(function ()
{
    'use strict';

    angular
        .module('app.human-resource.training.administration.courseschedule',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_administration_courseschedule', {
            url: '/Courseschedule',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/administration/courseschedule/courseschedule.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });
   
    }
})();
(function ()
{
    'use strict';

    angular.module('app.human-resource.training.administration.courseschedule')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($scope, $mdDialog, $mdDateLocale, dialogData)
    {
        
        $scope.uTimein = new Date("00:00");
        $scope.uTimeout = new Date("00:00");
        $scope.EmployeeSummary = [{
            "EmployeeID": "1001",
            "EmployeeName": "Jhonny",
            "Gender": "Male",
            "Country": "Australia",
            "DOB": "17/06/1983",
            "CompanyID": "58f71055845df405ec796c0d",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "",
            "Nationality": "Australians",
            "Designation": "",
            "Email": "",
            "DOJ": null,
            "PassportNumber": "",
            "PassportissueDate": null,
            "PassportIssuePlace": "",
            "PassportExpiryDate": null,
            "Currency": "",
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }, {
            "EmployeeID": "1002",
            "EmployeeName": "Robert",
            "Gender": "Male",
            "Country": "US",
            "DOB": "17/06/1972",
            "CompanyID": "58f70e398b2b84247cfddae0",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "58f71153845df405ec796c0f",
            "Nationality": "Americans",
            "Designation": "asds",
            "Email": "",
            "PassportNumber": "asd34234",
            "PassportIssuePlace": "sadsad3424",
            "ProbationInMonths": 4,
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }];
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.human-resource.training.administration.courseschedule')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.human-resource.training.administration.courseschedule')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($scope, $mdDialog, $mdDateLocale, dialogData)
    {
        
        $scope.uTimein = new Date("00:00");
        $scope.uTimeout = new Date("00:00");
        $scope.CourseSummary = [{ "CourseName":"Pest" },{ "CourseName":"Pest1" }];

        $scope.EmployeeSummary = [{
            "EmployeeID": "1001",
            "EmployeeName": "Jhonny",
            "Gender": "Male",
            "Country": "Australia",
            "DOB": "17/06/1983",
            "CompanyID": "58f71055845df405ec796c0d",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "",
            "Nationality": "Australians",
            "Designation": "",
            "Email": "",
            "DOJ": null,
            "PassportNumber": "",
            "PassportissueDate": null,
            "PassportIssuePlace": "",
            "PassportExpiryDate": null,
            "Currency": "",
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }, {
            "EmployeeID": "1002",
            "EmployeeName": "Robert",
            "Gender": "Male",
            "Country": "US",
            "DOB": "17/06/1972",
            "CompanyID": "58f70e398b2b84247cfddae0",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "58f71153845df405ec796c0f",
            "Nationality": "Americans",
            "Designation": "asds",
            "Email": "",
            "PassportNumber": "asd34234",
            "PassportIssuePlace": "sadsad3424",
            "ProbationInMonths": 4,
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }];
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.human-resource.training.administration.courseschedule')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.training.administration.monitoring', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_training_administration_monitoring', {
            url: '/Monitoring',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/administration/monitoring/monitoring.html',
                    controller: 'monitoringController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.administration.monitoring')
        .controller('monitoringController', monitoringController);

    /** @ngInject */
    function monitoringController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {

        $scope.printToCart = function (invoice) {
            var printButton = document.getElementById("printpagebutton");
            printButton.style.visibility = 'hidden';
            window.focus(invoice);
            window.print(invoice);
            printButton.style.visibility = 'visible';
        };
    }

})();

(function () {
    'use strict';

    angular
 
        .module('app.human-resource.health.eshbreifing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_health_eshbreifing', {
            url: '/EshBreifing',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/health/eshbreifing/eshbreifing.html',
                    controller: 'EshbreifingController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.health.eshbreifing')
        .controller('evaluationController', evaluationController);

    /** @ngInject */
    function evaluationController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {

            $scope.printToCart = function (evaluation) {
            var printButton = document.getElementById("printpagebutton");
            printButton.style.visibility = 'hidden';
            window.focus(evaluation);
            window.print(evaluation);
            printButton.style.visibility = 'visible';
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.human-resource.training.administration.courseschedule')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($scope, $mdDialog, $document, $mdDateLocale)
    {
        var vm = this;

        $scope.EmployeeSummary = [{
            "EmployeeID": "1001",
            "EmployeeName": "Jhonny",
            "Gender": "Male",
            "Country": "Australia",
            "DOB": "17/06/1983",
            "CompanyID": "58f71055845df405ec796c0d",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "",
            "Nationality": "Australians",
            "Designation": "",
            "Email": "",
            "DOJ": null,
            "PassportNumber": "",
            "PassportissueDate": null,
            "PassportIssuePlace": "",
            "PassportExpiryDate": null,
            "Currency": "",
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }, {
            "EmployeeID": "1002",
            "EmployeeName": "Robert",
            "Gender": "Male",
            "Country": "US",
            "DOB": "17/06/1972",
            "CompanyID": "58f70e398b2b84247cfddae0",
            "ShiftID": "",
            "ProjectID": "",
            "DepartmentID": "58f71153845df405ec796c0f",
            "Nationality": "Americans",
            "Designation": "asds",
            "Email": "",
            "PassportNumber": "asd34234",
            "PassportIssuePlace": "sadsad3424",
            "ProbationInMonths": 4,
            "AnnualLeave": 8,
            "SickLeaveHospitalization": 9,
            "SickLeaveNonHospitalization": 8,
            "ChildCareLeave": 4,
            "MaternityLeave": 7,
            "CompassionateLeave": 3,
            "NationalServiceLeave": 6,
            "InfantCareLeave": 5,
            "Monday": 1,
            "Tuesday": 8,
            "Wednesday": 8,
            "Thursday": 8,
            "Friday": 8,
            "Saturday": 8,
            "Sunday": 8,

        }];
        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl         : 'app/main/apps/human-resource/training/administration/courseschedule/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
            $scope.uTimein = new Date("00:00");
            $scope.uTimeout = new Date("00:00");
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl: 'app/main/apps/human-resource/training/administration/courseschedule/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }

})();
(function () {
    'use strict';

    angular
 
        .module('app.human-resource.training.administration.certification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_training_administration_certification', {
            url: '/Certification',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/administration/certification/certification.html',
                    controller: 'certificationController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.administration.certification')
        .controller('certificationController', certificationController);

    /** @ngInject */
    function certificationController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {
        $scope.fromDate = "Oct 13";
        $scope.toDate = "Oct 30 2020";
        $scope.printToCart = function (invoice) {
            var printButton = document.getElementById("printpagebutton");
            printButton.style.visibility = 'hidden';
            window.focus(invoice);
            window.print(invoice);
            printButton.style.visibility = 'visible';
        };
        $scope.sSubmit = function () {

            var days = [];
            if ($scope.DOW.Sun == true) {
                days.push({
                    DOW: "Sunday",
                })
            }
            if ($scope.DOW.Mon == true) {
                days.push({
                    DOW: "Monday",
                })
            }
            if ($scope.DOW.Tues == true) {
                days.push({
                    DOW: "Tuesday",
                })
            }
            if ($scope.DOW.Wed == true) {
                days.push({
                    DOW: "Wednesday",
                })
            }
            if ($scope.DOW.Thur == true) {
                days.push({
                    DOW: "Thursday",
                })
            }
            if ($scope.DOW.Fri == true) {
                days.push({
                    DOW: "Friday",
                })
            }
            if ($scope.DOW.Sat == true) {
                days.push({
                    DOW: "Saturday",
                })
            }
            if ($scope.night.shift == true) {
                $scope.uNightShift = "Night";
            }
            if ($scope.night.shift == false) {
                $scope.uNightShift = "Day";
            }
            $scope.uDOW = days.map(function (obj) { return obj.DOW; }).join(', ');
            if ($scope.Update === true) {

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/shift/update",
                    data: {
                        _id: $scope.SID, ClientID: $scope.uClientID, ShiftName: $scope.uShiftName, ShiftCode: $scope.uShiftCode,
                        ShiftStartTime: $scope.uShiftStartTime, ShiftEndTime: $scope.uShiftEndTime,
                        LunchBreakStartTime: $scope.uLunchBreakfrom, LunchBreakEndTime: $scope.uLunchBreakTo,
                        Break1StartTime: $scope.uAdditionalBreakfrom, Break1EndTime: $scope.uAdditionalBreakTo,
                        NightShift: $scope.uNightShift, DaysofWeek: $scope.uDOW, JobCategory: $scope.uJobCategory,
                        DepartmentID: $scope.uDepartmentID, UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Shiftgrid = true;
                    $scope.Shiftform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/shift/add",
                    data: {
                        ClientID: $scope.uClientID, ShiftName: $scope.uShiftName, ShiftCode: $scope.uShiftCode,
                        ShiftStartTime: $scope.uShiftStartTime, ShiftEndTime: $scope.uShiftEndTime,
                        LunchBreakStartTime: $scope.uLunchBreakfrom, LunchBreakEndTime: $scope.uLunchBreakTo,
                        Break1StartTime: $scope.uAdditionalBreakfrom, Break1EndTime: $scope.uAdditionalBreakTo,
                        NightShift: $scope.uNightShift, DaysofWeek: $scope.uDOW, JobCategory: $scope.uJobCategory,
                        DepartmentID: $scope.uDepartmentID, CreatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Shiftgrid = true;
                    $scope.Shiftform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Showgrid = function () {
            $scope.Shiftgrid = true;
            $scope.Shiftform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.rec1 = { Sun: false };
            $scope.rec2 = { Mon: false };
            $scope.rec3 = { Tues: false };
            $scope.rec4 = { Wed: false };
            $scope.rec5 = { Thur: false };
            $scope.rec6 = { Fri: false };
            $scope.rec7 = { Sat: false };
        }

        $scope.sAdd = function () {

            ClearForm();
            $scope.Update = false;
            $scope.Shiftform = true;
            $scope.Shiftgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.uShiftStartTime = new Date("00:00");
            $scope.uShiftEndTime = new Date("00:00");
            $scope.uLunchBreakfrom = new Date("00:00");
            $scope.uLunchBreakTo = new Date("00:00");
            $scope.uAdditionalBreakfrom = new Date("00:00");
            $scope.uAdditionalBreakTo = new Date("00:00");
            $scope.DOW = { Sun: false };
            $scope.DOW = { Mon: false };
            $scope.DOW = { Tues: false };
            $scope.DOW = { Wed: false };
            $scope.DOW = { Thur: false };
            $scope.DOW = { Fri: false };
            $scope.DOW = { Sat: false };
            $scope.night = { shift: false };
        }

        $http.get($rootScope.WebURL + "/client")
            .then(function (clientdata) {
                $scope.clientdatas = clientdata.data.data;
            });

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };

    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.leave.apply', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_leave_apply', {
            url: '/allowance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/leave/allowance/allowance.html',
                    controller: 'AllowanceController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.leave.apply')
        .controller('AllowanceController', AllowanceController);

    /** @ngInject */
    function AllowanceController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {

        $scope.Allowancegrid = true;
        $scope.Allowanceform = false;
        $scope.Update = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.sExport = function () {

            alasql('SELECT * INTO XLSX("Allowancedata.xlsx",{headers:true}) FROM ?', [$scope.Allowancedatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.allowanceinfo = function (AllowanceId) {
            $scope.SID = AllowanceId;

            $scope.Update = true;

            $scope.Allowanceform = true;
            $scope.Allowancegrid = false;

            $scope.allowanceinfoId = AllowanceId;

            var Allowancedata = $scope.Allowancesummary


            var info = $scope.Allowancedatas

            for (var i = 0; i < info.length; i++) {
                if (info[i].ID == AllowanceId) {

                    $scope.uJoininBonus = info[i].JoininBonus;
                    $scope.uRecommendafriend = info[i].Recommendafriend;
                    $scope.uPerfectAttendance = info[i].PerfectAttendance;
                    $scope.uRegistration = info[i].RegisterNumber;
                    $scope.uMosquitojobAllowance = info[i].MosquitojobAllowance;
                    $scope.uSoilTreatmentjobAllowance = info[i].SoilTreatmentjobAllowance;
                    $scope.uProductivityAllowance = info[i].ProductivityAllowance;
                    $scope.uOMOAllowance = info[i].OMOAllowance;
                    $scope.uWorkInjuryCompensation = info[i].WorkInjuryCompensation
                    $scope.uForiegnMedicalInsurance = info[i].ForiegnMedicalInsurance;
                    $scope.uTravelInsurancePlan = info[i].TravelInsurancePlan;

                }

            }
        }



        $scope.sSubmit = function () {

            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/allowance/update",
                    data: {
                        _id: $scope.SID, JoininBonus: $scope.uJoininBonus, Recommendafriend: $scope.uRecommendafriend, PerfectAttendance: $scope.uPerfectAttendance,
                        RegisterNumber: $scope.uRegistration,
                        MosquitojobAllowance: $scope.uMosquitojobAllowance, SoilTreatmentjobAllowance: $scope.uSoilTreatmentjobAllowance,
                        ProductivityAllowance: $scope.uProductivityAllowance, OMOAllowance: $scope.uOMOAllowance, WorkInjuryCompensation: $scope.uWorkInjuryCompensation,
                        TravelInsurancePlan: $scope.uTravelInsurancePlan,
                        ForiegnMedicalInsurance: $scope.uForiegnMedicalInsurance, UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {

                    RefreshGrid();
                    $scope.Allowancegrid = true;
                    $scope.Allowanceform = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/allowance/add",
                    data: {
                        JoininBonus: $scope.uJoininBonus, Recommendafriend: $scope.uRecommendafriend, PerfectAttendance: $scope.uPerfectAttendance,
                        MosquitojobAllowance: $scope.uMosquitojobAllowance, SoilTreatmentjobAllowance: $scope.uSoilTreatmentjobAllowance,
                        ProductivityAllowance: $scope.uProductivityAllowance, OMOAllowance: $scope.uOMOAllowance, WorkInjuryCompensation: $scope.uWorkInjuryCompensation,
                        TravelInsurancePlan: $scope.uTravelInsurancePlan,
                        ForiegnMedicalInsurance: $scope.uForiegnMedicalInsurance,
                        CreatedBy: $rootScope.createdby,
                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Allowancegrid = true;
                    $scope.Allowanceform = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Showgrid = function () {

            $scope.Allowancegrid = true;
            $scope.Allowanceform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Allowanceform = true;
            $scope.Allowancegrid = false;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }



        $http.get($rootScope.WebURL + "/allowance")
            .then(function (Allowancedata) {
                $scope.Allowancedatas = Allowancedata.data.data;

            });


        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/allowance")
                .then(function (Allowancedata) {
                    $scope.Allowancedatas = Allowancedata.data.data;
                });
        }


        function ClearForm() {
            $scope.uJoininBonus = '';
            $scope.uRecommendafriend = '';
            $scope.uPerfectAttendance = '';
            $scope.uRegistration = '';
            $scope.uMosquitojobAllowance = '';
            $scope.uTelephone = '';
            $scope.uWorkInjuryCompensation = '';
            $scope.uProductivityAllowance = '';
            $scope.uOMOAllowance = '';
            $scope.uForiegnMedicalInsurance = '';
            $scope.uSoilTreatmentjobAllowance = '';
            $scope.uTravelInsurancePlan = '';
        }



        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#product');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };


    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.appraisal.eappraisal', ["xeditable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_appraisal_eappraisal', {
            url: '/EmployeeAppraisal',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/eappraisal.html',
                    controller: 'AppraisalController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.appraisal.eappraisal')
        .controller('AppraisalController', AppraisalController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });


    function AppraisalController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        $scope.InitialFromDate = '01/01/' + new Date().getFullYear();
        $scope.uFrom = new Date($scope.InitialFromDate);
        $scope.InitialToDate = '12/31/' + new Date().getFullYear();
        $scope.uTo = new Date($scope.InitialToDate);

        RefreshGrid();
        DefaultDatefilter();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();
        RefreshAppraisaltemplateGrid();
        //RefreshAppraisaltemplatedataGrid();

        function DefaultDatefilter() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/employeeappraisalform/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Employeeappraisalformdatas = GList.data.data;
            });
        }

        $scope.Datefilter = function () {
            debugger
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/employeeappraisalform/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Employeeappraisalformdatas = GList.data.data;
            });
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employeeappraisalform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (AllEmployeeappraisalformdata) {
                $scope.AllEmployeeappraisalformdatas = AllEmployeeappraisalformdata.data.data;
            });
        }

        function RefreshAppraisaltemplateGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplateform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Appraisaltemplateformdata) {
                $scope.Appraisaltemplateformdatas = Appraisaltemplateformdata.data.data;
            });
        }

        function RefreshAppraisaltemplatedataGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplatedata",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Appraisaltemplatedata) {
                $scope.Appraisaltemplatedatas = Appraisaltemplatedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        var AppraisalID = getParameterByName('ID');
        if (AppraisalID != null) {
            var response = $http({
                url: $rootScope.WebURL + "/employeeappraisalform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeeappraisalformdata) {
                $scope.AllEmployeeappraisalformdatas = Employeeappraisalformdata.data.data;
                var item = $scope.AllEmployeeappraisalformdatas.filter(function (item) {
                    return item._id === AppraisalID;
                })[0];
                $scope.id = item._id;
                $scope.SID = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.TemplateName = item.AppraisalTypedetails[0].TemplateName;
                $scope.AppraisalPeriodStart = new Date(item.AppraisalPeriodStart);
                $scope.AppraisalPeriodEnd = new Date(item.AppraisalPeriodEnd);
                $scope.AppraisalYear = item.AppraisalYear;
                $scope.AppraisalType = item.AppraisalType;
                $scope.Photo = item.EmployeePhoto;
                if ($scope.Photo != "" && $scope.Photo != "undefined" && $scope.Photo != null) {
                    $scope.Photo = decode_base64(item.EmployeePhoto);
                }
                $scope.Department = item.Department;
                $scope.Designation = item.Designation;
                $scope.DateJoined = new Date(item.DateJoined);
                $scope.AppraisalNo = parseInt(item.AppraisalNo);
                $scope.TotalPFScore = parseInt(item.TotalPFScore);
                $scope.MaxPFScore = parseInt(item.MaxPFScore);
                $scope.TotalPF = parseInt(item.TotalPF);
                $scope.TotalScore = parseInt(item.TotalScore);
                $scope.BonusScore = parseInt(item.BonusScore);
                $scope.BonusScoreRemarks = item.BonusScoreRemarks;
                $scope.OverallRating = parseInt(item.OverallRating);
                $scope.EmployeeComment = item.EmployeeComment;
                $scope.CsoComment = item.CsoComment;
                $scope.HRComment = item.HRComment;
                $scope.Recommendation = item.Recommendation;
                $scope.Status = item.Status,
                    $scope.StatusID = item.StatusID;

                $scope.Update = true;
                $scope.ViewAppraisalform = true;
                $scope.Appraisalform = false;
                $scope.Appraisalgrid = false;
                $scope.aExport = false;
                $scope.aAdd = false;
                $scope.aSearch = false;
                $scope.aView = true;
                $scope.Appraisal = true;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'HRM Employee Appraisal') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'HRM Employee Appraisal') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
                RefreshEmployeeappraisaldataGrid();
            });
        }
        else {
            $scope.Appraisalform = false;
            $scope.ViewAppraisalform = false;
            $scope.Appraisalgrid = true;
            $scope.aExport = true;
            $scope.aAdd = true;
            $scope.aSearch = true;
            $scope.aView = false;
            $scope.Cancel = false;
            $scope.Appraisal = false;
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
        }

        $scope.Employeeclear = function () {
            $scope.Employee = '';
            $scope.Photo = '';
            $scope.Department = '';
            $scope.Designation = '';
            $scope.DateJoined = '';
            $scope.AppraisalNo = '';
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("EmployeeAppraisals.xlsx",{headers:true}) FROM ?', [$scope.Employeeappraisalformdatas]);
        };

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();

            var D = "FY-";
            var year = new Date().getFullYear();
            $scope.AppraisalYear = D + year;
            $scope.AppraisalPeriodStart = '01/01/' + new Date().getFullYear();
            $scope.AppraisalPeriodStart = new Date($scope.AppraisalPeriodStart);
            $scope.AppraisalPeriodEnd = '12/31/' + new Date().getFullYear();
            $scope.AppraisalPeriodEnd = new Date($scope.AppraisalPeriodEnd);

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.Update = false;
            $scope.Appraisalform = true;
            $scope.ViewAppraisalform = false;
            $scope.Appraisalgrid = false;
            $scope.aExport = false;
            $scope.aView = true;
            $scope.aAdd = false;
            $scope.aSearch = false;
            $scope.Cancel = false;
            $scope.Appraisal = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Appraisalgrid = true;
            $scope.Appraisalform = false;
            $scope.ViewAppraisalform = false;
            $scope.aExport = true;
            $scope.aAdd = true;
            $scope.aView = false;
            $scope.aSearch = true;
            $scope.Cancel = false;
            $scope.Appraisal = false;
        }

        $scope.EmployeeDetails = function () {
            try {
                $scope.Emp = $scope.Employee;
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.id === $scope.Emp;
                })[0];
                $scope.Photo = item.Photo;
                if ($scope.Photo != "" && $scope.Photo != "undefined" && $scope.Photo != null) {
                    $scope.Photo = decode_base64(item.Photo);
                }
                $scope.Department = item.ECostCenter;
                $scope.Designation = item.EDesignation;
                $scope.DateJoined = new Date(item.EDateOfJoin);
                $scope.RequestedByEmployee = item.EmployeeID + '-' + item.EmployeeName;
            } catch (err) { }

            var appraisal = [];
            angular.forEach($scope.AllEmployeeappraisalformdatas, function (value) {
                if ($scope.Employee == value.EmployeeID && $scope.AppraisalYear == value.AppraisalYear) {
                    appraisal.push({
                        id: value._id,
                        EmployeeID: value.EmployeeID,
                        AppraisalYear: value.AppraisalYear,
                    })
                }
            });
            $scope.appraisalsummary = appraisal;
            $scope.AppraisalNo = $scope.appraisalsummary.length + 1;
        }

        $scope.TemplateDetails = function (e) {
            try {
                var item = $scope.Appraisaltemplateformdatas.filter(function (item) {
                    return item._id === $scope.AppraisalType;
                })[0];
                $scope.id = item._id;
                $scope.UniqID = item.UniqueID;
                $scope.TempName = item.TemplateName;
            } catch (err) { }

            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplatedata/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqID },
            });
            response.then(function (Tempdetaildata) {
                $scope.Tempdetaildatas = Tempdetaildata.data.data;
                $mdDialog.show({
                    templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/viewtemplate.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: false,
                    controller: function AppraisalController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            });
        }

        $scope.TemplateDetailSave = function (data1, id, Category, Criteria) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeeappraisaldata/add",
                data: {
                    UniqueID: $scope.UniqueID,
                    Category: Category,
                    Criteria: Criteria,
                    Weightage: data1.Weightage,
                    Grade: data1.Grade,
                    Remarks: data1.Remarks,
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                //data1.Weightage = "";
                //data1.Grade = "";
                //data1.Remarks = "";
                $mdToast.show($mdToast.simple().textContent('Appraisal added Successfully!').position('top center'));
                RefreshEmployeeappraisaldataGrid();
            });
        };

        $scope.Templatedetailnewpopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.Category = '';
            $scope.vm.Criteria = '';
            $scope.vm.Weightage = '';
            $scope.vm.Grade = '';
            $scope.vm.Remarks = '';
            $scope.ATUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/newtemplate.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Templatedetailnewadd = function () {
            if ($scope.ATUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeappraisaldata/update",
                    data: {
                        _id: $scope.WTID,
                        Category: $scope.vm.Category,
                        Criteria: $scope.vm.Criteria,
                        Weightage: $scope.vm.Weightage,
                        Grade: $scope.vm.Grade,
                        Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshEmployeeappraisaldataGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeeappraisaldata/add",
                    data: {
                        UniqueID: $scope.UniqueID,
                        Category: $scope.vm.Category,
                        Criteria: $scope.vm.Criteria,
                        Weightage: $scope.vm.Weightage,
                        Grade: $scope.vm.Grade,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEmployeeappraisaldataGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Templatedetailnewupdate = function (e, TId) {
            $scope.ATUpdate = true;
            $scope.WTID = TId;
            try {
                var item = $scope.Employeeappraisaldatas.filter(function (item) {
                    return item._id === TId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.vm.Category = item.Category;
                $scope.vm.Criteria = item.Criteria;
                $scope.vm.Weightage = parseInt(item.Weightage);
                $scope.vm.Grade = parseInt(item.Grade);
                $scope.vm.Remarks = item.Remarks;
            } catch (err) { }
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/newtemplate.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Templatedetailnewdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/newtemplatedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.TDNdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeeappraisaldata/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshEmployeeappraisaldataGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.aSubmit = function () {
            if ($scope.AppraisalNo == "6") {
                $scope.Showgrid();
                $mdToast.show($mdToast.simple().textContent('You should not apply more than 5 times!!').position('top center'));
                return
            }

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeappraisalform/update",
                    data: {
                        _id: $scope.SID,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        EmployeeID: $scope.Employee,
                        AppraisalPeriodStart: $scope.AppraisalPeriodStart,
                        AppraisalPeriodEnd: $scope.AppraisalPeriodEnd,
                        AppraisalYear: $scope.AppraisalYear,
                        AppraisalType: $scope.AppraisalType,
                        EmployeePhoto: $scope.Photo,
                        Department: $scope.Department,
                        Designation: $scope.Designation,
                        DateJoined: $scope.DateJoined,
                        AppraisalNo: $scope.AppraisalNo,
                        TotalPFScore: $scope.TotalPFScore,
                        MaxPFScore: $scope.MaxPFScore,
                        TotalPF: $scope.TotalPF,
                        TotalScore: $scope.TotalScore,
                        BonusScore: $scope.BonusScore,
                        BonusScoreRemarks: $scope.BonusScoreRemarks,
                        OverallRating: $scope.OverallRating,
                        EmployeeComment: $scope.EmployeeComment,
                        CsoComment: $scope.CsoComment,
                        HRComment: $scope.HRComment,
                        Recommendation: $scope.Recommendation,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.TempName = $scope.Userdata.AppraisalTypedetails[0].TemplateName;
                    } catch (err) {
                    }
                    var SenderEmails = [];
                    try {
                        var EmployeeArray = $scope.Employeedatas;
                        var Empitem = EmployeeArray.filter(function (Empitem) {
                            return Empitem.EmployeeName === $scope.Userdata.SupervisorName;
                        })[0];

                        SenderEmails.push({ Email: Empitem.Email });
                    } catch (err) {
                    }
                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Employee Appraisal' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Employee Appraisal' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/employeeappraisalform/email",
                            data: {
                                AppraisalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                AppraisalPeriodStart: convertDate($scope.Userdata.AppraisalPeriodStart),
                                AppraisalPeriodEnd: convertDate($scope.Userdata.AppraisalPeriodEnd),
                                AppraisalYear: $scope.Userdata.AppraisalYear,
                                AppraisalType: $scope.TempName,
                                Department: $scope.Userdata.Department,
                                Designation: $scope.Userdata.Designation,
                                DateJoined: convertDate($scope.Userdata.DateJoined),
                                AppraisalNo: $scope.Userdata.AppraisalNo,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Employeeappraisalformdatas[$scope.IndexID] = GList.data.data[0];
                    DefaultDatefilter();
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeeappraisalform/add",
                    data: {
                        Client_Id: Client_Id,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.Employee,
                        AppraisalPeriodStart: $scope.AppraisalPeriodStart,
                        AppraisalPeriodEnd: $scope.AppraisalPeriodEnd,
                        AppraisalYear: $scope.AppraisalYear,
                        AppraisalType: $scope.AppraisalType,
                        EmployeePhoto: $scope.Photo,
                        Department: $scope.Department,
                        Designation: $scope.Designation,
                        DateJoined: $scope.DateJoined,
                        AppraisalNo: $scope.AppraisalNo,
                        TotalPFScore: $scope.TotalPFScore,
                        MaxPFScore: $scope.MaxPFScore,
                        TotalPF: $scope.TotalPF,
                        TotalScore: $scope.TotalScore,
                        BonusScore: $scope.BonusScore,
                        BonusScoreRemarks: $scope.BonusScoreRemarks,
                        OverallRating: $scope.OverallRating,
                        EmployeeComment: $scope.EmployeeComment,
                        CsoComment: $scope.CsoComment,
                        HRComment: $scope.HRComment,
                        Recommendation: $scope.Recommendation,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data;
                    try {
                        var Appraisalitem = $scope.Appraisaltemplateformdatas.filter(function (Appraisalitem) {
                            return Appraisalitem._id === $scope.Userdata.AppraisalType;
                        })[0];
                        $scope.TempName = Appraisalitem.TemplateName;
                    } catch (err) {
                    }
                    try {
                        var Eitem = $scope.Employeedatas.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) {
                    }
                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Employee Appraisal' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Employee Appraisal' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/employeeappraisalform/email",
                            data: {
                                AppraisalID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                AppraisalPeriodStart: convertDate($scope.Userdata.AppraisalPeriodStart),
                                AppraisalPeriodEnd: convertDate($scope.Userdata.AppraisalPeriodEnd),
                                AppraisalYear: $scope.Userdata.AppraisalYear,
                                AppraisalType: $scope.TempName,
                                Department: $scope.Userdata.Department,
                                Designation: $scope.Userdata.Designation,
                                DateJoined: convertDate($scope.Userdata.DateJoined),
                                AppraisalNo: $scope.Userdata.AppraisalNo,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Employee Appraisal",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    DefaultDatefilter();
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Appraisalinfo = function (AppraisalId, $index) {
            $scope.SID = AppraisalId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Employeeappraisalformdatas.filter(function (item) {
                    return item._id === AppraisalId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.Employee = item.EmployeeID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.AppraisalPeriodStart = new Date(item.AppraisalPeriodStart);
                    $scope.AppraisalPeriodEnd = new Date(item.AppraisalPeriodEnd);
                    $scope.AppraisalYear = item.AppraisalYear;
                    $scope.AppraisalType = item.AppraisalType;
                    $scope.Photo = item.EmployeePhoto;
                    if ($scope.Photo != "" && $scope.Photo != "undefined" && $scope.Photo != null) {
                        $scope.Photo = decode_base64(item.EmployeePhoto);
                    }
                    $scope.Department = item.Department;
                    $scope.Designation = item.Designation;
                    $scope.DateJoined = new Date(item.DateJoined);
                    $scope.AppraisalNo = parseInt(item.AppraisalNo);
                    $scope.TotalPFScore = parseInt(item.TotalPFScore);
                    $scope.MaxPFScore = parseInt(item.MaxPFScore);
                    $scope.TotalPF = parseInt(item.TotalPF);
                    $scope.TotalScore = parseInt(item.TotalScore);
                    $scope.BonusScore = parseInt(item.BonusScore);
                    $scope.BonusScoreRemarks = item.BonusScoreRemarks;
                    $scope.OverallRating = parseInt(item.OverallRating);
                    $scope.EmployeeComment = item.EmployeeComment;
                    $scope.CsoComment = item.CsoComment;
                    $scope.HRComment = item.HRComment;
                    $scope.Recommendation = item.Recommendation;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }
                RefreshEmployeeappraisaldataGrid();

                $scope.Update = true;
                $scope.Appraisalform = true;
                $scope.Appraisalgrid = false;
                $scope.ViewAppraisalform = false;
                $scope.aExport = false;
                $scope.aAdd = false;
                $scope.aSearch = false;
                $scope.aView = true;
                $scope.Appraisal = false;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();

            }
        }

        $scope.ViewAppraisalinfo = function (AId, $index) {
            debugger
            $scope.SID = AId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.ViewAppraisalform = true;
            $scope.Appraisalform = false;
            $scope.Appraisalgrid = false;
            $scope.aExport = false;
            $scope.aAdd = false;
            $scope.aSearch = false;
            $scope.aView = true;
            $scope.Appraisal = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = $scope.Status;
            $scope.NextLevelAction = '';
            try {
                var item = $scope.Employeeappraisalformdatas.filter(function (item) {
                    return item._id === AId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.AppraisalPeriodStart = new Date(item.AppraisalPeriodStart);
                $scope.AppraisalPeriodEnd = new Date(item.AppraisalPeriodEnd);
                $scope.AppraisalYear = item.AppraisalYear;
                $scope.AppraisalType = item.AppraisalType;
                $scope.TemplateName = item.AppraisalTypedetails[0].TemplateName;
                $scope.Photo = item.EmployeePhoto;
                if ($scope.Photo != "" && $scope.Photo != "undefined" && $scope.Photo != null) {
                    $scope.Photo = decode_base64(item.EmployeePhoto);
                }
                $scope.Department = item.Department;
                $scope.Designation = item.Designation;
                $scope.DateJoined = new Date(item.DateJoined);
                $scope.AppraisalNo = parseInt(item.AppraisalNo);
                $scope.TotalPFScore = parseInt(item.TotalPFScore);
                $scope.MaxPFScore = parseInt(item.MaxPFScore);
                $scope.TotalPF = parseInt(item.TotalPF);
                $scope.TotalScore = parseInt(item.TotalScore);
                $scope.BonusScore = parseInt(item.BonusScore);
                $scope.BonusScoreRemarks = item.BonusScoreRemarks;
                $scope.OverallRating = parseInt(item.OverallRating);
                $scope.EmployeeComment = item.EmployeeComment;
                $scope.CsoComment = item.CsoComment;
                $scope.HRComment = item.HRComment;
                $scope.Recommendation = item.Recommendation;
                $scope.Status = item.Status,
                    $scope.StatusID = item.StatusID;
            } catch (err) { }

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'HRM Employee Appraisal') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {

                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'HRM Employee Appraisal') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
            RefreshEmployeeappraisaldataGrid();

        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "HRM Employee Appraisal",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file;
            var response = Upload.upload({
                url: $rootScope.WebURL + "/employeeappraisalform/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Employee Appraisal",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.workflow = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeappraisalform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.TempName = $scope.Userdata.AppraisalTypedetails[0].TemplateName;
                    } catch (err) {
                    }

                    var SenderEmails = [];
                    try {
                        var EmployeeArray = $scope.Employeedatas;
                        var Empitem = EmployeeArray.filter(function (Empitem) {
                            return Empitem.EmployeeName === $scope.Userdata.SupervisorName;
                        })[0];

                        SenderEmails.push({ Email: Empitem.Email });
                    } catch (err) {
                    }
                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Employee Appraisal' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Employee Appraisal' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/employeeappraisalform/email",
                            data: {
                                AppraisalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                AppraisalPeriodStart: convertDate($scope.Userdata.AppraisalPeriodStart),
                                AppraisalPeriodEnd: convertDate($scope.Userdata.AppraisalPeriodEnd),
                                AppraisalYear: $scope.Userdata.AppraisalYear,
                                AppraisalType: $scope.TempName,
                                Department: $scope.Userdata.Department,
                                Designation: $scope.Userdata.Designation,
                                DateJoined: convertDate($scope.Userdata.DateJoined),
                                AppraisalNo: $scope.Userdata.AppraisalNo,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Employee Appraisal",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Employeeappraisalformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.reject = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeappraisalform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.TempName = $scope.Userdata.AppraisalTypedetails[0].TemplateName;
                    } catch (err) {
                    }

                    var SenderEmails = [];
                    try {
                        var EmployeeArray = $scope.Employeedatas;
                        var Empitem = EmployeeArray.filter(function (Empitem) {
                            return Empitem.EmployeeName === $scope.Userdata.SupervisorName;
                        })[0];

                        SenderEmails.push({ Email: Empitem.Email });
                    } catch (err) {
                    }
                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Employee Appraisal' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/employeeappraisalform/email",
                            data: {
                                AppraisalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                AppraisalPeriodStart: convertDate($scope.Userdata.AppraisalPeriodStart),
                                AppraisalPeriodEnd: convertDate($scope.Userdata.AppraisalPeriodEnd),
                                AppraisalYear: $scope.Userdata.AppraisalYear,
                                AppraisalType: $scope.TempName,
                                Department: $scope.Userdata.Department,
                                Designation: $scope.Userdata.Designation,
                                DateJoined: convertDate($scope.Userdata.DateJoined),
                                AppraisalNo: $scope.Userdata.AppraisalNo,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Employee Appraisal",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Employeeappraisalformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.cancelrequest = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeappraisalform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.TempName = $scope.Userdata.AppraisalTypedetails[0].TemplateName;
                    } catch (err) {
                    }

                    var SenderEmails = [];
                    try {
                        var EmployeeArray = $scope.Employeedatas;
                        var Empitem = EmployeeArray.filter(function (Empitem) {
                            return Empitem.EmployeeName === $scope.Userdata.SupervisorName;
                        })[0];

                        SenderEmails.push({ Email: Empitem.Email });
                    } catch (err) {
                    }

                    try {
                        try {
                            var myArray = $scope.Workflowdatas;
                            var Workflowitem = myArray.filter(function (Workflowitem) {
                                return Workflowitem.TypeName === 'HRM Employee Appraisal' && Workflowitem.LevelName === $scope.StatusID;
                            })[0];
                        } catch (err) {
                        }
                        try {
                            if (Workflowitem.NotifytoCurrentApprover == true) {
                                $scope.ApproversArray = Workflowitem.Approvers.split(',');
                                angular.forEach($scope.ApproversArray, function (value) {
                                    var UserArray = $scope.Userdatas;
                                    var Useritem = UserArray.filter(function (Useritem) {
                                        return Useritem.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: Useritem.Email });
                                });
                            }
                        } catch (err) {
                        }
                        try {
                            if (Workflowitem.NotifytoCreatorInitator == true) {
                                var UserArray2 = $scope.Userdatas;
                                var item2 = UserArray2.filter(function (item2) {
                                    return item2.UserID === $scope.Userdata.CreatedBy;
                                })[0];
                                SenderEmails.push({ Email: item2.Email });
                            }
                        } catch (err) {
                        }
                        try {
                            $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                            angular.forEach($scope.NotifyToArray, function (value) {
                                var UserArray3 = $scope.Userdatas;
                                var item3 = UserArray3.filter(function (item3) {
                                    return item3.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: item3.Email });
                            });
                        } catch (err) {
                        }
                        try {
                            if (Workflowitem.NotifytoNextLevelApprover == true) {
                                try {
                                    $scope.NLevel = Workflowitem.NextLevel;

                                    var myArray1 = $scope.Workflowdatas;
                                    var Workflowitem1 = myArray1.filter(function (item1) {
                                        return item1.TypeName === 'HRM Employee Appraisal' && item1.LevelName === $scope.NLevel;
                                    })[0];
                                } catch (err) {
                                }
                                try {
                                    $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                    angular.forEach($scope.NApproversArray, function (value) {
                                        var UserArray4 = $scope.Userdatas;
                                        var item4 = UserArray4.filter(function (item4) {
                                            return item4.UserID === value;
                                        })[0];
                                        SenderEmails.push({ Email: item4.Email });
                                    });
                                } catch (err) {
                                }
                            }
                        } catch (err) {
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/employeeappraisalform/email",
                            data: {
                                AppraisalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                AppraisalPeriodStart: convertDate($scope.Userdata.AppraisalPeriodStart),
                                AppraisalPeriodEnd: convertDate($scope.Userdata.AppraisalPeriodEnd),
                                AppraisalYear: $scope.Userdata.AppraisalYear,
                                AppraisalType: $scope.TempName,
                                Department: $scope.Userdata.Department,
                                Designation: $scope.Userdata.Designation,
                                DateJoined: convertDate($scope.Userdata.DateJoined),
                                AppraisalNo: $scope.Userdata.AppraisalNo,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Employee Appraisal",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Employeeappraisalformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        function RefreshEmployeeappraisaldataGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employeeappraisaldata/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Employeeappraisaldata) {
                $scope.Employeeappraisaldatas = Employeeappraisaldata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function ClearForm() {
            $scope.UniqueID = '';
            $scope.Employee = '';
            $scope.AppraisalPeriodStart = '';
            $scope.AppraisalPeriodEnd = '';
            $scope.AppraisalYear = '';
            $scope.AppraisalType = '';
            $scope.Photo = '';
            $scope.Department = '';
            $scope.Designation = '';
            $scope.DateJoined = '';
            $scope.ServiceYear = '';
            $scope.AppraisalNo = '';
            $scope.SupervisorName = '';
            $scope.CSOName = '';

            $scope.TotalPFScore = '';
            $scope.MaxPFScore = '';
            $scope.TotalPF = '';
            $scope.TotalScore = '';
            $scope.BonusScore = '';
            $scope.BonusScoreRemarks = '';
            $scope.OverallRating = '';
            $scope.SupervisorRecommendation = '';
            $scope.SupervisorComment = '';
            $scope.EmployeeAcceptance = '';
            $scope.EmployeeComment = '';
            $scope.AppraisalReview = '';
            $scope.CsoComment = '';
            $scope.HRComment = '';
            $scope.Recommendation = '';
            $scope.Employeeappraisaldatas = '';
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Appraisal.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        $scope.TemplateDetailspopupdatas = function () {

            //$scope.TDUpdate = false;
            try {
                var item = $scope.Appraisaltemplateformdatas.filter(function (item) {
                    return item._id === $scope.AppraisalType;
                })[0];
                $scope.id = item._id;
                $scope.UniqID = item.UniqueID;
                $scope.TempName = item.TemplateName;
            } catch (err) { }

            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplatedata/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqID },
            });
            response.then(function (Tempdetaildata) {
                $scope.Tempdetaildatas = Tempdetaildata.data.data;

                $mdDialog.show({
                    templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/eappraisal/viewtemplate.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function AppraisalController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            });

            var temp = [];
            angular.forEach($scope.Appraisaltemplatedatas, function (value) {

                if ($scope.UniqID == value.UniqueID) {
                    temp.push({
                        id: value._id,
                        TemplateName: $scope.TempName,
                        UniqID: value.UniqueID,
                        Category: value.Category,
                        Criteria: value.Criteria,
                        Weightage: value.Weightage,
                        Grade: value.Order,
                    })
                }
            });
            $scope.Tempdetaildatas = temp;
        }

        function momentDiff(a, b) {
            var oldDateMoment, newDateMoment, numYears, numMonths, numDays;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');
            return numYears + " years, " + numMonths + " months, " + numDays + " days.";
        }

    }
})();





(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.appraisal.template', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_appraisal_template', {
            url: '/AppraisalTemplate',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/template/template.html',
                    controller: 'AppraisaltemplateController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.appraisal.template')
        .controller('AppraisaltemplateController', AppraisaltemplateController)


    function AppraisaltemplateController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $mdDialog, $document, $http, $filter) {
        //var chkAceses = localStorage.getItem('pages');
        //if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        //}
        //else { $location.path("NoAccess"); }
        //$scope.model = {};
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');

        RefreshGrid();
        $scope.Templateform = false;
        $scope.Templategrid = true;
        $scope.tExport = true;
        $scope.tAdd = true;
        $scope.tSearch = true;
        $scope.tView = false;

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Appraisaltemplateformdatas.xlsx",{headers:true}) FROM ?', [$scope.Appraisaltemplateformdatas]);
        };

        $scope.Add = function () {
            ClearForm();
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.Update = false;
            $scope.Templateform = true;
            $scope.Templategrid = false;
            $scope.tExport = false;
            $scope.tView = true;
            $scope.tAdd = false;
            $scope.tSearch = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Templategrid = true;
            $scope.Templateform = false;
            $scope.tExport = true;
            $scope.tAdd = true;
            $scope.tView = false;
            $scope.tSearch = true;
        }

        $scope.tSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/appraisaltemplateform/update",
                    data: {
                        _id: $scope.SID,
                        TemplateName: $scope.TemplateName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Appraisaltemplateformdatas[$scope.IndexID] = GList.data.data;
                    RefreshAppraisaltemplatedataGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/appraisaltemplateform/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        TemplateName: $scope.TemplateName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Templateinfo = function (TemplateId, $index) {
            $scope.SID = TemplateId;
            $scope.IndxID = $index;
            $scope.Update = true;
            try {
                var item = $scope.Appraisaltemplateformdatas.filter(function (item) {
                    return item._id === TemplateId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.TemplateName = item.TemplateName;
            } catch (err) { }

            RefreshAppraisaltemplatedataGrid();

            $scope.Templateform = true;
            $scope.Templategrid = false;
            $scope.tExport = false;
            $scope.tView = true;
            $scope.tAdd = false;
            $scope.tSearch = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Clone = function (TId) {
            try {
                var item = $scope.Appraisaltemplateformdatas.filter(function (item) {
                    return item._id === TId;
                })[0];
                $scope.id = item._id;
                $scope.CUniqID = item.UniqueID;
                $scope.TemplateName = item.TemplateName;
            } catch (err) { }

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.cloneUniqueID = pass;

            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplatedata/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.CUniqID },
            });
            response.then(function (Appraisaltemplatedata) {
                $scope.CloneAppraisaltemplatedatas = Appraisaltemplatedata.data.data;

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/appraisaltemplateform/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.cloneUniqueID,
                        TemplateName: $scope.TemplateName + '_C1',
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    angular.forEach($scope.CloneAppraisaltemplatedatas, function (value) {
                        if ($scope.CUniqID == value.UniqueID) {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/appraisaltemplatedata/add",
                                data: {
                                    Client_Id: Client_Id,
                                    TemplateName: $scope.TemplateName + '_C1',
                                    UniqueID: $scope.cloneUniqueID,
                                    Category: value.Category,
                                    Criteria: value.Criteria,
                                    Weightage: value.Weightage,
                                    Order: value.Order,
                                    CreatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                    });
                    RefreshGrid();
                    RefreshAppraisaltemplatedataGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Cloned!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            });
        }

        $scope.Templateformdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/template/templatedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisaltemplateController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.TFdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/appraisaltemplateform/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Templatepopup = function (e, UniqueID) {
            $scope.UniqID = UniqueID;
            $scope.vm.tCategory = '';
            $scope.vm.tCriteria = '';
            $scope.vm.tWeightage = '';
            $scope.vm.tOrder = '';
            $scope.TUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/template/templatedetail.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisaltemplateController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Templateadd = function () {
            if ($scope.TUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/appraisaltemplatedata/update",
                    data: {
                        _id: $scope.WID,
                        Category: $scope.vm.tCategory,
                        Criteria: $scope.vm.tCriteria,
                        Weightage: $scope.vm.tWeightage,
                        Order: $scope.vm.tOrder,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshAppraisaltemplatedataGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/appraisaltemplatedata/add",
                    data: {
                        Client_Id: Client_Id,
                        TemplateName: $scope.TemplateName,
                        UniqueID: $scope.UniqID,
                        Category: $scope.vm.tCategory,
                        Criteria: $scope.vm.tCriteria,
                        Weightage: $scope.vm.tWeightage,
                        Order: $scope.vm.tOrder,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshAppraisaltemplatedataGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Templateupdate = function (e, TempId) {
            $scope.TUpdate = true;
            $scope.WID = TempId;
            try {
                var item = $scope.Appraisaltemplatedatas.filter(function (item) {
                    return item._id === TempId;
                })[0];
                $scope.id = item._id;
                $scope.TemplateName = item.TemplateName;
                $scope.UniqID = item.UniqueID;
                $scope.vm.tCategory = item.Category;
                $scope.vm.tCriteria = item.Criteria;
                $scope.vm.tWeightage = parseInt(item.Weightage);
                $scope.vm.tOrder = parseInt(item.Order);
            } catch (err) { }
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/template/templatedetail.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisaltemplateController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Templatedelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/appraisal/template/templatedetaildelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AppraisaltemplateController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.TDdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/appraisaltemplatedata/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshAppraisaltemplatedataGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplateform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Appraisaltemplateformdata) {
                $scope.Appraisaltemplateformdatas = Appraisaltemplateformdata.data.data;
            });
        }

        function RefreshAppraisaltemplatedataGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/appraisaltemplatedata/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Appraisaltemplatedata) {
                $scope.Appraisaltemplatedatas = Appraisaltemplatedata.data.data;
            });
        }

        function ClearForm() {
            $scope.UniqueID = '';
            $scope.TemplateName = '';
            $scope.Appraisaltemplatedatas = '';
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }
})();




(function ()
{
    'use strict';

    angular
        .module('app.todo',
            [
                // 3rd Party Dependencies
                'ng-sortable',
                'textAngular'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (msApi)
                {
                    return msApi.resolve('todo.tasks@get');
                },
                Tags : function (msApi)
                {
                    return msApi.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');

        // Api
        msApiProvider.register('todo.tasks', ['app/data/todo/tasks.json']);
        msApiProvider.register('todo.tags', ['app/data/todo/tags.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.to-do', {
            title : 'To-Do',
            icon  : 'icon-checkbox-marked',
            state : 'app.to-do',
            weight: 9
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, $scope, $rootScope, $mdToast, $http, $state, event, Task) {


        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }


        var vm = this;

        // Data
        vm.title = 'Edit Task';

        vm.task = angular.copy(Task);

        vm.show1 = false;
        vm.show = true;


        //vm.tasks = Task;
        vm.newTask = false;

        if (!vm.task) {
            vm.task = {
                'id': '',
                'title': '',
                'notes': '',
                'StartDate': new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate': '',
                'dueDateTimeStamp': '',
                'completed': false,
                'starred': false,
                'important': false,
                'deleted': false,
                // 'tags'              : []
            };


            vm.title = 'New Task';
            vm.newTask = true;
            vm.show1 = true;
            vm.show = false;
            //vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask() {

            debugger

            var response;

            angular.forEach(vm.task.AssignedTo, function (value, key) {

                response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/todo/add",
                    data: {
                        Title: vm.task.Title, StartDate: vm.task.StartDate, Notes: vm.task.Notes,
                        DueDate: vm.task.DueDate, AssignedTo: value.EmployeeName, completed: false, starred: false, important: false, deleted: false,
                        CreatedBy: $rootScope.createdby
                    },
                });

            });

            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));



            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });

            $state.reload();
            closeDialog();

            RefreshGrid();

        }

        /**
         * Save task
         */

        function saveTask() {

            debugger
            var response;
            response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/todo/update",
                data: {

                    _id: vm.task.id, Title: vm.task.Title, StartDate: vm.task.StartDate, Notes: vm.task.Notes,
                    DueDate: vm.task.DueDate, AssignedTo: vm.task.AssignedTo, completed: vm.task.completed, starred: vm.task.starred, important: vm.task.important,
                    deleted: vm.task.deleted,
                    UpdatedBy: $rootScope.createdby,
                },
            });

            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
            // saveTask();
            $state.reload();
            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask() {

            debugger
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                debugger
                var response;
                response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/todo/delete",
                    data: {
                        _id: vm.task.id,
                        deleted: true,
                        UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {
                    debugger
                    $state.reload();
                    $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });


            }, function () {
                // Cancel Action
            });
        }


        $http.get($rootScope.WebURL + "/employee")
            .then(function (employeedata) {
                $scope.Employeedatas = employeedata.data.data;
            });


        $http.get($rootScope.WebURL + "/todo")
            .then(function (ToDo) {
                debugger
                vm.tasks = ToDo.data.data;
                RefreshGrid()
            });

        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/todo")
                .then(function (ToDo) {
                    debugger
                    vm.tasks = ToDo.data.data;

                });


        }



        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip) {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name: chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.operations.trendingReports.setup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.operations_trendingreport_setup', {
            url: '/TrendingReportSetup',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/trendingReports/setup/setup.html',
                    controller: 'TrendingReportSetupController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operations.trendingReports.setup')
        .controller('TrendingReportSetupController', TrendingReportSetupController);

    /** @ngInject */
    function TrendingReportSetupController($mdDialog, $document, $scope, $rootScope, $mdToast, $http, Upload) {
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        var vm = this
        $scope.Search = true
        $scope.viewbtn = false
        $scope.SetupGrid = true
        $scope.Setupform = false
        $scope.Setupdatas = []
        $scope.Attachmentdatas = []
        Refresh()

        $scope.sAdd = function () {
            $scope.Search = false
            $scope.viewbtn = true
            $scope.SetupGrid = false
            $scope.Setupform = true
            $scope.vm.SalesOrder = null
            $scope.Lighttrapdatas = []
            $scope.RodentBaitdatas = []
            $scope.MonitoringStationdatas = []
            $scope.RodentTrapperdatas = []
            $scope.Update = false
            $scope.ReferenceNo = "TR-S" + String($scope.Setupdatas.length + 1).padStart(4, 0)
            Clear();
        }

        $scope.Showgrid = function () {
            $scope.Search = true;
            $scope.viewbtn = false;
            $scope.SetupGrid = true;
            $scope.Setupform = false;
        }

        $scope.ViewReqinfo = function (row) {
            Clear();
            $scope.Update = true
            $scope.Search = false
            $scope.viewbtn = true
            $scope.SetupGrid = false
            $scope.Setupform = true
            $scope.SID = row._id;
            $scope.vm.SalesOrder = row.SalesOrderID;
            $scope.vm.SiteContactPerson = row.SiteContactPerson;
            $scope.vm.ServiceLocation = row.ServiceLocation;
            $scope.vm.SiteContactNumber = row.SiteContactNo;
            $scope.vm.SiteEmail = row.Email;
            $scope.Lighttrapdatas = row.LightTrap;
            $scope.RodentBaitdatas = row.RodentBait;
            $scope.MonitoringStationdatas = row.MonitoringStation;
            $scope.RodentTrapperdatas = row.RodentTrapper;
            RefreshAttachmentGrid();
        }
        $scope.CustomerInfo = function (row) {
            Clear();
            $scope.vm.SiteContactNumber = row.Mobile;
            $scope.vm.SiteContactPerson = row.customerServicedetails[0].sContactPerson;
            $scope.vm.SiteEmail = row.Email;
            $scope.vm.ServiceLocation = row.customerServicedetails[0].sStreetName;
        }
        $scope.ChangeTreatment = function (Pestdata) {
            $scope.Treatmentpopupdata = [];
            if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
                $scope.Pesttypearray = [];
                angular.forEach(Pestdata, function (value) {
                    var Pestname = value.PestName;
                    $scope.Treatmentpopupdata.push({ PestName: Pestname });
                })
            }
        }
        $scope.TrapPopup = function (e, poptype) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/trendingReports/setup/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function TrendingReportSetupController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Location = ""
            $scope.vm.SelectPest = null
            $scope.Treatmentpopupdata = []

            if (poptype == 'LT') {
                $scope.vm.Title = "Add Light Trap"
                if ($scope.Lighttrapdatas.length > 0)
                    $scope.ReferenceNo = "LT" + String(parseInt(($scope.Lighttrapdatas[$scope.Lighttrapdatas.length - 1].ReferenceNo).substr(-2)) + 1).padStart(2, 0)
                else
                    $scope.ReferenceNo = "LT01"
            }
            else if (poptype == 'RBS') {
                $scope.vm.Title = "Add Rodent Bait Station"
                if ($scope.RodentBaitdatas.length > 0)
                    $scope.ReferenceNo = "RBS" + String(parseInt(($scope.RodentBaitdatas[$scope.RodentBaitdatas.length - 1].ReferenceNo).substr(-2)) + 1).padStart(2, 0)
                else
                    $scope.ReferenceNo = "RBS01"
            }
            else if (poptype == 'MS') {
                $scope.vm.Title = "Add Monitoring Station"
                if ($scope.MonitoringStationdatas.length > 0)
                    $scope.ReferenceNo = "MS" + String(parseInt(($scope.MonitoringStationdatas[$scope.MonitoringStationdatas.length - 1].ReferenceNo).substr(-2)) + 1).padStart(2, 0)
                else
                    $scope.ReferenceNo = "MS01"
            }
            else if (poptype == 'RT') {
                $scope.vm.Title = "Add Rodent Trapper"
                if ($scope.RodentTrapperdatas.length > 0)
                    $scope.ReferenceNo = "RT" + String(parseInt(($scope.RodentTrapperdatas[$scope.RodentTrapperdatas.length - 1].ReferenceNo).substr(-2)) + 1).padStart(2, 0)
                else
                    $scope.ReferenceNo = "RT01"
            }
        }

        $scope.SubmitPest = function (title) {
            var array = [];
            angular.forEach($scope.Treatmentpopupdata, function (item) {
                array.push({
                    PestType: item.PestName,
                    Threshold: item.Threshold,
                    Location: $scope.vm.Location,
                    ReferenceNo: $scope.ReferenceNo,
                });
            });
            if (title == "Add Light Trap") {
                $scope.Lighttrapdatas = $scope.Lighttrapdatas.concat(array)
            }

            else if (title == "Add Monitoring Station") {
                $scope.MonitoringStationdatas = $scope.MonitoringStationdatas.concat(array)
            }
            else if (title == "Add Rodent Trapper") {
                $scope.RodentTrapperdatas = $scope.RodentTrapperdatas.concat(array)
            }

            $mdDialog.hide();
        }
        $scope.SubmitBait = function () {
            $scope.RodentBaitdatas.push({
                Location: $scope.vm.Location,
                ReferenceNo: $scope.ReferenceNo,
                BaitConsumed: $scope.vm.BaitConsumed,
            });
            $mdDialog.hide();
        }

        $scope.Uploadfiles = function (file) {

            if ($scope.Update == false) {
                var count = file.length - 1;
                var upfile = file[count].file;
                var response = Upload.upload({
                    url: $rootScope.WebURL + "/trendingsetup/upload",
                    data: { file: upfile }
                }).then(function (resp) {
                    var UTableID = resp.data.data[0].GUIDFILENAME
                    var UfileName = resp.data.data[0].OriginalFileName
                    var UfileSize = resp.data.data[0].Size
                    var UPath = resp.data.data[0].Path
                    var UfileType = resp.data.data[0].Type
                    $scope.Attachmentdatas.push({ TableID: UTableID, FileName: UfileName, FileSize: UfileSize, FileType: UfileType, ModuleID: UPath, CreatedBy: $rootScope.createdby, CreatedDate: new Date() });
                })

            } else {
                var upfile = file[0].file
                var response = Upload.upload({
                    url: $rootScope.WebURL + "/trendingsetup/upload",
                    data: { file: upfile }
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME
                    $scope.fileName = resp.data.data[0].OriginalFileName
                    $scope.fileSize = resp.data.data[0].Size
                    $scope.Path = resp.data.data[0].Path
                    $scope.fileType = resp.data.data[0].Type
                    if (resp.data.message == "Successfully Uploaded") {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "Trending Setup",
                                FileID: $scope.SID,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response.then(function (GList) {
                            RefreshAttachmentGrid();
                            file[0].cancel();
                            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/trendingsetup/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        ReferenceNo: $scope.ReferenceNo,
                        SalesOrderID: vm.SalesOrder,
                        LightTrap: $scope.Lighttrapdatas,
                        RodentBait: $scope.RodentBaitdatas,
                        MonitoringStation: $scope.MonitoringStationdatas,
                        RodentTrapper: $scope.RodentTrapperdatas,
                        CreatedBy: $rootScope.CreatedBy
                    }
                })
                response.then(function (List) {
                    var id = List.data.data.id
                    _.each($scope.Attachmentdatas, function (item) {
                        var response1 = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: item.TableID,
                                TableName: "Trending Setup",
                                FileID: id,
                                FileName: item.FileName,
                                FileSize: item.FileSize,
                                FileType: item.FileType,
                                ModuleID: item.ModuleID,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                    })
                    Refresh()
                    $scope.Showgrid()
                    $mdToast.show($mdToast.simple().textContent('Setup added successfully !').position('top right'));
                })
            }
            else {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/trendingsetup/update",
                    data: {
                        _id: $scope.SID,
                        LightTrap: $scope.Lighttrapdatas,
                        RodentBait: $scope.RodentBaitdatas,
                        MonitoringStation: $scope.MonitoringStationdatas,
                        RodentTrapper: $scope.RodentTrapperdatas,
                        UpdatedBy: $rootScope.CreatedBy
                    }
                })
                response.then(function (List) {
                    Refresh()
                    $scope.Showgrid()
                    $scope.Update = false
                    $mdToast.show($mdToast.simple().textContent('Setup Updated successfully !').position('top right'));
                })
            }
        }

        $scope.Delete = function (index, type) {
            if (type == "LT") {
                $scope.Lighttrapdatas.splice(index, 1)
            }
            if (type == "RBS") {
                $scope.RodentBaitdatas.splice(index, 1)
            }
            if (type == "MS") {
                $scope.MonitoringStationdatas.splice(index, 1)
            }
            if (type == "RT") {
                $scope.RodentTrapperdatas.splice(index, 1)
            }
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.SID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function Refresh() {
            $http({
                url: $rootScope.WebURL + "/trendingsetup",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (List) {
                $scope.Setupdatas = List.data.data
            })
        }
        function Clear() {
            $scope.SID = null;
            $scope.vm.SalesOrder = null;
            $scope.vm.SiteContactPerson = null;
            $scope.vm.ServiceLocation = null;
            $scope.vm.SiteContactNumber = null;
            $scope.vm.SiteEmail = null;
            $scope.Lighttrapdatas = [];
            $scope.RodentBaitdatas = [];
            $scope.MonitoringStationdatas = [];
            $scope.RodentTrapperdatas = [];
        }
        $http({
            url: $rootScope.WebURL + "/salesorder",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        })
            .then(function (GList) {
                if (IsAdmin == true) {
                    var item = GList.data.data.filter(function (item) {
                        return item.TrendingReport === true
                    })
                    $scope.salesOrderdatas = item;
                }
                else {
                    var item = GList.data.data.filter(function (item) {
                        return item.TrendingReport === true && $scope.Emp_Id === item.SalesPerson_id
                    })
                    $scope.salesOrderdatas = item;
                }
            });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            },
            "columnDefs": [
                { "visible": false, "targets": 1 }
            ],
            "order": [[1, 'asc']],
            drawCallback: function (settings) {
                var api = this.api();

                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(1, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });
            },
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.operations.trendingReports.pendingReports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.operations_trendingreport_pendingreports', {
            url: '/PendingReports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/trendingReports/pendingReports/pendingReports.html',
                    controller: 'pendingreportsController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operations.trendingReports.pendingReports')
        .controller('pendingreportsController', pendingreportsController);

    /** @ngInject */
    function pendingreportsController($mdDateLocale, $mdDialog, $document, $scope, $rootScope, $timeout, $mdToast, $http) {

        var vm = this;
        $scope.Search = true;
        $scope.viewbtn = false;
        $scope.PendingGrid = true;
        $scope.Pendingform = false;
        $scope.TabletTrendingDatas = [];
        Refresh();

        $scope.sAdd = function () {
            $scope.Search = false;
            $scope.viewbtn = true;
            $scope.PendingGrid = false;
            $scope.Pendingform = true;
            $scope.vm.CustomerName = null;
            $scope.Lighttrapdatas = [];
            $scope.RodentBaitdatas = [];
            $scope.MonitoringStationdatas = [];
            $scope.RodentTrapperdatas = [];
            $scope.Update = false;
            $scope.vm.Index = -1;
        }

        $scope.Showgrid = function () {
            $scope.Search = true
            $scope.viewbtn = false
            $scope.PendingGrid = true
            $scope.Pendingform = false
        }

        $scope.ViewInfo = function (row) {
            $scope.Clear();
            $scope.Update = true
            $scope.Search = false
            $scope.viewbtn = true
            $scope.PendingGrid = false
            $scope.Pendingform = true
            $scope.SID = row._id
            $scope.vm.Service_Id = row.Service_Id;
            $scope.vm.ServiceID = row.ServiceID;
            $scope.vm.CustomerName = row.CompanyName;
            $scope.vm.SiteContactPerson = row.ContactPerson;
            $scope.vm.SiteContactNumber = row.ContactNumber;
            $scope.vm.ServiceLocation = row.Location;
            $scope.vm.SiteEmail = row.Email;
            $scope.Lighttrapdatas = row.LightTrap;
            $scope.RodentBaitdatas = row.RodentBait;
            $scope.MonitoringStationdatas = row.MonitoringStation;
            $scope.RodentTrapperdatas = row.RodentTrapper;
        }

        $scope.Clear = function () {
            $scope.SID = null;
            $scope.vm.Service_Id = null;
            $scope.vm.ServiceID = null;
            $scope.vm.CustomerName = null;
            $scope.vm.SiteContactPerson = null;
            $scope.vm.SiteContactNumber = null;
            $scope.vm.ServiceLocation = null;
            $scope.vm.SiteEmail = null;
            $scope.Lighttrapdatas = null;
            $scope.RodentBaitdatas = null;
            $scope.MonitoringStationdatas = null;
            $scope.RodentTrapperdatas = null;
        }

        $scope.Submit = function () {
            if ($scope.vm.Title == "Edit Rodent Bait Station") {
                $scope.RodentBaitdatas[$scope.vm.Index].BaitConsumed = $scope.vm.BaitConsumed;
                $scope.RodentBaitdatas[$scope.vm.Index].Location = $scope.vm.Location;
            }
            else if ($scope.vm.Title == "Edit Monitoring Station") {
                $scope.MonitoringStationdatas[$scope.vm.Index].PestType = $scope.vm.PestType;
                $scope.MonitoringStationdatas[$scope.vm.Index].Threshold = $scope.vm.Threshold;
            }
            else if ($scope.vm.Title == "Edit Rodent Trapper") {
                $scope.RodentTrapperdatas[$scope.vm.Index].PestType = $scope.vm.PestType;
                $scope.RodentTrapperdatas[$scope.vm.Index].Threshold = $scope.vm.Threshold;
            }
            else {
                $scope.Lighttrapdatas[$scope.vm.Index].PestType = $scope.vm.PestType;
                $scope.Lighttrapdatas[$scope.vm.Index].Threshold = $scope.vm.Threshold;
            }
            $http({
                method: "PUT",
                url: $rootScope.WebURL + "/tablettrendingsetup/update",
                data: {
                    _id: $scope.SID,
                    LightTrap: $scope.Lighttrapdatas,
                    RodentBait: $scope.RodentBaitdatas,
                    MonitoringStation: $scope.MonitoringStationdatas,
                    RodentTrapper: $scope.RodentTrapperdatas,
                    UpdatedBy: $rootScope.CreatedBy
                }
            }).then(function (List) {
                $mdDialog.cancel();
                $scope.Update = false;
                $mdToast.show($mdToast.simple().textContent('Updated successfully !').position('top right'));
                Refresh();
            })
        }

        $scope.EditPest = function (e, index, poptype) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/trendingReports/pendingReports/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function pendingreportsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Index = index;
            if (poptype == 'LT') {
                $scope.vm.Title = "Edit Light Trap";
                $scope.Treatmentpopupdata = $scope.Lighttrapdatas[index];
                $scope.vm.PestType = $scope.Lighttrapdatas[index].PestType;
                $scope.vm.Threshold = ($scope.Lighttrapdatas[index].Threshold) ? parseInt($scope.Lighttrapdatas[index].Threshold) : 0;
            }
            else if (poptype == 'RBS') {
                $scope.vm.Title = "Edit Rodent Bait Station";
                $scope.vm.Location = $scope.RodentBaitdatas[index].Location;
                $scope.vm.BaitConsumed = $scope.RodentBaitdatas[index].BaitConsumed;
            }
            else if (poptype == 'MS') {
                $scope.vm.Title = "Edit Monitoring Station";
                $scope.vm.PestType = $scope.MonitoringStationdatas[index].PestType;
                $scope.vm.Threshold = ($scope.MonitoringStationdatas[index].Threshold) ? parseInt($scope.MonitoringStationdatas[index].Threshold) : 0;

            }
            else if (poptype == 'RT') {
                $scope.vm.Title = "Edit Rodent Trapper";
                $scope.vm.PestType = $scope.RodentTrapperdatas[index].PestType;
                $scope.vm.Threshold = ($scope.RodentTrapperdatas[index].Threshold) ? parseInt($scope.RodentTrapperdatas[index].Threshold) : 0;
            }
        }
        $scope.SendReport = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/trendingReports/pendingReports/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function pendingreportsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Title = "Send Report";
        }
        $scope.GenerateReport = function (_id) {
            var url = $rootScope.ReportURL + 'TrendingReport.aspx' + '?' + 'ID=' + _id + '&Email=null&ServiceID=null&CustomerName=null';
            window.open(url);
        }
        $scope.SendEmail = function () {
            $http({
                url: $rootScope.WebURL + "/tablettrendingsetup/sendEmail",
                method: "POST",
                data: { _id: $scope.vm.Service_Id, Email: $scope.vm.Email, CustomerName: $scope.vm.CustomerName, ServiceID: $scope.vm.ServiceID },
            }).then(function (List) {
                $scope.vm.Service_Id = null;
                $scope.vm.CustomerName = null;
                $scope.vm.ServiceID = null;
                $mdToast.show($mdToast.simple().textContent('Email Sent Successfully !').position('top right'));
                $mdDialog.cancel();
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        function Refresh() {
            $http({
                url: $rootScope.WebURL + "/tablettrendingsetup",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (List) {
                $scope.TabletTrendingDatas = List.data.data
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            },
            "columnDefs": [
                { "visible": false, "targets": 1 }
            ],
            "order": [[1, 'asc']],
            drawCallback: function (settings) {
                var api = this.api();

                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(1, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });
            },
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.operations.trendingReports.pastTrendingReports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.operations_trendingreport_pasttrendingreports', {
            url: '/PastTrendingReports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/trendingReports/pastTrendingReports/pastTrendingReports.html',
                    controller: 'pasttrendingreportsController as vm'
                }
            }
        });
    }

})();

(function () {
  'use strict';

  angular
    .module('app.operations.trendingReports.pastTrendingReports')
    .controller('pasttrendingreportsController', pasttrendingreportsController);

  /** @ngInject */
  function pasttrendingreportsController($scope, $rootScope, $filter, $http) {

    var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
    var vm = this
    $scope.Search = true
    $scope.viewbtn = false
    $scope.PendingGrid = true
    $scope.Pendingform = false
    $scope.Setupdatas = []

    $scope.CustomerInfo = function (row) {
      $scope.vm.SiteEmail = null;
      $scope.vm.SiteContactPerson = null;
      $scope.vm.ServiceLocation = null;
      $scope.vm.SiteContactNumber = null;
      $scope.vm.CustomerName = null;
      $scope.vm.CustomerName = row.customerdetails[0].CompanyName;
      $scope.vm.SiteContactNumber = row.Mobile;
      $scope.vm.SiteContactPerson = row.customerServicedetails[0].sContactPerson;
      $scope.vm.SiteEmail = row.Email;
      $scope.vm.ServiceLocation = row.customerServicedetails[0].sStreetName;

    }
    $scope.Clear = function (row) {
      $scope.vm.SiteEmail = null;
      $scope.vm.SiteContactPerson = null;
      $scope.vm.ServiceLocation = null;
      $scope.vm.SiteContactNumber = null;
      $scope.vm.Customer_Id = null;
      $scope.vm.CustomerName = null;
      $scope.vm.StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
      $scope.vm.EndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
    }
    $scope.LoadDate = function () {
      $scope.vm.StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
      $scope.vm.EndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
    }
    $scope.GenerateReport = function (_id) {
      var StartDate = $filter('date')($scope.vm.StartDate, 'y-MM-dd HH:mm:ss');
      var EndDate = $filter('date')($scope.vm.EndDate, 'y-MM-dd HH:mm:ss');
      var url = $rootScope.ReportURL + 'PastTrendingReport.aspx?Customer_Id=' + $scope.vm.Customer_Id + '&StartDate=' + StartDate + '&EndDate=' + EndDate + '&CustomerName=' + $scope.vm.CustomerName;
      window.open(url);
    }
    vm.PreviewSpinner = true;
    $http({
      url: $rootScope.WebURL + "/salesorder",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (GList) {
      var resArr = [];
      var item = [];
      if (IsAdmin == true) {
        item = GList.data.data.filter(function (item) {
          return item.TrendingReport === true;
        })
      }
      else {
        item = GList.data.data.filter(function (item) {
          return item.TrendingReport === true && $scope.Emp_Id === item.SalesPerson_id;
        })
      }
      try {
        item.filter(function (item) {
          var i = resArr.findIndex(function (x) {
            return x.Customer_id == item.Customer_id
          });
          if (i <= -1)
            resArr.push(item);
        });
      } catch (e) { }
      $scope.SalesOrderdatas = resArr;
      vm.PreviewSpinner = false;
    });
  }
})();
/// <reference path="pest_types.html" />
(function ()
{
    'use strict';

    angular
        .module('app.operations.services-jobs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.servicesjobs', {
            url: '/servicesjobs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/services-jobs/service-jobs.html',
                    controller: 'servicejobsProjectController as vm'
                }
            }
        });
    }

})();
(function () {


    'use strict';
    angular
        .module('app.operations.services-jobs')
        .controller('servicejobsProjectController', servicejobsProjectController);


    /** @ngInject */
    function servicejobsProjectController($scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $http) {

        $scope.Servicesgrid = true;
        $scope.Export = true;
        $scope.Servicesform = false;
        $scope.Add = true;
        $scope.Search = true;

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Servicesform = true;
            $scope.Servicesgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Search = false;

        }
        $scope.Showgrid = function () {
            $scope.Servicesgrid = true;
            $scope.Servicesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.Servicesinfo = function (ServicesId) {

            $scope.SID = ServicesId;
            $scope.Update = true;
            $scope.Servicesform = true;
            $scope.Servicesgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;

            $scope.ServicesinfoId = ServicesId;
            var Servicesdata = $scope.Servicesdatas
            var info = $scope.Servicesdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ServicesId) {
                    $scope.uServicesName = info[i].ServicesName;
                    $scope.uServicesCode = info[i].ServicesCode;
                    vm.selectedItem = info[i].Country;
                    $scope.uCurrencyCode = info[i].CurrencyCode;
                    $scope.uAddress = info[i].Address;
                    $scope.uContactPerson = info[i].ContactPerson;
                    $scope.uStartDate = new Date(info[i].StartDate);
                    $scope.uEndDate = new Date(info[i].EndDate);

                    $scope.uRemarks = info[i].Remarks;
                }
            }
        }


        $scope.sSubmit = function () {

            if ($scope.Update == true) {

                if (vm.selectedItem.display == undefined) {
                    $scope.uCountry = vm.selectedItem;
                }
                else {
                    $scope.uCountry = vm.selectedItem.display;
                }
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/Services/update",
                    data: {
                        _id: $scope.SID, ServicesName: $scope.uServicesName, ServicesCode: $scope.uServicesCode, Address: $scope.uAddress,
                        Remarks: $scope.uRemarks, Country: $scope.uCountry, CurrencyCode: $scope.uCurrencyCode,
                        ContactPerson: $scope.uContactPerson, StartDate: $scope.uStartDate, EndDate: $scope.uEndDate,
                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Servicesgrid = true;
                    $scope.Servicesform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/Services/add",

                    data: {
                        ServicesName: $scope.uServicesName, ServicesCode: $scope.uServicesCode, Address: $scope.uAddress,
                        Remarks: $scope.uRemarks, Country: vm.selectedItem.display, CurrencyCode: $scope.uCurrencyCode,
                        ContactPerson: $scope.uContactPerson, StartDate: $scope.uStartDate, EndDate: $scope.uEndDate,
                    },

                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Servicesgrid = true;
                    $scope.Servicesform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $http.get($rootScope.WebURL + "/Services")
            .then(function (Servicesdata) {
                $scope.Servicesdatas = Servicesdata.data.data;
            });
        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/Services")
                .then(function (Servicesdata) {
                    $scope.Servicesdatas = Servicesdata.data.data;
                });
        }
        function ClearForm() {
            $scope.uServicesName = '';
            $scope.uServicesCode = '';
            vm.selectedItem = '';
            $scope.uCurrencyCode = '';
            $scope.uContactPerson = '';
            $scope.uRemarks = '';
            $scope.uAddress = '';
            $scope.uStartDate = null;
            $scope.uEndDate = null;
        }

        var vm = this;

        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };

        function loadAll() {
            var allStates = 'Afghanistan,  Aland Islands,  Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Antarctica, Antigua And Barbuda, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Bosnia And Herzegovina, Botswana, Bouvet Island, Brazil, British Indian Ocean Territory, Brunei Darussalam, Bulgaria, Burkina Faso, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Cayman Islands, Central African Republic, Chad, Chile, China, Christmas Island, Cocos (Keeling) Islands, Colombia, Comoros, Congo, Congo,  The Democratic Republic Of The, Cook Islands, Costa Rica,   Croatia, Cuba, Cyprus, Czechia, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Falkland,  Islands (Malvinas), Faroe,  Islands, Fiji, Finland, France, French,  Guiana, French, Polynesia, French, Southern, \
            Territories, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guinea-bissau, Guyana, Haiti, Heard Island And Mcdonald Islands, Holy See (Vatican City State), Honduras, Hong Kong, Hungary, Iceland, India, Indonesia, Iran,  Islamic Republic Of, Iraq, Ireland, Isle Of Man, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Korea, Republic Of, Kuwait, Kyrgyzstan, LaoPeoples,  Democratic,  Republic, Latvia, Lebanon, Lesotho, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Lithuania, Luxembourg, Macao, Macedonia,  The Former Yugoslav Republic Of, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Micronesia,  Federated States Of, Moldova,  Republic Of, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, \
            Netherlands Antilles, New Caledonia, New Zealand, Nicaragua, Niger, Nigeria, Niue, Norfolk Island, Northern Mariana Islands, Norway, Oman, Pakistan, Palau, Palestinian Territory,  Occupied, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Puerto Rico, Qatar, Reunion, Romania, Russian Federation, Rwanda, Saint Helena, Saint Kitts And Nevis, Saint Lucia, Saint Pierre And Miquelon, Saint Vincent And The Grenadines, Samoa, San Marino, Sao Tome And Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Georgia And The South Sandwich Islands, Spain, Sri Lanka, Sudan, Suriname, Svalbard And Jan Mayen, Swaziland, Sweden, Switzerland, Syrian Arab Republic, Taiwan,  Province Of China, Tajikistan, Tanzania,  United Republic Of, Thailand, Timor-leste, Togo, Tokelau, Tonga, Trinidad And Tobago, Tunisia, Turkey, Turkmenistan, Turks And Caicos Islands, \
            Tuvalu, Uganda, Ukraine, United Arab,  Emirates, United Kingdom, United States, United States,  Minor Outlying,  Islands, Uruguay, Uzbekistan, Vanuatu, Venezuela, Viet Nam, Virgin Islands,  British, Virgin Islands,  U.S., Wallis And Futuna, Western Sahara, Yemen, Zambia, Zimbabwe';

            return allStates.split(/, +/g).map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.operations.report.rodentsSummary', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.operations_report_rodentsSummary', {
            url: '/RodentsSummary',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/report/rodentsSummary/rodentsSummary.html',
                    controller: 'rodentsSummaryController as vm'
                }
            }
        });
    }

})();
(function () {
  'use strict';

  angular
    .module('app.operations.report.rodentsSummary')
    .controller('rodentsSummaryController', rodentsSummaryController);

  /** @ngInject */
  function rodentsSummaryController($mdDateLocale, $scope, $rootScope, $timeout, $mdToast, $http) {
    // var chkAceses = localStorage.getItem('pages');
    // if (chkAceses.split(",").includes("Reports")) {   // do nothing 
    // }
    // else { window.location = 'NoAccess'; }
    var vm = this;
    vm.Customer = [];

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/customer",
      data: {
        Client_Id: $rootScope.Client_Id
      },
    }).then(function (customerdata) {
      $scope.Customerdatas = customerdata.data.data;
    });
    $scope.uFrom = new Date();
    $scope.uTo = new Date();
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo.setHours(23, 59, 59, 999);
    vm.YTSPreviewSpinner = true;

    $scope.DownloadButton = true;

    LoadGridData();

    function LoadGridData() {

      $scope.DownloadButton = true;

      if ($scope.CustomerName == undefined) {
        vm.YTSPreviewSpinner = false;
        $mdToast.show($mdToast.simple().textContent('Please select customer !').position('top center'));
        return;
      } else {
        vm.YTSPreviewSpinner = true;
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/getforRodentsWeb",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer: $scope.CustomerName,
          },
        }).then(function (List) {
          $scope.RodentSummarydatas = List.data.data;
          vm.YTSPreviewSpinner = false;

          $timeout(function () {
            $scope.DownloadButton = false;
          }, 15000);
        });
      }
    }

    $scope.SearchData = function () {

      LoadGridData();
    }
    $scope.DownloadImage = function () {

      if ($scope.CustomerName == undefined) {
        $mdToast.show($mdToast.simple().textContent('Please select customer !').position('top center'));
        return;
      }

      var ZipName = "Images";

      if (getDateString($scope.uFrom) == getDateString($scope.uTo)) {
        ZipName = getDateString($scope.uFrom);
      } else {
        ZipName = getConcatDateString($scope.uFrom, $scope.uTo);
      }

      var url = $rootScope.PhotosDownloadURL + $scope.CustomerName + "_" + ZipName + ".Zip";

      window.open(url);

    }

    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }],
      dataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };

    vm.dataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.RodentSummarydatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Rodents Summary Details",
        allowExportSelectedData: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      allowColumnResizing: true,
      columns: [{
        caption: '#',
        width: "50",
        cellTemplate: function (cellElement, cellInfo) {
          cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
        }
      },
      {
        dataField: "ServiceID",
        width: "110",
        caption: "Service ID",
      },
      {
        caption: "Customer Name",
        dataField: "CustomerName"
      },
      {

        dataField: "Location",
        caption: "Address",
        groupIndex: 0,
        cellTemplate: function (container, options) {
          try {
            var Loca = options.data.Location;
            Loca = Loca.replace("null", "");
            $("<p>" + Loca + "</p>").appendTo(container);
          } catch (e) { }
        },
      },
      {
        dataField: "GroupName",
        caption: "Group Name",
      },
      {
        dataField: "Startsat",
        caption: "Scheduled Date",
        dataType: "date",
        format: 'dd/MM/yyyy'
      },
      {
        dataField: "NoOfBurrows",
        caption: "No of Burrows",
        calculateCellValue: function (rowData) {
          return rowData.NoOfBurrows === '' || rowData.NoOfBurrows == null || rowData.NoOfBurrows == undefined ? 0 : rowData.NoOfBurrows
        }
      },
      {
        dataField: "NoOfCulls",
        caption: "No of Culls",
        calculateCellValue: function (rowData) {
          return rowData.NoOfCulls === '' || rowData.NoOfCulls == null || rowData.NoOfCulls == undefined ? 0 : rowData.NoOfCulls
        }
      },
      {
        dataField: "NoOfDead",
        caption: "No of Deads",
        calculateCellValue: function (rowData) {
          return rowData.NoOfDead === '' || rowData.NoOfDead == null || rowData.NoOfDead == undefined ? 0 : rowData.NoOfDead
        }
      },
      {
        dataField: "Habitat",
        caption: "Habitat"
      },
      {
        dataField: "Reason",
        caption: "Reason"
      },
      {
        dataField: "Action",
        caption: "Action taken"
      },

      ],
      bindingOptions: {
        dataSource: "RodentSummarydatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };


    $scope.ChangeDate = function (Type) {
      if (Type == 'less') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
        $scope.uTo = new Date($scope.uFrom);
      }
      if (Type == 'greater') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
        $scope.uTo = new Date($scope.uFrom);
      }
    }

    function getDateString(ScheduleDate) {
      var date = new Date(ScheduleDate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = (month < 10 ? "0" : "") + month;
      var day = date.getDate();
      day = (day < 10 ? "0" : "") + day;

      return day + month + year;
    }

    function getConcatDateString(Start_Date, End_Date) {

      var date = new Date(Start_Date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = (month < 10 ? "0" : "") + month;
      var day = date.getDate();
      day = (day < 10 ? "0" : "") + day;

      var E_date = new Date(End_Date);
      var E_day = E_date.getDate();
      var E_month = E_date.getMonth() + 1;

      return day + month + E_day + E_month + year;
    }

    $mdDateLocale.formatDate = formatDate;

    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.operations.report.detailanalytical', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.operations_report_detailanalytical', {
            url: '/DetailAnalyticalReport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/report/detailanalytical/detailanalytical.html',
                    controller: 'DetailanalyticalController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/report/detailanalytical');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operations.report.detailanalytical')
        .controller('DetailanalyticalController', DetailanalyticalController);

    /** @ngInject */
    function DetailanalyticalController($mdDateLocale, $scope, $rootScope, $http) {
        //  var chkAceses = localStorage.getItem('pages');
        //  if (chkAceses.split(",").includes("Reports")) {   // do nothing 
        //  }
        //  else { window.location = 'NoAccess'; }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        DefaultDatefilter();
        RefreshCustomerGrid();

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("FeedbackDetails.xlsx",{headers:true}) FROM ?', [$scope.Feedbackdatas]);
        };

        function DefaultDatefilter() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/customerfeedback/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                debugger
                $scope.Feedbackdatas = GList.data.data;
            });
        }
        function RefreshCustomerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Customerdata) {
                $scope.Customerdatas = Customerdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            vm.YTSPreviewSpinner = true;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/customerfeedback/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Feedbackdatas = GList.data.data;
                vm.YTSPreviewSpinner = false;
            });
        }

        function RefreshFeedbackGrid() {
            vm.YTSPreviewSpinner = true;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customerfeedback",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Feedbackdata) {
                $scope.Feedbackdatas = Feedbackdata.data.data;
                vm.YTSPreviewSpinner = false;
            });
        }

        var applyFilterTypes = [{
            key: "auto",
            name: "Immediately"
        }, {
            key: "onClick",
            name: "On Button Click"
        }], dataGrid;
        $scope.filterRow = {
            visible: true,
            applyFilter: "auto"
        };
        $scope.headerFilter = {
            visible: true
        };
        vm.dataGrid = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            dataSource: $scope.ConsumptionReportdatas,
            keyExpr: "SchedulerID",
            paging: {
                enabled: true,
                pageSize: 10
            },
            editing: {
                allowUpdating: false,
            },
            export: {
                enabled: JSON.parse($rootScope.AllowExport),
                fileName: "Detail Analytical",
                allowExportSelectedData: false
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            groupPanel: {
                visible: true
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "ReferenceNo", width: "110", caption: "Service ID",
                },
                {
                    caption: "Customer Name", dataField: "Customerdetails[0].CompanyName", groupIndex: 0
                },
                {
                    caption: "Work Order #", dataField: "WorkOrder",
                },
                {

                    dataField: "ServiceAddress", caption: "Address",
                    cellTemplate: function (container, options) {
                        try {
                            var Loca = options.data.ServiceAddress;
                            Loca = Loca.replace("null", "");
                            $("<p>" + Loca + "</p>").appendTo(container);
                        } catch (e) { }
                    },
                },
                {
                    caption: "ServiceNo", dataField: "ServiceNo",
                },
                { dataField: "DateofService", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "PestType", caption: "Pest Types" },
                { dataField: "Feedback", caption: "Feedback" },
                { dataField: "Comment", caption: "Comment" },
                { dataField: "Status", caption: "Status" },

            ],
            bindingOptions: {
                dataSource: "ConsumptionReportdatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            onCellPrepared: function (e) {

            },
        };


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.operations.report.ConsumptionReport', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.operations_report_ConsumptionReport', {
            url: '/ConsumptionReport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/report/ConsumptionReport/ConsumptionReport.html',
                    controller: 'ConsumptionReportController as vm'
                }
            }
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.operations.report.ConsumptionReport')
    .controller('ConsumptionReportController', ConsumptionReportController);

  /** @ngInject */
  function ConsumptionReportController($mdDateLocale, $scope, $rootScope, $http) {
    // var chkAceses = localStorage.getItem('pages');
    // if (chkAceses.split(",").includes("Reports")) { // do nothing 
    // } else {
    //   window.location = 'NoAccess';
    // }

    var vm = this;
    var Client_Id = localStorage.getItem('Client_Id');
    $rootScope.LoginedUser = localStorage.getItem('UserName');
    $rootScope.LoginID = localStorage.getItem('LoginID');

    var d = new Date();
    var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
    //var lastDay = new Date(to);
    $scope.uFrom = lastDay;
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo = date;
    $scope.uTo.setHours(23, 59, 59, 999);

    $scope.CustomerID = null;
    $scope.WorkOrderID = null;
    $scope.ContractID = null;
    DefaultDatefilter();
    $scope.Export = function () {
      alasql('SELECT * INTO XLSX("ConsumptionReportDetails.xlsx",{headers:true}) FROM ?', [$scope.ConsumptionReportdatas]);
    };

    function DefaultDatefilter() {
      vm.YTSPreviewSpinner = true;



      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforConsumptionReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerConsumptionReportdatas = GList.data.data;
        try {
          $scope.FilterTabletMaterialConsumptionReportdatas = $scope.getSchedulerConsumptionReportdatas.filter(function (item) {
            return item.TabletMaterialdetails.length > 0;
          });
        } catch (error) { }
        $scope.getConsumptionReportdatas = [];
        angular.forEach($scope.FilterTabletMaterialConsumptionReportdatas, function (value) {
          var getAllTabletMaterials = value.TabletMaterialdetails;
          angular.forEach(getAllTabletMaterials, function (value1) {
            var getQuantity = 0;
            if (value1.Quantity != "" && value1.Quantity != null && value1.Quantity != undefined) {
              getQuantity = parseFloat(value1.Quantity);
            } else {
              getQuantity = 0;
            }
            if (getQuantity > 0) {
              $scope.getConsumptionReportdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerID: value.CustomerID,
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                AssignedToName: value.TeamName,
                PestType: value.PestType,
                MaterialName: value1.MaterialName,
                Quantity: value1.Quantity,
                Unit: value1.Unit,
                ServiceAddress: value.Location
              })
            }
          });
        });
        vm.YTSPreviewSpinner = false;
        $scope.ConsumptionReportdatas = $scope.getConsumptionReportdatas;
      });
    }
    $scope.RefreshFilter = function () {
      vm.YTSPreviewSpinner = true;
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
      $scope.uFrom = lastDay;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo = date;
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforConsumptionReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerConsumptionReportdatas = GList.data.data;
        try {
          $scope.FilterTabletMaterialConsumptionReportdatas = $scope.getSchedulerConsumptionReportdatas.filter(function (item) {
            return item.TabletMaterialdetails.length > 0;
          });
        } catch (error) { }
        $scope.getConsumptionReportdatas = [];
        angular.forEach($scope.FilterTabletMaterialConsumptionReportdatas, function (value) {
          var getAllTabletMaterials = value.TabletMaterialdetails;
          angular.forEach(getAllTabletMaterials, function (value1) {
            var getQuantity = 0;
            if (value1.Quantity != "" && value1.Quantity != null && value1.Quantity != undefined) {
              getQuantity = parseFloat(value1.Quantity);
            } else {
              getQuantity = 0;
            }
            if (getQuantity > 0) {
              $scope.getConsumptionReportdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerID: value.CustomerID,
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                AssignedToName: value.TeamName,
                PestType: value.PestType,
                MaterialName: value1.MaterialName,
                Quantity: value1.Quantity,
                Unit: value1.Unit,
                ServiceAddress: value.Location
              })
            }
          });
        });
        vm.YTSPreviewSpinner = false;
        $scope.ConsumptionReportdatas = $scope.getConsumptionReportdatas;
        RefreshWorkorderGrid();
        $scope.CustomerID = null;
        $scope.WorkOrderID = null;
        $scope.ContractID = null;

      });
    }
    $scope.Datefilter = function () {
      vm.YTSPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforConsumptionReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerConsumptionReportdatas = GList.data.data;
        try {
          $scope.FilterTabletMaterialConsumptionReportdatas = $scope.getSchedulerConsumptionReportdatas.filter(function (item) {
            return item.TabletMaterialdetails.length > 0;
          });
        } catch (error) { }
        $scope.getConsumptionReportdatas = [];
        angular.forEach($scope.FilterTabletMaterialConsumptionReportdatas, function (value) {
          var getAllTabletMaterials = value.TabletMaterialdetails;
          angular.forEach(getAllTabletMaterials, function (value1) {
            var getQuantity = 0;
            if (value1.Quantity != "" && value1.Quantity != null && value1.Quantity != undefined) {
              getQuantity = parseFloat(value1.Quantity);
            } else {
              getQuantity = 0;
            }
            if (getQuantity > 0) {
              $scope.getConsumptionReportdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerID: value.CustomerID,
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                AssignedToName: value.TeamName,
                PestType: value.PestType,
                MaterialName: value1.MaterialName,
                Quantity: value1.Quantity,
                Unit: value1.Unit,
                ServiceAddress: value.Location
              })
            }
          });
        });
        $scope.ConsumptionReportdatas = $scope.getConsumptionReportdatas;
        vm.YTSPreviewSpinner = false;
      });
    }

    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }],
      dataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    vm.dataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.ConsumptionReportdatas,
      keyExpr: "SchedulerID",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Birds and Rodents Count",
        allowExportSelectedData: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      allowColumnResizing: true,
      columns: [{
        caption: '#',
        width: "50",
        cellTemplate: function (cellElement, cellInfo) {
          cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
        }
      },
      {
        dataField: "ServiceID",
        width: "110",
        caption: "Service ID",
      },
      {
        caption: "Customer Name",
        dataField: "CustomerName",
        groupIndex: 0
      },
      {
        caption: "Work Order #",
        dataField: "WorkorderName",
      },
      {

        dataField: "ServiceAddress",
        caption: "Address",
        cellTemplate: function (container, options) {
          try {
            var Loca = options.data.ServiceAddress;
            Loca = Loca.replace("null", "");
            $("<p>" + Loca + "</p>").appendTo(container);
          } catch (e) { }
        },
      },
      {
        caption: "Group Name",
        dataField: "GroupName",
      },
      {
        caption: "Team",
        dataField: "AssignedToName",
      },
      {
        dataField: "ScheduledStartDate",
        caption: "Scheduled Date",
        dataType: "date",
        format: 'dd/MM/yyyy'
      },
      {
        dataField: "PestType",
        caption: "Pest Types"
      },
      {
        dataField: "MaterialName",
        caption: "Material"
      },
      {
        dataField: "Quantity",
        caption: "Quantity",
        calculateCellValue: function (rowData) {
          return rowData.Quantity === '' || rowData.Quantity == null || rowData.Quantity == undefined ? 0 : rowData.Quantity
        }
      },
      {
        dataField: "Unit",
        caption: "Unit"
      },

      ],
      bindingOptions: {
        dataSource: "ConsumptionReportdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellPrepared: function (e) {

      },
    };

    $mdDateLocale.formatDate = formatDate;

    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.operations.report.BirdsCount', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.operations_report_BirdsCount', {
            url: '/BirdsandRodentCount',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/report/BirdsCount/BirdsCount.html',
                    controller: 'BirdsCountController as vm'
                }
            }
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.operations.report.BirdsCount')
    .controller('BirdsCountController', BirdsCountController);

  /** @ngInject */
  function BirdsCountController($mdDateLocale, $scope, $rootScope, $http) {
    // var chkAceses = localStorage.getItem('pages');
    // if (chkAceses.split(",").includes("Reports")) { // do nothing 
    // } else {
    //   window.location = 'NoAccess';
    // }

    var Client_Id = localStorage.getItem('Client_Id');
    $rootScope.LoginedUser = localStorage.getItem('UserName');
    $rootScope.LoginID = localStorage.getItem('LoginID');
    var vm = this;
    var d = new Date();
    var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);

    var date = new Date();
    var lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
    //var lastDay = new Date(to);
    $scope.uFrom = lastDay;
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo = date;
    $scope.uTo.setHours(23, 59, 59, 999);
    //$scope.BirdsandRodentsReportdatas= [];
    DefaultDatefilter();
    $scope.Export = function () {
      alasql('SELECT * INTO XLSX("BirdsandRodentsCountDetails.xlsx",{headers:true}) FROM ?', [$scope.BirdsandRodentsReportdatas]);
    };

    function DefaultDatefilter() {
      vm.YTSPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforBirdsRodentReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerBirdsCountReportdatas = GList.data.data;
        $scope.getBirdsCountdatas = [];
        angular.forEach($scope.getSchedulerBirdsCountReportdatas, function (value) {

          var getAllPesttypes = value.TabletPesttype;
          var ArrayofgetAllPesttypes = getAllPesttypes.split(",");
          angular.forEach(ArrayofgetAllPesttypes, function (value1) {

            var getPest = value1;
            if (getPest === "Birds") {
              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Birds",
                NoOfCulls: value.NoOfCulls,
                NoOfBurrows: null,
                NoOfDead: null,
                ServiceAddress: value.Location,
              })
            }
            if (getPest === "Rodents") {


              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Rodents",
                NoOfCulls: null,
                NoOfBurrows: value.NoOfBurrows,
                NoOfDead: value.NoOfDead,
                ServiceAddress: value.Location,
              })
            }
          });
        });
        $scope.BirdsandRodentsReportdatas = $scope.getBirdsCountdatas;
        vm.YTSPreviewSpinner = false;
      });
    }
    $scope.RefreshFilter = function () {

      debugger

      $scope.vm.YTSPreviewSpinner = true;
      var date = new Date();
      var lastDay = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
      $scope.uFrom = lastDay;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo = date;
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforBirdsRodentReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerBirdsCountReportdatas = GList.data.data;

        $scope.getBirdsCountdatas = [];
        angular.forEach($scope.getSchedulerBirdsCountReportdatas, function (value) {

          var getAllPesttypes = value.TabletPesttype;
          var ArrayofgetAllPesttypes = getAllPesttypes.split(",");
          angular.forEach(ArrayofgetAllPesttypes, function (value1) {

            var getPest = value1;
            if (getPest === "Birds") {
              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Birds",
                NoOfCulls: value.NoOfCulls,
                NoOfBurrows: null,
                NoOfDead: null,
                ServiceAddress: value.Location,
              })
            }
            if (getPest === "Rodents") {


              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Rodents",
                NoOfCulls: null,
                NoOfBurrows: value.NoOfBurrows,
                NoOfDead: value.NoOfDead,
                ServiceAddress: value.Location,
              })
            }
          });
        });
        $scope.vm.YTSPreviewSpinner = false;
        $scope.BirdsandRodentsReportdatas = $scope.getBirdsCountdatas;
      });
    }
    $scope.Datefilter = function () {
      $scope.vm.YTSPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/GetforBirdsRodentReport",
        method: "POST",
        data: {
          Client_Id: Client_Id,
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo
        },
      });
      response.then(function (GList) {
        $scope.getSchedulerBirdsCountReportdatas = GList.data.data;

        $scope.getBirdsCountdatas = [];
        angular.forEach($scope.getSchedulerBirdsCountReportdatas, function (value) {

          var getAllPesttypes = value.TabletPesttype;
          var ArrayofgetAllPesttypes = getAllPesttypes.split(",");
          angular.forEach(ArrayofgetAllPesttypes, function (value1) {

            var getPest = value1;
            if (getPest === "Birds") {
              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Birds",
                NoOfCulls: value.NoOfCulls,
                NoOfBurrows: null,
                NoOfDead: null,
                ServiceAddress: value.Location,
              })
            }
            if (getPest === "Rodents") {

              $scope.getBirdsCountdatas.push({
                SchedulerID: value._id,
                ServiceID: value.ServiceID,
                ScheduledStartDate: new Date(value.Startsat),
                CustomerName: value.CustomerName,
                GroupName: value.GroupName,
                WorkorderName: value.WorkOrderNo,
                ServicedBy: value.UpdatedBy,
                PestType: "Rodents",
                NoOfCulls: null,
                NoOfBurrows: value.NoOfBurrows,
                NoOfDead: value.NoOfDead,
                ServiceAddress: value.Location,
              })
            }
          });
        });
        $scope.vm.YTSPreviewSpinner = false;
        $scope.BirdsandRodentsReportdatas = $scope.getBirdsCountdatas;
      });
    }

    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }],
      dataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    vm.dataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.BirdsandRodentsReportdatas,
      keyExpr: "SchedulerID",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Birds and Rodents Count",
        allowExportSelectedData: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      allowColumnResizing: true,
      columns: [{
        caption: '#',
        width: "50",
        cellTemplate: function (cellElement, cellInfo) {
          cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
        }
      },
      {
        dataField: "ServiceID",
        width: "110",
        caption: "Service ID",
      },
      {
        caption: "Customer Name",
        dataField: "CustomerName",
        groupIndex: 0
      },
      {
        caption: "Work Order #",
        dataField: "WorkorderName",
      },
      {
        dataField: "ServiceAddress",
        caption: "Address",
        cellTemplate: function (container, options) {
          try {
            var Loca = options.data.ServiceAddress;
            Loca = Loca.replace("null", "");
            $("<p>" + Loca + "</p>").appendTo(container);
          } catch (e) { }
        },
      },

      {
        caption: "Group Name",
        dataField: "GroupName",
      },
      {
        caption: "Serviced By",
        dataField: "ServicedBy",
      },
      {
        dataField: "ScheduledStartDate",
        caption: "Scheduled Date",
        dataType: "date",
        format: 'dd/MM/yyyy'
      },
      {
        dataField: "PestType",
        caption: "Pest Types"
      },
      {
        dataField: "NoOfBurrows",
        caption: "No of Burrows",
        calculateCellValue: function (rowData) {
          return rowData.NoOfBurrows === '' || rowData.NoOfBurrows == null || rowData.NoOfBurrows == undefined ? 0 : rowData.NoOfBurrows
        }
      },
      {
        dataField: "NoOfCulls",
        caption: "No of Culls",
        calculateCellValue: function (rowData) {
          return rowData.NoOfCulls === '' || rowData.NoOfCulls == null || rowData.NoOfCulls == undefined ? 0 : rowData.NoOfCulls
        }
      },
      {
        dataField: "NoOfDead",
        caption: "No of Deads",
        calculateCellValue: function (rowData) {
          return rowData.NoOfDead === '' || rowData.NoOfDead == null || rowData.NoOfDead == undefined ? 0 : rowData.NoOfDead
        }
      },
      {
        dataField: "SOR",
        caption: "SOR"
      },

      ],
      bindingOptions: {
        dataSource: "BirdsandRodentsReportdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };

    $mdDateLocale.formatDate = formatDate;

    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.procurement.stock.stocklist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_stocklist', {
            url: '/StockList',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/stocklist/stocklist.html',
                    controller: 'StockListController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.stocklist')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('StockListController', StockListController);


    function StockListController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $window, $mdToast, $location, $state, $mdDialog, $document, $http, $log, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var Client_Id = localStorage.getItem('Client_Id');

        RefreshStoreGrid();
        RefreshSupplierGrid();
        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshTransactionDetailGrid();
        RefreshCategory();
        RefreshUnit();
        RefreshPOGrid();
        //RefreshWorkflowGrid();
        //RefreshPurchaseformGrid();
        //RefreshPurchaseGrid();
        //RefreshStockissuancedetailsGrid();
        //RefreshStockissuanceformGrid();
        //RefreshStockreturnGrid();
        //RefreshStockreturnhistoryGrid();

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
            $scope.vm.searchTerm4 = '';
        }

        $scope.getRowColour = function (item) {
            if (parseFloat(item.ReorderQuantity) > parseFloat(item.TotalQuantity)) {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.ShowTotalStock = function (TotalStock) {
            if (TotalStock != null && TotalStock != undefined && TotalStock != "") {
                if (parseFloat(TotalStock) % 1 == 0) {
                    if (TotalStock < 0) {
                        return 0;
                    } else {
                        return TotalStock;
                    }
                }
                else {
                    if (TotalStock < 0) {
                        return 0;
                    } else {
                        return parseFloat(TotalStock).toFixed(1);
                    }
                }
            }
        }

        $scope.DisplayOnHold = function (value) {
            if (value != null && value != undefined && value != "") {
                if (parseFloat(value) % 1 == 0) {
                    if (value < 0) {
                        return 0;
                    } else {
                        return value;
                    }
                }
                else {
                    if (value < 0) {
                        return 0;
                    } else {
                        return parseFloat(value).toFixed(1);
                    }
                }
            }
        }

        $scope.getIssuanceHistoryRowColour = function (item) {
            if (item.ProductType === "Yes") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT StoreName,ProductCategory,ProductCode,ProductName,Description,formatvalue(ReorderQuantity) AS MinimumOrderQuantity,formatvalue(OnHold) As OnHold,formatvalue(TotalQuantity) As TotalQuantity,Unit,CreatedBy,formatdate(CreatedDate) As CreatedDate INTO XLSX("StockLists.xlsx",{headers:true}) FROM ?', [$scope.Goodsuniquedatas]);
        };

        $scope.PurchaseHistoryExport = function () {
            alasql('SELECT ReferenceNo,StoreName,DONumber,SerialNumber,formatvalue(OrderedQuantity) AS OrderedQuantity,formatvalue(ReceivedQuantity) As ReceivedQuantity,Unit,CreatedBy As ReceivedBy,formatdate(CreatedDate) As ReceivedDate  INTO XLSX("StockPurchaseHistory.xlsx",{headers:true}) FROM ?', [$scope.PurchaseHistorydatas]);
        };

        $scope.IssuaneHistoryExport = function () {
            alasql('SELECT ReferenceNo,StoreID,IssueTo,SerialNumber,formatvalue(Quantity) AS IssuedQuantity,formatdate(IssuedDate) As IssuedDate,ProductType As Returnable,formatdate(ReturnDate) As ExpectedReturnDate INTO XLSX("StockIssuanceHistory.xlsx",{headers:true}) FROM ?', [$scope.IssuanceHistorydatas]);
        };

        $scope.ReturnHistoryExport = function () {
            alasql('SELECT ReferenceNo,StoreID,SerialNumber,formatvalue(ReceivedQuantity) AS ReceivedQuantity,formatdate(CreatedDate) As ReceivedDate,formatdate(ReturnDate) As ExpectedReturnDate INTO XLSX("StockReturnHistory.xlsx",{headers:true}) FROM ?', [$scope.ReturnHistorydatas]);
        };

        alasql.fn.formatdate = function (dateStr) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(dateStr);
            if (d.getFullYear() > 2000) {
                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            }
            else { return ''; }
        };

        alasql.fn.formatvalue = function (str) {
            var va = 0;
            try {
                if (str != undefined || str != null || str != "") {
                    va = parseFloat(str);
                    if (va > 0) {
                        return parseFloat(va.toFixed(2));
                    } else { return parseFloat(va.toFixed(2)); }
                }
                else { return parseFloat(va.toFixed(2)); }
            } catch (error) {
                return parseFloat(va.toFixed(2));
            }
        };

        $scope.ViewStockHistory = function (e, GoodsId) {

            $scope.PurchaseHistorydatas = "";
            $scope.IssuanceHistorydatas = "";
            $scope.ReturnHistorydatas = "";
            var date = new Date();
            var lastDay = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
            $scope.model.uFromDate = lastDay;
            $scope.model.uFromDate.setHours(0, 0, 0, 0);
            $scope.model.uToDate = date;
            $scope.model.uToDate.setHours(23, 59, 59, 999);

            $scope.GoodsId = GoodsId;
            try {
                var item = $scope.Goodsuniquedatas.filter(function (item) {
                    return item._id === GoodsId;
                })[0];
                $scope.GId = item._id;
                $scope.StoreName = item.StoreName;
                $scope.ProductCategory = item.ProductCategory;
                $scope.ProductCode = item.ProductCode;
                $scope.ProductName = item.ProductName;
                $scope.Description = item.Description;
                $scope.Model = item.Model;
                $scope.SerialNumber = item.SerialNumber;
                $scope.TotalQuantity = parseFloat(item.TotalQuantity);
                if ($scope.TotalQuantity != null && $scope.TotalQuantity != undefined && $scope.TotalQuantity != "") {
                    if (parseFloat($scope.TotalQuantity) % 1 == 0) {
                        if ($scope.TotalQuantity < 0) {
                            $scope.TotalQuantity = 0;
                        } else {
                            $scope.TotalQuantity = $scope.TotalQuantity;
                        }
                    }
                    else {
                        if ($scope.TotalQuantity < 0) {
                            $scope.TotalQuantity = 0;
                        } else {
                            $scope.TotalQuantity = parseFloat($scope.TotalQuantity).toFixed(1);
                        }
                    }
                }
                $scope.ReorderQuantity = parseFloat(item.ReorderQuantity);
                $scope.OnHold = parseFloat(item.OnHold);
                $scope.Unit = item.Unit;
            } catch (err) { }


            var date = new Date();
            var lastDay = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
            $scope.FromDate = lastDay;
            $scope.FromDate.setHours(0, 0, 0, 0);
            $scope.ToDate = date;
            $scope.ToDate.setHours(23, 59, 59, 999);


            var presponse = $http({
                url: $rootScope.WebURL + "/goods/getPurchaseHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreName: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            presponse.then(function (PurchaseHistorydata) {

                $scope.PurchaseHistorydatas = PurchaseHistorydata.data.data;

                var gTotalPurchased = 0.00;
                angular.forEach($scope.PurchaseHistorydatas, function (Gvalue) {
                    if (Gvalue.ReceivedQuantity != "" && Gvalue.ReceivedQuantity != null && Gvalue.ReceivedQuantity != undefined) {
                        gTotalPurchased += parseFloat(Gvalue.ReceivedQuantity);
                    }
                });
                $scope.TotalPurchased = gTotalPurchased;

                if ($scope.TotalPurchased != null && $scope.TotalPurchased != undefined && $scope.TotalPurchased != "") {
                    if (parseFloat($scope.TotalPurchased) % 1 == 0) {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = $scope.TotalPurchased;
                        }
                    }
                    else {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = parseFloat($scope.TotalPurchased).toFixed(1);
                        }
                    }
                }
            });

            var iresponse = $http({
                url: $rootScope.WebURL + "/stockissuance/getIssuanceHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            iresponse.then(function (IssuanceHistorydata) {

                $scope.IssuanceHistorydatas = IssuanceHistorydata.data.data;

                var gTotalIssued = 0.00;
                angular.forEach($scope.IssuanceHistorydatas, function (Gvalue) {
                    if (Gvalue.Quantity != "" && Gvalue.Quantity != null && Gvalue.Quantity != undefined) {
                        gTotalIssued += parseFloat(Gvalue.Quantity);
                    }
                });
                $scope.TotalIssued = gTotalIssued;

                if ($scope.TotalIssued != null && $scope.TotalIssued != undefined && $scope.TotalIssued != "") {
                    if (parseFloat($scope.TotalIssued) % 1 == 0) {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = $scope.TotalIssued;
                        }
                    }
                    else {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = parseFloat($scope.TotalIssued).toFixed(1);
                        }
                    }
                }
            });

            var response = $http({
                url: $rootScope.WebURL + "/stockreturnhistory/getReturnHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (ReturnHistorydata) {
                $scope.ReturnHistorydatas = ReturnHistorydata.data.data;

                var gTotalReturned = 0.00;
                angular.forEach($scope.ReturnHistorydatas, function (Gvalue) {
                    if (Gvalue.ReturnedQuantity != "" && Gvalue.ReturnedQuantity != null && Gvalue.ReturnedQuantity != undefined) {
                        gTotalReturned += parseFloat(Gvalue.ReturnedQuantity);
                    }
                });
                $scope.TotalReturned = gTotalReturned;

                if ($scope.TotalReturned != null && $scope.TotalReturned != undefined && $scope.TotalReturned != "") {
                    if (parseFloat($scope.TotalReturned) % 1 == 0) {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = $scope.TotalReturned;
                        }
                    }
                    else {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = parseFloat($scope.TotalReturned).toFixed(1);
                        }
                    }
                }
                $mdDialog.show({
                    templateUrl: 'app/main/apps/procurement/stock/stocklist/stockhistory.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function StockListController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            });


        }

        $scope.model = {};
        $scope.PurchaseHistoryDetails = function () {

            var response = $http({
                url: $rootScope.WebURL + "/goods/getPurchaseHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreName: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (PurchaseHistorydata) {

                $scope.PurchaseHistorydatas = PurchaseHistorydata.data.data;

                var gTotalPurchased = 0.00;
                angular.forEach($scope.PurchaseHistorydatas, function (Gvalue) {
                    if (Gvalue.ReceivedQuantity != "" && Gvalue.ReceivedQuantity != null && Gvalue.ReceivedQuantity != undefined) {
                        gTotalPurchased += parseFloat(Gvalue.ReceivedQuantity);
                    }
                });
                $scope.TotalPurchased = gTotalPurchased;

                if ($scope.TotalPurchased != null && $scope.TotalPurchased != undefined && $scope.TotalPurchased != "") {
                    if (parseFloat($scope.TotalPurchased) % 1 == 0) {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = $scope.TotalPurchased;
                        }
                    }
                    else {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = parseFloat($scope.TotalPurchased).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.DateFilterPurchaseHistoryDetails = function () {

            $scope.model.uFromDate.setHours(0, 0, 0, 0);
            $scope.model.uToDate.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/goods/getPurchaseHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.model.uFromDate, End_Date: $scope.model.uToDate, StoreName: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (PurchaseHistorydata) {

                $scope.PurchaseHistorydatas = PurchaseHistorydata.data.data;

                var gTotalPurchased = 0.00;
                angular.forEach($scope.PurchaseHistorydatas, function (Gvalue) {
                    if (Gvalue.ReceivedQuantity != "" && Gvalue.ReceivedQuantity != null && Gvalue.ReceivedQuantity != undefined) {
                        gTotalPurchased += parseFloat(Gvalue.ReceivedQuantity);
                    }
                });
                $scope.TotalPurchased = gTotalPurchased;

                if ($scope.TotalPurchased != null && $scope.TotalPurchased != undefined && $scope.TotalPurchased != "") {
                    if (parseFloat($scope.TotalPurchased) % 1 == 0) {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = $scope.TotalPurchased;
                        }
                    }
                    else {
                        if ($scope.TotalPurchased < 0) {
                            $scope.TotalPurchased = 0;
                        } else {
                            $scope.TotalPurchased = parseFloat($scope.TotalPurchased).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.IssuanceHistoryDetails = function () {

            var response = $http({
                url: $rootScope.WebURL + "/stockissuance/getIssuanceHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (IssuanceHistorydata) {

                $scope.IssuanceHistorydatas = IssuanceHistorydata.data.data;

                var gTotalIssued = 0.00;
                angular.forEach($scope.IssuanceHistorydatas, function (Gvalue) {
                    if (Gvalue.Quantity != "" && Gvalue.Quantity != null && Gvalue.Quantity != undefined) {
                        gTotalIssued += parseFloat(Gvalue.Quantity);
                    }
                });
                $scope.TotalIssued = gTotalIssued;

                if ($scope.TotalIssued != null && $scope.TotalIssued != undefined && $scope.TotalIssued != "") {
                    if (parseFloat($scope.TotalIssued) % 1 == 0) {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = $scope.TotalIssued;
                        }
                    }
                    else {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = parseFloat($scope.TotalIssued).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.DateFilterIssuanceHistoryDetails = function () {

            $scope.model.uFromDate.setHours(0, 0, 0, 0);
            $scope.model.uToDate.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockissuance/getIssuanceHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.model.uFromDate, End_Date: $scope.model.uToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (IssuanceHistorydata) {

                $scope.IssuanceHistorydatas = IssuanceHistorydata.data.data;

                var gTotalIssued = 0.00;
                angular.forEach($scope.IssuanceHistorydatas, function (Gvalue) {
                    if (Gvalue.Quantity != "" && Gvalue.Quantity != null && Gvalue.Quantity != undefined) {
                        gTotalIssued += parseFloat(Gvalue.Quantity);
                    }
                });
                $scope.TotalIssued = gTotalIssued;

                if ($scope.TotalIssued != null && $scope.TotalIssued != undefined && $scope.TotalIssued != "") {
                    if (parseFloat($scope.TotalIssued) % 1 == 0) {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = $scope.TotalIssued;
                        }
                    }
                    else {
                        if ($scope.TotalIssued < 0) {
                            $scope.TotalIssued = 0;
                        } else {
                            $scope.TotalIssued = parseFloat($scope.TotalIssued).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.ReturnHistoryDetails = function () {

            var response = $http({
                url: $rootScope.WebURL + "/stockreturnhistory/getReturnHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.FromDate, End_Date: $scope.ToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (ReturnHistorydata) {

                $scope.ReturnHistorydatas = ReturnHistorydata.data.data;

                var gTotalReturned = 0.00;
                angular.forEach($scope.ReturnHistorydatas, function (Gvalue) {
                    if (Gvalue.ReturnedQuantity != "" && Gvalue.ReturnedQuantity != null && Gvalue.ReturnedQuantity != undefined) {
                        gTotalReturned += parseFloat(Gvalue.ReturnedQuantity);
                    }
                });
                $scope.TotalReturned = gTotalReturned;

                if ($scope.TotalReturned != null && $scope.TotalReturned != undefined && $scope.TotalReturned != "") {
                    if (parseFloat($scope.TotalReturned) % 1 == 0) {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = $scope.TotalReturned;
                        }
                    }
                    else {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = parseFloat($scope.TotalReturned).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.DateFilterReturnHistoryDetails = function () {

            $scope.model.uFromDate.setHours(0, 0, 0, 0);
            $scope.model.uToDate.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockreturnhistory/getReturnHistory",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.model.uFromDate, End_Date: $scope.model.uToDate, StoreID: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode },
            });
            response.then(function (ReturnHistorydata) {

                $scope.ReturnHistorydatas = ReturnHistorydata.data.data;

                var gTotalReturned = 0.00;
                angular.forEach($scope.ReturnHistorydatas, function (Gvalue) {
                    if (Gvalue.ReturnedQuantity != "" && Gvalue.ReturnedQuantity != null && Gvalue.ReturnedQuantity != undefined) {
                        gTotalReturned += parseFloat(Gvalue.ReturnedQuantity);
                    }
                });
                $scope.TotalReturned = gTotalReturned;

                if ($scope.TotalReturned != null && $scope.TotalReturned != undefined && $scope.TotalReturned != "") {
                    if (parseFloat($scope.TotalReturned) % 1 == 0) {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = $scope.TotalReturned;
                        }
                    }
                    else {
                        if ($scope.TotalReturned < 0) {
                            $scope.TotalReturned = 0;
                        } else {
                            $scope.TotalReturned = parseFloat($scope.TotalReturned).toFixed(1);
                        }
                    }
                }
            });
        }

        $scope.ReOrderedQuantityPopup = function (e, GoodsId, $index) {

            $scope.IndxID = $index;
            $scope.GoodsId = GoodsId;
            $scope.vm.ReorderQuantity = 0;

            try {
                var item = $scope.Goodsuniquedatas.filter(function (item) {
                    return item._id === GoodsId;
                })[0];
                $scope.GId = item._id;
                $scope.vm.ReorderQuantity = parseFloat(item.ReorderQuantity);
                if ($scope.vm.ReorderQuantity < 0 || $scope.vm.ReorderQuantity == "" || $scope.vm.ReorderQuantity == null || $scope.vm.ReorderQuantity == undefined || $scope.vm.ReorderQuantity == NaN) {
                    $scope.vm.ReorderQuantity = 0;
                }
                $scope.vm.Unit = item.Unit;
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/stocklist/reorder.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function StockListController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        $scope.ReorderSubmit = function () {
            $scope.IndexID = $scope.IndxID;
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/goodsunique/updateReorderQuantity",
                data: {
                    _id: $scope.GoodsId,
                    ReorderQuantity: $scope.vm.ReorderQuantity,
                    UpdatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                $scope.Goodsuniquedatas[$scope.IndexID] = GList.data.data[0];
                $mdDialog.cancel();
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.ManualaddPopup = function (e) {
            $scope.vm.mStore = $scope.Storedatas[0].StoreName;
            $scope.vm.mProductCategory = "";
            $scope.vm.mProductCode = "";
            $scope.vm.mProductName = "";
            $scope.vm.mQuantity = "";
            $scope.vm.mUnit = "";
            $scope.vm.mDescription = "";
            $scope.vm.mModel = "";
            $scope.vm.mSerialNumber = "";
            $scope.ShowAlert = false;

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/stocklist/manualadd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function StockListController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.getQuantity = function () {

            if ($scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != undefined) {
                $scope.CheckSerialNumber = $scope.vm.mSerialNumber;
                var rqnarray = $scope.CheckSerialNumber.split(",");
                var rqnarray1 = [];
                angular.forEach(rqnarray, function (svalue) {
                    rqnarray1.push(svalue);
                });
                $scope.getSerialNumber = rqnarray1;
                $scope.vm.mQuantity = $scope.getSerialNumber.length;
            }
            else if ($scope.vm.mSerialNumber == "" || $scope.vm.mSerialNumber == null || $scope.vm.mSerialNumber == undefined) {
                $scope.vm.mQuantity = "";
                $scope.ShowAlert = false;
            }
        }

        $scope.ProductNamedetails = function () {
            var response = $http({
                url: $rootScope.WebURL + "/product/getByCategory",
                method: "POST",
                data: { RequestID: $scope.vm.mProductCategory },
            });
            response.then(function (Categorydata) {

                $scope.Categorydatas = Categorydata.data.data;
            });
        }

        $scope.ProductCodedetails = function () {

            try {
                var item = $scope.Categorydatas.filter(function (item) {
                    return $scope.vm.mProductName == item.ProductName && $scope.vm.mProductCategory == item.Category;
                })[0];

                $scope.vm.mProductCode = item.ProductCode;
                $scope.vm.mDescription = item.Description;
                $scope.vm.mUnit = item.Unit;
                $scope.vm.mModel = item.Model;
            } catch (err) { }
        }

        $scope.ProductNameClear = function () {
            $scope.vm.mProductName = '';
            $scope.vm.mProductCode = '';
            $scope.vm.mDescription = '';
            $scope.vm.mUnit = ''; '';
            $scope.vm.mModel = '';
        }

        $scope.ManualSubmit = function () {

            $scope.ShowAlert = false;
            angular.forEach($scope.Goodsuniquedatas, function (value) {
                if ($scope.vm.mStore == value.StoreName && $scope.vm.mProductCategory == value.ProductCategory && $scope.vm.mProductCode == value.ProductCode) {
                    $scope.MId = value._id;
                    $scope.Store = value.StoreName;
                    $scope.ProductCategory = value.ProductCategory;
                    $scope.ProductCode = value.ProductCode;
                    $scope.ProductName = value.ProductName;
                    $scope.Description = value.Description;
                    $scope.TotalQuantity = parseFloat(value.TotalQuantity);
                    $scope.Unit = value.Unit;
                    $scope.Model = value.Model;
                    $scope.SerialNumber = value.SerialNumber;
                    $scope.ReorderQuantity = parseFloat(value.ReorderQuantity);
                    $scope.OnHold = parseFloat(value.OnHold);

                    $scope.Update = true;
                }
            });

            if ($scope.vm.mSerialNumber == "" || $scope.vm.mSerialNumber == null || $scope.vm.mSerialNumber == undefined) {

                $scope.Lighttrapdataqty = parseFloat($scope.vm.mQuantity);
                if ($scope.Update == true) {
                    $scope.TotQ = parseFloat($scope.vm.mQuantity) + parseFloat($scope.TotalQuantity);
                    if ($scope.TotQ < 0 || $scope.TotQ == "" || $scope.TotQ == null || $scope.TotQ == undefined || $scope.TotQ == NaN) {
                        $scope.TotQ = 0;
                    }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/goodsunique/updateQuantity",
                        data: {
                            _id: $scope.MId,
                            TotalQuantity: $scope.TotQ,
                            UpdatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/goods/add",
                            data: {
                                Client_Id: Client_Id,
                                ReferenceNo: "Manual",
                                UniqueID: $scope.UniqueID,
                                DONumber: "",
                                ReceivedDate: new Date(),
                                StoreName: $scope.vm.mStore,
                                ProductCategory: $scope.vm.mProductCategory,
                                ProductCode: $scope.vm.mProductCode,
                                ProductName: $scope.vm.mProductName,
                                Description: $scope.vm.mDescription,
                                ReceivedQuantity: $scope.vm.mQuantity,
                                Unit: $scope.vm.mUnit,
                                Model: $scope.vm.mModel,
                                SerialNumber: $scope.SerialNumber,
                                OrderedQuantity: "",
                                ReturnedQuantity: "0",
                                Status: "",
                                CreatedBy: $rootScope.LoginID,
                            },
                        });

                        if ($scope.vm.mProductCategory.toLowerCase() == "sensor" || $scope.vm.mProductCategory.toLowerCase() == "sensors" || $scope.vm.mProductCategory.toLowerCase() == "router" || $scope.vm.mProductCategory.toLowerCase() == "routers" || $scope.vm.mProductCategory.toLowerCase() == "ratsense" || $scope.vm.mProductCategory.toLowerCase() == "gateway" || $scope.vm.mProductCategory.toLowerCase() == "gateways" || $scope.vm.mProductCategory.toLowerCase() == "external sensor" || $scope.vm.mProductCategory.toLowerCase() == "external sensors") {
                            $scope.Lighttrapdata = $scope.Lighttrapdataqty;
                            $scope.saveLighttrapdatas();
                        }

                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        RefreshManualGrid();
                        RefreshTransactionDetailGrid();
                        $mdDialog.cancel();

                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
                else {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/goodsunique/add",
                        data: {
                            Client_Id: Client_Id,
                            StoreName: $scope.vm.mStore,
                            ProductCategory: $scope.vm.mProductCategory,
                            ProductCode: $scope.vm.mProductCode,
                            ProductName: $scope.vm.mProductName,
                            Description: $scope.vm.mDescription,
                            TotalQuantity: $scope.vm.mQuantity,
                            Unit: $scope.vm.mUnit,
                            Model: $scope.vm.mModel,
                            SerialNumber: $scope.vm.mSerialNumber,
                            ReorderQuantity: "0",
                            OnHold: "0",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {


                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/goods/add",
                            data: {
                                Client_Id: Client_Id,
                                ReferenceNo: "Manual",
                                UniqueID: $scope.UniqueID,
                                DONumber: "",
                                ReceivedDate: new Date(),
                                StoreName: $scope.vm.mStore,
                                ProductCategory: $scope.vm.mProductCategory,
                                ProductCode: $scope.vm.mProductCode,
                                ProductName: $scope.vm.mProductName,
                                Description: $scope.vm.mDescription,
                                ReceivedQuantity: $scope.vm.mQuantity,
                                Unit: $scope.vm.mUnit,
                                Model: $scope.vm.mModel,
                                SerialNumber: $scope.vm.mSerialNumber,
                                OrderedQuantity: "",
                                ReturnedQuantity: "0",
                                Status: "",
                                CreatedBy: $rootScope.LoginID,
                            },
                        });

                        if ($scope.vm.mProductCategory.toLowerCase() == "sensor" || $scope.vm.mProductCategory.toLowerCase() == "sensors" || $scope.vm.mProductCategory.toLowerCase() == "router" || $scope.vm.mProductCategory.toLowerCase() == "routers" || $scope.vm.mProductCategory.toLowerCase() == "ratsense" || $scope.vm.mProductCategory.toLowerCase() == "gateway" || $scope.vm.mProductCategory.toLowerCase() == "gateways" || $scope.vm.mProductCategory.toLowerCase() == "external sensor" || $scope.vm.mProductCategory.toLowerCase() == "external sensors") {
                            $scope.Lighttrapdata = $scope.Lighttrapdataqty;
                            $scope.saveLighttrapdatas();
                        }

                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshManualGrid();
                        RefreshTransactionDetailGrid();
                        $mdDialog.cancel();

                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                    });
                }
            }
            else if ($scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != undefined) {

                $scope.TSerialNo = $scope.vm.mSerialNumber;
                if ($scope.TSerialNo != null && $scope.TSerialNo != "" && $scope.TSerialNo != undefined) {
                    var snarray = $scope.TSerialNo.split(",");
                    var snarray1 = [];
                    angular.forEach(snarray, function (value) {
                        snarray1.push({ SerialNo: value });
                    });
                    $scope.SerialNoArray = snarray1;
                }
                $scope.CheckSNo = $scope.SerialNoArray.length;
                $scope.CLength = parseFloat($scope.vm.mQuantity);
                if ($scope.CLength > $scope.CheckSNo) {
                    $mdToast.show($mdToast.simple().textContent('Enter Serial Number for all the receiving quantities!!').position('top center'));
                    return
                }
                if ($scope.CLength < $scope.CheckSNo) {
                    $mdToast.show($mdToast.simple().textContent('Entered Serial Number for all the receiving quantities is High!!').position('top center'));
                    return
                }
                $scope.Lighttrapdataqty = $scope.SerialNoArray.length;


                var array = $scope.vm.mSerialNumber.split(",").map(function (item) {
                    return item.trim();
                });

                var response = $http({
                    url: $rootScope.WebURL + "/goods/getBySerialNumber",
                    method: "POST",
                    data: { SerialNumber: array, ProductCode: $scope.vm.mProductCode },
                });
                response.then(function (ExistingSerialNodata) {

                    $scope.ExistingSerialNodataList = ExistingSerialNodata.data.data;

                    if ($scope.ExistingSerialNodataList.length > 0) {

                        $scope.ExistingSerialNoList = $scope.ExistingSerialNodataList.map(function (obj) { return obj.SerialNumber; }).join(',');
                        $scope.ShowAlert = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Serial Number(s)!!').position('top center'));
                        return
                    }
                    else {

                        if ($scope.Update == true) {
                            $scope.TotQ = parseFloat($scope.vm.mQuantity) + parseFloat($scope.TotalQuantity);
                            if ($scope.TotQ < 0 || $scope.TotQ == "" || $scope.TotQ == null || $scope.TotQ == undefined || $scope.TotQ == NaN) {
                                $scope.TotQ = 0;
                            }
                            var response = $http({
                                method: "PUT",
                                url: $rootScope.WebURL + "/goodsunique/updateQuantity",
                                data: {
                                    _id: $scope.MId,
                                    TotalQuantity: $scope.TotQ,
                                    UpdatedBy: $rootScope.LoginID,
                                },
                            });
                            response.then(function (GList) {


                                var SerialNoinfo = $scope.SerialNoArray;
                                for (var i = 0; i < SerialNoinfo.length; i++) {

                                    var response = $http({
                                        method: "POST",
                                        url: $rootScope.WebURL + "/goods/add",
                                        data: {
                                            Client_Id: Client_Id,
                                            ReferenceNo: "Manual",
                                            UniqueID: $scope.UniqueID,
                                            DONumber: "",
                                            ReceivedDate: new Date(),
                                            StoreName: $scope.vm.mStore,
                                            ProductCategory: $scope.vm.mProductCategory,
                                            ProductCode: $scope.vm.mProductCode,
                                            ProductName: $scope.vm.mProductName,
                                            Description: $scope.vm.mDescription,
                                            ReceivedQuantity: "1",
                                            Unit: $scope.vm.mUnit,
                                            Model: $scope.vm.mModel,
                                            SerialNumber: SerialNoinfo[i].SerialNo,
                                            OrderedQuantity: "",
                                            ReturnedQuantity: "0",
                                            Status: "New",
                                            CreatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }

                                if ($scope.vm.mProductCategory.toLowerCase() == "sensor" || $scope.vm.mProductCategory.toLowerCase() == "sensors" || $scope.vm.mProductCategory.toLowerCase() == "router" || $scope.vm.mProductCategory.toLowerCase() == "routers" || $scope.vm.mProductCategory.toLowerCase() == "ratsense" || $scope.vm.mProductCategory.toLowerCase() == "gateway" || $scope.vm.mProductCategory.toLowerCase() == "gateways" || $scope.vm.mProductCategory.toLowerCase() == "external sensor" || $scope.vm.mProductCategory.toLowerCase() == "external sensors") {
                                    $scope.Lighttrapdata = $scope.Lighttrapdataqty;
                                    $scope.saveLighttrapdatas();
                                }
                                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                                RefreshManualGrid();
                                RefreshTransactionDetailGrid();
                                $mdDialog.cancel();

                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                        else {

                            $scope.TotQ = parseFloat($scope.vm.mQuantity) + parseFloat($scope.TotalQuantity);
                            if ($scope.TotQ < 0 || $scope.TotQ == "" || $scope.TotQ == null || $scope.TotQ == undefined || $scope.TotQ == NaN) {
                                $scope.TotQ = 0;
                            }
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/goodsunique/add",
                                data: {
                                    Client_Id: Client_Id,
                                    StoreName: $scope.vm.mStore,
                                    ProductCategory: $scope.vm.mProductCategory,
                                    ProductCode: $scope.vm.mProductCode,
                                    ProductName: $scope.vm.mProductName,
                                    Description: $scope.vm.mDescription,
                                    TotalQuantity: $scope.vm.mQuantity,
                                    Unit: $scope.vm.mUnit,
                                    Model: $scope.vm.mModel,
                                    SerialNumber: $scope.vm.mSerialNumber,
                                    ReorderQuantity: "0",
                                    OnHold: "0",
                                    CreatedBy: $rootScope.LoginID,
                                },
                            });
                            response.then(function (GList) {


                                var SerialNoinfo = $scope.SerialNoArray;
                                for (var i = 0; i < SerialNoinfo.length; i++) {

                                    var response = $http({
                                        method: "POST",
                                        url: $rootScope.WebURL + "/goods/add",
                                        data: {
                                            Client_Id: Client_Id,
                                            ReferenceNo: "Manual",
                                            UniqueID: $scope.UniqueID,
                                            DONumber: "",
                                            ReceivedDate: new Date(),
                                            StoreName: $scope.vm.mStore,
                                            ProductCategory: $scope.vm.mProductCategory,
                                            ProductCode: $scope.vm.mProductCode,
                                            ProductName: $scope.vm.mProductName,
                                            Description: $scope.vm.mDescription,
                                            ReceivedQuantity: "1",
                                            Unit: $scope.vm.mUnit,
                                            Model: $scope.vm.mModel,
                                            SerialNumber: SerialNoinfo[i].SerialNo,
                                            OrderedQuantity: "",
                                            ReturnedQuantity: "0",
                                            Status: "New",
                                            CreatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }

                                if ($scope.vm.mProductCategory.toLowerCase() == "sensor" || $scope.vm.mProductCategory.toLowerCase() == "sensors" || $scope.vm.mProductCategory.toLowerCase() == "router" || $scope.vm.mProductCategory.toLowerCase() == "routers" || $scope.vm.mProductCategory.toLowerCase() == "ratsense" || $scope.vm.mProductCategory.toLowerCase() == "gateway" || $scope.vm.mProductCategory.toLowerCase() == "gateways" || $scope.vm.mProductCategory.toLowerCase() == "external sensor" || $scope.vm.mProductCategory.toLowerCase() == "external sensors") {
                                    $scope.Lighttrapdata = $scope.Lighttrapdataqty;
                                    $scope.saveLighttrapdatas();
                                }
                                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                                RefreshManualGrid();
                                RefreshTransactionDetailGrid();
                                $mdDialog.cancel();

                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                    }

                });
            }
        }

        $scope.saveLighttrapdatas = function () {

            if ($scope.SerialNoArray != "" && $scope.SerialNoArray != null && $scope.SerialNoArray != undefined) {
                var SerialNoinfo = $scope.SerialNoArray;
                for (var i = 0; i < SerialNoinfo.length; i++) {


                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/lighttrap/add",
                        data: {
                            Client_Id: Client_Id,
                            StoreName: $scope.vm.mStore,
                            ProductCategory: $scope.vm.mProductCategory,
                            ProductCode: $scope.vm.mProductCode,
                            ProductName: $scope.vm.mProductName,
                            Description: $scope.vm.mDescription,
                            Model: $scope.vm.mModel,
                            Unit: $scope.vm.mUnit,
                            SerialNumber: SerialNoinfo[i].SerialNo,
                            Customer: null,
                            Location: "",
                            Status: "New",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                }
            }
            else if ($scope.SerialNoArray == "" || $scope.SerialNoArray == null || $scope.SerialNoArray == undefined) {
                for (var i = 0; i < $scope.Lighttrapdata; i++) {

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/lighttrap/add",
                        data: {
                            Client_Id: Client_Id,
                            StoreName: $scope.vm.mStore,
                            ProductCategory: $scope.vm.mProductCategory,
                            ProductCode: $scope.vm.mProductCode,
                            ProductName: $scope.vm.mProductName,
                            Description: $scope.vm.mDescription,
                            Model: $scope.vm.mModel,
                            Unit: $scope.vm.mUnit,
                            SerialNumber: $scope.vm.mSerialNumber,
                            Customer: null,
                            Location: "",
                            Status: "New",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                }
            }

        }

        $scope.StoreFilter = function () {

            try {
                $scope.Store = $scope.Store;

                $scope.Goodsuniquedatas = $scope.AllGoodsuniquedatas.filter(function (item) {
                    return item.StoreName === $scope.Store;
                });
            } catch (e) { }
        }

        $scope.GoPO = function (POId) {

            try {
                var item1 = $scope.PurchaseHistorydatas.filter(function (item1) {
                    return item1._id === POId;
                })[0];
                $scope.POrderID = item1.ReferenceNo;
            } catch (err) { }

            try {
                var item = $scope.Purchaseorderdatas.filter(function (item) {
                    return item.ReferenceNo === $scope.POrderID;
                })[0];
                $scope.VPOId = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
            } catch (err) { }

            $window.localStorage.setItem('IDforViewPO', $scope.VPOId);
            $state.go('app.purchaseorder');

        }

        function RefreshGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
                $scope.Store = $scope.Storedatas[0].StoreName;

                var gresponse = $http({
                    url: $rootScope.WebURL + "/goodsunique/StockList",
                    method: "POST",
                    data: { Client_Id: Client_Id },
                });
                gresponse.then(function (Goodsuniquedata) {

                    $scope.AllGoodsuniquedatas = Goodsuniquedata.data.data;

                    try {

                        $scope.Goodsuniquedatas = $scope.AllGoodsuniquedatas.filter(function (item) {
                            return item.StoreName === $scope.Store;
                        });
                    } catch (e) { }
                });
            });
        }

        function RefreshManualGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique/StockList",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {

                $scope.AllGoodsuniquedatas = Goodsuniquedata.data.data;
                //$scope.Store = $scope.Storedatas[0].StoreName;
                try {

                    $scope.Goodsuniquedatas = $scope.AllGoodsuniquedatas.filter(function (item) {
                        return item.StoreName === $scope.Store;
                    });
                } catch (e) { }

                RefreshTransactionDetailGrid();
            });
        }

        function RefreshTransactionDetailGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshCategory() {
            var response = $http({
                url: $rootScope.WebURL + "/category",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Categorydata) {
                $scope.ProductCategorydatas = Categorydata.data.data;
            });
        }

        function RefreshUnit() {
            var response = $http({
                url: $rootScope.WebURL + "/unit",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Unitdata) {
                $scope.Unitdatas = Unitdata.data.data;
            });
        }

        function RefreshPurchaseorderproductGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorderproduct/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Purchaseorderproductdata) {

                $scope.vm.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
            });
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Goodsdata) {
                $scope.vm.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.vm.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.vm.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.vm.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshPurchaseformGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Purchaseformdata) {
                $scope.Purchaseformdatas = Purchaseformdata.data.data;
            });

        }

        function RefreshStoreGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
                $scope.Store = $scope.Storedatas[0].StoreName;
            });
        }

        function RefreshSupplierGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        function RefreshPOGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Purchaseorderdata) {
                $scope.Purchaseorderdatas = Purchaseorderdata.data.data;
            });
        }

        function RefreshPurchaseGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchase",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Purchasedata) {
                $scope.Purchasedatas = Purchasedata.data.data;
            });
        }

        function RefreshStockissuancedetailsGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuance",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Stockissuancedata) {
                $scope.Stockissuancedatas = Stockissuancedata.data.data;
            });
        }

        function RefreshStockissuanceformGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuanceform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
            });
        }

        function RefreshStockreturnGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturn",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Stockreturndata) {
                $scope.Stockreturndatas = Stockreturndata.data.data;
            });
        }

        function RefreshStockreturnhistoryGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturnhistory",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Stockreturnhistorydata) {
                $scope.Stockreturnhistorydatas = Stockreturnhistorydata.data.data;
            });
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#Stocksearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            "lengthMenu": [[-1, 10, 25, 50, 100], ["All", 10, 25, 50, 100]],
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }

})();
(function () {
    'use strict';

    angular

        .module('app.procurement.stock.return', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_return', {
            url: '/StockReturn',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/return/return.html',
                    controller: 'ReturnController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.return')
        .controller('ReturnController', ReturnController);

    /** @ngInject */
    function ReturnController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $http, $log) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.RatsanseStartDate = new Date();
        $scope.RatsanseEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);

        RefreshStockreturnGrid();
        RefreshUniqueGoodsGrid();
        RefreshGoodsGrid();
        RefreshStockIssuanceGrid();
        RefreshStockRequestGrid();

        function RefreshStockreturnGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockreturn/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Stockreturndata) {
                debugger
                $scope.AllStockreturndatas = Stockreturndata.data.data;
                try {
                    $scope.Stockreturndatas = $scope.AllStockreturndatas.filter(function (item) {
                        return parseFloat(item.ReceivedQuantity) > parseFloat(item.ReturnedQuantity);
                    });
                } catch (e) { }
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockreturn/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Stockreturndata) {
                $scope.AllStockreturndatas = Stockreturndata.data.data;
                try {
                    $scope.Stockreturndatas = $scope.AllStockreturndatas.filter(function (item) {
                        return parseFloat(item.ReceivedQuantity) > parseFloat(item.ReturnedQuantity);
                    });
                } catch (e) { }
            });
        }

        //$scope.LocationAdd = function () {
        //    $scope.ReferenceListArray = [];
        //    $scope.StockListArray = [];
        //    angular.forEach($scope.AllStockreturndatas, function (value) {
        //        angular.forEach($scope.Stockissuanceformdatas, function (value1) {
        //            if (value.ReferenceNo == value1.ReferenceNo) {
        //                angular.forEach($scope.StockRequestdatas, function (value2) {
        //                    if (value1.StockReferenceNo == value2.ReferenceNo) {
        //                        $scope.ReferenceListArray.push({
        //                            ID: value._id,
        //                            ReferenceNo: value.ReferenceNo,
        //                            Customer: value2.CustomerID,
        //                            Location: value2.Location,
        //                        })
        //                    }
        //                });
        //            }
        //        });
        //    });
        //    $scope.StockListArray = $scope.ReferenceListArray;
        //    angular.forEach($scope.StockListArray, function (value) {
        //        if (value.ID != "") {
        //            var response = $http({
        //                method: "PUT",
        //                url:  $rootScope.WebURL + "/stockreturn/updateLocation",
        //                data: {
        //                    _id: value.ID,
        //                    CustomerID: value.Customer,
        //                    Location: value.Location,
        //                },
        //            });
        //        }
        //    });
        //};
        //StockReturnHistoryGrid();
        //function StockReturnHistoryGrid() {
        //    var response = $http({
        //        method: "POST",
        //        url:  $rootScope.WebURL + "/stockreturnhistory",
        //        data: { Client_Id: Client_Id },
        //    });
        //    response.then(function (StockReturnHistorydata) {
        //        $scope.StockReturnHistorydatas = StockReturnHistorydata.data.data;
        //    });
        //}
        //$scope.LocationAddforHistory = function () {
        //    angular.forEach($scope.AllStockreturndatas, function (value) {
        //        angular.forEach($scope.StockReturnHistorydatas, function (value1) {
        //            if (value.ReferenceNo == value1.ReferenceNo) {
        //                var response = $http({
        //                    method: "PUT",
        //                    url:  $rootScope.WebURL + "/stockreturnhistory/updateLocation",
        //                    data: {
        //                        _id: value1._id,
        //                        CustomerID: value.Customer,
        //                        Location: value.Location,
        //                    },
        //                });
        //            }
        //        });
        //    });
        //};

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("StockReturnLists.xlsx",{headers:true}) FROM ?', [$scope.Stockreturndatas]);
        };

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
        }

        $scope.ViewStockReturnHistory = function (e, SHid) {
            $scope.StockReturnHistoryId = SHid;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturnhistory/getByHistoryID",
                data: { Client_Id: Client_Id, HistoryId: SHid },
            });
            response.then(function (StockReturnHistorydata) {

                $scope.StockReturnHistorysummary = StockReturnHistorydata.data.data;

                $mdDialog.show({
                    templateUrl: 'app/main/apps/procurement/stock/return/returnquantityhistory.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function ReturnController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            });
        }

        $scope.ReturnQuantityPopup = function (e, ReturnID, $index) {

            $scope.RID = ReturnID;
            $scope.IndxID = $index;
            $scope.SerialNoArray = "";
            $scope.vm.SerialNumber = "";
            $scope.SerialNumber = "";
            $scope.vm.select = false;
            $scope.Alert = false;
            try {
                var item = $scope.Stockreturndatas.filter(function (item) {
                    return item._id === ReturnID;
                })[0];
                $scope.id = item._id;
                $scope.ReceivedQuantity = parseFloat(item.ReceivedQuantity);
                $scope.ReturnedQuantity = parseFloat(item.ReturnedQuantity);
            } catch (err) { }

            if ($scope.ReceivedQuantity == $scope.ReturnedQuantity) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.ReturnID = ReturnID;
                try {
                    $scope.id = item._id;
                    $scope.SRID = item._id;
                    $scope.ReceiverName = item.ReceiverName;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.StoreID = item.StoreID;
                    $scope.ProductCategory = item.ProductCategory;
                    $scope.ProductCode = item.ProductCode;
                    $scope.ProductName = item.ProductName;
                    $scope.Description = item.Description;
                    $scope.Model = item.Model;
                    $scope.SerialNumber = item.SerialNumber;
                    $scope.ReceivedQuantity = parseFloat(item.ReceivedQuantity);
                    $scope.ReturnedQuantity = parseFloat(item.ReturnedQuantity);
                    $scope.Unit = item.Unit;
                    $scope.Location = item.Location;
                    $scope.Customer = item.CustomerID;
                    if (item.ReturnDate != null) {
                        $scope.ReturnDate = new Date(item.ReturnDate);
                    }
                    else {
                        $scope.ReturnDate = null;
                    }

                    $scope.vm.ReturnQuantity = "";
                    $scope.vm.ReturnQuantityDate = new Date();
                    $scope.vm.SerialNumber = '';

                    if ($scope.SerialNumber != "" && $scope.SerialNumber != null && $scope.SerialNumber != undefined) {
                        $scope.SerialNoArray = $scope.SerialNumber.split(",");
                        $scope.vm.select = false;
                    }

                    $mdDialog.show({
                        templateUrl: 'app/main/apps/procurement/stock/return/returnquantity.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        scope: $scope.$new(),
                        clickOutsideToClose: true,
                        controller: function ReturnController($scope, $mdDialog) {
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            }
                        }
                    });

                } catch (err) { }
            }
        }

        $scope.getQuantitydetails = function () {

            if ($scope.vm.SerialNumber != undefined) {
                $scope.vm.ReturnQuantity = $scope.vm.SerialNumber.length;
            }
            else if ($scope.vm.SerialNumber == undefined) {
                $scope.vm.ReturnQuantity = "";
                $scope.vm.select = false;
            }
        }

        $scope.selectAll = function () {

            $scope.CheckSelect = $scope.vm.select;
            if ($scope.CheckSelect == true) {
                $scope.SelectSerialNumber = [];
                angular.forEach($scope.SerialNoArray, function (obj) {

                    $scope.SelectSerialNumber.push({
                        AllSerialNo: obj,
                    })
                })

                if ($scope.SelectSerialNumber != null && $scope.SelectSerialNumber != "" && $scope.SelectSerialNumber != undefined) {
                    $scope.AllSerialNumber = $scope.SelectSerialNumber.map(function (obj) { return obj.AllSerialNo }).join(',');
                }

                $scope.vm.SerialNumber = $scope.AllSerialNumber.split(",");
                $scope.vm.ReturnQuantity = $scope.vm.SerialNumber.length;
            }
            else if ($scope.CheckSelect == false) {
                $scope.vm.SerialNumber = "";
                $scope.vm.ReturnQuantity = "";
            }
        };

        $scope.ReturnQuantityadd = function () {

            $scope.IndexID = $scope.IndxID;
            $scope.RQ = parseFloat($scope.ReturnedQuantity) + parseFloat($scope.vm.ReturnQuantity);

            if (parseFloat($scope.ReceivedQuantity) < $scope.RQ) {
                //RefreshStocksReturnGrid();
                $scope.vm.ReturnQuantity = '';
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Returned Quantity should not be grater than Received Quantity!!').position('top center'));
                return
            }

            if ($scope.vm.SerialNumber != "" && $scope.vm.SerialNumber != null && $scope.vm.SerialNumber != undefined) {

                var CheckSNoLength = $scope.vm.SerialNumber.length;
                $scope.RSerialNumber = $scope.vm.SerialNumber;
                var AlreadyIssuedSNo = [];
                angular.forEach($scope.RSerialNumber, function (value) {
                    angular.forEach($scope.Goodsdatas, function (Gvalue) {
                        if (value == Gvalue.SerialNumber && $scope.ProductCode == Gvalue.ProductCode && Gvalue.Status == "Issued") { }
                        else if (value == Gvalue.SerialNumber && $scope.ProductCode == Gvalue.ProductCode && Gvalue.Status == "New") {
                            AlreadyIssuedSNo.push({
                                SerialNumber: Gvalue.SerialNumber,
                            })
                        }
                    });
                });

                var SNoLength = AlreadyIssuedSNo.length;
                if (SNoLength > 0) {
                    $scope.AlreadyReturnedSNoProduct = AlreadyIssuedSNo.map(function (obj) { return obj.SerialNumber; }).join(',');
                    $scope.Alert = true;
                    return
                }
            }


            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/stockreturn/updateReturnQuantity",
                data: {
                    _id: $scope.id,
                    ReturnedQuantity: $scope.RQ,
                    UpdatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                angular.forEach($scope.Goodsuniquedatas, function (value2) {
                    if ($scope.StoreID == value2.StoreName && $scope.ProductCategory == value2.ProductCategory && $scope.ProductCode == value2.ProductCode) {
                        $scope.tqty = parseFloat(value2.TotalQuantity) + parseFloat($scope.vm.ReturnQuantity);
                        if ($scope.tqty < 0 || $scope.tqty == "" || $scope.tqty == null || $scope.tqty == undefined || $scope.tqty == NaN) {
                            $scope.tqty = 0;
                        }
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/goodsunique/updateQuantity",
                            data: {
                                _id: value2.id,
                                TotalQuantity: $scope.tqty,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                });

                if ($scope.vm.SerialNumber != "" && $scope.vm.SerialNumber != null && $scope.vm.SerialNumber != undefined) {
                    $scope.RSerialNumber = $scope.vm.SerialNumber;
                    //try {
                    //    var item = $scope.Stockissuanceformdatas.filter(function (item) {
                    //        return item.ReferenceNo === $scope.ReferenceNo;
                    //    })[0];
                    //    $scope.StockReferenceNo = item.StockReferenceNo;
                    //    var Sitem = $scope.StockRequestdatas.filter(function (Sitem) {
                    //        return Sitem.ReferenceNo === $scope.StockReferenceNo;
                    //    })[0];
                    //    $scope.Customer = Sitem.CustomerID;
                    //    $scope.Location = Sitem.Location;
                    //} catch (err) { }
                    angular.forEach($scope.RSerialNumber, function (value) {
                        angular.forEach($scope.Goodsdatas, function (Gvalue) {
                            if (value == Gvalue.SerialNumber && $scope.ProductCode == Gvalue.ProductCode) {

                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goods/updateIssue",
                                    data: {
                                        _id: Gvalue.id,
                                        Status: "New",
                                        Customer: $scope.Customer,
                                        Location: $scope.Location,
                                        StartDate: $scope.RatsanseStartDate,
                                        EndDate: $scope.RatsanseEndDate,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });
                }

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/stockreturnhistory/add",
                    data: {
                        Client_Id: Client_Id,
                        HistoryId: $scope.SRID,
                        ReceiverName: $scope.ReceiverName,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.Customer,
                        Location: $scope.Location,
                        ProductCategory: $scope.ProductCategory,
                        ProductCode: $scope.ProductCode,
                        ProductName: $scope.ProductName,
                        Description: $scope.Description,
                        Model: $scope.Model,
                        SerialNumber: $scope.vm.SerialNumber,
                        ReceivedQuantity: $scope.ReceivedQuantity,
                        ReturnedQuantity: $scope.vm.ReturnQuantity,
                        Unit: $scope.Unit,
                        ReturnDate: $scope.ReturnDate,
                        ReturnQuantityDate: $scope.vm.ReturnQuantityDate,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                $scope.Stockreturndatas[$scope.IndexID] = GList.data.data[0];
                RefreshStockreturnGrid();
                RefreshStocksReturnHistoryGrid();
                RefreshUniqueGoodsGrid();
                RefreshGoodsGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });

        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.ShowReturned = function (ShowReturned) {
            if (ShowReturned == true) {
                try {
                    $scope.Stockreturndatas = $scope.AllStockreturndatas.filter(function (item) {
                        return parseFloat(item.ReceivedQuantity) === parseFloat(item.ReturnedQuantity);
                    });
                } catch (e) { }
            }
            else {
                try {
                    $scope.Stockreturndatas = $scope.AllStockreturndatas.filter(function (item) {
                        return parseFloat(item.ReceivedQuantity) > parseFloat(item.ReturnedQuantity);
                    });
                } catch (e) { }
            }
        }

        function RefreshStocksReturnGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturn",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Stockreturndata) {
                $scope.Stockreturndatas = Stockreturndata.data.data;
                RefreshStocksReturnHistoryGrid();
            });
        }

        function RefreshStocksReturnHistoryGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturnhistory",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Stockreturnhistorysummarydata) {
                $scope.Stockreturnhistorysummarydatas = Stockreturnhistorysummarydata.data.data;
                RefreshUniqueGoodsGrid();
            });
        }

        function RefreshStockIssuanceGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuanceform",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
            });
        }

        function RefreshStockRequestGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/materialform",
                data: { Client_Id: Client_Id },
            });
            response.then(function (StockRequestdata) {
                $scope.StockRequestdatas = StockRequestdata.data.data;
            });
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshUniqueGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();
(function () {
    'use strict';

    angular
 
        .module('app.procurement.stock.issuance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_issuance', {
            url: '/StockIssuance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/issuance/issuance.html',
                    controller: 'IssuanceController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.issuance')
        .controller('IssuanceController', IssuanceController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function IssuanceController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });
        RefreshGrid();

        $scope.StockIssuancegrid = true;
        $scope.StockIssuanceform = false;
        $scope.siExport = true;
        $scope.siSearch = true;
        $scope.siView = false;


        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockissuanceform/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/stockissuanceform/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
            });
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Stockinfo = function (StockId, $index) {
            $scope.SID = StockId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Stockissuanceformdatas.filter(function (item) {
                    return item._id === StockId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.StockReferenceNo = item.StockReferenceNo;
                $scope.RequestedBy = item.RequestedBy;
                $scope.RequestedByEmployee = item.RequestedByEmployee;
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.RequestedDate = new Date(item.RequestedDate);
                $scope.IssuedDate = new Date(item.IssuedDate);

                $scope.Update = true;
                $scope.StockIssuanceform = true;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siSearch = false;
                $scope.siView = true;
                RefreshStocksGrid();
                RefreshCommentGrid();
                RefreshAttachmentGrid();
            } catch (err) { }

        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Inventory Stock Issuance",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file

            var response = Upload.upload({
                url: $rootScope.WebURL + "/stockissuanceform/upload",
                data: { file: upfile }
            }).then(function (resp) {

                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Stock Issuance",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        function RefreshStocksGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/stockissuance/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Stockissuancedata) {
                $scope.Stockissuancedatas = Stockissuancedata.data.data;
            });

        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("StockissuanceDetails.xlsx",{headers:true}) FROM ?', [$scope.Stockissuanceformdatas]);
        };

        $scope.Showgrid = function () {
            $scope.StockIssuancegrid = true;
            $scope.StockIssuanceform = false;
            $scope.siExport = true;
            $scope.siView = false;
            $scope.siSearch = true;
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "StockIssuance.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }


    }

})();


(function () {
    'use strict';

    angular
        .module('app.procurement.stock.lighttraplist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_lighttraplist', {
            url: '/Sensors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/lighttraplist/lighttraplist.html',
                    controller: 'LightTrapListController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.lighttraplist')
        .controller('LightTrapListController', LightTrapListController);


    /** @ngInject */
    function LightTrapListController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $window, $mdToast, $location, $mdDialog, $document, $http, $log, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var Client_Id = localStorage.getItem('Client_Id');

        RefreshGrid();
        RefreshGoodsdetailsGrid();
        RefreshWorkflowGrid();
        RefreshEmployeeGrid();
        RefreshStoreGrid();
        RefreshSupplierGrid();
        RefreshPOGrid();
        RefreshCustomerGrid();
        $scope.myIndex = 0;
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("SensorLists.xlsx",{headers:true}) FROM ?', [$scope.Lighttrapdatas]);
        };

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
        }

        $scope.ViewIssuanceHistory = function (e, LighttrapdetailId) {
            $scope.LighttrapdetailId = LighttrapdetailId;
            //$scope.IndxID = $index;
            try {
                var item = $scope.Lighttrapdatas.filter(function (item) {
                    return item._id === LighttrapdetailId;
                })[0];
                $scope.GId = item._id;
                $scope.StoreName = item.StoreName;
                $scope.ProductCategory = item.ProductCategory;
                $scope.ProductCode = item.ProductCode;
                $scope.ProductName = item.ProductName;
                $scope.Description = item.Description;
                $scope.Unit = item.Unit;
                $scope.Model = item.Model;
                $scope.SerialNumber = item.SerialNumber;
                $scope.Customer = item.Customer;
                $scope.Location = item.Location;
                $scope.Status = item.Status;
            } catch (err) { }
            $scope.ClearLighttrapdetail();
            RefreshLighttrapdetail();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/lighttraplist/lighttraphistory.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function LightTrapListController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.IssuanceDetaildatas = function () {
            $scope.LighttrapdetailId = $scope.LighttrapdetailId;
            try {
                var GArray = $scope.Lighttrapdatas;
                var item = GArray.filter(function (item) {
                    return item._id === $scope.LighttrapdetailId;
                })[0];
                $scope.GId = item._id;
                $scope.StoreName = item.StoreName;
                $scope.ProductCategory = item.ProductCategory;
                $scope.ProductCode = item.ProductCode;
                $scope.ProductName = item.ProductName;
                $scope.Description = item.Description;
                $scope.Unit = item.Unit;
                $scope.Model = item.Model;
                $scope.SerialNumber = item.SerialNumber;
                $scope.Customer = item.Customer;
                $scope.Location = item.Location;
                $scope.Status = item.Status;
            } catch (err) { }
            $scope.ClearLighttrapdetail();
            RefreshLighttrapdetail();
            $scope.Update = false;

        }

        $scope.lighttrapdetailSubmit = function () {

            RefreshLighttrapdetail();

            angular.forEach($scope.Lighttrapdetaildatas, function (value) {
                if (value.LighttrapID === $scope.LighttrapdetailId) {
                    $scope.LId = value._id;
                    $scope.Status = value.Status;
                }
            });

            if ($scope.Status == "Issued") {
                $scope.ClearLighttrapdetail();
                $mdToast.show($mdToast.simple().textContent('Already Issued!!').position('top center'));
                return
            }

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/lighttrapdetail/add",
                data: {
                    LighttrapID: $scope.LighttrapdetailId,
                    Customer: $scope.vm.Customer,
                    Location: $scope.vm.Location,
                    StartDate: $scope.vm.StartDate,
                    EndDate: $scope.vm.EndDate,
                    Status: "Issued",
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {

                $scope.data = GList.data.data;
                var responsed = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/lighttrap/updatestatus",
                    data: {
                        _id: $scope.LighttrapdetailId,
                        Customer: $scope.vm.Customer,
                        Location: $scope.vm.Location,
                        Status: "Issued",
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                $scope.ClearLighttrapdetail();
                RefreshLighttrapdetail1();

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/lighttrap",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Lighttrapdata) {
                $scope.Lighttrapdatas = Lighttrapdata.data.data;
            });
        }

        function RefreshLighttrapdetail() {
            var response = $http({
                url: $rootScope.WebURL + "/lighttrapdetail/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.LighttrapdetailId },
            });
            response.then(function (Lighttrapdetaildata) {
                $scope.Lighttrapdetaildatas = Lighttrapdetaildata.data.data;
            });
            $scope.Update = false;
        }

        function RefreshLighttrapdetail1() {
            var response = $http({
                url: $rootScope.WebURL + "/lighttrapdetail/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.LighttrapdetailId },
            });
            response.then(function (Lighttrapdetaildata) {
                $scope.Lighttrapdetaildatas = Lighttrapdetaildata.data.data;
                RefreshGrid();
            });

            $scope.Update = false;
        }

        $scope.ClearLighttrapdetail = function () {
            $scope.vm.Customer = '';
            $scope.vm.Location = '';
            $scope.vm.StartDate = null;
            $scope.vm.EndDate = null;
            $scope.Status = '';
        }

        $scope.Lighttrapdetailinfo = function (lDetailId) {
            $scope.SID = lDetailId;

            $scope.Update = true;
            try {
                var LighttrapdetailArray = $scope.Lighttrapdetaildatas;
                var item = LighttrapdetailArray.filter(function (item) {
                    return item._id === lDetailId && $scope.LighttrapdetailId === item.LighttrapID;
                })[0];

                $scope.id = item._id;
                $scope.vm.Customer = item.Customer;
                $scope.vm.Location = item.Location;
                $scope.vm.StartDate = item.StartDate;
                if ($scope.vm.StartDate != null && $scope.vm.StartDate != "") {
                    $scope.vm.StartDate = new Date(item.StartDate);
                }
                $scope.vm.EndDate = item.EndDate;
                if ($scope.vm.EndDate != null && $scope.vm.EndDate != "") {
                    $scope.vm.EndDate = new Date(item.EndDate);
                }
                $scope.Status = item.Status;
            } catch (err) { }

        }

        $scope.CloseLighttrapissuance = function (LighttrapId, CompanyName, Location) {
            $scope.LighttrapdetailId = $scope.LighttrapdetailId;
            $scope.com = CompanyName;
            $scope.loc = Location;

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/lighttrapdetail/updatestatus",
                data: {
                    _id: LighttrapId,
                    Status: "Returned",
                    UpdatedBy: $rootScope.LoginID
                },
            });
            response.then(function (GList) {
                var responsed = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/lighttrap/updatestatus",
                    data: {
                        _id: $scope.LighttrapdetailId,
                        Customer: CompanyName,
                        Location: Location,
                        Status: "New",
                        UpdatedBy: $rootScope.LoginID
                    },
                });

                $mdToast.show($mdToast.simple().textContent('Successfully Returned!').position('top center'));
                //$scope.ClearLighttrapdetail();
                RefreshLighttrapdetail1();
                //RefreshGrid();

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.PurchaseHistoryDetails = function () {
            var response = $http({
                url: $rootScope.WebURL + "/goods/getSensorPurchaseHistory",
                method: "POST",
                data: { Client_Id: Client_Id, StoreName: $scope.StoreName, ProductCategory: $scope.ProductCategory, ProductCode: $scope.ProductCode, ProductName: $scope.ProductName },
            });
            response.then(function (PurchaseHistorydata) {
                $scope.PurchaseHistorydatas = PurchaseHistorydata.data.data;
            });

        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.GoPO = function (POId) {

            try {
                var item1 = $scope.PurchaseHistorydatas.filter(function (item1) {
                    return item1._id === POId;
                })[0];
                $scope.POrderID = item1.ReferenceNo;
            } catch (err) { }

            try {
                var item = $scope.Purchaseorderdatas.filter(function (item) {
                    return item.ReferenceNo === $scope.POrderID;
                })[0];
                $scope.VPOId = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
            } catch (err) { }

            $window.localStorage.setItem('IDforViewPO', $scope.VPOId);
            $state.go('app.purchaseorder');

        }

        $scope.GoPOdd = function (POId, e) {

            var s = POId;
            try {
                var item1 = $scope.PurchaseHistorydatas.filter(function (item1) {
                    return item1._id === POId;
                })[0];
                $scope.POrderID = item1.ReferenceNo;
            } catch (err) { }

            try {
                var item = $scope.Purchaseorderdatas.filter(function (item) {
                    return item.ReferenceNo === $scope.POrderID;
                })[0];
                $scope.vm.id = item._id;
                $scope.vm.UniqueID = item.UniqueID;
                $scope.vm.ReferenceNo = item.ReferenceNo;
                $scope.vm.RequisitionNo = item.PRID;
                $scope.vm.RequestedByEmployee = item.RequestedEmployee,
                    $scope.vm.RequestedBy = item.EmployeeID;
                $scope.vm.RequestedByName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.vm.DepartmentName = item.Employeedetails[0].EDesignation;
                $scope.vm.OrderDate = new Date(item.OrderDate);
                $scope.vm.DeliveryDate = new Date(item.DeliveryDate);
                $scope.vm.Remarks = item.Remarks;
                $scope.vm.Supplier = item.SupplierID;
                $scope.vm.SupplierName = item.Supplierdetails[0].Name;
                $scope.vm.SupplierAddress1 = item.Supplierdetails[0].Street1;
                $scope.vm.SupplierAddress2 = item.Supplierdetails[0].Street2;
                $scope.vm.SupplierCity = item.Supplierdetails[0].City;
                $scope.vm.SupplierState = item.Supplierdetails[0].State;
                $scope.vm.SupplierCountry = item.Supplierdetails[0].Country;
                $scope.vm.SupplierPostalCode = item.Supplierdetails[0].PostalCode;
                $scope.vm.SupplierPhone = item.Supplierdetails[0].Phone;
                $scope.vm.SupplierMobile = item.Supplierdetails[0].Mobile;
                $scope.vm.SupplierFax = item.Supplierdetails[0].Fax;
                $scope.vm.SupplierEmail = item.Supplierdetails[0].Email;
                $scope.vm.SupplierWebsite = item.Supplierdetails[0].Website;
                $scope.vm.Store = item.StoreID;
                $scope.vm.ClientStore = item.ClientStore;
                $scope.vm.StoreName = item.Storedetails[0].StoreName;
                $scope.vm.StoreAddress1 = item.Storedetails[0].Address1;
                $scope.vm.StoreAddress2 = item.Storedetails[0].Address2;
                $scope.vm.StoreCity = item.Storedetails[0].City;
                $scope.vm.StoreState = item.Storedetails[0].State;
                $scope.vm.StoreCountry = item.Storedetails[0].Country;
                $scope.vm.StorePostalCode = item.Storedetails[0].PostalCode;
                $scope.vm.StorePhone = item.Storedetails[0].Phone;
                $scope.vm.StoreEmail = item.Storedetails[0].Email;
                $scope.vm.Currency = item.Currency;
                $scope.vm.SubTotal = parseFloat(item.SubTotal);
                $scope.vm.DiscountBefore = parseFloat(item.DiscountBefore);
                $scope.vm.GST = parseFloat(item.GST);
                $scope.vm.DiscountAfter = parseFloat(item.DiscountAfter);
                $scope.vm.Total = parseFloat(item.Total);
                $scope.vm.TotalinWord = item.TotalinWord;
                $scope.vm.Status = item.Status;
                $scope.vm.StatusID = item.StatusID;
            } catch (err) { }

            RefreshPurchaseorderproductGrid();
            RefreshGoodsGrid();
            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Inventory Purchase Order') {
                    if ($scope.vm.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.vm.Actioned = value.Actioned;
                        $scope.NextLevel = value.NextLevel;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.vm.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.AfterNextLevel = value.NextLevel;
                    }
                }
            });
            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Inventory Purchase Order') {
                    if ($scope.vm.NextLevelAction == wvalue.Action) {
                        $scope.vm.NextLevelAction = wvalue.Action;
                    }
                }
            });
            if ($scope.vm.StatusID == "0") {
                $scope.vm.Actioned = $scope.vm.Status;
                $scope.vm.NextLevelAction = '';
            }
            if ($scope.vm.Actioned == "PO Completed") {
                $scope.vm.Actioned = $scope.vm.Status;
                $scope.vm.NextLevelAction = '';
            }

            $mdDialog.cancel();
            $window.localStorage.setItem('', "dfdsfdfgdsgf");
            var $popup = $window.open('ViewPurchaseOrder', "popup");

            $popup.Podataid = $scope.vm.id;
            $popup.UniqueID = $scope.vm.UniqueID;
            $popup.ReferenceNo = $scope.vm.ReferenceNo;
            $popup.RequisitionNo = $scope.vm.RequisitionNo;
            $popup.RequestedByName = $scope.vm.RequestedByName;
            $popup.OrderDate = $scope.vm.OrderDate;
            $popup.DeliveryDate = $scope.vm.DeliveryDate;
            $popup.Remarks = $scope.vm.Remarks;
            $popup.SupplierName = $scope.vm.SupplierName;
            $popup.SupplierAddress1 = $scope.vm.SupplierAddress1;
            $popup.SupplierAddress2 = $scope.vm.SupplierAddress2;
            $popup.SupplierCity = $scope.vm.SupplierCity;
            $popup.SupplierState = $scope.vm.SupplierState;
            $popup.SupplierCountry = $scope.vm.SupplierCountry;
            $popup.SupplierPostalCode = $scope.vm.SupplierPostalCode;
            $popup.SupplierPhone = $scope.vm.SupplierPhone;
            $popup.SupplierMobile = $scope.vm.SupplierMobile;
            $popup.SupplierFax = $scope.vm.SupplierFax;
            $popup.SupplierEmail = $scope.vm.SupplierEmail;
            $popup.SupplierWebsite = $scope.vm.SupplierWebsite;
            $popup.ClientStore = $scope.vm.ClientStore;
            $popup.StoreName = $scope.vm.StoreName;
            $popup.StoreAddress1 = $scope.vm.StoreAddress1;
            $popup.StoreAddress2 = $scope.vm.StoreAddress2;
            $popup.StoreCity = $scope.vm.StoreCity;
            $popup.StoreState = $scope.vm.StoreState;
            $popup.StoreCountry = $scope.vm.StoreCountry;
            $popup.StorePostalCode = $scope.vm.StorePostalCode;
            $popup.StorePhone = $scope.vm.StorePhone;
            $popup.StoreEmail = $scope.vm.StoreEmail;
            $popup.Currency = $scope.vm.Currency;
            $popup.SubTotal = $scope.vm.SubTotal;
            $popup.DiscountBefore = $scope.vm.DiscountBefore;
            $popup.GST = $scope.vm.GST;
            $popup.DiscountAfter = $scope.vm.DiscountAfter;
            $popup.Total = $scope.vm.Total;
            $popup.Status = $scope.vm.Status;
            $popup.StatusID = $scope.vm.StatusID;
            $popup.Actioned = $scope.vm.Actioned;
            $popup.NextLevelAction = $scope.vm.NextLevelAction;
            $popup.Purchaseorderproductdatas = $scope.vm.Purchaseorderproductdatas;
            $popup.Goodsdatas = $scope.vm.Goodsdatas;
            $popup.Commentdatas = $scope.vm.Commentdatas;
            $popup.Attachmentdatas = $scope.vm.Attachmentdatas;
            $popup.Logdetailsdatas = $scope.vm.Logdetailsdatas;


        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.vm.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.vm.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.vm.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function RefreshPurchaseorderproductGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorderproduct/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Purchaseorderproductdata) {
                $scope.vm.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
            });
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.vm.UniqueID },
            });
            response.then(function (Goodsdata) {
                $scope.vm.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshGoodsdetailsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshStoreGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
            });
        }

        function RefreshSupplierGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        function RefreshPOGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Purchaseorderdata) {
                $scope.Purchaseorderdatas = Purchaseorderdata.data.data;
            });
        }

        function RefreshCustomerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: { Client_Id: Client_Id },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }

})();
(function () {
    'use strict';

    angular
 
        .module('app.procurement.stock.deliverynote', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_deliverynote', {
            url: '/DeliveryNote',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/deliverynote/deliverynote.html',
                    controller: 'DeliverynoteController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.deliverynote')
        .controller('DeliverynoteController', DeliverynoteController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function DeliverynoteController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, Upload, NgMap) {
        document.getElementsByTagName('title')[0].text = "Procurement-Delivery Order"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');


        $scope.Deliverynotegrid = true;
        $scope.Deliverynoteform = false;
        $scope.ViewDeliverynoteform = false;
        $scope.dnExport = true;
        $scope.dnAdd = true;
        $scope.dnView = false;
        $scope.dnSearch = true;
        $scope.DeliveryDetailsdiv = false;

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        DefaultDatefilter();
        RefreshCustomerGrid();
        RefreshSupplierGrid();

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
        }


        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/deliverynote",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (CheckDeliverynotedata) {
                $scope.CheckDeliverynotedatas = CheckDeliverynotedata.data.data;
            });
        }

        function DefaultDatefilter() {
            //$scope.Deliverynotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/deliverynote",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.Deliverynotedatas = GList.data.data;
            });
        }

        function RefreshCustomerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        function RefreshSupplierGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        $scope.CustomerClear = function () {
            $scope.Customer = "";
            $scope.ThirdParty = '';
            $scope.Name = "";
            $scope.Address1 = "";
            $scope.Address2 = "";
            $scope.City = "";
            $scope.State = "";
            $scope.PostalCode = "";
            $scope.Country = "";
            $scope.Phone = "";
            $scope.Mobile = "";
            $scope.Fax = "";
            $scope.Email = "";
            $scope.Website = "";
            $scope.DeliveryDetailsdiv = false;
        }

        $scope.SupplierClear = function () {
            $scope.Supplier = "";
            $scope.Name = "";
            $scope.Address1 = "";
            $scope.Address2 = "";
            $scope.City = "";
            $scope.State = "";
            $scope.PostalCode = "";
            $scope.Country = "";
            $scope.Phone = "";
            $scope.Mobile = "";
            $scope.Fax = "";
            $scope.Email = "";
            $scope.Website = "";
            $scope.DeliveryDetailsdiv = false;
        }

        $scope.Datefilter = function () {

            //$scope.Deliverynotedatas = undefined;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/deliverynote/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {

                $scope.Deliverynotedatas = GList.data.data;
            });
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("DeliveryNote.xlsx",{headers:true}) FROM ?', [$scope.Deliverynotedatas]);
        };

        $scope.Add = function () {

            ClearForm();

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.Update = false;
            $scope.Deliverynoteform = true;
            $scope.ViewDeliverynoteform = false;
            $scope.Deliverynotegrid = false;
            $scope.dnExport = false;
            $scope.dnAdd = false;
            $scope.dnSearch = false;
            $scope.dnView = true;
            $scope.To = "Customer";
            $scope.DeliveryDetailsdiv = false;
            $scope.Date = new Date();
            $scope.UpdateAtachment = false
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Deliverynotedetailldatas = []
            $scope.Deliverynotedetaildatas = []
        }

        $scope.Showgrid = function () {
            $scope.Deliverynotegrid = true;
            $scope.Deliverynoteform = false;
            $scope.ViewDeliverynoteform = false;
            $scope.dnExport = true;
            $scope.dnAdd = true;
            $scope.dnView = false;
            $scope.dnSearch = true;
            $scope.DeliveryDetailsdiv = false;
        }

        $scope.Tofield = function () {
            debugger
            $scope.value = $scope.To;
            if ($scope.value == "Customer") {
                $scope.ThirdParty = '';
                $scope.Supplier = "";
                $scope.DeliveryDetailsdiv = false;
            }
            if ($scope.value == "Supplier") {
                $scope.ThirdParty = '';
                $scope.Customer = "";
                $scope.DeliveryDetailsdiv = false;
            }
            if ($scope.value == "Third Party") {
                $scope.Supplier = '';
                $scope.Customer = "";
                $scope.DeliveryDetailsdiv = false;
            }
        }


        $scope.Deliverynoteinfo = function (DeliveryId, $index) {

            $scope.SID = DeliveryId;
            $scope.IndxID = $index;

            try {
                var item = $scope.Deliverynotedatas.filter(function (item) {
                    return item._id === DeliveryId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.Supplier = item.Supplier;
                $scope.SupplierName = item.Supplierdetails[0].Name;
                $scope.ThirdParty = item.Name;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.Date = new Date(item.DODate);
                $scope.Remarks = item.Remarks;
                $scope.FileName = item.UploadDocument;
                if ($scope.FileName != undefined && $scope.FileName != null && $scope.FileName != '') {
                    $scope.UpdateAtachment = true
                    if (item.Attachmentdetails.length > 0)
                        $scope.AttachId = item.Attachmentdetails[0]._id
                    else
                        $scope.AttachId = null
                }

                else $scope.UpdateAtachment = false

                var item = $scope.Supplierdatas.filter(function (item) {
                    return item.id === $scope.Supplier
                })[0]
                if (item != undefined) {
                    var response = $http({
                        url: $rootScope.WebURL + "/supplieritems/getByRequestID",
                        method: "POST",
                        data: { RequestID: item.UniqueID },
                    });
                    response.then(function (Supplierbillingaddressdata) {
                        $scope.SupplierItemdatas = Supplierbillingaddressdata.data.data;
                    });
                }

            } catch (err) { }
            $scope.Attachmentdatas = []
            RefreshAttachment()
            RefreshDeliverynotedetailGrid();
            $scope.Update = true;
            $scope.Deliverynoteform = true;
            $scope.ViewDeliverynoteform = false;
            $scope.Deliverynotegrid = false;
            $scope.dnExport = false;
            $scope.dnAdd = false;
            $scope.dnSearch = false;
            $scope.dnView = true;
        }

        $scope.dnSubmit = function () {

            if ($scope.Supplier == null || $scope.Supplier == "" || $scope.Supplier == "undefined") {
                $scope.Supplier = null
            }
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/deliverynote/update",
                    data: {
                        _id: $scope.SID,
                        Supplier: $scope.Supplier,
                        DODate: $scope.Date,
                        Remarks: $scope.Remarks,
                        UploadDocument: $scope.FileName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var Id = GList.data.data[0]._id
                    var file = angular.element(document.querySelector('#fileInput'))[0].files[0] ? angular.element(document.querySelector('#fileInput'))[0].files : []
                    AddAttachment(file, Id)
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Deliverynotedatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var item = $scope.Deliverynotedetailldatas.filter(function (item) {
                    return item.ItemCategory === "Chemical"
                })
                if (item.length > 0) {
                    var sorted = _.differenceBy($scope.Deliverynotedetailldatas, item, 'ItemId');
                    $scope.Deliverynotedetailldatas = sorted
                    var chemcialdata = _.groupBy(item, "ItemId")
                    var Filtdata = []
                    angular.forEach(chemcialdata, function (value) {
                        Filtdata.push({
                            ItemCategory: value[0].ItemCategory,
                            UniqueID: value[0].UniqueID,
                            Description: value[0].Description,
                            ItemId: value[0].ItemId,
                            TotalPrice: value[0].TotalPrice,
                            Quantity: _.sumBy(value, "Quantity"),
                            Remarks: value[0].Remarks,
                            Code: value[0].Code,
                            SupplierID: value[0].SupplierID,
                            Manufacturer: value[0].Manufacturer,
                            Threshold: value[0].Threshold,
                            MinimumOrder: value[0].MinimumOrder,
                            Unit: value[0].Unit,
                            EquipmentDetailsdata: value[0].EquipmentDetailsdata
                        })
                    })

                    $scope.Deliverynotedetailldatas = $scope.Deliverynotedetailldatas.concat(Filtdata)
                }

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/deliverynote/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        UploadDocument: $scope.FileName,
                        Supplier: $scope.Supplier,
                        DODate: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var Id = GList.data.data.id
                    DefaultDatefilter();
                    $scope.Showgrid();
                    RefreshGrid()
                    var file = angular.element(document.querySelector('#fileInput'))[0].files[0] ? angular.element(document.querySelector('#fileInput'))[0].files : []
                    AddAttachment(file, Id)
                    // $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    var data = []
                    var Chemicaldata = []
                    angular.forEach($scope.Deliverynotedetailldatas, function (item) {
                        if (item.ItemCategory == "Equipment") {

                            angular.forEach(item.EquipmentDetailsdata, function (value) {
                                data.push({
                                    Client_Id: Client_Id,
                                    Code: item.Code,
                                    EquipmentName: item.Description,
                                    ItemId: item.ItemId,
                                    SupplierID: item.SupplierID,
                                    Manufacturer: item.Manufacturer,
                                    SerialNumber: value.SerialNumber,
                                    Brand: value.Brand,
                                    PurchasedDate: value.PurchasedDate,
                                    Location: value.Location,
                                    Remarks: item.Remarks,
                                    Quantity: 1,
                                    RecordLogdetails: [],
                                    ServiceLogdetails: [],
                                    DeliveryOrder: Id,
                                    CreatedBy: $rootScope.LoginID
                                })
                            })
                        }
                        else if (item.ItemCategory == "Chemical") {
                            Chemicaldata.push({
                                Client_Id: Client_Id,
                                Code: item.Code,
                                // Category:$scope.Category,
                                ChemicalName: item.Description,
                                Supplier: item.Manufacturer,
                                ItemId: item.ItemId,
                                SupplierID: item.SupplierID,
                                Threshold: item.Threshold,
                                MinimumOrder: item.MinimumOrder,
                                PurchasedDate: new Date(),
                                Remarks: item.Remarks,
                                Quantity: item.Quantity,
                                Unit: item.Unit,
                                CreatedBy: $rootScope.LoginID,
                            })

                        }
                    })
                    // inserting all equipment with its serial number as array
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/chemical/addfromDo",
                        data: {
                            data: Chemicaldata
                        },
                    });
                    response.then(function (Glist) {

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/Equipment/addbyDO",
                            data: { data: data }
                        });
                        response.then(function (Glist) {
                            RefreshDeliverynotedetailGrid();
                        });
                    })
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.getSupplierItems = function (UniquId, Name) {
            var response = $http({
                url: $rootScope.WebURL + "/supplieritems/getByRequestID",
                method: "POST",
                data: { RequestID: UniquId },
            });
            response.then(function (Supplierbillingaddressdata) {
                $scope.SupplierItemdatas = Supplierbillingaddressdata.data.data;
            });
            $scope.SupplierName = Name
        }

        function ClearForm() {
            $scope.UniqueID = "";
            $scope.Supplier = "";
            $scope.Date = new Date();
            $scope.Remarks = "";
            $scope.FileName = "";
            // $scope.Deliverynotedetaildatas = [];
        }
        $scope.AGUpload = function (fileInput) {
            var input = angular.element(document.querySelector('#' + fileInput))
            input[0].click()
            var Name = ''
            input.bind('change', function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == 'fileInput')
                $scope.FileName = Name
        }

        $scope.BindAttach = function (fileInput) {
            var input = angular.element(document.querySelector('#' + fileInput))
            var Name = input[0].files[0].name;
            input.bind('change', function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == 'fileInput')
                $scope.FileName = Name

        }
        function RefreshAttachment() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.SID },
            });
            response.then(function (attachmentdata) {
                var item = attachmentdata.data.data.filter(function (item) {
                    return item.FileName === $scope.FileName
                })
                $scope.Attachmentdatas = item;
            });
        }
        function AddAttachment(file, Id) {
            if (file.length != 0 && file.length != undefined) {
                if ($scope.UpdateAtachment == false) {
                    var upfile = file[0]
                    var response1 = Upload.upload({
                        url: $rootScope.WebURL + '/deliverynote/upload',
                        data: { file: upfile }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response2 = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID,
                                    TableName: "DeliveryOrder",
                                    FileID: Id,
                                    FileName: $scope.fileName,
                                    FileSize: $scope.fileSize,
                                    FileType: $scope.fileType,
                                    ModuleID: $scope.Path,
                                    Data: null,
                                    IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response2.then(function (GList) {

                            });
                        }
                    });
                }
                else {
                    var upfile = file[0]
                    var response1 = Upload.upload({
                        url: $rootScope.WebURL + '/deliverynote/upload',
                        data: { file: upfile }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response2 = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID,
                                    TableName: "DeliveryOrder",
                                    FileID: Id,
                                    FileName: $scope.fileName,
                                    FileSize: $scope.fileSize,
                                    FileType: $scope.fileType,
                                    ModuleID: $scope.Path,
                                    Data: null,
                                    IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response2.then(function (GList) {

                            });
                        }
                    });
                }
            }
        }


        $scope.Deliverynotedetailpopup = function (UniqueID, e) {

            $scope.DUpdate = false;
            $scope.UniqueID = UniqueID;
            $scope.vm.dDescription = "";
            $scope.vm.dTotalPrice = "";
            $scope.vm.Quantity = "";
            $scope.vm.Remarks = "";

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/deliverynote/DeliverynoteAdd.html',
                parent: angular.element($document.body),
                multiple: true,
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function DeliverynoteController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Deliverynotedetailadd = function () {

            if ($scope.DUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/deliverynotedetail/update",
                    data: {
                        _id: $scope.DID,
                        Description: $scope.vm.dDescription,
                        TotalPrice: $scope.vm.dTotalPrice,
                        Quantity: $scope.vm.Quantity,
                        Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshDeliverynotedetailGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                if ($scope.ItemCategory == "Equipment") {
                    $scope.dataGrid.saveEditData()
                    var SerialNum = []
                    angular.forEach($scope.EquipmentDetailsdata, function (value) {
                        SerialNum.push(value.SerialNumber)
                    })
                    var serdata = _.uniq(SerialNum);
                    if (serdata.length == SerialNum.length) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/Equipment/checkSerialNum",
                            data: {
                                SerialNum: SerialNum,
                                Client_Id: Client_Id
                            },
                        });
                        response.then(function (List) {
                            if (List.data.Count == 0) {
                                $scope.Deliverynotedetailldatas.push({
                                    ItemCategory: $scope.ItemCategory,
                                    UniqueID: $scope.UniqueID,
                                    Description: $scope.vm.dDescription,
                                    ItemId: $scope.ItemId,
                                    TotalPrice: $scope.vm.dTotalPrice,
                                    Quantity: $scope.vm.Quantity,
                                    Remarks: $scope.vm.Remarks,
                                    Code: $scope.Code,
                                    SupplierID: $scope.Supplier,
                                    Manufacturer: $scope.SupplierName,
                                    Threshold: $scope.Threshold,
                                    MinimumOrder: $scope.MinimumOrder,
                                    Unit: $scope.Unit,
                                    EquipmentDetailsdata: $scope.EquipmentDetailsdata
                                })
                                var response = $http({
                                    method: "POST",
                                    url: $rootScope.WebURL + "/deliverynotedetail/add",
                                    data: {
                                        UniqueID: $scope.UniqueID,
                                        Description: $scope.vm.dDescription,
                                        ItemId: $scope.ItemId,
                                        TotalPrice: $scope.vm.dTotalPrice,
                                        Quantity: $scope.vm.Quantity,
                                        Remarks: $scope.vm.Remarks,
                                        CreatedBy: $rootScope.LoginID,
                                    },
                                });
                                response.then(function (Glist) {
                                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                                    RefreshDeliverynotedetailGrid();
                                    $mdDialog.cancel();
                                    $mdDialog.cancel();
                                })
                            }
                            else {
                                $mdToast.show($mdToast.simple().textContent('Serial Nubmer cannot be duplicated for same Equipment!').position('top center'));
                            }
                        })
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Serial Nubmer cannot be duplicated for same Equipment!').position('top center'));
                    }
                }
                else {
                    $scope.Deliverynotedetailldatas.push({
                        ItemCategory: $scope.ItemCategory,
                        UniqueID: $scope.UniqueID,
                        Description: $scope.vm.dDescription,
                        ItemId: $scope.ItemId,
                        TotalPrice: $scope.vm.dTotalPrice,
                        Quantity: $scope.vm.Quantity,
                        Remarks: $scope.vm.Remarks,
                        Code: $scope.Code,
                        SupplierID: $scope.Supplier,
                        Manufacturer: $scope.SupplierName,
                        Threshold: $scope.Threshold,
                        MinimumOrder: $scope.MinimumOrder,
                        Unit: $scope.Unit,
                        EquipmentDetailsdata: $scope.EquipmentDetailsdata
                    })
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/deliverynotedetail/add",
                        data: {
                            UniqueID: $scope.UniqueID,
                            Description: $scope.vm.dDescription,
                            ItemId: $scope.ItemId,
                            TotalPrice: $scope.vm.dTotalPrice,
                            Quantity: $scope.vm.Quantity,
                            Remarks: $scope.vm.Remarks,
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (Glist) {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshDeliverynotedetailGrid();
                        $mdDialog.cancel();
                    })
                }

            }
        }

        $scope.Deliverynotedetailupdate = function (e, DeliverynotedetailId) {

            $scope.DUpdate = true;
            $scope.DID = DeliverynotedetailId;
            try {
                var item = $scope.Deliverynotedetaildatas.filter(function (item) {
                    return item._id === DeliverynotedetailId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.vm.dDescription = item.Description;
                $scope.vm.dTotalPrice = parseFloat(item.TotalPrice);
                $scope.vm.Remarks = item.Remarks;
                $scope.vm.Quantity = parseFloat(item.Quantity);
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/deliverynote/DeliverynoteAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IssuanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Deliverynotedetaildelete = function (e, deleteID) {
            vm.Title = "Are you sure you want to cancel this item?"
            $scope.deleteID = deleteID;
            $scope.DeleteDelivery = true
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/deliverynote/deliverynotedetaildelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IssuanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.DeliveryNoteDetailsdelete = function (index, row) {

            if ($scope.Update == false) {
                $scope.in = index
                $scope.row = row
                var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete this item?", "Confirm changes");
                result.done(function (dialogResult) {
                    if (dialogResult) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/deliverynotedetail/delete",
                            data: {
                                _id: $scope.in,
                            },
                        });
                        response.then(function (GList) {
                            RefreshDeliverynotedetailGrid();
                            if ($scope.Deliverynotedetailldatas.length > 0)
                                $scope.Deliverynotedetailldatas.splice($scope.row, 1)
                        })
                    }
                })
            }

            else {
                $scope.in = index
                var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete this item?", "Confirm changes");
                result.done(function (dialogResult) {
                    if (dialogResult) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/deliverynotedetail/delete",
                            data: {
                                _id: $scope.in,
                            },
                        });
                        response.then(function (GList) {
                            var item = $scope.Deliverynotedetaildatas.filter(function (item) {
                                return item._id === $scope.in
                            })[0];
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/deliverynote/deleteitem",
                                data: {
                                    ItemId: item.ItemId,
                                    Quantity: item.Quantity,
                                    DeliveryOrder: $scope.SID
                                },
                            });
                            response.then(function (GListt) {
                                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                                RefreshDeliverynotedetailGrid();
                                if ($scope.Deliverynotedetailldatas.length > 0)
                                    $scope.Deliverynotedetailldatas.splice($scope.row, 1)
                            })
                        })
                    }
                })
            }
        }


        $scope.Ddelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/deliverynotedetail/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshDeliverynotedetailGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshDeliverynotedetailGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/deliverynotedetail/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Deliverynotedetaildata) {

                $scope.Deliverynotedetaildatas = Deliverynotedetaildata.data.data;
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Deliverynote.aspx?ID=" + PId;
            window.open(url);
        };

        $scope.getItemDetails = function (data) {
            $scope.ItemId = data._id
            $scope.Code = data.ItemCode
            $scope.ItemCategory = data.Category
            $scope.Threshold = data.ThresholdLevel
            $scope.MinimumOrder = data.MinimumOrder
            $scope.Unit = data.Unit
        }

        $scope.EquipmentDetails = function (e) {
            if ($scope.ItemCategory == "Chemical") {
                $scope.Deliverynotedetailadd()
            }
            else {
                $scope.DeleteDelivery = false
                $scope.EquipmentDetailsdata = []
                var Count = 0
                vm.Title = "Please Enter Equipment Details";
                try {
                    for (var i = 0; i < $scope.vm.Quantity; i++) {
                        $scope.EquipmentDetailsdata.push({
                            ID: i + 1,
                            PurchasedDate: new Date(),
                            SerialNumber: "",
                            Brand: ""
                        })
                    }
                }
                catch (e) {
                }
                $mdDialog.show({
                    templateUrl: 'app/main/apps/procurement/stock/deliverynote/deliverynotedetaildelete.html',
                    multiple: true,
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function IssuanceController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });

                vm.dataGridOptions = {
                    dataSource: $scope.EquipmentDetailsdata,
                    keyExpr: "ID",
                    showBorders: true,
                    keyboardNavigation: {
                        enterKeyAction: "startEdit",
                        enterKeyDirection: "row",
                        editOnKeyPress: true
                    },
                    paging: {
                        enabled: false
                    },
                    editing: {
                        mode: "batch",
                        allowUpdating: true,
                        startEditAction: "dblClick"
                    },
                    onFocusedCellChanging: function (e) {
                        e.isHighlighted = true;
                    },
                    columns: [
                        {
                            dataField: "ID",
                            caption: "S.No",
                            width: 70
                        },
                        // {
                        //     dataField: "PurchasedDate",
                        //     caption: "Purchased Date",
                        //     dataType:'date'
                        // },
                        "SerialNumber",
                        "Brand"
                    ],
                    onInitialized: function (e) {
                        $scope.dataGrid = e.component;
                        $scope.dataGrid.option("keyboardNavigation.editOnKeyPress", true);
                        $scope.dataGrid.option("keyboardNavigation.enterKeyAction", "startEdit");
                        $scope.dataGrid.option("keyboardNavigation.enterKeyDirection", "row");
                    },
                    bindingOptions: {
                        dataSource: 'EquipmentDetailsdata'
                    }
                };
            }
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function DoconvertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }

})();


(function () {
    'use strict';

    angular
 
        .module('app.procurement.stock.auditing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_stock_auditing', {
            url: '/AuditingActivity',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/auditing/auditing.html',
                    controller: 'AuditingController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.auditing')
        .controller('AuditingController', AuditingController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function AuditingController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("StockManagement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        RefreshGrid();
        RefreshProductGrid();
        RefreshWorkflowGrid();
        RefreshStoreGrid();
        RefreshEmployeeGrid();
        RefreshCustomerGrid();
        //RefreshUserGrid();
        RefreshGoodsuniqueGrid();
        RefreshGoodsGrid();
        RefreshStocksReturnGrid();

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuanceform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
            });
        }

        function RefreshProductGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
        }

        function RefreshWorkflowGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Workflowdata) {

                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshStoreGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshCustomerGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        //function RefreshUserGrid() {
        //    var response = $http({
        //        url:  $rootScope.WebURL + "/user",
        //        method: "POST",
        //        data: { Client_Id: Client_Id },
        //    });
        //    response.then(function (Userdata) {
        //        $scope.Userdatas = Userdata.data.data;
        //    });
        //}

        function RefreshGoodsuniqueGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        function RefreshUniqueGoodsGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshStocksGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/stockissuance/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Stockissuancedata) {

                $scope.Stockissuancedatas = Stockissuancedata.data.data;
            });

        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {

            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {

                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function RefreshStocksReturnGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockreturn",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Stockreturndata) {
                $scope.Stockreturndatas = Stockreturndata.data.data;
            });
        }

        var StockID = getParameterByName('ID');

        if (StockID != null) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuanceform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Stockissuanceformdata) {
                $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
                try {
                    var StockissuanceformArray = $scope.Stockissuanceformdatas;
                    var item = StockissuanceformArray.filter(function (item) {
                        return item._id === StockID;
                    })[0];

                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.To = item.To;
                    $scope.EmployeeID = item.EmployeeID;
                    $scope.StoreID = item.StoreID;
                    $scope.CustomerID = item.CustomerID;
                    $scope.ThirdPartyName = item.ThirdParty;
                    $scope.Purpose = item.Purpose;
                    $scope.Remarks = item.Remarks;
                    if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                        $scope.QRCode = decode_base64(item.QRCode);
                    }
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                    $scope.RequestedDate = new Date(item.RequestedDate);
                    $scope.RequestedByName = item.ThirdParty;
                } catch (err) { }
                $scope.Update = true;
                $scope.ShowWorkflowButton = false;
                $scope.ShowIssueButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = '';
                $scope.NextLevelAction = '';
                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();
                $scope.ViewStockIssuanceform = true;
                $scope.StockIssuanceform = false;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siAdd = false;
                $scope.siSearch = false;
                $scope.siView = true;
                $scope.Cancel = false;
                $scope.Stock = true;
                $scope.StockPrint = true;

                angular.forEach($scope.Employeedatas, function (value1) {
                    if ($scope.EmployeeID == value1.id) {
                        $scope.RequestedByName = value1.EmployeeName;
                    }
                });
                angular.forEach($scope.Storedatas, function (value2) {
                    if ($scope.StoreID == value2._id) {
                        $scope.RequestedByName = value2.StoreName;
                        $scope.RequestedStoreName = value2.StoreName;
                    }
                });
                angular.forEach($scope.Customerdatas, function (value3) {
                    if ($scope.CustomerID == value3.id) {
                        $scope.RequestedByName = value3.CompanyName;
                    }
                });

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'Inventory Stock Issuance') {

                        if ($scope.StatusID == value.LevelName) {

                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {

                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {

                    var array = $scope.NextLevelApprovers.split(",");

                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID === array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'Inventory Stock Issuance') {

                        if ($scope.LevelName == "3" && $scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.ShowIssueButton = true;
                        }
                        else if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                            $scope.ShowIssueButton = false;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                            $scope.ShowIssueButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {

                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }


                RefreshStocksGrid();
                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
                RefreshUniqueGoodsGrid();
            });

        }
        else {
            $scope.StockIssuanceform = false;
            $scope.ViewStockIssuanceform = false;
            $scope.StockIssuancegrid = true;
            $scope.siExport = true;
            $scope.siAdd = true;
            $scope.siSearch = true;
            $scope.siView = false;
            $scope.Cancel = false;
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.ProductNameclear = function () {
            $scope.vm.iProductName = '';
            $scope.vm.iStockQuantity = '';
            $scope.vm.iUnits = '';
            $scope.vm.iProductCode = '';
            $scope.vm.iDescription = '';
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("StockissuanceDetails.xlsx",{headers:true}) FROM ?', [$scope.Stockissuanceformdatas]);
        };

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {

            ClearForm();
            $scope.Update = false;
            $scope.StockIssuanceform = true;
            $scope.ViewStockIssuanceform = false;
            $scope.StockIssuancegrid = false;
            $scope.siExport = false;
            $scope.siAdd = false;
            $scope.siSearch = false;
            $scope.siView = true;
            $scope.Cancel = false;
            $scope.To = "Employee";
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            var AR = "SI-";
            var info = $scope.Stockissuanceformdatas.length + 1;
            var y = pad(info, 6);
            $scope.ReferenceNo = AR + y;
        }

        $scope.Showgrid = function () {
            $scope.StockIssuancegrid = true;
            $scope.StockIssuanceform = false;
            $scope.ViewStockIssuanceform = false;
            $scope.siExport = true;
            $scope.siAdd = true;
            $scope.siView = false;
            $scope.siSearch = true;
            $scope.Cancel = false;
        }

        $scope.Tofield = function () {

            $scope.value = $scope.To;
            if ($scope.value == "Employee") {
                $scope.StoreID = "";
                $scope.CustomerID = "";
                $scope.ThirdPartyName = "";
            }
            else if ($scope.value == "Store") {
                $scope.EmployeeID = "";
                $scope.CustomerID = "";
                $scope.ThirdPartyName = "";
            }
            else if ($scope.value == "Customer") {
                $scope.EmployeeID = "";
                $scope.StoreID = "";
                $scope.ThirdPartyName = "";
            }
            else if ($scope.value == "ThirdParty") {
                $scope.EmployeeID = "";
                $scope.StoreID = "";
                $scope.CustomerID = "";
            }
        }

        $scope.ProductNamedetails = function () {

            var response = $http({
                url: $rootScope.WebURL + "/goodsunique/getByCategory",
                method: "POST",
                data: { StoreName: $scope.vm.iStore, RequestID: $scope.vm.iProductCategory },
            });
            response.then(function (Categorydata) {

                $scope.Categorydatas = Categorydata.data.data;

                $scope.vm.iStockQuantity = "0";
                $scope.vm.iUnits = "";
                $scope.vm.iProductCode = "";
                $scope.vm.iDescription = "";
            });
        }

        $scope.ProductCodedetails = function () {

            $scope.vm.iStockQuantity = "0";
            $scope.vm.iUnits = "";
            $scope.vm.iProductCode = "";
            $scope.vm.iDescription = "";
            try {
                var GoodsArray = $scope.Goodsuniquedatas;
                var item = GoodsArray.filter(function (item) {
                    return $scope.vm.iStore == item.StoreName && $scope.vm.iProductName == item.ProductName && $scope.vm.iProductCategory == item.ProductCategory;
                })[0];

                $scope.vm.iStockQuantity = item.BalanceQuantity;
                $scope.vm.iUnits = item.Unit;
                $scope.vm.iProductCode = item.ProductCode;
                $scope.vm.iDescription = item.Description;
                $scope.SerialNumber = item.SerialNumber;
                $scope.Model = item.Model;
            } catch (err) { }
        }

        $scope.siSubmit = function () {

            if ($scope.EmployeeID == null || $scope.EmployeeID == "" || $scope.EmployeeID == "undefined") {
                $scope.EmployeeID = null
            }
            if ($scope.StoreID == null || $scope.StoreID == "" || $scope.StoreID == "undefined") {
                $scope.StoreID = null
            }
            if ($scope.CustomerID == null || $scope.CustomerID == "" || $scope.CustomerID == "undefined") {
                $scope.CustomerID = null
            }
            if ($scope.ThirdPartyName == null || $scope.ThirdPartyName == "" || $scope.ThirdPartyName == "undefined") {
                $scope.ThirdPartyName = null
            }

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        RequestedDate: $scope.RequestedDate,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });


                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];
                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/stockissuanceform/add",
                    data: {
                        Client_Id: Client_Id,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: "New",
                        StatusID: "1",
                        RequestedDate: new Date(),
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data;

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Stockinfo = function (StockId, $index) {

            $scope.SID = StockId;
            $scope.IndxID = $index;
            try {
                var StockissuanceformArray = $scope.Stockissuanceformdatas;
                var item1 = StockissuanceformArray.filter(function (item1) {
                    return item1._id === StockId;
                })[0];

                $scope.id = item1._id;
                $scope.Status = item1.Status;
                $scope.StatusID = item1.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.Update = true;
                $scope.StockIssuanceform = true;
                $scope.ViewStockIssuanceform = false;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siAdd = false;
                $scope.siSearch = false;
                $scope.siView = true;
                $scope.Cancel = false;
                $scope.Stock = true;
                try {
                    var StockissuanceformArray = $scope.Stockissuanceformdatas;
                    var item = StockissuanceformArray.filter(function (item) {
                        return item._id === StockId;
                    })[0];

                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.To = item.To;
                    $scope.EmployeeID = item.EmployeeID;
                    $scope.StoreID = item.StoreID;
                    $scope.CustomerID = item.CustomerID;
                    $scope.ThirdPartyName = item.ThirdParty;
                    $scope.FromStoreID = item.FromStoreID;
                    $scope.Purpose = item.Purpose;
                    $scope.Remarks = item.Remarks;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                    $scope.RequestedDate = new Date(item.RequestedDate);
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

                RefreshStocksGrid();
            }
        }

        $scope.ViewStockinfo = function (VStockinfo, $index) {

            $scope.SID = VStockinfo;
            $scope.IndxID = $index;
            RefreshGrid();
            $scope.Update = true;
            $scope.ShowWorkflowButton = false;
            $scope.ShowIssueButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
            $scope.basicForm2.$setPristine();
            $scope.basicForm2.$setUntouched();

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";


            $scope.ViewStockIssuanceform = true;
            $scope.StockIssuanceform = false;
            $scope.StockIssuancegrid = false;
            $scope.siExport = false;
            $scope.siAdd = false;
            $scope.siSearch = false;
            $scope.siView = true;
            $scope.Cancel = false;
            $scope.Stock = true;
            $scope.StockPrint = true;
            try {
                var StockissuanceformArray = $scope.Stockissuanceformdatas;
                var item = StockissuanceformArray.filter(function (item) {
                    return item._id === VStockinfo;
                })[0];

                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.To = item.To;
                $scope.EmployeeID = item.EmployeeID;
                $scope.StoreID = item.StoreID;
                $scope.CustomerID = item.CustomerID;
                $scope.ThirdPartyName = item.ThirdParty;
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                    $scope.QRCode = decode_base64(item.QRCode);
                }
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.RequestedDate = new Date(item.RequestedDate);
                $scope.RequestedByName = item.ThirdParty;
            } catch (err) { }
            angular.forEach($scope.Employeedatas, function (value1) {
                if ($scope.EmployeeID == value1.id) {
                    $scope.RequestedByName = value1.EmployeeName;
                }
            });
            angular.forEach($scope.Storedatas, function (value2) {
                if ($scope.StoreID == value2._id) {
                    $scope.RequestedByName = value2.StoreName;
                    $scope.RequestedStoreName = value2.StoreName;
                }
            });
            angular.forEach($scope.Customerdatas, function (value3) {
                if ($scope.CustomerID == value3.id) {
                    $scope.RequestedByName = value3.CompanyName;
                }
            });

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Inventory Stock Issuance') {

                    if ($scope.StatusID == value.LevelName) {

                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {

                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");

                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID === array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Inventory Stock Issuance') {

                    if ($scope.LevelName == "3" && $scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.ShowIssueButton = true;
                    }
                    else if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        $scope.ShowIssueButton = false;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                        $scope.ShowIssueButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {

                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshStocksGrid();
            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
            RefreshUniqueGoodsGrid();

        }

        $scope.StockIssuancepopup = function (UniqueID, e) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/issuance/IssuanceAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IssuanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.UniqID = UniqueID;
            $scope.RefNo = $scope.ReferenceNo;
            $scope.SerialNumber = $scope.SerialNumber;
            $scope.Model = $scope.Model;

            $scope.vm.iType = "No";
            $scope.vm.iStore = '';
            $scope.vm.iExpectedReturnDate = null;
            $scope.vm.iProductCategory = '';
            $scope.vm.iProductName = '';
            $scope.vm.iProductCode = '';
            $scope.vm.iDescription = '';
            $scope.vm.iStockQuantity = '';
            $scope.vm.iQuantity = '';
            $scope.vm.iUnits = '';

        }

        $scope.StockIssuanceadd = function () {


            if (parseFloat($scope.vm.iStockQuantity) == 0 && parseFloat($scope.vm.iStockQuantity) < parseFloat($scope.vm.iQuantity)) {
                RefreshStocksGrid();
                $scope.vm.iQuantity = '';
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Product not available in this store!!').position('top center'));
                return
            }
            if (parseFloat($scope.vm.iStockQuantity) < parseFloat($scope.vm.iQuantity)) {
                RefreshStocksGrid();
                $scope.vm.iQuantity = '';
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Issue quantity should not be grater than Stock quantity!').position('top center'));
                return
            }

            if ($scope.vm.iExpectedReturnDate == null || $scope.vm.iExpectedReturnDate == "" || $scope.vm.iExpectedReturnDate == "undefined") {
                $scope.vm.iExpectedReturnDate = null
            }

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuance/add",
                data: {
                    Client_Id: Client_Id,
                    ReferenceNo: $scope.RefNo,
                    UniqueID: $scope.UniqID,
                    StoreID: $scope.vm.iStore,
                    ProductType: $scope.vm.iType,
                    ProductCategory: $scope.vm.iProductCategory,
                    ProductName: $scope.vm.iProductName,
                    ProductCode: $scope.vm.iProductCode,
                    Description: $scope.vm.iDescription,
                    Model: $scope.Model,
                    SerialNumber: $scope.SerialNumber,
                    StockQuantity: $scope.vm.iStockQuantity,
                    Quantity: $scope.vm.iQuantity,
                    Unit: $scope.vm.iUnits,
                    ReturnDate: $scope.vm.iExpectedReturnDate,
                    CreatedBy: $rootScope.LoginID,
                },
            });

            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                RefreshStocksGrid();

                $scope.StockIssuanceform = true;
                $scope.ViewStockIssuanceform = false;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siAdd = false;
                $scope.siSearch = false;
                $scope.siView = true;
                $scope.Cancel = false;


                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });

        }

        $scope.StockIssuanceupdate = function (e, RStockIssuanceId) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/issuance/IssuanceAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IssuanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.SIUpdate = true;
            $scope.SiID = RStockIssuanceId;
            try {
                var SArray = $scope.Stockreturndatas;
                var item = SArray.filter(function (item) {
                    return item.id === RStockIssuanceId;
                })[0];

                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.vm.iType = item.ProductType;
                $scope.vm.iStore = item.StoreID;
                $scope.vm.iExpectedReturnDate = item.ReturnDate;
                $scope.vm.iProductCategory = item.ProductCategory;
                $scope.vm.iProductName = item.ProductName;
                $scope.vm.iProductCode = item.ProductCode;
                $scope.vm.iDescription = item.Description;
                $scope.vm.iStockQuantity = item.StockQuantity;
                $scope.vm.iQuantity = item.Quantity;
                $scope.vm.iUnits = item.Unit;
                $scope.SerialNumber = item.SerialNumber;
                $scope.Model = item.Model;
            } catch (err) { }
        }

        $scope.StockIssuancedelete = function (e, deleteID) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/issuance/issuancedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IssuanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.SIdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuance/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshStocksGrid();

                $scope.StockIssuanceform = true;
                $scope.ViewStockIssuanceform = false;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siAdd = false;
                $scope.siSearch = false;
                $scope.siView = true;
                $scope.Cancel = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.commentSubmit = function () {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Inventory Stock Issuance",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {

                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();
                $scope.ViewStockIssuanceform = true;
                $scope.StockIssuanceform = false;
                $scope.StockIssuancegrid = false;
                $scope.siExport = false;
                $scope.siAdd = false;
                $scope.siSearch = false;
                $scope.siView = true;
                $scope.Cancel = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file

            var response = Upload.upload({
                url: $rootScope.WebURL + "/stockissuanceform/upload",
                data: { file: file }
            }).then(function (resp) {

                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Stock Issuance",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        $scope.workflow = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        FromStoreName: $scope.FromStoreID,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        RequestedDate: $scope.RequestedDate,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });

                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];
                    //RefreshGrid();
                    RefreshLogdetails();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.reject = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        FromStoreName: $scope.FromStoreID,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: "Rejected",
                        StatusID: "0",
                        RequestedDate: $scope.RequestedDate,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    //try {
                    //    if (Workflowitem.NotifytoNextLevelApprover == true) {
                    //        try {
                    //            $scope.NLevel = Workflowitem.NextLevel;
                    //            var myArray1 = $scope.Workflowdatas;
                    //            var Workflowitem1 = myArray1.filter(function (item1) {
                    //                return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                    //            })[0];
                    //        } catch (err) {
                    //        }
                    //        try {
                    //            $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                    //            angular.forEach($scope.NApproversArray, function (value) {
                    //                var UserArray4 = $scope.Userdatas;
                    //                var item4 = UserArray4.filter(function (item4) {
                    //                    return item4.UserID === value;
                    //                })[0];
                    //                SenderEmails.push({ Email: item4.Email });
                    //            });
                    //        } catch (err) {
                    //        }
                    //    }
                    //} catch (err) {
                    //}

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    RefreshLogdetails();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.issue = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;
            $scope.SUniqueID = $scope.UniqueID;
            $scope.ReferNo = $scope.ReferenceNo;
            $scope.IssueTo = $scope.To;
            $scope.RequestedBy = $scope.RequestedByName;
            $scope.StoreNameID = $scope.RequestedStoreName;

            var response = $http({
                url: $rootScope.WebURL + "/stockissuance/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.SUniqueID },
            });
            response.then(function (Stockdata) {
                $scope.Stockdatas = Stockdata.data.data;
            });

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNo: $scope.ReferNo,
                        UniqueID: $scope.SUniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        RequestedDate: $scope.RequestedDate,
                        IssuedDate: new Date(),
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: convertDate($scope.Userdata.IssuedDate),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });

                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    angular.forEach($scope.Stockdatas, function (value1) {
                        angular.forEach($scope.Goodsuniquedatas, function (value2) {
                            if (value1.StoreID == value2.StoreName && value1.ProductCode == value2.ProductCode) {

                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goodsunique/update",
                                    data: {
                                        _id: value2.id,
                                        StoreName: value2.StoreName,
                                        ProductCategory: value2.ProductCategory,
                                        ProductCode: value2.ProductCode,
                                        ProductName: value2.ProductName,
                                        Description: value2.Description,
                                        Model: value2.Model,
                                        SerialNumber: value2.SerialNumber,
                                        Unit: value2.Unit,
                                        TotalQuantity: parseFloat(value2.TotalQuantity),
                                        IssuedQuantity: parseFloat(value2.IssuedQuantity) + parseFloat(value1.Quantity),
                                        ReceivedQuantity: value2.ReceivedQuantity,
                                        BalanceQuantity: parseFloat(value2.BalanceQuantity) - parseFloat(value1.Quantity),
                                        ReorderQuantity: value2.ReorderQuantity,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });

                    if ($scope.IssueTo == "Store") {

                        $scope.IssueTo = $scope.To
                        $scope.StoreNameID = $scope.RequestedStoreName
                        $scope.IssueToStore();
                    }

                    angular.forEach($scope.Stockdatas, function (value3) {
                        if (value3.ReferenceNo == $scope.ReferNo && value3.ProductType == "Yes") {

                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/stockreturn/add",
                                data: {
                                    Client_Id: Client_Id,
                                    IssuedTo: $scope.IssueTo,
                                    ReceiverName: $scope.RequestedBy,
                                    UniqueID: $scope.SUniqueID,
                                    ReferenceNo: $scope.ReferNo,
                                    StoreID: value3.StoreID,
                                    ProductCategory: value3.ProductCategory,
                                    ProductCode: value3.ProductCode,
                                    ProductName: value3.ProductName,
                                    Description: value3.Description,
                                    Model: value3.Model,
                                    SerialNumber: value3.SerialNumber,
                                    ReceivedQuantity: value3.Quantity,
                                    ReturnedQuantity: "0",
                                    Unit: value3.Unit,
                                    ReturnDate: value3.ReturnDate,
                                    CreatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];
                    //RefreshGrid();
                    RefreshLogdetails();
                    RefreshUniqueGoodsGrid();
                    RefreshStocksReturnGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.IssueToStore = function () {

            angular.forEach($scope.Stockdatas, function (value1) {

                angular.forEach($scope.Goodsuniquedatas, function (value2) {

                    if ($scope.StoreNameID == value2.StoreName && value1.ProductCode == value2.ProductCode) {

                        $scope.tq = parseFloat(value2.TotalQuantity) + parseFloat(value1.Quantity);

                        $scope.bq = parseFloat(value2.BalanceQuantity) + parseFloat(value1.Quantity);
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/goodsunique/update",
                            data: {
                                _id: value2.id,
                                StoreName: value2.StoreName,
                                ProductCategory: value2.ProductCategory,
                                ProductCode: value2.ProductCode,
                                ProductName: value2.ProductName,
                                Description: value2.Description,
                                Model: value2.Model,
                                SerialNumber: value2.SerialNumber,
                                TotalQuantity: $scope.tq,
                                IssuedQuantity: parseFloat(value2.IssuedQuantity),
                                ReceivedQuantity: value2.ReceivedQuantity,
                                BalanceQuantity: $scope.bq,
                                ReorderQuantity: value2.ReorderQuantity,
                                Unit: value2.Unit,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                });
            });

        }

        $scope.revise = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.LevelName != 1 && $scope.StatusID != 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        FromStoreName: $scope.FromStoreID,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Revised!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    RefreshLogdetails();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.cancelrequest = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/stockissuanceform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        To: $scope.To,
                        EmployeeID: $scope.EmployeeID,
                        StoreID: $scope.StoreID,
                        CustomerID: $scope.CustomerID,
                        ThirdParty: $scope.ThirdPartyName,
                        FromStoreName: $scope.FromStoreID,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: "Cancelled",
                        StatusID: "0",
                        RequestedDate: $scope.RequestedDate,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    if ($scope.Userdata.ThirdParty != "" && $scope.Userdata.ThirdParty != "undefined" && $scope.Userdata.ThirdParty != null) {
                        $scope.RequestedByName = $scope.Userdata.ThirdParty;
                    }
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.RequestedByName = Eitem.EmployeeID + "-" + Eitem.EmployeeName;
                    } catch (err) {
                    }

                    try {
                        var SArray = $scope.Storedatas;
                        var Sitem = SArray.filter(function (Sitem) {
                            return Sitem._id === $scope.Userdata.StoreID;
                        })[0];
                        $scope.RequestedByName = Sitem.ReferenceNo + "-" + Sitem.StoreName;
                    } catch (err) {
                    }

                    try {
                        var CArray = $scope.Customerdatas;
                        var Citem = CArray.filter(function (Citem) {
                            return Citem.id === $scope.Userdata.CustomerID;
                        })[0];
                        $scope.RequestedByName = Citem.CustomerReference + "-" + Citem.CompanyName;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Issuance' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Issuance' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockissuanceform/email",
                            data: {

                                StockID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                To: $scope.Userdata.To,
                                Name: $scope.RequestedByName,
                                RequestedDate: convertDate($scope.Userdata.RequestedDate),
                                IssuedDate: "",
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),

                            },
                        });
                    });

                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Issuance",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Stockissuanceformdatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    RefreshLogdetails();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        function ClearForm() {
            $scope.ReferenceNo = '';
            $scope.UniqueID = '';
            $scope.To = '';
            $scope.EmployeeID = '';
            $scope.StoreID = '';
            $scope.CustomerID = '';
            $scope.ThirdPartyName = '';
            $scope.Purpose = '';
            $scope.Remarks = '';
            $scope.Status = '';
            $scope.StatusID = '';
            $scope.Stockissuancedatas = '';
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Stock.aspx?ID=" + PId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        //$http.get( $rootScope.WebURL + "/Workflow")
        //.then(function (Workflowdata) {
        //    $scope.Workflowdatas = Workflowdata.data.data;
        //});



        //$http.get( $rootScope.WebURL + "/employee")
        //.then(function (Employeedata) {
        //    $scope.Employeedatas = Employeedata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/store")
        //.then(function (Storedata) {
        //    $scope.Storedatas = Storedata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/customer")
        //.then(function (Customerdata) {
        //    $scope.Customerdatas = Customerdata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/product")
        //.then(function (Productdata) {
        //    $scope.Productdatas = Productdata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/goods")
        //.then(function (Goodsdata) {
        //    $scope.Goodsdatas = Goodsdata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/goodsunique")
        //.then(function (Goodsuniquedata) {
        //    $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/stockreturn")
        //.then(function (Stockreturndata) {
        //    $scope.Stockreturndatas = Stockreturndata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/stockissuanceform")
        //.then(function (Stockissuanceformdata) {

        //    $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
        //});

        //function RefreshGrid() {
        //    $http.get( $rootScope.WebURL + "/stockissuanceform")
        //   .then(function (Stockissuanceformdata) {
        //       $scope.Stockissuanceformdatas = Stockissuanceformdata.data.data;
        //   });
        //}

        //function RefreshUniqueGoodsGrid() {

        //    $http.get( $rootScope.WebURL + "/goodsunique")
        // .then(function (Goodsuniquedata) {
        //     $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
        // });
        //}

        //function RefreshStocksReturnGrid() {
        //    $http.get( $rootScope.WebURL + "/stockreturn")
        //        .then(function (Stockreturndata) {
        //            $scope.Stockreturndatas = Stockreturndata.data.data;
        //        });
        //}



        $scope.PrintStock = function (invoice, UID) {

            $scope.PrintID = UID;

            var StockissuanceformArray = $scope.Stockissuanceformdatas;
            var item = StockissuanceformArray.filter(function (item) {
                return item._id === UID;
            })[0];

            $scope.id = item._id;
            $scope.ReferenceNo = item.ReferenceNo;
            $scope.UniqueID = item.UniqueID;
            $scope.To = item.To;
            $scope.EmployeeID = item.EmployeeID;
            $scope.StoreID = item.StoreID;
            $scope.CustomerID = item.CustomerID;
            $scope.ThirdPartyName = item.ThirdParty;
            $scope.Purpose = item.Purpose;
            $scope.Remarks = item.Remarks;
            if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                $scope.QRCode = decode_base64(item.QRCode);
            }
            $scope.Status = item.Status;
            $scope.StatusID = parseInt(item.StatusID);
            $scope.RequestedDate = new Date(item.RequestedDate);
            $scope.RequestedByName = item.ThirdParty;

            angular.forEach($scope.Employeedatas, function (value1) {
                if ($scope.EmployeeID == value1.id) {
                    $scope.RequestedByName = value1.EmployeeName;
                }
            });
            angular.forEach($scope.Storedatas, function (value2) {
                if ($scope.StoreID == value2._id) {
                    $scope.RequestedByName = value2.StoreName;
                    $scope.RequestedStoreName = value2.StoreName;
                }
            });
            angular.forEach($scope.Customerdatas, function (value3) {
                if ($scope.CustomerID == value3.id) {
                    $scope.RequestedByName = value3.CompanyName;
                }
            });

            RefreshStocksGrid();

            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }


    }

})();


(function () {
    "use strict";

    angular.module("app.procurement.stock.EquipmentReturn", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.stock_EquipmentReturn", {
            url: "/EquipmentReturn",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/apps/procurement/stock/EquipmentReturn/EquipmentReturn.html",
                    controller: "EquipmentReturnController as vm",
                },
            },
        });
    }
})();
(function () {
    "use strict";

    angular.module("app.procurement.stock.Equipment", []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state("app.stock_Equipment", {
            url: "/Equipment",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/apps/procurement/stock/Equipment/Equipment.html",
                    controller: "EquipmentController as vm"
                }
            }
        });
    }
})();
(function () {
    "use strict";

    angular
        .module("app.procurement.stock.Equipment")
        .controller("EquipmentReturnController", EquipmentReturnController);

    /** @ngInject */
    function EquipmentReturnController(
        $mdDateLocale,
        $scope,
        $rootScope,
        $interval,
        $mdSidenav,
        $mdToast,
        $location,
        $mdDialog,
        $document,
        $http,
        $log,
        NgMap,
        Upload
    ) {
        document.getElementsByTagName("title")[0].text =
            "Procurement-Technician Inventory";
        var chkAceses = localStorage.getItem("pages");
        var EmpID = localStorage.getItem("EmployeeID");
        if (chkAceses.indexOf("Stores") > -1) {
            // do nothing
        }
        // else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log("markers", map.markers);
            console.log("shapes", map.shapes);
        });

        var Client_Id = localStorage.getItem("Client_Id");
        $rootScope.createdName = localStorage.getItem("UserName");
        $rootScope.LoginID = localStorage.getItem("LoginID");

        $scope.Storeform = false;
        $scope.AddEquipmentform = false;
        $scope.EquipmentInfo = false;
        $scope.Storegrid = true;
        $scope.Equipmentform = false;
        $scope.sExport = true;
        $scope.sAdd = true;
        $scope.sView = false;

        $scope.Showgrid = function () {
            $scope.Storegrid = true;
            $scope.Equipmentform = false;
            $scope.sExport = true;
            $scope.sAdd = true;
            $scope.sView = false;
        };

        $scope.AddEquipment = function () {
            $scope.Storegrid = false;
            $scope.Equipmentform = true;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sView = true;
            $scope.EquipmentItemdatas = [];
            try {
                $scope.vm.RequestedBy = null;
                $scope.vm.JobPosition = null;
                $scope.vm.ContactNumber = null;
                $scope.vm.RequestedDate = new Date();
                $scope.vm.Remarks = "";
                $scope.vm.VehicleNumber = "";
                $scope.vm.AssignedTo = null;
            } catch (e) { }
        };

        $scope.getEmployeedetails = function (EmployeeID) {
            var item = $scope.Employeedatas.filter(function (item) {
                return item.EmployeeID == EmployeeID;
            })[0];
            $scope.vm.RequestedBy = item.EmployeeID + "-" + item.EmployeeName;
            $scope.EmployeeID = EmployeeID;
            $scope.vm.JobPosition = item.EDesignation;
            $scope.vm.ContactNumber = item.Mobile;
        };

        var vm = this;
        var dataGrid;

        vm.dataGridOptions = {
            onInitialized: function (e) {
                dataGrid = e.component;
                RefreshGrid();
            },

            dataSource: $scope.Equipmentdatas,
            allowColumnReordering: true,
            showBorders: true,
            bindingOptions: {
                // grouping: "grouping",
                dataSource: "Equipmentdatas",
            },
            // grouping: {
            //     autoExpandAll: false
            // },
            searchPanel: {
                visible: true,
            },
            paging: {
                pageSize: 30,
            },
            groupPanel: {
                visible: true,
            },
            columns: [
                {
                    caption: "Inventory Code",
                    dataField: "Code",
                    cellTemplate: function (container, options) {
                        $(
                            "<p style='color:blue;cursor: pointer;'>" +
                            options.data.Code +
                            "</p>"
                        ).appendTo(container);
                    },
                },
                {
                    caption: "Product Name",
                    dataField: "EquipmentName",
                },
                {
                    caption: "Serial Number",
                    dataField: "SerialNumber",
                },
                {
                    caption: "Technician Name",
                    dataField: "EquipmentGivenTo",
                    groupIndex: 0,
                },
                {
                    dataField: "UpdatedDate",
                    caption: "Updated Date",
                    width: "150",
                    dataType: "datetime",
                    format: "dd/MM/yyyy",
                },
                {
                    caption: "Return",
                    width: "70",
                    fixed: false,
                    fixedPosition: "right",
                    alignment: "center",
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $("<div style:border:none/>")
                            .dxButton({
                                icon: "revert",
                                onClick: function (e) {
                                    $scope.ReturnEquipment(options.data._id);
                                },
                            })
                            .appendTo(container);
                    },
                },
            ],
            onCellClick: function (data) {
                if (data.column.caption == "Inventory Code") {
                    $scope.Storeinfo(data.data);
                }
            },
        };

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Store.xlsx",{headers:true}) FROM ?', [
                $scope.Equipmentdatas,
            ]);
        };

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Equipment/EquipmentReturn",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Equipmentdatas = Storedata.data.data;
            });

            $http({
                url: $rootScope.WebURL + "/equipment",
                method: "POST",
                data: { Client_Id: Client_Id },
            }).then(function (Unitdata) {
                $scope.EquipmentListName = _.uniqBy(
                    Unitdata.data.data,
                    "EquipmentName"
                );
                var item = Unitdata.data.data.filter(function (item) {
                    return item.Quantity === 1;
                });
                $scope.AllEquipmentdatas = item;
            });
        }

        $scope.AddERecord = function (e, Type) {
            $mdDialog.show({
                templateUrl:
                    "app/main/apps/procurement/stock/EquipmentReturn/ServicePop.html",
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function EquipmentReturnController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
            });
            if (Type == "Record") {
                $scope.vm.Title = "Record Log";
                $scope.Record = true;
                $scope.Service = false;
                $scope.vm.Date = null;
                $scope.vm.TechnicianName = null;
                $scope.vm.TechnicianId = null;
                $scope.vm.Contact = null;
                $scope.vm.FileName = null;
            } else {
                $scope.vm.Title = "Service Log";
                $scope.Record = false;
                $scope.Service = true;
                $scope.vm.SDate = null;
                $scope.vm.ServicedFor = null;
                $scope.vm.Remarks = null;
                $scope.vm.FileName1 = null;
            }
        };

        $scope.AGUpload = function (fileInput) {
            var input = angular.element(document.querySelector("#" + fileInput));
            input[0].click();
            var Name = "";
            input.bind("change", function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == "fileInput") $scope.vm.FileName = Name;
            else $scope.vm.FileName1 = Name;
        };
        $scope.ServiceSubmit = function () {
            var file = angular.element(document.querySelector("#fileInput1"))[0]
                .files[0]
                ? angular.element(document.querySelector("#fileInput1"))[0].files
                : [];
            AddAttachment(file, "Service");
            if (file.length == 0) {
                $scope.ServiceLogdetails.push({
                    ServiceDate: $scope.vm.SDate,
                    ServiceFor: $scope.vm.ServicedFor,
                    DocumentName: "",
                    Remarks: $scope.vm.Remarks,
                    Status: "New",
                    GUID: null,
                });
                $scope.ReturnEquip = true;
            }
            $mdDialog.cancel();
        };
        function AddAttachment(file, Type) {
            if (file.length != 0 && file.length != undefined) {
                var upfile = file[0];
                var response1 = Upload.upload({
                    url: $rootScope.WebURL + "/Equipment/upload",
                    data: { file: upfile },
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME;
                    $scope.fileName = resp.data.data[0].OriginalFileName;
                    $scope.fileSize = resp.data.data[0].Size;
                    $scope.Path = resp.data.data[0].Path;
                    $scope.fileType = resp.data.data[0].Type;
                    if (resp.data.message == "Successfully Uploaded") {
                        if (Type == "Service") {
                            $scope.ServiceLogdetails.push({
                                ServiceDate: $scope.vm.SDate,
                                ServiceFor: $scope.vm.ServicedFor,
                                UploadDocument: $scope.vm.FileName1,
                                Remarks: $scope.vm.Remarks,
                                GUID: $scope.TableID,
                            });
                        } else {
                            $scope.Recorddetails.push({
                                Date: $scope.vm.Date,
                                TechnicianName: $scope.vm.TechnicianName,
                                TechnicianId: $scope.vm.TechnicianId,
                                TechnicianContact: $scope.vm.Contact,
                                UploadDocument: $scope.vm.FileName,
                                GUID: $scope.TableID,
                            });
                        }
                        var response2 = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "EquipmentList",
                                // FileID: Id,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response2.then(function (GList) { });
                    }
                });
            }
        }

        $scope.BindAttach = function (fileInput) {
            var input = angular.element(document.querySelector("#" + fileInput));
            var Name = input[0].files[0].name;
            input.bind("change", function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == "fileInput") $scope.vm.FileName = Name;
            else $scope.vm.FileName1 = Name;
        };
        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                if (
                    $scope.ServiceLogdetails.filter(function (item) {
                        return item.Status == "New";
                    }).length > 0
                ) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/service",
                        data: {
                            _id: $scope.SID,
                        },
                    });
                } else {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/servicereturn",
                        data: {
                            _id: $scope.SID,
                        },
                    });
                }
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/Equipment/update",
                    data: {
                        _id: $scope.SID,
                        Category: $scope.Category,
                        EquipmentName: $scope.EquipmentName,
                        Manufacturer: $scope.Manufacturer,
                        SerialNumber: $scope.SerialNumber,
                        Brand: $scope.Brand,
                        PurchasedDate: $scope.PurchasedDate,
                        Location: $scope.Location,
                        Remarks: $scope.Remarks,
                        RecordLogdetails: $scope.Recorddetails,
                        ServiceLogdetails: $scope.ServiceLogdetails,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(
                    function (GList) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Successfully Updated!")
                                .position("top center")
                        );
                        RefreshGrid();
                        $scope.Showgrid();
                    },
                    function () {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Something entered gone wrong,please try again !")
                                .position("top center")
                        );
                    }
                );
            }
        };

        $scope.Storeinfo = function (item, $index) {
            try {
                $scope.id = item._id;
                $scope.vm.Code = item.Code;
                $scope.vm.Category = item.Category;
                $scope.vm.EquipmentName = item.EquipmentName;
                $scope.vm.Manufacturer = item.Manufacturer;
                $scope.vm.SerialNumber = item.SerialNumber;
                $scope.vm.Brand = item.Brand;
                $scope.vm.PurchasedDate = item.PurchasedDate;
                $scope.vm.Location = item.EquipmentGivenTo;
                $scope.vm.Remarks = item.Remarks;
                $scope.ServiceLogdetails = item.ServiceLogdetails;
                $scope.Recorddetails = item.RecordLogdetails;
                if (item.Quantity == -1) $scope.ReturnEquip = true;
                else $scope.ReturnEquip = false;
                $mdDialog.show({
                    templateUrl:
                        "app/main/apps/procurement/stock/EquipmentReturn/EquipmentInfo.html",
                    parent: angular.element($document.body),
                    multiple: true,
                    scope: $scope.$new(),
                    clickOutsideToClose: false,
                    controller: function EquipmentReturnController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        };
                    },
                });
            } catch (err) { }
        };

        $scope.ReturnEquipment = function (id) {
            var result = DevExpress.ui.dialog.confirm(
                "Do you wish to Return this Equipment back to stock ?",
                "Confirm Changes"
            );
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/StockReturn",
                        data: { _id: id },
                    });
                    response.then(function (Storedata) {
                        RefreshGrid();
                    });
                }
            });
        };

        $scope.AddRecord = function (e) {
            $mdDialog.show({
                templateUrl:
                    "app/main/apps/procurement/stock/EquipmentReturn/EquipmentAdd.html",
                parent: angular.element($document.body),
                targetEvent: e,
                multiple: true,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function EquipmentReturnController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
            });
            $scope.ViewTable = false;
            $scope.vm.Equipment = null;
            $scope.vm.dDescription = null;
            $scope.vm.Stock = null;
            $scope.vm.Quantity = null;
            $scope.EquipmentSeraildatas = [];
        };

        $scope.Equipmentdelete = function (Index) {
            $scope.EquipmentItemdatas.splice(Index, 1);
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        var response = $http({
            url: $rootScope.WebURL + "/unit",
            method: "POST",
            data: { Client_Id: Client_Id },
        });
        response.then(function (Unitdata) {
            $scope.Unitdatas = Unitdata.data.data;
        });

        $http({
            url: $rootScope.WebURL + "/employee/detailsforTab",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Unitdata) {
            $scope.Employeedatas = Unitdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/supplier",
            data: { Client_Id: Client_Id },
        }).then(function (Supplierdata) {
            $scope.Supplierdatas = Supplierdata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
        });

        $scope.getEquipmentSerialumber = function (EquipmentName) {
            var item = $scope.AllEquipmentdatas.filter(function (item) {
                return item.EquipmentName === EquipmentName && item.Quantity == 1;
            });
            $scope.EquipmentSeraildatas = item;
            $scope.vm.Stock = $scope.EquipmentSeraildatas.length;
            $scope.vm.Quantity = 0;
        };

        $scope.saveEquipment = function () {
            $scope.EqLogdetails = [];
            angular.forEach(vm.dDescription, function (value) {
                $scope.EquipmentItemdatas.push({
                    EquipmentName: value.EquipmentName,
                    Code: value.Code,
                    Manufacturer: value.Manufacturer,
                    SerialNumber: value.SerialNumber,
                    ItemId: value.id,
                });
                $scope.EqLogdetails = $scope.EqLogdetails.concat(
                    value.RecordLogdetails
                );
            });
            $scope.vm.Category = null;
            $scope.vm.EquipmentName = null;
            $scope.vm.Manufacturer = null;
            $scope.vm.SerialNumber = null;
            $scope.vm.ProductCode = null;
            $scope.Equipmentsdata = [];
            $scope.EUpdate = false;
            $scope.EquipmentItemdatas = _.uniqBy($scope.EquipmentItemdatas, "ItemId");
            $mdDialog.cancel();
        };

        $scope.fsubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/equipmentrequest/add",
                data: {
                    RequestedBy: $scope.EmployeeID,
                    ReferenceNo: $scope.vm.Reference,
                    RequestedDate: $scope.vm.RequestedDate,
                    Remarks: $scope.vm.Remarks,
                    VehicleNumber: $scope.vm.VehicleNumber,
                    ContactNumber: $scope.vm.ContactNumber,
                    TeamID: $scope.vm.AssignedTo,
                    JobPosition: $scope.vm.JobPosition,
                    EquipmentItems: $scope.EquipmentItemdatas,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby,
                },
            });

            response.then(
                function (GList) {
                    $scope.SID = GList.data.data.id;
                    try {
                        var data = [];
                        var EquipmentLog = [];
                        EquipmentLog.push({
                            Date: new Date(),
                            TechnicianName: $scope.vm.RequestedBy,
                            TechnicianContact: $scope.vm.ContactNumber,
                        });
                        EquipmentLog = EquipmentLog.concat($scope.EqLogdetails);
                        angular.forEach($scope.EquipmentItemdatas, function (item) {
                            data.push(item.ItemId);
                        });
                        var response1 = $http({
                            method: "POST",
                            url:

                                $rootScope.WebURL +
                                "/equipmentrequest/newrequestchange",
                            data: {
                                _id: $scope.SID,
                                EquipmentList: data,
                                RequestedBy: $scope.vm.RequestedBy,
                                EmployeeName: $scope.vm.RequestedBy,
                                Mobile: $scope.vm.ContactNumber,
                                RecordLogdetails: EquipmentLog,
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response1.then(function (Glist) {
                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .textContent("Successfully Added!")
                                    .position("top center")
                            );
                            RefreshGrid();
                            $scope.Showgrid();
                        });
                    } catch (error) { }
                },
                function () {
                    $mdToast.show(
                        $mdToast
                            .simple()
                            .textContent("Something entered gone wrong,please try again !")
                            .position("top center")
                    );
                }
            );
        };

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#search");

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: "simple",
            autoWidth: false,
            responsive: true
            //stateSave: true,
            //destroy: true
        };
        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: "",

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#search");

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: "simple",
            autoWidth: false,
            responsive: true
            //stateSave: true,
            //destroy: true
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "";
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("app.procurement.stock.Equipment")
        .controller("EquipmentController", EquipmentController);

    /** @ngInject */
    function EquipmentController(
        $mdDateLocale,
        $scope,
        $rootScope,
        $interval,
        $mdSidenav,
        $mdToast,
        $location,
        $mdDialog,
        $document,
        $http,
        $log,
        NgMap,
        Upload
    ) {
        document.getElementsByTagName("title")[0].text =
            "Procurement-Equipment Inventory";
        var chkAceses = localStorage.getItem("pages");
        if (chkAceses.indexOf("Stores") > -1) {
            // do nothing
        }
        // else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log("markers", map.markers);
            console.log("shapes", map.shapes);
        });

        var Client_Id = localStorage.getItem("Client_Id");
        $rootScope.createdName = localStorage.getItem("UserName");
        $rootScope.LoginID = localStorage.getItem("LoginID");

        $scope.Storeform = false;
        $scope.AddEquipmentform = false;
        $scope.EquipmentInfo = false;
        $scope.Storegrid = true;
        $scope.sExport = true;
        $scope.sAdd = true;
        $scope.sSearch = true;
        $scope.sView = false;
        $scope.EqView = false;

        $scope.Equipmentdatas = [];
        RefreshGrid();
        RefreshEmployeeGrid();

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = "";
            $scope.vm.searchTerm2 = "";
        };

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Store.xlsx",{headers:true}) FROM ?', [
                $scope.Equipmentdatas,
            ]);
        };

        function pad(n, width, z) {
            z = z || "0";
            n = n + "";
            return n.length >= width
                ? n
                : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();

            var y = $scope.Equipmentdatas.length + 1;

            var Code = "E-" + String(y).padStart(5, 0);
            $scope.Code = Code;
            $scope.Update = false;
            $scope.Storeform = false;
            $scope.AddEquipmentform = true;
            $scope.Storegrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.EquipmentInfo = false;
            $scope.sSearch = false;
            $scope.sView = true;
            $scope.EqView = false;
            $scope.Supplier = null;
            $scope.vm.dDescription = null;
            $scope.PurchasedDate = null;
            $scope.SerialNumber = null;
            $scope.Brand = null;
            $scope.Location = null;
            $scope.Remarks = null;
            $scope.ServiceLogdetails = [];
            $scope.Recorddetails = [];
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        };

        $scope.Showgrid = function () {
            $scope.Storegrid = true;
            $scope.Storeform = false;
            $scope.AddEquipmentform = false;
            $scope.EquipmentInfo = false;
            $scope.sExport = true;
            $scope.sAdd = true;
            $scope.sView = false;
            $scope.EqView = false;
            $scope.sSearch = true;
        };
        $scope.ShowEquipmentGrid = function () {
            $scope.Storegrid = false;
            $scope.Storeform = false;
            $scope.AddEquipmentform = false;
            $scope.EquipmentInfo = true;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sView = true;
            $scope.EqView = false;
            $scope.sSearch = false;
        };
        $scope.ReturnEquipment = function () {
            var result = DevExpress.ui.dialog.confirm(
                "Are you sure you want to return this Equipment to Store?",
                "Confirm changes"
            );
            result.done(function (dialogResult) {
                if (dialogResult) {
                    $scope.ReturnEquip = false;
                    angular.forEach($scope.ServiceLogdetails, function (item) {
                        item.Status = "Completed";
                    });
                }
            });
        };

        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                if (
                    $scope.ServiceLogdetails.filter(function (item) {
                        return item.Status == "New";
                    }).length > 0
                ) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/service",
                        data: {
                            _id: $scope.SID,
                        },
                    });
                } else {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/servicereturn",
                        data: {
                            _id: $scope.SID,
                        },
                    });
                }
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/Equipment/update",
                    data: {
                        _id: $scope.SID,
                        Category: $scope.Category,
                        EquipmentName: $scope.EquipmentName,
                        Manufacturer: $scope.Manufacturer,
                        SerialNumber: $scope.SerialNumber,
                        Brand: $scope.Brand,
                        PurchasedDate: $scope.PurchasedDate,
                        Location: $scope.Location,
                        Remarks: $scope.Remarks,
                        RecordLogdetails: $scope.Recorddetails,
                        ServiceLogdetails: $scope.ServiceLogdetails,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(
                    function (GList) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Successfully Updated!")
                                .position("top center")
                        );
                        RefreshGrid();
                        $scope.Showgrid();
                    },
                    function () {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Something entered gone wrong,please try again !")
                                .position("top center")
                        );
                    }
                );
            } else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/Equipment/add",
                    data: {
                        Client_Id: Client_Id,
                        Code: $scope.Code,
                        Category: $scope.Category,
                        EquipmentName: $scope.EquipmentName,
                        Manufacturer: $scope.Manufacturer,
                        SerialNumber: $scope.SerialNumber,
                        Brand: $scope.Brand,
                        PurchasedDate: $scope.PurchasedDate,
                        Location: $scope.Location,
                        Remarks: $scope.Remarks,
                        RecordLogdetails: $scope.Recorddetails,
                        ServiceLogdetails: $scope.ServiceLogdetails,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(
                    function (GList) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Successfully Added!")
                                .position("top center")
                        );
                        RefreshGrid();
                        $scope.Showgrid();
                    },
                    function () {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Something entered gone wrong,please try again !")
                                .position("top center")
                        );
                    }
                );
            }
        };

        $scope.DeleteEquipment = function (DelId) {
            $scope.DelEqId = DelId;
            var result = DevExpress.ui.dialog.confirm(
                "Are you sure you want to delete the Equipment?",
                "Confirm"
            );
            result.done(function (item) {
                if (item == true) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/Equipment/deleteEquipment",
                        data: { _id: $scope.DelEqId },
                    });
                    response.then(function (Storedata) {
                        $scope.EquipmentListdatas = Storedata.data.data;
                        RefreshGrid();
                    });
                }
            });
        };

        $scope.Storeinfo = function (StoreId, $index) {
            $scope.IndxID = $index;
            $scope.SID = StoreId;
            $scope.Update = true;
            $scope.Storeform = true;
            $scope.AddEquipmentform = false;
            $scope.EquipmentInfo = false;
            $scope.Storegrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = false;
            $scope.EqView = true;
            try {
                var StoreArray = $scope.EquipmentListdatas;
                var item = StoreArray.filter(function (item) {
                    return item.id === StoreId;
                })[0];
                $scope.id = item.id;
                $scope.Code = item.Code;
                $scope.Category = item.Category;
                $scope.EquipmentName = item.EquipmentName;
                $scope.Manufacturer = item.Manufacturer;
                $scope.SerialNumber = item.SerialNumber;
                $scope.Brand = item.Brand;
                $scope.PurchasedDate = item.PurchasedDate;
                $scope.Location = item.EquipmentGivenTo;
                $scope.Remarks = item.Remarks;
                $scope.ServiceLogdetails = item.ServiceLogdetails;
                $scope.Recorddetails = item.RecordLogdetails;
                if (item.Quantity == -1) $scope.ReturnEquip = true;
                else $scope.ReturnEquip = false;
            } catch (err) { }
        };

        $scope.EquipmentInfoR = function (EquipmentID, row) {
            // $scope.IndxID = $index;
            $scope.SID = EquipmentID;
            $scope.Update = true;
            $scope.Storeform = false;
            $scope.EquipmentInfo = true;
            $scope.AddEquipmentform = false;
            $scope.Storegrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = true;
            $scope.EqView = false;
            $scope.vm.EquipmentCode = row.EquipmentCode;
            $scope.vm.TotalStock = row.TotalStock;
            $scope.vm.EquipmentName = row.EquipmentName;
            $scope.vm.SupplierName = row.SupplierName;
            $scope.vm.ThresholdLevel = row.ThresholdLevel;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Equipment/getEquipmentbyItemId",
                data: { Client_Id: Client_Id, ItemId: EquipmentID },
            });
            response.then(function (Storedata) {
                $scope.EquipmentListdatas = Storedata.data.data;
            });
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/deliverynotedetail/getByItemID",
                data: { ItemId: EquipmentID },
            });
            response.then(function (Storedata) {
                var PurchaseHistory = [];
                angular.forEach(Storedata.data.data, function (value) {
                    PurchaseHistory.push(value.DeliveryOrderdetails);
                });
                $scope.PurchaseHistory = _.uniqBy(PurchaseHistory, _.isEqual);
            });
        };

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Equipment/getEquipmentStockList",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Equipmentdatas = Storedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function ClearForm() {
            $scope.Category = "";
            $scope.EquipmentName = "";
            $scope.Manufacturer = "";
            $scope.SerialNumber = "";
            $scope.Brand = "";
            $scope.PurchasedDate = new Date();
            $scope.Location = "";
            $scope.Remarks = "";
        }

        $scope.AddRecord = function (e, Type) {
            $mdDialog.show({
                templateUrl:
                    "app/main/apps/procurement/stock/Equipment/ServicePop.html",
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EquipmentController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
            });
            if (Type == "Record") {
                $scope.vm.Title = "Record Log";
                $scope.Record = true;
                $scope.Service = false;
                $scope.vm.Date = null;
                $scope.vm.TechnicianName = null;
                $scope.vm.TechnicianId = null;
                $scope.vm.Contact = null;
                $scope.vm.FileName = null;
            } else {
                $scope.vm.Title = "Service Log";
                $scope.Record = false;
                $scope.Service = true;
                $scope.vm.SDate = null;
                $scope.vm.ServicedFor = null;
                $scope.vm.Remarks = null;
                $scope.vm.FileName1 = null;
            }
        };

        $scope.AGUpload = function (fileInput) {
            var input = angular.element(document.querySelector("#" + fileInput));
            input[0].click();
            var Name = "";
            input.bind("change", function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == "fileInput") $scope.vm.FileName = Name;
            else $scope.vm.FileName1 = Name;
        };
        $scope.BindAttach = function (fileInput) {
            var input = angular.element(document.querySelector("#" + fileInput));
            var Name = input[0].files[0].name;
            input.bind("change", function (e) {
                $scope.$apply(function () {
                    var files = e.target.files;
                    if (files[0]) {
                        Name = files[0].name;
                    }
                });
            });
            if (fileInput == "fileInput") $scope.vm.FileName = Name;
            else $scope.vm.FileName1 = Name;
        };

        $scope.RecordSubmit = function () {
            var file = angular.element(document.querySelector("#fileInput"))[0]
                .files[0]
                ? angular.element(document.querySelector("#fileInput"))[0].files
                : [];
            AddAttachment(file, "Record");
            if (file.length == 0) {
                $scope.Recorddetails.push({
                    Date: $scope.vm.Date,
                    TechnicianName: $scope.vm.TechnicianName,
                    TechnicianId: $scope.vm.TechnicianId,
                    TechnicianContact: $scope.vm.Contact,
                    UploadDocument: "",
                    GUID: null,
                });
            }
            $mdDialog.cancel();
        };

        $scope.ServiceSubmit = function () {
            var file = angular.element(document.querySelector("#fileInput1"))[0]
                .files[0]
                ? angular.element(document.querySelector("#fileInput1"))[0].files
                : [];
            AddAttachment(file, "Service");
            if (file.length == 0) {
                $scope.ServiceLogdetails.push({
                    ServiceDate: $scope.vm.SDate,
                    ServiceFor: $scope.vm.ServicedFor,
                    DocumentName: "",
                    Remarks: $scope.vm.Remarks,
                    Status: "New",
                    GUID: null,
                });
                $scope.ReturnEquip = true;
            }
            $mdDialog.cancel();
        };
        function AddAttachment(file, Type) {
            if (file.length != 0 && file.length != undefined) {
                var upfile = file[0];
                var response1 = Upload.upload({
                    url: $rootScope.WebURL + "/Equipment/upload",
                    data: { file: upfile },
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME;
                    $scope.fileName = resp.data.data[0].OriginalFileName;
                    $scope.fileSize = resp.data.data[0].Size;
                    $scope.Path = resp.data.data[0].Path;
                    $scope.fileType = resp.data.data[0].Type;
                    if (resp.data.message == "Successfully Uploaded") {
                        if (Type == "Service") {
                            $scope.ServiceLogdetails.push({
                                ServiceDate: $scope.vm.SDate,
                                ServiceFor: $scope.vm.ServicedFor,
                                UploadDocument: $scope.vm.FileName1,
                                Remarks: $scope.vm.Remarks,
                                GUID: $scope.TableID,
                            });
                        } else {
                            $scope.Recorddetails.push({
                                Date: $scope.vm.Date,
                                TechnicianName: $scope.vm.TechnicianName,
                                TechnicianId: $scope.vm.TechnicianId,
                                TechnicianContact: $scope.vm.Contact,
                                UploadDocument: $scope.vm.FileName,
                                GUID: $scope.TableID,
                            });
                        }
                        var response2 = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "EquipmentList",
                                FileID: $scope.SID,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response2.then(function (GList) { });
                    }
                });
            }
        }

        $scope.NewSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Equipment/add",
                data: {
                    Client_Id: Client_Id,
                    Code: $scope.Code,
                    // Category: $scope.Category,
                    EquipmentName: $scope.vm.dDescription,
                    ItemId: $scope.ItemId,
                    SupplierID: $scope.Supplier,
                    Manufacturer: $scope.SupplierName,
                    SerialNumber: $scope.SerialNumber,
                    Brand: $scope.Brand,
                    PurchasedDate: $scope.PurchasedDate,
                    Location: $scope.Location,
                    Remarks: $scope.vm.Remarks,
                    Quantity: 1,
                    RecordLogdetails: [],
                    ServiceLogdetails: [],
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (Glist) {
                if (Glist.data.message == "Existing Equipment Name") {
                    $mdToast.show(
                        $mdToast
                            .simple()
                            .textContent("Existing Serial Number!")
                            .position("top center")
                    );
                } else {
                    $mdToast.show(
                        $mdToast
                            .simple()
                            .textContent("Successfully Added!")
                            .position("top center")
                    );
                    RefreshGrid();
                    $scope.Showgrid();
                }
            });
        };

        var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/supplier",
            data: {
                Client_Id: Client_Id
            },
        });
        response.then(function (Supplierdata) {
            $scope.Supplierdatas = Supplierdata.data.data;
        });

        $scope.getSupplierItems = function (UniquId, Name) {
            var response = $http({
                url: $rootScope.WebURL + "/supplieritems/getByRequestID",
                method: "POST",
                data: { RequestID: UniquId },
            });
            response.then(function (Supplierbillingaddressdata) {
                var item = Supplierbillingaddressdata.data.data.filter(function (item) {
                    return item.Category === "Equipment";
                });
                $scope.SupplierItemdatas = item;
            });
            $scope.SupplierName = Name;
        };

        $scope.getItemDetails = function (data) {
            $scope.ItemId = data._id;
            $scope.Code = data.ItemCode;
            $scope.ItemCategory = data.Category;
            $scope.Threshold = data.ThresholdLevel;
            $scope.MinimumOrder = data.MinimumOrder;
            $scope.Unit = data.Unit;
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        var response = $http({
            url: $rootScope.WebURL + "/employee/detailsforTab",
            method: "POST",
            data: { Client_Id: Client_Id },
        });
        response.then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#search");

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: "simple",
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };
        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: "",

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#search");

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: "simple",
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "";
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.Chemical', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.stock_Chemical', {
            url: '/Chemical',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/stock/Chemical/Chemical.html',
                    controller: 'ChemicalController as vm'
                }
            }
        });
    }

})();
(function () {
  "use strict";

  angular
    .module("app.procurement.stock.Chemical")
    .controller("ChemicalController", ChemicalController);

  /** @ngInject */
  function ChemicalController(
    $mdDateLocale,
    $scope,
    $rootScope,
    $interval,
    $mdSidenav,
    $mdToast,
    $location,
    $mdDialog,
    $document,
    $http,
    $log,
    NgMap
  ) {
    // var chkAceses = localStorage.getItem('pages');
    // if (chkAceses.split(",").includes("Stores")) {   // do nothing
    // }
    // else { $location.path("NoAccess"); }
    document.getElementsByTagName("title")[0].text =
      "Procurement-Chemical Inventory";

    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log("markers", map.markers);
      console.log("shapes", map.shapes);
    });

    var vm = this;
    $scope.selectedtab = "instock";
    var Client_Id = localStorage.getItem("Client_Id");
    $rootScope.createdName = localStorage.getItem("UserName");
    $rootScope.LoginID = localStorage.getItem("LoginID");

    $scope.Storeform = false;
    $scope.ChemicalAdd = false;
    $scope.Storegrid = true;
    $scope.sExport = true;
    $scope.sAdd = true;
    $scope.sSearch = true;
    $scope.sView = false;

    RefreshGrid();
    RefreshEmployeeGrid();

    $scope.clearSearchTerm = function () {
      $scope.vm.searchTerm1 = "";
      $scope.vm.searchTerm2 = "";
    };

    $scope.Export = function () {
      alasql('SELECT * INTO XLSX("Store.xlsx",{headers:true}) FROM ?', [
        $scope.Chemicaldatas,
      ]);
    };

    function pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    }

    $scope.Add = function () {
      ClearForm();

      var y = $scope.Chemicaldatas.length + 1;

      var Code = "C-" + String(y).padStart(5, 0);
      $scope.Code = Code;
      $scope.Update = false;
      $scope.Storeform = false;
      $scope.ChemicalAdd = true;
      $scope.Storegrid = false;
      $scope.sExport = false;
      $scope.sAdd = false;
      $scope.sSearch = false;
      $scope.sView = true;
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
    };

    $scope.Showgrid = function () {
      $scope.Storegrid = true;
      $scope.Storeform = false;
      $scope.ChemicalAdd = false;
      $scope.sExport = true;
      $scope.sAdd = true;
      $scope.sView = false;
      $scope.sSearch = true;
    };

    $scope.EditCurrentStock = function (id, Quantity, e) {
      $mdDialog.show({
        templateUrl: "app/main/apps/procurement/stock/Chemical/EditStock.html",
        parent: angular.element($document.body),
        multiple: true,
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function ChemicalController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        },
      });
      $scope.CID = id;
      $scope.vm.Stock = parseInt(Quantity);
    };

    var dataGrid;
    vm.dataGridContract = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.Chemicaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10,
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true,
      },
      sorting: {
        mode: "multiple",
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search...",
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          },
        },
        {
          dataField: "Picture",
          caption: "Image",
          dataType: "string",
          cellTemplate: function (container, options) {
            container.height(100);
            $("<img />")
              .height(100)
              .attr("src", options.value)
              .appendTo(container);
          },
        },
        {
          dataField: "Code",
          caption: "Chemical Code",
          width: "85",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.Code +
              "</p>"
            ).appendTo(container);
          },
        },
        {
          dataField: "ChemicalName",
          caption: "Chemical Name",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.ChemicalName +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.ChemicalName +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "Supplier",
          caption: "Supplier Name",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.Supplier +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.Supplier +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "CurrentStock",
          caption: "Current Stock",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.CurrentStock +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.CurrentStock +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "MinimumOrder",
          caption: "Minimum Order",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.MinimumOrder +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.MinimumOrder +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "Threshold",
          caption: "Threshold",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.Threshold +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.Threshold +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "threshol",
          caption: "threshol",
          visible: false,
          sortOrder: "asc",
        },
        // { dataField: "EmailSentDate", caption: "Contract Sent Date", width: "150", dataType: "datetime", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: "Edit",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  $scope.EditCurrentStock(
                    options.data._id,
                    options.data.CurrentStock,
                    e
                  );
                },
              })
              .appendTo(container);
          },
        },
        {
          caption: "Delete",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  $scope.DeleteChemical(options.data._id);
                },
              })
              .appendTo(container);
          },
        },
        {
          caption: "On-Hold",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "assets/icons/fonts/circle-stop-regular.svg",
                onClick: function (e) {
                  $scope.OnHoldId = options.data._id;
                  var result = DevExpress.ui.dialog.confirm(
                    "Are you sure you want to On-Hold the Chemical?",
                    "Confirm"
                  );
                  result.done(function (item) {
                    if (item == true) {
                      var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/chemical/onhold",
                        data: { _id: $scope.OnHoldId },
                      });
                      response.then(function (Storedata) {
                        var data = Storedata.data.data;
                        angular.forEach(data, function (item) {
                          if (
                            parseInt(item.Threshold) >
                            parseInt(item.CurrentStock)
                          ) {
                            item.threshol = 0;
                          }
                          item.Picture =
                            $scope.UploadsURL +
                            "Procurement/SupplierItems/" +
                            item.ItemId +
                            ".png";
                        });
                        data = _.sortBy(data, "threshol");
                        var data1 = data.filter(function (item) {
                          return item.Remarks == "On-Hold";
                        });
                        var data2 = data.filter(function (item) {
                          return item.Remarks == "";
                        });
                        $scope.OnHoldChemicaldatas = data1;
                        $scope.Chemicaldatas = data2;
                        if ($scope.selectedtab == "instock")
                          $scope.selecteddata = $scope.Chemicaldatas;
                        else $scope.selecteddata = $scope.OnHoldChemicaldatas;
                      });
                    }
                  });
                },
              })
              .appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "Chemicaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          Storeinfo(data.data._id);
        }
      },
    };

    var dataGrid1;
    vm.dataGridPending = {
      onInitialized: function (e) {
        dataGrid1 = e.component;
      },
      dataSource: $scope.OnHoldChemicaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10,
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true,
      },
      sorting: {
        mode: "multiple",
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search...",
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          },
        },
        {
          dataField: "Picture",
          caption: "Image",
          dataType: "string",
          cellTemplate: function (container, options) {
            container.height(100);
            $("<img />")
              .height(100)
              .attr("src", options.value)
              .appendTo(container);
          },
        },
        {
          dataField: "Code",
          caption: "Chemical Code",
          width: "85",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.Code +
              "</p>"
            ).appendTo(container);
          },
        },
        {
          dataField: "ChemicalName",
          caption: "Chemical Name",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.ChemicalName +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.ChemicalName +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "Supplier",
          caption: "Supplier Name",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.Supplier +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.Supplier +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "CurrentStock",
          caption: "Current Stock",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.CurrentStock +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.CurrentStock +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "MinimumOrder",
          caption: "Minimum Order",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.MinimumOrder +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.MinimumOrder +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "Threshold",
          caption: "Threshold",
          cellTemplate: function (container, options) {
            if (options.data.threshol == 0)
              $(
                "<p style='color:#bf0707;cursor: pointer;'>" +
                options.data.Threshold +
                "</p>"
              ).appendTo(container);
            else
              $(
                "<p style='color:black;cursor: pointer;'>" +
                options.data.Threshold +
                "</p>"
              ).appendTo(container);
          },
        },
        {
          dataField: "threshol",
          caption: "threshol",
          visible: false,
          sortOrder: "asc",
        },
        // { dataField: "EmailSentDate", caption: "Contract Sent Date", width: "150", dataType: "datetime", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: "Edit",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  $scope.EditCurrentStock(
                    options.data._id,
                    options.data.CurrentStock,
                    e
                  );
                },
              })
              .appendTo(container);
          },
        },
        {
          caption: "Delete",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  $scope.DeleteChemical(options.data._id);
                },
              })
              .appendTo(container);
          },
        },
        {
          caption: "Revert",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "revert",
                onClick: function (e) {
                  $scope.RevertID = options.data._id;
                  var result = DevExpress.ui.dialog.confirm(
                    "Are you sure you want to revert the Chemical?",
                    "Confirm"
                  );
                  result.done(function (item) {
                    if (item == true) {
                      var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/chemical/revert",
                        data: { _id: $scope.RevertID },
                      });
                      response.then(function (Storedata) {
                        var data = Storedata.data.data;
                        angular.forEach(data, function (item) {
                          if (
                            parseInt(item.Threshold) >
                            parseInt(item.CurrentStock)
                          ) {
                            item.threshol = 0;
                          }
                          item.Picture =
                            $scope.UploadsURL +
                            "Procurement/SupplierItems/" +
                            item.ItemId +
                            ".png";
                        });
                        data = _.sortBy(data, "threshol");
                        var data1 = data.filter(function (item) {
                          return item.Remarks == "On-Hold";
                        });
                        var data2 = data.filter(function (item) {
                          return item.Remarks == "";
                        });
                        $scope.OnHoldChemicaldatas = data1;
                        $scope.Chemicaldatas = data2;
                        if ($scope.selectedtab == "instock")
                          $scope.selecteddata = $scope.Chemicaldatas;
                        else $scope.selecteddata = $scope.OnHoldChemicaldatas;
                      });
                    }
                  });
                },
              })
              .appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "OnHoldChemicaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          Storeinfo(data.data._id);
        }
      },
    };

    $scope.UpdateStock = function () {
      if (
        $scope.vm.Stock == null ||
        $scope.vm.Stock == "" ||
        $scope.vm.Stock == undefined
      )
        $scope.vm.Stock = 0;
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/chemical/modifystock",
        data: { _id: $scope.CID, Stock: $scope.vm.Stock },
      });
      response.then(function (Storedata) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Updated!")
            .position("top center")
        );
        var data = Storedata.data.data;
        angular.forEach(data, function (item) {
          if (parseInt(item.Threshold) > parseInt(item.CurrentStock)) {
            item.threshol = 0;
          }
        });
        data = _.sortBy(data, "threshol");
        var data1 = data.filter(function (item) {
          return item.Remarks == "On-Hold";
        });
        var data2 = data.filter(function (item) {
          return item.Remarks == "";
        });
        $scope.OnHoldChemicaldatas = data1;
        $scope.Chemicaldatas = data2;
        if ($scope.selectedtab == "instock")
          $scope.selecteddata = $scope.Chemicaldatas;
        else $scope.selecteddata = $scope.OnHoldChemicaldatas;
      });
      $mdDialog.cancel();
    };

    $scope.DeleteChemical = function (id) {
      $scope.DelId = id;
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure you want to delete the Chemical?",
        "Confirm"
      );
      result.done(function (item) {
        if (item == true) {
          var response = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/chemical/deleteChemical",
            data: { _id: $scope.DelId },
          });
          response.then(function (Storedata) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Deleted!")
                .position("top center")
            );
            var data = Storedata.data.data;
            angular.forEach(data, function (item) {
              if (parseInt(item.Threshold) > parseInt(item.CurrentStock)) {
                item.threshol = 0;
              }
            });
            data = _.sortBy(data, "threshol");
            var data1 = data.filter(function (item) {
              return item.Remarks == "On-Hold";
            });
            var data2 = data.filter(function (item) {
              return item.Remarks == "";
            });
            $scope.OnHoldChemicaldatas = data1;
            $scope.Chemicaldatas = data2;
            if ($scope.selectedtab == "instock")
              $scope.selecteddata = $scope.Chemicaldatas;
            else $scope.selecteddata = $scope.OnHoldChemicaldatas;
          });
        }
      });
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.sSubmit = function () {
      if ($scope.Update == true) {
        $scope.IndexID = $scope.IndxID;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/chemical/update",
          data: {
            _id: $scope.SID,
            Category: $scope.Category,
            ChemicalName: $scope.ChemicalName,
            Supplier: $scope.Supplier,
            Threshold: $scope.Threshold,
            MinimumOrder: $scope.MinimumOrder,
            PurchasedDate: $scope.PurchasedDate,
            CurrentStock: $scope.CurrentStock,
            Remarks: $scope.Remarks,
            Quantity: $scope.Quantity,
            Unit: $scope.Unit,
            UpdatedBy: $rootScope.LoginID,
          },
        });
        response.then(
          function (GList) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Updated!")
                .position("top center")
            );
            RefreshGrid();
            $scope.Showgrid();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/chemical/add",
          data: {
            Client_Id: Client_Id,
            Code: $scope.Code,
            Category: $scope.Category,
            ChemicalName: $scope.ChemicalName,
            Supplier: $scope.Supplier,
            Threshold: $scope.Threshold,
            MinimumOrder: $scope.MinimumOrder,
            PurchasedDate: $scope.PurchasedDate,
            CurrentStock: $scope.CurrentStock,
            Remarks: $scope.Remarks,
            Quantity: $scope.Quantity,
            Unit: $scope.Unit,
            CreatedBy: $rootScope.LoginID,
          },
        });
        response.then(
          function (GList) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("top center")
            );
            RefreshGrid();
            $scope.Showgrid();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };

    $scope.Storeinfo = function (StoreId, $index) {
      $scope.IndxID = $index;
      $scope.SID = StoreId;
      $scope.Update = true;
      $scope.Storeform = true;
      $scope.ChemicalAdd = false;
      $scope.Storegrid = false;
      $scope.sExport = false;
      $scope.sAdd = false;
      $scope.sSearch = false;
      $scope.sView = true;
      try {
        var StoreArray = $scope.Chemicaldatas;
        var item = StoreArray.filter(function (item) {
          return item._id === StoreId;
        })[0];
        $scope.id = item._id;
        $scope.Code = item.Code;
        $scope.Category = item.Category;
        $scope.ChemicalName = item.ChemicalName;
        $scope.Supplier = item.Supplier;
        $scope.Threshold = item.Threshold;
        $scope.MinimumOrder = item.MinimumOrder;
        $scope.PurchasedDate = item.PurchasedDate;
        $scope.CurrentStock = item.CurrentStock;
        $scope.Remarks = item.Remarks;
        $scope.Quantity = item.Quantity;
        $scope.Unit = item.Unit;
        $scope.ItemId = item.ItemId;
        var response = $http({
          method: "POST",
          url:
            $rootScope.WebURL + "/deliverynotedetail/getByItemID",
          data: { ItemId: $scope.ItemId },
        });
        response.then(function (Storedata) {
          var PurchaseHistory = [];
          angular.forEach(Storedata.data.data, function (value) {
            PurchaseHistory.push(value.DeliveryOrderdetails);
          });
          $scope.PurchaseHistory = _.uniqBy(PurchaseHistory, _.isEqual);
        });
      } catch (err) { }
    };

    var response = $http({
      method: "POST",
      url: $rootScope.WebURL + "/supplier",
      data: {
        Client_Id: Client_Id,
      },
    });
    response.then(function (Supplierdata) {
      $scope.Supplierdatas = Supplierdata.data.data;
    });

    $scope.getSupplierItems = function (UniquId, Name) {
      var response = $http({
        url: $rootScope.WebURL + "/supplieritems/getByRequestID",
        method: "POST",
        data: { RequestID: UniquId },
      });
      response.then(function (Supplierbillingaddressdata) {
        var item = Supplierbillingaddressdata.data.data.filter(function (item) {
          return item.Category === "Chemical";
        });
        $scope.SupplierItemdatas = item;
      });
      $scope.SupplierName = Name;
    };

    $scope.getItemDetails = function (data) {
      $scope.ItemId = data._id;
      $scope.Code = data.ItemCode;
      $scope.ItemCategory = data.Category;
      $scope.Threshold = data.ThresholdLevel;
      $scope.MinimumOrder = data.MinimumOrder;
      $scope.Unit = data.Unit;
    };

    $scope.NewSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/chemical/addfromDo",
        data: {
          data: [
            {
              Client_Id: Client_Id,
              Code: $scope.Code,
              // Category:$scope.Category,
              ChemicalName: $scope.vm.dDescription,
              Supplier: $scope.SupplierName,
              ItemId: $scope.ItemId,
              SupplierID: $scope.Supplier,
              Threshold: $scope.Threshold,
              MinimumOrder: $scope.MinimumOrder,
              PurchasedDate: new Date(),
              Remarks: $scope.Remarks,
              Quantity: $scope.Quantity,
              Unit: $scope.Unit,
              CreatedBy: $rootScope.LoginID,
            },
          ],
        },
      });
      response.then(function (Glist) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Added!")
            .position("top center")
        );
        RefreshGrid();
        $scope.Showgrid();
      });
    };

    function RefreshGrid() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/chemical",
        data: { Client_Id: Client_Id },
      });
      response.then(function (Storedata) {
        var data = Storedata.data.data;
        angular.forEach(data, function (item) {
          if (parseInt(item.Threshold) > parseInt(item.CurrentStock)) {
            item.threshol = 0;
          }
          item.Picture =
            $scope.UploadsURL +
            "Procurement/SupplierItems/" +
            item.ItemId +
            ".png";
        });
        data = _.sortBy(data, "threshol");
        var data1 = data.filter(function (item) {
          return item.Remarks == "On-Hold";
        });
        var data2 = data.filter(function (item) {
          return item.Remarks == "";
        });
        $scope.OnHoldChemicaldatas = data1;
        $scope.Chemicaldatas = data2;
        if ($scope.selectedtab == "instock")
          $scope.selecteddata = $scope.Chemicaldatas;
        else $scope.selecteddata = $scope.OnHoldChemicaldatas;
      });
    }

    function RefreshEmployeeGrid() {
      var response = $http({
        url: $rootScope.WebURL + "/employee",
        method: "POST",
        data: { Client_Id: Client_Id },
      });
      response.then(function (Employeedata) {
        $scope.Employeedatas = Employeedata.data.data;
      });
    }
    $http({
      url: $rootScope.WebURL + "/unit",
      method: "POST",
      data: { Client_Id: Client_Id },
    }).then(function (Unitdata) {
      $scope.Unitdatas = Unitdata.data.data;
    });

    $scope.getOnHoldChemicals = function () {
      var response = $http({
        url: $rootScope.WebURL + "/chemical/getonHold",
        method: "POST",
        data: { Client_Id: Client_Id },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (item) {
          if (parseInt(item.Threshold) > parseInt(item.CurrentStock)) {
            item.threshol = 0;
          }
          item.Picture =
            $scope.UploadsURL +
            "Procurement/SupplierItems/" +
            item.ItemId +
            ".png";
        });
        $scope.OnHoldChemicaldatas = GList.data.data;
      });
    };

    $scope.Refresh = function () {
      RefreshGrid();
    };
    function ClearForm() {
      $scope.Category = "";
      $scope.ChemicalName = "";
      $scope.Supplier = "";
      $scope.Threshold = 0;
      $scope.MinimumOrder = 0;
      $scope.PurchasedDate = new Date();
      $scope.CurrentStock = 0;
      $scope.Remarks = "";
      $scope.Quantity = 0;
      $scope.Unit = "";
    }

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      //stateSave: true,
      //destroy: true
    };

    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }
  }
})();

(function () {
    'use strict';

    angular
 
        .module('app.procurement.request.purchase', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_request_purchase', {
            url: '/PurchaseApproval',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/request/purchase/purchase.html',
                    controller: 'PurchaseController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.request.purchase')
        .controller('PurchaseController', PurchaseController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });
    //.filter("htmlToPlaintext", function () {
    //    return function (input) {
    //        return input.replace(/<[^>]+>/gm, '');
    //    }
    //});

    function PurchaseController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $http, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Requests")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        RefreshGrid();
        InitialWorkflowLoading();
        RefreshSalesOrderGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });


        var PurchaseID = getParameterByName('ID');
        if (PurchaseID != null) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseform",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Purchaseformdata) {
                $scope.AllPurchaseformdatas = Purchaseformdata.data.data;
                try {
                    var item = $scope.AllPurchaseformdatas.filter(function (item) {
                        return item._id === PurchaseID;
                    })[0];
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.Employee = item.EmployeeID;
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.Supplier = item.SupplierID;
                    $scope.SupplierName = item.Supplierdetails[0].Name;
                    $scope.Store = item.StoreID;
                    $scope.StoreName = item.Storedetails[0].StoreName;
                    $scope.ClientStore = item.ClientStore;
                    $scope.WorkOrder = item.WorkOrder;
                    $scope.Date = new Date(item.Date);
                    $scope.Purpose = item.Purpose;
                    $scope.Deadline = new Date(item.Deadline);
                    $scope.Remarks = item.Remarks;
                    $scope.Currency = item.Currency;
                    $scope.SubTotal = parseFloat(item.SubTotal);
                    $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                    $scope.GST = parseFloat(item.GST);
                    $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                    $scope.Total = parseFloat(item.Total);
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.SID = PurchaseID;
                $scope.Update = true;
                $scope.Purchaseform = true;
                $scope.Purchasegrid = false;
                $scope.prExport = false;
                $scope.prSearch = false;
                $scope.prView = true;
                $scope.Purchase = true;
                $scope.NextApprovers = '';
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'Inventory Purchase Request') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'Inventory Purchase Request') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                RefreshPurchaseGrid();
                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
            });
        }
        else {
            $scope.Purchaseform = false;
            $scope.Purchasegrid = true;
            $scope.prExport = true;
            $scope.prAdd = true;
            $scope.prSearch = true;
            $scope.prView = false;
        }

        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseform/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Purchaseformdata) {
                $scope.Purchaseformdatas = Purchaseformdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseform/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Purchaseformdata) {
                $scope.Purchaseformdatas = Purchaseformdata.data.data;
            });
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("PurchaseRequests.xlsx",{headers:true}) FROM ?', [$scope.Purchaseformdatas]);
        };

        $scope.Showgrid = function () {
            $scope.Purchasegrid = true;
            $scope.Purchaseform = false;
            $scope.prExport = true;
            $scope.prView = false;
            $scope.prSearch = true;
            $scope.Purchase = false;
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
        }

        $scope.Purchaseinfo = function (PReqId, $index) {
            $scope.IndxID = $index;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.SID = PReqId;
            $scope.Update = true;
            $scope.Purchaseform = true;
            $scope.Purchasegrid = false;
            $scope.prExport = false;
            $scope.prSearch = false;
            $scope.prView = true;
            $scope.Purchase = true;
            $scope.NextApprovers = '';
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.NextLevelAction = "";

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            //RefreshGrid();

            try {
                var item = $scope.Purchaseformdatas.filter(function (item) {
                    return item._id === PReqId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.Supplier = item.SupplierID;
                $scope.SupplierName = item.Supplierdetails[0].Name;
                $scope.Store = item.StoreID;
                $scope.StoreName = item.Storedetails[0].StoreName;
                $scope.ClientStore = item.ClientStore;
                $scope.WorkOrder = item.WorkOrder;
                $scope.Date = new Date(item.Date);
                $scope.Purpose = item.Purpose;
                $scope.Deadline = new Date(item.Deadline);
                $scope.Remarks = item.Remarks;
                $scope.Currency = item.Currency;
                $scope.SubTotal = parseFloat(item.SubTotal);
                $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                $scope.GST = parseFloat(item.GST);
                $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                $scope.Total = parseFloat(item.Total);
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Inventory Purchase Request') {
                    if ($scope.StatusID === value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel === value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Inventory Purchase Request') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshPurchaseGrid();
            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
        }

        $scope.ViewPurchaseItmes = function (e, VPReqId) {
            try {
                var item = $scope.Purchaseformdatas.filter(function (item) {
                    return item._id === VPReqId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
            } catch (err) { }
            RefreshPurchaseGrid();
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/request/purchase/viewItems.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.workflow = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    if ($scope.Userdata.Status == "PO Created") {
                        $scope.PODetails = $scope.Userdata;
                        $scope.AddPurchaseOrder();
                    }

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseform/email",
                            data: {
                                PurchaseID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Deadline: convertDate($scope.Userdata.Deadline),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Purchaseformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.AddPurchaseOrder = function () {
            $scope.PODetails = $scope.PODetails;
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.POUniqueID = pass;
            $scope.OrderDate = new Date();
            //$scope.DeliveryDate = new Date(new Date().setDate(new Date().getDate() + 3));

            angular.forEach($scope.Purchasedatas, function (value1) {
                var popresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/purchaseorderproduct/add",
                    data: {
                        UniqueID: $scope.POUniqueID,
                        ProductCategory: value1.ProductCategory,
                        ProductCodeID: value1.ProductCodeID,
                        ProductName: value1.ProductName,
                        Description: value1.Description,
                        Model: value1.Model,
                        Quantity: value1.Quantity,
                        Unit: value1.Unit,
                        UnitPrice: value1.UnitPrice,
                        TotalCost: value1.TotalCost,
                        ReceivedQuantity: 0,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
            });

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder/add",
                data: {
                    Client_Id: Client_Id,
                    UniqueID: $scope.POUniqueID,
                    PRID: $scope.PODetails.ReferenceNo,
                    RequestedEmployee: $scope.PODetails.RequestedEmployee,
                    EmployeeID: $scope.PODetails.EmployeeID,
                    OrderDate: $scope.OrderDate,
                    DeliveryDate: null,
                    Remarks: $scope.PODetails.Remarks,
                    SupplierID: $scope.PODetails.SupplierID,
                    StoreID: $scope.PODetails.StoreID,
                    ClientStore: $scope.PODetails.ClientStore,
                    Currency: $scope.PODetails.Currency,
                    SubTotal: $scope.PODetails.SubTotal,
                    DiscountBefore: $scope.PODetails.DiscountBefore,
                    GST: $scope.PODetails.GST,
                    DiscountAfter: $scope.PODetails.DiscountAfter,
                    Total: $scope.PODetails.Total,
                    Status: $scope.PODetails.Status,
                    StatusID: "1",
                    EmailID: $scope.AllApproveEmails,
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                var loghistoryresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/logdetails/add",
                    data: {
                        RequestID: $scope.POUniqueID,
                        TypeName: "Inventory Purchase Order",
                        Action: $scope.PODetails.Status,
                        ActionedBy: $rootScope.LoginID,
                    },
                });
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.reject = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Status == "New" && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Already PO Created") {
                        debugger
                        $mdToast.show($mdToast.simple().textContent('Already PO Created!').position('top center'));
                        $scope.Showgrid();
                    }
                    else {
                        $scope.Userdata = GList.data.data[0];

                        try {
                            $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                            $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        } catch (err) { }

                        var SenderEmails = [];

                        try {
                            var myArray = $scope.Workflowdatas;
                            var Workflowitem = myArray.filter(function (Workflowitem) {
                                return Workflowitem.TypeName === 'Inventory Purchase Request' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                            })[0];
                        } catch (err) { }

                        try {
                            if (Workflowitem.NotifytoCurrentApprover == true) {
                                $scope.ApproversArray = Workflowitem.Approvers.split(',');
                                angular.forEach($scope.ApproversArray, function (value) {
                                    var UserArray = $scope.Userdatas;
                                    var Useritem = UserArray.filter(function (Useritem) {
                                        return Useritem.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: Useritem.Email });
                                });
                            }
                        } catch (err) { }

                        try {
                            if (Workflowitem.NotifytoCreatorInitator == true) {
                                var UserArray2 = $scope.Userdatas;
                                var item2 = UserArray2.filter(function (item2) {
                                    return item2.UserID === $scope.Userdata.CreatedBy;
                                })[0];
                                SenderEmails.push({ Email: item2.Email });
                            }
                        } catch (err) { }

                        try {
                            $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                            angular.forEach($scope.NotifyToArray, function (value) {
                                var UserArray3 = $scope.Userdatas;
                                var item3 = UserArray3.filter(function (item3) {
                                    return item3.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: item3.Email });
                            });
                        } catch (err) { }

                        $scope.Emails = SenderEmails;
                        $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                        angular.forEach($scope.SOgroups, function (value) {
                            var SendEmail = value[0].Email;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/purchaseform/email",
                                data: {
                                    PurchaseID: $scope.Userdata._id,
                                    SenderEmailAddress: SendEmail,
                                    ReferenceNo: $scope.Userdata.ReferenceNo,
                                    UniqueID: $scope.Userdata.UniqueID,
                                    EmployeeID: $scope.EmployeeId,
                                    EmployeeName: $scope.EmployeeName,
                                    WorkOrder: $scope.Userdata.WorkOrder,
                                    Date: convertDate($scope.Userdata.Date),
                                    Deadline: convertDate($scope.Userdata.Deadline),
                                    Purpose: $scope.Userdata.Purpose,
                                    Remarks: $scope.Userdata.Remarks,
                                    Status: $scope.Userdata.Status,
                                    StatusID: $scope.Userdata.StatusID,
                                    CreatedBy: $rootScope.LoginID,
                                    CreatedDate: convertDate(new Date()),
                                },
                            });
                        });

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/logdetails/add",
                            data: {
                                RequestID: $scope.UniqueID,
                                TypeName: "Inventory Purchase Request",
                                Action: "Rejected",
                                ActionedBy: $rootScope.LoginID,
                            },
                        });
                        $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                        $scope.Purchaseformdatas[$scope.IndexID] = GList.data.data[0];
                        $scope.Showgrid();
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.close = function () {
            $mdDialog.cancel();
        };

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Inventory Purchase Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/purchaseform/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Purchase Request",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function InitialWorkflowLoading() {
            $scope.AllSenderEmailsforNotifyApprove = [];

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: { Client_Id: Client_Id },
            });
            response.then(function (getforNewWorkflowdata) {
                $scope.getforNewWorkflowdatas = getforNewWorkflowdata.data.data;

                try {
                    var Workflowitem = $scope.getforNewWorkflowdatas.filter(function (Workflowitem) {
                        return Workflowitem.TypeName === 'Inventory Purchase Order' && Workflowitem.LevelName === "1";
                    })[0];
                } catch (err) { }

                try {
                    if (Workflowitem.NotifytoCurrentApprover == true) {
                        $scope.ApproversArray = Workflowitem.Approvers.split(',');
                        angular.forEach($scope.ApproversArray, function (value) {
                            var Useritem = $scope.Userdatas.filter(function (Useritem) {
                                return Useritem.UserID === value;
                            })[0];
                            $scope.AllSenderEmailsforNotifyApprove.push({ Email: Useritem.Email });
                        });
                    }
                } catch (err) { }

                try {
                    if (Workflowitem.NotifytoCreatorInitator == true) {
                        var item2 = $scope.Userdatas.filter(function (item2) {
                            return item2.UserID === $rootScope.LoginID;
                        })[0];
                        $scope.AllSenderEmailsforNotifyApprove.push({ Email: item2.Email });
                    }
                } catch (err) { }

                try {
                    $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                    angular.forEach($scope.NotifyToArray, function (value) {
                        var item3 = $scope.Userdatas.filter(function (item3) {
                            return item3.UserID === value;
                        })[0];
                        $scope.AllSenderEmailsforNotifyApprove.push({ Email: item3.Email });
                    });
                } catch (err) { }

                try {
                    if (Workflowitem.NotifytoNextLevelApprover == true) {
                        try {
                            $scope.NLevel = Workflowitem.NextLevel;
                            var Workflowitem1 = $scope.getforNewWorkflowdatas.filter(function (item1) {
                                return item1.TypeName === 'Inventory Purchase Order' && item1.LevelName === $scope.NLevel;
                            })[0];
                        } catch (err) { }

                        try {
                            $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                            angular.forEach($scope.NApproversArray, function (value) {
                                var item4 = $scope.Userdatas.filter(function (item4) {
                                    return item4.UserID === value;
                                })[0];
                                $scope.AllSenderEmailsforNotifyApprove.push({ Email: item4.Email });
                            });
                        } catch (err) { }

                        try {
                            $scope.NApproversNotifyArray = Workflowitem1.NotifyTo.split(',');
                            angular.forEach($scope.NApproversNotifyArray, function (value) {
                                var item4 = $scope.Userdatas.filter(function (item4) {
                                    return item4.UserID === value;
                                })[0];
                                $scope.AllSenderEmailsforNotifyApprove.push({ Email: item4.Email });
                            });
                        } catch (err) { }
                    }
                } catch (err) { }

                $scope.NewSOgroupsforApprove = _.groupBy($scope.AllSenderEmailsforNotifyApprove, 'Email');

                var resArr = [];
                try {
                    $scope.AllSenderEmailsforNotifyApprove.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                            return x.Email == item.Email
                        });
                        if (i <= -1)
                            resArr.push(item);
                    });
                } catch (e) { }
                $scope.getAllApproveEmail = resArr;
                if ($scope.getAllApproveEmail.length != 0) {
                    $scope.AllApproveEmails = $scope.getAllApproveEmail.map(function (obj) { return obj.Email; }).join(',');
                    //var url =  $rootScope.ReportURL + "EmailPurchaseOrder.aspx?ID=" + $scope.Userdata.id + "&EmailID=" + $scope.AllApproveEmail;
                }
            });
        }

        function RefreshSalesOrderGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/salesOrder",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (SalesOrderdata) {
                $scope.SalesOrderdatas = SalesOrderdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshPurchaseGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchase/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Purchasedata) {
                $scope.Purchasedatas = Purchasedata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "PurchaseRequest.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            destroy: true
        };

        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: '',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }

})();


(function () {
    'use strict';

    angular

        .module('app.procurement.request.material', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.procurement_request_material', {
            url: '/StockApproval',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/request/material/material.html',
                    controller: 'MaterialController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.request.material')
        .controller('MaterialController', MaterialController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });
    //.filter("htmlToPlaintext", function () {
    //    return function (input) {
    //        return input.replace(/<[^>]+>/gm, '');
    //    }
    //});


    function MaterialController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, $window, Upload) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Requests")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.RatsanseStartDate = new Date();
        $scope.RatsanseEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);

        RefreshGrid();
        RefreshSalesOrderGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();
        RefreshStockGrid();
        RefreshGoodsGrid();
        RefreshRatsenseGrid();

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/materialform/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Materialformdata) {
                $scope.Materialformdatas = Materialformdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/materialform/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Materialformdata) {
                $scope.Materialformdatas = Materialformdata.data.data;
            });
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }


        function RefreshSalesOrderGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/salesOrder",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (SalesOrderdata) {
                $scope.SalesOrderdatas = SalesOrderdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshStockGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        function RefreshRatsenseGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/lighttrap",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Lighttrapdata) {
                $scope.Lighttrapdatas = Lighttrapdata.data.data;
            });
        }


        var MaterialID = getParameterByName('ID');
        if (MaterialID != null) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/materialform",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Materialformdata) {
                $scope.Materialformdatas = Materialformdata.data.data;
                try {
                    var item = $scope.Materialformdatas.filter(function (item) {
                        return item._id === MaterialID;
                    })[0];
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.Employee = item.EmployeeID;
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                    $scope.WorkOrder = item.WorkOrder;
                    $scope.Date = new Date(item.Date);
                    $scope.Purpose = item.Purpose;
                    $scope.Remarks = item.Remarks;
                    $scope.TotalItems = item.TotalItems;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                    $scope.Location = item.Location;
                    $scope.Customer = item.CustomerID;
                    $scope.CustomerName = item.Customerdetails[0].CompanyName;
                } catch (err) { }

                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.Update = true;
                $scope.Materialform = true;
                $scope.Materialgrid = false;
                $scope.mrExport = false;
                $scope.mrSearch = false;
                $scope.mrView = true;
                $scope.Cancel = false;
                $scope.Material = true;
                $scope.NextApprovers = '';
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'Inventory Stock Request') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'Inventory Stock Request') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                RefreshMaterialGrid();
                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
            });
        }
        else {
            $scope.Materialform = false;
            $scope.Materialgrid = true;
            $scope.mrExport = true;
            $scope.mrSearch = true;
            $scope.mrView = false;
            $scope.Material = false;
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("StockRequests.xlsx",{headers:true}) FROM ?', [$scope.Materialformdatas]);
        };

        $scope.Showgrid = function () {
            $scope.Materialgrid = true;
            $scope.Materialform = false;
            $scope.mrExport = true;
            $scope.mrView = false;
            $scope.mrSearch = true;
            $scope.Material = false;

            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
        }

        //$http.get( $rootScope.WebURL + "/material")
        //.then(function (Locmaterialdata) {
        //    $scope.Locmaterialdatas = Locmaterialdata.data.data;
        //});

        // $scope.getLocation = function () {
        //     $scope.ReferenceListArray = [];
        //     $scope.StockListArray = [];
        //     angular.forEach($scope.Materialformdatas, function (value) {
        //         angular.forEach($scope.Locmaterialdatas, function (value1) {
        //             var checkdate = convertDate(value.CreatedDate);
        //             if (checkdate == "19/02/2018" && value.UniqueID == value1.UniqueID && value1.ProductCategory == "RATSENSE") {
        //                 if (value1.SerialNumber != null && value1.SerialNumber != "" && value1.SerialNumber != undefined) {
        //                     var Sno = value1.SerialNumber.split(",");
        //                     angular.forEach(Sno, function (v1) {
        //                         $scope.ReferenceListArray.push({
        //                             ReferenceNo: value.ReferenceNo,
        //                             UniqueID: value.UniqueID,
        //                             Customer: value.CustomerID,
        //                             Location: value.Location,
        //                             SerialNo: v1,
        //                             ProductCode: value1.ProductCode,
        //                             ProductCategory: value1.ProductCategory,
        //                         })
        //                     });
        //                 }
        //             }
        //         });
        //     });
        //     
        //     $scope.StockListArray = $scope.ReferenceListArray;
        //     angular.forEach($scope.ReferenceListArray, function (value) {
        //         angular.forEach($scope.Lighttrapdatas, function (value1) {
        //             if (value.SerialNo == value1.SerialNumber) {
        //                 
        //                 var response = $http({
        //                     method: "PUT",
        //                     url:  $rootScope.WebURL + "/lighttrap/updatestatusSR",
        //                     data: {
        //                         _id: value1._id,
        //                         Customer: value.Customer,
        //                         Location: value.Location,
        //                         StartDate: $scope.RatsanseStartDate,
        //                         EndDate: $scope.RatsanseEndDate,
        //                         Status: "Issued",
        //                         UpdatedBy: "admin",
        //                     },
        //                 });
        //             }
        //         });
        //     });
        // }

        $scope.Materialinfo = function (MReqId, $index) {
            $scope.IndxID = $index;
            RefreshGrid();
            $scope.SID = MReqId;

            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Update = true;
            $scope.Materialform = true;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Cancel = false;
            $scope.Material = true;
            $scope.NextApprovers = '';

            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = $scope.Status;
            $scope.NextLevelAction = '';

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            try {
                var item = $scope.Materialformdatas.filter(function (item) {
                    return item._id === MReqId;
                })[0];
                $scope.WID = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                $scope.WorkOrder = item.WorkOrder;
                $scope.Date = new Date(item.Date);
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                $scope.TotalItems = item.TotalItems;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.Location = item.Location;
                $scope.Customer = item.CustomerID;
                $scope.CustomerName = item.Customerdetails[0].CompanyName;
            } catch (err) { }

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Inventory Stock Request') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Inventory Stock Request') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshMaterialGrid();
            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
            RefreshStockGrid();
            RefreshGoodsGrid();
        }

        $scope.ViewMaterialItmes = function (e, VReqId) {
            try {
                var item = $scope.Materialformdatas.filter(function (item) {
                    return item._id === VReqId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
            } catch (err) { }
            RefreshMaterialGrid();
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/request/material/viewItems.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MaterialController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.updateMaterial = function (e, RMaterialId) {
            RefreshStockGrid();
            $scope.MUpdate = true;
            $scope.MID = RMaterialId;
            try {
                var item1 = $scope.Materialdatas.filter(function (item1) {
                    return item1._id === RMaterialId;
                })[0];
                $scope.id = item1._id;
                $scope.UniqueID = item1.UniqueID;
                $scope.vm.mType = item1.ProductType;
                $scope.vm.mExpectedReturnDate = item1.ExpectedReturnDate;
                $scope.vm.mStore = item1.StoreName;
                $scope.vm.mProductCategory = item1.ProductCategory;
                $scope.vm.mMaterial = item1.ProductName;
                $scope.vm.mProductCode = item1.ProductCode;
                $scope.vm.mDescription = item1.Description;
                $scope.vm.oQuantityRequired = parseFloat(item1.QuantityRequired);
                $scope.vm.mQuantityRequired = parseFloat(item1.QuantityRequired);
                $scope.vm.mUnits = item1.Unit;
                $scope.Model = item1.Model;
                $scope.SerialNumber = item1.SerialNumber;

                var gTotal = 0.00;
                angular.forEach($scope.Goodsuniquedatas, function (Gvalue) {
                    if ($scope.vm.mStore == Gvalue.StoreName && $scope.vm.mProductCategory == Gvalue.ProductCategory && $scope.vm.mProductCode == Gvalue.ProductCode) {
                        if (Gvalue.TotalQuantity != "" && Gvalue.TotalQuantity != null && Gvalue.TotalQuantity != undefined) {
                            gTotal = parseFloat(Gvalue.TotalQuantity) + parseFloat($scope.vm.mQuantityRequired);
                        }
                    }
                });
                if (gTotal < 0 || gTotal == "" || gTotal == null || gTotal == undefined || gTotal == NaN) {
                    gTotal = 0;
                }
                $scope.vm.mStockQuantity = gTotal;
                if ($scope.vm.mStockQuantity != null && $scope.vm.mStockQuantity != undefined && $scope.vm.mStockQuantity != "") {
                    if (parseFloat($scope.vm.mStockQuantity) % 1 == 0) {
                        if ($scope.vm.mStockQuantity < 0) {
                            $scope.vm.mStockQuantity = 0;
                        } else {
                            $scope.vm.mStockQuantity = $scope.vm.mStockQuantity;
                        }
                    }
                    else {
                        if ($scope.vm.mStockQuantity < 0) {
                            $scope.vm.mStockQuantity = 0;
                        } else {
                            $scope.vm.mStockQuantity = parseFloat($scope.vm.mStockQuantity).toFixed(1);
                        }
                    }
                }

                $mdDialog.show({
                    templateUrl: 'app/main/apps/procurement/request/material/materialupdate.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function MaterialController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            } catch (err) { }
        }

        $scope.Materialadd = function () {
            if ($scope.vm.mStockQuantity < $scope.vm.mQuantityRequired) {
                $mdToast.show($mdToast.simple().textContent('Stock Not Available!!').position('top center'));
                return
            }
            if ($scope.MUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/material/update",
                    data: {
                        _id: $scope.MID,
                        ProductType: $scope.vm.mType,
                        ExpectedReturnDate: $scope.vm.mExpectedReturnDate,
                        StoreName: $scope.vm.mStore,
                        ProductCategory: $scope.vm.mProductCategory,
                        ProductName: $scope.vm.mMaterial,
                        ProductCode: $scope.vm.mProductCode,
                        Description: $scope.vm.mDescription,
                        QuantityRequired: $scope.vm.mQuantityRequired,
                        Unit: $scope.vm.mUnits,
                        Model: $scope.Model,
                        SerialNumber: $scope.SerialNumber,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if ($scope.vm.oQuantityRequired != $scope.vm.mQuantityRequired) {
                        angular.forEach($scope.Goodsuniquedatas, function (value2) {
                            if ($scope.vm.mStore == value2.StoreName && $scope.vm.mProductCategory == value2.ProductCategory && $scope.vm.mProductCode == value2.ProductCode) {
                                $scope.oh = parseFloat(value2.OnHold) + parseFloat($scope.vm.mQuantityRequired) - parseFloat($scope.vm.oQuantityRequired);
                                if ($scope.oh < 0 || $scope.oh == "" || $scope.oh == null || $scope.oh == undefined || $scope.oh == NaN) {
                                    $scope.oh = 0;
                                }
                                $scope.tq = (parseFloat(value2.TotalQuantity) - parseFloat($scope.vm.mQuantityRequired) + parseFloat($scope.vm.oQuantityRequired));
                                if ($scope.tq < 0 || $scope.tq == "" || $scope.tq == null || $scope.tq == undefined || $scope.tq == NaN) {
                                    $scope.tq = 0;
                                }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                    data: {
                                        _id: value2.id,
                                        OnHold: $scope.oh,
                                        TotalQuantity: $scope.tq,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    }
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMaterialGrid();
                    RefreshStockGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else { }
        }

        $scope.DisplayAvailable = function (value) {
            if (value != null && value != undefined && value != "") {
                if (parseFloat(value) % 1 == 0) {
                    if (value < 0) {
                        return 0;
                    } else {
                        return value;
                    }
                }
                else {
                    if (value < 0) {
                        return 0;
                    } else {
                        return parseFloat(value).toFixed(1);
                    }
                }
            }
        }

        $scope.workflow = function (e) {
            if ($scope.NextLevelAction == "Approve") {
                $scope.sLength = $scope.Materialdatas.length;
                var sdata = [];
                var vsdata = [];
                angular.forEach($scope.Materialdatas, function (value1) {
                    angular.forEach($scope.Goodsuniquedatas, function (value2) {
                        if (value1.StoreName == value2.StoreName && value1.ProductCategory == value2.ProductCategory && value1.ProductCode == value2.ProductCode) {
                            $scope.aQuantity = parseFloat(value1.QuantityRequired);
                            if ($scope.aQuantity < 0 || $scope.aQuantity == "" || $scope.aQuantity == null || $scope.aQuantity == undefined || $scope.aQuantity == NaN) {
                                $scope.aQuantity = 0;
                            }
                            $scope.bQuantity = (parseFloat(value2.TotalQuantity) + parseFloat(value2.OnHold));
                            if ($scope.bQuantity < 0 || $scope.bQuantity == "" || $scope.bQuantity == null || $scope.bQuantity == undefined || $scope.bQuantity == NaN) {
                                $scope.bQuantity = 0;
                            }
                            if ($scope.aQuantity <= $scope.bQuantity) {
                                sdata.push({
                                    TotalQuantity: value2.TotalQuantity,
                                })
                            }
                            else if ($scope.aQuantity > $scope.bQuantity) {
                                vsdata.push({
                                    ProductName: value1.ProductName,
                                    AvailableQuantity: value2.TotalQuantity,
                                    RequiredQuantity: value1.QuantityRequired,
                                })
                            }
                        }
                    });
                });

                $scope.tdata = sdata;
                $scope.aLength = sdata.length;
                if ($scope.sLength != $scope.aLength) {
                    $scope.notavaildata = vsdata;
                    $mdDialog.show({
                        templateUrl: 'app/main/apps/procurement/request/material/unavailablestocks.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        scope: $scope.$new(),
                        clickOutsideToClose: true,
                        controller: function MaterialController($scope, $mdDialog) {
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            }
                        }
                    });
                    return
                }
            }

            $scope.WID = $scope.WID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/materialform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    if ($scope.Userdata.Status == "Issued") {
                        angular.forEach($scope.Materialdatas, function (value1) {
                            angular.forEach($scope.Goodsuniquedatas, function (value2) {
                                if (value1.StoreName == value2.StoreName && value1.ProductCategory == value2.ProductCategory && value1.ProductCode == value2.ProductCode) {
                                    $scope.ioh = (parseFloat(value2.OnHold) - parseFloat(value1.QuantityRequired));
                                    if ($scope.ioh < 0 || $scope.ioh == "" || $scope.ioh == null || $scope.ioh == undefined || $scope.ioh == NaN) {
                                        $scope.ioh = 0;
                                    }
                                    var response = $http({
                                        method: "PUT",
                                        url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                        data: {
                                            _id: value2.id,
                                            OnHold: $scope.ioh,
                                            TotalQuantity: value2.TotalQuantity,
                                            UpdatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }
                            });
                        });
                        $scope.SIDetails = $scope.Userdata;
                        $scope.AddStockIssuance();
                    }

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');
                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/materialform/email",
                            data: {
                                MaterialID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Materialformdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshStockGrid();
                    RefreshGoodsGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.AddStockIssuance = function () {
            $scope.SIDetails = $scope.SIDetails;

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.SIUniqueID = pass;

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/stockissuanceform/add",
                data: {
                    Client_Id: Client_Id,
                    UniqueID: $scope.SIUniqueID,
                    RequestedBy: $scope.SIDetails.EmployeeID,
                    RequestedByEmployee: $scope.SIDetails.RequestedEmployee,
                    StockReferenceNo: $scope.SIDetails.ReferenceNo,
                    Purpose: $scope.SIDetails.Purpose,
                    Remarks: $scope.SIDetails.Remarks,
                    Status: "Issued",
                    StatusID: "0",
                    RequestedDate: $scope.SIDetails.Date,
                    IssuedDate: new Date(),
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                $scope.SIFormdata = GList.data.data;
                angular.forEach($scope.Materialdatas, function (value3) {
                    var siresponse = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/stockissuance/add",
                        data: {
                            Client_Id: Client_Id,
                            UniqueID: $scope.SIUniqueID,
                            ReferenceNo: $scope.SIFormdata.ReferenceNo,
                            IssueTo: $scope.SIFormdata.RequestedByEmployee,
                            StoreID: value3.StoreName,
                            ProductType: value3.ProductType,
                            ProductCategory: value3.ProductCategory,
                            ProductName: value3.ProductName,
                            ProductCode: value3.ProductCode,
                            Description: value3.Description,
                            Model: value3.Model,
                            SerialNumber: value3.SerialNumber,
                            Quantity: value3.QuantityRequired,
                            Unit: value3.Unit,
                            ReturnDate: value3.ExpectedReturnDate,
                            IssuedDate: $scope.SIFormdata.IssuedDate,
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                });
                angular.forEach($scope.Materialdatas, function (value3) {
                    if (value3.ProductType == "Yes") {
                        var srresponse = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/stockreturn/add",
                            data: {
                                Client_Id: Client_Id,
                                ReceiverName: $scope.SIDetails.RequestedEmployee,
                                UniqueID: $scope.SIUniqueID,
                                ReferenceNo: $scope.SIFormdata.ReferenceNo,
                                StoreID: value3.StoreName,
                                CustomerID: $scope.SIDetails.CustomerID,
                                Location: $scope.SIDetails.Location,
                                ProductCategory: value3.ProductCategory,
                                ProductCode: value3.ProductCode,
                                ProductName: value3.ProductName,
                                Description: value3.Description,
                                Model: value3.Model,
                                SerialNumber: value3.SerialNumber,
                                ReceivedQuantity: value3.QuantityRequired,
                                ReturnedQuantity: "0",
                                Unit: value3.Unit,
                                ReturnDate: value3.ExpectedReturnDate,
                                CreatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                });

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.reject = function () {
            $scope.WID = $scope.WID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/materialform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    angular.forEach($scope.Materialdatas, function (value1) {
                        angular.forEach($scope.Goodsuniquedatas, function (value2) {
                            if (value1.StoreName == value2.StoreName && value1.ProductCategory == value2.ProductCategory && value1.ProductCode == value2.ProductCode) {
                                $scope.roh = (parseFloat(value2.OnHold) - parseFloat(value1.QuantityRequired));
                                if ($scope.roh < 0 || $scope.roh == "" || $scope.roh == null || $scope.roh == undefined || $scope.roh == NaN) {
                                    $scope.roh = 0;
                                }
                                $scope.rtq = (parseFloat(value2.TotalQuantity) + parseFloat(value1.QuantityRequired));
                                if ($scope.rtq < 0 || $scope.rtq == "" || $scope.rtq == null || $scope.rtq == undefined || $scope.rtq == NaN) {
                                    $scope.rtq = 0;
                                }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                    data: {
                                        _id: value2.id,
                                        OnHold: $scope.roh,
                                        TotalQuantity: $scope.rtq,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });

                    var marray = [];
                    angular.forEach($scope.Materialdatas, function (value) {
                        if (value.SerialNumber != null && value.SerialNumber != "null" && value.SerialNumber != undefined && value.SerialNumber != "undefined" && value.SerialNumber != "") {
                            var Sno = value.SerialNumber.split(",");
                            angular.forEach(Sno, function (v1) {
                                marray.push({
                                    SerialNo: v1,
                                    ProCode: value.ProductCode,
                                })
                            });
                        }
                    });
                    if (marray.length != 0) {
                        angular.forEach(marray, function (value) {
                            angular.forEach($scope.Goodsdatas, function (Gvalue) {
                                if (value.SerialNo == Gvalue.SerialNumber && value.ProCode == Gvalue.ProductCode) {
                                    var response = $http({
                                        method: "PUT",
                                        url: $rootScope.WebURL + "/goods/updateIssue",
                                        data: {
                                            _id: Gvalue.id,
                                            Status: "New",
                                            Customer: $scope.Customer,
                                            Location: $scope.Location,
                                            StartDate: $scope.RatsanseStartDate,
                                            EndDate: $scope.RatsanseEndDate,
                                            UpdatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }
                            });
                        });
                    }

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Request' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/materialform/email",
                            data: {
                                MaterialID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Request",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Materialformdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshStockGrid();
                    RefreshGoodsGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Inventory Stock Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/materialform/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Material Request",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.close = function () {
            $mdDialog.cancel();
        };

        function RefreshMaterialGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/material/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Materialdata) {
                $scope.Materialdatas = Materialdata.data.data;
            });
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "StockRequest.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.training.traininglist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_training_traininglist', {
            url: '/TrainingList',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/traininglist/traininglist.html',
                    controller: 'TrainingListController as vm'
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.traininglist')
        .controller('TrainingListController', TrainingListController);

    /** @ngInject */
    function TrainingListController($scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $filter) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Training List"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        var chkAllowCustomerExport = localStorage.getItem('AllowExport');
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        var EmpID = localStorage.getItem('EmployeeID');
        var vm = this

        $scope.iSearch = true
        $scope.iAdd = true
        $scope.iView = false
        $scope.iExport = true
        $scope.AllowExport = chkAllowCustomerExport
        $scope.Incidentgrid = true
        $scope.Incidentform = false

        RefreshTraining()
        $scope.Trainingdatas = []

        $scope.Add = function () {
            $scope.iSearch = false
            $scope.iAdd = false
            $scope.iView = true
            $scope.iExport = false
            $scope.Incidentgrid = false
            $scope.Incidentform = true
            $scope.Update = false
            clearform()
        }

        $scope.Showgrid = function () {
            $scope.iSearch = true
            $scope.iAdd = true
            $scope.iView = false
            $scope.iExport = true
            $scope.Incidentgrid = true
            $scope.Incidentform = false
        }

        function clearform() {
            $scope.TrainingName = null;
            $scope.Duration = null;
            $scope.StartDate = new Date();
            $scope.EndDate = new Date();
            $scope.TrainerName = null;
            $scope.TraineeSign = null;
            $rootScope.createdBy = null;
        }

        $scope.Signaturedatas = []

        $http({
            method: 'POST',
            url: $rootScope.WebURL + ' / User / getSign',
            data: { Client_Id: $rootScope.Client_Id }
        }).then(function (GList) {
            var data = GList.data.data
            angular.forEach(data, function (value) {
                if (value.TableID == null || value.TableID == undefined) {
                    value.TableID = null
                }
            })
            $scope.Signaturedatas = _.uniqBy(data, '_id');
        })

        $scope.ViewTraining = function (data) {
            $scope.UID = data._id;
            $scope.TrainingName = data.TrainingName
            $scope.Duration = parseFloat(data.Duration)
            $scope.StartDate = data.StartDate
            $scope.EndDate = data.EndDate
            $scope.TrainerName = data.TrainerName
            $scope.Remarks = data.Remarks
            var TraineeName = data.TraineeName
            if (TraineeName != null && TraineeName != "" && TraineeName != undefined) {
                var array = TraineeName.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                    var item = [];
                    item = $filter('filter')($scope.Signaturedatas, value);
                    if (item.length != 0) {
                        array1.push({ EmployeeName: value });
                    }
                });
                $scope.TraineeName = array1;
            }
            $scope.Update = true
            $scope.iSearch = false
            $scope.iAdd = false
            $scope.iView = true
            $scope.iExport = false
            $scope.Incidentgrid = false
            $scope.Incidentform = true
        }

        $scope.iSubmit = function () {
            if ($scope.TraineeName != null && $scope.TraineeName != "" && $scope.TraineeName != undefined) {
                $scope.TraineeName = $scope.TraineeName.map(function (obj) { return obj.EmployeeName; }).join(',');
            }
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + '/training/update',
                    data: {
                        _id: $scope.UID,
                        TrainingName: $scope.TrainingName,
                        Duration: $scope.Duration,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        TrainerName: $scope.TrainerName,
                        TraineeName: $scope.TraineeName,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdBy
                    }
                })
                response.then(function (GList) {
                    RefreshTraining()
                    $scope.Showgrid()
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
                })
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + '/training/add',
                    data: {
                        TrainingName: $scope.TrainingName,
                        Duration: $scope.Duration,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        TrainerName: $scope.TrainerName,
                        TraineeName: $scope.TraineeName,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id
                    }
                })
                response.then(function (GList) {
                    RefreshTraining()
                    $scope.Showgrid()
                    $mdToast.show($mdToast.simple().textContent('Added Successfully !').position('top center'));
                })
            }
        }

        function RefreshTraining() {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + '/training',
                data: { Client_Id: $rootScope.Client_Id }
            }).then(function (GList) {
                $scope.Trainingdatas = GList.data.data
            })
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };



    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.training.training', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_training_training', {
            url: '/Training',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/training/training.html',
                    controller: 'TrainingController as vm'
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.training')
        .controller('TrainingController', TrainingController);

    /** @ngInject */
    function TrainingController($scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Personnel Training"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        var chkAllowCustomerExport = localStorage.getItem('AllowExport');
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        var EmpID = localStorage.getItem('EmployeeID');
        var vm = this

        $scope.iSearch = true
        $scope.iAdd = true
        $scope.iView = false
        $scope.iExport = true
        $scope.AllowExport = chkAllowCustomerExport
        $scope.Incidentgrid = true
        $scope.Incidentform = false


        $scope.Trainingdatas = []
        RefreshTraining()

        $scope.Add = function () {
            $scope.iSearch = false
            $scope.iAdd = false
            $scope.iView = true
            $scope.iExport = false
            $scope.Incidentgrid = false
            $scope.Incidentform = true
            $scope.Update = false
            clearform()
        }

        $scope.Showgrid = function () {
            $scope.iSearch = true
            $scope.iAdd = true
            $scope.iView = false
            $scope.iExport = true
            $scope.Incidentgrid = true
            $scope.Incidentform = false
        }

        function clearform() {
            $scope.TrainingName = null;
            $scope.Duration = null;
            $scope.StartDate = new Date();
            $scope.EndDate = new Date();
            $scope.TrainerName = null;
            $scope.TraineeSign = null;
            $rootScope.createdBy = null;
        }

        $scope.Signaturedatas = []

        $scope.ViewTraining = function (data) {
            $scope.UID = data._id;
            $scope.TrainingName = data.TrainingName
            $scope.Duration = parseFloat(data.Duration)
            $scope.StartDate = data.StartDate
            $scope.EndDate = data.EndDate
            $scope.TrainerName = data.TrainerName
            $scope.TraineeSign = data.TraineeSign
            $scope.Remarks = data.Remarks
            $scope.Update = true
            $scope.iSearch = false
            $scope.iAdd = false
            $scope.iView = true
            $scope.iExport = false
            $scope.Incidentgrid = false
            $scope.Incidentform = true
        }

        $http({
            method: 'POST',
            url: $rootScope.WebURL + '/User/getSign',
            data: { Client_Id: $rootScope.Client_Id }
        }).then(function (GList) {
            var data = GList.data.data
            angular.forEach(data, function (value) {
                if (value.TableID == null || value.TableID == undefined) {
                    value.TableID = null
                }
            })
            $scope.Signaturedatas = _.uniqBy(data, '_id');
        })

        $scope.iSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + '/personneltraining/update',
                    data: {
                        _id: $scope.UID,
                        TrainingName: $scope.TrainingName,
                        Duration: $scope.Duration,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        TrainerName: $scope.TrainerName,
                        TraineeSign: $scope.TraineeSign,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    }
                })
                response.then(function (GList) {
                    RefreshTraining()
                    $scope.Showgrid()
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
                })
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + '/personneltraining/add',
                    data: {
                        TrainingName: $scope.TrainingName,
                        Duration: $scope.Duration,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        TrainerName: $scope.TrainerName,
                        TraineeSign: $scope.TraineeSign,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id
                    }
                })
                response.then(function (GList) {
                    RefreshTraining()
                    $scope.Showgrid()
                    $mdToast.show($mdToast.simple().textContent('Added Successfully !').position('top center'));
                })
            }
        }

        function RefreshTraining() {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + '/personneltraining',
                data: { Client_Id: $rootScope.Client_Id }
            }).then(function (GList) {
                $scope.Trainingdatas = GList.data.data
            })
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.training.report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_training_report', {
            url: '/TrainingReports',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/report/report.html',
                    controller: 'reportController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.training.report')
        .controller('reportController', reportController);

    /** @ngInject */
    function reportController($scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

    }

})();
/*
 * angular-ui-bootstrap
 * https://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.tabindex", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.datepicker", "ui.bootstrap.position", "ui.bootstrap.datepickerPopup", "ui.bootstrap.debounce", "ui.bootstrap.multiMap", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/year.html", "uib/template/datepickerPopup/popup.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

    .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
        var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
        return {
            link: function (scope, element, attrs) {
                var expandingExpr = $parse(attrs.expanding),
                    expandedExpr = $parse(attrs.expanded),
                    collapsingExpr = $parse(attrs.collapsing),
                    collapsedExpr = $parse(attrs.collapsed),
                    horizontal = false,
                    css = {},
                    cssTo = {};

                init();

                function init() {
                    horizontal = !!('horizontal' in attrs);
                    if (horizontal) {
                        css = {
                            width: ''
                        };
                        cssTo = { width: '0' };
                    } else {
                        css = {
                            height: ''
                        };
                        cssTo = { height: '0' };
                    }
                    if (!scope.$eval(attrs.uibCollapse)) {
                        element.addClass('in')
                            .addClass('collapse')
                            .attr('aria-expanded', true)
                            .attr('aria-hidden', false)
                            .css(css);
                    }
                }

                function getScrollFromElement(element) {
                    if (horizontal) {
                        return { width: element.scrollWidth + 'px' };
                    }
                    return { height: element.scrollHeight + 'px' };
                }

                function expand() {
                    if (element.hasClass('collapse') && element.hasClass('in')) {
                        return;
                    }

                    $q.resolve(expandingExpr(scope))
                        .then(function () {
                            element.removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', true)
                                .attr('aria-hidden', false);

                            if ($animateCss) {
                                $animateCss(element, {
                                    addClass: 'in',
                                    easing: 'ease',
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).start()['finally'](expandDone);
                            } else {
                                $animate.addClass(element, 'in', {
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).then(expandDone);
                            }
                        }, angular.noop);
                }

                function expandDone() {
                    element.removeClass('collapsing')
                        .addClass('collapse')
                        .css(css);
                    expandedExpr(scope);
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    $q.resolve(collapsingExpr(scope))
                        .then(function () {
                            element
                                // IMPORTANT: The width must be set before adding "collapsing" class.
                                // Otherwise, the browser attempts to animate from width 0 (in
                                // collapsing class) to the given width here.
                                .css(getScrollFromElement(element[0]))
                                // initially all panel collapse have the collapse class, this removal
                                // prevents the animation from jumping to collapsed state
                                .removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', false)
                                .attr('aria-hidden', true);

                            if ($animateCss) {
                                $animateCss(element, {
                                    removeClass: 'in',
                                    to: cssTo
                                }).start()['finally'](collapseDone);
                            } else {
                                $animate.removeClass(element, 'in', {
                                    to: cssTo
                                }).then(collapseDone);
                            }
                        }, angular.noop);
                }

                function collapseDone() {
                    element.css(cssTo); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing')
                        .addClass('collapse');
                    collapsedExpr(scope);
                }

                scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.tabindex', [])

    .directive('uibTabindexToggle', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                attrs.$observe('disabled', function (disabled) {
                    attrs.$set('tabindex', disabled ? -1 : null);
                });
            }
        };
    });

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

    .constant('uibAccordionConfig', {
        closeOthers: true
    })

    .controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
        // This array keeps track of the accordion groups
        this.groups = [];

        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        this.closeOthers = function (openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ?
                $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if (closeOthers) {
                angular.forEach(this.groups, function (group) {
                    if (group !== openGroup) {
                        group.isOpen = false;
                    }
                });
            }
        };

        // This is called from the accordion-group directive to add itself to the accordion
        this.addGroup = function (groupScope) {
            var that = this;
            this.groups.push(groupScope);

            groupScope.$on('$destroy', function (event) {
                that.removeGroup(groupScope);
            });
        };

        // This is called from the accordion-group directive when to remove itself
        this.removeGroup = function (group) {
            var index = this.groups.indexOf(group);
            if (index !== -1) {
                this.groups.splice(index, 1);
            }
        };
    }])

    // The accordion directive simply sets up the directive controller
    // and adds an accordion CSS class to itself element.
    .directive('uibAccordion', function () {
        return {
            controller: 'UibAccordionController',
            controllerAs: 'accordion',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion.html';
            }
        };
    })

    // The accordion-group directive indicates a block of html that will expand and collapse in an accordion
    .directive('uibAccordionGroup', function () {
        return {
            require: '^uibAccordion',         // We need this directive to be inside an accordion
            transclude: true,              // It transcludes the contents of the directive into the template
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
            },
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                panelClass: '@?',           // Ditto with panelClass
                isOpen: '=?',
                isDisabled: '=?'
            },
            controller: function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            },
            link: function (scope, element, attrs, accordionCtrl) {
                element.addClass('panel');
                accordionCtrl.addGroup(scope);

                scope.openClass = attrs.openClass || 'panel-open';
                scope.panelClass = attrs.panelClass || 'panel-default';
                scope.$watch('isOpen', function (value) {
                    element.toggleClass(scope.openClass, !!value);
                    if (value) {
                        accordionCtrl.closeOthers(scope);
                    }
                });

                scope.toggleOpen = function ($event) {
                    if (!scope.isDisabled) {
                        if (!$event || $event.which === 32) {
                            scope.isOpen = !scope.isOpen;
                        }
                    }
                };

                var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
                scope.headingId = id + '-tab';
                scope.panelId = id + '-panel';
            }
        };
    })

    // Use accordion-heading below an accordion-group to provide a heading containing HTML
    .directive('uibAccordionHeading', function () {
        return {
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
            }
        };
    })

    // Use in the accordion-group template to indicate where you want the heading to be transcluded
    // You must provide the property on the accordion-group controller that will hold the transcluded element
    .directive('uibAccordionTransclude', function () {
        return {
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, controller) {
                scope.$watch(function () { return controller[attrs.uibAccordionTransclude]; }, function (heading) {
                    if (heading) {
                        var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
                        elem.html('');
                        elem.append(heading);
                    }
                });
            }
        };

        function getHeaderSelectors() {
            return 'uib-accordion-header,' +
                'data-uib-accordion-header,' +
                'x-uib-accordion-header,' +
                'uib\\:accordion-header,' +
                '[uib-accordion-header],' +
                '[data-uib-accordion-header],' +
                '[x-uib-accordion-header]';
        }
    });

angular.module('ui.bootstrap.alert', [])

    .controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
        $scope.closeable = !!$attrs.close;
        $element.addClass('alert');
        $attrs.$set('role', 'alert');
        if ($scope.closeable) {
            $element.addClass('alert-dismissible');
        }

        var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
            $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

        if (dismissOnTimeout) {
            $timeout(function () {
                $scope.close();
            }, parseInt(dismissOnTimeout, 10));
        }
    }])

    .directive('uibAlert', function () {
        return {
            controller: 'UibAlertController',
            controllerAs: 'alert',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/alert/alert.html';
            },
            transclude: true,
            scope: {
                close: '&'
            }
        };
    });

angular.module('ui.bootstrap.buttons', [])

    .constant('uibButtonConfig', {
        activeClass: 'active',
        toggleEvent: 'click'
    })

    .controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
        this.activeClass = buttonConfig.activeClass || 'active';
        this.toggleEvent = buttonConfig.toggleEvent || 'click';
    }])

    .directive('uibBtnRadio', ['$parse', function ($parse) {
        return {
            require: ['uibBtnRadio', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'buttons',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                var uncheckableExpr = $parse(attrs.uibUncheckable);

                element.find('input').css({ display: 'none' });

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    var isActive = element.hasClass(buttonsCtrl.activeClass);

                    if (!isActive || angular.isDefined(attrs.uncheckable)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });

                if (attrs.uibUncheckable) {
                    scope.$watch(uncheckableExpr, function (uncheckable) {
                        attrs.$set('uncheckable', uncheckable ? '' : undefined);
                    });
                }
            }
        };
    }])

    .directive('uibBtnCheckbox', function () {
        return {
            require: ['uibBtnCheckbox', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'button',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                element.find('input').css({ display: 'none' });

                function getTrueValue() {
                    return getCheckboxValue(attrs.btnCheckboxTrue, true);
                }

                function getFalseValue() {
                    return getCheckboxValue(attrs.btnCheckboxFalse, false);
                }

                function getCheckboxValue(attribute, defaultValue) {
                    return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    });

angular.module('ui.bootstrap.carousel', [])

    .controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
        var self = this,
            slides = self.slides = $scope.slides = [],
            SLIDE_DIRECTION = 'uib-slideDirection',
            currentIndex = $scope.active,
            currentInterval, isPlaying;

        var destroyed = false;
        $element.addClass('carousel');

        self.addSlide = function (slide, element) {
            slides.push({
                slide: slide,
                element: element
            });
            slides.sort(function (a, b) {
                return +a.slide.index - +b.slide.index;
            });
            //if this is the first slide or the slide is set to active, select it
            if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition = null;
                }

                currentIndex = slide.index;
                $scope.active = slide.index;
                setActive(currentIndex);
                self.select(slides[findSlideIndex(slide)]);
                if (slides.length === 1) {
                    $scope.play();
                }
            }
        };

        self.getCurrentIndex = function () {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide.index === currentIndex) {
                    return i;
                }
            }
        };

        self.next = $scope.next = function () {
            var newIndex = (self.getCurrentIndex() + 1) % slides.length;

            if (newIndex === 0 && $scope.noWrap()) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'next');
        };

        self.prev = $scope.prev = function () {
            var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

            if ($scope.noWrap() && newIndex === slides.length - 1) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'prev');
        };

        self.removeSlide = function (slide) {
            var index = findSlideIndex(slide);

            //get the index of the slide inside the carousel
            slides.splice(index, 1);
            if (slides.length > 0 && currentIndex === index) {
                if (index >= slides.length) {
                    currentIndex = slides.length - 1;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[slides.length - 1]);
                } else {
                    currentIndex = index;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
                $scope.active = currentIndex;
            }

            //clean the active value when no more slide
            if (slides.length === 0) {
                currentIndex = null;
                $scope.active = null;
            }
        };

        /* direction: "prev" or "next" */
        self.select = $scope.select = function (nextSlide, direction) {
            var nextIndex = findSlideIndex(nextSlide.slide);
            //Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            }
            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (nextSlide.slide.index !== currentIndex &&
                !$scope.$currentTransition) {
                goNext(nextSlide.slide, nextIndex, direction);
            }
        };

        /* Allow outside people to call indexOf on slides array */
        $scope.indexOfSlide = function (slide) {
            return +slide.slide.index;
        };

        $scope.isActive = function (slide) {
            return $scope.active === slide.slide.index;
        };

        $scope.isPrevDisabled = function () {
            return $scope.active === 0 && $scope.noWrap();
        };

        $scope.isNextDisabled = function () {
            return $scope.active === slides.length - 1 && $scope.noWrap();
        };

        $scope.pause = function () {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };

        $scope.play = function () {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };

        $element.on('mouseenter', $scope.pause);
        $element.on('mouseleave', $scope.play);

        $scope.$on('$destroy', function () {
            destroyed = true;
            resetTimer();
        });

        $scope.$watch('noTransition', function (noTransition) {
            $animate.enabled($element, !noTransition);
        });

        $scope.$watch('interval', restartTimer);

        $scope.$watchCollection('slides', resetTransition);

        $scope.$watch('active', function (index) {
            if (angular.isNumber(index) && currentIndex !== index) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i].slide.index === index) {
                        index = i;
                        break;
                    }
                }

                var slide = slides[index];
                if (slide) {
                    setActive(index);
                    self.select(slides[index]);
                    currentIndex = index;
                }
            }
        });

        function getSlideByIndex(index) {
            for (var i = 0, l = slides.length; i < l; ++i) {
                if (slides[i].index === index) {
                    return slides[i];
                }
            }
        }

        function setActive(index) {
            for (var i = 0; i < slides.length; i++) {
                slides[i].slide.active = i === index;
            }
        }

        function goNext(slide, index, direction) {
            if (destroyed) {
                return;
            }

            angular.extend(slide, { direction: direction });
            angular.extend(slides[currentIndex].slide || {}, { direction: direction });
            if ($animate.enabled($element) && !$scope.$currentTransition &&
                slides[index].element && self.slides.length > 1) {
                slides[index].element.data(SLIDE_DIRECTION, slide.direction);
                var currentIdx = self.getCurrentIndex();

                if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
                    slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
                }

                $scope.$currentTransition = true;
                $animate.on('addClass', slides[index].element, function (element, phase) {
                    if (phase === 'close') {
                        $scope.$currentTransition = null;
                        $animate.off('addClass', element);
                    }
                });
            }

            $scope.active = slide.index;
            currentIndex = slide.index;
            setActive(index);

            //every time you change slides, reset the timer
            restartTimer();
        }

        function findSlideIndex(slide) {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide === slide) {
                    return i;
                }
            }
        }

        function resetTimer() {
            if (currentInterval) {
                $interval.cancel(currentInterval);
                currentInterval = null;
            }
        }

        function resetTransition(slides) {
            if (!slides.length) {
                $scope.$currentTransition = null;
            }
        }

        function restartTimer() {
            resetTimer();
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval > 0) {
                currentInterval = $interval(timerFn, interval);
            }
        }

        function timerFn() {
            var interval = +$scope.interval;
            if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
                $scope.next();
            } else {
                $scope.pause();
            }
        }
    }])

    .directive('uibCarousel', function () {
        return {
            transclude: true,
            controller: 'UibCarouselController',
            controllerAs: 'carousel',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/carousel.html';
            },
            scope: {
                active: '=',
                interval: '=',
                noTransition: '=',
                noPause: '=',
                noWrap: '&'
            }
        };
    })

    .directive('uibSlide', ['$animate', function ($animate) {
        return {
            require: '^uibCarousel',
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/slide.html';
            },
            scope: {
                actual: '=?',
                index: '=?'
            },
            link: function (scope, element, attrs, carouselCtrl) {
                element.addClass('item');
                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', function () {
                    carouselCtrl.removeSlide(scope);
                });

                scope.$watch('active', function (active) {
                    $animate[active ? 'addClass' : 'removeClass'](element, 'active');
                });
            }
        };
    }])

    .animation('.item', ['$animateCss',
        function ($animateCss) {
            var SLIDE_DIRECTION = 'uib-slideDirection';

            function removeClass(element, className, callback) {
                element.removeClass(className);
                if (callback) {
                    callback();
                }
            }

            return {
                beforeAddClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element,
                            directionClass + ' ' + direction, done);
                        element.addClass(direction);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                },
                beforeRemoveClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element, directionClass, done);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                }
            };
        }]);

angular.module('ui.bootstrap.dateparser', [])

    .service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
        // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
        var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

        var localeId;
        var formatCodeToRegex;

        this.init = function () {
            localeId = $locale.id;

            this.parsers = {};
            this.formatters = {};

            formatCodeToRegex = [
                {
                    key: 'yyyy',
                    regex: '\\d{4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yyyy');
                    }
                },
                {
                    key: 'yy',
                    regex: '\\d{2}',
                    apply: function (value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yy');
                    }
                },
                {
                    key: 'y',
                    regex: '\\d{1,4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'y');
                    }
                },
                {
                    key: 'M!',
                    regex: '0?[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) {
                        var value = date.getMonth();
                        if (/^[0-9]$/.test(value)) {
                            return dateFilter(date, 'MM');
                        }

                        return dateFilter(date, 'M');
                    }
                },
                {
                    key: 'MMMM',
                    regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMMM'); }
                },
                {
                    key: 'MMM',
                    regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMM'); }
                },
                {
                    key: 'MM',
                    regex: '0[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'MM'); }
                },
                {
                    key: 'M',
                    regex: '[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'M'); }
                },
                {
                    key: 'd!',
                    regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) {
                        var value = date.getDate();
                        if (/^[1-9]$/.test(value)) {
                            return dateFilter(date, 'dd');
                        }

                        return dateFilter(date, 'd');
                    }
                },
                {
                    key: 'dd',
                    regex: '[0-2][0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'dd'); }
                },
                {
                    key: 'd',
                    regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'd'); }
                },
                {
                    key: 'EEEE',
                    regex: $locale.DATETIME_FORMATS.DAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEEE'); }
                },
                {
                    key: 'EEE',
                    regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEE'); }
                },
                {
                    key: 'HH',
                    regex: '(?:0|1)[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'HH'); }
                },
                {
                    key: 'hh',
                    regex: '0[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'hh'); }
                },
                {
                    key: 'H',
                    regex: '1?[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'H'); }
                },
                {
                    key: 'h',
                    regex: '[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'h'); }
                },
                {
                    key: 'mm',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'mm'); }
                },
                {
                    key: 'm',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'm'); }
                },
                {
                    key: 'sss',
                    regex: '[0-9][0-9][0-9]',
                    apply: function (value) { this.milliseconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'sss'); }
                },
                {
                    key: 'ss',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'ss'); }
                },
                {
                    key: 's',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 's'); }
                },
                {
                    key: 'a',
                    regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
                    apply: function (value) {
                        if (this.hours === 12) {
                            this.hours = 0;
                        }

                        if (value === 'PM') {
                            this.hours += 12;
                        }
                    },
                    formatter: function (date) { return dateFilter(date, 'a'); }
                },
                {
                    key: 'Z',
                    regex: '[+-]\\d{4}',
                    apply: function (value) {
                        var matches = value.match(/([+-])(\d{2})(\d{2})/),
                            sign = matches[1],
                            hours = matches[2],
                            minutes = matches[3];
                        this.hours += toInt(sign + hours);
                        this.minutes += toInt(sign + minutes);
                    },
                    formatter: function (date) {
                        return dateFilter(date, 'Z');
                    }
                },
                {
                    key: 'ww',
                    regex: '[0-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'ww'); }
                },
                {
                    key: 'w',
                    regex: '[0-9]|[1-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'w'); }
                },
                {
                    key: 'GGGG',
                    regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
                    formatter: function (date) { return dateFilter(date, 'GGGG'); }
                },
                {
                    key: 'GGG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GGG'); }
                },
                {
                    key: 'GG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GG'); }
                },
                {
                    key: 'G',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'G'); }
                }
            ];

            if (angular.version.major >= 1 && angular.version.minor > 4) {
                formatCodeToRegex.push({
                    key: 'LLLL',
                    regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'LLLL'); }
                });
            }
        };

        this.init();

        function getFormatCodeToRegex(key) {
            return filterFilter(formatCodeToRegex, { key: key }, true)[0];
        }

        this.getParser = function (key) {
            var f = getFormatCodeToRegex(key);
            return f && f.apply || null;
        };

        this.overrideParser = function (key, parser) {
            var f = getFormatCodeToRegex(key);
            if (f && angular.isFunction(parser)) {
                this.parsers = {};
                f.apply = parser;
            }
        }.bind(this);

        function createParser(format) {
            var map = [], regex = format.split('');

            // check for literal values
            var quoteIndex = format.indexOf('\'');
            if (quoteIndex > -1) {
                var inLiteral = false;
                format = format.split('');
                for (var i = quoteIndex; i < format.length; i++) {
                    if (inLiteral) {
                        if (format[i] === '\'') {
                            if (i + 1 < format.length && format[i + 1] === '\'') { // escaped single quote
                                format[i + 1] = '$';
                                regex[i + 1] = '';
                            } else { // end of literal
                                regex[i] = '';
                                inLiteral = false;
                            }
                        }
                        format[i] = '$';
                    } else {
                        if (format[i] === '\'') { // start of literal
                            format[i] = '$';
                            regex[i] = '';
                            inLiteral = true;
                        }
                    }
                }

                format = format.join('');
            }

            angular.forEach(formatCodeToRegex, function (data) {
                var index = format.indexOf(data.key);

                if (index > -1) {
                    format = format.split('');

                    regex[index] = '(' + data.regex + ')';
                    format[index] = '$'; // Custom symbol to define consumed part of format
                    for (var i = index + 1, n = index + data.key.length; i < n; i++) {
                        regex[i] = '';
                        format[i] = '$';
                    }
                    format = format.join('');

                    map.push({
                        index: index,
                        key: data.key,
                        apply: data.apply,
                        matcher: data.regex
                    });
                }
            });

            return {
                regex: new RegExp('^' + regex.join('') + '$'),
                map: orderByFilter(map, 'index')
            };
        }

        function createFormatter(format) {
            var formatters = [];
            var i = 0;
            var formatter, literalIdx;
            while (i < format.length) {
                if (angular.isNumber(literalIdx)) {
                    if (format.charAt(i) === '\'') {
                        if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
                            formatters.push(constructLiteralFormatter(format, literalIdx, i));
                            literalIdx = null;
                        }
                    } else if (i === format.length) {
                        while (literalIdx < format.length) {
                            formatter = constructFormatterFromIdx(format, literalIdx);
                            formatters.push(formatter);
                            literalIdx = formatter.endIdx;
                        }
                    }

                    i++;
                    continue;
                }

                if (format.charAt(i) === '\'') {
                    literalIdx = i;
                    i++;
                    continue;
                }

                formatter = constructFormatterFromIdx(format, i);

                formatters.push(formatter.parser);
                i = formatter.endIdx;
            }

            return formatters;
        }

        function constructLiteralFormatter(format, literalIdx, endIdx) {
            return function () {
                return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
            };
        }

        function constructFormatterFromIdx(format, i) {
            var currentPosStr = format.substr(i);
            for (var j = 0; j < formatCodeToRegex.length; j++) {
                if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
                    var data = formatCodeToRegex[j];
                    return {
                        endIdx: i + data.key.length,
                        parser: data.formatter
                    };
                }
            }

            return {
                endIdx: i + 1,
                parser: function () {
                    return currentPosStr.charAt(0);
                }
            };
        }

        this.filter = function (date, format) {
            if (!angular.isDate(date) || isNaN(date) || !format) {
                return '';
            }

            format = $locale.DATETIME_FORMATS[format] || format;

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.formatters[format]) {
                this.formatters[format] = createFormatter(format);
            }

            var formatters = this.formatters[format];

            return formatters.reduce(function (str, formatter) {
                return str + formatter(date);
            }, '');
        };

        this.parse = function (input, format, baseDate) {
            if (!angular.isString(input) || !format) {
                return input;
            }

            format = $locale.DATETIME_FORMATS[format] || format;
            format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.parsers[format]) {
                this.parsers[format] = createParser(format, 'apply');
            }

            var parser = this.parsers[format],
                regex = parser.regex,
                map = parser.map,
                results = input.match(regex),
                tzOffset = false;
            if (results && results.length) {
                var fields, dt;
                if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
                    fields = {
                        year: baseDate.getFullYear(),
                        month: baseDate.getMonth(),
                        date: baseDate.getDate(),
                        hours: baseDate.getHours(),
                        minutes: baseDate.getMinutes(),
                        seconds: baseDate.getSeconds(),
                        milliseconds: baseDate.getMilliseconds()
                    };
                } else {
                    if (baseDate) {
                        $log.warn('dateparser:', 'baseDate is not a valid date');
                    }
                    fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
                }

                for (var i = 1, n = results.length; i < n; i++) {
                    var mapper = map[i - 1];
                    if (mapper.matcher === 'Z') {
                        tzOffset = true;
                    }

                    if (mapper.apply) {
                        mapper.apply.call(fields, results[i]);
                    }
                }

                var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
                    Date.prototype.setFullYear;
                var timesetter = tzOffset ? Date.prototype.setUTCHours :
                    Date.prototype.setHours;

                if (isValid(fields.year, fields.month, fields.date)) {
                    if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
                        dt = new Date(baseDate);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours, fields.minutes,
                            fields.seconds, fields.milliseconds);
                    } else {
                        dt = new Date(0);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
                            fields.seconds || 0, fields.milliseconds || 0);
                    }
                }

                return dt;
            }
        };

        // Check if date is valid for specific month (and year for February).
        // Month: 0 = Jan, 1 = Feb, etc
        function isValid(year, month, date) {
            if (date < 1) {
                return false;
            }

            if (month === 1 && date > 28) {
                return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
            }

            if (month === 3 || month === 5 || month === 8 || month === 10) {
                return date < 31;
            }

            return true;
        }

        function toInt(str) {
            return parseInt(str, 10);
        }

        this.toTimezone = toTimezone;
        this.fromTimezone = fromTimezone;
        this.timezoneToOffset = timezoneToOffset;
        this.addDateMinutes = addDateMinutes;
        this.convertTimezoneToLocal = convertTimezoneToLocal;

        function toTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
        }

        function fromTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
        }

        //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
        function timezoneToOffset(timezone, fallback) {
            timezone = timezone.replace(/:/g, '');
            var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
            return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
        }

        function addDateMinutes(date, minutes) {
            date = new Date(date.getTime());
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function convertTimezoneToLocal(date, timezone, reverse) {
            reverse = reverse ? -1 : 1;
            var dateTimezoneOffset = date.getTimezoneOffset();
            var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
            return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
        }
    }]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
    .directive('uibIsClass', [
        '$animate',
        function ($animate) {
            //                    11111111          22222222
            var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
            //                    11111111           22222222
            var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

            var dataPerTracked = {};

            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    var linkedScopes = [];
                    var instances = [];
                    var expToData = {};
                    var lastActivated = null;
                    var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
                    var onExp = onExpMatches[2];
                    var expsStr = onExpMatches[1];
                    var exps = expsStr.split(',');

                    return linkFn;

                    function linkFn(scope, element, attrs) {
                        linkedScopes.push(scope);
                        instances.push({
                            scope: scope,
                            element: element
                        });

                        exps.forEach(function (exp, k) {
                            addForExp(exp, scope);
                        });

                        scope.$on('$destroy', removeScope);
                    }

                    function addForExp(exp, scope) {
                        var matches = exp.match(IS_REGEXP);
                        var clazz = scope.$eval(matches[1]);
                        var compareWithExp = matches[2];
                        var data = expToData[exp];
                        if (!data) {
                            var watchFn = function (compareWithVal) {
                                var newActivated = null;
                                instances.some(function (instance) {
                                    var thisVal = instance.scope.$eval(onExp);
                                    if (thisVal === compareWithVal) {
                                        newActivated = instance;
                                        return true;
                                    }
                                });
                                if (data.lastActivated !== newActivated) {
                                    if (data.lastActivated) {
                                        $animate.removeClass(data.lastActivated.element, clazz);
                                    }
                                    if (newActivated) {
                                        $animate.addClass(newActivated.element, clazz);
                                    }
                                    data.lastActivated = newActivated;
                                }
                            };
                            expToData[exp] = data = {
                                lastActivated: null,
                                scope: scope,
                                watchFn: watchFn,
                                compareWithExp: compareWithExp,
                                watcher: scope.$watch(compareWithExp, watchFn)
                            };
                        }
                        data.watchFn(scope.$eval(compareWithExp));
                    }

                    function removeScope(e) {
                        var removedScope = e.targetScope;
                        var index = linkedScopes.indexOf(removedScope);
                        linkedScopes.splice(index, 1);
                        instances.splice(index, 1);
                        if (linkedScopes.length) {
                            var newWatchScope = linkedScopes[0];
                            angular.forEach(expToData, function (data) {
                                if (data.scope === removedScope) {
                                    data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
                                    data.scope = newWatchScope;
                                }
                            });
                        } else {
                            expToData = {};
                        }
                    }
                }
            };
        }]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

    .value('$datepickerSuppressError', false)

    .value('$datepickerLiteralWarning', true)

    .constant('uibDatepickerConfig', {
        datepickerMode: 'day',
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        maxDate: null,
        maxMode: 'year',
        minDate: null,
        minMode: 'day',
        monthColumns: 3,
        ngModelOptions: {},
        shortcutPropagation: false,
        showWeeks: true,
        yearColumns: 5,
        yearRows: 4
    })

    .controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
        function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
            var self = this,
                ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
                ngModelOptions = {},
                watchListeners = [];

            $element.addClass('uib-datepicker');
            $attrs.$set('role', 'application');

            if (!$scope.datepickerOptions) {
                $scope.datepickerOptions = {};
            }

            // Modes chain
            this.modes = ['day', 'month', 'year'];

            [
                'customClass',
                'dateDisabled',
                'datepickerMode',
                'formatDay',
                'formatDayHeader',
                'formatDayTitle',
                'formatMonth',
                'formatMonthTitle',
                'formatYear',
                'maxDate',
                'maxMode',
                'minDate',
                'minMode',
                'monthColumns',
                'showWeeks',
                'shortcutPropagation',
                'startingDay',
                'yearColumns',
                'yearRows'
            ].forEach(function (key) {
                switch (key) {
                    case 'customClass':
                    case 'dateDisabled':
                        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
                        break;
                    case 'datepickerMode':
                        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
                            $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
                        break;
                    case 'formatDay':
                    case 'formatDayHeader':
                    case 'formatDayTitle':
                    case 'formatMonth':
                    case 'formatMonthTitle':
                    case 'formatYear':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $interpolate($scope.datepickerOptions[key])($scope.$parent) :
                            datepickerConfig[key];
                        break;
                    case 'monthColumns':
                    case 'showWeeks':
                    case 'shortcutPropagation':
                    case 'yearColumns':
                    case 'yearRows':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $scope.datepickerOptions[key] : datepickerConfig[key];
                        break;
                    case 'startingDay':
                        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
                            self.startingDay = $scope.datepickerOptions.startingDay;
                        } else if (angular.isNumber(datepickerConfig.startingDay)) {
                            self.startingDay = datepickerConfig.startingDay;
                        } else {
                            self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
                        }

                        break;
                    case 'maxDate':
                    case 'minDate':
                        $scope.$watch('datepickerOptions.' + key, function (value) {
                            if (value) {
                                if (angular.isDate(value)) {
                                    self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
                                } else {
                                    if ($datepickerLiteralWarning) {
                                        $log.warn('Literal date support has been deprecated, please switch to date object usage');
                                    }

                                    self[key] = new Date(dateFilter(value, 'medium'));
                                }
                            } else {
                                self[key] = datepickerConfig[key] ?
                                    dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
                                    null;
                            }

                            self.refreshView();
                        });

                        break;
                    case 'maxMode':
                    case 'minMode':
                        if ($scope.datepickerOptions[key]) {
                            $scope.$watch(function () { return $scope.datepickerOptions[key]; }, function (value) {
                                self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
                                if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
                                    key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
                                    $scope.datepickerMode = self[key];
                                    $scope.datepickerOptions.datepickerMode = self[key];
                                }
                            });
                        } else {
                            self[key] = $scope[key] = datepickerConfig[key] || null;
                        }

                        break;
                }
            });

            $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if (angular.isDefined($attrs.ngDisabled)) {
                watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
                    $scope.disabled = disabled;
                    self.refreshView();
                }));
            }

            $scope.isActive = function (dateObject) {
                if (self.compare(dateObject.date, self.activeDate) === 0) {
                    $scope.activeDateId = dateObject.uid;
                    return true;
                }
                return false;
            };

            this.init = function (ngModelCtrl_) {
                ngModelCtrl = ngModelCtrl_;
                ngModelOptions = extractOptions(ngModelCtrl);

                if ($scope.datepickerOptions.initDate) {
                    self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
                    $scope.$watch('datepickerOptions.initDate', function (initDate) {
                        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                            self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
                            self.refreshView();
                        }
                    });
                } else {
                    self.activeDate = new Date();
                }

                var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
                this.activeDate = !isNaN(date) ?
                    dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
                    dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

                ngModelCtrl.$render = function () {
                    self.render();
                };
            };

            this.render = function () {
                if (ngModelCtrl.$viewValue) {
                    var date = new Date(ngModelCtrl.$viewValue),
                        isValid = !isNaN(date);

                    if (isValid) {
                        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    } else if (!$datepickerSuppressError) {
                        $log.error('Datepicker directive: "ng-model" value must be a Date object');
                    }
                }
                this.refreshView();
            };

            this.refreshView = function () {
                if (this.element) {
                    $scope.selectedDt = null;
                    this._refreshView();
                    if ($scope.activeDt) {
                        $scope.activeDateId = $scope.activeDt.uid;
                    }

                    var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                    date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setValidity('dateDisabled', !date ||
                        this.element && !this.isDisabled(date));
                }
            };

            this.createDateObject = function (date, format) {
                var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
                var today = new Date();
                today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                var time = this.compare(date, today);
                var dt = {
                    date: date,
                    label: dateParser.filter(date, format),
                    selected: model && this.compare(date, model) === 0,
                    disabled: this.isDisabled(date),
                    past: time < 0,
                    current: time === 0,
                    future: time > 0,
                    customClass: this.customClass(date) || null
                };

                if (model && this.compare(date, model) === 0) {
                    $scope.selectedDt = dt;
                }

                if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
                    $scope.activeDt = dt;
                }

                return dt;
            };

            this.isDisabled = function (date) {
                return $scope.disabled ||
                    this.minDate && this.compare(date, this.minDate) < 0 ||
                    this.maxDate && this.compare(date, this.maxDate) > 0 ||
                    $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
            };

            this.customClass = function (date) {
                return $scope.customClass({ date: date, mode: $scope.datepickerMode });
            };

            // Split array into smaller arrays
            this.split = function (arr, size) {
                var arrays = [];
                while (arr.length > 0) {
                    arrays.push(arr.splice(0, size));
                }
                return arrays;
            };

            $scope.select = function (date) {
                if ($scope.datepickerMode === self.minMode) {
                    var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
                    dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setViewValue(dt);
                    ngModelCtrl.$render();
                } else {
                    self.activeDate = date;
                    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

                    $scope.$emit('uib:datepicker.mode');
                }

                $scope.$broadcast('uib:datepicker.focus');
            };

            $scope.move = function (direction) {
                var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                    month = self.activeDate.getMonth() + direction * (self.step.months || 0);
                self.activeDate.setFullYear(year, month, 1);
                self.refreshView();
            };

            $scope.toggleMode = function (direction) {
                direction = direction || 1;

                if ($scope.datepickerMode === self.maxMode && direction === 1 ||
                    $scope.datepickerMode === self.minMode && direction === -1) {
                    return;
                }

                setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

                $scope.$emit('uib:datepicker.mode');
            };

            // Key event mapper
            $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

            var focusElement = function () {
                self.element[0].focus();
            };

            // Listen for focus requests from popup directive
            $scope.$on('uib:datepicker.focus', focusElement);

            $scope.keydown = function (evt) {
                var key = $scope.keys[evt.which];

                if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
                    return;
                }

                evt.preventDefault();
                if (!self.shortcutPropagation) {
                    evt.stopPropagation();
                }

                if (key === 'enter' || key === 'space') {
                    if (self.isDisabled(self.activeDate)) {
                        return; // do nothing
                    }
                    $scope.select(self.activeDate);
                } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                    $scope.toggleMode(key === 'up' ? 1 : -1);
                } else {
                    self.handleKeyDown(key, evt);
                    self.refreshView();
                }
            };

            $element.on('keydown', function (evt) {
                $scope.$apply(function () {
                    $scope.keydown(evt);
                });
            });

            $scope.$on('$destroy', function () {
                //Clear all watch listeners on destroy
                while (watchListeners.length) {
                    watchListeners.shift()();
                }
            });

            function setMode(mode) {
                $scope.datepickerMode = mode;
                $scope.datepickerOptions.datepickerMode = mode;
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options ||
                        $scope.datepickerOptions.ngModelOptions ||
                        datepickerConfig.ngModelOptions ||
                        {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
                    var timezone = ngModelCtrl.$options.getOption('timezone') ||
                        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
                        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

                    // values passed to createChild override existing values
                    ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
                        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
                        .createChild($scope.datepickerOptions.ngModelOptions)
                        .createChild(ngModelCtrl.$options) // highest precedence
                        .createChild({ timezone: timezone }); // to keep from squashing a non-null value
                }

                return ngModelOptions;
            }
        }])

    .controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        this.step = { months: 1 };
        this.element = $element;
        function getDaysInMonth(year, month) {
            return month === 1 && year % 4 === 0 &&
                (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
        }

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            scope.showWeeks = ctrl.showWeeks;
            ctrl.refreshView();
        };

        this.getDates = function (startDate, n) {
            var dates = new Array(n), current = new Date(startDate), i = 0, date;
            while (i < n) {
                date = new Date(current);
                dates[i++] = date;
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };

        this._refreshView = function () {
            var year = this.activeDate.getFullYear(),
                month = this.activeDate.getMonth(),
                firstDayOfMonth = new Date(this.activeDate);

            firstDayOfMonth.setFullYear(year, month, 1);

            var difference = this.startingDay - firstDayOfMonth.getDay(),
                numDisplayedFromPreviousMonth = difference > 0 ?
                    7 - difference : -difference,
                firstDate = new Date(firstDayOfMonth);

            if (numDisplayedFromPreviousMonth > 0) {
                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            }

            // 42 is the number of days on a six-week calendar
            var days = this.getDates(firstDate, 42);
            for (var i = 0; i < 42; i++) {
                days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
                    secondary: days[i].getMonth() !== month,
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.labels = new Array(7);
            for (var j = 0; j < 7; j++) {
                scope.labels[j] = {
                    abbr: dateFilter(days[j].date, this.formatDayHeader),
                    full: dateFilter(days[j].date, 'EEEE')
                };
            }

            scope.title = dateFilter(this.activeDate, this.formatDayTitle);
            scope.rows = this.split(days, 7);

            if (scope.showWeeks) {
                scope.weekNumbers = [];
                var thursdayIndex = (4 + 7 - this.startingDay) % 7,
                    numWeeks = scope.rows.length;
                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                    scope.weekNumbers.push(
                        getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
                }
            }
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        function getISO8601WeekNumber(date) {
            var checkDate = new Date(date);
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
            var time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        }

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getDate();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - 7;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + 7;
            } else if (key === 'pageup' || key === 'pagedown') {
                var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setMonth(month, 1);
                date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
            } else if (key === 'home') {
                date = 1;
            } else if (key === 'end') {
                date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
            }
            this.activeDate.setDate(date);
        };
    }])

    .controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        this.step = { years: 1 };
        this.element = $element;

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            ctrl.refreshView();
        };

        this._refreshView = function () {
            var months = new Array(12),
                year = this.activeDate.getFullYear(),
                date;

            for (var i = 0; i < 12; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(year, i, 1);
                months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
            scope.rows = this.split(months, this.monthColumns);
            scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getMonth();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - this.monthColumns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + this.monthColumns;
            } else if (key === 'pageup' || key === 'pagedown') {
                var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setFullYear(year);
            } else if (key === 'home') {
                date = 0;
            } else if (key === 'end') {
                date = 11;
            }
            this.activeDate.setMonth(date);
        };
    }])

    .controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var columns, range;
        this.element = $element;

        function getStartingYear(year) {
            return parseInt((year - 1) / range, 10) * range + 1;
        }

        this.yearpickerInit = function () {
            columns = this.yearColumns;
            range = this.yearRows * columns;
            this.step = { years: range };
        };

        this._refreshView = function () {
            var years = new Array(range), date;

            for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(start + i, 0, 1);
                years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = [years[0].label, years[range - 1].label].join(' - ');
            scope.rows = this.split(years, columns);
            scope.columns = columns;
        };

        this.compare = function (date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getFullYear();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - columns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + columns;
            } else if (key === 'pageup' || key === 'pagedown') {
                date += (key === 'pageup' ? -1 : 1) * range;
            } else if (key === 'home') {
                date = getStartingYear(this.activeDate.getFullYear());
            } else if (key === 'end') {
                date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
            }
            this.activeDate.setFullYear(date);
        };
    }])

    .directive('uibDatepicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
            },
            scope: {
                datepickerOptions: '=?'
            },
            require: ['uibDatepicker', '^ngModel'],
            restrict: 'A',
            controller: 'UibDatepickerController',
            controllerAs: 'datepicker',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                datepickerCtrl.init(ngModelCtrl);
            }
        };
    })

    .directive('uibDaypicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/day.html';
            },
            require: ['^uibDatepicker', 'uibDaypicker'],
            restrict: 'A',
            controller: 'UibDaypickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    daypickerCtrl = ctrls[1];

                daypickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibMonthpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/month.html';
            },
            require: ['^uibDatepicker', 'uibMonthpicker'],
            restrict: 'A',
            controller: 'UibMonthpickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    monthpickerCtrl = ctrls[1];

                monthpickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibYearpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/year.html';
            },
            require: ['^uibDatepicker', 'uibYearpicker'],
            restrict: 'A',
            controller: 'UibYearpickerController',
            link: function (scope, element, attrs, ctrls) {
                var ctrl = ctrls[0];
                angular.extend(ctrl, ctrls[1]);
                ctrl.yearpickerInit();

                ctrl.refreshView();
            }
        };
    });

angular.module('ui.bootstrap.position', [])

    /**
     * A set of utility methods for working with the DOM.
     * It is meant to be used where we need to absolute-position elements in
     * relation to another element (this is the case for tooltips, popovers,
     * typeahead suggestions etc.).
     */
    .factory('$uibPosition', ['$document', '$window', function ($document, $window) {
        /**
         * Used by scrollbarWidth() function to cache scrollbar's width.
         * Do not access this variable directly, use scrollbarWidth() instead.
         */
        var SCROLLBAR_WIDTH;
        /**
         * scrollbar on body and html element in IE and Edge overlay
         * content and should be considered 0 width.
         */
        var BODY_SCROLLBAR_WIDTH;
        var OVERFLOW_REGEX = {
            normal: /(auto|scroll)/,
            hidden: /(auto|scroll|hidden)/
        };
        var PLACEMENT_REGEX = {
            auto: /\s?auto?\s?/i,
            primary: /^(top|bottom|left|right)$/,
            secondary: /^(top|bottom|left|right|center)$/,
            vertical: /^(top|bottom)$/
        };
        var BODY_REGEX = /(HTML|BODY)/;

        return {

            /**
             * Provides a raw DOM element from a jQuery/jQLite element.
             *
             * @param {element} elem - The element to convert.
             *
             * @returns {element} A HTML element.
             */
            getRawNode: function (elem) {
                return elem.nodeName ? elem : elem[0] || elem;
            },

            /**
             * Provides a parsed number for a style property.  Strips
             * units and casts invalid numbers to 0.
             *
             * @param {string} value - The style value to parse.
             *
             * @returns {number} A valid number.
             */
            parseStyle: function (value) {
                value = parseFloat(value);
                return isFinite(value) ? value : 0;
            },

            /**
             * Provides the closest positioned ancestor.
             *
             * @param {element} element - The element to get the offest parent for.
             *
             * @returns {element} The closest positioned ancestor.
             */
            offsetParent: function (elem) {
                elem = this.getRawNode(elem);

                var offsetParent = elem.offsetParent || $document[0].documentElement;

                function isStaticPositioned(el) {
                    return ($window.getComputedStyle(el).position || 'static') === 'static';
                }

                while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || $document[0].documentElement;
            },

            /**
             * Provides the scrollbar width, concept from TWBS measureScrollbar()
             * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
             * In IE and Edge, scollbar on body and html element overlay and should
             * return a width of 0.
             *
             * @returns {number} The width of the browser scollbar.
             */
            scrollbarWidth: function (isBody) {
                if (isBody) {
                    if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
                        var bodyElem = $document.find('body');
                        bodyElem.addClass('uib-position-body-scrollbar-measure');
                        BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
                        BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
                        bodyElem.removeClass('uib-position-body-scrollbar-measure');
                    }
                    return BODY_SCROLLBAR_WIDTH;
                }

                if (angular.isUndefined(SCROLLBAR_WIDTH)) {
                    var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
                    $document.find('body').append(scrollElem);
                    SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
                    SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
                    scrollElem.remove();
                }

                return SCROLLBAR_WIDTH;
            },

            /**
             * Provides the padding required on an element to replace the scrollbar.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**scrollbarWidth**: the width of the scrollbar</li>
             *     <li>**widthOverflow**: whether the the width is overflowing</li>
             *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
             *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
             *     <li>**heightOverflow**: whether the the height is overflowing</li>
             *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
             *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
             *   </ul>
             */
            scrollbarPadding: function (elem) {
                elem = this.getRawNode(elem);

                var elemStyle = $window.getComputedStyle(elem);
                var paddingRight = this.parseStyle(elemStyle.paddingRight);
                var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
                var scrollParent = this.scrollParent(elem, false, true);
                var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

                return {
                    scrollbarWidth: scrollbarWidth,
                    widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
                    right: paddingRight + scrollbarWidth,
                    originalRight: paddingRight,
                    heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
                    bottom: paddingBottom + scrollbarWidth,
                    originalBottom: paddingBottom
                };
            },

            /**
             * Checks to see if the element is scrollable.
             *
             * @param {element} elem - The element to check.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             *
             * @returns {boolean} Whether the element is scrollable.
             */
            isScrollable: function (elem, includeHidden) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var elemStyle = $window.getComputedStyle(elem);
                return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
            },

            /**
             * Provides the closest scrollable ancestor.
             * A port of the jQuery UI scrollParent method:
             * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
             *
             * @param {element} elem - The element to find the scroll parent of.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             * @param {boolean=} [includeSelf=false] - Should the element being passed be
             * included in the scrollable llokup.
             *
             * @returns {element} A HTML element.
             */
            scrollParent: function (elem, includeHidden, includeSelf) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var documentEl = $document[0].documentElement;
                var elemStyle = $window.getComputedStyle(elem);
                if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
                    return elem;
                }
                var excludeStatic = elemStyle.position === 'absolute';
                var scrollParent = elem.parentElement || documentEl;

                if (scrollParent === documentEl || elemStyle.position === 'fixed') {
                    return documentEl;
                }

                while (scrollParent.parentElement && scrollParent !== documentEl) {
                    var spStyle = $window.getComputedStyle(scrollParent);
                    if (excludeStatic && spStyle.position !== 'static') {
                        excludeStatic = false;
                    }

                    if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
                        break;
                    }
                    scrollParent = scrollParent.parentElement;
                }

                return scrollParent;
            },

            /**
             * Provides read-only equivalent of jQuery's position function:
             * https://api.jquery.com/position/ - distance to closest positioned
             * ancestor.  Does not account for margins by default like jQuery position.
             *
             * @param {element} elem - The element to caclulate the position on.
             * @param {boolean=} [includeMargins=false] - Should margins be accounted
             * for, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of offset parent</li>
             *     <li>**left**: distance to left edge of offset parent</li>
             *   </ul>
             */
            position: function (elem, includeMagins) {
                elem = this.getRawNode(elem);

                var elemOffset = this.offset(elem);
                if (includeMagins) {
                    var elemStyle = $window.getComputedStyle(elem);
                    elemOffset.top -= this.parseStyle(elemStyle.marginTop);
                    elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
                }
                var parent = this.offsetParent(elem);
                var parentOffset = { top: 0, left: 0 };

                if (parent !== $document[0].documentElement) {
                    parentOffset = this.offset(parent);
                    parentOffset.top += parent.clientTop - parent.scrollTop;
                    parentOffset.left += parent.clientLeft - parent.scrollLeft;
                }

                return {
                    width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
                    top: Math.round(elemOffset.top - parentOffset.top),
                    left: Math.round(elemOffset.left - parentOffset.left)
                };
            },

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * https://api.jquery.com/offset/ - distance to viewport.  Does
             * not account for borders, margins, or padding on the body
             * element.
             *
             * @param {element} elem - The element to calculate the offset on.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of viewport</li>
             *     <li>**right**: distance to bottom edge of viewport</li>
             *   </ul>
             */
            offset: function (elem) {
                elem = this.getRawNode(elem);

                var elemBCR = elem.getBoundingClientRect();
                return {
                    width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
                    top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
                    left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
                };
            },

            /**
             * Provides offset distance to the closest scrollable ancestor
             * or viewport.  Accounts for border and scrollbar width.
             *
             * Right and bottom dimensions represent the distance to the
             * respective edge of the viewport element.  If the element
             * edge extends beyond the viewport, a negative value will be
             * reported.
             *
             * @param {element} elem - The element to get the viewport offset for.
             * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
             * of the first scrollable element, default is false.
             * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
             * be accounted for, default is true.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: distance to the top content edge of viewport element</li>
             *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
             *     <li>**left**: distance to the left content edge of viewport element</li>
             *     <li>**right**: distance to the right content edge of viewport element</li>
             *   </ul>
             */
            viewportOffset: function (elem, useDocument, includePadding) {
                elem = this.getRawNode(elem);
                includePadding = includePadding !== false ? true : false;

                var elemBCR = elem.getBoundingClientRect();
                var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

                var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
                var offsetParentBCR = offsetParent.getBoundingClientRect();

                offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
                offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
                if (offsetParent === $document[0].documentElement) {
                    offsetBCR.top += $window.pageYOffset;
                    offsetBCR.left += $window.pageXOffset;
                }
                offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
                offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

                if (includePadding) {
                    var offsetParentStyle = $window.getComputedStyle(offsetParent);
                    offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
                    offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
                    offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
                    offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
                }

                return {
                    top: Math.round(elemBCR.top - offsetBCR.top),
                    bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
                    left: Math.round(elemBCR.left - offsetBCR.left),
                    right: Math.round(offsetBCR.right - elemBCR.right)
                };
            },

            /**
             * Provides an array of placement values parsed from a placement string.
             * Along with the 'auto' indicator, supported placement strings are:
             *   <ul>
             *     <li>top: element on top, horizontally centered on host element.</li>
             *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
             *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
             *     <li>bottom: element on bottom, horizontally centered on host element.</li>
             *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
             *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
             *     <li>left: element on left, vertically centered on host element.</li>
             *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
             *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
             *     <li>right: element on right, vertically centered on host element.</li>
             *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
             *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
             *   </ul>
             * A placement string with an 'auto' indicator is expected to be
             * space separated from the placement, i.e: 'auto bottom-left'  If
             * the primary and secondary placement values do not match 'top,
             * bottom, left, right' then 'top' will be the primary placement and
             * 'center' will be the secondary placement.  If 'auto' is passed, true
             * will be returned as the 3rd value of the array.
             *
             * @param {string} placement - The placement string to parse.
             *
             * @returns {array} An array with the following values
             * <ul>
             *   <li>**[0]**: The primary placement.</li>
             *   <li>**[1]**: The secondary placement.</li>
             *   <li>**[2]**: If auto is passed: true, else undefined.</li>
             * </ul>
             */
            parsePlacement: function (placement) {
                var autoPlace = PLACEMENT_REGEX.auto.test(placement);
                if (autoPlace) {
                    placement = placement.replace(PLACEMENT_REGEX.auto, '');
                }

                placement = placement.split('-');

                placement[0] = placement[0] || 'top';
                if (!PLACEMENT_REGEX.primary.test(placement[0])) {
                    placement[0] = 'top';
                }

                placement[1] = placement[1] || 'center';
                if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
                    placement[1] = 'center';
                }

                if (autoPlace) {
                    placement[2] = true;
                } else {
                    placement[2] = false;
                }

                return placement;
            },

            /**
             * Provides coordinates for an element to be positioned relative to
             * another element.  Passing 'auto' as part of the placement parameter
             * will enable smart placement - where the element fits. i.e:
             * 'auto left-top' will check to see if there is enough space to the left
             * of the hostElem to fit the targetElem, if not place right (same for secondary
             * top placement).  Available space is calculated using the viewportOffset
             * function.
             *
             * @param {element} hostElem - The element to position against.
             * @param {element} targetElem - The element to position.
             * @param {string=} [placement=top] - The placement for the targetElem,
             *   default is 'top'. 'center' is assumed as secondary placement for
             *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
             *   <ul>
             *     <li>top</li>
             *     <li>top-right</li>
             *     <li>top-left</li>
             *     <li>bottom</li>
             *     <li>bottom-left</li>
             *     <li>bottom-right</li>
             *     <li>left</li>
             *     <li>left-top</li>
             *     <li>left-bottom</li>
             *     <li>right</li>
             *     <li>right-top</li>
             *     <li>right-bottom</li>
             *   </ul>
             * @param {boolean=} [appendToBody=false] - Should the top and left values returned
             *   be calculated from the body element, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: Value for targetElem top.</li>
             *     <li>**left**: Value for targetElem left.</li>
             *     <li>**placement**: The resolved placement.</li>
             *   </ul>
             */
            positionElements: function (hostElem, targetElem, placement, appendToBody) {
                hostElem = this.getRawNode(hostElem);
                targetElem = this.getRawNode(targetElem);

                // need to read from prop to support tests.
                var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
                var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

                placement = this.parsePlacement(placement);

                var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
                var targetElemPos = { top: 0, left: 0, placement: '' };

                if (placement[2]) {
                    var viewportOffset = this.viewportOffset(hostElem, appendToBody);

                    var targetElemStyle = $window.getComputedStyle(targetElem);
                    var adjustedSize = {
                        width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
                        height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
                    };

                    placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                        placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                            placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                                placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                                    placement[0];

                    placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                        placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                            placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                                placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                                    placement[1];

                    if (placement[1] === 'center') {
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
                            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                                placement[1] = 'left';
                            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                                placement[1] = 'right';
                            }
                        } else {
                            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
                            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                                placement[1] = 'top';
                            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                                placement[1] = 'bottom';
                            }
                        }
                    }
                }

                switch (placement[0]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top - targetHeight;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left - targetWidth;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width;
                        break;
                }

                switch (placement[1]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
                        break;
                    case 'center':
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
                        } else {
                            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
                        }
                        break;
                }

                targetElemPos.top = Math.round(targetElemPos.top);
                targetElemPos.left = Math.round(targetElemPos.left);
                targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

                return targetElemPos;
            },

            /**
             * Provides a way to adjust the top positioning after first
             * render to correctly align element to top after content
             * rendering causes resized element height
             *
             * @param {array} placementClasses - The array of strings of classes
             * element should have.
             * @param {object} containerPosition - The object with container
             * position information
             * @param {number} initialHeight - The initial height for the elem.
             * @param {number} currentHeight - The current height for the elem.
             */
            adjustTop: function (placementClasses, containerPosition, initialHeight, currentHeight) {
                if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
                    return {
                        top: containerPosition.top - currentHeight + 'px'
                    };
                }
            },

            /**
             * Provides a way for positioning tooltip & dropdown
             * arrows when using placement options beyond the standard
             * left, right, top, or bottom.
             *
             * @param {element} elem - The tooltip/dropdown element.
             * @param {string} placement - The placement for the elem.
             */
            positionArrow: function (elem, placement) {
                elem = this.getRawNode(elem);

                var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
                if (!innerElem) {
                    return;
                }

                var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

                var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
                if (!arrowElem) {
                    return;
                }

                var arrowCss = {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                };

                placement = this.parsePlacement(placement);
                if (placement[1] === 'center') {
                    // no adjustment necessary - just reset styles
                    angular.element(arrowElem).css(arrowCss);
                    return;
                }

                var borderProp = 'border-' + placement[0] + '-width';
                var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

                var borderRadiusProp = 'border-';
                if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                    borderRadiusProp += placement[0] + '-' + placement[1];
                } else {
                    borderRadiusProp += placement[1] + '-' + placement[0];
                }
                borderRadiusProp += '-radius';
                var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

                switch (placement[0]) {
                    case 'top':
                        arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'bottom':
                        arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'left':
                        arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'right':
                        arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
                        break;
                }

                arrowCss[placement[1]] = borderRadius;

                angular.element(arrowElem).css(arrowCss);
            }
        };
    }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

    .value('$datepickerPopupLiteralWarning', true)

    .constant('uibDatepickerPopupConfig', {
        altInputFormats: [],
        appendToBody: false,
        clearText: 'Clear',
        closeOnDateSelection: true,
        closeText: 'Done',
        currentText: 'Today',
        datepickerPopup: 'yyyy-MM-dd',
        datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
        datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        onOpenFocus: true,
        showButtonBar: true,
        placement: 'auto bottom-left'
    })

    .controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
        function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
            var cache = {},
                isHtml5DateInput = false;
            var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
                datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
                ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

            this.init = function (_ngModel_) {
                ngModel = _ngModel_;
                ngModelOptions = extractOptions(ngModel);
                closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
                    $scope.$parent.$eval($attrs.closeOnDateSelection) :
                    datepickerPopupConfig.closeOnDateSelection;
                appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
                    $scope.$parent.$eval($attrs.datepickerAppendToBody) :
                    datepickerPopupConfig.appendToBody;
                onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
                    $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
                datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
                    $attrs.datepickerPopupTemplateUrl :
                    datepickerPopupConfig.datepickerPopupTemplateUrl;
                datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
                    $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
                altInputFormats = angular.isDefined($attrs.altInputFormats) ?
                    $scope.$parent.$eval($attrs.altInputFormats) :
                    datepickerPopupConfig.altInputFormats;

                $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
                    $scope.$parent.$eval($attrs.showButtonBar) :
                    datepickerPopupConfig.showButtonBar;

                if (datepickerPopupConfig.html5Types[$attrs.type]) {
                    dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
                    $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
                        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
                        // Invalidate the $modelValue to ensure that formatters re-run
                        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = null;

                            if (!dateFormat) {
                                throw new Error('uibDatepickerPopup must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('uibDatepickerPopup must have a date format specified.');
                }

                if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
                    throw new Error('HTML5 date input types do not support custom formats.');
                }

                // popup element used to display calendar
                popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)',
                    'template-url': datepickerPopupTemplateUrl
                });

                // datepicker element
                datepickerEl = angular.element(popupEl.children()[0]);
                datepickerEl.attr('template-url', datepickerTemplateUrl);

                if (!$scope.datepickerOptions) {
                    $scope.datepickerOptions = {};
                }

                if (isHtml5DateInput) {
                    if ($attrs.type === 'month') {
                        $scope.datepickerOptions.datepickerMode = 'month';
                        $scope.datepickerOptions.minMode = 'month';
                    }
                }

                datepickerEl.attr('datepicker-options', 'datepickerOptions');

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'date';
                    ngModel.$validators.date = validator;
                    ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        if (ngModel.$isEmpty(value)) {
                            $scope.date = value;
                            return value;
                        }

                        if (angular.isNumber(value)) {
                            value = new Date(value);
                        }

                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

                        return dateParser.filter($scope.date, dateFormat);
                    });
                } else {
                    ngModel.$formatters.push(function (value) {
                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
                        return value;
                    });
                }

                // Detect changes in the view from the text box
                ngModel.$viewChangeListeners.push(function () {
                    $scope.date = parseDateString(ngModel.$viewValue);
                });

                $element.on('keydown', inputKeydownBind);

                $popup = $compile(popupEl)($scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    $element.after($popup);
                }

                $scope.$on('$destroy', function () {
                    if ($scope.isOpen === true) {
                        if (!$rootScope.$$phase) {
                            $scope.$apply(function () {
                                $scope.isOpen = false;
                            });
                        }
                    }

                    $popup.remove();
                    $element.off('keydown', inputKeydownBind);
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);

                    //Clear all watch listeners on destroy
                    while (watchListeners.length) {
                        watchListeners.shift()();
                    }
                });
            };

            $scope.getText = function (key) {
                return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
            };

            $scope.isDisabled = function (date) {
                if (date === 'today') {
                    date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
                }

                var dates = {};
                angular.forEach(['minDate', 'maxDate'], function (key) {
                    if (!$scope.datepickerOptions[key]) {
                        dates[key] = null;
                    } else if (angular.isDate($scope.datepickerOptions[key])) {
                        dates[key] = new Date($scope.datepickerOptions[key]);
                    } else {
                        if ($datepickerPopupLiteralWarning) {
                            $log.warn('Literal date support has been deprecated, please switch to date object usage');
                        }

                        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
                    }
                });

                return $scope.datepickerOptions &&
                    dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
                    dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
            };

            $scope.compare = function (date1, date2) {
                return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            };

            // Inner change
            $scope.dateSelection = function (dt) {
                $scope.date = dt;
                var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
                $element.val(date);
                ngModel.$setViewValue(date);

                if (closeOnDateSelection) {
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.keydown = function (evt) {
                if (evt.which === 27) {
                    evt.stopPropagation();
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.select = function (date, evt) {
                evt.stopPropagation();

                if (date === 'today') {
                    var today = new Date();
                    if (angular.isDate($scope.date)) {
                        date = new Date($scope.date);
                        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                    } else {
                        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                        date.setHours(0, 0, 0, 0);
                    }
                }
                $scope.dateSelection(date);
            };

            $scope.close = function (evt) {
                evt.stopPropagation();

                $scope.isOpen = false;
                $element[0].focus();
            };

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if ($attrs.ngDisabled) {
                watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
                    $scope.disabled = disabled;
                }));
            }

            $scope.$watch('isOpen', function (value) {
                if (value) {
                    if (!$scope.disabled) {
                        $timeout(function () {
                            positionPopup();

                            if (onOpenFocus) {
                                $scope.$broadcast('uib:datepicker.focus');
                            }

                            $document.on('click', documentClickBind);

                            var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                            if (appendToBody || $position.parsePlacement(placement)[2]) {
                                scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
                                if (scrollParentEl) {
                                    scrollParentEl.on('scroll', positionPopup);
                                }
                            } else {
                                scrollParentEl = null;
                            }

                            angular.element($window).on('resize', positionPopup);
                        }, 0, false);
                    } else {
                        $scope.isOpen = false;
                    }
                } else {
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);
                }
            });

            function cameltoDash(string) {
                return string.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
            }

            function parseDateString(viewValue) {
                var date = dateParser.parse(viewValue, dateFormat, $scope.date);
                if (isNaN(date)) {
                    for (var i = 0; i < altInputFormats.length; i++) {
                        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
                        if (!isNaN(date)) {
                            return date;
                        }
                    }
                }
                return date;
            }

            function parseDate(viewValue) {
                if (angular.isNumber(viewValue)) {
                    // presumably timestamp to date object
                    viewValue = new Date(viewValue);
                }

                if (!viewValue) {
                    return null;
                }

                if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                    return viewValue;
                }

                if (angular.isString(viewValue)) {
                    var date = parseDateString(viewValue);
                    if (!isNaN(date)) {
                        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
                    }
                }

                return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
            }

            function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;

                if (!$attrs.ngRequired && !value) {
                    return true;
                }

                if (angular.isNumber(value)) {
                    value = new Date(value);
                }

                if (!value) {
                    return true;
                }

                if (angular.isDate(value) && !isNaN(value)) {
                    return true;
                }

                if (angular.isString(value)) {
                    return !isNaN(parseDateString(value));
                }

                return false;
            }

            function documentClickBind(event) {
                if (!$scope.isOpen && $scope.disabled) {
                    return;
                }

                var popup = $popup[0];
                var dpContainsTarget = $element[0].contains(event.target);
                // The popup node may not be an element node
                // In some browsers (IE) only element nodes have the 'contains' function
                var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
                if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                }
            }

            function inputKeydownBind(evt) {
                if (evt.which === 27 && $scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                    $element[0].focus();
                } else if (evt.which === 40 && !$scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = true;
                    });
                }
            }

            function positionPopup() {
                if ($scope.isOpen) {
                    var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
                    var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                    var position = $position.positionElements($element, dpElement, placement, appendToBody);
                    dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
                    if (dpElement.hasClass('uib-position-measure')) {
                        dpElement.removeClass('uib-position-measure');
                    }
                }
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
                        ngModelCtrl.$options :
                        {
                            timezone: null
                        };

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }

            $scope.$on('uib:datepicker.mode', function () {
                $timeout(positionPopup, 0, false);
            });
        }])

    .directive('uibDatepickerPopup', function () {
        return {
            require: ['ngModel', 'uibDatepickerPopup'],
            controller: 'UibDatepickerPopupController',
            scope: {
                datepickerOptions: '=?',
                isOpen: '=?',
                currentText: '@',
                clearText: '@',
                closeText: '@'
            },
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0],
                    ctrl = ctrls[1];

                ctrl.init(ngModel);
            }
        };
    })

    .directive('uibDatepickerPopupWrap', function () {
        return {
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
            }
        };
    });

angular.module('ui.bootstrap.debounce', [])
    /**
     * A helper, internal service that debounces a function
     */
    .factory('$$debounce', ['$timeout', function ($timeout) {
        return function (callback, debounceTime) {
            var timeoutPromise;

            return function () {
                var self = this;
                var args = Array.prototype.slice.call(arguments);
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }

                timeoutPromise = $timeout(function () {
                    callback.apply(self, args);
                }, debounceTime);
            };
        };
    }]);

angular.module('ui.bootstrap.multiMap', [])
    /**
     * A helper, internal data structure that stores all references attached to key
     */
    .factory('$$multiMap', function () {
        return {
            createNew: function () {
                var map = {};

                return {
                    entries: function () {
                        return Object.keys(map).map(function (key) {
                            return {
                                key: key,
                                value: map[key]
                            };
                        });
                    },
                    get: function (key) {
                        return map[key];
                    },
                    hasKey: function (key) {
                        return !!map[key];
                    },
                    keys: function () {
                        return Object.keys(map);
                    },
                    put: function (key, value) {
                        if (!map[key]) {
                            map[key] = [];
                        }

                        map[key].push(value);
                    },
                    remove: function (key, value) {
                        var values = map[key];

                        if (!values) {
                            return;
                        }

                        var idx = values.indexOf(value);

                        if (idx !== -1) {
                            values.splice(idx, 1);
                        }

                        if (!values.length) {
                            delete map[key];
                        }
                    }
                };
            }
        };
    });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

    .constant('uibDropdownConfig', {
        appendToOpenClass: 'uib-dropdown-open',
        openClass: 'open'
    })

    .service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
        var openScope = null;
        var openedContainers = $$multiMap.createNew();

        this.isOnlyOpen = function (dropdownScope, appendTo) {
            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (openDropdown) {
                    return openedDropdowns.length === 1;
                }
            }

            return false;
        };

        this.open = function (dropdownScope, element, appendTo) {
            if (!openScope) {
                $document.on('click', closeDropdown);
            }

            if (openScope && openScope !== dropdownScope) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openedScopes = openedDropdowns.map(function (dropdown) {
                    return dropdown.scope;
                });
                if (openedScopes.indexOf(dropdownScope) === -1) {
                    openedContainers.put(appendTo, {
                        scope: dropdownScope
                    });
                }
            } else {
                openedContainers.put(appendTo, {
                    scope: dropdownScope
                });
            }
        };

        this.close = function (dropdownScope, element, appendTo) {
            if (openScope === dropdownScope) {
                $document.off('click', closeDropdown);
                $document.off('keydown', this.keybindFilter);
                openScope = null;
            }

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (dropdownToClose) {
                    openedContainers.remove(appendTo, dropdownToClose);
                }
            }
        };

        var closeDropdown = function (evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope || !openScope.isOpen) { return; }

            if (evt && openScope.getAutoClose() === 'disabled') { return; }

            if (evt && evt.which === 3) { return; }

            var toggleElement = openScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            if (evt && openScope.getAutoClose() === 'outsideClick' &&
                dropdownElement && dropdownElement[0].contains(evt.target)) {
                return;
            }

            openScope.focusToggleElement();
            openScope.isOpen = false;

            if (!$rootScope.$$phase) {
                openScope.$apply();
            }
        };

        this.keybindFilter = function (evt) {
            if (!openScope) {
                // see this.close as ESC could have been pressed which kills the scope so we can not proceed
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            var toggleElement = openScope.getToggleElement();
            var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
            var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
            if (evt.which === 27) {
                evt.stopPropagation();
                openScope.focusToggleElement();
                closeDropdown();
            } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
                evt.preventDefault();
                evt.stopPropagation();
                openScope.focusDropdownEntry(evt.which);
            }
        };
    }])

    .controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
        var self = this,
            scope = $scope.$new(), // create a child scope so we are not polluting original one
            templateScope,
            appendToOpenClass = dropdownConfig.appendToOpenClass,
            openClass = dropdownConfig.openClass,
            getIsOpen,
            setIsOpen = angular.noop,
            toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
            keynavEnabled = false,
            selectedOption = null,
            body = $document.find('body');

        $element.addClass('dropdown');

        this.init = function () {
            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function (value) {
                    scope.isOpen = !!value;
                });
            }

            keynavEnabled = angular.isDefined($attrs.keyboardNav);
        };

        this.toggle = function (open) {
            scope.isOpen = arguments.length ? !!open : !scope.isOpen;
            if (angular.isFunction(setIsOpen)) {
                setIsOpen(scope, scope.isOpen);
            }

            return scope.isOpen;
        };

        // Allow other directives to watch status
        this.isOpen = function () {
            return scope.isOpen;
        };

        scope.getToggleElement = function () {
            return self.toggleElement;
        };

        scope.getAutoClose = function () {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function () {
            return $element;
        };

        scope.isKeynavEnabled = function () {
            return keynavEnabled;
        };

        scope.focusDropdownEntry = function (keyCode) {
            var elems = self.dropdownMenu ? //If append to body is used.
                angular.element(self.dropdownMenu).find('a') :
                $element.find('ul').eq(0).find('a');

            switch (keyCode) {
                case 40: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = 0;
                    } else {
                        self.selectedOption = self.selectedOption === elems.length - 1 ?
                            self.selectedOption :
                            self.selectedOption + 1;
                    }
                    break;
                }
                case 38: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = elems.length - 1;
                    } else {
                        self.selectedOption = self.selectedOption === 0 ?
                            0 : self.selectedOption - 1;
                    }
                    break;
                }
            }
            elems[self.selectedOption].focus();
        };

        scope.getDropdownElement = function () {
            return self.dropdownMenu;
        };

        scope.focusToggleElement = function () {
            if (self.toggleElement) {
                self.toggleElement[0].focus();
            }
        };

        function removeDropdownMenu() {
            $element.append(self.dropdownMenu);
        }

        scope.$watch('isOpen', function (isOpen, wasOpen) {
            var appendTo = null,
                appendToBody = false;

            if (angular.isDefined($attrs.dropdownAppendTo)) {
                var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
                if (appendToEl) {
                    appendTo = angular.element(appendToEl);
                }
            }

            if (angular.isDefined($attrs.dropdownAppendToBody)) {
                var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
                if (appendToBodyValue !== false) {
                    appendToBody = true;
                }
            }

            if (appendToBody && !appendTo) {
                appendTo = body;
            }

            if (appendTo && self.dropdownMenu) {
                if (isOpen) {
                    appendTo.append(self.dropdownMenu);
                    $element.on('$destroy', removeDropdownMenu);
                } else {
                    $element.off('$destroy', removeDropdownMenu);
                    removeDropdownMenu();
                }
            }

            if (appendTo && self.dropdownMenu) {
                var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
                    css,
                    rightalign,
                    scrollbarPadding,
                    scrollbarWidth = 0;

                css = {
                    top: pos.top + 'px',
                    display: isOpen ? 'block' : 'none'
                };

                rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
                if (!rightalign) {
                    css.left = pos.left + 'px';
                    css.right = 'auto';
                } else {
                    css.left = 'auto';
                    scrollbarPadding = $position.scrollbarPadding(appendTo);

                    if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        scrollbarWidth = scrollbarPadding.scrollbarWidth;
                    }

                    css.right = window.innerWidth - scrollbarWidth -
                        (pos.left + $element.prop('offsetWidth')) + 'px';
                }

                // Need to adjust our positioning to be relative to the appendTo container
                // if it's not the body element
                if (!appendToBody) {
                    var appendOffset = $position.offset(appendTo);

                    css.top = pos.top - appendOffset.top + 'px';

                    if (!rightalign) {
                        css.left = pos.left - appendOffset.left + 'px';
                    } else {
                        css.right = window.innerWidth -
                            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
                    }
                }

                self.dropdownMenu.css(css);
            }

            var openContainer = appendTo ? appendTo : $element;
            var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
            var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
            var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

            if (hasOpenClass === !isOpen) {
                var toggleClass;
                if (appendTo) {
                    toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
                } else {
                    toggleClass = isOpen ? 'addClass' : 'removeClass';
                }
                $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
                    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                        toggleInvoker($scope, { open: !!isOpen });
                    }
                });
            }

            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) {
                    $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
                        templateScope = scope.$new();
                        $compile(tplContent.trim())(templateScope, function (dropdownElement) {
                            var newEl = dropdownElement;
                            self.dropdownMenu.replaceWith(newEl);
                            self.dropdownMenu = newEl;
                            $document.on('keydown', uibDropdownService.keybindFilter);
                        });
                    });
                } else {
                    $document.on('keydown', uibDropdownService.keybindFilter);
                }

                scope.focusToggleElement();
                uibDropdownService.open(scope, $element, appendTo);
            } else {
                uibDropdownService.close(scope, $element, appendTo);
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) {
                        templateScope.$destroy();
                    }
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }

                self.selectedOption = null;
            }

            if (angular.isFunction(setIsOpen)) {
                setIsOpen($scope, isOpen);
            }
        });
    }])

    .directive('uibDropdown', function () {
        return {
            controller: 'UibDropdownController',
            link: function (scope, element, attrs, dropdownCtrl) {
                dropdownCtrl.init();
            }
        };
    })

    .directive('uibDropdownMenu', function () {
        return {
            restrict: 'A',
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
                    return;
                }

                element.addClass('dropdown-menu');

                var tplUrl = attrs.templateUrl;
                if (tplUrl) {
                    dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                }

                if (!dropdownCtrl.dropdownMenu) {
                    dropdownCtrl.dropdownMenu = element;
                }
            }
        };
    })

    .directive('uibDropdownToggle', function () {
        return {
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }

                element.addClass('dropdown-toggle');

                dropdownCtrl.toggleElement = element;

                var toggleDropdown = function (event) {
                    event.preventDefault();

                    if (!element.hasClass('disabled') && !attrs.disabled) {
                        scope.$apply(function () {
                            dropdownCtrl.toggle();
                        });
                    }
                };

                element.on('click', toggleDropdown);

                // WAI-ARIA
                element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function () {
                    element.off('click', toggleDropdown);
                });
            }
        };
    });

angular.module('ui.bootstrap.stackedMap', [])
    /**
     * A helper, internal data structure that acts as a map but also allows getting / removing
     * elements in the LIFO order
     */
    .factory('$$stackedMap', function () {
        return {
            createNew: function () {
                var stack = [];

                return {
                    add: function (key, value) {
                        stack.push({
                            key: key,
                            value: value
                        });
                    },
                    get: function (key) {
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                return stack[i];
                            }
                        }
                    },
                    keys: function () {
                        var keys = [];
                        for (var i = 0; i < stack.length; i++) {
                            keys.push(stack[i].key);
                        }
                        return keys;
                    },
                    top: function () {
                        return stack[stack.length - 1];
                    },
                    remove: function (key) {
                        var idx = -1;
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                idx = i;
                                break;
                            }
                        }
                        return stack.splice(idx, 1)[0];
                    },
                    removeTop: function () {
                        return stack.pop();
                    },
                    length: function () {
                        return stack.length;
                    }
                };
            }
        };
    });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
    /**
     * Pluggable resolve mechanism for the modal resolve resolution
     * Supports UI Router's $resolve service
     */
    .provider('$uibResolve', function () {
        var resolve = this;
        this.resolver = null;

        this.setResolver = function (resolver) {
            this.resolver = resolver;
        };

        this.$get = ['$injector', '$q', function ($injector, $q) {
            var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
            return {
                resolve: function (invocables, locals, parent, self) {
                    if (resolver) {
                        return resolver.resolve(invocables, locals, parent, self);
                    }

                    var promises = [];

                    angular.forEach(invocables, function (value) {
                        if (angular.isFunction(value) || angular.isArray(value)) {
                            promises.push($q.resolve($injector.invoke(value)));
                        } else if (angular.isString(value)) {
                            promises.push($q.resolve($injector.get(value)));
                        } else {
                            promises.push($q.resolve(value));
                        }
                    });

                    return $q.all(promises).then(function (resolves) {
                        var resolveObj = {};
                        var resolveIter = 0;
                        angular.forEach(invocables, function (value, key) {
                            resolveObj[key] = resolves[resolveIter++];
                        });

                        return resolveObj;
                    });
                }
            };
        }];
    })

    /**
     * A helper directive for the $modal service. It creates a backdrop element.
     */
    .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
        function ($animate, $injector, $modalStack) {
            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    tElement.addClass(tAttrs.backdropClass);
                    return linkFn;
                }
            };

            function linkFn(scope, element, attrs) {
                if (attrs.modalInClass) {
                    $animate.addClass(element, attrs.modalInClass);

                    scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                        var done = setIsAsync();
                        if (scope.modalOptions.animation) {
                            $animate.removeClass(element, attrs.modalInClass).then(done);
                        } else {
                            done();
                        }
                    });
                }
            }
        }])

    .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
        function ($modalStack, $q, $animateCss, $document) {
            return {
                scope: {
                    index: '@'
                },
                restrict: 'A',
                transclude: true,
                templateUrl: function (tElement, tAttrs) {
                    return tAttrs.templateUrl || 'uib/template/modal/window.html';
                },
                link: function (scope, element, attrs) {
                    element.addClass(attrs.windowTopClass || '');
                    scope.size = attrs.size;

                    scope.close = function (evt) {
                        var modal = $modalStack.getTop();
                        if (modal && modal.value.backdrop &&
                            modal.value.backdrop !== 'static' &&
                            evt.target === evt.currentTarget) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            $modalStack.dismiss(modal.key, 'backdrop click');
                        }
                    };

                    // moved from template to fix issue #2280
                    element.on('click', scope.close);

                    // This property is only added to the scope for the purpose of detecting when this directive is rendered.
                    // We can detect that by using this property in the template associated with this directive and then use
                    // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
                    scope.$isRendered = true;

                    // Deferred object that will be resolved when this modal is rendered.
                    var modalRenderDeferObj = $q.defer();
                    // Resolve render promise post-digest
                    scope.$$postDigest(function () {
                        modalRenderDeferObj.resolve();
                    });

                    modalRenderDeferObj.promise.then(function () {
                        var animationPromise = null;

                        if (attrs.modalInClass) {
                            animationPromise = $animateCss(element, {
                                addClass: attrs.modalInClass
                            }).start();

                            scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                                var done = setIsAsync();
                                $animateCss(element, {
                                    removeClass: attrs.modalInClass
                                }).start().then(done);
                            });
                        }


                        $q.when(animationPromise).then(function () {
                            // Notify {@link $modalStack} that modal is rendered.
                            var modal = $modalStack.getTop();
                            if (modal) {
                                $modalStack.modalRendered(modal.key);
                            }

                            /**
                             * If something within the freshly-opened modal already has focus (perhaps via a
                             * directive that causes focus) then there's no need to try to focus anything.
                             */
                            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
                                var inputWithAutofocus = element[0].querySelector('[autofocus]');
                                /**
                                 * Auto-focusing of a freshly-opened modal element causes any child elements
                                 * with the autofocus attribute to lose focus. This is an issue on touch
                                 * based devices which will show and then hide the onscreen keyboard.
                                 * Attempts to refocus the autofocus element via JavaScript will not reopen
                                 * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
                                 * the modal element if the modal does not contain an autofocus element.
                                 */
                                if (inputWithAutofocus) {
                                    inputWithAutofocus.focus();
                                } else {
                                    element[0].focus();
                                }
                            }
                        });
                    });
                }
            };
        }])

    .directive('uibModalAnimationClass', function () {
        return {
            compile: function (tElement, tAttrs) {
                if (tAttrs.modalAnimation) {
                    tElement.addClass(tAttrs.uibModalAnimationClass);
                }
            }
        };
    })

    .directive('uibModalTransclude', ['$animate', function ($animate) {
        return {
            link: function (scope, element, attrs, controller, transclude) {
                transclude(scope.$parent, function (clone) {
                    element.empty();
                    $animate.enter(clone, element);
                });
            }
        };
    }])

    .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
        '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
        function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
            var OPENED_MODAL_CLASS = 'modal-open';

            var backdropDomEl, backdropScope;
            var openedWindows = $$stackedMap.createNew();
            var openedClasses = $$multiMap.createNew();
            var $modalStack = {
                NOW_CLOSING_EVENT: 'modal.stack.now-closing'
            };
            var topModalIndex = 0;
            var previousTopOpenedModal = null;
            var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

            //Modal focus behavior
            var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
                'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
                'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
            var scrollbarPadding;
            var SNAKE_CASE_REGEXP = /[A-Z]/g;

            // TODO: extract into common dependency with tooltip
            function snake_case(name) {
                var separator = '-';
                return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
                    return (pos ? separator : '') + letter.toLowerCase();
                });
            }

            function isVisible(element) {
                return !!(element.offsetWidth ||
                    element.offsetHeight ||
                    element.getClientRects().length);
            }

            function backdropIndex() {
                var topBackdropIndex = -1;
                var opened = openedWindows.keys();
                for (var i = 0; i < opened.length; i++) {
                    if (openedWindows.get(opened[i]).value.backdrop) {
                        topBackdropIndex = i;
                    }
                }

                // If any backdrop exist, ensure that it's index is always
                // right below the top modal
                if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
                    topBackdropIndex = topModalIndex;
                }
                return topBackdropIndex;
            }

            $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
                if (backdropScope) {
                    backdropScope.index = newBackdropIndex;
                }
            });

            function removeModalWindow(modalInstance, elementToReceiveFocus) {
                var modalWindow = openedWindows.get(modalInstance).value;
                var appendToElement = modalWindow.appendTo;

                //clean up the stack
                openedWindows.remove(modalInstance);
                previousTopOpenedModal = openedWindows.top();
                if (previousTopOpenedModal) {
                    topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
                }

                removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
                    var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
                    openedClasses.remove(modalBodyClass, modalInstance);
                    var areAnyOpen = openedClasses.hasKey(modalBodyClass);
                    appendToElement.toggleClass(modalBodyClass, areAnyOpen);
                    if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        if (scrollbarPadding.originalRight) {
                            appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
                        } else {
                            appendToElement.css({ paddingRight: '' });
                        }
                        scrollbarPadding = null;
                    }
                    toggleTopWindowClass(true);
                }, modalWindow.closedDeferred);
                checkRemoveBackdrop();

                //move focus to specified element if available, or else to body
                if (elementToReceiveFocus && elementToReceiveFocus.focus) {
                    elementToReceiveFocus.focus();
                } else if (appendToElement.focus) {
                    appendToElement.focus();
                }
            }

            // Add or remove "windowTopClass" from the top window in the stack
            function toggleTopWindowClass(toggleSwitch) {
                var modalWindow;

                if (openedWindows.length() > 0) {
                    modalWindow = openedWindows.top().value;
                    modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
                }
            }

            function checkRemoveBackdrop() {
                //remove backdrop if no longer needed
                if (backdropDomEl && backdropIndex() === -1) {
                    var backdropScopeRef = backdropScope;
                    removeAfterAnimate(backdropDomEl, backdropScope, function () {
                        backdropScopeRef = null;
                    });
                    backdropDomEl = undefined;
                    backdropScope = undefined;
                }
            }

            function removeAfterAnimate(domEl, scope, done, closedDeferred) {
                var asyncDeferred;
                var asyncPromise = null;
                var setIsAsync = function () {
                    if (!asyncDeferred) {
                        asyncDeferred = $q.defer();
                        asyncPromise = asyncDeferred.promise;
                    }

                    return function asyncDone() {
                        asyncDeferred.resolve();
                    };
                };
                scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

                // Note that it's intentional that asyncPromise might be null.
                // That's when setIsAsync has not been called during the
                // NOW_CLOSING_EVENT broadcast.
                return $q.when(asyncPromise).then(afterAnimating);

                function afterAnimating() {
                    if (afterAnimating.done) {
                        return;
                    }
                    afterAnimating.done = true;

                    $animate.leave(domEl).then(function () {
                        if (done) {
                            done();
                        }

                        domEl.remove();
                        if (closedDeferred) {
                            closedDeferred.resolve();
                        }
                    });

                    scope.$destroy();
                }
            }

            $document.on('keydown', keydownListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keydown', keydownListener);
            });

            function keydownListener(evt) {
                if (evt.isDefaultPrevented()) {
                    return evt;
                }

                var modal = openedWindows.top();
                if (modal) {
                    switch (evt.which) {
                        case 27: {
                            if (modal.value.keyboard) {
                                evt.preventDefault();
                                $rootScope.$apply(function () {
                                    $modalStack.dismiss(modal.key, 'escape key press');
                                });
                            }
                            break;
                        }
                        case 9: {
                            var list = $modalStack.loadFocusElementList(modal);
                            var focusChanged = false;
                            if (evt.shiftKey) {
                                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                                    focusChanged = $modalStack.focusLastFocusableElement(list);
                                }
                            } else {
                                if ($modalStack.isFocusInLastItem(evt, list)) {
                                    focusChanged = $modalStack.focusFirstFocusableElement(list);
                                }
                            }

                            if (focusChanged) {
                                evt.preventDefault();
                                evt.stopPropagation();
                            }

                            break;
                        }
                    }
                }
            }

            $modalStack.open = function (modalInstance, modal) {
                var modalOpener = $document[0].activeElement,
                    modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

                toggleTopWindowClass(false);

                // Store the current top first, to determine what index we ought to use
                // for the current top modal
                previousTopOpenedModal = openedWindows.top();

                openedWindows.add(modalInstance, {
                    deferred: modal.deferred,
                    renderDeferred: modal.renderDeferred,
                    closedDeferred: modal.closedDeferred,
                    modalScope: modal.scope,
                    backdrop: modal.backdrop,
                    keyboard: modal.keyboard,
                    openedClass: modal.openedClass,
                    windowTopClass: modal.windowTopClass,
                    animation: modal.animation,
                    appendTo: modal.appendTo
                });

                openedClasses.put(modalBodyClass, modalInstance);

                var appendToElement = modal.appendTo,
                    currBackdropIndex = backdropIndex();

                if (currBackdropIndex >= 0 && !backdropDomEl) {
                    backdropScope = $rootScope.$new(true);
                    backdropScope.modalOptions = modal;
                    backdropScope.index = currBackdropIndex;
                    backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
                    backdropDomEl.attr({
                        'class': 'modal-backdrop',
                        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
                        'uib-modal-animation-class': 'fade',
                        'modal-in-class': 'in'
                    });
                    if (modal.backdropClass) {
                        backdropDomEl.addClass(modal.backdropClass);
                    }

                    if (modal.animation) {
                        backdropDomEl.attr('modal-animation', 'true');
                    }
                    $compile(backdropDomEl)(backdropScope);
                    $animate.enter(backdropDomEl, appendToElement);
                    if ($uibPosition.isScrollable(appendToElement)) {
                        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
                        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                            appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
                        }
                    }
                }

                var content;
                if (modal.component) {
                    content = document.createElement(snake_case(modal.component.name));
                    content = angular.element(content);
                    content.attr({
                        resolve: '$resolve',
                        'modal-instance': '$uibModalInstance',
                        close: '$close($value)',
                        dismiss: '$dismiss($value)'
                    });
                } else {
                    content = modal.content;
                }

                // Set the top modal index based on the index of the previous top modal
                topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
                var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
                angularDomEl.attr({
                    'class': 'modal',
                    'template-url': modal.windowTemplateUrl,
                    'window-top-class': modal.windowTopClass,
                    'role': 'dialog',
                    'aria-labelledby': modal.ariaLabelledBy,
                    'aria-describedby': modal.ariaDescribedBy,
                    'size': modal.size,
                    'index': topModalIndex,
                    'animate': 'animate',
                    'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
                    'tabindex': -1,
                    'uib-modal-animation-class': 'fade',
                    'modal-in-class': 'in'
                }).append(content);
                if (modal.windowClass) {
                    angularDomEl.addClass(modal.windowClass);
                }

                if (modal.animation) {
                    angularDomEl.attr('modal-animation', 'true');
                }

                appendToElement.addClass(modalBodyClass);
                if (modal.scope) {
                    // we need to explicitly add the modal index to the modal scope
                    // because it is needed by ngStyle to compute the zIndex property.
                    modal.scope.$$topModalIndex = topModalIndex;
                }
                $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

                openedWindows.top().value.modalDomEl = angularDomEl;
                openedWindows.top().value.modalOpener = modalOpener;

                applyAriaHidden(angularDomEl);

                function applyAriaHidden(el) {
                    if (!el || el[0].tagName === 'BODY') {
                        return;
                    }

                    getSiblings(el).forEach(function (sibling) {
                        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
                            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

                        if (!ariaHiddenCount) {
                            ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
                        }

                        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
                        sibling.setAttribute('aria-hidden', 'true');
                    });

                    return applyAriaHidden(el.parent());

                    function getSiblings(el) {
                        var children = el.parent() ? el.parent().children() : [];

                        return Array.prototype.filter.call(children, function (child) {
                            return child !== el[0];
                        });
                    }
                }
            };

            function broadcastClosing(modalWindow, resultOrReason, closing) {
                return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
            }

            function unhideBackgroundElements() {
                Array.prototype.forEach.call(
                    document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
                    function (hiddenEl) {
                        var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
                            newHiddenCount = ariaHiddenCount - 1;
                        hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

                        if (!newHiddenCount) {
                            hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
                            hiddenEl.removeAttribute('aria-hidden');
                        }
                    }
                );
            }

            $modalStack.close = function (modalInstance, result) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, result, true)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.resolve(result);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }

                return !modalWindow;
            };

            $modalStack.dismiss = function (modalInstance, reason) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.reject(reason);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }
                return !modalWindow;
            };

            $modalStack.dismissAll = function (reason) {
                var topModal = this.getTop();
                while (topModal && this.dismiss(topModal.key, reason)) {
                    topModal = this.getTop();
                }
            };

            $modalStack.getTop = function () {
                return openedWindows.top();
            };

            $modalStack.modalRendered = function (modalInstance) {
                var modalWindow = openedWindows.get(modalInstance);
                if (modalWindow) {
                    modalWindow.value.renderDeferred.resolve();
                }
            };

            $modalStack.focusFirstFocusableElement = function (list) {
                if (list.length > 0) {
                    list[0].focus();
                    return true;
                }
                return false;
            };

            $modalStack.focusLastFocusableElement = function (list) {
                if (list.length > 0) {
                    list[list.length - 1].focus();
                    return true;
                }
                return false;
            };

            $modalStack.isModalFocused = function (evt, modalWindow) {
                if (evt && modalWindow) {
                    var modalDomEl = modalWindow.value.modalDomEl;
                    if (modalDomEl && modalDomEl.length) {
                        return (evt.target || evt.srcElement) === modalDomEl[0];
                    }
                }
                return false;
            };

            $modalStack.isFocusInFirstItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[0];
                }
                return false;
            };

            $modalStack.isFocusInLastItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[list.length - 1];
                }
                return false;
            };

            $modalStack.loadFocusElementList = function (modalWindow) {
                if (modalWindow) {
                    var modalDomE1 = modalWindow.value.modalDomEl;
                    if (modalDomE1 && modalDomE1.length) {
                        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
                        return elements ?
                            Array.prototype.filter.call(elements, function (element) {
                                return isVisible(element);
                            }) : elements;
                    }
                }
            };

            return $modalStack;
        }])

    .provider('$uibModal', function () {
        var $modalProvider = {
            options: {
                animation: true,
                backdrop: true, //can also be false or 'static'
                keyboard: true
            },
            $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
                function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
                    var $modal = {};

                    function getTemplatePromise(options) {
                        return options.template ? $q.when(options.template) :
                            $templateRequest(angular.isFunction(options.templateUrl) ?
                                options.templateUrl() : options.templateUrl);
                    }

                    var promiseChain = null;
                    $modal.getPromiseChain = function () {
                        return promiseChain;
                    };

                    $modal.open = function (modalOptions) {
                        var modalResultDeferred = $q.defer();
                        var modalOpenedDeferred = $q.defer();
                        var modalClosedDeferred = $q.defer();
                        var modalRenderDeferred = $q.defer();

                        //prepare an instance of a modal to be injected into controllers and returned to a caller
                        var modalInstance = {
                            result: modalResultDeferred.promise,
                            opened: modalOpenedDeferred.promise,
                            closed: modalClosedDeferred.promise,
                            rendered: modalRenderDeferred.promise,
                            close: function (result) {
                                return $modalStack.close(modalInstance, result);
                            },
                            dismiss: function (reason) {
                                return $modalStack.dismiss(modalInstance, reason);
                            }
                        };

                        //merge and clean up options
                        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                        modalOptions.resolve = modalOptions.resolve || {};
                        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

                        if (!modalOptions.appendTo.length) {
                            throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
                        }

                        //verify options
                        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
                            throw new Error('One of component or template or templateUrl options is required.');
                        }

                        var templateAndResolvePromise;
                        if (modalOptions.component) {
                            templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
                        } else {
                            templateAndResolvePromise =
                                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
                        }

                        function resolveWithTemplate() {
                            return templateAndResolvePromise;
                        }

                        // Wait for the resolution of the existing promise chain.
                        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                        // Then add to $modalStack and resolve opened.
                        // Finally clean up the chain variable if no subsequent modal has overwritten it.
                        var samePromise;
                        samePromise = promiseChain = $q.all([promiseChain])
                            .then(resolveWithTemplate, resolveWithTemplate)
                            .then(function resolveSuccess(tplAndVars) {
                                var providedScope = modalOptions.scope || $rootScope;

                                var modalScope = providedScope.$new();
                                modalScope.$close = modalInstance.close;
                                modalScope.$dismiss = modalInstance.dismiss;

                                modalScope.$on('$destroy', function () {
                                    if (!modalScope.$$uibDestructionScheduled) {
                                        modalScope.$dismiss('$uibUnscheduledDestruction');
                                    }
                                });

                                var modal = {
                                    scope: modalScope,
                                    deferred: modalResultDeferred,
                                    renderDeferred: modalRenderDeferred,
                                    closedDeferred: modalClosedDeferred,
                                    animation: modalOptions.animation,
                                    backdrop: modalOptions.backdrop,
                                    keyboard: modalOptions.keyboard,
                                    backdropClass: modalOptions.backdropClass,
                                    windowTopClass: modalOptions.windowTopClass,
                                    windowClass: modalOptions.windowClass,
                                    windowTemplateUrl: modalOptions.windowTemplateUrl,
                                    ariaLabelledBy: modalOptions.ariaLabelledBy,
                                    ariaDescribedBy: modalOptions.ariaDescribedBy,
                                    size: modalOptions.size,
                                    openedClass: modalOptions.openedClass,
                                    appendTo: modalOptions.appendTo
                                };

                                var component = {};
                                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                                if (modalOptions.component) {
                                    constructLocals(component, false, true, false);
                                    component.name = modalOptions.component;
                                    modal.component = component;
                                } else if (modalOptions.controller) {
                                    constructLocals(ctrlLocals, true, false, true);

                                    // the third param will make the controller instantiate later,private api
                                    // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                                    ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                                    if (modalOptions.controllerAs && modalOptions.bindToController) {
                                        ctrlInstance = ctrlInstantiate.instance;
                                        ctrlInstance.$close = modalScope.$close;
                                        ctrlInstance.$dismiss = modalScope.$dismiss;
                                        angular.extend(ctrlInstance, {
                                            $resolve: ctrlLocals.$scope.$resolve
                                        }, providedScope);
                                    }

                                    ctrlInstance = ctrlInstantiate();

                                    if (angular.isFunction(ctrlInstance.$onInit)) {
                                        ctrlInstance.$onInit();
                                    }
                                }

                                if (!modalOptions.component) {
                                    modal.content = tplAndVars[0];
                                }

                                $modalStack.open(modalInstance, modal);
                                modalOpenedDeferred.resolve(true);

                                function constructLocals(obj, template, instanceOnScope, injectable) {
                                    obj.$scope = modalScope;
                                    obj.$scope.$resolve = {};
                                    if (instanceOnScope) {
                                        obj.$scope.$uibModalInstance = modalInstance;
                                    } else {
                                        obj.$uibModalInstance = modalInstance;
                                    }

                                    var resolves = template ? tplAndVars[1] : tplAndVars;
                                    angular.forEach(resolves, function (value, key) {
                                        if (injectable) {
                                            obj[key] = value;
                                        }

                                        obj.$scope.$resolve[key] = value;
                                    });
                                }
                            }, function resolveError(reason) {
                                modalOpenedDeferred.reject(reason);
                                modalResultDeferred.reject(reason);
                            })['finally'](function () {
                                if (promiseChain === samePromise) {
                                    promiseChain = null;
                                }
                            });

                        return modalInstance;
                    };

                    return $modal;
                }
            ]
        };

        return $modalProvider;
    });

angular.module('ui.bootstrap.paging', [])
    /**
     * Helper internal service for generating common controller code between the
     * pager and pagination components
     */
    .factory('uibPaging', ['$parse', function ($parse) {
        return {
            create: function (ctrl, $scope, $attrs) {
                ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
                ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
                ctrl._watchers = [];

                ctrl.init = function (ngModelCtrl, config) {
                    ctrl.ngModelCtrl = ngModelCtrl;
                    ctrl.config = config;

                    ngModelCtrl.$render = function () {
                        ctrl.render();
                    };

                    if ($attrs.itemsPerPage) {
                        ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
                            ctrl.itemsPerPage = parseInt(value, 10);
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }));
                    } else {
                        ctrl.itemsPerPage = config.itemsPerPage;
                    }

                    $scope.$watch('totalItems', function (newTotal, oldTotal) {
                        if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }
                    });
                };

                ctrl.calculateTotalPages = function () {
                    var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
                    return Math.max(totalPages || 0, 1);
                };

                ctrl.render = function () {
                    $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
                };

                $scope.selectPage = function (page, evt) {
                    if (evt) {
                        evt.preventDefault();
                    }

                    var clickAllowed = !$scope.ngDisabled || !evt;
                    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                        if (evt && evt.target) {
                            evt.target.blur();
                        }
                        ctrl.ngModelCtrl.$setViewValue(page);
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.getText = function (key) {
                    return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
                };

                $scope.noPrevious = function () {
                    return $scope.page === 1;
                };

                $scope.noNext = function () {
                    return $scope.page === $scope.totalPages;
                };

                ctrl.updatePage = function () {
                    ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

                    if ($scope.page > $scope.totalPages) {
                        $scope.selectPage($scope.totalPages);
                    } else {
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.$on('$destroy', function () {
                    while (ctrl._watchers.length) {
                        ctrl._watchers.shift()();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

    .controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
        $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

        uibPaging.create(this, $scope, $attrs);
    }])

    .constant('uibPagerConfig', {
        itemsPerPage: 10,
        previousText: 'Â« Previous',
        nextText: 'Next Â»',
        align: true
    })

    .directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
        return {
            scope: {
                totalItems: '=',
                previousText: '@',
                nextText: '@',
                ngDisabled: '='
            },
            require: ['uibPager', '?ngModel'],
            restrict: 'A',
            controller: 'UibPagerController',
            controllerAs: 'pager',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pager/pager.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pager');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPagerConfig);
            }
        };
    }]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
    .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
        var ctrl = this;
        // Setup configuration parameters
        var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
            rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
            forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
            boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
            pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) { return $scope.$parent.$eval($attrs.pageLabel, { $page: idx }); } : angular.identity;
        $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
        $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
        $attrs.$set('role', 'menu');

        uibPaging.create(this, $scope, $attrs);

        if ($attrs.maxSize) {
            ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
                maxSize = parseInt(value, 10);
                ctrl.render();
            }));
        }

        // Create page object used in template
        function makePage(number, text, isActive) {
            return {
                number: number,
                text: text,
                active: isActive
            };
        }

        function getPages(currentPage, totalPages) {
            var pages = [];

            // Default page limits
            var startPage = 1, endPage = totalPages;
            var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

            // recompute if maxSize
            if (isMaxSized) {
                if (rotate) {
                    // Current page is displayed in the middle of the visible ones
                    startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                    endPage = startPage + maxSize - 1;

                    // Adjust if limit is exceeded
                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = endPage - maxSize + 1;
                    }
                } else {
                    // Visible pages are paginated with maxSize
                    startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

                    // Adjust last page if limit is exceeded
                    endPage = Math.min(startPage + maxSize - 1, totalPages);
                }
            }

            // Add page number links
            for (var number = startPage; number <= endPage; number++) {
                var page = makePage(number, pageLabel(number), number === currentPage);
                pages.push(page);
            }

            // Add links to move between page sets
            if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
                if (startPage > 1) {
                    if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
                        var previousPageSet = makePage(startPage - 1, '...', false);
                        pages.unshift(previousPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
                            var secondPageLink = makePage(2, '2', false);
                            pages.unshift(secondPageLink);
                        }
                        //add the first page
                        var firstPageLink = makePage(1, '1', false);
                        pages.unshift(firstPageLink);
                    }
                }

                if (endPage < totalPages) {
                    if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
                        var nextPageSet = makePage(endPage + 1, '...', false);
                        pages.push(nextPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
                            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
                            pages.push(secondToLastPageLink);
                        }
                        //add the last page
                        var lastPageLink = makePage(totalPages, totalPages, false);
                        pages.push(lastPageLink);
                    }
                }
            }
            return pages;
        }

        var originalRender = this.render;
        this.render = function () {
            originalRender();
            if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
                $scope.pages = getPages($scope.page, $scope.totalPages);
            }
        };
    }])

    .constant('uibPaginationConfig', {
        itemsPerPage: 10,
        boundaryLinks: false,
        boundaryLinkNumbers: false,
        directionLinks: true,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: true,
        forceEllipses: false
    })

    .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
        return {
            scope: {
                totalItems: '=',
                firstText: '@',
                previousText: '@',
                nextText: '@',
                lastText: '@',
                ngDisabled: '='
            },
            require: ['uibPagination', '?ngModel'],
            restrict: 'A',
            controller: 'UibPaginationController',
            controllerAs: 'pagination',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pagination/pagination.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pagination');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
            }
        };
    }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

    /**
     * The $tooltip service creates tooltip- and popover-like directives as well as
     * houses global options for them.
     */
    .provider('$uibTooltip', function () {
        // The default options tooltip and popover.
        var defaultOptions = {
            placement: 'top',
            placementClassPrefix: '',
            animation: true,
            popupDelay: 0,
            popupCloseDelay: 0,
            useContentExp: false
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'outsideClick': 'outsideClick',
            'focus': 'blur',
            'none': ''
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * `options({})` allows global configuration of all tooltips in the
         * application.
         *
         *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
         *     // place tooltips left instead of top by default
         *     $tooltipProvider.options( { placement: 'left' } );
         *   });
         */
        this.options = function (value) {
            angular.extend(globalOptions, value);
        };

        /**
         * This allows you to extend the set of trigger mappings available. E.g.:
         *
         *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
         */
        this.setTriggers = function setTriggers(triggers) {
            angular.extend(triggerMap, triggers);
        };

        /**
         * This is a helper function for translating camel-case to snake_case.
         */
        function snake_case(name) {
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function (letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /**
         * Returns the actual instance of the $tooltip service.
         * TODO support multiple triggers
         */
        this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
            var openedTooltips = $$stackedMap.createNew();
            $document.on('keyup', keypressListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keyup', keypressListener);
            });

            function keypressListener(e) {
                if (e.which === 27) {
                    var last = openedTooltips.top();
                    if (last) {
                        last.value.close();
                        last = null;
                    }
                }
            }

            return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
                options = angular.extend({}, defaultOptions, globalOptions, options);

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers(trigger) {
                    var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
                    var hide = show.map(function (trigger) {
                        return triggerMap[trigger] || trigger;
                    });
                    return {
                        show: show,
                        hide: hide
                    };
                }

                var directiveName = snake_case(ttType);

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<div ' + directiveName + '-popup ' +
                    'uib-title="' + startSym + 'title' + endSym + '" ' +
                    (options.useContentExp ?
                        'content-exp="contentExp()" ' :
                        'content="' + startSym + 'content' + endSym + '" ') +
                    'origin-scope="origScope" ' +
                    'class="uib-position-measure ' + prefix + '" ' +
                    'tooltip-animation-class="fade"' +
                    'uib-tooltip-classes ' +
                    'ng-class="{ in: isOpen }" ' +
                    '>' +
                    '</div>';

                return {
                    compile: function (tElem, tAttrs) {
                        var tooltipLinker = $compile(template);

                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var showTimeout;
                            var hideTimeout;
                            var positionTimeout;
                            var adjustmentTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
                            var ttScope = scope.$new(true);
                            var repositionScheduled = false;
                            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
                            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
                            var observers = [];
                            var lastPlacement;

                            var positionTooltip = function () {
                                // check if tooltip exists and is not empty
                                if (!tooltip || !tooltip.html()) { return; }

                                if (!positionTimeout) {
                                    positionTimeout = $timeout(function () {
                                        var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                        var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                        var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                                        tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                                        var placementClasses = ttPosition.placement.split('-');

                                        if (!tooltip.hasClass(placementClasses[0])) {
                                            tooltip.removeClass(lastPlacement.split('-')[0]);
                                            tooltip.addClass(placementClasses[0]);
                                        }

                                        if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                                            tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                                            tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                                        }

                                        adjustmentTimeout = $timeout(function () {
                                            var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                            var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                                            if (adjustment) {
                                                tooltip.css(adjustment);
                                            }
                                            adjustmentTimeout = null;
                                        }, 0, false);

                                        // first time through tt element will have the
                                        // uib-position-measure class or if the placement
                                        // has changed we need to position the arrow.
                                        if (tooltip.hasClass('uib-position-measure')) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                            tooltip.removeClass('uib-position-measure');
                                        } else if (lastPlacement !== ttPosition.placement) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                        }
                                        lastPlacement = ttPosition.placement;

                                        positionTimeout = null;
                                    }, 0, false);
                                }
                            };

                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;

                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;

                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) {
                                    showTooltipBind();
                                } else {
                                    hideTooltipBind();
                                }
                            }

                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                    return;
                                }

                                cancelHide();
                                prepareTooltip();

                                if (ttScope.popupDelay) {
                                    // Do nothing if the tooltip was already scheduled to pop-up.
                                    // This happens if show is triggered multiple times before any hide is triggered.
                                    if (!showTimeout) {
                                        showTimeout = $timeout(show, ttScope.popupDelay, false);
                                    }
                                } else {
                                    show();
                                }
                            }

                            function hideTooltipBind() {
                                cancelShow();

                                if (ttScope.popupCloseDelay) {
                                    if (!hideTimeout) {
                                        hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                                    }
                                } else {
                                    hide();
                                }
                            }

                            // Show the tooltip popup element.
                            function show() {
                                cancelShow();
                                cancelHide();

                                // Don't show empty tooltips.
                                if (!ttScope.content) {
                                    return angular.noop;
                                }

                                createTooltip();

                                // And show the tooltip.
                                ttScope.$evalAsync(function () {
                                    ttScope.isOpen = true;
                                    assignIsOpen(true);
                                    positionTooltip();
                                });
                            }

                            function cancelShow() {
                                if (showTimeout) {
                                    $timeout.cancel(showTimeout);
                                    showTimeout = null;
                                }

                                if (positionTimeout) {
                                    $timeout.cancel(positionTimeout);
                                    positionTimeout = null;
                                }
                            }

                            // Hide the tooltip popup element.
                            function hide() {
                                if (!ttScope) {
                                    return;
                                }

                                // First things first: we don't show it anymore.
                                ttScope.$evalAsync(function () {
                                    if (ttScope) {
                                        ttScope.isOpen = false;
                                        assignIsOpen(false);
                                        // And now we remove it from the DOM. However, if we have animation, we
                                        // need to wait for it to expire beforehand.
                                        // FIXME: this is a placeholder for a port of the transitions library.
                                        // The fade transition in TWBS is 150ms.
                                        if (ttScope.animation) {
                                            if (!transitionTimeout) {
                                                transitionTimeout = $timeout(removeTooltip, 150, false);
                                            }
                                        } else {
                                            removeTooltip();
                                        }
                                    }
                                });
                            }

                            function cancelHide() {
                                if (hideTimeout) {
                                    $timeout.cancel(hideTimeout);
                                    hideTimeout = null;
                                }

                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }
                            }

                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) {
                                    return;
                                }

                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                                    if (appendToBody) {
                                        $document.find('body').append(tooltip);
                                    } else {
                                        element.after(tooltip);
                                    }
                                });

                                openedTooltips.add(ttScope, {
                                    close: hide
                                });

                                prepObservers();
                            }

                            function removeTooltip() {
                                cancelShow();
                                cancelHide();
                                unregisterObservers();

                                if (tooltip) {
                                    tooltip.remove();

                                    tooltip = null;
                                    if (adjustmentTimeout) {
                                        $timeout.cancel(adjustmentTimeout);
                                    }
                                }

                                openedTooltips.remove(ttScope);

                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }

                            /**
                             * Set the initial scope values. Once
                             * the tooltip is created, the observers
                             * will be added to keep things in sync.
                             */
                            function prepareTooltip() {
                                ttScope.title = attrs[prefix + 'Title'];
                                if (contentParse) {
                                    ttScope.content = contentParse(scope);
                                } else {
                                    ttScope.content = attrs[ttType];
                                }

                                ttScope.popupClass = attrs[prefix + 'Class'];
                                ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
                                var placement = $position.parsePlacement(ttScope.placement);
                                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

                                var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
                                var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
                            }

                            function assignIsOpen(isOpen) {
                                if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                                    isOpenParse.assign(scope, isOpen);
                                }
                            }

                            ttScope.contentExp = function () {
                                return ttScope.content;
                            };

                            /**
                             * Observe the relevant attributes.
                             */
                            attrs.$observe('disabled', function (val) {
                                if (val) {
                                    cancelShow();
                                }

                                if (val && ttScope.isOpen) {
                                    hide();
                                }
                            });

                            if (isOpenParse) {
                                scope.$watch(isOpenParse, function (val) {
                                    if (ttScope && !val === ttScope.isOpen) {
                                        toggleTooltipBind();
                                    }
                                });
                            }

                            function prepObservers() {
                                observers.length = 0;

                                if (contentParse) {
                                    observers.push(
                                        scope.$watch(contentParse, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            }
                                        })
                                    );

                                    observers.push(
                                        tooltipLinkedScope.$watch(function () {
                                            if (!repositionScheduled) {
                                                repositionScheduled = true;
                                                tooltipLinkedScope.$$postDigest(function () {
                                                    repositionScheduled = false;
                                                    if (ttScope && ttScope.isOpen) {
                                                        positionTooltip();
                                                    }
                                                });
                                            }
                                        })
                                    );
                                } else {
                                    observers.push(
                                        attrs.$observe(ttType, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            } else {
                                                positionTooltip();
                                            }
                                        })
                                    );
                                }

                                observers.push(
                                    attrs.$observe(prefix + 'Title', function (val) {
                                        ttScope.title = val;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );

                                observers.push(
                                    attrs.$observe(prefix + 'Placement', function (val) {
                                        ttScope.placement = val ? val : options.placement;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );
                            }

                            function unregisterObservers() {
                                if (observers.length) {
                                    angular.forEach(observers, function (observer) {
                                        observer();
                                    });
                                    observers.length = 0;
                                }
                            }

                            // hide tooltips/popovers for outsideClick trigger
                            function bodyHideTooltipBind(e) {
                                if (!ttScope || !ttScope.isOpen || !tooltip) {
                                    return;
                                }
                                // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
                                if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                                    hideTooltipBind();
                                }
                            }

                            // KeyboardEvent handler to hide the tooltip on Escape key press
                            function hideOnEscapeKey(e) {
                                if (e.which === 27) {
                                    hideTooltipBind();
                                }
                            }

                            var unregisterTriggers = function () {
                                triggers.show.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        element.off('click', toggleTooltipBind);
                                    } else {
                                        element.off(trigger, showTooltipBind);
                                        element.off(trigger, toggleTooltipBind);
                                    }
                                    element.off('keypress', hideOnEscapeKey);
                                });
                                triggers.hide.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        $document.off('click', bodyHideTooltipBind);
                                    } else {
                                        element.off(trigger, hideTooltipBind);
                                    }
                                });
                            };

                            function prepTriggers() {
                                var showTriggers = [], hideTriggers = [];
                                var val = scope.$eval(attrs[prefix + 'Trigger']);
                                unregisterTriggers();

                                if (angular.isObject(val)) {
                                    Object.keys(val).forEach(function (key) {
                                        showTriggers.push(key);
                                        hideTriggers.push(val[key]);
                                    });
                                    triggers = {
                                        show: showTriggers,
                                        hide: hideTriggers
                                    };
                                } else {
                                    triggers = getTriggers(val);
                                }

                                if (triggers.show !== 'none') {
                                    triggers.show.forEach(function (trigger, idx) {
                                        if (trigger === 'outsideClick') {
                                            element.on('click', toggleTooltipBind);
                                            $document.on('click', bodyHideTooltipBind);
                                        } else if (trigger === triggers.hide[idx]) {
                                            element.on(trigger, toggleTooltipBind);
                                        } else if (trigger) {
                                            element.on(trigger, showTooltipBind);
                                            element.on(triggers.hide[idx], hideTooltipBind);
                                        }
                                        element.on('keypress', hideOnEscapeKey);
                                    });
                                }
                            }

                            prepTriggers();

                            var animation = scope.$eval(attrs[prefix + 'Animation']);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

                            var appendToBodyVal;
                            var appendKey = prefix + 'AppendToBody';
                            if (appendKey in attrs && attrs[appendKey] === undefined) {
                                appendToBodyVal = true;
                            } else {
                                appendToBodyVal = scope.$eval(attrs[appendKey]);
                            }

                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

                            // Make sure tooltip is destroyed and removed.
                            scope.$on('$destroy', function onDestroyTooltip() {
                                unregisterTriggers();
                                removeTooltip();
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }];
    })

    // This is mostly ngInclude code but with a custom scope
    .directive('uibTooltipTemplateTransclude', [
        '$animate', '$sce', '$compile', '$templateRequest',
        function ($animate, $sce, $compile, $templateRequest) {
            return {
                link: function (scope, elem, attrs) {
                    var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

                    var changeCounter = 0,
                        currentScope,
                        previousElement,
                        currentElement;

                    var cleanupLastIncludeContent = function () {
                        if (previousElement) {
                            previousElement.remove();
                            previousElement = null;
                        }

                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }

                        if (currentElement) {
                            $animate.leave(currentElement).then(function () {
                                previousElement = null;
                            });
                            previousElement = currentElement;
                            currentElement = null;
                        }
                    };

                    scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
                        var thisChangeId = ++changeCounter;

                        if (src) {
                            //set the 2nd param to true to ignore the template request error so that the inner
                            //contents and scope can be cleaned up.
                            $templateRequest(src, true).then(function (response) {
                                if (thisChangeId !== changeCounter) { return; }
                                var newScope = origScope.$new();
                                var template = response;

                                var clone = $compile(template)(newScope, function (clone) {
                                    cleanupLastIncludeContent();
                                    $animate.enter(clone, elem);
                                });

                                currentScope = newScope;
                                currentElement = clone;

                                currentScope.$emit('$includeContentLoaded', src);
                            }, function () {
                                if (thisChangeId === changeCounter) {
                                    cleanupLastIncludeContent();
                                    scope.$emit('$includeContentError', src);
                                }
                            });
                            scope.$emit('$includeContentRequested', src);
                        } else {
                            cleanupLastIncludeContent();
                        }
                    });

                    scope.$on('$destroy', cleanupLastIncludeContent);
                }
            };
        }])

    /**
     * Note that it's intentional that these classes are *not* applied through $animate.
     * They must not be animated as they're expected to be present on the tooltip on
     * initialization.
     */
    .directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                // need to set the primary position so the
                // arrow has space during position measure.
                // tooltip.positionTooltip()
                if (scope.placement) {
                    // // There are no top-left etc... classes
                    // // in TWBS, so we need the primary position.
                    var position = $uibPosition.parsePlacement(scope.placement);
                    element.addClass(position[0]);
                }

                if (scope.popupClass) {
                    element.addClass(scope.popupClass);
                }

                if (scope.animation) {
                    element.addClass(attrs.tooltipAnimationClass);
                }
            }
        };
    }])

    .directive('uibTooltipPopup', function () {
        return {
            restrict: 'A',
            scope: { content: '@' },
            templateUrl: 'uib/template/tooltip/tooltip-popup.html'
        };
    })

    .directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
    }])

    .directive('uibTooltipTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
        };
    })

    .directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('uibTooltipHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
        };
    })

    .directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

    .directive('uibPopoverTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/popover/popover-template.html'
        };
    })

    .directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', uibTitle: '@' },
            templateUrl: 'uib/template/popover/popover-html.html'
        };
    })

    .directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverPopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', content: '@' },
            templateUrl: 'uib/template/popover/popover.html'
        };
    })

    .directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopover', 'popover', 'click');
    }]);

angular.module('ui.bootstrap.progressbar', [])

    .constant('uibProgressConfig', {
        animate: true,
        max: 100
    })

    .controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
        var self = this,
            animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

        this.bars = [];
        $scope.max = getMaxOrDefault();

        this.addBar = function (bar, element, attrs) {
            if (!animate) {
                element.css({ 'transition': 'none' });
            }

            this.bars.push(bar);

            bar.max = getMaxOrDefault();
            bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

            bar.$watch('value', function (value) {
                bar.recalculatePercentage();
            });

            bar.recalculatePercentage = function () {
                var totalPercentage = self.bars.reduce(function (total, bar) {
                    bar.percent = +(100 * bar.value / bar.max).toFixed(2);
                    return total + bar.percent;
                }, 0);

                if (totalPercentage > 100) {
                    bar.percent -= totalPercentage - 100;
                }
            };

            bar.$on('$destroy', function () {
                element = null;
                self.removeBar(bar);
            });
        };

        this.removeBar = function (bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        };

        //$attrs.$observe('maxParam', function(maxParam) {
        $scope.$watch('maxParam', function (maxParam) {
            self.bars.forEach(function (bar) {
                bar.max = getMaxOrDefault();
                bar.recalculatePercentage();
            });
        });

        function getMaxOrDefault() {
            return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
        }
    }])

    .directive('uibProgress', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            require: 'uibProgress',
            scope: {
                maxParam: '=?max'
            },
            templateUrl: 'uib/template/progressbar/progress.html'
        };
    })

    .directive('uibBar', function () {
        return {
            replace: true,
            transclude: true,
            require: '^uibProgress',
            scope: {
                value: '=',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/bar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, element, attrs);
            }
        };
    })

    .directive('uibProgressbar', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            scope: {
                value: '=',
                maxParam: '=?max',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/progressbar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
            }
        };
    });

angular.module('ui.bootstrap.rating', [])

    .constant('uibRatingConfig', {
        max: 5,
        stateOn: null,
        stateOff: null,
        enableReset: true,
        titles: ['one', 'two', 'three', 'four', 'five']
    })

    .controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
        var ngModelCtrl = { $setViewValue: angular.noop },
            self = this;

        this.init = function (ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.push(function (value) {
                if (angular.isNumber(value) && value << 0 !== value) {
                    value = Math.round(value);
                }

                return value;
            });

            this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
            this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
            this.enableReset = angular.isDefined($attrs.enableReset) ?
                $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
            var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
            this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
                tmpTitles : ratingConfig.titles;

            var ratingStates = angular.isDefined($attrs.ratingStates) ?
                $scope.$parent.$eval($attrs.ratingStates) :
                new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
            $scope.range = this.buildTemplateObjects(ratingStates);
        };

        this.buildTemplateObjects = function (states) {
            for (var i = 0, n = states.length; i < n; i++) {
                states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
            }
            return states;
        };

        this.getTitle = function (index) {
            if (index >= this.titles.length) {
                return index + 1;
            }

            return this.titles[index];
        };

        $scope.rate = function (value) {
            if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
                var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
                ngModelCtrl.$setViewValue(newViewValue);
                ngModelCtrl.$render();
            }
        };

        $scope.enter = function (value) {
            if (!$scope.readonly) {
                $scope.value = value;
            }
            $scope.onHover({ value: value });
        };

        $scope.reset = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.onLeave();
        };

        $scope.onKeydown = function (evt) {
            if (/(37|38|39|40)/.test(evt.which)) {
                evt.preventDefault();
                evt.stopPropagation();
                $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
            }
        };

        this.render = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.title = self.getTitle($scope.value - 1);
        };
    }])

    .directive('uibRating', function () {
        return {
            require: ['uibRating', 'ngModel'],
            restrict: 'A',
            scope: {
                readonly: '=?readOnly',
                onHover: '&',
                onLeave: '&'
            },
            controller: 'UibRatingController',
            templateUrl: 'uib/template/rating/rating.html',
            link: function (scope, element, attrs, ctrls) {
                var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                ratingCtrl.init(ngModelCtrl);
            }
        };
    });

angular.module('ui.bootstrap.tabs', [])

    .controller('UibTabsetController', ['$scope', function ($scope) {
        var ctrl = this,
            oldIndex;
        ctrl.tabs = [];

        ctrl.select = function (index, evt) {
            if (!destroyed) {
                var previousIndex = findTabIndex(oldIndex);
                var previousSelected = ctrl.tabs[previousIndex];
                if (previousSelected) {
                    previousSelected.tab.onDeselect({
                        $event: evt,
                        $selectedIndex: index
                    });
                    if (evt && evt.isDefaultPrevented()) {
                        return;
                    }
                    previousSelected.tab.active = false;
                }

                var selected = ctrl.tabs[index];
                if (selected) {
                    selected.tab.onSelect({
                        $event: evt
                    });
                    selected.tab.active = true;
                    ctrl.active = selected.index;
                    oldIndex = selected.index;
                } else if (!selected && angular.isDefined(oldIndex)) {
                    ctrl.active = null;
                    oldIndex = null;
                }
            }
        };

        ctrl.addTab = function addTab(tab) {
            ctrl.tabs.push({
                tab: tab,
                index: tab.index
            });
            ctrl.tabs.sort(function (t1, t2) {
                if (t1.index > t2.index) {
                    return 1;
                }

                if (t1.index < t2.index) {
                    return -1;
                }

                return 0;
            });

            if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
                var newActiveIndex = findTabIndex(tab.index);
                ctrl.select(newActiveIndex);
            }
        };

        ctrl.removeTab = function removeTab(tab) {
            var index;
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].tab === tab) {
                    index = i;
                    break;
                }
            }

            if (ctrl.tabs[index].index === ctrl.active) {
                var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
                    index - 1 : index + 1 % ctrl.tabs.length;
                ctrl.select(newActiveTabIndex);
            }

            ctrl.tabs.splice(index, 1);
        };

        $scope.$watch('tabset.active', function (val) {
            if (angular.isDefined(val) && val !== oldIndex) {
                ctrl.select(findTabIndex(val));
            }
        });

        var destroyed;
        $scope.$on('$destroy', function () {
            destroyed = true;
        });

        function findTabIndex(index) {
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].index === index) {
                    return i;
                }
            }
        }
    }])

    .directive('uibTabset', function () {
        return {
            transclude: true,
            replace: true,
            scope: {},
            bindToController: {
                active: '=?',
                type: '@'
            },
            controller: 'UibTabsetController',
            controllerAs: 'tabset',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tabset.html';
            },
            link: function (scope, element, attrs) {
                scope.vertical = angular.isDefined(attrs.vertical) ?
                    scope.$parent.$eval(attrs.vertical) : false;
                scope.justified = angular.isDefined(attrs.justified) ?
                    scope.$parent.$eval(attrs.justified) : false;
            }
        };
    })

    .directive('uibTab', ['$parse', function ($parse) {
        return {
            require: '^uibTabset',
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tab.html';
            },
            transclude: true,
            scope: {
                heading: '@',
                index: '=?',
                classes: '@?',
                onSelect: '&select', //This callback is called in contentHeadingTransclude
                //once it inserts the tab's content into the dom
                onDeselect: '&deselect'
            },
            controller: function () {
                //Empty controller so other directives can require being 'under' a tab
            },
            controllerAs: 'tab',
            link: function (scope, elm, attrs, tabsetCtrl, transclude) {
                scope.disabled = false;
                if (attrs.disable) {
                    scope.$parent.$watch($parse(attrs.disable), function (value) {
                        scope.disabled = !!value;
                    });
                }

                if (angular.isUndefined(attrs.index)) {
                    if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
                        scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) { return t.index; })) + 1;
                    } else {
                        scope.index = 0;
                    }
                }

                if (angular.isUndefined(attrs.classes)) {
                    scope.classes = '';
                }

                scope.select = function (evt) {
                    if (!scope.disabled) {
                        var index;
                        for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
                            if (tabsetCtrl.tabs[i].tab === scope) {
                                index = i;
                                break;
                            }
                        }

                        tabsetCtrl.select(index, evt);
                    }
                };

                tabsetCtrl.addTab(scope);
                scope.$on('$destroy', function () {
                    tabsetCtrl.removeTab(scope);
                });

                //We need to transclude later, once the content container is ready.
                //when this link happens, we're inside a tab heading.
                scope.$transcludeFn = transclude;
            }
        };
    }])

    .directive('uibTabHeadingTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTab',
            link: function (scope, elm) {
                scope.$watch('headingElement', function updateHeadingElement(heading) {
                    if (heading) {
                        elm.html('');
                        elm.append(heading);
                    }
                });
            }
        };
    })

    .directive('uibTabContentTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTabset',
            link: function (scope, elm, attrs) {
                var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

                //Now our tab is ready to be transcluded: both the tab heading area
                //and the tab content area are loaded.  Transclude 'em both.
                tab.$transcludeFn(tab.$parent, function (contents) {
                    angular.forEach(contents, function (node) {
                        if (isTabHeading(node)) {
                            //Let tabHeadingTransclude know.
                            tab.headingElement = node;
                        } else {
                            elm.append(node);
                        }
                    });
                });
            }
        };

        function isTabHeading(node) {
            return node.tagName && (
                node.hasAttribute('uib-tab-heading') ||
                node.hasAttribute('data-uib-tab-heading') ||
                node.hasAttribute('x-uib-tab-heading') ||
                node.tagName.toLowerCase() === 'uib-tab-heading' ||
                node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'uib:tab-heading'
            );
        }
    });

angular.module('ui.bootstrap.timepicker', [])

    .constant('uibTimepickerConfig', {
        hourStep: 1,
        minuteStep: 1,
        secondStep: 1,
        showMeridian: true,
        showSeconds: false,
        meridians: null,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
        showSpinners: true,
        templateUrl: 'uib/template/timepicker/timepicker.html'
    })

    .controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
        var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
        var selected = new Date(),
            watchers = [],
            ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
            meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
            padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

        $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
        $element.removeAttr('tabindex');

        this.init = function (ngModelCtrl_, inputs) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.unshift(function (modelValue) {
                return modelValue ? new Date(modelValue) : null;
            });

            var hoursInputEl = inputs.eq(0),
                minutesInputEl = inputs.eq(1),
                secondsInputEl = inputs.eq(2);

            hoursModelCtrl = hoursInputEl.controller('ngModel');
            minutesModelCtrl = minutesInputEl.controller('ngModel');
            secondsModelCtrl = secondsInputEl.controller('ngModel');

            var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

            if (mousewheel) {
                this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
            if (arrowkeys) {
                this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
            this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
        };

        var hourStep = timepickerConfig.hourStep;
        if ($attrs.hourStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
                hourStep = +value;
            }));
        }

        var minuteStep = timepickerConfig.minuteStep;
        if ($attrs.minuteStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
                minuteStep = +value;
            }));
        }

        var min;
        watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
            var dt = new Date(value);
            min = isNaN(dt) ? undefined : dt;
        }));

        var max;
        watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
            var dt = new Date(value);
            max = isNaN(dt) ? undefined : dt;
        }));

        var disabled = false;
        if ($attrs.ngDisabled) {
            watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
                disabled = value;
            }));
        }

        $scope.noIncrementHours = function () {
            var incrementedSelected = addMinutes(selected, hourStep * 60);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementHours = function () {
            var decrementedSelected = addMinutes(selected, -hourStep * 60);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementMinutes = function () {
            var incrementedSelected = addMinutes(selected, minuteStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementMinutes = function () {
            var decrementedSelected = addMinutes(selected, -minuteStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementSeconds = function () {
            var incrementedSelected = addSeconds(selected, secondStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementSeconds = function () {
            var decrementedSelected = addSeconds(selected, -secondStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noToggleMeridian = function () {
            if (selected.getHours() < 12) {
                return disabled || addMinutes(selected, 12 * 60) > max;
            }

            return disabled || addMinutes(selected, -12 * 60) < min;
        };

        var secondStep = timepickerConfig.secondStep;
        if ($attrs.secondStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
                secondStep = +value;
            }));
        }

        $scope.showSeconds = timepickerConfig.showSeconds;
        if ($attrs.showSeconds) {
            watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
                $scope.showSeconds = !!value;
            }));
        }

        // 12H / 24H mode
        $scope.showMeridian = timepickerConfig.showMeridian;
        if ($attrs.showMeridian) {
            watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
                $scope.showMeridian = !!value;

                if (ngModelCtrl.$error.time) {
                    // Evaluate from template
                    var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                    if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                        selected.setHours(hours);
                        refresh();
                    }
                } else {
                    updateTemplate();
                }
            }));
        }

        // Get $scope.hours in 24H mode if valid
        function getHoursFromTemplate() {
            var hours = +$scope.hours;
            var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
                hours >= 0 && hours < 24;
            if (!valid || $scope.hours === '') {
                return undefined;
            }

            if ($scope.showMeridian) {
                if (hours === 12) {
                    hours = 0;
                }
                if ($scope.meridian === meridians[1]) {
                    hours = hours + 12;
                }
            }
            return hours;
        }

        function getMinutesFromTemplate() {
            var minutes = +$scope.minutes;
            var valid = minutes >= 0 && minutes < 60;
            if (!valid || $scope.minutes === '') {
                return undefined;
            }
            return minutes;
        }

        function getSecondsFromTemplate() {
            var seconds = +$scope.seconds;
            return seconds >= 0 && seconds < 60 ? seconds : undefined;
        }

        function pad(value, noPad) {
            if (value === null) {
                return '';
            }

            return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
                '0' + value : value.toString();
        }

        // Respond on mousewheel spin
        this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            var isScrollingUp = function (e) {
                if (e.originalEvent) {
                    e = e.originalEvent;
                }
                //pick correct delta variable depending on event
                var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                return e.detail || delta > 0;
            };

            hoursInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
                }
                e.preventDefault();
            });

            minutesInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
                }
                e.preventDefault();
            });

            secondsInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
                }
                e.preventDefault();
            });
        };

        // Respond on up/down arrowkeys
        this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            hoursInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementHours();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementHours();
                        $scope.$apply();
                    }
                }
            });

            minutesInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementMinutes();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementMinutes();
                        $scope.$apply();
                    }
                }
            });

            secondsInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementSeconds();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementSeconds();
                        $scope.$apply();
                    }
                }
            });
        };

        this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            if ($scope.readonlyInput) {
                $scope.updateHours = angular.noop;
                $scope.updateMinutes = angular.noop;
                $scope.updateSeconds = angular.noop;
                return;
            }

            var invalidate = function (invalidHours, invalidMinutes, invalidSeconds) {
                ngModelCtrl.$setViewValue(null);
                ngModelCtrl.$setValidity('time', false);
                if (angular.isDefined(invalidHours)) {
                    $scope.invalidHours = invalidHours;
                    if (hoursModelCtrl) {
                        hoursModelCtrl.$setValidity('hours', false);
                    }
                }

                if (angular.isDefined(invalidMinutes)) {
                    $scope.invalidMinutes = invalidMinutes;
                    if (minutesModelCtrl) {
                        minutesModelCtrl.$setValidity('minutes', false);
                    }
                }

                if (angular.isDefined(invalidSeconds)) {
                    $scope.invalidSeconds = invalidSeconds;
                    if (secondsModelCtrl) {
                        secondsModelCtrl.$setValidity('seconds', false);
                    }
                }
            };

            $scope.updateHours = function () {
                var hours = getHoursFromTemplate(),
                    minutes = getMinutesFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(true);
                    } else {
                        refresh('h');
                    }
                } else {
                    invalidate(true);
                }
            };

            hoursInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.hours === null || $scope.hours === '') {
                    invalidate(true);
                } else if (!$scope.invalidHours && $scope.hours < 10) {
                    $scope.$apply(function () {
                        $scope.hours = pad($scope.hours, !padHours);
                    });
                }
            });

            $scope.updateMinutes = function () {
                var minutes = getMinutesFromTemplate(),
                    hours = getHoursFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(undefined, true);
                    } else {
                        refresh('m');
                    }
                } else {
                    invalidate(undefined, true);
                }
            };

            minutesInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.minutes === null) {
                    invalidate(undefined, true);
                } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
                    $scope.$apply(function () {
                        $scope.minutes = pad($scope.minutes);
                    });
                }
            });

            $scope.updateSeconds = function () {
                var seconds = getSecondsFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(seconds)) {
                    selected.setSeconds(seconds);
                    refresh('s');
                } else {
                    invalidate(undefined, undefined, true);
                }
            };

            secondsInputEl.on('blur', function (e) {
                if (modelIsEmpty()) {
                    makeValid();
                } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
                    $scope.$apply(function () {
                        $scope.seconds = pad($scope.seconds);
                    });
                }
            });

        };

        this.render = function () {
            var date = ngModelCtrl.$viewValue;

            if (isNaN(date)) {
                ngModelCtrl.$setValidity('time', false);
                $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            } else {
                if (date) {
                    selected = date;
                }

                if (selected < min || selected > max) {
                    ngModelCtrl.$setValidity('time', false);
                    $scope.invalidHours = true;
                    $scope.invalidMinutes = true;
                } else {
                    makeValid();
                }
                updateTemplate();
            }
        };

        // Call internally when we know that model is valid.
        function refresh(keyboardChange) {
            makeValid();
            ngModelCtrl.$setViewValue(new Date(selected));
            updateTemplate(keyboardChange);
        }

        function makeValid() {
            if (hoursModelCtrl) {
                hoursModelCtrl.$setValidity('hours', true);
            }

            if (minutesModelCtrl) {
                minutesModelCtrl.$setValidity('minutes', true);
            }

            if (secondsModelCtrl) {
                secondsModelCtrl.$setValidity('seconds', true);
            }

            ngModelCtrl.$setValidity('time', true);
            $scope.invalidHours = false;
            $scope.invalidMinutes = false;
            $scope.invalidSeconds = false;
        }

        function updateTemplate(keyboardChange) {
            if (!ngModelCtrl.$modelValue) {
                $scope.hours = null;
                $scope.minutes = null;
                $scope.seconds = null;
                $scope.meridian = meridians[0];
            } else {
                var hours = selected.getHours(),
                    minutes = selected.getMinutes(),
                    seconds = selected.getSeconds();

                if ($scope.showMeridian) {
                    hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
                }

                $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
                if (keyboardChange !== 'm') {
                    $scope.minutes = pad(minutes);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

                if (keyboardChange !== 's') {
                    $scope.seconds = pad(seconds);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
            }
        }

        function addSecondsToSelected(seconds) {
            selected = addSeconds(selected, seconds);
            refresh();
        }

        function addMinutes(selected, minutes) {
            return addSeconds(selected, minutes * 60);
        }

        function addSeconds(date, seconds) {
            var dt = new Date(date.getTime() + seconds * 1000);
            var newDate = new Date(date);
            newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
            return newDate;
        }

        function modelIsEmpty() {
            return ($scope.hours === null || $scope.hours === '') &&
                ($scope.minutes === null || $scope.minutes === '') &&
                (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
        }

        $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
            $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

        $scope.incrementHours = function () {
            if (!$scope.noIncrementHours()) {
                addSecondsToSelected(hourStep * 60 * 60);
            }
        };

        $scope.decrementHours = function () {
            if (!$scope.noDecrementHours()) {
                addSecondsToSelected(-hourStep * 60 * 60);
            }
        };

        $scope.incrementMinutes = function () {
            if (!$scope.noIncrementMinutes()) {
                addSecondsToSelected(minuteStep * 60);
            }
        };

        $scope.decrementMinutes = function () {
            if (!$scope.noDecrementMinutes()) {
                addSecondsToSelected(-minuteStep * 60);
            }
        };

        $scope.incrementSeconds = function () {
            if (!$scope.noIncrementSeconds()) {
                addSecondsToSelected(secondStep);
            }
        };

        $scope.decrementSeconds = function () {
            if (!$scope.noDecrementSeconds()) {
                addSecondsToSelected(-secondStep);
            }
        };

        $scope.toggleMeridian = function () {
            var minutes = getMinutesFromTemplate(),
                hours = getHoursFromTemplate();

            if (!$scope.noToggleMeridian()) {
                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
                } else {
                    $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
                }
            }
        };

        $scope.blur = function () {
            ngModelCtrl.$setTouched();
        };

        $scope.$on('$destroy', function () {
            while (watchers.length) {
                watchers.shift()();
            }
        });
    }])

    .directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
        return {
            require: ['uibTimepicker', '?^ngModel'],
            restrict: 'A',
            controller: 'UibTimepickerController',
            controllerAs: 'timepicker',
            scope: {},
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || uibTimepickerConfig.templateUrl;
            },
            link: function (scope, element, attrs, ctrls) {
                var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (ngModelCtrl) {
                    timepickerCtrl.init(ngModelCtrl, element.find('input'));
                }
            }
        };
    }]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

    /**
     * A helper service that can parse typeahead's syntax (string provided by users)
     * Extracted to a separate service for ease of unit testing
     */
    .factory('uibTypeaheadParser', ['$parse', function ($parse) {
        //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        return {
            parse: function (input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error(
                        'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
                        ' but got "' + input + '".');
                }

                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    }])

    .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
        function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
            var HOT_KEYS = [9, 13, 27, 38, 40];
            var eventDebounceTime = 200;
            var modelCtrl, ngModelOptions;
            //SUPPORTED ATTRIBUTES (OPTIONS)

            //minimal no of characters that needs to be entered before typeahead kicks-in
            var minLength = originalScope.$eval(attrs.typeaheadMinLength);
            if (!minLength && minLength !== 0) {
                minLength = 1;
            }

            originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
                minLength = !newVal && newVal !== 0 ? 1 : newVal;
            });

            //minimal wait time after last character typed before typeahead kicks-in
            var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

            //should it restrict model values to the ones selected from the popup only?
            var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
            originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
                isEditable = newVal !== false;
            });

            //binding to a variable that indicates if matches are being retrieved asynchronously
            var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

            //a function to determine if an event should cause selection
            var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {
                var evt = vals.$event;
                return evt.which === 13 || evt.which === 9;
            };

            //a callback executed when a match is selected
            var onSelectCallback = $parse(attrs.typeaheadOnSelect);

            //should it select highlighted popup value when losing focus?
            var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

            //binding to a variable that indicates if there were no results after the query is completed
            var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

            var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

            var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

            var appendTo = attrs.typeaheadAppendTo ?
                originalScope.$eval(attrs.typeaheadAppendTo) : null;

            var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

            //If input matches an item of the list exactly, select it automatically
            var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

            //binding to a variable that indicates if dropdown is open
            var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

            var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

            //INTERNAL VARIABLES

            //model setter executed upon match selection
            var parsedModel = $parse(attrs.ngModel);
            var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
            var $setModelValue = function (scope, newValue) {
                if (angular.isFunction(parsedModel(originalScope)) &&
                    ngModelOptions.getOption('getterSetter')) {
                    return invokeModelSetter(scope, { $$$p: newValue });
                }

                return parsedModel.assign(scope, newValue);
            };

            //expressions used by typeahead
            var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

            var hasFocus;

            //Used to avoid bug in iOS webview where iOS keyboard does not fire
            //mousedown & mouseup events
            //Issue #3699
            var selected;

            //create a child scope for the typeahead directive so we are not polluting original scope
            //with typeahead-specific data (matches, query etc.)
            var scope = originalScope.$new();
            var offDestroy = originalScope.$on('$destroy', function () {
                scope.$destroy();
            });
            scope.$on('$destroy', offDestroy);

            // WAI-ARIA
            var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
            element.attr({
                'aria-autocomplete': 'list',
                'aria-expanded': false,
                'aria-owns': popupId
            });

            var inputsContainer, hintInputElem;
            //add read-only input to show hint
            if (showHint) {
                inputsContainer = angular.element('<div></div>');
                inputsContainer.css('position', 'relative');
                element.after(inputsContainer);
                hintInputElem = element.clone();
                hintInputElem.attr('placeholder', '');
                hintInputElem.attr('tabindex', '-1');
                hintInputElem.val('');
                hintInputElem.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': '0px',
                    'border-color': 'transparent',
                    'box-shadow': 'none',
                    'opacity': 1,
                    'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
                    'color': '#999'
                });
                element.css({
                    'position': 'relative',
                    'vertical-align': 'top',
                    'background-color': 'transparent'
                });

                if (hintInputElem.attr('id')) {
                    hintInputElem.removeAttr('id'); // remove duplicate id if present.
                }
                inputsContainer.append(hintInputElem);
                hintInputElem.after(element);
            }

            //pop-up element used to display matches
            var popUpEl = angular.element('<div uib-typeahead-popup></div>');
            popUpEl.attr({
                id: popupId,
                matches: 'matches',
                active: 'activeIdx',
                select: 'select(activeIdx, evt)',
                'move-in-progress': 'moveInProgress',
                query: 'query',
                position: 'position',
                'assign-is-open': 'assignIsOpen(isOpen)',
                debounce: 'debounceUpdate'
            });
            //custom item template
            if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
                popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
            }

            if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
                popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
            }

            var resetHint = function () {
                if (showHint) {
                    hintInputElem.val('');
                }
            };

            var resetMatches = function () {
                scope.matches = [];
                scope.activeIdx = -1;
                element.attr('aria-expanded', false);
                resetHint();
            };

            var getMatchId = function (index) {
                return popupId + '-option-' + index;
            };

            // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
            // This attribute is added or removed automatically when the `activeIdx` changes.
            scope.$watch('activeIdx', function (index) {
                if (index < 0) {
                    element.removeAttr('aria-activedescendant');
                } else {
                    element.attr('aria-activedescendant', getMatchId(index));
                }
            });

            var inputIsExactMatch = function (inputValue, index) {
                if (scope.matches.length > index && inputValue) {
                    return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
                }

                return false;
            };

            var getMatchesAsync = function (inputValue, evt) {
                var locals = { $viewValue: inputValue };
                isLoadingSetter(originalScope, true);
                isNoResultsSetter(originalScope, false);
                $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
                    //it might happen that several async queries were in progress if a user were typing fast
                    //but we are interested only in responses that correspond to the current view value
                    var onCurrentRequest = inputValue === modelCtrl.$viewValue;
                    if (onCurrentRequest && hasFocus) {
                        if (matches && matches.length > 0) {
                            scope.activeIdx = focusFirst ? 0 : -1;
                            isNoResultsSetter(originalScope, false);
                            scope.matches.length = 0;

                            //transform labels
                            for (var i = 0; i < matches.length; i++) {
                                locals[parserResult.itemName] = matches[i];
                                scope.matches.push({
                                    id: getMatchId(i),
                                    label: parserResult.viewMapper(scope, locals),
                                    model: matches[i]
                                });
                            }

                            scope.query = inputValue;
                            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                            //due to other elements being rendered
                            recalculatePosition();

                            element.attr('aria-expanded', true);

                            //Select the single remaining option if user input matches
                            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(0, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(0, evt);
                                }
                            }

                            if (showHint) {
                                var firstLabel = scope.matches[0].label;
                                if (angular.isString(inputValue) &&
                                    inputValue.length > 0 &&
                                    firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                                    hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
                                } else {
                                    hintInputElem.val('');
                                }
                            }
                        } else {
                            resetMatches();
                            isNoResultsSetter(originalScope, true);
                        }
                    }
                    if (onCurrentRequest) {
                        isLoadingSetter(originalScope, false);
                    }
                }, function () {
                    resetMatches();
                    isLoadingSetter(originalScope, false);
                    isNoResultsSetter(originalScope, true);
                });
            };

            // bind events only if appendToBody params exist - performance feature
            if (appendToBody) {
                angular.element($window).on('resize', fireRecalculating);
                $document.find('body').on('scroll', fireRecalculating);
            }

            // Declare the debounced function outside recalculating for
            // proper debouncing
            var debouncedRecalculate = $$debounce(function () {
                // if popup is visible
                if (scope.matches.length) {
                    recalculatePosition();
                }

                scope.moveInProgress = false;
            }, eventDebounceTime);

            // Default progress type
            scope.moveInProgress = false;

            function fireRecalculating() {
                if (!scope.moveInProgress) {
                    scope.moveInProgress = true;
                    scope.$digest();
                }

                debouncedRecalculate();
            }

            // recalculate actual position and set new values to scope
            // after digest loop is popup in right position
            function recalculatePosition() {
                scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                scope.position.top += element.prop('offsetHeight');
            }

            //we need to propagate user's query so we can higlight matches
            scope.query = undefined;

            //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
            var timeoutPromise;

            var scheduleSearchWithTimeout = function (inputValue) {
                timeoutPromise = $timeout(function () {
                    getMatchesAsync(inputValue);
                }, waitTime);
            };

            var cancelPreviousTimeout = function () {
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }
            };

            resetMatches();

            scope.assignIsOpen = function (isOpen) {
                isOpenSetter(originalScope, isOpen);
            };

            scope.select = function (activeIdx, evt) {
                //called from within the $digest() cycle
                var locals = {};
                var model, item;

                selected = true;
                locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                model = parserResult.modelMapper(originalScope, locals);
                $setModelValue(originalScope, model);
                modelCtrl.$setValidity('editable', true);
                modelCtrl.$setValidity('parse', true);

                onSelectCallback(originalScope, {
                    $item: item,
                    $model: model,
                    $label: parserResult.viewMapper(originalScope, locals),
                    $event: evt
                });

                resetMatches();

                //return focus to the input element if a match was selected via a mouse click event
                // use timeout to avoid $rootScope:inprog error
                if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
                    $timeout(function () { element[0].focus(); }, 0, false);
                }
            };

            //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
            element.on('keydown', function (evt) {
                //typeahead is open and an "interesting" key was pressed
                if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
                    return;
                }

                var shouldSelect = isSelectEvent(originalScope, { $event: evt });

                /**
                 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
                 * or
                 * shift + tab is pressed to bring focus to the previous element
                 * then clear the results
                 */
                if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
                    resetMatches();
                    scope.$digest();
                    return;
                }

                evt.preventDefault();
                var target;
                switch (evt.which) {
                    case 27: // escape
                        evt.stopPropagation();

                        resetMatches();
                        originalScope.$digest();
                        break;
                    case 38: // up arrow
                        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    case 40: // down arrow
                        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    default:
                        if (shouldSelect) {
                            scope.$apply(function () {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(scope.activeIdx, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(scope.activeIdx, evt);
                                }
                            });
                        }
                }
            });

            element.on('focus', function (evt) {
                hasFocus = true;
                if (minLength === 0 && !modelCtrl.$viewValue) {
                    $timeout(function () {
                        getMatchesAsync(modelCtrl.$viewValue, evt);
                    }, 0);
                }
            });

            element.on('blur', function (evt) {
                if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
                    selected = true;
                    scope.$apply(function () {
                        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
                            $$debounce(function () {
                                scope.select(scope.activeIdx, evt);
                            }, scope.debounceUpdate.blur);
                        } else {
                            scope.select(scope.activeIdx, evt);
                        }
                    });
                }
                if (!isEditable && modelCtrl.$error.editable) {
                    modelCtrl.$setViewValue();
                    scope.$apply(function () {
                        // Reset validity as we are clearing
                        modelCtrl.$setValidity('editable', true);
                        modelCtrl.$setValidity('parse', true);
                    });
                    element.val('');
                }
                hasFocus = false;
                selected = false;
            });

            // Keep reference to click handler to unbind it.
            var dismissClickHandler = function (evt) {
                // Issue #3973
                // Firefox treats right click as a click on document
                if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
                    resetMatches();
                    if (!$rootScope.$$phase) {
                        originalScope.$digest();
                    }
                }
            };

            $document.on('click', dismissClickHandler);

            originalScope.$on('$destroy', function () {
                $document.off('click', dismissClickHandler);
                if (appendToBody || appendTo) {
                    $popup.remove();
                }

                if (appendToBody) {
                    angular.element($window).off('resize', fireRecalculating);
                    $document.find('body').off('scroll', fireRecalculating);
                }
                // Prevent jQuery cache memory leak
                popUpEl.remove();

                if (showHint) {
                    inputsContainer.remove();
                }
            });

            var $popup = $compile(popUpEl)(scope);

            if (appendToBody) {
                $document.find('body').append($popup);
            } else if (appendTo) {
                angular.element(appendTo).eq(0).append($popup);
            } else {
                element.after($popup);
            }

            this.init = function (_modelCtrl) {
                modelCtrl = _modelCtrl;
                ngModelOptions = extractOptions(modelCtrl);

                scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

                //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                modelCtrl.$parsers.unshift(function (inputValue) {
                    hasFocus = true;

                    if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                        if (waitTime > 0) {
                            cancelPreviousTimeout();
                            scheduleSearchWithTimeout(inputValue);
                        } else {
                            getMatchesAsync(inputValue);
                        }
                    } else {
                        isLoadingSetter(originalScope, false);
                        cancelPreviousTimeout();
                        resetMatches();
                    }

                    if (isEditable) {
                        return inputValue;
                    }

                    if (!inputValue) {
                        // Reset in case user had typed something previously.
                        modelCtrl.$setValidity('editable', true);
                        return null;
                    }

                    modelCtrl.$setValidity('editable', false);
                    return undefined;
                });

                modelCtrl.$formatters.push(function (modelValue) {
                    var candidateViewValue, emptyViewValue;
                    var locals = {};

                    // The validity may be set to false via $parsers (see above) if
                    // the model is restricted to selected values. If the model
                    // is set manually it is considered to be valid.
                    if (!isEditable) {
                        modelCtrl.$setValidity('editable', true);
                    }

                    if (inputFormatter) {
                        locals.$model = modelValue;
                        return inputFormatter(originalScope, locals);
                    }

                    //it might happen that we don't have enough info to properly render input value
                    //we need to check for this situation and simply return model value if we can't apply custom formatting
                    locals[parserResult.itemName] = modelValue;
                    candidateViewValue = parserResult.viewMapper(originalScope, locals);
                    locals[parserResult.itemName] = undefined;
                    emptyViewValue = parserResult.viewMapper(originalScope, locals);

                    return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                });
            };

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options || {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }
        }])

    .directive('uibTypeahead', function () {
        return {
            controller: 'UibTypeaheadController',
            require: ['ngModel', 'uibTypeahead'],
            link: function (originalScope, element, attrs, ctrls) {
                ctrls[1].init(ctrls[0]);
            }
        };
    })

    .directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
        return {
            scope: {
                matches: '=',
                query: '=',
                active: '=',
                position: '&',
                moveInProgress: '=',
                select: '&',
                assignIsOpen: '&',
                debounce: '&'
            },
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
            },
            link: function (scope, element, attrs) {
                scope.templateUrl = attrs.templateUrl;

                scope.isOpen = function () {
                    var isDropdownOpen = scope.matches.length > 0;
                    scope.assignIsOpen({ isOpen: isDropdownOpen });
                    return isDropdownOpen;
                };

                scope.isActive = function (matchIdx) {
                    return scope.active === matchIdx;
                };

                scope.selectActive = function (matchIdx) {
                    scope.active = matchIdx;
                };

                scope.selectMatch = function (activeIdx, evt) {
                    var debounce = scope.debounce();
                    if (angular.isNumber(debounce) || angular.isObject(debounce)) {
                        $$debounce(function () {
                            scope.select({ activeIdx: activeIdx, evt: evt });
                        }, angular.isNumber(debounce) ? debounce : debounce['default']);
                    } else {
                        scope.select({ activeIdx: activeIdx, evt: evt });
                    }
                };
            }
        };
    }])

    .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
        return {
            scope: {
                index: '=',
                match: '=',
                query: '='
            },
            link: function (scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
                $templateRequest(tplUrl).then(function (tplContent) {
                    var tplEl = angular.element(tplContent.trim());
                    element.replaceWith(tplEl);
                    $compile(tplEl)(scope);
                });
            }
        };
    }])

    .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
        var isSanitizePresent;
        isSanitizePresent = $injector.has('$sanitize');

        function escapeRegexp(queryToEscape) {
            // Regex: capture the whole query string and replace it with the string that will be used to match
            // the results, for example if the capture is "a" the result will be \a
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        function containsHtml(matchItem) {
            return /<.*>/g.test(matchItem);
        }

        return function (matchItem, query) {
            if (!isSanitizePresent && containsHtml(matchItem)) {
                $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
            }
            matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
            if (!isSanitizePresent) {
                matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
            }
            return matchItem;
        };
    }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion-group.html",
        "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
        "  <h4 class=\"panel-title\">\n" +
        "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
        "  </h4>\n" +
        "</div>\n" +
        "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
        "  <div class=\"panel-body\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion.html",
        "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/alert/alert.html",
        "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
        "  <span aria-hidden=\"true\">&times;</span>\n" +
        "  <span class=\"sr-only\">Close</span>\n" +
        "</button>\n" +
        "<div ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/carousel.html",
        "<div class=\"carousel-inner\" ng-transclude></div>\n" +
        "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
        "  <span class=\"sr-only\">previous</span>\n" +
        "</a>\n" +
        "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
        "  <span class=\"sr-only\">next</span>\n" +
        "</a>\n" +
        "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
        "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
        "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
        "  </li>\n" +
        "</ol>\n" +
        "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/slide.html",
        "<div class=\"text-center\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/datepicker.html",
        "<div ng-switch=\"datepickerMode\">\n" +
        "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
        "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
        "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/day.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
        "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/month.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/year.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepickerPopup/popup.html",
        "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
        "  <li ng-transclude></li>\n" +
        "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
        "    <span class=\"btn-group pull-left\">\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
        "    </span>\n" +
        "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
        "  </li>\n" +
        "</ul>\n" +
        "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/modal/window.html",
        "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
        "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pager/pager.html",
        "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pagination/pagination.html",
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\"\n" +
        "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-html.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-template.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\"\n" +
        "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/bar.html",
        "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progress.html",
        "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progressbar.html",
        "<div class=\"progress\">\n" +
        "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/rating/rating.html",
        "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
        "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
        "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
        "</span>\n" +
        "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tab.html",
        "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
        "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
        "</li>\n" +
        "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tabset.html",
        "<div>\n" +
        "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
        "  <div class=\"tab-content\">\n" +
        "    <div class=\"tab-pane\"\n" +
        "         ng-repeat=\"tab in tabset.tabs\"\n" +
        "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
        "         uib-tab-content-transclude=\"tab\">\n" +
        "    </div>\n" +
        "  </div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/timepicker/timepicker.html",
        "<table class=\"uib-timepicker\">\n" +
        "  <tbody>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
        "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
        "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
        "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
        "    </tr>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-match.html",
        "<a href\n" +
        "   tabindex=\"-1\"\n" +
        "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
        "   ng-attr-title=\"{{match.label}}\"></a>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-popup.html",
        "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
        "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
        "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
        "    </li>\n" +
        "</ul>\n" +
        "");
}]);
angular.module('ui.bootstrap.carousel').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi PievilÃ¤inen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */
/* global module, define */

; (function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory()
    } else if (typeof define === 'function' && define.amd) {
        define([], factory)
    } else {
        root.RRule = factory(root)
        root.RRuleSet = root.RRule.RRuleSet
        root.rrulestr = root.RRule.rrulestr
    }
}(typeof window === 'object' ? window : this, function (root) {
    // =============================================================================
    // Date utilities
    // =============================================================================

    /**
     * General date-related utilities.
     * Also handles several incompatibilities between JavaScript and Python
     *
     */
    var dateutil = {
        MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

        /**
         * Number of milliseconds of one day
         */
        ONE_DAY: 1000 * 60 * 60 * 24,

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.MAXYEAR>
         */
        MAXYEAR: 9999,

        /**
         * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
         * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
         * therefore we use 1-Jan-1970 instead
         */
        ORDINAL_BASE: new Date(1970, 0, 1),

        /**
         * Python: MO-SU: 0 - 6
         * JS: SU-SAT 0 - 6
         */
        PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],

        /**
         * py_date.timetuple()[7]
         */
        getYearDay: function (date) {
            var dateNoTime = new Date(
                date.getFullYear(), date.getMonth(), date.getDate())
            return Math.ceil(
                (dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1
        },

        isLeapYear: function (year) {
            if (year instanceof Date) year = year.getFullYear()
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
        },

        /**
         * @return {Number} the date's timezone offset in ms
         */
        tzOffset: function (date) {
            return date.getTimezoneOffset() * 60 * 1000
        },

        /**
         * @see: <https://www.mcfedries.com/JavaScript/DaysBetween.asp>
         */
        daysBetween: function (date1, date2) {
            // The number of milliseconds in one day
            // Convert both dates to milliseconds
            var date1_ms = date1.getTime() - dateutil.tzOffset(date1)
            var date2_ms = date2.getTime() - dateutil.tzOffset(date2)
            // Calculate the difference in milliseconds
            var difference_ms = Math.abs(date1_ms - date2_ms)
            // Convert back to days and return
            return Math.round(difference_ms / dateutil.ONE_DAY)
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.date.toordinal>
         */
        toOrdinal: function (date) {
            return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
        },

        /**
         * @see - <https://docs.python.org/library/datetime.html#datetime.date.fromordinal>
         */
        fromOrdinal: function (ordinal) {
            var millisecsFromBase = ordinal * dateutil.ONE_DAY
            return new Date(dateutil.ORDINAL_BASE.getTime() -
                dateutil.tzOffset(dateutil.ORDINAL_BASE) +
                millisecsFromBase +
                dateutil.tzOffset(new Date(millisecsFromBase)))
        },

        /**
         * @see: <https://docs.python.org/library/calendar.html#calendar.monthrange>
         */
        monthRange: function (year, month) {
            var date = new Date(year, month, 1)
            return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
        },

        getMonthDays: function (date) {
            var month = date.getMonth()
            return month === 1 && dateutil.isLeapYear(date)
                ? 29 : dateutil.MONTH_DAYS[month]
        },

        /**
         * @return {Number} python-like weekday
         */
        getWeekday: function (date) {
            return dateutil.PY_WEEKDAYS[date.getDay()]
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.datetime.combine>
         */
        combine: function (date, time) {
            time = time || date
            return new Date(
                date.getFullYear(), date.getMonth(), date.getDate(),
                time.getHours(), time.getMinutes(), time.getSeconds(),
                time.getMilliseconds())
        },

        clone: function (date) {
            var dolly = new Date(date.getTime())
            return dolly
        },

        cloneDates: function (dates) {
            var clones = []
            for (var i = 0; i < dates.length; i++) {
                clones.push(dateutil.clone(dates[i]))
            }
            return clones
        },

        /**
         * Sorts an array of Date or dateutil.Time objects
         */
        sort: function (dates) {
            dates.sort(function (a, b) {
                return a.getTime() - b.getTime()
            })
        },

        timeToUntilString: function (time) {
            var comp
            var date = new Date(time)
            var comps = [
                date.getUTCFullYear(),
                date.getUTCMonth() + 1,
                date.getUTCDate(),
                'T',
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
                'Z'
            ]

            for (var i = 0; i < comps.length; i++) {
                comp = comps[i]
                if (!/[TZ]/.test(comp) && comp < 10) comps[i] = '0' + String(comp)
            }
            return comps.join('')
        },

        untilStringToDate: function (until) {
            var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z)?$/
            var bits = re.exec(until)
            if (!bits) throw new Error('Invalid UNTIL value: ' + until)
            return new Date(Date.UTC(
                bits[1],
                bits[2] - 1,
                bits[3],
                bits[5] || 0,
                bits[6] || 0,
                bits[7] || 0))
        }
    }

    dateutil.Time = function (hour, minute, second, millisecond) {
        this.hour = hour
        this.minute = minute
        this.second = second
        this.millisecond = millisecond || 0
    }

    dateutil.Time.prototype = {
        constructor: dateutil.Time,
        getHours: function () {
            return this.hour
        },
        getMinutes: function () {
            return this.minute
        },
        getSeconds: function () {
            return this.second
        },
        getMilliseconds: function () {
            return this.millisecond
        },
        getTime: function () {
            return ((this.hour * 60 * 60) + (this.minute * 60) + this.second) * 1000 +
                this.millisecond
        }
    }

    // =============================================================================
    // Helper functions
    // =============================================================================

    /**
     * Simplified version of python's range()
     */
    var range = function (start, end) {
        if (arguments.length === 1) {
            end = start
            start = 0
        }
        var rang = []
        for (var i = start; i < end; i++) rang.push(i)
        return rang
    }

    var repeat = function (value, times) {
        var i = 0
        var array = []

        if (value instanceof Array) {
            for (; i < times; i++) array[i] = [].concat(value)
        } else {
            for (; i < times; i++) array[i] = value
        }
        return array
    }

    /**
     * Python like split
     */
    var split = function (str, sep, num) {
        var splits = str.split(sep)
        return num
            ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits
    }

    /**
     * closure/goog/math/math.js:modulo
     * Copyright 2006 The Closure Library Authors.
     * The % operator in JavaScript returns the remainder of a / b, but differs from
     * some other languages in that the result will have the same sign as the
     * dividend. For example, -1 % 8 == -1, whereas in some other languages
     * (such as Python) the result would be 7. This function emulates the more
     * correct modulo behavior, which is useful for certain applications such as
     * calculating an offset index in a circular list.
     *
     * @param {number} a The dividend.
     * @param {number} b The divisor.
     * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
     *     or b < x <= 0, depending on the sign of b).
     */
    var pymod = function (a, b) {
        var r = a % b
        // If r and b differ in sign, add b to wrap the result to the correct sign.
        return (r * b < 0) ? r + b : r
    }

    /**
     * @see: <https://docs.python.org/library/functions.html#divmod>
     */
    var divmod = function (a, b) {
        return { div: Math.floor(a / b), mod: pymod(a, b) }
    }

    /**
     * Python-like boolean
     * @return {Boolean} value of an object/primitive, taking into account
     * the fact that in Python an empty list's/tuple's
     * boolean value is False, whereas in JS it's true
     */
    var plb = function (obj) {
        return (obj instanceof Array && obj.length === 0)
            ? false : Boolean(obj)
    }

    /**
     * Return true if a value is in an array
     */
    var contains = function (arr, val) {
        return arr.indexOf(val) !== -1
    }

    // =============================================================================
    // Date masks
    // =============================================================================

    // Every mask is 7 days longer to handle cross-year weekly periods.

    var M365MASK = [].concat(
        repeat(1, 31), repeat(2, 28), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M366MASK = [].concat(
        repeat(1, 31), repeat(2, 29), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M28 = range(1, 29)
    var M29 = range(1, 30)
    var M30 = range(1, 31)
    var M31 = range(1, 32)

    var MDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var MDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    M28 = range(-28, 0)
    M29 = range(-29, 0)
    M30 = range(-30, 0)
    M31 = range(-31, 0)

    var NMDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var NMDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
    var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365]

    var WDAYMASK = (function () {
        for (var wdaymask = [], i = 0; i < 55; i++) wdaymask = wdaymask.concat(range(7))
        return wdaymask
    }())

    // =============================================================================
    // Weekday
    // =============================================================================

    var Weekday = function (weekday, n) {
        if (n === 0) throw new Error("Can't create weekday with n == 0")
        this.weekday = weekday
        this.n = n
    }

    Weekday.prototype = {
        constructor: Weekday,
        // __call__ - Cannot call the object directly, do it through
        // e.g. RRule.TH.nth(-1) instead,
        nth: function (n) {
            return this.n === n ? this : new Weekday(this.weekday, n)
        },

        // __eq__
        equals: function (other) {
            return this.weekday === other.weekday && this.n === other.n
        },

        // __repr__
        toString: function () {
            var s = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'][this.weekday]
            if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s
            return s
        },

        getJsWeekday: function () {
            return this.weekday === 6 ? 0 : this.weekday + 1
        }

    }

    // =============================================================================
    // RRule
    // =============================================================================

    /**
     *
     * @param {Object?} options - see <https://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
     *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
     * @constructor
     */
    var RRule = function (options, noCache) {
        options = options || {}
        // RFC string
        this._string = null
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }

        // used by toString()
        this.origOptions = {}

        var invalid = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        // Shallow copy for origOptions and check for invalid
        keys.forEach(function (key) {
            this.origOptions[key] = options[key]
            if (!contains(defaultKeys, key)) invalid.push(key)
        }, this)

        if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

        if (!RRule.FREQUENCIES[options.freq] && options.byeaster === null) {
            throw new Error('Invalid frequency: ' + String(options.freq))
        }

        // Merge in default options
        defaultKeys.forEach(function (key) {
            if (!contains(keys, key)) options[key] = RRule.DEFAULT_OPTIONS[key]
        })

        var opts = this.options = options

        if (opts.byeaster !== null) opts.freq = RRule.YEARLY
        if (!opts.dtstart) opts.dtstart = new Date()

        var millisecondModulo = opts.dtstart.getTime() % 1000
        if (opts.wkst === null) {
            opts.wkst = RRule.MO.weekday
        } else if (typeof opts.wkst === 'number') {
            // cool, just keep it like that
        } else {
            opts.wkst = opts.wkst.weekday
        }

        if (opts.bysetpos !== null) {
            if (typeof opts.bysetpos === 'number') opts.bysetpos = [opts.bysetpos]

            for (var i = 0; i < opts.bysetpos.length; i++) {
                var v = opts.bysetpos[i]
                if (v === 0 || !(v >= -366 && v <= 366)) {
                    throw new Error('bysetpos must be between 1 and 366,' +
                        ' or between -366 and -1')
                }
            }
        }

        if (!(plb(opts.byweekno) || plb(opts.byyearday) || plb(opts.bymonthday) ||
            opts.byweekday !== null || opts.byeaster !== null)) {
            switch (opts.freq) {
                case RRule.YEARLY:
                    if (!opts.bymonth) opts.bymonth = opts.dtstart.getMonth() + 1
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.MONTHLY:
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.WEEKLY:
                    opts.byweekday = dateutil.getWeekday(opts.dtstart)
                    break
            }
        }

        // bymonth
        if (opts.bymonth !== null && !(opts.bymonth instanceof Array)) {
            opts.bymonth = [opts.bymonth]
        }
        // byyearday
        if (opts.byyearday !== null && !(opts.byyearday instanceof Array)) {
            opts.byyearday = [opts.byyearday]
        }

        // bymonthday
        if (opts.bymonthday === null) {
            opts.bymonthday = []
            opts.bynmonthday = []
        } else if (opts.bymonthday instanceof Array) {
            var bymonthday = []
            var bynmonthday = []

            for (i = 0; i < opts.bymonthday.length; i++) {
                v = opts.bymonthday[i]
                if (v > 0) {
                    bymonthday.push(v)
                } else if (v < 0) {
                    bynmonthday.push(v)
                }
            }
            opts.bymonthday = bymonthday
            opts.bynmonthday = bynmonthday
        } else {
            if (opts.bymonthday < 0) {
                opts.bynmonthday = [opts.bymonthday]
                opts.bymonthday = []
            } else {
                opts.bynmonthday = []
                opts.bymonthday = [opts.bymonthday]
            }
        }

        // byweekno
        if (opts.byweekno !== null && !(opts.byweekno instanceof Array)) {
            opts.byweekno = [opts.byweekno]
        }

        // byweekday / bynweekday
        if (opts.byweekday === null) {
            opts.bynweekday = null
        } else if (typeof opts.byweekday === 'number') {
            opts.byweekday = [opts.byweekday]
            opts.bynweekday = null
        } else if (opts.byweekday instanceof Weekday) {
            if (!opts.byweekday.n || opts.freq > RRule.MONTHLY) {
                opts.byweekday = [opts.byweekday.weekday]
                opts.bynweekday = null
            } else {
                opts.bynweekday = [
                    [opts.byweekday.weekday, opts.byweekday.n]
                ]
                opts.byweekday = null
            }
        } else {
            var byweekday = []
            var bynweekday = []

            for (i = 0; i < opts.byweekday.length; i++) {
                var wday = opts.byweekday[i]

                if (typeof wday === 'number') {
                    byweekday.push(wday)
                } else if (!wday.n || opts.freq > RRule.MONTHLY) {
                    byweekday.push(wday.weekday)
                } else {
                    bynweekday.push([wday.weekday, wday.n])
                }
            }
            opts.byweekday = plb(byweekday) ? byweekday : null
            opts.bynweekday = plb(bynweekday) ? bynweekday : null
        }

        // byhour
        if (opts.byhour === null) {
            opts.byhour = (opts.freq < RRule.HOURLY) ? [opts.dtstart.getHours()] : null
        } else if (typeof opts.byhour === 'number') {
            opts.byhour = [opts.byhour]
        }

        // byminute
        if (opts.byminute === null) {
            opts.byminute = (opts.freq < RRule.MINUTELY)
                ? [opts.dtstart.getMinutes()] : null
        } else if (typeof opts.byminute === 'number') {
            opts.byminute = [opts.byminute]
        }

        // bysecond
        if (opts.bysecond === null) {
            opts.bysecond = (opts.freq < RRule.SECONDLY)
                ? [opts.dtstart.getSeconds()] : null
        } else if (typeof opts.bysecond === 'number') {
            opts.bysecond = [opts.bysecond]
        }

        if (opts.freq >= RRule.HOURLY) {
            this.timeset = null
        } else {
            this.timeset = []
            for (i = 0; i < opts.byhour.length; i++) {
                var hour = opts.byhour[i]
                for (var j = 0; j < opts.byminute.length; j++) {
                    var minute = opts.byminute[j]
                    for (var k = 0; k < opts.bysecond.length; k++) {
                        var second = opts.bysecond[k]
                        // python:
                        // datetime.time(hour, minute, second,
                        // tzinfo=self._tzinfo))
                        this.timeset.push(new dateutil.Time(hour, minute, second, millisecondModulo))
                    }
                }
            }
            dateutil.sort(this.timeset)
        }
    }

    // RRule class 'constants'

    RRule.FREQUENCIES = [
        'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY',
        'HOURLY', 'MINUTELY', 'SECONDLY'
    ]

    RRule.YEARLY = 0
    RRule.MONTHLY = 1
    RRule.WEEKLY = 2
    RRule.DAILY = 3
    RRule.HOURLY = 4
    RRule.MINUTELY = 5
    RRule.SECONDLY = 6

    RRule.MO = new Weekday(0)
    RRule.TU = new Weekday(1)
    RRule.WE = new Weekday(2)
    RRule.TH = new Weekday(3)
    RRule.FR = new Weekday(4)
    RRule.SA = new Weekday(5)
    RRule.SU = new Weekday(6)

    RRule.DEFAULT_OPTIONS = {
        freq: null,
        dtstart: null,
        interval: 1,
        wkst: RRule.MO,
        count: null,
        until: null,
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: null,
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
    }

    RRule.parseText = function (text, language) {
        return getnlp().parseText(text, language)
    }

    RRule.fromText = function (text, language) {
        return getnlp().fromText(text, language)
    }

    RRule.optionsToString = function (options) {
        var key, value, strValues
        var pairs = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        for (var i = 0; i < keys.length; i++) {
            if (!contains(defaultKeys, keys[i])) continue

            key = keys[i].toUpperCase()
            value = options[keys[i]]
            strValues = []

            if (value === null || value instanceof Array && !value.length) continue

            switch (key) {
                case 'FREQ':
                    value = RRule.FREQUENCIES[options.freq]
                    break
                case 'WKST':
                    value = value.toString()
                    break
                case 'BYWEEKDAY':
                    /*
                    NOTE: BYWEEKDAY is a special case.
                    RRule() deconstructs the rule.options.byweekday array
                    into an array of Weekday arguments.
                    On the other hand, rule.origOptions is an array of Weekdays.
                    We need to handle both cases here.
                    It might be worth change RRule to keep the Weekdays.
          
                    Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
          
                    */
                    key = 'BYDAY'
                    if (!(value instanceof Array)) value = [value]

                    for (var wday, j = 0; j < value.length; j++) {
                        wday = value[j]
                        if (wday instanceof Weekday) {
                            // good
                        } else if (wday instanceof Array) {
                            wday = new Weekday(wday[0], wday[1])
                        } else {
                            wday = new Weekday(wday)
                        }
                        strValues[j] = wday.toString()
                    }
                    value = strValues
                    break
                case 'DTSTART':
                case 'UNTIL':
                    value = dateutil.timeToUntilString(value)
                    break
                default:
                    if (value instanceof Array) {
                        for (j = 0; j < value.length; j++) strValues[j] = String(value[j])
                        value = strValues
                    } else {
                        value = String(value)
                    }

            }
            pairs.push([key, value])
        }

        var strings = []
        for (i = 0; i < pairs.length; i++) {
            var attr = pairs[i]
            strings.push(attr[0] + '=' + attr[1].toString())
        }
        return strings.join(';')
    }

    RRule.prototype = {
        constructor: RRule,

        /**
         * @param {Function} iterator - optional function that will be called
         *                   on each date that is added. It can return false
         *                   to stop the iteration.
         * @return Array containing all recurrences.
         */
        all: function (iterator) {
            if (iterator) {
                return this._iter(new CallbackIterResult('all', {}, iterator))
            } else {
                var result = this._cacheGet('all')
                if (result === false) {
                    result = this._iter(new IterResult('all', {}))
                    this._cacheAdd('all', result)
                }
                return result
            }
        },

        /**
         * Returns all the occurrences of the rrule between after and before.
         * The inc keyword defines what happens if after and/or before are
         * themselves occurrences. With inc == True, they will be included in the
         * list, if they are found in the recurrence set.
         * @return Array
         */
        between: function (after, before, inc, iterator) {
            var args = {
                before: before,
                after: after,
                inc: inc
            }

            if (iterator) {
                return this._iter(new CallbackIterResult('between', args, iterator))
            }
            var result = this._cacheGet('between', args)
            if (result === false) {
                result = this._iter(new IterResult('between', args))
                this._cacheAdd('between', result, args)
            }
            return result
        },

        /**
         * Returns the last recurrence before the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        before: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('before', args)
            if (result === false) {
                result = this._iter(new IterResult('before', args))
                this._cacheAdd('before', result, args)
            }
            return result
        },

        /**
         * Returns the first recurrence after the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        after: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('after', args)
            if (result === false) {
                result = this._iter(new IterResult('after', args))
                this._cacheAdd('after', result, args)
            }
            return result
        },

        /**
         * Returns the number of recurrences in this set. It will have go trough
         * the whole recurrence, if this hasn't been done before.
         */
        count: function () {
            return this.all().length
        },

        /**
         * Converts the rrule into its string representation
         * @see <https://www.ietf.org/rfc/rfc2445.txt>
         * @return String
         */
        toString: function () {
            return RRule.optionsToString(this.origOptions)
        },

        /**
        * Will convert all rules described in nlp:ToText
        * to text.
        */
        toText: function (gettext, language) {
            return getnlp().toText(this, gettext, language)
        },

        isFullyConvertibleToText: function () {
            return getnlp().isFullyConvertible(this)
        },

        /**
         * @param {String} what - all/before/after/between
         * @param {Array,Date} value - an array of dates, one date, or null
         * @param {Object?} args - _iter arguments
         */
        _cacheAdd: function (what, value, args) {
            if (!this._cache) return

            if (value) {
                value = (value instanceof Date)
                    ? dateutil.clone(value) : dateutil.cloneDates(value)
            }

            if (what === 'all') {
                this._cache.all = value
            } else {
                args._value = value
                this._cache[what].push(args)
            }
        },

        /**
         * @return false - not in the cache
         *         null  - cached, but zero occurrences (before/after)
         *         Date  - cached (before/after)
         *         []    - cached, but zero occurrences (all/between)
         *         [Date1, DateN] - cached (all/between)
         */
        _cacheGet: function (what, args) {
            if (!this._cache) return false

            var cached = false
            var argsKeys = args ? Object.keys(args) : []
            var findCacheDiff = function (item) {
                for (var key, i = 0; i < argsKeys.length; i++) {
                    key = argsKeys[i]
                    if (String(args[key]) !== String(item[key])) return true
                }
                return false
            }

            if (what === 'all') {
                cached = this._cache.all
            } else {
                // Let's see whether we've already called the
                // 'what' method with the same 'args'
                for (var item, i = 0; i < this._cache[what].length; i++) {
                    item = this._cache[what][i]
                    if (argsKeys.length && findCacheDiff(item)) continue
                    cached = item._value
                    break
                }
            }

            if (!cached && this._cache.all) {
                // Not in the cache, but we already know all the occurrences,
                // so we can find the correct dates from the cached ones.
                var iterResult = new IterResult(what, args)
                for (i = 0; i < this._cache.all.length; i++) {
                    if (!iterResult.accept(this._cache.all[i])) break
                }
                cached = iterResult.getValue()
                this._cacheAdd(what, cached, args)
            }

            return cached instanceof Array
                ? dateutil.cloneDates(cached)
                : (cached instanceof Date ? dateutil.clone(cached) : cached)
        },

        /**
         * @return a RRule instance with the same freq and options
         *          as this one (cache is not cloned)
         */
        clone: function () {
            return new RRule(this.origOptions)
        },

        _iter: function (iterResult) {
            /* Since JavaScript doesn't have the python's yield operator (<1.7),
               we use the IterResult object that tells us when to stop iterating.
      
            */

            var dtstart = this.options.dtstart
            var dtstartMillisecondModulo = this.options.dtstart % 1000

            var year = dtstart.getFullYear()
            var month = dtstart.getMonth() + 1
            var day = dtstart.getDate()
            var hour = dtstart.getHours()
            var minute = dtstart.getMinutes()
            var second = dtstart.getSeconds()
            var weekday = dateutil.getWeekday(dtstart)

            // Some local variables to speed things up a bit
            var freq = this.options.freq
            var interval = this.options.interval
            var wkst = this.options.wkst
            var until = this.options.until
            var bymonth = this.options.bymonth
            var byweekno = this.options.byweekno
            var byyearday = this.options.byyearday
            var byweekday = this.options.byweekday
            var byeaster = this.options.byeaster
            var bymonthday = this.options.bymonthday
            var bynmonthday = this.options.bynmonthday
            var bysetpos = this.options.bysetpos
            var byhour = this.options.byhour
            var byminute = this.options.byminute
            var bysecond = this.options.bysecond

            var ii = new Iterinfo(this)
            ii.rebuild(year, month)

            var getdayset = {}
            getdayset[RRule.YEARLY] = ii.ydayset
            getdayset[RRule.MONTHLY] = ii.mdayset
            getdayset[RRule.WEEKLY] = ii.wdayset
            getdayset[RRule.DAILY] = ii.ddayset
            getdayset[RRule.HOURLY] = ii.ddayset
            getdayset[RRule.MINUTELY] = ii.ddayset
            getdayset[RRule.SECONDLY] = ii.ddayset

            getdayset = getdayset[freq]

            var timeset
            if (freq < RRule.HOURLY) {
                timeset = this.timeset
            } else {
                var gettimeset = {}
                gettimeset[RRule.HOURLY] = ii.htimeset
                gettimeset[RRule.MINUTELY] = ii.mtimeset
                gettimeset[RRule.SECONDLY] = ii.stimeset
                gettimeset = gettimeset[freq]
                if ((freq >= RRule.HOURLY && plb(byhour) && !contains(byhour, hour)) ||
                    (freq >= RRule.MINUTELY && plb(byminute) && !contains(byminute, minute)) ||
                    (freq >= RRule.SECONDLY && plb(bysecond) && !contains(bysecond, minute))) {
                    timeset = []
                } else {
                    timeset = gettimeset.call(ii, hour, minute, second, dtstartMillisecondModulo)
                }
            }

            var total = 0
            var count = this.options.count
            var i, j, k, dm, div, mod, tmp, pos, dayset, start, end, fixday, filtered

            while (true) {
                // Get dayset with the right frequency
                tmp = getdayset.call(ii, year, month, day)
                dayset = tmp[0]
                start = tmp[1]
                end = tmp[2]

                // Do the "hard" work ;-)
                filtered = false
                for (j = start; j < end; j++) {
                    i = dayset[j]

                    filtered = (plb(bymonth) && !contains(bymonth, ii.mmask[i])) ||
                        (plb(byweekno) && !ii.wnomask[i]) ||
                        (plb(byweekday) && !contains(byweekday, ii.wdaymask[i])) ||
                        (plb(ii.nwdaymask) && !ii.nwdaymask[i]) ||
                        (byeaster !== null && !contains(ii.eastermask, i)) ||
                        ((plb(bymonthday) || plb(bynmonthday)) &&
                            !contains(bymonthday, ii.mdaymask[i]) &&
                            !contains(bynmonthday, ii.nmdaymask[i])) ||
                        (plb(byyearday) &&
                            ((i < ii.yearlen &&
                                !contains(byyearday, i + 1) &&
                                !contains(byyearday, -ii.yearlen + i)) ||
                                (i >= ii.yearlen &&
                                    !contains(byyearday, i + 1 - ii.yearlen) &&
                                    !contains(byyearday, -ii.nextyearlen + i - ii.yearlen))))

                    if (filtered) dayset[i] = null
                }

                // Output results
                if (plb(bysetpos) && plb(timeset)) {
                    var daypos, timepos
                    var poslist = []

                    for (i, j = 0; j < bysetpos.length; j++) {
                        pos = bysetpos[j]

                        if (pos < 0) {
                            daypos = Math.floor(pos / timeset.length)
                            timepos = pymod(pos, timeset.length)
                        } else {
                            daypos = Math.floor((pos - 1) / timeset.length)
                            timepos = pymod((pos - 1), timeset.length)
                        }

                        try {
                            tmp = []
                            for (k = start; k < end; k++) {
                                var val = dayset[k]
                                if (val === null) continue
                                tmp.push(val)
                            }
                            if (daypos < 0) {
                                // we're trying to emulate python's aList[-n]
                                i = tmp.slice(daypos)[0]
                            } else {
                                i = tmp[daypos]
                            }

                            var time = timeset[timepos]
                            var date = dateutil.fromOrdinal(ii.yearordinal + i)
                            var res = dateutil.combine(date, time)
                            // XXX: can this ever be in the array?
                            // - compare the actual date instead?
                            if (!contains(poslist, res)) poslist.push(res)
                        } catch (e) { }
                    }

                    dateutil.sort(poslist)
                    for (j = 0; j < poslist.length; j++) {
                        res = poslist[j]
                        if (until && res > until) {
                            this._len = total
                            return iterResult.getValue()
                        } else if (res >= dtstart) {
                            ++total
                            if (!iterResult.accept(res)) return iterResult.getValue()
                            if (count) {
                                --count
                                if (!count) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                        }
                    }
                } else {
                    for (j = start; j < end; j++) {
                        i = dayset[j]
                        if (i !== null) {
                            date = dateutil.fromOrdinal(ii.yearordinal + i)
                            for (k = 0; k < timeset.length; k++) {
                                time = timeset[k]
                                res = dateutil.combine(date, time)
                                if (until && res > until) {
                                    this._len = total
                                    return iterResult.getValue()
                                } else if (res >= dtstart) {
                                    ++total
                                    if (!iterResult.accept(res)) return iterResult.getValue()
                                    if (count) {
                                        --count
                                        if (!count) {
                                            this._len = total
                                            return iterResult.getValue()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // Handle frequency and interval
                fixday = false
                if (freq === RRule.YEARLY) {
                    year += interval
                    if (year > dateutil.MAXYEAR) {
                        this._len = total
                        return iterResult.getValue()
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.MONTHLY) {
                    month += interval
                    if (month > 12) {
                        div = Math.floor(month / 12)
                        mod = pymod(month, 12)
                        month = mod
                        year += div
                        if (month === 0) {
                            month = 12
                            --year
                        }
                        if (year > dateutil.MAXYEAR) {
                            this._len = total
                            return iterResult.getValue()
                        }
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.WEEKLY) {
                    if (wkst > weekday) {
                        day += -(weekday + 1 + (6 - wkst)) + interval * 7
                    } else {
                        day += -(weekday - wkst) + interval * 7
                    }
                    weekday = wkst
                    fixday = true
                } else if (freq === RRule.DAILY) {
                    day += interval
                    fixday = true
                } else if (freq === RRule.HOURLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        hour += Math.floor((23 - hour) / interval) * interval
                    }
                    while (true) {
                        hour += interval
                        dm = divmod(hour, 24)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            hour = mod
                            day += div
                            fixday = true
                        }
                        if (!plb(byhour) || contains(byhour, hour)) break
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.MINUTELY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        minute += Math.floor(
                            (1439 - (hour * 60 + minute)) / interval) * interval
                    }

                    while (true) {
                        minute += interval
                        dm = divmod(minute, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            minute = mod
                            hour += div
                            dm = divmod(hour, 24)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                hour = mod
                                day += div
                                fixday = true
                                filtered = false
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.SECONDLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        second += Math.floor(
                            (86399 - (hour * 3600 + minute * 60 + second)) / interval) * interval
                    }
                    while (true) {
                        second += interval
                        dm = divmod(second, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            second = mod
                            minute += div
                            dm = divmod(minute, 60)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                minute = mod
                                hour += div
                                dm = divmod(hour, 24)
                                div = dm.div
                                mod = dm.mod
                                if (div) {
                                    hour = mod
                                    day += div
                                    fixday = true
                                }
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute)) &&
                            (!plb(bysecond) || contains(bysecond, second))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                }

                if (fixday && day > 28) {
                    var daysinmonth = dateutil.monthRange(year, month - 1)[1]
                    if (day > daysinmonth) {
                        while (day > daysinmonth) {
                            day -= daysinmonth
                            ++month
                            if (month === 13) {
                                month = 1
                                ++year
                                if (year > dateutil.MAXYEAR) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                            daysinmonth = dateutil.monthRange(year, month - 1)[1]
                        }
                        ii.rebuild(year, month)
                    }
                }
            }
        }

    }

    RRule.parseString = function (rfcString) {
        rfcString = rfcString.replace(/^\s+|\s+$/, '')
        if (!rfcString.length) return null

        var i, j, key, value, attr
        var attrs = rfcString.split(';')
        var options = {}

        for (i = 0; i < attrs.length; i++) {
            attr = attrs[i].split('=')
            key = attr[0]
            value = attr[1]
            switch (key) {
                case 'FREQ':
                    options.freq = RRule[value]
                    break
                case 'WKST':
                    options.wkst = RRule[value]
                    break
                case 'COUNT':
                case 'INTERVAL':
                case 'BYSETPOS':
                case 'BYMONTH':
                case 'BYMONTHDAY':
                case 'BYYEARDAY':
                case 'BYWEEKNO':
                case 'BYHOUR':
                case 'BYMINUTE':
                case 'BYSECOND':
                    if (value.indexOf(',') !== -1) {
                        value = value.split(',')
                        for (j = 0; j < value.length; j++) {
                            if (/^[+-]?\d+$/.test(value[j])) value[j] = Number(value[j])
                        }
                    } else if (/^[+-]?\d+$/.test(value)) {
                        value = Number(value)
                    }
                    key = key.toLowerCase()
                    options[key] = value
                    break
                case 'BYDAY': // => byweekday
                    var n, wday, day
                    var days = value.split(',')

                    options.byweekday = []
                    for (j = 0; j < days.length; j++) {
                        day = days[j]
                        if (day.length === 2) { // MO, TU, ...
                            wday = RRule[day] // wday instanceof Weekday
                            options.byweekday.push(wday)
                        } else { // -1MO, +3FR, 1SO, ...
                            day = day.match(/^([+-]?\d)([A-Z]{2})$/)
                            n = Number(day[1])
                            wday = day[2]
                            wday = RRule[wday].weekday
                            options.byweekday.push(new Weekday(wday, n))
                        }
                    }
                    break
                case 'DTSTART':
                    options.dtstart = dateutil.untilStringToDate(value)
                    break
                case 'UNTIL':
                    options.until = dateutil.untilStringToDate(value)
                    break
                case 'BYEASTER':
                    options.byeaster = Number(value)
                    break
                default:
                    throw new Error("Unknown RRULE property '" + key + "'")
            }
        }
        return options
    }

    RRule.fromString = function (string) {
        return new RRule(RRule.parseString(string))
    }

    // =============================================================================
    // Iterinfo
    // =============================================================================

    var Iterinfo = function (rrule) {
        this.rrule = rrule
        this.lastyear = null
        this.lastmonth = null
        this.yearlen = null
        this.nextyearlen = null
        this.yearordinal = null
        this.yearweekday = null
        this.mmask = null
        this.mrange = null
        this.mdaymask = null
        this.nmdaymask = null
        this.wdaymask = null
        this.wnomask = null
        this.nwdaymask = null
        this.eastermask = null
    }

    Iterinfo.prototype.easter = function (y, offset) {
        offset = offset || 0

        var a = y % 19
        var b = Math.floor(y / 100)
        var c = y % 100
        var d = Math.floor(b / 4)
        var e = b % 4
        var f = Math.floor((b + 8) / 25)
        var g = Math.floor((b - f + 1) / 3)
        var h = Math.floor(19 * a + b - d - g + 15) % 30
        var i = Math.floor(c / 4)
        var k = c % 4
        var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7
        var m = Math.floor((a + 11 * h + 22 * l) / 451)
        var month = Math.floor((h + l - 7 * m + 114) / 31)
        var day = (h + l - 7 * m + 114) % 31 + 1
        var date = Date.UTC(y, month - 1, day + offset)
        var yearStart = Date.UTC(y, 0, 1)

        return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))]
    }

    Iterinfo.prototype.rebuild = function (year, month) {
        var rr = this.rrule

        if (year !== this.lastyear) {
            this.yearlen = dateutil.isLeapYear(year) ? 366 : 365
            this.nextyearlen = dateutil.isLeapYear(year + 1) ? 366 : 365
            var firstyday = new Date(year, 0, 1)

            this.yearordinal = dateutil.toOrdinal(firstyday)
            this.yearweekday = dateutil.getWeekday(firstyday)

            var wday = dateutil.getWeekday(new Date(year, 0, 1))

            if (this.yearlen === 365) {
                this.mmask = [].concat(M365MASK)
                this.mdaymask = [].concat(MDAY365MASK)
                this.nmdaymask = [].concat(NMDAY365MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M365RANGE)
            } else {
                this.mmask = [].concat(M366MASK)
                this.mdaymask = [].concat(MDAY366MASK)
                this.nmdaymask = [].concat(NMDAY366MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M366RANGE)
            }

            if (!plb(rr.options.byweekno)) {
                this.wnomask = null
            } else {
                this.wnomask = repeat(0, this.yearlen + 7)
                var no1wkst, firstwkst, wyearlen
                no1wkst = firstwkst = pymod(7 - this.yearweekday + rr.options.wkst, 7)
                if (no1wkst >= 4) {
                    no1wkst = 0
                    // Number of days in the year, plus the days we got
                    // from last year.
                    wyearlen = this.yearlen + pymod(this.yearweekday - rr.options.wkst, 7)
                } else {
                    // Number of days in the year, minus the days we
                    // left in last year.
                    wyearlen = this.yearlen - no1wkst
                }
                var div = Math.floor(wyearlen / 7)
                var mod = pymod(wyearlen, 7)
                var numweeks = Math.floor(div + (mod / 4))
                for (var n, i, j = 0; j < rr.options.byweekno.length; j++) {
                    n = rr.options.byweekno[j]
                    if (n < 0) {
                        n += numweeks + 1
                    } if (!(n > 0 && n <= numweeks)) {
                        continue
                    } if (n > 1) {
                        i = no1wkst + (n - 1) * 7
                        if (no1wkst !== firstwkst) {
                            i -= 7 - firstwkst
                        }
                    } else {
                        i = no1wkst
                    }
                    for (var k = 0; k < 7; k++) {
                        this.wnomask[i] = 1
                        i++
                        if (this.wdaymask[i] === rr.options.wkst) break
                    }
                }

                if (contains(rr.options.byweekno, 1)) {
                    // Check week number 1 of next year as well
                    // orig-TODO : Check -numweeks for next year.
                    i = no1wkst + numweeks * 7
                    if (no1wkst !== firstwkst) i -= 7 - firstwkst
                    if (i < this.yearlen) {
                        // If week starts in next year, we
                        // don't care about it.
                        for (j = 0; j < 7; j++) {
                            this.wnomask[i] = 1
                            i += 1
                            if (this.wdaymask[i] === rr.options.wkst) break
                        }
                    }
                }

                if (no1wkst) {
                    // Check last week number of last year as
                    // well. If no1wkst is 0, either the year
                    // started on week start, or week number 1
                    // got days from last year, so there are no
                    // days from last year's last week number in
                    // this year.
                    var lnumweeks
                    if (!contains(rr.options.byweekno, -1)) {
                        var lyearweekday = dateutil.getWeekday(new Date(year - 1, 0, 1))
                        var lno1wkst = pymod(7 - lyearweekday + rr.options.wkst, 7)
                        var lyearlen = dateutil.isLeapYear(year - 1) ? 366 : 365
                        if (lno1wkst >= 4) {
                            lno1wkst = 0
                            lnumweeks = Math.floor(52 +
                                pymod(lyearlen + pymod(lyearweekday - rr.options.wkst, 7), 7) / 4)
                        } else {
                            lnumweeks = Math.floor(52 + pymod(this.yearlen - no1wkst, 7) / 4)
                        }
                    } else {
                        lnumweeks = -1
                    }
                    if (contains(rr.options.byweekno, lnumweeks)) {
                        for (i = 0; i < no1wkst; i++) this.wnomask[i] = 1
                    }
                }
            }
        }

        if (plb(rr.options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
            var ranges = []
            if (rr.options.freq === RRule.YEARLY) {
                if (plb(rr.options.bymonth)) {
                    for (j = 0; j < rr.options.bymonth.length; j++) {
                        month = rr.options.bymonth[j]
                        ranges.push(this.mrange.slice(month - 1, month + 1))
                    }
                } else {
                    ranges = [[0, this.yearlen]]
                }
            } else if (rr.options.freq === RRule.MONTHLY) {
                ranges = [this.mrange.slice(month - 1, month + 1)]
            }
            if (plb(ranges)) {
                // Weekly frequency won't get here, so we may not
                // care about cross-year weekly periods.
                this.nwdaymask = repeat(0, this.yearlen)

                for (j = 0; j < ranges.length; j++) {
                    var rang = ranges[j]
                    var first = rang[0]
                    var last = rang[1]
                    last -= 1
                    for (k = 0; k < rr.options.bynweekday.length; k++) {
                        wday = rr.options.bynweekday[k][0]
                        n = rr.options.bynweekday[k][1]
                        if (n < 0) {
                            i = last + (n + 1) * 7
                            i -= pymod(this.wdaymask[i] - wday, 7)
                        } else {
                            i = first + (n - 1) * 7
                            i += pymod(7 - this.wdaymask[i] + wday, 7)
                        }
                        if (first <= i && i <= last) this.nwdaymask[i] = 1
                    }
                }
            }

            this.lastyear = year
            this.lastmonth = month
        }

        if (rr.options.byeaster !== null) {
            this.eastermask = this.easter(year, rr.options.byeaster)
        }
    }

    Iterinfo.prototype.ydayset = function (year, month, day) {
        return [range(this.yearlen), 0, this.yearlen]
    }

    Iterinfo.prototype.mdayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var start = this.mrange[month - 1]
        var end = this.mrange[month]
        for (var i = start; i < end; i++) set[i] = i
        return [set, start, end]
    }

    Iterinfo.prototype.wdayset = function (year, month, day) {
        // We need to handle cross-year weeks here.
        var set = repeat(null, this.yearlen + 7)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        var start = i
        for (var j = 0; j < 7; j++) {
            set[i] = i
            ++i
            if (this.wdaymask[i] === this.rrule.options.wkst) break
        }
        return [set, start, i]
    }

    Iterinfo.prototype.ddayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        set[i] = i
        return [set, i, i + 1]
    }

    Iterinfo.prototype.htimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var i = 0; i < rr.options.byminute.length; i++) {
            minute = rr.options.byminute[i]
            for (var j = 0; j < rr.options.bysecond.length; j++) {
                second = rr.options.bysecond[j]
                set.push(new dateutil.Time(hour, minute, second, millisecond))
            }
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.mtimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var j = 0; j < rr.options.bysecond.length; j++) {
            second = rr.options.bysecond[j]
            set.push(new dateutil.Time(hour, minute, second, millisecond))
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
        return [new dateutil.Time(hour, minute, second, millisecond)]
    }

    // =============================================================================
    // Results
    // =============================================================================

    /**
     * This class helps us to emulate python's generators, sorta.
     */
    var IterResult = function (method, args) {
        this.init(method, args)
    }

    IterResult.prototype = {
        constructor: IterResult,
        init: function (method, args) {
            this.method = method
            this.args = args
            this.minDate = null
            this.maxDate = null
            this._result = []

            if (method === 'between') {
                this.maxDate = args.inc
                    ? args.before : new Date(args.before.getTime() - 1)
                this.minDate = args.inc
                    ? args.after : new Date(args.after.getTime() + 1)
            } else if (method === 'before') {
                this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1)
            } else if (method === 'after') {
                this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1)
            }
        },

        /**
         * Possibly adds a date into the result.
         *
         * @param {Date} date - the date isn't necessarly added to the result
         *                      list (if it is too late/too early)
         * @return {Boolean} true if it makes sense to continue the iteration
         *                   false if we're done.
         */
        accept: function (date) {
            var tooEarly = this.minDate && date < this.minDate
            var tooLate = this.maxDate && date > this.maxDate

            if (this.method === 'between') {
                if (tooEarly) return true
                if (tooLate) return false
            } else if (this.method === 'before') {
                if (tooLate) return false
            } else if (this.method === 'after') {
                if (tooEarly) return true
                this.add(date)
                return false
            }

            return this.add(date)
        },

        /**
         *
         * @param {Date} date that is part of the result.
         * @return {Boolean} whether we are interested in more values.
         */
        add: function (date) {
            this._result.push(date)
            return true
        },

        /**
         * 'before' and 'after' return only one date, whereas 'all'
         * and 'between' an array.
         * @return {Date,Array?}
         */
        getValue: function () {
            var res = this._result
            switch (this.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                case 'after':
                    return res.length ? res[res.length - 1] : null
            }
        },

        clone: function () {
            return new IterResult(this.method, this.args)
        }
    }

    /**
     * IterResult subclass that calls a callback function on each add,
     * and stops iterating when the callback returns false.
     */
    var CallbackIterResult = function (method, args, iterator) {
        var allowedMethods = ['all', 'between']
        if (!contains(allowedMethods, method)) {
            throw new Error('Invalid method "' + method +
                '". Only all and between works with iterator.')
        }
        this.add = function (date) {
            if (iterator(date, this._result.length)) {
                this._result.push(date)
                return true
            }
            return false
        }

        this.init(method, args)
    }
    CallbackIterResult.prototype = IterResult.prototype

    /**
     *
     * @param {Boolean?} noCache
     *  The same stratagy as RRule on cache, default to false
     * @constructor
     */

    var RRuleSet = function (noCache) {
        // Let RRuleSet cacheable
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }
        this._rrule = []
        this._rdate = []
        this._exrule = []
        this._exdate = []
    }

    RRuleSet.prototype = {
        constructor: RRuleSet,

        /**
        * @param {RRule}
        */
        rrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._rrule.map(String), String(rrule))) {
                this._rrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        rdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._rdate.map(Number), Number(date))) {
                this._rdate.push(date)
                dateutil.sort(this._rdate)
            }
        },

        /**
        * @param {RRule}
        */
        exrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._exrule.map(String), String(rrule))) {
                this._exrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        exdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._exdate.map(Number), Number(date))) {
                this._exdate.push(date)
                dateutil.sort(this._exdate)
            }
        },

        valueOf: function () {
            var result = []
            if (this._rrule.length) {
                this._rrule.forEach(function (rrule) {
                    result.push('RRULE:' + rrule)
                })
            }
            if (this._rdate.length) {
                result.push('RDATE:' + this._rdate.map(function (rdate) {
                    return dateutil.timeToUntilString(rdate)
                }).join(','))
            }
            if (this._exrule.length) {
                this._exrule.forEach(function (exrule) {
                    result.push('EXRULE:' + exrule)
                })
            }
            if (this._exdate.length) {
                result.push('EXDATE:' + this._exdate.map(function (exdate) {
                    return dateutil.timeToUntilString(exdate)
                }).join(','))
            }
            return result
        },

        /**
        * to generate recurrence field sush as:
        *   ["RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU;DTSTART=19970902T010000Z","RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH;DTSTART=19970902T010000Z"]
        */
        toString: function () {
            return JSON.stringify(this.valueOf())
        },

        _iter: function (iterResult) {
            var _exdateHash = {}
            var _exrule = this._exrule
            var _accept = iterResult.accept

            function evalExdate(after, before) {
                _exrule.forEach(function (rrule) {
                    rrule.between(after, before, true).forEach(function (date) {
                        _exdateHash[Number(date)] = true
                    })
                })
            }

            this._exdate.forEach(function (date) {
                _exdateHash[Number(date)] = true
            })

            iterResult.accept = function (date) {
                var dt = Number(date)
                if (!_exdateHash[dt]) {
                    evalExdate(new Date(dt - 1), new Date(dt + 1))
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                }
                return true
            }

            if (iterResult.method === 'between') {
                evalExdate(iterResult.args.after, iterResult.args.before)
                iterResult.accept = function (date) {
                    var dt = Number(date)
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                    return true
                }
            }

            for (var i = 0; i < this._rdate.length; i++) {
                if (!iterResult.accept(new Date(this._rdate[i]))) break
            }

            this._rrule.forEach(function (rrule) {
                rrule._iter(iterResult)
            })

            var res = iterResult._result
            dateutil.sort(res)
            switch (iterResult.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                    return (res.length && res[res.length - 1]) || null
                case 'after':
                    return (res.length && res[0]) || null
                default:
                    return null
            }
        },

        /**
        * Create a new RRuleSet Object completely base on current instance
        */
        clone: function () {
            var rrs = new RRuleSet(!!this._cache)
            var i
            for (i = 0; i < this._rrule.length; i++) {
                rrs.rrule(this._rrule[i].clone())
            }
            for (i = 0; i < this._rdate.length; i++) {
                rrs.rdate(new Date(this._rdate[i]))
            }
            for (i = 0; i < this._exrule.length; i++) {
                rrs.exrule(this._exrule[i].clone())
            }
            for (i = 0; i < this._exdate.length; i++) {
                rrs.exdate(new Date(this._exdate[i]))
            }
            return rrs
        }
    }

    /**
     * Inherts method from RRule
     *  add Read interface and set RRuleSet cacheable
     */
    var RRuleSetMethods = ['all', 'between', 'before', 'after', 'count', '_cacheAdd', '_cacheGet']
    RRuleSetMethods.forEach(function (method) {
        RRuleSet.prototype[method] = RRule.prototype[method]
    })

    /**
     * RRuleStr
     *  To parse a set of rrule strings
     */

    var RRuleStr = function () { }

    RRuleStr.DEFAULT_OPTIONS = {
        dtstart: null,
        cache: false,
        unfold: false,
        forceset: false,
        compatible: false,
        ignoretz: false,
        tzinfos: null
    }

    RRuleStr._freq_map = {
        'YEARLY': RRule.YEARLY,
        'MONTHLY': RRule.MONTHLY,
        'WEEKLY': RRule.WEEKLY,
        'DAILY': RRule.DAILY,
        'HOURLY': RRule.HOURLY,
        'MINUTELY': RRule.MINUTELY,
        'SECONDLY': RRule.SECONDLY
    }

    RRuleStr._weekday_map = {
        'MO': 0,
        'TU': 1,
        'WE': 2,
        'TH': 3,
        'FR': 4,
        'SA': 5,
        'SU': 6
    }

    RRuleStr.prototype = {
        constructor: RRuleStr,

        _handle_int: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = parseInt(value, 10)
        },

        _handle_int_list: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = value.split(',').map(function (x) {
                return parseInt(x, 10)
            })
        },

        _handle_FREQ: function (rrkwargs, name, value, options) {
            rrkwargs['freq'] = RRuleStr._freq_map[value]
        },

        _handle_UNTIL: function (rrkwargs, name, value, options) {
            try {
                rrkwargs['until'] = dateutil.untilStringToDate(value)
            } catch (error) {
                throw new Error('invalid until date')
            }
        },

        _handle_WKST: function (rrkwargs, name, value, options) {
            rrkwargs['wkst'] = RRuleStr._weekday_map[value]
        },

        _handle_BYWEEKDAY: function (rrkwargs, name, value, options) {
            // Two ways to specify this: +1MO or MO(+1)
            var splt, i, j, n, w, wday
            var l = []
            var wdays = value.split(',')

            for (i = 0; i < wdays.length; i++) {
                wday = wdays[i]
                if (wday.indexOf('(') > -1) {
                    // If it's of the form TH(+1), etc.
                    splt = wday.split('(')
                    w = splt[0]
                    n = parseInt(splt.slice(1, -1), 10)
                } else {
                    // # If it's of the form +1MO
                    for (j = 0; j < wday.length; j++) {
                        if ('+-0123456789'.indexOf(wday[j]) === -1) break
                    }
                    n = wday.slice(0, j) || null
                    w = wday.slice(j)

                    if (n) n = parseInt(n, 10)
                }

                var weekday = new Weekday(RRuleStr._weekday_map[w], n)
                l.push(weekday)
            }
            rrkwargs['byweekday'] = l
        },

        _parseRfcRRule: function (line, options) {
            options = options || {}
            options.dtstart = options.dtstart || null
            options.cache = options.cache || false
            options.ignoretz = options.ignoretz || false
            options.tzinfos = options.tzinfos || null

            var name, value, parts
            if (line.indexOf(':') !== -1) {
                parts = line.split(':')
                name = parts[0]
                value = parts[1]

                if (name !== 'RRULE') throw new Error('unknown parameter name')
            } else {
                value = line
            }

            var i
            var rrkwargs = {}
            var pairs = value.split(';')

            for (i = 0; i < pairs.length; i++) {
                parts = pairs[i].split('=')
                name = parts[0].toUpperCase()
                value = parts[1].toUpperCase()

                try {
                    this['_handle_' + name](rrkwargs, name, value, {
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                } catch (error) {
                    throw new Error("unknown parameter '" + name + "':" + value)
                }
            }
            rrkwargs.dtstart = rrkwargs.dtstart || options.dtstart
            return new RRule(rrkwargs, !options.cache)
        },

        _parseRfc: function (s, options) {
            if (options.compatible) {
                options.forceset = true
                options.unfold = true
            }

            s = s && s.toUpperCase().trim()
            if (!s) throw new Error('Invalid empty string')

            var i = 0
            var line, lines

            // More info about 'unfold' option
            // Go head to https://www.ietf.org/rfc/rfc2445.txt
            if (options.unfold) {
                lines = s.split('\n')
                while (i < lines.length) {
                    // TODO
                    line = lines[i] = lines[i].replace(/\s+$/g, '')
                    if (!line) {
                        lines.splice(i, 1)
                    } else if (i > 0 && line[0] === ' ') {
                        lines[i - 1] += line.slice(1)
                        lines.splice(i, 1)
                    } else {
                        i += 1
                    }
                }
            } else {
                lines = s.split(/\s/)
            }

            var rrulevals = []
            var rdatevals = []
            var exrulevals = []
            var exdatevals = []
            var name, value, parts, parms, parm, dtstart, rset, j, k, datestrs, datestr

            if (!options.forceset && lines.length === 1 && (s.indexOf(':') === -1 ||
                s.indexOf('RRULE:') === 0)) {
                return this._parseRfcRRule(lines[0], {
                    cache: options.cache,
                    dtstart: options.dtstart,
                    ignoretz: options.ignoretz,
                    tzinfos: options.tzinfos
                })
            } else {
                for (i = 0; i < lines.length; i++) {
                    line = lines[i]
                    if (!line) continue
                    if (line.indexOf(':') === -1) {
                        name = 'RRULE'
                        value = line
                    } else {
                        parts = split(line, ':', 1)
                        name = parts[0]
                        value = parts[1]
                    }
                    parms = name.split(';')
                    if (!parms) throw new Error('empty property name')
                    name = parms[0]
                    parms = parms.slice(1)

                    if (name === 'RRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported RRULE parm: ' + parm)
                        }
                        rrulevals.push(value)
                    } else if (name === 'RDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        rdatevals.push(value)
                    } else if (name === 'EXRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported EXRULE parm: ' + parm)
                        }
                        exrulevals.push(value)
                    } else if (name === 'EXDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        exdatevals.push(value)
                    } else if (name === 'DTSTART') {
                        dtstart = dateutil.untilStringToDate(value)
                    } else {
                        throw new Error('unsupported property: ' + name)
                    }
                }

                if (options.forceset || rrulevals.length > 1 || rdatevals.length ||
                    exrulevals.length || exdatevals.length) {
                    rset = new RRuleSet(!options.cache)
                    for (j = 0; j < rrulevals.length; j++) {
                        rset.rrule(this._parseRfcRRule(rrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < rdatevals.length; j++) {
                        datestrs = rdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.rdate(dateutil.untilStringToDate(datestr))
                        }
                    }
                    for (j = 0; j < exrulevals.length; j++) {
                        rset.exrule(this._parseRfcRRule(exrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < exdatevals.length; j++) {
                        datestrs = exdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.exdate(dateutil.untilStringToDate(datestr))
                        }
                    }

                    if (options.campatiable && options.dtstart) rset.rdate(dtstart)
                    return rset
                } else {
                    return this._parseRfcRRule(rrulevals[0], {
                        dtstart: options.dtstart || dtstart,
                        cache: options.cache,
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                }
            }
        },

        parse: function (s, options) {
            options = options || {}

            var invalid = []
            var keys = Object.keys(options)
            var defaultKeys = Object.keys(RRuleStr.DEFAULT_OPTIONS)

            keys.forEach(function (key) {
                if (!contains(defaultKeys, key)) invalid.push(key)
            }, this)

            if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

            // Merge in default options
            defaultKeys.forEach(function (key) {
                if (!contains(keys, key)) options[key] = RRuleStr.DEFAULT_OPTIONS[key]
            })

            return this._parseRfc(s, options)
        }
    }

    RRuleStr.prototype._handle_DTSTART = function (rrkwargs, name, value, options) {
        rrkwargs[name.toLowerCase()] = dateutil.untilStringToDate(value)
    }

    RRuleStr.prototype._handle_BYDAY = RRuleStr.prototype._handle_BYWEEKDAY
    RRuleStr.prototype._handle_INTERVAL = RRuleStr.prototype._handle_int
    RRuleStr.prototype._handle_COUNT = RRuleStr.prototype._handle_int

        ;[
            '_handle_BYSETPOS', '_handle_BYMONTH', '_handle_BYMONTHDAY',
            '_handle_BYYEARDAY', '_handle_BYEASTER', '_handle_BYWEEKNO',
            '_handle_BYHOUR', '_handle_BYMINUTE', '_handle_BYSECOND'
        ].forEach(function (method) {
            RRuleStr.prototype[method] = RRuleStr.prototype._handle_int_list
        })

    // =============================================================================
    // Export
    // =============================================================================

    // Only one RRuleStr instance for all rrule string parsing work.
    var rruleStr = new RRuleStr()
    var rrulestr = function () {
        return rruleStr.parse.apply(rruleStr, arguments)
    }

    RRule.RRule = RRule
    RRule.RRuleSet = RRuleSet
    RRule.rrulestr = rrulestr
    return RRule

    function getnlp() {
        // Lazy, runtime import to avoid circular refs.
        if (!getnlp._nlp) {
            if (root && root._getRRuleNLP) {
                getnlp._nlp = root._getRRuleNLP(RRule)
            } else if (typeof require === 'function') {
                getnlp._nlp = require('./nlp')(RRule)
            } else {
                throw new Error('You need to include rrule/nlp.js for fromText/toText to work.')
            }
        }
        return getnlp._nlp
    }
}))

//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

; (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            global.moment = factory()
}(this, (function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    var some$1 = some;

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !== 'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var keys$1 = keys;

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/;            //       0 - 9
    var match2 = /\d\d/;          //      00 - 99
    var match3 = /\d{3}/;         //     000 - 999
    var match4 = /\d{4}/;         //    0000 - 9999
    var match6 = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2 = /\d\d?/;         //       0 - 99
    var match3to4 = /\d\d\d\d?/;     //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/;       //       0 - 999
    var match1to4 = /\d{1,4}/;       //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned = /\d+/;           //       0 - inf
    var matchSigned = /[+-]?\d+/;      //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    var indexOf$1 = indexOf;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return this._months;
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return this._monthsShort;
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //https://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        if (!m) {
            return this._weekdays;
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // months
    // week
    // weekdays
    // meridiem
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See https://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys$1(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11 ? MONTH :
                    a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                        a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                            a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE :
                                a[SECOND] < 0 || a[SECOND] > 59 ? SECOND :
                                    a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                                        -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'https://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () { };

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof (input) === 'object') {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
            0 :
            parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () { };

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from https://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                    'See https://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                        diff < 2 ? 'nextDay' :
                            diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                    units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                        units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    function startOf(units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf() {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$1() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$1;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;

    // Year
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;

    // Week Year
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    proto.quarter = proto.quarters = getSetQuarter;

    // Month
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

    // Week
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;

    // Hour
    proto.hour = proto.hours = getSetHour;

    // Minute
    proto.minute = proto.minutes = getSetMinute;

    // Second
    proto.second = proto.seconds = getSetSecond;

    // Millisecond
    proto.millisecond = proto.milliseconds = getSetMillisecond;

    // Offset
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;

    // Timezone
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

    // Deprecations
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See https://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    // Month
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;

    // Week
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    // Hours
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week': return days / 7 + milliseconds / 6048e5;
                case 'day': return days + milliseconds / 864e5;
                case 'hour': return days * 24 + milliseconds / 36e5;
                case 'minute': return days * 1440 + milliseconds / 6e4;
                case 'second': return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asYears = makeAs('y');

    function get$2(units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds] ||
            minutes <= 1 && ['m'] ||
            minutes < thresholds.m && ['mm', minutes] ||
            hours <= 1 && ['h'] ||
            hours < thresholds.h && ['hh', hours] ||
            days <= 1 && ['d'] ||
            days < thresholds.d && ['dd', days] ||
            months <= 1 && ['M'] ||
            months < thresholds.M && ['MM', months] ||
            years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof (roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize(withSuffix) {
        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    // Deprecations
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.17.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    return hooks;

})));
/**
 * interact.js v1.2.9
 *
 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
(function (realWindow) {
    'use strict';

    // return early if there's no window to work with (eg. Node.js)
    if (!realWindow) { return; }

    var // get wrapped window if using Shadow DOM polyfill
        window = (function () {
            // create a TextNode
            var el = realWindow.document.createTextNode('');

            // check if it's wrapped by a polyfill
            if (el.ownerDocument !== realWindow.document
                && typeof realWindow.wrap === 'function'
                && realWindow.wrap(el) === el) {
                // return wrapped window
                return realWindow.wrap(realWindow);
            }

            // no Shadow DOM polyfil or native implementation
            return realWindow;
        }()),

        document = window.document,
        DocumentFragment = window.DocumentFragment || blank,
        SVGElement = window.SVGElement || blank,
        SVGSVGElement = window.SVGSVGElement || blank,
        SVGElementInstance = window.SVGElementInstance || blank,
        HTMLElement = window.HTMLElement || window.Element,

        PointerEvent = (window.PointerEvent || window.MSPointerEvent),
        pEventTypes,

        hypot = Math.hypot || function (x, y) { return Math.sqrt(x * x + y * y); },

        tmpXY = {},     // reduce object creation in getXY()

        documents = [],   // all documents being listened to

        interactables = [],   // all set interactables
        interactions = [],   // all interactions

        dynamicDrop = false,

        // {
        //      type: {
        //          selectors: ['selector', ...],
        //          contexts : [document, ...],
        //          listeners: [[listener, useCapture], ...]
        //      }
        //  }
        delegatedEvents = {},

        defaultOptions = {
            base: {
                accept: null,
                actionChecker: null,
                styleCursor: true,
                preventDefault: 'auto',
                origin: { x: 0, y: 0 },
                deltaSource: 'page',
                allowFrom: null,
                ignoreFrom: null,
                _context: document,
                dropChecker: null
            },

            drag: {
                enabled: false,
                manualStart: true,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                axis: 'xy'
            },

            drop: {
                enabled: false,
                accept: null,
                overlap: 'pointer'
            },

            resize: {
                enabled: false,
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                square: false,
                preserveAspectRatio: false,
                axis: 'xy',

                // use default margin
                margin: NaN,

                // object with props left, right, top, bottom which are
                // true/false values to resize when the pointer is over that edge,
                // CSS selectors to match the handles for each direction
                // or the Elements for each handle
                edges: null,

                // a value of 'none' will limit the resize rect to a minimum of 0x0
                // 'negate' will alow the rect to have negative width/height
                // 'reposition' will keep the width/height positive by swapping
                // the top and bottom edges and/or swapping the left and right edges
                invert: 'none'
            },

            gesture: {
                manualStart: false,
                enabled: false,
                max: Infinity,
                maxPerElement: 1,

                restrict: null
            },

            perAction: {
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: {
                    enabled: false,
                    endOnly: false,
                    range: Infinity,
                    targets: null,
                    offsets: null,

                    relativePoints: null
                },

                restrict: {
                    enabled: false,
                    endOnly: false
                },

                autoScroll: {
                    enabled: false,
                    container: null,     // the item that is scrolled (Window or HTMLElement)
                    margin: 60,
                    speed: 300       // the scroll speed in pixels per second
                },

                inertia: {
                    enabled: false,
                    resistance: 10,    // the lambda in exponential decay
                    minSpeed: 100,   // target speed must be above this for inertia to start
                    endSpeed: 10,    // the speed at which inertia is slow enough to stop
                    allowResume: true,  // allow resuming an action in inertia phase
                    zeroResumeDelta: true,  // if an action is resumed after launch, set dx/dy to 0
                    smoothEndDuration: 300    // animate to snap/restrict endOnly if there's no inertia
                }
            },

            _holdDuration: 600
        },

        // Things related to autoScroll
        autoScroll = {
            interaction: null,
            i: null,    // the handle returned by window.setInterval
            x: 0, y: 0, // Direction each pulse is to scroll in

            // scroll the window by the values in scroll.x/y
            scroll: function () {
                var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll,
                    container = options.container || getWindow(autoScroll.interaction.element),
                    now = new Date().getTime(),
                    // change in time in seconds
                    dtx = (now - autoScroll.prevTimeX) / 1000,
                    dty = (now - autoScroll.prevTimeY) / 1000,
                    vx, vy, sx, sy;

                // displacement
                if (options.velocity) {
                    vx = options.velocity.x;
                    vy = options.velocity.y;
                }
                else {
                    vx = vy = options.speed
                }

                sx = vx * dtx;
                sy = vy * dty;

                if (sx >= 1 || sy >= 1) {
                    if (isWindow(container)) {
                        container.scrollBy(autoScroll.x * sx, autoScroll.y * sy);
                    }
                    else if (container) {
                        container.scrollLeft += autoScroll.x * sx;
                        container.scrollTop += autoScroll.y * sy;
                    }

                    if (sx >= 1) autoScroll.prevTimeX = now;
                    if (sy >= 1) autoScroll.prevTimeY = now;
                }

                if (autoScroll.isScrolling) {
                    cancelFrame(autoScroll.i);
                    autoScroll.i = reqFrame(autoScroll.scroll);
                }
            },

            isScrolling: false,
            prevTimeX: 0,
            prevTimeY: 0,

            start: function (interaction) {
                autoScroll.isScrolling = true;
                cancelFrame(autoScroll.i);

                autoScroll.interaction = interaction;
                autoScroll.prevTimeX = new Date().getTime();
                autoScroll.prevTimeY = new Date().getTime();
                autoScroll.i = reqFrame(autoScroll.scroll);
            },

            stop: function () {
                autoScroll.isScrolling = false;
                cancelFrame(autoScroll.i);
            }
        },

        // Does the browser support touch input?
        supportsTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),

        // Does the browser support PointerEvents
        // Avoid PointerEvent bugs introduced in Chrome 55
        supportsPointerEvent = PointerEvent && !/Chrome/.test(navigator.userAgent),

        // Less Precision with touch input
        margin = supportsTouch || supportsPointerEvent ? 20 : 10,

        pointerMoveTolerance = 1,

        // for ignoring browser's simulated mouse events
        prevTouchTime = 0,

        // Allow this many interactions to happen simultaneously
        maxInteractions = Infinity,

        // Check if is IE9 or older
        actionCursors = (document.all && !window.atob) ? {
            drag: 'move',
            resizex: 'e-resize',
            resizey: 's-resize',
            resizexy: 'se-resize',

            resizetop: 'n-resize',
            resizeleft: 'w-resize',
            resizebottom: 's-resize',
            resizeright: 'e-resize',
            resizetopleft: 'se-resize',
            resizebottomright: 'se-resize',
            resizetopright: 'ne-resize',
            resizebottomleft: 'ne-resize',

            gesture: ''
        } : {
            drag: 'move',
            resizex: 'ew-resize',
            resizey: 'ns-resize',
            resizexy: 'nwse-resize',

            resizetop: 'ns-resize',
            resizeleft: 'ew-resize',
            resizebottom: 'ns-resize',
            resizeright: 'ew-resize',
            resizetopleft: 'nwse-resize',
            resizebottomright: 'nwse-resize',
            resizetopright: 'nesw-resize',
            resizebottomleft: 'nesw-resize',

            gesture: ''
        },

        actionIsEnabled = {
            drag: true,
            resize: true,
            gesture: true
        },

        // because Webkit and Opera still use 'mousewheel' event type
        wheelEvent = 'onmousewheel' in document ? 'mousewheel' : 'wheel',

        eventTypes = [
            'dragstart',
            'dragmove',
            'draginertiastart',
            'dragend',
            'dragenter',
            'dragleave',
            'dropactivate',
            'dropdeactivate',
            'dropmove',
            'drop',
            'resizestart',
            'resizemove',
            'resizeinertiastart',
            'resizeend',
            'gesturestart',
            'gesturemove',
            'gestureinertiastart',
            'gestureend',

            'down',
            'move',
            'up',
            'cancel',
            'tap',
            'doubletap',
            'hold'
        ],

        globalEvents = {},

        // Opera Mobile must be handled differently
        isOperaMobile = navigator.appName == 'Opera' &&
            supportsTouch &&
            navigator.userAgent.match('Presto'),

        // scrolling doesn't change the result of getClientRects on iOS 7
        isIOS7 = (/iP(hone|od|ad)/.test(navigator.platform)
            && /OS 7[^\d]/.test(navigator.appVersion)),

        // prefix matchesSelector
        prefixedMatchesSelector = 'matches' in Element.prototype ?
            'matches' : 'webkitMatchesSelector' in Element.prototype ?
                'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ?
                    'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ?
                        'oMatchesSelector' : 'msMatchesSelector',

        // will be polyfill function if browser is IE8
        ie8MatchesSelector,

        // native requestAnimationFrame or polyfill
        reqFrame = realWindow.requestAnimationFrame,
        cancelFrame = realWindow.cancelAnimationFrame,

        // Events wrapper
        events = (function () {
            var useAttachEvent = ('attachEvent' in window) && !('addEventListener' in window),
                addEvent = useAttachEvent ? 'attachEvent' : 'addEventListener',
                removeEvent = useAttachEvent ? 'detachEvent' : 'removeEventListener',
                on = useAttachEvent ? 'on' : '',

                elements = [],
                targets = [],
                attachedListeners = [];

            function add(element, type, listener, useCapture) {
                var elementIndex = indexOf(elements, element),
                    target = targets[elementIndex];

                if (!target) {
                    target = {
                        events: {},
                        typeCount: 0
                    };

                    elementIndex = elements.push(element) - 1;
                    targets.push(target);

                    attachedListeners.push((useAttachEvent ? {
                        supplied: [],
                        wrapped: [],
                        useCount: []
                    } : null));
                }

                if (!target.events[type]) {
                    target.events[type] = [];
                    target.typeCount++;
                }

                if (!contains(target.events[type], listener)) {
                    var ret;

                    if (useAttachEvent) {
                        var listeners = attachedListeners[elementIndex],
                            listenerIndex = indexOf(listeners.supplied, listener);

                        var wrapped = listeners.wrapped[listenerIndex] || function (event) {
                            if (!event.immediatePropagationStopped) {
                                event.target = event.srcElement;
                                event.currentTarget = element;

                                event.preventDefault = event.preventDefault || preventDef;
                                event.stopPropagation = event.stopPropagation || stopProp;
                                event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;

                                if (/mouse|click/.test(event.type)) {
                                    event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;
                                    event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;
                                }

                                listener(event);
                            }
                        };

                        ret = element[addEvent](on + type, wrapped, Boolean(useCapture));

                        if (listenerIndex === -1) {
                            listeners.supplied.push(listener);
                            listeners.wrapped.push(wrapped);
                            listeners.useCount.push(1);
                        }
                        else {
                            listeners.useCount[listenerIndex]++;
                        }
                    }
                    else {
                        ret = element[addEvent](type, listener, useCapture || false);
                    }
                    target.events[type].push(listener);

                    return ret;
                }
            }

            function remove(element, type, listener, useCapture) {
                var i,
                    elementIndex = indexOf(elements, element),
                    target = targets[elementIndex],
                    listeners,
                    listenerIndex,
                    wrapped = listener;

                if (!target || !target.events) {
                    return;
                }

                if (useAttachEvent) {
                    listeners = attachedListeners[elementIndex];
                    listenerIndex = indexOf(listeners.supplied, listener);
                    wrapped = listeners.wrapped[listenerIndex];
                }

                if (type === 'all') {
                    for (type in target.events) {
                        if (target.events.hasOwnProperty(type)) {
                            remove(element, type, 'all');
                        }
                    }
                    return;
                }

                if (target.events[type]) {
                    var len = target.events[type].length;

                    if (listener === 'all') {
                        for (i = 0; i < len; i++) {
                            remove(element, type, target.events[type][i], Boolean(useCapture));
                        }
                        return;
                    } else {
                        for (i = 0; i < len; i++) {
                            if (target.events[type][i] === listener) {
                                element[removeEvent](on + type, wrapped, useCapture || false);
                                target.events[type].splice(i, 1);

                                if (useAttachEvent && listeners) {
                                    listeners.useCount[listenerIndex]--;
                                    if (listeners.useCount[listenerIndex] === 0) {
                                        listeners.supplied.splice(listenerIndex, 1);
                                        listeners.wrapped.splice(listenerIndex, 1);
                                        listeners.useCount.splice(listenerIndex, 1);
                                    }
                                }

                                break;
                            }
                        }
                    }

                    if (target.events[type] && target.events[type].length === 0) {
                        target.events[type] = null;
                        target.typeCount--;
                    }
                }

                if (!target.typeCount) {
                    targets.splice(elementIndex, 1);
                    elements.splice(elementIndex, 1);
                    attachedListeners.splice(elementIndex, 1);
                }
            }

            function preventDef() {
                this.returnValue = false;
            }

            function stopProp() {
                this.cancelBubble = true;
            }

            function stopImmProp() {
                this.cancelBubble = true;
                this.immediatePropagationStopped = true;
            }

            return {
                add: add,
                remove: remove,
                useAttachEvent: useAttachEvent,

                _elements: elements,
                _targets: targets,
                _attachedListeners: attachedListeners
            };
        }());

    function blank() { }

    function isElement(o) {
        if (!o || (typeof o !== 'object')) { return false; }

        var _window = getWindow(o) || window;

        return (/object|function/.test(typeof _window.Element)
            ? o instanceof _window.Element //DOM2
            : o.nodeType === 1 && typeof o.nodeName === "string");
    }
    function isWindow(thing) { return thing === window || !!(thing && thing.Window) && (thing instanceof thing.Window); }
    function isDocFrag(thing) { return !!thing && thing instanceof DocumentFragment; }
    function isArray(thing) {
        return isObject(thing)
            && (typeof thing.length !== undefined)
            && isFunction(thing.splice);
    }
    function isObject(thing) { return !!thing && (typeof thing === 'object'); }
    function isFunction(thing) { return typeof thing === 'function'; }
    function isNumber(thing) { return typeof thing === 'number'; }
    function isBool(thing) { return typeof thing === 'boolean'; }
    function isString(thing) { return typeof thing === 'string'; }

    function trySelector(value) {
        if (!isString(value)) { return false; }

        // an exception will be raised if it is invalid
        document.querySelector(value);
        return true;
    }

    function extend(dest, source) {
        for (var prop in source) {
            dest[prop] = source[prop];
        }
        return dest;
    }

    var prefixedPropREs = {
        webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
    };

    function pointerExtend(dest, source) {
        for (var prop in source) {
            var deprecated = false;

            // skip deprecated prefixed properties
            for (var vendor in prefixedPropREs) {
                if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
                    deprecated = true;
                    break;
                }
            }

            if (!deprecated) {
                dest[prop] = source[prop];
            }
        }
        return dest;
    }

    function copyCoords(dest, src) {
        dest.page = dest.page || {};
        dest.page.x = src.page.x;
        dest.page.y = src.page.y;

        dest.client = dest.client || {};
        dest.client.x = src.client.x;
        dest.client.y = src.client.y;

        dest.timeStamp = src.timeStamp;
    }

    function setEventXY(targetObj, pointers, interaction) {
        var pointer = (pointers.length > 1
            ? pointerAverage(pointers)
            : pointers[0]);

        getPageXY(pointer, tmpXY, interaction);
        targetObj.page.x = tmpXY.x;
        targetObj.page.y = tmpXY.y;

        getClientXY(pointer, tmpXY, interaction);
        targetObj.client.x = tmpXY.x;
        targetObj.client.y = tmpXY.y;

        targetObj.timeStamp = new Date().getTime();
    }

    function setEventDeltas(targetObj, prev, cur) {
        targetObj.page.x = cur.page.x - prev.page.x;
        targetObj.page.y = cur.page.y - prev.page.y;
        targetObj.client.x = cur.client.x - prev.client.x;
        targetObj.client.y = cur.client.y - prev.client.y;
        targetObj.timeStamp = new Date().getTime() - prev.timeStamp;

        // set pointer velocity
        var dt = Math.max(targetObj.timeStamp / 1000, 0.001);
        targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
        targetObj.page.vx = targetObj.page.x / dt;
        targetObj.page.vy = targetObj.page.y / dt;

        targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
        targetObj.client.vx = targetObj.client.x / dt;
        targetObj.client.vy = targetObj.client.y / dt;
    }

    function isNativePointer(pointer) {
        return (pointer instanceof window.Event
            || (supportsTouch && window.Touch && pointer instanceof window.Touch));
    }

    // Get specified X/Y coords for mouse or event.touches[0]
    function getXY(type, pointer, xy) {
        xy = xy || {};
        type = type || 'page';

        xy.x = pointer[type + 'X'];
        xy.y = pointer[type + 'Y'];

        return xy;
    }

    function getPageXY(pointer, page) {
        page = page || {};

        // Opera Mobile handles the viewport and scrolling oddly
        if (isOperaMobile && isNativePointer(pointer)) {
            getXY('screen', pointer, page);

            page.x += window.scrollX;
            page.y += window.scrollY;
        }
        else {
            getXY('page', pointer, page);
        }

        return page;
    }

    function getClientXY(pointer, client) {
        client = client || {};

        if (isOperaMobile && isNativePointer(pointer)) {
            // Opera Mobile handles the viewport and scrolling oddly
            getXY('screen', pointer, client);
        }
        else {
            getXY('client', pointer, client);
        }

        return client;
    }

    function getScrollXY(win) {
        win = win || window;
        return {
            x: win.scrollX || win.document.documentElement.scrollLeft,
            y: win.scrollY || win.document.documentElement.scrollTop
        };
    }

    function getPointerId(pointer) {
        return isNumber(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
    }

    function getActualElement(element) {
        return (element instanceof SVGElementInstance
            ? element.correspondingUseElement
            : element);
    }

    function getWindow(node) {
        if (isWindow(node)) {
            return node;
        }

        var rootNode = (node.ownerDocument || node);

        return rootNode.defaultView || rootNode.parentWindow || window;
    }

    function getElementClientRect(element) {
        var clientRect = (element instanceof SVGElement
            ? element.getBoundingClientRect()
            : element.getClientRects()[0]);

        return clientRect && {
            left: clientRect.left,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
            width: clientRect.width || clientRect.right - clientRect.left,
            height: clientRect.height || clientRect.bottom - clientRect.top
        };
    }

    function getElementRect(element) {
        var clientRect = getElementClientRect(element);

        if (!isIOS7 && clientRect) {
            var scroll = getScrollXY(getWindow(element));

            clientRect.left += scroll.x;
            clientRect.right += scroll.x;
            clientRect.top += scroll.y;
            clientRect.bottom += scroll.y;
        }

        return clientRect;
    }

    function getTouchPair(event) {
        var touches = [];

        // array of touches is supplied
        if (isArray(event)) {
            touches[0] = event[0];
            touches[1] = event[1];
        }
        // an event
        else {
            if (event.type === 'touchend') {
                if (event.touches.length === 1) {
                    touches[0] = event.touches[0];
                    touches[1] = event.changedTouches[0];
                }
                else if (event.touches.length === 0) {
                    touches[0] = event.changedTouches[0];
                    touches[1] = event.changedTouches[1];
                }
            }
            else {
                touches[0] = event.touches[0];
                touches[1] = event.touches[1];
            }
        }

        return touches;
    }

    function pointerAverage(pointers) {
        var average = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        };
        var prop;

        for (var i = 0; i < pointers.length; i++) {
            for (prop in average) {
                average[prop] += pointers[i][prop];
            }
        }
        for (prop in average) {
            average[prop] /= pointers.length;
        }

        return average;
    }

    function touchBBox(event) {
        if (!event.length && !(event.touches && event.touches.length > 1)) {
            return;
        }

        var touches = getTouchPair(event),
            minX = Math.min(touches[0].pageX, touches[1].pageX),
            minY = Math.min(touches[0].pageY, touches[1].pageY),
            maxX = Math.max(touches[0].pageX, touches[1].pageX),
            maxY = Math.max(touches[0].pageY, touches[1].pageY);

        return {
            x: minX,
            y: minY,
            left: minX,
            top: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }

    function touchDistance(event, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event);


        var dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY];

        return hypot(dx, dy);
    }

    function touchAngle(event, prevAngle, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event),
            dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY],
            angle = 180 * Math.atan(dy / dx) / Math.PI;

        if (isNumber(prevAngle)) {
            var dr = angle - prevAngle,
                drClamped = dr % 360;

            if (drClamped > 315) {
                angle -= 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped > 135) {
                angle -= 180 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -315) {
                angle += 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -135) {
                angle += 180 + (angle / 360) | 0 * 360;
            }
        }

        return angle;
    }

    function getOriginXY(interactable, element) {
        var origin = interactable
            ? interactable.options.origin
            : defaultOptions.origin;

        if (origin === 'parent') {
            origin = parentElement(element);
        }
        else if (origin === 'self') {
            origin = interactable.getRect(element);
        }
        else if (trySelector(origin)) {
            origin = closest(element, origin) || { x: 0, y: 0 };
        }

        if (isFunction(origin)) {
            origin = origin(interactable && element);
        }

        if (isElement(origin)) {
            origin = getElementRect(origin);
        }

        origin.x = ('x' in origin) ? origin.x : origin.left;
        origin.y = ('y' in origin) ? origin.y : origin.top;

        return origin;
    }

    // https://stackoverflow.com/a/5634528/2280888
    function _getQBezierValue(t, p1, p2, p3) {
        var iT = 1 - t;
        return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
    }

    function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
        return {
            x: _getQBezierValue(position, startX, cpX, endX),
            y: _getQBezierValue(position, startY, cpY, endY)
        };
    }

    // https://gizma.com/easing/
    function easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
    }

    function nodeContains(parent, child) {
        while (child) {
            if (child === parent) {
                return true;
            }

            child = child.parentNode;
        }

        return false;
    }

    function closest(child, selector) {
        var parent = parentElement(child);

        while (isElement(parent)) {
            if (matchesSelector(parent, selector)) { return parent; }

            parent = parentElement(parent);
        }

        return null;
    }

    function parentElement(node) {
        var parent = node.parentNode;

        if (isDocFrag(parent)) {
            // skip past #shado-root fragments
            while ((parent = parent.host) && isDocFrag(parent)) { }

            return parent;
        }

        return parent;
    }

    function inContext(interactable, element) {
        return interactable._context === element.ownerDocument
            || nodeContains(interactable._context, element);
    }

    function testIgnore(interactable, interactableElement, element) {
        var ignoreFrom = interactable.options.ignoreFrom;

        if (!ignoreFrom || !isElement(element)) { return false; }

        if (isString(ignoreFrom)) {
            return matchesUpTo(element, ignoreFrom, interactableElement);
        }
        else if (isElement(ignoreFrom)) {
            return nodeContains(ignoreFrom, element);
        }

        return false;
    }

    function testAllow(interactable, interactableElement, element) {
        var allowFrom = interactable.options.allowFrom;

        if (!allowFrom) { return true; }

        if (!isElement(element)) { return false; }

        if (isString(allowFrom)) {
            return matchesUpTo(element, allowFrom, interactableElement);
        }
        else if (isElement(allowFrom)) {
            return nodeContains(allowFrom, element);
        }

        return false;
    }

    function checkAxis(axis, interactable) {
        if (!interactable) { return false; }

        var thisAxis = interactable.options.drag.axis;

        return (axis === 'xy' || thisAxis === 'xy' || thisAxis === axis);
    }

    function checkSnap(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].snap && options[action].snap.enabled;
    }

    function checkRestrict(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].restrict && options[action].restrict.enabled;
    }

    function checkAutoScroll(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].autoScroll && options[action].autoScroll.enabled;
    }

    function withinInteractionLimit(interactable, element, action) {
        var options = interactable.options,
            maxActions = options[action.name].max,
            maxPerElement = options[action.name].maxPerElement,
            activeInteractions = 0,
            targetCount = 0,
            targetElementCount = 0;

        for (var i = 0, len = interactions.length; i < len; i++) {
            var interaction = interactions[i],
                otherAction = interaction.prepared.name,
                active = interaction.interacting();

            if (!active) { continue; }

            activeInteractions++;

            if (activeInteractions >= maxInteractions) {
                return false;
            }

            if (interaction.target !== interactable) { continue; }

            targetCount += (otherAction === action.name) | 0;

            if (targetCount >= maxActions) {
                return false;
            }

            if (interaction.element === element) {
                targetElementCount++;

                if (otherAction !== action.name || targetElementCount >= maxPerElement) {
                    return false;
                }
            }
        }

        return maxInteractions > 0;
    }

    // Test for the element that's "above" all other qualifiers
    function indexOfDeepestElement(elements) {
        var dropzone,
            deepestZone = elements[0],
            index = deepestZone ? 0 : -1,
            parent,
            deepestZoneParents = [],
            dropzoneParents = [],
            child,
            i,
            n;

        for (i = 1; i < elements.length; i++) {
            dropzone = elements[i];

            // an element might belong to multiple selector dropzones
            if (!dropzone || dropzone === deepestZone) {
                continue;
            }

            if (!deepestZone) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            // check if the deepest or current are document.documentElement or document.rootElement
            // - if the current dropzone is, do nothing and continue
            if (dropzone.parentNode === dropzone.ownerDocument) {
                continue;
            }
            // - if deepest is, update with the current dropzone and continue to next
            else if (deepestZone.parentNode === dropzone.ownerDocument) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            if (!deepestZoneParents.length) {
                parent = deepestZone;
                while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
                    deepestZoneParents.unshift(parent);
                    parent = parent.parentNode;
                }
            }

            // if this element is an svg element and the current deepest is
            // an HTMLElement
            if (deepestZone instanceof HTMLElement
                && dropzone instanceof SVGElement
                && !(dropzone instanceof SVGSVGElement)) {

                if (dropzone === deepestZone.parentNode) {
                    continue;
                }

                parent = dropzone.ownerSVGElement;
            }
            else {
                parent = dropzone;
            }

            dropzoneParents = [];

            while (parent.parentNode !== parent.ownerDocument) {
                dropzoneParents.unshift(parent);
                parent = parent.parentNode;
            }

            n = 0;

            // get (position of last common ancestor) + 1
            while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
                n++;
            }

            var parents = [
                dropzoneParents[n - 1],
                dropzoneParents[n],
                deepestZoneParents[n]
            ];

            child = parents[0].lastChild;

            while (child) {
                if (child === parents[1]) {
                    deepestZone = dropzone;
                    index = i;
                    deepestZoneParents = [];

                    break;
                }
                else if (child === parents[2]) {
                    break;
                }

                child = child.previousSibling;
            }
        }

        return index;
    }

    function Interaction() {
        this.target = null; // current interactable being interacted with
        this.element = null; // the target element of the interactable
        this.dropTarget = null; // the dropzone a drag target might be dropped into
        this.dropElement = null; // the element at the time of checking
        this.prevDropTarget = null; // the dropzone that was recently dragged away from
        this.prevDropElement = null; // the element at the time of checking

        this.prepared = {     // action that's ready to be fired on next move event
            name: null,
            axis: null,
            edges: null
        };

        this.matches = [];   // all selectors that are matched by target element
        this.matchElements = [];   // corresponding elements

        this.inertiaStatus = {
            active: false,
            smoothEnd: false,
            ending: false,

            startEvent: null,
            upCoords: {},

            xe: 0, ye: 0,
            sx: 0, sy: 0,

            t0: 0,
            vx0: 0, vys: 0,
            duration: 0,

            resumeDx: 0,
            resumeDy: 0,

            lambda_v0: 0,
            one_ve_v0: 0,
            i: null
        };

        if (isFunction(Function.prototype.bind)) {
            this.boundInertiaFrame = this.inertiaFrame.bind(this);
            this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);
        }
        else {
            var that = this;

            this.boundInertiaFrame = function () { return that.inertiaFrame(); };
            this.boundSmoothEndFrame = function () { return that.smoothEndFrame(); };
        }

        this.activeDrops = {
            dropzones: [],      // the dropzones that are mentioned below
            elements: [],      // elements of dropzones that accept the target draggable
            rects: []       // the rects of the elements mentioned above
        };

        // keep track of added pointers
        this.pointers = [];
        this.pointerIds = [];
        this.downTargets = [];
        this.downTimes = [];
        this.holdTimers = [];

        // Previous native pointer move event coordinates
        this.prevCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };
        // current native pointer move event coordinates
        this.curCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Starting InteractEvent pointer coordinates
        this.startCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Change in coordinates and time of the pointer
        this.pointerDelta = {
            page: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            client: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            timeStamp: 0
        };

        this.downEvent = null;    // pointerdown/mousedown/touchstart event
        this.downPointer = {};

        this._eventTarget = null;
        this._curEventTarget = null;

        this.prevEvent = null;      // previous action event
        this.tapTime = 0;         // time of the most recent tap event
        this.prevTap = null;

        this.startOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.restrictOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.snapOffsets = [];

        this.gesture = {
            start: { x: 0, y: 0 },

            startDistance: 0,   // distance between two touches of touchStart
            prevDistance: 0,
            distance: 0,

            scale: 1,           // gesture.distance / gesture.startDistance

            startAngle: 0,      // angle of line joining two touches
            prevAngle: 0       // angle of the previous gesture event
        };

        this.snapStatus = {
            x: 0, y: 0,
            dx: 0, dy: 0,
            realX: 0, realY: 0,
            snappedX: 0, snappedY: 0,
            targets: [],
            locked: false,
            changed: false
        };

        this.restrictStatus = {
            dx: 0, dy: 0,
            restrictedX: 0, restrictedY: 0,
            snap: null,
            restricted: false,
            changed: false
        };

        this.restrictStatus.snap = this.snapStatus;

        this.pointerIsDown = false;
        this.pointerWasMoved = false;
        this.gesturing = false;
        this.dragging = false;
        this.resizing = false;
        this.resizeAxes = 'xy';

        this.mouse = false;

        interactions.push(this);
    }

    Interaction.prototype = {
        getPageXY: function (pointer, xy) { return getPageXY(pointer, xy, this); },
        getClientXY: function (pointer, xy) { return getClientXY(pointer, xy, this); },
        setEventXY: function (target, ptr) { return setEventXY(target, ptr, this); },

        pointerOver: function (pointer, event, eventTarget) {
            if (this.prepared.name || !this.mouse) { return; }

            var curMatches = [],
                curMatchElements = [],
                prevTargetElement = this.element;

            this.addPointer(pointer);

            if (this.target
                && (testIgnore(this.target, this.element, eventTarget)
                    || !testAllow(this.target, this.element, eventTarget))) {
                // if the eventTarget should be ignored or shouldn't be allowed
                // clear the previous target
                this.target = null;
                this.element = null;
                this.matches = [];
                this.matchElements = [];
            }

            var elementInteractable = interactables.get(eventTarget),
                elementAction = (elementInteractable
                    && !testIgnore(elementInteractable, eventTarget, eventTarget)
                    && testAllow(elementInteractable, eventTarget, eventTarget)
                    && validateAction(
                        elementInteractable.getAction(pointer, event, this, eventTarget),
                        elementInteractable));

            if (elementAction && !withinInteractionLimit(elementInteractable, eventTarget, elementAction)) {
                elementAction = null;
            }

            function pushCurMatches(interactable, selector) {
                if (interactable
                    && isElement(eventTarget)
                    && inContext(interactable, eventTarget)
                    && !testIgnore(interactable, eventTarget, eventTarget)
                    && testAllow(interactable, eventTarget, eventTarget)
                    && matchesSelector(eventTarget, selector)) {

                    curMatches.push(interactable);
                    curMatchElements.push(eventTarget);
                }
            }

            if (elementAction) {
                this.target = elementInteractable;
                this.element = eventTarget;
                this.matches = [];
                this.matchElements = [];
            }
            else {
                interactables.forEachSelector(pushCurMatches);

                if (this.validateSelector(pointer, event, curMatches, curMatchElements)) {
                    this.matches = curMatches;
                    this.matchElements = curMatchElements;

                    this.pointerHover(pointer, event, this.matches, this.matchElements);
                    events.add(eventTarget,
                        supportsPointerEvent ? pEventTypes.move : 'mousemove',
                        listeners.pointerHover);
                }
                else if (this.target) {
                    if (nodeContains(prevTargetElement, eventTarget)) {
                        this.pointerHover(pointer, event, this.matches, this.matchElements);
                        events.add(this.element,
                            supportsPointerEvent ? pEventTypes.move : 'mousemove',
                            listeners.pointerHover);
                    }
                    else {
                        this.target = null;
                        this.element = null;
                        this.matches = [];
                        this.matchElements = [];
                    }
                }
            }
        },

        // Check what action would be performed on pointerMove target if a mouse
        // button were pressed and change the cursor accordingly
        pointerHover: function (pointer, event, eventTarget, curEventTarget, matches, matchElements) {
            var target = this.target;

            if (!this.prepared.name && this.mouse) {

                var action;

                // update pointer coords for defaultActionChecker to use
                this.setEventXY(this.curCoords, [pointer]);

                if (matches) {
                    action = this.validateSelector(pointer, event, matches, matchElements);
                }
                else if (target) {
                    action = validateAction(target.getAction(this.pointers[0], event, this, this.element), this.target);
                }

                if (target && target.options.styleCursor) {
                    if (action) {
                        target._doc.documentElement.style.cursor = getActionCursor(action);
                    }
                    else {
                        target._doc.documentElement.style.cursor = '';
                    }
                }
            }
            else if (this.prepared.name) {
                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        pointerOut: function (pointer, event, eventTarget) {
            if (this.prepared.name) { return; }

            // Remove temporary event listeners for selector Interactables
            if (!interactables.get(eventTarget)) {
                events.remove(eventTarget,
                    supportsPointerEvent ? pEventTypes.move : 'mousemove',
                    listeners.pointerHover);
            }

            if (this.target && this.target.options.styleCursor && !this.interacting()) {
                this.target._doc.documentElement.style.cursor = '';
            }
        },

        selectorDown: function (pointer, event, eventTarget, curEventTarget) {
            var that = this,
                // copy event to be used in timeout for IE8
                eventCopy = events.useAttachEvent ? extend({}, event) : event,
                element = eventTarget,
                pointerIndex = this.addPointer(pointer),
                action;

            this.holdTimers[pointerIndex] = setTimeout(function () {
                that.pointerHold(events.useAttachEvent ? eventCopy : pointer, eventCopy, eventTarget, curEventTarget);
            }, defaultOptions._holdDuration);

            this.pointerIsDown = true;

            // Check if the down event hits the current inertia target
            if (this.inertiaStatus.active && this.target.selector) {
                // climb up the DOM tree from the event target
                while (isElement(element)) {

                    // if this element is the current inertia target element
                    if (element === this.element
                        // and the prospective action is the same as the ongoing one
                        && validateAction(this.target.getAction(pointer, event, this, this.element), this.target).name === this.prepared.name) {

                        // stop inertia so that the next move will be a normal one
                        cancelFrame(this.inertiaStatus.i);
                        this.inertiaStatus.active = false;

                        this.collectEventTargets(pointer, event, eventTarget, 'down');
                        return;
                    }
                    element = parentElement(element);
                }
            }

            // do nothing if interacting
            if (this.interacting()) {
                this.collectEventTargets(pointer, event, eventTarget, 'down');
                return;
            }

            function pushMatches(interactable, selector, context) {
                var elements = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, elements)) {

                    that.matches.push(interactable);
                    that.matchElements.push(element);
                }
            }

            // update pointer coords for defaultActionChecker to use
            this.setEventXY(this.curCoords, [pointer]);
            this.downEvent = event;

            while (isElement(element) && !action) {
                this.matches = [];
                this.matchElements = [];

                interactables.forEachSelector(pushMatches);

                action = this.validateSelector(pointer, event, this.matches, this.matchElements);
                element = parentElement(element);
            }

            if (action) {
                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.collectEventTargets(pointer, event, eventTarget, 'down');

                return this.pointerDown(pointer, event, eventTarget, curEventTarget, action);
            }
            else {
                // do these now since pointerDown isn't being called from here
                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.curCoords);
                this.pointerWasMoved = false;
            }

            this.collectEventTargets(pointer, event, eventTarget, 'down');
        },

        // Determine action to be performed on next pointerMove and add appropriate
        // style and event Listeners
        pointerDown: function (pointer, event, eventTarget, curEventTarget, forceAction) {
            if (!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) {
                this.checkAndPreventDefault(event, this.target, this.element);

                return;
            }

            this.pointerIsDown = true;
            this.downEvent = event;

            var pointerIndex = this.addPointer(pointer),
                action;

            // If it is the second touch of a multi-touch gesture, keep the
            // target the same and get a new action if a target was set by the
            // first touch
            if (this.pointerIds.length > 1 && this.target._element === this.element) {
                var newAction = validateAction(forceAction || this.target.getAction(pointer, event, this, this.element), this.target);

                if (withinInteractionLimit(this.target, this.element, newAction)) {
                    action = newAction;
                }

                this.prepared.name = null;
            }
            // Otherwise, set the target if there is no action prepared
            else if (!this.prepared.name) {
                var interactable = interactables.get(curEventTarget);

                if (interactable
                    && !testIgnore(interactable, curEventTarget, eventTarget)
                    && testAllow(interactable, curEventTarget, eventTarget)
                    && (action = validateAction(forceAction || interactable.getAction(pointer, event, this, curEventTarget), interactable, eventTarget))
                    && withinInteractionLimit(interactable, curEventTarget, action)) {
                    this.target = interactable;
                    this.element = curEventTarget;
                }
            }

            var target = this.target,
                options = target && target.options;

            if (target && (forceAction || !this.prepared.name)) {
                action = action || validateAction(forceAction || target.getAction(pointer, event, this, curEventTarget), target, this.element);

                this.setEventXY(this.startCoords, this.pointers);

                if (!action) { return; }

                if (options.styleCursor) {
                    target._doc.documentElement.style.cursor = getActionCursor(action);
                }

                this.resizeAxes = action.name === 'resize' ? action.axis : null;

                if (action === 'gesture' && this.pointerIds.length < 2) {
                    action = null;
                }

                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.snapStatus.snappedX = this.snapStatus.snappedY =
                    this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;

                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.startCoords);
                this.pointerWasMoved = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
            // if inertia is active try to resume action
            else if (this.inertiaStatus.active
                && curEventTarget === this.element
                && validateAction(target.getAction(pointer, event, this, this.element), target).name === this.prepared.name) {

                cancelFrame(this.inertiaStatus.i);
                this.inertiaStatus.active = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        setModifications: function (coords, preEnd) {
            var target = this.target,
                shouldMove = true,
                shouldSnap = checkSnap(target, this.prepared.name) && (!target.options[this.prepared.name].snap.endOnly || preEnd),
                shouldRestrict = checkRestrict(target, this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);

            if (shouldSnap) { this.setSnapping(coords); } else { this.snapStatus.locked = false; }
            if (shouldRestrict) { this.setRestriction(coords); } else { this.restrictStatus.restricted = false; }

            if (shouldSnap && this.snapStatus.locked && !this.snapStatus.changed) {
                shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;
            }
            else if (shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed) {
                shouldMove = false;
            }

            return shouldMove;
        },

        setStartOffsets: function (action, interactable, element) {
            var rect = interactable.getRect(element),
                origin = getOriginXY(interactable, element),
                snap = interactable.options[this.prepared.name].snap,
                restrict = interactable.options[this.prepared.name].restrict,
                width, height;

            if (rect) {
                this.startOffset.left = this.startCoords.page.x - rect.left;
                this.startOffset.top = this.startCoords.page.y - rect.top;

                this.startOffset.right = rect.right - this.startCoords.page.x;
                this.startOffset.bottom = rect.bottom - this.startCoords.page.y;

                if ('width' in rect) { width = rect.width; }
                else { width = rect.right - rect.left; }
                if ('height' in rect) { height = rect.height; }
                else { height = rect.bottom - rect.top; }
            }
            else {
                this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;
            }

            this.snapOffsets.splice(0);

            var snapOffset = snap && snap.offset === 'startCoords'
                ? {
                    x: this.startCoords.page.x - origin.x,
                    y: this.startCoords.page.y - origin.y
                }
                : snap && snap.offset || { x: 0, y: 0 };

            if (rect && snap && snap.relativePoints && snap.relativePoints.length) {
                for (var i = 0; i < snap.relativePoints.length; i++) {
                    this.snapOffsets.push({
                        x: this.startOffset.left - (width * snap.relativePoints[i].x) + snapOffset.x,
                        y: this.startOffset.top - (height * snap.relativePoints[i].y) + snapOffset.y
                    });
                }
            }
            else {
                this.snapOffsets.push(snapOffset);
            }

            if (rect && restrict.elementRect) {
                this.restrictOffset.left = this.startOffset.left - (width * restrict.elementRect.left);
                this.restrictOffset.top = this.startOffset.top - (height * restrict.elementRect.top);

                this.restrictOffset.right = this.startOffset.right - (width * (1 - restrict.elementRect.right));
                this.restrictOffset.bottom = this.startOffset.bottom - (height * (1 - restrict.elementRect.bottom));
            }
            else {
                this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
            }
        },

        /*\
         * Interaction.start
         [ method ]
         *
         * Start an action with the given Interactable and Element as tartgets. The
         * action must be enabled for the target Interactable and an appropriate number
         * of pointers must be held down â€“ 1 for drag/resize, 2 for gesture.
         *
         * Use it with `interactable.<action>able({ manualStart: false })` to always
         * [start actions manually](https://github.com/taye/interact.js/issues/114)
         *
         - action       (object)  The action to be performed - drag, resize, etc.
         - interactable (Interactable) The Interactable to target
         - element      (Element) The DOM Element to target
         = (object) interact
         **
         | interact(target)
         |   .draggable({
         |     // disable the default drag start by down->move
         |     manualStart: true
         |   })
         |   // start dragging after the user holds the pointer down
         |   .on('hold', function (event) {
         |     var interaction = event.interaction;
         |
         |     if (!interaction.interacting()) {
         |       interaction.start({ name: 'drag' },
         |                         event.interactable,
         |                         event.currentTarget);
         |     }
         | });
        \*/
        start: function (action, interactable, element) {
            if (this.interacting()
                || !this.pointerIsDown
                || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) {
                return;
            }

            // if this interaction had been removed after stopping
            // add it back
            if (indexOf(interactions, this) === -1) {
                interactions.push(this);
            }

            // set the startCoords if there was no prepared action
            if (!this.prepared.name) {
                this.setEventXY(this.startCoords, this.pointers);
            }

            this.prepared.name = action.name;
            this.prepared.axis = action.axis;
            this.prepared.edges = action.edges;
            this.target = interactable;
            this.element = element;

            this.setStartOffsets(action.name, interactable, element);
            this.setModifications(this.startCoords.page);

            this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);
        },

        pointerMove: function (pointer, event, eventTarget, curEventTarget, preEnd) {
            if (this.inertiaStatus.active) {
                var pageUp = this.inertiaStatus.upCoords.page;
                var clientUp = this.inertiaStatus.upCoords.client;

                var inertiaPosition = {
                    pageX: pageUp.x + this.inertiaStatus.sx,
                    pageY: pageUp.y + this.inertiaStatus.sy,
                    clientX: clientUp.x + this.inertiaStatus.sx,
                    clientY: clientUp.y + this.inertiaStatus.sy
                };

                this.setEventXY(this.curCoords, [inertiaPosition]);
            }
            else {
                this.recordPointer(pointer);
                this.setEventXY(this.curCoords, this.pointers);
            }

            var duplicateMove = (this.curCoords.page.x === this.prevCoords.page.x
                && this.curCoords.page.y === this.prevCoords.page.y
                && this.curCoords.client.x === this.prevCoords.client.x
                && this.curCoords.client.y === this.prevCoords.client.y);

            var dx, dy,
                pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // register movement greater than pointerMoveTolerance
            if (this.pointerIsDown && !this.pointerWasMoved) {
                dx = this.curCoords.client.x - this.startCoords.client.x;
                dy = this.curCoords.client.y - this.startCoords.client.y;

                this.pointerWasMoved = hypot(dx, dy) > pointerMoveTolerance;
            }

            if (!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)) {
                if (this.pointerIsDown) {
                    clearTimeout(this.holdTimers[pointerIndex]);
                }

                this.collectEventTargets(pointer, event, eventTarget, 'move');
            }

            if (!this.pointerIsDown) { return; }

            if (duplicateMove && this.pointerWasMoved && !preEnd) {
                this.checkAndPreventDefault(event, this.target, this.element);
                return;
            }

            // set pointer coordinate, time changes and speeds
            setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

            if (!this.prepared.name) { return; }

            if (this.pointerWasMoved
                // ignore movement while inertia is active
                && (!this.inertiaStatus.active || (pointer instanceof InteractEvent && /inertiastart/.test(pointer.type)))) {

                // if just starting an action, calculate the pointer speed now
                if (!this.interacting()) {
                    setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

                    // check if a drag is in the correct axis
                    if (this.prepared.name === 'drag') {
                        var absX = Math.abs(dx),
                            absY = Math.abs(dy),
                            targetAxis = this.target.options.drag.axis,
                            axis = (absX > absY ? 'x' : absX < absY ? 'y' : 'xy');

                        // if the movement isn't in the axis of the interactable
                        if (axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis) {
                            // cancel the prepared action
                            this.prepared.name = null;

                            // then try to get a drag from another ineractable

                            var element = eventTarget;

                            // check element interactables
                            while (isElement(element)) {
                                var elementInteractable = interactables.get(element);

                                if (elementInteractable
                                    && elementInteractable !== this.target
                                    && !elementInteractable.options.drag.manualStart
                                    && elementInteractable.getAction(this.downPointer, this.downEvent, this, element).name === 'drag'
                                    && checkAxis(axis, elementInteractable)) {

                                    this.prepared.name = 'drag';
                                    this.target = elementInteractable;
                                    this.element = element;
                                    break;
                                }

                                element = parentElement(element);
                            }

                            // if there's no drag from element interactables,
                            // check the selector interactables
                            if (!this.prepared.name) {
                                var thisInteraction = this;

                                var getDraggable = function (interactable, selector, context) {
                                    var elements = ie8MatchesSelector
                                        ? context.querySelectorAll(selector)
                                        : undefined;

                                    if (interactable === thisInteraction.target) { return; }

                                    if (inContext(interactable, eventTarget)
                                        && !interactable.options.drag.manualStart
                                        && !testIgnore(interactable, element, eventTarget)
                                        && testAllow(interactable, element, eventTarget)
                                        && matchesSelector(element, selector, elements)
                                        && interactable.getAction(thisInteraction.downPointer, thisInteraction.downEvent, thisInteraction, element).name === 'drag'
                                        && checkAxis(axis, interactable)
                                        && withinInteractionLimit(interactable, element, 'drag')) {

                                        return interactable;
                                    }
                                };

                                element = eventTarget;

                                while (isElement(element)) {
                                    var selectorInteractable = interactables.forEachSelector(getDraggable);

                                    if (selectorInteractable) {
                                        this.prepared.name = 'drag';
                                        this.target = selectorInteractable;
                                        this.element = element;
                                        break;
                                    }

                                    element = parentElement(element);
                                }
                            }
                        }
                    }
                }

                var starting = !!this.prepared.name && !this.interacting();

                if (starting
                    && (this.target.options[this.prepared.name].manualStart
                        || !withinInteractionLimit(this.target, this.element, this.prepared))) {
                    this.stop(event);
                    return;
                }

                if (this.prepared.name && this.target) {
                    if (starting) {
                        this.start(this.prepared, this.target, this.element);
                    }

                    var shouldMove = this.setModifications(this.curCoords.page, preEnd);

                    // move if snapping or restriction doesn't prevent it
                    if (shouldMove || starting) {
                        this.prevEvent = this[this.prepared.name + 'Move'](event);
                    }

                    this.checkAndPreventDefault(event, this.target, this.element);
                }
            }

            copyCoords(this.prevCoords, this.curCoords);

            if (this.dragging || this.resizing) {
                this.autoScrollMove(pointer);
            }
        },

        dragStart: function (event) {
            var dragEvent = new InteractEvent(this, event, 'drag', 'start', this.element);

            this.dragging = true;
            this.target.fire(dragEvent);

            // reset active dropzones
            this.activeDrops.dropzones = [];
            this.activeDrops.elements = [];
            this.activeDrops.rects = [];

            if (!this.dynamicDrop) {
                this.setActiveDrops(this.element);
            }

            var dropEvents = this.getDropEvents(event, dragEvent);

            if (dropEvents.activate) {
                this.fireActiveDrops(dropEvents.activate);
            }

            return dragEvent;
        },

        dragMove: function (event) {
            var target = this.target,
                dragEvent = new InteractEvent(this, event, 'drag', 'move', this.element),
                draggableElement = this.element,
                drop = this.getDrop(dragEvent, event, draggableElement);

            this.dropTarget = drop.dropzone;
            this.dropElement = drop.element;

            var dropEvents = this.getDropEvents(event, dragEvent);

            target.fire(dragEvent);

            if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
            if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
            if (dropEvents.move) { this.dropTarget.fire(dropEvents.move); }

            this.prevDropTarget = this.dropTarget;
            this.prevDropElement = this.dropElement;

            return dragEvent;
        },

        resizeStart: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'start', this.element);

            if (this.prepared.edges) {
                var startRect = this.target.getRect(this.element);

                /*
                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
                 * on the active edges and the edge being interacted with.
                 */
                if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
                    var linkedEdges = extend({}, this.prepared.edges);

                    linkedEdges.top = linkedEdges.top || (linkedEdges.left && !linkedEdges.bottom);
                    linkedEdges.left = linkedEdges.left || (linkedEdges.top && !linkedEdges.right);
                    linkedEdges.bottom = linkedEdges.bottom || (linkedEdges.right && !linkedEdges.top);
                    linkedEdges.right = linkedEdges.right || (linkedEdges.bottom && !linkedEdges.left);

                    this.prepared._linkedEdges = linkedEdges;
                }
                else {
                    this.prepared._linkedEdges = null;
                }

                // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
                if (this.target.options.resize.preserveAspectRatio) {
                    this.resizeStartAspectRatio = startRect.width / startRect.height;
                }

                this.resizeRects = {
                    start: startRect,
                    current: extend({}, startRect),
                    restricted: extend({}, startRect),
                    previous: extend({}, startRect),
                    delta: {
                        left: 0, right: 0, width: 0,
                        top: 0, bottom: 0, height: 0
                    }
                };

                resizeEvent.rect = this.resizeRects.restricted;
                resizeEvent.deltaRect = this.resizeRects.delta;
            }

            this.target.fire(resizeEvent);

            this.resizing = true;

            return resizeEvent;
        },

        resizeMove: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'move', this.element);

            var edges = this.prepared.edges,
                invert = this.target.options.resize.invert,
                invertible = invert === 'reposition' || invert === 'negate';

            if (edges) {
                var dx = resizeEvent.dx,
                    dy = resizeEvent.dy,

                    start = this.resizeRects.start,
                    current = this.resizeRects.current,
                    restricted = this.resizeRects.restricted,
                    delta = this.resizeRects.delta,
                    previous = extend(this.resizeRects.previous, restricted),

                    originalEdges = edges;

                // `resize.preserveAspectRatio` takes precedence over `resize.square`
                if (this.target.options.resize.preserveAspectRatio) {
                    var resizeStartAspectRatio = this.resizeStartAspectRatio;

                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx / resizeStartAspectRatio;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx / resizeStartAspectRatio; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy * resizeStartAspectRatio; }
                }
                else if (this.target.options.resize.square) {
                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy; }
                }

                // update the 'current' rect without modifications
                if (edges.top) { current.top += dy; }
                if (edges.bottom) { current.bottom += dy; }
                if (edges.left) { current.left += dx; }
                if (edges.right) { current.right += dx; }

                if (invertible) {
                    // if invertible, copy the current rect
                    extend(restricted, current);

                    if (invert === 'reposition') {
                        // swap edge values if necessary to keep width/height positive
                        var swap;

                        if (restricted.top > restricted.bottom) {
                            swap = restricted.top;

                            restricted.top = restricted.bottom;
                            restricted.bottom = swap;
                        }
                        if (restricted.left > restricted.right) {
                            swap = restricted.left;

                            restricted.left = restricted.right;
                            restricted.right = swap;
                        }
                    }
                }
                else {
                    // if not invertible, restrict to minimum of 0x0 rect
                    restricted.top = Math.min(current.top, start.bottom);
                    restricted.bottom = Math.max(current.bottom, start.top);
                    restricted.left = Math.min(current.left, start.right);
                    restricted.right = Math.max(current.right, start.left);
                }

                restricted.width = restricted.right - restricted.left;
                restricted.height = restricted.bottom - restricted.top;

                for (var edge in restricted) {
                    delta[edge] = restricted[edge] - previous[edge];
                }

                resizeEvent.edges = this.prepared.edges;
                resizeEvent.rect = restricted;
                resizeEvent.deltaRect = delta;
            }

            this.target.fire(resizeEvent);

            return resizeEvent;
        },

        gestureStart: function (event) {
            var gestureEvent = new InteractEvent(this, event, 'gesture', 'start', this.element);

            gestureEvent.ds = 0;

            this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;
            this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.scale = 1;

            this.gesturing = true;

            this.target.fire(gestureEvent);

            return gestureEvent;
        },

        gestureMove: function (event) {
            if (!this.pointerIds.length) {
                return this.prevEvent;
            }

            var gestureEvent;

            gestureEvent = new InteractEvent(this, event, 'gesture', 'move', this.element);
            gestureEvent.ds = gestureEvent.scale - this.gesture.scale;

            this.target.fire(gestureEvent);

            this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.prevDistance = gestureEvent.distance;

            if (gestureEvent.scale !== Infinity &&
                gestureEvent.scale !== null &&
                gestureEvent.scale !== undefined &&
                !isNaN(gestureEvent.scale)) {

                this.gesture.scale = gestureEvent.scale;
            }

            return gestureEvent;
        },

        pointerHold: function (pointer, event, eventTarget) {
            this.collectEventTargets(pointer, event, eventTarget, 'hold');
        },

        pointerUp: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'up');
            this.collectEventTargets(pointer, event, eventTarget, 'tap');

            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        pointerCancel: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'cancel');
            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        // https://www.quirksmode.org/dom/events/click.html
        // >Events leading to dblclick
        //
        // IE8 doesn't fire down event before dblclick.
        // This workaround tries to fire a tap and doubletap after dblclick
        ie8Dblclick: function (pointer, event, eventTarget) {
            if (this.prevTap
                && event.clientX === this.prevTap.clientX
                && event.clientY === this.prevTap.clientY
                && eventTarget === this.prevTap.target) {

                this.downTargets[0] = eventTarget;
                this.downTimes[0] = new Date().getTime();
                this.collectEventTargets(pointer, event, eventTarget, 'tap');
            }
        },

        // End interact move events and stop auto-scroll unless inertia is enabled
        pointerEnd: function (pointer, event, eventTarget, curEventTarget) {
            var endEvent,
                target = this.target,
                options = target && target.options,
                inertiaOptions = options && this.prepared.name && options[this.prepared.name].inertia,
                inertiaStatus = this.inertiaStatus;

            if (this.interacting()) {

                if (inertiaStatus.active && !inertiaStatus.ending) { return; }

                var pointerSpeed,
                    now = new Date().getTime(),
                    inertiaPossible = false,
                    inertia = false,
                    smoothEnd = false,
                    endSnap = checkSnap(target, this.prepared.name) && options[this.prepared.name].snap.endOnly,
                    endRestrict = checkRestrict(target, this.prepared.name) && options[this.prepared.name].restrict.endOnly,
                    dx = 0,
                    dy = 0,
                    startEvent;

                if (this.dragging) {
                    if (options.drag.axis === 'x') { pointerSpeed = Math.abs(this.pointerDelta.client.vx); }
                    else if (options.drag.axis === 'y') { pointerSpeed = Math.abs(this.pointerDelta.client.vy); }
                    else   /*options.drag.axis === 'xy'*/ { pointerSpeed = this.pointerDelta.client.speed; }
                }
                else {
                    pointerSpeed = this.pointerDelta.client.speed;
                }

                // check if inertia should be started
                inertiaPossible = (inertiaOptions && inertiaOptions.enabled
                    && this.prepared.name !== 'gesture'
                    && event !== inertiaStatus.startEvent);

                inertia = (inertiaPossible
                    && (now - this.curCoords.timeStamp) < 50
                    && pointerSpeed > inertiaOptions.minSpeed
                    && pointerSpeed > inertiaOptions.endSpeed);

                if (inertiaPossible && !inertia && (endSnap || endRestrict)) {

                    var snapRestrict = {};

                    snapRestrict.snap = snapRestrict.restrict = snapRestrict;

                    if (endSnap) {
                        this.setSnapping(this.curCoords.page, snapRestrict);
                        if (snapRestrict.locked) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (endRestrict) {
                        this.setRestriction(this.curCoords.page, snapRestrict);
                        if (snapRestrict.restricted) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (dx || dy) {
                        smoothEnd = true;
                    }
                }

                if (inertia || smoothEnd) {
                    copyCoords(inertiaStatus.upCoords, this.curCoords);

                    this.pointers[0] = inertiaStatus.startEvent = startEvent =
                        new InteractEvent(this, event, this.prepared.name, 'inertiastart', this.element);

                    inertiaStatus.t0 = now;

                    target.fire(inertiaStatus.startEvent);

                    if (inertia) {
                        inertiaStatus.vx0 = this.pointerDelta.client.vx;
                        inertiaStatus.vy0 = this.pointerDelta.client.vy;
                        inertiaStatus.v0 = pointerSpeed;

                        this.calcInertia(inertiaStatus);

                        var page = extend({}, this.curCoords.page),
                            origin = getOriginXY(target, this.element),
                            statusObject;

                        page.x = page.x + inertiaStatus.xe - origin.x;
                        page.y = page.y + inertiaStatus.ye - origin.y;

                        statusObject = {
                            useStatusXY: true,
                            x: page.x,
                            y: page.y,
                            dx: 0,
                            dy: 0,
                            snap: null
                        };

                        statusObject.snap = statusObject;

                        dx = dy = 0;

                        if (endSnap) {
                            var snap = this.setSnapping(this.curCoords.page, statusObject);

                            if (snap.locked) {
                                dx += snap.dx;
                                dy += snap.dy;
                            }
                        }

                        if (endRestrict) {
                            var restrict = this.setRestriction(this.curCoords.page, statusObject);

                            if (restrict.restricted) {
                                dx += restrict.dx;
                                dy += restrict.dy;
                            }
                        }

                        inertiaStatus.modifiedXe += dx;
                        inertiaStatus.modifiedYe += dy;

                        inertiaStatus.i = reqFrame(this.boundInertiaFrame);
                    }
                    else {
                        inertiaStatus.smoothEnd = true;
                        inertiaStatus.xe = dx;
                        inertiaStatus.ye = dy;

                        inertiaStatus.sx = inertiaStatus.sy = 0;

                        inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
                    }

                    inertiaStatus.active = true;
                    return;
                }

                if (endSnap || endRestrict) {
                    // fire a move event at the snapped coordinates
                    this.pointerMove(pointer, event, eventTarget, curEventTarget, true);
                }
            }

            if (this.dragging) {
                endEvent = new InteractEvent(this, event, 'drag', 'end', this.element);

                var draggableElement = this.element,
                    drop = this.getDrop(endEvent, event, draggableElement);

                this.dropTarget = drop.dropzone;
                this.dropElement = drop.element;

                var dropEvents = this.getDropEvents(event, endEvent);

                if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
                if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
                if (dropEvents.drop) { this.dropTarget.fire(dropEvents.drop); }
                if (dropEvents.deactivate) {
                    this.fireActiveDrops(dropEvents.deactivate);
                }

                target.fire(endEvent);
            }
            else if (this.resizing) {
                endEvent = new InteractEvent(this, event, 'resize', 'end', this.element);
                target.fire(endEvent);
            }
            else if (this.gesturing) {
                endEvent = new InteractEvent(this, event, 'gesture', 'end', this.element);
                target.fire(endEvent);
            }

            this.stop(event);
        },

        collectDrops: function (element) {
            var drops = [],
                elements = [],
                i;

            element = element || this.element;

            // collect all dropzones and their elements which qualify for a drop
            for (i = 0; i < interactables.length; i++) {
                if (!interactables[i].options.drop.enabled) { continue; }

                var current = interactables[i],
                    accept = current.options.drop.accept;

                // test the draggable element against the dropzone's accept setting
                if ((isElement(accept) && accept !== element)
                    || (isString(accept)
                        && !matchesSelector(element, accept))) {

                    continue;
                }

                // query for new elements if necessary
                var dropElements = current.selector ? current._context.querySelectorAll(current.selector) : [current._element];

                for (var j = 0, len = dropElements.length; j < len; j++) {
                    var currentElement = dropElements[j];

                    if (currentElement === element) {
                        continue;
                    }

                    drops.push(current);
                    elements.push(currentElement);
                }
            }

            return {
                dropzones: drops,
                elements: elements
            };
        },

        fireActiveDrops: function (event) {
            var i,
                current,
                currentElement,
                prevElement;

            // loop through all active dropzones and trigger event
            for (i = 0; i < this.activeDrops.dropzones.length; i++) {
                current = this.activeDrops.dropzones[i];
                currentElement = this.activeDrops.elements[i];

                // prevent trigger of duplicate events on same element
                if (currentElement !== prevElement) {
                    // set current element as event target
                    event.target = currentElement;
                    current.fire(event);
                }
                prevElement = currentElement;
            }
        },

        // Collect a new set of possible drops and save them in activeDrops.
        // setActiveDrops should always be called when a drag has just started or a
        // drag event happens while dynamicDrop is true
        setActiveDrops: function (dragElement) {
            // get dropzones and their elements that could receive the draggable
            var possibleDrops = this.collectDrops(dragElement, true);

            this.activeDrops.dropzones = possibleDrops.dropzones;
            this.activeDrops.elements = possibleDrops.elements;
            this.activeDrops.rects = [];

            for (var i = 0; i < this.activeDrops.dropzones.length; i++) {
                this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);
            }
        },

        getDrop: function (dragEvent, event, dragElement) {
            var validDrops = [];

            if (dynamicDrop) {
                this.setActiveDrops(dragElement);
            }

            // collect all dropzones and their elements which qualify for a drop
            for (var j = 0; j < this.activeDrops.dropzones.length; j++) {
                var current = this.activeDrops.dropzones[j],
                    currentElement = this.activeDrops.elements[j],
                    rect = this.activeDrops.rects[j];

                validDrops.push(current.dropCheck(dragEvent, event, this.target, dragElement, currentElement, rect)
                    ? currentElement
                    : null);
            }

            // get the most appropriate dropzone based on DOM depth and order
            var dropIndex = indexOfDeepestElement(validDrops),
                dropzone = this.activeDrops.dropzones[dropIndex] || null,
                element = this.activeDrops.elements[dropIndex] || null;

            return {
                dropzone: dropzone,
                element: element
            };
        },

        getDropEvents: function (pointerEvent, dragEvent) {
            var dropEvents = {
                enter: null,
                leave: null,
                activate: null,
                deactivate: null,
                move: null,
                drop: null
            };

            if (this.dropElement !== this.prevDropElement) {
                // if there was a prevDropTarget, create a dragleave event
                if (this.prevDropTarget) {
                    dropEvents.leave = {
                        target: this.prevDropElement,
                        dropzone: this.prevDropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragleave'
                    };

                    dragEvent.dragLeave = this.prevDropElement;
                    dragEvent.prevDropzone = this.prevDropTarget;
                }
                // if the dropTarget is not null, create a dragenter event
                if (this.dropTarget) {
                    dropEvents.enter = {
                        target: this.dropElement,
                        dropzone: this.dropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragenter'
                    };

                    dragEvent.dragEnter = this.dropElement;
                    dragEvent.dropzone = this.dropTarget;
                }
            }

            if (dragEvent.type === 'dragend' && this.dropTarget) {
                dropEvents.drop = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'drop'
                };

                dragEvent.dropzone = this.dropTarget;
            }
            if (dragEvent.type === 'dragstart') {
                dropEvents.activate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropactivate'
                };
            }
            if (dragEvent.type === 'dragend') {
                dropEvents.deactivate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropdeactivate'
                };
            }
            if (dragEvent.type === 'dragmove' && this.dropTarget) {
                dropEvents.move = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    dragmove: dragEvent,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropmove'
                };
                dragEvent.dropzone = this.dropTarget;
            }

            return dropEvents;
        },

        currentAction: function () {
            return (this.dragging && 'drag') || (this.resizing && 'resize') || (this.gesturing && 'gesture') || null;
        },

        interacting: function () {
            return this.dragging || this.resizing || this.gesturing;
        },

        clearTargets: function () {
            this.target = this.element = null;

            this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
        },

        stop: function (event) {
            if (this.interacting()) {
                autoScroll.stop();
                this.matches = [];
                this.matchElements = [];

                var target = this.target;

                if (target.options.styleCursor) {
                    target._doc.documentElement.style.cursor = '';
                }

                // prevent Default only if were previously interacting
                if (event && isFunction(event.preventDefault)) {
                    this.checkAndPreventDefault(event, target, this.element);
                }

                if (this.dragging) {
                    this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;
                }
            }

            this.clearTargets();

            this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;
            this.prepared.name = this.prevEvent = null;
            this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;

            // remove pointers if their ID isn't in this.pointerIds
            for (var i = 0; i < this.pointers.length; i++) {
                if (indexOf(this.pointerIds, getPointerId(this.pointers[i])) === -1) {
                    this.pointers.splice(i, 1);
                }
            }
        },

        inertiaFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                options = this.target.options[this.prepared.name].inertia,
                lambda = options.resistance,
                t = new Date().getTime() / 1000 - inertiaStatus.t0;

            if (t < inertiaStatus.te) {

                var progress = 1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;

                if (inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye) {
                    inertiaStatus.sx = inertiaStatus.xe * progress;
                    inertiaStatus.sy = inertiaStatus.ye * progress;
                }
                else {
                    var quadPoint = getQuadraticCurvePoint(
                        0, 0,
                        inertiaStatus.xe, inertiaStatus.ye,
                        inertiaStatus.modifiedXe, inertiaStatus.modifiedYe,
                        progress);

                    inertiaStatus.sx = quadPoint.x;
                    inertiaStatus.sy = quadPoint.y;
                }

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundInertiaFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.modifiedXe;
                inertiaStatus.sy = inertiaStatus.modifiedYe;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        smoothEndFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                t = new Date().getTime() - inertiaStatus.t0,
                duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;

            if (t < duration) {
                inertiaStatus.sx = easeOutQuad(t, 0, inertiaStatus.xe, duration);
                inertiaStatus.sy = easeOutQuad(t, 0, inertiaStatus.ye, duration);

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.xe;
                inertiaStatus.sy = inertiaStatus.ye;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.smoothEnd =
                    inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        addPointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) {
                index = this.pointerIds.length;
            }

            this.pointerIds[index] = id;
            this.pointers[index] = pointer;

            return index;
        },

        removePointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) { return; }

            this.pointers.splice(index, 1);
            this.pointerIds.splice(index, 1);
            this.downTargets.splice(index, 1);
            this.downTimes.splice(index, 1);
            this.holdTimers.splice(index, 1);
        },

        recordPointer: function (pointer) {
            var index = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            if (index === -1) { return; }

            this.pointers[index] = pointer;
        },

        collectEventTargets: function (pointer, event, eventTarget, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // do not fire a tap event if the pointer was moved before being lifted
            if (eventType === 'tap' && (this.pointerWasMoved
                // or if the pointerup target is different to the pointerdown target
                || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))) {
                return;
            }

            var targets = [],
                elements = [],
                element = eventTarget;

            function collectSelectors(interactable, selector, context) {
                var els = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (interactable._iEvents[eventType]
                    && isElement(element)
                    && inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, els)) {

                    targets.push(interactable);
                    elements.push(element);
                }
            }

            while (element) {
                if (interact.isSet(element) && interact(element)._iEvents[eventType]) {
                    targets.push(interact(element));
                    elements.push(element);
                }

                interactables.forEachSelector(collectSelectors);

                element = parentElement(element);
            }

            // create the tap event even if there are no listeners so that
            // doubletap can still be created and fired
            if (targets.length || eventType === 'tap') {
                this.firePointers(pointer, event, eventTarget, targets, elements, eventType);
            }
        },

        firePointers: function (pointer, event, eventTarget, targets, elements, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer)),
                pointerEvent = {},
                i,
                // for tap events
                interval, createNewDoubleTap;

            // if it's a doubletap then the event properties would have been
            // copied from the tap event and provided as the pointer argument
            if (eventType === 'doubletap') {
                pointerEvent = pointer;
            }
            else {
                pointerExtend(pointerEvent, event);
                if (event !== pointer) {
                    pointerExtend(pointerEvent, pointer);
                }

                pointerEvent.preventDefault = preventOriginalDefault;
                pointerEvent.stopPropagation = InteractEvent.prototype.stopPropagation;
                pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;
                pointerEvent.interaction = this;

                pointerEvent.timeStamp = new Date().getTime();
                pointerEvent.originalEvent = event;
                pointerEvent.originalPointer = pointer;
                pointerEvent.type = eventType;
                pointerEvent.pointerId = getPointerId(pointer);
                pointerEvent.pointerType = this.mouse ? 'mouse' : !supportsPointerEvent ? 'touch'
                    : isString(pointer.pointerType)
                        ? pointer.pointerType
                        : [, , 'touch', 'pen', 'mouse'][pointer.pointerType];
            }

            if (eventType === 'tap') {
                pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];

                interval = pointerEvent.timeStamp - this.tapTime;
                createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap'
                    && this.prevTap.target === pointerEvent.target
                    && interval < 500);

                pointerEvent.double = createNewDoubleTap;

                this.tapTime = pointerEvent.timeStamp;
            }

            for (i = 0; i < targets.length; i++) {
                pointerEvent.currentTarget = elements[i];
                pointerEvent.interactable = targets[i];
                targets[i].fire(pointerEvent);

                if (pointerEvent.immediatePropagationStopped
                    || (pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget)) {
                    break;
                }
            }

            if (createNewDoubleTap) {
                var doubleTap = {};

                extend(doubleTap, pointerEvent);

                doubleTap.dt = interval;
                doubleTap.type = 'doubletap';

                this.collectEventTargets(doubleTap, event, eventTarget, 'doubletap');

                this.prevTap = doubleTap;
            }
            else if (eventType === 'tap') {
                this.prevTap = pointerEvent;
            }
        },

        validateSelector: function (pointer, event, matches, matchElements) {
            for (var i = 0, len = matches.length; i < len; i++) {
                var match = matches[i],
                    matchElement = matchElements[i],
                    action = validateAction(match.getAction(pointer, event, this, matchElement), match);

                if (action && withinInteractionLimit(match, matchElement, action)) {
                    this.target = match;
                    this.element = matchElement;

                    return action;
                }
            }
        },

        setSnapping: function (pageCoords, status) {
            var snap = this.target.options[this.prepared.name].snap,
                targets = [],
                target,
                page,
                i;

            status = status || this.snapStatus;

            if (status.useStatusXY) {
                page = { x: status.x, y: status.y };
            }
            else {
                var origin = getOriginXY(this.target, this.element);

                page = extend({}, pageCoords);

                page.x -= origin.x;
                page.y -= origin.y;
            }

            status.realX = page.x;
            status.realY = page.y;

            page.x = page.x - this.inertiaStatus.resumeDx;
            page.y = page.y - this.inertiaStatus.resumeDy;

            var len = snap.targets ? snap.targets.length : 0;

            for (var relIndex = 0; relIndex < this.snapOffsets.length; relIndex++) {
                var relative = {
                    x: page.x - this.snapOffsets[relIndex].x,
                    y: page.y - this.snapOffsets[relIndex].y
                };

                for (i = 0; i < len; i++) {
                    if (isFunction(snap.targets[i])) {
                        target = snap.targets[i](relative.x, relative.y, this);
                    }
                    else {
                        target = snap.targets[i];
                    }

                    if (!target) { continue; }

                    targets.push({
                        x: isNumber(target.x) ? (target.x + this.snapOffsets[relIndex].x) : relative.x,
                        y: isNumber(target.y) ? (target.y + this.snapOffsets[relIndex].y) : relative.y,

                        range: isNumber(target.range) ? target.range : snap.range
                    });
                }
            }

            var closest = {
                target: null,
                inRange: false,
                distance: 0,
                range: 0,
                dx: 0,
                dy: 0
            };

            for (i = 0, len = targets.length; i < len; i++) {
                target = targets[i];

                var range = target.range,
                    dx = target.x - page.x,
                    dy = target.y - page.y,
                    distance = hypot(dx, dy),
                    inRange = distance <= range;

                // Infinite targets count as being out of range
                // compared to non infinite ones that are in range
                if (range === Infinity && closest.inRange && closest.range !== Infinity) {
                    inRange = false;
                }

                if (!closest.target || (inRange
                    // is the closest target in range?
                    ? (closest.inRange && range !== Infinity
                        // the pointer is relatively deeper in this target
                        ? distance / range < closest.distance / closest.range
                        // this target has Infinite range and the closest doesn't
                        : (range === Infinity && closest.range !== Infinity)
                        // OR this target is closer that the previous closest
                        || distance < closest.distance)
                    // The other is not in range and the pointer is closer to this target
                    : (!closest.inRange && distance < closest.distance))) {

                    if (range === Infinity) {
                        inRange = true;
                    }

                    closest.target = target;
                    closest.distance = distance;
                    closest.range = range;
                    closest.inRange = inRange;
                    closest.dx = dx;
                    closest.dy = dy;

                    status.range = range;
                }
            }

            var snapChanged;

            if (closest.target) {
                snapChanged = (status.snappedX !== closest.target.x || status.snappedY !== closest.target.y);

                status.snappedX = closest.target.x;
                status.snappedY = closest.target.y;
            }
            else {
                snapChanged = true;

                status.snappedX = NaN;
                status.snappedY = NaN;
            }

            status.dx = closest.dx;
            status.dy = closest.dy;

            status.changed = (snapChanged || (closest.inRange && !status.locked));
            status.locked = closest.inRange;

            return status;
        },

        setRestriction: function (pageCoords, status) {
            var target = this.target,
                restrict = target && target.options[this.prepared.name].restrict,
                restriction = restrict && restrict.restriction,
                page;

            if (!restriction) {
                return status;
            }

            status = status || this.restrictStatus;

            page = status.useStatusXY
                ? page = { x: status.x, y: status.y }
                : page = extend({}, pageCoords);

            if (status.snap && status.snap.locked) {
                page.x += status.snap.dx || 0;
                page.y += status.snap.dy || 0;
            }

            page.x -= this.inertiaStatus.resumeDx;
            page.y -= this.inertiaStatus.resumeDy;

            status.dx = 0;
            status.dy = 0;
            status.restricted = false;

            var rect, restrictedX, restrictedY;

            if (isString(restriction)) {
                if (restriction === 'parent') {
                    restriction = parentElement(this.element);
                }
                else if (restriction === 'self') {
                    restriction = target.getRect(this.element);
                }
                else {
                    restriction = closest(this.element, restriction);
                }

                if (!restriction) { return status; }
            }

            if (isFunction(restriction)) {
                restriction = restriction(page.x, page.y, this.element);
            }

            if (isElement(restriction)) {
                restriction = getElementRect(restriction);
            }

            rect = restriction;

            if (!restriction) {
                restrictedX = page.x;
                restrictedY = page.y;
            }
            // object is assumed to have
            // x, y, width, height or
            // left, top, right, bottom
            else if ('x' in restriction && 'y' in restriction) {
                restrictedX = Math.max(Math.min(rect.x + rect.width - this.restrictOffset.right, page.x), rect.x + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom, page.y), rect.y + this.restrictOffset.top);
            }
            else {
                restrictedX = Math.max(Math.min(rect.right - this.restrictOffset.right, page.x), rect.left + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom, page.y), rect.top + this.restrictOffset.top);
            }

            status.dx = restrictedX - page.x;
            status.dy = restrictedY - page.y;

            status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;
            status.restricted = !!(status.dx || status.dy);

            status.restrictedX = restrictedX;
            status.restrictedY = restrictedY;

            return status;
        },

        checkAndPreventDefault: function (event, interactable, element) {
            if (!(interactable = interactable || this.target)) { return; }

            var options = interactable.options,
                prevent = options.preventDefault;

            if (prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)) {
                // do not preventDefault on pointerdown if the prepared action is a drag
                // and dragging can only start from a certain direction - this allows
                // a touch to pan the viewport if a drag isn't in the right direction
                if (/down|start/i.test(event.type)
                    && this.prepared.name === 'drag' && options.drag.axis !== 'xy') {

                    return;
                }

                // with manualStart, only preventDefault while interacting
                if (options[this.prepared.name] && options[this.prepared.name].manualStart
                    && !this.interacting()) {
                    return;
                }

                event.preventDefault();
                return;
            }

            if (prevent === 'always') {
                event.preventDefault();
                return;
            }
        },

        calcInertia: function (status) {
            var inertiaOptions = this.target.options[this.prepared.name].inertia,
                lambda = inertiaOptions.resistance,
                inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;

            status.x0 = this.prevEvent.pageX;
            status.y0 = this.prevEvent.pageY;
            status.t0 = status.startEvent.timeStamp / 1000;
            status.sx = status.sy = 0;

            status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
            status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
            status.te = inertiaDur;

            status.lambda_v0 = lambda / status.v0;
            status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
        },

        autoScrollMove: function (pointer) {
            if (!(this.interacting()
                && checkAutoScroll(this.target, this.prepared.name))) {
                return;
            }

            if (this.inertiaStatus.active) {
                autoScroll.x = autoScroll.y = 0;
                return;
            }

            var top,
                right,
                bottom,
                left,
                options = this.target.options[this.prepared.name].autoScroll,
                container = options.container || getWindow(this.element);

            if (isWindow(container)) {
                left = pointer.clientX < autoScroll.margin;
                top = pointer.clientY < autoScroll.margin;
                right = pointer.clientX > container.innerWidth - autoScroll.margin;
                bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
            }
            else {
                var rect = getElementClientRect(container);

                left = pointer.clientX < rect.left + autoScroll.margin;
                top = pointer.clientY < rect.top + autoScroll.margin;
                right = pointer.clientX > rect.right - autoScroll.margin;
                bottom = pointer.clientY > rect.bottom - autoScroll.margin;
            }

            autoScroll.x = (right ? 1 : left ? -1 : 0);
            autoScroll.y = (bottom ? 1 : top ? -1 : 0);

            if (!autoScroll.isScrolling) {
                // set the autoScroll properties to those of the target
                autoScroll.margin = options.margin;
                autoScroll.speed = options.speed;

                autoScroll.start(this);
            }
        },

        _updateEventTargets: function (target, currentTarget) {
            this._eventTarget = target;
            this._curEventTarget = currentTarget;
        }

    };

    function getInteractionFromPointer(pointer, eventType, eventTarget) {
        var i = 0, len = interactions.length,
            mouseEvent = (/mouse/i.test(pointer.pointerType || eventType)
                // MSPointerEvent.MSPOINTER_TYPE_MOUSE
                || pointer.pointerType === 4),
            interaction;

        var id = getPointerId(pointer);

        // try to resume inertia with a new pointer
        if (/down|start/i.test(eventType)) {
            for (i = 0; i < len; i++) {
                interaction = interactions[i];

                var element = eventTarget;

                if (interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume
                    && (interaction.mouse === mouseEvent)) {
                    while (element) {
                        // if the element is the interaction element
                        if (element === interaction.element) {
                            return interaction;
                        }
                        element = parentElement(element);
                    }
                }
            }
        }

        // if it's a mouse interaction
        if (mouseEvent || !(supportsTouch || supportsPointerEvent)) {

            // find a mouse interaction that's not in inertia phase
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !interactions[i].inertiaStatus.active) {
                    return interactions[i];
                }
            }

            // find any interaction specifically for mouse.
            // if the eventType is a mousedown, and inertia is active
            // ignore the interaction
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)) {
                    return interaction;
                }
            }

            // create a new interaction for mouse
            interaction = new Interaction();
            interaction.mouse = true;

            return interaction;
        }

        // get interaction that has this pointer
        for (i = 0; i < len; i++) {
            if (contains(interactions[i].pointerIds, id)) {
                return interactions[i];
            }
        }

        // at this stage, a pointerUp should not return an interaction
        if (/up|end|out/i.test(eventType)) {
            return null;
        }

        // get first idle interaction
        for (i = 0; i < len; i++) {
            interaction = interactions[i];

            if ((!interaction.prepared.name || (interaction.target.options.gesture.enabled))
                && !interaction.interacting()
                && !(!mouseEvent && interaction.mouse)) {

                return interaction;
            }
        }

        return new Interaction();
    }

    function doOnInteractions(method) {
        return (function (event) {
            var interaction,
                eventTarget = getActualElement(event.path
                    ? event.path[0]
                    : event.target),
                curEventTarget = getActualElement(event.currentTarget),
                i;

            if (supportsTouch && /touch/.test(event.type)) {
                prevTouchTime = new Date().getTime();

                for (i = 0; i < event.changedTouches.length; i++) {
                    var pointer = event.changedTouches[i];

                    interaction = getInteractionFromPointer(pointer, event.type, eventTarget);

                    if (!interaction) { continue; }

                    interaction._updateEventTargets(eventTarget, curEventTarget);

                    interaction[method](pointer, event, eventTarget, curEventTarget);
                }
            }
            else {
                if (!supportsPointerEvent && /mouse/.test(event.type)) {
                    // ignore mouse events while touch interactions are active
                    for (i = 0; i < interactions.length; i++) {
                        if (!interactions[i].mouse && interactions[i].pointerIsDown) {
                            return;
                        }
                    }

                    // try to ignore mouse events that are simulated by the browser
                    // after a touch event
                    if (new Date().getTime() - prevTouchTime < 500) {
                        return;
                    }
                }

                interaction = getInteractionFromPointer(event, event.type, eventTarget);

                if (!interaction) { return; }

                interaction._updateEventTargets(eventTarget, curEventTarget);

                interaction[method](event, event, eventTarget, curEventTarget);
            }
        });
    }

    function InteractEvent(interaction, event, action, phase, element, related) {
        var client,
            page,
            target = interaction.target,
            snapStatus = interaction.snapStatus,
            restrictStatus = interaction.restrictStatus,
            pointers = interaction.pointers,
            deltaSource = (target && target.options || defaultOptions).deltaSource,
            sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            options = target ? target.options : defaultOptions,
            origin = getOriginXY(target, element),
            starting = phase === 'start',
            ending = phase === 'end',
            coords = starting ? interaction.startCoords : interaction.curCoords;

        element = element || interaction.element;

        page = extend({}, coords.page);
        client = extend({}, coords.client);

        page.x -= origin.x;
        page.y -= origin.y;

        client.x -= origin.x;
        client.y -= origin.y;

        var relativePoints = options[action].snap && options[action].snap.relativePoints;

        if (checkSnap(target, action) && !(starting && relativePoints && relativePoints.length)) {
            this.snap = {
                range: snapStatus.range,
                locked: snapStatus.locked,
                x: snapStatus.snappedX,
                y: snapStatus.snappedY,
                realX: snapStatus.realX,
                realY: snapStatus.realY,
                dx: snapStatus.dx,
                dy: snapStatus.dy
            };

            if (snapStatus.locked) {
                page.x += snapStatus.dx;
                page.y += snapStatus.dy;
                client.x += snapStatus.dx;
                client.y += snapStatus.dy;
            }
        }

        if (checkRestrict(target, action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted) {
            page.x += restrictStatus.dx;
            page.y += restrictStatus.dy;
            client.x += restrictStatus.dx;
            client.y += restrictStatus.dy;

            this.restrict = {
                dx: restrictStatus.dx,
                dy: restrictStatus.dy
            };
        }

        this.pageX = page.x;
        this.pageY = page.y;
        this.clientX = client.x;
        this.clientY = client.y;

        this.x0 = interaction.startCoords.page.x - origin.x;
        this.y0 = interaction.startCoords.page.y - origin.y;
        this.clientX0 = interaction.startCoords.client.x - origin.x;
        this.clientY0 = interaction.startCoords.client.y - origin.y;
        this.ctrlKey = event.ctrlKey;
        this.altKey = event.altKey;
        this.shiftKey = event.shiftKey;
        this.metaKey = event.metaKey;
        this.button = event.button;
        this.buttons = event.buttons;
        this.target = element;
        this.t0 = interaction.downTimes[0];
        this.type = action + (phase || '');

        this.interaction = interaction;
        this.interactable = target;

        var inertiaStatus = interaction.inertiaStatus;

        if (inertiaStatus.active) {
            this.detail = 'inertia';
        }

        if (related) {
            this.relatedTarget = related;
        }

        // end event dx, dy is difference between start and end points
        if (ending) {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.startCoords.client.x;
                this.dy = client.y - interaction.startCoords.client.y;
            }
            else {
                this.dx = page.x - interaction.startCoords.page.x;
                this.dy = page.y - interaction.startCoords.page.y;
            }
        }
        else if (starting) {
            this.dx = 0;
            this.dy = 0;
        }
        // copy properties from previousmove if starting inertia
        else if (phase === 'inertiastart') {
            this.dx = interaction.prevEvent.dx;
            this.dy = interaction.prevEvent.dy;
        }
        else {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.prevEvent.clientX;
                this.dy = client.y - interaction.prevEvent.clientY;
            }
            else {
                this.dx = page.x - interaction.prevEvent.pageX;
                this.dy = page.y - interaction.prevEvent.pageY;
            }
        }
        if (interaction.prevEvent && interaction.prevEvent.detail === 'inertia'
            && !inertiaStatus.active
            && options[action].inertia && options[action].inertia.zeroResumeDelta) {

            inertiaStatus.resumeDx += this.dx;
            inertiaStatus.resumeDy += this.dy;

            this.dx = this.dy = 0;
        }

        if (action === 'resize' && interaction.resizeAxes) {
            if (options.resize.square) {
                if (interaction.resizeAxes === 'y') {
                    this.dx = this.dy;
                }
                else {
                    this.dy = this.dx;
                }
                this.axes = 'xy';
            }
            else {
                this.axes = interaction.resizeAxes;

                if (interaction.resizeAxes === 'x') {
                    this.dy = 0;
                }
                else if (interaction.resizeAxes === 'y') {
                    this.dx = 0;
                }
            }
        }
        else if (action === 'gesture') {
            this.touches = [pointers[0], pointers[1]];

            if (starting) {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = 1;
                this.ds = 0;
                this.angle = touchAngle(pointers, undefined, deltaSource);
                this.da = 0;
            }
            else if (ending || event instanceof InteractEvent) {
                this.distance = interaction.prevEvent.distance;
                this.box = interaction.prevEvent.box;
                this.scale = interaction.prevEvent.scale;
                this.ds = this.scale - 1;
                this.angle = interaction.prevEvent.angle;
                this.da = this.angle - interaction.gesture.startAngle;
            }
            else {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = this.distance / interaction.gesture.startDistance;
                this.angle = touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);

                this.ds = this.scale - interaction.gesture.prevScale;
                this.da = this.angle - interaction.gesture.prevAngle;
            }
        }

        if (starting) {
            this.timeStamp = interaction.downTimes[0];
            this.dt = 0;
            this.duration = 0;
            this.speed = 0;
            this.velocityX = 0;
            this.velocityY = 0;
        }
        else if (phase === 'inertiastart') {
            this.timeStamp = interaction.prevEvent.timeStamp;
            this.dt = interaction.prevEvent.dt;
            this.duration = interaction.prevEvent.duration;
            this.speed = interaction.prevEvent.speed;
            this.velocityX = interaction.prevEvent.velocityX;
            this.velocityY = interaction.prevEvent.velocityY;
        }
        else {
            this.timeStamp = new Date().getTime();
            this.dt = this.timeStamp - interaction.prevEvent.timeStamp;
            this.duration = this.timeStamp - interaction.downTimes[0];

            if (event instanceof InteractEvent) {
                var dx = this[sourceX] - interaction.prevEvent[sourceX],
                    dy = this[sourceY] - interaction.prevEvent[sourceY],
                    dt = this.dt / 1000;

                this.speed = hypot(dx, dy) / dt;
                this.velocityX = dx / dt;
                this.velocityY = dy / dt;
            }
            // if normal move or end event, use previous user event coords
            else {
                // speed and velocity in pixels per second
                this.speed = interaction.pointerDelta[deltaSource].speed;
                this.velocityX = interaction.pointerDelta[deltaSource].vx;
                this.velocityY = interaction.pointerDelta[deltaSource].vy;
            }
        }

        if ((ending || phase === 'inertiastart')
            && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150) {

            var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI,
                overlap = 22.5;

            if (angle < 0) {
                angle += 360;
            }

            var left = 135 - overlap <= angle && angle < 225 + overlap,
                up = 225 - overlap <= angle && angle < 315 + overlap,

                right = !left && (315 - overlap <= angle || angle < 45 + overlap),
                down = !up && 45 - overlap <= angle && angle < 135 + overlap;

            this.swipe = {
                up: up,
                down: down,
                left: left,
                right: right,
                angle: angle,
                speed: interaction.prevEvent.speed,
                velocity: {
                    x: interaction.prevEvent.velocityX,
                    y: interaction.prevEvent.velocityY
                }
            };
        }
    }

    InteractEvent.prototype = {
        preventDefault: blank,
        stopImmediatePropagation: function () {
            this.immediatePropagationStopped = this.propagationStopped = true;
        },
        stopPropagation: function () {
            this.propagationStopped = true;
        }
    };

    function preventOriginalDefault() {
        this.originalEvent.preventDefault();
    }

    function getActionCursor(action) {
        var cursor = '';

        if (action.name === 'drag') {
            cursor = actionCursors.drag;
        }
        if (action.name === 'resize') {
            if (action.axis) {
                cursor = actionCursors[action.name + action.axis];
            }
            else if (action.edges) {
                var cursorKey = 'resize',
                    edgeNames = ['top', 'bottom', 'left', 'right'];

                for (var i = 0; i < 4; i++) {
                    if (action.edges[edgeNames[i]]) {
                        cursorKey += edgeNames[i];
                    }
                }

                cursor = actionCursors[cursorKey];
            }
        }

        return cursor;
    }

    function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
        // false, '', undefined, null
        if (!value) { return false; }

        // true value, use pointer coords and element rect
        if (value === true) {
            // if dimensions are negative, "switch" edges
            var width = isNumber(rect.width) ? rect.width : rect.right - rect.left,
                height = isNumber(rect.height) ? rect.height : rect.bottom - rect.top;

            if (width < 0) {
                if (name === 'left') { name = 'right'; }
                else if (name === 'right') { name = 'left'; }
            }
            if (height < 0) {
                if (name === 'top') { name = 'bottom'; }
                else if (name === 'bottom') { name = 'top'; }
            }

            if (name === 'left') { return page.x < ((width >= 0 ? rect.left : rect.right) + margin); }
            if (name === 'top') { return page.y < ((height >= 0 ? rect.top : rect.bottom) + margin); }

            if (name === 'right') { return page.x > ((width >= 0 ? rect.right : rect.left) - margin); }
            if (name === 'bottom') { return page.y > ((height >= 0 ? rect.bottom : rect.top) - margin); }
        }

        // the remaining checks require an element
        if (!isElement(element)) { return false; }

        return isElement(value)
            // the value is an element to use as a resize handle
            ? value === element
            // otherwise check if element matches value as selector
            : matchesUpTo(element, value, interactableElement);
    }

    function defaultActionChecker(pointer, interaction, element) {
        var rect = this.getRect(element),
            shouldResize = false,
            action = null,
            resizeAxes = null,
            resizeEdges,
            page = extend({}, interaction.curCoords.page),
            options = this.options;

        if (!rect) { return null; }

        if (actionIsEnabled.resize && options.resize.enabled) {
            var resizeOptions = options.resize;

            resizeEdges = {
                left: false, right: false, top: false, bottom: false
            };

            // if using resize.edges
            if (isObject(resizeOptions.edges)) {
                for (var edge in resizeEdges) {
                    resizeEdges[edge] = checkResizeEdge(edge,
                        resizeOptions.edges[edge],
                        page,
                        interaction._eventTarget,
                        element,
                        rect,
                        resizeOptions.margin || margin);
                }

                resizeEdges.left = resizeEdges.left && !resizeEdges.right;
                resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;

                shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;
            }
            else {
                var right = options.resize.axis !== 'y' && page.x > (rect.right - margin),
                    bottom = options.resize.axis !== 'x' && page.y > (rect.bottom - margin);

                shouldResize = right || bottom;
                resizeAxes = (right ? 'x' : '') + (bottom ? 'y' : '');
            }
        }

        action = shouldResize
            ? 'resize'
            : actionIsEnabled.drag && options.drag.enabled
                ? 'drag'
                : null;

        if (actionIsEnabled.gesture
            && interaction.pointerIds.length >= 2
            && !(interaction.dragging || interaction.resizing)) {
            action = 'gesture';
        }

        if (action) {
            return {
                name: action,
                axis: resizeAxes,
                edges: resizeEdges
            };
        }

        return null;
    }

    // Check if action is enabled globally and the current target supports it
    // If so, return the validated action. Otherwise, return null
    function validateAction(action, interactable) {
        if (!isObject(action)) { return null; }

        var actionName = action.name,
            options = interactable.options;

        if (((actionName === 'resize' && options.resize.enabled)
            || (actionName === 'drag' && options.drag.enabled)
            || (actionName === 'gesture' && options.gesture.enabled))
            && actionIsEnabled[actionName]) {

            if (actionName === 'resize' || actionName === 'resizeyx') {
                actionName = 'resizexy';
            }

            return action;
        }
        return null;
    }

    var listeners = {},
        interactionListeners = [
            'dragStart', 'dragMove', 'resizeStart', 'resizeMove', 'gestureStart', 'gestureMove',
            'pointerOver', 'pointerOut', 'pointerHover', 'selectorDown',
            'pointerDown', 'pointerMove', 'pointerUp', 'pointerCancel', 'pointerEnd',
            'addPointer', 'removePointer', 'recordPointer', 'autoScrollMove'
        ];

    for (var i = 0, len = interactionListeners.length; i < len; i++) {
        var name = interactionListeners[i];

        listeners[name] = doOnInteractions(name);
    }

    // bound to the interactable context when a DOM event
    // listener is added to a selector interactable
    function delegateListener(event, useCapture) {
        var fakeEvent = {},
            delegated = delegatedEvents[event.type],
            eventTarget = getActualElement(event.path
                ? event.path[0]
                : event.target),
            element = eventTarget;

        useCapture = useCapture ? true : false;

        // duplicate the event so that currentTarget can be changed
        for (var prop in event) {
            fakeEvent[prop] = event[prop];
        }

        fakeEvent.originalEvent = event;
        fakeEvent.preventDefault = preventOriginalDefault;

        // climb up document tree looking for selector matches
        while (isElement(element)) {
            for (var i = 0; i < delegated.selectors.length; i++) {
                var selector = delegated.selectors[i],
                    context = delegated.contexts[i];

                if (matchesSelector(element, selector)
                    && nodeContains(context, eventTarget)
                    && nodeContains(context, element)) {

                    var listeners = delegated.listeners[i];

                    fakeEvent.currentTarget = element;

                    for (var j = 0; j < listeners.length; j++) {
                        if (listeners[j][1] === useCapture) {
                            listeners[j][0](fakeEvent);
                        }
                    }
                }
            }

            element = parentElement(element);
        }
    }

    function delegateUseCapture(event) {
        return delegateListener.call(this, event, true);
    }

    interactables.indexOfElement = function indexOfElement(element, context) {
        context = context || document;

        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if ((interactable.selector === element
                && (interactable._context === context))
                || (!interactable.selector && interactable._element === element)) {

                return i;
            }
        }
        return -1;
    };

    interactables.get = function interactableGet(element, options) {
        return this[this.indexOfElement(element, options && options.context)];
    };

    interactables.forEachSelector = function (callback) {
        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if (!interactable.selector) {
                continue;
            }

            var ret = callback(interactable, interactable.selector, interactable._context, i, this);

            if (ret !== undefined) {
                return ret;
            }
        }
    };

    /*\
     * interact
     [ method ]
     *
     * The methods of this variable can be used to set elements as
     * interactables and also to change various default settings.
     *
     * Calling it as a function and passing an element or a valid CSS selector
     * string returns an Interactable object which has various methods to
     * configure it.
     *
     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
     = (object) An @Interactable
     *
     > Usage
     | interact(document.getElementById('draggable')).draggable(true);
     |
     | var rectables = interact('rect');
     | rectables
     |     .gesturable(true)
     |     .on('gesturemove', function (event) {
     |         // something cool...
     |     })
     |     .autoScroll(true);
    \*/
    function interact(element, options) {
        return interactables.get(element, options) || new Interactable(element, options);
    }

    /*\
     * Interactable
     [ property ]
     **
     * Object type returned by @interact
    \*/
    function Interactable(element, options) {
        this._element = element;
        this._iEvents = this._iEvents || {};

        var _window;

        if (trySelector(element)) {
            this.selector = element;

            var context = options && options.context;

            _window = context ? getWindow(context) : window;

            if (context && (_window.Node
                ? context instanceof _window.Node
                : (isElement(context) || context === _window.document))) {

                this._context = context;
            }
        }
        else {
            _window = getWindow(element);

            if (isElement(element, _window)) {

                if (supportsPointerEvent) {
                    events.add(this._element, pEventTypes.down, listeners.pointerDown);
                    events.add(this._element, pEventTypes.move, listeners.pointerHover);
                }
                else {
                    events.add(this._element, 'mousedown', listeners.pointerDown);
                    events.add(this._element, 'mousemove', listeners.pointerHover);
                    events.add(this._element, 'touchstart', listeners.pointerDown);
                    events.add(this._element, 'touchmove', listeners.pointerHover);
                }
            }
        }

        this._doc = _window.document;

        if (!contains(documents, this._doc)) {
            listenToDocument(this._doc);
        }

        interactables.push(this);

        this.set(options);
    }

    Interactable.prototype = {
        setOnEvents: function (action, phases) {
            if (action === 'drop') {
                if (isFunction(phases.ondrop)) { this.ondrop = phases.ondrop; }
                if (isFunction(phases.ondropactivate)) { this.ondropactivate = phases.ondropactivate; }
                if (isFunction(phases.ondropdeactivate)) { this.ondropdeactivate = phases.ondropdeactivate; }
                if (isFunction(phases.ondragenter)) { this.ondragenter = phases.ondragenter; }
                if (isFunction(phases.ondragleave)) { this.ondragleave = phases.ondragleave; }
                if (isFunction(phases.ondropmove)) { this.ondropmove = phases.ondropmove; }
            }
            else {
                action = 'on' + action;

                if (isFunction(phases.onstart)) { this[action + 'start'] = phases.onstart; }
                if (isFunction(phases.onmove)) { this[action + 'move'] = phases.onmove; }
                if (isFunction(phases.onend)) { this[action + 'end'] = phases.onend; }
                if (isFunction(phases.oninertiastart)) { this[action + 'inertiastart'] = phases.oninertiastart; }
            }

            return this;
        },

        /*\
         * Interactable.draggable
         [ method ]
         *
         * Gets or sets whether drag actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of drag events
         | var isDraggable = interact('ul li').draggable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
         = (object) This Interactable
         | interact(element).draggable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // the axis in which the first movement must be
         |     // for the drag sequence to start
         |     // 'xy' by default - any direction
         |     axis: 'x' || 'y' || 'xy',
         |
         |     // max number of drags that can happen concurrently
         |     // with elements of this Interactable. Infinity by default
         |     max: Infinity,
         |
         |     // max number of drags that can target the same element+Interactable
         |     // 1 by default
         |     maxPerElement: 2
         | });
        \*/
        draggable: function (options) {
            if (isObject(options)) {
                this.options.drag.enabled = options.enabled === false ? false : true;
                this.setPerAction('drag', options);
                this.setOnEvents('drag', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.drag.axis = options.axis;
                }
                else if (options.axis === null) {
                    delete this.options.drag.axis;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drag.enabled = options;

                return this;
            }

            return this.options.drag;
        },

        setPerAction: function (action, options) {
            // for all the default per-action options
            for (var option in options) {
                // if this option exists for this action
                if (option in defaultOptions[action]) {
                    // if the option in the options arg is an object value
                    if (isObject(options[option])) {
                        // duplicate the object
                        this.options[action][option] = extend(this.options[action][option] || {}, options[option]);

                        if (isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]) {
                            this.options[action][option].enabled = options[option].enabled === false ? false : true;
                        }
                    }
                    else if (isBool(options[option]) && isObject(defaultOptions.perAction[option])) {
                        this.options[action][option].enabled = options[option];
                    }
                    else if (options[option] !== undefined) {
                        // or if it's not undefined, do a plain assignment
                        this.options[action][option] = options[option];
                    }
                }
            }
        },

        /*\
         * Interactable.dropzone
         [ method ]
         *
         * Returns or sets whether elements can be dropped onto this
         * Interactable to trigger drop events
         *
         * Dropzones can receive the following events:
         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
         *  - `dragmove` when a draggable that has entered the dropzone is moved
         *  - `drop` when a draggable is dropped into this dropzone
         *
         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
         *
         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
         *   - `'pointer'`, the pointer must be over the dropzone (default)
         *   - `'center'`, the draggable element's center must be over the dropzone
         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
         *       e.g. `0.5` for drop to happen when half of the area of the
         *       draggable is over the dropzone
         *
         - options (boolean | object | null) #optional The new value to be set.
         | interact('.drop').dropzone({
         |   accept: '.can-drop' || document.getElementById('single-drop'),
         |   overlap: 'pointer' || 'center' || zeroToOne
         | }
         = (boolean | object) The current setting or this Interactable
        \*/
        dropzone: function (options) {
            if (isObject(options)) {
                this.options.drop.enabled = options.enabled === false ? false : true;
                this.setOnEvents('drop', options);

                if (/^(pointer|center)$/.test(options.overlap)) {
                    this.options.drop.overlap = options.overlap;
                }
                else if (isNumber(options.overlap)) {
                    this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
                }
                if ('accept' in options) {
                    this.options.drop.accept = options.accept;
                }
                if ('checker' in options) {
                    this.options.drop.checker = options.checker;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drop.enabled = options;

                return this;
            }

            return this.options.drop;
        },

        dropCheck: function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
            var dropped = false;

            // if the dropzone has no rect (eg. display: none)
            // call the custom dropChecker or just return false
            if (!(rect = rect || this.getRect(dropElement))) {
                return (this.options.drop.checker
                    ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement)
                    : false);
            }

            var dropOverlap = this.options.drop.overlap;

            if (dropOverlap === 'pointer') {
                var page = getPageXY(dragEvent),
                    origin = getOriginXY(draggable, draggableElement),
                    horizontal,
                    vertical;

                page.x += origin.x;
                page.y += origin.y;

                horizontal = (page.x > rect.left) && (page.x < rect.right);
                vertical = (page.y > rect.top) && (page.y < rect.bottom);

                dropped = horizontal && vertical;
            }

            var dragRect = draggable.getRect(draggableElement);

            if (dropOverlap === 'center') {
                var cx = dragRect.left + dragRect.width / 2,
                    cy = dragRect.top + dragRect.height / 2;

                dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
            }

            if (isNumber(dropOverlap)) {
                var overlapArea = (Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left))
                    * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top))),
                    overlapRatio = overlapArea / (dragRect.width * dragRect.height);

                dropped = overlapRatio >= dropOverlap;
            }

            if (this.options.drop.checker) {
                dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
            }

            return dropped;
        },

        /*\
         * Interactable.dropChecker
         [ method ]
         *
         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
         *
         * Gets or sets the function used to check if a dragged element is
         * over this Interactable.
         *
         - checker (function) #optional The function that will be called when checking for a drop
         = (Function | Interactable) The checker function or this Interactable
         *
         * The checker function takes the following arguments:
         *
         - dragEvent (InteractEvent) The related dragmove or dragend event
         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
         - dropped (boolean) The value from the default drop checker
         - dropzone (Interactable) The dropzone interactable
         - dropElement (Element) The dropzone element
         - draggable (Interactable) The Interactable being dragged
         - draggableElement (Element) The actual element that's being dragged
         *
         > Usage:
         | interact(target)
         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
         |                       event,             // TouchEvent/PointerEvent/MouseEvent
         |                       dropped,           // bool result of the default checker
         |                       dropzone,          // dropzone Interactable
         |                       dropElement,       // dropzone elemnt
         |                       draggable,         // draggable Interactable
         |                       draggableElement) {// draggable element
         |
         |   return dropped && event.target.hasAttribute('allow-drop');
         | }
        \*/
        dropChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.drop.checker = checker;

                return this;
            }
            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.options.drop.checker;
        },

        /*\
         * Interactable.accept
         [ method ]
         *
         * Deprecated. add an `accept` property to the options object passed to
         * @Interactable.dropzone instead.
         *
         * Gets or sets the Element or CSS selector match that this
         * Interactable accepts if it is a dropzone.
         *
         - newValue (Element | string | null) #optional
         * If it is an Element, then only that element can be dropped into this dropzone.
         * If it is a string, the element being dragged must match it as a selector.
         * If it is null, the accept options is cleared - it accepts any element.
         *
         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
        \*/
        accept: function (newValue) {
            if (isElement(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            // test if it is a valid CSS selector
            if (trySelector(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.drop.accept;

                return this;
            }

            return this.options.drop.accept;
        },

        /*\
         * Interactable.resizable
         [ method ]
         *
         * Gets or sets whether resize actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of resize elements
         | var isResizeable = interact('input[type=text]').resizable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
         = (object) This Interactable
         | interact(element).resizable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     edges: {
         |       top   : true,       // Use pointer coords to check for resize.
         |       left  : false,      // Disable resizing from left edge.
         |       bottom: '.resize-s',// Resize if pointer target matches selector
         |       right : handleEl    // Resize if pointer target is the given Element
         |     },
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height are adjusted at a 1:1 ratio.
         |     square: false,
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height maintain the aspect ratio they had when resizing started.
         |     preserveAspectRatio: false,
         |
         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
         |     // 'negate' will allow the rect to have negative width/height
         |     // 'reposition' will keep the width/height positive by swapping
         |     // the top and bottom edges and/or swapping the left and right edges
         |     invert: 'none' || 'negate' || 'reposition'
         |
         |     // limit multiple resizes.
         |     // See the explanation in the @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        resizable: function (options) {
            if (isObject(options)) {
                this.options.resize.enabled = options.enabled === false ? false : true;
                this.setPerAction('resize', options);
                this.setOnEvents('resize', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.resize.axis = options.axis;
                }
                else if (options.axis === null) {
                    this.options.resize.axis = defaultOptions.resize.axis;
                }

                if (isBool(options.preserveAspectRatio)) {
                    this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
                }
                else if (isBool(options.square)) {
                    this.options.resize.square = options.square;
                }

                return this;
            }
            if (isBool(options)) {
                this.options.resize.enabled = options;

                return this;
            }
            return this.options.resize;
        },

        /*\
         * Interactable.squareResize
         [ method ]
         *
         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
         *
         * Gets or sets whether resizing is forced 1:1 aspect
         *
         = (boolean) Current setting
         *
         * or
         *
         - newValue (boolean) #optional
         = (object) this Interactable
        \*/
        squareResize: function (newValue) {
            if (isBool(newValue)) {
                this.options.resize.square = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.resize.square;

                return this;
            }

            return this.options.resize.square;
        },

        /*\
         * Interactable.gesturable
         [ method ]
         *
         * Gets or sets whether multitouch gestures can be performed on the
         * Interactable's element
         *
         = (boolean) Indicates if this can be the target of gesture events
         | var isGestureable = interact(element).gesturable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
         = (object) this Interactable
         | interact(element).gesturable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // limit multiple gestures.
         |     // See the explanation in @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        gesturable: function (options) {
            if (isObject(options)) {
                this.options.gesture.enabled = options.enabled === false ? false : true;
                this.setPerAction('gesture', options);
                this.setOnEvents('gesture', options);

                return this;
            }

            if (isBool(options)) {
                this.options.gesture.enabled = options;

                return this;
            }

            return this.options.gesture;
        },

        /*\
         * Interactable.autoScroll
         [ method ]
         **
         * Deprecated. Add an `autoscroll` property to the options object
         * passed to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets whether dragging and resizing near the edges of the
         * window/container trigger autoScroll for this Interactable
         *
         = (object) Object with autoScroll properties
         *
         * or
         *
         - options (object | boolean) #optional
         * options can be:
         * - an object with margin, distance and interval properties,
         * - true or false to enable or disable autoScroll or
         = (Interactable) this Interactable
        \*/
        autoScroll: function (options) {
            if (isObject(options)) {
                options = extend({ actions: ['drag', 'resize'] }, options);
            }
            else if (isBool(options)) {
                options = { actions: ['drag', 'resize'], enabled: options };
            }

            return this.setOptions('autoScroll', options);
        },

        /*\
         * Interactable.snap
         [ method ]
         **
         * Deprecated. Add a `snap` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how action coordinates are snapped. By
         * default, snapping is relative to the pointer coordinates. You can
         * change this by setting the
         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
         **
         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | interact(document.querySelector('#thing')).snap({
         |     targets: [
         |         // snap to this specific point
         |         {
         |             x: 100,
         |             y: 100,
         |             range: 25
         |         },
         |         // give this function the x and y page coords and snap to the object returned
         |         function (x, y) {
         |             return {
         |                 x: x,
         |                 y: (75 + 50 * Math.sin(x * 0.04)),
         |                 range: 40
         |             };
         |         },
         |         // create a function that snaps to a grid
         |         interact.createSnapGrid({
         |             x: 50,
         |             y: 50,
         |             range: 10,              // optional
         |             offset: { x: 5, y: 10 } // optional
         |         })
         |     ],
         |     // do not snap during normal movement.
         |     // Instead, trigger only one snapped move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     relativePoints: [
         |         { x: 0, y: 0 },  // snap relative to the top left of the element
         |         { x: 1, y: 1 },  // and also to the bottom right
         |     ],  
         |
         |     // offset the snap target coordinates
         |     // can be an object with x/y or 'startCoords'
         |     offset: { x: 50, y: 50 }
         |   }
         | });
        \*/
        snap: function (options) {
            var ret = this.setOptions('snap', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        setOptions: function (option, options) {
            var actions = options && isArray(options.actions)
                ? options.actions
                : ['drag'];

            var i;

            if (isObject(options) || isBool(options)) {
                for (i = 0; i < actions.length; i++) {
                    var action = /resize/.test(actions[i]) ? 'resize' : actions[i];

                    if (!isObject(this.options[action])) { continue; }

                    var thisOption = this.options[action][option];

                    if (isObject(options)) {
                        extend(thisOption, options);
                        thisOption.enabled = options.enabled === false ? false : true;

                        if (option === 'snap') {
                            if (thisOption.mode === 'grid') {
                                thisOption.targets = [
                                    interact.createSnapGrid(extend({
                                        offset: thisOption.gridOffset || { x: 0, y: 0 }
                                    }, thisOption.grid || {}))
                                ];
                            }
                            else if (thisOption.mode === 'anchor') {
                                thisOption.targets = thisOption.anchors;
                            }
                            else if (thisOption.mode === 'path') {
                                thisOption.targets = thisOption.paths;
                            }

                            if ('elementOrigin' in options) {
                                thisOption.relativePoints = [options.elementOrigin];
                            }
                        }
                    }
                    else if (isBool(options)) {
                        thisOption.enabled = options;
                    }
                }

                return this;
            }

            var ret = {},
                allActions = ['drag', 'resize', 'gesture'];

            for (i = 0; i < allActions.length; i++) {
                if (option in defaultOptions[allActions[i]]) {
                    ret[allActions[i]] = this.options[allActions[i]][option];
                }
            }

            return ret;
        },


        /*\
         * Interactable.inertia
         [ method ]
         **
         * Deprecated. Add an `inertia` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how events continue to run after the pointer is released
         **
         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | // enable and use default settings
         | interact(element).inertia(true);
         |
         | // enable and use custom settings
         | interact(element).inertia({
         |     // value greater than 0
         |     // high values slow the object down more quickly
         |     resistance     : 16,
         |
         |     // the minimum launch speed (pixels per second) that results in inertia start
         |     minSpeed       : 200,
         |
         |     // inertia will stop when the object slows down to this speed
         |     endSpeed       : 20,
         |
         |     // boolean; should actions be resumed when the pointer goes down during inertia
         |     allowResume    : true,
         |
         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
         |     zeroResumeDelta: false,
         |
         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
         |     // the pointer without triggering inertia will animate from the release
         |     // point to the snaped/restricted point in the given amount of time (ms)
         |     smoothEndDuration: 300,
         |
         |     // an array of action types that can have inertia (no gesture)
         |     actions        : ['drag', 'resize']
         | });
         |
         | // reset custom settings and use all defaults
         | interact(element).inertia(null);
        \*/
        inertia: function (options) {
            var ret = this.setOptions('inertia', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        getAction: function (pointer, event, interaction, element) {
            var action = this.defaultActionChecker(pointer, interaction, element);

            if (this.options.actionChecker) {
                return this.options.actionChecker(pointer, event, action, this, element, interaction);
            }

            return action;
        },

        defaultActionChecker: defaultActionChecker,

        /*\
         * Interactable.actionChecker
         [ method ]
         *
         * Gets or sets the function used to check action to be performed on
         * pointerDown
         *
         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
         = (Function | Interactable) The checker function or this Interactable
         *
         | interact('.resize-drag')
         |   .resizable(true)
         |   .draggable(true)
         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
         |
         |   if (interact.matchesSelector(event.target, '.drag-handle') {
         |     // force drag with handle target
         |     action.name = drag;
         |   }
         |   else {
         |     // resize from the top and right edges
         |     action.name  = 'resize';
         |     action.edges = { top: true, right: true };
         |   }
         |
         |   return action;
         | });
        \*/
        actionChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.actionChecker = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.actionChecker;

                return this;
            }

            return this.options.actionChecker;
        },

        /*\
         * Interactable.getRect
         [ method ]
         *
         * The default function to get an Interactables bounding rect. Can be
         * overridden using @Interactable.rectChecker.
         *
         - element (Element) #optional The element to measure.
         = (object) The object's bounding rectangle.
         o {
         o     top   : 0,
         o     left  : 0,
         o     bottom: 0,
         o     right : 0,
         o     width : 0,
         o     height: 0
         o }
        \*/
        getRect: function rectCheck(element) {
            element = element || this._element;

            if (this.selector && !(isElement(element))) {
                element = this._context.querySelector(this.selector);
            }

            return getElementRect(element);
        },

        /*\
         * Interactable.rectChecker
         [ method ]
         *
         * Returns or sets the function used to calculate the interactable's
         * element's rectangle
         *
         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
         = (function | object) The checker function or this Interactable
        \*/
        rectChecker: function (checker) {
            if (isFunction(checker)) {
                this.getRect = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.getRect;
        },

        /*\
         * Interactable.styleCursor
         [ method ]
         *
         * Returns or sets whether the action that would be performed when the
         * mouse on the element are checked on `mousemove` so that the cursor
         * may be styled appropriately
         *
         - newValue (boolean) #optional
         = (boolean | Interactable) The current setting or this Interactable
        \*/
        styleCursor: function (newValue) {
            if (isBool(newValue)) {
                this.options.styleCursor = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.styleCursor;

                return this;
            }

            return this.options.styleCursor;
        },

        /*\
         * Interactable.preventDefault
         [ method ]
         *
         * Returns or sets whether to prevent the browser's default behaviour
         * in response to pointer events. Can be set to:
         *  - `'always'` to always prevent
         *  - `'never'` to never prevent
         *  - `'auto'` to let interact.js try to determine what would be best
         *
         - newValue (string) #optional `true`, `false` or `'auto'`
         = (string | Interactable) The current setting or this Interactable
        \*/
        preventDefault: function (newValue) {
            if (/^(always|never|auto)$/.test(newValue)) {
                this.options.preventDefault = newValue;
                return this;
            }

            if (isBool(newValue)) {
                this.options.preventDefault = newValue ? 'always' : 'never';
                return this;
            }

            return this.options.preventDefault;
        },

        /*\
         * Interactable.origin
         [ method ]
         *
         * Gets or sets the origin of the Interactable's element.  The x and y
         * of the origin will be subtracted from action event coordinates.
         *
         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
         * OR
         - origin (Element) #optional An HTML or SVG Element whose rect will be used
         **
         = (object) The current origin or this Interactable
        \*/
        origin: function (newValue) {
            if (trySelector(newValue)) {
                this.options.origin = newValue;
                return this;
            }
            else if (isObject(newValue)) {
                this.options.origin = newValue;
                return this;
            }

            return this.options.origin;
        },

        /*\
         * Interactable.deltaSource
         [ method ]
         *
         * Returns or sets the mouse coordinate types used to calculate the
         * movement of the pointer.
         *
         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
         = (string | object) The current deltaSource or this Interactable
        \*/
        deltaSource: function (newValue) {
            if (newValue === 'page' || newValue === 'client') {
                this.options.deltaSource = newValue;

                return this;
            }

            return this.options.deltaSource;
        },

        /*\
         * Interactable.restrict
         [ method ]
         **
         * Deprecated. Add a `restrict` property to the options object passed to
         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
         *
         * Returns or sets the rectangles within which actions on this
         * interactable (after snap calculations) are restricted. By default,
         * restricting is relative to the pointer coordinates. You can change
         * this by setting the
         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
         **
         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
         = (object) The current restrictions object or this Interactable
         **
         | interact(element).restrict({
         |     // the rect will be `interact.getElementRect(element.parentNode)`
         |     drag: element.parentNode,
         |
         |     // x and y are relative to the the interactable's origin
         |     resize: { x: 100, y: 100, width: 200, height: 200 }
         | })
         |
         | interact('.draggable').restrict({
         |     // the rect will be the selected element's parent
         |     drag: 'parent',
         |
         |     // do not restrict during normal movement.
         |     // Instead, trigger only one restricted move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
         | });
        \*/
        restrict: function (options) {
            if (!isObject(options)) {
                return this.setOptions('restrict', options);
            }

            var actions = ['drag', 'resize', 'gesture'],
                ret;

            for (var i = 0; i < actions.length; i++) {
                var action = actions[i];

                if (action in options) {
                    var perAction = extend({
                        actions: [action],
                        restriction: options[action]
                    }, options);

                    ret = this.setOptions('restrict', perAction);
                }
            }

            return ret;
        },

        /*\
         * Interactable.context
         [ method ]
         *
         * Gets the selector context Node of the Interactable. The default is `window.document`.
         *
         = (Node) The context Node of this Interactable
         **
        \*/
        context: function () {
            return this._context;
        },

        _context: document,

        /*\
         * Interactable.ignoreFrom
         [ method ]
         *
         * If the target of the `mousedown`, `pointerdown` or `touchstart`
         * event or any of it's parents match the given CSS selector or
         * Element, no drag/resize/gesture is started.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
         = (string | Element | object) The current ignoreFrom value or this Interactable
         **
         | interact(element, { ignoreFrom: document.getElementById('no-action') });
         | // or
         | interact(element).ignoreFrom('input, textarea, a');
        \*/
        ignoreFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.ignoreFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.ignoreFrom = newValue;
                return this;
            }

            return this.options.ignoreFrom;
        },

        /*\
         * Interactable.allowFrom
         [ method ]
         *
         * A drag/resize/gesture is started only If the target of the
         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
         * parents match the given CSS selector or Element.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
         = (string | Element | object) The current allowFrom value or this Interactable
         **
         | interact(element, { allowFrom: document.getElementById('drag-handle') });
         | // or
         | interact(element).allowFrom('.handle');
        \*/
        allowFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.allowFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.allowFrom = newValue;
                return this;
            }

            return this.options.allowFrom;
        },

        /*\
         * Interactable.element
         [ method ]
         *
         * If this is not a selector Interactable, it returns the element this
         * interactable represents
         *
         = (Element) HTML / SVG Element
        \*/
        element: function () {
            return this._element;
        },

        /*\
         * Interactable.fire
         [ method ]
         *
         * Calls listeners for the given InteractEvent type bound globally
         * and directly to this Interactable
         *
         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
         = (Interactable) this Interactable
        \*/
        fire: function (iEvent) {
            if (!(iEvent && iEvent.type) || !contains(eventTypes, iEvent.type)) {
                return this;
            }

            var listeners,
                i,
                len,
                onEvent = 'on' + iEvent.type,
                funcName = '';

            // Interactable#on() listeners
            if (iEvent.type in this._iEvents) {
                listeners = this._iEvents[iEvent.type];

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            // interactable.onevent listener
            if (isFunction(this[onEvent])) {
                funcName = this[onEvent].name;
                this[onEvent](iEvent);
            }

            // interact.on() listeners
            if (iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type])) {

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            return this;
        },

        /*\
         * Interactable.on
         [ method ]
         *
         * Binds a listener for an InteractEvent or DOM event.
         *
         - eventType  (string | array | object) The types of events to listen for
         - listener   (function) The function to be called on the given event(s)
         - useCapture (boolean) #optional useCapture flag for addEventListener
         = (object) This Interactable
        \*/
        on: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.on(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.on(prop, eventType[prop], listener);
                }

                return this;
            }

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (contains(eventTypes, eventType)) {
                // if this type of event was never bound to this Interactable
                if (!(eventType in this._iEvents)) {
                    this._iEvents[eventType] = [listener];
                }
                else {
                    this._iEvents[eventType].push(listener);
                }
            }
            // delegated event for selector
            else if (this.selector) {
                if (!delegatedEvents[eventType]) {
                    delegatedEvents[eventType] = {
                        selectors: [],
                        contexts: [],
                        listeners: []
                    };

                    // add delegate listener functions
                    for (i = 0; i < documents.length; i++) {
                        events.add(documents[i], eventType, delegateListener);
                        events.add(documents[i], eventType, delegateUseCapture, true);
                    }
                }

                var delegated = delegatedEvents[eventType],
                    index;

                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {
                        break;
                    }
                }

                if (index === -1) {
                    index = delegated.selectors.length;

                    delegated.selectors.push(this.selector);
                    delegated.contexts.push(this._context);
                    delegated.listeners.push([]);
                }

                // keep listener and useCapture flag
                delegated.listeners[index].push([listener, useCapture]);
            }
            else {
                events.add(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.off
         [ method ]
         *
         * Removes an InteractEvent or DOM event listener
         *
         - eventType  (string | array | object) The types of events that were listened for
         - listener   (function) The listener function to be removed
         - useCapture (boolean) #optional useCapture flag for removeEventListener
         = (object) This Interactable
        \*/
        off: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.off(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.off(prop, eventType[prop], listener);
                }

                return this;
            }

            var eventList,
                index = -1;

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // if it is an action event type
            if (contains(eventTypes, eventType)) {
                eventList = this._iEvents[eventType];

                if (eventList && (index = indexOf(eventList, listener)) !== -1) {
                    this._iEvents[eventType].splice(index, 1);
                }
            }
            // delegated event
            else if (this.selector) {
                var delegated = delegatedEvents[eventType],
                    matchFound = false;

                if (!delegated) { return this; }

                // count from last index of delegated to 0
                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    // look for matching selector and context Node
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {

                        var listeners = delegated.listeners[index];

                        // each item of the listeners array is an array: [function, useCaptureFlag]
                        for (i = listeners.length - 1; i >= 0; i--) {
                            var fn = listeners[i][0],
                                useCap = listeners[i][1];

                            // check if the listener functions and useCapture flags match
                            if (fn === listener && useCap === useCapture) {
                                // remove the listener from the array of listeners
                                listeners.splice(i, 1);

                                // if all listeners for this interactable have been removed
                                // remove the interactable from the delegated arrays
                                if (!listeners.length) {
                                    delegated.selectors.splice(index, 1);
                                    delegated.contexts.splice(index, 1);
                                    delegated.listeners.splice(index, 1);

                                    // remove delegate function from context
                                    events.remove(this._context, eventType, delegateListener);
                                    events.remove(this._context, eventType, delegateUseCapture, true);

                                    // remove the arrays if they are empty
                                    if (!delegated.selectors.length) {
                                        delegatedEvents[eventType] = null;
                                    }
                                }

                                // only remove one listener
                                matchFound = true;
                                break;
                            }
                        }

                        if (matchFound) { break; }
                    }
                }
            }
            // remove listener from this Interatable's element
            else {
                events.remove(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.set
         [ method ]
         *
         * Reset the options of this Interactable
         - options (object) The new settings to apply
         = (object) This Interactable
        \*/
        set: function (options) {
            if (!isObject(options)) {
                options = {};
            }

            this.options = extend({}, defaultOptions.base);

            var i,
                actions = ['drag', 'drop', 'resize', 'gesture'],
                methods = ['draggable', 'dropzone', 'resizable', 'gesturable'],
                perActions = extend(extend({}, defaultOptions.perAction), options[action] || {});

            for (i = 0; i < actions.length; i++) {
                var action = actions[i];

                this.options[action] = extend({}, defaultOptions[action]);

                this.setPerAction(action, perActions);

                this[methods[i]](options[action]);
            }

            var settings = [
                'accept', 'actionChecker', 'allowFrom', 'deltaSource',
                'dropChecker', 'ignoreFrom', 'origin', 'preventDefault',
                'rectChecker', 'styleCursor'
            ];

            for (i = 0, len = settings.length; i < len; i++) {
                var setting = settings[i];

                this.options[setting] = defaultOptions.base[setting];

                if (setting in options) {
                    this[setting](options[setting]);
                }
            }

            return this;
        },

        /*\
         * Interactable.unset
         [ method ]
         *
         * Remove this interactable from the list of interactables and remove
         * it's drag, drop, resize and gesture capabilities
         *
         = (object) @interact
        \*/
        unset: function () {
            events.remove(this._element, 'all');

            if (!isString(this.selector)) {
                events.remove(this, 'all');
                if (this.options.styleCursor) {
                    this._element.style.cursor = '';
                }
            }
            else {
                // remove delegated events
                for (var type in delegatedEvents) {
                    var delegated = delegatedEvents[type];

                    for (var i = 0; i < delegated.selectors.length; i++) {
                        if (delegated.selectors[i] === this.selector
                            && delegated.contexts[i] === this._context) {

                            delegated.selectors.splice(i, 1);
                            delegated.contexts.splice(i, 1);
                            delegated.listeners.splice(i, 1);

                            // remove the arrays if they are empty
                            if (!delegated.selectors.length) {
                                delegatedEvents[type] = null;
                            }
                        }

                        events.remove(this._context, type, delegateListener);
                        events.remove(this._context, type, delegateUseCapture, true);

                        break;
                    }
                }
            }

            this.dropzone(false);

            interactables.splice(indexOf(interactables, this), 1);

            return interact;
        }
    };

    function warnOnce(method, message) {
        var warned = false;

        return function () {
            if (!warned) {
                window.console.warn(message);
                warned = true;
            }

            return method.apply(this, arguments);
        };
    }

    Interactable.prototype.snap = warnOnce(Interactable.prototype.snap,
        'Interactable#snap is deprecated. See the new documentation for snapping at https://interactjs.io/docs/snapping');
    Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict,
        'Interactable#restrict is deprecated. See the new documentation for resticting at https://interactjs.io/docs/restriction');
    Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia,
        'Interactable#inertia is deprecated. See the new documentation for inertia at https://interactjs.io/docs/inertia');
    Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll,
        'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at https://interactjs.io/docs/#autoscroll');
    Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize,
        'Interactable#squareResize is deprecated. See https://interactjs.io/docs/#resize-square');

    Interactable.prototype.accept = warnOnce(Interactable.prototype.accept,
        'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');
    Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker,
        'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');
    Interactable.prototype.context = warnOnce(Interactable.prototype.context,
        'Interactable#context as a method is deprecated. It will soon be a DOM Node instead');

    /*\
     * interact.isSet
     [ method ]
     *
     * Check if an element has been set
     - element (Element) The Element being searched for
     = (boolean) Indicates if the element or CSS selector was previously passed to interact
    \*/
    interact.isSet = function (element, options) {
        return interactables.indexOfElement(element, options && options.context) !== -1;
    };

    /*\
     * interact.on
     [ method ]
     *
     * Adds a global listener for an InteractEvent or adds a DOM event to
     * `document`
     *
     - type       (string | array | object) The types of events to listen for
     - listener   (function) The function to be called on the given event(s)
     - useCapture (boolean) #optional useCapture flag for addEventListener
     = (object) interact
    \*/
    interact.on = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.on(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.on(prop, type[prop], listener);
            }

            return interact;
        }

        // if it is an InteractEvent type, add listener to globalEvents
        if (contains(eventTypes, type)) {
            // if this type of event was never bound
            if (!globalEvents[type]) {
                globalEvents[type] = [listener];
            }
            else {
                globalEvents[type].push(listener);
            }
        }
        // If non InteractEvent type, addEventListener to document
        else {
            events.add(document, type, listener, useCapture);
        }

        return interact;
    };

    /*\
     * interact.off
     [ method ]
     *
     * Removes a global InteractEvent listener or DOM event from `document`
     *
     - type       (string | array | object) The types of events that were listened for
     - listener   (function) The listener function to be removed
     - useCapture (boolean) #optional useCapture flag for removeEventListener
     = (object) interact
     \*/
    interact.off = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.off(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.off(prop, type[prop], listener);
            }

            return interact;
        }

        if (!contains(eventTypes, type)) {
            events.remove(document, type, listener, useCapture);
        }
        else {
            var index;

            if (type in globalEvents
                && (index = indexOf(globalEvents[type], listener)) !== -1) {
                globalEvents[type].splice(index, 1);
            }
        }

        return interact;
    };

    /*\
     * interact.enableDragging
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether dragging is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableDragging = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.drag = newValue;

            return interact;
        }
        return actionIsEnabled.drag;
    }, 'interact.enableDragging is deprecated and will soon be removed.');

    /*\
     * interact.enableResizing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether resizing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableResizing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.resize = newValue;

            return interact;
        }
        return actionIsEnabled.resize;
    }, 'interact.enableResizing is deprecated and will soon be removed.');

    /*\
     * interact.enableGesturing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether gesturing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableGesturing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.gesture = newValue;

            return interact;
        }
        return actionIsEnabled.gesture;
    }, 'interact.enableGesturing is deprecated and will soon be removed.');

    interact.eventTypes = eventTypes;

    /*\
     * interact.debug
     [ method ]
     *
     * Returns debugging data
     = (object) An object with properties that outline the current state and expose internal functions and variables
    \*/
    interact.debug = function () {
        var interaction = interactions[0] || new Interaction();

        return {
            interactions: interactions,
            target: interaction.target,
            dragging: interaction.dragging,
            resizing: interaction.resizing,
            gesturing: interaction.gesturing,
            prepared: interaction.prepared,
            matches: interaction.matches,
            matchElements: interaction.matchElements,

            prevCoords: interaction.prevCoords,
            startCoords: interaction.startCoords,

            pointerIds: interaction.pointerIds,
            pointers: interaction.pointers,
            addPointer: listeners.addPointer,
            removePointer: listeners.removePointer,
            recordPointer: listeners.recordPointer,

            snap: interaction.snapStatus,
            restrict: interaction.restrictStatus,
            inertia: interaction.inertiaStatus,

            downTime: interaction.downTimes[0],
            downEvent: interaction.downEvent,
            downPointer: interaction.downPointer,
            prevEvent: interaction.prevEvent,

            Interactable: Interactable,
            interactables: interactables,
            pointerIsDown: interaction.pointerIsDown,
            defaultOptions: defaultOptions,
            defaultActionChecker: defaultActionChecker,

            actionCursors: actionCursors,
            dragMove: listeners.dragMove,
            resizeMove: listeners.resizeMove,
            gestureMove: listeners.gestureMove,
            pointerUp: listeners.pointerUp,
            pointerDown: listeners.pointerDown,
            pointerMove: listeners.pointerMove,
            pointerHover: listeners.pointerHover,

            eventTypes: eventTypes,

            events: events,
            globalEvents: globalEvents,
            delegatedEvents: delegatedEvents,

            prefixedPropREs: prefixedPropREs
        };
    };

    // expose the functions used to calculate multi-touch properties
    interact.getPointerAverage = pointerAverage;
    interact.getTouchBBox = touchBBox;
    interact.getTouchDistance = touchDistance;
    interact.getTouchAngle = touchAngle;

    interact.getElementRect = getElementRect;
    interact.getElementClientRect = getElementClientRect;
    interact.matchesSelector = matchesSelector;
    interact.closest = closest;

    /*\
     * interact.margin
     [ method ]
     *
     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
     * Returns or sets the margin for autocheck resizing used in
     * @Interactable.getAction. That is the distance from the bottom and right
     * edges of an element clicking in which will start resizing
     *
     - newValue (number) #optional
     = (number | interact) The current margin value or interact
    \*/
    interact.margin = warnOnce(function (newvalue) {
        if (isNumber(newvalue)) {
            margin = newvalue;

            return interact;
        }
        return margin;
    },
        'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.');

    /*\
     * interact.supportsTouch
     [ method ]
     *
     = (boolean) Whether or not the browser supports touch input
    \*/
    interact.supportsTouch = function () {
        return supportsTouch;
    };

    /*\
     * interact.supportsPointerEvent
     [ method ]
     *
     = (boolean) Whether or not the browser supports PointerEvents
    \*/
    interact.supportsPointerEvent = function () {
        return supportsPointerEvent;
    };

    /*\
     * interact.stop
     [ method ]
     *
     * Cancels all interactions (end events are not fired)
     *
     - event (Event) An event on which to call preventDefault()
     = (object) interact
    \*/
    interact.stop = function (event) {
        for (var i = interactions.length - 1; i >= 0; i--) {
            interactions[i].stop(event);
        }

        return interact;
    };

    /*\
     * interact.dynamicDrop
     [ method ]
     *
     * Returns or sets whether the dimensions of dropzone elements are
     * calculated on every dragmove or only on dragstart for the default
     * dropChecker
     *
     - newValue (boolean) #optional True to check on each move. False to check only before start
     = (boolean | interact) The current setting or interact
    \*/
    interact.dynamicDrop = function (newValue) {
        if (isBool(newValue)) {
            //if (dragging && dynamicDrop !== newValue && !newValue) {
            //calcRects(dropzones);
            //}

            dynamicDrop = newValue;

            return interact;
        }
        return dynamicDrop;
    };

    /*\
     * interact.pointerMoveTolerance
     [ method ]
     * Returns or sets the distance the pointer must be moved before an action
     * sequence occurs. This also affects tolerance for tap events.
     *
     - newValue (number) #optional The movement from the start position must be greater than this value
     = (number | Interactable) The current setting or interact
    \*/
    interact.pointerMoveTolerance = function (newValue) {
        if (isNumber(newValue)) {
            pointerMoveTolerance = newValue;

            return this;
        }

        return pointerMoveTolerance;
    };

    /*\
     * interact.maxInteractions
     [ method ]
     **
     * Returns or sets the maximum number of concurrent interactions allowed.
     * By default only 1 interaction is allowed at a time (for backwards
     * compatibility). To allow multiple interactions on the same Interactables
     * and elements, you need to enable it in the draggable, resizable and
     * gesturable `'max'` and `'maxPerElement'` options.
     **
     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
    \*/
    interact.maxInteractions = function (newValue) {
        if (isNumber(newValue)) {
            maxInteractions = newValue;

            return this;
        }

        return maxInteractions;
    };

    interact.createSnapGrid = function (grid) {
        return function (x, y) {
            var offsetX = 0,
                offsetY = 0;

            if (isObject(grid.offset)) {
                offsetX = grid.offset.x;
                offsetY = grid.offset.y;
            }

            var gridx = Math.round((x - offsetX) / grid.x),
                gridy = Math.round((y - offsetY) / grid.y),

                newX = gridx * grid.x + offsetX,
                newY = gridy * grid.y + offsetY;

            return {
                x: newX,
                y: newY,
                range: grid.range
            };
        };
    };

    function endAllInteractions(event) {
        for (var i = 0; i < interactions.length; i++) {
            interactions[i].pointerEnd(event, event);
        }
    }

    function listenToDocument(doc) {
        if (contains(documents, doc)) { return; }

        var win = doc.defaultView || doc.parentWindow;

        // add delegate event listener
        for (var eventType in delegatedEvents) {
            events.add(doc, eventType, delegateListener);
            events.add(doc, eventType, delegateUseCapture, true);
        }

        if (supportsPointerEvent) {
            if (PointerEvent === win.MSPointerEvent) {
                pEventTypes = {
                    up: 'MSPointerUp', down: 'MSPointerDown', over: 'mouseover',
                    out: 'mouseout', move: 'MSPointerMove', cancel: 'MSPointerCancel'
                };
            }
            else {
                pEventTypes = {
                    up: 'pointerup', down: 'pointerdown', over: 'pointerover',
                    out: 'pointerout', move: 'pointermove', cancel: 'pointercancel'
                };
            }

            events.add(doc, pEventTypes.down, listeners.selectorDown);
            events.add(doc, pEventTypes.move, listeners.pointerMove);
            events.add(doc, pEventTypes.over, listeners.pointerOver);
            events.add(doc, pEventTypes.out, listeners.pointerOut);
            events.add(doc, pEventTypes.up, listeners.pointerUp);
            events.add(doc, pEventTypes.cancel, listeners.pointerCancel);

            // autoscroll
            events.add(doc, pEventTypes.move, listeners.autoScrollMove);
        }
        else {
            events.add(doc, 'mousedown', listeners.selectorDown);
            events.add(doc, 'mousemove', listeners.pointerMove);
            events.add(doc, 'mouseup', listeners.pointerUp);
            events.add(doc, 'mouseover', listeners.pointerOver);
            events.add(doc, 'mouseout', listeners.pointerOut);

            events.add(doc, 'touchstart', listeners.selectorDown);
            events.add(doc, 'touchmove', listeners.pointerMove);
            events.add(doc, 'touchend', listeners.pointerUp);
            events.add(doc, 'touchcancel', listeners.pointerCancel);

            // autoscroll
            events.add(doc, 'mousemove', listeners.autoScrollMove);
            events.add(doc, 'touchmove', listeners.autoScrollMove);
        }

        events.add(win, 'blur', endAllInteractions);

        try {
            if (win.frameElement) {
                var parentDoc = win.frameElement.ownerDocument,
                    parentWindow = parentDoc.defaultView;

                events.add(parentDoc, 'mouseup', listeners.pointerEnd);
                events.add(parentDoc, 'touchend', listeners.pointerEnd);
                events.add(parentDoc, 'touchcancel', listeners.pointerEnd);
                events.add(parentDoc, 'pointerup', listeners.pointerEnd);
                events.add(parentDoc, 'MSPointerUp', listeners.pointerEnd);
                events.add(parentWindow, 'blur', endAllInteractions);
            }
        }
        catch (error) {
            interact.windowParentError = error;
        }

        // prevent native HTML5 drag on interact.js target elements
        events.add(doc, 'dragstart', function (event) {
            for (var i = 0; i < interactions.length; i++) {
                var interaction = interactions[i];

                if (interaction.element
                    && (interaction.element === event.target
                        || nodeContains(interaction.element, event.target))) {

                    interaction.checkAndPreventDefault(event, interaction.target, interaction.element);
                    return;
                }
            }
        });

        if (events.useAttachEvent) {
            // For IE's lack of Event#preventDefault
            events.add(doc, 'selectstart', function (event) {
                var interaction = interactions[0];

                if (interaction.currentAction()) {
                    interaction.checkAndPreventDefault(event);
                }
            });

            // For IE's bad dblclick event sequence
            events.add(doc, 'dblclick', doOnInteractions('ie8Dblclick'));
        }

        documents.push(doc);
    }

    listenToDocument(document);

    function indexOf(array, target) {
        for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === target) {
                return i;
            }
        }

        return -1;
    }

    function contains(array, target) {
        return indexOf(array, target) !== -1;
    }

    function matchesSelector(element, selector, nodeList) {
        if (ie8MatchesSelector) {
            return ie8MatchesSelector(element, selector, nodeList);
        }

        // remove /deep/ from selectors if shadowDOM polyfill is used
        if (window !== realWindow) {
            selector = selector.replace(/\/deep\//g, ' ');
        }

        return element[prefixedMatchesSelector](selector);
    }

    function matchesUpTo(element, selector, limit) {
        while (isElement(element)) {
            if (matchesSelector(element, selector)) {
                return true;
            }

            element = parentElement(element);

            if (element === limit) {
                return matchesSelector(element, selector);
            }
        }

        return false;
    }

    // For IE8's lack of an Element#matchesSelector
    // taken from https://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
    if (!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])) {
        ie8MatchesSelector = function (element, selector, elems) {
            elems = elems || element.parentNode.querySelectorAll(selector);

            for (var i = 0, len = elems.length; i < len; i++) {
                if (elems[i] === element) {
                    return true;
                }
            }

            return false;
        };
    }

    // requestAnimationFrame polyfill
    (function () {
        var lastTime = 0,
            vendors = ['ms', 'moz', 'webkit', 'o'];

        for (var x = 0; x < vendors.length && !realWindow.requestAnimationFrame; ++x) {
            reqFrame = realWindow[vendors[x] + 'RequestAnimationFrame'];
            cancelFrame = realWindow[vendors[x] + 'CancelAnimationFrame'] || realWindow[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!reqFrame) {
            reqFrame = function (callback) {
                var currTime = new Date().getTime(),
                    timeToCall = Math.max(0, 16 - (currTime - lastTime)),
                    id = setTimeout(function () { callback(currTime + timeToCall); },
                        timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        }

        if (!cancelFrame) {
            cancelFrame = function (id) {
                clearTimeout(id);
            };
        }
    }());

    /* global exports: true, module, define */

    // https://documentcloud.github.io/underscore/docs/underscore.html#section-11
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = interact;
        }
        exports.interact = interact;
    }
    // AMD
    else if (typeof define === 'function' && define.amd) {
        define('interact', function () {
            return interact;
        });
    }
    else {
        realWindow.interact = interact;
    }

}(typeof window === 'undefined' ? undefined : window));
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.calender', ['mwl.calendar', 'ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_training_calender', {
            url: '/CourseAdministration',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/calender/calender.html',
                    controller: 'calenderController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/training/calender');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.calender')
        .controller('calenderController', calenderController);

    /** @ngInject */
    function calenderController($mdDateLocale, $scope, $rootScope, $location, $mdDialog, $document, $interval, $mdToast, moment, calendarConfig, $timeout, $q, $log, $mdSidenav, $http, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.model = {};
        $scope.CAgrid = true;
        $scope.CourseSchedulinggrid = true;
        $scope.CourseSchedulingform = false;
        $scope.CourseMasterUpdate = false;
        $scope.Enrollmentgrid = true;
        $scope.EnrollmentForm = false;
        $scope.sAdd = function () {
            var info = $scope.Courseschedulingdatas
            for (var x = 1; x <= 1 + info.length; x++) {
                var z = 'TA-' + ('0000' + x).slice(-4);
            }
            $scope.vm.BatchID = z;
            $scope.CourseSchedulinggrid = false;
            $scope.CourseSchedulingform = true;

            $scope.vm.CourseName = null;
            $scope.vm.BatchName = null;
            $scope.vm.TrainerName = null;
            $scope.vm.VenueDetails = null;
            $scope.vm.StartDate = null;
            $scope.vm.EndDate = null;
            $scope.vm.TotalSeatings = null;
            $scope.vm.Remarks = null;
            $scope.vm.SubsidiaryProvider = null;
            $scope.vm.SDFReferenceNumber = null;
            $scope.vm.TotalHours = null;
            $scope.vm.NoofDays = null;
            $scope.Inhouse = { value: false, };

        }
        $scope.EAdd = function () {
            $scope.EnrollmentsForm.$setPristine();
            $scope.EnrollmentsForm.$setUntouched();
            $scope.vm.ECourseName = null;
            $scope.vm.EBatchName = null;
            $scope.vm.EEmployeeName = null;
            $scope.vm.EFees = null;
            $scope.vm.ERemarks = null;
            $scope.vm.GST = null;
            $scope.vm.PaymentReceived = null;
            $scope.Company = { value: false }
            $scope.EnrollmentUpdate = false;
            $scope.Enrollmentgrid = false;
            $scope.EnrollmentForm = true;
        }
        $scope.CourseMasterSubmit = function () {
            debugger
            if ($scope.CourseMasterUpdate == true) {
                $scope.CourseMasterUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/coursemaster/update",
                    data: {
                        _id: $scope.CourseMasterId, CourseName: $scope.CourseName,
                        Description: $scope.Description, CourseProvider: $scope.CourseProvider,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $scope.CourseMasterUpdate = false;
                    $scope.CourseMasterId = null;
                    $scope.CourseName = null;
                    $scope.Description = null;
                    $scope.CourseProvider = null;
                    $scope.coursemaster.$setPristine();
                    $scope.coursemaster.$setUntouched();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/coursemaster/add",
                    data: {
                        CourseName: $scope.CourseName, Description: $scope.Description, CourseProvider: $scope.CourseProvider,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $scope.CourseMasterUpdate = false;
                    $scope.CourseName = null;
                    $scope.CourseProvider = null;
                    $scope.Description = null;
                    $scope.coursemaster.$setPristine();
                    $scope.coursemaster.$setUntouched();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.CourseMasterinfo = function (CourseMasterId) {
            $scope.CourseMasterId = CourseMasterId;
            $scope.CourseMasterUpdate = true;
            $scope.CourseMasterId = CourseMasterId;
            angular.forEach($scope.Coursemasterdatas, function (value) {
                if (value.id == CourseMasterId) {
                    $scope.CourseName = value.CourseName;
                    $scope.Description = value.Description;
                    $scope.CourseProvider = value.CourseProvider;
                }
            })
        }

        $scope.CourseSchedulinginfo = function (CourseSchedulingID) {
            $scope.CourseSchedulingID = CourseSchedulingID;
            $scope.CourseSchedulingUpdate = true;
            $scope.CourseSchedulinggrid = false;
            $scope.CourseSchedulingform = true;
            angular.forEach($scope.Courseschedulingdatas, function (value) {
                if (value.id == CourseSchedulingID) {
                    $scope.vm.BatchID = value.BatchID;
                    $scope.vm.CourseName = value.CourseName;
                    $scope.vm.BatchName = value.BatchName;
                    $scope.vm.TrainerName = value.TrainerName;
                    $scope.vm.VenueDetails = value.VenueDetails;
                    $scope.vm.StartDate = value.StartDate;
                    $scope.vm.EndDate = value.EndDate;
                    $scope.vm.TotalSeatings = parseInt(value.TotalSeatings);
                    $scope.vm.Remarks = value.Remarks;
                    $scope.vm.SubsidiaryProvider = value.SubsidiaryProvider;
                    $scope.vm.SDFReferenceNumber = value.SDFReferenceNumber;
                    $scope.vm.TotalHours = parseInt(value.TotalHours);
                    $scope.vm.NoofDays = value.NoofDays;
                    if (value.InhouseTraining == "Yes") { $scope.Inhouse = { value: true, }; }
                    if (value.InhouseTraining == "No" || value.InhouseTraining == "" || value.InhouseTraining == null) {
                        $scope.Inhouse = { value: false, };
                    }
                }
            })
        }
        $scope.CourseSchedulingSubmit = function () {
            if ($scope.Inhouse.value == true) { $scope.vm.InhouseTraining = 'Yes' }
            else { $scope.vm.InhouseTraining = 'No' }
            if ($scope.CourseSchedulingUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/coursescheduling/update",
                    data: {
                        _id: $scope.CourseSchedulingID,
                        BatchID: $scope.vm.BatchID,
                        CourseName: $scope.vm.CourseName,
                        BatchName: $scope.vm.BatchName,
                        TrainerName: $scope.vm.TrainerName,
                        InhouseTraining: $scope.vm.InhouseTraining,
                        VenueDetails: $scope.vm.VenueDetails,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        TotalSeatings: $scope.vm.TotalSeatings,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $scope.vm.CreatedBy,
                        NoofDays: $scope.vm.NoofDays,
                        SubsidiaryProvider: $scope.vm.SubsidiaryProvider,
                        SDFReferenceNumber: $scope.vm.SDFReferenceNumber,
                        TotalHours: $scope.vm.TotalHours,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.CourseSchedulinggrid = true;
                    $scope.CourseSchedulingform = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/coursescheduling/add",
                    data: {
                        BatchID: $scope.vm.BatchID,
                        CourseName: $scope.vm.CourseName,
                        BatchName: $scope.vm.BatchName,
                        TrainerName: $scope.vm.TrainerName,
                        InhouseTraining: $scope.vm.InhouseTraining,
                        VenueDetails: $scope.vm.VenueDetails,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        TotalSeatings: $scope.vm.TotalSeatings,
                        Remarks: $scope.vm.Remarks,
                        NoofDays: $scope.vm.NoofDays,
                        SubsidiaryProvider: $scope.vm.SubsidiaryProvider,
                        SDFReferenceNumber: $scope.vm.SDFReferenceNumber,
                        TotalHours: $scope.vm.TotalHours,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },

                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.CourseSchedulinggrid = true;
                    $scope.CourseSchedulingform = false;
                    $scope.Export = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Enrolmentinfo = function (EnrolementId) {
            debugger
            $scope.EnrolementId = EnrolementId;
            $scope.EnrollmentUpdate = true;
            $scope.Enrollmentgrid = false;
            $scope.EnrollmentForm = true;
            angular.forEach($scope.Enrollmentsdatas, function (value) {
                if (value.id == EnrolementId) {
                    $scope.vm.EnrolmentID = value.EnrolmentID;
                    $scope.vm.ECourseName = value.CourseName;
                    $scope.vm.EBatchName = value.BatchName;
                    $scope.vm.EEmployeeName = value.EmployeeName;
                    $scope.vm.EmpName = value.EmployeeName;
                    $scope.vm.ERemarks = value.Remarks;
                    $scope.vm.EStatus = value.Status;
                    $scope.vm.ECStatus = value.CStatus;
                    $scope.vm.PaymentReceived = value.PaymentReceived;
                    $scope.vm.EFees = parseInt(value.Fees);
                    $scope.vm.GST = parseFloat(value.GST);
                    if (value.CompanySponsored == "Yes") { $scope.Company = { value: true, }; }
                    if (value.CompanySponsored == "No" || value.CompanySponsored == "" || value.CompanySponsored == null) {
                        $scope.Company = { value: false, };
                    }
                }
            })
        }
        $scope.EnrollmentSubmit = function () {
            if ($scope.Company.value == true) { $scope.vm.CompanySponsored = 'Yes' }
            else { $scope.vm.CompanySponsored = 'No' }
            if ($scope.EnrollmentUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/enrollments/update",
                    data: {
                        _id: $scope.EnrolementId,
                        EnrolmentID: $scope.vm.EnrolmentID,
                        CourseName: $scope.vm.ECourseName,
                        BatchName: $scope.vm.EBatchName,
                        EmployeeName: $scope.vm.EEmployeeName,
                        CompanySponsored: $scope.vm.CompanySponsored,
                        Fees: $scope.vm.EFees,
                        Remarks: $scope.vm.ERemarks,
                        Status: $scope.vm.EStatus,
                        CStatus: $scope.vm.ECStatus,
                        GST: $scope.vm.GST,
                        PaymentReceived: $scope.vm.PaymentReceived,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Enrollmentgrid = true;
                    $scope.EnrollmentForm = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                debugger
                var Einfo = $scope.vm.EEmployeeName;
                for (var i = 0; i < Einfo.length; i++) {
                    var info = $scope.Enrollmentsdatas
                    for (var x = 1; x <= i + 1 + info.length; x++) {
                        var z = 'EN-' + ('0000' + x).slice(-4);
                    }
                    $scope.vm.EnrolmentID = z;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/enrollments/add",
                        data: {
                            EnrolmentID: $scope.vm.EnrolmentID,
                            CourseName: $scope.vm.ECourseName,
                            BatchName: $scope.vm.EBatchName,
                            EmployeeName: Einfo[i].EmployeeName,
                            CompanySponsored: $scope.vm.CompanySponsored,
                            Fees: $scope.vm.EFees,
                            Remarks: $scope.vm.ERemarks,
                            Status: 'Not Done',
                            CStatus: 'Not Done',
                            GST: $scope.vm.GST,
                            PaymentReceived: $scope.vm.PaymentReceived,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                }
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Enrollmentgrid = true;
                    $scope.EnrollmentForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.tabclick = function () {
            var eventpush = [];
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/coursescheduling",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (courseschedulingdata) {
                $scope.Courseschedulingdatas = courseschedulingdata.data.data;
                angular.forEach($scope.Courseschedulingdatas, function (value) {
                    eventpush.push({
                        title: "Course : " + value.CourseName + '&emsp;&emsp;&emsp;' + 'Batch : ' + value.BatchName + '&emsp;&emsp;&emsp;',
                        startsAt: moment(value.StartDate).startOf('day').toDate(),
                        endsAt: moment(value.EndDate).endOf('day').toDate(),
                        id: value.id
                    });
                })
                $scope.calendereventdata = eventpush;
            });
        }
        $scope.Inhouse = { value: false }
        $scope.Company = { value: false }
        $scope.DaysCalc = function (CED) {
            debugger
            var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            var firstDate = new Date($scope.vm.StartDate);
            var secondDate = new Date($scope.vm.EndDate);
            $scope.vm.NoofDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        }
        $scope.Showgrid = function () {
            $scope.CourseSchedulinggrid = true;
            $scope.CourseSchedulingform = false;
            $scope.Enrollmentgrid = true;
            $scope.EnrollmentForm = false;
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursemaster",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (coursemasterdata) {
            $scope.Coursemasterdatas = coursemasterdata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursescheduling",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseschedulingdata) {
            $scope.Courseschedulingdatas = courseschedulingdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/coursemaster",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (coursemasterdata) {
                $scope.Coursemasterdatas = coursemasterdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/coursescheduling",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (courseschedulingdata) {
                $scope.Courseschedulingdatas = courseschedulingdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/enrollments",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (enrollmentsdata) {
                $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            });
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }

        };

        vm.calendarView = 'month';
        vm.viewDate = new Date();
        var actions = [{
            label: '<i class=\'glyphicon glyphicon-pencil\'></i>',
            onClick: function (args) {
                alert.show('Edited', args.calendarEvent);
            }
        }, {
            label: '<i class=\'glyphicon glyphicon-remove\'></i>',
            onClick: function (args) {
                alert.show('Deleted', args.calendarEvent);
            }
        }];

        vm.cellIsOpen = false;

        vm.eventClicked = function (event) {
            alert.show('Clicked', event);
        };

        vm.eventEdited = function (event) {
            alert.show('Edited', event);
        };

        vm.eventDeleted = function (event) {
            alert.show('Deleted', event);
        };

        vm.eventTimesChanged = function (event) {
            alert.show('Dropped or resized', event);
        };

        vm.toggle = function ($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        };

        vm.timespanClicked = function (date, cell) {
            debugger
            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            }

        };

        $scope.updateValue = function (name) {

            // Use timeout to simulate a 650ms request.

        };

        $scope.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(item);
            }
        };

        $scope.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.isIndeterminate = function () {
            return ($scope.selected.length !== 0 &&
                $scope.selected.length !== $scope.items.length);
        };

        $scope.isChecked = function () {
            return $scope.selected.length === $scope.items.length;
        };
        $scope.toggleAll = function () {
            if ($scope.selected.length === $scope.items.length) {
                $scope.selected = [];
            } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
                $scope.selected = $scope.items.slice(0);
            }
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
angular
    .module('app.human-resource.training.calender')
    .factory('alert', function ($uibModal) {

        function show(action, event) {
            return $uibModal.open({
                templateUrl: 'modalContent.html',
                controller: function () {
                    var vm = this;
                    vm.action = action;
                    vm.event = event;
                },
                controllerAs: 'vm'
            });
        }
        return {
            show: show
        };
    });
angular.module('app.human-resource.training.calender').config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY');
    };
});

angular.module('colorpicker.module', [])
    .factory('Helper', function () {
        'use strict';
        return {
            closestSlider: function (elem) {
                var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
                if (matchesSelector.bind(elem)('I')) {
                    return elem.parentNode;
                }
                return elem;
            },
            getOffset: function (elem, fixedPosition) {
                var
                  scrollX = 0,
                  scrollY = 0,
                  rect = elem.getBoundingClientRect();
                while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
                    if (!fixedPosition && elem.tagName === 'BODY') {
                        scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
                        scrollY += document.documentElement.scrollTop || elem.scrollTop;
                    } else {
                        scrollX += elem.scrollLeft;
                        scrollY += elem.scrollTop;
                    }
                    elem = elem.offsetParent;
                }
                return {
                    top: rect.top + window.pageYOffset,
                    left: rect.left + window.pageXOffset,
                    scrollX: scrollX,
                    scrollY: scrollY
                };
            },
            // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
            stringParsers: [
              {
                  re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16)
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16)
                      ];
                  }
              }
            ]
        };
    })
    .factory('Color', ['Helper', function (Helper) {
        'use strict';
        return {
            value: {
                h: 1,
                s: 1,
                b: 1,
                a: 1
            },
            // translate a format from Color object to a string
            'rgb': function () {
                var rgb = this.toRGB();
                return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
            },
            'rgba': function () {
                var rgb = this.toRGB();
                return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
            },
            'hex': function () {
                return this.toHex();
            },

            // HSBtoRGB from RaphaelJS
            RGBtoHSB: function (r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V === r ? (g - b) / C :
                        V === g ? (b - r) / C + 2 :
                            (r - g) / C + 4
                    );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return { h: H || 1, s: S, b: V, a: a || 1 };
            },

            //parse a string to HSB
            setColor: function (val) {
                val = (val) ? val.toLowerCase() : val;
                for (var key in Helper.stringParsers) {
                    if (Helper.stringParsers.hasOwnProperty(key)) {
                        var parser = Helper.stringParsers[key];
                        var match = parser.re.exec(val),
                            values = match && parser.parse(match);
                        if (values) {
                            this.value = this.RGBtoHSB.apply(null, values);
                            return false;
                        }
                    }
                }
            },

            setHue: function (h) {
                this.value.h = 1 - h;
            },

            setSaturation: function (s) {
                this.value.s = s;
            },

            setLightness: function (b) {
                this.value.b = 1 - b;
            },

            setAlpha: function (a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },

            // HSBtoRGB from RaphaelJS
            // https://github.com/DmitryBaranovskiy/raphael/
            toRGB: function (h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },

            toHex: function (h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
            }
        };
    }])
    .factory('Slider', ['Helper', function (Helper) {
        'use strict';
        var
            slider = {
                maxLeft: 0,
                maxTop: 0,
                callLeft: null,
                callTop: null,
                knob: {
                    top: 0,
                    left: 0
                }
            },
            pointer = {};

        return {
            getSlider: function () {
                return slider;
            },
            getLeftPosition: function (event) {
                return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
            },
            getTopPosition: function (event) {
                return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
            },
            setSlider: function (event, fixedPosition) {
                var
                  target = Helper.closestSlider(event.target),
                  targetOffset = Helper.getOffset(target, fixedPosition),
                  rect = target.getBoundingClientRect(),
                  offsetX = event.clientX - rect.left,
                  offsetY = event.clientY - rect.top;

                slider.knob = target.children[0].style;
                slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
                slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;

                pointer = {
                    left: event.pageX - (offsetX - slider.left),
                    top: event.pageY - (offsetY - slider.top)
                };
            },
            setSaturation: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: componentSize,
                    maxTop: componentSize,
                    callLeft: 'setSaturation',
                    callTop: 'setLightness'
                };
                this.setSlider(event, fixedPosition);
            },
            setHue: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setHue'
                };
                this.setSlider(event, fixedPosition);
            },
            setAlpha: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setAlpha'
                };
                this.setSlider(event, fixedPosition);
            },
            setKnob: function (top, left) {
                slider.knob.top = top + 'px';
                slider.knob.left = left + 'px';
            }
        };
    }])
    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
        'use strict';
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function ($scope, elem, attrs, ngModel) {
                var
                    thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
                    position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
                    inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
                    fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
                    target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
                    withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
                    componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
                    componentSizePx = componentSize + 'px',
                    inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
                    closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
                    template =
                        '<div class="colorpicker dropdown">' +
                            '<div class="dropdown-menu">' +
                            '<colorpicker-saturation><i></i></colorpicker-saturation>' +
                            '<colorpicker-hue><i></i></colorpicker-hue>' +
                            '<colorpicker-alpha><i></i></colorpicker-alpha>' +
                            '<colorpicker-preview></colorpicker-preview>' +
                            inputTemplate +
                            closeButton +
                            '</div>' +
                            '</div>',
                    colorpickerTemplate = angular.element(template),
                    pickerColor = Color,
                    colorpickerValue = {
                        h: 1,
                        s: 0,
                        b: 1,
                        a: 1
                    },
                    sliderAlpha,
                    sliderHue = colorpickerTemplate.find('colorpicker-hue'),
                    sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
                    colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
                    pickerColorPointers = colorpickerTemplate.find('i'),
                    componentWidthWithToolbars = parseInt(componentSize) + 29 + (thisFormat === 'rgba' ? 15 : 0),
                    componentHeightWithToolbars = parseInt(componentSize) + 55;

                $compile(colorpickerTemplate)($scope);
                colorpickerTemplate.css('min-width', componentWidthWithToolbars + 'px');
                sliderSaturation.css({
                    'width': componentSizePx,
                    'height': componentSizePx
                });
                sliderHue.css('height', componentSizePx);

                if (withInput) {
                    var pickerColorInput = colorpickerTemplate.find('input');
                    pickerColorInput.css('width', componentSizePx);
                    pickerColorInput
                        .on('mousedown', function (event) {
                            event.stopPropagation();
                        })
                      .on('keyup', function () {
                          var newColor = this.value;
                          elem.val(newColor);
                          if (ngModel && ngModel.$modelValue !== newColor) {
                              $scope.$apply(ngModel.$setViewValue(newColor));
                              update(true);
                          }
                      });
                }

                function bindMouseEvents() {
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }

                if (thisFormat === 'rgba') {
                    colorpickerTemplate.addClass('alpha');
                    sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
                    sliderAlpha.css('height', componentSizePx);
                    sliderAlpha
                        .on('click', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            mousemove(event);
                        })
                        .on('mousedown', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            bindMouseEvents();
                        })
                        .on('mouseup', function (event) {
                            emitEvent('colorpicker-selected-alpha');
                        });
                }

                sliderHue
                    .on('click', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        mousemove(event);
                    })
                    .on('mousedown', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-hue');
                    });

                sliderSaturation
                    .on('click', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        mousemove(event);
                        if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
                            hideColorpickerTemplate();
                        }
                    })
                    .on('mousedown', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-saturation');
                    });

                if (fixedPosition) {
                    colorpickerTemplate.addClass('colorpicker-fixed-position');
                }

                colorpickerTemplate.addClass('colorpicker-position-' + position);
                if (inline === 'true') {
                    colorpickerTemplate.addClass('colorpicker-inline');
                }

                target.append(colorpickerTemplate);

                if (ngModel) {
                    ngModel.$render = function () {
                        elem.val(ngModel.$viewValue);

                        update();
                    };
                }

                elem.on('blur keyup change', function () {
                    update();
                });

                elem.on('$destroy', function () {
                    colorpickerTemplate.remove();
                });

                function previewColor() {
                    try {
                        colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
                    } catch (e) {
                        colorpickerPreview.css('backgroundColor', pickerColor.toHex());
                    }
                    sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
                    if (thisFormat === 'rgba') {
                        sliderAlpha.css.backgroundColor = pickerColor.toHex();
                    }
                }

                function mousemove(event) {
                    var
                        left = Slider.getLeftPosition(event),
                        top = Slider.getTopPosition(event),
                        slider = Slider.getSlider();

                    Slider.setKnob(top, left);

                    if (slider.callLeft) {
                        pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
                    }
                    if (slider.callTop) {
                        pickerColor[slider.callTop].call(pickerColor, top / componentSize);
                    }
                    previewColor();
                    var newColor = pickerColor[thisFormat]();
                    elem.val(newColor);
                    if (ngModel) {
                        $scope.$apply(ngModel.$setViewValue(newColor));
                    }
                    if (withInput) {
                        pickerColorInput.val(newColor);
                    }
                    return false;
                }

                function mouseup() {
                    emitEvent('colorpicker-selected');
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                }

                function update(omitInnerInput) {
                    pickerColor.value = colorpickerValue;
                    pickerColor.setColor(elem.val());
                    if (withInput && !omitInnerInput) {
                        pickerColorInput.val(elem.val());
                    }
                    pickerColorPointers.eq(0).css({
                        left: pickerColor.value.s * componentSize + 'px',
                        top: componentSize - pickerColor.value.b * componentSize + 'px'
                    });
                    pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
                    pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
                    colorpickerValue = pickerColor.value;
                    previewColor();
                }

                function getColorpickerTemplatePosition() {
                    var
                        positionValue,
                        positionOffset = Helper.getOffset(elem[0]),
                        additionalSpaceBetweenElements = 2;

                    if (angular.isDefined(attrs.colorpickerParent)) {
                        positionOffset.left = 0;
                        positionOffset.top = 0;
                    }

                    if (position === 'top') {
                        positionValue = {
                            'top': positionOffset.top - componentHeightWithToolbars - additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'right') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left + elem[0].offsetWidth + additionalSpaceBetweenElements
                        };
                    } else if (position === 'bottom') {
                        positionValue = {
                            'top': positionOffset.top + elem[0].offsetHeight + additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'left') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left - componentWidthWithToolbars - additionalSpaceBetweenElements
                        };
                    }
                    return {
                        'top': positionValue.top + 'px',
                        'left': positionValue.left + 'px'
                    };
                }

                function documentMousedownHandler() {
                    hideColorpickerTemplate();
                }

                function showColorpickerTemplate() {

                    if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
                        update();
                        colorpickerTemplate
                          .addClass('colorpicker-visible')
                          .css(getColorpickerTemplatePosition());
                        emitEvent('colorpicker-shown');

                        if (inline === false) {
                            // register global mousedown event to hide the colorpicker
                            $document.on('mousedown', documentMousedownHandler);
                        }

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = true;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                if (inline === false) {
                    elem.on('click', showColorpickerTemplate);
                } else {
                    showColorpickerTemplate();
                }

                colorpickerTemplate.on('mousedown', function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                });

                function emitEvent(name) {
                    if (ngModel) {
                        $scope.$emit(name, {
                            name: attrs.ngModel,
                            value: ngModel.$modelValue
                        });
                    }
                }

                function hideColorpickerTemplate() {
                    if (colorpickerTemplate.hasClass('colorpicker-visible')) {
                        colorpickerTemplate.removeClass('colorpicker-visible');
                        emitEvent('colorpicker-closed');
                        // unregister the global mousedown event
                        $document.off('mousedown', documentMousedownHandler);

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = false;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                colorpickerTemplate.find('button').on('click', function () {
                    hideColorpickerTemplate();
                });

                if (attrs.colorpickerIsOpen) {
                    $scope.$watch(attrs.colorpickerIsOpen, function (shouldBeOpen) {

                        if (shouldBeOpen === true) {
                            showColorpickerTemplate();
                        } else if (shouldBeOpen === false) {
                            hideColorpickerTemplate();
                        }

                    });
                }
            }
        };
    }]);
/**
 * angular-bootstrap-calendar - A pure AngularJS bootstrap themed responsive calendar that can display events and has views for year, month, week and day
 * @version v0.29.3
 * @link https://github.com/mattlewis92/angular-bootstrap-calendar
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else if (typeof define === 'function' && define.amd)
        define(["angular", "moment", "interact"], factory);
    else if (typeof exports === 'object')
        exports["angularBootstrapCalendarModuleName"] = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else
        root["angularBootstrapCalendarModuleName"] = factory(root["angular"], root["moment"], root["interact"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_71__, __WEBPACK_EXTERNAL_MODULE_72__) {
    return /******/ (function (modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};
        /******/
        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {
            /******/
            /******/ 		// Check if module is in cache
            /******/ 		if (installedModules[moduleId]) {
                /******/ 			return installedModules[moduleId].exports;
                /******/
            }
            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/
            };
            /******/
            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;
            /******/
            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/
        }
        /******/
        /******/
        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;
        /******/
        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;
        /******/
        /******/ 	// identity function for calling harmony imports with the correct context
        /******/ 	__webpack_require__.i = function (value) { return value; };
        /******/
        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function (exports, name, getter) {
            /******/ 		if (!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, {
                    /******/ 				configurable: false,
                    /******/ 				enumerable: true,
                    /******/ 				get: getter
            /******/
        });
                /******/
            }
            /******/
        };
        /******/
        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function (module) {
            /******/ 		var getter = module && module.__esModule ?
            /******/ 			function getDefault() { return module['default']; } :
            /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/
        };
        /******/
        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";
        /******/
        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 60);
        /******/
    })
    /************************************************************************/
    /******/([
    /* 0 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

            /***/
        }),
    /* 1 */
    /***/ (function (module, exports, __webpack_require__) {

            var isDate = __webpack_require__(24)

            var MILLISECONDS_IN_HOUR = 3600000
            var MILLISECONDS_IN_MINUTE = 60000
            var DEFAULT_ADDITIONAL_DIGITS = 2

            var parseTokenDateTimeDelimeter = /[T ]/
            var parseTokenPlainTime = /:/

            // year tokens
            var parseTokenYY = /^(\d{2})$/
            var parseTokensYYY = [
                /^([+-]\d{2})$/, // 0 additional digits
                /^([+-]\d{3})$/, // 1 additional digit
                /^([+-]\d{4})$/ // 2 additional digits
            ]

            var parseTokenYYYY = /^(\d{4})/
            var parseTokensYYYYY = [
                /^([+-]\d{4})/, // 0 additional digits
                /^([+-]\d{5})/, // 1 additional digit
                /^([+-]\d{6})/ // 2 additional digits
            ]

            // date tokens
            var parseTokenMM = /^-(\d{2})$/
            var parseTokenDDD = /^-?(\d{3})$/
            var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
            var parseTokenWww = /^-?W(\d{2})$/
            var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

            // time tokens
            var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
            var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
            var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

            // timezone tokens
            var parseTokenTimezone = /([Z+-].*)$/
            var parseTokenTimezoneZ = /^(Z)$/
            var parseTokenTimezoneHH = /^([+-])(\d{2})$/
            var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

            /**
             * @category Common Helpers
             * @summary Convert the given argument to an instance of Date.
             *
             * @description
             * Convert the given argument to an instance of Date.
             *
             * If the argument is an instance of Date, the function returns its clone.
             *
             * If the argument is a number, it is treated as a timestamp.
             *
             * If an argument is a string, the function tries to parse it.
             * Function accepts complete ISO 8601 formats as well as partial implementations.
             * ISO 8601: https://en.wikipedia.org/wiki/ISO_8601
             *
             * If all above fails, the function passes the given argument to Date constructor.
             *
             * @param {Date|String|Number} argument - the value to convert
             * @param {Object} [options] - the object with options
             * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
             * @returns {Date} the parsed date in the local time zone
             *
             * @example
             * // Convert string '2014-02-11T11:30:30' to date:
             * var result = parse('2014-02-11T11:30:30')
             * //=> Tue Feb 11 2014 11:30:30
             *
             * @example
             * // Parse string '+02014101',
             * // if the additional number of digits in the extended year format is 1:
             * var result = parse('+02014101', {additionalDigits: 1})
             * //=> Fri Apr 11 2014 00:00:00
             */
            function parse(argument, dirtyOptions) {
                if (isDate(argument)) {
                    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
                    return new Date(argument.getTime())
                } else if (typeof argument !== 'string') {
                    return new Date(argument)
                }

                var options = dirtyOptions || {}
                var additionalDigits = options.additionalDigits
                if (additionalDigits == null) {
                    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
                } else {
                    additionalDigits = Number(additionalDigits)
                }

                var dateStrings = splitDateString(argument)

                var parseYearResult = parseYear(dateStrings.date, additionalDigits)
                var year = parseYearResult.year
                var restDateString = parseYearResult.restDateString

                var date = parseDate(restDateString, year)

                if (date) {
                    var timestamp = date.getTime()
                    var time = 0
                    var offset

                    if (dateStrings.time) {
                        time = parseTime(dateStrings.time)
                    }

                    if (dateStrings.timezone) {
                        offset = parseTimezone(dateStrings.timezone)
                    } else {
                        // get offset accurate to hour in timezones that change offset
                        offset = new Date(timestamp + time).getTimezoneOffset()
                        offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
                    }

                    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
                } else {
                    return new Date(argument)
                }
            }

            function splitDateString(dateString) {
                var dateStrings = {}
                var array = dateString.split(parseTokenDateTimeDelimeter)
                var timeString

                if (parseTokenPlainTime.test(array[0])) {
                    dateStrings.date = null
                    timeString = array[0]
                } else {
                    dateStrings.date = array[0]
                    timeString = array[1]
                }

                if (timeString) {
                    var token = parseTokenTimezone.exec(timeString)
                    if (token) {
                        dateStrings.time = timeString.replace(token[1], '')
                        dateStrings.timezone = token[1]
                    } else {
                        dateStrings.time = timeString
                    }
                }

                return dateStrings
            }

            function parseYear(dateString, additionalDigits) {
                var parseTokenYYY = parseTokensYYY[additionalDigits]
                var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

                var token

                // YYYY or Â±YYYYY
                token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
                if (token) {
                    var yearString = token[1]
                    return {
                        year: parseInt(yearString, 10),
                        restDateString: dateString.slice(yearString.length)
                    }
                }

                // YY or Â±YYY
                token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
                if (token) {
                    var centuryString = token[1]
                    return {
                        year: parseInt(centuryString, 10) * 100,
                        restDateString: dateString.slice(centuryString.length)
                    }
                }

                // Invalid ISO-formatted year
                return {
                    year: null
                }
            }

            function parseDate(dateString, year) {
                // Invalid ISO-formatted year
                if (year === null) {
                    return null
                }

                var token
                var date
                var month
                var week

                // YYYY
                if (dateString.length === 0) {
                    date = new Date(0)
                    date.setUTCFullYear(year)
                    return date
                }

                // YYYY-MM
                token = parseTokenMM.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    date.setUTCFullYear(year, month)
                    return date
                }

                // YYYY-DDD or YYYYDDD
                token = parseTokenDDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    var dayOfYear = parseInt(token[1], 10)
                    date.setUTCFullYear(year, 0, dayOfYear)
                    return date
                }

                // YYYY-MM-DD or YYYYMMDD
                token = parseTokenMMDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    var day = parseInt(token[2], 10)
                    date.setUTCFullYear(year, month, day)
                    return date
                }

                // YYYY-Www or YYYYWww
                token = parseTokenWww.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    return dayOfISOYear(year, week)
                }

                // YYYY-Www-D or YYYYWwwD
                token = parseTokenWwwD.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    var dayOfWeek = parseInt(token[2], 10) - 1
                    return dayOfISOYear(year, week, dayOfWeek)
                }

                // Invalid ISO-formatted date
                return null
            }

            function parseTime(timeString) {
                var token
                var hours
                var minutes

                // hh
                token = parseTokenHH.exec(timeString)
                if (token) {
                    hours = parseFloat(token[1].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR
                }

                // hh:mm or hhmm
                token = parseTokenHHMM.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseFloat(token[2].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE
                }

                // hh:mm:ss or hhmmss
                token = parseTokenHHMMSS.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseInt(token[2], 10)
                    var seconds = parseFloat(token[3].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE +
                        seconds * 1000
                }

                // Invalid ISO-formatted time
                return null
            }

            function parseTimezone(timezoneString) {
                var token
                var absoluteOffset

                // Z
                token = parseTokenTimezoneZ.exec(timezoneString)
                if (token) {
                    return 0
                }

                // Â±hh
                token = parseTokenTimezoneHH.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                // Â±hh:mm or Â±hhmm
                token = parseTokenTimezoneHHMM.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                return 0
            }

            function dayOfISOYear(isoYear, week, day) {
                week = week || 0
                day = day || 0
                var date = new Date(0)
                date.setUTCFullYear(isoYear, 0, 4)
                var fourthOfJanuaryDay = date.getUTCDay() || 7
                var diff = week * 7 + day + 1 - fourthOfJanuaryDay
                date.setUTCDate(date.getUTCDate() + diff)
                return date
            }

            module.exports = parse


            /***/
        }),
    /* 2 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Add the specified number of milliseconds to the given date.
             *
             * @description
             * Add the specified number of milliseconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of milliseconds to be added
             * @returns {Date} the new date with the milliseconds added
             *
             * @example
             * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
             * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
             * //=> Thu Jul 10 2014 12:45:30.750
             */
            function addMilliseconds(dirtyDate, dirtyAmount) {
                var timestamp = parse(dirtyDate).getTime()
                var amount = Number(dirtyAmount)
                return new Date(timestamp + amount)
            }

            module.exports = addMilliseconds


            /***/
        }),
    /* 3 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the start of a day for the given date.
             *
             * @description
             * Return the start of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a day
             *
             * @example
             * // The start of a day for 2 September 2014 11:55:00:
             * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 00:00:00
             */
            function startOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfDay


            /***/
        }),
    /* 4 */
    /***/ (function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__ = __webpack_require__(20);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__ = __webpack_require__(13);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__(17);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__ = __webpack_require__(3);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__ = __webpack_require__(25);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__ = __webpack_require__(23);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__ = __webpack_require__(35);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__ = __webpack_require__(11);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__ = __webpack_require__(22);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__ = __webpack_require__(19);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__ = __webpack_require__(33);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__ = __webpack_require__(21);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__ = __webpack_require__(26);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__ = __webpack_require__(27);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__ = __webpack_require__(30);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__ = __webpack_require__(31);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__ = __webpack_require__(32);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__ = __webpack_require__(18);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__ = __webpack_require__(12);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__ = __webpack_require__(14);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min__ = __webpack_require__(29);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_date_fns_min__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max__ = __webpack_require__(28);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_date_fns_max__);
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDS_IN_DAY", function () { return SECONDS_IN_DAY; });
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewEventOffset"] = getWeekViewEventOffset;
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewHeader"] = getWeekViewHeader;
        /* harmony export (immutable) */ __webpack_exports__["getWeekView"] = getWeekView;
        /* harmony export (immutable) */ __webpack_exports__["getMonthView"] = getMonthView;
        /* harmony export (immutable) */ __webpack_exports__["getDayView"] = getDayView;
        /* harmony export (immutable) */ __webpack_exports__["getDayViewHourGrid"] = getDayViewHourGrid;






















            var WEEKEND_DAY_NUMBERS = [0, 6];
            var DAYS_IN_WEEK = 7;
            var HOURS_IN_DAY = 24;
            var MINUTES_IN_HOUR = 60;
            var SECONDS_IN_DAY = 60 * 60 * 24;
            function getExcludedSeconds(_a) {
                var startDate = _a.startDate, seconds = _a.seconds, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b;
                if (excluded.length < 1) {
                    return 0;
                }
                var result = 0; // Calculated in seconds
                var endDate;
                var dayStart;
                var dayEnd;
                switch (precision) {
                    case 'minutes':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(startDate, seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(startDate);
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endDate, 0));
                        excluded.forEach(function (excludedDay) {
                            if (excludedDay === dayStart) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(startDate), startDate) + 1;
                            }
                            else if (excludedDay === dayEnd) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(endDate, __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endDate)) + 1;
                            }
                            else if (excludedDay > dayStart && excludedDay < dayEnd) {
                                result += SECONDS_IN_DAY;
                            }
                        });
                        break;
                    case 'days':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate), seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate));
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(endDate);
                        result += excluded.filter(function (excludedDay) { return excludedDay >= dayStart && excludedDay <= dayEnd; }).length * SECONDS_IN_DAY;
                        break;
                }
                return result;
            }
            function getWeekViewEventSpan(_a) {
                var event = _a.event, offset = _a.offset, startOfWeekDate = _a.startOfWeekDate, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b, weekStartsOn = _a.weekStartsOn;
                offset = Math.round(offset * SECONDS_IN_DAY);
                var span = SECONDS_IN_DAY;
                var begin = __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default()(event.start, startOfWeekDate);
                var endOfWeekDate = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(startOfWeekDate, { weekStartsOn: weekStartsOn });
                if (event.end) {
                    switch (precision) {
                        case 'days':
                            span = (__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.end), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endOfWeekDate)), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(begin)) + 1) * SECONDS_IN_DAY;
                            break;
                        case 'minutes':
                            span = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(event.end, __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endOfWeekDate, 1)), begin);
                            break;
                    }
                }
                span -= getExcludedSeconds({ startDate: begin, seconds: span, excluded: excluded, precision: precision });
                return span / SECONDS_IN_DAY;
            }
            function getWeekViewEventOffset(_a) {
                var event = _a.event, startOfWeek = _a.startOfWeek, _b = _a.excluded, excluded = _b === void 0 ? [] : _b, _c = _a.precision, precision = _c === void 0 ? 'days' : _c;
                if (event.start < startOfWeek) {
                    return 0;
                }
                var offset;
                switch (precision) {
                    case 'days':
                        offset = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.start), startOfWeek) * SECONDS_IN_DAY;
                        break;
                    case 'minutes':
                        offset = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(event.start, startOfWeek);
                        break;
                }
                offset -= getExcludedSeconds({ startDate: startOfWeek, seconds: offset, excluded: excluded, precision: precision });
                return offset / SECONDS_IN_DAY;
            }
            function isEventIsPeriod(_a) {
                var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                var eventStart = event.start;
                var eventEnd = event.end || event.start;
                if (eventStart > periodStart && eventStart < periodEnd) {
                    return true;
                }
                if (eventEnd > periodStart && eventEnd < periodEnd) {
                    return true;
                }
                if (eventStart < periodStart && eventEnd > periodEnd) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodEnd)) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodEnd)) {
                    return true;
                }
                return false;
            }
            function getEventsInPeriod(_a) {
                var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });
            }
            function getWeekDay(_a) {
                var date = _a.date;
                var today = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(new Date());
                return {
                    date: date,
                    isPast: date < today,
                    isToday: __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default()(date, today),
                    isFuture: date > today,
                    isWeekend: WEEKEND_DAY_NUMBERS.indexOf(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(date)) > -1
                };
            }
            function getWeekViewHeader(_a) {
                var viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _b = _a.excluded, excluded = _b === void 0 ? [] : _b;
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var days = [];
                var _loop_1 = function (i) {
                    var date = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(start, i);
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        days.push(getWeekDay({ date: date }));
                    }
                };
                for (var i = 0; i < DAYS_IN_WEEK; i++) {
                    _loop_1(i);
                }
                return days;
            }
            function getWeekView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.precision, precision = _d === void 0 ? 'days' : _d, _e = _a.absolutePositionedEvents, absolutePositionedEvents = _e === void 0 ? false : _e;
                if (!events) {
                    events = [];
                }
                var startOfViewWeek = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var endOfViewWeek = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var maxRange = DAYS_IN_WEEK - excluded.length;
                var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfViewWeek, periodEnd: endOfViewWeek }).map(function (event) {
                    var offset = getWeekViewEventOffset({ event: event, startOfWeek: startOfViewWeek, excluded: excluded, precision: precision });
                    var span = getWeekViewEventSpan({ event: event, offset: offset, startOfWeekDate: startOfViewWeek, excluded: excluded, precision: precision, weekStartsOn: weekStartsOn });
                    return { event: event, offset: offset, span: span };
                }).filter(function (e) { return e.offset < maxRange; }).filter(function (e) { return e.span > 0; }).map(function (entry) {
                    return ({
                        event: entry.event,
                        offset: entry.offset,
                        span: entry.span,
                        startsBeforeWeek: entry.event.start < startOfViewWeek,
                        endsAfterWeek: (entry.event.end || entry.event.start) > endOfViewWeek
                    });
                }).sort(function (itemA, itemB) {
                    var startSecondsDiff = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemA.event.start, itemB.event.start);
                    if (startSecondsDiff === 0) {
                        return __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemB.event.end || itemB.event.start, itemA.event.end || itemA.event.start);
                    }
                    return startSecondsDiff;
                });
                var eventRows = [];
                var allocatedEvents = [];
                eventsMapped.forEach(function (event, index) {
                    if (allocatedEvents.indexOf(event) === -1) {
                        allocatedEvents.push(event);
                        var rowSpan_1 = event.span + event.offset;
                        var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {
                            if (nextEvent.offset >= rowSpan_1 &&
                                rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK &&
                                allocatedEvents.indexOf(nextEvent) === -1) {
                                var nextEventOffset = nextEvent.offset - rowSpan_1;
                                if (!absolutePositionedEvents) {
                                    nextEvent.offset = nextEventOffset;
                                }
                                rowSpan_1 += nextEvent.span + nextEventOffset;
                                allocatedEvents.push(nextEvent);
                                return true;
                            }
                        });
                        eventRows.push({
                            row: [
                                event
                            ].concat(otherRowEvents)
                        });
                    }
                });
                return eventRows;
            }
            function getMonthView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.viewStart, viewStart = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default()(viewDate) : _d, _e = _a.viewEnd, viewEnd = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default()(viewDate) : _e;
                if (!events) {
                    events = [];
                }
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewStart, { weekStartsOn: weekStartsOn });
                var end = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewEnd, { weekStartsOn: weekStartsOn });
                var eventsInMonth = getEventsInPeriod({
                    events: events,
                    periodStart: start,
                    periodEnd: end
                });
                var days = [];
                var previousDate;
                var _loop_2 = function (i) {
                    // hacky fix for https://github.com/mattlewis92/angular-calendar/issues/173
                    var date;
                    if (previousDate) {
                        date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY));
                        if (previousDate.getTime() === date.getTime()) {
                            date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY + 1));
                        }
                        previousDate = date;
                    }
                    else {
                        date = previousDate = start;
                    }
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        var day = getWeekDay({ date: date });
                        var events_1 = getEventsInPeriod({
                            events: eventsInMonth,
                            periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(date),
                            periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(date)
                        });
                        day.inMonth = __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default()(date, viewDate);
                        day.events = events_1;
                        day.badgeTotal = events_1.length;
                        days.push(day);
                    }
                };
                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(end, start) + 1; i++) {
                    _loop_2(i);
                }
                var totalDaysVisibleInWeek = DAYS_IN_WEEK - excluded.length;
                var rows = Math.floor(days.length / totalDaysVisibleInWeek);
                var rowOffsets = [];
                for (var i = 0; i < rows; i++) {
                    rowOffsets.push(i * totalDaysVisibleInWeek);
                }
                return {
                    rowOffsets: rowOffsets,
                    totalDaysVisibleInWeek: totalDaysVisibleInWeek,
                    days: days
                };
            }
            function getDayView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd, eventWidth = _a.eventWidth, segmentHeight = _a.segmentHeight;
                if (!events) {
                    events = [];
                }
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var previousDayEvents = [];
                var dayViewEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return !event.allDay; }),
                    periodStart: startOfView,
                    periodEnd: endOfView
                }).sort(function (eventA, eventB) {
                    return eventA.start.valueOf() - eventB.start.valueOf();
                }).map(function (event) {
                    var eventStart = event.start;
                    var eventEnd = event.end || eventStart;
                    var startsBeforeDay = eventStart < startOfView;
                    var endsAfterDay = eventEnd > endOfView;
                    var hourHeightModifier = (hourSegments * segmentHeight) / MINUTES_IN_HOUR;
                    var top = 0;
                    if (eventStart > startOfView) {
                        top += __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(eventStart, startOfView);
                    }
                    top *= hourHeightModifier;
                    var startDate = startsBeforeDay ? startOfView : eventStart;
                    var endDate = endsAfterDay ? endOfView : eventEnd;
                    var height = __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(endDate, startDate);
                    if (!event.end) {
                        height = segmentHeight;
                    }
                    else {
                        height *= hourHeightModifier;
                    }
                    var bottom = top + height;
                    var overlappingPreviousEvents = previousDayEvents.filter(function (previousEvent) {
                        var previousEventTop = previousEvent.top;
                        var previousEventBottom = previousEvent.top + previousEvent.height;
                        if (top < previousEventBottom && previousEventBottom < bottom) {
                            return true;
                        }
                        else if (previousEventTop <= top && bottom <= previousEventBottom) {
                            return true;
                        }
                        return false;
                    });
                    var left = 0;
                    while (overlappingPreviousEvents.some(function (previousEvent) { return previousEvent.left === left; })) {
                        left += eventWidth;
                    }
                    var dayEvent = {
                        event: event,
                        height: height,
                        width: eventWidth,
                        top: top,
                        left: left,
                        startsBeforeDay: startsBeforeDay,
                        endsAfterDay: endsAfterDay
                    };
                    if (height > 0) {
                        previousDayEvents.push(dayEvent);
                    }
                    return dayEvent;
                }).filter(function (dayEvent) { return dayEvent.height > 0; });
                var width = Math.max.apply(Math, dayViewEvents.map(function (event) { return event.left + event.width; }));
                var allDayEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return event.allDay; }),
                    periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startOfView),
                    periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(endOfView)
                });
                return {
                    events: dayViewEvents,
                    width: width,
                    allDayEvents: allDayEvents
                };
            }
            function getDayViewHourGrid(_a) {
                var viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd;
                var hours = [];
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var segmentDuration = MINUTES_IN_HOUR / hourSegments;
                var startOfViewDay = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate);
                for (var i = 0; i < HOURS_IN_DAY; i++) {
                    var segments = [];
                    for (var j = 0; j < hourSegments; j++) {
                        var date = __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(startOfViewDay, i), j * segmentDuration);
                        if (date >= startOfView && date < endOfView) {
                            segments.push({
                                date: date,
                                isStart: j === 0
                            });
                        }
                    }
                    if (segments.length > 0) {
                        hours.push({ segments: segments });
                    }
                }
                return hours;
            }
            //# sourceMappingURL=calendarUtils.js.map

            /***/
        }),
    /* 5 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Get the number of milliseconds between the given dates.
             *
             * @description
             * Get the number of milliseconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of milliseconds
             *
             * @example
             * // How many milliseconds are between
             * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
             * var result = differenceInMilliseconds(
             *   new Date(2014, 6, 2, 12, 30, 21, 700),
             *   new Date(2014, 6, 2, 12, 30, 20, 600)
             * )
             * //=> 1100
             */
            function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getTime() - dateRight.getTime()
            }

            module.exports = differenceInMilliseconds


            /***/
        }),
    /* 6 */
    /***/ (function (module, exports) {

            // removed by extract-text-webpack-plugin

            /***/
        }),
    /* 7 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./mwlCalendar.js": 45,
                "./mwlCalendarDay.js": 46,
                "./mwlCalendarHourList.js": 47,
                "./mwlCalendarMonth.js": 48,
                "./mwlCalendarSlideBox.js": 49,
                "./mwlCalendarWeek.js": 50,
                "./mwlCalendarYear.js": 51,
                "./mwlCollapseFallback.js": 52,
                "./mwlDateModifier.js": 53,
                "./mwlDragSelect.js": 54,
                "./mwlDraggable.js": 55,
                "./mwlDroppable.js": 56,
                "./mwlDynamicDirectiveTemplate.js": 57,
                "./mwlElementDimensions.js": 58,
                "./mwlResizable.js": 59
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 7;

            /***/
        }),
    /* 8 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarDate.js": 61,
                "./calendarLimitTo.js": 62,
                "./calendarTruncateEventTitle.js": 63,
                "./calendarTrustAsHtml.js": 64
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 8;

            /***/
        }),
    /* 9 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarConfig.js": 65,
                "./calendarEventTitle.js": 66,
                "./calendarHelper.js": 67,
                "./calendarTitle.js": 68,
                "./interact.js": 69,
                "./moment.js": 70
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 9;

            /***/
        }),
    /* 10 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendar.html": 36,
                "./calendarDayView.html": 37,
                "./calendarHourList.html": 38,
                "./calendarMonthCell.html": 39,
                "./calendarMonthCellEvents.html": 40,
                "./calendarMonthView.html": 41,
                "./calendarSlideBox.html": 42,
                "./calendarWeekView.html": 43,
                "./calendarYearView.html": 44
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 10;

            /***/
        }),
    /* 11 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Add the specified number of days to the given date.
             *
             * @description
             * Add the specified number of days to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of days to be added
             * @returns {Date} the new date with the days added
             *
             * @example
             * // Add 10 days to 1 September 2014:
             * var result = addDays(new Date(2014, 8, 1), 10)
             * //=> Thu Sep 11 2014 00:00:00
             */
            function addDays(dirtyDate, dirtyAmount) {
                var date = parse(dirtyDate)
                var amount = Number(dirtyAmount)
                date.setDate(date.getDate() + amount)
                return date
            }

            module.exports = addDays


            /***/
        }),
    /* 12 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_HOUR = 3600000

            /**
             * @category Hour Helpers
             * @summary Add the specified number of hours to the given date.
             *
             * @description
             * Add the specified number of hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of hours to be added
             * @returns {Date} the new date with the hours added
             *
             * @example
             * // Add 2 hours to 10 July 2014 23:00:00:
             * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
             * //=> Fri Jul 11 2014 01:00:00
             */
            function addHours(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
            }

            module.exports = addHours


            /***/
        }),
    /* 13 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Add the specified number of minutes to the given date.
             *
             * @description
             * Add the specified number of minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of minutes to be added
             * @returns {Date} the new date with the minutes added
             *
             * @example
             * // Add 30 minutes to 10 July 2014 12:00:00:
             * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
             * //=> Thu Jul 10 2014 12:30:00
             */
            function addMinutes(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
            }

            module.exports = addMinutes


            /***/
        }),
    /* 14 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            /**
             * @category Second Helpers
             * @summary Add the specified number of seconds to the given date.
             *
             * @description
             * Add the specified number of seconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of seconds to be added
             * @returns {Date} the new date with the seconds added
             *
             * @example
             * // Add 30 seconds to 10 July 2014 12:45:00:
             * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
             * //=> Thu Jul 10 2014 12:45:30
             */
            function addSeconds(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * 1000)
            }

            module.exports = addSeconds


            /***/
        }),
    /* 15 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Compare the two dates and return -1, 0 or 1.
             *
             * @description
             * Compare the two dates and return 1 if the first date is after the second,
             * -1 if the first date is before the second or 0 if dates are equal.
             *
             * @param {Date|String|Number} dateLeft - the first date to compare
             * @param {Date|String|Number} dateRight - the second date to compare
             * @returns {Number} the result of the comparison
             *
             * @example
             * // Compare 11 February 1987 and 10 July 1989:
             * var result = compareAsc(
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * )
             * //=> -1
             *
             * @example
             * // Sort the array of dates:
             * var result = [
             *   new Date(1995, 6, 2),
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * ].sort(compareAsc)
             * //=> [
             * //   Wed Feb 11 1987 00:00:00,
             * //   Mon Jul 10 1989 00:00:00,
             * //   Sun Jul 02 1995 00:00:00
             * // ]
             */
            function compareAsc(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var timeLeft = dateLeft.getTime()
                var dateRight = parse(dirtyDateRight)
                var timeRight = dateRight.getTime()

                if (timeLeft < timeRight) {
                    return -1
                } else if (timeLeft > timeRight) {
                    return 1
                } else {
                    return 0
                }
            }

            module.exports = compareAsc


            /***/
        }),
    /* 16 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            var MILLISECONDS_IN_MINUTE = 60000
            var MILLISECONDS_IN_DAY = 86400000

            /**
             * @category Day Helpers
             * @summary Get the number of calendar days between the given dates.
             *
             * @description
             * Get the number of calendar days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar days
             *
             * @example
             * // How many calendar days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInCalendarDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 366
             */
            function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
                var startOfDayLeft = startOfDay(dirtyDateLeft)
                var startOfDayRight = startOfDay(dirtyDateRight)

                var timestampLeft = startOfDayLeft.getTime() -
                    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
                var timestampRight = startOfDayRight.getTime() -
                    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

                // Round the number of days to the nearest integer
                // because the number of milliseconds in a day is not constant
                // (e.g. it's different in the day of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
            }

            module.exports = differenceInCalendarDays


            /***/
        }),
    /* 17 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)
            var differenceInCalendarDays = __webpack_require__(16)
            var compareAsc = __webpack_require__(15)

            /**
             * @category Day Helpers
             * @summary Get the number of full days between the given dates.
             *
             * @description
             * Get the number of full days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of full days
             *
             * @example
             * // How many full days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 365
             */
            function differenceInDays(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)

                var sign = compareAsc(dateLeft, dateRight)
                var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
                dateLeft.setDate(dateLeft.getDate() - sign * difference)

                // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
                return sign * (difference - isLastDayNotFull)
            }

            module.exports = differenceInDays


            /***/
        }),
    /* 18 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Get the number of minutes between the given dates.
             *
             * @description
             * Get the number of minutes between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of minutes
             *
             * @example
             * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
             * var result = differenceInMinutes(
             *   new Date(2014, 6, 2, 12, 20, 0),
             *   new Date(2014, 6, 2, 12, 7, 59)
             * )
             * //=> 12
             */
            function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInMinutes


            /***/
        }),
    /* 19 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            /**
             * @category Second Helpers
             * @summary Get the number of seconds between the given dates.
             *
             * @description
             * Get the number of seconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of seconds
             *
             * @example
             * // How many seconds are between
             * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
             * var result = differenceInSeconds(
             *   new Date(2014, 6, 2, 12, 30, 20, 0),
             *   new Date(2014, 6, 2, 12, 30, 7, 999)
             * )
             * //=> 12
             */
            function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInSeconds


            /***/
        }),
    /* 20 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the end of a day for the given date.
             *
             * @description
             * Return the end of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a day
             *
             * @example
             * // The end of a day for 2 September 2014 11:55:00:
             * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 23:59:59.999
             */
            function endOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfDay


            /***/
        }),
    /* 21 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the end of a month for the given date.
             *
             * @description
             * Return the end of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a month
             *
             * @example
             * // The end of a month for 2 September 2014 11:55:00:
             * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 23:59:59.999
             */
            function endOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                var month = date.getMonth()
                date.setFullYear(date.getFullYear(), month + 1, 0)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfMonth


            /***/
        }),
    /* 22 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the end of a week for the given date.
             *
             * @description
             * Return the end of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the end of a week
             *
             * @example
             * // The end of a week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sat Sep 06 2014 23:59:59.999
             *
             * @example
             * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Sun Sep 07 2014 23:59:59.999
             */
            function endOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

                date.setDate(date.getDate() + diff)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfWeek


            /***/
        }),
    /* 23 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Weekday Helpers
             * @summary Get the day of the week of the given date.
             *
             * @description
             * Get the day of the week of the given date.
             *
             * @param {Date|String|Number} date - the given date
             * @returns {Number} the day of week
             *
             * @example
             * // Which day of the week is 29 February 2012?
             * var result = getDay(new Date(2012, 1, 29))
             * //=> 3
             */
            function getDay(dirtyDate) {
                var date = parse(dirtyDate)
                var day = date.getDay()
                return day
            }

            module.exports = getDay


            /***/
        }),
    /* 24 */
    /***/ (function (module, exports) {

            /**
             * @category Common Helpers
             * @summary Is the given argument an instance of Date?
             *
             * @description
             * Is the given argument an instance of Date?
             *
             * @param {*} argument - the argument to check
             * @returns {Boolean} the given argument is an instance of Date
             *
             * @example
             * // Is 'mayonnaise' a Date?
             * var result = isDate('mayonnaise')
             * //=> false
             */
            function isDate(argument) {
                return argument instanceof Date
            }

            module.exports = isDate


            /***/
        }),
    /* 25 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            /**
             * @category Day Helpers
             * @summary Are the given dates in the same day?
             *
             * @description
             * Are the given dates in the same day?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same day
             *
             * @example
             * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
             * var result = isSameDay(
             *   new Date(2014, 8, 4, 6, 0),
             *   new Date(2014, 8, 4, 18, 0)
             * )
             * //=> true
             */
            function isSameDay(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
                var dateRightStartOfDay = startOfDay(dirtyDateRight)

                return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
            }

            module.exports = isSameDay


            /***/
        }),
    /* 26 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Are the given dates in the same month?
             *
             * @description
             * Are the given dates in the same month?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same month
             *
             * @example
             * // Are 2 September 2014 and 25 September 2014 in the same month?
             * var result = isSameMonth(
             *   new Date(2014, 8, 2),
             *   new Date(2014, 8, 25)
             * )
             * //=> true
             */
            function isSameMonth(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getFullYear() === dateRight.getFullYear() &&
                    dateLeft.getMonth() === dateRight.getMonth()
            }

            module.exports = isSameMonth


            /***/
        }),
    /* 27 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfSecond = __webpack_require__(34)

            /**
             * @category Second Helpers
             * @summary Are the given dates in the same second?
             *
             * @description
             * Are the given dates in the same second?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same second
             *
             * @example
             * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
             * // in the same second?
             * var result = isSameSecond(
             *   new Date(2014, 8, 4, 6, 30, 15),
             *   new Date(2014, 8, 4, 6, 30, 15, 500)
             * )
             * //=> true
             */
            function isSameSecond(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
                var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

                return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
            }

            module.exports = isSameSecond


            /***/
        }),
    /* 28 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the latest of the given dates.
             *
             * @description
             * Return the latest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the latest of the dates
             *
             * @example
             * // Which of these dates is the latest?
             * var result = max(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Sun Jul 02 1995 00:00:00
             */
            function max() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var latestTimestamp = Math.max.apply(null, dates)
                return new Date(latestTimestamp)
            }

            module.exports = max


            /***/
        }),
    /* 29 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the earliest of the given dates.
             *
             * @description
             * Return the earliest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the earliest of the dates
             *
             * @example
             * // Which of these dates is the earliest?
             * var result = min(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Wed Feb 11 1987 00:00:00
             */
            function min() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var earliestTimestamp = Math.min.apply(null, dates)
                return new Date(earliestTimestamp)
            }

            module.exports = min


            /***/
        }),
    /* 30 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Hour Helpers
             * @summary Set the hours to the given date.
             *
             * @description
             * Set the hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} hours - the hours of the new date
             * @returns {Date} the new date with the hours setted
             *
             * @example
             * // Set 4 hours to 1 September 2014 11:30:00:
             * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
             * //=> Mon Sep 01 2014 04:30:00
             */
            function setHours(dirtyDate, dirtyHours) {
                var date = parse(dirtyDate)
                var hours = Number(dirtyHours)
                date.setHours(hours)
                return date
            }

            module.exports = setHours


            /***/
        }),
    /* 31 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Set the minutes to the given date.
             *
             * @description
             * Set the minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} minutes - the minutes of the new date
             * @returns {Date} the new date with the minutes setted
             *
             * @example
             * // Set 45 minutes to 1 September 2014 11:30:40:
             * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
             * //=> Mon Sep 01 2014 11:45:40
             */
            function setMinutes(dirtyDate, dirtyMinutes) {
                var date = parse(dirtyDate)
                var minutes = Number(dirtyMinutes)
                date.setMinutes(minutes)
                return date
            }

            module.exports = setMinutes


            /***/
        }),
    /* 32 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Return the start of a minute for the given date.
             *
             * @description
             * Return the start of a minute for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a minute
             *
             * @example
             * // The start of a minute for 1 December 2014 22:15:45.400:
             * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:00
             */
            function startOfMinute(dirtyDate) {
                var date = parse(dirtyDate)
                date.setSeconds(0, 0)
                return date
            }

            module.exports = startOfMinute


            /***/
        }),
    /* 33 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the start of a month for the given date.
             *
             * @description
             * Return the start of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a month
             *
             * @example
             * // The start of a month for 2 September 2014 11:55:00:
             * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                date.setDate(1)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfMonth


            /***/
        }),
    /* 34 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Second Helpers
             * @summary Return the start of a second for the given date.
             *
             * @description
             * Return the start of a second for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a second
             *
             * @example
             * // The start of a second for 1 December 2014 22:15:45.400:
             * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:45.000
             */
            function startOfSecond(dirtyDate) {
                var date = parse(dirtyDate)
                date.setMilliseconds(0)
                return date
            }

            module.exports = startOfSecond


            /***/
        }),
    /* 35 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the start of a week for the given date.
             *
             * @description
             * Return the start of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the start of a week
             *
             * @example
             * // The start of a week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Aug 31 2014 00:00:00
             *
             * @example
             * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

                date.setDate(date.getDate() - diff)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfWeek


            /***/
        }),
    /* 36 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  class=\"cal-context\"\n  ng-switch=\"vm.view\"\n  ng-if=\"vm.templatesLoaded\">\n\n  <div class=\"alert alert-danger\" ng-switch-default>The value passed to the view attribute of the calendar is not set</div>\n\n  <div class=\"alert alert-danger\" ng-hide=\"vm.viewDate\">The value passed to view-date attribute of the calendar is not set</div>\n\n  <mwl-calendar-year\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    ng-switch-when=\"year\">\n  </mwl-calendar-year>\n\n  <mwl-calendar-month\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"month\">\n  </mwl-calendar-month>\n\n  <mwl-calendar-week\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"week\">\n  </mwl-calendar-week>\n\n  <mwl-calendar-day\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    day-view-event-width=\"vm.dayViewEventWidth\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    day-view-time-position=\"vm.dayViewTimePosition || 'default'\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-class=\"{\n      'time-on-side' : vm.dayViewTimePosition === 'side',\n      'time-hidden' : vm.dayViewTimePosition === 'hidden'\n    }\"\n    ng-switch-when=\"day\">\n  </mwl-calendar-day>\n</div>\n";

            /***/
        }),
    /* 37 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box cal-all-day-events-box\" ng-if=\"vm.allDayEvents.length > 0\">\n  <div class=\"cal-day-panel clearfix\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            class=\"cal-cell-6 day-highlight\"\n            ng-style=\"{backgroundColor: event.color.secondary}\"\n            data-event-class\n            ng-repeat=\"event in vm.allDayEvents track by event.calendarEventId\">\n            <strong>\n              <span ng-bind=\"event.startsAt | calendarDate:'datetime':true\"></span>\n              <span ng-if=\"event.endsAt\">\n                - <span ng-bind=\"event.endsAt | calendarDate:'datetime':true\"></span>\n              </span>\n            </strong>\n            <a\n              href=\"javascript:;\"\n              class=\"event-item\"\n              ng-bind-html=\"vm.calendarEventTitle.dayView(event) | calendarTrustAsHtml\">\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"cal-day-box\">\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.dayViewHeight + 'px', minWidth: vm.viewWidth + 'px'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      on-event-times-changed=\"vm.onEventTimesChanged\"\n      view-date=\"vm.viewDate\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      cell-modifier=\"vm.cellModifier\"\n      view=\"day\">\n    </mwl-calendar-hour-list>\n\n    <div\n      class=\"pull-left day-event day-highlight\"\n      ng-repeat=\"dayEvent in vm.nonAllDayEvents track by dayEvent.event.calendarEventId\"\n      ng-class=\"dayEvent.event.cssClass\"\n      ng-style=\"{\n        top: dayEvent.top - 1 + 'px',\n        left: dayEvent.left +  vm.dayViewTimePositionOffset + 'px',\n        height: dayEvent.height + 'px',\n        width: dayEvent.width + 'px',\n        backgroundColor: dayEvent.event.color.secondary,\n        borderColor: dayEvent.event.color.primary\n      }\"\n      mwl-draggable=\"dayEvent.event.draggable === true\"\n      axis=\"'xy'\"\n      snap-grid=\"{y: vm.dayViewEventChunkSize || 30, x: 50}\"\n      on-drag=\"vm.eventDragged(dayEvent.event, y / 30)\"\n      on-drag-end=\"vm.eventDragComplete(dayEvent.event, y / 30)\"\n      auto-scroll=\"vm.draggableAutoScroll\"\n      mwl-resizable=\"dayEvent.event.resizable === true && dayEvent.event.endsAt\"\n      resize-edges=\"{top: true, bottom: true}\"\n      on-resize=\"vm.eventResized(dayEvent.event, edge, y / 30)\"\n      on-resize-end=\"vm.eventResizeComplete(dayEvent.event, edge, y / 30)\"\n      uib-tooltip-html=\"vm.calendarEventTitle.dayViewTooltip(dayEvent.event) | calendarTrustAsHtml\"\n      tooltip-append-to-body=\"true\">\n\n      <span class=\"cal-hours\">\n        <span ng-show=\"dayEvent.top == 0\"><span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'day':true\"></span>, </span>\n        <span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'time':true\"></span>\n      </span>\n      <a\n        href=\"javascript:;\"\n        class=\"event-item\"\n        ng-click=\"vm.onEventClick({calendarEvent: dayEvent.event})\">\n        <span ng-bind-html=\"vm.calendarEventTitle.dayView(dayEvent.event) | calendarTrustAsHtml\"></span>\n      </a>\n\n      <a\n        href=\"javascript:;\"\n        class=\"event-item-action\"\n        ng-repeat=\"action in dayEvent.event.actions track by $index\"\n        ng-class=\"action.cssClass\"\n        ng-bind-html=\"action.label | calendarTrustAsHtml\"\n        ng-click=\"action.onClick({calendarEvent: dayEvent.event})\">\n      </a>\n\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 38 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-day-panel-hour\">\n\n  <div class=\"cal-day-hour\" ng-repeat=\"hour in vm.hourGrid track by $index\">\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= segment.date &&\n                segment.date < vm.dateRangeSelect.endDate }, segment.cssClass]\"\n      ng-click=\"vm.onTimespanClick({calendarDate: segment.date})\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, segment.date)\"\n      mwl-drag-select=\"!!vm.onDateRangeSelect\"\n      on-drag-select-start=\"vm.onDragSelectStart(segment.date)\"\n      on-drag-select-move=\"vm.onDragSelectMove(segment.nextSegmentDate)\"\n      on-drag-select-end=\"vm.onDragSelectEnd(segment.nextSegmentDate)\"\n      ng-if=\"!vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n      </div>\n    </div>\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-if=\"vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n        &nbsp;\n      </div>\n      <div\n        class=\"cal-day-hour-part-spacer\"\n        ng-repeat=\"day in segment.days track by $index\"\n        ng-style=\"{width: (vm.dayWidth - ($last ? vm.scrollBarWidth : 0)) + 'px'}\"\n        ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= day.date &&\n                day.date < vm.dateRangeSelect.endDate }, day.cssClass]\"\n        ng-click=\"vm.onTimespanClick({calendarDate: day.date})\"\n        mwl-droppable\n        on-drop=\"vm.eventDropped(dropData.event, day.date)\"\n        mwl-drag-select=\"!!vm.onDateRangeSelect\"\n        on-drag-select-start=\"vm.onDragSelectStart(day.date)\"\n        on-drag-select-move=\"vm.onDragSelectMove(day.nextSegmentDate)\"\n        on-drag-select-end=\"vm.onDragSelectEnd(day.nextSegmentDate)\">\n      </div>\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 39 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  mwl-droppable\n  on-drop=\"vm.handleEventDrop(dropData.event, day.date, dropData.draggedFromDate)\"\n  mwl-drag-select=\"!!vm.onDateRangeSelect\"\n  on-drag-select-start=\"vm.onDragSelectStart(day)\"\n  on-drag-select-move=\"vm.onDragSelectMove(day)\"\n  on-drag-select-end=\"vm.onDragSelectEnd(day)\"\n  class=\"cal-month-day {{ day.cssClass }}\"\n  ng-class=\"{\n    'cal-day-outmonth': !day.inMonth,\n    'cal-day-inmonth': day.inMonth,\n    'cal-day-weekend': day.isWeekend,\n    'cal-day-past': day.isPast,\n    'cal-day-today': day.isToday,\n    'cal-day-future': day.isFuture,\n    'cal-day-selected': vm.dateRangeSelect && vm.dateRangeSelect.startDate <= day.date && day.date <= vm.dateRangeSelect.endDate,\n    'cal-day-open': dayIndex === vm.openDayIndex\n  }\">\n\n  <small\n    class=\"cal-events-num badge badge-important pull-left\"\n    ng-show=\"day.badgeTotal > 0 && (vm.calendarConfig.displayAllMonthEvents || day.inMonth)\"\n    ng-bind=\"day.badgeTotal\">\n  </small>\n\n  <span\n    class=\"pull-right\"\n    data-cal-date\n    ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n    ng-bind=\"day.label\">\n  </span>\n\n  <div class=\"cal-day-tick\" ng-show=\"dayIndex === vm.openDayIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\">\n    <i class=\"glyphicon glyphicon-chevron-up\"></i>\n    <i class=\"fa fa-chevron-up\"></i>\n  </div>\n\n  <ng-include src=\"vm.customTemplateUrls.calendarMonthCellEvents || vm.calendarConfig.templates.calendarMonthCellEvents\"></ng-include>\n\n  <div id=\"cal-week-box\" ng-if=\"$first && rowHovered\">\n    <span ng-bind=\"vm.getWeekNumberLabel(day)\"></span>\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 40 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"events-list\" ng-show=\"day.events.length > 0\">\n  <a\n    ng-repeat=\"event in day.events | orderBy:'startsAt' track by event.calendarEventId\"\n    href=\"javascript:;\"\n    ng-click=\"$event.stopPropagation(); vm.onEventClick({calendarEvent: event})\"\n    class=\"pull-left event\"\n    ng-class=\"event.cssClass\"\n    ng-style=\"{backgroundColor: event.color.primary}\"\n    ng-mousedown=\"$event.stopPropagation()\"\n    ng-mouseenter=\"vm.highlightEvent(event, true)\"\n    ng-mouseleave=\"vm.highlightEvent(event, false)\"\n    tooltip-append-to-body=\"true\"\n    uib-tooltip-html=\"vm.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml\"\n    mwl-draggable=\"event.draggable === true\"\n    drop-data=\"{event: event, draggedFromDate: day.date.toDate()}\"\n    auto-scroll=\"vm.draggableAutoScroll\">\n  </a>\n</div>\n";

            /***/
        }),
    /* 41 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-row-fluid cal-row-head\">\n\n  <div class=\"cal-cell1\" ng-repeat=\"day in vm.weekDays track by $index\" ng-bind=\"day\"></div>\n\n</div>\n<div class=\"cal-month-box\">\n\n  <div\n    ng-repeat=\"rowOffset in vm.monthOffsets track by rowOffset\"\n    ng-mouseenter=\"rowHovered = true\"\n    ng-mouseleave=\"rowHovered = false\">\n    <div class=\"cal-row-fluid cal-before-eventlist\">\n      <div\n        ng-repeat=\"day in vm.view | calendarLimitTo:7:rowOffset track by $index\"\n        ng-init=\"dayIndex = vm.view.indexOf(day)\"\n        class=\"cal-cell1 cal-cell {{ day.highlightClass }}\"\n        ng-style=\"{backgroundColor: day.backgroundColor}\"\n        ng-click=\"vm.dayClicked(day, false, $event)\"\n        ng-class=\"{pointer: day.events.length > 0}\">\n        <ng-include src=\"vm.customTemplateUrls.calendarMonthCell || vm.calendarConfig.templates.calendarMonthCell\"></ng-include>\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openDayIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openDayIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      draggable-auto-scroll=\"vm.draggableAutoScroll\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 42 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-slide-box\" uib-collapse=\"vm.isCollapsed\" mwl-collapse-fallback=\"vm.isCollapsed\">\n  <div class=\"cal-slide-content cal-event-list\">\n    <ul class=\"unstyled list-unstyled\">\n\n      <li\n        ng-repeat=\"event in vm.events | orderBy:'startsAt' track by event.calendarEventId\"\n        ng-class=\"event.cssClass\"\n        ng-mousedown=\"$event.stopPropagation()\"\n        mwl-draggable=\"event.draggable === true\"\n        drop-data=\"{event: event}\"\n        auto-scroll=\"vm.draggableAutoScroll\">\n        <span class=\"pull-left event\" ng-style=\"{backgroundColor: event.color.primary}\"></span>\n        &nbsp;\n        <a\n          href=\"javascript:;\"\n          class=\"event-item\"\n          ng-click=\"vm.onEventClick({calendarEvent: event})\">\n          <span ng-bind-html=\"isMonthView ? vm.calendarEventTitle.monthView(day.date) : vm.calendarEventTitle.yearView(day.date) | calendarTrustAsHtml\"></span>\n        </a>\n\n        <a\n          href=\"javascript:;\"\n          class=\"event-item-action\"\n          ng-class=\"action.cssClass\"\n          ng-repeat=\"action in event.actions track by $index\"\n          ng-bind-html=\"action.label | calendarTrustAsHtml\"\n          ng-click=\"action.onClick({calendarEvent: event})\">\n        </a>\n\n      </li>\n\n    </ul>\n  </div>\n</div>\n";

            /***/
        }),
    /* 43 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box\" ng-class=\"{'cal-day-box': vm.showTimes}\">\n  <div class=\"cal-row-fluid cal-row-head\">\n\n    <div\n      class=\"cal-cell1\"\n      ng-repeat=\"day in vm.view.days track by $index\"\n      ng-class=\"{\n        'cal-day-weekend': day.isWeekend,\n        'cal-day-past': day.isPast,\n        'cal-day-today': day.isToday,\n        'cal-day-future': day.isFuture}\"\n      mwl-element-dimensions=\"vm.dayColumnDimensions\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, day.date)\">\n\n      <span ng-bind=\"day.weekDayLabel\"></span>\n      <br>\n      <small>\n        <span\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n          class=\"pointer\"\n          ng-bind=\"day.dayLabel\">\n        </span>\n      </small>\n\n    </div>\n\n  </div>\n\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.showTimes ? (vm.dayViewHeight + 'px') : 'auto'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      day-width=\"vm.dayColumnDimensions.width\"\n      view-date=\"vm.viewDate\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      cell-modifier=\"vm.cellModifier\"\n      template-scope=\"vm.templateScope\"\n      view=\"week\"\n      ng-if=\"vm.showTimes\">\n    </mwl-calendar-hour-list>\n\n    <div class=\"row\" ng-repeat=\"row in vm.view.eventRows track by $index\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\"\n            ng-class=\"'cal-cell' + (vm.showTimes ? 1 : eventRow.span) + (vm.showTimes ? '' : ' cal-offset' + eventRow.offset)\"\n            ng-style=\"{\n              top: vm.showTimes ? ((eventRow.top) + 'px') : 'auto',\n              position: vm.showTimes ? 'absolute' : 'inherit',\n              width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\n              left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 15 + 'px' : ''\n            }\">\n            <div\n              class=\"day-highlight\"\n              ng-class=\"[eventRow.event.cssClass, !vm.showTimes && eventRow.startsBeforeWeek ? '' : 'border-left-rounded', !vm.showTimes && eventRow.endsAfterWeek ? '' : 'border-right-rounded']\"\n              ng-style=\"{backgroundColor: eventRow.event.color.secondary}\"\n              data-event-class\n              mwl-draggable=\"eventRow.event.draggable === true\"\n              axis=\"vm.showTimes ? 'xy' : 'x'\"\n              snap-grid=\"vm.showTimes ? {x: vm.dayColumnDimensions.width, y: vm.dayViewEventChunkSize || 30} : {x: vm.dayColumnDimensions.width}\"\n              auto-scroll=\"vm.draggableAutoScroll\"\n              on-drag=\"vm.tempTimeChanged(eventRow.event, y / 30)\"\n              on-drag-end=\"vm.weekDragged(eventRow.event, x / vm.dayColumnDimensions.width, y / 30)\"\n              mwl-resizable=\"eventRow.event.resizable === true && eventRow.event.endsAt && !vm.showTimes\"\n              resize-edges=\"{left: true, right: true}\"\n              on-resize-end=\"vm.weekResized(eventRow.event, edge, x / vm.dayColumnDimensions.width)\">\n              <strong ng-bind=\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:'time':true\" ng-show=\"vm.showTimes\"></strong>\n              <a\n                href=\"javascript:;\"\n                ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\"\n                class=\"event-item\"\n                ng-bind-html=\"vm.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\"\n                uib-tooltip-html=\"vm.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml\"\n                tooltip-placement=\"left\"\n                tooltip-append-to-body=\"true\">\n              </a>\n              <a\n                href=\"javascript:;\"\n                class=\"event-item-action\"\n                ng-class=\"action.cssClass\"\n                ng-repeat=\"action in eventRow.event.actions track by $index\"\n                ng-bind-html=\"action.label | calendarTrustAsHtml\"\n                ng-click=\"action.onClick({calendarEvent: eventRow.event})\">\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n";

            /***/
        }),
    /* 44 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-year-box\">\n  <div ng-repeat=\"rowOffset in [0, 4, 8] track by rowOffset\">\n    <div class=\"row cal-before-eventlist\">\n      <div\n        class=\"span3 col-md-3 col-xs-6 cal-cell {{ day.cssClass }}\"\n        ng-repeat=\"month in vm.view | calendarLimitTo:4:rowOffset track by $index\"\n        ng-init=\"monthIndex = vm.view.indexOf(month)\"\n        ng-click=\"vm.monthClicked(month, false, $event)\"\n        ng-class=\"{pointer: month.events.length > 0, 'cal-day-today': month.isToday}\"\n        mwl-droppable\n        on-drop=\"vm.handleEventDrop(dropData.event, month.date)\">\n\n        <span\n          class=\"pull-right\"\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(month.date)\"\n          ng-bind=\"month.label\">\n        </span>\n\n        <small\n          class=\"cal-events-num badge badge-important pull-left\"\n          ng-show=\"month.badgeTotal > 0\"\n          ng-bind=\"month.badgeTotal\">\n        </small>\n\n        <div\n          class=\"cal-day-tick\"\n          ng-show=\"monthIndex === vm.openMonthIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\">\n          <i class=\"glyphicon glyphicon-chevron-up\"></i>\n          <i class=\"fa fa-chevron-up\"></i>\n        </div>\n\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openMonthIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openMonthIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 45 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var LOG_PREFIX = 'Bootstrap calendar:';

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarCtrl', ["$scope", "$log", "$timeout", "$attrs", "$locale", "moment", "calendarTitle", "calendarHelper", function ($scope, $log, $timeout, $attrs, $locale, moment, calendarTitle, calendarHelper) {

                    var vm = this;

                    vm.changeView = function (view, newDay) {
                        vm.view = view;
                        vm.viewDate = newDay;
                    };

                    vm.dateClicked = function (date) {

                        var rawDate = moment(date).toDate();

                        var nextView = {
                            year: 'month',
                            month: 'day',
                            week: 'day'
                        };

                        if (vm.onViewChangeClick({ calendarDate: rawDate, calendarNextView: nextView[vm.view] }) !== false) {
                            vm.changeView(nextView[vm.view], rawDate);
                        }

                    };

                    vm.$onInit = function () {

                        if (vm.slideBoxDisabled) {
                            $log.warn(LOG_PREFIX, 'The `slide-box-disabled` option is deprecated and will be removed in the next release. ' +
                                'Instead set `cell-auto-open-disabled` to true');
                        }

                        vm.events = vm.events || [];

                        var previousDate = moment(vm.viewDate);
                        var previousView = vm.view;

                        function checkEventIsValid(event) {
                            if (!event.startsAt) {
                                $log.warn(LOG_PREFIX, 'Event is missing the startsAt field', event);
                            } else if (!angular.isDate(event.startsAt)) {
                                $log.warn(LOG_PREFIX, 'Event startsAt should be a javascript date object. Do `new Date(event.startsAt)` to fix it.', event);
                            }

                            if (event.endsAt) {
                                if (!angular.isDate(event.endsAt)) {
                                    $log.warn(LOG_PREFIX, 'Event endsAt should be a javascript date object. Do `new Date(event.endsAt)` to fix it.', event);
                                }
                                if (moment(event.startsAt).isAfter(moment(event.endsAt))) {
                                    $log.warn(LOG_PREFIX, 'Event cannot start after it finishes', event);
                                }
                            }
                        }

                        function refreshCalendar() {

                            if (calendarTitle[vm.view] && angular.isDefined($attrs.viewTitle)) {
                                vm.viewTitle = calendarTitle[vm.view](vm.viewDate);
                            }

                            vm.events.forEach(function (event, index) {
                                checkEventIsValid(event);
                                event.calendarEventId = index;
                            });

                            //if on-timespan-click="calendarDay = calendarDate" is set then don't update the view as nothing needs to change
                            var currentDate = moment(vm.viewDate);
                            var shouldUpdate = true;
                            if (
                                previousDate.clone().startOf(vm.view).isSame(currentDate.clone().startOf(vm.view)) &&
                                !previousDate.isSame(currentDate) &&
                                vm.view === previousView
                            ) {
                                shouldUpdate = false;
                            }
                            previousDate = currentDate;
                            previousView = vm.view;

                            if (shouldUpdate) {
                                // a $timeout is required as $broadcast is synchronous so if a new events array is set the calendar won't update
                                $timeout(function () {
                                    $scope.$broadcast('calendar.refreshView');
                                });
                            }
                        }

                        calendarHelper.loadTemplates().then(function () {
                            vm.templatesLoaded = true;

                            var eventsWatched = false;

                            //Refresh the calendar when any of these variables change.
                            $scope.$watchGroup([
                                'vm.viewDate',
                                'vm.view',
                                'vm.cellIsOpen',
                                function () {
                                    return moment.locale() + $locale.id; //Auto update the calendar when the locale changes
                                }
                            ], function () {
                                if (!eventsWatched) {
                                    eventsWatched = true;
                                    //need to deep watch events hence why it isn't included in the watch group
                                    $scope.$watch('vm.events', refreshCalendar, true); //this will call refreshCalendar when the watcher starts (i.e. now)
                                } else {
                                    refreshCalendar();
                                }
                            });

                        }).catch(function (err) {
                            $log.error('Could not load all calendar templates', err);
                        });

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendar', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendar" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        scope: {
                            events: '=',
                            view: '=',
                            viewTitle: '=?',
                            viewDate: '=',
                            cellIsOpen: '=?',
                            cellAutoOpenDisabled: '=?',
                            slideBoxDisabled: '=?',
                            customTemplateUrls: '=?',
                            draggableAutoScroll: '=?',
                            onEventClick: '&',
                            onEventTimesChanged: '&',
                            onTimespanClick: '&',
                            onDateRangeSelect: '&?',
                            onViewChangeClick: '&',
                            cellModifier: '&',
                            dayViewStart: '@',
                            dayViewEnd: '@',
                            dayViewSplit: '@',
                            dayViewEventChunkSize: '@',
                            dayViewEventWidth: '@',
                            templateScope: '=?',
                            dayViewTimePosition: '@'
                        },
                        controller: 'MwlCalendarCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 46 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarDayCtrl', ["$scope", "moment", "calendarHelper", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarEventTitle) {

                    var vm = this;

                    vm.calendarEventTitle = calendarEventTitle;

                    function refreshView() {

                        vm.timeHidden = vm.dayViewTimePosition === 'hidden';
                        vm.dayViewTimePositionOffset = vm.dayViewTimePosition !== 'default' ? 0 : 60;

                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );

                        var view = calendarHelper.getDayView(
                            vm.events,
                            vm.viewDate,
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit,
                            vm.dayViewEventWidth
                        );

                        vm.allDayEvents = view.allDayEvents;
                        vm.nonAllDayEvents = view.events;
                        vm.viewWidth = view.width + 62;

                    }

                    $scope.$on('calendar.refreshView', refreshView);

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit'
                    ], refreshView);

                    vm.eventDragComplete = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var newStart = moment(event.startsAt).add(minutesDiff, 'minutes');
                        var newEnd = moment(event.endsAt).add(minutesDiff, 'minutes');
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDragged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                    vm.eventResizeComplete = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(minutesDiff, 'minutes');
                        } else {
                            end.add(minutesDiff, 'minutes');
                        }
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });
                    };

                    vm.eventResized = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        if (edge === 'start') {
                            event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                        }
                    };

                }])
                .directive('mwlCalendarDay', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarDayView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            dayViewEventWidth: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            dayViewTimePosition: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarDayCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 47 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarHourListCtrl', ["$scope", "$document", "moment", "calendarHelper", function ($scope, $document, moment, calendarHelper) {
                    var vm = this;

                    // source: https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
                    function getScrollbarWidth() {
                        var outer = $document[0].createElement('div');
                        outer.style.visibility = 'hidden';
                        outer.style.width = '100px';
                        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

                        $document[0].body.appendChild(outer);

                        var widthNoScroll = outer.offsetWidth;
                        // force scrollbars
                        outer.style.overflow = 'scroll';

                        // add innerdiv
                        var inner = $document[0].createElement('div');
                        inner.style.width = '100%';
                        outer.appendChild(inner);

                        var widthWithScroll = inner.offsetWidth;

                        // remove divs
                        outer.parentNode.removeChild(outer);

                        return widthNoScroll - widthWithScroll;
                    }

                    vm.scrollBarWidth = getScrollbarWidth();

                    function updateDays() {

                        vm.dayViewSplit = parseInt(vm.dayViewSplit);
                        var dayStart = (vm.dayViewStart || '00:00').split(':');
                        var dayEnd = (vm.dayViewEnd || '23:59').split(':');
                        vm.hourGrid = calendarUtils.getDayViewHourGrid({
                            viewDate: vm.view === 'week' ? moment(vm.viewDate).startOf('week').toDate() : moment(vm.viewDate).toDate(),
                            hourSegments: 60 / vm.dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            }
                        });

                        vm.hourGrid.forEach(function (hour) {
                            hour.segments.forEach(function (segment) {

                                segment.date = moment(segment.date);
                                segment.nextSegmentDate = segment.date.clone().add(vm.dayViewSplit, 'minutes');

                                if (vm.view === 'week') {

                                    segment.days = [];

                                    for (var i = 0; i < 7; i++) {
                                        var day = {
                                            date: moment(segment.date).add(i, 'days')
                                        };
                                        day.nextSegmentDate = day.date.clone().add(vm.dayViewSplit, 'minutes');
                                        vm.cellModifier({ calendarCell: day });
                                        segment.days.push(day);
                                    }

                                } else {
                                    vm.cellModifier({ calendarCell: segment });
                                }

                            });
                        });

                    }

                    var originalLocale = moment.locale();

                    $scope.$on('calendar.refreshView', function () {

                        if (originalLocale !== moment.locale()) {
                            originalLocale = moment.locale();
                            updateDays();
                        }

                    });

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit',
                        'vm.viewDate'
                    ], function () {
                        updateDays();
                    });

                    vm.eventDropped = function (event, date) {
                        var newStart = moment(date);
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: date,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.onDragSelectStart = function (date, dayIndex) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                active: true,
                                startDate: date,
                                endDate: date,
                                dayIndex: dayIndex
                            };
                        }
                    };

                    vm.onDragSelectMove = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                        }
                    };

                    vm.onDragSelectEnd = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                }])
                .directive('mwlCalendarHourList', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarHourList" overrides="vm.customTemplateUrls"></div>',
                        controller: 'MwlCalendarHourListCtrl as vm',
                        scope: {
                            viewDate: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayWidth: '=?',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            onEventTimesChanged: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            view: '@'
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 48 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarMonthCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;
                    vm.openRowIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openDayIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (day, dayIndex) {
                                if (moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.openDayIndex = dayIndex;
                                    vm.openRowIndex = Math.floor(dayIndex / 7);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {

                        vm.weekDays = calendarHelper.getWeekDayNames();

                        var monthView = calendarHelper.getMonthView(vm.events, vm.viewDate, vm.cellModifier);
                        vm.view = monthView.days;
                        vm.monthOffsets = monthView.rowOffsets;

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openRowIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openDayIndex = null;
                            vm.view.forEach(function (day) {
                                if (day.inMonth && moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.dayClicked(day, true);
                                }
                            });
                        }

                    });

                    vm.dayClicked = function (day, dayClickedFirstRun, $event) {

                        if (!dayClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: day.date.toDate(),
                                calendarCell: day,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var dayIndex = vm.view.indexOf(day);
                            if (dayIndex === vm.openDayIndex) { //the day has been clicked and is already open
                                vm.openDayIndex = null; //close the open day
                                vm.cellIsOpen = false;
                            } else {
                                vm.openDayIndex = dayIndex;
                                vm.openRowIndex = Math.floor(dayIndex / 7);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.highlightEvent = function (event, shouldAddClass) {

                        vm.view.forEach(function (day) {
                            delete day.highlightClass;
                            delete day.backgroundColor;
                            if (shouldAddClass) {
                                var dayContainsEvent = day.events.indexOf(event) > -1;
                                if (dayContainsEvent) {
                                    day.backgroundColor = event.color ? event.color.secondary : '';
                                }
                            }
                        });

                    };

                    vm.handleEventDrop = function (event, newDayDate, draggedFromDate) {

                        var newStart = moment(event.startsAt)
                            .year(moment(newDayDate).year())
                            .month(moment(newDayDate).month())
                            .date(moment(newDayDate).date());

                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newDayDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null,
                            calendarDraggedFromDate: draggedFromDate
                        });
                    };

                    vm.getWeekNumberLabel = function (day) {
                        var weekNumber = day.date.clone().add(1, 'day').isoWeek();
                        if (typeof calendarConfig.i18nStrings.weekNumber === 'function') {
                            return calendarConfig.i18nStrings.weekNumber({ weekNumber: weekNumber });
                        } else {
                            return calendarConfig.i18nStrings.weekNumber.replace('{week}', weekNumber);
                        }
                    };

                    vm.onDragSelectStart = function (day) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                startDate: day.date,
                                endDate: day.date
                            };
                        }
                    };

                    vm.onDragSelectMove = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                        }
                    };

                    vm.onDragSelectEnd = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.clone().startOf('day').toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.clone().endOf('day').toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarMonth', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarMonthView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onDateRangeSelect: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarMonthCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 49 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarSlideBoxCtrl', ["$scope", "$timeout", "calendarConfig", "calendarEventTitle", function ($scope, $timeout, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;

                    vm.isCollapsed = true;
                    $scope.$watch('vm.isOpen', function (isOpen) {
                        //events must be populated first to set the element height before animation will work
                        $timeout(function () {
                            vm.isCollapsed = !isOpen;
                        });
                    });

                }])
                .directive('mwlCalendarSlideBox', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarSlideBox" overrides="vm.customTemplateUrls"></div>',
                        replace: true,
                        controller: 'MwlCalendarSlideBoxCtrl as vm',
                        require: ['^?mwlCalendarMonth', '^?mwlCalendarYear'],
                        link: function (scope, elm, attrs, ctrls) {
                            scope.isMonthView = !!ctrls[0];
                            scope.isYearView = !!ctrls[1];
                        },
                        scope: {
                            isOpen: '=',
                            events: '=',
                            onEventClick: '=',
                            cell: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 50 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarWeekCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;

                    vm.showTimes = calendarConfig.showTimesOnWeekView;
                    vm.calendarEventTitle = calendarEventTitle;

                    $scope.$on('calendar.refreshView', function () {
                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );
                        if (vm.showTimes) {
                            vm.view = calendarHelper.getWeekViewWithTimes(
                                vm.events,
                                vm.viewDate,
                                vm.dayViewStart,
                                vm.dayViewEnd,
                                vm.dayViewSplit
                            );
                        } else {
                            vm.view = calendarHelper.getWeekView(vm.events, vm.viewDate);
                        }
                    });

                    vm.weekDragged = function (event, daysDiff, minuteChunksMoved) {

                        var newStart = moment(event.startsAt).add(daysDiff, 'days');
                        var newEnd = moment(event.endsAt).add(daysDiff, 'days');

                        if (minuteChunksMoved) {
                            var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                            newStart = newStart.add(minutesDiff, 'minutes');
                            newEnd = newEnd.add(minutesDiff, 'minutes');
                        }

                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDropped = function (event, date) {
                        var daysDiff = moment(date).diff(moment(event.startsAt), 'days');
                        vm.weekDragged(event, daysDiff);
                    };

                    vm.weekResized = function (event, edge, daysDiff) {

                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(daysDiff, 'days');
                        } else {
                            end.add(daysDiff, 'days');
                        }

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });

                    };

                    vm.tempTimeChanged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                }])
                .directive('mwlCalendarWeek', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarWeekView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarWeekCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 51 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarYearCtrl', ["$scope", "moment", "calendarHelper", function ($scope, moment, calendarHelper) {

                    var vm = this;
                    vm.openMonthIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openMonthIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (month, monthIndex) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.openMonthIndex = monthIndex;
                                    vm.openRowIndex = Math.floor(monthIndex / 4);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {
                        vm.view = calendarHelper.getYearView(vm.events, vm.viewDate, vm.cellModifier);

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openMonthIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openMonthIndex = null;
                            vm.view.forEach(function (month) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.monthClicked(month, true);
                                }
                            });
                        }

                    });

                    vm.monthClicked = function (month, monthClickedFirstRun, $event) {

                        if (!monthClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: month.date.toDate(),
                                calendarCell: month,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var monthIndex = vm.view.indexOf(month);
                            if (monthIndex === vm.openMonthIndex) { //the month has been clicked and is already open
                                vm.openMonthIndex = null; //close the open month
                                vm.cellIsOpen = false;
                            } else {
                                vm.openMonthIndex = monthIndex;
                                vm.openRowIndex = Math.floor(monthIndex / 4);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.handleEventDrop = function (event, newMonthDate) {
                        var newStart = moment(event.startsAt)
                            .year(moment(newMonthDate).year())
                            .month(moment(newMonthDate).month());
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newMonthDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarYear', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarYearView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '='
                        },
                        controller: 'MwlCalendarYearCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 52 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCollapseFallbackCtrl', ["$scope", "$attrs", "$element", function ($scope, $attrs, $element) {

                    $scope.$watch($attrs.mwlCollapseFallback, function (shouldCollapse) {
                        if (shouldCollapse) {
                            $element.addClass('ng-hide');
                        } else {
                            $element.removeClass('ng-hide');
                        }
                    });

                }])
                .directive('mwlCollapseFallback', ["$injector", function ($injector) {

                    if ($injector.has('uibCollapseDirective')) {
                        return {};
                    }

                    return {
                        restrict: 'A',
                        controller: 'MwlCollapseFallbackCtrl'
                    };

                }]);


            /***/
        }),
    /* 53 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDateModifierCtrl', ["$element", "$attrs", "$scope", "moment", function ($element, $attrs, $scope, moment) {

                    var vm = this;

                    function onClick() {
                        if (angular.isDefined($attrs.setToToday)) {
                            vm.date = new Date();
                        } else if (angular.isDefined($attrs.increment)) {
                            vm.date = moment(vm.date).add(1, vm.increment).toDate();
                        } else if (angular.isDefined($attrs.decrement)) {
                            vm.date = moment(vm.date).subtract(1, vm.decrement).toDate();
                        }
                        $scope.$apply();
                    }

                    $element.bind('click', onClick);

                    $scope.$on('$destroy', function () {
                        $element.unbind('click', onClick);
                    });

                }])
                .directive('mwlDateModifier', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDateModifierCtrl as vm',
                        scope: {
                            date: '=',
                            increment: '=',
                            decrement: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 54 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDragSelectCtrl', ["$scope", "$element", "$parse", "$attrs", function ($scope, $element, $parse, $attrs) {

                    function handleMouseEvent(callbackName) {
                        return function (event) {
                            if (callbackName && event.button !== 2) {
                                $parse(callbackName)($scope);
                                $scope.$apply();
                            }
                            event.preventDefault();
                        };
                    }

                    var onMouseDown = handleMouseEvent($attrs.onDragSelectStart);
                    var onMouseMove = handleMouseEvent($attrs.onDragSelectMove);
                    var onMouseUp = handleMouseEvent($attrs.onDragSelectEnd);

                    function enableMouseListeners() {
                        $element.on('mousedown', onMouseDown);
                        $element.on('mousemove', onMouseMove);
                        $element.on('mouseup', onMouseUp);
                    }

                    function disableMouseListeners() {
                        $element.off('mousedown', onMouseDown);
                        $element.off('mousemove', onMouseMove);
                        $element.off('mouseup', onMouseUp);
                    }

                    $scope.$watch($attrs.mwlDragSelect, function (isEnabled) {
                        if (isEnabled) {
                            enableMouseListeners();
                        } else {
                            disableMouseListeners();
                        }
                    });

                    $scope.$on('$destroy', function () {
                        disableMouseListeners();
                    });

                }])
                .directive('mwlDragSelect', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDragSelectCtrl'
                    };

                });


            /***/
        }),
    /* 55 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDraggableCtrl', ["$element", "$scope", "$window", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $window, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    function translateElement(elm, transformValue) {
                        return elm
                            .css('-ms-transform', transformValue)
                            .css('-webkit-transform', transformValue)
                            .css('transform', transformValue);
                    }

                    var autoScroll = $parse($attrs.autoScroll)($scope);
                    if (typeof autoScroll === 'undefined') {
                        autoScroll = true;
                    }

                    interact($element[0]).draggable({
                        autoScroll: autoScroll,
                        snap: snap,
                        onstart: function (event) {
                            angular.element(event.target).addClass('dragging-active');
                            event.target.dropData = $parse($attrs.dropData)($scope);
                            event.target.style.pointerEvents = 'none';
                            if ($attrs.onDragStart) {
                                $parse($attrs.onDragStart)($scope);
                                $scope.$apply();
                            }
                        },
                        onmove: function (event) {

                            var elm = angular.element(event.target);
                            var x = (parseFloat(elm.attr('data-x')) || 0) + (event.dx || 0);
                            var y = (parseFloat(elm.attr('data-y')) || 0) + (event.dy || 0);

                            switch ($parse($attrs.axis)($scope)) {
                                case 'x':
                                    y = 0;
                                    break;

                                case 'y':
                                    x = 0;
                                    break;

                                default:
                            }

                            if ($window.getComputedStyle(elm[0]).position === 'static') {
                                elm.css('position', 'relative');
                            }

                            translateElement(elm, 'translate(' + x + 'px, ' + y + 'px)')
                                .css('z-index', 50)
                                .attr('data-x', x)
                                .attr('data-y', y);

                            if ($attrs.onDrag) {
                                $parse($attrs.onDrag)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var x = elm.attr('data-x');
                            var y = elm.attr('data-y');

                            event.target.style.pointerEvents = 'auto';
                            if ($attrs.onDragEnd) {
                                $parse($attrs.onDragEnd)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                            $timeout(function () {
                                translateElement(elm, '')
                                    .css('z-index', 'auto')
                                    .removeAttr('data-x')
                                    .removeAttr('data-y')
                                    .removeClass('dragging-active');
                            });

                        }
                    });

                    $scope.$watch($attrs.mwlDraggable, function (enabled) {
                        interact($element[0]).draggable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDraggable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDraggableCtrl'
                    };

                });


            /***/
        }),
    /* 56 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDroppableCtrl', ["$element", "$scope", "$parse", "$attrs", "interact", function ($element, $scope, $parse, $attrs, interact) {

                    if (!interact) {
                        return;
                    }

                    var DROP_ACTIVE_CLASS = $attrs.dropActiveClass || 'drop-active';

                    interact($element[0]).dropzone({
                        ondragenter: function (event) {
                            angular.element(event.target).addClass(DROP_ACTIVE_CLASS);
                        },
                        ondragleave: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondropdeactivate: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondrop: function (event) {
                            if (event.relatedTarget.dropData) {
                                $parse($attrs.onDrop)($scope, { dropData: event.relatedTarget.dropData });
                                $scope.$apply();
                            }
                        }
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDroppable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDroppableCtrl'
                    };

                });


            /***/
        }),
    /* 57 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDynamicDirectiveTemplateCtrl', ["$compile", "$scope", "$attrs", "$element", "$templateCache", "$log", "calendarConfig", function ($compile, $scope, $attrs, $element, $templateCache, $log, calendarConfig) {

                    $scope.$watch($attrs.overrides, function (overrides) {

                        var templateName = calendarConfig.templates[$attrs.name];
                        if (
                            overrides &&
                            angular.isObject(overrides) &&
                            overrides[$attrs.name]
                        ) {
                            if ($templateCache.get(overrides[$attrs.name])) {
                                templateName = overrides[$attrs.name];
                            } else {
                                $log.warn('Bootstrap Calendar', 'The custom template for ' + overrides[$attrs.name] +
                                    ' was not found in the template cache. Please ensure it is pre-loaded via a script tag ' +
                                    '<script type="text/ng-template" id="' + overrides[$attrs.name] + '">Custom template content</script> or ' +
                                    'via a tool such as https://www.npmjs.com/package/gulp-angular-templatecache');
                            }
                        }
                        var template = $templateCache.get(templateName);
                        $element.html(template);
                        $compile($element.contents())($scope);

                    });

                }])
                .directive('mwlDynamicDirectiveTemplate', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDynamicDirectiveTemplateCtrl'
                    };

                });


            /***/
        }),
    /* 58 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlElementDimensionsCtrl', ["$element", "$scope", "$parse", "$attrs", "$window", function ($element, $scope, $parse, $attrs, $window) {

                    function setDimensions() {
                        $parse($attrs.mwlElementDimensions).assign($scope, {
                            width: $element[0].offsetWidth - 1,
                            height: $element[0].offsetHeight
                        });
                        $scope.$applyAsync();
                    }

                    var win = angular.element($window);

                    win.bind('resize', setDimensions);

                    setDimensions();

                    $scope.$on('$destroy', function () {
                        win.unbind('resize', setDimensions);
                    });

                }])
                .directive('mwlElementDimensions', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlElementDimensionsCtrl'
                    };

                });


            /***/
        }),
    /* 59 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlResizableCtrl', ["$element", "$scope", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    var originalDimensions = {};
                    var originalDimensionsStyle = {};
                    var resizeEdge;

                    function getUnitsResized(edge, elm) {
                        var unitsResized = {};
                        unitsResized.edge = edge;
                        if (edge === 'start') {
                            unitsResized.x = elm.data('x');
                            unitsResized.y = elm.data('y');
                        } else if (edge === 'end') {
                            unitsResized.x = parseFloat(elm.css('width').replace('px', '')) - originalDimensions.width;
                            unitsResized.y = parseFloat(elm.css('height').replace('px', '')) - originalDimensions.height;
                        }
                        return unitsResized;
                    }

                    interact($element[0]).resizable({
                        edges: $parse($attrs.resizeEdges)($scope),
                        snap: snap,
                        onstart: function (event) {

                            resizeEdge = 'end';
                            var elm = angular.element(event.target);
                            originalDimensions.height = elm[0].offsetHeight;
                            originalDimensions.width = elm[0].offsetWidth;
                            originalDimensionsStyle.height = elm.css('height');
                            originalDimensionsStyle.width = elm.css('width');

                        },
                        onmove: function (event) {

                            if (event.rect.width > 0 && event.rect.height > 0) {
                                var elm = angular.element(event.target);
                                var x = parseFloat(elm.data('x') || 0);
                                var y = parseFloat(elm.data('y') || 0);

                                elm.css({
                                    width: event.rect.width + 'px',
                                    height: event.rect.height + 'px'
                                });

                                // translate when resizing from top or left edges
                                x += event.deltaRect.left;
                                y += event.deltaRect.top;

                                elm.css('transform', 'translate(' + x + 'px,' + y + 'px)');

                                elm.data('x', x);
                                elm.data('y', y);

                                if (event.deltaRect.left !== 0 || event.deltaRect.top !== 0) {
                                    resizeEdge = 'start';
                                }

                                if ($attrs.onResize) {
                                    $parse($attrs.onResize)($scope, getUnitsResized(resizeEdge, elm));
                                    $scope.$apply();
                                }

                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var unitsResized = getUnitsResized(resizeEdge, elm);

                            $timeout(function () {
                                elm
                                    .data('x', null)
                                    .data('y', null)
                                    .css({
                                        transform: '',
                                        width: originalDimensionsStyle.width,
                                        height: originalDimensionsStyle.height
                                    });
                            });

                            if ($attrs.onResizeEnd) {
                                $parse($attrs.onResizeEnd)($scope, unitsResized);
                                $scope.$apply();
                            }

                        }
                    });

                    $scope.$watch($attrs.mwlResizable, function (enabled) {
                        interact($element[0]).resizable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlResizable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlResizableCtrl'
                    };

                });


            /***/
        }),
    /* 60 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            __webpack_require__(6);

            var angular = __webpack_require__(0);

            function requireAll(r) {
                r.keys().forEach(r);
            }

            var templates = {};

            if (true) {

                var templatesContext = __webpack_require__(10);

                templatesContext.keys().forEach(function (templateName) {
                    var templateNameWithoutPrefix = templateName.replace('./', '');
                    var cacheTemplateName = 'mwl/' + templateNameWithoutPrefix;
                    var configTemplateName = templateNameWithoutPrefix.replace('.html', '');
                    templates[configTemplateName] = {
                        cacheTemplateName: cacheTemplateName,
                        template: templatesContext(templateName)
                    };
                });

            }

            module.exports = angular
                .module('mwl.calendar', [])
                .config(["calendarConfig", function (calendarConfig) {
                    angular.forEach(templates, function (template, templateName) {
                        if (!calendarConfig.templates[templateName]) {
                            calendarConfig.templates[templateName] = template.cacheTemplateName;
                        }
                    });
                }])
                .run(["$templateCache", "$interpolate", function ($templateCache, $interpolate) {

                    angular.forEach(templates, function (template) {
                        if (!$templateCache.get(template.cacheTemplateName)) {
                            var templateContents = template.template
                                .replace('{{', $interpolate.startSymbol())
                                .replace('}}', $interpolate.endSymbol());
                            $templateCache.put(template.cacheTemplateName, templateContents);
                        }
                    });

                }]).name;

            requireAll(__webpack_require__(7));
            requireAll(__webpack_require__(8));
            requireAll(__webpack_require__(9));


            /***/
        }),
    /* 61 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarDate', ["calendarHelper", "calendarConfig", function (calendarHelper, calendarConfig) {

                    function calendarDate(date, format, getFromConfig) {

                        if (getFromConfig === true) {
                            format = calendarConfig.dateFormats[format];
                        }

                        return calendarHelper.formatDate(date, format);

                    }

                    // This is stateful because the locale can change as well
                    // as calendarConfig.dateFormats which would change the value outside of this filter
                    calendarDate.$stateful = true;

                    return calendarDate;

                }]);


            /***/
        }),
    /* 62 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarLimitTo', ["limitToFilter", function (limitToFilter) {

                    if (angular.version.minor >= 4) { //1.4+ supports the begin attribute
                        return limitToFilter;
                    }

                    //Copied from the angular source. Only 1.4 has the begin functionality.
                    return function (input, limit, begin) {
                        if (Math.abs(Number(limit)) === Infinity) {
                            limit = Number(limit);
                        } else {
                            limit = parseInt(limit);
                        }
                        if (isNaN(limit)) {
                            return input;
                        }

                        if (angular.isNumber(input)) {
                            input = input.toString();
                        }
                        if (!angular.isArray(input) && !angular.isString(input)) {
                            return input;
                        }

                        begin = (!begin || isNaN(begin)) ? 0 : parseInt(begin);
                        begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

                        if (limit >= 0) {
                            return input.slice(begin, begin + limit);
                        } else if (begin === 0) {
                            return input.slice(limit, input.length);
                        } else {
                            return input.slice(Math.max(0, begin + limit), begin);
                        }
                    };

                }]);


            /***/
        }),
    /* 63 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTruncateEventTitle', function () {

                    return function (string, length, boxHeight) {
                        if (!string) {
                            return '';
                        }

                        //Only truncate if if actually needs truncating
                        if (string.length >= length && string.length / 20 > boxHeight / 30) {
                            return string.substr(0, length) + '...';
                        } else {
                            return string;
                        }
                    };

                });


            /***/
        }),
    /* 64 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTrustAsHtml', ["$sce", function ($sce) {

                    return function (text) {
                        return $sce.trustAsHtml(text);
                    };

                }]);


            /***/
        }),
    /* 65 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .constant('calendarConfig', {
                    allDateFormats: {
                        angular: {
                            date: {
                                hour: 'ha',
                                day: 'd MMM',
                                month: 'MMMM',
                                weekDay: 'EEEE',
                                time: 'HH:mm',
                                datetime: 'MMM d, h:mm a'
                            },
                            title: {
                                day: 'EEEE d MMMM, yyyy',
                                week: 'Week {week} of {year}',
                                month: 'MMMM yyyy',
                                year: 'yyyy'
                            }
                        },
                        moment: {
                            date: {
                                hour: 'ha',
                                day: 'D MMM',
                                month: 'MMMM',
                                weekDay: 'dddd',
                                time: 'HH:mm',
                                datetime: 'MMM D, h:mm a'
                            },
                            title: {
                                day: 'dddd D MMMM, YYYY',
                                week: 'Week {week} of {year}',
                                month: 'MMMM YYYY',
                                year: 'YYYY'
                            }
                        }
                    },
                    get dateFormats() {
                        return this.allDateFormats[this.dateFormatter].date;
                    },
                    get titleFormats() {
                        return this.allDateFormats[this.dateFormatter].title;
                    },
                    dateFormatter: 'angular',
                    showTimesOnWeekView: false,
                    displayAllMonthEvents: false,
                    i18nStrings: {
                        weekNumber: 'Week {week}'
                    },
                    templates: {},
                    colorTypes: {
                        info: {
                            primary: '#1e90ff',
                            secondary: '#d1e8ff'
                        },
                        important: {
                            primary: '#ad2121',
                            secondary: '#fae3e3'
                        },
                        warning: {
                            primary: '#e3bc08',
                            secondary: '#fdf1ba'
                        },
                        inverse: {
                            primary: '#1b1b1b',
                            secondary: '#c1c1c1'
                        },
                        special: {
                            primary: '#800080',
                            secondary: '#ffe6ff'
                        },
                        success: {
                            primary: '#006400',
                            secondary: '#caffca'
                        }
                    }
                });


            /***/
        }),
    /* 66 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarEventTitle', ["calendarDateFilter", "calendarTruncateEventTitleFilter", function (calendarDateFilter, calendarTruncateEventTitleFilter) {

                    function yearView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'datetime', true) + ')';
                    }

                    function monthView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
                    }

                    function monthViewTooltip(event) {
                        return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
                    }

                    function weekView(event) {
                        return event.title;
                    }

                    function weekViewTooltip(event) {
                        return event.title;
                    }

                    function dayView(event) {
                        return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);
                    }

                    function dayViewTooltip(event) {
                        return event.title;
                    }

                    return {
                        yearView: yearView,
                        monthView: monthView,
                        monthViewTooltip: monthViewTooltip,
                        weekView: weekView,
                        weekViewTooltip: weekViewTooltip,
                        dayView: dayView,
                        dayViewTooltip: dayViewTooltip
                    };

                }]);


            /***/
        }),
    /* 67 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .factory('calendarHelper', ["$q", "$templateRequest", "dateFilter", "moment", "calendarConfig", function ($q, $templateRequest, dateFilter, moment, calendarConfig) {

                    function formatDate(date, format) {
                        if (calendarConfig.dateFormatter === 'angular') {
                            return dateFilter(moment(date).toDate(), format);
                        } else if (calendarConfig.dateFormatter === 'moment') {
                            return moment(date).format(format);
                        } else {
                            throw new Error('Unknown date formatter: ' + calendarConfig.dateFormatter);
                        }
                    }

                    function adjustEndDateFromStartDiff(oldStart, newStart, oldEnd) {
                        if (!oldEnd) {
                            return oldEnd;
                        }
                        var diffInSeconds = moment(newStart).diff(moment(oldStart));
                        return moment(oldEnd).add(diffInSeconds);
                    }

                    function getRecurringEventPeriod(eventPeriod, recursOn, containerPeriodStart) {

                        var eventStart = moment(eventPeriod.start);
                        var eventEnd = moment(eventPeriod.end);
                        var periodStart = moment(containerPeriodStart);

                        if (recursOn) {

                            switch (recursOn) {
                                case 'year':
                                    eventStart.set({
                                        year: periodStart.year()
                                    });
                                    break;

                                case 'month':
                                    eventStart.set({
                                        year: periodStart.year(),
                                        month: periodStart.month()
                                    });
                                    break;

                                default:
                                    throw new Error('Invalid value (' + recursOn + ') given for recurs on. Can only be year or month.');
                            }

                            eventEnd = adjustEndDateFromStartDiff(eventPeriod.start, eventStart, eventEnd);

                        }

                        return { start: eventStart, end: eventEnd };

                    }

                    function eventIsInPeriod(event, periodStart, periodEnd) {

                        periodStart = moment(periodStart);
                        periodEnd = moment(periodEnd);

                        var eventPeriod = getRecurringEventPeriod({ start: event.startsAt, end: event.endsAt || event.startsAt }, event.recursOn, periodStart);
                        var eventStart = eventPeriod.start;
                        var eventEnd = eventPeriod.end;

                        return (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) ||
                            (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) ||
                            (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) ||
                            eventStart.isSame(periodStart) ||
                            eventEnd.isSame(periodEnd);

                    }

                    function filterEventsInPeriod(events, startPeriod, endPeriod) {
                        return events.filter(function (event) {
                            return eventIsInPeriod(event, startPeriod, endPeriod);
                        });
                    }

                    function getEventsInPeriod(calendarDate, period, allEvents) {
                        var startPeriod = moment(calendarDate).startOf(period);
                        var endPeriod = moment(calendarDate).endOf(period);
                        return filterEventsInPeriod(allEvents, startPeriod, endPeriod);
                    }

                    function getBadgeTotal(events) {
                        return events.filter(function (event) {
                            return event.incrementsBadgeTotal !== false;
                        }).length;
                    }

                    function getWeekDayNames() {
                        var weekdays = [];
                        var count = 0;
                        while (count < 7) {
                            weekdays.push(formatDate(moment().weekday(count++), calendarConfig.dateFormats.weekDay));
                        }
                        return weekdays;
                    }

                    function getYearView(events, viewDate, cellModifier) {

                        var view = [];
                        var eventsInPeriod = getEventsInPeriod(viewDate, 'year', events);
                        var month = moment(viewDate).startOf('year');
                        var count = 0;
                        while (count < 12) {
                            var startPeriod = month.clone();
                            var endPeriod = startPeriod.clone().endOf('month');
                            var periodEvents = filterEventsInPeriod(eventsInPeriod, startPeriod, endPeriod);
                            var cell = {
                                label: formatDate(startPeriod, calendarConfig.dateFormats.month),
                                isToday: startPeriod.isSame(moment().startOf('month')),
                                events: periodEvents,
                                date: startPeriod,
                                badgeTotal: getBadgeTotal(periodEvents)
                            };

                            cellModifier({ calendarCell: cell });
                            view.push(cell);
                            month.add(1, 'month');
                            count++;
                        }

                        return view;

                    }

                    function updateEventForCalendarUtils(event, eventPeriod) {
                        event.start = eventPeriod.start.toDate();
                        if (event.endsAt) {
                            event.end = eventPeriod.end.toDate();
                        }
                        return event;
                    }

                    function getMonthView(events, viewDate, cellModifier) {

                        // hack required to work with the calendar-utils api
                        events.forEach(function (event) {
                            var eventPeriod = getRecurringEventPeriod({
                                start: moment(event.startsAt),
                                end: moment(event.endsAt || event.startsAt)
                            }, event.recursOn, moment(viewDate).startOf('month'));
                            updateEventForCalendarUtils(event, eventPeriod);
                        });

                        var view = calendarUtils.getMonthView({
                            events: events,
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        });

                        view.days = view.days.map(function (day) {
                            day.date = moment(day.date);
                            day.label = day.date.date();
                            day.badgeTotal = getBadgeTotal(day.events);
                            if (!calendarConfig.displayAllMonthEvents && !day.inMonth) {
                                day.events = [];
                            }
                            cellModifier({ calendarCell: day });
                            return day;
                        });

                        // remove hack
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekView(events, viewDate) {

                        var days = calendarUtils.getWeekViewHeader({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        }).map(function (day) {
                            day.date = moment(day.date);
                            day.weekDayLabel = formatDate(day.date, calendarConfig.dateFormats.weekDay);
                            day.dayLabel = formatDate(day.date, calendarConfig.dateFormats.day);
                            return day;
                        });

                        var startOfWeek = moment(viewDate).startOf('week');
                        var endOfWeek = moment(viewDate).endOf('week');

                        var eventRows = calendarUtils.getWeekView({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day(),
                            events: filterEventsInPeriod(events, startOfWeek, endOfWeek).map(function (event) {

                                var weekViewStart = moment(startOfWeek).startOf('day');

                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, weekViewStart);

                                var calendarUtilsEvent = {
                                    originalEvent: event,
                                    start: eventPeriod.start.toDate()
                                };

                                if (event.endsAt) {
                                    calendarUtilsEvent.end = eventPeriod.end.toDate();
                                }

                                return calendarUtilsEvent;
                            })
                        }).map(function (eventRow) {

                            eventRow.row = eventRow.row.map(function (rowEvent) {
                                rowEvent.event = rowEvent.event.originalEvent;
                                return rowEvent;
                            });

                            return eventRow;

                        });

                        return { days: days, eventRows: eventRows };

                    }

                    function getDayView(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit, dayViewEventWidth) {

                        var dayStart = (dayViewStart || '00:00').split(':');
                        var dayEnd = (dayViewEnd || '23:59').split(':');

                        var view = calendarUtils.getDayView({
                            events: events.map(function (event) { // hack required to work with event API
                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, moment(viewDate).startOf('day'));
                                return updateEventForCalendarUtils(event, eventPeriod);
                            }),
                            viewDate: viewDate,
                            hourSegments: 60 / dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            },
                            eventWidth: dayViewEventWidth ? +dayViewEventWidth : 150,
                            segmentHeight: 30
                        });

                        // remove hack to work with new event API
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekViewWithTimes(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {
                        var weekView = getWeekView(events, viewDate);
                        var newEvents = [];
                        var flattenedEvents = [];
                        weekView.eventRows.forEach(function (row) {
                            row.row.forEach(function (eventRow) {
                                flattenedEvents.push(eventRow.event);
                            });
                        });
                        weekView.days.forEach(function (day) {
                            var dayEvents = flattenedEvents.filter(function (event) {
                                return moment(event.startsAt).startOf('day').isSame(moment(day.date).startOf('day'));
                            });
                            var newDayEvents = getDayView(
                                dayEvents,
                                day.date,
                                dayViewStart,
                                dayViewEnd,
                                dayViewSplit
                            ).events;
                            newEvents = newEvents.concat(newDayEvents);
                        });
                        weekView.eventRows = [{
                            row: newEvents.map(function (dayEvent) {
                                var event = dayEvent.event;
                                return {
                                    event: event,
                                    top: dayEvent.top,
                                    offset: calendarUtils.getWeekViewEventOffset({
                                        event: {
                                            start: event.startsAt,
                                            end: event.endsAt
                                        },
                                        startOfWeek: moment(viewDate).startOf('week').toDate()
                                    })
                                };
                            })
                        }];
                        return weekView;
                    }

                    function getDayViewHeight(dayViewStart, dayViewEnd, dayViewSplit) {
                        var dayViewStartM = moment(dayViewStart || '00:00', 'HH:mm');
                        var dayViewEndM = moment(dayViewEnd || '23:59', 'HH:mm');
                        var hourHeight = (60 / dayViewSplit) * 30;
                        return ((dayViewEndM.diff(dayViewStartM, 'minutes') / 60) * hourHeight) + 3;
                    }

                    function loadTemplates() {

                        var templatePromises = Object.keys(calendarConfig.templates).map(function (key) {
                            var templateUrl = calendarConfig.templates[key];
                            return $templateRequest(templateUrl);
                        });

                        return $q.all(templatePromises);

                    }

                    return {
                        getWeekDayNames: getWeekDayNames,
                        getYearView: getYearView,
                        getMonthView: getMonthView,
                        getWeekView: getWeekView,
                        getDayView: getDayView,
                        getWeekViewWithTimes: getWeekViewWithTimes,
                        getDayViewHeight: getDayViewHeight,
                        adjustEndDateFromStartDiff: adjustEndDateFromStartDiff,
                        formatDate: formatDate,
                        loadTemplates: loadTemplates,
                        eventIsInPeriod: eventIsInPeriod //expose for testing only
                    };

                }]);


            /***/
        }),
    /* 68 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarTitle', ["moment", "calendarConfig", "calendarHelper", function (moment, calendarConfig, calendarHelper) {

                    function day(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);
                    }

                    function week(viewDate) {
                        return calendarConfig.titleFormats.week
                            .replace('{week}', moment(viewDate).isoWeek())
                            .replace('{year}', moment(viewDate).startOf('isoweek').format('YYYY'));
                    }

                    function month(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);
                    }

                    function year(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);
                    }

                    return {
                        day: day,
                        week: week,
                        month: month,
                        year: year
                    };

                }]);


            /***/
        }),
    /* 69 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var interact;
            try {
                interact = __webpack_require__(72);
            } catch (e) {
                /* istanbul ignore next */
                interact = null;
            }

            angular
                .module('mwl.calendar')
                .constant('interact', interact);


            /***/
        }),
    /* 70 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var moment = __webpack_require__(71);

            angular
                .module('mwl.calendar')
                .constant('moment', moment);


            /***/
        }),
    /* 71 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_71__;

            /***/
        }),
    /* 72 */
    /***/ (function (module, exports) {

            if (typeof __WEBPACK_EXTERNAL_MODULE_72__ === 'undefined') { var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e; }
            module.exports = __WEBPACK_EXTERNAL_MODULE_72__;

            /***/
        })
    /******/]);
});
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.administration', ['ui.calendar'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_training_administration', {
            url: '/CourseProgress',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/administration/administration.html',
                    controller: 'administrationController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/training/administration');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.training.administration')
        .controller('administrationController', administrationController);

    /** @ngInject */
    function administrationController($mdDateLocale, $scope, $rootScope, $mdDialog, $document, $interval, $mdToast, $mdSidenav, $window, $state, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.CourseNameFilter = {}
        $scope.AttendanceFilter = {}
        $scope.BatchNameFilter = {}
        $scope.queryBy = '$'

        $scope.model = {};
        $scope.CAgrid = true;
        $scope.CourseAGrid = true;
        $scope.CourseAForm = false
        $scope.CourseAUpdate = false;

        $scope.sAdd = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/training/administration/administrationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function administrationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.EnrolmentID = null;
            $scope.vm.CourseName = null;
            $scope.vm.BatchName = null;
            $scope.vm.EmployeeName = null;
            $scope.vm.AttendanceDate = null;
            $scope.vm.StartTime = null;
            $scope.vm.EndTime = null;
            $scope.CourseAGrid = true;
            $scope.CourseAForm = false;
            $scope.CAgrid = false;
            $scope.CAform = true;
            $scope.CourseAUpdate = false;
        }
        $scope.Showgrid = function () {
            $scope.CourseAGrid = true;
            $scope.CourseAForm = false
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $scope.CourseAInfo = function (e, CourseAId) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/training/administration/administrationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function administrationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.CourseAId = CourseAId;
            $scope.CourseAUpdate = true;
            angular.forEach($scope.Courseattendancedatas, function (value) {
                if (value._id == CourseAId) {
                    $scope.vm.EnrolmentID = value.EnrolmentID;
                    $scope.vm.CourseName = value.CourseName;
                    $scope.vm.BatchName = value.BatchName;
                    $scope.vm.EmployeeName = value.employeedetails[0].EmployeeName;
                    $scope.vm.Employee_id = value.EmployeeName;
                    $scope.vm.AttendanceDate = value.AttendanceDate;
                    $scope.vm.StartTime = value.StartTime;
                    $scope.vm.EndTime = value.EndTime;
                }
            })
        }
        $scope.CourseASubmit = function () {
            if ($scope.CourseAUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/courseattendance/update",
                    data: {
                        _id: $scope.CourseAId,
                        CourseName: $scope.vm.CourseName,
                        BatchName: $scope.vm.BatchName,
                        EmployeeName: $scope.vm.Employee_id,
                        AttendanceDate: $scope.vm.AttendanceDate,
                        StartTime: $scope.vm.StartTime,
                        EndTime: $scope.vm.EndTime,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var Einfo = $scope.vm.EmployeeName;
                for (var i = 0; i < Einfo.length; i++) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/courseattendance/add",
                        data: {
                            CourseName: $scope.vm.CourseName,
                            BatchName: $scope.vm.BatchName,
                            EmployeeName: Einfo[i].id,
                            AttendanceDate: $scope.vm.AttendanceDate,
                            StartTime: $scope.vm.StartTime,
                            EndTime: $scope.vm.EndTime,
                            Client_Id: $rootScope.Client_Id,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                        },
                    });
                }
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $window.localStorage.setItem('idForEvaluation', "");
        $scope.Evaluation = function (AId) {
            $window.localStorage.setItem('idForEvaluation', AId);
            $state.go('app.pages_administration_evaluation');
        }
        $scope.Certificate = function (AId) {
            $window.localStorage.setItem('idForCertification', AId);
            $state.go('app.pages_administration_certification');
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursemaster",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (coursemasterdata) {
            $scope.Coursemasterdatas = coursemasterdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursescheduling",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseschedulingdata) {
            $scope.Courseschedulingdatas = courseschedulingdata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/courseattendance",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseattendancedata) {
            $scope.Courseattendancedatas = courseattendancedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            angular.forEach($scope.Enrollmentsdatas, function (evalue) {
                angular.forEach($scope.Courseschedulingdatas, function (cvalue) {
                    if (evalue.CourseName == cvalue.CourseName) {
                        evalue.CompanySponsored = cvalue.StartDate;
                        evalue.Remarks = cvalue.EndDate;
                    }
                })
            })
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/coursescheduling",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (courseschedulingdata) {
                $scope.Courseschedulingdatas = courseschedulingdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/enrollments",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (enrollmentsdata) {
                $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/coursemaster",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (coursemasterdata) {
                $scope.Coursemasterdatas = coursemasterdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/courseattendance",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (courseattendancedata) {
                $scope.Courseattendancedatas = courseattendancedata.data.data;
            });
        }

        function ClearLeaveTypes() {

            $scope.model.LeaveType = '';
            $scope.model.NDays = '';
            $scope.model.Remarks = '';
            $scope.leaveform2.$setPristine();
            $scope.leaveform2.$setUntouched();
        }

        var vm = this;

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.shift', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_timelog_shift', {
            url: '/shift',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/timelog/shift/shift.html',
                    controller: 'shiftController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.shift')
        .controller('shiftController', shiftController);

    /** @ngInject */
    function shiftController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, $location, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Timelog")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Shiftgrid = true;
        $scope.Export = true;
        $scope.Shiftform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.sExport = function () {

            alasql('SELECT ShiftName,ShiftCode,ClientID,ShiftStartTime,ShiftEndTime,NightShift,LunchBreakStartTime,LunchBreakEndTime,Break1StartTime,Break1EndTime,DaysofWeek INTO XLSX("Shiftdatas.xlsx",{headers:true}) FROM ?', [$scope.Shiftdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.shiftinfo = function (ShiftID) {
            $scope.SID = ShiftID;
            $scope.Update = true;
            $scope.Shiftform = true;
            $scope.Shiftgrid = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.Export = false;
            $scope.view = true;
            var info = $scope.Shiftsummary
            angular.forEach($scope.Shiftsummary, function (svalue) {
                if (svalue.ID === ShiftID) {
                    $scope.uShiftID = svalue.ID;
                    $scope.uClientID = svalue.ClientID;
                    $scope.uDepartmentID = svalue.DepartmentID;
                    $scope.uShiftName = svalue.ShiftName;
                    $scope.uShiftCode = svalue.ShiftCode;
                    $scope.uJobCategory = svalue.JobCategory;
                    $scope.uShiftStartTime = svalue.ShiftStartTime;
                    if ($scope.uShiftStartTime != null && $scope.uShiftStartTime != "") {
                        $scope.uShiftStartTime = new Date(svalue.ShiftStartTime);
                    }
                    $scope.uShiftEndTime = svalue.ShiftEndTime;
                    if ($scope.uShiftEndTime != null && $scope.uShiftEndTime != "") {
                        $scope.uShiftEndTime = new Date(svalue.ShiftEndTime);
                    }
                    $scope.uLunchBreakfrom = svalue.LunchBreakStartTime
                    if ($scope.uLunchBreakfrom != null && $scope.uLunchBreakfrom != "") {
                        $scope.uLunchBreakfrom = new Date(svalue.LunchBreakStartTime);
                    }
                    $scope.uLunchBreakTo = svalue.LunchBreakEndTime
                    if ($scope.uLunchBreakTo != null && $scope.uLunchBreakTo != "") {
                        $scope.uLunchBreakTo = new Date(svalue.LunchBreakEndTime);
                    }
                    $scope.uAdditionalBreakfrom = svalue.Break1StartTime
                    if ($scope.uAdditionalBreakfrom != null && $scope.uAdditionalBreakfrom != "") {
                        $scope.uAdditionalBreakfrom = new Date(svalue.Break1StartTime);
                    }
                    $scope.uAdditionalBreakTo = svalue.Break1EndTime
                    if ($scope.uAdditionalBreakTo != null && $scope.uAdditionalBreakTo != "") {
                        $scope.uAdditionalBreakTo = new Date(svalue.Break1EndTime);
                    }
                    var NightShift = svalue.NightShift;
                    var DaysofWeek = svalue.DaysofWeek;
                    if (DaysofWeek.split(",").includes("Sunday")) {
                        $scope.rec1 = { Sun: true };
                    }
                    if (DaysofWeek.split(",").includes("Monday")) {
                        $scope.rec2 = { Mon: true };
                    }
                    if (DaysofWeek.split(",").includes("Tuesday")) {
                        $scope.rec3 = { Tues: true };
                    }
                    if (DaysofWeek.split(",").includes("Wednesday")) {
                        $scope.rec4 = { Wed: true };
                    }
                    if (DaysofWeek.split(",").includes("Thursday")) {
                        $scope.rec5 = { Thur: true };
                    }
                    if (DaysofWeek.split(",").includes("Friday")) {
                        $scope.rec6 = { Fri: true };
                    }
                    if (DaysofWeek.split(",").includes("Saturday")) {
                        $scope.rec7 = { Sat: true };
                    }
                    if (NightShift == "Night") {
                        $scope.night = { shift: true };
                    }
                    if (NightShift == "Day") {
                        $scope.night = { shift: false };
                    }
                }
            });
        }

        $scope.DOW = { Sun: false };
        $scope.DOW = { Mon: false };
        $scope.DOW = { Tues: false };
        $scope.DOW = { Wed: false };
        $scope.DOW = { Thur: false };
        $scope.DOW = { Fri: false };
        $scope.DOW = { Sat: false };
        $scope.night = { shift: false };

        $scope.sSubmit = function () {
            var days = [];
            if ($scope.DOW.Sun == true) {
                days.push({
                    DOW: "Sunday",
                })
            }
            if ($scope.DOW.Mon == true) {
                days.push({
                    DOW: "Monday",
                })
            }
            if ($scope.DOW.Tues == true) {
                days.push({
                    DOW: "Tuesday",
                })
            }
            if ($scope.DOW.Wed == true) {
                days.push({
                    DOW: "Wednesday",
                })
            }
            if ($scope.DOW.Thur == true) {
                days.push({
                    DOW: "Thursday",
                })
            }
            if ($scope.DOW.Fri == true) {
                days.push({
                    DOW: "Friday",
                })
            }
            if ($scope.DOW.Sat == true) {
                days.push({
                    DOW: "Saturday",
                })
            }
            if ($scope.night.shift == true) {
                $scope.uNightShift = "Night";
            }
            if ($scope.night.shift == false) {
                $scope.uNightShift = "Day";
            }
            $scope.uDOW = days.map(function (obj) { return obj.DOW; }).join(', ');
            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/shift/update",
                    data: {
                        _id: $scope.SID, ClientID: $scope.uClientID, ShiftName: $scope.uShiftName, ShiftCode: $scope.uShiftCode,
                        ShiftStartTime: $scope.uShiftStartTime, ShiftEndTime: $scope.uShiftEndTime,
                        LunchBreakStartTime: $scope.uLunchBreakfrom, LunchBreakEndTime: $scope.uLunchBreakTo,
                        Break1StartTime: $scope.uAdditionalBreakfrom, Break1EndTime: $scope.uAdditionalBreakTo,
                        NightShift: $scope.uNightShift, DaysofWeek: $scope.uDOW, JobCategory: $scope.uJobCategory,
                        DepartmentID: $scope.uDepartmentID, UpdatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Shiftgrid = true;
                    $scope.Shiftform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/shift/add",
                    data: {
                        ClientID: $scope.uClientID, ShiftName: $scope.uShiftName, ShiftCode: $scope.uShiftCode,
                        ShiftStartTime: $scope.uShiftStartTime, ShiftEndTime: $scope.uShiftEndTime,
                        LunchBreakStartTime: $scope.uLunchBreakfrom, LunchBreakEndTime: $scope.uLunchBreakTo,
                        Break1StartTime: $scope.uAdditionalBreakfrom, Break1EndTime: $scope.uAdditionalBreakTo,
                        NightShift: $scope.uNightShift, DaysofWeek: $scope.uDOW, JobCategory: $scope.uJobCategory,
                        DepartmentID: $scope.uDepartmentID, CreatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Shiftgrid = true;
                    $scope.Shiftform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Showgrid = function () {
            $scope.Shiftgrid = true;
            $scope.Shiftform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.rec1 = { Sun: false };
            $scope.rec2 = { Mon: false };
            $scope.rec3 = { Tues: false };
            $scope.rec4 = { Wed: false };
            $scope.rec5 = { Thur: false };
            $scope.rec6 = { Fri: false };
            $scope.rec7 = { Sat: false };
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Shiftform = true;
            $scope.Shiftgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.uShiftStartTime = new Date("00:00:AM");
            $scope.uShiftEndTime = new Date("00:00:AM");
            $scope.uLunchBreakfrom = new Date("00:00");
            $scope.uLunchBreakTo = new Date("00:00");
            $scope.uAdditionalBreakfrom = new Date("00:00");
            $scope.uAdditionalBreakTo = new Date("00:00");
            $scope.DOW = { Sun: false };
            $scope.DOW = { Mon: false };
            $scope.DOW = { Tues: false };
            $scope.DOW = { Wed: false };
            $scope.DOW = { Thur: false };
            $scope.DOW = { Fri: false };
            $scope.DOW = { Sat: false };
            $scope.night = { shift: false };
            angular.forEach($scope.clientdatas, function (value, key) {
                if (value.Primary == "Yes")
                    $scope.uClientID = value.id;
            });
        }
        $http.get($rootScope.WebURL + "/client")
            .then(function (clientdata) {
                $scope.clientdatas = clientdata.data.data;
            });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
            Shiftsummary();
        });
        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/client")
                .then(function (clientdata) {
                    $scope.clientdatas = clientdata.data.data;
                });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/shift",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Shiftdata) {
                $scope.Shiftdatas = Shiftdata.data.data;
                Shiftsummary();
            });
        }

        function Shiftsummary() {
            var Shift = [];
            angular.forEach($scope.Shiftdatas, function (svalue) {
                angular.forEach($scope.clientdatas, function (cvalue) {
                    if (svalue.ClientID == cvalue.id) {
                        $scope.ClientName = cvalue.ClientName;
                        $scope.ClientID = cvalue.id;
                    }
                });
                Shift.push({
                    ID: svalue.id,
                    ShiftName: svalue.ShiftName,
                    ShiftCode: svalue.ShiftCode,
                    ShiftStartTime: svalue.ShiftStartTime,
                    ShiftEndTime: svalue.ShiftEndTime,
                    NightShift: svalue.NightShift,
                    LunchBreakStartTime: svalue.LunchBreakStartTime,
                    LunchBreakEndTime: svalue.LunchBreakEndTime,
                    Break1StartTime: svalue.Break1StartTime,
                    Break1EndTime: svalue.Break1EndTime,
                    DaysofWeek: svalue.DaysofWeek,
                    JobCategory: svalue.JobCategory,
                    ClientName: $scope.ClientName,
                    Department: $scope.Department,
                    ClientID: $scope.ClientID,
                })
            });
            $scope.Shiftsummary = Shift;
        }

        function ClearForm() {
            $scope.uShiftName = '';
            $scope.uShiftCode = '';
            $scope.uClientID = '';
            $scope.uDepartmentID = '';
            $scope.uJobCategory = '';
            $scope.uDesignation = '';
            $scope.uEmail = '';
            $scope.uDOJ = '';
            $scope.uPassportNumber = '';
            $scope.uPassportissueDate = '';
            $scope.uPassportIssuePlace = '';

        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };

    }

})();



(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.midmonth', ['moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_midmonth', {
            url: '/MidMonthPayroll',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/midmonth/midmonth.html',
                    controller: 'midmonthController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.midmonth')
        .controller('midmonthController', midmonthController);

    /** @ngInject */
    function midmonthController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $mdDialog, $document) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var monthFormat = buildLocaleProvider("MMM-YYYY");
        var ymdFormat = buildLocaleProvider("YYYY-MM-DD");

        $scope.dateFields = {
            type: 'date',
            required: false,
            binding: 'applicant.expectedGraduation',
            startView: 'month',
            label: 'Credit Card Expiry - Year/Month picker',
            mode: 'month',
            locale: monthFormat,
            selectedDate: moment(new Date())
        };


        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            var pestdatas = pestdata.data.data;
            angular.forEach(pestdatas, function (value) {
                angular.forEach($scope.Divisiondatas, function (dvalue) {

                    if (value.Division == dvalue.id) {
                        value.DivisionName = dvalue.DivisionName;
                    }
                })
            })
            $scope.pestdatas = pestdatas.filter(function (item) {
                return item.DivisionName === "GP";
            });

        });


        LoadHoliday();

        RefreshGrid();




        $scope.PrintReport = function () {
            var ID = $scope.SelectedIds;
            var url = $rootScope.PayrollURL + "MidMonthPayslip.aspx?ID=" + ID;
            window.open(url);
        }

        $scope.OnMonthChange = function () {

            var date = $scope.dateFields.selectedDate._d;

            RefreshGrid();
            LoadHoliday();
        }

        function LoadHoliday() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/calendar/getHolidayByMonth",
                data: { Client_Id: $rootScope.Client_Id, StartDate: StartDate, EndDate: EndDate },
            }).then(function (Holidaydata) {

                $scope.Holidaydatas = Holidaydata.data.data;

                CalendarWorkingDays();
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/midmonthpayroll/getSchedulerDetails",
                data: { Client_Id: $rootScope.Client_Id, FromDate: StartDate, ToDate: EndDate },
            }).then(function (Schedulerdata) {
                $scope.Schedulerdatas = Schedulerdata.data.data;

            });

        }

        function RefreshGrid() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/midmonthpayroll/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (Payrolldata) {
                $scope.Payrolldatas = Payrolldata.data.data;
                LoadAttendance();
            }, function (err) {
                LoadAttendance();
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/payrollsettings/getemployeedeatils",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;

            });

        }

        function LoadAttendance() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/midmonthpayroll/getAttendanceByEmployeeID",
                data: { Client_Id: $rootScope.Client_Id, FromDate: StartDate, ToDate: EndDate },
            }).then(function (Attendancedata) {
                $scope.Attendancedatas = Attendancedata.data.data;

                LoadDetails();
            });

        }
        function LoadDetails() {

            var EndMonthData = [];

            angular.forEach($scope.Employeedatas, function (value) {

                var EmployeeID = undefined;
                var _id = undefined;
                var EmployeeName = undefined;
                var BankName = undefined;
                var Acc = undefined;
                var EDateOfJoin = undefined;
                var WorkWeekdetails = undefined;
                var Amount = undefined;
                var Remarks = undefined;
                var IsConfirmed = false;
                var PayRollID = -1;
                var TotalWorkedDays = 0;
                var CalendarDays = 0;

                var GPIncentives = 0;
                var OTBSIncentives = 0;
                var WeekdayAllowance = 0;
                var WeekendAllowance = 0;
                var SiteAllowance = 0;
                var OT15 = 0;
                var OT20 = 0;
                var TotalPay = 0;
                var HourRate = 0;
                var OT20Rate = 0;
                var OT15Rate = 0;
                var OTEligible = "No";
                var IncrementAmount = 0;
                var IncrementDate = 0;


                EmployeeID = value.EmployeeID;
                EmployeeName = value.EmployeeName;
                EDateOfJoin = value.EDateOfJoin;
                PayRollID = value.PayRollID;


                if (value.Payrolldetails.length > 0) {
                    BankName = value.Payrolldetails[0].BankName;
                    Acc = value.Payrolldetails[0].Acc;
                    Amount = value.Payrolldetails[0].Amount;
                    OTEligible = value.Payrolldetails[0].OTEligible;
                }

                if (value.Incrementdetails.length > 0) {

                    angular.forEach(value.Incrementdetails, function (Ivalue) {

                        IncrementDate = Ivalue.IncrementDate;

                        if (new Date(IncrementDate) <= new Date()) {

                            IncrementAmount = IncrementAmount + parseFloat(Ivalue.IncrementAmount);
                        }
                    });
                }

                Amount = parseFloat(Amount) + IncrementAmount;

                if (value.WorkWeekdetails.length > 0) {
                    WorkWeekdetails = value.WorkWeekdetails[0];
                    CalendarDays = CalendarWorkingDays(WorkWeekdetails)
                }

                if ($scope.Payrolldatas != undefined) {
                    var item = $scope.Payrolldatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (item != undefined) {

                        IsConfirmed = item.IsConfirmed;
                        Remarks = item.Remarks;
                        PayRollID = item._id;
                        OTBSIncentives = item.OTBSIncentives;
                        WeekdayAllowance = item.WeekdayAllowance;
                        WeekendAllowance = item.WeekendAllowance;
                        SiteAllowance = item.SiteAllowance;
                        OT15 = item.OT15;
                        OT20 = item.OT20;
                        GPIncentives = item.GPIncentives;
                        HourRate = item.HourRate;
                        TotalPay = item.TotalPay;
                        OT20Rate = item.OT20Rate;
                        OT15Rate = item.OT15Rate;
                        debugger
                    }
                }
                if (PayRollID == -1) {

                    if (OTEligible == "Yes") {

                        if ($scope.Attendancedatas != undefined) {

                            var Attendanceitem = $scope.Attendancedatas.filter(function (Avalue) {
                                return Avalue.Employee === value._id;
                            });

                            OT15 = AttendanceCalculation(Attendanceitem, WorkWeekdetails);
                        }


                        if (OT15 > 0) {
                            OT15 = OT15 * 1.5;
                        }

                        OT15Rate = parseFloat(OT15 * parseFloat(HourRate));
                        OT20Rate = parseFloat(OT20 * parseFloat(HourRate));

                    }

                    GPIncentives = GPIncentiveCalculation(EmployeeName);
                    HourRate = parseFloat($scope.HourRate(Amount, CalendarDays)).toFixed(2);
                    TotalPay = parseFloat(GPIncentives) + parseFloat(OTBSIncentives) + parseFloat(WeekdayAllowance) + parseFloat(WeekendAllowance) +
                        parseFloat(SiteAllowance) + parseFloat(OT15 * parseFloat(HourRate)) + parseFloat(OT20 * parseFloat(HourRate));

                }

                EndMonthData.push({
                    _id: value._id,
                    EmployeeID: EmployeeID,
                    EmployeeName: EmployeeName,
                    BankName: BankName,
                    Acc: Acc,
                    EDateOfJoin: EDateOfJoin,
                    WorkWeekdetails: WorkWeekdetails,
                    Amount: Amount,
                    Remarks: Remarks,
                    IsConfirmed: IsConfirmed,
                    PayRollID: PayRollID,
                    CalendarDays: CalendarDays,
                    GPIncentives: GPIncentives,
                    OTBSIncentives: OTBSIncentives,
                    WeekdayAllowance: WeekdayAllowance,
                    WeekendAllowance: WeekendAllowance,
                    SiteAllowance: SiteAllowance,
                    OT15: OT15,
                    OT20: OT20,
                    TotalPay: TotalPay,
                    HourRate: HourRate,
                    OT20Rate: OT20Rate,
                    OT15Rate: OT15Rate
                });

            });

            $scope.EndMonthData = EndMonthData;
        }

        function AttendanceCalculation(data, WorkingDays) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var TotalDays = 0;
            angular.forEach(data, function (value) {
                var TimeIn = value.TimeIn;
                var TimeOut = value.TimeOut;
                var ShiftStartTime = value.Shiftdetails[0].ShiftStartTime;
                var ShiftEndTime = value.Shiftdetails[0].ShiftEndTime;
                var LunchBreakStartTime = value.Shiftdetails[0].LunchBreakStartTime;
                var LunchBreakEndTime = value.Shiftdetails[0].LunchBreakEndTime;

                if (TimeOut != null && TimeOut != undefined) {

                    var lunch = TimeSpan.FromDates(new Date(LunchBreakEndTime), new Date(LunchBreakStartTime), true).hours();
                    var basichour = TimeSpan.FromDates(new Date(ShiftEndTime), new Date(ShiftStartTime), true).hours();

                    basichour = (basichour - (lunch));

                    var Totaltimespan = 0;
                    if (moment(TimeIn).format("hh:mm:ss") < moment(ShiftStartTime).format("hh:mm:ss")) {

                        Totaltimespan = TimeSpan.FromDates(new Date(TimeOut), new Date(ShiftStartTime), true)
                    }
                    else {

                        Totaltimespan = TimeSpan.FromDates(new Date(TimeOut), new Date(TimeIn), true)
                    }

                    var timespan = Totaltimespan.hours() + "." + Totaltimespan.minutes();

                    var workedhours = (parseFloat(timespan) - parseFloat(lunch));

                    var d = new Date(TimeIn);
                    var dayName = days[d.getDay()];



                    if (dayName == "Monday") {
                        if (Monday > 0) {
                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Monday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Monday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                    if (dayName == "Tuesday") {

                        if (Tuesday > 0) {
                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Tuesday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Tuesday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                    if (dayName == "Wednesday") {

                        if (Wednesday > 0) {

                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Wednesday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Wednesday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                    if (dayName == "Thursday") {

                        if (Thursday > 0) {

                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Thursday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Thursday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                    if (dayName == "Friday") {

                        if (Friday > 0) {

                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Friday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Friday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                    if (dayName == "Saturday") {

                        if (Saturday > 0) {

                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Saturday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Saturday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    } if (dayName == "Sunday") {
                        if (Sunday > 0) {

                            if (workedhours > 8) {
                                var OTHours = workedhours - 8;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Sunday == 4) {
                            if (workedhours > 4) {
                                var OTHours = workedhours - 4;
                                OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                                TotalDays = TotalDays + parseFloat(OTHours);
                            }
                        }
                        else if (Sunday == 0) {
                            var OTHours = workedhours;
                            OTHours = Round(OTHours).hours() + "." + Round(OTHours).minutes();
                            TotalDays = TotalDays + parseFloat(OTHours);
                        }
                    }
                }

            });
            return TotalDays;

        }

        function Round(time) {
            time = parseFloat(time).toFixed(2);

            var split = time.split(".");
            var input = new TimeSpan();

            input.addHours(parseInt(split[0]));
            input.addMinutes(parseInt(split[1]));

            if (input.minutes() >= 45) {
                input.subtractMinutes(input.minutes());
                input.addHours(1);
            }
            else if (input.minutes() >= 30 && input.minutes() < 45) {
                input.subtractMinutes(input.minutes());
                input.addMinutes(30);
            }
            else if (input.minutes() < 30) {
                input.subtractMinutes(input.minutes());
            }
            return input;
        }

        function GPIncentiveCalculation(EmployeeName) {

            var TotalGPJobs = 0;

            angular.forEach($scope.Schedulerdatas, function (value) {

                if (value.Teamdetails[0].TeamLead == EmployeeName) {
                    var Count = 0;
                    var array = value.PestType.split(",");

                    angular.forEach(array, function (pt) {

                        var item = $scope.pestdatas.filter(function (item) {
                            return item.PestName === pt;
                        })[0];

                        if (item != undefined) {
                            Count++;
                        }
                    });

                    if (Count > 0) {
                        TotalGPJobs = TotalGPJobs + 1;
                    }

                }


                var TeamMembers = value.Teamdetails[0].TeamMembers.split(",");

                angular.forEach(TeamMembers, function (team) {

                    if (EmployeeName == team) {
                        Count = 0;
                        var array = value.PestType.split(",");

                        angular.forEach(array, function (pt) {

                            var item = $scope.pestdatas.filter(function (item) {
                                return item.PestName === pt;
                            })[0];

                            if (item != undefined) {
                                Count++;
                            }
                        });

                        if (Count > 0) {
                            TotalGPJobs = TotalGPJobs + 1;
                        }
                    }
                });
            });


            return (((TotalGPJobs * 2) * 60) / 100);
        }

        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }


        $scope.EditSelected = function (e) {

            $scope.vm.OTBSIncentives = 0;
            $scope.vm.WeekdayAllowance = 0;
            $scope.vm.WeekendAllowance = 0;
            $scope.vm.SiteAllowance = 0;
            $scope.vm.GPIncentives = 0;
            $scope.vm.OT15 = 0;
            $scope.vm.OT20 = 0;
            $scope.vm.Remarks = undefined;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/midmonth/bulkeditpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.EditIndividual = function (EmployeeID, e) {

            $scope.vm.OTBSIncentives = 0;
            $scope.vm.WeekdayAllowance = 0;
            $scope.vm.WeekendAllowance = 0;
            $scope.vm.SiteAllowance = 0;
            $scope.vm.GPIncentives = 0;
            $scope.vm.OT15 = 0;
            $scope.vm.OT20 = 0;
            $scope.vm.Remarks = undefined;

            $scope.IndividualEmployeeID = EmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];

            $scope.vm.Remarks = item.Remarks;
            $scope.vm.OTBSIncentives = item.OTBSIncentives;
            $scope.vm.WeekdayAllowance = item.WeekdayAllowance;
            $scope.vm.WeekendAllowance = item.WeekendAllowance;
            $scope.vm.SiteAllowance = item.SiteAllowance;
            $scope.vm.GPIncentives = item.GPIncentives;
            $scope.vm.OT15 = item.OT15;
            $scope.vm.OT20 = item.OT20;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/midmonth/editpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitIndividual = function () {

            var EmployeeID = $scope.IndividualEmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];

            var OT15Rate = parseFloat($scope.vm.OT15 * parseFloat(item.HourRate));
            var OT20Rate = parseFloat($scope.vm.OT20 * parseFloat(item.HourRate));

            var TotalPay = parseFloat($scope.vm.GPIncentives) + parseFloat($scope.vm.OTBSIncentives) + parseFloat($scope.vm.WeekdayAllowance) + parseFloat($scope.vm.WeekendAllowance) +
                parseFloat($scope.vm.SiteAllowance) + OT15Rate + OT20Rate;


            if (item.PayRollID == -1) {
                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/midmonthpayroll/add",
                    data: {
                        EmployeeID: EmployeeID, GPIncentives: $scope.vm.GPIncentives, Month: $scope.dateFields.selectedDate._d,
                        OTBSIncentives: $scope.vm.OTBSIncentives, WeekdayAllowance: $scope.vm.WeekdayAllowance,
                        WeekendAllowance: $scope.vm.WeekendAllowance, SiteAllowance: $scope.vm.SiteAllowance,
                        OT15: $scope.vm.OT15, OT20: $scope.vm.OT20, TotalPay: TotalPay, HourRate: item.HourRate, OT20Rate: OT20Rate,
                        OT15Rate: OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                        CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
            else {


                var responses = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/midmonthpayroll/update",
                    data: {
                        _id: item.PayRollID, EmployeeID: EmployeeID, GPIncentives: $scope.vm.GPIncentives,
                        OTBSIncentives: $scope.vm.OTBSIncentives, WeekdayAllowance: $scope.vm.WeekdayAllowance,
                        WeekendAllowance: $scope.vm.WeekendAllowance, SiteAllowance: $scope.vm.SiteAllowance,
                        OT15: $scope.vm.OT15, OT20: $scope.vm.OT20, TotalPay: TotalPay, HourRate: item.HourRate, OT20Rate: OT20Rate,
                        OT15Rate: OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed, UpdatedBy: $rootScope.createdby
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
        }

        $scope.ConfirmSelected = function (e) {

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/midmonth/alertpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.UpdateSelected = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                var OT15Rate = parseFloat($scope.vm.OT15 * parseFloat(item.HourRate));
                var OT20Rate = parseFloat($scope.vm.OT20 * parseFloat(item.HourRate));

                var TotalPay = parseFloat($scope.vm.GPIncentives) + parseFloat($scope.vm.OTBSIncentives) + parseFloat($scope.vm.WeekdayAllowance) + parseFloat($scope.vm.WeekendAllowance) +
                    parseFloat($scope.vm.SiteAllowance) + OT15Rate + OT20Rate;

                if (item.PayRollID == -1) {
                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/midmonthpayroll/add",
                        data: {
                            EmployeeID: item._id, Month: $scope.dateFields.selectedDate._d, GPIncentives: $scope.vm.GPIncentives,
                            OTBSIncentives: $scope.vm.OTBSIncentives, WeekdayAllowance: $scope.vm.WeekdayAllowance,
                            WeekendAllowance: $scope.vm.WeekendAllowance, SiteAllowance: $scope.vm.SiteAllowance,
                            OT15: $scope.vm.OT15, OT20: $scope.vm.OT20, TotalPay: TotalPay, HourRate: item.HourRate, OT20Rate: OT20Rate,
                            OT15Rate: OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }
                else {
                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/midmonthpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, GPIncentives: $scope.vm.GPIncentives,
                            OTBSIncentives: $scope.vm.OTBSIncentives, WeekdayAllowance: $scope.vm.WeekdayAllowance,
                            WeekendAllowance: $scope.vm.WeekendAllowance, SiteAllowance: $scope.vm.SiteAllowance,
                            OT15: $scope.vm.OT15, OT20: $scope.vm.OT20, TotalPay: TotalPay, HourRate: item.HourRate, OT20Rate: OT20Rate,
                            OT15Rate: OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                            UpdatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }




            })


        }

        $scope.ConfirmPayroll = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                if (item.PayRollID == -1) {

                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/midmonthpayroll/add",
                        data: {
                            EmployeeID: item._id, Month: $scope.dateFields.selectedDate._d, GPIncentives: item.GPIncentives,
                            OTBSIncentives: item.OTBSIncentives, WeekdayAllowance: item.WeekdayAllowance, WeekendAllowance: item.WeekendAllowance,
                            SiteAllowance: item.SiteAllowance, OT15: item.OT15, OT20: item.OT20, TotalPay: item.TotalPay, HourRate: item.HourRate,
                            OT20Rate: item.OT20Rate, OT15Rate: item.OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: true,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                } else {

                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/midmonthpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, GPIncentives: item.GPIncentives, OTBSIncentives: item.OTBSIncentives,
                            WeekdayAllowance: item.WeekdayAllowance, WeekendAllowance: item.WeekendAllowance, SiteAllowance: item.SiteAllowance,
                            OT15: item.OT15, OT20: item.OT20, TotalPay: item.TotalPay, HourRate: item.HourRate, OT20Rate: item.OT20Rate,
                            OT15Rate: item.OT15Rate, Remarks: $scope.vm.Remarks, IsConfirmed: true, CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }
            });
        }

        $scope.SelectedIds = [];
        $scope.CheckAll = function (IsTicked) {
            if (IsTicked == true) {
                $scope.TRCdiv = true;
                angular.forEach($scope.EndMonthData, function (value) {
                    if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
                })
                $scope.Selec = { value: true }
            }
            if (IsTicked == false) {
                $scope.TRCdiv = false;
                $scope.SelectedIds = [];
                $scope.Selec = { value: false }
            }
        }
        $scope.Check = function (TrF, Ids) {
            if (TrF == true) {
                $scope.TRCdiv = true;
                if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
            }
            if (TrF == false) {
                $scope.TRCdiv = false;
                var index = $scope.SelectedIds.indexOf(Ids);
                if (index > -1) {
                    $scope.SelectedIds.splice(index, 1);
                }
            }
            if ($scope.SelectedIds.length > 0) {
                $scope.TRCdiv = true;
            }
        }
        $scope.TRCdiv = false;

        $scope.TotalWorkingDays = function (WorkingDays, EmployeeID) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var Holidays = 0;
            if ($scope.Holidaydatas != undefined && $scope.Holidaydatas.length > 0) {
                Holidays = $scope.Holidaydatas.length;
            }

            // var TotalCalendarDays = daysInMonth(date.getMonth() + 1, date.getFullYear())

            // var TotalWorkingDays = TotalCalendarDays - Holidays;
            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var dates = getDates(StartDate, EndDate);

            var TotalDays = 0;

            angular.forEach(dates, function (value) {

                var d = new Date(value);
                var dayName = days[d.getDay()];
                if (dayName == "Monday") {
                    if (Monday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Tuesday") {
                    if (Tuesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Wednesday") {
                    if (Wednesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Thursday") {
                    if (Thursday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Friday") {
                    if (Friday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Saturday") {
                    if (Saturday > 0) {
                        TotalDays++;
                    }
                } if (dayName == "Sunday") {
                    if (Sunday > 0) {
                        TotalDays++;
                    }
                }
            });


            // var item = $scope.Attendancedatas.filter(function (value) {
            //     return value.Employee === EmployeeID;
            // });

            var TotalWorkingCalendarDays = TotalDays - Holidays;

            return TotalWorkingCalendarDays;
        }

        $scope.RecordStatus = function (row) {

            if (row.IsConfirmed == true) {
                return "GreenColor";
            }
            else {
                return "RedColor"
            }
        }

        $scope.HourRate = function (a, b) {
            var DayRate = 0;
            if (parseFloat(a) > 0) {
                var TotalDays = parseFloat(b);
                DayRate = parseFloat(parseFloat(a) / TotalDays);
                return parseFloat(DayRate / 8);
            }
            else {
                return 0;
            }
        }

        $scope.Exportdata = function () {
            alasql('SELECT EmployeeID,  EmployeeName, BankName, Acc,formatdate(EDateOfJoin) AS  DateOfJoin,   Amount AS BasicPay, CalendarDays, GPIncentives, OTBSIncentives,  WeekdayAllowance, WeekendAllowance, SiteAllowance, OT15,  OT20, TotalPay,Remarks, booleanvalue(IsConfirmed) AS IsConfirmed  INTO XLSX("MidMonthPayroll.xlsx",{headers:true}) FROM ?', [$scope.EndMonthData]);
        };

        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        // Returns an array of dates between the two dates
        var getDates = function (startDate, endDate) {
            var dates = [],
                currentDate = startDate,
                addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
            while (currentDate <= endDate) {
                dates.push(currentDate);
                currentDate = addDays.call(currentDate, 1);
            }
            return dates;
        };

        function CalendarWorkingDays(WorkingDays) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var Holidays = 0;
            if ($scope.Holidaydatas != undefined && $scope.Holidaydatas.length > 0) {
                Holidays = $scope.Holidaydatas.length;
            }

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var dates = getDates(StartDate, EndDate);

            var TotalDays = 0;

            angular.forEach(dates, function (value) {

                var d = new Date(value);
                var dayName = days[d.getDay()];
                if (dayName == "Monday") {
                    if (Monday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Tuesday") {
                    if (Tuesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Wednesday") {
                    if (Wednesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Thursday") {
                    if (Thursday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Friday") {
                    if (Friday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Saturday") {
                    if (Saturday > 0) {
                        TotalDays++;
                    }
                } if (dayName == "Sunday") {
                    if (Sunday > 0) {
                        TotalDays++;
                    }
                }
            });


            var TotalWorkingCalendarDays = TotalDays - Holidays;

            return TotalWorkingCalendarDays;

        }

        function sundaysInMonth(y, m) {
            var days = new Date(y, m, 0).getDate();
            var sundays = [8 - (new Date(m + '/01/' + y).getDay())];
            for (var i = sundays[0] + 7; i < days; i += 7) {
                sundays.push(i);
            }
            return sundays;
        }

        function daysInMonth(month, year) {
            return new Date(year, month, 0).getDate();
        }


        $scope.WorkedMonth = function (a) {
            var b = new Date();
            return momentDiff1(a, b);
        }

        function momentDiff1(a, b) {

            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');

            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        function buildLocaleProvider(formatString) {
            return {
                formatDate: function (date) {
                    if (date) return moment(date).format(formatString);
                    else return null;
                },
                parseDate: function (dateString) {
                    if (dateString) {
                        var m = moment(dateString, formatString, true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    } else return null;
                }
            };
        }

        alasql.fn.formatdate = function (dateStr) {

            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(dateStr);

            if (d.getFullYear() > 2000) {

                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            }
            else {
                return "";
            }
        };

        alasql.fn.booleanvalue = function (str) {

            if (str == true) {

                return "Yes"
            }
            else {
                return "No";
            }
        };


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Type-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true,

            //retrieve: true,

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.monthlyplan', ['mwl.calendar', 'ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_timelog_monthlyplan', {
            url: '/MonthlyPlan',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/timelog/monthlyplan/monthlyplan.html',
                    controller: 'MonthlyplanController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.monthlyplan')
        .controller('MonthlyplanController', MonthlyplanController);
    /** @ngInject */
    function MonthlyplanController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdDialog, $document, $mdSidenav, $http, $filter, moment, calendarConfig, $timeout, $q, $log) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Timelog")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.mpExport = function () {
            var array = [];
            angular.forEach($scope.Monthlyplandatas, function (value) {
                array.push({
                    ShiftName: value.shiftdetails[0].ShiftName,
                    TeamName: value.teamdetails[0].TeamName,
                    Date: $filter('date')(value.StartDate, 'dd/MM/yyyy'),
                });
            })
            alasql('SELECT * INTO XLSX("Monthlyplandatas.xlsx",{headers:true}) FROM ?', [array]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.model = {};
        $scope.vm.addform = true;
        $scope.vm.deleteform = false;
        $scope.sAdd = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/timelog/monthlyplan/calendarpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MonthlyplanController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Shift_id = null;
            $scope.vm.Team_id = null;
            $scope.vm.StartDate = new Date();
            $scope.vm.EndDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
            $scope.vm.addform = true;
            $scope.vm.deleteform = false;
            $scope.Update == false;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $scope.EventList = function (e, MonthlyplanID) {
            debugger
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/timelog/monthlyplan/calendarpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MonthlyplanController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            angular.forEach($scope.Monthlyplandatas, function (value) {
                if (value._id == MonthlyplanID) {
                    $scope.vm.Team_id = value.Team_id;
                    $scope.vm.Shift_id = value.Shift_id;
                    $scope.vm.StartDate = new Date(value.StartDate);
                    $scope.vm.EndDate = new Date(value.EndDate);
                }
            })
            $scope.MonthlyplanID = MonthlyplanID;
            $scope.vm.addform = false;
            $scope.vm.deleteform = true;
            $scope.Update = false;
        }
        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/monthlyplan/update",
                    data: {
                        _id: $scope.MonthlyplanID,
                        Team_id: $scope.vm.Team_id,
                        Shift_id: $scope.vm.Shift_id,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var oneDay = 24 * 60 * 60 * 1000;
                var diff = Math.round(Math.abs(($scope.vm.StartDate.setHours(0, 0, 0, 0) - $scope.vm.EndDate.setHours(23, 59, 59, 999)) / (oneDay)));
                for (var i = 0; i < diff; i++) {
                    var currentDate = new Date($scope.vm.StartDate);
                    $scope.StartDate = new Date(currentDate.setDate(currentDate.getDate() + i));
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/monthlyplan/add",
                        data: {
                            Team_id: $scope.vm.Team_id,
                            Shift_id: $scope.vm.Shift_id,
                            StartDate: $scope.StartDate,
                            EndDate: $scope.vm.EndDate,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                }
                response.then(function (GList) {
                    RefreshGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.deleteplan = function (MonthlyplanID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/monthlyplan/delete",
                data: {
                    _id: $scope.MonthlyplanID,
                },
            });
            response.then(function (GList) {
                RefreshGrid();
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.Teamdatas = teamdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/monthlyplan",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (monthlyplan) {
            $scope.Monthlyplandatas = monthlyplan.data.data;
            init();
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/shift",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Shiftdata) {
                $scope.Shiftdatas = Shiftdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (teamdata) {
                $scope.Teamdatas = teamdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/monthlyplan",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (monthlyplan) {
                $scope.Monthlyplandatas = monthlyplan.data.data;
                init();
            });
        }
        function init() {
            var eventpush = [];
            angular.forEach($scope.Monthlyplandatas, function (value) {
                eventpush.push({
                    title: "Shift : " + value.shiftdetails[0].ShiftName + '&emsp;&emsp;&emsp;' + 'Team : ' + value.teamdetails[0].TeamName + '&emsp;&emsp;&emsp;',
                    startsAt: moment(value.StartDate).startOf('day').toDate(),
                    id: value._id
                });
            })
            $scope.calendereventdata = eventpush;
        }
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };
        vm.calendarView = 'month';
        vm.viewDate = new Date();
        var actions = [{
            label: '<i class=\'glyphicon glyphicon-pencil\'></i>',
            onClick: function (args) {
                alert.show('Edited', args.calendarEvent);
            }
        }, {
            label: '<i class=\'glyphicon glyphicon-remove\'></i>',
            onClick: function (args) {
                alert.show('Deleted', args.calendarEvent);
            }
        }];

        vm.cellIsOpen = false;

        vm.eventClicked = function (event) {
            alert.show('Clicked', event);
        };

        vm.eventEdited = function (event) {
            alert.show('Edited', event);
        };

        vm.eventDeleted = function (event) {
            alert.show('Deleted', event);
        };

        vm.eventTimesChanged = function (event) {
            alert.show('Dropped or resized', event);
        };

        vm.toggle = function ($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        };

        vm.timespanClicked = function (date, cell) {
            debugger
            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            }

        };

        $scope.updateValue = function (name) {

            // Use timeout to simulate a 650ms request.

        };

        $scope.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(item);
            }
        };

        $scope.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.isIndeterminate = function () {
            return ($scope.selected.length !== 0 &&
                $scope.selected.length !== $scope.items.length);
        };

        $scope.isChecked = function () {
            return $scope.selected.length === $scope.items.length;
        };
        $scope.toggleAll = function () {
            if ($scope.selected.length === $scope.items.length) {
                $scope.selected = [];
            } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
                $scope.selected = $scope.items.slice(0);
            }
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
angular
    .module('app.human-resource.timelog.monthlyplan')
    .factory('alert', function ($uibModal) {

        function show(action, event) {
            return $uibModal.open({
                templateUrl: 'modalContent.html',
                controller: function () {
                    var vm = this;
                    vm.action = action;
                    vm.event = event;
                },
                controllerAs: 'vm'
            });
        }
        return {
            show: show
        };
    });
angular.module('app.human-resource.timelog.monthlyplan').config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY');
    };
});



(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.attendance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_timelog_attendance', {
            url: '/Attendance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/timelog/attendance/attendance.html',
                    controller: 'AttendanceController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.timelog.attendance')
        .controller('AttendanceController', AttendanceController);
    /** @ngInject */
    function AttendanceController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdDialog, $document, $mdSidenav, $http, $window, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Timelog")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Attendancegrid = true;
        $scope.Export = true;
        $scope.Attendanceform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.ExportAdatas = function () {
            debugger

            var array = [];
            angular.forEach($scope.Attendancedatas, function (value) {
                try {
                    var ShiftName = undefined;
                    if (value.Shiftdetails.length > 0) {
                        ShiftName = value.Shiftdetails[0].ShiftName;
                    }

                    array.push({
                        EmployeeID: value.Employeedetails.EmployeeID,
                        EmployeeName: value.Employeedetails.EmployeeName,


                        ShiftName: ShiftName,
                        EntryType: value.EntryType,
                        Date: $filter('date')(value.TimeIn, 'dd/MM/yyyy'),
                        TimeIn: $filter('date')(value.TimeIn, 'hh:mm a'),
                        TimeOut: $filter('date')(value.TimeOut, 'hh:mm a'),
                    });
                }
                catch (e) {
                }
            })
            alasql('SELECT * INTO XLSX("Attendancedatas.xlsx",{headers:true}) FROM ?', [array]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.clearSearchTerm = function () {
            $scope.vm.searchShift = '';
            $scope.vm.searchPest = '';
        }

        $scope.uFrom = new Date();
        $scope.uTo = new Date();

        $scope.PrintTimeSheet = function () {

            if ($scope.EmployeeID == undefined) {
                $mdToast.show($mdToast.simple().textContent('Please Select Employee').position('top center'));
            }
            else {
                var item = $scope.EmployeeItems.filter(function (item) {
                    return item.id === $scope.EmployeeID;
                })[0];

                var url = $rootScope.ReportURL + "TimeSheetReport.aspx?EmployeeID=" + $scope.EmployeeID + "&FromDate=" + convertDate($scope.uFrom) + "&ToDate=" + convertDate($scope.uTo) + "&ClientID=" + $rootScope.Client_Id + "&EID=" + item.EmployeeID + "&EmployeeName=" + item.EmployeeName + "&From=" + new Date($scope.uFrom) + "&To=" + new Date($scope.uTo);
                window.open(url);

            }
        }

        $scope.PrintPaySlip = function () {

            if ($scope.EmployeeID == undefined) {
                $mdToast.show($mdToast.simple().textContent('Please Select Employee').position('top center'));
            }
            else {
                var item = $scope.EmployeeItems.filter(function (item) {
                    return item.id === $scope.EmployeeID;
                })[0];

                var url = $rootScope.ReportURL + "IndividualPaySlipReport.aspx?EmployeeID=" + $scope.EmployeeID + "&FromDate=" + convertDate($scope.uFrom) + "&ToDate=" + convertDate($scope.uTo) + "&ClientID=" + $rootScope.Client_Id + "&EID=" + item.EmployeeID + "&EmployeeName=" + item.EmployeeName + "&From=" + new Date($scope.uFrom) + "&To=" + new Date($scope.uTo);
                window.open(url);

            }
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        $scope.Datefilter = function () {
            debugger
            $scope.uFrom = new Date($scope.uFrom);
            $scope.uTo = new Date($scope.uTo);
            $scope.Attendancedatas = undefined;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/attendance/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Attendancedatas = GList.data.data;
            });
        }

        $scope.Showgrid = function () {
            $scope.Attendancegrid = true;
            $scope.Attendanceform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }

        $scope.sAdd = function (e) {

            ClearForm();
            $scope.Update = false;
            $scope.Attendanceform = false;
            $scope.Attendancegrid = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.vm.uDate = new Date();
            //$scope.vm.uTimeIn = new Date();
            $scope.vm.uTimeOut = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/timelog/attendance/Attendancepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AttendanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Attendanceinfo = function (e, AttendanceId) {
            $scope.SID = AttendanceId;
            $scope.Update = true;
            $scope.Attendancegrid = true;
            $scope.Export = true;
            $scope.view = false;
            $scope.Add = true;
            $scope.Search = true;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/timelog/attendance/Attendancepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AttendanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            angular.forEach($scope.Attendancedatas, function (value) {
                if (value._id === AttendanceId) {
                    $scope.SID = AttendanceId;
                    $scope.vm.uEmployee = value.Employee;
                    $scope.vm.uEmployee_id = value.Employee;
                    if ($scope.vm.uEmployee != null && $scope.vm.uEmployee != "" && $scope.vm.uEmployee != undefined) {
                        var array1 = [];
                        array1.push({ EmployeeName: $scope.vm.uEmployee });
                        $scope.vm.uEmployee = array1;
                    }
                    $scope.vm.EmpName = value.Employeedetails.EmployeeID + '-' + value.Employeedetails.EmployeeName;
                    $scope.vm.uShift = value.Shift;
                    $scope.vm.Latitude = value.Latitude;
                    $scope.vm.Longitude = value.Longitude;
                    $scope.vm.uDate = new Date(value.TimeIn);
                    $scope.vm.EntryType = value.EntryType;
                    $scope.vm.uTimeIn = new Date(value.TimeIn);
                    $scope.vm.uTimeOut = value.TimeOut;
                    if ($scope.vm.uTimeOut != null && $scope.vm.uTimeOut != '' && $scope.vm.uTimeOut != undefined) {
                        $scope.vm.uTimeOut = new Date(value.TimeOut);
                    }
                }
            });
        }

        $scope.sSubmit = function () {
            debugger
            $scope.CDate = $scope.vm.uDate;
            $scope.In = $scope.vm.uTimeIn;
            $scope.Out = $scope.vm.uTimeOut;

            $scope.addDateforTimeIn = new Date($scope.In.setDate(new Date($scope.CDate).getDate()));
            $scope.addMonthforTimeIn = new Date($scope.addDateforTimeIn.setMonth(new Date($scope.CDate).getMonth()));
            $scope.addYearforTimeIn = new Date($scope.addMonthforTimeIn.setFullYear(new Date($scope.CDate).getFullYear()));
            $scope.TimeIn = $scope.addYearforTimeIn;

            $scope.addDateforTimeOut = new Date($scope.Out.setDate(new Date($scope.CDate).getDate()));
            $scope.addMonthforTimeOut = new Date($scope.addDateforTimeOut.setMonth(new Date($scope.CDate).getMonth()));
            $scope.addYearforTimeOut = new Date($scope.addMonthforTimeOut.setFullYear(new Date($scope.CDate).getFullYear()));
            $scope.TimeOut = $scope.addYearforTimeOut;
            debugger
            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/attendance/update",
                    data: {
                        _id: $scope.SID,
                        Client_Id: $rootScope.Client_Id,
                        Employee: $scope.vm.uEmployee_id,
                        Shift: $scope.vm.uShift,
                        TimeIn: $scope.TimeIn,
                        TimeOut: $scope.TimeOut,
                        Latitude: $scope.vm.Latitude,
                        Longitude: $scope.vm.Longitude,
                        EntryType: $scope.vm.EntryType,
                        UpdatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $mdDialog.cancel();
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var info = $scope.vm.uEmployee;
                for (var i = 0; i < info.length; i++) {
                    debugger
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attendance/add",
                        data: {
                            Client_Id: $rootScope.Client_Id,
                            Employee: info[i].id,
                            Shift: $scope.vm.uShift,
                            TimeIn: $scope.TimeIn,
                            TimeOut: $scope.TimeOut,
                            EntryType: 'Manual',
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                }
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        $scope.timeDuration = function (uTimeIn, uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var t1 = moment(uTimeIn);
                var t2 = moment(uTimeOut);
                var seconds = t2.diff(t1, 'seconds');
                $scope.Seconds = seconds;
                var date = new Date(null);
                date.setSeconds($scope.Seconds);
                return date.toISOString().substr(11, 5);
            }
            else { return null }
        }

        $scope.Totla = function (uTimeIn, uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var t1 = moment(uTimeIn);
                var t2 = moment(uTimeOut);
                var seconds = t2.diff(t1, 'seconds');
                $scope.Seconds = seconds;
                var date = new Date(null);
                date.setSeconds($scope.Seconds);
                return date.toISOString().substr(11, 5);
            }
            else { return null }
        }

        $scope.OT = function (uTimeIn, uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                //var dd = new Date().getDate();
                //var mm = new Date().getMonth() + 1;
                //var yy = new Date().getFullYear();
                //var hh = new Date(uTimeIn).getHours();
                //var ms = new Date(uTimeIn).getMinutes();
                //var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;

                var dd = new Date();
                var hh = uTimeIn;
                var mm = new Date(hh.setDate(new Date(dd).getDate()));
                var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                var x = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                var uTimeIn = new Date(x);

                //var edd = new Date().getDate();
                //var emm = new Date().getMonth() + 1;
                //var eyy = new Date().getFullYear();
                //var ehh = new Date(uTimeOut).getHours();
                //var ems = new Date(uTimeOut).getMinutes();
                //var y = eyy + ',' + emm + ',' + edd + ' ' + ehh + ':' + ems;
                var dd = new Date();
                var hh = uTimeOut;
                var mm = new Date(hh.setDate(new Date(dd).getDate()));
                var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                var y = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                var uTimeOut = new Date(y);

                if (new Date(uTimeOut) > new Date(uTimeIn)) {
                    var t1 = moment(uTimeIn);
                    var t2 = moment(uTimeOut);
                    var seconds = t2.diff(t1, 'seconds');
                    $scope.Seconds = seconds;
                    var date = new Date(null);
                    date.setSeconds($scope.Seconds);
                    return date.toISOString().substr(11, 5);
                }
                else { }
            }
            else { return null }
        }

        $scope.Showlocation = function (Latitude, Longitude) {
            if (Latitude != null && Latitude != '' && Latitude != undefined) {
                $window.open('https://www.latlong.net/c/?lat=' + Latitude + '&long=' + Longitude)
            } else {
                $window.open('https://www.latlong.net/c/?lat=1.278023&long=103.680694')
            }
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (EmployeeLengthdata) {
            $scope.EmployeeItems = EmployeeLengthdata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/scheduler/uniquescheduler",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (uniquescheduler) {
            $scope.Uniqueschedulerdatas = uniquescheduler.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/monthlyplan",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (monthlyplan) {
            $scope.Monthlyplandatas = monthlyplan.data.data;
            $scope.Datefilter();
        });
        //$http({
        //    method: "POST",
        //    url:  $rootScope.WebURL + "/attendance",
        //    data: { Client_Id: $rootScope.Client_Id },
        //}).then(function (Attendancedata) {
        //    $scope.Attendancedatas = Attendancedata.data.data;
        //});

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/shift",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Shiftdata) {
                $scope.Shiftdatas = Shiftdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/uniquescheduler",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (uniquescheduler) {
                $scope.Uniqueschedulerdatas = uniquescheduler.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/monthlyplan",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (monthlyplan) {
                $scope.Monthlyplandatas = monthlyplan.data.data;
                $scope.Datefilter();
            });

            //$http({
            //    method: "POST",
            //    url:  $rootScope.WebURL + "/attendance",
            //    data: { Client_Id: $rootScope.Client_Id },
            //}).then(function (Attendancedata) {
            //         $scope.Attendancedatas = Attendancedata.data.data;
            //     });
        }

        function ClearForm() {
            $scope.vm.uShift = '';
            $scope.vm.uDate = new Date();
            $scope.vm.uTimeIn = '';
            $scope.vm.uTimeOut = '';
        }



        $scope.PreviousMonth = function () {

            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;

        }
        $scope.CurrentMonth = function () {

            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth());
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;

        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }




})();



(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.payslip', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_payslip', {
            url: '/PaySlip',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/payslip/payslip.html',
                    controller: 'payslipController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.payslip')
        .controller('payslipController', payslipController);

    /** @ngInject */
    function payslipController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdDialog, $document, $mdSidenav, $http, $filter) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Payrollgrid = true;
        $scope.Search = true;
        $scope.view = false;

        LoadCurrentMonth();

        $scope.PrintPaySlip = function () {
            var url = $rootScope.ReportURL + "PaySlipReport.aspx?ClientID=" + $rootScope.Client_Id + "&FromDate=" + convertDate($scope.uFrom) + "&ToDate=" + convertDate($scope.uTo);
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/payrollsettings",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Payrolldata) {
            $scope.Paysettingsdatas = Payrolldata.data.data;
            $scope.Filled = [];
            angular.forEach($scope.Paysettingsdatas, function (value) {
                $scope.Filled.push(value.Employee_Id)
            })
            $scope.Blank = $scope.Employeelength.length - $scope.Filled.length;
        });


        $scope.PreviousMonth = function () {

            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;

        }
        $scope.CurrentMonth = function () {
            LoadCurrentMonth();
        }
        function LoadCurrentMonth() {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth());
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.payrollsetting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_payrollsetting', {
            url: '/Payroll',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/payrollsetting/payrollsetting.html',
                    controller: 'payrollsettingController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.payrollsetting')
        .controller('payrollsettingController', payrollsettingController);

    /** @ngInject */
    function payrollsettingController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdDialog, $document, $mdSidenav, $http) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Payrollgrid = true;
        $scope.Export = true;
        $scope.Payrollform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;

        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Paysettingsdatas.xlsx",{headers:true}) FROM ?', [$scope.Paysettingsdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.Datefilter = function () {

            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/Payroll/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Paysettingsdatas = GList.data.data;
            });
        }
        $scope.Payrollinfo = function (PayrollId) {
            $scope.SID = PayrollId;
            $scope.Update = true;
            $scope.Payrollgrid = false;
            $scope.Payrollform = true;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            try {
                var item = $scope.Paysettingsdatas.filter(function (item) {
                    return item.id === PayrollId;
                })[0];
                $scope.vm.EmployeeName = item.EmployeeName
                $scope.vm.EffectiveDate = new Date(item.EffectiveDate)

                $scope.vm.Employee = [];
                $scope.vm.Employee_Id = item.Employee_Id
                $scope.vm.Employee.push({ id: $scope.vm.Employee_Id })

                if (item.FromDate != null && item.FromDate != undefined && item.FromDate != "") {
                    $scope.vm.FromDate = new Date(item.FromDate)
                }
                if (item.ToDate != null && item.ToDate != undefined && item.ToDate != "") {
                    $scope.vm.ToDate = new Date(item.ToDate)
                }
                $scope.vm.EmployeeID = item.EmployeeID
                $scope.vm.BasicPay = item.BasicPay
                $scope.vm.Amount = parseFloat(item.Amount)
                $scope.vm.PayCycle = item.PayCycle
                $scope.vm.OTEligible = item.OTEligible
                if ($scope.vm.OTEligible == 'Yes') { $scope.OT = { value: true } }
                else { $scope.OT = { value: false } }
                $scope.vm.SDF = parseFloat(item.SDF)
                $scope.vm.BankName = item.BankName
                $scope.BIC = item.BIC
                $scope.BankCode = item.BankCode
                $scope.vm.Acc = item.Acc
                $scope.vm.AgencyAmount = parseFloat(item.AgencyAmount)
                $scope.vm.CPFType = item.CPFType
                $scope.vm.payment = item.PaymentMode
            }
            catch (e) { }
            IncrementFilterGrid();
            RefreshGridallowance();
        }
        $scope.AddAllowance = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/payroll/payrollsetting/Allowancepop.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function payrollsettingController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.ADAmount = null;
            $scope.vm.Amount = null;
            $scope.vm.TypeName = null;
            $scope.vm.Date = null;
            $scope.AD = { value: false };
            $scope.vm.MonthReq = null;
            $scope.AEUpdate = false;
        }
        $scope.Allowanceinfo = function (e, AEId) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/payroll/payrollsetting/Allowancepop.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function payrollsettingController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.AEUpdate = true;
            angular.forEach($scope.AllowanceEmployeedatas, function (value, key) {
                try {
                    if (AEId == value.id) {
                        $scope.AEId = AEId;
                        $scope.vm.TypeName = value.TypeName;
                        $scope.vm.ADAmount = parseFloat(value.Amount);
                        $scope.vm.Date = value.Date;
                        if ($scope.vm.Date != null && $scope.vm.Date != undefined && $scope.vm.Date != "") {
                            $scope.vm.Date = new Date($scope.vm.Date)
                        }
                        $scope.vm.MonthReq = value.MonthReq;
                        if ($scope.vm.MonthReq == 'Yes') { $scope.AD = { value: true }; }
                        else { $scope.AD = { value: false }; }
                    }
                }
                catch (e) { }
            });
        }
        $scope.Alertpopup = function (e, deleteID, which) {
            $scope.AWCEmployeediv = false;
            $scope.IncrementE = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/payroll/payrollsetting/Alert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PayController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.AllowanceEmployeeId = deleteID;
            if (which == 'AWCEmployee') { $scope.AWCEmployeediv = true; }
            if (which == 'IncrementE') { $scope.IncrementE = true; }
        }
        $scope.AD = { value: false };
        $scope.AllowanceSubmit = function () {
            if ($scope.AD.value == true) { $scope.vm.MonthReq = 'Yes' }
            else { $scope.vm.MonthReq = 'No' }
            if ($scope.AEUpdate === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/allowanceEmployee/update",
                    data: {
                        _id: $scope.AEId, TypeName: $scope.vm.TypeName, AllowanceType: $scope.vm.AllowanceType, Amount: $scope.vm.ADAmount,
                        Date: $scope.vm.Date, MonthReq: $scope.vm.MonthReq,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $mdDialog.cancel();
                    RefreshGridallowance();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                if ($scope.vm.Employee != null && $scope.vm.Employee != "" && $scope.vm.Employee != undefined) {
                    var info = $scope.vm.Employee;
                    for (var i = 0; i < info.length; i++) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/allowanceEmployee/add",
                            data: {
                                TypeName: $scope.vm.TypeName, AllowanceType: $scope.vm.AllowanceType, Amount: $scope.vm.ADAmount,
                                Date: $scope.vm.Date, MonthReq: $scope.vm.MonthReq, Employee_Id: info[i].id,
                                CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                            },
                        });
                    }
                    response.then(function (GList) {
                        $scope.vm.Employee_Id = GList.data.data.Employee_Id;
                        RefreshGridallowance();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        $mdDialog.hide();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                    });
                }
            }
        }
        $scope.AllowanceEmployeedelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/allowanceEmployee/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                RefreshGridallowance();
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.IncrementSubmit = function () {
            if ($scope.vm.Employee != null && $scope.vm.Employee != "" && $scope.vm.Employee != undefined) {
                var info = $scope.vm.Employee;
                for (var i = 0; i < info.length; i++) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/increment/add",
                        data: {
                            IncrementAmount: $scope.vm.IncrementAmount, IncrementDate: $scope.vm.IncrementEffectiveDate,
                            Employee_Id: info[i].id,
                            CreatedBy: $rootScope.createdby, IsActive: true
                        },
                    });
                }
                response.then(function (GList) {
                    $scope.vm.Employee_Id = GList.data.data.Employee_Id;
                    IncrementFilterGrid();
                    $scope.vm.IncrementAmount = null;
                    $scope.vm.IncrementEffectiveDate = null;
                }, function () {
                });
            }
        }
        $scope.getBIC = function (Bank) {
            if (Bank != null) {
                var item = $scope.HRMBankdatas.filter(function (item) {
                    return item.BankName === Bank
                })[0];
                $scope.BIC = item.BIC;
                $scope.BankCode = item.BankCode;
            } else {
                $scope.BIC = '';
                $scope.BankCode = '';
            }
        }
        $scope.sSubmit = function () {
            if ($scope.OT.value == true) { $scope.vm.OTEligible = 'Yes' }
            else { $scope.vm.OTEligible = 'No' }
            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/payrollsettings/update",
                    data: {
                        _id: $scope.SID,
                        EmployeeName: $scope.vm.EmployeeName,
                        EffectiveDate: $scope.vm.EffectiveDate,
                        Employee_Id: $scope.vm.Employee_Id,
                        FromDate: $scope.vm.FromDate,
                        ToDate: $scope.vm.ToDate,
                        BasicPay: $scope.vm.BasicPay,
                        Amount: $scope.vm.Amount,
                        PayCycle: $scope.vm.PayCycle,
                        PaymentMode: $scope.vm.payment,
                        OTEligible: $scope.vm.OTEligible,
                        AgencyAmount: $scope.vm.AgencyAmount,
                        CPFType: $scope.vm.CPFType,
                        SDF: $scope.vm.SDF,
                        BankName: $scope.vm.BankName,
                        BankCode: $scope.BankCode,
                        BIC: $scope.BIC,
                        Acc: $scope.vm.Acc,
                        EmployeeID: $scope.vm.EmployeeID,
                        UpdatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Payrollgrid = true;
                    $scope.Payrollform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var info = $scope.vm.Employee;
                try {
                    for (var i = 0; i < info.length; i++) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/payrollsettings/add",
                            data: {
                                EmployeeName: info[i].EmployeeName,
                                EffectiveDate: $scope.vm.EffectiveDate,
                                Employee_Id: info[i].id,
                                FromDate: $scope.vm.FromDate,
                                ToDate: $scope.vm.ToDate,
                                BasicPay: $scope.vm.BasicPay,
                                Amount: $scope.vm.Amount,
                                PayCycle: $scope.vm.PayCycle,
                                PaymentMode: $scope.vm.payment,
                                OTEligible: $scope.vm.OTEligible,
                                AgencyAmount: $scope.vm.AgencyAmount,
                                CPFType: $scope.vm.CPFType,
                                SDF: $scope.vm.SDF,
                                BankName: $scope.vm.BankName,
                                BankCode: $scope.BankCode,
                                BIC: $scope.BIC,
                                Acc: $scope.vm.Acc,
                                EmployeeID: info[i].EmployeeID,
                                CreatedBy: $rootScope.createdby,
                                Client_Id: $rootScope.Client_Id,
                            },
                        });
                    }
                }
                catch (e) { }
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Payrollgrid = true;
                    $scope.Payrollform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.DeleteIncrement = function (deleteId) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/increment/delete",
                data: {
                    _id: deleteId
                },
            });
            response.then(function (GList) {
                IncrementFilterGrid();
                $mdDialog.cancel();
            }, function () {
            });
        }
        $scope.GetEmployees = function () {

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (employeedata) {
                var EmpArray = [];
                angular.forEach(employeedata.data.data, function (value) {
                    if ($scope.Filled.indexOf(value.id) > -1) {
                    }
                    else {
                        EmpArray.push(value)
                    }
                })

                $scope.Employeedatas = EmpArray;
            });
        }
        // $scope.Calculate = function () {
        //     var item = $scope.Employeedatas.filter(function (item) {
        //         return item.id === $scope.vm.Employee_Id;
        //     })[0];
        //     debugger
        //     if (item.DateofBirth != null && item.DateofBirth != undefined && item.DateofBirth != '') {
        //         var DOB = new Date(item.DateofBirth);
        //         var percentage = null;
        //         var ageDifMs = new Date() - DOB.getTime();
        //         var ageDate = new Date(ageDifMs); // miliseconds from epoch
        //         var age = Math.abs(ageDate.getUTCFullYear() - 1970);
        //         if (age <= 55) { percentage = 20 }
        //         if (age > 55 && age <= 60) { percentage = 13 }
        //         if (age > 60 && age <= 65) { percentage = 7.5 }
        //         if (age > 65) { percentage = 5 }
        //         $scope.vm.CPFEmployee = (percentage * $scope.vm.Amount) / 100;

        //         if (age <= 55) { percentage = 17 }
        //         if (age > 55 && age <= 60) { percentage = 13 }
        //         if (age > 60 && age <= 65) { percentage = 9 }
        //         if (age > 65) { percentage = 7.5 }
        //         $scope.vm.CPFEmployer = (percentage * $scope.vm.Amount) / 100;
        //     }
        // }
        $scope.CalculateAgency = function (CPFType) {
            if (CPFType == "CDAC") {
                if ($scope.vm.Amount <= 2000) {
                    $scope.vm.AgencyAmount = 0.50;
                }
                if ($scope.vm.Amount > 2000 && $scope.vm.Amount <= 3500) {
                    $scope.vm.AgencyAmount = 1;
                }
                if ($scope.vm.Amount > 3500 && $scope.vm.Amount <= 5000) {
                    $scope.vm.AgencyAmount = 1.50;
                }
                if ($scope.vm.Amount > 5000 && $scope.vm.Amount <= 7500) {
                    $scope.vm.AgencyAmount = 2;
                }
                if ($scope.vm.Amount > 7500) {
                    $scope.vm.AgencyAmount = 3;
                }
            }
            if (CPFType == "ECF") {
                if ($scope.vm.Amount <= 1000) {
                    $scope.vm.AgencyAmount = 2;
                }
                if ($scope.vm.Amount > 1000 && $scope.vm.Amount <= 1500) {
                    $scope.vm.AgencyAmount = 4;
                }
                if ($scope.vm.Amount > 1500 && $scope.vm.Amount <= 2500) {
                    $scope.vm.AgencyAmount = 6;
                }
                if ($scope.vm.Amount > 2500 && $scope.vm.Amount <= 4000) {
                    $scope.vm.AgencyAmount = 9;
                }
                if ($scope.vm.Amount > 4000 && $scope.vm.Amount <= 7000) {
                    $scope.vm.AgencyAmount = 12;
                }
                if ($scope.vm.Amount > 7000 && $scope.vm.Amount <= 10000) {
                    $scope.vm.AgencyAmount = 16;
                }
                if ($scope.vm.Amount > 10000) {
                    $scope.vm.AgencyAmount = 20;
                }
            }
            if (CPFType == "SINDA") {
                if ($scope.vm.Amount <= 1000) {
                    $scope.vm.AgencyAmount = 1;
                }
                if ($scope.vm.Amount > 1000 && $scope.vm.Amount <= 1500) {
                    $scope.vm.AgencyAmount = 3;
                }
                if ($scope.vm.Amount > 1500 && $scope.vm.Amount <= 2500) {
                    $scope.vm.AgencyAmount = 5;
                }
                if ($scope.vm.Amount > 2500 && $scope.vm.Amount <= 4500) {
                    $scope.vm.AgencyAmount = 7;
                }
                if ($scope.vm.Amount > 4500 && $scope.vm.Amount <= 7500) {
                    $scope.vm.AgencyAmount = 9;
                }
                if ($scope.vm.Amount > 7500 && $scope.vm.Amount <= 10000) {
                    $scope.vm.AgencyAmount = 12;
                }
                if ($scope.vm.Amount > 10000 && $scope.vm.Amount <= 15000) {
                    $scope.vm.AgencyAmount = 18;
                }
                if ($scope.vm.Amount > 15000) {
                    $scope.vm.AgencyAmount = 30;
                }
            }
            if (CPFType == "MBMF") {
                if ($scope.vm.Amount <= 1000) {
                    $scope.vm.AgencyAmount = 3;
                }
                if ($scope.vm.Amount > 1000 && $scope.vm.Amount <= 2000) {
                    $scope.vm.AgencyAmount = 4.50;
                }
                if ($scope.vm.Amount > 2000 && $scope.vm.Amount <= 3000) {
                    $scope.vm.AgencyAmount = 6.50;
                }
                if ($scope.vm.Amount > 3000 && $scope.vm.Amount <= 4000) {
                    $scope.vm.AgencyAmount = 15;
                }
                if ($scope.vm.Amount > 4000 && $scope.vm.Amount <= 6000) {
                    $scope.vm.AgencyAmount = 19.50;
                }
                if ($scope.vm.Amount > 6000 && $scope.vm.Amount <= 8000) {
                    $scope.vm.AgencyAmount = 22;
                }
                if ($scope.vm.Amount > 8000 && $scope.vm.Amount <= 10000) {
                    $scope.vm.AgencyAmount = 24;
                }
                if ($scope.vm.Amount > 10000) {
                    $scope.vm.AgencyAmount = 26;
                }
            }
        }
        function calculateCPFEmployee(birthday) {
            var DOB = new Date(birthday);
            var percentage = null;
            var ageDifMs = new Date() - DOB.getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            var age = Math.abs(ageDate.getUTCFullYear() - 1970);
            if (age <= 55) { percentage = 20 }
            if (age > 55 && age <= 60) { percentage = 13 }
            if (age > 60 && age <= 65) { percentage = 7.5 }
            if (age > 65) { percentage = 5 }
            return (percentage * $scope.vm.Amount) / 100;
        }
        function calculateCPFEmployer(birthday) {
            var DOB = new Date(birthday);
            var percentage = null;
            var ageDifMs = new Date() - DOB.getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            var age = Math.abs(ageDate.getUTCFullYear() - 1970);
            if (age <= 55) { percentage = 17 }
            if (age > 55 && age <= 60) { percentage = 13 }
            if (age > 60 && age <= 65) { percentage = 9 }
            if (age > 65) { percentage = 7.5 }
            return (percentage * $scope.vm.Amount) / 100;
        }
        function RefreshGridallowance() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/allowanceEmployee/getByID",
                data: {
                    Employee_Id: $scope.vm.Employee_Id
                },
            });
            response.then(function (GList) {
                $scope.AllowanceEmployeedatas = GList.data.data;
            }, function () {
            });
        }

        function IncrementFilterGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/increment/getById",
                data: {
                    Employee_Id: $scope.vm.Employee_Id
                },
            });
            response.then(function (GList) {
                $scope.Incrementdatadatas = GList.data.data;
            }, function () {
            });
        }
        $scope.OT = { value: false }
        $scope.Showgrid = function () {
            $scope.Payrollgrid = true;
            $scope.Payrollform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.Payrollform = true;
            $scope.Payrollgrid = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.vm.EffectiveDate = new Date();
            $scope.OT = { value: false }
            $scope.vm.EmployeeID = null;
            $scope.GetEmployees();
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/bankhrm",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (BankHrmdata) {
            $scope.HRMBankdatas = BankHrmdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/allowance",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Allowancesdata) {
            $scope.Allowancesdatas = Allowancesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (employeedata) {
            debugger
            $scope.Employeelength = employeedata.data.data;
            $scope.Employeedatas = employeedata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/payrollsettings",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Payrolldata) {
            debugger
            $scope.Paysettingsdatas = Payrolldata.data.data;
            $scope.Filled = [];
            angular.forEach($scope.Paysettingsdatas, function (value) {
                $scope.Filled.push(value.Employee_Id)
            })
            $scope.Blank = $scope.Employeelength.length - $scope.Filled.length;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (employeedata) {
                $scope.Employeelength = employeedata.data.data;
                $scope.Employeedatas = employeedata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/allowance",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Allowancesdata) {
                $scope.Allowancesdatas = Allowancesdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/payrollsettings",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Payrolldata) {
                $scope.Paysettingsdatas = Payrolldata.data.data;
                $scope.Filled = [];
                angular.forEach($scope.Paysettingsdatas, function (value) {
                    $scope.Filled.push(value.Employee_Id)
                })
            });
        }

        function ClearForm() {
            $scope.Employeedatas = null;
            $scope.AllowanceEmployeedatas = null;
            $scope.Incrementdatadatas = null;
            $scope.vm.Employee = null;
            $scope.vm.EffectiveDate = null;
            $scope.vm.Empoyee_Id = null;
            $scope.vm.FromDate = null;
            $scope.vm.Amount = null;
            $scope.vm.ToDate = null;
            $scope.vm.BasicPay = null;
            $scope.vm.PayCycle = null;
            $scope.vm.OTEligible = null;
            $scope.vm.AgencyAmount = null;
            $scope.vm.CPFType = null;
            $scope.vm.SDF = null;
            $scope.vm.BankName = null;
            $scope.vm.Acc = null;
            $scope.vm.payment = null;
            $scope.vm.IncrementAmount = null;
            $scope.vm.IncrementEffectiveDate = null;
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.endmonth', ['moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_endmonth', {
            url: '/EndMonthPayroll',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/endmonth/endmonth.html',
                    controller: 'endmonthController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.endmonth')
        .controller('endmonthController', endmonthController);

    /** @ngInject */
    function endmonthController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $mdDialog, $document) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var monthFormat = buildLocaleProvider("MMM-YYYY");
        var ymdFormat = buildLocaleProvider("YYYY-MM-DD");

        $scope.dateFields = {
            type: 'date',
            required: false,
            binding: 'applicant.expectedGraduation',
            startView: 'month',
            label: 'Credit Card Expiry - Year/Month picker',
            mode: 'month',
            locale: monthFormat,
            selectedDate: moment(new Date())
        };

        LoadHoliday();

        RefreshGrid();

        $scope.OnMonthChange = function () {
            debugger

            var date = $scope.dateFields.selectedDate._d;

            RefreshGrid();
            LoadHoliday();
        }

        function LoadHoliday() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/calendar/getHolidayByMonth",
                data: { Client_Id: $rootScope.Client_Id, StartDate: StartDate, EndDate: EndDate },
            }).then(function (Holidaydata) {

                $scope.Holidaydatas = Holidaydata.data.data;

                CalendarWorkingDays();
            });

        }

        function RefreshGrid() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/endmonthpayroll/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (Payrolldata) {
                $scope.Payrolldatas = Payrolldata.data.data;
                LoadAttendance();
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/payrollsettings/getemployeedeatils",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;

            });

        }

        function LoadAttendance() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/endmonthpayroll/getAttendanceByEmployeeID",
                data: { Client_Id: $rootScope.Client_Id, FromDate: StartDate, ToDate: EndDate },
            }).then(function (Attendancedata) {
                $scope.Attendancedatas = Attendancedata.data.data;

                LoadDetails();
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/endmonthpayroll/getLeaveDetails",
                data: { Client_Id: $rootScope.Client_Id, FromDate: StartDate, ToDate: EndDate },
            }).then(function (Leavedata) {

                $scope.Leavedatas = Leavedata.data.data;

            });


        }
        function LoadDetails() {

            var EndMonthData = [];

            angular.forEach($scope.Employeedatas, function (value) {

                var EmployeeID = undefined;
                var _id = undefined;
                var EmployeeName = undefined;
                var BankName = undefined;
                var Acc = undefined;
                var EDateOfJoin = undefined;
                var WorkWeekdetails = undefined;
                var Amount = undefined;
                var Remarks = undefined;
                var IsConfirmed = false;
                var PayRollID = -1;
                var TotalWorkedDays = 0;
                var CalendarDays = 0;
                var IncrementAmount = 0;
                var IncrementDate = 0;

                EmployeeID = value.EmployeeID;
                EmployeeName = value.EmployeeName;
                EDateOfJoin = value.EDateOfJoin;
                PayRollID = value.PayRollID;

                if (value.Payrolldetails.length > 0) {
                    BankName = value.Payrolldetails[0].BankName;
                    Acc = value.Payrolldetails[0].Acc;
                    Amount = value.Payrolldetails[0].Amount;
                }

                if (value.Incrementdetails.length > 0) {

                    angular.forEach(value.Incrementdetails, function (Ivalue) {

                        IncrementDate = Ivalue.IncrementDate;

                        if (new Date(IncrementDate) <= new Date()) {

                            IncrementAmount = IncrementAmount + parseFloat(Ivalue.IncrementAmount);
                        }
                    });

                }

                Amount = parseFloat(Amount) + IncrementAmount;

                if (value.WorkWeekdetails.length > 0) {
                    WorkWeekdetails = value.WorkWeekdetails[0];
                    CalendarDays = CalendarWorkingDays(WorkWeekdetails)
                }

                if ($scope.Payrolldatas != undefined) {
                    var item = $scope.Payrolldatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (item != undefined) {

                        IsConfirmed = item.IsConfirmed;
                        Remarks = item.Remarks;
                        PayRollID = item._id;
                    }
                }

                if ($scope.Attendancedatas != undefined) {

                    var Attendanceitem = $scope.Attendancedatas.filter(function (Avalue) {
                        return Avalue.Employee === value._id;
                    });
                    var Leaveitem = [];
                    if ($scope.Leavedatas != undefined) {
                        var Leaveitem = $scope.Leavedatas.filter(function (Lvalue) {
                            return Lvalue.EmployeeID === value._id;
                        });
                    }

                    TotalWorkedDays = AttendanceCalculation(Attendanceitem, WorkWeekdetails, Leaveitem);
                }


                EndMonthData.push({
                    _id: value._id,
                    EmployeeID: EmployeeID,
                    EmployeeName: EmployeeName,
                    BankName: BankName,
                    Acc: Acc,
                    EDateOfJoin: EDateOfJoin,
                    WorkWeekdetails: WorkWeekdetails,
                    Amount: Amount,
                    Remarks: Remarks,
                    IsConfirmed: IsConfirmed,
                    PayRollID: PayRollID,
                    TotalWorkedDays: TotalWorkedDays,
                    CalendarDays: CalendarDays
                });

            });

            $scope.EndMonthData = EndMonthData;
        }

        function AttendanceCalculation(data, WorkingDays, Leavedatas) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var TotalDays = 0;
            angular.forEach(data, function (value) {
                var TimeIn = value.TimeIn;
                var TimeOut = value.TimeOut;

                if (value.Shiftdetails != null && value.Shiftdetails != undefined && value.Shiftdetails.length > 0) {

                    var ShiftStartTime = value.Shiftdetails[0].ShiftStartTime;
                    var ShiftEndTime = value.Shiftdetails[0].ShiftEndTime;
                    var LunchBreakStartTime = value.Shiftdetails[0].LunchBreakStartTime;
                    var LunchBreakEndTime = value.Shiftdetails[0].LunchBreakEndTime;

                    if (TimeOut != null && TimeOut != undefined) {

                        var lunch = TimeSpan.FromDates(new Date(LunchBreakEndTime), new Date(LunchBreakStartTime), true).hours();
                        var basichour = TimeSpan.FromDates(new Date(ShiftEndTime), new Date(ShiftStartTime), true).hours();

                        basichour = (basichour - (lunch));

                        var Totaltimespan = 0;
                        if (moment(TimeIn).format("hh:mm:ss") < moment(ShiftStartTime).format("hh:mm:ss")) {

                            Totaltimespan = TimeSpan.FromDates(new Date(TimeOut), new Date(ShiftStartTime), true)
                        }
                        else {

                            Totaltimespan = TimeSpan.FromDates(new Date(TimeOut), new Date(TimeIn), true)
                        }

                        var timespan = Totaltimespan.hours() + "." + Totaltimespan.minutes();

                        var workedhours = (parseFloat(timespan) - parseFloat(lunch));

                        var d = new Date(TimeIn);
                        var dayName = days[d.getDay()];
                        if (dayName == "Monday") {
                            if (Monday > 0) {

                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                        if (dayName == "Tuesday") {
                            if (Tuesday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                        if (dayName == "Wednesday") {
                            if (Wednesday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                        if (dayName == "Thursday") {
                            if (Thursday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                        if (dayName == "Friday") {
                            if (Friday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                        if (dayName == "Saturday") {
                            if (Saturday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        } if (dayName == "Sunday") {
                            if (Sunday > 0) {
                                if (workedhours > 7.45) {
                                    TotalDays = TotalDays + 1;
                                }
                                else if (workedhours > 3.45) {
                                    TotalDays = TotalDays + 0.5;
                                }
                            }
                        }
                    }
                }

            });

            angular.forEach(Leavedatas, function (value) {
                TotalDays = TotalDays + parseFloat(value.TotalPaidLeaves);
            });

            return TotalDays;

        }


        $scope.EditSelected = function (e) {

            $scope.vm.Remarks = undefined;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/endmonth/bulkeditpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.EditIndividual = function (EmployeeID, e) {

            $scope.vm.TotalDays = 0;
            $scope.vm.DayRate = 0;
            $scope.vm.NetPay = 0;
            $scope.vm.Remarks = undefined;

            $scope.IndividualEmployeeID = EmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];


            if (item.WorkWeekdetails != undefined) {
                $scope.vm.TotalDays = item.TotalWorkedDays;
                $scope.vm.DayRate = parseFloat($scope.DayRate(item.Amount, item.CalendarDays)).toFixed(2);
                $scope.vm.NetPay = parseFloat($scope.NetPay($scope.DayRate(item.Amount, item.CalendarDays), $scope.vm.TotalDays)).toFixed(2);
            }

            $scope.vm.Remarks = item.Remarks

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/endmonth/editpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitIndividual = function () {

            var EmployeeID = $scope.IndividualEmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];

            if (item.PayRollID == -1) {
                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/endmonthpayroll/add",
                    data: {
                        EmployeeID: EmployeeID, TotalDays: $scope.vm.TotalDays, Month: $scope.dateFields.selectedDate._d,
                        DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                        CalendarDays: item.CalendarDays, CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
            else {

                var responses = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/endmonthpayroll/update",
                    data: {
                        _id: item.PayRollID, EmployeeID: EmployeeID, TotalDays: $scope.vm.TotalDays, IsConfirmed: item.IsConfirmed,
                        DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: $scope.vm.Remarks, CalendarDays: item.CalendarDays,
                        UpdatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
        }

        $scope.ConfirmSelected = function (e) {

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/endmonth/alertpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.UpdateSelected = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                $scope.vm.TotalDays = 0;
                $scope.vm.DayRate = 0;
                $scope.vm.NetPay = 0;

                if (item.WorkWeekdetails != undefined) {
                    $scope.vm.TotalDays = item.TotalWorkedDays;
                    $scope.vm.DayRate = parseFloat($scope.DayRate(item.Amount, item.CalendarDays)).toFixed(2);
                    $scope.vm.NetPay = parseFloat($scope.NetPay($scope.DayRate(item.Amount, item.CalendarDays), $scope.vm.TotalDays)).toFixed(2);
                }

                if (item.PayRollID == -1) {
                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/endmonthpayroll/add",
                        data: {
                            EmployeeID: item._id, TotalDays: $scope.vm.TotalDays, Month: $scope.dateFields.selectedDate._d, CalendarDays: item.CalendarDays,
                            DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }
                else {
                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/endmonthpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, TotalDays: $scope.vm.TotalDays, IsConfirmed: item.IsConfirmed,
                            DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: $scope.vm.Remarks, CalendarDays: item.CalendarDays,
                            UpdatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }




            })


        }

        $scope.ConfirmPayroll = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                $scope.vm.TotalDays = 0;
                $scope.vm.DayRate = 0;
                $scope.vm.NetPay = 0;

                if (item.WorkWeekdetails != undefined) {
                    $scope.vm.TotalDays = item.TotalWorkedDays;
                    $scope.vm.DayRate = parseFloat($scope.DayRate(item.Amount, item.CalendarDays)).toFixed(2);
                    $scope.vm.NetPay = parseFloat($scope.NetPay($scope.DayRate(item.Amount, item.CalendarDays), $scope.vm.TotalDays)).toFixed(2);
                }


                if (item.PayRollID == -1) {

                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/endmonthpayroll/add",
                        data: {
                            EmployeeID: item._id, TotalDays: $scope.vm.TotalDays, Month: $scope.dateFields.selectedDate._d, CalendarDays: item.CalendarDays,
                            DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: item.Remarks, IsConfirmed: true,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                } else {

                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/endmonthpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, TotalDays: $scope.vm.TotalDays, CalendarDays: item.CalendarDays,
                            DayRate: $scope.vm.DayRate, NetPay: $scope.vm.NetPay, Remarks: item.Remarks, IsConfirmed: true,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })

                }

            });


        }

        $scope.SelectedIds = [];
        $scope.CheckAll = function (IsTicked) {
            if (IsTicked == true) {
                $scope.TRCdiv = true;
                angular.forEach($scope.EndMonthData, function (value) {
                    if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
                })
                $scope.Selec = { value: true }
            }
            if (IsTicked == false) {
                $scope.TRCdiv = false;
                $scope.SelectedIds = [];
                $scope.Selec = { value: false }
            }
        }
        $scope.Check = function (TrF, Ids) {
            if (TrF == true) {
                $scope.TRCdiv = true;
                if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
            }
            if (TrF == false) {
                $scope.TRCdiv = false;
                var index = $scope.SelectedIds.indexOf(Ids);
                if (index > -1) {
                    $scope.SelectedIds.splice(index, 1);
                }
            }
            if ($scope.SelectedIds.length > 0) {
                $scope.TRCdiv = true;
            }
        }
        $scope.TRCdiv = false;

        $scope.TotalWorkingDays = function (WorkingDays, EmployeeID) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var Holidays = 0;
            if ($scope.Holidaydatas != undefined && $scope.Holidaydatas.length > 0) {
                Holidays = $scope.Holidaydatas.length;
            }

            // var TotalCalendarDays = daysInMonth(date.getMonth() + 1, date.getFullYear())

            // var TotalWorkingDays = TotalCalendarDays - Holidays;
            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var dates = getDates(StartDate, EndDate);

            var TotalDays = 0;

            angular.forEach(dates, function (value) {

                var d = new Date(value);
                var dayName = days[d.getDay()];
                if (dayName == "Monday") {
                    if (Monday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Tuesday") {
                    if (Tuesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Wednesday") {
                    if (Wednesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Thursday") {
                    if (Thursday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Friday") {
                    if (Friday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Saturday") {
                    if (Saturday > 0) {
                        TotalDays++;
                    }
                } if (dayName == "Sunday") {
                    if (Sunday > 0) {
                        TotalDays++;
                    }
                }
            });


            // var item = $scope.Attendancedatas.filter(function (value) {
            //     return value.Employee === EmployeeID;
            // });

            var TotalWorkingCalendarDays = TotalDays - Holidays;

            return TotalWorkingCalendarDays;
        }

        $scope.RecordStatus = function (row) {

            if (row.IsConfirmed == true) {
                return "GreenColor";
            }
            else {
                return "RedColor"
            }
        }

        $scope.DayRate = function (a, b) {

            if (parseFloat(a) > 0) {
                var TotalDays = parseFloat(b);
                return parseFloat(parseFloat(a) / TotalDays);
            }
            else {
                return 0;
            }
        }

        $scope.NetPay = function (a, b) {

            if (parseFloat(a) > 0) {
                return parseFloat(parseFloat(a) * parseFloat(b)).toFixed(2);
            }
            else {
                return 0;
            }
        }


        $scope.Exportdata = function () {
            alasql('SELECT EmployeeID,  EmployeeName, BankName, Acc,formatdate(EDateOfJoin) AS  DateOfJoin,ConvertFloat(Amount) AS BasicPay, CalendarDays,TotalWorkedDays,DayRate(Amount,CalendarDays) As DayRate ,NetPay(DayRate(Amount,CalendarDays),TotalWorkedDays) As NetPay,Remarks INTO XLSX("EndMonthPayroll.xlsx",{headers:true}) FROM ?', [$scope.EndMonthData]);
        };

        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        // Returns an array of dates between the two dates
        var getDates = function (startDate, endDate) {
            var dates = [],
                currentDate = startDate,
                addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
            while (currentDate <= endDate) {
                dates.push(currentDate);
                currentDate = addDays.call(currentDate, 1);
            }
            return dates;
        };

        function CalendarWorkingDays(WorkingDays) {

            var Monday = 8;
            var Tuesday = 8;
            var Wednesday = 8;
            var Thursday = 8;
            var Friday = 8;
            var Saturday = 8;
            var Sunday = 0;

            if (WorkingDays != undefined) {
                Monday = parseInt(WorkingDays.Monday);
                Tuesday = parseInt(WorkingDays.Tuesday);
                Wednesday = parseInt(WorkingDays.Wednesday);
                Thursday = parseInt(WorkingDays.Thursday);
                Friday = parseInt(WorkingDays.Friday);
                Saturday = parseInt(WorkingDays.Saturday);
                Sunday = parseInt(WorkingDays.Sunday);
            }

            var Holidays = 0;
            if ($scope.Holidaydatas != undefined && $scope.Holidaydatas.length > 0) {
                Holidays = $scope.Holidaydatas.length;
            }

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var dates = getDates(StartDate, EndDate);

            var TotalDays = 0;

            angular.forEach(dates, function (value) {

                var d = new Date(value);
                var dayName = days[d.getDay()];
                if (dayName == "Monday") {
                    if (Monday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Tuesday") {
                    if (Tuesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Wednesday") {
                    if (Wednesday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Thursday") {
                    if (Thursday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Friday") {
                    if (Friday > 0) {
                        TotalDays++;
                    }
                }
                if (dayName == "Saturday") {
                    if (Saturday > 0) {
                        TotalDays++;
                    }
                } if (dayName == "Sunday") {
                    if (Sunday > 0) {
                        TotalDays++;
                    }
                }
            });


            var TotalWorkingCalendarDays = TotalDays - Holidays;

            return TotalWorkingCalendarDays;

        }

        function sundaysInMonth(y, m) {
            var days = new Date(y, m, 0).getDate();
            var sundays = [8 - (new Date(m + '/01/' + y).getDay())];
            for (var i = sundays[0] + 7; i < days; i += 7) {
                sundays.push(i);
            }
            return sundays;
        }

        function daysInMonth(month, year) {
            return new Date(year, month, 0).getDate();
        }


        $scope.WorkedMonth = function (a) {
            var b = new Date();
            return momentDiff1(a, b);
        }

        function momentDiff1(a, b) {

            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');

            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        function buildLocaleProvider(formatString) {
            return {
                formatDate: function (date) {
                    if (date) return moment(date).format(formatString);
                    else return null;
                },
                parseDate: function (dateString) {
                    if (dateString) {
                        var m = moment(dateString, formatString, true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    } else return null;
                }
            };
        }

        alasql.fn.formatdate = function (dateStr) {

            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(dateStr);

            if (d.getFullYear() > 2000) {

                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            }
            else {
                return "";
            }
        };

        alasql.fn.booleanvalue = function (str) {

            if (str == true) {

                return "Yes"
            }
            else {
                return "No";
            }
        };

        alasql.fn.DayRate = function (a, b) {

            if (parseFloat(a) > 0) {
                var TotalDays = parseFloat(b);
                return parseFloat(parseFloat(a) / TotalDays).toFixed(2);
            }
            else {
                return 0;
            }
        }

        alasql.fn.NetPay = function (a, b) {

            if (parseFloat(a) > 0) {
                return parseFloat(parseFloat(a) * parseFloat(b)).toFixed(2);
            }
            else {
                return 0;
            }
        }

        alasql.fn.ConvertFloat = function (value) {

            debugger
            if (parseFloat(value) > 0) {
                return value;
            }
            else {
                return 0;
            }
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Type-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true,

            //retrieve: true,

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.iras', ['moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_iras', {
            url: '/IRASSubmission',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/iras/iras.html',
                    controller: 'irasController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.iras')
        .controller('irasController', irasController);

    /** @ngInject */
    function irasController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $mdDialog, $document) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        $scope.Employeegrid = true;
        $scope.Export = true;
        $scope.Employeeform = false;

        var monthFormat = buildLocaleProvider("MMM-YYYY");
        var ymdFormat = buildLocaleProvider("YYYY-MM-DD");

        $scope.dateFields = {
            type: 'date',
            required: false,
            binding: 'applicant.expectedGraduation',
            startView: 'year',
            label: 'Credit Card Expiry - Year/Month picker',
            mode: 'year',
            locale: monthFormat,
            selectedDate: moment(new Date())
        };

        $scope.DownloadIRASSubmission = function () {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), 0, 1);
            var EndDate = new Date(date.getFullYear(), 11, 31);

            var url = $rootScope.PayrollURL + "IRASSubmission.aspx?ClientID=" + $rootScope.Client_Id + "&From=" + new Date(StartDate) + "&To=" + new Date(EndDate);
            window.open(url);

        }


        RefreshGrid();

        $scope.OnMonthChange = function () {
            debugger

            var date = $scope.dateFields.selectedDate._d;

            RefreshGrid();
        }



        function RefreshGrid() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), 0, 1);
            var EndDate = new Date(date.getFullYear(), 11, 31);


            $http({
                method: "POST",
                url: $rootScope.WebURL + "/cpfpayroll/IRASSubmission",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (Payrolldata) {

                $scope.Payrolldatas = Payrolldata.data.data;
            });


            $http({
                method: "POST",
                url: $rootScope.WebURL + "/iras/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (irasdata) {
                debugger
                $scope.Irasdatas = irasdata.data.data;
            });



            $http({
                method: "POST",
                url: $rootScope.WebURL + "/payrollsettings/getemployeedetailsforiras",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDetails();
            });

        }


        function LoadDetails() {

            var EndMonthData = [];

            angular.forEach($scope.Employeedatas, function (value) {


                var EmployeeID = value._id; var _id = undefined; var EmployeeName = value.EmployeeName; var BankCode = undefined; var Bonus = 0; var Gender = value.Gender;
                var DOB = value.DateofBirth; var NRICNumber = value.NRICNumber; var NationalityCode = value.NationalityCode; var Block = value.Block; var StreetName = value.StreetName; var LevelNo = value.LevelNo;
                var UnitNo = value.UnitNo; var Agnecy = 0; var AddressType = undefined; var PostalCode = undefined; var Address1 = value.Address1; var Address2 = value.Address2;
                var Address3 = value.Address3; var CountryCode = value.CountryCode; var MBF = 0; var Donations = 0; var Insurance = 0; var Directorsfees = 0;
                var Others = 0; var ExemptIncome = 0; var AmountOfEmployementIncome = 0; var FixedAmountOfIncomeTax = 0; var Appendix8A = undefined;
                var Section45 = undefined; var EmployeesIncomeTax = undefined; var Gratuity = undefined; var Compensationforlossofoffice = undefined; var ApprovalattainedfromIRAS = undefined; var DateofApprovalIRAS = undefined;
                var CessationProvisions = undefined; var FormIR8S = undefined; var Remission = undefined; var GrossCommission = 0; var GrossCommissionFromDate = undefined; var GrossCommissionToDate = undefined;
                var GrossCommissionIndicator = undefined; var Pension = 0; var TransportAllowance = 0; var EntertainmentAllowance = 0; var OtherAllowance = 0; var GratuityAmount = 0;
                var CompensationforlossofofficeAmount = 0; var Retirementbenefitsaccrued311292 = 0; var Retirementbenefitsaccruedfrom1993 = 0; var Contributionmadebyemployertoanypension = 0;
                var Excessvoluntrycontribution = 0; var Gainsandprofits = 0; var Valueofbenefits = 0; var Employeesvoluntrycontribution = 0; var DateofCommencement = undefined; var DateofCessation = undefined;
                var DateofBonus = undefined; var DateofDirectorsfeesapproval = undefined; var NameofDesignatedPension = undefined; var NameoffundforRetirementbenefits = undefined; var Remarks = undefined;
                var IsConfirmed = false; var PayRollID = value.PayRollID; var BasicPay = 0; var SDF = 0; var OT = 0; var Incentives = 0; var GrossPay = 0; var EmployeeCPF = 0;

                var Designation = value.EDesignation;
                PostalCode = parseFloat(value.Postal);
                var EmpID = value.EmployeeID;


                if ($scope.Payrolldatas != undefined) {
                    var item = $scope.Payrolldatas.filter(function (item) {
                        return item._id === value._id;
                    })[0];

                    if (item != undefined) {

                        if (item.BasicPay != undefined) { BasicPay = item.BasicPay; }
                        if (item.EmployeeCPF != undefined) { EmployeeCPF = item.EmployeeCPF; }
                        if (item.Incentives != undefined) { Incentives = item.Incentives; }
                        if (item.Agnecy != undefined) { Agnecy = item.Agnecy; }
                        if (item.SDF != undefined) { SDF = item.SDF; }
                        if (item.OT != undefined) { OT = item.OT; }
                        if (item.GrossPay != undefined) { GrossPay = item.GrossPay; }
                    }
                }
                if ($scope.Irasdatas != undefined) {

                    var item = $scope.Irasdatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (item != undefined) {
                        _id = item._id; PayRollID = item._id; IsConfirmed = item.IsConfirmed;

                        if (item.BasicPay != undefined) { BasicPay = item.BasicPay; }
                        if (item.EmployeeCPF != undefined) { EmployeeCPF = item.EmployeeCPF; }
                        if (item.Incentives != undefined) { Incentives = item.Incentives; }
                        if (item.Agnecy != undefined) { Agnecy = item.Agnecy; }
                        if (item.SDF != undefined) { SDF = item.SDF; }
                        if (item.OT != undefined) { OT = item.OT; }
                        if (item.GrossPay != undefined) { GrossPay = item.GrossPay; }

                        Gender = item.Gender; DOB = item.DOB; NRICNumber = item.NRICNumber; BankCode = item.BankCode;
                        NationalityCode = item.NationalityCode; Block = item.Block; StreetName = item.StreetName; LevelNo = item.LevelNo; UnitNo = item.UnitNo; AddressType = item.AddressType; PostalCode = item.PostalCode;
                        Address1 = item.Address1; Address2 = item.Address2; Address3 = item.Address3; CountryCode = item.CountryCode;

                        if (item.MBF != undefined) { MBF = item.MBF; }
                        if (item.Donations != undefined) { Donations = item.Donations; }
                        if (item.Insurance != undefined) { Insurance = item.Insurance; }
                        if (item.Bonus != undefined) { Bonus = item.Bonus; }
                        if (item.Directorsfees != undefined) { Directorsfees = item.Directorsfees; }
                        if (item.Others != undefined) { Others = item.Others; }
                        if (item.ExemptIncome != undefined) { ExemptIncome = item.ExemptIncome; }
                        if (item.AmountOfEmployementIncome != undefined) { AmountOfEmployementIncome = item.AmountOfEmployementIncome; }
                        if (item.FixedAmountOfIncomeTax != undefined) { FixedAmountOfIncomeTax = item.FixedAmountOfIncomeTax; }

                        Appendix8A = item.Appendix8A; Section45 = item.Section45; EmployeesIncomeTax = item.EmployeesIncomeTax; Gratuity = item.Gratuity; Compensationforlossofoffice = item.Compensationforlossofoffice;
                        ApprovalattainedfromIRAS = item.ApprovalattainedfromIRAS; DateofApprovalIRAS = item.DateofApprovalIRAS; CessationProvisions = item.CessationProvisions; FormIR8S = item.FormIR8S; Remission = item.Remission;

                        if (item.GrossCommission != undefined) { GrossCommission = item.GrossCommission; }
                        if (item.Pension != undefined) { Pension = item.Pension; }
                        if (item.TransportAllowance != undefined) { TransportAllowance = item.TransportAllowance; }
                        if (item.EntertainmentAllowance != undefined) { EntertainmentAllowance = item.EntertainmentAllowance; }
                        if (item.OtherAllowance != undefined) { OtherAllowance = item.OtherAllowance; }
                        if (item.GratuityAmount != undefined) { GratuityAmount = item.GratuityAmount; }
                        if (item.CompensationforlossofofficeAmount != undefined) { CompensationforlossofofficeAmount = item.CompensationforlossofofficeAmount; }
                        if (item.Retirementbenefitsaccrued311292 != undefined) { Retirementbenefitsaccrued311292 = item.Retirementbenefitsaccrued311292; }
                        if (item.Retirementbenefitsaccruedfrom1993 != undefined) { Retirementbenefitsaccruedfrom1993 = item.Retirementbenefitsaccruedfrom1993; }
                        if (item.Contributionmadebyemployertoanypension != undefined) { Contributionmadebyemployertoanypension = item.Contributionmadebyemployertoanypension; }
                        if (item.Excessvoluntrycontribution != undefined) { Excessvoluntrycontribution = item.Excessvoluntrycontribution; }
                        if (item.Gainsandprofits != undefined) { Gainsandprofits = item.Gainsandprofits; }
                        if (item.Valueofbenefits != undefined) { Valueofbenefits = item.Valueofbenefits; }
                        if (item.Employeesvoluntrycontribution != undefined) { Employeesvoluntrycontribution = item.Employeesvoluntrycontribution; }

                        GrossCommissionFromDate = item.GrossCommissionFromDate; GrossCommissionToDate = item.GrossCommissionToDate; GrossCommissionIndicator = item.GrossCommissionIndicator;
                        DateofCommencement = item.DateofCommencement; DateofCessation = item.DateofCessation; DateofBonus = item.DateofBonus; DateofDirectorsfeesapproval = item.DateofDirectorsfeesapproval;
                        NameofDesignatedPension = item.NameofDesignatedPension; NameoffundforRetirementbenefits = item.NameoffundforRetirementbenefits;
                    }
                }

                EndMonthData.push({
                    _id: _id, EmpID: EmpID,
                    EmployeeID: EmployeeID, EmployeeName: EmployeeName, Designation: Designation,
                    BankCode: BankCode, BasicPay: BasicPay,
                    Remarks: Remarks, IsConfirmed: IsConfirmed, PayRollID: PayRollID,
                    Agnecy: Agnecy, SDF: SDF, OT: OT, Incentives: Incentives,
                    GrossPay: GrossPay, EmployeeCPF: EmployeeCPF, Gender: Gender, DOB: DOB, NRICNumber: NRICNumber, NationalityCode: NationalityCode,
                    Block: Block, StreetName: StreetName, LevelNo: LevelNo, UnitNo: UnitNo, AddressType: AddressType, PostalCode: PostalCode,
                    Address1: Address1, Address2: Address2, Address3: Address3,
                    CountryCode: CountryCode, MBF: MBF, Donations: Donations, Insurance: Insurance, Bonus: Bonus,
                    Directorsfees: Directorsfees, Others: Others, ExemptIncome: ExemptIncome, AmountOfEmployementIncome: AmountOfEmployementIncome,
                    FixedAmountOfIncomeTax: FixedAmountOfIncomeTax, Appendix8A: Appendix8A, Section45: Section45,
                    EmployeesIncomeTax: EmployeesIncomeTax, Gratuity: Gratuity, Compensationforlossofoffice: Compensationforlossofoffice,
                    ApprovalattainedfromIRAS: ApprovalattainedfromIRAS, DateofApprovalIRAS: DateofApprovalIRAS,
                    CessationProvisions: CessationProvisions, FormIR8S: FormIR8S, Remission: Remission, GrossCommission: GrossCommission,
                    GrossCommissionFromDate: GrossCommissionFromDate, GrossCommissionToDate: GrossCommissionToDate,
                    GrossCommissionIndicator: GrossCommissionIndicator, Pension: Pension, TransportAllowance: TransportAllowance, EntertainmentAllowance: EntertainmentAllowance,
                    OtherAllowance: OtherAllowance, GratuityAmount: GratuityAmount, CompensationforlossofofficeAmount: CompensationforlossofofficeAmount,
                    Retirementbenefitsaccrued311292: Retirementbenefitsaccrued311292, Retirementbenefitsaccruedfrom1993: Retirementbenefitsaccruedfrom1993,
                    Contributionmadebyemployertoanypension: Contributionmadebyemployertoanypension, Excessvoluntrycontribution: Excessvoluntrycontribution, Gainsandprofits: Gainsandprofits,
                    Valueofbenefits: Valueofbenefits, Employeesvoluntrycontribution: Employeesvoluntrycontribution, DateofCommencement: DateofCommencement, DateofCessation: DateofCessation,
                    DateofBonus: DateofBonus, DateofDirectorsfeesapproval: DateofDirectorsfeesapproval, NameofDesignatedPension: NameofDesignatedPension, NameoffundforRetirementbenefits: NameoffundforRetirementbenefits,

                });

            });

            $scope.EndMonthData = EndMonthData;
        }



        $scope.EditSelected = function (e) {

            $scope.vm.Deductions = 0;
            $scope.vm.EmployeeCPF = 0;
            $scope.vm.EmployerCPF = 0;
            $scope.vm.AgencyAmount = 0;
            $scope.vm.SDF = 0;
            $scope.vm.PaymentMode = undefined;
            $scope.vm.Remarks = undefined;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/cpf/bulkeditpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Showgrid = function () {
            $scope.Employeegrid = true;
            $scope.Export = true;
            $scope.Employeeform = false;
        }


        $scope.OnAddressTypeChange = function () {
            debugger
            if ($scope.vm.AddressType == "L") {
                $scope.Local = true;
            } else {
                $scope.Local = false;
            }
        }


        $scope.EditIndividual = function (EmployeeID, e) {


            $scope.Employeegrid = false;
            $scope.Export = false;
            $scope.Employeeform = true;


            $scope.IndividualEmployeeID = EmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item.EmployeeID === EmployeeID;
            })[0];


            $scope.vm.AddressType = item.AddressType;
            $scope.vm.AddressType = "L";
            if ($scope.vm.AddressType == "L") {
                $scope.Local = true;
            } else {
                $scope.Local = false;
            }

            $scope.vm.EmployeeName = item.EmployeeName;
            $scope.vm.BankCode = item.BankCode;
            $scope.vm.BasicPay = item.BasicPay;
            $scope.vm.PayRollID = item.PayRollID;
            $scope.vm.Gender = item.Gender;
            $scope.vm.DOB = item.DOB;
            $scope.vm.EmployeeCPF = parseFloat((item.EmployeeCPF).toFixed(2));

            $scope.vm.Salary = item.GrossPay;
            $scope.vm.Designation = item.Designation;

            $scope.vm.NRICNumber = item.NRICNumber;
            $scope.vm.NationalityCode = item.NationalityCode;
            $scope.vm.Block = item.Block;
            $scope.vm.StreetName = item.StreetName;
            $scope.vm.LevelNo = item.LevelNo;
            $scope.vm.UnitNo = item.UnitNo;
            $scope.vm.PostalCode = item.PostalCode;
            $scope.vm.Address1 = item.Address1;
            $scope.vm.Address2 = item.Address2;
            $scope.vm.Address3 = item.Address3;
            $scope.vm.CountryCode = item.CountryCode;
            $scope.vm.MBF = item.MBF;
            $scope.vm.Donations = item.Donations;
            $scope.vm.Insurance = item.Insurance;
            $scope.vm.Bonus = item.Bonus;
            $scope.vm.Directorsfees = item.Directorsfees;
            $scope.vm.Others = item.Others;
            $scope.vm.ExemptIncome = item.ExemptIncome;
            $scope.vm.AmountOfEmployementIncome = item.AmountOfEmployementIncome;
            $scope.vm.FixedAmountOfIncomeTax = item.FixedAmountOfIncomeTax;
            $scope.vm.Appendix8A = item.Appendix8A;
            $scope.vm.Section45 = item.Section45;
            $scope.vm.EmployeesIncomeTax = item.EmployeesIncomeTax;
            $scope.vm.Gratuity = item.Gratuity;
            $scope.vm.Compensationforlossofoffice = item.Compensationforlossofoffice;
            $scope.vm.ApprovalattainedfromIRAS = item.ApprovalattainedfromIRAS;
            $scope.vm.DateofApprovalIRAS = item.DateofApprovalIRAS;
            $scope.vm.CessationProvisions = item.CessationProvisions;
            $scope.vm.Remission = item.Remission;
            $scope.vm.GrossCommission = item.GrossCommission;
            $scope.vm.GrossCommissionFromDate = item.GrossCommissionFromDate;
            $scope.vm.GrossCommissionToDate = item.GrossCommissionToDate;
            $scope.vm.GrossCommissionIndicator = item.GrossCommissionIndicator;
            $scope.vm.Pension = item.Pension;
            $scope.vm.TransportAllowance = item.TransportAllowance;
            $scope.vm.EntertainmentAllowance = item.EntertainmentAllowance;
            $scope.vm.OtherAllowance = item.OtherAllowance;
            $scope.vm.GratuityAmount = item.GratuityAmount;
            $scope.vm.CompensationforlossofofficeAmount = item.CompensationforlossofofficeAmount;
            $scope.vm.Retirementbenefitsaccrued311292 = item.Retirementbenefitsaccrued311292;
            $scope.vm.Retirementbenefitsaccruedfrom1993 = item.Retirementbenefitsaccruedfrom1993;
            $scope.vm.Contributionmadebyemployertoanypension = item.Contributionmadebyemployertoanypension;
            $scope.vm.Excessvoluntrycontribution = item.Excessvoluntrycontribution;
            $scope.vm.Gainsandprofits = item.Gainsandprofits;
            $scope.vm.Valueofbenefits = item.Valueofbenefits;
            $scope.vm.Employeesvoluntrycontribution = item.Employeesvoluntrycontribution;
            $scope.vm.DateofCommencement = item.DateofCommencement;
            $scope.vm.DateofCessation = item.DateofCessation;
            $scope.vm.DateofBonus = item.DateofBonus;
            $scope.vm.DateofDirectorsfeesapproval = item.DateofDirectorsfeesapproval;
            $scope.vm.NameofDesignatedPension = item.NameofDesignatedPension;
            $scope.vm.NameoffundforRetirementbenefits = item.NameoffundforRetirementbenefits;

        }





        $scope.SubmitIndividual = function () {

            debugger

            var EmployeeID = $scope.IndividualEmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item.EmployeeID === EmployeeID;
            })[0];

            debugger

            if (item.PayRollID == -1) {
                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/iras/add",
                    data: {
                        EmployeeID: EmployeeID, Year: $scope.dateFields.selectedDate._d, Designation: item.Designation,
                        EmployeeName: $scope.vm.EmployeeName, Gender: $scope.vm.Gender, DOB: $scope.vm.DOB, NRICNumber: $scope.vm.NRICNumber,
                        NationalityCode: $scope.vm.NationalityCode, BasicPay: item.BasicPay, OT: item.OT, Incentives: item.Incentives,
                        GrossPay: item.GrossPay, EmployeeCPF: item.EmployeeCPF, Agnecy: item.Agnecy, SDF: item.SDF, BankCode: $scope.vm.BankCode,
                        AddressType: $scope.vm.AddressType, Block: $scope.vm.Block, StreetName: $scope.vm.StreetName, LevelNo: $scope.vm.LevelNo,
                        UnitNo: $scope.vm.UnitNo, PostalCode: $scope.vm.PostalCode, Address1: $scope.vm.Address1, Address2: $scope.vm.Address2,
                        Address3: $scope.vm.Address3, CountryCode: $scope.vm.CountryCode, MBF: $scope.vm.MBF, Donations: $scope.vm.Donations,
                        Insurance: $scope.vm.Insurance, Bonus: $scope.vm.Bonus, Directorsfees: $scope.vm.Directorsfees, Others: $scope.vm.Others,
                        ExemptIncome: $scope.vm.ExemptIncome, AmountOfEmployementIncome: $scope.vm.AmountOfEmployementIncome, FixedAmountOfIncomeTax: $scope.vm.FixedAmountOfIncomeTax,
                        Appendix8A: $scope.vm.Appendix8A, Section45: $scope.vm.Section45, EmployeesIncomeTax: $scope.vm.EmployeesIncomeTax, Gratuity: $scope.vm.Gratuity, Compensationforlossofoffice: $scope.vm.Compensationforlossofoffice,
                        ApprovalattainedfromIRAS: $scope.vm.ApprovalattainedfromIRAS, DateofApprovalIRAS: $scope.vm.DateofApprovalIRAS, CessationProvisions: $scope.vm.CessationProvisions, FormIR8S: $scope.vm.FormIR8S,
                        Remission: $scope.vm.Remission, GrossCommission: $scope.vm.GrossCommission, GrossCommissionFromDate: $scope.vm.GrossCommissionFromDate, GrossCommissionToDate: $scope.vm.GrossCommissionToDate,
                        GrossCommissionIndicator: $scope.vm.GrossCommissionIndicator, Pension: $scope.vm.Pension, TransportAllowance: $scope.vm.TransportAllowance, EntertainmentAllowance: $scope.vm.EntertainmentAllowance,
                        OtherAllowance: $scope.vm.OtherAllowance, GratuityAmount: $scope.vm.GratuityAmount, CompensationforlossofofficeAmount: $scope.vm.CompensationforlossofofficeAmount, Retirementbenefitsaccrued311292: $scope.vm.Retirementbenefitsaccrued311292,
                        Retirementbenefitsaccruedfrom1993: $scope.vm.Retirementbenefitsaccruedfrom1993, Contributionmadebyemployertoanypension: $scope.vm.Contributionmadebyemployertoanypension, Excessvoluntrycontribution: $scope.vm.Excessvoluntrycontribution, Gainsandprofits: $scope.vm.Gainsandprofits,
                        Valueofbenefits: $scope.vm.Valueofbenefits, Employeesvoluntrycontribution: $scope.vm.Employeesvoluntrycontribution, DateofCommencement: $scope.vm.DateofCommencement, DateofCessation: $scope.vm.DateofCessation,
                        DateofBonus: $scope.vm.DateofBonus, DateofDirectorsfeesapproval: $scope.vm.DateofDirectorsfeesapproval, NameoffundforRetirementbenefits: $scope.vm.NameoffundforRetirementbenefits, NameofDesignatedPension: $scope.vm.NameofDesignatedPension,
                        Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed, CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                    },
                });
                responses.then(function (GList) {

                    RefreshGrid();
                    $scope.Showgrid();
                })
            }
            else {

                var responses = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/iras/update",
                    data: {
                        _id: item.PayRollID, EmployeeID: EmployeeID, Year: $scope.dateFields.selectedDate._d,
                        EmployeeName: $scope.vm.EmployeeName, Gender: $scope.vm.Gender, DOB: $scope.vm.DOB, NRICNumber: $scope.vm.NRICNumber,
                        NationalityCode: $scope.vm.NationalityCode, BasicPay: item.BasicPay, OT: item.OT, Incentives: item.Incentives,
                        GrossPay: item.GrossPay, EmployeeCPF: item.EmployeeCPF, Agnecy: item.Agnecy, SDF: item.SDF, BankCode: $scope.vm.BankCode,
                        AddressType: $scope.vm.AddressType, Block: $scope.vm.Block, StreetName: $scope.vm.StreetName, LevelNo: $scope.vm.LevelNo,
                        UnitNo: $scope.vm.UnitNo, PostalCode: $scope.vm.PostalCode, Address1: $scope.vm.Address1, Address2: $scope.vm.Address2,
                        Address3: $scope.vm.Address3, CountryCode: $scope.vm.CountryCode, MBF: $scope.vm.MBF, Donations: $scope.vm.Donations,
                        Insurance: $scope.vm.Insurance, Bonus: $scope.vm.Bonus, Directorsfees: $scope.vm.Directorsfees, Others: $scope.vm.Others,
                        ExemptIncome: $scope.vm.ExemptIncome, AmountOfEmployementIncome: $scope.vm.AmountOfEmployementIncome, FixedAmountOfIncomeTax: $scope.vm.FixedAmountOfIncomeTax,
                        Appendix8A: $scope.vm.Appendix8A, Section45: $scope.vm.Section45, EmployeesIncomeTax: $scope.vm.EmployeesIncomeTax, Gratuity: $scope.vm.Gratuity, Compensationforlossofoffice: $scope.vm.Compensationforlossofoffice,
                        ApprovalattainedfromIRAS: $scope.vm.ApprovalattainedfromIRAS, DateofApprovalIRAS: $scope.vm.DateofApprovalIRAS, CessationProvisions: $scope.vm.CessationProvisions, FormIR8S: $scope.vm.FormIR8S,
                        Remission: $scope.vm.Remission, GrossCommission: $scope.vm.GrossCommission, GrossCommissionFromDate: $scope.vm.GrossCommissionFromDate, GrossCommissionToDate: $scope.vm.GrossCommissionToDate,
                        GrossCommissionIndicator: $scope.vm.GrossCommissionIndicator, Pension: $scope.vm.Pension, TransportAllowance: $scope.vm.TransportAllowance, EntertainmentAllowance: $scope.vm.EntertainmentAllowance,
                        OtherAllowance: $scope.vm.OtherAllowance, GratuityAmount: $scope.vm.GratuityAmount, CompensationforlossofofficeAmount: $scope.vm.CompensationforlossofofficeAmount, Retirementbenefitsaccrued311292: $scope.vm.Retirementbenefitsaccrued311292,
                        Retirementbenefitsaccruedfrom1993: $scope.vm.Retirementbenefitsaccruedfrom1993, Contributionmadebyemployertoanypension: $scope.vm.Contributionmadebyemployertoanypension, Excessvoluntrycontribution: $scope.vm.Excessvoluntrycontribution, Gainsandprofits: $scope.vm.Gainsandprofits,
                        Valueofbenefits: $scope.vm.Valueofbenefits, Employeesvoluntrycontribution: $scope.vm.Employeesvoluntrycontribution, DateofCommencement: $scope.vm.DateofCommencement, DateofCessation: $scope.vm.DateofCessation,
                        DateofBonus: $scope.vm.DateofBonus, DateofDirectorsfeesapproval: $scope.vm.DateofDirectorsfeesapproval, NameoffundforRetirementbenefits: $scope.vm.NameoffundforRetirementbenefits, NameofDesignatedPension: $scope.vm.NameofDesignatedPension,
                        Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed, UpdatedBy: $rootScope.createdby
                    },
                });
                responses.then(function (GList) {

                    RefreshGrid();
                    $scope.Showgrid();
                })
            }
        }

        $scope.ConfirmSelected = function (e) {

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/iras/alertpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }



        $scope.ConfirmPayroll = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                if (item != undefined) {

                    if (item.PayRollID == -1) {

                        var responses = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/iras/add",
                            data: {
                                EmployeeID: item.EmployeeID, Month: $scope.dateFields.selectedDate._d, IsConfirmed: true,
                                EmployeeName: item.EmployeeName, Designation: item.Designation, Gender: item.Gender, DOB: item.DOB, NRICNumber: item.NRICNumber,
                                NationalityCode: item.NationalityCode, BasicPay: item.BasicPay, OT: item.OT, Incentives: item.Incentives,
                                GrossPay: item.GrossPay, EmployeeCPF: item.EmployeeCPF, Agnecy: item.Agnecy, SDF: item.SDF, BankCode: item.BankCode,
                                AddressType: item.AddressType, Block: item.Block, StreetName: item.StreetName, LevelNo: item.LevelNo,
                                UnitNo: item.UnitNo, PostalCode: item.PostalCode, Address1: item.Address1, Address2: item.Address2,
                                Address3: item.Address3, CountryCode: item.CountryCode, MBF: item.MBF, Donations: item.Donations,
                                Insurance: item.Insurance, Bonus: item.Bonus, Directorsfees: item.Directorsfees, Others: item.Others,
                                ExemptIncome: item.ExemptIncome, AmountOfEmployementIncome: item.AmountOfEmployementIncome, FixedAmountOfIncomeTax: item.FixedAmountOfIncomeTax,
                                Appendix8A: item.Appendix8A, Section45: item.Section45, EmployeesIncomeTax: item.EmployeesIncomeTax, Gratuity: item.Gratuity, Compensationforlossofoffice: item.Compensationforlossofoffice,
                                ApprovalattainedfromIRAS: item.ApprovalattainedfromIRAS, DateofApprovalIRAS: item.DateofApprovalIRAS, CessationProvisions: item.CessationProvisions, FormIR8S: item.FormIR8S,
                                Remission: item.Remission, GrossCommission: item.GrossCommission, GrossCommissionFromDate: item.GrossCommissionFromDate, GrossCommissionToDate: item.GrossCommissionToDate,
                                GrossCommissionIndicator: item.GrossCommissionIndicator, Pension: item.Pension, TransportAllowance: item.TransportAllowance, EntertainmentAllowance: item.EntertainmentAllowance,
                                OtherAllowance: item.OtherAllowance, GratuityAmount: item.GratuityAmount, CompensationforlossofofficeAmount: item.CompensationforlossofofficeAmount, Retirementbenefitsaccrued311292: item.Retirementbenefitsaccrued311292,
                                Retirementbenefitsaccruedfrom1993: item.Retirementbenefitsaccruedfrom1993, Contributionmadebyemployertoanypension: item.Contributionmadebyemployertoanypension, Excessvoluntrycontribution: item.Excessvoluntrycontribution, Gainsandprofits: item.Gainsandprofits,
                                Valueofbenefits: item.Valueofbenefits, Employeesvoluntrycontribution: item.Employeesvoluntrycontribution, DateofCommencement: item.DateofCommencement, DateofCessation: item.DateofCessation,
                                DateofBonus: item.DateofBonus, DateofDirectorsfeesapproval: item.DateofDirectorsfeesapproval, NameoffundforRetirementbenefits: item.NameoffundforRetirementbenefits, NameofDesignatedPension: item.NameofDesignatedPension,
                                Remarks: item.Remarks, CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                            },
                        });
                        responses.then(function (GList) {

                            $mdDialog.hide();

                            index = index + 1;
                            if (index == $scope.SelectedIds.length) {
                                RefreshGrid();
                            }
                        })
                    } else {

                        var responses = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/iras/update",
                            data: {
                                _id: item.PayRollID, EmployeeID: item.EmployeeID, Year: $scope.dateFields.selectedDate._d,
                                EmployeeName: item.EmployeeName, Gender: item.Gender, DOB: item.DOB, NRICNumber: item.NRICNumber,
                                NationalityCode: item.NationalityCode, BasicPay: item.BasicPay, OT: item.OT, Incentives: item.Incentives,
                                GrossPay: item.GrossPay, EmployeeCPF: item.EmployeeCPF, Agnecy: item.Agnecy, SDF: item.SDF, BankCode: item.BankCode,
                                AddressType: item.AddressType, Block: item.Block, StreetName: item.StreetName, LevelNo: item.LevelNo,
                                UnitNo: item.UnitNo, PostalCode: item.PostalCode, Address1: item.Address1, Address2: item.Address2,
                                Address3: item.Address3, CountryCode: item.CountryCode, MBF: item.MBF, Donations: item.Donations,
                                Insurance: item.Insurance, Bonus: item.Bonus, Directorsfees: item.Directorsfees, Others: item.Others,
                                ExemptIncome: item.ExemptIncome, AmountOfEmployementIncome: item.AmountOfEmployementIncome, FixedAmountOfIncomeTax: item.FixedAmountOfIncomeTax,
                                Appendix8A: item.Appendix8A, Section45: item.Section45, EmployeesIncomeTax: item.EmployeesIncomeTax, Gratuity: item.Gratuity, Compensationforlossofoffice: item.Compensationforlossofoffice,
                                ApprovalattainedfromIRAS: item.ApprovalattainedfromIRAS, DateofApprovalIRAS: item.DateofApprovalIRAS, CessationProvisions: item.CessationProvisions, FormIR8S: item.FormIR8S,
                                Remission: item.Remission, GrossCommission: item.GrossCommission, GrossCommissionFromDate: item.GrossCommissionFromDate, GrossCommissionToDate: item.GrossCommissionToDate,
                                GrossCommissionIndicator: item.GrossCommissionIndicator, Pension: item.Pension, TransportAllowance: item.TransportAllowance, EntertainmentAllowance: item.EntertainmentAllowance,
                                OtherAllowance: item.OtherAllowance, GratuityAmount: item.GratuityAmount, CompensationforlossofofficeAmount: item.CompensationforlossofofficeAmount, Retirementbenefitsaccrued311292: item.Retirementbenefitsaccrued311292,
                                Retirementbenefitsaccruedfrom1993: item.Retirementbenefitsaccruedfrom1993, Contributionmadebyemployertoanypension: item.Contributionmadebyemployertoanypension, Excessvoluntrycontribution: item.Excessvoluntrycontribution, Gainsandprofits: item.Gainsandprofits,
                                Valueofbenefits: item.Valueofbenefits, Employeesvoluntrycontribution: item.Employeesvoluntrycontribution, DateofCommencement: item.DateofCommencement, DateofCessation: item.DateofCessation,
                                DateofBonus: item.DateofBonus, DateofDirectorsfeesapproval: item.DateofDirectorsfeesapproval, NameoffundforRetirementbenefits: item.NameoffundforRetirementbenefits, NameofDesignatedPension: item.NameofDesignatedPension,
                                Remarks: item.Remarks, IsConfirmed: true, UpdatedBy: $rootScope.createdby
                            },
                        });
                        responses.then(function (GList) {

                            $mdDialog.hide();

                            index = index + 1;
                            if (index == $scope.SelectedIds.length) {
                                RefreshGrid();
                            }
                        })

                    }
                }

            });


        }

        $scope.SelectedIds = [];
        $scope.CheckAll = function (IsTicked) {
            if (IsTicked == true) {
                $scope.TRCdiv = true;
                angular.forEach($scope.EndMonthData, function (value) {
                    if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
                })
                $scope.Selec = { value: true }
            }
            if (IsTicked == false) {
                $scope.TRCdiv = false;
                $scope.SelectedIds = [];
                $scope.Selec = { value: false }
            }
        }
        $scope.Check = function (TrF, Ids) {
            if (TrF == true) {
                $scope.TRCdiv = true;
                if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
            }
            if (TrF == false) {
                $scope.TRCdiv = false;
                var index = $scope.SelectedIds.indexOf(Ids);
                if (index > -1) {
                    $scope.SelectedIds.splice(index, 1);
                }
            }
            if ($scope.SelectedIds.length > 0) {
                $scope.TRCdiv = true;
            }
        }
        $scope.TRCdiv = false;



        $scope.RecordStatus = function (row) {

            if (row.IsConfirmed == true) {
                return "GreenColor";
            }
            else {
                return "RedColor"
            }
        }


        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Allowancesdatas.xlsx",{headers:true}) FROM ?', [$scope.Allowancesdatas]);
        };

        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        // Returns an array of dates between the two dates
        var getDates = function (startDate, endDate) {
            var dates = [],
                currentDate = startDate,
                addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
            while (currentDate <= endDate) {
                dates.push(currentDate);
                currentDate = addDays.call(currentDate, 1);
            }
            return dates;
        };



        $scope.WorkedMonth = function (a) {
            var b = new Date();
            return momentDiff1(a, b);
        }

        function momentDiff1(a, b) {

            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');

            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        function lastmonth() {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            $scope.lastMonthStartDate = lastMonthStartDate;
            $scope.lastMonthEndDate = lastMonthEndDate;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        function getAge(dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        function buildLocaleProvider(formatString) {
            return {
                formatDate: function (date) {
                    if (date) return moment(date).format(formatString);
                    else return null;
                },
                parseDate: function (dateString) {
                    if (dateString) {
                        var m = moment(dateString, formatString, true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    } else return null;
                }
            };
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Type-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true,

            //retrieve: true,

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $http({
            url: $rootScope.WebURL + "/country",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (countrydata) {
            $scope.Countrydatas = countrydata.data.data;
        });

        $http({
            url: $rootScope.WebURL + "/nationality",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (countrydata) {
            $scope.Nationalitydatas = countrydata.data.data;
        });


        $scope.BankCodeList = [
            { "name": "DBS BANK LTD", "code": "1" },
            { "name": "UNITED OVERSEAS BANK LIMITED", "code": "2" },
            { "name": "OVERSEA-CHINESE BANKING CORPORATION LIMITED", "code": "3" },
            { "name": "OTHERS", "code": "4" },
            { "name": "CIMB BANK BERHAD", "code": "5" },
            { "name": "CITIBANK SINGAPORE LIMITED", "code": "6" },
            { "name": "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED", "code": "7" },
            { "name": "MALAYAN BANKING BERHAD", "code": "8" },
            { "name": "STANDARD CHARTERED BANK", "code": "9" },
            { "name": "FAR EASTERN BANK LTD", "code": "A" },
            { "name": "AUSTRALIA & NEW ZEALAND BANKING GROUP LIMITED", "code": "B" },
            { "name": "BANGKOK BANK PUBLIC COMPANY LIMITED", "code": "C" },
            { "name": "BANK OF AMERICA, NATIONAL ASSOCIATION", "code": "D" },
            { "name": "BANK OF CHINA LIMITED", "code": "E" },
            { "name": "BANK OF EAST ASIA LTD", "code": "F" },
            { "name": "BANK OF INDIA", "code": "G" },
            { "name": "BANK OF TOKYO-MITSUBISHI UFJ, LTD", "code": "H" },
            { "name": "BNP PARIBAS", "code": "I" },
            { "name": "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK", "code": "J" },
            { "name": "HL BANK", "code": "K" },
            { "name": "ICICI BANK LIMITED", "code": "L" },
            { "name": "INDIAN BANK", "code": "M" },
            { "name": "INDIAN OVERSEAS BANK", "code": "N" },
            { "name": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED", "code": "O" },
            { "name": "JPMORGAN CHASE BANK, N.A.", "code": "P" },
            { "name": "MIZUHO CORPORATE BANK", "code": "Q" },
            { "name": "PT BANK NEGARA INDONESIA (PERSERO) TBK", "code": "R" },
            { "name": "RHB BANK BERHAD", "code": "S" },
            { "name": "STATE BANK OF INDIA", "code": "T" },
            { "name": "SUMITOMO MITSUI BANKING CORPORATION", "code": "U" },
            { "name": "UCO BANK", "code": "V" },];


    }
})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.cpf', ['moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_cpf', {
            url: '/PayrollCPFSubmission',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/cpf/cpf.html',
                    controller: 'cpfController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.cpf')
        .controller('cpfController', cpfController);

    /** @ngInject */
    function cpfController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $mdDialog, $document) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var monthFormat = buildLocaleProvider("MMM-YYYY");
        var ymdFormat = buildLocaleProvider("YYYY-MM-DD");

        $scope.dateFields = {
            type: 'date',
            required: false,
            binding: 'applicant.expectedGraduation',
            startView: 'month',
            label: 'Credit Card Expiry - Year/Month picker',
            mode: 'month',
            locale: monthFormat,
            selectedDate: moment(new Date())
        };


        $scope.DownloadCPFSubmission = function () {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var url = $rootScope.PayrollURL + "CPFSubmission.aspx?ClientID=" + $rootScope.Client_Id + "&From=" + new Date(StartDate) + "&To=" + new Date(EndDate);
            window.open(url);

        }

        $scope.DownloadPayrollSubmission = function () {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var url = $rootScope.PayrollURL + "PayrollSubmission.aspx?ClientID=" + $rootScope.Client_Id + "&From=" + new Date(StartDate) + "&To=" + new Date(EndDate);
            window.open(url);

        }

        RefreshGrid();

        $scope.OnMonthChange = function () {
            debugger

            var date = $scope.dateFields.selectedDate._d;

            RefreshGrid();
        }



        function RefreshGrid() {
            debugger
            lastmonth();
            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            var lastMonthStartDate = $scope.lastMonthStartDate;
            var lastMonthEndDate = $scope.lastMonthEndDate;

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/endmonthpayroll/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (EndmonthPayrolldata) {
                $scope.EndmonthPayrolldatas = EndmonthPayrolldata.data.data;
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/midmonthpayroll/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: lastMonthStartDate, End_Date: lastMonthEndDate },
            }).then(function (MidmonthPayrolldata) {
                $scope.MidmonthPayrolldatas = MidmonthPayrolldata.data.data;
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/cpfpayroll/getpayrollDetails",
                data: { Client_Id: $rootScope.Client_Id, Start_Date: StartDate, End_Date: EndDate },
            }).then(function (Payrolldata) {
                $scope.Payrolldatas = Payrolldata.data.data;
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/payrollsettings/getemployeedeatils",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDetails();
            });

        }

        function LoadAttendance() {

            var date = $scope.dateFields.selectedDate._d;
            var StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var EndDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);


        }
        function LoadDetails() {

            var EndMonthData = [];

            angular.forEach($scope.Employeedatas, function (value) {

                var EmployeeID = undefined;
                var _id = undefined;
                var EmployeeName = undefined;
                var BankName = undefined;
                var Acc = undefined;
                var EDateOfJoin = undefined;
                var BasicPay = 0;
                var Salary = 0;
                var Remarks = undefined;
                var IsConfirmed = false;
                var PayRollID = -1;
                var TotalDays = 0;
                var CalendarDays = 0;
                var AgencyAmount = 0;
                var SDF = 0;
                var AgencyType = undefined;
                var PaymentMode = undefined;
                var OTEligible = "No";
                var OT = 0;
                var Incentives = 0;
                var Deductions = 0;
                var GrossPay = 0;
                var EmployeeCPF = 0;
                var EmployerCPF = 0;
                var NetPay = 0;
                var DayRate = 0;
                var DateofBirth = 0;
                var VisaType = 0;

                var Age = 0;

                EmployeeID = value.EmployeeID;
                EmployeeName = value.EmployeeName;
                EDateOfJoin = value.EDateOfJoin;
                PayRollID = value.PayRollID;



                DateofBirth = value.DateofBirth;
                VisaType = value.VisaType;

                if (value.DateofBirth != undefined || value.DateofBirth != null) {
                    Age = getAge(DateofBirth);
                }

                if (value.Payrolldetails.length > 0) {
                    BankName = value.Payrolldetails[0].BankName;
                    Acc = value.Payrolldetails[0].Acc;
                    Salary = value.Payrolldetails[0].Amount;
                    OTEligible = value.Payrolldetails[0].OTEligible;
                    AgencyAmount = parseFloat(value.Payrolldetails[0].AgencyAmount);
                    SDF = parseFloat(value.Payrolldetails[0].SDF);
                    AgencyType = value.Payrolldetails[0].CPFType;
                    PaymentMode = value.Payrolldetails[0].PaymentMode;
                }

                if ($scope.EndmonthPayrolldatas != undefined) {
                    var enditem = $scope.EndmonthPayrolldatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (enditem != undefined) {
                        TotalDays = enditem.TotalDays;
                        DayRate = enditem.DayRate;
                        BasicPay = enditem.NetPay;
                        CalendarDays = enditem.CalendarDays;
                    }
                }

                if ($scope.MidmonthPayrolldatas != undefined) {
                    var miditem = $scope.MidmonthPayrolldatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (miditem != undefined) {
                        Incentives = (miditem.GPIncentives) + (miditem.OTBSIncentives) + (miditem.SiteAllowance) + (miditem.WeekdayAllowance) + (miditem.WeekendAllowance);
                        OT = (miditem.OT15Rate) + (miditem.OT20Rate);
                    }
                }

                if ($scope.Payrolldatas != undefined) {
                    var item = $scope.Payrolldatas.filter(function (item) {
                        return item.EmployeeID === value._id;
                    })[0];

                    if (item != undefined) {

                        IsConfirmed = item.IsConfirmed;
                        Remarks = item.Remarks;
                        PayRollID = item._id;
                        DayRate = item.DayRate;
                        NetPay = item.NetPay;
                        TotalDays = item.TotalDays;
                        BasicPay = item.BasicPay;
                        CalendarDays = item.CalendarDays;
                        Incentives = item.Incentives;
                        OT = item.OT;
                        Deductions = item.Deductions;
                        GrossPay = item.GrossPay;
                        EmployeeCPF = item.EmployeeCPF;
                        EmployerCPF = item.EmployerCPF;
                        AgencyAmount = item.Agnecy;
                        SDF = item.SDF;
                        PaymentMode = item.PaymentMode;
                        NetPay = item.NetPay;
                        AgencyType = AgencyType;
                    }
                }

                GrossPay = BasicPay + OT + Incentives;

                if ((VisaType == "Singaporean" || VisaType == "Permanent Resident") && GrossPay > 750) {

                    EmployeeCPF = CalculateEmployeeCPF(GrossPay, Age);
                    EmployerCPF = CalculateEmployerCPF(GrossPay, Age);
                }


                NetPay = GrossPay - EmployeeCPF - AgencyAmount - Deductions;

                EndMonthData.push({
                    _id: value._id,
                    EmployeeID: EmployeeID,
                    EmployeeName: EmployeeName,
                    BankName: BankName,
                    Acc: Acc,
                    EDateOfJoin: EDateOfJoin,
                    BasicPay: BasicPay,
                    DayRate: DayRate,
                    Remarks: Remarks,
                    IsConfirmed: IsConfirmed,
                    PayRollID: PayRollID,
                    TotalDays: TotalDays,
                    CalendarDays: CalendarDays,
                    AgencyAmount: AgencyAmount,
                    SDF: SDF,
                    AgencyType: AgencyType,
                    PaymentMode: PaymentMode,
                    OT: OT,
                    Incentives: Incentives,
                    Deductions: Deductions,
                    GrossPay: GrossPay,
                    EmployeeCPF: EmployeeCPF,
                    EmployerCPF: EmployerCPF,
                    NetPay: NetPay
                });

            });

            $scope.EndMonthData = EndMonthData;
        }

        function CalculateEmployeeCPF(GrossPay, Age) {

            if (Age <= 55) {
                return (GrossPay * 20) / 100;
            }
            else if (Age > 55 && Age <= 60) {

                return (GrossPay * 13) / 100;
            }
            else if (Age > 60 && Age <= 65) {

                return (GrossPay * 7.5) / 100;
            }
            else if (Age > 65) {

                return (GrossPay * 5) / 100;

            } else {
                return 0;
            }
        }


        function CalculateEmployerCPF(GrossPay, Age) {

            if (Age <= 55) {
                return (GrossPay * 17) / 100;
            }
            else if (Age > 55 && Age <= 60) {

                return (GrossPay * 13) / 100;
            }
            else if (Age > 60 && Age <= 65) {

                return (GrossPay * 9) / 100;
            }
            else if (Age > 65) {

                return (GrossPay * 7.5) / 100;

            } else {
                return 0;
            }
        }

        $scope.EditSelected = function (e) {

            $scope.vm.Deductions = 0;
            $scope.vm.EmployeeCPF = 0;
            $scope.vm.EmployerCPF = 0;
            $scope.vm.AgencyAmount = 0;
            $scope.vm.SDF = 0;
            $scope.vm.PaymentMode = undefined;
            $scope.vm.Remarks = undefined;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/cpf/bulkeditpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.EditIndividual = function (EmployeeID, e) {

            $scope.vm.Deductions = 0;
            $scope.vm.EmployeeCPF = 0;
            $scope.vm.EmployerCPF = 0;
            $scope.vm.AgencyAmount = 0;
            $scope.vm.SDF = 0;
            $scope.vm.PaymentMode = undefined;
            $scope.vm.Remarks = undefined;

            $scope.IndividualEmployeeID = EmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];

            $scope.vm.Deductions = item.Deductions;
            $scope.vm.EmployeeCPF = item.EmployeeCPF;
            $scope.vm.EmployerCPF = item.EmployerCPF;
            $scope.vm.AgencyAmount = item.AgencyAmount;
            $scope.vm.SDF = item.SDF;
            $scope.vm.PaymentMode = item.PaymentMode;
            $scope.vm.Remarks = item.Remarks;

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/cpf/editpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitIndividual = function () {

            var EmployeeID = $scope.IndividualEmployeeID;
            var item = $scope.EndMonthData.filter(function (item) {
                return item._id === EmployeeID;
            })[0];

            debugger

            var GrossPay = item.BasicPay + item.OT + item.Incentives;

            var NetPay = GrossPay - $scope.vm.Deductions - $scope.vm.EmployeeCPF - $scope.vm.AgencyAmount;



            if (GrossPay < 0) {
                GrossPay = 0;
                NetPay = 0;
            }

            if (item.PayRollID == -1) {
                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/cpfpayroll/add",
                    data: {
                        EmployeeID: EmployeeID, Month: $scope.dateFields.selectedDate._d,
                        CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                        Incentives: item.Incentives, Deductions: $scope.vm.Deductions, GrossPay: GrossPay, EmployeeCPF: $scope.vm.EmployeeCPF,
                        EmployerCPF: $scope.vm.EmployerCPF, Agnecy: $scope.vm.AgencyAmount, SDF: $scope.vm.SDF, PaymentMode: $scope.vm.PaymentMode,
                        DayRate: item.DayRate, NetPay: NetPay, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                        CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
            else {

                var responses = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/cpfpayroll/update",
                    data: {
                        _id: item.PayRollID, EmployeeID: EmployeeID, CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                        Incentives: item.Incentives, Deductions: $scope.vm.Deductions, GrossPay: GrossPay, EmployeeCPF: $scope.vm.EmployeeCPF, IsConfirmed: item.IsConfirmed,
                        EmployerCPF: $scope.vm.EmployerCPF, Agnecy: $scope.vm.AgencyAmount, SDF: $scope.vm.SDF, PaymentMode: $scope.vm.PaymentMode,
                        DayRate: item.DayRate, NetPay: NetPay, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.createdby
                    },
                });
                responses.then(function (GList) {

                    $mdDialog.hide();
                    RefreshGrid();
                })
            }
        }

        $scope.ConfirmSelected = function (e) {

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/payroll/cpf/alertpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.UpdateSelected = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];



                var GrossPay = item.BasicPay + item.OT + item.Incentives;

                var NetPay = GrossPay - $scope.vm.Deductions - $scope.vm.EmployeeCPF - $scope.vm.AgencyAmount;

                if (GrossPay < 0) {
                    GrossPay = 0;
                    NetPay = 0;
                }

                if (item.PayRollID == -1) {
                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/cpfpayroll/add",
                        data: {
                            EmployeeID: item._id, Month: $scope.dateFields.selectedDate._d,
                            CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                            Incentives: item.Incentives, Deductions: $scope.vm.Deductions, GrossPay: GrossPay, EmployeeCPF: $scope.vm.EmployeeCPF,
                            EmployerCPF: $scope.vm.EmployerCPF, Agnecy: $scope.vm.AgencyAmount, SDF: $scope.vm.SDF, PaymentMode: $scope.vm.PaymentMode,
                            DayRate: item.DayRate, NetPay: NetPay, Remarks: $scope.vm.Remarks, IsConfirmed: item.IsConfirmed,
                            CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }
                else {
                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/cpfpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, IsConfirmed: item.IsConfirmed,
                            CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                            Incentives: item.Incentives, Deductions: $scope.vm.Deductions, GrossPay: GrossPay, EmployeeCPF: $scope.vm.EmployeeCPF,
                            EmployerCPF: $scope.vm.EmployerCPF, Agnecy: $scope.vm.AgencyAmount, SDF: $scope.vm.SDF, PaymentMode: $scope.vm.PaymentMode,
                            DayRate: item.DayRate, NetPay: NetPay, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.createdby
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                }




            })


        }

        $scope.ConfirmPayroll = function () {

            var d = $scope.SelectedIds;
            var index = 0;
            angular.forEach($scope.SelectedIds, function (value) {

                var item = $scope.EndMonthData.filter(function (item) {
                    return item._id === value;
                })[0];

                var GrossPay = item.BasicPay + item.OT + item.Incentives;

                var NetPay = GrossPay - item.Deductions;


                var NetPay = GrossPay - item.Deductions - item.EmployeeCPF - item.AgencyAmount;

                if (GrossPay < 0) {
                    GrossPay = 0;
                    NetPay = 0;
                }

                if (item.PayRollID == -1) {

                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/cpfpayroll/add",
                        data: {
                            EmployeeID: item._id, Month: $scope.dateFields.selectedDate._d, IsConfirmed: true,
                            CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                            Incentives: item.Incentives, Deductions: item.Deductions, GrossPay: GrossPay, EmployeeCPF: item.EmployeeCPF,
                            EmployerCPF: item.EmployerCPF, Agnecy: item.AgencyAmount, SDF: item.SDF, PaymentMode: item.PaymentMode,
                            DayRate: item.DayRate, NetPay: NetPay, Remarks: item.Remarks, CreatedBy: $rootScope.createdby, Client_Id: $rootScope.Client_Id
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })
                } else {

                    var responses = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/cpfpayroll/update",
                        data: {
                            _id: item.PayRollID, EmployeeID: item._id, CalendarDays: item.CalendarDays, BasicPay: item.BasicPay, OT: item.OT, TotalDays: item.TotalDays,
                            Incentives: item.Incentives, Deductions: item.Deductions, GrossPay: GrossPay, EmployeeCPF: item.EmployeeCPF,
                            EmployerCPF: item.EmployerCPF, Agnecy: item.AgencyAmount, SDF: item.SDF, PaymentMode: item.PaymentMode,
                            DayRate: item.DayRate, NetPay: NetPay, Remarks: item.Remarks, IsConfirmed: true, CreatedBy: $rootScope.createdby
                        },
                    });
                    responses.then(function (GList) {

                        $mdDialog.hide();

                        index = index + 1;
                        if (index == $scope.SelectedIds.length) {
                            RefreshGrid();
                        }
                    })

                }

            });


        }

        $scope.SelectedIds = [];
        $scope.CheckAll = function (IsTicked) {
            if (IsTicked == true) {
                $scope.TRCdiv = true;
                angular.forEach($scope.EndMonthData, function (value) {
                    if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
                })
                $scope.Selec = { value: true }
            }
            if (IsTicked == false) {
                $scope.TRCdiv = false;
                $scope.SelectedIds = [];
                $scope.Selec = { value: false }
            }
        }
        $scope.Check = function (TrF, Ids) {
            if (TrF == true) {
                $scope.TRCdiv = true;
                if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
            }
            if (TrF == false) {
                $scope.TRCdiv = false;
                var index = $scope.SelectedIds.indexOf(Ids);
                if (index > -1) {
                    $scope.SelectedIds.splice(index, 1);
                }
            }
            if ($scope.SelectedIds.length > 0) {
                $scope.TRCdiv = true;
            }
        }
        $scope.TRCdiv = false;



        $scope.RecordStatus = function (row) {

            if (row.IsConfirmed == true) {
                return "GreenColor";
            }
            else {
                return "RedColor"
            }
        }


        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Allowancesdatas.xlsx",{headers:true}) FROM ?', [$scope.Allowancesdatas]);
        };

        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        // Returns an array of dates between the two dates
        var getDates = function (startDate, endDate) {
            var dates = [],
                currentDate = startDate,
                addDays = function (days) {
                    var date = new Date(this.valueOf());
                    date.setDate(date.getDate() + days);
                    return date;
                };
            while (currentDate <= endDate) {
                dates.push(currentDate);
                currentDate = addDays.call(currentDate, 1);
            }
            return dates;
        };



        $scope.WorkedMonth = function (a) {
            var b = new Date();
            return momentDiff1(a, b);
        }

        function momentDiff1(a, b) {

            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');

            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        function lastmonth() {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            $scope.lastMonthStartDate = lastMonthStartDate;
            $scope.lastMonthEndDate = lastMonthEndDate;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        function getAge(dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        function buildLocaleProvider(formatString) {
            return {
                formatDate: function (date) {
                    if (date) return moment(date).format(formatString);
                    else return null;
                },
                parseDate: function (dateString) {
                    if (dateString) {
                        var m = moment(dateString, formatString, true);
                        return m.isValid() ? m.toDate() : new Date(NaN);
                    } else return null;
                }
            };
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Type-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true,

            //retrieve: true,

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.template', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_performance_template', {
            url: '/PerformanceTemplate',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/performance/template/template.html',
                    controller: 'templateController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.template')
        .controller('templateController', templateController);

    /** @ngInject */
    function templateController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Performance")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.allowances', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_payroll_allowances', {
            url: '/Allowances',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/payroll/allowances/allowances.html',
                    controller: 'allowancesController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.payroll.allowances')
        .controller('allowancesController', allowancesController);

    /** @ngInject */
    function allowancesController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payroll")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Allowancesgrid = true;
        $scope.Export = true;
        $scope.Allowancesform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Allowancesdatas.xlsx",{headers:true}) FROM ?', [$scope.Allowancesdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/Allowances/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Allowancesdatas = GList.data.data;
            });
        }

        $scope.Allowancesinfo = function (AllowancesId) {
            $scope.SID = AllowancesId;
            $scope.Update = true;
            $scope.Allowancesgrid = false;
            $scope.Allowancesform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            angular.forEach($scope.Allowancesdatas, function (value) {
                if (value.id === AllowancesId) {
                    $scope.vm.Type = value.Type;
                    $scope.vm.Remarks = value.Remarks;
                    $scope.vm.TypeName = value.TypeName;
                    $scope.vm.Period = value.Period;
                    $scope.vm.TypeCode = value.TypeCode;
                }
            });
        }

        $scope.sSubmit = function () {
            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/allowance/update",
                    data: {
                        _id: $scope.SID,
                        Type: $scope.vm.Type, TypeName: $scope.vm.TypeName,
                        Period: $scope.vm.Period, TypeCode: $scope.vm.TypeCode,
                        Remarks: $scope.vm.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Allowancesgrid = true;
                    $scope.Allowancesform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/allowance/add",
                    data: {
                        Type: $scope.vm.Type, TypeName: $scope.vm.TypeName,
                        Period: $scope.vm.Period, TypeCode: $scope.vm.TypeCode,
                        Remarks: $scope.vm.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Allowancesgrid = true;
                    $scope.Allowancesform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Showgrid = function () {
            $scope.Allowancesgrid = true;
            $scope.Allowancesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Allowancesform = true;
            $scope.Allowancesgrid = false;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.vm.Period = new Date();
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/allowance",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Allowancesdata) {
            $scope.Allowancesdatas = Allowancesdata.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/allowance",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Allowancesdata) {
                $scope.Allowancesdatas = Allowancesdata.data.data;
            });
        }

        function ClearForm() {
            $scope.vm.TypeName = null;
            $scope.vm.Period = null;
            $scope.vm.TypeCode = null;
            $scope.vm.Remarks = null;
            $scope.vm.TypeCode = null;
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Type-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.tracker', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_performance_tracker', {
            url: '/PerformanceTracker',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/performance/tracker/tracker.html',
                    controller: 'trackerController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.tracker')
        .controller('trackerController', trackerController);

    /** @ngInject */
    function trackerController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Performance")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

    }

})();




(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.review', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_performance_review', {
            url: '/PerformanceReview',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/performance/review/review.html',
                    controller: 'reviewController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.performance.review')
        .controller('reviewController', reviewController);

    /** @ngInject */
    function reviewController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Performance")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.insurance.items', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_insurance_items', {
            url: '/InsuranceItems',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/insurance/items/items.html',
                    controller: 'itemsController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/insurance/items');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.insurance.items')
        .controller('itemsController', itemsController);

    /** @ngInject */
    function itemsController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, $location, $filter, Upload) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Vehicle Insurance"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Insurance")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Insuranceitemsgrid = true;
        $scope.Export = true;
        $scope.Insuranceitemsform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.FileID = undefined
        $scope.sExport = function () {
            alasql('SELECT InsuranceitemsName,InsuranceitemsCode,ClientID,InsuranceitemsStartTime,InsuranceitemsEndTime,NightInsuranceitems,LunchBreakStartTime,LunchBreakEndTime,Break1StartTime,Break1EndTime,DaysofWeek INTO XLSX("Insuranceitemsdatas.xlsx",{headers:true}) FROM ?', [$scope.Insuranceitemsdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.shiftinfo = function (InsuranceitemsID) {
            $scope.SID = InsuranceitemsID;
            $scope.Update = true;
            $scope.Insuranceitemsform = true;
            $scope.Insuranceitemsgrid = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.Export = false;
            $scope.view = true;

            var item = $scope.Insuranceitemsdatas.filter(function (item) {
                return item.id === InsuranceitemsID;
            })[0];
            $scope.InsuranceName = item.InsuranceName;
            $scope.ProviderName = item.ProviderName;
            $scope.FileID = item.FileID;
            $scope.StartDate = new Date(item.StartDate);
            $scope.Remarks = item.Remarks;
            $scope.EndDate = new Date(item.EndDate);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/getbyId",
                data: { _id: $scope.FileID }
            }).then(function (List) {
                if (List.data.data.length > 0) {
                    $scope.TableID = List.data.data[0].TableID
                    $scope.fileName = List.data.data[0].FileName
                }
                else {
                    $scope.TableID = '#'
                    $scope.fileName = ''
                    $scope.FileID = undefined
                }
                RefreshAttach('nric')
            })
        }

        $scope.sSubmit = function () {
            debugger

            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/insuranceitems/update",
                    data: {
                        _id: $scope.SID,
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Insuranceitemsgrid = true;
                    $scope.Insuranceitemsform = false;
                    $scope.Update = false
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/insuranceitems/add",
                    data: {
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Insuranceitemsgrid = true;
                    $scope.Insuranceitemsform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.UploadFile = function (file) {
            debugger
            try {
                var docum = $("#" + file)[0].files
                if (docum.length > 0) {
                    docum = docum[0]
                    $scope.DocumentName = docum.name
                    //   if($scope.Update==true){
                    $scope.vm.Spinner = true
                    var response = Upload.upload({
                        url: $rootScope.WebURL + "/insuranceitems/upload",
                        data: { file: docum }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID, TableName: "VehicleInsurance", FileID: null,
                                    FileName: $scope.fileName, DocumentName: file,
                                    FileSize: $scope.fileSize, FileType: $scope.fileType,
                                    ModuleID: $scope.Path, Data: null, IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response.then(function (GList) {
                                $scope.FileID = GList.data.data.id
                                RefreshAttach(file);
                                $("#" + file).val('')
                                $scope.vm.Spinner = false
                                $mdToast.show($mdToast.simple().textContent('Successfully Uploaded!').position('top center'));
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

                // }
            } catch (error) {

            }
        }

        $scope.messages = [
            { Name: "Document", value: "nric" },
        ]

        function RefreshAttach(name) {
            if ($scope.FileID != undefined) {
                document.getElementById('Upload' + name).style.display = "none";
                document.getElementById(name).style.display = "none";
                document.getElementById('Delete' + name).style.display = "block";
                document.getElementById('test' + name).style.display = "block";
                if (name === 'nric') {
                    var abc = $rootScope.UploadsURL + '/HRMCore/VehicleInsurance/' + $scope.TableID;
                    document.getElementById('testnric').innerHTML = '<a href="' + abc + '">' + $scope.fileName + '</a>';
                }

            }
            else {
                document.getElementById('Upload' + name).style.display = "block";
                document.getElementById(name).style.display = "block";
                document.getElementById('Delete' + name).style.display = "none";
                document.getElementById('test' + name).style.display = "none";
                if (name === 'nric') $scope.nricAtach = []

            }
        }

        $scope.Removefile = function (name) {
            var id = null
            if (name === 'nric') id = $scope.FileID

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/delete",
                data: { _id: id },
            }).then(function (List) {
                $scope.FileID = undefined
                RefreshAttach(name)
                $mdToast.show($mdToast.simple().textContent('Deleted successfully !').position('top center'));
            })
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Insuranceitemsform = true;
            $scope.Insuranceitemsgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Yearly = { value: false };
            $("#nric").val('')
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/insuranceitems",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (insuranceitems) {
            $scope.Insuranceitemsdatas = insuranceitems.data.data;
        });

        function RefreshGrid() {

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/insuranceitems",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (insuranceitems) {
                $scope.Insuranceitemsdatas = insuranceitems.data.data;
            });
        }

        $scope.DeleteInfo = function (id) {
            $scope.vid = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the record ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/insuranceitems/delete",
                        method: "POST",
                        data: { id: $scope.vid },
                    });
                    response.then(function (GList) {
                        RefreshGrid()
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.Showgrid = function () {
            $scope.Insuranceitemsgrid = true;
            $scope.Insuranceitemsform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.Yearly = { value: false };
        }
        function ClearForm() {
            $scope.ProviderName = null;
            $scope.InsuranceName = null;
            $scope.FileID = undefined;
            $scope.Amount = null;
            $scope.StartDate = new Date(new Date().setFullYear(new Date().getFullYear()));;
            $scope.Yearly = null;
            $scope.Excess = null;
            $scope.Remarks = null;
            $scope.EndDate = new Date(new Date().setMonth(new Date().getMonth() + 1));;
            RefreshAttach('nric')
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }

        };

    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.insurance.master', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_insurance_master', {
            url: '/InsuranceMaster',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/insurance/master/master.html',
                    controller: 'masterController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/insurance/master');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.insurance.master')
        .controller('masterController', masterController);
    /** @ngInject */
    function masterController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdDialog, $document, Upload, $mdSidenav, $http, $window, $filter) {
        document.getElementsByTagName('title')[0].text = "Human Resource-General Insurance"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Insurance")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Insurancemastergrid = true;
        $scope.Export = true;
        $scope.Insurancemasterform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Insurancemasterdatas.xlsx",{headers:true}) FROM ?', [$scope.Insurancemasterdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.shiftinfo = function (InsuranceitemsID) {
            $scope.SID = InsuranceitemsID;
            $scope.Update = true;
            $scope.Insurancemasterform = true;
            $scope.Insurancemastergrid = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.Export = false;
            $scope.view = true;

            var item = $scope.Insurancemasterdatas.filter(function (item) {
                return item.id === InsuranceitemsID;
            })[0];
            $scope.InsuranceName = item.InsuranceName;
            $scope.ProviderName = item.ProviderName;
            $scope.FileID = item.FileID;
            $scope.StartDate = new Date(item.StartDate);
            $scope.Remarks = item.Remarks;
            $scope.EndDate = new Date(item.EndDate);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/getbyId",
                data: { _id: $scope.FileID }
            }).then(function (List) {
                if (List.data.data.length > 0) {
                    $scope.TableID = List.data.data[0].TableID
                    $scope.fileName = List.data.data[0].FileName
                }
                else {
                    $scope.TableID = '#'
                    $scope.fileName = ''
                    $scope.FileID = undefined
                }
                RefreshAttach('nric')
            })
        }


        $scope.sSubmit = function () {
            debugger
            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/insurancemaster/update",
                    data: {
                        _id: $scope.SID,
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Insurancemastergrid = true;
                    $scope.Insurancemasterform = false;
                    $scope.Update = false
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/insurancemaster/add",
                    data: {
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Insurancemastergrid = true;
                    $scope.Insurancemasterform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Insurancemasterform = true;
            $scope.Insurancemastergrid = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.view = true;
            $scope.Add = false;

        }
        $scope.UploadFile = function (file) {
            debugger
            try {
                var docum = $("#" + file)[0].files
                if (docum.length > 0) {
                    docum = docum[0]
                    $scope.DocumentName = docum.name
                    //   if($scope.Update==true){
                    $scope.vm.Spinner = true
                    var response = Upload.upload({
                        url: $rootScope.WebURL + "/insurancemaster/upload",
                        data: { file: docum }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID, TableName: "GeneralInsurance", FileID: null,
                                    FileName: $scope.fileName, DocumentName: file,
                                    FileSize: $scope.fileSize, FileType: $scope.fileType,
                                    ModuleID: $scope.Path, Data: null, IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response.then(function (GList) {
                                $scope.FileID = GList.data.data.id
                                RefreshAttach(file);
                                $("#" + file).val('')
                                $scope.vm.Spinner = false
                                $mdToast.show($mdToast.simple().textContent('Successfully Uploaded!').position('top center'));
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

                // }
            } catch (error) {

            }
        }

        $scope.messages = [
            { Name: "Document", value: "nric" },
        ]

        function RefreshAttach(name) {
            if ($scope.FileID != undefined) {
                document.getElementById('Upload' + name).style.display = "none";
                document.getElementById(name).style.display = "none";
                document.getElementById('Delete' + name).style.display = "block";
                document.getElementById('test' + name).style.display = "block";
                if (name === 'nric') {
                    var abc = $rootScope.UploadsURL + '/HRMCore/GeneralInsurance/' + $scope.TableID;
                    document.getElementById('testnric').innerHTML = '<a href="' + abc + '">' + $scope.fileName + '</a>';
                }

            }
            else {
                document.getElementById('Upload' + name).style.display = "block";
                document.getElementById(name).style.display = "block";
                document.getElementById('Delete' + name).style.display = "none";
                document.getElementById('test' + name).style.display = "none";
                if (name === 'nric') $scope.nricAtach = []

            }
        }

        $scope.Removefile = function (name) {
            var id = null
            if (name === 'nric') id = $scope.FileID

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/delete",
                data: { _id: id },
            }).then(function (List) {
                $scope.FileID = undefined
                RefreshAttach(name)
                $mdToast.show($mdToast.simple().textContent('Deleted successfully !').position('top center'));
            })
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/insurancemaster",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (insurancemaster) {
            $scope.Insurancemasterdatas = insurancemaster.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/insurancemaster",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (insurancemaster) {
                $scope.Insurancemasterdatas = insurancemaster.data.data;
            });
        }

        $scope.DeleteInfo = function (id) {
            $scope.vid = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the record ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/insurancemaster/delete",
                        method: "POST",
                        data: { id: $scope.vid },
                    });
                    response.then(function (GList) {
                        RefreshGrid()
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.Showgrid = function () {
            $scope.Insurancemastergrid = true;
            $scope.Insurancemasterform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        function ClearForm() {
            $scope.ProviderName = null;
            $scope.InsuranceName = null;
            $scope.FileID = undefined;
            $scope.Amount = null;
            $scope.StartDate = new Date(new Date().setFullYear(new Date().getFullYear()));;
            $scope.Yearly = null;
            $scope.Excess = null;
            $scope.Remarks = null;
            $scope.EndDate = new Date(new Date().setMonth(new Date().getMonth() + 1));;
            RefreshAttach('nric')
        }

        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.health.eshbreifing')
        .controller('EshbreifingController', EshbreifingController);

    /** @ngInject */
    function EshbreifingController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $mdDialog, $document, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Health")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');
        RefreshGrid();
        RefreshEmployeeGrid();

        $scope.Breifinggrid = true;
        $scope.Breifingform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;

        $scope.Export = function () {

            alasql('SELECT EmployeeName,Date,Description INTO XLSX("Breifingdatas.xlsx",{headers:true}) FROM ?', [$scope.breifingsummary]);
        };

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Breifinggrid = false;
            $scope.Breifingform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Date = new Date();
        }

        $scope.Showgrid = function () {
            $scope.Breifinggrid = true;
            $scope.Breifingform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }

        $scope.bSubmit = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/eshbreifing/update",
                    data: {
                        _id: $scope.SID,
                        EmployeeID: $scope.Employee,
                        Date: $scope.Date,
                        Description: $scope.Description,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Breifingdatas[$scope.IndexID] = GList.data.data[0];
                    //RefreshGrid();

                    $scope.Breifinggrid = true;
                    $scope.Breifingform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/eshbreifing/add",
                    data: {
                        Client_Id: Client_Id,
                        EmployeeID: $scope.Employee,
                        Date: $scope.Date,
                        Description: $scope.Description,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();

                    $scope.Breifinggrid = true;
                    $scope.Breifingform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Breifinginfo = function (BreifingId, $index) {

            $scope.SID = BreifingId;
            $scope.IndxID = $index;
            $scope.Update = true;

            $scope.Breifingform = true;
            $scope.Breifinggrid = false;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;

            try {
                var BreifingArray = $scope.Breifingdatas;
                var item = BreifingArray.filter(function (item) {
                    return item._id === BreifingId;
                })[0];
                $scope.id = item._id;
                $scope.Employee = item.EmployeeID;
                $scope.Date = new Date(item.Date);
                $scope.Description = item.Description;
            } catch (err) { }

        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/eshbreifing",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Breifingdata) {
                $scope.Breifingdatas = Breifingdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function ClearForm() {
            $scope.Employee = '';
            $scope.Date = '';
            $scope.Description = '';
        }

        //$http.get( $rootScope.WebURL + "/employee")
        // .then(function (Employeedata) {
        //     $scope.Employeedatas = Employeedata.data.data;
        // });

        //$http.get( $rootScope.WebURL + "/eshbreifing")
        //    .then(function (Breifingdata) {
        //        $scope.Breifingdatas = Breifingdata.data.data;
        //        Breifingsummary();
        //    });

        //function Breifingsummary() {
        //    
        //    var master = [];
        //    var Employeeinfo = $scope.Employeedatas
        //    var Breifinginfo = $scope.Breifingdatas
        //    for (var i = 0; i < Breifinginfo.length; i++) {
        //        for (var d = 0; d < Employeeinfo.length; d++) {
        //            if (Breifinginfo[i].EmployeeID == Employeeinfo[d].id) {
        //                master.push({
        //                    id: Breifinginfo[i].id,
        //                    Date: Breifinginfo[i].Date,
        //                    Description: Breifinginfo[i].Description,
        //                    EmployeeName: Employeeinfo[d].EmployeeName,
        //                    EmployeeID: Employeeinfo[d].id,
        //                })
        //            }
        //        }
        //    }
        //    $scope.breifingsummary = master;
        //}


        //function RefreshGrid() {
        //    $http.get( $rootScope.WebURL + "/eshbreifing")
        //    .then(function (Breifingdata) {
        //        $scope.Breifingdatas = Breifingdata.data.data;
        //        Breifingsummary();
        //    });
        //}



        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true

        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }





    }

})();



(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.incident', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_health_incident', {
            url: '/IncidentReport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/health/incident/incident.html',
                    controller: 'IncidentController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.incident')
        .controller('IncidentController', IncidentController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });

    function IncidentController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, $filter, Upload) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Incident Reports"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');

        $scope.Incidentform = false;
        $scope.Incidentgrid = true;
        $scope.iExport = true;
        $scope.iAdd = true;
        $scope.iSearch = true;
        $scope.iView = false;
        $scope.Update = false;
        $scope.Incident = false;

        RefreshGrid();
        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }


        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("IncidentReports.xlsx",{headers:true}) FROM ?', [$scope.Incidentdatas]);
        };

        $scope.Showgrid = function () {
            $scope.Incidentgrid = true;
            $scope.Incidentform = false;
            $scope.iExport = true;
            $scope.iAdd = true;
            $scope.iView = false;
            $scope.iSearch = true;
            $scope.Incident = false;
        }

        $scope.shiftinfo = function (InsuranceitemsID) {
            $scope.SID = InsuranceitemsID;
            $scope.Update = true;
            $scope.Incidentform = true;
            $scope.Incidentgrid = false;
            $scope.iAdd = false;
            $scope.iSearch = false;
            $scope.iExport = false;
            $scope.iView = true;

            var item = $scope.Incidentdatas.filter(function (item) {
                return item._id === InsuranceitemsID;
            })[0];
            $scope.InsuranceName = item.InsuranceName;
            $scope.ProviderName = item.ProviderName;
            $scope.FileID = item.FileID;
            $scope.StartDate = new Date(item.StartDate);
            $scope.Remarks = item.Remarks;
            $scope.EndDate = new Date(item.EndDate);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/getbyId",
                data: { _id: $scope.FileID }
            }).then(function (List) {
                if (List.data.data.length > 0) {
                    $scope.TableID = List.data.data[0].TableID
                    $scope.fileName = List.data.data[0].FileName
                }
                else {
                    $scope.TableID = '#'
                    $scope.fileName = ''
                    $scope.FileID = undefined
                }
                RefreshAttach('nric')
            })
        }

        $scope.sSubmit = function () {

            if ($scope.Update === true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/incident/update",
                    data: {
                        _id: $scope.SID,
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Incidentgrid = true;
                    $scope.Incidentform = false;
                    $scope.Update = false
                    $scope.iExport = true;
                    $scope.iAdd = true;
                    $scope.iSearch = true;
                    $scope.iView = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/incident/add",
                    data: {
                        InsuranceName: $scope.InsuranceName,
                        ProviderName: $scope.ProviderName,
                        FileID: $scope.FileID,
                        StartDate: $scope.StartDate,
                        EndDate: $scope.EndDate,
                        Remarks: $scope.Remarks,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: true
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Incidentgrid = true;
                    $scope.Incidentform = false;
                    $scope.iExport = true;
                    $scope.iAdd = true;
                    $scope.iSearch = true;
                    $scope.iView = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.UploadFile = function (file) {
            debugger
            try {
                var docum = $("#" + file)[0].files
                if (docum.length > 0) {
                    docum = docum[0]
                    $scope.DocumentName = docum.name
                    //   if($scope.Update==true){
                    $scope.vm.Spinner = true
                    var response = Upload.upload({
                        url: $rootScope.WebURL + "/incident/upload",
                        data: { file: docum }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID, TableName: "Incident", FileID: null,
                                    FileName: $scope.fileName, DocumentName: file,
                                    FileSize: $scope.fileSize, FileType: $scope.fileType,
                                    ModuleID: $scope.Path, Data: null, IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response.then(function (GList) {
                                $scope.FileID = GList.data.data.id
                                RefreshAttach(file);
                                $("#" + file).val('')
                                $scope.vm.Spinner = false
                                $mdToast.show($mdToast.simple().textContent('Successfully Uploaded!').position('top center'));
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

                // }
            } catch (error) {

            }
        }

        $scope.messages = [
            { Name: "Document", value: "nric" },
        ]

        function RefreshAttach(name) {
            if ($scope.FileID != undefined) {
                document.getElementById('Upload' + name).style.display = "none";
                document.getElementById(name).style.display = "none";
                document.getElementById('Delete' + name).style.display = "block";
                document.getElementById('test' + name).style.display = "block";
                if (name === 'nric') {
                    var abc = $rootScope.UploadsURL + '/HRMCore/VehicleInsurance/' + $scope.TableID;
                    document.getElementById('testnric').innerHTML = '<a href="' + abc + '">' + $scope.fileName + '</a>';
                }

            }
            else {
                document.getElementById('Upload' + name).style.display = "block";
                document.getElementById(name).style.display = "block";
                document.getElementById('Delete' + name).style.display = "none";
                document.getElementById('test' + name).style.display = "none";
                if (name === 'nric') $scope.nricAtach = []

            }
        }

        $scope.Removefile = function (name) {
            var id = null
            if (name === 'nric') id = $scope.FileID

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/delete",
                data: { _id: id },
            }).then(function (List) {
                $scope.FileID = undefined
                RefreshAttach(name)
                $mdToast.show($mdToast.simple().textContent('Deleted successfully !').position('top center'));
            })
        }

        function ClearForm() {
            $scope.ProviderName = null;
            $scope.InsuranceName = null;
            $scope.FileID = undefined;
            $scope.Amount = null;
            $scope.StartDate = new Date(new Date().setFullYear(new Date().getFullYear()));;
            $scope.Yearly = null;
            $scope.Excess = null;
            $scope.Remarks = null;
            $scope.EndDate = new Date(new Date().setMonth(new Date().getMonth() + 1));;
            RefreshAttach('nric')
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Incidentgrid = false;
            $scope.Incidentform = true;
            $scope.iExport = false;
            $scope.iView = true;
            $scope.iAdd = false;
            $scope.iSearch = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Yearly = { value: false };
            $("#nric").val('')
        }
        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/incident",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Incidentdata) {
                $scope.Incidentdatas = Incidentdata.data.data;
            });
        }


        var vm = this;

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide isearch box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }
})();





(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.medical', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_health_medical', {
            url: '/MedicalClaim',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/health/medical/medical.html',
                    controller: 'MedicalController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.medical')
        .controller('MedicalController', MedicalController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });

    function MedicalController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, $filter, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Health")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var Client_Id = localStorage.getItem('Client_Id');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();

        var MedicalID = null;
        if (MedicalID != null) {
            var response = $http({
                url: $rootScope.WebURL + "/medical",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Medicaldata) {
                $scope.AllMedicaldatas = Medicaldata.data.data;
                try {
                    var item = $scope.AllMedicaldatas.filter(function (item) {
                        return item._id === MedicalID;
                    })[0];
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueMID = item.UniqueMID;
                    $scope.Employee = item.EmployeeID;
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.ClaimDate = new Date(item.ClaimDate);
                    $scope.VisitDate = new Date(item.VisitDate);
                    $scope.MedicalInstitution = item.MedicalInstitution;
                    $scope.Amount = parseInt(item.Amount);
                    $scope.Consultation = parseInt(item.Consultation);
                    $scope.Reimbursable = parseInt(item.Reimbursable);
                    $scope.MedicalLeave = item.MedicalLeave;
                    $scope.Purpose = item.Purpose;
                    $scope.Remarks = item.Remarks;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }
                $scope.Update = true;
                $scope.Medicalform = true;
                $scope.Medicalgrid = false;
                $scope.mExport = false;
                $scope.mView = true;
                $scope.mAdd = false;
                $scope.mSearch = false;
                $scope.MedicalClaim = true;
                $scope.vm.Comments = '';
                $scope.Commentdatas = '';
                $scope.Attachmentdatas = '';
                $scope.Logdetailsdatas = '';
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'HRM Medical Claim Request') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'HRM Medical Claim Request') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }
                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
            });
        }
        else {
            $scope.Medicalform = false;
            $scope.Medicalgrid = true;
            $scope.mExport = true;
            $scope.mAdd = true;
            $scope.mSearch = true;
            $scope.mView = false;
            $scope.MedicalClaim = false;
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("MedicalClaims.xlsx",{headers:true}) FROM ?', [$scope.Medicaldatas]);
        };

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/medical/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Medicaldatas = GList.data.data;
            });
        }

        $scope.Showgrid = function () {
            $scope.Medicalgrid = true;
            $scope.Medicalform = false;
            $scope.mExport = true;
            $scope.mAdd = true;
            $scope.mView = false;
            $scope.mSearch = true;
            $scope.MedicalClaim = false;
        }

        $scope.Medicalinfo = function (MedicalId, $index) {
            $scope.SID = MedicalId;
            $scope.IndxID = $index;
            $scope.Update = true;

            $scope.Medicalform = true;
            $scope.Medicalgrid = false;
            $scope.mExport = false;
            $scope.mView = true;
            $scope.mAdd = false;
            $scope.mSearch = false;
            $scope.MedicalClaim = true;
            $scope.vm.Comments = '';
            $scope.Claimsave = false;

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = $scope.Status;
            $scope.NextLevelAction = '';

            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();

            try {
                var item = $scope.Medicaldatas.filter(function (item) {
                    return item._id === MedicalId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueMID = item.UniqueMID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.ClaimDate = new Date(item.ClaimDate);
                $scope.VisitDate = new Date(item.VisitDate);
                $scope.MedicalInstitution = item.MedicalInstitution;
                $scope.Amount = parseFloat(item.Amount);
                $scope.Consultation = parseFloat(item.Consultation);
                $scope.Reimbursable = parseFloat(item.Reimbursable);
                $scope.MedicalLeave = item.MedicalLeave;
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'HRM Medical Claim Request') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'HRM Medical Claim Request') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }
            if ($scope.NextLevelAction == "Approve") {
                $scope.Claimsave = true;
            }
            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueMID,
                    TableName: "HRM Medical Claim Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/medical/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Medical Claim Request",
                            FileID: $scope.UniqueMID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.mUpdate = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medical/updateMedicalDetails",
                    data: {
                        _id: $scope.SID,
                        Amount: $scope.Amount,
                        Consultation: $scope.Consultation,
                        Reimbursable: $scope.Reimbursable,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            }
        }

        $scope.workflow = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medical/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Medical Claim Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Medical Claim Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/medical/email",
                            data: {
                                MedicalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueMID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                ClaimDate: convertDate($scope.Userdata.ClaimDate),
                                VisitDate: convertDate($scope.Userdata.VisitDate),
                                MedicalInstitution: $scope.Userdata.MedicalInstitution,
                                Amount: $scope.Userdata.Amount,
                                Consultation: $scope.Userdata.Consultation,
                                Reimbursable: $scope.Userdata.Reimbursable,
                                MedicalLeave: $scope.Userdata.MedicalLeave,
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueMID,
                            TypeName: "HRM Medical Claim Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Medicaldatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.reject = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medical/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Medical Claim Request' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/medical/email",
                            data: {
                                MedicalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueMID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                ClaimDate: convertDate($scope.Userdata.ClaimDate),
                                VisitDate: convertDate($scope.Userdata.VisitDate),
                                MedicalInstitution: $scope.Userdata.MedicalInstitution,
                                Amount: $scope.Userdata.Amount,
                                Consultation: $scope.Userdata.Consultation,
                                Reimbursable: $scope.Userdata.Reimbursable,
                                MedicalLeave: $scope.Userdata.MedicalLeave,
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueMID,
                            TypeName: "HRM Medical Claim Request",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Medicaldatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Medical.aspx?ID=" + PId;
            window.open(url);
        };

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/medical",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Medicaldata) {
                $scope.Medicaldatas = Medicaldata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueMID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueMID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueMID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }
})();




(function () {
    'use strict';

    angular
 
        .module('app.human-resource.health.eshattendance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_health_eshattendance', {
            url: '/EshAttendance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/health/eshattendance/eshattendance.html',
                    controller: 'EshattendanceController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.health.eshattendance')
        .controller('EshattendanceController', EshattendanceController);
    /** @ngInject */
    function EshattendanceController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $mdDialog, $document, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Health")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');
        RefreshGrid();

        $scope.Attendancegrid = true;
        $scope.Attendanceform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;


        $scope.Export = function () {

            alasql('SELECT Date,Description,Attachment INTO XLSX("Attendancedatas.xlsx",{headers:true}) FROM ?', [$scope.attendancesummary]);
        };

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Attendancegrid = false;
            $scope.Attendanceform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Date = new Date();
        }

        $scope.Showgrid = function () {
            $scope.Attendancegrid = true;
            $scope.Attendanceform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }

        $scope.aSubmit = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/eshattendance/update",
                    data: {
                        _id: $scope.SID,
                        Date: $scope.Date,
                        Description: $scope.Description,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Attendancedatas[$scope.IndexID] = GList.data.data;
                    //RefreshGrid();

                    $scope.Attendancegrid = true;
                    $scope.Attendanceform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/eshattendance/add",
                    data: {
                        Client_Id: Client_Id,
                        Date: $scope.Date,
                        Description: $scope.Description,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();

                    $scope.Attendancegrid = true;
                    $scope.Attendanceform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Attendanceinfo = function (AttendanceId, $index) {

            $scope.SID = AttendanceId;
            $scope.IndxID = $index;
            $scope.Update = true;

            $scope.Attendancegrid = false;
            $scope.Attendanceform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;

            try {
                var Array = $scope.Attendancedatas;
                var item = Array.filter(function (item) {
                    return item.id === AttendanceId;
                })[0];
                $scope.id = item.id;
                $scope.Date = new Date(item.Date);
                $scope.Description = item.Description;
                $scope.Attachment = item.Attachment;
            } catch (err) { }


            //$scope.AttendanceinfoId = AttendanceId;
            //var info = $scope.Attendancedatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == AttendanceId) {
            //        $scope.Date = new Date(info[i].Date);
            //        $scope.Description = info[i].Description;
            //        $scope.Attachment = info[i].Attachment;
            //    }
            //}
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/eshattendance",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Attendancedata) {
                $scope.Attendancedatas = Attendancedata.data.data;
            });

            //$http.get( $rootScope.WebURL + "/eshattendance")
            //.then(function (Attendancedata) {
            //    $scope.Attendancedatas = Attendancedata.data.data;
            //});
        }

        // $http.get( $rootScope.WebURL + "/attachment")
        //.then(function (Attachmentdata) {
        //    
        //    $scope.Attachmentdatas = Attachmentdata.data.data;
        //});

        // function Attendancedatasummary() {
        //     
        //     var attendance = [];
        //     var Attachmentinfo = $scope.Attachmentdatas
        //     var info = $scope.Attendancedatas
        //     for (var i = 0; i < info.length; i++) {
        //         for (var d = 0; d < Attachmentinfo.length; d++) {
        //             if (info[i].id == Attachmentinfo[d].TableID && Attachmentinfo[d].TableName == 'EshAttendance') {
        //                 attendance.push({
        //                     id: info[i].id, Date: info[i].Date, Description: info[i].Description,
        //                     Attachment: decode_base64(Attachmentinfo[d].Attachment), DataId: Attachmentinfo[d].id,
        //                 })
        //             }
        //         }
        //     }
        //     $scope.attendancedatasummary = attendance;
        // }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        function ClearForm() {
            $scope.Date = '';
            $scope.Description = '';
            $scope.Attachment = '';
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true

        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.human-resource.leaveentitlement', ['flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.human-resource_HcmLeave_leaveentitlement', {
            url: '/LeaveEntitlement',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmLeave/leaveentitlement/leaveentitlement.html',
                    controller: 'LeaveEntitlementController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.leaveentitlement')
        .controller('LeaveEntitlementController', LeaveEntitlementController);

    function LeaveEntitlementController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $mdDialog, $document, $http, $filter, Upload) {

        document.getElementsByTagName('title')[0].text = "Human Resource-Leave Approval"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("ELeaves")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();

        $scope.getLeave = function (data) {
            $scope.Leavegrid = false;
            $scope.Leaveform = false;
            $scope.Leaveform2 = true
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lView = false;
            $scope.UView = true;
            $scope.lSearch = false;
            $scope.LeaveUpdate = false

            $scope.vm.ContractId = data._id
            $scope.EmployeeName = data.Employeedetails[0].EmployeeID + '-' + data.Employeedetails[0].EmployeeName
            $scope.LeaveType = data.Type
            $scope.LeaveDates = $filter('date')(data.StartDate, 'dd/MM/yyyy') + ' to ' + $filter('date')(data.EndDate, 'dd/MM/yyyy')
            $scope.Reamrks = data.Remarks
            RefresAttach()

        }

        $scope.AddLeaveEntitlement = function () {
            $scope.Leavegrid = false
            $scope.LeaveUpdate = false
            $scope.Leaveform = true
            $scope.Leaveform2 = false
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.lView = true;
            $scope.UView = false;
            $scope.Update = false;
            $scope.vm.AnnualLeave = 0
            $scope.vm.UnpaidLeave = 0;
            $scope.vm.SickHospitalisation = 0
            $scope.vm.Adoption = 0
            $scope.vm.Paternity = 0
            $scope.vm.Maternity = 0
            $scope.vm.ChildCare = 0
            $scope.vm.Reservist = 0
            $scope.vm.OAnnualLeave = 0
            $scope.vm.OUnpaidLeave = 0;
            $scope.vm.OHospital = 0
            $scope.vm.OMedical = 0
            $scope.vm.OPaternal = 0
            $scope.vm.OMaternity = 0
            $scope.vm.OChildCare = 0
            $scope.vm.OReservist = 0
            $scope.vm.FromLeave = "FullDay";
            $scope.vm.ToLeave = "FullDay";
            $scope.SameDate = false
            Clearform()
        }
        $scope.Leavedatas = [
            { Name: "Annual Leave" },
            { Name: "Medical Leave" },
            { Name: "Hospitalization Leave" },
            { Name: "Unpaid Leave" },
            { Name: "Maternity Leave" },
            { Name: "Paternity Leave" },
            { Name: "Childcare Leave" },
            { Name: "Reservist Leave" },
        ]

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/leaveentitlement",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leaveentitlementdata) {
                $scope.Leaveentitlementdatas = Leaveentitlementdata.data.data;
                RefreshEmployeeGrid()
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/getforLeave",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                angular.forEach(Employeedata.data.data, function (value) {
                    value.EmpID = value.EmployeeID
                    value.EmployeeID = value.id
                })
                $scope.Employeedatas = Employeedata.data.data;
                $scope.GroupEmployee = Employeedata.data.data;
                //  $scope.GroupEmployee = _.intersectionBy($scope.Employeedatas, $scope.Leaveentitlementdatas, "EmployeeID")
            });
        }

        $scope.getEmployeeBalance = function (row) {
            var data = row
            if (row.Annual != null && data.Annual != undefined && data.Annual != "") {
                $scope.vm.AnnualLeave = row.Annual
                $scope.vm.OAnnualLeave = row.Annual
            }
            else { $scope.vm.OAnnualLeave = 0; $scope.vm.AnnualLeave = 0 }

            if (row.UnpaidLeavr != null && data.UnpaidLeavr != undefined && data.UnpaidLeavr != "") {
                $scope.vm.UnpaidLeave = row.UnpaidLeavr
                $scope.vm.OUnpaidLeave = row.UnpaidLeavr
            }
            else { $scope.vm.UnpaidLeave = 0; $scope.vm.OUnpaidLeave = 0 }
            if (row.SickHospitalisation != null && data.SickHospitalisation != undefined && data.SickHospitalisation != "") {
                $scope.vm.SickHospitalisation = row.SickHospitalisation
                $scope.vm.OSickHospitalisation = row.SickHospitalisation
            }
            else { $scope.vm.SickHospitalisation = 0; $scope.vm.OSickHospitalisation = 0 }
            if (row.Adoption != null && data.Adoption != undefined && data.Adoption != "") {
                $scope.vm.Adoption = row.Adoption
                $scope.vm.OAdoption = row.Adoption
            }
            else { $scope.vm.Adoption = 0; $scope.vm.OAdoption = 0 }
            if (row.Maternity != null && data.Maternity != undefined && data.Maternity != "") {
                $scope.vm.Maternity = row.Maternity
                $scope.vm.OMaternity = row.Maternity
            }
            else { $scope.vm.Maternity = 0; $scope.vm.OMaternity = 0 }
            if (row.Paternity != null && data.Paternity != undefined && data.Paternity != "") {
                $scope.vm.Paternity = row.Paternity
                $scope.vm.OPaternity = row.Paternity
            }
            else { $scope.vm.Paternity = 0; $scope.vm.OPaternity = 0 }
            if (row.ChildCare != null && data.ChildCare != undefined && data.ChildCare != "") {
                $scope.vm.ChildCare = row.ChildCare
                $scope.vm.OChildCare = row.ChildCare
            }
            else { $scope.vm.ChildCare = 0; $scope.vm.OChildCare = 0 }
            if (row.Reservist != null && data.Reservist != undefined && data.Reservist != "") {
                $scope.vm.Reservist = row.Reservist
                $scope.vm.OReservist = row.Reservist
            }
            else { $scope.vm.Reservist = 0; $scope.vm.OReservist = 0 }

            $scope.WorkWeekCode = row.WorkWeekCode
        }

        $scope.CalculateDays = function () {
            if ($scope.vm.Type != null && $scope.vm.StartDate != null && $scope.vm.EndDate != null) {
                if ($scope.WorkWeekCode === "Monday - Saturday(Half)") {
                    var flevday = 1
                    var tlevday = 1
                    var Days = 0
                    $scope.vm.StartDate.setHours(0, 0, 0, 0)
                    var Start = new Date($scope.vm.StartDate)
                    $scope.vm.EndDate.setHours(23, 59, 59, 999)
                    var End = new Date($scope.vm.EndDate)
                    var End1 = new Date($scope.vm.EndDate)
                    End1.setHours(0, 0, 0, 0)

                    if (Start.getTime() === End1.getTime()) $scope.SameDate = true
                    else $scope.SameDate = false

                    if ($scope.vm.FromLeave.includes("HalfDay")) flevday = 0.5
                    if ($scope.vm.ToLeave.includes("HalfDay")) tlevday = 0.5
                    for (var i = Start; i < End; i.setDate(i.getDate() + 1)) {
                        if (i.getTime() == $scope.vm.StartDate.getTime()) {
                            Days += flevday
                            if (i.getDay() == 6) Days -= 0.5
                            else if (i.getDay() == 0) Days -= flevday
                            else {
                                if ($scope.HolidaySelectedon.indexOf(i.getTime()) > -1) Days -= 1
                            }
                        }
                        else if (i.getTime() == End1.getTime()) {
                            Days += tlevday
                            if (i.getDay() == 6) Days -= 0.5
                            else if (i.getDay() == 0) Days -= tlevday
                            else {
                                if ($scope.HolidaySelectedon.indexOf(i.getTime()) > -1) Days -= 1
                            }
                        }
                        else {
                            if (i.getDay() == 6) Days += 0.5

                            else if (i.getDay() != 0 && $scope.HolidaySelectedon.indexOf(i.getTime()) == -1) Days += 1
                        }
                    }
                    $scope.Days = Days
                    if ($scope.vm.Type == "Annual Leave") {
                        $scope.vm.AnnualLeave = $scope.vm.OAnnualLeave - Days
                    }
                    else {
                        $scope.vm.AnnualLeave = $scope.vm.OAnnualLeave
                    }
                    if ($scope.vm.Type == "Medical Leave") {
                        $scope.vm.SickHospitalisation = $scope.vm.OSickHospitalisation - Days
                    }
                    else {
                        $scope.vm.SickHospitalisation = $scope.vm.OSickHospitalisation
                    }
                    if ($scope.vm.Type == "Hospitalization Leave") {
                        $scope.vm.Adoption = $scope.vm.OAdoption - Days
                    }
                    else {
                        $scope.vm.Adoption = $scope.vm.OAdoption
                    }
                    if ($scope.vm.Type == "Unpaid Leave") {
                        $scope.vm.UnpaidLeave = $scope.vm.OUnpaidLeave - Days
                    }
                    else {
                        $scope.vm.UnpaidLeave = $scope.vm.OUnpaidLeave
                    }
                    if ($scope.vm.Type == "Maternity Leave") {
                        $scope.vm.Maternity = $scope.vm.OMaternity - Days
                    }
                    else {
                        $scope.vm.Maternity = $scope.vm.OMaternity
                    }
                    if ($scope.vm.Type == "Paternity Leave") {
                        $scope.vm.Paternity = $scope.vm.OPaternity - Days
                    }
                    else {
                        $scope.vm.Paternity = $scope.vm.OPaternity
                    }
                    if ($scope.vm.Type == "Childcare Leave") {
                        $scope.vm.ChildCare = $scope.vm.OChildCare - Days
                    }
                    else {
                        $scope.vm.ChildCare = $scope.vm.OChildCare
                    }
                    if ($scope.vm.Type == "Reservist Leave") {
                        $scope.vm.Reservist = $scope.vm.OReservist + Days
                    }
                    else {
                        $scope.vm.Reservist = $scope.vm.OReservist
                    }
                }
                else {
                    var flevday = 1
                    var tlevday = 1
                    var Days = 0
                    $scope.vm.StartDate.setHours(0, 0, 0, 0)
                    var Start = new Date($scope.vm.StartDate)
                    $scope.vm.EndDate.setHours(23, 59, 59, 999)
                    var End = new Date($scope.vm.EndDate)
                    var End1 = new Date($scope.vm.EndDate)
                    End1.setHours(0, 0, 0, 0)

                    if (Start.getTime() === End1.getTime()) $scope.SameDate = true
                    else $scope.SameDate = false

                    if ($scope.vm.FromLeave.includes("HalfDay")) flevday = 0.5
                    if ($scope.vm.ToLeave.includes("HalfDay")) tlevday = 0.5
                    for (var i = Start; i < End; i.setDate(i.getDate() + 1)) {
                        if (i.getTime() == $scope.vm.StartDate.getTime()) {
                            Days += flevday
                            if (i.getDay() == 6) Days -= 1
                            else if (i.getDay() == 0) Days -= 1
                            else {
                                if ($scope.HolidaySelectedon.indexOf(i.getTime()) > -1) Days -= 1
                            }
                        }
                        else if (i.getTime() == End1.getTime()) {
                            Days += tlevday
                            if (i.getDay() == 6) Days -= 1
                            else if (i.getDay() == 0) Days -= 1
                            else {
                                if ($scope.HolidaySelectedon.indexOf(i.getTime()) > -1) Days -= 1
                            }
                        }
                        else {
                            if (i.getDay() == 6) Days += 0

                            else if (i.getDay() != 0 && $scope.HolidaySelectedon.indexOf(i.getTime()) == -1) Days += 1
                        }
                    }
                    $scope.Days = Days
                    if ($scope.vm.Type == "Annual Leave") {
                        $scope.vm.AnnualLeave = $scope.vm.OAnnualLeave - Days
                    }
                    else {
                        $scope.vm.AnnualLeave = $scope.vm.OAnnualLeave
                    }
                    if ($scope.vm.Type == "Medical Leave") {
                        $scope.vm.SickHospitalisation = $scope.vm.OSickHospitalisation - Days
                    }
                    else {
                        $scope.vm.SickHospitalisation = $scope.vm.OSickHospitalisation
                    }
                    if ($scope.vm.Type == "Hospitalization Leave") {
                        $scope.vm.Adoption = $scope.vm.OAdoption - Days
                    }
                    else {
                        $scope.vm.Adoption = $scope.vm.OAdoption
                    }
                    if ($scope.vm.Type == "Unpaid Leave") {
                        $scope.vm.UnpaidLeave = $scope.vm.OUnpaidLeave - Days
                    }
                    else {
                        $scope.vm.UnpaidLeave = $scope.vm.OUnpaidLeave
                    }
                    if ($scope.vm.Type == "Maternity Leave") {
                        $scope.vm.Maternity = $scope.vm.OMaternity - Days
                    }
                    else {
                        $scope.vm.Maternity = $scope.vm.OMaternity
                    }
                    if ($scope.vm.Type == "Paternity Leave") {
                        $scope.vm.Paternity = $scope.vm.OPaternity - Days
                    }
                    else {
                        $scope.vm.Paternity = $scope.vm.OPaternity
                    }
                    if ($scope.vm.Type == "Childcare Leave") {
                        $scope.vm.ChildCare = $scope.vm.OChildCare - Days
                    }
                    else {
                        $scope.vm.ChildCare = $scope.vm.OChildCare
                    }
                    if ($scope.vm.Type == "Reservist Leave") {
                        $scope.vm.Reservist = $scope.vm.OReservist + Days
                    }
                    else {
                        $scope.vm.Reservist = $scope.vm.OReservist
                    }
                }
            }
        }

        $scope.Leavegrid = true;
        $scope.LeaveUpdate = false
        $scope.Leaveform = false;
        $scope.Leaveform2 = false
        $scope.lExport = true;
        $scope.lAdd = true;
        $scope.lSearch = true;
        $scope.lView = false;
        $scope.UView = false;

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("LeaveEntitlements.xlsx",{headers:true}) FROM ?', [$scope.Leaveentitlementdatas]);
        };

        function Clearform() {
            $scope.vm.Employee = null
            $scope.vm.Type = null
            $scope.vm.StartDate = null
            $scope.vm.EndDate = null
            $scope.vm.Remarks = ""
            $scope.Days = 0
        }

        $scope.Showgrid = function () {
            $scope.Leavegrid = true;
            $scope.Leaveform = false;
            $scope.Leaveform2 = false
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lView = false;
            $scope.UView = false;
            $scope.lSearch = true;
            $scope.LeaveUpdate = false
        }

        $scope.ShowLeave = function () {
            $scope.Leavegrid = false;
            $scope.Leaveform = false;
            $scope.Leaveform2 = false
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lView = true;
            $scope.UView = false;
            $scope.lSearch = false;
            $scope.LeaveUpdate = true
        }


        $scope.cancel = function () {
            $mdDialog.cancel();
        };



        $scope.Leaveentitlementinfo = function (row) {
            $scope.vm.LeaveID = row.LeaveID
            $scope.vm.EmployeeName = row.Employeedetails[0].EmployeeName
            $scope.vm.Type = row.Type
            $scope.vm.StartDate = row.StartDate
            $scope.vm.EndDate = row.EndDate
            $scope.vm.Remarks = row.Remarks
            $scope.Leavegrid = false;
            $scope.Leaveform2 = false
            $scope.Leaveform = false;
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lView = true;
            $scope.UView = false;
            $scope.lSearch = false;
            $scope.LeaveUpdate = true
            var item = $scope.Employeedatas.filter(function (item) {
                return item.id === row.EmployeeID
            })[0]
            $scope.vm.AnnualLeave = item.Annual
            $scope.vm.UnpaidLeave = item.UnpaidLeavr
            $scope.vm.Adoption = item.Adoption
            $scope.vm.SickHospitalisation = item.SickHospitalisation
            $scope.vm.Paternity = item.Paternity
            $scope.vm.Maternity = item.Maternity
            $scope.vm.ChildCare = item.ChildCare
            $scope.vm.Reservist = item.Reservist
        }

        $scope.getEmployeeLeave = function (EmployeeId, data) {
            var item = $scope.Leaveentitlementdatas.filter(function (item) {
                return item.EmployeeID == EmployeeId
            })
            angular.forEach(item, function (val) {
                val.FromLeaveDay = "Full Day"
                if (val.FLeaveDay == "HalfDayMorning") val.FromLeaveDay = "Half day (Mor)"
                else if (val.FLeaveDay == "HalfDayAftn") val.FromLeaveDay = "Half day (Aftn)"

                val.ToLeaveDay = "Full Day"
                if (val.TLeaveDay == "HalfDayMorning") val.ToLeaveDay = "Half day (Mor)"
                else if (val.TLeaveDay == "HalfDayAftn") val.ToLeaveDay = "Half day (Aftn)"
            })
            $scope.SelectedEmp = EmployeeId
            $scope.EmpLeavedatas = item
            $scope.Leavegrid = false;
            $scope.Leaveform = false;
            $scope.Leaveform2 = false
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lView = true;
            $scope.UView = false;
            $scope.lSearch = false;
            $scope.LeaveUpdate = true

            $scope.UAnnual = data.Annual
            $scope.UUnpaidLeavr = data.UnpaidLeavr
            $scope.USickHospitalisation = data.SickHospitalisation
            $scope.UAdoption = data.Adoption
            $scope.UMaternity = data.Maternity
            $scope.UPaternity = data.Paternity
            $scope.UChildCare = data.ChildCare
            $scope.UReservist = data.Reservist

        }

        $scope.sSubmit = function () {
            if ($scope.Update == false) {
                var response = $http({
                    url: $rootScope.WebURL + "/leaveentitlement/add",
                    method: "POST",
                    data: {
                        Client_Id: Client_Id,
                        EmployeeID: $scope.vm.Employee,
                        EmployeeName: $scope.vm.EmployeeName,
                        Type: $scope.vm.Type,
                        Remarks: $scope.vm.Remarks,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        Days: $scope.Days,
                        FLeaveDay: $scope.vm.FromLeave,
                        TLeaveDay: $scope.vm.ToLeave,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Leave Added Successfully !').position('top center'));
                    RefreshGrid()
                    RefreshEmployeeGrid()
                    $scope.Showgrid()
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
            else {

            }
        }

        $scope.uploadfile = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/leaveentitlement/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Leave", FileID: $scope.vm.ContractId,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefresAttach();
                        // $scope.ShowLeave()
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefresAttach() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.ContractId },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        $scope.Adelete = function (id) {
            $scope.Did = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete this attachment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult == true) {
                    var response = $http({
                        url: $rootScope.WebURL + "/attachment/delete",
                        method: "POST",
                        data: { _id: $scope.Did, },
                    });
                    response.then(function (Leaveentitlementdata) {
                        RefresAttach()
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            })
        }


        $scope.DeleteLeav = function (id) {
            $scope.Did = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete this Leave?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult == true) {
                    var response = $http({
                        url: $rootScope.WebURL + "/leaveentitlement/delete",
                        method: "PUT",
                        data: { _id: $scope.Did, CreatedBy: $rootScope.createdby },
                    });
                    response.then(function (Leaveentitlementdata) {
                        var response = $http({
                            url: $rootScope.WebURL + "/leaveentitlement",
                            method: "POST",
                            data: { Client_Id: Client_Id },
                        });
                        response.then(function (Leaveentitlementdata) {
                            $scope.Leaveentitlementdatas = Leaveentitlementdata.data.data;
                            var item = $scope.Leaveentitlementdatas.filter(function (item) {
                                return item.EmployeeID == $scope.SelectedEmp
                            })
                            angular.forEach(item, function (val) {
                                val.FromLeaveDay = "Full Day"
                                if (val.FLeaveDay == "HalfDayMorning") val.FromLeaveDay = "Half day (Mor)"
                                else if (val.FLeaveDay == "HalfDayAftn") val.FromLeaveDay = "Half day (Aftn)"

                                val.ToLeaveDay = "Full Day"
                                if (val.TLeaveDay == "HalfDayMorning") val.ToLeaveDay = "Half day (Mor)"
                                else if (val.TLeaveDay == "HalfDayAftn") val.ToLeaveDay = "Half day (Aftn)"
                            })
                            $scope.EmpLeavedatas = item
                            $mdToast.show($mdToast.simple().textContent('Leave Deleted Successfully !').position('top center'));
                        });
                    });
                }
            })
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/calendar",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Calendardata) {
            $scope.Holidaysdatas = Calendardata.data.data;
            var item = $scope.Holidaysdatas.filter(function (item) {
                return item.EventType === 'Holiday';
            });
            $scope.HolidaySelectedon = [];
            angular.forEach(item, function (value) {
                $scope.HolidaySelectedon.push(new Date(value.StartDate).setHours(0, 0, 0, 0))
            })
        });
        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

    }
})();
(function () {
    'use strict';

    angular
 
        .module('app.human-resource.health.checkup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_health_checkup', {
            url: '/MedicalCheckup',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/health/checkup/checkup.html',
                    controller: 'CheckupController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.health.checkup')
        .controller('CheckupController', CheckupController);

    /** @ngInject */
    function CheckupController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $mdDialog, $document, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Health")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        $rootScope.LoginedUser = localStorage.getItem('UserName');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/medicalcheckup",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Medicalcheckupdata) {
                $scope.Medicalcheckupdatas = Medicalcheckupdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.Employee = item1.id;
            } catch (error) { }
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.Checkupgrid = true;
        $scope.Checkupform = false;
        $scope.cExport = true;
        $scope.cAdd = true;
        $scope.cSearch = true;
        $scope.cview = false;

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Medicalcheckup.xlsx",{headers:true}) FROM ?', [$scope.Medicalcheckupdatas]);
        };

        $scope.Add = function () {
            ClearForm();
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.Employee = item1.id;
            } catch (error) { }

            $scope.VisitDate = new Date();
            $scope.Update = false;
            $scope.Checkupgrid = false;
            $scope.Checkupform = true;
            $scope.cExport = false;
            $scope.cAdd = false;
            $scope.cSearch = false;
            $scope.cview = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Checkupgrid = true;
            $scope.Checkupform = false;
            $scope.cExport = true;
            $scope.cAdd = true;
            $scope.cSearch = true;
            $scope.cview = false;
        }

        $scope.cSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medicalcheckup/update",
                    data: {
                        _id: $scope.SID,
                        EmployeeID: $scope.Employee,
                        MedicalInstitution: $scope.MedicalInstitution,
                        MedicalTest: $scope.MedicalTest,
                        TestDate: $scope.TestDate,
                        NextTestDate: $scope.NextTestDate,
                        TestType: $scope.TestType,
                        RBCCount: $scope.RBCCount,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Medicalcheckupdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/medicalcheckup/add",
                    data: {
                        Client_Id: Client_Id,
                        EmployeeID: $scope.Employee,
                        MedicalInstitution: $scope.MedicalInstitution,
                        MedicalTest: $scope.MedicalTest,
                        TestDate: $scope.TestDate,
                        NextTestDate: $scope.NextTestDate,
                        TestType: $scope.TestType,
                        RBCCount: $scope.RBCCount,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Checkupinfo = function (CheckupId, $index) {
            $scope.SID = CheckupId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.Checkupgrid = false;
            $scope.Checkupform = true;
            $scope.cExport = false;
            $scope.cAdd = false;
            $scope.cSearch = false;
            $scope.cview = true;

            try {
                var item = $scope.Medicalcheckupdatas.filter(function (item) {
                    return item._id === CheckupId;
                })[0];
                $scope.id = item._id;
                $scope.Employee = item.EmployeeID;
                $scope.MedicalInstitution = item.MedicalInstitution;
                $scope.MedicalTest = item.MedicalTest;
                if (item.TestDate != null && item.TestDate != undefined && item.TestDate != "") {
                    $scope.TestDate = new Date(item.TestDate);
                }
                if (item.NextTestDate != null && item.NextTestDate != undefined && item.NextTestDate != "") {
                    $scope.NextTestDate = new Date(item.NextTestDate);
                }
                $scope.TestType = item.TestType;
                $scope.RBCCount = parseFloat(item.RBCCount);
                $scope.Remarks = item.Remarks;
            } catch (err) { }
        }

        $scope.Checkupdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/health/checkup/checkupdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CheckupController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Cdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/medicalcheckup/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function ClearForm() {
            $scope.Employee = '';
            $scope.MedicalInstitution = '';
            $scope.MedicalTest = '';
            $scope.TestDate = null;
            $scope.NextTestDate = null;
            $scope.TestType = '';
            $scope.RBCCount = '';
            $scope.Remarks = '';
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true

        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmLeave.leaveapproval', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmLeave_leaveapproval', {
            url: '/LeaveApproval',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmLeave/leaveapproval/leaveapproval.html',
                    controller: 'LeaveApprovalController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmLeave.leaveapproval')
        .controller('LeaveApprovalController', LeaveApprovalController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });


    function LeaveApprovalController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $mdDialog, $document, $http, $filter, Upload) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Leave Approval"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();
        RefreshCourseattendanceGrid();
        RefreshLeaveEntitlementGrid();

        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/leave/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/leave/AllDatefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
            });
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        var LeaveID = getParameterByName('ID');
        if (LeaveID != null) {
            var response = $http({
                url: $rootScope.WebURL + "/leave",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
                try {
                    var item = $scope.Leavedatas.filter(function (item) {
                        return item._id === LeaveID;
                    })[0];
                    $scope.LID = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.Employee = item.EmployeeID;
                    $scope.FromDate = new Date(item.FromDate);
                    $scope.ToDate = new Date(item.ToDate);
                    $scope.FromDayType = item.FromDayType;
                    $scope.ToDayType = item.ToDayType;
                    $scope.LeaveType = item.LeaveType;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.Reason = item.Reason;
                    if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                        $scope.EmergencyContactNo = parseFloat(item.EmergencyContactNo);
                    }
                    $scope.TotalDaysApplied = parseFloat(item.TotalDaysApplied);
                    $scope.TotalPaidLeaves = parseFloat(item.TotalPaidLeaves);
                    $scope.TotalUnPaidLeaves = parseFloat(item.TotalUnPaidLeaves);
                    $scope.LeaveTaken = item.LeaveTaken;
                    $scope.LeaveBalance = item.LeaveBalance;
                    $scope.LeaveEntitlement = item.LeaveEntitlement;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;

                    $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);
                    $scope.Division = item.Employeedetails[0].EDivision;
                    $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.FromDate);

                    if ($scope.TotalWorkedMonths != null && $scope.TotalWorkedMonths != undefined && $scope.TotalWorkedMonths != "") {
                        if ($scope.TotalWorkedMonths <= 12) {
                            $scope.CurrentYearTotalWorkedMonths = $scope.TotalWorkedMonths;
                        }
                        else if ($scope.TotalWorkedMonths > 12) {
                            if (parseFloat($scope.TotalWorkedMonths) % 12 == 0) {
                                $scope.CurrentYearTotalWorkedMonths = 12;
                            }
                            else if (parseFloat($scope.TotalWorkedMonths) % 12 != 0) {
                                $scope.CurrentYearTotalWorkedMonths = parseFloat($scope.TotalWorkedMonths) % 12;
                            }
                        }
                    }
                } catch (e) { }

                var male = [];
                angular.forEach($scope.Leavedatas, function (value1) {
                    angular.forEach($scope.Employeedatas, function (value2) {
                        $scope.CheckFromDate = new Date(value1.FromDate);
                        $scope.CheckToDate = new Date(value1.ToDate);
                        if ($scope.LID != "undefined" || $scope.LID != "" || $scope.LID != null) {
                            if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                                if (value1.Status == "New" || value1.Status == "Reviewed" || value1.Status == "Approved") {
                                    if (value1.EmployeeID == value2.id && value2.Gender == "Male" && $scope.LID != value1._id) {
                                        male.push({
                                            id: value1._id,
                                            FromDate: value1.FromDate,
                                            ToDate: value1.ToDate,
                                            EmployeeID: value2.EmployeeID,
                                            EmployeeName: value2.EmployeeName,
                                            Gender: value2.Gender,
                                            Eid: value2.id,
                                        })
                                    }
                                }
                            }
                        }
                    });
                });
                $scope.malesummary = male;
                $scope.MaleAssociate = $scope.malesummary.length;

                var female = [];
                angular.forEach($scope.Leavedatas, function (value3) {
                    angular.forEach($scope.Employeedatas, function (value4) {
                        $scope.CheckFromDate = new Date(value3.FromDate);
                        $scope.CheckToDate = new Date(value3.ToDate);
                        if ($scope.LID != "undefined" || $scope.LID != "" || $scope.LID != null) {
                            if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                                if (value3.Status == "New" || value3.Status == "Reviewed" || value3.Status == "Approved") {
                                    if (value3.EmployeeID == value4.id && value4.Gender == "Female" && $scope.LID != value3._id) {
                                        female.push({
                                            id: value3._id,
                                            FromDate: value3.FromDate,
                                            ToDate: value3.ToDate,
                                            EmployeeID: value4.EmployeeID,
                                            EmployeeName: value4.EmployeeName,
                                            Gender: value4.Gender,
                                            Eid: value4.id,
                                        })
                                    }
                                }
                            }
                        }
                    });
                });
                $scope.femalesummary = female;
                $scope.FemaleAssociate = $scope.femalesummary.length;

                var trainee = [];
                angular.forEach($scope.Courseattendancedatas, function (value5) {
                    $scope.CheckFromDate = new Date(value5.AttendanceDate);
                    $scope.CheckFromDate.setHours(0, 0, 0, 0);
                    if ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) {
                        trainee.push({
                            id: value5._id,
                            AttendanceDate: value5.AttendanceDate,
                            EmployeeName: value5.EmployeeName,
                        })
                    }
                });
                $scope.traineesummary = trainee;
                $scope.TraineeAssociate = $scope.traineesummary.length;

                $scope.Update = true;
                $scope.Leaveform = true;
                $scope.Leavegrid = false;
                $scope.lExport = false;
                $scope.lView = true;
                $scope.lAdd = false;
                $scope.lSearch = false;
                $scope.Leave = true;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
                $scope.NextApprovers = '';

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'HRM Leave Request') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'HRM Leave Request') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
            });
        }
        else {
            $scope.Leaveform = false;
            $scope.Leavegrid = true;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lSearch = true;
            $scope.lView = false;
            $scope.Leave = false;
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("LeaveRequestDetails.xlsx",{headers:true}) FROM ?', [$scope.Leavedatas]);
        };

        $scope.Showgrid = function () {
            $scope.Leavegrid = true;
            $scope.Leaveform = false;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lView = false;
            $scope.lSearch = true;
            $scope.Leave = false;
        }

        function mySplit(string, nb) {
            var array = string.split(';');
            return array[nb];
        }

        $scope.Leaveinfo = function (LeaveId, $index) {
            debugger
            $scope.IndxID = $index;
            $scope.LID = LeaveId;
            $scope.Update = true;
            $scope.Leaveform = true;
            $scope.Leavegrid = false;
            $scope.lExport = false;
            $scope.lView = true;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.Leave = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();

            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = $scope.Status;
            $scope.NextLevelAction = '';
            $scope.NextApprovers = '';

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            try {
                var item = $scope.Leavedatas.filter(function (item) {
                    return item._id === LeaveId;
                })[0];
                $scope.LID = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.FromDate = new Date(item.FromDate);
                $scope.ToDate = new Date(item.ToDate);
                $scope.FromDayType = item.FromDayType;
                $scope.ToDayType = item.ToDayType;
                $scope.LeaveType = item.LeaveType;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.Reason = item.Reason;
                if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                    $scope.EmergencyContactNo = parseFloat(item.EmergencyContactNo);
                }
                $scope.TotalDaysApplied = parseFloat(item.TotalDaysApplied);
                $scope.TotalPaidLeaves = parseFloat(item.TotalPaidLeaves);
                $scope.TotalUnPaidLeaves = parseFloat(item.TotalUnPaidLeaves);
                $scope.LeaveTaken = item.LeaveTaken;
                $scope.LeaveBalance = item.LeaveBalance;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.LeaveEntitlement = item.LeaveEntitlement;
                $scope.a1 = mySplit(item.LeaveEntitlement, 0);
                $scope.a2 = mySplit(item.LeaveEntitlement, 1);
                $scope.a3 = mySplit(item.LeaveEntitlement, 2);
                $scope.a4 = mySplit(item.LeaveEntitlement, 3);
                $scope.b1 = mySplit(item.LeaveEntitlement, 4);
                $scope.b2 = mySplit(item.LeaveEntitlement, 5);
                $scope.b3 = mySplit(item.LeaveEntitlement, 6);
                $scope.b4 = mySplit(item.LeaveEntitlement, 7);
                $scope.LeaveEntitlement1 = $scope.a1 + ";" + $scope.a2 + ";" + $scope.a3 + ";" + $scope.a4 + ";";
                $scope.LeaveEntitlement2 = $scope.b1 + ";" + $scope.b2 + ";" + $scope.b3 + ";" + $scope.b4 + ";";
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;

                $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);
                $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.FromDate);
                if ($scope.TotalWorkedMonths != null && $scope.TotalWorkedMonths != undefined && $scope.TotalWorkedMonths != "") {
                    if ($scope.TotalWorkedMonths <= 12) {
                        $scope.CurrentYearTotalWorkedMonths = $scope.TotalWorkedMonths;
                    }
                    else if ($scope.TotalWorkedMonths > 12) {
                        if (parseFloat($scope.TotalWorkedMonths) % 12 == 0) {
                            $scope.CurrentYearTotalWorkedMonths = 12;
                        }
                        else if (parseFloat($scope.TotalWorkedMonths) % 12 != 0) {
                            $scope.CurrentYearTotalWorkedMonths = parseFloat($scope.TotalWorkedMonths) % 12;
                        }
                    }
                }


            } catch (e) { }

            var male = [];
            angular.forEach($scope.Leavedatas, function (value1) {
                angular.forEach($scope.Employeedatas, function (value2) {
                    $scope.CheckFromDate = new Date(value1.FromDate);
                    $scope.CheckToDate = new Date(value1.ToDate);
                    if ($scope.LID != "undefined" || $scope.LID != "" || $scope.LID != null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value1.Status == "New" || value1.Status == "Reviewed" || value1.Status == "Approved") {
                                if (value1.EmployeeID == value2.id && value2.Gender == "Male" && $scope.LID != value1._id) {
                                    male.push({
                                        id: value1._id,
                                        FromDate: value1.FromDate,
                                        ToDate: value1.ToDate,
                                        EmployeeID: value2.EmployeeID,
                                        EmployeeName: value2.EmployeeName,
                                        Gender: value2.Gender,
                                        Eid: value2.id,
                                    })
                                }
                            }
                        }
                    }
                });
            });
            $scope.malesummary = male;
            $scope.MaleAssociate = $scope.malesummary.length;

            var female = [];
            angular.forEach($scope.Leavedatas, function (value3) {
                angular.forEach($scope.Employeedatas, function (value4) {
                    $scope.CheckFromDate = new Date(value3.FromDate);
                    $scope.CheckToDate = new Date(value3.ToDate);
                    if ($scope.LID != "undefined" || $scope.LID != "" || $scope.LID != null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value3.Status == "New" || value3.Status == "Reviewed" || value3.Status == "Approved") {
                                if (value3.EmployeeID == value4.id && value4.Gender == "Female" && $scope.LID != value3._id) {
                                    female.push({
                                        id: value3._id,
                                        FromDate: value3.FromDate,
                                        ToDate: value3.ToDate,
                                        EmployeeID: value4.EmployeeID,
                                        EmployeeName: value4.EmployeeName,
                                        Gender: value4.Gender,
                                        Eid: value4.id,
                                    })
                                }
                            }
                        }
                    }
                });
            });
            $scope.femalesummary = female;
            $scope.FemaleAssociate = $scope.femalesummary.length;

            var trainee = [];
            angular.forEach($scope.Courseattendancedatas, function (value5) {
                $scope.CheckFromDate = new Date(value5.AttendanceDate);
                $scope.CheckFromDate.setHours(0, 0, 0, 0);
                if ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) {
                    trainee.push({
                        id: value5._id,
                        AttendanceDate: value5.AttendanceDate,
                        EmployeeName: value5.EmployeeName,
                    })
                }
            });
            $scope.traineesummary = trainee;
            $scope.TraineeAssociate = $scope.traineesummary.length;

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'HRM Leave Request') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'HRM Leave Request') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "HRM Leave Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm11.$setPristine();
                $scope.basicForm11.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/incident/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Leave Request",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.workflow = function () {
            $scope.WID = $scope.LID;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    //$scope.Emails = SenderEmails;
                    //$scope.SOgroups = _.groupBy(SenderEmails, 'Email');
                    //angular.forEach($scope.SOgroups, function (value) {
                    //    var SendEmail = value[0].Email;
                    //    var response = $http({
                    //        method: "POST",
                    //        url:  $rootScope.WebURL + "/leave/email",
                    //        data: {
                    //            LeaveID: $scope.Userdata.id,
                    //            SenderEmailAddress: SendEmail,
                    //            ReferenceNo: $scope.Userdata.ReferenceNo,
                    //            UniqueID: $scope.Userdata.UniqueID,
                    //            EmployeeID: $scope.EmployeeId,
                    //            EmployeeName: $scope.EmployeeName,
                    //            FromDate: convertDate($scope.FromDate),
                    //            ToDate: convertDate($scope.ToDate),
                    //            FromDayType: $scope.FromDayType,
                    //            ToDayType: $scope.ToDayType,
                    //            LeaveType: $scope.LeaveType,
                    //            Reason: $scope.Reason,
                    //            EmergencyContactNo: $scope.EmergencyContactNo,
                    //            TotalDaysApplied: $scope.TotalDaysApplied,
                    //            TotalPaidLeaves: $scope.TotalPaidLeaves,
                    //            TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                    //            Status: $scope.Userdata.Status,
                    //            StatusID: $scope.Userdata.StatusID,
                    //            CreatedBy: $rootScope.LoginID,
                    //            CreatedDate: convertDate(new Date()),
                    //        },
                    //    });
                    //});

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.reject = function () {
            debugger
            $scope.WID = $scope.LID;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.Userdata = GList.data.data[0];
                    $scope.RejectUpdateLeaveEntitlement();
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    //try {
                    //    if (Workflowitem.NotifytoNextLevelApprover == true) {
                    //        try {
                    //            $scope.NLevel = Workflowitem.NextLevel;
                    //            var myArray1 = $scope.Workflowdatas;
                    //            var Workflowitem1 = myArray1.filter(function (item1) {
                    //                return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                    //            })[0];
                    //        } catch (err) {
                    //        }
                    //        try {
                    //            $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                    //            angular.forEach($scope.NApproversArray, function (value) {
                    //                var UserArray4 = $scope.Userdatas;
                    //                var item4 = UserArray4.filter(function (item4) {
                    //                    return item4.UserID === value;
                    //                })[0];
                    //                SenderEmails.push({ Email: item4.Email });
                    //            });
                    //        } catch (err) {
                    //        }
                    //    }
                    //} catch (err) {
                    //}

                    //$scope.Emails = SenderEmails;
                    //$scope.SOgroups = _.groupBy(SenderEmails, 'Email');
                    //angular.forEach($scope.SOgroups, function (value) {
                    //    var SendEmail = value[0].Email;
                    //    var response = $http({
                    //        method: "POST",
                    //        url:  $rootScope.WebURL + "/leave/email",
                    //        data: {
                    //            LeaveID: $scope.Userdata.id,
                    //            SenderEmailAddress: SendEmail,
                    //            ReferenceNo: $scope.Userdata.ReferenceNo,
                    //            UniqueID: $scope.Userdata.UniqueID,
                    //            EmployeeID: $scope.EmployeeId,
                    //            EmployeeName: $scope.EmployeeName,
                    //            FromDate: convertDate($scope.FromDate),
                    //            ToDate: convertDate($scope.ToDate),
                    //            FromDayType: $scope.FromDayType,
                    //            ToDayType: $scope.ToDayType,
                    //            LeaveType: $scope.LeaveType,
                    //            Reason: $scope.Reason,
                    //            EmergencyContactNo: $scope.EmergencyContactNo,
                    //            TotalDaysApplied: $scope.TotalDaysApplied,
                    //            TotalPaidLeaves: $scope.TotalPaidLeaves,
                    //            TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                    //            Status: $scope.Userdata.Status,
                    //            StatusID: $scope.Userdata.StatusID,
                    //            CreatedBy: $rootScope.LoginID,
                    //            CreatedDate: convertDate(new Date()),
                    //        },
                    //    });
                    //});

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];
                    RefreshLeaveEntitlementGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.RejectUpdateLeaveEntitlement = function () {
            debugger
            var CurrentYear = new Date().getFullYear();

            try {
                $scope.EmpID = $scope.Employee;
                var item = $scope.Leaveentitlementdatas.filter(function (item) {
                    return item.EmployeeID === $scope.EmpID;
                })[0];
                $scope.LEID = item._id;
                $scope.AnnualLeaveEntitlement = item.AnnualLeaveEntitlement;
                $scope.Earned = item.Earned;
                $scope.Annual = item.AnnualLeave;
                $scope.AdoptionLeave = item.AdoptionLeave;
                $scope.ChildCareLeave = item.ChildCareLeave;
                $scope.CompassionateLeave = item.CompassionateLeave;
                $scope.MaternityLeave = item.MaternityLeave;
                $scope.PaternityLeave = item.PaternityLeave;
                $scope.SharedParentalLeave = item.SharedParentalLeave;
                $scope.SickLeave = item.SickLeave;
                $scope.LeaveEntitlementYear = item.LeaveEntitlementYear;
                $scope.LeaveEntitlementDetails = item.LeaveentitlementDetails;
            } catch (err) { }

            try {
                var LEitem = $scope.LeaveEntitlementDetails.filter(function (LEitem) {
                    return (parseFloat(LEitem.LeaveEntitlementYear) === parseFloat($scope.LeaveEntitlementYear));
                })[0];
                debugger
                $scope.ULEAnnualLeaveEntitlement = LEitem.AnnualLeaveEntitlement;
                $scope.ULEEarned = LEitem.Earned;
                $scope.ULEAnnual = LEitem.AnnualLeave;
                $scope.ULEAdoption = LEitem.AdoptionLeave;
                $scope.ULEChildCare = LEitem.ChildCareLeave;
                $scope.ULECompassionate = LEitem.CompassionateLeave;
                $scope.ULEMaternity = LEitem.MaternityLeave;
                $scope.ULEPaternity = LEitem.PaternityLeave;
                $scope.ULESharedParentalLeave = LEitem.SharedParentalLeave;
                $scope.ULESickLeave = LEitem.SickLeave;
            } catch (err) { }

            try {
                if ($scope.LeaveType == "Annual Leave") {
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        if ($scope.ULEAnnualLeaveEntitlement == $scope.AnnualLeaveEntitlement) {
                            $scope.UpdateEarned = (parseFloat($scope.Earned) + parseFloat($scope.TotalPaidLeaves));
                            if ($scope.UpdateEarned < 0 || $scope.UpdateEarned == "" || $scope.UpdateEarned == null || $scope.UpdateEarned == undefined) {
                                $scope.UpdateEarned = 0;
                            }
                            $scope.UpdateAnnualLeaveEntitlement = $scope.AnnualLeaveEntitlement;
                            if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                $scope.UpdateAnnualLeaveEntitlement = 0;
                            }
                        }
                        else if ($scope.ULEAnnualLeaveEntitlement > $scope.AnnualLeaveEntitlement) {
                            $scope.getTotalLeave = $scope.TotalPaidLeaves;
                            $scope.CHKAnnualLeaveEntitlement = (parseFloat($scope.AnnualLeaveEntitlement) + parseFloat($scope.getTotalLeave));

                            if ($scope.CHKAnnualLeaveEntitlement == $scope.ULEAnnualLeaveEntitlement) {
                                $scope.UpdateEarned = 0;
                                $scope.UpdateAnnualLeaveEntitlement = $scope.CHKAnnualLeaveEntitlement;
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            else if ($scope.CHKAnnualLeaveEntitlement > $scope.ULEAnnualLeaveEntitlement) {
                                $scope.BUpdateEarned = (parseFloat($scope.CHKAnnualLeaveEntitlement) - parseFloat($scope.ULEAnnualLeaveEntitlement));
                                $scope.UpdateEarned = (parseFloat($scope.Earned) + parseFloat($scope.BUpdateEarned));
                                if ($scope.UpdateEarned < 0 || $scope.UpdateEarned == "" || $scope.UpdateEarned == null || $scope.UpdateEarned == undefined) {
                                    $scope.UpdateEarned = 0;
                                }
                                $scope.UpdateAnnualLeaveEntitlement = (parseFloat($scope.CHKAnnualLeaveEntitlement) - parseFloat($scope.BUpdateEarned));
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            else if ($scope.CHKAnnualLeaveEntitlement < $scope.ULEAnnualLeaveEntitlement) {
                                $scope.UpdateEarned = 0;
                                $scope.UpdateAnnualLeaveEntitlement = $scope.CHKAnnualLeaveEntitlement;
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                        }
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateAnnual",
                            data: {
                                _id: $scope.LEID,
                                AnnualLeaveEntitlement: $scope.UpdateAnnualLeaveEntitlement,
                                Earned: $scope.UpdateEarned,
                                AnnualLeave: $scope.AnnualLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.UpdateAdoptionLeave = (parseFloat($scope.AdoptionLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateAdoptionLeave < 0 || $scope.UpdateAdoptionLeave == "" || $scope.UpdateAdoptionLeave == null || $scope.UpdateAdoptionLeave == undefined) {
                        $scope.UpdateAdoptionLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateAdoption",
                            data: {
                                _id: $scope.LEID,
                                AdoptionLeave: $scope.UpdateAdoptionLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.UpdateChildCareLeave = (parseFloat($scope.ChildCareLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateChildCareLeave < 0 || $scope.UpdateChildCareLeave == "" || $scope.UpdateChildCareLeave == null || $scope.UpdateChildCareLeave == undefined) {
                        $scope.UpdateChildCareLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateChildCare",
                            data: {
                                _id: $scope.LEID,
                                ChildCareLeave: $scope.UpdateChildCareLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.UpdateCompassionateLeave = (parseFloat($scope.CompassionateLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateCompassionateLeave < 0 || $scope.UpdateCompassionateLeave == "" || $scope.UpdateCompassionateLeave == null || $scope.UpdateCompassionateLeave == undefined) {
                        $scope.UpdateCompassionateLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateCompassionate",
                            data: {
                                _id: $scope.LEID,
                                CompassionateLeave: $scope.UpdateCompassionateLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.UpdateMaternityLeave = (parseFloat($scope.MaternityLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateMaternityLeave < 0 || $scope.UpdateMaternityLeave == "" || $scope.UpdateMaternityLeave == null || $scope.UpdateMaternityLeave == undefined) {
                        $scope.UpdateMaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateMaternity",
                            data: {
                                _id: $scope.LEID,
                                MaternityLeave: $scope.UpdateMaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.UpdatePaternityLeave = (parseFloat($scope.PaternityLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdatePaternityLeave < 0 || $scope.UpdatePaternityLeave == "" || $scope.UpdatePaternityLeave == null || $scope.UpdatePaternityLeave == undefined) {
                        $scope.UpdatePaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updatePaternity",
                            data: {
                                _id: $scope.LEID,
                                PaternityLeave: $scope.UpdatePaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.UpdateSharedParentalLeave = (parseFloat($scope.SharedParentalLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSharedParentalLeave < 0 || $scope.UpdateSharedParentalLeave == "" || $scope.UpdateSharedParentalLeave == null || $scope.UpdateSharedParentalLeave == undefined) {
                        $scope.UpdateSharedParentalLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSharedParental",
                            data: {
                                _id: $scope.LEID,
                                SharedParentalLeave: $scope.UpdateSharedParentalLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.UpdateSickLeave = (parseFloat($scope.SickLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSickLeave < 0 || $scope.UpdateSickLeave == "" || $scope.UpdateSickLeave == null || $scope.UpdateSickLeave == undefined) {
                        $scope.UpdateSickLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSick",
                            data: {
                                _id: $scope.LEID,
                                SickLeave: $scope.UpdateSickLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Off In-Lieu") { }
            } catch (e) { }
        }

        function momentDiff(a, b) {
            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');
            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshCourseattendanceGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/courseattendance",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (courseattendancedata) {
                $scope.Courseattendancedatas = courseattendancedata.data.data;
            });
        }

        function RefreshLeaveEntitlementGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/leaveentitlement",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leaveentitlementdata) {
                $scope.Leaveentitlementdatas = Leaveentitlementdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Leave.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }
})();




(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.qualification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_qualification', {
            url: '/Qualifications',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/qualification/qualification.html',
                    controller: 'QualificationController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/qualification');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.qualification')
        .controller('QualificationController', QualificationController);

    /** @ngInject */
    function QualificationController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Qualification & Skills"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshEducation();
        RefreshSkills();
        RefreshLicense();
        RefreshLanguage();
        RefreshMembership();

        $scope.Update = false;
        $scope.model = {};

        $scope.eduExport = true;
        $scope.skillExport = false;
        $scope.licenseExport = false;
        $scope.languageExport = false;
        $scope.membershipExport = false;

        $scope.Education = function () {
            $scope.eduExport = true;
            $scope.skillExport = false;
            $scope.licenseExport = false;
            $scope.languageExport = false;
            $scope.membershipExport = false;
            $scope.model.Search = '';
            RefreshEducation();
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Educationdatas.xlsx",{headers:true}) FROM ?', [$scope.Educationdatas]);
        };

        $scope.Skills = function () {
            $scope.eduExport = false;
            $scope.skillExport = true;
            $scope.licenseExport = false;
            $scope.languageExport = false;
            $scope.membershipExport = false;
            $scope.model.Search = '';
            RefreshSkills();
        }
        $scope.skExport = function () {
            alasql('SELECT * INTO XLSX("Skillsdatas.xlsx",{headers:true}) FROM ?', [$scope.Skillsdatas]);
        };

        $scope.License = function () {
            $scope.eduExport = false;
            $scope.skillExport = false;
            $scope.licenseExport = true;
            $scope.languageExport = false;
            $scope.membershipExport = false;
            $scope.model.Search = '';
            RefreshLicense();
        }
        $scope.liExport = function () {
            alasql('SELECT * INTO XLSX("Licensedatas.xlsx",{headers:true}) FROM ?', [$scope.Licensedatas]);
        };

        $scope.Language = function () {
            $scope.eduExport = false;
            $scope.skillExport = false;
            $scope.licenseExport = false;
            $scope.languageExport = true;
            $scope.membershipExport = false;
            $scope.model.Search = '';
            RefreshLanguage();
        }
        $scope.laExport = function () {
            alasql('SELECT * INTO XLSX("Languagedatas.xlsx",{headers:true}) FROM ?', [$scope.Languagedatas]);
        };

        $scope.Membership = function () {
            $scope.eduExport = false;
            $scope.skillExport = false;
            $scope.licenseExport = false;
            $scope.languageExport = false;
            $scope.membershipExport = true;
            $scope.model.Search = '';
            RefreshMembership();
        }
        $scope.mExport = function () {
            alasql('SELECT * INTO XLSX("Membershipdatas.xlsx",{headers:true}) FROM ?', [$scope.Membershipdatas]);
        };


        $scope.saveEducation = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/education/update",
                    data: {
                        _id: $scope.SID, EducationLevel: $scope.model.EducationLevel, EducationName: $scope.model.EducationName, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearEducation();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Educationdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshEducation();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/education/add",
                    data: {
                        Client_Id: Client_Id,
                        EducationLevel: $scope.model.EducationLevel, EducationName: $scope.model.EducationName, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearEducation();
                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEducation();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Educationinfo = function (EducationId, $index) {

            $scope.IndxID = $index;
            $scope.SID = EducationId;
            $scope.Update = true;
            $scope.EducationinfoId = EducationId;
            try {
                var EducationArray = $scope.Educationdatas;
                var item = EducationArray.filter(function (item) {
                    return item.id === EducationId;
                })[0];
                $scope.id = item.id;
                $scope.model.EducationLevel = item.EducationLevel;
                $scope.model.EducationName = item.EducationName;
            } catch (err) { }

            //var info = $scope.Educationdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == EducationId) {
            //        $scope.model.EducationLevel = info[i].EducationLevel;
            //        $scope.model.EducationName = info[i].EducationName;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/education")
        //   .then(function (Educationdata) {
        //       $scope.Educationdatas = Educationdata.data.data;
        //   });

        function RefreshEducation() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/education",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Educationdata) {
                $scope.Educationdatas = Educationdata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/education")
            //.then(function (Educationdata) {
            //    $scope.Educationdatas = Educationdata.data.data;
            //});

            $scope.Update = false;
        }

        function ClearEducation() {
            $scope.model.EducationLevel = '';
            $scope.model.EducationName = '';
            $scope.qualificationform1.$setPristine();
            $scope.qualificationform1.$setUntouched();
        }

        $scope.cancelEducation = function () {
            $scope.Update = false;
            ClearEducation();
        }

        $scope.saveSkills = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/skill/update",
                    data: {
                        _id: $scope.SID, Name: $scope.model.Name, Description: $scope.model.Description, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearSkills();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Skillsdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshSkills();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/skill/add",
                    data: {
                        Client_Id: Client_Id,
                        Name: $scope.model.Name, Description: $scope.model.Description, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearSkills();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshSkills();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Skillsinfo = function (SkillsId, $index) {

            $scope.IndxID = $index;
            $scope.SID = SkillsId;
            $scope.Update = true;
            $scope.SkillsinfoId = SkillsId;
            try {
                var SkillArray = $scope.Skillsdatas;
                var item = SkillArray.filter(function (item) {
                    return item.id === SkillsId;
                })[0];
                $scope.id = item.id;
                $scope.model.Name = item.Name;
                $scope.model.Description = item.Description;
            } catch (err) { }

            //var info = $scope.Skillsdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == SkillsId) {
            //        $scope.model.Name = info[i].Name;
            //        $scope.model.Description = info[i].Description;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/skill")
        //   .then(function (Skillsdata) {
        //       $scope.Skillsdatas = Skillsdata.data.data;
        //   });

        function RefreshSkills() {
            var response = $http({
                url: $rootScope.WebURL + "/skill",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Skillsdata) {
                $scope.Skillsdatas = Skillsdata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/skill")
            //.then(function (Skillsdata) {
            //    $scope.Skillsdatas = Skillsdata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearSkills() {
            $scope.model.Name = '';
            $scope.model.Description = '';
            $scope.qualificationform2.$setPristine();
            $scope.qualificationform2.$setUntouched();
        }

        $scope.cancelSkills = function () {
            $scope.Update = false;
            ClearSkills();
        }

        $scope.saveLicense = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/license/update",
                    data: {
                        _id: $scope.SID, Licenses: $scope.model.Licenses, AgencyName: $scope.model.AgencyName, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearLicense();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Licensedatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshLicense();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/license/add",
                    data: {
                        Client_Id: Client_Id,
                        Licenses: $scope.model.Licenses, AgencyName: $scope.model.AgencyName, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearLicense();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshLicense();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Licenseinfo = function (LicenseId, $index) {

            $scope.IndxID = $index;
            $scope.SID = LicenseId;
            $scope.Update = true;
            $scope.LicenseinfoId = LicenseId;
            try {
                var LicenseArray = $scope.Licensedatas;
                var item = LicenseArray.filter(function (item) {
                    return item.id === LicenseId;
                })[0];
                $scope.id = item.id;
                $scope.model.Licenses = item.Licenses;
                $scope.model.AgencyName = item.AgencyName;
            } catch (err) { }
            //var info = $scope.Licensedatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == LicenseId) {
            //        $scope.model.Licenses = info[i].Licenses;
            //        $scope.model.AgencyName = info[i].AgencyName;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/license")
        //   .then(function (Licensedata) {
        //       $scope.Licensedatas = Licensedata.data.data;
        //   });

        function RefreshLicense() {
            var response = $http({
                url: $rootScope.WebURL + "/license",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Licensedata) {
                $scope.Licensedatas = Licensedata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/license")
            //.then(function (Licensedata) {
            //    $scope.Licensedatas = Licensedata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearLicense() {
            $scope.model.Licenses = '';
            $scope.model.AgencyName = '';
            $scope.qualificationform3.$setPristine();
            $scope.qualificationform3.$setUntouched();
        }

        $scope.cancelLicense = function () {
            $scope.Update = false;
            ClearLicense();
        }

        $scope.saveLanguage = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/language/update",
                    data: {
                        _id: $scope.SID, LanguageName: $scope.model.LanguageName, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearLanguage();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Languagedatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshLanguage();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/language/add",
                    data: {
                        Client_Id: Client_Id,
                        LanguageName: $scope.model.LanguageName, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearLanguage();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshLanguage();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Languageinfo = function (LanguageId, $index) {

            $scope.IndxID = $index;
            $scope.SID = LanguageId;
            $scope.Update = true;
            $scope.LanguageinfoId = LanguageId;
            try {
                var LanguageArray = $scope.Languagedatas;
                var item = LanguageArray.filter(function (item) {
                    return item.id === LanguageId;
                })[0];
                $scope.id = item.id;
                $scope.model.LanguageName = item.LanguageName;
            } catch (err) { }

            //var info = $scope.Languagedatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == LanguageId) {
            //        $scope.model.LanguageName = info[i].LanguageName;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/language")
        //   .then(function (Languagedata) {
        //       $scope.Languagedatas = Languagedata.data.data;
        //   });

        function RefreshLanguage() {
            var response = $http({
                url: $rootScope.WebURL + "/language",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Languagedata) {
                $scope.Languagedatas = Languagedata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/language")
            //.then(function (Languagedata) {
            //    $scope.Languagedatas = Languagedata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearLanguage() {
            $scope.model.LanguageName = '';
            $scope.qualificationform4.$setPristine();
            $scope.qualificationform4.$setUntouched();
        }

        $scope.cancelLanguage = function () {
            $scope.Update = false;
            ClearLanguage();
        }

        $scope.saveMembership = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/membership/update",
                    data: {
                        _id: $scope.SID, MembershipName: $scope.model.MembershipName, Association: $scope.model.Association, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearMembership();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Membershipdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshMembership();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/membership/add",
                    data: {
                        Client_Id: Client_Id,
                        MembershipName: $scope.model.MembershipName, Association: $scope.model.Association, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearMembership();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMembership();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Membershipinfo = function (MembershipId, $index) {

            $scope.IndxID = $index;
            $scope.SID = MembershipId;
            $scope.Update = true;
            $scope.MembershipinfoId = MembershipId;
            try {
                var MembershipArray = $scope.Membershipdatas;
                var item = MembershipArray.filter(function (item) {
                    return item.id === MembershipId;
                })[0];
                $scope.id = item.id;
                $scope.model.MembershipName = item.MembershipName;
                $scope.model.Association = item.Association;
            } catch (err) { }

            //var info = $scope.Membershipdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == MembershipId) {
            //        $scope.model.MembershipName = info[i].MembershipName;
            //        $scope.model.Association = info[i].Association;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/membership")
        //   .then(function (Membershipdata) {
        //       $scope.Membershipdatas = Membershipdata.data.data;
        //   });

        function RefreshMembership() {
            var response = $http({
                url: $rootScope.WebURL + "/membership",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Membershipdata) {
                $scope.Membershipdatas = Membershipdata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/membership")
            //.then(function (Membershipdata) {
            //    $scope.Membershipdatas = Membershipdata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearMembership() {
            $scope.model.MembershipName = '';
            $scope.model.Association = '';
            $scope.qualificationform5.$setPristine();
            $scope.qualificationform5.$setUntouched();
        }

        $scope.cancelMembership = function () {
            $scope.Update = false;
            ClearMembership();
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };



    }

})();
(function () {
    'use strict';

    angular
 
        .module('app.human-resource.HcmAdmin.workweek', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_workweek', {
            url: '/WorkWeekSettings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/workweek/workweek.html',
                    controller: 'WorkweekController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/workweek');
    }

})();

 
(function () {
    'use strict';

    angular

        .module('app.human-resource.HcmAdmin.workweek')
        .controller('WorkweekController', WorkweekController);

    /** @ngInject */
    function WorkweekController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $mdDialog, $document, $http) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Work Week Settings"
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshGrid();

        $scope.Workweekform = false;
        $scope.Workweekgrid = true;
        $scope.lExport = true;
        $scope.lAdd = true;
        $scope.lSearch = true;
        $scope.lView = false;

        $scope.Export = function () {
            alasql('SELECT WorkWeekCode,WorkWeekDescription,TotalWorkingHours,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday,SaturdayOff  INTO XLSX("Workweekdatas.xlsx",{headers:true}) FROM ?', [$scope.Workweekdatas]);
        };

        $scope.Add = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Workweekform = true;
            $scope.Workweekgrid = false;
            $scope.lExport = false;
            $scope.lView = true;
            $scope.lAdd = false;
            $scope.lSearch = false;

            $scope.Monday = 8;
            $scope.Tuesday = 8;
            $scope.Wednesday = 8;
            $scope.Thursday = 8;
            $scope.Friday = 8;
            $scope.Saturday = 0;
            $scope.Sunday = 0;
            $scope.SaturdayOff = "NA";

            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Workweekgrid = true;
            $scope.Workweekform = false;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lView = false;
            $scope.lSearch = true;
        }

        $scope.saveWorkweek = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/workweek/update",
                    data: {
                        _id: $scope.SID,
                        WorkWeekCode: $scope.WorkWeekCode,
                        WorkWeekDescription: $scope.WorkWeekDescription,
                        TotalWorkingHours: $scope.TotalWorkingHours,
                        Monday: $scope.Monday,
                        Tuesday: $scope.Tuesday,
                        Wednesday: $scope.Wednesday,
                        Thursday: $scope.Thursday,
                        Friday: $scope.Friday,
                        Saturday: $scope.Saturday,
                        Sunday: $scope.Sunday,
                        SaturdayOff: $scope.SaturdayOff,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                //ClearForm();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Workweekdatas[$scope.IndexID] = GList.data.data;
                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/workweek/add",
                    data: {
                        Client_Id: Client_Id,
                        WorkWeekCode: $scope.WorkWeekCode,
                        WorkWeekDescription: $scope.WorkWeekDescription,
                        TotalWorkingHours: $scope.TotalWorkingHours,
                        Monday: $scope.Monday,
                        Tuesday: $scope.Tuesday,
                        Wednesday: $scope.Wednesday,
                        Thursday: $scope.Thursday,
                        Friday: $scope.Friday,
                        Saturday: $scope.Saturday,
                        Sunday: $scope.Sunday,
                        SaturdayOff: $scope.SaturdayOff,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                //ClearForm();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Workweekinfo = function (WorkweekId, $index) {

            $scope.SID = WorkweekId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.Workweekform = true;
            $scope.Workweekgrid = false;
            $scope.lExport = false;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.lView = true;

            $scope.WorkweekinfoId = WorkweekId;
            try {
                var MedicalformArray = $scope.Workweekdatas;
                var item = MedicalformArray.filter(function (item) {
                    return item.id === WorkweekId;
                })[0];
                $scope.id = item.id;
                $scope.WorkWeekCode = item.WorkWeekCode;
                $scope.WorkWeekDescription = item.WorkWeekDescription;
                $scope.TotalWorkingHours = parseInt(item.TotalWorkingHours);
                $scope.Monday = parseInt(item.Monday);
                $scope.Tuesday = parseInt(item.Tuesday);
                $scope.Wednesday = parseInt(item.Wednesday);
                $scope.Thursday = parseInt(item.Thursday);
                $scope.Friday = parseInt(item.Friday);
                $scope.Saturday = parseInt(item.Saturday);
                $scope.Sunday = parseInt(item.Sunday);
                $scope.SaturdayOff = item.SaturdayOff;
            } catch (err) { }

            //var info = $scope.Workweekdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == WorkweekId) {
            //        $scope.WorkWeekCode = info[i].WorkWeekCode;
            //        $scope.WorkWeekDescription = info[i].WorkWeekDescription;
            //        $scope.TotalWorkingHours = parseInt(info[i].TotalWorkingHours);
            //        $scope.Monday = parseInt(info[i].Monday);
            //        $scope.Tuesday = parseInt(info[i].Tuesday);
            //        $scope.Wednesday = parseInt(info[i].Wednesday);
            //        $scope.Thursday = parseInt(info[i].Thursday);
            //        $scope.Friday = parseInt(info[i].Friday);
            //        $scope.Saturday = parseInt(info[i].Saturday);
            //        $scope.Sunday = parseInt(info[i].Sunday);
            //        $scope.SaturdayOff = info[i].SaturdayOff;
            //    }
            //}
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/workweek",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workweekdata) {
                $scope.Workweekdatas = Workweekdata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/workweek")
            //.then(function (Workweekdata) {
            //    $scope.Workweekdatas = Workweekdata.data.data;
            //});
        }

        function ClearForm() {
            $scope.WorkWeekCode = '';
            $scope.WorkWeekDescription = '';
            $scope.TotalWorkingHours = '';
            $scope.Monday = '';
            $scope.Tuesday = '';
            $scope.Wednesday = '';
            $scope.Thursday = '';
            $scope.Friday = '';
            $scope.Saturday = '';
            $scope.Sunday = '';
            $scope.SaturdayOff = '';
        }

        //$http.get( $rootScope.WebURL + "/workweek")
        //   .then(function (Workweekdata) {
        //       $scope.Workweekdatas = Workweekdata.data.data;
        //   });

        //function fetchData(WorkweekId) {
        //    $scope.WorkweekinfoId = WorkweekId;
        //    var info = $scope.Workweekdatas
        //    for (var i = 0; i < info.length; i++) {
        //        if (info[i].id == WorkweekId) {
        //            $scope.WorkWeekCode = info[i].WorkWeekCode;
        //            $scope.WorkWeekDescription = info[i].WorkWeekDescription;
        //            $scope.TotalWorkingHours = info[i].TotalWorkingHours;
        //            $scope.Monday = info[i].Monday;
        //            $scope.Tuesday = info[i].Tuesday;
        //            $scope.Wednesday = info[i].Wednesday;
        //            $scope.Thursday = info[i].Thursday;
        //            $scope.Friday = info[i].Friday;
        //            $scope.Saturday = info[i].Saturday;
        //            $scope.Sunday = info[i].Sunday;
        //            $scope.SaturdayOff = info[i].SaturdayOff;
        //        }
        //    }
        //}

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.organization', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_organization', {
            url: '/OrganizationSetup',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/organization/organization.html',
                    controller: 'organizationController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/organization');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.organization')
        .controller('organizationController', organizationController);

    function organizationController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Organization Setup"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshOrganization();
        RefreshCostCentre();
        RefreshDivision();
        RefreshBank();
        RefreshOrganizationChartGrid();

        $scope.orgExport = true;
        $scope.costExport = false;
        $scope.divisionExport = false;
        $scope.chartExport = false;
        $scope.bankExport = false;
        $scope.Update = false;
        $scope.model = {};


        $scope.loadFile = function (files) {
            $scope.$apply(function () {
                $scope.selectedFile = files[0];
                $scope.handleFile();
            })
        }
        $scope.handleFile = function () {
            var file = $scope.selectedFile;
            if (file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var data = e.target.result;
                    var workbook = XLSX.read(data, { type: 'binary' });
                    var first_sheet_name = workbook.SheetNames[0];
                    var dataObjects = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name]);
                    //console.log(excelData);   
                    if (dataObjects.length > 0) {
                        $scope.save(dataObjects, first_sheet_name);
                    } else {
                        $scope.message = "Error : Something Wrong !";
                        showDialog($scope.Event);
                    }
                }
                reader.onerror = function (ex) {
                }
                reader.readAsBinaryString(file);
            }
        }
        $scope.save = function (dataObjects) {
            angular.forEach(dataObjects, function (value) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/country/add",
                    data: {
                        Client_Id: Client_Id,
                        CountryCode: value.CountryCode, CountryName: value.CountryName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
            });
        }


        $scope.Structure = function () {
            $scope.orgExport = true;
            $scope.costExport = false;
            $scope.divisionExport = false;
            $scope.chartExport = false;
            $scope.bankExport = false;
            $scope.model.Search = '';
            RefreshOrganization();
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Organizationdatas.xlsx",{headers:true}) FROM ?', [$scope.Organizationdatas]);
        };

        $scope.CostCentre = function () {
            $scope.orgExport = false;
            $scope.costExport = true;
            $scope.divisionExport = false;
            $scope.chartExport = false;
            $scope.bankExport = false;
            $scope.model.Search = '';
            RefreshCostCentre();
        }
        $scope.ccExport = function () {
            alasql('SELECT * INTO XLSX("CostCentredatas.xlsx",{headers:true}) FROM ?', [$scope.CostCentredatas]);
        };

        $scope.Division = function () {
            $scope.orgExport = false;
            $scope.costExport = false;
            $scope.divisionExport = true;
            $scope.chartExport = false;
            $scope.bankExport = false;
            $scope.nationExport = false;
            $scope.countryExport = false;
            $scope.model.Search = '';
            RefreshDivision();
        }
        $scope.dExport = function () {
            alasql('SELECT * INTO XLSX("Divisiondatas.xlsx",{headers:true}) FROM ?', [$scope.Divisiondatas]);
        };
        $scope.Bank = function () {
            $scope.orgExport = false;
            $scope.costExport = false;
            $scope.divisionExport = false;
            $scope.chartExport = false;
            $scope.bankExport = true;
            $scope.nationExport = false;
            $scope.countryExport = false;
            $scope.model.Search = '';
            RefreshBank();
        }
        $scope.bExport = function () {
            alasql('SELECT * INTO XLSX("Bankdatas.xlsx",{headers:true}) FROM ?', [$scope.Bankdatas]);
        };
        $scope.Chart = function () {
            $scope.orgExport = false;
            $scope.costExport = false;
            $scope.divisionExport = false;
            $scope.chartExport = true;
            $scope.bankExport = false;
            $scope.nationExport = false;
            $scope.countryExport = false;
            $scope.model.Search = '';
            RefreshOrganizationChartGrid();
        }
        $scope.chExport = function () {
            alasql('SELECT * INTO XLSX("Chartdatas.xlsx",{headers:true}) FROM ?', [$scope.Divisiondatas]);
        };
        $scope.Nationality = function () {
            $scope.orgExport = false;
            $scope.costExport = false;
            $scope.divisionExport = false;
            $scope.chartExport = false;
            $scope.bankExport = false;
            $scope.nationExport = true;
            $scope.model.Search = '';
        }
        $scope.nExport = function () {
            alasql('SELECT * INTO XLSX("Nationalitydatas.xlsx",{headers:true}) FROM ?', [$scope.Nationalitydatas]);
        };
        $scope.Country = function () {
            $scope.orgExport = false;
            $scope.costExport = false;
            $scope.divisionExport = false;
            $scope.chartExport = false;
            $scope.bankExport = false;
            $scope.nationExport = false;
            $scope.countryExport = true;
            $scope.model.Search = '';
        }
        $scope.cExport = function () {
            alasql('SELECT * INTO XLSX("Countrydatas.xlsx",{headers:true}) FROM ?', [$scope.Countrydatas]);
        };


        $scope.saveOrganization = function () {

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/organization/update",
                    data: {
                        _id: $scope.SID, BusinessUnitName: $scope.model.BusinessUnitName, BusinessUnitCode: $scope.model.BusinessUnitCode,
                        BusinessUnitLocation: $scope.model.BusinessUnitLocation, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearOrganization();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Organizationdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshOrganization();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/organization/add",
                    data: {
                        Client_Id: Client_Id,
                        BusinessUnitName: $scope.model.BusinessUnitName, BusinessUnitCode: $scope.model.BusinessUnitCode,
                        BusinessUnitLocation: $scope.model.BusinessUnitLocation, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearOrganization();
                response.then(function (GList) {
                    RefreshOrganization();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Organizationinfo = function (OrganizationId, $index) {

            $scope.SID = OrganizationId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.OrganizationinfoId = OrganizationId;
            try {
                var OrganizationArray = $scope.Organizationdatas;
                var item = OrganizationArray.filter(function (item) {
                    return item.id === OrganizationId;
                })[0];
                $scope.id = item.id;
                $scope.model.BusinessUnitName = item.BusinessUnitName;
                $scope.model.BusinessUnitCode = item.BusinessUnitCode;
                $scope.model.BusinessUnitLocation = item.BusinessUnitLocation;
            } catch (err) { }

            //var info = $scope.Organizationdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == OrganizationId) {
            //        $scope.model.BusinessUnitName = info[i].BusinessUnitName;
            //        $scope.model.BusinessUnitCode = info[i].BusinessUnitCode;
            //        $scope.model.BusinessUnitLocation = info[i].BusinessUnitLocation;
            //    }
            //}
        }


        function RefreshOrganization() {
            var response = $http({
                url: $rootScope.WebURL + "/organization",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Organizationdata) {
                $scope.Organizationdatas = Organizationdata.data.data;
            });

            //$http.get( $rootScope.WebURL + "/organization")
            //.then(function (Organizationdata) {

            //    $scope.Organizationdatas = Organizationdata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearOrganization() {
            $scope.model.BusinessUnitName = '';
            $scope.model.BusinessUnitCode = '';
            $scope.model.BusinessUnitLocation = '';
            $scope.organizationform1.$setPristine();
            $scope.organizationform1.$setUntouched();
        }

        $scope.cancelOrganization = function () {
            $scope.Update = false;
            ClearOrganization();
        }

        $scope.saveCostCentre = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/costcentre/update",
                    data: {
                        _id: $scope.SID, CostCentreName: $scope.model.CostCentreName, CostCentreCode: $scope.model.CostCentreCode, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearCostCentre();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.CostCentredatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshCostCentre();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/costcentre/add",
                    data: {
                        Client_Id: Client_Id, CostCentreName: $scope.model.CostCentreName, CostCentreCode: $scope.model.CostCentreCode, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearCostCentre();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshCostCentre();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.CostCentreinfo = function (CostCentreId, $index) {

            $scope.SID = CostCentreId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.CostCentreinfoId = CostCentreId;
            try {
                var CostCentreArray = $scope.CostCentredatas;
                var item = CostCentreArray.filter(function (item) {
                    return item.id === CostCentreId;
                })[0];
                $scope.id = item.id;
                $scope.model.CostCentreName = item.CostCentreName;
                $scope.model.CostCentreCode = item.CostCentreCode;
            } catch (err) { }

            //var info = $scope.CostCentredatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == CostCentreId) {
            //        $scope.model.CostCentreName = info[i].CostCentreName;
            //        $scope.model.CostCentreCode = info[i].CostCentreCode;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/costcentre")
        //   .then(function (CostCentredata) {
        //       $scope.CostCentredatas = CostCentredata.data.data;
        //   });

        function RefreshCostCentre() {
            var response = $http({
                url: $rootScope.WebURL + "/costcentre",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CostCentredata) {
                $scope.CostCentredatas = CostCentredata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/costcentre")
            //.then(function (CostCentredata) {
            //    $scope.CostCentredatas = CostCentredata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearCostCentre() {
            $scope.model.CostCentreName = '';
            $scope.model.CostCentreCode = '';
            $scope.organizationform2.$setPristine();
            $scope.organizationform2.$setUntouched();
        }

        $scope.cancelCostCentre = function () {
            $scope.Update = false;
            ClearCostCentre();
        }

        $scope.saveDivision = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/division/update",
                    data: {
                        _id: $scope.SID, DivisionName: $scope.model.DivisionName, DivisionCode: $scope.model.DivisionCode, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearDivision();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Divisiondatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshDivision();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/division/add",
                    data: {
                        Client_Id: Client_Id,
                        DivisionName: $scope.model.DivisionName, DivisionCode: $scope.model.DivisionCode, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearDivision();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshDivision();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Divisioninfo = function (DivisionId, $index) {

            $scope.SID = DivisionId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.DivisioninfoId = DivisionId;
            try {
                var DivisionArray = $scope.Divisiondatas;
                var item = DivisionArray.filter(function (item) {
                    return item.id === DivisionId;
                })[0];
                $scope.id = item.id;
                $scope.model.DivisionName = item.DivisionName;
                $scope.model.DivisionCode = item.DivisionCode;
            } catch (err) { }

            //var info = $scope.Divisiondatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == DivisionId) {
            //        $scope.model.DivisionName = info[i].DivisionName;
            //        $scope.model.DivisionCode = info[i].DivisionCode;
            //    }
            //}
        }

        $scope.saveBank = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.ID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/bankhrm/update",
                    data: {
                        _id: $scope.SID, BankName: $scope.model.BankName, BankCode: $scope.model.BankCode, BIC: $scope.model.BIC, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearBank();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Bankdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/bankhrm/add",
                    data: {
                        Client_Id: Client_Id,
                        BankName: $scope.model.BankName, BankCode: $scope.model.BankCode, BIC: $scope.model.BIC, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearBank();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshBank();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Bankinfo = function (BankId, $index) {

            $scope.SID = BankId;
            $scope.ID = $index;
            $scope.Update = true;
            $scope.BankinfoId = BankId;
            try {
                var BankdataArray = $scope.Bankdatas;
                var item = BankdataArray.filter(function (item) {
                    return item.id === BankId;
                })[0];
                $scope.id = item.id;
                $scope.model.BankCode = item.BankCode;
                $scope.model.BankName = item.BankName;
                $scope.model.BIC = item.BIC;
            } catch (err) { }

        }
        //$http.get( $rootScope.WebURL + "/division")
        //   .then(function (Divisiondata) {
        //       $scope.Divisiondatas = Divisiondata.data.data;
        //   });
        $scope.CountryUpdate = false;
        $scope.saveCountry = function () {
            if ($scope.CountryUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/country/update",
                    data: {
                        _id: $scope.Country_Id,
                        CountryCode: $scope.model.CountryCode, CountryName: $scope.model.CountryName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.CountryUpdate = false;
                    $scope.model.CountryCode = "";
                    $scope.model.CountryName = "";
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $http({
                        url: $rootScope.WebURL + "/country",
                        method: "POST",
                        data: { Client_Id: Client_Id },
                    }).then(function (countrydata) {
                        $scope.Countrydatas = countrydata.data.data;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/country/add",
                    data: {
                        Client_Id: Client_Id,
                        CountryCode: $scope.model.CountryCode, CountryName: $scope.model.CountryName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.CountryUpdate = false;
                    $scope.model.CountryCode = "";
                    $scope.model.CountryName = "";
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $http({
                        url: $rootScope.WebURL + "/country",
                        method: "POST",
                        data: { Client_Id: Client_Id },
                    }).then(function (countrydata) {
                        $scope.Countrydatas = countrydata.data.data;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Countryinfo = function (Id, CC, CN) {
            $scope.Country_Id = Id;
            $scope.model.CountryName = CN;
            $scope.model.CountryCode = CC;
            $scope.CountryUpdate = true;
        }

        $scope.NationalityUpdate = false;
        $scope.saveNationality = function () {
            if ($scope.NationalityUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/nationality/update",
                    data: {
                        _id: $scope.Nationality_Id,
                        NationalityCode: $scope.model.NationalityCode, NationalityName: $scope.model.NationalityName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.NationalityUpdate = false;
                    $scope.model.NationalityCode = "";
                    $scope.model.NationalityName = "";
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $http({
                        url: $rootScope.WebURL + "/nationality",
                        method: "POST",
                        data: { Client_Id: Client_Id },
                    }).then(function (countrydata) {
                        $scope.Nationalitydatas = countrydata.data.data;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/nationality/add",
                    data: {
                        Client_Id: Client_Id,
                        NationalityCode: $scope.model.NationalityCode, NationalityName: $scope.model.NationalityName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.NationalityUpdate = false;
                    $scope.model.NationalityCode = "";
                    $scope.model.NationalityName = "";
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $http({
                        url: $rootScope.WebURL + "/nationality",
                        method: "POST",
                        data: { Client_Id: Client_Id },
                    }).then(function (countrydata) {
                        $scope.Nationalitydatas = countrydata.data.data;
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Nationalityinfo = function (Id, CC, CN) {
            $scope.Nationality_Id = Id;
            $scope.model.NationalityName = CN;
            $scope.model.NationalityCode = CC;
            $scope.NationalityUpdate = true;
        }
        $http({
            url: $rootScope.WebURL + "/country",
            method: "POST",
            data: { Client_Id: Client_Id },
        }).then(function (countrydata) {
            $scope.Countrydatas = countrydata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/nationality",
            method: "POST",
            data: { Client_Id: Client_Id },
        }).then(function (countrydata) {
            $scope.Nationalitydatas = countrydata.data.data;
        });
        function RefreshDivision() {
            var response = $http({
                url: $rootScope.WebURL + "/division",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/division")
            //.then(function (Divisiondata) {
            //    $scope.Divisiondatas = Divisiondata.data.data;
            //});
            $scope.Update = false;
        }

        function RefreshBank() {
            var response = $http({
                url: $rootScope.WebURL + "/bankhrm",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
            $scope.Update = false;
        }

        function ClearDivision() {
            $scope.model.DivisionName = '';
            $scope.model.DivisionCode = '';
            $scope.organizationform3.$setPristine();
            $scope.organizationform3.$setUntouched();
        }
        function ClearBank() {
            $scope.model.BankName = '';
            $scope.model.BankCode = '';
            $scope.model.BIC = '';
            $scope.organizationform4.$setPristine();
            $scope.organizationform4.$setUntouched();
        }

        $scope.cancelDivision = function () {
            $scope.Update = false;
            ClearDivision();
        }
        $scope.cancelBank = function () {
            $scope.Update = false;
            ClearBank();
        }
        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/organizationchart/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Organization Chart",
                            FileID: null,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshOrganizationChartGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        function RefreshOrganizationChartGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByTableName",
                method: "POST",
                data: { TableName: "Organization Chart" },
            });
            response.then(function (Organizationchartdata) {
                $scope.Organizationchartdatas = Organizationchartdata.data.data;
            });
        }


        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
        };


    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.hrpolicy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_hrpolicy', {
            url: '/HRPolicy',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/hrpolicy/hrpolicy.html',
                    controller: 'HrPolicyController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/hrpolicy');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.hrpolicy')
        .controller('HrPolicyController', HrPolicyController);

    /** @ngInject */
    function HrPolicyController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        debugger

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshGrid();
        RefreshEmployeehandbookGrid();

        $scope.HandbookTab = function () {
            debugger
            RefreshEmployeehandbookGrid();
            RefreshdataGrid();
        }

        $scope.HandbookExport = function () {
            alasql('SELECT * INTO XLSX("Organizationdatas.xlsx",{headers:true}) FROM ?', [$scope.Organizationdatas]);
        };

        $scope.PolicyTab = function () {
            RefreshPolicyGrid();
            RefreshdataGrid();
        }

        $scope.PolicyExport = function () {
            alasql('SELECT * INTO XLSX("CostCentredatas.xlsx",{headers:true}) FROM ?', [$scope.CostCentredatas]);
        };

        $scope.UploadEmployeeHandbookfiles = function (file) {
            var upfile = file[0].file
            debugger
            var response = Upload.upload({
                url: $rootScope.WebURL + "/hrpolicy/upload",
                data: { file: upfile }
            }).then(function (resp) {
                debugger
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Employee Handbook",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshEmployeehandbookGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        $scope.UploadHrpolicyfiles = function (file) {
            var uhfile = file[0].file
            debugger
            var response = Upload.upload({
                url: $rootScope.WebURL + "/hrpolicy/upload",
                data: { file: uhfile }
            }).then(function (resp) {
                debugger
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "HR Policy",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshPolicyGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/hrpolicy",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Hrpolicydata) {
                debugger
                $scope.Hrpolicydetaildatas = Hrpolicydata.data.data;
                RefreshdataGrid();
            });
        }

        function RefreshdataGrid() {
            debugger
            angular.forEach($scope.Hrpolicydetaildatas, function (value) {
                if ($scope.Hrpolicydetaildatas != "" && $scope.Hrpolicydetaildatas != null && $scope.Hrpolicydetaildatas != undefined) {
                    debugger
                    $scope.id = value.id;
                    $scope.model.HandbookDetail = value.HandbookDetail;
                    $scope.model.PolicyDetail = value.PolicyDetail;
                }
                debugger
                $scope.CHandbookDetail = $scope.model.HandbookDetail;
                $scope.CPolicyDetail = $scope.model.PolicyDetail;
            });

        }

        function RefreshdataGrid1() {
            debugger
            angular.forEach($scope.Hrpolicydetaildatas, function (value) {
                if ($scope.Hrpolicydetaildatas != "" && $scope.Hrpolicydetaildatas != null && $scope.Hrpolicydetaildatas != undefined) {
                    debugger
                    $scope.id = value.id;
                    $scope.CHandbookDetail = value.HandbookDetail;
                    $scope.CPolicyDetail = value.PolicyDetail;
                }
            });

        }

        function RefreshEmployeehandbookGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByTableName",
                method: "POST",
                data: { TableName: "Employee Handbook" },
            });
            response.then(function (EmployeeHandbookdata) {
                debugger
                $scope.EmployeeHandbookdatas = EmployeeHandbookdata.data.data;
            });
        }

        function RefreshPolicyGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByTableName",
                method: "POST",
                data: { TableName: "HR Policy" },
            });
            response.then(function (Hrpolicydata) {
                $scope.Hrpolicydatas = Hrpolicydata.data.data;
            });
        }

        $scope.HandbookSubmit = function () {
            debugger
            RefreshdataGrid1();


            if ($scope.CHandbookDetail != null && $scope.CHandbookDetail != "" && $scope.CHandbookDetail != undefined) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/hrpolicy/update",
                    data: {
                        _id: $scope.id,
                        HandbookDetail: $scope.model.HandbookDetail,
                        PolicyDetail: $scope.CPolicyDetail,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/hrpolicy/add",
                    data: {

                        Client_Id: Client_Id,
                        HandbookDetail: $scope.model.HandbookDetail,
                        PolicyDetail: $scope.CPolicyDetail,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.PolicySubmit = function () {
            debugger
            RefreshdataGrid1();


            if ($scope.CPolicyDetail != null && $scope.CPolicyDetail != "" && $scope.CPolicyDetail != undefined) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/hrpolicy/update",
                    data: {
                        _id: $scope.id,
                        HandbookDetail: $scope.CHandbookDetail,
                        PolicyDetail: $scope.model.PolicyDetail,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/hrpolicy/add",
                    data: {
                        Client_Id: Client_Id,
                        HandbookDetail: $scope.CHandbookDetail,
                        PolicyDetail: $scope.model.PolicyDetail,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        //function RefreshGrid() {
        //    debugger
        //    $http.get( $rootScope.WebURL + "/hrpolicy")
        //   .then(function (Hrpolicydata) {
        //       debugger
        //       $scope.Hrpolicydetaildatas = Hrpolicydata.data.data;
        //   });
        //}

        var vm = this;

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };



    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.job', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_job', {
            url: '/JobCategories',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/job/job.html',
                    controller: 'JobController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/job');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.job')
        .controller('JobController', JobController);

    function JobController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {

        document.getElementsByTagName('title')[0].text = "Human Resource-Job Categories"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        RefreshJobTitle();
        RefreshJobCategories();
        RefreshEmploymentStatus();
        RefreshVisaType();

        $scope.Update = false;
        $scope.model = {};

        $scope.titleExport = true;
        $scope.categoryExport = false;
        $scope.statusExport = false;
        $scope.visatypeExport = false;

        $scope.Title = function () {
            $scope.titleExport = true;
            $scope.categoryExport = false;
            $scope.statusExport = false;
            $scope.visatypeExport = false;
            $scope.model.Search = '';
            RefreshJobTitle();
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("JobTitledatas.xlsx",{headers:true}) FROM ?', [$scope.JobTitledatas]);
        };

        $scope.Category = function () {
            $scope.titleExport = false;
            $scope.categoryExport = true;
            $scope.statusExport = false;
            $scope.visatypeExport = false;
            $scope.model.Search = '';
            RefreshJobCategories();
        }
        $scope.cExport = function () {
            alasql('SELECT * INTO XLSX("JobCategoriesdatas.xlsx",{headers:true}) FROM ?', [$scope.JobCategoriesdatas]);
        };

        $scope.Status = function () {
            $scope.titleExport = false;
            $scope.categoryExport = false;
            $scope.statusExport = true;
            $scope.visatypeExport = false;
            $scope.model.Search = '';
            RefreshEmploymentStatus();
        }
        $scope.sExport = function () {
            alasql('SELECT * INTO XLSX("EmploymentStatusdatas.xlsx",{headers:true}) FROM ?', [$scope.EmploymentStatusdatas]);
        };

        $scope.VisaType = function () {
            $scope.titleExport = false;
            $scope.categoryExport = false;
            $scope.statusExport = false;
            $scope.visatypeExport = true;
            $scope.model.Search = '';
            RefreshVisaType();
        }
        $scope.vExport = function () {
            alasql('SELECT * INTO XLSX("VisaTypedatas.xlsx",{headers:true}) FROM ?', [$scope.VisaTypedatas]);
        };


        $scope.saveJobTitle = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/jobtitle/update",
                    data: {
                        _id: $scope.SID, JobTitle: $scope.model.JobTitle, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearJobTitle();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.JobTitledatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshJobTitle();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/jobtitle/add",
                    data: {
                        Client_Id: Client_Id,
                        JobTitle: $scope.model.JobTitle, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearJobTitle();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshJobTitle();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.JobTitleinfo = function (JobTitleId, $index) {

            $scope.IndxID = $index;
            $scope.SID = JobTitleId;
            $scope.Update = true;
            $scope.JobTitleinfoId = JobTitleId;
            try {
                var JobTitleArray = $scope.JobTitledatas;
                var item = JobTitleArray.filter(function (item) {
                    return item.id === JobTitleId;
                })[0];
                $scope.id = item.id;
                $scope.model.JobTitle = item.JobTitle;
            } catch (err) { }

            //var info = $scope.JobTitledatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == JobTitleId) {
            //        $scope.model.JobTitle = info[i].JobTitle;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/jobtitle")
        //   .then(function (JobTitledata) {
        //       $scope.JobTitledatas = JobTitledata.data.data;
        //   });

        function RefreshJobTitle() {
            var response = $http({
                url: $rootScope.WebURL + "/jobtitle",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (JobTitledata) {
                $scope.JobTitledatas = JobTitledata.data.data;
            });

            // $http.get( $rootScope.WebURL + "/jobtitle")
            //.then(function (JobTitledata) {
            //    $scope.JobTitledatas = JobTitledata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearJobTitle() {
            $scope.model.JobTitle = '';
            $scope.jobform1.$setPristine();
            $scope.jobform1.$setUntouched();
        }

        $scope.cancelJobTitle = function () {
            $scope.Update = false;
            ClearJobTitle();
        }

        $scope.saveJobCategories = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/jobcategories/update",
                    data: {
                        _id: $scope.SID, Name: $scope.model.Name, Code: $scope.model.Code, Description: $scope.model.Description, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearJobCategories();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.JobCategoriesdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshJobCategories();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/jobcategories/add",
                    data: {
                        Client_Id: Client_Id,
                        Name: $scope.model.Name, Code: $scope.model.Code, Description: $scope.model.Description, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearJobCategories();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshJobCategories();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.JobCategoriesinfo = function (JobCategoriesId, $index) {

            $scope.IndxID = $index;
            $scope.SID = JobCategoriesId;
            $scope.Update = true;
            $scope.JobCategoriesinfoId = JobCategoriesId;
            try {
                var JobCategoriesArray = $scope.JobCategoriesdatas;
                var item = JobCategoriesArray.filter(function (item) {
                    return item.id === JobCategoriesId;
                })[0];
                $scope.id = item.id;
                $scope.model.Name = item.Name;
                $scope.model.Code = item.Code;
                $scope.model.Description = item.Description;
            } catch (err) { }

            //var info = $scope.JobCategoriesdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == JobCategoriesId) {
            //        $scope.model.Name = info[i].Name;
            //        $scope.model.Code = info[i].Code;
            //        $scope.model.Description = info[i].Description;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/jobcategories")
        //   .then(function (JobCategoriesdata) {
        //       $scope.JobCategoriesdatas = JobCategoriesdata.data.data;
        //   });


        $scope.JobCategoriesDelete = function (id) {
            $scope.DelId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure, you want to delete?", "Confirm")
            result.done(function (dialogResult) {
                if (dialogResult == true) {
                    var response = $http({
                        url: $rootScope.WebURL + "/jobcategories/delete",
                        method: "POST",
                        data: { id: id },
                    });
                    response.then(function (JobTitledata) {
                        RefreshJobCategories()
                    });
                }
            })
        }

        function RefreshJobCategories() {
            var response = $http({
                url: $rootScope.WebURL + "/jobcategories",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (JobCategoriesdata) {
                $scope.JobCategoriesdatas = JobCategoriesdata.data.data;
            });
            $scope.Update = false;
        }

        function ClearJobCategories() {
            $scope.model.Name = '';
            $scope.model.Code = '';
            $scope.model.Description = '';
            $scope.jobform2.$setPristine();
            $scope.jobform2.$setUntouched();
        }

        $scope.cancelJobCategories = function () {
            $scope.Update = false;
            ClearJobCategories();
        }

        $scope.saveEmploymentStatus = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employmentstatus/update",
                    data: {
                        _id: $scope.SID, EmploymentStatusName: $scope.model.EmploymentStatusName, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearEmploymentStatus();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.EmploymentStatusdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                    //RefreshEmploymentStatus();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employmentstatus/add",
                    data: {
                        Client_Id: Client_Id,
                        EmploymentStatusName: $scope.model.EmploymentStatusName, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearEmploymentStatus();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEmploymentStatus();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.EmploymentStatusinfo = function (EmploymentStatusId, $index) {

            $scope.IndxID = $index;
            $scope.SID = EmploymentStatusId;
            $scope.Update = true;
            $scope.EmploymentStatusinfoId = EmploymentStatusId;
            try {
                var EmploymentStatusArray = $scope.EmploymentStatusdatas;
                var item = EmploymentStatusArray.filter(function (item) {
                    return item.id === EmploymentStatusId;
                })[0];
                $scope.id = item.id;
                $scope.model.EmploymentStatusName = item.EmploymentStatusName;
            } catch (err) { }

            //var info = $scope.EmploymentStatusdatas
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == EmploymentStatusId) {
            //        $scope.model.EmploymentStatusName = info[i].EmploymentStatusName;
            //    }
            //}
        }

        //$http.get( $rootScope.WebURL + "/employmentstatus")
        //   .then(function (EmploymentStatusdata) {
        //       $scope.EmploymentStatusdatas = EmploymentStatusdata.data.data;
        //   });

        function RefreshEmploymentStatus() {
            var response = $http({
                url: $rootScope.WebURL + "/employmentstatus",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (EmploymentStatusdata) {
                $scope.EmploymentStatusdatas = EmploymentStatusdata.data.data;
            });
            // $http.get( $rootScope.WebURL + "/employmentstatus")
            //.then(function (EmploymentStatusdata) {
            //    $scope.EmploymentStatusdatas = EmploymentStatusdata.data.data;
            //});
            $scope.Update = false;
        }

        function ClearEmploymentStatus() {
            $scope.model.EmploymentStatusName = '';
            $scope.jobform3.$setPristine();
            $scope.jobform3.$setUntouched();
        }

        $scope.cancelEmploymentStatus = function () {
            $scope.Update = false;
            ClearEmploymentStatus();
        }

        $scope.saveVisaType = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/visatype/update",
                    data: {
                        _id: $scope.SID, VisaTypeName: $scope.model.visatype, UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearVisaType();
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.VisaTypedatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/visatype/add",
                    data: {
                        Client_Id: Client_Id,
                        VisaTypeName: $scope.model.visatype, CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearVisaType();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshVisaType();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.VisaTypeinfo = function (VisatypeId, $index) {

            $scope.IndxID = $index;
            $scope.SID = VisatypeId;
            $scope.Update = true;
            $scope.VisaTypeinfoId = VisatypeId;
            try {
                var VisaTypeArray = $scope.VisaTypedatas;
                var item = VisaTypeArray.filter(function (item) {
                    return item.id === VisatypeId;
                })[0];
                $scope.id = item.id;
                $scope.model.visatype = item.VisaTypeName;
            } catch (err) { }

        }
        function RefreshVisaType() {
            var response = $http({
                url: $rootScope.WebURL + "/visatype",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (VisaTypedata) {
                $scope.VisaTypedatas = VisaTypedata.data.data;
            });
            $scope.Update = false;
        }
        function ClearVisaType() {
            $scope.model.visatype = '';
            $scope.jobform4.$setPristine();
            $scope.jobform4.$setUntouched();
        }
        $scope.cancelVisaType = function () {
            $scope.Update = false;
            ClearVisaType();
        }


        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.data', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_data', {
            url: '/DataImport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/data/data.html',
                    controller: 'dataController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.data')
        .controller('dataController', dataController);

    /** @ngInject */
    function dataController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

    }

})();
/*
 * angular-ui-bootstrap
 * https://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.tabindex", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.datepicker", "ui.bootstrap.position", "ui.bootstrap.datepickerPopup", "ui.bootstrap.debounce", "ui.bootstrap.multiMap", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/year.html", "uib/template/datepickerPopup/popup.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

    .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
        var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
        return {
            link: function (scope, element, attrs) {
                var expandingExpr = $parse(attrs.expanding),
                    expandedExpr = $parse(attrs.expanded),
                    collapsingExpr = $parse(attrs.collapsing),
                    collapsedExpr = $parse(attrs.collapsed),
                    horizontal = false,
                    css = {},
                    cssTo = {};

                init();

                function init() {
                    horizontal = !!('horizontal' in attrs);
                    if (horizontal) {
                        css = {
                            width: ''
                        };
                        cssTo = { width: '0' };
                    } else {
                        css = {
                            height: ''
                        };
                        cssTo = { height: '0' };
                    }
                    if (!scope.$eval(attrs.uibCollapse)) {
                        element.addClass('in')
                            .addClass('collapse')
                            .attr('aria-expanded', true)
                            .attr('aria-hidden', false)
                            .css(css);
                    }
                }

                function getScrollFromElement(element) {
                    if (horizontal) {
                        return { width: element.scrollWidth + 'px' };
                    }
                    return { height: element.scrollHeight + 'px' };
                }

                function expand() {
                    if (element.hasClass('collapse') && element.hasClass('in')) {
                        return;
                    }

                    $q.resolve(expandingExpr(scope))
                        .then(function () {
                            element.removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', true)
                                .attr('aria-hidden', false);

                            if ($animateCss) {
                                $animateCss(element, {
                                    addClass: 'in',
                                    easing: 'ease',
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).start()['finally'](expandDone);
                            } else {
                                $animate.addClass(element, 'in', {
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).then(expandDone);
                            }
                        }, angular.noop);
                }

                function expandDone() {
                    element.removeClass('collapsing')
                        .addClass('collapse')
                        .css(css);
                    expandedExpr(scope);
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    $q.resolve(collapsingExpr(scope))
                        .then(function () {
                            element
                                // IMPORTANT: The width must be set before adding "collapsing" class.
                                // Otherwise, the browser attempts to animate from width 0 (in
                                // collapsing class) to the given width here.
                                .css(getScrollFromElement(element[0]))
                                // initially all panel collapse have the collapse class, this removal
                                // prevents the animation from jumping to collapsed state
                                .removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', false)
                                .attr('aria-hidden', true);

                            if ($animateCss) {
                                $animateCss(element, {
                                    removeClass: 'in',
                                    to: cssTo
                                }).start()['finally'](collapseDone);
                            } else {
                                $animate.removeClass(element, 'in', {
                                    to: cssTo
                                }).then(collapseDone);
                            }
                        }, angular.noop);
                }

                function collapseDone() {
                    element.css(cssTo); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing')
                        .addClass('collapse');
                    collapsedExpr(scope);
                }

                scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.tabindex', [])

    .directive('uibTabindexToggle', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                attrs.$observe('disabled', function (disabled) {
                    attrs.$set('tabindex', disabled ? -1 : null);
                });
            }
        };
    });

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

    .constant('uibAccordionConfig', {
        closeOthers: true
    })

    .controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
        // This array keeps track of the accordion groups
        this.groups = [];

        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        this.closeOthers = function (openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ?
                $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if (closeOthers) {
                angular.forEach(this.groups, function (group) {
                    if (group !== openGroup) {
                        group.isOpen = false;
                    }
                });
            }
        };

        // This is called from the accordion-group directive to add itself to the accordion
        this.addGroup = function (groupScope) {
            var that = this;
            this.groups.push(groupScope);

            groupScope.$on('$destroy', function (event) {
                that.removeGroup(groupScope);
            });
        };

        // This is called from the accordion-group directive when to remove itself
        this.removeGroup = function (group) {
            var index = this.groups.indexOf(group);
            if (index !== -1) {
                this.groups.splice(index, 1);
            }
        };
    }])

    // The accordion directive simply sets up the directive controller
    // and adds an accordion CSS class to itself element.
    .directive('uibAccordion', function () {
        return {
            controller: 'UibAccordionController',
            controllerAs: 'accordion',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion.html';
            }
        };
    })

    // The accordion-group directive indicates a block of html that will expand and collapse in an accordion
    .directive('uibAccordionGroup', function () {
        return {
            require: '^uibAccordion',         // We need this directive to be inside an accordion
            transclude: true,              // It transcludes the contents of the directive into the template
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
            },
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                panelClass: '@?',           // Ditto with panelClass
                isOpen: '=?',
                isDisabled: '=?'
            },
            controller: function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            },
            link: function (scope, element, attrs, accordionCtrl) {
                element.addClass('panel');
                accordionCtrl.addGroup(scope);

                scope.openClass = attrs.openClass || 'panel-open';
                scope.panelClass = attrs.panelClass || 'panel-default';
                scope.$watch('isOpen', function (value) {
                    element.toggleClass(scope.openClass, !!value);
                    if (value) {
                        accordionCtrl.closeOthers(scope);
                    }
                });

                scope.toggleOpen = function ($event) {
                    if (!scope.isDisabled) {
                        if (!$event || $event.which === 32) {
                            scope.isOpen = !scope.isOpen;
                        }
                    }
                };

                var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
                scope.headingId = id + '-tab';
                scope.panelId = id + '-panel';
            }
        };
    })

    // Use accordion-heading below an accordion-group to provide a heading containing HTML
    .directive('uibAccordionHeading', function () {
        return {
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
            }
        };
    })

    // Use in the accordion-group template to indicate where you want the heading to be transcluded
    // You must provide the property on the accordion-group controller that will hold the transcluded element
    .directive('uibAccordionTransclude', function () {
        return {
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, controller) {
                scope.$watch(function () { return controller[attrs.uibAccordionTransclude]; }, function (heading) {
                    if (heading) {
                        var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
                        elem.html('');
                        elem.append(heading);
                    }
                });
            }
        };

        function getHeaderSelectors() {
            return 'uib-accordion-header,' +
                'data-uib-accordion-header,' +
                'x-uib-accordion-header,' +
                'uib\\:accordion-header,' +
                '[uib-accordion-header],' +
                '[data-uib-accordion-header],' +
                '[x-uib-accordion-header]';
        }
    });

angular.module('ui.bootstrap.alert', [])

    .controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
        $scope.closeable = !!$attrs.close;
        $element.addClass('alert');
        $attrs.$set('role', 'alert');
        if ($scope.closeable) {
            $element.addClass('alert-dismissible');
        }

        var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
            $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

        if (dismissOnTimeout) {
            $timeout(function () {
                $scope.close();
            }, parseInt(dismissOnTimeout, 10));
        }
    }])

    .directive('uibAlert', function () {
        return {
            controller: 'UibAlertController',
            controllerAs: 'alert',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/alert/alert.html';
            },
            transclude: true,
            scope: {
                close: '&'
            }
        };
    });

angular.module('ui.bootstrap.buttons', [])

    .constant('uibButtonConfig', {
        activeClass: 'active',
        toggleEvent: 'click'
    })

    .controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
        this.activeClass = buttonConfig.activeClass || 'active';
        this.toggleEvent = buttonConfig.toggleEvent || 'click';
    }])

    .directive('uibBtnRadio', ['$parse', function ($parse) {
        return {
            require: ['uibBtnRadio', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'buttons',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                var uncheckableExpr = $parse(attrs.uibUncheckable);

                element.find('input').css({ display: 'none' });

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    var isActive = element.hasClass(buttonsCtrl.activeClass);

                    if (!isActive || angular.isDefined(attrs.uncheckable)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });

                if (attrs.uibUncheckable) {
                    scope.$watch(uncheckableExpr, function (uncheckable) {
                        attrs.$set('uncheckable', uncheckable ? '' : undefined);
                    });
                }
            }
        };
    }])

    .directive('uibBtnCheckbox', function () {
        return {
            require: ['uibBtnCheckbox', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'button',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                element.find('input').css({ display: 'none' });

                function getTrueValue() {
                    return getCheckboxValue(attrs.btnCheckboxTrue, true);
                }

                function getFalseValue() {
                    return getCheckboxValue(attrs.btnCheckboxFalse, false);
                }

                function getCheckboxValue(attribute, defaultValue) {
                    return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    });

angular.module('ui.bootstrap.carousel', [])

    .controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
        var self = this,
            slides = self.slides = $scope.slides = [],
            SLIDE_DIRECTION = 'uib-slideDirection',
            currentIndex = $scope.active,
            currentInterval, isPlaying;

        var destroyed = false;
        $element.addClass('carousel');

        self.addSlide = function (slide, element) {
            slides.push({
                slide: slide,
                element: element
            });
            slides.sort(function (a, b) {
                return +a.slide.index - +b.slide.index;
            });
            //if this is the first slide or the slide is set to active, select it
            if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition = null;
                }

                currentIndex = slide.index;
                $scope.active = slide.index;
                setActive(currentIndex);
                self.select(slides[findSlideIndex(slide)]);
                if (slides.length === 1) {
                    $scope.play();
                }
            }
        };

        self.getCurrentIndex = function () {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide.index === currentIndex) {
                    return i;
                }
            }
        };

        self.next = $scope.next = function () {
            var newIndex = (self.getCurrentIndex() + 1) % slides.length;

            if (newIndex === 0 && $scope.noWrap()) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'next');
        };

        self.prev = $scope.prev = function () {
            var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

            if ($scope.noWrap() && newIndex === slides.length - 1) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'prev');
        };

        self.removeSlide = function (slide) {
            var index = findSlideIndex(slide);

            //get the index of the slide inside the carousel
            slides.splice(index, 1);
            if (slides.length > 0 && currentIndex === index) {
                if (index >= slides.length) {
                    currentIndex = slides.length - 1;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[slides.length - 1]);
                } else {
                    currentIndex = index;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
                $scope.active = currentIndex;
            }

            //clean the active value when no more slide
            if (slides.length === 0) {
                currentIndex = null;
                $scope.active = null;
            }
        };

        /* direction: "prev" or "next" */
        self.select = $scope.select = function (nextSlide, direction) {
            var nextIndex = findSlideIndex(nextSlide.slide);
            //Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            }
            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (nextSlide.slide.index !== currentIndex &&
                !$scope.$currentTransition) {
                goNext(nextSlide.slide, nextIndex, direction);
            }
        };

        /* Allow outside people to call indexOf on slides array */
        $scope.indexOfSlide = function (slide) {
            return +slide.slide.index;
        };

        $scope.isActive = function (slide) {
            return $scope.active === slide.slide.index;
        };

        $scope.isPrevDisabled = function () {
            return $scope.active === 0 && $scope.noWrap();
        };

        $scope.isNextDisabled = function () {
            return $scope.active === slides.length - 1 && $scope.noWrap();
        };

        $scope.pause = function () {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };

        $scope.play = function () {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };

        $element.on('mouseenter', $scope.pause);
        $element.on('mouseleave', $scope.play);

        $scope.$on('$destroy', function () {
            destroyed = true;
            resetTimer();
        });

        $scope.$watch('noTransition', function (noTransition) {
            $animate.enabled($element, !noTransition);
        });

        $scope.$watch('interval', restartTimer);

        $scope.$watchCollection('slides', resetTransition);

        $scope.$watch('active', function (index) {
            if (angular.isNumber(index) && currentIndex !== index) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i].slide.index === index) {
                        index = i;
                        break;
                    }
                }

                var slide = slides[index];
                if (slide) {
                    setActive(index);
                    self.select(slides[index]);
                    currentIndex = index;
                }
            }
        });

        function getSlideByIndex(index) {
            for (var i = 0, l = slides.length; i < l; ++i) {
                if (slides[i].index === index) {
                    return slides[i];
                }
            }
        }

        function setActive(index) {
            for (var i = 0; i < slides.length; i++) {
                slides[i].slide.active = i === index;
            }
        }

        function goNext(slide, index, direction) {
            if (destroyed) {
                return;
            }

            angular.extend(slide, { direction: direction });
            angular.extend(slides[currentIndex].slide || {}, { direction: direction });
            if ($animate.enabled($element) && !$scope.$currentTransition &&
                slides[index].element && self.slides.length > 1) {
                slides[index].element.data(SLIDE_DIRECTION, slide.direction);
                var currentIdx = self.getCurrentIndex();

                if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
                    slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
                }

                $scope.$currentTransition = true;
                $animate.on('addClass', slides[index].element, function (element, phase) {
                    if (phase === 'close') {
                        $scope.$currentTransition = null;
                        $animate.off('addClass', element);
                    }
                });
            }

            $scope.active = slide.index;
            currentIndex = slide.index;
            setActive(index);

            //every time you change slides, reset the timer
            restartTimer();
        }

        function findSlideIndex(slide) {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide === slide) {
                    return i;
                }
            }
        }

        function resetTimer() {
            if (currentInterval) {
                $interval.cancel(currentInterval);
                currentInterval = null;
            }
        }

        function resetTransition(slides) {
            if (!slides.length) {
                $scope.$currentTransition = null;
            }
        }

        function restartTimer() {
            resetTimer();
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval > 0) {
                currentInterval = $interval(timerFn, interval);
            }
        }

        function timerFn() {
            var interval = +$scope.interval;
            if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
                $scope.next();
            } else {
                $scope.pause();
            }
        }
    }])

    .directive('uibCarousel', function () {
        return {
            transclude: true,
            controller: 'UibCarouselController',
            controllerAs: 'carousel',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/carousel.html';
            },
            scope: {
                active: '=',
                interval: '=',
                noTransition: '=',
                noPause: '=',
                noWrap: '&'
            }
        };
    })

    .directive('uibSlide', ['$animate', function ($animate) {
        return {
            require: '^uibCarousel',
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/slide.html';
            },
            scope: {
                actual: '=?',
                index: '=?'
            },
            link: function (scope, element, attrs, carouselCtrl) {
                element.addClass('item');
                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', function () {
                    carouselCtrl.removeSlide(scope);
                });

                scope.$watch('active', function (active) {
                    $animate[active ? 'addClass' : 'removeClass'](element, 'active');
                });
            }
        };
    }])

    .animation('.item', ['$animateCss',
        function ($animateCss) {
            var SLIDE_DIRECTION = 'uib-slideDirection';

            function removeClass(element, className, callback) {
                element.removeClass(className);
                if (callback) {
                    callback();
                }
            }

            return {
                beforeAddClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element,
                            directionClass + ' ' + direction, done);
                        element.addClass(direction);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                },
                beforeRemoveClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element, directionClass, done);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                }
            };
        }]);

angular.module('ui.bootstrap.dateparser', [])

    .service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
        // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
        var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

        var localeId;
        var formatCodeToRegex;

        this.init = function () {
            localeId = $locale.id;

            this.parsers = {};
            this.formatters = {};

            formatCodeToRegex = [
                {
                    key: 'yyyy',
                    regex: '\\d{4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yyyy');
                    }
                },
                {
                    key: 'yy',
                    regex: '\\d{2}',
                    apply: function (value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yy');
                    }
                },
                {
                    key: 'y',
                    regex: '\\d{1,4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'y');
                    }
                },
                {
                    key: 'M!',
                    regex: '0?[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) {
                        var value = date.getMonth();
                        if (/^[0-9]$/.test(value)) {
                            return dateFilter(date, 'MM');
                        }

                        return dateFilter(date, 'M');
                    }
                },
                {
                    key: 'MMMM',
                    regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMMM'); }
                },
                {
                    key: 'MMM',
                    regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMM'); }
                },
                {
                    key: 'MM',
                    regex: '0[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'MM'); }
                },
                {
                    key: 'M',
                    regex: '[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'M'); }
                },
                {
                    key: 'd!',
                    regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) {
                        var value = date.getDate();
                        if (/^[1-9]$/.test(value)) {
                            return dateFilter(date, 'dd');
                        }

                        return dateFilter(date, 'd');
                    }
                },
                {
                    key: 'dd',
                    regex: '[0-2][0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'dd'); }
                },
                {
                    key: 'd',
                    regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'd'); }
                },
                {
                    key: 'EEEE',
                    regex: $locale.DATETIME_FORMATS.DAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEEE'); }
                },
                {
                    key: 'EEE',
                    regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEE'); }
                },
                {
                    key: 'HH',
                    regex: '(?:0|1)[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'HH'); }
                },
                {
                    key: 'hh',
                    regex: '0[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'hh'); }
                },
                {
                    key: 'H',
                    regex: '1?[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'H'); }
                },
                {
                    key: 'h',
                    regex: '[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'h'); }
                },
                {
                    key: 'mm',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'mm'); }
                },
                {
                    key: 'm',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'm'); }
                },
                {
                    key: 'sss',
                    regex: '[0-9][0-9][0-9]',
                    apply: function (value) { this.milliseconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'sss'); }
                },
                {
                    key: 'ss',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'ss'); }
                },
                {
                    key: 's',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 's'); }
                },
                {
                    key: 'a',
                    regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
                    apply: function (value) {
                        if (this.hours === 12) {
                            this.hours = 0;
                        }

                        if (value === 'PM') {
                            this.hours += 12;
                        }
                    },
                    formatter: function (date) { return dateFilter(date, 'a'); }
                },
                {
                    key: 'Z',
                    regex: '[+-]\\d{4}',
                    apply: function (value) {
                        var matches = value.match(/([+-])(\d{2})(\d{2})/),
                            sign = matches[1],
                            hours = matches[2],
                            minutes = matches[3];
                        this.hours += toInt(sign + hours);
                        this.minutes += toInt(sign + minutes);
                    },
                    formatter: function (date) {
                        return dateFilter(date, 'Z');
                    }
                },
                {
                    key: 'ww',
                    regex: '[0-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'ww'); }
                },
                {
                    key: 'w',
                    regex: '[0-9]|[1-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'w'); }
                },
                {
                    key: 'GGGG',
                    regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
                    formatter: function (date) { return dateFilter(date, 'GGGG'); }
                },
                {
                    key: 'GGG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GGG'); }
                },
                {
                    key: 'GG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GG'); }
                },
                {
                    key: 'G',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'G'); }
                }
            ];

            if (angular.version.major >= 1 && angular.version.minor > 4) {
                formatCodeToRegex.push({
                    key: 'LLLL',
                    regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'LLLL'); }
                });
            }
        };

        this.init();

        function getFormatCodeToRegex(key) {
            return filterFilter(formatCodeToRegex, { key: key }, true)[0];
        }

        this.getParser = function (key) {
            var f = getFormatCodeToRegex(key);
            return f && f.apply || null;
        };

        this.overrideParser = function (key, parser) {
            var f = getFormatCodeToRegex(key);
            if (f && angular.isFunction(parser)) {
                this.parsers = {};
                f.apply = parser;
            }
        }.bind(this);

        function createParser(format) {
            var map = [], regex = format.split('');

            // check for literal values
            var quoteIndex = format.indexOf('\'');
            if (quoteIndex > -1) {
                var inLiteral = false;
                format = format.split('');
                for (var i = quoteIndex; i < format.length; i++) {
                    if (inLiteral) {
                        if (format[i] === '\'') {
                            if (i + 1 < format.length && format[i + 1] === '\'') { // escaped single quote
                                format[i + 1] = '$';
                                regex[i + 1] = '';
                            } else { // end of literal
                                regex[i] = '';
                                inLiteral = false;
                            }
                        }
                        format[i] = '$';
                    } else {
                        if (format[i] === '\'') { // start of literal
                            format[i] = '$';
                            regex[i] = '';
                            inLiteral = true;
                        }
                    }
                }

                format = format.join('');
            }

            angular.forEach(formatCodeToRegex, function (data) {
                var index = format.indexOf(data.key);

                if (index > -1) {
                    format = format.split('');

                    regex[index] = '(' + data.regex + ')';
                    format[index] = '$'; // Custom symbol to define consumed part of format
                    for (var i = index + 1, n = index + data.key.length; i < n; i++) {
                        regex[i] = '';
                        format[i] = '$';
                    }
                    format = format.join('');

                    map.push({
                        index: index,
                        key: data.key,
                        apply: data.apply,
                        matcher: data.regex
                    });
                }
            });

            return {
                regex: new RegExp('^' + regex.join('') + '$'),
                map: orderByFilter(map, 'index')
            };
        }

        function createFormatter(format) {
            var formatters = [];
            var i = 0;
            var formatter, literalIdx;
            while (i < format.length) {
                if (angular.isNumber(literalIdx)) {
                    if (format.charAt(i) === '\'') {
                        if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
                            formatters.push(constructLiteralFormatter(format, literalIdx, i));
                            literalIdx = null;
                        }
                    } else if (i === format.length) {
                        while (literalIdx < format.length) {
                            formatter = constructFormatterFromIdx(format, literalIdx);
                            formatters.push(formatter);
                            literalIdx = formatter.endIdx;
                        }
                    }

                    i++;
                    continue;
                }

                if (format.charAt(i) === '\'') {
                    literalIdx = i;
                    i++;
                    continue;
                }

                formatter = constructFormatterFromIdx(format, i);

                formatters.push(formatter.parser);
                i = formatter.endIdx;
            }

            return formatters;
        }

        function constructLiteralFormatter(format, literalIdx, endIdx) {
            return function () {
                return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
            };
        }

        function constructFormatterFromIdx(format, i) {
            var currentPosStr = format.substr(i);
            for (var j = 0; j < formatCodeToRegex.length; j++) {
                if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
                    var data = formatCodeToRegex[j];
                    return {
                        endIdx: i + data.key.length,
                        parser: data.formatter
                    };
                }
            }

            return {
                endIdx: i + 1,
                parser: function () {
                    return currentPosStr.charAt(0);
                }
            };
        }

        this.filter = function (date, format) {
            if (!angular.isDate(date) || isNaN(date) || !format) {
                return '';
            }

            format = $locale.DATETIME_FORMATS[format] || format;

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.formatters[format]) {
                this.formatters[format] = createFormatter(format);
            }

            var formatters = this.formatters[format];

            return formatters.reduce(function (str, formatter) {
                return str + formatter(date);
            }, '');
        };

        this.parse = function (input, format, baseDate) {
            if (!angular.isString(input) || !format) {
                return input;
            }

            format = $locale.DATETIME_FORMATS[format] || format;
            format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.parsers[format]) {
                this.parsers[format] = createParser(format, 'apply');
            }

            var parser = this.parsers[format],
                regex = parser.regex,
                map = parser.map,
                results = input.match(regex),
                tzOffset = false;
            if (results && results.length) {
                var fields, dt;
                if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
                    fields = {
                        year: baseDate.getFullYear(),
                        month: baseDate.getMonth(),
                        date: baseDate.getDate(),
                        hours: baseDate.getHours(),
                        minutes: baseDate.getMinutes(),
                        seconds: baseDate.getSeconds(),
                        milliseconds: baseDate.getMilliseconds()
                    };
                } else {
                    if (baseDate) {
                        $log.warn('dateparser:', 'baseDate is not a valid date');
                    }
                    fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
                }

                for (var i = 1, n = results.length; i < n; i++) {
                    var mapper = map[i - 1];
                    if (mapper.matcher === 'Z') {
                        tzOffset = true;
                    }

                    if (mapper.apply) {
                        mapper.apply.call(fields, results[i]);
                    }
                }

                var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
                    Date.prototype.setFullYear;
                var timesetter = tzOffset ? Date.prototype.setUTCHours :
                    Date.prototype.setHours;

                if (isValid(fields.year, fields.month, fields.date)) {
                    if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
                        dt = new Date(baseDate);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours, fields.minutes,
                            fields.seconds, fields.milliseconds);
                    } else {
                        dt = new Date(0);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
                            fields.seconds || 0, fields.milliseconds || 0);
                    }
                }

                return dt;
            }
        };

        // Check if date is valid for specific month (and year for February).
        // Month: 0 = Jan, 1 = Feb, etc
        function isValid(year, month, date) {
            if (date < 1) {
                return false;
            }

            if (month === 1 && date > 28) {
                return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
            }

            if (month === 3 || month === 5 || month === 8 || month === 10) {
                return date < 31;
            }

            return true;
        }

        function toInt(str) {
            return parseInt(str, 10);
        }

        this.toTimezone = toTimezone;
        this.fromTimezone = fromTimezone;
        this.timezoneToOffset = timezoneToOffset;
        this.addDateMinutes = addDateMinutes;
        this.convertTimezoneToLocal = convertTimezoneToLocal;

        function toTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
        }

        function fromTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
        }

        //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
        function timezoneToOffset(timezone, fallback) {
            timezone = timezone.replace(/:/g, '');
            var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
            return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
        }

        function addDateMinutes(date, minutes) {
            date = new Date(date.getTime());
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function convertTimezoneToLocal(date, timezone, reverse) {
            reverse = reverse ? -1 : 1;
            var dateTimezoneOffset = date.getTimezoneOffset();
            var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
            return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
        }
    }]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
    .directive('uibIsClass', [
        '$animate',
        function ($animate) {
            //                    11111111          22222222
            var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
            //                    11111111           22222222
            var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

            var dataPerTracked = {};

            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    var linkedScopes = [];
                    var instances = [];
                    var expToData = {};
                    var lastActivated = null;
                    var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
                    var onExp = onExpMatches[2];
                    var expsStr = onExpMatches[1];
                    var exps = expsStr.split(',');

                    return linkFn;

                    function linkFn(scope, element, attrs) {
                        linkedScopes.push(scope);
                        instances.push({
                            scope: scope,
                            element: element
                        });

                        exps.forEach(function (exp, k) {
                            addForExp(exp, scope);
                        });

                        scope.$on('$destroy', removeScope);
                    }

                    function addForExp(exp, scope) {
                        var matches = exp.match(IS_REGEXP);
                        var clazz = scope.$eval(matches[1]);
                        var compareWithExp = matches[2];
                        var data = expToData[exp];
                        if (!data) {
                            var watchFn = function (compareWithVal) {
                                var newActivated = null;
                                instances.some(function (instance) {
                                    var thisVal = instance.scope.$eval(onExp);
                                    if (thisVal === compareWithVal) {
                                        newActivated = instance;
                                        return true;
                                    }
                                });
                                if (data.lastActivated !== newActivated) {
                                    if (data.lastActivated) {
                                        $animate.removeClass(data.lastActivated.element, clazz);
                                    }
                                    if (newActivated) {
                                        $animate.addClass(newActivated.element, clazz);
                                    }
                                    data.lastActivated = newActivated;
                                }
                            };
                            expToData[exp] = data = {
                                lastActivated: null,
                                scope: scope,
                                watchFn: watchFn,
                                compareWithExp: compareWithExp,
                                watcher: scope.$watch(compareWithExp, watchFn)
                            };
                        }
                        data.watchFn(scope.$eval(compareWithExp));
                    }

                    function removeScope(e) {
                        var removedScope = e.targetScope;
                        var index = linkedScopes.indexOf(removedScope);
                        linkedScopes.splice(index, 1);
                        instances.splice(index, 1);
                        if (linkedScopes.length) {
                            var newWatchScope = linkedScopes[0];
                            angular.forEach(expToData, function (data) {
                                if (data.scope === removedScope) {
                                    data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
                                    data.scope = newWatchScope;
                                }
                            });
                        } else {
                            expToData = {};
                        }
                    }
                }
            };
        }]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

    .value('$datepickerSuppressError', false)

    .value('$datepickerLiteralWarning', true)

    .constant('uibDatepickerConfig', {
        datepickerMode: 'day',
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        maxDate: null,
        maxMode: 'year',
        minDate: null,
        minMode: 'day',
        monthColumns: 3,
        ngModelOptions: {},
        shortcutPropagation: false,
        showWeeks: true,
        yearColumns: 5,
        yearRows: 4
    })

    .controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
        function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
            var self = this,
                ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
                ngModelOptions = {},
                watchListeners = [];

            $element.addClass('uib-datepicker');
            $attrs.$set('role', 'application');

            if (!$scope.datepickerOptions) {
                $scope.datepickerOptions = {};
            }

            // Modes chain
            this.modes = ['day', 'month', 'year'];

            [
                'customClass',
                'dateDisabled',
                'datepickerMode',
                'formatDay',
                'formatDayHeader',
                'formatDayTitle',
                'formatMonth',
                'formatMonthTitle',
                'formatYear',
                'maxDate',
                'maxMode',
                'minDate',
                'minMode',
                'monthColumns',
                'showWeeks',
                'shortcutPropagation',
                'startingDay',
                'yearColumns',
                'yearRows'
            ].forEach(function (key) {
                switch (key) {
                    case 'customClass':
                    case 'dateDisabled':
                        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
                        break;
                    case 'datepickerMode':
                        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
                            $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
                        break;
                    case 'formatDay':
                    case 'formatDayHeader':
                    case 'formatDayTitle':
                    case 'formatMonth':
                    case 'formatMonthTitle':
                    case 'formatYear':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $interpolate($scope.datepickerOptions[key])($scope.$parent) :
                            datepickerConfig[key];
                        break;
                    case 'monthColumns':
                    case 'showWeeks':
                    case 'shortcutPropagation':
                    case 'yearColumns':
                    case 'yearRows':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $scope.datepickerOptions[key] : datepickerConfig[key];
                        break;
                    case 'startingDay':
                        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
                            self.startingDay = $scope.datepickerOptions.startingDay;
                        } else if (angular.isNumber(datepickerConfig.startingDay)) {
                            self.startingDay = datepickerConfig.startingDay;
                        } else {
                            self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
                        }

                        break;
                    case 'maxDate':
                    case 'minDate':
                        $scope.$watch('datepickerOptions.' + key, function (value) {
                            if (value) {
                                if (angular.isDate(value)) {
                                    self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
                                } else {
                                    if ($datepickerLiteralWarning) {
                                        $log.warn('Literal date support has been deprecated, please switch to date object usage');
                                    }

                                    self[key] = new Date(dateFilter(value, 'medium'));
                                }
                            } else {
                                self[key] = datepickerConfig[key] ?
                                    dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
                                    null;
                            }

                            self.refreshView();
                        });

                        break;
                    case 'maxMode':
                    case 'minMode':
                        if ($scope.datepickerOptions[key]) {
                            $scope.$watch(function () { return $scope.datepickerOptions[key]; }, function (value) {
                                self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
                                if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
                                    key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
                                    $scope.datepickerMode = self[key];
                                    $scope.datepickerOptions.datepickerMode = self[key];
                                }
                            });
                        } else {
                            self[key] = $scope[key] = datepickerConfig[key] || null;
                        }

                        break;
                }
            });

            $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if (angular.isDefined($attrs.ngDisabled)) {
                watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
                    $scope.disabled = disabled;
                    self.refreshView();
                }));
            }

            $scope.isActive = function (dateObject) {
                if (self.compare(dateObject.date, self.activeDate) === 0) {
                    $scope.activeDateId = dateObject.uid;
                    return true;
                }
                return false;
            };

            this.init = function (ngModelCtrl_) {
                ngModelCtrl = ngModelCtrl_;
                ngModelOptions = extractOptions(ngModelCtrl);

                if ($scope.datepickerOptions.initDate) {
                    self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
                    $scope.$watch('datepickerOptions.initDate', function (initDate) {
                        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                            self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
                            self.refreshView();
                        }
                    });
                } else {
                    self.activeDate = new Date();
                }

                var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
                this.activeDate = !isNaN(date) ?
                    dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
                    dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

                ngModelCtrl.$render = function () {
                    self.render();
                };
            };

            this.render = function () {
                if (ngModelCtrl.$viewValue) {
                    var date = new Date(ngModelCtrl.$viewValue),
                        isValid = !isNaN(date);

                    if (isValid) {
                        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    } else if (!$datepickerSuppressError) {
                        $log.error('Datepicker directive: "ng-model" value must be a Date object');
                    }
                }
                this.refreshView();
            };

            this.refreshView = function () {
                if (this.element) {
                    $scope.selectedDt = null;
                    this._refreshView();
                    if ($scope.activeDt) {
                        $scope.activeDateId = $scope.activeDt.uid;
                    }

                    var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                    date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setValidity('dateDisabled', !date ||
                        this.element && !this.isDisabled(date));
                }
            };

            this.createDateObject = function (date, format) {
                var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
                var today = new Date();
                today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                var time = this.compare(date, today);
                var dt = {
                    date: date,
                    label: dateParser.filter(date, format),
                    selected: model && this.compare(date, model) === 0,
                    disabled: this.isDisabled(date),
                    past: time < 0,
                    current: time === 0,
                    future: time > 0,
                    customClass: this.customClass(date) || null
                };

                if (model && this.compare(date, model) === 0) {
                    $scope.selectedDt = dt;
                }

                if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
                    $scope.activeDt = dt;
                }

                return dt;
            };

            this.isDisabled = function (date) {
                return $scope.disabled ||
                    this.minDate && this.compare(date, this.minDate) < 0 ||
                    this.maxDate && this.compare(date, this.maxDate) > 0 ||
                    $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
            };

            this.customClass = function (date) {
                return $scope.customClass({ date: date, mode: $scope.datepickerMode });
            };

            // Split array into smaller arrays
            this.split = function (arr, size) {
                var arrays = [];
                while (arr.length > 0) {
                    arrays.push(arr.splice(0, size));
                }
                return arrays;
            };

            $scope.select = function (date) {
                if ($scope.datepickerMode === self.minMode) {
                    var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
                    dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setViewValue(dt);
                    ngModelCtrl.$render();
                } else {
                    self.activeDate = date;
                    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

                    $scope.$emit('uib:datepicker.mode');
                }

                $scope.$broadcast('uib:datepicker.focus');
            };

            $scope.move = function (direction) {
                var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                    month = self.activeDate.getMonth() + direction * (self.step.months || 0);
                self.activeDate.setFullYear(year, month, 1);
                self.refreshView();
            };

            $scope.toggleMode = function (direction) {
                direction = direction || 1;

                if ($scope.datepickerMode === self.maxMode && direction === 1 ||
                    $scope.datepickerMode === self.minMode && direction === -1) {
                    return;
                }

                setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

                $scope.$emit('uib:datepicker.mode');
            };

            // Key event mapper
            $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

            var focusElement = function () {
                self.element[0].focus();
            };

            // Listen for focus requests from popup directive
            $scope.$on('uib:datepicker.focus', focusElement);

            $scope.keydown = function (evt) {
                var key = $scope.keys[evt.which];

                if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
                    return;
                }

                evt.preventDefault();
                if (!self.shortcutPropagation) {
                    evt.stopPropagation();
                }

                if (key === 'enter' || key === 'space') {
                    if (self.isDisabled(self.activeDate)) {
                        return; // do nothing
                    }
                    $scope.select(self.activeDate);
                } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                    $scope.toggleMode(key === 'up' ? 1 : -1);
                } else {
                    self.handleKeyDown(key, evt);
                    self.refreshView();
                }
            };

            $element.on('keydown', function (evt) {
                $scope.$apply(function () {
                    $scope.keydown(evt);
                });
            });

            $scope.$on('$destroy', function () {
                //Clear all watch listeners on destroy
                while (watchListeners.length) {
                    watchListeners.shift()();
                }
            });

            function setMode(mode) {
                $scope.datepickerMode = mode;
                $scope.datepickerOptions.datepickerMode = mode;
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options ||
                        $scope.datepickerOptions.ngModelOptions ||
                        datepickerConfig.ngModelOptions ||
                        {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
                    var timezone = ngModelCtrl.$options.getOption('timezone') ||
                        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
                        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

                    // values passed to createChild override existing values
                    ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
                        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
                        .createChild($scope.datepickerOptions.ngModelOptions)
                        .createChild(ngModelCtrl.$options) // highest precedence
                        .createChild({ timezone: timezone }); // to keep from squashing a non-null value
                }

                return ngModelOptions;
            }
        }])

    .controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        this.step = { months: 1 };
        this.element = $element;
        function getDaysInMonth(year, month) {
            return month === 1 && year % 4 === 0 &&
                (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
        }

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            scope.showWeeks = ctrl.showWeeks;
            ctrl.refreshView();
        };

        this.getDates = function (startDate, n) {
            var dates = new Array(n), current = new Date(startDate), i = 0, date;
            while (i < n) {
                date = new Date(current);
                dates[i++] = date;
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };

        this._refreshView = function () {
            var year = this.activeDate.getFullYear(),
                month = this.activeDate.getMonth(),
                firstDayOfMonth = new Date(this.activeDate);

            firstDayOfMonth.setFullYear(year, month, 1);

            var difference = this.startingDay - firstDayOfMonth.getDay(),
                numDisplayedFromPreviousMonth = difference > 0 ?
                    7 - difference : -difference,
                firstDate = new Date(firstDayOfMonth);

            if (numDisplayedFromPreviousMonth > 0) {
                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            }

            // 42 is the number of days on a six-week calendar
            var days = this.getDates(firstDate, 42);
            for (var i = 0; i < 42; i++) {
                days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
                    secondary: days[i].getMonth() !== month,
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.labels = new Array(7);
            for (var j = 0; j < 7; j++) {
                scope.labels[j] = {
                    abbr: dateFilter(days[j].date, this.formatDayHeader),
                    full: dateFilter(days[j].date, 'EEEE')
                };
            }

            scope.title = dateFilter(this.activeDate, this.formatDayTitle);
            scope.rows = this.split(days, 7);

            if (scope.showWeeks) {
                scope.weekNumbers = [];
                var thursdayIndex = (4 + 7 - this.startingDay) % 7,
                    numWeeks = scope.rows.length;
                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                    scope.weekNumbers.push(
                        getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
                }
            }
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        function getISO8601WeekNumber(date) {
            var checkDate = new Date(date);
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
            var time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        }

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getDate();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - 7;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + 7;
            } else if (key === 'pageup' || key === 'pagedown') {
                var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setMonth(month, 1);
                date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
            } else if (key === 'home') {
                date = 1;
            } else if (key === 'end') {
                date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
            }
            this.activeDate.setDate(date);
        };
    }])

    .controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        this.step = { years: 1 };
        this.element = $element;

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            ctrl.refreshView();
        };

        this._refreshView = function () {
            var months = new Array(12),
                year = this.activeDate.getFullYear(),
                date;

            for (var i = 0; i < 12; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(year, i, 1);
                months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
            scope.rows = this.split(months, this.monthColumns);
            scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getMonth();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - this.monthColumns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + this.monthColumns;
            } else if (key === 'pageup' || key === 'pagedown') {
                var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setFullYear(year);
            } else if (key === 'home') {
                date = 0;
            } else if (key === 'end') {
                date = 11;
            }
            this.activeDate.setMonth(date);
        };
    }])

    .controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var columns, range;
        this.element = $element;

        function getStartingYear(year) {
            return parseInt((year - 1) / range, 10) * range + 1;
        }

        this.yearpickerInit = function () {
            columns = this.yearColumns;
            range = this.yearRows * columns;
            this.step = { years: range };
        };

        this._refreshView = function () {
            var years = new Array(range), date;

            for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(start + i, 0, 1);
                years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = [years[0].label, years[range - 1].label].join(' - ');
            scope.rows = this.split(years, columns);
            scope.columns = columns;
        };

        this.compare = function (date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getFullYear();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - columns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + columns;
            } else if (key === 'pageup' || key === 'pagedown') {
                date += (key === 'pageup' ? -1 : 1) * range;
            } else if (key === 'home') {
                date = getStartingYear(this.activeDate.getFullYear());
            } else if (key === 'end') {
                date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
            }
            this.activeDate.setFullYear(date);
        };
    }])

    .directive('uibDatepicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
            },
            scope: {
                datepickerOptions: '=?'
            },
            require: ['uibDatepicker', '^ngModel'],
            restrict: 'A',
            controller: 'UibDatepickerController',
            controllerAs: 'datepicker',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                datepickerCtrl.init(ngModelCtrl);
            }
        };
    })

    .directive('uibDaypicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/day.html';
            },
            require: ['^uibDatepicker', 'uibDaypicker'],
            restrict: 'A',
            controller: 'UibDaypickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    daypickerCtrl = ctrls[1];

                daypickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibMonthpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/month.html';
            },
            require: ['^uibDatepicker', 'uibMonthpicker'],
            restrict: 'A',
            controller: 'UibMonthpickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    monthpickerCtrl = ctrls[1];

                monthpickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibYearpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/year.html';
            },
            require: ['^uibDatepicker', 'uibYearpicker'],
            restrict: 'A',
            controller: 'UibYearpickerController',
            link: function (scope, element, attrs, ctrls) {
                var ctrl = ctrls[0];
                angular.extend(ctrl, ctrls[1]);
                ctrl.yearpickerInit();

                ctrl.refreshView();
            }
        };
    });

angular.module('ui.bootstrap.position', [])

    /**
     * A set of utility methods for working with the DOM.
     * It is meant to be used where we need to absolute-position elements in
     * relation to another element (this is the case for tooltips, popovers,
     * typeahead suggestions etc.).
     */
    .factory('$uibPosition', ['$document', '$window', function ($document, $window) {
        /**
         * Used by scrollbarWidth() function to cache scrollbar's width.
         * Do not access this variable directly, use scrollbarWidth() instead.
         */
        var SCROLLBAR_WIDTH;
        /**
         * scrollbar on body and html element in IE and Edge overlay
         * content and should be considered 0 width.
         */
        var BODY_SCROLLBAR_WIDTH;
        var OVERFLOW_REGEX = {
            normal: /(auto|scroll)/,
            hidden: /(auto|scroll|hidden)/
        };
        var PLACEMENT_REGEX = {
            auto: /\s?auto?\s?/i,
            primary: /^(top|bottom|left|right)$/,
            secondary: /^(top|bottom|left|right|center)$/,
            vertical: /^(top|bottom)$/
        };
        var BODY_REGEX = /(HTML|BODY)/;

        return {

            /**
             * Provides a raw DOM element from a jQuery/jQLite element.
             *
             * @param {element} elem - The element to convert.
             *
             * @returns {element} A HTML element.
             */
            getRawNode: function (elem) {
                return elem.nodeName ? elem : elem[0] || elem;
            },

            /**
             * Provides a parsed number for a style property.  Strips
             * units and casts invalid numbers to 0.
             *
             * @param {string} value - The style value to parse.
             *
             * @returns {number} A valid number.
             */
            parseStyle: function (value) {
                value = parseFloat(value);
                return isFinite(value) ? value : 0;
            },

            /**
             * Provides the closest positioned ancestor.
             *
             * @param {element} element - The element to get the offest parent for.
             *
             * @returns {element} The closest positioned ancestor.
             */
            offsetParent: function (elem) {
                elem = this.getRawNode(elem);

                var offsetParent = elem.offsetParent || $document[0].documentElement;

                function isStaticPositioned(el) {
                    return ($window.getComputedStyle(el).position || 'static') === 'static';
                }

                while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || $document[0].documentElement;
            },

            /**
             * Provides the scrollbar width, concept from TWBS measureScrollbar()
             * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
             * In IE and Edge, scollbar on body and html element overlay and should
             * return a width of 0.
             *
             * @returns {number} The width of the browser scollbar.
             */
            scrollbarWidth: function (isBody) {
                if (isBody) {
                    if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
                        var bodyElem = $document.find('body');
                        bodyElem.addClass('uib-position-body-scrollbar-measure');
                        BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
                        BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
                        bodyElem.removeClass('uib-position-body-scrollbar-measure');
                    }
                    return BODY_SCROLLBAR_WIDTH;
                }

                if (angular.isUndefined(SCROLLBAR_WIDTH)) {
                    var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
                    $document.find('body').append(scrollElem);
                    SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
                    SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
                    scrollElem.remove();
                }

                return SCROLLBAR_WIDTH;
            },

            /**
             * Provides the padding required on an element to replace the scrollbar.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**scrollbarWidth**: the width of the scrollbar</li>
             *     <li>**widthOverflow**: whether the the width is overflowing</li>
             *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
             *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
             *     <li>**heightOverflow**: whether the the height is overflowing</li>
             *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
             *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
             *   </ul>
             */
            scrollbarPadding: function (elem) {
                elem = this.getRawNode(elem);

                var elemStyle = $window.getComputedStyle(elem);
                var paddingRight = this.parseStyle(elemStyle.paddingRight);
                var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
                var scrollParent = this.scrollParent(elem, false, true);
                var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

                return {
                    scrollbarWidth: scrollbarWidth,
                    widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
                    right: paddingRight + scrollbarWidth,
                    originalRight: paddingRight,
                    heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
                    bottom: paddingBottom + scrollbarWidth,
                    originalBottom: paddingBottom
                };
            },

            /**
             * Checks to see if the element is scrollable.
             *
             * @param {element} elem - The element to check.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             *
             * @returns {boolean} Whether the element is scrollable.
             */
            isScrollable: function (elem, includeHidden) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var elemStyle = $window.getComputedStyle(elem);
                return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
            },

            /**
             * Provides the closest scrollable ancestor.
             * A port of the jQuery UI scrollParent method:
             * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
             *
             * @param {element} elem - The element to find the scroll parent of.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             * @param {boolean=} [includeSelf=false] - Should the element being passed be
             * included in the scrollable llokup.
             *
             * @returns {element} A HTML element.
             */
            scrollParent: function (elem, includeHidden, includeSelf) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var documentEl = $document[0].documentElement;
                var elemStyle = $window.getComputedStyle(elem);
                if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
                    return elem;
                }
                var excludeStatic = elemStyle.position === 'absolute';
                var scrollParent = elem.parentElement || documentEl;

                if (scrollParent === documentEl || elemStyle.position === 'fixed') {
                    return documentEl;
                }

                while (scrollParent.parentElement && scrollParent !== documentEl) {
                    var spStyle = $window.getComputedStyle(scrollParent);
                    if (excludeStatic && spStyle.position !== 'static') {
                        excludeStatic = false;
                    }

                    if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
                        break;
                    }
                    scrollParent = scrollParent.parentElement;
                }

                return scrollParent;
            },

            /**
             * Provides read-only equivalent of jQuery's position function:
             * https://api.jquery.com/position/ - distance to closest positioned
             * ancestor.  Does not account for margins by default like jQuery position.
             *
             * @param {element} elem - The element to caclulate the position on.
             * @param {boolean=} [includeMargins=false] - Should margins be accounted
             * for, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of offset parent</li>
             *     <li>**left**: distance to left edge of offset parent</li>
             *   </ul>
             */
            position: function (elem, includeMagins) {
                elem = this.getRawNode(elem);

                var elemOffset = this.offset(elem);
                if (includeMagins) {
                    var elemStyle = $window.getComputedStyle(elem);
                    elemOffset.top -= this.parseStyle(elemStyle.marginTop);
                    elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
                }
                var parent = this.offsetParent(elem);
                var parentOffset = { top: 0, left: 0 };

                if (parent !== $document[0].documentElement) {
                    parentOffset = this.offset(parent);
                    parentOffset.top += parent.clientTop - parent.scrollTop;
                    parentOffset.left += parent.clientLeft - parent.scrollLeft;
                }

                return {
                    width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
                    top: Math.round(elemOffset.top - parentOffset.top),
                    left: Math.round(elemOffset.left - parentOffset.left)
                };
            },

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * https://api.jquery.com/offset/ - distance to viewport.  Does
             * not account for borders, margins, or padding on the body
             * element.
             *
             * @param {element} elem - The element to calculate the offset on.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of viewport</li>
             *     <li>**right**: distance to bottom edge of viewport</li>
             *   </ul>
             */
            offset: function (elem) {
                elem = this.getRawNode(elem);

                var elemBCR = elem.getBoundingClientRect();
                return {
                    width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
                    top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
                    left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
                };
            },

            /**
             * Provides offset distance to the closest scrollable ancestor
             * or viewport.  Accounts for border and scrollbar width.
             *
             * Right and bottom dimensions represent the distance to the
             * respective edge of the viewport element.  If the element
             * edge extends beyond the viewport, a negative value will be
             * reported.
             *
             * @param {element} elem - The element to get the viewport offset for.
             * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
             * of the first scrollable element, default is false.
             * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
             * be accounted for, default is true.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: distance to the top content edge of viewport element</li>
             *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
             *     <li>**left**: distance to the left content edge of viewport element</li>
             *     <li>**right**: distance to the right content edge of viewport element</li>
             *   </ul>
             */
            viewportOffset: function (elem, useDocument, includePadding) {
                elem = this.getRawNode(elem);
                includePadding = includePadding !== false ? true : false;

                var elemBCR = elem.getBoundingClientRect();
                var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

                var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
                var offsetParentBCR = offsetParent.getBoundingClientRect();

                offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
                offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
                if (offsetParent === $document[0].documentElement) {
                    offsetBCR.top += $window.pageYOffset;
                    offsetBCR.left += $window.pageXOffset;
                }
                offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
                offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

                if (includePadding) {
                    var offsetParentStyle = $window.getComputedStyle(offsetParent);
                    offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
                    offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
                    offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
                    offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
                }

                return {
                    top: Math.round(elemBCR.top - offsetBCR.top),
                    bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
                    left: Math.round(elemBCR.left - offsetBCR.left),
                    right: Math.round(offsetBCR.right - elemBCR.right)
                };
            },

            /**
             * Provides an array of placement values parsed from a placement string.
             * Along with the 'auto' indicator, supported placement strings are:
             *   <ul>
             *     <li>top: element on top, horizontally centered on host element.</li>
             *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
             *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
             *     <li>bottom: element on bottom, horizontally centered on host element.</li>
             *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
             *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
             *     <li>left: element on left, vertically centered on host element.</li>
             *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
             *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
             *     <li>right: element on right, vertically centered on host element.</li>
             *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
             *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
             *   </ul>
             * A placement string with an 'auto' indicator is expected to be
             * space separated from the placement, i.e: 'auto bottom-left'  If
             * the primary and secondary placement values do not match 'top,
             * bottom, left, right' then 'top' will be the primary placement and
             * 'center' will be the secondary placement.  If 'auto' is passed, true
             * will be returned as the 3rd value of the array.
             *
             * @param {string} placement - The placement string to parse.
             *
             * @returns {array} An array with the following values
             * <ul>
             *   <li>**[0]**: The primary placement.</li>
             *   <li>**[1]**: The secondary placement.</li>
             *   <li>**[2]**: If auto is passed: true, else undefined.</li>
             * </ul>
             */
            parsePlacement: function (placement) {
                var autoPlace = PLACEMENT_REGEX.auto.test(placement);
                if (autoPlace) {
                    placement = placement.replace(PLACEMENT_REGEX.auto, '');
                }

                placement = placement.split('-');

                placement[0] = placement[0] || 'top';
                if (!PLACEMENT_REGEX.primary.test(placement[0])) {
                    placement[0] = 'top';
                }

                placement[1] = placement[1] || 'center';
                if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
                    placement[1] = 'center';
                }

                if (autoPlace) {
                    placement[2] = true;
                } else {
                    placement[2] = false;
                }

                return placement;
            },

            /**
             * Provides coordinates for an element to be positioned relative to
             * another element.  Passing 'auto' as part of the placement parameter
             * will enable smart placement - where the element fits. i.e:
             * 'auto left-top' will check to see if there is enough space to the left
             * of the hostElem to fit the targetElem, if not place right (same for secondary
             * top placement).  Available space is calculated using the viewportOffset
             * function.
             *
             * @param {element} hostElem - The element to position against.
             * @param {element} targetElem - The element to position.
             * @param {string=} [placement=top] - The placement for the targetElem,
             *   default is 'top'. 'center' is assumed as secondary placement for
             *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
             *   <ul>
             *     <li>top</li>
             *     <li>top-right</li>
             *     <li>top-left</li>
             *     <li>bottom</li>
             *     <li>bottom-left</li>
             *     <li>bottom-right</li>
             *     <li>left</li>
             *     <li>left-top</li>
             *     <li>left-bottom</li>
             *     <li>right</li>
             *     <li>right-top</li>
             *     <li>right-bottom</li>
             *   </ul>
             * @param {boolean=} [appendToBody=false] - Should the top and left values returned
             *   be calculated from the body element, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: Value for targetElem top.</li>
             *     <li>**left**: Value for targetElem left.</li>
             *     <li>**placement**: The resolved placement.</li>
             *   </ul>
             */
            positionElements: function (hostElem, targetElem, placement, appendToBody) {
                hostElem = this.getRawNode(hostElem);
                targetElem = this.getRawNode(targetElem);

                // need to read from prop to support tests.
                var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
                var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

                placement = this.parsePlacement(placement);

                var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
                var targetElemPos = { top: 0, left: 0, placement: '' };

                if (placement[2]) {
                    var viewportOffset = this.viewportOffset(hostElem, appendToBody);

                    var targetElemStyle = $window.getComputedStyle(targetElem);
                    var adjustedSize = {
                        width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
                        height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
                    };

                    placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                        placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                            placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                                placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                                    placement[0];

                    placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                        placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                            placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                                placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                                    placement[1];

                    if (placement[1] === 'center') {
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
                            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                                placement[1] = 'left';
                            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                                placement[1] = 'right';
                            }
                        } else {
                            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
                            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                                placement[1] = 'top';
                            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                                placement[1] = 'bottom';
                            }
                        }
                    }
                }

                switch (placement[0]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top - targetHeight;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left - targetWidth;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width;
                        break;
                }

                switch (placement[1]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
                        break;
                    case 'center':
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
                        } else {
                            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
                        }
                        break;
                }

                targetElemPos.top = Math.round(targetElemPos.top);
                targetElemPos.left = Math.round(targetElemPos.left);
                targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

                return targetElemPos;
            },

            /**
             * Provides a way to adjust the top positioning after first
             * render to correctly align element to top after content
             * rendering causes resized element height
             *
             * @param {array} placementClasses - The array of strings of classes
             * element should have.
             * @param {object} containerPosition - The object with container
             * position information
             * @param {number} initialHeight - The initial height for the elem.
             * @param {number} currentHeight - The current height for the elem.
             */
            adjustTop: function (placementClasses, containerPosition, initialHeight, currentHeight) {
                if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
                    return {
                        top: containerPosition.top - currentHeight + 'px'
                    };
                }
            },

            /**
             * Provides a way for positioning tooltip & dropdown
             * arrows when using placement options beyond the standard
             * left, right, top, or bottom.
             *
             * @param {element} elem - The tooltip/dropdown element.
             * @param {string} placement - The placement for the elem.
             */
            positionArrow: function (elem, placement) {
                elem = this.getRawNode(elem);

                var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
                if (!innerElem) {
                    return;
                }

                var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

                var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
                if (!arrowElem) {
                    return;
                }

                var arrowCss = {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                };

                placement = this.parsePlacement(placement);
                if (placement[1] === 'center') {
                    // no adjustment necessary - just reset styles
                    angular.element(arrowElem).css(arrowCss);
                    return;
                }

                var borderProp = 'border-' + placement[0] + '-width';
                var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

                var borderRadiusProp = 'border-';
                if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                    borderRadiusProp += placement[0] + '-' + placement[1];
                } else {
                    borderRadiusProp += placement[1] + '-' + placement[0];
                }
                borderRadiusProp += '-radius';
                var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

                switch (placement[0]) {
                    case 'top':
                        arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'bottom':
                        arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'left':
                        arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'right':
                        arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
                        break;
                }

                arrowCss[placement[1]] = borderRadius;

                angular.element(arrowElem).css(arrowCss);
            }
        };
    }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

    .value('$datepickerPopupLiteralWarning', true)

    .constant('uibDatepickerPopupConfig', {
        altInputFormats: [],
        appendToBody: false,
        clearText: 'Clear',
        closeOnDateSelection: true,
        closeText: 'Done',
        currentText: 'Today',
        datepickerPopup: 'yyyy-MM-dd',
        datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
        datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        onOpenFocus: true,
        showButtonBar: true,
        placement: 'auto bottom-left'
    })

    .controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
        function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
            var cache = {},
                isHtml5DateInput = false;
            var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
                datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
                ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

            this.init = function (_ngModel_) {
                ngModel = _ngModel_;
                ngModelOptions = extractOptions(ngModel);
                closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
                    $scope.$parent.$eval($attrs.closeOnDateSelection) :
                    datepickerPopupConfig.closeOnDateSelection;
                appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
                    $scope.$parent.$eval($attrs.datepickerAppendToBody) :
                    datepickerPopupConfig.appendToBody;
                onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
                    $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
                datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
                    $attrs.datepickerPopupTemplateUrl :
                    datepickerPopupConfig.datepickerPopupTemplateUrl;
                datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
                    $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
                altInputFormats = angular.isDefined($attrs.altInputFormats) ?
                    $scope.$parent.$eval($attrs.altInputFormats) :
                    datepickerPopupConfig.altInputFormats;

                $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
                    $scope.$parent.$eval($attrs.showButtonBar) :
                    datepickerPopupConfig.showButtonBar;

                if (datepickerPopupConfig.html5Types[$attrs.type]) {
                    dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
                    $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
                        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
                        // Invalidate the $modelValue to ensure that formatters re-run
                        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = null;

                            if (!dateFormat) {
                                throw new Error('uibDatepickerPopup must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('uibDatepickerPopup must have a date format specified.');
                }

                if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
                    throw new Error('HTML5 date input types do not support custom formats.');
                }

                // popup element used to display calendar
                popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)',
                    'template-url': datepickerPopupTemplateUrl
                });

                // datepicker element
                datepickerEl = angular.element(popupEl.children()[0]);
                datepickerEl.attr('template-url', datepickerTemplateUrl);

                if (!$scope.datepickerOptions) {
                    $scope.datepickerOptions = {};
                }

                if (isHtml5DateInput) {
                    if ($attrs.type === 'month') {
                        $scope.datepickerOptions.datepickerMode = 'month';
                        $scope.datepickerOptions.minMode = 'month';
                    }
                }

                datepickerEl.attr('datepicker-options', 'datepickerOptions');

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'date';
                    ngModel.$validators.date = validator;
                    ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        if (ngModel.$isEmpty(value)) {
                            $scope.date = value;
                            return value;
                        }

                        if (angular.isNumber(value)) {
                            value = new Date(value);
                        }

                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

                        return dateParser.filter($scope.date, dateFormat);
                    });
                } else {
                    ngModel.$formatters.push(function (value) {
                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
                        return value;
                    });
                }

                // Detect changes in the view from the text box
                ngModel.$viewChangeListeners.push(function () {
                    $scope.date = parseDateString(ngModel.$viewValue);
                });

                $element.on('keydown', inputKeydownBind);

                $popup = $compile(popupEl)($scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    $element.after($popup);
                }

                $scope.$on('$destroy', function () {
                    if ($scope.isOpen === true) {
                        if (!$rootScope.$$phase) {
                            $scope.$apply(function () {
                                $scope.isOpen = false;
                            });
                        }
                    }

                    $popup.remove();
                    $element.off('keydown', inputKeydownBind);
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);

                    //Clear all watch listeners on destroy
                    while (watchListeners.length) {
                        watchListeners.shift()();
                    }
                });
            };

            $scope.getText = function (key) {
                return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
            };

            $scope.isDisabled = function (date) {
                if (date === 'today') {
                    date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
                }

                var dates = {};
                angular.forEach(['minDate', 'maxDate'], function (key) {
                    if (!$scope.datepickerOptions[key]) {
                        dates[key] = null;
                    } else if (angular.isDate($scope.datepickerOptions[key])) {
                        dates[key] = new Date($scope.datepickerOptions[key]);
                    } else {
                        if ($datepickerPopupLiteralWarning) {
                            $log.warn('Literal date support has been deprecated, please switch to date object usage');
                        }

                        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
                    }
                });

                return $scope.datepickerOptions &&
                    dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
                    dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
            };

            $scope.compare = function (date1, date2) {
                return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            };

            // Inner change
            $scope.dateSelection = function (dt) {
                $scope.date = dt;
                var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
                $element.val(date);
                ngModel.$setViewValue(date);

                if (closeOnDateSelection) {
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.keydown = function (evt) {
                if (evt.which === 27) {
                    evt.stopPropagation();
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.select = function (date, evt) {
                evt.stopPropagation();

                if (date === 'today') {
                    var today = new Date();
                    if (angular.isDate($scope.date)) {
                        date = new Date($scope.date);
                        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                    } else {
                        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                        date.setHours(0, 0, 0, 0);
                    }
                }
                $scope.dateSelection(date);
            };

            $scope.close = function (evt) {
                evt.stopPropagation();

                $scope.isOpen = false;
                $element[0].focus();
            };

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if ($attrs.ngDisabled) {
                watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
                    $scope.disabled = disabled;
                }));
            }

            $scope.$watch('isOpen', function (value) {
                if (value) {
                    if (!$scope.disabled) {
                        $timeout(function () {
                            positionPopup();

                            if (onOpenFocus) {
                                $scope.$broadcast('uib:datepicker.focus');
                            }

                            $document.on('click', documentClickBind);

                            var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                            if (appendToBody || $position.parsePlacement(placement)[2]) {
                                scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
                                if (scrollParentEl) {
                                    scrollParentEl.on('scroll', positionPopup);
                                }
                            } else {
                                scrollParentEl = null;
                            }

                            angular.element($window).on('resize', positionPopup);
                        }, 0, false);
                    } else {
                        $scope.isOpen = false;
                    }
                } else {
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);
                }
            });

            function cameltoDash(string) {
                return string.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
            }

            function parseDateString(viewValue) {
                var date = dateParser.parse(viewValue, dateFormat, $scope.date);
                if (isNaN(date)) {
                    for (var i = 0; i < altInputFormats.length; i++) {
                        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
                        if (!isNaN(date)) {
                            return date;
                        }
                    }
                }
                return date;
            }

            function parseDate(viewValue) {
                if (angular.isNumber(viewValue)) {
                    // presumably timestamp to date object
                    viewValue = new Date(viewValue);
                }

                if (!viewValue) {
                    return null;
                }

                if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                    return viewValue;
                }

                if (angular.isString(viewValue)) {
                    var date = parseDateString(viewValue);
                    if (!isNaN(date)) {
                        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
                    }
                }

                return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
            }

            function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;

                if (!$attrs.ngRequired && !value) {
                    return true;
                }

                if (angular.isNumber(value)) {
                    value = new Date(value);
                }

                if (!value) {
                    return true;
                }

                if (angular.isDate(value) && !isNaN(value)) {
                    return true;
                }

                if (angular.isString(value)) {
                    return !isNaN(parseDateString(value));
                }

                return false;
            }

            function documentClickBind(event) {
                if (!$scope.isOpen && $scope.disabled) {
                    return;
                }

                var popup = $popup[0];
                var dpContainsTarget = $element[0].contains(event.target);
                // The popup node may not be an element node
                // In some browsers (IE) only element nodes have the 'contains' function
                var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
                if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                }
            }

            function inputKeydownBind(evt) {
                if (evt.which === 27 && $scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                    $element[0].focus();
                } else if (evt.which === 40 && !$scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = true;
                    });
                }
            }

            function positionPopup() {
                if ($scope.isOpen) {
                    var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
                    var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                    var position = $position.positionElements($element, dpElement, placement, appendToBody);
                    dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
                    if (dpElement.hasClass('uib-position-measure')) {
                        dpElement.removeClass('uib-position-measure');
                    }
                }
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
                        ngModelCtrl.$options :
                        {
                            timezone: null
                        };

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }

            $scope.$on('uib:datepicker.mode', function () {
                $timeout(positionPopup, 0, false);
            });
        }])

    .directive('uibDatepickerPopup', function () {
        return {
            require: ['ngModel', 'uibDatepickerPopup'],
            controller: 'UibDatepickerPopupController',
            scope: {
                datepickerOptions: '=?',
                isOpen: '=?',
                currentText: '@',
                clearText: '@',
                closeText: '@'
            },
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0],
                    ctrl = ctrls[1];

                ctrl.init(ngModel);
            }
        };
    })

    .directive('uibDatepickerPopupWrap', function () {
        return {
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
            }
        };
    });

angular.module('ui.bootstrap.debounce', [])
    /**
     * A helper, internal service that debounces a function
     */
    .factory('$$debounce', ['$timeout', function ($timeout) {
        return function (callback, debounceTime) {
            var timeoutPromise;

            return function () {
                var self = this;
                var args = Array.prototype.slice.call(arguments);
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }

                timeoutPromise = $timeout(function () {
                    callback.apply(self, args);
                }, debounceTime);
            };
        };
    }]);

angular.module('ui.bootstrap.multiMap', [])
    /**
     * A helper, internal data structure that stores all references attached to key
     */
    .factory('$$multiMap', function () {
        return {
            createNew: function () {
                var map = {};

                return {
                    entries: function () {
                        return Object.keys(map).map(function (key) {
                            return {
                                key: key,
                                value: map[key]
                            };
                        });
                    },
                    get: function (key) {
                        return map[key];
                    },
                    hasKey: function (key) {
                        return !!map[key];
                    },
                    keys: function () {
                        return Object.keys(map);
                    },
                    put: function (key, value) {
                        if (!map[key]) {
                            map[key] = [];
                        }

                        map[key].push(value);
                    },
                    remove: function (key, value) {
                        var values = map[key];

                        if (!values) {
                            return;
                        }

                        var idx = values.indexOf(value);

                        if (idx !== -1) {
                            values.splice(idx, 1);
                        }

                        if (!values.length) {
                            delete map[key];
                        }
                    }
                };
            }
        };
    });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

    .constant('uibDropdownConfig', {
        appendToOpenClass: 'uib-dropdown-open',
        openClass: 'open'
    })

    .service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
        var openScope = null;
        var openedContainers = $$multiMap.createNew();

        this.isOnlyOpen = function (dropdownScope, appendTo) {
            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (openDropdown) {
                    return openedDropdowns.length === 1;
                }
            }

            return false;
        };

        this.open = function (dropdownScope, element, appendTo) {
            if (!openScope) {
                $document.on('click', closeDropdown);
            }

            if (openScope && openScope !== dropdownScope) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openedScopes = openedDropdowns.map(function (dropdown) {
                    return dropdown.scope;
                });
                if (openedScopes.indexOf(dropdownScope) === -1) {
                    openedContainers.put(appendTo, {
                        scope: dropdownScope
                    });
                }
            } else {
                openedContainers.put(appendTo, {
                    scope: dropdownScope
                });
            }
        };

        this.close = function (dropdownScope, element, appendTo) {
            if (openScope === dropdownScope) {
                $document.off('click', closeDropdown);
                $document.off('keydown', this.keybindFilter);
                openScope = null;
            }

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (dropdownToClose) {
                    openedContainers.remove(appendTo, dropdownToClose);
                }
            }
        };

        var closeDropdown = function (evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope || !openScope.isOpen) { return; }

            if (evt && openScope.getAutoClose() === 'disabled') { return; }

            if (evt && evt.which === 3) { return; }

            var toggleElement = openScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            if (evt && openScope.getAutoClose() === 'outsideClick' &&
                dropdownElement && dropdownElement[0].contains(evt.target)) {
                return;
            }

            openScope.focusToggleElement();
            openScope.isOpen = false;

            if (!$rootScope.$$phase) {
                openScope.$apply();
            }
        };

        this.keybindFilter = function (evt) {
            if (!openScope) {
                // see this.close as ESC could have been pressed which kills the scope so we can not proceed
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            var toggleElement = openScope.getToggleElement();
            var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
            var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
            if (evt.which === 27) {
                evt.stopPropagation();
                openScope.focusToggleElement();
                closeDropdown();
            } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
                evt.preventDefault();
                evt.stopPropagation();
                openScope.focusDropdownEntry(evt.which);
            }
        };
    }])

    .controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
        var self = this,
            scope = $scope.$new(), // create a child scope so we are not polluting original one
            templateScope,
            appendToOpenClass = dropdownConfig.appendToOpenClass,
            openClass = dropdownConfig.openClass,
            getIsOpen,
            setIsOpen = angular.noop,
            toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
            keynavEnabled = false,
            selectedOption = null,
            body = $document.find('body');

        $element.addClass('dropdown');

        this.init = function () {
            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function (value) {
                    scope.isOpen = !!value;
                });
            }

            keynavEnabled = angular.isDefined($attrs.keyboardNav);
        };

        this.toggle = function (open) {
            scope.isOpen = arguments.length ? !!open : !scope.isOpen;
            if (angular.isFunction(setIsOpen)) {
                setIsOpen(scope, scope.isOpen);
            }

            return scope.isOpen;
        };

        // Allow other directives to watch status
        this.isOpen = function () {
            return scope.isOpen;
        };

        scope.getToggleElement = function () {
            return self.toggleElement;
        };

        scope.getAutoClose = function () {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function () {
            return $element;
        };

        scope.isKeynavEnabled = function () {
            return keynavEnabled;
        };

        scope.focusDropdownEntry = function (keyCode) {
            var elems = self.dropdownMenu ? //If append to body is used.
                angular.element(self.dropdownMenu).find('a') :
                $element.find('ul').eq(0).find('a');

            switch (keyCode) {
                case 40: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = 0;
                    } else {
                        self.selectedOption = self.selectedOption === elems.length - 1 ?
                            self.selectedOption :
                            self.selectedOption + 1;
                    }
                    break;
                }
                case 38: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = elems.length - 1;
                    } else {
                        self.selectedOption = self.selectedOption === 0 ?
                            0 : self.selectedOption - 1;
                    }
                    break;
                }
            }
            elems[self.selectedOption].focus();
        };

        scope.getDropdownElement = function () {
            return self.dropdownMenu;
        };

        scope.focusToggleElement = function () {
            if (self.toggleElement) {
                self.toggleElement[0].focus();
            }
        };

        function removeDropdownMenu() {
            $element.append(self.dropdownMenu);
        }

        scope.$watch('isOpen', function (isOpen, wasOpen) {
            var appendTo = null,
                appendToBody = false;

            if (angular.isDefined($attrs.dropdownAppendTo)) {
                var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
                if (appendToEl) {
                    appendTo = angular.element(appendToEl);
                }
            }

            if (angular.isDefined($attrs.dropdownAppendToBody)) {
                var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
                if (appendToBodyValue !== false) {
                    appendToBody = true;
                }
            }

            if (appendToBody && !appendTo) {
                appendTo = body;
            }

            if (appendTo && self.dropdownMenu) {
                if (isOpen) {
                    appendTo.append(self.dropdownMenu);
                    $element.on('$destroy', removeDropdownMenu);
                } else {
                    $element.off('$destroy', removeDropdownMenu);
                    removeDropdownMenu();
                }
            }

            if (appendTo && self.dropdownMenu) {
                var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
                    css,
                    rightalign,
                    scrollbarPadding,
                    scrollbarWidth = 0;

                css = {
                    top: pos.top + 'px',
                    display: isOpen ? 'block' : 'none'
                };

                rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
                if (!rightalign) {
                    css.left = pos.left + 'px';
                    css.right = 'auto';
                } else {
                    css.left = 'auto';
                    scrollbarPadding = $position.scrollbarPadding(appendTo);

                    if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        scrollbarWidth = scrollbarPadding.scrollbarWidth;
                    }

                    css.right = window.innerWidth - scrollbarWidth -
                        (pos.left + $element.prop('offsetWidth')) + 'px';
                }

                // Need to adjust our positioning to be relative to the appendTo container
                // if it's not the body element
                if (!appendToBody) {
                    var appendOffset = $position.offset(appendTo);

                    css.top = pos.top - appendOffset.top + 'px';

                    if (!rightalign) {
                        css.left = pos.left - appendOffset.left + 'px';
                    } else {
                        css.right = window.innerWidth -
                            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
                    }
                }

                self.dropdownMenu.css(css);
            }

            var openContainer = appendTo ? appendTo : $element;
            var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
            var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
            var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

            if (hasOpenClass === !isOpen) {
                var toggleClass;
                if (appendTo) {
                    toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
                } else {
                    toggleClass = isOpen ? 'addClass' : 'removeClass';
                }
                $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
                    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                        toggleInvoker($scope, { open: !!isOpen });
                    }
                });
            }

            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) {
                    $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
                        templateScope = scope.$new();
                        $compile(tplContent.trim())(templateScope, function (dropdownElement) {
                            var newEl = dropdownElement;
                            self.dropdownMenu.replaceWith(newEl);
                            self.dropdownMenu = newEl;
                            $document.on('keydown', uibDropdownService.keybindFilter);
                        });
                    });
                } else {
                    $document.on('keydown', uibDropdownService.keybindFilter);
                }

                scope.focusToggleElement();
                uibDropdownService.open(scope, $element, appendTo);
            } else {
                uibDropdownService.close(scope, $element, appendTo);
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) {
                        templateScope.$destroy();
                    }
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }

                self.selectedOption = null;
            }

            if (angular.isFunction(setIsOpen)) {
                setIsOpen($scope, isOpen);
            }
        });
    }])

    .directive('uibDropdown', function () {
        return {
            controller: 'UibDropdownController',
            link: function (scope, element, attrs, dropdownCtrl) {
                dropdownCtrl.init();
            }
        };
    })

    .directive('uibDropdownMenu', function () {
        return {
            restrict: 'A',
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
                    return;
                }

                element.addClass('dropdown-menu');

                var tplUrl = attrs.templateUrl;
                if (tplUrl) {
                    dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                }

                if (!dropdownCtrl.dropdownMenu) {
                    dropdownCtrl.dropdownMenu = element;
                }
            }
        };
    })

    .directive('uibDropdownToggle', function () {
        return {
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }

                element.addClass('dropdown-toggle');

                dropdownCtrl.toggleElement = element;

                var toggleDropdown = function (event) {
                    event.preventDefault();

                    if (!element.hasClass('disabled') && !attrs.disabled) {
                        scope.$apply(function () {
                            dropdownCtrl.toggle();
                        });
                    }
                };

                element.on('click', toggleDropdown);

                // WAI-ARIA
                element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function () {
                    element.off('click', toggleDropdown);
                });
            }
        };
    });

angular.module('ui.bootstrap.stackedMap', [])
    /**
     * A helper, internal data structure that acts as a map but also allows getting / removing
     * elements in the LIFO order
     */
    .factory('$$stackedMap', function () {
        return {
            createNew: function () {
                var stack = [];

                return {
                    add: function (key, value) {
                        stack.push({
                            key: key,
                            value: value
                        });
                    },
                    get: function (key) {
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                return stack[i];
                            }
                        }
                    },
                    keys: function () {
                        var keys = [];
                        for (var i = 0; i < stack.length; i++) {
                            keys.push(stack[i].key);
                        }
                        return keys;
                    },
                    top: function () {
                        return stack[stack.length - 1];
                    },
                    remove: function (key) {
                        var idx = -1;
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                idx = i;
                                break;
                            }
                        }
                        return stack.splice(idx, 1)[0];
                    },
                    removeTop: function () {
                        return stack.pop();
                    },
                    length: function () {
                        return stack.length;
                    }
                };
            }
        };
    });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
    /**
     * Pluggable resolve mechanism for the modal resolve resolution
     * Supports UI Router's $resolve service
     */
    .provider('$uibResolve', function () {
        var resolve = this;
        this.resolver = null;

        this.setResolver = function (resolver) {
            this.resolver = resolver;
        };

        this.$get = ['$injector', '$q', function ($injector, $q) {
            var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
            return {
                resolve: function (invocables, locals, parent, self) {
                    if (resolver) {
                        return resolver.resolve(invocables, locals, parent, self);
                    }

                    var promises = [];

                    angular.forEach(invocables, function (value) {
                        if (angular.isFunction(value) || angular.isArray(value)) {
                            promises.push($q.resolve($injector.invoke(value)));
                        } else if (angular.isString(value)) {
                            promises.push($q.resolve($injector.get(value)));
                        } else {
                            promises.push($q.resolve(value));
                        }
                    });

                    return $q.all(promises).then(function (resolves) {
                        var resolveObj = {};
                        var resolveIter = 0;
                        angular.forEach(invocables, function (value, key) {
                            resolveObj[key] = resolves[resolveIter++];
                        });

                        return resolveObj;
                    });
                }
            };
        }];
    })

    /**
     * A helper directive for the $modal service. It creates a backdrop element.
     */
    .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
        function ($animate, $injector, $modalStack) {
            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    tElement.addClass(tAttrs.backdropClass);
                    return linkFn;
                }
            };

            function linkFn(scope, element, attrs) {
                if (attrs.modalInClass) {
                    $animate.addClass(element, attrs.modalInClass);

                    scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                        var done = setIsAsync();
                        if (scope.modalOptions.animation) {
                            $animate.removeClass(element, attrs.modalInClass).then(done);
                        } else {
                            done();
                        }
                    });
                }
            }
        }])

    .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
        function ($modalStack, $q, $animateCss, $document) {
            return {
                scope: {
                    index: '@'
                },
                restrict: 'A',
                transclude: true,
                templateUrl: function (tElement, tAttrs) {
                    return tAttrs.templateUrl || 'uib/template/modal/window.html';
                },
                link: function (scope, element, attrs) {
                    element.addClass(attrs.windowTopClass || '');
                    scope.size = attrs.size;

                    scope.close = function (evt) {
                        var modal = $modalStack.getTop();
                        if (modal && modal.value.backdrop &&
                            modal.value.backdrop !== 'static' &&
                            evt.target === evt.currentTarget) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            $modalStack.dismiss(modal.key, 'backdrop click');
                        }
                    };

                    // moved from template to fix issue #2280
                    element.on('click', scope.close);

                    // This property is only added to the scope for the purpose of detecting when this directive is rendered.
                    // We can detect that by using this property in the template associated with this directive and then use
                    // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
                    scope.$isRendered = true;

                    // Deferred object that will be resolved when this modal is rendered.
                    var modalRenderDeferObj = $q.defer();
                    // Resolve render promise post-digest
                    scope.$$postDigest(function () {
                        modalRenderDeferObj.resolve();
                    });

                    modalRenderDeferObj.promise.then(function () {
                        var animationPromise = null;

                        if (attrs.modalInClass) {
                            animationPromise = $animateCss(element, {
                                addClass: attrs.modalInClass
                            }).start();

                            scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                                var done = setIsAsync();
                                $animateCss(element, {
                                    removeClass: attrs.modalInClass
                                }).start().then(done);
                            });
                        }


                        $q.when(animationPromise).then(function () {
                            // Notify {@link $modalStack} that modal is rendered.
                            var modal = $modalStack.getTop();
                            if (modal) {
                                $modalStack.modalRendered(modal.key);
                            }

                            /**
                             * If something within the freshly-opened modal already has focus (perhaps via a
                             * directive that causes focus) then there's no need to try to focus anything.
                             */
                            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
                                var inputWithAutofocus = element[0].querySelector('[autofocus]');
                                /**
                                 * Auto-focusing of a freshly-opened modal element causes any child elements
                                 * with the autofocus attribute to lose focus. This is an issue on touch
                                 * based devices which will show and then hide the onscreen keyboard.
                                 * Attempts to refocus the autofocus element via JavaScript will not reopen
                                 * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
                                 * the modal element if the modal does not contain an autofocus element.
                                 */
                                if (inputWithAutofocus) {
                                    inputWithAutofocus.focus();
                                } else {
                                    element[0].focus();
                                }
                            }
                        });
                    });
                }
            };
        }])

    .directive('uibModalAnimationClass', function () {
        return {
            compile: function (tElement, tAttrs) {
                if (tAttrs.modalAnimation) {
                    tElement.addClass(tAttrs.uibModalAnimationClass);
                }
            }
        };
    })

    .directive('uibModalTransclude', ['$animate', function ($animate) {
        return {
            link: function (scope, element, attrs, controller, transclude) {
                transclude(scope.$parent, function (clone) {
                    element.empty();
                    $animate.enter(clone, element);
                });
            }
        };
    }])

    .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
        '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
        function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
            var OPENED_MODAL_CLASS = 'modal-open';

            var backdropDomEl, backdropScope;
            var openedWindows = $$stackedMap.createNew();
            var openedClasses = $$multiMap.createNew();
            var $modalStack = {
                NOW_CLOSING_EVENT: 'modal.stack.now-closing'
            };
            var topModalIndex = 0;
            var previousTopOpenedModal = null;
            var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

            //Modal focus behavior
            var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
                'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
                'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
            var scrollbarPadding;
            var SNAKE_CASE_REGEXP = /[A-Z]/g;

            // TODO: extract into common dependency with tooltip
            function snake_case(name) {
                var separator = '-';
                return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
                    return (pos ? separator : '') + letter.toLowerCase();
                });
            }

            function isVisible(element) {
                return !!(element.offsetWidth ||
                    element.offsetHeight ||
                    element.getClientRects().length);
            }

            function backdropIndex() {
                var topBackdropIndex = -1;
                var opened = openedWindows.keys();
                for (var i = 0; i < opened.length; i++) {
                    if (openedWindows.get(opened[i]).value.backdrop) {
                        topBackdropIndex = i;
                    }
                }

                // If any backdrop exist, ensure that it's index is always
                // right below the top modal
                if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
                    topBackdropIndex = topModalIndex;
                }
                return topBackdropIndex;
            }

            $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
                if (backdropScope) {
                    backdropScope.index = newBackdropIndex;
                }
            });

            function removeModalWindow(modalInstance, elementToReceiveFocus) {
                var modalWindow = openedWindows.get(modalInstance).value;
                var appendToElement = modalWindow.appendTo;

                //clean up the stack
                openedWindows.remove(modalInstance);
                previousTopOpenedModal = openedWindows.top();
                if (previousTopOpenedModal) {
                    topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
                }

                removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
                    var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
                    openedClasses.remove(modalBodyClass, modalInstance);
                    var areAnyOpen = openedClasses.hasKey(modalBodyClass);
                    appendToElement.toggleClass(modalBodyClass, areAnyOpen);
                    if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        if (scrollbarPadding.originalRight) {
                            appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
                        } else {
                            appendToElement.css({ paddingRight: '' });
                        }
                        scrollbarPadding = null;
                    }
                    toggleTopWindowClass(true);
                }, modalWindow.closedDeferred);
                checkRemoveBackdrop();

                //move focus to specified element if available, or else to body
                if (elementToReceiveFocus && elementToReceiveFocus.focus) {
                    elementToReceiveFocus.focus();
                } else if (appendToElement.focus) {
                    appendToElement.focus();
                }
            }

            // Add or remove "windowTopClass" from the top window in the stack
            function toggleTopWindowClass(toggleSwitch) {
                var modalWindow;

                if (openedWindows.length() > 0) {
                    modalWindow = openedWindows.top().value;
                    modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
                }
            }

            function checkRemoveBackdrop() {
                //remove backdrop if no longer needed
                if (backdropDomEl && backdropIndex() === -1) {
                    var backdropScopeRef = backdropScope;
                    removeAfterAnimate(backdropDomEl, backdropScope, function () {
                        backdropScopeRef = null;
                    });
                    backdropDomEl = undefined;
                    backdropScope = undefined;
                }
            }

            function removeAfterAnimate(domEl, scope, done, closedDeferred) {
                var asyncDeferred;
                var asyncPromise = null;
                var setIsAsync = function () {
                    if (!asyncDeferred) {
                        asyncDeferred = $q.defer();
                        asyncPromise = asyncDeferred.promise;
                    }

                    return function asyncDone() {
                        asyncDeferred.resolve();
                    };
                };
                scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

                // Note that it's intentional that asyncPromise might be null.
                // That's when setIsAsync has not been called during the
                // NOW_CLOSING_EVENT broadcast.
                return $q.when(asyncPromise).then(afterAnimating);

                function afterAnimating() {
                    if (afterAnimating.done) {
                        return;
                    }
                    afterAnimating.done = true;

                    $animate.leave(domEl).then(function () {
                        if (done) {
                            done();
                        }

                        domEl.remove();
                        if (closedDeferred) {
                            closedDeferred.resolve();
                        }
                    });

                    scope.$destroy();
                }
            }

            $document.on('keydown', keydownListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keydown', keydownListener);
            });

            function keydownListener(evt) {
                if (evt.isDefaultPrevented()) {
                    return evt;
                }

                var modal = openedWindows.top();
                if (modal) {
                    switch (evt.which) {
                        case 27: {
                            if (modal.value.keyboard) {
                                evt.preventDefault();
                                $rootScope.$apply(function () {
                                    $modalStack.dismiss(modal.key, 'escape key press');
                                });
                            }
                            break;
                        }
                        case 9: {
                            var list = $modalStack.loadFocusElementList(modal);
                            var focusChanged = false;
                            if (evt.shiftKey) {
                                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                                    focusChanged = $modalStack.focusLastFocusableElement(list);
                                }
                            } else {
                                if ($modalStack.isFocusInLastItem(evt, list)) {
                                    focusChanged = $modalStack.focusFirstFocusableElement(list);
                                }
                            }

                            if (focusChanged) {
                                evt.preventDefault();
                                evt.stopPropagation();
                            }

                            break;
                        }
                    }
                }
            }

            $modalStack.open = function (modalInstance, modal) {
                var modalOpener = $document[0].activeElement,
                    modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

                toggleTopWindowClass(false);

                // Store the current top first, to determine what index we ought to use
                // for the current top modal
                previousTopOpenedModal = openedWindows.top();

                openedWindows.add(modalInstance, {
                    deferred: modal.deferred,
                    renderDeferred: modal.renderDeferred,
                    closedDeferred: modal.closedDeferred,
                    modalScope: modal.scope,
                    backdrop: modal.backdrop,
                    keyboard: modal.keyboard,
                    openedClass: modal.openedClass,
                    windowTopClass: modal.windowTopClass,
                    animation: modal.animation,
                    appendTo: modal.appendTo
                });

                openedClasses.put(modalBodyClass, modalInstance);

                var appendToElement = modal.appendTo,
                    currBackdropIndex = backdropIndex();

                if (currBackdropIndex >= 0 && !backdropDomEl) {
                    backdropScope = $rootScope.$new(true);
                    backdropScope.modalOptions = modal;
                    backdropScope.index = currBackdropIndex;
                    backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
                    backdropDomEl.attr({
                        'class': 'modal-backdrop',
                        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
                        'uib-modal-animation-class': 'fade',
                        'modal-in-class': 'in'
                    });
                    if (modal.backdropClass) {
                        backdropDomEl.addClass(modal.backdropClass);
                    }

                    if (modal.animation) {
                        backdropDomEl.attr('modal-animation', 'true');
                    }
                    $compile(backdropDomEl)(backdropScope);
                    $animate.enter(backdropDomEl, appendToElement);
                    if ($uibPosition.isScrollable(appendToElement)) {
                        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
                        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                            appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
                        }
                    }
                }

                var content;
                if (modal.component) {
                    content = document.createElement(snake_case(modal.component.name));
                    content = angular.element(content);
                    content.attr({
                        resolve: '$resolve',
                        'modal-instance': '$uibModalInstance',
                        close: '$close($value)',
                        dismiss: '$dismiss($value)'
                    });
                } else {
                    content = modal.content;
                }

                // Set the top modal index based on the index of the previous top modal
                topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
                var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
                angularDomEl.attr({
                    'class': 'modal',
                    'template-url': modal.windowTemplateUrl,
                    'window-top-class': modal.windowTopClass,
                    'role': 'dialog',
                    'aria-labelledby': modal.ariaLabelledBy,
                    'aria-describedby': modal.ariaDescribedBy,
                    'size': modal.size,
                    'index': topModalIndex,
                    'animate': 'animate',
                    'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
                    'tabindex': -1,
                    'uib-modal-animation-class': 'fade',
                    'modal-in-class': 'in'
                }).append(content);
                if (modal.windowClass) {
                    angularDomEl.addClass(modal.windowClass);
                }

                if (modal.animation) {
                    angularDomEl.attr('modal-animation', 'true');
                }

                appendToElement.addClass(modalBodyClass);
                if (modal.scope) {
                    // we need to explicitly add the modal index to the modal scope
                    // because it is needed by ngStyle to compute the zIndex property.
                    modal.scope.$$topModalIndex = topModalIndex;
                }
                $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

                openedWindows.top().value.modalDomEl = angularDomEl;
                openedWindows.top().value.modalOpener = modalOpener;

                applyAriaHidden(angularDomEl);

                function applyAriaHidden(el) {
                    if (!el || el[0].tagName === 'BODY') {
                        return;
                    }

                    getSiblings(el).forEach(function (sibling) {
                        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
                            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

                        if (!ariaHiddenCount) {
                            ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
                        }

                        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
                        sibling.setAttribute('aria-hidden', 'true');
                    });

                    return applyAriaHidden(el.parent());

                    function getSiblings(el) {
                        var children = el.parent() ? el.parent().children() : [];

                        return Array.prototype.filter.call(children, function (child) {
                            return child !== el[0];
                        });
                    }
                }
            };

            function broadcastClosing(modalWindow, resultOrReason, closing) {
                return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
            }

            function unhideBackgroundElements() {
                Array.prototype.forEach.call(
                    document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
                    function (hiddenEl) {
                        var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
                            newHiddenCount = ariaHiddenCount - 1;
                        hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

                        if (!newHiddenCount) {
                            hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
                            hiddenEl.removeAttribute('aria-hidden');
                        }
                    }
                );
            }

            $modalStack.close = function (modalInstance, result) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, result, true)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.resolve(result);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }

                return !modalWindow;
            };

            $modalStack.dismiss = function (modalInstance, reason) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.reject(reason);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }
                return !modalWindow;
            };

            $modalStack.dismissAll = function (reason) {
                var topModal = this.getTop();
                while (topModal && this.dismiss(topModal.key, reason)) {
                    topModal = this.getTop();
                }
            };

            $modalStack.getTop = function () {
                return openedWindows.top();
            };

            $modalStack.modalRendered = function (modalInstance) {
                var modalWindow = openedWindows.get(modalInstance);
                if (modalWindow) {
                    modalWindow.value.renderDeferred.resolve();
                }
            };

            $modalStack.focusFirstFocusableElement = function (list) {
                if (list.length > 0) {
                    list[0].focus();
                    return true;
                }
                return false;
            };

            $modalStack.focusLastFocusableElement = function (list) {
                if (list.length > 0) {
                    list[list.length - 1].focus();
                    return true;
                }
                return false;
            };

            $modalStack.isModalFocused = function (evt, modalWindow) {
                if (evt && modalWindow) {
                    var modalDomEl = modalWindow.value.modalDomEl;
                    if (modalDomEl && modalDomEl.length) {
                        return (evt.target || evt.srcElement) === modalDomEl[0];
                    }
                }
                return false;
            };

            $modalStack.isFocusInFirstItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[0];
                }
                return false;
            };

            $modalStack.isFocusInLastItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[list.length - 1];
                }
                return false;
            };

            $modalStack.loadFocusElementList = function (modalWindow) {
                if (modalWindow) {
                    var modalDomE1 = modalWindow.value.modalDomEl;
                    if (modalDomE1 && modalDomE1.length) {
                        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
                        return elements ?
                            Array.prototype.filter.call(elements, function (element) {
                                return isVisible(element);
                            }) : elements;
                    }
                }
            };

            return $modalStack;
        }])

    .provider('$uibModal', function () {
        var $modalProvider = {
            options: {
                animation: true,
                backdrop: true, //can also be false or 'static'
                keyboard: true
            },
            $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
                function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
                    var $modal = {};

                    function getTemplatePromise(options) {
                        return options.template ? $q.when(options.template) :
                            $templateRequest(angular.isFunction(options.templateUrl) ?
                                options.templateUrl() : options.templateUrl);
                    }

                    var promiseChain = null;
                    $modal.getPromiseChain = function () {
                        return promiseChain;
                    };

                    $modal.open = function (modalOptions) {
                        var modalResultDeferred = $q.defer();
                        var modalOpenedDeferred = $q.defer();
                        var modalClosedDeferred = $q.defer();
                        var modalRenderDeferred = $q.defer();

                        //prepare an instance of a modal to be injected into controllers and returned to a caller
                        var modalInstance = {
                            result: modalResultDeferred.promise,
                            opened: modalOpenedDeferred.promise,
                            closed: modalClosedDeferred.promise,
                            rendered: modalRenderDeferred.promise,
                            close: function (result) {
                                return $modalStack.close(modalInstance, result);
                            },
                            dismiss: function (reason) {
                                return $modalStack.dismiss(modalInstance, reason);
                            }
                        };

                        //merge and clean up options
                        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                        modalOptions.resolve = modalOptions.resolve || {};
                        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

                        if (!modalOptions.appendTo.length) {
                            throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
                        }

                        //verify options
                        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
                            throw new Error('One of component or template or templateUrl options is required.');
                        }

                        var templateAndResolvePromise;
                        if (modalOptions.component) {
                            templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
                        } else {
                            templateAndResolvePromise =
                                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
                        }

                        function resolveWithTemplate() {
                            return templateAndResolvePromise;
                        }

                        // Wait for the resolution of the existing promise chain.
                        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                        // Then add to $modalStack and resolve opened.
                        // Finally clean up the chain variable if no subsequent modal has overwritten it.
                        var samePromise;
                        samePromise = promiseChain = $q.all([promiseChain])
                            .then(resolveWithTemplate, resolveWithTemplate)
                            .then(function resolveSuccess(tplAndVars) {
                                var providedScope = modalOptions.scope || $rootScope;

                                var modalScope = providedScope.$new();
                                modalScope.$close = modalInstance.close;
                                modalScope.$dismiss = modalInstance.dismiss;

                                modalScope.$on('$destroy', function () {
                                    if (!modalScope.$$uibDestructionScheduled) {
                                        modalScope.$dismiss('$uibUnscheduledDestruction');
                                    }
                                });

                                var modal = {
                                    scope: modalScope,
                                    deferred: modalResultDeferred,
                                    renderDeferred: modalRenderDeferred,
                                    closedDeferred: modalClosedDeferred,
                                    animation: modalOptions.animation,
                                    backdrop: modalOptions.backdrop,
                                    keyboard: modalOptions.keyboard,
                                    backdropClass: modalOptions.backdropClass,
                                    windowTopClass: modalOptions.windowTopClass,
                                    windowClass: modalOptions.windowClass,
                                    windowTemplateUrl: modalOptions.windowTemplateUrl,
                                    ariaLabelledBy: modalOptions.ariaLabelledBy,
                                    ariaDescribedBy: modalOptions.ariaDescribedBy,
                                    size: modalOptions.size,
                                    openedClass: modalOptions.openedClass,
                                    appendTo: modalOptions.appendTo
                                };

                                var component = {};
                                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                                if (modalOptions.component) {
                                    constructLocals(component, false, true, false);
                                    component.name = modalOptions.component;
                                    modal.component = component;
                                } else if (modalOptions.controller) {
                                    constructLocals(ctrlLocals, true, false, true);

                                    // the third param will make the controller instantiate later,private api
                                    // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                                    ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                                    if (modalOptions.controllerAs && modalOptions.bindToController) {
                                        ctrlInstance = ctrlInstantiate.instance;
                                        ctrlInstance.$close = modalScope.$close;
                                        ctrlInstance.$dismiss = modalScope.$dismiss;
                                        angular.extend(ctrlInstance, {
                                            $resolve: ctrlLocals.$scope.$resolve
                                        }, providedScope);
                                    }

                                    ctrlInstance = ctrlInstantiate();

                                    if (angular.isFunction(ctrlInstance.$onInit)) {
                                        ctrlInstance.$onInit();
                                    }
                                }

                                if (!modalOptions.component) {
                                    modal.content = tplAndVars[0];
                                }

                                $modalStack.open(modalInstance, modal);
                                modalOpenedDeferred.resolve(true);

                                function constructLocals(obj, template, instanceOnScope, injectable) {
                                    obj.$scope = modalScope;
                                    obj.$scope.$resolve = {};
                                    if (instanceOnScope) {
                                        obj.$scope.$uibModalInstance = modalInstance;
                                    } else {
                                        obj.$uibModalInstance = modalInstance;
                                    }

                                    var resolves = template ? tplAndVars[1] : tplAndVars;
                                    angular.forEach(resolves, function (value, key) {
                                        if (injectable) {
                                            obj[key] = value;
                                        }

                                        obj.$scope.$resolve[key] = value;
                                    });
                                }
                            }, function resolveError(reason) {
                                modalOpenedDeferred.reject(reason);
                                modalResultDeferred.reject(reason);
                            })['finally'](function () {
                                if (promiseChain === samePromise) {
                                    promiseChain = null;
                                }
                            });

                        return modalInstance;
                    };

                    return $modal;
                }
            ]
        };

        return $modalProvider;
    });

angular.module('ui.bootstrap.paging', [])
    /**
     * Helper internal service for generating common controller code between the
     * pager and pagination components
     */
    .factory('uibPaging', ['$parse', function ($parse) {
        return {
            create: function (ctrl, $scope, $attrs) {
                ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
                ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
                ctrl._watchers = [];

                ctrl.init = function (ngModelCtrl, config) {
                    ctrl.ngModelCtrl = ngModelCtrl;
                    ctrl.config = config;

                    ngModelCtrl.$render = function () {
                        ctrl.render();
                    };

                    if ($attrs.itemsPerPage) {
                        ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
                            ctrl.itemsPerPage = parseInt(value, 10);
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }));
                    } else {
                        ctrl.itemsPerPage = config.itemsPerPage;
                    }

                    $scope.$watch('totalItems', function (newTotal, oldTotal) {
                        if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }
                    });
                };

                ctrl.calculateTotalPages = function () {
                    var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
                    return Math.max(totalPages || 0, 1);
                };

                ctrl.render = function () {
                    $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
                };

                $scope.selectPage = function (page, evt) {
                    if (evt) {
                        evt.preventDefault();
                    }

                    var clickAllowed = !$scope.ngDisabled || !evt;
                    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                        if (evt && evt.target) {
                            evt.target.blur();
                        }
                        ctrl.ngModelCtrl.$setViewValue(page);
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.getText = function (key) {
                    return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
                };

                $scope.noPrevious = function () {
                    return $scope.page === 1;
                };

                $scope.noNext = function () {
                    return $scope.page === $scope.totalPages;
                };

                ctrl.updatePage = function () {
                    ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

                    if ($scope.page > $scope.totalPages) {
                        $scope.selectPage($scope.totalPages);
                    } else {
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.$on('$destroy', function () {
                    while (ctrl._watchers.length) {
                        ctrl._watchers.shift()();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

    .controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
        $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

        uibPaging.create(this, $scope, $attrs);
    }])

    .constant('uibPagerConfig', {
        itemsPerPage: 10,
        previousText: 'Â« Previous',
        nextText: 'Next Â»',
        align: true
    })

    .directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
        return {
            scope: {
                totalItems: '=',
                previousText: '@',
                nextText: '@',
                ngDisabled: '='
            },
            require: ['uibPager', '?ngModel'],
            restrict: 'A',
            controller: 'UibPagerController',
            controllerAs: 'pager',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pager/pager.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pager');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPagerConfig);
            }
        };
    }]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
    .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
        var ctrl = this;
        // Setup configuration parameters
        var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
            rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
            forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
            boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
            pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) { return $scope.$parent.$eval($attrs.pageLabel, { $page: idx }); } : angular.identity;
        $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
        $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
        $attrs.$set('role', 'menu');

        uibPaging.create(this, $scope, $attrs);

        if ($attrs.maxSize) {
            ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
                maxSize = parseInt(value, 10);
                ctrl.render();
            }));
        }

        // Create page object used in template
        function makePage(number, text, isActive) {
            return {
                number: number,
                text: text,
                active: isActive
            };
        }

        function getPages(currentPage, totalPages) {
            var pages = [];

            // Default page limits
            var startPage = 1, endPage = totalPages;
            var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

            // recompute if maxSize
            if (isMaxSized) {
                if (rotate) {
                    // Current page is displayed in the middle of the visible ones
                    startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                    endPage = startPage + maxSize - 1;

                    // Adjust if limit is exceeded
                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = endPage - maxSize + 1;
                    }
                } else {
                    // Visible pages are paginated with maxSize
                    startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

                    // Adjust last page if limit is exceeded
                    endPage = Math.min(startPage + maxSize - 1, totalPages);
                }
            }

            // Add page number links
            for (var number = startPage; number <= endPage; number++) {
                var page = makePage(number, pageLabel(number), number === currentPage);
                pages.push(page);
            }

            // Add links to move between page sets
            if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
                if (startPage > 1) {
                    if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
                        var previousPageSet = makePage(startPage - 1, '...', false);
                        pages.unshift(previousPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
                            var secondPageLink = makePage(2, '2', false);
                            pages.unshift(secondPageLink);
                        }
                        //add the first page
                        var firstPageLink = makePage(1, '1', false);
                        pages.unshift(firstPageLink);
                    }
                }

                if (endPage < totalPages) {
                    if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
                        var nextPageSet = makePage(endPage + 1, '...', false);
                        pages.push(nextPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
                            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
                            pages.push(secondToLastPageLink);
                        }
                        //add the last page
                        var lastPageLink = makePage(totalPages, totalPages, false);
                        pages.push(lastPageLink);
                    }
                }
            }
            return pages;
        }

        var originalRender = this.render;
        this.render = function () {
            originalRender();
            if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
                $scope.pages = getPages($scope.page, $scope.totalPages);
            }
        };
    }])

    .constant('uibPaginationConfig', {
        itemsPerPage: 10,
        boundaryLinks: false,
        boundaryLinkNumbers: false,
        directionLinks: true,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: true,
        forceEllipses: false
    })

    .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
        return {
            scope: {
                totalItems: '=',
                firstText: '@',
                previousText: '@',
                nextText: '@',
                lastText: '@',
                ngDisabled: '='
            },
            require: ['uibPagination', '?ngModel'],
            restrict: 'A',
            controller: 'UibPaginationController',
            controllerAs: 'pagination',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pagination/pagination.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pagination');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
            }
        };
    }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

    /**
     * The $tooltip service creates tooltip- and popover-like directives as well as
     * houses global options for them.
     */
    .provider('$uibTooltip', function () {
        // The default options tooltip and popover.
        var defaultOptions = {
            placement: 'top',
            placementClassPrefix: '',
            animation: true,
            popupDelay: 0,
            popupCloseDelay: 0,
            useContentExp: false
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'outsideClick': 'outsideClick',
            'focus': 'blur',
            'none': ''
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * `options({})` allows global configuration of all tooltips in the
         * application.
         *
         *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
         *     // place tooltips left instead of top by default
         *     $tooltipProvider.options( { placement: 'left' } );
         *   });
         */
        this.options = function (value) {
            angular.extend(globalOptions, value);
        };

        /**
         * This allows you to extend the set of trigger mappings available. E.g.:
         *
         *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
         */
        this.setTriggers = function setTriggers(triggers) {
            angular.extend(triggerMap, triggers);
        };

        /**
         * This is a helper function for translating camel-case to snake_case.
         */
        function snake_case(name) {
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function (letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /**
         * Returns the actual instance of the $tooltip service.
         * TODO support multiple triggers
         */
        this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
            var openedTooltips = $$stackedMap.createNew();
            $document.on('keyup', keypressListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keyup', keypressListener);
            });

            function keypressListener(e) {
                if (e.which === 27) {
                    var last = openedTooltips.top();
                    if (last) {
                        last.value.close();
                        last = null;
                    }
                }
            }

            return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
                options = angular.extend({}, defaultOptions, globalOptions, options);

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers(trigger) {
                    var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
                    var hide = show.map(function (trigger) {
                        return triggerMap[trigger] || trigger;
                    });
                    return {
                        show: show,
                        hide: hide
                    };
                }

                var directiveName = snake_case(ttType);

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<div ' + directiveName + '-popup ' +
                    'uib-title="' + startSym + 'title' + endSym + '" ' +
                    (options.useContentExp ?
                        'content-exp="contentExp()" ' :
                        'content="' + startSym + 'content' + endSym + '" ') +
                    'origin-scope="origScope" ' +
                    'class="uib-position-measure ' + prefix + '" ' +
                    'tooltip-animation-class="fade"' +
                    'uib-tooltip-classes ' +
                    'ng-class="{ in: isOpen }" ' +
                    '>' +
                    '</div>';

                return {
                    compile: function (tElem, tAttrs) {
                        var tooltipLinker = $compile(template);

                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var showTimeout;
                            var hideTimeout;
                            var positionTimeout;
                            var adjustmentTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
                            var ttScope = scope.$new(true);
                            var repositionScheduled = false;
                            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
                            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
                            var observers = [];
                            var lastPlacement;

                            var positionTooltip = function () {
                                // check if tooltip exists and is not empty
                                if (!tooltip || !tooltip.html()) { return; }

                                if (!positionTimeout) {
                                    positionTimeout = $timeout(function () {
                                        var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                        var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                        var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                                        tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                                        var placementClasses = ttPosition.placement.split('-');

                                        if (!tooltip.hasClass(placementClasses[0])) {
                                            tooltip.removeClass(lastPlacement.split('-')[0]);
                                            tooltip.addClass(placementClasses[0]);
                                        }

                                        if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                                            tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                                            tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                                        }

                                        adjustmentTimeout = $timeout(function () {
                                            var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                            var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                                            if (adjustment) {
                                                tooltip.css(adjustment);
                                            }
                                            adjustmentTimeout = null;
                                        }, 0, false);

                                        // first time through tt element will have the
                                        // uib-position-measure class or if the placement
                                        // has changed we need to position the arrow.
                                        if (tooltip.hasClass('uib-position-measure')) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                            tooltip.removeClass('uib-position-measure');
                                        } else if (lastPlacement !== ttPosition.placement) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                        }
                                        lastPlacement = ttPosition.placement;

                                        positionTimeout = null;
                                    }, 0, false);
                                }
                            };

                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;

                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;

                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) {
                                    showTooltipBind();
                                } else {
                                    hideTooltipBind();
                                }
                            }

                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                    return;
                                }

                                cancelHide();
                                prepareTooltip();

                                if (ttScope.popupDelay) {
                                    // Do nothing if the tooltip was already scheduled to pop-up.
                                    // This happens if show is triggered multiple times before any hide is triggered.
                                    if (!showTimeout) {
                                        showTimeout = $timeout(show, ttScope.popupDelay, false);
                                    }
                                } else {
                                    show();
                                }
                            }

                            function hideTooltipBind() {
                                cancelShow();

                                if (ttScope.popupCloseDelay) {
                                    if (!hideTimeout) {
                                        hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                                    }
                                } else {
                                    hide();
                                }
                            }

                            // Show the tooltip popup element.
                            function show() {
                                cancelShow();
                                cancelHide();

                                // Don't show empty tooltips.
                                if (!ttScope.content) {
                                    return angular.noop;
                                }

                                createTooltip();

                                // And show the tooltip.
                                ttScope.$evalAsync(function () {
                                    ttScope.isOpen = true;
                                    assignIsOpen(true);
                                    positionTooltip();
                                });
                            }

                            function cancelShow() {
                                if (showTimeout) {
                                    $timeout.cancel(showTimeout);
                                    showTimeout = null;
                                }

                                if (positionTimeout) {
                                    $timeout.cancel(positionTimeout);
                                    positionTimeout = null;
                                }
                            }

                            // Hide the tooltip popup element.
                            function hide() {
                                if (!ttScope) {
                                    return;
                                }

                                // First things first: we don't show it anymore.
                                ttScope.$evalAsync(function () {
                                    if (ttScope) {
                                        ttScope.isOpen = false;
                                        assignIsOpen(false);
                                        // And now we remove it from the DOM. However, if we have animation, we
                                        // need to wait for it to expire beforehand.
                                        // FIXME: this is a placeholder for a port of the transitions library.
                                        // The fade transition in TWBS is 150ms.
                                        if (ttScope.animation) {
                                            if (!transitionTimeout) {
                                                transitionTimeout = $timeout(removeTooltip, 150, false);
                                            }
                                        } else {
                                            removeTooltip();
                                        }
                                    }
                                });
                            }

                            function cancelHide() {
                                if (hideTimeout) {
                                    $timeout.cancel(hideTimeout);
                                    hideTimeout = null;
                                }

                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }
                            }

                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) {
                                    return;
                                }

                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                                    if (appendToBody) {
                                        $document.find('body').append(tooltip);
                                    } else {
                                        element.after(tooltip);
                                    }
                                });

                                openedTooltips.add(ttScope, {
                                    close: hide
                                });

                                prepObservers();
                            }

                            function removeTooltip() {
                                cancelShow();
                                cancelHide();
                                unregisterObservers();

                                if (tooltip) {
                                    tooltip.remove();

                                    tooltip = null;
                                    if (adjustmentTimeout) {
                                        $timeout.cancel(adjustmentTimeout);
                                    }
                                }

                                openedTooltips.remove(ttScope);

                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }

                            /**
                             * Set the initial scope values. Once
                             * the tooltip is created, the observers
                             * will be added to keep things in sync.
                             */
                            function prepareTooltip() {
                                ttScope.title = attrs[prefix + 'Title'];
                                if (contentParse) {
                                    ttScope.content = contentParse(scope);
                                } else {
                                    ttScope.content = attrs[ttType];
                                }

                                ttScope.popupClass = attrs[prefix + 'Class'];
                                ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
                                var placement = $position.parsePlacement(ttScope.placement);
                                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

                                var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
                                var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
                            }

                            function assignIsOpen(isOpen) {
                                if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                                    isOpenParse.assign(scope, isOpen);
                                }
                            }

                            ttScope.contentExp = function () {
                                return ttScope.content;
                            };

                            /**
                             * Observe the relevant attributes.
                             */
                            attrs.$observe('disabled', function (val) {
                                if (val) {
                                    cancelShow();
                                }

                                if (val && ttScope.isOpen) {
                                    hide();
                                }
                            });

                            if (isOpenParse) {
                                scope.$watch(isOpenParse, function (val) {
                                    if (ttScope && !val === ttScope.isOpen) {
                                        toggleTooltipBind();
                                    }
                                });
                            }

                            function prepObservers() {
                                observers.length = 0;

                                if (contentParse) {
                                    observers.push(
                                        scope.$watch(contentParse, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            }
                                        })
                                    );

                                    observers.push(
                                        tooltipLinkedScope.$watch(function () {
                                            if (!repositionScheduled) {
                                                repositionScheduled = true;
                                                tooltipLinkedScope.$$postDigest(function () {
                                                    repositionScheduled = false;
                                                    if (ttScope && ttScope.isOpen) {
                                                        positionTooltip();
                                                    }
                                                });
                                            }
                                        })
                                    );
                                } else {
                                    observers.push(
                                        attrs.$observe(ttType, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            } else {
                                                positionTooltip();
                                            }
                                        })
                                    );
                                }

                                observers.push(
                                    attrs.$observe(prefix + 'Title', function (val) {
                                        ttScope.title = val;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );

                                observers.push(
                                    attrs.$observe(prefix + 'Placement', function (val) {
                                        ttScope.placement = val ? val : options.placement;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );
                            }

                            function unregisterObservers() {
                                if (observers.length) {
                                    angular.forEach(observers, function (observer) {
                                        observer();
                                    });
                                    observers.length = 0;
                                }
                            }

                            // hide tooltips/popovers for outsideClick trigger
                            function bodyHideTooltipBind(e) {
                                if (!ttScope || !ttScope.isOpen || !tooltip) {
                                    return;
                                }
                                // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
                                if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                                    hideTooltipBind();
                                }
                            }

                            // KeyboardEvent handler to hide the tooltip on Escape key press
                            function hideOnEscapeKey(e) {
                                if (e.which === 27) {
                                    hideTooltipBind();
                                }
                            }

                            var unregisterTriggers = function () {
                                triggers.show.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        element.off('click', toggleTooltipBind);
                                    } else {
                                        element.off(trigger, showTooltipBind);
                                        element.off(trigger, toggleTooltipBind);
                                    }
                                    element.off('keypress', hideOnEscapeKey);
                                });
                                triggers.hide.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        $document.off('click', bodyHideTooltipBind);
                                    } else {
                                        element.off(trigger, hideTooltipBind);
                                    }
                                });
                            };

                            function prepTriggers() {
                                var showTriggers = [], hideTriggers = [];
                                var val = scope.$eval(attrs[prefix + 'Trigger']);
                                unregisterTriggers();

                                if (angular.isObject(val)) {
                                    Object.keys(val).forEach(function (key) {
                                        showTriggers.push(key);
                                        hideTriggers.push(val[key]);
                                    });
                                    triggers = {
                                        show: showTriggers,
                                        hide: hideTriggers
                                    };
                                } else {
                                    triggers = getTriggers(val);
                                }

                                if (triggers.show !== 'none') {
                                    triggers.show.forEach(function (trigger, idx) {
                                        if (trigger === 'outsideClick') {
                                            element.on('click', toggleTooltipBind);
                                            $document.on('click', bodyHideTooltipBind);
                                        } else if (trigger === triggers.hide[idx]) {
                                            element.on(trigger, toggleTooltipBind);
                                        } else if (trigger) {
                                            element.on(trigger, showTooltipBind);
                                            element.on(triggers.hide[idx], hideTooltipBind);
                                        }
                                        element.on('keypress', hideOnEscapeKey);
                                    });
                                }
                            }

                            prepTriggers();

                            var animation = scope.$eval(attrs[prefix + 'Animation']);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

                            var appendToBodyVal;
                            var appendKey = prefix + 'AppendToBody';
                            if (appendKey in attrs && attrs[appendKey] === undefined) {
                                appendToBodyVal = true;
                            } else {
                                appendToBodyVal = scope.$eval(attrs[appendKey]);
                            }

                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

                            // Make sure tooltip is destroyed and removed.
                            scope.$on('$destroy', function onDestroyTooltip() {
                                unregisterTriggers();
                                removeTooltip();
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }];
    })

    // This is mostly ngInclude code but with a custom scope
    .directive('uibTooltipTemplateTransclude', [
        '$animate', '$sce', '$compile', '$templateRequest',
        function ($animate, $sce, $compile, $templateRequest) {
            return {
                link: function (scope, elem, attrs) {
                    var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

                    var changeCounter = 0,
                        currentScope,
                        previousElement,
                        currentElement;

                    var cleanupLastIncludeContent = function () {
                        if (previousElement) {
                            previousElement.remove();
                            previousElement = null;
                        }

                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }

                        if (currentElement) {
                            $animate.leave(currentElement).then(function () {
                                previousElement = null;
                            });
                            previousElement = currentElement;
                            currentElement = null;
                        }
                    };

                    scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
                        var thisChangeId = ++changeCounter;

                        if (src) {
                            //set the 2nd param to true to ignore the template request error so that the inner
                            //contents and scope can be cleaned up.
                            $templateRequest(src, true).then(function (response) {
                                if (thisChangeId !== changeCounter) { return; }
                                var newScope = origScope.$new();
                                var template = response;

                                var clone = $compile(template)(newScope, function (clone) {
                                    cleanupLastIncludeContent();
                                    $animate.enter(clone, elem);
                                });

                                currentScope = newScope;
                                currentElement = clone;

                                currentScope.$emit('$includeContentLoaded', src);
                            }, function () {
                                if (thisChangeId === changeCounter) {
                                    cleanupLastIncludeContent();
                                    scope.$emit('$includeContentError', src);
                                }
                            });
                            scope.$emit('$includeContentRequested', src);
                        } else {
                            cleanupLastIncludeContent();
                        }
                    });

                    scope.$on('$destroy', cleanupLastIncludeContent);
                }
            };
        }])

    /**
     * Note that it's intentional that these classes are *not* applied through $animate.
     * They must not be animated as they're expected to be present on the tooltip on
     * initialization.
     */
    .directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                // need to set the primary position so the
                // arrow has space during position measure.
                // tooltip.positionTooltip()
                if (scope.placement) {
                    // // There are no top-left etc... classes
                    // // in TWBS, so we need the primary position.
                    var position = $uibPosition.parsePlacement(scope.placement);
                    element.addClass(position[0]);
                }

                if (scope.popupClass) {
                    element.addClass(scope.popupClass);
                }

                if (scope.animation) {
                    element.addClass(attrs.tooltipAnimationClass);
                }
            }
        };
    }])

    .directive('uibTooltipPopup', function () {
        return {
            restrict: 'A',
            scope: { content: '@' },
            templateUrl: 'uib/template/tooltip/tooltip-popup.html'
        };
    })

    .directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
    }])

    .directive('uibTooltipTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
        };
    })

    .directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('uibTooltipHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
        };
    })

    .directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

    .directive('uibPopoverTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/popover/popover-template.html'
        };
    })

    .directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', uibTitle: '@' },
            templateUrl: 'uib/template/popover/popover-html.html'
        };
    })

    .directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverPopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', content: '@' },
            templateUrl: 'uib/template/popover/popover.html'
        };
    })

    .directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopover', 'popover', 'click');
    }]);

angular.module('ui.bootstrap.progressbar', [])

    .constant('uibProgressConfig', {
        animate: true,
        max: 100
    })

    .controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
        var self = this,
            animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

        this.bars = [];
        $scope.max = getMaxOrDefault();

        this.addBar = function (bar, element, attrs) {
            if (!animate) {
                element.css({ 'transition': 'none' });
            }

            this.bars.push(bar);

            bar.max = getMaxOrDefault();
            bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

            bar.$watch('value', function (value) {
                bar.recalculatePercentage();
            });

            bar.recalculatePercentage = function () {
                var totalPercentage = self.bars.reduce(function (total, bar) {
                    bar.percent = +(100 * bar.value / bar.max).toFixed(2);
                    return total + bar.percent;
                }, 0);

                if (totalPercentage > 100) {
                    bar.percent -= totalPercentage - 100;
                }
            };

            bar.$on('$destroy', function () {
                element = null;
                self.removeBar(bar);
            });
        };

        this.removeBar = function (bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        };

        //$attrs.$observe('maxParam', function(maxParam) {
        $scope.$watch('maxParam', function (maxParam) {
            self.bars.forEach(function (bar) {
                bar.max = getMaxOrDefault();
                bar.recalculatePercentage();
            });
        });

        function getMaxOrDefault() {
            return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
        }
    }])

    .directive('uibProgress', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            require: 'uibProgress',
            scope: {
                maxParam: '=?max'
            },
            templateUrl: 'uib/template/progressbar/progress.html'
        };
    })

    .directive('uibBar', function () {
        return {
            replace: true,
            transclude: true,
            require: '^uibProgress',
            scope: {
                value: '=',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/bar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, element, attrs);
            }
        };
    })

    .directive('uibProgressbar', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            scope: {
                value: '=',
                maxParam: '=?max',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/progressbar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
            }
        };
    });

angular.module('ui.bootstrap.rating', [])

    .constant('uibRatingConfig', {
        max: 5,
        stateOn: null,
        stateOff: null,
        enableReset: true,
        titles: ['one', 'two', 'three', 'four', 'five']
    })

    .controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
        var ngModelCtrl = { $setViewValue: angular.noop },
            self = this;

        this.init = function (ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.push(function (value) {
                if (angular.isNumber(value) && value << 0 !== value) {
                    value = Math.round(value);
                }

                return value;
            });

            this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
            this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
            this.enableReset = angular.isDefined($attrs.enableReset) ?
                $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
            var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
            this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
                tmpTitles : ratingConfig.titles;

            var ratingStates = angular.isDefined($attrs.ratingStates) ?
                $scope.$parent.$eval($attrs.ratingStates) :
                new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
            $scope.range = this.buildTemplateObjects(ratingStates);
        };

        this.buildTemplateObjects = function (states) {
            for (var i = 0, n = states.length; i < n; i++) {
                states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
            }
            return states;
        };

        this.getTitle = function (index) {
            if (index >= this.titles.length) {
                return index + 1;
            }

            return this.titles[index];
        };

        $scope.rate = function (value) {
            if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
                var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
                ngModelCtrl.$setViewValue(newViewValue);
                ngModelCtrl.$render();
            }
        };

        $scope.enter = function (value) {
            if (!$scope.readonly) {
                $scope.value = value;
            }
            $scope.onHover({ value: value });
        };

        $scope.reset = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.onLeave();
        };

        $scope.onKeydown = function (evt) {
            if (/(37|38|39|40)/.test(evt.which)) {
                evt.preventDefault();
                evt.stopPropagation();
                $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
            }
        };

        this.render = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.title = self.getTitle($scope.value - 1);
        };
    }])

    .directive('uibRating', function () {
        return {
            require: ['uibRating', 'ngModel'],
            restrict: 'A',
            scope: {
                readonly: '=?readOnly',
                onHover: '&',
                onLeave: '&'
            },
            controller: 'UibRatingController',
            templateUrl: 'uib/template/rating/rating.html',
            link: function (scope, element, attrs, ctrls) {
                var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                ratingCtrl.init(ngModelCtrl);
            }
        };
    });

angular.module('ui.bootstrap.tabs', [])

    .controller('UibTabsetController', ['$scope', function ($scope) {
        var ctrl = this,
            oldIndex;
        ctrl.tabs = [];

        ctrl.select = function (index, evt) {
            if (!destroyed) {
                var previousIndex = findTabIndex(oldIndex);
                var previousSelected = ctrl.tabs[previousIndex];
                if (previousSelected) {
                    previousSelected.tab.onDeselect({
                        $event: evt,
                        $selectedIndex: index
                    });
                    if (evt && evt.isDefaultPrevented()) {
                        return;
                    }
                    previousSelected.tab.active = false;
                }

                var selected = ctrl.tabs[index];
                if (selected) {
                    selected.tab.onSelect({
                        $event: evt
                    });
                    selected.tab.active = true;
                    ctrl.active = selected.index;
                    oldIndex = selected.index;
                } else if (!selected && angular.isDefined(oldIndex)) {
                    ctrl.active = null;
                    oldIndex = null;
                }
            }
        };

        ctrl.addTab = function addTab(tab) {
            ctrl.tabs.push({
                tab: tab,
                index: tab.index
            });
            ctrl.tabs.sort(function (t1, t2) {
                if (t1.index > t2.index) {
                    return 1;
                }

                if (t1.index < t2.index) {
                    return -1;
                }

                return 0;
            });

            if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
                var newActiveIndex = findTabIndex(tab.index);
                ctrl.select(newActiveIndex);
            }
        };

        ctrl.removeTab = function removeTab(tab) {
            var index;
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].tab === tab) {
                    index = i;
                    break;
                }
            }

            if (ctrl.tabs[index].index === ctrl.active) {
                var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
                    index - 1 : index + 1 % ctrl.tabs.length;
                ctrl.select(newActiveTabIndex);
            }

            ctrl.tabs.splice(index, 1);
        };

        $scope.$watch('tabset.active', function (val) {
            if (angular.isDefined(val) && val !== oldIndex) {
                ctrl.select(findTabIndex(val));
            }
        });

        var destroyed;
        $scope.$on('$destroy', function () {
            destroyed = true;
        });

        function findTabIndex(index) {
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].index === index) {
                    return i;
                }
            }
        }
    }])

    .directive('uibTabset', function () {
        return {
            transclude: true,
            replace: true,
            scope: {},
            bindToController: {
                active: '=?',
                type: '@'
            },
            controller: 'UibTabsetController',
            controllerAs: 'tabset',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tabset.html';
            },
            link: function (scope, element, attrs) {
                scope.vertical = angular.isDefined(attrs.vertical) ?
                    scope.$parent.$eval(attrs.vertical) : false;
                scope.justified = angular.isDefined(attrs.justified) ?
                    scope.$parent.$eval(attrs.justified) : false;
            }
        };
    })

    .directive('uibTab', ['$parse', function ($parse) {
        return {
            require: '^uibTabset',
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tab.html';
            },
            transclude: true,
            scope: {
                heading: '@',
                index: '=?',
                classes: '@?',
                onSelect: '&select', //This callback is called in contentHeadingTransclude
                //once it inserts the tab's content into the dom
                onDeselect: '&deselect'
            },
            controller: function () {
                //Empty controller so other directives can require being 'under' a tab
            },
            controllerAs: 'tab',
            link: function (scope, elm, attrs, tabsetCtrl, transclude) {
                scope.disabled = false;
                if (attrs.disable) {
                    scope.$parent.$watch($parse(attrs.disable), function (value) {
                        scope.disabled = !!value;
                    });
                }

                if (angular.isUndefined(attrs.index)) {
                    if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
                        scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) { return t.index; })) + 1;
                    } else {
                        scope.index = 0;
                    }
                }

                if (angular.isUndefined(attrs.classes)) {
                    scope.classes = '';
                }

                scope.select = function (evt) {
                    if (!scope.disabled) {
                        var index;
                        for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
                            if (tabsetCtrl.tabs[i].tab === scope) {
                                index = i;
                                break;
                            }
                        }

                        tabsetCtrl.select(index, evt);
                    }
                };

                tabsetCtrl.addTab(scope);
                scope.$on('$destroy', function () {
                    tabsetCtrl.removeTab(scope);
                });

                //We need to transclude later, once the content container is ready.
                //when this link happens, we're inside a tab heading.
                scope.$transcludeFn = transclude;
            }
        };
    }])

    .directive('uibTabHeadingTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTab',
            link: function (scope, elm) {
                scope.$watch('headingElement', function updateHeadingElement(heading) {
                    if (heading) {
                        elm.html('');
                        elm.append(heading);
                    }
                });
            }
        };
    })

    .directive('uibTabContentTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTabset',
            link: function (scope, elm, attrs) {
                var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

                //Now our tab is ready to be transcluded: both the tab heading area
                //and the tab content area are loaded.  Transclude 'em both.
                tab.$transcludeFn(tab.$parent, function (contents) {
                    angular.forEach(contents, function (node) {
                        if (isTabHeading(node)) {
                            //Let tabHeadingTransclude know.
                            tab.headingElement = node;
                        } else {
                            elm.append(node);
                        }
                    });
                });
            }
        };

        function isTabHeading(node) {
            return node.tagName && (
                node.hasAttribute('uib-tab-heading') ||
                node.hasAttribute('data-uib-tab-heading') ||
                node.hasAttribute('x-uib-tab-heading') ||
                node.tagName.toLowerCase() === 'uib-tab-heading' ||
                node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'uib:tab-heading'
            );
        }
    });

angular.module('ui.bootstrap.timepicker', [])

    .constant('uibTimepickerConfig', {
        hourStep: 1,
        minuteStep: 1,
        secondStep: 1,
        showMeridian: true,
        showSeconds: false,
        meridians: null,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
        showSpinners: true,
        templateUrl: 'uib/template/timepicker/timepicker.html'
    })

    .controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
        var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
        var selected = new Date(),
            watchers = [],
            ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
            meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
            padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

        $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
        $element.removeAttr('tabindex');

        this.init = function (ngModelCtrl_, inputs) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.unshift(function (modelValue) {
                return modelValue ? new Date(modelValue) : null;
            });

            var hoursInputEl = inputs.eq(0),
                minutesInputEl = inputs.eq(1),
                secondsInputEl = inputs.eq(2);

            hoursModelCtrl = hoursInputEl.controller('ngModel');
            minutesModelCtrl = minutesInputEl.controller('ngModel');
            secondsModelCtrl = secondsInputEl.controller('ngModel');

            var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

            if (mousewheel) {
                this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
            if (arrowkeys) {
                this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
            this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
        };

        var hourStep = timepickerConfig.hourStep;
        if ($attrs.hourStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
                hourStep = +value;
            }));
        }

        var minuteStep = timepickerConfig.minuteStep;
        if ($attrs.minuteStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
                minuteStep = +value;
            }));
        }

        var min;
        watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
            var dt = new Date(value);
            min = isNaN(dt) ? undefined : dt;
        }));

        var max;
        watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
            var dt = new Date(value);
            max = isNaN(dt) ? undefined : dt;
        }));

        var disabled = false;
        if ($attrs.ngDisabled) {
            watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
                disabled = value;
            }));
        }

        $scope.noIncrementHours = function () {
            var incrementedSelected = addMinutes(selected, hourStep * 60);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementHours = function () {
            var decrementedSelected = addMinutes(selected, -hourStep * 60);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementMinutes = function () {
            var incrementedSelected = addMinutes(selected, minuteStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementMinutes = function () {
            var decrementedSelected = addMinutes(selected, -minuteStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementSeconds = function () {
            var incrementedSelected = addSeconds(selected, secondStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementSeconds = function () {
            var decrementedSelected = addSeconds(selected, -secondStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noToggleMeridian = function () {
            if (selected.getHours() < 12) {
                return disabled || addMinutes(selected, 12 * 60) > max;
            }

            return disabled || addMinutes(selected, -12 * 60) < min;
        };

        var secondStep = timepickerConfig.secondStep;
        if ($attrs.secondStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
                secondStep = +value;
            }));
        }

        $scope.showSeconds = timepickerConfig.showSeconds;
        if ($attrs.showSeconds) {
            watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
                $scope.showSeconds = !!value;
            }));
        }

        // 12H / 24H mode
        $scope.showMeridian = timepickerConfig.showMeridian;
        if ($attrs.showMeridian) {
            watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
                $scope.showMeridian = !!value;

                if (ngModelCtrl.$error.time) {
                    // Evaluate from template
                    var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                    if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                        selected.setHours(hours);
                        refresh();
                    }
                } else {
                    updateTemplate();
                }
            }));
        }

        // Get $scope.hours in 24H mode if valid
        function getHoursFromTemplate() {
            var hours = +$scope.hours;
            var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
                hours >= 0 && hours < 24;
            if (!valid || $scope.hours === '') {
                return undefined;
            }

            if ($scope.showMeridian) {
                if (hours === 12) {
                    hours = 0;
                }
                if ($scope.meridian === meridians[1]) {
                    hours = hours + 12;
                }
            }
            return hours;
        }

        function getMinutesFromTemplate() {
            var minutes = +$scope.minutes;
            var valid = minutes >= 0 && minutes < 60;
            if (!valid || $scope.minutes === '') {
                return undefined;
            }
            return minutes;
        }

        function getSecondsFromTemplate() {
            var seconds = +$scope.seconds;
            return seconds >= 0 && seconds < 60 ? seconds : undefined;
        }

        function pad(value, noPad) {
            if (value === null) {
                return '';
            }

            return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
                '0' + value : value.toString();
        }

        // Respond on mousewheel spin
        this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            var isScrollingUp = function (e) {
                if (e.originalEvent) {
                    e = e.originalEvent;
                }
                //pick correct delta variable depending on event
                var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                return e.detail || delta > 0;
            };

            hoursInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
                }
                e.preventDefault();
            });

            minutesInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
                }
                e.preventDefault();
            });

            secondsInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
                }
                e.preventDefault();
            });
        };

        // Respond on up/down arrowkeys
        this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            hoursInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementHours();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementHours();
                        $scope.$apply();
                    }
                }
            });

            minutesInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementMinutes();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementMinutes();
                        $scope.$apply();
                    }
                }
            });

            secondsInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementSeconds();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementSeconds();
                        $scope.$apply();
                    }
                }
            });
        };

        this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            if ($scope.readonlyInput) {
                $scope.updateHours = angular.noop;
                $scope.updateMinutes = angular.noop;
                $scope.updateSeconds = angular.noop;
                return;
            }

            var invalidate = function (invalidHours, invalidMinutes, invalidSeconds) {
                ngModelCtrl.$setViewValue(null);
                ngModelCtrl.$setValidity('time', false);
                if (angular.isDefined(invalidHours)) {
                    $scope.invalidHours = invalidHours;
                    if (hoursModelCtrl) {
                        hoursModelCtrl.$setValidity('hours', false);
                    }
                }

                if (angular.isDefined(invalidMinutes)) {
                    $scope.invalidMinutes = invalidMinutes;
                    if (minutesModelCtrl) {
                        minutesModelCtrl.$setValidity('minutes', false);
                    }
                }

                if (angular.isDefined(invalidSeconds)) {
                    $scope.invalidSeconds = invalidSeconds;
                    if (secondsModelCtrl) {
                        secondsModelCtrl.$setValidity('seconds', false);
                    }
                }
            };

            $scope.updateHours = function () {
                var hours = getHoursFromTemplate(),
                    minutes = getMinutesFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(true);
                    } else {
                        refresh('h');
                    }
                } else {
                    invalidate(true);
                }
            };

            hoursInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.hours === null || $scope.hours === '') {
                    invalidate(true);
                } else if (!$scope.invalidHours && $scope.hours < 10) {
                    $scope.$apply(function () {
                        $scope.hours = pad($scope.hours, !padHours);
                    });
                }
            });

            $scope.updateMinutes = function () {
                var minutes = getMinutesFromTemplate(),
                    hours = getHoursFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(undefined, true);
                    } else {
                        refresh('m');
                    }
                } else {
                    invalidate(undefined, true);
                }
            };

            minutesInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.minutes === null) {
                    invalidate(undefined, true);
                } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
                    $scope.$apply(function () {
                        $scope.minutes = pad($scope.minutes);
                    });
                }
            });

            $scope.updateSeconds = function () {
                var seconds = getSecondsFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(seconds)) {
                    selected.setSeconds(seconds);
                    refresh('s');
                } else {
                    invalidate(undefined, undefined, true);
                }
            };

            secondsInputEl.on('blur', function (e) {
                if (modelIsEmpty()) {
                    makeValid();
                } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
                    $scope.$apply(function () {
                        $scope.seconds = pad($scope.seconds);
                    });
                }
            });

        };

        this.render = function () {
            var date = ngModelCtrl.$viewValue;

            if (isNaN(date)) {
                ngModelCtrl.$setValidity('time', false);
                $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            } else {
                if (date) {
                    selected = date;
                }

                if (selected < min || selected > max) {
                    ngModelCtrl.$setValidity('time', false);
                    $scope.invalidHours = true;
                    $scope.invalidMinutes = true;
                } else {
                    makeValid();
                }
                updateTemplate();
            }
        };

        // Call internally when we know that model is valid.
        function refresh(keyboardChange) {
            makeValid();
            ngModelCtrl.$setViewValue(new Date(selected));
            updateTemplate(keyboardChange);
        }

        function makeValid() {
            if (hoursModelCtrl) {
                hoursModelCtrl.$setValidity('hours', true);
            }

            if (minutesModelCtrl) {
                minutesModelCtrl.$setValidity('minutes', true);
            }

            if (secondsModelCtrl) {
                secondsModelCtrl.$setValidity('seconds', true);
            }

            ngModelCtrl.$setValidity('time', true);
            $scope.invalidHours = false;
            $scope.invalidMinutes = false;
            $scope.invalidSeconds = false;
        }

        function updateTemplate(keyboardChange) {
            if (!ngModelCtrl.$modelValue) {
                $scope.hours = null;
                $scope.minutes = null;
                $scope.seconds = null;
                $scope.meridian = meridians[0];
            } else {
                var hours = selected.getHours(),
                    minutes = selected.getMinutes(),
                    seconds = selected.getSeconds();

                if ($scope.showMeridian) {
                    hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
                }

                $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
                if (keyboardChange !== 'm') {
                    $scope.minutes = pad(minutes);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

                if (keyboardChange !== 's') {
                    $scope.seconds = pad(seconds);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
            }
        }

        function addSecondsToSelected(seconds) {
            selected = addSeconds(selected, seconds);
            refresh();
        }

        function addMinutes(selected, minutes) {
            return addSeconds(selected, minutes * 60);
        }

        function addSeconds(date, seconds) {
            var dt = new Date(date.getTime() + seconds * 1000);
            var newDate = new Date(date);
            newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
            return newDate;
        }

        function modelIsEmpty() {
            return ($scope.hours === null || $scope.hours === '') &&
                ($scope.minutes === null || $scope.minutes === '') &&
                (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
        }

        $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
            $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

        $scope.incrementHours = function () {
            if (!$scope.noIncrementHours()) {
                addSecondsToSelected(hourStep * 60 * 60);
            }
        };

        $scope.decrementHours = function () {
            if (!$scope.noDecrementHours()) {
                addSecondsToSelected(-hourStep * 60 * 60);
            }
        };

        $scope.incrementMinutes = function () {
            if (!$scope.noIncrementMinutes()) {
                addSecondsToSelected(minuteStep * 60);
            }
        };

        $scope.decrementMinutes = function () {
            if (!$scope.noDecrementMinutes()) {
                addSecondsToSelected(-minuteStep * 60);
            }
        };

        $scope.incrementSeconds = function () {
            if (!$scope.noIncrementSeconds()) {
                addSecondsToSelected(secondStep);
            }
        };

        $scope.decrementSeconds = function () {
            if (!$scope.noDecrementSeconds()) {
                addSecondsToSelected(-secondStep);
            }
        };

        $scope.toggleMeridian = function () {
            var minutes = getMinutesFromTemplate(),
                hours = getHoursFromTemplate();

            if (!$scope.noToggleMeridian()) {
                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
                } else {
                    $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
                }
            }
        };

        $scope.blur = function () {
            ngModelCtrl.$setTouched();
        };

        $scope.$on('$destroy', function () {
            while (watchers.length) {
                watchers.shift()();
            }
        });
    }])

    .directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
        return {
            require: ['uibTimepicker', '?^ngModel'],
            restrict: 'A',
            controller: 'UibTimepickerController',
            controllerAs: 'timepicker',
            scope: {},
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || uibTimepickerConfig.templateUrl;
            },
            link: function (scope, element, attrs, ctrls) {
                var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (ngModelCtrl) {
                    timepickerCtrl.init(ngModelCtrl, element.find('input'));
                }
            }
        };
    }]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

    /**
     * A helper service that can parse typeahead's syntax (string provided by users)
     * Extracted to a separate service for ease of unit testing
     */
    .factory('uibTypeaheadParser', ['$parse', function ($parse) {
        //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        return {
            parse: function (input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error(
                        'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
                        ' but got "' + input + '".');
                }

                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    }])

    .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
        function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
            var HOT_KEYS = [9, 13, 27, 38, 40];
            var eventDebounceTime = 200;
            var modelCtrl, ngModelOptions;
            //SUPPORTED ATTRIBUTES (OPTIONS)

            //minimal no of characters that needs to be entered before typeahead kicks-in
            var minLength = originalScope.$eval(attrs.typeaheadMinLength);
            if (!minLength && minLength !== 0) {
                minLength = 1;
            }

            originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
                minLength = !newVal && newVal !== 0 ? 1 : newVal;
            });

            //minimal wait time after last character typed before typeahead kicks-in
            var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

            //should it restrict model values to the ones selected from the popup only?
            var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
            originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
                isEditable = newVal !== false;
            });

            //binding to a variable that indicates if matches are being retrieved asynchronously
            var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

            //a function to determine if an event should cause selection
            var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {
                var evt = vals.$event;
                return evt.which === 13 || evt.which === 9;
            };

            //a callback executed when a match is selected
            var onSelectCallback = $parse(attrs.typeaheadOnSelect);

            //should it select highlighted popup value when losing focus?
            var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

            //binding to a variable that indicates if there were no results after the query is completed
            var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

            var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

            var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

            var appendTo = attrs.typeaheadAppendTo ?
                originalScope.$eval(attrs.typeaheadAppendTo) : null;

            var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

            //If input matches an item of the list exactly, select it automatically
            var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

            //binding to a variable that indicates if dropdown is open
            var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

            var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

            //INTERNAL VARIABLES

            //model setter executed upon match selection
            var parsedModel = $parse(attrs.ngModel);
            var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
            var $setModelValue = function (scope, newValue) {
                if (angular.isFunction(parsedModel(originalScope)) &&
                    ngModelOptions.getOption('getterSetter')) {
                    return invokeModelSetter(scope, { $$$p: newValue });
                }

                return parsedModel.assign(scope, newValue);
            };

            //expressions used by typeahead
            var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

            var hasFocus;

            //Used to avoid bug in iOS webview where iOS keyboard does not fire
            //mousedown & mouseup events
            //Issue #3699
            var selected;

            //create a child scope for the typeahead directive so we are not polluting original scope
            //with typeahead-specific data (matches, query etc.)
            var scope = originalScope.$new();
            var offDestroy = originalScope.$on('$destroy', function () {
                scope.$destroy();
            });
            scope.$on('$destroy', offDestroy);

            // WAI-ARIA
            var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
            element.attr({
                'aria-autocomplete': 'list',
                'aria-expanded': false,
                'aria-owns': popupId
            });

            var inputsContainer, hintInputElem;
            //add read-only input to show hint
            if (showHint) {
                inputsContainer = angular.element('<div></div>');
                inputsContainer.css('position', 'relative');
                element.after(inputsContainer);
                hintInputElem = element.clone();
                hintInputElem.attr('placeholder', '');
                hintInputElem.attr('tabindex', '-1');
                hintInputElem.val('');
                hintInputElem.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': '0px',
                    'border-color': 'transparent',
                    'box-shadow': 'none',
                    'opacity': 1,
                    'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
                    'color': '#999'
                });
                element.css({
                    'position': 'relative',
                    'vertical-align': 'top',
                    'background-color': 'transparent'
                });

                if (hintInputElem.attr('id')) {
                    hintInputElem.removeAttr('id'); // remove duplicate id if present.
                }
                inputsContainer.append(hintInputElem);
                hintInputElem.after(element);
            }

            //pop-up element used to display matches
            var popUpEl = angular.element('<div uib-typeahead-popup></div>');
            popUpEl.attr({
                id: popupId,
                matches: 'matches',
                active: 'activeIdx',
                select: 'select(activeIdx, evt)',
                'move-in-progress': 'moveInProgress',
                query: 'query',
                position: 'position',
                'assign-is-open': 'assignIsOpen(isOpen)',
                debounce: 'debounceUpdate'
            });
            //custom item template
            if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
                popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
            }

            if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
                popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
            }

            var resetHint = function () {
                if (showHint) {
                    hintInputElem.val('');
                }
            };

            var resetMatches = function () {
                scope.matches = [];
                scope.activeIdx = -1;
                element.attr('aria-expanded', false);
                resetHint();
            };

            var getMatchId = function (index) {
                return popupId + '-option-' + index;
            };

            // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
            // This attribute is added or removed automatically when the `activeIdx` changes.
            scope.$watch('activeIdx', function (index) {
                if (index < 0) {
                    element.removeAttr('aria-activedescendant');
                } else {
                    element.attr('aria-activedescendant', getMatchId(index));
                }
            });

            var inputIsExactMatch = function (inputValue, index) {
                if (scope.matches.length > index && inputValue) {
                    return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
                }

                return false;
            };

            var getMatchesAsync = function (inputValue, evt) {
                var locals = { $viewValue: inputValue };
                isLoadingSetter(originalScope, true);
                isNoResultsSetter(originalScope, false);
                $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
                    //it might happen that several async queries were in progress if a user were typing fast
                    //but we are interested only in responses that correspond to the current view value
                    var onCurrentRequest = inputValue === modelCtrl.$viewValue;
                    if (onCurrentRequest && hasFocus) {
                        if (matches && matches.length > 0) {
                            scope.activeIdx = focusFirst ? 0 : -1;
                            isNoResultsSetter(originalScope, false);
                            scope.matches.length = 0;

                            //transform labels
                            for (var i = 0; i < matches.length; i++) {
                                locals[parserResult.itemName] = matches[i];
                                scope.matches.push({
                                    id: getMatchId(i),
                                    label: parserResult.viewMapper(scope, locals),
                                    model: matches[i]
                                });
                            }

                            scope.query = inputValue;
                            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                            //due to other elements being rendered
                            recalculatePosition();

                            element.attr('aria-expanded', true);

                            //Select the single remaining option if user input matches
                            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(0, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(0, evt);
                                }
                            }

                            if (showHint) {
                                var firstLabel = scope.matches[0].label;
                                if (angular.isString(inputValue) &&
                                    inputValue.length > 0 &&
                                    firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                                    hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
                                } else {
                                    hintInputElem.val('');
                                }
                            }
                        } else {
                            resetMatches();
                            isNoResultsSetter(originalScope, true);
                        }
                    }
                    if (onCurrentRequest) {
                        isLoadingSetter(originalScope, false);
                    }
                }, function () {
                    resetMatches();
                    isLoadingSetter(originalScope, false);
                    isNoResultsSetter(originalScope, true);
                });
            };

            // bind events only if appendToBody params exist - performance feature
            if (appendToBody) {
                angular.element($window).on('resize', fireRecalculating);
                $document.find('body').on('scroll', fireRecalculating);
            }

            // Declare the debounced function outside recalculating for
            // proper debouncing
            var debouncedRecalculate = $$debounce(function () {
                // if popup is visible
                if (scope.matches.length) {
                    recalculatePosition();
                }

                scope.moveInProgress = false;
            }, eventDebounceTime);

            // Default progress type
            scope.moveInProgress = false;

            function fireRecalculating() {
                if (!scope.moveInProgress) {
                    scope.moveInProgress = true;
                    scope.$digest();
                }

                debouncedRecalculate();
            }

            // recalculate actual position and set new values to scope
            // after digest loop is popup in right position
            function recalculatePosition() {
                scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                scope.position.top += element.prop('offsetHeight');
            }

            //we need to propagate user's query so we can higlight matches
            scope.query = undefined;

            //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
            var timeoutPromise;

            var scheduleSearchWithTimeout = function (inputValue) {
                timeoutPromise = $timeout(function () {
                    getMatchesAsync(inputValue);
                }, waitTime);
            };

            var cancelPreviousTimeout = function () {
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }
            };

            resetMatches();

            scope.assignIsOpen = function (isOpen) {
                isOpenSetter(originalScope, isOpen);
            };

            scope.select = function (activeIdx, evt) {
                //called from within the $digest() cycle
                var locals = {};
                var model, item;

                selected = true;
                locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                model = parserResult.modelMapper(originalScope, locals);
                $setModelValue(originalScope, model);
                modelCtrl.$setValidity('editable', true);
                modelCtrl.$setValidity('parse', true);

                onSelectCallback(originalScope, {
                    $item: item,
                    $model: model,
                    $label: parserResult.viewMapper(originalScope, locals),
                    $event: evt
                });

                resetMatches();

                //return focus to the input element if a match was selected via a mouse click event
                // use timeout to avoid $rootScope:inprog error
                if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
                    $timeout(function () { element[0].focus(); }, 0, false);
                }
            };

            //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
            element.on('keydown', function (evt) {
                //typeahead is open and an "interesting" key was pressed
                if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
                    return;
                }

                var shouldSelect = isSelectEvent(originalScope, { $event: evt });

                /**
                 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
                 * or
                 * shift + tab is pressed to bring focus to the previous element
                 * then clear the results
                 */
                if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
                    resetMatches();
                    scope.$digest();
                    return;
                }

                evt.preventDefault();
                var target;
                switch (evt.which) {
                    case 27: // escape
                        evt.stopPropagation();

                        resetMatches();
                        originalScope.$digest();
                        break;
                    case 38: // up arrow
                        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    case 40: // down arrow
                        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    default:
                        if (shouldSelect) {
                            scope.$apply(function () {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(scope.activeIdx, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(scope.activeIdx, evt);
                                }
                            });
                        }
                }
            });

            element.on('focus', function (evt) {
                hasFocus = true;
                if (minLength === 0 && !modelCtrl.$viewValue) {
                    $timeout(function () {
                        getMatchesAsync(modelCtrl.$viewValue, evt);
                    }, 0);
                }
            });

            element.on('blur', function (evt) {
                if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
                    selected = true;
                    scope.$apply(function () {
                        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
                            $$debounce(function () {
                                scope.select(scope.activeIdx, evt);
                            }, scope.debounceUpdate.blur);
                        } else {
                            scope.select(scope.activeIdx, evt);
                        }
                    });
                }
                if (!isEditable && modelCtrl.$error.editable) {
                    modelCtrl.$setViewValue();
                    scope.$apply(function () {
                        // Reset validity as we are clearing
                        modelCtrl.$setValidity('editable', true);
                        modelCtrl.$setValidity('parse', true);
                    });
                    element.val('');
                }
                hasFocus = false;
                selected = false;
            });

            // Keep reference to click handler to unbind it.
            var dismissClickHandler = function (evt) {
                // Issue #3973
                // Firefox treats right click as a click on document
                if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
                    resetMatches();
                    if (!$rootScope.$$phase) {
                        originalScope.$digest();
                    }
                }
            };

            $document.on('click', dismissClickHandler);

            originalScope.$on('$destroy', function () {
                $document.off('click', dismissClickHandler);
                if (appendToBody || appendTo) {
                    $popup.remove();
                }

                if (appendToBody) {
                    angular.element($window).off('resize', fireRecalculating);
                    $document.find('body').off('scroll', fireRecalculating);
                }
                // Prevent jQuery cache memory leak
                popUpEl.remove();

                if (showHint) {
                    inputsContainer.remove();
                }
            });

            var $popup = $compile(popUpEl)(scope);

            if (appendToBody) {
                $document.find('body').append($popup);
            } else if (appendTo) {
                angular.element(appendTo).eq(0).append($popup);
            } else {
                element.after($popup);
            }

            this.init = function (_modelCtrl) {
                modelCtrl = _modelCtrl;
                ngModelOptions = extractOptions(modelCtrl);

                scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

                //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                modelCtrl.$parsers.unshift(function (inputValue) {
                    hasFocus = true;

                    if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                        if (waitTime > 0) {
                            cancelPreviousTimeout();
                            scheduleSearchWithTimeout(inputValue);
                        } else {
                            getMatchesAsync(inputValue);
                        }
                    } else {
                        isLoadingSetter(originalScope, false);
                        cancelPreviousTimeout();
                        resetMatches();
                    }

                    if (isEditable) {
                        return inputValue;
                    }

                    if (!inputValue) {
                        // Reset in case user had typed something previously.
                        modelCtrl.$setValidity('editable', true);
                        return null;
                    }

                    modelCtrl.$setValidity('editable', false);
                    return undefined;
                });

                modelCtrl.$formatters.push(function (modelValue) {
                    var candidateViewValue, emptyViewValue;
                    var locals = {};

                    // The validity may be set to false via $parsers (see above) if
                    // the model is restricted to selected values. If the model
                    // is set manually it is considered to be valid.
                    if (!isEditable) {
                        modelCtrl.$setValidity('editable', true);
                    }

                    if (inputFormatter) {
                        locals.$model = modelValue;
                        return inputFormatter(originalScope, locals);
                    }

                    //it might happen that we don't have enough info to properly render input value
                    //we need to check for this situation and simply return model value if we can't apply custom formatting
                    locals[parserResult.itemName] = modelValue;
                    candidateViewValue = parserResult.viewMapper(originalScope, locals);
                    locals[parserResult.itemName] = undefined;
                    emptyViewValue = parserResult.viewMapper(originalScope, locals);

                    return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                });
            };

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options || {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }
        }])

    .directive('uibTypeahead', function () {
        return {
            controller: 'UibTypeaheadController',
            require: ['ngModel', 'uibTypeahead'],
            link: function (originalScope, element, attrs, ctrls) {
                ctrls[1].init(ctrls[0]);
            }
        };
    })

    .directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
        return {
            scope: {
                matches: '=',
                query: '=',
                active: '=',
                position: '&',
                moveInProgress: '=',
                select: '&',
                assignIsOpen: '&',
                debounce: '&'
            },
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
            },
            link: function (scope, element, attrs) {
                scope.templateUrl = attrs.templateUrl;

                scope.isOpen = function () {
                    var isDropdownOpen = scope.matches.length > 0;
                    scope.assignIsOpen({ isOpen: isDropdownOpen });
                    return isDropdownOpen;
                };

                scope.isActive = function (matchIdx) {
                    return scope.active === matchIdx;
                };

                scope.selectActive = function (matchIdx) {
                    scope.active = matchIdx;
                };

                scope.selectMatch = function (activeIdx, evt) {
                    var debounce = scope.debounce();
                    if (angular.isNumber(debounce) || angular.isObject(debounce)) {
                        $$debounce(function () {
                            scope.select({ activeIdx: activeIdx, evt: evt });
                        }, angular.isNumber(debounce) ? debounce : debounce['default']);
                    } else {
                        scope.select({ activeIdx: activeIdx, evt: evt });
                    }
                };
            }
        };
    }])

    .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
        return {
            scope: {
                index: '=',
                match: '=',
                query: '='
            },
            link: function (scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
                $templateRequest(tplUrl).then(function (tplContent) {
                    var tplEl = angular.element(tplContent.trim());
                    element.replaceWith(tplEl);
                    $compile(tplEl)(scope);
                });
            }
        };
    }])

    .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
        var isSanitizePresent;
        isSanitizePresent = $injector.has('$sanitize');

        function escapeRegexp(queryToEscape) {
            // Regex: capture the whole query string and replace it with the string that will be used to match
            // the results, for example if the capture is "a" the result will be \a
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        function containsHtml(matchItem) {
            return /<.*>/g.test(matchItem);
        }

        return function (matchItem, query) {
            if (!isSanitizePresent && containsHtml(matchItem)) {
                $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
            }
            matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
            if (!isSanitizePresent) {
                matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
            }
            return matchItem;
        };
    }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion-group.html",
        "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
        "  <h4 class=\"panel-title\">\n" +
        "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
        "  </h4>\n" +
        "</div>\n" +
        "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
        "  <div class=\"panel-body\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion.html",
        "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/alert/alert.html",
        "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
        "  <span aria-hidden=\"true\">&times;</span>\n" +
        "  <span class=\"sr-only\">Close</span>\n" +
        "</button>\n" +
        "<div ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/carousel.html",
        "<div class=\"carousel-inner\" ng-transclude></div>\n" +
        "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
        "  <span class=\"sr-only\">previous</span>\n" +
        "</a>\n" +
        "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
        "  <span class=\"sr-only\">next</span>\n" +
        "</a>\n" +
        "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
        "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
        "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
        "  </li>\n" +
        "</ol>\n" +
        "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/slide.html",
        "<div class=\"text-center\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/datepicker.html",
        "<div ng-switch=\"datepickerMode\">\n" +
        "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
        "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
        "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/day.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
        "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/month.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/year.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepickerPopup/popup.html",
        "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
        "  <li ng-transclude></li>\n" +
        "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
        "    <span class=\"btn-group pull-left\">\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
        "    </span>\n" +
        "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
        "  </li>\n" +
        "</ul>\n" +
        "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/modal/window.html",
        "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
        "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pager/pager.html",
        "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pagination/pagination.html",
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\"\n" +
        "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-html.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-template.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\"\n" +
        "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/bar.html",
        "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progress.html",
        "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progressbar.html",
        "<div class=\"progress\">\n" +
        "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/rating/rating.html",
        "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
        "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
        "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
        "</span>\n" +
        "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tab.html",
        "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
        "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
        "</li>\n" +
        "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tabset.html",
        "<div>\n" +
        "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
        "  <div class=\"tab-content\">\n" +
        "    <div class=\"tab-pane\"\n" +
        "         ng-repeat=\"tab in tabset.tabs\"\n" +
        "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
        "         uib-tab-content-transclude=\"tab\">\n" +
        "    </div>\n" +
        "  </div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/timepicker/timepicker.html",
        "<table class=\"uib-timepicker\">\n" +
        "  <tbody>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
        "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
        "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
        "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
        "    </tr>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-match.html",
        "<a href\n" +
        "   tabindex=\"-1\"\n" +
        "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
        "   ng-attr-title=\"{{match.label}}\"></a>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-popup.html",
        "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
        "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
        "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
        "    </li>\n" +
        "</ul>\n" +
        "");
}]);
angular.module('ui.bootstrap.carousel').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi PievilÃ¤inen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */
/* global module, define */

; (function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory()
    } else if (typeof define === 'function' && define.amd) {
        define([], factory)
    } else {
        root.RRule = factory(root)
        root.RRuleSet = root.RRule.RRuleSet
        root.rrulestr = root.RRule.rrulestr
    }
}(typeof window === 'object' ? window : this, function (root) {
    // =============================================================================
    // Date utilities
    // =============================================================================

    /**
     * General date-related utilities.
     * Also handles several incompatibilities between JavaScript and Python
     *
     */
    var dateutil = {
        MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

        /**
         * Number of milliseconds of one day
         */
        ONE_DAY: 1000 * 60 * 60 * 24,

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.MAXYEAR>
         */
        MAXYEAR: 9999,

        /**
         * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
         * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
         * therefore we use 1-Jan-1970 instead
         */
        ORDINAL_BASE: new Date(1970, 0, 1),

        /**
         * Python: MO-SU: 0 - 6
         * JS: SU-SAT 0 - 6
         */
        PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],

        /**
         * py_date.timetuple()[7]
         */
        getYearDay: function (date) {
            var dateNoTime = new Date(
                date.getFullYear(), date.getMonth(), date.getDate())
            return Math.ceil(
                (dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1
        },

        isLeapYear: function (year) {
            if (year instanceof Date) year = year.getFullYear()
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
        },

        /**
         * @return {Number} the date's timezone offset in ms
         */
        tzOffset: function (date) {
            return date.getTimezoneOffset() * 60 * 1000
        },

        /**
         * @see: <https://www.mcfedries.com/JavaScript/DaysBetween.asp>
         */
        daysBetween: function (date1, date2) {
            // The number of milliseconds in one day
            // Convert both dates to milliseconds
            var date1_ms = date1.getTime() - dateutil.tzOffset(date1)
            var date2_ms = date2.getTime() - dateutil.tzOffset(date2)
            // Calculate the difference in milliseconds
            var difference_ms = Math.abs(date1_ms - date2_ms)
            // Convert back to days and return
            return Math.round(difference_ms / dateutil.ONE_DAY)
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.date.toordinal>
         */
        toOrdinal: function (date) {
            return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
        },

        /**
         * @see - <https://docs.python.org/library/datetime.html#datetime.date.fromordinal>
         */
        fromOrdinal: function (ordinal) {
            var millisecsFromBase = ordinal * dateutil.ONE_DAY
            return new Date(dateutil.ORDINAL_BASE.getTime() -
                dateutil.tzOffset(dateutil.ORDINAL_BASE) +
                millisecsFromBase +
                dateutil.tzOffset(new Date(millisecsFromBase)))
        },

        /**
         * @see: <https://docs.python.org/library/calendar.html#calendar.monthrange>
         */
        monthRange: function (year, month) {
            var date = new Date(year, month, 1)
            return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
        },

        getMonthDays: function (date) {
            var month = date.getMonth()
            return month === 1 && dateutil.isLeapYear(date)
                ? 29 : dateutil.MONTH_DAYS[month]
        },

        /**
         * @return {Number} python-like weekday
         */
        getWeekday: function (date) {
            return dateutil.PY_WEEKDAYS[date.getDay()]
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.datetime.combine>
         */
        combine: function (date, time) {
            time = time || date
            return new Date(
                date.getFullYear(), date.getMonth(), date.getDate(),
                time.getHours(), time.getMinutes(), time.getSeconds(),
                time.getMilliseconds())
        },

        clone: function (date) {
            var dolly = new Date(date.getTime())
            return dolly
        },

        cloneDates: function (dates) {
            var clones = []
            for (var i = 0; i < dates.length; i++) {
                clones.push(dateutil.clone(dates[i]))
            }
            return clones
        },

        /**
         * Sorts an array of Date or dateutil.Time objects
         */
        sort: function (dates) {
            dates.sort(function (a, b) {
                return a.getTime() - b.getTime()
            })
        },

        timeToUntilString: function (time) {
            var comp
            var date = new Date(time)
            var comps = [
                date.getUTCFullYear(),
                date.getUTCMonth() + 1,
                date.getUTCDate(),
                'T',
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
                'Z'
            ]

            for (var i = 0; i < comps.length; i++) {
                comp = comps[i]
                if (!/[TZ]/.test(comp) && comp < 10) comps[i] = '0' + String(comp)
            }
            return comps.join('')
        },

        untilStringToDate: function (until) {
            var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z)?$/
            var bits = re.exec(until)
            if (!bits) throw new Error('Invalid UNTIL value: ' + until)
            return new Date(Date.UTC(
                bits[1],
                bits[2] - 1,
                bits[3],
                bits[5] || 0,
                bits[6] || 0,
                bits[7] || 0))
        }
    }

    dateutil.Time = function (hour, minute, second, millisecond) {
        this.hour = hour
        this.minute = minute
        this.second = second
        this.millisecond = millisecond || 0
    }

    dateutil.Time.prototype = {
        constructor: dateutil.Time,
        getHours: function () {
            return this.hour
        },
        getMinutes: function () {
            return this.minute
        },
        getSeconds: function () {
            return this.second
        },
        getMilliseconds: function () {
            return this.millisecond
        },
        getTime: function () {
            return ((this.hour * 60 * 60) + (this.minute * 60) + this.second) * 1000 +
                this.millisecond
        }
    }

    // =============================================================================
    // Helper functions
    // =============================================================================

    /**
     * Simplified version of python's range()
     */
    var range = function (start, end) {
        if (arguments.length === 1) {
            end = start
            start = 0
        }
        var rang = []
        for (var i = start; i < end; i++) rang.push(i)
        return rang
    }

    var repeat = function (value, times) {
        var i = 0
        var array = []

        if (value instanceof Array) {
            for (; i < times; i++) array[i] = [].concat(value)
        } else {
            for (; i < times; i++) array[i] = value
        }
        return array
    }

    /**
     * Python like split
     */
    var split = function (str, sep, num) {
        var splits = str.split(sep)
        return num
            ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits
    }

    /**
     * closure/goog/math/math.js:modulo
     * Copyright 2006 The Closure Library Authors.
     * The % operator in JavaScript returns the remainder of a / b, but differs from
     * some other languages in that the result will have the same sign as the
     * dividend. For example, -1 % 8 == -1, whereas in some other languages
     * (such as Python) the result would be 7. This function emulates the more
     * correct modulo behavior, which is useful for certain applications such as
     * calculating an offset index in a circular list.
     *
     * @param {number} a The dividend.
     * @param {number} b The divisor.
     * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
     *     or b < x <= 0, depending on the sign of b).
     */
    var pymod = function (a, b) {
        var r = a % b
        // If r and b differ in sign, add b to wrap the result to the correct sign.
        return (r * b < 0) ? r + b : r
    }

    /**
     * @see: <https://docs.python.org/library/functions.html#divmod>
     */
    var divmod = function (a, b) {
        return { div: Math.floor(a / b), mod: pymod(a, b) }
    }

    /**
     * Python-like boolean
     * @return {Boolean} value of an object/primitive, taking into account
     * the fact that in Python an empty list's/tuple's
     * boolean value is False, whereas in JS it's true
     */
    var plb = function (obj) {
        return (obj instanceof Array && obj.length === 0)
            ? false : Boolean(obj)
    }

    /**
     * Return true if a value is in an array
     */
    var contains = function (arr, val) {
        return arr.indexOf(val) !== -1
    }

    // =============================================================================
    // Date masks
    // =============================================================================

    // Every mask is 7 days longer to handle cross-year weekly periods.

    var M365MASK = [].concat(
        repeat(1, 31), repeat(2, 28), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M366MASK = [].concat(
        repeat(1, 31), repeat(2, 29), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M28 = range(1, 29)
    var M29 = range(1, 30)
    var M30 = range(1, 31)
    var M31 = range(1, 32)

    var MDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var MDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    M28 = range(-28, 0)
    M29 = range(-29, 0)
    M30 = range(-30, 0)
    M31 = range(-31, 0)

    var NMDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var NMDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
    var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365]

    var WDAYMASK = (function () {
        for (var wdaymask = [], i = 0; i < 55; i++) wdaymask = wdaymask.concat(range(7))
        return wdaymask
    }())

    // =============================================================================
    // Weekday
    // =============================================================================

    var Weekday = function (weekday, n) {
        if (n === 0) throw new Error("Can't create weekday with n == 0")
        this.weekday = weekday
        this.n = n
    }

    Weekday.prototype = {
        constructor: Weekday,
        // __call__ - Cannot call the object directly, do it through
        // e.g. RRule.TH.nth(-1) instead,
        nth: function (n) {
            return this.n === n ? this : new Weekday(this.weekday, n)
        },

        // __eq__
        equals: function (other) {
            return this.weekday === other.weekday && this.n === other.n
        },

        // __repr__
        toString: function () {
            var s = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'][this.weekday]
            if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s
            return s
        },

        getJsWeekday: function () {
            return this.weekday === 6 ? 0 : this.weekday + 1
        }

    }

    // =============================================================================
    // RRule
    // =============================================================================

    /**
     *
     * @param {Object?} options - see <https://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
     *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
     * @constructor
     */
    var RRule = function (options, noCache) {
        options = options || {}
        // RFC string
        this._string = null
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }

        // used by toString()
        this.origOptions = {}

        var invalid = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        // Shallow copy for origOptions and check for invalid
        keys.forEach(function (key) {
            this.origOptions[key] = options[key]
            if (!contains(defaultKeys, key)) invalid.push(key)
        }, this)

        if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

        if (!RRule.FREQUENCIES[options.freq] && options.byeaster === null) {
            throw new Error('Invalid frequency: ' + String(options.freq))
        }

        // Merge in default options
        defaultKeys.forEach(function (key) {
            if (!contains(keys, key)) options[key] = RRule.DEFAULT_OPTIONS[key]
        })

        var opts = this.options = options

        if (opts.byeaster !== null) opts.freq = RRule.YEARLY
        if (!opts.dtstart) opts.dtstart = new Date()

        var millisecondModulo = opts.dtstart.getTime() % 1000
        if (opts.wkst === null) {
            opts.wkst = RRule.MO.weekday
        } else if (typeof opts.wkst === 'number') {
            // cool, just keep it like that
        } else {
            opts.wkst = opts.wkst.weekday
        }

        if (opts.bysetpos !== null) {
            if (typeof opts.bysetpos === 'number') opts.bysetpos = [opts.bysetpos]

            for (var i = 0; i < opts.bysetpos.length; i++) {
                var v = opts.bysetpos[i]
                if (v === 0 || !(v >= -366 && v <= 366)) {
                    throw new Error('bysetpos must be between 1 and 366,' +
                        ' or between -366 and -1')
                }
            }
        }

        if (!(plb(opts.byweekno) || plb(opts.byyearday) || plb(opts.bymonthday) ||
            opts.byweekday !== null || opts.byeaster !== null)) {
            switch (opts.freq) {
                case RRule.YEARLY:
                    if (!opts.bymonth) opts.bymonth = opts.dtstart.getMonth() + 1
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.MONTHLY:
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.WEEKLY:
                    opts.byweekday = dateutil.getWeekday(opts.dtstart)
                    break
            }
        }

        // bymonth
        if (opts.bymonth !== null && !(opts.bymonth instanceof Array)) {
            opts.bymonth = [opts.bymonth]
        }
        // byyearday
        if (opts.byyearday !== null && !(opts.byyearday instanceof Array)) {
            opts.byyearday = [opts.byyearday]
        }

        // bymonthday
        if (opts.bymonthday === null) {
            opts.bymonthday = []
            opts.bynmonthday = []
        } else if (opts.bymonthday instanceof Array) {
            var bymonthday = []
            var bynmonthday = []

            for (i = 0; i < opts.bymonthday.length; i++) {
                v = opts.bymonthday[i]
                if (v > 0) {
                    bymonthday.push(v)
                } else if (v < 0) {
                    bynmonthday.push(v)
                }
            }
            opts.bymonthday = bymonthday
            opts.bynmonthday = bynmonthday
        } else {
            if (opts.bymonthday < 0) {
                opts.bynmonthday = [opts.bymonthday]
                opts.bymonthday = []
            } else {
                opts.bynmonthday = []
                opts.bymonthday = [opts.bymonthday]
            }
        }

        // byweekno
        if (opts.byweekno !== null && !(opts.byweekno instanceof Array)) {
            opts.byweekno = [opts.byweekno]
        }

        // byweekday / bynweekday
        if (opts.byweekday === null) {
            opts.bynweekday = null
        } else if (typeof opts.byweekday === 'number') {
            opts.byweekday = [opts.byweekday]
            opts.bynweekday = null
        } else if (opts.byweekday instanceof Weekday) {
            if (!opts.byweekday.n || opts.freq > RRule.MONTHLY) {
                opts.byweekday = [opts.byweekday.weekday]
                opts.bynweekday = null
            } else {
                opts.bynweekday = [
                    [opts.byweekday.weekday, opts.byweekday.n]
                ]
                opts.byweekday = null
            }
        } else {
            var byweekday = []
            var bynweekday = []

            for (i = 0; i < opts.byweekday.length; i++) {
                var wday = opts.byweekday[i]

                if (typeof wday === 'number') {
                    byweekday.push(wday)
                } else if (!wday.n || opts.freq > RRule.MONTHLY) {
                    byweekday.push(wday.weekday)
                } else {
                    bynweekday.push([wday.weekday, wday.n])
                }
            }
            opts.byweekday = plb(byweekday) ? byweekday : null
            opts.bynweekday = plb(bynweekday) ? bynweekday : null
        }

        // byhour
        if (opts.byhour === null) {
            opts.byhour = (opts.freq < RRule.HOURLY) ? [opts.dtstart.getHours()] : null
        } else if (typeof opts.byhour === 'number') {
            opts.byhour = [opts.byhour]
        }

        // byminute
        if (opts.byminute === null) {
            opts.byminute = (opts.freq < RRule.MINUTELY)
                ? [opts.dtstart.getMinutes()] : null
        } else if (typeof opts.byminute === 'number') {
            opts.byminute = [opts.byminute]
        }

        // bysecond
        if (opts.bysecond === null) {
            opts.bysecond = (opts.freq < RRule.SECONDLY)
                ? [opts.dtstart.getSeconds()] : null
        } else if (typeof opts.bysecond === 'number') {
            opts.bysecond = [opts.bysecond]
        }

        if (opts.freq >= RRule.HOURLY) {
            this.timeset = null
        } else {
            this.timeset = []
            for (i = 0; i < opts.byhour.length; i++) {
                var hour = opts.byhour[i]
                for (var j = 0; j < opts.byminute.length; j++) {
                    var minute = opts.byminute[j]
                    for (var k = 0; k < opts.bysecond.length; k++) {
                        var second = opts.bysecond[k]
                        // python:
                        // datetime.time(hour, minute, second,
                        // tzinfo=self._tzinfo))
                        this.timeset.push(new dateutil.Time(hour, minute, second, millisecondModulo))
                    }
                }
            }
            dateutil.sort(this.timeset)
        }
    }

    // RRule class 'constants'

    RRule.FREQUENCIES = [
        'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY',
        'HOURLY', 'MINUTELY', 'SECONDLY'
    ]

    RRule.YEARLY = 0
    RRule.MONTHLY = 1
    RRule.WEEKLY = 2
    RRule.DAILY = 3
    RRule.HOURLY = 4
    RRule.MINUTELY = 5
    RRule.SECONDLY = 6

    RRule.MO = new Weekday(0)
    RRule.TU = new Weekday(1)
    RRule.WE = new Weekday(2)
    RRule.TH = new Weekday(3)
    RRule.FR = new Weekday(4)
    RRule.SA = new Weekday(5)
    RRule.SU = new Weekday(6)

    RRule.DEFAULT_OPTIONS = {
        freq: null,
        dtstart: null,
        interval: 1,
        wkst: RRule.MO,
        count: null,
        until: null,
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: null,
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
    }

    RRule.parseText = function (text, language) {
        return getnlp().parseText(text, language)
    }

    RRule.fromText = function (text, language) {
        return getnlp().fromText(text, language)
    }

    RRule.optionsToString = function (options) {
        var key, value, strValues
        var pairs = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        for (var i = 0; i < keys.length; i++) {
            if (!contains(defaultKeys, keys[i])) continue

            key = keys[i].toUpperCase()
            value = options[keys[i]]
            strValues = []

            if (value === null || value instanceof Array && !value.length) continue

            switch (key) {
                case 'FREQ':
                    value = RRule.FREQUENCIES[options.freq]
                    break
                case 'WKST':
                    value = value.toString()
                    break
                case 'BYWEEKDAY':
                    /*
                    NOTE: BYWEEKDAY is a special case.
                    RRule() deconstructs the rule.options.byweekday array
                    into an array of Weekday arguments.
                    On the other hand, rule.origOptions is an array of Weekdays.
                    We need to handle both cases here.
                    It might be worth change RRule to keep the Weekdays.
          
                    Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
          
                    */
                    key = 'BYDAY'
                    if (!(value instanceof Array)) value = [value]

                    for (var wday, j = 0; j < value.length; j++) {
                        wday = value[j]
                        if (wday instanceof Weekday) {
                            // good
                        } else if (wday instanceof Array) {
                            wday = new Weekday(wday[0], wday[1])
                        } else {
                            wday = new Weekday(wday)
                        }
                        strValues[j] = wday.toString()
                    }
                    value = strValues
                    break
                case 'DTSTART':
                case 'UNTIL':
                    value = dateutil.timeToUntilString(value)
                    break
                default:
                    if (value instanceof Array) {
                        for (j = 0; j < value.length; j++) strValues[j] = String(value[j])
                        value = strValues
                    } else {
                        value = String(value)
                    }

            }
            pairs.push([key, value])
        }

        var strings = []
        for (i = 0; i < pairs.length; i++) {
            var attr = pairs[i]
            strings.push(attr[0] + '=' + attr[1].toString())
        }
        return strings.join(';')
    }

    RRule.prototype = {
        constructor: RRule,

        /**
         * @param {Function} iterator - optional function that will be called
         *                   on each date that is added. It can return false
         *                   to stop the iteration.
         * @return Array containing all recurrences.
         */
        all: function (iterator) {
            if (iterator) {
                return this._iter(new CallbackIterResult('all', {}, iterator))
            } else {
                var result = this._cacheGet('all')
                if (result === false) {
                    result = this._iter(new IterResult('all', {}))
                    this._cacheAdd('all', result)
                }
                return result
            }
        },

        /**
         * Returns all the occurrences of the rrule between after and before.
         * The inc keyword defines what happens if after and/or before are
         * themselves occurrences. With inc == True, they will be included in the
         * list, if they are found in the recurrence set.
         * @return Array
         */
        between: function (after, before, inc, iterator) {
            var args = {
                before: before,
                after: after,
                inc: inc
            }

            if (iterator) {
                return this._iter(new CallbackIterResult('between', args, iterator))
            }
            var result = this._cacheGet('between', args)
            if (result === false) {
                result = this._iter(new IterResult('between', args))
                this._cacheAdd('between', result, args)
            }
            return result
        },

        /**
         * Returns the last recurrence before the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        before: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('before', args)
            if (result === false) {
                result = this._iter(new IterResult('before', args))
                this._cacheAdd('before', result, args)
            }
            return result
        },

        /**
         * Returns the first recurrence after the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        after: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('after', args)
            if (result === false) {
                result = this._iter(new IterResult('after', args))
                this._cacheAdd('after', result, args)
            }
            return result
        },

        /**
         * Returns the number of recurrences in this set. It will have go trough
         * the whole recurrence, if this hasn't been done before.
         */
        count: function () {
            return this.all().length
        },

        /**
         * Converts the rrule into its string representation
         * @see <https://www.ietf.org/rfc/rfc2445.txt>
         * @return String
         */
        toString: function () {
            return RRule.optionsToString(this.origOptions)
        },

        /**
        * Will convert all rules described in nlp:ToText
        * to text.
        */
        toText: function (gettext, language) {
            return getnlp().toText(this, gettext, language)
        },

        isFullyConvertibleToText: function () {
            return getnlp().isFullyConvertible(this)
        },

        /**
         * @param {String} what - all/before/after/between
         * @param {Array,Date} value - an array of dates, one date, or null
         * @param {Object?} args - _iter arguments
         */
        _cacheAdd: function (what, value, args) {
            if (!this._cache) return

            if (value) {
                value = (value instanceof Date)
                    ? dateutil.clone(value) : dateutil.cloneDates(value)
            }

            if (what === 'all') {
                this._cache.all = value
            } else {
                args._value = value
                this._cache[what].push(args)
            }
        },

        /**
         * @return false - not in the cache
         *         null  - cached, but zero occurrences (before/after)
         *         Date  - cached (before/after)
         *         []    - cached, but zero occurrences (all/between)
         *         [Date1, DateN] - cached (all/between)
         */
        _cacheGet: function (what, args) {
            if (!this._cache) return false

            var cached = false
            var argsKeys = args ? Object.keys(args) : []
            var findCacheDiff = function (item) {
                for (var key, i = 0; i < argsKeys.length; i++) {
                    key = argsKeys[i]
                    if (String(args[key]) !== String(item[key])) return true
                }
                return false
            }

            if (what === 'all') {
                cached = this._cache.all
            } else {
                // Let's see whether we've already called the
                // 'what' method with the same 'args'
                for (var item, i = 0; i < this._cache[what].length; i++) {
                    item = this._cache[what][i]
                    if (argsKeys.length && findCacheDiff(item)) continue
                    cached = item._value
                    break
                }
            }

            if (!cached && this._cache.all) {
                // Not in the cache, but we already know all the occurrences,
                // so we can find the correct dates from the cached ones.
                var iterResult = new IterResult(what, args)
                for (i = 0; i < this._cache.all.length; i++) {
                    if (!iterResult.accept(this._cache.all[i])) break
                }
                cached = iterResult.getValue()
                this._cacheAdd(what, cached, args)
            }

            return cached instanceof Array
                ? dateutil.cloneDates(cached)
                : (cached instanceof Date ? dateutil.clone(cached) : cached)
        },

        /**
         * @return a RRule instance with the same freq and options
         *          as this one (cache is not cloned)
         */
        clone: function () {
            return new RRule(this.origOptions)
        },

        _iter: function (iterResult) {
            /* Since JavaScript doesn't have the python's yield operator (<1.7),
               we use the IterResult object that tells us when to stop iterating.
      
            */

            var dtstart = this.options.dtstart
            var dtstartMillisecondModulo = this.options.dtstart % 1000

            var year = dtstart.getFullYear()
            var month = dtstart.getMonth() + 1
            var day = dtstart.getDate()
            var hour = dtstart.getHours()
            var minute = dtstart.getMinutes()
            var second = dtstart.getSeconds()
            var weekday = dateutil.getWeekday(dtstart)

            // Some local variables to speed things up a bit
            var freq = this.options.freq
            var interval = this.options.interval
            var wkst = this.options.wkst
            var until = this.options.until
            var bymonth = this.options.bymonth
            var byweekno = this.options.byweekno
            var byyearday = this.options.byyearday
            var byweekday = this.options.byweekday
            var byeaster = this.options.byeaster
            var bymonthday = this.options.bymonthday
            var bynmonthday = this.options.bynmonthday
            var bysetpos = this.options.bysetpos
            var byhour = this.options.byhour
            var byminute = this.options.byminute
            var bysecond = this.options.bysecond

            var ii = new Iterinfo(this)
            ii.rebuild(year, month)

            var getdayset = {}
            getdayset[RRule.YEARLY] = ii.ydayset
            getdayset[RRule.MONTHLY] = ii.mdayset
            getdayset[RRule.WEEKLY] = ii.wdayset
            getdayset[RRule.DAILY] = ii.ddayset
            getdayset[RRule.HOURLY] = ii.ddayset
            getdayset[RRule.MINUTELY] = ii.ddayset
            getdayset[RRule.SECONDLY] = ii.ddayset

            getdayset = getdayset[freq]

            var timeset
            if (freq < RRule.HOURLY) {
                timeset = this.timeset
            } else {
                var gettimeset = {}
                gettimeset[RRule.HOURLY] = ii.htimeset
                gettimeset[RRule.MINUTELY] = ii.mtimeset
                gettimeset[RRule.SECONDLY] = ii.stimeset
                gettimeset = gettimeset[freq]
                if ((freq >= RRule.HOURLY && plb(byhour) && !contains(byhour, hour)) ||
                    (freq >= RRule.MINUTELY && plb(byminute) && !contains(byminute, minute)) ||
                    (freq >= RRule.SECONDLY && plb(bysecond) && !contains(bysecond, minute))) {
                    timeset = []
                } else {
                    timeset = gettimeset.call(ii, hour, minute, second, dtstartMillisecondModulo)
                }
            }

            var total = 0
            var count = this.options.count
            var i, j, k, dm, div, mod, tmp, pos, dayset, start, end, fixday, filtered

            while (true) {
                // Get dayset with the right frequency
                tmp = getdayset.call(ii, year, month, day)
                dayset = tmp[0]
                start = tmp[1]
                end = tmp[2]

                // Do the "hard" work ;-)
                filtered = false
                for (j = start; j < end; j++) {
                    i = dayset[j]

                    filtered = (plb(bymonth) && !contains(bymonth, ii.mmask[i])) ||
                        (plb(byweekno) && !ii.wnomask[i]) ||
                        (plb(byweekday) && !contains(byweekday, ii.wdaymask[i])) ||
                        (plb(ii.nwdaymask) && !ii.nwdaymask[i]) ||
                        (byeaster !== null && !contains(ii.eastermask, i)) ||
                        ((plb(bymonthday) || plb(bynmonthday)) &&
                            !contains(bymonthday, ii.mdaymask[i]) &&
                            !contains(bynmonthday, ii.nmdaymask[i])) ||
                        (plb(byyearday) &&
                            ((i < ii.yearlen &&
                                !contains(byyearday, i + 1) &&
                                !contains(byyearday, -ii.yearlen + i)) ||
                                (i >= ii.yearlen &&
                                    !contains(byyearday, i + 1 - ii.yearlen) &&
                                    !contains(byyearday, -ii.nextyearlen + i - ii.yearlen))))

                    if (filtered) dayset[i] = null
                }

                // Output results
                if (plb(bysetpos) && plb(timeset)) {
                    var daypos, timepos
                    var poslist = []

                    for (i, j = 0; j < bysetpos.length; j++) {
                        pos = bysetpos[j]

                        if (pos < 0) {
                            daypos = Math.floor(pos / timeset.length)
                            timepos = pymod(pos, timeset.length)
                        } else {
                            daypos = Math.floor((pos - 1) / timeset.length)
                            timepos = pymod((pos - 1), timeset.length)
                        }

                        try {
                            tmp = []
                            for (k = start; k < end; k++) {
                                var val = dayset[k]
                                if (val === null) continue
                                tmp.push(val)
                            }
                            if (daypos < 0) {
                                // we're trying to emulate python's aList[-n]
                                i = tmp.slice(daypos)[0]
                            } else {
                                i = tmp[daypos]
                            }

                            var time = timeset[timepos]
                            var date = dateutil.fromOrdinal(ii.yearordinal + i)
                            var res = dateutil.combine(date, time)
                            // XXX: can this ever be in the array?
                            // - compare the actual date instead?
                            if (!contains(poslist, res)) poslist.push(res)
                        } catch (e) { }
                    }

                    dateutil.sort(poslist)
                    for (j = 0; j < poslist.length; j++) {
                        res = poslist[j]
                        if (until && res > until) {
                            this._len = total
                            return iterResult.getValue()
                        } else if (res >= dtstart) {
                            ++total
                            if (!iterResult.accept(res)) return iterResult.getValue()
                            if (count) {
                                --count
                                if (!count) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                        }
                    }
                } else {
                    for (j = start; j < end; j++) {
                        i = dayset[j]
                        if (i !== null) {
                            date = dateutil.fromOrdinal(ii.yearordinal + i)
                            for (k = 0; k < timeset.length; k++) {
                                time = timeset[k]
                                res = dateutil.combine(date, time)
                                if (until && res > until) {
                                    this._len = total
                                    return iterResult.getValue()
                                } else if (res >= dtstart) {
                                    ++total
                                    if (!iterResult.accept(res)) return iterResult.getValue()
                                    if (count) {
                                        --count
                                        if (!count) {
                                            this._len = total
                                            return iterResult.getValue()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // Handle frequency and interval
                fixday = false
                if (freq === RRule.YEARLY) {
                    year += interval
                    if (year > dateutil.MAXYEAR) {
                        this._len = total
                        return iterResult.getValue()
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.MONTHLY) {
                    month += interval
                    if (month > 12) {
                        div = Math.floor(month / 12)
                        mod = pymod(month, 12)
                        month = mod
                        year += div
                        if (month === 0) {
                            month = 12
                            --year
                        }
                        if (year > dateutil.MAXYEAR) {
                            this._len = total
                            return iterResult.getValue()
                        }
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.WEEKLY) {
                    if (wkst > weekday) {
                        day += -(weekday + 1 + (6 - wkst)) + interval * 7
                    } else {
                        day += -(weekday - wkst) + interval * 7
                    }
                    weekday = wkst
                    fixday = true
                } else if (freq === RRule.DAILY) {
                    day += interval
                    fixday = true
                } else if (freq === RRule.HOURLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        hour += Math.floor((23 - hour) / interval) * interval
                    }
                    while (true) {
                        hour += interval
                        dm = divmod(hour, 24)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            hour = mod
                            day += div
                            fixday = true
                        }
                        if (!plb(byhour) || contains(byhour, hour)) break
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.MINUTELY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        minute += Math.floor(
                            (1439 - (hour * 60 + minute)) / interval) * interval
                    }

                    while (true) {
                        minute += interval
                        dm = divmod(minute, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            minute = mod
                            hour += div
                            dm = divmod(hour, 24)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                hour = mod
                                day += div
                                fixday = true
                                filtered = false
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.SECONDLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        second += Math.floor(
                            (86399 - (hour * 3600 + minute * 60 + second)) / interval) * interval
                    }
                    while (true) {
                        second += interval
                        dm = divmod(second, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            second = mod
                            minute += div
                            dm = divmod(minute, 60)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                minute = mod
                                hour += div
                                dm = divmod(hour, 24)
                                div = dm.div
                                mod = dm.mod
                                if (div) {
                                    hour = mod
                                    day += div
                                    fixday = true
                                }
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute)) &&
                            (!plb(bysecond) || contains(bysecond, second))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                }

                if (fixday && day > 28) {
                    var daysinmonth = dateutil.monthRange(year, month - 1)[1]
                    if (day > daysinmonth) {
                        while (day > daysinmonth) {
                            day -= daysinmonth
                            ++month
                            if (month === 13) {
                                month = 1
                                ++year
                                if (year > dateutil.MAXYEAR) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                            daysinmonth = dateutil.monthRange(year, month - 1)[1]
                        }
                        ii.rebuild(year, month)
                    }
                }
            }
        }

    }

    RRule.parseString = function (rfcString) {
        rfcString = rfcString.replace(/^\s+|\s+$/, '')
        if (!rfcString.length) return null

        var i, j, key, value, attr
        var attrs = rfcString.split(';')
        var options = {}

        for (i = 0; i < attrs.length; i++) {
            attr = attrs[i].split('=')
            key = attr[0]
            value = attr[1]
            switch (key) {
                case 'FREQ':
                    options.freq = RRule[value]
                    break
                case 'WKST':
                    options.wkst = RRule[value]
                    break
                case 'COUNT':
                case 'INTERVAL':
                case 'BYSETPOS':
                case 'BYMONTH':
                case 'BYMONTHDAY':
                case 'BYYEARDAY':
                case 'BYWEEKNO':
                case 'BYHOUR':
                case 'BYMINUTE':
                case 'BYSECOND':
                    if (value.indexOf(',') !== -1) {
                        value = value.split(',')
                        for (j = 0; j < value.length; j++) {
                            if (/^[+-]?\d+$/.test(value[j])) value[j] = Number(value[j])
                        }
                    } else if (/^[+-]?\d+$/.test(value)) {
                        value = Number(value)
                    }
                    key = key.toLowerCase()
                    options[key] = value
                    break
                case 'BYDAY': // => byweekday
                    var n, wday, day
                    var days = value.split(',')

                    options.byweekday = []
                    for (j = 0; j < days.length; j++) {
                        day = days[j]
                        if (day.length === 2) { // MO, TU, ...
                            wday = RRule[day] // wday instanceof Weekday
                            options.byweekday.push(wday)
                        } else { // -1MO, +3FR, 1SO, ...
                            day = day.match(/^([+-]?\d)([A-Z]{2})$/)
                            n = Number(day[1])
                            wday = day[2]
                            wday = RRule[wday].weekday
                            options.byweekday.push(new Weekday(wday, n))
                        }
                    }
                    break
                case 'DTSTART':
                    options.dtstart = dateutil.untilStringToDate(value)
                    break
                case 'UNTIL':
                    options.until = dateutil.untilStringToDate(value)
                    break
                case 'BYEASTER':
                    options.byeaster = Number(value)
                    break
                default:
                    throw new Error("Unknown RRULE property '" + key + "'")
            }
        }
        return options
    }

    RRule.fromString = function (string) {
        return new RRule(RRule.parseString(string))
    }

    // =============================================================================
    // Iterinfo
    // =============================================================================

    var Iterinfo = function (rrule) {
        this.rrule = rrule
        this.lastyear = null
        this.lastmonth = null
        this.yearlen = null
        this.nextyearlen = null
        this.yearordinal = null
        this.yearweekday = null
        this.mmask = null
        this.mrange = null
        this.mdaymask = null
        this.nmdaymask = null
        this.wdaymask = null
        this.wnomask = null
        this.nwdaymask = null
        this.eastermask = null
    }

    Iterinfo.prototype.easter = function (y, offset) {
        offset = offset || 0

        var a = y % 19
        var b = Math.floor(y / 100)
        var c = y % 100
        var d = Math.floor(b / 4)
        var e = b % 4
        var f = Math.floor((b + 8) / 25)
        var g = Math.floor((b - f + 1) / 3)
        var h = Math.floor(19 * a + b - d - g + 15) % 30
        var i = Math.floor(c / 4)
        var k = c % 4
        var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7
        var m = Math.floor((a + 11 * h + 22 * l) / 451)
        var month = Math.floor((h + l - 7 * m + 114) / 31)
        var day = (h + l - 7 * m + 114) % 31 + 1
        var date = Date.UTC(y, month - 1, day + offset)
        var yearStart = Date.UTC(y, 0, 1)

        return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))]
    }

    Iterinfo.prototype.rebuild = function (year, month) {
        var rr = this.rrule

        if (year !== this.lastyear) {
            this.yearlen = dateutil.isLeapYear(year) ? 366 : 365
            this.nextyearlen = dateutil.isLeapYear(year + 1) ? 366 : 365
            var firstyday = new Date(year, 0, 1)

            this.yearordinal = dateutil.toOrdinal(firstyday)
            this.yearweekday = dateutil.getWeekday(firstyday)

            var wday = dateutil.getWeekday(new Date(year, 0, 1))

            if (this.yearlen === 365) {
                this.mmask = [].concat(M365MASK)
                this.mdaymask = [].concat(MDAY365MASK)
                this.nmdaymask = [].concat(NMDAY365MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M365RANGE)
            } else {
                this.mmask = [].concat(M366MASK)
                this.mdaymask = [].concat(MDAY366MASK)
                this.nmdaymask = [].concat(NMDAY366MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M366RANGE)
            }

            if (!plb(rr.options.byweekno)) {
                this.wnomask = null
            } else {
                this.wnomask = repeat(0, this.yearlen + 7)
                var no1wkst, firstwkst, wyearlen
                no1wkst = firstwkst = pymod(7 - this.yearweekday + rr.options.wkst, 7)
                if (no1wkst >= 4) {
                    no1wkst = 0
                    // Number of days in the year, plus the days we got
                    // from last year.
                    wyearlen = this.yearlen + pymod(this.yearweekday - rr.options.wkst, 7)
                } else {
                    // Number of days in the year, minus the days we
                    // left in last year.
                    wyearlen = this.yearlen - no1wkst
                }
                var div = Math.floor(wyearlen / 7)
                var mod = pymod(wyearlen, 7)
                var numweeks = Math.floor(div + (mod / 4))
                for (var n, i, j = 0; j < rr.options.byweekno.length; j++) {
                    n = rr.options.byweekno[j]
                    if (n < 0) {
                        n += numweeks + 1
                    } if (!(n > 0 && n <= numweeks)) {
                        continue
                    } if (n > 1) {
                        i = no1wkst + (n - 1) * 7
                        if (no1wkst !== firstwkst) {
                            i -= 7 - firstwkst
                        }
                    } else {
                        i = no1wkst
                    }
                    for (var k = 0; k < 7; k++) {
                        this.wnomask[i] = 1
                        i++
                        if (this.wdaymask[i] === rr.options.wkst) break
                    }
                }

                if (contains(rr.options.byweekno, 1)) {
                    // Check week number 1 of next year as well
                    // orig-TODO : Check -numweeks for next year.
                    i = no1wkst + numweeks * 7
                    if (no1wkst !== firstwkst) i -= 7 - firstwkst
                    if (i < this.yearlen) {
                        // If week starts in next year, we
                        // don't care about it.
                        for (j = 0; j < 7; j++) {
                            this.wnomask[i] = 1
                            i += 1
                            if (this.wdaymask[i] === rr.options.wkst) break
                        }
                    }
                }

                if (no1wkst) {
                    // Check last week number of last year as
                    // well. If no1wkst is 0, either the year
                    // started on week start, or week number 1
                    // got days from last year, so there are no
                    // days from last year's last week number in
                    // this year.
                    var lnumweeks
                    if (!contains(rr.options.byweekno, -1)) {
                        var lyearweekday = dateutil.getWeekday(new Date(year - 1, 0, 1))
                        var lno1wkst = pymod(7 - lyearweekday + rr.options.wkst, 7)
                        var lyearlen = dateutil.isLeapYear(year - 1) ? 366 : 365
                        if (lno1wkst >= 4) {
                            lno1wkst = 0
                            lnumweeks = Math.floor(52 +
                                pymod(lyearlen + pymod(lyearweekday - rr.options.wkst, 7), 7) / 4)
                        } else {
                            lnumweeks = Math.floor(52 + pymod(this.yearlen - no1wkst, 7) / 4)
                        }
                    } else {
                        lnumweeks = -1
                    }
                    if (contains(rr.options.byweekno, lnumweeks)) {
                        for (i = 0; i < no1wkst; i++) this.wnomask[i] = 1
                    }
                }
            }
        }

        if (plb(rr.options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
            var ranges = []
            if (rr.options.freq === RRule.YEARLY) {
                if (plb(rr.options.bymonth)) {
                    for (j = 0; j < rr.options.bymonth.length; j++) {
                        month = rr.options.bymonth[j]
                        ranges.push(this.mrange.slice(month - 1, month + 1))
                    }
                } else {
                    ranges = [[0, this.yearlen]]
                }
            } else if (rr.options.freq === RRule.MONTHLY) {
                ranges = [this.mrange.slice(month - 1, month + 1)]
            }
            if (plb(ranges)) {
                // Weekly frequency won't get here, so we may not
                // care about cross-year weekly periods.
                this.nwdaymask = repeat(0, this.yearlen)

                for (j = 0; j < ranges.length; j++) {
                    var rang = ranges[j]
                    var first = rang[0]
                    var last = rang[1]
                    last -= 1
                    for (k = 0; k < rr.options.bynweekday.length; k++) {
                        wday = rr.options.bynweekday[k][0]
                        n = rr.options.bynweekday[k][1]
                        if (n < 0) {
                            i = last + (n + 1) * 7
                            i -= pymod(this.wdaymask[i] - wday, 7)
                        } else {
                            i = first + (n - 1) * 7
                            i += pymod(7 - this.wdaymask[i] + wday, 7)
                        }
                        if (first <= i && i <= last) this.nwdaymask[i] = 1
                    }
                }
            }

            this.lastyear = year
            this.lastmonth = month
        }

        if (rr.options.byeaster !== null) {
            this.eastermask = this.easter(year, rr.options.byeaster)
        }
    }

    Iterinfo.prototype.ydayset = function (year, month, day) {
        return [range(this.yearlen), 0, this.yearlen]
    }

    Iterinfo.prototype.mdayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var start = this.mrange[month - 1]
        var end = this.mrange[month]
        for (var i = start; i < end; i++) set[i] = i
        return [set, start, end]
    }

    Iterinfo.prototype.wdayset = function (year, month, day) {
        // We need to handle cross-year weeks here.
        var set = repeat(null, this.yearlen + 7)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        var start = i
        for (var j = 0; j < 7; j++) {
            set[i] = i
            ++i
            if (this.wdaymask[i] === this.rrule.options.wkst) break
        }
        return [set, start, i]
    }

    Iterinfo.prototype.ddayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        set[i] = i
        return [set, i, i + 1]
    }

    Iterinfo.prototype.htimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var i = 0; i < rr.options.byminute.length; i++) {
            minute = rr.options.byminute[i]
            for (var j = 0; j < rr.options.bysecond.length; j++) {
                second = rr.options.bysecond[j]
                set.push(new dateutil.Time(hour, minute, second, millisecond))
            }
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.mtimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var j = 0; j < rr.options.bysecond.length; j++) {
            second = rr.options.bysecond[j]
            set.push(new dateutil.Time(hour, minute, second, millisecond))
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
        return [new dateutil.Time(hour, minute, second, millisecond)]
    }

    // =============================================================================
    // Results
    // =============================================================================

    /**
     * This class helps us to emulate python's generators, sorta.
     */
    var IterResult = function (method, args) {
        this.init(method, args)
    }

    IterResult.prototype = {
        constructor: IterResult,
        init: function (method, args) {
            this.method = method
            this.args = args
            this.minDate = null
            this.maxDate = null
            this._result = []

            if (method === 'between') {
                this.maxDate = args.inc
                    ? args.before : new Date(args.before.getTime() - 1)
                this.minDate = args.inc
                    ? args.after : new Date(args.after.getTime() + 1)
            } else if (method === 'before') {
                this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1)
            } else if (method === 'after') {
                this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1)
            }
        },

        /**
         * Possibly adds a date into the result.
         *
         * @param {Date} date - the date isn't necessarly added to the result
         *                      list (if it is too late/too early)
         * @return {Boolean} true if it makes sense to continue the iteration
         *                   false if we're done.
         */
        accept: function (date) {
            var tooEarly = this.minDate && date < this.minDate
            var tooLate = this.maxDate && date > this.maxDate

            if (this.method === 'between') {
                if (tooEarly) return true
                if (tooLate) return false
            } else if (this.method === 'before') {
                if (tooLate) return false
            } else if (this.method === 'after') {
                if (tooEarly) return true
                this.add(date)
                return false
            }

            return this.add(date)
        },

        /**
         *
         * @param {Date} date that is part of the result.
         * @return {Boolean} whether we are interested in more values.
         */
        add: function (date) {
            this._result.push(date)
            return true
        },

        /**
         * 'before' and 'after' return only one date, whereas 'all'
         * and 'between' an array.
         * @return {Date,Array?}
         */
        getValue: function () {
            var res = this._result
            switch (this.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                case 'after':
                    return res.length ? res[res.length - 1] : null
            }
        },

        clone: function () {
            return new IterResult(this.method, this.args)
        }
    }

    /**
     * IterResult subclass that calls a callback function on each add,
     * and stops iterating when the callback returns false.
     */
    var CallbackIterResult = function (method, args, iterator) {
        var allowedMethods = ['all', 'between']
        if (!contains(allowedMethods, method)) {
            throw new Error('Invalid method "' + method +
                '". Only all and between works with iterator.')
        }
        this.add = function (date) {
            if (iterator(date, this._result.length)) {
                this._result.push(date)
                return true
            }
            return false
        }

        this.init(method, args)
    }
    CallbackIterResult.prototype = IterResult.prototype

    /**
     *
     * @param {Boolean?} noCache
     *  The same stratagy as RRule on cache, default to false
     * @constructor
     */

    var RRuleSet = function (noCache) {
        // Let RRuleSet cacheable
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }
        this._rrule = []
        this._rdate = []
        this._exrule = []
        this._exdate = []
    }

    RRuleSet.prototype = {
        constructor: RRuleSet,

        /**
        * @param {RRule}
        */
        rrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._rrule.map(String), String(rrule))) {
                this._rrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        rdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._rdate.map(Number), Number(date))) {
                this._rdate.push(date)
                dateutil.sort(this._rdate)
            }
        },

        /**
        * @param {RRule}
        */
        exrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._exrule.map(String), String(rrule))) {
                this._exrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        exdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._exdate.map(Number), Number(date))) {
                this._exdate.push(date)
                dateutil.sort(this._exdate)
            }
        },

        valueOf: function () {
            var result = []
            if (this._rrule.length) {
                this._rrule.forEach(function (rrule) {
                    result.push('RRULE:' + rrule)
                })
            }
            if (this._rdate.length) {
                result.push('RDATE:' + this._rdate.map(function (rdate) {
                    return dateutil.timeToUntilString(rdate)
                }).join(','))
            }
            if (this._exrule.length) {
                this._exrule.forEach(function (exrule) {
                    result.push('EXRULE:' + exrule)
                })
            }
            if (this._exdate.length) {
                result.push('EXDATE:' + this._exdate.map(function (exdate) {
                    return dateutil.timeToUntilString(exdate)
                }).join(','))
            }
            return result
        },

        /**
        * to generate recurrence field sush as:
        *   ["RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU;DTSTART=19970902T010000Z","RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH;DTSTART=19970902T010000Z"]
        */
        toString: function () {
            return JSON.stringify(this.valueOf())
        },

        _iter: function (iterResult) {
            var _exdateHash = {}
            var _exrule = this._exrule
            var _accept = iterResult.accept

            function evalExdate(after, before) {
                _exrule.forEach(function (rrule) {
                    rrule.between(after, before, true).forEach(function (date) {
                        _exdateHash[Number(date)] = true
                    })
                })
            }

            this._exdate.forEach(function (date) {
                _exdateHash[Number(date)] = true
            })

            iterResult.accept = function (date) {
                var dt = Number(date)
                if (!_exdateHash[dt]) {
                    evalExdate(new Date(dt - 1), new Date(dt + 1))
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                }
                return true
            }

            if (iterResult.method === 'between') {
                evalExdate(iterResult.args.after, iterResult.args.before)
                iterResult.accept = function (date) {
                    var dt = Number(date)
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                    return true
                }
            }

            for (var i = 0; i < this._rdate.length; i++) {
                if (!iterResult.accept(new Date(this._rdate[i]))) break
            }

            this._rrule.forEach(function (rrule) {
                rrule._iter(iterResult)
            })

            var res = iterResult._result
            dateutil.sort(res)
            switch (iterResult.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                    return (res.length && res[res.length - 1]) || null
                case 'after':
                    return (res.length && res[0]) || null
                default:
                    return null
            }
        },

        /**
        * Create a new RRuleSet Object completely base on current instance
        */
        clone: function () {
            var rrs = new RRuleSet(!!this._cache)
            var i
            for (i = 0; i < this._rrule.length; i++) {
                rrs.rrule(this._rrule[i].clone())
            }
            for (i = 0; i < this._rdate.length; i++) {
                rrs.rdate(new Date(this._rdate[i]))
            }
            for (i = 0; i < this._exrule.length; i++) {
                rrs.exrule(this._exrule[i].clone())
            }
            for (i = 0; i < this._exdate.length; i++) {
                rrs.exdate(new Date(this._exdate[i]))
            }
            return rrs
        }
    }

    /**
     * Inherts method from RRule
     *  add Read interface and set RRuleSet cacheable
     */
    var RRuleSetMethods = ['all', 'between', 'before', 'after', 'count', '_cacheAdd', '_cacheGet']
    RRuleSetMethods.forEach(function (method) {
        RRuleSet.prototype[method] = RRule.prototype[method]
    })

    /**
     * RRuleStr
     *  To parse a set of rrule strings
     */

    var RRuleStr = function () { }

    RRuleStr.DEFAULT_OPTIONS = {
        dtstart: null,
        cache: false,
        unfold: false,
        forceset: false,
        compatible: false,
        ignoretz: false,
        tzinfos: null
    }

    RRuleStr._freq_map = {
        'YEARLY': RRule.YEARLY,
        'MONTHLY': RRule.MONTHLY,
        'WEEKLY': RRule.WEEKLY,
        'DAILY': RRule.DAILY,
        'HOURLY': RRule.HOURLY,
        'MINUTELY': RRule.MINUTELY,
        'SECONDLY': RRule.SECONDLY
    }

    RRuleStr._weekday_map = {
        'MO': 0,
        'TU': 1,
        'WE': 2,
        'TH': 3,
        'FR': 4,
        'SA': 5,
        'SU': 6
    }

    RRuleStr.prototype = {
        constructor: RRuleStr,

        _handle_int: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = parseInt(value, 10)
        },

        _handle_int_list: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = value.split(',').map(function (x) {
                return parseInt(x, 10)
            })
        },

        _handle_FREQ: function (rrkwargs, name, value, options) {
            rrkwargs['freq'] = RRuleStr._freq_map[value]
        },

        _handle_UNTIL: function (rrkwargs, name, value, options) {
            try {
                rrkwargs['until'] = dateutil.untilStringToDate(value)
            } catch (error) {
                throw new Error('invalid until date')
            }
        },

        _handle_WKST: function (rrkwargs, name, value, options) {
            rrkwargs['wkst'] = RRuleStr._weekday_map[value]
        },

        _handle_BYWEEKDAY: function (rrkwargs, name, value, options) {
            // Two ways to specify this: +1MO or MO(+1)
            var splt, i, j, n, w, wday
            var l = []
            var wdays = value.split(',')

            for (i = 0; i < wdays.length; i++) {
                wday = wdays[i]
                if (wday.indexOf('(') > -1) {
                    // If it's of the form TH(+1), etc.
                    splt = wday.split('(')
                    w = splt[0]
                    n = parseInt(splt.slice(1, -1), 10)
                } else {
                    // # If it's of the form +1MO
                    for (j = 0; j < wday.length; j++) {
                        if ('+-0123456789'.indexOf(wday[j]) === -1) break
                    }
                    n = wday.slice(0, j) || null
                    w = wday.slice(j)

                    if (n) n = parseInt(n, 10)
                }

                var weekday = new Weekday(RRuleStr._weekday_map[w], n)
                l.push(weekday)
            }
            rrkwargs['byweekday'] = l
        },

        _parseRfcRRule: function (line, options) {
            options = options || {}
            options.dtstart = options.dtstart || null
            options.cache = options.cache || false
            options.ignoretz = options.ignoretz || false
            options.tzinfos = options.tzinfos || null

            var name, value, parts
            if (line.indexOf(':') !== -1) {
                parts = line.split(':')
                name = parts[0]
                value = parts[1]

                if (name !== 'RRULE') throw new Error('unknown parameter name')
            } else {
                value = line
            }

            var i
            var rrkwargs = {}
            var pairs = value.split(';')

            for (i = 0; i < pairs.length; i++) {
                parts = pairs[i].split('=')
                name = parts[0].toUpperCase()
                value = parts[1].toUpperCase()

                try {
                    this['_handle_' + name](rrkwargs, name, value, {
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                } catch (error) {
                    throw new Error("unknown parameter '" + name + "':" + value)
                }
            }
            rrkwargs.dtstart = rrkwargs.dtstart || options.dtstart
            return new RRule(rrkwargs, !options.cache)
        },

        _parseRfc: function (s, options) {
            if (options.compatible) {
                options.forceset = true
                options.unfold = true
            }

            s = s && s.toUpperCase().trim()
            if (!s) throw new Error('Invalid empty string')

            var i = 0
            var line, lines

            // More info about 'unfold' option
            // Go head to https://www.ietf.org/rfc/rfc2445.txt
            if (options.unfold) {
                lines = s.split('\n')
                while (i < lines.length) {
                    // TODO
                    line = lines[i] = lines[i].replace(/\s+$/g, '')
                    if (!line) {
                        lines.splice(i, 1)
                    } else if (i > 0 && line[0] === ' ') {
                        lines[i - 1] += line.slice(1)
                        lines.splice(i, 1)
                    } else {
                        i += 1
                    }
                }
            } else {
                lines = s.split(/\s/)
            }

            var rrulevals = []
            var rdatevals = []
            var exrulevals = []
            var exdatevals = []
            var name, value, parts, parms, parm, dtstart, rset, j, k, datestrs, datestr

            if (!options.forceset && lines.length === 1 && (s.indexOf(':') === -1 ||
                s.indexOf('RRULE:') === 0)) {
                return this._parseRfcRRule(lines[0], {
                    cache: options.cache,
                    dtstart: options.dtstart,
                    ignoretz: options.ignoretz,
                    tzinfos: options.tzinfos
                })
            } else {
                for (i = 0; i < lines.length; i++) {
                    line = lines[i]
                    if (!line) continue
                    if (line.indexOf(':') === -1) {
                        name = 'RRULE'
                        value = line
                    } else {
                        parts = split(line, ':', 1)
                        name = parts[0]
                        value = parts[1]
                    }
                    parms = name.split(';')
                    if (!parms) throw new Error('empty property name')
                    name = parms[0]
                    parms = parms.slice(1)

                    if (name === 'RRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported RRULE parm: ' + parm)
                        }
                        rrulevals.push(value)
                    } else if (name === 'RDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        rdatevals.push(value)
                    } else if (name === 'EXRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported EXRULE parm: ' + parm)
                        }
                        exrulevals.push(value)
                    } else if (name === 'EXDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        exdatevals.push(value)
                    } else if (name === 'DTSTART') {
                        dtstart = dateutil.untilStringToDate(value)
                    } else {
                        throw new Error('unsupported property: ' + name)
                    }
                }

                if (options.forceset || rrulevals.length > 1 || rdatevals.length ||
                    exrulevals.length || exdatevals.length) {
                    rset = new RRuleSet(!options.cache)
                    for (j = 0; j < rrulevals.length; j++) {
                        rset.rrule(this._parseRfcRRule(rrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < rdatevals.length; j++) {
                        datestrs = rdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.rdate(dateutil.untilStringToDate(datestr))
                        }
                    }
                    for (j = 0; j < exrulevals.length; j++) {
                        rset.exrule(this._parseRfcRRule(exrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < exdatevals.length; j++) {
                        datestrs = exdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.exdate(dateutil.untilStringToDate(datestr))
                        }
                    }

                    if (options.campatiable && options.dtstart) rset.rdate(dtstart)
                    return rset
                } else {
                    return this._parseRfcRRule(rrulevals[0], {
                        dtstart: options.dtstart || dtstart,
                        cache: options.cache,
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                }
            }
        },

        parse: function (s, options) {
            options = options || {}

            var invalid = []
            var keys = Object.keys(options)
            var defaultKeys = Object.keys(RRuleStr.DEFAULT_OPTIONS)

            keys.forEach(function (key) {
                if (!contains(defaultKeys, key)) invalid.push(key)
            }, this)

            if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

            // Merge in default options
            defaultKeys.forEach(function (key) {
                if (!contains(keys, key)) options[key] = RRuleStr.DEFAULT_OPTIONS[key]
            })

            return this._parseRfc(s, options)
        }
    }

    RRuleStr.prototype._handle_DTSTART = function (rrkwargs, name, value, options) {
        rrkwargs[name.toLowerCase()] = dateutil.untilStringToDate(value)
    }

    RRuleStr.prototype._handle_BYDAY = RRuleStr.prototype._handle_BYWEEKDAY
    RRuleStr.prototype._handle_INTERVAL = RRuleStr.prototype._handle_int
    RRuleStr.prototype._handle_COUNT = RRuleStr.prototype._handle_int

        ;[
            '_handle_BYSETPOS', '_handle_BYMONTH', '_handle_BYMONTHDAY',
            '_handle_BYYEARDAY', '_handle_BYEASTER', '_handle_BYWEEKNO',
            '_handle_BYHOUR', '_handle_BYMINUTE', '_handle_BYSECOND'
        ].forEach(function (method) {
            RRuleStr.prototype[method] = RRuleStr.prototype._handle_int_list
        })

    // =============================================================================
    // Export
    // =============================================================================

    // Only one RRuleStr instance for all rrule string parsing work.
    var rruleStr = new RRuleStr()
    var rrulestr = function () {
        return rruleStr.parse.apply(rruleStr, arguments)
    }

    RRule.RRule = RRule
    RRule.RRuleSet = RRuleSet
    RRule.rrulestr = rrulestr
    return RRule

    function getnlp() {
        // Lazy, runtime import to avoid circular refs.
        if (!getnlp._nlp) {
            if (root && root._getRRuleNLP) {
                getnlp._nlp = root._getRRuleNLP(RRule)
            } else if (typeof require === 'function') {
                getnlp._nlp = require('./nlp')(RRule)
            } else {
                throw new Error('You need to include rrule/nlp.js for fromText/toText to work.')
            }
        }
        return getnlp._nlp
    }
}))

//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

; (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            global.moment = factory()
}(this, (function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    var some$1 = some;

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !== 'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var keys$1 = keys;

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/;            //       0 - 9
    var match2 = /\d\d/;          //      00 - 99
    var match3 = /\d{3}/;         //     000 - 999
    var match4 = /\d{4}/;         //    0000 - 9999
    var match6 = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2 = /\d\d?/;         //       0 - 99
    var match3to4 = /\d\d\d\d?/;     //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/;       //       0 - 999
    var match1to4 = /\d{1,4}/;       //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned = /\d+/;           //       0 - inf
    var matchSigned = /[+-]?\d+/;      //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    var indexOf$1 = indexOf;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return this._months;
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return this._monthsShort;
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //https://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        if (!m) {
            return this._weekdays;
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // months
    // week
    // weekdays
    // meridiem
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See https://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys$1(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11 ? MONTH :
                    a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                        a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                            a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE :
                                a[SECOND] < 0 || a[SECOND] > 59 ? SECOND :
                                    a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                                        -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'https://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () { };

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof (input) === 'object') {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
            0 :
            parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () { };

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from https://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                    'See https://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                        diff < 2 ? 'nextDay' :
                            diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                    units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                        units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    function startOf(units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf() {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$1() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$1;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;

    // Year
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;

    // Week Year
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    proto.quarter = proto.quarters = getSetQuarter;

    // Month
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

    // Week
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;

    // Hour
    proto.hour = proto.hours = getSetHour;

    // Minute
    proto.minute = proto.minutes = getSetMinute;

    // Second
    proto.second = proto.seconds = getSetSecond;

    // Millisecond
    proto.millisecond = proto.milliseconds = getSetMillisecond;

    // Offset
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;

    // Timezone
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

    // Deprecations
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See https://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    // Month
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;

    // Week
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    // Hours
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week': return days / 7 + milliseconds / 6048e5;
                case 'day': return days + milliseconds / 864e5;
                case 'hour': return days * 24 + milliseconds / 36e5;
                case 'minute': return days * 1440 + milliseconds / 6e4;
                case 'second': return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asYears = makeAs('y');

    function get$2(units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds] ||
            minutes <= 1 && ['m'] ||
            minutes < thresholds.m && ['mm', minutes] ||
            hours <= 1 && ['h'] ||
            hours < thresholds.h && ['hh', hours] ||
            days <= 1 && ['d'] ||
            days < thresholds.d && ['dd', days] ||
            months <= 1 && ['M'] ||
            months < thresholds.M && ['MM', months] ||
            years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof (roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize(withSuffix) {
        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    // Deprecations
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.17.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    return hooks;

})));
/**
 * interact.js v1.2.9
 *
 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
(function (realWindow) {
    'use strict';

    // return early if there's no window to work with (eg. Node.js)
    if (!realWindow) { return; }

    var // get wrapped window if using Shadow DOM polyfill
        window = (function () {
            // create a TextNode
            var el = realWindow.document.createTextNode('');

            // check if it's wrapped by a polyfill
            if (el.ownerDocument !== realWindow.document
                && typeof realWindow.wrap === 'function'
                && realWindow.wrap(el) === el) {
                // return wrapped window
                return realWindow.wrap(realWindow);
            }

            // no Shadow DOM polyfil or native implementation
            return realWindow;
        }()),

        document = window.document,
        DocumentFragment = window.DocumentFragment || blank,
        SVGElement = window.SVGElement || blank,
        SVGSVGElement = window.SVGSVGElement || blank,
        SVGElementInstance = window.SVGElementInstance || blank,
        HTMLElement = window.HTMLElement || window.Element,

        PointerEvent = (window.PointerEvent || window.MSPointerEvent),
        pEventTypes,

        hypot = Math.hypot || function (x, y) { return Math.sqrt(x * x + y * y); },

        tmpXY = {},     // reduce object creation in getXY()

        documents = [],   // all documents being listened to

        interactables = [],   // all set interactables
        interactions = [],   // all interactions

        dynamicDrop = false,

        // {
        //      type: {
        //          selectors: ['selector', ...],
        //          contexts : [document, ...],
        //          listeners: [[listener, useCapture], ...]
        //      }
        //  }
        delegatedEvents = {},

        defaultOptions = {
            base: {
                accept: null,
                actionChecker: null,
                styleCursor: true,
                preventDefault: 'auto',
                origin: { x: 0, y: 0 },
                deltaSource: 'page',
                allowFrom: null,
                ignoreFrom: null,
                _context: document,
                dropChecker: null
            },

            drag: {
                enabled: false,
                manualStart: true,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                axis: 'xy'
            },

            drop: {
                enabled: false,
                accept: null,
                overlap: 'pointer'
            },

            resize: {
                enabled: false,
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                square: false,
                preserveAspectRatio: false,
                axis: 'xy',

                // use default margin
                margin: NaN,

                // object with props left, right, top, bottom which are
                // true/false values to resize when the pointer is over that edge,
                // CSS selectors to match the handles for each direction
                // or the Elements for each handle
                edges: null,

                // a value of 'none' will limit the resize rect to a minimum of 0x0
                // 'negate' will alow the rect to have negative width/height
                // 'reposition' will keep the width/height positive by swapping
                // the top and bottom edges and/or swapping the left and right edges
                invert: 'none'
            },

            gesture: {
                manualStart: false,
                enabled: false,
                max: Infinity,
                maxPerElement: 1,

                restrict: null
            },

            perAction: {
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: {
                    enabled: false,
                    endOnly: false,
                    range: Infinity,
                    targets: null,
                    offsets: null,

                    relativePoints: null
                },

                restrict: {
                    enabled: false,
                    endOnly: false
                },

                autoScroll: {
                    enabled: false,
                    container: null,     // the item that is scrolled (Window or HTMLElement)
                    margin: 60,
                    speed: 300       // the scroll speed in pixels per second
                },

                inertia: {
                    enabled: false,
                    resistance: 10,    // the lambda in exponential decay
                    minSpeed: 100,   // target speed must be above this for inertia to start
                    endSpeed: 10,    // the speed at which inertia is slow enough to stop
                    allowResume: true,  // allow resuming an action in inertia phase
                    zeroResumeDelta: true,  // if an action is resumed after launch, set dx/dy to 0
                    smoothEndDuration: 300    // animate to snap/restrict endOnly if there's no inertia
                }
            },

            _holdDuration: 600
        },

        // Things related to autoScroll
        autoScroll = {
            interaction: null,
            i: null,    // the handle returned by window.setInterval
            x: 0, y: 0, // Direction each pulse is to scroll in

            // scroll the window by the values in scroll.x/y
            scroll: function () {
                var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll,
                    container = options.container || getWindow(autoScroll.interaction.element),
                    now = new Date().getTime(),
                    // change in time in seconds
                    dtx = (now - autoScroll.prevTimeX) / 1000,
                    dty = (now - autoScroll.prevTimeY) / 1000,
                    vx, vy, sx, sy;

                // displacement
                if (options.velocity) {
                    vx = options.velocity.x;
                    vy = options.velocity.y;
                }
                else {
                    vx = vy = options.speed
                }

                sx = vx * dtx;
                sy = vy * dty;

                if (sx >= 1 || sy >= 1) {
                    if (isWindow(container)) {
                        container.scrollBy(autoScroll.x * sx, autoScroll.y * sy);
                    }
                    else if (container) {
                        container.scrollLeft += autoScroll.x * sx;
                        container.scrollTop += autoScroll.y * sy;
                    }

                    if (sx >= 1) autoScroll.prevTimeX = now;
                    if (sy >= 1) autoScroll.prevTimeY = now;
                }

                if (autoScroll.isScrolling) {
                    cancelFrame(autoScroll.i);
                    autoScroll.i = reqFrame(autoScroll.scroll);
                }
            },

            isScrolling: false,
            prevTimeX: 0,
            prevTimeY: 0,

            start: function (interaction) {
                autoScroll.isScrolling = true;
                cancelFrame(autoScroll.i);

                autoScroll.interaction = interaction;
                autoScroll.prevTimeX = new Date().getTime();
                autoScroll.prevTimeY = new Date().getTime();
                autoScroll.i = reqFrame(autoScroll.scroll);
            },

            stop: function () {
                autoScroll.isScrolling = false;
                cancelFrame(autoScroll.i);
            }
        },

        // Does the browser support touch input?
        supportsTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),

        // Does the browser support PointerEvents
        // Avoid PointerEvent bugs introduced in Chrome 55
        supportsPointerEvent = PointerEvent && !/Chrome/.test(navigator.userAgent),

        // Less Precision with touch input
        margin = supportsTouch || supportsPointerEvent ? 20 : 10,

        pointerMoveTolerance = 1,

        // for ignoring browser's simulated mouse events
        prevTouchTime = 0,

        // Allow this many interactions to happen simultaneously
        maxInteractions = Infinity,

        // Check if is IE9 or older
        actionCursors = (document.all && !window.atob) ? {
            drag: 'move',
            resizex: 'e-resize',
            resizey: 's-resize',
            resizexy: 'se-resize',

            resizetop: 'n-resize',
            resizeleft: 'w-resize',
            resizebottom: 's-resize',
            resizeright: 'e-resize',
            resizetopleft: 'se-resize',
            resizebottomright: 'se-resize',
            resizetopright: 'ne-resize',
            resizebottomleft: 'ne-resize',

            gesture: ''
        } : {
            drag: 'move',
            resizex: 'ew-resize',
            resizey: 'ns-resize',
            resizexy: 'nwse-resize',

            resizetop: 'ns-resize',
            resizeleft: 'ew-resize',
            resizebottom: 'ns-resize',
            resizeright: 'ew-resize',
            resizetopleft: 'nwse-resize',
            resizebottomright: 'nwse-resize',
            resizetopright: 'nesw-resize',
            resizebottomleft: 'nesw-resize',

            gesture: ''
        },

        actionIsEnabled = {
            drag: true,
            resize: true,
            gesture: true
        },

        // because Webkit and Opera still use 'mousewheel' event type
        wheelEvent = 'onmousewheel' in document ? 'mousewheel' : 'wheel',

        eventTypes = [
            'dragstart',
            'dragmove',
            'draginertiastart',
            'dragend',
            'dragenter',
            'dragleave',
            'dropactivate',
            'dropdeactivate',
            'dropmove',
            'drop',
            'resizestart',
            'resizemove',
            'resizeinertiastart',
            'resizeend',
            'gesturestart',
            'gesturemove',
            'gestureinertiastart',
            'gestureend',

            'down',
            'move',
            'up',
            'cancel',
            'tap',
            'doubletap',
            'hold'
        ],

        globalEvents = {},

        // Opera Mobile must be handled differently
        isOperaMobile = navigator.appName == 'Opera' &&
            supportsTouch &&
            navigator.userAgent.match('Presto'),

        // scrolling doesn't change the result of getClientRects on iOS 7
        isIOS7 = (/iP(hone|od|ad)/.test(navigator.platform)
            && /OS 7[^\d]/.test(navigator.appVersion)),

        // prefix matchesSelector
        prefixedMatchesSelector = 'matches' in Element.prototype ?
            'matches' : 'webkitMatchesSelector' in Element.prototype ?
                'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ?
                    'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ?
                        'oMatchesSelector' : 'msMatchesSelector',

        // will be polyfill function if browser is IE8
        ie8MatchesSelector,

        // native requestAnimationFrame or polyfill
        reqFrame = realWindow.requestAnimationFrame,
        cancelFrame = realWindow.cancelAnimationFrame,

        // Events wrapper
        events = (function () {
            var useAttachEvent = ('attachEvent' in window) && !('addEventListener' in window),
                addEvent = useAttachEvent ? 'attachEvent' : 'addEventListener',
                removeEvent = useAttachEvent ? 'detachEvent' : 'removeEventListener',
                on = useAttachEvent ? 'on' : '',

                elements = [],
                targets = [],
                attachedListeners = [];

            function add(element, type, listener, useCapture) {
                var elementIndex = indexOf(elements, element),
                    target = targets[elementIndex];

                if (!target) {
                    target = {
                        events: {},
                        typeCount: 0
                    };

                    elementIndex = elements.push(element) - 1;
                    targets.push(target);

                    attachedListeners.push((useAttachEvent ? {
                        supplied: [],
                        wrapped: [],
                        useCount: []
                    } : null));
                }

                if (!target.events[type]) {
                    target.events[type] = [];
                    target.typeCount++;
                }

                if (!contains(target.events[type], listener)) {
                    var ret;

                    if (useAttachEvent) {
                        var listeners = attachedListeners[elementIndex],
                            listenerIndex = indexOf(listeners.supplied, listener);

                        var wrapped = listeners.wrapped[listenerIndex] || function (event) {
                            if (!event.immediatePropagationStopped) {
                                event.target = event.srcElement;
                                event.currentTarget = element;

                                event.preventDefault = event.preventDefault || preventDef;
                                event.stopPropagation = event.stopPropagation || stopProp;
                                event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;

                                if (/mouse|click/.test(event.type)) {
                                    event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;
                                    event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;
                                }

                                listener(event);
                            }
                        };

                        ret = element[addEvent](on + type, wrapped, Boolean(useCapture));

                        if (listenerIndex === -1) {
                            listeners.supplied.push(listener);
                            listeners.wrapped.push(wrapped);
                            listeners.useCount.push(1);
                        }
                        else {
                            listeners.useCount[listenerIndex]++;
                        }
                    }
                    else {
                        ret = element[addEvent](type, listener, useCapture || false);
                    }
                    target.events[type].push(listener);

                    return ret;
                }
            }

            function remove(element, type, listener, useCapture) {
                var i,
                    elementIndex = indexOf(elements, element),
                    target = targets[elementIndex],
                    listeners,
                    listenerIndex,
                    wrapped = listener;

                if (!target || !target.events) {
                    return;
                }

                if (useAttachEvent) {
                    listeners = attachedListeners[elementIndex];
                    listenerIndex = indexOf(listeners.supplied, listener);
                    wrapped = listeners.wrapped[listenerIndex];
                }

                if (type === 'all') {
                    for (type in target.events) {
                        if (target.events.hasOwnProperty(type)) {
                            remove(element, type, 'all');
                        }
                    }
                    return;
                }

                if (target.events[type]) {
                    var len = target.events[type].length;

                    if (listener === 'all') {
                        for (i = 0; i < len; i++) {
                            remove(element, type, target.events[type][i], Boolean(useCapture));
                        }
                        return;
                    } else {
                        for (i = 0; i < len; i++) {
                            if (target.events[type][i] === listener) {
                                element[removeEvent](on + type, wrapped, useCapture || false);
                                target.events[type].splice(i, 1);

                                if (useAttachEvent && listeners) {
                                    listeners.useCount[listenerIndex]--;
                                    if (listeners.useCount[listenerIndex] === 0) {
                                        listeners.supplied.splice(listenerIndex, 1);
                                        listeners.wrapped.splice(listenerIndex, 1);
                                        listeners.useCount.splice(listenerIndex, 1);
                                    }
                                }

                                break;
                            }
                        }
                    }

                    if (target.events[type] && target.events[type].length === 0) {
                        target.events[type] = null;
                        target.typeCount--;
                    }
                }

                if (!target.typeCount) {
                    targets.splice(elementIndex, 1);
                    elements.splice(elementIndex, 1);
                    attachedListeners.splice(elementIndex, 1);
                }
            }

            function preventDef() {
                this.returnValue = false;
            }

            function stopProp() {
                this.cancelBubble = true;
            }

            function stopImmProp() {
                this.cancelBubble = true;
                this.immediatePropagationStopped = true;
            }

            return {
                add: add,
                remove: remove,
                useAttachEvent: useAttachEvent,

                _elements: elements,
                _targets: targets,
                _attachedListeners: attachedListeners
            };
        }());

    function blank() { }

    function isElement(o) {
        if (!o || (typeof o !== 'object')) { return false; }

        var _window = getWindow(o) || window;

        return (/object|function/.test(typeof _window.Element)
            ? o instanceof _window.Element //DOM2
            : o.nodeType === 1 && typeof o.nodeName === "string");
    }
    function isWindow(thing) { return thing === window || !!(thing && thing.Window) && (thing instanceof thing.Window); }
    function isDocFrag(thing) { return !!thing && thing instanceof DocumentFragment; }
    function isArray(thing) {
        return isObject(thing)
            && (typeof thing.length !== undefined)
            && isFunction(thing.splice);
    }
    function isObject(thing) { return !!thing && (typeof thing === 'object'); }
    function isFunction(thing) { return typeof thing === 'function'; }
    function isNumber(thing) { return typeof thing === 'number'; }
    function isBool(thing) { return typeof thing === 'boolean'; }
    function isString(thing) { return typeof thing === 'string'; }

    function trySelector(value) {
        if (!isString(value)) { return false; }

        // an exception will be raised if it is invalid
        document.querySelector(value);
        return true;
    }

    function extend(dest, source) {
        for (var prop in source) {
            dest[prop] = source[prop];
        }
        return dest;
    }

    var prefixedPropREs = {
        webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
    };

    function pointerExtend(dest, source) {
        for (var prop in source) {
            var deprecated = false;

            // skip deprecated prefixed properties
            for (var vendor in prefixedPropREs) {
                if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
                    deprecated = true;
                    break;
                }
            }

            if (!deprecated) {
                dest[prop] = source[prop];
            }
        }
        return dest;
    }

    function copyCoords(dest, src) {
        dest.page = dest.page || {};
        dest.page.x = src.page.x;
        dest.page.y = src.page.y;

        dest.client = dest.client || {};
        dest.client.x = src.client.x;
        dest.client.y = src.client.y;

        dest.timeStamp = src.timeStamp;
    }

    function setEventXY(targetObj, pointers, interaction) {
        var pointer = (pointers.length > 1
            ? pointerAverage(pointers)
            : pointers[0]);

        getPageXY(pointer, tmpXY, interaction);
        targetObj.page.x = tmpXY.x;
        targetObj.page.y = tmpXY.y;

        getClientXY(pointer, tmpXY, interaction);
        targetObj.client.x = tmpXY.x;
        targetObj.client.y = tmpXY.y;

        targetObj.timeStamp = new Date().getTime();
    }

    function setEventDeltas(targetObj, prev, cur) {
        targetObj.page.x = cur.page.x - prev.page.x;
        targetObj.page.y = cur.page.y - prev.page.y;
        targetObj.client.x = cur.client.x - prev.client.x;
        targetObj.client.y = cur.client.y - prev.client.y;
        targetObj.timeStamp = new Date().getTime() - prev.timeStamp;

        // set pointer velocity
        var dt = Math.max(targetObj.timeStamp / 1000, 0.001);
        targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
        targetObj.page.vx = targetObj.page.x / dt;
        targetObj.page.vy = targetObj.page.y / dt;

        targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
        targetObj.client.vx = targetObj.client.x / dt;
        targetObj.client.vy = targetObj.client.y / dt;
    }

    function isNativePointer(pointer) {
        return (pointer instanceof window.Event
            || (supportsTouch && window.Touch && pointer instanceof window.Touch));
    }

    // Get specified X/Y coords for mouse or event.touches[0]
    function getXY(type, pointer, xy) {
        xy = xy || {};
        type = type || 'page';

        xy.x = pointer[type + 'X'];
        xy.y = pointer[type + 'Y'];

        return xy;
    }

    function getPageXY(pointer, page) {
        page = page || {};

        // Opera Mobile handles the viewport and scrolling oddly
        if (isOperaMobile && isNativePointer(pointer)) {
            getXY('screen', pointer, page);

            page.x += window.scrollX;
            page.y += window.scrollY;
        }
        else {
            getXY('page', pointer, page);
        }

        return page;
    }

    function getClientXY(pointer, client) {
        client = client || {};

        if (isOperaMobile && isNativePointer(pointer)) {
            // Opera Mobile handles the viewport and scrolling oddly
            getXY('screen', pointer, client);
        }
        else {
            getXY('client', pointer, client);
        }

        return client;
    }

    function getScrollXY(win) {
        win = win || window;
        return {
            x: win.scrollX || win.document.documentElement.scrollLeft,
            y: win.scrollY || win.document.documentElement.scrollTop
        };
    }

    function getPointerId(pointer) {
        return isNumber(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
    }

    function getActualElement(element) {
        return (element instanceof SVGElementInstance
            ? element.correspondingUseElement
            : element);
    }

    function getWindow(node) {
        if (isWindow(node)) {
            return node;
        }

        var rootNode = (node.ownerDocument || node);

        return rootNode.defaultView || rootNode.parentWindow || window;
    }

    function getElementClientRect(element) {
        var clientRect = (element instanceof SVGElement
            ? element.getBoundingClientRect()
            : element.getClientRects()[0]);

        return clientRect && {
            left: clientRect.left,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
            width: clientRect.width || clientRect.right - clientRect.left,
            height: clientRect.height || clientRect.bottom - clientRect.top
        };
    }

    function getElementRect(element) {
        var clientRect = getElementClientRect(element);

        if (!isIOS7 && clientRect) {
            var scroll = getScrollXY(getWindow(element));

            clientRect.left += scroll.x;
            clientRect.right += scroll.x;
            clientRect.top += scroll.y;
            clientRect.bottom += scroll.y;
        }

        return clientRect;
    }

    function getTouchPair(event) {
        var touches = [];

        // array of touches is supplied
        if (isArray(event)) {
            touches[0] = event[0];
            touches[1] = event[1];
        }
        // an event
        else {
            if (event.type === 'touchend') {
                if (event.touches.length === 1) {
                    touches[0] = event.touches[0];
                    touches[1] = event.changedTouches[0];
                }
                else if (event.touches.length === 0) {
                    touches[0] = event.changedTouches[0];
                    touches[1] = event.changedTouches[1];
                }
            }
            else {
                touches[0] = event.touches[0];
                touches[1] = event.touches[1];
            }
        }

        return touches;
    }

    function pointerAverage(pointers) {
        var average = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        };
        var prop;

        for (var i = 0; i < pointers.length; i++) {
            for (prop in average) {
                average[prop] += pointers[i][prop];
            }
        }
        for (prop in average) {
            average[prop] /= pointers.length;
        }

        return average;
    }

    function touchBBox(event) {
        if (!event.length && !(event.touches && event.touches.length > 1)) {
            return;
        }

        var touches = getTouchPair(event),
            minX = Math.min(touches[0].pageX, touches[1].pageX),
            minY = Math.min(touches[0].pageY, touches[1].pageY),
            maxX = Math.max(touches[0].pageX, touches[1].pageX),
            maxY = Math.max(touches[0].pageY, touches[1].pageY);

        return {
            x: minX,
            y: minY,
            left: minX,
            top: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }

    function touchDistance(event, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event);


        var dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY];

        return hypot(dx, dy);
    }

    function touchAngle(event, prevAngle, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event),
            dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY],
            angle = 180 * Math.atan(dy / dx) / Math.PI;

        if (isNumber(prevAngle)) {
            var dr = angle - prevAngle,
                drClamped = dr % 360;

            if (drClamped > 315) {
                angle -= 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped > 135) {
                angle -= 180 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -315) {
                angle += 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -135) {
                angle += 180 + (angle / 360) | 0 * 360;
            }
        }

        return angle;
    }

    function getOriginXY(interactable, element) {
        var origin = interactable
            ? interactable.options.origin
            : defaultOptions.origin;

        if (origin === 'parent') {
            origin = parentElement(element);
        }
        else if (origin === 'self') {
            origin = interactable.getRect(element);
        }
        else if (trySelector(origin)) {
            origin = closest(element, origin) || { x: 0, y: 0 };
        }

        if (isFunction(origin)) {
            origin = origin(interactable && element);
        }

        if (isElement(origin)) {
            origin = getElementRect(origin);
        }

        origin.x = ('x' in origin) ? origin.x : origin.left;
        origin.y = ('y' in origin) ? origin.y : origin.top;

        return origin;
    }

    // https://stackoverflow.com/a/5634528/2280888
    function _getQBezierValue(t, p1, p2, p3) {
        var iT = 1 - t;
        return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
    }

    function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
        return {
            x: _getQBezierValue(position, startX, cpX, endX),
            y: _getQBezierValue(position, startY, cpY, endY)
        };
    }

    // https://gizma.com/easing/
    function easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
    }

    function nodeContains(parent, child) {
        while (child) {
            if (child === parent) {
                return true;
            }

            child = child.parentNode;
        }

        return false;
    }

    function closest(child, selector) {
        var parent = parentElement(child);

        while (isElement(parent)) {
            if (matchesSelector(parent, selector)) { return parent; }

            parent = parentElement(parent);
        }

        return null;
    }

    function parentElement(node) {
        var parent = node.parentNode;

        if (isDocFrag(parent)) {
            // skip past #shado-root fragments
            while ((parent = parent.host) && isDocFrag(parent)) { }

            return parent;
        }

        return parent;
    }

    function inContext(interactable, element) {
        return interactable._context === element.ownerDocument
            || nodeContains(interactable._context, element);
    }

    function testIgnore(interactable, interactableElement, element) {
        var ignoreFrom = interactable.options.ignoreFrom;

        if (!ignoreFrom || !isElement(element)) { return false; }

        if (isString(ignoreFrom)) {
            return matchesUpTo(element, ignoreFrom, interactableElement);
        }
        else if (isElement(ignoreFrom)) {
            return nodeContains(ignoreFrom, element);
        }

        return false;
    }

    function testAllow(interactable, interactableElement, element) {
        var allowFrom = interactable.options.allowFrom;

        if (!allowFrom) { return true; }

        if (!isElement(element)) { return false; }

        if (isString(allowFrom)) {
            return matchesUpTo(element, allowFrom, interactableElement);
        }
        else if (isElement(allowFrom)) {
            return nodeContains(allowFrom, element);
        }

        return false;
    }

    function checkAxis(axis, interactable) {
        if (!interactable) { return false; }

        var thisAxis = interactable.options.drag.axis;

        return (axis === 'xy' || thisAxis === 'xy' || thisAxis === axis);
    }

    function checkSnap(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].snap && options[action].snap.enabled;
    }

    function checkRestrict(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].restrict && options[action].restrict.enabled;
    }

    function checkAutoScroll(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].autoScroll && options[action].autoScroll.enabled;
    }

    function withinInteractionLimit(interactable, element, action) {
        var options = interactable.options,
            maxActions = options[action.name].max,
            maxPerElement = options[action.name].maxPerElement,
            activeInteractions = 0,
            targetCount = 0,
            targetElementCount = 0;

        for (var i = 0, len = interactions.length; i < len; i++) {
            var interaction = interactions[i],
                otherAction = interaction.prepared.name,
                active = interaction.interacting();

            if (!active) { continue; }

            activeInteractions++;

            if (activeInteractions >= maxInteractions) {
                return false;
            }

            if (interaction.target !== interactable) { continue; }

            targetCount += (otherAction === action.name) | 0;

            if (targetCount >= maxActions) {
                return false;
            }

            if (interaction.element === element) {
                targetElementCount++;

                if (otherAction !== action.name || targetElementCount >= maxPerElement) {
                    return false;
                }
            }
        }

        return maxInteractions > 0;
    }

    // Test for the element that's "above" all other qualifiers
    function indexOfDeepestElement(elements) {
        var dropzone,
            deepestZone = elements[0],
            index = deepestZone ? 0 : -1,
            parent,
            deepestZoneParents = [],
            dropzoneParents = [],
            child,
            i,
            n;

        for (i = 1; i < elements.length; i++) {
            dropzone = elements[i];

            // an element might belong to multiple selector dropzones
            if (!dropzone || dropzone === deepestZone) {
                continue;
            }

            if (!deepestZone) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            // check if the deepest or current are document.documentElement or document.rootElement
            // - if the current dropzone is, do nothing and continue
            if (dropzone.parentNode === dropzone.ownerDocument) {
                continue;
            }
            // - if deepest is, update with the current dropzone and continue to next
            else if (deepestZone.parentNode === dropzone.ownerDocument) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            if (!deepestZoneParents.length) {
                parent = deepestZone;
                while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
                    deepestZoneParents.unshift(parent);
                    parent = parent.parentNode;
                }
            }

            // if this element is an svg element and the current deepest is
            // an HTMLElement
            if (deepestZone instanceof HTMLElement
                && dropzone instanceof SVGElement
                && !(dropzone instanceof SVGSVGElement)) {

                if (dropzone === deepestZone.parentNode) {
                    continue;
                }

                parent = dropzone.ownerSVGElement;
            }
            else {
                parent = dropzone;
            }

            dropzoneParents = [];

            while (parent.parentNode !== parent.ownerDocument) {
                dropzoneParents.unshift(parent);
                parent = parent.parentNode;
            }

            n = 0;

            // get (position of last common ancestor) + 1
            while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
                n++;
            }

            var parents = [
                dropzoneParents[n - 1],
                dropzoneParents[n],
                deepestZoneParents[n]
            ];

            child = parents[0].lastChild;

            while (child) {
                if (child === parents[1]) {
                    deepestZone = dropzone;
                    index = i;
                    deepestZoneParents = [];

                    break;
                }
                else if (child === parents[2]) {
                    break;
                }

                child = child.previousSibling;
            }
        }

        return index;
    }

    function Interaction() {
        this.target = null; // current interactable being interacted with
        this.element = null; // the target element of the interactable
        this.dropTarget = null; // the dropzone a drag target might be dropped into
        this.dropElement = null; // the element at the time of checking
        this.prevDropTarget = null; // the dropzone that was recently dragged away from
        this.prevDropElement = null; // the element at the time of checking

        this.prepared = {     // action that's ready to be fired on next move event
            name: null,
            axis: null,
            edges: null
        };

        this.matches = [];   // all selectors that are matched by target element
        this.matchElements = [];   // corresponding elements

        this.inertiaStatus = {
            active: false,
            smoothEnd: false,
            ending: false,

            startEvent: null,
            upCoords: {},

            xe: 0, ye: 0,
            sx: 0, sy: 0,

            t0: 0,
            vx0: 0, vys: 0,
            duration: 0,

            resumeDx: 0,
            resumeDy: 0,

            lambda_v0: 0,
            one_ve_v0: 0,
            i: null
        };

        if (isFunction(Function.prototype.bind)) {
            this.boundInertiaFrame = this.inertiaFrame.bind(this);
            this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);
        }
        else {
            var that = this;

            this.boundInertiaFrame = function () { return that.inertiaFrame(); };
            this.boundSmoothEndFrame = function () { return that.smoothEndFrame(); };
        }

        this.activeDrops = {
            dropzones: [],      // the dropzones that are mentioned below
            elements: [],      // elements of dropzones that accept the target draggable
            rects: []       // the rects of the elements mentioned above
        };

        // keep track of added pointers
        this.pointers = [];
        this.pointerIds = [];
        this.downTargets = [];
        this.downTimes = [];
        this.holdTimers = [];

        // Previous native pointer move event coordinates
        this.prevCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };
        // current native pointer move event coordinates
        this.curCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Starting InteractEvent pointer coordinates
        this.startCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Change in coordinates and time of the pointer
        this.pointerDelta = {
            page: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            client: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            timeStamp: 0
        };

        this.downEvent = null;    // pointerdown/mousedown/touchstart event
        this.downPointer = {};

        this._eventTarget = null;
        this._curEventTarget = null;

        this.prevEvent = null;      // previous action event
        this.tapTime = 0;         // time of the most recent tap event
        this.prevTap = null;

        this.startOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.restrictOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.snapOffsets = [];

        this.gesture = {
            start: { x: 0, y: 0 },

            startDistance: 0,   // distance between two touches of touchStart
            prevDistance: 0,
            distance: 0,

            scale: 1,           // gesture.distance / gesture.startDistance

            startAngle: 0,      // angle of line joining two touches
            prevAngle: 0       // angle of the previous gesture event
        };

        this.snapStatus = {
            x: 0, y: 0,
            dx: 0, dy: 0,
            realX: 0, realY: 0,
            snappedX: 0, snappedY: 0,
            targets: [],
            locked: false,
            changed: false
        };

        this.restrictStatus = {
            dx: 0, dy: 0,
            restrictedX: 0, restrictedY: 0,
            snap: null,
            restricted: false,
            changed: false
        };

        this.restrictStatus.snap = this.snapStatus;

        this.pointerIsDown = false;
        this.pointerWasMoved = false;
        this.gesturing = false;
        this.dragging = false;
        this.resizing = false;
        this.resizeAxes = 'xy';

        this.mouse = false;

        interactions.push(this);
    }

    Interaction.prototype = {
        getPageXY: function (pointer, xy) { return getPageXY(pointer, xy, this); },
        getClientXY: function (pointer, xy) { return getClientXY(pointer, xy, this); },
        setEventXY: function (target, ptr) { return setEventXY(target, ptr, this); },

        pointerOver: function (pointer, event, eventTarget) {
            if (this.prepared.name || !this.mouse) { return; }

            var curMatches = [],
                curMatchElements = [],
                prevTargetElement = this.element;

            this.addPointer(pointer);

            if (this.target
                && (testIgnore(this.target, this.element, eventTarget)
                    || !testAllow(this.target, this.element, eventTarget))) {
                // if the eventTarget should be ignored or shouldn't be allowed
                // clear the previous target
                this.target = null;
                this.element = null;
                this.matches = [];
                this.matchElements = [];
            }

            var elementInteractable = interactables.get(eventTarget),
                elementAction = (elementInteractable
                    && !testIgnore(elementInteractable, eventTarget, eventTarget)
                    && testAllow(elementInteractable, eventTarget, eventTarget)
                    && validateAction(
                        elementInteractable.getAction(pointer, event, this, eventTarget),
                        elementInteractable));

            if (elementAction && !withinInteractionLimit(elementInteractable, eventTarget, elementAction)) {
                elementAction = null;
            }

            function pushCurMatches(interactable, selector) {
                if (interactable
                    && isElement(eventTarget)
                    && inContext(interactable, eventTarget)
                    && !testIgnore(interactable, eventTarget, eventTarget)
                    && testAllow(interactable, eventTarget, eventTarget)
                    && matchesSelector(eventTarget, selector)) {

                    curMatches.push(interactable);
                    curMatchElements.push(eventTarget);
                }
            }

            if (elementAction) {
                this.target = elementInteractable;
                this.element = eventTarget;
                this.matches = [];
                this.matchElements = [];
            }
            else {
                interactables.forEachSelector(pushCurMatches);

                if (this.validateSelector(pointer, event, curMatches, curMatchElements)) {
                    this.matches = curMatches;
                    this.matchElements = curMatchElements;

                    this.pointerHover(pointer, event, this.matches, this.matchElements);
                    events.add(eventTarget,
                        supportsPointerEvent ? pEventTypes.move : 'mousemove',
                        listeners.pointerHover);
                }
                else if (this.target) {
                    if (nodeContains(prevTargetElement, eventTarget)) {
                        this.pointerHover(pointer, event, this.matches, this.matchElements);
                        events.add(this.element,
                            supportsPointerEvent ? pEventTypes.move : 'mousemove',
                            listeners.pointerHover);
                    }
                    else {
                        this.target = null;
                        this.element = null;
                        this.matches = [];
                        this.matchElements = [];
                    }
                }
            }
        },

        // Check what action would be performed on pointerMove target if a mouse
        // button were pressed and change the cursor accordingly
        pointerHover: function (pointer, event, eventTarget, curEventTarget, matches, matchElements) {
            var target = this.target;

            if (!this.prepared.name && this.mouse) {

                var action;

                // update pointer coords for defaultActionChecker to use
                this.setEventXY(this.curCoords, [pointer]);

                if (matches) {
                    action = this.validateSelector(pointer, event, matches, matchElements);
                }
                else if (target) {
                    action = validateAction(target.getAction(this.pointers[0], event, this, this.element), this.target);
                }

                if (target && target.options.styleCursor) {
                    if (action) {
                        target._doc.documentElement.style.cursor = getActionCursor(action);
                    }
                    else {
                        target._doc.documentElement.style.cursor = '';
                    }
                }
            }
            else if (this.prepared.name) {
                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        pointerOut: function (pointer, event, eventTarget) {
            if (this.prepared.name) { return; }

            // Remove temporary event listeners for selector Interactables
            if (!interactables.get(eventTarget)) {
                events.remove(eventTarget,
                    supportsPointerEvent ? pEventTypes.move : 'mousemove',
                    listeners.pointerHover);
            }

            if (this.target && this.target.options.styleCursor && !this.interacting()) {
                this.target._doc.documentElement.style.cursor = '';
            }
        },

        selectorDown: function (pointer, event, eventTarget, curEventTarget) {
            var that = this,
                // copy event to be used in timeout for IE8
                eventCopy = events.useAttachEvent ? extend({}, event) : event,
                element = eventTarget,
                pointerIndex = this.addPointer(pointer),
                action;

            this.holdTimers[pointerIndex] = setTimeout(function () {
                that.pointerHold(events.useAttachEvent ? eventCopy : pointer, eventCopy, eventTarget, curEventTarget);
            }, defaultOptions._holdDuration);

            this.pointerIsDown = true;

            // Check if the down event hits the current inertia target
            if (this.inertiaStatus.active && this.target.selector) {
                // climb up the DOM tree from the event target
                while (isElement(element)) {

                    // if this element is the current inertia target element
                    if (element === this.element
                        // and the prospective action is the same as the ongoing one
                        && validateAction(this.target.getAction(pointer, event, this, this.element), this.target).name === this.prepared.name) {

                        // stop inertia so that the next move will be a normal one
                        cancelFrame(this.inertiaStatus.i);
                        this.inertiaStatus.active = false;

                        this.collectEventTargets(pointer, event, eventTarget, 'down');
                        return;
                    }
                    element = parentElement(element);
                }
            }

            // do nothing if interacting
            if (this.interacting()) {
                this.collectEventTargets(pointer, event, eventTarget, 'down');
                return;
            }

            function pushMatches(interactable, selector, context) {
                var elements = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, elements)) {

                    that.matches.push(interactable);
                    that.matchElements.push(element);
                }
            }

            // update pointer coords for defaultActionChecker to use
            this.setEventXY(this.curCoords, [pointer]);
            this.downEvent = event;

            while (isElement(element) && !action) {
                this.matches = [];
                this.matchElements = [];

                interactables.forEachSelector(pushMatches);

                action = this.validateSelector(pointer, event, this.matches, this.matchElements);
                element = parentElement(element);
            }

            if (action) {
                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.collectEventTargets(pointer, event, eventTarget, 'down');

                return this.pointerDown(pointer, event, eventTarget, curEventTarget, action);
            }
            else {
                // do these now since pointerDown isn't being called from here
                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.curCoords);
                this.pointerWasMoved = false;
            }

            this.collectEventTargets(pointer, event, eventTarget, 'down');
        },

        // Determine action to be performed on next pointerMove and add appropriate
        // style and event Listeners
        pointerDown: function (pointer, event, eventTarget, curEventTarget, forceAction) {
            if (!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) {
                this.checkAndPreventDefault(event, this.target, this.element);

                return;
            }

            this.pointerIsDown = true;
            this.downEvent = event;

            var pointerIndex = this.addPointer(pointer),
                action;

            // If it is the second touch of a multi-touch gesture, keep the
            // target the same and get a new action if a target was set by the
            // first touch
            if (this.pointerIds.length > 1 && this.target._element === this.element) {
                var newAction = validateAction(forceAction || this.target.getAction(pointer, event, this, this.element), this.target);

                if (withinInteractionLimit(this.target, this.element, newAction)) {
                    action = newAction;
                }

                this.prepared.name = null;
            }
            // Otherwise, set the target if there is no action prepared
            else if (!this.prepared.name) {
                var interactable = interactables.get(curEventTarget);

                if (interactable
                    && !testIgnore(interactable, curEventTarget, eventTarget)
                    && testAllow(interactable, curEventTarget, eventTarget)
                    && (action = validateAction(forceAction || interactable.getAction(pointer, event, this, curEventTarget), interactable, eventTarget))
                    && withinInteractionLimit(interactable, curEventTarget, action)) {
                    this.target = interactable;
                    this.element = curEventTarget;
                }
            }

            var target = this.target,
                options = target && target.options;

            if (target && (forceAction || !this.prepared.name)) {
                action = action || validateAction(forceAction || target.getAction(pointer, event, this, curEventTarget), target, this.element);

                this.setEventXY(this.startCoords, this.pointers);

                if (!action) { return; }

                if (options.styleCursor) {
                    target._doc.documentElement.style.cursor = getActionCursor(action);
                }

                this.resizeAxes = action.name === 'resize' ? action.axis : null;

                if (action === 'gesture' && this.pointerIds.length < 2) {
                    action = null;
                }

                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.snapStatus.snappedX = this.snapStatus.snappedY =
                    this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;

                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.startCoords);
                this.pointerWasMoved = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
            // if inertia is active try to resume action
            else if (this.inertiaStatus.active
                && curEventTarget === this.element
                && validateAction(target.getAction(pointer, event, this, this.element), target).name === this.prepared.name) {

                cancelFrame(this.inertiaStatus.i);
                this.inertiaStatus.active = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        setModifications: function (coords, preEnd) {
            var target = this.target,
                shouldMove = true,
                shouldSnap = checkSnap(target, this.prepared.name) && (!target.options[this.prepared.name].snap.endOnly || preEnd),
                shouldRestrict = checkRestrict(target, this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);

            if (shouldSnap) { this.setSnapping(coords); } else { this.snapStatus.locked = false; }
            if (shouldRestrict) { this.setRestriction(coords); } else { this.restrictStatus.restricted = false; }

            if (shouldSnap && this.snapStatus.locked && !this.snapStatus.changed) {
                shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;
            }
            else if (shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed) {
                shouldMove = false;
            }

            return shouldMove;
        },

        setStartOffsets: function (action, interactable, element) {
            var rect = interactable.getRect(element),
                origin = getOriginXY(interactable, element),
                snap = interactable.options[this.prepared.name].snap,
                restrict = interactable.options[this.prepared.name].restrict,
                width, height;

            if (rect) {
                this.startOffset.left = this.startCoords.page.x - rect.left;
                this.startOffset.top = this.startCoords.page.y - rect.top;

                this.startOffset.right = rect.right - this.startCoords.page.x;
                this.startOffset.bottom = rect.bottom - this.startCoords.page.y;

                if ('width' in rect) { width = rect.width; }
                else { width = rect.right - rect.left; }
                if ('height' in rect) { height = rect.height; }
                else { height = rect.bottom - rect.top; }
            }
            else {
                this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;
            }

            this.snapOffsets.splice(0);

            var snapOffset = snap && snap.offset === 'startCoords'
                ? {
                    x: this.startCoords.page.x - origin.x,
                    y: this.startCoords.page.y - origin.y
                }
                : snap && snap.offset || { x: 0, y: 0 };

            if (rect && snap && snap.relativePoints && snap.relativePoints.length) {
                for (var i = 0; i < snap.relativePoints.length; i++) {
                    this.snapOffsets.push({
                        x: this.startOffset.left - (width * snap.relativePoints[i].x) + snapOffset.x,
                        y: this.startOffset.top - (height * snap.relativePoints[i].y) + snapOffset.y
                    });
                }
            }
            else {
                this.snapOffsets.push(snapOffset);
            }

            if (rect && restrict.elementRect) {
                this.restrictOffset.left = this.startOffset.left - (width * restrict.elementRect.left);
                this.restrictOffset.top = this.startOffset.top - (height * restrict.elementRect.top);

                this.restrictOffset.right = this.startOffset.right - (width * (1 - restrict.elementRect.right));
                this.restrictOffset.bottom = this.startOffset.bottom - (height * (1 - restrict.elementRect.bottom));
            }
            else {
                this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
            }
        },

        /*\
         * Interaction.start
         [ method ]
         *
         * Start an action with the given Interactable and Element as tartgets. The
         * action must be enabled for the target Interactable and an appropriate number
         * of pointers must be held down â€“ 1 for drag/resize, 2 for gesture.
         *
         * Use it with `interactable.<action>able({ manualStart: false })` to always
         * [start actions manually](https://github.com/taye/interact.js/issues/114)
         *
         - action       (object)  The action to be performed - drag, resize, etc.
         - interactable (Interactable) The Interactable to target
         - element      (Element) The DOM Element to target
         = (object) interact
         **
         | interact(target)
         |   .draggable({
         |     // disable the default drag start by down->move
         |     manualStart: true
         |   })
         |   // start dragging after the user holds the pointer down
         |   .on('hold', function (event) {
         |     var interaction = event.interaction;
         |
         |     if (!interaction.interacting()) {
         |       interaction.start({ name: 'drag' },
         |                         event.interactable,
         |                         event.currentTarget);
         |     }
         | });
        \*/
        start: function (action, interactable, element) {
            if (this.interacting()
                || !this.pointerIsDown
                || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) {
                return;
            }

            // if this interaction had been removed after stopping
            // add it back
            if (indexOf(interactions, this) === -1) {
                interactions.push(this);
            }

            // set the startCoords if there was no prepared action
            if (!this.prepared.name) {
                this.setEventXY(this.startCoords, this.pointers);
            }

            this.prepared.name = action.name;
            this.prepared.axis = action.axis;
            this.prepared.edges = action.edges;
            this.target = interactable;
            this.element = element;

            this.setStartOffsets(action.name, interactable, element);
            this.setModifications(this.startCoords.page);

            this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);
        },

        pointerMove: function (pointer, event, eventTarget, curEventTarget, preEnd) {
            if (this.inertiaStatus.active) {
                var pageUp = this.inertiaStatus.upCoords.page;
                var clientUp = this.inertiaStatus.upCoords.client;

                var inertiaPosition = {
                    pageX: pageUp.x + this.inertiaStatus.sx,
                    pageY: pageUp.y + this.inertiaStatus.sy,
                    clientX: clientUp.x + this.inertiaStatus.sx,
                    clientY: clientUp.y + this.inertiaStatus.sy
                };

                this.setEventXY(this.curCoords, [inertiaPosition]);
            }
            else {
                this.recordPointer(pointer);
                this.setEventXY(this.curCoords, this.pointers);
            }

            var duplicateMove = (this.curCoords.page.x === this.prevCoords.page.x
                && this.curCoords.page.y === this.prevCoords.page.y
                && this.curCoords.client.x === this.prevCoords.client.x
                && this.curCoords.client.y === this.prevCoords.client.y);

            var dx, dy,
                pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // register movement greater than pointerMoveTolerance
            if (this.pointerIsDown && !this.pointerWasMoved) {
                dx = this.curCoords.client.x - this.startCoords.client.x;
                dy = this.curCoords.client.y - this.startCoords.client.y;

                this.pointerWasMoved = hypot(dx, dy) > pointerMoveTolerance;
            }

            if (!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)) {
                if (this.pointerIsDown) {
                    clearTimeout(this.holdTimers[pointerIndex]);
                }

                this.collectEventTargets(pointer, event, eventTarget, 'move');
            }

            if (!this.pointerIsDown) { return; }

            if (duplicateMove && this.pointerWasMoved && !preEnd) {
                this.checkAndPreventDefault(event, this.target, this.element);
                return;
            }

            // set pointer coordinate, time changes and speeds
            setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

            if (!this.prepared.name) { return; }

            if (this.pointerWasMoved
                // ignore movement while inertia is active
                && (!this.inertiaStatus.active || (pointer instanceof InteractEvent && /inertiastart/.test(pointer.type)))) {

                // if just starting an action, calculate the pointer speed now
                if (!this.interacting()) {
                    setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

                    // check if a drag is in the correct axis
                    if (this.prepared.name === 'drag') {
                        var absX = Math.abs(dx),
                            absY = Math.abs(dy),
                            targetAxis = this.target.options.drag.axis,
                            axis = (absX > absY ? 'x' : absX < absY ? 'y' : 'xy');

                        // if the movement isn't in the axis of the interactable
                        if (axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis) {
                            // cancel the prepared action
                            this.prepared.name = null;

                            // then try to get a drag from another ineractable

                            var element = eventTarget;

                            // check element interactables
                            while (isElement(element)) {
                                var elementInteractable = interactables.get(element);

                                if (elementInteractable
                                    && elementInteractable !== this.target
                                    && !elementInteractable.options.drag.manualStart
                                    && elementInteractable.getAction(this.downPointer, this.downEvent, this, element).name === 'drag'
                                    && checkAxis(axis, elementInteractable)) {

                                    this.prepared.name = 'drag';
                                    this.target = elementInteractable;
                                    this.element = element;
                                    break;
                                }

                                element = parentElement(element);
                            }

                            // if there's no drag from element interactables,
                            // check the selector interactables
                            if (!this.prepared.name) {
                                var thisInteraction = this;

                                var getDraggable = function (interactable, selector, context) {
                                    var elements = ie8MatchesSelector
                                        ? context.querySelectorAll(selector)
                                        : undefined;

                                    if (interactable === thisInteraction.target) { return; }

                                    if (inContext(interactable, eventTarget)
                                        && !interactable.options.drag.manualStart
                                        && !testIgnore(interactable, element, eventTarget)
                                        && testAllow(interactable, element, eventTarget)
                                        && matchesSelector(element, selector, elements)
                                        && interactable.getAction(thisInteraction.downPointer, thisInteraction.downEvent, thisInteraction, element).name === 'drag'
                                        && checkAxis(axis, interactable)
                                        && withinInteractionLimit(interactable, element, 'drag')) {

                                        return interactable;
                                    }
                                };

                                element = eventTarget;

                                while (isElement(element)) {
                                    var selectorInteractable = interactables.forEachSelector(getDraggable);

                                    if (selectorInteractable) {
                                        this.prepared.name = 'drag';
                                        this.target = selectorInteractable;
                                        this.element = element;
                                        break;
                                    }

                                    element = parentElement(element);
                                }
                            }
                        }
                    }
                }

                var starting = !!this.prepared.name && !this.interacting();

                if (starting
                    && (this.target.options[this.prepared.name].manualStart
                        || !withinInteractionLimit(this.target, this.element, this.prepared))) {
                    this.stop(event);
                    return;
                }

                if (this.prepared.name && this.target) {
                    if (starting) {
                        this.start(this.prepared, this.target, this.element);
                    }

                    var shouldMove = this.setModifications(this.curCoords.page, preEnd);

                    // move if snapping or restriction doesn't prevent it
                    if (shouldMove || starting) {
                        this.prevEvent = this[this.prepared.name + 'Move'](event);
                    }

                    this.checkAndPreventDefault(event, this.target, this.element);
                }
            }

            copyCoords(this.prevCoords, this.curCoords);

            if (this.dragging || this.resizing) {
                this.autoScrollMove(pointer);
            }
        },

        dragStart: function (event) {
            var dragEvent = new InteractEvent(this, event, 'drag', 'start', this.element);

            this.dragging = true;
            this.target.fire(dragEvent);

            // reset active dropzones
            this.activeDrops.dropzones = [];
            this.activeDrops.elements = [];
            this.activeDrops.rects = [];

            if (!this.dynamicDrop) {
                this.setActiveDrops(this.element);
            }

            var dropEvents = this.getDropEvents(event, dragEvent);

            if (dropEvents.activate) {
                this.fireActiveDrops(dropEvents.activate);
            }

            return dragEvent;
        },

        dragMove: function (event) {
            var target = this.target,
                dragEvent = new InteractEvent(this, event, 'drag', 'move', this.element),
                draggableElement = this.element,
                drop = this.getDrop(dragEvent, event, draggableElement);

            this.dropTarget = drop.dropzone;
            this.dropElement = drop.element;

            var dropEvents = this.getDropEvents(event, dragEvent);

            target.fire(dragEvent);

            if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
            if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
            if (dropEvents.move) { this.dropTarget.fire(dropEvents.move); }

            this.prevDropTarget = this.dropTarget;
            this.prevDropElement = this.dropElement;

            return dragEvent;
        },

        resizeStart: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'start', this.element);

            if (this.prepared.edges) {
                var startRect = this.target.getRect(this.element);

                /*
                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
                 * on the active edges and the edge being interacted with.
                 */
                if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
                    var linkedEdges = extend({}, this.prepared.edges);

                    linkedEdges.top = linkedEdges.top || (linkedEdges.left && !linkedEdges.bottom);
                    linkedEdges.left = linkedEdges.left || (linkedEdges.top && !linkedEdges.right);
                    linkedEdges.bottom = linkedEdges.bottom || (linkedEdges.right && !linkedEdges.top);
                    linkedEdges.right = linkedEdges.right || (linkedEdges.bottom && !linkedEdges.left);

                    this.prepared._linkedEdges = linkedEdges;
                }
                else {
                    this.prepared._linkedEdges = null;
                }

                // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
                if (this.target.options.resize.preserveAspectRatio) {
                    this.resizeStartAspectRatio = startRect.width / startRect.height;
                }

                this.resizeRects = {
                    start: startRect,
                    current: extend({}, startRect),
                    restricted: extend({}, startRect),
                    previous: extend({}, startRect),
                    delta: {
                        left: 0, right: 0, width: 0,
                        top: 0, bottom: 0, height: 0
                    }
                };

                resizeEvent.rect = this.resizeRects.restricted;
                resizeEvent.deltaRect = this.resizeRects.delta;
            }

            this.target.fire(resizeEvent);

            this.resizing = true;

            return resizeEvent;
        },

        resizeMove: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'move', this.element);

            var edges = this.prepared.edges,
                invert = this.target.options.resize.invert,
                invertible = invert === 'reposition' || invert === 'negate';

            if (edges) {
                var dx = resizeEvent.dx,
                    dy = resizeEvent.dy,

                    start = this.resizeRects.start,
                    current = this.resizeRects.current,
                    restricted = this.resizeRects.restricted,
                    delta = this.resizeRects.delta,
                    previous = extend(this.resizeRects.previous, restricted),

                    originalEdges = edges;

                // `resize.preserveAspectRatio` takes precedence over `resize.square`
                if (this.target.options.resize.preserveAspectRatio) {
                    var resizeStartAspectRatio = this.resizeStartAspectRatio;

                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx / resizeStartAspectRatio;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx / resizeStartAspectRatio; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy * resizeStartAspectRatio; }
                }
                else if (this.target.options.resize.square) {
                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy; }
                }

                // update the 'current' rect without modifications
                if (edges.top) { current.top += dy; }
                if (edges.bottom) { current.bottom += dy; }
                if (edges.left) { current.left += dx; }
                if (edges.right) { current.right += dx; }

                if (invertible) {
                    // if invertible, copy the current rect
                    extend(restricted, current);

                    if (invert === 'reposition') {
                        // swap edge values if necessary to keep width/height positive
                        var swap;

                        if (restricted.top > restricted.bottom) {
                            swap = restricted.top;

                            restricted.top = restricted.bottom;
                            restricted.bottom = swap;
                        }
                        if (restricted.left > restricted.right) {
                            swap = restricted.left;

                            restricted.left = restricted.right;
                            restricted.right = swap;
                        }
                    }
                }
                else {
                    // if not invertible, restrict to minimum of 0x0 rect
                    restricted.top = Math.min(current.top, start.bottom);
                    restricted.bottom = Math.max(current.bottom, start.top);
                    restricted.left = Math.min(current.left, start.right);
                    restricted.right = Math.max(current.right, start.left);
                }

                restricted.width = restricted.right - restricted.left;
                restricted.height = restricted.bottom - restricted.top;

                for (var edge in restricted) {
                    delta[edge] = restricted[edge] - previous[edge];
                }

                resizeEvent.edges = this.prepared.edges;
                resizeEvent.rect = restricted;
                resizeEvent.deltaRect = delta;
            }

            this.target.fire(resizeEvent);

            return resizeEvent;
        },

        gestureStart: function (event) {
            var gestureEvent = new InteractEvent(this, event, 'gesture', 'start', this.element);

            gestureEvent.ds = 0;

            this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;
            this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.scale = 1;

            this.gesturing = true;

            this.target.fire(gestureEvent);

            return gestureEvent;
        },

        gestureMove: function (event) {
            if (!this.pointerIds.length) {
                return this.prevEvent;
            }

            var gestureEvent;

            gestureEvent = new InteractEvent(this, event, 'gesture', 'move', this.element);
            gestureEvent.ds = gestureEvent.scale - this.gesture.scale;

            this.target.fire(gestureEvent);

            this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.prevDistance = gestureEvent.distance;

            if (gestureEvent.scale !== Infinity &&
                gestureEvent.scale !== null &&
                gestureEvent.scale !== undefined &&
                !isNaN(gestureEvent.scale)) {

                this.gesture.scale = gestureEvent.scale;
            }

            return gestureEvent;
        },

        pointerHold: function (pointer, event, eventTarget) {
            this.collectEventTargets(pointer, event, eventTarget, 'hold');
        },

        pointerUp: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'up');
            this.collectEventTargets(pointer, event, eventTarget, 'tap');

            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        pointerCancel: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'cancel');
            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        // https://www.quirksmode.org/dom/events/click.html
        // >Events leading to dblclick
        //
        // IE8 doesn't fire down event before dblclick.
        // This workaround tries to fire a tap and doubletap after dblclick
        ie8Dblclick: function (pointer, event, eventTarget) {
            if (this.prevTap
                && event.clientX === this.prevTap.clientX
                && event.clientY === this.prevTap.clientY
                && eventTarget === this.prevTap.target) {

                this.downTargets[0] = eventTarget;
                this.downTimes[0] = new Date().getTime();
                this.collectEventTargets(pointer, event, eventTarget, 'tap');
            }
        },

        // End interact move events and stop auto-scroll unless inertia is enabled
        pointerEnd: function (pointer, event, eventTarget, curEventTarget) {
            var endEvent,
                target = this.target,
                options = target && target.options,
                inertiaOptions = options && this.prepared.name && options[this.prepared.name].inertia,
                inertiaStatus = this.inertiaStatus;

            if (this.interacting()) {

                if (inertiaStatus.active && !inertiaStatus.ending) { return; }

                var pointerSpeed,
                    now = new Date().getTime(),
                    inertiaPossible = false,
                    inertia = false,
                    smoothEnd = false,
                    endSnap = checkSnap(target, this.prepared.name) && options[this.prepared.name].snap.endOnly,
                    endRestrict = checkRestrict(target, this.prepared.name) && options[this.prepared.name].restrict.endOnly,
                    dx = 0,
                    dy = 0,
                    startEvent;

                if (this.dragging) {
                    if (options.drag.axis === 'x') { pointerSpeed = Math.abs(this.pointerDelta.client.vx); }
                    else if (options.drag.axis === 'y') { pointerSpeed = Math.abs(this.pointerDelta.client.vy); }
                    else   /*options.drag.axis === 'xy'*/ { pointerSpeed = this.pointerDelta.client.speed; }
                }
                else {
                    pointerSpeed = this.pointerDelta.client.speed;
                }

                // check if inertia should be started
                inertiaPossible = (inertiaOptions && inertiaOptions.enabled
                    && this.prepared.name !== 'gesture'
                    && event !== inertiaStatus.startEvent);

                inertia = (inertiaPossible
                    && (now - this.curCoords.timeStamp) < 50
                    && pointerSpeed > inertiaOptions.minSpeed
                    && pointerSpeed > inertiaOptions.endSpeed);

                if (inertiaPossible && !inertia && (endSnap || endRestrict)) {

                    var snapRestrict = {};

                    snapRestrict.snap = snapRestrict.restrict = snapRestrict;

                    if (endSnap) {
                        this.setSnapping(this.curCoords.page, snapRestrict);
                        if (snapRestrict.locked) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (endRestrict) {
                        this.setRestriction(this.curCoords.page, snapRestrict);
                        if (snapRestrict.restricted) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (dx || dy) {
                        smoothEnd = true;
                    }
                }

                if (inertia || smoothEnd) {
                    copyCoords(inertiaStatus.upCoords, this.curCoords);

                    this.pointers[0] = inertiaStatus.startEvent = startEvent =
                        new InteractEvent(this, event, this.prepared.name, 'inertiastart', this.element);

                    inertiaStatus.t0 = now;

                    target.fire(inertiaStatus.startEvent);

                    if (inertia) {
                        inertiaStatus.vx0 = this.pointerDelta.client.vx;
                        inertiaStatus.vy0 = this.pointerDelta.client.vy;
                        inertiaStatus.v0 = pointerSpeed;

                        this.calcInertia(inertiaStatus);

                        var page = extend({}, this.curCoords.page),
                            origin = getOriginXY(target, this.element),
                            statusObject;

                        page.x = page.x + inertiaStatus.xe - origin.x;
                        page.y = page.y + inertiaStatus.ye - origin.y;

                        statusObject = {
                            useStatusXY: true,
                            x: page.x,
                            y: page.y,
                            dx: 0,
                            dy: 0,
                            snap: null
                        };

                        statusObject.snap = statusObject;

                        dx = dy = 0;

                        if (endSnap) {
                            var snap = this.setSnapping(this.curCoords.page, statusObject);

                            if (snap.locked) {
                                dx += snap.dx;
                                dy += snap.dy;
                            }
                        }

                        if (endRestrict) {
                            var restrict = this.setRestriction(this.curCoords.page, statusObject);

                            if (restrict.restricted) {
                                dx += restrict.dx;
                                dy += restrict.dy;
                            }
                        }

                        inertiaStatus.modifiedXe += dx;
                        inertiaStatus.modifiedYe += dy;

                        inertiaStatus.i = reqFrame(this.boundInertiaFrame);
                    }
                    else {
                        inertiaStatus.smoothEnd = true;
                        inertiaStatus.xe = dx;
                        inertiaStatus.ye = dy;

                        inertiaStatus.sx = inertiaStatus.sy = 0;

                        inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
                    }

                    inertiaStatus.active = true;
                    return;
                }

                if (endSnap || endRestrict) {
                    // fire a move event at the snapped coordinates
                    this.pointerMove(pointer, event, eventTarget, curEventTarget, true);
                }
            }

            if (this.dragging) {
                endEvent = new InteractEvent(this, event, 'drag', 'end', this.element);

                var draggableElement = this.element,
                    drop = this.getDrop(endEvent, event, draggableElement);

                this.dropTarget = drop.dropzone;
                this.dropElement = drop.element;

                var dropEvents = this.getDropEvents(event, endEvent);

                if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
                if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
                if (dropEvents.drop) { this.dropTarget.fire(dropEvents.drop); }
                if (dropEvents.deactivate) {
                    this.fireActiveDrops(dropEvents.deactivate);
                }

                target.fire(endEvent);
            }
            else if (this.resizing) {
                endEvent = new InteractEvent(this, event, 'resize', 'end', this.element);
                target.fire(endEvent);
            }
            else if (this.gesturing) {
                endEvent = new InteractEvent(this, event, 'gesture', 'end', this.element);
                target.fire(endEvent);
            }

            this.stop(event);
        },

        collectDrops: function (element) {
            var drops = [],
                elements = [],
                i;

            element = element || this.element;

            // collect all dropzones and their elements which qualify for a drop
            for (i = 0; i < interactables.length; i++) {
                if (!interactables[i].options.drop.enabled) { continue; }

                var current = interactables[i],
                    accept = current.options.drop.accept;

                // test the draggable element against the dropzone's accept setting
                if ((isElement(accept) && accept !== element)
                    || (isString(accept)
                        && !matchesSelector(element, accept))) {

                    continue;
                }

                // query for new elements if necessary
                var dropElements = current.selector ? current._context.querySelectorAll(current.selector) : [current._element];

                for (var j = 0, len = dropElements.length; j < len; j++) {
                    var currentElement = dropElements[j];

                    if (currentElement === element) {
                        continue;
                    }

                    drops.push(current);
                    elements.push(currentElement);
                }
            }

            return {
                dropzones: drops,
                elements: elements
            };
        },

        fireActiveDrops: function (event) {
            var i,
                current,
                currentElement,
                prevElement;

            // loop through all active dropzones and trigger event
            for (i = 0; i < this.activeDrops.dropzones.length; i++) {
                current = this.activeDrops.dropzones[i];
                currentElement = this.activeDrops.elements[i];

                // prevent trigger of duplicate events on same element
                if (currentElement !== prevElement) {
                    // set current element as event target
                    event.target = currentElement;
                    current.fire(event);
                }
                prevElement = currentElement;
            }
        },

        // Collect a new set of possible drops and save them in activeDrops.
        // setActiveDrops should always be called when a drag has just started or a
        // drag event happens while dynamicDrop is true
        setActiveDrops: function (dragElement) {
            // get dropzones and their elements that could receive the draggable
            var possibleDrops = this.collectDrops(dragElement, true);

            this.activeDrops.dropzones = possibleDrops.dropzones;
            this.activeDrops.elements = possibleDrops.elements;
            this.activeDrops.rects = [];

            for (var i = 0; i < this.activeDrops.dropzones.length; i++) {
                this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);
            }
        },

        getDrop: function (dragEvent, event, dragElement) {
            var validDrops = [];

            if (dynamicDrop) {
                this.setActiveDrops(dragElement);
            }

            // collect all dropzones and their elements which qualify for a drop
            for (var j = 0; j < this.activeDrops.dropzones.length; j++) {
                var current = this.activeDrops.dropzones[j],
                    currentElement = this.activeDrops.elements[j],
                    rect = this.activeDrops.rects[j];

                validDrops.push(current.dropCheck(dragEvent, event, this.target, dragElement, currentElement, rect)
                    ? currentElement
                    : null);
            }

            // get the most appropriate dropzone based on DOM depth and order
            var dropIndex = indexOfDeepestElement(validDrops),
                dropzone = this.activeDrops.dropzones[dropIndex] || null,
                element = this.activeDrops.elements[dropIndex] || null;

            return {
                dropzone: dropzone,
                element: element
            };
        },

        getDropEvents: function (pointerEvent, dragEvent) {
            var dropEvents = {
                enter: null,
                leave: null,
                activate: null,
                deactivate: null,
                move: null,
                drop: null
            };

            if (this.dropElement !== this.prevDropElement) {
                // if there was a prevDropTarget, create a dragleave event
                if (this.prevDropTarget) {
                    dropEvents.leave = {
                        target: this.prevDropElement,
                        dropzone: this.prevDropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragleave'
                    };

                    dragEvent.dragLeave = this.prevDropElement;
                    dragEvent.prevDropzone = this.prevDropTarget;
                }
                // if the dropTarget is not null, create a dragenter event
                if (this.dropTarget) {
                    dropEvents.enter = {
                        target: this.dropElement,
                        dropzone: this.dropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragenter'
                    };

                    dragEvent.dragEnter = this.dropElement;
                    dragEvent.dropzone = this.dropTarget;
                }
            }

            if (dragEvent.type === 'dragend' && this.dropTarget) {
                dropEvents.drop = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'drop'
                };

                dragEvent.dropzone = this.dropTarget;
            }
            if (dragEvent.type === 'dragstart') {
                dropEvents.activate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropactivate'
                };
            }
            if (dragEvent.type === 'dragend') {
                dropEvents.deactivate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropdeactivate'
                };
            }
            if (dragEvent.type === 'dragmove' && this.dropTarget) {
                dropEvents.move = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    dragmove: dragEvent,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropmove'
                };
                dragEvent.dropzone = this.dropTarget;
            }

            return dropEvents;
        },

        currentAction: function () {
            return (this.dragging && 'drag') || (this.resizing && 'resize') || (this.gesturing && 'gesture') || null;
        },

        interacting: function () {
            return this.dragging || this.resizing || this.gesturing;
        },

        clearTargets: function () {
            this.target = this.element = null;

            this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
        },

        stop: function (event) {
            if (this.interacting()) {
                autoScroll.stop();
                this.matches = [];
                this.matchElements = [];

                var target = this.target;

                if (target.options.styleCursor) {
                    target._doc.documentElement.style.cursor = '';
                }

                // prevent Default only if were previously interacting
                if (event && isFunction(event.preventDefault)) {
                    this.checkAndPreventDefault(event, target, this.element);
                }

                if (this.dragging) {
                    this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;
                }
            }

            this.clearTargets();

            this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;
            this.prepared.name = this.prevEvent = null;
            this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;

            // remove pointers if their ID isn't in this.pointerIds
            for (var i = 0; i < this.pointers.length; i++) {
                if (indexOf(this.pointerIds, getPointerId(this.pointers[i])) === -1) {
                    this.pointers.splice(i, 1);
                }
            }
        },

        inertiaFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                options = this.target.options[this.prepared.name].inertia,
                lambda = options.resistance,
                t = new Date().getTime() / 1000 - inertiaStatus.t0;

            if (t < inertiaStatus.te) {

                var progress = 1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;

                if (inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye) {
                    inertiaStatus.sx = inertiaStatus.xe * progress;
                    inertiaStatus.sy = inertiaStatus.ye * progress;
                }
                else {
                    var quadPoint = getQuadraticCurvePoint(
                        0, 0,
                        inertiaStatus.xe, inertiaStatus.ye,
                        inertiaStatus.modifiedXe, inertiaStatus.modifiedYe,
                        progress);

                    inertiaStatus.sx = quadPoint.x;
                    inertiaStatus.sy = quadPoint.y;
                }

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundInertiaFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.modifiedXe;
                inertiaStatus.sy = inertiaStatus.modifiedYe;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        smoothEndFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                t = new Date().getTime() - inertiaStatus.t0,
                duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;

            if (t < duration) {
                inertiaStatus.sx = easeOutQuad(t, 0, inertiaStatus.xe, duration);
                inertiaStatus.sy = easeOutQuad(t, 0, inertiaStatus.ye, duration);

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.xe;
                inertiaStatus.sy = inertiaStatus.ye;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.smoothEnd =
                    inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        addPointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) {
                index = this.pointerIds.length;
            }

            this.pointerIds[index] = id;
            this.pointers[index] = pointer;

            return index;
        },

        removePointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) { return; }

            this.pointers.splice(index, 1);
            this.pointerIds.splice(index, 1);
            this.downTargets.splice(index, 1);
            this.downTimes.splice(index, 1);
            this.holdTimers.splice(index, 1);
        },

        recordPointer: function (pointer) {
            var index = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            if (index === -1) { return; }

            this.pointers[index] = pointer;
        },

        collectEventTargets: function (pointer, event, eventTarget, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // do not fire a tap event if the pointer was moved before being lifted
            if (eventType === 'tap' && (this.pointerWasMoved
                // or if the pointerup target is different to the pointerdown target
                || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))) {
                return;
            }

            var targets = [],
                elements = [],
                element = eventTarget;

            function collectSelectors(interactable, selector, context) {
                var els = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (interactable._iEvents[eventType]
                    && isElement(element)
                    && inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, els)) {

                    targets.push(interactable);
                    elements.push(element);
                }
            }

            while (element) {
                if (interact.isSet(element) && interact(element)._iEvents[eventType]) {
                    targets.push(interact(element));
                    elements.push(element);
                }

                interactables.forEachSelector(collectSelectors);

                element = parentElement(element);
            }

            // create the tap event even if there are no listeners so that
            // doubletap can still be created and fired
            if (targets.length || eventType === 'tap') {
                this.firePointers(pointer, event, eventTarget, targets, elements, eventType);
            }
        },

        firePointers: function (pointer, event, eventTarget, targets, elements, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer)),
                pointerEvent = {},
                i,
                // for tap events
                interval, createNewDoubleTap;

            // if it's a doubletap then the event properties would have been
            // copied from the tap event and provided as the pointer argument
            if (eventType === 'doubletap') {
                pointerEvent = pointer;
            }
            else {
                pointerExtend(pointerEvent, event);
                if (event !== pointer) {
                    pointerExtend(pointerEvent, pointer);
                }

                pointerEvent.preventDefault = preventOriginalDefault;
                pointerEvent.stopPropagation = InteractEvent.prototype.stopPropagation;
                pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;
                pointerEvent.interaction = this;

                pointerEvent.timeStamp = new Date().getTime();
                pointerEvent.originalEvent = event;
                pointerEvent.originalPointer = pointer;
                pointerEvent.type = eventType;
                pointerEvent.pointerId = getPointerId(pointer);
                pointerEvent.pointerType = this.mouse ? 'mouse' : !supportsPointerEvent ? 'touch'
                    : isString(pointer.pointerType)
                        ? pointer.pointerType
                        : [, , 'touch', 'pen', 'mouse'][pointer.pointerType];
            }

            if (eventType === 'tap') {
                pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];

                interval = pointerEvent.timeStamp - this.tapTime;
                createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap'
                    && this.prevTap.target === pointerEvent.target
                    && interval < 500);

                pointerEvent.double = createNewDoubleTap;

                this.tapTime = pointerEvent.timeStamp;
            }

            for (i = 0; i < targets.length; i++) {
                pointerEvent.currentTarget = elements[i];
                pointerEvent.interactable = targets[i];
                targets[i].fire(pointerEvent);

                if (pointerEvent.immediatePropagationStopped
                    || (pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget)) {
                    break;
                }
            }

            if (createNewDoubleTap) {
                var doubleTap = {};

                extend(doubleTap, pointerEvent);

                doubleTap.dt = interval;
                doubleTap.type = 'doubletap';

                this.collectEventTargets(doubleTap, event, eventTarget, 'doubletap');

                this.prevTap = doubleTap;
            }
            else if (eventType === 'tap') {
                this.prevTap = pointerEvent;
            }
        },

        validateSelector: function (pointer, event, matches, matchElements) {
            for (var i = 0, len = matches.length; i < len; i++) {
                var match = matches[i],
                    matchElement = matchElements[i],
                    action = validateAction(match.getAction(pointer, event, this, matchElement), match);

                if (action && withinInteractionLimit(match, matchElement, action)) {
                    this.target = match;
                    this.element = matchElement;

                    return action;
                }
            }
        },

        setSnapping: function (pageCoords, status) {
            var snap = this.target.options[this.prepared.name].snap,
                targets = [],
                target,
                page,
                i;

            status = status || this.snapStatus;

            if (status.useStatusXY) {
                page = { x: status.x, y: status.y };
            }
            else {
                var origin = getOriginXY(this.target, this.element);

                page = extend({}, pageCoords);

                page.x -= origin.x;
                page.y -= origin.y;
            }

            status.realX = page.x;
            status.realY = page.y;

            page.x = page.x - this.inertiaStatus.resumeDx;
            page.y = page.y - this.inertiaStatus.resumeDy;

            var len = snap.targets ? snap.targets.length : 0;

            for (var relIndex = 0; relIndex < this.snapOffsets.length; relIndex++) {
                var relative = {
                    x: page.x - this.snapOffsets[relIndex].x,
                    y: page.y - this.snapOffsets[relIndex].y
                };

                for (i = 0; i < len; i++) {
                    if (isFunction(snap.targets[i])) {
                        target = snap.targets[i](relative.x, relative.y, this);
                    }
                    else {
                        target = snap.targets[i];
                    }

                    if (!target) { continue; }

                    targets.push({
                        x: isNumber(target.x) ? (target.x + this.snapOffsets[relIndex].x) : relative.x,
                        y: isNumber(target.y) ? (target.y + this.snapOffsets[relIndex].y) : relative.y,

                        range: isNumber(target.range) ? target.range : snap.range
                    });
                }
            }

            var closest = {
                target: null,
                inRange: false,
                distance: 0,
                range: 0,
                dx: 0,
                dy: 0
            };

            for (i = 0, len = targets.length; i < len; i++) {
                target = targets[i];

                var range = target.range,
                    dx = target.x - page.x,
                    dy = target.y - page.y,
                    distance = hypot(dx, dy),
                    inRange = distance <= range;

                // Infinite targets count as being out of range
                // compared to non infinite ones that are in range
                if (range === Infinity && closest.inRange && closest.range !== Infinity) {
                    inRange = false;
                }

                if (!closest.target || (inRange
                    // is the closest target in range?
                    ? (closest.inRange && range !== Infinity
                        // the pointer is relatively deeper in this target
                        ? distance / range < closest.distance / closest.range
                        // this target has Infinite range and the closest doesn't
                        : (range === Infinity && closest.range !== Infinity)
                        // OR this target is closer that the previous closest
                        || distance < closest.distance)
                    // The other is not in range and the pointer is closer to this target
                    : (!closest.inRange && distance < closest.distance))) {

                    if (range === Infinity) {
                        inRange = true;
                    }

                    closest.target = target;
                    closest.distance = distance;
                    closest.range = range;
                    closest.inRange = inRange;
                    closest.dx = dx;
                    closest.dy = dy;

                    status.range = range;
                }
            }

            var snapChanged;

            if (closest.target) {
                snapChanged = (status.snappedX !== closest.target.x || status.snappedY !== closest.target.y);

                status.snappedX = closest.target.x;
                status.snappedY = closest.target.y;
            }
            else {
                snapChanged = true;

                status.snappedX = NaN;
                status.snappedY = NaN;
            }

            status.dx = closest.dx;
            status.dy = closest.dy;

            status.changed = (snapChanged || (closest.inRange && !status.locked));
            status.locked = closest.inRange;

            return status;
        },

        setRestriction: function (pageCoords, status) {
            var target = this.target,
                restrict = target && target.options[this.prepared.name].restrict,
                restriction = restrict && restrict.restriction,
                page;

            if (!restriction) {
                return status;
            }

            status = status || this.restrictStatus;

            page = status.useStatusXY
                ? page = { x: status.x, y: status.y }
                : page = extend({}, pageCoords);

            if (status.snap && status.snap.locked) {
                page.x += status.snap.dx || 0;
                page.y += status.snap.dy || 0;
            }

            page.x -= this.inertiaStatus.resumeDx;
            page.y -= this.inertiaStatus.resumeDy;

            status.dx = 0;
            status.dy = 0;
            status.restricted = false;

            var rect, restrictedX, restrictedY;

            if (isString(restriction)) {
                if (restriction === 'parent') {
                    restriction = parentElement(this.element);
                }
                else if (restriction === 'self') {
                    restriction = target.getRect(this.element);
                }
                else {
                    restriction = closest(this.element, restriction);
                }

                if (!restriction) { return status; }
            }

            if (isFunction(restriction)) {
                restriction = restriction(page.x, page.y, this.element);
            }

            if (isElement(restriction)) {
                restriction = getElementRect(restriction);
            }

            rect = restriction;

            if (!restriction) {
                restrictedX = page.x;
                restrictedY = page.y;
            }
            // object is assumed to have
            // x, y, width, height or
            // left, top, right, bottom
            else if ('x' in restriction && 'y' in restriction) {
                restrictedX = Math.max(Math.min(rect.x + rect.width - this.restrictOffset.right, page.x), rect.x + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom, page.y), rect.y + this.restrictOffset.top);
            }
            else {
                restrictedX = Math.max(Math.min(rect.right - this.restrictOffset.right, page.x), rect.left + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom, page.y), rect.top + this.restrictOffset.top);
            }

            status.dx = restrictedX - page.x;
            status.dy = restrictedY - page.y;

            status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;
            status.restricted = !!(status.dx || status.dy);

            status.restrictedX = restrictedX;
            status.restrictedY = restrictedY;

            return status;
        },

        checkAndPreventDefault: function (event, interactable, element) {
            if (!(interactable = interactable || this.target)) { return; }

            var options = interactable.options,
                prevent = options.preventDefault;

            if (prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)) {
                // do not preventDefault on pointerdown if the prepared action is a drag
                // and dragging can only start from a certain direction - this allows
                // a touch to pan the viewport if a drag isn't in the right direction
                if (/down|start/i.test(event.type)
                    && this.prepared.name === 'drag' && options.drag.axis !== 'xy') {

                    return;
                }

                // with manualStart, only preventDefault while interacting
                if (options[this.prepared.name] && options[this.prepared.name].manualStart
                    && !this.interacting()) {
                    return;
                }

                event.preventDefault();
                return;
            }

            if (prevent === 'always') {
                event.preventDefault();
                return;
            }
        },

        calcInertia: function (status) {
            var inertiaOptions = this.target.options[this.prepared.name].inertia,
                lambda = inertiaOptions.resistance,
                inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;

            status.x0 = this.prevEvent.pageX;
            status.y0 = this.prevEvent.pageY;
            status.t0 = status.startEvent.timeStamp / 1000;
            status.sx = status.sy = 0;

            status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
            status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
            status.te = inertiaDur;

            status.lambda_v0 = lambda / status.v0;
            status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
        },

        autoScrollMove: function (pointer) {
            if (!(this.interacting()
                && checkAutoScroll(this.target, this.prepared.name))) {
                return;
            }

            if (this.inertiaStatus.active) {
                autoScroll.x = autoScroll.y = 0;
                return;
            }

            var top,
                right,
                bottom,
                left,
                options = this.target.options[this.prepared.name].autoScroll,
                container = options.container || getWindow(this.element);

            if (isWindow(container)) {
                left = pointer.clientX < autoScroll.margin;
                top = pointer.clientY < autoScroll.margin;
                right = pointer.clientX > container.innerWidth - autoScroll.margin;
                bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
            }
            else {
                var rect = getElementClientRect(container);

                left = pointer.clientX < rect.left + autoScroll.margin;
                top = pointer.clientY < rect.top + autoScroll.margin;
                right = pointer.clientX > rect.right - autoScroll.margin;
                bottom = pointer.clientY > rect.bottom - autoScroll.margin;
            }

            autoScroll.x = (right ? 1 : left ? -1 : 0);
            autoScroll.y = (bottom ? 1 : top ? -1 : 0);

            if (!autoScroll.isScrolling) {
                // set the autoScroll properties to those of the target
                autoScroll.margin = options.margin;
                autoScroll.speed = options.speed;

                autoScroll.start(this);
            }
        },

        _updateEventTargets: function (target, currentTarget) {
            this._eventTarget = target;
            this._curEventTarget = currentTarget;
        }

    };

    function getInteractionFromPointer(pointer, eventType, eventTarget) {
        var i = 0, len = interactions.length,
            mouseEvent = (/mouse/i.test(pointer.pointerType || eventType)
                // MSPointerEvent.MSPOINTER_TYPE_MOUSE
                || pointer.pointerType === 4),
            interaction;

        var id = getPointerId(pointer);

        // try to resume inertia with a new pointer
        if (/down|start/i.test(eventType)) {
            for (i = 0; i < len; i++) {
                interaction = interactions[i];

                var element = eventTarget;

                if (interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume
                    && (interaction.mouse === mouseEvent)) {
                    while (element) {
                        // if the element is the interaction element
                        if (element === interaction.element) {
                            return interaction;
                        }
                        element = parentElement(element);
                    }
                }
            }
        }

        // if it's a mouse interaction
        if (mouseEvent || !(supportsTouch || supportsPointerEvent)) {

            // find a mouse interaction that's not in inertia phase
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !interactions[i].inertiaStatus.active) {
                    return interactions[i];
                }
            }

            // find any interaction specifically for mouse.
            // if the eventType is a mousedown, and inertia is active
            // ignore the interaction
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)) {
                    return interaction;
                }
            }

            // create a new interaction for mouse
            interaction = new Interaction();
            interaction.mouse = true;

            return interaction;
        }

        // get interaction that has this pointer
        for (i = 0; i < len; i++) {
            if (contains(interactions[i].pointerIds, id)) {
                return interactions[i];
            }
        }

        // at this stage, a pointerUp should not return an interaction
        if (/up|end|out/i.test(eventType)) {
            return null;
        }

        // get first idle interaction
        for (i = 0; i < len; i++) {
            interaction = interactions[i];

            if ((!interaction.prepared.name || (interaction.target.options.gesture.enabled))
                && !interaction.interacting()
                && !(!mouseEvent && interaction.mouse)) {

                return interaction;
            }
        }

        return new Interaction();
    }

    function doOnInteractions(method) {
        return (function (event) {
            var interaction,
                eventTarget = getActualElement(event.path
                    ? event.path[0]
                    : event.target),
                curEventTarget = getActualElement(event.currentTarget),
                i;

            if (supportsTouch && /touch/.test(event.type)) {
                prevTouchTime = new Date().getTime();

                for (i = 0; i < event.changedTouches.length; i++) {
                    var pointer = event.changedTouches[i];

                    interaction = getInteractionFromPointer(pointer, event.type, eventTarget);

                    if (!interaction) { continue; }

                    interaction._updateEventTargets(eventTarget, curEventTarget);

                    interaction[method](pointer, event, eventTarget, curEventTarget);
                }
            }
            else {
                if (!supportsPointerEvent && /mouse/.test(event.type)) {
                    // ignore mouse events while touch interactions are active
                    for (i = 0; i < interactions.length; i++) {
                        if (!interactions[i].mouse && interactions[i].pointerIsDown) {
                            return;
                        }
                    }

                    // try to ignore mouse events that are simulated by the browser
                    // after a touch event
                    if (new Date().getTime() - prevTouchTime < 500) {
                        return;
                    }
                }

                interaction = getInteractionFromPointer(event, event.type, eventTarget);

                if (!interaction) { return; }

                interaction._updateEventTargets(eventTarget, curEventTarget);

                interaction[method](event, event, eventTarget, curEventTarget);
            }
        });
    }

    function InteractEvent(interaction, event, action, phase, element, related) {
        var client,
            page,
            target = interaction.target,
            snapStatus = interaction.snapStatus,
            restrictStatus = interaction.restrictStatus,
            pointers = interaction.pointers,
            deltaSource = (target && target.options || defaultOptions).deltaSource,
            sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            options = target ? target.options : defaultOptions,
            origin = getOriginXY(target, element),
            starting = phase === 'start',
            ending = phase === 'end',
            coords = starting ? interaction.startCoords : interaction.curCoords;

        element = element || interaction.element;

        page = extend({}, coords.page);
        client = extend({}, coords.client);

        page.x -= origin.x;
        page.y -= origin.y;

        client.x -= origin.x;
        client.y -= origin.y;

        var relativePoints = options[action].snap && options[action].snap.relativePoints;

        if (checkSnap(target, action) && !(starting && relativePoints && relativePoints.length)) {
            this.snap = {
                range: snapStatus.range,
                locked: snapStatus.locked,
                x: snapStatus.snappedX,
                y: snapStatus.snappedY,
                realX: snapStatus.realX,
                realY: snapStatus.realY,
                dx: snapStatus.dx,
                dy: snapStatus.dy
            };

            if (snapStatus.locked) {
                page.x += snapStatus.dx;
                page.y += snapStatus.dy;
                client.x += snapStatus.dx;
                client.y += snapStatus.dy;
            }
        }

        if (checkRestrict(target, action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted) {
            page.x += restrictStatus.dx;
            page.y += restrictStatus.dy;
            client.x += restrictStatus.dx;
            client.y += restrictStatus.dy;

            this.restrict = {
                dx: restrictStatus.dx,
                dy: restrictStatus.dy
            };
        }

        this.pageX = page.x;
        this.pageY = page.y;
        this.clientX = client.x;
        this.clientY = client.y;

        this.x0 = interaction.startCoords.page.x - origin.x;
        this.y0 = interaction.startCoords.page.y - origin.y;
        this.clientX0 = interaction.startCoords.client.x - origin.x;
        this.clientY0 = interaction.startCoords.client.y - origin.y;
        this.ctrlKey = event.ctrlKey;
        this.altKey = event.altKey;
        this.shiftKey = event.shiftKey;
        this.metaKey = event.metaKey;
        this.button = event.button;
        this.buttons = event.buttons;
        this.target = element;
        this.t0 = interaction.downTimes[0];
        this.type = action + (phase || '');

        this.interaction = interaction;
        this.interactable = target;

        var inertiaStatus = interaction.inertiaStatus;

        if (inertiaStatus.active) {
            this.detail = 'inertia';
        }

        if (related) {
            this.relatedTarget = related;
        }

        // end event dx, dy is difference between start and end points
        if (ending) {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.startCoords.client.x;
                this.dy = client.y - interaction.startCoords.client.y;
            }
            else {
                this.dx = page.x - interaction.startCoords.page.x;
                this.dy = page.y - interaction.startCoords.page.y;
            }
        }
        else if (starting) {
            this.dx = 0;
            this.dy = 0;
        }
        // copy properties from previousmove if starting inertia
        else if (phase === 'inertiastart') {
            this.dx = interaction.prevEvent.dx;
            this.dy = interaction.prevEvent.dy;
        }
        else {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.prevEvent.clientX;
                this.dy = client.y - interaction.prevEvent.clientY;
            }
            else {
                this.dx = page.x - interaction.prevEvent.pageX;
                this.dy = page.y - interaction.prevEvent.pageY;
            }
        }
        if (interaction.prevEvent && interaction.prevEvent.detail === 'inertia'
            && !inertiaStatus.active
            && options[action].inertia && options[action].inertia.zeroResumeDelta) {

            inertiaStatus.resumeDx += this.dx;
            inertiaStatus.resumeDy += this.dy;

            this.dx = this.dy = 0;
        }

        if (action === 'resize' && interaction.resizeAxes) {
            if (options.resize.square) {
                if (interaction.resizeAxes === 'y') {
                    this.dx = this.dy;
                }
                else {
                    this.dy = this.dx;
                }
                this.axes = 'xy';
            }
            else {
                this.axes = interaction.resizeAxes;

                if (interaction.resizeAxes === 'x') {
                    this.dy = 0;
                }
                else if (interaction.resizeAxes === 'y') {
                    this.dx = 0;
                }
            }
        }
        else if (action === 'gesture') {
            this.touches = [pointers[0], pointers[1]];

            if (starting) {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = 1;
                this.ds = 0;
                this.angle = touchAngle(pointers, undefined, deltaSource);
                this.da = 0;
            }
            else if (ending || event instanceof InteractEvent) {
                this.distance = interaction.prevEvent.distance;
                this.box = interaction.prevEvent.box;
                this.scale = interaction.prevEvent.scale;
                this.ds = this.scale - 1;
                this.angle = interaction.prevEvent.angle;
                this.da = this.angle - interaction.gesture.startAngle;
            }
            else {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = this.distance / interaction.gesture.startDistance;
                this.angle = touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);

                this.ds = this.scale - interaction.gesture.prevScale;
                this.da = this.angle - interaction.gesture.prevAngle;
            }
        }

        if (starting) {
            this.timeStamp = interaction.downTimes[0];
            this.dt = 0;
            this.duration = 0;
            this.speed = 0;
            this.velocityX = 0;
            this.velocityY = 0;
        }
        else if (phase === 'inertiastart') {
            this.timeStamp = interaction.prevEvent.timeStamp;
            this.dt = interaction.prevEvent.dt;
            this.duration = interaction.prevEvent.duration;
            this.speed = interaction.prevEvent.speed;
            this.velocityX = interaction.prevEvent.velocityX;
            this.velocityY = interaction.prevEvent.velocityY;
        }
        else {
            this.timeStamp = new Date().getTime();
            this.dt = this.timeStamp - interaction.prevEvent.timeStamp;
            this.duration = this.timeStamp - interaction.downTimes[0];

            if (event instanceof InteractEvent) {
                var dx = this[sourceX] - interaction.prevEvent[sourceX],
                    dy = this[sourceY] - interaction.prevEvent[sourceY],
                    dt = this.dt / 1000;

                this.speed = hypot(dx, dy) / dt;
                this.velocityX = dx / dt;
                this.velocityY = dy / dt;
            }
            // if normal move or end event, use previous user event coords
            else {
                // speed and velocity in pixels per second
                this.speed = interaction.pointerDelta[deltaSource].speed;
                this.velocityX = interaction.pointerDelta[deltaSource].vx;
                this.velocityY = interaction.pointerDelta[deltaSource].vy;
            }
        }

        if ((ending || phase === 'inertiastart')
            && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150) {

            var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI,
                overlap = 22.5;

            if (angle < 0) {
                angle += 360;
            }

            var left = 135 - overlap <= angle && angle < 225 + overlap,
                up = 225 - overlap <= angle && angle < 315 + overlap,

                right = !left && (315 - overlap <= angle || angle < 45 + overlap),
                down = !up && 45 - overlap <= angle && angle < 135 + overlap;

            this.swipe = {
                up: up,
                down: down,
                left: left,
                right: right,
                angle: angle,
                speed: interaction.prevEvent.speed,
                velocity: {
                    x: interaction.prevEvent.velocityX,
                    y: interaction.prevEvent.velocityY
                }
            };
        }
    }

    InteractEvent.prototype = {
        preventDefault: blank,
        stopImmediatePropagation: function () {
            this.immediatePropagationStopped = this.propagationStopped = true;
        },
        stopPropagation: function () {
            this.propagationStopped = true;
        }
    };

    function preventOriginalDefault() {
        this.originalEvent.preventDefault();
    }

    function getActionCursor(action) {
        var cursor = '';

        if (action.name === 'drag') {
            cursor = actionCursors.drag;
        }
        if (action.name === 'resize') {
            if (action.axis) {
                cursor = actionCursors[action.name + action.axis];
            }
            else if (action.edges) {
                var cursorKey = 'resize',
                    edgeNames = ['top', 'bottom', 'left', 'right'];

                for (var i = 0; i < 4; i++) {
                    if (action.edges[edgeNames[i]]) {
                        cursorKey += edgeNames[i];
                    }
                }

                cursor = actionCursors[cursorKey];
            }
        }

        return cursor;
    }

    function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
        // false, '', undefined, null
        if (!value) { return false; }

        // true value, use pointer coords and element rect
        if (value === true) {
            // if dimensions are negative, "switch" edges
            var width = isNumber(rect.width) ? rect.width : rect.right - rect.left,
                height = isNumber(rect.height) ? rect.height : rect.bottom - rect.top;

            if (width < 0) {
                if (name === 'left') { name = 'right'; }
                else if (name === 'right') { name = 'left'; }
            }
            if (height < 0) {
                if (name === 'top') { name = 'bottom'; }
                else if (name === 'bottom') { name = 'top'; }
            }

            if (name === 'left') { return page.x < ((width >= 0 ? rect.left : rect.right) + margin); }
            if (name === 'top') { return page.y < ((height >= 0 ? rect.top : rect.bottom) + margin); }

            if (name === 'right') { return page.x > ((width >= 0 ? rect.right : rect.left) - margin); }
            if (name === 'bottom') { return page.y > ((height >= 0 ? rect.bottom : rect.top) - margin); }
        }

        // the remaining checks require an element
        if (!isElement(element)) { return false; }

        return isElement(value)
            // the value is an element to use as a resize handle
            ? value === element
            // otherwise check if element matches value as selector
            : matchesUpTo(element, value, interactableElement);
    }

    function defaultActionChecker(pointer, interaction, element) {
        var rect = this.getRect(element),
            shouldResize = false,
            action = null,
            resizeAxes = null,
            resizeEdges,
            page = extend({}, interaction.curCoords.page),
            options = this.options;

        if (!rect) { return null; }

        if (actionIsEnabled.resize && options.resize.enabled) {
            var resizeOptions = options.resize;

            resizeEdges = {
                left: false, right: false, top: false, bottom: false
            };

            // if using resize.edges
            if (isObject(resizeOptions.edges)) {
                for (var edge in resizeEdges) {
                    resizeEdges[edge] = checkResizeEdge(edge,
                        resizeOptions.edges[edge],
                        page,
                        interaction._eventTarget,
                        element,
                        rect,
                        resizeOptions.margin || margin);
                }

                resizeEdges.left = resizeEdges.left && !resizeEdges.right;
                resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;

                shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;
            }
            else {
                var right = options.resize.axis !== 'y' && page.x > (rect.right - margin),
                    bottom = options.resize.axis !== 'x' && page.y > (rect.bottom - margin);

                shouldResize = right || bottom;
                resizeAxes = (right ? 'x' : '') + (bottom ? 'y' : '');
            }
        }

        action = shouldResize
            ? 'resize'
            : actionIsEnabled.drag && options.drag.enabled
                ? 'drag'
                : null;

        if (actionIsEnabled.gesture
            && interaction.pointerIds.length >= 2
            && !(interaction.dragging || interaction.resizing)) {
            action = 'gesture';
        }

        if (action) {
            return {
                name: action,
                axis: resizeAxes,
                edges: resizeEdges
            };
        }

        return null;
    }

    // Check if action is enabled globally and the current target supports it
    // If so, return the validated action. Otherwise, return null
    function validateAction(action, interactable) {
        if (!isObject(action)) { return null; }

        var actionName = action.name,
            options = interactable.options;

        if (((actionName === 'resize' && options.resize.enabled)
            || (actionName === 'drag' && options.drag.enabled)
            || (actionName === 'gesture' && options.gesture.enabled))
            && actionIsEnabled[actionName]) {

            if (actionName === 'resize' || actionName === 'resizeyx') {
                actionName = 'resizexy';
            }

            return action;
        }
        return null;
    }

    var listeners = {},
        interactionListeners = [
            'dragStart', 'dragMove', 'resizeStart', 'resizeMove', 'gestureStart', 'gestureMove',
            'pointerOver', 'pointerOut', 'pointerHover', 'selectorDown',
            'pointerDown', 'pointerMove', 'pointerUp', 'pointerCancel', 'pointerEnd',
            'addPointer', 'removePointer', 'recordPointer', 'autoScrollMove'
        ];

    for (var i = 0, len = interactionListeners.length; i < len; i++) {
        var name = interactionListeners[i];

        listeners[name] = doOnInteractions(name);
    }

    // bound to the interactable context when a DOM event
    // listener is added to a selector interactable
    function delegateListener(event, useCapture) {
        var fakeEvent = {},
            delegated = delegatedEvents[event.type],
            eventTarget = getActualElement(event.path
                ? event.path[0]
                : event.target),
            element = eventTarget;

        useCapture = useCapture ? true : false;

        // duplicate the event so that currentTarget can be changed
        for (var prop in event) {
            fakeEvent[prop] = event[prop];
        }

        fakeEvent.originalEvent = event;
        fakeEvent.preventDefault = preventOriginalDefault;

        // climb up document tree looking for selector matches
        while (isElement(element)) {
            for (var i = 0; i < delegated.selectors.length; i++) {
                var selector = delegated.selectors[i],
                    context = delegated.contexts[i];

                if (matchesSelector(element, selector)
                    && nodeContains(context, eventTarget)
                    && nodeContains(context, element)) {

                    var listeners = delegated.listeners[i];

                    fakeEvent.currentTarget = element;

                    for (var j = 0; j < listeners.length; j++) {
                        if (listeners[j][1] === useCapture) {
                            listeners[j][0](fakeEvent);
                        }
                    }
                }
            }

            element = parentElement(element);
        }
    }

    function delegateUseCapture(event) {
        return delegateListener.call(this, event, true);
    }

    interactables.indexOfElement = function indexOfElement(element, context) {
        context = context || document;

        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if ((interactable.selector === element
                && (interactable._context === context))
                || (!interactable.selector && interactable._element === element)) {

                return i;
            }
        }
        return -1;
    };

    interactables.get = function interactableGet(element, options) {
        return this[this.indexOfElement(element, options && options.context)];
    };

    interactables.forEachSelector = function (callback) {
        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if (!interactable.selector) {
                continue;
            }

            var ret = callback(interactable, interactable.selector, interactable._context, i, this);

            if (ret !== undefined) {
                return ret;
            }
        }
    };

    /*\
     * interact
     [ method ]
     *
     * The methods of this variable can be used to set elements as
     * interactables and also to change various default settings.
     *
     * Calling it as a function and passing an element or a valid CSS selector
     * string returns an Interactable object which has various methods to
     * configure it.
     *
     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
     = (object) An @Interactable
     *
     > Usage
     | interact(document.getElementById('draggable')).draggable(true);
     |
     | var rectables = interact('rect');
     | rectables
     |     .gesturable(true)
     |     .on('gesturemove', function (event) {
     |         // something cool...
     |     })
     |     .autoScroll(true);
    \*/
    function interact(element, options) {
        return interactables.get(element, options) || new Interactable(element, options);
    }

    /*\
     * Interactable
     [ property ]
     **
     * Object type returned by @interact
    \*/
    function Interactable(element, options) {
        this._element = element;
        this._iEvents = this._iEvents || {};

        var _window;

        if (trySelector(element)) {
            this.selector = element;

            var context = options && options.context;

            _window = context ? getWindow(context) : window;

            if (context && (_window.Node
                ? context instanceof _window.Node
                : (isElement(context) || context === _window.document))) {

                this._context = context;
            }
        }
        else {
            _window = getWindow(element);

            if (isElement(element, _window)) {

                if (supportsPointerEvent) {
                    events.add(this._element, pEventTypes.down, listeners.pointerDown);
                    events.add(this._element, pEventTypes.move, listeners.pointerHover);
                }
                else {
                    events.add(this._element, 'mousedown', listeners.pointerDown);
                    events.add(this._element, 'mousemove', listeners.pointerHover);
                    events.add(this._element, 'touchstart', listeners.pointerDown);
                    events.add(this._element, 'touchmove', listeners.pointerHover);
                }
            }
        }

        this._doc = _window.document;

        if (!contains(documents, this._doc)) {
            listenToDocument(this._doc);
        }

        interactables.push(this);

        this.set(options);
    }

    Interactable.prototype = {
        setOnEvents: function (action, phases) {
            if (action === 'drop') {
                if (isFunction(phases.ondrop)) { this.ondrop = phases.ondrop; }
                if (isFunction(phases.ondropactivate)) { this.ondropactivate = phases.ondropactivate; }
                if (isFunction(phases.ondropdeactivate)) { this.ondropdeactivate = phases.ondropdeactivate; }
                if (isFunction(phases.ondragenter)) { this.ondragenter = phases.ondragenter; }
                if (isFunction(phases.ondragleave)) { this.ondragleave = phases.ondragleave; }
                if (isFunction(phases.ondropmove)) { this.ondropmove = phases.ondropmove; }
            }
            else {
                action = 'on' + action;

                if (isFunction(phases.onstart)) { this[action + 'start'] = phases.onstart; }
                if (isFunction(phases.onmove)) { this[action + 'move'] = phases.onmove; }
                if (isFunction(phases.onend)) { this[action + 'end'] = phases.onend; }
                if (isFunction(phases.oninertiastart)) { this[action + 'inertiastart'] = phases.oninertiastart; }
            }

            return this;
        },

        /*\
         * Interactable.draggable
         [ method ]
         *
         * Gets or sets whether drag actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of drag events
         | var isDraggable = interact('ul li').draggable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
         = (object) This Interactable
         | interact(element).draggable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // the axis in which the first movement must be
         |     // for the drag sequence to start
         |     // 'xy' by default - any direction
         |     axis: 'x' || 'y' || 'xy',
         |
         |     // max number of drags that can happen concurrently
         |     // with elements of this Interactable. Infinity by default
         |     max: Infinity,
         |
         |     // max number of drags that can target the same element+Interactable
         |     // 1 by default
         |     maxPerElement: 2
         | });
        \*/
        draggable: function (options) {
            if (isObject(options)) {
                this.options.drag.enabled = options.enabled === false ? false : true;
                this.setPerAction('drag', options);
                this.setOnEvents('drag', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.drag.axis = options.axis;
                }
                else if (options.axis === null) {
                    delete this.options.drag.axis;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drag.enabled = options;

                return this;
            }

            return this.options.drag;
        },

        setPerAction: function (action, options) {
            // for all the default per-action options
            for (var option in options) {
                // if this option exists for this action
                if (option in defaultOptions[action]) {
                    // if the option in the options arg is an object value
                    if (isObject(options[option])) {
                        // duplicate the object
                        this.options[action][option] = extend(this.options[action][option] || {}, options[option]);

                        if (isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]) {
                            this.options[action][option].enabled = options[option].enabled === false ? false : true;
                        }
                    }
                    else if (isBool(options[option]) && isObject(defaultOptions.perAction[option])) {
                        this.options[action][option].enabled = options[option];
                    }
                    else if (options[option] !== undefined) {
                        // or if it's not undefined, do a plain assignment
                        this.options[action][option] = options[option];
                    }
                }
            }
        },

        /*\
         * Interactable.dropzone
         [ method ]
         *
         * Returns or sets whether elements can be dropped onto this
         * Interactable to trigger drop events
         *
         * Dropzones can receive the following events:
         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
         *  - `dragmove` when a draggable that has entered the dropzone is moved
         *  - `drop` when a draggable is dropped into this dropzone
         *
         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
         *
         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
         *   - `'pointer'`, the pointer must be over the dropzone (default)
         *   - `'center'`, the draggable element's center must be over the dropzone
         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
         *       e.g. `0.5` for drop to happen when half of the area of the
         *       draggable is over the dropzone
         *
         - options (boolean | object | null) #optional The new value to be set.
         | interact('.drop').dropzone({
         |   accept: '.can-drop' || document.getElementById('single-drop'),
         |   overlap: 'pointer' || 'center' || zeroToOne
         | }
         = (boolean | object) The current setting or this Interactable
        \*/
        dropzone: function (options) {
            if (isObject(options)) {
                this.options.drop.enabled = options.enabled === false ? false : true;
                this.setOnEvents('drop', options);

                if (/^(pointer|center)$/.test(options.overlap)) {
                    this.options.drop.overlap = options.overlap;
                }
                else if (isNumber(options.overlap)) {
                    this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
                }
                if ('accept' in options) {
                    this.options.drop.accept = options.accept;
                }
                if ('checker' in options) {
                    this.options.drop.checker = options.checker;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drop.enabled = options;

                return this;
            }

            return this.options.drop;
        },

        dropCheck: function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
            var dropped = false;

            // if the dropzone has no rect (eg. display: none)
            // call the custom dropChecker or just return false
            if (!(rect = rect || this.getRect(dropElement))) {
                return (this.options.drop.checker
                    ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement)
                    : false);
            }

            var dropOverlap = this.options.drop.overlap;

            if (dropOverlap === 'pointer') {
                var page = getPageXY(dragEvent),
                    origin = getOriginXY(draggable, draggableElement),
                    horizontal,
                    vertical;

                page.x += origin.x;
                page.y += origin.y;

                horizontal = (page.x > rect.left) && (page.x < rect.right);
                vertical = (page.y > rect.top) && (page.y < rect.bottom);

                dropped = horizontal && vertical;
            }

            var dragRect = draggable.getRect(draggableElement);

            if (dropOverlap === 'center') {
                var cx = dragRect.left + dragRect.width / 2,
                    cy = dragRect.top + dragRect.height / 2;

                dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
            }

            if (isNumber(dropOverlap)) {
                var overlapArea = (Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left))
                    * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top))),
                    overlapRatio = overlapArea / (dragRect.width * dragRect.height);

                dropped = overlapRatio >= dropOverlap;
            }

            if (this.options.drop.checker) {
                dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
            }

            return dropped;
        },

        /*\
         * Interactable.dropChecker
         [ method ]
         *
         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
         *
         * Gets or sets the function used to check if a dragged element is
         * over this Interactable.
         *
         - checker (function) #optional The function that will be called when checking for a drop
         = (Function | Interactable) The checker function or this Interactable
         *
         * The checker function takes the following arguments:
         *
         - dragEvent (InteractEvent) The related dragmove or dragend event
         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
         - dropped (boolean) The value from the default drop checker
         - dropzone (Interactable) The dropzone interactable
         - dropElement (Element) The dropzone element
         - draggable (Interactable) The Interactable being dragged
         - draggableElement (Element) The actual element that's being dragged
         *
         > Usage:
         | interact(target)
         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
         |                       event,             // TouchEvent/PointerEvent/MouseEvent
         |                       dropped,           // bool result of the default checker
         |                       dropzone,          // dropzone Interactable
         |                       dropElement,       // dropzone elemnt
         |                       draggable,         // draggable Interactable
         |                       draggableElement) {// draggable element
         |
         |   return dropped && event.target.hasAttribute('allow-drop');
         | }
        \*/
        dropChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.drop.checker = checker;

                return this;
            }
            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.options.drop.checker;
        },

        /*\
         * Interactable.accept
         [ method ]
         *
         * Deprecated. add an `accept` property to the options object passed to
         * @Interactable.dropzone instead.
         *
         * Gets or sets the Element or CSS selector match that this
         * Interactable accepts if it is a dropzone.
         *
         - newValue (Element | string | null) #optional
         * If it is an Element, then only that element can be dropped into this dropzone.
         * If it is a string, the element being dragged must match it as a selector.
         * If it is null, the accept options is cleared - it accepts any element.
         *
         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
        \*/
        accept: function (newValue) {
            if (isElement(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            // test if it is a valid CSS selector
            if (trySelector(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.drop.accept;

                return this;
            }

            return this.options.drop.accept;
        },

        /*\
         * Interactable.resizable
         [ method ]
         *
         * Gets or sets whether resize actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of resize elements
         | var isResizeable = interact('input[type=text]').resizable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
         = (object) This Interactable
         | interact(element).resizable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     edges: {
         |       top   : true,       // Use pointer coords to check for resize.
         |       left  : false,      // Disable resizing from left edge.
         |       bottom: '.resize-s',// Resize if pointer target matches selector
         |       right : handleEl    // Resize if pointer target is the given Element
         |     },
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height are adjusted at a 1:1 ratio.
         |     square: false,
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height maintain the aspect ratio they had when resizing started.
         |     preserveAspectRatio: false,
         |
         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
         |     // 'negate' will allow the rect to have negative width/height
         |     // 'reposition' will keep the width/height positive by swapping
         |     // the top and bottom edges and/or swapping the left and right edges
         |     invert: 'none' || 'negate' || 'reposition'
         |
         |     // limit multiple resizes.
         |     // See the explanation in the @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        resizable: function (options) {
            if (isObject(options)) {
                this.options.resize.enabled = options.enabled === false ? false : true;
                this.setPerAction('resize', options);
                this.setOnEvents('resize', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.resize.axis = options.axis;
                }
                else if (options.axis === null) {
                    this.options.resize.axis = defaultOptions.resize.axis;
                }

                if (isBool(options.preserveAspectRatio)) {
                    this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
                }
                else if (isBool(options.square)) {
                    this.options.resize.square = options.square;
                }

                return this;
            }
            if (isBool(options)) {
                this.options.resize.enabled = options;

                return this;
            }
            return this.options.resize;
        },

        /*\
         * Interactable.squareResize
         [ method ]
         *
         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
         *
         * Gets or sets whether resizing is forced 1:1 aspect
         *
         = (boolean) Current setting
         *
         * or
         *
         - newValue (boolean) #optional
         = (object) this Interactable
        \*/
        squareResize: function (newValue) {
            if (isBool(newValue)) {
                this.options.resize.square = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.resize.square;

                return this;
            }

            return this.options.resize.square;
        },

        /*\
         * Interactable.gesturable
         [ method ]
         *
         * Gets or sets whether multitouch gestures can be performed on the
         * Interactable's element
         *
         = (boolean) Indicates if this can be the target of gesture events
         | var isGestureable = interact(element).gesturable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
         = (object) this Interactable
         | interact(element).gesturable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // limit multiple gestures.
         |     // See the explanation in @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        gesturable: function (options) {
            if (isObject(options)) {
                this.options.gesture.enabled = options.enabled === false ? false : true;
                this.setPerAction('gesture', options);
                this.setOnEvents('gesture', options);

                return this;
            }

            if (isBool(options)) {
                this.options.gesture.enabled = options;

                return this;
            }

            return this.options.gesture;
        },

        /*\
         * Interactable.autoScroll
         [ method ]
         **
         * Deprecated. Add an `autoscroll` property to the options object
         * passed to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets whether dragging and resizing near the edges of the
         * window/container trigger autoScroll for this Interactable
         *
         = (object) Object with autoScroll properties
         *
         * or
         *
         - options (object | boolean) #optional
         * options can be:
         * - an object with margin, distance and interval properties,
         * - true or false to enable or disable autoScroll or
         = (Interactable) this Interactable
        \*/
        autoScroll: function (options) {
            if (isObject(options)) {
                options = extend({ actions: ['drag', 'resize'] }, options);
            }
            else if (isBool(options)) {
                options = { actions: ['drag', 'resize'], enabled: options };
            }

            return this.setOptions('autoScroll', options);
        },

        /*\
         * Interactable.snap
         [ method ]
         **
         * Deprecated. Add a `snap` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how action coordinates are snapped. By
         * default, snapping is relative to the pointer coordinates. You can
         * change this by setting the
         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
         **
         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | interact(document.querySelector('#thing')).snap({
         |     targets: [
         |         // snap to this specific point
         |         {
         |             x: 100,
         |             y: 100,
         |             range: 25
         |         },
         |         // give this function the x and y page coords and snap to the object returned
         |         function (x, y) {
         |             return {
         |                 x: x,
         |                 y: (75 + 50 * Math.sin(x * 0.04)),
         |                 range: 40
         |             };
         |         },
         |         // create a function that snaps to a grid
         |         interact.createSnapGrid({
         |             x: 50,
         |             y: 50,
         |             range: 10,              // optional
         |             offset: { x: 5, y: 10 } // optional
         |         })
         |     ],
         |     // do not snap during normal movement.
         |     // Instead, trigger only one snapped move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     relativePoints: [
         |         { x: 0, y: 0 },  // snap relative to the top left of the element
         |         { x: 1, y: 1 },  // and also to the bottom right
         |     ],  
         |
         |     // offset the snap target coordinates
         |     // can be an object with x/y or 'startCoords'
         |     offset: { x: 50, y: 50 }
         |   }
         | });
        \*/
        snap: function (options) {
            var ret = this.setOptions('snap', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        setOptions: function (option, options) {
            var actions = options && isArray(options.actions)
                ? options.actions
                : ['drag'];

            var i;

            if (isObject(options) || isBool(options)) {
                for (i = 0; i < actions.length; i++) {
                    var action = /resize/.test(actions[i]) ? 'resize' : actions[i];

                    if (!isObject(this.options[action])) { continue; }

                    var thisOption = this.options[action][option];

                    if (isObject(options)) {
                        extend(thisOption, options);
                        thisOption.enabled = options.enabled === false ? false : true;

                        if (option === 'snap') {
                            if (thisOption.mode === 'grid') {
                                thisOption.targets = [
                                    interact.createSnapGrid(extend({
                                        offset: thisOption.gridOffset || { x: 0, y: 0 }
                                    }, thisOption.grid || {}))
                                ];
                            }
                            else if (thisOption.mode === 'anchor') {
                                thisOption.targets = thisOption.anchors;
                            }
                            else if (thisOption.mode === 'path') {
                                thisOption.targets = thisOption.paths;
                            }

                            if ('elementOrigin' in options) {
                                thisOption.relativePoints = [options.elementOrigin];
                            }
                        }
                    }
                    else if (isBool(options)) {
                        thisOption.enabled = options;
                    }
                }

                return this;
            }

            var ret = {},
                allActions = ['drag', 'resize', 'gesture'];

            for (i = 0; i < allActions.length; i++) {
                if (option in defaultOptions[allActions[i]]) {
                    ret[allActions[i]] = this.options[allActions[i]][option];
                }
            }

            return ret;
        },


        /*\
         * Interactable.inertia
         [ method ]
         **
         * Deprecated. Add an `inertia` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how events continue to run after the pointer is released
         **
         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | // enable and use default settings
         | interact(element).inertia(true);
         |
         | // enable and use custom settings
         | interact(element).inertia({
         |     // value greater than 0
         |     // high values slow the object down more quickly
         |     resistance     : 16,
         |
         |     // the minimum launch speed (pixels per second) that results in inertia start
         |     minSpeed       : 200,
         |
         |     // inertia will stop when the object slows down to this speed
         |     endSpeed       : 20,
         |
         |     // boolean; should actions be resumed when the pointer goes down during inertia
         |     allowResume    : true,
         |
         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
         |     zeroResumeDelta: false,
         |
         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
         |     // the pointer without triggering inertia will animate from the release
         |     // point to the snaped/restricted point in the given amount of time (ms)
         |     smoothEndDuration: 300,
         |
         |     // an array of action types that can have inertia (no gesture)
         |     actions        : ['drag', 'resize']
         | });
         |
         | // reset custom settings and use all defaults
         | interact(element).inertia(null);
        \*/
        inertia: function (options) {
            var ret = this.setOptions('inertia', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        getAction: function (pointer, event, interaction, element) {
            var action = this.defaultActionChecker(pointer, interaction, element);

            if (this.options.actionChecker) {
                return this.options.actionChecker(pointer, event, action, this, element, interaction);
            }

            return action;
        },

        defaultActionChecker: defaultActionChecker,

        /*\
         * Interactable.actionChecker
         [ method ]
         *
         * Gets or sets the function used to check action to be performed on
         * pointerDown
         *
         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
         = (Function | Interactable) The checker function or this Interactable
         *
         | interact('.resize-drag')
         |   .resizable(true)
         |   .draggable(true)
         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
         |
         |   if (interact.matchesSelector(event.target, '.drag-handle') {
         |     // force drag with handle target
         |     action.name = drag;
         |   }
         |   else {
         |     // resize from the top and right edges
         |     action.name  = 'resize';
         |     action.edges = { top: true, right: true };
         |   }
         |
         |   return action;
         | });
        \*/
        actionChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.actionChecker = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.actionChecker;

                return this;
            }

            return this.options.actionChecker;
        },

        /*\
         * Interactable.getRect
         [ method ]
         *
         * The default function to get an Interactables bounding rect. Can be
         * overridden using @Interactable.rectChecker.
         *
         - element (Element) #optional The element to measure.
         = (object) The object's bounding rectangle.
         o {
         o     top   : 0,
         o     left  : 0,
         o     bottom: 0,
         o     right : 0,
         o     width : 0,
         o     height: 0
         o }
        \*/
        getRect: function rectCheck(element) {
            element = element || this._element;

            if (this.selector && !(isElement(element))) {
                element = this._context.querySelector(this.selector);
            }

            return getElementRect(element);
        },

        /*\
         * Interactable.rectChecker
         [ method ]
         *
         * Returns or sets the function used to calculate the interactable's
         * element's rectangle
         *
         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
         = (function | object) The checker function or this Interactable
        \*/
        rectChecker: function (checker) {
            if (isFunction(checker)) {
                this.getRect = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.getRect;
        },

        /*\
         * Interactable.styleCursor
         [ method ]
         *
         * Returns or sets whether the action that would be performed when the
         * mouse on the element are checked on `mousemove` so that the cursor
         * may be styled appropriately
         *
         - newValue (boolean) #optional
         = (boolean | Interactable) The current setting or this Interactable
        \*/
        styleCursor: function (newValue) {
            if (isBool(newValue)) {
                this.options.styleCursor = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.styleCursor;

                return this;
            }

            return this.options.styleCursor;
        },

        /*\
         * Interactable.preventDefault
         [ method ]
         *
         * Returns or sets whether to prevent the browser's default behaviour
         * in response to pointer events. Can be set to:
         *  - `'always'` to always prevent
         *  - `'never'` to never prevent
         *  - `'auto'` to let interact.js try to determine what would be best
         *
         - newValue (string) #optional `true`, `false` or `'auto'`
         = (string | Interactable) The current setting or this Interactable
        \*/
        preventDefault: function (newValue) {
            if (/^(always|never|auto)$/.test(newValue)) {
                this.options.preventDefault = newValue;
                return this;
            }

            if (isBool(newValue)) {
                this.options.preventDefault = newValue ? 'always' : 'never';
                return this;
            }

            return this.options.preventDefault;
        },

        /*\
         * Interactable.origin
         [ method ]
         *
         * Gets or sets the origin of the Interactable's element.  The x and y
         * of the origin will be subtracted from action event coordinates.
         *
         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
         * OR
         - origin (Element) #optional An HTML or SVG Element whose rect will be used
         **
         = (object) The current origin or this Interactable
        \*/
        origin: function (newValue) {
            if (trySelector(newValue)) {
                this.options.origin = newValue;
                return this;
            }
            else if (isObject(newValue)) {
                this.options.origin = newValue;
                return this;
            }

            return this.options.origin;
        },

        /*\
         * Interactable.deltaSource
         [ method ]
         *
         * Returns or sets the mouse coordinate types used to calculate the
         * movement of the pointer.
         *
         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
         = (string | object) The current deltaSource or this Interactable
        \*/
        deltaSource: function (newValue) {
            if (newValue === 'page' || newValue === 'client') {
                this.options.deltaSource = newValue;

                return this;
            }

            return this.options.deltaSource;
        },

        /*\
         * Interactable.restrict
         [ method ]
         **
         * Deprecated. Add a `restrict` property to the options object passed to
         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
         *
         * Returns or sets the rectangles within which actions on this
         * interactable (after snap calculations) are restricted. By default,
         * restricting is relative to the pointer coordinates. You can change
         * this by setting the
         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
         **
         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
         = (object) The current restrictions object or this Interactable
         **
         | interact(element).restrict({
         |     // the rect will be `interact.getElementRect(element.parentNode)`
         |     drag: element.parentNode,
         |
         |     // x and y are relative to the the interactable's origin
         |     resize: { x: 100, y: 100, width: 200, height: 200 }
         | })
         |
         | interact('.draggable').restrict({
         |     // the rect will be the selected element's parent
         |     drag: 'parent',
         |
         |     // do not restrict during normal movement.
         |     // Instead, trigger only one restricted move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
         | });
        \*/
        restrict: function (options) {
            if (!isObject(options)) {
                return this.setOptions('restrict', options);
            }

            var actions = ['drag', 'resize', 'gesture'],
                ret;

            for (var i = 0; i < actions.length; i++) {
                var action = actions[i];

                if (action in options) {
                    var perAction = extend({
                        actions: [action],
                        restriction: options[action]
                    }, options);

                    ret = this.setOptions('restrict', perAction);
                }
            }

            return ret;
        },

        /*\
         * Interactable.context
         [ method ]
         *
         * Gets the selector context Node of the Interactable. The default is `window.document`.
         *
         = (Node) The context Node of this Interactable
         **
        \*/
        context: function () {
            return this._context;
        },

        _context: document,

        /*\
         * Interactable.ignoreFrom
         [ method ]
         *
         * If the target of the `mousedown`, `pointerdown` or `touchstart`
         * event or any of it's parents match the given CSS selector or
         * Element, no drag/resize/gesture is started.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
         = (string | Element | object) The current ignoreFrom value or this Interactable
         **
         | interact(element, { ignoreFrom: document.getElementById('no-action') });
         | // or
         | interact(element).ignoreFrom('input, textarea, a');
        \*/
        ignoreFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.ignoreFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.ignoreFrom = newValue;
                return this;
            }

            return this.options.ignoreFrom;
        },

        /*\
         * Interactable.allowFrom
         [ method ]
         *
         * A drag/resize/gesture is started only If the target of the
         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
         * parents match the given CSS selector or Element.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
         = (string | Element | object) The current allowFrom value or this Interactable
         **
         | interact(element, { allowFrom: document.getElementById('drag-handle') });
         | // or
         | interact(element).allowFrom('.handle');
        \*/
        allowFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.allowFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.allowFrom = newValue;
                return this;
            }

            return this.options.allowFrom;
        },

        /*\
         * Interactable.element
         [ method ]
         *
         * If this is not a selector Interactable, it returns the element this
         * interactable represents
         *
         = (Element) HTML / SVG Element
        \*/
        element: function () {
            return this._element;
        },

        /*\
         * Interactable.fire
         [ method ]
         *
         * Calls listeners for the given InteractEvent type bound globally
         * and directly to this Interactable
         *
         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
         = (Interactable) this Interactable
        \*/
        fire: function (iEvent) {
            if (!(iEvent && iEvent.type) || !contains(eventTypes, iEvent.type)) {
                return this;
            }

            var listeners,
                i,
                len,
                onEvent = 'on' + iEvent.type,
                funcName = '';

            // Interactable#on() listeners
            if (iEvent.type in this._iEvents) {
                listeners = this._iEvents[iEvent.type];

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            // interactable.onevent listener
            if (isFunction(this[onEvent])) {
                funcName = this[onEvent].name;
                this[onEvent](iEvent);
            }

            // interact.on() listeners
            if (iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type])) {

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            return this;
        },

        /*\
         * Interactable.on
         [ method ]
         *
         * Binds a listener for an InteractEvent or DOM event.
         *
         - eventType  (string | array | object) The types of events to listen for
         - listener   (function) The function to be called on the given event(s)
         - useCapture (boolean) #optional useCapture flag for addEventListener
         = (object) This Interactable
        \*/
        on: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.on(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.on(prop, eventType[prop], listener);
                }

                return this;
            }

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (contains(eventTypes, eventType)) {
                // if this type of event was never bound to this Interactable
                if (!(eventType in this._iEvents)) {
                    this._iEvents[eventType] = [listener];
                }
                else {
                    this._iEvents[eventType].push(listener);
                }
            }
            // delegated event for selector
            else if (this.selector) {
                if (!delegatedEvents[eventType]) {
                    delegatedEvents[eventType] = {
                        selectors: [],
                        contexts: [],
                        listeners: []
                    };

                    // add delegate listener functions
                    for (i = 0; i < documents.length; i++) {
                        events.add(documents[i], eventType, delegateListener);
                        events.add(documents[i], eventType, delegateUseCapture, true);
                    }
                }

                var delegated = delegatedEvents[eventType],
                    index;

                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {
                        break;
                    }
                }

                if (index === -1) {
                    index = delegated.selectors.length;

                    delegated.selectors.push(this.selector);
                    delegated.contexts.push(this._context);
                    delegated.listeners.push([]);
                }

                // keep listener and useCapture flag
                delegated.listeners[index].push([listener, useCapture]);
            }
            else {
                events.add(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.off
         [ method ]
         *
         * Removes an InteractEvent or DOM event listener
         *
         - eventType  (string | array | object) The types of events that were listened for
         - listener   (function) The listener function to be removed
         - useCapture (boolean) #optional useCapture flag for removeEventListener
         = (object) This Interactable
        \*/
        off: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.off(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.off(prop, eventType[prop], listener);
                }

                return this;
            }

            var eventList,
                index = -1;

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // if it is an action event type
            if (contains(eventTypes, eventType)) {
                eventList = this._iEvents[eventType];

                if (eventList && (index = indexOf(eventList, listener)) !== -1) {
                    this._iEvents[eventType].splice(index, 1);
                }
            }
            // delegated event
            else if (this.selector) {
                var delegated = delegatedEvents[eventType],
                    matchFound = false;

                if (!delegated) { return this; }

                // count from last index of delegated to 0
                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    // look for matching selector and context Node
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {

                        var listeners = delegated.listeners[index];

                        // each item of the listeners array is an array: [function, useCaptureFlag]
                        for (i = listeners.length - 1; i >= 0; i--) {
                            var fn = listeners[i][0],
                                useCap = listeners[i][1];

                            // check if the listener functions and useCapture flags match
                            if (fn === listener && useCap === useCapture) {
                                // remove the listener from the array of listeners
                                listeners.splice(i, 1);

                                // if all listeners for this interactable have been removed
                                // remove the interactable from the delegated arrays
                                if (!listeners.length) {
                                    delegated.selectors.splice(index, 1);
                                    delegated.contexts.splice(index, 1);
                                    delegated.listeners.splice(index, 1);

                                    // remove delegate function from context
                                    events.remove(this._context, eventType, delegateListener);
                                    events.remove(this._context, eventType, delegateUseCapture, true);

                                    // remove the arrays if they are empty
                                    if (!delegated.selectors.length) {
                                        delegatedEvents[eventType] = null;
                                    }
                                }

                                // only remove one listener
                                matchFound = true;
                                break;
                            }
                        }

                        if (matchFound) { break; }
                    }
                }
            }
            // remove listener from this Interatable's element
            else {
                events.remove(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.set
         [ method ]
         *
         * Reset the options of this Interactable
         - options (object) The new settings to apply
         = (object) This Interactable
        \*/
        set: function (options) {
            if (!isObject(options)) {
                options = {};
            }

            this.options = extend({}, defaultOptions.base);

            var i,
                actions = ['drag', 'drop', 'resize', 'gesture'],
                methods = ['draggable', 'dropzone', 'resizable', 'gesturable'],
                perActions = extend(extend({}, defaultOptions.perAction), options[action] || {});

            for (i = 0; i < actions.length; i++) {
                var action = actions[i];

                this.options[action] = extend({}, defaultOptions[action]);

                this.setPerAction(action, perActions);

                this[methods[i]](options[action]);
            }

            var settings = [
                'accept', 'actionChecker', 'allowFrom', 'deltaSource',
                'dropChecker', 'ignoreFrom', 'origin', 'preventDefault',
                'rectChecker', 'styleCursor'
            ];

            for (i = 0, len = settings.length; i < len; i++) {
                var setting = settings[i];

                this.options[setting] = defaultOptions.base[setting];

                if (setting in options) {
                    this[setting](options[setting]);
                }
            }

            return this;
        },

        /*\
         * Interactable.unset
         [ method ]
         *
         * Remove this interactable from the list of interactables and remove
         * it's drag, drop, resize and gesture capabilities
         *
         = (object) @interact
        \*/
        unset: function () {
            events.remove(this._element, 'all');

            if (!isString(this.selector)) {
                events.remove(this, 'all');
                if (this.options.styleCursor) {
                    this._element.style.cursor = '';
                }
            }
            else {
                // remove delegated events
                for (var type in delegatedEvents) {
                    var delegated = delegatedEvents[type];

                    for (var i = 0; i < delegated.selectors.length; i++) {
                        if (delegated.selectors[i] === this.selector
                            && delegated.contexts[i] === this._context) {

                            delegated.selectors.splice(i, 1);
                            delegated.contexts.splice(i, 1);
                            delegated.listeners.splice(i, 1);

                            // remove the arrays if they are empty
                            if (!delegated.selectors.length) {
                                delegatedEvents[type] = null;
                            }
                        }

                        events.remove(this._context, type, delegateListener);
                        events.remove(this._context, type, delegateUseCapture, true);

                        break;
                    }
                }
            }

            this.dropzone(false);

            interactables.splice(indexOf(interactables, this), 1);

            return interact;
        }
    };

    function warnOnce(method, message) {
        var warned = false;

        return function () {
            if (!warned) {
                window.console.warn(message);
                warned = true;
            }

            return method.apply(this, arguments);
        };
    }

    Interactable.prototype.snap = warnOnce(Interactable.prototype.snap,
        'Interactable#snap is deprecated. See the new documentation for snapping at https://interactjs.io/docs/snapping');
    Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict,
        'Interactable#restrict is deprecated. See the new documentation for resticting at https://interactjs.io/docs/restriction');
    Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia,
        'Interactable#inertia is deprecated. See the new documentation for inertia at https://interactjs.io/docs/inertia');
    Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll,
        'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at https://interactjs.io/docs/#autoscroll');
    Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize,
        'Interactable#squareResize is deprecated. See https://interactjs.io/docs/#resize-square');

    Interactable.prototype.accept = warnOnce(Interactable.prototype.accept,
        'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');
    Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker,
        'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');
    Interactable.prototype.context = warnOnce(Interactable.prototype.context,
        'Interactable#context as a method is deprecated. It will soon be a DOM Node instead');

    /*\
     * interact.isSet
     [ method ]
     *
     * Check if an element has been set
     - element (Element) The Element being searched for
     = (boolean) Indicates if the element or CSS selector was previously passed to interact
    \*/
    interact.isSet = function (element, options) {
        return interactables.indexOfElement(element, options && options.context) !== -1;
    };

    /*\
     * interact.on
     [ method ]
     *
     * Adds a global listener for an InteractEvent or adds a DOM event to
     * `document`
     *
     - type       (string | array | object) The types of events to listen for
     - listener   (function) The function to be called on the given event(s)
     - useCapture (boolean) #optional useCapture flag for addEventListener
     = (object) interact
    \*/
    interact.on = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.on(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.on(prop, type[prop], listener);
            }

            return interact;
        }

        // if it is an InteractEvent type, add listener to globalEvents
        if (contains(eventTypes, type)) {
            // if this type of event was never bound
            if (!globalEvents[type]) {
                globalEvents[type] = [listener];
            }
            else {
                globalEvents[type].push(listener);
            }
        }
        // If non InteractEvent type, addEventListener to document
        else {
            events.add(document, type, listener, useCapture);
        }

        return interact;
    };

    /*\
     * interact.off
     [ method ]
     *
     * Removes a global InteractEvent listener or DOM event from `document`
     *
     - type       (string | array | object) The types of events that were listened for
     - listener   (function) The listener function to be removed
     - useCapture (boolean) #optional useCapture flag for removeEventListener
     = (object) interact
     \*/
    interact.off = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.off(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.off(prop, type[prop], listener);
            }

            return interact;
        }

        if (!contains(eventTypes, type)) {
            events.remove(document, type, listener, useCapture);
        }
        else {
            var index;

            if (type in globalEvents
                && (index = indexOf(globalEvents[type], listener)) !== -1) {
                globalEvents[type].splice(index, 1);
            }
        }

        return interact;
    };

    /*\
     * interact.enableDragging
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether dragging is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableDragging = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.drag = newValue;

            return interact;
        }
        return actionIsEnabled.drag;
    }, 'interact.enableDragging is deprecated and will soon be removed.');

    /*\
     * interact.enableResizing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether resizing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableResizing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.resize = newValue;

            return interact;
        }
        return actionIsEnabled.resize;
    }, 'interact.enableResizing is deprecated and will soon be removed.');

    /*\
     * interact.enableGesturing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether gesturing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableGesturing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.gesture = newValue;

            return interact;
        }
        return actionIsEnabled.gesture;
    }, 'interact.enableGesturing is deprecated and will soon be removed.');

    interact.eventTypes = eventTypes;

    /*\
     * interact.debug
     [ method ]
     *
     * Returns debugging data
     = (object) An object with properties that outline the current state and expose internal functions and variables
    \*/
    interact.debug = function () {
        var interaction = interactions[0] || new Interaction();

        return {
            interactions: interactions,
            target: interaction.target,
            dragging: interaction.dragging,
            resizing: interaction.resizing,
            gesturing: interaction.gesturing,
            prepared: interaction.prepared,
            matches: interaction.matches,
            matchElements: interaction.matchElements,

            prevCoords: interaction.prevCoords,
            startCoords: interaction.startCoords,

            pointerIds: interaction.pointerIds,
            pointers: interaction.pointers,
            addPointer: listeners.addPointer,
            removePointer: listeners.removePointer,
            recordPointer: listeners.recordPointer,

            snap: interaction.snapStatus,
            restrict: interaction.restrictStatus,
            inertia: interaction.inertiaStatus,

            downTime: interaction.downTimes[0],
            downEvent: interaction.downEvent,
            downPointer: interaction.downPointer,
            prevEvent: interaction.prevEvent,

            Interactable: Interactable,
            interactables: interactables,
            pointerIsDown: interaction.pointerIsDown,
            defaultOptions: defaultOptions,
            defaultActionChecker: defaultActionChecker,

            actionCursors: actionCursors,
            dragMove: listeners.dragMove,
            resizeMove: listeners.resizeMove,
            gestureMove: listeners.gestureMove,
            pointerUp: listeners.pointerUp,
            pointerDown: listeners.pointerDown,
            pointerMove: listeners.pointerMove,
            pointerHover: listeners.pointerHover,

            eventTypes: eventTypes,

            events: events,
            globalEvents: globalEvents,
            delegatedEvents: delegatedEvents,

            prefixedPropREs: prefixedPropREs
        };
    };

    // expose the functions used to calculate multi-touch properties
    interact.getPointerAverage = pointerAverage;
    interact.getTouchBBox = touchBBox;
    interact.getTouchDistance = touchDistance;
    interact.getTouchAngle = touchAngle;

    interact.getElementRect = getElementRect;
    interact.getElementClientRect = getElementClientRect;
    interact.matchesSelector = matchesSelector;
    interact.closest = closest;

    /*\
     * interact.margin
     [ method ]
     *
     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
     * Returns or sets the margin for autocheck resizing used in
     * @Interactable.getAction. That is the distance from the bottom and right
     * edges of an element clicking in which will start resizing
     *
     - newValue (number) #optional
     = (number | interact) The current margin value or interact
    \*/
    interact.margin = warnOnce(function (newvalue) {
        if (isNumber(newvalue)) {
            margin = newvalue;

            return interact;
        }
        return margin;
    },
        'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.');

    /*\
     * interact.supportsTouch
     [ method ]
     *
     = (boolean) Whether or not the browser supports touch input
    \*/
    interact.supportsTouch = function () {
        return supportsTouch;
    };

    /*\
     * interact.supportsPointerEvent
     [ method ]
     *
     = (boolean) Whether or not the browser supports PointerEvents
    \*/
    interact.supportsPointerEvent = function () {
        return supportsPointerEvent;
    };

    /*\
     * interact.stop
     [ method ]
     *
     * Cancels all interactions (end events are not fired)
     *
     - event (Event) An event on which to call preventDefault()
     = (object) interact
    \*/
    interact.stop = function (event) {
        for (var i = interactions.length - 1; i >= 0; i--) {
            interactions[i].stop(event);
        }

        return interact;
    };

    /*\
     * interact.dynamicDrop
     [ method ]
     *
     * Returns or sets whether the dimensions of dropzone elements are
     * calculated on every dragmove or only on dragstart for the default
     * dropChecker
     *
     - newValue (boolean) #optional True to check on each move. False to check only before start
     = (boolean | interact) The current setting or interact
    \*/
    interact.dynamicDrop = function (newValue) {
        if (isBool(newValue)) {
            //if (dragging && dynamicDrop !== newValue && !newValue) {
            //calcRects(dropzones);
            //}

            dynamicDrop = newValue;

            return interact;
        }
        return dynamicDrop;
    };

    /*\
     * interact.pointerMoveTolerance
     [ method ]
     * Returns or sets the distance the pointer must be moved before an action
     * sequence occurs. This also affects tolerance for tap events.
     *
     - newValue (number) #optional The movement from the start position must be greater than this value
     = (number | Interactable) The current setting or interact
    \*/
    interact.pointerMoveTolerance = function (newValue) {
        if (isNumber(newValue)) {
            pointerMoveTolerance = newValue;

            return this;
        }

        return pointerMoveTolerance;
    };

    /*\
     * interact.maxInteractions
     [ method ]
     **
     * Returns or sets the maximum number of concurrent interactions allowed.
     * By default only 1 interaction is allowed at a time (for backwards
     * compatibility). To allow multiple interactions on the same Interactables
     * and elements, you need to enable it in the draggable, resizable and
     * gesturable `'max'` and `'maxPerElement'` options.
     **
     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
    \*/
    interact.maxInteractions = function (newValue) {
        if (isNumber(newValue)) {
            maxInteractions = newValue;

            return this;
        }

        return maxInteractions;
    };

    interact.createSnapGrid = function (grid) {
        return function (x, y) {
            var offsetX = 0,
                offsetY = 0;

            if (isObject(grid.offset)) {
                offsetX = grid.offset.x;
                offsetY = grid.offset.y;
            }

            var gridx = Math.round((x - offsetX) / grid.x),
                gridy = Math.round((y - offsetY) / grid.y),

                newX = gridx * grid.x + offsetX,
                newY = gridy * grid.y + offsetY;

            return {
                x: newX,
                y: newY,
                range: grid.range
            };
        };
    };

    function endAllInteractions(event) {
        for (var i = 0; i < interactions.length; i++) {
            interactions[i].pointerEnd(event, event);
        }
    }

    function listenToDocument(doc) {
        if (contains(documents, doc)) { return; }

        var win = doc.defaultView || doc.parentWindow;

        // add delegate event listener
        for (var eventType in delegatedEvents) {
            events.add(doc, eventType, delegateListener);
            events.add(doc, eventType, delegateUseCapture, true);
        }

        if (supportsPointerEvent) {
            if (PointerEvent === win.MSPointerEvent) {
                pEventTypes = {
                    up: 'MSPointerUp', down: 'MSPointerDown', over: 'mouseover',
                    out: 'mouseout', move: 'MSPointerMove', cancel: 'MSPointerCancel'
                };
            }
            else {
                pEventTypes = {
                    up: 'pointerup', down: 'pointerdown', over: 'pointerover',
                    out: 'pointerout', move: 'pointermove', cancel: 'pointercancel'
                };
            }

            events.add(doc, pEventTypes.down, listeners.selectorDown);
            events.add(doc, pEventTypes.move, listeners.pointerMove);
            events.add(doc, pEventTypes.over, listeners.pointerOver);
            events.add(doc, pEventTypes.out, listeners.pointerOut);
            events.add(doc, pEventTypes.up, listeners.pointerUp);
            events.add(doc, pEventTypes.cancel, listeners.pointerCancel);

            // autoscroll
            events.add(doc, pEventTypes.move, listeners.autoScrollMove);
        }
        else {
            events.add(doc, 'mousedown', listeners.selectorDown);
            events.add(doc, 'mousemove', listeners.pointerMove);
            events.add(doc, 'mouseup', listeners.pointerUp);
            events.add(doc, 'mouseover', listeners.pointerOver);
            events.add(doc, 'mouseout', listeners.pointerOut);

            events.add(doc, 'touchstart', listeners.selectorDown);
            events.add(doc, 'touchmove', listeners.pointerMove);
            events.add(doc, 'touchend', listeners.pointerUp);
            events.add(doc, 'touchcancel', listeners.pointerCancel);

            // autoscroll
            events.add(doc, 'mousemove', listeners.autoScrollMove);
            events.add(doc, 'touchmove', listeners.autoScrollMove);
        }

        events.add(win, 'blur', endAllInteractions);

        try {
            if (win.frameElement) {
                var parentDoc = win.frameElement.ownerDocument,
                    parentWindow = parentDoc.defaultView;

                events.add(parentDoc, 'mouseup', listeners.pointerEnd);
                events.add(parentDoc, 'touchend', listeners.pointerEnd);
                events.add(parentDoc, 'touchcancel', listeners.pointerEnd);
                events.add(parentDoc, 'pointerup', listeners.pointerEnd);
                events.add(parentDoc, 'MSPointerUp', listeners.pointerEnd);
                events.add(parentWindow, 'blur', endAllInteractions);
            }
        }
        catch (error) {
            interact.windowParentError = error;
        }

        // prevent native HTML5 drag on interact.js target elements
        events.add(doc, 'dragstart', function (event) {
            for (var i = 0; i < interactions.length; i++) {
                var interaction = interactions[i];

                if (interaction.element
                    && (interaction.element === event.target
                        || nodeContains(interaction.element, event.target))) {

                    interaction.checkAndPreventDefault(event, interaction.target, interaction.element);
                    return;
                }
            }
        });

        if (events.useAttachEvent) {
            // For IE's lack of Event#preventDefault
            events.add(doc, 'selectstart', function (event) {
                var interaction = interactions[0];

                if (interaction.currentAction()) {
                    interaction.checkAndPreventDefault(event);
                }
            });

            // For IE's bad dblclick event sequence
            events.add(doc, 'dblclick', doOnInteractions('ie8Dblclick'));
        }

        documents.push(doc);
    }

    listenToDocument(document);

    function indexOf(array, target) {
        for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === target) {
                return i;
            }
        }

        return -1;
    }

    function contains(array, target) {
        return indexOf(array, target) !== -1;
    }

    function matchesSelector(element, selector, nodeList) {
        if (ie8MatchesSelector) {
            return ie8MatchesSelector(element, selector, nodeList);
        }

        // remove /deep/ from selectors if shadowDOM polyfill is used
        if (window !== realWindow) {
            selector = selector.replace(/\/deep\//g, ' ');
        }

        return element[prefixedMatchesSelector](selector);
    }

    function matchesUpTo(element, selector, limit) {
        while (isElement(element)) {
            if (matchesSelector(element, selector)) {
                return true;
            }

            element = parentElement(element);

            if (element === limit) {
                return matchesSelector(element, selector);
            }
        }

        return false;
    }

    // For IE8's lack of an Element#matchesSelector
    // taken from https://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
    if (!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])) {
        ie8MatchesSelector = function (element, selector, elems) {
            elems = elems || element.parentNode.querySelectorAll(selector);

            for (var i = 0, len = elems.length; i < len; i++) {
                if (elems[i] === element) {
                    return true;
                }
            }

            return false;
        };
    }

    // requestAnimationFrame polyfill
    (function () {
        var lastTime = 0,
            vendors = ['ms', 'moz', 'webkit', 'o'];

        for (var x = 0; x < vendors.length && !realWindow.requestAnimationFrame; ++x) {
            reqFrame = realWindow[vendors[x] + 'RequestAnimationFrame'];
            cancelFrame = realWindow[vendors[x] + 'CancelAnimationFrame'] || realWindow[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!reqFrame) {
            reqFrame = function (callback) {
                var currTime = new Date().getTime(),
                    timeToCall = Math.max(0, 16 - (currTime - lastTime)),
                    id = setTimeout(function () { callback(currTime + timeToCall); },
                        timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        }

        if (!cancelFrame) {
            cancelFrame = function (id) {
                clearTimeout(id);
            };
        }
    }());

    /* global exports: true, module, define */

    // https://documentcloud.github.io/underscore/docs/underscore.html#section-11
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = interact;
        }
        exports.interact = interact;
    }
    // AMD
    else if (typeof define === 'function' && define.amd) {
        define('interact', function () {
            return interact;
        });
    }
    else {
        realWindow.interact = interact;
    }

}(typeof window === 'undefined' ? undefined : window));
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.calendar', ['mwl.calendar', 'ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_calendar', {
            url: '/Calendar',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/calendar/calendar.html',
                    controller: 'AdminCalendarController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmAdmin/calendar');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.human-resource.HcmAdmin.calendar')
        .controller('AdminCalendarController', AdminCalendarController);


    /** @ngInject */
    function AdminCalendarController($scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Calendar"
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshEventGrid();
        $scope.Update = false;
        $scope.Eventform = true;

        //var today = new Date()
        //$scope.uFrom = new Date(today.getFullYear(), today.getMonth() -1, today.getDate() - 1);
        //$scope.uTo = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        $scope.FromDate = new Date();
        $scope.ToDate = new Date();

        $scope.Datefilter = function () {

            $scope.Calendardatas = undefined;

            $scope.FromDate.setHours(0, 0, 0, 0);
            $scope.ToDate.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/calendar/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, FilterStart_Date: $scope.FromDate, FilterEnd_Date: $scope.ToDate },
            });
            response.then(function (GList) {
                debugger
                $scope.Calendardatas = GList.data.data;
            });
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Calendardatas.xlsx",{headers:true}) FROM ?', [$scope.Calendardatas]);
        };

        $scope.Calendarpopup = function (e) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/calendar/calendarpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AdCalendarController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });


            $scope.DialogTitle = "Add";
            $scope.vm.eEventType = "Event";
            $scope.vm.eEventTitle = '';
            $scope.vm.eStartDate = new Date();
            $scope.vm.eDescription = '';
            $scope.CUpdate = false;
        }

        $scope.CalendarEventadd = function () {

            if ($scope.CUpdate == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/calendar/update",
                    data: {
                        _id: $scope.CID,
                        EventType: $scope.vm.eEventType,
                        EventTitle: $scope.vm.eEventTitle,
                        StartDate: $scope.vm.eStartDate,
                        EndDate: $scope.vm.eStartDate,
                        Description: $scope.vm.eDescription,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Calendardatas[$scope.IndexID] = GList.data.data;
                    //RefreshEventGrid();

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/calendar/add",
                    data: {
                        Client_Id: Client_Id,
                        EventType: $scope.vm.eEventType,
                        EventTitle: $scope.vm.eEventTitle,
                        StartDate: $scope.vm.eStartDate,
                        EndDate: $scope.vm.eStartDate,
                        Description: $scope.vm.eDescription,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEventGrid();

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.CalendarEventupdate = function (e, CalendarEventId, $index) {

            $scope.CUpdate = true;
            $scope.CID = CalendarEventId;
            $scope.IndxID = $index;
            try {
                var CalendarArray = $scope.Calendardatas;
                var item = CalendarArray.filter(function (item) {
                    return item.id === CalendarEventId;
                })[0];
                $scope.id = item.id;
                $scope.DialogTitle = "Edit";
                $scope.vm.eEventType = item.EventType;
                $scope.vm.eEventTitle = item.EventTitle;
                $scope.vm.eStartDate = new Date(item.StartDate);
                $scope.vm.eStartDate = new Date(item.EndDate);
                $scope.vm.eDescription = item.Description;
            } catch (err) { }

            //var info = $scope.Calendardatas
            //
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == CalendarEventId) {
            //        
            //        $scope.DialogTitle = "Edit";
            //        $scope.vm.eEventType = info[i].EventType;
            //        $scope.vm.eEventTitle = info[i].EventTitle;
            //        $scope.vm.eStartDate = new Date(info[i].StartDate);
            //        $scope.vm.eStartDate = new Date(info[i].EndDate);
            //        $scope.vm.eDescription = info[i].Description;
            //    }
            //}

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/calendar/calendarpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AdCalendarController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        $scope.CalendarEventdelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/calendar/calendardelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AdCalendarController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Eventdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/calendar/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Scheduler List deleted successfully!').position('top center'));
                RefreshEventGrid();

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.loadFile = function (files) {

            $scope.$apply(function () {
                $scope.selectedFile = files[0];
                $scope.handleFile();
            })
        }

        $scope.handleFile = function () {

            var file = $scope.selectedFile;
            if (file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var data = e.target.result;
                    var workbook = XLSX.read(data, { type: 'binary' });
                    var first_sheet_name = workbook.SheetNames[0];
                    var dataObjects = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name]);
                    //console.log(excelData);   
                    if (dataObjects.length > 0) {
                        $scope.save(dataObjects, first_sheet_name);
                    } else {
                        $scope.message = "Error : Something Wrong !";
                        showDialog($scope.Event);
                    }
                }
                reader.onerror = function (ex) {
                }
                reader.readAsBinaryString(file);
            }
        }

        $scope.save = function (dataObjects) {

            angular.forEach(dataObjects, function (value, key) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/calendar/add",
                    data: {
                        EventTitle: value.EventTitle,
                        StartDate: new Date(value.StartDate),
                        EndDate: new Date(value.StartDate),
                        Description: value.Description,
                        EventType: value.EventType,
                        CreatedBy: value.CreatedBy,
                    },
                });
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                RefreshEventGrid();

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        //$http.get( $rootScope.WebURL + "/calendar")
        //      .then(function (Calendardata) {
        //          
        //          $scope.Calendardatas = Calendardata.data.data;
        //      });

        function RefreshEventGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/calendar",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Calendardata) {
                $scope.Calendardatas = Calendardata.data.data;
            });

            //$http.get( $rootScope.WebURL + "/calendar")
            //    .then(function (Calendardata) {
            //        $scope.Calendardatas = Calendardata.data.data;
            //    });
            $scope.Update = false;
        }

        $scope.EventList = function (e, EventId) {
            $scope.CID = EventId;
            $scope.CalendarEventId = EventId;
            $scope.CUpdate = true;

            try {
                var CalendarArray = $scope.Calendardatas;
                var item = CalendarArray.filter(function (item) {
                    return item.id === EventId;
                })[0];
                $scope.id = item.id;
                $scope.DialogTitle = "Edit";
                $scope.vm.eEventType = item.EventType;
                $scope.vm.eEventTitle = item.EventTitle;
                $scope.vm.eStartDate = new Date(item.StartDate);
                $scope.vm.eStartDate = new Date(item.EndDate);
                $scope.vm.eDescription = item.Description;
            } catch (err) { }

            //var info = $scope.Calendardatas
            //
            //for (var i = 0; i < info.length; i++) {
            //    if (info[i].id == EventId) {

            //        $scope.DialogTitle = "Edit";
            //        $scope.vm.eEventType = info[i].EventType;
            //        $scope.vm.eEventTitle = info[i].EventTitle;
            //        $scope.vm.eStartDate = new Date(info[i].StartDate);
            //        $scope.vm.eStartDate = new Date(info[i].EndDate);
            //        $scope.vm.eDescription = info[i].Description;
            //    }
            //}


            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/calendar/calendarpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AdCalendarController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.event = function event() {

            var eventpush = [];

            var response = $http({
                url: $rootScope.WebURL + "/calendar",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Calendardata) {
                $scope.Calendardatas = Calendardata.data.data;
                console.log("data=" + JSON.stringify($scope.Calendardatas));

                for (var i = 0; i < $scope.Calendardatas.length; i++) {

                    eventpush.push({
                        title: $scope.Calendardatas[i].EventTitle,

                        startsAt: moment($scope.Calendardatas[i].StartDate).startOf('day').toDate(),
                        endsAt: moment($scope.Calendardatas[i].EndDate).endOf('day').toDate(),
                        id: $scope.Calendardatas[i].id
                    });

                }
                $scope.calendereventdata = eventpush;
            });

        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        vm.calendarView = 'month';
        vm.viewDate = new Date();
        var actions = [{
            label: '<i class=\'glyphicon glyphicon-pencil\'></i>',
            onClick: function (args) {
                alert.show('Edited', args.calendarEvent);
            }
        }, {
            label: '<i class=\'glyphicon glyphicon-remove\'></i>',
            onClick: function (args) {
                alert.show('Deleted', args.calendarEvent);
            }
        }];

        vm.cellIsOpen = false;

        vm.eventClicked = function (event) {
            alert.show('Clicked', event);
        };

        vm.eventEdited = function (event) {
            alert.show('Edited', event);
        };

        vm.eventDeleted = function (event) {
            alert.show('Deleted', event);
        };

        vm.eventTimesChanged = function (event) {
            alert.show('Dropped or resized', event);
        };

        vm.toggle = function ($event, field, event) {
            $event.preventDefault();
            $event.stopPropagation();
            event[field] = !event[field];
        };

        vm.timespanClicked = function (date, cell) {

            if (vm.calendarView === 'month') {
                if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            } else if (vm.calendarView === 'year') {
                if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
                    vm.cellIsOpen = false;
                } else {
                    vm.cellIsOpen = true;
                    vm.viewDate = new Date(date);
                }
            }

        };

        $scope.updateValue = function (name) {

            // Use timeout to simulate a 650ms request.

        };

        $scope.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(item);
            }
        };

        $scope.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        $scope.isIndeterminate = function () {
            return ($scope.selected.length !== 0 &&
                $scope.selected.length !== $scope.items.length);
        };

        $scope.isChecked = function () {
            return $scope.selected.length === $scope.items.length;
        };

        $scope.toggleAll = function () {
            if ($scope.selected.length === $scope.items.length) {
                $scope.selected = [];
            } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
                $scope.selected = $scope.items.slice(0);
            }
        };

    }

    angular
        .module('app.human-resource.HcmAdmin.calendar')
        .factory('alert', function ($uibModal) {

            function show(action, event) {
                return $uibModal.open({
                    templateUrl: 'modalContent.html',
                    controller: function () {
                        var vm = this;
                        vm.action = action;
                        vm.event = event;
                    },
                    controllerAs: 'vm'
                });
            }

            return {
                show: show
            };

        });

    angular.module('app.human-resource.HcmAdmin.calendar').config(function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD/MM/YYYY');
        };
    });

})();






angular.module('colorpicker.module', [])
    .factory('Helper', function () {
        'use strict';
        return {
            closestSlider: function (elem) {
                var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
                if (matchesSelector.bind(elem)('I')) {
                    return elem.parentNode;
                }
                return elem;
            },
            getOffset: function (elem, fixedPosition) {
                var
                  scrollX = 0,
                  scrollY = 0,
                  rect = elem.getBoundingClientRect();
                while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
                    if (!fixedPosition && elem.tagName === 'BODY') {
                        scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
                        scrollY += document.documentElement.scrollTop || elem.scrollTop;
                    } else {
                        scrollX += elem.scrollLeft;
                        scrollY += elem.scrollTop;
                    }
                    elem = elem.offsetParent;
                }
                return {
                    top: rect.top + window.pageYOffset,
                    left: rect.left + window.pageXOffset,
                    scrollX: scrollX,
                    scrollY: scrollY
                };
            },
            // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
            stringParsers: [
              {
                  re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16)
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16)
                      ];
                  }
              }
            ]
        };
    })
    .factory('Color', ['Helper', function (Helper) {
        'use strict';
        return {
            value: {
                h: 1,
                s: 1,
                b: 1,
                a: 1
            },
            // translate a format from Color object to a string
            'rgb': function () {
                var rgb = this.toRGB();
                return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
            },
            'rgba': function () {
                var rgb = this.toRGB();
                return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
            },
            'hex': function () {
                return this.toHex();
            },

            // HSBtoRGB from RaphaelJS
            RGBtoHSB: function (r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V === r ? (g - b) / C :
                        V === g ? (b - r) / C + 2 :
                            (r - g) / C + 4
                    );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return { h: H || 1, s: S, b: V, a: a || 1 };
            },

            //parse a string to HSB
            setColor: function (val) {
                val = (val) ? val.toLowerCase() : val;
                for (var key in Helper.stringParsers) {
                    if (Helper.stringParsers.hasOwnProperty(key)) {
                        var parser = Helper.stringParsers[key];
                        var match = parser.re.exec(val),
                            values = match && parser.parse(match);
                        if (values) {
                            this.value = this.RGBtoHSB.apply(null, values);
                            return false;
                        }
                    }
                }
            },

            setHue: function (h) {
                this.value.h = 1 - h;
            },

            setSaturation: function (s) {
                this.value.s = s;
            },

            setLightness: function (b) {
                this.value.b = 1 - b;
            },

            setAlpha: function (a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },

            // HSBtoRGB from RaphaelJS
            // https://github.com/DmitryBaranovskiy/raphael/
            toRGB: function (h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },

            toHex: function (h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
            }
        };
    }])
    .factory('Slider', ['Helper', function (Helper) {
        'use strict';
        var
            slider = {
                maxLeft: 0,
                maxTop: 0,
                callLeft: null,
                callTop: null,
                knob: {
                    top: 0,
                    left: 0
                }
            },
            pointer = {};

        return {
            getSlider: function () {
                return slider;
            },
            getLeftPosition: function (event) {
                return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
            },
            getTopPosition: function (event) {
                return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
            },
            setSlider: function (event, fixedPosition) {
                var
                  target = Helper.closestSlider(event.target),
                  targetOffset = Helper.getOffset(target, fixedPosition),
                  rect = target.getBoundingClientRect(),
                  offsetX = event.clientX - rect.left,
                  offsetY = event.clientY - rect.top;

                slider.knob = target.children[0].style;
                slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
                slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;

                pointer = {
                    left: event.pageX - (offsetX - slider.left),
                    top: event.pageY - (offsetY - slider.top)
                };
            },
            setSaturation: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: componentSize,
                    maxTop: componentSize,
                    callLeft: 'setSaturation',
                    callTop: 'setLightness'
                };
                this.setSlider(event, fixedPosition);
            },
            setHue: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setHue'
                };
                this.setSlider(event, fixedPosition);
            },
            setAlpha: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setAlpha'
                };
                this.setSlider(event, fixedPosition);
            },
            setKnob: function (top, left) {
                slider.knob.top = top + 'px';
                slider.knob.left = left + 'px';
            }
        };
    }])
    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
        'use strict';
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function ($scope, elem, attrs, ngModel) {
                var
                    thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
                    position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
                    inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
                    fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
                    target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
                    withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
                    componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
                    componentSizePx = componentSize + 'px',
                    inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
                    closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
                    template =
                        '<div class="colorpicker dropdown">' +
                            '<div class="dropdown-menu">' +
                            '<colorpicker-saturation><i></i></colorpicker-saturation>' +
                            '<colorpicker-hue><i></i></colorpicker-hue>' +
                            '<colorpicker-alpha><i></i></colorpicker-alpha>' +
                            '<colorpicker-preview></colorpicker-preview>' +
                            inputTemplate +
                            closeButton +
                            '</div>' +
                            '</div>',
                    colorpickerTemplate = angular.element(template),
                    pickerColor = Color,
                    colorpickerValue = {
                        h: 1,
                        s: 0,
                        b: 1,
                        a: 1
                    },
                    sliderAlpha,
                    sliderHue = colorpickerTemplate.find('colorpicker-hue'),
                    sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
                    colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
                    pickerColorPointers = colorpickerTemplate.find('i'),
                    componentWidthWithToolbars = parseInt(componentSize) + 29 + (thisFormat === 'rgba' ? 15 : 0),
                    componentHeightWithToolbars = parseInt(componentSize) + 55;

                $compile(colorpickerTemplate)($scope);
                colorpickerTemplate.css('min-width', componentWidthWithToolbars + 'px');
                sliderSaturation.css({
                    'width': componentSizePx,
                    'height': componentSizePx
                });
                sliderHue.css('height', componentSizePx);

                if (withInput) {
                    var pickerColorInput = colorpickerTemplate.find('input');
                    pickerColorInput.css('width', componentSizePx);
                    pickerColorInput
                        .on('mousedown', function (event) {
                            event.stopPropagation();
                        })
                      .on('keyup', function () {
                          var newColor = this.value;
                          elem.val(newColor);
                          if (ngModel && ngModel.$modelValue !== newColor) {
                              $scope.$apply(ngModel.$setViewValue(newColor));
                              update(true);
                          }
                      });
                }

                function bindMouseEvents() {
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }

                if (thisFormat === 'rgba') {
                    colorpickerTemplate.addClass('alpha');
                    sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
                    sliderAlpha.css('height', componentSizePx);
                    sliderAlpha
                        .on('click', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            mousemove(event);
                        })
                        .on('mousedown', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            bindMouseEvents();
                        })
                        .on('mouseup', function (event) {
                            emitEvent('colorpicker-selected-alpha');
                        });
                }

                sliderHue
                    .on('click', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        mousemove(event);
                    })
                    .on('mousedown', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-hue');
                    });

                sliderSaturation
                    .on('click', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        mousemove(event);
                        if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
                            hideColorpickerTemplate();
                        }
                    })
                    .on('mousedown', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-saturation');
                    });

                if (fixedPosition) {
                    colorpickerTemplate.addClass('colorpicker-fixed-position');
                }

                colorpickerTemplate.addClass('colorpicker-position-' + position);
                if (inline === 'true') {
                    colorpickerTemplate.addClass('colorpicker-inline');
                }

                target.append(colorpickerTemplate);

                if (ngModel) {
                    ngModel.$render = function () {
                        elem.val(ngModel.$viewValue);

                        update();
                    };
                }

                elem.on('blur keyup change', function () {
                    update();
                });

                elem.on('$destroy', function () {
                    colorpickerTemplate.remove();
                });

                function previewColor() {
                    try {
                        colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
                    } catch (e) {
                        colorpickerPreview.css('backgroundColor', pickerColor.toHex());
                    }
                    sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
                    if (thisFormat === 'rgba') {
                        sliderAlpha.css.backgroundColor = pickerColor.toHex();
                    }
                }

                function mousemove(event) {
                    var
                        left = Slider.getLeftPosition(event),
                        top = Slider.getTopPosition(event),
                        slider = Slider.getSlider();

                    Slider.setKnob(top, left);

                    if (slider.callLeft) {
                        pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
                    }
                    if (slider.callTop) {
                        pickerColor[slider.callTop].call(pickerColor, top / componentSize);
                    }
                    previewColor();
                    var newColor = pickerColor[thisFormat]();
                    elem.val(newColor);
                    if (ngModel) {
                        $scope.$apply(ngModel.$setViewValue(newColor));
                    }
                    if (withInput) {
                        pickerColorInput.val(newColor);
                    }
                    return false;
                }

                function mouseup() {
                    emitEvent('colorpicker-selected');
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                }

                function update(omitInnerInput) {
                    pickerColor.value = colorpickerValue;
                    pickerColor.setColor(elem.val());
                    if (withInput && !omitInnerInput) {
                        pickerColorInput.val(elem.val());
                    }
                    pickerColorPointers.eq(0).css({
                        left: pickerColor.value.s * componentSize + 'px',
                        top: componentSize - pickerColor.value.b * componentSize + 'px'
                    });
                    pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
                    pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
                    colorpickerValue = pickerColor.value;
                    previewColor();
                }

                function getColorpickerTemplatePosition() {
                    var
                        positionValue,
                        positionOffset = Helper.getOffset(elem[0]),
                        additionalSpaceBetweenElements = 2;

                    if (angular.isDefined(attrs.colorpickerParent)) {
                        positionOffset.left = 0;
                        positionOffset.top = 0;
                    }

                    if (position === 'top') {
                        positionValue = {
                            'top': positionOffset.top - componentHeightWithToolbars - additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'right') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left + elem[0].offsetWidth + additionalSpaceBetweenElements
                        };
                    } else if (position === 'bottom') {
                        positionValue = {
                            'top': positionOffset.top + elem[0].offsetHeight + additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'left') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left - componentWidthWithToolbars - additionalSpaceBetweenElements
                        };
                    }
                    return {
                        'top': positionValue.top + 'px',
                        'left': positionValue.left + 'px'
                    };
                }

                function documentMousedownHandler() {
                    hideColorpickerTemplate();
                }

                function showColorpickerTemplate() {

                    if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
                        update();
                        colorpickerTemplate
                          .addClass('colorpicker-visible')
                          .css(getColorpickerTemplatePosition());
                        emitEvent('colorpicker-shown');

                        if (inline === false) {
                            // register global mousedown event to hide the colorpicker
                            $document.on('mousedown', documentMousedownHandler);
                        }

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = true;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                if (inline === false) {
                    elem.on('click', showColorpickerTemplate);
                } else {
                    showColorpickerTemplate();
                }

                colorpickerTemplate.on('mousedown', function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                });

                function emitEvent(name) {
                    if (ngModel) {
                        $scope.$emit(name, {
                            name: attrs.ngModel,
                            value: ngModel.$modelValue
                        });
                    }
                }

                function hideColorpickerTemplate() {
                    if (colorpickerTemplate.hasClass('colorpicker-visible')) {
                        colorpickerTemplate.removeClass('colorpicker-visible');
                        emitEvent('colorpicker-closed');
                        // unregister the global mousedown event
                        $document.off('mousedown', documentMousedownHandler);

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = false;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                colorpickerTemplate.find('button').on('click', function () {
                    hideColorpickerTemplate();
                });

                if (attrs.colorpickerIsOpen) {
                    $scope.$watch(attrs.colorpickerIsOpen, function (shouldBeOpen) {

                        if (shouldBeOpen === true) {
                            showColorpickerTemplate();
                        } else if (shouldBeOpen === false) {
                            hideColorpickerTemplate();
                        }

                    });
                }
            }
        };
    }]);
/**
 * angular-bootstrap-calendar - A pure AngularJS bootstrap themed responsive calendar that can display events and has views for year, month, week and day
 * @version v0.29.3
 * @link https://github.com/mattlewis92/angular-bootstrap-calendar
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else if (typeof define === 'function' && define.amd)
        define(["angular", "moment", "interact"], factory);
    else if (typeof exports === 'object')
        exports["angularBootstrapCalendarModuleName"] = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else
        root["angularBootstrapCalendarModuleName"] = factory(root["angular"], root["moment"], root["interact"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_71__, __WEBPACK_EXTERNAL_MODULE_72__) {
    return /******/ (function (modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};
        /******/
        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {
            /******/
            /******/ 		// Check if module is in cache
            /******/ 		if (installedModules[moduleId]) {
                /******/ 			return installedModules[moduleId].exports;
                /******/
            }
            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/
            };
            /******/
            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;
            /******/
            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/
        }
        /******/
        /******/
        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;
        /******/
        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;
        /******/
        /******/ 	// identity function for calling harmony imports with the correct context
        /******/ 	__webpack_require__.i = function (value) { return value; };
        /******/
        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function (exports, name, getter) {
            /******/ 		if (!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, {
                    /******/ 				configurable: false,
                    /******/ 				enumerable: true,
                    /******/ 				get: getter
            /******/
        });
                /******/
            }
            /******/
        };
        /******/
        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function (module) {
            /******/ 		var getter = module && module.__esModule ?
            /******/ 			function getDefault() { return module['default']; } :
            /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/
        };
        /******/
        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";
        /******/
        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 60);
        /******/
    })
    /************************************************************************/
    /******/([
    /* 0 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

            /***/
        }),
    /* 1 */
    /***/ (function (module, exports, __webpack_require__) {

            var isDate = __webpack_require__(24)

            var MILLISECONDS_IN_HOUR = 3600000
            var MILLISECONDS_IN_MINUTE = 60000
            var DEFAULT_ADDITIONAL_DIGITS = 2

            var parseTokenDateTimeDelimeter = /[T ]/
            var parseTokenPlainTime = /:/

            // year tokens
            var parseTokenYY = /^(\d{2})$/
            var parseTokensYYY = [
                /^([+-]\d{2})$/, // 0 additional digits
                /^([+-]\d{3})$/, // 1 additional digit
                /^([+-]\d{4})$/ // 2 additional digits
            ]

            var parseTokenYYYY = /^(\d{4})/
            var parseTokensYYYYY = [
                /^([+-]\d{4})/, // 0 additional digits
                /^([+-]\d{5})/, // 1 additional digit
                /^([+-]\d{6})/ // 2 additional digits
            ]

            // date tokens
            var parseTokenMM = /^-(\d{2})$/
            var parseTokenDDD = /^-?(\d{3})$/
            var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
            var parseTokenWww = /^-?W(\d{2})$/
            var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

            // time tokens
            var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
            var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
            var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

            // timezone tokens
            var parseTokenTimezone = /([Z+-].*)$/
            var parseTokenTimezoneZ = /^(Z)$/
            var parseTokenTimezoneHH = /^([+-])(\d{2})$/
            var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

            /**
             * @category Common Helpers
             * @summary Convert the given argument to an instance of Date.
             *
             * @description
             * Convert the given argument to an instance of Date.
             *
             * If the argument is an instance of Date, the function returns its clone.
             *
             * If the argument is a number, it is treated as a timestamp.
             *
             * If an argument is a string, the function tries to parse it.
             * Function accepts complete ISO 8601 formats as well as partial implementations.
             * ISO 8601: https://en.wikipedia.org/wiki/ISO_8601
             *
             * If all above fails, the function passes the given argument to Date constructor.
             *
             * @param {Date|String|Number} argument - the value to convert
             * @param {Object} [options] - the object with options
             * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
             * @returns {Date} the parsed date in the local time zone
             *
             * @example
             * // Convert string '2014-02-11T11:30:30' to date:
             * var result = parse('2014-02-11T11:30:30')
             * //=> Tue Feb 11 2014 11:30:30
             *
             * @example
             * // Parse string '+02014101',
             * // if the additional number of digits in the extended year format is 1:
             * var result = parse('+02014101', {additionalDigits: 1})
             * //=> Fri Apr 11 2014 00:00:00
             */
            function parse(argument, dirtyOptions) {
                if (isDate(argument)) {
                    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
                    return new Date(argument.getTime())
                } else if (typeof argument !== 'string') {
                    return new Date(argument)
                }

                var options = dirtyOptions || {}
                var additionalDigits = options.additionalDigits
                if (additionalDigits == null) {
                    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
                } else {
                    additionalDigits = Number(additionalDigits)
                }

                var dateStrings = splitDateString(argument)

                var parseYearResult = parseYear(dateStrings.date, additionalDigits)
                var year = parseYearResult.year
                var restDateString = parseYearResult.restDateString

                var date = parseDate(restDateString, year)

                if (date) {
                    var timestamp = date.getTime()
                    var time = 0
                    var offset

                    if (dateStrings.time) {
                        time = parseTime(dateStrings.time)
                    }

                    if (dateStrings.timezone) {
                        offset = parseTimezone(dateStrings.timezone)
                    } else {
                        // get offset accurate to hour in timezones that change offset
                        offset = new Date(timestamp + time).getTimezoneOffset()
                        offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
                    }

                    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
                } else {
                    return new Date(argument)
                }
            }

            function splitDateString(dateString) {
                var dateStrings = {}
                var array = dateString.split(parseTokenDateTimeDelimeter)
                var timeString

                if (parseTokenPlainTime.test(array[0])) {
                    dateStrings.date = null
                    timeString = array[0]
                } else {
                    dateStrings.date = array[0]
                    timeString = array[1]
                }

                if (timeString) {
                    var token = parseTokenTimezone.exec(timeString)
                    if (token) {
                        dateStrings.time = timeString.replace(token[1], '')
                        dateStrings.timezone = token[1]
                    } else {
                        dateStrings.time = timeString
                    }
                }

                return dateStrings
            }

            function parseYear(dateString, additionalDigits) {
                var parseTokenYYY = parseTokensYYY[additionalDigits]
                var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

                var token

                // YYYY or Â±YYYYY
                token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
                if (token) {
                    var yearString = token[1]
                    return {
                        year: parseInt(yearString, 10),
                        restDateString: dateString.slice(yearString.length)
                    }
                }

                // YY or Â±YYY
                token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
                if (token) {
                    var centuryString = token[1]
                    return {
                        year: parseInt(centuryString, 10) * 100,
                        restDateString: dateString.slice(centuryString.length)
                    }
                }

                // Invalid ISO-formatted year
                return {
                    year: null
                }
            }

            function parseDate(dateString, year) {
                // Invalid ISO-formatted year
                if (year === null) {
                    return null
                }

                var token
                var date
                var month
                var week

                // YYYY
                if (dateString.length === 0) {
                    date = new Date(0)
                    date.setUTCFullYear(year)
                    return date
                }

                // YYYY-MM
                token = parseTokenMM.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    date.setUTCFullYear(year, month)
                    return date
                }

                // YYYY-DDD or YYYYDDD
                token = parseTokenDDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    var dayOfYear = parseInt(token[1], 10)
                    date.setUTCFullYear(year, 0, dayOfYear)
                    return date
                }

                // YYYY-MM-DD or YYYYMMDD
                token = parseTokenMMDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    var day = parseInt(token[2], 10)
                    date.setUTCFullYear(year, month, day)
                    return date
                }

                // YYYY-Www or YYYYWww
                token = parseTokenWww.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    return dayOfISOYear(year, week)
                }

                // YYYY-Www-D or YYYYWwwD
                token = parseTokenWwwD.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    var dayOfWeek = parseInt(token[2], 10) - 1
                    return dayOfISOYear(year, week, dayOfWeek)
                }

                // Invalid ISO-formatted date
                return null
            }

            function parseTime(timeString) {
                var token
                var hours
                var minutes

                // hh
                token = parseTokenHH.exec(timeString)
                if (token) {
                    hours = parseFloat(token[1].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR
                }

                // hh:mm or hhmm
                token = parseTokenHHMM.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseFloat(token[2].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE
                }

                // hh:mm:ss or hhmmss
                token = parseTokenHHMMSS.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseInt(token[2], 10)
                    var seconds = parseFloat(token[3].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE +
                        seconds * 1000
                }

                // Invalid ISO-formatted time
                return null
            }

            function parseTimezone(timezoneString) {
                var token
                var absoluteOffset

                // Z
                token = parseTokenTimezoneZ.exec(timezoneString)
                if (token) {
                    return 0
                }

                // Â±hh
                token = parseTokenTimezoneHH.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                // Â±hh:mm or Â±hhmm
                token = parseTokenTimezoneHHMM.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                return 0
            }

            function dayOfISOYear(isoYear, week, day) {
                week = week || 0
                day = day || 0
                var date = new Date(0)
                date.setUTCFullYear(isoYear, 0, 4)
                var fourthOfJanuaryDay = date.getUTCDay() || 7
                var diff = week * 7 + day + 1 - fourthOfJanuaryDay
                date.setUTCDate(date.getUTCDate() + diff)
                return date
            }

            module.exports = parse


            /***/
        }),
    /* 2 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Add the specified number of milliseconds to the given date.
             *
             * @description
             * Add the specified number of milliseconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of milliseconds to be added
             * @returns {Date} the new date with the milliseconds added
             *
             * @example
             * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
             * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
             * //=> Thu Jul 10 2014 12:45:30.750
             */
            function addMilliseconds(dirtyDate, dirtyAmount) {
                var timestamp = parse(dirtyDate).getTime()
                var amount = Number(dirtyAmount)
                return new Date(timestamp + amount)
            }

            module.exports = addMilliseconds


            /***/
        }),
    /* 3 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the start of a day for the given date.
             *
             * @description
             * Return the start of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a day
             *
             * @example
             * // The start of a day for 2 September 2014 11:55:00:
             * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 00:00:00
             */
            function startOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfDay


            /***/
        }),
    /* 4 */
    /***/ (function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__ = __webpack_require__(20);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__ = __webpack_require__(13);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__(17);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__ = __webpack_require__(3);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__ = __webpack_require__(25);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__ = __webpack_require__(23);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__ = __webpack_require__(35);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__ = __webpack_require__(11);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__ = __webpack_require__(22);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__ = __webpack_require__(19);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__ = __webpack_require__(33);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__ = __webpack_require__(21);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__ = __webpack_require__(26);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__ = __webpack_require__(27);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__ = __webpack_require__(30);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__ = __webpack_require__(31);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__ = __webpack_require__(32);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__ = __webpack_require__(18);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__ = __webpack_require__(12);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__ = __webpack_require__(14);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min__ = __webpack_require__(29);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_date_fns_min__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max__ = __webpack_require__(28);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_date_fns_max__);
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDS_IN_DAY", function () { return SECONDS_IN_DAY; });
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewEventOffset"] = getWeekViewEventOffset;
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewHeader"] = getWeekViewHeader;
        /* harmony export (immutable) */ __webpack_exports__["getWeekView"] = getWeekView;
        /* harmony export (immutable) */ __webpack_exports__["getMonthView"] = getMonthView;
        /* harmony export (immutable) */ __webpack_exports__["getDayView"] = getDayView;
        /* harmony export (immutable) */ __webpack_exports__["getDayViewHourGrid"] = getDayViewHourGrid;






















            var WEEKEND_DAY_NUMBERS = [0, 6];
            var DAYS_IN_WEEK = 7;
            var HOURS_IN_DAY = 24;
            var MINUTES_IN_HOUR = 60;
            var SECONDS_IN_DAY = 60 * 60 * 24;
            function getExcludedSeconds(_a) {
                var startDate = _a.startDate, seconds = _a.seconds, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b;
                if (excluded.length < 1) {
                    return 0;
                }
                var result = 0; // Calculated in seconds
                var endDate;
                var dayStart;
                var dayEnd;
                switch (precision) {
                    case 'minutes':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(startDate, seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(startDate);
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endDate, 0));
                        excluded.forEach(function (excludedDay) {
                            if (excludedDay === dayStart) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(startDate), startDate) + 1;
                            }
                            else if (excludedDay === dayEnd) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(endDate, __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endDate)) + 1;
                            }
                            else if (excludedDay > dayStart && excludedDay < dayEnd) {
                                result += SECONDS_IN_DAY;
                            }
                        });
                        break;
                    case 'days':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate), seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate));
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(endDate);
                        result += excluded.filter(function (excludedDay) { return excludedDay >= dayStart && excludedDay <= dayEnd; }).length * SECONDS_IN_DAY;
                        break;
                }
                return result;
            }
            function getWeekViewEventSpan(_a) {
                var event = _a.event, offset = _a.offset, startOfWeekDate = _a.startOfWeekDate, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b, weekStartsOn = _a.weekStartsOn;
                offset = Math.round(offset * SECONDS_IN_DAY);
                var span = SECONDS_IN_DAY;
                var begin = __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default()(event.start, startOfWeekDate);
                var endOfWeekDate = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(startOfWeekDate, { weekStartsOn: weekStartsOn });
                if (event.end) {
                    switch (precision) {
                        case 'days':
                            span = (__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.end), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endOfWeekDate)), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(begin)) + 1) * SECONDS_IN_DAY;
                            break;
                        case 'minutes':
                            span = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(event.end, __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endOfWeekDate, 1)), begin);
                            break;
                    }
                }
                span -= getExcludedSeconds({ startDate: begin, seconds: span, excluded: excluded, precision: precision });
                return span / SECONDS_IN_DAY;
            }
            function getWeekViewEventOffset(_a) {
                var event = _a.event, startOfWeek = _a.startOfWeek, _b = _a.excluded, excluded = _b === void 0 ? [] : _b, _c = _a.precision, precision = _c === void 0 ? 'days' : _c;
                if (event.start < startOfWeek) {
                    return 0;
                }
                var offset;
                switch (precision) {
                    case 'days':
                        offset = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.start), startOfWeek) * SECONDS_IN_DAY;
                        break;
                    case 'minutes':
                        offset = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(event.start, startOfWeek);
                        break;
                }
                offset -= getExcludedSeconds({ startDate: startOfWeek, seconds: offset, excluded: excluded, precision: precision });
                return offset / SECONDS_IN_DAY;
            }
            function isEventIsPeriod(_a) {
                var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                var eventStart = event.start;
                var eventEnd = event.end || event.start;
                if (eventStart > periodStart && eventStart < periodEnd) {
                    return true;
                }
                if (eventEnd > periodStart && eventEnd < periodEnd) {
                    return true;
                }
                if (eventStart < periodStart && eventEnd > periodEnd) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodEnd)) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodEnd)) {
                    return true;
                }
                return false;
            }
            function getEventsInPeriod(_a) {
                var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });
            }
            function getWeekDay(_a) {
                var date = _a.date;
                var today = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(new Date());
                return {
                    date: date,
                    isPast: date < today,
                    isToday: __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default()(date, today),
                    isFuture: date > today,
                    isWeekend: WEEKEND_DAY_NUMBERS.indexOf(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(date)) > -1
                };
            }
            function getWeekViewHeader(_a) {
                var viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _b = _a.excluded, excluded = _b === void 0 ? [] : _b;
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var days = [];
                var _loop_1 = function (i) {
                    var date = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(start, i);
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        days.push(getWeekDay({ date: date }));
                    }
                };
                for (var i = 0; i < DAYS_IN_WEEK; i++) {
                    _loop_1(i);
                }
                return days;
            }
            function getWeekView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.precision, precision = _d === void 0 ? 'days' : _d, _e = _a.absolutePositionedEvents, absolutePositionedEvents = _e === void 0 ? false : _e;
                if (!events) {
                    events = [];
                }
                var startOfViewWeek = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var endOfViewWeek = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var maxRange = DAYS_IN_WEEK - excluded.length;
                var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfViewWeek, periodEnd: endOfViewWeek }).map(function (event) {
                    var offset = getWeekViewEventOffset({ event: event, startOfWeek: startOfViewWeek, excluded: excluded, precision: precision });
                    var span = getWeekViewEventSpan({ event: event, offset: offset, startOfWeekDate: startOfViewWeek, excluded: excluded, precision: precision, weekStartsOn: weekStartsOn });
                    return { event: event, offset: offset, span: span };
                }).filter(function (e) { return e.offset < maxRange; }).filter(function (e) { return e.span > 0; }).map(function (entry) {
                    return ({
                        event: entry.event,
                        offset: entry.offset,
                        span: entry.span,
                        startsBeforeWeek: entry.event.start < startOfViewWeek,
                        endsAfterWeek: (entry.event.end || entry.event.start) > endOfViewWeek
                    });
                }).sort(function (itemA, itemB) {
                    var startSecondsDiff = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemA.event.start, itemB.event.start);
                    if (startSecondsDiff === 0) {
                        return __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemB.event.end || itemB.event.start, itemA.event.end || itemA.event.start);
                    }
                    return startSecondsDiff;
                });
                var eventRows = [];
                var allocatedEvents = [];
                eventsMapped.forEach(function (event, index) {
                    if (allocatedEvents.indexOf(event) === -1) {
                        allocatedEvents.push(event);
                        var rowSpan_1 = event.span + event.offset;
                        var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {
                            if (nextEvent.offset >= rowSpan_1 &&
                                rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK &&
                                allocatedEvents.indexOf(nextEvent) === -1) {
                                var nextEventOffset = nextEvent.offset - rowSpan_1;
                                if (!absolutePositionedEvents) {
                                    nextEvent.offset = nextEventOffset;
                                }
                                rowSpan_1 += nextEvent.span + nextEventOffset;
                                allocatedEvents.push(nextEvent);
                                return true;
                            }
                        });
                        eventRows.push({
                            row: [
                                event
                            ].concat(otherRowEvents)
                        });
                    }
                });
                return eventRows;
            }
            function getMonthView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.viewStart, viewStart = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default()(viewDate) : _d, _e = _a.viewEnd, viewEnd = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default()(viewDate) : _e;
                if (!events) {
                    events = [];
                }
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewStart, { weekStartsOn: weekStartsOn });
                var end = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewEnd, { weekStartsOn: weekStartsOn });
                var eventsInMonth = getEventsInPeriod({
                    events: events,
                    periodStart: start,
                    periodEnd: end
                });
                var days = [];
                var previousDate;
                var _loop_2 = function (i) {
                    // hacky fix for https://github.com/mattlewis92/angular-calendar/issues/173
                    var date;
                    if (previousDate) {
                        date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY));
                        if (previousDate.getTime() === date.getTime()) {
                            date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY + 1));
                        }
                        previousDate = date;
                    }
                    else {
                        date = previousDate = start;
                    }
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        var day = getWeekDay({ date: date });
                        var events_1 = getEventsInPeriod({
                            events: eventsInMonth,
                            periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(date),
                            periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(date)
                        });
                        day.inMonth = __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default()(date, viewDate);
                        day.events = events_1;
                        day.badgeTotal = events_1.length;
                        days.push(day);
                    }
                };
                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(end, start) + 1; i++) {
                    _loop_2(i);
                }
                var totalDaysVisibleInWeek = DAYS_IN_WEEK - excluded.length;
                var rows = Math.floor(days.length / totalDaysVisibleInWeek);
                var rowOffsets = [];
                for (var i = 0; i < rows; i++) {
                    rowOffsets.push(i * totalDaysVisibleInWeek);
                }
                return {
                    rowOffsets: rowOffsets,
                    totalDaysVisibleInWeek: totalDaysVisibleInWeek,
                    days: days
                };
            }
            function getDayView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd, eventWidth = _a.eventWidth, segmentHeight = _a.segmentHeight;
                if (!events) {
                    events = [];
                }
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var previousDayEvents = [];
                var dayViewEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return !event.allDay; }),
                    periodStart: startOfView,
                    periodEnd: endOfView
                }).sort(function (eventA, eventB) {
                    return eventA.start.valueOf() - eventB.start.valueOf();
                }).map(function (event) {
                    var eventStart = event.start;
                    var eventEnd = event.end || eventStart;
                    var startsBeforeDay = eventStart < startOfView;
                    var endsAfterDay = eventEnd > endOfView;
                    var hourHeightModifier = (hourSegments * segmentHeight) / MINUTES_IN_HOUR;
                    var top = 0;
                    if (eventStart > startOfView) {
                        top += __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(eventStart, startOfView);
                    }
                    top *= hourHeightModifier;
                    var startDate = startsBeforeDay ? startOfView : eventStart;
                    var endDate = endsAfterDay ? endOfView : eventEnd;
                    var height = __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(endDate, startDate);
                    if (!event.end) {
                        height = segmentHeight;
                    }
                    else {
                        height *= hourHeightModifier;
                    }
                    var bottom = top + height;
                    var overlappingPreviousEvents = previousDayEvents.filter(function (previousEvent) {
                        var previousEventTop = previousEvent.top;
                        var previousEventBottom = previousEvent.top + previousEvent.height;
                        if (top < previousEventBottom && previousEventBottom < bottom) {
                            return true;
                        }
                        else if (previousEventTop <= top && bottom <= previousEventBottom) {
                            return true;
                        }
                        return false;
                    });
                    var left = 0;
                    while (overlappingPreviousEvents.some(function (previousEvent) { return previousEvent.left === left; })) {
                        left += eventWidth;
                    }
                    var dayEvent = {
                        event: event,
                        height: height,
                        width: eventWidth,
                        top: top,
                        left: left,
                        startsBeforeDay: startsBeforeDay,
                        endsAfterDay: endsAfterDay
                    };
                    if (height > 0) {
                        previousDayEvents.push(dayEvent);
                    }
                    return dayEvent;
                }).filter(function (dayEvent) { return dayEvent.height > 0; });
                var width = Math.max.apply(Math, dayViewEvents.map(function (event) { return event.left + event.width; }));
                var allDayEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return event.allDay; }),
                    periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startOfView),
                    periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(endOfView)
                });
                return {
                    events: dayViewEvents,
                    width: width,
                    allDayEvents: allDayEvents
                };
            }
            function getDayViewHourGrid(_a) {
                var viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd;
                var hours = [];
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var segmentDuration = MINUTES_IN_HOUR / hourSegments;
                var startOfViewDay = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate);
                for (var i = 0; i < HOURS_IN_DAY; i++) {
                    var segments = [];
                    for (var j = 0; j < hourSegments; j++) {
                        var date = __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(startOfViewDay, i), j * segmentDuration);
                        if (date >= startOfView && date < endOfView) {
                            segments.push({
                                date: date,
                                isStart: j === 0
                            });
                        }
                    }
                    if (segments.length > 0) {
                        hours.push({ segments: segments });
                    }
                }
                return hours;
            }
            //# sourceMappingURL=calendarUtils.js.map

            /***/
        }),
    /* 5 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Get the number of milliseconds between the given dates.
             *
             * @description
             * Get the number of milliseconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of milliseconds
             *
             * @example
             * // How many milliseconds are between
             * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
             * var result = differenceInMilliseconds(
             *   new Date(2014, 6, 2, 12, 30, 21, 700),
             *   new Date(2014, 6, 2, 12, 30, 20, 600)
             * )
             * //=> 1100
             */
            function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getTime() - dateRight.getTime()
            }

            module.exports = differenceInMilliseconds


            /***/
        }),
    /* 6 */
    /***/ (function (module, exports) {

            // removed by extract-text-webpack-plugin

            /***/
        }),
    /* 7 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./mwlCalendar.js": 45,
                "./mwlCalendarDay.js": 46,
                "./mwlCalendarHourList.js": 47,
                "./mwlCalendarMonth.js": 48,
                "./mwlCalendarSlideBox.js": 49,
                "./mwlCalendarWeek.js": 50,
                "./mwlCalendarYear.js": 51,
                "./mwlCollapseFallback.js": 52,
                "./mwlDateModifier.js": 53,
                "./mwlDragSelect.js": 54,
                "./mwlDraggable.js": 55,
                "./mwlDroppable.js": 56,
                "./mwlDynamicDirectiveTemplate.js": 57,
                "./mwlElementDimensions.js": 58,
                "./mwlResizable.js": 59
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 7;

            /***/
        }),
    /* 8 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarDate.js": 61,
                "./calendarLimitTo.js": 62,
                "./calendarTruncateEventTitle.js": 63,
                "./calendarTrustAsHtml.js": 64
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 8;

            /***/
        }),
    /* 9 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarConfig.js": 65,
                "./calendarEventTitle.js": 66,
                "./calendarHelper.js": 67,
                "./calendarTitle.js": 68,
                "./interact.js": 69,
                "./moment.js": 70
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 9;

            /***/
        }),
    /* 10 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendar.html": 36,
                "./calendarDayView.html": 37,
                "./calendarHourList.html": 38,
                "./calendarMonthCell.html": 39,
                "./calendarMonthCellEvents.html": 40,
                "./calendarMonthView.html": 41,
                "./calendarSlideBox.html": 42,
                "./calendarWeekView.html": 43,
                "./calendarYearView.html": 44
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 10;

            /***/
        }),
    /* 11 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Add the specified number of days to the given date.
             *
             * @description
             * Add the specified number of days to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of days to be added
             * @returns {Date} the new date with the days added
             *
             * @example
             * // Add 10 days to 1 September 2014:
             * var result = addDays(new Date(2014, 8, 1), 10)
             * //=> Thu Sep 11 2014 00:00:00
             */
            function addDays(dirtyDate, dirtyAmount) {
                var date = parse(dirtyDate)
                var amount = Number(dirtyAmount)
                date.setDate(date.getDate() + amount)
                return date
            }

            module.exports = addDays


            /***/
        }),
    /* 12 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_HOUR = 3600000

            /**
             * @category Hour Helpers
             * @summary Add the specified number of hours to the given date.
             *
             * @description
             * Add the specified number of hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of hours to be added
             * @returns {Date} the new date with the hours added
             *
             * @example
             * // Add 2 hours to 10 July 2014 23:00:00:
             * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
             * //=> Fri Jul 11 2014 01:00:00
             */
            function addHours(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
            }

            module.exports = addHours


            /***/
        }),
    /* 13 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Add the specified number of minutes to the given date.
             *
             * @description
             * Add the specified number of minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of minutes to be added
             * @returns {Date} the new date with the minutes added
             *
             * @example
             * // Add 30 minutes to 10 July 2014 12:00:00:
             * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
             * //=> Thu Jul 10 2014 12:30:00
             */
            function addMinutes(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
            }

            module.exports = addMinutes


            /***/
        }),
    /* 14 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            /**
             * @category Second Helpers
             * @summary Add the specified number of seconds to the given date.
             *
             * @description
             * Add the specified number of seconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of seconds to be added
             * @returns {Date} the new date with the seconds added
             *
             * @example
             * // Add 30 seconds to 10 July 2014 12:45:00:
             * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
             * //=> Thu Jul 10 2014 12:45:30
             */
            function addSeconds(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * 1000)
            }

            module.exports = addSeconds


            /***/
        }),
    /* 15 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Compare the two dates and return -1, 0 or 1.
             *
             * @description
             * Compare the two dates and return 1 if the first date is after the second,
             * -1 if the first date is before the second or 0 if dates are equal.
             *
             * @param {Date|String|Number} dateLeft - the first date to compare
             * @param {Date|String|Number} dateRight - the second date to compare
             * @returns {Number} the result of the comparison
             *
             * @example
             * // Compare 11 February 1987 and 10 July 1989:
             * var result = compareAsc(
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * )
             * //=> -1
             *
             * @example
             * // Sort the array of dates:
             * var result = [
             *   new Date(1995, 6, 2),
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * ].sort(compareAsc)
             * //=> [
             * //   Wed Feb 11 1987 00:00:00,
             * //   Mon Jul 10 1989 00:00:00,
             * //   Sun Jul 02 1995 00:00:00
             * // ]
             */
            function compareAsc(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var timeLeft = dateLeft.getTime()
                var dateRight = parse(dirtyDateRight)
                var timeRight = dateRight.getTime()

                if (timeLeft < timeRight) {
                    return -1
                } else if (timeLeft > timeRight) {
                    return 1
                } else {
                    return 0
                }
            }

            module.exports = compareAsc


            /***/
        }),
    /* 16 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            var MILLISECONDS_IN_MINUTE = 60000
            var MILLISECONDS_IN_DAY = 86400000

            /**
             * @category Day Helpers
             * @summary Get the number of calendar days between the given dates.
             *
             * @description
             * Get the number of calendar days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar days
             *
             * @example
             * // How many calendar days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInCalendarDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 366
             */
            function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
                var startOfDayLeft = startOfDay(dirtyDateLeft)
                var startOfDayRight = startOfDay(dirtyDateRight)

                var timestampLeft = startOfDayLeft.getTime() -
                    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
                var timestampRight = startOfDayRight.getTime() -
                    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

                // Round the number of days to the nearest integer
                // because the number of milliseconds in a day is not constant
                // (e.g. it's different in the day of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
            }

            module.exports = differenceInCalendarDays


            /***/
        }),
    /* 17 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)
            var differenceInCalendarDays = __webpack_require__(16)
            var compareAsc = __webpack_require__(15)

            /**
             * @category Day Helpers
             * @summary Get the number of full days between the given dates.
             *
             * @description
             * Get the number of full days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of full days
             *
             * @example
             * // How many full days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 365
             */
            function differenceInDays(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)

                var sign = compareAsc(dateLeft, dateRight)
                var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
                dateLeft.setDate(dateLeft.getDate() - sign * difference)

                // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
                return sign * (difference - isLastDayNotFull)
            }

            module.exports = differenceInDays


            /***/
        }),
    /* 18 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Get the number of minutes between the given dates.
             *
             * @description
             * Get the number of minutes between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of minutes
             *
             * @example
             * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
             * var result = differenceInMinutes(
             *   new Date(2014, 6, 2, 12, 20, 0),
             *   new Date(2014, 6, 2, 12, 7, 59)
             * )
             * //=> 12
             */
            function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInMinutes


            /***/
        }),
    /* 19 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            /**
             * @category Second Helpers
             * @summary Get the number of seconds between the given dates.
             *
             * @description
             * Get the number of seconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of seconds
             *
             * @example
             * // How many seconds are between
             * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
             * var result = differenceInSeconds(
             *   new Date(2014, 6, 2, 12, 30, 20, 0),
             *   new Date(2014, 6, 2, 12, 30, 7, 999)
             * )
             * //=> 12
             */
            function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInSeconds


            /***/
        }),
    /* 20 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the end of a day for the given date.
             *
             * @description
             * Return the end of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a day
             *
             * @example
             * // The end of a day for 2 September 2014 11:55:00:
             * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 23:59:59.999
             */
            function endOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfDay


            /***/
        }),
    /* 21 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the end of a month for the given date.
             *
             * @description
             * Return the end of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a month
             *
             * @example
             * // The end of a month for 2 September 2014 11:55:00:
             * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 23:59:59.999
             */
            function endOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                var month = date.getMonth()
                date.setFullYear(date.getFullYear(), month + 1, 0)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfMonth


            /***/
        }),
    /* 22 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the end of a week for the given date.
             *
             * @description
             * Return the end of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the end of a week
             *
             * @example
             * // The end of a week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sat Sep 06 2014 23:59:59.999
             *
             * @example
             * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Sun Sep 07 2014 23:59:59.999
             */
            function endOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

                date.setDate(date.getDate() + diff)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfWeek


            /***/
        }),
    /* 23 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Weekday Helpers
             * @summary Get the day of the week of the given date.
             *
             * @description
             * Get the day of the week of the given date.
             *
             * @param {Date|String|Number} date - the given date
             * @returns {Number} the day of week
             *
             * @example
             * // Which day of the week is 29 February 2012?
             * var result = getDay(new Date(2012, 1, 29))
             * //=> 3
             */
            function getDay(dirtyDate) {
                var date = parse(dirtyDate)
                var day = date.getDay()
                return day
            }

            module.exports = getDay


            /***/
        }),
    /* 24 */
    /***/ (function (module, exports) {

            /**
             * @category Common Helpers
             * @summary Is the given argument an instance of Date?
             *
             * @description
             * Is the given argument an instance of Date?
             *
             * @param {*} argument - the argument to check
             * @returns {Boolean} the given argument is an instance of Date
             *
             * @example
             * // Is 'mayonnaise' a Date?
             * var result = isDate('mayonnaise')
             * //=> false
             */
            function isDate(argument) {
                return argument instanceof Date
            }

            module.exports = isDate


            /***/
        }),
    /* 25 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            /**
             * @category Day Helpers
             * @summary Are the given dates in the same day?
             *
             * @description
             * Are the given dates in the same day?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same day
             *
             * @example
             * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
             * var result = isSameDay(
             *   new Date(2014, 8, 4, 6, 0),
             *   new Date(2014, 8, 4, 18, 0)
             * )
             * //=> true
             */
            function isSameDay(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
                var dateRightStartOfDay = startOfDay(dirtyDateRight)

                return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
            }

            module.exports = isSameDay


            /***/
        }),
    /* 26 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Are the given dates in the same month?
             *
             * @description
             * Are the given dates in the same month?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same month
             *
             * @example
             * // Are 2 September 2014 and 25 September 2014 in the same month?
             * var result = isSameMonth(
             *   new Date(2014, 8, 2),
             *   new Date(2014, 8, 25)
             * )
             * //=> true
             */
            function isSameMonth(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getFullYear() === dateRight.getFullYear() &&
                    dateLeft.getMonth() === dateRight.getMonth()
            }

            module.exports = isSameMonth


            /***/
        }),
    /* 27 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfSecond = __webpack_require__(34)

            /**
             * @category Second Helpers
             * @summary Are the given dates in the same second?
             *
             * @description
             * Are the given dates in the same second?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same second
             *
             * @example
             * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
             * // in the same second?
             * var result = isSameSecond(
             *   new Date(2014, 8, 4, 6, 30, 15),
             *   new Date(2014, 8, 4, 6, 30, 15, 500)
             * )
             * //=> true
             */
            function isSameSecond(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
                var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

                return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
            }

            module.exports = isSameSecond


            /***/
        }),
    /* 28 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the latest of the given dates.
             *
             * @description
             * Return the latest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the latest of the dates
             *
             * @example
             * // Which of these dates is the latest?
             * var result = max(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Sun Jul 02 1995 00:00:00
             */
            function max() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var latestTimestamp = Math.max.apply(null, dates)
                return new Date(latestTimestamp)
            }

            module.exports = max


            /***/
        }),
    /* 29 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the earliest of the given dates.
             *
             * @description
             * Return the earliest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the earliest of the dates
             *
             * @example
             * // Which of these dates is the earliest?
             * var result = min(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Wed Feb 11 1987 00:00:00
             */
            function min() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var earliestTimestamp = Math.min.apply(null, dates)
                return new Date(earliestTimestamp)
            }

            module.exports = min


            /***/
        }),
    /* 30 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Hour Helpers
             * @summary Set the hours to the given date.
             *
             * @description
             * Set the hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} hours - the hours of the new date
             * @returns {Date} the new date with the hours setted
             *
             * @example
             * // Set 4 hours to 1 September 2014 11:30:00:
             * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
             * //=> Mon Sep 01 2014 04:30:00
             */
            function setHours(dirtyDate, dirtyHours) {
                var date = parse(dirtyDate)
                var hours = Number(dirtyHours)
                date.setHours(hours)
                return date
            }

            module.exports = setHours


            /***/
        }),
    /* 31 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Set the minutes to the given date.
             *
             * @description
             * Set the minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} minutes - the minutes of the new date
             * @returns {Date} the new date with the minutes setted
             *
             * @example
             * // Set 45 minutes to 1 September 2014 11:30:40:
             * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
             * //=> Mon Sep 01 2014 11:45:40
             */
            function setMinutes(dirtyDate, dirtyMinutes) {
                var date = parse(dirtyDate)
                var minutes = Number(dirtyMinutes)
                date.setMinutes(minutes)
                return date
            }

            module.exports = setMinutes


            /***/
        }),
    /* 32 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Return the start of a minute for the given date.
             *
             * @description
             * Return the start of a minute for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a minute
             *
             * @example
             * // The start of a minute for 1 December 2014 22:15:45.400:
             * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:00
             */
            function startOfMinute(dirtyDate) {
                var date = parse(dirtyDate)
                date.setSeconds(0, 0)
                return date
            }

            module.exports = startOfMinute


            /***/
        }),
    /* 33 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the start of a month for the given date.
             *
             * @description
             * Return the start of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a month
             *
             * @example
             * // The start of a month for 2 September 2014 11:55:00:
             * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                date.setDate(1)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfMonth


            /***/
        }),
    /* 34 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Second Helpers
             * @summary Return the start of a second for the given date.
             *
             * @description
             * Return the start of a second for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a second
             *
             * @example
             * // The start of a second for 1 December 2014 22:15:45.400:
             * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:45.000
             */
            function startOfSecond(dirtyDate) {
                var date = parse(dirtyDate)
                date.setMilliseconds(0)
                return date
            }

            module.exports = startOfSecond


            /***/
        }),
    /* 35 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the start of a week for the given date.
             *
             * @description
             * Return the start of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the start of a week
             *
             * @example
             * // The start of a week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Aug 31 2014 00:00:00
             *
             * @example
             * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

                date.setDate(date.getDate() - diff)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfWeek


            /***/
        }),
    /* 36 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  class=\"cal-context\"\n  ng-switch=\"vm.view\"\n  ng-if=\"vm.templatesLoaded\">\n\n  <div class=\"alert alert-danger\" ng-switch-default>The value passed to the view attribute of the calendar is not set</div>\n\n  <div class=\"alert alert-danger\" ng-hide=\"vm.viewDate\">The value passed to view-date attribute of the calendar is not set</div>\n\n  <mwl-calendar-year\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    ng-switch-when=\"year\">\n  </mwl-calendar-year>\n\n  <mwl-calendar-month\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"month\">\n  </mwl-calendar-month>\n\n  <mwl-calendar-week\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"week\">\n  </mwl-calendar-week>\n\n  <mwl-calendar-day\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    day-view-event-width=\"vm.dayViewEventWidth\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    day-view-time-position=\"vm.dayViewTimePosition || 'default'\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-class=\"{\n      'time-on-side' : vm.dayViewTimePosition === 'side',\n      'time-hidden' : vm.dayViewTimePosition === 'hidden'\n    }\"\n    ng-switch-when=\"day\">\n  </mwl-calendar-day>\n</div>\n";

            /***/
        }),
    /* 37 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box cal-all-day-events-box\" ng-if=\"vm.allDayEvents.length > 0\">\n  <div class=\"cal-day-panel clearfix\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            class=\"cal-cell-6 day-highlight\"\n            ng-style=\"{backgroundColor: event.color.secondary}\"\n            data-event-class\n            ng-repeat=\"event in vm.allDayEvents track by event.calendarEventId\">\n            <strong>\n              <span ng-bind=\"event.startsAt | calendarDate:'datetime':true\"></span>\n              <span ng-if=\"event.endsAt\">\n                - <span ng-bind=\"event.endsAt | calendarDate:'datetime':true\"></span>\n              </span>\n            </strong>\n            <a\n              href=\"javascript:;\"\n              class=\"event-item\"\n              ng-bind-html=\"vm.calendarEventTitle.dayView(event) | calendarTrustAsHtml\">\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"cal-day-box\">\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.dayViewHeight + 'px', minWidth: vm.viewWidth + 'px'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      on-event-times-changed=\"vm.onEventTimesChanged\"\n      view-date=\"vm.viewDate\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      cell-modifier=\"vm.cellModifier\"\n      view=\"day\">\n    </mwl-calendar-hour-list>\n\n    <div\n      class=\"pull-left day-event day-highlight\"\n      ng-repeat=\"dayEvent in vm.nonAllDayEvents track by dayEvent.event.calendarEventId\"\n      ng-class=\"dayEvent.event.cssClass\"\n      ng-style=\"{\n        top: dayEvent.top - 1 + 'px',\n        left: dayEvent.left +  vm.dayViewTimePositionOffset + 'px',\n        height: dayEvent.height + 'px',\n        width: dayEvent.width + 'px',\n        backgroundColor: dayEvent.event.color.secondary,\n        borderColor: dayEvent.event.color.primary\n      }\"\n      mwl-draggable=\"dayEvent.event.draggable === true\"\n      axis=\"'xy'\"\n      snap-grid=\"{y: vm.dayViewEventChunkSize || 30, x: 50}\"\n      on-drag=\"vm.eventDragged(dayEvent.event, y / 30)\"\n      on-drag-end=\"vm.eventDragComplete(dayEvent.event, y / 30)\"\n      auto-scroll=\"vm.draggableAutoScroll\"\n      mwl-resizable=\"dayEvent.event.resizable === true && dayEvent.event.endsAt\"\n      resize-edges=\"{top: true, bottom: true}\"\n      on-resize=\"vm.eventResized(dayEvent.event, edge, y / 30)\"\n      on-resize-end=\"vm.eventResizeComplete(dayEvent.event, edge, y / 30)\"\n      uib-tooltip-html=\"vm.calendarEventTitle.dayViewTooltip(dayEvent.event) | calendarTrustAsHtml\"\n      tooltip-append-to-body=\"true\">\n\n      <span class=\"cal-hours\">\n        <span ng-show=\"dayEvent.top == 0\"><span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'day':true\"></span>, </span>\n        <span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'time':true\"></span>\n      </span>\n      <a\n        href=\"javascript:;\"\n        class=\"event-item\"\n        ng-click=\"vm.onEventClick({calendarEvent: dayEvent.event})\">\n        <span ng-bind-html=\"vm.calendarEventTitle.dayView(dayEvent.event) | calendarTrustAsHtml\"></span>\n      </a>\n\n      <a\n        href=\"javascript:;\"\n        class=\"event-item-action\"\n        ng-repeat=\"action in dayEvent.event.actions track by $index\"\n        ng-class=\"action.cssClass\"\n        ng-bind-html=\"action.label | calendarTrustAsHtml\"\n        ng-click=\"action.onClick({calendarEvent: dayEvent.event})\">\n      </a>\n\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 38 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-day-panel-hour\">\n\n  <div class=\"cal-day-hour\" ng-repeat=\"hour in vm.hourGrid track by $index\">\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= segment.date &&\n                segment.date < vm.dateRangeSelect.endDate }, segment.cssClass]\"\n      ng-click=\"vm.onTimespanClick({calendarDate: segment.date})\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, segment.date)\"\n      mwl-drag-select=\"!!vm.onDateRangeSelect\"\n      on-drag-select-start=\"vm.onDragSelectStart(segment.date)\"\n      on-drag-select-move=\"vm.onDragSelectMove(segment.nextSegmentDate)\"\n      on-drag-select-end=\"vm.onDragSelectEnd(segment.nextSegmentDate)\"\n      ng-if=\"!vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n      </div>\n    </div>\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-if=\"vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n        &nbsp;\n      </div>\n      <div\n        class=\"cal-day-hour-part-spacer\"\n        ng-repeat=\"day in segment.days track by $index\"\n        ng-style=\"{width: (vm.dayWidth - ($last ? vm.scrollBarWidth : 0)) + 'px'}\"\n        ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= day.date &&\n                day.date < vm.dateRangeSelect.endDate }, day.cssClass]\"\n        ng-click=\"vm.onTimespanClick({calendarDate: day.date})\"\n        mwl-droppable\n        on-drop=\"vm.eventDropped(dropData.event, day.date)\"\n        mwl-drag-select=\"!!vm.onDateRangeSelect\"\n        on-drag-select-start=\"vm.onDragSelectStart(day.date)\"\n        on-drag-select-move=\"vm.onDragSelectMove(day.nextSegmentDate)\"\n        on-drag-select-end=\"vm.onDragSelectEnd(day.nextSegmentDate)\">\n      </div>\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 39 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  mwl-droppable\n  on-drop=\"vm.handleEventDrop(dropData.event, day.date, dropData.draggedFromDate)\"\n  mwl-drag-select=\"!!vm.onDateRangeSelect\"\n  on-drag-select-start=\"vm.onDragSelectStart(day)\"\n  on-drag-select-move=\"vm.onDragSelectMove(day)\"\n  on-drag-select-end=\"vm.onDragSelectEnd(day)\"\n  class=\"cal-month-day {{ day.cssClass }}\"\n  ng-class=\"{\n    'cal-day-outmonth': !day.inMonth,\n    'cal-day-inmonth': day.inMonth,\n    'cal-day-weekend': day.isWeekend,\n    'cal-day-past': day.isPast,\n    'cal-day-today': day.isToday,\n    'cal-day-future': day.isFuture,\n    'cal-day-selected': vm.dateRangeSelect && vm.dateRangeSelect.startDate <= day.date && day.date <= vm.dateRangeSelect.endDate,\n    'cal-day-open': dayIndex === vm.openDayIndex\n  }\">\n\n  <small\n    class=\"cal-events-num badge badge-important pull-left\"\n    ng-show=\"day.badgeTotal > 0 && (vm.calendarConfig.displayAllMonthEvents || day.inMonth)\"\n    ng-bind=\"day.badgeTotal\">\n  </small>\n\n  <span\n    class=\"pull-right\"\n    data-cal-date\n    ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n    ng-bind=\"day.label\">\n  </span>\n\n  <div class=\"cal-day-tick\" ng-show=\"dayIndex === vm.openDayIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\">\n    <i class=\"glyphicon glyphicon-chevron-up\"></i>\n    <i class=\"fa fa-chevron-up\"></i>\n  </div>\n\n  <ng-include src=\"vm.customTemplateUrls.calendarMonthCellEvents || vm.calendarConfig.templates.calendarMonthCellEvents\"></ng-include>\n\n  <div id=\"cal-week-box\" ng-if=\"$first && rowHovered\">\n    <span ng-bind=\"vm.getWeekNumberLabel(day)\"></span>\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 40 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"events-list\" ng-show=\"day.events.length > 0\">\n  <a\n    ng-repeat=\"event in day.events | orderBy:'startsAt' track by event.calendarEventId\"\n    href=\"javascript:;\"\n    ng-click=\"$event.stopPropagation(); vm.onEventClick({calendarEvent: event})\"\n    class=\"pull-left event\"\n    ng-class=\"event.cssClass\"\n    ng-style=\"{backgroundColor: event.color.primary}\"\n    ng-mousedown=\"$event.stopPropagation()\"\n    ng-mouseenter=\"vm.highlightEvent(event, true)\"\n    ng-mouseleave=\"vm.highlightEvent(event, false)\"\n    tooltip-append-to-body=\"true\"\n    uib-tooltip-html=\"vm.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml\"\n    mwl-draggable=\"event.draggable === true\"\n    drop-data=\"{event: event, draggedFromDate: day.date.toDate()}\"\n    auto-scroll=\"vm.draggableAutoScroll\">\n  </a>\n</div>\n";

            /***/
        }),
    /* 41 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-row-fluid cal-row-head\">\n\n  <div class=\"cal-cell1\" ng-repeat=\"day in vm.weekDays track by $index\" ng-bind=\"day\"></div>\n\n</div>\n<div class=\"cal-month-box\">\n\n  <div\n    ng-repeat=\"rowOffset in vm.monthOffsets track by rowOffset\"\n    ng-mouseenter=\"rowHovered = true\"\n    ng-mouseleave=\"rowHovered = false\">\n    <div class=\"cal-row-fluid cal-before-eventlist\">\n      <div\n        ng-repeat=\"day in vm.view | calendarLimitTo:7:rowOffset track by $index\"\n        ng-init=\"dayIndex = vm.view.indexOf(day)\"\n        class=\"cal-cell1 cal-cell {{ day.highlightClass }}\"\n        ng-style=\"{backgroundColor: day.backgroundColor}\"\n        ng-click=\"vm.dayClicked(day, false, $event)\"\n        ng-class=\"{pointer: day.events.length > 0}\">\n        <ng-include src=\"vm.customTemplateUrls.calendarMonthCell || vm.calendarConfig.templates.calendarMonthCell\"></ng-include>\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openDayIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openDayIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      draggable-auto-scroll=\"vm.draggableAutoScroll\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 42 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-slide-box\" uib-collapse=\"vm.isCollapsed\" mwl-collapse-fallback=\"vm.isCollapsed\">\n  <div class=\"cal-slide-content cal-event-list\">\n    <ul class=\"unstyled list-unstyled\">\n\n      <li\n        ng-repeat=\"event in vm.events | orderBy:'startsAt' track by event.calendarEventId\"\n        ng-class=\"event.cssClass\"\n        ng-mousedown=\"$event.stopPropagation()\"\n        mwl-draggable=\"event.draggable === true\"\n        drop-data=\"{event: event}\"\n        auto-scroll=\"vm.draggableAutoScroll\">\n        <span class=\"pull-left event\" ng-style=\"{backgroundColor: event.color.primary}\"></span>\n        &nbsp;\n        <a\n          href=\"javascript:;\"\n          class=\"event-item\"\n          ng-click=\"vm.onEventClick({calendarEvent: event})\">\n          <span ng-bind-html=\"isMonthView ? vm.calendarEventTitle.monthView(day.date) : vm.calendarEventTitle.yearView(day.date) | calendarTrustAsHtml\"></span>\n        </a>\n\n        <a\n          href=\"javascript:;\"\n          class=\"event-item-action\"\n          ng-class=\"action.cssClass\"\n          ng-repeat=\"action in event.actions track by $index\"\n          ng-bind-html=\"action.label | calendarTrustAsHtml\"\n          ng-click=\"action.onClick({calendarEvent: event})\">\n        </a>\n\n      </li>\n\n    </ul>\n  </div>\n</div>\n";

            /***/
        }),
    /* 43 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box\" ng-class=\"{'cal-day-box': vm.showTimes}\">\n  <div class=\"cal-row-fluid cal-row-head\">\n\n    <div\n      class=\"cal-cell1\"\n      ng-repeat=\"day in vm.view.days track by $index\"\n      ng-class=\"{\n        'cal-day-weekend': day.isWeekend,\n        'cal-day-past': day.isPast,\n        'cal-day-today': day.isToday,\n        'cal-day-future': day.isFuture}\"\n      mwl-element-dimensions=\"vm.dayColumnDimensions\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, day.date)\">\n\n      <span ng-bind=\"day.weekDayLabel\"></span>\n      <br>\n      <small>\n        <span\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n          class=\"pointer\"\n          ng-bind=\"day.dayLabel\">\n        </span>\n      </small>\n\n    </div>\n\n  </div>\n\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.showTimes ? (vm.dayViewHeight + 'px') : 'auto'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      day-width=\"vm.dayColumnDimensions.width\"\n      view-date=\"vm.viewDate\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      cell-modifier=\"vm.cellModifier\"\n      template-scope=\"vm.templateScope\"\n      view=\"week\"\n      ng-if=\"vm.showTimes\">\n    </mwl-calendar-hour-list>\n\n    <div class=\"row\" ng-repeat=\"row in vm.view.eventRows track by $index\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\"\n            ng-class=\"'cal-cell' + (vm.showTimes ? 1 : eventRow.span) + (vm.showTimes ? '' : ' cal-offset' + eventRow.offset)\"\n            ng-style=\"{\n              top: vm.showTimes ? ((eventRow.top) + 'px') : 'auto',\n              position: vm.showTimes ? 'absolute' : 'inherit',\n              width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\n              left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 15 + 'px' : ''\n            }\">\n            <div\n              class=\"day-highlight\"\n              ng-class=\"[eventRow.event.cssClass, !vm.showTimes && eventRow.startsBeforeWeek ? '' : 'border-left-rounded', !vm.showTimes && eventRow.endsAfterWeek ? '' : 'border-right-rounded']\"\n              ng-style=\"{backgroundColor: eventRow.event.color.secondary}\"\n              data-event-class\n              mwl-draggable=\"eventRow.event.draggable === true\"\n              axis=\"vm.showTimes ? 'xy' : 'x'\"\n              snap-grid=\"vm.showTimes ? {x: vm.dayColumnDimensions.width, y: vm.dayViewEventChunkSize || 30} : {x: vm.dayColumnDimensions.width}\"\n              auto-scroll=\"vm.draggableAutoScroll\"\n              on-drag=\"vm.tempTimeChanged(eventRow.event, y / 30)\"\n              on-drag-end=\"vm.weekDragged(eventRow.event, x / vm.dayColumnDimensions.width, y / 30)\"\n              mwl-resizable=\"eventRow.event.resizable === true && eventRow.event.endsAt && !vm.showTimes\"\n              resize-edges=\"{left: true, right: true}\"\n              on-resize-end=\"vm.weekResized(eventRow.event, edge, x / vm.dayColumnDimensions.width)\">\n              <strong ng-bind=\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:'time':true\" ng-show=\"vm.showTimes\"></strong>\n              <a\n                href=\"javascript:;\"\n                ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\"\n                class=\"event-item\"\n                ng-bind-html=\"vm.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\"\n                uib-tooltip-html=\"vm.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml\"\n                tooltip-placement=\"left\"\n                tooltip-append-to-body=\"true\">\n              </a>\n              <a\n                href=\"javascript:;\"\n                class=\"event-item-action\"\n                ng-class=\"action.cssClass\"\n                ng-repeat=\"action in eventRow.event.actions track by $index\"\n                ng-bind-html=\"action.label | calendarTrustAsHtml\"\n                ng-click=\"action.onClick({calendarEvent: eventRow.event})\">\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n";

            /***/
        }),
    /* 44 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-year-box\">\n  <div ng-repeat=\"rowOffset in [0, 4, 8] track by rowOffset\">\n    <div class=\"row cal-before-eventlist\">\n      <div\n        class=\"span3 col-md-3 col-xs-6 cal-cell {{ day.cssClass }}\"\n        ng-repeat=\"month in vm.view | calendarLimitTo:4:rowOffset track by $index\"\n        ng-init=\"monthIndex = vm.view.indexOf(month)\"\n        ng-click=\"vm.monthClicked(month, false, $event)\"\n        ng-class=\"{pointer: month.events.length > 0, 'cal-day-today': month.isToday}\"\n        mwl-droppable\n        on-drop=\"vm.handleEventDrop(dropData.event, month.date)\">\n\n        <span\n          class=\"pull-right\"\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(month.date)\"\n          ng-bind=\"month.label\">\n        </span>\n\n        <small\n          class=\"cal-events-num badge badge-important pull-left\"\n          ng-show=\"month.badgeTotal > 0\"\n          ng-bind=\"month.badgeTotal\">\n        </small>\n\n        <div\n          class=\"cal-day-tick\"\n          ng-show=\"monthIndex === vm.openMonthIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\">\n          <i class=\"glyphicon glyphicon-chevron-up\"></i>\n          <i class=\"fa fa-chevron-up\"></i>\n        </div>\n\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openMonthIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openMonthIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 45 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var LOG_PREFIX = 'Bootstrap calendar:';

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarCtrl', ["$scope", "$log", "$timeout", "$attrs", "$locale", "moment", "calendarTitle", "calendarHelper", function ($scope, $log, $timeout, $attrs, $locale, moment, calendarTitle, calendarHelper) {

                    var vm = this;

                    vm.changeView = function (view, newDay) {
                        vm.view = view;
                        vm.viewDate = newDay;
                    };

                    vm.dateClicked = function (date) {

                        var rawDate = moment(date).toDate();

                        var nextView = {
                            year: 'month',
                            month: 'day',
                            week: 'day'
                        };

                        if (vm.onViewChangeClick({ calendarDate: rawDate, calendarNextView: nextView[vm.view] }) !== false) {
                            vm.changeView(nextView[vm.view], rawDate);
                        }

                    };

                    vm.$onInit = function () {

                        if (vm.slideBoxDisabled) {
                            $log.warn(LOG_PREFIX, 'The `slide-box-disabled` option is deprecated and will be removed in the next release. ' +
                                'Instead set `cell-auto-open-disabled` to true');
                        }

                        vm.events = vm.events || [];

                        var previousDate = moment(vm.viewDate);
                        var previousView = vm.view;

                        function checkEventIsValid(event) {
                            if (!event.startsAt) {
                                $log.warn(LOG_PREFIX, 'Event is missing the startsAt field', event);
                            } else if (!angular.isDate(event.startsAt)) {
                                $log.warn(LOG_PREFIX, 'Event startsAt should be a javascript date object. Do `new Date(event.startsAt)` to fix it.', event);
                            }

                            if (event.endsAt) {
                                if (!angular.isDate(event.endsAt)) {
                                    $log.warn(LOG_PREFIX, 'Event endsAt should be a javascript date object. Do `new Date(event.endsAt)` to fix it.', event);
                                }
                                if (moment(event.startsAt).isAfter(moment(event.endsAt))) {
                                    $log.warn(LOG_PREFIX, 'Event cannot start after it finishes', event);
                                }
                            }
                        }

                        function refreshCalendar() {

                            if (calendarTitle[vm.view] && angular.isDefined($attrs.viewTitle)) {
                                vm.viewTitle = calendarTitle[vm.view](vm.viewDate);
                            }

                            vm.events.forEach(function (event, index) {
                                checkEventIsValid(event);
                                event.calendarEventId = index;
                            });

                            //if on-timespan-click="calendarDay = calendarDate" is set then don't update the view as nothing needs to change
                            var currentDate = moment(vm.viewDate);
                            var shouldUpdate = true;
                            if (
                                previousDate.clone().startOf(vm.view).isSame(currentDate.clone().startOf(vm.view)) &&
                                !previousDate.isSame(currentDate) &&
                                vm.view === previousView
                            ) {
                                shouldUpdate = false;
                            }
                            previousDate = currentDate;
                            previousView = vm.view;

                            if (shouldUpdate) {
                                // a $timeout is required as $broadcast is synchronous so if a new events array is set the calendar won't update
                                $timeout(function () {
                                    $scope.$broadcast('calendar.refreshView');
                                });
                            }
                        }

                        calendarHelper.loadTemplates().then(function () {
                            vm.templatesLoaded = true;

                            var eventsWatched = false;

                            //Refresh the calendar when any of these variables change.
                            $scope.$watchGroup([
                                'vm.viewDate',
                                'vm.view',
                                'vm.cellIsOpen',
                                function () {
                                    return moment.locale() + $locale.id; //Auto update the calendar when the locale changes
                                }
                            ], function () {
                                if (!eventsWatched) {
                                    eventsWatched = true;
                                    //need to deep watch events hence why it isn't included in the watch group
                                    $scope.$watch('vm.events', refreshCalendar, true); //this will call refreshCalendar when the watcher starts (i.e. now)
                                } else {
                                    refreshCalendar();
                                }
                            });

                        }).catch(function (err) {
                            $log.error('Could not load all calendar templates', err);
                        });

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendar', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendar" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        scope: {
                            events: '=',
                            view: '=',
                            viewTitle: '=?',
                            viewDate: '=',
                            cellIsOpen: '=?',
                            cellAutoOpenDisabled: '=?',
                            slideBoxDisabled: '=?',
                            customTemplateUrls: '=?',
                            draggableAutoScroll: '=?',
                            onEventClick: '&',
                            onEventTimesChanged: '&',
                            onTimespanClick: '&',
                            onDateRangeSelect: '&?',
                            onViewChangeClick: '&',
                            cellModifier: '&',
                            dayViewStart: '@',
                            dayViewEnd: '@',
                            dayViewSplit: '@',
                            dayViewEventChunkSize: '@',
                            dayViewEventWidth: '@',
                            templateScope: '=?',
                            dayViewTimePosition: '@'
                        },
                        controller: 'MwlCalendarCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 46 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarDayCtrl', ["$scope", "moment", "calendarHelper", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarEventTitle) {

                    var vm = this;

                    vm.calendarEventTitle = calendarEventTitle;

                    function refreshView() {

                        vm.timeHidden = vm.dayViewTimePosition === 'hidden';
                        vm.dayViewTimePositionOffset = vm.dayViewTimePosition !== 'default' ? 0 : 60;

                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );

                        var view = calendarHelper.getDayView(
                            vm.events,
                            vm.viewDate,
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit,
                            vm.dayViewEventWidth
                        );

                        vm.allDayEvents = view.allDayEvents;
                        vm.nonAllDayEvents = view.events;
                        vm.viewWidth = view.width + 62;

                    }

                    $scope.$on('calendar.refreshView', refreshView);

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit'
                    ], refreshView);

                    vm.eventDragComplete = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var newStart = moment(event.startsAt).add(minutesDiff, 'minutes');
                        var newEnd = moment(event.endsAt).add(minutesDiff, 'minutes');
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDragged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                    vm.eventResizeComplete = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(minutesDiff, 'minutes');
                        } else {
                            end.add(minutesDiff, 'minutes');
                        }
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });
                    };

                    vm.eventResized = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        if (edge === 'start') {
                            event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                        }
                    };

                }])
                .directive('mwlCalendarDay', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarDayView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            dayViewEventWidth: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            dayViewTimePosition: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarDayCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 47 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarHourListCtrl', ["$scope", "$document", "moment", "calendarHelper", function ($scope, $document, moment, calendarHelper) {
                    var vm = this;

                    // source: https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
                    function getScrollbarWidth() {
                        var outer = $document[0].createElement('div');
                        outer.style.visibility = 'hidden';
                        outer.style.width = '100px';
                        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

                        $document[0].body.appendChild(outer);

                        var widthNoScroll = outer.offsetWidth;
                        // force scrollbars
                        outer.style.overflow = 'scroll';

                        // add innerdiv
                        var inner = $document[0].createElement('div');
                        inner.style.width = '100%';
                        outer.appendChild(inner);

                        var widthWithScroll = inner.offsetWidth;

                        // remove divs
                        outer.parentNode.removeChild(outer);

                        return widthNoScroll - widthWithScroll;
                    }

                    vm.scrollBarWidth = getScrollbarWidth();

                    function updateDays() {

                        vm.dayViewSplit = parseInt(vm.dayViewSplit);
                        var dayStart = (vm.dayViewStart || '00:00').split(':');
                        var dayEnd = (vm.dayViewEnd || '23:59').split(':');
                        vm.hourGrid = calendarUtils.getDayViewHourGrid({
                            viewDate: vm.view === 'week' ? moment(vm.viewDate).startOf('week').toDate() : moment(vm.viewDate).toDate(),
                            hourSegments: 60 / vm.dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            }
                        });

                        vm.hourGrid.forEach(function (hour) {
                            hour.segments.forEach(function (segment) {

                                segment.date = moment(segment.date);
                                segment.nextSegmentDate = segment.date.clone().add(vm.dayViewSplit, 'minutes');

                                if (vm.view === 'week') {

                                    segment.days = [];

                                    for (var i = 0; i < 7; i++) {
                                        var day = {
                                            date: moment(segment.date).add(i, 'days')
                                        };
                                        day.nextSegmentDate = day.date.clone().add(vm.dayViewSplit, 'minutes');
                                        vm.cellModifier({ calendarCell: day });
                                        segment.days.push(day);
                                    }

                                } else {
                                    vm.cellModifier({ calendarCell: segment });
                                }

                            });
                        });

                    }

                    var originalLocale = moment.locale();

                    $scope.$on('calendar.refreshView', function () {

                        if (originalLocale !== moment.locale()) {
                            originalLocale = moment.locale();
                            updateDays();
                        }

                    });

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit',
                        'vm.viewDate'
                    ], function () {
                        updateDays();
                    });

                    vm.eventDropped = function (event, date) {
                        var newStart = moment(date);
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: date,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.onDragSelectStart = function (date, dayIndex) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                active: true,
                                startDate: date,
                                endDate: date,
                                dayIndex: dayIndex
                            };
                        }
                    };

                    vm.onDragSelectMove = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                        }
                    };

                    vm.onDragSelectEnd = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                }])
                .directive('mwlCalendarHourList', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarHourList" overrides="vm.customTemplateUrls"></div>',
                        controller: 'MwlCalendarHourListCtrl as vm',
                        scope: {
                            viewDate: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayWidth: '=?',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            onEventTimesChanged: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            view: '@'
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 48 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarMonthCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;
                    vm.openRowIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openDayIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (day, dayIndex) {
                                if (moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.openDayIndex = dayIndex;
                                    vm.openRowIndex = Math.floor(dayIndex / 7);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {

                        vm.weekDays = calendarHelper.getWeekDayNames();

                        var monthView = calendarHelper.getMonthView(vm.events, vm.viewDate, vm.cellModifier);
                        vm.view = monthView.days;
                        vm.monthOffsets = monthView.rowOffsets;

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openRowIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openDayIndex = null;
                            vm.view.forEach(function (day) {
                                if (day.inMonth && moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.dayClicked(day, true);
                                }
                            });
                        }

                    });

                    vm.dayClicked = function (day, dayClickedFirstRun, $event) {

                        if (!dayClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: day.date.toDate(),
                                calendarCell: day,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var dayIndex = vm.view.indexOf(day);
                            if (dayIndex === vm.openDayIndex) { //the day has been clicked and is already open
                                vm.openDayIndex = null; //close the open day
                                vm.cellIsOpen = false;
                            } else {
                                vm.openDayIndex = dayIndex;
                                vm.openRowIndex = Math.floor(dayIndex / 7);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.highlightEvent = function (event, shouldAddClass) {

                        vm.view.forEach(function (day) {
                            delete day.highlightClass;
                            delete day.backgroundColor;
                            if (shouldAddClass) {
                                var dayContainsEvent = day.events.indexOf(event) > -1;
                                if (dayContainsEvent) {
                                    day.backgroundColor = event.color ? event.color.secondary : '';
                                }
                            }
                        });

                    };

                    vm.handleEventDrop = function (event, newDayDate, draggedFromDate) {

                        var newStart = moment(event.startsAt)
                            .year(moment(newDayDate).year())
                            .month(moment(newDayDate).month())
                            .date(moment(newDayDate).date());

                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newDayDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null,
                            calendarDraggedFromDate: draggedFromDate
                        });
                    };

                    vm.getWeekNumberLabel = function (day) {
                        var weekNumber = day.date.clone().add(1, 'day').isoWeek();
                        if (typeof calendarConfig.i18nStrings.weekNumber === 'function') {
                            return calendarConfig.i18nStrings.weekNumber({ weekNumber: weekNumber });
                        } else {
                            return calendarConfig.i18nStrings.weekNumber.replace('{week}', weekNumber);
                        }
                    };

                    vm.onDragSelectStart = function (day) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                startDate: day.date,
                                endDate: day.date
                            };
                        }
                    };

                    vm.onDragSelectMove = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                        }
                    };

                    vm.onDragSelectEnd = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.clone().startOf('day').toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.clone().endOf('day').toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarMonth', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarMonthView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onDateRangeSelect: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarMonthCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 49 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarSlideBoxCtrl', ["$scope", "$timeout", "calendarConfig", "calendarEventTitle", function ($scope, $timeout, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;

                    vm.isCollapsed = true;
                    $scope.$watch('vm.isOpen', function (isOpen) {
                        //events must be populated first to set the element height before animation will work
                        $timeout(function () {
                            vm.isCollapsed = !isOpen;
                        });
                    });

                }])
                .directive('mwlCalendarSlideBox', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarSlideBox" overrides="vm.customTemplateUrls"></div>',
                        replace: true,
                        controller: 'MwlCalendarSlideBoxCtrl as vm',
                        require: ['^?mwlCalendarMonth', '^?mwlCalendarYear'],
                        link: function (scope, elm, attrs, ctrls) {
                            scope.isMonthView = !!ctrls[0];
                            scope.isYearView = !!ctrls[1];
                        },
                        scope: {
                            isOpen: '=',
                            events: '=',
                            onEventClick: '=',
                            cell: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 50 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarWeekCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;

                    vm.showTimes = calendarConfig.showTimesOnWeekView;
                    vm.calendarEventTitle = calendarEventTitle;

                    $scope.$on('calendar.refreshView', function () {
                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );
                        if (vm.showTimes) {
                            vm.view = calendarHelper.getWeekViewWithTimes(
                                vm.events,
                                vm.viewDate,
                                vm.dayViewStart,
                                vm.dayViewEnd,
                                vm.dayViewSplit
                            );
                        } else {
                            vm.view = calendarHelper.getWeekView(vm.events, vm.viewDate);
                        }
                    });

                    vm.weekDragged = function (event, daysDiff, minuteChunksMoved) {

                        var newStart = moment(event.startsAt).add(daysDiff, 'days');
                        var newEnd = moment(event.endsAt).add(daysDiff, 'days');

                        if (minuteChunksMoved) {
                            var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                            newStart = newStart.add(minutesDiff, 'minutes');
                            newEnd = newEnd.add(minutesDiff, 'minutes');
                        }

                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDropped = function (event, date) {
                        var daysDiff = moment(date).diff(moment(event.startsAt), 'days');
                        vm.weekDragged(event, daysDiff);
                    };

                    vm.weekResized = function (event, edge, daysDiff) {

                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(daysDiff, 'days');
                        } else {
                            end.add(daysDiff, 'days');
                        }

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });

                    };

                    vm.tempTimeChanged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                }])
                .directive('mwlCalendarWeek', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarWeekView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarWeekCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 51 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarYearCtrl', ["$scope", "moment", "calendarHelper", function ($scope, moment, calendarHelper) {

                    var vm = this;
                    vm.openMonthIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openMonthIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (month, monthIndex) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.openMonthIndex = monthIndex;
                                    vm.openRowIndex = Math.floor(monthIndex / 4);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {
                        vm.view = calendarHelper.getYearView(vm.events, vm.viewDate, vm.cellModifier);

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openMonthIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openMonthIndex = null;
                            vm.view.forEach(function (month) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.monthClicked(month, true);
                                }
                            });
                        }

                    });

                    vm.monthClicked = function (month, monthClickedFirstRun, $event) {

                        if (!monthClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: month.date.toDate(),
                                calendarCell: month,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var monthIndex = vm.view.indexOf(month);
                            if (monthIndex === vm.openMonthIndex) { //the month has been clicked and is already open
                                vm.openMonthIndex = null; //close the open month
                                vm.cellIsOpen = false;
                            } else {
                                vm.openMonthIndex = monthIndex;
                                vm.openRowIndex = Math.floor(monthIndex / 4);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.handleEventDrop = function (event, newMonthDate) {
                        var newStart = moment(event.startsAt)
                            .year(moment(newMonthDate).year())
                            .month(moment(newMonthDate).month());
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newMonthDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarYear', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarYearView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '='
                        },
                        controller: 'MwlCalendarYearCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 52 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCollapseFallbackCtrl', ["$scope", "$attrs", "$element", function ($scope, $attrs, $element) {

                    $scope.$watch($attrs.mwlCollapseFallback, function (shouldCollapse) {
                        if (shouldCollapse) {
                            $element.addClass('ng-hide');
                        } else {
                            $element.removeClass('ng-hide');
                        }
                    });

                }])
                .directive('mwlCollapseFallback', ["$injector", function ($injector) {

                    if ($injector.has('uibCollapseDirective')) {
                        return {};
                    }

                    return {
                        restrict: 'A',
                        controller: 'MwlCollapseFallbackCtrl'
                    };

                }]);


            /***/
        }),
    /* 53 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDateModifierCtrl', ["$element", "$attrs", "$scope", "moment", function ($element, $attrs, $scope, moment) {

                    var vm = this;

                    function onClick() {
                        if (angular.isDefined($attrs.setToToday)) {
                            vm.date = new Date();
                        } else if (angular.isDefined($attrs.increment)) {
                            vm.date = moment(vm.date).add(1, vm.increment).toDate();
                        } else if (angular.isDefined($attrs.decrement)) {
                            vm.date = moment(vm.date).subtract(1, vm.decrement).toDate();
                        }
                        $scope.$apply();
                    }

                    $element.bind('click', onClick);

                    $scope.$on('$destroy', function () {
                        $element.unbind('click', onClick);
                    });

                }])
                .directive('mwlDateModifier', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDateModifierCtrl as vm',
                        scope: {
                            date: '=',
                            increment: '=',
                            decrement: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 54 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDragSelectCtrl', ["$scope", "$element", "$parse", "$attrs", function ($scope, $element, $parse, $attrs) {

                    function handleMouseEvent(callbackName) {
                        return function (event) {
                            if (callbackName && event.button !== 2) {
                                $parse(callbackName)($scope);
                                $scope.$apply();
                            }
                            event.preventDefault();
                        };
                    }

                    var onMouseDown = handleMouseEvent($attrs.onDragSelectStart);
                    var onMouseMove = handleMouseEvent($attrs.onDragSelectMove);
                    var onMouseUp = handleMouseEvent($attrs.onDragSelectEnd);

                    function enableMouseListeners() {
                        $element.on('mousedown', onMouseDown);
                        $element.on('mousemove', onMouseMove);
                        $element.on('mouseup', onMouseUp);
                    }

                    function disableMouseListeners() {
                        $element.off('mousedown', onMouseDown);
                        $element.off('mousemove', onMouseMove);
                        $element.off('mouseup', onMouseUp);
                    }

                    $scope.$watch($attrs.mwlDragSelect, function (isEnabled) {
                        if (isEnabled) {
                            enableMouseListeners();
                        } else {
                            disableMouseListeners();
                        }
                    });

                    $scope.$on('$destroy', function () {
                        disableMouseListeners();
                    });

                }])
                .directive('mwlDragSelect', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDragSelectCtrl'
                    };

                });


            /***/
        }),
    /* 55 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDraggableCtrl', ["$element", "$scope", "$window", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $window, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    function translateElement(elm, transformValue) {
                        return elm
                            .css('-ms-transform', transformValue)
                            .css('-webkit-transform', transformValue)
                            .css('transform', transformValue);
                    }

                    var autoScroll = $parse($attrs.autoScroll)($scope);
                    if (typeof autoScroll === 'undefined') {
                        autoScroll = true;
                    }

                    interact($element[0]).draggable({
                        autoScroll: autoScroll,
                        snap: snap,
                        onstart: function (event) {
                            angular.element(event.target).addClass('dragging-active');
                            event.target.dropData = $parse($attrs.dropData)($scope);
                            event.target.style.pointerEvents = 'none';
                            if ($attrs.onDragStart) {
                                $parse($attrs.onDragStart)($scope);
                                $scope.$apply();
                            }
                        },
                        onmove: function (event) {

                            var elm = angular.element(event.target);
                            var x = (parseFloat(elm.attr('data-x')) || 0) + (event.dx || 0);
                            var y = (parseFloat(elm.attr('data-y')) || 0) + (event.dy || 0);

                            switch ($parse($attrs.axis)($scope)) {
                                case 'x':
                                    y = 0;
                                    break;

                                case 'y':
                                    x = 0;
                                    break;

                                default:
                            }

                            if ($window.getComputedStyle(elm[0]).position === 'static') {
                                elm.css('position', 'relative');
                            }

                            translateElement(elm, 'translate(' + x + 'px, ' + y + 'px)')
                                .css('z-index', 50)
                                .attr('data-x', x)
                                .attr('data-y', y);

                            if ($attrs.onDrag) {
                                $parse($attrs.onDrag)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var x = elm.attr('data-x');
                            var y = elm.attr('data-y');

                            event.target.style.pointerEvents = 'auto';
                            if ($attrs.onDragEnd) {
                                $parse($attrs.onDragEnd)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                            $timeout(function () {
                                translateElement(elm, '')
                                    .css('z-index', 'auto')
                                    .removeAttr('data-x')
                                    .removeAttr('data-y')
                                    .removeClass('dragging-active');
                            });

                        }
                    });

                    $scope.$watch($attrs.mwlDraggable, function (enabled) {
                        interact($element[0]).draggable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDraggable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDraggableCtrl'
                    };

                });


            /***/
        }),
    /* 56 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDroppableCtrl', ["$element", "$scope", "$parse", "$attrs", "interact", function ($element, $scope, $parse, $attrs, interact) {

                    if (!interact) {
                        return;
                    }

                    var DROP_ACTIVE_CLASS = $attrs.dropActiveClass || 'drop-active';

                    interact($element[0]).dropzone({
                        ondragenter: function (event) {
                            angular.element(event.target).addClass(DROP_ACTIVE_CLASS);
                        },
                        ondragleave: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondropdeactivate: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondrop: function (event) {
                            if (event.relatedTarget.dropData) {
                                $parse($attrs.onDrop)($scope, { dropData: event.relatedTarget.dropData });
                                $scope.$apply();
                            }
                        }
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDroppable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDroppableCtrl'
                    };

                });


            /***/
        }),
    /* 57 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDynamicDirectiveTemplateCtrl', ["$compile", "$scope", "$attrs", "$element", "$templateCache", "$log", "calendarConfig", function ($compile, $scope, $attrs, $element, $templateCache, $log, calendarConfig) {

                    $scope.$watch($attrs.overrides, function (overrides) {

                        var templateName = calendarConfig.templates[$attrs.name];
                        if (
                            overrides &&
                            angular.isObject(overrides) &&
                            overrides[$attrs.name]
                        ) {
                            if ($templateCache.get(overrides[$attrs.name])) {
                                templateName = overrides[$attrs.name];
                            } else {
                                $log.warn('Bootstrap Calendar', 'The custom template for ' + overrides[$attrs.name] +
                                    ' was not found in the template cache. Please ensure it is pre-loaded via a script tag ' +
                                    '<script type="text/ng-template" id="' + overrides[$attrs.name] + '">Custom template content</script> or ' +
                                    'via a tool such as https://www.npmjs.com/package/gulp-angular-templatecache');
                            }
                        }
                        var template = $templateCache.get(templateName);
                        $element.html(template);
                        $compile($element.contents())($scope);

                    });

                }])
                .directive('mwlDynamicDirectiveTemplate', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDynamicDirectiveTemplateCtrl'
                    };

                });


            /***/
        }),
    /* 58 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlElementDimensionsCtrl', ["$element", "$scope", "$parse", "$attrs", "$window", function ($element, $scope, $parse, $attrs, $window) {

                    function setDimensions() {
                        $parse($attrs.mwlElementDimensions).assign($scope, {
                            width: $element[0].offsetWidth - 1,
                            height: $element[0].offsetHeight
                        });
                        $scope.$applyAsync();
                    }

                    var win = angular.element($window);

                    win.bind('resize', setDimensions);

                    setDimensions();

                    $scope.$on('$destroy', function () {
                        win.unbind('resize', setDimensions);
                    });

                }])
                .directive('mwlElementDimensions', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlElementDimensionsCtrl'
                    };

                });


            /***/
        }),
    /* 59 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlResizableCtrl', ["$element", "$scope", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    var originalDimensions = {};
                    var originalDimensionsStyle = {};
                    var resizeEdge;

                    function getUnitsResized(edge, elm) {
                        var unitsResized = {};
                        unitsResized.edge = edge;
                        if (edge === 'start') {
                            unitsResized.x = elm.data('x');
                            unitsResized.y = elm.data('y');
                        } else if (edge === 'end') {
                            unitsResized.x = parseFloat(elm.css('width').replace('px', '')) - originalDimensions.width;
                            unitsResized.y = parseFloat(elm.css('height').replace('px', '')) - originalDimensions.height;
                        }
                        return unitsResized;
                    }

                    interact($element[0]).resizable({
                        edges: $parse($attrs.resizeEdges)($scope),
                        snap: snap,
                        onstart: function (event) {

                            resizeEdge = 'end';
                            var elm = angular.element(event.target);
                            originalDimensions.height = elm[0].offsetHeight;
                            originalDimensions.width = elm[0].offsetWidth;
                            originalDimensionsStyle.height = elm.css('height');
                            originalDimensionsStyle.width = elm.css('width');

                        },
                        onmove: function (event) {

                            if (event.rect.width > 0 && event.rect.height > 0) {
                                var elm = angular.element(event.target);
                                var x = parseFloat(elm.data('x') || 0);
                                var y = parseFloat(elm.data('y') || 0);

                                elm.css({
                                    width: event.rect.width + 'px',
                                    height: event.rect.height + 'px'
                                });

                                // translate when resizing from top or left edges
                                x += event.deltaRect.left;
                                y += event.deltaRect.top;

                                elm.css('transform', 'translate(' + x + 'px,' + y + 'px)');

                                elm.data('x', x);
                                elm.data('y', y);

                                if (event.deltaRect.left !== 0 || event.deltaRect.top !== 0) {
                                    resizeEdge = 'start';
                                }

                                if ($attrs.onResize) {
                                    $parse($attrs.onResize)($scope, getUnitsResized(resizeEdge, elm));
                                    $scope.$apply();
                                }

                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var unitsResized = getUnitsResized(resizeEdge, elm);

                            $timeout(function () {
                                elm
                                    .data('x', null)
                                    .data('y', null)
                                    .css({
                                        transform: '',
                                        width: originalDimensionsStyle.width,
                                        height: originalDimensionsStyle.height
                                    });
                            });

                            if ($attrs.onResizeEnd) {
                                $parse($attrs.onResizeEnd)($scope, unitsResized);
                                $scope.$apply();
                            }

                        }
                    });

                    $scope.$watch($attrs.mwlResizable, function (enabled) {
                        interact($element[0]).resizable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlResizable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlResizableCtrl'
                    };

                });


            /***/
        }),
    /* 60 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            __webpack_require__(6);

            var angular = __webpack_require__(0);

            function requireAll(r) {
                r.keys().forEach(r);
            }

            var templates = {};

            if (true) {

                var templatesContext = __webpack_require__(10);

                templatesContext.keys().forEach(function (templateName) {
                    var templateNameWithoutPrefix = templateName.replace('./', '');
                    var cacheTemplateName = 'mwl/' + templateNameWithoutPrefix;
                    var configTemplateName = templateNameWithoutPrefix.replace('.html', '');
                    templates[configTemplateName] = {
                        cacheTemplateName: cacheTemplateName,
                        template: templatesContext(templateName)
                    };
                });

            }

            module.exports = angular
                .module('mwl.calendar', [])
                .config(["calendarConfig", function (calendarConfig) {
                    angular.forEach(templates, function (template, templateName) {
                        if (!calendarConfig.templates[templateName]) {
                            calendarConfig.templates[templateName] = template.cacheTemplateName;
                        }
                    });
                }])
                .run(["$templateCache", "$interpolate", function ($templateCache, $interpolate) {

                    angular.forEach(templates, function (template) {
                        if (!$templateCache.get(template.cacheTemplateName)) {
                            var templateContents = template.template
                                .replace('{{', $interpolate.startSymbol())
                                .replace('}}', $interpolate.endSymbol());
                            $templateCache.put(template.cacheTemplateName, templateContents);
                        }
                    });

                }]).name;

            requireAll(__webpack_require__(7));
            requireAll(__webpack_require__(8));
            requireAll(__webpack_require__(9));


            /***/
        }),
    /* 61 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarDate', ["calendarHelper", "calendarConfig", function (calendarHelper, calendarConfig) {

                    function calendarDate(date, format, getFromConfig) {

                        if (getFromConfig === true) {
                            format = calendarConfig.dateFormats[format];
                        }

                        return calendarHelper.formatDate(date, format);

                    }

                    // This is stateful because the locale can change as well
                    // as calendarConfig.dateFormats which would change the value outside of this filter
                    calendarDate.$stateful = true;

                    return calendarDate;

                }]);


            /***/
        }),
    /* 62 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarLimitTo', ["limitToFilter", function (limitToFilter) {

                    if (angular.version.minor >= 4) { //1.4+ supports the begin attribute
                        return limitToFilter;
                    }

                    //Copied from the angular source. Only 1.4 has the begin functionality.
                    return function (input, limit, begin) {
                        if (Math.abs(Number(limit)) === Infinity) {
                            limit = Number(limit);
                        } else {
                            limit = parseInt(limit);
                        }
                        if (isNaN(limit)) {
                            return input;
                        }

                        if (angular.isNumber(input)) {
                            input = input.toString();
                        }
                        if (!angular.isArray(input) && !angular.isString(input)) {
                            return input;
                        }

                        begin = (!begin || isNaN(begin)) ? 0 : parseInt(begin);
                        begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

                        if (limit >= 0) {
                            return input.slice(begin, begin + limit);
                        } else if (begin === 0) {
                            return input.slice(limit, input.length);
                        } else {
                            return input.slice(Math.max(0, begin + limit), begin);
                        }
                    };

                }]);


            /***/
        }),
    /* 63 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTruncateEventTitle', function () {

                    return function (string, length, boxHeight) {
                        if (!string) {
                            return '';
                        }

                        //Only truncate if if actually needs truncating
                        if (string.length >= length && string.length / 20 > boxHeight / 30) {
                            return string.substr(0, length) + '...';
                        } else {
                            return string;
                        }
                    };

                });


            /***/
        }),
    /* 64 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTrustAsHtml', ["$sce", function ($sce) {

                    return function (text) {
                        return $sce.trustAsHtml(text);
                    };

                }]);


            /***/
        }),
    /* 65 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .constant('calendarConfig', {
                    allDateFormats: {
                        angular: {
                            date: {
                                hour: 'ha',
                                day: 'd MMM',
                                month: 'MMMM',
                                weekDay: 'EEEE',
                                time: 'HH:mm',
                                datetime: 'MMM d, h:mm a'
                            },
                            title: {
                                day: 'EEEE d MMMM, yyyy',
                                week: 'Week {week} of {year}',
                                month: 'MMMM yyyy',
                                year: 'yyyy'
                            }
                        },
                        moment: {
                            date: {
                                hour: 'ha',
                                day: 'D MMM',
                                month: 'MMMM',
                                weekDay: 'dddd',
                                time: 'HH:mm',
                                datetime: 'MMM D, h:mm a'
                            },
                            title: {
                                day: 'dddd D MMMM, YYYY',
                                week: 'Week {week} of {year}',
                                month: 'MMMM YYYY',
                                year: 'YYYY'
                            }
                        }
                    },
                    get dateFormats() {
                        return this.allDateFormats[this.dateFormatter].date;
                    },
                    get titleFormats() {
                        return this.allDateFormats[this.dateFormatter].title;
                    },
                    dateFormatter: 'angular',
                    showTimesOnWeekView: false,
                    displayAllMonthEvents: false,
                    i18nStrings: {
                        weekNumber: 'Week {week}'
                    },
                    templates: {},
                    colorTypes: {
                        info: {
                            primary: '#1e90ff',
                            secondary: '#d1e8ff'
                        },
                        important: {
                            primary: '#ad2121',
                            secondary: '#fae3e3'
                        },
                        warning: {
                            primary: '#e3bc08',
                            secondary: '#fdf1ba'
                        },
                        inverse: {
                            primary: '#1b1b1b',
                            secondary: '#c1c1c1'
                        },
                        special: {
                            primary: '#800080',
                            secondary: '#ffe6ff'
                        },
                        success: {
                            primary: '#006400',
                            secondary: '#caffca'
                        }
                    }
                });


            /***/
        }),
    /* 66 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarEventTitle', ["calendarDateFilter", "calendarTruncateEventTitleFilter", function (calendarDateFilter, calendarTruncateEventTitleFilter) {

                    function yearView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'datetime', true) + ')';
                    }

                    function monthView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
                    }

                    function monthViewTooltip(event) {
                        return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
                    }

                    function weekView(event) {
                        return event.title;
                    }

                    function weekViewTooltip(event) {
                        return event.title;
                    }

                    function dayView(event) {
                        return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);
                    }

                    function dayViewTooltip(event) {
                        return event.title;
                    }

                    return {
                        yearView: yearView,
                        monthView: monthView,
                        monthViewTooltip: monthViewTooltip,
                        weekView: weekView,
                        weekViewTooltip: weekViewTooltip,
                        dayView: dayView,
                        dayViewTooltip: dayViewTooltip
                    };

                }]);


            /***/
        }),
    /* 67 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .factory('calendarHelper', ["$q", "$templateRequest", "dateFilter", "moment", "calendarConfig", function ($q, $templateRequest, dateFilter, moment, calendarConfig) {

                    function formatDate(date, format) {
                        if (calendarConfig.dateFormatter === 'angular') {
                            return dateFilter(moment(date).toDate(), format);
                        } else if (calendarConfig.dateFormatter === 'moment') {
                            return moment(date).format(format);
                        } else {
                            throw new Error('Unknown date formatter: ' + calendarConfig.dateFormatter);
                        }
                    }

                    function adjustEndDateFromStartDiff(oldStart, newStart, oldEnd) {
                        if (!oldEnd) {
                            return oldEnd;
                        }
                        var diffInSeconds = moment(newStart).diff(moment(oldStart));
                        return moment(oldEnd).add(diffInSeconds);
                    }

                    function getRecurringEventPeriod(eventPeriod, recursOn, containerPeriodStart) {

                        var eventStart = moment(eventPeriod.start);
                        var eventEnd = moment(eventPeriod.end);
                        var periodStart = moment(containerPeriodStart);

                        if (recursOn) {

                            switch (recursOn) {
                                case 'year':
                                    eventStart.set({
                                        year: periodStart.year()
                                    });
                                    break;

                                case 'month':
                                    eventStart.set({
                                        year: periodStart.year(),
                                        month: periodStart.month()
                                    });
                                    break;

                                default:
                                    throw new Error('Invalid value (' + recursOn + ') given for recurs on. Can only be year or month.');
                            }

                            eventEnd = adjustEndDateFromStartDiff(eventPeriod.start, eventStart, eventEnd);

                        }

                        return { start: eventStart, end: eventEnd };

                    }

                    function eventIsInPeriod(event, periodStart, periodEnd) {

                        periodStart = moment(periodStart);
                        periodEnd = moment(periodEnd);

                        var eventPeriod = getRecurringEventPeriod({ start: event.startsAt, end: event.endsAt || event.startsAt }, event.recursOn, periodStart);
                        var eventStart = eventPeriod.start;
                        var eventEnd = eventPeriod.end;

                        return (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) ||
                            (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) ||
                            (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) ||
                            eventStart.isSame(periodStart) ||
                            eventEnd.isSame(periodEnd);

                    }

                    function filterEventsInPeriod(events, startPeriod, endPeriod) {
                        return events.filter(function (event) {
                            return eventIsInPeriod(event, startPeriod, endPeriod);
                        });
                    }

                    function getEventsInPeriod(calendarDate, period, allEvents) {
                        var startPeriod = moment(calendarDate).startOf(period);
                        var endPeriod = moment(calendarDate).endOf(period);
                        return filterEventsInPeriod(allEvents, startPeriod, endPeriod);
                    }

                    function getBadgeTotal(events) {
                        return events.filter(function (event) {
                            return event.incrementsBadgeTotal !== false;
                        }).length;
                    }

                    function getWeekDayNames() {
                        var weekdays = [];
                        var count = 0;
                        while (count < 7) {
                            weekdays.push(formatDate(moment().weekday(count++), calendarConfig.dateFormats.weekDay));
                        }
                        return weekdays;
                    }

                    function getYearView(events, viewDate, cellModifier) {

                        var view = [];
                        var eventsInPeriod = getEventsInPeriod(viewDate, 'year', events);
                        var month = moment(viewDate).startOf('year');
                        var count = 0;
                        while (count < 12) {
                            var startPeriod = month.clone();
                            var endPeriod = startPeriod.clone().endOf('month');
                            var periodEvents = filterEventsInPeriod(eventsInPeriod, startPeriod, endPeriod);
                            var cell = {
                                label: formatDate(startPeriod, calendarConfig.dateFormats.month),
                                isToday: startPeriod.isSame(moment().startOf('month')),
                                events: periodEvents,
                                date: startPeriod,
                                badgeTotal: getBadgeTotal(periodEvents)
                            };

                            cellModifier({ calendarCell: cell });
                            view.push(cell);
                            month.add(1, 'month');
                            count++;
                        }

                        return view;

                    }

                    function updateEventForCalendarUtils(event, eventPeriod) {
                        event.start = eventPeriod.start.toDate();
                        if (event.endsAt) {
                            event.end = eventPeriod.end.toDate();
                        }
                        return event;
                    }

                    function getMonthView(events, viewDate, cellModifier) {

                        // hack required to work with the calendar-utils api
                        events.forEach(function (event) {
                            var eventPeriod = getRecurringEventPeriod({
                                start: moment(event.startsAt),
                                end: moment(event.endsAt || event.startsAt)
                            }, event.recursOn, moment(viewDate).startOf('month'));
                            updateEventForCalendarUtils(event, eventPeriod);
                        });

                        var view = calendarUtils.getMonthView({
                            events: events,
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        });

                        view.days = view.days.map(function (day) {
                            day.date = moment(day.date);
                            day.label = day.date.date();
                            day.badgeTotal = getBadgeTotal(day.events);
                            if (!calendarConfig.displayAllMonthEvents && !day.inMonth) {
                                day.events = [];
                            }
                            cellModifier({ calendarCell: day });
                            return day;
                        });

                        // remove hack
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekView(events, viewDate) {

                        var days = calendarUtils.getWeekViewHeader({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        }).map(function (day) {
                            day.date = moment(day.date);
                            day.weekDayLabel = formatDate(day.date, calendarConfig.dateFormats.weekDay);
                            day.dayLabel = formatDate(day.date, calendarConfig.dateFormats.day);
                            return day;
                        });

                        var startOfWeek = moment(viewDate).startOf('week');
                        var endOfWeek = moment(viewDate).endOf('week');

                        var eventRows = calendarUtils.getWeekView({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day(),
                            events: filterEventsInPeriod(events, startOfWeek, endOfWeek).map(function (event) {

                                var weekViewStart = moment(startOfWeek).startOf('day');

                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, weekViewStart);

                                var calendarUtilsEvent = {
                                    originalEvent: event,
                                    start: eventPeriod.start.toDate()
                                };

                                if (event.endsAt) {
                                    calendarUtilsEvent.end = eventPeriod.end.toDate();
                                }

                                return calendarUtilsEvent;
                            })
                        }).map(function (eventRow) {

                            eventRow.row = eventRow.row.map(function (rowEvent) {
                                rowEvent.event = rowEvent.event.originalEvent;
                                return rowEvent;
                            });

                            return eventRow;

                        });

                        return { days: days, eventRows: eventRows };

                    }

                    function getDayView(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit, dayViewEventWidth) {

                        var dayStart = (dayViewStart || '00:00').split(':');
                        var dayEnd = (dayViewEnd || '23:59').split(':');

                        var view = calendarUtils.getDayView({
                            events: events.map(function (event) { // hack required to work with event API
                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, moment(viewDate).startOf('day'));
                                return updateEventForCalendarUtils(event, eventPeriod);
                            }),
                            viewDate: viewDate,
                            hourSegments: 60 / dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            },
                            eventWidth: dayViewEventWidth ? +dayViewEventWidth : 150,
                            segmentHeight: 30
                        });

                        // remove hack to work with new event API
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekViewWithTimes(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {
                        var weekView = getWeekView(events, viewDate);
                        var newEvents = [];
                        var flattenedEvents = [];
                        weekView.eventRows.forEach(function (row) {
                            row.row.forEach(function (eventRow) {
                                flattenedEvents.push(eventRow.event);
                            });
                        });
                        weekView.days.forEach(function (day) {
                            var dayEvents = flattenedEvents.filter(function (event) {
                                return moment(event.startsAt).startOf('day').isSame(moment(day.date).startOf('day'));
                            });
                            var newDayEvents = getDayView(
                                dayEvents,
                                day.date,
                                dayViewStart,
                                dayViewEnd,
                                dayViewSplit
                            ).events;
                            newEvents = newEvents.concat(newDayEvents);
                        });
                        weekView.eventRows = [{
                            row: newEvents.map(function (dayEvent) {
                                var event = dayEvent.event;
                                return {
                                    event: event,
                                    top: dayEvent.top,
                                    offset: calendarUtils.getWeekViewEventOffset({
                                        event: {
                                            start: event.startsAt,
                                            end: event.endsAt
                                        },
                                        startOfWeek: moment(viewDate).startOf('week').toDate()
                                    })
                                };
                            })
                        }];
                        return weekView;
                    }

                    function getDayViewHeight(dayViewStart, dayViewEnd, dayViewSplit) {
                        var dayViewStartM = moment(dayViewStart || '00:00', 'HH:mm');
                        var dayViewEndM = moment(dayViewEnd || '23:59', 'HH:mm');
                        var hourHeight = (60 / dayViewSplit) * 30;
                        return ((dayViewEndM.diff(dayViewStartM, 'minutes') / 60) * hourHeight) + 3;
                    }

                    function loadTemplates() {

                        var templatePromises = Object.keys(calendarConfig.templates).map(function (key) {
                            var templateUrl = calendarConfig.templates[key];
                            return $templateRequest(templateUrl);
                        });

                        return $q.all(templatePromises);

                    }

                    return {
                        getWeekDayNames: getWeekDayNames,
                        getYearView: getYearView,
                        getMonthView: getMonthView,
                        getWeekView: getWeekView,
                        getDayView: getDayView,
                        getWeekViewWithTimes: getWeekViewWithTimes,
                        getDayViewHeight: getDayViewHeight,
                        adjustEndDateFromStartDiff: adjustEndDateFromStartDiff,
                        formatDate: formatDate,
                        loadTemplates: loadTemplates,
                        eventIsInPeriod: eventIsInPeriod //expose for testing only
                    };

                }]);


            /***/
        }),
    /* 68 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarTitle', ["moment", "calendarConfig", "calendarHelper", function (moment, calendarConfig, calendarHelper) {

                    function day(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);
                    }

                    function week(viewDate) {
                        return calendarConfig.titleFormats.week
                            .replace('{week}', moment(viewDate).isoWeek())
                            .replace('{year}', moment(viewDate).startOf('isoweek').format('YYYY'));
                    }

                    function month(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);
                    }

                    function year(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);
                    }

                    return {
                        day: day,
                        week: week,
                        month: month,
                        year: year
                    };

                }]);


            /***/
        }),
    /* 69 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var interact;
            try {
                interact = __webpack_require__(72);
            } catch (e) {
                /* istanbul ignore next */
                interact = null;
            }

            angular
                .module('mwl.calendar')
                .constant('interact', interact);


            /***/
        }),
    /* 70 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var moment = __webpack_require__(71);

            angular
                .module('mwl.calendar')
                .constant('moment', moment);


            /***/
        }),
    /* 71 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_71__;

            /***/
        }),
    /* 72 */
    /***/ (function (module, exports) {

            if (typeof __WEBPACK_EXTERNAL_MODULE_72__ === 'undefined') { var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e; }
            module.exports = __WEBPACK_EXTERNAL_MODULE_72__;

            /***/
        })
    /******/]);
});
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.autoattendance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_autoattendance', {
            url: '/Autoattendance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmAdmin/autoattendance/autoattendance.html',
                    controller: 'AutoAttendanceController as vm'
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.autoattendance')
        .controller('AutoAttendanceController', AutoAttendanceController);
    /** @ngInject */
    function AutoAttendanceController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdDialog, $document, $mdSidenav, $http, $window, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Attendancegrid = true;
        $scope.Export = true;
        $scope.Attendanceform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("AutoAttendancedatas.xlsx",{headers:true}) FROM ?', [$scope.Attendancedatas]);
        };


        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }


        $scope.sSubmit = function () {

            if ($scope.vm.uEmployee != null && $scope.vm.uEmployee != "" && $scope.vm.uEmployee != undefined) {

                debugger
                var info = $scope.vm.uEmployee;
                for (var i = 0; i < info.length; i++) {
                    debugger
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/autoattendance/add",
                        data: {
                            Client_Id: $rootScope.Client_Id,
                            Employee: info[i].id,
                            Shift: $scope.vm.uShift,
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                }
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Attendancegrid = true;
                    $scope.Attendanceform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
                // }
            }

        }
        $scope.Alertpopup = function (e, deleteID) {
            debugger
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/autoattendance/autoattendancealert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AutoAttendanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.AttendanceID = deleteID;
        }
        $scope.AutoAttendancedelete = function (deleteID) {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/autoattendance/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                RefreshGrid();
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Showgrid = function () {
            $scope.Attendancegrid = true;
            $scope.Attendanceform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.sAdd = function (e) {
            ClearForm();
            $scope.Update = false;
            $scope.Attendanceform = false;
            $scope.Attendancegrid = true;
            // $scope.basicForm.$setPristine();
            // $scope.basicForm.$setUntouched();
            $scope.vm.uDate = new Date();
            $scope.vm.uTimeIn = new Date();
            $scope.vm.uTimeOut = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/human-resource/HcmAdmin/autoattendance/autoAttendancepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function AutoAttendanceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/autoattendance",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Attendancedata) {
            debugger
            $scope.Attendancedatas = Attendancedata.data.data;
        });


        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/autoattendance",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Attendancedata) {
                $scope.Attendancedatas = Attendancedata.data.data;
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/shift",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Shiftdata) {
                $scope.Shiftdatas = Shiftdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });

        }

        function ClearForm() {
            $scope.vm.uShift = '';
            $scope.vm.uDate = new Date();
            $scope.vm.uTimeIn = new Date();
            $scope.vm.uTimeOut = '';
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            destroy: true

        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }




})();


(function () {
    'use strict';

    angular
 
        .module('app.human-resource.HcmCore.expirydetails', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_expirydetails', {
            url: '/ExpiryDetails',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/expirydetails/expirydetails.html',
                    controller: 'expirydetailsController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmCore/expirydetails');
    }

})();

 
(function () {
    'use strict';

    angular

        .module('app.human-resource.HcmCore.expirydetails')
        .controller('expirydetailsController', expirydetailsController);

    /** @ngInject */
    function expirydetailsController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        $scope.Expiryform = true;
        $scope.Export = true;
        $scope.Search = true;
        $scope.view = false;
        $scope.Export = function () {


            if ($scope.vm.selectedIndex == "0") {

                alasql('SELECT EmployeeID,EmployeeName,NRICNumber,NRICExpiryDate INTO XLSX("NRICInfo.xlsx",{headers:true}) FROM ?', [$scope.EmployeInfo]);
            }

            else if ($scope.vm.selectedIndex == "1") {

                alasql('SELECT EmployeeID,EmployeeName,PassportNo,WorkPassExpiryDate INTO XLSX("PassportInfo.xlsx",{headers:true}) FROM ?', [$scope.EmployeInfo]);
            }


            else if ($scope.vm.selectedIndex == "2") {

                alasql('SELECT * INTO XLSX("CourseInfo.xlsx",{headers:true}) FROM ?', [$scope.EmployeInfo]);
            }

            else if ($scope.vm.selectedIndex == "3") {

                alasql('SELECT  EmployeeID,EmployeeName,PassNumber,ExpiryDate INTO XLSX("PassInfo.xlsx",{headers:true}) FROM ?', [$scope.EmployeInfo]);
            }

        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];



        $scope.NRIC = function () {
            debugger
            $scope.uFrom = null;
            $scope.uTo = null;
            $scope.EmployeInfo = null;

        }

        $scope.Passport = function () {
            debugger
            $scope.uFrom = null;
            $scope.uTo = null;
            $scope.EmployeInfo = null;

        }



        $scope.Course = function () {
            debugger
            $scope.uFrom = null;
            $scope.uTo = null;
            $scope.EmployeInfo = null;
        }


        $scope.Pass = function () {
            debugger
            $scope.uFrom = null;
            $scope.uTo = null;
            $scope.EmployeInfo = null;
        }







        $scope.lastmonth = function () {

            $scope.uFrom = null;
            $scope.uTo = null;

            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;


            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC";
                $scope.uFrom = lastMonthStartDate;
                $scope.uTo = lastMonthEndDate;

            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport";
                $scope.uFrom = lastMonthStartDate;
                $scope.uTo = lastMonthEndDate;

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course";
                $scope.uFrom = lastMonthStartDate;
                $scope.uTo = lastMonthEndDate;

            }



            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass";
                $scope.uFrom = lastMonthStartDate;
                $scope.uTo = lastMonthEndDate;

            }

            common();




        }




        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();

            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }




        $scope.Search = function () {


            var Startdate = $scope.uFrom;
            $scope.uFrom.setHours(0, 0, 0, 0);

            var Enddate = $scope.uTo;
            $scope.uTo.setHours(23, 59, 59, 999);



            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC"


            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport"

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course"

            }

            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass"

            }


            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expirydetails/datefilter",
                method: "POST",
                data: { Start_Date: Startdate, End_Date: Enddate, Client_Id: $rootScope.Client_Id, Type: $scope.uType },
            });
            response.then(function (GList) {
                $scope.EmployeInfo = GList.data.data;

                debugger

                $scope.EmployeInfo = GList.data.data;

                if (GList.data.message == "PassList") {
                    var Pass = [];
                    angular.forEach($scope.EmployeInfo, function (value, key) {
                        angular.forEach($scope.Employeedatas, function (value1, key1) {

                            if (value.EmployeeID == value1.EmployeeID) {
                                Pass.push({
                                    EmployeeName: value1.EmployeeName,
                                    EmployeeID: value.EmployeeID,
                                    PassNumber: value.PassNumber,
                                    ExpiryDate: value.ExpiryDate,
                                })
                            }
                        });
                    });
                    $scope.EmployeInfo = Pass;
                }
            });

        }



        $scope.Expired = function () {

            debugger
            $scope.uFrom = null;
            $scope.uTo = null;

            var today = new Date();

            $scope.startdate = "01-01-1987"

            $scope.enddate = today;

            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC"


            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport"

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course"

            }

            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass"

            }

            ExpiredDetails();

        }



        function ExpiredDetails() {

            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expirydetails/datefilter",
                method: "POST",
                data: { Start_Date: $scope.startdate, End_Date: $scope.enddate, Client_Id: $rootScope.Client_Id, Type: $scope.uType },
            });
            response.then(function (GList) {


                $scope.EmployeInfo = GList.data.data;

                debugger
                $scope.EmployeInfo = GList.data.data;
                if (GList.data.message == "PassList") {
                    var Pass = [];
                    angular.forEach($scope.EmployeInfo, function (value, key) {
                        angular.forEach($scope.Employeedatas, function (value1, key1) {

                            if (value.EmployeeID == value1.EmployeeID) {

                                debugger
                                Pass.push({
                                    EmployeeName: value1.EmployeeName,
                                    EmployeeID: value.EmployeeID,
                                    PassNumber: value.PassNumber,
                                    ExpiryDate: value.ExpiryDate,

                                })
                            }
                        });


                    });

                    $scope.EmployeInfo = Pass;
                }

            });


        }



        $scope.Today = function () {


            var today = new Date();

            var end = new Date();


            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);

            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);

            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC"

            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport"

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course"

            }



            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass"

            }

            common();

        }


        $scope.lastweek = function () {


            $scope.uFrom = null;
            $scope.uTo = null;

            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);

            from = $filter('date')(from);
            to = $filter('date')(to);

            $scope.uFrom = from;

            $scope.uTo = to;

            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC"
                $scope.uFrom = from;

                $scope.uTo = to;


            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport";
                $scope.uFrom = from;
                $scope.uTo = to;

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course";
                $scope.uFrom = from;
                $scope.uTo = to;

            }


            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass";
                $scope.uFrom = from;
                $scope.uTo = to;

            }

            common();


        }

        $scope.NextWeek = function () {

            $scope.uFrom = null;
            $scope.uTo = null;

            var d = new Date();

            var dayIndex = [1];

            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);

            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);

            from = $filter('date')(from);
            to = $filter('date')(to);

            $scope.uFrom = from;

            $scope.uTo = to;

            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC";
                $scope.uFrom = from;

                $scope.uTo = to;

            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport";
                $scope.uFrom = from;
                $scope.uTo = to;

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course";
                $scope.uFrom = from;
                $scope.uTo = to;

            }

            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass";
                $scope.uFrom = from;
                $scope.uTo = to;

            }

            common();


        }
        $scope.NextMonth = function () {

            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);

            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);

            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;

            if ($scope.vm.selectedIndex == "0") {
                $scope.uType = "NRIC";
                $scope.uFrom = firstDay;
                $scope.uTo = lastDay;

            }

            else if ($scope.vm.selectedIndex == "1") {
                $scope.uType = "Passport";
                $scope.uFrom = firstDay;
                $scope.uTo = lastDay;

            }

            else if ($scope.vm.selectedIndex == "2") {
                $scope.uType = "Course";
                $scope.uFrom = firstDay;
                $scope.uTo = lastDay;

            }


            else if ($scope.vm.selectedIndex == "3") {
                $scope.uType = "Pass"

            }

            common();


        }


        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });



        function common() {

            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expirydetails/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id, Type: $scope.uType },
            });
            response.then(function (GList) {
                debugger
                $scope.EmployeInfo = GList.data.data;
                if (GList.data.message == "PassList") {
                    var Pass = [];

                    angular.forEach($scope.EmployeInfo, function (value, key) {

                        angular.forEach($scope.Employeedatas, function (value1, key1) {

                            if (value.EmployeeID == value1.EmployeeID) {

                                debugger
                                Pass.push({
                                    EmployeeName: value1.EmployeeName,
                                    EmployeeID: value.EmployeeID,
                                    PassNumber: value.PassNumber,
                                    ExpiryDate: value.ExpiryDate,

                                })
                            }
                        });


                    });

                    $scope.EmployeInfo = Pass;
                }

            })
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }

        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.pass', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_pass', {
            url: '/PassManagement',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/pass/pass.html',
                    controller: 'passController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmCore/pass');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.pass')
        .controller('passController', passController);

    /** @ngInject */
    function passController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $location, $mdSidenav, $http, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        $scope.Passgrid = true;
        $scope.Export = true;
        $scope.Passform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        //$scope.ExpiryDate.setHours(0, 0, 0, 0);
        $scope.Export = function () {
            alasql('SELECT EmployeeID,EmployeeName,PassNumber,PassDetails,AppliedDate,IssuedDate,ExpiryDate INTO XLSX("Passdatas.xlsx",{headers:true}) FROM ?', [$scope.Passsummary]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.passinfo = function (PassID) {
            $scope.SID = PassID;
            $scope.Update = true;
            $scope.Passform = true;
            $scope.Passgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;

            var Passdata = $scope.Passdatas
            var info = $scope.Passdatas
            debugger

            angular.forEach(info, function (value, key) {
                if (value.id === PassID) {

                    $scope.EmployeeID = value.EmployeeID;
                    $scope.PassNumber = value.PassNumber;
                    $scope.PassDetails = value.PassDetails;
                    $scope.AppliedDate = value.AppliedDate;
                    $scope.IssuedDate = value.IssuedDate;
                    $scope.ExpiryDate = value.ExpiryDate;
                }
            });

        }


        $scope.sSubmit = function () {
            debugger
            var days = [];
            if ($scope.Update === true) {

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/pass/update",
                    data: {
                        _id: $scope.SID, EmployeeID: $scope.EmployeeID, PassNumber: $scope.PassNumber, PassDetails: $scope.PassDetails,
                        AppliedDate: $scope.AppliedDate, IssuedDate: $scope.IssuedDate, ExpiryDate: $scope.ExpiryDate, UpdatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.Passgrid = true;
                    $scope.Passform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/pass/add",
                    data: {
                        EmployeeID: $scope.EmployeeID, PassNumber: $scope.PassNumber, PassDetails: $scope.PassDetails,
                        AppliedDate: $scope.AppliedDate, IssuedDate: $scope.IssuedDate, ExpiryDate: $scope.ExpiryDate, CreatedBy: $rootScope.createdby,   //, status: "true",                       
                        Client_Id: $rootScope.Client_Id
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Passgrid = true;
                    $scope.Passform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Showgrid = function () {
            $scope.Passgrid = true;
            $scope.Passform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;

        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Passform = true;
            $scope.Passgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            // $scope.EmployeeID = "";
            // $scope.PassNumber = "";
            //$scope.PassDetails = "";
            //$scope.AppliedDate = new Date("00:00");
            // $scope.IssuedDate = "";
            // $scope.ExpiryDate ="";
        }


        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pass",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Passdata) {
            debugger
            $scope.Passdatas = Passdata.data.data;
            Passsummary();
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pass",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Passdata) {
                $scope.Passdatas = Passdata.data.data;
                Passsummary();
            });
        }

        function Passsummary() {
            debugger
            var Pass = [];

            var passinfo = $scope.Passdatas

            var Employeeinfo = $scope.Employeedatas

            angular.forEach(passinfo, function (value, key) {
                angular.forEach(Employeeinfo, function (value1, key1) {
                    if (value.EmployeeID == value1.EmployeeID) {
                        debugger
                        Pass.push({
                            ID: value.id,
                            EmployeeName: value1.EmployeeName,
                            EmployeeID: value.EmployeeID,
                            PassNumber: value.PassNumber,
                            PassDetails: value.PassDetails,
                            AppliedDate: value.AppliedDate,
                            IssuedDate: value.IssuedDate,
                            ExpiryDate: value.ExpiryDate,

                        })
                    }

                });
            });

            debugger
            $scope.Passsummary = Pass;
        }

        function ClearForm() {
            $scope.EmployeeID = '';
            $scope.PassNumber = '';
            $scope.PassDetails = '';
            $scope.AppliedDate = '';
            $scope.IssuedDate = '';
            $scope.ExpiryDate = '';
        }





        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }

        };


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.leave', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_leave', {
            url: '/LeaveApplication',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/leave/leave.html',
                    controller: 'LeaveController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmCore/leave');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmCore.leave')
        .controller('LeaveController', LeaveController)
        .filter('unique', function () {
            return function (collection, keyname) {
                var output = [],
                    keys = [];

                angular.forEach(collection, function (item) {
                    var key = item[keyname];
                    if (keys.indexOf === -1) {
                        keys.push;
                        output.push(item);
                    }
                });

                return output;
            };
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });


    function LeaveController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $mdDialog, $document, $http, $filter, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();
        RefreshCourseattendanceGrid();
        //RefreshUserGrid();
        //$scope.Leaveform = false;
        //$scope.Leavegrid = true;
        //$scope.lExport = true;
        //$scope.lAdd = true;
        //$scope.lSearch = true;
        //$scope.lView = false;
        //$scope.Leave = false;
        //$http.get( $rootScope.WebURL + "/Workflow")
        //   .then(function (Workflowdata) {
        //       $scope.Workflowdatas = Workflowdata.data.data;
        //   });
        //$http.get( $rootScope.WebURL + "/employee")
        // .then(function (Employeedata) {
        //     $scope.Employeedatas = Employeedata.data.data;
        // });
        //$http.get( $rootScope.WebURL + "/leave")
        //    .then(function (Leavedata) {
        //        $scope.Leavedatas = Leavedata.data.data;
        //    });
        //function RefreshUserGrid() {
        //    var response = $http({
        //        url:  $rootScope.WebURL + "/user",
        //        method: "POST",
        //        data: { Client_Id: Client_Id },
        //    });
        //    response.then(function (Userdata) {
        //        $scope.Userdatas = Userdata.data.data;
        //    });
        //}
        //function RefreshGrid() {
        //    $http.get( $rootScope.WebURL + "/leave")
        //      .then(function (Leavedata) {
        //          $scope.Leavedatas = Leavedata.data.data;
        //      });
        //}

        var LeaveID = getParameterByName('ID');

        if (LeaveID != null) {

            var response = $http({
                url: $rootScope.WebURL + "/leave",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leavedata) {

                $scope.Leavedatas = Leavedata.data.data;

                var LeaveArray = $scope.Leavedatas;
                var item = LeaveArray.filter(function (item) {
                    return item._id === LeaveID;
                })[0];

                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.FromDate = new Date(item.FromDate);
                $scope.ToDate = new Date(item.ToDate);
                $scope.FromDayType = item.FromDayType;
                $scope.ToDayType = item.ToDayType;
                $scope.LeaveType = item.LeaveType;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Reason = item.Reason;
                if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                    $scope.EmergencyContactNo = parseInt(item.EmergencyContactNo);
                }
                $scope.TotalDaysApplied = parseInt(item.TotalDaysApplied);
                $scope.TotalPaidLeaves = parseInt(item.TotalPaidLeaves);
                $scope.TotalUnPaidLeaves = parseInt(item.TotalUnPaidLeaves);
                $scope.LeaveTaken = item.LeaveTaken;
                $scope.LeaveBalance = item.LeaveBalance;
                $scope.LeaveEntitlement = item.LeaveEntitlement;
                $scope.MaleAssociate = parseInt(item.MaleAssociate);
                $scope.FemaleAssociate = parseInt(item.FemaleAssociate);
                $scope.TraineeAssociate = parseInt(item.Trainee);
                if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                    $scope.QRCode = decode_base64(item.QRCode);
                }
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                try {
                    $scope.Emp = $scope.Employee;
                    var myArray1 = $scope.Employeedatas;
                    var item1 = myArray1.filter(function (item1) {
                        return item1.id === $scope.Emp;
                    })[0];

                    $scope.EmployeeName = item1.EmployeeID + '-' + item1.EmployeeName;
                } catch (err) { }

                $scope.Update = true;
                $scope.Leaveform = true;
                $scope.Leavegrid = false;
                $scope.lExport = false;
                $scope.lView = true;
                $scope.lAdd = false;
                $scope.lSearch = false;
                $scope.Leave = true;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
                $scope.NextApprovers = '';

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'HRM Leave Request') {

                        if ($scope.StatusID == value.LevelName) {

                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {

                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {

                    var array = $scope.NextLevelApprovers.split(",");

                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID == array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'HRM Leave Request') {

                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {

                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();

            });

        }
        else {
            $scope.Leaveform = false;
            $scope.Leavegrid = true;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lSearch = true;
            $scope.lView = false;
            $scope.Leave = false;
        }

        $scope.Export = function () {

            alasql('SELECT * INTO XLSX("Leavedatas.xlsx",{headers:true}) FROM ?', [$scope.Leavedatas]);
        };

        $scope.Datefilter = function () {

            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/medical/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {

                $scope.Medicaldatas = GList.data.data;
            });
        }

        $scope.Showgrid = function () {
            $scope.Leavegrid = true;
            $scope.Leaveform = false;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lView = false;
            $scope.lSearch = true;
            $scope.Leave = false;
        }

        function mySplit(string, nb) {
            var array = string.split(';');
            return array[nb];
        }

        $scope.Leaveinfo = function (LeaveId, $index) {


            $scope.IndxID = $index;
            $scope.SID = LeaveId;
            $scope.Update = true;
            $scope.Leaveform = true;
            $scope.Leavegrid = false;
            $scope.lExport = false;
            $scope.lView = true;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.Leave = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();

            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = $scope.Status;
            $scope.NextLevelAction = '';
            $scope.NextApprovers = '';

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            try {
                var LeaveArray = $scope.Leavedatas;
                var item = LeaveArray.filter(function (item) {
                    return item._id === LeaveId;
                })[0];

                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.FromDate = new Date(item.FromDate);
                $scope.ToDate = new Date(item.ToDate);
                $scope.FromDayType = item.FromDayType;
                $scope.ToDayType = item.ToDayType;
                $scope.LeaveType = item.LeaveType;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Reason = item.Reason;
                if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                    $scope.EmergencyContactNo = parseInt(item.EmergencyContactNo);
                }
                $scope.TotalDaysApplied = parseInt(item.TotalDaysApplied);
                $scope.TotalPaidLeaves = parseInt(item.TotalPaidLeaves);
                $scope.TotalUnPaidLeaves = parseInt(item.TotalUnPaidLeaves);
                $scope.LeaveTaken = item.LeaveTaken;
                $scope.LeaveBalance = item.LeaveBalance;
                $scope.LeaveEntitlement = item.LeaveEntitlement;
                $scope.a1 = mySplit(item.LeaveEntitlement, 0);
                $scope.a2 = mySplit(item.LeaveEntitlement, 1);
                $scope.a3 = mySplit(item.LeaveEntitlement, 2);
                $scope.a4 = mySplit(item.LeaveEntitlement, 3);
                $scope.b1 = mySplit(item.LeaveEntitlement, 4);
                $scope.b2 = mySplit(item.LeaveEntitlement, 5);
                $scope.b3 = mySplit(item.LeaveEntitlement, 6);
                $scope.b4 = mySplit(item.LeaveEntitlement, 7);
                $scope.b5 = mySplit(item.LeaveEntitlement, 8);
                $scope.LeaveEntitlement1 = $scope.a1 + ";" + $scope.a2 + ";" + $scope.a3 + ";" + $scope.a4 + ";";
                $scope.LeaveEntitlement2 = $scope.b1 + ";" + $scope.b2 + ";" + $scope.b3 + ";" + $scope.b4 + ";" + $scope.b5 + ";";
                //$scope.MaleAssociate = parseInt(item.MaleAssociate);
                //$scope.FemaleAssociate = parseInt(item.FemaleAssociate);
                //$scope.TraineeAssociate = parseInt(item.Trainee);
                if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                    $scope.QRCode = decode_base64(item.QRCode);
                }
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }


            var male = [];
            angular.forEach($scope.Leavedatas, function (value1) {
                angular.forEach($scope.Employeedatas, function (value2) {
                    $scope.CheckFromDate = new Date(value1.FromDate);
                    $scope.CheckToDate = new Date(value1.ToDate);

                    if ($scope.id == "undefined" || $scope.id == "" || $scope.id == null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value1.Status == "New" || value1.Status == "Reviewed" || value1.Status == "Approved") {
                                if (value1.EmployeeID == value2.id && value2.Gender == "Male") {
                                    male.push({
                                        id: value1._id,
                                        FromDate: value1.FromDate,
                                        ToDate: value1.ToDate,
                                        EmployeeID: value2.EmployeeID,
                                        EmployeeName: value2.EmployeeName,
                                        Gender: value2.Gender,
                                        Eid: value2.id,
                                    })
                                }
                            }
                        }
                    }
                    else if ($scope.id != "undefined" || $scope.id != "" || $scope.id != null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value1.Status == "New" || value1.Status == "Reviewed" || value1.Status == "Approved") {
                                if (value1.EmployeeID == value2.id && value2.Gender == "Male" && $scope.id != value1._id) {
                                    male.push({
                                        id: value1._id,
                                        FromDate: value1.FromDate,
                                        ToDate: value1.ToDate,
                                        EmployeeID: value2.EmployeeID,
                                        EmployeeName: value2.EmployeeName,
                                        Gender: value2.Gender,
                                        Eid: value2.id,
                                    })
                                }
                            }
                        }
                    }
                });
            });

            $scope.malesummary = male;
            $scope.MaleAssociate = $scope.malesummary.length;

            var female = [];
            angular.forEach($scope.Leavedatas, function (value3) {
                angular.forEach($scope.Employeedatas, function (value4) {
                    $scope.CheckFromDate = new Date(value3.FromDate);
                    $scope.CheckToDate = new Date(value3.ToDate);
                    if ($scope.id == "undefined" || $scope.id == "" || $scope.id == null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value3.Status == "New" || value3.Status == "Reviewed" || value3.Status == "Approved") {
                                if (value3.EmployeeID == value4.id && value4.Gender == "Female") {
                                    female.push({
                                        id: value3._id,
                                        FromDate: value3.FromDate,
                                        ToDate: value3.ToDate,
                                        EmployeeID: value4.EmployeeID,
                                        EmployeeName: value4.EmployeeName,
                                        Gender: value4.Gender,
                                        Eid: value4.id,
                                    })
                                }
                            }
                        }
                    }
                    else if ($scope.id != "undefined" || $scope.id != "" || $scope.id != null) {
                        if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                            if (value3.Status == "New" || value3.Status == "Reviewed" || value3.Status == "Approved") {
                                if (value3.EmployeeID == value4.id && value4.Gender == "Female" && $scope.id != value3._id) {
                                    female.push({
                                        id: value3._id,
                                        FromDate: value3.FromDate,
                                        ToDate: value3.ToDate,
                                        EmployeeID: value4.EmployeeID,
                                        EmployeeName: value4.EmployeeName,
                                        Gender: value4.Gender,
                                        Eid: value4.id,
                                    })
                                }
                            }
                        }
                    }
                });
            });

            $scope.femalesummary = female;
            $scope.FemaleAssociate = $scope.femalesummary.length;

            var trainee = [];
            angular.forEach($scope.Courseattendancedatas, function (value5) {
                $scope.CheckFromDate = new Date(value5.AttendanceDate);
                $scope.CheckFromDate.setHours(0, 0, 0, 0);
                if ($scope.id == "undefined" || $scope.id == "" || $scope.id == null) {
                    if ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) {
                        trainee.push({
                            id: value5._id,
                            AttendanceDate: value5.AttendanceDate,
                            EmployeeName: value5.EmployeeName,
                        })
                    }
                }
                else if ($scope.id != "undefined" || $scope.id != "" || $scope.id != null) {
                    if ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) {
                        if ($scope.id != value5._id) {
                            trainee.push({
                                id: value5._id,
                                AttendanceDate: value5.AttendanceDate,
                                EmployeeName: value5.EmployeeName,
                            })
                        }
                    }
                }
            });

            $scope.traineesummary = trainee;
            $scope.TraineeAssociate = $scope.traineesummary.length;


            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'HRM Leave Request') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");

                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'HRM Leave Request') {

                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {

                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
        }

        $scope.commentSubmit = function () {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "HRM Leave Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {

                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm11.$setPristine();
                $scope.basicForm11.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file

            var response = Upload.upload({
                url: $rootScope.WebURL + "/incident/upload",
                data: { file: file }
            }).then(function (resp) {

                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Leave Request",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        $scope.workflow = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.Employee,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        FromDayType: $scope.FromDayType,
                        ToDayType: $scope.ToDayType,
                        LeaveType: $scope.LeaveType,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        Reason: $scope.Reason,
                        EmergencyContactNo: $scope.EmergencyContactNo,
                        TotalDaysApplied: $scope.TotalDaysApplied,
                        TotalPaidLeaves: $scope.TotalPaidLeaves,
                        TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                        LeaveTaken: $scope.LeaveTaken,
                        LeaveBalance: $scope.LeaveBalance,
                        LeaveEntitlement: $scope.LeaveEntitlement,
                        MaleAssociate: $scope.MaleAssociate,
                        FemaleAssociate: $scope.FemaleAssociate,
                        Trainee: $scope.TraineeAssociate,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/leave/email",
                            data: {

                                LeaveID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                FromDate: convertDate($scope.FromDate),
                                ToDate: convertDate($scope.ToDate),
                                FromDayType: $scope.FromDayType,
                                ToDayType: $scope.ToDayType,
                                LeaveType: $scope.LeaveType,
                                Reason: $scope.Reason,
                                EmergencyContactNo: $scope.EmergencyContactNo,
                                TotalDaysApplied: $scope.TotalDaysApplied,
                                TotalPaidLeaves: $scope.TotalPaidLeaves,
                                TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.reject = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.Employee,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        FromDayType: $scope.FromDayType,
                        ToDayType: $scope.ToDayType,
                        LeaveType: $scope.LeaveType,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        Reason: $scope.Reason,
                        EmergencyContactNo: $scope.EmergencyContactNo,
                        TotalDaysApplied: $scope.TotalDaysApplied,
                        TotalPaidLeaves: $scope.TotalPaidLeaves,
                        TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                        LeaveTaken: $scope.LeaveTaken,
                        LeaveBalance: $scope.LeaveBalance,
                        LeaveEntitlement: $scope.LeaveEntitlement,
                        MaleAssociate: $scope.MaleAssociate,
                        FemaleAssociate: $scope.FemaleAssociate,
                        Trainee: $scope.TraineeAssociate,
                        Status: "Rejected",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    //try {
                    //    if (Workflowitem.NotifytoNextLevelApprover == true) {
                    //        try {
                    //            $scope.NLevel = Workflowitem.NextLevel;
                    //            var myArray1 = $scope.Workflowdatas;
                    //            var Workflowitem1 = myArray1.filter(function (item1) {
                    //                return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                    //            })[0];
                    //        } catch (err) {
                    //        }
                    //        try {
                    //            $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                    //            angular.forEach($scope.NApproversArray, function (value) {
                    //                var UserArray4 = $scope.Userdatas;
                    //                var item4 = UserArray4.filter(function (item4) {
                    //                    return item4.UserID === value;
                    //                })[0];
                    //                SenderEmails.push({ Email: item4.Email });
                    //            });
                    //        } catch (err) {
                    //        }
                    //    }
                    //} catch (err) {
                    //}

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/leave/email",
                            data: {

                                LeaveID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                FromDate: convertDate($scope.FromDate),
                                ToDate: convertDate($scope.ToDate),
                                FromDayType: $scope.FromDayType,
                                ToDayType: $scope.ToDayType,
                                LeaveType: $scope.LeaveType,
                                Reason: $scope.Reason,
                                EmergencyContactNo: $scope.EmergencyContactNo,
                                TotalDaysApplied: $scope.TotalDaysApplied,
                                TotalPaidLeaves: $scope.TotalPaidLeaves,
                                TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.revise = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.LevelName != 1 && $scope.StatusID != 1 && $scope.Update == true) {
                //if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.Employee,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        FromDayType: $scope.FromDayType,
                        ToDayType: $scope.ToDayType,
                        LeaveType: $scope.LeaveType,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        Reason: $scope.Reason,
                        EmergencyContactNo: $scope.EmergencyContactNo,
                        TotalDaysApplied: $scope.TotalDaysApplied,
                        TotalPaidLeaves: $scope.TotalPaidLeaves,
                        TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                        LeaveTaken: $scope.LeaveTaken,
                        LeaveBalance: $scope.LeaveBalance,
                        LeaveEntitlement: $scope.LeaveEntitlement,
                        MaleAssociate: $scope.MaleAssociate,
                        FemaleAssociate: $scope.FemaleAssociate,
                        Trainee: $scope.TraineeAssociate,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                    },
                });
                response.then(function (GList) {


                    $scope.Userdata = GList.data.data[0];

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/leave/email",
                            data: {

                                LeaveID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                FromDate: convertDate($scope.FromDate),
                                ToDate: convertDate($scope.ToDate),
                                FromDayType: $scope.FromDayType,
                                ToDayType: $scope.ToDayType,
                                LeaveType: $scope.LeaveType,
                                Reason: $scope.Reason,
                                EmergencyContactNo: $scope.EmergencyContactNo,
                                TotalDaysApplied: $scope.TotalDaysApplied,
                                TotalPaidLeaves: $scope.TotalPaidLeaves,
                                TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Revised!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.cancelreq = function () {

            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNo: $scope.ReferenceNo,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.Employee,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        FromDayType: $scope.FromDayType,
                        ToDayType: $scope.ToDayType,
                        LeaveType: $scope.LeaveType,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        Reason: $scope.Reason,
                        EmergencyContactNo: $scope.EmergencyContactNo,
                        TotalDaysApplied: $scope.TotalDaysApplied,
                        TotalPaidLeaves: $scope.TotalPaidLeaves,
                        TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                        LeaveTaken: $scope.LeaveTaken,
                        LeaveBalance: $scope.LeaveBalance,
                        LeaveEntitlement: $scope.LeaveEntitlement,
                        MaleAssociate: $scope.MaleAssociate,
                        FemaleAssociate: $scope.FemaleAssociate,
                        Trainee: $scope.TraineeAssociate,
                        Status: "Cancelled",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');



                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;

                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/leave/email",
                            data: {

                                LeaveID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                FromDate: convertDate($scope.FromDate),
                                ToDate: convertDate($scope.ToDate),
                                FromDayType: $scope.FromDayType,
                                ToDayType: $scope.ToDayType,
                                LeaveType: $scope.LeaveType,
                                Reason: $scope.Reason,
                                EmergencyContactNo: $scope.EmergencyContactNo,
                                TotalDaysApplied: $scope.TotalDaysApplied,
                                TotalPaidLeaves: $scope.TotalPaidLeaves,
                                TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });


                    //$scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];

                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        function RefreshGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/leave",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leavedata) {

                $scope.Leavedatas = Leavedata.data.data;
            });

        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshCourseattendanceGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/courseattendance",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (courseattendancedata) {
                $scope.Courseattendancedatas = courseattendancedata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {

            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {

                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Leave.aspx?ID=" + PId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.PrintLeave = function (printleave, UniqID) {

            $scope.PrintID = UniqID;

            var LeaveArray = $scope.Leavedatas;
            var item = LeaveArray.filter(function (item) {
                return item.UniqueID === UniqID;
            })[0];

            $scope.id = item._id;
            $scope.ReferenceNo = item.ReferenceNo;
            $scope.UniqueID = item.UniqueID;
            $scope.Employee = item.EmployeeID;
            $scope.FromDate = new Date(item.FromDate);
            $scope.ToDate = new Date(item.ToDate);
            $scope.FromDayType = item.FromDayType;
            $scope.ToDayType = item.ToDayType;
            $scope.LeaveType = item.LeaveType;
            $scope.RequestedByEmployee = item.RequestedEmployee,
                $scope.Reason = item.Reason;
            if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                $scope.EmergencyContactNo = parseInt(item.EmergencyContactNo);
            }
            $scope.TotalDaysApplied = parseInt(item.TotalDaysApplied);
            $scope.TotalPaidLeaves = parseInt(item.TotalPaidLeaves);
            $scope.TotalUnPaidLeaves = parseInt(item.TotalUnPaidLeaves);
            $scope.LeaveTaken = item.LeaveTaken;
            $scope.LeaveBalance = item.LeaveBalance;
            $scope.LeaveEntitlement = item.LeaveEntitlement;
            $scope.MaleAssociate = parseInt(item.MaleAssociate);
            $scope.FemaleAssociate = parseInt(item.FemaleAssociate);
            $scope.TraineeAssociate = parseInt(item.Trainee);
            if (item.QRCode != null && item.QRCode != "" && item.QRCode != undefined) {
                $scope.QRCode = decode_base64(item.QRCode);
            }
            $scope.Status = item.Status;
            $scope.StatusID = parseInt(item.StatusID);

            $scope.Emp = $scope.Employee;
            var myArray1 = $scope.Employeedatas;
            var item1 = myArray1.filter(function (item1) {
                return item1.id === $scope.Emp;
            })[0];

            $scope.EmployeeName = item1.EmployeeID + '-' + item1.EmployeeName;


            //$scope.Pop = true;
            var innerContents = document.getElementById(printleave).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;


        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }
})();




(function ()
{
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.employee', ['flow'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_employee', {
            url      : '/Employee',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/employee/employee.html',
                    controller: 'EmployeeController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmCore/employee');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.employee')
        .controller('EmployeeController', EmployeeController);

    /** @ngInject */
    function EmployeeController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $mdDialog, $document, $http, $log, $filter, $location, $window, $state, Upload, NgMap) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Employee Profile"

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMAdmin")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Employeegrid = true;
        $scope.Export = true;
        $scope.Employeeform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        $scope.ExportData = function () {
            alasql('SELECT * INTO XLSX("Employeedatas.xlsx",{headers:true}) FROM ?', [$scope.Employeedatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

        $scope.loadFile = function (files) {
            $scope.$apply(function () {
                $scope.selectedFile = files[0];
                $scope.handleFile();
            })
        }
        $scope.handleFile = function () {
            var file = $scope.selectedFile;
            if (file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var data = e.target.result;
                    var workbook = XLSX.read(data, { type: 'binary' });
                    var first_sheet_name = workbook.SheetNames[0];
                    var dataObjects = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name]);
                    if (dataObjects.length > 0) {
                        $scope.save(dataObjects, first_sheet_name);
                    } else {
                        $scope.message = "Error : Something Wrong !";
                        showDialog($scope.Event);
                    }
                }
                reader.onerror = function (ex) {
                }

                reader.readAsBinaryString(file);
            }
        }


        $scope.save = function (dataObjects) {
            angular.forEach(dataObjects, function (value, key) {

            });
        }
        $scope.getMartial = function (value) {
            if (value == 'Miss' || value == 'Ms' || value == 'Mrs') {
                $scope.vm.uGender = 'Female';
            }
            else {
                $scope.vm.uGender = 'Male';
            }
        }
        $scope.Employeephoto = [
            { photo: false }]
        $scope.IC = [
            { photo: false }]
        $scope.ICBack = [
            { photo: false }]
        $scope.Passport = [
            { photo: false }]
        $scope.PassportBack = [
            { photo: false }]
        $scope.vm.DeleteEmployee = false;
        $scope.employeepopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/employee/employeepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EmployeeController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.DeleteEmployee = false;
            $scope.deleteID = deleteID;
        }
        $scope.closeaddform = function () {
            $scope.Qualificationdiv = false;
            $scope.Membershipdiv = false;
            $scope.Familydiv = false;
        }
        $scope.Qualificationpopup = function (e) {
            //$mdDialog.show({
            //    templateUrl: 'app/main/apps//human-resource/HcmCore/employee/Qualification.html',
            //    parent: angular.element($document.body),
            //    targetEvent: e,
            //    scope: $scope.$new(),
            //    clickOutsideToClose: true,
            //    controller: function EmployeeController($scope, $mdDialog) {
            //        $scope.closeDialog = function() {
            //            $mdDialog.hide();
            //        }
            //    }
            //});
            $scope.QUpdate = false;
            $scope.vm.QuQualificationsName = null;
            $scope.vm.QuFrom = null;
            $scope.vm.QuTo = null;
            $scope.vm.QuNameofSchoolInstitution = null;
            $scope.vm.QuCountry = null;
            $scope.vm.QuHighestQualificationsAttained = null;
            $scope.Qualificationdiv = true;
        }
        $scope.uShowResigned = false;
        $scope.Qualificationadd = function () {
            if ($scope.QUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeQualification/update",
                    data: {
                        _id: $scope.QID,
                        EmployeeID: $scope.vm.uEmployeeID,
                        QQualificationsName: $scope.vm.QuQualificationsName,
                        QFrom: $scope.vm.QuFrom,
                        QTo: $scope.vm.QuTo,
                        QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                        QCountry: $scope.vm.QuCountry,
                        QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    RefreshGrid();
                    $scope.Qtable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.Qualificationdiv = false;
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeeQualification/add",
                    data: {
                        EmployeeID: $scope.vm.uEmployeeID,
                        QQualificationsName: $scope.vm.QuQualificationsName,
                        QFrom: $scope.vm.QuFrom,
                        QTo: $scope.vm.QuTo,
                        QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                        QCountry: $scope.vm.QuCountry,
                        QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });

                response.then(function (GList) {
                    RefreshGrid();
                    $scope.Qtable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                    $scope.Qualificationdiv = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.getPCD = function (PSD) {
            var d = new Date(PSD)
            $scope.vm.EuProbationCompletionDate = new Date(d.setMonth(new Date().getMonth() + 2));
        }
        $scope.getDoJ = function (PSD) {
            var d = new Date(PSD)
            $scope.vm.EuDateOfJoin = new Date(PSD)
            $scope.vm.EuProbationCompletionDate = new Date(d.setMonth(new Date().getMonth() + 2));
        }
        $scope.Qualificationsupdate = function (e, QId) {
            //$mdDialog.show({
            //    templateUrl: 'app/main/apps//human-resource/HcmCore/employee/Qualification.html',
            //    parent: angular.element($document.body),
            //    targetEvent: e,
            //    scope: $scope.$new(),
            //    clickOutsideToClose: true,
            //    controller: function EmployeeController($scope, $mdDialog) {
            //        $scope.closeDialog = function() {
            //            $mdDialog.hide();
            //        }
            //    }
            //});
            $scope.Qualificationdiv = true;
            $scope.QUpdate = true;
            $scope.QID = QId;
            angular.forEach($scope.EmployeeQualificationdatas, function (value) {
                if (value.id == QId) {
                    $scope.vm.QuQualificationsName = value.QQualificationsName;
                    $scope.vm.QuFrom = value.QFrom;
                    $scope.vm.QuTo = value.QTo;
                    $scope.vm.QuNameofSchoolInstitution = value.QNameofSchoolInstitution;
                    $scope.vm.QuCountry = value.QCountry;
                    $scope.vm.QuHighestQualificationsAttained = value.QHighestQualificationsAttained;
                }
            });
        }
        $scope.Qualificationelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeeQualification/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                RefreshGrid();
                $scope.Employeegrid = false;
                $scope.Employeeform = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.employeeMpopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/employee/employeeMpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EmployeeController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Membershipopup = function (e) {
            $scope.MUpdate = false;
            $scope.vm.uMembershipName = null;
            $scope.vm.uMembershipValidFrom = null;
            $scope.vm.uMembershipValidTo = null;
            $scope.Membershipdiv = true;
        }

        $scope.Membershipadd = function () {
            if ($scope.MUpdate == true) {
                $scope.MUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeMembership/update",
                    data: {
                        _id: $scope.MID,
                        EmployeeID: $scope.vm.uEmployeeID,
                        MembershipName: $scope.vm.uMembershipName,
                        MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                        MembershipValidTo: $scope.vm.uMembershipValidTo,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    RefreshGrid();
                    $scope.Mtable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                    $scope.Membershipdiv = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeeMembership/add",
                    data: {
                        EmployeeID: $scope.vm.uEmployeeID,
                        MembershipName: $scope.vm.uMembershipName,
                        MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                        MembershipValidTo: $scope.vm.uMembershipValidTo,
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {

                    RefreshGrid();
                    $scope.Mtable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                    $scope.Membershipdiv = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Membershipupdate = function (e, MId) {
            $scope.Membershipdiv = true;
            $scope.MUpdate = true;
            $scope.MID = MId;
            angular.forEach($scope.EmployeeMembershipatas, function (value) {
                if (value.id == MId) {
                    $scope.vm.uMembershipName = value.MembershipName;
                    $scope.vm.uMembershipValidFrom = value.MembershipValidFrom;
                    $scope.vm.uMembershipValidTo = value.MembershipValidTo;
                }
            });
        }
        $scope.Membershipelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeeMembership/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                RefreshGrid();
                $scope.Employeegrid = false;
                $scope.Employeeform = true;
                $scope.Add = true;
                $scope.Search = true;
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.employeeFpopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/employee/employeeFpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EmployeeController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }
        $scope.Familypopup = function (e) {
            //$mdDialog.show({
            //    templateUrl: 'app/main/apps//human-resource/HcmCore/employee/Family.html',
            //    parent: angular.element($document.body),
            //    targetEvent: e,
            //    scope: $scope.$new(),
            //    clickOutsideToClose: true, controller: function EmployeeController($scope, $mdDialog) {
            //        $scope.closeDialog = function () {
            //            $mdDialog.hide();
            //        }
            //    }
            //});
            $scope.FUpdate = false;
            $scope.vm.FuName = '';
            $scope.vm.FuDOB = null;
            $scope.vm.FuRelationship = '';
            $scope.vm.FuOccupation = '';
            $scope.vm.FuNationality = '';
            $scope.vm.FuHomeTel = '';
            $scope.vm.FuMobile = '';
            $scope.vm.FuEmail = '';
            $scope.Familydiv = true;
        }
        $scope.Familyadd = function () {
            if ($scope.FUpdate == true) {
                $scope.FUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeeFamily/update",
                    data: {
                        _id: $scope.FID,
                        EmployeeID: $scope.vm.uEmployeeID,
                        FName: $scope.vm.FuName,
                        FDOB: $scope.vm.FuDOB,
                        FRelationship: $scope.vm.FuRelationship,
                        FOccupation: $scope.vm.FuOccupation,
                        FNationality: $scope.vm.FuNationality,
                        FHomeTel: $scope.vm.FuHomeTel,
                        FMobile: $scope.vm.FuMobile,
                        FEmail: $scope.vm.FuEmail,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    RefreshGrid();
                    $scope.Ftable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                    $scope.Familydiv = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeeFamily/add",
                    data: {
                        EmployeeID: $scope.vm.uEmployeeID,
                        FName: $scope.vm.FuName,
                        FDOB: $scope.vm.FuDOB,
                        FRelationship: $scope.vm.FuRelationship,
                        FOccupation: $scope.vm.FuOccupation,
                        FNationality: $scope.vm.FuNationality,
                        FHomeTel: $scope.vm.FuHomeTel,
                        FMobile: $scope.vm.FuMobile,
                        FEmail: $scope.vm.FuEmail,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    RefreshGrid();
                    $scope.Ftable = true;
                    $scope.Employeegrid = false;
                    $scope.Employeeform = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                    $scope.Familydiv = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Familyupdate = function (e, FId) {
            //$mdDialog.show({
            //    templateUrl: 'app/main/apps//human-resource/HcmCore/employee/Family.html',
            //    parent: angular.element($document.body),
            //    targetEvent: e,
            //    scope: $scope.$new(),
            //    clickOutsideToClose: true,
            //    controller: function EmployeeController($scope, $mdDialog) {
            //        $scope.closeDialog = function () {
            //            $mdDialog.hide();
            //        }
            //    }
            //});
            $scope.Familydiv = true;
            $scope.FUpdate = true;
            $scope.FID = FId;
            angular.forEach($scope.EmployeeFamilyatas, function (value) {
                if (value.id == FId) {
                    $scope.vm.FuName = value.FName;
                    $scope.vm.FuDOB = value.FDOB;
                    $scope.vm.FuRelationship = value.FRelationship;
                    $scope.vm.FuOccupation = value.FOccupation;
                    $scope.vm.FuNationality = value.FNationality;
                    $scope.vm.FuHomeTel = parseInt(value.FHomeTel);
                    $scope.vm.FuMobile = parseInt(value.FMobile);
                    $scope.vm.FuEmail = value.FEmail;
                }
            });
        }
        $scope.Familydelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeeFamily/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                RefreshGrid();
                $scope.Employeegrid = false;
                $scope.Employeeform = true;
                $scope.Add = true;
                $scope.Search = true;
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Employeeinfo = function (EmployeeId) {
            $scope.SID = EmployeeId;
            $scope.Update = true;
            $scope.Employeeform = true;
            $scope.Employeegrid = false;
            $scope.tabnext = true;
            $scope.tabsubmit = false;
            $scope.tabnext1 = false;
            $scope.EmployeeinfoId = EmployeeId;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
            $scope.Qtable = true;
            $scope.Mtable = true;
            $scope.Ftable = true;
            $scope.error2 = false;
            $scope.error1 = false;
            Visatype();
            RefreshAttach(null)
            angular.forEach($scope.Employeedatas, function (evalue) {
                if (evalue.id == EmployeeId) {
                    $scope.vm.uEmployeeID = evalue.EmployeeID;
                    $scope.vm.uSalutation = evalue.Salutation;
                    $scope.vm.uEmployeeName = evalue.EmployeeName;
                    $scope.vm.uEmployeeFullName = evalue.EmployeeFullName;
                    $scope.vm.uGender = evalue.Gender;
                    $scope.vm.uMaritalStatus = evalue.MaritalStatus;
                    $scope.vm.uCitizenship = evalue.Citizenship;
                    $scope.vm.uRace = evalue.Race;
                    $scope.vm.uVisaType = evalue.VisaType;
                    $scope.vm.uPlaceofBirth = evalue.PlaceofBirth;
                    $scope.vm.uDateofBirth = evalue.DateofBirth;
                    $scope.vm.uDrivinglicense = evalue.Drivinglicense;
                    $scope.vm.uDrivingLicenseExpiryDate = evalue.DrivingLicenseExpiryDate;
                    $scope.vm.uNRICNumber = evalue.NRICNumber;
                    $scope.vm.uNRICIssuedDate = evalue.NRICIssuedDate;
                    $scope.vm.uNRICExpiryDate = evalue.NRICExpiryDate;
                    $scope.vm.permitIssueDate = evalue.PermitIssueDate;
                    $scope.vm.permitExpiryDate = evalue.PermitExpiryDate;
                    $scope.vm.uWorkPermitNumber = evalue.WorkPermitNumber;
                    $scope.vm.uPassportNo = evalue.PassportNo;
                    $scope.vm.uPassportIssuedPlace = evalue.PassportIssuedPlace;
                    $scope.vm.uPassportIssuedDate = evalue.PassportIssuedDate;
                    $scope.vm.uWorkPassExpiryDate = evalue.WorkPassExpiryDate;
                    $scope.vm.CuResidentialAddress = evalue.ResidentialAddress;
                    $scope.vm.CuUnitBuilding = evalue.UnitBuilding;
                    $scope.vm.CuPostal = parseInt(evalue.Postal);
                    $scope.vm.CuCountry = evalue.Country;
                    $scope.vm.CuHomeTel = parseInt(evalue.HomeTel);
                    $scope.vm.CuMobile = parseInt(evalue.Mobile);
                    $scope.vm.CuEmail = evalue.Email;
                    $scope.vm.uPermanentResidentialAddress = evalue.PermanentResidentialAddress;
                    $scope.vm.CuOUnitBuilding = evalue.OUnitBuilding;
                    $scope.vm.CuOPostalZip = parseInt(evalue.OPostalZip);
                    $scope.vm.CuOCountry = evalue.OCountry;
                    $scope.vm.CuOContactNo = parseInt(evalue.OContactNo);
                    $scope.vm.EuDesignation = evalue.EDesignation;
                    $scope.vm.EuCostCenter = evalue.ECostCenter;
                    $scope.vm.EuDivision = evalue.EDivision;
                    $scope.vm.EuJobCategory = evalue.EJobCategory;
                    $scope.vm.EuTeam = evalue.ETeam;
                    $scope.vm.uVCTLicenseDate = evalue.VCTLicenseDate;
                    $scope.vm.uVCTExpiryDate = evalue.VCTExpiryDate;
                    $scope.vm.uDLicenseIssueDate = evalue.DLicenseIssueDate;
                    $scope.vm.uDLClass = evalue.DLClass;
                    $scope.vm.EuEmploymentStatus = evalue.EEmploymentStatus;
                    if (evalue.ESupervisor != null && evalue.ESupervisor != undefined && evalue.ESupervisor != "") {
                        var item = $scope.Employeedataselect.filter(function (item) {
                            return evalue.ESupervisor.includes(item.id)
                        })
                        if (item != undefined)
                            $scope.vm.EuSupervisor = item;
                        else $scope.vm.EuSupervisor = []
                    }
                    else $scope.vm.EuSupervisor = []
                    $scope.vm.EuHOD = evalue.EHOD;
                    $scope.vm.EuPeer = evalue.EPeer;
                    $scope.vm.EuProbationStartDate = evalue.EProbationStartDate;
                    $scope.vm.EuProbationCompletionDate = evalue.EProbationCompletionDate;
                    $scope.vm.EuDateOfJoin = evalue.EDateOfJoin;
                    $scope.vm.uSkill = evalue.Skill;
                    if ($scope.vm.uSkill != null && $scope.vm.uSkill != "" && $scope.vm.uSkill != undefined) {
                        var array = $scope.vm.uSkill.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ Name: value });
                        });
                        $scope.vm.uSkill = array1;
                    }
                    $scope.vm.QLicenceName = evalue.QLicenceName;
                    $scope.vm.QLicenceStartDate = evalue.QLicenceStartDate;
                    $scope.vm.QLicenceEndDate = evalue.QLicenceEndDate;
                    $scope.vm.uLanguageSpoken = evalue.LanguageSpoken;

                    if ($scope.vm.uLanguageSpoken != null && $scope.vm.uLanguageSpoken != "" && $scope.vm.uLanguageSpoken != undefined) {
                        var array = $scope.vm.uLanguageSpoken.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ LanguageName: value });
                        });
                        $scope.vm.uLanguageSpoken = array1;
                    }
                    $scope.vm.uLanguageWritten = evalue.LanguageWritten;
                    if ($scope.vm.uLanguageWritten != null && $scope.vm.uLanguageWritten != "" && $scope.vm.uLanguageWritten != undefined) {
                        var array = $scope.vm.uLanguageWritten.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ LanguageName: value });
                        });
                        $scope.vm.uLanguageWritten = array1;
                    }

                    $scope.vm.uName = evalue.Name;
                    $scope.vm.NRelationship = evalue.NRelationship;
                    $scope.vm.NHomeTel = parseInt(evalue.NHomeTel);
                    $scope.vm.NOfficeTel = parseInt(evalue.NOfficeTel);
                    $scope.vm.NMobile = parseInt(evalue.NMobile);
                    $scope.vm.NEmail = evalue.NEmail;
                    $scope.vm.uLiability = evalue.Liability;
                    $scope.vm.uNSType = evalue.NSType;
                    $scope.vm.uVocation = evalue.Vocation;
                    $scope.vm.uUnitAttachedTo = evalue.UnitAttachedTo;
                    $scope.vm.uCurrentNSStatus = evalue.rrentNSStatus;
                    $scope.vm.uHighestRankAttained = evalue.HighestRankAttained;
                    $scope.vm.uEnlistmentDate = evalue.EnlistmentDate;
                    $scope.vm.uORDDate = evalue.ORDDate;
                    $scope.vm.uNextReservistDate = evalue.NextReservistDate;
                    $scope.vm.uYearofAward = parseInt(evalue.YearofAward);
                    $scope.vm.uDescription = evalue.Description;
                    $scope.vm.uValueofAward = evalue.ValueofAward;
                    $scope.vm.uStartDateofBond = evalue.StartDateofBond;
                    $scope.vm.uEndDateofBond = evalue.EndDateofBond;
                    $scope.vm.uHobbies = evalue.Hobbies;
                    $scope.vm.uWorkWeekCode = evalue.WorkWeekCode;
                    $scope.vm.uWorkWeekDescription = evalue.WorkWeekDescription;
                    $scope.vm.Annual = parseInt(evalue.Annual);
                    $scope.vm.Adoption = parseInt(evalue.Adoption);
                    $scope.vm.ChildCare = parseInt(evalue.ChildCare);
                    $scope.vm.Maternity = parseInt(evalue.Maternity);
                    $scope.vm.Paternity = parseInt(evalue.Paternity);
                    $scope.vm.Sharedparentalleave = parseInt(evalue.Sharedparentalleave);
                    $scope.vm.SickHospitalisation = parseInt(evalue.SickHospitalisation);
                    $scope.vm.SickNonHospitalisation = parseInt(evalue.SickNonHospitalisation);
                    $scope.vm.UnpaidLeavr = parseInt(evalue.UnpaidLeavr);
                    $scope.vm.RuResignationofDate = evalue.RResignationofDate;
                    $scope.vm.RuReason = evalue.RReason;
                    $scope.vm.RuOtherReason = evalue.ROtherReason;
                    $scope.vm.RuRemarks = evalue.RRemarks;
                    $scope.vm.ResignationStatus = evalue.ResignationStatus;

                    $scope.Photo = evalue.Photo;
                    $scope.ICFront = evalue.ICFront;
                    $scope.uICBack = evalue.ICBack;
                    $scope.PassportFront = evalue.PassportFront;
                    $scope.uPassportBack = evalue.PassportBack;
                }
            });
        }
        $scope.ShowResigned = function (ShowResigned) {
            $scope.TotalEmployeedatas = undefined;
            if (ShowResigned == true) {
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.IsActive === false;
                });
                $scope.TotalEmployeedatas = item;
            }
            else {
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.IsActive === true;
                });
                $scope.TotalEmployeedatas = item;
            }
        }
        $scope.ExitInterview = function (EmployeeId) {
            var EIdata = [];
            EIdata.push({
                Employee_id: EmployeeId,
                ResignationStatus: $scope.vm.ResignationStatus,
                RuResignationofDate: $scope.vm.RuResignationofDate,
                RuReason: $scope.vm.RuReason,
                RuOtherReason: $scope.vm.RuOtherReason,
                RuRemarks: $scope.vm.RuRemarks,
            })
            $window.localStorage.setItem('idForExitInterview', JSON.stringify(EIdata[0]));
            $state.go('app.pages_form_exit');
        }
        $scope.uploader = {};
        $scope.sSubmit = function () {
            if ($scope.vm.uSkill != null && $scope.vm.uSkill != "" && $scope.vm.uSkill != undefined) {
                $scope.vm.uSkill = $scope.vm.uSkill.map(function (obj) { return obj.Name; }).join(',');
            }
            if ($scope.vm.uLanguageSpoken != null && $scope.vm.uLanguageSpoken != "" && $scope.vm.uLanguageSpoken != undefined) {
                $scope.vm.uLanguageSpoken = $scope.vm.uLanguageSpoken.map(function (obj) { return obj.LanguageName; }).join(',');
            }
            if ($scope.vm.uLanguageWritten != null && $scope.vm.uLanguageWritten != "" && $scope.vm.uLanguageWritten != undefined) {
                $scope.vm.uLanguageWritten = $scope.vm.uLanguageWritten.map(function (obj) { return obj.LanguageName; }).join(',');
            }
            $scope.Employeeupload = null
            $scope.ICupload = null
            $scope.ICBackupload = null
            $scope.Passportupload = null
            $scope.PassportBackupload = null
            // var data = new FormData();
            // var reader = new FileReader();
            // $scope.Employeeupload = document.getElementById('Employeeupload');
            // $scope.ICupload = document.getElementById('ICupload');
            // $scope.ICBackupload = document.getElementById('ICBackupload');
            // $scope.Passportupload = document.getElementById('Passportupload');
            // $scope.PassportBackupload = document.getElementById('PassportBackupload');
            // if ($scope.Employeeupload.src == null || $scope.Employeeupload.src == "" || $scope.Employeeupload.src == undefined) {
            //     $scope.Employeeupload = { src: null };
            //     if ($scope.Photo != null || $scope.Photo != "" || $scope.Photo == undefined) {
            //         $scope.Employeeupload = { src: $scope.Photo };
            //     }
            // }
            // if ($scope.ICupload.src == null || $scope.ICupload.src == "" || $scope.ICupload.src == undefined) {
            //     $scope.ICupload = { src: null };
            //     if ($scope.ICFront != null || $scope.ICFront != "" || $scope.ICFront == undefined) {
            //         $scope.ICupload = { src: $scope.ICFront };
            //     }
            // }

            // if ($scope.ICBackupload.src == null || $scope.ICBackupload.src == "" || $scope.ICBackupload.src == undefined) {
            //     $scope.ICBackupload = { src: null };
            //     if ($scope.uICBack != null || $scope.uICBack != "" || $scope.uICBack == undefined) {
            //         $scope.ICBackupload = { src: $scope.uICBack };
            //     }
            // }
            // if ($scope.Passportupload.src == null || $scope.Passportupload.src == "" || $scope.Passportupload.src == undefined) {
            //     $scope.Passportupload = { src: null };
            //     if ($scope.PassportFront != null || $scope.PassportFront != "" || $scope.PassportFront == undefined) {
            //         $scope.Passportupload = { src: $scope.PassportFront };
            //     }
            // }
            // if ($scope.PassportBackupload.src == null || $scope.PassportBackupload.src == "" || $scope.PassportBackupload.src == undefined) {
            //     $scope.PassportBackupload = { src: null };
            //     if ($scope.uPassportBack != null || $scope.uPassportBack != "" || $scope.uPassportBack == undefined) {
            //         $scope.PassportBackupload = { src: $scope.uPassportBack };
            //     }
            // }
            var EuSupervisor = [];
            if ($scope.vm.EuSupervisor != null && $scope.vm.EuSupervisor != "" && $scope.vm.EuSupervisor != undefined) {
                EuSupervisor = $scope.vm.EuSupervisor.map(function (o) { return o.id })
            }
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employee/update",
                    data: {
                        _id: $scope.SID,
                        EmployeeID: $scope.vm.uEmployeeID,
                        Salutation: $scope.vm.uSalutation,
                        EmployeeName: $scope.vm.uEmployeeName,
                        EmployeeFullName: $scope.vm.uEmployeeFullName,
                        Gender: $scope.vm.uGender,
                        MaritalStatus: $scope.vm.uMaritalStatus,
                        Citizenship: $scope.vm.uCitizenship,
                        Race: $scope.vm.uRace,
                        VisaType: $scope.vm.uVisaType,
                        PlaceofBirth: $scope.vm.uPlaceofBirth,
                        DateofBirth: $scope.vm.uDateofBirth,
                        Drivinglicense: $scope.vm.uDrivinglicense,
                        DrivingLicenseExpiryDate: $scope.vm.uDrivingLicenseExpiryDate,
                        NRICNumber: $scope.vm.uNRICNumber,
                        NRICIssuedDate: $scope.vm.uNRICIssuedDate,
                        NRICExpiryDate: $scope.vm.uNRICExpiryDate,
                        PermitIssueDate: $scope.vm.permitIssueDate,
                        PermitExpiryDate: $scope.vm.permitExpiryDate,
                        WorkPermitNumber: $scope.vm.uWorkPermitNumber,
                        PassportNo: $scope.vm.uPassportNo,
                        PassportIssuedPlace: $scope.vm.uPassportIssuedPlace,
                        PassportIssuedDate: $scope.vm.uPassportIssuedDate,
                        WorkPassExpiryDate: $scope.vm.uWorkPassExpiryDate,
                        VCTLicenseDate: $scope.vm.uVCTLicenseDate,
                        VCTExpiryDate: $scope.vm.uVCTExpiryDate,
                        DLicenseIssueDate: $scope.vm.uDLicenseIssueDate,
                        DLClass: $scope.vm.uDLClass,
                        ResidentialAddress: $scope.vm.CuResidentialAddress,
                        UnitBuilding: $scope.vm.CuUnitBuilding,
                        Postal: $scope.vm.CuPostal,
                        Country: $scope.vm.CuCountry,
                        HomeTel: $scope.vm.CuHomeTel,
                        Mobile: $scope.vm.CuMobile,
                        Email: $scope.vm.CuEmail,
                        PermanentResidentialAddress: $scope.vm.uPermanentResidentialAddress,
                        OUnitBuilding: $scope.vm.CuOUnitBuilding,
                        OPostalZip: $scope.vm.CuOPostalZip,
                        OCountry: $scope.vm.CuOCountry,
                        OContactNo: $scope.vm.CuOContactNo,
                        EDesignation: $scope.vm.EuDesignation,
                        ECostCenter: $scope.vm.EuCostCenter,
                        EDivision: $scope.vm.EuDivision,
                        EJobCategory: $scope.vm.EuJobCategory,
                        ETeam: $scope.vm.EuTeam,
                        EEmploymentStatus: $scope.vm.EuEmploymentStatus,
                        ESupervisor: EuSupervisor,
                        EHOD: $scope.vm.EuHOD,
                        EPeer: $scope.vm.EuPeer,
                        EProbationStartDate: $scope.vm.EuProbationStartDate,
                        EProbationCompletionDate: $scope.vm.EuProbationCompletionDate,
                        EDateOfJoin: $scope.vm.EuDateOfJoin,
                        QQualificationsName: $scope.vm.QuQualificationsName,
                        QFrom: $scope.vm.QuFrom,
                        QTo: $scope.vm.QuTo,
                        QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                        QCountry: $scope.vm.QuCountry,
                        QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                        Skill: $scope.vm.uSkill,
                        QLicenceName: $scope.vm.QLicenceName,
                        QLicenceStartDate: $scope.vm.QLicenceStartDate,
                        QLicenceEndDate: $scope.vm.QLicenceEndDate,
                        LanguageSpoken: $scope.vm.uLanguageSpoken,
                        LanguageWritten: $scope.vm.uLanguageWritten,
                        MembershipName: $scope.vm.uMembershipName,
                        MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                        MembershipValidTo: $scope.vm.uMembershipValidTo,
                        FName: $scope.vm.FuName,
                        FDOB: $scope.vm.FuDOB,
                        FRelationship: $scope.vm.FuRelationship,
                        FOccupation: $scope.vm.FuOccupation,
                        FNationality: $scope.vm.FuNationality,
                        FHomeTel: $scope.vm.FuHomeTel,
                        FMobile: $scope.vm.FuMobile,
                        FEmail: $scope.vm.FuEmail,
                        Name: $scope.vm.uName,
                        NRelationship: $scope.vm.NRelationship,
                        NHomeTel: $scope.vm.NHomeTel,
                        NOfficeTel: $scope.vm.NOfficeTel,
                        NMobile: $scope.vm.NMobile,
                        NEmail: $scope.vm.NEmail,
                        Liability: $scope.vm.uLiability,
                        NSType: $scope.vm.uNSType,
                        Vocation: $scope.vm.uVocation,
                        UnitAttachedTo: $scope.vm.uUnitAttachedTo,
                        rrentNSStatus: $scope.vm.uCurrentNSStatus,
                        HighestRankAttained: $scope.vm.uHighestRankAttained,
                        EnlistmentDate: $scope.vm.uEnlistmentDate,
                        ORDDate: $scope.vm.uORDDate,
                        NextReservistDate: $scope.vm.uNextReservistDate,
                        YearofAward: $scope.vm.uYearofAward,
                        Description: $scope.vm.uDescription,
                        ValueofAward: $scope.vm.uValueofAward,
                        StartDateofBond: $scope.vm.uStartDateofBond,
                        EndDateofBond: $scope.vm.uEndDateofBond,
                        Hobbies: $scope.vm.uHobbies,
                        WorkWeekCode: $scope.vm.uWorkWeekCode,
                        WorkWeekDescription: $scope.vm.uWorkWeekDescription,
                        Annual: $scope.vm.Annual,
                        Adoption: $scope.vm.Adoption,
                        ChildCare: $scope.vm.ChildCare,
                        Maternity: $scope.vm.Maternity,
                        Paternity: $scope.vm.Paternity,
                        Sharedparentalleave: $scope.vm.Sharedparentalleave,
                        SickHospitalisation: $scope.vm.SickHospitalisation,
                        SickNonHospitalisation: $scope.vm.SickNonHospitalisation,
                        UnpaidLeavr: $scope.vm.UnpaidLeavr,
                        RResignationofDate: $scope.vm.RuResignationofDate,
                        RReason: $scope.vm.RuReason,
                        ROtherReason: $scope.vm.RuOtherReason,
                        RRemarks: $scope.vm.RuRemarks,
                        Photo: $scope.Employeeupload,
                        ICFront: $scope.ICupload,
                        ICBack: $scope.ICBackupload,
                        PassportFront: $scope.Passportupload,
                        PassportBack: $scope.PassportBackupload,
                        UpdatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing Display Name") {
                        $scope.error2 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Display Name !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else if (GList.data.message == "Existing Employee Name") {
                        $scope.error2 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Employee Name !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        RefreshGrid();
                        $scope.Employeegrid = true;
                        $scope.Export = true;
                        $scope.Employeeform = false;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee/add",
                    data: {
                        EmployeeID: $scope.vm.uEmployeeID,
                        Salutation: $scope.vm.uSalutation,
                        EmployeeName: $scope.vm.uEmployeeName,
                        EmployeeFullName: $scope.vm.uEmployeeFullName,
                        Gender: $scope.vm.uGender,
                        MaritalStatus: $scope.vm.uMaritalStatus,
                        Citizenship: $scope.vm.uCitizenship,
                        Race: $scope.vm.uRace,
                        VisaType: $scope.vm.uVisaType,
                        PlaceofBirth: $scope.vm.uPlaceofBirth,
                        DateofBirth: $scope.vm.uDateofBirth,
                        Drivinglicense: $scope.vm.uDrivinglicense,
                        DrivingLicenseExpiryDate: $scope.vm.uDrivingLicenseExpiryDate,
                        NRICNumber: $scope.vm.uNRICNumber,
                        NRICIssuedDate: $scope.vm.uNRICIssuedDate,
                        NRICExpiryDate: $scope.vm.uNRICExpiryDate,
                        PermitIssueDate: $scope.vm.permitIssueDate,
                        PermitExpiryDate: $scope.vm.permitExpiryDate,
                        WorkPermitNumber: $scope.vm.uWorkPermitNumber,
                        PassportNo: $scope.vm.uPassportNo,
                        PassportIssuedPlace: $scope.vm.uPassportIssuedPlace,
                        PassportIssuedDate: $scope.vm.uPassportIssuedDate,
                        WorkPassExpiryDate: $scope.vm.uWorkPassExpiryDate,
                        VCTLicenseDate: $scope.vm.uVCTLicenseDate,
                        VCTExpiryDate: $scope.vm.uVCTExpiryDate,
                        DLicenseIssueDate: $scope.vm.uDLicenseIssueDate,
                        DLClass: $scope.vm.uDLClass,
                        ResidentialAddress: $scope.vm.CuResidentialAddress,
                        UnitBuilding: $scope.vm.CuUnitBuilding,
                        Postal: $scope.vm.CuPostal,
                        Country: $scope.vm.CuCountry,
                        HomeTel: $scope.vm.CuHomeTel,
                        Mobile: $scope.vm.CuMobile,
                        Email: $scope.vm.CuEmail,
                        PermanentResidentialAddress: $scope.vm.uPermanentResidentialAddress,
                        OUnitBuilding: $scope.vm.CuOUnitBuilding,
                        OPostalZip: $scope.vm.CuOPostalZip,
                        OCountry: $scope.vm.CuOCountry,
                        OContactNo: $scope.vm.CuOContactNo,
                        EDesignation: $scope.vm.EuDesignation,
                        ECostCenter: $scope.vm.EuCostCenter,
                        EDivision: $scope.vm.EuDivision,
                        EJobCategory: $scope.vm.EuJobCategory,
                        ETeam: $scope.vm.EuTeam,
                        EEmploymentStatus: $scope.vm.EuEmploymentStatus,
                        ESupervisor: EuSupervisor,
                        EHOD: $scope.vm.EuHOD,
                        EPeer: $scope.vm.EuPeer,
                        EProbationStartDate: $scope.vm.EuProbationStartDate,
                        EProbationCompletionDate: $scope.vm.EuProbationCompletionDate,
                        EDateOfJoin: $scope.vm.EuDateOfJoin,
                        QQualificationsName: $scope.vm.QuQualificationsName,
                        QFrom: $scope.vm.QuFrom,
                        QTo: $scope.vm.QuTo,
                        QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                        QCountry: $scope.vm.QuCountry,
                        QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                        Skill: $scope.vm.uSkill,
                        QLicenceName: $scope.vm.QLicenceName,
                        QLicenceStartDate: $scope.vm.QLicenceStartDate,
                        QLicenceEndDate: $scope.vm.QLicenceEndDate,
                        LanguageSpoken: $scope.vm.uLanguageSpoken,
                        LanguageWritten: $scope.vm.uLanguageWritten,
                        MembershipName: $scope.vm.uMembershipName,
                        MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                        MembershipValidTo: $scope.vm.uMembershipValidTo,
                        FName: $scope.vm.FuName,
                        FDOB: $scope.vm.FuDOB,
                        FRelationship: $scope.vm.FuRelationship,
                        FOccupation: $scope.vm.FuOccupation,
                        FNationality: $scope.vm.FuNationality,
                        FHomeTel: $scope.vm.FuHomeTel,
                        FMobile: $scope.vm.FuMobile,
                        FEmail: $scope.vm.FuEmail,
                        Name: $scope.vm.uName,
                        NRelationship: $scope.vm.NRelationship,
                        NHomeTel: $scope.vm.NHomeTel,
                        NOfficeTel: $scope.vm.NOfficeTel,
                        NMobile: $scope.vm.NMobile,
                        NEmail: $scope.vm.NEmail,
                        Liability: $scope.vm.uLiability,
                        NSType: $scope.vm.uNSType,
                        Vocation: $scope.vm.uVocation,
                        UnitAttachedTo: $scope.vm.uUnitAttachedTo,
                        rrentNSStatus: $scope.vm.uCurrentNSStatus,
                        HighestRankAttained: $scope.vm.uHighestRankAttained,
                        EnlistmentDate: $scope.vm.uEnlistmentDate,
                        ORDDate: $scope.vm.uORDDate,
                        NextReservistDate: $scope.vm.uNextReservistDate,
                        YearofAward: $scope.vm.uYearofAward,
                        Description: $scope.vm.uDescription,
                        ValueofAward: $scope.vm.uValueofAward,
                        StartDateofBond: $scope.vm.uStartDateofBond,
                        EndDateofBond: $scope.vm.uEndDateofBond,
                        Hobbies: $scope.vm.uHobbies,
                        WorkWeekCode: $scope.vm.uWorkWeekCode,
                        WorkWeekDescription: $scope.vm.uWorkWeekDescription,
                        Annual: $scope.vm.Annual,
                        Adoption: $scope.vm.Adoption,
                        ChildCare: $scope.vm.ChildCare,
                        Maternity: $scope.vm.Maternity,
                        Paternity: $scope.vm.Paternity,
                        Sharedparentalleave: $scope.vm.Sharedparentalleave,
                        SickHospitalisation: $scope.vm.SickHospitalisation,
                        SickNonHospitalisation: $scope.vm.SickNonHospitalisation,
                        UnpaidLeavr: $scope.vm.UnpaidLeavr,
                        RResignationofDate: $scope.vm.RuResignationofDate,
                        RReason: $scope.vm.RuReason,
                        ROtherReason: $scope.vm.RuOtherReason,
                        RRemarks: $scope.vm.RuRemarks,

                        Photo: $scope.Employeeupload,
                        ICFront: $scope.ICupload,
                        ICBack: $scope.ICBackupload,
                        PassportFront: $scope.Passportupload,
                        PassportBack: $scope.PassportBackupload,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },

                });

                response.then(function (GList) {
                    if (GList.data.message == "Existing NRICNumber") {
                        $scope.error1 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing NRIC/FIN Number !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else if (GList.data.message == "Existing Display Name") {
                        $scope.error2 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Display Name !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else if (GList.data.message == "Existing Employee Name") {
                        $scope.error2 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Employee Name !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else if (GList.data.message == "Existing PassportNo") {
                        $scope.error2 = true;
                        $mdToast.show($mdToast.simple().textContent('Existing PassportNo Number !').position('top center'));
                        $scope.Employeeform = true;
                        $scope.Employeegrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        UpdateFileID(GList.data.data.id)
                        RefreshGrid();
                        $scope.Employeegrid = true;
                        $scope.Export = true;
                        $scope.Employeeform = false;
                        $scope.view = false;
                        $scope.Add = true;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        function UpdateFileID(id) {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/attachment/updateFileID',
                data: { FileID: id, TableName: 'Employee', UniqueID: $scope.SID }
            }).then(function (List) {
            })

        }
        $scope.DeleteEmployeepopup = function (item, e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/employee/employeepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EmployeeController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.DeleteEmployeeId = item.id;
            $scope.vm.DeleteEmployee = true;
        }
        $scope.DeleteEmployee = function () {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/delete",
                data: {
                    _id: $scope.DeleteEmployeeId,
                },
            }).then(function (GList) {
                $scope.DeleteEmployeeId = null;
                $scope.vm.DeleteEmployee = false;
                $mdDialog.cancel();
                RefreshGrid();
                $scope.Employeegrid = true;
                $scope.Export = true;
                $scope.Employeeform = false;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            $scope.Employeegrid = true;
            $scope.Employeeform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.QUpdate = false;
            $scope.MUpdate = false;
            $scope.FUpdate = false;
        }
        $scope.sAdd = function () {
            debugger

            ClearForm();
            Visatype();
            RefreshAttach(null)
            try {
                if ($scope.LastEId.length != 0) {
                    var y = $scope.LastEId[0].EmployeeID;
                    $scope.vm.uEmployeeID = parseInt(y) + 1;
                }
                else {
                    var info = $scope.EmployeeLengthdatas
                    for (var x = 1001; x <= 1001 + info.length; x++) {
                        var y = x;
                    }
                    $scope.vm.uEmployeeID = y;
                }
                if ($scope.LastEId.length == undefined) { $scope.vm.uEmployeeID = 1001; }
            }
            catch (e) { }
            //var info = $scope.EmployeeLengthdatas
            //for (var x = 1001; x <= 1001 + info.length; x++) {
            //    var y = x;}
            var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 6; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.SID = pass;

            $scope.vm.Annual = 0;
            $scope.vm.Adoption = 0;
            $scope.vm.ChildCare = 0;
            $scope.vm.Maternity = 0;
            $scope.vm.Paternity = 0;
            $scope.vm.Sharedparentalleave = 0;
            $scope.vm.SickHospitalisation = 0;
            $scope.vm.SickNonHospitalisation = 0;
            $scope.vm.UnpaidLeavr = 0;
            $scope.Qualificationdiv = false;
            $scope.Membershipdiv = false;
            $scope.Familydiv = false;
            $scope.uShowResigned = false;
            $scope.Update = false;
            $scope.Employeeform = true;
            $scope.Employeegrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.QUpdate = false;
            $scope.MUpdate = false;
            $scope.FUpdate = false;
            $scope.Qtable = false;
            $scope.Mtable = false;
            $scope.Ftable = false;
            $scope.EmployeeQualificationdatas = null;
            $scope.EmployeeMembershipatas = null;
            $scope.EmployeeFamilyatas = null;
            $scope.error1 = false;
            $scope.error2 = false;
            $scope.Photo = null;
            $scope.ICFront = null;
            $scope.uICBack = null;
            $scope.PassportFront = null;
            $scope.uPassportBack = null;

        }
        $scope.workweek = function (wwc) {
            angular.forEach($scope.Workweekdatas, function (value) {

                if (value.WorkWeekCode == wwc)
                    $scope.vm.uWorkWeekDescription = value.WorkWeekDescription;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/LastEId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (edata) {
            $scope.LastEId = edata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/language",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (languagedata) {
            $scope.Languagesdatas = languagedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/costcentre",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (costcentredata) {
            $scope.Costcentredatas = costcentredata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/division",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/workweek",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Workweekdata) {
            $scope.Workweekdatas = Workweekdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/education",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Educationdata) {
            $scope.Educationdatas = Educationdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/license",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Licensedata) {
            $scope.Licensedatas = Licensedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/jobtitle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (JobTitledata) {
            $scope.JobTitledatas = JobTitledata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/jobcategories",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (JobCategoriesdata) {
            $scope.JobCategoriesdatas = JobCategoriesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employmentstatus",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (EmploymentStatusdata) {
            $scope.EmploymentStatusdatas = EmploymentStatusdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
            $scope.EmployeeLengthdatas = Employeedata.data.data;
            angular.forEach($scope.Employeedatas, function (employee) {
                if (employee.Photo != null && employee.Photo != "" && employee.Photo != undefined) {
                    employee.Photo = decode_base64(employee.Photo);
                }
                if (employee.ICFront != null && employee.ICFront != "" && employee.ICFront != undefined) {
                    employee.ICFront = decode_base64(employee.ICFront);
                }
                if (employee.ICBack != null && employee.ICBack != "" && employee.ICBack != undefined) {
                    employee.ICBack = decode_base64(employee.ICBack);
                }
                if (employee.PassportFront != null && employee.PassportFront != "" && employee.PassportFront != undefined) {
                    employee.PassportFront = decode_base64(employee.PassportFront);
                }
                if (employee.PassportBack != null && employee.PassportBack != "" && employee.PassportBack != undefined) {
                    employee.PassportBack = decode_base64(employee.PassportBack);
                }
            });
            var item = $scope.Employeedatas.filter(function (item) {
                return item.IsActive === true;
            });
            $scope.Employeedataselect = item;
            $scope.TotalEmployeedatas = item;
        });
        $http({
            url: $rootScope.WebURL + "/country",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (countrydata) {
            $scope.Countrydatas = countrydata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/nationality",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (countrydata) {
            $scope.Nationalitydatas = countrydata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/skill",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (skilldata) {
            $scope.skilldatas = skilldata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/membership",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Membershipdata) {
            $scope.Membershipdatas = Membershipdata.data.data;
        });
        $http.get($rootScope.WebURL + "/employeeQualification")
            .then(function (employeeQualificationdata) {
                $scope.EmployeeQualificationdatas = employeeQualificationdata.data.data;
            });
        $http.get($rootScope.WebURL + "/employeeMembership")
            .then(function (employeeMembershipdata) {
                $scope.EmployeeMembershipatas = employeeMembershipdata.data.data;
            });
        $http.get($rootScope.WebURL + "/employeeFamily")
            .then(function (employeeFamilydata) {
                $scope.EmployeeFamilyatas = employeeFamilydata.data.data;
            });

        $scope.messages = [
            { Name: "NRIC", value: "nric" },
            { Name: "Driving License", value: "driving" },
            { Name: "VCT License", value: "vct" },
            { Name: "Contract", value: "contract" },
            { Name: "Other Documents", value: "others" }
        ]

        $scope.fmessages = [{ Name: "Passport", value: "passport" }, { Name: "Work Permit/S Pass/EP Pass", value: "work" }]

        $scope.UploadFile = function (file) {
            debugger
            try {
                var docum = $("#" + file)[0].files
                if (docum.length > 0) {
                    docum = docum[0]
                    //   if($scope.Update==true){
                    $scope.vm.Spinner = true
                    var response = Upload.upload({
                        url: $rootScope.WebURL + "/employee/upload",
                        data: { file: docum }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID, TableName: "Employee", FileID: $scope.SID,
                                    FileName: $scope.fileName, DocumentName: file,
                                    FileSize: $scope.fileSize, FileType: $scope.fileType,
                                    ModuleID: $scope.Path, Data: null, IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response.then(function (GList) {
                                RefreshAttach(file);
                                $("#" + file).val('')
                                $scope.vm.Spinner = false
                                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                            });
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

                // }
            } catch (error) {

            }


        }

        function RefreshAttach(name) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/getByFileID",
                data: { FileID: $scope.SID },
            }).then(function (attcch) {
                if (name != undefined || name != null) {
                    var item = attcch.data.data.filter(function (item) {
                        return item.DocumentName === name && item.TableName === "Employee"
                    })[0];
                    if (item != undefined) {
                        document.getElementById('Upload' + name).style.display = "none";
                        document.getElementById(name).style.display = "none";
                        document.getElementById('Delete' + name).style.display = "block";
                        document.getElementById('test' + name).style.display = "block";
                        if (name === 'nric') {
                            $scope.nricAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.nricAtach.TableID;
                            document.getElementById('testnric').innerHTML = '<a href="' + abc + '">' + $scope.nricAtach.FileName + '</a>';
                        }
                        else if (name === 'driving') {
                            $scope.drivingAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.drivingAtach.TableID;
                            document.getElementById('testdriving').innerHTML = '<a href="' + abc + '">' + $scope.drivingAtach.FileName + '</a>';
                        }
                        else if (name === 'vct') {
                            $scope.vctAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.vctAtach.TableID;
                            document.getElementById('testvct').innerHTML = '<a href="' + abc + '">' + $scope.vctAtach.FileName + '</a>';
                        }
                        else if (name === 'contract') {
                            $scope.contractAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.contractAtach.TableID;
                            document.getElementById('testcontract').innerHTML = '<a href="' + abc + '">' + $scope.contractAtach.FileName + '</a>';
                        }
                        else if (name === 'others') {
                            $scope.OthersAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.OthersAtach.TableID;
                            document.getElementById('testothers').innerHTML = '<a href="' + abc + '">' + $scope.OthersAtach.FileName + '</a>';
                        }
                        else if (name === 'passport') {
                            $scope.passportAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.passportAtach.TableID;
                            document.getElementById('testpassport').innerHTML = '<a href="' + abc + '">' + $scope.passportAtach.FileName + '</a>';
                        }
                        else if (name === 'work') {
                            $scope.workAtach = item
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.workAtach.TableID;
                            document.getElementById('testwork').innerHTML = '<a href="' + abc + '">' + $scope.workAtach.FileName + '</a>';
                        }

                    }
                    else {
                        document.getElementById('Upload' + name).style.display = "block";
                        document.getElementById(name).style.display = "block";
                        document.getElementById('Delete' + name).style.display = "none";
                        document.getElementById('test' + name).style.display = "none";
                        if (name === 'nric') $scope.nricAtach = []
                        else if (name === 'driving') $scope.drivingAtach = []
                        else if (name === 'vct') $scope.vctAtach = []
                        else if (name === 'contract') $scope.contractAtach = []
                        else if (name === 'others') $scope.OthersAtach = []
                        else if (name === 'passport') $scope.passportAtach = []
                        else if (name === 'work') $scope.workAtach = []
                    }
                }
                else {
                    var item = attcch.data.data.filter(function (item) {
                        return item.TableName === "Employee"
                    })
                    if (item != undefined) {
                        var nricitem = item.filter(function (item) {
                            return item.DocumentName === "nric"
                        })[0];
                        if (nricitem != undefined) {
                            document.getElementById('Uploadnric').style.display = "none";
                            document.getElementById('nric').style.display = "none";
                            document.getElementById('Deletenric').style.display = "block";
                            document.getElementById('testnric').style.display = "block";
                            $scope.nricAtach = nricitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.nricAtach.TableID;
                            document.getElementById('testnric').innerHTML = '<a href="' + abc + '">' + $scope.nricAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadnric').style.display = "block";
                            document.getElementById('nric').style.display = "block";
                            document.getElementById('Deletenric').style.display = "none";
                            document.getElementById('testnric').style.display = "none";
                            $scope.nricAtach = []
                        }
                        var drivitem = item.filter(function (item) {
                            return item.DocumentName === "driving"
                        })[0];
                        if (drivitem != undefined) {
                            document.getElementById('Uploaddriving').style.display = "none";
                            document.getElementById('driving').style.display = "none";
                            document.getElementById('Deletedriving').style.display = "block";
                            document.getElementById('testdriving').style.display = "block";
                            $scope.drivingAtach = drivitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.drivingAtach.TableID;
                            document.getElementById('testdriving').innerHTML = '<a href="' + abc + '">' + $scope.drivingAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploaddriving').style.display = "block";
                            document.getElementById('driving').style.display = "block";
                            document.getElementById('Deletedriving').style.display = "none";
                            document.getElementById('testdriving').style.display = "none";
                            $scope.drivingAtach = []
                        }
                        var vctitem = item.filter(function (item) {
                            return item.DocumentName === "vct"
                        })[0];
                        if (vctitem != undefined) {
                            document.getElementById('Uploadvct').style.display = "none";
                            document.getElementById('vct').style.display = "none";
                            document.getElementById('Deletevct').style.display = "block";
                            document.getElementById('testvct').style.display = "block";
                            $scope.vctAtach = vctitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.vctAtach.TableID;
                            document.getElementById('testvct').innerHTML = '<a href="' + abc + '">' + $scope.vctAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadvct').style.display = "block";
                            document.getElementById('vct').style.display = "block";
                            document.getElementById('Deletevct').style.display = "none";
                            document.getElementById('testvct').style.display = "none";
                            $scope.vctAtach = []
                        }
                        var contractitem = item.filter(function (item) {
                            return item.DocumentName === "contract"
                        })[0];
                        if (contractitem != undefined) {
                            document.getElementById('Uploadcontract').style.display = "none";
                            document.getElementById('contract').style.display = "none";
                            document.getElementById('Deletecontract').style.display = "block";
                            document.getElementById('testcontract').style.display = "block";
                            $scope.contractAtach = contractitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.contractAtach.TableID;
                            document.getElementById('testcontract').innerHTML = '<a href="' + abc + '">' + $scope.contractAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadcontract').style.display = "block";
                            document.getElementById('contract').style.display = "block";
                            document.getElementById('Deletecontract').style.display = "none";
                            document.getElementById('testcontract').style.display = "none";
                            $scope.contractAtach = []
                        }
                        var othersitem = item.filter(function (item) {
                            return item.DocumentName === "others"
                        })[0];
                        if (othersitem != undefined) {
                            document.getElementById('Uploadothers').style.display = "none";
                            document.getElementById('others').style.display = "none";
                            document.getElementById('Deleteothers').style.display = "block";
                            document.getElementById('testothers').style.display = "block";
                            $scope.OthersAtach = othersitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.OthersAtach.TableID;
                            document.getElementById('testothers').innerHTML = '<a href="' + abc + '">' + $scope.OthersAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadothers').style.display = "block";
                            document.getElementById('others').style.display = "block";
                            document.getElementById('Deleteothers').style.display = "none";
                            document.getElementById('testothers').style.display = "none";
                            $scope.OthersAtach = []
                        }
                        var passportitem = item.filter(function (item) {
                            return item.DocumentName === "passport"
                        })[0];
                        if (passportitem != undefined) {
                            document.getElementById('Uploadpassport').style.display = "none";
                            document.getElementById('passport').style.display = "none";
                            document.getElementById('Deletepassport').style.display = "block";
                            document.getElementById('testpassport').style.display = "block";
                            $scope.passportAtach = passportitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.passportAtach.TableID;
                            document.getElementById('testpassport').innerHTML = '<a href="' + abc + '">' + $scope.passportAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadpassport').style.display = "block";
                            document.getElementById('passport').style.display = "block";
                            document.getElementById('Deletepassport').style.display = "none";
                            document.getElementById('testpassport').style.display = "none";
                            $scope.passportAtach = []
                        }
                        var workitem = item.filter(function (item) {
                            return item.DocumentName === "work"
                        })[0];
                        if (workitem != undefined) {
                            document.getElementById('Uploadwork').style.display = "none";
                            document.getElementById('work').style.display = "none";
                            document.getElementById('Deletework').style.display = "block";
                            document.getElementById('testwork').style.display = "block";
                            $scope.workAtach = workitem
                            var abc = $rootScope.UploadsURL + '/HRMCore/Employee/' + $scope.workAtach.TableID;
                            document.getElementById('testwork').innerHTML = '<a href="' + abc + '">' + $scope.workAtach.FileName + '</a>';
                        }
                        else {
                            document.getElementById('Uploadwork').style.display = "block";
                            document.getElementById('work').style.display = "block";
                            document.getElementById('Deletework').style.display = "none";
                            document.getElementById('testwork').style.display = "none";
                            $scope.workAtach = []
                        }
                    }
                    else {
                        document.getElementById('Uploadnric').style.display = "block";
                        document.getElementById('nric').style.display = "block";
                        document.getElementById('Deletenric').style.display = "none";
                        document.getElementById('testnric').style.display = "none";

                        document.getElementById('Uploaddriving').style.display = "block";
                        document.getElementById('driving').style.display = "block";
                        document.getElementById('Deletedriving').style.display = "none";
                        document.getElementById('testdriving').style.display = "none";

                        document.getElementById('Uploadvct').style.display = "block";
                        document.getElementById('vct').style.display = "block";
                        document.getElementById('Deletevct').style.display = "none";
                        document.getElementById('testvct').style.display = "none";

                        document.getElementById('Uploadcontract').style.display = "block";
                        document.getElementById('contract').style.display = "block";
                        document.getElementById('Deletecontract').style.display = "none";
                        document.getElementById('testcontract').style.display = "none";

                        document.getElementById('Uploadothers').style.display = "block";
                        document.getElementById('others').style.display = "block";
                        document.getElementById('Deleteothers').style.display = "none";
                        document.getElementById('testothers').style.display = "none";

                        document.getElementById('Uploadpassport').style.display = "block";
                        document.getElementById('passport').style.display = "block";
                        document.getElementById('Deletepassport').style.display = "none";
                        document.getElementById('testpassport').style.display = "none";

                        document.getElementById('Uploadwork').style.display = "block";
                        document.getElementById('work').style.display = "block";
                        document.getElementById('Deletework').style.display = "none";
                        document.getElementById('testwork').style.display = "none";
                        $scope.nricAtach = []
                        $scope.drivingAtach = []
                        $scope.vctAtach = []
                        $scope.contractAtach = []
                        $scope.OthersAtach = []
                        $scope.passportAtach = []
                        $scope.workAtach = []
                    }
                }
            })
        }

        $scope.Removefile = function (name) {
            var id = null
            if (name === 'nric') id = $scope.nricAtach._id
            else if (name === 'driving') id = $scope.drivingAtach._id
            else if (name === 'vct') id = $scope.vctAtach._id
            else if (name === 'contract') id = $scope.contractAtach._id
            else if (name === 'others') id = $scope.OthersAtach._id
            else if (name === 'passport') id = $scope.passportAtach._id
            else if (name === 'work') id = $scope.workAtach._id
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/delete",
                data: { _id: id },
            }).then(function (List) {
                RefreshAttach(name)
                $mdToast.show($mdToast.simple().textContent('Deleted successfully !').position('top center'));
            })
        }

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                $scope.EmployeeLengthdatas = Employeedata.data.data;
                angular.forEach($scope.Employeedatas, function (employee) {
                    if (employee.Photo != null && employee.Photo != "" && employee.Photo != undefined) {
                        employee.Photo = decode_base64(employee.Photo);
                    }
                    if (employee.ICFront != null && employee.ICFront != "" && employee.ICFront != undefined) {
                        employee.ICFront = decode_base64(employee.ICFront);
                    }
                    if (employee.ICBack != null && employee.ICBack != "" && employee.ICBack != undefined) {
                        employee.ICBack = decode_base64(employee.ICBack);
                    }
                    if (employee.PassportFront != null && employee.PassportFront != "" && employee.PassportFront != undefined) {
                        employee.PassportFront = decode_base64(employee.PassportFront);
                    }
                    if (employee.PassportBack != null && employee.PassportBack != "" && employee.PassportBack != undefined) {
                        employee.PassportBack = decode_base64(employee.PassportBack);
                    }
                });
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.IsActive === true;
                });
                $scope.Employeedataselect = item;
                $scope.TotalEmployeedatas = item;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/LastEId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (edata) {
                $scope.LastEId = edata.data.data;
            });

            $http.get($rootScope.WebURL + "/employeeQualification")
                .then(function (employeeQualificationdata) {
                    $scope.EmployeeQualificationdatas = employeeQualificationdata.data.data;
                });
            $http.get($rootScope.WebURL + "/employeeMembership")
                .then(function (employeeMembershipdata) {
                    $scope.EmployeeMembershipatas = employeeMembershipdata.data.data;
                });
            $http.get($rootScope.WebURL + "/employeeFamily")
                .then(function (employeeFamilydata) {
                    $scope.EmployeeFamilyatas = employeeFamilydata.data.data;
                });
        }

        function Visatype() {
            var response = $http({
                url: $rootScope.WebURL + "/visatype",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            });
            response.then(function (VisaTypedata) {
                $scope.VisaTypedatas = VisaTypedata.data.data;
            });
        }
        function ClearForm() {
            $scope.vm.uEmployeeID = '';
            $scope.vm.uSalutation = '';
            $scope.vm.uEmployeeName = '';
            $scope.vm.uEmployeeFullName = '';
            $scope.vm.uGender = '';
            $scope.vm.uMaritalStatus = '';
            $scope.vm.uCitizenship = '';
            $scope.vm.uRace = '';
            $scope.vm.uVisaType = '';
            $scope.vm.uPlaceofBirth = '';
            $scope.vm.uDateofBirth = null;
            $scope.vm.uDrivinglicense = '';
            $scope.vm.uDrivingLicenseExpiryDate = null;
            $scope.vm.uNRICNumber = '';
            $scope.vm.uNRICIssuedDate = null;
            $scope.vm.uNRICExpiryDate = null;
            $scope.vm.permitIssueDate = null;
            $scope.vm.permitExpiryDate = null;
            $scope.vm.uWorkPermitNumber = null;
            $scope.vm.uPassportNo = '';
            $scope.vm.uPassportIssuedPlace = '';
            $scope.vm.uPassportIssuedDate = null;
            $scope.vm.uWorkPassExpiryDate = null;
            $scope.vm.uVCTLicenseDate = null;
            $scope.vm.uVCTExpiryDate = null;
            $scope.vm.uDLicenseIssueDate = null;
            $scope.vm.uDLClass = null;
            $scope.vm.CuResidentialAddress = '';
            $scope.vm.CuUnitBuilding = '';
            $scope.vm.CuPostal = '';
            $scope.vm.CuCountry = '';
            $scope.vm.CuHomeTel = '';
            $scope.vm.CuMobile = '';
            $scope.vm.CuEmail = '';
            $scope.vm.uPermanentResidentialAddress = '';
            $scope.vm.CuOUnitBuilding = '';
            $scope.vm.CuOPostalZip = '';
            $scope.vm.CuOCountry = '';
            $scope.vm.CuOContactNo = '';
            $scope.vm.EuDesignation = '';
            $scope.vm.EuCostCenter = '';
            $scope.vm.QuQualificationsName = null;
            $scope.vm.EuDivision = '';
            $scope.vm.EuJobCategory = '';
            $scope.vm.EuTeam = '';
            $scope.vm.EuEmploymentStatus = '';
            $scope.vm.EuSupervisor = '';
            $scope.vm.EuHOD = '';
            $scope.vm.EuPeer = '';
            $scope.vm.EuProbationStartDate = null;
            $scope.vm.EuProbationCompletionDate = null;
            $scope.vm.EuDateOfJoin = null;
            $scope.vm.QuQualificationsName = '';
            $scope.vm.QuNameofSchoolInstitution = '';
            $scope.vm.QuCountry = '';
            $scope.vm.QuHighestQualificationsAttained = '';
            $scope.vm.uSkill = '';
            $scope.vm.QLicenceName = '';
            $scope.vm.QLicenceStartDate = null;
            $scope.vm.QLicenceEndDate = null;
            $scope.vm.uLanguageSpoken = '';
            $scope.vm.uLanguageWritten = '';
            $scope.vm.uMembershipName = '';
            $scope.vm.uMembershipValidFrom = null;
            $scope.vm.uMembershipValidTo = null;
            $scope.vm.FuName = '';
            $scope.vm.FuRelationship = '';
            $scope.vm.FuOccupation = '';
            $scope.vm.FuNationality = '';
            $scope.vm.FuHomeTel = '';
            $scope.vm.FuMobile = '';
            $scope.vm.FuEmail = '';
            $scope.vm.uName = '';
            $scope.vm.NRelationship = '';
            $scope.vm.NHomeTel = '';
            $scope.vm.NOfficeTel = '';
            $scope.vm.NMobile = '';
            $scope.vm.NEmail = '';
            $scope.vm.uLiability = '';
            $scope.vm.uNSType = '';
            $scope.vm.uVocation = '';
            $scope.vm.uUnitAttachedTo = '';
            $scope.vm.uCurrentNSStatus = '';
            $scope.vm.uHighestRankAttained = '';
            $scope.vm.uEnlistmentDate = null;
            $scope.vm.uORDDate = null;
            $scope.vm.uNextReservistDate = null;
            $scope.vm.uYearofAward = '';
            $scope.vm.uDescription = '';
            $scope.vm.uValueofAward = '';
            $scope.vm.uStartDateofBond = null;
            $scope.vm.uEndDateofBond = null;
            $scope.vm.uHobbies = '';
            $scope.vm.uWorkWeekCode = '';
            $scope.vm.uWorkWeekDescription = '';
            $scope.vm.Annual = null;
            $scope.vm.Adoption = null;
            $scope.vm.ChildCare = null;
            $scope.vm.Maternity = null;
            $scope.vm.Paternity = null;
            $scope.vm.Sharedparentalleave = null;
            $scope.vm.SickHospitalisation = null;
            $scope.vm.SickNonHospitalisation = null;
            $scope.vm.UnpaidLeavr = null;
            $scope.vm.RuResignationofDate = null;
            $scope.vm.RuReason = '';
            $scope.vm.RuOtherReason = '';
            $scope.vm.RuRemarks = '';
        }
        function EmployeeSummary() {
            var Emaster = [];
            var attachmentinfo = $scope.attachmentdatas
            for (var i = 0; i < Employeeinfo.length; i++) {
                for (var d = 0; d < companyinfo.length; d++) {
                    if (Employeeinfo[i].CompanyID == companyinfo[d].id) {
                        angular.forEach($scope.attachmentdatas, function (attachment) {
                            angular.forEach($scope.attachmentdatas, function (attachment) {
                                if (Employeeinfo[i].id == attachment.TableID && attachment.TableName == 'hrm_mas_employee') {
                                    $scope.employeephoto = attachment.Data;
                                }
                            });
                        });
                        Emaster.push({
                            ID: Employeeinfo[i].id,
                            CompanyName: companyinfo[d].CompanyName,
                            EmployeeID: Employeeinfo[i].EmployeeID,
                            EmployeeName: Employeeinfo[i].EmployeeName,

                            Gender: Employeeinfo[i].Gender,
                            Nationality: Employeeinfo[i].Nationality,
                            DOB: Employeeinfo[i].DOB,
                            DepartmentID: Employeeinfo[i].DepartmentID,
                            CompanyID: Employeeinfo[i].CompanyID,
                            Status: Employeeinfo[i].Status,
                            DOJ: Employeeinfo[i].DOJ,
                            ProjectID: Employeeinfo[i].ProjectID,
                            ShiftID: Employeeinfo[i].ShiftID,

                            //ProjectName: projectinfo[t].ProjectName,

                            //ShiftName: shiftinfo[s].ShiftName,
                            PassportIssuePlace: Employeeinfo[i].PassportIssuePlace,
                            PassportissueDate: Employeeinfo[i].PassportissueDate,
                            PassportNumber: Employeeinfo[i].PassportNumber,
                            PassportExpiryDate: Employeeinfo[i].PassportExpiryDate,
                            Email: Employeeinfo[i].Email,
                            Country: Employeeinfo[i].Country,
                            ProbationInMonths: Employeeinfo[i].ProbationInMonths,
                            ReportingOfficer: Employeeinfo[i].ReportingOfficer,
                            ReviewManager: Employeeinfo[i].ReviewManager,
                            AnnualLeave: Employeeinfo[i].AnnualLeave,
                            SickLeaveHospitalization: Employeeinfo[i].SickLeaveHospitalization,
                            SickLeaveNonHospitalization: Employeeinfo[i].SickLeaveNonHospitalization,
                            ChildCareLeave: Employeeinfo[i].ChildCareLeave,
                            MaternityLeave: Employeeinfo[i].MaternityLeave,
                            CompassionateLeave: Employeeinfo[i].CompassionateLeave,
                            NationalServiceLeave: Employeeinfo[i].NationalServiceLeave,
                            InfantCareLeave: Employeeinfo[i].InfantCareLeave,

                            Monday: Employeeinfo[i].Monday,
                            Tuesday: Employeeinfo[i].Tuesday,
                            Wednesday: Employeeinfo[i].Wednesday,
                            Thursday: Employeeinfo[i].Thursday,
                            Friday: Employeeinfo[i].Friday,
                            Saturday: Employeeinfo[i].Saturday,
                            Sunday: Employeeinfo[i].Sunday,
                            TotalWorkingDays: Employeeinfo[i].TotalWorkingDays,
                            WorkingHoursPerDay: Employeeinfo[i].WorkingHoursPerDay,

                            Designation: Employeeinfo[i].Designation,
                            WorkPermitNumber: Employeeinfo[i].WorkPermitNumber,
                            ICNumber: Employeeinfo[i].ICNumber,
                            ICExpiryDate: Employeeinfo[i].ICExpiryDate,

                            PaternityLeave: Employeeinfo[i].PaternityLeave,
                            VisaType: Employeeinfo[i].VisaType,
                            Photo: Employeeinfo[i].Photo,
                            emphoto: $scope.employeephoto,
                            Remarks: Employeeinfo[i].Remarks,
                        })
                        $scope.employeephoto = undefined;
                    }
                }
            }


            $scope.EmployeeSummary = Emaster;

        }
        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }
        function RefreshAttchment() {
            $http.get($rootScope.WebURL + "/attachment")
                .then(function (Attachmentdata) {
                    $scope.Attachmentdatas = Attachmentdata.data.data;
                });
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file

            var response = Upload.upload({
                url: $rootScope.WebURL + "/employee/upload",
                data: { file: file }
            }).then(function (resp) {

                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Employee", FileID: $scope.SID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttchment();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];
        $scope.NationalityList = [{ name: "Afghanistan" },
        { name: "Albania" },
        { name: "Algeria" },
        { name: "Andorra" },
        { name: "Angola" },
        { name: "Anguilla" },
        { name: "Antigua & Barbuda" },
        { name: "Argentina" },
        { name: "Armenia" },
        { name: "Aruba" },
        { name: "Australia" },
        { name: "Austria" },
        { name: "Azerbaijan" },
        { name: "Bahamas" },
        { name: "Bahrain" },
        { name: "Bangladesh" },
        { name: "Barbados" },
        { name: "Belarus" },
        { name: "Belgium" },
        { name: "Belize" },
        { name: "Benin" },
        { name: "Bermuda" },
        { name: "Bhutan" },
        { name: "Bolivia" },
        { name: "Bosnia & Herzegovina" },
        { name: "Botswana" },
        { name: "Brazil" },
        { name: "British Virgin Islands" },
        { name: "Brunei" },
        { name: "Bulgaria" },
        { name: "Burkina Faso" },
        { name: "Burundi" },
        { name: "Cambodia" },
        { name: "Cameroon" },
        { name: "Cape Verde" },
        { name: "Cayman Islands" },
        { name: "Chad" },
        { name: "Chile" },
        { name: "China" },
        { name: "Colombia" },
        { name: "Congo" },
        { name: "Cook Islands" },
        { name: "Costa Rica" },
        { name: "Cote D Ivoire" },
        { name: "Croatia" },
        { name: "Cruise Ship" },
        { name: "Cuba" },
        { name: "Cyprus" },
        { name: "Czech Republic" },
        { name: "Denmark" },
        { name: "Djibouti" },
        { name: "Dominica" },
        { name: "Dominican Republic" },
        { name: "Ecuador" },
        { name: "Egypt" },
        { name: "El Salvador" },
        { name: "Equatorial Guinea" },
        { name: "Estonia" },
        { name: "Ethiopia" },
        { name: "Falkland Islands" },
        { name: "Faroe Islands" },
        { name: "Fiji" },
        { name: "Finland" },
        { name: "France" },
        { name: "French Polynesia" },
        { name: "French West Indies" },
        { name: "Gabon" },
        { name: "Gambia" },
        { name: "Georgia" },
        { name: "Germany" },
        { name: "Ghana" },
        { name: "Gibraltar" },
        { name: "Greece" },
        { name: "Greenland" },
        { name: "Grenada" },
        { name: "Guam" },
        { name: "Guatemala" },
        { name: "Guernsey" },
        { name: "Guinea" },
        { name: "Guinea Bissau" },
        { name: "Guyana" },
        { name: "Haiti" },
        { name: "Honduras" },
        { name: "Hong Kong" },
        { name: "Hungary" },
        { name: "Iceland" },
        { name: "India" },
        { name: "Indonesia" },
        { name: "Iran" },
        { name: "Iraq" },
        { name: "Ireland" },
        { name: "Isle of Man" },
        { name: "Israel" },
        { name: "Italy" },
        { name: "Jamaica" },
        { name: "Japan" },
        { name: "Jersey" },
        { name: "Jordan" },
        { name: "Kazakhstan" },
        { name: "Kenya" },
        { name: "Kuwait" },
        { name: "Kyrgyz Republic" },
        { name: "Laos" },
        { name: "Latvia" },
        { name: "Lebanon" },
        { name: "Lesotho" },
        { name: "Liberia" },
        { name: "Libya" },
        { name: "Liechtenstein" },
        { name: "Lithuania" },
        { name: "Luxembourg" },
        { name: "Macau" },
        { name: "Macedonia" },
        { name: "Madagascar" },
        { name: "Malawi" },
        { name: "Malaysia" },
        { name: "Maldives" },
        { name: "Mali" },
        { name: "Malta" },
        { name: "Mauritania" },
        { name: "Mauritius" },
        { name: "Mexico" },
        { name: "Moldova" },
        { name: "Monaco" },
        { name: "Mongolia" },
        { name: "Montenegro" },
        { name: "Montserrat" },
        { name: "Morocco" },
        { name: "Mozambique" },
        { name: "Namibia" },
        { name: "Nepal" },
        { name: "Netherlands" },
        { name: "Netherlands Antilles" },
        { name: "New Caledonia" },
        { name: "New Zealand" },
        { name: "Nicaragua" },
        { name: "Niger" },
        { name: "Nigeria" },
        { name: "Norway" },
        { name: "Oman" },
        { name: "Pakistan" },
        { name: "Palestine" },
        { name: "Panama" },
        { name: "Papua New Guinea" },
        { name: "Paraguay" },
        { name: "Peru" },
        { name: "Philippines" },
        { name: "Poland" },
        { name: "Portugal" },
        { name: "Puerto Rico" },
        { name: "Qatar" },
        { name: "Reunion" },
        { name: "Romania" },
        { name: "Russia" },
        { name: "Rwanda" },
        { name: "Saint Pierre & Miquelon" },
        { name: "Samoa" },
        { name: "San Marino" },
        { name: "Satellite" },
        { name: "Saudi Arabia" },
        { name: "Senegal" },
        { name: "Serbia" },
        { name: "Seychelles" },
        { name: "Sierra Leone" },
        { name: "Singapore" },
        { name: "Slovakia" },
        { name: "Slovenia" },
        { name: "South Africa" },
        { name: "South Korea" },
        { name: "Spain" },
        { name: "Sri Lanka" },
        { name: "St Kitts & Nevis" },
        { name: "St Lucia" },
        { name: "St Vincent" },
        { name: "St. Lucia" },
        { name: "Sudan" },
        { name: "Suriname" },
        { name: "Swaziland" },
        { name: "Sweden" },
        { name: "Switzerland" },
        { name: "Syria" },
        { name: "Taiwan" },
        { name: "Tajikistan" },
        { name: "Tanzania" },
        { name: "Thailand" },
        { name: "Timor L'Este" },
        { name: "Togo" },
        { name: "Tonga" },
        { name: "Trinidad & Tobago" },
        { name: "Tunisia" },
        { name: "Turkey" },
        { name: "Turkmenistan" },
        { name: "Turks & Caicos" },
        { name: "Uganda" },
        { name: "Ukraine" },
        { name: "United Arab Emirates" },
        { name: "United Kingdom" },
        { name: "Uruguay" },
        { name: "Uzbekistan" },
        { name: "Venezuela" },
        { name: "Vietnam" },
        { name: "Virgin Islands (US)" },
        { name: "Yemen" },
        { name: "Zambia" },
        { name: "Zimbabwe" }];

        $scope.EmployeehandleUpload = function ($files, $event, $flow) {

            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.Employeephoto.push({ photo: $files[i] });

                }
            }
        };

        $scope.IChandleUpload = function ($files, $event, $flow) {

            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.IC.push({ photo: $files[i] });

                }
            }
        };
        $scope.ICBackhandleUpload = function ($files, $event, $flow) {
            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.ICBack.push({ photo: $files[i] });
                }
            }
        };
        $scope.PassporthandleUpload = function ($files, $event, $flow) {
            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.Passport.push({ photo: $files[i] });
                }
            }
        };
        $scope.PassportBackhandleUpload = function ($files, $event, $flow) {
            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.PassportBack.push({ photo: $files[i] });
                }
            }
        };
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'DD-MM-YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.contracttemplate', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmAdmin_contracttemplate', {
            url: '/ContractTemplate',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/HcmCore/contracttemplate/contracttemplate.html',
                    controller: 'ContracttemplateController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/HcmCore/contracttemplate');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.HcmAdmin.contracttemplate')
        .controller('ContracttemplateController', ContracttemplateController)


    function ContracttemplateController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $mdDialog, $document, $http, $log, $filter, $location, $window, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');
        RefreshGrid();

        $scope.Templateform = false;
        $scope.Templategrid = true;
        $scope.tExport = true;
        $scope.tAdd = true;
        $scope.tSearch = true;
        $scope.tView = false;

        $scope.Export = function () {

            alasql('SELECT * INTO XLSX("Contracttemplate.xlsx",{headers:true}) FROM ?', [$scope.Contracttemplateformdatas]);
        };

        RefreshAttachment()

        $scope.RemoveFiles = function (index, flow) {
            flow.splice(index, 1)
        }

        $scope.Uploadfiles = function (files) {
            var filelength = files.length
            angular.forEach(files, function (item, key) {
                var upfile = item.file
                Upload.upload({
                    url: $rootScope.WebURL + "/contracttemplate/upload",
                    data: { file: upfile }
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME
                    $scope.fileName = resp.data.data[0].OriginalFileName
                    $scope.fileSize = resp.data.data[0].Size
                    $scope.Path = resp.data.data[0].Path
                    $scope.fileType = resp.data.data[0].Type
                    if (resp.data.message == "Successfully Uploaded") {
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "ContractTemplate",
                                FileID: item.TfileName,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        }).then(function (List) {
                            if (key === filelength - 1) {
                                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                                RefreshAttachment()
                            }
                        });
                    }
                });
            })
        }

        $scope.Adelete = function (id) {
            $scope.delAtachId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/attachment/delete",
                        method: "POST",
                        data: { _id: $scope.delAtachId },
                    }).then(function (attachmentdata) {
                        RefreshAttachment()
                        $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
                    })
                }
            })
        }

        function RefreshAttachment() {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + "/attachment/getByTableName",
                data: { TableName: 'ContractTemplate' }
            }).then(function (List) {
                $scope.Templatedatas = List.data.data
            })
        }

        $scope.Datefilter = function () {

            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/medical/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {


                $scope.Medicaldatas = GList.data.data;
            });
        }

        $scope.Add = function () {

            ClearForm();
            $scope.Update = false;
            $scope.Templateform = true;
            $scope.Templategrid = false;
            $scope.tExport = false;
            $scope.tView = true;
            $scope.tAdd = false;
            $scope.tSearch = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Templategrid = true;
            $scope.Templateform = false;
            $scope.tExport = true;
            $scope.tAdd = true;
            $scope.tView = false;
            $scope.tSearch = true;
        }

        $scope.tSubmit = function () {
            if ($scope.Update == true) {

                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employeecontracttemplateform/update",
                    data: {
                        _id: $scope.SID,
                        TemplateName: $scope.TemplateName,
                        TemplateDetail: $scope.TemplateDetail,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Employeecontracttemplateformdatas[$scope.IndexID] = GList.data.data;
                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employeecontracttemplateform/add",
                    data: {
                        Client_Id: Client_Id,
                        TemplateName: $scope.TemplateName,
                        TemplateDetail: $scope.TemplateDetail,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Templateinfo = function (TemplateId, $index) {

            $scope.SID = TemplateId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.Templateform = true;
            $scope.Templategrid = false;
            $scope.tExport = false;
            $scope.tView = true;
            $scope.tAdd = false;
            $scope.tSearch = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

            try {
                var TemplateArray = $scope.Employeecontracttemplateformdatas;
                var item = TemplateArray.filter(function (item) {
                    return item._id === TemplateId;
                })[0];

                $scope.id = item._id;
                $scope.TemplateName = item.TemplateName;
                $scope.TemplateDetail = item.TemplateDetail;
            } catch (err) { }
        }

        $scope.Clone = function (TId) {

            try {
                var TemplateArray = $scope.Employeecontracttemplateformdatas;
                var item = TemplateArray.filter(function (item) {
                    return item._id === TId;
                })[0];

                $scope.id = item._id;
                $scope.TemplateName = item.TemplateName;
                $scope.TemplateDetail = item.TemplateDetail;
            } catch (err) { }


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeecontracttemplateform/add",
                data: {
                    Client_Id: Client_Id,
                    TemplateName: $scope.TemplateName + '_C1',
                    TemplateDetail: $scope.TemplateDetail,
                    CreatedBy: $rootScope.LoginID,
                },
            });

            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Cloned!').position('top center'));
                RefreshGrid();
                //$scope.Showgrid();

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });

        }

        $scope.Templateformdelete = function (e, deleteID) {
            debugger
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/HcmCore/contracttemplate/contracttemplatedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ContracttemplateController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.TFdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employeecontracttemplateform/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        //$http.get( $rootScope.WebURL + "/employeecontracttemplateform")
        //.then(function (Employeecontracttemplateformdata) {
        //    
        //    $scope.Employeecontracttemplateformdatas = Employeecontracttemplateformdata.data.data;
        //});

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employeecontracttemplateform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeecontracttemplateformdata) {
                $scope.Employeecontracttemplateformdatas = Employeecontracttemplateformdata.data.data;
            });

            //    $http.get( $rootScope.WebURL + "/employeecontracttemplateform")
            //    .then(function (Employeecontracttemplateformdatas) {
            //    
            //    $scope.Employeecontracttemplateformdatas = Employeecontracttemplateformdata.data.data;
            //});
        }

        function ClearForm() {
            $scope.TemplateName = '';
            $scope.TemplateDetail = '';
        }

        var vm = this;

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }
})();




(function ()
{
    'use strict';

    angular
        .module('app.accounts.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.accounts_dashboard', {
            url: '/DashboardAccounts',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/dashboard/operations.html',
                    controller: 'DashboardaccountsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/dashboard');

        // Api 
        // Api 
        
        msApiProvider.register('dashboard.server', ['app/data/dashboard/project/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.dashboard')
        .controller('DashboardaccountsController', DashboardaccountsController);

    /** @ngInject */
    function DashboardaccountsController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DAccounts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        debugger
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";

        totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;
        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalpayables = 0;
        $scope.totalpaid = 0;
        $scope.totalreceivables = 0;
        $scope.totalreceived = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;

                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;

                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }


        $scope.Range = function () {
            debugger

            var range = vm.widget1.currentRange;
            if (range == "All") {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (scheduler) {
                    $scope.schedulerdatas = scheduler.data.data;
                    $scope.totaljobs = $scope.schedulerdatas.length;

                    var item = $scope.schedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }


        RefreshAssetRegister();
        RefreshAssetDisposal();
        RefreshPurchaseinvoice();
        RefreshPaysupplier();
        RefreshSalesInvoice();
        RefreshCollectPayment();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                $scope.totalassets = $scope.AssetRegisterdatas.length;
            });


        }
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;

                $scope.totaldiposed = $scope.AssetDisposaldatas.length;
            });
        }

        function RefreshPurchaseinvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (purchaseinvoicedata) {
                debugger
                $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;

                $scope.totalpayables = $scope.Purchaseinvoicedatas.length;
            });
        }

        function RefreshPaysupplier() {

            var response = $http({
                url: $rootScope.WebURL + "/paysupplier",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (paysupplierdata) {
                $scope.Paysupplierdatas = paysupplierdata.data.data;

                $scope.totalpaid = $scope.Paysupplierdatas.length;
            });

        }

        function RefreshSalesInvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                debugger
                $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                $scope.totalreceivables = $scope.Salesinvoicedatas.length;
            });
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;

                $scope.totalreceived = $scope.CollectPaymentdatas.length;
            });
        }


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100]
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];




        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
/// <reference path="sormaster.html" />
(function () {
    'use strict';

    angular
        .module('apps.crm.templates.sormaster', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.sormaster', {
            url: '/SOR',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/templates/sormaster/sormaster.html',
                    controller: 'SorMasterController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';
    angular
        .module('apps.crm.templates.sormaster')
        .controller('SorMasterController', SorMasterController);


    /** @ngInject */
    function SorMasterController($scope, $rootScope, $interval, $location, $mdDialog, $document, $mdToast, $http, moment, calendarConfig) {
        document.getElementsByTagName('title')[0].text = "Customer Relationship-SOR"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("PestType")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.SorGrid = true;
        $scope.exportbtn = true;
        $scope.pesttypeform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.pesttypeform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.SorGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.pesttypeform = false;
            $scope.SorGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.SorGrid = true;
            $scope.pesttypeform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {

            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.pesttypeform = true;
            $scope.SorGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.error1 = false;
        }

        $scope.pestinfo = function (pesttypeId) {

            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = pesttypeId;
            $scope.Update = true;
            $scope.pesttypeform = true;
            $scope.SorGrid = false;
            $scope.pestinfoId = pesttypeId;
            var info = $scope.Sordatas
            for (var i = 0; i < info.length; i++) {
                if (info[i]._id == pesttypeId) {
                    $scope.CustomerName = info[i].Customer;
                    $scope.Description = info[i].Description;
                    $scope.Unit = info[i].Unit;
                    $scope.RateOfficeHour = parseInt(info[i].RateDuringOfficeHour);
                    $scope.RateAfterOfficeHour = parseInt(info[i].RateAfterOfficeHour);

                }
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/sor/update",
                    data: {
                        _id: $scope.SID,
                        Customer: null,
                        Description: $scope.Description,
                        Unit: $scope.Unit,
                        RateDuringOfficeHour: $scope.RateOfficeHour,
                        RateAfterOfficeHour: $scope.RateAfterOfficeHour,
                        UpdatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id,

                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.SorGrid = true;
                    $scope.pesttypeform = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;
                    $scope.addbtn = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/sor/insert",
                    data: {
                        Customer: null,
                        Description: $scope.Description,
                        Unit: $scope.Unit,
                        RateDuringOfficeHour: $scope.RateOfficeHour,
                        RateAfterOfficeHour: $scope.RateAfterOfficeHour,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.SorGrid = true;
                    $scope.pesttypeform = false;
                    $scope.addbtn = true;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.DeletePopup = function (e, id) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/sormaster/alert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function SorMasterController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.DeleteId = id;
        }
        $scope.Delete = function () {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/sor/delete",
                data: {
                    _id: $scope.vm.DeleteId,
                },
            }).then(function (GList) {
                $scope.vm.DeleteId = null;
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $scope.Export = function () {
            var array = [];
            angular.forEach($scope.Sordatas, function (item) {
                array.push({ Customer: item.Customerdetails[0].CompanyName, Description: item.Description, Unit: item.Unit, RateDuringOfficeHour: item.RateDuringOfficeHour, RateAfterOfficeHour: item.RateAfterOfficeHour });
            });
            alasql('SELECT * INTO XLSX("Sordatas.xlsx",{headers:true}) FROM ?', [array]);
        };


        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/sor/get",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Sortabledata) {
            $scope.Sordatas = Sortabledata.data.data;
            angular.forEach($scope.Sordatas, function (value) {
                angular.forEach($scope.Divisiondatas, function (dvalue) {
                    if (value.Division == dvalue.id) {
                        value.DivisionName = dvalue.DivisionName;
                    }
                })
            })
        });


        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/sor/get",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Sortabledata) {
                $scope.Sordatas = Sortabledata.data.data;
                angular.forEach($scope.Sordatas, function (value) {
                    angular.forEach($scope.Divisiondatas, function (dvalue) {
                        if (value.Division == dvalue.id) {
                            value.DivisionName = dvalue.DivisionName;
                        }
                    })
                })
            });
        }
        function ClearForm() {

            $scope.CustomerName = null;
            $scope.Unit = null;
            $scope.Description = null;
            $scope.RateOfficeHour = null;
            $scope.RateAfterOfficeHour = null;
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
    }


})();







(function () {
    'use strict';

    angular
        .module('app.accounts.dashboard')
        .controller('DashboardaccountsController', DashboardaccountsController);

    /** @ngInject */
    function DashboardaccountsController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DAccounts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        debugger
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";

        totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;
        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalpayables = 0;
        $scope.totalpaid = 0;
        $scope.totalreceivables = 0;
        $scope.totalreceived = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;

                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;

                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }


        $scope.Range = function () {
            debugger

            var range = vm.widget1.currentRange;
            if (range == "All") {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (scheduler) {
                    $scope.schedulerdatas = scheduler.data.data;
                    $scope.totaljobs = $scope.schedulerdatas.length;

                    var item = $scope.schedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }


        RefreshAssetRegister();
        RefreshAssetDisposal();
        RefreshPurchaseinvoice();
        RefreshPaysupplier();
        RefreshSalesInvoice();
        RefreshCollectPayment();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                $scope.totalassets = $scope.AssetRegisterdatas.length;
            });


        }
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;

                $scope.totaldiposed = $scope.AssetDisposaldatas.length;
            });
        }

        function RefreshPurchaseinvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (purchaseinvoicedata) {
                debugger
                $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;

                $scope.totalpayables = $scope.Purchaseinvoicedatas.length;
            });
        }

        function RefreshPaysupplier() {

            var response = $http({
                url: $rootScope.WebURL + "/paysupplier",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (paysupplierdata) {
                $scope.Paysupplierdatas = paysupplierdata.data.data;

                $scope.totalpaid = $scope.Paysupplierdatas.length;
            });

        }

        function RefreshSalesInvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                debugger
                $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                $scope.totalreceivables = $scope.Salesinvoicedatas.length;
            });
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;

                $scope.totalreceived = $scope.CollectPaymentdatas.length;
            });
        }


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100]
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];




        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('apps.crm.templates.quotation', ['wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.quotation', {
            url: '/QuotationTemplate',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/templates/quotation/quotation.html',
                    controller: 'quotationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/templates/quotation');
    }
  
})();
(function () {

    'use strict';

    angular
        .module('apps.crm.templates.quotation')
        .controller('quotationController', quotationController);

    /** @ngInject */
    function quotationController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $mdDialog, $document, $http, $log, $filter, $location, $window, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Quotation")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Quotationform = false;
        $scope.Quotationgrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        //$scope.Table = null;
        $scope.Employeephoto = [
            { photo: false }]
        $scope.EmployeehandleUpload = function ($files, $event, $flow) {
            debugger
            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.Employeephoto.push({ photo: $files[i] });

                }
            }
        };
        $scope.sAdd = function () {
            $scope.vm.TableTitle1 = null;
            $scope.vm.TableTitle2 = null;
            $scope.vm.TableTitle3 = null;
            $scope.vm.TableTitle4 = null;
            $scope.vm.TableTitle5 = null;
            $scope.vm.TableTitle6 = null;
            $scope.vm.TableTitle7 = null;
            $scope.vm.TableTitle8 = null;
            $scope.vm.Subject = null;
            $scope.vm.TemplateName = null;
            $scope.vm.TableTempID1 = null;
            $scope.vm.TableTempID2 = null;
            $scope.vm.TableTempID3 = null;
            $scope.vm.TableTempID4 = null;
            $scope.vm.TableTempID5 = null;
            $scope.vm.TableTempID6 = null;
            $scope.vm.TableTempID7 = null;
            $scope.vm.TableTempID8 = null;
            $scope.Update = false;
            $scope.Quotationform = true;
            $scope.Quotationgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = false;
            $scope.Search = false;
            $scope.vm.Header = "<div><p><b>QUOTE FOR ANTI - TERMITE SOIL TREATMENT AT PROJECT :</b></p><p><b>EUNOSVILLE SHOWFLAT - PROPOSED ERECTION OF 1 - STOREY TEMPORARY SHOWFLAT AND SALES GALLERY FOR PROPOSED RESIDENTIAL DEVELOPMENT ON LOT 04135W MK 23 AT SIMS AVENUE (GEYLANG PLANNING AREA)​</b></p></div>";
            $scope.vm.Footer = "<p>We trust that the above meet your expectation and looking forward for your early favourable reply. Please feel free to contact the undersigned at 9733 8342 should you need any assistance.</p>";
            $scope.vm.TermsCondition11 = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.TableTempID = pass;
        }
        $scope.Preview = function (TId, invoice) {
            RefreshGrid();
            $scope.vm.TableTitle1 = null;
            $scope.vm.TableTitle2 = null;
            $scope.vm.TableTitle3 = null;
            $scope.vm.TableTitle4 = null;
            $scope.vm.TableTitle5 = null;
            $scope.vm.TableTitle6 = null;
            $scope.vm.TableTitle7 = null;
            $scope.vm.TableTitle8 = null;
            angular.forEach($scope.Quotationtemplates, function (qvalue) {
                if (qvalue.id == TId) {
                    $scope.vm.TermsCondition = qvalue.TermsCondition;
                    $scope.vm.Footer = qvalue.Footer;
                    $scope.vm.Header = qvalue.Header;
                    $scope.vm.Subject = qvalue.Subject;
                    $scope.TableTitle = qvalue.TableTitle;
                    $scope.TableTempID = qvalue.TemplateID;
                }
            });
            angular.forEach($scope.Quotationdatas, function (pvalue) {
                if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                    if (pvalue.TableTempID1 == $scope.TableTempID) {
                        $scope.vm.TableTitle1 = pvalue.TableTitle1;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                    if (pvalue.TableTempID2 == $scope.TableTempID) {
                        $scope.vm.TableTitle2 = pvalue.TableTitle2;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle3")) {
                    if (pvalue.TableTempID3 == $scope.TableTempID) {
                        $scope.vm.TableTitle3 = pvalue.TableTitle3;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                    if (pvalue.TableTempID4 == $scope.TableTempID) {
                        $scope.vm.TableTitle4 = pvalue.TableTitle4;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                    if (pvalue.TableTempID5 == $scope.TableTempID) {
                        $scope.vm.TableTitle5 = pvalue.TableTitle5;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                    if (pvalue.TableTempID6 == $scope.TableTempID) {
                        $scope.vm.TableTitle6 = pvalue.TableTitle6;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                    if (pvalue.TableTempID7 == $scope.TableTempID) {
                        $scope.vm.TableTitle7 = pvalue.TableTitle7;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                    if (pvalue.TableTempID8 == $scope.TableTempID) {
                        $scope.vm.TableTitle8 = pvalue.TableTitle8;
                    }
                }
            });
            setTimeout(function () {
                $scope.$apply(function () {
                    $scope.vm.TableTitle1 = $scope.vm.TableTitle1;
                    $scope.vm.TableTitle2 = $scope.vm.TableTitle2;
                    $scope.vm.TableTitle3 = $scope.vm.TableTitle3;
                    $scope.vm.TableTitle4 = $scope.vm.TableTitle4;
                    $scope.vm.TableTitle5 = $scope.vm.TableTitle5;
                    $scope.vm.TableTitle6 = $scope.vm.TableTitle6;
                    $scope.vm.TableTitle7 = $scope.vm.TableTitle7;
                    $scope.vm.TableTitle8 = $scope.vm.TableTitle8;
                    preview();
                });
            }, 1);
        }
        function preview() {
            $scope.Previewdiv = true;
            var innerContents = document.getElementById('invoice').innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload= print()>' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            popupWinindow.document.close($scope.Previewdiv = false);
        }
        $scope.Clone = function (TId) {
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.cloneTableTempID = pass

            angular.forEach($scope.Quotationtemplates, function (value) {
                if (value.id == TId) {
                    $scope.vm.TableTitleID = value.TableTitleID;
                    $scope.vm.TemplateName = value.TemplateName;
                    $scope.vm.Division = value.Division;
                    $scope.TableTitle = value.TableTitle;
                    $scope.vm.Subject = value.Subject;
                    $scope.vm.TermsCondition = value.TermsCondition;
                    $scope.vm.Footer = value.Footer;
                    $scope.vm.Header = value.Header;
                    $scope.TableTempID = value.TemplateID;

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/quotationtemplate/add",
                        data: {
                            TemplateID: $scope.cloneTableTempID,
                            TemplateName: $scope.vm.TemplateName + '_C1',
                            Division: $scope.vm.Division,
                            TableTitle: $scope.TableTitle,
                            TableTitleID: $scope.vm.TableTitleID,
                            Subject: $scope.vm.Subject,
                            TermsCondition: $scope.vm.TermsCondition,
                            Footer: $scope.vm.Footer,
                            Header: $scope.vm.Header,
                            CreatedBy: $rootScope.createdby,
                            Client_Id: $rootScope.Client_Id,
                            IsActive: "true",
                        },
                    });
                    response.then(function (GList) {
                        RefreshGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Cloned!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });
            angular.forEach($scope.Quotationdatas, function (pvalue) {
                if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                    if (pvalue.TableTempID1 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle1: pvalue.TableTitle1,
                                TableTempID1: $scope.cloneTableTempID,
                                T1PestType: pvalue.T1PestType,
                                T1Timing: pvalue.T1Timing,
                                T1Frequency: pvalue.T1Frequency,
                                T1Pricing: pvalue.T1Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                    if (pvalue.TableTempID2 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle2: pvalue.TableTitle2,
                                TableTempID2: $scope.cloneTableTempID,
                                T2PestType: pvalue.T2PestType,
                                T2Timing: pvalue.T2Timing,
                                T2Quantity: pvalue.T2Quantity,
                                T2Frequency: pvalue.T2Frequency,
                                T2Pricing: pvalue.T2Pricing,
                                Client_Id: $rootScope.Client_Id,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle3")) {
                    if (pvalue.TableTempID3 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle3: pvalue.TableTitle3,
                                TableTempID3: $scope.cloneTableTempID,
                                T3Area: pvalue.T3Area,
                                T3PestType: pvalue.T3PestType,
                                T3Quantity: pvalue.T3Quantity,
                                T3Timing: pvalue.T3Timing,
                                T3Frequency: pvalue.T3Frequency,
                                T3Pricing: pvalue.T3Pricing,
                                Client_Id: $rootScope.Client_Id,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                    if (pvalue.TableTempID4 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle4: pvalue.TableTitle4,
                                TableTempID4: $scope.cloneTableTempID,
                                T4Product: pvalue.T4Product,
                                T4NoOfPieces: pvalue.T4NoOfPieces,
                                T4Pricing: pvalue.T4Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                    if (pvalue.TableTempID5 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle5: pvalue.TableTitle5,
                                TableTempID5: $scope.cloneTableTempID,
                                T5Product: pvalue.T5Product,
                                T5Quantity: pvalue.T5Quantity,
                                T5LeasingUnitPrice: pvalue.T5LeasingUnitPrice,
                                T5SellingUnitPrice: pvalue.T5SellingUnitPrice,
                                T5Photo: pvalue.T5Photo.src,
                                Client_Id: $rootScope.Client_Id,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                    if (pvalue.TableTempID6 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle6: pvalue.TableTitle6,
                                TableTempID6: $scope.cloneTableTempID,
                                T6Description: pvalue.T6Description,
                                T6Price: pvalue.T6Price,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                    if (pvalue.TableTempID7 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle7: pvalue.TableTitle7,
                                TableTempID7: $scope.cloneTableTempID,
                                T7PartNo: pvalue.T7PartNo,
                                T7ForModelNo: pvalue.T7ForModelNo,
                                T7NoOfLightTubesNeed: pvalue.T7NoOfLightTubesNeed,
                                T7SellingPricing: pvalue.T7SellingPricing,
                                T7Lifespan: pvalue.T7Lifespan,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                    if (pvalue.TableTempID8 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle8: pvalue.TableTitle8,
                                TableTempID8: $scope.cloneTableTempID,
                                T8ForModelNo: pvalue.T8ForModelNo,
                                T8NoOfBoardsNeeded: pvalue.T8NoOfBoardsNeeded,
                                T8SellingPricing: pvalue.T8SellingPricing,
                                T8Lifespan: pvalue.T8Lifespan,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
            });
        }
        $scope.Delete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationtemplate/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                RefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.QDelete = function (QdeleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation/delete",
                data: {
                    _id: QdeleteID,
                },
            });
            response.then(function (GList) {
                quotationRefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            $scope.Quotationgrid = true;
            $scope.Quotationform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
        }

        $scope.AddDescription = function (e, FB) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/quotation/description.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function quotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.AddDescription = null;
            if (FB == 'Front') { $scope.ForB = true }
            if (FB == 'Back') { $scope.ForB = false }
        }
        $scope.LoadDesc = function (Des) {
            if ($scope.ForB == true) { $scope.vm.TableTitle3 = Des; }
            else { $scope.vm.T3Description = Des; }
            $mdDialog.cancel();
        }
        $scope.AddDescriptionSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/description/add",
                data: {
                    Descriptions: $scope.vm.AddDescription,
                    CreatedBy: $rootScope.createdby, IsActive: true,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                $scope.vm.AddDescription = null;
                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/description",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (descriptiondata) {
                    $scope.Descriptiondatas = descriptiondata.data.data;
                });

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.AddDescriptionDelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/description/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/description",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (descriptiondata) {
                    $scope.Descriptiondatas = descriptiondata.data.data;
                });
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.AddTermsAndCondition = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/quotation/TermsAndCondition.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function quotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.TACUpdate = false;
            $scope.vm.Name = null;
            $scope.vm.AddTermsCondition = null;
        }
        $scope.TermsAndConditionSubmit = function () {
            if ($scope.TACUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/termsAndCondition/update",
                    data: {
                        _id: $scope.TACId,
                        Name: $scope.vm.Name,
                        TermsCondition: $scope.vm.AddTermsCondition,
                        UpdatedBy: $rootScope.createdby, IsActive: true,

                    },
                });
                response.then(function (GList) {
                    $scope.TACUpdate = false;
                    $scope.vm.Name = null;
                    $scope.vm.AddTermsCondition = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/termsAndCondition",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (termsAndConditiondata) {
                        $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/termsAndCondition/add",
                    data: {
                        Name: $scope.vm.Name,
                        TermsCondition: $scope.vm.AddTermsCondition,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $scope.TACUpdate = false;
                    $scope.vm.Name = null;
                    $scope.vm.AddTermsCondition = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/termsAndCondition",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (termsAndConditiondata) {
                        $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.TermsAndConditioninfo = function (Id, name, tc) {
            $scope.TACId = Id;
            $scope.vm.Name = name;
            $scope.vm.AddTermsCondition = tc;
            $scope.TACUpdate = true;
        }
        $scope.TermsAndConditionDelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/termsAndCondition/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/termsAndCondition",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (termsAndConditiondata) {
                    $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                });
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.EditAction = function (e, CTable, Id) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/quotation/quotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function quotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = true;
            $scope.vm.T3Description = null;
            $scope.vm.T3Quantity = 0;
            $scope.vm.T3UnitRate = 0;
            $scope.vm.T3Amount = 0;

            if (CTable == 'Title3') {
                $scope.Title3 = true;
                $scope.TableTitle = $scope.vm.TableTitle3;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Quotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T3Description = item.T3Description;
                    $scope.vm.T3Quantity = parseInt(item.T3Quantity);
                    $scope.vm.T3UnitRate = parseInt(item.T3UnitRate);
                    $scope.vm.T3Amount = parseInt(item.T3Amount);
                } catch (e) { }
            }
            else { $scope.vm.QRT_Id = null; }

        }

        $scope.PestManagement = function (e, CTable) {
            $scope.Title = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/quotation/quotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function quotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;
            $scope.TableTitle = $scope.vm.TableTitle3;

            $scope.vm.T3Description = null;
            $scope.vm.T3Quantity = 0;
            $scope.vm.T3UnitRate = 0;
            $scope.vm.T3Amount = 0;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };

        $scope.templateinfo = function (TId) {
            debugger
            $scope.vm.TableTitle1 = null;
            $scope.vm.TableTitle2 = null;
            $scope.vm.TableTitle3 = null;
            $scope.vm.TableTitle4 = null;
            $scope.vm.TableTitle5 = null;
            $scope.vm.TableTitle6 = null;
            $scope.vm.TableTitle7 = null;
            $scope.vm.TableTitle8 = null;
            $scope.vm.Subject = null;
            $scope.vm.Header = null;
            $scope.vm.TermsCondition = null;
            $scope.vm.Footer = null;
            $scope.vm.TemplateName = null;
            $scope.vm.Division = null;
            $scope.vm.TableTempID1 = null;
            $scope.vm.TableTempID2 = null;
            $scope.vm.TableTempID3 = null;
            $scope.vm.TableTempID4 = null;
            $scope.vm.TableTempID5 = null;
            $scope.vm.TableTempID6 = null;
            $scope.vm.TableTempID7 = null;
            $scope.vm.TableTempID8 = null;
            $scope.SID = TId;
            $scope.Update = true;
            $scope.Quotationform = true;
            $scope.Quotationgrid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;
            $scope.Search = false;
            angular.forEach($scope.Quotationtemplates, function (value) {
                if (value.id == TId) {
                    $scope.vm.LeadId = value.id;
                    $scope.vm.TemplateName = value.TemplateName;
                    $scope.vm.Division = value.Division;
                    $scope.vm.TableTitle = value.TableTitle;
                    $scope.vm.Subject = value.Subject;
                    $scope.vm.TermsCondition = value.TermsCondition;
                    $scope.vm.Footer = value.Footer;
                    $scope.vm.Header = value.Header;
                    $scope.TableTempID = value.TemplateID;
                    angular.forEach($scope.Quotationdatas, function (qvalue) {
                        if (qvalue.TableTempID1 == value.TemplateID) {
                            $scope.vm.TableTitle1 = qvalue.TableTitle1;
                            $scope.vm.TableTempID1 = qvalue.TableTempID1;
                        }
                        if (qvalue.TableTempID2 == value.TemplateID) {
                            $scope.vm.TableTitle2 = qvalue.TableTitle2;
                            $scope.vm.TableTempID2 = qvalue.TableTempID2;
                        }
                        if (qvalue.TableTempID3 == value.TemplateID) {
                            $scope.vm.TableTitle3 = qvalue.TableTitle3;
                            $scope.vm.TableTempID3 = qvalue.TableTempID3;
                        }
                        if (qvalue.TableTempID4 == value.TemplateID) {
                            $scope.vm.TableTitle4 = qvalue.TableTitle4;
                            $scope.vm.TableTempID4 = qvalue.TableTempID4;
                        }
                        if (qvalue.TableTempID5 == value.TemplateID) {
                            $scope.vm.TableTitle5 = qvalue.TableTitle5;
                            $scope.vm.TableTempID5 = qvalue.TableTempID5;
                        }
                        if (qvalue.TableTempID6 == value.TemplateID) {
                            $scope.vm.TableTitle6 = qvalue.TableTitle6;
                            $scope.vm.TableTempID6 = qvalue.TableTempID6;
                        }
                        if (qvalue.TableTempID7 == value.TemplateID) {
                            $scope.vm.TableTitle7 = qvalue.TableTitle7;
                            $scope.vm.TableTempID7 = qvalue.TableTempID7;
                        }
                        if (qvalue.TableTempID8 == value.TemplateID) {
                            $scope.vm.TableTitle8 = qvalue.TableTitle8;
                            $scope.vm.TableTempID8 = qvalue.TableTempID8;
                        }
                    });
                }
            });
        }

        $scope.sSubmit = function () {
            debugger
            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }

            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotationtemplate/update",
                    data: {
                        _id: $scope.SID,
                        TemplateID: $scope.TableTempID,
                        TemplateName: $scope.vm.TemplateName,
                        Division: $scope.vm.Division,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.vm.Subject,
                        TermsCondition: $scope.vm.TermsCondition,
                        Footer: $scope.vm.Footer,
                        Header: $scope.vm.Header,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = false;
                    $scope.Quotationgrid = true;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotationtemplate/add",
                    data: {
                        TemplateID: $scope.TableTempID,
                        TemplateName: $scope.vm.TemplateName,
                        Division: $scope.vm.Division,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.vm.Subject,
                        TermsCondition: $scope.vm.TermsCondition,
                        Footer: $scope.vm.Footer,
                        Header: $scope.vm.Header,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    debugger
                    if (GList.data.message == "Existing TemplateName") {
                        $scope.error1 = true;
                        $scope.Quotationform = true;
                        $scope.Quotationgrid = false;
                        $scope.Export = false;
                        $scope.Add = false;
                        $scope.Search = false;
                        $scope.view = true;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Template Saved!').position('top center'));
                        RefreshGrid();
                        $scope.Quotationform = false;
                        $scope.Quotationgrid = true;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.Search = true;
                        $scope.view = false;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Title3Submit = function () {

            if ($scope.QRTUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle3: $scope.vm.TableTitle3,
                        TableTempID3: $scope.TableTempID,
                        T3Description: $scope.vm.T3Description,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3UnitRate: $scope.vm.T3UnitRate,
                        T3Amount: ($scope.vm.T3Quantity * $scope.vm.T3UnitRate),
                        UpdatedBy: $rootScope.createdby,
                        IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $scope.QRTUpdate = false;
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.Quotationgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle3: $scope.vm.TableTitle3,
                        TableTempID3: $scope.TableTempID,
                        T3Description: $scope.vm.T3Description,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3UnitRate: $scope.vm.T3UnitRate,
                        T3Amount: ($scope.vm.T3Quantity * $scope.vm.T3UnitRate),
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby,
                        IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.QRTUpdate = false;
                    $scope.Quotationform = true;
                    $scope.Quotationgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/quotationtemplate/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Quotation Template", FileID: $scope.TableTempID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.productphoto = function (Pid) {
            angular.forEach($scope.Attachmentdatas, function (value) {
                if (value.TableID == Pid) {
                    $scope.uICBack = value.Data;
                }
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotation",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (quotationdata) {
            $scope.Quotationdatas = quotationdata.data.data;
            angular.forEach($scope.Quotationdatas, function (value) {
                if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                    value.T5Photo = decode_base64(value.T5Photo);
                }
            })
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotationtemplate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (quotationtemplate) {
            $scope.Quotationtemplates = quotationtemplate.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item;
            }
            catch (e) { }
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/termsAndCondition",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (termsAndConditiondata) {
            $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/product",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Productdata) {
            $scope.Productdatas = Productdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/areas",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (areasdata) {
            $scope.areasdatas = areasdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });
        $http.get($rootScope.WebURL + "/attachment")
            .then(function (Attachmentdata) {
                $scope.Attachmentdatas = Attachmentdata.data.data;
                angular.forEach($scope.Attachmentdatas, function (qvalue) {
                    if (qvalue.Data != null && qvalue.Data != '' && qvalue.Data != undefined) {
                        qvalue.Data = decode_base64(qvalue.Data);
                    }
                })
            });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.Pestdatas = pestdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/areas",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (areasdata) {
                $scope.areasdatas = areasdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationtemplate",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (quotationtemplate) {
                $scope.Quotationtemplates = quotationtemplate.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (preparequotationdata) {
                $scope.Quotationdatas = preparequotationdata.data.data;
                angular.forEach($scope.Quotationdatas, function (value) {
                    if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                        value.T5Photo = decode_base64(value.T5Photo);
                    }
                })
            });

        }
        function quotationRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (preparequotationdata) {
                $scope.Quotationdatas = preparequotationdata.data.data;
                angular.forEach($scope.Quotationdatas, function (value) {
                    if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                        value.T5Photo = decode_base64(value.T5Photo);
                    }
                })
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }
        var vm = this;
        //// Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.Header = "<div><p><b>QUOTE FOR ANTI - TERMITE SOIL TREATMENT AT PROJECT :</b></p><p><b>EUNOSVILLE SHOWFLAT - PROPOSED ERECTION OF 1 - STOREY TEMPORARY SHOWFLAT AND SALES GALLERY FOR PROPOSED RESIDENTIAL DEVELOPMENT ON LOT 04135W MK 23 AT SIMS AVENUE (GEYLANG PLANNING AREA)​</b></p></div>";
        vm.Footer = "<p>We trust that the above meet your expectation and looking forward for your early favourable reply. Please feel free to contact the undersigned at 9733 8342 should you need any assistance.</p>";
        vm.TermsCondition11 = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        //vm.dtOptions = {
        //    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        //    initComplete: function () {
        //        var api = this.api(),
        //            searchBox = angular.element('body').find('#forms-search');
        //        // Bind an external input as a table wide search box
        //        if (searchBox.length > 0) {
        //            searchBox.on('keyup', function (event) {
        //                api.search(event.target.value).draw();
        //            });
        //        }
        //    },
        //    pagingType: 'simple',
        //    autoWidth: false,
        //    lengthMenu: [10, 20, 30, 50, 100],
        //    stateSave: true,
        //    responsive: true,
        //    "language": {
        //        "lengthMenu": $rootScope.lengthMenu,
        //        "zeroRecords": $rootScope.zeroRecords,
        //        "info": $rootScope.info,
        //        "infoEmpty":$rootScope.infoEmpty,
        //        "infoFiltered": $rootScope.infoFiltered,
        //        "Header":$rootScope.Header,
        //    }
        //};

    }

})();
(function ()
{
    'use strict';

    angular
        .module('apps.crm.templates.contractstemplates', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.contractstemplates', {
            url: '/ContractsTemplates',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/templates/contractstemplates/contractstemplates.html',
                    controller: 'contractstemplatesController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/templates/contractstemplates');
    }

})();
(function () {


    'use strict';

    angular
        .module('apps.crm.templates.contractstemplates')
        .controller('contractstemplatesController', contractstemplatesController);


    /** @ngInject */
    function contractstemplatesController($scope, $interval, $location, $mdSidenav, $rootScope, $mdToast, $http, $mdDialog, $document, DashboardData, $timeout) {
        document.getElementsByTagName('title')[0].text = "Customer Relationship-Contract Templates"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Quotation")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $scope.ContractsTemplatesform = false;
        $scope.ContractsTemplatesgrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;

        RefreshPestTypeGrid();
        RefreshFrequencyGrid();

        function RefreshPestTypeGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Pestdata) {
                $scope.Pestdatas = Pestdata.data.data;
            });
        }

        function RefreshFrequencyGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/settings",
                data: { Client_Id: Client_Id },
            });
            response.then(function (settingsdata) {
                $scope.Settingsdatas = settingsdata.data.data;
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'ScheduleFrequency';
                    });
                    $scope.ScheduleFrequencydatas = item;
                }
                catch (e) { }
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };
        $scope.sAdd = function () {
            $scope.vm.TableTitle1 = null;
            $scope.vm.TableTitle2 = null;
            $scope.vm.TableTitle3 = null;
            $scope.vm.TableTitle4 = null;
            $scope.vm.TableTitle5 = null;
            $scope.vm.TableTitle6 = null;
            $scope.vm.TableTitle7 = null;
            $scope.vm.TableTitle8 = null;
            $scope.vm.Subject = null;
            $scope.vm.TemplateName = null;
            $scope.vm.TableTempID1 = null;
            $scope.vm.TableTempID2 = null;
            $scope.vm.TableTempID3 = null;
            $scope.vm.TableTempID4 = null;
            $scope.vm.TableTempID5 = null;
            $scope.vm.TableTempID6 = null;
            $scope.vm.TableTempID7 = null;
            $scope.vm.TableTempID8 = null;
            $scope.Update = false;
            $scope.ContractsTemplatesform = true;
            $scope.ContractsTemplatesgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = false;
            $scope.Search = false;
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.TableTempID = pass;

            $scope.vm.Header = "<div><h3><span></span><div>This contract is an agreement made between the client stated above (hereinafter called <b><span><b>&#34;The Client&#34;) </b></span></b><span>and " + $scope.Clientdata.ClientName + " (hereinafter called </span><b><span><b>&#34;The Contractor&#34;</b></span></b><span >) as follows:-</span></div></h3></div><div><h5><p></p><p><br/></p><p></p><p><span><b>COMMENCEMENT OF CONTRACT </b></span></b></p></h5><h3><span>This Contract will hereby commence at the above service location from<b> ____</b></span><span> to </span><u><span>_____</span></u><span> and to hold unto The Client for a period of <b> _______</b></span><span>. The Client agrees to pay for the scope of work on a <u>____ </u></span><span>basis, a sum of Singapore Dollars <b>_____</b></span><span> per month. </span><span>Payable to </span><span>" + $scope.Clientdata.ClientName + " </span><span>within <b>___</b> of invoice. Additional services stated on the Schedule of Rates will be charged separately.</span></h3><div><p><br/></p></div><p></p><p></p><p><span></span></p><p><b><span><b>SERVICE HOURS</b></span></b></p><p><span>Refer to the ‘Scope of Work’ as stated below will be carried out </span><b><span><b>During</b></span></b><span> </span><b><span><b>Office Hours</b></span></b><span>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range.</span></p><!--EndFragment--><br/><b>ACCESS TO PREMISES</b><br/></div><div><p>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p><p><br/></p></div><div><h5><b>LIABILITY</b></h5></div><div><p>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br/></p><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div><p><br/></p><p></p></div><div><h5><b>TERMINATION OF CONTRACT</b></h5></div><div><p>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Months·notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>";
        }
        $scope.Delete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contracttemplate/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                debugger
                RefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.QDelete = function (QdeleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation/delete",
                data: {
                    _id: QdeleteID,
                },
            });
            response.then(function (GList) {
                quotationRefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            $scope.ContractsTemplatesgrid = true;
            $scope.ContractsTemplatesform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
        }

        $scope.Preview = function (TId, invoice) {
            RefreshGrid();
            $scope.vm.TableTitle1 = null;
            $scope.vm.TableTitle2 = null;
            $scope.vm.TableTitle3 = null;
            $scope.vm.TableTitle4 = null;
            $scope.vm.TableTitle5 = null;
            $scope.vm.TableTitle6 = null;
            $scope.vm.TableTitle7 = null;
            $scope.vm.TableTitle8 = null;
            angular.forEach($scope.Contracttemplates, function (qvalue) {
                if (qvalue.id == TId) {
                    $scope.vm.TermsCondition = qvalue.TermsCondition;
                    $scope.vm.Footer = qvalue.Footer;
                    $scope.vm.Header = qvalue.Header;
                    $scope.vm.Subject = qvalue.Subject;
                    $scope.TableTitle = qvalue.TableTitle;
                    $scope.vm.TemplateName = qvalue.TemplateName;
                    $scope.TableTempID = qvalue.TemplateID;
                }
            });
            angular.forEach($scope.Contractquotationdatas, function (pvalue) {
                if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                    if (pvalue.TableTempID1 == $scope.TableTempID) {
                        $scope.vm.TableTitle1 = pvalue.TableTitle1;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                    if (pvalue.TableTempID2 == $scope.TableTempID) {
                        $scope.vm.TableTitle2 = pvalue.TableTitle2;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle3")) {
                    if (pvalue.TableTempID3 == $scope.TableTempID) {
                        $scope.vm.TableTitle3 = pvalue.TableTitle3;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                    if (pvalue.TableTempID4 == $scope.TableTempID) {
                        $scope.vm.TableTitle4 = pvalue.TableTitle4;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                    if (pvalue.TableTempID5 == $scope.TableTempID) {
                        $scope.vm.TableTitle5 = pvalue.TableTitle5;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                    if (pvalue.TableTempID6 == $scope.TableTempID) {
                        $scope.vm.TableTitle6 = pvalue.TableTitle6;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                    if (pvalue.TableTempID7 == $scope.TableTempID) {
                        $scope.vm.TableTitle7 = pvalue.TableTitle7;
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                    if (pvalue.TableTempID8 == $scope.TableTempID) {
                        $scope.vm.TableTitle8 = pvalue.TableTitle8;
                    }
                }
            });
            setTimeout(function () {
                $scope.$apply(function () {
                    $scope.vm.TableTitle1 = $scope.vm.TableTitle1;
                    $scope.vm.TableTitle2 = $scope.vm.TableTitle2;
                    $scope.vm.TableTitle3 = $scope.vm.TableTitle3;
                    $scope.vm.TableTitle4 = $scope.vm.TableTitle4;
                    $scope.vm.TableTitle5 = $scope.vm.TableTitle5;
                    $scope.vm.TableTitle6 = $scope.vm.TableTitle6;
                    $scope.vm.TableTitle7 = $scope.vm.TableTitle7;
                    $scope.vm.TableTitle8 = $scope.vm.TableTitle8;
                    preview();
                });
            }, 1);
        }
        function preview() {
            $scope.Previewdiv = true;
            var innerContents = document.getElementById('invoice').innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body  onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            popupWinindow.document.close($scope.Previewdiv = false);
        }
        $scope.Clone = function (TId) {
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.cloneTableTempID = pass
            angular.forEach($scope.Contracttemplates, function (value) {
                if (value.id == TId) {
                    $scope.vm.TableTitleID = value.TableTitleID;
                    $scope.vm.TemplateName = value.TemplateName;
                    $scope.TableTitle = value.TableTitle;
                    $scope.vm.Subject = value.Subject;
                    $scope.vm.TermsCondition = value.TermsCondition;
                    $scope.vm.Footer = value.Footer;
                    $scope.vm.Header = value.Header;
                    $scope.TableTempID = value.TemplateID;

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/contracttemplate/add",
                        data: {
                            TemplateID: $scope.cloneTableTempID,
                            TemplateName: $scope.vm.TemplateName + '_C1',
                            TableTitle: $scope.TableTitle,
                            TableTitleID: $scope.vm.TableTitleID,
                            Subject: $scope.vm.Subject,
                            TermsCondition: $scope.vm.TermsCondition,
                            Footer: $scope.vm.Footer,
                            Header: $scope.vm.Header,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {
                        RefreshGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Cloned!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });
            angular.forEach($scope.Contractquotationdatas, function (pvalue) {
                //if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                if (pvalue.TableTempID1 == $scope.TableTempID) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/contractquotation/add",
                        data: {
                            TableTitle1: pvalue.TableTitle1,
                            TableTempID1: $scope.cloneTableTempID,
                            T1PestType: pvalue.T1PestType,
                            T1ScopeofWork: pvalue.T1ScopeofWork,
                            T1Frequency: pvalue.T1Frequency,
                            T1Pricing: pvalue.T1Pricing,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                        },
                    });
                    response.then(function (GList) {
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                    // }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                    if (pvalue.TableTempID2 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle2: pvalue.TableTitle2,
                                TableTempID2: $scope.cloneTableTempID,
                                T2PestType: pvalue.T2PestType,
                                T2Timing: pvalue.T2Timing,
                                T2Quantity: pvalue.T2Quantity,
                                T2Frequency: pvalue.T2Frequency,
                                T2Pricing: pvalue.T2Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle3")) {
                    if (pvalue.TableTempID3 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle3: pvalue.TableTitle3,
                                TableTempID3: $scope.cloneTableTempID,
                                T3Area: pvalue.T3Area,
                                T3PestType: pvalue.T3PestType,
                                T3Quantity: pvalue.T3Quantity,
                                T3Timing: pvalue.T3Timing,
                                T3Frequency: pvalue.T3Frequency,
                                T3Pricing: pvalue.T3Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                    if (pvalue.TableTempID4 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle4: pvalue.TableTitle4,
                                TableTempID4: $scope.cloneTableTempID,
                                T4Product: pvalue.T4Product,
                                T4NoOfPieces: pvalue.T4NoOfPieces,
                                T4Pricing: pvalue.T4Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                    if (pvalue.TableTempID5 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle5: pvalue.TableTitle5,
                                TableTempID5: $scope.cloneTableTempID,
                                T5Description: pvalue.T5Description,
                                T5Quantity: pvalue.T5Quantity,
                                T5Rate: pvalue.T5Rate,
                                T5Amount: pvalue.T5Amount,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                    if (pvalue.TableTempID6 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle6: pvalue.TableTitle6,
                                TableTempID6: $scope.cloneTableTempID,
                                T6Description: pvalue.T6Description,
                                T6Price: pvalue.T6Price,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                    if (pvalue.TableTempID7 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle7: pvalue.TableTitle7,
                                TableTempID7: $scope.cloneTableTempID,
                                T7SerialNo: pvalue.T7SerialNo,
                                T7ForModelNo: pvalue.T7ForModelNo,
                                T7LeasePerAnnum: pvalue.T7LeasePerAnnum,
                                T7EffectiveDate: pvalue.T7EffectiveDate,
                                T7ExpiryDate: pvalue.T7ExpiryDate,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
                if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                    if (pvalue.TableTempID8 == $scope.TableTempID) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle8: pvalue.TableTitle8,
                                TableTempID8: $scope.cloneTableTempID,
                                T8ForModelNo: pvalue.T8ForModelNo,
                                T8NoOfBoardsNeeded: pvalue.T8NoOfBoardsNeeded,
                                T8SellingPricing: pvalue.T8SellingPricing,
                                T8Lifespan: pvalue.T8Lifespan,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                }
            });
        }
        $scope.EditAction = function (e, CTable, Id) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;

            $scope.TableTitle = "";
            $scope.QRTUpdate = true;
            $scope.vm.T1PestType = null;
            $scope.vm.T1Frequency = null;

            $scope.vm.T1ScopeofWork = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Description = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5Rate = null;
            $scope.vm.T5Amount = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7SerialNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7LeasePerAnnum = null;
            $scope.vm.T7EffectiveDate = null;
            $scope.vm.T7ExpiryDate = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;

            if (CTable == 'Title1') {
                $scope.Title1 = true;
                $scope.TableTitle = $scope.vm.TableTitle1;
                $scope.vm.QRT_Id = Id;
                var item = $scope.Contractquotationdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.T1PestType = item.T1PestType;
                $scope.vm.T1ScopeofWork = item.T1ScopeofWork;
                $scope.vm.T1Frequency = item.T1Frequency;
                $scope.vm.T1Pricing = parseInt(item.T1Pricing);
            }
            else if (CTable == 'Title2') {
                $scope.Title2 = true; $scope.TableTitle = $scope.vm.TableTitle2;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T2PestType = item.T2PestType;
                    $scope.vm.T2Timing = item.T2Timing;
                    $scope.vm.T2Quantity = parseInt(item.T2Quantity);
                    $scope.vm.T2Frequency = item.T2Frequency;
                    $scope.vm.T2Pricing = parseInt(item.T2Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title3') {
                $scope.Title3 = true; $scope.TableTitle = $scope.vm.TableTitle3;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T3Area = item.T3Area;
                    $scope.vm.T3PestType = item.T3PestType;
                    $scope.vm.T3Quantity = parseInt(item.T3Quantity);
                    $scope.vm.T3Timing = item.T3Timing;
                    $scope.vm.T3Frequency = item.T3Frequency;
                    $scope.vm.T3Pricing = parseInt(item.T3Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title4') {
                $scope.Title4 = true; $scope.TableTitle = $scope.vm.TableTitle4;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T4Product = item.T4Product;
                    $scope.vm.T4NoOfPieces = parseInt(item.T4NoOfPieces);
                    $scope.vm.T4Pricing = parseInt(item.T4Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title5') {
                $scope.Title5 = true; $scope.TableTitle = $scope.vm.TableTitle5;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T5Description = item.T5Description;
                    $scope.vm.T5Quantity = parseInt(item.T5Quantity);
                    $scope.vm.T5Rate = parseInt(item.T5Rate);
                    $scope.vm.T5Amount = parseInt(item.T5Amount);
                }
                catch (e) { }
            }
            else if (CTable == 'Title6') {
                $scope.Title6 = true; $scope.TableTitle = $scope.vm.TableTitle6;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T6Description = item.T6Description;
                    $scope.vm.T6Price = parseInt(item.T6Price);
                }
                catch (e) { }
            }
            else if (CTable == 'Title7') {
                $scope.Title7 = true; $scope.TableTitle = $scope.vm.TableTitle7;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T7SerialNo = item.T7SerialNo;
                    $scope.vm.T7ForModelNo = item.T7ForModelNo;
                    $scope.vm.T7LeasePerAnnum = parseInt(item.T7LeasePerAnnum);
                    if (item.T7EffectiveDate != undefined && item.T7EffectiveDate != null && item.T7EffectiveDate != "") { $scope.vm.T7EffectiveDate = new Date(item.T7EffectiveDate); }
                    if (item.T7ExpiryDate != undefined && item.T7ExpiryDate != null && item.T7ExpiryDate != "") { $scope.vm.T7ExpiryDate = new Date(item.T7ExpiryDate); }
                }
                catch (e) { }
            }
            else if (CTable == 'Title8') {
                $scope.Title8 = true; $scope.TableTitle = $scope.vm.TableTitle8;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T8ForModelNo = item.T8ForModelNo;
                    $scope.vm.T8NoOfBoardsNeeded = parseInt(item.T8NoOfBoardsNeeded);
                    $scope.vm.T8SellingPricing = parseInt(item.T8SellingPricing);
                    $scope.vm.T8Lifespan = item.T8Lifespan;
                }
                catch (e) { }
            }
            else { $scope.vm.QRT_Id = null; }

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/contractstemplates/contractpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractstemplatesController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }
        $scope.PestManagement = function (e, CTable) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/contractstemplates/contractpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractstemplatesController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;
            if (CTable == 'Title1') { $scope.Title1 = true; $scope.TableTitle = $scope.vm.TableTitle1 }
            if (CTable == 'Title2') { $scope.Title2 = true; $scope.TableTitle = $scope.vm.TableTitle2 }
            if (CTable == 'Title3') { $scope.Title3 = true; $scope.TableTitle = $scope.vm.TableTitle3 }
            if (CTable == 'Title4') { $scope.Title4 = true; $scope.TableTitle = $scope.vm.TableTitle4 }
            if (CTable == 'Title5') { $scope.Title5 = true; $scope.TableTitle = $scope.vm.TableTitle5 }
            if (CTable == 'Title6') { $scope.Title6 = true; $scope.TableTitle = $scope.vm.TableTitle6 }
            if (CTable == 'Title7') { $scope.Title7 = true; $scope.TableTitle = $scope.vm.TableTitle7 }
            if (CTable == 'Title8') { $scope.Title8 = true; $scope.TableTitle = $scope.vm.TableTitle8 }

            $scope.vm.T1PestType = null;
            $scope.vm.T1Frequency = null;

            $scope.vm.T1ScopeofWork = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Description = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5Rate = null;
            $scope.vm.T5Amount = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7SerialNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7LeasePerAnnum = null;
            $scope.vm.T7EffectiveDate = null;
            $scope.vm.T7ExpiryDate = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };
        $scope.templateinfo = function (TId) {
            debugger
            $scope.SID = TId;
            $scope.Update = true;
            $scope.ContractsTemplatesform = true;
            $scope.ContractsTemplatesgrid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;
            $scope.Search = false;
            angular.forEach($scope.Contracttemplates, function (value) {
                if (value.id == TId) {
                    $scope.vm.ContractId = value.id;
                    $scope.vm.TemplateName = value.TemplateName;
                    $scope.vm.TableTitle = value.TableTitle;
                    $scope.vm.Subject = value.Subject;
                    $scope.vm.TermsCondition = value.TermsCondition;
                    $scope.vm.Footer = value.Footer;
                    $scope.vm.Header = value.Header;
                    $scope.TableTempID = value.TemplateID;
                    angular.forEach($scope.Contractquotationdatas, function (qvalue) {
                        if (qvalue.TableTempID1 == value.TemplateID) {
                            $scope.vm.TableTitle1 = qvalue.TableTitle1;
                            $scope.vm.TableTempID1 = qvalue.TableTempID1;
                        }
                        if (qvalue.TableTempID2 == value.TemplateID) {
                            $scope.vm.TableTitle2 = qvalue.TableTitle2;
                            $scope.vm.TableTempID2 = qvalue.TableTempID2;
                        }
                        if (qvalue.TableTempID3 == value.TemplateID) {
                            $scope.vm.TableTitle3 = qvalue.TableTitle3;
                            $scope.vm.TableTempID3 = qvalue.TableTempID3;
                        }
                        if (qvalue.TableTempID4 == value.TemplateID) {
                            $scope.vm.TableTitle4 = qvalue.TableTitle4;
                            $scope.vm.TableTempID4 = qvalue.TableTempID4;
                        }
                        if (qvalue.TableTempID5 == value.TemplateID) {
                            $scope.vm.TableTitle5 = qvalue.TableTitle5;
                            $scope.vm.TableTempID5 = qvalue.TableTempID5;
                        }
                        if (qvalue.TableTempID6 == value.TemplateID) {
                            $scope.vm.TableTitle6 = qvalue.TableTitle6;
                            $scope.vm.TableTempID6 = qvalue.TableTempID6;
                        }
                        if (qvalue.TableTempID7 == value.TemplateID) {
                            $scope.vm.TableTitle7 = qvalue.TableTitle7;
                            $scope.vm.TableTempID7 = qvalue.TableTempID7;
                        }
                        if (qvalue.TableTempID8 == value.TemplateID) {
                            $scope.vm.TableTitle8 = qvalue.TableTitle8;
                            $scope.vm.TableTempID8 = qvalue.TableTempID8;
                        }
                    });
                }
            });
        }
        $scope.sSubmit = function () {
            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }
            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contracttemplate/update",
                    data: {
                        _id: $scope.SID,
                        TemplateID: $scope.TableTempID,
                        TemplateName: $scope.vm.TemplateName,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.vm.Subject,
                        TermsCondition: $scope.vm.TermsCondition,
                        Footer: $scope.vm.Footer,
                        Header: $scope.vm.Header,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $scope.ContractsTemplatesform = false;
                    $scope.ContractsTemplatesgrid = true;
                    $scope.Export = true;
                    $scope.Pageform = false;
                    $scope.Add = true;
                    $scope.Search = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contracttemplate/add",
                    data: {
                        TemplateID: $scope.TableTempID,
                        TemplateName: $scope.vm.TemplateName,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.vm.Subject,
                        TermsCondition: $scope.vm.TermsCondition,
                        Footer: $scope.vm.Footer,
                        Header: $scope.vm.Header,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    debugger
                    if (GList.data.message == "Existing TemplateName") {
                        $scope.error1 = true;
                        $scope.ContractsTemplatesform = true;
                        $scope.ContractsTemplatesgrid = false;
                        $scope.Export = false;
                        $scope.Add = false;
                        $scope.Search = false;
                        $scope.view = true;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Template Saved!').position('top center'));
                        RefreshGrid();
                        $scope.ContractsTemplatesform = false;
                        $scope.ContractsTemplatesgrid = true;
                        $scope.Export = true;
                        $scope.Pageform = false;
                        $scope.Add = true;
                        $scope.Search = true;
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/contracttemplate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (contracttemplate) {
            $scope.Contracttemplates = contracttemplate.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "GET",
                url: $rootScope.WebURL + "/client",
            }).then(function (Clientdata) {
                var data = Clientdata.data.data;
                $scope.Clientdata = data.filter(function (item) {
                    return item.id == $rootScope.Client_Id
                })[0]
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.Pestdatas = pestdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/areas",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (areasdata) {
                $scope.areasdatas = areasdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contractquotationdata) {
                $scope.Contractquotationdatas = contractquotationdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contracttemplate",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contracttemplate) {
                $scope.Contracttemplates = contracttemplate.data.data;
            });
        }

        RefreshGrid()

        function quotationRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contractquotationdata) {
                $scope.Contractquotationdatas = contractquotationdata.data.data;
            });
        }

        var vm = this;
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        // $timeout(function() {
        //     vm.Header = "<div><h3><span></span><div>This contract is an agreement made between the client stated above (hereinafter called <b><span><b>&#34;The Client&#34;) </b></span></b><span>and "+ $scope.Clientdata.ClientName+" (hereinafter called </span><b><span><b>&#34;The Contractor&#34;</b></span></b><span >) as follows:-</span></div></h3></div><div><h5><p></p><p><br/></p><p></p><p><span><b>COMMENCEMENT OF CONTRACT </b></span></b></p></h5><h3><span>This Contract will hereby commence at the above service location from<b> ____</b></span><span> to </span><u><span>_____</span></u><span> and to hold unto The Client for a period of <b> _______</b></span><span>. The Client agrees to pay for the scope of work on a <u>____ </u></span><span>basis, a sum of Singapore Dollars <b>_____</b></span><span> per month. </span><span>Payable to </span><span>"+$scope.Clientdata.ClientName+" </span><span>within <b>___</b> of invoice. Additional services stated on the Schedule of Rates will be charged separately.</span></h3><div><p><br/></p></div><p></p><p></p><p><span></span></p><p><b><span><b>SERVICE HOURS</b></span></b></p><p><span>Refer to the ‘Scope of Work’ as stated below will be carried out </span><b><span><b>During</b></span></b><span> </span><b><span><b>Office Hours</b></span></b><span>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range.</span></p><!--EndFragment--><br/><b>ACCESS TO PREMISES</b><br/></div><div><p>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p><p><br/></p></div><div><h5><b>LIABILITY</b></h5></div><div><p>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br/></p><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div><p><br/></p><p></p></div><div><h5><b>TERMINATION OF CONTRACT</b></h5></div><div><p>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Months·notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>";
        // }, 3000);

        vm.Footer11 = '<p>It is hereby agreed that the CLIENT will make annual payments in advance for the maintenance agreement as stipulated in the table indicated and all prices quoted are subjected to prevailing GST.<br><br>Should you have any clarifications, please do not hesitate to contact me.<br><br>Thank you.</p>';
        vm.TermsCondition11 = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        //vm.dtOptions = {
        //    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        //    initComplete: function () {
        //        var api = this.api(),
        //            searchBox = angular.element('body').find('#forms-search');
        //        // Bind an external input as a table wide search box
        //        if (searchBox.length > 0) {
        //            searchBox.on('keyup', function (event) {
        //                api.search(event.target.value).draw();
        //            });
        //        }
        //    },
        //    pagingType: 'simple',
        //    autoWidth: false,
        //    lengthMenu: [10, 20, 30, 50, 100],
        //    responsive: true,
        //    "language": {
        //        "lengthMenu": $rootScope.lengthMenu,
        //        "zeroRecords": $rootScope.zeroRecords,
        //        "info": $rootScope.info,
        //        "infoEmpty":$rootScope.infoEmpty,
        //        "infoFiltered": $rootScope.infoFiltered,
        //        "Header":$rootScope.Header,
        //    }
        //};
    }



})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');

        // Navigation
        //var IsAccess = 0;
        //if (IsAccess == 1) {

        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 2
        });
        }

    //    else {
    //        return
    //    }
    //}
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accounts.reports.profitloss', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_profitloss', {
            url: '/profitloss',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/profitloss/profitloss.html',
                    controller: 'profitlossController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/profitloss');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.profitloss')
        .controller('profitlossController', profitlossController);

    function profitlossController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        //var today = new Date();
        //var end = new Date();
        //$scope.uFrom = today;
        //$scope.uFrom.setHours(0, 0, 0, 0);
        //$scope.uTo = end;
        //$scope.uTo.setHours(23, 59, 59, 999);

        debugger
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());

        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);



        RefreshChartofAccount();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }



        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        UniqueLedgerFilter();
        function UniqueLedgerFilter() {
            debugger
            $scope.Uniqueledgersummary = undefined;

            var response = $http({
                url: $rootScope.WebURL + "/ledger/uniqueledgerdatefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.UniqueLedgerdatas = Ledgerdata.data.data;

                var Unique = [];

                angular.forEach($scope.ChartofAccountatas, function (value1) {

                    var item = $scope.UniqueLedgerdatas.filter(function (item) {
                        return item.AccountID === value1._id && value1.AccountClassification === "P&L";
                    })[0];

                    debugger

                    if (item != undefined) {

                        var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                            return Accitem._id === item.AccountID && value1.AccountClassification === "P&L";
                        })[0];

                        Unique.push({
                            AccountCode: Accitem.AccountCode,
                            AccountDescription: Accitem.AccountDescription,
                            AccountGroup: Accitem.Grouping,
                            CreditAmountTotal: item.totalCreditAmount,
                            DebitAmountTotal: item.totalDebitAmount,
                        });
                    }
                    else {
                        if (value1.AccountClassification === "P&L") {
                            Unique.push({
                                AccountCode: value1.AccountCode,
                                AccountDescription: value1.AccountDescription,
                                AccountGroup: value1.Grouping,
                                CreditAmountTotal: 0,
                                DebitAmountTotal: 0,
                            });
                        }
                    }

                });


                $scope.Uniqueledgersummary = Unique;


            });
        }

        $scope.UniqueLedgerFilter = function () {
            UniqueLedgerFilter();
        }

        $scope.Export = function () {

            var Unique = [];

            var TotalCreditAmount = 0;
            var TotalDebitAmount = 0;
            var TotalIncomes = 0;
            var TotalExpenses = 0;

            debugger
            angular.forEach($scope.ChartofAccountatas, function (value1) {

                var item = $scope.UniqueLedgerdatas.filter(function (item) {
                    return item.AccountID === value1._id && value1.AccountClassification === "P&L" && value1.Grouping === "Income";
                })[0];



                if (item != undefined) {

                    var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                        return Accitem._id === item.AccountID && value1.AccountClassification === "P&L" && value1.Grouping === "Income";
                    })[0];

                    Unique.push({
                        AccountCode: Accitem.AccountCode,
                        AccountDescription: Accitem.AccountDescription,
                        CreditAmountTotal: item.totalCreditAmount,
                        DebitAmountTotal: item.totalDebitAmount,
                    });

                    TotalCreditAmount = TotalCreditAmount + item.totalCreditAmount;
                    TotalDebitAmount = TotalDebitAmount + item.totalDebitAmount;

                }
                else {
                    if (value1.AccountClassification === "P&L" && value1.Grouping === "Income") {
                        Unique.push({
                            AccountCode: value1.AccountCode,
                            AccountDescription: value1.AccountDescription,
                            CreditAmountTotal: 0,
                            DebitAmountTotal: 0,
                        });
                    }
                }

            });

            debugger
            TotalIncomes = TotalIncomes + (TotalDebitAmount - TotalCreditAmount)

            debugger
            Unique.push({
                AccountCode: "",
                AccountDescription: "Total",
                CreditAmountTotal: TotalCreditAmount,
                DebitAmountTotal: TotalDebitAmount,
            });


            Unique.push({
                AccountCode: "",
                AccountDescription: "Gross Profit",
                CreditAmountTotal: TotalIncomes,
                DebitAmountTotal: "",
            });


            TotalCreditAmount = 0;
            TotalDebitAmount = 0;

            angular.forEach($scope.ChartofAccountatas, function (value1) {

                var item = $scope.UniqueLedgerdatas.filter(function (item) {
                    return item.AccountID === value1._id && value1.AccountClassification === "P&L" && value1.Grouping === "Expense";
                })[0];

                debugger

                if (item != undefined) {

                    var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                        return Accitem._id === item.AccountID && value1.AccountClassification === "P&L" && value1.Grouping === "Expense";
                    })[0];

                    Unique.push({
                        AccountCode: Accitem.AccountCode,
                        AccountDescription: Accitem.AccountDescription,
                        CreditAmountTotal: item.totalCreditAmount,
                        DebitAmountTotal: item.totalDebitAmount,
                    });

                    TotalCreditAmount = TotalCreditAmount + item.totalCreditAmount;
                    TotalDebitAmount = TotalDebitAmount + item.totalDebitAmount;

                }
                else {
                    if (value1.AccountClassification === "P&L" && value1.Grouping === "Income") {
                        Unique.push({
                            AccountCode: value1.AccountCode,
                            AccountDescription: value1.AccountDescription,
                            CreditAmountTotal: 0,
                            DebitAmountTotal: 0,
                        });
                    }
                }

            });


            TotalExpenses = TotalExpenses + (TotalDebitAmount - TotalCreditAmount)


            Unique.push({
                AccountCode: "",
                AccountDescription: "Total",
                CreditAmountTotal: TotalCreditAmount,
                DebitAmountTotal: TotalDebitAmount,
            });


            Unique.push({
                AccountCode: "",
                AccountDescription: "Gross Loss",
                CreditAmountTotal: "",
                DebitAmountTotal: TotalExpenses,
            });

            Unique.push({
                AccountCode: "",
                AccountDescription: "Total Gross",
                CreditAmountTotal: TotalIncomes - TotalExpenses,
                DebitAmountTotal: " ",
            });

            $scope.UniqueledgerReport = Unique;

            alasql('SELECT AccountCode,AccountDescription,DebitAmountTotal As Debit,CreditAmountTotal AS Credit INTO XLSX("Profit&Loss.xlsx",{headers:true}) FROM ?', [$scope.UniqueledgerReport]);
        };

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },


            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            },
            drawCallback: function (settings) {
                var api = this.api();
                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(1, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });

            }
        };

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.viewgeneralledger', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_viewgeneralledger', {
            url: '/Generalledger',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/viewgeneralledger/viewgeneralledger.html',
                    controller: 'ViewgeneralledgerController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/viewgeneralledger');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.viewgeneralledger')
        .controller('ViewgeneralledgerController', ViewgeneralledgerController);

    function ViewgeneralledgerController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        //var today = new Date();
        //var end = new Date();
        //$scope.uFrom = today;
        //$scope.uFrom.setHours(0, 0, 0, 0);
        //$scope.uTo = end;
        //$scope.uTo.setHours(23, 59, 59, 999);

        debugger
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());

        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);



        RefreshChartofAccount();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        $scope.ViewLedgerHistory = function (e, LedgerId, LedgerType) {


            $scope.LedgerId = LedgerId;

            var response = $http({
                url: $rootScope.WebURL + "/ledger/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {

                $scope.Ledgerdatas = Ledgerdata.data.data;

                var item = $scope.Ledgerdatas.filter(function (item) {

                    return item.AccountID === LedgerId;
                });
                debugger
                $scope.deatilgrid = item;
            });

            if (LedgerType[0] == 'Sales') {
                $mdDialog.show({
                    templateUrl: 'app/main/apps/accounts/reports/viewgeneralledger/ledgerSaleshistory.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function ViewgeneralledgerController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            }
            else {
                $mdDialog.show({
                    templateUrl: 'app/main/apps/accounts/reports/viewgeneralledger/ledgerpayableshistory.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function ViewgeneralledgerController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            }



        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        UniqueLedgerFilter();
        function UniqueLedgerFilter() {
            debugger
            $scope.Uniqueledgersummary = undefined;

            var response = $http({
                url: $rootScope.WebURL + "/ledger/uniqueledgerdatefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.UniqueLedgerdatas = Ledgerdata.data.data;

                var Unique = [];
                angular.forEach($scope.UniqueLedgerdatas, function (value) {

                    angular.forEach($scope.ChartofAccountatas, function (value1) {

                        if (value.AccountID == value1._id) {

                            Unique.push({
                                _id: value.AccountID,
                                AccountCode: value1.AccountCode,
                                AccountDescription: value1.AccountDescription,
                                DebitAmountTotal: value.totalDebitAmount,
                                CreditAmountTotal: value.totalCreditAmount,
                                Balance: value.Balance,
                                LedgerType: value.LedgerType,
                            })
                        }
                    });
                });
                debugger
                $scope.Uniqueledgersummary = Unique;


            });
        }

        $scope.UniqueLedgerFilter = function () {
            UniqueLedgerFilter();
        }

        $scope.Export = function () {

            var ExportData = [];
            angular.forEach($scope.Ledgerdatas, function (value, key) {


                if (value.Customerdetails.length > 0 && value.Accountdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: value.Accountdetails[0].AccountCode,
                        AccountDescription: value.Accountdetails[0].AccountDescription,
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: value.Customerdetails[0].CustomerReference,
                        CustomerName: value.Customerdetails[0].CompanyName,
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }
                else if (value.Supplierdetails.length > 0 && value.Accountdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: value.Accountdetails[0].AccountCode,
                        AccountDescription: value.Accountdetails[0].AccountDescription,
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: value.Supplierdetails[0].ReferenceNo,
                        SupplierName: value.Supplierdetails[0].Name,
                    });
                }
                else if (value.Accountdetails == 0 && value.Customerdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: value.Customerdetails[0].CustomerReference,
                        CustomerName: value.Customerdetails[0].CompanyName,
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }
                else if (value.Accountdetails == 0 && value.Supplierdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: value.Supplierdetails[0].ReferenceNo,
                        SupplierName: value.Supplierdetails[0].Name,
                    });
                }
                else {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }



            })

            alasql('SELECT * INTO XLSX("Ledger.xlsx",{headers:true}) FROM ?', [ExportData]);
        };

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.trailbalance', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_trailbalance', {
            url: '/trailbalance',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/trailbalance/trailbalance.html',
                    controller: 'trailbalanceController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/trailbalance')
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.trailbalance')
        .controller('trailbalanceController', trailbalanceController);

    function trailbalanceController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        //var today = new Date();
        //var end = new Date();
        //$scope.uFrom = today;
        //$scope.uFrom.setHours(0, 0, 0, 0);
        //$scope.uTo = end;
        //$scope.uTo.setHours(23, 59, 59, 999);

        debugger
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());

        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);



        RefreshChartofAccount();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }



        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        UniqueLedgerFilter();
        function UniqueLedgerFilter() {
            debugger
            $scope.Uniqueledgersummary = undefined;

            var response = $http({
                url: $rootScope.WebURL + "/ledger/uniqueledgerdatefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.UniqueLedgerdatas = Ledgerdata.data.data;

                var Unique = [];

                angular.forEach($scope.ChartofAccountatas, function (value1) {

                    var item = $scope.UniqueLedgerdatas.filter(function (item) {
                        return item.AccountID === value1._id;
                    })[0];

                    debugger

                    if (item != undefined) {

                        var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                            return Accitem._id === item.AccountID;
                        })[0];

                        Unique.push({
                            AccountCode: Accitem.AccountCode,
                            AccountDescription: Accitem.AccountDescription,
                            CreditAmountTotal: item.totalCreditAmount,
                            DebitAmountTotal: item.totalDebitAmount,
                        });
                    }
                    else {
                        Unique.push({
                            AccountCode: value1.AccountCode,
                            AccountDescription: value1.AccountDescription,
                            CreditAmountTotal: 0,
                            DebitAmountTotal: 0,
                        });
                    }

                });


                $scope.Uniqueledgersummary = Unique;


            });
        }

        $scope.UniqueLedgerFilter = function () {
            UniqueLedgerFilter();
        }

        $scope.Export = function () {

            var Unique = [];

            var TotalCreditAmount = 0;
            var TotalDebitAmount = 0;

            angular.forEach($scope.ChartofAccountatas, function (value1) {

                var item = $scope.UniqueLedgerdatas.filter(function (item) {
                    return item.AccountID === value1._id;
                })[0];

                debugger

                if (item != undefined) {

                    var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                        return Accitem._id === item.AccountID;
                    })[0];

                    Unique.push({
                        AccountCode: Accitem.AccountCode,
                        AccountDescription: Accitem.AccountDescription,
                        CreditAmountTotal: item.totalCreditAmount,
                        DebitAmountTotal: item.totalDebitAmount,
                    });

                    TotalCreditAmount = TotalCreditAmount + item.totalCreditAmount;
                    TotalDebitAmount = TotalDebitAmount + item.totalDebitAmount;

                }
                else {
                    Unique.push({
                        AccountCode: value1.AccountCode,
                        AccountDescription: value1.AccountDescription,
                        CreditAmountTotal: 0,
                        DebitAmountTotal: 0,
                    });
                }

            });

            Unique.push({
                AccountCode: "",
                AccountDescription: "Total",
                CreditAmountTotal: TotalCreditAmount,
                DebitAmountTotal: TotalDebitAmount,
            });



            $scope.UniqueledgerReport = Unique;

            alasql('SELECT AccountCode,AccountDescription,DebitAmountTotal As Debit,CreditAmountTotal AS Credit INTO XLSX("TrailBalance.xlsx",{headers:true}) FROM ?', [$scope.UniqueledgerReport]);
        };

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },


            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.billingreport', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_billingreport', {
            url: '/billingreport',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/billingreport/billingreport.html',
                    controller: 'billingreportController as vm' 
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/billingreport');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.billingreport')
        .controller('billingreportController', billingreportController);

    function billingreportController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');

        $scope.grid = true;
        $scope.Export = true;
        $scope.form = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;
        $scope.isLoading = true;


        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        RefreshCustomer();
        RefreshSalesOrder();
        RefreshContract();
        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }
        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }


        $scope.Filter = function () {
            $scope.isLoading = false;
            RefreshInvoice();
        }

        RefreshInvoice();
        RefreshScheduler();

        function RefreshInvoice() {
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/datefilter",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                $scope.isLoading = true;
                debugger
                $scope.AllSalesinvoicedatas = salesinvoicedata.data.data;

                if ($scope.CustomerID != undefined && $scope.ContractID != undefined && $scope.WorkOrderID != undefined) {
                    var item = $scope.AllSalesinvoicedatas.filter(function (item) {
                        return item.CustomerID === $scope.CustomerID && item.ContractID === $scope.ContractID && item.WorkOrderID === $scope.WorkOrderID;
                    });
                    $scope.Salesinvoicedatas = item;
                    ReportSummary();
                }
                else if ($scope.CustomerID != undefined && $scope.ContractID == undefined && $scope.WorkOrderID == undefined) {
                    var item = $scope.AllSalesinvoicedatas.filter(function (item) {
                        return item.CustomerID === $scope.CustomerID;
                    });
                    $scope.Salesinvoicedatas = item;
                    ReportSummary();
                }


                // if (ContractID != undefined  ) {
                //     var item = $scope.Salesinvoicedatas.filter(function (item) {
                //         return item.ContractID === ContractID;
                //     }); 
                //     $scope.Salesinvoicedatas=item;
                // }
                // if (WorkOrderID != undefined) {
                //     var item = $scope.Salesinvoicedatas.filter(function (item) {
                //         return item.WorkOrderID === WorkOrderID;
                //     }); 
                //     $scope.Salesinvoicedatas=item;
                // }


            });
        }
        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }
        function ReportSummary() {
            var Reportdata = [];
            angular.forEach($scope.Salesinvoicedatas, function (value) {

                $scope.ServiceDate = undefined; var array2 = [];

                try {
                    if (value.ServiceID != null && value.ServiceID != "" && value.ServiceID != undefined) {
                        var array = value.ServiceID.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ ServiceID: value });
                            var Serviceitem = $scope.schedulerdatas.filter(function (item) {
                                return item.ServiceID === value;
                            })[0];
                            if (Serviceitem != undefined) {
                                array2.push({ ServiceDate: convertDate(Serviceitem.Startsat) });
                            }
                        });

                        if (array2.length > 0) {
                            $scope.ServiceDate = array2.map(function (obj) { return obj.ServiceDate; }).join(',');
                        }
                    }
                } catch (error) {

                }

                var ServiceID = value.ServiceID;
                var ServiceDate = $scope.ServiceDate;
                var InvoiceNumber = value.InvoiceNumber;
                var InvoiceDate = value.Date;
                var Amount = value.Amount;
                var InvoiceAmount = value.InvoiceAmount;
                var OutStandingAmount = value.OutStandingAmount;
                var Status = value.Status;

                Reportdata.push({
                    ServiceID: ServiceID,
                    ServiceDate: ServiceDate,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceDate: InvoiceDate,
                    Amount: Amount,
                    InvoiceAmount: InvoiceAmount,
                    OutStandingAmount: OutStandingAmount,
                    Status: Status,
                })
            });

            $scope.Salesdatas = Reportdata;
        }

        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GList) {
                $scope.schedulerdatas = GList.data.data;
            });
        }

        function ClearForm() {

            $scope.Description = '';
            $scope.AccountingCode = '';
            $scope.JournalVoucherNumber = '';
            $scope.TransactionType = '';
            $scope.Amount = '';
            $scope.Remarks = '';
            $scope.TransactionDate = new Date(new Date().setFullYear(new Date().getFullYear()));

        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("BillingReport.xlsx",{headers:true}) FROM ?', [$scope.Salesdatas]);
        };


        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };






        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }
        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.reconciliation', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_reconciliation', {
            url: '/reconciliation',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/reconciliation/reconciliation.html',
                    controller: 'reconciliationController as vm' 
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/reconciliation');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.reconciliation')
        .controller('reconciliationController', reconciliationController);

    function reconciliationController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.grid = true;
        $scope.Export = true;
        $scope.form = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.form = true;
            $scope.grid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.error1 = false;
        }

        $scope.Showgrid = function () {
            $scope.grid = true;
            $scope.form = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.error1 = false;
        }

        // $http.get( $rootScope.WebURL + "/chartofaccount")
        //     .then(function (ChartofAccountdata) {
        //         $scope.ChartofAccountatas = ChartofAccountdata.data.data;
        //     });


        $scope.Ledgerinfo = function (LedgerID) {

            $scope.Update = true;
            $scope.form = true;
            $scope.grid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;

            $scope.LedgerID = LedgerID;

            angular.forEach($scope.Ledgerdatas, function (value, key) {
                if (LedgerID == value.id) {

                    $scope.TransactionDate = value.TransactionDate;
                    $scope.Description = value.Description;
                    $scope.AccountingCode = value.AccountingCode;
                    $scope.JournalVoucherNumber = value.JournalVoucherNumber;
                    $scope.TransactionType = value.TransactionType;

                    if (value.TransactionType == "Credit") {
                        $scope.Amount = parseFloat(value.CreditAmount);
                    }
                    else {
                        $scope.Amount = parseFloat(value.DebitAmount);
                    }


                }
            });
        }

        $scope.Submit = function () {

            $scope.CreditAmount = null;
            $scope.DebitAmount = null;
            if ($scope.TransactionType == "Credit") {
                $scope.CreditAmount = $scope.Amount;
            }
            else {
                $scope.DebitAmount = $scope.Amount;
            }
            if ($scope.Update == true) {

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/ledger/update",
                    data: {
                        _id: $scope.LedgerID, TransactionDate: $scope.TransactionDate, Description: $scope.Description, AccountingCode: $scope.AccountingCode,
                        JournalVoucherNumber: $scope.JournalVoucherNumber, TransactionType: $scope.TransactionType, CreditAmount: $scope.CreditAmount,
                        DebitAmount: $scope.DebitAmount, UpdatedBy: $rootScope.ProfName
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.grid = true;
                    $scope.form = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();
                    $scope.displayStart = 12;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/ledger/add",

                    data: {
                        TransactionDate: $scope.TransactionDate, Description: $scope.Description, AccountingCode: $scope.AccountingCode,
                        JournalVoucherNumber: $scope.JournalVoucherNumber, TransactionType: $scope.TransactionType,
                        CreditAmount: $scope.CreditAmount, DebitAmount: $scope.DebitAmount, CreatedBy: $rootScope.ProfName
                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.grid = true;
                    $scope.form = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        // $http.get( $rootScope.WebURL + "/ledger")
        //     .then(function (Ledgerdata) {
        //         $scope.Ledgerdatas = Ledgerdata.data.data;
        //     });

        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/ledger")
                .then(function (Ledgerdata) {
                    $scope.Ledgerdatas = Ledgerdata.data.data;
                });
        }


        $scope.Filter = function () {
            var response = $http({
                url: $rootScope.WebURL + "/ledger/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Ledgerdata) {
                $scope.Ledgerdatas = Ledgerdata.data.data;
            });
        }

        function ClearForm() {

            $scope.Description = '';
            $scope.AccountingCode = '';
            $scope.JournalVoucherNumber = '';
            $scope.TransactionType = '';
            $scope.Amount = '';
            $scope.TransactionDate = new Date(new Date().setFullYear(new Date().getFullYear()));

        }

        $scope.ReconciliationExport = function () {
            alasql('SELECT * INTO XLSX("Reconciliation.xlsx",{headers:true}) FROM ?', [null]);
        };

        var vm = this;


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };






        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }
        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.generalledger', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_generalledger', {
            url: '/JournalEntry',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/generalledger/generalledger.html',
                    controller: 'generalledgerController as vm' 
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/generalledger');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.generalledger')
        .controller('generalledgerController', generalledgerController);

    function generalledgerController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');

        $scope.grid = true;
        $scope.Export = true;
        $scope.form = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.form = true;
            $scope.grid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.error1 = false;
        }

        $scope.Showgrid = function () {
            $scope.grid = true;
            $scope.form = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.error1 = false;
        }

        RefreshChartofAccount();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        $scope.Ledgerinfo = function (LedgerID) {
            debugger
            $scope.Update = true;
            $scope.form = true;
            $scope.grid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;

            $scope.LedgerID = LedgerID;

            angular.forEach($scope.Ledgerdatas, function (value, key) {
                if (LedgerID == value._id) {

                    $scope.TransactionDate = value.TransactionDate;
                    $scope.Description = value.Description;
                    $scope.AccountingCode = value.AccountID;
                    $scope.JournalVoucherNumber = value.JournalVoucherNumber;
                    $scope.TransactionType = value.TransactionType;
                    $scope.Remarks = value.Remarks;

                    if (value.TransactionType == "Credit") {
                        $scope.Amount = parseFloat(value.CreditAmount);
                    }
                    else {
                        $scope.Amount = parseFloat(value.DebitAmount);
                    }


                }
            });
        }

        $scope.Submit = function () {
            debugger
            $scope.CreditAmount = null;
            $scope.DebitAmount = null;
            if ($scope.TransactionType == "Credit") {
                $scope.CreditAmount = $scope.Amount;
            }
            else {
                $scope.DebitAmount = $scope.Amount;
            }
            if ($scope.Update == true) {

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/ledger/update",
                    data: {
                        _id: $scope.LedgerID, TransactionDate: $scope.TransactionDate, Description: $scope.Description, AccountID: $scope.AccountingCode,
                        JournalVoucherNumber: $scope.JournalVoucherNumber, TransactionType: $scope.TransactionType, CreditAmount: $scope.CreditAmount,
                        DebitAmount: $scope.DebitAmount, Remarks: $scope.Remarks, UpdatedBy: $rootScope.ProfName
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.grid = true;
                    $scope.form = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();
                    $scope.displayStart = 12;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/ledger/add",

                    data: {
                        TransactionDate: $scope.TransactionDate, Client_Id: Client_Id, Description: $scope.Description, AccountID: $scope.AccountingCode,
                        JournalVoucherNumber: $scope.JournalVoucherNumber, TransactionType: $scope.TransactionType,
                        CreditAmount: $scope.CreditAmount, DebitAmount: $scope.DebitAmount, Remarks: $scope.Remarks, CreatedBy: $rootScope.ProfName
                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.grid = true;
                    $scope.form = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        RefreshGrid();

        function RefreshGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/ledger",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.Ledgerdatas = Ledgerdata.data.data;
            });
        }


        $scope.Filter = function () {
            $scope.Ledgerdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/ledger/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.Ledgerdatas = Ledgerdata.data.data;
            });
        }

        function ClearForm() {

            $scope.Description = '';
            $scope.AccountingCode = '';
            $scope.JournalVoucherNumber = '';
            $scope.TransactionType = '';
            $scope.Amount = '';
            $scope.Remarks = '';
            $scope.TransactionDate = new Date(new Date().setFullYear(new Date().getFullYear()));

        }
        $scope.Export = function () {

            var ExportData = [];
            angular.forEach($scope.Ledgerdatas, function (value, key) {


                if (value.Customerdetails.length > 0 && value.Accountdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: value.Accountdetails[0].AccountCode,
                        AccountDescription: value.Accountdetails[0].AccountDescription,
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: value.Customerdetails[0].CustomerReference,
                        CustomerName: value.Customerdetails[0].CompanyName,
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }
                else if (value.Supplierdetails.length > 0 && value.Accountdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: value.Accountdetails[0].AccountCode,
                        AccountDescription: value.Accountdetails[0].AccountDescription,
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: value.Supplierdetails[0].ReferenceNo,
                        SupplierName: value.Supplierdetails[0].Name,
                    });
                }
                else if (value.Accountdetails == 0 && value.Customerdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: value.Customerdetails[0].CustomerReference,
                        CustomerName: value.Customerdetails[0].CompanyName,
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }
                else if (value.Accountdetails == 0 && value.Supplierdetails.length > 0) {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: value.Supplierdetails[0].ReferenceNo,
                        SupplierName: value.Supplierdetails[0].Name,
                    });
                }
                else {
                    ExportData.push({
                        TransactionDate: convertDate(value.TransactionDate),
                        TransactionDetails: value.Description,
                        AccountCode: "",
                        AccountDescription: "",
                        VoucherNumber: value.JournalVoucherNumber,
                        TransactionType: value.TransactionType,
                        CreditAmount: value.CreditAmount,
                        DebitAmount: value.DebitAmount,
                        CustomerCode: "",
                        CustomerName: "",
                        SupplierCode: "",
                        SupplierName: "",
                    });
                }



            })

            alasql('SELECT * INTO XLSX("Ledger.xlsx",{headers:true}) FROM ?', [ExportData]);
        };


        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };






        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }
        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }
        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.balancesheet', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_balancesheet', {
            url: '/balancesheet',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/reports/balancesheet/balancesheet.html',
                    controller: 'balancesheetController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/reports/balancesheet');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.reports.balancesheet')
        .controller('balancesheetController', balancesheetController);

    function balancesheetController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $filter, $mdDateLocale) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Ledger")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        //var today = new Date();
        //var end = new Date();
        //$scope.uFrom = today;
        //$scope.uFrom.setHours(0, 0, 0, 0);
        //$scope.uTo = end;
        //$scope.uTo.setHours(23, 59, 59, 999);

        debugger
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());

        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);



        RefreshChartofAccount();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }



        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        UniqueLedgerFilter();
        function UniqueLedgerFilter() {
            debugger
            $scope.Uniqueledgersummary = undefined;

            var response = $http({
                url: $rootScope.WebURL + "/ledger/uniqueledgerdatefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Ledgerdata) {
                $scope.UniqueLedgerdatas = Ledgerdata.data.data;

                var Unique = [];

                angular.forEach($scope.ChartofAccountatas, function (value1) {

                    var item = $scope.UniqueLedgerdatas.filter(function (item) {
                        return item.AccountID === value1._id && value1.AccountClassification === "Balance Sheet";
                    })[0];

                    debugger

                    if (item != undefined) {

                        var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                            return Accitem._id === item.AccountID && value1.AccountClassification === "Balance Sheet";
                        })[0];

                        Unique.push({
                            AccountCode: Accitem.AccountCode,
                            AccountDescription: Accitem.AccountDescription,
                            AccountGroup: Accitem.Grouping,
                            CreditAmountTotal: item.totalCreditAmount,
                            DebitAmountTotal: item.totalDebitAmount,
                        });
                    }
                    else {
                        if (value1.AccountClassification === "Balance Sheet") {
                            Unique.push({
                                AccountCode: value1.AccountCode,
                                AccountDescription: value1.AccountDescription,
                                AccountGroup: value1.Grouping,
                                CreditAmountTotal: 0,
                                DebitAmountTotal: 0,
                            });
                        }
                    }

                });


                $scope.Uniqueledgersummary = Unique;


            });
        }

        $scope.UniqueLedgerFilter = function () {
            UniqueLedgerFilter();
        }

        $scope.Export = function () {

            var Unique = [];

            var TotalCreditAmount = 0;
            var TotalDebitAmount = 0;

            angular.forEach($scope.ChartofAccountatas, function (value1) {

                var item = $scope.UniqueLedgerdatas.filter(function (item) {
                    return item.AccountID === value1._id && value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Liability";
                })[0];

                debugger

                if (item != undefined) {

                    var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                        return Accitem._id === item.AccountID && value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Liability";
                    })[0];

                    Unique.push({
                        AccountCode: Accitem.AccountCode,
                        AccountDescription: Accitem.AccountDescription,
                        CreditAmountTotal: item.totalCreditAmount,
                        DebitAmountTotal: item.totalDebitAmount,
                    });

                    TotalCreditAmount = TotalCreditAmount + item.totalCreditAmount;
                    TotalDebitAmount = TotalDebitAmount + item.totalDebitAmount;

                }
                else {
                    if (value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Liability") {
                        Unique.push({
                            AccountCode: value1.AccountCode,
                            AccountDescription: value1.AccountDescription,
                            CreditAmountTotal: 0,
                            DebitAmountTotal: 0,
                        });
                    }
                }

            });

            Unique.push({
                AccountCode: "",
                AccountDescription: "Total Liability",
                CreditAmountTotal: TotalCreditAmount,
                DebitAmountTotal: TotalDebitAmount,
            });

            TotalCreditAmount = 0;
            TotalDebitAmount = 0;

            angular.forEach($scope.ChartofAccountatas, function (value1) {

                var item = $scope.UniqueLedgerdatas.filter(function (item) {
                    return item.AccountID === value1._id && value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Asset";
                })[0];

                debugger

                if (item != undefined) {

                    var Accitem = $scope.ChartofAccountatas.filter(function (Accitem) {
                        return Accitem._id === item.AccountID && value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Asset";
                    })[0];

                    Unique.push({
                        AccountCode: Accitem.AccountCode,
                        AccountDescription: Accitem.AccountDescription,
                        CreditAmountTotal: item.totalCreditAmount,
                        DebitAmountTotal: item.totalDebitAmount,
                    });

                    TotalCreditAmount = TotalCreditAmount + item.totalCreditAmount;
                    TotalDebitAmount = TotalDebitAmount + item.totalDebitAmount;

                }
                else {
                    if (value1.AccountClassification === "Balance Sheet" && value1.Grouping === "Asset") {
                        Unique.push({
                            AccountCode: value1.AccountCode,
                            AccountDescription: value1.AccountDescription,
                            CreditAmountTotal: 0,
                            DebitAmountTotal: 0,
                        });
                    }
                }

            });


            Unique.push({
                AccountCode: "",
                AccountDescription: "Total Asset",
                CreditAmountTotal: TotalCreditAmount,
                DebitAmountTotal: TotalDebitAmount,
            });



            $scope.UniqueledgerReport = Unique;

            alasql('SELECT AccountCode,AccountDescription,DebitAmountTotal As Debit,CreditAmountTotal AS Credit INTO XLSX("BalanceSheet.xlsx",{headers:true}) FROM ?', [$scope.UniqueledgerReport]);
        };

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            drawCallback: function (settings) {
                var api = this.api();
                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(1, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });

            },

            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            fixedHeader: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.dashboard')
        .controller('DashboardaccountsController', DashboardaccountsController);

    /** @ngInject */
    function DashboardaccountsController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DAccounts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        debugger
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";

        totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;
        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalpayables = 0;
        $scope.totalpaid = 0;
        $scope.totalreceivables = 0;
        $scope.totalreceived = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;

                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;

                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }


        $scope.Range = function () {
            debugger

            var range = vm.widget1.currentRange;
            if (range == "All") {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (scheduler) {
                    $scope.schedulerdatas = scheduler.data.data;
                    $scope.totaljobs = $scope.schedulerdatas.length;

                    var item = $scope.schedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }


        RefreshAssetRegister();
        RefreshAssetDisposal();
        RefreshPurchaseinvoice();
        RefreshPaysupplier();
        RefreshSalesInvoice();
        RefreshCollectPayment();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                $scope.totalassets = $scope.AssetRegisterdatas.length;
            });


        }
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;

                $scope.totaldiposed = $scope.AssetDisposaldatas.length;
            });
        }

        function RefreshPurchaseinvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (purchaseinvoicedata) {
                debugger
                $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;

                $scope.totalpayables = $scope.Purchaseinvoicedatas.length;
            });
        }

        function RefreshPaysupplier() {

            var response = $http({
                url: $rootScope.WebURL + "/paysupplier",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (paysupplierdata) {
                $scope.Paysupplierdatas = paysupplierdata.data.data;

                $scope.totalpaid = $scope.Paysupplierdatas.length;
            });

        }

        function RefreshSalesInvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                debugger
                $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                $scope.totalreceivables = $scope.Salesinvoicedatas.length;
            });
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;

                $scope.totalreceived = $scope.CollectPaymentdatas.length;
            });
        }


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100]
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];




        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.pestoff.salesreceivables', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_salesreceivables', {
            url: '/salesreceivables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/Pestoff/salesreceivables/salesreceivables.html',
                    controller: 'salesreceivablesController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/Pestoff/salesreceivables');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.pestoff.salesreceivables')
        .controller('salesreceivablesController', salesreceivablesController);


    function salesreceivablesController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        document.getElementsByTagName('title')[0].text = "nvoice"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcLumiair")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $scope.TRCCdiv = false
        var select = 'always'
        $scope.Desc = true;
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);
        $scope.vm.uTo = $scope.uTo;
        $scope.vm.uFrom = $scope.uFrom;

        $scope.InvoiceSelect = true;
        $scope.InvoiceGrid = true;
        $scope.InvoiceForm = false;
        $scope.CollectPaymentSelect = false;
        $scope.CreditnoteSelect = false;
        $scope.CustomerStatementSelect = false;
        $scope.CreditnoteGrid = false;
        $scope.CreditnoteForm = false;
        $scope.DebitnoteSelect = false;
        $scope.DebitnoteGrid = false;
        $scope.DebitnoteForm = false;
        $scope.InvoiceFormback = false;
        $scope.CollectPaymentGrid = false;
        $scope.CollectPaymentForm = false;
        $scope.CollectPaymentFormback = false;

        $scope.FilterByCustomer = true;
        var dataGrid = ""

        vm.dataGridContract = {
            onInitialized: function (e) {
                dataGrid = e.component;
                RefreshInvoice()
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.Salesinvoicedatas,
            keyExpr: "_id",
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            // selection: {
            //     mode: "multiple",
            //     showCheckBoxesMode: select,
            //   },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "CustomerName", caption: "Customer Name" },
                { dataField: "SalesOrderNo", caption: "Work Order#" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy', sortOrder: 'desc' },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "PaymentMode", caption: "Payment Mode" },
                { dataField: "PurchaseOrderNo", caption: "Purchase Order No" },
                { dataField: "BillingAddress", caption: "Billing Address" },
                { dataField: "ServiceAddress", caption: "Service Address" },
                { dataField: "PestType", caption: "Pest Coverage" },
                { dataField: "BillingFrequency", caption: "Billing Frequency" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Xero Invoice No.", caption: "Remarks" },
                {
                    dataField: "PushedtoXero", caption: "Pushed to Xero?",
                    cellTemplate: function (container, options) {
                        if (options.data.PushedtoXero)
                            $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                        else
                            $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                    }
                },
                {
                    caption: 'Work Order Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                var url = $rootScope.ReportURL + 'WorkOrder.aspx' + '?' + 'ID=' + options.data.SalesOrderID;
                                window.open(url);
                            }
                        }).appendTo(container);
                    }
                },
                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                                // var byteArray = new Uint8Array(List.data.data.body.data);
                                // var blob = new Blob([byteArray], { type: 'application/pdf' });
                                //  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                //    window.navigator.msSaveOrOpenBlob(blob);
                                //  } else {
                                //    var objectUrl = URL.createObjectURL(blob);
                                //    window.open(objectUrl);
                                //  }
                                // var file = new Blob([List.data.data.body], {type: 'application/pdf'});
                                // var fileURL = URL.createObjectURL(file);

                                // 
                            }
                        }).appendTo(container);
                    }
                },
                // {
                //     caption: 'Send Email',
                //     width: "90",
                //     fixed: false,
                //     fixedPosition: 'right',
                //     alignment: 'center',
                //     allowSorting: false,
                //     cellTemplate: function (container, options) {
                //         $('<div />').dxButton({
                //             icon: 'email',
                //             onClick: function (e) {
                //                 $scope.SendMail(options.data._id, options.data.BillingFrequency, options.data.ServiceStartDate, options.data.ServiceEndDate, options.data.CreatedBy, 'Send Email')
                //             }
                //         }).appendTo(container);
                //     }
                // }

            ],
            bindingOptions: {
                dataSource: "Salesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "true",
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },
            // onToolbarPreparing: function (e) {
            //     e.toolbarOptions.items.unshift({
            //         location: "before",
            //         template: "totalGroupCount"
            //     }
            //     );
            // },
            onCellClick: function (data) {
                if (data.columnIndex == 1) {
                    var index = dataGrid.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo(data.data._id, index)
                }
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedIds = [];
                    $scope.TRCCdiv = true;
                    $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.TRCCdiv = false;
                    $scope.SelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
        };

        $scope.InvoiceFilter = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Status: "Paid", Type: "Invoice" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", Skip: Skip, Limit: Limit, Department: "Pest Off" }
                    }).then(function (GList) {
                        if (dataGrid != "")
                            $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.Salesinvoicedatas = $scope.Salesinvoicedatas.concat(GList.data.data)
                        $scope.Salesinvoicedatas = _.uniqWith($scope.Salesinvoicedatas, _.isEqual);
                        $scope.vm.PreviewSpinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        $scope.InvoiceFilterByDate = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/countbyDate",
                data: { Client_Id: $rootScope.Client_Id, Status: "Paid", Type: "Invoice", Department: 'Pest Off', StartDate: $scope.uFrom, EndDate: $scope.uTo }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                if (ContractLength == 0) {
                    $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                    $scope.Salesinvoicedatas = []
                    $scope.vm.PreviewSpinner = false
                }
                else {
                    for (var i = 0; i < ContractLength; i++) {
                        if (i == 0) Skip = 0
                        else Skip += 300
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/salesinvoice/getByDate",
                            data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", Skip: Skip, Limit: Limit, StartDate: $scope.uFrom, EndDate: $scope.uTo, Department: "Pest Off" }
                        }).then(function (GList) {
                            if (dataGrid != "")
                                $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                            $scope.Salesinvoicedatas = $scope.Salesinvoicedatas.concat(GList.data.data)
                            $scope.Salesinvoicedatas = _.uniqWith($scope.Salesinvoicedatas, _.isEqual);
                            $scope.vm.PreviewSpinner = false
                        })
                    }
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })
        };

        RefreshCustomer();

        $scope.PushtoXero = function () {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/pushtoxero",
                method: "PUT",
                data: { InvoiceArray: $scope.SelectedIds, CreatedBy: $rootScope.createdby },
            });
            response.then(function (salesinvoicedata) {
                $mdToast.show($mdToast.simple().textContent('Successfully Exported to Xero!').position('top center'));

            })
        }

        $scope.ChangeDate = function (Type) {
            if (Type == 'less') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
                $scope.uTo = new Date($scope.uFrom);
            }
            if (Type == 'greater') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
                $scope.uTo = new Date($scope.uFrom);
            }
        }

        GetTotalCurrentYearInvoices();
        function GetTotalCurrentYearInvoices() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearInvoices = 0 }


            });
        }

        $scope.ShowClosed = function (con) {
            $scope.DefaultInvoice = con
            if ($scope.DefaultInvoice) {
                select = 'none'
                $scope.Salesinvoicedatas = undefined;
                var FromDate = $scope.uFrom;
                var ToDate = $scope.uTo;
                var response = $http({
                    url: $rootScope.WebURL + "/salesinvoice/getByXero",
                    method: "POST",
                    data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
                });
                response.then(function (salesinvoicedata) {

                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                });
            }
            else {
                select = 'always'
                $scope.InvoiceFilterByDate()
            }
        }

        $scope.Invoiceadd = function (e) {
            ClearInvoice();

            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;

            var AR = "5" + new Date().getFullYear().toString().substr(-2);

            var info = $scope.TotalCurrentYearInvoices + 1;
            var y = pad(info, 6);
            $scope.InvoiceNumber = AR + y;

            var VR = "SV" + new Date().getFullYear().toString().substr(-2);

            $scope.VoucherNumber = VR + y;

            var item = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            if (item != undefined) {
                $scope.GSTID = item._id;
            }

            $scope.Date = new Date();
            $scope.VoucherDate = new Date();
            $scope.DueDate = new Date();

            $scope.Descriptiondatas = null;
            $scope.ServiceID = null;
            $scope.ServiceIDs = null;

        }

        $scope.ssubmit = function () {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/salesinvoice/newupdate',
                data: {
                    _id: $scope.InvoiceID,
                    DueDate: $scope.DueDate,
                    Amount: $scope.Amount,
                    Remarks: $scope.Remarks,
                    AmountReceived: $scope.AmountReceived
                }
            }).then(function (List) {
                RefreshInvoice();
                $scope.InvoiceGrid = true;
                $scope.InvoiceForm = false;
                $scope.InvoiceFormback = false;
                $scope.InvoiceSelect = true;
                $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
            })
        }

        $scope.ClearSearch = function () {

            $scope.searchTermc = null;
            $scope.CustomerID = null;
            $scope.vm.CustomerID = null;

        }


        $scope.SalesInvoiceInfo = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.Salesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: InvoiceID },
            });
            response1.then(function (GList) {

                $scope.Paymentdatas = GList.data.data;
            });
        }

        $scope.PDeletePopup = function (id, Amount) {
            $scope.PId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the payment?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/paymenthistory/delete",
                        method: "POST",
                        data: { _id: $scope.PId },
                    });
                    response.then(function (GList) {
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));
                        });
                    });
                    var ReduceAmount = parseFloat($scope.AmountReceived) - parseFloat(Amount)
                    var Outstanding = parseFloat($scope.OutStandingAmount) + parseFloat(Amount)
                    $scope.TOutStandingAmount = Outstanding.toString()
                    var Status = "Paid"
                    if (Outstanding != $scope.Amount && ReduceAmount > 0)
                        Status = "Partially Paid"
                    else if (ReduceAmount == 0) Status = "Unpaid"
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: ReduceAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.AmountReceived = ReduceAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $scope.InvoiceFilter()
                    })
                }
            });
        }

        RefreshBank();
        RefreshClientBank();

        $scope.SelectScheduler = function () {
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.ServiceID === $scope.ServiceID
            })[0]
            $scope.Description = moment(item.Startsat).format('DD MMMM YYYY') + " - " + item.PestType
        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshClientBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });
        }

        function RefreshInvoice() {
            $scope.InvoiceFilterByDate()
        }
        function ClearInvoice() {
            $scope.CustomerID = null; $scope.WorkOrderID = null; $scope.Date = null; $scope.VoucherNumber = null;
            $scope.Amount = null; $scope.ServiceIDs = null; $scope.GSTID = null; $scope.Description = null;
            $scope.VoucherDate = null; $scope.CreditTerm = null; $scope.Remarks = null;
            $scope.ContractID = null; $scope.ConID = null;
        }
        $scope.updateCustomRequest = function (data, type, res) {

        };

        $scope.OnTopInvoiceContractChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ContractID;
            })[0];

            $scope.ConID = $scope.ContractID;
            $scope.CustomerID = item.Customer_id;
            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.OnConChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ConID;
            })[0];

            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.IsAmountLoaded = false;


        GetTotalCurrentYearPayments();
        function GetTotalCurrentYearPayments() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearPayments = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearPayments = 0 }


            });
        }


        $scope.CollectPaymentadd = function (e) {

            $scope.InvoicefilterByCustomer();
            $scope.IsAmountLoaded = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            ClearCollectPayment();
            $scope.Update = false;

            $scope.vm.uTo = $scope.uTo;
            $scope.vm.uFrom = $scope.uFrom;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

            var itemB = $scope.Bankdatas.filter(function (item) {
                return item.BankName === "OCBC";
            })[0];

            $scope.vm.BankID = itemB._id;

            $scope.vm.Date = new Date();
            $scope.vm.VoucherDate = new Date();

            var info = $scope.TotalCurrentYearPayments + 1;
            var y = pad(info, 6);
            var VR = "CP" + new Date().getFullYear().toString().substr(-2);
            $scope.vm.VoucherNumber = VR + y;

            $scope.CPItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


        }

        $scope.SaveCollectPayment = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/collectpayment/update",
                    data: {
                        _id: $scope.CollectPaymentID, CustomerID: $scope.vm.CustomerID,
                        Description: $scope.vm.Description, Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID, ClientBankName: $scope.vm.ClientBankName, ChequeDate: $scope.vm.ChequeDate,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.CollectPaymentdatas[$scope.CollectPaymentIndex] = GList.data.data[0];

                    RefreshInvoice();
                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {




                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                        Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                    },
                });


                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    GetTotalCurrentYearPayments()
                    RefreshCollectPayment();
                    RefreshCustomerstatement();
                    RefreshInvoice();

                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }


        $scope.CollectPaymentinfo = function (CollectPaymentID, Index) {

            $scope.CollectPaymentIndex = Index;
            $scope.Salesinvoicedatasdd = $scope.Salesinvoicedatas;

            $scope.CollectPaymentID = CollectPaymentID;
            $scope.Update = true;

            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;

            var item = $scope.CollectPaymentdatas.filter(function (item) {
                return item._id === CollectPaymentID;
            })[0];

            $scope.vm.CustomerID = item.CustomerID;
            $scope.vm.BankID = item.BankID;
            $scope.vm.VoucherNumber = item.VoucherNumber;
            $scope.vm.VoucherDate = new Date(item.VoucherDate);
            $scope.vm.ChequeNumber = item.ChequeNumber;
            $scope.vm.ChequeDate = new Date(item.ChequeDate);
            $scope.vm.Description = item.Description;
            $scope.vm.Date = new Date(item.Date);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.ClientBankName = item.ClientBankName;

            $scope.CPItemDetails = item.itemDetails;

            $scope.IsAmountLoaded = true;

            $scope.HideAdd = true;
            $scope.HideSave = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

        }

        $scope.CPItemSubmit = function () {


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/collectpayment/add",
                data: {
                    CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                    Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                    VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Collectpayment") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/collectpayment/getByID",
                        data: {
                            VoucherNumber: $scope.vm.VoucherNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CollectPaymentID = GList.data.data[0]._id;
                        SaveCPItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CollectPaymentID = GList.data.data.id;
                    SaveCPItems(GList.data.data.id);
                    GetTotalCurrentYearPayments()
                }

            }, function () {


            });

        }


        $scope.CPItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }

            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/UpdateItem",
                data: {
                    CollectPaymentID: $scope.CollectPaymentID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    PaidAmount: $scope.PaidAmount,
                    InvoiceAmount: parseFloat(InvoiceAmount),
                    OutStandingAmount: OutStandingAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CPItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCPItems(CollectPaymentID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }


            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "PaidAmount": $scope.PaidAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceAmount": parseFloat(InvoiceAmount),
                "OutStandingAmount": OutStandingAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "_id": undefined
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/addItems",
                data: {
                    _id: CollectPaymentID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    InvoiceNumber: InvoiceNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Date: $scope.vm.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CPItemDetails != undefined) {
                    $scope.CPItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/getByID",
                    data: {
                        VoucherNumber: $scope.vm.VoucherNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CPItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CPItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CPItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.ServiceSelect = function () {
            RefreshScheduler()
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }

        $scope.CollectPaymentFilter = function () {
            $scope.CollectPaymentdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }
        function ClearCollectPayment() {

            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.Date = null;
            $scope.vm.ChequeDate = null;
            $scope.vm.Amount = null;
            $scope.vm.InvoiceID = null;
            $scope.vm.Description = null;
            $scope.vm.Remarks = null;
            $scope.vm.ChequeNumber = null;
            $scope.vm.VoucherNumber = null;
            $scope.vm.ClientBankName = null;
        }


        GetTotalCurrentYearCreditnotes();

        function GetTotalCurrentYearCreditnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearCreditnotes = 0
                }


            });
        }

        $scope.Creditnoteadd = function (e) {
            ClearCreditnote();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;
            $scope.Update = false;
            $scope.IsAmountLoaded = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;

            $scope.CreditNote.$setPristine();
            $scope.CreditNote.$setUntouched();

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearCreditnotes + 1;
            var y = pad(info, 6);
            var VR = "CNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "CNS" + new Date().getFullYear().toString().substr(-2);
            $scope.CreditNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }
        function ClearCreditnote() {

            $scope.RefrenceNumber = null
            $scope.InvoiceID = null;
            $scope.AccountID = null
            $scope.Description = null
            $scope.Amount = null
            $scope.GSTID = null
            $scope.Remarks = null;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveCreditnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salescreditnote/update",
                    data: {
                        _id: $scope.CreditnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshInvoice();
                    RefreshCustomerstatement();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearCreditnotes();
                    RefreshCreditnote();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Creditnoteinfo = function (CreditnoteID, index) {


            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;

            $scope.CreditnoteID = CreditnoteID;
            $scope.Update = true;

            var item = $scope.Creditnotedatas.filter(function (item) {
                return item._id === CreditnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)

            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.CreditNoteNumber = item.CreditNoteNumber
            $scope.CNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }


        $scope.ClearCNItems = function () {
            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        $scope.CNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salescreditnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales credit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salescreditnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveCNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveCNItems(GList.data.data.id);
                    GetTotalCurrentYearCreditnotes();
                }

            }, function () {


            });

        }


        $scope.CNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/UpdateItem",
                data: {
                    CreditnoteID: $scope.CreditnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CNItemDetails != undefined) {
                    $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }

        function RefreshCreditnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });


        }

        $scope.CreditnoteFilter = function () {
            $scope.Creditnotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });
        }

        $scope.CreditnoteShowgrid = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridCollectPayment = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;


        }
        function ClearCreditnote() {
            $scope.RefrenceNumber = null;
            $scope.VoucherDate = null;
            $scope.InvoiceID = null;
            $scope.Date = null;
            $scope.AccountID = null;
            $scope.Description = null;
            $scope.Amount = null;
            $scope.GSTID = null;
            $scope.Remarks = null;
        }

        RefreshGST();
        RefreshChartofAccount();

        RefreshContract();


        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {

                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }
        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getBySalesOrder",
                data: {
                    SalesOrderId: $scope.WorkOrderID,
                },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getforinvoice",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }
        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getByCustomer",
                data: {
                    CustomerId: $scope.CustomerID
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshDescription() {

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
                // DeleteDescription();
            });
        }
        function DeleteDescription() {

            try {
                $scope.ServiceIDs = $scope.ServiceID.map(function (obj) { return obj.ServiceID; }).join(',');
            } catch (error) {

            }

            angular.forEach($scope.Descriptiondatas, function (value, key) {

                if (aContainsB($scope.ServiceIDs.trim(), value.ServiceReportNo.trim())) {

                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: value._id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                    });
                }

            });
        }
        $scope.DeletePopup = function (ID) {
            $scope.Id = ID
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the description?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: $scope.Id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }


        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }

        $scope.EnableDescription = function (DescID, ServiceReportNo) {
            $scope.Desc = false;
            $scope.textbar = true;
            $scope.ServiceReportNo = ServiceReportNo;
            $scope.DescID = DescID;

            var item = $scope.Descriptiondatas.filter(function (item) {
                return item._id === DescID;
            })[0];

            if (item != undefined) {
                $scope.Description = item.Description
                $scope.ServiceID = $scope.ServiceReportNo
            }

        }
        $scope.DescriptionSubmit = function () {
            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/update",
                method: "PUT",
                data: { _id: $scope.DescID, ServiceReportNo: $scope.ServiceID, Description: $scope.Description },
            });
            response.then(function (GList) {
                RefreshDescription();
                $scope.Description = null;
                $scope.Desc = true;
            });
        }

        $scope.AddPayment = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function cashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Date = new Date()
            $scope.vm.Amount = 0
        }

        $scope.SubmitPayment = function () {
            var TotalAmount = parseFloat($scope.vm.Amount) + parseFloat($scope.AmountReceived)
            if (TotalAmount > $scope.Amount)
                $mdToast.show($mdToast.simple().textContent('Amount Paid is greater than Invoice Amount!').position('top center'));
            else {
                var Outstanding = parseFloat($scope.Amount) - TotalAmount
                $scope.TOutStandingAmount = Outstanding.toString()
                var Status = "Paid"
                if (Outstanding != $scope.Amount && TotalAmount > 0)
                    Status = "Partially Paid"
                else if (TotalAmount == 0) Status = "Unpaid"
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + '/paymenthistory/add',
                    data: {
                        InvoiceID: $scope.InvoiceID,
                        Amount: $scope.vm.Amount,
                        Date: $scope.vm.Date,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.createdby
                    }
                }).then(function (List) {
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: TotalAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.InvoiceFilterByDate()
                        $scope.AmountReceived = TotalAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $mdDialog.cancel()
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Payment Added Successfully!').position('top center'));
                        });
                    })
                })
            }

        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        $scope.OnWorkOrderChange = function () {

            var myArray = $scope.ServiceID;

            if (myArray == undefined) {
                $scope.ServiceIDs = "null";
                RefreshDescription();
            }


            var BillingAmount = 0;
            angular.forEach(myArray, function (value, key) {

                var Description = "Being Inspection and Treatment carried out for the control of";

                try {
                    Description = "Being Inspection and Treatment carried out for the control of " + monthNames[new Date(value.Startsat).getMonth()] + " " + new Date(value.Startsat).getFullYear()

                } catch (error) {

                }

                if (value.BillingAmount != undefined) {
                    BillingAmount = BillingAmount + parseFloat(value.BillingAmount);

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: value.BillingAmount },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: 0 },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }

            });





            $scope.Amount = BillingAmount;




            // var myArray = $scope.ServiceID;

            // var item = myArray.filter(function (item) {
            //     return item._id === $scope.WorkOrderID;
            // })[0];

            // var TotalOrderValue = item.TotalOrderValue;
            // var TotalServices = $scope.ServiceID;
            // $scope.Amount = Math.round(TotalOrderValue / (TotalServices.length), 2);

        }
        $scope.OnInvoiceChange = function () {



            if ($scope.IsAmountLoaded == false) {

                var InvoiceID = $scope.vm.InvoiceID;
                var TotalAmount = 0;
                angular.forEach(InvoiceID, function (value, key) {

                    TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);


                    // var item = $scope.GSTdatas.filter(function (item) {
                    //     return item.id === value.GSTID;
                    // })[0]; 

                    // if(item!=undefined){

                    //     if (value.Status == "Partial") { 

                    //         var Amt=TotalAmount + parseFloat(value.OutStandingAmount); 

                    //         TotalAmount=Amt + (parseFloat((Amt / 100) * parseFloat(item.TaxRate))); 
                    //     }
                    //     else { 
                    //        // TotalAmount = TotalAmount + parseFloat(value.Amount);
                    //         TotalAmount = parseFloat(TotalAmount) + parseFloat(value.Amount) + (parseFloat((value.Amount / 100) * parseFloat(item.TaxRate)));
                    //     }  

                    // }
                    //else{
                    // if (value.Status == "Partial") {
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount); 
                    // }
                    // else { 
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);
                    // } 
                    // }

                });
                $scope.vm.Amount = TotalAmount;
            }

        }

        $scope.OnCNInvoiceChange = function () {


            // if($scope.IsAmountLoaded == false) {
            // var InvoiceID = $scope.InvoiceID;
            // var TotalAmount = 0;
            // angular.forEach(InvoiceID, function (value, key) {

            //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);

            // }); 
            // $scope.Amount = TotalAmount;
            //  }
        }
        $scope.OnCustomerChange = function () {

            var myArray = $scope.Customerdatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.CustomerID;
            })[0];

            if (item.CreditTerm != undefined) {

                $scope.CreditTerm = parseInt(item.CreditTerm);
            }
            else {
                $scope.CreditTerm = 0;
            }

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }


            RefreshSalesOrder()
        }

        $scope.OnVoucherDateChange = function () {
            $scope.Date = $scope.VoucherDate;
            if ($scope.CreditTerm != null || $scope.CreditTerm != undefined) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
            else {
                $scope.DueDate = $scope.VoucherDate;
            }
        }

        $scope.OnInvoiceDateChange = function () {
            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCreditTermChange = function () {

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCSStatusChange = function () {

            if ($scope.CSStatus == 'ShowAll') {

                $scope.Customerstatementdatas = $scope.Customerstatementalldatas;
            } else {

                if ($scope.Customerstatementalldatas != undefined) {
                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === $scope.CSStatus;
                    });
                    $scope.Customerstatementdatas = item;
                }

            }
        }



        function RefreshCustomerstatement() {
            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.RefreshCustomers = function () {
            $scope.Customerstatementdatas = undefined;

            if ($scope.FilterByCustomer == true) {

                if ($scope.CusID == undefined) {

                    $mdToast.show($mdToast.simple().textContent('Please Select Customer & Click Search!').position('top center'));

                    $scope.Customerstatementdatas = [];
                }
                else {
                    var response = $http({
                        url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                        method: "POST",
                        data: { CustomerID: $scope.CusID },
                    });
                    response.then(function (Customerstatementdata) {
                        $scope.Customerstatementdatas = Customerstatementdata.data.data;
                        $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                        var item = $scope.Customerstatementalldatas.filter(function (item) {
                            return item.Status === 'Unpaid';
                        });
                        $scope.Customerstatementdatas = item;
                    });
                }
            }
            else {
                var response = $http({
                    url: $rootScope.WebURL + "/customerstatement/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
                });
                response.then(function (Customerstatementdata) {
                    $scope.Customerstatementdatas = Customerstatementdata.data.data;
                    $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === 'Unpaid';
                    });
                    $scope.Customerstatementdatas = item;
                });
            }

        }

        $scope.Filter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                method: "POST",
                data: { CustomerID: $scope.CusID },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        GetTotalCurrentYearDebitnotes();

        function GetTotalCurrentYearDebitnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearDebitnotes = 0
                }


            });
        }

        $scope.Debitnoteadd = function (e) {

            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;

            $scope.DebitnoteSelect = false;

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearDebitnotes + 1;
            var y = pad(info, 6);
            var VR = "DNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "DNS" + new Date().getFullYear().toString().substr(-2);
            $scope.DebitNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;
            $scope.Update = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.Description = undefined;
            $scope.Remarks = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        $scope.SaveDebitnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salesdebitnote/update",
                    data: {
                        _id: $scope.DebitnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshDebitnote();

                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearDebitnotes();
                    RefreshDebitnote();
                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Debitnoteinfo = function (DebitnoteID, index) {

            $scope.DebitnoteID = DebitnoteID;
            $scope.Update = true;
            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.DebitnoteSelect = false;
            $scope.DebitnoteID = DebitnoteID;

            var item = $scope.Debitnotedatas.filter(function (item) {
                return item._id === DebitnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)


            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.DebitNoteNumber = item.DebitNoteNumber
            $scope.DNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        function RefreshDebitnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }

        $scope.DebitnoteFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }


        $scope.DNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesdebitnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales debit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesdebitnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveDNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveDNItems(GList.data.data.id);
                    GetTotalCurrentYearDebitnotes();
                }

            }, function () {


            });

        }


        $scope.DNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/UpdateItem",
                data: {
                    DebitnoteID: $scope.DebitnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.DNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveDNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.DNItemDetails != undefined) {
                    $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.DNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.DNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.DNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.Showgrid = function () {
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceGrid = true;
            $scope.InvoiceForm = false;
            $scope.InvoiceSelect = true;
            $scope.InvoiceFormback = false;

            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridDebit = function () {

            $scope.DebitnoteSelect = true;
            $scope.DebitnoteGrid = true;
            $scope.DebitnoteForm = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.InvoicefilterByCustomer = function () {


            $scope.vm.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.vm.uFrom;
            var ToDate = $scope.vm.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });

            response.then(function (salesinvoicedata) {

                var myArray = salesinvoicedata.data.data;

                var item = myArray.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                $scope.Salesinvoicedatasdd = item;
            });
        };

        $scope.InvoicefilterByCustomerform = function () {


            $scope.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });
            response.then(function (salesinvoicedata) {
                $scope.Salesinvoicedatasddf = salesinvoicedata.data.data;

                var item = $scope.Salesinvoicedatasddf.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                var item2 = item.filter(function (item) {
                    return item.Status !== "Adjust" && parseFloat(item.OutStandingAmount) > 0;
                });
                $scope.Salesinvoicedatasddf = item2;
            });


        };

        $scope.InvoiceExport = function () {
            alasql('SELECT * INTO XLSX("Invoice.xlsx",{headers:true}) FROM ?', [$scope.Salesinvoicedatas]);
        };
        $scope.CollectPaymentExport = function () {
            alasql('SELECT * INTO XLSX("CollectPayment.xlsx",{headers:true}) FROM ?', [$scope.CollectPaymentdatas]);
        };
        $scope.CreditnoteExport = function () {
            alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
        };
        $scope.DebitnoteExport = function () {
            alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
        };
        $scope.CustomerStatementExport = function () {
            alasql('SELECT * INTO XLSX("CustomerStatement.xlsx",{headers:true}) FROM ?', [$scope.Customerstatementdatas]);
        };


        $scope.Printsalesinvoice = function (CreditnoteID) {
            var url = $rootScope.ReportURL + "SalesInvoice.aspx?ID=" + CreditnoteID;
            window.open(url);
        }


        $scope.getTotal = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.Amount);
                });

                return total.toFixed(2);
            } else {
                0
            }
        }
        $scope.getAccountCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var AccountCode = itemDetails.map(function (obj) {
                    return obj.AccountCode;
                }).join(',');
                return AccountCode;
            } else {
                return null;
            }
        }

        $scope.getGSTCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var GSTCode = itemDetails.map(function (obj) {
                    return obj.GSTCode;
                }).join(',');
                return GSTCode;
            } else {
                return null;
            }
        }
        $scope.getInvoiceNumber = function (itemDetails) {

            if (itemDetails != undefined) {
                var InvoiceNumber = itemDetails.map(function (obj) {
                    return obj.InvoiceNumber;
                }).join(',');
                return InvoiceNumber;
            } else {
                return null;
            }
        }


        $scope.getTotalInvoiceAmount = function (itemDetails) {

            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.InvoiceAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }
        $scope.getTotalOutStandingAmount = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.OutStandingAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }



        vm.dtOptions = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            bProcessing: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        vm.dtOptions1 = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.InvoiceTab = function () {
            $scope.InvoiceSelect = true;
            $scope.InvoiceGrid = true;

            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };

        $scope.CollectPaymentTab = function () {
            RefreshCollectPayment();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.CreditnoteTab = function () {
            RefreshCreditnote();
            $scope.InvoiceSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.InvoiceForm = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.DebitnoteTab = function () {
            RefreshDebitnote();
            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = true;
            $scope.CollectPaymentSelect = false;
            $scope.InvoiceForm = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteGrid = true;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.SearchValue = "";
        };
        $scope.CustomerStatementTab = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });


            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = true;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceForm = false;

            $scope.CollectPaymentFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.SearchValue = "";
        };

        $scope.Today = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            $scope.uFrom = new Date();
            $scope.uTo = new Date();
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();

        }

        $scope.lastweek = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = new Date(from);
            $scope.uTo = new Date(to);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        $scope.lastmonth = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = new Date(lastMonthStartDate);
            $scope.uTo = new Date(lastMonthEndDate);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        var now = new Date();
        $scope.minDate = new Date(
            now.getFullYear() - 5,
            now.getMonth(),
            now.getDate()
        );


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'D.M.YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }


})();
(function () {
    'use strict';

    angular
        .module('app.accounts.salesreceivables', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_Lsalesreceivables', {
            url: '/Lsalesreceivables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/Lumair/salesreceivables/salesreceivables.html',
                    controller: 'LsalesreceivablesController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/Lumair/salesreceivables');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.salesreceivables')
        .controller('LsalesreceivablesController', LsalesreceivablesController);


    function LsalesreceivablesController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        document.getElementsByTagName('title')[0].text = "Accounts-Invoice"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcLumiair")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $scope.TRCCdiv = false
        var select = 'always'
        $scope.Desc = true;
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);
        $scope.vm.uTo = $scope.uTo;
        $scope.vm.uFrom = $scope.uFrom;

        $scope.InvoiceSelect = true;
        $scope.InvoiceGrid = true;
        $scope.InvoiceForm = false;
        $scope.CollectPaymentSelect = false;
        $scope.CreditnoteSelect = false;
        $scope.CustomerStatementSelect = false;
        $scope.CreditnoteGrid = false;
        $scope.CreditnoteForm = false;
        $scope.DebitnoteSelect = false;
        $scope.DebitnoteGrid = false;
        $scope.DebitnoteForm = false;
        $scope.InvoiceFormback = false;
        $scope.CollectPaymentGrid = false;
        $scope.CollectPaymentForm = false;
        $scope.CollectPaymentFormback = false;

        $scope.FilterByCustomer = true;
        var dataGrid = ""

        vm.dataGridContract = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.Salesinvoicedatas,
            keyExpr: "_id",
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            // selection: {
            //     mode: "multiple",
            //     showCheckBoxesMode: select,
            //   },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "CustomerName", caption: "Customer Name" },
                { dataField: "SalesOrderNo", caption: "Work Order#" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy' },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "PaymentMode", caption: "Payment Mode" },
                { dataField: "PurchaseOrderNo", caption: "Purchase Order No" },
                { dataField: "BillingAddress", caption: "Billing Address" },
                { dataField: "ServiceAddress", caption: "Service Address" },
                { dataField: "PestType", caption: "Pest Coverage" },
                { dataField: "BillingFrequency", caption: "Billing Frequency" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Xero Invoice No.", caption: "Remarks" },
                {
                    dataField: "PushedtoXero", caption: "Pushed to Xero?",
                    cellTemplate: function (container, options) {
                        if (options.data.PushedtoXero)
                            $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                        else
                            $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                    }
                },
                {
                    caption: 'Work Order Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                var url = $rootScope.ReportURL + 'WorkOrder.aspx' + '?' + 'ID=' + options.data.SalesOrderID;
                                window.open(url);
                            }
                        }).appendTo(container);
                    }
                },
                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
                // {
                //     caption: 'Send Email',
                //     width: "90",
                //     fixed: false,
                //     fixedPosition: 'right',
                //     alignment: 'center',
                //     allowSorting: false,
                //     cellTemplate: function (container, options) {
                //         $('<div />').dxButton({
                //             icon: 'email',
                //             onClick: function (e) {
                //                 $scope.SendMail(options.data._id, options.data.BillingFrequency, options.data.ServiceStartDate, options.data.ServiceEndDate, options.data.CreatedBy, 'Send Email')
                //             }
                //         }).appendTo(container);
                //     }
                // }

            ],
            bindingOptions: {
                dataSource: "Salesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "true",
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },
            // onToolbarPreparing: function (e) {
            //     e.toolbarOptions.items.unshift({
            //         location: "before",
            //         template: "totalGroupCount"
            //     }
            //     );
            // },
            onCellClick: function (data) {
                if (data.columnIndex == 1) {
                    var index = dataGrid.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo(data.data._id, index)
                }
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedIds = [];
                    $scope.TRCCdiv = true;
                    $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.TRCCdiv = false;
                    $scope.SelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
        };

        $scope.InvoiceFilter = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []
            $scope.vm.YTSPreviewSpinner = true
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Status: "Paid", Type: "Invoice" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", Skip: Skip, Limit: Limit, Department: "Lumiair" }
                    }).then(function (GList) {
                        if (dataGrid != "")
                            $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.Salesinvoicedatas = $scope.Salesinvoicedatas.concat(GList.data.data)
                        $scope.Salesinvoicedatas = _.uniqWith($scope.Salesinvoicedatas, _.isEqual);
                        $scope.vm.YTSPreviewSpinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        $scope.InvoiceFilterByDate = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []
            $scope.vm.YTSPreviewSpinner = true
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getByDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", StartDate: $scope.uFrom, EndDate: $scope.uTo, Department: "Lumiair" }
            }).then(function (GList) {
                if (dataGrid != "")
                    $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                $scope.Salesinvoicedatas = GList.data.data
                $scope.vm.YTSPreviewSpinner = false
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        RefreshCustomer();
        $scope.InvoiceFilter()



        $scope.PushtoXero = function () {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/pushtoxero",
                method: "PUT",
                data: { InvoiceArray: $scope.SelectedIds, CreatedBy: $rootScope.createdby },
            });
            response.then(function (salesinvoicedata) {
                $mdToast.show($mdToast.simple().textContent('Successfully Exported to Xero!').position('top center'));

            })
        }

        $scope.ChangeDate = function (Type) {
            if (Type == 'less') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
                $scope.uTo = new Date($scope.uFrom);
            }
            if (Type == 'greater') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
                $scope.uTo = new Date($scope.uFrom);
            }
        }

        GetTotalCurrentYearInvoices();
        function GetTotalCurrentYearInvoices() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearInvoices = 0 }


            });
        }

        $scope.ShowClosed = function (con) {
            $scope.DefaultInvoice = con
            if ($scope.DefaultInvoice) {
                select = 'none'
                $scope.Salesinvoicedatas = undefined;
                var FromDate = $scope.uFrom;
                var ToDate = $scope.uTo;
                var response = $http({
                    url: $rootScope.WebURL + "/salesinvoice/getByXero",
                    method: "POST",
                    data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
                });
                response.then(function (salesinvoicedata) {

                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                });
            }
            else {
                select = 'always'
                $scope.InvoiceFilter()
            }
        }

        $scope.Invoiceadd = function (e) {
            ClearInvoice();

            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;

            var AR = "5" + new Date().getFullYear().toString().substr(-2);

            var info = $scope.TotalCurrentYearInvoices + 1;
            var y = pad(info, 6);
            $scope.InvoiceNumber = AR + y;

            var VR = "SV" + new Date().getFullYear().toString().substr(-2);

            $scope.VoucherNumber = VR + y;

            var item = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            if (item != undefined) {
                $scope.GSTID = item._id;
            }

            $scope.Date = new Date();
            $scope.VoucherDate = new Date();
            $scope.DueDate = new Date();

            $scope.Descriptiondatas = null;
            $scope.ServiceID = null;
            $scope.ServiceIDs = null;

        }

        // $scope.SaveInvoice = function () {

        //     $scope.ServiceIDs = ""

        //     var OutStandingAmount = 0
        //     var InvoiceAmount = 0; var GSTAmount = 0;
        //     if ($scope.GSTID == "" || $scope.GSTID == undefined) {
        //         $scope.GSTID = null;
        //     }
        //     else {
        //         var item = $scope.GSTdatas.filter(function (item) {
        //             return item._id === $scope.GSTID;
        //         })[0];

        //         OutStandingAmount = parseFloat(OutStandingAmount) + (parseFloat(OutStandingAmount / 100) * parseFloat(item.TaxRate));

        //         GSTAmount = parseFloat($scope.Amount / 100) * parseFloat(item.TaxRate);
        //     }

        //     if ($scope.Amount > $scope.AmountReceived)
        //         OutStandingAmount = $scope.Amount - $scope.AmountReceived
        //     if ($scope.Amount < $scope.AmountReceived)
        //         OutStandingAmount = $scope.AmountReceived - $scope.Amount

        //     if ($scope.Update == true) {

        //         $scope.Update = true;
        //         var response = $http({
        //             method: "PUT",
        //             url:  $rootScope.WebURL + "/salesinvoice/update",
        //             data: {
        //                 _id: $scope.InvoiceID, InvoiceNumber: $scope.InvoiceNumber, CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //                 Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //                 VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, UpdatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //                 OutStandingAmount: OutStandingAmount, InvoiceAmount: $scope.Amount, GSTAmount: GSTAmount, ContractID: $scope.ConID, AmountReceived: $scope.AmountReceived
        //             },
        //         });

        //         response.then(function (GList) {
        //             $scope.InvoiceFilter()
        //             $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



        //             //RefreshInvoice();
        //             $scope.InvoiceGrid = true;
        //             $scope.InvoiceForm = false;
        //             $scope.InvoiceFormback = false;
        //             $scope.InvoiceSelect = true;
        //         }, function () {
        //             $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //         });
        //     }
        //     else {
        //         var response = $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/salesinvoice/add",
        //             data: {
        //                 InvoiceNumber: $scope.InvoiceNumber, Client_Id: Client_Id, CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //                 Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //                 VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, CreatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //                 OutStandingAmount: OutStandingAmount, InvoiceAmount: $scope.Amount, GSTAmount: GSTAmount, ContractID: $scope.ConID
        //             },
        //         });

        //         response.then(function (GList) {

        //             if (GList.data.message == "Existing Sales invoice") {

        //                 $mdToast.show($mdToast.simple().textContent('Invoice Number is already exists, please submit again !').position('top center'));
        //             }
        //             else {
        //                 $scope.InvoiceFilter()
        //                 $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //             }

        //             RefreshInvoice();
        //             GetTotalCurrentYearInvoices();
        //             $scope.InvoiceGrid = true;
        //             $scope.InvoiceForm = false;
        //             $scope.InvoiceFormback = false;
        //             $scope.InvoiceSelect = true;
        //         }, function () {
        //             $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        //         });

        //     }
        //     // else {

        //     //     var firstDay = new Date(new Date().getFullYear(),0, 1);   
        //     //     firstDay.setHours(0, 0, 0, 0);  
        //     //     $scope.uTo.setHours(23, 59, 59, 999);
        //     //     var response = $http({
        //     //         url:  $rootScope.WebURL + "/salesinvoice/datefilter",
        //     //         method: "POST",
        //     //         data: { Start_Date: firstDay, End_Date: $scope.uTo,Client_Id: Client_Id , },
        //     //     });
        //     //     response.then(function (salesinvoicedata) {

        //     //         $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data;

        //     //         var item = $scope.TotalCurrentYearInvoices.filter(function (item) {
        //     //             return item.InvoiceNumber === $scope.InvoiceNumber;
        //     //         })[0];

        //     //         if (item != undefined) {

        //     //             var firstDay = new Date(new Date().getFullYear(),0, 1);   
        //     //             firstDay.setHours(0, 0, 0, 0);  
        //     //             $scope.uTo.setHours(23, 59, 59, 999);
        //     //             var response = $http({
        //     //                 url:  $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
        //     //                 method: "POST",
        //     //                 data: { Start_Date: firstDay, End_Date:  $scope.uTo, Client_Id: Client_Id },
        //     //             });
        //     //             response.then(function (salesinvoicedata) {


        //     //                 if (salesinvoicedata.data.data.length > 0) {

        //     //                     $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
        //     //                 }
        //     //                 else { $scope.TotalCurrentYearInvoices = 0 }


        //     //                 var AR = "5" + new Date().getFullYear().toString().substr(-2);

        //     //                 var info = $scope.TotalCurrentYearInvoices + 1;
        //     //                 var y = pad(info, 6);
        //     //                 $scope.InvoiceNumber = AR + y;

        //     //                 var VR = "SV" + new Date().getFullYear().toString().substr(-2);
        //     //                 $scope.VoucherNumber = VR + y;

        //     //                 var response = $http({
        //     //                     method: "POST",
        //     //                     url:  $rootScope.WebURL + "/salesinvoice/add",
        //     //                     data: {
        //     //                         InvoiceNumber: $scope.InvoiceNumber,Client_Id: Client_Id , CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //     //                         Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //     //                         VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, CreatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //     //                         OutStandingAmount: OutStandingAmount, InvoiceAmount: InvoiceAmount, GSTAmount: GSTAmount, ContractID: $scope.ConID
        //     //                     },
        //     //                 });

        //     //                 response.then(function (GList) {

        //     //                     if (GList.data.message == "Existing Sales invoice") {

        //     //                         $mdToast.show($mdToast.simple().textContent('Invoice Number is already exists, please submit again !').position('top center'));
        //     //                     }
        //     //                     else {
        //     //                         $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //     //                     }

        //     //                     RefreshInvoice();
        //     //                     GetTotalCurrentYearInvoices();
        //     //                     $scope.InvoiceGrid = true;
        //     //                     $scope.InvoiceForm = false;
        //     //                     $scope.InvoiceFormback = false;
        //     //                     $scope.InvoiceSelect = true;
        //     //                 }, function () {
        //     //                     $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        //     //                 });

        //     //             });

        //     //         }
        //     //     });




        //     // }
        // }

        $scope.ssubmit = function () {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/salesinvoice/newupdate',
                data: {
                    _id: $scope.InvoiceID,
                    DueDate: $scope.DueDate,
                    Amount: $scope.Amount,
                    Remarks: $scope.Remarks,
                    AmountReceived: $scope.AmountReceived
                }
            }).then(function (List) {
                RefreshInvoice();
                $scope.InvoiceGrid = true;
                $scope.InvoiceForm = false;
                $scope.InvoiceFormback = false;
                $scope.InvoiceSelect = true;
                $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
            })
        }

        $scope.ClearSearch = function () {

            $scope.searchTermc = null;
            $scope.CustomerID = null;
            $scope.vm.CustomerID = null;

        }


        $scope.SalesInvoiceInfo = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.Salesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: InvoiceID },
            });
            response1.then(function (GList) {

                $scope.Paymentdatas = GList.data.data;
            });
        }

        $scope.PDeletePopup = function (id, Amount) {
            $scope.PId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the payment?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/paymenthistory/delete",
                        method: "POST",
                        data: { _id: $scope.PId },
                    });
                    response.then(function (GList) {
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));
                        });
                    });
                    var ReduceAmount = parseFloat($scope.AmountReceived) - parseFloat(Amount)
                    var Outstanding = parseFloat($scope.OutStandingAmount) + parseFloat(Amount)
                    $scope.TOutStandingAmount = Outstanding.toString()
                    var Status = "Paid"
                    if (Outstanding != $scope.Amount && ReduceAmount > 0)
                        Status = "Partially Paid"
                    else if (ReduceAmount == 0) Status = "Unpaid"
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: ReduceAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.AmountReceived = ReduceAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $scope.InvoiceFilter()
                    })
                }
            });
        }

        RefreshBank();
        RefreshClientBank();

        $scope.SelectScheduler = function () {
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.ServiceID === $scope.ServiceID
            })[0]
            $scope.Description = moment(item.Startsat).format('DD MMMM YYYY') + " - " + item.PestType
        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshClientBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });
        }

        function RefreshInvoice() {
            $scope.InvoiceFilter()
            // var FromDate = $scope.uFrom;
            // var ToDate = $scope.uTo;
            // var response = $http({
            //     url:  $rootScope.WebURL + "/salesinvoice/datefilter",
            //     method: "POST",
            //     data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
            // });
            // response.then(function (salesinvoicedata) {

            //     $scope.Salesinvoicedatas = salesinvoicedata.data.data;

            // });
        }
        function ClearInvoice() {
            $scope.CustomerID = null; $scope.WorkOrderID = null; $scope.Date = null; $scope.VoucherNumber = null;
            $scope.Amount = null; $scope.ServiceIDs = null; $scope.GSTID = null; $scope.Description = null;
            $scope.VoucherDate = null; $scope.CreditTerm = null; $scope.Remarks = null;
            $scope.ContractID = null; $scope.ConID = null;
        }
        $scope.updateCustomRequest = function (data, type, res) {

        };

        $scope.OnTopInvoiceContractChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ContractID;
            })[0];

            $scope.ConID = $scope.ContractID;
            $scope.CustomerID = item.Customer_id;
            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.OnConChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ConID;
            })[0];

            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.IsAmountLoaded = false;


        GetTotalCurrentYearPayments();
        function GetTotalCurrentYearPayments() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearPayments = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearPayments = 0 }


            });
        }


        $scope.CollectPaymentadd = function (e) {

            $scope.InvoicefilterByCustomer();
            $scope.IsAmountLoaded = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            ClearCollectPayment();
            $scope.Update = false;

            $scope.vm.uTo = $scope.uTo;
            $scope.vm.uFrom = $scope.uFrom;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

            var itemB = $scope.Bankdatas.filter(function (item) {
                return item.BankName === "OCBC";
            })[0];

            $scope.vm.BankID = itemB._id;

            $scope.vm.Date = new Date();
            $scope.vm.VoucherDate = new Date();

            var info = $scope.TotalCurrentYearPayments + 1;
            var y = pad(info, 6);
            var VR = "CP" + new Date().getFullYear().toString().substr(-2);
            $scope.vm.VoucherNumber = VR + y;

            $scope.CPItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


        }

        $scope.SaveCollectPayment = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/collectpayment/update",
                    data: {
                        _id: $scope.CollectPaymentID, CustomerID: $scope.vm.CustomerID,
                        Description: $scope.vm.Description, Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID, ClientBankName: $scope.vm.ClientBankName, ChequeDate: $scope.vm.ChequeDate,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.CollectPaymentdatas[$scope.CollectPaymentIndex] = GList.data.data[0];

                    RefreshInvoice();
                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {




                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                        Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                    },
                });


                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    GetTotalCurrentYearPayments()
                    RefreshCollectPayment();
                    RefreshCustomerstatement();
                    RefreshInvoice();

                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }


        $scope.CollectPaymentinfo = function (CollectPaymentID, Index) {

            $scope.CollectPaymentIndex = Index;
            $scope.Salesinvoicedatasdd = $scope.Salesinvoicedatas;

            $scope.CollectPaymentID = CollectPaymentID;
            $scope.Update = true;

            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;

            var item = $scope.CollectPaymentdatas.filter(function (item) {
                return item._id === CollectPaymentID;
            })[0];

            $scope.vm.CustomerID = item.CustomerID;
            $scope.vm.BankID = item.BankID;
            $scope.vm.VoucherNumber = item.VoucherNumber;
            $scope.vm.VoucherDate = new Date(item.VoucherDate);
            $scope.vm.ChequeNumber = item.ChequeNumber;
            $scope.vm.ChequeDate = new Date(item.ChequeDate);
            $scope.vm.Description = item.Description;
            $scope.vm.Date = new Date(item.Date);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.ClientBankName = item.ClientBankName;

            $scope.CPItemDetails = item.itemDetails;

            $scope.IsAmountLoaded = true;

            $scope.HideAdd = true;
            $scope.HideSave = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

        }

        $scope.CPItemSubmit = function () {


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/collectpayment/add",
                data: {
                    CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                    Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                    VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Collectpayment") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/collectpayment/getByID",
                        data: {
                            VoucherNumber: $scope.vm.VoucherNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CollectPaymentID = GList.data.data[0]._id;
                        SaveCPItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CollectPaymentID = GList.data.data.id;
                    SaveCPItems(GList.data.data.id);
                    GetTotalCurrentYearPayments()
                }

            }, function () {


            });

        }


        $scope.CPItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }

            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/UpdateItem",
                data: {
                    CollectPaymentID: $scope.CollectPaymentID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    PaidAmount: $scope.PaidAmount,
                    InvoiceAmount: parseFloat(InvoiceAmount),
                    OutStandingAmount: OutStandingAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CPItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCPItems(CollectPaymentID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }


            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "PaidAmount": $scope.PaidAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceAmount": parseFloat(InvoiceAmount),
                "OutStandingAmount": OutStandingAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "_id": undefined
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/addItems",
                data: {
                    _id: CollectPaymentID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    InvoiceNumber: InvoiceNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Date: $scope.vm.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CPItemDetails != undefined) {
                    $scope.CPItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/getByID",
                    data: {
                        VoucherNumber: $scope.vm.VoucherNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CPItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CPItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CPItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.ServiceSelect = function () {
            RefreshScheduler()
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }

        $scope.CollectPaymentFilter = function () {
            $scope.CollectPaymentdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }
        function ClearCollectPayment() {

            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.Date = null;
            $scope.vm.ChequeDate = null;
            $scope.vm.Amount = null;
            $scope.vm.InvoiceID = null;
            $scope.vm.Description = null;
            $scope.vm.Remarks = null;
            $scope.vm.ChequeNumber = null;
            $scope.vm.VoucherNumber = null;
            $scope.vm.ClientBankName = null;
        }


        GetTotalCurrentYearCreditnotes();

        function GetTotalCurrentYearCreditnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearCreditnotes = 0
                }


            });
        }

        $scope.Creditnoteadd = function (e) {
            ClearCreditnote();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;
            $scope.Update = false;
            $scope.IsAmountLoaded = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;

            $scope.CreditNote.$setPristine();
            $scope.CreditNote.$setUntouched();

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearCreditnotes + 1;
            var y = pad(info, 6);
            var VR = "CNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "CNS" + new Date().getFullYear().toString().substr(-2);
            $scope.CreditNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }
        function ClearCreditnote() {

            $scope.RefrenceNumber = null
            $scope.InvoiceID = null;
            $scope.AccountID = null
            $scope.Description = null
            $scope.Amount = null
            $scope.GSTID = null
            $scope.Remarks = null;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveCreditnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salescreditnote/update",
                    data: {
                        _id: $scope.CreditnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshInvoice();
                    RefreshCustomerstatement();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearCreditnotes();
                    RefreshCreditnote();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Creditnoteinfo = function (CreditnoteID, index) {


            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;

            $scope.CreditnoteID = CreditnoteID;
            $scope.Update = true;

            var item = $scope.Creditnotedatas.filter(function (item) {
                return item._id === CreditnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)

            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.CreditNoteNumber = item.CreditNoteNumber
            $scope.CNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }


        $scope.ClearCNItems = function () {
            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        $scope.CNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salescreditnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales credit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salescreditnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveCNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveCNItems(GList.data.data.id);
                    GetTotalCurrentYearCreditnotes();
                }

            }, function () {


            });

        }


        $scope.CNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/UpdateItem",
                data: {
                    CreditnoteID: $scope.CreditnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CNItemDetails != undefined) {
                    $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }

        function RefreshCreditnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });


        }

        $scope.CreditnoteFilter = function () {
            $scope.Creditnotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });
        }

        $scope.CreditnoteShowgrid = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridCollectPayment = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;


        }
        function ClearCreditnote() {
            $scope.RefrenceNumber = null;
            $scope.VoucherDate = null;
            $scope.InvoiceID = null;
            $scope.Date = null;
            $scope.AccountID = null;
            $scope.Description = null;
            $scope.Amount = null;
            $scope.GSTID = null;
            $scope.Remarks = null;
        }

        RefreshGST();
        RefreshChartofAccount();

        RefreshContract();


        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {

                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }
        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getBySalesOrder",
                data: {
                    SalesOrderId: $scope.WorkOrderID,
                },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getforinvoice",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }
        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getByCustomer",
                data: {
                    CustomerId: $scope.CustomerID
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshDescription() {

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
                // DeleteDescription();
            });
        }
        function DeleteDescription() {

            try {
                $scope.ServiceIDs = $scope.ServiceID.map(function (obj) { return obj.ServiceID; }).join(',');
            } catch (error) {

            }

            angular.forEach($scope.Descriptiondatas, function (value, key) {

                if (aContainsB($scope.ServiceIDs.trim(), value.ServiceReportNo.trim())) {

                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: value._id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                    });
                }

            });
        }
        $scope.DeletePopup = function (ID) {
            $scope.Id = ID
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the description?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: $scope.Id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }


        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }

        $scope.EnableDescription = function (DescID, ServiceReportNo) {
            $scope.Desc = false;
            $scope.textbar = true;
            $scope.ServiceReportNo = ServiceReportNo;
            $scope.DescID = DescID;

            var item = $scope.Descriptiondatas.filter(function (item) {
                return item._id === DescID;
            })[0];

            if (item != undefined) {
                $scope.Description = item.Description
                $scope.ServiceID = $scope.ServiceReportNo
            }

        }
        $scope.DescriptionSubmit = function () {
            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/update",
                method: "PUT",
                data: { _id: $scope.DescID, ServiceReportNo: $scope.ServiceID, Description: $scope.Description },
            });
            response.then(function (GList) {
                RefreshDescription();
                $scope.Description = null;
                $scope.Desc = true;
            });
        }

        $scope.AddPayment = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function cashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Date = new Date()
            $scope.vm.Amount = 0
        }

        $scope.SubmitPayment = function () {
            var TotalAmount = parseFloat($scope.vm.Amount) + parseFloat($scope.AmountReceived)
            if (TotalAmount > $scope.Amount)
                $mdToast.show($mdToast.simple().textContent('Amount Paid is greater than Invoice Amount!').position('top center'));
            else {
                var Outstanding = parseFloat($scope.Amount) - TotalAmount
                $scope.TOutStandingAmount = Outstanding.toString()
                var Status = "Paid"
                if (Outstanding != $scope.Amount && TotalAmount > 0)
                    Status = "Partially Paid"
                else if (TotalAmount == 0) Status = "Unpaid"
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + '/paymenthistory/add',
                    data: {
                        InvoiceID: $scope.InvoiceID,
                        Amount: $scope.vm.Amount,
                        Date: $scope.vm.Date,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.createdby
                    }
                }).then(function (List) {
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: TotalAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.InvoiceFilter()
                        $scope.AmountReceived = TotalAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $mdDialog.cancel()
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Payment Added Successfully!').position('top center'));
                        });
                    })
                })
            }

        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        $scope.OnWorkOrderChange = function () {

            var myArray = $scope.ServiceID;

            if (myArray == undefined) {
                $scope.ServiceIDs = "null";
                RefreshDescription();
            }


            var BillingAmount = 0;
            angular.forEach(myArray, function (value, key) {

                var Description = "Being Inspection and Treatment carried out for the control of";

                try {
                    Description = "Being Inspection and Treatment carried out for the control of " + monthNames[new Date(value.Startsat).getMonth()] + " " + new Date(value.Startsat).getFullYear()

                } catch (error) {

                }

                if (value.BillingAmount != undefined) {
                    BillingAmount = BillingAmount + parseFloat(value.BillingAmount);

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: value.BillingAmount },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: 0 },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }

            });





            $scope.Amount = BillingAmount;




            // var myArray = $scope.ServiceID;

            // var item = myArray.filter(function (item) {
            //     return item._id === $scope.WorkOrderID;
            // })[0];

            // var TotalOrderValue = item.TotalOrderValue;
            // var TotalServices = $scope.ServiceID;
            // $scope.Amount = Math.round(TotalOrderValue / (TotalServices.length), 2);

        }
        $scope.OnInvoiceChange = function () {



            if ($scope.IsAmountLoaded == false) {

                var InvoiceID = $scope.vm.InvoiceID;
                var TotalAmount = 0;
                angular.forEach(InvoiceID, function (value, key) {

                    TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);


                    // var item = $scope.GSTdatas.filter(function (item) {
                    //     return item.id === value.GSTID;
                    // })[0]; 

                    // if(item!=undefined){

                    //     if (value.Status == "Partial") { 

                    //         var Amt=TotalAmount + parseFloat(value.OutStandingAmount); 

                    //         TotalAmount=Amt + (parseFloat((Amt / 100) * parseFloat(item.TaxRate))); 
                    //     }
                    //     else { 
                    //        // TotalAmount = TotalAmount + parseFloat(value.Amount);
                    //         TotalAmount = parseFloat(TotalAmount) + parseFloat(value.Amount) + (parseFloat((value.Amount / 100) * parseFloat(item.TaxRate)));
                    //     }  

                    // }
                    //else{
                    // if (value.Status == "Partial") {
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount); 
                    // }
                    // else { 
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);
                    // } 
                    // }

                });
                $scope.vm.Amount = TotalAmount;
            }

        }

        $scope.OnCNInvoiceChange = function () {


            // if($scope.IsAmountLoaded == false) {
            // var InvoiceID = $scope.InvoiceID;
            // var TotalAmount = 0;
            // angular.forEach(InvoiceID, function (value, key) {

            //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);

            // }); 
            // $scope.Amount = TotalAmount;
            //  }
        }
        $scope.OnCustomerChange = function () {

            var myArray = $scope.Customerdatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.CustomerID;
            })[0];

            if (item.CreditTerm != undefined) {

                $scope.CreditTerm = parseInt(item.CreditTerm);
            }
            else {
                $scope.CreditTerm = 0;
            }

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }


            RefreshSalesOrder()
        }

        $scope.OnVoucherDateChange = function () {
            $scope.Date = $scope.VoucherDate;
            if ($scope.CreditTerm != null || $scope.CreditTerm != undefined) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
            else {
                $scope.DueDate = $scope.VoucherDate;
            }
        }

        $scope.OnInvoiceDateChange = function () {
            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCreditTermChange = function () {

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCSStatusChange = function () {

            if ($scope.CSStatus == 'ShowAll') {

                $scope.Customerstatementdatas = $scope.Customerstatementalldatas;
            } else {

                if ($scope.Customerstatementalldatas != undefined) {
                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === $scope.CSStatus;
                    });
                    $scope.Customerstatementdatas = item;
                }

            }
        }



        function RefreshCustomerstatement() {
            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.RefreshCustomers = function () {
            $scope.Customerstatementdatas = undefined;

            if ($scope.FilterByCustomer == true) {

                if ($scope.CusID == undefined) {

                    $mdToast.show($mdToast.simple().textContent('Please Select Customer & Click Search!').position('top center'));

                    $scope.Customerstatementdatas = [];
                }
                else {
                    var response = $http({
                        url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                        method: "POST",
                        data: { CustomerID: $scope.CusID },
                    });
                    response.then(function (Customerstatementdata) {
                        $scope.Customerstatementdatas = Customerstatementdata.data.data;
                        $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                        var item = $scope.Customerstatementalldatas.filter(function (item) {
                            return item.Status === 'Unpaid';
                        });
                        $scope.Customerstatementdatas = item;
                    });
                }
            }
            else {
                var response = $http({
                    url: $rootScope.WebURL + "/customerstatement/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
                });
                response.then(function (Customerstatementdata) {
                    $scope.Customerstatementdatas = Customerstatementdata.data.data;
                    $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === 'Unpaid';
                    });
                    $scope.Customerstatementdatas = item;
                });
            }

        }

        $scope.Filter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                method: "POST",
                data: { CustomerID: $scope.CusID },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        GetTotalCurrentYearDebitnotes();

        function GetTotalCurrentYearDebitnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearDebitnotes = 0
                }


            });
        }

        $scope.Debitnoteadd = function (e) {

            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;

            $scope.DebitnoteSelect = false;

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearDebitnotes + 1;
            var y = pad(info, 6);
            var VR = "DNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "DNS" + new Date().getFullYear().toString().substr(-2);
            $scope.DebitNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;
            $scope.Update = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.Description = undefined;
            $scope.Remarks = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        $scope.SaveDebitnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salesdebitnote/update",
                    data: {
                        _id: $scope.DebitnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshDebitnote();

                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearDebitnotes();
                    RefreshDebitnote();
                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Debitnoteinfo = function (DebitnoteID, index) {

            $scope.DebitnoteID = DebitnoteID;
            $scope.Update = true;
            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.DebitnoteSelect = false;
            $scope.DebitnoteID = DebitnoteID;

            var item = $scope.Debitnotedatas.filter(function (item) {
                return item._id === DebitnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)


            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.DebitNoteNumber = item.DebitNoteNumber
            $scope.DNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        function RefreshDebitnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }

        $scope.DebitnoteFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }


        $scope.DNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesdebitnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales debit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesdebitnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveDNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveDNItems(GList.data.data.id);
                    GetTotalCurrentYearDebitnotes();
                }

            }, function () {


            });

        }


        $scope.DNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/UpdateItem",
                data: {
                    DebitnoteID: $scope.DebitnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.DNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveDNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.DNItemDetails != undefined) {
                    $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.DNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.DNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.DNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.Showgrid = function () {
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceGrid = true;
            $scope.InvoiceForm = false;
            $scope.InvoiceSelect = true;
            $scope.InvoiceFormback = false;

            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridDebit = function () {

            $scope.DebitnoteSelect = true;
            $scope.DebitnoteGrid = true;
            $scope.DebitnoteForm = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.InvoicefilterByCustomer = function () {


            $scope.vm.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.vm.uFrom;
            var ToDate = $scope.vm.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });

            response.then(function (salesinvoicedata) {

                var myArray = salesinvoicedata.data.data;

                var item = myArray.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                $scope.Salesinvoicedatasdd = item;
            });
        };

        $scope.InvoicefilterByCustomerform = function () {


            $scope.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });
            response.then(function (salesinvoicedata) {
                $scope.Salesinvoicedatasddf = salesinvoicedata.data.data;

                var item = $scope.Salesinvoicedatasddf.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                var item2 = item.filter(function (item) {
                    return item.Status !== "Adjust" && parseFloat(item.OutStandingAmount) > 0;
                });
                $scope.Salesinvoicedatasddf = item2;
            });


        };

        $scope.InvoiceExport = function () {
            alasql('SELECT * INTO XLSX("Invoice.xlsx",{headers:true}) FROM ?', [$scope.Salesinvoicedatas]);
        };
        $scope.CollectPaymentExport = function () {
            alasql('SELECT * INTO XLSX("CollectPayment.xlsx",{headers:true}) FROM ?', [$scope.CollectPaymentdatas]);
        };
        $scope.CreditnoteExport = function () {
            alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
        };
        $scope.DebitnoteExport = function () {
            alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
        };
        $scope.CustomerStatementExport = function () {
            alasql('SELECT * INTO XLSX("CustomerStatement.xlsx",{headers:true}) FROM ?', [$scope.Customerstatementdatas]);
        };


        $scope.Printsalesinvoice = function (CreditnoteID) {
            var url = $rootScope.ReportURL + "SalesInvoice.aspx?ID=" + CreditnoteID;
            window.open(url);
        }


        $scope.getTotal = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.Amount);
                });

                return total.toFixed(2);
            } else {
                0
            }
        }
        $scope.getAccountCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var AccountCode = itemDetails.map(function (obj) {
                    return obj.AccountCode;
                }).join(',');
                return AccountCode;
            } else {
                return null;
            }
        }

        $scope.getGSTCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var GSTCode = itemDetails.map(function (obj) {
                    return obj.GSTCode;
                }).join(',');
                return GSTCode;
            } else {
                return null;
            }
        }
        $scope.getInvoiceNumber = function (itemDetails) {

            if (itemDetails != undefined) {
                var InvoiceNumber = itemDetails.map(function (obj) {
                    return obj.InvoiceNumber;
                }).join(',');
                return InvoiceNumber;
            } else {
                return null;
            }
        }


        $scope.getTotalInvoiceAmount = function (itemDetails) {

            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.InvoiceAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }
        $scope.getTotalOutStandingAmount = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.OutStandingAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }



        vm.dtOptions = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            bProcessing: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        vm.dtOptions1 = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.InvoiceTab = function () {
            $scope.InvoiceSelect = true;
            $scope.InvoiceGrid = true;

            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };

        $scope.CollectPaymentTab = function () {
            RefreshCollectPayment();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.CreditnoteTab = function () {
            RefreshCreditnote();
            $scope.InvoiceSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.InvoiceForm = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.DebitnoteTab = function () {
            RefreshDebitnote();
            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = true;
            $scope.CollectPaymentSelect = false;
            $scope.InvoiceForm = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteGrid = true;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.SearchValue = "";
        };
        $scope.CustomerStatementTab = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });


            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = true;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceForm = false;

            $scope.CollectPaymentFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.SearchValue = "";
        };

        $scope.Today = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            $scope.uFrom = new Date();
            $scope.uTo = new Date();
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();

        }

        $scope.lastweek = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = new Date(from);
            $scope.uTo = new Date(to);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        $scope.lastmonth = function () {

            $scope.uFrom = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 0)
            $scope.uTo = new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        var now = new Date();
        $scope.minDate = new Date(
            now.getFullYear() - 5,
            now.getMonth(),
            now.getDate()
        );


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'D.M.YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }


})();
(function () {
    'use strict';

    angular
        .module('app.accounts.cashInvoice', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.accounts_cashInvoice', {
            url: '/cashInvoice',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/Pestoff/casheInvoice/cashInvoice.html',
                    controller: 'cashInvoiceController as vm'
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.cashInvoice')
        .controller('cashInvoiceController', cashInvoiceController);


    function cashInvoiceController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        document.getElementsByTagName('title')[0].text = "Accounts-Cash/Cheque"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcPestOff")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $scope.TRCCdiv = false
        var select = 'always'
        $scope.Desc = true;
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);
        $scope.vm.uTo = $scope.uTo;
        $scope.vm.uFrom = $scope.uFrom;

        $scope.InvoiceSelect = true;
        $scope.InvoiceGrid = true;
        $scope.InvoiceForm = false;
        $scope.CollectPaymentSelect = false;
        $scope.CreditnoteSelect = false;
        $scope.CustomerStatementSelect = false;
        $scope.CreditnoteGrid = false;
        $scope.CreditnoteForm = false;
        $scope.DebitnoteSelect = false;
        $scope.DebitnoteGrid = false;
        $scope.DebitnoteForm = false;
        $scope.InvoiceFormback = false;
        $scope.CollectPaymentGrid = false;
        $scope.CollectPaymentForm = false;
        $scope.CollectPaymentFormback = false;

        $scope.FilterByCustomer = true;

        var dataGrid1 = ""
        $scope.TRCdiv = false;
        $scope.UTRCdiv = false;
        vm.dataGridPending = {
            onInitialized: function (e) {
                dataGrid1 = e.component;
                RefreshInvoice()
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.PendingSalesinvoicedatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: select,
            },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85", sortOrder: "desc",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "CustomerName", caption: "Customer Name" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy', sortOrder: 'desc' },
                { dataField: "CreatedBy", caption: "Technician" },
                { dataField: "SalesOrderNo", caption: "SalesOrder No", width: "100" },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "AmountReceived", caption: "Amount Paid", width: "100" },
                { dataField: "OutStandingAmount", caption: "Outstanding Amount", width: "100" },
                // { dataField: "PaymentMode", caption: "Payment Mode" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                // { dataField: "Remarks", caption: "Xero Invoice No" },
                //     { dataField: "PushedtoXero", caption: "Pushed to Xero?",
                //     cellTemplate: function (container, options) {
                //         if(options.data.PushedtoXero)
                //       $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                //       else
                //       $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                //   }
                //   },

                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
            ],
            bindingOptions: {
                dataSource: "PendingSalesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
            onToolbarPreparing: function (e) {
                var dataGrid = e.component;

                e.toolbarOptions.items.unshift({
                    location: "before",
                    template: "totalGroupCount"
                });
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedIds = [];
                    $scope.TRCdiv = true;
                    $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.TRCdiv = false;
                    $scope.SelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
            onCellClick: function (data) {
                if (data.columnIndex == 2) {
                    var index = dataGrid1.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo(data.data._id, index)
                }
            },
        };

        var dataGrid2 = ""

        vm.dataGridCollected = {
            onInitialized: function (e) {
                dataGrid2 = e.component;
                RefreshInvoice()
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.CollectedSalesinvoicedatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            // selection: {
            //     mode: "multiple",
            //     showCheckBoxesMode: select,
            //   },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: select,
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85", sortOrder: "desc",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "CustomerName", caption: "Customer Name" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy', sortOrder: 'desc', },
                { dataField: "CreatedBy", caption: "Technician" },
                { dataField: "SalesOrderNo", caption: "SalesOrder No", width: "100" },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "AmountReceived", caption: "Amount Paid", width: "100" },
                { dataField: "OutStandingAmount", caption: "Outstanding Amount", width: "100" },
                { dataField: "PaymentMode", caption: "Payment Mode" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Remarks", caption: "Remarks" },
                //     { dataField: "PushedtoXero", caption: "Pushed to Xero?",
                //     cellTemplate: function (container, options) {
                //         if(options.data.PushedtoXero)
                //       $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                //       else
                //       $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                //   }
                //   },
                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
            ],
            bindingOptions: {
                dataSource: "CollectedSalesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },

            onCellClick: function (data) {
                if (data.columnIndex == 1) {
                    var index = dataGrid2.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo2(data.data._id, index)
                }
            },
            onToolbarPreparing: function (e) {
                var dataGrid = e.component;

                e.toolbarOptions.items.unshift({
                    location: "before",
                    template: "totalGroupCount1"
                });
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.USelectedIds = [];
                    $scope.UTRCdiv = true;
                    $scope.USelectedIds.push.apply($scope.USelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.UTRCdiv = false;
                    $scope.USelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
        };


        $scope.InvoiceFilter = function () {
            if (dataGrid1 != "")
                $("#PendingContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.PendingSalesinvoicedatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Status: "Unpaid", Type: "COD" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Unpaid", Skip: Skip, Limit: Limit, Department: "Pest Off" }
                    }).then(function (GList) {
                        if (dataGrid1 != "")
                            $("#PendingContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.PendingSalesinvoicedatas = $scope.PendingSalesinvoicedatas.concat(GList.data.data)
                        $scope.workOrd = $scope.PendingSalesinvoicedatas
                        $scope.vm.PreviewSpinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid2 != "")
                $("#YTSContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.CollectedSalesinvoicedatas = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid", Skip: Skip, Limit: Limit, Department: "Pest Off" }
                    }).then(function (GList) {
                        if (dataGrid2 != "")
                            $("#YTSContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.CollectedSalesinvoicedatas = $scope.CollectedSalesinvoicedatas.concat(GList.data.data)
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        $scope.InvoiceFilterByDate = function () {
            if (dataGrid1 != "")
                $("#PendingContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.PendingSalesinvoicedatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/countbyDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Unpaid", Department: 'Pest Off', StartDate: $scope.uFrom, EndDate: $scope.uTo }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                if (ContractLength == 0) {
                    $("#PendingContainer").dxDataGrid('instance').endCustomLoading()
                    $scope.PendingSalesinvoicedatas = []
                    $scope.workOrd = $scope.PendingSalesinvoicedatas
                }
                else {
                    for (var i = 0; i < ContractLength; i++) {
                        if (i == 0) Skip = 0
                        else Skip += 300
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/salesinvoice/getByDate",
                            data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Unpaid", StartDate: $scope.uFrom, EndDate: $scope.uTo, Department: "Pest Off", Skip: Skip, Limit: Limit }
                        }).then(function (GList) {
                            if (dataGrid1 != "")
                                $("#PendingContainer").dxDataGrid('instance').endCustomLoading()
                            $scope.PendingSalesinvoicedatas = $scope.PendingSalesinvoicedatas.concat(GList.data.data)
                            $scope.PendingSalesinvoicedatas = _.uniqWith($scope.PendingSalesinvoicedatas, _.isEqual);
                            $scope.workOrd = $scope.PendingSalesinvoicedatas
                            $scope.vm.PreviewSpinner = false
                        })
                    }
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid2 != "")
                $("#YTSContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.CollectedSalesinvoicedatas = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/countbyDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid", Department: 'Pest Off', StartDate: $scope.uFrom, EndDate: $scope.uTo }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                if (ContractLength == 0) {
                    $("#YTSContainer").dxDataGrid('instance').endCustomLoading()
                    $scope.CollectedSalesinvoicedatas = []
                }
                else {
                    for (var i = 0; i < ContractLength; i++) {
                        if (i == 0) Skip = 0
                        else Skip += 300
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/salesinvoice/getByDate",
                            data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid", Department: 'Pest Off', StartDate: $scope.uFrom, EndDate: $scope.uTo, Skip: Skip, Limit: Limit }
                        }).then(function (GList) {
                            if (dataGrid2 != "")
                                $("#YTSContainer").dxDataGrid('instance').endCustomLoading()
                            $scope.CollectedSalesinvoicedatas = $scope.CollectedSalesinvoicedatas.concat(GList.data.data)
                            $scope.CollectedSalesinvoicedatas = _.uniqWith($scope.CollectedSalesinvoicedatas, _.isEqual);
                        })
                    }
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        RefreshCustomer();



        $scope.PushtoXero = function () {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/pushtoxero",
                method: "PUT",
                data: { InvoiceArray: $scope.SelectedIds, CreatedBy: $rootScope.createdby },
            });
            response.then(function (salesinvoicedata) {
                $mdToast.show($mdToast.simple().textContent('Successfully Exported to Xero!').position('top center'));

            })
        }

        $scope.PushCollected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to push the selected invoice to Collected ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/salesinvoice/tocollected",
                        method: "PUT",
                        data: { InvoiceID: $scope.SelectedIds },
                    });
                    response.then(function (GList) {
                        $scope.InvoiceFilter()
                        $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.PushUnCollected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to push the selected invoice to Un-Collected ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/salesinvoice/toUncollected",
                        method: "PUT",
                        data: { InvoiceID: $scope.USelectedIds },
                    });
                    response.then(function (GList) {
                        $scope.InvoiceFilter()
                        $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.ChangeDate = function (Type) {
            if (Type == 'less') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
                $scope.uTo = new Date($scope.uFrom);
            }
            if (Type == 'greater') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
                $scope.uTo = new Date($scope.uFrom);
            }
        }

        GetTotalCurrentYearInvoices();
        function GetTotalCurrentYearInvoices() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearInvoices = 0 }


            });
        }

        $scope.ShowClosed = function (con) {
            $scope.DefaultInvoice = con
            if ($scope.DefaultInvoice) {
                select = 'none'
                $scope.Salesinvoicedatas = undefined;
                var FromDate = $scope.uFrom;
                var ToDate = $scope.uTo;
                var response = $http({
                    url: $rootScope.WebURL + "/salesinvoice/getByXero",
                    method: "POST",
                    data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
                });
                response.then(function (salesinvoicedata) {

                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                });
            }
            else {
                select = 'always'
                $scope.InvoiceFilterByDate()
            }
        }

        $scope.Invoiceadd = function (e) {
            ClearInvoice();

            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;

            var AR = "5" + new Date().getFullYear().toString().substr(-2);

            var info = $scope.TotalCurrentYearInvoices + 1;
            var y = pad(info, 6);
            $scope.InvoiceNumber = AR + y;

            var VR = "SV" + new Date().getFullYear().toString().substr(-2);

            $scope.VoucherNumber = VR + y;

            var item = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            if (item != undefined) {
                $scope.GSTID = item._id;
            }

            $scope.Date = new Date();
            $scope.VoucherDate = new Date();
            $scope.DueDate = new Date();

            $scope.Descriptiondatas = null;
            $scope.ServiceID = null;
            $scope.ServiceIDs = null;

        }

        $scope.ssubmit = function () {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/salesinvoice/newupdate',
                data: {
                    _id: $scope.InvoiceID,
                    DueDate: $scope.DueDate,
                    Amount: $scope.Amount,
                    Remarks: $scope.Remarks,
                    AmountReceived: $scope.AmountReceived
                }
            }).then(function (List) {
                RefreshInvoice();
                $scope.InvoiceGrid = true;
                $scope.InvoiceForm = false;
                $scope.InvoiceFormback = false;
                $scope.InvoiceSelect = true;
                $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
            })
        }

        $scope.ClearSearch = function () {

            $scope.searchTermc = null;
            $scope.CustomerID = null;
            $scope.vm.CustomerID = null;

        }


        $scope.SalesInvoiceInfo = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.PendingSalesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            RefreshPayment()
        }
        $scope.SalesInvoiceInfo2 = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.CollectedSalesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            RefreshPayment()
        }

        $scope.PDeletePopup = function (id, Amount) {
            $scope.PId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the payment?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/paymenthistory/delete",
                        method: "POST",
                        data: { _id: $scope.PId },
                    });
                    response.then(function (GList) {
                        PRefreshPayment()
                        RefreshPayment()
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                    var ReduceAmount = parseFloat($scope.AmountReceived) - parseFloat(Amount)
                    var Outstanding = parseFloat($scope.OutStandingAmount) + parseFloat(Amount)
                    $scope.TOutStandingAmount = Outstanding.toString()
                    var Status = "Unpaid"
                    if (Outstanding != $scope.Amount && ReduceAmount > 0)
                        Status = "Partially Paid"
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: ReduceAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.AmountReceived = ReduceAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $scope.InvoiceFilterByDate()
                    })
                }
            });
        }


        RefreshBank();
        RefreshClientBank();

        $scope.SelectScheduler = function () {
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.ServiceID === $scope.ServiceID
            })[0]
            $scope.Description = moment(item.Startsat).format('DD MMMM YYYY') + " - " + item.PestType
        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshClientBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });
        }

        function RefreshInvoice() {
            $scope.InvoiceFilterByDate()

        }
        function ClearInvoice() {
            $scope.CustomerID = null; $scope.WorkOrderID = null; $scope.Date = null; $scope.VoucherNumber = null;
            $scope.Amount = null; $scope.ServiceIDs = null; $scope.GSTID = null; $scope.Description = null;
            $scope.VoucherDate = null; $scope.CreditTerm = null; $scope.Remarks = null;
            $scope.ContractID = null; $scope.ConID = null;
        }
        $scope.updateCustomRequest = function (data, type, res) {

        };

        $scope.OnTopInvoiceContractChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ContractID;
            })[0];

            $scope.ConID = $scope.ContractID;
            $scope.CustomerID = item.Customer_id;
            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.OnConChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ConID;
            })[0];

            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.IsAmountLoaded = false;


        GetTotalCurrentYearPayments();
        function GetTotalCurrentYearPayments() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearPayments = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearPayments = 0 }


            });
        }


        $scope.CollectPaymentadd = function (e) {

            $scope.InvoicefilterByCustomer();
            $scope.IsAmountLoaded = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            ClearCollectPayment();
            $scope.Update = false;

            $scope.vm.uTo = $scope.uTo;
            $scope.vm.uFrom = $scope.uFrom;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

            var itemB = $scope.Bankdatas.filter(function (item) {
                return item.BankName === "OCBC";
            })[0];

            $scope.vm.BankID = itemB._id;

            $scope.vm.Date = new Date();
            $scope.vm.VoucherDate = new Date();

            var info = $scope.TotalCurrentYearPayments + 1;
            var y = pad(info, 6);
            var VR = "CP" + new Date().getFullYear().toString().substr(-2);
            $scope.vm.VoucherNumber = VR + y;

            $scope.CPItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


        }

        $scope.SaveCollectPayment = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/collectpayment/update",
                    data: {
                        _id: $scope.CollectPaymentID, CustomerID: $scope.vm.CustomerID,
                        Description: $scope.vm.Description, Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID, ClientBankName: $scope.vm.ClientBankName, ChequeDate: $scope.vm.ChequeDate,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.CollectPaymentdatas[$scope.CollectPaymentIndex] = GList.data.data[0];

                    RefreshInvoice();
                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {




                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                        Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                    },
                });


                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    GetTotalCurrentYearPayments()
                    RefreshCollectPayment();
                    RefreshCustomerstatement();
                    RefreshInvoice();

                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }


        $scope.CollectPaymentinfo = function (CollectPaymentID, Index) {

            $scope.CollectPaymentIndex = Index;
            $scope.Salesinvoicedatasdd = $scope.Salesinvoicedatas;

            $scope.CollectPaymentID = CollectPaymentID;
            $scope.Update = true;

            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;

            var item = $scope.CollectPaymentdatas.filter(function (item) {
                return item._id === CollectPaymentID;
            })[0];

            $scope.vm.CustomerID = item.CustomerID;
            $scope.vm.BankID = item.BankID;
            $scope.vm.VoucherNumber = item.VoucherNumber;
            $scope.vm.VoucherDate = new Date(item.VoucherDate);
            $scope.vm.ChequeNumber = item.ChequeNumber;
            $scope.vm.ChequeDate = new Date(item.ChequeDate);
            $scope.vm.Description = item.Description;
            $scope.vm.Date = new Date(item.Date);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.ClientBankName = item.ClientBankName;

            $scope.CPItemDetails = item.itemDetails;

            $scope.IsAmountLoaded = true;

            $scope.HideAdd = true;
            $scope.HideSave = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

        }

        $scope.CPItemSubmit = function () {


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/collectpayment/add",
                data: {
                    CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                    Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                    VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Collectpayment") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/collectpayment/getByID",
                        data: {
                            VoucherNumber: $scope.vm.VoucherNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CollectPaymentID = GList.data.data[0]._id;
                        SaveCPItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CollectPaymentID = GList.data.data.id;
                    SaveCPItems(GList.data.data.id);
                    GetTotalCurrentYearPayments()
                }

            }, function () {


            });

        }


        $scope.CPItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }

            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/UpdateItem",
                data: {
                    CollectPaymentID: $scope.CollectPaymentID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    PaidAmount: $scope.PaidAmount,
                    InvoiceAmount: parseFloat(InvoiceAmount),
                    OutStandingAmount: OutStandingAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CPItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCPItems(CollectPaymentID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }


            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "PaidAmount": $scope.PaidAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceAmount": parseFloat(InvoiceAmount),
                "OutStandingAmount": OutStandingAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "_id": undefined
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/addItems",
                data: {
                    _id: CollectPaymentID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    InvoiceNumber: InvoiceNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Date: $scope.vm.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CPItemDetails != undefined) {
                    $scope.CPItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/getByID",
                    data: {
                        VoucherNumber: $scope.vm.VoucherNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CPItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CPItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CPItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.ServiceSelect = function () {
            RefreshScheduler()
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }

        $scope.CollectPaymentFilter = function () {
            $scope.CollectPaymentdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }
        function ClearCollectPayment() {

            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.Date = null;
            $scope.vm.ChequeDate = null;
            $scope.vm.Amount = null;
            $scope.vm.InvoiceID = null;
            $scope.vm.Description = null;
            $scope.vm.Remarks = null;
            $scope.vm.ChequeNumber = null;
            $scope.vm.VoucherNumber = null;
            $scope.vm.ClientBankName = null;
        }


        GetTotalCurrentYearCreditnotes();

        function GetTotalCurrentYearCreditnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearCreditnotes = 0
                }


            });
        }

        $scope.Creditnoteadd = function (e) {
            ClearCreditnote();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;
            $scope.Update = false;
            $scope.IsAmountLoaded = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;

            $scope.CreditNote.$setPristine();
            $scope.CreditNote.$setUntouched();

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearCreditnotes + 1;
            var y = pad(info, 6);
            var VR = "CNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "CNS" + new Date().getFullYear().toString().substr(-2);
            $scope.CreditNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }
        function ClearCreditnote() {

            $scope.RefrenceNumber = null
            $scope.InvoiceID = null;
            $scope.AccountID = null
            $scope.Description = null
            $scope.Amount = null
            $scope.GSTID = null
            $scope.Remarks = null;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveCreditnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salescreditnote/update",
                    data: {
                        _id: $scope.CreditnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshInvoice();
                    RefreshCustomerstatement();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearCreditnotes();
                    RefreshCreditnote();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Creditnoteinfo = function (CreditnoteID, index) {


            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;

            $scope.CreditnoteID = CreditnoteID;
            $scope.Update = true;

            var item = $scope.Creditnotedatas.filter(function (item) {
                return item._id === CreditnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)

            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.CreditNoteNumber = item.CreditNoteNumber
            $scope.CNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }


        $scope.ClearCNItems = function () {
            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        $scope.CNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salescreditnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales credit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salescreditnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveCNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveCNItems(GList.data.data.id);
                    GetTotalCurrentYearCreditnotes();
                }

            }, function () {


            });

        }


        $scope.CNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/UpdateItem",
                data: {
                    CreditnoteID: $scope.CreditnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CNItemDetails != undefined) {
                    $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }

        function RefreshCreditnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });


        }

        $scope.CreditnoteFilter = function () {
            $scope.Creditnotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });
        }

        $scope.CreditnoteShowgrid = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridCollectPayment = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;


        }
        function ClearCreditnote() {
            $scope.RefrenceNumber = null;
            $scope.VoucherDate = null;
            $scope.InvoiceID = null;
            $scope.Date = null;
            $scope.AccountID = null;
            $scope.Description = null;
            $scope.Amount = null;
            $scope.GSTID = null;
            $scope.Remarks = null;
        }

        RefreshGST();
        RefreshChartofAccount();

        RefreshContract();


        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {

                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }
        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getBySalesOrder",
                data: {
                    SalesOrderId: $scope.WorkOrderID,
                },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getforinvoice",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getByCustomer",
                data: {
                    CustomerId: $scope.CustomerID
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshDescription() {

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
                // DeleteDescription();
            });
        }
        function DeleteDescription() {

            try {
                $scope.ServiceIDs = $scope.ServiceID.map(function (obj) { return obj.ServiceID; }).join(',');
            } catch (error) {

            }

            angular.forEach($scope.Descriptiondatas, function (value, key) {

                if (aContainsB($scope.ServiceIDs.trim(), value.ServiceReportNo.trim())) {

                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: value._id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                    });
                }

            });
        }
        $scope.DeletePopup = function (ID) {
            $scope.Id = ID
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the description?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: $scope.Id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }


        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }

        $scope.EnableDescription = function (DescID, ServiceReportNo) {
            $scope.Desc = false;
            $scope.textbar = true;
            $scope.ServiceReportNo = ServiceReportNo;
            $scope.DescID = DescID;

            var item = $scope.Descriptiondatas.filter(function (item) {
                return item._id === DescID;
            })[0];

            if (item != undefined) {
                $scope.Description = item.Description
                $scope.ServiceID = $scope.ServiceReportNo
            }

        }
        $scope.DescriptionSubmit = function () {
            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/update",
                method: "PUT",
                data: { _id: $scope.DescID, ServiceReportNo: $scope.ServiceID, Description: $scope.Description },
            });
            response.then(function (GList) {
                RefreshDescription();
                $scope.Description = null;
                $scope.Desc = true;
            });
        }

        $scope.AddPayment = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/Pestoff/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function cashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Date = new Date()
            $scope.vm.Amount = 0
        }
        $scope.UpdatePay = false
        $scope.EditPop = function (e, data) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/Pestoff/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function cashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.UpdatePay = true
            $scope.UpdateID = data._id;
            $scope.vm.Remarks = data.Remarks;
            $scope.vm.Date = data.Date;
            $scope.vm.Amount = parseFloat(data.Amount)
            $scope.AmountReceived = $scope.AmountReceived - parseFloat(data.Amount)
        }

        $scope.SubmitPayment = function () {
            var TotalAmount = parseFloat($scope.vm.Amount) + parseFloat($scope.AmountReceived)
            if (TotalAmount > $scope.Amount)
                $mdToast.show($mdToast.simple().textContent('Amount Paid is greater than Invoice Amount!').position('top center'));
            else {

                var Amount = parseFloat($scope.Amount);
                var Outstanding = Amount - TotalAmount;
                $scope.TOutStandingAmount = Outstanding.toString();

                var Status = "Unpaid";
                if (!isNaN(Amount) && !isNaN(TotalAmount)) {
                    if (Outstanding === 0) {
                        Status = "Fully Paid";
                    } else if (Outstanding !== Amount && TotalAmount > 0) {
                        Status = "Partially Paid";
                    }
                }
                if ($scope.UpdatePay == false) {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + '/paymenthistory/add',
                        data: {
                            InvoiceID: $scope.InvoiceID,
                            Amount: $scope.vm.Amount,
                            Date: $scope.vm.Date,
                            Remarks: $scope.vm.Remarks,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (List) {
                        $http({
                            method: "PUT",
                            url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                            data: {
                                _id: $scope.InvoiceID,
                                AmountReceived: TotalAmount,
                                OutStandingAmount: Outstanding,
                                Status: Status,
                                CreatedBy: $rootScope.createdby
                            }
                        }).then(function (GList) {
                            $scope.InvoiceFilterByDate()
                            $scope.AmountReceived = TotalAmount
                            $scope.OutStandingAmount = Outstanding
                            $scope.Status = Status
                            $scope.UpdatePay = false
                            $mdDialog.cancel()
                            PRefreshPayment()
                            RefreshPayment()
                            $mdToast.show($mdToast.simple().textContent('Payment Added Successfully!').position('top center'));

                        })
                    })
                }
                else {
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/paymenthistory/update',
                        data: {
                            _id: $scope.UpdateID,
                            InvoiceID: $scope.InvoiceID,
                            Amount: $scope.vm.Amount,
                            Date: $scope.vm.Date,
                            Remarks: $scope.vm.Remarks,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (List) {
                        $http({
                            method: "PUT",
                            url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                            data: {
                                _id: $scope.InvoiceID,
                                AmountReceived: TotalAmount,
                                OutStandingAmount: Outstanding,
                                Status: Status,
                                CreatedBy: $rootScope.createdby
                            }
                        }).then(function (GList) {
                            $scope.InvoiceFilterByDate()
                            PRefreshPayment()
                            RefreshPayment()
                            $scope.AmountReceived = TotalAmount
                            $scope.OutStandingAmount = Outstanding
                            $scope.UpdatePay = false
                            $scope.Status = Status
                            $mdDialog.cancel()
                            $mdToast.show($mdToast.simple().textContent('Payment Updated Successfully!').position('top center'));

                        })
                    })
                }
            }

        }

        function RefreshPayment() {
            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: $scope.InvoiceID },
            });
            response1.then(function (GList) {
                var data = GList.data.data;
                $scope.CollectedAmt = 0
                angular.forEach(data, function (item) {
                    item.Date = new Date(item.Date)
                    $scope.CollectedAmt = $scope.CollectedAmt + parseFloat(item.Amount)
                })
                $scope.Paymentdatas = data;
            })
        }

        function PRefreshPayment() {
            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: $scope.InvoiceID },
            });
            response1.then(function (GList) {
                var data = GList.data.data;
                var CollectedAmt = 0
                angular.forEach(data, function (item) {
                    CollectedAmt = CollectedAmt + parseFloat(item.Amount)
                })

                var OutStandingAmount = 0
                OutStandingAmount = parseFloat($scope.Amount) - parseFloat(CollectedAmt)

                $http({
                    method: 'PUT',
                    url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                    data: {
                        _id: $scope.InvoiceID,
                        AmountReceived: CollectedAmt,
                        OutStandingAmount: OutStandingAmount,
                        Status: "Partially Paid",
                        UpdatedBy: $rootScope.createdby,

                    }
                }).then(function (List) {
                    RefreshInvoice();
                    $scope.TOutStandingAmount = OutStandingAmount
                })

            })
        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        $scope.OnWorkOrderChange = function () {

            var myArray = $scope.ServiceID;

            if (myArray == undefined) {
                $scope.ServiceIDs = "null";
                RefreshDescription();
            }


            var BillingAmount = 0;
            angular.forEach(myArray, function (value, key) {

                var Description = "Being Inspection and Treatment carried out for the control of";

                try {
                    Description = "Being Inspection and Treatment carried out for the control of " + monthNames[new Date(value.Startsat).getMonth()] + " " + new Date(value.Startsat).getFullYear()

                } catch (error) {

                }

                if (value.BillingAmount != undefined) {
                    BillingAmount = BillingAmount + parseFloat(value.BillingAmount);

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: value.BillingAmount },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: 0 },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }

            });





            $scope.Amount = BillingAmount;




            // var myArray = $scope.ServiceID;

            // var item = myArray.filter(function (item) {
            //     return item._id === $scope.WorkOrderID;
            // })[0];

            // var TotalOrderValue = item.TotalOrderValue;
            // var TotalServices = $scope.ServiceID;
            // $scope.Amount = Math.round(TotalOrderValue / (TotalServices.length), 2);

        }
        $scope.OnInvoiceChange = function () {



            if ($scope.IsAmountLoaded == false) {

                var InvoiceID = $scope.vm.InvoiceID;
                var TotalAmount = 0;
                angular.forEach(InvoiceID, function (value, key) {

                    TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);


                    // var item = $scope.GSTdatas.filter(function (item) {
                    //     return item.id === value.GSTID;
                    // })[0]; 

                    // if(item!=undefined){

                    //     if (value.Status == "Partial") { 

                    //         var Amt=TotalAmount + parseFloat(value.OutStandingAmount); 

                    //         TotalAmount=Amt + (parseFloat((Amt / 100) * parseFloat(item.TaxRate))); 
                    //     }
                    //     else { 
                    //        // TotalAmount = TotalAmount + parseFloat(value.Amount);
                    //         TotalAmount = parseFloat(TotalAmount) + parseFloat(value.Amount) + (parseFloat((value.Amount / 100) * parseFloat(item.TaxRate)));
                    //     }  

                    // }
                    //else{
                    // if (value.Status == "Partial") {
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount); 
                    // }
                    // else { 
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);
                    // } 
                    // }

                });
                $scope.vm.Amount = TotalAmount;
            }

        }

        $scope.OnCNInvoiceChange = function () {


            // if($scope.IsAmountLoaded == false) {
            // var InvoiceID = $scope.InvoiceID;
            // var TotalAmount = 0;
            // angular.forEach(InvoiceID, function (value, key) {

            //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);

            // }); 
            // $scope.Amount = TotalAmount;
            //  }
        }
        $scope.OnCustomerChange = function () {

            var myArray = $scope.Customerdatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.CustomerID;
            })[0];

            if (item.CreditTerm != undefined) {

                $scope.CreditTerm = parseInt(item.CreditTerm);
            }
            else {
                $scope.CreditTerm = 0;
            }

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }


            RefreshSalesOrder()
        }

        $scope.OnVoucherDateChange = function () {
            $scope.Date = $scope.VoucherDate;
            if ($scope.CreditTerm != null || $scope.CreditTerm != undefined) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
            else {
                $scope.DueDate = $scope.VoucherDate;
            }
        }

        $scope.OnInvoiceDateChange = function () {
            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCreditTermChange = function () {

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCSStatusChange = function () {

            if ($scope.CSStatus == 'ShowAll') {

                $scope.Customerstatementdatas = $scope.Customerstatementalldatas;
            } else {

                if ($scope.Customerstatementalldatas != undefined) {
                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === $scope.CSStatus;
                    });
                    $scope.Customerstatementdatas = item;
                }

            }
        }



        function RefreshCustomerstatement() {
            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.RefreshCustomers = function () {
            $scope.Customerstatementdatas = undefined;

            if ($scope.FilterByCustomer == true) {

                if ($scope.CusID == undefined) {

                    $mdToast.show($mdToast.simple().textContent('Please Select Customer & Click Search!').position('top center'));

                    $scope.Customerstatementdatas = [];
                }
                else {
                    var response = $http({
                        url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                        method: "POST",
                        data: { CustomerID: $scope.CusID },
                    });
                    response.then(function (Customerstatementdata) {
                        $scope.Customerstatementdatas = Customerstatementdata.data.data;
                        $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                        var item = $scope.Customerstatementalldatas.filter(function (item) {
                            return item.Status === 'Unpaid';
                        });
                        $scope.Customerstatementdatas = item;
                    });
                }
            }
            else {
                var response = $http({
                    url: $rootScope.WebURL + "/customerstatement/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
                });
                response.then(function (Customerstatementdata) {
                    $scope.Customerstatementdatas = Customerstatementdata.data.data;
                    $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === 'Unpaid';
                    });
                    $scope.Customerstatementdatas = item;
                });
            }

        }

        $scope.Filter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                method: "POST",
                data: { CustomerID: $scope.CusID },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        GetTotalCurrentYearDebitnotes();

        function GetTotalCurrentYearDebitnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearDebitnotes = 0
                }


            });
        }

        $scope.Debitnoteadd = function (e) {

            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;

            $scope.DebitnoteSelect = false;

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearDebitnotes + 1;
            var y = pad(info, 6);
            var VR = "DNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "DNS" + new Date().getFullYear().toString().substr(-2);
            $scope.DebitNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;
            $scope.Update = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.Description = undefined;
            $scope.Remarks = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        $scope.SaveDebitnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salesdebitnote/update",
                    data: {
                        _id: $scope.DebitnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshDebitnote();

                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearDebitnotes();
                    RefreshDebitnote();
                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Debitnoteinfo = function (DebitnoteID, index) {

            $scope.DebitnoteID = DebitnoteID;
            $scope.Update = true;
            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.DebitnoteSelect = false;
            $scope.DebitnoteID = DebitnoteID;

            var item = $scope.Debitnotedatas.filter(function (item) {
                return item._id === DebitnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)


            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.DebitNoteNumber = item.DebitNoteNumber
            $scope.DNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        function RefreshDebitnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }

        $scope.DebitnoteFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }


        $scope.DNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesdebitnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales debit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesdebitnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveDNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveDNItems(GList.data.data.id);
                    GetTotalCurrentYearDebitnotes();
                }

            }, function () {


            });

        }


        $scope.DNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/UpdateItem",
                data: {
                    DebitnoteID: $scope.DebitnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.DNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveDNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.DNItemDetails != undefined) {
                    $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.DNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.DNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.DNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.Showgrid = function () {
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceGrid = true;
            $scope.InvoiceForm = false;
            $scope.InvoiceSelect = true;
            $scope.InvoiceFormback = false;

            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridDebit = function () {

            $scope.DebitnoteSelect = true;
            $scope.DebitnoteGrid = true;
            $scope.DebitnoteForm = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.InvoicefilterByCustomer = function () {


            $scope.vm.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.vm.uFrom;
            var ToDate = $scope.vm.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });

            response.then(function (salesinvoicedata) {

                var myArray = salesinvoicedata.data.data;

                var item = myArray.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                $scope.Salesinvoicedatasdd = item;
            });
        };

        $scope.InvoicefilterByCustomerform = function () {


            $scope.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });
            response.then(function (salesinvoicedata) {
                $scope.Salesinvoicedatasddf = salesinvoicedata.data.data;

                var item = $scope.Salesinvoicedatasddf.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                var item2 = item.filter(function (item) {
                    return item.Status !== "Adjust" && parseFloat(item.OutStandingAmount) > 0;
                });
                $scope.Salesinvoicedatasddf = item2;
            });


        };

        $scope.InvoiceExport = function () {
            alasql('SELECT * INTO XLSX("Invoice.xlsx",{headers:true}) FROM ?', [$scope.Salesinvoicedatas]);
        };
        $scope.CollectPaymentExport = function () {
            alasql('SELECT * INTO XLSX("CollectPayment.xlsx",{headers:true}) FROM ?', [$scope.CollectPaymentdatas]);
        };
        $scope.CreditnoteExport = function () {
            alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
        };
        $scope.DebitnoteExport = function () {
            alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
        };
        $scope.CustomerStatementExport = function () {
            alasql('SELECT * INTO XLSX("CustomerStatement.xlsx",{headers:true}) FROM ?', [$scope.Customerstatementdatas]);
        };


        $scope.Printsalesinvoice = function (CreditnoteID) {
            var url = $rootScope.ReportURL + "SalesInvoice.aspx?ID=" + CreditnoteID;
            window.open(url);
        }


        $scope.getTotal = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.Amount);
                });

                return total.toFixed(2);
            } else {
                0
            }
        }
        $scope.getAccountCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var AccountCode = itemDetails.map(function (obj) {
                    return obj.AccountCode;
                }).join(',');
                return AccountCode;
            } else {
                return null;
            }
        }

        $scope.getGSTCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var GSTCode = itemDetails.map(function (obj) {
                    return obj.GSTCode;
                }).join(',');
                return GSTCode;
            } else {
                return null;
            }
        }
        $scope.getInvoiceNumber = function (itemDetails) {

            if (itemDetails != undefined) {
                var InvoiceNumber = itemDetails.map(function (obj) {
                    return obj.InvoiceNumber;
                }).join(',');
                return InvoiceNumber;
            } else {
                return null;
            }
        }


        $scope.getTotalInvoiceAmount = function (itemDetails) {

            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.InvoiceAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }
        $scope.getTotalOutStandingAmount = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.OutStandingAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }



        vm.dtOptions = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            bProcessing: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        vm.dtOptions1 = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.InvoiceTab = function () {
            $scope.InvoiceSelect = true;
            $scope.InvoiceGrid = true;

            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };

        $scope.CollectPaymentTab = function () {
            RefreshCollectPayment();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.CreditnoteTab = function () {
            RefreshCreditnote();
            $scope.InvoiceSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.InvoiceForm = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.DebitnoteTab = function () {
            RefreshDebitnote();
            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = true;
            $scope.CollectPaymentSelect = false;
            $scope.InvoiceForm = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteGrid = true;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.SearchValue = "";
        };
        $scope.CustomerStatementTab = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });


            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = true;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceForm = false;

            $scope.CollectPaymentFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.SearchValue = "";
        };

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $scope.Today = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            $scope.uFrom = new Date();
            $scope.uTo = new Date();
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();

        }
        $scope.lastweek = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = new Date(from);
            $scope.uTo = new Date(to);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        $scope.lastmonth = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = new Date(lastMonthStartDate);
            $scope.uTo = new Date(lastMonthEndDate);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        var now = new Date();
        $scope.minDate = new Date(
            now.getFullYear() - 5,
            now.getMonth(),
            now.getDate()
        );


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'D.M.YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }


})();
(function () {
    'use strict';

    angular
        .module('app.accounts.lumair.cashInvoice', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.accounts_LcashInvoice', {
            url: '/LcashInvoice',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/Lumair/casheInvoice/cashInvoice.html',
                    controller: 'LcashInvoiceController as vm'
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.lumair.cashInvoice')
        .controller('LcashInvoiceController', LcashInvoiceController);


    function LcashInvoiceController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        document.getElementsByTagName('title')[0].text = "Lumiair-Cash/Cheque"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcLumiair")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $scope.TRCCdiv = false
        var select = 'always'
        $scope.Desc = true;
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);
        $scope.vm.uTo = $scope.uTo;
        $scope.vm.uFrom = $scope.uFrom;

        $scope.InvoiceSelect = true;
        $scope.InvoiceGrid = true;
        $scope.InvoiceForm = false;
        $scope.CollectPaymentSelect = false;
        $scope.CreditnoteSelect = false;
        $scope.CustomerStatementSelect = false;
        $scope.CreditnoteGrid = false;
        $scope.CreditnoteForm = false;
        $scope.DebitnoteSelect = false;
        $scope.DebitnoteGrid = false;
        $scope.DebitnoteForm = false;
        $scope.InvoiceFormback = false;
        $scope.CollectPaymentGrid = false;
        $scope.CollectPaymentForm = false;
        $scope.CollectPaymentFormback = false;

        $scope.FilterByCustomer = true;

        var dataGrid1 = ""
        $scope.TRCdiv = false;
        $scope.UTRCdiv = false;
        vm.dataGridPending = {
            onInitialized: function (e) {
                dataGrid1 = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.PendingSalesinvoicedatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: select,
            },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85", sortOrder: "desc",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                {
                    dataField: "CustomerName", caption: "Customer Name",
                    cellTemplate: function (container, options) {
                        $("<p style='black:blue;cursor: pointer;'>" + options.data.CustomerName + "</p>").appendTo(container);
                    },
                },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy' },
                { dataField: "CreatedBy", caption: "Technician" },
                { dataField: "SalesOrderNo", caption: "SalesOrder No", width: "100" },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "AmountReceived", caption: "Amount Paid", width: "100" },
                { dataField: "OutStandingAmount", caption: "Outstanding Amount", width: "100" },
                // { dataField: "PaymentMode", caption: "Payment Mode" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Remarks", caption: "Xero Invoice No" },
                {
                    dataField: "PushedtoXero", caption: "Pushed to Xero?",
                    cellTemplate: function (container, options) {
                        if (options.data.PushedtoXero)
                            $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                        else
                            $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                    }
                },
                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
            ],
            bindingOptions: {
                dataSource: "PendingSalesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
            onToolbarPreparing: function (e) {
                var dataGrid = e.component;

                e.toolbarOptions.items.unshift({
                    location: "before",
                    template: "totalGroupCount"
                });
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedIds = [];
                    $scope.TRCdiv = true;
                    $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.TRCdiv = false;
                    $scope.SelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
            onCellClick: function (data) {
                if (data.columnIndex == 2) {
                    var index = dataGrid1.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo(data.data._id, index)
                }
                if (data.columnIndex == 3) {
                    $scope.SID = data.data.Customer_Id
                    $scope.AllIfo(data.data.Customer_Id)
                }
            },
        };

        var dataGrid2 = ""

        vm.dataGridCollected = {
            onInitialized: function (e) {
                dataGrid2 = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.CollectedSalesinvoicedatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            // selection: {
            //     mode: "multiple",
            //     showCheckBoxesMode: select,
            //   },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: select,
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85", sortOrder: "desc",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "CustomerName", caption: "Customer Name" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy' },
                { dataField: "CreatedBy", caption: "Technician" },
                { dataField: "SalesOrderNo", caption: "Work Order No", width: "100" },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "AmountReceived", caption: "Amount Collected", width: "100" },
                { dataField: "OutStandingAmount", caption: "Outstanding Amount", width: "100" },
                { dataField: "PaymentMode", caption: "Payment Mode" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Remarks", caption: "Remarks" },
                {
                    dataField: "PushedtoXero", caption: "Pushed to Xero?",
                    cellTemplate: function (container, options) {
                        if (options.data.PushedtoXero)
                            $("<p style='color:blue;cursor: pointer;'>Yes</p>").appendTo(container);
                        else
                            $("<p style='color:blue;cursor: pointer;'>No</p>").appendTo(container);
                    }
                },
                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                if (options.data.XeroInvoiceID) {
                                    var fileurl = "https://go.xero.com/AccountsReceivable/View.aspx?InvoiceID=" + options.data.XeroInvoiceID
                                    window.open(fileurl);
                                }
                                else
                                    $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
            ],
            bindingOptions: {
                dataSource: "CollectedSalesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },

            onCellClick: function (data) {
                if (data.columnIndex == 1) {
                    var index = dataGrid2.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo2(data.data._id, index)
                }
            },
            onToolbarPreparing: function (e) {
                var dataGrid = e.component;

                e.toolbarOptions.items.unshift({
                    location: "before",
                    template: "totalGroupCount1"
                });
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.USelectedIds = [];
                    $scope.UTRCdiv = true;
                    $scope.USelectedIds.push.apply($scope.USelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.UTRCdiv = false;
                    $scope.USelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
        };

        $scope.dateBox = {
            type: "date",
            value: new Date(),
            displayFormat: 'Year',
            calendarOptions: {
                zoomLevel: 'decade',
                maxZoomLevel: 'decade',
                mixZoomLevel: 'decade',
            },
            onValueChanged: function (e) {
                $scope.GetSchedulerDetails($scope.SID, e.value)
            },

        }

        $scope.GetSchedulerDetails = function (CId, Status) {

            $scope.vm.Start_Date = new Date(new Date(Status).getFullYear(), 0, 1)
            $scope.vm.End_Date = new Date(new Date(Status).getFullYear(), 12, 0)
            $scope.vm.PreviewSpinner = true;
            $scope.Schedulerdetails = [];
            $scope.PVSchedulerdetails = [];
            $http({
                url: $rootScope.WebURL + "/scheduler/getByFileID",
                method: "POST",
                data: { FileID: CId, Start_Date: $scope.vm.Start_Date, End_Date: $scope.vm.End_Date },
            }).then(function (List) {
                $scope.Schedulerdetails = List.data.data;
                $scope.PVSchedulerdetails = List.data.data;
                var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
                    return new Date(item4.Startsat) >= $scope.vm.pvFrom && new Date(item4.Startsat) <= $scope.vm.pvTo && item4.Status === "Completed";
                });
                $scope.PVSchedulerdetails = item4;
                $scope.vm.PreviewSpinner = false;
            });
        }

        vm.dataGridCustomerService = {
            dataSource: $scope.CustomerServicedatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            searchPanel: {
                visible: false,
                width: 320,
                placeholder: "Search..."
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "sName", caption: "Name" },
                { dataField: "sContactPerson", caption: "Contact Person" },
                //   { dataField: "sBLK", caption: "Blk" },
                //   { dataField: "sUnit", caption: "Unit" },
                { dataField: "sStreetName", caption: "Address" },
                { dataField: "sPostal", caption: "Postal" },
                { dataField: "sEmail", caption: "Email" },
                { dataField: "sMobile", caption: "Mobile" },
            ],
            bindingOptions: {
                dataSource: "CustomerServicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
        };

        vm.dataGridCustomerBilling = {

            dataSource: $scope.CustomerBillingdatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            searchPanel: {
                visible: false,
                width: 320,
                placeholder: "Search..."
            },
            columns: [
                {
                    caption: '#', width: "40", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "bContactPerson", caption: "Contact Person" },
                //   { dataField: "bBLK", caption: "Blk" },
                { dataField: "bStreetName", caption: "Address" },
                { dataField: "bPostal", caption: "Postal" },
                { dataField: "bCountry", caption: "Country" },
                { dataField: "bEmail", caption: "Email" },
                { dataField: "bMobile", caption: "Mobile" },

            ],
            bindingOptions: {
                dataSource: "CustomerBillingdatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
        };

        $scope.AllIfo = function (CId) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getById",
                data: { _id: CId },
            });
            response.then(function (GList) {
                try {
                    var item = GList.data.data[0];
                    $scope.vm.PaymentTerm = item.Unit;
                    $scope.vm.CreditTerm = item.CreditTerm;
                    $scope.vm.uCustomerID = item.CustomerID;
                    $scope.RequestID = item.CustomerID;
                    $scope.vm.CustomerReference = item.CustomerReference;
                    $scope.vm.Salutation = item.Salutation;
                    $scope.vm.FirstName = item.FirstName;
                    $scope.vm.LastName = item.LastName;
                    $scope.vm.CompanyName = item.CompanyName;
                    $scope.vm.Note = item.Note;
                    var Address = item.Address.split(',');
                    var add = Address.filter(function (val) {
                        return val != "null" && val != "undefined"
                    })
                    $scope.vm.Address = add.join(',') + " Singapore " + item.Postal
                    $scope.vm.Address1 = item.Address1;
                    $scope.vm.ContactPerson = item.ContactPerson;
                    $scope.vm.SalesPerson = item.SalesPerson_id;
                    $scope.vm.Phone = (item.Phone);
                    $scope.vm.Mobile = item.Mobile
                    $scope.vm.Email = item.Email

                    if (item.ConEndDate != "" && item.ConEndDate != null && item.ConEndDate != undefined) {
                        $scope.vm.ConEndDate = new Date(item.ConEndDate);
                    } else { $scope.vm.ConEndDate = null }
                    if (item.ProspectFollowupDate != "" && item.ProspectFollowupDate != null && item.ProspectFollowupDate != undefined) {
                        $scope.vm.ProspectFollowDate = new Date(item.ProspectFollowupDate);
                    } else { $scope.vm.ProspectFollowDate = null }
                    $scope.vm.Unit = item.Unit;
                    $scope.vm.StreetName = item.StreetName;
                    $scope.vm.BuildingName = item.BuildingName;
                    $scope.vm.CreditTerm = item.CreditTerm;
                    if (item.State == "null" || item.State == undefined) {
                        $scope.vm.State = "Active";
                    }
                    else {
                        $scope.vm.State = item.State;
                    }
                    $scope.vm.Category = item.Category;
                    $scope.vm.MarketSection = item.MarketSection

                    $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
                    $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
                    $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
                    $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
                    $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
                    angular.forEach($scope.Schedulerdetails, function (value) {
                        angular.forEach($scope.SalesOrderdetails, function (svalue) {
                            if (value.JobsOrders == svalue._id) {
                                value.JobsOrders = svalue.SalesOrderNo
                            }
                        })
                        angular.forEach($scope.Contracterdetails, function (cvalue) {
                            if (value.ContractOrder == cvalue._id) {
                                value.ContractOrder = cvalue.ContractReferenceNo
                            }
                        })
                    })
                    angular.forEach($scope.SalesOrderdetails, function (svalue) {
                        angular.forEach($scope.Contracterdetails, function (cvalue) {
                            if (svalue._id == cvalue.SalesOrderID) {
                                cvalue.SalesOrderID = svalue.SalesOrderNo
                            }
                        })
                    })
                    var item = $scope.Schedulerdetails.filter(function (item) {
                        return new Date(item.Startsat) >= $scope.vm.upFrom && new Date(item.Startsat) <= $scope.vm.upTo && item.Status === "Yet to Start";
                    });
                    $scope.Schedulerdetails = item;
                    var item1 = $scope.Invoicedetails.filter(function (item1) {
                        return new Date(item1.Date) >= $scope.vm.uIFrom && new Date(item1.Date) <= $scope.vm.uITo;
                    });
                    $scope.Invoicedetails = item1;

                    var item3 = $scope.Contracterdetails.filter(function (item3) {
                        return new Date(item3.ContractEndDate) >= $scope.vm.ucFrom && new Date(item3.ContractEndDate) <= $scope.vm.ucTo;
                    });
                    $scope.Contracterdetails = item3;
                    var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
                        return new Date(item4.Startsat) >= $scope.vm.pvFrom && new Date(item4.Startsat) <= $scope.vm.pvTo && item4.Status === "Completed";
                    });
                    $scope.PVSchedulerdetails = item4;
                    CustomerBillingdatadetails()
                    CustomerServicedatadetails()
                    $mdDialog.show({
                        multiple: true,
                        templateUrl: 'app/main/apps/accounts/Lumair/casheInvoice/CustomerInfo.html',
                        parent: angular.element($document.body),
                        targetEvent: Event,
                        scope: $scope.$new(),
                        clickOutsideToClose: false,
                        controller: function LcashInvoiceController($scope, $mdDialog) {
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            }
                        }
                    });
                }
                catch (e) { }
            });
        }

        function CustomerBillingdatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforBilling",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerBillingdata) {
                $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
            });
        }
        function CustomerServicedatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerServicedata) {
                $scope.CustomerServicedatas = CustomerServicedata.data.data;
            });
        }

        $scope.InvoiceFilter = function () {
            if (dataGrid1 != "")
                $("#PendingContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.PendingSalesinvoicedatas = []
            $scope.vm.PendingSchedulespinner = true
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Status: "Unpaid", Type: "COD" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Unpaid", Skip: Skip, Limit: Limit, Department: "Lumiair" }
                    }).then(function (GList) {
                        if (dataGrid1 != "")
                            $("#PendingContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.PendingSalesinvoicedatas = $scope.PendingSalesinvoicedatas.concat(GList.data.data)
                        $scope.PendingSalesinvoicedatas = _.uniqWith($scope.PendingSalesinvoicedatas, _.isEqual);
                        $scope.workOrd = $scope.PendingSalesinvoicedatas
                        $scope.vm.PendingSchedulespinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid2 != "")
                $("#YTSContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.CollectedSalesinvoicedatas = []
            $scope.vm.YTSPreviewSpinner = true
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid", Skip: Skip, Limit: Limit, Department: "Lumiair" }
                    }).then(function (GList) {
                        if (dataGrid2 != "")
                            $("#YTSContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.CollectedSalesinvoicedatas = $scope.CollectedSalesinvoicedatas.concat(GList.data.data)
                        $scope.CollectedSalesinvoicedatas = _.uniqWith($scope.CollectedSalesinvoicedatas, _.isEqual);
                        $scope.vm.YTSPreviewSpinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        $scope.InvoiceFilterByDate = function () {
            if (dataGrid1 != "")
                $("#PendingContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.PendingSalesinvoicedatas = []
            $scope.vm.PendingSchedulespinner = true
            $scope.workOrd = []

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getByDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Unpaid", StartDate: $scope.uFrom, EndDate: $scope.uTo, Department: "Lumiair" }
            }).then(function (GList) {
                if (dataGrid1 != "")
                    $("#PendingContainer").dxDataGrid('instance').endCustomLoading()
                $scope.PendingSalesinvoicedatas = $scope.PendingSalesinvoicedatas.concat(GList.data.data)
                $scope.PendingSalesinvoicedatas = _.uniqWith($scope.PendingSalesinvoicedatas, _.isEqual);
                $scope.workOrd = $scope.PendingSalesinvoicedatas
                $scope.vm.PendingSchedulespinner = false

            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid2 != "")
                $("#YTSContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.CollectedSalesinvoicedatas = []
            $scope.vm.YTSPreviewSpinner = true
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getByDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "COD", Status: "Paid", StartDate: $scope.uFrom, EndDate: $scope.uTo, Department: "Lumiair" }
            }).then(function (GList) {
                if (dataGrid2 != "")
                    $("#YTSContainer").dxDataGrid('instance').endCustomLoading()
                $scope.CollectedSalesinvoicedatas = $scope.CollectedSalesinvoicedatas.concat(GList.data.data)
                $scope.CollectedSalesinvoicedatas = _.uniqWith($scope.CollectedSalesinvoicedatas, _.isEqual);
                $scope.vm.YTSPreviewSpinner = false
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        RefreshCustomer();
        $scope.InvoiceFilter()



        $scope.PushtoXero = function () {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/pushtoxero",
                method: "PUT",
                data: { InvoiceArray: $scope.SelectedIds, CreatedBy: $rootScope.createdby },
            });
            response.then(function (salesinvoicedata) {
                $mdToast.show($mdToast.simple().textContent('Successfully Exported to Xero!').position('top center'));

            })
        }

        $scope.PushCollected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to push the selected invoice to Collected ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/salesinvoice/tocollected",
                        method: "PUT",
                        data: { InvoiceID: $scope.SelectedIds },
                    });
                    response.then(function (GList) {
                        $scope.InvoiceFilter()
                        $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.PushUnCollected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to push the selected invoice to Un-Collected ?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/salesinvoice/toUncollected",
                        method: "PUT",
                        data: { InvoiceID: $scope.USelectedIds },
                    });
                    response.then(function (GList) {
                        $scope.InvoiceFilter()
                        $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));

                    });
                }
            });
        }

        $scope.ChangeDate = function (Type) {
            if (Type == 'less') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
                $scope.uTo = new Date($scope.uFrom);
            }
            if (Type == 'greater') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
                $scope.uTo = new Date($scope.uFrom);
            }
        }

        GetTotalCurrentYearInvoices();
        function GetTotalCurrentYearInvoices() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearInvoices = 0 }


            });
        }

        $scope.ShowClosed = function (con) {
            $scope.DefaultInvoice = con
            if ($scope.DefaultInvoice) {
                select = 'none'
                $scope.Salesinvoicedatas = undefined;
                var FromDate = $scope.uFrom;
                var ToDate = $scope.uTo;
                var response = $http({
                    url: $rootScope.WebURL + "/salesinvoice/getByXero",
                    method: "POST",
                    data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
                });
                response.then(function (salesinvoicedata) {

                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                });
            }
            else {
                select = 'always'
                $scope.InvoiceFilter()
            }
        }

        $scope.Invoiceadd = function (e) {
            ClearInvoice();

            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;

            var AR = "5" + new Date().getFullYear().toString().substr(-2);

            var info = $scope.TotalCurrentYearInvoices + 1;
            var y = pad(info, 6);
            $scope.InvoiceNumber = AR + y;

            var VR = "SV" + new Date().getFullYear().toString().substr(-2);

            $scope.VoucherNumber = VR + y;

            var item = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            if (item != undefined) {
                $scope.GSTID = item._id;
            }

            $scope.Date = new Date();
            $scope.VoucherDate = new Date();
            $scope.DueDate = new Date();

            $scope.Descriptiondatas = null;
            $scope.ServiceID = null;
            $scope.ServiceIDs = null;

        }

        $scope.ssubmit = function () {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/salesinvoice/newupdate',
                data: {
                    _id: $scope.InvoiceID,
                    DueDate: $scope.DueDate,
                    Amount: $scope.Amount,
                    Remarks: $scope.Remarks,
                    AmountReceived: $scope.AmountReceived
                }
            }).then(function (List) {
                RefreshInvoice();
                $scope.InvoiceGrid = true;
                $scope.InvoiceForm = false;
                $scope.InvoiceFormback = false;
                $scope.InvoiceSelect = true;
                $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
            })
        }

        $scope.ClearSearch = function () {

            $scope.searchTermc = null;
            $scope.CustomerID = null;
            $scope.vm.CustomerID = null;

        }


        $scope.SalesInvoiceInfo = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.PendingSalesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            RefreshPayment()
        }
        $scope.SalesInvoiceInfo2 = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.CollectedSalesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            RefreshPayment()
        }

        $scope.PDeletePopup = function (id, Amount) {
            $scope.PId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the payment?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/paymenthistory/delete",
                        method: "POST",
                        data: { _id: $scope.PId },
                    });
                    response.then(function (GList) {
                        PRefreshPayment()
                        RefreshPayment()
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                    var ReduceAmount = parseFloat($scope.AmountReceived) - parseFloat(Amount)
                    var Outstanding = parseFloat($scope.OutStandingAmount) + parseFloat(Amount)
                    $scope.TOutStandingAmount = Outstanding.toString()
                    var Status = "Unpaid"
                    if (Outstanding != $scope.Amount && ReduceAmount > 0)
                        Status = "Partially Paid"
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: ReduceAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.AmountReceived = ReduceAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $scope.InvoiceFilter()
                    })
                }
            });
        }


        RefreshBank();
        RefreshClientBank();

        $scope.SelectScheduler = function () {
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.ServiceID === $scope.ServiceID
            })[0]
            $scope.Description = moment(item.Startsat).format('DD MMMM YYYY') + " - " + item.PestType
        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshClientBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });
        }

        function RefreshInvoice() {
            $scope.InvoiceFilter()
            // var FromDate = $scope.uFrom;
            // var ToDate = $scope.uTo;
            // var response = $http({
            //     url:  $rootScope.WebURL + "/salesinvoice/datefilter",
            //     method: "POST",
            //     data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
            // });
            // response.then(function (salesinvoicedata) {

            //     $scope.Salesinvoicedatas = salesinvoicedata.data.data;

            // });
        }
        function ClearInvoice() {
            $scope.CustomerID = null; $scope.WorkOrderID = null; $scope.Date = null; $scope.VoucherNumber = null;
            $scope.Amount = null; $scope.ServiceIDs = null; $scope.GSTID = null; $scope.Description = null;
            $scope.VoucherDate = null; $scope.CreditTerm = null; $scope.Remarks = null;
            $scope.ContractID = null; $scope.ConID = null;
        }
        $scope.updateCustomRequest = function (data, type, res) {

        };

        $scope.OnTopInvoiceContractChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ContractID;
            })[0];

            $scope.ConID = $scope.ContractID;
            $scope.CustomerID = item.Customer_id;
            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.OnConChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ConID;
            })[0];

            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.IsAmountLoaded = false;


        GetTotalCurrentYearPayments();
        function GetTotalCurrentYearPayments() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearPayments = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearPayments = 0 }


            });
        }


        $scope.CollectPaymentadd = function (e) {

            $scope.InvoicefilterByCustomer();
            $scope.IsAmountLoaded = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            ClearCollectPayment();
            $scope.Update = false;

            $scope.vm.uTo = $scope.uTo;
            $scope.vm.uFrom = $scope.uFrom;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

            var itemB = $scope.Bankdatas.filter(function (item) {
                return item.BankName === "OCBC";
            })[0];

            $scope.vm.BankID = itemB._id;

            $scope.vm.Date = new Date();
            $scope.vm.VoucherDate = new Date();

            var info = $scope.TotalCurrentYearPayments + 1;
            var y = pad(info, 6);
            var VR = "CP" + new Date().getFullYear().toString().substr(-2);
            $scope.vm.VoucherNumber = VR + y;

            $scope.CPItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


        }

        $scope.SaveCollectPayment = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/collectpayment/update",
                    data: {
                        _id: $scope.CollectPaymentID, CustomerID: $scope.vm.CustomerID,
                        Description: $scope.vm.Description, Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID, ClientBankName: $scope.vm.ClientBankName, ChequeDate: $scope.vm.ChequeDate,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.CollectPaymentdatas[$scope.CollectPaymentIndex] = GList.data.data[0];

                    RefreshInvoice();
                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {




                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                        Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                    },
                });


                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    GetTotalCurrentYearPayments()
                    RefreshCollectPayment();
                    RefreshCustomerstatement();
                    RefreshInvoice();

                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }


        $scope.CollectPaymentinfo = function (CollectPaymentID, Index) {

            $scope.CollectPaymentIndex = Index;
            $scope.Salesinvoicedatasdd = $scope.Salesinvoicedatas;

            $scope.CollectPaymentID = CollectPaymentID;
            $scope.Update = true;

            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;

            var item = $scope.CollectPaymentdatas.filter(function (item) {
                return item._id === CollectPaymentID;
            })[0];

            $scope.vm.CustomerID = item.CustomerID;
            $scope.vm.BankID = item.BankID;
            $scope.vm.VoucherNumber = item.VoucherNumber;
            $scope.vm.VoucherDate = new Date(item.VoucherDate);
            $scope.vm.ChequeNumber = item.ChequeNumber;
            $scope.vm.ChequeDate = new Date(item.ChequeDate);
            $scope.vm.Description = item.Description;
            $scope.vm.Date = new Date(item.Date);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.ClientBankName = item.ClientBankName;

            $scope.CPItemDetails = item.itemDetails;

            $scope.IsAmountLoaded = true;

            $scope.HideAdd = true;
            $scope.HideSave = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

        }

        $scope.CPItemSubmit = function () {


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/collectpayment/add",
                data: {
                    CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                    Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                    VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Collectpayment") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/collectpayment/getByID",
                        data: {
                            VoucherNumber: $scope.vm.VoucherNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CollectPaymentID = GList.data.data[0]._id;
                        SaveCPItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CollectPaymentID = GList.data.data.id;
                    SaveCPItems(GList.data.data.id);
                    GetTotalCurrentYearPayments()
                }

            }, function () {


            });

        }


        $scope.CPItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }

            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/UpdateItem",
                data: {
                    CollectPaymentID: $scope.CollectPaymentID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    PaidAmount: $scope.PaidAmount,
                    InvoiceAmount: parseFloat(InvoiceAmount),
                    OutStandingAmount: OutStandingAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CPItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCPItems(CollectPaymentID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }


            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "PaidAmount": $scope.PaidAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceAmount": parseFloat(InvoiceAmount),
                "OutStandingAmount": OutStandingAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "_id": undefined
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/addItems",
                data: {
                    _id: CollectPaymentID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    InvoiceNumber: InvoiceNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Date: $scope.vm.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CPItemDetails != undefined) {
                    $scope.CPItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/getByID",
                    data: {
                        VoucherNumber: $scope.vm.VoucherNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CPItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CPItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CPItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.ServiceSelect = function () {
            RefreshScheduler()
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }

        $scope.CollectPaymentFilter = function () {
            $scope.CollectPaymentdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }
        function ClearCollectPayment() {

            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.Date = null;
            $scope.vm.ChequeDate = null;
            $scope.vm.Amount = null;
            $scope.vm.InvoiceID = null;
            $scope.vm.Description = null;
            $scope.vm.Remarks = null;
            $scope.vm.ChequeNumber = null;
            $scope.vm.VoucherNumber = null;
            $scope.vm.ClientBankName = null;
        }


        GetTotalCurrentYearCreditnotes();

        function GetTotalCurrentYearCreditnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearCreditnotes = 0
                }


            });
        }

        $scope.Creditnoteadd = function (e) {
            ClearCreditnote();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;
            $scope.Update = false;
            $scope.IsAmountLoaded = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;

            $scope.CreditNote.$setPristine();
            $scope.CreditNote.$setUntouched();

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearCreditnotes + 1;
            var y = pad(info, 6);
            var VR = "CNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "CNS" + new Date().getFullYear().toString().substr(-2);
            $scope.CreditNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }
        function ClearCreditnote() {

            $scope.RefrenceNumber = null
            $scope.InvoiceID = null;
            $scope.AccountID = null
            $scope.Description = null
            $scope.Amount = null
            $scope.GSTID = null
            $scope.Remarks = null;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveCreditnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salescreditnote/update",
                    data: {
                        _id: $scope.CreditnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshInvoice();
                    RefreshCustomerstatement();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearCreditnotes();
                    RefreshCreditnote();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Creditnoteinfo = function (CreditnoteID, index) {


            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;

            $scope.CreditnoteID = CreditnoteID;
            $scope.Update = true;

            var item = $scope.Creditnotedatas.filter(function (item) {
                return item._id === CreditnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)

            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.CreditNoteNumber = item.CreditNoteNumber
            $scope.CNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }


        $scope.ClearCNItems = function () {
            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        $scope.CNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salescreditnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales credit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salescreditnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveCNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveCNItems(GList.data.data.id);
                    GetTotalCurrentYearCreditnotes();
                }

            }, function () {


            });

        }


        $scope.CNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/UpdateItem",
                data: {
                    CreditnoteID: $scope.CreditnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CNItemDetails != undefined) {
                    $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }

        function RefreshCreditnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });


        }

        $scope.CreditnoteFilter = function () {
            $scope.Creditnotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });
        }

        $scope.CreditnoteShowgrid = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridCollectPayment = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;


        }
        function ClearCreditnote() {
            $scope.RefrenceNumber = null;
            $scope.VoucherDate = null;
            $scope.InvoiceID = null;
            $scope.Date = null;
            $scope.AccountID = null;
            $scope.Description = null;
            $scope.Amount = null;
            $scope.GSTID = null;
            $scope.Remarks = null;
        }

        RefreshGST();
        RefreshChartofAccount();

        RefreshContract();


        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {

                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }
        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getBySalesOrder",
                data: {
                    SalesOrderId: $scope.WorkOrderID,
                },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getforinvoice",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getByCustomer",
                data: {
                    CustomerId: $scope.CustomerID
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshDescription() {

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
                // DeleteDescription();
            });
        }
        function DeleteDescription() {

            try {
                $scope.ServiceIDs = $scope.ServiceID.map(function (obj) { return obj.ServiceID; }).join(',');
            } catch (error) {

            }

            angular.forEach($scope.Descriptiondatas, function (value, key) {

                if (aContainsB($scope.ServiceIDs.trim(), value.ServiceReportNo.trim())) {

                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: value._id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                    });
                }

            });
        }
        $scope.DeletePopup = function (ID) {
            $scope.Id = ID
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the description?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: $scope.Id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }


        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }

        $scope.EnableDescription = function (DescID, ServiceReportNo) {
            $scope.Desc = false;
            $scope.textbar = true;
            $scope.ServiceReportNo = ServiceReportNo;
            $scope.DescID = DescID;

            var item = $scope.Descriptiondatas.filter(function (item) {
                return item._id === DescID;
            })[0];

            if (item != undefined) {
                $scope.Description = item.Description
                $scope.ServiceID = $scope.ServiceReportNo
            }

        }
        $scope.DescriptionSubmit = function () {
            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/update",
                method: "PUT",
                data: { _id: $scope.DescID, ServiceReportNo: $scope.ServiceID, Description: $scope.Description },
            });
            response.then(function (GList) {
                RefreshDescription();
                $scope.Description = null;
                $scope.Desc = true;
            });
        }

        $scope.AddPayment = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function LcashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Date = new Date()
            $scope.vm.Amount = 0
        }
        $scope.UpdatePay = false
        $scope.EditPop = function (e, data) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function LcashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.UpdatePay = true
            $scope.UpdateID = data._id;
            $scope.vm.Remarks = data.Remarks;
            $scope.vm.Date = data.Date;
            $scope.vm.Amount = parseFloat(data.Amount)
            $scope.AmountReceived = $scope.AmountReceived - parseFloat(data.Amount)
        }

        $scope.SubmitPayment = function () {
            var TotalAmount = parseFloat($scope.vm.Amount) + parseFloat($scope.AmountReceived)
            if (TotalAmount > $scope.Amount)
                $mdToast.show($mdToast.simple().textContent('Amount Paid is greater than Invoice Amount!').position('top center'));
            else {

                var Outstanding = parseFloat($scope.Amount) - TotalAmount
                $scope.TOutStandingAmount = Outstanding.toString()
                var Status = "Unpaid"
                if (Outstanding != $scope.Amount && TotalAmount > 0)
                    Status = "Partially Paid"
                if ($scope.UpdatePay == false) {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + '/paymenthistory/add',
                        data: {
                            InvoiceID: $scope.InvoiceID,
                            Amount: $scope.vm.Amount,
                            Date: $scope.vm.Date,
                            Remarks: $scope.vm.Remarks,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (List) {
                        $http({
                            method: "PUT",
                            url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                            data: {
                                _id: $scope.InvoiceID,
                                AmountReceived: TotalAmount,
                                OutStandingAmount: Outstanding,
                                Status: Status,
                                CreatedBy: $rootScope.createdby
                            }
                        }).then(function (GList) {
                            $scope.InvoiceFilter()
                            $scope.AmountReceived = TotalAmount
                            $scope.OutStandingAmount = Outstanding
                            $scope.Status = Status
                            $scope.UpdatePay = false
                            $mdDialog.cancel()
                            PRefreshPayment()
                            RefreshPayment()
                            $mdToast.show($mdToast.simple().textContent('Payment Added Successfully!').position('top center'));

                        })
                    })
                }
                else {
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/paymenthistory/update',
                        data: {
                            _id: $scope.UpdateID,
                            InvoiceID: $scope.InvoiceID,
                            Amount: $scope.vm.Amount,
                            Date: $scope.vm.Date,
                            Remarks: $scope.vm.Remarks,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (List) {
                        $http({
                            method: "PUT",
                            url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                            data: {
                                _id: $scope.InvoiceID,
                                AmountReceived: TotalAmount,
                                OutStandingAmount: Outstanding,
                                Status: Status,
                                CreatedBy: $rootScope.createdby
                            }
                        }).then(function (GList) {
                            $scope.InvoiceFilter()
                            PRefreshPayment()
                            RefreshPayment()
                            $scope.AmountReceived = TotalAmount
                            $scope.OutStandingAmount = Outstanding
                            $scope.UpdatePay = false
                            $scope.Status = Status
                            $mdDialog.cancel()
                            $mdToast.show($mdToast.simple().textContent('Payment Updated Successfully!').position('top center'));

                        })
                    })
                }
            }

        }

        function RefreshPayment() {
            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: $scope.InvoiceID },
            });
            response1.then(function (GList) {
                var data = GList.data.data;
                $scope.CollectedAmt = 0
                angular.forEach(data, function (item) {
                    item.Date = new Date(item.Date)
                    $scope.CollectedAmt = $scope.CollectedAmt + parseFloat(item.Amount)
                })
                $scope.Paymentdatas = data;
            })
        }

        function PRefreshPayment() {
            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: $scope.InvoiceID },
            });
            response1.then(function (GList) {
                var data = GList.data.data;
                var CollectedAmt = 0
                angular.forEach(data, function (item) {
                    CollectedAmt = CollectedAmt + parseFloat(item.Amount)
                })

                var OutStandingAmount = 0
                OutStandingAmount = parseFloat($scope.Amount) - parseFloat(CollectedAmt)

                $http({
                    method: 'PUT',
                    url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                    data: {
                        _id: $scope.InvoiceID,
                        AmountReceived: CollectedAmt,
                        OutStandingAmount: OutStandingAmount,
                        Status: "Partially Paid",
                        UpdatedBy: $rootScope.createdby,

                    }
                }).then(function (List) {
                    RefreshInvoice();
                    $scope.TOutStandingAmount = OutStandingAmount
                })

            })
        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        $scope.OnWorkOrderChange = function () {

            var myArray = $scope.ServiceID;

            if (myArray == undefined) {
                $scope.ServiceIDs = "null";
                RefreshDescription();
            }


            var BillingAmount = 0;
            angular.forEach(myArray, function (value, key) {

                var Description = "Being Inspection and Treatment carried out for the control of";

                try {
                    Description = "Being Inspection and Treatment carried out for the control of " + monthNames[new Date(value.Startsat).getMonth()] + " " + new Date(value.Startsat).getFullYear()

                } catch (error) {

                }

                if (value.BillingAmount != undefined) {
                    BillingAmount = BillingAmount + parseFloat(value.BillingAmount);

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: value.BillingAmount },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: 0 },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }

            });





            $scope.Amount = BillingAmount;




            // var myArray = $scope.ServiceID;

            // var item = myArray.filter(function (item) {
            //     return item._id === $scope.WorkOrderID;
            // })[0];

            // var TotalOrderValue = item.TotalOrderValue;
            // var TotalServices = $scope.ServiceID;
            // $scope.Amount = Math.round(TotalOrderValue / (TotalServices.length), 2);

        }
        $scope.OnInvoiceChange = function () {



            if ($scope.IsAmountLoaded == false) {

                var InvoiceID = $scope.vm.InvoiceID;
                var TotalAmount = 0;
                angular.forEach(InvoiceID, function (value, key) {

                    TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);


                    // var item = $scope.GSTdatas.filter(function (item) {
                    //     return item.id === value.GSTID;
                    // })[0]; 

                    // if(item!=undefined){

                    //     if (value.Status == "Partial") { 

                    //         var Amt=TotalAmount + parseFloat(value.OutStandingAmount); 

                    //         TotalAmount=Amt + (parseFloat((Amt / 100) * parseFloat(item.TaxRate))); 
                    //     }
                    //     else { 
                    //        // TotalAmount = TotalAmount + parseFloat(value.Amount);
                    //         TotalAmount = parseFloat(TotalAmount) + parseFloat(value.Amount) + (parseFloat((value.Amount / 100) * parseFloat(item.TaxRate)));
                    //     }  

                    // }
                    //else{
                    // if (value.Status == "Partial") {
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount); 
                    // }
                    // else { 
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);
                    // } 
                    // }

                });
                $scope.vm.Amount = TotalAmount;
            }

        }

        $scope.OnCNInvoiceChange = function () {


            // if($scope.IsAmountLoaded == false) {
            // var InvoiceID = $scope.InvoiceID;
            // var TotalAmount = 0;
            // angular.forEach(InvoiceID, function (value, key) {

            //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);

            // }); 
            // $scope.Amount = TotalAmount;
            //  }
        }
        $scope.OnCustomerChange = function () {

            var myArray = $scope.Customerdatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.CustomerID;
            })[0];

            if (item.CreditTerm != undefined) {

                $scope.CreditTerm = parseInt(item.CreditTerm);
            }
            else {
                $scope.CreditTerm = 0;
            }

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }


            RefreshSalesOrder()
        }

        $scope.OnVoucherDateChange = function () {
            $scope.Date = $scope.VoucherDate;
            if ($scope.CreditTerm != null || $scope.CreditTerm != undefined) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
            else {
                $scope.DueDate = $scope.VoucherDate;
            }
        }

        $scope.OnInvoiceDateChange = function () {
            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCreditTermChange = function () {

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCSStatusChange = function () {

            if ($scope.CSStatus == 'ShowAll') {

                $scope.Customerstatementdatas = $scope.Customerstatementalldatas;
            } else {

                if ($scope.Customerstatementalldatas != undefined) {
                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === $scope.CSStatus;
                    });
                    $scope.Customerstatementdatas = item;
                }

            }
        }



        function RefreshCustomerstatement() {
            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.RefreshCustomers = function () {
            $scope.Customerstatementdatas = undefined;

            if ($scope.FilterByCustomer == true) {

                if ($scope.CusID == undefined) {

                    $mdToast.show($mdToast.simple().textContent('Please Select Customer & Click Search!').position('top center'));

                    $scope.Customerstatementdatas = [];
                }
                else {
                    var response = $http({
                        url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                        method: "POST",
                        data: { CustomerID: $scope.CusID },
                    });
                    response.then(function (Customerstatementdata) {
                        $scope.Customerstatementdatas = Customerstatementdata.data.data;
                        $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                        var item = $scope.Customerstatementalldatas.filter(function (item) {
                            return item.Status === 'Unpaid';
                        });
                        $scope.Customerstatementdatas = item;
                    });
                }
            }
            else {
                var response = $http({
                    url: $rootScope.WebURL + "/customerstatement/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
                });
                response.then(function (Customerstatementdata) {
                    $scope.Customerstatementdatas = Customerstatementdata.data.data;
                    $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === 'Unpaid';
                    });
                    $scope.Customerstatementdatas = item;
                });
            }

        }

        $scope.Filter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                method: "POST",
                data: { CustomerID: $scope.CusID },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        GetTotalCurrentYearDebitnotes();

        function GetTotalCurrentYearDebitnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearDebitnotes = 0
                }


            });
        }

        $scope.Debitnoteadd = function (e) {

            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;

            $scope.DebitnoteSelect = false;

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearDebitnotes + 1;
            var y = pad(info, 6);
            var VR = "DNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "DNS" + new Date().getFullYear().toString().substr(-2);
            $scope.DebitNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;
            $scope.Update = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.Description = undefined;
            $scope.Remarks = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        $scope.SaveDebitnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salesdebitnote/update",
                    data: {
                        _id: $scope.DebitnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshDebitnote();

                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearDebitnotes();
                    RefreshDebitnote();
                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Debitnoteinfo = function (DebitnoteID, index) {

            $scope.DebitnoteID = DebitnoteID;
            $scope.Update = true;
            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.DebitnoteSelect = false;
            $scope.DebitnoteID = DebitnoteID;

            var item = $scope.Debitnotedatas.filter(function (item) {
                return item._id === DebitnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)


            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.DebitNoteNumber = item.DebitNoteNumber
            $scope.DNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        function RefreshDebitnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }

        $scope.DebitnoteFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }


        $scope.DNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesdebitnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales debit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesdebitnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveDNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveDNItems(GList.data.data.id);
                    GetTotalCurrentYearDebitnotes();
                }

            }, function () {


            });

        }


        $scope.DNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/UpdateItem",
                data: {
                    DebitnoteID: $scope.DebitnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.DNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveDNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.DNItemDetails != undefined) {
                    $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.DNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.DNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.DNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.Showgrid = function () {
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceGrid = true;
            $scope.InvoiceForm = false;
            $scope.InvoiceSelect = true;
            $scope.InvoiceFormback = false;

            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridDebit = function () {

            $scope.DebitnoteSelect = true;
            $scope.DebitnoteGrid = true;
            $scope.DebitnoteForm = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.InvoicefilterByCustomer = function () {


            $scope.vm.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.vm.uFrom;
            var ToDate = $scope.vm.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });

            response.then(function (salesinvoicedata) {

                var myArray = salesinvoicedata.data.data;

                var item = myArray.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                $scope.Salesinvoicedatasdd = item;
            });
        };

        $scope.InvoicefilterByCustomerform = function () {


            $scope.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });
            response.then(function (salesinvoicedata) {
                $scope.Salesinvoicedatasddf = salesinvoicedata.data.data;

                var item = $scope.Salesinvoicedatasddf.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                var item2 = item.filter(function (item) {
                    return item.Status !== "Adjust" && parseFloat(item.OutStandingAmount) > 0;
                });
                $scope.Salesinvoicedatasddf = item2;
            });


        };

        $scope.InvoiceExport = function () {
            alasql('SELECT * INTO XLSX("Invoice.xlsx",{headers:true}) FROM ?', [$scope.Salesinvoicedatas]);
        };
        $scope.CollectPaymentExport = function () {
            alasql('SELECT * INTO XLSX("CollectPayment.xlsx",{headers:true}) FROM ?', [$scope.CollectPaymentdatas]);
        };
        $scope.CreditnoteExport = function () {
            alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
        };
        $scope.DebitnoteExport = function () {
            alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
        };
        $scope.CustomerStatementExport = function () {
            alasql('SELECT * INTO XLSX("CustomerStatement.xlsx",{headers:true}) FROM ?', [$scope.Customerstatementdatas]);
        };


        $scope.Printsalesinvoice = function (CreditnoteID) {
            var url = $rootScope.ReportURL + "SalesInvoice.aspx?ID=" + CreditnoteID;
            window.open(url);
        }


        $scope.getTotal = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.Amount);
                });

                return total.toFixed(2);
            } else {
                0
            }
        }
        $scope.getAccountCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var AccountCode = itemDetails.map(function (obj) {
                    return obj.AccountCode;
                }).join(',');
                return AccountCode;
            } else {
                return null;
            }
        }

        $scope.getGSTCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var GSTCode = itemDetails.map(function (obj) {
                    return obj.GSTCode;
                }).join(',');
                return GSTCode;
            } else {
                return null;
            }
        }
        $scope.getInvoiceNumber = function (itemDetails) {

            if (itemDetails != undefined) {
                var InvoiceNumber = itemDetails.map(function (obj) {
                    return obj.InvoiceNumber;
                }).join(',');
                return InvoiceNumber;
            } else {
                return null;
            }
        }


        $scope.getTotalInvoiceAmount = function (itemDetails) {

            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.InvoiceAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }
        $scope.getTotalOutStandingAmount = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.OutStandingAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }



        vm.dtOptions = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            bProcessing: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        vm.dtOptions1 = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.InvoiceTab = function () {
            $scope.InvoiceSelect = true;
            $scope.InvoiceGrid = true;

            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };

        $scope.CollectPaymentTab = function () {
            RefreshCollectPayment();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.CreditnoteTab = function () {
            RefreshCreditnote();
            $scope.InvoiceSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.InvoiceForm = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.DebitnoteTab = function () {
            RefreshDebitnote();
            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = true;
            $scope.CollectPaymentSelect = false;
            $scope.InvoiceForm = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteGrid = true;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.SearchValue = "";
        };
        $scope.CustomerStatementTab = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });


            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = true;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceForm = false;

            $scope.CollectPaymentFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.SearchValue = "";
        };

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $scope.Today = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            $scope.uFrom = new Date();
            $scope.uTo = new Date();
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();

        }
        $scope.lastweek = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = new Date(from);
            $scope.uTo = new Date(to);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        $scope.lastmonth = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = new Date(lastMonthStartDate);
            $scope.uTo = new Date(lastMonthEndDate);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        var now = new Date();
        $scope.minDate = new Date(
            now.getFullYear() - 5,
            now.getMonth(),
            now.getDate()
        );


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'D.M.YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }


})();
(function () {
    'use strict';

    angular
        .module('app.pages.administration', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider

            .state('app.pages_administration_certification', {
                url: '/certification',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/administration/certification/certification.html',
                        controller: 'certificationController as vm'
                    }
                },
                resolve: {
                    Invoice: function (msApi) {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })

               .state('app.pages_administration_evaluation', {
                   url: '/evaluation',
                   views: {
                       'content@app': {
                           templateUrl: 'app/main/pages/administration/evaluation/evaluation.html',
                           controller: 'evaluationController as vm'
                       }
                   },
                   resolve: {
                       Invoice: function (msApi) {
                           return msApi.resolve('invoice@get');
                       }
                   },
                   bodyClass: 'invoice printable'
               })

                .state('app.pages_administration_monitoring', {
                    url: '/monitoring',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/pages/administration/monitoring/monitoring.html',
                            controller: 'monitoringController as vm'
                        }
                    },
                    resolve: {
                        Invoice: function (msApi) {
                            return msApi.resolve('invoice@get');
                        }
                    },
                    bodyClass: 'invoice printable'
                })

         

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/administration');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages.administration.certification', {
            state: 'app.pages_administration_certification'
        });

        msNavigationServiceProvider.saveItem('pages.administration.evaluation', {
            state: 'app.pages_administration_evaluation'
        });


        msNavigationServiceProvider.saveItem('pages.administration.monitoring', {
            state: 'app.pages_administration_monitoring'
        });
        }

        else {
            return
        }
      
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.administration')
        .controller('monitoringController', monitoringController);

    /** @ngInject */
    function monitoringController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {

        $scope.printToCart = function (monitoring) {
            var printButton = document.getElementById("printpagebutton");
            printButton.style.visibility = 'hidden';
            window.focus(monitoring);
            window.print(monitoring);
            printButton.style.visibility = 'visible';
        };

        $scope.td1 = function () {
            document.getElementById("td1").style.backgroundColor = "#ccc";
        }
        $scope.td2= function () {
            document.getElementById("td2").style.backgroundColor = "#ccc";
        }
        $scope.td3 = function () {
            document.getElementById("td3").style.backgroundColor = "#ccc";
        }
        $scope.td4 = function () {
            document.getElementById("td4").style.backgroundColor = "#ccc";
        }
        $scope.td5 = function () {
            document.getElementById("td5").style.backgroundColor = "#ccc";
        }
        $scope.td6 = function () {
            document.getElementById("td6").style.backgroundColor = "#ccc";
        }
        $scope.td7 = function () {
            document.getElementById("td7").style.backgroundColor = "#ccc";
        }
        $scope.td8 = function () {
            document.getElementById("td8").style.backgroundColor = "#ccc";
        }
        $scope.td9 = function () {
            document.getElementById("td9").style.backgroundColor = "#ccc";
        }
        $scope.td10 = function () {
            document.getElementById("td10").style.backgroundColor = "#ccc";
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.administration')
        .controller('evaluationController', evaluationController);

    /** @ngInject */
    function evaluationController($mdDateLocale, $scope, $rootScope, $mdDialog, $document, $interval, $mdToast, $window, $mdSidenav, $state, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var AId = localStorage.getItem('idForEvaluation');
        $scope.CP_id = AId;
        $scope.Update = false;
        function init() {
            angular.forEach($scope.Enrollmentsdatas, function (value) {
                if ($scope.CP_id == value.id) {
                    $scope.Name = value.EmployeeName;
                    var Training = value.Fees;
                    if (Training == 'Yes') { $scope.TypeofTraining = 'Inhouse Training' }
                    if (Training == 'No') { $scope.TypeofTraining = 'External' }
                    $scope.From = new Date(value.CompanySponsored);
                    $scope.To = new Date(value.Remarks);
                }
            })
            angular.forEach($scope.RealEnrollmentsdatas, function (rvalue) {
                if ($scope.CP_id == rvalue.id) {
                    $scope.vm.EnrolmentID = rvalue.EnrolmentID;
                    $scope.vm.ECourseName = rvalue.CourseName;
                    $scope.vm.EBatchName = rvalue.BatchName;
                    $scope.vm.EEmployeeName = rvalue.EmployeeName;
                    $scope.vm.CompanySponsored = rvalue.CompanySponsored;
                    $scope.vm.EFees = rvalue.Fees;
                    $scope.vm.Status = rvalue.Status;
                    $scope.vm.ERemarks = rvalue.Remarks;
                }
            })
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/courseevaluation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (courseevaluation) {
                $scope.Courseevaluationdatas = courseevaluation.data.data;
                if ($scope.vm.Status == 'Completed') {
                    try {
                        var myArray = $scope.Courseevaluationdatas;
                        var item = myArray.filter(function (item) {
                            return item.CP_id === $scope.CP_id;
                        })[0];
                        $scope.SID = item.id;
                        $scope.CP_id = item.CP_id;
                        $scope.Name = item.Name;
                        $scope.TE1 = item.TE1;
                        $scope.TE2 = item.TE2;
                        $scope.TE4 = item.TE4;
                        $scope.TE5 = item.TE5;
                        $scope.TE6 = item.TE6;
                        $scope.TE7 = item.TE7;
                        $scope.TE8 = item.TE8;
                        $scope.TE3 = item.TE3;
                        $scope.TE9 = item.TE9;
                        $scope.TE10 = item.TE10;
                        $scope.Status = item.Status;
                        $scope.CStatus = item.CStatus;
                        $scope.Update = true
                    }
                    catch (e) { }
                    debugger
                    var myArray1 = $scope.Employeedatas.filter(function (myArray1) {
                        return myArray1.EmployeeName == $scope.Name;
                    })[0];
                    $scope.EmployeeID = myArray1.EmployeeID;
                }
            });
        }
        $scope.Save = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/courseevaluation/update",
                    data: {
                        _id: $scope.SID,
                        CP_id: $scope.CP_id,
                        Name: $scope.Name,
                        TE1: $scope.TE1,
                        TE2: $scope.TE2,
                        TE4: $scope.TE4,
                        TE5: $scope.TE5,
                        TE6: $scope.TE6,
                        TE7: $scope.TE7,
                        TE8: $scope.TE8,
                        TE3: $scope.TE3,
                        TE9: $scope.TE9,
                        TE10: $scope.TE10,
                        From: $scope.From,
                        To: $scope.To,
                        Type: $scope.TypeofTraining,
                        Status: 'Completed',
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $window.localStorage.setItem('idForEvaluation', "");
                    $state.go('app.human-resource_training_administration');
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/courseevaluation/add",
                    data: {
                        CP_id: $scope.CP_id,
                        Name: $scope.Name,
                        TE1: $scope.TE1,
                        TE2: $scope.TE2,
                        TE4: $scope.TE4,
                        TE5: $scope.TE5,
                        TE6: $scope.TE6,
                        TE7: $scope.TE7,
                        TE8: $scope.TE8,
                        TE3: $scope.TE3,
                        TE9: $scope.TE9,
                        TE10: $scope.TE10,
                        From: $scope.From,
                        To: $scope.To,
                        Type: $scope.TypeofTraining,
                        Status: 'Completed',
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/enrollments/update",
                        data: {
                            _id: $scope.CP_id,
                            EnrolmentID: $scope.vm.EnrolmentID,
                            CourseName: $scope.vm.ECourseName,
                            BatchName: $scope.vm.EBatchName,
                            EmployeeName: $scope.vm.EEmployeeName,
                            CompanySponsored: $scope.vm.CompanySponsored,
                            Fees: $scope.vm.EFees,
                            Remarks: $scope.vm.ERemarks,
                            Status: 'Completed',
                            CStatus: $scope.CStatus,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {
                    })
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $window.localStorage.setItem('idForEvaluation', "");
                    $state.go('app.human-resource_training_administration');
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Back = function () {
            $window.localStorage.setItem('idForEvaluation', "");
            $state.go('app.human-resource_training_administration');
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursescheduling",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseschedulingdata) {
            $scope.Courseschedulingdatas = courseschedulingdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (RealEnrollmentsdata) {
            $scope.RealEnrollmentsdatas = RealEnrollmentsdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/courseevaluation",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseevaluation) {
            $scope.Courseevaluationdatas = courseevaluation.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            angular.forEach($scope.Enrollmentsdatas, function (evalue) {
                angular.forEach($scope.Courseschedulingdatas, function (cvalue) {
                    if (evalue.CourseName == cvalue.CourseName) {
                        evalue.CompanySponsored = cvalue.StartDate;
                        evalue.Fees = cvalue.InhouseTraining;
                        evalue.Remarks = cvalue.EndDate;
                    }
                })
            })
            init();
        });

        $scope.printToCart = function (printe) {
            window.open($rootScope.ReportURL + 'Evaluation.aspx' + '?' + 'ID=' + $scope.SID + '~' + $scope.EmployeeID, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');

            //    var printButton = document.getElementById("printpagebutton");
            //    var printButton1 = document.getElementById("printpagebutton1");
            //    var printButton2 = document.getElementById("printpagebutton2");
            //    var printButton3 = document.getElementById("printpagebutton3");
            //    var printButton4 = document.getElementById("printpagebutton4");
            //    printButton.style.visibility = 'hidden';
            //    printButton1.style.visibility = 'hidden';
            //    printButton2.style.visibility = 'hidden';
            //    printButton3.style.visibility = 'hidden';
            //    printButton4.style.visibility = 'hidden';
            //window.focus(printe);
            //window.print(printe);
            //printButton.style.visibility = 'visible';
            //printButton1.style.visibility = 'visible';
            //printButton2.style.visibility = 'visible';
            //printButton3.style.visibility = 'visible';
            //printButton4.style.visibility = 'visible';
        };
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation  
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }
else{
           return 
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($scope, $window, $rootScope, $interval, $mdToast, $mdSidenav, $http) {
        $scope.ResetPassword = function () {
            if ($scope.uLoginID == '') {
                $scope.Error6 = true;
            }
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var ii = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(ii);
            }
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/login/resetPassword",
                data: {
                    UserID: $scope.uLoginID, rNewPassword: pass,
                },
            });
            response.then(function (GList) {
                if (GList.data.message == "Invalid UserID") {
                    $scope.Error7 = false;
                    $scope.Error6 = true;
                }
                $scope.Userdata = GList.data.data
                if ($scope.Userdata.UserName != null) {

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/user/email",
                        data: {
                            SenderEmailAddress: $scope.Userdata.Email, UserName: $scope.Userdata.UserName,
                            UserID: $scope.uLoginID,
                            Password: pass,
                        },
                    });
                    $scope.Error6 = false;
                    $scope.Error7 = true;
                    return;
                }
                else {

                    $scope.Error7 = false;
                    $scope.Error6 = true;
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config)

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
            msNavigationServiceProvider.saveItem('pages.auth', {
                title: 'Authentication',
                icon: 'icon-lock',
                weight: 1
            });

            msNavigationServiceProvider.saveItem('pages.auth.login', {
                title: 'Login',
                state: 'app.pages_auth_login',
                weight: 1
            });
    }

else{
           return 
    }
}
})();
(function () {
  "use strict";

  angular
    .module("app.pages.auth.login")
    .controller("LoginController", LoginController);
  /** @ngInject */
  function LoginController(
    $scope,
    $window,
    $rootScope,
    $interval,
    $mdToast,
    $mdSidenav,
    $http,
    $location,
    $state,
    socket,
    $log,
    indexedDBService
  ) {
    document.getElementsByTagName("title")[0].text = "Scheduler X-Login";

    $scope.forgotpassword = false;
    $scope.loginform = true;
    $scope.Error1 = false;
    $scope.Error2 = false;
    $scope.Error3 = false;
    $scope.Error4 = false;
    $scope.Error5 = false;
    sessionStorage.setItem("IsAuthenticated", "false");

    $window.localStorage.setItem("DefaultLanguage", "English");
    $scope.login = function () {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/login/",
        data: {
          UserID: $scope.uLoginID,
          Password: $scope.uPassword
        }
      }).then(
        function (response) {
          var data = response.data;
          $scope.Userdata = data.data;

          // Handle error messages
          if (data.message === "Password Not Matched") {
            $scope.Error1 = false;
            $scope.Error2 = true;
            return;
          } else if (data.message === "UserID Not Found") {
            $scope.Error1 = true;
            return;
          } else if (data.message === "Locked") {
            $scope.Error1 = false;
            $scope.Error2 = false;
            $scope.Error3 = true;
            return;
          } else if (data.message === "NotActive") {
            $scope.Error1 = false;
            $scope.Error2 = false;
            $scope.Error3 = false;
            $scope.Error4 = true;
            return;
          } else if (data.message == "Expired") {
            $scope.Error1 = false;
            $scope.Error2 = false;
            $scope.Error3 = false;
            $scope.Error4 = false;
            $scope.Error5 = true;
            return;
          }

          if ($scope.Userdata.UserName != null) {
            // Clear all error flags
            $scope.Error1 = false;
            $scope.Error2 = false;
            $scope.Error3 = false;
            $scope.Error4 = false;
            $scope.Error5 = false;
            $scope.SID = $scope.Userdata.id;
            $log.log($scope.Userdata);
            $window.localStorage.setItem("access_token", $scope.Userdata.token);
            indexedDBService.clearAllStores().then(function () {
              console.log("All local IndexedDB stores cleared.");
              // proceed with your data fetch or page redirection
            });

            get_other_data()
              .then(function () {
                // Process page access
                var pageaccess = [];
                angular.forEach($scope.Pagedatas, function (value) {
                  if ($scope.SID == value.UserID) {
                    pageaccess.push(value.PageName);
                  }
                });
                var Roleaccess = [];
                angular.forEach($scope.Userroledatas, function (urvalue) {
                  angular.forEach($scope.Roledatas, function (rvalue) {
                    if (
                      $scope.SID == urvalue.UserID &&
                      urvalue.RoleID == rvalue.RoleID
                    ) {
                      if (Roleaccess.indexOf(rvalue.RoleName) == -1) {
                        Roleaccess.push(rvalue.RoleName);
                      }
                    }
                  });
                });
                var item = $scope.Employeedatas.filter(function (value) {
                  return value.EmployeeID === $scope.Userdata.EmployeeID;
                })[0];
                try {
                  $window.localStorage.setItem("EmpId", item.id);
                } catch (error) { }

                $window.localStorage.setItem("IsAuthenticated", "true");
                $window.localStorage.setItem("UserName", $scope.Userdata.UserName);
                $window.localStorage.setItem("LoginID", $scope.Userdata.UserID);
                $window.localStorage.setItem(
                  "SessionStartDate",
                  $scope.Userdata.SessionStartDate
                );
                $window.localStorage.setItem("ID", $scope.Userdata.id);
                $window.localStorage.setItem("pages", pageaccess);
                $window.localStorage.setItem("Roles", Roleaccess);
                $window.localStorage.setItem(
                  "EmployeeID",
                  $scope.Userdata.EmployeeID
                );
                $window.localStorage.setItem(
                  "AllowExport",
                  $scope.Userdata.AllowExport
                );
                $window.localStorage.setItem("Client_Id", $scope.Userdata.ClientID);
                $window.localStorage.setItem(
                  "Customer_Id",
                  $scope.Userdata.Customer_Id
                );
                $window.localStorage.setItem("IsAdmin", $scope.Userdata.IsAdmin);
                if (
                  $scope.Userdata.Customer_Id != null &&
                  $scope.Userdata.Customer_Id != undefined &&
                  $scope.Userdata.Customer_Id != "" &&
                  $scope.Userdata.Customer_Id != "undefined"
                ) {
                  window.location = "CustomerPortal";
                } else if ($scope.Userdata.IsAdmin == false) {
                  $window.localStorage.setItem(
                    "Customer_Id",
                    "$scope.Userdata.Customer_Id"
                  );
                  if (pageaccess.includes("DCRM"))
                    window.location = "DashboardSales";
                  else if (pageaccess.includes("DOperations"))
                    window.location = "DashboardOperations";
                  else if (pageaccess.includes("DHuman"))
                    window.location = "DashboardHumanresource";
                  else if (pageaccess.includes("DAccounts"))
                    window.location = "DashboardAccounts";
                  else if (pageaccess.includes("DProcurement"))
                    window.location = "DashboardInventry";
                  else {
                    $window.localStorage.setItem("Customer_Id", null);
                    window.location = "Dashboard";
                  }
                } else {
                  window.location = "Dashboard";
                }
              })
              .catch(function () {
                $scope.Error1 = true;
              });
          }
        },
        function () {
          $scope.Error1 = true;
        }
      );
    };

    function get_other_data() {
      // Return a promise chain
      return $http
        .get($rootScope.WebURL + "/pagedb")
        .then(function (pagedataResponse) {
          $scope.Pagedatas = pagedataResponse.data.data;
          return $http.get($rootScope.WebURL + "/userrole");
        })
        .then(function (userroleResponse) {
          $scope.Userroledatas = userroleResponse.data.data;
          return $http.get($rootScope.WebURL + "/role");
        })
        .then(function (roleResponse) {
          $scope.Roledatas = roleResponse.data.data;
          return $http.get($rootScope.WebURL + "/employee/get");
        })
        .then(function (employeeResponse) {
          $scope.Employeedatas = employeeResponse.data.data;
          return $http.get(
            $rootScope.WebURL + "/chemicalrequest/newCount"
          );
        })
        .then(function (chemicalResponse) {
          sessionStorage.setItem("ChemicalCount", chemicalResponse.data.data);
          return $http({
            method: "POST",
            url: $rootScope.WebURL + "/chemical/thresholdCount",
            data: {
              Client_Id: $rootScope.Client_Id
            }
          });
        })
        .then(function (thresholdResponse) {
          sessionStorage.setItem(
            "ChemicalInvCount",
            thresholdResponse.data.data
          );
        })
        .catch(function (error) {
          console.error("Error in get_other_data():", error);
          // You can reject or handle error accordingly here
          return Promise.reject(error);
        });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.administration')
        .controller('certificationController', certificationController);

    /** @ngInject */
    function certificationController($mdDateLocale, $scope, $rootScope, $mdDialog, $document, $interval, $mdToast, $window, $state, $mdSidenav, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Training")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var AId = localStorage.getItem('idForCertification');
        $scope.CP_id = AId;
        $scope.Update = false;
        function init() {
            angular.forEach($scope.Enrollmentsdatas, function (value) {
                if ($scope.CP_id == value.id) {
                    $scope.Name = value.EmployeeName;
                    $scope.From = value.CompanySponsored;
                    $scope.To = value.Remarks;

                    $scope.vm.EnrolmentID = value.EnrolmentID;
                    $scope.vm.ECourseName = value.CourseName;
                    $scope.vm.EBatchName = value.BatchName;
                    $scope.vm.EEmployeeName = value.EmployeeName;
                    $scope.vm.CompanySponsored = value.CompanySponsored;
                    $scope.vm.EFees = value.Fees;
                    $scope.vm.ERemarks = value.Remarks;
                }
            })
            angular.forEach($scope.RealEnrollmentsdatas, function (rvalue) {
                if ($scope.CP_id == rvalue.id) {
                    $scope.vm.EnrolmentID = rvalue.EnrolmentID;
                    $scope.vm.ECourseName = rvalue.CourseName;
                    $scope.vm.EBatchName = rvalue.BatchName;
                    $scope.vm.EEmployeeName = rvalue.EmployeeName;
                    $scope.vm.CompanySponsored = rvalue.CompanySponsored;
                    $scope.vm.EFees = rvalue.Fees;
                    $scope.vm.Status = rvalue.Status;
                    $scope.vm.CStatus = rvalue.CStatus;
                    $scope.vm.ERemarks = rvalue.Remarks;
                }
            })
            var CSArray = $scope.Courseschedulingdatas;
            var CSitem = CSArray.filter(function (CSitem) {
                return CSitem.BatchName === $scope.vm.EBatchName;
            })[0];
            $scope.Trainer = CSitem.TrainerName;

            if ($scope.vm.CStatus == 'Completed') {
                var myArray = $scope.Coursecertificatedatas;
                var item = myArray.filter(function (item) {
                    return item.CP_id === $scope.CP_id;
                })[0];
                $scope.SID = item.id;
                $scope.CP_id = item.CP_id;
                $scope.Name = item.Name;
                $scope.From = item.From;
                $scope.To = item.To;
                $scope.Status = item.Status;
                $scope.Update = true

                var myArray1 = $scope.Employeedatas.filter(function (myArray1) {
                    return myArray1.EmployeeName == $scope.Name;
                })[0];
                $scope.EmployeeID = myArray1.EmployeeID;
            }
        }
        $scope.Save = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/coursecertificate/update",
                    data: {
                        _id: $scope.SID,
                        CP_id: $scope.CP_id,
                        Name: $scope.Name,
                        From: $scope.From,
                        To: $scope.To,
                        Status: 'Completed',
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $window.localStorage.setItem('idForCertification', "");
                    $state.go('app.human-resource_training_administration');
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/coursecertificate/add",
                    data: {
                        CP_id: $scope.CP_id,
                        Name: $scope.Name,
                        From: $scope.From,
                        To: $scope.To,
                        Status: 'Completed',
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/enrollments/update",
                        data: {
                            _id: $scope.CP_id,
                            EnrolmentID: $scope.vm.EnrolmentID,
                            CourseName: $scope.vm.ECourseName,
                            BatchName: $scope.vm.EBatchName,
                            EmployeeName: $scope.vm.EEmployeeName,
                            CompanySponsored: $scope.vm.CompanySponsored,
                            Fees: $scope.vm.EFees,
                            Remarks: $scope.vm.ERemarks,
                            Status: 'Completed',
                            CStatus: 'Completed',
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {
                    })
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $window.localStorage.setItem('idForCertification', "");
                    $state.go('app.human-resource_training_administration');
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Back = function () {
            $window.localStorage.setItem('idForCertification', "");
            $state.go('app.human-resource_training_administration');
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursescheduling",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (courseschedulingdata) {
            $scope.Courseschedulingdatas = courseschedulingdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (RealEnrollmentsdata) {
            $scope.RealEnrollmentsdatas = RealEnrollmentsdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/coursecertificate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (coursecertificate) {
            $scope.Coursecertificatedatas = coursecertificate.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            angular.forEach($scope.Enrollmentsdatas, function (evalue) {
                angular.forEach($scope.Courseschedulingdatas, function (cvalue) {
                    if (evalue.CourseName == cvalue.CourseName) {
                        evalue.CompanySponsored = cvalue.StartDate;
                        evalue.Fees = cvalue.InhouseTraining;
                        evalue.Remarks = cvalue.EndDate;
                    }
                })
            })
            init();
        });

        $scope.printToCart = function (printe) {
            window.open($rootScope.ReportURL + 'Certificate.aspx' + '?' + 'ID=' + $scope.Name + '~' + $scope.From + '~' + $scope.To + '~' + $scope.Trainer + '~' + $scope.vm.ECourseName + '~' + $scope.EmployeeID, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
            //var printButton = document.getElementById("printpagebutton");
            //var printButton1 = document.getElementById("printpagebutton1");
            //var printButton2 = document.getElementById("printpagebutton2");
            //var printButton3 = document.getElementById("printpagebutton3");
            //var printButton4 = document.getElementById("printpagebutton4");
            //printButton.style.visibility = 'hidden';
            //printButton1.style.visibility = 'hidden';
            //printButton2.style.visibility = 'hidden';
            //printButton3.style.visibility = 'hidden';
            //printButton4.style.visibility = 'hidden';
            ////window.focus(printe);
            ////window.print(printe);
            //printButton.style.visibility = 'visible';
            //printButton1.style.visibility = 'visible';
            //printButton2.style.visibility = 'visible';
            //printButton3.style.visibility = 'visible';
            //printButton4.style.visibility = 'visible';
        };

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true

        };

    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.security.workflow', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.workflow', {
            url      :'/workflow',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/security/workflow/workflow.html',
                    controller: 'WorkflowController as vm'
                }
            }
        });
    }

})();
(function () {
  'use strict';

  angular
    .module('app.security.workflow')
    .controller('WorkflowController', WorkflowController);

  /** @ngInject */
  function WorkflowController($mdDateLocale, $filter, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $http, $timeout, $q, $log) {
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("Workflow")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }

    var Client_Id = localStorage.getItem('Client_Id');

    $scope.Workflowgrid = true;
    $scope.Export = true;
    $scope.Workflowform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.error1 = false;

    $scope.sAdd = function () {
      ClearForm();
      $scope.Update = false;
      $scope.Workflowform = true;
      $scope.Workflowgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
      $scope.Search = false;
      $scope.error1 = false;

    }

    $scope.Showgrid = function () {
      $scope.Workflowgrid = true;
      $scope.Workflowform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.Search = true;
      $scope.view = false;
      $scope.error1 = false;
      $scope.checkboxModel = {
        value: false,
      };
      $scope.oneWorkflow = false;
    }

    $scope.Workflowinfo = function (WorkflowId) {
      debugger
      $scope.Update = true;
      $scope.Workflowform = true;
      $scope.Workflowgrid = false;
      $scope.Export = false;
      $scope.view = true
      $scope.Add = false;

      $scope.WorkflowID = WorkflowId;

      angular.forEach($scope.Workflowdatas, function (value, key) {
        if (WorkflowId == value._id) {

          $scope.TypeName = value.TypeName;
          $scope.LevelName = parseInt(value.LevelName);
          $scope.Action = value.Action;
          $scope.Actioned = value.Actioned;
          $scope.NextLevel = parseInt(value.NextLevel);

          $scope.ClientID = value.Client_Id;

          $scope.Approvers = value.Approvers;
          if ($scope.Approvers != null && $scope.Approvers != "" && $scope.Approvers != undefined) {
            var array = $scope.Approvers.split(",");
            var array1 = [];
            angular.forEach(array, function (value) {
              var item = [];
              item = $scope.Userdatas.filter(function (item) {
                return item.UserID === value;
              });
              if (item.length != 0) {
                array1.push({
                  UserID: value
                });
              }
            });
            $scope.Approvers = array1;
          }

          $scope.NotifyTo = value.NotifyTo;
          if ($scope.NotifyTo != null && $scope.NotifyTo != "" && $scope.NotifyTo != undefined) {
            var array = $scope.NotifyTo.split(",");
            var array1 = [];
            angular.forEach(array, function (value) {
              var item = [];
              item = $scope.Userdatas.filter(function (item) {
                return item.UserID === value;
              });
              if (item.length != 0) {
                array1.push({
                  UserID: value
                });
              }
            });
            $scope.NotifyTo = array1;
          }

          $scope.EmailExceptions = value.EmailExceptions;
          $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;

          if (value.ShowCancelButton == true) {
            $scope.ShowCancelButton = {
              value: true,
            }
          } else {
            $scope.ShowCancelButton = {
              value: false,
            };
          }
          if (value.ShowRejectButton == true) {
            $scope.ShowRejectButton = {
              value: true,
            }
          } else {
            $scope.ShowRejectButton = {
              value: false,
            };
          }
          if (value.ShowReviseButton == true) {
            $scope.ShowReviseButton = {
              value: true,
            }
          } else {
            $scope.ShowReviseButton = {
              value: false,
            };
          }
          if (value.Mandatory == true) {
            $scope.Mandatory = {
              value: true,
            }
          } else {
            $scope.Mandatory = {
              value: false,
            };
          }
          if (value.EmailNotification == true) {
            $scope.EmailNotification = {
              value: true,
            }
          } else {
            $scope.EmailNotification = {
              value: false,
            };
          }
          if (value.NotifytoCurrentApprover == true) {
            $scope.NotifytoCurrentApprover = {
              value: true,
            }
          } else {
            $scope.NotifytoCurrentApprover = {
              value: false,
            };
          }
          if (value.NotifytoNextLevelApprover == true) {
            $scope.NotifytoNextLevelApprover = {
              value: true,
            }
          } else {
            $scope.NotifytoNextLevelApprover = {
              value: false,
            };
          }
          if (value.NotifytoCreatorInitator == true) {
            $scope.NotifytoCreatorInitator = {
              value: true,
            }
          } else {
            $scope.NotifytoCreatorInitator = {
              value: false,
            };
          }

        }
      });
    }

    $scope.checkboxModel = {
      value: false,
    };

    $scope.Submit = function () {

      var ShowRejectButton = $scope.ShowRejectButton.value;
      var ShowCancelButton = $scope.ShowCancelButton.value;
      var ShowReviseButton = $scope.ShowReviseButton.value;
      var Mandatory = $scope.Mandatory.value;
      var EmailNotification = $scope.EmailNotification.value;
      var NotifytoCurrentApprover = $scope.NotifytoCurrentApprover.value;
      var NotifytoNextLevelApprover = $scope.NotifytoNextLevelApprover.value;
      var NotifytoCreatorInitator = $scope.NotifytoCreatorInitator.value;

      if ($scope.Approvers != null && $scope.Approvers != "" && $scope.Approvers != undefined) {
        $scope.Approvers = $scope.Approvers.map(function (obj) {
          return obj.UserID;
        }).join(',');
      }
      if ($scope.NotifyTo != null && $scope.NotifyTo != "" && $scope.NotifyTo != undefined) {
        $scope.NotifyTo = $scope.NotifyTo.map(function (obj) {
          return obj.UserID;
        }).join(',');
      }

      if ($scope.Update == true) {

        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/Workflow/update",
          data: {
            _id: $scope.WorkflowID,
            TypeName: $scope.TypeName,
            LevelName: $scope.LevelName,
            Action: $scope.Action,
            Actioned: $scope.Actioned,
            ShowCancelButton: ShowCancelButton,
            ShowRejectButton: ShowRejectButton,
            ShowReviseButton: ShowReviseButton,
            NextLevel: $scope.NextLevel,
            Mandatory: Mandatory,
            EmailNotification: EmailNotification,
            NotifytoCurrentApprover: NotifytoCurrentApprover,
            NotifytoNextLevelApprover: NotifytoNextLevelApprover,
            NotifytoCreatorInitator: NotifytoCreatorInitator,
            Approvers: $scope.Approvers,
            NotifyTo: $scope.NotifyTo,
            EmailExceptions: $scope.EmailExceptions,
            AlwaysNotifyTo: $scope.AlwaysNotifyTo,
            UpdatedBy: $rootScope.ProfName
          },
        });

        response.then(function (GList) {

          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          $scope.Workflowgrid = true;
          $scope.Workflowform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.Search = true;
          $scope.view = false;
          RefreshGrid();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/Workflow/add",

          data: {
            TypeName: $scope.TypeName,
            LevelName: $scope.LevelName,
            Action: $scope.Action,
            Actioned: $scope.Actioned,
            Client_Id: $scope.ClientID,
            ShowCancelButton: ShowCancelButton,
            ShowRejectButton: ShowRejectButton,
            ShowReviseButton: ShowReviseButton,
            NextLevel: $scope.NextLevel,
            Mandatory: Mandatory,
            EmailNotification: EmailNotification,
            NotifytoCurrentApprover: NotifytoCurrentApprover,
            NotifytoNextLevelApprover: NotifytoNextLevelApprover,
            NotifytoCreatorInitator: NotifytoCreatorInitator,
            Approvers: $scope.Approvers,
            NotifyTo: $scope.NotifyTo,
            EmailExceptions: $scope.EmailExceptions,
            AlwaysNotifyTo: $scope.AlwaysNotifyTo,
            CreatedBy: $rootScope.ProfName
          },

        });

        response.then(function (GList) {

          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshGrid();
          $scope.Workflowgrid = true;
          $scope.Workflowform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;

        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      }
    }

    $http.get($rootScope.WebURL + "/user")
      .then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        $scope.AllUserdatas = Userdata.data.data;
      });

    RefreshGrid();

    function RefreshGrid() {
      debugger

      $http.get($rootScope.WebURL + "/Workflow/get")
        .then(function (Workflowdata) {
          $scope.Workflowdatas = Workflowdata.data.data;
          $scope.AllWorkflowdatas = Workflowdata.data.data;

          var myArray = $scope.AllWorkflowdatas;
          var item = myArray.filter(function (item) {
            return item.Client_Id === Client_Id;
          });

          $scope.Workflowdatas = item;
          $scope.ClID = Client_Id;
        });
    }

    $http.get($rootScope.WebURL + "/client")
      .then(function (Clientdata) {
        $scope.Clientdatas = Clientdata.data.data;
      });


    $scope.OnClientChange = function () {

      $scope.Workflowdatas = undefined;

      var myArray = $scope.AllWorkflowdatas;
      var item = myArray.filter(function (item) {
        return item.Client_Id === $scope.ClID;
      });
      $scope.Workflowdatas = item;
    };

    function ClearForm() {

      $scope.TypeName = null;
      $scope.LevelName = null;
      $scope.Action = null;
      $scope.Actioned = null;
      $scope.NextLevel = null;
      $scope.ClientID = null;
      $scope.Approvers = null;
      $scope.NotifyTo = null;
      $scope.EmailExceptions = null;
      $scope.AlwaysNotifyTo = null;

      $scope.ShowCancelButton = {
        value: false,
      };
      $scope.ShowRejectButton = {
        value: true,
      };
      $scope.ShowReviseButton = {
        value: false,
      };
      $scope.Mandatory = {
        value: false,
      };
      $scope.EmailNotification = {
        value: true,
      };
      $scope.NotifytoCurrentApprover = {
        value: false,
      };
      $scope.NotifytoNextLevelApprover = {
        value: true,
      };
      $scope.NotifytoCreatorInitator = {
        value: true,
      };
    }
    $scope.Export = function () {
      alasql('SELECT * INTO XLSX("Workflows.xlsx",{headers:true}) FROM ?', [$scope.Workflowdatas]);
    };


    $scope.clearSearchTerm = function () {
      $scope.searchTerm = null;
      $scope.searchTerm1 = null;
    }

    $scope.LoadUserByClient = function () {

      var item = $scope.AllUserdatas.filter(function (item) {
        return item.ClientID === $scope.ClientID;
      });

      $scope.Userdatas = item;
    }


    var vm = this;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

      initComplete: function () {

        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      retrieve: true,
      stateSave: true,
      drawCallback: function (settings) {
        var api = this.api();
        var rows = api.rows({
          page: 'current'
        }).nodes();
        var last = null;

        api.column(2, {
          page: 'current'
        }).data().each(function (group, i) {
          if (last !== group) {
            $(rows).eq(i).before(
              '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
            );

            last = group;
          }
        });
      }


    };

  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.security.user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.user', {
            url      : '/Users',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/security/user/user.html',
                    controller: 'userProjectController as vm'
                }
            },
            resolve  : {
                UserData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'security-user'
        });
    }

})();
(function () {
    'use strict';
    angular
        .module('app.security.user')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('userProjectController', userProjectController);
    function userProjectController($mdDateLocale, $scope, $interval, $mdSidenav, $mdToast, $http, $mdDialog, $document, $rootScope, $state, $window, $log, $location, $filter, Upload) {
        document.getElementsByTagName('title')[0].text = "Security-User"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Users")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.UAllowExport = localStorage.getItem('AllowExport')

        $scope.Userform = false;
        $scope.Usergrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;
        $scope.ischanged = false;
        $scope.AllSelect = { value: false, };
        $scope.IsAdmin = { value: false, };
        $scope.Securitydiv = false;
        $scope.Humandiv = false;
        $scope.Procurementdiv = false;
        $scope.Operationsdiv = false;
        $scope.Salediv = false;
        $scope.Accountsdiv = false;
        $scope.RequstForm = false
        $scope.RoleLength = []

        $scope.SelectAllchkbox = function () {
            if ($scope.AllSelect.value == true) {
                $scope.rec1 = { Users: 1 }
                $scope.rec2 = { Client: 1 }
                $scope.rec3 = { HRMAdmin: 1 }
                $scope.rec4 = { HRMCore: 1 }
                $scope.rec5 = { Products: 1 }
                $scope.rec6 = { Supliers: 1 }
                $scope.rec7 = { PestType: 1 }
                $scope.rec8 = { Services: 1 }
                $scope.rec9 = { Customers: 1 }
                $scope.rec10 = { Timelog: 1 }
                $scope.rec11 = { Recruitment: 1 }
                $scope.rec12 = { Training: 1 }
                $scope.rec13 = { CrmSettings: 1 }
                $scope.rec14 = { Lead: 1 }
                $scope.rec15 = { Quotation: 1 }
                $scope.rec16 = { WorkOrder: 1 }
                $scope.rec17 = { Stores: 1 }
                $scope.rec18 = { Contracts: 1 }
                $scope.rec19 = { EquipmentRequest: 1 }
                $scope.rec20 = { PurchaseOrder: 1 }
                $scope.rec21 = { StockManagement: 1 }
                $scope.rec22 = { Requests: 1 }
                $scope.rec23 = { Invoice: 1 }
                $scope.rec24 = { Ledger: 1 }
                $scope.rec25 = { BankCash: 1 }
                $scope.rec26 = { AccountsWorkOrder: 1 }
                $scope.rec27 = { SalesReceivables: 1 }
                $scope.rec28 = { Asset: 1 }
                $scope.rec29 = { Uniform: 1 }
                $scope.rec30 = { Workflow: 1 }
                $scope.rec31 = { EmailAlerts: 1 }
                $scope.rec32 = { Teams: 1 }
                $scope.rec33 = { Scheduler: 1 }
                $scope.rec34 = { Vehicle: 1 }
                $scope.rec35 = { DManagement: 1 }
                $scope.rec36 = { DHuman: 1 }
                $scope.rec37 = { DProcurement: 1 }
                $scope.rec38 = { DCRM: 1 }
                $scope.rec39 = { DOperations: 1 }
                $scope.rec40 = { AcCustomer: 1 }
                $scope.rec41 = { AcContract: 1 }
                $scope.rec42 = { Insurance: 1 }
                $scope.rec43 = { ELeaves: 1 }
                $scope.rec44 = { Hrmusers: 1 }
                $scope.rec45 = { AcScheduler: 1 }
                $scope.rec46 = { AcDScheduler: 1 }
                $scope.rec47 = { AcPestOff: 1 }
                $scope.rec48 = { AcLumiair: 1 }
                $scope.rec49 = { UniformR: 1 }
                $scope.rec50 = { Incident: 1 }
                $scope.rec51 = { Medical: 1 }
                $scope.rec52 = { Expense: 1 }
                $scope.rec53 = { Payment: 1 }
                $scope.rec54 = { SChecklist: 1 }
                $scope.rec55 = { ChemicalRequest: 1 }
                $scope.rec56 = { ProcurementSettings: 1 }
                $scope.rec57 = { Treatment: 1 }
                $scope.rec58 = { Feedback: 1 }
                $scope.rec59 = { OperationsReport: 1 }
                $scope.rec61 = { ChemicalRequest: 1 }
                $scope.DManagement = { value: true, };
                $scope.DHuman = { value: true, };
                $scope.DProcurement = { value: true, };
                $scope.AcCustomer = { value: true, };
                $scope.AcScheduler = { value: true, };
                $scope.AcPestOff = { value: true, };
                $scope.AcDScheduler = { value: true, };
                $scope.AcContract = { value: true, };
                $scope.DCRM = { value: true, };
                $scope.DOperations = { value: true, };
                $scope.CashCheque = { value: true, };
                $scope.LeaveR = { value: true, };
                $scope.MaterialR = { value: true, };
                $scope.AcLumiair = { value: true, };
                $scope.Incident = { value: true, };
                $scope.Medical = { value: true, };
                $scope.Expense = { value: true, };
                $scope.Payment = { value: true, }
                $scope.Insurance = { value: true, }
                $scope.Division = { value: true, }
                $scope.ELeaves = { value: true, }
                $scope.Hrmusers = { value: true, }
                $scope.SChecklist = { value: true, }
                $scope.ChemicalRequest = { value: true, }
                $scope.ProcurementSettings = { value: true, }
                $scope.Treatment = { value: true, }
                $scope.Users = { value: true, };
                $scope.Client = { value: true, };
                $scope.HRMAdmin = { value: true, };
                $scope.HRMCore = { value: true, };
                $scope.Products = { value: true, };
                $scope.Supliers = { value: true, };
                $scope.PestType = { value: true, };
                $scope.Services = { value: true, };
                $scope.Customers = { value: true, };
                $scope.Timelog = { value: true, };
                $scope.Recruitment = { value: true, };
                $scope.Training = { value: true, };
                $scope.CrmSettings = { value: true, }
                $scope.Lead = { value: true, }
                $scope.Quotation = { value: true, }
                $scope.WorkOrder = { value: true, }
                $scope.Stores = { value: true, }
                $scope.Contracts = { value: true, }
                $scope.EquipmentRequest = { value: true, }
                $scope.PurchaseOrder = { value: true, }
                $scope.StockManagement = { value: true, }
                $scope.Requests = { value: true, }
                $scope.Invoice = { value: true, }
                $scope.Ledger = { value: true, }
                $scope.BankCash = { value: true, }
                $scope.AccountsWorkOrder = { value: true, }
                $scope.SalesReceivables = { value: true, }
                $scope.Asset = { value: true, }
                $scope.Uniform = { value: true, }
                $scope.Workflow = { value: true, }
                $scope.EmailAlerts = { value: true, }
                $scope.Teams = { value: true, }
                $scope.Scheduler = { value: true, }
                $scope.Vehicle = { value: true, }
                $scope.Health = { value: true, }
                $scope.UniformR = { value: true, }
                $scope.Feedback = { value: true, }
                $scope.ChemicalRequest = { value: true, }
            }
            else {
                $scope.rec1 = { Users: 0 }
                $scope.rec2 = { Client: 0 }
                $scope.rec3 = { HRMAdmin: 0 }
                $scope.rec4 = { HRMCore: 0 }
                $scope.rec5 = { Products: 0 }
                $scope.rec6 = { Supliers: 0 }
                $scope.rec7 = { PestType: 0 }
                $scope.rec8 = { Services: 0 }
                $scope.rec9 = { Customers: 0 }
                $scope.rec10 = { Timelog: 0 }
                $scope.rec11 = { Recruitment: 0 }
                $scope.rec12 = { Training: 0 }
                $scope.rec13 = { CrmSettings: 0 }
                $scope.rec14 = { Lead: 0 }
                $scope.rec15 = { Quotation: 0 }
                $scope.rec16 = { WorkOrder: 0 }
                $scope.rec17 = { Stores: 0 }
                $scope.rec18 = { Contracts: 0 }
                $scope.rec19 = { EquipmentRequest: 0 }
                $scope.rec20 = { PurchaseOrder: 0 }
                $scope.rec21 = { StockManagement: 0 }
                $scope.rec22 = { Requests: 0 }
                $scope.rec23 = { Invoice: 0 }
                $scope.rec24 = { Ledger: 0 }
                $scope.rec25 = { BankCash: 0 }
                $scope.rec26 = { AccountsWorkOrder: 0 }
                $scope.rec27 = { SalesReceivables: 0 }
                $scope.rec28 = { Asset: 0 }
                $scope.rec29 = { Uniform: 0 }
                $scope.rec30 = { Workflow: 0 }
                $scope.rec31 = { EmailAlerts: 0 }
                $scope.rec32 = { Teams: 0 }
                $scope.rec33 = { Scheduler: 0 }
                $scope.rec34 = { Vehicle: 0 }
                $scope.rec35 = { DManagement: 0 }
                $scope.rec36 = { DHuman: 0 }
                $scope.rec37 = { DProcurement: 0 }
                $scope.rec38 = { DCRM: 0 }
                $scope.rec39 = { DOperations: 0 }
                $scope.rec40 = { AcCustomer: 0 }
                $scope.rec41 = { AcContract: 0 }
                $scope.rec42 = { Insurance: 0 }
                $scope.rec43 = { ELeaves: 0 }
                $scope.rec44 = { Hrmusers: 0 }
                $scope.rec45 = { AcScheduler: 0 }
                $scope.rec46 = { AcDScheduler: 0 }
                $scope.rec47 = { AcPestOff: 0 }
                $scope.rec48 = { AcLumiair: 0 }
                $scope.rec49 = { UniformR: 0 }
                $scope.rec50 = { Incident: 0 }
                $scope.rec51 = { Medical: 0 }
                $scope.rec52 = { Expense: 0 }
                $scope.rec53 = { Payment: 0 }
                $scope.rec54 = { SChecklist: 0 }
                $scope.rec55 = { ChemicalRequest: 0 }
                $scope.rec56 = { ProcurementSettings: 0 }
                $scope.rec57 = { Treatment: 0 }
                $scope.rec58 = { Feedback: 0 }
                $scope.rec59 = { OperationsReport: 0 }
                $scope.rec61 = { ChemicalRequest: 0 }
                $scope.DManagement = { value: false, };
                $scope.DHuman = { value: false, };
                $scope.DProcurement = { value: false, };
                $scope.AcCustomer = { value: false, };
                $scope.AcScheduler = { value: false, };
                $scope.AcPestOff = { value: false, };
                $scope.AcDScheduler = { value: false, };
                $scope.AcContract = { value: false, };
                $scope.DCRM = { value: false, };
                $scope.DOperations = { value: false, };
                $scope.CashCheque = { value: false, };
                $scope.LeaveR = { value: false, };
                $scope.MaterialR = { value: false, };
                $scope.AcLumiair = { value: false, };
                $scope.Incident = { value: false, };
                $scope.Medical = { value: false, };
                $scope.Expense = { value: false, };
                $scope.Payment = { value: false, }
                $scope.Insurance = { value: false, }
                $scope.Division = { value: false, }
                $scope.ELeaves = { value: false, }
                $scope.Hrmusers = { value: false, }
                $scope.SChecklist = { value: false, }
                $scope.ChemicalRequest = { value: false, }
                $scope.ProcurementSettings = { value: false, }
                $scope.Treatment = { value: false, }
                $scope.Users = { value: false, };
                $scope.Client = { value: false, };
                $scope.HRMAdmin = { value: false, };
                $scope.HRMCore = { value: false, };
                $scope.Products = { value: false, };
                $scope.Supliers = { value: false, };
                $scope.PestType = { value: false, };
                $scope.Services = { value: false, };
                $scope.Customers = { value: false, };
                $scope.Timelog = { value: false, };
                $scope.Recruitment = { value: false, };
                $scope.Training = { value: false, };
                $scope.CrmSettings = { value: false, }
                $scope.Lead = { value: false, }
                $scope.Quotation = { value: false, }
                $scope.WorkOrder = { value: false, }
                $scope.Stores = { value: false, }
                $scope.Contracts = { value: false, }
                $scope.EquipmentRequest = { value: false, }
                $scope.PurchaseOrder = { value: false, }
                $scope.StockManagement = { value: false, }
                $scope.Requests = { value: false, }
                $scope.Invoice = { value: false, }
                $scope.Ledger = { value: false, }
                $scope.BankCash = { value: false, }
                $scope.AccountsWorkOrder = { value: false, }
                $scope.SalesReceivables = { value: false, }
                $scope.Asset = { value: false, }
                $scope.Uniform = { value: false, }
                $scope.Workflow = { value: false, }
                $scope.EmailAlerts = { value: false, }
                $scope.Teams = { value: false, }
                $scope.Scheduler = { value: false, }
                $scope.Vehicle = { value: false, }
                $scope.Health = { value: false, }
                $scope.UniformR = { value: false, }
                $scope.Feedback = { value: false, }
                $scope.ChemicalRequest = { value: false, }
            }
        }
        $scope.valEmail = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
        $rootScope.ProfName = sessionStorage.getItem('UserName');
        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Userdata.xlsx",{headers:true}) FROM ?', [$scope.Userdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.getNumber = function () {
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.formData.uPassword = pass;
        }
        $scope.getEmailID = function (EId) {
            try {
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === EId;
                })[0];
                $scope.formData.uEmail = item.Email;
            }
            catch (e) { }
        }
        $scope.reset = function (UserId) {
            $scope.UserInfoId = UserId;
            var item = $scope.Userdatas.filter(function (item) {
                return item.ID === UserId;
            })[0];
            $scope.uLoginID = item.UserID;
            $scope.Email = item.Email;
            $scope.UserName = item.UserName;
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var ii = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(ii);
            }
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/login/resetPassword",
                data: {
                    UserID: $scope.uLoginID,
                    rNewPassword: pass,
                },
            });
            response.then(function (GList) {
                $scope.Userdata = GList.data
                if ($scope.Userdata.UserName != null) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/user/email",
                        data: {
                            SenderEmailAddress: $scope.Userdata.EmailID, UserName: $scope.Userdata.UserName,
                            LoginID: $scope.uLoginID,
                            Password: pass,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }
                else {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                }
            });
        }
        $scope.userpopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/user/userpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function userProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }
        $scope.Userdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                // var item = $scope.Userdatas.filter(function (item) {
                //     return item.id === deleteID;
                // })[0];
                // debugger
                // $scope.DeletedUserName = item.UserID;
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
                $mdDialog.cancel();
                RefreshGrid();
                // angular.forEach($scope.Workflowdatas, function (value) {
                //     var Approversarray = [];
                //     var NotifierArray = [];
                //     var UpdatedApprover = "";
                //     var UpdatedNotifier = "";
                //     debugger
                //     if (value.Approvers != null && value.Approvers != undefined) Approversarray = value.Approvers.split(",");
                //     if (value.NotifyTo != null && value.NotifyTo != undefined) NotifierArray = value.NotifyTo.split(",");
                //     try {
                //         debugger
                //         for (var i = 0; i < Approversarray.length; i++) {
                //             if (Approversarray[i] === $scope.DeletedUserName) { Approversarray.splice(i, 1) }
                //         }
                //         UpdatedApprover = Approversarray.join(",");

                //         for (var i = 0; i < NotifierArray.length; i++) {
                //             if (NotifierArray[i] === $scope.DeletedUserName) { NotifierArray.splice(i, 1) }
                //         }
                //         UpdatedNotifier = NotifierArray.join(",");
                //     } catch (ex) { }

                //     var response = $http({
                //         method: "PUT",
                //         url:  $rootScope.WebURL + "/Workflow/update",
                //         data: {
                //             _id: value._id, TypeName: value.TypeName, LevelName: value.LevelName, Action: value.Action, Actioned: value.Actioned,
                //             ShowCancelButton: value.ShowCancelButton, ShowRejectButton: value.ShowRejectButton, ShowReviseButton: value.ShowReviseButton, NextLevel: value.NextLevel,
                //             Mandatory: value.Mandatory, EmailNotification: value.EmailNotification, NotifytoCurrentApprover: value.NotifytoCurrentApprover,
                //             NotifytoNextLevelApprover: value.NotifytoNextLevelApprover, NotifytoCreatorInitator: value.NotifytoCreatorInitator,
                //             Approvers: UpdatedApprover, NotifyTo: UpdatedNotifier, EmailExceptions: value.EmailExceptions, AlwaysNotifyTo: value.AlwaysNotifyTo, UpdatedBy: value.ProfName
                //         },
                //     });
                //     response.then(function (GList) { debugger })
                // })
                // var item = $scope.Customerdatas.filter(function(value){
                //     return value.AssignedUser===$scope.DeletedUserName
                // })
                // if(item.lengthå>0){
                //     angular.forEach(item, function (value) {
                //             var response = $http({
                //                 method: "PUT",
                //                 url:  $rootScope.WebURL + "/customer/updateAssignedUser",
                //                 data: {
                //                     _id: value.id,
                //                     AssignedUser: null,
                //                     UpdatedBy: $rootScope.createdby,
                //                 },
                //             });
                //     });
                // }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.getEmployees = function (ClientId) {
            if (ClientId != null && ClientId != undefined) {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee/detailsforTab",
                    data: { Client_Id: ClientId },
                }).then(function (Employeedata) {
                    $scope.Employeedatas = Employeedata.data.data;
                });
            }
        }
        $scope.userinfo = function (UserId) {
            $scope.RoleLength = []
            $scope.SID = UserId;
            $scope.Update = true;
            $scope.Userform = true;
            $scope.Usergrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = true;
            $scope.Search = false;
            $scope.error1 = false;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.DashBoarddiv = false;
            $scope.RequstForm = false
            $scope.UserInfoId = UserId;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { WorkOrder: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { EquipmentRequest: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Invoice: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { AccountsWorkOrder: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { EmailAlerts: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { AcCustomer: 0 }
            $scope.rec41 = { AcContract: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { ELeaves: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { AcScheduler: 0 }
            $scope.rec46 = { AcDScheduler: 0 }
            $scope.rec47 = { AcPestOff: 0 }
            $scope.rec48 = { AcLumiair: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { ChemicalRequest: 0 }
            $scope.rec56 = { ProcurementSettings: 0 }
            $scope.rec57 = { Treatment: 0 }
            $scope.rec58 = { Feedback: 0 }
            $scope.rec59 = { OperationsReport: 0 }
            $scope.rec61 = { ChemicalRequest: 0 }

            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.AcCustomer = { value: false, };
            $scope.AcScheduler = { value: false, };
            $scope.AcPestOff = { value: false, };
            $scope.AcDScheduler = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.CashCheque = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.AcLumiair = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.ELeaves = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.ChemicalRequest = { value: false, }
            $scope.ProcurementSettings = { value: false, }
            $scope.Treatment = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.WorkOrder = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.EquipmentRequest = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Invoice = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.AccountsWorkOrder = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.EmailAlerts = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.ChemicalRequest = { value: false, }

            var Roleselect = [];
            var Moduleselect = [];
            var info = $scope.Userdatas
            var st = '';

            var item = $scope.Userdatas.filter(function (item) {
                return item.id === UserId;
            })[0];
            $scope.uClientID = item.ClientID
            $scope.getEmployees($scope.uClientID)
            $scope.formData.SID = UserId;
            $scope.formData.uLoginID = item.UserID;
            $scope.formData.uEmail = item.Email;
            $scope.formData.uUserName = item.UserName;
            $scope.formData.uMobileNumber = parseInt(item.MobileNumber);
            $scope.formData.uDesignation = item.Designation;
            $scope.formData.uExpiryDate = new Date(item.ExpiryDate);
            $scope.formData.uPassword = item.Password
            $scope.formData.uLastSuccess = item.LastSuccess;
            $scope.formData.uLastSuccess = item.LastFailure;
            $scope.formData.IsActive = item.IsActive;
            $scope.formData.IsLocked = item.IsLocked;
            $scope.uEmployeeID = item.EmployeeID
            $scope.uClientName = item.ClientName
            $scope.AllowExport = item.AllowExport
            $scope.IsAdmin = item.IsAdmin
            var selected = item.Roles
            Roleselect = selected.split(',')
            if ($scope.AllowExport == true) {
                $scope.AllowExport = { value: true }
            }
            else {
                $scope.AllowExport = { value: false }
            }
            if ($scope.IsAdmin == true) {
                $scope.IsAdmin = { value: true }
            }
            else {
                $scope.IsAdmin = { value: false }
            }
            // angular.forEach($scope.Userroledatas, function (urvalue) {
            //     angular.forEach($scope.Roledatas, function (rvalue) {
            //         if (item.id == urvalue.UserID && item.id == $scope.UserInfoId && urvalue.RoleID == rvalue.RoleID) {
            //             var item1 = Roleselect.filter(function (item1) {
            //                 return item1.RoleID == rvalue.RoleID;
            //             })
            //             if (item1.length == 0) {
            //                 Roleselect.push({
            //                     RoleName: rvalue.RoleName,
            //                     RoleID: rvalue.RoleID,
            //                     ticked: true,
            //                 })
            //             }
            //         }
            //     })
            // })
            st = Roleselect.map(function (obj) { return obj.RoleName; }).join(', ');
            // angular.forEach($scope.userModulesdatas, function (umvalue) {
            //     angular.forEach(Roleselect, function (rvalue) {
            //         if (rvalue.RoleName == umvalue.UserID) {
            //             Moduleselect.push({
            //                 ModuleName: umvalue.ModelID,
            //             })
            //         }
            //     });
            // });
            if (selected != undefined) {
                var mtr = selected;
                $scope.RoleLength = mtr
                if (mtr.length > 0) {
                    if (mtr.split(",").includes("Security")) {
                        $scope.Securitydiv = true;
                    }
                    if (mtr.indexOf("Human Resource") > -1) {
                        $scope.Humandiv = true;
                    }
                    if (mtr.split(",").includes("Procurement")) {
                        $scope.Procurementdiv = true;
                    }
                    if (mtr.split(",").includes("Operations")) {
                        $scope.Operationsdiv = true;
                    }
                    if (mtr.indexOf("Customer Relationship") > -1) {
                        $scope.Salediv = true;
                    }
                    if (mtr.split(",").includes("Accounts")) {
                        $scope.Accountsdiv = true;
                    }
                    if (mtr.split(",").includes("Management")) {
                        $scope.DashBoarddiv = true;
                    }
                    if (mtr.indexOf("Request Forms") > -1) {
                        $scope.RequstForm = true;
                    }
                }
            }
            //     });
            // });
            mtr = []
            angular.forEach(Roleselect, function (item) {
                mtr.push({ RoleName: item.trim(), ticked: true })
            })
            $scope.formData.selectedRole = mtr;
            $scope.Selectedrole = mtr;
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pagedb/getPageforClient",
                data: {
                    Client_Id: $scope.uClientID,
                },
            }).then(function (page) {
                var Pagedatas = page.data.data

                angular.forEach(Pagedatas, function (value) {
                    if (value.UserID == UserId) {
                        if (value.PageName == "Users") { $scope.rec1 = { Users: 1 } }
                        if (value.PageName == "Client") { $scope.rec2 = { Client: 1 } }
                        if (value.PageName == "HRMAdmin") { $scope.rec3 = { HRMAdmin: 1 } }
                        if (value.PageName == "HRMCore") { $scope.rec4 = { HRMCore: 1 } }
                        if (value.PageName == "Products") { $scope.rec5 = { Products: 1 } }
                        if (value.PageName == "Supliers") { $scope.rec6 = { Supliers: 1 } }
                        if (value.PageName == "PestType") { $scope.rec7 = { PestType: 1 } }
                        if (value.PageName == "Services") { $scope.rec8 = { Services: 1 } }
                        if (value.PageName == "Customers") { $scope.rec9 = { Customers: 1 } }
                        if (value.PageName == "Timelog") { $scope.rec10 = { Timelog: 1 } }
                        if (value.PageName == "Recruitment") { $scope.rec11 = { Recruitment: 1 } }
                        if (value.PageName == "Training") { $scope.rec12 = { Training: 1 } }
                        if (value.PageName == "CrmSettings") { $scope.rec13 = { CrmSettings: 1 } }
                        if (value.PageName == "Lead") { $scope.rec14 = { Lead: 1 } }
                        if (value.PageName == "Quotation") { $scope.rec15 = { Quotation: 1 } }
                        if (value.PageName == "WorkOrder") { $scope.rec16 = { WorkOrder: 1 } }
                        if (value.PageName == "Stores") { $scope.rec17 = { Stores: 1 } }
                        if (value.PageName == "Contracts") { $scope.rec18 = { Contracts: 1 } }
                        if (value.PageName == "EquipmentRequest") { $scope.rec19 = { EquipmentRequest: 1 } }
                        if (value.PageName == "PurchaseOrder") { $scope.rec20 = { PurchaseOrder: 1 } }
                        if (value.PageName == "StockManagement") { $scope.rec21 = { StockManagement: 1 } }
                        if (value.PageName == "Requests") { $scope.rec22 = { Requests: 1 } }
                        if (value.PageName == "Invoice") { $scope.rec23 = { Invoice: 1 } }
                        if (value.PageName == "Ledger") { $scope.rec24 = { Ledger: 1 } }
                        if (value.PageName == "BankCash") { $scope.rec25 = { BankCash: 1 } }
                        if (value.PageName == "AccountsWorkOrder") { $scope.rec26 = { AccountsWorkOrder: 1 } }
                        if (value.PageName == "SalesReceivables") { $scope.rec27 = { SalesReceivables: 1 } }
                        if (value.PageName == "Asset") { $scope.rec28 = { Asset: 1 } }
                        if (value.PageName == "Uniform") { $scope.rec29 = { Uniform: 1 } }
                        if (value.PageName == "Workflow") { $scope.rec30 = { Workflow: 1 } }
                        if (value.PageName == "EmailAlerts") { $scope.rec31 = { EmailAlerts: 1 } }
                        if (value.PageName == "Teams") { $scope.rec32 = { Teams: 1 } }
                        if (value.PageName == "Scheduler") { $scope.rec33 = { Scheduler: 1 } }
                        if (value.PageName == "Vehicle") { $scope.rec34 = { Vehicle: 1 } }
                        if (value.PageName == "DManagement") { $scope.rec35 = { DManagement: 1 } }
                        if (value.PageName == "DHuman") { $scope.rec36 = { DHuman: 1 } }
                        if (value.PageName == "DProcurement") { $scope.rec37 = { DProcurement: 1 } }
                        if (value.PageName == "DCRM") { $scope.rec38 = { DCRM: 1 } }
                        if (value.PageName == "DOperations") { $scope.rec39 = { DOperations: 1 } }
                        if (value.PageName == "AcCustomer") { $scope.rec40 = { AcCustomer: 1 } }
                        if (value.PageName == "AcContract") { $scope.rec41 = { AcContract: 1 } }
                        if (value.PageName == "Insurance") { $scope.rec42 = { Insurance: 1 } }
                        if (value.PageName == "ELeaves") { $scope.rec43 = { ELeaves: 1 } }
                        if (value.PageName == "Hrmusers") { $scope.rec44 = { Hrmusers: 1 } }
                        if (value.PageName == "AcScheduler") { $scope.rec45 = { AcScheduler: 1 } }
                        if (value.PageName == "AcDScheduler") { $scope.rec46 = { AcDScheduler: 1 } }
                        if (value.PageName == "AcPestOff") { $scope.rec47 = { AcPestOff: 1 } }
                        if (value.PageName == "AcLumiair") { $scope.rec48 = { AcLumiair: 1 } }
                        if (value.PageName == "UniformR") { $scope.rec49 = { UniformR: 1 } }
                        if (value.PageName == "Incident") { $scope.rec50 = { Incident: 1 } }
                        if (value.PageName == "Medical") { $scope.rec51 = { Medical: 1 } }
                        if (value.PageName == "Expense") { $scope.rec52 = { Expense: 1 } }
                        if (value.PageName == "Payment") { $scope.rec53 = { Payment: 1 } }
                        if (value.PageName == "SChecklist") { $scope.rec54 = { SChecklist: 1 } }
                        if (value.PageName == "ChemicalRequest") { $scope.rec55 = { ChemicalRequest: 1 } }
                        if (value.PageName == "ProcurementSettings") { $scope.rec56 = { ProcurementSettings: 1 } }
                        if (value.PageName == "Treatment") { $scope.rec57 = { Treatment: 1 } }
                        if (value.PageName == "Feedback") { $scope.rec58 = { Feedback: 1 } }
                        if (value.PageName == "OperationsReport") { $scope.rec59 = { OperationsReport: 1 } }
                        if (value.PageName == "ChemicalRequest") { $scope.rec61 = { ChemicalRequest: 1 } }

                    }
                });
            });
            RefreshAttachmentGrid(item.id);
        }

        $scope.AllowExport = { value: false, };
        $scope.checkboxModel = { value: false, };
        $scope.IsAdmin = { value: false, };
        $scope.DManagement = { value: false, };
        $scope.DHuman = { value: false, };
        $scope.DProcurement = { value: false, };
        $scope.AcCustomer = { value: false, };
        $scope.AcCustomer = { value: false, };
        $scope.AcScheduler = { value: false, };
        $scope.AcPestOff = { value: false, };
        $scope.AcDScheduler = { value: false, };
        $scope.DCRM = { value: false, };
        $scope.DOperations = { value: false, };
        $scope.CashCheque = { value: false, };
        $scope.LeaveR = { value: false, };
        $scope.MaterialR = { value: false, };
        $scope.AcLumiair = { value: false, };
        $scope.Incident = { value: false, };
        $scope.Medical = { value: false, };
        $scope.Expense = { value: false, };
        $scope.Payment = { value: false, }
        $scope.Insurance = { value: false, }
        $scope.Division = { value: false, }
        $scope.ELeaves = { value: false, }
        $scope.Hrmusers = { value: false, }
        $scope.SChecklist = { value: false, }
        $scope.ChemicalRequest = { value: false, }
        $scope.ProcurementSettings = { value: false, }
        $scope.Treatment = { value: false, }
        $scope.Users = { value: false, };
        $scope.Client = { value: false, };
        $scope.HRMAdmin = { value: false, };
        $scope.HRMCore = { value: false, };
        $scope.Products = { value: false, };
        $scope.Supliers = { value: false, };
        $scope.PestType = { value: false, };
        $scope.Services = { value: false, };
        $scope.Customers = { value: false, };
        $scope.Timelog = { value: false, };
        $scope.Recruitment = { value: false, };
        $scope.Training = { value: false, };
        $scope.CrmSettings = { value: false, }
        $scope.Lead = { value: false, }
        $scope.Quotation = { value: false, }
        $scope.WorkOrder = { value: false, }
        $scope.Stores = { value: false, }
        $scope.Contracts = { value: false, }
        $scope.EquipmentRequest = { value: false, }
        $scope.PurchaseOrder = { value: false, }
        $scope.StockManagement = { value: false, }
        $scope.Requests = { value: false, }
        $scope.Invoice = { value: false, }
        $scope.Ledger = { value: false, }
        $scope.BankCash = { value: false, }
        $scope.AccountsWorkOrder = { value: false, }
        $scope.SalesReceivables = { value: false, }
        $scope.Asset = { value: false, }
        $scope.Uniform = { value: false, }
        $scope.Workflow = { value: false, }
        $scope.EmailAlerts = { value: false, }
        $scope.Teams = { value: false, }
        $scope.Scheduler = { value: false, }
        $scope.Vehicle = { value: false, }
        $scope.Health = { value: false, }
        $scope.UniformR = { value: false, }
        $scope.Feedback = { value: false, }
        $scope.OperationsReport = { value: false, }
        $scope.ChemicalRequest = { value: false, }
        $scope.formData = {};

        function pageSubmit(UserID) {
            $scope.CurrentID = UserID;
            var pages = [];
            try {
                if ($scope.Users.value == true) { pages.push({ PageName: "Users", }) }
                if ($scope.Client.value == true) { pages.push({ PageName: "Client", }) }
                if ($scope.HRMAdmin.value == true) { pages.push({ PageName: "HRMAdmin", }) }
                if ($scope.HRMCore.value == true) { pages.push({ PageName: "HRMCore", }) }
                if ($scope.Timelog.value == true) { pages.push({ PageName: "Timelog", }) }
                if ($scope.Recruitment.value == true) { pages.push({ PageName: "Recruitment", }) }
                if ($scope.Training.value == true) { pages.push({ PageName: "Training", }) }
                if ($scope.Products.value == true) { pages.push({ PageName: "Products", }) }
                if ($scope.Supliers.value == true) { pages.push({ PageName: "Supliers", }) }
                if ($scope.PestType.value == true) { pages.push({ PageName: "PestType", }) }
                if ($scope.Services.value == true) { pages.push({ PageName: "Services", }) }
                if ($scope.Customers.value == true) { pages.push({ PageName: "Customers", }) }

                if ($scope.CrmSettings.value == true) { pages.push({ PageName: "CrmSettings", }) }
                if ($scope.Lead.value == true) { pages.push({ PageName: "Lead", }) }
                if ($scope.Quotation.value == true) { pages.push({ PageName: "Quotation", }) }
                if ($scope.WorkOrder.value == true) { pages.push({ PageName: "WorkOrder", }) }
                if ($scope.Stores.value == true) { pages.push({ PageName: "Stores", }) }
                if ($scope.Contracts.value == true) { pages.push({ PageName: "Contracts", }) }
                if ($scope.EquipmentRequest.value == true) { pages.push({ PageName: "EquipmentRequest", }) }
                if ($scope.PurchaseOrder.value == true) { pages.push({ PageName: "PurchaseOrder", }) }
                if ($scope.StockManagement.value == true) { pages.push({ PageName: "StockManagement", }) }
                if ($scope.Requests.value == true) { pages.push({ PageName: "Requests", }) }
                if ($scope.Invoice.value == true) { pages.push({ PageName: "Invoice", }) }
                if ($scope.Ledger.value == true) { pages.push({ PageName: "Ledger", }) }
                if ($scope.BankCash.value == true) { pages.push({ PageName: "BankCash", }) }
                if ($scope.AccountsWorkOrder.value == true) { pages.push({ PageName: "AccountsWorkOrder", }) }
                if ($scope.SalesReceivables.value == true) { pages.push({ PageName: "SalesReceivables", }) }
                if ($scope.Asset.value == true) { pages.push({ PageName: "Asset", }) }
                if ($scope.Uniform.value == true) { pages.push({ PageName: "Uniform", }) }
                if ($scope.Workflow.value == true) { pages.push({ PageName: "Workflow", }) }
                if ($scope.EmailAlerts.value == true) { pages.push({ PageName: "EmailAlerts", }) }
                if ($scope.Teams.value == true) { pages.push({ PageName: "Teams", }) }
                if ($scope.Scheduler.value == true) { pages.push({ PageName: "Scheduler", }) }
                if ($scope.Vehicle.value == true) { pages.push({ PageName: "Vehicle", }) }
                if ($scope.Health.value == true) { pages.push({ PageName: "Health", }) }

                if ($scope.DManagement.value == true) { pages.push({ PageName: "DManagement", }) }
                if ($scope.DHuman.value == true) { pages.push({ PageName: "DHuman", }) }
                if ($scope.DProcurement.value == true) { pages.push({ PageName: "DProcurement", }) }
                if ($scope.AcCustomer.value == true) { pages.push({ PageName: "AcCustomer", }) }
                if ($scope.AcScheduler.value == true) { pages.push({ PageName: "AcScheduler", }) }
                if ($scope.AcPestOff.value == true) { pages.push({ PageName: "AcPestOff", }) }
                if ($scope.AcDScheduler.value == true) { pages.push({ PageName: "AcDScheduler", }) }
                if ($scope.AcContract.value == true) { pages.push({ PageName: "AcContract", }) }
                if ($scope.DCRM.value == true) { pages.push({ PageName: "DCRM", }) }
                if ($scope.DOperations.value == true) { pages.push({ PageName: "DOperations", }) }
                if ($scope.CashCheque.value == true) { pages.push({ PageName: "CashCheque", }) }
                if ($scope.LeaveR.value == true) { pages.push({ PageName: "LeaveR", }) }
                if ($scope.MaterialR.value == true) { pages.push({ PageName: "MaterialR", }) }
                if ($scope.AcLumiair.value == true) { pages.push({ PageName: "AcLumiair", }) }
                if ($scope.UniformR.value == true) { pages.push({ PageName: "UniformR", }) }
                if ($scope.Incident.value == true) { pages.push({ PageName: "Incident", }) }
                if ($scope.Medical.value == true) { pages.push({ PageName: "Medical", }) }
                if ($scope.Expense.value == true) { pages.push({ PageName: "Expense", }) }
                if ($scope.Payment.value == true) { pages.push({ PageName: "Payment", }) }
                if ($scope.Insurance.value == true) { pages.push({ PageName: "Insurance", }) }
                if ($scope.ELeaves.value == true) { pages.push({ PageName: "ELeaves", }) }
                if ($scope.Hrmusers.value == true) { pages.push({ PageName: "Hrmusers", }) }
                if ($scope.Division.value == true) { pages.push({ PageName: "Division", }) }
                if ($scope.SChecklist.value == true) { pages.push({ PageName: "SChecklist", }) }
                if ($scope.ChemicalRequest.value == true) { pages.push({ PageName: "ChemicalRequest", }) }
                if ($scope.ProcurementSettings.value == true) { pages.push({ PageName: "ProcurementSettings", }) }
                if ($scope.Treatment.value == true) { pages.push({ PageName: "Treatment", }) }
                if ($scope.Feedback.value == true) { pages.push({ PageName: "Feedback", }) }
                if ($scope.OperationsReport.value == true) { pages.push({ PageName: "OperationsReport", }) }
                if ($scope.ChemicalRequest.value == true) { pages.push({ PageName: "ChemicalRequest", }) }

            }
            catch (error) {
            }
            if ($scope.Update == true) {
                var deleteresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/pagedb/delete",
                    data: {
                        UserID: $scope.CurrentID,
                    },
                });
                deleteresponse.then(function (List) {
                    if (pages.length == 0) {
                        RefreshGrid();
                        $scope.vm.PreviewSpinner = false;
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated !').position('top center'));
                        $scope.Usergrid = true;
                        $scope.Userform = false;
                        $scope.Pageform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                    else {
                        for (var r = 0; r < pages.length; r++) {
                            $scope.uPages = pages[r].PageName;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/pagedb/add",
                                data: {
                                    UserID: $scope.SID,
                                    PageName: $scope.uPages,
                                    client_id: $scope.uClientID
                                },
                            });
                        }
                        response.then(function (GList) {
                            RefreshGrid();
                            $scope.vm.PreviewSpinner = false;
                            $mdToast.show($mdToast.simple().textContent('Successfully Updated !').position('top center'));
                            $scope.Usergrid = true;
                            $scope.Userform = false;
                            $scope.Pageform = false;
                            $scope.Export = true;
                            $scope.Add = true;
                            $scope.view = false;
                            $scope.Search = true;
                        }, function () {
                            $scope.vm.PreviewSpinner = false;
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                });
            }
            else {
                if (pages.length == 0) {
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added !').position('top center'));
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }
                for (var r = 0; r < pages.length; r++) {
                    $scope.uPages = pages[r].PageName;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/pagedb/add",
                        data: {
                            UserID: $scope.CurrentID,
                            PageName: $scope.uPages,
                            client_id: $scope.uClientID

                        },
                    });
                }
                response.then(function (GList) {
                    RefreshGrid();
                    $scope.vm.PreviewSpinner = false;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added !').position('top center'));
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }, function () {
                    $scope.vm.PreviewSpinner = false;
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            var file = angular.element(document.querySelector('#fileInput'))[0].files;
            if (file.length != 0 && file.length != undefined) {
                var files = [];
                files.push({ file: file[0] })
                $scope.Uploadfiles(files, UserID)
            }
        }
        $scope.sSubmit = function () {
            $scope.vm.PreviewSpinner = true;
            // if ($scope.Securitydiv == false || $scope.Securitydiv == undefined) {
            //     $scope.Users = { value: false };
            //     $scope.Client = { value: false };
            //     $scope.Workflow = { value: false };
            // }
            // if ($scope.Humandiv == false || $scope.Humandiv == undefined) {
            //     $scope.DHuman = { value: false };
            //     $scope.HRMAdmin = { value: false };
            //     $scope.HRMCore = { value: false };
            //     $scope.Timelog = { value: false };
            //     $scope.Recruitment = { value: false };
            //     $scope.Training = { value: false };
            //     $scope.Health = { value: false };
            //     $scope.Insurance = { value: false };
            //     $scope.ELeaves = { value: false };
            //     $scope.Hrmusers = { value: false };
            // }
            // if ($scope.Procurementdiv == false || $scope.Procurementdiv == undefined) {
            //     $scope.DProcurement = { value: false };
            //     $scope.Stores = { value: false };
            //     $scope.Vehicle = { value: false };
            //     $scope.PurchaseOrder = { value: false };
            //     $scope.StockManagement = { value: false };
            //     $scope.Requests = { value: false };
            //     $scope.Products = { value: false };
            //     $scope.Supliers = { value: false };
            //     $scope.Uniform = { value: false };
            // }
            // if ($scope.Operationsdiv == false || $scope.Operationsdiv == undefined) {
            //     $scope.DOperations = { value: false };
            //     $scope.Services = { value: false };
            //     $scope.EmailAlerts = { value: false };
            //     $scope.Teams = { value: false };
            //     $scope.Scheduler = { value: false };
            //     $scope.SChecklist = { value: false, }
            //     $scope.Division = { value: false };
            //     $scope.ProcurementSettings = { value: false };
            //     $scope.Treatment = { value: false };
            //     $scope.Feedback = { value: false };
            //     $scope.OperationsReport = { value: false };
            // }
            // if ($scope.RequstForm == false|| $scope.RequstForm == undefined) {
            //     $scope.LeaveR = { value: false };
            //     $scope.Incident = { value: false };
            //     $scope.Medical = { value: false };
            //     $scope.Expense = { value: false };
            // }
            // if ($scope.Salediv == false || $scope.Salediv == undefined) {
            //     $scope.DCRM = { value: false };
            //     $scope.Customers = { value: false };
            //     $scope.CrmSettings = { value: false };
            //     $scope.Lead = { value: false };
            //     $scope.Quotation = { value: false };
            //     $scope.WorkOrder = { value: false };
            //     $scope.Contracts = { value: false };
            //     $scope.ChemicalRequest = { value: false };
            //     $scope.PestType = { value: false };
            //     $scope.EquipmentRequest = { value: false };
            // }
            // if ($scope.Accountsdiv == false || $scope.Accountsdiv == undefined) {
            //     $scope.CashCheque = { value: false };
            //     $scope.Invoice = { value: false };
            //     $scope.Ledger = { value: false };
            //     $scope.BankCash = { value: false };
            //     $scope.AccountsWorkOrder = { value: false };
            //     $scope.SalesReceivables = { value: false };
            //     $scope.Asset = { value: false };
            // }
            if ($scope.checkboxModel.value == true) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/email",
                    data: {
                        SenderEmailAddress: $scope.formData.uEmail,
                        UserName: $scope.formData.uUserName,
                        UserID: $scope.formData.uLoginID,
                        Password: $scope.formData.uPassword,
                    },
                });
            }
            try {
                var item = $scope.Clientdatas.filter(function (item) {
                    return item._id === $scope.uClientID;
                })[0];
                $scope.uClientName = item.ClientName;
            }
            catch (e) { }
            $scope.uRoles = $scope.formData.selectedRole;
            if ($scope.Update == true) {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/user/update",
                    data: {
                        _id: $scope.SID, UserID: $scope.formData.uLoginID, Email: $scope.formData.uEmail, UserName: $scope.formData.uUserName,
                        MobileNumber: $scope.formData.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: $scope.RoleLength, ExpiryDate: $scope.formData.uExpiryDate,
                        Password: $scope.formData.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked,
                        ClientID: $scope.uClientID, EmployeeID: $scope.uEmployeeID,
                        ClientName: $scope.uClientName, AllowExport: $scope.AllowExport.value, IsAdmin: $scope.IsAdmin.value,
                        UpdatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/userrole/delete",
                        data: {
                            UserID: $scope.SID,
                        },
                    }).then(function (result) {
                        var roles = $scope.uRoles;
                        for (var i = 0; i < roles.length; i++) {
                            $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/userrole/add",
                                data: {
                                    UserID: $scope.SID,
                                    RoleID: roles[i].RoleID,
                                },
                            }).then(function (result) {
                            })
                        }
                    })
                    $scope.CurrentID = $scope.SID;
                    pageSubmit($scope.CurrentID);
                }, function () {
                    $scope.vm.PreviewSpinner = false;
                });
            }
            else {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/add",
                    data: {
                        UserID: $scope.formData.uLoginID, Email: $scope.formData.uEmail, UserName: $scope.formData.uUserName,
                        MobileNumber: $scope.formData.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: $scope.RoleLength,
                        ExpiryDate: $scope.formData.uExpiryDate, Password: $scope.formData.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, CreatedBy: $rootScope.createdby,
                        ClientID: $scope.uClientID, EmployeeID: $scope.uEmployeeID, AllowExport: $scope.AllowExport.value, IsAdmin: $scope.IsAdmin.value,
                        ClientName: $scope.uClientName,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing UserID") {
                        $scope.error1 = true;
                        $scope.vm.PreviewSpinner = false;
                        $scope.Userform = true;
                        $scope.Usergrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else { //
                    }
                    $scope.CurrentID = GList.data.data.id;
                    $scope.vm.PreviewSpinner = false;
                    var roles = $scope.uRoles;
                    for (var r = 0; r < roles.length; r++) {
                        $scope.uRoles = roles[r].RoleID;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/userrole/add",
                            data: {
                                UserID: $scope.CurrentID,
                                RoleID: $scope.uRoles,
                            },
                        });
                    }
                    pageSubmit($scope.CurrentID);

                }, function () {
                    $scope.vm.PreviewSpinner = false;
                });
            }
        }
        $scope.getdisabled = function (val) {
            if (val == true) { $scope.vm.chkbox = "yes" }
            else { $scope.vm.chkbox = null; }

            if ($scope.Security.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Human.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Procurement.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Operations.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.CRManagement.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Accounts.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Management.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Tablet.value == true) { $scope.vm.chkbox = "yes" }
        }
        $scope.Security = { value: false, };
        $scope.Human = { value: false, };
        $scope.Procurement = { value: false, };
        $scope.Operations = { value: false, };
        $scope.CRManagement = { value: false, };
        $scope.Accounts = { value: false, };
        $scope.Management = { value: false, };
        $scope.Tablet = { value: false, };
        $scope.RolesSubmit = function () {
            var modules = [];
            if ($scope.Security.value == true) { modules.push({ ModuleName: "Security", }) }
            if ($scope.Human.value == true) { modules.push({ ModuleName: "Human Resource", }) }
            if ($scope.Procurement.value == true) { modules.push({ ModuleName: "Procurement", }) }
            if ($scope.Operations.value == true) { modules.push({ ModuleName: "Operations", }) }
            if ($scope.CRManagement.value == true) { modules.push({ ModuleName: "Customer Relationship", }) }
            if ($scope.Accounts.value == true) { modules.push({ ModuleName: "Accounts", }) }
            if ($scope.Management.value == true) { modules.push({ ModuleName: "Management", }) }
            if ($scope.Tablet.value == true) { modules.push({ ModuleName: "Tablet", }) }
            $scope.umodule = modules;
            var roleinfo = $scope.Roledatas;
            for (var i = 0; i <= roleinfo.length; i++) {
                $scope.vm.uNewroleID = i + 1;
            }
            if ($scope.moduleupdate == true) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/usermodel/delete",
                    data: {
                        UserID: $scope.vm.uNewrole,
                    },
                });
                response.then(function (GList) {
                    var modules = $scope.umodule;
                    for (var i = 0; i < modules.length; i++) {
                        var Roleresponse = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/usermodel/add",
                            data: {
                                UserID: $scope.vm.uNewrole,
                                ModelID: modules[i].ModuleName,
                            },
                        });
                    }
                    Roleresponse.then(function (GList) {
                        $scope.moduleupdate = false;
                        $scope.vm.uNewrole = null;
                        $scope.Security = { value: false, };
                        $scope.Human = { value: false, };
                        $scope.Procurement = { value: false, };
                        $scope.Operations = { value: false, };
                        $scope.CRManagement = { value: false, };
                        $scope.Accounts = { value: false, };
                        $scope.Management = { value: false, };
                        $scope.Tablet = { value: false, };
                        $http.get($rootScope.WebURL + "/role")
                            .then(function (Roledata) {
                                $scope.Roledatas = Roledata.data.data;
                            });
                        $http.get($rootScope.WebURL + "/usermodel")
                            .then(function (userModulesdata) {
                                $scope.userModulesdatas = userModulesdata.data.data;
                            });
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/role/add",
                    data: {
                        RoleName: $scope.vm.uNewrole,
                        RoleID: $scope.vm.uNewroleID,
                        Description: $scope.vm.uDescription,
                        createdBy: "System",
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing RoleName") {
                        $mdToast.show($mdToast.simple().textContent('Role Name Exist!').position('top center'));
                    }
                    else {
                        var modules = $scope.umodule;
                        for (var i = 0; i < modules.length; i++) {
                            var Roleresponse = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/usermodel/add",
                                data: {
                                    UserID: $scope.vm.uNewrole,
                                    ModelID: modules[i].ModuleName,
                                },
                            });
                        }
                        Roleresponse.then(function (GList) {
                            $scope.moduleupdate = false;
                            $scope.vm.uNewrole = null;
                            $scope.Security = { value: false, };
                            $scope.Human = { value: false, };
                            $scope.Procurement = { value: false, };
                            $scope.Operations = { value: false, };
                            $scope.CRManagement = { value: false, };
                            $scope.Accounts = { value: false, };
                            $scope.Management = { value: false, };
                            $scope.Tablet = { value: false, };
                            $http.get($rootScope.WebURL + "/role")
                                .then(function (Roledata) {
                                    $scope.Roledatas = Roledata.data.data;
                                });
                            $http.get($rootScope.WebURL + "/usermodel")
                                .then(function (userModulesdata) {
                                    $scope.userModulesdatas = userModulesdata.data.data;
                                });
                            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        });
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Showgrid = function (ischanged) {
            $scope.Usergrid = true;
            $scope.Userform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
            $scope.error1 = false;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { WorkOrder: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { EquipmentRequest: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Invoice: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { AccountsWorkOrder: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { EmailAlerts: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { AcCustomer: 0 }
            $scope.rec41 = { AcContract: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { ELeaves: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { AcScheduler: 0 }
            $scope.rec46 = { AcDScheduler: 0 }
            $scope.rec47 = { AcPestOff: 0 }
            $scope.rec48 = { AcLumiair: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { ChemicalRequest: 0 }
            $scope.rec56 = { ProcurementSettings: 0 }
            $scope.rec57 = { Treatment: 0 }
            $scope.rec58 = { Feedback: 0 }
            $scope.rec59 = { OperationsReport: 0 }
            $scope.rec61 = { ChemicalRequest: 0 }
            $scope.checkboxModel = { value: false, };
            $scope.IsAdmin = { value: false, };
            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.AcCustomer = { value: false, };
            $scope.AcScheduler = { value: false, };
            $scope.AcPestOff = { value: false, };
            $scope.AcDScheduler = { value: false, };
            $scope.AcContract = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.CashCheque = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.AcLumiair = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.ELeaves = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.ProcurementSettings = { value: false, }
            $scope.ChemicalRequest = { value: false, }
            $scope.Treatment = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.WorkOrder = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.EquipmentRequest = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Invoice = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.AccountsWorkOrder = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.EmailAlerts = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }
            $scope.UniformR = { value: false, }
            $scope.ChemicalRequest = { value: false, };

            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.DashBoarddiv = false;
            $scope.RequstForm = false;
        }
        $scope.Rolesadd = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/user/addroles.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function userProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.Security = { value: false, };
            $scope.Human = { value: false, };
            $scope.Procurement = { value: false, };
            $scope.Operations = { value: false, };
            $scope.CRManagement = { value: false, };
            $scope.Accounts = { value: false, };
            $scope.Management = { value: false, };
            $scope.Tablet = { value: false, };
            $scope.ret1 = { Security: 0, };
            $scope.ret2 = { Human: 0, };
            $scope.ret3 = { Procurement: 0, };
            $scope.ret4 = { Operations: 0, };
            $scope.ret5 = { CRManagement: 0, };
            $scope.ret6 = { Accounts: 0, };
            $scope.ret7 = { Management: 0, };
            $scope.ret8 = { Tablet: 0, };
            $scope.moduleupdate = false;
            $scope.rolereadonly = false;
        }
        $scope.rolebased = function (selected) {
            if (selected == undefined || selected == null) {
                $scope.Pageform = false;
                $scope.Securitydiv = false;
                $scope.Humandiv = false;
                $scope.Procurementdiv = false;
                $scope.Operationsdiv = false;
                $scope.Salediv = false;
                $scope.Accountsdiv = false;
                $scope.RequstForm = false;

                $scope.DManagement = { value: false, };
                $scope.DHuman = { value: false, };
                $scope.AcCustomer = { value: false, };
                $scope.AcScheduler = { value: false, };
                $scope.AcPestOff = { value: false, };
                $scope.AcDScheduler = { value: false, };
                $scope.AcContract = { value: false, };
                $scope.DProcurement = { value: false, };
                $scope.DCRM = { value: false, };
                $scope.DOperations = { value: false, };
                $scope.CashCheque = { value: false, };
                $scope.LeaveR = { value: false, };
                $scope.MaterialR = { value: false, };
                $scope.AcLumiair = { value: false, };
                $scope.Incident = { value: false, };
                $scope.Medical = { value: false, };
                $scope.Expense = { value: false, };
                $scope.Payment = { value: false, }
                $scope.Insurance = { value: false, }
                $scope.Division = { value: false, }
                $scope.ELeaves = { value: false, }
                $scope.Hrmusers = { value: false, }
                $scope.SChecklist = { value: false, }
                $scope.ProcurementSettings = { value: false, }
                $scope.ChemicalRequest = { value: false, }
                $scope.Treatment = { value: false, }
                $scope.Feedback = { value: false, }
                $scope.OperationsReport = { value: false, }
                $scope.ChemicalRequest = { value: false, }
                $scope.Users = { value: false, };
                $scope.Client = { value: false, };
                $scope.HRMAdmin = { value: false, };
                $scope.HRMCore = { value: false, };
                $scope.Products = { value: false, };
                $scope.Supliers = { value: false, };
                $scope.PestType = { value: false, };
                $scope.Services = { value: false, };
                $scope.Customers = { value: false, };
                $scope.Timelog = { value: false, };
                $scope.Recruitment = { value: false, };
                $scope.Training = { value: false, };
                $scope.CrmSettings = { value: false, }
                $scope.Lead = { value: false, }
                $scope.Quotation = { value: false, }
                $scope.WorkOrder = { value: false, }
                $scope.Stores = { value: false, }
                $scope.Contracts = { value: false, }
                $scope.EquipmentRequest = { value: false, }
                $scope.PurchaseOrder = { value: false, }
                $scope.StockManagement = { value: false, }
                $scope.Requests = { value: false, }
                $scope.Invoice = { value: false, }
                $scope.Ledger = { value: false, }
                $scope.BankCash = { value: false, }
                $scope.AccountsWorkOrder = { value: false, }
                $scope.SalesReceivables = { value: false, }
                $scope.Asset = { value: false, }
                $scope.Uniform = { value: false, }
                $scope.Workflow = { value: false, }
                $scope.EmailAlerts = { value: false, }
                $scope.Teams = { value: false, }
                $scope.Scheduler = { value: false, }
                $scope.Vehicle = { value: false, }
                $scope.Health = { value: false, }
                $scope.UniformR = { value: false, }
                $scope.RoleLength = []
                return
            }
            $scope.Pageform = true;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.RequstForm = false;
            var Moduleselect = [];
            angular.forEach($scope.userModulesdatas, function (umvalue) {
                angular.forEach(selected, function (rvalue) {
                    if (rvalue.RoleName == umvalue.UserID) {
                        Moduleselect.push({
                            ModuleName: umvalue.ModelID,
                        })
                    }
                });
            });
            $scope.RoleLength = []
            if (selected != undefined) {
                var mtr = selected.map(function (obj) { if (obj.RoleName != "") return obj.RoleName; }).join(', ');
                $scope.RoleLength = mtr
                if (mtr.length > 0) {
                    if (mtr.split(",").includes("Security")) {
                        $scope.Securitydiv = true;
                    }
                    if (mtr.indexOf("Human Resource") > -1) {
                        $scope.Humandiv = true;
                    }
                    if (mtr.split(",").includes("Procurement")) {
                        $scope.Procurementdiv = true;
                    }
                    if (mtr.split(",").includes("Operations")) {
                        $scope.Operationsdiv = true;
                    }
                    if (mtr.indexOf("Customer Relationship") > -1) {
                        $scope.Salediv = true;
                    }
                    if (mtr.split(",").includes("Accounts")) {
                        $scope.Accountsdiv = true;
                    }
                    if (mtr.indexOf("Request Forms") > -1) {
                        $scope.RequstForm = true;
                    }

                }
            }
            //     });
            // });
            if ($scope.Securitydiv == false || $scope.Securitydiv == undefined) {
                $scope.Users = { value: false };
                $scope.Client = { value: false };
                $scope.Workflow = { value: false };
            }
            if ($scope.Humandiv == false || $scope.Humandiv == undefined) {
                $scope.DHuman = { value: false };
                $scope.HRMAdmin = { value: false };
                $scope.HRMCore = { value: false };
                $scope.Timelog = { value: false };
                $scope.Recruitment = { value: false };
                $scope.Training = { value: false };
                $scope.Health = { value: false };
                $scope.Insurance = { value: false };
                $scope.ELeaves = { value: false };
                $scope.Hrmusers = { value: false };
            }
            if ($scope.Procurementdiv == false || $scope.Procurementdiv == undefined) {
                $scope.DProcurement = { value: false };
                $scope.Stores = { value: false };
                $scope.Vehicle = { value: false };
                $scope.PurchaseOrder = { value: false };
                $scope.StockManagement = { value: false };
                $scope.Requests = { value: false };
                $scope.Products = { value: false };
                $scope.Supliers = { value: false };
                $scope.Uniform = { value: false };
            }
            if ($scope.Operationsdiv == false || $scope.Operationsdiv == undefined) {
                $scope.DOperations = { value: false };
                $scope.Services = { value: false };
                $scope.EmailAlerts = { value: false };
                $scope.Teams = { value: false };
                $scope.Scheduler = { value: false };
                $scope.SChecklist = { value: false, }
                $scope.Division = { value: false };
                $scope.ProcurementSettings = { value: false };
                $scope.Treatment = { value: false };
                $scope.Feedback = { value: false };
                $scope.OperationsReport = { value: false };

            }
            if ($scope.Salediv == false || $scope.Salediv == undefined) {
                $scope.DCRM = { value: false };
                $scope.Customers = { value: false };
                $scope.CrmSettings = { value: false };
                $scope.Lead = { value: false };
                $scope.Quotation = { value: false };
                $scope.WorkOrder = { value: false };
                $scope.Contracts = { value: false };
                $scope.ChemicalRequest = { value: false };
                $scope.PestType = { value: false };
                $scope.EquipmentRequest = { value: false };
            }
            if ($scope.Accountsdiv == false || $scope.Accountsdiv == undefined) {
                $scope.CashCheque = { value: false };
                $scope.Invoice = { value: false };
                $scope.Ledger = { value: false };
                $scope.BankCash = { value: false };
                $scope.AccountsWorkOrder = { value: false };
                $scope.SalesReceivables = { value: false };
                $scope.Asset = { value: false };
            }
        }
        $scope.Moduleedit = function (module) {
            $scope.moduleupdate = true;
            $scope.vm.uNewrole = module;
            $scope.rolereadonly = true;
            $scope.ret1 = { Security: 0 }
            $scope.ret2 = { Human: 0 }
            $scope.ret3 = { Procurement: 0 }
            $scope.ret4 = { Operations: 0 }
            $scope.ret5 = { CRManagement: 0 }
            $scope.ret6 = { Accounts: 0 }
            $scope.ret7 = { Management: 0 }
            $scope.ret8 = { Tablet: 0 }
            var mselected = module
            var Moduleselect = [];
            angular.forEach($scope.Roledatas, function (value) {
                if (module == value.RoleName) {
                    $scope.vm.uDescription = value.Description;
                }
            })
            angular.forEach($scope.userModulesdatas, function (mvalue) {
                if (mselected == mvalue.UserID) {
                    Moduleselect.push({
                        ModuleName: mvalue.ModelID,
                    })
                }
            })
            var mtr = Moduleselect.map(function (obj) { return obj.ModuleName; }).join(', ');
            if (mtr.split(",").includes("Security")) {
                $scope.ret1 = { Security: 1 }
            }
            if (mtr.indexOf("Human Resource") > -1) {
                $scope.ret2 = { Human: 1 }
            }
            if (mtr.split(",").includes("Procurement")) {
                $scope.ret3 = { Procurement: 1 }
            }
            if (mtr.split(",").includes("Operations")) {
                $scope.ret4 = { Operations: 1 }
            }
            if (mtr.indexOf("Customer Relationship") > -1) {
                $scope.ret5 = { CRManagement: 1 }
            }
            if (mtr.split(",").includes("Accounts")) {
                $scope.ret6 = { Accounts: 1 }
            }
            if (mtr.split(",").includes("Management")) {
                $scope.ret7 = { Management: 1 }
            }
            if (mtr.split(",").includes("Tablet")) {
                $scope.ret8 = { Tablet: 1 }
            }
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.sAdd = function () {
            ClearForm();
            $scope.RoleLength = []
            $scope.Update = false;
            $scope.FilePath = null;
            $scope.fileName = null;
            angular.element(document.querySelector('#fileInput'))[0] = [];
            $scope.Userform = true;
            $scope.Usergrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.error1 = false;
            $scope.AllowExport = { value: false, };
            $scope.IsAdmin = { value: false, };
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Pageform = false;
            $scope.Search = false;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { WorkOrder: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { EquipmentRequest: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Invoice: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { AccountsWorkOrder: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { EmailAlerts: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec41 = { AcContract: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { ELeaves: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { AcScheduler: 0 }
            $scope.rec46 = { AcDScheduler: 0 }
            $scope.rec47 = { AcPestOff: 0 }
            $scope.rec48 = { AcLumiair: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec61 = { ChemicalRequest: 0 }

            $scope.formData.uExpiryDate = new Date(
                new Date().getFullYear() + 5,
                0,
                1
            );
            angular.forEach($scope.Clientdatas, function (value, key) {
                if (value.Primary == "Yes") {
                    $scope.uClientID = value.id;
                    $scope.getEmployees(value.id);
                }

            });
        }
        $scope.alertcancel = function () {
            RefreshGrid();
            $scope.Usergrid = true;
            $scope.Userform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
            $mdDialog.cancel();

        }

        function showDialog(UserId) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/user/alertuser.html',
                parent: angular.element($document.body),
                targetEvent: UserId,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function userProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }

            });
            $scope.UserId = UserId;
        }

        $scope.Actsubmit = function (UserId) {
            fetchData(UserId);
            $scope.IsActive = false;
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/user/update",
                data: {
                    _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                    Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                    IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $scope.uClientID, ClientName: $scope.uClientName, AllowExport: $scope.AllowExport, IsAdmin: $scope.IsAdmin
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;


            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.chkIsActive = function (UserId, check) {
            var Isactivemodel = check;
            if (Isactivemodel == true) {
                fetchData(UserId);
                $scope.IsActive = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/user/update",
                    data: {
                        _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $scope.uClientID, AllowExport: $scope.AllowExport, IsAdmin: $scope.IsAdmin,
                        EmployeeID: $scope.uEmployeeID,
                        ClientName: $scope.uClientName,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            if (Isactivemodel == false) {
                showDialog(UserId);
            }

        }
        $scope.chkIsLocked = function (UserId, check) {
            fetchData(UserId);
            var Islockmodel = check;
            if (Islockmodel == true) {
                $scope.IsLocked = true;
            }
            if (Islockmodel == false) {
                $scope.IsLocked = false;
            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/user/update",
                data: {
                    _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                    Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                    IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $scope.uClientID, EmployeeID: $scope.uEmployeeID,
                    ClientName: $scope.uClientName, AllowExport: $scope.AllowExport, IsAdmin: $scope.IsAdmin
                },

            });

            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                RefreshGrid();
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Uploadfiles = function (file, UserID) {
            var upfile = file[0].file;
            var response = Upload.upload({
                url: $rootScope.WebURL + "/user/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/deleteByFileID",
                        data: { FileID: UserID },
                    }).then(function (GList) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "Users",
                                FileID: UserID,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response.then(function (GList) {
                            $scope.fileName = null;
                        });
                    });
                }
            });
        }

        function RefreshAttachmentGrid(_id) {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: _id },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
                $scope.FilePath = null;
                try {
                    $scope.FilePath = $rootScope.UploadsURL + 'Security/Users/' + $scope.Attachmentdatas[0].TableID;
                    $scope.fileName = null;
                } catch (e) {
                    $scope.FilePath = null;
                }
            });
        }
        $scope.Roledatas = [
            { id: 1, RoleName: 'Request Forms', value: 'Request Forms' },
            { id: 2, RoleName: 'Security', value: 'Security' },
            { id: 3, RoleName: 'Human Resource', value: 'Human Resource' },
            { id: 4, RoleName: 'Customer Relationship', value: 'Customer Relationship' },
            { id: 5, RoleName: 'Operations', value: 'Operations' },
            { id: 6, RoleName: 'Accounts', value: 'Accounts' },
            { id: 7, RoleName: 'Tablet', value: 'Tablet' }
        ]
        $http.get($rootScope.WebURL + "/userrole")
            .then(function (Userroledata) {
                $scope.Userroledatas = Userroledata.data.data;
            });
        // $http.get( $rootScope.WebURL + "/role")
        //   .then(function (Roledata) {
        //       $scope.Roledatas = Roledata.data.data;
        //   });
        $http.get($rootScope.WebURL + "/client/getForPage")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
            });
        $http.get($rootScope.WebURL + "/usermodel")
            .then(function (userModulesdata) {
                $scope.userModulesdatas = userModulesdata.data.data;
            });
        $http.get($rootScope.WebURL + "/workflow/get")
            .then(function (workflowUserdata) {
                $scope.Workflowdatas = workflowUserdata.data.data;
            });
        $http.get($rootScope.WebURL + "/user/getForPage")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });
        $http.get($rootScope.WebURL + "/login/usersession")
            .then(function (usersessiondata) {
                $scope.Usersessiondatadatas = usersessiondata.data.data;
                UserSummary();
            });
        $http.get($rootScope.WebURL + "/pagedb")
            .then(function (Pagedata) {
                $scope.Pagedatas = Pagedata.data.data;
            });

        function UserSummary() {
            var Users = [];
            var st = '';
            try {
                angular.forEach($scope.Userdatas, function (value) {
                    var Roleselect = [];
                    angular.forEach($scope.Userroledatas, function (urvalue) {
                        angular.forEach($scope.Roledatas, function (rvalue) {
                            if (value.id == urvalue.UserID && urvalue.RoleID == rvalue.RoleID) {
                                if (Roleselect.indexOf(rvalue.RoleName) == -1) {
                                    Roleselect.push(rvalue.RoleName)
                                }
                            }
                        });
                    });
                    angular.forEach($scope.Usersessiondatadatas, function (usersession) {
                        if (value.UserID == usersession.UserID) {
                            $scope.LastLoginDate = usersession.SessionStartDate;
                        }
                    });
                    //angular.forEach($scope.Clientdatas, function (clientvalue) {
                    //    if (value.ClientID == clientvalue.id) {
                    //        $scope.ClientName = clientvalue.ClientName;
                    //    }
                    //});
                    st = Roleselect.map(function (obj) { return obj; }).join(', ');
                    var Roleselect = [];
                    Users.push({
                        ID: value.id,
                        UserID: value.UserID,
                        Email: value.Email,
                        UserName: value.UserName,
                        MobileNumber: value.MobileNumber,
                        Designation: value.Designation,
                        ExpiryDate: value.ExpiryDate,
                        Password: value.Password,
                        LastSuccess: value.LastSuccess,
                        LastFailure: value.LastFailure,
                        IsActive: value.IsActive,
                        IsLocked: value.IsLocked,
                        EmployeeID: value.EmployeeID,
                        AllowExport: value.AllowExport,
                        IsAdmin: value.IsAdmin,
                        LastLoginDate: $scope.LastLoginDate,
                        Roles: value.Roles,
                        ClientName: value.ClientName,
                    })
                    $scope.LastLoginDate = null
                });
                $scope.UserSummary = Users;
            }
            catch (e) { }
        }
        $scope.getLoginDate = function (ID) {
            try {
                if ($scope.Usersessiondatadatas != undefined && ID != undefined) {
                    var index = _.findLastIndex($scope.Usersessiondatadatas, {
                        UserID: ID
                    });
                    return $scope.Usersessiondatadatas[index].SessionStartDate
                }
            }
            catch (e) { }
        }
        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/userrole")
                .then(function (Userroledata) {
                    $scope.Userroledatas = Userroledata.data.data;
                });
            $http.get($rootScope.WebURL + "/login/usersession")
                .then(function (usersessiondata) {
                    $scope.Usersessiondatadatas = usersessiondata.data.data;
                });
            $http.get($rootScope.WebURL + "/usermodel")
                .then(function (userModulesdata) {
                    $scope.userModulesdatas = userModulesdata.data.data;
                });
            $http.get($rootScope.WebURL + "/user/getForPage")
                .then(function (Userdata) {
                    $scope.Userdatas = Userdata.data.data;
                });
            $http.get($rootScope.WebURL + "/workflow/get")
                .then(function (workflowUserdata) {
                    $scope.Workflowdatas = workflowUserdata.data.data;
                });
            $http.get($rootScope.WebURL + "/pagedb")
                .then(function (Pagedata) {
                    $scope.Pagedatas = Pagedata.data.data;
                    UserSummary();
                });
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { WorkOrder: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { EquipmentRequest: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Invoice: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { AccountsWorkOrder: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { EmailAlerts: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { AcCustomer: 0 }
            $scope.rec41 = { AcContract: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { ELeaves: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { AcScheduler: 0 }
            $scope.rec46 = { AcDScheduler: 0 }
            $scope.rec47 = { AcPestOff: 0 }
            $scope.rec48 = { AcLumiair: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { ProcurementSettings: 0 }
            $scope.rec56 = { ChemicalRequest: 0 }
            $scope.rec57 = { Treatment: 0 }
            $scope.rec58 = { Feedback: 0 }
            $scope.rec59 = { OperationsReport: 0 }
            $scope.rec61 = { ChemicalRequest: 0 }
            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.AcCustomer = { value: false, };
            $scope.AcScheduler = { value: false, };
            $scope.AcPestOff = { value: false, };
            $scope.AcDScheduler = { value: false, };
            $scope.AcContract = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.CashCheque = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.AcLumiair = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.ELeaves = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.ProcurementSettings = { value: false, }
            $scope.ChemicalRequest = { value: false, }
            $scope.Treatment = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.ChemicalRequest = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.WorkOrder = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.EquipmentRequest = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Invoice = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.AccountsWorkOrder = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.EmailAlerts = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }
            $scope.UniformR = { value: false, }

            $scope.Pageform = false;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.RequstForm = false
        }
        function ClearForm() {
            var userActive = document.getElementById('userActive');
            var userLocked = document.getElementById('userLocked');
            $scope.formData.uLoginID = null;
            $scope.formData.uEmail = null;
            $scope.formData.uUserName = null;
            $scope.formData.uMobileNumber = null
            $scope.uEmployeeID = null;
            $scope.formData.uDesignation = null;
            $scope.formData.uPassword = null;
            $scope.formData.uRoles = null;
            $scope.formData.uExpiryDate = null;
            $scope.IsActive = null;
            $scope.IsLocked = null;
            $scope.vm.searchE = '';
            $scope.formData.uLastSuccess = null;
            $scope.formData.uLastSuccess = null;
            $scope.formData.selectedRole = [];
            $scope.formData.selectedModule = [];
            $scope.uClientID = null;
            $scope.AllowExport = { value: false, };
            $scope.IsAdmin = { value: false, };
        }
        function fetchData(UserId) {
            angular.forEach($scope.Userdatas, function (value) {
                if (value.id == UserId) {
                    $scope.uLoginID = value.UserID;
                    $scope.uEmail = value.Email;
                    $scope.uUserName = value.UserName;
                    $scope.uMobileNumber = value.MobileNumber;
                    $scope.uClientID = value.ClientID;
                    $scope.uClientName = value.ClientName;
                    $scope.uRoles = value.Roles;
                    $scope.uExpiryDate = value.ExpiryDate;
                    $scope.uPassword = value.Password
                    $scope.IsActive = value.IsActive;
                    $scope.IsLocked = value.IsLocked;
                    $scope.uLastSuccess = value.LastSuccess;
                    $scope.uLastSuccess = value.LastFailure;
                    $scope.AllowExport = value.AllowExport;
                    $scope.IsAdmin = value.IsAdmin;
                }
            });
        }

        var vm = this;
        vm.ischanged = 1;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.operations.treatment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.treatment', {
            url: '/TreatmentMethods',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/treatment/treatment.html',
                    controller: 'TreatmentController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/treatment');
    }

})();
(function () {


    'use strict';
    angular
        .module('app.operations.treatment')
        .controller('TreatmentController', TreatmentController);


    /** @ngInject */
    function TreatmentController($scope, $rootScope, $mdDialog, $document, $location, $mdToast, $http) {
        document.getElementsByTagName('title')[0].text = "Operations-Treatment Methods"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Treatment")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        $scope.IsAdmin = IsAdmin
        $scope.Treatmentgrid = true;
        $scope.Export = true;
        $scope.Treatmentform = false;
        $scope.Add = true;
        $scope.Search = true;

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Treatmentform = true;
            $scope.Treatmentgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Search = false;
            $scope.error1 = false;
        }
        $scope.Showgrid = function () {
            $scope.Treatmentgrid = true;
            $scope.Treatmentform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.Treatmentinfo = function (TreatmentId) {
            $scope.SID = TreatmentId;
            $scope.Update = true;
            $scope.Treatmentform = true;
            $scope.Treatmentgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.TreatmentinfoId = TreatmentId;
            var Treatmentdata = $scope.Treatmentdatas
            var info = $scope.Treatmentdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == TreatmentId) {
                    $scope.TreatmentMethod = info[i].TreatmentMethod;
                    $scope.TreatmentName = info[i].TreatmentName;
                    $scope.Description = info[i].Description;
                    $scope.Chemical = info[i].Chemical;
                    $scope.Dilution = info[i].Dilution;
                    $scope.Chemical1 = info[i].Chemical1;
                    $scope.Dilution1 = info[i].Dilution1;
                    $scope.SOP = info[i].SOP;
                    $scope.DilutionDetails = info[i].DilutionDetails;
                    $scope.PestType = info[i].PestType;

                }
            }
        }

        $scope.SOP = "";
        $scope.DilutionDetails = "";
        $scope.textAreaWithMaxLength = {
            height: 90,
            bindingOptions: {
                'value': 'SOP'
            }

        };

        $scope.sSubmit = function () {
            var Pesttype = $scope.PestType

            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/treatment/update",
                    data: {
                        _id: $scope.SID,
                        TreatmentMethod: $scope.TreatmentName,
                        TreatmentName: $scope.TreatmentName,
                        Description: $scope.Description,
                        PestType: Pesttype,
                        Chemical: $scope.Chemical,
                        Dilution: $scope.Dilution,
                        Chemical1: $scope.Chemical1,
                        Dilution1: $scope.Dilution1,
                        SOP: $scope.SOP,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },

                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Treatmentgrid = true;
                    $scope.Treatmentform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/treatment/add",
                    data: {
                        TreatmentMethod: $scope.TreatmentName,
                        TreatmentName: $scope.TreatmentName,
                        Description: $scope.Description,
                        Chemical: $scope.Chemical,
                        Dilution: $scope.Dilution,
                        Chemical1: $scope.Chemical1,
                        Dilution1: $scope.Dilution1,
                        SOP: $scope.SOP,
                        PestType: Pesttype,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing TreatmentName") {
                        $scope.error1 = true;
                        $scope.Treatmentform = true;
                        $scope.Treatmentgrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.Treatmentgrid = true;
                        $scope.Treatmentform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Treatmentdata.xlsx",{headers:true}) FROM ?', [$scope.Treatmentdatas]);
        };
        $scope.DeletePopup = function (e, id) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/sormaster/alert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function TreatmentController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.DeleteId = id;
        }
        $scope.Delete = function () {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/treatment/delete",
                data: {
                    _id: $scope.vm.DeleteId,
                },
            }).then(function (GList) {
                $scope.vm.DeleteId = null;
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/treatment",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Treatmentdata) {
            $scope.Treatmentdatas = Treatmentdata.data.data;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/treatment",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Treatmentdata) {
                $scope.Treatmentdatas = Treatmentdata.data.data;
            });
        }
        function ClearForm() {
            $scope.TreatmentMethod = '';
            $scope.TreatmentName = '';
            $scope.PestType = "";
            $scope.Description = '';
            vm.selectedItem = '';
            $scope.Chemical = "";
            $scope.Dilution = "";
            $scope.Chemical1 = "";
            $scope.Dilution1 = "";
            $scope.SOP = "";
            $scope.DilutionDetails = "";
        }

        var vm = this;

        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        function loadAll() {
            var allStates = 'Afghanistan,  Aland Islands,  Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Antarctica, Antigua And Barbuda, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Bosnia And Herzegovina, Botswana, Bouvet Island, Brazil, British Indian Ocean Territory, Brunei Darussalam, Bulgaria, Burkina Faso, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Cayman Islands, Central African Republic, Chad, Chile, China, Christmas Island, Cocos (Keeling) Islands, Colombia, Comoros, Congo, Congo,  The Democratic Republic Of The, Cook Islands, Costa Rica,   Croatia, Cuba, Cyprus, Czechia, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Falkland,  Islands (Malvinas), Faroe,  Islands, Fiji, Finland, France, French,  Guiana, French, Polynesia, French, Southern, \
            Territories, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guinea-bissau, Guyana, Haiti, Heard Island And Mcdonald Islands, Holy See (Vatican City State), Honduras, Hong Kong, Hungary, Iceland, India, Indonesia, Iran,  Islamic Republic Of, Iraq, Ireland, Isle Of Man, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Korea, Republic Of, Kuwait, Kyrgyzstan, LaoPeoples,  Democratic,  Republic, Latvia, Lebanon, Lesotho, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Lithuania, Luxembourg, Macao, Macedonia,  The Former Yugoslav Republic Of, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Micronesia,  Federated States Of, Moldova,  Republic Of, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, \
            Netherlands Antilles, New Caledonia, New Zealand, Nicaragua, Niger, Nigeria, Niue, Norfolk Island, Northern Mariana Islands, Norway, Oman, Pakistan, Palau, Palestinian Territory,  Occupied, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Puerto Rico, Qatar, Reunion, Romania, Russian Federation, Rwanda, Saint Helena, Saint Kitts And Nevis, Saint Lucia, Saint Pierre And Miquelon, Saint Vincent And The Grenadines, Samoa, San Marino, Sao Tome And Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Georgia And The South Sandwich Islands, Spain, Sri Lanka, Sudan, Suriname, Svalbard And Jan Mayen, Swaziland, Sweden, Switzerland, Syrian Arab Republic, Taiwan,  Province Of China, Tajikistan, Tanzania,  United Republic Of, Thailand, Timor-leste, Togo, Tokelau, Tonga, Trinidad And Tobago, Tunisia, Turkey, Turkmenistan, Turks And Caicos Islands, \
            Tuvalu, Uganda, Ukraine, United Arab,  Emirates, United Kingdom, United States, United States,  Minor Outlying,  Islands, Uruguay, Uzbekistan, Vanuatu, Venezuela, Viet Nam, Virgin Islands,  British, Virgin Islands,  U.S., Wallis And Futuna, Western Sahara, Yemen, Zambia, Zimbabwe';

            return allStates.split(/, +/g).map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.security.clients', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.clients', {
            url      : '/Clients',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/security/clients/clients.html',
                    controller: 'ClientController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.security.clients')
        .controller('ClientController', ClientController);

    /** @ngInject */
    function ClientController($mdDateLocale, $filter, $scope, $rootScope, $interval, $mdToast, $mdDialog, $document, $mdSidenav, $http, $window, $timeout, $q, $log, Upload, NgMap) {
        document.getElementsByTagName('title')[0].text = "Security-Client/Licensor"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Client")) {
            // do nothing
        }
        else {
            window.location = 'NoAccess';
        }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Clientdatas.xlsx",{headers:true}) FROM ?', [$scope.Clientdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.Logo = [{ photo: false }]
        $scope.Clientgrid = true;
        $scope.Export = true;
        $scope.Clientform = false;
        if ($scope.filtered_client) {
            $scope.Add = false;
        }
        else
            $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;
        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Clientform = true;
            $scope.Clientgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.ClientAddressdatas = [];
            //$scope.basicForm.$setPristine();
            //$scope.basicForm.$setUntouched();
            $scope.Search = false;
            $scope.error1 = false;
            var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890!@#$%^&*()";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.vm.uDeliveryAddressId = pass;
            angular.forEach($scope.Clientdatas, function (value, key) {
                if (value.Primary == "Yes")
                    $scope.oneclient = true;
                $scope.checkboxModel = { value: false }
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.Showgrid = function () {
            $scope.Clientgrid = true;
            $scope.Clientform = false;
            $scope.Export = true;
            if ($scope.filtered_client) {
                $scope.Add = false;
            }
            else
                $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.error1 = false;
            $scope.checkboxModel = { value: false, };
            $scope.oneclient = false;
        }
        $scope.checkclearImage = function () {
            $scope.ShowImageView = false;
            $scope.ClearImageView = true;
        }
        $scope.checkaddImage = function () {
            $scope.ShowImageView = true;
            $scope.ClearImageView = false;
        }
        $scope.cspopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/clients/cspopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ClientController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.deleteID = deleteID;
        }
        $scope.Servicepopup = function (e, uDeliveryAddressId) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/clients/Delivery.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ClientController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.uDeliveryAddressId = uDeliveryAddressId;
            $scope.vm.ubBLK = null;
            $scope.vm.ubUnit = null;
            $scope.vm.ubPostal = null;
            $scope.vm.ubCountry = 'Singapore';
            $scope.vm.ubContactPerson = null;
            $scope.vm.ubBuildingName = null;
            $scope.vm.ubStreetName = null;
            $scope.vm.ubMobile = null;
            $scope.vm.ubEmail = null;
            $scope.DAUpdate = false;
        }
        $scope.Deliveryadd = function () {
            if ($scope.DAUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/clientAddress/update",
                    data: {
                        _id: $scope.QID,
                        DeliveryAddressId: $scope.vm.uDeliveryAddressId,
                        bBLK: $scope.vm.ubBLK,
                        bUnit: $scope.vm.ubUnit,
                        bPostal: $scope.vm.ubPostal,
                        bCountry: $scope.vm.ubCountry,
                        bContactPerson: $scope.vm.ubContactPerson,
                        bBuildingName: $scope.vm.ubBuildingName,
                        bStreetName: $scope.vm.ubStreetName,
                        bMobile: $scope.vm.ubMobile,
                        bEmail: $scope.vm.ubEmail,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $scope.RequestID = $scope.vm.uDeliveryAddressId;
                    ClientAddressdetails();
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/clientAddress/add",
                    data: {
                        DeliveryAddressId: $scope.vm.uDeliveryAddressId,
                        bBLK: $scope.vm.ubBLK,
                        bUnit: $scope.vm.ubUnit,
                        bPostal: $scope.vm.ubPostal,
                        bCountry: $scope.vm.ubCountry,
                        bContactPerson: $scope.vm.ubContactPerson,
                        bBuildingName: $scope.vm.ubBuildingName,
                        bStreetName: $scope.vm.ubStreetName,
                        bMobile: $scope.vm.ubMobile,
                        bEmail: $scope.vm.ubEmail,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                    },
                });
                response.then(function (GList) {
                    $scope.RequestID = $scope.vm.uDeliveryAddressId;
                    ClientAddressdetails();
                    $scope.Servicegrid = true;
                    $scope.Add = false;
                    $scope.Search = false;
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Deliveryupdate = function (e, QId) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/security/clients/Delivery.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ClientController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.DAUpdate = true;
            $scope.QID = QId;
            var info = $scope.ClientAddressdatas
            try {
                var item = info.filter(function (item) {
                    return item.id === QId;
                })[0];
                $scope.vm.ubBLK = item.bBLK;
                $scope.vm.ubUnit = item.bUnit;
                $scope.vm.ubPostal = parseInt(item.bPostal);
                $scope.vm.ubCountry = item.bCountry;
                $scope.vm.ubContactPerson = item.bContactPerson;
                $scope.vm.ubBuildingName = item.bBuildingName;
                $scope.vm.ubStreetName = item.bStreetName;
                if (item.bMobile != null && item.bMobile != undefined && item.bMobile != "") { $scope.vm.ubMobile = parseInt(item.bMobile); }
                $scope.vm.ubEmail = item.bEmail;
            }
            catch (e) { }
        }
        $scope.model = {};
        $scope.Deliverydelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientAddress/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                ClientAddressdetails();
                $scope.Servicegrid = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Clientinfo = function (ClientId) {
            $scope.SID = ClientId;
            $scope.Update = true;
            $scope.Clientform = true;
            $scope.Clientgrid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;
            $scope.ClientinfoId = ClientId;
            var Clientdata = $scope.Clientdatas
            var info = $scope.Clientdatas
            var primarysummary = [];
            var info = $scope.Clientdatas
            $scope.model.Data = null;
            var primarysummary = [];
            for (var p = 0; p < info.length; p++) {
                primarysummary.push(
                    info[p].Primary
                );
            }
            try {
                var item = info.filter(function (item) {
                    return item._id === ClientId;
                })[0];
                $scope.vm.uClientName = item.ClientName;
                $scope.vm.uClientCode = item.ClientCode;
                vm.selectedItem = item.Country;
                $scope.vm.uCurrencyCode = item.CurrencyCode;
                $scope.vm.uAddress = item.Address;
                $scope.vm.uContactPerson = item.ContactPerson;
                $scope.vm.uStartDate = new Date(item.StartDate);
                $scope.vm.uEndDate = new Date(item.EndDate);
                $scope.vm.uRemarks = item.Remarks;
                $scope.vm.Blk = item.BLK;
                $scope.vm.uDeliveryAddressId = item.DeliveryAddressId;
                $scope.vm.Unit = item.Unit;
                $scope.vm.StreetName = item.StreetName;
                $scope.vm.BuildingName = item.BuildingName;
                $scope.vm.Website = item.Website;
                $scope.vm.Language = item.Language;
                $scope.previewSrc =
                    $rootScope.UploadsURL + "Security/Client/" + $scope.SID + ".png";
                if (
                    item.Phone != null &&
                    item.Phone != undefined &&
                    item.Phone != "" &&
                    item.Phone != "undefined"
                ) {
                    $scope.vm.Phone = parseInt(item.Phone);
                }
                if (item.Mobile != null && item.Mobile != undefined && item.Mobile != "" && item.Mobile != "undefined") {
                    $scope.vm.Mobile = parseInt(item.Mobile);
                }
                if (item.PostalCode != null && item.PostalCode != undefined && item.PostalCode != "" && item.PostalCode != "undefined") {
                    $scope.vm.PostalCode = parseInt(item.PostalCode);
                }
                $scope.vm.Email = item.Email;
                $scope.vm.GSTNumber = item.GSTNumber;
                $scope.vm.Fax = item.Fax;

                $scope.TransactionCurrencies = item.TransactionCurrencies;
                if ($scope.TransactionCurrencies != null && $scope.TransactionCurrencies != "" && $scope.TransactionCurrencies != undefined) {
                    var array = $scope.TransactionCurrencies.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ CCode: value });
                    });
                    $scope.vm.TransactionCurrencies = array1;
                }
                if (item.Primary == "Yes") { $scope.checkboxModel = { value: true, }; $scope.oneclient = false; $scope.filtered_client = false }
                if (item.Primary == "No") {
                    $scope.checkboxModel = { value: false, }; $scope.oneclient = true;
                    $scope.filtered_client = true

                    if (primarysummary.split(",").includes("Yes")) {
                        $scope.oneclient = true;
                    }
                    else { $scope.oneclient = false; }
                }
                $scope.model.Data = decode_base64(item.Logo);
                if ($scope.model.Data != "" && $scope.model.Data != null && $scope.model.Data != undefined) {
                    $scope.ShowImageView = true;
                    $scope.ClearImageView = false;
                }
                else {
                    $scope.ShowImageView = false;
                    $scope.ClearImageView = true;
                }
            }
            catch (e) { }
            $scope.RequestID = $scope.vm.uDeliveryAddressId;

        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }
        $scope.decode_base64 = function (str) {
            return decodeURIComponent(escape(window.atob(str)));
        }
        $scope.checkboxModel = { value: false, };
        $scope.sSubmit = function () {
            if ($scope.checkboxModel.value == true) {
                $scope.uPrimary = "Yes";
            } else {
                $scope.uPrimary = "No";
            }

            var fileInput = document.getElementById("fileInput");
            var file = fileInput.files[0];

            if (!file && !$scope.previewSrc) {
                $scope.fileError = true;
                return;
            }

            // if ($scope.model.Data == null || $scope.model.Data == "" || $scope.model.Data == "undefined") {
            //     $scope.model.Data = null;
            // }
            // else {
            //     $scope.model.Data = $scope.model.Data;
            // }

            // if ($scope.ClearImageView == true) {
            //     $scope.Data = "";
            // }
            // else {
            //     var data = new FormData();
            //     var reader = new FileReader();
            //     $scope.files = document.getElementById('upload');
            //     var a = $scope.files.baseURI;

            //     if ($scope.files.src == null || $scope.files.src == "" || $scope.files.src == undefined) {
            //         $scope.Data = "";
            //         if ($scope.Update == false) {
            //             $scope.Data = "";
            //         }
            //         else if ($scope.Update == true) {
            //             if ($scope.model.Data == null || $scope.model.Data == "" || $scope.model.Data == undefined) {
            //                 $scope.Data = "";
            //             }
            //             else {
            //                 $scope.Data = $scope.model.Data;
            //             }
            //         }
            //     }
            //     else {      $scope.Data = $scope.files.src;  }
            // }
            $scope.Data = "";
            if ($scope.vm.TransactionCurrencies != null && $scope.vm.TransactionCurrencies != "" && $scope.vm.TransactionCurrencies != undefined) {
                $scope.vm.TransactionCurrencies = $scope.vm.TransactionCurrencies.map(function (obj) { return obj.CCode; }).join(',');
            }
            if ($scope.Update == true) {
                if (vm.selectedItem.display == undefined) {
                    $scope.vm.uCountry = vm.selectedItem;
                }
                else {
                    $scope.vm.uCountry = vm.selectedItem.display;
                }
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/client/update",
                    data: {
                        _id: $scope.SID, ClientName: $scope.vm.uClientName, ClientCode: $scope.vm.uClientCode, DeliveryAddressId: $scope.vm.uDeliveryAddressId,
                        Remarks: $scope.vm.uRemarks, Country: $scope.vm.uCountry, CurrencyCode: $scope.vm.uCurrencyCode, TransactionCurrencies: $scope.vm.TransactionCurrencies,
                        ContactPerson: $scope.vm.uContactPerson, StartDate: $scope.vm.uStartDate, EndDate: $scope.vm.uEndDate,
                        Logo: $scope.Data, PostalCode: $scope.vm.PostalCode, GSTNumber: $scope.vm.GSTNumber,
                        BLK: $scope.vm.Blk, Unit: $scope.vm.Unit, StreetName: $scope.vm.StreetName, Website: $scope.vm.Website,
                        BuildingName: $scope.vm.BuildingName, Phone: $scope.vm.Phone, Mobile: $scope.vm.Mobile,
                        Email: $scope.vm.Email, Fax: $scope.vm.Fax, Language: $scope.vm.Language,
                        Primary: $scope.uPrimary, UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Clientgrid = true;
                    $scope.Clientform = false;
                    $scope.Export = true;
                    if ($scope.filtered_client) {
                        $scope.Add = false;
                    }
                    else
                        $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    var UserID = $scope.SID;
                    var file = angular.element(document.querySelector("#fileInput"))[0]
                        .files;
                    if (file.length != 0 && file.length != undefined) {
                        var files = [];
                        files.push({ file: file[0] });
                        $scope.Uploadfiles(files, UserID);
                    }
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/client/add",
                    data: {
                        ClientName: $scope.vm.uClientName, ClientCode: $scope.vm.uClientCode, Address: $scope.vm.uAddress,
                        Remarks: $scope.vm.uRemarks, Country: vm.selectedItem.display, CurrencyCode: $scope.vm.uCurrencyCode,
                        ContactPerson: $scope.vm.uContactPerson, StartDate: $scope.vm.uStartDate, EndDate: $scope.vm.uEndDate,
                        TransactionCurrencies: $scope.vm.TransactionCurrencies,
                        Logo: $scope.Data, PostalCode: $scope.vm.PostalCode, GSTNumber: $scope.vm.GSTNumber, DeliveryAddressId: $scope.vm.uDeliveryAddressId,
                        BLK: $scope.vm.Blk, Unit: $scope.vm.Unit, StreetName: $scope.vm.StreetName, Website: $scope.vm.Website,
                        BuildingName: $scope.vm.BuildingName, Phone: $scope.vm.Phone, Mobile: $scope.vm.Mobile,
                        Email: $scope.vm.Email, Fax: $scope.vm.Fax, Language: $scope.vm.Language,
                        Primary: $scope.uPrimary, CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing ClientName") {
                        $scope.error1 = true;
                        $scope.Clientgrid = false;
                        $scope.Clientform = true;
                        $scope.Export = false;
                        $scope.Add = false;
                        $scope.Search = false;
                        $scope.view = true;
                    } else {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Successfully Added!")
                                .position("top center")
                        );
                        var UserID = GList.data.data.id;
                        var file = angular.element(
                            document.querySelector("#fileInput")
                        )[0].files;
                        if (file.length != 0 && file.length != undefined) {
                            var files = [];
                            files.push({ file: file[0] });
                            $scope.Uploadfiles(files, UserID);
                        }
                        RefreshGrid();
                        $scope.Clientgrid = true;
                        $scope.Clientform = false;
                        $scope.Export = true;
                        if ($scope.filtered_client) {
                            $scope.Add = false;
                        }
                        else
                            $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/client/getForPage")
                .then(function (Clientdata) {
                    if (Clientdata.data.statusCode == 201) {
                        $scope.filtered_client = true;
                        $scope.Add = false
                    }
                    $scope.Clientdatas = Clientdata.data.data;
                });
        }
        RefreshGrid()
        function ClientAddressdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/clientAddress",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (Logdetailsdata) {
                $scope.ClientAddressdatas = Logdetailsdata.data.data;
            });
        }
        function ClearForm() {
            var fileInput = angular.element(document.querySelector("#fileInput"))[0];
            var file = fileInput.files;
            fileInput.value = "";
            $scope.fileError = false;
            $scope.previewSrc = null;
            $scope.vm.uClientName = "";
            $scope.vm.uClientCode = "";
            vm.selectedItem = { display: "Singapore" };
            $scope.vm.uCurrencyCode = 'SGD';
            $scope.vm.uContactPerson = '';
            $scope.vm.uRemarks = '';
            $scope.vm.uAddress = '';
            $scope.vm.Blk = '';
            $scope.vm.TransactionCurrencies = null;
            $scope.vm.Unit = null;
            $scope.vm.Phone = null;
            $scope.vm.GSTNumber = null;
            $scope.vm.Mobile = null;
            $scope.vm.Fax = null;
            $scope.vm.Email = null;
            $scope.vm.Website = null;
            $scope.vm.Language = 'Engish';
            $scope.vm.StreetName = null;
            $scope.vm.BuildingName = null;
            $scope.vm.PostalCode = null;
            $scope.vm.BuildingName = null;
            $scope.model.Data = "";
            $scope.vm.uStartDate = new Date(new Date().setFullYear(new Date().getFullYear()));
            $scope.vm.uEndDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
        }

        var vm = this;
        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true

        };
        $scope.CurrencyCodeList = [
            { CCode: "AED" },
            { CCode: "AFN" },
            { CCode: "ALL" },
            { CCode: "AMD" },
            { CCode: "ANG" },
            { CCode: "AOA" },
            { CCode: "ARS" },
            { CCode: "AUD" },
            { CCode: "AWG" },
            { CCode: "AZN" },
            { CCode: "BAM" },
            { CCode: "BBD" },
            { CCode: "BDT" },
            { CCode: "BGN" },
            { CCode: "BHD" },
            { CCode: "BIF" },
            { CCode: "BMD" },
            { CCode: "BND" },
            { CCode: "BOB" },
            { CCode: "BRL" },
            { CCode: "BSD" },
            { CCode: "BTN" },
            { CCode: "BWP" },
            { CCode: "BYN" },
            { CCode: "BYR" },
            { CCode: "BZD" },
            { CCode: "CAD" },
            { CCode: "CDF" },
            { CCode: "CHF" },
            { CCode: "CLF" },
            { CCode: "CLP" },
            { CCode: "CNY" },
            { CCode: "COP" },
            { CCode: "CRC" },
            { CCode: "CUC" },
            { CCode: "CUP" },
            { CCode: "CVE" },
            { CCode: "CZK" },
            { CCode: "DJF" },
            { CCode: "DKK" },
            { CCode: "DOP" },
            { CCode: "DZD" },
            { CCode: "EGP" },
            { CCode: "ERN" },
            { CCode: "ETB" },
            { CCode: "EUR" },
            { CCode: "FJD" },
            { CCode: "FKP" },
            { CCode: "GBP" },
            { CCode: "GEL" },
            { CCode: "GHS" },
            { CCode: "GIP" },
            { CCode: "GMD" },
            { CCode: "GNF" },
            { CCode: "GTQ" },
            { CCode: "GYD" },
            { CCode: "HKD" },
            { CCode: "HNL" },
            { CCode: "HRK" },
            { CCode: "HTG" },
            { CCode: "HUF" },
            { CCode: "IDR" },
            { CCode: "ILS" },
            { CCode: "INR" },
            { CCode: "IQD" },
            { CCode: "IRR" },
            { CCode: "ISK" },
            { CCode: "JMD" },
            { CCode: "JOD" },
            { CCode: "JPY" },
            { CCode: "KES" },
            { CCode: "KGS" },
            { CCode: "KHR" },
            { CCode: "KMF" },
            { CCode: "KPW" },
            { CCode: "KRW" },
            { CCode: "KWD" },
            { CCode: "KYD" },
            { CCode: "KZT" },
            { CCode: "LAK" },
            { CCode: "LBP" },
            { CCode: "LKR" },
            { CCode: "LRD" },
            { CCode: "LSL" },
            { CCode: "LYD" },
            { CCode: "MAD" },
            { CCode: "MDL" },
            { CCode: "MGA" },
            { CCode: "MKD" },
            { CCode: "MMK" },
            { CCode: "MNT" },
            { CCode: "MOP" },
            { CCode: "MRO" },
            { CCode: "MUR" },
            { CCode: "MVR" },
            { CCode: "MWK" },
            { CCode: "MXN" },
            { CCode: "MXV" },
            { CCode: "MYR" },
            { CCode: "MZN" },
            { CCode: "NAD" },
            { CCode: "NGN" },
            { CCode: "NIO" },
            { CCode: "NOK" },
            { CCode: "NPR" },
            { CCode: "NZD" },
            { CCode: "OMR" },
            { CCode: "PAB" },
            { CCode: "PEN" },
            { CCode: "PGK" },
            { CCode: "PHP" },
            { CCode: "PKR" },
            { CCode: "PLN" },
            { CCode: "PYG" },
            { CCode: "QAR" },
            { CCode: "RON" },
            { CCode: "RSD" },
            { CCode: "RUB" },
            { CCode: "RWF" },
            { CCode: "SAR" },
            { CCode: "SBD" },
            { CCode: "SCR" },
            { CCode: "SDG" },
            { CCode: "SEK" },
            { CCode: "SGD" },
            { CCode: "SHP" },
            { CCode: "SLL" },
            { CCode: "SOS" },
            { CCode: "SRD" },
            { CCode: "SSP" },
            { CCode: "STD" },
            { CCode: "SVC" },
            { CCode: "SYP" },
            { CCode: "SZL" },
            { CCode: "THB" },
            { CCode: "TJS" },
            { CCode: "TMT" },
            { CCode: "TND" },
            { CCode: "TOP" },
            { CCode: "TRY" },
            { CCode: "TTD" },
            { CCode: "TWD" },
            { CCode: "TZS" },
            { CCode: "UAH" },
            { CCode: "UGX" },
            { CCode: "USD" },
            { CCode: "UYI" },
            { CCode: "UYU" },
            { CCode: "UZS" },
            { CCode: "VEF" },
            { CCode: "VND" },
            { CCode: "VUV" },
            { CCode: "WST" },
            { CCode: "XAF" },
            { CCode: "XCD" },
            { CCode: "XOF" },
            { CCode: "XPF" },
            { CCode: "XXX" },
            { CCode: "YER" },
            { CCode: "ZAR" },
            { CCode: "ZMW" },
            { CCode: "ZWL" }];
        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];
        function loadAll() {
            var allStates = 'Afghanistan,  Aland Islands,  Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Antarctica, Antigua And Barbuda, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Bosnia And Herzegovina, Botswana, Bouvet Island, Brazil, British Indian Ocean Territory, Brunei Darussalam, Bulgaria, Burkina Faso, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Cayman Islands, Central African Republic, Chad, Chile, China, Christmas Island, Cocos (Keeling) Islands, Colombia, Comoros, Congo, Congo,  The Democratic Republic Of The, Cook Islands, Costa Rica,   Croatia, Cuba, Cyprus, Czechia, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Falkland,  Islands (Malvinas), Faroe,  Islands, Fiji, Finland, France, French,  Guiana, French, Polynesia, French, Southern, \
            Territories, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guinea-bissau, Guyana, Haiti, Heard Island And Mcdonald Islands, Holy See (Vatican City State), Honduras, Hong Kong, Hungary, Iceland, India, Indonesia, Iran,  Islamic Republic Of, Iraq, Ireland, Isle Of Man, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Korea, Republic Of, Kuwait, Kyrgyzstan, LaoPeoples,  Democratic,  Republic, Latvia, Lebanon, Lesotho, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Lithuania, Luxembourg, Macao, Macedonia,  The Former Yugoslav Republic Of, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Micronesia,  Federated States Of, Moldova,  Republic Of, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, \
            Netherlands Antilles, New Caledonia, New Zealand, Nicaragua, Niger, Nigeria, Niue, Norfolk Island, Northern Mariana Islands, Norway, Oman, Pakistan, Palau, Palestinian Territory,  Occupied, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Puerto Rico, Qatar, Reunion, Romania, Russian Federation, Rwanda, Saint Helena, Saint Kitts And Nevis, Saint Lucia, Saint Pierre And Miquelon, Saint Vincent And The Grenadines, Samoa, San Marino, Sao Tome And Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Georgia And The South Sandwich Islands, Spain, Sri Lanka, Sudan, Suriname, Svalbard And Jan Mayen, Swaziland, Sweden, Switzerland, Syrian Arab Republic, Taiwan,  Province Of China, Tajikistan, Tanzania,  United Republic Of, Thailand, Timor-leste, Togo, Tokelau, Tonga, Trinidad And Tobago, Tunisia, Turkey, Turkmenistan, Turks And Caicos Islands, \
            Tuvalu, Uganda, Ukraine, United Arab,  Emirates, United Kingdom, United States, United States,  Minor Outlying,  Islands, Uruguay, Uzbekistan, Vanuatu, Venezuela, Viet Nam, Virgin Islands,  British, Virgin Islands,  U.S., Wallis And Futuna, Western Sahara, Yemen, Zambia, Zimbabwe';

            return allStates.split(/, +/g).map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }
        function selectedItemChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        $scope.previewSrc = null;
        $scope.FilePath = null; // Set this if an existing logo URL is available

        // Trigger file input click
        $scope.triggerFileInput = function () {
            document.getElementById("fileInput").click();
        };

        // Attach file change listener AFTER DOM is ready
        $timeout(function () {
            var fileInput = document.getElementById("fileInput");
            if (fileInput) {
                fileInput.addEventListener("change", function () {
                    var file = this.files[0];
                    if (file) {
                        $scope.fileError = false;
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            $scope.$apply(function () {
                                $scope.previewSrc = e.target.result;
                            });
                        };
                        reader.readAsDataURL(file);
                    }
                });
            }
        });
        $scope.Uploadfiles = function (file, UserID) {
            debugger;
            var file = file[0].file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                file = reader.result;
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/client/upload",
                    data: { file: file, _id: UserID }
                }).then(function (GList) {
                    $scope.fileName = null;
                    var fileInput = angular.element(
                        document.querySelector("#fileInput")
                    )[0];
                    var file = fileInput.files;
                    // ... perform your image upload logic here ...

                    // ✅ Clear the file input after upload
                    fileInput.value = "";
                    localStorage.removeItem("logo_url");
                });
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
                $scope.fileName = null;
                var fileInput = angular.element(
                    document.querySelector("#fileInput")
                )[0];
                var file = fileInput.files;

                // ... perform your image upload logic here ...

                // ✅ Clear the file input after upload
                fileInput.value = "";
                localStorage.removeItem("logo_url");
            };
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.security.email', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.email', {
            url: '/EmailNotifications',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/security/email/email.html',
                    controller: 'EmailController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.security.email')
        .controller('EmailController', EmailController);

    /** @ngInject */
    function EmailController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Email")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.model = {};

        $scope.saveNotification = function () {
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/notification/update",
                    data: {
                        _id: $scope.SID, NotificationType: $scope.model.NotificationType,
                    },
                });
                ClearNotification();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshNotification();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/notification/add",
                    data: {
                        NotificationType: $scope.model.NotificationType,
                    },
                });
                ClearNotification();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshNotification();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Notificationinfo = function (NotificationId) {

            $scope.SID = NotificationId;
            $scope.Update = true;
            $scope.NotificationinfoId = NotificationId;
            var info = $scope.Notificationdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == NotificationId) {
                    $scope.model.NotificationType = info[i].NotificationType;
                }
            }
        }

        $http.get($rootScope.WebURL + "/notification")
            .then(function (Notificationdata) {
                $scope.Notificationdatas = Notificationdata.data.data;
            });

        function RefreshNotification() {

            $http.get($rootScope.WebURL + "/notification")
                .then(function (Notificationdata) {
                    $scope.Notificationdatas = Notificationdata.data.data;
                });
        }

        function ClearNotification() {

            $scope.model.NotificationType = '';
            $scope.qualificationform6.$setPristine();
            $scope.qualificationform6.$setUntouched();
        }

        $scope.cancelNotification = function () {
            ClearNotification();
        }

        $scope.saveSubscriber = function () {
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/subscriber/update",
                    data: {
                        _id: $scope.SID, SubscriberName: $scope.model.SubscriberName, SubscriberEmail: $scope.model.SubscriberEmail,
                    },
                });
                ClearSubscriber();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshSubscriber();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/subscriber/add",
                    data: {
                        SubscriberName: $scope.model.SubscriberName, SubscriberEmail: $scope.model.SubscriberEmail,
                    },
                });
                ClearSubscriber();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshSubscriber();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Subscriberinfo = function (SubscriberId) {

            $scope.SID = SubscriberId;
            $scope.Update = true;
            $scope.SubscriberinfoId = SubscriberId;
            var info = $scope.Subscriberdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == SubscriberId) {
                    $scope.model.SubscriberName = info[i].SubscriberName;
                    $scope.model.SubscriberEmail = info[i].SubscriberEmail;
                }
            }
        }

        $http.get($rootScope.WebURL + "/subscriber")
            .then(function (Subscriberdata) {
                $scope.Subscriberdatas = Subscriberdata.data.data;
            });

        function RefreshSubscriber() {

            $http.get($rootScope.WebURL + "/subscriber")
                .then(function (Subscriberdata) {
                    $scope.Subscriberdatas = Subscriberdata.data.data;
                });
        }

        function ClearSubscriber() {

            $scope.model.SubscriberName = '';
            $scope.model.SubscriberEmail = '';
            $scope.qualificationform7.$setPristine();
            $scope.qualificationform7.$setUntouched();
        }

        $scope.cancelSubscriber = function () {
            ClearSubscriber();
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };



    }

})();
/*
 * angular-ui-bootstrap
 * https://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.tabindex", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.datepicker", "ui.bootstrap.position", "ui.bootstrap.datepickerPopup", "ui.bootstrap.debounce", "ui.bootstrap.multiMap", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/year.html", "uib/template/datepickerPopup/popup.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

    .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
        var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
        return {
            link: function (scope, element, attrs) {
                var expandingExpr = $parse(attrs.expanding),
                    expandedExpr = $parse(attrs.expanded),
                    collapsingExpr = $parse(attrs.collapsing),
                    collapsedExpr = $parse(attrs.collapsed),
                    horizontal = false,
                    css = {},
                    cssTo = {};

                init();

                function init() {
                    horizontal = !!('horizontal' in attrs);
                    if (horizontal) {
                        css = {
                            width: ''
                        };
                        cssTo = { width: '0' };
                    } else {
                        css = {
                            height: ''
                        };
                        cssTo = { height: '0' };
                    }
                    if (!scope.$eval(attrs.uibCollapse)) {
                        element.addClass('in')
                            .addClass('collapse')
                            .attr('aria-expanded', true)
                            .attr('aria-hidden', false)
                            .css(css);
                    }
                }

                function getScrollFromElement(element) {
                    if (horizontal) {
                        return { width: element.scrollWidth + 'px' };
                    }
                    return { height: element.scrollHeight + 'px' };
                }

                function expand() {
                    if (element.hasClass('collapse') && element.hasClass('in')) {
                        return;
                    }

                    $q.resolve(expandingExpr(scope))
                        .then(function () {
                            element.removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', true)
                                .attr('aria-hidden', false);

                            if ($animateCss) {
                                $animateCss(element, {
                                    addClass: 'in',
                                    easing: 'ease',
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).start()['finally'](expandDone);
                            } else {
                                $animate.addClass(element, 'in', {
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).then(expandDone);
                            }
                        }, angular.noop);
                }

                function expandDone() {
                    element.removeClass('collapsing')
                        .addClass('collapse')
                        .css(css);
                    expandedExpr(scope);
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    $q.resolve(collapsingExpr(scope))
                        .then(function () {
                            element
                                // IMPORTANT: The width must be set before adding "collapsing" class.
                                // Otherwise, the browser attempts to animate from width 0 (in
                                // collapsing class) to the given width here.
                                .css(getScrollFromElement(element[0]))
                                // initially all panel collapse have the collapse class, this removal
                                // prevents the animation from jumping to collapsed state
                                .removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', false)
                                .attr('aria-hidden', true);

                            if ($animateCss) {
                                $animateCss(element, {
                                    removeClass: 'in',
                                    to: cssTo
                                }).start()['finally'](collapseDone);
                            } else {
                                $animate.removeClass(element, 'in', {
                                    to: cssTo
                                }).then(collapseDone);
                            }
                        }, angular.noop);
                }

                function collapseDone() {
                    element.css(cssTo); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing')
                        .addClass('collapse');
                    collapsedExpr(scope);
                }

                scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.tabindex', [])

    .directive('uibTabindexToggle', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                attrs.$observe('disabled', function (disabled) {
                    attrs.$set('tabindex', disabled ? -1 : null);
                });
            }
        };
    });

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

    .constant('uibAccordionConfig', {
        closeOthers: true
    })

    .controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
        // This array keeps track of the accordion groups
        this.groups = [];

        // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
        this.closeOthers = function (openGroup) {
            var closeOthers = angular.isDefined($attrs.closeOthers) ?
                $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
            if (closeOthers) {
                angular.forEach(this.groups, function (group) {
                    if (group !== openGroup) {
                        group.isOpen = false;
                    }
                });
            }
        };

        // This is called from the accordion-group directive to add itself to the accordion
        this.addGroup = function (groupScope) {
            var that = this;
            this.groups.push(groupScope);

            groupScope.$on('$destroy', function (event) {
                that.removeGroup(groupScope);
            });
        };

        // This is called from the accordion-group directive when to remove itself
        this.removeGroup = function (group) {
            var index = this.groups.indexOf(group);
            if (index !== -1) {
                this.groups.splice(index, 1);
            }
        };
    }])

    // The accordion directive simply sets up the directive controller
    // and adds an accordion CSS class to itself element.
    .directive('uibAccordion', function () {
        return {
            controller: 'UibAccordionController',
            controllerAs: 'accordion',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion.html';
            }
        };
    })

    // The accordion-group directive indicates a block of html that will expand and collapse in an accordion
    .directive('uibAccordionGroup', function () {
        return {
            require: '^uibAccordion',         // We need this directive to be inside an accordion
            transclude: true,              // It transcludes the contents of the directive into the template
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
            },
            scope: {
                heading: '@',               // Interpolate the heading attribute onto this scope
                panelClass: '@?',           // Ditto with panelClass
                isOpen: '=?',
                isDisabled: '=?'
            },
            controller: function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            },
            link: function (scope, element, attrs, accordionCtrl) {
                element.addClass('panel');
                accordionCtrl.addGroup(scope);

                scope.openClass = attrs.openClass || 'panel-open';
                scope.panelClass = attrs.panelClass || 'panel-default';
                scope.$watch('isOpen', function (value) {
                    element.toggleClass(scope.openClass, !!value);
                    if (value) {
                        accordionCtrl.closeOthers(scope);
                    }
                });

                scope.toggleOpen = function ($event) {
                    if (!scope.isDisabled) {
                        if (!$event || $event.which === 32) {
                            scope.isOpen = !scope.isOpen;
                        }
                    }
                };

                var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
                scope.headingId = id + '-tab';
                scope.panelId = id + '-panel';
            }
        };
    })

    // Use accordion-heading below an accordion-group to provide a heading containing HTML
    .directive('uibAccordionHeading', function () {
        return {
            transclude: true,   // Grab the contents to be used as the heading
            template: '',       // In effect remove this element!
            replace: true,
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, accordionGroupCtrl, transclude) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
            }
        };
    })

    // Use in the accordion-group template to indicate where you want the heading to be transcluded
    // You must provide the property on the accordion-group controller that will hold the transcluded element
    .directive('uibAccordionTransclude', function () {
        return {
            require: '^uibAccordionGroup',
            link: function (scope, element, attrs, controller) {
                scope.$watch(function () { return controller[attrs.uibAccordionTransclude]; }, function (heading) {
                    if (heading) {
                        var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
                        elem.html('');
                        elem.append(heading);
                    }
                });
            }
        };

        function getHeaderSelectors() {
            return 'uib-accordion-header,' +
                'data-uib-accordion-header,' +
                'x-uib-accordion-header,' +
                'uib\\:accordion-header,' +
                '[uib-accordion-header],' +
                '[data-uib-accordion-header],' +
                '[x-uib-accordion-header]';
        }
    });

angular.module('ui.bootstrap.alert', [])

    .controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
        $scope.closeable = !!$attrs.close;
        $element.addClass('alert');
        $attrs.$set('role', 'alert');
        if ($scope.closeable) {
            $element.addClass('alert-dismissible');
        }

        var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
            $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

        if (dismissOnTimeout) {
            $timeout(function () {
                $scope.close();
            }, parseInt(dismissOnTimeout, 10));
        }
    }])

    .directive('uibAlert', function () {
        return {
            controller: 'UibAlertController',
            controllerAs: 'alert',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/alert/alert.html';
            },
            transclude: true,
            scope: {
                close: '&'
            }
        };
    });

angular.module('ui.bootstrap.buttons', [])

    .constant('uibButtonConfig', {
        activeClass: 'active',
        toggleEvent: 'click'
    })

    .controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
        this.activeClass = buttonConfig.activeClass || 'active';
        this.toggleEvent = buttonConfig.toggleEvent || 'click';
    }])

    .directive('uibBtnRadio', ['$parse', function ($parse) {
        return {
            require: ['uibBtnRadio', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'buttons',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                var uncheckableExpr = $parse(attrs.uibUncheckable);

                element.find('input').css({ display: 'none' });

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    var isActive = element.hasClass(buttonsCtrl.activeClass);

                    if (!isActive || angular.isDefined(attrs.uncheckable)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });

                if (attrs.uibUncheckable) {
                    scope.$watch(uncheckableExpr, function (uncheckable) {
                        attrs.$set('uncheckable', uncheckable ? '' : undefined);
                    });
                }
            }
        };
    }])

    .directive('uibBtnCheckbox', function () {
        return {
            require: ['uibBtnCheckbox', 'ngModel'],
            controller: 'UibButtonsController',
            controllerAs: 'button',
            link: function (scope, element, attrs, ctrls) {
                var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                element.find('input').css({ display: 'none' });

                function getTrueValue() {
                    return getCheckboxValue(attrs.btnCheckboxTrue, true);
                }

                function getFalseValue() {
                    return getCheckboxValue(attrs.btnCheckboxFalse, false);
                }

                function getCheckboxValue(attribute, defaultValue) {
                    return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                };

                //ui->model
                element.on(buttonsCtrl.toggleEvent, function () {
                    if (attrs.disabled) {
                        return;
                    }

                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    });

angular.module('ui.bootstrap.carousel', [])

    .controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
        var self = this,
            slides = self.slides = $scope.slides = [],
            SLIDE_DIRECTION = 'uib-slideDirection',
            currentIndex = $scope.active,
            currentInterval, isPlaying;

        var destroyed = false;
        $element.addClass('carousel');

        self.addSlide = function (slide, element) {
            slides.push({
                slide: slide,
                element: element
            });
            slides.sort(function (a, b) {
                return +a.slide.index - +b.slide.index;
            });
            //if this is the first slide or the slide is set to active, select it
            if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition = null;
                }

                currentIndex = slide.index;
                $scope.active = slide.index;
                setActive(currentIndex);
                self.select(slides[findSlideIndex(slide)]);
                if (slides.length === 1) {
                    $scope.play();
                }
            }
        };

        self.getCurrentIndex = function () {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide.index === currentIndex) {
                    return i;
                }
            }
        };

        self.next = $scope.next = function () {
            var newIndex = (self.getCurrentIndex() + 1) % slides.length;

            if (newIndex === 0 && $scope.noWrap()) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'next');
        };

        self.prev = $scope.prev = function () {
            var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

            if ($scope.noWrap() && newIndex === slides.length - 1) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'prev');
        };

        self.removeSlide = function (slide) {
            var index = findSlideIndex(slide);

            //get the index of the slide inside the carousel
            slides.splice(index, 1);
            if (slides.length > 0 && currentIndex === index) {
                if (index >= slides.length) {
                    currentIndex = slides.length - 1;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[slides.length - 1]);
                } else {
                    currentIndex = index;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
                $scope.active = currentIndex;
            }

            //clean the active value when no more slide
            if (slides.length === 0) {
                currentIndex = null;
                $scope.active = null;
            }
        };

        /* direction: "prev" or "next" */
        self.select = $scope.select = function (nextSlide, direction) {
            var nextIndex = findSlideIndex(nextSlide.slide);
            //Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            }
            //Prevent this user-triggered transition from occurring if there is already one in progress
            if (nextSlide.slide.index !== currentIndex &&
                !$scope.$currentTransition) {
                goNext(nextSlide.slide, nextIndex, direction);
            }
        };

        /* Allow outside people to call indexOf on slides array */
        $scope.indexOfSlide = function (slide) {
            return +slide.slide.index;
        };

        $scope.isActive = function (slide) {
            return $scope.active === slide.slide.index;
        };

        $scope.isPrevDisabled = function () {
            return $scope.active === 0 && $scope.noWrap();
        };

        $scope.isNextDisabled = function () {
            return $scope.active === slides.length - 1 && $scope.noWrap();
        };

        $scope.pause = function () {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };

        $scope.play = function () {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };

        $element.on('mouseenter', $scope.pause);
        $element.on('mouseleave', $scope.play);

        $scope.$on('$destroy', function () {
            destroyed = true;
            resetTimer();
        });

        $scope.$watch('noTransition', function (noTransition) {
            $animate.enabled($element, !noTransition);
        });

        $scope.$watch('interval', restartTimer);

        $scope.$watchCollection('slides', resetTransition);

        $scope.$watch('active', function (index) {
            if (angular.isNumber(index) && currentIndex !== index) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i].slide.index === index) {
                        index = i;
                        break;
                    }
                }

                var slide = slides[index];
                if (slide) {
                    setActive(index);
                    self.select(slides[index]);
                    currentIndex = index;
                }
            }
        });

        function getSlideByIndex(index) {
            for (var i = 0, l = slides.length; i < l; ++i) {
                if (slides[i].index === index) {
                    return slides[i];
                }
            }
        }

        function setActive(index) {
            for (var i = 0; i < slides.length; i++) {
                slides[i].slide.active = i === index;
            }
        }

        function goNext(slide, index, direction) {
            if (destroyed) {
                return;
            }

            angular.extend(slide, { direction: direction });
            angular.extend(slides[currentIndex].slide || {}, { direction: direction });
            if ($animate.enabled($element) && !$scope.$currentTransition &&
                slides[index].element && self.slides.length > 1) {
                slides[index].element.data(SLIDE_DIRECTION, slide.direction);
                var currentIdx = self.getCurrentIndex();

                if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
                    slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
                }

                $scope.$currentTransition = true;
                $animate.on('addClass', slides[index].element, function (element, phase) {
                    if (phase === 'close') {
                        $scope.$currentTransition = null;
                        $animate.off('addClass', element);
                    }
                });
            }

            $scope.active = slide.index;
            currentIndex = slide.index;
            setActive(index);

            //every time you change slides, reset the timer
            restartTimer();
        }

        function findSlideIndex(slide) {
            for (var i = 0; i < slides.length; i++) {
                if (slides[i].slide === slide) {
                    return i;
                }
            }
        }

        function resetTimer() {
            if (currentInterval) {
                $interval.cancel(currentInterval);
                currentInterval = null;
            }
        }

        function resetTransition(slides) {
            if (!slides.length) {
                $scope.$currentTransition = null;
            }
        }

        function restartTimer() {
            resetTimer();
            var interval = +$scope.interval;
            if (!isNaN(interval) && interval > 0) {
                currentInterval = $interval(timerFn, interval);
            }
        }

        function timerFn() {
            var interval = +$scope.interval;
            if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
                $scope.next();
            } else {
                $scope.pause();
            }
        }
    }])

    .directive('uibCarousel', function () {
        return {
            transclude: true,
            controller: 'UibCarouselController',
            controllerAs: 'carousel',
            restrict: 'A',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/carousel.html';
            },
            scope: {
                active: '=',
                interval: '=',
                noTransition: '=',
                noPause: '=',
                noWrap: '&'
            }
        };
    })

    .directive('uibSlide', ['$animate', function ($animate) {
        return {
            require: '^uibCarousel',
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/carousel/slide.html';
            },
            scope: {
                actual: '=?',
                index: '=?'
            },
            link: function (scope, element, attrs, carouselCtrl) {
                element.addClass('item');
                carouselCtrl.addSlide(scope, element);
                //when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', function () {
                    carouselCtrl.removeSlide(scope);
                });

                scope.$watch('active', function (active) {
                    $animate[active ? 'addClass' : 'removeClass'](element, 'active');
                });
            }
        };
    }])

    .animation('.item', ['$animateCss',
        function ($animateCss) {
            var SLIDE_DIRECTION = 'uib-slideDirection';

            function removeClass(element, className, callback) {
                element.removeClass(className);
                if (callback) {
                    callback();
                }
            }

            return {
                beforeAddClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element,
                            directionClass + ' ' + direction, done);
                        element.addClass(direction);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                },
                beforeRemoveClass: function (element, className, done) {
                    if (className === 'active') {
                        var stopped = false;
                        var direction = element.data(SLIDE_DIRECTION);
                        var directionClass = direction === 'next' ? 'left' : 'right';
                        var removeClassFn = removeClass.bind(this, element, directionClass, done);

                        $animateCss(element, { addClass: directionClass })
                            .start()
                            .done(removeClassFn);

                        return function () {
                            stopped = true;
                        };
                    }
                    done();
                }
            };
        }]);

angular.module('ui.bootstrap.dateparser', [])

    .service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
        // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
        var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

        var localeId;
        var formatCodeToRegex;

        this.init = function () {
            localeId = $locale.id;

            this.parsers = {};
            this.formatters = {};

            formatCodeToRegex = [
                {
                    key: 'yyyy',
                    regex: '\\d{4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yyyy');
                    }
                },
                {
                    key: 'yy',
                    regex: '\\d{2}',
                    apply: function (value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'yy');
                    }
                },
                {
                    key: 'y',
                    regex: '\\d{1,4}',
                    apply: function (value) { this.year = +value; },
                    formatter: function (date) {
                        var _date = new Date();
                        _date.setFullYear(Math.abs(date.getFullYear()));
                        return dateFilter(_date, 'y');
                    }
                },
                {
                    key: 'M!',
                    regex: '0?[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) {
                        var value = date.getMonth();
                        if (/^[0-9]$/.test(value)) {
                            return dateFilter(date, 'MM');
                        }

                        return dateFilter(date, 'M');
                    }
                },
                {
                    key: 'MMMM',
                    regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMMM'); }
                },
                {
                    key: 'MMM',
                    regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'MMM'); }
                },
                {
                    key: 'MM',
                    regex: '0[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'MM'); }
                },
                {
                    key: 'M',
                    regex: '[1-9]|1[0-2]',
                    apply: function (value) { this.month = value - 1; },
                    formatter: function (date) { return dateFilter(date, 'M'); }
                },
                {
                    key: 'd!',
                    regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) {
                        var value = date.getDate();
                        if (/^[1-9]$/.test(value)) {
                            return dateFilter(date, 'dd');
                        }

                        return dateFilter(date, 'd');
                    }
                },
                {
                    key: 'dd',
                    regex: '[0-2][0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'dd'); }
                },
                {
                    key: 'd',
                    regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
                    apply: function (value) { this.date = +value; },
                    formatter: function (date) { return dateFilter(date, 'd'); }
                },
                {
                    key: 'EEEE',
                    regex: $locale.DATETIME_FORMATS.DAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEEE'); }
                },
                {
                    key: 'EEE',
                    regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
                    formatter: function (date) { return dateFilter(date, 'EEE'); }
                },
                {
                    key: 'HH',
                    regex: '(?:0|1)[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'HH'); }
                },
                {
                    key: 'hh',
                    regex: '0[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'hh'); }
                },
                {
                    key: 'H',
                    regex: '1?[0-9]|2[0-3]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'H'); }
                },
                {
                    key: 'h',
                    regex: '[0-9]|1[0-2]',
                    apply: function (value) { this.hours = +value; },
                    formatter: function (date) { return dateFilter(date, 'h'); }
                },
                {
                    key: 'mm',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'mm'); }
                },
                {
                    key: 'm',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.minutes = +value; },
                    formatter: function (date) { return dateFilter(date, 'm'); }
                },
                {
                    key: 'sss',
                    regex: '[0-9][0-9][0-9]',
                    apply: function (value) { this.milliseconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'sss'); }
                },
                {
                    key: 'ss',
                    regex: '[0-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 'ss'); }
                },
                {
                    key: 's',
                    regex: '[0-9]|[1-5][0-9]',
                    apply: function (value) { this.seconds = +value; },
                    formatter: function (date) { return dateFilter(date, 's'); }
                },
                {
                    key: 'a',
                    regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
                    apply: function (value) {
                        if (this.hours === 12) {
                            this.hours = 0;
                        }

                        if (value === 'PM') {
                            this.hours += 12;
                        }
                    },
                    formatter: function (date) { return dateFilter(date, 'a'); }
                },
                {
                    key: 'Z',
                    regex: '[+-]\\d{4}',
                    apply: function (value) {
                        var matches = value.match(/([+-])(\d{2})(\d{2})/),
                            sign = matches[1],
                            hours = matches[2],
                            minutes = matches[3];
                        this.hours += toInt(sign + hours);
                        this.minutes += toInt(sign + minutes);
                    },
                    formatter: function (date) {
                        return dateFilter(date, 'Z');
                    }
                },
                {
                    key: 'ww',
                    regex: '[0-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'ww'); }
                },
                {
                    key: 'w',
                    regex: '[0-9]|[1-4][0-9]|5[0-3]',
                    formatter: function (date) { return dateFilter(date, 'w'); }
                },
                {
                    key: 'GGGG',
                    regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
                    formatter: function (date) { return dateFilter(date, 'GGGG'); }
                },
                {
                    key: 'GGG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GGG'); }
                },
                {
                    key: 'GG',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'GG'); }
                },
                {
                    key: 'G',
                    regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
                    formatter: function (date) { return dateFilter(date, 'G'); }
                }
            ];

            if (angular.version.major >= 1 && angular.version.minor > 4) {
                formatCodeToRegex.push({
                    key: 'LLLL',
                    regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
                    apply: function (value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
                    formatter: function (date) { return dateFilter(date, 'LLLL'); }
                });
            }
        };

        this.init();

        function getFormatCodeToRegex(key) {
            return filterFilter(formatCodeToRegex, { key: key }, true)[0];
        }

        this.getParser = function (key) {
            var f = getFormatCodeToRegex(key);
            return f && f.apply || null;
        };

        this.overrideParser = function (key, parser) {
            var f = getFormatCodeToRegex(key);
            if (f && angular.isFunction(parser)) {
                this.parsers = {};
                f.apply = parser;
            }
        }.bind(this);

        function createParser(format) {
            var map = [], regex = format.split('');

            // check for literal values
            var quoteIndex = format.indexOf('\'');
            if (quoteIndex > -1) {
                var inLiteral = false;
                format = format.split('');
                for (var i = quoteIndex; i < format.length; i++) {
                    if (inLiteral) {
                        if (format[i] === '\'') {
                            if (i + 1 < format.length && format[i + 1] === '\'') { // escaped single quote
                                format[i + 1] = '$';
                                regex[i + 1] = '';
                            } else { // end of literal
                                regex[i] = '';
                                inLiteral = false;
                            }
                        }
                        format[i] = '$';
                    } else {
                        if (format[i] === '\'') { // start of literal
                            format[i] = '$';
                            regex[i] = '';
                            inLiteral = true;
                        }
                    }
                }

                format = format.join('');
            }

            angular.forEach(formatCodeToRegex, function (data) {
                var index = format.indexOf(data.key);

                if (index > -1) {
                    format = format.split('');

                    regex[index] = '(' + data.regex + ')';
                    format[index] = '$'; // Custom symbol to define consumed part of format
                    for (var i = index + 1, n = index + data.key.length; i < n; i++) {
                        regex[i] = '';
                        format[i] = '$';
                    }
                    format = format.join('');

                    map.push({
                        index: index,
                        key: data.key,
                        apply: data.apply,
                        matcher: data.regex
                    });
                }
            });

            return {
                regex: new RegExp('^' + regex.join('') + '$'),
                map: orderByFilter(map, 'index')
            };
        }

        function createFormatter(format) {
            var formatters = [];
            var i = 0;
            var formatter, literalIdx;
            while (i < format.length) {
                if (angular.isNumber(literalIdx)) {
                    if (format.charAt(i) === '\'') {
                        if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
                            formatters.push(constructLiteralFormatter(format, literalIdx, i));
                            literalIdx = null;
                        }
                    } else if (i === format.length) {
                        while (literalIdx < format.length) {
                            formatter = constructFormatterFromIdx(format, literalIdx);
                            formatters.push(formatter);
                            literalIdx = formatter.endIdx;
                        }
                    }

                    i++;
                    continue;
                }

                if (format.charAt(i) === '\'') {
                    literalIdx = i;
                    i++;
                    continue;
                }

                formatter = constructFormatterFromIdx(format, i);

                formatters.push(formatter.parser);
                i = formatter.endIdx;
            }

            return formatters;
        }

        function constructLiteralFormatter(format, literalIdx, endIdx) {
            return function () {
                return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
            };
        }

        function constructFormatterFromIdx(format, i) {
            var currentPosStr = format.substr(i);
            for (var j = 0; j < formatCodeToRegex.length; j++) {
                if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
                    var data = formatCodeToRegex[j];
                    return {
                        endIdx: i + data.key.length,
                        parser: data.formatter
                    };
                }
            }

            return {
                endIdx: i + 1,
                parser: function () {
                    return currentPosStr.charAt(0);
                }
            };
        }

        this.filter = function (date, format) {
            if (!angular.isDate(date) || isNaN(date) || !format) {
                return '';
            }

            format = $locale.DATETIME_FORMATS[format] || format;

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.formatters[format]) {
                this.formatters[format] = createFormatter(format);
            }

            var formatters = this.formatters[format];

            return formatters.reduce(function (str, formatter) {
                return str + formatter(date);
            }, '');
        };

        this.parse = function (input, format, baseDate) {
            if (!angular.isString(input) || !format) {
                return input;
            }

            format = $locale.DATETIME_FORMATS[format] || format;
            format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

            if ($locale.id !== localeId) {
                this.init();
            }

            if (!this.parsers[format]) {
                this.parsers[format] = createParser(format, 'apply');
            }

            var parser = this.parsers[format],
                regex = parser.regex,
                map = parser.map,
                results = input.match(regex),
                tzOffset = false;
            if (results && results.length) {
                var fields, dt;
                if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
                    fields = {
                        year: baseDate.getFullYear(),
                        month: baseDate.getMonth(),
                        date: baseDate.getDate(),
                        hours: baseDate.getHours(),
                        minutes: baseDate.getMinutes(),
                        seconds: baseDate.getSeconds(),
                        milliseconds: baseDate.getMilliseconds()
                    };
                } else {
                    if (baseDate) {
                        $log.warn('dateparser:', 'baseDate is not a valid date');
                    }
                    fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
                }

                for (var i = 1, n = results.length; i < n; i++) {
                    var mapper = map[i - 1];
                    if (mapper.matcher === 'Z') {
                        tzOffset = true;
                    }

                    if (mapper.apply) {
                        mapper.apply.call(fields, results[i]);
                    }
                }

                var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
                    Date.prototype.setFullYear;
                var timesetter = tzOffset ? Date.prototype.setUTCHours :
                    Date.prototype.setHours;

                if (isValid(fields.year, fields.month, fields.date)) {
                    if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
                        dt = new Date(baseDate);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours, fields.minutes,
                            fields.seconds, fields.milliseconds);
                    } else {
                        dt = new Date(0);
                        datesetter.call(dt, fields.year, fields.month, fields.date);
                        timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
                            fields.seconds || 0, fields.milliseconds || 0);
                    }
                }

                return dt;
            }
        };

        // Check if date is valid for specific month (and year for February).
        // Month: 0 = Jan, 1 = Feb, etc
        function isValid(year, month, date) {
            if (date < 1) {
                return false;
            }

            if (month === 1 && date > 28) {
                return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
            }

            if (month === 3 || month === 5 || month === 8 || month === 10) {
                return date < 31;
            }

            return true;
        }

        function toInt(str) {
            return parseInt(str, 10);
        }

        this.toTimezone = toTimezone;
        this.fromTimezone = fromTimezone;
        this.timezoneToOffset = timezoneToOffset;
        this.addDateMinutes = addDateMinutes;
        this.convertTimezoneToLocal = convertTimezoneToLocal;

        function toTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
        }

        function fromTimezone(date, timezone) {
            return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
        }

        //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
        function timezoneToOffset(timezone, fallback) {
            timezone = timezone.replace(/:/g, '');
            var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
            return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
        }

        function addDateMinutes(date, minutes) {
            date = new Date(date.getTime());
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function convertTimezoneToLocal(date, timezone, reverse) {
            reverse = reverse ? -1 : 1;
            var dateTimezoneOffset = date.getTimezoneOffset();
            var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
            return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
        }
    }]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
    .directive('uibIsClass', [
        '$animate',
        function ($animate) {
            //                    11111111          22222222
            var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
            //                    11111111           22222222
            var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

            var dataPerTracked = {};

            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    var linkedScopes = [];
                    var instances = [];
                    var expToData = {};
                    var lastActivated = null;
                    var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
                    var onExp = onExpMatches[2];
                    var expsStr = onExpMatches[1];
                    var exps = expsStr.split(',');

                    return linkFn;

                    function linkFn(scope, element, attrs) {
                        linkedScopes.push(scope);
                        instances.push({
                            scope: scope,
                            element: element
                        });

                        exps.forEach(function (exp, k) {
                            addForExp(exp, scope);
                        });

                        scope.$on('$destroy', removeScope);
                    }

                    function addForExp(exp, scope) {
                        var matches = exp.match(IS_REGEXP);
                        var clazz = scope.$eval(matches[1]);
                        var compareWithExp = matches[2];
                        var data = expToData[exp];
                        if (!data) {
                            var watchFn = function (compareWithVal) {
                                var newActivated = null;
                                instances.some(function (instance) {
                                    var thisVal = instance.scope.$eval(onExp);
                                    if (thisVal === compareWithVal) {
                                        newActivated = instance;
                                        return true;
                                    }
                                });
                                if (data.lastActivated !== newActivated) {
                                    if (data.lastActivated) {
                                        $animate.removeClass(data.lastActivated.element, clazz);
                                    }
                                    if (newActivated) {
                                        $animate.addClass(newActivated.element, clazz);
                                    }
                                    data.lastActivated = newActivated;
                                }
                            };
                            expToData[exp] = data = {
                                lastActivated: null,
                                scope: scope,
                                watchFn: watchFn,
                                compareWithExp: compareWithExp,
                                watcher: scope.$watch(compareWithExp, watchFn)
                            };
                        }
                        data.watchFn(scope.$eval(compareWithExp));
                    }

                    function removeScope(e) {
                        var removedScope = e.targetScope;
                        var index = linkedScopes.indexOf(removedScope);
                        linkedScopes.splice(index, 1);
                        instances.splice(index, 1);
                        if (linkedScopes.length) {
                            var newWatchScope = linkedScopes[0];
                            angular.forEach(expToData, function (data) {
                                if (data.scope === removedScope) {
                                    data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
                                    data.scope = newWatchScope;
                                }
                            });
                        } else {
                            expToData = {};
                        }
                    }
                }
            };
        }]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

    .value('$datepickerSuppressError', false)

    .value('$datepickerLiteralWarning', true)

    .constant('uibDatepickerConfig', {
        datepickerMode: 'day',
        formatDay: 'dd',
        formatMonth: 'MMMM',
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM yyyy',
        formatMonthTitle: 'yyyy',
        maxDate: null,
        maxMode: 'year',
        minDate: null,
        minMode: 'day',
        monthColumns: 3,
        ngModelOptions: {},
        shortcutPropagation: false,
        showWeeks: true,
        yearColumns: 5,
        yearRows: 4
    })

    .controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
        function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
            var self = this,
                ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
                ngModelOptions = {},
                watchListeners = [];

            $element.addClass('uib-datepicker');
            $attrs.$set('role', 'application');

            if (!$scope.datepickerOptions) {
                $scope.datepickerOptions = {};
            }

            // Modes chain
            this.modes = ['day', 'month', 'year'];

            [
                'customClass',
                'dateDisabled',
                'datepickerMode',
                'formatDay',
                'formatDayHeader',
                'formatDayTitle',
                'formatMonth',
                'formatMonthTitle',
                'formatYear',
                'maxDate',
                'maxMode',
                'minDate',
                'minMode',
                'monthColumns',
                'showWeeks',
                'shortcutPropagation',
                'startingDay',
                'yearColumns',
                'yearRows'
            ].forEach(function (key) {
                switch (key) {
                    case 'customClass':
                    case 'dateDisabled':
                        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
                        break;
                    case 'datepickerMode':
                        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
                            $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
                        break;
                    case 'formatDay':
                    case 'formatDayHeader':
                    case 'formatDayTitle':
                    case 'formatMonth':
                    case 'formatMonthTitle':
                    case 'formatYear':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $interpolate($scope.datepickerOptions[key])($scope.$parent) :
                            datepickerConfig[key];
                        break;
                    case 'monthColumns':
                    case 'showWeeks':
                    case 'shortcutPropagation':
                    case 'yearColumns':
                    case 'yearRows':
                        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
                            $scope.datepickerOptions[key] : datepickerConfig[key];
                        break;
                    case 'startingDay':
                        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
                            self.startingDay = $scope.datepickerOptions.startingDay;
                        } else if (angular.isNumber(datepickerConfig.startingDay)) {
                            self.startingDay = datepickerConfig.startingDay;
                        } else {
                            self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
                        }

                        break;
                    case 'maxDate':
                    case 'minDate':
                        $scope.$watch('datepickerOptions.' + key, function (value) {
                            if (value) {
                                if (angular.isDate(value)) {
                                    self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
                                } else {
                                    if ($datepickerLiteralWarning) {
                                        $log.warn('Literal date support has been deprecated, please switch to date object usage');
                                    }

                                    self[key] = new Date(dateFilter(value, 'medium'));
                                }
                            } else {
                                self[key] = datepickerConfig[key] ?
                                    dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
                                    null;
                            }

                            self.refreshView();
                        });

                        break;
                    case 'maxMode':
                    case 'minMode':
                        if ($scope.datepickerOptions[key]) {
                            $scope.$watch(function () { return $scope.datepickerOptions[key]; }, function (value) {
                                self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
                                if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
                                    key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
                                    $scope.datepickerMode = self[key];
                                    $scope.datepickerOptions.datepickerMode = self[key];
                                }
                            });
                        } else {
                            self[key] = $scope[key] = datepickerConfig[key] || null;
                        }

                        break;
                }
            });

            $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if (angular.isDefined($attrs.ngDisabled)) {
                watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
                    $scope.disabled = disabled;
                    self.refreshView();
                }));
            }

            $scope.isActive = function (dateObject) {
                if (self.compare(dateObject.date, self.activeDate) === 0) {
                    $scope.activeDateId = dateObject.uid;
                    return true;
                }
                return false;
            };

            this.init = function (ngModelCtrl_) {
                ngModelCtrl = ngModelCtrl_;
                ngModelOptions = extractOptions(ngModelCtrl);

                if ($scope.datepickerOptions.initDate) {
                    self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
                    $scope.$watch('datepickerOptions.initDate', function (initDate) {
                        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                            self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
                            self.refreshView();
                        }
                    });
                } else {
                    self.activeDate = new Date();
                }

                var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
                this.activeDate = !isNaN(date) ?
                    dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
                    dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

                ngModelCtrl.$render = function () {
                    self.render();
                };
            };

            this.render = function () {
                if (ngModelCtrl.$viewValue) {
                    var date = new Date(ngModelCtrl.$viewValue),
                        isValid = !isNaN(date);

                    if (isValid) {
                        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    } else if (!$datepickerSuppressError) {
                        $log.error('Datepicker directive: "ng-model" value must be a Date object');
                    }
                }
                this.refreshView();
            };

            this.refreshView = function () {
                if (this.element) {
                    $scope.selectedDt = null;
                    this._refreshView();
                    if ($scope.activeDt) {
                        $scope.activeDateId = $scope.activeDt.uid;
                    }

                    var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                    date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setValidity('dateDisabled', !date ||
                        this.element && !this.isDisabled(date));
                }
            };

            this.createDateObject = function (date, format) {
                var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
                model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
                var today = new Date();
                today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                var time = this.compare(date, today);
                var dt = {
                    date: date,
                    label: dateParser.filter(date, format),
                    selected: model && this.compare(date, model) === 0,
                    disabled: this.isDisabled(date),
                    past: time < 0,
                    current: time === 0,
                    future: time > 0,
                    customClass: this.customClass(date) || null
                };

                if (model && this.compare(date, model) === 0) {
                    $scope.selectedDt = dt;
                }

                if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
                    $scope.activeDt = dt;
                }

                return dt;
            };

            this.isDisabled = function (date) {
                return $scope.disabled ||
                    this.minDate && this.compare(date, this.minDate) < 0 ||
                    this.maxDate && this.compare(date, this.maxDate) > 0 ||
                    $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
            };

            this.customClass = function (date) {
                return $scope.customClass({ date: date, mode: $scope.datepickerMode });
            };

            // Split array into smaller arrays
            this.split = function (arr, size) {
                var arrays = [];
                while (arr.length > 0) {
                    arrays.push(arr.splice(0, size));
                }
                return arrays;
            };

            $scope.select = function (date) {
                if ($scope.datepickerMode === self.minMode) {
                    var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
                    dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
                    ngModelCtrl.$setViewValue(dt);
                    ngModelCtrl.$render();
                } else {
                    self.activeDate = date;
                    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

                    $scope.$emit('uib:datepicker.mode');
                }

                $scope.$broadcast('uib:datepicker.focus');
            };

            $scope.move = function (direction) {
                var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
                    month = self.activeDate.getMonth() + direction * (self.step.months || 0);
                self.activeDate.setFullYear(year, month, 1);
                self.refreshView();
            };

            $scope.toggleMode = function (direction) {
                direction = direction || 1;

                if ($scope.datepickerMode === self.maxMode && direction === 1 ||
                    $scope.datepickerMode === self.minMode && direction === -1) {
                    return;
                }

                setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

                $scope.$emit('uib:datepicker.mode');
            };

            // Key event mapper
            $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

            var focusElement = function () {
                self.element[0].focus();
            };

            // Listen for focus requests from popup directive
            $scope.$on('uib:datepicker.focus', focusElement);

            $scope.keydown = function (evt) {
                var key = $scope.keys[evt.which];

                if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
                    return;
                }

                evt.preventDefault();
                if (!self.shortcutPropagation) {
                    evt.stopPropagation();
                }

                if (key === 'enter' || key === 'space') {
                    if (self.isDisabled(self.activeDate)) {
                        return; // do nothing
                    }
                    $scope.select(self.activeDate);
                } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
                    $scope.toggleMode(key === 'up' ? 1 : -1);
                } else {
                    self.handleKeyDown(key, evt);
                    self.refreshView();
                }
            };

            $element.on('keydown', function (evt) {
                $scope.$apply(function () {
                    $scope.keydown(evt);
                });
            });

            $scope.$on('$destroy', function () {
                //Clear all watch listeners on destroy
                while (watchListeners.length) {
                    watchListeners.shift()();
                }
            });

            function setMode(mode) {
                $scope.datepickerMode = mode;
                $scope.datepickerOptions.datepickerMode = mode;
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options ||
                        $scope.datepickerOptions.ngModelOptions ||
                        datepickerConfig.ngModelOptions ||
                        {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
                    var timezone = ngModelCtrl.$options.getOption('timezone') ||
                        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
                        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

                    // values passed to createChild override existing values
                    ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
                        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
                        .createChild($scope.datepickerOptions.ngModelOptions)
                        .createChild(ngModelCtrl.$options) // highest precedence
                        .createChild({ timezone: timezone }); // to keep from squashing a non-null value
                }

                return ngModelOptions;
            }
        }])

    .controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        this.step = { months: 1 };
        this.element = $element;
        function getDaysInMonth(year, month) {
            return month === 1 && year % 4 === 0 &&
                (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
        }

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            scope.showWeeks = ctrl.showWeeks;
            ctrl.refreshView();
        };

        this.getDates = function (startDate, n) {
            var dates = new Array(n), current = new Date(startDate), i = 0, date;
            while (i < n) {
                date = new Date(current);
                dates[i++] = date;
                current.setDate(current.getDate() + 1);
            }
            return dates;
        };

        this._refreshView = function () {
            var year = this.activeDate.getFullYear(),
                month = this.activeDate.getMonth(),
                firstDayOfMonth = new Date(this.activeDate);

            firstDayOfMonth.setFullYear(year, month, 1);

            var difference = this.startingDay - firstDayOfMonth.getDay(),
                numDisplayedFromPreviousMonth = difference > 0 ?
                    7 - difference : -difference,
                firstDate = new Date(firstDayOfMonth);

            if (numDisplayedFromPreviousMonth > 0) {
                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
            }

            // 42 is the number of days on a six-week calendar
            var days = this.getDates(firstDate, 42);
            for (var i = 0; i < 42; i++) {
                days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
                    secondary: days[i].getMonth() !== month,
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.labels = new Array(7);
            for (var j = 0; j < 7; j++) {
                scope.labels[j] = {
                    abbr: dateFilter(days[j].date, this.formatDayHeader),
                    full: dateFilter(days[j].date, 'EEEE')
                };
            }

            scope.title = dateFilter(this.activeDate, this.formatDayTitle);
            scope.rows = this.split(days, 7);

            if (scope.showWeeks) {
                scope.weekNumbers = [];
                var thursdayIndex = (4 + 7 - this.startingDay) % 7,
                    numWeeks = scope.rows.length;
                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
                    scope.weekNumbers.push(
                        getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
                }
            }
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        function getISO8601WeekNumber(date) {
            var checkDate = new Date(date);
            checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
            var time = checkDate.getTime();
            checkDate.setMonth(0); // Compare with Jan 1
            checkDate.setDate(1);
            return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        }

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getDate();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - 7;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + 7;
            } else if (key === 'pageup' || key === 'pagedown') {
                var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setMonth(month, 1);
                date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
            } else if (key === 'home') {
                date = 1;
            } else if (key === 'end') {
                date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
            }
            this.activeDate.setDate(date);
        };
    }])

    .controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        this.step = { years: 1 };
        this.element = $element;

        this.init = function (ctrl) {
            angular.extend(ctrl, this);
            ctrl.refreshView();
        };

        this._refreshView = function () {
            var months = new Array(12),
                year = this.activeDate.getFullYear(),
                date;

            for (var i = 0; i < 12; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(year, i, 1);
                months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
            scope.rows = this.split(months, this.monthColumns);
            scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
        };

        this.compare = function (date1, date2) {
            var _date1 = new Date(date1.getFullYear(), date1.getMonth());
            var _date2 = new Date(date2.getFullYear(), date2.getMonth());
            _date1.setFullYear(date1.getFullYear());
            _date2.setFullYear(date2.getFullYear());
            return _date1 - _date2;
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getMonth();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - this.monthColumns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + this.monthColumns;
            } else if (key === 'pageup' || key === 'pagedown') {
                var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
                this.activeDate.setFullYear(year);
            } else if (key === 'home') {
                date = 0;
            } else if (key === 'end') {
                date = 11;
            }
            this.activeDate.setMonth(date);
        };
    }])

    .controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
        var columns, range;
        this.element = $element;

        function getStartingYear(year) {
            return parseInt((year - 1) / range, 10) * range + 1;
        }

        this.yearpickerInit = function () {
            columns = this.yearColumns;
            range = this.yearRows * columns;
            this.step = { years: range };
        };

        this._refreshView = function () {
            var years = new Array(range), date;

            for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
                date = new Date(this.activeDate);
                date.setFullYear(start + i, 0, 1);
                years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
                    uid: scope.uniqueId + '-' + i
                });
            }

            scope.title = [years[0].label, years[range - 1].label].join(' - ');
            scope.rows = this.split(years, columns);
            scope.columns = columns;
        };

        this.compare = function (date1, date2) {
            return date1.getFullYear() - date2.getFullYear();
        };

        this.handleKeyDown = function (key, evt) {
            var date = this.activeDate.getFullYear();

            if (key === 'left') {
                date = date - 1;
            } else if (key === 'up') {
                date = date - columns;
            } else if (key === 'right') {
                date = date + 1;
            } else if (key === 'down') {
                date = date + columns;
            } else if (key === 'pageup' || key === 'pagedown') {
                date += (key === 'pageup' ? -1 : 1) * range;
            } else if (key === 'home') {
                date = getStartingYear(this.activeDate.getFullYear());
            } else if (key === 'end') {
                date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
            }
            this.activeDate.setFullYear(date);
        };
    }])

    .directive('uibDatepicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
            },
            scope: {
                datepickerOptions: '=?'
            },
            require: ['uibDatepicker', '^ngModel'],
            restrict: 'A',
            controller: 'UibDatepickerController',
            controllerAs: 'datepicker',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                datepickerCtrl.init(ngModelCtrl);
            }
        };
    })

    .directive('uibDaypicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/day.html';
            },
            require: ['^uibDatepicker', 'uibDaypicker'],
            restrict: 'A',
            controller: 'UibDaypickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    daypickerCtrl = ctrls[1];

                daypickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibMonthpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/month.html';
            },
            require: ['^uibDatepicker', 'uibMonthpicker'],
            restrict: 'A',
            controller: 'UibMonthpickerController',
            link: function (scope, element, attrs, ctrls) {
                var datepickerCtrl = ctrls[0],
                    monthpickerCtrl = ctrls[1];

                monthpickerCtrl.init(datepickerCtrl);
            }
        };
    })

    .directive('uibYearpicker', function () {
        return {
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepicker/year.html';
            },
            require: ['^uibDatepicker', 'uibYearpicker'],
            restrict: 'A',
            controller: 'UibYearpickerController',
            link: function (scope, element, attrs, ctrls) {
                var ctrl = ctrls[0];
                angular.extend(ctrl, ctrls[1]);
                ctrl.yearpickerInit();

                ctrl.refreshView();
            }
        };
    });

angular.module('ui.bootstrap.position', [])

    /**
     * A set of utility methods for working with the DOM.
     * It is meant to be used where we need to absolute-position elements in
     * relation to another element (this is the case for tooltips, popovers,
     * typeahead suggestions etc.).
     */
    .factory('$uibPosition', ['$document', '$window', function ($document, $window) {
        /**
         * Used by scrollbarWidth() function to cache scrollbar's width.
         * Do not access this variable directly, use scrollbarWidth() instead.
         */
        var SCROLLBAR_WIDTH;
        /**
         * scrollbar on body and html element in IE and Edge overlay
         * content and should be considered 0 width.
         */
        var BODY_SCROLLBAR_WIDTH;
        var OVERFLOW_REGEX = {
            normal: /(auto|scroll)/,
            hidden: /(auto|scroll|hidden)/
        };
        var PLACEMENT_REGEX = {
            auto: /\s?auto?\s?/i,
            primary: /^(top|bottom|left|right)$/,
            secondary: /^(top|bottom|left|right|center)$/,
            vertical: /^(top|bottom)$/
        };
        var BODY_REGEX = /(HTML|BODY)/;

        return {

            /**
             * Provides a raw DOM element from a jQuery/jQLite element.
             *
             * @param {element} elem - The element to convert.
             *
             * @returns {element} A HTML element.
             */
            getRawNode: function (elem) {
                return elem.nodeName ? elem : elem[0] || elem;
            },

            /**
             * Provides a parsed number for a style property.  Strips
             * units and casts invalid numbers to 0.
             *
             * @param {string} value - The style value to parse.
             *
             * @returns {number} A valid number.
             */
            parseStyle: function (value) {
                value = parseFloat(value);
                return isFinite(value) ? value : 0;
            },

            /**
             * Provides the closest positioned ancestor.
             *
             * @param {element} element - The element to get the offest parent for.
             *
             * @returns {element} The closest positioned ancestor.
             */
            offsetParent: function (elem) {
                elem = this.getRawNode(elem);

                var offsetParent = elem.offsetParent || $document[0].documentElement;

                function isStaticPositioned(el) {
                    return ($window.getComputedStyle(el).position || 'static') === 'static';
                }

                while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
                    offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || $document[0].documentElement;
            },

            /**
             * Provides the scrollbar width, concept from TWBS measureScrollbar()
             * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
             * In IE and Edge, scollbar on body and html element overlay and should
             * return a width of 0.
             *
             * @returns {number} The width of the browser scollbar.
             */
            scrollbarWidth: function (isBody) {
                if (isBody) {
                    if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
                        var bodyElem = $document.find('body');
                        bodyElem.addClass('uib-position-body-scrollbar-measure');
                        BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
                        BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
                        bodyElem.removeClass('uib-position-body-scrollbar-measure');
                    }
                    return BODY_SCROLLBAR_WIDTH;
                }

                if (angular.isUndefined(SCROLLBAR_WIDTH)) {
                    var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
                    $document.find('body').append(scrollElem);
                    SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
                    SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
                    scrollElem.remove();
                }

                return SCROLLBAR_WIDTH;
            },

            /**
             * Provides the padding required on an element to replace the scrollbar.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**scrollbarWidth**: the width of the scrollbar</li>
             *     <li>**widthOverflow**: whether the the width is overflowing</li>
             *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
             *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
             *     <li>**heightOverflow**: whether the the height is overflowing</li>
             *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
             *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
             *   </ul>
             */
            scrollbarPadding: function (elem) {
                elem = this.getRawNode(elem);

                var elemStyle = $window.getComputedStyle(elem);
                var paddingRight = this.parseStyle(elemStyle.paddingRight);
                var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
                var scrollParent = this.scrollParent(elem, false, true);
                var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

                return {
                    scrollbarWidth: scrollbarWidth,
                    widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
                    right: paddingRight + scrollbarWidth,
                    originalRight: paddingRight,
                    heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
                    bottom: paddingBottom + scrollbarWidth,
                    originalBottom: paddingBottom
                };
            },

            /**
             * Checks to see if the element is scrollable.
             *
             * @param {element} elem - The element to check.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             *
             * @returns {boolean} Whether the element is scrollable.
             */
            isScrollable: function (elem, includeHidden) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var elemStyle = $window.getComputedStyle(elem);
                return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
            },

            /**
             * Provides the closest scrollable ancestor.
             * A port of the jQuery UI scrollParent method:
             * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
             *
             * @param {element} elem - The element to find the scroll parent of.
             * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
             *   default is false.
             * @param {boolean=} [includeSelf=false] - Should the element being passed be
             * included in the scrollable llokup.
             *
             * @returns {element} A HTML element.
             */
            scrollParent: function (elem, includeHidden, includeSelf) {
                elem = this.getRawNode(elem);

                var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
                var documentEl = $document[0].documentElement;
                var elemStyle = $window.getComputedStyle(elem);
                if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
                    return elem;
                }
                var excludeStatic = elemStyle.position === 'absolute';
                var scrollParent = elem.parentElement || documentEl;

                if (scrollParent === documentEl || elemStyle.position === 'fixed') {
                    return documentEl;
                }

                while (scrollParent.parentElement && scrollParent !== documentEl) {
                    var spStyle = $window.getComputedStyle(scrollParent);
                    if (excludeStatic && spStyle.position !== 'static') {
                        excludeStatic = false;
                    }

                    if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
                        break;
                    }
                    scrollParent = scrollParent.parentElement;
                }

                return scrollParent;
            },

            /**
             * Provides read-only equivalent of jQuery's position function:
             * https://api.jquery.com/position/ - distance to closest positioned
             * ancestor.  Does not account for margins by default like jQuery position.
             *
             * @param {element} elem - The element to caclulate the position on.
             * @param {boolean=} [includeMargins=false] - Should margins be accounted
             * for, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of offset parent</li>
             *     <li>**left**: distance to left edge of offset parent</li>
             *   </ul>
             */
            position: function (elem, includeMagins) {
                elem = this.getRawNode(elem);

                var elemOffset = this.offset(elem);
                if (includeMagins) {
                    var elemStyle = $window.getComputedStyle(elem);
                    elemOffset.top -= this.parseStyle(elemStyle.marginTop);
                    elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
                }
                var parent = this.offsetParent(elem);
                var parentOffset = { top: 0, left: 0 };

                if (parent !== $document[0].documentElement) {
                    parentOffset = this.offset(parent);
                    parentOffset.top += parent.clientTop - parent.scrollTop;
                    parentOffset.left += parent.clientLeft - parent.scrollLeft;
                }

                return {
                    width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
                    top: Math.round(elemOffset.top - parentOffset.top),
                    left: Math.round(elemOffset.left - parentOffset.left)
                };
            },

            /**
             * Provides read-only equivalent of jQuery's offset function:
             * https://api.jquery.com/offset/ - distance to viewport.  Does
             * not account for borders, margins, or padding on the body
             * element.
             *
             * @param {element} elem - The element to calculate the offset on.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**width**: the width of the element</li>
             *     <li>**height**: the height of the element</li>
             *     <li>**top**: distance to top edge of viewport</li>
             *     <li>**right**: distance to bottom edge of viewport</li>
             *   </ul>
             */
            offset: function (elem) {
                elem = this.getRawNode(elem);

                var elemBCR = elem.getBoundingClientRect();
                return {
                    width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
                    height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
                    top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
                    left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
                };
            },

            /**
             * Provides offset distance to the closest scrollable ancestor
             * or viewport.  Accounts for border and scrollbar width.
             *
             * Right and bottom dimensions represent the distance to the
             * respective edge of the viewport element.  If the element
             * edge extends beyond the viewport, a negative value will be
             * reported.
             *
             * @param {element} elem - The element to get the viewport offset for.
             * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
             * of the first scrollable element, default is false.
             * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
             * be accounted for, default is true.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: distance to the top content edge of viewport element</li>
             *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
             *     <li>**left**: distance to the left content edge of viewport element</li>
             *     <li>**right**: distance to the right content edge of viewport element</li>
             *   </ul>
             */
            viewportOffset: function (elem, useDocument, includePadding) {
                elem = this.getRawNode(elem);
                includePadding = includePadding !== false ? true : false;

                var elemBCR = elem.getBoundingClientRect();
                var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

                var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
                var offsetParentBCR = offsetParent.getBoundingClientRect();

                offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
                offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
                if (offsetParent === $document[0].documentElement) {
                    offsetBCR.top += $window.pageYOffset;
                    offsetBCR.left += $window.pageXOffset;
                }
                offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
                offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

                if (includePadding) {
                    var offsetParentStyle = $window.getComputedStyle(offsetParent);
                    offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
                    offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
                    offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
                    offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
                }

                return {
                    top: Math.round(elemBCR.top - offsetBCR.top),
                    bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
                    left: Math.round(elemBCR.left - offsetBCR.left),
                    right: Math.round(offsetBCR.right - elemBCR.right)
                };
            },

            /**
             * Provides an array of placement values parsed from a placement string.
             * Along with the 'auto' indicator, supported placement strings are:
             *   <ul>
             *     <li>top: element on top, horizontally centered on host element.</li>
             *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
             *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
             *     <li>bottom: element on bottom, horizontally centered on host element.</li>
             *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
             *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
             *     <li>left: element on left, vertically centered on host element.</li>
             *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
             *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
             *     <li>right: element on right, vertically centered on host element.</li>
             *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
             *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
             *   </ul>
             * A placement string with an 'auto' indicator is expected to be
             * space separated from the placement, i.e: 'auto bottom-left'  If
             * the primary and secondary placement values do not match 'top,
             * bottom, left, right' then 'top' will be the primary placement and
             * 'center' will be the secondary placement.  If 'auto' is passed, true
             * will be returned as the 3rd value of the array.
             *
             * @param {string} placement - The placement string to parse.
             *
             * @returns {array} An array with the following values
             * <ul>
             *   <li>**[0]**: The primary placement.</li>
             *   <li>**[1]**: The secondary placement.</li>
             *   <li>**[2]**: If auto is passed: true, else undefined.</li>
             * </ul>
             */
            parsePlacement: function (placement) {
                var autoPlace = PLACEMENT_REGEX.auto.test(placement);
                if (autoPlace) {
                    placement = placement.replace(PLACEMENT_REGEX.auto, '');
                }

                placement = placement.split('-');

                placement[0] = placement[0] || 'top';
                if (!PLACEMENT_REGEX.primary.test(placement[0])) {
                    placement[0] = 'top';
                }

                placement[1] = placement[1] || 'center';
                if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
                    placement[1] = 'center';
                }

                if (autoPlace) {
                    placement[2] = true;
                } else {
                    placement[2] = false;
                }

                return placement;
            },

            /**
             * Provides coordinates for an element to be positioned relative to
             * another element.  Passing 'auto' as part of the placement parameter
             * will enable smart placement - where the element fits. i.e:
             * 'auto left-top' will check to see if there is enough space to the left
             * of the hostElem to fit the targetElem, if not place right (same for secondary
             * top placement).  Available space is calculated using the viewportOffset
             * function.
             *
             * @param {element} hostElem - The element to position against.
             * @param {element} targetElem - The element to position.
             * @param {string=} [placement=top] - The placement for the targetElem,
             *   default is 'top'. 'center' is assumed as secondary placement for
             *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
             *   <ul>
             *     <li>top</li>
             *     <li>top-right</li>
             *     <li>top-left</li>
             *     <li>bottom</li>
             *     <li>bottom-left</li>
             *     <li>bottom-right</li>
             *     <li>left</li>
             *     <li>left-top</li>
             *     <li>left-bottom</li>
             *     <li>right</li>
             *     <li>right-top</li>
             *     <li>right-bottom</li>
             *   </ul>
             * @param {boolean=} [appendToBody=false] - Should the top and left values returned
             *   be calculated from the body element, default is false.
             *
             * @returns {object} An object with the following properties:
             *   <ul>
             *     <li>**top**: Value for targetElem top.</li>
             *     <li>**left**: Value for targetElem left.</li>
             *     <li>**placement**: The resolved placement.</li>
             *   </ul>
             */
            positionElements: function (hostElem, targetElem, placement, appendToBody) {
                hostElem = this.getRawNode(hostElem);
                targetElem = this.getRawNode(targetElem);

                // need to read from prop to support tests.
                var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
                var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

                placement = this.parsePlacement(placement);

                var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
                var targetElemPos = { top: 0, left: 0, placement: '' };

                if (placement[2]) {
                    var viewportOffset = this.viewportOffset(hostElem, appendToBody);

                    var targetElemStyle = $window.getComputedStyle(targetElem);
                    var adjustedSize = {
                        width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
                        height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
                    };

                    placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                        placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                            placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                                placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                                    placement[0];

                    placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                        placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                            placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                                placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                                    placement[1];

                    if (placement[1] === 'center') {
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
                            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                                placement[1] = 'left';
                            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                                placement[1] = 'right';
                            }
                        } else {
                            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
                            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                                placement[1] = 'top';
                            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                                placement[1] = 'bottom';
                            }
                        }
                    }
                }

                switch (placement[0]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top - targetHeight;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left - targetWidth;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width;
                        break;
                }

                switch (placement[1]) {
                    case 'top':
                        targetElemPos.top = hostElemPos.top;
                        break;
                    case 'bottom':
                        targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
                        break;
                    case 'left':
                        targetElemPos.left = hostElemPos.left;
                        break;
                    case 'right':
                        targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
                        break;
                    case 'center':
                        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
                        } else {
                            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
                        }
                        break;
                }

                targetElemPos.top = Math.round(targetElemPos.top);
                targetElemPos.left = Math.round(targetElemPos.left);
                targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

                return targetElemPos;
            },

            /**
             * Provides a way to adjust the top positioning after first
             * render to correctly align element to top after content
             * rendering causes resized element height
             *
             * @param {array} placementClasses - The array of strings of classes
             * element should have.
             * @param {object} containerPosition - The object with container
             * position information
             * @param {number} initialHeight - The initial height for the elem.
             * @param {number} currentHeight - The current height for the elem.
             */
            adjustTop: function (placementClasses, containerPosition, initialHeight, currentHeight) {
                if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
                    return {
                        top: containerPosition.top - currentHeight + 'px'
                    };
                }
            },

            /**
             * Provides a way for positioning tooltip & dropdown
             * arrows when using placement options beyond the standard
             * left, right, top, or bottom.
             *
             * @param {element} elem - The tooltip/dropdown element.
             * @param {string} placement - The placement for the elem.
             */
            positionArrow: function (elem, placement) {
                elem = this.getRawNode(elem);

                var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
                if (!innerElem) {
                    return;
                }

                var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

                var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
                if (!arrowElem) {
                    return;
                }

                var arrowCss = {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                };

                placement = this.parsePlacement(placement);
                if (placement[1] === 'center') {
                    // no adjustment necessary - just reset styles
                    angular.element(arrowElem).css(arrowCss);
                    return;
                }

                var borderProp = 'border-' + placement[0] + '-width';
                var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

                var borderRadiusProp = 'border-';
                if (PLACEMENT_REGEX.vertical.test(placement[0])) {
                    borderRadiusProp += placement[0] + '-' + placement[1];
                } else {
                    borderRadiusProp += placement[1] + '-' + placement[0];
                }
                borderRadiusProp += '-radius';
                var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

                switch (placement[0]) {
                    case 'top':
                        arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'bottom':
                        arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'left':
                        arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
                        break;
                    case 'right':
                        arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
                        break;
                }

                arrowCss[placement[1]] = borderRadius;

                angular.element(arrowElem).css(arrowCss);
            }
        };
    }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

    .value('$datepickerPopupLiteralWarning', true)

    .constant('uibDatepickerPopupConfig', {
        altInputFormats: [],
        appendToBody: false,
        clearText: 'Clear',
        closeOnDateSelection: true,
        closeText: 'Done',
        currentText: 'Today',
        datepickerPopup: 'yyyy-MM-dd',
        datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
        datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        onOpenFocus: true,
        showButtonBar: true,
        placement: 'auto bottom-left'
    })

    .controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
        function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
            var cache = {},
                isHtml5DateInput = false;
            var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
                datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
                ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

            this.init = function (_ngModel_) {
                ngModel = _ngModel_;
                ngModelOptions = extractOptions(ngModel);
                closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
                    $scope.$parent.$eval($attrs.closeOnDateSelection) :
                    datepickerPopupConfig.closeOnDateSelection;
                appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
                    $scope.$parent.$eval($attrs.datepickerAppendToBody) :
                    datepickerPopupConfig.appendToBody;
                onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
                    $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
                datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
                    $attrs.datepickerPopupTemplateUrl :
                    datepickerPopupConfig.datepickerPopupTemplateUrl;
                datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
                    $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
                altInputFormats = angular.isDefined($attrs.altInputFormats) ?
                    $scope.$parent.$eval($attrs.altInputFormats) :
                    datepickerPopupConfig.altInputFormats;

                $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
                    $scope.$parent.$eval($attrs.showButtonBar) :
                    datepickerPopupConfig.showButtonBar;

                if (datepickerPopupConfig.html5Types[$attrs.type]) {
                    dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
                    $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
                        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
                        // Invalidate the $modelValue to ensure that formatters re-run
                        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = null;

                            if (!dateFormat) {
                                throw new Error('uibDatepickerPopup must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('uibDatepickerPopup must have a date format specified.');
                }

                if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
                    throw new Error('HTML5 date input types do not support custom formats.');
                }

                // popup element used to display calendar
                popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)',
                    'template-url': datepickerPopupTemplateUrl
                });

                // datepicker element
                datepickerEl = angular.element(popupEl.children()[0]);
                datepickerEl.attr('template-url', datepickerTemplateUrl);

                if (!$scope.datepickerOptions) {
                    $scope.datepickerOptions = {};
                }

                if (isHtml5DateInput) {
                    if ($attrs.type === 'month') {
                        $scope.datepickerOptions.datepickerMode = 'month';
                        $scope.datepickerOptions.minMode = 'month';
                    }
                }

                datepickerEl.attr('datepicker-options', 'datepickerOptions');

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'date';
                    ngModel.$validators.date = validator;
                    ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        if (ngModel.$isEmpty(value)) {
                            $scope.date = value;
                            return value;
                        }

                        if (angular.isNumber(value)) {
                            value = new Date(value);
                        }

                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

                        return dateParser.filter($scope.date, dateFormat);
                    });
                } else {
                    ngModel.$formatters.push(function (value) {
                        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
                        return value;
                    });
                }

                // Detect changes in the view from the text box
                ngModel.$viewChangeListeners.push(function () {
                    $scope.date = parseDateString(ngModel.$viewValue);
                });

                $element.on('keydown', inputKeydownBind);

                $popup = $compile(popupEl)($scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    $element.after($popup);
                }

                $scope.$on('$destroy', function () {
                    if ($scope.isOpen === true) {
                        if (!$rootScope.$$phase) {
                            $scope.$apply(function () {
                                $scope.isOpen = false;
                            });
                        }
                    }

                    $popup.remove();
                    $element.off('keydown', inputKeydownBind);
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);

                    //Clear all watch listeners on destroy
                    while (watchListeners.length) {
                        watchListeners.shift()();
                    }
                });
            };

            $scope.getText = function (key) {
                return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
            };

            $scope.isDisabled = function (date) {
                if (date === 'today') {
                    date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
                }

                var dates = {};
                angular.forEach(['minDate', 'maxDate'], function (key) {
                    if (!$scope.datepickerOptions[key]) {
                        dates[key] = null;
                    } else if (angular.isDate($scope.datepickerOptions[key])) {
                        dates[key] = new Date($scope.datepickerOptions[key]);
                    } else {
                        if ($datepickerPopupLiteralWarning) {
                            $log.warn('Literal date support has been deprecated, please switch to date object usage');
                        }

                        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
                    }
                });

                return $scope.datepickerOptions &&
                    dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
                    dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
            };

            $scope.compare = function (date1, date2) {
                return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            };

            // Inner change
            $scope.dateSelection = function (dt) {
                $scope.date = dt;
                var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
                $element.val(date);
                ngModel.$setViewValue(date);

                if (closeOnDateSelection) {
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.keydown = function (evt) {
                if (evt.which === 27) {
                    evt.stopPropagation();
                    $scope.isOpen = false;
                    $element[0].focus();
                }
            };

            $scope.select = function (date, evt) {
                evt.stopPropagation();

                if (date === 'today') {
                    var today = new Date();
                    if (angular.isDate($scope.date)) {
                        date = new Date($scope.date);
                        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                    } else {
                        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
                        date.setHours(0, 0, 0, 0);
                    }
                }
                $scope.dateSelection(date);
            };

            $scope.close = function (evt) {
                evt.stopPropagation();

                $scope.isOpen = false;
                $element[0].focus();
            };

            $scope.disabled = angular.isDefined($attrs.disabled) || false;
            if ($attrs.ngDisabled) {
                watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
                    $scope.disabled = disabled;
                }));
            }

            $scope.$watch('isOpen', function (value) {
                if (value) {
                    if (!$scope.disabled) {
                        $timeout(function () {
                            positionPopup();

                            if (onOpenFocus) {
                                $scope.$broadcast('uib:datepicker.focus');
                            }

                            $document.on('click', documentClickBind);

                            var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                            if (appendToBody || $position.parsePlacement(placement)[2]) {
                                scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
                                if (scrollParentEl) {
                                    scrollParentEl.on('scroll', positionPopup);
                                }
                            } else {
                                scrollParentEl = null;
                            }

                            angular.element($window).on('resize', positionPopup);
                        }, 0, false);
                    } else {
                        $scope.isOpen = false;
                    }
                } else {
                    $document.off('click', documentClickBind);
                    if (scrollParentEl) {
                        scrollParentEl.off('scroll', positionPopup);
                    }
                    angular.element($window).off('resize', positionPopup);
                }
            });

            function cameltoDash(string) {
                return string.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
            }

            function parseDateString(viewValue) {
                var date = dateParser.parse(viewValue, dateFormat, $scope.date);
                if (isNaN(date)) {
                    for (var i = 0; i < altInputFormats.length; i++) {
                        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
                        if (!isNaN(date)) {
                            return date;
                        }
                    }
                }
                return date;
            }

            function parseDate(viewValue) {
                if (angular.isNumber(viewValue)) {
                    // presumably timestamp to date object
                    viewValue = new Date(viewValue);
                }

                if (!viewValue) {
                    return null;
                }

                if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                    return viewValue;
                }

                if (angular.isString(viewValue)) {
                    var date = parseDateString(viewValue);
                    if (!isNaN(date)) {
                        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
                    }
                }

                return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
            }

            function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;

                if (!$attrs.ngRequired && !value) {
                    return true;
                }

                if (angular.isNumber(value)) {
                    value = new Date(value);
                }

                if (!value) {
                    return true;
                }

                if (angular.isDate(value) && !isNaN(value)) {
                    return true;
                }

                if (angular.isString(value)) {
                    return !isNaN(parseDateString(value));
                }

                return false;
            }

            function documentClickBind(event) {
                if (!$scope.isOpen && $scope.disabled) {
                    return;
                }

                var popup = $popup[0];
                var dpContainsTarget = $element[0].contains(event.target);
                // The popup node may not be an element node
                // In some browsers (IE) only element nodes have the 'contains' function
                var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
                if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                }
            }

            function inputKeydownBind(evt) {
                if (evt.which === 27 && $scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = false;
                    });
                    $element[0].focus();
                } else if (evt.which === 40 && !$scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = true;
                    });
                }
            }

            function positionPopup() {
                if ($scope.isOpen) {
                    var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
                    var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
                    var position = $position.positionElements($element, dpElement, placement, appendToBody);
                    dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
                    if (dpElement.hasClass('uib-position-measure')) {
                        dpElement.removeClass('uib-position-measure');
                    }
                }
            }

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
                        ngModelCtrl.$options :
                        {
                            timezone: null
                        };

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }

            $scope.$on('uib:datepicker.mode', function () {
                $timeout(positionPopup, 0, false);
            });
        }])

    .directive('uibDatepickerPopup', function () {
        return {
            require: ['ngModel', 'uibDatepickerPopup'],
            controller: 'UibDatepickerPopupController',
            scope: {
                datepickerOptions: '=?',
                isOpen: '=?',
                currentText: '@',
                clearText: '@',
                closeText: '@'
            },
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0],
                    ctrl = ctrls[1];

                ctrl.init(ngModel);
            }
        };
    })

    .directive('uibDatepickerPopupWrap', function () {
        return {
            restrict: 'A',
            transclude: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
            }
        };
    });

angular.module('ui.bootstrap.debounce', [])
    /**
     * A helper, internal service that debounces a function
     */
    .factory('$$debounce', ['$timeout', function ($timeout) {
        return function (callback, debounceTime) {
            var timeoutPromise;

            return function () {
                var self = this;
                var args = Array.prototype.slice.call(arguments);
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }

                timeoutPromise = $timeout(function () {
                    callback.apply(self, args);
                }, debounceTime);
            };
        };
    }]);

angular.module('ui.bootstrap.multiMap', [])
    /**
     * A helper, internal data structure that stores all references attached to key
     */
    .factory('$$multiMap', function () {
        return {
            createNew: function () {
                var map = {};

                return {
                    entries: function () {
                        return Object.keys(map).map(function (key) {
                            return {
                                key: key,
                                value: map[key]
                            };
                        });
                    },
                    get: function (key) {
                        return map[key];
                    },
                    hasKey: function (key) {
                        return !!map[key];
                    },
                    keys: function () {
                        return Object.keys(map);
                    },
                    put: function (key, value) {
                        if (!map[key]) {
                            map[key] = [];
                        }

                        map[key].push(value);
                    },
                    remove: function (key, value) {
                        var values = map[key];

                        if (!values) {
                            return;
                        }

                        var idx = values.indexOf(value);

                        if (idx !== -1) {
                            values.splice(idx, 1);
                        }

                        if (!values.length) {
                            delete map[key];
                        }
                    }
                };
            }
        };
    });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

    .constant('uibDropdownConfig', {
        appendToOpenClass: 'uib-dropdown-open',
        openClass: 'open'
    })

    .service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
        var openScope = null;
        var openedContainers = $$multiMap.createNew();

        this.isOnlyOpen = function (dropdownScope, appendTo) {
            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (openDropdown) {
                    return openedDropdowns.length === 1;
                }
            }

            return false;
        };

        this.open = function (dropdownScope, element, appendTo) {
            if (!openScope) {
                $document.on('click', closeDropdown);
            }

            if (openScope && openScope !== dropdownScope) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var openedScopes = openedDropdowns.map(function (dropdown) {
                    return dropdown.scope;
                });
                if (openedScopes.indexOf(dropdownScope) === -1) {
                    openedContainers.put(appendTo, {
                        scope: dropdownScope
                    });
                }
            } else {
                openedContainers.put(appendTo, {
                    scope: dropdownScope
                });
            }
        };

        this.close = function (dropdownScope, element, appendTo) {
            if (openScope === dropdownScope) {
                $document.off('click', closeDropdown);
                $document.off('keydown', this.keybindFilter);
                openScope = null;
            }

            if (!appendTo) {
                return;
            }

            var openedDropdowns = openedContainers.get(appendTo);
            if (openedDropdowns) {
                var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
                    if (dropdown.scope === dropdownScope) {
                        return dropdown;
                    }

                    return toClose;
                }, {});
                if (dropdownToClose) {
                    openedContainers.remove(appendTo, dropdownToClose);
                }
            }
        };

        var closeDropdown = function (evt) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope || !openScope.isOpen) { return; }

            if (evt && openScope.getAutoClose() === 'disabled') { return; }

            if (evt && evt.which === 3) { return; }

            var toggleElement = openScope.getToggleElement();
            if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            if (evt && openScope.getAutoClose() === 'outsideClick' &&
                dropdownElement && dropdownElement[0].contains(evt.target)) {
                return;
            }

            openScope.focusToggleElement();
            openScope.isOpen = false;

            if (!$rootScope.$$phase) {
                openScope.$apply();
            }
        };

        this.keybindFilter = function (evt) {
            if (!openScope) {
                // see this.close as ESC could have been pressed which kills the scope so we can not proceed
                return;
            }

            var dropdownElement = openScope.getDropdownElement();
            var toggleElement = openScope.getToggleElement();
            var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
            var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
            if (evt.which === 27) {
                evt.stopPropagation();
                openScope.focusToggleElement();
                closeDropdown();
            } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
                evt.preventDefault();
                evt.stopPropagation();
                openScope.focusDropdownEntry(evt.which);
            }
        };
    }])

    .controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
        var self = this,
            scope = $scope.$new(), // create a child scope so we are not polluting original one
            templateScope,
            appendToOpenClass = dropdownConfig.appendToOpenClass,
            openClass = dropdownConfig.openClass,
            getIsOpen,
            setIsOpen = angular.noop,
            toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
            keynavEnabled = false,
            selectedOption = null,
            body = $document.find('body');

        $element.addClass('dropdown');

        this.init = function () {
            if ($attrs.isOpen) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function (value) {
                    scope.isOpen = !!value;
                });
            }

            keynavEnabled = angular.isDefined($attrs.keyboardNav);
        };

        this.toggle = function (open) {
            scope.isOpen = arguments.length ? !!open : !scope.isOpen;
            if (angular.isFunction(setIsOpen)) {
                setIsOpen(scope, scope.isOpen);
            }

            return scope.isOpen;
        };

        // Allow other directives to watch status
        this.isOpen = function () {
            return scope.isOpen;
        };

        scope.getToggleElement = function () {
            return self.toggleElement;
        };

        scope.getAutoClose = function () {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function () {
            return $element;
        };

        scope.isKeynavEnabled = function () {
            return keynavEnabled;
        };

        scope.focusDropdownEntry = function (keyCode) {
            var elems = self.dropdownMenu ? //If append to body is used.
                angular.element(self.dropdownMenu).find('a') :
                $element.find('ul').eq(0).find('a');

            switch (keyCode) {
                case 40: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = 0;
                    } else {
                        self.selectedOption = self.selectedOption === elems.length - 1 ?
                            self.selectedOption :
                            self.selectedOption + 1;
                    }
                    break;
                }
                case 38: {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = elems.length - 1;
                    } else {
                        self.selectedOption = self.selectedOption === 0 ?
                            0 : self.selectedOption - 1;
                    }
                    break;
                }
            }
            elems[self.selectedOption].focus();
        };

        scope.getDropdownElement = function () {
            return self.dropdownMenu;
        };

        scope.focusToggleElement = function () {
            if (self.toggleElement) {
                self.toggleElement[0].focus();
            }
        };

        function removeDropdownMenu() {
            $element.append(self.dropdownMenu);
        }

        scope.$watch('isOpen', function (isOpen, wasOpen) {
            var appendTo = null,
                appendToBody = false;

            if (angular.isDefined($attrs.dropdownAppendTo)) {
                var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
                if (appendToEl) {
                    appendTo = angular.element(appendToEl);
                }
            }

            if (angular.isDefined($attrs.dropdownAppendToBody)) {
                var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
                if (appendToBodyValue !== false) {
                    appendToBody = true;
                }
            }

            if (appendToBody && !appendTo) {
                appendTo = body;
            }

            if (appendTo && self.dropdownMenu) {
                if (isOpen) {
                    appendTo.append(self.dropdownMenu);
                    $element.on('$destroy', removeDropdownMenu);
                } else {
                    $element.off('$destroy', removeDropdownMenu);
                    removeDropdownMenu();
                }
            }

            if (appendTo && self.dropdownMenu) {
                var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
                    css,
                    rightalign,
                    scrollbarPadding,
                    scrollbarWidth = 0;

                css = {
                    top: pos.top + 'px',
                    display: isOpen ? 'block' : 'none'
                };

                rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
                if (!rightalign) {
                    css.left = pos.left + 'px';
                    css.right = 'auto';
                } else {
                    css.left = 'auto';
                    scrollbarPadding = $position.scrollbarPadding(appendTo);

                    if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        scrollbarWidth = scrollbarPadding.scrollbarWidth;
                    }

                    css.right = window.innerWidth - scrollbarWidth -
                        (pos.left + $element.prop('offsetWidth')) + 'px';
                }

                // Need to adjust our positioning to be relative to the appendTo container
                // if it's not the body element
                if (!appendToBody) {
                    var appendOffset = $position.offset(appendTo);

                    css.top = pos.top - appendOffset.top + 'px';

                    if (!rightalign) {
                        css.left = pos.left - appendOffset.left + 'px';
                    } else {
                        css.right = window.innerWidth -
                            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
                    }
                }

                self.dropdownMenu.css(css);
            }

            var openContainer = appendTo ? appendTo : $element;
            var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
            var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
            var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

            if (hasOpenClass === !isOpen) {
                var toggleClass;
                if (appendTo) {
                    toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
                } else {
                    toggleClass = isOpen ? 'addClass' : 'removeClass';
                }
                $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
                    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                        toggleInvoker($scope, { open: !!isOpen });
                    }
                });
            }

            if (isOpen) {
                if (self.dropdownMenuTemplateUrl) {
                    $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
                        templateScope = scope.$new();
                        $compile(tplContent.trim())(templateScope, function (dropdownElement) {
                            var newEl = dropdownElement;
                            self.dropdownMenu.replaceWith(newEl);
                            self.dropdownMenu = newEl;
                            $document.on('keydown', uibDropdownService.keybindFilter);
                        });
                    });
                } else {
                    $document.on('keydown', uibDropdownService.keybindFilter);
                }

                scope.focusToggleElement();
                uibDropdownService.open(scope, $element, appendTo);
            } else {
                uibDropdownService.close(scope, $element, appendTo);
                if (self.dropdownMenuTemplateUrl) {
                    if (templateScope) {
                        templateScope.$destroy();
                    }
                    var newEl = angular.element('<ul class="dropdown-menu"></ul>');
                    self.dropdownMenu.replaceWith(newEl);
                    self.dropdownMenu = newEl;
                }

                self.selectedOption = null;
            }

            if (angular.isFunction(setIsOpen)) {
                setIsOpen($scope, isOpen);
            }
        });
    }])

    .directive('uibDropdown', function () {
        return {
            controller: 'UibDropdownController',
            link: function (scope, element, attrs, dropdownCtrl) {
                dropdownCtrl.init();
            }
        };
    })

    .directive('uibDropdownMenu', function () {
        return {
            restrict: 'A',
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
                    return;
                }

                element.addClass('dropdown-menu');

                var tplUrl = attrs.templateUrl;
                if (tplUrl) {
                    dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                }

                if (!dropdownCtrl.dropdownMenu) {
                    dropdownCtrl.dropdownMenu = element;
                }
            }
        };
    })

    .directive('uibDropdownToggle', function () {
        return {
            require: '?^uibDropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }

                element.addClass('dropdown-toggle');

                dropdownCtrl.toggleElement = element;

                var toggleDropdown = function (event) {
                    event.preventDefault();

                    if (!element.hasClass('disabled') && !attrs.disabled) {
                        scope.$apply(function () {
                            dropdownCtrl.toggle();
                        });
                    }
                };

                element.on('click', toggleDropdown);

                // WAI-ARIA
                element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
                scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function () {
                    element.off('click', toggleDropdown);
                });
            }
        };
    });

angular.module('ui.bootstrap.stackedMap', [])
    /**
     * A helper, internal data structure that acts as a map but also allows getting / removing
     * elements in the LIFO order
     */
    .factory('$$stackedMap', function () {
        return {
            createNew: function () {
                var stack = [];

                return {
                    add: function (key, value) {
                        stack.push({
                            key: key,
                            value: value
                        });
                    },
                    get: function (key) {
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                return stack[i];
                            }
                        }
                    },
                    keys: function () {
                        var keys = [];
                        for (var i = 0; i < stack.length; i++) {
                            keys.push(stack[i].key);
                        }
                        return keys;
                    },
                    top: function () {
                        return stack[stack.length - 1];
                    },
                    remove: function (key) {
                        var idx = -1;
                        for (var i = 0; i < stack.length; i++) {
                            if (key === stack[i].key) {
                                idx = i;
                                break;
                            }
                        }
                        return stack.splice(idx, 1)[0];
                    },
                    removeTop: function () {
                        return stack.pop();
                    },
                    length: function () {
                        return stack.length;
                    }
                };
            }
        };
    });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
    /**
     * Pluggable resolve mechanism for the modal resolve resolution
     * Supports UI Router's $resolve service
     */
    .provider('$uibResolve', function () {
        var resolve = this;
        this.resolver = null;

        this.setResolver = function (resolver) {
            this.resolver = resolver;
        };

        this.$get = ['$injector', '$q', function ($injector, $q) {
            var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
            return {
                resolve: function (invocables, locals, parent, self) {
                    if (resolver) {
                        return resolver.resolve(invocables, locals, parent, self);
                    }

                    var promises = [];

                    angular.forEach(invocables, function (value) {
                        if (angular.isFunction(value) || angular.isArray(value)) {
                            promises.push($q.resolve($injector.invoke(value)));
                        } else if (angular.isString(value)) {
                            promises.push($q.resolve($injector.get(value)));
                        } else {
                            promises.push($q.resolve(value));
                        }
                    });

                    return $q.all(promises).then(function (resolves) {
                        var resolveObj = {};
                        var resolveIter = 0;
                        angular.forEach(invocables, function (value, key) {
                            resolveObj[key] = resolves[resolveIter++];
                        });

                        return resolveObj;
                    });
                }
            };
        }];
    })

    /**
     * A helper directive for the $modal service. It creates a backdrop element.
     */
    .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
        function ($animate, $injector, $modalStack) {
            return {
                restrict: 'A',
                compile: function (tElement, tAttrs) {
                    tElement.addClass(tAttrs.backdropClass);
                    return linkFn;
                }
            };

            function linkFn(scope, element, attrs) {
                if (attrs.modalInClass) {
                    $animate.addClass(element, attrs.modalInClass);

                    scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                        var done = setIsAsync();
                        if (scope.modalOptions.animation) {
                            $animate.removeClass(element, attrs.modalInClass).then(done);
                        } else {
                            done();
                        }
                    });
                }
            }
        }])

    .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
        function ($modalStack, $q, $animateCss, $document) {
            return {
                scope: {
                    index: '@'
                },
                restrict: 'A',
                transclude: true,
                templateUrl: function (tElement, tAttrs) {
                    return tAttrs.templateUrl || 'uib/template/modal/window.html';
                },
                link: function (scope, element, attrs) {
                    element.addClass(attrs.windowTopClass || '');
                    scope.size = attrs.size;

                    scope.close = function (evt) {
                        var modal = $modalStack.getTop();
                        if (modal && modal.value.backdrop &&
                            modal.value.backdrop !== 'static' &&
                            evt.target === evt.currentTarget) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            $modalStack.dismiss(modal.key, 'backdrop click');
                        }
                    };

                    // moved from template to fix issue #2280
                    element.on('click', scope.close);

                    // This property is only added to the scope for the purpose of detecting when this directive is rendered.
                    // We can detect that by using this property in the template associated with this directive and then use
                    // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
                    scope.$isRendered = true;

                    // Deferred object that will be resolved when this modal is rendered.
                    var modalRenderDeferObj = $q.defer();
                    // Resolve render promise post-digest
                    scope.$$postDigest(function () {
                        modalRenderDeferObj.resolve();
                    });

                    modalRenderDeferObj.promise.then(function () {
                        var animationPromise = null;

                        if (attrs.modalInClass) {
                            animationPromise = $animateCss(element, {
                                addClass: attrs.modalInClass
                            }).start();

                            scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                                var done = setIsAsync();
                                $animateCss(element, {
                                    removeClass: attrs.modalInClass
                                }).start().then(done);
                            });
                        }


                        $q.when(animationPromise).then(function () {
                            // Notify {@link $modalStack} that modal is rendered.
                            var modal = $modalStack.getTop();
                            if (modal) {
                                $modalStack.modalRendered(modal.key);
                            }

                            /**
                             * If something within the freshly-opened modal already has focus (perhaps via a
                             * directive that causes focus) then there's no need to try to focus anything.
                             */
                            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
                                var inputWithAutofocus = element[0].querySelector('[autofocus]');
                                /**
                                 * Auto-focusing of a freshly-opened modal element causes any child elements
                                 * with the autofocus attribute to lose focus. This is an issue on touch
                                 * based devices which will show and then hide the onscreen keyboard.
                                 * Attempts to refocus the autofocus element via JavaScript will not reopen
                                 * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
                                 * the modal element if the modal does not contain an autofocus element.
                                 */
                                if (inputWithAutofocus) {
                                    inputWithAutofocus.focus();
                                } else {
                                    element[0].focus();
                                }
                            }
                        });
                    });
                }
            };
        }])

    .directive('uibModalAnimationClass', function () {
        return {
            compile: function (tElement, tAttrs) {
                if (tAttrs.modalAnimation) {
                    tElement.addClass(tAttrs.uibModalAnimationClass);
                }
            }
        };
    })

    .directive('uibModalTransclude', ['$animate', function ($animate) {
        return {
            link: function (scope, element, attrs, controller, transclude) {
                transclude(scope.$parent, function (clone) {
                    element.empty();
                    $animate.enter(clone, element);
                });
            }
        };
    }])

    .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
        '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
        function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
            var OPENED_MODAL_CLASS = 'modal-open';

            var backdropDomEl, backdropScope;
            var openedWindows = $$stackedMap.createNew();
            var openedClasses = $$multiMap.createNew();
            var $modalStack = {
                NOW_CLOSING_EVENT: 'modal.stack.now-closing'
            };
            var topModalIndex = 0;
            var previousTopOpenedModal = null;
            var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

            //Modal focus behavior
            var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
                'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
                'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
            var scrollbarPadding;
            var SNAKE_CASE_REGEXP = /[A-Z]/g;

            // TODO: extract into common dependency with tooltip
            function snake_case(name) {
                var separator = '-';
                return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
                    return (pos ? separator : '') + letter.toLowerCase();
                });
            }

            function isVisible(element) {
                return !!(element.offsetWidth ||
                    element.offsetHeight ||
                    element.getClientRects().length);
            }

            function backdropIndex() {
                var topBackdropIndex = -1;
                var opened = openedWindows.keys();
                for (var i = 0; i < opened.length; i++) {
                    if (openedWindows.get(opened[i]).value.backdrop) {
                        topBackdropIndex = i;
                    }
                }

                // If any backdrop exist, ensure that it's index is always
                // right below the top modal
                if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
                    topBackdropIndex = topModalIndex;
                }
                return topBackdropIndex;
            }

            $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
                if (backdropScope) {
                    backdropScope.index = newBackdropIndex;
                }
            });

            function removeModalWindow(modalInstance, elementToReceiveFocus) {
                var modalWindow = openedWindows.get(modalInstance).value;
                var appendToElement = modalWindow.appendTo;

                //clean up the stack
                openedWindows.remove(modalInstance);
                previousTopOpenedModal = openedWindows.top();
                if (previousTopOpenedModal) {
                    topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
                }

                removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
                    var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
                    openedClasses.remove(modalBodyClass, modalInstance);
                    var areAnyOpen = openedClasses.hasKey(modalBodyClass);
                    appendToElement.toggleClass(modalBodyClass, areAnyOpen);
                    if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                        if (scrollbarPadding.originalRight) {
                            appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
                        } else {
                            appendToElement.css({ paddingRight: '' });
                        }
                        scrollbarPadding = null;
                    }
                    toggleTopWindowClass(true);
                }, modalWindow.closedDeferred);
                checkRemoveBackdrop();

                //move focus to specified element if available, or else to body
                if (elementToReceiveFocus && elementToReceiveFocus.focus) {
                    elementToReceiveFocus.focus();
                } else if (appendToElement.focus) {
                    appendToElement.focus();
                }
            }

            // Add or remove "windowTopClass" from the top window in the stack
            function toggleTopWindowClass(toggleSwitch) {
                var modalWindow;

                if (openedWindows.length() > 0) {
                    modalWindow = openedWindows.top().value;
                    modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
                }
            }

            function checkRemoveBackdrop() {
                //remove backdrop if no longer needed
                if (backdropDomEl && backdropIndex() === -1) {
                    var backdropScopeRef = backdropScope;
                    removeAfterAnimate(backdropDomEl, backdropScope, function () {
                        backdropScopeRef = null;
                    });
                    backdropDomEl = undefined;
                    backdropScope = undefined;
                }
            }

            function removeAfterAnimate(domEl, scope, done, closedDeferred) {
                var asyncDeferred;
                var asyncPromise = null;
                var setIsAsync = function () {
                    if (!asyncDeferred) {
                        asyncDeferred = $q.defer();
                        asyncPromise = asyncDeferred.promise;
                    }

                    return function asyncDone() {
                        asyncDeferred.resolve();
                    };
                };
                scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

                // Note that it's intentional that asyncPromise might be null.
                // That's when setIsAsync has not been called during the
                // NOW_CLOSING_EVENT broadcast.
                return $q.when(asyncPromise).then(afterAnimating);

                function afterAnimating() {
                    if (afterAnimating.done) {
                        return;
                    }
                    afterAnimating.done = true;

                    $animate.leave(domEl).then(function () {
                        if (done) {
                            done();
                        }

                        domEl.remove();
                        if (closedDeferred) {
                            closedDeferred.resolve();
                        }
                    });

                    scope.$destroy();
                }
            }

            $document.on('keydown', keydownListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keydown', keydownListener);
            });

            function keydownListener(evt) {
                if (evt.isDefaultPrevented()) {
                    return evt;
                }

                var modal = openedWindows.top();
                if (modal) {
                    switch (evt.which) {
                        case 27: {
                            if (modal.value.keyboard) {
                                evt.preventDefault();
                                $rootScope.$apply(function () {
                                    $modalStack.dismiss(modal.key, 'escape key press');
                                });
                            }
                            break;
                        }
                        case 9: {
                            var list = $modalStack.loadFocusElementList(modal);
                            var focusChanged = false;
                            if (evt.shiftKey) {
                                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                                    focusChanged = $modalStack.focusLastFocusableElement(list);
                                }
                            } else {
                                if ($modalStack.isFocusInLastItem(evt, list)) {
                                    focusChanged = $modalStack.focusFirstFocusableElement(list);
                                }
                            }

                            if (focusChanged) {
                                evt.preventDefault();
                                evt.stopPropagation();
                            }

                            break;
                        }
                    }
                }
            }

            $modalStack.open = function (modalInstance, modal) {
                var modalOpener = $document[0].activeElement,
                    modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

                toggleTopWindowClass(false);

                // Store the current top first, to determine what index we ought to use
                // for the current top modal
                previousTopOpenedModal = openedWindows.top();

                openedWindows.add(modalInstance, {
                    deferred: modal.deferred,
                    renderDeferred: modal.renderDeferred,
                    closedDeferred: modal.closedDeferred,
                    modalScope: modal.scope,
                    backdrop: modal.backdrop,
                    keyboard: modal.keyboard,
                    openedClass: modal.openedClass,
                    windowTopClass: modal.windowTopClass,
                    animation: modal.animation,
                    appendTo: modal.appendTo
                });

                openedClasses.put(modalBodyClass, modalInstance);

                var appendToElement = modal.appendTo,
                    currBackdropIndex = backdropIndex();

                if (currBackdropIndex >= 0 && !backdropDomEl) {
                    backdropScope = $rootScope.$new(true);
                    backdropScope.modalOptions = modal;
                    backdropScope.index = currBackdropIndex;
                    backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
                    backdropDomEl.attr({
                        'class': 'modal-backdrop',
                        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
                        'uib-modal-animation-class': 'fade',
                        'modal-in-class': 'in'
                    });
                    if (modal.backdropClass) {
                        backdropDomEl.addClass(modal.backdropClass);
                    }

                    if (modal.animation) {
                        backdropDomEl.attr('modal-animation', 'true');
                    }
                    $compile(backdropDomEl)(backdropScope);
                    $animate.enter(backdropDomEl, appendToElement);
                    if ($uibPosition.isScrollable(appendToElement)) {
                        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
                        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                            appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
                        }
                    }
                }

                var content;
                if (modal.component) {
                    content = document.createElement(snake_case(modal.component.name));
                    content = angular.element(content);
                    content.attr({
                        resolve: '$resolve',
                        'modal-instance': '$uibModalInstance',
                        close: '$close($value)',
                        dismiss: '$dismiss($value)'
                    });
                } else {
                    content = modal.content;
                }

                // Set the top modal index based on the index of the previous top modal
                topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
                var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
                angularDomEl.attr({
                    'class': 'modal',
                    'template-url': modal.windowTemplateUrl,
                    'window-top-class': modal.windowTopClass,
                    'role': 'dialog',
                    'aria-labelledby': modal.ariaLabelledBy,
                    'aria-describedby': modal.ariaDescribedBy,
                    'size': modal.size,
                    'index': topModalIndex,
                    'animate': 'animate',
                    'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
                    'tabindex': -1,
                    'uib-modal-animation-class': 'fade',
                    'modal-in-class': 'in'
                }).append(content);
                if (modal.windowClass) {
                    angularDomEl.addClass(modal.windowClass);
                }

                if (modal.animation) {
                    angularDomEl.attr('modal-animation', 'true');
                }

                appendToElement.addClass(modalBodyClass);
                if (modal.scope) {
                    // we need to explicitly add the modal index to the modal scope
                    // because it is needed by ngStyle to compute the zIndex property.
                    modal.scope.$$topModalIndex = topModalIndex;
                }
                $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

                openedWindows.top().value.modalDomEl = angularDomEl;
                openedWindows.top().value.modalOpener = modalOpener;

                applyAriaHidden(angularDomEl);

                function applyAriaHidden(el) {
                    if (!el || el[0].tagName === 'BODY') {
                        return;
                    }

                    getSiblings(el).forEach(function (sibling) {
                        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
                            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

                        if (!ariaHiddenCount) {
                            ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
                        }

                        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
                        sibling.setAttribute('aria-hidden', 'true');
                    });

                    return applyAriaHidden(el.parent());

                    function getSiblings(el) {
                        var children = el.parent() ? el.parent().children() : [];

                        return Array.prototype.filter.call(children, function (child) {
                            return child !== el[0];
                        });
                    }
                }
            };

            function broadcastClosing(modalWindow, resultOrReason, closing) {
                return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
            }

            function unhideBackgroundElements() {
                Array.prototype.forEach.call(
                    document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
                    function (hiddenEl) {
                        var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
                            newHiddenCount = ariaHiddenCount - 1;
                        hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

                        if (!newHiddenCount) {
                            hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
                            hiddenEl.removeAttribute('aria-hidden');
                        }
                    }
                );
            }

            $modalStack.close = function (modalInstance, result) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, result, true)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.resolve(result);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }

                return !modalWindow;
            };

            $modalStack.dismiss = function (modalInstance, reason) {
                var modalWindow = openedWindows.get(modalInstance);
                unhideBackgroundElements();
                if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
                    modalWindow.value.modalScope.$$uibDestructionScheduled = true;
                    modalWindow.value.deferred.reject(reason);
                    removeModalWindow(modalInstance, modalWindow.value.modalOpener);
                    return true;
                }
                return !modalWindow;
            };

            $modalStack.dismissAll = function (reason) {
                var topModal = this.getTop();
                while (topModal && this.dismiss(topModal.key, reason)) {
                    topModal = this.getTop();
                }
            };

            $modalStack.getTop = function () {
                return openedWindows.top();
            };

            $modalStack.modalRendered = function (modalInstance) {
                var modalWindow = openedWindows.get(modalInstance);
                if (modalWindow) {
                    modalWindow.value.renderDeferred.resolve();
                }
            };

            $modalStack.focusFirstFocusableElement = function (list) {
                if (list.length > 0) {
                    list[0].focus();
                    return true;
                }
                return false;
            };

            $modalStack.focusLastFocusableElement = function (list) {
                if (list.length > 0) {
                    list[list.length - 1].focus();
                    return true;
                }
                return false;
            };

            $modalStack.isModalFocused = function (evt, modalWindow) {
                if (evt && modalWindow) {
                    var modalDomEl = modalWindow.value.modalDomEl;
                    if (modalDomEl && modalDomEl.length) {
                        return (evt.target || evt.srcElement) === modalDomEl[0];
                    }
                }
                return false;
            };

            $modalStack.isFocusInFirstItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[0];
                }
                return false;
            };

            $modalStack.isFocusInLastItem = function (evt, list) {
                if (list.length > 0) {
                    return (evt.target || evt.srcElement) === list[list.length - 1];
                }
                return false;
            };

            $modalStack.loadFocusElementList = function (modalWindow) {
                if (modalWindow) {
                    var modalDomE1 = modalWindow.value.modalDomEl;
                    if (modalDomE1 && modalDomE1.length) {
                        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
                        return elements ?
                            Array.prototype.filter.call(elements, function (element) {
                                return isVisible(element);
                            }) : elements;
                    }
                }
            };

            return $modalStack;
        }])

    .provider('$uibModal', function () {
        var $modalProvider = {
            options: {
                animation: true,
                backdrop: true, //can also be false or 'static'
                keyboard: true
            },
            $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
                function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
                    var $modal = {};

                    function getTemplatePromise(options) {
                        return options.template ? $q.when(options.template) :
                            $templateRequest(angular.isFunction(options.templateUrl) ?
                                options.templateUrl() : options.templateUrl);
                    }

                    var promiseChain = null;
                    $modal.getPromiseChain = function () {
                        return promiseChain;
                    };

                    $modal.open = function (modalOptions) {
                        var modalResultDeferred = $q.defer();
                        var modalOpenedDeferred = $q.defer();
                        var modalClosedDeferred = $q.defer();
                        var modalRenderDeferred = $q.defer();

                        //prepare an instance of a modal to be injected into controllers and returned to a caller
                        var modalInstance = {
                            result: modalResultDeferred.promise,
                            opened: modalOpenedDeferred.promise,
                            closed: modalClosedDeferred.promise,
                            rendered: modalRenderDeferred.promise,
                            close: function (result) {
                                return $modalStack.close(modalInstance, result);
                            },
                            dismiss: function (reason) {
                                return $modalStack.dismiss(modalInstance, reason);
                            }
                        };

                        //merge and clean up options
                        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                        modalOptions.resolve = modalOptions.resolve || {};
                        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

                        if (!modalOptions.appendTo.length) {
                            throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
                        }

                        //verify options
                        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
                            throw new Error('One of component or template or templateUrl options is required.');
                        }

                        var templateAndResolvePromise;
                        if (modalOptions.component) {
                            templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
                        } else {
                            templateAndResolvePromise =
                                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
                        }

                        function resolveWithTemplate() {
                            return templateAndResolvePromise;
                        }

                        // Wait for the resolution of the existing promise chain.
                        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                        // Then add to $modalStack and resolve opened.
                        // Finally clean up the chain variable if no subsequent modal has overwritten it.
                        var samePromise;
                        samePromise = promiseChain = $q.all([promiseChain])
                            .then(resolveWithTemplate, resolveWithTemplate)
                            .then(function resolveSuccess(tplAndVars) {
                                var providedScope = modalOptions.scope || $rootScope;

                                var modalScope = providedScope.$new();
                                modalScope.$close = modalInstance.close;
                                modalScope.$dismiss = modalInstance.dismiss;

                                modalScope.$on('$destroy', function () {
                                    if (!modalScope.$$uibDestructionScheduled) {
                                        modalScope.$dismiss('$uibUnscheduledDestruction');
                                    }
                                });

                                var modal = {
                                    scope: modalScope,
                                    deferred: modalResultDeferred,
                                    renderDeferred: modalRenderDeferred,
                                    closedDeferred: modalClosedDeferred,
                                    animation: modalOptions.animation,
                                    backdrop: modalOptions.backdrop,
                                    keyboard: modalOptions.keyboard,
                                    backdropClass: modalOptions.backdropClass,
                                    windowTopClass: modalOptions.windowTopClass,
                                    windowClass: modalOptions.windowClass,
                                    windowTemplateUrl: modalOptions.windowTemplateUrl,
                                    ariaLabelledBy: modalOptions.ariaLabelledBy,
                                    ariaDescribedBy: modalOptions.ariaDescribedBy,
                                    size: modalOptions.size,
                                    openedClass: modalOptions.openedClass,
                                    appendTo: modalOptions.appendTo
                                };

                                var component = {};
                                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                                if (modalOptions.component) {
                                    constructLocals(component, false, true, false);
                                    component.name = modalOptions.component;
                                    modal.component = component;
                                } else if (modalOptions.controller) {
                                    constructLocals(ctrlLocals, true, false, true);

                                    // the third param will make the controller instantiate later,private api
                                    // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                                    ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                                    if (modalOptions.controllerAs && modalOptions.bindToController) {
                                        ctrlInstance = ctrlInstantiate.instance;
                                        ctrlInstance.$close = modalScope.$close;
                                        ctrlInstance.$dismiss = modalScope.$dismiss;
                                        angular.extend(ctrlInstance, {
                                            $resolve: ctrlLocals.$scope.$resolve
                                        }, providedScope);
                                    }

                                    ctrlInstance = ctrlInstantiate();

                                    if (angular.isFunction(ctrlInstance.$onInit)) {
                                        ctrlInstance.$onInit();
                                    }
                                }

                                if (!modalOptions.component) {
                                    modal.content = tplAndVars[0];
                                }

                                $modalStack.open(modalInstance, modal);
                                modalOpenedDeferred.resolve(true);

                                function constructLocals(obj, template, instanceOnScope, injectable) {
                                    obj.$scope = modalScope;
                                    obj.$scope.$resolve = {};
                                    if (instanceOnScope) {
                                        obj.$scope.$uibModalInstance = modalInstance;
                                    } else {
                                        obj.$uibModalInstance = modalInstance;
                                    }

                                    var resolves = template ? tplAndVars[1] : tplAndVars;
                                    angular.forEach(resolves, function (value, key) {
                                        if (injectable) {
                                            obj[key] = value;
                                        }

                                        obj.$scope.$resolve[key] = value;
                                    });
                                }
                            }, function resolveError(reason) {
                                modalOpenedDeferred.reject(reason);
                                modalResultDeferred.reject(reason);
                            })['finally'](function () {
                                if (promiseChain === samePromise) {
                                    promiseChain = null;
                                }
                            });

                        return modalInstance;
                    };

                    return $modal;
                }
            ]
        };

        return $modalProvider;
    });

angular.module('ui.bootstrap.paging', [])
    /**
     * Helper internal service for generating common controller code between the
     * pager and pagination components
     */
    .factory('uibPaging', ['$parse', function ($parse) {
        return {
            create: function (ctrl, $scope, $attrs) {
                ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
                ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
                ctrl._watchers = [];

                ctrl.init = function (ngModelCtrl, config) {
                    ctrl.ngModelCtrl = ngModelCtrl;
                    ctrl.config = config;

                    ngModelCtrl.$render = function () {
                        ctrl.render();
                    };

                    if ($attrs.itemsPerPage) {
                        ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
                            ctrl.itemsPerPage = parseInt(value, 10);
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }));
                    } else {
                        ctrl.itemsPerPage = config.itemsPerPage;
                    }

                    $scope.$watch('totalItems', function (newTotal, oldTotal) {
                        if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
                            $scope.totalPages = ctrl.calculateTotalPages();
                            ctrl.updatePage();
                        }
                    });
                };

                ctrl.calculateTotalPages = function () {
                    var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
                    return Math.max(totalPages || 0, 1);
                };

                ctrl.render = function () {
                    $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
                };

                $scope.selectPage = function (page, evt) {
                    if (evt) {
                        evt.preventDefault();
                    }

                    var clickAllowed = !$scope.ngDisabled || !evt;
                    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
                        if (evt && evt.target) {
                            evt.target.blur();
                        }
                        ctrl.ngModelCtrl.$setViewValue(page);
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.getText = function (key) {
                    return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
                };

                $scope.noPrevious = function () {
                    return $scope.page === 1;
                };

                $scope.noNext = function () {
                    return $scope.page === $scope.totalPages;
                };

                ctrl.updatePage = function () {
                    ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

                    if ($scope.page > $scope.totalPages) {
                        $scope.selectPage($scope.totalPages);
                    } else {
                        ctrl.ngModelCtrl.$render();
                    }
                };

                $scope.$on('$destroy', function () {
                    while (ctrl._watchers.length) {
                        ctrl._watchers.shift()();
                    }
                });
            }
        };
    }]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

    .controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
        $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

        uibPaging.create(this, $scope, $attrs);
    }])

    .constant('uibPagerConfig', {
        itemsPerPage: 10,
        previousText: 'Â« Previous',
        nextText: 'Next Â»',
        align: true
    })

    .directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
        return {
            scope: {
                totalItems: '=',
                previousText: '@',
                nextText: '@',
                ngDisabled: '='
            },
            require: ['uibPager', '?ngModel'],
            restrict: 'A',
            controller: 'UibPagerController',
            controllerAs: 'pager',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pager/pager.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pager');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPagerConfig);
            }
        };
    }]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
    .controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
        var ctrl = this;
        // Setup configuration parameters
        var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
            rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
            forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
            boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
            pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) { return $scope.$parent.$eval($attrs.pageLabel, { $page: idx }); } : angular.identity;
        $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
        $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
        $attrs.$set('role', 'menu');

        uibPaging.create(this, $scope, $attrs);

        if ($attrs.maxSize) {
            ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
                maxSize = parseInt(value, 10);
                ctrl.render();
            }));
        }

        // Create page object used in template
        function makePage(number, text, isActive) {
            return {
                number: number,
                text: text,
                active: isActive
            };
        }

        function getPages(currentPage, totalPages) {
            var pages = [];

            // Default page limits
            var startPage = 1, endPage = totalPages;
            var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

            // recompute if maxSize
            if (isMaxSized) {
                if (rotate) {
                    // Current page is displayed in the middle of the visible ones
                    startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
                    endPage = startPage + maxSize - 1;

                    // Adjust if limit is exceeded
                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = endPage - maxSize + 1;
                    }
                } else {
                    // Visible pages are paginated with maxSize
                    startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

                    // Adjust last page if limit is exceeded
                    endPage = Math.min(startPage + maxSize - 1, totalPages);
                }
            }

            // Add page number links
            for (var number = startPage; number <= endPage; number++) {
                var page = makePage(number, pageLabel(number), number === currentPage);
                pages.push(page);
            }

            // Add links to move between page sets
            if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
                if (startPage > 1) {
                    if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
                        var previousPageSet = makePage(startPage - 1, '...', false);
                        pages.unshift(previousPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
                            var secondPageLink = makePage(2, '2', false);
                            pages.unshift(secondPageLink);
                        }
                        //add the first page
                        var firstPageLink = makePage(1, '1', false);
                        pages.unshift(firstPageLink);
                    }
                }

                if (endPage < totalPages) {
                    if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
                        var nextPageSet = makePage(endPage + 1, '...', false);
                        pages.push(nextPageSet);
                    }
                    if (boundaryLinkNumbers) {
                        if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
                            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
                            pages.push(secondToLastPageLink);
                        }
                        //add the last page
                        var lastPageLink = makePage(totalPages, totalPages, false);
                        pages.push(lastPageLink);
                    }
                }
            }
            return pages;
        }

        var originalRender = this.render;
        this.render = function () {
            originalRender();
            if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
                $scope.pages = getPages($scope.page, $scope.totalPages);
            }
        };
    }])

    .constant('uibPaginationConfig', {
        itemsPerPage: 10,
        boundaryLinks: false,
        boundaryLinkNumbers: false,
        directionLinks: true,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: true,
        forceEllipses: false
    })

    .directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
        return {
            scope: {
                totalItems: '=',
                firstText: '@',
                previousText: '@',
                nextText: '@',
                lastText: '@',
                ngDisabled: '='
            },
            require: ['uibPagination', '?ngModel'],
            restrict: 'A',
            controller: 'UibPaginationController',
            controllerAs: 'pagination',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/pagination/pagination.html';
            },
            link: function (scope, element, attrs, ctrls) {
                element.addClass('pagination');
                var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (!ngModelCtrl) {
                    return; // do nothing if no ng-model
                }

                paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
            }
        };
    }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

    /**
     * The $tooltip service creates tooltip- and popover-like directives as well as
     * houses global options for them.
     */
    .provider('$uibTooltip', function () {
        // The default options tooltip and popover.
        var defaultOptions = {
            placement: 'top',
            placementClassPrefix: '',
            animation: true,
            popupDelay: 0,
            popupCloseDelay: 0,
            useContentExp: false
        };

        // Default hide triggers for each show trigger
        var triggerMap = {
            'mouseenter': 'mouseleave',
            'click': 'click',
            'outsideClick': 'outsideClick',
            'focus': 'blur',
            'none': ''
        };

        // The options specified to the provider globally.
        var globalOptions = {};

        /**
         * `options({})` allows global configuration of all tooltips in the
         * application.
         *
         *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
         *     // place tooltips left instead of top by default
         *     $tooltipProvider.options( { placement: 'left' } );
         *   });
         */
        this.options = function (value) {
            angular.extend(globalOptions, value);
        };

        /**
         * This allows you to extend the set of trigger mappings available. E.g.:
         *
         *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
         */
        this.setTriggers = function setTriggers(triggers) {
            angular.extend(triggerMap, triggers);
        };

        /**
         * This is a helper function for translating camel-case to snake_case.
         */
        function snake_case(name) {
            var regexp = /[A-Z]/g;
            var separator = '-';
            return name.replace(regexp, function (letter, pos) {
                return (pos ? separator : '') + letter.toLowerCase();
            });
        }

        /**
         * Returns the actual instance of the $tooltip service.
         * TODO support multiple triggers
         */
        this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
            var openedTooltips = $$stackedMap.createNew();
            $document.on('keyup', keypressListener);

            $rootScope.$on('$destroy', function () {
                $document.off('keyup', keypressListener);
            });

            function keypressListener(e) {
                if (e.which === 27) {
                    var last = openedTooltips.top();
                    if (last) {
                        last.value.close();
                        last = null;
                    }
                }
            }

            return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
                options = angular.extend({}, defaultOptions, globalOptions, options);

                /**
                 * Returns an object of show and hide triggers.
                 *
                 * If a trigger is supplied,
                 * it is used to show the tooltip; otherwise, it will use the `trigger`
                 * option passed to the `$tooltipProvider.options` method; else it will
                 * default to the trigger supplied to this directive factory.
                 *
                 * The hide trigger is based on the show trigger. If the `trigger` option
                 * was passed to the `$tooltipProvider.options` method, it will use the
                 * mapped trigger from `triggerMap` or the passed trigger if the map is
                 * undefined; otherwise, it uses the `triggerMap` value of the show
                 * trigger; else it will just use the show trigger.
                 */
                function getTriggers(trigger) {
                    var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
                    var hide = show.map(function (trigger) {
                        return triggerMap[trigger] || trigger;
                    });
                    return {
                        show: show,
                        hide: hide
                    };
                }

                var directiveName = snake_case(ttType);

                var startSym = $interpolate.startSymbol();
                var endSym = $interpolate.endSymbol();
                var template =
                    '<div ' + directiveName + '-popup ' +
                    'uib-title="' + startSym + 'title' + endSym + '" ' +
                    (options.useContentExp ?
                        'content-exp="contentExp()" ' :
                        'content="' + startSym + 'content' + endSym + '" ') +
                    'origin-scope="origScope" ' +
                    'class="uib-position-measure ' + prefix + '" ' +
                    'tooltip-animation-class="fade"' +
                    'uib-tooltip-classes ' +
                    'ng-class="{ in: isOpen }" ' +
                    '>' +
                    '</div>';

                return {
                    compile: function (tElem, tAttrs) {
                        var tooltipLinker = $compile(template);

                        return function link(scope, element, attrs, tooltipCtrl) {
                            var tooltip;
                            var tooltipLinkedScope;
                            var transitionTimeout;
                            var showTimeout;
                            var hideTimeout;
                            var positionTimeout;
                            var adjustmentTimeout;
                            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
                            var triggers = getTriggers(undefined);
                            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
                            var ttScope = scope.$new(true);
                            var repositionScheduled = false;
                            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
                            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
                            var observers = [];
                            var lastPlacement;

                            var positionTooltip = function () {
                                // check if tooltip exists and is not empty
                                if (!tooltip || !tooltip.html()) { return; }

                                if (!positionTimeout) {
                                    positionTimeout = $timeout(function () {
                                        var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                                        var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                        var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                                        tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                                        var placementClasses = ttPosition.placement.split('-');

                                        if (!tooltip.hasClass(placementClasses[0])) {
                                            tooltip.removeClass(lastPlacement.split('-')[0]);
                                            tooltip.addClass(placementClasses[0]);
                                        }

                                        if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                                            tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                                            tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                                        }

                                        adjustmentTimeout = $timeout(function () {
                                            var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                                            var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                                            if (adjustment) {
                                                tooltip.css(adjustment);
                                            }
                                            adjustmentTimeout = null;
                                        }, 0, false);

                                        // first time through tt element will have the
                                        // uib-position-measure class or if the placement
                                        // has changed we need to position the arrow.
                                        if (tooltip.hasClass('uib-position-measure')) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                            tooltip.removeClass('uib-position-measure');
                                        } else if (lastPlacement !== ttPosition.placement) {
                                            $position.positionArrow(tooltip, ttPosition.placement);
                                        }
                                        lastPlacement = ttPosition.placement;

                                        positionTimeout = null;
                                    }, 0, false);
                                }
                            };

                            // Set up the correct scope to allow transclusion later
                            ttScope.origScope = scope;

                            // By default, the tooltip is not open.
                            // TODO add ability to start tooltip opened
                            ttScope.isOpen = false;

                            function toggleTooltipBind() {
                                if (!ttScope.isOpen) {
                                    showTooltipBind();
                                } else {
                                    hideTooltipBind();
                                }
                            }

                            // Show the tooltip with delay if specified, otherwise show it immediately
                            function showTooltipBind() {
                                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                                    return;
                                }

                                cancelHide();
                                prepareTooltip();

                                if (ttScope.popupDelay) {
                                    // Do nothing if the tooltip was already scheduled to pop-up.
                                    // This happens if show is triggered multiple times before any hide is triggered.
                                    if (!showTimeout) {
                                        showTimeout = $timeout(show, ttScope.popupDelay, false);
                                    }
                                } else {
                                    show();
                                }
                            }

                            function hideTooltipBind() {
                                cancelShow();

                                if (ttScope.popupCloseDelay) {
                                    if (!hideTimeout) {
                                        hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                                    }
                                } else {
                                    hide();
                                }
                            }

                            // Show the tooltip popup element.
                            function show() {
                                cancelShow();
                                cancelHide();

                                // Don't show empty tooltips.
                                if (!ttScope.content) {
                                    return angular.noop;
                                }

                                createTooltip();

                                // And show the tooltip.
                                ttScope.$evalAsync(function () {
                                    ttScope.isOpen = true;
                                    assignIsOpen(true);
                                    positionTooltip();
                                });
                            }

                            function cancelShow() {
                                if (showTimeout) {
                                    $timeout.cancel(showTimeout);
                                    showTimeout = null;
                                }

                                if (positionTimeout) {
                                    $timeout.cancel(positionTimeout);
                                    positionTimeout = null;
                                }
                            }

                            // Hide the tooltip popup element.
                            function hide() {
                                if (!ttScope) {
                                    return;
                                }

                                // First things first: we don't show it anymore.
                                ttScope.$evalAsync(function () {
                                    if (ttScope) {
                                        ttScope.isOpen = false;
                                        assignIsOpen(false);
                                        // And now we remove it from the DOM. However, if we have animation, we
                                        // need to wait for it to expire beforehand.
                                        // FIXME: this is a placeholder for a port of the transitions library.
                                        // The fade transition in TWBS is 150ms.
                                        if (ttScope.animation) {
                                            if (!transitionTimeout) {
                                                transitionTimeout = $timeout(removeTooltip, 150, false);
                                            }
                                        } else {
                                            removeTooltip();
                                        }
                                    }
                                });
                            }

                            function cancelHide() {
                                if (hideTimeout) {
                                    $timeout.cancel(hideTimeout);
                                    hideTimeout = null;
                                }

                                if (transitionTimeout) {
                                    $timeout.cancel(transitionTimeout);
                                    transitionTimeout = null;
                                }
                            }

                            function createTooltip() {
                                // There can only be one tooltip element per directive shown at once.
                                if (tooltip) {
                                    return;
                                }

                                tooltipLinkedScope = ttScope.$new();
                                tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                                    if (appendToBody) {
                                        $document.find('body').append(tooltip);
                                    } else {
                                        element.after(tooltip);
                                    }
                                });

                                openedTooltips.add(ttScope, {
                                    close: hide
                                });

                                prepObservers();
                            }

                            function removeTooltip() {
                                cancelShow();
                                cancelHide();
                                unregisterObservers();

                                if (tooltip) {
                                    tooltip.remove();

                                    tooltip = null;
                                    if (adjustmentTimeout) {
                                        $timeout.cancel(adjustmentTimeout);
                                    }
                                }

                                openedTooltips.remove(ttScope);

                                if (tooltipLinkedScope) {
                                    tooltipLinkedScope.$destroy();
                                    tooltipLinkedScope = null;
                                }
                            }

                            /**
                             * Set the initial scope values. Once
                             * the tooltip is created, the observers
                             * will be added to keep things in sync.
                             */
                            function prepareTooltip() {
                                ttScope.title = attrs[prefix + 'Title'];
                                if (contentParse) {
                                    ttScope.content = contentParse(scope);
                                } else {
                                    ttScope.content = attrs[ttType];
                                }

                                ttScope.popupClass = attrs[prefix + 'Class'];
                                ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
                                var placement = $position.parsePlacement(ttScope.placement);
                                lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

                                var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
                                var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
                                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
                                ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
                            }

                            function assignIsOpen(isOpen) {
                                if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                                    isOpenParse.assign(scope, isOpen);
                                }
                            }

                            ttScope.contentExp = function () {
                                return ttScope.content;
                            };

                            /**
                             * Observe the relevant attributes.
                             */
                            attrs.$observe('disabled', function (val) {
                                if (val) {
                                    cancelShow();
                                }

                                if (val && ttScope.isOpen) {
                                    hide();
                                }
                            });

                            if (isOpenParse) {
                                scope.$watch(isOpenParse, function (val) {
                                    if (ttScope && !val === ttScope.isOpen) {
                                        toggleTooltipBind();
                                    }
                                });
                            }

                            function prepObservers() {
                                observers.length = 0;

                                if (contentParse) {
                                    observers.push(
                                        scope.$watch(contentParse, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            }
                                        })
                                    );

                                    observers.push(
                                        tooltipLinkedScope.$watch(function () {
                                            if (!repositionScheduled) {
                                                repositionScheduled = true;
                                                tooltipLinkedScope.$$postDigest(function () {
                                                    repositionScheduled = false;
                                                    if (ttScope && ttScope.isOpen) {
                                                        positionTooltip();
                                                    }
                                                });
                                            }
                                        })
                                    );
                                } else {
                                    observers.push(
                                        attrs.$observe(ttType, function (val) {
                                            ttScope.content = val;
                                            if (!val && ttScope.isOpen) {
                                                hide();
                                            } else {
                                                positionTooltip();
                                            }
                                        })
                                    );
                                }

                                observers.push(
                                    attrs.$observe(prefix + 'Title', function (val) {
                                        ttScope.title = val;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );

                                observers.push(
                                    attrs.$observe(prefix + 'Placement', function (val) {
                                        ttScope.placement = val ? val : options.placement;
                                        if (ttScope.isOpen) {
                                            positionTooltip();
                                        }
                                    })
                                );
                            }

                            function unregisterObservers() {
                                if (observers.length) {
                                    angular.forEach(observers, function (observer) {
                                        observer();
                                    });
                                    observers.length = 0;
                                }
                            }

                            // hide tooltips/popovers for outsideClick trigger
                            function bodyHideTooltipBind(e) {
                                if (!ttScope || !ttScope.isOpen || !tooltip) {
                                    return;
                                }
                                // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
                                if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                                    hideTooltipBind();
                                }
                            }

                            // KeyboardEvent handler to hide the tooltip on Escape key press
                            function hideOnEscapeKey(e) {
                                if (e.which === 27) {
                                    hideTooltipBind();
                                }
                            }

                            var unregisterTriggers = function () {
                                triggers.show.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        element.off('click', toggleTooltipBind);
                                    } else {
                                        element.off(trigger, showTooltipBind);
                                        element.off(trigger, toggleTooltipBind);
                                    }
                                    element.off('keypress', hideOnEscapeKey);
                                });
                                triggers.hide.forEach(function (trigger) {
                                    if (trigger === 'outsideClick') {
                                        $document.off('click', bodyHideTooltipBind);
                                    } else {
                                        element.off(trigger, hideTooltipBind);
                                    }
                                });
                            };

                            function prepTriggers() {
                                var showTriggers = [], hideTriggers = [];
                                var val = scope.$eval(attrs[prefix + 'Trigger']);
                                unregisterTriggers();

                                if (angular.isObject(val)) {
                                    Object.keys(val).forEach(function (key) {
                                        showTriggers.push(key);
                                        hideTriggers.push(val[key]);
                                    });
                                    triggers = {
                                        show: showTriggers,
                                        hide: hideTriggers
                                    };
                                } else {
                                    triggers = getTriggers(val);
                                }

                                if (triggers.show !== 'none') {
                                    triggers.show.forEach(function (trigger, idx) {
                                        if (trigger === 'outsideClick') {
                                            element.on('click', toggleTooltipBind);
                                            $document.on('click', bodyHideTooltipBind);
                                        } else if (trigger === triggers.hide[idx]) {
                                            element.on(trigger, toggleTooltipBind);
                                        } else if (trigger) {
                                            element.on(trigger, showTooltipBind);
                                            element.on(triggers.hide[idx], hideTooltipBind);
                                        }
                                        element.on('keypress', hideOnEscapeKey);
                                    });
                                }
                            }

                            prepTriggers();

                            var animation = scope.$eval(attrs[prefix + 'Animation']);
                            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

                            var appendToBodyVal;
                            var appendKey = prefix + 'AppendToBody';
                            if (appendKey in attrs && attrs[appendKey] === undefined) {
                                appendToBodyVal = true;
                            } else {
                                appendToBodyVal = scope.$eval(attrs[appendKey]);
                            }

                            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

                            // Make sure tooltip is destroyed and removed.
                            scope.$on('$destroy', function onDestroyTooltip() {
                                unregisterTriggers();
                                removeTooltip();
                                ttScope = null;
                            });
                        };
                    }
                };
            };
        }];
    })

    // This is mostly ngInclude code but with a custom scope
    .directive('uibTooltipTemplateTransclude', [
        '$animate', '$sce', '$compile', '$templateRequest',
        function ($animate, $sce, $compile, $templateRequest) {
            return {
                link: function (scope, elem, attrs) {
                    var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

                    var changeCounter = 0,
                        currentScope,
                        previousElement,
                        currentElement;

                    var cleanupLastIncludeContent = function () {
                        if (previousElement) {
                            previousElement.remove();
                            previousElement = null;
                        }

                        if (currentScope) {
                            currentScope.$destroy();
                            currentScope = null;
                        }

                        if (currentElement) {
                            $animate.leave(currentElement).then(function () {
                                previousElement = null;
                            });
                            previousElement = currentElement;
                            currentElement = null;
                        }
                    };

                    scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
                        var thisChangeId = ++changeCounter;

                        if (src) {
                            //set the 2nd param to true to ignore the template request error so that the inner
                            //contents and scope can be cleaned up.
                            $templateRequest(src, true).then(function (response) {
                                if (thisChangeId !== changeCounter) { return; }
                                var newScope = origScope.$new();
                                var template = response;

                                var clone = $compile(template)(newScope, function (clone) {
                                    cleanupLastIncludeContent();
                                    $animate.enter(clone, elem);
                                });

                                currentScope = newScope;
                                currentElement = clone;

                                currentScope.$emit('$includeContentLoaded', src);
                            }, function () {
                                if (thisChangeId === changeCounter) {
                                    cleanupLastIncludeContent();
                                    scope.$emit('$includeContentError', src);
                                }
                            });
                            scope.$emit('$includeContentRequested', src);
                        } else {
                            cleanupLastIncludeContent();
                        }
                    });

                    scope.$on('$destroy', cleanupLastIncludeContent);
                }
            };
        }])

    /**
     * Note that it's intentional that these classes are *not* applied through $animate.
     * They must not be animated as they're expected to be present on the tooltip on
     * initialization.
     */
    .directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                // need to set the primary position so the
                // arrow has space during position measure.
                // tooltip.positionTooltip()
                if (scope.placement) {
                    // // There are no top-left etc... classes
                    // // in TWBS, so we need the primary position.
                    var position = $uibPosition.parsePlacement(scope.placement);
                    element.addClass(position[0]);
                }

                if (scope.popupClass) {
                    element.addClass(scope.popupClass);
                }

                if (scope.animation) {
                    element.addClass(attrs.tooltipAnimationClass);
                }
            }
        };
    }])

    .directive('uibTooltipPopup', function () {
        return {
            restrict: 'A',
            scope: { content: '@' },
            templateUrl: 'uib/template/tooltip/tooltip-popup.html'
        };
    })

    .directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
    }])

    .directive('uibTooltipTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
        };
    })

    .directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }])

    .directive('uibTooltipHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&' },
            templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
        };
    })

    .directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
            useContentExp: true
        });
    }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

    .directive('uibPopoverTemplatePopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
            templateUrl: 'uib/template/popover/popover-template.html'
        };
    })

    .directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverHtmlPopup', function () {
        return {
            restrict: 'A',
            scope: { contentExp: '&', uibTitle: '@' },
            templateUrl: 'uib/template/popover/popover-html.html'
        };
    })

    .directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
            useContentExp: true
        });
    }])

    .directive('uibPopoverPopup', function () {
        return {
            restrict: 'A',
            scope: { uibTitle: '@', content: '@' },
            templateUrl: 'uib/template/popover/popover.html'
        };
    })

    .directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
        return $uibTooltip('uibPopover', 'popover', 'click');
    }]);

angular.module('ui.bootstrap.progressbar', [])

    .constant('uibProgressConfig', {
        animate: true,
        max: 100
    })

    .controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
        var self = this,
            animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

        this.bars = [];
        $scope.max = getMaxOrDefault();

        this.addBar = function (bar, element, attrs) {
            if (!animate) {
                element.css({ 'transition': 'none' });
            }

            this.bars.push(bar);

            bar.max = getMaxOrDefault();
            bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

            bar.$watch('value', function (value) {
                bar.recalculatePercentage();
            });

            bar.recalculatePercentage = function () {
                var totalPercentage = self.bars.reduce(function (total, bar) {
                    bar.percent = +(100 * bar.value / bar.max).toFixed(2);
                    return total + bar.percent;
                }, 0);

                if (totalPercentage > 100) {
                    bar.percent -= totalPercentage - 100;
                }
            };

            bar.$on('$destroy', function () {
                element = null;
                self.removeBar(bar);
            });
        };

        this.removeBar = function (bar) {
            this.bars.splice(this.bars.indexOf(bar), 1);
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        };

        //$attrs.$observe('maxParam', function(maxParam) {
        $scope.$watch('maxParam', function (maxParam) {
            self.bars.forEach(function (bar) {
                bar.max = getMaxOrDefault();
                bar.recalculatePercentage();
            });
        });

        function getMaxOrDefault() {
            return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
        }
    }])

    .directive('uibProgress', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            require: 'uibProgress',
            scope: {
                maxParam: '=?max'
            },
            templateUrl: 'uib/template/progressbar/progress.html'
        };
    })

    .directive('uibBar', function () {
        return {
            replace: true,
            transclude: true,
            require: '^uibProgress',
            scope: {
                value: '=',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/bar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, element, attrs);
            }
        };
    })

    .directive('uibProgressbar', function () {
        return {
            replace: true,
            transclude: true,
            controller: 'UibProgressController',
            scope: {
                value: '=',
                maxParam: '=?max',
                type: '@'
            },
            templateUrl: 'uib/template/progressbar/progressbar.html',
            link: function (scope, element, attrs, progressCtrl) {
                progressCtrl.addBar(scope, angular.element(element.children()[0]), { title: attrs.title });
            }
        };
    });

angular.module('ui.bootstrap.rating', [])

    .constant('uibRatingConfig', {
        max: 5,
        stateOn: null,
        stateOff: null,
        enableReset: true,
        titles: ['one', 'two', 'three', 'four', 'five']
    })

    .controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
        var ngModelCtrl = { $setViewValue: angular.noop },
            self = this;

        this.init = function (ngModelCtrl_) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.push(function (value) {
                if (angular.isNumber(value) && value << 0 !== value) {
                    value = Math.round(value);
                }

                return value;
            });

            this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
            this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
            this.enableReset = angular.isDefined($attrs.enableReset) ?
                $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
            var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
            this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
                tmpTitles : ratingConfig.titles;

            var ratingStates = angular.isDefined($attrs.ratingStates) ?
                $scope.$parent.$eval($attrs.ratingStates) :
                new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
            $scope.range = this.buildTemplateObjects(ratingStates);
        };

        this.buildTemplateObjects = function (states) {
            for (var i = 0, n = states.length; i < n; i++) {
                states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
            }
            return states;
        };

        this.getTitle = function (index) {
            if (index >= this.titles.length) {
                return index + 1;
            }

            return this.titles[index];
        };

        $scope.rate = function (value) {
            if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
                var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
                ngModelCtrl.$setViewValue(newViewValue);
                ngModelCtrl.$render();
            }
        };

        $scope.enter = function (value) {
            if (!$scope.readonly) {
                $scope.value = value;
            }
            $scope.onHover({ value: value });
        };

        $scope.reset = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.onLeave();
        };

        $scope.onKeydown = function (evt) {
            if (/(37|38|39|40)/.test(evt.which)) {
                evt.preventDefault();
                evt.stopPropagation();
                $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
            }
        };

        this.render = function () {
            $scope.value = ngModelCtrl.$viewValue;
            $scope.title = self.getTitle($scope.value - 1);
        };
    }])

    .directive('uibRating', function () {
        return {
            require: ['uibRating', 'ngModel'],
            restrict: 'A',
            scope: {
                readonly: '=?readOnly',
                onHover: '&',
                onLeave: '&'
            },
            controller: 'UibRatingController',
            templateUrl: 'uib/template/rating/rating.html',
            link: function (scope, element, attrs, ctrls) {
                var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                ratingCtrl.init(ngModelCtrl);
            }
        };
    });

angular.module('ui.bootstrap.tabs', [])

    .controller('UibTabsetController', ['$scope', function ($scope) {
        var ctrl = this,
            oldIndex;
        ctrl.tabs = [];

        ctrl.select = function (index, evt) {
            if (!destroyed) {
                var previousIndex = findTabIndex(oldIndex);
                var previousSelected = ctrl.tabs[previousIndex];
                if (previousSelected) {
                    previousSelected.tab.onDeselect({
                        $event: evt,
                        $selectedIndex: index
                    });
                    if (evt && evt.isDefaultPrevented()) {
                        return;
                    }
                    previousSelected.tab.active = false;
                }

                var selected = ctrl.tabs[index];
                if (selected) {
                    selected.tab.onSelect({
                        $event: evt
                    });
                    selected.tab.active = true;
                    ctrl.active = selected.index;
                    oldIndex = selected.index;
                } else if (!selected && angular.isDefined(oldIndex)) {
                    ctrl.active = null;
                    oldIndex = null;
                }
            }
        };

        ctrl.addTab = function addTab(tab) {
            ctrl.tabs.push({
                tab: tab,
                index: tab.index
            });
            ctrl.tabs.sort(function (t1, t2) {
                if (t1.index > t2.index) {
                    return 1;
                }

                if (t1.index < t2.index) {
                    return -1;
                }

                return 0;
            });

            if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
                var newActiveIndex = findTabIndex(tab.index);
                ctrl.select(newActiveIndex);
            }
        };

        ctrl.removeTab = function removeTab(tab) {
            var index;
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].tab === tab) {
                    index = i;
                    break;
                }
            }

            if (ctrl.tabs[index].index === ctrl.active) {
                var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
                    index - 1 : index + 1 % ctrl.tabs.length;
                ctrl.select(newActiveTabIndex);
            }

            ctrl.tabs.splice(index, 1);
        };

        $scope.$watch('tabset.active', function (val) {
            if (angular.isDefined(val) && val !== oldIndex) {
                ctrl.select(findTabIndex(val));
            }
        });

        var destroyed;
        $scope.$on('$destroy', function () {
            destroyed = true;
        });

        function findTabIndex(index) {
            for (var i = 0; i < ctrl.tabs.length; i++) {
                if (ctrl.tabs[i].index === index) {
                    return i;
                }
            }
        }
    }])

    .directive('uibTabset', function () {
        return {
            transclude: true,
            replace: true,
            scope: {},
            bindToController: {
                active: '=?',
                type: '@'
            },
            controller: 'UibTabsetController',
            controllerAs: 'tabset',
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tabset.html';
            },
            link: function (scope, element, attrs) {
                scope.vertical = angular.isDefined(attrs.vertical) ?
                    scope.$parent.$eval(attrs.vertical) : false;
                scope.justified = angular.isDefined(attrs.justified) ?
                    scope.$parent.$eval(attrs.justified) : false;
            }
        };
    })

    .directive('uibTab', ['$parse', function ($parse) {
        return {
            require: '^uibTabset',
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || 'uib/template/tabs/tab.html';
            },
            transclude: true,
            scope: {
                heading: '@',
                index: '=?',
                classes: '@?',
                onSelect: '&select', //This callback is called in contentHeadingTransclude
                //once it inserts the tab's content into the dom
                onDeselect: '&deselect'
            },
            controller: function () {
                //Empty controller so other directives can require being 'under' a tab
            },
            controllerAs: 'tab',
            link: function (scope, elm, attrs, tabsetCtrl, transclude) {
                scope.disabled = false;
                if (attrs.disable) {
                    scope.$parent.$watch($parse(attrs.disable), function (value) {
                        scope.disabled = !!value;
                    });
                }

                if (angular.isUndefined(attrs.index)) {
                    if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
                        scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) { return t.index; })) + 1;
                    } else {
                        scope.index = 0;
                    }
                }

                if (angular.isUndefined(attrs.classes)) {
                    scope.classes = '';
                }

                scope.select = function (evt) {
                    if (!scope.disabled) {
                        var index;
                        for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
                            if (tabsetCtrl.tabs[i].tab === scope) {
                                index = i;
                                break;
                            }
                        }

                        tabsetCtrl.select(index, evt);
                    }
                };

                tabsetCtrl.addTab(scope);
                scope.$on('$destroy', function () {
                    tabsetCtrl.removeTab(scope);
                });

                //We need to transclude later, once the content container is ready.
                //when this link happens, we're inside a tab heading.
                scope.$transcludeFn = transclude;
            }
        };
    }])

    .directive('uibTabHeadingTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTab',
            link: function (scope, elm) {
                scope.$watch('headingElement', function updateHeadingElement(heading) {
                    if (heading) {
                        elm.html('');
                        elm.append(heading);
                    }
                });
            }
        };
    })

    .directive('uibTabContentTransclude', function () {
        return {
            restrict: 'A',
            require: '^uibTabset',
            link: function (scope, elm, attrs) {
                var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

                //Now our tab is ready to be transcluded: both the tab heading area
                //and the tab content area are loaded.  Transclude 'em both.
                tab.$transcludeFn(tab.$parent, function (contents) {
                    angular.forEach(contents, function (node) {
                        if (isTabHeading(node)) {
                            //Let tabHeadingTransclude know.
                            tab.headingElement = node;
                        } else {
                            elm.append(node);
                        }
                    });
                });
            }
        };

        function isTabHeading(node) {
            return node.tagName && (
                node.hasAttribute('uib-tab-heading') ||
                node.hasAttribute('data-uib-tab-heading') ||
                node.hasAttribute('x-uib-tab-heading') ||
                node.tagName.toLowerCase() === 'uib-tab-heading' ||
                node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
                node.tagName.toLowerCase() === 'uib:tab-heading'
            );
        }
    });

angular.module('ui.bootstrap.timepicker', [])

    .constant('uibTimepickerConfig', {
        hourStep: 1,
        minuteStep: 1,
        secondStep: 1,
        showMeridian: true,
        showSeconds: false,
        meridians: null,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true,
        showSpinners: true,
        templateUrl: 'uib/template/timepicker/timepicker.html'
    })

    .controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
        var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
        var selected = new Date(),
            watchers = [],
            ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
            meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
            padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

        $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
        $element.removeAttr('tabindex');

        this.init = function (ngModelCtrl_, inputs) {
            ngModelCtrl = ngModelCtrl_;
            ngModelCtrl.$render = this.render;

            ngModelCtrl.$formatters.unshift(function (modelValue) {
                return modelValue ? new Date(modelValue) : null;
            });

            var hoursInputEl = inputs.eq(0),
                minutesInputEl = inputs.eq(1),
                secondsInputEl = inputs.eq(2);

            hoursModelCtrl = hoursInputEl.controller('ngModel');
            minutesModelCtrl = minutesInputEl.controller('ngModel');
            secondsModelCtrl = secondsInputEl.controller('ngModel');

            var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

            if (mousewheel) {
                this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
            if (arrowkeys) {
                this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
            }

            $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
            this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
        };

        var hourStep = timepickerConfig.hourStep;
        if ($attrs.hourStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
                hourStep = +value;
            }));
        }

        var minuteStep = timepickerConfig.minuteStep;
        if ($attrs.minuteStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
                minuteStep = +value;
            }));
        }

        var min;
        watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
            var dt = new Date(value);
            min = isNaN(dt) ? undefined : dt;
        }));

        var max;
        watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
            var dt = new Date(value);
            max = isNaN(dt) ? undefined : dt;
        }));

        var disabled = false;
        if ($attrs.ngDisabled) {
            watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
                disabled = value;
            }));
        }

        $scope.noIncrementHours = function () {
            var incrementedSelected = addMinutes(selected, hourStep * 60);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementHours = function () {
            var decrementedSelected = addMinutes(selected, -hourStep * 60);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementMinutes = function () {
            var incrementedSelected = addMinutes(selected, minuteStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementMinutes = function () {
            var decrementedSelected = addMinutes(selected, -minuteStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noIncrementSeconds = function () {
            var incrementedSelected = addSeconds(selected, secondStep);
            return disabled || incrementedSelected > max ||
                incrementedSelected < selected && incrementedSelected < min;
        };

        $scope.noDecrementSeconds = function () {
            var decrementedSelected = addSeconds(selected, -secondStep);
            return disabled || decrementedSelected < min ||
                decrementedSelected > selected && decrementedSelected > max;
        };

        $scope.noToggleMeridian = function () {
            if (selected.getHours() < 12) {
                return disabled || addMinutes(selected, 12 * 60) > max;
            }

            return disabled || addMinutes(selected, -12 * 60) < min;
        };

        var secondStep = timepickerConfig.secondStep;
        if ($attrs.secondStep) {
            watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
                secondStep = +value;
            }));
        }

        $scope.showSeconds = timepickerConfig.showSeconds;
        if ($attrs.showSeconds) {
            watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
                $scope.showSeconds = !!value;
            }));
        }

        // 12H / 24H mode
        $scope.showMeridian = timepickerConfig.showMeridian;
        if ($attrs.showMeridian) {
            watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
                $scope.showMeridian = !!value;

                if (ngModelCtrl.$error.time) {
                    // Evaluate from template
                    var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                    if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                        selected.setHours(hours);
                        refresh();
                    }
                } else {
                    updateTemplate();
                }
            }));
        }

        // Get $scope.hours in 24H mode if valid
        function getHoursFromTemplate() {
            var hours = +$scope.hours;
            var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
                hours >= 0 && hours < 24;
            if (!valid || $scope.hours === '') {
                return undefined;
            }

            if ($scope.showMeridian) {
                if (hours === 12) {
                    hours = 0;
                }
                if ($scope.meridian === meridians[1]) {
                    hours = hours + 12;
                }
            }
            return hours;
        }

        function getMinutesFromTemplate() {
            var minutes = +$scope.minutes;
            var valid = minutes >= 0 && minutes < 60;
            if (!valid || $scope.minutes === '') {
                return undefined;
            }
            return minutes;
        }

        function getSecondsFromTemplate() {
            var seconds = +$scope.seconds;
            return seconds >= 0 && seconds < 60 ? seconds : undefined;
        }

        function pad(value, noPad) {
            if (value === null) {
                return '';
            }

            return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
                '0' + value : value.toString();
        }

        // Respond on mousewheel spin
        this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            var isScrollingUp = function (e) {
                if (e.originalEvent) {
                    e = e.originalEvent;
                }
                //pick correct delta variable depending on event
                var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
                return e.detail || delta > 0;
            };

            hoursInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
                }
                e.preventDefault();
            });

            minutesInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
                }
                e.preventDefault();
            });

            secondsInputEl.on('mousewheel wheel', function (e) {
                if (!disabled) {
                    $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
                }
                e.preventDefault();
            });
        };

        // Respond on up/down arrowkeys
        this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            hoursInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementHours();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementHours();
                        $scope.$apply();
                    }
                }
            });

            minutesInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementMinutes();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementMinutes();
                        $scope.$apply();
                    }
                }
            });

            secondsInputEl.on('keydown', function (e) {
                if (!disabled) {
                    if (e.which === 38) { // up
                        e.preventDefault();
                        $scope.incrementSeconds();
                        $scope.$apply();
                    } else if (e.which === 40) { // down
                        e.preventDefault();
                        $scope.decrementSeconds();
                        $scope.$apply();
                    }
                }
            });
        };

        this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
            if ($scope.readonlyInput) {
                $scope.updateHours = angular.noop;
                $scope.updateMinutes = angular.noop;
                $scope.updateSeconds = angular.noop;
                return;
            }

            var invalidate = function (invalidHours, invalidMinutes, invalidSeconds) {
                ngModelCtrl.$setViewValue(null);
                ngModelCtrl.$setValidity('time', false);
                if (angular.isDefined(invalidHours)) {
                    $scope.invalidHours = invalidHours;
                    if (hoursModelCtrl) {
                        hoursModelCtrl.$setValidity('hours', false);
                    }
                }

                if (angular.isDefined(invalidMinutes)) {
                    $scope.invalidMinutes = invalidMinutes;
                    if (minutesModelCtrl) {
                        minutesModelCtrl.$setValidity('minutes', false);
                    }
                }

                if (angular.isDefined(invalidSeconds)) {
                    $scope.invalidSeconds = invalidSeconds;
                    if (secondsModelCtrl) {
                        secondsModelCtrl.$setValidity('seconds', false);
                    }
                }
            };

            $scope.updateHours = function () {
                var hours = getHoursFromTemplate(),
                    minutes = getMinutesFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(true);
                    } else {
                        refresh('h');
                    }
                } else {
                    invalidate(true);
                }
            };

            hoursInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.hours === null || $scope.hours === '') {
                    invalidate(true);
                } else if (!$scope.invalidHours && $scope.hours < 10) {
                    $scope.$apply(function () {
                        $scope.hours = pad($scope.hours, !padHours);
                    });
                }
            });

            $scope.updateMinutes = function () {
                var minutes = getMinutesFromTemplate(),
                    hours = getHoursFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    selected.setHours(hours);
                    selected.setMinutes(minutes);
                    if (selected < min || selected > max) {
                        invalidate(undefined, true);
                    } else {
                        refresh('m');
                    }
                } else {
                    invalidate(undefined, true);
                }
            };

            minutesInputEl.on('blur', function (e) {
                ngModelCtrl.$setTouched();
                if (modelIsEmpty()) {
                    makeValid();
                } else if ($scope.minutes === null) {
                    invalidate(undefined, true);
                } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
                    $scope.$apply(function () {
                        $scope.minutes = pad($scope.minutes);
                    });
                }
            });

            $scope.updateSeconds = function () {
                var seconds = getSecondsFromTemplate();

                ngModelCtrl.$setDirty();

                if (angular.isDefined(seconds)) {
                    selected.setSeconds(seconds);
                    refresh('s');
                } else {
                    invalidate(undefined, undefined, true);
                }
            };

            secondsInputEl.on('blur', function (e) {
                if (modelIsEmpty()) {
                    makeValid();
                } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
                    $scope.$apply(function () {
                        $scope.seconds = pad($scope.seconds);
                    });
                }
            });

        };

        this.render = function () {
            var date = ngModelCtrl.$viewValue;

            if (isNaN(date)) {
                ngModelCtrl.$setValidity('time', false);
                $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
            } else {
                if (date) {
                    selected = date;
                }

                if (selected < min || selected > max) {
                    ngModelCtrl.$setValidity('time', false);
                    $scope.invalidHours = true;
                    $scope.invalidMinutes = true;
                } else {
                    makeValid();
                }
                updateTemplate();
            }
        };

        // Call internally when we know that model is valid.
        function refresh(keyboardChange) {
            makeValid();
            ngModelCtrl.$setViewValue(new Date(selected));
            updateTemplate(keyboardChange);
        }

        function makeValid() {
            if (hoursModelCtrl) {
                hoursModelCtrl.$setValidity('hours', true);
            }

            if (minutesModelCtrl) {
                minutesModelCtrl.$setValidity('minutes', true);
            }

            if (secondsModelCtrl) {
                secondsModelCtrl.$setValidity('seconds', true);
            }

            ngModelCtrl.$setValidity('time', true);
            $scope.invalidHours = false;
            $scope.invalidMinutes = false;
            $scope.invalidSeconds = false;
        }

        function updateTemplate(keyboardChange) {
            if (!ngModelCtrl.$modelValue) {
                $scope.hours = null;
                $scope.minutes = null;
                $scope.seconds = null;
                $scope.meridian = meridians[0];
            } else {
                var hours = selected.getHours(),
                    minutes = selected.getMinutes(),
                    seconds = selected.getSeconds();

                if ($scope.showMeridian) {
                    hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
                }

                $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
                if (keyboardChange !== 'm') {
                    $scope.minutes = pad(minutes);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

                if (keyboardChange !== 's') {
                    $scope.seconds = pad(seconds);
                }
                $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
            }
        }

        function addSecondsToSelected(seconds) {
            selected = addSeconds(selected, seconds);
            refresh();
        }

        function addMinutes(selected, minutes) {
            return addSeconds(selected, minutes * 60);
        }

        function addSeconds(date, seconds) {
            var dt = new Date(date.getTime() + seconds * 1000);
            var newDate = new Date(date);
            newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
            return newDate;
        }

        function modelIsEmpty() {
            return ($scope.hours === null || $scope.hours === '') &&
                ($scope.minutes === null || $scope.minutes === '') &&
                (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
        }

        $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
            $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

        $scope.incrementHours = function () {
            if (!$scope.noIncrementHours()) {
                addSecondsToSelected(hourStep * 60 * 60);
            }
        };

        $scope.decrementHours = function () {
            if (!$scope.noDecrementHours()) {
                addSecondsToSelected(-hourStep * 60 * 60);
            }
        };

        $scope.incrementMinutes = function () {
            if (!$scope.noIncrementMinutes()) {
                addSecondsToSelected(minuteStep * 60);
            }
        };

        $scope.decrementMinutes = function () {
            if (!$scope.noDecrementMinutes()) {
                addSecondsToSelected(-minuteStep * 60);
            }
        };

        $scope.incrementSeconds = function () {
            if (!$scope.noIncrementSeconds()) {
                addSecondsToSelected(secondStep);
            }
        };

        $scope.decrementSeconds = function () {
            if (!$scope.noDecrementSeconds()) {
                addSecondsToSelected(-secondStep);
            }
        };

        $scope.toggleMeridian = function () {
            var minutes = getMinutesFromTemplate(),
                hours = getHoursFromTemplate();

            if (!$scope.noToggleMeridian()) {
                if (angular.isDefined(minutes) && angular.isDefined(hours)) {
                    addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
                } else {
                    $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
                }
            }
        };

        $scope.blur = function () {
            ngModelCtrl.$setTouched();
        };

        $scope.$on('$destroy', function () {
            while (watchers.length) {
                watchers.shift()();
            }
        });
    }])

    .directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
        return {
            require: ['uibTimepicker', '?^ngModel'],
            restrict: 'A',
            controller: 'UibTimepickerController',
            controllerAs: 'timepicker',
            scope: {},
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || uibTimepickerConfig.templateUrl;
            },
            link: function (scope, element, attrs, ctrls) {
                var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

                if (ngModelCtrl) {
                    timepickerCtrl.init(ngModelCtrl, element.find('input'));
                }
            }
        };
    }]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

    /**
     * A helper service that can parse typeahead's syntax (string provided by users)
     * Extracted to a separate service for ease of unit testing
     */
    .factory('uibTypeaheadParser', ['$parse', function ($parse) {
        //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
        var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
        return {
            parse: function (input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error(
                        'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
                        ' but got "' + input + '".');
                }

                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    }])

    .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
        function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
            var HOT_KEYS = [9, 13, 27, 38, 40];
            var eventDebounceTime = 200;
            var modelCtrl, ngModelOptions;
            //SUPPORTED ATTRIBUTES (OPTIONS)

            //minimal no of characters that needs to be entered before typeahead kicks-in
            var minLength = originalScope.$eval(attrs.typeaheadMinLength);
            if (!minLength && minLength !== 0) {
                minLength = 1;
            }

            originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
                minLength = !newVal && newVal !== 0 ? 1 : newVal;
            });

            //minimal wait time after last character typed before typeahead kicks-in
            var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

            //should it restrict model values to the ones selected from the popup only?
            var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
            originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
                isEditable = newVal !== false;
            });

            //binding to a variable that indicates if matches are being retrieved asynchronously
            var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

            //a function to determine if an event should cause selection
            var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {
                var evt = vals.$event;
                return evt.which === 13 || evt.which === 9;
            };

            //a callback executed when a match is selected
            var onSelectCallback = $parse(attrs.typeaheadOnSelect);

            //should it select highlighted popup value when losing focus?
            var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

            //binding to a variable that indicates if there were no results after the query is completed
            var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

            var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

            var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

            var appendTo = attrs.typeaheadAppendTo ?
                originalScope.$eval(attrs.typeaheadAppendTo) : null;

            var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

            //If input matches an item of the list exactly, select it automatically
            var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

            //binding to a variable that indicates if dropdown is open
            var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

            var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

            //INTERNAL VARIABLES

            //model setter executed upon match selection
            var parsedModel = $parse(attrs.ngModel);
            var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
            var $setModelValue = function (scope, newValue) {
                if (angular.isFunction(parsedModel(originalScope)) &&
                    ngModelOptions.getOption('getterSetter')) {
                    return invokeModelSetter(scope, { $$$p: newValue });
                }

                return parsedModel.assign(scope, newValue);
            };

            //expressions used by typeahead
            var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

            var hasFocus;

            //Used to avoid bug in iOS webview where iOS keyboard does not fire
            //mousedown & mouseup events
            //Issue #3699
            var selected;

            //create a child scope for the typeahead directive so we are not polluting original scope
            //with typeahead-specific data (matches, query etc.)
            var scope = originalScope.$new();
            var offDestroy = originalScope.$on('$destroy', function () {
                scope.$destroy();
            });
            scope.$on('$destroy', offDestroy);

            // WAI-ARIA
            var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
            element.attr({
                'aria-autocomplete': 'list',
                'aria-expanded': false,
                'aria-owns': popupId
            });

            var inputsContainer, hintInputElem;
            //add read-only input to show hint
            if (showHint) {
                inputsContainer = angular.element('<div></div>');
                inputsContainer.css('position', 'relative');
                element.after(inputsContainer);
                hintInputElem = element.clone();
                hintInputElem.attr('placeholder', '');
                hintInputElem.attr('tabindex', '-1');
                hintInputElem.val('');
                hintInputElem.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': '0px',
                    'border-color': 'transparent',
                    'box-shadow': 'none',
                    'opacity': 1,
                    'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
                    'color': '#999'
                });
                element.css({
                    'position': 'relative',
                    'vertical-align': 'top',
                    'background-color': 'transparent'
                });

                if (hintInputElem.attr('id')) {
                    hintInputElem.removeAttr('id'); // remove duplicate id if present.
                }
                inputsContainer.append(hintInputElem);
                hintInputElem.after(element);
            }

            //pop-up element used to display matches
            var popUpEl = angular.element('<div uib-typeahead-popup></div>');
            popUpEl.attr({
                id: popupId,
                matches: 'matches',
                active: 'activeIdx',
                select: 'select(activeIdx, evt)',
                'move-in-progress': 'moveInProgress',
                query: 'query',
                position: 'position',
                'assign-is-open': 'assignIsOpen(isOpen)',
                debounce: 'debounceUpdate'
            });
            //custom item template
            if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
                popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
            }

            if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
                popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
            }

            var resetHint = function () {
                if (showHint) {
                    hintInputElem.val('');
                }
            };

            var resetMatches = function () {
                scope.matches = [];
                scope.activeIdx = -1;
                element.attr('aria-expanded', false);
                resetHint();
            };

            var getMatchId = function (index) {
                return popupId + '-option-' + index;
            };

            // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
            // This attribute is added or removed automatically when the `activeIdx` changes.
            scope.$watch('activeIdx', function (index) {
                if (index < 0) {
                    element.removeAttr('aria-activedescendant');
                } else {
                    element.attr('aria-activedescendant', getMatchId(index));
                }
            });

            var inputIsExactMatch = function (inputValue, index) {
                if (scope.matches.length > index && inputValue) {
                    return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
                }

                return false;
            };

            var getMatchesAsync = function (inputValue, evt) {
                var locals = { $viewValue: inputValue };
                isLoadingSetter(originalScope, true);
                isNoResultsSetter(originalScope, false);
                $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
                    //it might happen that several async queries were in progress if a user were typing fast
                    //but we are interested only in responses that correspond to the current view value
                    var onCurrentRequest = inputValue === modelCtrl.$viewValue;
                    if (onCurrentRequest && hasFocus) {
                        if (matches && matches.length > 0) {
                            scope.activeIdx = focusFirst ? 0 : -1;
                            isNoResultsSetter(originalScope, false);
                            scope.matches.length = 0;

                            //transform labels
                            for (var i = 0; i < matches.length; i++) {
                                locals[parserResult.itemName] = matches[i];
                                scope.matches.push({
                                    id: getMatchId(i),
                                    label: parserResult.viewMapper(scope, locals),
                                    model: matches[i]
                                });
                            }

                            scope.query = inputValue;
                            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                            //due to other elements being rendered
                            recalculatePosition();

                            element.attr('aria-expanded', true);

                            //Select the single remaining option if user input matches
                            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(0, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(0, evt);
                                }
                            }

                            if (showHint) {
                                var firstLabel = scope.matches[0].label;
                                if (angular.isString(inputValue) &&
                                    inputValue.length > 0 &&
                                    firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                                    hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
                                } else {
                                    hintInputElem.val('');
                                }
                            }
                        } else {
                            resetMatches();
                            isNoResultsSetter(originalScope, true);
                        }
                    }
                    if (onCurrentRequest) {
                        isLoadingSetter(originalScope, false);
                    }
                }, function () {
                    resetMatches();
                    isLoadingSetter(originalScope, false);
                    isNoResultsSetter(originalScope, true);
                });
            };

            // bind events only if appendToBody params exist - performance feature
            if (appendToBody) {
                angular.element($window).on('resize', fireRecalculating);
                $document.find('body').on('scroll', fireRecalculating);
            }

            // Declare the debounced function outside recalculating for
            // proper debouncing
            var debouncedRecalculate = $$debounce(function () {
                // if popup is visible
                if (scope.matches.length) {
                    recalculatePosition();
                }

                scope.moveInProgress = false;
            }, eventDebounceTime);

            // Default progress type
            scope.moveInProgress = false;

            function fireRecalculating() {
                if (!scope.moveInProgress) {
                    scope.moveInProgress = true;
                    scope.$digest();
                }

                debouncedRecalculate();
            }

            // recalculate actual position and set new values to scope
            // after digest loop is popup in right position
            function recalculatePosition() {
                scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                scope.position.top += element.prop('offsetHeight');
            }

            //we need to propagate user's query so we can higlight matches
            scope.query = undefined;

            //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
            var timeoutPromise;

            var scheduleSearchWithTimeout = function (inputValue) {
                timeoutPromise = $timeout(function () {
                    getMatchesAsync(inputValue);
                }, waitTime);
            };

            var cancelPreviousTimeout = function () {
                if (timeoutPromise) {
                    $timeout.cancel(timeoutPromise);
                }
            };

            resetMatches();

            scope.assignIsOpen = function (isOpen) {
                isOpenSetter(originalScope, isOpen);
            };

            scope.select = function (activeIdx, evt) {
                //called from within the $digest() cycle
                var locals = {};
                var model, item;

                selected = true;
                locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
                model = parserResult.modelMapper(originalScope, locals);
                $setModelValue(originalScope, model);
                modelCtrl.$setValidity('editable', true);
                modelCtrl.$setValidity('parse', true);

                onSelectCallback(originalScope, {
                    $item: item,
                    $model: model,
                    $label: parserResult.viewMapper(originalScope, locals),
                    $event: evt
                });

                resetMatches();

                //return focus to the input element if a match was selected via a mouse click event
                // use timeout to avoid $rootScope:inprog error
                if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
                    $timeout(function () { element[0].focus(); }, 0, false);
                }
            };

            //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
            element.on('keydown', function (evt) {
                //typeahead is open and an "interesting" key was pressed
                if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
                    return;
                }

                var shouldSelect = isSelectEvent(originalScope, { $event: evt });

                /**
                 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
                 * or
                 * shift + tab is pressed to bring focus to the previous element
                 * then clear the results
                 */
                if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
                    resetMatches();
                    scope.$digest();
                    return;
                }

                evt.preventDefault();
                var target;
                switch (evt.which) {
                    case 27: // escape
                        evt.stopPropagation();

                        resetMatches();
                        originalScope.$digest();
                        break;
                    case 38: // up arrow
                        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    case 40: // down arrow
                        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
                        scope.$digest();
                        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
                        target.parentNode.scrollTop = target.offsetTop;
                        break;
                    default:
                        if (shouldSelect) {
                            scope.$apply(function () {
                                if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                                    $$debounce(function () {
                                        scope.select(scope.activeIdx, evt);
                                    }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
                                } else {
                                    scope.select(scope.activeIdx, evt);
                                }
                            });
                        }
                }
            });

            element.on('focus', function (evt) {
                hasFocus = true;
                if (minLength === 0 && !modelCtrl.$viewValue) {
                    $timeout(function () {
                        getMatchesAsync(modelCtrl.$viewValue, evt);
                    }, 0);
                }
            });

            element.on('blur', function (evt) {
                if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
                    selected = true;
                    scope.$apply(function () {
                        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
                            $$debounce(function () {
                                scope.select(scope.activeIdx, evt);
                            }, scope.debounceUpdate.blur);
                        } else {
                            scope.select(scope.activeIdx, evt);
                        }
                    });
                }
                if (!isEditable && modelCtrl.$error.editable) {
                    modelCtrl.$setViewValue();
                    scope.$apply(function () {
                        // Reset validity as we are clearing
                        modelCtrl.$setValidity('editable', true);
                        modelCtrl.$setValidity('parse', true);
                    });
                    element.val('');
                }
                hasFocus = false;
                selected = false;
            });

            // Keep reference to click handler to unbind it.
            var dismissClickHandler = function (evt) {
                // Issue #3973
                // Firefox treats right click as a click on document
                if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
                    resetMatches();
                    if (!$rootScope.$$phase) {
                        originalScope.$digest();
                    }
                }
            };

            $document.on('click', dismissClickHandler);

            originalScope.$on('$destroy', function () {
                $document.off('click', dismissClickHandler);
                if (appendToBody || appendTo) {
                    $popup.remove();
                }

                if (appendToBody) {
                    angular.element($window).off('resize', fireRecalculating);
                    $document.find('body').off('scroll', fireRecalculating);
                }
                // Prevent jQuery cache memory leak
                popUpEl.remove();

                if (showHint) {
                    inputsContainer.remove();
                }
            });

            var $popup = $compile(popUpEl)(scope);

            if (appendToBody) {
                $document.find('body').append($popup);
            } else if (appendTo) {
                angular.element(appendTo).eq(0).append($popup);
            } else {
                element.after($popup);
            }

            this.init = function (_modelCtrl) {
                modelCtrl = _modelCtrl;
                ngModelOptions = extractOptions(modelCtrl);

                scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

                //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
                //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
                modelCtrl.$parsers.unshift(function (inputValue) {
                    hasFocus = true;

                    if (minLength === 0 || inputValue && inputValue.length >= minLength) {
                        if (waitTime > 0) {
                            cancelPreviousTimeout();
                            scheduleSearchWithTimeout(inputValue);
                        } else {
                            getMatchesAsync(inputValue);
                        }
                    } else {
                        isLoadingSetter(originalScope, false);
                        cancelPreviousTimeout();
                        resetMatches();
                    }

                    if (isEditable) {
                        return inputValue;
                    }

                    if (!inputValue) {
                        // Reset in case user had typed something previously.
                        modelCtrl.$setValidity('editable', true);
                        return null;
                    }

                    modelCtrl.$setValidity('editable', false);
                    return undefined;
                });

                modelCtrl.$formatters.push(function (modelValue) {
                    var candidateViewValue, emptyViewValue;
                    var locals = {};

                    // The validity may be set to false via $parsers (see above) if
                    // the model is restricted to selected values. If the model
                    // is set manually it is considered to be valid.
                    if (!isEditable) {
                        modelCtrl.$setValidity('editable', true);
                    }

                    if (inputFormatter) {
                        locals.$model = modelValue;
                        return inputFormatter(originalScope, locals);
                    }

                    //it might happen that we don't have enough info to properly render input value
                    //we need to check for this situation and simply return model value if we can't apply custom formatting
                    locals[parserResult.itemName] = modelValue;
                    candidateViewValue = parserResult.viewMapper(originalScope, locals);
                    locals[parserResult.itemName] = undefined;
                    emptyViewValue = parserResult.viewMapper(originalScope, locals);

                    return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
                });
            };

            function extractOptions(ngModelCtrl) {
                var ngModelOptions;

                if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
                    // guarantee a value
                    ngModelOptions = ngModelCtrl.$options || {};

                    // mimic 1.6+ api
                    ngModelOptions.getOption = function (key) {
                        return ngModelOptions[key];
                    };
                } else { // in angular >=1.6 $options is always present
                    ngModelOptions = ngModelCtrl.$options;
                }

                return ngModelOptions;
            }
        }])

    .directive('uibTypeahead', function () {
        return {
            controller: 'UibTypeaheadController',
            require: ['ngModel', 'uibTypeahead'],
            link: function (originalScope, element, attrs, ctrls) {
                ctrls[1].init(ctrls[0]);
            }
        };
    })

    .directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
        return {
            scope: {
                matches: '=',
                query: '=',
                active: '=',
                position: '&',
                moveInProgress: '=',
                select: '&',
                assignIsOpen: '&',
                debounce: '&'
            },
            replace: true,
            templateUrl: function (element, attrs) {
                return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
            },
            link: function (scope, element, attrs) {
                scope.templateUrl = attrs.templateUrl;

                scope.isOpen = function () {
                    var isDropdownOpen = scope.matches.length > 0;
                    scope.assignIsOpen({ isOpen: isDropdownOpen });
                    return isDropdownOpen;
                };

                scope.isActive = function (matchIdx) {
                    return scope.active === matchIdx;
                };

                scope.selectActive = function (matchIdx) {
                    scope.active = matchIdx;
                };

                scope.selectMatch = function (activeIdx, evt) {
                    var debounce = scope.debounce();
                    if (angular.isNumber(debounce) || angular.isObject(debounce)) {
                        $$debounce(function () {
                            scope.select({ activeIdx: activeIdx, evt: evt });
                        }, angular.isNumber(debounce) ? debounce : debounce['default']);
                    } else {
                        scope.select({ activeIdx: activeIdx, evt: evt });
                    }
                };
            }
        };
    }])

    .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
        return {
            scope: {
                index: '=',
                match: '=',
                query: '='
            },
            link: function (scope, element, attrs) {
                var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
                $templateRequest(tplUrl).then(function (tplContent) {
                    var tplEl = angular.element(tplContent.trim());
                    element.replaceWith(tplEl);
                    $compile(tplEl)(scope);
                });
            }
        };
    }])

    .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
        var isSanitizePresent;
        isSanitizePresent = $injector.has('$sanitize');

        function escapeRegexp(queryToEscape) {
            // Regex: capture the whole query string and replace it with the string that will be used to match
            // the results, for example if the capture is "a" the result will be \a
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        function containsHtml(matchItem) {
            return /<.*>/g.test(matchItem);
        }

        return function (matchItem, query) {
            if (!isSanitizePresent && containsHtml(matchItem)) {
                $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
            }
            matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
            if (!isSanitizePresent) {
                matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
            }
            return matchItem;
        };
    }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion-group.html",
        "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
        "  <h4 class=\"panel-title\">\n" +
        "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
        "  </h4>\n" +
        "</div>\n" +
        "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
        "  <div class=\"panel-body\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/accordion/accordion.html",
        "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/alert/alert.html",
        "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
        "  <span aria-hidden=\"true\">&times;</span>\n" +
        "  <span class=\"sr-only\">Close</span>\n" +
        "</button>\n" +
        "<div ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/carousel.html",
        "<div class=\"carousel-inner\" ng-transclude></div>\n" +
        "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
        "  <span class=\"sr-only\">previous</span>\n" +
        "</a>\n" +
        "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
        "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
        "  <span class=\"sr-only\">next</span>\n" +
        "</a>\n" +
        "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
        "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
        "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
        "  </li>\n" +
        "</ol>\n" +
        "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/carousel/slide.html",
        "<div class=\"text-center\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/datepicker.html",
        "<div ng-switch=\"datepickerMode\">\n" +
        "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
        "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
        "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/day.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
        "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/month.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepicker/year.html",
        "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
        "  <thead>\n" +
        "    <tr>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
        "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
        "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
        "    </tr>\n" +
        "  </thead>\n" +
        "  <tbody>\n" +
        "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
        "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
        "        id=\"{{::dt.uid}}\"\n" +
        "        ng-class=\"::dt.customClass\">\n" +
        "        <button type=\"button\" class=\"btn btn-default\"\n" +
        "          uib-is-class=\"\n" +
        "            'btn-info' for selectedDt,\n" +
        "            'active' for activeDt\n" +
        "            on dt\"\n" +
        "          ng-click=\"select(dt.date)\"\n" +
        "          ng-disabled=\"::dt.disabled\"\n" +
        "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
        "      </td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/datepickerPopup/popup.html",
        "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
        "  <li ng-transclude></li>\n" +
        "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
        "    <span class=\"btn-group pull-left\">\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
        "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
        "    </span>\n" +
        "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
        "  </li>\n" +
        "</ul>\n" +
        "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/modal/window.html",
        "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
        "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pager/pager.html",
        "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/pagination/pagination.html",
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
        "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
        "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
        "<div class=\"tooltip-arrow\"></div>\n" +
        "<div class=\"tooltip-inner\"\n" +
        "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-html.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover-template.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\"\n" +
        "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
        "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/popover/popover.html",
        "<div class=\"arrow\"></div>\n" +
        "\n" +
        "<div class=\"popover-inner\">\n" +
        "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
        "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/bar.html",
        "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progress.html",
        "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/progressbar/progressbar.html",
        "<div class=\"progress\">\n" +
        "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/rating/rating.html",
        "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
        "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
        "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
        "</span>\n" +
        "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tab.html",
        "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
        "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
        "</li>\n" +
        "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/tabs/tabset.html",
        "<div>\n" +
        "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
        "  <div class=\"tab-content\">\n" +
        "    <div class=\"tab-pane\"\n" +
        "         ng-repeat=\"tab in tabset.tabs\"\n" +
        "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
        "         uib-tab-content-transclude=\"tab\">\n" +
        "    </div>\n" +
        "  </div>\n" +
        "</div>\n" +
        "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/timepicker/timepicker.html",
        "<table class=\"uib-timepicker\">\n" +
        "  <tbody>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "    <tr>\n" +
        "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
        "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
        "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
        "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
        "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
        "      </td>\n" +
        "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
        "    </tr>\n" +
        "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
        "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td>&nbsp;</td>\n" +
        "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
        "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
        "      <td ng-show=\"showMeridian\"></td>\n" +
        "    </tr>\n" +
        "  </tbody>\n" +
        "</table>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-match.html",
        "<a href\n" +
        "   tabindex=\"-1\"\n" +
        "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
        "   ng-attr-title=\"{{match.label}}\"></a>\n" +
        "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("uib/template/typeahead/typeahead-popup.html",
        "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
        "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
        "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
        "    </li>\n" +
        "</ul>\n" +
        "");
}]);
angular.module('ui.bootstrap.carousel').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function () { !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

(function () {
    'use strict';

    angular
        .module('app.operations.scheduler', ['ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.scheduler', {
            url: '/scheduler',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/scheduler/scheduler.html',
                    controller: 'operationsProjectController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/scheduler');
    }

})();
(function () {

  'use strict';
  angular
    .module('app.operations.scheduler')
    .directive('starRating', function () {
      return {
        scope: {
          rating: '=',
          maxRating: '@',
          readOnly: '@',
          click: "&",
          mouseHover: "&",
          mouseLeave: "&"
        },
        restrict: 'EA',
        template:
          "<div style='display: inline-block; margin: 0px; padding: 0px; cursor:pointer;' ng-repeat='idx in maxRatings track by $index'> \
                  <img ng-src='{{((hoverValue + _rating) <= $index) && \"https://www.codeproject.com/script/ratings/images/star-empty-lg.png\" || \"https://www.codeproject.com/script/ratings/images/star-fill-lg.png\"}}' \
                  ng-Click='isolatedClick($index + 1)' \
                  ng-mouseenter='isolatedMouseHover($index + 1)' \
                  ng-mouseleave='isolatedMouseLeave($index + 1)'></img> \
          </div>",
        compile: function (element, attrs) {
          if (!attrs.maxRating || (Number(attrs.maxRating) <= 0)) {
            attrs.maxRating = '5';
          };
        },
        controller: function ($scope, $element, $attrs) {
          $scope.maxRatings = [];
          for (var i = 1; i <= $scope.maxRating; i++) {
            $scope.maxRatings.push({});
          };
          $scope._rating = $scope.rating;
          $scope.isolatedClick = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope.rating = $scope._rating = param;
            $scope.hoverValue = 0;
            $scope.click({
              param: param
            });
          };
          $scope.isolatedMouseHover = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = 0;
            $scope.hoverValue = param;
            $scope.mouseHover({
              param: param
            });
          };
          $scope.isolatedMouseLeave = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = $scope.rating;
            $scope.hoverValue = 0;
            $scope.mouseLeave({
              param: param
            });
          };
        }
      };
    })
    .directive('ngMouseWheelUp', function () {
      return function ($scope, element, attrs) {
        element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

          // cross-browser wheel delta
          var event = window.event || event; // old IE support
          var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

          if (delta > 0) {
            $scope.$apply(function () {
              $scope.$eval(attrs.ngMouseWheelUp);
            });

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if (event.preventDefault) event.preventDefault();
          }
        });
      };
    })
    .directive('ngMouseWheelDown', function () {
      return function ($scope, element, attrs) {
        element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

          // cross-browser wheel delta
          var event = window.event || event; // old IE support
          var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

          if (delta < 0) {
            $scope.$apply(function () {
              $scope.$eval(attrs.ngMouseWheelDown);
            });

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if (event.preventDefault) event.preventDefault();
          }
        });
      };
    })
    .controller('operationsProjectController', operationsProjectController);
  /** @ngInject */
  function operationsProjectController($scope, $rootScope, socket, $interval, $mdSidenav, $filter, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document, $window, NgMap, $locale, Upload, DataSyncService) {

    document.getElementsByTagName('title')[0].text = "Operations-Scheduler"
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("Scheduler")) {   // do nothing 
    }
    else { window.location = 'NoAccess'; }
    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log('markers', map.markers);
      console.log('shapes', map.shapes);
    });
    $scope.click1 = function (param) {
      console.log('Click(' + param + ')');
    };
    $scope.CustomeScheduler = false
    var vm = this

    $scope.vm.AStartTime = new Date()
    $scope.vm.AEndTime = new Date()

    var today = new Date()
    $scope.uFrom = new Date(today);
    $scope.uTo = new Date(today);

    $scope.Exportdata = function () {
      var promises = [];
      var data = [];
      if ($scope.vm.SelectedTab == 'In-Progress') {
        data = $scope.MobileInProgressdatas;
      }
      else if ($scope.vm.SelectedTab == 'Outstanding') {
        data = $scope.InProgressdatas;
      }
      else if ($scope.vm.SelectedTab == 'Completed') {
        data = $scope.Completeddatas;
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        data = $scope.PendingApprovaldatas;
      }
      else if ($scope.vm.SelectedTab == 'Ad-hoc') {
        data = $scope.AdhocJobsdatas;
      }
      else if ($scope.vm.SelectedTab == 'Cancelled') {
        data = $scope.Cancelleddatas;
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        data = $scope.PendingScheduledatas;
      }
      else {
        data = $scope.YettoStartdatas;
      }
      var array = [];
      if ($scope.vm.SelectedTab == 'Completed') {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
            data: { _id: value._id },
          }).then(function (tabletschedulerrecord) {
            try {
              var item = tabletschedulerrecord.data.data[0];
              var uitem = [];
              uitem = $scope.Userdatas.filter(function (uitem) {
                return uitem.UserID == item.CreatedBy
              })[0];
              value.InProgressedBy = uitem.EmployeeID;
            }
            catch (e) { }
            try {
              var ContractNo = "";
              if (value.Contracterdetails.length > 0) {
                ContractNo = value.Contracterdetails[0].ContractReferenceNo;
              }
              var CustomerName = "";
              if (value.customerdetails.length > 0) {
                CustomerName = value.customerdetails[0].CompanyName;
              } else { CustomerName = value.AdhocCustomerName; }
              array.push({
                ServiceID: value.ServiceID,
                CustomerName: CustomerName,
                Address: value.customerServicedetails[0].sBLK + ',' + value.customerServicedetails[0].sStreetName,
                ContactPerson: value.ContactPerson,
                SalesOrderNo: value.JobOrdersdetails[0].SalesOrderNo,
                ContractNo: ContractNo,
                TeamName: value.teamdetails[0].TeamName,
                TeamLead: value.teamdetails[0].TeamLead,
                TeamMembers: value.teamdetails[0].TeamMembers,
                PestType: value.PestType,
                Frequency: value.Frequency,
                Status: value.Status,
                Day: $filter('date')(value.Startsat, 'EEEE'),
                ServiceDate: $filter('date')(value.Startsat, 'dd/MM/yyyy'),
                StartTime: $filter('date')(value.Startsat, 'hh:mm a'),
                EndTime: $filter('date')(value.Endsat, 'hh:mm a'),
                ActualStartTime: $filter('date')(item.Startsat, 'hh:mm a'),
                ActualEndTime: $filter('date')(item.Endsat, 'hh:mm a'),
                JobPerformedBy: value.InProgressedBy,
                CreatedBy: value.CreatedBy,
                CreatedDate: $filter('date')(value.CreateDate, 'dd/MM/yyyy'),
              })
            }
            catch (e) { }
            deferred.resolve(data);
          });
          promises.push(deferred.promise);
        });
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          try {
            array.push({
              CustomerName: value.customerdetails[0].CompanyName,
              SalesOrderNo: value.SalesOrderNo,
              PestType: value.PestType,
              DateTimeofTreatment: value.DateTimeofTreatment,
              EstimatedHoursRequired: value.EstimatedHoursRequired,
              Urgent: value.Urgent = true ? "Yes" : "No",
              CreatedBy: value.CreatedBy,
              CreatedDate: $filter('date')(value.CreatedDate, 'dd/MM/yyyy'),
            })
          }
          catch (e) {

          }
          deferred.resolve(data);
          promises.push(deferred.promise);
        });
      }
      else {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          try {
            var ContractNo = "";
            if (value.Contracterdetails.length > 0) {
              ContractNo = value.Contracterdetails[0].ContractReferenceNo;
            }
            var CustomerName = "";
            if (value.customerdetails.length > 0) {
              CustomerName = value.customerdetails[0].CompanyName;
            } else { CustomerName = value.AdhocCustomerName; }
            array.push({
              ServiceID: value.ServiceID,
              CustomerName: CustomerName,
              Address: value.customerServicedetails[0].sBLK + ',' + value.customerServicedetails[0].sStreetName,
              ContactPerson: value.ContactPerson,
              SalesOrderNo: value.JobOrdersdetails[0].SalesOrderNo,
              ContractNo: ContractNo,
              TeamName: value.teamdetails[0].TeamName,
              TeamLead: value.teamdetails[0].TeamLead,
              TeamMembers: value.teamdetails[0].TeamMembers,
              PestType: value.PestType,
              Frequency: value.Frequency,
              Status: value.Status,
              Day: $filter('date')(value.Startsat, 'EEEE'),
              ServiceDate: $filter('date')(value.Startsat, 'dd/MM/yyyy'),
              StartTime: $filter('date')(value.Startsat, 'hh:mm a'),
              EndTime: $filter('date')(value.Startsat, 'hh:mm a'),
              CreatedBy: value.CreatedBy,
              CreatedDate: $filter('date')(value.CreateDate, 'dd/MM/yyyy'),
            })
          }
          catch (e) {

          }
          deferred.resolve(data);
          promises.push(deferred.promise);
        });
      }
      $q.all(promises).then(
        function (results) {
          alasql('SELECT * INTO XLSX("Schedulerdatas.xlsx",{headers:true}) FROM ?', [array]);
        },
        function (response) {
        }
      );
    }
    $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

    $scope.vm.cdate = new Date().setHours(23, 59, 59, 999);
    $scope.pesttypeGrid = true;
    $scope.exportbtn = true;
    $scope.shedulerform = false;
    $scope.addbtn = true;
    $scope.viewbtn = false;
    $scope.Search = true;
    $scope.schedulartab = true;
    $scope.SelectedCustomerID = undefined;
    $scope.vm.filtercustomer = null;
    $scope.TRCCdiv = false;
    $scope.vm.YTSPreviewSpinner = false;
    $scope.CompletedSelectedIds = [];
    $scope.CheckCompletedAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.vm.YTSPreviewSpinner = true;
        angular.forEach($scope.Completeddatas, function (value) {
          var i = $scope.CompletedSelectedIds.findIndex(function (x) {
            return x.ID == value._id
          });
          if (i <= -1) {
            $scope.CompletedSelectedIds.push({
              ID: value._id,
              ServiceID: value.ServiceID,
            })
          }
        })
        $scope.CSelec = { value: true }
        $scope.vm.YTSPreviewSpinner = false;
        $scope.TRCCdiv = true;
      }
      if (IsTicked == false) {
        $scope.TRCCdiv = false;
        $scope.CompletedSelectedIds = [];
        $scope.CSelec = { value: false }
      }
    }
    $scope.CompletedCheck = function (SI, Ids, ServiceID) {
      if (SI == true) {
        $scope.vm.YTSPreviewSpinner = true;
        var i = $scope.CompletedSelectedIds.findIndex(function (x) {
          return x.ID == Ids
        });
        if (i <= -1) {
          $scope.CompletedSelectedIds.push({
            ID: Ids,
            ServiceID: ServiceID,
          })
        }
        $scope.TRCCdiv = true;
        $scope.vm.YTSPreviewSpinner = false;
      }
      if (SI == false) {
        $scope.TRCCdiv = false;
        $scope.vm.YTSPreviewSpinner = true;
        var index = $scope.CompletedSelectedIds.findIndex(function (x) {
          return x.ID == Ids
        });
        if (index > -1) {
          $scope.CompletedSelectedIds.splice(index, 1);
        }
        $scope.vm.YTSPreviewSpinner = false;
      }
      if ($scope.CompletedSelectedIds.length > 0) {
        $scope.TRCCdiv = true;
      }
    }
    $scope.ConfirmEmailforCompletedJob = function (e) {
      $scope.vm.Confirmation = true;
      $scope.vm.EmailDetails = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmEmailforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.ConfirmDownloadforCompletedJob = function (e) {
      $scope.vm.CurrentDateTimeFolder = new Date();
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmDownloadforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
      });
    }
    $scope.ConfirmVerifyforCompletedJob = function (e) {
      $scope.vm.ShowVerifySpinner = false;
      $scope.DataforCompletedService = [];
      var getGroupID = 0;
      angular.forEach($scope.CompletedSelectedIds, function (value1) {
        try {
          var item = $scope.Completeddatas.filter(function (item) {
            return item._id === value1.ID;
          })[0];
        } catch (err) { }
        if (value1.ID === item._id) {
          var PestType = "";
          var SOR = "";
          if (item.SOR != "" && item.SOR != null && item.SOR != undefined) {
            SOR = item.SOR;
            PestType = item.PestType + " (SOR: " + SOR + ")";
          }
          else {
            PestType = item.PestType;
          }


          var CustomerWoNo = "";
          if (item.CustomerWoNo != "" && item.CustomerWoNo != null && item.CustomerWoNo != undefined) {
            CustomerWoNo = item.CustomerWoNo;
          }
          var SORRate = "";
          if (item.SORRate != "" && item.SORRate != null && item.SORRate != undefined) {
            SORRate = parseFloat(item.SORRate);
          }
          var GroupID = "";
          if (item.GroupID != "" && item.GroupID != null && item.GroupID != undefined) {
            GroupID = item.GroupID;
          }

          var GroupName = "";
          if (item.customerServicedetails.length > 0) {
            if (item.customerServicedetails[0].GroupName != "" && item.customerServicedetails[0].GroupName != null && item.customerServicedetails[0].GroupName != undefined) {
              GroupName = item.customerServicedetails[0].GroupName;
            }
          }
          $scope.DataforCompletedService.push({
            ID: item._id,
            ServiceID: item.ServiceID,
            PestType: PestType,
            //SOR: SOR,
            CustomerWoNo: CustomerWoNo,
            SORRate: SORRate,
            GroupID: GroupID,
            GroupName: GroupName,
          })
        }
      })
      $scope.VerifydataGridOptions = {
        dataSource: $scope.DataforCompletedService,
        keyExpr: "ID",
        showColumnLines: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        showBorders: true,
        paging: {
          enabled: true,
          pageSize: 5
        },
        editing: {
          mode: "cell",
          allowUpdating: true
        },
        allowColumnResizing: true,
        columns: [
          {
            caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
              cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
            }
          },
          {
            dataField: "ServiceID",
            caption: "Service ID",
            allowEditing: false,
          },
          {
            dataField: "PestType",
            caption: "Details",
            allowEditing: false,
          },
          {
            dataField: "GroupID",
            caption: "Group ID",
            allowEditing: false,
            width: 100
          },
          {
            dataField: "GroupName",
            caption: "Group Name",
            allowEditing: false,
          },
          {
            dataField: "CustomerWoNo",
            caption: "Customer Wo No",
            dataType: "text",
            allowEditing: true,
          },
          {
            dataField: "SORRate",
            caption: "SOR Rate",
            dataType: "number",
            allowEditing: true,
            width: 100
          }
        ],
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [5, 10, 20, 50, 100],
          showInfo: true
        },
        onCellPrepared: function (e) {
          if (e.rowType === "header" &&
            (e.column.dataField === "CustomerWoNo" ||
              e.column.dataField === "SORRate"))
            e.cellElement.css({ "backgroundColor": "#90EE90" });
        },
        onRowUpdating: function (e) {
          var getNewData = e.newData;
          var getSchID = e.key;
          var UpCustomerWoNo = "";
          var UpSORRate = 0;
          if (getNewData.CustomerWoNo != "" && getNewData.CustomerWoNo != null && getNewData.CustomerWoNo != undefined) {
            UpCustomerWoNo = getNewData.CustomerWoNo
          }
          if (getNewData.SORRate != "" && getNewData.SORRate != null && getNewData.SORRate != undefined) {
            UpSORRate = getNewData.SORRate
          }
          angular.forEach($scope.DataforCompletedService, function (value) {
            if (value.ID == getSchID) {
              if (UpCustomerWoNo != "" && UpSORRate != 0) {
                value.CustomerWoNo = UpCustomerWoNo;
                value.SORRate = UpSORRate;
              }
              else if (UpCustomerWoNo != "" && UpSORRate == 0) {
                value.CustomerWoNo = UpCustomerWoNo;
              }
              else if (UpCustomerWoNo == "" && UpSORRate != 0) {
                value.SORRate = UpSORRate;
              }
            }
          });
        },
      };
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/VerifyDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.getConfirmationtoVerifyforSelectedCompletedJob = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmVerifyforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.ConfirmServiceReportApprove = function (e) {
      $scope.vm.ServiceReportApproveSpinner = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmServiceReportApprove.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.SendEmailforSelectedCompletedJob = function () {
      $scope.ShowCompletedSelectedIds = [];
      angular.forEach($scope.CompletedSelectedIds, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          $scope.ShowCompletedSelectedIds.push({
            ID: value.ID,
            ServiceID: value.ServiceID,
            EmailStatus: "In-Progress",
            EmailSentDate: "",
            EmailSentTo: "",
            Remarks: "",
          })
        }
      });

      $scope.vm.Confirmation = false;
      $scope.vm.EmailDetails = true;
      $scope.vm.OverallEmailStatus = false;
      $scope.vm.OverallEmailStatusInitialize = false;
      var Ecount = 0;
      var promise = $q.all([]);
      if (Ecount == 0) {
        $scope.vm.EMax = $scope.CompletedSelectedIds.length;
        $scope.vm.EValue = 0;
        $scope.vm.ECount = 0;
        $scope.vm.OverallEmailStatus = true;
      }

      angular.forEach($scope.CompletedSelectedIds, function (value, index) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/SendEmailtoCompletedService",
                data: { _id: value.ID, email_id: value.EmailId },
              });
              response.then(function (GList) {
                Ecount = Ecount + 1;
                var getEValue = (Ecount / $scope.vm.EMax) * 100;
                $scope.vm.EValue = parseInt(getEValue);
                $scope.vm.ECount = Ecount;
                var Uresponse = $http({
                  url: $rootScope.WebURL + "/scheduler/uniqueschedulerByID",
                  method: "POST",
                  data: { Client_Id: $rootScope.Client_Id, _id: value.ID },
                });
                Uresponse.then(function (GList) {
                  $scope.getCurrentSchedulerData = GList.data.data[0];

                  if ($scope.getCurrentSchedulerData.EmailSent == true) {
                    var EmailStatusMessage = "Sent";
                    var EmailSentDate = new Date($scope.getCurrentSchedulerData.EmailSentDate);
                    var EmailSentTo = $scope.getCurrentSchedulerData.EmailSentTo;
                    var EmailRemarks = "Email Sent Successfully";
                  }
                  else if ($scope.getCurrentSchedulerData.EmailSent == false) {
                    var EmailStatusMessage = "Failed";
                    var EmailSentDate = "";
                    var EmailSentTo = "";
                    var EmailRemarks = $scope.getCurrentSchedulerData.EmailSentError;
                  }

                  $scope.ShowCompletedSelectedIds[index]["EmailStatus"] = EmailStatusMessage;
                  $scope.ShowCompletedSelectedIds[index]["EmailSentDate"] = EmailSentDate;
                  $scope.ShowCompletedSelectedIds[index]["EmailSentTo"] = EmailSentTo;
                  $scope.ShowCompletedSelectedIds[index]["Remarks"] = EmailRemarks;
                });
                if (Ecount === $scope.CompletedSelectedIds.length) {
                  $scope.vm.OverallEmailStatusInitialize = false;
                  $scope.CompletedSelectedIds = [];
                  $scope.getAllCompletedID = "";
                  $scope.CSelec = { value: false };
                  $scope.AllCSelec = { value: false };
                  $scope.TRCCdiv = false;
                  $scope.vm.OverallEmailStatus = false;
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    angular.forEach(GList.data.data, function (value) {
                      try {
                        var PestCode = '';
                        var pest = value.PestType.split(',')
                        angular.forEach(pest, function (ele) {
                          var pt = $scope.Pesttypedatas.filter(function (pt) {
                            return ele == pt.PestName;
                          })[0];
                          PestCode = PestCode + pt.Pestcode + ',';
                        })
                        PestCode = PestCode.substring(0, PestCode.length - 1);
                        value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
                        // var PestArray = []
                        // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
                        //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
                      } catch (e) {
                      }
                    })
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;
                    $scope.ClearGrid();
                    NewGetScheduler("Completed")
                  });
                }
              }, function () {
                //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 8000);
          });
        }
      });
    }
    $scope.DownloadforSelectedCompletedJob = function (DTFolder, e) {
      $scope.DTFolderName = DTFolder;
      var getDTFYear = new Date($scope.DTFolderName).getFullYear();
      var getDTFMonth = new Date($scope.DTFolderName).getMonth() + 1;
      if (getDTFMonth < 10) {
        getDTFMonth = "0" + getDTFMonth.toString();
      }
      else {
        getDTFMonth = getDTFMonth;
      }
      var getDTFDate = new Date($scope.DTFolderName).getDate();
      if (getDTFDate < 10) {
        getDTFDate = "0" + getDTFDate.toString();
      }
      else {
        getDTFDate = getDTFDate;
      }
      var getDTFHour = new Date($scope.DTFolderName).getHours();
      if (getDTFHour < 10) {
        getDTFHour = "0" + getDTFHour.toString();
      }
      else {
        getDTFHour = getDTFHour;
      }
      var getDTFMins = new Date($scope.DTFolderName).getMinutes();
      if (getDTFMins < 10) {
        getDTFMins = "0" + getDTFMins.toString();
      }
      else {
        getDTFMins = getDTFMins;
      }
      var getDTFSecs = new Date($scope.DTFolderName).getSeconds();
      if (getDTFSecs < 10) {
        getDTFSecs = "0" + getDTFSecs.toString();
      }
      else {
        getDTFSecs = getDTFSecs;
      }
      var FolderName = getDTFYear.toString() + getDTFMonth.toString() + getDTFDate.toString() + getDTFHour.toString() + getDTFMins.toString() + getDTFSecs.toString();
      var count = 0;
      var promise = $q.all([]);
      if (count == 0) {
        $mdDialog.cancel();
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/operations/scheduler/ShowDownloadedHistoryDetails.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          controller: function operationsProjectController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
      }
      var TotalReports = $scope.CompletedSelectedIds.length;
      var ReportFolderName = FolderName + ".zip";
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/add",
        data: {
          Client_Id: $rootScope.Client_Id,
          RequestedBy: $scope.RequestedBy,
          RequestedDate: new Date($scope.DTFolderName),
          DownloadedDate: new Date(),
          TotalRecords: TotalReports,
          CompletedRecords: 0,
          DownloadedLink: ReportFolderName,
          CreatedBy: $rootScope.createdby,
        },
      }).then(function (SRPGList) {
        $scope.getReportID = SRPGList.data.data.id;
        RefreshSchedulerReportPathGrid();
        angular.forEach($scope.CompletedSelectedIds, function (value) {
          if (value.ID != "" && value.ID != null && value.ID != undefined) {
            promise = promise.then(function () {
              return $timeout(function () {
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/scheduler/DownloadCompletedServiceReport",
                  data: {
                    _id: value.ID,
                    ServiceID: value.ServiceID,
                    FolderName: FolderName,
                  },
                }).then(function (GList) {
                  count = count + 1;
                  //$scope.Schedulerreportpathdatas[0]["CompletedRecords"] = count;
                  var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/schedulerreportpath/updateCompleted",
                    data: {
                      _id: $scope.getReportID,
                      CompletedRecords: count,
                      UpdatedBy: $rootScope.createdby,
                    },
                  });
                  response.then(function (GList) {
                    $scope.Schedulerreportpathdatas[0] = GList.data.data;
                  });

                  if (count === $scope.CompletedSelectedIds.length) {
                    //RefreshSchedulerReportPathGrid();
                    $scope.ClearGrid();
                    $scope.CompletedSelectedIds = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $mdToast.show($mdToast.simple().textContent('Successfully Downloaded!').position('top center'));
                  }
                }, function () {
                  //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
              }, 6000);
            });
          }
        });
      });
    }
    $scope.ShowDownloadedHistory = function (e) {
      $scope.vm.DownSpinner = true;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowDownloadedHistoryDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
        $scope.vm.DownSpinner = false;
      });
    }
    $scope.RefreshReportPathHistory = function () {
      $scope.vm.DownSpinner = true;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
        $scope.vm.DownSpinner = false;
      });
    }

    $scope.VerifyforSelectedCompletedJob = function () {
      var count = 0;
      var promise = $q.all([]);
      if (count == 0) {
        $mdDialog.cancel();
        $scope.vm.ShowVerifySpinner = true;
      }
      angular.forEach($scope.DataforCompletedService, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/VerifyCompletedService",
                data: {
                  _id: value.ID,
                  CustomerWoNo: value.CustomerWoNo,
                  SORRate: value.SORRate,
                  GroupName: value.GroupName,
                  UpdatedBy: $rootScope.createdby,
                },
              });
              response.then(function (GList) {
                count = count + 1;
                if (count === $scope.DataforCompletedService.length) {
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;
                    $scope.CompletedSelectedIds = [];
                    $scope.DataforCompletedService = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $scope.vm.ShowVerifySpinner = false;
                    $scope.ClearGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Verified Successfully!').position('top center'));
                  });
                }
              }, function () {
                //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 300);
          });
        }
      });
    }
    $scope.ApproveServiceReportforSelectedCompletedJob = function () {
      $scope.vm.ServiceReportApproveSpinner = true;
      var Ecount = 0;
      var promise = $q.all([]);
      angular.forEach($scope.CompletedSelectedIds, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/updateServiceReportStatus",
                data: { _id: value.ID, UpdatedBy: $rootScope.createdby },
              });
              response.then(function (GList) {
                Ecount = Ecount + 1;
                if (Ecount === $scope.CompletedSelectedIds.length) {
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    angular.forEach(GList.data.data, function (value) {
                      try {
                        var PestCode = '';
                        var pest = value.PestType.split(',')
                        angular.forEach(pest, function (ele) {
                          var pt = $scope.Pesttypedatas.filter(function (pt) {
                            return ele == pt.PestName;
                          })[0];
                          PestCode = PestCode + pt.Pestcode + ',';
                        })
                        PestCode = PestCode.substring(0, PestCode.length - 1);
                        value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
                        // var PestArray = []
                        // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
                        //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
                      } catch (e) {
                      }
                    })
                    $scope.AllScheduleDatas = GList.data.data;
                    $scope.Uniqueschedulerdatas = GList.data.data;
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;

                    var getPending = [];
                    try {
                      getPending = resArr.filter(function (pending) {
                        return pending.ServiceReportStatus == "Pending";
                      });
                    } catch (e) { }
                    $scope.PendingApprovaldatas = getPending;

                    $scope.CompletedSelectedIds = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $scope.vm.ServiceReportApproveSpinner = false;
                    $scope.ClearGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Service Report Approved Successfully !').position('top center'));
                  });
                }
              }, function () { });
            }, 100);
          });
        }
      });
    }

    $scope.CloseVerification = function () {
      $scope.CompletedSelectedIds = [];
      $scope.DataforCompletedService = [];
      $scope.getAllCompletedID = "";
      $scope.CSelec = { value: false };
      $scope.AllCSelec = { value: false };
      $scope.TRCCdiv = false;
      $scope.ClearGrid();
      $mdDialog.cancel();
    };
    $scope.getVerificationRowColour = function (item) {
      if (item.Verified === true) {
        return true;
      }
      else {
        return false;
      }
    }
    $scope.ShowEmailedHistory = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowEmailedHistoryDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.getRowColourforSentBulkEmail = function (item) {
      if (item.EmailStatus === "Failed") {
        return true;
      }
      else {
        return false;
      }
    }
    $scope.getRowColourforSentEmail = function (item) {
      if (item.EmailSent === false) {
        return true;
      }
      else {
        return false;
      }
    }


    RefreshUnit();


    //RefreshGroupID();
    $scope.AllSASelec = { value: false };
    $scope.SASelec = { value: false };
    $scope.svAll = { value: false };
    $scope.ServiceAddressarray = [];
    $scope.CheckAllServiceAddress = function (IsTicked) {
      if (IsTicked == true) {
        angular.forEach($scope.CustomerServicedatas, function (value) {
          if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined && value.Type == 'Service') {
            if ($scope.ServiceAddressarray.indexOf(value) == -1) { $scope.ServiceAddressarray.push(value) }
          }
        })
        $scope.AllSASelec = { value: true };
        $scope.SASelec = { value: true };
      }
      else {
        $scope.ServiceAddressarray = [];
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
      }
    }
    $scope.CheckServiceAddress = function (CheckSA, SIds) {
      if (CheckSA == true) {
        if ($scope.ServiceAddressarray.indexOf(SIds) == -1) {
          $scope.ServiceAddressarray.push(SIds)
        }
      }
      else if (CheckSA == false) {
        var index = $scope.ServiceAddressarray.indexOf(SIds);
        if (index > -1) {
          $scope.ServiceAddressarray.splice(index, 1);
        }
      }
      if ($scope.ServiceAddressarray.length <= 0) {
        $scope.AllSASelec = { value: false };
      }
    }
    $scope.mapDate = new Date();
    $scope.SelectedIds = [];
    $scope.CheckAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.TRCdiv = true;
        angular.forEach($scope.YettoStartdatas, function (value) {
          if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
        })
        $scope.Selec = { value: true }
      }
      if (IsTicked == false) {
        $scope.TRCdiv = false;
        $scope.SelectedIds = [];
        $scope.Selec = { value: false }
      }
    }
    $scope.Check = function (TrF, Ids) {
      if (TrF == true) {
        $scope.TRCdiv = true;
        if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
      }
      if (TrF == false) {
        $scope.TRCdiv = false;
        var index = $scope.SelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.SelectedIds.splice(index, 1);
        }
      }
      if ($scope.SelectedIds.length > 0) {
        $scope.TRCdiv = true;
      }
    }
    $scope.TRCdiv = false;
    $scope.Selec = { value: false }
    $scope.Update = false;
    $scope.shedulerform = true;
    $scope.pesttypeGrid = false;
    $scope.Cancel = { value: false };
    $scope.Reschedule = { value: false };
    $scope.InfestationLevel = [
      { Name: 'High' }, { Name: 'Medium' }, { Name: 'Low' }, { Name: 'Nil' }
    ]
    $scope.RescheduleSelected = function (e) {
      $scope.vm.Title = 'Reschedule';
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.ResheduleSSTime = null;
      $scope.vm.ResheduleSETime = null;
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.RescheduleSelectedbyTime = function (e) {
      $scope.vm.Title = 'Reschedule by Time';
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.ResheduleSSTime = null;
      $scope.vm.ResheduleSETime = null;
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.CancelSelected = function (e) {
      $scope.vm.Title = 'Cancel';
      $scope.vm.CancelSRemarks = null;
      $scope.vm.CancelSpinner = false;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.SubmitRescheduleSelected = function () {
      $scope.vm.RescheduleSpinner = true;
      var Rcount = 0;
      var promise = $q.all([]);

      var dd = $scope.vm.ResheduleSFrom;
      var hh = $scope.vm.ResheduleSSTime;
      var mm = new Date(hh.setDate(new Date(dd).getDate()));
      var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
      $scope.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));

      var edd = $scope.vm.ResheduleSFrom;
      var ehh = $scope.vm.ResheduleSETime;
      var emm = new Date(ehh.setDate(new Date(edd).getDate()));
      var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
      $scope.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));

      var currentDate = new Date($scope.schusdateTime);
      var enddate = new Date($scope.schuedateTime);
      $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
      $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
      angular.forEach($scope.SelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.YettoStartdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: value,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleFromDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var item = ($scope.Uniqueschedulerdatas || $scope.YettoStartdatas).filter(function (item) {
                    return item._id == value;
                  })[0];
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: value,
                      ServiceID: item.ServiceID,
                      CustomerName: item.customerdetails[0].CompanyName,
                      Status: item.Status,
                      PreviousStartsat: new Date(item.Startsat),
                      PreviousEndsat: new Date(item.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: item.PestType1,
                      TeamName: item.TeamName,
                      TeamLead: item.TeamMembersName,
                      TeamMember: item.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: "Yet to Start",
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  }
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.SelectedIds.length) {
                  $scope.SelectedIds = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.submitrescheduled = function () {
      $scope.vm.RescheduleSpinner = true;
      var Rcount = 0;
      var promise = $q.all([]);
      var currentDate = new Date()
      var enddate = new Date()
      angular.forEach($scope.Rescheduledata, function (item, index) {
        if (item != "" && item != null && item != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.ServiceOn = item.ServiceOn
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
                currentDate = CombineDateAndTime(new Date(item.Startsat), $scope.vm.ResheduleSSTime)
                enddate = CombineDateAndTime(new Date(item.Endsat), $scope.vm.ResheduleSETime)
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: item._id,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  RescheduledDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var iitem = ($scope.Uniqueschedulerdatas || $scope.Rescheduledata).filter(function (iitem) {
                    return iitem._id == item._id;
                  })[0];
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: item._id,
                      ServiceID: iitem.ServiceID,
                      CustomerName: iitem.customerdetails[0].CompanyName,
                      Status: iitem.Status,
                      PreviousStartsat: new Date(iitem.Startsat),
                      PreviousEndsat: new Date(iitem.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: iitem.PestType1,
                      TeamName: iitem.TeamName,
                      TeamLead: iitem.TeamMembersName,
                      TeamMember: iitem.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: iitem.JobsOrders,
                    Customer: iitem.Customer,
                    AssignedTo: iitem.AssignedTo,
                    Frequency: iitem.Frequency,
                    ServiceOn: iitem.ServiceOn,
                    Types: iitem.Types,
                    Status: "Yet to Start",
                    Startsat: new Date(iitem.Startsat),
                    Endsat: new Date(iitem.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: iitem.PestType,
                    ContractOrder: iitem.ContractOrder,
                    ServiceID: iitem.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  },
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.Rescheduledata.length) {
                  $scope.Rescheduledata = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.SubmitCancelSelected = function () {
      $scope.vm.CancelSpinner = true;
      var Ccount = 0;
      var promise = $q.all([]);

      angular.forEach($scope.SelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.YettoStartdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                  _id: value,
                  Status: "Cancelled",
                  CancelRemarks: $scope.vm.CancelSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleDate: $scope.ServiceStartAt,
                  UpdatedBy: $rootScope.createdby
                },
              });
              response.then(function (GList) {
                var Logresponse = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: item.Status,
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    CancelRemarks: $scope.vm.CancelSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  }
                });
                //lresponse.then(function (GList) { })
                Ccount = Ccount + 1;
                if (Ccount === $scope.SelectedIds.length) {
                  $scope.SelectedIds = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.CancelSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.getEndTime = function (StartTime) {
      if (StartTime != null && StartTime != undefined && StartTime != "") {
        $scope.vm.ResheduleEndTime = new Date(moment(StartTime).add(1, 'hours'))
      }
    }

    $scope.OutstandingSelectedIds = [];
    $scope.OutstandingCheckAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.OutstandingTRCdiv = true;
        angular.forEach($scope.InProgressdatas, function (value) {
          if ($scope.OutstandingSelectedIds.indexOf(value._id) == -1) { $scope.OutstandingSelectedIds.push(value._id) }
        })
        $scope.OutstandingSelec = { value: true }
      }
      if (IsTicked == false) {
        $scope.OutstandingTRCdiv = false;
        $scope.OutstandingSelectedIds = [];
        $scope.OutstandingSelec = { value: false }
      }
    }
    $scope.OutstandingCheck = function (TrF, Ids) {
      if (TrF == true) {
        $scope.OutstandingTRCdiv = true;
        if ($scope.OutstandingSelectedIds.indexOf(Ids) == -1) { $scope.OutstandingSelectedIds.push(Ids) }
      }
      if (TrF == false) {
        $scope.OutstandingTRCdiv = false;
        var index = $scope.OutstandingSelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.OutstandingSelectedIds.splice(index, 1);
        }
      }
      if ($scope.OutstandingSelectedIds.length > 0) {
        $scope.OutstandingTRCdiv = true;
      }
    }
    $scope.OutstandingTRCdiv = false;
    $scope.OutstandingSelec = { value: false }
    $scope.OutstandingRescheduleSelected = function (e) {
      $scope.vm.Title = 'Reschedule';
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.ResheduleSSTime = null;
      $scope.vm.ResheduleSETime = null;
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OutStandingSelectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.OutstandingCancelSelected = function (e) {
      $scope.vm.Title = 'Cancel';
      $scope.vm.CancelSRemarks = null;
      $scope.vm.CancelSpinner = false;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OutStandingSelectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.OutstandingSubmitRescheduleSelected = function () {
      var Rcount = 0;
      if (Rcount == 0) {
        $scope.vm.RescheduleSpinner = true;
      }
      var promise = $q.all([]);

      var dd = $scope.vm.ResheduleSFrom;
      var hh = $scope.vm.ResheduleSSTime;
      var mm = new Date(hh.setDate(new Date(dd).getDate()));
      var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
      $scope.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));

      var edd = $scope.vm.ResheduleSFrom;
      var ehh = $scope.vm.ResheduleSETime;
      var emm = new Date(ehh.setDate(new Date(edd).getDate()));
      var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
      $scope.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));

      var currentDate = new Date($scope.schusdateTime);
      var enddate = new Date($scope.schuedateTime);
      $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
      $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
      angular.forEach($scope.OutstandingSelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.InProgressdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }
              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: value,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleFromDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var item = GList.data.data
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: value,
                      ServiceID: item.ServiceID,
                      CustomerName: item.customerdetails[0].CompanyName,
                      Status: item.Status,
                      PreviousStartsat: new Date(item.Startsat),
                      PreviousEndsat: new Date(item.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: item.PestType1,
                      TeamName: item.TeamName,
                      TeamLead: item.TeamMembersName,
                      TeamMember: item.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: "Outstanding",
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  },
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.OutstandingSelectedIds.length) {
                  $scope.OutstandingSelectedIds = [];
                  $scope.OutstandingTRCdiv = false;
                  $scope.OutstandingSelec = { value: false }
                  $scope.getOutsatnding();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }
    $scope.OutstandingSubmitCancelSelected = function () {
      $scope.vm.CancelSpinner = true;
      var Ccount = 0;
      var promise = $q.all([]);

      angular.forEach($scope.OutstandingSelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {

          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.InProgressdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                  _id: value,
                  Status: "Cancelled",
                  CancelRemarks: $scope.vm.CancelSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleDate: $scope.ServiceStartAt,
                  UpdatedBy: $rootScope.createdby
                },
              });
              response.then(function (GList) {
                var Logresponse = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: item.Status,
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    CancelRemarks: $scope.vm.CancelSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  }
                });
                //lresponse.then(function (GList) { })
                Ccount = Ccount + 1;
                if (Ccount === $scope.OutstandingSelectedIds.length) {
                  $scope.OutstandingSelectedIds = [];
                  $scope.OutstandingTRCdiv = false;
                  $scope.OutstandingSelec = { value: false }
                  $scope.getOutsatnding();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.CancelSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.Viewclk = function () {
      $scope.shedulerform = false;
      $scope.addbtn = true;
      $scope.exportbtn = true;
      $scope.viewbtn = false
      $scope.pesttypeGrid = true;
    }
    $scope.cancelbtnclk = function () {
      $scope.shedulerform = false;
      $scope.pesttypeGrid = true;
      $scope.addbtn = true;
      $scope.viewbtn = false;
      $scope.exportbtn = true;
    }
    $scope.Showgrid = function () {
      $scope.pesttypeGrid = true;
      $scope.shedulerform = false;
      $scope.exportbtn = true;
      $scope.addbtn = true;
      $scope.viewbtn = false;

      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
    }
    $scope.SelectJobOrder = function (item) {
      try {
        $scope.vm.Frequency = item.Frequency;
        item.MultiFrequency.forEach(function (value) {
          value.PestName = value.PestType;
          if (value.Frequency.toUpperCase() == 'MONTHLY' || value.Frequency.toUpperCase().indexOf('MONTHLY (12)') > -1 || value.Frequency.toUpperCase().indexOf('1 MONTH') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'BIMONTHLY' || value.Frequency.toUpperCase().indexOf('BI-MONTHLY (6)') > -1 || value.Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1 || value.Frequency.toUpperCase().indexOf('2 MONTHS') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'QUARTERLY (4)' || value.Frequency.toUpperCase() == 'QUARTERLY' || value.Frequency.toUpperCase().indexOf('3 MONTHS') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'HALF-YEARLY' || value.Frequency.toUpperCase().indexOf('HALFY-EARLY (2)') || value.Frequency.toUpperCase().indexOf('6 WEEKS') > -1 > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'YEARLY' || value.Frequency.toUpperCase().indexOf('YEARLY (1)') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
        })
        $scope.vm.Message = item.Message
        $scope.vm.firstSpecialRemark = ""
        $scope.vm.CoverageArea = item.CoverageArea
        $scope.vm.PestType = item.MultiFrequency;
        $scope.Pestdatas = item.MultiFrequency;
        $scope.vm.BillingFrequency = item.BillingFrequency
        if (item.BillingFrequency == "Weekly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 52).toFixed(2);
        }
        else if (item.BillingFrequency == "Monthly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 12).toFixed(2);
        }
        else if (item.BillingFrequency == "Quarterly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 4).toFixed(2);
        }
        else {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 1).toFixed(2);
        }
        if (item.Contractdetails.length > 0)
          $scope.vm.ContractReferenceNo = item.Contractdetails[0].ContractReferenceNo;
        $scope.vm.ContractStartDate = item.ContractStartDate;
        if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
          $scope.vm.ContractStartDate = new Date(item.ContractStartDate);
        }
        $scope.vm.ContractEndDate = item.ContractEndDate;
        if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
          $scope.vm.ContractEndDate = new Date(item.ContractEndDate);
        }
        $scope.vm.SalesOrderNo = item.SalesOrderNo;
        $scope.vm.CustomerID = item.Customer_id;
        $scope.vm.OrderType = item.OrderType;
        $scope.vm.Types = item.Types;
        $scope.vm.PreferredTime = item.DateTimeofTreatment
        $scope.vm.ServiceStartDate = item.ServiceStartDate;
        if ($scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != "") {
          $scope.vm.ServiceStartAt = new Date(item.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = item.ServiceEndDate;
        if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
          $scope.vm.ServiceEndAt = new Date(item.ServiceEndDate);
        }
        var today = new Date()
        $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 9, 0, 0);
        var EstimationHour = parseFloat(item.EstimatedHoursRequired)
        if (EstimationHour != NaN) {
          $scope.vm.EstimationHr = EstimationHour
          $scope.vm.TeamEstimationHr = EstimationHour
          $scope.WoEstimationHour = EstimationHour
          var End = new Date($scope.vm.ServiceStartTime);
          $scope.vm.ServiceEndTime = new Date(moment(End).add(EstimationHour, 'hours'))
        }
        else {
          $scope.WoEstimationHour = 0
          var End = new Date($scope.vm.ServiceStartTime);
          $scope.vm.ServiceEndTime = new Date(moment(End).add(EstimationHour, 'hours'))
        }
        if ($filter('date')($scope.vm.ServiceStartAt, 'dd/MM/yyyy') === $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy')) {
          var ServiceOn = $filter('date')($scope.vm.ServiceStartAt, 'EEEE');
          var ite = $scope.items.filter(function (ite) {
            return ite.names == ServiceOn
          });
          $scope.selected = ite;
        }
      }
      catch (e) { }
    }
    $scope.SelectContract = function (CId) {
      try {
        var item = $scope.contractdatas.filter(function (item) {
          return item._id === CId;
        })[0];
        $scope.vm.ContractReferenceNo = item.ContractReferenceNo;
        $scope.vm.ContractStartDate = item.ContractStartDate;
        if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
          $scope.vm.ContractStartDate = new Date(item.ContractStartDate);
        }
        $scope.vm.ContractEndDate = item.ContractEndDate;
        if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
          $scope.vm.ContractEndDate = new Date(item.ContractEndDate);
        }
      }
      catch (e) { }
    }
    $scope.Schinfolist = function (e, item) {
      $scope.vm.ResheduleRemarks = null;
      try {

        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        $scope.vm.Frequency = item.Frequency;
        $scope.selectedvalue = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.CustomerID = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.vm.ServiceStartAtlog = new Date(item.Startsat);
        $scope.vm.ServiceEndAtlog = new Date(item.Endsat);
        $scope.status = item.Status;
        $scope.vm.BillingAmount = null
        $scope.vm.TeamName = item.TeamName;
        $scope.vm.Teammemberdata = item.TeamMembersName;
        if (item.BillingAmount != null && item.BillingAmount != "" && item.BillingAmount != undefined) {
          $scope.vm.BillingAmount = item.BillingAmount;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName; $scope.vm.CompanyID = item.customerdetails[0].CustomerID;
          $scope.vm.CusEmail = item.customerdetails[0].Email
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) { $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo; }
        $scope.vm.ResheduleFrom = new Date(item.Startsat);
        $scope.vm.ResheduleStartTime = $scope.vm.ServiceStartAt
        $scope.vm.ResheduleEndTime = $scope.vm.ServiceEndAt

        $scope.vm.Billable = item.Billable;
        $scope.vm.CollectPayment = item.CollectPayment;
        $scope.vm.Location = item.Location;
        $scope.vm.LatLong = item.Location;
        if (item.Contracterdetails.length > 0)
          $scope.vm.ContractOrderNo = item.Contracterdetails[0].ContractReferenceNo
        if (item.customerdetails.length > 0)
          $scope.vm.CustomerName = item.customerdetails[0].CompanyName
        $scope.vm.ContactPerson = item.SiteContactPerson

        var teamdata = []
        $scope.teamdatas.filter(function (val) {
          if (item.Team_Id.includes(val.id)) {
            teamdata.push(val)
          }
        })
        $scope.vm.UTeam = teamdata
        $scope.vm.UTeam1 = teamdata[0].TeamName
        $scope.vm.TEamLead = teamdata[0].TeamLead
      } catch (e) { }
      $scope.SID = item._id;
      $scope.schedulerId = item._id;
      $scope.Update = true;
      $scope.Reschedule.value = false;
      $scope.dateBox.ResheduleFrom = {
        type: "date",
        displayFormat: "dd/MM/yyy",
        value: $scope.vm.ResheduleFrom,
        onValueChanged: function (e) {
          $scope.vm.ResheduleFrom = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleFrom'
        }
      }
      $scope.dateBox.ResheduleStartTime = {
        type: "time",
        value: $scope.vm.ServiceStartAt,
        onValueChanged: function (e) {
          $scope.vm.ServiceStartAt = e.value
          $scope.vm.ResheduleStartTime= e.value
        },
        bindingOptions: {
          'value': 'vm.ServiceStartAt'
        }
      },
        $scope.dateBox.ResheduleEndTime = {
          type: "time",
          value: $scope.vm.ServiceEndAt,
          onValueChanged: function (e) {
            $scope.vm.ServiceEndAt = e.value
            $scope.vm.ResheduleEndTime= e.value
          },
          bindingOptions: {
            'value': 'vm.ServiceEndAt'
          }
        }

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Scheduler_list_popup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      getAllCustomerServiceAdressesByCustomerID($scope.vm.CompanyID).then(function (List) {
        var semail = List.data.data.map(function (o) { if (o.sEmail != null && o.sEmail != undefined && o.sEmail != "") { return o.sEmail } })
        var bemail = List.data.data.map(function (o) { if (o.bEmail != null && o.bEmail != undefined && o.bEmail != "") { return o.bEmail } })
        semail = semail.concat(bemail)
        if ($scope.vm.CusEmail != null && $scope.vm.CusEmail != "" && $scope.vm.CusEmail != undefined) {
          semail.push($scope.vm.CusEmail)
        }
        $scope.vm.CusEmail = semail.join(',')
      })
    }
    $scope.userpopup = function (e, deleteID) {
      $scope.deleteID = deleteID;
      $scope.vm.CancelRemarks = null;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Scheduler-popup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    function getAllCustomerServiceAdressesByCustomerID(customer_id) {
      return $http({
        method: 'POST',
        url: $rootScope.WebURL + '/customerService/getByID',
        data: { RequestID: customer_id }
      });
    }

    function OnHold(e, id) {
      $scope.OnholdId = id
      $scope.vm.OnHoldRemarks = null
      $scope.vm.OnHoldDate = new Date()

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OnHoldPopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.SubmitOnHold = function () {
      var status = "From Pending Schedule"
      if ($scope.vm.SelectedTab === "ScheduledWorkOrder")
        status = "From Scheduled WorkOrder"
      $http({
        url: $rootScope.WebURL + "/salesOrder/OnHold",
        method: "PUT",
        data: { _id: $scope.OnholdId, OnHoldComments: $scope.vm.OnHoldRemarks, OnHoldDate: $scope.vm.OnHoldDate, status: status },
      }).then(function (attachmentdata) {
        $scope.NewGetByStatus()
        $scope.OnHoldFlag = false
        $mdDialog.cancel()
        $mdToast.show($mdToast.simple().textContent('Updated On-Hold Successfully!').position('top center'));
      })
    }

    $scope.cancel = function () {
      $mdDialog.cancel();
      $('#PendingContainer').dxDataGrid("instance").clearSelection();
      $scope.OnHoldFlag = false
    };

    $scope.pcancel = function () {
      $mdDialog.cancel();
    }

    $scope.Schinfodelete = function (deleteID) {
      try {
        var item = $scope.AllScheduleDatas.filter(function (item) {
          return item._id === deleteID;
        })[0];
        var createdBy = item.CreatedBy;
        if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
          var teamLead = item.teamdetails[0].TeamLead;
          var teamMember = item.teamdetails[0].TeamMembers;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.CompanyName = item.customerdetails[0].CompanyName;
        }
        $scope.jobdata = item.JobsOrders;
        $scope.CustomerID = item.Customer;
        $scope.AssignedTo = item.AssignedTo;
        $scope.Frequency = item.Frequency;
        $scope.Types = item.Types;
        $scope.ServiceOn = item.ServiceOn;
        $scope.PestType = item.PestType;
        $scope.ContractOrder = item.ContractOrder;
        $scope.ServiceID = item.ServiceID;
        $scope.Status = item.Status;
        $scope.ServiceStartAt = new Date(item.Startsat);
        $scope.ServiceEndAt = new Date(item.Endsat);
      } catch (e) { }
      $scope.Emails = null;
      if ($scope.Cancel.value == true) {
        var array = [];
        angular.forEach($scope.Userdatas, function (uvalue) {
          if (createdBy.indexOf(uvalue.UserID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
          if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
          if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
        })
        if (array.length > 0) {
          var SenderEmails = [];
          $scope.Emailgroups = _.groupBy(array, 'EmailId');
          angular.forEach($scope.Emailgroups, function (value) {
            SenderEmails.push(value[0].EmailId);
          });
          $scope.Emails = SenderEmails;
        }
      }
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/Cancelupdate",
        data: {
          _id: deleteID,
          Status: "Cancelled",
          CancelRemarks: $scope.vm.CancelRemarks,
          SenderEmailAddress: $scope.Emails,
          CompanyName: $scope.CompanyName,
          ScheduleDate: $scope.ServiceStartAt,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        var lresponse = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulelog/add",
          data: {
            Client_Id: $rootScope.Client_Id,
            JobsOrders: $scope.jobdata,
            Customer: $scope.CustomerID,
            AssignedTo: $scope.AssignedTo,
            Frequency: $scope.Frequency,
            ServiceOn: $scope.ServiceOn,
            Types: $scope.Types,
            Status: $scope.Status,
            Startsat: $scope.ServiceStartAt,
            Endsat: $scope.ServiceEndAt,
            PestType: $scope.PestType,
            ContractOrder: $scope.ContractOrder,
            ServiceID: $scope.ServiceID,
            CancelRemarks: $scope.vm.CancelRemarks,
            CreatedBy: $rootScope.createdby,
            IsActive: true,
          },
        });
        lresponse.then(function (GList) {
          if ($scope.vm.SelectedTab == 'Outstanding') {
            $scope.getOutsatnding();
          }
          else { RefreshGrid(); }
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.schedulartab = true;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
        })
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.vm.CancelledPreviewSpinner = false;

    $scope.getCancelled = function () {
      $scope.Cancelleddatas = [];
      $scope.vm.CancelledPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getCancelled",
        data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
      }).then(function (Cancelled) {
        angular.forEach(Cancelled.data.data, function (value) {
          try {
            var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.Cancelleddatas = Cancelled.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.CancelledPreviewSpinner = false;
      });
    }
    $scope.vm.PendingSchedulespinner = false

    $scope.getPendingSchedule = function () {
      $scope.PendingScheduledatas = []
      $scope.vm.PendingSchedulespinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getPending",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (salesorder) {
        var item = salesorder.data.data
        angular.forEach(item, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              if (pt != undefined)
                PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              console.log("Scheduler-Pending Schedule - " + error)

              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            console.log("Scheduler-Pending Schedule - " + e)
            $scope.vm.PendingSchedulespinner = false;
          }
        })
        $scope.PendingScheduledatas = item
        $scope.vm.PendingSchedulespinner = false;

      })
    }

    $scope.getPendingSchedule()
    $scope.AddComments = function (e, SId, CancelledTab) {
      CleanAddComments();

      $scope.vm.SalesOrderNo = '';
      $scope.vm.ContractReferenceNo = '';
      $scope.vm.CompanyName = '';
      $scope.vm.Types = '';
      $scope.vm.Remarks = '';
      $scope.vm.SiteCcontactName = '';
      $scope.vm.SiteContactNo = '';
      $scope.vm.SiteEmail = '';
      $scope.vm.EmailSentTo = '';
      $scope.vm.PaymentRemarks = "";
      $scope.vm.ServiceReportStatus = "Pending";
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/infestation",
        data: { ServiceID: SId._id },
      }).then(function (Materialsdata) {
        $scope.Materialsdatas = Materialsdata.data.data;
      });
      $scope.vm.ScedulId = SId._id;
      $scope.File_id = SId._id;
      $scope.center = [];
      $scope.latlng = [];
      $scope.Billable = { value: true };
      $scope.CollectPayment = { value: false };
      if (CancelledTab != true) {
        var item = SId
        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        $scope.vm.PreferredTime = item.PreferredTime
        $scope.vm.Message = item.Message
        $scope.vm.TeamName = item.TeamName;
        $scope.vm.TeamMembers = item.TeamMembersName;
        $scope.vm.SiteCcontactName = '';
        $scope.vm.SiteContactNo = '';
        $scope.vm.SiteEmail = '';
        $scope.vm.Remarks = item.SpecialRemark
        $scope.vm.PreferredStartTime = item.PreferredStartTime;
        $scope.vm.PreferredEndTime = item.PreferredEndTime;
        $scope.vm.AvoidStartTime = item.AvoidStartTime;
        $scope.vm.AvoidEndTime = item.AvoidEndTime;
        var item1 = $scope.teamdatas.filter(function (item1) {
          return $scope.vm.TeamName.includes(item1.TeamName)
        })
        $scope.vm.TeamLead = item1.map(function (obj) { return obj.TeamLead }).join(',')
        try {
          if (item.Adhocdata[0] != null && item.Adhocdata[0] != "" && item.Adhocdata[0] != undefined) {
            $scope.vm.CompanyName = item.Adhocdata[0].CompanyName;
            $scope.vm.Address = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        try {
          $scope.vm.SiteCcontactName = item.customerServicedetails[0].sContactPerson;
          $scope.vm.SiteContactNo = item.customerServicedetails[0].sMobile;
          $scope.vm.SiteEmail = item.customerServicedetails[0].sEmail;

        }
        catch (e) { }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
          $scope.vm.Address = item.customerdetails[0].Address;
          $scope.vm.Mobile = item.customerdetails[0].Mobile;
          $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) {
          $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
          $scope.vm.WPaymentMethod = item.JobOrdersdetails[0].PaymentMode
          $scope.MultiFrequency = item.JobOrdersdetails[0].MultiFrequency
          $scope.vm.IsUrgent = item.JobOrdersdetails[0].IsUrgent;
        }
        $scope.MultiFrequencydatas = []
        angular.forEach($scope.MultiFrequency, function (value) {
          var item1 = $scope.Treatmentdatas.filter(function (item1) {
            return value.Treatment.indexOf(item1.TreatmentMethod) > -1
          })[0];
          var Chemcial = ""
          var Dilution = ""
          if (item1 != undefined && item1 != null) {
            Chemcial = item1.Chemical
            Dilution = item1.Dilution
          }
          $scope.MultiFrequencydatas.push({
            Frequency: value.Frequency,
            PestType: value.PestType,
            TreatmentMethod: value.Treatment,
            Chemical: Chemcial,
            Dilution: Dilution,
          })
        })
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.ServiceOn = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.Pestdatas = array1;
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.Customer_Id = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.AssignedTo = item.AssignedTo;
        $scope.vm.BillingAmount = item.BillingAmount;
        $scope.vm.Location = item.Location;
        if (item.ServiceReportStatus != null && item.ServiceReportStatus != "" && item.ServiceReportStatus != undefined) {
          $scope.vm.ServiceReportStatus = item.ServiceReportStatus;
        }
        else { $scope.vm.ServiceReportStatus = "Pending"; }
        //
        try {
          if (item.Adhocdata.length > 0) {
            $scope.vm.Location = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        $scope.vm.Status = item.Status;
        $scope.vm.JobContinues = item.JobContinues;
        $scope.CreatedBy = item.CreatedBy;
        $scope.CreatedDate = new Date(item.CreateDate);

        $scope.InProgressedBy = "";
        $scope.InProgresseAt = null;
        if ($scope.vm.Status != "Yet to Start" && $scope.vm.Status != "Outstanding") {
          var uitem = [];
          try {
            uitem = $scope.Userdatas.filter(function (uitem) {
              return uitem.UserID == item.InProgressedBy
            })[0];
            $scope.InProgressedBy = uitem.EmployeeID;
            $scope.InProgresseAt = new Date(item.UpdatedDate);
          }
          catch (e) { }
          if ($scope.vm.Status == "Completed") {
            try {
              var uitem = [];
              uitem = $scope.Userdatas.filter(function (uitem) {
                return uitem.UserID == item.UpdatedBy
              })[0];
              $scope.InProgressedBy = uitem.EmployeeID;
            }
            catch (e) { }
          }
        }
        if (item.CollectPayment == "true") {
          $scope.CollectPayment = { value: true }
        }
        if (item.EmailSentDate == null || item.EmailSentDate == undefined || item.EmailSentDate == "null") {
          $scope.vm.EmailSentDate = "";
        }
        else {
          $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
        }
        try {
          $scope.vm.EmailSentTo = item.EmailSentTo.replace(",", ", ");
        }
        catch (e) { }
        $scope.vm.Pesttype = null;
        $scope.vm.Services = null;
        $scope.CustomerSignature = null;
        $scope.vm.Paymentmethod = null
        $scope.vm.Totalpayment = null
        $scope.vm.PaymentNotes = null
        $scope.vm.MobilEmailId = null;
        $scope.vm.PaymentRemarks = null;
        $scope.vm.Totalarea = null
        $scope.vm.TeamSignature = null;
        $scope.vm.AServiceStartAt = null;
        $scope.vm.AServiceEndAt = null;
        $scope.vm.starRating1r = 0;
        $scope.vm.Attitude = 0;
        $scope.vm.Appearance = 0;
        $scope.vm.ServiceQuality = 0;
        $scope.vm.Punctuality = 0;
        $scope.vm.CDate = new Date();

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (tabletschedulerrecord) {
          $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
          angular.forEach($scope.Tabletschedulerrecord, function (value) {
            try {
              if (value.TeamSignature != null && value.TeamSignature != '' && value.TeamSignature != undefined) {
                value.TeamSignature = decode_base64(value.TeamSignature);
              }
              if (value.CustomerSignature != null && value.CustomerSignature != '' && value.CustomerSignature != undefined) {
                value.CustomerSignature = decode_base64(value.CustomerSignature);
              }
              $scope.vm.CustomerPresent = value.IsCustomerPresent
              if ($scope.vm.CustomerPresent == "true" || $scope.vm.CustomerPresent == true) $scope.vm.CustomerPresent = 'Yes'
              else $scope.vm.CustomerPresent = 'No'
              if ($scope.vm.ScedulId === value.ServiceId) {
                $scope.vm.Pesttype = value.Pesttype
                $scope.vm.Services = value.Services
                $scope.vm.Materials = value.Materials
                if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                  var array = $scope.vm.Services.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ Servicetype: value });
                  });
                  $scope.vm.RServicetype = array1;
                }
                if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                  var array = $scope.vm.Materials.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ MaterialsName: value });
                  });
                  $scope.vm.RMaterialsName = array1;
                }
                $scope.vm.TeamMember = value.TeamMember
                $scope.vm.TeamRemarks = value.TeamRemarks
                $scope.vm.CustomerRemarks = value.CustomerFeedback;
                $scope.vm.TeamLead = value.TeamLead
                $scope.vm.ATimeIn = new Date(value.Startsat);
                $scope.vm.ATimeOut = new Date(value.Endsat);
                $scope.vm.Scheduledate = new Date(value.Scheduledate);
                $scope.CustomerSignature = value.CustomerSignature;
                $scope.vm.StartLocation = value.StartLocation;
                $scope.vm.EndLocation = value.EndLocation;
                $scope.vm.BreedingFound = value.BreedingFound;
                $scope.vm.Species = value.Species;
                $scope.vm.Findings = value.Findings;
                $scope.vm.MistingCariedOut = value.MistingCariedOut;
                $scope.vm.Density = value.Density;
                $scope.vm.Instar = value.Instar;
                $scope.vm.Reason = value.Reason;
                $scope.vm.TeamSignature = value.TeamSignature;
                $scope.vm.Paymentmethod = value.Paymentmethod;
                $scope.vm.PaymentMode = value.PaymentMode;
                $scope.vm.PaymentNotes = value.PaymentNotes;
                $scope.vm.MobilEmailId = value.EmailId;
                $scope.vm.PaymentRemarks = value.PaymentRemarks;
                $scope.vm.starRating1 = value.Rating;
                $scope.vm.AmountReceived = value.AmountReceived
                $scope.vm.BankName = value.BankName
                $scope.vm.ChequeNo = value.ChequeNo
                $scope.vm.AServiceStartAt = new Date(value.Startsat);
                if ($scope.vm.Status == "Completed") { $scope.InProgresseAt = $scope.vm.AServiceStartAt; }
                $scope.vm.AServiceEndAt = new Date(value.Endsat);
                $scope.vm.Totalarea = value.Totalarea;
                $scope.vm.Totalcompleted = value.Totalcompleted;
                $scope.vm.Totalpayment = value.Totalpayment;
                if ($scope.vm.Totalarea == null || $scope.vm.Totalarea == "" || $scope.vm.Totalarea == undefined) {
                  $scope.vm.Totalarea = 0;
                }
                if ($scope.vm.Totalcompleted == "null" || $scope.vm.Totalcompleted == null || $scope.vm.Totalcompleted == "" || $scope.vm.Totalcompleted == undefined) {
                  $scope.vm.Totalcompleted = 0;
                }
                if ($scope.vm.Totalpayment == "null" || $scope.vm.Totalpayment == null || $scope.vm.Totalpayment == "" || $scope.vm.Totalpayment == undefined) {
                  $scope.vm.Totalpayment = 0;
                }
                $scope.vm.CustomerCurrentDate = new Date(value.CustomerCurrentDate);
                // if ($scope.vm.Attitude != "null" && $scope.vm.Attitude != null && $scope.vm.Attitude != "" && $scope.vm.Attitude != undefined) {
                $scope.vm.Attitude = parseInt(value.Attitude);
                //    }
                // if ($scope.vm.Appearance != "null" && $scope.vm.Appearance != null && $scope.vm.Appearance != "" && $scope.vm.Appearance != undefined) {
                $scope.vm.Appearance = parseInt(value.TechnicianAppearance);
                // }
                // if ($scope.vm.ServiceQuality != "null" && $scope.vm.ServiceQuality != null && $scope.vm.ServiceQuality != "" && $scope.vm.ServiceQuality != undefined) {
                $scope.vm.ServiceQuality = parseInt(value.ServiceQuality);
                // }
                // if ($scope.vm.Punctuality != "null" && $scope.vm.Punctuality != null && $scope.vm.Punctuality != "" && $scope.vm.Punctuality != undefined) {
                $scope.vm.Punctuality = parseInt(value.Punctuality);
                // }

              }
            }
            catch (e) { }
          })
        });
        var address = $scope.vm.Location || 'Singapore';
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              $scope.latlng = [];
              $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
              $scope.center = [];
              $scope.center.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
            }
          });
        }
      }
      else if (CancelledTab == true) {
        var item = $scope.Cancelleddatas.filter(function (item) {
          return item._id === SId._id;
        })[0];
        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
          $scope.vm.TeamName = item.teamdetails[0].TeamName;
          $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
          $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
          $scope.vm.Address = item.customerdetails[0].Address;
          $scope.vm.Mobile = item.customerdetails[0].Mobile;
          $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) {
          $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
        }
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.ServiceOn = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.Pestdatas = array1;
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.Customer_Id = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.AssignedTo = item.AssignedTo;
        $scope.vm.BillingAmount = item.BillingAmount;
        $scope.vm.Location = item.Location;
        if (item.ServiceReportStatus != null && item.ServiceReportStatus != "" && item.ServiceReportStatus != undefined) {
          $scope.vm.ServiceReportStatus = item.ServiceReportStatus;
        }
        else { $scope.vm.ServiceReportStatus = "Pending"; }
        try {
          if (item.Adhocdata.length > 0) {
            $scope.vm.Location = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        $scope.vm.Status = item.Status;
        $scope.vm.JobContinues = item.JobContinues;
        $scope.CreatedBy = item.CreatedBy;
        $scope.CreatedDate = new Date(item.CreateDate);
        if (item.EmailSentDate == null || item.EmailSentDate == undefined || item.EmailSentDate == "null") {
          $scope.vm.EmailSentDate = "";
        }
        else {
          $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
        }
        try {
          $scope.vm.EmailSentTo = item.EmailSentTo.replace(",", ", ");
        }
        catch (e) { }
        $scope.Billable = { value: true };
        $scope.CollectPayment = { value: false };
        $scope.vm.Pesttype = null;
        $scope.vm.Services = null;
        $scope.CustomerSignature = null;
        $scope.vm.Paymentmethod = null
        $scope.vm.Totalpayment = null
        $scope.vm.PaymentNotes = null
        $scope.vm.MobilEmailId = null;
        $scope.vm.PaymentRemarks = null;
        $scope.vm.Totalarea = null
        $scope.vm.TeamSignature = null;
        $scope.vm.CDate = new Date();
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (tabletschedulerrecord) {
          $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
          angular.forEach($scope.Tabletschedulerrecord, function (value) {
            try {
              if (value.TeamSignature != null && value.TeamSignature != '' && value.TeamSignature != undefined) {
                value.TeamSignature = decode_base64(value.TeamSignature);
              }
              if (value.CustomerSignature != null && value.CustomerSignature != '' && value.CustomerSignature != undefined) {
                value.CustomerSignature = decode_base64(value.CustomerSignature);
              }
              if ($scope.vm.ScedulId === value.ServiceId) {
                $scope.vm.Pesttype = value.Pesttype
                $scope.vm.Services = value.Services
                $scope.vm.Materials = value.Materials
                if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                  var array = $scope.vm.Services.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ Servicetype: value });
                  });
                  $scope.vm.RServicetype = array1;
                }
                if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                  var array = $scope.vm.Materials.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ MaterialsName: value });
                  });
                  $scope.vm.RMaterialsName = array1;
                }
                $scope.vm.TeamMember = value.TeamMember
                $scope.vm.TeamRemarks = value.TeamRemarks
                $scope.vm.CustomerRemarks = value.CustomerRemarks
                $scope.vm.CustomerRemarks = value.CustomerRemarks
                $scope.vm.TeamLead = value.TeamLead
                $scope.vm.ATimeIn = new Date(value.Startsat);
                $scope.vm.ATimeOut = new Date(value.Endsat);
                $scope.vm.Scheduledate = new Date(value.Scheduledate);
                $scope.CustomerSignature = value.CustomerSignature;
                $scope.vm.StartLocation = value.StartLocation;
                $scope.vm.EndLocation = value.EndLocation;
                $scope.vm.BreedingFound = value.BreedingFound;
                $scope.vm.Species = value.Species;
                $scope.vm.Findings = value.Findings;
                $scope.vm.MistingCariedOut = value.MistingCariedOut;
                $scope.vm.Density = value.Density;
                $scope.vm.Instar = value.Instar;
                $scope.vm.Reason = value.Reason;
                $scope.vm.MistingCariedOutNo = value.MistingCariedOutNo;
                $scope.vm.NoOfCulls = value.NoOfCulls;
                $scope.vm.NoOfBurrows = value.NoOfBurrows;
                $scope.vm.NoOfDead = value.NoOfDead;
                $scope.vm.Habitat = value.Habitat;
                $scope.vm.Action = value.Action;
                $scope.vm.Recommendation = value.Recommendation;
                $scope.vm.SOR = value.SOR;
                $scope.vm.OthersReason = value.Others;
                $scope.vm.TeamSignature = value.TeamSignature;
                $scope.vm.Paymentmethod = value.Paymentmethod;
                $scope.vm.PaymentNotes = value.PaymentNotes;
                $scope.vm.MobilEmailId = value.EmailId;
                $scope.vm.PaymentRemarks = value.PaymentRemarks;
                $scope.vm.starRating1 = value.Rating;
                $scope.vm.AServiceStartAt = new Date(value.Startsat);
                $scope.vm.AServiceEndAt = new Date(value.Endsat);
                $scope.vm.Totalarea = value.Totalarea;
                $scope.vm.Totalcompleted = value.Totalcompleted;
                $scope.vm.Totalpayment = value.Totalpayment;
                if ($scope.vm.Totalarea == null || $scope.vm.Totalarea == "" || $scope.vm.Totalarea == undefined) {
                  $scope.vm.Totalarea = 0;
                }
                if ($scope.vm.Totalcompleted == "null" || $scope.vm.Totalcompleted == null || $scope.vm.Totalcompleted == "" || $scope.vm.Totalcompleted == undefined) {
                  $scope.vm.Totalcompleted = 0;
                }
                if ($scope.vm.Totalpayment == "null" || $scope.vm.Totalpayment == null || $scope.vm.Totalpayment == "" || $scope.vm.Totalpayment == undefined) {
                  $scope.vm.Totalpayment = 0;
                }
                $scope.vm.CustomerCurrentDate = new Date(value.CustomerCurrentDate);
                if ($scope.vm.starRating1 != "null" && $scope.vm.starRating1 != null && $scope.vm.starRating1 != "" && $scope.vm.starRating1 != undefined) {
                  $scope.vm.starRating1r = parseInt(value.Rating);
                }
              }
            }
            catch (e) { }
          })
        });

        var address = $scope.vm.Location || 'Singapore';
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              $scope.latlng = [];
              $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
            }
          });
        }
      }
      RefreshAttachmentGrid();
      Refreshcomment();
      RefreshPhotos();
      RefreshSchedulerLogs();

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/addcoments.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
          // $('#DetailsdtLog').DataTable({
          // });
          //vm.dtLogdetails = {
          //    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          //    initComplete: function () {
          //        var api = this.api(),
          //            searchBox = angular.element('body').find('#DetailsdtLog');
          //        // Bind an external input as a table wide search box
          //        if (searchBox.length > 0) {
          //            searchBox.on('keyup', function (event) {
          //                api.search(event.target.value).draw();
          //            });
          //        }
          //    },
          //    pagingType: 'simple',
          //    autoWidth: false,
          //    //responsive: true,
          //    //destroy: true
          //};
        }
      });

    }

    $scope.RemarkSubmit = function () {
      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/scheduler/postRemark',
        data: { _id: $scope.vm.ScedulId, Remark: $scope.vm.Remarks }
      }).then(function (item) {
        $scope.vm.ssRemark = $scope.vm.Remarks;
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
      })
    }

    $scope.updateServiceReportStatus = function () {
      $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/updateServiceReportStatus",
        data: { _id: $scope.vm.ScedulId, UpdatedBy: $rootScope.createdby },
      }).then(function (GList) {
        $scope.vm.ServiceReportStatus = "Approved";
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/SendEmailtoCompletedService",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (GList) {
        });
        $scope.NewGetByStatus();
      }, function () { });
    }

    function CleanAddComments() {
      $scope.vm.CustomerPresent = ""
      $scope.vm.Status = "";
      $scope.vm.ServiceID = "";
      $scope.vm.SalesOrderNo = "";
      $scope.vm.ContractReferenceNo = "";
      $scope.vm.CompanyName = "";
      $scope.vm.Location = "";
      $scope.vm.TeamName = "";
      $scope.vm.ServiceStartAt = "";
      $scope.vm.ServiceEndAt = "";
      $scope.vm.PestType1 = "";
      $scope.vm.Types = "";
      $scope.vm.ServiceOn = "";
      $scope.InProgresseAt = "";
      $scope.vm.AServiceEndAt = "";
      $scope.vm.EmailSentTo = "";
      $scope.vm.EmailSentDate = "";
      $scope.InProgressedBy = "";
      $scope.CreatedBy = "";
      $scope.CreatedDate = "";
      $scope.vm.Vehicle = "";
      $scope.Billable = { value: true };
      $scope.vm.BillingAmount = 0
      $scope.Tabletlighttracklistdatas = [];
      $scope.TabletMaterialslistdatas = [];
      $scope.vm.TeamLead = "";
      $scope.vm.TeamMembers = "";
      $scope.vm.TeamRemarks = "";
      $scope.vm.TeamSignature = "";
      $scope.PhotosBdatas = [];
      $scope.Photosdatas = [];
      $scope.vm.NoOfCulls = "";
      $scope.vm.MistingCariedOut = "";
      $scope.vm.NoOfBurrows = "";
      $scope.vm.Density = "";
      $scope.vm.NoOfDead = "";
      $scope.vm.Instar = "";
      $scope.vm.BreedingFound = "";
      $scope.vm.Habitat = "";
      $scope.vm.Species = "";
      $scope.vm.Action = "";
      $scope.vm.Findings = "";
      $scope.vm.Recommendation = "";
      $scope.vm.MobilEmailId = "";
      $scope.vm.Paymentmethod = "";
      $scope.vm.Totalpayment = "";
      $scope.vm.PaymentNotes = "";
      $scope.vm.PaymentRemarks = "";
      $scope.vm.Totalarea = "";
      $scope.vm.Totalcompleted = "";
      $scope.vm.starRating1r = "";
      $scope.vm.CustomerRemarks = "";
      $scope.CustomerSignature = "";
      $scope.vm.Addcomments = "";
      $scope.Commentdatas = [];
      $scope.Attachmentdatas = [];
      $scope.SchedulerLogdatas = [];
      $scope.vm.ATimeIn = "";
      $scope.vm.ATimeOut = "";
      $scope.vm.ContactPerson = "";
      $scope.vm.TeamMember = "";
      $scope.vm.starRating1 = "";
      $scope.Pestdatas = [];
      $scope.vm.MServicetype = "";
      $scope.vm.MLSMPestType = [];
      $scope.vm.MMaterialsName = "";
      $scope.vm.MQuantity = "";
      $scope.vm.MUnit = "";
      $scope.vm.ImgBPestType = [];
      $scope.vm.ImgBRemarks = "";
      $scope.uCPB = "";
      $scope.vm.Paymentmethod = "";
      $scope.vm.Totalpayment = "";
      $scope.vm.PaymentNotes = "";
      $scope.vm.PaymentRemarks = "";
      $scope.vm.Totalarea = "";
      $scope.vm.Totalcompleted = "";
      $scope.vm.Reason = "";
      $scope.vm.PreferredStartTime = "";
      $scope.vm.PreferredEndTime = "";
      $scope.vm.AvoidStartTime = "";
      $scope.vm.AvoidEndTime = "";

    }

    $scope.getWorkOrderDetails = function () {
      try {
        $scope.getSalesOrderdatas = $scope.salesdatas.filter(function (item) {
          return item.Customer_id === $scope.vm.CustomerID;
        });
      } catch (e) { }
      try {
        $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
          return item1.Customer_id === $scope.vm.CustomerID;
        });
      } catch (e) { }
      $scope.vm.WorkOrderID = null;
      $scope.vm.ContractID = null;
      $scope.vm.Types = null;
    }
    $scope.getContractDetails = function () {
      if ($scope.vm.CustomerID != "" && $scope.vm.CustomerID != null && $scope.vm.CustomerID != undefined && $scope.vm.WorkOrderID != "" && $scope.vm.WorkOrderID != null && $scope.vm.WorkOrderID != undefined) {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.Customer_id === $scope.vm.CustomerID && item1.SalesOrderID === $scope.vm.WorkOrderID;
          });
        } catch (e) { }
      }
      else if ($scope.vm.CustomerID != "" && $scope.vm.WorkOrderID == "") {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.Customer_id === $scope.vm.CustomerID;
          });
        } catch (e) { }
      }
      else if ($scope.vm.CustomerID == "" && $scope.vm.WorkOrderID != "") {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.SalesOrderID === $scope.vm.WorkOrderID;
          });
        } catch (e) { }
      }
      if ($scope.vm.WorkOrderID != "" && $scope.vm.WorkOrderID != null && $scope.vm.WorkOrderID != undefined) {
        try {
          var getSalesOrderType = $scope.salesdatas.filter(function (item) {
            return item._id === $scope.vm.WorkOrderID;
          })[0];
        } catch (e) { }
        $scope.vm.Types = getSalesOrderType.Types;
      }
      else {
        $scope.vm.Types = "";
      }
    }
    $scope.AdhocUpdate = function () {
      $scope.IndexID = $scope.IndxID;
      if ($scope.vm.CustomerID == "" || $scope.vm.CustomerID == undefined) { $scope.vm.CustomerID = null }
      if ($scope.vm.WorkOrderID == "" || $scope.vm.WorkOrderID == undefined) { $scope.vm.WorkOrderID = null }
      if ($scope.vm.ContractID == "" || $scope.vm.ContractID == undefined) { $scope.vm.ContractID = null }
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/updateAdhocdetail",
        data: {
          _id: $scope.vm.ScedulId,
          Customer: $scope.vm.CustomerID,
          JobsOrders: $scope.vm.WorkOrderID,
          ContractOrder: $scope.vm.ContractID,
          Types: $scope.vm.Types,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
        $scope.AdhocJobsdatas[$scope.IndexID] = GList.data.data[0];
        //RefreshGrid();
        $mdDialog.cancel();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.BillableSubmit = function () {
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/update",
        data: {
          _id: $scope.vm.ScedulId,
          Types: $scope.vm.Types,
          JobType: $scope.vm.JobType,
          PreferredTime: $scope.vm.PreferredTime,
          SpecialRemark: $scope.vm.SpecialRemark,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
        RefreshGrid();
        $mdDialog.cancel();
      });
    }
    $scope.EditmobileSubmit = function () {
      if ($scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == undefined) {
        $scope.vm.BreedingFound = null;
      }
      if ($scope.vm.Species == "" || $scope.vm.Species == "undefined" || $scope.vm.Species == undefined) {
        $scope.vm.Species = null;
      }
      if ($scope.vm.Findings == "" || $scope.vm.Findings == "undefined" || $scope.vm.Findings == undefined) {
        $scope.vm.Findings = null;
      }
      if ($scope.vm.MistingCariedOut == "" || $scope.vm.MistingCariedOut == "undefined" || $scope.vm.MistingCariedOut == undefined) {
        $scope.vm.MistingCariedOut = null;
      }
      if ($scope.vm.Reason == "" || $scope.vm.Reason == "undefined" || $scope.vm.Reason == undefined) {
        $scope.vm.Reason = null;
      }
      if ($scope.vm.Instar == "" || $scope.vm.Instar == "undefined" || $scope.vm.Instar == undefined) {
        $scope.vm.Instar = null;
      }
      if ($scope.vm.Density == "" || $scope.vm.Density == "undefined" || $scope.vm.Density == undefined) {
        $scope.vm.Density = null;
      }
      if ($scope.vm.Others == "" || $scope.vm.Others == "undefined" || $scope.vm.Others == undefined) {
        $scope.vm.Others = null;
      }
      if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
        $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
      }
      if ($scope.vm.MMaterialsName != null && $scope.vm.MMaterialsName != "" && $scope.vm.MMaterialsName != undefined) {
        $scope.vm.MMaterialsName = $scope.vm.MMaterialsName.map(function (obj) { return obj.MaterialsName; }).join(',');
      }

      if ($scope.vm.tbsc_id != undefined && $scope.vm.tbsc_id != null && $scope.vm.tbsc_id != "") {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletschedulerrecord/update",
          data: {
            _id: $scope.vm.tbsc_id,
            ServiceId: $scope.vm.ServiceID,
            Team: $scope.vm.TeamName,
            Scheduledate: $scope.vm.ServiceStartAt,
            WorkorderNo: $scope.vm.SalesOrderNo,
            ContractOrderNo: $scope.vm.ContractReferenceNo,
            CustomerName: $scope.vm.CompanyName,
            Location: $scope.vm.Location,
            Startsat: $scope.vm.Startsat,
            Endsat: $scope.vm.Endsat,
            Pesttype: $scope.vm.PestType1,
            Services: $scope.vm.MServicetype,
            TeamLead: $scope.vm.TeamLead,
            TeamMember: $scope.vm.TeamMembers,
            TeamRemarks: $scope.vm.TeamRemarks,
            TeamSignature: $scope.vm.TeamSignature,
            BreedingFound: $scope.vm.BreedingFound,
            Species: $scope.vm.Species,
            Findings: $scope.vm.Findings,
            MistingCariedOut: $scope.vm.MistingCariedOut,
            Density: $scope.vm.Density,
            Instar: $scope.vm.Instar,
            Reason: $scope.vm.Reason,
            CustomerCurrentDate: $scope.CustomerCurrentDate,
            Rating: $scope.vm.starRating1,
            Materials: $scope.vm.MMaterialsName,
            CustomerRemarks: $scope.vm.CustomerRemarks,
            CustomerSignature: $scope.vm.CustomerSignature,
            Paymentmethod: $scope.vm.Paymentmethod,
            Totalpayment: $scope.vm.Totalpayment,
            PaymentNotes: $scope.vm.PaymentNotes,
            Totalarea: $scope.vm.Totalarea,
            EmailId: $scope.vm.MobilEmailId,
            PaymentRemarks: $scope.vm.PaymentRemarks,
            Totalcompleted: $scope.vm.Totalcompleted,
          },
        });
        response.then(function (GList) {
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          $mdDialog.cancel();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        })
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/add",
          data: {
            ServiceId: $scope.vm.ScedulId,
            Team: $scope.vm.TeamName,
            Scheduledate: $scope.vm.ServiceStartAt,
            WorkorderNo: $scope.vm.SalesOrderNo,
            ContractOrderNo: $scope.vm.ContractReferenceNo,
            CustomerName: $scope.vm.CompanyName,
            Location: $scope.vm.Location,
            Startsat: new Date(),
            Endsat: new Date(),
            Pesttype: $scope.vm.PestType1,
            Services: $scope.vm.MServicetype,
            TeamLead: $scope.vm.TeamLead,
            TeamMember: $scope.vm.TeamMembers,
            TeamRemarks: $scope.vm.TeamRemarks,
            TeamSignature: $scope.vm.TeamSignature,
            BreedingFound: $scope.vm.BreedingFound,
            Species: $scope.vm.Species,
            Findings: $scope.vm.Findings,
            MistingCariedOut: $scope.vm.MistingCariedOut,
            Density: $scope.vm.Density,
            Instar: $scope.vm.Instar,
            Reason: $scope.vm.Reason,
            CustomerCurrentDate: new Date(),
            Rating: $scope.vm.starRating1,
            Materials: $scope.vm.MMaterialsName,
            CustomerRemarks: $scope.vm.CustomerRemarks,
            CustomerSignature: $scope.vm.CustomerSignature,
            Paymentmethod: $scope.vm.Paymentmethod,
            Totalpayment: $scope.vm.Totalpayment,
            PaymentNotes: $scope.vm.PaymentNotes,
            Totalarea: $scope.vm.Totalarea,
            EmailId: $scope.vm.MobilEmailId,
            PaymentRemarks: $scope.vm.PaymentRemarks,
            Totalcompleted: $scope.vm.Totalcompleted,
            CreatedBy: $rootScope.createdby,
          },
        });
        response.then(function (GList) {
          var response1 = $http({
            url: $rootScope.WebURL + "/scheduler/Statusupdate",
            method: "PUT",
            data: {
              _id: $scope.vm.ScedulId,
              Status: "Completed",
              UpdatedBy: $rootScope.createdby,
            },
          });
          response1.then(function (GList) {
            $mdDialog.cancel();
            $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
            $mdDialog.cancel();
            RefreshGrid();
          });
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        })
      }
    }
    $scope.getpos = function (event) {
      $scope.lat = event.latLng.lat();
      $scope.lng = event.latLng.lng();
      $scope.latlng = [event.latLng.lat(), event.latLng.lng()];
    };
    $scope.placeMarker = function () {
      console.log(this.getPlace());
      var loc = this.getPlace().geometry.location;
      $scope.latlng = [loc.lat(), loc.lng()];
      $scope.center = [loc.lat(), loc.lng()];
    };
    $scope.EditMobileLogs = function (e, Sid) {
      $scope.vm.SMLMUpdate = false;
      $scope.vm.SMUpdate = false;
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.MLSMPestType = null;
      $scope.vm.MMaterialsName = null;
      $scope.vm.MQuantity = null;
      $scope.vm.MUnit = null;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Editemobilelog.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ServiceID = Sid;
      $scope.vm.starRating1 = 0;
      $scope.vm.tbsc_id = null;
      if ($scope.vm.Status == 'Completed') {
        angular.forEach($scope.Tabletschedulerrecord, function (value) {
          try {
            if ($scope.vm.ScedulId === value.ServiceId) {
              $scope.vm.tbsc_id = value._id
              $scope.vm.Pesttype = value.Pesttype
              if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
                var array = $scope.vm.Pesttype.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ PestName: value });
                });
                $scope.Pestdatas = array1;
              }
              $scope.vm.Services = value.Services
              $scope.vm.Materials = value.Materials
              if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                var array = $scope.vm.Services.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ Servicetype: value });
                });
                $scope.vm.MServicetype = array1;
              }
              if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                var array = $scope.vm.Materials.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ MaterialsName: value });
                });
                $scope.vm.MMaterialsName = array1;
              }
              $scope.vm.TeamMember = value.TeamMember
              $scope.vm.TeamRemarks = value.TeamRemarks
              $scope.vm.CustomerRemarks = value.CustomerRemarks
              $scope.vm.CustomerRemarks = value.CustomerRemarks
              $scope.vm.TeamLead = value.TeamLead
              $scope.vm.ATimeIn = new Date(value.Startsat);
              $scope.vm.ATimeOut = new Date(value.Endsat);
              $scope.vm.Scheduledate = new Date(value.Scheduledate);
              $scope.CustomerSignature = value.CustomerSignature;
              $scope.uPB1 = value.PB1;
              $scope.uPB2 = value.PB2;
              $scope.uPB3 = value.PB3;
              $scope.uPB4 = value.PB4;
              $scope.uPA1 = value.PA1;
              $scope.uPA2 = value.PA2;
              $scope.uPA3 = value.PA3;
              $scope.uPA4 = value.PA4;
              $scope.vm.TeamSignature = value.TeamSignature;
              $scope.vm.Paymentmethod = value.Paymentmethod;
              $scope.vm.MobilEmailId = value.EmailId;
              $scope.vm.PaymentRemarks = value.PaymentRemarks;
              $scope.vm.Totalpayment = parseInt(value.Totalpayment);
              $scope.vm.PaymentNotes = value.PaymentNotes;
              $scope.vm.Totalarea = parseInt(value.Totalarea);
              $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
              $scope.starRating1r = value.Rating;
              $scope.vm.starRating1 = value.Rating;
              $scope.vm.AServiceStartAt = new Date(value.Startsat);
              $scope.vm.AServiceEndAt = new Date(value.Endsat);
              $scope.vm.CustomerCurrentDate = new Date(CustomerCurrentDate);
            }
          }
          catch (e) { }
        })
      }
      else {
        $scope.vm.tbsc_id = null;
      }
    }

    $scope.vm.AStartTime = new Date()
    $scope.vm.AEndTime = null

    $scope.dateBox = {
      ServiceStartTime: {
        type: "time",
        value: $scope.vm.ServiceStartTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceStartTime = e.value
          $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.ServiceStartTime'
        }
      },
      ServiceEndTime: {
        type: "time",
        value: $scope.vm.ServiceEndTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ServiceEndTime'
        }
      },
      PreferredStartTime: {
        type: "time",
        value: $scope.vm.PreferredStartTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredStartTime = e.value
          // $scope.vm.PreferredEndTime = new Date(moment(e.value).add(1, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.PreferredStartTime'
        }
      },
      PreferredEndTime: {
        type: "time",
        value: $scope.vm.PreferredEndTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.PreferredEndTime'
        }
      },
      AvoidStartTime: {
        type: "time",
        value: $scope.vm.AvoidStartTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidStartTime = e.value
          // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.AvoidStartTime'
        }
      },
      AvoidEndTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AvoidEndTime'
        }
      },
      ResheduleSSTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleSSTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSSTime'
        }
      },
      ResheduleSETime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleSETime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSETime'
        }
      },
      ResheduleStartTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleStartTime = e.value
          $scope.vm.ResheduleEndTime = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
        },
        bindingOptions: {
          'value': 'vm.ResheduleStartTime'
        }
      },
      ResheduleEndTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleEndTime'
        }
      },
      ResheduleFrom: {
        type: "date",
        displayFormat: "dd/MM/yyy",
        value: $scope.vm.ResheduleFrom,
        onValueChanged: function (e) {
          $scope.vm.ResheduleFrom = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleFrom'
        }
      },
      AStartTime: {
        type: "datetime",
        displayFormat: "dd/MM/yyyy hh:mm a",
        value: $scope.vm.AStartTime,
        onValueChanged: function (e) {
          $scope.vm.AStartTime = e.value;
          calculate_estimation_and_end_time();
        },
        bindingOptions: {
          'value': 'vm.AStartTime'
        }
      },
      AEndTime: {
        type: "datetime",
        displayFormat: "dd/MM/yyyy hh:mm a",
        disabled: true,
        value: $scope.vm.AEndTime,
        onValueChanged: function (e) {
          $scope.vm.AEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AEndTime'
        }
      },
    }

    $scope.calculate_end_time = function () {
      $scope.vm.AStartTime = new Date()
      calculate_estimation_and_end_time()
    }
    // Add function for new design..............
    $scope.addNewSchedule = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/NewAdd.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.Twiceday = null
      $scope.vm.uContactPerson = null
      $scope.vm.ClientEmail = null
      $scope.vm.SiteContactName = null
      $scope.vm.SiteAddress = null
      $scope.vm.SiteContactNumber = null
      $scope.AllSASelec = { value: false };
      $scope.SASelec = { value: false };
      $scope.svAll = { value: false };
      $scope.ServiceAddressarray = [];
      $scope.thdata = true;
      $scope.vm.Types = 'Follow-up'
      $scope.vm.JobType = 'Fixed'
      $scope.vm.SFOPH = "Next Day";
      $scope.vm.jobdata = null;
      $scope.vm.SearchGetCW = null;
      $scope.customer = null;
      $scope.vm.AssignedTo = null;
      $scope.vm.ContractOrder = null;
      $scope.vm.PreferredTime = null;
      $scope.vm.SpecialRemark = null;
      $scope.vm.firstSpecialRemark = null;
      $scope.vm.PreferredStartTime = null;
      $scope.vm.PreferredEndTime = null;
      $scope.vm.AvoidStartTime = null;
      $scope.vm.AvoidEndTime = null;
      $scope.vm.ppZone = '';
      var today = new Date();
      $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 9, 0, 0);
      $scope.vm.ServiceEndTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 10, 0, 0);
      $scope.vm.Frequency = "";
      if ($scope.selected.length === $scope.items.length) {
        $scope.selected = [];
      } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = [];
      }

      $scope.vm.AStartTime = new Date()
      $scope.vm.AEndTime = new Date()

      $scope.dateBox.ServiceStartTime = {
        type: "time",
        value: $scope.vm.ServiceStartTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceStartTime = e.value
          // $scope.vm.ServiceEndTime.setHours(e.value.getHours() + 1, e.value.getMinutes(), e.value.getSeconds())
          $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.ServiceStartTime'
        }
      }
      $scope.dateBox.ServiceEndTime = {
        type: "time",
        value: $scope.vm.ServiceEndTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ServiceEndTime'
        }
      }
      $scope.dateBox.PreferredStartTime = {
        type: "time",
        value: $scope.vm.PreferredStartTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredStartTime = e.value
          // $scope.vm.PreferredEndTime = new Date(moment(e.value).add(1, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.PreferredStartTime'
        }
      }
      $scope.dateBox.PreferredEndTime = {
        type: "time",
        value: $scope.vm.PreferredEndTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.PreferredEndTime'
        }
      },
        $scope.dateBox.AvoidStartTime = {
          type: "time",
          value: $scope.vm.AvoidStartTime,
          onValueChanged: function (e) {
            $scope.vm.AvoidStartTime = e.value
            // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
          },
          bindingOptions: {
            'value': 'vm.AvoidStartTime'
          }
        }
      $scope.dateBox.AvoidEndTime = {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AvoidEndTime'
        }
      }
      $scope.dateBox.ResheduleSSTime = {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSSTime'
        }
      }
      $scope.dateBox.ResheduleSETime = {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSETime'
        }
      }
      $scope.dateBox.ResheduleStartTime = {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleStartTime = e.value
          $scope.vm.ResheduleEndTime = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
        },
        bindingOptions: {
          'value': 'vm.ResheduleStartTime'
        }
      }
      $scope.dateBox.ResheduleEndTime = {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleEndTime'
        }
      }
      $scope.dateBox.ResheduleFrom = {
        type: "date",
        displayFormat: "dd/MM/yyy",
        value: $scope.vm.ResheduleFrom,
        onValueChanged: function (e) {
          $scope.vm.ResheduleFrom = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleFrom'
        }
      }
      $scope.dateBox.AStartTime = {
        type: "datetime",
        value: $scope.vm.AStartTime,
        onValueChanged: function (e) {
          $scope.vm.AStartTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AStartTime'
        }
      }
      $scope.dateBox.AEndTime = {
        type: "datetime",
        value: $scope.vm.AEndTime,
        onValueChanged: function (e) {
          $scope.vm.AEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AEndTime'
        }
      }

      $scope.vm.GetCWCType = "Customers";
      $scope.vm.ServiceStartAt = null;
      $scope.vm.ServiceEndAt = null;
      $scope.vm.PestType = null;
      $scope.vm.ppCompanyName = null;
      $scope.vm.ppWorkOrder = null;
      $scope.vm.ppContractNo = null;
      $scope.vm.TM = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.ForBiWeekly = '';
      $scope.vm.ForMonthly = '';
      $scope.vm.ForBiMonthly = '';
      $scope.vm.ForYearlyWeek = '';
      $scope.vm.ForYearly = '';
      $scope.vm.ForQuaterlyWeek = '';
      $scope.vm.ForQuaterly = '';
      $scope.vm.ForHalfYearlyWeek = '';
      $scope.vm.ForHalfYearly = '';
      $scope.Update = false;
      $scope.Holidays = { value: true };
      $scope.Summary = '';
      $scope.vm.ScheduleType = "Fixed";
    };

    $scope.filterCustomerfn = function (searchText) {
      if (!$scope.Customerdatas) return [];

      return $scope.Customerdatas.filter(function (item) {
        return (
          item.CompanyName &&
          item.CompanyName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        );
      });
    };


    $scope.onCustomerSelected = function (item) {
      if (item) {
        $scope.vm.billingAddresses = []
        $scope.vm.serviceAddresses = []
        $scope.vm.ACompanyID = item._id;
        $scope.vm.ACompanyName = item.CompanyName; // Selected from dropdown
        $scope.vm.AContactName = item.ContactPerson
        search_customer_billing_sevice_address(item.CustomerID)

      } else {
        $scope.vm.ACompanyName = vm.searchCompanyText;
        $scope.vm.ACompanyID = null// Free-text input
        $scope.vm.billingAddresses = []
        $scope.vm.AContactName = null
        $scope.vm.serviceAddresses = []

      }
      $scope.vm.ABillingAddress = '';
      $scope.vm.ABPostal = '';
      $scope.vm.ABEMail = [];
      $scope.vm.AServicesAddress = '';
      $scope.vm.ASPostal = '';
      $scope.vm.ASEmail = [];
    };

    vm.onEmail1ChipAdd = function () {
      vm.Email1ChipWarning = false;
    };
    vm.onEmail2ChipAdd = function () {
      vm.Email2ChipWarning = false;
    };

    function search_customer_billing_sevice_address(uniq_customer_id) {
      getAllCustomerServiceAdressesByCustomerID(uniq_customer_id).then(function (item) {
        if (item) {
          var all_customer_addresses = item.data.data
          $scope.vm.billingAddresses = all_customer_addresses.filter(function (v) { return v.Type === "Billing" })
          $scope.vm.serviceAddresses = all_customer_addresses.filter(function (v) { return v.Type === "Service" })
        }
      })
    }
    vm.fillBillingAddress = function (selected) {
      if (selected) {
        $scope.vm.ABillingAddress = selected.bStreetName;
        $scope.vm.ABPostal = selected.bPostal;
        $scope.vm.ABEMail = selected.bEmail.split(",") || [];
      } else {
        $scope.vm.ABillingAddress = '';
        $scope.vm.ABPostal = '';
        $scope.vm.ABEMail = [];
      }
    };
    vm.fillServiceAddress = function (selected) {
      if (selected) {
        $scope.vm.AServicesAddress = selected.sStreetName;
        $scope.vm.ASPostal = selected.sPostal;
        $scope.vm.ASEmail = selected.sEmail.split(",") || [];
      } else {
        $scope.vm.AServicesAddress = '';
        $scope.vm.ASPostal = '';
        $scope.vm.ASEmail = [];
      }
    };

    $scope.placeChanged1 = function () {
      $scope.vm.ABPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.ABPostal =
              vm.place.address_components[i].long_name

          }
        }
      }
    };

    $scope.placeChanged2 = function () {
      $scope.vm.ASPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.ASPostal =
              vm.place.address_components[i].long_name

          }
        }
      }
    };

    $scope.addCustomSchedule = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomAdd.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        },
        onComplete: function (scope, element) {
          update_contact_email_field(scope);
        }
      });
      if ($scope.treeBoxInstance) {
        $scope.treeBoxInstance.option('value', []); // or .reset()
      } else {
        $scope.treeBoxValue = [];
        if (!$scope.$$phase) $scope.$applyAsync();
      }


      $scope.vm.emailValidationError = false
      $scope.vm.emailValidationError = false
      $scope.AllSASelec = { value: false };
      $scope.SASelec = { value: false };
      $scope.svAll = { value: false };
      $scope.ServiceAddressarray = [];
      $scope.thdata = true;
      $scope.vm.Types = 'Follow-up'
      $scope.vm.SFOPH = "Skip";
      $scope.vm.jobdata = null;
      $scope.vm.SearchGetCW = null;
      $scope.customer = null;
      $scope.vm.AssignedTo = null;
      $scope.vm.ContractOrder = null;
      var today = new Date();
      $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 30, 0);
      $scope.vm.ServiceEndTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 17, 30, 0);
      $scope.vm.Frequency = "";
      if ($scope.selected.length === $scope.items.length) {
        $scope.selected = [];
      } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = [];
      }
      $scope.vm.GetCWCType = "Customers";
      $scope.vm.ServiceStartAt = null;
      $scope.vm.ServiceEndAt = null;
      $scope.vm.PestType = null;
      $scope.vm.ppCompanyName = null;
      $scope.Update = false;
      $scope.vm.ForQuaterlyWeek = '';
      $scope.Holidays = { value: true };
      $scope.vm.ppWorkOrder = null;
      $scope.vm.ppContractNo = null;
      $scope.vm.TM = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.ForBiWeekly = '';
      $scope.vm.ForMonthly = '';
      $scope.vm.ForBiMonthly = '';
      $scope.vm.ForYearlyWeek = '';
      $scope.vm.ForYearly = '';
      $scope.vm.ForQuaterlyWeek = '';
      $scope.vm.ForQuaterly = '';
      $scope.vm.ForHalfYearlyWeek = '';
      $scope.vm.ForHalfYearly = '';
      $scope.Summary = '';
      $scope.vm.ScheduleType = "Custom";
    };
    $scope.GetCWC = function (a) {
      $scope.vm.SO = null;
      $scope.vm.ServiceEndAt = null;
      $scope.AllSASelec = { value: false };
      $scope.SASelec = { value: false };
      $scope.svAll = { value: false };
      $scope.ServiceAddressarray = [];
      $scope.CustomerServicedatas = [];
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/GetCWC.html',
        parent: angular.element($document.body),
        targetEvent: a,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          },
            $('#Detailsdt').DataTable({
            });
          vm.dtdetails = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
              var api = this.api(),
                searchBox = angular.element('body').find('#forms-Detailsdt');
              var table = $('#Detailsdt').DataTable();
              table.search('').draw();
              // Bind an external input as a table wide search box
              if (searchBox.length > 0) {
                searchBox.on('keyup', function (event) {
                  api.search(event.target.value).draw();
                });
              }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[3, "asc"]],
            lengthMenu: [5, 10, 20, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
              "lengthMenu": $rootScope.lengthMenu,
              "zeroRecords": $rootScope.zeroRecords,
              "info": $rootScope.info,
              "infoEmpty": $rootScope.infoEmpty,
              "infoFiltered": $rootScope.infoFiltered,
              "Header": $rootScope.Header,
            }

          };
        }
      });

      $scope.vm.Location = null;
      $scope.vm.SO = null;
      $scope.vm.ppCompanyName = null;
      $scope.vm.Customersearch = null;
      $scope.vm.jobdata = null;
      $scope.vm.ContractOrder = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.ppWorkOrder = null;
      $scope.vm.ppContractNo = null;
      $scope.vm.ShowScheduledStatus = "New";
      $scope.vm.ShowScheduled = false;
      $scope.vm.ForBiWeekly = '';
      $scope.vm.ForMonthly = '';
      $scope.vm.ForBiMonthly = '';
      $scope.vm.ForYearlyWeek = '';
      $scope.vm.ForYearly = '';
      $scope.vm.ForQuaterlyWeek = '';
      $scope.vm.ForQuaterly = '';
      $scope.vm.ForHalfYearlyWeek = '';
      $scope.vm.ForHalfYearly = '';
      $scope.vm.PreferredTime = null;
      $scope.vm.ppZone = '';
      $scope.vm.SpecialRemark = null;
      $scope.vm.firstSpecialRemark = null;
      if ($scope.vm.SearchGetCW != null && $scope.vm.SearchGetCW != undefined && $scope.vm.SearchGetCW != "") {
        $scope.vm.SearchGetCW = $scope.vm.SearchGetCW.toUpperCase();
        if ($scope.vm.GetCWCType == "Customers") {
          try {
            var item = $scope.Customerdatas.filter(function (item) {
              return item.CompanyName.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            var SOarray = [];
            var Carray = [];
            angular.forEach(data, function (value) {
              var item1 = $scope.salesdatas.filter(function (item1) {
                return item1.Customer_id === value.id;
              });
              var item2 = $scope.contractdatas.filter(function (item2) {
                return item2.Customer_id === value.id;
              });
              SOarray.push(item1);
            })
            angular.forEach(SOarray, function (value) {
              angular.forEach(value, function (innervalue) {
                Carray.push(innervalue);
              })
            })
            angular.forEach(Carray, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach($scope.contractdatas, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = Carray.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = Carray.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
        if ($scope.vm.GetCWCType == "WorkOrder") {
          try {
            var item = $scope.salesdatas.filter(function (item) {
              return item.SalesOrderNo.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            angular.forEach(data, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach($scope.contractdatas, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
        if ($scope.vm.GetCWCType == "Contracts") {
          try {
            var item = $scope.contractdatas.filter(function (item) {
              return item.ContractReferenceNo.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            angular.forEach($scope.salesdatas, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach(data, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
      }
      else {
        var data = $scope.salesdatas
        angular.forEach(data, function (cvalue) {
          cvalue.IsActive = "";
          cvalue.TotalOrderValue = null;
          angular.forEach($scope.contractdatas, function (value) {
            if (cvalue.ContractNo == value._id) {
              cvalue.IsActive = value.ContractReferenceNo;
              cvalue.TotalOrderValue = value._id;
            }
          })
        })
        try {
          var item = [];
          if ($scope.vm.ScheduleType == 'Fixed') {
            item = data.filter(function (item) {
              return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
          }
          else {
            item = data.filter(function (item) {
              return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
          }
          $scope.CWCDatas = item;
        }
        catch (e) { }
      }
    }
    $scope.PHDetails = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/PublicHolidays.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      if ($scope.vm.ServiceStartAt != null && $scope.vm.ServiceStartAt != undefined && $scope.vm.ServiceStartAt != "") {
        var FilterStart_Date = new Date($scope.vm.ServiceStartAt);
        var FilterEnd_Date = new Date($scope.vm.ServiceEndAt);
        FilterStart_Date.setHours(0, 0, 0, 0);
        FilterEnd_Date.setHours(23, 59, 59, 999);
        var response = $http({
          url: $rootScope.WebURL + "/calendar/datefilter",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id, FilterStart_Date: FilterStart_Date, FilterEnd_Date: FilterEnd_Date },
        });
        response.then(function (GList) {
          $scope.PHDetailsdatas = GList.data.data;
        });
      }
      else {
        $http({
          url: $rootScope.WebURL + "/calendar",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Calendardata) {
          $scope.PHDetailsdatas = Calendardata.data.data;
        });
      }
    }
    $scope.GetSummary = function (sm) {
      var days = ''
      var Includes = '';
      if ($scope.Holidays.value == true) { Includes = 'Excludes' }
      if ($scope.Holidays.value == false) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      if (sm == 'FORTNIGHTLY') {
        $scope.Summary = 'Occurs every two week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'MONTHLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'BIMONTHLY') {
        $scope.Summary = 'Occurs every two months ' + $scope.vm.ForBiMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'QUARTERLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForQuaterly + ' month of ' + $scope.vm.ForQuaterlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'HALFYEARLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForHalfYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'YEARLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForYearly + ' month of ' + $scope.vm.ForYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
    }
    $scope.GetSummaryforP = function (ph) {
      var days = ''
      var Includes = '';
      if (ph == false) { Includes = 'Excludes' }
      if (ph == true) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      $scope.Summary = 'Occurs every week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
    }
    $scope.sNewSubmit = function (type, M) {

      if ($scope.vm.Twiceday != null && $scope.selected[0].id === $scope.vm.Twiceday.id) {
        $mdToast.show($mdToast.simple().textContent('Please select different days for Twice of Week!').position('top center'));
      }
      if ($scope.vm.Types == "Contractual" && $scope.NAttachmentdatas.length == 0) {
        $mdToast.show($mdToast.simple().textContent('An attachment is required for job type: Contractual.').position('top center'));
        return
      }

      if (!$scope.vm.ServiceStartAt || !$scope.vm.ServiceEndAt) {
        $mdToast.show($mdToast.simple().textContent('Please add Start and End Dates').position('top center'));
        return
      }
      else {
        $scope.vm.PreviewSpinner = true;
        $http({
          url: $rootScope.WebURL + "/scheduler/checkWorkOrer",
          method: "POST",
          data: { JobsOrders: $scope.vm.jobdata },
        }).then(function (WList) {
          var ServicesRequiredper = 0;
          $scope.vm.CheckWorkOrerCount = WList.data.data;
          if ($scope.vm.ServicesRequired != null && $scope.vm.ServicesRequired != undefined && $scope.vm.ServicesRequired != "") {
            var ServicesRequiredper = parseInt($scope.vm.ServicesRequired);
          }
          setTimeout(function () {
            $scope.vm.PreviewSpinner = false;
            if ($scope.vm.CheckWorkOrerCount > ServicesRequiredper) {
              $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/scheduler/workordercheck.html',
                parent: angular.element($document.body),
                targetEvent: M,
                scope: $scope.$new(),
                controller: function operationsProjectController($scope, $mdDialog) {
                  $scope.closeDialog = function () {
                    $mdDialog.hide();
                  }
                }
              });
            }
            else {
              $scope.SchedulerCalculation(type, M)
              // $scope.CheckWorkOrderYes(M)
            }
          }, 2000)
        });
      }
    }

    $scope.CheckWorkOrderYes = function (M) {
      $scope.vm.PreviewSpinner = true;
      $http.get($rootScope.WebURL + "/scheduler/getLength")
        .then(function (scheduler) {
          var schedulerdatasforlength = scheduler.data.data;
          if (new Date($scope.vm.ServiceStartAt) < new Date()) {
            $scope.vm.ServiceStartAt = new Date();
          }
          $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
          $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
          var previewdata = [];
          $scope.previewdatas = [];
          var oneDay = 24 * 60 * 60 * 1000;
          var datecount = Math.round(Math.abs(($scope.vm.SSAt.getTime() - $scope.vm.SSEt.getTime()) / (oneDay)));
          var daysId = $scope.selected.map(function (obj) { return obj.id; }).join(',');
          var fqw = 1;
          var t = 1;
          var twm = 0;
          angular.forEach($scope.vm.PestType, function (value) {
            try {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return value.PestName == pt.PestName;
              })[0];
              value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
            } catch (e) { }
          })
          var groupedFrequency = _.groupBy($scope.vm.PestType, 'Frequency');
          var Fnum = 0;
          try {
            Fnum = $scope.vm.PestType.map(function (Fnum) {
              return parseInt(Fnum["ServicesRequired"])
            });
            Fnum = Math.max.apply(null, Fnum);
          }
          catch (e) { }
          var Assigned = $scope.vm.AssignedTo.map(function (obj) { return obj.id; }).join(',');
          Assigned = Assigned.split(',')
          angular.forEach(groupedFrequency, function (element) {
            element.Frequency = element[0].Frequency;
            element.PestName = element.map(function (obj) { return obj.PestName; }).join(',');
            element.PestCode = element.map(function (obj) { return obj.PestCode; }).join(',');
            $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
            $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
            for (var i = 0; i <= datecount; i++) {
              if (element.Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || element.Frequency.toUpperCase().indexOf('DAILY') > -1 || element.Frequency.toUpperCase().indexOf('WEEKLY') > -1
                || element.Frequency.toUpperCase().indexOf('1 WEEK') > -1 || element.Frequency.toUpperCase().indexOf('2 WEEKS') > -1 || element.Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1
                || element.Frequency.toUpperCase().indexOf('BIWEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1
                || element.Frequency.toUpperCase().indexOf('10 DAYS') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A WEEK (104)') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A WEEK') > -1
                || element.Frequency.toUpperCase().indexOf('AD-HOC') > -1) {
                var currentDate = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + i));
                if ((element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1) && previewdata.length > 0) {
                  var LastStartsat = new Date(previewdata[previewdata.length - 1].Startsat);
                  // if (LastStartsat.getDate() >= 15) {
                  //   var fday = (new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay() == 0) ? 7 : new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
                  //   var fistdate = (7 - fday) + parseInt($scope.selected[0].id)
                  //   currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), fistdate + 1);
                  // }
                  if (twm >= 2) {
                    i = i + (37 - LastStartsat.getDate());
                    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, fqw, currentDate);
                    twm = 0;
                  }
                }
                var endDate = new Date($scope.vm.SSEt);
                if (currentDate <= endDate) {
                  var SameTeam = 'No';
                  try {
                    angular.forEach($scope.Teamtabledata, function (items) {
                      if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(currentDate, 'dd/MM/yyyy')) {
                        var edd = new Date(items.Startsat);
                        var ehh = $scope.vm.ServiceStartTime;
                        var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        var edd = new Date(items.Startsat);
                        var ehh = $scope.vm.ServiceEndTime;
                        var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        var edd = new Date(items.Startsat);
                        var ehh = new Date(items.Endsat);
                        var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
                          SameTeam = 'Yes';
                        }
                        else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
                          SameTeam = 'Yes';
                        }
                        else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
                          SameTeam = 'Yes';
                        }
                        else if (startTime < EndDate && endTime >= EndDate) {
                          SameTeam = 'Yes';
                        }
                        else {
                          //SameTeam = 'No';
                        }
                      }
                    });
                  }
                  catch (e) { }
                  if (daysId.indexOf(currentDate.getDay()) > -1) {
                    var ServiceOn = $filter('date')(currentDate, 'EEEE');
                    var dd = currentDate;
                    var hh = $scope.vm.ServiceStartTime;
                    var mm = new Date(hh.setMonth(new Date(dd).getMonth()));
                    var yy = new Date(mm.setDate(new Date(dd).getDate()));
                    currentDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    var edd = endDate;
                    var ehh = $scope.vm.ServiceEndTime;
                    var emm = new Date(ehh.setMonth(new Date(edd).getMonth()));
                    var eyy = new Date(emm.setDate(new Date(edd).getDate()));
                    endDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    previewdata.push({
                      PestType: element.PestName,
                      PestCode: element.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: currentDate,
                      Endsat: endDate,
                      Frequency: element.Frequency,
                      SameTeam: SameTeam
                    })
                    if (element.Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || element.Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('2 WEEKS') > -1 || element.Frequency.toUpperCase().indexOf('BIWEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('FORTNIGHTLY (26)') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        i = i + 13;
                      }
                      else { t++; }
                    }
                    if (element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        if ($filter('date')(previewdata[previewdata.length - 1].Startsat, 'MM') == $filter('date')(currentDate, 'MM')) {
                          twm++;
                        }
                        if (twm == 1) {
                          i = i + 7;
                        }
                      }
                      else { t++; }
                    }
                    if (element.Frequency.toUpperCase().indexOf('10 DAYS') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        i = i + 10;
                      }
                      else { t++; }
                    }
                  }
                }
              }
              else {
                angular.forEach($scope.selected, function (value, key) {
                  fqw = 1;
                  // if (key == 0) {
                  //   if ($scope.vm.SSAt.setHours(23, 59, 59, 999) <= new Date().setHours(23, 59, 59, 999)) {
                  //     fqw = ($scope.vm.SSAt.getWeekOfMonth() == 6) ? $scope.vm.SSAt.getWeekOfMonth() - 1 : $scope.vm.SSAt.getWeekOfMonth();
                  //   }
                  // }
                  var wc = (getWeekOfMonth($scope.vm.SSAt) == 6) ? getWeekOfMonth($scope.vm.SSAt) - 1 : getWeekOfMonth($scope.vm.SSAt);
                  fqw = (daysInMonth($scope.vm.SSAt, value.id).length < wc) ? daysInMonth($scope.vm.SSAt, value.id).length : wc;
                  var currentDate = nthWeekdayOfMonth(value.id, fqw, $scope.vm.SSAt);
                  var endDate = new Date($scope.vm.SSEt);
                  if (currentDate <= endDate) {
                    var SameTeam = 'No';
                    try {
                      angular.forEach($scope.Teamtabledata, function (items) {
                        if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(currentDate, 'dd/MM/yyyy')) {
                          var edd = new Date(items.Startsat);
                          var ehh = $scope.vm.ServiceStartTime;
                          var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                          var edd = new Date(items.Startsat);
                          var ehh = $scope.vm.ServiceEndTime;
                          var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                          var edd = new Date(items.Startsat);
                          var ehh = new Date(items.Endsat);
                          var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));
                          if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
                            SameTeam = 'Yes';
                          }
                          else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
                            SameTeam = 'Yes';
                          }
                          else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
                            SameTeam = 'Yes';
                          }
                          else if (startTime < EndDate && endTime >= EndDate) {
                            SameTeam = 'Yes';
                          }
                          else {
                            //SameTeam = 'No';
                          }
                        }
                      })
                    }
                    catch (e) { SameTeam = 'No' }
                    var ServiceOn = $filter('date')(currentDate, 'EEEE');
                    var dd = currentDate;
                    var hh = $scope.vm.ServiceStartTime;
                    var mm = new Date(hh.setMonth(new Date(dd).getMonth()));
                    var yy = new Date(mm.setDate(new Date(dd).getDate()));
                    currentDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    var edd = endDate;
                    var ehh = $scope.vm.ServiceEndTime;
                    var emm = new Date(ehh.setMonth(new Date(edd).getMonth()));
                    var eyy = new Date(emm.setDate(new Date(edd).getDate()));
                    endDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    previewdata.push({
                      PestType: element.PestName,
                      PestCode: element.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: currentDate,
                      Endsat: endDate,
                      Frequency: element.Frequency,
                      SameTeam: SameTeam
                    })
                    if (key == $scope.selected.length - 1) {
                      if (element.Frequency.toUpperCase() == 'MONTHLY' || element.Frequency.toUpperCase().indexOf('MONTHLY (12)') > -1 || element.Frequency.toUpperCase().indexOf('1 MONTH') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 1));
                      }
                      else if (element.Frequency.toUpperCase() == 'BIMONTHLY' || element.Frequency.toUpperCase().indexOf('BI-MONTHLY (6)') > -1 || element.Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1 || element.Frequency.toUpperCase().indexOf('2 MONTHS') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 2));
                      }
                      else if (element.Frequency.toUpperCase() == 'QUARTERLY (4)' || element.Frequency.toUpperCase() == 'QUARTERLY' || element.Frequency.toUpperCase().indexOf('3 MONTHS') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 3));
                      }
                      else if (element.Frequency.toUpperCase() == 'HALF-YEARLY' || element.Frequency.toUpperCase().indexOf('HALFY-EARLY (2)') || element.Frequency.toUpperCase().indexOf('6 WEEKS') > -1 > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 6));
                      }
                      else if (element.Frequency.toUpperCase() == 'YEARLY' || element.Frequency.toUpperCase().indexOf('YEARLY (1)') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 12));
                      }
                    }
                  }
                })
              }
            }
          })
          if ($scope.Holidays.value == true) {
            angular.forEach(previewdata, function (value, key) {
              var HollydayDate = new Date(value.Startsat).setHours(0, 0, 0, 0);
              if ($scope.vm.SFOPH == "Next Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  value.Startsat = new Date(value.Startsat.setDate(value.Startsat.getDate() + 1));
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Previous Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  value.Startsat = new Date(value.Startsat.setDate(value.Startsat.getDate() - 1));
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Skip") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  previewdata.splice(key, 1)
                }
              }
            })
          }
          try {
            previewdata = _.uniqWith(previewdata, _.isEqual);
            var item = previewdata.filter(function (item) {
              return new Date(item.Startsat).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
            var ASchearray = [];
            var PreferDays = ""
            if ($scope.vm.PreferredDays != undefined && $scope.vm.PreferredDays != "" && $scope.vm.PreferredDays != null) {
              $scope.vm.PreferredDays = _.sortBy($scope.vm.PreferredDays, "id")
              PreferDays = $scope.vm.PreferredDays.map(function (obj) { return obj.names; }).join(',');
            }
            else
              PreferDays = ""
            var sd = 0;
            angular.forEach($scope.vm.PestType, function (Freq) {
              var key = 0;
              angular.forEach(item, function (value, index) {
                if (value.Frequency == Freq.Frequency) {
                  key++;
                  if (Freq.ServicesRequired > 0 && key > (Freq.ServicesRequired * $scope.selected.length)) {
                    item.splice(index, 1);
                  }
                }
              })
            });
            angular.forEach($scope.ServiceAddressarray, function (value) {
              angular.forEach(item, function (subvalue, key) {
                var sz = 'SVC-' + ('000000' + (1 + sd + schedulerdatasforlength)).slice(-6);
                var isSameDate = false;
                angular.forEach(ASchearray, function (ditem) {
                  if ($filter('date')(ditem.Startsat, 'dd/MM/yyyy') == $filter('date')(subvalue.Startsat, 'dd/MM/yyyy')
                    && ditem.Frequency != subvalue.Frequency) {
                    try {
                      // var array = (ditem.PestType + ',' + subvalue.PestType).split(',');
                      // var filteredArray = array.filter(function (item, pos) {
                      //   return array.indexOf(item) == pos;
                      // }); 
                      ditem.PestType = ditem.PestType + ',' + subvalue.PestType;
                      ditem.PestCode = ditem.PestCode + ',' + subvalue.PestCode;
                      // ditem.PestType = filteredArray.map(function (obj) { return obj; }).join(',');
                    } catch (e) { }
                    isSameDate = true;
                  }
                })
                if (isSameDate == false) {
                  ASchearray.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: Assigned,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    BillingAmount: $scope.vm.BillingAmount,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    TeamName: $scope.vm.ppTeamName,
                    TeamMembersName: $scope.vm.TM,
                    PreferredTime: PreferDays,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    Message: $scope.vm.Message,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  $scope.previewdatas.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    PreferredTime: $scope.vm.PreferredTime,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    Message: $scope.vm.Message,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  console.log(sd)
                  sd++;
                }
              })
            })
          } catch (e) { }
          $scope.previewGridDatas = ASchearray;
          $scope.AllPreviewGridDatas = ASchearray;
          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/f.html',
            parent: angular.element($document.body),
            targetEvent: M,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
          try {
            var dupitem = [];
            dupitem = ASchearray.filter(function (dupitem) {
              return dupitem.Duplicate === true;
            });
            $scope.vm.DuplicateCount = dupitem.length;
          } catch (e) { }
          $scope.vm.ServiceID = null;
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.vm.PreviewSpinner = false;
          $scope.vm.ShowDuplicate = false;
          $scope.vm.RemoveDuplicate = false;
        });
    }
    $scope.Rpd = function (e, i, t) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/PreviewAlert.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.RemovePData = t;
      $scope.vm.RemovePindex = i;
      if (t == 'RemovePData') { $scope.vm.RemovePTitle = 'Remove'; }
      if (t == 'ReschedulePData') {
        $scope.vm.RemovePTitle = 'Reschedule';
        var today = new Date();
        $scope.vm.RPDservicStime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 30, 0);
        $scope.vm.RPDservicEtime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 17, 30, 0);
      }
    }
    $scope.RemovePData = function (d) {
      try {
        $scope.previewdatas.splice(d, 1);
        $mdDialog.cancel();
      }
      catch (e) { }
    }
    $scope.ReSchedulePData = function (d) {
      try {
        //var dd = new Date($scope.vm.RPDservicat).getDate();
        //var mm = new Date($scope.vm.RPDservicat).getMonth() + 1;
        //var yy = new Date($scope.vm.RPDservicat).getFullYear();
        //var hh = new Date($scope.vm.RPDservicStime).getHours();
        //var ms = new Date($scope.vm.RPDservicStime).getMinutes();
        //new Date(yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms);

        var dd = $scope.vm.RPDservicat;
        var hh = $scope.vm.RPDservicStime;
        var mm = new Date(hh.setDate(new Date(dd).getDate()));
        var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
        var x = new Date(yy.setFullYear(new Date(dd).getFullYear()));

        //var edd = new Date($scope.vm.ServiceEndAt).getDate();
        //var emm = new Date($scope.vm.ServiceEndAt).getMonth() + 1;
        //var eyy = new Date($scope.vm.ServiceEndAt).getFullYear();
        //var ehh = new Date($scope.vm.RPDservicEtime).getHours();
        //var ems = new Date($scope.vm.RPDservicEtime).getMinutes();
        // new Date(eyy + ',' + emm + ',' + edd + ' ' + ehh + ':' + ems);

        var edd = $scope.vm.ServiceEndAt;
        var ehh = $scope.vm.RPDservicEtime;
        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
        var y = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
        var z = x;
        var items = $scope.previewdatas.filter(function (items) {
          return new Date(items.Startsat).setHours(0, 0, 0, 0) == z.setHours(0, 0, 0, 0);
        });
        if (items.length != 0) {
          $mdToast.show($mdToast.simple().textContent('Already Exist!').position('top center'));
        }
        else {
          angular.forEach($scope.previewdatas, function (item, key) {
            if (key == d) {
              var HcurrentDate = new Date(item.Startsat).setHours(0, 0, 0, 0);
              if ($scope.HolidaySelectedon.indexOf(HcurrentDate) > -1) {
                $mdToast.show($mdToast.simple().textContent('Selected date is holiday').position('top center'));
              }
              else {
                item.Startsat = x;
                item.Endsat = y;
              }
            }
          });
          $mdDialog.cancel();
        }
      }
      catch (e) { }
    }
    $scope.ReDo = function () {
      $mdDialog.cancel();
    }
    $scope.NewcommentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/add",
        data: {
          TableRowID: $scope.vm.jobdata,
          TableName: "Scheduler",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.NewComments,
          ModuleID: "",
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        RefreshAllJobComment()
        $mdToast.show($mdToast.simple().textContent('Comment Added Successfully').position('top center'));

      })
    }

    function calculate_estimation_and_end_time() {
      $scope.vm.AEndTime = moment($scope.vm.AStartTime).add($scope.vm.AManHour, 'hours');
    }

    function RefreshAllJobComment() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/comment/getByRequestID",
        data: {
          RequestID: $scope.vm.jobdata,
        },
      });
      response.then(function (GList) {
        var item = GList.data.data.filter(function (item) {
          return item.TableName === 'Scheduler'
        })
        $scope.NewCommentdatas = item
      })
    }

    $scope.vm.PreviewSpinner = false;
    $scope.PreviewConfirm = function () {
      $scope.vm.PreviewSpinner = true;
      $mdDialog.cancel();
      $mdDialog.cancel();
      $scope.previewdatas = $scope.AllPreviewGridDatas;
      if ($scope.vm.RemoveDuplicate === true) {
        var item = [];
        item = $scope.AllPreviewGridDatas.filter(function (item) {
          return item.Duplicate === false;
        })
        $scope.previewdatas = item;
      }
      else {
        $scope.previewdatas = $scope.AllPreviewGridDatas;
      }
      $scope.previewdatas[0].Types = 'Initial Service';
      $scope.previewdatas[0].SpecialRemark = $scope.vm.firstSpecialRemark;
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/addbyarray",
        data: { ServiceArray: $scope.previewdatas },
      }).then(function (List) {
        $scope.vm.PreviewSpinner = false;
        $scope.vm.ServiceID = null;
        $mdToast.show($mdToast.simple().textContent('Successfully Added' + ' ' + $scope.previewdatas.length + ' ' + 'Service Jobs').position('top center'));
        RefreshGrid();
        $scope.getPendingSchedule()
        $scope.pesttypeGrid = true;
        $scope.shedulerform = true;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.exportbtn = true;
        $scope.thdata = false;
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
        $scope.ServiceAddressarray = [];
        var result = DevExpress.ui.dialog.confirm('Do you wish to generate the scheduler calendar?', 'Confirm!');
        result.done(function (dialogResult) {
          if (dialogResult === true) {
            var url = $rootScope.ReportURL + 'Scheduler.aspx' + '?' + 'ID=' + $scope.previewdatas[0].JobsOrders;
            $scope.previewdatas = [];
            window.open(url);
          }
          else
            $scope.previewdatas = [];
        })
      });
    }
    $scope.ShowPhotoinfo = function (e, photo) {
      $scope.uShowImage = photo;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.PhotoBeforeinfo = function (e, id, p) {
      $scope.PhotoBeforeinfoId = id;
      $scope.PhotoBeforeinfoUpdate = true;
      $scope.uCPB = p;
      $scope.uShowImage = p;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.UploadPhotoBefore = function (flow) {
      $scope.CPB1 = document.getElementById('CPB1');
      if ($scope.CPB1.src == null || $scope.CPB1.src == "" || $scope.CPB1.src == undefined) {
        $scope.CPB1 = { src: null };
        if ($scope.uCPB != null || $scope.uCPB != "" || $scope.uCPB != undefined) {
          $scope.CPB1 = { src: $scope.uCPB };
        }
      }

      if ($scope.UpdatePhoto == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletschedulerrecord/UpdatePhoto",
          data: {
            _id: $scope.UploadPhotoid,
            data: $scope.CPB1.src,
            ServiceId: $scope.vm.ScedulId,
            Remarks: $scope.vm.ImgBRemarks,
            Client_Id: $rootScope.Client_Id,
            CreatedBy: $rootScope.CreatedBy
          }
        });
        response.then(function (GList) {
          $scope.vm.flow.files = [];
          flow.cancel();
          $scope.PhotoBeforeinfoUpdate = false;
          $scope.UpdatePhoto = false
          $scope.uCPB = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/AddPhotoOld",
          data: {
            ServiceId: $scope.vm.ScedulId,
            data: $scope.CPB1.src,
            PestType: $scope.vm.ImgBPestType,
            Remarks: $scope.vm.ImgBRemarks,
            Client_Id: $rootScope.Client_Id,
            CreatedBy: $rootScope.CreatedBy
          }
        });
        response.then(function (GList) {
          $scope.vm.flow.files = [];
          flow.cancel();
          $scope.PhotoBeforeinfoUpdate = false;
          $scope.UpdatePhoto = false
          $scope.vm.ImgBRemarks = null;
          $scope.uCPB = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }

    }
    $scope.DeletePhotosBeforeReport = function (id) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/tabletschedulerrecord/DeletePhoto",
        data: {
          _id: id,
          ServiceId: $scope.vm.ScedulId,
        }
      })
      response.then(function (List) {
        $scope.PhotoBeforeinfoUpdate = false;
        $scope.UpdatePhoto = false
        $scope.vm.ImgBRemarks = null;
        $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
        RefreshPhotos();
      })
    }
    $scope.Photoinfo = function (e, id, p) {
      $scope.PhotoinfoId = id;
      $scope.PhotoinfoUpdate = true;
      $scope.uCP = p;
      $scope.uShowImage = p;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.UploadPhoto = function () {
      $scope.CP1 = document.getElementById('CP1');
      if ($scope.CP1.src == null || $scope.CP1.src == "" || $scope.CP1.src == undefined) {
        $scope.CP1 = { src: null };
        if ($scope.uCP != null || $scope.uCP != "" || $scope.uCP != undefined) {
          $scope.CP1 = { src: $scope.uCP };
        }
      }
      if ($scope.PhotoinfoUpdate == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/schedulerpicafter/update",
          data: {
            _id: $scope.PhotoinfoId,
            ServiceId: $scope.vm.ScedulId,
            schimgafter: $scope.CP1.src,
            PestType: $scope.vm.ImgAPestType,
            Remarks: $scope.vm.ImgARemarks,
            CreatedBy: $rootScope.createdBy,
            schimgbefore: null,
          }
        });
        response.then(function (GList) {
          $scope.PhotoinfoUpdate = false;
          $scope.vm.ImgARemarks = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulerpicafter/add",
          data: {
            ServiceId: $scope.vm.ScedulId,
            schimgafter: $scope.CP1.src,
            PestType: $scope.vm.ImgAPestType,
            Remarks: $scope.vm.ImgARemarks,
          }
        });
        response.then(function (GList) {
          $scope.PhotoinfoUpdate = false;
          $scope.vm.ImgARemarks = null;
          $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
    }
    $scope.UpdatePhotosBeforeReport = function (row) {
      $scope.uCPB = row.Path
      $scope.vm.ImgBRemarks = row.Remarks
      $scope.UploadPhotoid = row.id
      $scope.UpdatePhoto = true
    }
    $scope.AddServicesReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Services";
      $scope.vm.ReportEditTtlte = "Add Services";
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.Finding = null;
      $scope.vm.Recommendation = null;
      RefreshRecommendationGrid();
      RefreshFindingGrid();
    }
    $scope.EditServicesReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.Finding = null;
      $scope.vm.Recommendation = null;
      $scope.vm.ReportEditType = "Services";
      $scope.vm.ReportEditTtlte = "Edit Services";
      $scope.SMId = item.id;
      $scope.vm.SMPestType = item.PestType;
      try {
        if (item.Services != null && item.Services != "" && item.Services != undefined) {
          var array = item.Services.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Servicetype: value });
          });
          $scope.vm.MServicetype = array1;
        }
      } catch (e) { }
      try {
        if (item.Finding != null && item.Finding != "" && item.Finding != undefined) {
          var array = item.Finding.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Description: value });
          });
          $scope.vm.Finding = array1;
        }
      } catch (e) { }
      try {
        if (item.Recommendation != null && item.Recommendation != "" && item.Recommendation != undefined) {
          var array = item.Recommendation.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Description: value });
          });
          $scope.vm.Recommendation = array1;
        }
      } catch (e) { }
      RefreshRecommendationGrid();
      RefreshFindingGrid();

    }
    $scope.EditInfestationReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Edit Infestation";
      $scope.vm.ReportEditTtlte = "Edit Infestation";
      $scope.InfestationPest = $scope.Materialsdatas
      if ($scope.Materialsdatas.length == 0) {
        var Pest = $scope.vm.PestType1.split(',')
        var PEstType = []
        angular.forEach(Pest, function (List) {
          PEstType.push({
            PestType: List,
            InvestationLevel: 'Nil'
          })
        })
        $scope.InfestationPest = PEstType
      }
    }

    $scope.SubmitInfestation = function () {
      var len = $scope.InfestationPest.length
      angular.forEach($scope.InfestationPest, function (item, key) {
        var id = null
        if (item.id != null && item.id != undefined)
          id = item.id
        $http({
          method: 'PUT',
          url: $rootScope.WebURL + '/infestation/upsert',
          data: {
            _id: id,
            ServiceID: $scope.vm.ScedulId,
            PestType: item.PestType,
            Infestationlevel: item.InvestationLevel
          }
        })
        if (key == len - 1) {
          $mdDialog.cancel();
          $scope.Materialsdatas = $scope.InfestationPest
        }
      })

    }
    $scope.EditMaterialReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.MLSMPestType = null;
      $scope.vm.MMaterialsName = null;
      $scope.vm.MQuantity = null;
      $scope.vm.MUnit = null;
      $scope.vm.MDilution = null;
      $scope.vm.ReportEditType = "Materials";
      $scope.vm.ReportEditTtlte = "Edit Materials";
      $scope.SMLMId = item.id;
      try {
        $scope.vm.MLSMPestType = item.PestType;
        $scope.vm.MMaterialsName = item.MaterialName;
        $scope.vm.Dilution = item.Dilution;
        $scope.vm.Unit = item.Unit;
        $scope.vm.Quantity = parseInt(item.Quantity);
      } catch (e) { }

    }
    $scope.SubmitMaterialsReport = function (e) {
      if ($scope.vm.ReportEditTtlte == 'Edit Materials') {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletMaterials/update",
          data: {
            _id: $scope.SMLMId,
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            Dilution: $scope.vm.MDilution,
            UpdatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $scope.vm.MDilution = null;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshMobileLogMaterials();
        });

      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletMaterials/add",
          data: {
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            Dilution: $scope.vm.MDilution,
            CreatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $scope.vm.MDilution = null;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
    }
    $scope.EditPhotoBeforeReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.UpdatePhoto = false
      $scope.vm.MLSMPestType = null;
      $scope.uCPBt = null;
      $scope.uCPB = null;
      $scope.vm.ImgBRemarks = null;
      $scope.vm.ReportEditType = "Photo Before";
      $scope.vm.ReportEditTtlte = "Edit Photo Before";
    }
    $scope.EditPhotoAfterReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.MLSMPestType = null;
      $scope.uCPBt = null;
      $scope.vm.ReportEditType = "Photo After";
      $scope.vm.ReportEditTtlte = "Edit Photo After";
    }
    $scope.EditReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Edit Report";
      $scope.vm.ReportEditTtlte = "Edit Report";
      angular.forEach($scope.Tabletschedulerrecord, function (value) {
        try {
          if ($scope.vm.ScedulId === value.ServiceId) {
            $scope.vm.tbsc_id = value._id
            $scope.vm.Pesttype = value.Pesttype
            if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
              var array = $scope.vm.Pesttype.split(",");
              var array1 = [];
              angular.forEach(array, function (value) {
                array1.push({ PestName: value });
              });
              $scope.Pestdatas = array1;
            }
            $scope.vm.PerformedBy = value.TeamLead;
            if (value.TeamMember != null && value.TeamMember != "" && value.TeamMember != undefined) {
              var array = value.TeamMember.split(",");
              var array1 = [];
              angular.forEach(array, function (value) {
                array1.push({ EmployeeName: value });
              });
              $scope.vm.CoTechnicians = array1;
            }
            $scope.vm.TeamSignature = value.TeamSignature;
            $scope.vm.Paymentmethod = value.Paymentmethod;
            $scope.vm.PaymentRemarks = value.PaymentRemarks;
            $scope.vm.PaymentNotes = value.PaymentNotes;
            $scope.vm.BreedingFound = value.BreedingFound;
            $scope.vm.Species = value.Species;
            $scope.vm.Findings = value.Findings;
            $scope.vm.MistingCariedOut = value.MistingCariedOut;
            $scope.vm.Instar = value.Instar;
            $scope.vm.AServiceStartAt = new Date(value.Startsat);
            $scope.vm.AServiceEndAt = new Date(value.Endsat);
            $scope.vm.Totalarea = parseInt(value.Totalarea);
            $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
            $scope.vm.Totalpayment = parseInt(value.Totalpayment);
            $scope.vm.Density = parseInt(value.Density);
          }
        }
        catch (e) { }
      })
    }

    $scope.getTeamTable = function (TeamId) {
      if (TeamId != undefined) {
        var TeamID = TeamId.map(function (obj) { return obj.id; }).join(',');
        $scope.vm.TM = _.uniq(TeamId.map(function (obj) { return obj.TeamMembers; }).join(',').split(','))
        $scope.vm.ppTeamName = TeamId.map(function (obj) { return obj.TeamName; }).join(',');
        $scope.vm.TeamEstimationHr = ($scope.vm.EstimationHr / TeamId.length) % 1 == 0 ? $scope.vm.EstimationHr / TeamId.length : ($scope.vm.EstimationHr / TeamId.length).toFixed(2)
        $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
      }
      else {
        var TeamID = []
        $scope.vm.TM = null
        $scope.vm.ppTeamName = null
      }
      try {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getTeamforDate",
          method: "POST",
          data: {
            Start_Date: $scope.vm.ServiceStartAt, End_Date: $scope.vm.ServiceEndAt,
            Client_Id: $rootScope.Client_Id, Team_Id: TeamID
          },
        });
        response.then(function (GList) {
          var Fteam = GList.data.data;
          $scope.Teamtabledata = Fteam;
        });
      }
      catch (e) { }
    }

    function getTeamTableforCustomSchedule() {
      var TeamId = $scope.vm.AAssignedTo
      $scope.vm.EstimationHr = $scope.vm.AManHour
      $scope.vm.ServiceStartTime = $scope.vm.AStartTime
      if (TeamId != undefined) {
        var TeamID = TeamId.map(function (obj) { return obj.id; }).join(',');
        $scope.vm.TM = _.uniq(TeamId.map(function (obj) { return obj.TeamMembers; }).join(',').split(','))
        $scope.vm.ppTeamName = TeamId.map(function (obj) { return obj.TeamName; }).join(',');
        $scope.vm.TeamEstimationHr = ($scope.vm.EstimationHr / TeamId.length) % 1 == 0 ? $scope.vm.EstimationHr / TeamId.length : ($scope.vm.EstimationHr / TeamId.length).toFixed(2)
        $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
      }
      else {
        var TeamID = []
        $scope.vm.TM = null
        $scope.vm.ppTeamName = null
      }
      try {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getTeamforDate",
          method: "POST",
          data: {
            Start_Date: $scope.vm.ServiceStartAt, End_Date: $scope.vm.ServiceEndAt,
            Client_Id: $rootScope.Client_Id, Team_Id: TeamID
          },
        });
        response.then(function (GList) {
          var Fteam = GList.data.data;
          $scope.Teamtabledata = Fteam;
        });
        return response
      }
      catch (e) { }

    }

    $scope.AddMobileLogMaterials = function () {
      //$http({
      //    method: "POST",
      //    url:  $rootScope.WebURL + "/tabletMaterials/delete",
      //    data: { Service_Id: $scope.vm.ScedulId }, 
      //}).then(function (TSdata) {
      //});
      if ($scope.vm.SMLMUpdate == false) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletMaterials/add",
          data: {
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            CreatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
      else if ($scope.vm.SMLMUpdate == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletMaterials/update",
          data: {
            _id: $scope.SMLMId,
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            UpdatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
    }
    $scope.MobileLogMaterialinfo = function (item) {
      $scope.vm.SMLMUpdate = true;
      $scope.SMLMId = item.id;
      $scope.vm.MLSMPestType = item.PestType;
      $scope.vm.MMaterialsName = item.MaterialName;
      $scope.vm.MQuantity = parseFloat(item.Quantity);
      $scope.vm.MUnit = item.Unit;
    }
    $scope.ChangeDate = function (Type) {
      if (Type == 'less') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
        $scope.uTo = new Date($scope.uFrom);
      }
      if (Type == 'greater') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
        $scope.uTo = new Date($scope.uFrom);
      }
    }
    $scope.RevertPopup = function (r, Id, ServiceID) {
      $scope.vm.RevertId = Id;
      $scope.vm.RevertServiceID = ServiceID;
      $scope.vm.EditTeamdiv = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/RevertPopup.html',
        parent: angular.element($document.body),
        targetEvent: r,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.RevertSubmit = function () {
      $http({
        url: $rootScope.WebURL + "/scheduler/Statusupdate",
        method: "PUT",
        data: {
          _id: $scope.vm.RevertId,
          Status: "Yet to Start",
          UpdatedBy: $rootScope.createdby,
        },
      }).then(function (GList) {
        $http({
          url: $rootScope.WebURL + "/tabletschedulerrecord/delete",
          method: "PUT",
          data: {
            ServiceId: $scope.vm.RevertId,
          },
        }).then(function (GList) {
        })
        $mdDialog.cancel();
        $scope.NewGetByStatus();
      });
    }
    $scope.EditTeam = function (r, item) {
      $scope.vm.EditTeamdiv = true;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/RevertPopup.html',
        parent: angular.element($document.body),
        targetEvent: r,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ServiceId = item._id;
      $scope.vm.ServiceID = item.ServiceID;
      $scope.vm.TeamName = item.TeamName;
      $scope.vm.TeamMembers = item.TeamMembersName;
      $scope.vm.CustomerName = item.customerdetails[0].CompanyName || row.AdhocCustomerName;
      $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
      $scope.vm.Team_id = null;
      $scope.vm.TM = null;
      var item = $scope.teamdatas.filter(function (item) {
        return $scope.vm.TeamName.includes(item.TeamName)
      })
      $scope.vm.Team_id = item
      $scope.vm.TeamLead = item.map(function (obj) { return obj.TeamLead }).join(',')
    }
    $scope.TeamEditSubmit = function () {
      var Team = $scope.vm.Team_id.map(function (obj) { return obj.id })
      $http({
        url: $rootScope.WebURL + "/scheduler/updateteam",
        method: "PUT",
        data: {
          _id: $scope.vm.ServiceId,
          AssignedTo: Team,
          TeamName: $scope.vm.ppTeamName,
          TeamMembersName: $scope.vm.TM,
          UpdatedBy: $rootScope.createdby,
        },
      }).then(function (GList) {
        $mdDialog.cancel();
        $scope.vm.Team_id = null;
        $scope.vm.TM = null;
        $scope.vm.ServiceId = null;
        $scope.vm.ServiceID = null;
        $scope.vm.TeamName = null;
        $scope.vm.TeamLead = null;
        $scope.vm.TeamMembers = null;
        $scope.vm.CustomerName = null;
        $scope.vm.SalesOrderNo = null;
        $scope.NewGetByStatus();
      });
    }
    $scope.GetLatlong = function () {
      angular.forEach($scope.ServiceAddressarray, function (value) {
        var getLocation = "";
        if (value.sBLK != "" && value.sBLK != null && value.sBLK != undefined) {
          getLocation = value.sBLK;
        }
        if (value.sUnit != "" && value.sUnit != null && value.sUnit != undefined) {
          getLocation = getLocation + " " + value.sUnit;
        }
        if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
          getLocation = getLocation + " " + value.sBuildingName;
        }
        if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
          getLocation = getLocation + " " + value.sStreetName;
        }
        if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
          getLocation = getLocation + " " + value.sPostal;
        }
        var address = getLocation;
        value.LatLong = "103.8677,1.3554";
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
            }
          });
        }
        value.getLocation = getLocation;
      })
      $mdDialog.cancel();
    }
    $scope.ShowScheduled = function (ShowScheduled) {
      if (ShowScheduled == true) {
        $scope.vm.ShowScheduledStatus = "Scheduled"
      } else {
        $scope.vm.ShowScheduledStatus = "New"
      }
    }
    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }], dataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $scope.ShowDuplicate = function (value) {
      if (value === true) {
        var item = [];
        item = $scope.previewGridDatas.filter(function (item) {
          return item.Duplicate === true;
        });
        $scope.previewGridDatas = item
      }
      else {
        $scope.previewGridDatas = $scope.AllPreviewGridDatas;
      }
    }
    // End function for new design..............

    $scope.viewCustomerInfo = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomerInfo.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.Customersearch = null;
      $scope.vm.uContactPerson = null;
      $scope.vm.CustomerID = null;
      $scope.vm.Location = null;
      $scope.CustomerServicedatas = [];
    }
    $scope.GetCinfo = function (item) {

      $scope.vm.uCustomerType = item.CustomerType;
      $scope.RequestID = item.CustomerID;
      $scope.vm.uPostal = item.Postal;
      $scope.vm.uCountry = item.Country;
      $scope.vm.uContactPerson = item.ContactPerson;
      $scope.vm.ppCompanyName = item.CompanyName;
      $scope.vm.BLK = item.BLK;
      $scope.vm.Unit = item.Unit;
      $scope.vm.StreetName = item.StreetName;
      $scope.vm.BuildingName = item.BuildingName;
      $scope.vm.FixedTeam = item.FixedTeam;
      $scope.vm.FixedTeamdata = item.FixedTeamdata;
      try {
        $scope.vm.ClientEmail = item.Email.replace(',', ', ')
      }
      catch (e) { }
      CustomerServicedatadetails();
    }
    $scope.ViewSchedule = function (e, TeamId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/scheduleview.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.TeamFilterId = TeamId;
      try {
        var item = $scope.teamdatas.filter(function (item) {
          return item.id === TeamId;
        })[0];
        $scope.vm.sTeamName = item.TeamName;
        $scope.vm.sTeamLead = item.TeamLead;
      }
      catch (e) { }
    }
    $scope.getNewDate = function (d) {
      if (d != null && d != undefined && d != "") {
        try {
          $scope.vm.ServiceStartAt = new Date(d);
          $scope.vm.ServiceEndAt = new Date(d.setDate(new Date(d).getDate() + $scope.skippeddatas.length - 1));
        }
        catch (e) { }
      }
    }
    $scope.sSubmit = function (e) {
      if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
        $scope.vm.sPestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
      }
      var Team = $scope.vm.UTeam.map(function (obj) { return obj.id; }).join(',');
      Team = Team.split(',')
      if ($scope.Update == true) {
        var dd = $scope.vm.ResheduleFrom;
        var hh = $scope.vm.ResheduleStartTime;
        var ehh = $scope.vm.ResheduleEndTime;

        $scope.vm.schusdateTime = combineDateAndTime(dd, hh);
        $scope.vm.schuedateTime = combineDateAndTime(dd, ehh);

        var currentDate = new Date($scope.vm.schusdateTime);
        var enddate = new Date($scope.vm.schuedateTime);
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/forReschedule",
          data: {
            _id: $scope.SID,
            AssignedTo: $scope.vm.AssignedTo,
            Start_Date: currentDate,
            End_Date: enddate,
          },
        }).then(function (GList) {
          var CheckforReschedule = GList.data.data;
          $scope.CheckReschedule = false;
          angular.forEach(CheckforReschedule, function (item) {
            var edd = new Date($scope.vm.ResheduleFrom);
            var ehh = new Date(item.Endsat);
            var emm = new Date(ehh.setDate(new Date(edd).getDate()));
            var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
            item.Endsat = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
            if (new Date(item.Startsat) < currentDate && currentDate < new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            if (new Date(item.Startsat) < enddate && enddate < new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            if (new Date(item.Startsat) >= currentDate && enddate > new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            var St = $filter('date')(currentDate, 'dd/MM/yyyy hh:mm a');
            var Et = $filter('date')(enddate, 'dd/MM/yyyy hh:mm a');
            var dbSt = $filter('date')(new Date(item.Startsat), 'dd/MM/yyyy hh:mm a');
            var dbEt = $filter('date')(new Date(item.Endsat), 'dd/MM/yyyy hh:mm a');
            if (St == dbSt && Et == dbEt) {
              $scope.CheckReschedule = true;
            }
          });
          $scope.Emails = null;
          if ($scope.Reschedule.value == true) {
            var array = [];
            var createdBy = null;
            var teamLead = null;
            var teamMember = null;
            try {
              var gItem = $scope.Uniqueschedulerdatas.filter(function (item) {
                return $scope.SID === item._id;
              })[0];
              createdBy = gItem.CreatedBy;
              teamLead = gItem.teamdetails[0].TeamLead;
              teamMember = gItem.teamdetails[0].TeamMembers;
            } catch (error) { }
            angular.forEach($scope.Userdatas, function (uvalue) {
              if (createdBy.indexOf(uvalue.UserID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
              if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
              if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
            })
            if (array.length > 0) {
              var SenderEmails = [];
              $scope.Emailgroups = _.groupBy(array, 'EmailId');
              angular.forEach($scope.Emailgroups, function (value) {
                SenderEmails.push(value[0].EmailId);
              });
              $scope.Emails = SenderEmails;
            }
          }
          $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
          $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
          $http({
            method: "PUT",
            url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
            data: {
              _id: $scope.SID,
              ServiceOn: $scope.ServiceOn,
              Startsat: currentDate,
              Endsat: enddate,
              ResheduleRemarks: $scope.vm.ResheduleRemarks,
              SenderEmailAddress: $scope.Emails,
              CompanyName: $scope.vm.CompanyName,
              ScheduleFromDate: $scope.vm.ServiceStartAtlog,
              UpdatedBy: $rootScope.createdby,
              AssignedTo: Team[0],
              Team_Id: Team,
              TeamName: $scope.vm.ppTeamName,
              TeamMembersName: $scope.vm.TM,
              IsActive: true
            },
          }).then(function (GList) {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/schedulerNotification/add",
              data: {
                ServiceId: $scope.SID,
                ServiceID: $scope.vm.ServiceID,
                CustomerName: $scope.vm.CompanyName,
                Status: $scope.status,
                PreviousStartsat: $scope.vm.ServiceStartAtlog,
                PreviousEndsat: $scope.vm.ServiceEndAtlog,
                Startsat: currentDate,
                Endsat: enddate,
                PestType: $scope.vm.PestType1,
                TeamName: $scope.vm.TeamName,
                TeamLead: $scope.vm.Teammemberdata,
                TeamMember: $scope.vm.Teammemberdata,
                Acknowledged: null,
                AcknowledgedBy: null,
                CreatedBy: $rootScope.createdby,
                IsActive: true
              },
            }).then(function (GList) {
            });
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/schedulelog/add",
              data: {
                Client_Id: $rootScope.Client_Id,
                JobsOrders: $scope.vm.jobdata,
                Customer: $scope.vm.CustomerID,
                AssignedTo: $scope.vm.AssignedTo,
                Frequency: $scope.vm.Frequency,
                ServiceOn: $scope.ServiceOn,
                Types: $scope.vm.Types,
                Status: "Yet to Start",
                Startsat: $scope.vm.ServiceStartAtlog,
                Endsat: $scope.vm.ServiceEndAtlog,
                ScheduledStartsat: currentDate,
                ScheduledEndsat: enddate,
                PestType: $scope.vm.PestType1,
                ContractOrder: $scope.vm.ContractOrder,
                ServiceID: $scope.vm.ServiceID,
                ResheduleRemarks: $scope.vm.ResheduleRemarks,
                CreatedBy: $rootScope.createdby,
                IsActive: true,
              },
            }).then(function (GList) {
              if ($scope.vm.SelectedTab == 'Outstanding') {
                $scope.getOutsatnding();
              }
              else { RefreshGrid(); }
              $mdDialog.cancel();
              $scope.pesttypeGrid = true;
              $scope.shedulerform = true;
              $scope.addbtn = true;
              $scope.viewbtn = false;
              $scope.exportbtn = true;
              $scope.thdata = false;
              $scope.schedulartab = true;
              $mdDialog.cancel();
              $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
            });
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        });
      }
    }
    $scope.commentSubmit = function () {
      $scope.File_id = $scope.vm.ScedulId;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          SchedulerID: $scope.vm.ScedulId,
          SalesOrderID: $scope.vm.jobdata,
          CustomerID: $scope.vm.Customer_Id,
          TableName: 'Scheduler',
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          CreatedBy: $rootScope.createdby, IsActive: "true",
        },
      });
      response.then(function (GList) {
        Refreshcomment();
        $scope.vm.Addcomments = '';
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.NcommentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          SalesOrderID: $scope.vm.jobdata,
          CustomerID: $scope.vm.Customersearch,
          TableName: 'Scheduler',
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.NAddcomments,
          CreatedBy: $rootScope.createdby, IsActive: "true",
        },
      });
      response.then(function (GList) {
        var response = $http({
          url: $rootScope.WebURL + "/schedulercomment/getByCustomer",
          method: "POST",
          data: { RequestID: $scope.vm.Customersearch },
        });
        response.then(function (Commentdata) {
          $scope.NCommentdatas = Commentdata.data.data;
        });
        $scope.vm.NAddcomments = '';
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.Uploadfiles = function (file) {
      $scope.File_id = $scope.vm.ScedulId;
      var file = file[0].file
      var response = Upload.upload({
        url: $rootScope.WebURL + "/scheduler/upload",
        data: { file: file }
      }).then(function (resp) {
        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID, TableName: "Operations", FileID: $scope.vm.jobdata,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize, FileType: $scope.fileType,
              ModuleID: $scope.Path, Data: null, IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            RefreshAttachmentGrid();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.printToCart = function (Sanitation) {
      var innerContents = document.getElementById(Sanitation).innerHTML;
      var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
      popupWinindow.document.close();
    };
    $scope.printService = function (service) {
      var myPdfUrl = $rootScope.DownloadURL + $scope.vm.ServiceID + '.pdf';
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/DownloadServiceReport",
        data: {
          _id: $scope.vm.ScedulId,
          ServiceID: $scope.vm.ServiceID
        },
      });
      response.then(function (GList) {
        setTimeout(function () {
          $window.open(myPdfUrl, '_blank');
        }, 3000);
      });
      alert("Report will be opened in new window. You may have to wait for a while as the system generating the PDF. Please change your settings to allow the popup window for this URL. !")
      //var url =  $rootScope.ReportURL + 'Service.aspx' + '?' + 'ID=' + $scope.vm.ScedulId;
      //window.open(url) 
    };
    $scope.printServiceWeb = function (service) {
      var url = $rootScope.ReportURL + 'Service.aspx' + '?' + 'ID=' + $scope.vm.ScedulId;
      window.open(url);
    };


    $scope.printWork = function (Work) {
      var innerContents = document.getElementById(Work).innerHTML;
      var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
      popupWinindow.document.close();
    };

    $scope.Showlocation = function (e, Latitude) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/MapView.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      NgMap.getMap().then(function (map) {
        vm.map = map;
      });
      $scope.CenterMapView = [];
      vm.stores = [];
      var array = Latitude.split(",");
      // angular.forEach($scope.YettoStartdatas, function (Mapviewprog) {
      // if (Mapviewprog.customerdetails.length > 0) {
      var lati = 1.3554;
      var lngi = 103.8677;
      // if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
      // var array = Mapviewprog.LatLong.split(",");
      lati = parseFloat(array[0]);
      lngi = parseFloat(array[1]);
      if ($scope.CenterMapView.length == 0) {
        $scope.CenterMapView = [lati, lngi];
      }
      // }
      var lat = lati + (Math.random() / 100);
      var lng = lngi + (Math.random() / 100);
      vm.stores.push({
        position: [lat, lng],
        items: [{
          ServiceId: $scope.vm.ServiceID,
          Customer: $scope.vm.CompanyName,
          Team: $scope.vm.TeamName,
          Time: $filter('date')(new Date($scope.vm.ATimeIn), 'hh:m a') + " - " + $filter('date')(new Date($scope.vm.ATimeOut), 'hh:m a'),
        }],
      })
      // }
      if ($scope.CenterMapView.length == 0) {
        $scope.CenterMapView = [1.3554, 103.8677];
      }
      vm.showStore = function (evt, storeId) {
        vm.store = vm.stores[storeId];
        vm.map.showInfoWindow('foo', this);
      };
      vm.mouseover = function () {
        console.log('mouseover');
      };
    }

    $scope.thdata = false;
    $scope.shouldDateBeShown = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        $scope.uTo = new Date(uTimeOut);
        var secondDate = $scope.uTo;
        if (firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)) {
          return 'Expiried'
        }
        else {
          var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
          if (res == 0) {
            return 'Expiried'
          }
          else {
            return res;
          }
        }
      }
      else { return null }
    }
    $scope.splice = function (event) {
      $scope.vm.events = "";
      $scope.thdata = false;
      $scope.schedulartab = true;
    }

    $scope.Today = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      $scope.uFrom = new Date();
      $scope.uTo = new Date();
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);

    }
    $scope.lastweek = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var d = new Date();
      var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
      var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = new Date(from);
      $scope.uTo = new Date(to);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }
    $scope.NextWeek = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var d = new Date();
      var dayIndex = [1];
      var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
      var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = new Date(from);
      $scope.uTo = new Date(to);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);

    }
    $scope.NextMonth = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      firstDay = $filter('date')(firstDay);
      lastDay = $filter('date')(lastDay);
      $scope.uFrom = new Date(firstDay);
      $scope.uTo = new Date(lastDay);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }
    $scope.lastmonth = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var now = new Date();
      var nowDayOfWeek = now.getDay();
      var nowDay = now.getDate();
      var nowMonth = now.getMonth();
      var nowYear = now.getFullYear();
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastYear = lastMonthDate.getFullYear();
      var lastMonth = lastMonthDate.getMonth();
      var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
      var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
      lastMonthStartDate = $filter('date')(lastMonthStartDate);
      lastMonthEndDate = $filter('date')(lastMonthEndDate);
      $scope.uFrom = new Date(lastMonthStartDate);
      $scope.uTo = new Date(lastMonthEndDate);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }

    $scope.jobname = false;
    $scope.showjoblist = function () {
      $scope.jobname = true;
      if ($scope.vm.jobdata == "" | $scope.vm.jobdata == null) {
        $scope.jobname = false;
      }
    }
    $scope.jobval = function (name, customer) {
      var str = name;
      $scope.vm.jobdata = name;
      $scope.customer = customer;
      $scope.jobname = false;

    }
    $scope.Holidays = { value: false }
    $scope.contacts = [{
      'id': 1,
      'Name': 'Daily',

    }, {
      'id': 2,
      'Name': 'Weekly',

    }, {
      'id': 3,
      'Name': 'Fortnightly',

    }, {
      'id': 4,
      'Name': 'Monthly',

    }, {
      'id': 5,
      'Name': 'Quarterly',

    }, {
      'id': 6,
      'Name': 'Half-Yearly',

    }, {
      'id': 7,
      'Name': 'Yearly',

    }];
    $scope.Typeslist = [{
      'id': 1,
      'TyName': 'Follow-up',

    }, {
      'id': 2,
      'TyName': 'Routine',

    }, {
      'id': 3,
      'TyName': 'Non-Contractual',

    },
    {
      'id': 4,
      'TyName': 'Feedback',

    }, {
      'id': 5,
      'TyName': 'FOC',

    }];
    $scope.items = [
      { id: 1, names: 'Monday' },
      { id: 2, names: 'Tuesday' },
      { id: 3, names: 'Wednesday' },
      { id: 4, names: 'Thursday' },
      { id: 5, names: 'Friday' },
      { id: 6, names: 'Saturday' },
      { id: 0, names: 'Sunday' },
    ];
    $scope.Prefitems = [
      { id: 1, names: 'Mon' },
      { id: 2, names: 'Tue' },
      { id: 3, names: 'Wed' },
      { id: 4, names: 'Thur' },
      { id: 5, names: 'Fri' },
      { id: 6, names: 'Sat' },
      { id: 0, names: 'Sun' },
    ];
    $scope.dayitem = [
      { id: 1, names: 'Mon' },
      { id: 2, names: 'Tue' },
      { id: 3, names: 'Wed' },
      { id: 4, names: 'Thur' },
      { id: 5, names: 'Fri' },
      { id: 6, names: 'Sat' },
      { id: 0, names: 'Sun' },
    ];
    $scope.selected = [{ id: 0, names: 'Sunday' }];
    $scope.vm.Twiceday = null
    $scope.toggle = function (item, list, e) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
      var count = 0
      $scope.vm.PestType.filter(function (item) {
        if (item.Frequency.includes('Twice a Week')) {
          count++
        }
      })
      // if($scope.vm.Twiceday!=null && $scope.items[0].id===$scope.vm.Twiceday.id) $scope.vm.Twiceday=null
      $scope.dayitem1 = _.differenceBy($scope.items, list, "id")
      $scope.dayitem2 = _.differenceBy($scope.items, list, "id")
      if (count > 0 && $scope.vm.Twiceday == null) {
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          controller: function operationsProjectController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
        $scope.vm.Tittle = "Select Other Day for Twice a Week"
      }
      //if (list.length > 5) {
      //    $mdDialog.show({
      //        multiple: true,
      //        templateUrl: 'app/main/apps/operations/scheduler/ServiceOnalert.html',
      //        parent: angular.element($document.body),
      //        targetEvent: e,
      //        scope: $scope.$new(),
      //        controller: function operationsProjectController($scope, $mdDialog) {
      //            $scope.closeDialog = function () {
      //                $mdDialog.hide();
      //            }
      //        }
      //    });
      //}
      var days = ''
      var Includes = '';
      if ($scope.Holidays.value == true) { Includes = 'Excludes' }
      if ($scope.Holidays.value == false) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      if ($scope.vm.ForMonthly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForBiMonthly != '') {
        $scope.Summary = 'Occurs every two months ' + $scope.vm.ForBiMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForHalfYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForQuaterlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForHalfYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForHalfYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForYearly + ' month of ' + $scope.vm.ForYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForBiWeekly != '') {
        $scope.Summary = 'Occurs every two weeks on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else {
        $scope.Summary = 'Occurs every week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
    };
    $scope.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };
    $scope.isIndeterminate = function () {
      return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.items.length);
    };
    $scope.isChecked = function () {
      return $scope.selected.length === $scope.items.length;
    };
    $scope.toggleAll = function (e) {
      if ($scope.selected.length === $scope.items.length) {
        $scope.selected = [];
      } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = $scope.items.slice(0);
        //$mdDialog.show({
        //    multiple: true,
        //    templateUrl: 'app/main/apps/operations/scheduler/ServiceOnalert.html',
        //    parent: angular.element($document.body),
        //    targetEvent: e,
        //    scope: $scope.$new(),
        //    controller: function operationsProjectController($scope, $mdDialog) {
        //        $scope.closeDialog = function () {
        //            $mdDialog.hide();
        //        }
        //    }
        //});
      }
    };
    $scope.NoNotAll = function () {
      $mdDialog.cancel();
      return $scope.selected.length = [];
    }
    $scope.FilterByTeam = function (FC, FT, FZ) {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      if (FC != undefined && FC != null || FT != undefined && FT != null) {
        var FilteredData = null;
        if (FC != undefined && FC != null && FT != undefined && FT != null) {
          var FilterByTeam = $scope.Uniqueschedulerdatas.filter(function (FilterByTeam) {
            return FT.indexOf(FilterByTeam.AssignedTo) > -1 && FC.indexOf(FilterByTeam.Customer) > -1;
          });
          FilteredData = FilterByTeam;
        }
        if (FC == undefined || FC == null || FC == "") {
          var FilterByTeam = $scope.Uniqueschedulerdatas.filter(function (FilterByTeam) {
            return FT.indexOf(FilterByTeam.AssignedTo) > -1;
          });
          FilteredData = FilterByTeam;
        }
        if (FT == undefined || FT == null || FT == "") {
          var FilterByC = $scope.Uniqueschedulerdatas.filter(function (FilterByC) {
            return FC.indexOf(FilterByC.Customer) > -1;
          });
          FilteredData = FilterByC;
        }
        var yet = FilteredData.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = FilteredData.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        $scope.MobileInProgressdatas = InProgres;
        var completed = FilteredData.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;
        var datapush = [];
        angular.forEach(FilteredData, function (value) {
          try {
            if (value.Contracterdetails[0] != null && value.Contracterdetails[0] != '' && value.Contracterdetails[0] != undefined) {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Contract : ' + value.Contracterdetails[0].ContractReferenceNo,
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true, resizable: true,
              });
            }
            else {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;',
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true, resizable: true,
              });
            }
          } catch (error) {
          }
        })
        $scope.calenderdata = datapush;
      }
    }
    $scope.Datefilter = function (FC, FT, FZ) {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") {
        $scope.vm.filtercustomer = null
      }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") {
        $scope.vm.filterteam = null
      }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: $scope.vm.filtercustomer,
          Team_Id: $scope.vm.filterteam
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.AllScheduleDatas = GList.data.data;
        $scope.Uniqueschedulerdatas = GList.data.data;
        var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = $scope.Uniqueschedulerdatas.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        $scope.MobileInProgressdatas = InProgres;
        var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;

        var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
          return adhoc.AdhocType === "Adhoc";
        });
        $scope.AdhocJobsdatas = adhoc;
        var datapush = [];
        angular.forEach($scope.Uniqueschedulerdatas, function (value) {
          try {
            datapush.push({
              title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
              startsAt: new Date(value.Startsat),
              endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
              id: value._id,
              draggable: true,
              resizable: true,
            });
          } catch (error) { }
        })
        $scope.calenderdata = datapush;
      });
    }
    $scope.DatefilterMulti = function (FC, FT) {
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      if (FC != null && FC != "" && FC != undefined) {
        FC = FC.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: null,
          Team_Id: null
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType; var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.AllScheduleDatas = GList.data.data;
        $scope.Uniqueschedulerdatas = GList.data.data;
        if (FC != null && FC != undefined && FC != "" && FT != null && FT != undefined && FT != "") {
          var item = $scope.Uniqueschedulerdatas.filter(function (item) {
            return FC.indexOf(item.Customer) > -1 && FT.indexOf(item.AssignedTo) > -1;
          });
          $scope.Uniqueschedulerdatas = item;
        } else if (FC != undefined && FC != null && FC != "") {
          if (FT == undefined || FT == null || FT == "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FC.indexOf(item.Customer) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
        } else if (FT != undefined && FT != null && FT != "") {
          if (FC == undefined || FC == null || FC == "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
        }
        var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = $scope.Uniqueschedulerdatas.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        //$scope.MobileInProgressdatas = InProgres;
        var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;
        var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
          return adhoc.AdhocType === "Adhoc";
        });
        $scope.AdhocJobsdatas = adhoc;
        var datapush = [];
        angular.forEach($scope.Uniqueschedulerdatas, function (value) {
          try {
            datapush.push({
              title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
              startsAt: new Date(value.Startsat),
              endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
              id: value._id,
              draggable: true,
              resizable: true,
            });
          } catch (error) { }
        })
        $scope.calenderdata = datapush;
      });
    }
    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item1 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'ScheduleFrequency';
        });
        $scope.ScheduleFrequencydatas = item1;
      }
      catch (e) { }
      try {
        var item2 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'PaymentMode';
        });
        $scope.PaymentModedatas = item2;
      }
      catch (e) { }
      try {
        var item3 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'BillingFrequency';
        });
        $scope.BillingFrequencydatas = item3;
      }
      catch (e) { }
      try {
        var item3 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'Remarks';
        });
        $scope.Remarksdatas = item3;
      }
      catch (e) { }
      try {
        var item4 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'JobTypes';
        });
        $scope.JobTypesdatas = item4;
      }
      catch (e) { }
    });

    function RefreshCustomerdatas() {
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.Customerdatas = customerdata;
        $scope.CustomerSearchdatas = customerdata;
      });
    }

    RefreshCustomerdatas()

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/servicetypelist",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Servicesdata) {
      $scope.Servicesdatas = Servicesdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/vehicle",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Vehicledata) {
      $scope.Vehicledatas = Vehicledata.data.data;
    });

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/detailsforTab",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/user/getByClientId",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        try {
          var Userdata = $scope.Userdatas.filter(function (item) {
            return item.UserID === $rootScope.createdby;
          })[0];

          var item1 = $scope.Employeedatas.filter(function (item) {
            return item.EmployeeID === Userdata.EmployeeID;
          })[0];
          $scope.RequestedBy = item1.EmployeeID + '-' + item1.EmployeeName;
        } catch (error) { }
        angular.forEach($scope.Userdatas, function (value) {
          angular.forEach($scope.Employeedatas, function (evalue) {
            if (value.EmployeeID == evalue.EmployeeID)
              value.EmployeeID = evalue.EmployeeName;
          })
        })
      });
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/calendar",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Calendardata) {
      $scope.Holidaysdatas = Calendardata.data.data;
      var item = $scope.Holidaysdatas.filter(function (item) {
        return item.EventType === 'Holiday';
      });
      $scope.HolidaySelectedon = [];
      angular.forEach(item, function (value) {
        $scope.HolidaySelectedon.push(new Date(value.StartDate).setHours(0, 0, 0, 0))
      })
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder/getForScheduler",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (salesdata) {
      $scope.salesdatas = salesdata.data.data;
      // var array = [];
      // angular.forEach($scope.Customerdatas, function (value, key) {
      //   angular.forEach($scope.salesdatas, function (svalue, skey) {
      //     try {
      //       if (value.id == svalue.Customer_id) {
      //         array.push(value);
      //       }
      //     }
      //     catch (e) { }
      //   })
      // })
      // if (array.length != 0) {
      //   try {
      //     var newArr = [];
      //     angular.forEach(array, function (value, key) {
      //       var exists = false;
      //       angular.forEach(newArr, function (val2, key) {
      //         if (angular.equals(value.id, val2.id)) { exists = true };
      //       });
      //       if (exists == false && value.id != "") { newArr.push(value); }
      //     });
      //     $scope.Customerdatas = newArr;
      //   }
      //   catch (e) { }
      // }
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contract",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (contractdata) {
      $scope.contractdatas = contractdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/team",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (teamdata) {
      $scope.teamdatas = teamdata.data.data;
      var tdydate = new Date()
      var today = new Date();
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
    });
    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }
    function RefreshGrid() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/user/getByClientId",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        angular.forEach($scope.Userdatas, function (value) {
          angular.forEach($scope.Employeedatas, function (evalue) {
            if (value.EmployeeID == evalue.EmployeeID)
              value.EmployeeID = evalue.EmployeeName;
          })
        })
        $scope.NewGetByStatus()
      });
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
      $("#PendingContainer").dxDataGrid("instance").clearSelection();
    }
    $scope.uoFrom = new Date(new Date().setDate(new Date().getDate() - 1));
    $scope.uoTo = new Date(new Date().setDate(new Date().getDate() - 1));
    $scope.vm.OutstandingPreviewSpinner = false;
    $scope.vm.InProgressPreviewSpinner = false;
    $scope.vm.AdhocJobPreviewSpinner = false;

    $scope.getOutsatnding = function () {
      $scope.InProgressdatas = [];
      $scope.vm.OutstandingPreviewSpinner = true;
      $scope.vm.filtercustomer = null
      $scope.vm.filterteam = null
      $scope.uoFrom.setHours(0, 0, 0, 0);
      $scope.uoTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uoFrom,
          End_Date: $scope.uoTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: $scope.vm.filtercustomer,
          Team_Id: $scope.vm.filterteam
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',');
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          }
          catch (e) { }
        })
        $scope.Uniqueschedulerdatas = GList.data.data;
        var idarry = [];
        try {
          var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
            return yet.Status === "Yet to Start";
          });
        } catch (e) { }
        angular.forEach(yet, function (value) {
          var dd = new Date(value.Startsat);
          var hh = new Date(value.Endsat);
          var mm = new Date(hh.setDate(new Date(dd).getDate()));
          var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
          var x = new Date(yy.setFullYear(new Date(dd).getFullYear()));
          var e = new Date(x).getTime();
          var c = new Date().getTime();
          if (e < c) {
            idarry.push(value._id)
          }
        })
        $http({
          url: $rootScope.WebURL + "/scheduler/getAllOutstandingJobs",
          method: "POST",
          data: {
            Client_Id: $rootScope.Client_Id,
          },
        }).then(function (List) {
          $scope.vm.OutstandingPreviewSpinner = false;
          angular.forEach(List.data.data, function (value) {
            try {

              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              try {
                value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
              } catch (error) {
                value.NewSiteName = value.customerdetails[0].CompanyName
                $scope.vm.OutstandingPreviewSpinner = false;
                console.log(error)
              }
            }
            catch (e) { $scope.vm.OutstandingPreviewSpinner = false; $mdDialog.cancel(); console.log(e) }
          })
          $mdDialog.cancel();
          var progerss = List.data.data
          $scope.InProgressdatas = progerss;
          $scope.AllScheduleDatas = $scope.AllScheduleDatas.concat(progerss);
          $scope.vm.OutstandingPreviewSpinner = false;
        })
        try {
          $scope.DeleteMarkers();
        } catch (e) { }

      });
    }
    $scope.getAllInProgress = function () {
      $scope.MobileInProgressdatas = [];
      $scope.vm.InProgressPreviewSpinner = true;
      $scope.iFrom = new Date($scope.uFrom);
      $scope.iTo = new Date($scope.uTo);
      $scope.iFrom.setHours(0, 0, 0, 0);
      $scope.iTo.setHours(23, 59, 59, 999);
      $http({
        url: $rootScope.WebURL + "/scheduler/getInProgress",
        method: "POST",
        data: {
          Start_Date: $scope.iFrom,
          End_Date: $scope.iTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {

            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.MobileInProgressdatas = GList.data.data;
        $scope.AllScheduleDatas = GList.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.InProgressPreviewSpinner = false;
      });
    }
    $scope.getAdhocJobs = function () {
      $scope.AdhocJobsdatas = [];
      $scope.vm.AdhocJobPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $http({
        url: $rootScope.WebURL + "/scheduler/getAdhocJobs",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (GList) {
        $scope.AdhocJobsdatas = GList.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.AdhocJobPreviewSpinner = false;
      });
    }
    $scope.ShowEmailSent = function (EmailSent) {
      if (EmailSent != null && EmailSent != undefined && EmailSent != "") {
        if (EmailSent == true) {
          return "Yes";
        }
        else if (EmailSent == false) {
          return "No";
        }
        else {
          return "No";
        }
      }
      else {
        return "No";
      }
    }
    $scope.vm.PreviewSpinner = false;
    $scope.GetByStatus = function (Status, FT) {
      $scope.TRCCdiv = false;
      $scope.CompletedSelectedIds = [];
      $scope.AllCSelec = { value: false };
      $scope.CSelec = { value: false }
      $scope.YettoStartdatas = [];
      $scope.vm.YTSPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      else {
        // do nothing
      }
      if (Status == 'Completed') {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {

              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Completeddata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Completeddata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          $scope.Completeddatas = resArr;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if (Status == 'Pending Approval') {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatusCompleted",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Pendingdata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Pendingdata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }

          var getPending = [];
          try {
            getPending = resArr.filter(function (pending) {
              return pending.ServiceReportStatus == "Pending";
            });
          } catch (e) { }

          $scope.PendingApprovaldatas = getPending;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FC.indexOf(item.Customer) > -1 && FT.indexOf(item.AssignedTo) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
          var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
            return yet.Status === "Yet to Start";
          });
          $scope.YettoStartdatas = yet;
          var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
            return completed.Status === "Completed";
          });
          $scope.Completeddatas = completed;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          var datapush = [];
          angular.forEach($scope.Uniqueschedulerdatas, function (value) {
            try {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true,
                resizable: true,
              });
            } catch (error) { }
          })
          $scope.calenderdata = datapush;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }
    $scope.StatusDatefilterMulti = function (FT) {
      var Status = 'Yet to Start'
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $scope.Completeddatas = [];
      $scope.YettoStartdatas = [];
      $scope.vm.YTSPreviewSpinner = true;
      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      if ($scope.vm.SelectedTab == 'Completed') {
        Status = 'Completed'
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Completeddata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Completeddata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          $scope.Completeddatas = resArr;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        Status = 'Completed'
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatusCompleted",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var PendingData = Uniqueschedulerdatas;
          var resArr = [];
          try {
            PendingData.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          var getPending = [];
          try {
            getPending = resArr.filter(function (pending) {
              return pending.ServiceReportStatus == "Pending";
            });
          } catch (e) { }

          $scope.PendingApprovaldatas = getPending;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        $scope.getPendingSchedule()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else if ($scope.vm.SelectedTab == 'In-Progress') {
        $scope.getAllInProgress()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else if ($scope.vm.SelectedTab == 'ScheduledWorkOrder') {
        $scope.getScheduledWorkOrder()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.Team_Id) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
          else if (Status == "Completed") {
            var completed = []
            try {
              completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
                return completed.Status === "Completed";
              });
            } catch (e) { }
            $scope.Completeddatas = completed;

            var pendingApproval = []
            try {
              pendingApproval = $scope.Uniqueschedulerdatas.filter(function (pending) {
                return pending.Status === "Completed" && pending.ServiceReportStatus == "Pending";
              });
            } catch (e) { }
            $scope.PendingApprovaldatas = pendingApproval;
          }
          else {
            var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
              return yet.Status === "Yet to Start";
            });
            $scope.YettoStartdatas = yet;
          }
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }
    function getMonthDays(myMonth) {
      var now = new Date();
      var nowYear = now.getFullYear();
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    }
    function RefreshAttachmentGrid() {
      $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.jobdata },
      }).then(function (attachmentdata) {
        var item = attachmentdata.data.data.filter(function (item) {
          return item.TableName === 'Operations'
        })
        $scope.Attachmentdatas = item;
      });
      $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.jobdata },
      }).then(function (attachmentdata) {
        var item = attachmentdata.data.data.filter(function (item) {
          return item.TableName === 'Sales Order' || item.TableName === 'Operations'
        })
        $scope.NAttachmentdatas = item;
      });
    }
    $scope.DeleteAttachment = function (id) {
      $scope.delAtachId = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          $http({
            url: $rootScope.WebURL + "/attachment/delete",
            method: "POST",
            data: { _id: $scope.delAtachId },
          }).then(function (attachmentdata) {
            RefreshAttachmentGrid()
            $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
          })
        }
      })
    }

    $scope.DeleteComment = function (id) {
      $scope.delComId = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          $http({
            url: $rootScope.WebURL + "/schedulercomment/delete",
            method: "POST",
            data: { _id: $scope.delComId },
          }).then(function (attachmentdata) {
            var response = $http({
              url: $rootScope.WebURL + "/schedulercomment/getByCustomer",
              method: "POST",
              data: { RequestID: $scope.vm.Customersearch },
            });
            response.then(function (Commentdata) {
              $scope.NCommentdatas = Commentdata.data.data;
              $mdToast.show($mdToast.simple().textContent('Comment deleted Successfully!').position('top center'));
            });
          })
        }
      })
    }

    $scope.makeComplete = function () {
      var Startdate = CombineDateAndTime($scope.vm.ResheduleFrom, $scope.vm.ResheduleStartTime)
      var Enddate = CombineDateAndTime($scope.vm.ResheduleFrom, $scope.vm.ResheduleEndTime)
      var item = $scope.teamdatas.filter(function (item) {
        return item.TeamName === $scope.vm.UTeam1
      })[0]
      var TeamMem = item.TeamMembers
      var TeamLead = item.TeamLead
      $http({
        method: 'PUT',
        url: $rootScope.WebURL + '/tabletschedulerrecord/tocomplete',
        data: {
          ServiceId: $scope.SID,
          Team: $scope.vm.UTeam1,
          Scheduledate: new Date(Startdate),
          WorkorderNo: $scope.vm.SalesOrderNo,
          ContractOrderNo: $scope.vm.ContractOrderNo,
          ContactPerson: $scope.vm.ContactPerson,
          Startsat: Startdate,
          Endsat: Enddate,
          Location: $scope.vm.Location,
          StartLocation: $scope.vm.LatLong,
          EndLocation: $scope.vm.LatLong,
          Pesttype: $scope.vm.PestType1,
          TeamLead: TeamLead,
          BillingAmount: $scope.vm.BillingAmount,
          TeamMember: TeamMem,
          JobType: $scope.vm.JobType,
          CustomerName: $scope.vm.CustomerName,
          EmailId: $scope.vm.CusEmail,
          CreatedBy: $rootScope.createdBy
        }
      }).then(function (Glist) {
        $scope.getOutsatnding()
        $mdToast.show($mdToast.simple().textContent('Outstanding updated Successfully!').position('top center'));
        $mdDialog.cancel()
      })
    }
    $scope.PestTreatmentMethod = []
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pocarddatas) {
      $scope.Pesttypedatas = pocarddatas.data.data;
      $scope.Pestdatasdatas = pocarddatas.data.data;
      angular.forEach($scope.Pesttypedatas, function (value, key) {
        $scope.PestTreatmentMethod.push({
          "ID": value.PestName,
          "name": value.PestName,
          "expanded": false
        })
      })
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (treatment) {
        $scope.Treatmentdatas = treatment.data.data
        angular.forEach($scope.Treatmentdatas, function (value) {
          $scope.PestTreatmentMethod.push({
            "ID": value.TreatmentName + '~' + value.PestType,
            "categoryId": value.PestType,
            "name": value.TreatmentName,
          })
        })
      })
    })
    function Refreshcomment() {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByReqID",
        method: "POST",
        data: { RequestID: $scope.vm.jobdata },
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
      });
    }

    function findCustomerServiceIDforServiceAddress(uniq_customer_id) {
      return $http({
        url: $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: uniq_customer_id },
      });
    }

    function CustomerServicedatadetails() {
      var response = findCustomerServiceIDforServiceAddress($scope.RequestID)
      response.then(function (CustomerServicedata) {
        //$scope.CustomerServicedatas = CustomerServicedata.data.data;
        var resArr = [];
        try {
          CustomerServicedata.data.data.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return x.sBLK == item.sBLK && x.sUnit == item.sUnit && x.sStreetName == item.sStreetName && x.sPostal == item.sPostal
            });
            if (i <= -1)
              resArr.push(item);
          });
        } catch (e) { }
        $scope.CustomerServicedatas = resArr;
        $scope.vm.PreviewSpinner = false;
        if ($scope.vm.FixedTeam == "Yes") {
          if ($scope.vm.FixedTeamdata != null && $scope.vm.FixedTeamdata != "" && $scope.vm.FixedTeamdata != undefined) {
            var array = $scope.vm.FixedTeamdata.split(",");
            var array1 = [];
            angular.forEach(array, function (item) {
              angular.forEach($scope.teamdatas, function (value) {
                if (item == value.TeamName) {
                  array1.push(value);
                }
              });
            });
            $scope.teamdatas = array1;
          } else {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/team",
              data: {
                Client_Id: $rootScope.Client_Id
              },
            }).then(function (teamdata) {
              $scope.teamdatas = teamdata.data.data;
            });
          }
        }
        else {
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
          }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
          });
        }
      });
    }
    function RefreshPhotos() {
      $scope.Photosdatas = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerpicafter",
        data: { ScedulId: $scope.vm.ScedulId },
      }).then(function (Glist) {
        $scope.Photosdatas = Glist.data.data;
        angular.forEach($scope.Photosdatas, function (item) {
          item.Path = $rootScope.ServicePhotosURL + item.ServiceId + "/" + item.id + ".png";
        });
      });
    }


    function RefreshSchedulerLogs() {
      var response = $http({
        url: $rootScope.WebURL + "/schedulelog/getByServiceID",
        method: "POST",
        data: { ServiceID: $scope.vm.ServiceID },
      });
      response.then(function (SchedulerLogdata) {

        $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
      });
    }
    function RefreshUnit() {
      var response = $http({
        url: $rootScope.WebURL + "/unit",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Unitdata) {
        $scope.Unitdatas = Unitdata.data.data;
      });
    }
    function CombineDateAndTime(date, time) {
      var timeString = time.getHours() + ':' + time.getMinutes() + ':00';
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // Jan is 0, dec is 11
      var day = date.getDate();
      var dateString = '' + year + '-' + month + '-' + day;
      var combined = new Date(dateString + ' ' + timeString);
      return combined;
    };
    function RefreshSchedulerReportPathGrid() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
      });
    }
    function RefreshGroupID() {
      var response = $http({
        url: $rootScope.WebURL + "/groupid/LastOne",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Groupiddata) {
        $scope.Groupiddatas = Groupiddata.data.data;
      });
    }
    function pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    function nthWeekdayOfMonth(weekday, n, date) {
      var count = 0,
        idate = new Date(date.getFullYear(), date.getMonth(), 1);
      while (true) {
        if (idate.getDay() === weekday) {
          if (++count == n) {
            break;
          }
        }
        idate.setDate(idate.getDate() + 1);
      }
      if (idate.getMonth() === new Date(date).getMonth())
        return idate;
      else {
        return new Date(idate.setDate(idate.getDate() - 7));
      }
    }
    function daysInMonth(d, day) {
      var days = [];
      var getTot = new Date(d.getFullYear(), d.getMonth(), 0).getDate();
      for (var i = 1; i <= getTot; i++) {
        var newDate = new Date(d.getFullYear(), d.getMonth(), i)
        if (newDate.getDay() == 1 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 2 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 3 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 4 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 5 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 6 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 0 && day == newDate.getDay()) {
          days.push(i)
        }
      }
      return days;
    }
    function CheckNotEmpty(value) {
      if (value != null && value != undefined && value != "")
        return true;
      else
        return false
    }
    function getWeekOfMonth(exact) {
      var month = exact.getMonth()
        , year = exact.getFullYear()
        , firstWeekday = new Date(year, month, 1).getDay()
        , lastDateOfMonth = new Date(year, month + 1, 0).getDate()
        , offsetDate = exact.getDate() + firstWeekday - 1
        , index = 1 // start index at 0 or 1, your choice
        , weeksInMonth = index + Math.ceil((lastDateOfMonth + firstWeekday - 7) / 7)
        , week = index + Math.floor(offsetDate / 7)
        ;
      if (exact || week < 2 + index) return week;
      return week === weeksInMonth ? index + 5 : week;
    }
    $scope.ShowType = function (gCR, gRSR) {
      if (gCR != null && gCR != undefined && gCR != "") {
        return "Cancelled";
      }
      else if (gRSR != null && gRSR != undefined && gRSR != "") {
        return "Rescheduled";
      }
      else {
        return null;
      }
    }
    var vm = this;
    vm.searchInit = true;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');
        if (vm.searchInit == true) {
          var table = $('#example').DataTable();
          table.search('').draw();
          vm.searchInit = false;
        }
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      destroy: true,
      pagingType: 'simple',
      autoWidth: false,
      order: [[1, "asc"]],
      lengthMenu: [10, 20, 30, 50, 100],
      responsive: true,
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };
    vm.dtOptions1 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#search');
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      destroy: true
    };
    vm.dtdetails1 = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-dtdetails1');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dtOptions2 = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#ReportSearch');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };
    vm.dtpreviewdetails = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-dtpreviewdetails');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 50, 100, 1000],
      destroy: true
    };

    vm.dtOptions5 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      drawCallback: function (settings) {
        var api = this.api();

        var rows = api.rows({ page: 'current' }).nodes();
        var last = null;

        api.column(1, { page: 'current' }).data().each(function (group, i) {
          if (last !== group) {
            $(rows).eq(i).before(
              '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
            );

            last = group;
          }
        });
      },
    }

    vm.calendarView = 'day';
    vm.viewDate = new Date();
    var actions = [{
      label: '<i class=\'glyphicon glyphicon-pencil\'></i>',
      onClick: function (args) {
        alert.show('Edited', args.calendarEvent);
      }
    }, {
      label: '<i class=\'glyphicon glyphicon-remove\'></i>',
      onClick: function (args) {
        alert.show('Deleted', args.calendarEvent);
      }
    }];
    vm.cellIsOpen = false;

    vm.eventClicked = function (event) {


      alert.show('Clicked', event);
    };
    vm.eventEdited = function (event) {

      alert.show('Edited', event);
    };
    vm.eventDeleted = function (event) {
      alert.show('Deleted', event);
    };
    vm.toggle = function ($event, field, event) {
      $event.preventDefault();
      $event.stopPropagation();
      event[field] = !event[field];
    };
    vm.timespanClicked = function (date, cell) {
      if (vm.calendarView === 'month') {
        if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      } else if (vm.calendarView === 'year') {
        if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      }

    };
    $scope.mapFilter = function () {
      NgMap.getMap().then(function (map) {
        for (var key in map.markers) {
          map.markers[key].setMap(null);
          // map.directionsRenderers[key].setMap(null);
        };

      });
      var Start_Date = new Date($scope.mapDate.setHours(0, 0, 0, 0));
      var End_Date = new Date($scope.mapDate.setHours(23, 59, 59, 999));

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/routemapfilter",
        data: { Client_Id: $rootScope.Client_Id, Team: $scope.vm.mapTeam, Start_Date: Start_Date, End_Date: End_Date },
      }).then(function (uniquescheduler) {
        $scope.Routemapdatas = uniquescheduler.data.data;
        GetRouteByTeam();
      });
    }
    $scope.Maping = function () {
      $scope.MapViewProgresdatas = [];
      $scope.DeleteMarkers();
      $http({
        url: $rootScope.WebURL + "/scheduler/getforMaping",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
        },
      }).then(function (GList) {
        $scope.MapViewProgresdatas = GList.data.data;
        NgMap.getMap().then(function (map) {
          if (map.markers != "" && map.markers != null && map.markers != undefined) {

            for (var i in map.markers) {
              i = parseFloat(i);
              map.markers[i].setMap(null);
              map.markers[i].setPosition(null);
              map.markers[i].setTitle(null);
              map.markers[i].setIcon(null);
              map.markers[i].setVisible(false);
            }
          }
          //map.markers = null;
          //map.markers.length = 0;
          //map.markers = new Array();
          //google.maps.Map.prototype.markers = new Array();
          $scope.Mapingpositions = [];
          var getmarkers = [];
          var Mapviewprog = $scope.MapViewProgresdatas;
          angular.forEach($scope.MapViewProgresdatas, function (Mapviewprog) {
            var address = Mapviewprog.Location;
            var Colour = "#2D11E0";
            var Customer = "";
            var TeamLead = "";
            var latitude = 1.3554;
            var longitude = 103.8677;
            var LatLong = "103.8677,1.3554"
            if (Mapviewprog.Status == "In-Progress") {
              Colour = '/assets/images/logos/personGreen.png';
            }
            if (Mapviewprog.Status == "Completed") {
              Colour = '/assets/images/logos/personRed.png';
            }
            if (Mapviewprog.AdhocType == "Adhoc") {
              if (Mapviewprog.CompanyName != null && Mapviewprog.CompanyName != undefined) {
                try {
                  Customer = Mapviewprog.CompanyName;
                  TeamLead = Mapviewprog.TeamLead;
                  if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                    LatLong = Mapviewprog.LatLong;
                  }
                }
                catch (e) { }
              }
              else {
                try {
                  Customer = Mapviewprog.AdhocCustomerName;
                  TeamLead = Mapviewprog.TeamLead;
                  if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                    LatLong = Mapviewprog.LatLong;
                  }
                }
                catch (e) { }
              }
            }
            else {
              try {
                Customer = Mapviewprog.CompanyName;
                TeamLead = Mapviewprog.TeamLead;
                if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                  LatLong = Mapviewprog.LatLong;
                }
              }
              catch (e) { }
            }
            var j = getmarkers.findIndex(function (x) {
              return x.LatLong == LatLong && x.icon == Colour;
            });
            if (j <= -1) {
              var len = getmarkers.length;
              getmarkers[len] = new google.maps.Marker({
                title: TeamLead + " - " + $filter('date')(new Date(Mapviewprog.Startsat), 'hh:m a') + " - " + $filter('date')(new Date(Mapviewprog.Endsat), 'hh:m a') + " - " + Mapviewprog.ServiceID,
                icon: Colour,
                LatLong: LatLong,
                //onRoute: false,
                //map: null,
                //id: len,
                //trigger: 'active',
              })
            }
            else {
              angular.forEach(getmarkers, function (item, key) {
                if (item.LatLong === Mapviewprog.LatLong && item.icon === Colour) {
                  item.title = item.title + '\n' + TeamLead + " - " + $filter('date')(new Date(Mapviewprog.Startsat), 'hh:m a') + " - " + $filter('date')(new Date(Mapviewprog.Endsat), 'hh:m a') + " - " + Mapviewprog.ServiceID;
                }
              });
            }
          })
          angular.forEach(getmarkers, function (gmvalue) {
            var lati = 1.3554;
            var lngi = 103.8677;
            if (gmvalue.LatLong != "" && gmvalue.LatLong != null && gmvalue.LatLong != undefined) {
              var array = gmvalue.LatLong.split(",")
              lati = parseFloat(array[1]);
              lngi = parseFloat(array[0]);
            }
            var lat = lati + (Math.random() / 100);
            var lng = lngi + (Math.random() / 100);
            var latlng = new google.maps.LatLng(lat, lng);
            gmvalue.setPosition(latlng);
            gmvalue.setMap(map);
            gmvalue.setVisible(true);
          })
          $scope.Mapingpositions = getmarkers;
        });
      });
    }
    $scope.DeleteMarkers = function () {
      var markers = $scope.Mapingpositions;
      if (markers != undefined) {
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(null);
          markers[i].setPosition(null);
          markers[i].setTitle(null);
          markers[i].setIcon(null);
          markers[i].setVisible(false);
        }
      }
      $scope.Mapingpositions = [];
      var getmarkers = [];
    };
    function GetRouteByTeam() {
      $scope.positions = [];
      var route = 1;
      angular.forEach($scope.Routemapdatas, function (evalue) {
        var geocoder = new google.maps.Geocoder();
        var address = evalue.Location;

        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();

            $scope.positions.push({ title: evalue.ServiceID, pos: [latitude, longitude], onRoute: false, id: route })
            route++;
            DisplayRoute();
          }
        });
      });
    }
    function DisplayRoute() {
      $scope.route = $scope.positions;
      $scope.start = $scope.positions[0];
      $scope.theWaypoints = [];
      if ($scope.route.length > 1) {
        for (var i = 1; i < $scope.route.length - 1; i++) {
          var obj = {
            location: {
              lat: $scope.route[i].pos[0],
              lng: $scope.route[i].pos[1]
            },
            stopover: true
          };
          $scope.theWaypoints.push(obj);
        }
      }
      $scope.end = $scope.route[$scope.route.length - 1];
      if ($scope.positions.length > 0) {
        NgMap.getMap().then(function (map) {
          $scope.map = map;
          google.maps.event.trigger($scope.map, "resize");
        });
      }
    }
    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "single",
        showCheckBoxesMode: 'onClick',
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sBuildingName", caption: "Building Name" },
        { dataField: "sStreetName", caption: "Street Name" },
        { dataField: "sPostal", caption: "Postal" },
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.ServiceAddressarray = [];
          $scope.vm.SiteContactName = e.selectedRowsData[0].sContactPerson;
          $scope.vm.SiteAddress = e.selectedRowsData[0].sBuildingName + " " + e.selectedRowsData[0].sStreetName + " " + e.selectedRowsData[0].sPostal;
          $scope.vm.SiteContactNumber = e.selectedRowsData[0].sMobile;
          $scope.ServiceAddressarray.push.apply($scope.ServiceAddressarray, e.selectedRowsData);
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
          if (e.selectedRowsData[0].sPostal) {
            var PostalCode = e.selectedRowsData[0].sPostal.substring(0, 2);
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/scheduler/getZone",
              data: { PostalCode: PostalCode }
            }).then(function (List) {
              try {
                $scope.vm.ppZone = List.data.data.Zone;
              }
              catch (e) { $scope.vm.ppZone = "" }
            })
          }
        }
        else {
          $scope.ServiceAddressarray = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };
    var resourcesData = [{
      text: "Yet to Start",
      id: 1,
      color: "#CB6BB2"
    }, {
      text: "In-Progress",
      id: 2,
      color: "#56CA85"
    }, {
      text: "Completed",
      id: 3,
      color: "#000000"
    }, {
      text: "Outstanding",
      id: 4,
      color: "#FF9747"
    }, {
      text: "Cancelled",
      id: 5,
      color: "#FF0000"
    }, {
      text: "Blocked",
      id: 6,
      color: "#696969"
    }];

    $scope.FoggingList = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.Tittle = "Select Month to Export"
    }
    $scope.dateBox1 = {
      type: "date",
      width: 200,
      value: new Date(),
      displayFormat: 'monthAndYear',
      calendarOptions: {
        zoomLevel: 'month',
        maxZoomLevel: 'year',
        minZoomLevel: 'century',
      },
      onValueChanged: function (e) {
        var StartDate = new Date(e.value)
        var EndDate = new Date(new Date(e.value).getFullYear(), new Date(e.value).getMonth() + 1, 0)
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getforfogging",
          method: "POST",
          data: {
            Start_Date: StartDate,
            End_Date: EndDate,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: null,
            Status: "Yet to Start",
            Team_Id: null
          },
        });
        response.then(function (GList) {
          $mdDialog.cancel()
          GList.data.data = _.sortBy(GList.data.data, "Startsat")
          var promises = [];
          var data = [];
          var array = [];
          angular.forEach(GList.data.data, function (value) {
            var deferred = $q.defer();
            try {
              // var MultiFrequency = value.JobOrdersdetails[0].MultiFrequency
              // var ite = MultiFrequency.filter(function (ite) {
              //   return ite.PestType == "Adult Mosquito" && ite.Treatment == "Fogging"
              // })
              // if (ite.length > 0) {
              var Blok = "NA"
              var Floor = "NA"
              var addressarray = value.sStreetName.split(' ')
              var Building = value.sBuildingName
              var StreetName = value.sStreetName
              Blok = _.isInteger(addressarray[0]) ? addressarray[0] : "NA"
              angular.forEach(addressarray, function (value) {
                if (value.includes('#')) {
                  Floor = value
                }
              })

              if (parseInt(moment(value.Endsat).diff(moment(value.Startsat), 'hours')) > 3) {
                value.Endsat = new Date(moment(value.Startsat).add(3, 'hours'))
              }
              if (value.TeamLeadContact == null || value.TeamLeadContact == undefined || value.TeamLeadContact == "null" || value.TeamLeadContact == "undefined") {
                value.TeamLeadContact = ""
              }

              if (Building == null || Building == undefined || Building == "null" || Building == "undefined")
                Building = "";
              var land = "Others"
              if (value.MarketSection.includes('Residential - Landed') || value.MarketSection.includes('Condominium'))
                land = "Landed"
              else if (value.MarketSection.includes('Industrial') || value.MarketSection.includes('Food Manufacturing') || value.MarketSection.includes('Construction'))
                land = "Industrial"
              if (Blok != "NA")
                StreetName = StreetName.replace(Blok, '').trim()
              if (Floor != "NA")
                StreetName = StreetName.replace(Floor, '').trim()
              StreetName = StreetName.replace(',', ' ').trim()

              array.push({
                Date: $filter('date')(value.Startsat, 'd/MM/yyyy'),
                "Time Start": $filter('date')(value.Startsat, 'hh:mm a'),
                "Time End": $filter('date')(value.Endsat, 'hh:mm a'),
                "Block/House No": Blok,
                "Floor/Unit No": Floor,
                "Street Name": StreetName.substring(0, 50),
                "Building Name": Building,
                "Postal Code": value.sPostal,
                "Land Use Type": land,
                "Other Land Use Type": "NA",
                Product: "Able Max",
                "Conc Amt": "25",
                "Mode of Aplication": "Oil-Based",
                "Purpose of Fogging (Adult Mosquito)": "Y",
                "Purpose of Fogging (Cockroach)": "Y",
                "Purpose of Fogging (Mosquito Larva)": "N",
                "Purpose of Fogging (Other Pests)": "N",
                "Source Reduction": 'Y',
                "Immediate Neighbour": "Y",
                "Immediate Reason for not Informing": '',
                "Contact Person": value.TeamLead,
                "Contact No": value.TeamLeadContact,
              })
              // }
            }
            catch (e) {

            }
            deferred.resolve(data);
            promises.push(deferred.promise);
          });
          $q.all(promises).then(
            function (results) {
              alasql('SELECT * INTO XLSX("Fogging List.csv",{headers:true}) FROM ?', [array]);
            },
            function (response) {
            }
          );
        })
      },

    }


    vm.dataGridYTS = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.YettoStartdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      export: {
        enabled: false,
        allowExportSelectedData: false,
        fileName: "Yet to Start Datas"
      },
      sorting: {
        mode: "multiple",
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: 'always',
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          caption: "Work Order#", dataField: "JobOrdersdetails[0].SalesOrderNo",

        },
        {

          dataField: "Location", caption: "Address",
          //   dataField: "customerServicedetails[0].sStreetName", caption: "Address",
          //   cellTemplate: function (container, options) {
          //       try {
          //           if (options.data.customerServicedetails.length > 0) {
          //               $("<p>" + $scope.TrimleadingComma($scope.CheckNullvalue(options.data.customerServicedetails[0].sBLK) + ',' + $scope.CheckNullvalue(options.data.customerServicedetails[0].sStreetName)) + "</p>").appendTo(container);
          //           }
          //           if (options.data.Adhocdata != null && options.data.Adhocdata != undefined) {
          //               if (options.data.Adhocdata.length > 0) {
          //                   $("<p>" + $scope.TrimleadingComma(options.data.Adhocdata[0].Address) + "</p>").appendTo(container);
          //               }
          //           }
          //       } catch (e) { }
          //   },
        },

        // { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
          cellTemplate: function (container, options) {
            try {
              $("<p style='color:blue;cursor: pointer;'>" + options.data.TeamName + "</p>").appendTo(container);
            } catch (e) { }
          },
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: 'Reschedule',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'event',
              onClick: function (e) {
                $scope.Schinfolist(e, options.data)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Cancel',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                $scope.userpopup(e, options.data._id)
              }
            }).appendTo(container);
          }
        },

      ],
      bindingOptions: {
        dataSource: "YettoStartdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 2) {
          $scope.AddComments(data, data.data, false)
        }
        if (data.column.caption == "Team") {
          if (data.data != null && data.data != undefined && data.data != "") {
            $scope.EditTeam(data, data.data);
          }
        }
      },
      onExporting: function (e) {
        e.cancel = true
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.Rescheduledata = [];
          $scope.TRCdiv = true;
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
          $scope.Rescheduledata.push.apply($scope.Rescheduledata, e.selectedRowsData)
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
        }
        else {
          $scope.TRCdiv = false;
          $scope.SelectedIds = [];
          $scope.Rescheduledata = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };

    vm.dataGridOnHold = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.OnHolddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      export: {
        enabled: false,
        allowExportSelectedData: false,
        fileName: "On Hold Datas"
      },
      sorting: {
        mode: "multiple",
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "CompanyName",
        },
        { dataField: "SiteAddress", caption: "Site Name" },
        { dataField: "SalesOrderNo", caption: "Work Order#" },
        {
          caption: "Reminder Date", dataField: "OnHoldDate", dataType: "date", format: 'dd/MM/yyyy'
        },
        {
          caption: "Status", dataField: "OnHoldStatus",
        },
        {
          caption: "Reason", dataField: "OnHoldComments",
        },
        { dataField: "PestCode", caption: "Pest Types" },
        { dataField: "RemainingStartJobs", caption: "Remaining Jobs" },
        {
          caption: "On-Hold Date", dataField: "OnHoldUpdatedDate", dataType: "date", format: 'dd/MM/yyyy hh:mm a'
        },
        {
          caption: 'Re-Schedule',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'undo',
              onClick: function (e) {
                $scope.UnscheduleWorkOrder(options.data.id)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Remove',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'trash',
              onClick: function (e) {
                CancelOnHoldDatas(options.data.id)
              }
            }).appendTo(container);
          }
        },
      ],
      bindingOptions: {
        dataSource: "OnHolddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      // onCellClick: function (data) {
      //   if (data.columnIndex == 2) {
      //     $scope.AddComments(data, data.data, false)
      //   }
      //   if (data.columnIndex == 6) {
      //     if (data.data != null && data.data != undefined && data.data != "") {
      //       $scope.EditTeam(data, data.data);
      //     }
      //   }
      // },
      onExporting: function (e) {
        e.cancel = true
      },
      // onSelectionChanged: function (e) {
      //   if (e.selectedRowKeys.length > 0) {
      //     $scope.SelectedIds = [];
      //     $scope.Rescheduledata = [];
      //     $scope.TRCdiv = true;
      //     $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
      //     $scope.Rescheduledata.push.apply($scope.Rescheduledata, e.selectedRowsData)
      //     e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
      //     e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
      //   }
      //   else {
      //     $scope.TRCdiv = false;
      //     $scope.SelectedIds = [];
      //     $scope.Rescheduledata = [];
      //     e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
      //   }
      // },
    };


    vm.dataGridINP = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.MobileInProgressdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {

          dataField: "Location", caption: "Address",
          //   dataField: "customerServicedetails[0].sStreetName", caption: "Address",
          //   cellTemplate: function (container, options) {
          //       try {
          //           if (options.data.customerServicedetails.length > 0) {
          //               $("<p>" + $scope.TrimleadingComma($scope.CheckNullvalue(options.data.customerServicedetails[0].sBLK) + ',' + $scope.CheckNullvalue(options.data.customerServicedetails[0].sStreetName)) + "</p>").appendTo(container);
          //           }
          //           if (options.data.Adhocdata != null && options.data.Adhocdata != undefined) {
          //               if (options.data.Adhocdata.length > 0) {
          //                   $("<p>" + $scope.TrimleadingComma(options.data.Adhocdata[0].Address) + "</p>").appendTo(container);
          //               }
          //           }
          //       } catch (e) { }
          //   },
        },

        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: 'Revert',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'revert',
              onClick: function (e) {
                $scope.RevertPopup(e, options.data._id, options.data.ServiceID)
              }
            }).appendTo(container);
          }
        },
      ],
      bindingOptions: {
        dataSource: "MobileInProgressdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      }
    };
    vm.dataGridOTS = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.InProgressdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: 'onClick',
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {

          dataField: "Location", caption: "Address",
          //   dataField: "customerServicedetails[0].sStreetName", caption: "Address",
          //   cellTemplate: function (container, options) {
          //       try {
          //           if (options.data.customerServicedetails.length > 0) {
          //               $("<p>" + $scope.TrimleadingComma($scope.CheckNullvalue(options.data.customerServicedetails[0].sBLK) + ',' + $scope.CheckNullvalue(options.data.customerServicedetails[0].sStreetName)) + "</p>").appendTo(container);
          //           }
          //           if (options.data.Adhocdata != null && options.data.Adhocdata != undefined) {
          //               if (options.data.Adhocdata.length > 0) {
          //                   $("<p>" + $scope.TrimleadingComma(options.data.Adhocdata[0].Address) + "</p>").appendTo(container);
          //               }
          //           }
          //       } catch (e) { }
          //   },
        },

        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: 'Reschedule',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'event',
              onClick: function (e) {
                $scope.Schinfolist(e, options.data)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Cancel',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                $scope.userpopup(e, options.data._id)
              }
            }).appendTo(container);
          }
        },
        // {
        //   caption: 'Make Complete',
        //   fixed: false,
        //   fixedPosition: 'right',
        //   alignment: 'center',
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     $('<div />').dxButton({
        //       icon: 'check',
        //       onClick: function (e) {
        //         $scope.MakeComplete(e, options.data._id)
        //       }
        //     }).appendTo(container);
        //   }
        // },

      ],
      bindingOptions: {
        dataSource: "InProgressdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 2) {
          $scope.AddComments(data, data.data, false)
        }
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.OutstandingSelectedIds = [];
          $scope.OutstandingTRCdiv = true;
          $scope.OutstandingSelectedIds.push.apply($scope.OutstandingSelectedIds, e.selectedRowKeys)
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
        }
        else {
          $scope.OutstandingTRCdiv = false;
          $scope.OutstandingSelectedIds = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };
    vm.dataGridCMP = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.Completeddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: 'onClick',
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
            if (options.data.ImagesAvaliable == true) {
              $('<img />')
                .height(25)
                .attr('src', '../../../../../../assets/images/logos/Camera.png')
                .appendTo(container);
            }
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          dataField: "Location", caption: "Address",
        },
        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "tabletschedulerrecord[0].Team", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          dataField: "EmailSentTo", caption: "Emailed To",
          cellTemplate: function (container, options) {
            $("<p>" + $scope.removeLastComma(options.data.EmailSentTo) + "</p>").appendTo(container);
          },
        },
        { dataField: "EmailSentDate", caption: "Email Sent On", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: 'Clone',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'floppy',
              onClick: function (e) {
                clonejob(e, options.data)
              }
            }).appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "Completeddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 2) {
          $scope.AddComments(data, data.data, false)
        }
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.CompletedSelectedIds = [];
          $scope.TRCCdiv = true;
          angular.forEach(e.selectedRowsData, function (value) {
            $scope.CompletedSelectedIds.push({
              ID: value._id,
              ServiceID: value.ServiceID,
              EmailId: value.tabletschedulerrecord ? value.tabletschedulerrecord[0].EmailId : null
            })
          })
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
        }
        else {
          $scope.TRCCdiv = false;
          $scope.CompletedSelectedIds = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };
    vm.dataGridPASR = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      onCellPrepared: function (e) {
        angular.forEach($scope.PendingApprovaldatas, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
      },
      dataSource: $scope.PendingApprovaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: 'onClick',
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
            if (options.data.ImagesAvaliable == true) {
              $('<img />')
                .height(25)
                .attr('src', '../../../../../../assets/images/logos/Camera.png')
                .appendTo(container);
            }
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "JobCompletedDate", caption: "Job Completed Date & Time", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
      ],
      bindingOptions: {
        dataSource: "PendingApprovaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 3) {
          $scope.AddComments(data, data.data, false)
        }
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.CompletedSelectedIds = [];
          $scope.TRCCdiv = true;
          angular.forEach(e.selectedRowsData, function (value) {
            $scope.CompletedSelectedIds.push({
              ID: value._id,
              ServiceID: value.ServiceID,
            })
          })
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
        }
        else {
          $scope.TRCCdiv = false;
          $scope.CompletedSelectedIds = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };
    vm.dataGridCNL = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.Cancelleddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          dataField: "Location", caption: "Address",
          //   cellTemplate: function (container, options) {
          //       try {
          //           if (options.data.customerServicedetails.length > 0) {
          //               $("<p>" + $scope.TrimleadingComma($scope.CheckNullvalue(options.data.customerServicedetails[0].sBLK) + ',' + $scope.CheckNullvalue(options.data.customerServicedetails[0].sStreetName)) + "</p>").appendTo(container);
          //           }
          //           if (options.data.Adhocdata != null && options.data.Adhocdata != undefined) {
          //               if (options.data.Adhocdata.length > 0) {
          //                   $("<p>" + $scope.TrimleadingComma(options.data.Adhocdata[0].Address) + "</p>").appendTo(container);
          //               }
          //           }
          //       } catch (e) { }
          //   },
        },

        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        { dataField: "Startsat", caption: "Start Time", dataType: "date", format: 'hh:mm a' },
        { dataField: "Endsat", caption: "End Time", dataType: "date", format: 'hh:mm a' },
        { dataField: "Status", caption: "Status" },
        { dataField: "CancelRemarks", caption: "Remarks" },
      ],
      bindingOptions: {
        dataSource: "Cancelleddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, true)
        }
      }
    };
    vm.PendingSchedulerdataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      onCellPrepared: function (e) {

      },
      dataSource: $scope.PendingScheduledatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "single"
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        { dataField: "SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        { dataField: "DateTimeofTreatment", caption: "Prefered Date & Time" },
        { dataField: "EstimatedHoursRequired", caption: "Time Needed" },
        {
          caption: 'VIP ?',
          // fixed: true,
          // fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            if (options.data.IsUrgent == true) {
              // $('<div><md-icon md-font-icon="icon-alert-circle" ng-if="row.IsUrgent" style="color: orangered;"></md-icon>').appendTo(container);
              $('<div />').dxButton({
                icon: 'warning'
              }).appendTo(container);
            }
          }
        },
        {
          caption: 'On-Hold',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: "assets/icons/fonts/circle-stop-regular.svg",
              onClick: function (e) {
                $scope.OnHoldFlag = true
                OnHold(e, options.data._id)
              }
            }).appendTo(container);
          }
        },
      ],
      onSelectionChanged: function (selectedItems) {
        if (!$scope.OnHoldFlag) {
          try {
            $scope.NewCommentdatas = []
            var data = selectedItems.selectedRowsData[0]
            $scope.ServiceAddressarray = []
            if (data.customerServicedetails.length > 0)
              $scope.ServiceAddressarray.push(data.customerServicedetails[0])
            else {
              $http({
                method: 'POST',
                url: $rootScope.WebURL + '/customerService/getcustomerserviceaddressdetailsbyID',
                data: { RequestID: data.CustomerID }
              }).then(function (List) {
                $scope.ServiceAddressarray.push(List.data.data[0])
              })
            }
            angular.forEach($scope.ServiceAddressarray, function (value) {
              var getLocation = "";
              value.LatLong = "";
              value.getLocation = ""
              if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
                getLocation = getLocation + " " + value.sBuildingName;
              }
              if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
                getLocation = getLocation + " " + value.sStreetName;
              }
              if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
                getLocation = getLocation + ", Singapore " + value.sPostal;
              }
              var address = getLocation;
              value.LatLong = "103.8677,1.3554";
              try {
                var geocoder = new google.maps.Geocoder();
                if (geocoder) {
                  geocoder.geocode({
                    'address': address
                  }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                      value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                    }
                  });
                }
              }
              catch (e) {
                $('#PendingContainer').dxDataGrid("instance").clearSelection();
                $scope.OnHoldFlag = false
              }

              value.getLocation = getLocation;
            })
            $scope.vm.SiteAddress = $scope.ServiceAddressarray[0].getLocation;
            $scope.vm.SiteContactName = data.customerServicedetails[0].sContactPerson;
            $scope.vm.SiteContactNumber = data.customerServicedetails[0].sMobile;
            $scope.vm.CustomerID = null
            $scope.vm.PreferredDays = null
            $scope.vm.Notes = ""
            // $scope.GetLatlong()
            $scope.SelectJobOrder(data);
            //   $scope.SelectContract(data.ContractNo);
            $scope.GetCinfo(data.customerdetails[0]);
            $scope.vm.ppCompanyName = data.customerdetails[0].CompanyName;
            $scope.vm.Customersearch = data.customerdetails[0]._id;
            $scope.vm.jobdata = data._id;
            $scope.vm.ContractOrder = data.ContractNo;
            $scope.vm.JobsPerFrequency = data.JobsPerFrequency;
            $scope.vm.ServicesRequired = data.ServicesRequired;
            $scope.vm.ppWorkOrder = data.SalesOrderNo;
            $scope.vm.ppContractNo = $scope.vm.ContractReferenceNo;
            $scope.vm.PreviewSpinner = true;
            var response = $http({
              url: $rootScope.WebURL + "/schedulercomment/getByCustomer",
              method: "POST",
              data: { RequestID: data.customerdetails[0]._id },
            });
            response.then(function (Commentdata) {
              $scope.NCommentdatas = Commentdata.data.data;
            });
            $http({
              url: $rootScope.WebURL + "/attachment/getByFileID",
              method: "POST",
              data: { FileID: $scope.vm.jobdata },
            }).then(function (attachmentdata) {
              var item = attachmentdata.data.data.filter(function (item) {
                return item.TableName === 'Sales Order' || item.TableName === 'Operations'
              })
              $scope.NAttachmentdatas = item;
            });
            $mdDialog.show({
              multiple: true,
              templateUrl: 'app/main/apps/operations/scheduler/NewAdd.html',
              parent: angular.element($document.body),
              targetEvent: event,
              scope: $scope.$new(),
              controller: function operationsProjectController($scope, $mdDialog) {
                $scope.closeDialog = function () {
                  $mdDialog.hide();
                }
              }
            });
            $scope.vm.Twiceday = null
            $scope.vm.PreferredStartTime = null
            $scope.vm.PreferredEndTime = null
            $scope.vm.AvoidEndTime = null
            $scope.vm.AvoidStartTime = null
            $scope.AllSASelec = { value: false };
            $scope.SASelec = { value: false };
            $scope.svAll = { value: false };
            $scope.thdata = true;
            $scope.vm.Types = 'Follow-up'
            $scope.vm.JobType = 'Fixed'
            $scope.vm.SFOPH = "Next Day";
            var today = new Date();
            $scope.vm.Frequency = "";
            if ($scope.selected.length === $scope.items.length) {
              $scope.selected = [];
            } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
              $scope.selected = [];
            }



            $scope.dateBox = {
              ServiceStartTime: {
                type: "time",
                value: $scope.vm.ServiceStartTime,
                onValueChanged: function (e) {
                  $scope.vm.ServiceStartTime = e.value
                  $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
                },
                bindingOptions: {
                  'value': 'vm.ServiceStartTime'
                }
              },
              ServiceEndTime: {
                type: "time",
                value: $scope.vm.ServiceEndTime,
                onValueChanged: function (e) {
                  $scope.vm.ServiceEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.ServiceEndTime'
                }
              },
              PreferredStartTime: {
                type: "time",
                value: $scope.vm.PreferredStartTime,
                validationRules: [{
                  type: "required",
                  message: "Preferred Start Time is required"
                }],
                onValueChanged: function (e) {
                  $scope.vm.PreferredStartTime = e.value
                  // $scope.vm.PreferredEndTime = new Date(moment(e.value).add(1, 'hours'))
                },
                bindingOptions: {
                  'value': 'vm.PreferredStartTime'
                }
              },
              PreferredEndTime: {
                type: "time",
                value: $scope.vm.PreferredEndTime,
                validationRules: [{
                  type: "required",
                  message: "Preferred End Time is required"
                }],
                onValueChanged: function (e) {
                  $scope.vm.PreferredEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.PreferredEndTime'
                }
              },
              AvoidStartTime: {
                type: "time",
                value: $scope.vm.AvoidStartTime,
                onValueChanged: function (e) {
                  $scope.vm.AvoidStartTime = e.value
                  // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
                },
                bindingOptions: {
                  'value': 'vm.AvoidStartTime'
                }
              },
              AvoidEndTime: {
                type: "time",
                value: $scope.vm.AvoidEndTime,
                onValueChanged: function (e) {
                  $scope.vm.AvoidEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.AvoidEndTime'
                }
              },
              ResheduleSSTime: {
                type: "time",
                value: $scope.vm.AvoidEndTime,
                onValueChanged: function (e) {
                  $scope.vm.AvoidEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.ResheduleSSTime'
                }
              },
              ResheduleSETime: {
                type: "time",
                value: $scope.vm.AvoidEndTime,
                onValueChanged: function (e) {
                  $scope.vm.AvoidEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.ResheduleSETime'
                }
              },
              ResheduleStartTime: {
                type: "time",
                value: $scope.vm.AvoidEndTime,
                onValueChanged: function (e) {
                  $scope.vm.ResheduleStartTime = e.value
                  $scope.vm.ResheduleEndTime = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                },
                bindingOptions: {
                  'value': 'vm.ResheduleStartTime'
                }
              },
              ResheduleEndTime: {
                type: "time",
                value: $scope.vm.AvoidEndTime,
                onValueChanged: function (e) {
                  $scope.vm.ResheduleEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.ResheduleEndTime'
                }
              },
              ResheduleFrom: {
                type: "date",
                displayFormat: "dd/MM/yyy",
                value: $scope.vm.ResheduleFrom,
                onValueChanged: function (e) {
                  $scope.vm.ResheduleFrom = e.value
                },
                bindingOptions: {
                  'value': 'vm.ResheduleFrom'
                }
              },
              AStartTime: {
                type: "datetime",
                value: $scope.vm.AStartTime,
                onValueChanged: function (e) {
                  $scope.vm.AStartTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.AStartTime'
                }
              },
              AEndTime: {
                type: "datetime",
                value: $scope.vm.AEndTime,
                onValueChanged: function (e) {
                  $scope.vm.AEndTime = e.value
                },
                bindingOptions: {
                  'value': 'vm.AEndTime'
                }
              },
            }
            $scope.vm.GetCWCType = "WorkOrder";
            $scope.vm.TM = null;
            $scope.vm.AssignedTo = null;
            $scope.vm.ForBiWeekly = '';
            $scope.vm.ForMonthly = '';
            $scope.vm.ForBiMonthly = '';
            $scope.vm.ForYearlyWeek = '';
            $scope.vm.ForYearly = '';
            $scope.vm.ForQuaterlyWeek = '';
            $scope.vm.ForQuaterly = '';
            $scope.vm.ForHalfYearlyWeek = '';
            $scope.vm.ForHalfYearly = '';
            $scope.Update = false;
            $scope.Holidays = { value: true };
            $scope.Summary = '';
            $scope.vm.ScheduleType = "Fixed";
            if (data.customerServicedetails[0].sPostal) {
              var PostalCode = data.customerServicedetails[0].sPostal.substring(0, 2);
              $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getZone",
                data: { PostalCode: PostalCode }
              }).then(function (List) {
                try {
                  $scope.vm.ppZone = List.data.data.Zone;
                }
                catch (e) {
                  $scope.vm.ppZone = ""
                }
              })
            }


          } catch (error) {
            $('#PendingContainer').dxDataGrid("instance").clearSelection();
            $scope.OnHoldFlag = false
          }
        }

      },
      bindingOptions: {
        dataSource: "PendingScheduledatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };
    vm.ScheduledWorkOrderdataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.ScheduledWorkOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "single"
      },
      allowColumnResizing: true,
      OnCellPrepared: function (e) {
        if (e.rowType !== "data")
          return
        if (e.data.Status === "Scheduled") {
          e.rowElement.css("background-color", "red");
        }
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "CompanyName",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.CompanyName + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.CompanyName + "</p>").appendTo(container);
          },
        },
        {
          dataField: "SalesOrderNo", caption: "Work Order #",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.SalesOrderNo + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.SalesOrderNo + "</p>").appendTo(container);
          },
        },
        {
          dataField: "PestCode", caption: "Pest Types",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.PestCode + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.PestCode + "</p>").appendTo(container);
          },
        },
        {
          dataField: "SiteAddress", caption: "Site Name",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.SiteAddress + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.SiteAddress + "</p>").appendTo(container);
          },
        },
        {
          dataField: "TotalJob", caption: "Remaining Jobs",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.TotalJob + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.TotalJob + "</p>").appendTo(container);
          },
        },
        // { dataField: "DateTimeofTreatment", caption: "Prefered Date & Time" },
        // { dataField: "EstimatedHoursRequired", caption: "Time Needed" },
        // {
        //   caption: 'VIP ?',
        //   alignment: 'center',
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     if (options.data.IsUrgent == true) {
        //       // $('<div><md-icon md-font-icon="icon-alert-circle" ng-if="row.IsUrgent" style="color: orangered;"></md-icon>').appendTo(container);
        //       $('<div />').dxButton({
        //         icon: 'warning'
        //       }).appendTo(container);
        //     }
        //   }
        // },
        {
          caption: 'On-Hold',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: "assets/icons/fonts/circle-stop-regular.svg",
              onClick: function (e) {
                OnHold(e, options.data._id)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Reschedule',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'event',
              disabled: options.data.Status === "Completed" ? true : false,
              onClick: function (e) {
                ReschedulScheduledWO(options.data, e)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Unschedule',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'undo',
              onClick: function (e) {
                $scope.UnscheduleWorkOrder(options.data._id)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Edit',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'edit',
              onClick: function (e) {
                $scope.EditSchedulerLine(options.data._id)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Generate Calendar',
          fixed: true,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div style:border:none/>').dxButton({
              icon: 'columnchooser',
              onClick: function (e) {
                var url = $rootScope.ReportURL + 'Scheduler.aspx' + '?' + 'ID=' + options.data._id;
                window.open(url);
              }
            }).appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "ScheduledWorkOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };

    $scope.grouping = {
      autoExpandAll: false
    };
    vm.dataGridOptions = {
      // onInitialized: function (e) {
      //   dataGrid = e.component;
      // },
      dataSource: $scope.previewGridDatas,
      keyExpr: "ServiceID",
      paging: {
        enabled: true,
        pageSize: 100
      },
      editing: {
        mode: "cell",
        allowUpdating: true
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          },
          allowEditing: false
        },
        { dataField: "ServiceID", caption: "Service ID", allowEditing: false },
        { dataField: "PestCode", width: "350", caption: "Pest Type", allowEditing: false },
        { dataField: "ServiceOn", caption: "Day", allowEditing: false },
        { dataField: "Startsat", caption: "Schedule Date", dataType: "date", format: 'dd/MM/yyyy', showEditorAlways: true, },
        {
          dataField: "Startsat", caption: "Start Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          dataField: "Endsat", caption: "End Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          caption: 'Delete',
          fixed: true,
          fixedPosition: 'right',
          width: 60,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                $scope.previewGridDatas.splice(options.rowIndex, 1)
              }
            }).appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "previewGridDatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "false",
        // filterRow: "filterRow",
        // headerFilter: "headerFilter",
        // grouping: "grouping"
      },
      onRowPrepared: function (e) {
        try {
          if (e.data.SameTeam == 'Yes') {
            e.rowElement.css('background', '#a8dea8');
          }
          else if (e.data.SameTeam == 'Fixed') {
            e.rowElement.css('background', '#ffa500ab');
          }
          // if (e.data.Duplicate == true) {
          //   e.rowElement.css('background', '#ffa500ab');
          // }
        }
        catch (e) { }
      },
      onRowUpdating: function (e) {

        // e.cancel=true
        try {
          $scope.vm.PreviewSchedulespinner = true
          var StartDate = null
          if (e.newData.Startsat != undefined) {
            StartDate = new Date(e.newData.Startsat)
            StartDate.setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.newData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.oldData.Endsat).getHours(), new Date(e.oldData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Startsat = new Date(e.newData.Startsat).setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() - 1, 0, 0)
          }
          if (e.newData.Endsat != undefined) {
            StartDate = new Date(e.oldData.Startsat)
            StartDate.setHours(new Date(e.oldData.Startsat).getHours(), new Date(e.oldData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.oldData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Endsat = new Date(e.newData.Endsat).setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() + 1, 0, 0)
          }

          $scope.vm.PreviewSchedulespinner = false
        }
        catch (e) { $scope.vm.PreviewSchedulespinner = false }

        //   if (e.newData.Startsat) {
        //     try {
        //       e.oldData.ServiceOn = $filter('date')(new Date(e.newData.Startsat), 'EEEE');
        //       e.oldData.SameTeam = 'No';
        //       angular.forEach($scope.Teamtabledata, function (items) {
        //         if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(e.newData.Startsat, 'dd/MM/yyyy')) {
        //           var edd = new Date(items.Startsat);
        //           var ehh = $scope.vm.ServiceStartTime;
        //           var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           var edd = new Date(items.Startsat);
        //           var ehh = $scope.vm.ServiceEndTime;
        //           var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           var edd = new Date(items.Startsat);
        //           var ehh = new Date(items.Endsat);
        //           var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (startTime < EndDate && endTime >= EndDate) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else {
        //             //SameTeam = 'No';
        //           }
        //         }
        //       });
        //     }
        //     catch (e) { }
        //   }
        //   else
        //     e.oldData.ServiceOn = $filter('date')(new Date(e.oldData.Startsat), 'EEEE');
      },
    };

    vm.dataGridOptionsforReschdule = {
      // onInitialized: function (e) {
      //   dataGrid = e.component;
      // },
      dataSource: $scope.newPreviewGridDatas,
      keyExpr: "ServiceID",
      paging: {
        enabled: true,
        pageSize: 100
      },
      editing: {
        mode: "cell",
        allowUpdating: true
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          },
          allowEditing: false
        },
        { dataField: "ServiceID", caption: "Service ID", allowEditing: false },
        { dataField: "PestCode", caption: "Pest Type", allowEditing: false },
        { dataField: "OldStartsat", caption: "Old Schedule Date", dataType: "date", format: 'dd/MM/yyyy', showEditorAlways: false, },

        { dataField: "Startsat", caption: "Schedule Date", dataType: "date", format: 'dd/MM/yyyy', showEditorAlways: true, },
        { dataField: "ServiceOn", caption: "Day", allowEditing: false },
        {
          dataField: "Startsat", caption: "Start Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          dataField: "Endsat", caption: "End Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          caption: 'Delete',
          fixed: true,
          fixedPosition: 'right',
          width: 60,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                $scope.newPreviewGridDatas.splice(options.rowIndex, 1)
              }
            }).appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "newPreviewGridDatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "false",
        // filterRow: "filterRow",
        // headerFilter: "headerFilter",
        // grouping: "grouping"
      },
      onRowPrepared: function (e) {
        try {
          if (e.data.SameTeam == 'Yes') {
            e.rowElement.css('background', '#a8dea8');
          }
          else if (e.data.SameTeam == 'Fixed') {
            e.rowElement.css('background', '#ffa500ab');
          }
          // if (e.data.Duplicate == true) {
          //   e.rowElement.css('background', '#ffa500ab');
          // }
          // if (e.rowType === "data") {
          // Strike only specific columns
          var columnsToStrike = ['OldStartsat'];
          e.columns.forEach(function (column, index) {
            if (columnsToStrike.includes(column.dataField)) {
              $(e.rowElement).find('td').eq(index).css("text-decoration", "line-through");
            }
          });
          if (e.rowType === "data" && e.data.extra) {
            $(e.rowElement).css("text-decoration", "line-through");
          }
          // }
        }
        catch (e) { }
      },
      onRowUpdating: function (e) {

        // e.cancel=true
        try {
          $scope.vm.PreviewSchedulespinner = true
          var StartDate = null
          if (e.newData.Startsat != undefined) {
            StartDate = new Date(e.newData.Startsat)
            StartDate.setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.newData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.oldData.Endsat).getHours(), new Date(e.oldData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Startsat = new Date(e.newData.Startsat).setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() - 1, 0, 0)
          }
          if (e.newData.Endsat != undefined) {
            StartDate = new Date(e.oldData.Startsat)
            StartDate.setHours(new Date(e.oldData.Startsat).getHours(), new Date(e.oldData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.oldData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Endsat = new Date(e.newData.Endsat).setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() + 1, 0, 0)
          }

          $scope.vm.PreviewSchedulespinner = false
        }
        catch (e) { $scope.vm.PreviewSchedulespinner = false }

      },
    };

    $scope.CheckNullvalue = function (val) {
      var string = '';
      if (val == null || val == undefined || val == " ") {

        return string;
      } else {

        return val;
      }
    }
    $scope.TrimleadingComma = function (val) {

      var string = val;
      if (string.substring(0, 1) == ',') {
        string = string.substring(1);
        return string;
      } else {
        return val;
      }
    }
    $scope.removeLastComma = function (str) {
      if (str != undefined) {
        return str.replace(/,(\s+)?$/, '');
      } else {
        return "";
      }
    }
    $scope.Checkrowhasvalues = function (val) {

      if (val == null || val == undefined || val == " ") {
        return false;
      }
      else if (val.length > 2) {
        return true;
      } else {
        return false;
      }
    }
    $scope.CheckNullvalueBurrows = function (val) {
      var string = 0;
      if (val == null || val == undefined || val == " ") {

        return string;
      } else {

        return val;
      }
    }
    $scope.removeLastComma = function (str) {
      if (str != undefined) {
        return str.replace(/,(\s+)?$/, '');
      } else {
        return "";
      }
    }
    $scope.ShowVerified = function (EmailSent) {
      if (EmailSent != null && EmailSent != undefined && EmailSent != "") {
        if (EmailSent == true) {
          return "Verified";
        }
        else if (EmailSent == false) {
          return "Not Verified";
        }
        else {
          return "Not Verified";
        }
      }
      else {
        return "Not Verified";
      }
    }
    $scope.ClearGrid = function () {
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }

    $scope.getScheduledWorkOrder = function () {
      $scope.vm.ScheduledWorkOrderspinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getscheduledjobs",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Glist) {
        var data = Glist.data.data
        angular.forEach(data, function (value) {
          try {
            value.SiteAddress = (value.SBuildingName == null ? "" : value.SBuildingName) + " " + value.SStreetName + " " + value.SPostal
            var pest = value.PestName.split(',')
            var PestArray = []
            PestArray = $scope.Pestdatasdatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            $scope.vm.ScheduledWorkOrderspinner = true
          }
        })
        $scope.ScheduledWorkOrderdatas = data
        $scope.vm.ScheduledWorkOrderspinner = false
      })
    }

    $scope.getOnHoldWorkOrder = function () {
      $scope.vm.OnholdPreviewSpinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getOnhold",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Glist) {
        var data = Glist.data.data
        angular.forEach(data, function (value) {
          try {
            value.SiteAddress = (value.SBuildingName == null ? "" : value.SBuildingName) + " " + value.SStreetName + " " + value.SPostal
            var pest = value.PestName.split(',')
            var PestArray = []
            PestArray = $scope.Pestdatasdatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            $scope.vm.OnholdPreviewSpinner = true
          }
        })
        $scope.OnHolddatas = data
        $scope.vm.OnholdPreviewSpinner = false
      })
    }

    $scope.UnscheduleWorkOrder = function (id) {
      $scope.UnschedulerID = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to Unschedule all the jobs', 'Unschedule Jobs');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          var resp = $http({
            method: 'PUT',
            url: $rootScope.WebURL + "/salesOrder/unschedulejobs",
            data: { _id: $scope.UnschedulerID, UpdatedBy: $rootScope.createdby }
          });
          resp.then(function (Gli) {
            $mdToast.show($mdToast.simple().textContent('Unscheduled all jobs Successfully!').position('top center'));
            $scope.NewGetByStatus()
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      })
    }

    $scope.EditSchedulerLine = function (data) {
      $scope.vm.ScheduledWorkOrderspinner = true
      $scope.EditSO_Id = data
      $scope.PdateBox = {}
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyWO",
        data: { SlesOrderId: data },
      }).then(function (Glist) {
        var SchedulerJob = Glist.data.data
        if (SchedulerJob != null) {
          $scope.vm.PPreferredStartTime = SchedulerJob.PreferredStartTime
          $scope.vm.PPreferredEndTime = SchedulerJob.PreferredEndTime
          $scope.vm.PAvoidStartTime = SchedulerJob.AvoidStartTime
          $scope.vm.PAvoidEndTime = SchedulerJob.AvoidEndTime
          var preferday = SchedulerJob.PreferredTime.split(',')
          var item = $scope.teamdatas.filter(function (item) {
            return SchedulerJob.Team_Id.includes(item.id)
          })
          $scope.vm.TeamList = item
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/salesOrder/getById",
            data: { _id: SchedulerJob.JobsOrders },
          }).then(function (Glist) {
            console.log(Glist.data.data)
            $scope.vm.ManHour = parseFloat(Glist.data.data[0].EstimatedHoursRequired)
          })

          $scope.vm.PPreferredDays = []
          preferday.forEach(function (item) {
            var value = $filter('filter')($scope.Prefitems, item);
            $scope.vm.PPreferredDays = $scope.vm.PPreferredDays.concat(value)
          })
          $scope.PdateBox = {

            PreferredStartTime: {
              type: "time",
              value: $scope.vm.PPreferredStartTime,
              onValueChanged: function (e) {
                $scope.vm.PPreferredStartTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PPreferredStartTime'
              }
            },
            PreferredEndTime: {
              type: "time",
              value: $scope.vm.PPreferredEndTime,
              onValueChanged: function (e) {
                $scope.vm.PPreferredEndTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PPreferredEndTime'
              }
            },
            AvoidStartTime: {
              type: "time",
              value: $scope.vm.PAvoidStartTime,
              onValueChanged: function (e) {
                $scope.vm.PAvoidStartTime = e.value
                // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
              },
              bindingOptions: {
                'value': 'vm.PAvoidStartTime'
              }
            },
            AvoidEndTime: {
              type: "time",
              value: $scope.vm.PAvoidEndTime,
              onValueChanged: function (e) {
                $scope.vm.PAvoidEndTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PAvoidEndTime'
              }
            },
          }
          $scope.vm.ScheduledWorkOrderspinner = false
          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/EditServiceLine.html',
            parent: angular.element($document.body),
            //targetEvent: e,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
        }
        else {
          $scope.vm.ScheduledWorkOrderspinner = false
          $mdToast.show($mdToast.simple().textContent('All jobs are completed. You cant edit Scheduler Line !').position('top center'));
        }
        $scope.vm.ScheduledWorkOrderspinner = false
      })
    }

    $scope.SubmitSchedulerLine = function () {
      var TeamName = $scope.vm.TeamList.map(function (obj) { return obj.TeamLead }).join(',')
      var TeamId = $scope.vm.TeamList.map(function (obj) { return obj.id })
      $scope.vm.PPreferredDays = _.sortBy($scope.vm.PPreferredDays, "id")
      var PreferDays = $scope.vm.PPreferredDays.map(function (obj) { return obj.names; }).join(',');
      var resp = $http({
        method: 'PUT',
        url: $rootScope.WebURL + "/scheduler/updateLine",
        data: {
          _id: $scope.EditSO_Id,
          PreferredTime: PreferDays,
          PreferredStartTime: $scope.vm.PPreferredStartTime,
          PreferredEndTime: $scope.vm.PPreferredEndTime,
          AvoidStartTime: $scope.vm.PAvoidStartTime,
          AvoidEndTime: $scope.vm.PAvoidEndTime,
          TeamName: TeamName,
          TeamId: TeamId,
          ManHour: $scope.vm.ManHour,
          UpdatedBy: $rootScope.createdby
        }
      });
      resp.then(function (Gli) {
        $mdToast.show($mdToast.simple().textContent('Scheduler Line updated Successfully!').position('top center'));
        $mdDialog.cancel()
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });

    }

    $scope.OpenCustomScheduler = function () {
      $mdDialog.cancel();
      var $popup = $window.open('customscheduler');
    }

    $scope.ShowTimetoAvoid = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      try {
        var Fteam = $scope.Teamtabledata;
        var yet = Fteam.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        var newArray = _.uniqBy(yet, "JobsOrders")
        newArray = _.uniqWith(_.map(newArray, _.partialRight(_.pick, ['ServiceOn', 'Startsat', 'Endsat'])), _.isEqual);
        angular.forEach(newArray, function (item) {
          var Startsat1 = new Date(item.Startsat).toTimeString()
          var Endsat1 = new Date(item.Endsat).toTimeString()
          item.StartTime = new Date(new moment(Startsat1, 'HH:mm:ss')).toTimeString();
          item.EndTime = new Date(new moment(Endsat1, 'HH:mm:ss')).toTimeString();
          item.STime = new Date(new moment(Startsat1, 'HH:mm:ss')).getTime()
          item.ETime = new Date(new moment(Endsat1, 'HH:mm:ss')).getTime()
          item.Active = false
        })
        newArray = _.uniqBy(newArray, function (elem) { return [elem.StartTime, elem.EndTime].join(); });
        newArray = _.sortBy(newArray, "StartTime")
        var array = _.groupBy(newArray, "StartTime")
        var groupedarray = []
        console.log(array)
        _.each(array, function (item) {
          if (item.length == 2) {
            var a = ""
            _.each(item, function (subitem) {
              if (a == "")
                a = subitem
              else if (subitem.ETime > a.ETime) {
                a = subitem
              }
            })
            item = a
          }
          groupedarray.push(item)
        })
        groupedarray = _.flattenDeep(groupedarray)
        console.log(groupedarray)
        _.each(groupedarray, function (item) {
          var a = item.STime, b = item.ETime;
          for (var i = 1; i < groupedarray.length; i++) {
            if (a > groupedarray[i].STime && b < groupedarray[i].ETime) {
              a = groupedarray[i].STime;
              b = groupedarray[i].ETime
              groupedarray[i].Active = true
            }

            if (b > groupedarray[i].ETime && a < groupedarray[i].STime) {
              groupedarray[i].Active = true
            }
          }
          item.STime = a
          item.ETime = b
        })
        _.each(groupedarray, function (item) {
          for (var i = 1; i < groupedarray.length; i++) {
            if (item.ETime >= groupedarray[i].STime) {
              item.ETime = groupedarray[i].ETime
              groupedarray[i].Active = true
            }
          }
        })

        var newArray = []
        _.each(groupedarray, function (item) {
          if (item.Active == false) {
            item.CheckStartTime = new Date(item.STime)
            item.CheckEndTime = new Date(item.ETime)
            newArray.push(item)
          }
        })
        $scope.TimetoAvoiddatas = newArray

        $scope.PreferedTime = []
        var StartTime = new Date(new Date().setHours(8, 30, 0, 0))
        var EndTime = new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0))
        var value = $scope.TimetoAvoiddatas
        if (value.length > 0) {
          for (var i = 0; i < value.length; i++) {
            if (value.length == i + 1 && value.length == 1) {
              if (value[i].CheckStartTime > StartTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: StartTime,
                  CheckEndTime: value[i].CheckStartTime
                })
              }
              if (value[i].CheckEndTime < EndTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: value[i].CheckEndTime,
                  CheckEndTime: EndTime
                })
              }
            }
            else if (value.length == i + 1) {
              if (value[i - 1].CheckEndTime <= value[i].CheckStartTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: value[i - 1].CheckEndTime,
                  CheckEndTime: value[i].CheckStartTime
                })
                if (value[i].CheckStartTime < EndTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: value[i].CheckEndTime,
                    CheckEndTime: EndTime
                  })
                }
              }
              //   else
              //   {
              //     $scope.PreferedTime.push({
              //       CheckStartTime: value[i].CheckStartTime,
              //       CheckEndTime: EndTime
              //   })
              // }
            }
            else {
              if (i == 0) {
                if (value[i].CheckStartTime >= StartTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: StartTime,
                    CheckEndTime: value[i].CheckStartTime
                  })
                }
              }
              else {
                if (value[i - 1].CheckEndTime <= value[i].CheckStartTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: value[i - 1].CheckEndTime,
                    CheckEndTime: value[i].CheckStartTime
                  })
                }
              }
            }
          }
        }
        else {
          $scope.PreferedTime.push({
            CheckStartTime: new Date(new Date().setHours(8, 30, 0, 0)),
            CheckEndTime: new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0))
          })
        }
      }
      catch (e) { }
    }

    $scope.SchedulerCalculation = function (type, M) {
      $scope.vm.PreviewSpinner = true;
      $http.get($rootScope.WebURL + "/scheduler/getLength")
        .then(function (scheduler) {
          var schedulerdatasforlength = scheduler.data.data;
          // if (new Date($scope.vm.ServiceStartAt) < new Date()) {
          //   $scope.vm.ServiceStartAt = new Date();
          // }
          $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
          $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
          var previewdata = [];
          $scope.previewdatas = [];
          angular.forEach($scope.vm.PestType, function (value) {
            try {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return value.PestName == pt.PestName;
              })[0];
              value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
            } catch (e) { }
          })
          angular.forEach($scope.vm.PestType, function (item) {
            if (item.Frequency == "Ad-Hoc") item.ServicesRequired = 365
            else if (item.Frequency == "10 Days") item.ServicesRequired = 36
          })
          $scope.vm.PestType = _.sortBy($scope.vm.PestType, "ServicesRequired").reverse()
          var groupedFrequency = _.groupBy($scope.vm.PestType, 'Frequency');

          var groupFreq = []
          angular.forEach(groupedFrequency, function (item, key) {
            var PestTreatment = ""
            angular.forEach(item, function (item1) {
              if (item1.Others != "" && item1.Others != null && item1.Others != undefined) {
                item1.Treatment = item1.Others
              }
              if (PestTreatment != "")
                PestTreatment = PestTreatment + "||" + item1.Frequency + '~' + item1.PestName + "~" + item1.Treatment
              else
                PestTreatment = item1.Frequency + '~' + item1.PestName + "~" + item1.Treatment
            })
            groupFreq.push({
              Frequency: key,
              PestName: item.map(function (obj) { return obj.PestName; }).join(','),
              PestCode: item.map(function (obj) { return obj.PestCode; }).join(','),
              Treatment: item.map(function (obj) { return obj.Treatment; }).join(','),
              PestTreatment: PestTreatment
            })
          })

          var Assigned = $scope.vm.AssignedTo.map(function (obj) { return obj.id; }).join(',');
          Assigned = Assigned.split(',')

          var firstScheduledData = []

          angular.forEach(groupFreq, function (item) {
            if (firstScheduledData.length == 0) {
              if (item.Frequency.toLocaleLowerCase() == "ad-hoc") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt)
                ettime.setHours(23, 59, 59, 999)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 1)) {
                  var currentDate = new Date(i)
                  // if (currentDate.getDay() != 0) {
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  firstScheduledData.push({
                    id: firstScheduledData.length + 1,
                    PestType: item.PestName,
                    PestCode: item.PestCode,
                    ServiceOn: ServiceOn,
                    Startsat: new Date(currentDate),
                    Endsat: endDate,
                    Frequency: item.PestTreatment,
                    SameTeam: getSameTeam(Stdate, eendDate)
                  })
                  i = new Date(currentDate)
                  // }
                  // else {
                  //   if (currentDate.getDay() == 0)
                  //     var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                  //   var Stime = new Date($scope.vm.ServiceStartTime)
                  //   var Etime = new Date($scope.vm.ServiceEndTime)
                  //   j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  //   var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                  //   var endDate = new Date($scope.vm.SSEt)
                  //   endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  //   var Stdate = new Date(j)
                  //   Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                  //   var eendDate = new Date(j)
                  //   if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  //   eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  //   firstScheduledData.push({
                  //     id: firstScheduledData.length + 1,
                  //     PestType: item.PestName,
                  //     PestCode: item.PestCode,
                  //     ServiceOn: ServiceOn,
                  //     Startsat: new Date(j),
                  //     Endsat: endDate,
                  //     Frequency: item.PestTreatment,
                  //     SameTeam: getSameTeam(Stdate, eendDate)
                  //   })
                  //   i = new Date(j)
                  // }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }
              else if (item.Frequency === "10 Days") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt)
                ettime.setHours(23, 59, 59, 999)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 10)) {
                  var currentDate = new Date(i)
                  if (currentDate.getDay() != 0 && currentDate.getDay() != 6) {
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(currentDate)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                    var eendDate = new Date(currentDate)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                  else {
                    if (currentDate.getDay() == 0)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    else if (currentDate.getDay() == 6)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 2))
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(j)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(j),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }
              else if (item.Frequency === 'Twice a Week (104)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Alternate Twice a Week')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0

                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")",
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""

                    Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")",
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")",
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""

                    Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")",
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Weekly')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency === 'Alternate Week (52)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                var ccount = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      var PestCode = ""
                      if (ccount % 2 == 0) {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                        PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      }
                      else {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                        PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      }
                      ccount++
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""
                    var PestCode = ""
                    if (ccount % 2 == 0) {
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                      PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                    }
                    else {
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                      PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                    }
                    ccount++
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Fortnightly')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 52
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 39
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 26
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 14)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  } else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }

                }
              }
              else if (item.Frequency.includes('Twice a Month (24)')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                var WeekofMonth = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 48
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 36
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 24
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // if(count>0){
                  //   while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                  //   WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                  //     currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                  //   }
                  // }
                  // else{
                  //    WeekofMonth = Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7);
                  //    if(WeekofMonth==5) WeekofMonth=4
                  // }
                  // if(new Date(currentDate).getDate()>15) currentDate.setDate(j.getDate() - 7)
                  if (count > 0) {
                    //  if(WeekofMonth>=3)WeekofMonth=2
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = parseInt((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1
                    if (WeekofMonth == 1) WeekofMonth = 1
                    else if (WeekofMonth == 2) WeekofMonth = 2
                    else if (WeekofMonth == 3) {
                      WeekofMonth = 1
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)

                      var Stime = new Date($scope.vm.ServiceStartTime)
                      var Etime = new Date($scope.vm.ServiceEndTime)
                      currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                      var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                      var endDate = new Date($scope.vm.SSEt)
                      endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                      var Stdate = new Date(currentDate)
                      Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                      var eendDate = new Date(currentDate)
                      if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                      eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      currentDate = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    }
                    else if (WeekofMonth == 4) {
                      WeekofMonth = 2
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)

                      var Stime = new Date($scope.vm.ServiceStartTime)
                      var Etime = new Date($scope.vm.ServiceEndTime)
                      currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                      var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                      var endDate = new Date($scope.vm.SSEt)
                      endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                      var Stdate = new Date(currentDate)
                      Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                      var eendDate = new Date(currentDate)
                      if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                      eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      currentDate = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    }
                    else if (WeekofMonth == 5) {
                      WeekofMonth = 1
                      i = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)
                    }
                  }
                  var monthcount = 0
                  var monthEnd = new Date(new Date(currentDate).getFullYear(), new Date(currentDate).getMonth() + 1, 0)
                  monthEnd.setHours(23, 59, 59, 999)
                  for (var j = new Date(currentDate); monthcount < 2 && j < monthEnd; j.setDate(j.getDate() + 14)) {
                    if (firstScheduledData.length > 0 && moment(j).diff(moment(firstScheduledData[firstScheduledData.length - 1].Startsat), 'days') == 7) { j < monthEnd; j.setDate(j.getDate() + 7) }

                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(j)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    if (fnum > 0) {
                      if (count < fnum) {
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Stdate, eendDate)
                        })
                      }
                      count++
                      monthcount++;
                    } else {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(j),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      monthcount++;
                    }

                  }
                  i = new Date(currentDate.setDate(1))
                }
              }
              else if (item.Frequency === 'Monthly (12)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var WeekofMonth = 0
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 24
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 18
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 12
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // get week of the month

                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                    // WeekofMonth = Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7);
                    // if(WeekofMonth==5) WeekofMonth=4
                  }

                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Bi-Monthly (6)") {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 12
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 9
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 6
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // get week of the month

                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency.includes('Quarterly')) {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 8
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 6
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 4
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Half Yearly (2)") {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 4
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 3
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 2
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Yearly (1)") {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 2
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 1
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }

            }
            else {
              if (item.Frequency === 'Twice a Week (104)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency === 'Alternate Twice a Week (104)') {

                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++

                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]

                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++

                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Weekly')) {

                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency === 'Alternate Week (52)') {
                var ccount = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      var PestCode = ""
                      if (ccount % 2 == 0) {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                        PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      }
                      else {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                        PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      }
                      ccount++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + PestCode
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Fortnightly')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 14)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=26){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Twice a Month (24)')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var STDate = new Date($scope.vm.SSAt)
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 48
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 36
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 24
                var data = []
                var currentDate = new Date(new Date(STDate).setDate(1))
                var startofthedata = new Date(new Date(currentDate).setDate(1))
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var fiitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                fiitem = _.sortBy(fiitem, "Startsat")
                var a = 1, b = 3
                if (fiitem.length) {
                  var WeekofMonth = parseInt((new Date(fiitem[0].Startsat).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  if (WeekofMonth == 2 || WeekofMonth == 4) {
                    a = 2, b = 4
                  }
                  var fdate1 = nthWeekdayOfMonth($scope.selected[0].id, a, currentDate)
                  var item1 = fiitem.filter(function (item1) {
                    return (new Date(item1.Startsat).getDate() === new Date(fdate1).getDate())
                  })
                  var fdate2 = nthWeekdayOfMonth($scope.selected[0].id, b, currentDate)
                  var item2 = fiitem.filter(function (item2) {
                    return (new Date(item2.Startsat).getDate() === new Date(fdate2).getDate())
                  })
                  if (item1.length > 0) {
                    item1[0].PestType = item1[0].PestType + "," + item.PestName
                    item1[0].PestCode = item1[0].PestCode + "," + item.PestCode
                    item1[0].Frequency = item1[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item1)
                  } else {
                    fiitem[0].PestType = fiitem[0].PestType + "," + item.PestName
                    fiitem[0].PestCode = fiitem[0].PestCode + "," + item.PestCode
                    fiitem[0].Frequency = fiitem[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(fiitem)
                  }
                  if (item2.length > 0) {
                    if (item2[0].Startsat != fiitem[0].Startsat) {
                      item2[0].PestType = item2[0].PestType + "," + item.PestName
                      item2[0].PestCode = item2[0].PestCode + "," + item.PestCode
                      item2[0].Frequency = item2[0].Frequency + "||" + item.PestTreatment
                      data = data.concat(item2)
                    }

                  } else {
                    var stdate = new Date(moment(new Date(fiitem[0].Startsat)).add(14, 'days'))
                    if (new Date(stdate).getMonth() === new Date(fiitem[0].Startsat).getMonth()) {
                      var bitem1 = fiitem.filter(function (bitem1) {
                        return (new Date(bitem1.Startsat).getDate() === new Date(stdate).getDate())
                      })
                      if (bitem1.length > 0) {
                        bitem1[0].PestType = bitem1[0].PestType + "," + item.PestName
                        bitem1[0].PestCode = bitem1[0].PestCode + "," + item.PestCode
                        bitem1[0].Frequency = bitem1[0].Frequency + "||" + item.PestTreatment
                        data = data.concat(bitem1)
                      }
                    }
                  }
                }
                STDate = new Date(new Date(STDate).setMonth(new Date(STDate).getMonth() + 1, 1))
                for (var i = new Date(STDate); i < new Date($scope.vm.SSEt); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  var fdate1 = nthWeekdayOfMonth($scope.selected[0].id, a, currentDate)
                  var item1 = iitem.filter(function (item1) {
                    return (new Date(item1.Startsat).getDate() === new Date(fdate1).getDate())
                  })
                  var fdate2 = nthWeekdayOfMonth($scope.selected[0].id, b, currentDate)
                  var item2 = iitem.filter(function (item2) {
                    return (new Date(item2.Startsat).getDate() === new Date(fdate2).getDate())
                  })
                  if (item1.length > 0) {
                    item1[0].PestType = item1[0].PestType + "," + item.PestName
                    item1[0].PestCode = item1[0].PestCode + "," + item.PestCode
                    item1[0].Frequency = item1[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item1)
                  } else {
                    if (iitem.length > 0) {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      data = data.concat(fiitem)
                    }
                  }
                  if (item2.length > 0) {
                    item2[0].PestType = item2[0].PestType + "," + item.PestName
                    item2[0].PestCode = item2[0].PestCode + "," + item.PestCode
                    item2[0].Frequency = item2[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item2)
                  } else {
                    if (iitem.length > 0) {
                      var stdate = new Date(moment(new Date(iitem[0].Startsat)).add(14, 'days'))
                      if (new Date(stdate).getMonth() === new Date(iitem[0].Startsat).getMonth()) {
                        var bitem1 = iitem.filter(function (bitem1) {
                          return (new Date(bitem1.Startsat).getDate() === new Date(stdate).getDate())
                        })
                        if (bitem1.length > 0) {
                          bitem1[0].PestType = bitem1[0].PestType + "," + item.PestName
                          bitem1[0].PestCode = bitem1[0].PestCode + "," + item.PestCode
                          bitem1[0].Frequency = bitem1[0].Frequency + "||" + item.PestTreatment
                          data = data.concat(bitem1)
                        }
                      }
                    }
                  }
                  firstScheduledData = _.differenceBy(firstScheduledData, data, "id")
                  firstScheduledData = firstScheduledData.concat(data)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  i = new Date(currentDate.setDate(1))
                }
              }
              else if (item.Frequency === 'Monthly (12)') {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var firstDate = new Date(firstScheduledData[0].Startsat)
                var count = 0
                var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  if (WeekofMonth == 5) {
                    var y = new Date(i).getFullYear()
                    var m = new Date(i).getMonth()
                    var w = $scope.selected[0].id
                    if (DaysinWeek(y, m, w) != 5) {
                      WeekofMonth = 4
                    }
                  }
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      count++
                    }
                    catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                  else {
                    var iitem = firstScheduledData.filter(function (iitem) {
                      return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                    })
                    if (iitem.length > 0) {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                        count++
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }
                    else {
                      if (count > 0) {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date(i)
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var sdate = new Date(j)
                        sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(sdate, eendDate)
                        })
                        count++
                      }
                      else {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date($scope.vm.SSAt)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var eendDate = new Date(j)
                        var sdate = new Date(j)
                        sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                    }
                  }

                }
              }
              else if (item.Frequency === "Bi-Monthly (6)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var firstDate = new Date(firstScheduledData[0].Startsat)
                var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                  if (WeekofMonth == 5) {
                    var y = new Date(i).getFullYear()
                    var m = new Date(i).getMonth()
                    var w = $scope.selected[0].id
                    if (DaysinWeek(y, m, w) != 5) {
                      WeekofMonth = 4
                    }
                  }
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                    } catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                  else {
                    var iitem = firstScheduledData.filter(function (iitem) {
                      return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                    })
                    if (iitem.length > 0) {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      } catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }
                    else {
                      if (count > 0) {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date(i)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var Sdate = new Date(j)
                        Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                      else {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date($scope.vm.SSAt)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var Sdate = new Date(j)
                        Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                    }

                  }
                }
              }
              else if (item.Frequency.includes('Quarterly')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  }
                  catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "Half Yearly (2)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "Yearly (1)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 0)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "10 Days") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 10)) {
                  var currentDate = new Date(i)
                  if (currentDate.getDay() != 0 && currentDate.getDay() != 6) {
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Sdate = new Date(currentDate)
                    Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                    var eendDate = new Date(i)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                    var iitem = []
                    iitem = firstScheduledData.filter(function (iitem) {
                      return new Date(iitem.Startsat).getTime() === new Date(currentDate).getTime()
                    })
                    if (iitem.length == 0) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Sdate, eendDate)
                      })
                      i = new Date(currentDate)
                    }
                    else {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }

                  }
                  else {
                    if (currentDate.getDay() == 0)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    else if (currentDate.getDay() == 6)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var Sdate = new Date(j)
                    Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                    var iitem = []
                    iitem = firstScheduledData.filter(function (iitem) {
                      return new Date(iitem.Startsat).getTime() === new Date(j).getTime()
                    })
                    if (iitem.length == 0) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(j),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Sdate, eendDate)
                      })
                      i = new Date(currentDate)
                    }
                    else {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                      i = new Date(currentDate)
                    }
                  }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }

            }
          })
          firstScheduledData = _.sortBy(firstScheduledData, "Startsat")

          try {
            if ($scope.vm.BillingFrequency == "COD") {
              var count = 0
              angular.forEach(firstScheduledData, function (item) {
                count++;
                item.XeroInvoice = true
                item.XeroCount = count
              })
            }
            else if ($scope.vm.BillingFrequency == "Weekly") {
              var count = 0
              var SSAt = new Date(firstScheduledData[0].Startsat);

              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date(SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                var currentDate = new Date(i)
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                // if(count<=52){
                angular.forEach(firstScheduledData, function (vitem) {
                  if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                    count++
                    vitem.XeroInvoice = true
                    vitem.XeroCount = count
                  }
                })
                // }
              }
            }
            else if ($scope.vm.BillingFrequency == "Monthly") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var firstDate = new Date(firstScheduledData[0].Startsat)
              var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                if (WeekofMonth == 5) {
                  var y = new Date(i).getFullYear()
                  var m = new Date(i).getMonth()
                  var w = $scope.selected[0].id
                  if (DaysinWeek(y, m, w) != 5) {
                    WeekofMonth = 4
                  }
                }
                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                })
                if (iitem.length > 0) {
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    count++
                    iitem[0].XeroInvoice = true
                    iitem[0].XeroCount = count

                  }
                  catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
                else {
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      count++
                      iitem[0].XeroInvoice = true
                      iitem[0].XeroCount = count
                    }
                    catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }

                }

              }

            }
            else if ($scope.vm.BillingFrequency === "Bi-Monthly (6)") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var firstDate = new Date(firstScheduledData[0].Startsat)
              var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                if (WeekofMonth == 5) {
                  var y = new Date(i).getFullYear()
                  var m = new Date(i).getMonth()
                  var w = $scope.selected[0].id
                  if (DaysinWeek(y, m, w) != 5) {
                    WeekofMonth = 4
                  }
                }
                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                })
                if (iitem.length > 0) {
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    count++
                    iitem[0].XeroInvoice = true
                    iitem[0].XeroCount = count
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
                else {
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      count++
                      iitem[0].XeroInvoice = true
                      iitem[0].XeroCount = count
                    } catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                }
              }
            } else if ($scope.vm.BillingFrequency === "Quarterly") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 1)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count++
                }
                catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
            else if ($scope.vm.BillingFrequency === "Half Yearly (2)") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 1)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count
                } catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
            else if ($scope.vm.BillingFrequency === "Yearly") {
              var Count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 0)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count
                } catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
          } catch (error) {

          }


          previewdata = firstScheduledData
          if ($scope.Holidays.value == true) {
            angular.forEach(previewdata, function (value, key) {
              var HollydayDate = new Date(value.Startsat).setHours(0, 0, 0, 0);
              if ($scope.vm.SFOPH == "Next Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  var Startsat = new Date(new Date(value.Startsat).setDate(new Date(value.Startsat).getDate() + 1));
                  var item = []
                  item = previewdata.filter(function (item) {
                    return new Date(item.Startsat).getTime() == new Date(Startsat).getTime()
                  })
                  if (item.length > 0) {
                    value.Startsat = new Date(new Date(Startsat).setDate(new Date(Startsat).getDate() + 1));
                  }
                  else {
                    value.Startsat = new Date(Startsat)
                  }
                  var Sdate = new Date(value.Startsat)
                  Sdate.setHours(Sdate.getHours(), Sdate.getMinutes() + 1, 59, 999)
                  var eendDate = new Date(Sdate)
                  if (new Date(value.Endsat) == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(value.Endsat.getHours(), value.Endsat.getMinutes() - 1, 0, 0)
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Previous Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  var Startsat = new Date(new Date(value.Startsat).setDate(new Date(value.Startsat).getDate() - 1));
                  var item = []
                  item = previewdata.filter(function (item) {
                    return new Date(item.Startsat).getTime() == new Date(Startsat).getTime()
                  })
                  if (item.length > 0) {
                    value.Startsat = new Date(new Date(Startsat).setDate(new Date(Startsat).getDate() - 1));
                  }
                  else {
                    value.Startsat = new Date(Startsat)
                  }
                  var Sdate = new Date(value.Startsat)
                  Sdate.setHours(Sdate.getHours(), Sdate.getMinutes() + 1, 59, 999)
                  var eendDate = new Date(Sdate)
                  if (new Date(value.Endsat) == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(value.Endsat.getHours(), value.Endsat.getMinutes() - 1, 0, 0)
                  value.SameTeam = getSameTeam(Sdate, eendDate)
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Skip") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  previewdata.splice(key, 1)
                }
              }
            })
          }
          previewdata = _.uniqBy(previewdata, function (o) { return new Date(o.Startsat).getTime() })
          try {
            //previewdata = _.uniqWith(previewdata, _32.isEqual);
            var item = previewdata.filter(function (item) {
              return new Date(item.Startsat).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
            //  var item = previewdata
            var ASchearray = [];
            var PreferDays = ""
            if ($scope.vm.PreferredDays != undefined && $scope.vm.PreferredDays != "" && $scope.vm.PreferredDays != null) {
              $scope.vm.PreferredDays = _.sortBy($scope.vm.PreferredDays, "id")
              PreferDays = $scope.vm.PreferredDays.map(function (obj) { return obj.names; }).join(',');
            }

            else
              PreferDays = ""
            var sd = 0;
            // angular.forEach($scope.vm.PestType, function (Freq) {
            //   var key = 0;
            //   angular.forEach(item, function (value, index) {
            //     if (value.Frequency == Freq.Frequency) {
            //       key++;
            //       if (Freq.ServicesRequired > 0 && key > (Freq.ServicesRequired * $scope.selected.length)) {
            //         item.splice(index, 1);
            //       }
            //     }
            //   })
            // });
            angular.forEach($scope.ServiceAddressarray, function (value) {
              angular.forEach(item, function (subvalue, key) {
                var sz = 'SVC-' + ('000000' + (1 + sd + schedulerdatasforlength)).slice(-6);
                var isSameDate = false;
                angular.forEach(ASchearray, function (ditem) {
                  if ($filter('date')(ditem.Startsat, 'dd/MM/yyyy') == $filter('date')(subvalue.Startsat, 'dd/MM/yyyy')
                    && ditem.Frequency != subvalue.Frequency) {
                    try {
                      // var array = (ditem.PestType + ',' + subvalue.PestType).split(',');
                      // var filteredArray = array.filter(function (item, pos) {
                      //   return array.indexOf(item) == pos;
                      // }); 
                      ditem.PestType = ditem.PestType + ',' + subvalue.PestType;
                      ditem.PestCode = ditem.PestCode + ',' + subvalue.PestCode;
                      // ditem.PestType = filteredArray.map(function (obj) { return obj; }).join(',');
                    } catch (e) { }
                    isSameDate = true;
                  }
                })
                if (isSameDate == false) {
                  ASchearray.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: Assigned,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    XeroInvoice: subvalue.XeroInvoice == true ? true : false,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    BillingAmount: $scope.vm.BillingAmount,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    AccountsNotes: $scope.vm.Notes,
                    Message: $scope.vm.Message,
                    TeamName: $scope.vm.ppTeamName,
                    TeamMembersName: $scope.vm.TM,
                    PreferredTime: PreferDays,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  $scope.previewdatas.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    XeroInvoice: subvalue.XeroInvoice == true ? true : false,
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    AccountsNotes: $scope.vm.Notes,
                    Message: $scope.vm.Message,
                    PreferredTime: $scope.vm.PreferredTime,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  console.log(sd)
                  sd++;
                }
              })
            })
          } catch (e) { }
          $scope.previewGridDatas = ASchearray;
          $scope.AllPreviewGridDatas = ASchearray;
          if (type != "RescheduleSubmit") {
            $mdDialog.show({
              multiple: true,
              templateUrl: 'app/main/apps/operations/scheduler/Previewschedule.html',
              parent: angular.element($document.body),
              targetEvent: M,
              scope: $scope.$new(),
              controller: function operationsProjectController($scope, $mdDialog) {
                $scope.closeDialog = function () {
                  $mdDialog.hide();
                }
              }
            });
          }
          else {
            $scope.newPreviewGridDatas = ASchearray;
            $scope.newAllPreviewGridDatas = ASchearray;

            var maxLength = Math.max($scope.newPreviewGridDatas.length, $scope.scheduledServices.length);

            for (var i = 0; i < maxLength; i++) {
              var previewItem = $scope.newPreviewGridDatas[i];
              var serviceItem = $scope.scheduledServices[i];
              var firstService = $scope.scheduledServices[0]

              if (previewItem && serviceItem) {
                // Update only these fields
                previewItem.OldStartsat = serviceItem.Startsat;
                previewItem.OldEndsat = serviceItem.Endsat;
                previewItem._id = serviceItem.id;
              } else if (previewItem && !serviceItem) {
                // Clear old values if no matching service
                previewItem.OldStartsat = null;
                previewItem.OldEndsat = null;
                previewItem.JobsOrders = firstService.JobsOrders;
                previewItem.Customer = firstService.Customer;
                previewItem.AssignedTo = [firstService.AssignedTo];
                previewItem.Frequency = firstService.Frequency;
                previewItem.Status = "Yet to Start";
                previewItem.Types = $scope.scheduledServices[$scope.scheduledServices.length - 1].Types;
                previewItem.PestType = firstService.PestType;
                previewItem.PestCode = firstService.PestCode;
                previewItem.XeroInvoice = firstService.XeroInvoice;
                previewItem.JobContinues = firstService.JobContinues;
                previewItem.ContractOrder = firstService.ContractOrder;
                previewItem.ServiceID = firstService.ServiceID;
                previewItem.Location = firstService.Location;
                previewItem.ContactNumber = firstService.ContactNumber;
                previewItem.ContactPerson = firstService.ContactPerson;
                previewItem.CustomerService_Id = firstService.CustomerService_Id;
                previewItem.SameTeam = firstService.SameTeam;
                previewItem.BillingAmount = firstService.BillingAmount;
                previewItem.ScheduleType = firstService.ScheduleType;
                previewItem.JobType = firstService.JobType;
                previewItem.Duplicate = firstService.Duplicate;
                previewItem.LatLong = firstService.LatLong;
                previewItem.SpecialRemark = firstService.SpecialRemark;
                previewItem.AccountsNotes = firstService.AccountsNotes;
                previewItem.Message = firstService.Message;
                previewItem.TeamName = firstService.TeamName;
                previewItem.TeamMembersName = firstService.TeamMembersName;
                previewItem.PreferredTime = firstService.PreferredTime;
                previewItem.PreferredStartTime = firstService.PreferredStartTime;
                previewItem.PreferredEndTime = firstService.PreferredEndTime;
                previewItem.AvoidStartTime = firstService.AvoidStartTime;
                previewItem.AvoidEndTime = firstService.AvoidEndTime;
                previewItem.Team_Id = firstService.Team_Id;
                previewItem.Client_Id = firstService.Client_Id;
                previewItem.CreatedBy = $rootScope.createdby
              } else if (!previewItem && serviceItem) {
                // Add a new entry with just the two new fields
                $scope.newPreviewGridDatas.push({
                  _id: serviceItem.id,
                  OldStartsat: serviceItem.Startsat,
                  OldEndsat: serviceItem.Endsat,
                  ServiceID: serviceItem.ServiceID,
                  PestCode: serviceItem["PestType"],
                  extra: true
                });
              }
            }

            $scope.newPreviewGridDatas[0].Types = $scope.scheduledServices[0].Types

            $mdDialog.show({
              multiple: true,
              templateUrl: 'app/main/apps/operations/scheduler/PreviewforReschedule.html',
              parent: angular.element($document.body),
              targetEvent: M,
              scope: $scope.$new(),
              controller: function operationsProjectController($scope, $mdDialog) {
                $scope.closeDialog = function () {
                  $mdDialog.hide();
                }
              }
            });
          }
          try {
            var dupitem = [];
            dupitem = ASchearray.filter(function (dupitem) {
              return dupitem.Duplicate === true;
            });
            $scope.vm.DuplicateCount = dupitem.length;
          } catch (e) { }
          $scope.vm.ServiceID = null;
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.vm.PreviewSpinner = false;
          $scope.vm.ShowDuplicate = false;
          $scope.vm.RemoveDuplicate = false;
        });


    }

    function DaysinWeek(year, month, week) {

      var day, counter, date;

      day = 1;
      counter = 0;
      date = new Date(year, month, day);
      while (date.getMonth() === month) {
        if (date.getDay() === week) { // Sun=0, Mon=1, Tue=2, etc.
          counter += 1;
        }
        day += 1;
        date = new Date(year, month, day);
      }
      return counter;
    }

    $scope.addadhoc = function (e) {
      $scope.vm.billingAddresses = []
      $scope.vm.serviceAddresses = []
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomAdd.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        },
        onComplete: function (scope, element) {
          update_contact_email_field(scope);
        }
      });
      $scope.vm.selectedCustomer = null
      $scope.vm.ABEMail = []
      $scope.vm.ASEmail = []
      $scope.vm.ACompanyName = ""
      vm.ACompanyName = ""
      $scope.vm.searchCompanyText = ""
      $scope.vm.AContactName = ""
      $scope.vm.ATotalPrice = 0
      $scope.vm.APaymentMode = ""
      $scope.vm.ABillingFrequency = ""
      $scope.vm.AAssignedTo = ""
      $scope.vm.ASalesperson = ""
      $scope.vm.AManHour = 0
      $scope.vm.ARemarks = ""
      $scope.treeBoxValue = []
      $scope.vm.AStartTime = new Date()
      $scope.vm.AEndTime = new Date()
      $scope.vm.ABillingAddress = ""
      $scope.vm.ABPostal = null
      $scope.vm.AServicesAddress = ""
      $scope.vm.ASPostal = null

      $scope.treeBoxValue = [];
      $scope.ApestType = [];


      $scope.treeBoxValue = [];
      if ($scope.treeViewInstance) {
        $scope.treeViewInstance.unselectAll(); // clear UI selection
      }
    }


    var treeView;

    var syncTreeViewSelection = function (treeView) {
      if (!treeView) return;

      if (!$scope.treeBoxValue) {
        treeView.unselectAll();
        return;
      }

      $scope.treeBoxValue.forEach(function (key) {
        treeView.selectItem(key);

      });

    };

    $scope.treeBoxValue = [];
    $scope.ApestType = [];

    $scope.treeBoxOptions = {
      onInitialized: function (e) {
        $scope.treeBoxInstance = e.component;
      },
      bindingOptions: {
        value: 'treeBoxValue',
        dataSource: "PestTreatmentMethod",
        'treeView.dataSource': "PestTreatmentMethod"
      },
      valueExpr: "ID",
      displayExpr: "name",
      placeholder: "Select a value...",
      showClearButton: true,
      grouped: true,
      dataSource: $scope.PestTreatmentMethod,
      onValueChanged: function () {
        syncTreeViewSelection(treeView);
      },
      treeView: {
        dataSource: $scope.PestTreatmentMethod,
        dataStructure: "plain",
        keyExpr: "ID",
        parentIdExpr: "categoryId",
        displayExpr: "name",
        selectByClick: true,
        selectNodesRecursive: false,
        showCheckBoxesMode: "normal",
        // searchEnabled: true,
        grouped: true,
        bindingOptions: {
          selectionMode: "selectionMode"
        },
        onContentReady: function (e) {
          $scope.treeViewInstance = e.component;  // save reference here
          syncTreeViewSelection($scope.treeViewInstance);
        },
        onItemSelectionChanged: function (args) {
          $scope.treeBoxValue = args.component.getSelectedNodesKeys()
          // var selected = args.node.itemData
          // if(!selected.ID.includes('~')){
          //   if(selected.selected){
          //     var child = args.node.children
          //     var childelem = []
          //     child.forEach(function(item){
          //       childelem.push(item.key)
          //     })
          //     childelem = childelem.concat($scope.treeBoxValue)
          //     $scope.treeBoxValue = [selected.name].concat(childelem)
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          //   else{
          //     var child = args.node.children
          //     var childelem = []
          //     child.forEach(function(item){
          //       childelem.push(item.key)
          //     })
          //     var removeitem = [selected.name].concat(childelem)
          //     $scope.treeBoxValue =  _.differenceWith(removeitem, $scope.treeBoxValue, _.isEqual);
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //     removeitem.forEach(function(item){
          //       treeView.unselectItem(item)
          //     })
          //   }
          // }
          // else{
          //   if(selected.selected){
          //     $scope.treeBoxValue = [selected.name].concat($scope.treeBoxValue)
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          //   else{

          //     var removeitem = [selected.name]
          //     $scope.treeBoxValue =  _.differenceWith(removeitem, $scope.treeBoxValue, _.isEqual);
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          // }

        }
      },
    };

    function ReschedulScheduledWO(data, e) {

      getScheduledServices(data._id).then(function (List) {
        $scope.ServiceAddressarray = []
        $scope.scheduledServices = _.sortBy(List.data.data, 'Startsat');
        if ($scope.scheduledServices.length > 0) {
          var firstService = $scope.scheduledServices[0]

          $scope.vm.TM = firstService.TeamMembersName
          $scope.vm.ServiceStartAt = firstService.Startsat
          $scope.vm.ServiceEndAt = $scope.scheduledServices[$scope.scheduledServices.length - 1].Endsat
          $scope.vm.uContactPerson = firstService.ContactPerson
          $scope.vm.SiteContactNumber = firstService.ContactNumber
          $scope.vm.ServiceStartTime = firstService.Startsat
          $scope.vm.ServiceEndTime = firstService.Endsat
          $scope.vm.PreferredDays = firstService.PreferredTime
          $scope.vm.AssignedTo = $scope.teamdatas.filter(function (data) { return data.id == firstService.AssignedTo })
          $scope.getTeamTable($scope.vm.AssignedTo)
          $http({
            method: 'POST',
            url: $rootScope.WebURL + '/customerService/getcustomerserviceaddressdetailsbyID',
            data: { _id: firstService.CustomerService_Id }
          }).then(function (List) {
            $scope.ServiceAddressarray.push(List.data.data[0])

          })

          $scope.dateBox = {
            ServiceStartTime: {
              type: "time",
              value: $scope.vm.ServiceStartTime,
              onValueChanged: function (e) {
                $scope.vm.ServiceStartTime = e.value
              },
              bindingOptions: {
                'value': 'vm.ServiceStartTime'
              }
            },
            ServiceEndTime: {
              type: "time",
              value: $scope.vm.ServiceEndTime,
              onValueChanged: function (e) {
                $scope.vm.ServiceEndTime = e.value
              },
              bindingOptions: {
                'value': 'vm.ServiceEndTime'
              }
            }
          }

          $scope.vm.ppWorkOrder = data.SalesOrderNo
          $scope.vm.ppCompanyName = data.CompanyName
          $scope.vm.Twiceday = null
          $scope.vm.SFOPH = "Next Day"
          $scope.vm.SiteAddress = data.SiteAddress
          data.MultiFrequency.forEach(function (data) {
            data.PestName = data.PestType
          })
          $scope.vm.PestType = data.MultiFrequency
          $scope.vm.BillingFrequency = data.BillingFrequency
          if ($scope.selected.length === $scope.items.length) {
            $scope.selected = [];
          } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
            $scope.selected = [];
          }

          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/RescheduleNewAdd.html',
            parent: angular.element($document.body),
            targetEvent: e,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
        }
        else {
          $mdToast.show($mdToast.simple().textContent('There is no "Yet to Start" Scheduled Jobs found for this Treatment Instructions').position('top center'));
        }
      })

    }

    function getScheduledServices(id) {
      return $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getscheduledServices",
        data: { salesOrderId: id },
      })
    }

    function update_contact_email_field(scope) {
      var emailInput1 = angular.element(document.querySelector('#BillingEmail input[placeholder="Email"]'));
      var emailInput2 = angular.element(document.querySelector('#ServiceEmail input[placeholder="Email"]'));

      emailInput1.on('blur', function () {
        var val = emailInput1.val().trim();
        scope.$apply(function () {
          scope.vm.Email1ChipWarning = !!val;
        });
      });

      emailInput2.on('blur', function () {
        var val = emailInput2.val().trim();
        scope.$apply(function () {
          scope.vm.Email2ChipWarning = !!val;
        });
      });
    }

    $scope.transformChip = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    $scope.transformChip1 = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError1 = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError1 = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };



    $scope.CheckForFrequency = function (pesttType) {
      var item = pesttType.filter(function (item) {
        return item.Frequency.includes('Twice a Week')
      })
      if (item.length > 0) {
        $scope.vm.Twiceday = null;
        $scope.selected = []
      }
      else {
        if ($scope.vm.Twiceday != null) $scope.vm.Twiceday = null
      }
    }

    function getSameTeam(a, b) {
      var item = []
      item = $scope.Teamtabledata.filter(function (item) {
        //  a = new Date(a)
        //  a.setHours(new Date(a).getHours(),new Date(a).getMinutes()+1,new Date(a).getSeconds(),new Date(a).getMilliseconds())
        if (new Date(a).getHours() == 0) {
          a = new Date(new Date(a).setDate(new Date(a).getDate() + 1))
          a.setHours(new Date(a).getHours(), new Date(a).getMinutes(), 0, 0)
          a = new Date(a).getTime()
        }
        if (new Date(b).getHours() == 0) {
          b = new Date(new Date(b).setDate(new Date(b).getDate() + 1))
          b.setHours(new Date(b).getHours(), new Date(b).getMinutes(), 0, 0)
          b = new Date(b).getTime()
        }

        //  b = new Date(b)
        //  b.setHours(new Date(b).getHours(),new Date(b).getMinutes()-1,new Date(b).getSeconds(),new Date(b).getMilliseconds())
        b = new Date(b).getTime()

        var x = new Date(item.Startsat).getTime()
        var y = new Date(item.Startsat)
        y.setHours(new Date(item.Endsat).getHours(), new Date(item.Endsat).getMinutes(), new Date(item.Endsat).getSeconds(), new Date(item.Endsat).getMilliseconds())
        y = y.getTime()
        return (Math.min(x, y) <= Math.max(a, b) && Math.max(x, y) >= Math.min(a, b) && item.Status == "Yet to Start" && item.VerifiedBy == true && item.IsActive == true)
      })
      if (item.length == 0) return "No";
      else {
        var iitem = item.filter(function (iitem) {
          return iitem.JobType === "Fixed"
        })
        if (iitem.length == 0) return "Yes"
        else return "Fixed"
      }

    }
    var ALatLong = "103.8677,1.3554";


    $scope.sCustomScheduler = function (M) {
      $scope.vm.PreviewSpinner = true;
      var TeamId = $scope.vm.AAssignedTo
      $scope.vm.EstimationHr = $scope.vm.AManHour
      $scope.vm.ServiceStartTime = $scope.vm.AStartTime
      if (TeamId != undefined) {
        var TeamID = TeamId.map(function (obj) { return obj.id; }).join(',');
        $scope.vm.TM = _.uniq(TeamId.map(function (obj) { return obj.TeamMembers; }).join(',').split(','))
        $scope.vm.ppTeamName = TeamId.map(function (obj) { return obj.TeamName; }).join(',');
        $scope.vm.TeamEstimationHr = ($scope.vm.EstimationHr / TeamId.length) % 1 == 0 ? $scope.vm.EstimationHr / TeamId.length : ($scope.vm.EstimationHr / TeamId.length).toFixed(2)
        $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
      }
      else {
        var TeamID = []
        $scope.vm.TM = null
        $scope.vm.ppTeamName = null
      }
      try {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getTeamforDate",
          method: "POST",
          data: {
            Start_Date: $scope.vm.AStartTime, End_Date: $scope.vm.AEndTime,
            Client_Id: $rootScope.Client_Id, Team_Id: TeamID
          },
        });
        response.then(function (GList) {
          var Fteam = GList.data.data;
          $scope.Teamtabledata = Fteam;

          $http.get($rootScope.WebURL + "/scheduler/getLength")
            .then(function (scheduler) {
              var schedulerdatasforlength = scheduler.data.data;
              var sd = 1
              var sz = 'SVC-' + ('000000' + (sd + schedulerdatasforlength)).slice(-6);

              var firstScheduledData = []
              $scope.ApestType = []
              if (!$scope.treeViewInstance) {
                $scope.vm.PreviewSpinner = false;
                $mdToast.show($mdToast.simple().textContent('Please select the Pest type').position('top center'));
                return
              }
              var arr = $scope.treeViewInstance._getOptionValue().dataSource.filter(function (o) { return o.selected === true })
              arr.forEach(function (item) {
                if (!item.categoryId) {
                  var pest = item.ID;
                  var children = arr.filter(function (child) { return child.categoryId === pest });
                  if (children.length === 0) {
                    $scope.ApestType.push({ Frequency: "Ad-Hoc", PestType: pest, Treatment: "" });
                  } else {
                    children.forEach(function (child) {
                      $scope.ApestType.push({ Frequency: "Ad-Hoc", PestType: pest, Treatment: child.name });
                    });
                  }
                }
              });

              angular.forEach($scope.ApestType, function (value) {
                try {
                  var pt = $scope.Pesttypedatas.filter(function (pt) {
                    return value.PestType == pt.PestName;
                  })[0];
                  value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
                } catch (e) { }
              })

              var pestName = []

              $scope.ApestType.forEach(function (o) {
                if (pestName.indexOf(o.PestType) === -1) {
                  pestName.push(o.PestType)
                }
              })
              $scope.vm.APest = pestName.join(",")

              $scope.vm.APest = $scope.ApestType.map(function (o) { return o.PestType }).join(',')
              var pestCodes = [];
              $scope.ApestType.forEach(function (o) {
                if (pestCodes.indexOf(o.PestCode) === -1) {
                  pestCodes.push(o.PestCode);
                }
              });
              $scope.vm.APestCode = pestCodes.join(',');
              var groupedFrequency = _.groupBy($scope.ApestType, 'PestType');

              var groupFreq = []
              var groupTreatment = []
              angular.forEach(groupedFrequency, function (item) {
                var PestTreatment = ""
                angular.forEach(item, function (item1) {

                  if (PestTreatment != "")
                    PestTreatment = PestTreatment + "||Ad-Hoc~" + item1.PestType + "~" + item1.Treatment
                  else
                    PestTreatment = "Ad-Hoc" + '~' + item1.PestType + "~" + item1.Treatment
                })
                groupTreatment.push({ PestTreatment: PestTreatment })
                groupFreq.push({
                  Frequency: "Ad-Hoc",
                  PestName: item.map(function (obj) { return obj.PestType; }).join(','),
                  PestCode: item.map(function (obj) { return obj.PestCode; }).join(','),
                  Treatment: item.map(function (obj) { return obj.Treatment; }).join(','),
                  PestTreatment: PestTreatment
                })
              })


              // angular.forEach(groupFreq, function (item) {
              // if (item.Frequency.toLocaleLowerCase() == "ad-hoc") {

              $scope.vm.SSAt = new Date($scope.vm.AStartTime);
              $scope.vm.SSEt = new Date($scope.vm.AEndTime);
              var ettime = new Date($scope.vm.AEndTime)
              ettime.setHours(23, 59, 59, 999)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 1)) {
                var sz = 'SVC-' + ('000000' + (sd + schedulerdatasforlength)).slice(-6);
                var currentDate = new Date(i)
                // if (currentDate.getDay() != 0) {
                var Stime = new Date($scope.vm.AStartTime)
                var Etime = new Date($scope.vm.AEndTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                var endDate = new Date($scope.vm.SSEt)
                endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                var Stdate = new Date(currentDate)
                Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                var eendDate = new Date(currentDate)
                if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                firstScheduledData.push({
                  id: firstScheduledData.length + 1,
                  ServiceID: sz,
                  PestType: $scope.vm.APest,
                  PestCode: $scope.vm.APestCode,
                  ServiceOn: ServiceOn,
                  Startsat: new Date(currentDate),
                  Endsat: endDate,
                  Frequency: groupTreatment,
                  SameTeam: getSameTeam(Stdate, eendDate),
                  Location: $scope.vm.AServicesAddress,
                  JobType: "Ad-Hoc"
                })
                i = new Date(currentDate)
                sd++
              }
              firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              // }
              // })
              var address = $scope.vm.AServicesAddress;

              var geocoder = new google.maps.Geocoder();
              if (geocoder) {
                geocoder.geocode({
                  'address': address
                }, function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    ALatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                  }
                });
              }
              $scope.previewdatas = firstScheduledData
              $scope.previewGridDatas = $scope.previewdatas
              $scope.vm.PreviewSpinner = false;
              $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/scheduler/CustomPreview.html',
                parent: angular.element($document.body),
                targetEvent: M,
                scope: $scope.$new(),
                controller: function operationsProjectController($scope, $mdDialog) {
                  $scope.closeDialog = function () {
                    $mdDialog.hide();
                  }
                }
              });

            })
        });
      }
      catch (e) { }
    }


    $scope.customPreviewsubmit = function () {
      $scope.vm.PreviewSpinner = true;
      var BEmail = null
      var SEmail = null
      var teaam = $scope.vm.AAssignedTo.map(function (obj) { return obj.id })
      var TeamName = $scope.vm.AAssignedTo.map(function (obj) { return obj.TeamName })
      if ($scope.vm.ABEMail != null && $scope.vm.ABEMail != "" && $scope.vm.ABEMail != undefined) BEmail = $scope.vm.ABEMail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.ASEmail != null && $scope.vm.ASEmail != "" && $scope.vm.ASEmail != undefined) SEmail = $scope.vm.ASEmail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.ASEmail.length == 0) SEmail = ""
      if ($scope.vm.ABEMail.length == 0) BEmail = ""
      if (!$scope.vm.ACompanyName) {
        $scope.vm.ACompanyName = vm.searchCompanyText;
        $scope.vm.ACompanyID = null// Free-text input
      }

      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/scheduler/createadhoc',
        data: {
          CustomerName: $scope.vm.ACompanyName,
          ContactName: $scope.vm.AContactName,
          TotalPrice: $scope.vm.ATotalPrice,
          PaymentMode: $scope.vm.APaymentMode,
          BillingFrequency: $scope.vm.ABillingFrequency,
          TeamId: teaam,
          TeamName: TeamName,
          Manhour: $scope.vm.AManHour,
          Remarks: $scope.vm.ARemarks,
          SalesPerson: $scope.vm.ASalesperson,
          Pest: $scope.vm.APest,
          StartTime: $scope.vm.AStartTime,
          EndTime: $scope.vm.AEndTime,
          BAddress: $scope.vm.ABillingAddress,
          BPostal: $scope.vm.ABPostal,
          BEmail: BEmail,
          SAddress: $scope.vm.AServicesAddress,
          SEmail: SEmail,
          SPostal: $scope.vm.ASPostal,
          MultiFrequency: $scope.ApestType,
          Client_Id: $rootScope.Client_Id,
          CreatedBy: $rootScope.createdby,
          SchedulerArray: $scope.previewGridDatas,
          LatLong: ALatLong,
          SameTeam: getSameTeam($scope.vm.AStartTime, $scope.vm.AEndTime),
        }
      }).then(function (List) {
        $mdDialog.cancel()
        $mdDialog.cancel()
        $scope.vm.PreviewSpinner = false;
        $scope.vm.ServiceID = null;
        $scope.previewdatas = [];
        RefreshGrid();
        RefreshCustomerdatas();
        $scope.getPendingSchedule()
        $scope.pesttypeGrid = true;
        $scope.shedulerform = true;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.exportbtn = true;
        $scope.thdata = false;
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
        $scope.ServiceAddressarray = [];
        $mdToast.show($mdToast.simple().textContent('Custom Schedule for ' + $scope.vm.ACompanyName + ' is created successfully!').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      })
    }

    function clonejob(e, data) {
      $scope.vm.Title = 'Clone the Job'
      $scope.Cloneschedule = data
      $scope.vm.RescheduleSpinner = false
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ResheduleSSTime = data.Startsat
      $scope.vm.ResheduleSETime = data.Endsat
      $scope.vm.AssignedTo = data.Team_Id
      $scope.vm.ResheduleSRemarks = data.SpecialRemarks
      $scope.Pestdatas = data.JobOrdersdetails[0].MultiFrequency
    }

    $scope.SubmitClone = function () {
      var value = $scope.Cloneschedule
      var data = ""
      $scope.vm.CPestType.forEach(function (item) {
        if (data == "")
          data = item.Frequency + "~" + item.PestType + "~" + item.Treatment
        else
          data = data + "||" + item.Frequency + "~" + item.PestType + "~" + item.Treatment
      })
      var ServiceOn = $filter('date')(new Date($scope.vm.ResheduleSFrom), 'EEEE');
      var currentDate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSSTime))
      var enddate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSETime))

      var serviceArray = [{
        JobsOrders: (value.JobsOrders),
        AssignedTo: ($scope.vm.CAssignedTo[0].id),
        Frequency: data,
        ServiceOn: ServiceOn,
        Types: value.Types,
        Status: "Yet to Start",
        Customer: (value.Customer),
        Startsat: currentDate,
        Endsat: enddate,
        CreatedBy: $rootScope.createdBy,
        PestType: $scope.vm.CPestType.map(function (o) { return o.PestType }).join(','),
        ContractOrder: value.ContractOrder,
        JobType: value.JobType,
        ServiceReportNo: value.ServiceReportNo,
        BillingAmount: value.BillingAmount,
        Billable: value.Billable,
        JobContinues: value.JobContinues,
        CollectPayment: value.CollectPayment,
        Location: value.Location,
        LatLong: value.LatLong,
        Client_Id: $rootScope.Client_Id,
        CustomerService_Id: (value.CustomerService_Id),
        ContactPerson: value.ContactPerson,
        ContactNumber: value.ContactNumber,
        Vehicle: value.Vehicle,
        ScheduleType: value.ScheduleType,
        SpecialRemark: $scope.vm.ResheduleSRemarks,
        PreferredTime: value.PreferredTime,
        PreferredStartTime: value.PreferredStartTime,
        PreferredEndTime: value.PreferredEndTime,
        AvoidStartTime: value.AvoidStartTime,
        AvoidEndTime: value.AvoidEndTime,
        Team_Id: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
        TeamName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamName }).join(','),
        TeamMembersName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamMembers }).join(','),

      }]
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/add",
        data: {
          ServiceArray: serviceArray
        }
      }).then(function (List) {
        $mdDialog.cancel()
        $mdToast.show($mdToast.simple().textContent('Successfully Added Service Jobs').position('top center'));
        RefreshGrid();
      })
    }

    function combineDateAndTime(date, time) {
      var d = new Date(date);
      var t = new Date(time);

      d.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), 0);
      return d;
    }

    $scope.NewGetByStatus = function () {
      if ($scope.vm.SelectedTab == 'PendingSchedule') {
        $scope.getPendingSchedule()
      }
      else if ($scope.vm.SelectedTab == 'Yet to Start') {
        NewGetScheduler("Yet to Start")
      }
      else if ($scope.vm.SelectedTab == "In-Progress") {
        $scope.getAllInProgress();
      }
      else if ($scope.vm.SelectedTab == 'Outstanding') {
        $scope.getOutsatnding();
      }
      else if ($scope.vm.SelectedTab == 'Completed') {
        NewGetScheduler("Completed")
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        NewGetScheduler("Pending Approval")
      }
      else if ($scope.vm.SelectedTab == 'ScheduledWorkOrder') {
        $scope.getScheduledWorkOrder()
      }
      else if ($scope.vm.SelectedTab == 'Cancelled') {
        $scope.getCancelled()
      }
      else if ($scope.vm.SelectedTab == 'On-Hold') {
        $scope.getOnHoldWorkOrder()
      }
    }

    function NewGetScheduler(status) {
      var baseUrl = $rootScope.WebURL;

      if (status === "Pending Approval") {
        $scope.vm.YTSPreviewSpinner = true;
        $scope.PendingApprovaldatas = [];

        $http({
          method: "POST",
          url: baseUrl + "/scheduler/lengthbystatus",
          data: {
            Client_Id: $rootScope.Client_Id,
            Status: "Completed",
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
          },
        }).then(function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          var Limit = 300;

          if (ContractLength === 0) {
            $scope.vm.YTSPreviewSpinner = false;
            return;
          }

          var requests = [];

          for (var i = 0; i < ContractLength; i++) {
            var Skip = i * Limit;
            requests.push(
              $http({
                method: "POST",
                url: baseUrl + "/scheduler/get",
                data: {
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo,
                  Client_Id: $rootScope.Client_Id,
                  Skip: Skip,
                  Limit: Limit,
                  Status: "Completed",
                  Team_Id: $scope.vm.filterteam,
                  Customer: $scope.SelectedCustomerID,
                  SalesOrder: $scope.Salesorderselected,
                },
              })
            );
          }

          $q.all(requests).then(function (responses) {
            responses.forEach(function (res) {
              var item = res.data.data.filter(function (item) {
                return item.ServiceReportStatus === "Pending";
              });

              $scope.PendingApprovaldatas = $scope.PendingApprovaldatas.concat(item);
            });

            $scope.PendingApprovaldatas = _.uniqWith($scope.PendingApprovaldatas, _.isEqual);
            $scope.vm.YTSPreviewSpinner = false;
          });
        });
      } else {
        $scope.vm.YTSPreviewSpinner = true;
        $scope.vm.CancelledPreviewSpinner = true;
        $scope.YettoStartdatas = [];
        $scope.Completeddatas = [];
        $scope.Cancelleddatas = [];

        $http({
          method: "POST",
          url: baseUrl + "/scheduler/lengthbystatus",
          data: {
            Client_Id: $rootScope.Client_Id,
            Status: status,
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
          },
        }).then(function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 500);
          var Limit = 500;

          if (ContractLength === 0) {
            $scope.vm.YTSPreviewSpinner = false;
            $scope.vm.CancelledPreviewSpinner = false;
            return;
          }

          var requests = [];

          for (var i = 0; i < ContractLength; i++) {
            var Skip = i * Limit;
            requests.push(
              $http({
                method: "POST",
                url: baseUrl + "/scheduler/get",
                data: {
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo,
                  Client_Id: $rootScope.Client_Id,
                  Status: status,
                  Skip: Skip,
                  Limit: Limit,
                  Team_Id: $scope.vm.filterteam,
                  Customer: $scope.SelectedCustomerID,
                  SalesOrder: $scope.Salesorderselected,
                },
              })
            );
          }

          $q.all(requests).then(function (responses) {
            var combined = [];

            responses.forEach(function (res) {
              combined = combined.concat(res.data.data);
            });

            combined = _.uniqWith(combined, _.isEqual);

            if (status === "Yet to Start") {
              $scope.YettoStartdatas = combined;
              $scope.vm.YTSPreviewSpinner = false;
            } else if (status === "Completed") {
              $scope.Completeddatas = combined;
              $scope.vm.YTSPreviewSpinner = false;
            } else if (status === "Cancelled") {
              $scope.Cancelleddatas = combined;
              $scope.vm.CancelledPreviewSpinner = false;
            }
          });
        });
      }
    }




    $scope.selectedIndex = 0;
    var selectedIndex = localStorage.getItem("TabFromDashboard");
    if (selectedIndex != null && selectedIndex != undefined && selectedIndex != "null" && selectedIndex != "undefined" && selectedIndex != "") {
      try {
        $scope.selectedIndex = parseInt(selectedIndex);
        if ($scope.selectedIndex == 1) {
          NewGetScheduler("Yet to Start");
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 4) {
          $scope.getOutsatnding()
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 6) {
          NewGetScheduler("Pending Approval")
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 0) {
          $scope.getPendingSchedule()
          localStorage.setItem("TabFromDashboard", null)
        }

        localStorage.setItem("TabFromDashboard", "");
      }
      catch (e) { $scope.selectedIndex = 0; NewGetScheduler("Yet to Start"); localStorage.setItem("TabFromDashboard", null) }
    }
    else { $scope.selectedIndex = 0; }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder/getSO",
      data: {
        Client_Id: $rootScope.Client_Id,
      }
    }).then(function (List) {
      $scope.AllSalesOrderSearchdatas = List.data.data
    })

    function CancelOnHoldDatas(id) {
      $scope.cancelonhold = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to Remove the jobs', 'Remove Jobs');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          var resp = $http({
            method: 'PUT',
            url: $rootScope.WebURL + "/scheduler/cancelschedulerline",
            data: { id: $scope.cancelonhold, UpdatedBy: $rootScope.createdby }
          });
          resp.then(function (Gli) {
            $mdToast.show($mdToast.simple().textContent('Removed the jobs Successfully!').position('top center'));
            $scope.NewGetByStatus()
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      })
    }

    $scope.getSalesOrderforCustomer = function (customer) {

    }

    $scope.sNewSubmitforReschedule = function (e) {
      if (new Date($scope.vm.ServiceStartAt) < new Date())
        $mdToast.show($mdToast.simple().textContent('Service Start Date is older than current date').position('top center'));
      else if (new Date($scope.vm.ServiceEndAt) < (new Date($scope.vm.ServiceStartAt)))
        $mdToast.show($mdToast.simple().textContent('Service End Date is smaller than Service Start date').position('top center'));
      else
        $scope.sNewSubmit('RescheduleSubmit', e)

    }

    $scope.PreviewRescheduleConfirm = function (e) {
      var newArray = []
      $scope.newAllPreviewGridDatas.forEach(function (data) {
        if (data._id) {
          if (data.extra) {
            $http({
              method: "PUT",
              url: $rootScope.WebURL + "/scheduler/Cancelupdate",
              data: {
                _id: data._id,
                Status: "Cancelled",
                CancelRemarks: "Reschedule Service jobs cancelled this extra job",
                SenderEmailAddress: null,
                CompanyName: null,
                ScheduleDate: null,
                UpdatedBy: $rootScope.createdby
              },
            });
          }
          else {
            $http({
              method: "PUT",
              url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
              data: {
                _id: data._id,
                ServiceOn: data.ServiceOn,
                Startsat: data.Startsat,
                Endsat: data.Endsat,
                ScheduleFromDate: data.OldStartsat,
                ResheduleRemarks: "Rescheduled from Scheduled services",
                UpdatedBy: $rootScope.createdby,
                IsActive: true
              },
            })
          }

        }
        else {
          newArray.push(data)
        }
      })
      if (newArray.length > 0) {
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/add",
          data: {
            ServiceArray: newArray
          }
        })
      }
      setTimeout(function () {
        $scope.NewGetByStatus()
        $mdDialog.cancel()
        $mdDialog.cancel()
        $mdToast.show($mdToast.simple().textContent('Rescheduled Successfully !').position('top center'));

      }, 200);
    }
    /// Socket Configuration for Scheduler

    socket.on("Scheduler Created by Inserting multiple", function (data) {
      if (data.result.length > 0) {
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var updatedData = data.result.map(function (o) { return o.id })

          $http({
            method: "POST",
            url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
            data: {
              id: updatedData,
              StartDate: $scope.uFrom,
              EndDate: $scope.uTo,
              Client_Id: $rootScope.Client_Id
            }
          }).then(function (List) {
            var data = List.data.data
            $scope.YettoStartdatas = $scope.YettoStartdatas.concat(data)
            $scope.YettoStartdatas = _.uniqWith($scope.YettoStartdatas, _.isEqual)
          })
        }
        if ($scope.vm.SelectedTab == "PendingSchedule") {
          var item = $scope.PendingScheduledatas.filter(function (item) {
            return item._id != data.result[0].JobsOrders
          })
          item = _.uniqWith(item, _.isEqual)
          $scope.PendingScheduledatas = item
        }
      }
    })

    socket.on("scheduler dragged", function (data) {
      if ($scope.vm.SelectedTab == "Yet to Start") {
        var updatedData = [data.data.id]

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
          data: {
            id: updatedData,
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
            Client_Id: $rootScope.Client_Id
          }
        }).then(function (List) {
          var data = List.data.data
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        })
      }
    })
    socket.on("scheduler dropped", function (data) {
      if ($scope.vm.SelectedTab == "Yet to Start") {
        var updatedData = [data.data.id]

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
          data: {
            id: updatedData,
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
            Client_Id: $rootScope.Client_Id
          }
        }).then(function (List) {
          var data = List.data.data
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        })
      }
    })
    socket.on("Scheduler updated", function (data) {
      var updatedData = [data.result.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler specified updated", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler cancelled", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")

          $scope.YettoStartdatas = rmdata
        }

        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")

          $scope.MobileInProgressdatas = rmdata
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
      })
    })

    socket.on("Scheduler Team Updated", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler UpdateTeam method", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Update Scheduler Line", function (data) {
      //   $scope.NewGetByStatus(null)
    })
    socket.on("Scheduler Completed", function (data) {
      var updatedData = [data.data.id]
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          $scope.YettoStartdatas = rmdata
        }
        if ($scope.vm.SelectedTab == "Completed") {
          if (data[0].ServiceReportStatus != "Pending")
            $scope.Completeddatas = $scope.Completeddatas.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          if (data[0].ServiceReportStatus == "Pending")
            $scope.PendingApprovaldatas = $scope.PendingApprovaldatas.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          $scope.MobileInProgressdatas = rmdata
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          $scope.InProgressdatas = rmdata
        }
      })
    })
    socket.on("WorkOrder unscheduled", function (data) {
      // $scope.NewGetByStatus(null)
    })

    $scope.$on("customer_created", function (event, customer) {
      RefreshCustomerdatas()
    });

    $scope.$on("customer_modified", function (event, updatedCustomer) {
      RefreshCustomerdatas()
    });

    $scope.$on("customer_deleted", function () {
      RefreshCustomerdatas()
    });

  }

  angular
    .module('app.operations.scheduler')
    .factory('alert', function ($uibModal) {
      function show(action, event) {
        return $uibModal.open({
          templateUrl: 'modalContent.html',
          controller: function () {
            var vm = this;
            vm.action = action;
            vm.event = event;
          },
          controllerAs: 'vm'
        });
      }
      return {
        show: show
      };


    });
  angular.module('app.operations.scheduler').config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('DD/MM/YYYY');
    };
  });
})();

/*!
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi PievilÃ¤inen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */
/* global module, define */

; (function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory()
    } else if (typeof define === 'function' && define.amd) {
        define([], factory)
    } else {
        root.RRule = factory(root)
        root.RRuleSet = root.RRule.RRuleSet
        root.rrulestr = root.RRule.rrulestr
    }
}(typeof window === 'object' ? window : this, function (root) {
    // =============================================================================
    // Date utilities
    // =============================================================================

    /**
     * General date-related utilities.
     * Also handles several incompatibilities between JavaScript and Python
     *
     */
    var dateutil = {
        MONTH_DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

        /**
         * Number of milliseconds of one day
         */
        ONE_DAY: 1000 * 60 * 60 * 24,

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.MAXYEAR>
         */
        MAXYEAR: 9999,

        /**
         * Python uses 1-Jan-1 as the base for calculating ordinals but we don't
         * want to confuse the JS engine with milliseconds > Number.MAX_NUMBER,
         * therefore we use 1-Jan-1970 instead
         */
        ORDINAL_BASE: new Date(1970, 0, 1),

        /**
         * Python: MO-SU: 0 - 6
         * JS: SU-SAT 0 - 6
         */
        PY_WEEKDAYS: [6, 0, 1, 2, 3, 4, 5],

        /**
         * py_date.timetuple()[7]
         */
        getYearDay: function (date) {
            var dateNoTime = new Date(
                date.getFullYear(), date.getMonth(), date.getDate())
            return Math.ceil(
                (dateNoTime - new Date(date.getFullYear(), 0, 1)) / dateutil.ONE_DAY) + 1
        },

        isLeapYear: function (year) {
            if (year instanceof Date) year = year.getFullYear()
            return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
        },

        /**
         * @return {Number} the date's timezone offset in ms
         */
        tzOffset: function (date) {
            return date.getTimezoneOffset() * 60 * 1000
        },

        /**
         * @see: <https://www.mcfedries.com/JavaScript/DaysBetween.asp>
         */
        daysBetween: function (date1, date2) {
            // The number of milliseconds in one day
            // Convert both dates to milliseconds
            var date1_ms = date1.getTime() - dateutil.tzOffset(date1)
            var date2_ms = date2.getTime() - dateutil.tzOffset(date2)
            // Calculate the difference in milliseconds
            var difference_ms = Math.abs(date1_ms - date2_ms)
            // Convert back to days and return
            return Math.round(difference_ms / dateutil.ONE_DAY)
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.date.toordinal>
         */
        toOrdinal: function (date) {
            return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
        },

        /**
         * @see - <https://docs.python.org/library/datetime.html#datetime.date.fromordinal>
         */
        fromOrdinal: function (ordinal) {
            var millisecsFromBase = ordinal * dateutil.ONE_DAY
            return new Date(dateutil.ORDINAL_BASE.getTime() -
                dateutil.tzOffset(dateutil.ORDINAL_BASE) +
                millisecsFromBase +
                dateutil.tzOffset(new Date(millisecsFromBase)))
        },

        /**
         * @see: <https://docs.python.org/library/calendar.html#calendar.monthrange>
         */
        monthRange: function (year, month) {
            var date = new Date(year, month, 1)
            return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
        },

        getMonthDays: function (date) {
            var month = date.getMonth()
            return month === 1 && dateutil.isLeapYear(date)
                ? 29 : dateutil.MONTH_DAYS[month]
        },

        /**
         * @return {Number} python-like weekday
         */
        getWeekday: function (date) {
            return dateutil.PY_WEEKDAYS[date.getDay()]
        },

        /**
         * @see: <https://docs.python.org/library/datetime.html#datetime.datetime.combine>
         */
        combine: function (date, time) {
            time = time || date
            return new Date(
                date.getFullYear(), date.getMonth(), date.getDate(),
                time.getHours(), time.getMinutes(), time.getSeconds(),
                time.getMilliseconds())
        },

        clone: function (date) {
            var dolly = new Date(date.getTime())
            return dolly
        },

        cloneDates: function (dates) {
            var clones = []
            for (var i = 0; i < dates.length; i++) {
                clones.push(dateutil.clone(dates[i]))
            }
            return clones
        },

        /**
         * Sorts an array of Date or dateutil.Time objects
         */
        sort: function (dates) {
            dates.sort(function (a, b) {
                return a.getTime() - b.getTime()
            })
        },

        timeToUntilString: function (time) {
            var comp
            var date = new Date(time)
            var comps = [
                date.getUTCFullYear(),
                date.getUTCMonth() + 1,
                date.getUTCDate(),
                'T',
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
                'Z'
            ]

            for (var i = 0; i < comps.length; i++) {
                comp = comps[i]
                if (!/[TZ]/.test(comp) && comp < 10) comps[i] = '0' + String(comp)
            }
            return comps.join('')
        },

        untilStringToDate: function (until) {
            var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z)?$/
            var bits = re.exec(until)
            if (!bits) throw new Error('Invalid UNTIL value: ' + until)
            return new Date(Date.UTC(
                bits[1],
                bits[2] - 1,
                bits[3],
                bits[5] || 0,
                bits[6] || 0,
                bits[7] || 0))
        }
    }

    dateutil.Time = function (hour, minute, second, millisecond) {
        this.hour = hour
        this.minute = minute
        this.second = second
        this.millisecond = millisecond || 0
    }

    dateutil.Time.prototype = {
        constructor: dateutil.Time,
        getHours: function () {
            return this.hour
        },
        getMinutes: function () {
            return this.minute
        },
        getSeconds: function () {
            return this.second
        },
        getMilliseconds: function () {
            return this.millisecond
        },
        getTime: function () {
            return ((this.hour * 60 * 60) + (this.minute * 60) + this.second) * 1000 +
                this.millisecond
        }
    }

    // =============================================================================
    // Helper functions
    // =============================================================================

    /**
     * Simplified version of python's range()
     */
    var range = function (start, end) {
        if (arguments.length === 1) {
            end = start
            start = 0
        }
        var rang = []
        for (var i = start; i < end; i++) rang.push(i)
        return rang
    }

    var repeat = function (value, times) {
        var i = 0
        var array = []

        if (value instanceof Array) {
            for (; i < times; i++) array[i] = [].concat(value)
        } else {
            for (; i < times; i++) array[i] = value
        }
        return array
    }

    /**
     * Python like split
     */
    var split = function (str, sep, num) {
        var splits = str.split(sep)
        return num
            ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits
    }

    /**
     * closure/goog/math/math.js:modulo
     * Copyright 2006 The Closure Library Authors.
     * The % operator in JavaScript returns the remainder of a / b, but differs from
     * some other languages in that the result will have the same sign as the
     * dividend. For example, -1 % 8 == -1, whereas in some other languages
     * (such as Python) the result would be 7. This function emulates the more
     * correct modulo behavior, which is useful for certain applications such as
     * calculating an offset index in a circular list.
     *
     * @param {number} a The dividend.
     * @param {number} b The divisor.
     * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
     *     or b < x <= 0, depending on the sign of b).
     */
    var pymod = function (a, b) {
        var r = a % b
        // If r and b differ in sign, add b to wrap the result to the correct sign.
        return (r * b < 0) ? r + b : r
    }

    /**
     * @see: <https://docs.python.org/library/functions.html#divmod>
     */
    var divmod = function (a, b) {
        return { div: Math.floor(a / b), mod: pymod(a, b) }
    }

    /**
     * Python-like boolean
     * @return {Boolean} value of an object/primitive, taking into account
     * the fact that in Python an empty list's/tuple's
     * boolean value is False, whereas in JS it's true
     */
    var plb = function (obj) {
        return (obj instanceof Array && obj.length === 0)
            ? false : Boolean(obj)
    }

    /**
     * Return true if a value is in an array
     */
    var contains = function (arr, val) {
        return arr.indexOf(val) !== -1
    }

    // =============================================================================
    // Date masks
    // =============================================================================

    // Every mask is 7 days longer to handle cross-year weekly periods.

    var M365MASK = [].concat(
        repeat(1, 31), repeat(2, 28), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M366MASK = [].concat(
        repeat(1, 31), repeat(2, 29), repeat(3, 31),
        repeat(4, 30), repeat(5, 31), repeat(6, 30),
        repeat(7, 31), repeat(8, 31), repeat(9, 30),
        repeat(10, 31), repeat(11, 30), repeat(12, 31),
        repeat(1, 7))

    var M28 = range(1, 29)
    var M29 = range(1, 30)
    var M30 = range(1, 31)
    var M31 = range(1, 32)

    var MDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var MDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    M28 = range(-28, 0)
    M29 = range(-29, 0)
    M30 = range(-30, 0)
    M31 = range(-31, 0)

    var NMDAY366MASK = [].concat(
        M31, M29, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var NMDAY365MASK = [].concat(
        M31, M28, M31,
        M30, M31, M30,
        M31, M31, M30,
        M31, M30, M31,
        M31.slice(0, 7))

    var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
    var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365]

    var WDAYMASK = (function () {
        for (var wdaymask = [], i = 0; i < 55; i++) wdaymask = wdaymask.concat(range(7))
        return wdaymask
    }())

    // =============================================================================
    // Weekday
    // =============================================================================

    var Weekday = function (weekday, n) {
        if (n === 0) throw new Error("Can't create weekday with n == 0")
        this.weekday = weekday
        this.n = n
    }

    Weekday.prototype = {
        constructor: Weekday,
        // __call__ - Cannot call the object directly, do it through
        // e.g. RRule.TH.nth(-1) instead,
        nth: function (n) {
            return this.n === n ? this : new Weekday(this.weekday, n)
        },

        // __eq__
        equals: function (other) {
            return this.weekday === other.weekday && this.n === other.n
        },

        // __repr__
        toString: function () {
            var s = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'][this.weekday]
            if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s
            return s
        },

        getJsWeekday: function () {
            return this.weekday === 6 ? 0 : this.weekday + 1
        }

    }

    // =============================================================================
    // RRule
    // =============================================================================

    /**
     *
     * @param {Object?} options - see <https://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
     *        The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
     * @constructor
     */
    var RRule = function (options, noCache) {
        options = options || {}
        // RFC string
        this._string = null
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }

        // used by toString()
        this.origOptions = {}

        var invalid = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        // Shallow copy for origOptions and check for invalid
        keys.forEach(function (key) {
            this.origOptions[key] = options[key]
            if (!contains(defaultKeys, key)) invalid.push(key)
        }, this)

        if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

        if (!RRule.FREQUENCIES[options.freq] && options.byeaster === null) {
            throw new Error('Invalid frequency: ' + String(options.freq))
        }

        // Merge in default options
        defaultKeys.forEach(function (key) {
            if (!contains(keys, key)) options[key] = RRule.DEFAULT_OPTIONS[key]
        })

        var opts = this.options = options

        if (opts.byeaster !== null) opts.freq = RRule.YEARLY
        if (!opts.dtstart) opts.dtstart = new Date()

        var millisecondModulo = opts.dtstart.getTime() % 1000
        if (opts.wkst === null) {
            opts.wkst = RRule.MO.weekday
        } else if (typeof opts.wkst === 'number') {
            // cool, just keep it like that
        } else {
            opts.wkst = opts.wkst.weekday
        }

        if (opts.bysetpos !== null) {
            if (typeof opts.bysetpos === 'number') opts.bysetpos = [opts.bysetpos]

            for (var i = 0; i < opts.bysetpos.length; i++) {
                var v = opts.bysetpos[i]
                if (v === 0 || !(v >= -366 && v <= 366)) {
                    throw new Error('bysetpos must be between 1 and 366,' +
                        ' or between -366 and -1')
                }
            }
        }

        if (!(plb(opts.byweekno) || plb(opts.byyearday) || plb(opts.bymonthday) ||
            opts.byweekday !== null || opts.byeaster !== null)) {
            switch (opts.freq) {
                case RRule.YEARLY:
                    if (!opts.bymonth) opts.bymonth = opts.dtstart.getMonth() + 1
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.MONTHLY:
                    opts.bymonthday = opts.dtstart.getDate()
                    break
                case RRule.WEEKLY:
                    opts.byweekday = dateutil.getWeekday(opts.dtstart)
                    break
            }
        }

        // bymonth
        if (opts.bymonth !== null && !(opts.bymonth instanceof Array)) {
            opts.bymonth = [opts.bymonth]
        }
        // byyearday
        if (opts.byyearday !== null && !(opts.byyearday instanceof Array)) {
            opts.byyearday = [opts.byyearday]
        }

        // bymonthday
        if (opts.bymonthday === null) {
            opts.bymonthday = []
            opts.bynmonthday = []
        } else if (opts.bymonthday instanceof Array) {
            var bymonthday = []
            var bynmonthday = []

            for (i = 0; i < opts.bymonthday.length; i++) {
                v = opts.bymonthday[i]
                if (v > 0) {
                    bymonthday.push(v)
                } else if (v < 0) {
                    bynmonthday.push(v)
                }
            }
            opts.bymonthday = bymonthday
            opts.bynmonthday = bynmonthday
        } else {
            if (opts.bymonthday < 0) {
                opts.bynmonthday = [opts.bymonthday]
                opts.bymonthday = []
            } else {
                opts.bynmonthday = []
                opts.bymonthday = [opts.bymonthday]
            }
        }

        // byweekno
        if (opts.byweekno !== null && !(opts.byweekno instanceof Array)) {
            opts.byweekno = [opts.byweekno]
        }

        // byweekday / bynweekday
        if (opts.byweekday === null) {
            opts.bynweekday = null
        } else if (typeof opts.byweekday === 'number') {
            opts.byweekday = [opts.byweekday]
            opts.bynweekday = null
        } else if (opts.byweekday instanceof Weekday) {
            if (!opts.byweekday.n || opts.freq > RRule.MONTHLY) {
                opts.byweekday = [opts.byweekday.weekday]
                opts.bynweekday = null
            } else {
                opts.bynweekday = [
                    [opts.byweekday.weekday, opts.byweekday.n]
                ]
                opts.byweekday = null
            }
        } else {
            var byweekday = []
            var bynweekday = []

            for (i = 0; i < opts.byweekday.length; i++) {
                var wday = opts.byweekday[i]

                if (typeof wday === 'number') {
                    byweekday.push(wday)
                } else if (!wday.n || opts.freq > RRule.MONTHLY) {
                    byweekday.push(wday.weekday)
                } else {
                    bynweekday.push([wday.weekday, wday.n])
                }
            }
            opts.byweekday = plb(byweekday) ? byweekday : null
            opts.bynweekday = plb(bynweekday) ? bynweekday : null
        }

        // byhour
        if (opts.byhour === null) {
            opts.byhour = (opts.freq < RRule.HOURLY) ? [opts.dtstart.getHours()] : null
        } else if (typeof opts.byhour === 'number') {
            opts.byhour = [opts.byhour]
        }

        // byminute
        if (opts.byminute === null) {
            opts.byminute = (opts.freq < RRule.MINUTELY)
                ? [opts.dtstart.getMinutes()] : null
        } else if (typeof opts.byminute === 'number') {
            opts.byminute = [opts.byminute]
        }

        // bysecond
        if (opts.bysecond === null) {
            opts.bysecond = (opts.freq < RRule.SECONDLY)
                ? [opts.dtstart.getSeconds()] : null
        } else if (typeof opts.bysecond === 'number') {
            opts.bysecond = [opts.bysecond]
        }

        if (opts.freq >= RRule.HOURLY) {
            this.timeset = null
        } else {
            this.timeset = []
            for (i = 0; i < opts.byhour.length; i++) {
                var hour = opts.byhour[i]
                for (var j = 0; j < opts.byminute.length; j++) {
                    var minute = opts.byminute[j]
                    for (var k = 0; k < opts.bysecond.length; k++) {
                        var second = opts.bysecond[k]
                        // python:
                        // datetime.time(hour, minute, second,
                        // tzinfo=self._tzinfo))
                        this.timeset.push(new dateutil.Time(hour, minute, second, millisecondModulo))
                    }
                }
            }
            dateutil.sort(this.timeset)
        }
    }

    // RRule class 'constants'

    RRule.FREQUENCIES = [
        'YEARLY', 'MONTHLY', 'WEEKLY', 'DAILY',
        'HOURLY', 'MINUTELY', 'SECONDLY'
    ]

    RRule.YEARLY = 0
    RRule.MONTHLY = 1
    RRule.WEEKLY = 2
    RRule.DAILY = 3
    RRule.HOURLY = 4
    RRule.MINUTELY = 5
    RRule.SECONDLY = 6

    RRule.MO = new Weekday(0)
    RRule.TU = new Weekday(1)
    RRule.WE = new Weekday(2)
    RRule.TH = new Weekday(3)
    RRule.FR = new Weekday(4)
    RRule.SA = new Weekday(5)
    RRule.SU = new Weekday(6)

    RRule.DEFAULT_OPTIONS = {
        freq: null,
        dtstart: null,
        interval: 1,
        wkst: RRule.MO,
        count: null,
        until: null,
        bysetpos: null,
        bymonth: null,
        bymonthday: null,
        bynmonthday: null,
        byyearday: null,
        byweekno: null,
        byweekday: null,
        bynweekday: null,
        byhour: null,
        byminute: null,
        bysecond: null,
        byeaster: null
    }

    RRule.parseText = function (text, language) {
        return getnlp().parseText(text, language)
    }

    RRule.fromText = function (text, language) {
        return getnlp().fromText(text, language)
    }

    RRule.optionsToString = function (options) {
        var key, value, strValues
        var pairs = []
        var keys = Object.keys(options)
        var defaultKeys = Object.keys(RRule.DEFAULT_OPTIONS)

        for (var i = 0; i < keys.length; i++) {
            if (!contains(defaultKeys, keys[i])) continue

            key = keys[i].toUpperCase()
            value = options[keys[i]]
            strValues = []

            if (value === null || value instanceof Array && !value.length) continue

            switch (key) {
                case 'FREQ':
                    value = RRule.FREQUENCIES[options.freq]
                    break
                case 'WKST':
                    value = value.toString()
                    break
                case 'BYWEEKDAY':
                    /*
                    NOTE: BYWEEKDAY is a special case.
                    RRule() deconstructs the rule.options.byweekday array
                    into an array of Weekday arguments.
                    On the other hand, rule.origOptions is an array of Weekdays.
                    We need to handle both cases here.
                    It might be worth change RRule to keep the Weekdays.
          
                    Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
          
                    */
                    key = 'BYDAY'
                    if (!(value instanceof Array)) value = [value]

                    for (var wday, j = 0; j < value.length; j++) {
                        wday = value[j]
                        if (wday instanceof Weekday) {
                            // good
                        } else if (wday instanceof Array) {
                            wday = new Weekday(wday[0], wday[1])
                        } else {
                            wday = new Weekday(wday)
                        }
                        strValues[j] = wday.toString()
                    }
                    value = strValues
                    break
                case 'DTSTART':
                case 'UNTIL':
                    value = dateutil.timeToUntilString(value)
                    break
                default:
                    if (value instanceof Array) {
                        for (j = 0; j < value.length; j++) strValues[j] = String(value[j])
                        value = strValues
                    } else {
                        value = String(value)
                    }

            }
            pairs.push([key, value])
        }

        var strings = []
        for (i = 0; i < pairs.length; i++) {
            var attr = pairs[i]
            strings.push(attr[0] + '=' + attr[1].toString())
        }
        return strings.join(';')
    }

    RRule.prototype = {
        constructor: RRule,

        /**
         * @param {Function} iterator - optional function that will be called
         *                   on each date that is added. It can return false
         *                   to stop the iteration.
         * @return Array containing all recurrences.
         */
        all: function (iterator) {
            if (iterator) {
                return this._iter(new CallbackIterResult('all', {}, iterator))
            } else {
                var result = this._cacheGet('all')
                if (result === false) {
                    result = this._iter(new IterResult('all', {}))
                    this._cacheAdd('all', result)
                }
                return result
            }
        },

        /**
         * Returns all the occurrences of the rrule between after and before.
         * The inc keyword defines what happens if after and/or before are
         * themselves occurrences. With inc == True, they will be included in the
         * list, if they are found in the recurrence set.
         * @return Array
         */
        between: function (after, before, inc, iterator) {
            var args = {
                before: before,
                after: after,
                inc: inc
            }

            if (iterator) {
                return this._iter(new CallbackIterResult('between', args, iterator))
            }
            var result = this._cacheGet('between', args)
            if (result === false) {
                result = this._iter(new IterResult('between', args))
                this._cacheAdd('between', result, args)
            }
            return result
        },

        /**
         * Returns the last recurrence before the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        before: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('before', args)
            if (result === false) {
                result = this._iter(new IterResult('before', args))
                this._cacheAdd('before', result, args)
            }
            return result
        },

        /**
         * Returns the first recurrence after the given datetime instance.
         * The inc keyword defines what happens if dt is an occurrence.
         * With inc == True, if dt itself is an occurrence, it will be returned.
         * @return Date or null
         */
        after: function (dt, inc) {
            var args = { dt: dt, inc: inc }
            var result = this._cacheGet('after', args)
            if (result === false) {
                result = this._iter(new IterResult('after', args))
                this._cacheAdd('after', result, args)
            }
            return result
        },

        /**
         * Returns the number of recurrences in this set. It will have go trough
         * the whole recurrence, if this hasn't been done before.
         */
        count: function () {
            return this.all().length
        },

        /**
         * Converts the rrule into its string representation
         * @see <https://www.ietf.org/rfc/rfc2445.txt>
         * @return String
         */
        toString: function () {
            return RRule.optionsToString(this.origOptions)
        },

        /**
        * Will convert all rules described in nlp:ToText
        * to text.
        */
        toText: function (gettext, language) {
            return getnlp().toText(this, gettext, language)
        },

        isFullyConvertibleToText: function () {
            return getnlp().isFullyConvertible(this)
        },

        /**
         * @param {String} what - all/before/after/between
         * @param {Array,Date} value - an array of dates, one date, or null
         * @param {Object?} args - _iter arguments
         */
        _cacheAdd: function (what, value, args) {
            if (!this._cache) return

            if (value) {
                value = (value instanceof Date)
                    ? dateutil.clone(value) : dateutil.cloneDates(value)
            }

            if (what === 'all') {
                this._cache.all = value
            } else {
                args._value = value
                this._cache[what].push(args)
            }
        },

        /**
         * @return false - not in the cache
         *         null  - cached, but zero occurrences (before/after)
         *         Date  - cached (before/after)
         *         []    - cached, but zero occurrences (all/between)
         *         [Date1, DateN] - cached (all/between)
         */
        _cacheGet: function (what, args) {
            if (!this._cache) return false

            var cached = false
            var argsKeys = args ? Object.keys(args) : []
            var findCacheDiff = function (item) {
                for (var key, i = 0; i < argsKeys.length; i++) {
                    key = argsKeys[i]
                    if (String(args[key]) !== String(item[key])) return true
                }
                return false
            }

            if (what === 'all') {
                cached = this._cache.all
            } else {
                // Let's see whether we've already called the
                // 'what' method with the same 'args'
                for (var item, i = 0; i < this._cache[what].length; i++) {
                    item = this._cache[what][i]
                    if (argsKeys.length && findCacheDiff(item)) continue
                    cached = item._value
                    break
                }
            }

            if (!cached && this._cache.all) {
                // Not in the cache, but we already know all the occurrences,
                // so we can find the correct dates from the cached ones.
                var iterResult = new IterResult(what, args)
                for (i = 0; i < this._cache.all.length; i++) {
                    if (!iterResult.accept(this._cache.all[i])) break
                }
                cached = iterResult.getValue()
                this._cacheAdd(what, cached, args)
            }

            return cached instanceof Array
                ? dateutil.cloneDates(cached)
                : (cached instanceof Date ? dateutil.clone(cached) : cached)
        },

        /**
         * @return a RRule instance with the same freq and options
         *          as this one (cache is not cloned)
         */
        clone: function () {
            return new RRule(this.origOptions)
        },

        _iter: function (iterResult) {
            /* Since JavaScript doesn't have the python's yield operator (<1.7),
               we use the IterResult object that tells us when to stop iterating.
      
            */

            var dtstart = this.options.dtstart
            var dtstartMillisecondModulo = this.options.dtstart % 1000

            var year = dtstart.getFullYear()
            var month = dtstart.getMonth() + 1
            var day = dtstart.getDate()
            var hour = dtstart.getHours()
            var minute = dtstart.getMinutes()
            var second = dtstart.getSeconds()
            var weekday = dateutil.getWeekday(dtstart)

            // Some local variables to speed things up a bit
            var freq = this.options.freq
            var interval = this.options.interval
            var wkst = this.options.wkst
            var until = this.options.until
            var bymonth = this.options.bymonth
            var byweekno = this.options.byweekno
            var byyearday = this.options.byyearday
            var byweekday = this.options.byweekday
            var byeaster = this.options.byeaster
            var bymonthday = this.options.bymonthday
            var bynmonthday = this.options.bynmonthday
            var bysetpos = this.options.bysetpos
            var byhour = this.options.byhour
            var byminute = this.options.byminute
            var bysecond = this.options.bysecond

            var ii = new Iterinfo(this)
            ii.rebuild(year, month)

            var getdayset = {}
            getdayset[RRule.YEARLY] = ii.ydayset
            getdayset[RRule.MONTHLY] = ii.mdayset
            getdayset[RRule.WEEKLY] = ii.wdayset
            getdayset[RRule.DAILY] = ii.ddayset
            getdayset[RRule.HOURLY] = ii.ddayset
            getdayset[RRule.MINUTELY] = ii.ddayset
            getdayset[RRule.SECONDLY] = ii.ddayset

            getdayset = getdayset[freq]

            var timeset
            if (freq < RRule.HOURLY) {
                timeset = this.timeset
            } else {
                var gettimeset = {}
                gettimeset[RRule.HOURLY] = ii.htimeset
                gettimeset[RRule.MINUTELY] = ii.mtimeset
                gettimeset[RRule.SECONDLY] = ii.stimeset
                gettimeset = gettimeset[freq]
                if ((freq >= RRule.HOURLY && plb(byhour) && !contains(byhour, hour)) ||
                    (freq >= RRule.MINUTELY && plb(byminute) && !contains(byminute, minute)) ||
                    (freq >= RRule.SECONDLY && plb(bysecond) && !contains(bysecond, minute))) {
                    timeset = []
                } else {
                    timeset = gettimeset.call(ii, hour, minute, second, dtstartMillisecondModulo)
                }
            }

            var total = 0
            var count = this.options.count
            var i, j, k, dm, div, mod, tmp, pos, dayset, start, end, fixday, filtered

            while (true) {
                // Get dayset with the right frequency
                tmp = getdayset.call(ii, year, month, day)
                dayset = tmp[0]
                start = tmp[1]
                end = tmp[2]

                // Do the "hard" work ;-)
                filtered = false
                for (j = start; j < end; j++) {
                    i = dayset[j]

                    filtered = (plb(bymonth) && !contains(bymonth, ii.mmask[i])) ||
                        (plb(byweekno) && !ii.wnomask[i]) ||
                        (plb(byweekday) && !contains(byweekday, ii.wdaymask[i])) ||
                        (plb(ii.nwdaymask) && !ii.nwdaymask[i]) ||
                        (byeaster !== null && !contains(ii.eastermask, i)) ||
                        ((plb(bymonthday) || plb(bynmonthday)) &&
                            !contains(bymonthday, ii.mdaymask[i]) &&
                            !contains(bynmonthday, ii.nmdaymask[i])) ||
                        (plb(byyearday) &&
                            ((i < ii.yearlen &&
                                !contains(byyearday, i + 1) &&
                                !contains(byyearday, -ii.yearlen + i)) ||
                                (i >= ii.yearlen &&
                                    !contains(byyearday, i + 1 - ii.yearlen) &&
                                    !contains(byyearday, -ii.nextyearlen + i - ii.yearlen))))

                    if (filtered) dayset[i] = null
                }

                // Output results
                if (plb(bysetpos) && plb(timeset)) {
                    var daypos, timepos
                    var poslist = []

                    for (i, j = 0; j < bysetpos.length; j++) {
                        pos = bysetpos[j]

                        if (pos < 0) {
                            daypos = Math.floor(pos / timeset.length)
                            timepos = pymod(pos, timeset.length)
                        } else {
                            daypos = Math.floor((pos - 1) / timeset.length)
                            timepos = pymod((pos - 1), timeset.length)
                        }

                        try {
                            tmp = []
                            for (k = start; k < end; k++) {
                                var val = dayset[k]
                                if (val === null) continue
                                tmp.push(val)
                            }
                            if (daypos < 0) {
                                // we're trying to emulate python's aList[-n]
                                i = tmp.slice(daypos)[0]
                            } else {
                                i = tmp[daypos]
                            }

                            var time = timeset[timepos]
                            var date = dateutil.fromOrdinal(ii.yearordinal + i)
                            var res = dateutil.combine(date, time)
                            // XXX: can this ever be in the array?
                            // - compare the actual date instead?
                            if (!contains(poslist, res)) poslist.push(res)
                        } catch (e) { }
                    }

                    dateutil.sort(poslist)
                    for (j = 0; j < poslist.length; j++) {
                        res = poslist[j]
                        if (until && res > until) {
                            this._len = total
                            return iterResult.getValue()
                        } else if (res >= dtstart) {
                            ++total
                            if (!iterResult.accept(res)) return iterResult.getValue()
                            if (count) {
                                --count
                                if (!count) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                        }
                    }
                } else {
                    for (j = start; j < end; j++) {
                        i = dayset[j]
                        if (i !== null) {
                            date = dateutil.fromOrdinal(ii.yearordinal + i)
                            for (k = 0; k < timeset.length; k++) {
                                time = timeset[k]
                                res = dateutil.combine(date, time)
                                if (until && res > until) {
                                    this._len = total
                                    return iterResult.getValue()
                                } else if (res >= dtstart) {
                                    ++total
                                    if (!iterResult.accept(res)) return iterResult.getValue()
                                    if (count) {
                                        --count
                                        if (!count) {
                                            this._len = total
                                            return iterResult.getValue()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                // Handle frequency and interval
                fixday = false
                if (freq === RRule.YEARLY) {
                    year += interval
                    if (year > dateutil.MAXYEAR) {
                        this._len = total
                        return iterResult.getValue()
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.MONTHLY) {
                    month += interval
                    if (month > 12) {
                        div = Math.floor(month / 12)
                        mod = pymod(month, 12)
                        month = mod
                        year += div
                        if (month === 0) {
                            month = 12
                            --year
                        }
                        if (year > dateutil.MAXYEAR) {
                            this._len = total
                            return iterResult.getValue()
                        }
                    }
                    ii.rebuild(year, month)
                } else if (freq === RRule.WEEKLY) {
                    if (wkst > weekday) {
                        day += -(weekday + 1 + (6 - wkst)) + interval * 7
                    } else {
                        day += -(weekday - wkst) + interval * 7
                    }
                    weekday = wkst
                    fixday = true
                } else if (freq === RRule.DAILY) {
                    day += interval
                    fixday = true
                } else if (freq === RRule.HOURLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        hour += Math.floor((23 - hour) / interval) * interval
                    }
                    while (true) {
                        hour += interval
                        dm = divmod(hour, 24)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            hour = mod
                            day += div
                            fixday = true
                        }
                        if (!plb(byhour) || contains(byhour, hour)) break
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.MINUTELY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        minute += Math.floor(
                            (1439 - (hour * 60 + minute)) / interval) * interval
                    }

                    while (true) {
                        minute += interval
                        dm = divmod(minute, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            minute = mod
                            hour += div
                            dm = divmod(hour, 24)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                hour = mod
                                day += div
                                fixday = true
                                filtered = false
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                } else if (freq === RRule.SECONDLY) {
                    if (filtered) {
                        // Jump to one iteration before next day
                        second += Math.floor(
                            (86399 - (hour * 3600 + minute * 60 + second)) / interval) * interval
                    }
                    while (true) {
                        second += interval
                        dm = divmod(second, 60)
                        div = dm.div
                        mod = dm.mod
                        if (div) {
                            second = mod
                            minute += div
                            dm = divmod(minute, 60)
                            div = dm.div
                            mod = dm.mod
                            if (div) {
                                minute = mod
                                hour += div
                                dm = divmod(hour, 24)
                                div = dm.div
                                mod = dm.mod
                                if (div) {
                                    hour = mod
                                    day += div
                                    fixday = true
                                }
                            }
                        }
                        if ((!plb(byhour) || contains(byhour, hour)) &&
                            (!plb(byminute) || contains(byminute, minute)) &&
                            (!plb(bysecond) || contains(bysecond, second))) {
                            break
                        }
                    }
                    timeset = gettimeset.call(ii, hour, minute, second)
                }

                if (fixday && day > 28) {
                    var daysinmonth = dateutil.monthRange(year, month - 1)[1]
                    if (day > daysinmonth) {
                        while (day > daysinmonth) {
                            day -= daysinmonth
                            ++month
                            if (month === 13) {
                                month = 1
                                ++year
                                if (year > dateutil.MAXYEAR) {
                                    this._len = total
                                    return iterResult.getValue()
                                }
                            }
                            daysinmonth = dateutil.monthRange(year, month - 1)[1]
                        }
                        ii.rebuild(year, month)
                    }
                }
            }
        }

    }

    RRule.parseString = function (rfcString) {
        rfcString = rfcString.replace(/^\s+|\s+$/, '')
        if (!rfcString.length) return null

        var i, j, key, value, attr
        var attrs = rfcString.split(';')
        var options = {}

        for (i = 0; i < attrs.length; i++) {
            attr = attrs[i].split('=')
            key = attr[0]
            value = attr[1]
            switch (key) {
                case 'FREQ':
                    options.freq = RRule[value]
                    break
                case 'WKST':
                    options.wkst = RRule[value]
                    break
                case 'COUNT':
                case 'INTERVAL':
                case 'BYSETPOS':
                case 'BYMONTH':
                case 'BYMONTHDAY':
                case 'BYYEARDAY':
                case 'BYWEEKNO':
                case 'BYHOUR':
                case 'BYMINUTE':
                case 'BYSECOND':
                    if (value.indexOf(',') !== -1) {
                        value = value.split(',')
                        for (j = 0; j < value.length; j++) {
                            if (/^[+-]?\d+$/.test(value[j])) value[j] = Number(value[j])
                        }
                    } else if (/^[+-]?\d+$/.test(value)) {
                        value = Number(value)
                    }
                    key = key.toLowerCase()
                    options[key] = value
                    break
                case 'BYDAY': // => byweekday
                    var n, wday, day
                    var days = value.split(',')

                    options.byweekday = []
                    for (j = 0; j < days.length; j++) {
                        day = days[j]
                        if (day.length === 2) { // MO, TU, ...
                            wday = RRule[day] // wday instanceof Weekday
                            options.byweekday.push(wday)
                        } else { // -1MO, +3FR, 1SO, ...
                            day = day.match(/^([+-]?\d)([A-Z]{2})$/)
                            n = Number(day[1])
                            wday = day[2]
                            wday = RRule[wday].weekday
                            options.byweekday.push(new Weekday(wday, n))
                        }
                    }
                    break
                case 'DTSTART':
                    options.dtstart = dateutil.untilStringToDate(value)
                    break
                case 'UNTIL':
                    options.until = dateutil.untilStringToDate(value)
                    break
                case 'BYEASTER':
                    options.byeaster = Number(value)
                    break
                default:
                    throw new Error("Unknown RRULE property '" + key + "'")
            }
        }
        return options
    }

    RRule.fromString = function (string) {
        return new RRule(RRule.parseString(string))
    }

    // =============================================================================
    // Iterinfo
    // =============================================================================

    var Iterinfo = function (rrule) {
        this.rrule = rrule
        this.lastyear = null
        this.lastmonth = null
        this.yearlen = null
        this.nextyearlen = null
        this.yearordinal = null
        this.yearweekday = null
        this.mmask = null
        this.mrange = null
        this.mdaymask = null
        this.nmdaymask = null
        this.wdaymask = null
        this.wnomask = null
        this.nwdaymask = null
        this.eastermask = null
    }

    Iterinfo.prototype.easter = function (y, offset) {
        offset = offset || 0

        var a = y % 19
        var b = Math.floor(y / 100)
        var c = y % 100
        var d = Math.floor(b / 4)
        var e = b % 4
        var f = Math.floor((b + 8) / 25)
        var g = Math.floor((b - f + 1) / 3)
        var h = Math.floor(19 * a + b - d - g + 15) % 30
        var i = Math.floor(c / 4)
        var k = c % 4
        var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7
        var m = Math.floor((a + 11 * h + 22 * l) / 451)
        var month = Math.floor((h + l - 7 * m + 114) / 31)
        var day = (h + l - 7 * m + 114) % 31 + 1
        var date = Date.UTC(y, month - 1, day + offset)
        var yearStart = Date.UTC(y, 0, 1)

        return [Math.ceil((date - yearStart) / (1000 * 60 * 60 * 24))]
    }

    Iterinfo.prototype.rebuild = function (year, month) {
        var rr = this.rrule

        if (year !== this.lastyear) {
            this.yearlen = dateutil.isLeapYear(year) ? 366 : 365
            this.nextyearlen = dateutil.isLeapYear(year + 1) ? 366 : 365
            var firstyday = new Date(year, 0, 1)

            this.yearordinal = dateutil.toOrdinal(firstyday)
            this.yearweekday = dateutil.getWeekday(firstyday)

            var wday = dateutil.getWeekday(new Date(year, 0, 1))

            if (this.yearlen === 365) {
                this.mmask = [].concat(M365MASK)
                this.mdaymask = [].concat(MDAY365MASK)
                this.nmdaymask = [].concat(NMDAY365MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M365RANGE)
            } else {
                this.mmask = [].concat(M366MASK)
                this.mdaymask = [].concat(MDAY366MASK)
                this.nmdaymask = [].concat(NMDAY366MASK)
                this.wdaymask = WDAYMASK.slice(wday)
                this.mrange = [].concat(M366RANGE)
            }

            if (!plb(rr.options.byweekno)) {
                this.wnomask = null
            } else {
                this.wnomask = repeat(0, this.yearlen + 7)
                var no1wkst, firstwkst, wyearlen
                no1wkst = firstwkst = pymod(7 - this.yearweekday + rr.options.wkst, 7)
                if (no1wkst >= 4) {
                    no1wkst = 0
                    // Number of days in the year, plus the days we got
                    // from last year.
                    wyearlen = this.yearlen + pymod(this.yearweekday - rr.options.wkst, 7)
                } else {
                    // Number of days in the year, minus the days we
                    // left in last year.
                    wyearlen = this.yearlen - no1wkst
                }
                var div = Math.floor(wyearlen / 7)
                var mod = pymod(wyearlen, 7)
                var numweeks = Math.floor(div + (mod / 4))
                for (var n, i, j = 0; j < rr.options.byweekno.length; j++) {
                    n = rr.options.byweekno[j]
                    if (n < 0) {
                        n += numweeks + 1
                    } if (!(n > 0 && n <= numweeks)) {
                        continue
                    } if (n > 1) {
                        i = no1wkst + (n - 1) * 7
                        if (no1wkst !== firstwkst) {
                            i -= 7 - firstwkst
                        }
                    } else {
                        i = no1wkst
                    }
                    for (var k = 0; k < 7; k++) {
                        this.wnomask[i] = 1
                        i++
                        if (this.wdaymask[i] === rr.options.wkst) break
                    }
                }

                if (contains(rr.options.byweekno, 1)) {
                    // Check week number 1 of next year as well
                    // orig-TODO : Check -numweeks for next year.
                    i = no1wkst + numweeks * 7
                    if (no1wkst !== firstwkst) i -= 7 - firstwkst
                    if (i < this.yearlen) {
                        // If week starts in next year, we
                        // don't care about it.
                        for (j = 0; j < 7; j++) {
                            this.wnomask[i] = 1
                            i += 1
                            if (this.wdaymask[i] === rr.options.wkst) break
                        }
                    }
                }

                if (no1wkst) {
                    // Check last week number of last year as
                    // well. If no1wkst is 0, either the year
                    // started on week start, or week number 1
                    // got days from last year, so there are no
                    // days from last year's last week number in
                    // this year.
                    var lnumweeks
                    if (!contains(rr.options.byweekno, -1)) {
                        var lyearweekday = dateutil.getWeekday(new Date(year - 1, 0, 1))
                        var lno1wkst = pymod(7 - lyearweekday + rr.options.wkst, 7)
                        var lyearlen = dateutil.isLeapYear(year - 1) ? 366 : 365
                        if (lno1wkst >= 4) {
                            lno1wkst = 0
                            lnumweeks = Math.floor(52 +
                                pymod(lyearlen + pymod(lyearweekday - rr.options.wkst, 7), 7) / 4)
                        } else {
                            lnumweeks = Math.floor(52 + pymod(this.yearlen - no1wkst, 7) / 4)
                        }
                    } else {
                        lnumweeks = -1
                    }
                    if (contains(rr.options.byweekno, lnumweeks)) {
                        for (i = 0; i < no1wkst; i++) this.wnomask[i] = 1
                    }
                }
            }
        }

        if (plb(rr.options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
            var ranges = []
            if (rr.options.freq === RRule.YEARLY) {
                if (plb(rr.options.bymonth)) {
                    for (j = 0; j < rr.options.bymonth.length; j++) {
                        month = rr.options.bymonth[j]
                        ranges.push(this.mrange.slice(month - 1, month + 1))
                    }
                } else {
                    ranges = [[0, this.yearlen]]
                }
            } else if (rr.options.freq === RRule.MONTHLY) {
                ranges = [this.mrange.slice(month - 1, month + 1)]
            }
            if (plb(ranges)) {
                // Weekly frequency won't get here, so we may not
                // care about cross-year weekly periods.
                this.nwdaymask = repeat(0, this.yearlen)

                for (j = 0; j < ranges.length; j++) {
                    var rang = ranges[j]
                    var first = rang[0]
                    var last = rang[1]
                    last -= 1
                    for (k = 0; k < rr.options.bynweekday.length; k++) {
                        wday = rr.options.bynweekday[k][0]
                        n = rr.options.bynweekday[k][1]
                        if (n < 0) {
                            i = last + (n + 1) * 7
                            i -= pymod(this.wdaymask[i] - wday, 7)
                        } else {
                            i = first + (n - 1) * 7
                            i += pymod(7 - this.wdaymask[i] + wday, 7)
                        }
                        if (first <= i && i <= last) this.nwdaymask[i] = 1
                    }
                }
            }

            this.lastyear = year
            this.lastmonth = month
        }

        if (rr.options.byeaster !== null) {
            this.eastermask = this.easter(year, rr.options.byeaster)
        }
    }

    Iterinfo.prototype.ydayset = function (year, month, day) {
        return [range(this.yearlen), 0, this.yearlen]
    }

    Iterinfo.prototype.mdayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var start = this.mrange[month - 1]
        var end = this.mrange[month]
        for (var i = start; i < end; i++) set[i] = i
        return [set, start, end]
    }

    Iterinfo.prototype.wdayset = function (year, month, day) {
        // We need to handle cross-year weeks here.
        var set = repeat(null, this.yearlen + 7)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        var start = i
        for (var j = 0; j < 7; j++) {
            set[i] = i
            ++i
            if (this.wdaymask[i] === this.rrule.options.wkst) break
        }
        return [set, start, i]
    }

    Iterinfo.prototype.ddayset = function (year, month, day) {
        var set = repeat(null, this.yearlen)
        var i = dateutil.toOrdinal(new Date(year, month - 1, day)) - this.yearordinal
        set[i] = i
        return [set, i, i + 1]
    }

    Iterinfo.prototype.htimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var i = 0; i < rr.options.byminute.length; i++) {
            minute = rr.options.byminute[i]
            for (var j = 0; j < rr.options.bysecond.length; j++) {
                second = rr.options.bysecond[j]
                set.push(new dateutil.Time(hour, minute, second, millisecond))
            }
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.mtimeset = function (hour, minute, second, millisecond) {
        var set = []
        var rr = this.rrule
        for (var j = 0; j < rr.options.bysecond.length; j++) {
            second = rr.options.bysecond[j]
            set.push(new dateutil.Time(hour, minute, second, millisecond))
        }
        dateutil.sort(set)
        return set
    }

    Iterinfo.prototype.stimeset = function (hour, minute, second, millisecond) {
        return [new dateutil.Time(hour, minute, second, millisecond)]
    }

    // =============================================================================
    // Results
    // =============================================================================

    /**
     * This class helps us to emulate python's generators, sorta.
     */
    var IterResult = function (method, args) {
        this.init(method, args)
    }

    IterResult.prototype = {
        constructor: IterResult,
        init: function (method, args) {
            this.method = method
            this.args = args
            this.minDate = null
            this.maxDate = null
            this._result = []

            if (method === 'between') {
                this.maxDate = args.inc
                    ? args.before : new Date(args.before.getTime() - 1)
                this.minDate = args.inc
                    ? args.after : new Date(args.after.getTime() + 1)
            } else if (method === 'before') {
                this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1)
            } else if (method === 'after') {
                this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1)
            }
        },

        /**
         * Possibly adds a date into the result.
         *
         * @param {Date} date - the date isn't necessarly added to the result
         *                      list (if it is too late/too early)
         * @return {Boolean} true if it makes sense to continue the iteration
         *                   false if we're done.
         */
        accept: function (date) {
            var tooEarly = this.minDate && date < this.minDate
            var tooLate = this.maxDate && date > this.maxDate

            if (this.method === 'between') {
                if (tooEarly) return true
                if (tooLate) return false
            } else if (this.method === 'before') {
                if (tooLate) return false
            } else if (this.method === 'after') {
                if (tooEarly) return true
                this.add(date)
                return false
            }

            return this.add(date)
        },

        /**
         *
         * @param {Date} date that is part of the result.
         * @return {Boolean} whether we are interested in more values.
         */
        add: function (date) {
            this._result.push(date)
            return true
        },

        /**
         * 'before' and 'after' return only one date, whereas 'all'
         * and 'between' an array.
         * @return {Date,Array?}
         */
        getValue: function () {
            var res = this._result
            switch (this.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                case 'after':
                    return res.length ? res[res.length - 1] : null
            }
        },

        clone: function () {
            return new IterResult(this.method, this.args)
        }
    }

    /**
     * IterResult subclass that calls a callback function on each add,
     * and stops iterating when the callback returns false.
     */
    var CallbackIterResult = function (method, args, iterator) {
        var allowedMethods = ['all', 'between']
        if (!contains(allowedMethods, method)) {
            throw new Error('Invalid method "' + method +
                '". Only all and between works with iterator.')
        }
        this.add = function (date) {
            if (iterator(date, this._result.length)) {
                this._result.push(date)
                return true
            }
            return false
        }

        this.init(method, args)
    }
    CallbackIterResult.prototype = IterResult.prototype

    /**
     *
     * @param {Boolean?} noCache
     *  The same stratagy as RRule on cache, default to false
     * @constructor
     */

    var RRuleSet = function (noCache) {
        // Let RRuleSet cacheable
        this._cache = noCache ? null : {
            all: false,
            before: [],
            after: [],
            between: []
        }
        this._rrule = []
        this._rdate = []
        this._exrule = []
        this._exdate = []
    }

    RRuleSet.prototype = {
        constructor: RRuleSet,

        /**
        * @param {RRule}
        */
        rrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._rrule.map(String), String(rrule))) {
                this._rrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        rdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._rdate.map(Number), Number(date))) {
                this._rdate.push(date)
                dateutil.sort(this._rdate)
            }
        },

        /**
        * @param {RRule}
        */
        exrule: function (rrule) {
            if (!(rrule instanceof RRule)) {
                throw new TypeError(String(rrule) + ' is not RRule instance')
            }
            if (!contains(this._exrule.map(String), String(rrule))) {
                this._exrule.push(rrule)
            }
        },

        /**
        * @param {Date}
        */
        exdate: function (date) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + ' is not Date instance')
            }
            if (!contains(this._exdate.map(Number), Number(date))) {
                this._exdate.push(date)
                dateutil.sort(this._exdate)
            }
        },

        valueOf: function () {
            var result = []
            if (this._rrule.length) {
                this._rrule.forEach(function (rrule) {
                    result.push('RRULE:' + rrule)
                })
            }
            if (this._rdate.length) {
                result.push('RDATE:' + this._rdate.map(function (rdate) {
                    return dateutil.timeToUntilString(rdate)
                }).join(','))
            }
            if (this._exrule.length) {
                this._exrule.forEach(function (exrule) {
                    result.push('EXRULE:' + exrule)
                })
            }
            if (this._exdate.length) {
                result.push('EXDATE:' + this._exdate.map(function (exdate) {
                    return dateutil.timeToUntilString(exdate)
                }).join(','))
            }
            return result
        },

        /**
        * to generate recurrence field sush as:
        *   ["RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU;DTSTART=19970902T010000Z","RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH;DTSTART=19970902T010000Z"]
        */
        toString: function () {
            return JSON.stringify(this.valueOf())
        },

        _iter: function (iterResult) {
            var _exdateHash = {}
            var _exrule = this._exrule
            var _accept = iterResult.accept

            function evalExdate(after, before) {
                _exrule.forEach(function (rrule) {
                    rrule.between(after, before, true).forEach(function (date) {
                        _exdateHash[Number(date)] = true
                    })
                })
            }

            this._exdate.forEach(function (date) {
                _exdateHash[Number(date)] = true
            })

            iterResult.accept = function (date) {
                var dt = Number(date)
                if (!_exdateHash[dt]) {
                    evalExdate(new Date(dt - 1), new Date(dt + 1))
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                }
                return true
            }

            if (iterResult.method === 'between') {
                evalExdate(iterResult.args.after, iterResult.args.before)
                iterResult.accept = function (date) {
                    var dt = Number(date)
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true
                        return _accept.call(this, date)
                    }
                    return true
                }
            }

            for (var i = 0; i < this._rdate.length; i++) {
                if (!iterResult.accept(new Date(this._rdate[i]))) break
            }

            this._rrule.forEach(function (rrule) {
                rrule._iter(iterResult)
            })

            var res = iterResult._result
            dateutil.sort(res)
            switch (iterResult.method) {
                case 'all':
                case 'between':
                    return res
                case 'before':
                    return (res.length && res[res.length - 1]) || null
                case 'after':
                    return (res.length && res[0]) || null
                default:
                    return null
            }
        },

        /**
        * Create a new RRuleSet Object completely base on current instance
        */
        clone: function () {
            var rrs = new RRuleSet(!!this._cache)
            var i
            for (i = 0; i < this._rrule.length; i++) {
                rrs.rrule(this._rrule[i].clone())
            }
            for (i = 0; i < this._rdate.length; i++) {
                rrs.rdate(new Date(this._rdate[i]))
            }
            for (i = 0; i < this._exrule.length; i++) {
                rrs.exrule(this._exrule[i].clone())
            }
            for (i = 0; i < this._exdate.length; i++) {
                rrs.exdate(new Date(this._exdate[i]))
            }
            return rrs
        }
    }

    /**
     * Inherts method from RRule
     *  add Read interface and set RRuleSet cacheable
     */
    var RRuleSetMethods = ['all', 'between', 'before', 'after', 'count', '_cacheAdd', '_cacheGet']
    RRuleSetMethods.forEach(function (method) {
        RRuleSet.prototype[method] = RRule.prototype[method]
    })

    /**
     * RRuleStr
     *  To parse a set of rrule strings
     */

    var RRuleStr = function () { }

    RRuleStr.DEFAULT_OPTIONS = {
        dtstart: null,
        cache: false,
        unfold: false,
        forceset: false,
        compatible: false,
        ignoretz: false,
        tzinfos: null
    }

    RRuleStr._freq_map = {
        'YEARLY': RRule.YEARLY,
        'MONTHLY': RRule.MONTHLY,
        'WEEKLY': RRule.WEEKLY,
        'DAILY': RRule.DAILY,
        'HOURLY': RRule.HOURLY,
        'MINUTELY': RRule.MINUTELY,
        'SECONDLY': RRule.SECONDLY
    }

    RRuleStr._weekday_map = {
        'MO': 0,
        'TU': 1,
        'WE': 2,
        'TH': 3,
        'FR': 4,
        'SA': 5,
        'SU': 6
    }

    RRuleStr.prototype = {
        constructor: RRuleStr,

        _handle_int: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = parseInt(value, 10)
        },

        _handle_int_list: function (rrkwargs, name, value, options) {
            rrkwargs[name.toLowerCase()] = value.split(',').map(function (x) {
                return parseInt(x, 10)
            })
        },

        _handle_FREQ: function (rrkwargs, name, value, options) {
            rrkwargs['freq'] = RRuleStr._freq_map[value]
        },

        _handle_UNTIL: function (rrkwargs, name, value, options) {
            try {
                rrkwargs['until'] = dateutil.untilStringToDate(value)
            } catch (error) {
                throw new Error('invalid until date')
            }
        },

        _handle_WKST: function (rrkwargs, name, value, options) {
            rrkwargs['wkst'] = RRuleStr._weekday_map[value]
        },

        _handle_BYWEEKDAY: function (rrkwargs, name, value, options) {
            // Two ways to specify this: +1MO or MO(+1)
            var splt, i, j, n, w, wday
            var l = []
            var wdays = value.split(',')

            for (i = 0; i < wdays.length; i++) {
                wday = wdays[i]
                if (wday.indexOf('(') > -1) {
                    // If it's of the form TH(+1), etc.
                    splt = wday.split('(')
                    w = splt[0]
                    n = parseInt(splt.slice(1, -1), 10)
                } else {
                    // # If it's of the form +1MO
                    for (j = 0; j < wday.length; j++) {
                        if ('+-0123456789'.indexOf(wday[j]) === -1) break
                    }
                    n = wday.slice(0, j) || null
                    w = wday.slice(j)

                    if (n) n = parseInt(n, 10)
                }

                var weekday = new Weekday(RRuleStr._weekday_map[w], n)
                l.push(weekday)
            }
            rrkwargs['byweekday'] = l
        },

        _parseRfcRRule: function (line, options) {
            options = options || {}
            options.dtstart = options.dtstart || null
            options.cache = options.cache || false
            options.ignoretz = options.ignoretz || false
            options.tzinfos = options.tzinfos || null

            var name, value, parts
            if (line.indexOf(':') !== -1) {
                parts = line.split(':')
                name = parts[0]
                value = parts[1]

                if (name !== 'RRULE') throw new Error('unknown parameter name')
            } else {
                value = line
            }

            var i
            var rrkwargs = {}
            var pairs = value.split(';')

            for (i = 0; i < pairs.length; i++) {
                parts = pairs[i].split('=')
                name = parts[0].toUpperCase()
                value = parts[1].toUpperCase()

                try {
                    this['_handle_' + name](rrkwargs, name, value, {
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                } catch (error) {
                    throw new Error("unknown parameter '" + name + "':" + value)
                }
            }
            rrkwargs.dtstart = rrkwargs.dtstart || options.dtstart
            return new RRule(rrkwargs, !options.cache)
        },

        _parseRfc: function (s, options) {
            if (options.compatible) {
                options.forceset = true
                options.unfold = true
            }

            s = s && s.toUpperCase().trim()
            if (!s) throw new Error('Invalid empty string')

            var i = 0
            var line, lines

            // More info about 'unfold' option
            // Go head to https://www.ietf.org/rfc/rfc2445.txt
            if (options.unfold) {
                lines = s.split('\n')
                while (i < lines.length) {
                    // TODO
                    line = lines[i] = lines[i].replace(/\s+$/g, '')
                    if (!line) {
                        lines.splice(i, 1)
                    } else if (i > 0 && line[0] === ' ') {
                        lines[i - 1] += line.slice(1)
                        lines.splice(i, 1)
                    } else {
                        i += 1
                    }
                }
            } else {
                lines = s.split(/\s/)
            }

            var rrulevals = []
            var rdatevals = []
            var exrulevals = []
            var exdatevals = []
            var name, value, parts, parms, parm, dtstart, rset, j, k, datestrs, datestr

            if (!options.forceset && lines.length === 1 && (s.indexOf(':') === -1 ||
                s.indexOf('RRULE:') === 0)) {
                return this._parseRfcRRule(lines[0], {
                    cache: options.cache,
                    dtstart: options.dtstart,
                    ignoretz: options.ignoretz,
                    tzinfos: options.tzinfos
                })
            } else {
                for (i = 0; i < lines.length; i++) {
                    line = lines[i]
                    if (!line) continue
                    if (line.indexOf(':') === -1) {
                        name = 'RRULE'
                        value = line
                    } else {
                        parts = split(line, ':', 1)
                        name = parts[0]
                        value = parts[1]
                    }
                    parms = name.split(';')
                    if (!parms) throw new Error('empty property name')
                    name = parms[0]
                    parms = parms.slice(1)

                    if (name === 'RRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported RRULE parm: ' + parm)
                        }
                        rrulevals.push(value)
                    } else if (name === 'RDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        rdatevals.push(value)
                    } else if (name === 'EXRULE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            throw new Error('unsupported EXRULE parm: ' + parm)
                        }
                        exrulevals.push(value)
                    } else if (name === 'EXDATE') {
                        for (j = 0; j < parms.length; j++) {
                            parm = parms[j]
                            if (parm !== 'VALUE=DATE-TIME') {
                                throw new Error('unsupported RDATE parm: ' + parm)
                            }
                        }
                        exdatevals.push(value)
                    } else if (name === 'DTSTART') {
                        dtstart = dateutil.untilStringToDate(value)
                    } else {
                        throw new Error('unsupported property: ' + name)
                    }
                }

                if (options.forceset || rrulevals.length > 1 || rdatevals.length ||
                    exrulevals.length || exdatevals.length) {
                    rset = new RRuleSet(!options.cache)
                    for (j = 0; j < rrulevals.length; j++) {
                        rset.rrule(this._parseRfcRRule(rrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < rdatevals.length; j++) {
                        datestrs = rdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.rdate(dateutil.untilStringToDate(datestr))
                        }
                    }
                    for (j = 0; j < exrulevals.length; j++) {
                        rset.exrule(this._parseRfcRRule(exrulevals[j], {
                            dtstart: options.dtstart || dtstart,
                            ignoretz: options.ignoretz,
                            tzinfos: options.tzinfos
                        }))
                    }
                    for (j = 0; j < exdatevals.length; j++) {
                        datestrs = exdatevals[j].split(',')
                        for (k = 0; k < datestrs.length; k++) {
                            datestr = datestrs[k]
                            rset.exdate(dateutil.untilStringToDate(datestr))
                        }
                    }

                    if (options.campatiable && options.dtstart) rset.rdate(dtstart)
                    return rset
                } else {
                    return this._parseRfcRRule(rrulevals[0], {
                        dtstart: options.dtstart || dtstart,
                        cache: options.cache,
                        ignoretz: options.ignoretz,
                        tzinfos: options.tzinfos
                    })
                }
            }
        },

        parse: function (s, options) {
            options = options || {}

            var invalid = []
            var keys = Object.keys(options)
            var defaultKeys = Object.keys(RRuleStr.DEFAULT_OPTIONS)

            keys.forEach(function (key) {
                if (!contains(defaultKeys, key)) invalid.push(key)
            }, this)

            if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '))

            // Merge in default options
            defaultKeys.forEach(function (key) {
                if (!contains(keys, key)) options[key] = RRuleStr.DEFAULT_OPTIONS[key]
            })

            return this._parseRfc(s, options)
        }
    }

    RRuleStr.prototype._handle_DTSTART = function (rrkwargs, name, value, options) {
        rrkwargs[name.toLowerCase()] = dateutil.untilStringToDate(value)
    }

    RRuleStr.prototype._handle_BYDAY = RRuleStr.prototype._handle_BYWEEKDAY
    RRuleStr.prototype._handle_INTERVAL = RRuleStr.prototype._handle_int
    RRuleStr.prototype._handle_COUNT = RRuleStr.prototype._handle_int

        ;[
            '_handle_BYSETPOS', '_handle_BYMONTH', '_handle_BYMONTHDAY',
            '_handle_BYYEARDAY', '_handle_BYEASTER', '_handle_BYWEEKNO',
            '_handle_BYHOUR', '_handle_BYMINUTE', '_handle_BYSECOND'
        ].forEach(function (method) {
            RRuleStr.prototype[method] = RRuleStr.prototype._handle_int_list
        })

    // =============================================================================
    // Export
    // =============================================================================

    // Only one RRuleStr instance for all rrule string parsing work.
    var rruleStr = new RRuleStr()
    var rrulestr = function () {
        return rruleStr.parse.apply(rruleStr, arguments)
    }

    RRule.RRule = RRule
    RRule.RRuleSet = RRuleSet
    RRule.rrulestr = rrulestr
    return RRule

    function getnlp() {
        // Lazy, runtime import to avoid circular refs.
        if (!getnlp._nlp) {
            if (root && root._getRRuleNLP) {
                getnlp._nlp = root._getRRuleNLP(RRule)
            } else if (typeof require === 'function') {
                getnlp._nlp = require('./nlp')(RRule)
            } else {
                throw new Error('You need to include rrule/nlp.js for fromText/toText to work.')
            }
        }
        return getnlp._nlp
    }
}))

//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

; (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            global.moment = factory()
}(this, (function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        var k;
        for (k in obj) {
            // even if its not own property I'd still call it non-empty
            return false;
        }
        return true;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    var some$1 = some;

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    function isUndefined(input) {
        return input === void 0;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !== 'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var keys$1 = keys;

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid()) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/;            //       0 - 9
    var match2 = /\d\d/;          //      00 - 99
    var match3 = /\d{3}/;         //     000 - 999
    var match4 = /\d{4}/;         //    0000 - 9999
    var match6 = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2 = /\d\d?/;         //       0 - 99
    var match3to4 = /\d\d\d\d?/;     //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/;       //       0 - 999
    var match1to4 = /\d{1,4}/;       //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned = /\d+/;           //       0 - inf
    var matchSigned = /[+-]?\d+/;      //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    var indexOf$1 = indexOf;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return this._months;
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return this._monthsShort;
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //https://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        //the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    //https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        if (!m) {
            return this._weekdays;
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf$1.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    // months
    // week
    // weekdays
    // meridiem
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        ordinalParse: defaultOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See https://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, parentConfig = baseConfig;
            // MERGE
            if (locales[name] != null) {
                parentConfig = locales[name]._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys$1(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11 ? MONTH :
                    a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                        a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                            a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE :
                                a[SECOND] < 0 || a[SECOND] > 59 ? SECOND :
                                    a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                                        -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'https://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () { };

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof (input) === 'object') {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. https://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
            0 :
            parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () { };

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from https://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                    'See https://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                        diff < 2 ? 'nextDay' :
                            diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that,
            zoneDelta,
            delta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                    units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                        units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString() {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if (isFunction(Date.prototype.toISOString)) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
                createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    function startOf(units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf(units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf() {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$1() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$1;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;

    // Year
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;

    // Week Year
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    proto.quarter = proto.quarters = getSetQuarter;

    // Month
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;

    // Week
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;

    // Hour
    proto.hour = proto.hours = getSetHour;

    // Minute
    proto.minute = proto.minutes = getSetMinute;

    // Second
    proto.second = proto.seconds = getSetSecond;

    // Millisecond
    proto.millisecond = proto.milliseconds = getSetMillisecond;

    // Offset
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;

    // Timezone
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;

    // Deprecations
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See https://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    // Month
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;

    // Week
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    // Hours
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week': return days / 7 + milliseconds / 6048e5;
                case 'day': return days + milliseconds / 864e5;
                case 'hour': return days * 24 + milliseconds / 36e5;
                case 'minute': return days * 1440 + milliseconds / 6e4;
                case 'second': return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asYears = makeAs('y');

    function get$2(units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds] ||
            minutes <= 1 && ['m'] ||
            minutes < thresholds.m && ['mm', minutes] ||
            hours <= 1 && ['h'] ||
            hours < thresholds.h && ['hh', hours] ||
            days <= 1 && ['d'] ||
            days < thresholds.d && ['dd', days] ||
            months <= 1 && ['M'] ||
            months < thresholds.M && ['MM', months] ||
            years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof (roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize(withSuffix) {
        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    // Deprecations
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.17.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    return hooks;

})));
/**
 * interact.js v1.2.9
 *
 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
(function (realWindow) {
    'use strict';

    // return early if there's no window to work with (eg. Node.js)
    if (!realWindow) { return; }

    var // get wrapped window if using Shadow DOM polyfill
        window = (function () {
            // create a TextNode
            var el = realWindow.document.createTextNode('');

            // check if it's wrapped by a polyfill
            if (el.ownerDocument !== realWindow.document
                && typeof realWindow.wrap === 'function'
                && realWindow.wrap(el) === el) {
                // return wrapped window
                return realWindow.wrap(realWindow);
            }

            // no Shadow DOM polyfil or native implementation
            return realWindow;
        }()),

        document = window.document,
        DocumentFragment = window.DocumentFragment || blank,
        SVGElement = window.SVGElement || blank,
        SVGSVGElement = window.SVGSVGElement || blank,
        SVGElementInstance = window.SVGElementInstance || blank,
        HTMLElement = window.HTMLElement || window.Element,

        PointerEvent = (window.PointerEvent || window.MSPointerEvent),
        pEventTypes,

        hypot = Math.hypot || function (x, y) { return Math.sqrt(x * x + y * y); },

        tmpXY = {},     // reduce object creation in getXY()

        documents = [],   // all documents being listened to

        interactables = [],   // all set interactables
        interactions = [],   // all interactions

        dynamicDrop = false,

        // {
        //      type: {
        //          selectors: ['selector', ...],
        //          contexts : [document, ...],
        //          listeners: [[listener, useCapture], ...]
        //      }
        //  }
        delegatedEvents = {},

        defaultOptions = {
            base: {
                accept: null,
                actionChecker: null,
                styleCursor: true,
                preventDefault: 'auto',
                origin: { x: 0, y: 0 },
                deltaSource: 'page',
                allowFrom: null,
                ignoreFrom: null,
                _context: document,
                dropChecker: null
            },

            drag: {
                enabled: false,
                manualStart: true,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                axis: 'xy'
            },

            drop: {
                enabled: false,
                accept: null,
                overlap: 'pointer'
            },

            resize: {
                enabled: false,
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: null,
                restrict: null,
                inertia: null,
                autoScroll: null,

                square: false,
                preserveAspectRatio: false,
                axis: 'xy',

                // use default margin
                margin: NaN,

                // object with props left, right, top, bottom which are
                // true/false values to resize when the pointer is over that edge,
                // CSS selectors to match the handles for each direction
                // or the Elements for each handle
                edges: null,

                // a value of 'none' will limit the resize rect to a minimum of 0x0
                // 'negate' will alow the rect to have negative width/height
                // 'reposition' will keep the width/height positive by swapping
                // the top and bottom edges and/or swapping the left and right edges
                invert: 'none'
            },

            gesture: {
                manualStart: false,
                enabled: false,
                max: Infinity,
                maxPerElement: 1,

                restrict: null
            },

            perAction: {
                manualStart: false,
                max: Infinity,
                maxPerElement: 1,

                snap: {
                    enabled: false,
                    endOnly: false,
                    range: Infinity,
                    targets: null,
                    offsets: null,

                    relativePoints: null
                },

                restrict: {
                    enabled: false,
                    endOnly: false
                },

                autoScroll: {
                    enabled: false,
                    container: null,     // the item that is scrolled (Window or HTMLElement)
                    margin: 60,
                    speed: 300       // the scroll speed in pixels per second
                },

                inertia: {
                    enabled: false,
                    resistance: 10,    // the lambda in exponential decay
                    minSpeed: 100,   // target speed must be above this for inertia to start
                    endSpeed: 10,    // the speed at which inertia is slow enough to stop
                    allowResume: true,  // allow resuming an action in inertia phase
                    zeroResumeDelta: true,  // if an action is resumed after launch, set dx/dy to 0
                    smoothEndDuration: 300    // animate to snap/restrict endOnly if there's no inertia
                }
            },

            _holdDuration: 600
        },

        // Things related to autoScroll
        autoScroll = {
            interaction: null,
            i: null,    // the handle returned by window.setInterval
            x: 0, y: 0, // Direction each pulse is to scroll in

            // scroll the window by the values in scroll.x/y
            scroll: function () {
                var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll,
                    container = options.container || getWindow(autoScroll.interaction.element),
                    now = new Date().getTime(),
                    // change in time in seconds
                    dtx = (now - autoScroll.prevTimeX) / 1000,
                    dty = (now - autoScroll.prevTimeY) / 1000,
                    vx, vy, sx, sy;

                // displacement
                if (options.velocity) {
                    vx = options.velocity.x;
                    vy = options.velocity.y;
                }
                else {
                    vx = vy = options.speed
                }

                sx = vx * dtx;
                sy = vy * dty;

                if (sx >= 1 || sy >= 1) {
                    if (isWindow(container)) {
                        container.scrollBy(autoScroll.x * sx, autoScroll.y * sy);
                    }
                    else if (container) {
                        container.scrollLeft += autoScroll.x * sx;
                        container.scrollTop += autoScroll.y * sy;
                    }

                    if (sx >= 1) autoScroll.prevTimeX = now;
                    if (sy >= 1) autoScroll.prevTimeY = now;
                }

                if (autoScroll.isScrolling) {
                    cancelFrame(autoScroll.i);
                    autoScroll.i = reqFrame(autoScroll.scroll);
                }
            },

            isScrolling: false,
            prevTimeX: 0,
            prevTimeY: 0,

            start: function (interaction) {
                autoScroll.isScrolling = true;
                cancelFrame(autoScroll.i);

                autoScroll.interaction = interaction;
                autoScroll.prevTimeX = new Date().getTime();
                autoScroll.prevTimeY = new Date().getTime();
                autoScroll.i = reqFrame(autoScroll.scroll);
            },

            stop: function () {
                autoScroll.isScrolling = false;
                cancelFrame(autoScroll.i);
            }
        },

        // Does the browser support touch input?
        supportsTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),

        // Does the browser support PointerEvents
        // Avoid PointerEvent bugs introduced in Chrome 55
        supportsPointerEvent = PointerEvent && !/Chrome/.test(navigator.userAgent),

        // Less Precision with touch input
        margin = supportsTouch || supportsPointerEvent ? 20 : 10,

        pointerMoveTolerance = 1,

        // for ignoring browser's simulated mouse events
        prevTouchTime = 0,

        // Allow this many interactions to happen simultaneously
        maxInteractions = Infinity,

        // Check if is IE9 or older
        actionCursors = (document.all && !window.atob) ? {
            drag: 'move',
            resizex: 'e-resize',
            resizey: 's-resize',
            resizexy: 'se-resize',

            resizetop: 'n-resize',
            resizeleft: 'w-resize',
            resizebottom: 's-resize',
            resizeright: 'e-resize',
            resizetopleft: 'se-resize',
            resizebottomright: 'se-resize',
            resizetopright: 'ne-resize',
            resizebottomleft: 'ne-resize',

            gesture: ''
        } : {
            drag: 'move',
            resizex: 'ew-resize',
            resizey: 'ns-resize',
            resizexy: 'nwse-resize',

            resizetop: 'ns-resize',
            resizeleft: 'ew-resize',
            resizebottom: 'ns-resize',
            resizeright: 'ew-resize',
            resizetopleft: 'nwse-resize',
            resizebottomright: 'nwse-resize',
            resizetopright: 'nesw-resize',
            resizebottomleft: 'nesw-resize',

            gesture: ''
        },

        actionIsEnabled = {
            drag: true,
            resize: true,
            gesture: true
        },

        // because Webkit and Opera still use 'mousewheel' event type
        wheelEvent = 'onmousewheel' in document ? 'mousewheel' : 'wheel',

        eventTypes = [
            'dragstart',
            'dragmove',
            'draginertiastart',
            'dragend',
            'dragenter',
            'dragleave',
            'dropactivate',
            'dropdeactivate',
            'dropmove',
            'drop',
            'resizestart',
            'resizemove',
            'resizeinertiastart',
            'resizeend',
            'gesturestart',
            'gesturemove',
            'gestureinertiastart',
            'gestureend',

            'down',
            'move',
            'up',
            'cancel',
            'tap',
            'doubletap',
            'hold'
        ],

        globalEvents = {},

        // Opera Mobile must be handled differently
        isOperaMobile = navigator.appName == 'Opera' &&
            supportsTouch &&
            navigator.userAgent.match('Presto'),

        // scrolling doesn't change the result of getClientRects on iOS 7
        isIOS7 = (/iP(hone|od|ad)/.test(navigator.platform)
            && /OS 7[^\d]/.test(navigator.appVersion)),

        // prefix matchesSelector
        prefixedMatchesSelector = 'matches' in Element.prototype ?
            'matches' : 'webkitMatchesSelector' in Element.prototype ?
                'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ?
                    'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ?
                        'oMatchesSelector' : 'msMatchesSelector',

        // will be polyfill function if browser is IE8
        ie8MatchesSelector,

        // native requestAnimationFrame or polyfill
        reqFrame = realWindow.requestAnimationFrame,
        cancelFrame = realWindow.cancelAnimationFrame,

        // Events wrapper
        events = (function () {
            var useAttachEvent = ('attachEvent' in window) && !('addEventListener' in window),
                addEvent = useAttachEvent ? 'attachEvent' : 'addEventListener',
                removeEvent = useAttachEvent ? 'detachEvent' : 'removeEventListener',
                on = useAttachEvent ? 'on' : '',

                elements = [],
                targets = [],
                attachedListeners = [];

            function add(element, type, listener, useCapture) {
                var elementIndex = indexOf(elements, element),
                    target = targets[elementIndex];

                if (!target) {
                    target = {
                        events: {},
                        typeCount: 0
                    };

                    elementIndex = elements.push(element) - 1;
                    targets.push(target);

                    attachedListeners.push((useAttachEvent ? {
                        supplied: [],
                        wrapped: [],
                        useCount: []
                    } : null));
                }

                if (!target.events[type]) {
                    target.events[type] = [];
                    target.typeCount++;
                }

                if (!contains(target.events[type], listener)) {
                    var ret;

                    if (useAttachEvent) {
                        var listeners = attachedListeners[elementIndex],
                            listenerIndex = indexOf(listeners.supplied, listener);

                        var wrapped = listeners.wrapped[listenerIndex] || function (event) {
                            if (!event.immediatePropagationStopped) {
                                event.target = event.srcElement;
                                event.currentTarget = element;

                                event.preventDefault = event.preventDefault || preventDef;
                                event.stopPropagation = event.stopPropagation || stopProp;
                                event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;

                                if (/mouse|click/.test(event.type)) {
                                    event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;
                                    event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;
                                }

                                listener(event);
                            }
                        };

                        ret = element[addEvent](on + type, wrapped, Boolean(useCapture));

                        if (listenerIndex === -1) {
                            listeners.supplied.push(listener);
                            listeners.wrapped.push(wrapped);
                            listeners.useCount.push(1);
                        }
                        else {
                            listeners.useCount[listenerIndex]++;
                        }
                    }
                    else {
                        ret = element[addEvent](type, listener, useCapture || false);
                    }
                    target.events[type].push(listener);

                    return ret;
                }
            }

            function remove(element, type, listener, useCapture) {
                var i,
                    elementIndex = indexOf(elements, element),
                    target = targets[elementIndex],
                    listeners,
                    listenerIndex,
                    wrapped = listener;

                if (!target || !target.events) {
                    return;
                }

                if (useAttachEvent) {
                    listeners = attachedListeners[elementIndex];
                    listenerIndex = indexOf(listeners.supplied, listener);
                    wrapped = listeners.wrapped[listenerIndex];
                }

                if (type === 'all') {
                    for (type in target.events) {
                        if (target.events.hasOwnProperty(type)) {
                            remove(element, type, 'all');
                        }
                    }
                    return;
                }

                if (target.events[type]) {
                    var len = target.events[type].length;

                    if (listener === 'all') {
                        for (i = 0; i < len; i++) {
                            remove(element, type, target.events[type][i], Boolean(useCapture));
                        }
                        return;
                    } else {
                        for (i = 0; i < len; i++) {
                            if (target.events[type][i] === listener) {
                                element[removeEvent](on + type, wrapped, useCapture || false);
                                target.events[type].splice(i, 1);

                                if (useAttachEvent && listeners) {
                                    listeners.useCount[listenerIndex]--;
                                    if (listeners.useCount[listenerIndex] === 0) {
                                        listeners.supplied.splice(listenerIndex, 1);
                                        listeners.wrapped.splice(listenerIndex, 1);
                                        listeners.useCount.splice(listenerIndex, 1);
                                    }
                                }

                                break;
                            }
                        }
                    }

                    if (target.events[type] && target.events[type].length === 0) {
                        target.events[type] = null;
                        target.typeCount--;
                    }
                }

                if (!target.typeCount) {
                    targets.splice(elementIndex, 1);
                    elements.splice(elementIndex, 1);
                    attachedListeners.splice(elementIndex, 1);
                }
            }

            function preventDef() {
                this.returnValue = false;
            }

            function stopProp() {
                this.cancelBubble = true;
            }

            function stopImmProp() {
                this.cancelBubble = true;
                this.immediatePropagationStopped = true;
            }

            return {
                add: add,
                remove: remove,
                useAttachEvent: useAttachEvent,

                _elements: elements,
                _targets: targets,
                _attachedListeners: attachedListeners
            };
        }());

    function blank() { }

    function isElement(o) {
        if (!o || (typeof o !== 'object')) { return false; }

        var _window = getWindow(o) || window;

        return (/object|function/.test(typeof _window.Element)
            ? o instanceof _window.Element //DOM2
            : o.nodeType === 1 && typeof o.nodeName === "string");
    }
    function isWindow(thing) { return thing === window || !!(thing && thing.Window) && (thing instanceof thing.Window); }
    function isDocFrag(thing) { return !!thing && thing instanceof DocumentFragment; }
    function isArray(thing) {
        return isObject(thing)
            && (typeof thing.length !== undefined)
            && isFunction(thing.splice);
    }
    function isObject(thing) { return !!thing && (typeof thing === 'object'); }
    function isFunction(thing) { return typeof thing === 'function'; }
    function isNumber(thing) { return typeof thing === 'number'; }
    function isBool(thing) { return typeof thing === 'boolean'; }
    function isString(thing) { return typeof thing === 'string'; }

    function trySelector(value) {
        if (!isString(value)) { return false; }

        // an exception will be raised if it is invalid
        document.querySelector(value);
        return true;
    }

    function extend(dest, source) {
        for (var prop in source) {
            dest[prop] = source[prop];
        }
        return dest;
    }

    var prefixedPropREs = {
        webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
    };

    function pointerExtend(dest, source) {
        for (var prop in source) {
            var deprecated = false;

            // skip deprecated prefixed properties
            for (var vendor in prefixedPropREs) {
                if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
                    deprecated = true;
                    break;
                }
            }

            if (!deprecated) {
                dest[prop] = source[prop];
            }
        }
        return dest;
    }

    function copyCoords(dest, src) {
        dest.page = dest.page || {};
        dest.page.x = src.page.x;
        dest.page.y = src.page.y;

        dest.client = dest.client || {};
        dest.client.x = src.client.x;
        dest.client.y = src.client.y;

        dest.timeStamp = src.timeStamp;
    }

    function setEventXY(targetObj, pointers, interaction) {
        var pointer = (pointers.length > 1
            ? pointerAverage(pointers)
            : pointers[0]);

        getPageXY(pointer, tmpXY, interaction);
        targetObj.page.x = tmpXY.x;
        targetObj.page.y = tmpXY.y;

        getClientXY(pointer, tmpXY, interaction);
        targetObj.client.x = tmpXY.x;
        targetObj.client.y = tmpXY.y;

        targetObj.timeStamp = new Date().getTime();
    }

    function setEventDeltas(targetObj, prev, cur) {
        targetObj.page.x = cur.page.x - prev.page.x;
        targetObj.page.y = cur.page.y - prev.page.y;
        targetObj.client.x = cur.client.x - prev.client.x;
        targetObj.client.y = cur.client.y - prev.client.y;
        targetObj.timeStamp = new Date().getTime() - prev.timeStamp;

        // set pointer velocity
        var dt = Math.max(targetObj.timeStamp / 1000, 0.001);
        targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
        targetObj.page.vx = targetObj.page.x / dt;
        targetObj.page.vy = targetObj.page.y / dt;

        targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
        targetObj.client.vx = targetObj.client.x / dt;
        targetObj.client.vy = targetObj.client.y / dt;
    }

    function isNativePointer(pointer) {
        return (pointer instanceof window.Event
            || (supportsTouch && window.Touch && pointer instanceof window.Touch));
    }

    // Get specified X/Y coords for mouse or event.touches[0]
    function getXY(type, pointer, xy) {
        xy = xy || {};
        type = type || 'page';

        xy.x = pointer[type + 'X'];
        xy.y = pointer[type + 'Y'];

        return xy;
    }

    function getPageXY(pointer, page) {
        page = page || {};

        // Opera Mobile handles the viewport and scrolling oddly
        if (isOperaMobile && isNativePointer(pointer)) {
            getXY('screen', pointer, page);

            page.x += window.scrollX;
            page.y += window.scrollY;
        }
        else {
            getXY('page', pointer, page);
        }

        return page;
    }

    function getClientXY(pointer, client) {
        client = client || {};

        if (isOperaMobile && isNativePointer(pointer)) {
            // Opera Mobile handles the viewport and scrolling oddly
            getXY('screen', pointer, client);
        }
        else {
            getXY('client', pointer, client);
        }

        return client;
    }

    function getScrollXY(win) {
        win = win || window;
        return {
            x: win.scrollX || win.document.documentElement.scrollLeft,
            y: win.scrollY || win.document.documentElement.scrollTop
        };
    }

    function getPointerId(pointer) {
        return isNumber(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
    }

    function getActualElement(element) {
        return (element instanceof SVGElementInstance
            ? element.correspondingUseElement
            : element);
    }

    function getWindow(node) {
        if (isWindow(node)) {
            return node;
        }

        var rootNode = (node.ownerDocument || node);

        return rootNode.defaultView || rootNode.parentWindow || window;
    }

    function getElementClientRect(element) {
        var clientRect = (element instanceof SVGElement
            ? element.getBoundingClientRect()
            : element.getClientRects()[0]);

        return clientRect && {
            left: clientRect.left,
            right: clientRect.right,
            top: clientRect.top,
            bottom: clientRect.bottom,
            width: clientRect.width || clientRect.right - clientRect.left,
            height: clientRect.height || clientRect.bottom - clientRect.top
        };
    }

    function getElementRect(element) {
        var clientRect = getElementClientRect(element);

        if (!isIOS7 && clientRect) {
            var scroll = getScrollXY(getWindow(element));

            clientRect.left += scroll.x;
            clientRect.right += scroll.x;
            clientRect.top += scroll.y;
            clientRect.bottom += scroll.y;
        }

        return clientRect;
    }

    function getTouchPair(event) {
        var touches = [];

        // array of touches is supplied
        if (isArray(event)) {
            touches[0] = event[0];
            touches[1] = event[1];
        }
        // an event
        else {
            if (event.type === 'touchend') {
                if (event.touches.length === 1) {
                    touches[0] = event.touches[0];
                    touches[1] = event.changedTouches[0];
                }
                else if (event.touches.length === 0) {
                    touches[0] = event.changedTouches[0];
                    touches[1] = event.changedTouches[1];
                }
            }
            else {
                touches[0] = event.touches[0];
                touches[1] = event.touches[1];
            }
        }

        return touches;
    }

    function pointerAverage(pointers) {
        var average = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        };
        var prop;

        for (var i = 0; i < pointers.length; i++) {
            for (prop in average) {
                average[prop] += pointers[i][prop];
            }
        }
        for (prop in average) {
            average[prop] /= pointers.length;
        }

        return average;
    }

    function touchBBox(event) {
        if (!event.length && !(event.touches && event.touches.length > 1)) {
            return;
        }

        var touches = getTouchPair(event),
            minX = Math.min(touches[0].pageX, touches[1].pageX),
            minY = Math.min(touches[0].pageY, touches[1].pageY),
            maxX = Math.max(touches[0].pageX, touches[1].pageX),
            maxY = Math.max(touches[0].pageY, touches[1].pageY);

        return {
            x: minX,
            y: minY,
            left: minX,
            top: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }

    function touchDistance(event, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event);


        var dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY];

        return hypot(dx, dy);
    }

    function touchAngle(event, prevAngle, deltaSource) {
        deltaSource = deltaSource || defaultOptions.deltaSource;

        var sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            touches = getTouchPair(event),
            dx = touches[0][sourceX] - touches[1][sourceX],
            dy = touches[0][sourceY] - touches[1][sourceY],
            angle = 180 * Math.atan(dy / dx) / Math.PI;

        if (isNumber(prevAngle)) {
            var dr = angle - prevAngle,
                drClamped = dr % 360;

            if (drClamped > 315) {
                angle -= 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped > 135) {
                angle -= 180 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -315) {
                angle += 360 + (angle / 360) | 0 * 360;
            }
            else if (drClamped < -135) {
                angle += 180 + (angle / 360) | 0 * 360;
            }
        }

        return angle;
    }

    function getOriginXY(interactable, element) {
        var origin = interactable
            ? interactable.options.origin
            : defaultOptions.origin;

        if (origin === 'parent') {
            origin = parentElement(element);
        }
        else if (origin === 'self') {
            origin = interactable.getRect(element);
        }
        else if (trySelector(origin)) {
            origin = closest(element, origin) || { x: 0, y: 0 };
        }

        if (isFunction(origin)) {
            origin = origin(interactable && element);
        }

        if (isElement(origin)) {
            origin = getElementRect(origin);
        }

        origin.x = ('x' in origin) ? origin.x : origin.left;
        origin.y = ('y' in origin) ? origin.y : origin.top;

        return origin;
    }

    // https://stackoverflow.com/a/5634528/2280888
    function _getQBezierValue(t, p1, p2, p3) {
        var iT = 1 - t;
        return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
    }

    function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
        return {
            x: _getQBezierValue(position, startX, cpX, endX),
            y: _getQBezierValue(position, startY, cpY, endY)
        };
    }

    // https://gizma.com/easing/
    function easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
    }

    function nodeContains(parent, child) {
        while (child) {
            if (child === parent) {
                return true;
            }

            child = child.parentNode;
        }

        return false;
    }

    function closest(child, selector) {
        var parent = parentElement(child);

        while (isElement(parent)) {
            if (matchesSelector(parent, selector)) { return parent; }

            parent = parentElement(parent);
        }

        return null;
    }

    function parentElement(node) {
        var parent = node.parentNode;

        if (isDocFrag(parent)) {
            // skip past #shado-root fragments
            while ((parent = parent.host) && isDocFrag(parent)) { }

            return parent;
        }

        return parent;
    }

    function inContext(interactable, element) {
        return interactable._context === element.ownerDocument
            || nodeContains(interactable._context, element);
    }

    function testIgnore(interactable, interactableElement, element) {
        var ignoreFrom = interactable.options.ignoreFrom;

        if (!ignoreFrom || !isElement(element)) { return false; }

        if (isString(ignoreFrom)) {
            return matchesUpTo(element, ignoreFrom, interactableElement);
        }
        else if (isElement(ignoreFrom)) {
            return nodeContains(ignoreFrom, element);
        }

        return false;
    }

    function testAllow(interactable, interactableElement, element) {
        var allowFrom = interactable.options.allowFrom;

        if (!allowFrom) { return true; }

        if (!isElement(element)) { return false; }

        if (isString(allowFrom)) {
            return matchesUpTo(element, allowFrom, interactableElement);
        }
        else if (isElement(allowFrom)) {
            return nodeContains(allowFrom, element);
        }

        return false;
    }

    function checkAxis(axis, interactable) {
        if (!interactable) { return false; }

        var thisAxis = interactable.options.drag.axis;

        return (axis === 'xy' || thisAxis === 'xy' || thisAxis === axis);
    }

    function checkSnap(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].snap && options[action].snap.enabled;
    }

    function checkRestrict(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].restrict && options[action].restrict.enabled;
    }

    function checkAutoScroll(interactable, action) {
        var options = interactable.options;

        if (/^resize/.test(action)) {
            action = 'resize';
        }

        return options[action].autoScroll && options[action].autoScroll.enabled;
    }

    function withinInteractionLimit(interactable, element, action) {
        var options = interactable.options,
            maxActions = options[action.name].max,
            maxPerElement = options[action.name].maxPerElement,
            activeInteractions = 0,
            targetCount = 0,
            targetElementCount = 0;

        for (var i = 0, len = interactions.length; i < len; i++) {
            var interaction = interactions[i],
                otherAction = interaction.prepared.name,
                active = interaction.interacting();

            if (!active) { continue; }

            activeInteractions++;

            if (activeInteractions >= maxInteractions) {
                return false;
            }

            if (interaction.target !== interactable) { continue; }

            targetCount += (otherAction === action.name) | 0;

            if (targetCount >= maxActions) {
                return false;
            }

            if (interaction.element === element) {
                targetElementCount++;

                if (otherAction !== action.name || targetElementCount >= maxPerElement) {
                    return false;
                }
            }
        }

        return maxInteractions > 0;
    }

    // Test for the element that's "above" all other qualifiers
    function indexOfDeepestElement(elements) {
        var dropzone,
            deepestZone = elements[0],
            index = deepestZone ? 0 : -1,
            parent,
            deepestZoneParents = [],
            dropzoneParents = [],
            child,
            i,
            n;

        for (i = 1; i < elements.length; i++) {
            dropzone = elements[i];

            // an element might belong to multiple selector dropzones
            if (!dropzone || dropzone === deepestZone) {
                continue;
            }

            if (!deepestZone) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            // check if the deepest or current are document.documentElement or document.rootElement
            // - if the current dropzone is, do nothing and continue
            if (dropzone.parentNode === dropzone.ownerDocument) {
                continue;
            }
            // - if deepest is, update with the current dropzone and continue to next
            else if (deepestZone.parentNode === dropzone.ownerDocument) {
                deepestZone = dropzone;
                index = i;
                continue;
            }

            if (!deepestZoneParents.length) {
                parent = deepestZone;
                while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
                    deepestZoneParents.unshift(parent);
                    parent = parent.parentNode;
                }
            }

            // if this element is an svg element and the current deepest is
            // an HTMLElement
            if (deepestZone instanceof HTMLElement
                && dropzone instanceof SVGElement
                && !(dropzone instanceof SVGSVGElement)) {

                if (dropzone === deepestZone.parentNode) {
                    continue;
                }

                parent = dropzone.ownerSVGElement;
            }
            else {
                parent = dropzone;
            }

            dropzoneParents = [];

            while (parent.parentNode !== parent.ownerDocument) {
                dropzoneParents.unshift(parent);
                parent = parent.parentNode;
            }

            n = 0;

            // get (position of last common ancestor) + 1
            while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
                n++;
            }

            var parents = [
                dropzoneParents[n - 1],
                dropzoneParents[n],
                deepestZoneParents[n]
            ];

            child = parents[0].lastChild;

            while (child) {
                if (child === parents[1]) {
                    deepestZone = dropzone;
                    index = i;
                    deepestZoneParents = [];

                    break;
                }
                else if (child === parents[2]) {
                    break;
                }

                child = child.previousSibling;
            }
        }

        return index;
    }

    function Interaction() {
        this.target = null; // current interactable being interacted with
        this.element = null; // the target element of the interactable
        this.dropTarget = null; // the dropzone a drag target might be dropped into
        this.dropElement = null; // the element at the time of checking
        this.prevDropTarget = null; // the dropzone that was recently dragged away from
        this.prevDropElement = null; // the element at the time of checking

        this.prepared = {     // action that's ready to be fired on next move event
            name: null,
            axis: null,
            edges: null
        };

        this.matches = [];   // all selectors that are matched by target element
        this.matchElements = [];   // corresponding elements

        this.inertiaStatus = {
            active: false,
            smoothEnd: false,
            ending: false,

            startEvent: null,
            upCoords: {},

            xe: 0, ye: 0,
            sx: 0, sy: 0,

            t0: 0,
            vx0: 0, vys: 0,
            duration: 0,

            resumeDx: 0,
            resumeDy: 0,

            lambda_v0: 0,
            one_ve_v0: 0,
            i: null
        };

        if (isFunction(Function.prototype.bind)) {
            this.boundInertiaFrame = this.inertiaFrame.bind(this);
            this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);
        }
        else {
            var that = this;

            this.boundInertiaFrame = function () { return that.inertiaFrame(); };
            this.boundSmoothEndFrame = function () { return that.smoothEndFrame(); };
        }

        this.activeDrops = {
            dropzones: [],      // the dropzones that are mentioned below
            elements: [],      // elements of dropzones that accept the target draggable
            rects: []       // the rects of the elements mentioned above
        };

        // keep track of added pointers
        this.pointers = [];
        this.pointerIds = [];
        this.downTargets = [];
        this.downTimes = [];
        this.holdTimers = [];

        // Previous native pointer move event coordinates
        this.prevCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };
        // current native pointer move event coordinates
        this.curCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Starting InteractEvent pointer coordinates
        this.startCoords = {
            page: { x: 0, y: 0 },
            client: { x: 0, y: 0 },
            timeStamp: 0
        };

        // Change in coordinates and time of the pointer
        this.pointerDelta = {
            page: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            client: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
            timeStamp: 0
        };

        this.downEvent = null;    // pointerdown/mousedown/touchstart event
        this.downPointer = {};

        this._eventTarget = null;
        this._curEventTarget = null;

        this.prevEvent = null;      // previous action event
        this.tapTime = 0;         // time of the most recent tap event
        this.prevTap = null;

        this.startOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.restrictOffset = { left: 0, right: 0, top: 0, bottom: 0 };
        this.snapOffsets = [];

        this.gesture = {
            start: { x: 0, y: 0 },

            startDistance: 0,   // distance between two touches of touchStart
            prevDistance: 0,
            distance: 0,

            scale: 1,           // gesture.distance / gesture.startDistance

            startAngle: 0,      // angle of line joining two touches
            prevAngle: 0       // angle of the previous gesture event
        };

        this.snapStatus = {
            x: 0, y: 0,
            dx: 0, dy: 0,
            realX: 0, realY: 0,
            snappedX: 0, snappedY: 0,
            targets: [],
            locked: false,
            changed: false
        };

        this.restrictStatus = {
            dx: 0, dy: 0,
            restrictedX: 0, restrictedY: 0,
            snap: null,
            restricted: false,
            changed: false
        };

        this.restrictStatus.snap = this.snapStatus;

        this.pointerIsDown = false;
        this.pointerWasMoved = false;
        this.gesturing = false;
        this.dragging = false;
        this.resizing = false;
        this.resizeAxes = 'xy';

        this.mouse = false;

        interactions.push(this);
    }

    Interaction.prototype = {
        getPageXY: function (pointer, xy) { return getPageXY(pointer, xy, this); },
        getClientXY: function (pointer, xy) { return getClientXY(pointer, xy, this); },
        setEventXY: function (target, ptr) { return setEventXY(target, ptr, this); },

        pointerOver: function (pointer, event, eventTarget) {
            if (this.prepared.name || !this.mouse) { return; }

            var curMatches = [],
                curMatchElements = [],
                prevTargetElement = this.element;

            this.addPointer(pointer);

            if (this.target
                && (testIgnore(this.target, this.element, eventTarget)
                    || !testAllow(this.target, this.element, eventTarget))) {
                // if the eventTarget should be ignored or shouldn't be allowed
                // clear the previous target
                this.target = null;
                this.element = null;
                this.matches = [];
                this.matchElements = [];
            }

            var elementInteractable = interactables.get(eventTarget),
                elementAction = (elementInteractable
                    && !testIgnore(elementInteractable, eventTarget, eventTarget)
                    && testAllow(elementInteractable, eventTarget, eventTarget)
                    && validateAction(
                        elementInteractable.getAction(pointer, event, this, eventTarget),
                        elementInteractable));

            if (elementAction && !withinInteractionLimit(elementInteractable, eventTarget, elementAction)) {
                elementAction = null;
            }

            function pushCurMatches(interactable, selector) {
                if (interactable
                    && isElement(eventTarget)
                    && inContext(interactable, eventTarget)
                    && !testIgnore(interactable, eventTarget, eventTarget)
                    && testAllow(interactable, eventTarget, eventTarget)
                    && matchesSelector(eventTarget, selector)) {

                    curMatches.push(interactable);
                    curMatchElements.push(eventTarget);
                }
            }

            if (elementAction) {
                this.target = elementInteractable;
                this.element = eventTarget;
                this.matches = [];
                this.matchElements = [];
            }
            else {
                interactables.forEachSelector(pushCurMatches);

                if (this.validateSelector(pointer, event, curMatches, curMatchElements)) {
                    this.matches = curMatches;
                    this.matchElements = curMatchElements;

                    this.pointerHover(pointer, event, this.matches, this.matchElements);
                    events.add(eventTarget,
                        supportsPointerEvent ? pEventTypes.move : 'mousemove',
                        listeners.pointerHover);
                }
                else if (this.target) {
                    if (nodeContains(prevTargetElement, eventTarget)) {
                        this.pointerHover(pointer, event, this.matches, this.matchElements);
                        events.add(this.element,
                            supportsPointerEvent ? pEventTypes.move : 'mousemove',
                            listeners.pointerHover);
                    }
                    else {
                        this.target = null;
                        this.element = null;
                        this.matches = [];
                        this.matchElements = [];
                    }
                }
            }
        },

        // Check what action would be performed on pointerMove target if a mouse
        // button were pressed and change the cursor accordingly
        pointerHover: function (pointer, event, eventTarget, curEventTarget, matches, matchElements) {
            var target = this.target;

            if (!this.prepared.name && this.mouse) {

                var action;

                // update pointer coords for defaultActionChecker to use
                this.setEventXY(this.curCoords, [pointer]);

                if (matches) {
                    action = this.validateSelector(pointer, event, matches, matchElements);
                }
                else if (target) {
                    action = validateAction(target.getAction(this.pointers[0], event, this, this.element), this.target);
                }

                if (target && target.options.styleCursor) {
                    if (action) {
                        target._doc.documentElement.style.cursor = getActionCursor(action);
                    }
                    else {
                        target._doc.documentElement.style.cursor = '';
                    }
                }
            }
            else if (this.prepared.name) {
                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        pointerOut: function (pointer, event, eventTarget) {
            if (this.prepared.name) { return; }

            // Remove temporary event listeners for selector Interactables
            if (!interactables.get(eventTarget)) {
                events.remove(eventTarget,
                    supportsPointerEvent ? pEventTypes.move : 'mousemove',
                    listeners.pointerHover);
            }

            if (this.target && this.target.options.styleCursor && !this.interacting()) {
                this.target._doc.documentElement.style.cursor = '';
            }
        },

        selectorDown: function (pointer, event, eventTarget, curEventTarget) {
            var that = this,
                // copy event to be used in timeout for IE8
                eventCopy = events.useAttachEvent ? extend({}, event) : event,
                element = eventTarget,
                pointerIndex = this.addPointer(pointer),
                action;

            this.holdTimers[pointerIndex] = setTimeout(function () {
                that.pointerHold(events.useAttachEvent ? eventCopy : pointer, eventCopy, eventTarget, curEventTarget);
            }, defaultOptions._holdDuration);

            this.pointerIsDown = true;

            // Check if the down event hits the current inertia target
            if (this.inertiaStatus.active && this.target.selector) {
                // climb up the DOM tree from the event target
                while (isElement(element)) {

                    // if this element is the current inertia target element
                    if (element === this.element
                        // and the prospective action is the same as the ongoing one
                        && validateAction(this.target.getAction(pointer, event, this, this.element), this.target).name === this.prepared.name) {

                        // stop inertia so that the next move will be a normal one
                        cancelFrame(this.inertiaStatus.i);
                        this.inertiaStatus.active = false;

                        this.collectEventTargets(pointer, event, eventTarget, 'down');
                        return;
                    }
                    element = parentElement(element);
                }
            }

            // do nothing if interacting
            if (this.interacting()) {
                this.collectEventTargets(pointer, event, eventTarget, 'down');
                return;
            }

            function pushMatches(interactable, selector, context) {
                var elements = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, elements)) {

                    that.matches.push(interactable);
                    that.matchElements.push(element);
                }
            }

            // update pointer coords for defaultActionChecker to use
            this.setEventXY(this.curCoords, [pointer]);
            this.downEvent = event;

            while (isElement(element) && !action) {
                this.matches = [];
                this.matchElements = [];

                interactables.forEachSelector(pushMatches);

                action = this.validateSelector(pointer, event, this.matches, this.matchElements);
                element = parentElement(element);
            }

            if (action) {
                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.collectEventTargets(pointer, event, eventTarget, 'down');

                return this.pointerDown(pointer, event, eventTarget, curEventTarget, action);
            }
            else {
                // do these now since pointerDown isn't being called from here
                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.curCoords);
                this.pointerWasMoved = false;
            }

            this.collectEventTargets(pointer, event, eventTarget, 'down');
        },

        // Determine action to be performed on next pointerMove and add appropriate
        // style and event Listeners
        pointerDown: function (pointer, event, eventTarget, curEventTarget, forceAction) {
            if (!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) {
                this.checkAndPreventDefault(event, this.target, this.element);

                return;
            }

            this.pointerIsDown = true;
            this.downEvent = event;

            var pointerIndex = this.addPointer(pointer),
                action;

            // If it is the second touch of a multi-touch gesture, keep the
            // target the same and get a new action if a target was set by the
            // first touch
            if (this.pointerIds.length > 1 && this.target._element === this.element) {
                var newAction = validateAction(forceAction || this.target.getAction(pointer, event, this, this.element), this.target);

                if (withinInteractionLimit(this.target, this.element, newAction)) {
                    action = newAction;
                }

                this.prepared.name = null;
            }
            // Otherwise, set the target if there is no action prepared
            else if (!this.prepared.name) {
                var interactable = interactables.get(curEventTarget);

                if (interactable
                    && !testIgnore(interactable, curEventTarget, eventTarget)
                    && testAllow(interactable, curEventTarget, eventTarget)
                    && (action = validateAction(forceAction || interactable.getAction(pointer, event, this, curEventTarget), interactable, eventTarget))
                    && withinInteractionLimit(interactable, curEventTarget, action)) {
                    this.target = interactable;
                    this.element = curEventTarget;
                }
            }

            var target = this.target,
                options = target && target.options;

            if (target && (forceAction || !this.prepared.name)) {
                action = action || validateAction(forceAction || target.getAction(pointer, event, this, curEventTarget), target, this.element);

                this.setEventXY(this.startCoords, this.pointers);

                if (!action) { return; }

                if (options.styleCursor) {
                    target._doc.documentElement.style.cursor = getActionCursor(action);
                }

                this.resizeAxes = action.name === 'resize' ? action.axis : null;

                if (action === 'gesture' && this.pointerIds.length < 2) {
                    action = null;
                }

                this.prepared.name = action.name;
                this.prepared.axis = action.axis;
                this.prepared.edges = action.edges;

                this.snapStatus.snappedX = this.snapStatus.snappedY =
                    this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;

                this.downTimes[pointerIndex] = new Date().getTime();
                this.downTargets[pointerIndex] = eventTarget;
                pointerExtend(this.downPointer, pointer);

                copyCoords(this.prevCoords, this.startCoords);
                this.pointerWasMoved = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
            // if inertia is active try to resume action
            else if (this.inertiaStatus.active
                && curEventTarget === this.element
                && validateAction(target.getAction(pointer, event, this, this.element), target).name === this.prepared.name) {

                cancelFrame(this.inertiaStatus.i);
                this.inertiaStatus.active = false;

                this.checkAndPreventDefault(event, target, this.element);
            }
        },

        setModifications: function (coords, preEnd) {
            var target = this.target,
                shouldMove = true,
                shouldSnap = checkSnap(target, this.prepared.name) && (!target.options[this.prepared.name].snap.endOnly || preEnd),
                shouldRestrict = checkRestrict(target, this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);

            if (shouldSnap) { this.setSnapping(coords); } else { this.snapStatus.locked = false; }
            if (shouldRestrict) { this.setRestriction(coords); } else { this.restrictStatus.restricted = false; }

            if (shouldSnap && this.snapStatus.locked && !this.snapStatus.changed) {
                shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;
            }
            else if (shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed) {
                shouldMove = false;
            }

            return shouldMove;
        },

        setStartOffsets: function (action, interactable, element) {
            var rect = interactable.getRect(element),
                origin = getOriginXY(interactable, element),
                snap = interactable.options[this.prepared.name].snap,
                restrict = interactable.options[this.prepared.name].restrict,
                width, height;

            if (rect) {
                this.startOffset.left = this.startCoords.page.x - rect.left;
                this.startOffset.top = this.startCoords.page.y - rect.top;

                this.startOffset.right = rect.right - this.startCoords.page.x;
                this.startOffset.bottom = rect.bottom - this.startCoords.page.y;

                if ('width' in rect) { width = rect.width; }
                else { width = rect.right - rect.left; }
                if ('height' in rect) { height = rect.height; }
                else { height = rect.bottom - rect.top; }
            }
            else {
                this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;
            }

            this.snapOffsets.splice(0);

            var snapOffset = snap && snap.offset === 'startCoords'
                ? {
                    x: this.startCoords.page.x - origin.x,
                    y: this.startCoords.page.y - origin.y
                }
                : snap && snap.offset || { x: 0, y: 0 };

            if (rect && snap && snap.relativePoints && snap.relativePoints.length) {
                for (var i = 0; i < snap.relativePoints.length; i++) {
                    this.snapOffsets.push({
                        x: this.startOffset.left - (width * snap.relativePoints[i].x) + snapOffset.x,
                        y: this.startOffset.top - (height * snap.relativePoints[i].y) + snapOffset.y
                    });
                }
            }
            else {
                this.snapOffsets.push(snapOffset);
            }

            if (rect && restrict.elementRect) {
                this.restrictOffset.left = this.startOffset.left - (width * restrict.elementRect.left);
                this.restrictOffset.top = this.startOffset.top - (height * restrict.elementRect.top);

                this.restrictOffset.right = this.startOffset.right - (width * (1 - restrict.elementRect.right));
                this.restrictOffset.bottom = this.startOffset.bottom - (height * (1 - restrict.elementRect.bottom));
            }
            else {
                this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
            }
        },

        /*\
         * Interaction.start
         [ method ]
         *
         * Start an action with the given Interactable and Element as tartgets. The
         * action must be enabled for the target Interactable and an appropriate number
         * of pointers must be held down â€“ 1 for drag/resize, 2 for gesture.
         *
         * Use it with `interactable.<action>able({ manualStart: false })` to always
         * [start actions manually](https://github.com/taye/interact.js/issues/114)
         *
         - action       (object)  The action to be performed - drag, resize, etc.
         - interactable (Interactable) The Interactable to target
         - element      (Element) The DOM Element to target
         = (object) interact
         **
         | interact(target)
         |   .draggable({
         |     // disable the default drag start by down->move
         |     manualStart: true
         |   })
         |   // start dragging after the user holds the pointer down
         |   .on('hold', function (event) {
         |     var interaction = event.interaction;
         |
         |     if (!interaction.interacting()) {
         |       interaction.start({ name: 'drag' },
         |                         event.interactable,
         |                         event.currentTarget);
         |     }
         | });
        \*/
        start: function (action, interactable, element) {
            if (this.interacting()
                || !this.pointerIsDown
                || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) {
                return;
            }

            // if this interaction had been removed after stopping
            // add it back
            if (indexOf(interactions, this) === -1) {
                interactions.push(this);
            }

            // set the startCoords if there was no prepared action
            if (!this.prepared.name) {
                this.setEventXY(this.startCoords, this.pointers);
            }

            this.prepared.name = action.name;
            this.prepared.axis = action.axis;
            this.prepared.edges = action.edges;
            this.target = interactable;
            this.element = element;

            this.setStartOffsets(action.name, interactable, element);
            this.setModifications(this.startCoords.page);

            this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);
        },

        pointerMove: function (pointer, event, eventTarget, curEventTarget, preEnd) {
            if (this.inertiaStatus.active) {
                var pageUp = this.inertiaStatus.upCoords.page;
                var clientUp = this.inertiaStatus.upCoords.client;

                var inertiaPosition = {
                    pageX: pageUp.x + this.inertiaStatus.sx,
                    pageY: pageUp.y + this.inertiaStatus.sy,
                    clientX: clientUp.x + this.inertiaStatus.sx,
                    clientY: clientUp.y + this.inertiaStatus.sy
                };

                this.setEventXY(this.curCoords, [inertiaPosition]);
            }
            else {
                this.recordPointer(pointer);
                this.setEventXY(this.curCoords, this.pointers);
            }

            var duplicateMove = (this.curCoords.page.x === this.prevCoords.page.x
                && this.curCoords.page.y === this.prevCoords.page.y
                && this.curCoords.client.x === this.prevCoords.client.x
                && this.curCoords.client.y === this.prevCoords.client.y);

            var dx, dy,
                pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // register movement greater than pointerMoveTolerance
            if (this.pointerIsDown && !this.pointerWasMoved) {
                dx = this.curCoords.client.x - this.startCoords.client.x;
                dy = this.curCoords.client.y - this.startCoords.client.y;

                this.pointerWasMoved = hypot(dx, dy) > pointerMoveTolerance;
            }

            if (!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)) {
                if (this.pointerIsDown) {
                    clearTimeout(this.holdTimers[pointerIndex]);
                }

                this.collectEventTargets(pointer, event, eventTarget, 'move');
            }

            if (!this.pointerIsDown) { return; }

            if (duplicateMove && this.pointerWasMoved && !preEnd) {
                this.checkAndPreventDefault(event, this.target, this.element);
                return;
            }

            // set pointer coordinate, time changes and speeds
            setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

            if (!this.prepared.name) { return; }

            if (this.pointerWasMoved
                // ignore movement while inertia is active
                && (!this.inertiaStatus.active || (pointer instanceof InteractEvent && /inertiastart/.test(pointer.type)))) {

                // if just starting an action, calculate the pointer speed now
                if (!this.interacting()) {
                    setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

                    // check if a drag is in the correct axis
                    if (this.prepared.name === 'drag') {
                        var absX = Math.abs(dx),
                            absY = Math.abs(dy),
                            targetAxis = this.target.options.drag.axis,
                            axis = (absX > absY ? 'x' : absX < absY ? 'y' : 'xy');

                        // if the movement isn't in the axis of the interactable
                        if (axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis) {
                            // cancel the prepared action
                            this.prepared.name = null;

                            // then try to get a drag from another ineractable

                            var element = eventTarget;

                            // check element interactables
                            while (isElement(element)) {
                                var elementInteractable = interactables.get(element);

                                if (elementInteractable
                                    && elementInteractable !== this.target
                                    && !elementInteractable.options.drag.manualStart
                                    && elementInteractable.getAction(this.downPointer, this.downEvent, this, element).name === 'drag'
                                    && checkAxis(axis, elementInteractable)) {

                                    this.prepared.name = 'drag';
                                    this.target = elementInteractable;
                                    this.element = element;
                                    break;
                                }

                                element = parentElement(element);
                            }

                            // if there's no drag from element interactables,
                            // check the selector interactables
                            if (!this.prepared.name) {
                                var thisInteraction = this;

                                var getDraggable = function (interactable, selector, context) {
                                    var elements = ie8MatchesSelector
                                        ? context.querySelectorAll(selector)
                                        : undefined;

                                    if (interactable === thisInteraction.target) { return; }

                                    if (inContext(interactable, eventTarget)
                                        && !interactable.options.drag.manualStart
                                        && !testIgnore(interactable, element, eventTarget)
                                        && testAllow(interactable, element, eventTarget)
                                        && matchesSelector(element, selector, elements)
                                        && interactable.getAction(thisInteraction.downPointer, thisInteraction.downEvent, thisInteraction, element).name === 'drag'
                                        && checkAxis(axis, interactable)
                                        && withinInteractionLimit(interactable, element, 'drag')) {

                                        return interactable;
                                    }
                                };

                                element = eventTarget;

                                while (isElement(element)) {
                                    var selectorInteractable = interactables.forEachSelector(getDraggable);

                                    if (selectorInteractable) {
                                        this.prepared.name = 'drag';
                                        this.target = selectorInteractable;
                                        this.element = element;
                                        break;
                                    }

                                    element = parentElement(element);
                                }
                            }
                        }
                    }
                }

                var starting = !!this.prepared.name && !this.interacting();

                if (starting
                    && (this.target.options[this.prepared.name].manualStart
                        || !withinInteractionLimit(this.target, this.element, this.prepared))) {
                    this.stop(event);
                    return;
                }

                if (this.prepared.name && this.target) {
                    if (starting) {
                        this.start(this.prepared, this.target, this.element);
                    }

                    var shouldMove = this.setModifications(this.curCoords.page, preEnd);

                    // move if snapping or restriction doesn't prevent it
                    if (shouldMove || starting) {
                        this.prevEvent = this[this.prepared.name + 'Move'](event);
                    }

                    this.checkAndPreventDefault(event, this.target, this.element);
                }
            }

            copyCoords(this.prevCoords, this.curCoords);

            if (this.dragging || this.resizing) {
                this.autoScrollMove(pointer);
            }
        },

        dragStart: function (event) {
            var dragEvent = new InteractEvent(this, event, 'drag', 'start', this.element);

            this.dragging = true;
            this.target.fire(dragEvent);

            // reset active dropzones
            this.activeDrops.dropzones = [];
            this.activeDrops.elements = [];
            this.activeDrops.rects = [];

            if (!this.dynamicDrop) {
                this.setActiveDrops(this.element);
            }

            var dropEvents = this.getDropEvents(event, dragEvent);

            if (dropEvents.activate) {
                this.fireActiveDrops(dropEvents.activate);
            }

            return dragEvent;
        },

        dragMove: function (event) {
            var target = this.target,
                dragEvent = new InteractEvent(this, event, 'drag', 'move', this.element),
                draggableElement = this.element,
                drop = this.getDrop(dragEvent, event, draggableElement);

            this.dropTarget = drop.dropzone;
            this.dropElement = drop.element;

            var dropEvents = this.getDropEvents(event, dragEvent);

            target.fire(dragEvent);

            if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
            if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
            if (dropEvents.move) { this.dropTarget.fire(dropEvents.move); }

            this.prevDropTarget = this.dropTarget;
            this.prevDropElement = this.dropElement;

            return dragEvent;
        },

        resizeStart: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'start', this.element);

            if (this.prepared.edges) {
                var startRect = this.target.getRect(this.element);

                /*
                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
                 * on the active edges and the edge being interacted with.
                 */
                if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
                    var linkedEdges = extend({}, this.prepared.edges);

                    linkedEdges.top = linkedEdges.top || (linkedEdges.left && !linkedEdges.bottom);
                    linkedEdges.left = linkedEdges.left || (linkedEdges.top && !linkedEdges.right);
                    linkedEdges.bottom = linkedEdges.bottom || (linkedEdges.right && !linkedEdges.top);
                    linkedEdges.right = linkedEdges.right || (linkedEdges.bottom && !linkedEdges.left);

                    this.prepared._linkedEdges = linkedEdges;
                }
                else {
                    this.prepared._linkedEdges = null;
                }

                // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
                if (this.target.options.resize.preserveAspectRatio) {
                    this.resizeStartAspectRatio = startRect.width / startRect.height;
                }

                this.resizeRects = {
                    start: startRect,
                    current: extend({}, startRect),
                    restricted: extend({}, startRect),
                    previous: extend({}, startRect),
                    delta: {
                        left: 0, right: 0, width: 0,
                        top: 0, bottom: 0, height: 0
                    }
                };

                resizeEvent.rect = this.resizeRects.restricted;
                resizeEvent.deltaRect = this.resizeRects.delta;
            }

            this.target.fire(resizeEvent);

            this.resizing = true;

            return resizeEvent;
        },

        resizeMove: function (event) {
            var resizeEvent = new InteractEvent(this, event, 'resize', 'move', this.element);

            var edges = this.prepared.edges,
                invert = this.target.options.resize.invert,
                invertible = invert === 'reposition' || invert === 'negate';

            if (edges) {
                var dx = resizeEvent.dx,
                    dy = resizeEvent.dy,

                    start = this.resizeRects.start,
                    current = this.resizeRects.current,
                    restricted = this.resizeRects.restricted,
                    delta = this.resizeRects.delta,
                    previous = extend(this.resizeRects.previous, restricted),

                    originalEdges = edges;

                // `resize.preserveAspectRatio` takes precedence over `resize.square`
                if (this.target.options.resize.preserveAspectRatio) {
                    var resizeStartAspectRatio = this.resizeStartAspectRatio;

                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx / resizeStartAspectRatio;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx / resizeStartAspectRatio; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy * resizeStartAspectRatio; }
                }
                else if (this.target.options.resize.square) {
                    edges = this.prepared._linkedEdges;

                    if ((originalEdges.left && originalEdges.bottom)
                        || (originalEdges.right && originalEdges.top)) {
                        dy = -dx;
                    }
                    else if (originalEdges.left || originalEdges.right) { dy = dx; }
                    else if (originalEdges.top || originalEdges.bottom) { dx = dy; }
                }

                // update the 'current' rect without modifications
                if (edges.top) { current.top += dy; }
                if (edges.bottom) { current.bottom += dy; }
                if (edges.left) { current.left += dx; }
                if (edges.right) { current.right += dx; }

                if (invertible) {
                    // if invertible, copy the current rect
                    extend(restricted, current);

                    if (invert === 'reposition') {
                        // swap edge values if necessary to keep width/height positive
                        var swap;

                        if (restricted.top > restricted.bottom) {
                            swap = restricted.top;

                            restricted.top = restricted.bottom;
                            restricted.bottom = swap;
                        }
                        if (restricted.left > restricted.right) {
                            swap = restricted.left;

                            restricted.left = restricted.right;
                            restricted.right = swap;
                        }
                    }
                }
                else {
                    // if not invertible, restrict to minimum of 0x0 rect
                    restricted.top = Math.min(current.top, start.bottom);
                    restricted.bottom = Math.max(current.bottom, start.top);
                    restricted.left = Math.min(current.left, start.right);
                    restricted.right = Math.max(current.right, start.left);
                }

                restricted.width = restricted.right - restricted.left;
                restricted.height = restricted.bottom - restricted.top;

                for (var edge in restricted) {
                    delta[edge] = restricted[edge] - previous[edge];
                }

                resizeEvent.edges = this.prepared.edges;
                resizeEvent.rect = restricted;
                resizeEvent.deltaRect = delta;
            }

            this.target.fire(resizeEvent);

            return resizeEvent;
        },

        gestureStart: function (event) {
            var gestureEvent = new InteractEvent(this, event, 'gesture', 'start', this.element);

            gestureEvent.ds = 0;

            this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;
            this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.scale = 1;

            this.gesturing = true;

            this.target.fire(gestureEvent);

            return gestureEvent;
        },

        gestureMove: function (event) {
            if (!this.pointerIds.length) {
                return this.prevEvent;
            }

            var gestureEvent;

            gestureEvent = new InteractEvent(this, event, 'gesture', 'move', this.element);
            gestureEvent.ds = gestureEvent.scale - this.gesture.scale;

            this.target.fire(gestureEvent);

            this.gesture.prevAngle = gestureEvent.angle;
            this.gesture.prevDistance = gestureEvent.distance;

            if (gestureEvent.scale !== Infinity &&
                gestureEvent.scale !== null &&
                gestureEvent.scale !== undefined &&
                !isNaN(gestureEvent.scale)) {

                this.gesture.scale = gestureEvent.scale;
            }

            return gestureEvent;
        },

        pointerHold: function (pointer, event, eventTarget) {
            this.collectEventTargets(pointer, event, eventTarget, 'hold');
        },

        pointerUp: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'up');
            this.collectEventTargets(pointer, event, eventTarget, 'tap');

            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        pointerCancel: function (pointer, event, eventTarget, curEventTarget) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            clearTimeout(this.holdTimers[pointerIndex]);

            this.collectEventTargets(pointer, event, eventTarget, 'cancel');
            this.pointerEnd(pointer, event, eventTarget, curEventTarget);

            this.removePointer(pointer);
        },

        // https://www.quirksmode.org/dom/events/click.html
        // >Events leading to dblclick
        //
        // IE8 doesn't fire down event before dblclick.
        // This workaround tries to fire a tap and doubletap after dblclick
        ie8Dblclick: function (pointer, event, eventTarget) {
            if (this.prevTap
                && event.clientX === this.prevTap.clientX
                && event.clientY === this.prevTap.clientY
                && eventTarget === this.prevTap.target) {

                this.downTargets[0] = eventTarget;
                this.downTimes[0] = new Date().getTime();
                this.collectEventTargets(pointer, event, eventTarget, 'tap');
            }
        },

        // End interact move events and stop auto-scroll unless inertia is enabled
        pointerEnd: function (pointer, event, eventTarget, curEventTarget) {
            var endEvent,
                target = this.target,
                options = target && target.options,
                inertiaOptions = options && this.prepared.name && options[this.prepared.name].inertia,
                inertiaStatus = this.inertiaStatus;

            if (this.interacting()) {

                if (inertiaStatus.active && !inertiaStatus.ending) { return; }

                var pointerSpeed,
                    now = new Date().getTime(),
                    inertiaPossible = false,
                    inertia = false,
                    smoothEnd = false,
                    endSnap = checkSnap(target, this.prepared.name) && options[this.prepared.name].snap.endOnly,
                    endRestrict = checkRestrict(target, this.prepared.name) && options[this.prepared.name].restrict.endOnly,
                    dx = 0,
                    dy = 0,
                    startEvent;

                if (this.dragging) {
                    if (options.drag.axis === 'x') { pointerSpeed = Math.abs(this.pointerDelta.client.vx); }
                    else if (options.drag.axis === 'y') { pointerSpeed = Math.abs(this.pointerDelta.client.vy); }
                    else   /*options.drag.axis === 'xy'*/ { pointerSpeed = this.pointerDelta.client.speed; }
                }
                else {
                    pointerSpeed = this.pointerDelta.client.speed;
                }

                // check if inertia should be started
                inertiaPossible = (inertiaOptions && inertiaOptions.enabled
                    && this.prepared.name !== 'gesture'
                    && event !== inertiaStatus.startEvent);

                inertia = (inertiaPossible
                    && (now - this.curCoords.timeStamp) < 50
                    && pointerSpeed > inertiaOptions.minSpeed
                    && pointerSpeed > inertiaOptions.endSpeed);

                if (inertiaPossible && !inertia && (endSnap || endRestrict)) {

                    var snapRestrict = {};

                    snapRestrict.snap = snapRestrict.restrict = snapRestrict;

                    if (endSnap) {
                        this.setSnapping(this.curCoords.page, snapRestrict);
                        if (snapRestrict.locked) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (endRestrict) {
                        this.setRestriction(this.curCoords.page, snapRestrict);
                        if (snapRestrict.restricted) {
                            dx += snapRestrict.dx;
                            dy += snapRestrict.dy;
                        }
                    }

                    if (dx || dy) {
                        smoothEnd = true;
                    }
                }

                if (inertia || smoothEnd) {
                    copyCoords(inertiaStatus.upCoords, this.curCoords);

                    this.pointers[0] = inertiaStatus.startEvent = startEvent =
                        new InteractEvent(this, event, this.prepared.name, 'inertiastart', this.element);

                    inertiaStatus.t0 = now;

                    target.fire(inertiaStatus.startEvent);

                    if (inertia) {
                        inertiaStatus.vx0 = this.pointerDelta.client.vx;
                        inertiaStatus.vy0 = this.pointerDelta.client.vy;
                        inertiaStatus.v0 = pointerSpeed;

                        this.calcInertia(inertiaStatus);

                        var page = extend({}, this.curCoords.page),
                            origin = getOriginXY(target, this.element),
                            statusObject;

                        page.x = page.x + inertiaStatus.xe - origin.x;
                        page.y = page.y + inertiaStatus.ye - origin.y;

                        statusObject = {
                            useStatusXY: true,
                            x: page.x,
                            y: page.y,
                            dx: 0,
                            dy: 0,
                            snap: null
                        };

                        statusObject.snap = statusObject;

                        dx = dy = 0;

                        if (endSnap) {
                            var snap = this.setSnapping(this.curCoords.page, statusObject);

                            if (snap.locked) {
                                dx += snap.dx;
                                dy += snap.dy;
                            }
                        }

                        if (endRestrict) {
                            var restrict = this.setRestriction(this.curCoords.page, statusObject);

                            if (restrict.restricted) {
                                dx += restrict.dx;
                                dy += restrict.dy;
                            }
                        }

                        inertiaStatus.modifiedXe += dx;
                        inertiaStatus.modifiedYe += dy;

                        inertiaStatus.i = reqFrame(this.boundInertiaFrame);
                    }
                    else {
                        inertiaStatus.smoothEnd = true;
                        inertiaStatus.xe = dx;
                        inertiaStatus.ye = dy;

                        inertiaStatus.sx = inertiaStatus.sy = 0;

                        inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
                    }

                    inertiaStatus.active = true;
                    return;
                }

                if (endSnap || endRestrict) {
                    // fire a move event at the snapped coordinates
                    this.pointerMove(pointer, event, eventTarget, curEventTarget, true);
                }
            }

            if (this.dragging) {
                endEvent = new InteractEvent(this, event, 'drag', 'end', this.element);

                var draggableElement = this.element,
                    drop = this.getDrop(endEvent, event, draggableElement);

                this.dropTarget = drop.dropzone;
                this.dropElement = drop.element;

                var dropEvents = this.getDropEvents(event, endEvent);

                if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
                if (dropEvents.enter) { this.dropTarget.fire(dropEvents.enter); }
                if (dropEvents.drop) { this.dropTarget.fire(dropEvents.drop); }
                if (dropEvents.deactivate) {
                    this.fireActiveDrops(dropEvents.deactivate);
                }

                target.fire(endEvent);
            }
            else if (this.resizing) {
                endEvent = new InteractEvent(this, event, 'resize', 'end', this.element);
                target.fire(endEvent);
            }
            else if (this.gesturing) {
                endEvent = new InteractEvent(this, event, 'gesture', 'end', this.element);
                target.fire(endEvent);
            }

            this.stop(event);
        },

        collectDrops: function (element) {
            var drops = [],
                elements = [],
                i;

            element = element || this.element;

            // collect all dropzones and their elements which qualify for a drop
            for (i = 0; i < interactables.length; i++) {
                if (!interactables[i].options.drop.enabled) { continue; }

                var current = interactables[i],
                    accept = current.options.drop.accept;

                // test the draggable element against the dropzone's accept setting
                if ((isElement(accept) && accept !== element)
                    || (isString(accept)
                        && !matchesSelector(element, accept))) {

                    continue;
                }

                // query for new elements if necessary
                var dropElements = current.selector ? current._context.querySelectorAll(current.selector) : [current._element];

                for (var j = 0, len = dropElements.length; j < len; j++) {
                    var currentElement = dropElements[j];

                    if (currentElement === element) {
                        continue;
                    }

                    drops.push(current);
                    elements.push(currentElement);
                }
            }

            return {
                dropzones: drops,
                elements: elements
            };
        },

        fireActiveDrops: function (event) {
            var i,
                current,
                currentElement,
                prevElement;

            // loop through all active dropzones and trigger event
            for (i = 0; i < this.activeDrops.dropzones.length; i++) {
                current = this.activeDrops.dropzones[i];
                currentElement = this.activeDrops.elements[i];

                // prevent trigger of duplicate events on same element
                if (currentElement !== prevElement) {
                    // set current element as event target
                    event.target = currentElement;
                    current.fire(event);
                }
                prevElement = currentElement;
            }
        },

        // Collect a new set of possible drops and save them in activeDrops.
        // setActiveDrops should always be called when a drag has just started or a
        // drag event happens while dynamicDrop is true
        setActiveDrops: function (dragElement) {
            // get dropzones and their elements that could receive the draggable
            var possibleDrops = this.collectDrops(dragElement, true);

            this.activeDrops.dropzones = possibleDrops.dropzones;
            this.activeDrops.elements = possibleDrops.elements;
            this.activeDrops.rects = [];

            for (var i = 0; i < this.activeDrops.dropzones.length; i++) {
                this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);
            }
        },

        getDrop: function (dragEvent, event, dragElement) {
            var validDrops = [];

            if (dynamicDrop) {
                this.setActiveDrops(dragElement);
            }

            // collect all dropzones and their elements which qualify for a drop
            for (var j = 0; j < this.activeDrops.dropzones.length; j++) {
                var current = this.activeDrops.dropzones[j],
                    currentElement = this.activeDrops.elements[j],
                    rect = this.activeDrops.rects[j];

                validDrops.push(current.dropCheck(dragEvent, event, this.target, dragElement, currentElement, rect)
                    ? currentElement
                    : null);
            }

            // get the most appropriate dropzone based on DOM depth and order
            var dropIndex = indexOfDeepestElement(validDrops),
                dropzone = this.activeDrops.dropzones[dropIndex] || null,
                element = this.activeDrops.elements[dropIndex] || null;

            return {
                dropzone: dropzone,
                element: element
            };
        },

        getDropEvents: function (pointerEvent, dragEvent) {
            var dropEvents = {
                enter: null,
                leave: null,
                activate: null,
                deactivate: null,
                move: null,
                drop: null
            };

            if (this.dropElement !== this.prevDropElement) {
                // if there was a prevDropTarget, create a dragleave event
                if (this.prevDropTarget) {
                    dropEvents.leave = {
                        target: this.prevDropElement,
                        dropzone: this.prevDropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragleave'
                    };

                    dragEvent.dragLeave = this.prevDropElement;
                    dragEvent.prevDropzone = this.prevDropTarget;
                }
                // if the dropTarget is not null, create a dragenter event
                if (this.dropTarget) {
                    dropEvents.enter = {
                        target: this.dropElement,
                        dropzone: this.dropTarget,
                        relatedTarget: dragEvent.target,
                        draggable: dragEvent.interactable,
                        dragEvent: dragEvent,
                        interaction: this,
                        timeStamp: dragEvent.timeStamp,
                        type: 'dragenter'
                    };

                    dragEvent.dragEnter = this.dropElement;
                    dragEvent.dropzone = this.dropTarget;
                }
            }

            if (dragEvent.type === 'dragend' && this.dropTarget) {
                dropEvents.drop = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'drop'
                };

                dragEvent.dropzone = this.dropTarget;
            }
            if (dragEvent.type === 'dragstart') {
                dropEvents.activate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropactivate'
                };
            }
            if (dragEvent.type === 'dragend') {
                dropEvents.deactivate = {
                    target: null,
                    dropzone: null,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropdeactivate'
                };
            }
            if (dragEvent.type === 'dragmove' && this.dropTarget) {
                dropEvents.move = {
                    target: this.dropElement,
                    dropzone: this.dropTarget,
                    relatedTarget: dragEvent.target,
                    draggable: dragEvent.interactable,
                    dragEvent: dragEvent,
                    interaction: this,
                    dragmove: dragEvent,
                    timeStamp: dragEvent.timeStamp,
                    type: 'dropmove'
                };
                dragEvent.dropzone = this.dropTarget;
            }

            return dropEvents;
        },

        currentAction: function () {
            return (this.dragging && 'drag') || (this.resizing && 'resize') || (this.gesturing && 'gesture') || null;
        },

        interacting: function () {
            return this.dragging || this.resizing || this.gesturing;
        },

        clearTargets: function () {
            this.target = this.element = null;

            this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
        },

        stop: function (event) {
            if (this.interacting()) {
                autoScroll.stop();
                this.matches = [];
                this.matchElements = [];

                var target = this.target;

                if (target.options.styleCursor) {
                    target._doc.documentElement.style.cursor = '';
                }

                // prevent Default only if were previously interacting
                if (event && isFunction(event.preventDefault)) {
                    this.checkAndPreventDefault(event, target, this.element);
                }

                if (this.dragging) {
                    this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;
                }
            }

            this.clearTargets();

            this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;
            this.prepared.name = this.prevEvent = null;
            this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;

            // remove pointers if their ID isn't in this.pointerIds
            for (var i = 0; i < this.pointers.length; i++) {
                if (indexOf(this.pointerIds, getPointerId(this.pointers[i])) === -1) {
                    this.pointers.splice(i, 1);
                }
            }
        },

        inertiaFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                options = this.target.options[this.prepared.name].inertia,
                lambda = options.resistance,
                t = new Date().getTime() / 1000 - inertiaStatus.t0;

            if (t < inertiaStatus.te) {

                var progress = 1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;

                if (inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye) {
                    inertiaStatus.sx = inertiaStatus.xe * progress;
                    inertiaStatus.sy = inertiaStatus.ye * progress;
                }
                else {
                    var quadPoint = getQuadraticCurvePoint(
                        0, 0,
                        inertiaStatus.xe, inertiaStatus.ye,
                        inertiaStatus.modifiedXe, inertiaStatus.modifiedYe,
                        progress);

                    inertiaStatus.sx = quadPoint.x;
                    inertiaStatus.sy = quadPoint.y;
                }

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundInertiaFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.modifiedXe;
                inertiaStatus.sy = inertiaStatus.modifiedYe;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        smoothEndFrame: function () {
            var inertiaStatus = this.inertiaStatus,
                t = new Date().getTime() - inertiaStatus.t0,
                duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;

            if (t < duration) {
                inertiaStatus.sx = easeOutQuad(t, 0, inertiaStatus.xe, duration);
                inertiaStatus.sy = easeOutQuad(t, 0, inertiaStatus.ye, duration);

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
            }
            else {
                inertiaStatus.ending = true;

                inertiaStatus.sx = inertiaStatus.xe;
                inertiaStatus.sy = inertiaStatus.ye;

                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);

                inertiaStatus.smoothEnd =
                    inertiaStatus.active = inertiaStatus.ending = false;
            }
        },

        addPointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) {
                index = this.pointerIds.length;
            }

            this.pointerIds[index] = id;
            this.pointers[index] = pointer;

            return index;
        },

        removePointer: function (pointer) {
            var id = getPointerId(pointer),
                index = this.mouse ? 0 : indexOf(this.pointerIds, id);

            if (index === -1) { return; }

            this.pointers.splice(index, 1);
            this.pointerIds.splice(index, 1);
            this.downTargets.splice(index, 1);
            this.downTimes.splice(index, 1);
            this.holdTimers.splice(index, 1);
        },

        recordPointer: function (pointer) {
            var index = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            if (index === -1) { return; }

            this.pointers[index] = pointer;
        },

        collectEventTargets: function (pointer, event, eventTarget, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer));

            // do not fire a tap event if the pointer was moved before being lifted
            if (eventType === 'tap' && (this.pointerWasMoved
                // or if the pointerup target is different to the pointerdown target
                || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))) {
                return;
            }

            var targets = [],
                elements = [],
                element = eventTarget;

            function collectSelectors(interactable, selector, context) {
                var els = ie8MatchesSelector
                    ? context.querySelectorAll(selector)
                    : undefined;

                if (interactable._iEvents[eventType]
                    && isElement(element)
                    && inContext(interactable, element)
                    && !testIgnore(interactable, element, eventTarget)
                    && testAllow(interactable, element, eventTarget)
                    && matchesSelector(element, selector, els)) {

                    targets.push(interactable);
                    elements.push(element);
                }
            }

            while (element) {
                if (interact.isSet(element) && interact(element)._iEvents[eventType]) {
                    targets.push(interact(element));
                    elements.push(element);
                }

                interactables.forEachSelector(collectSelectors);

                element = parentElement(element);
            }

            // create the tap event even if there are no listeners so that
            // doubletap can still be created and fired
            if (targets.length || eventType === 'tap') {
                this.firePointers(pointer, event, eventTarget, targets, elements, eventType);
            }
        },

        firePointers: function (pointer, event, eventTarget, targets, elements, eventType) {
            var pointerIndex = this.mouse ? 0 : indexOf(this.pointerIds, getPointerId(pointer)),
                pointerEvent = {},
                i,
                // for tap events
                interval, createNewDoubleTap;

            // if it's a doubletap then the event properties would have been
            // copied from the tap event and provided as the pointer argument
            if (eventType === 'doubletap') {
                pointerEvent = pointer;
            }
            else {
                pointerExtend(pointerEvent, event);
                if (event !== pointer) {
                    pointerExtend(pointerEvent, pointer);
                }

                pointerEvent.preventDefault = preventOriginalDefault;
                pointerEvent.stopPropagation = InteractEvent.prototype.stopPropagation;
                pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;
                pointerEvent.interaction = this;

                pointerEvent.timeStamp = new Date().getTime();
                pointerEvent.originalEvent = event;
                pointerEvent.originalPointer = pointer;
                pointerEvent.type = eventType;
                pointerEvent.pointerId = getPointerId(pointer);
                pointerEvent.pointerType = this.mouse ? 'mouse' : !supportsPointerEvent ? 'touch'
                    : isString(pointer.pointerType)
                        ? pointer.pointerType
                        : [, , 'touch', 'pen', 'mouse'][pointer.pointerType];
            }

            if (eventType === 'tap') {
                pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];

                interval = pointerEvent.timeStamp - this.tapTime;
                createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap'
                    && this.prevTap.target === pointerEvent.target
                    && interval < 500);

                pointerEvent.double = createNewDoubleTap;

                this.tapTime = pointerEvent.timeStamp;
            }

            for (i = 0; i < targets.length; i++) {
                pointerEvent.currentTarget = elements[i];
                pointerEvent.interactable = targets[i];
                targets[i].fire(pointerEvent);

                if (pointerEvent.immediatePropagationStopped
                    || (pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget)) {
                    break;
                }
            }

            if (createNewDoubleTap) {
                var doubleTap = {};

                extend(doubleTap, pointerEvent);

                doubleTap.dt = interval;
                doubleTap.type = 'doubletap';

                this.collectEventTargets(doubleTap, event, eventTarget, 'doubletap');

                this.prevTap = doubleTap;
            }
            else if (eventType === 'tap') {
                this.prevTap = pointerEvent;
            }
        },

        validateSelector: function (pointer, event, matches, matchElements) {
            for (var i = 0, len = matches.length; i < len; i++) {
                var match = matches[i],
                    matchElement = matchElements[i],
                    action = validateAction(match.getAction(pointer, event, this, matchElement), match);

                if (action && withinInteractionLimit(match, matchElement, action)) {
                    this.target = match;
                    this.element = matchElement;

                    return action;
                }
            }
        },

        setSnapping: function (pageCoords, status) {
            var snap = this.target.options[this.prepared.name].snap,
                targets = [],
                target,
                page,
                i;

            status = status || this.snapStatus;

            if (status.useStatusXY) {
                page = { x: status.x, y: status.y };
            }
            else {
                var origin = getOriginXY(this.target, this.element);

                page = extend({}, pageCoords);

                page.x -= origin.x;
                page.y -= origin.y;
            }

            status.realX = page.x;
            status.realY = page.y;

            page.x = page.x - this.inertiaStatus.resumeDx;
            page.y = page.y - this.inertiaStatus.resumeDy;

            var len = snap.targets ? snap.targets.length : 0;

            for (var relIndex = 0; relIndex < this.snapOffsets.length; relIndex++) {
                var relative = {
                    x: page.x - this.snapOffsets[relIndex].x,
                    y: page.y - this.snapOffsets[relIndex].y
                };

                for (i = 0; i < len; i++) {
                    if (isFunction(snap.targets[i])) {
                        target = snap.targets[i](relative.x, relative.y, this);
                    }
                    else {
                        target = snap.targets[i];
                    }

                    if (!target) { continue; }

                    targets.push({
                        x: isNumber(target.x) ? (target.x + this.snapOffsets[relIndex].x) : relative.x,
                        y: isNumber(target.y) ? (target.y + this.snapOffsets[relIndex].y) : relative.y,

                        range: isNumber(target.range) ? target.range : snap.range
                    });
                }
            }

            var closest = {
                target: null,
                inRange: false,
                distance: 0,
                range: 0,
                dx: 0,
                dy: 0
            };

            for (i = 0, len = targets.length; i < len; i++) {
                target = targets[i];

                var range = target.range,
                    dx = target.x - page.x,
                    dy = target.y - page.y,
                    distance = hypot(dx, dy),
                    inRange = distance <= range;

                // Infinite targets count as being out of range
                // compared to non infinite ones that are in range
                if (range === Infinity && closest.inRange && closest.range !== Infinity) {
                    inRange = false;
                }

                if (!closest.target || (inRange
                    // is the closest target in range?
                    ? (closest.inRange && range !== Infinity
                        // the pointer is relatively deeper in this target
                        ? distance / range < closest.distance / closest.range
                        // this target has Infinite range and the closest doesn't
                        : (range === Infinity && closest.range !== Infinity)
                        // OR this target is closer that the previous closest
                        || distance < closest.distance)
                    // The other is not in range and the pointer is closer to this target
                    : (!closest.inRange && distance < closest.distance))) {

                    if (range === Infinity) {
                        inRange = true;
                    }

                    closest.target = target;
                    closest.distance = distance;
                    closest.range = range;
                    closest.inRange = inRange;
                    closest.dx = dx;
                    closest.dy = dy;

                    status.range = range;
                }
            }

            var snapChanged;

            if (closest.target) {
                snapChanged = (status.snappedX !== closest.target.x || status.snappedY !== closest.target.y);

                status.snappedX = closest.target.x;
                status.snappedY = closest.target.y;
            }
            else {
                snapChanged = true;

                status.snappedX = NaN;
                status.snappedY = NaN;
            }

            status.dx = closest.dx;
            status.dy = closest.dy;

            status.changed = (snapChanged || (closest.inRange && !status.locked));
            status.locked = closest.inRange;

            return status;
        },

        setRestriction: function (pageCoords, status) {
            var target = this.target,
                restrict = target && target.options[this.prepared.name].restrict,
                restriction = restrict && restrict.restriction,
                page;

            if (!restriction) {
                return status;
            }

            status = status || this.restrictStatus;

            page = status.useStatusXY
                ? page = { x: status.x, y: status.y }
                : page = extend({}, pageCoords);

            if (status.snap && status.snap.locked) {
                page.x += status.snap.dx || 0;
                page.y += status.snap.dy || 0;
            }

            page.x -= this.inertiaStatus.resumeDx;
            page.y -= this.inertiaStatus.resumeDy;

            status.dx = 0;
            status.dy = 0;
            status.restricted = false;

            var rect, restrictedX, restrictedY;

            if (isString(restriction)) {
                if (restriction === 'parent') {
                    restriction = parentElement(this.element);
                }
                else if (restriction === 'self') {
                    restriction = target.getRect(this.element);
                }
                else {
                    restriction = closest(this.element, restriction);
                }

                if (!restriction) { return status; }
            }

            if (isFunction(restriction)) {
                restriction = restriction(page.x, page.y, this.element);
            }

            if (isElement(restriction)) {
                restriction = getElementRect(restriction);
            }

            rect = restriction;

            if (!restriction) {
                restrictedX = page.x;
                restrictedY = page.y;
            }
            // object is assumed to have
            // x, y, width, height or
            // left, top, right, bottom
            else if ('x' in restriction && 'y' in restriction) {
                restrictedX = Math.max(Math.min(rect.x + rect.width - this.restrictOffset.right, page.x), rect.x + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom, page.y), rect.y + this.restrictOffset.top);
            }
            else {
                restrictedX = Math.max(Math.min(rect.right - this.restrictOffset.right, page.x), rect.left + this.restrictOffset.left);
                restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom, page.y), rect.top + this.restrictOffset.top);
            }

            status.dx = restrictedX - page.x;
            status.dy = restrictedY - page.y;

            status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;
            status.restricted = !!(status.dx || status.dy);

            status.restrictedX = restrictedX;
            status.restrictedY = restrictedY;

            return status;
        },

        checkAndPreventDefault: function (event, interactable, element) {
            if (!(interactable = interactable || this.target)) { return; }

            var options = interactable.options,
                prevent = options.preventDefault;

            if (prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)) {
                // do not preventDefault on pointerdown if the prepared action is a drag
                // and dragging can only start from a certain direction - this allows
                // a touch to pan the viewport if a drag isn't in the right direction
                if (/down|start/i.test(event.type)
                    && this.prepared.name === 'drag' && options.drag.axis !== 'xy') {

                    return;
                }

                // with manualStart, only preventDefault while interacting
                if (options[this.prepared.name] && options[this.prepared.name].manualStart
                    && !this.interacting()) {
                    return;
                }

                event.preventDefault();
                return;
            }

            if (prevent === 'always') {
                event.preventDefault();
                return;
            }
        },

        calcInertia: function (status) {
            var inertiaOptions = this.target.options[this.prepared.name].inertia,
                lambda = inertiaOptions.resistance,
                inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;

            status.x0 = this.prevEvent.pageX;
            status.y0 = this.prevEvent.pageY;
            status.t0 = status.startEvent.timeStamp / 1000;
            status.sx = status.sy = 0;

            status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
            status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
            status.te = inertiaDur;

            status.lambda_v0 = lambda / status.v0;
            status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
        },

        autoScrollMove: function (pointer) {
            if (!(this.interacting()
                && checkAutoScroll(this.target, this.prepared.name))) {
                return;
            }

            if (this.inertiaStatus.active) {
                autoScroll.x = autoScroll.y = 0;
                return;
            }

            var top,
                right,
                bottom,
                left,
                options = this.target.options[this.prepared.name].autoScroll,
                container = options.container || getWindow(this.element);

            if (isWindow(container)) {
                left = pointer.clientX < autoScroll.margin;
                top = pointer.clientY < autoScroll.margin;
                right = pointer.clientX > container.innerWidth - autoScroll.margin;
                bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
            }
            else {
                var rect = getElementClientRect(container);

                left = pointer.clientX < rect.left + autoScroll.margin;
                top = pointer.clientY < rect.top + autoScroll.margin;
                right = pointer.clientX > rect.right - autoScroll.margin;
                bottom = pointer.clientY > rect.bottom - autoScroll.margin;
            }

            autoScroll.x = (right ? 1 : left ? -1 : 0);
            autoScroll.y = (bottom ? 1 : top ? -1 : 0);

            if (!autoScroll.isScrolling) {
                // set the autoScroll properties to those of the target
                autoScroll.margin = options.margin;
                autoScroll.speed = options.speed;

                autoScroll.start(this);
            }
        },

        _updateEventTargets: function (target, currentTarget) {
            this._eventTarget = target;
            this._curEventTarget = currentTarget;
        }

    };

    function getInteractionFromPointer(pointer, eventType, eventTarget) {
        var i = 0, len = interactions.length,
            mouseEvent = (/mouse/i.test(pointer.pointerType || eventType)
                // MSPointerEvent.MSPOINTER_TYPE_MOUSE
                || pointer.pointerType === 4),
            interaction;

        var id = getPointerId(pointer);

        // try to resume inertia with a new pointer
        if (/down|start/i.test(eventType)) {
            for (i = 0; i < len; i++) {
                interaction = interactions[i];

                var element = eventTarget;

                if (interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume
                    && (interaction.mouse === mouseEvent)) {
                    while (element) {
                        // if the element is the interaction element
                        if (element === interaction.element) {
                            return interaction;
                        }
                        element = parentElement(element);
                    }
                }
            }
        }

        // if it's a mouse interaction
        if (mouseEvent || !(supportsTouch || supportsPointerEvent)) {

            // find a mouse interaction that's not in inertia phase
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !interactions[i].inertiaStatus.active) {
                    return interactions[i];
                }
            }

            // find any interaction specifically for mouse.
            // if the eventType is a mousedown, and inertia is active
            // ignore the interaction
            for (i = 0; i < len; i++) {
                if (interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)) {
                    return interaction;
                }
            }

            // create a new interaction for mouse
            interaction = new Interaction();
            interaction.mouse = true;

            return interaction;
        }

        // get interaction that has this pointer
        for (i = 0; i < len; i++) {
            if (contains(interactions[i].pointerIds, id)) {
                return interactions[i];
            }
        }

        // at this stage, a pointerUp should not return an interaction
        if (/up|end|out/i.test(eventType)) {
            return null;
        }

        // get first idle interaction
        for (i = 0; i < len; i++) {
            interaction = interactions[i];

            if ((!interaction.prepared.name || (interaction.target.options.gesture.enabled))
                && !interaction.interacting()
                && !(!mouseEvent && interaction.mouse)) {

                return interaction;
            }
        }

        return new Interaction();
    }

    function doOnInteractions(method) {
        return (function (event) {
            var interaction,
                eventTarget = getActualElement(event.path
                    ? event.path[0]
                    : event.target),
                curEventTarget = getActualElement(event.currentTarget),
                i;

            if (supportsTouch && /touch/.test(event.type)) {
                prevTouchTime = new Date().getTime();

                for (i = 0; i < event.changedTouches.length; i++) {
                    var pointer = event.changedTouches[i];

                    interaction = getInteractionFromPointer(pointer, event.type, eventTarget);

                    if (!interaction) { continue; }

                    interaction._updateEventTargets(eventTarget, curEventTarget);

                    interaction[method](pointer, event, eventTarget, curEventTarget);
                }
            }
            else {
                if (!supportsPointerEvent && /mouse/.test(event.type)) {
                    // ignore mouse events while touch interactions are active
                    for (i = 0; i < interactions.length; i++) {
                        if (!interactions[i].mouse && interactions[i].pointerIsDown) {
                            return;
                        }
                    }

                    // try to ignore mouse events that are simulated by the browser
                    // after a touch event
                    if (new Date().getTime() - prevTouchTime < 500) {
                        return;
                    }
                }

                interaction = getInteractionFromPointer(event, event.type, eventTarget);

                if (!interaction) { return; }

                interaction._updateEventTargets(eventTarget, curEventTarget);

                interaction[method](event, event, eventTarget, curEventTarget);
            }
        });
    }

    function InteractEvent(interaction, event, action, phase, element, related) {
        var client,
            page,
            target = interaction.target,
            snapStatus = interaction.snapStatus,
            restrictStatus = interaction.restrictStatus,
            pointers = interaction.pointers,
            deltaSource = (target && target.options || defaultOptions).deltaSource,
            sourceX = deltaSource + 'X',
            sourceY = deltaSource + 'Y',
            options = target ? target.options : defaultOptions,
            origin = getOriginXY(target, element),
            starting = phase === 'start',
            ending = phase === 'end',
            coords = starting ? interaction.startCoords : interaction.curCoords;

        element = element || interaction.element;

        page = extend({}, coords.page);
        client = extend({}, coords.client);

        page.x -= origin.x;
        page.y -= origin.y;

        client.x -= origin.x;
        client.y -= origin.y;

        var relativePoints = options[action].snap && options[action].snap.relativePoints;

        if (checkSnap(target, action) && !(starting && relativePoints && relativePoints.length)) {
            this.snap = {
                range: snapStatus.range,
                locked: snapStatus.locked,
                x: snapStatus.snappedX,
                y: snapStatus.snappedY,
                realX: snapStatus.realX,
                realY: snapStatus.realY,
                dx: snapStatus.dx,
                dy: snapStatus.dy
            };

            if (snapStatus.locked) {
                page.x += snapStatus.dx;
                page.y += snapStatus.dy;
                client.x += snapStatus.dx;
                client.y += snapStatus.dy;
            }
        }

        if (checkRestrict(target, action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted) {
            page.x += restrictStatus.dx;
            page.y += restrictStatus.dy;
            client.x += restrictStatus.dx;
            client.y += restrictStatus.dy;

            this.restrict = {
                dx: restrictStatus.dx,
                dy: restrictStatus.dy
            };
        }

        this.pageX = page.x;
        this.pageY = page.y;
        this.clientX = client.x;
        this.clientY = client.y;

        this.x0 = interaction.startCoords.page.x - origin.x;
        this.y0 = interaction.startCoords.page.y - origin.y;
        this.clientX0 = interaction.startCoords.client.x - origin.x;
        this.clientY0 = interaction.startCoords.client.y - origin.y;
        this.ctrlKey = event.ctrlKey;
        this.altKey = event.altKey;
        this.shiftKey = event.shiftKey;
        this.metaKey = event.metaKey;
        this.button = event.button;
        this.buttons = event.buttons;
        this.target = element;
        this.t0 = interaction.downTimes[0];
        this.type = action + (phase || '');

        this.interaction = interaction;
        this.interactable = target;

        var inertiaStatus = interaction.inertiaStatus;

        if (inertiaStatus.active) {
            this.detail = 'inertia';
        }

        if (related) {
            this.relatedTarget = related;
        }

        // end event dx, dy is difference between start and end points
        if (ending) {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.startCoords.client.x;
                this.dy = client.y - interaction.startCoords.client.y;
            }
            else {
                this.dx = page.x - interaction.startCoords.page.x;
                this.dy = page.y - interaction.startCoords.page.y;
            }
        }
        else if (starting) {
            this.dx = 0;
            this.dy = 0;
        }
        // copy properties from previousmove if starting inertia
        else if (phase === 'inertiastart') {
            this.dx = interaction.prevEvent.dx;
            this.dy = interaction.prevEvent.dy;
        }
        else {
            if (deltaSource === 'client') {
                this.dx = client.x - interaction.prevEvent.clientX;
                this.dy = client.y - interaction.prevEvent.clientY;
            }
            else {
                this.dx = page.x - interaction.prevEvent.pageX;
                this.dy = page.y - interaction.prevEvent.pageY;
            }
        }
        if (interaction.prevEvent && interaction.prevEvent.detail === 'inertia'
            && !inertiaStatus.active
            && options[action].inertia && options[action].inertia.zeroResumeDelta) {

            inertiaStatus.resumeDx += this.dx;
            inertiaStatus.resumeDy += this.dy;

            this.dx = this.dy = 0;
        }

        if (action === 'resize' && interaction.resizeAxes) {
            if (options.resize.square) {
                if (interaction.resizeAxes === 'y') {
                    this.dx = this.dy;
                }
                else {
                    this.dy = this.dx;
                }
                this.axes = 'xy';
            }
            else {
                this.axes = interaction.resizeAxes;

                if (interaction.resizeAxes === 'x') {
                    this.dy = 0;
                }
                else if (interaction.resizeAxes === 'y') {
                    this.dx = 0;
                }
            }
        }
        else if (action === 'gesture') {
            this.touches = [pointers[0], pointers[1]];

            if (starting) {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = 1;
                this.ds = 0;
                this.angle = touchAngle(pointers, undefined, deltaSource);
                this.da = 0;
            }
            else if (ending || event instanceof InteractEvent) {
                this.distance = interaction.prevEvent.distance;
                this.box = interaction.prevEvent.box;
                this.scale = interaction.prevEvent.scale;
                this.ds = this.scale - 1;
                this.angle = interaction.prevEvent.angle;
                this.da = this.angle - interaction.gesture.startAngle;
            }
            else {
                this.distance = touchDistance(pointers, deltaSource);
                this.box = touchBBox(pointers);
                this.scale = this.distance / interaction.gesture.startDistance;
                this.angle = touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);

                this.ds = this.scale - interaction.gesture.prevScale;
                this.da = this.angle - interaction.gesture.prevAngle;
            }
        }

        if (starting) {
            this.timeStamp = interaction.downTimes[0];
            this.dt = 0;
            this.duration = 0;
            this.speed = 0;
            this.velocityX = 0;
            this.velocityY = 0;
        }
        else if (phase === 'inertiastart') {
            this.timeStamp = interaction.prevEvent.timeStamp;
            this.dt = interaction.prevEvent.dt;
            this.duration = interaction.prevEvent.duration;
            this.speed = interaction.prevEvent.speed;
            this.velocityX = interaction.prevEvent.velocityX;
            this.velocityY = interaction.prevEvent.velocityY;
        }
        else {
            this.timeStamp = new Date().getTime();
            this.dt = this.timeStamp - interaction.prevEvent.timeStamp;
            this.duration = this.timeStamp - interaction.downTimes[0];

            if (event instanceof InteractEvent) {
                var dx = this[sourceX] - interaction.prevEvent[sourceX],
                    dy = this[sourceY] - interaction.prevEvent[sourceY],
                    dt = this.dt / 1000;

                this.speed = hypot(dx, dy) / dt;
                this.velocityX = dx / dt;
                this.velocityY = dy / dt;
            }
            // if normal move or end event, use previous user event coords
            else {
                // speed and velocity in pixels per second
                this.speed = interaction.pointerDelta[deltaSource].speed;
                this.velocityX = interaction.pointerDelta[deltaSource].vx;
                this.velocityY = interaction.pointerDelta[deltaSource].vy;
            }
        }

        if ((ending || phase === 'inertiastart')
            && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150) {

            var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI,
                overlap = 22.5;

            if (angle < 0) {
                angle += 360;
            }

            var left = 135 - overlap <= angle && angle < 225 + overlap,
                up = 225 - overlap <= angle && angle < 315 + overlap,

                right = !left && (315 - overlap <= angle || angle < 45 + overlap),
                down = !up && 45 - overlap <= angle && angle < 135 + overlap;

            this.swipe = {
                up: up,
                down: down,
                left: left,
                right: right,
                angle: angle,
                speed: interaction.prevEvent.speed,
                velocity: {
                    x: interaction.prevEvent.velocityX,
                    y: interaction.prevEvent.velocityY
                }
            };
        }
    }

    InteractEvent.prototype = {
        preventDefault: blank,
        stopImmediatePropagation: function () {
            this.immediatePropagationStopped = this.propagationStopped = true;
        },
        stopPropagation: function () {
            this.propagationStopped = true;
        }
    };

    function preventOriginalDefault() {
        this.originalEvent.preventDefault();
    }

    function getActionCursor(action) {
        var cursor = '';

        if (action.name === 'drag') {
            cursor = actionCursors.drag;
        }
        if (action.name === 'resize') {
            if (action.axis) {
                cursor = actionCursors[action.name + action.axis];
            }
            else if (action.edges) {
                var cursorKey = 'resize',
                    edgeNames = ['top', 'bottom', 'left', 'right'];

                for (var i = 0; i < 4; i++) {
                    if (action.edges[edgeNames[i]]) {
                        cursorKey += edgeNames[i];
                    }
                }

                cursor = actionCursors[cursorKey];
            }
        }

        return cursor;
    }

    function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
        // false, '', undefined, null
        if (!value) { return false; }

        // true value, use pointer coords and element rect
        if (value === true) {
            // if dimensions are negative, "switch" edges
            var width = isNumber(rect.width) ? rect.width : rect.right - rect.left,
                height = isNumber(rect.height) ? rect.height : rect.bottom - rect.top;

            if (width < 0) {
                if (name === 'left') { name = 'right'; }
                else if (name === 'right') { name = 'left'; }
            }
            if (height < 0) {
                if (name === 'top') { name = 'bottom'; }
                else if (name === 'bottom') { name = 'top'; }
            }

            if (name === 'left') { return page.x < ((width >= 0 ? rect.left : rect.right) + margin); }
            if (name === 'top') { return page.y < ((height >= 0 ? rect.top : rect.bottom) + margin); }

            if (name === 'right') { return page.x > ((width >= 0 ? rect.right : rect.left) - margin); }
            if (name === 'bottom') { return page.y > ((height >= 0 ? rect.bottom : rect.top) - margin); }
        }

        // the remaining checks require an element
        if (!isElement(element)) { return false; }

        return isElement(value)
            // the value is an element to use as a resize handle
            ? value === element
            // otherwise check if element matches value as selector
            : matchesUpTo(element, value, interactableElement);
    }

    function defaultActionChecker(pointer, interaction, element) {
        var rect = this.getRect(element),
            shouldResize = false,
            action = null,
            resizeAxes = null,
            resizeEdges,
            page = extend({}, interaction.curCoords.page),
            options = this.options;

        if (!rect) { return null; }

        if (actionIsEnabled.resize && options.resize.enabled) {
            var resizeOptions = options.resize;

            resizeEdges = {
                left: false, right: false, top: false, bottom: false
            };

            // if using resize.edges
            if (isObject(resizeOptions.edges)) {
                for (var edge in resizeEdges) {
                    resizeEdges[edge] = checkResizeEdge(edge,
                        resizeOptions.edges[edge],
                        page,
                        interaction._eventTarget,
                        element,
                        rect,
                        resizeOptions.margin || margin);
                }

                resizeEdges.left = resizeEdges.left && !resizeEdges.right;
                resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;

                shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;
            }
            else {
                var right = options.resize.axis !== 'y' && page.x > (rect.right - margin),
                    bottom = options.resize.axis !== 'x' && page.y > (rect.bottom - margin);

                shouldResize = right || bottom;
                resizeAxes = (right ? 'x' : '') + (bottom ? 'y' : '');
            }
        }

        action = shouldResize
            ? 'resize'
            : actionIsEnabled.drag && options.drag.enabled
                ? 'drag'
                : null;

        if (actionIsEnabled.gesture
            && interaction.pointerIds.length >= 2
            && !(interaction.dragging || interaction.resizing)) {
            action = 'gesture';
        }

        if (action) {
            return {
                name: action,
                axis: resizeAxes,
                edges: resizeEdges
            };
        }

        return null;
    }

    // Check if action is enabled globally and the current target supports it
    // If so, return the validated action. Otherwise, return null
    function validateAction(action, interactable) {
        if (!isObject(action)) { return null; }

        var actionName = action.name,
            options = interactable.options;

        if (((actionName === 'resize' && options.resize.enabled)
            || (actionName === 'drag' && options.drag.enabled)
            || (actionName === 'gesture' && options.gesture.enabled))
            && actionIsEnabled[actionName]) {

            if (actionName === 'resize' || actionName === 'resizeyx') {
                actionName = 'resizexy';
            }

            return action;
        }
        return null;
    }

    var listeners = {},
        interactionListeners = [
            'dragStart', 'dragMove', 'resizeStart', 'resizeMove', 'gestureStart', 'gestureMove',
            'pointerOver', 'pointerOut', 'pointerHover', 'selectorDown',
            'pointerDown', 'pointerMove', 'pointerUp', 'pointerCancel', 'pointerEnd',
            'addPointer', 'removePointer', 'recordPointer', 'autoScrollMove'
        ];

    for (var i = 0, len = interactionListeners.length; i < len; i++) {
        var name = interactionListeners[i];

        listeners[name] = doOnInteractions(name);
    }

    // bound to the interactable context when a DOM event
    // listener is added to a selector interactable
    function delegateListener(event, useCapture) {
        var fakeEvent = {},
            delegated = delegatedEvents[event.type],
            eventTarget = getActualElement(event.path
                ? event.path[0]
                : event.target),
            element = eventTarget;

        useCapture = useCapture ? true : false;

        // duplicate the event so that currentTarget can be changed
        for (var prop in event) {
            fakeEvent[prop] = event[prop];
        }

        fakeEvent.originalEvent = event;
        fakeEvent.preventDefault = preventOriginalDefault;

        // climb up document tree looking for selector matches
        while (isElement(element)) {
            for (var i = 0; i < delegated.selectors.length; i++) {
                var selector = delegated.selectors[i],
                    context = delegated.contexts[i];

                if (matchesSelector(element, selector)
                    && nodeContains(context, eventTarget)
                    && nodeContains(context, element)) {

                    var listeners = delegated.listeners[i];

                    fakeEvent.currentTarget = element;

                    for (var j = 0; j < listeners.length; j++) {
                        if (listeners[j][1] === useCapture) {
                            listeners[j][0](fakeEvent);
                        }
                    }
                }
            }

            element = parentElement(element);
        }
    }

    function delegateUseCapture(event) {
        return delegateListener.call(this, event, true);
    }

    interactables.indexOfElement = function indexOfElement(element, context) {
        context = context || document;

        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if ((interactable.selector === element
                && (interactable._context === context))
                || (!interactable.selector && interactable._element === element)) {

                return i;
            }
        }
        return -1;
    };

    interactables.get = function interactableGet(element, options) {
        return this[this.indexOfElement(element, options && options.context)];
    };

    interactables.forEachSelector = function (callback) {
        for (var i = 0; i < this.length; i++) {
            var interactable = this[i];

            if (!interactable.selector) {
                continue;
            }

            var ret = callback(interactable, interactable.selector, interactable._context, i, this);

            if (ret !== undefined) {
                return ret;
            }
        }
    };

    /*\
     * interact
     [ method ]
     *
     * The methods of this variable can be used to set elements as
     * interactables and also to change various default settings.
     *
     * Calling it as a function and passing an element or a valid CSS selector
     * string returns an Interactable object which has various methods to
     * configure it.
     *
     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
     = (object) An @Interactable
     *
     > Usage
     | interact(document.getElementById('draggable')).draggable(true);
     |
     | var rectables = interact('rect');
     | rectables
     |     .gesturable(true)
     |     .on('gesturemove', function (event) {
     |         // something cool...
     |     })
     |     .autoScroll(true);
    \*/
    function interact(element, options) {
        return interactables.get(element, options) || new Interactable(element, options);
    }

    /*\
     * Interactable
     [ property ]
     **
     * Object type returned by @interact
    \*/
    function Interactable(element, options) {
        this._element = element;
        this._iEvents = this._iEvents || {};

        var _window;

        if (trySelector(element)) {
            this.selector = element;

            var context = options && options.context;

            _window = context ? getWindow(context) : window;

            if (context && (_window.Node
                ? context instanceof _window.Node
                : (isElement(context) || context === _window.document))) {

                this._context = context;
            }
        }
        else {
            _window = getWindow(element);

            if (isElement(element, _window)) {

                if (supportsPointerEvent) {
                    events.add(this._element, pEventTypes.down, listeners.pointerDown);
                    events.add(this._element, pEventTypes.move, listeners.pointerHover);
                }
                else {
                    events.add(this._element, 'mousedown', listeners.pointerDown);
                    events.add(this._element, 'mousemove', listeners.pointerHover);
                    events.add(this._element, 'touchstart', listeners.pointerDown);
                    events.add(this._element, 'touchmove', listeners.pointerHover);
                }
            }
        }

        this._doc = _window.document;

        if (!contains(documents, this._doc)) {
            listenToDocument(this._doc);
        }

        interactables.push(this);

        this.set(options);
    }

    Interactable.prototype = {
        setOnEvents: function (action, phases) {
            if (action === 'drop') {
                if (isFunction(phases.ondrop)) { this.ondrop = phases.ondrop; }
                if (isFunction(phases.ondropactivate)) { this.ondropactivate = phases.ondropactivate; }
                if (isFunction(phases.ondropdeactivate)) { this.ondropdeactivate = phases.ondropdeactivate; }
                if (isFunction(phases.ondragenter)) { this.ondragenter = phases.ondragenter; }
                if (isFunction(phases.ondragleave)) { this.ondragleave = phases.ondragleave; }
                if (isFunction(phases.ondropmove)) { this.ondropmove = phases.ondropmove; }
            }
            else {
                action = 'on' + action;

                if (isFunction(phases.onstart)) { this[action + 'start'] = phases.onstart; }
                if (isFunction(phases.onmove)) { this[action + 'move'] = phases.onmove; }
                if (isFunction(phases.onend)) { this[action + 'end'] = phases.onend; }
                if (isFunction(phases.oninertiastart)) { this[action + 'inertiastart'] = phases.oninertiastart; }
            }

            return this;
        },

        /*\
         * Interactable.draggable
         [ method ]
         *
         * Gets or sets whether drag actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of drag events
         | var isDraggable = interact('ul li').draggable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
         = (object) This Interactable
         | interact(element).draggable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // the axis in which the first movement must be
         |     // for the drag sequence to start
         |     // 'xy' by default - any direction
         |     axis: 'x' || 'y' || 'xy',
         |
         |     // max number of drags that can happen concurrently
         |     // with elements of this Interactable. Infinity by default
         |     max: Infinity,
         |
         |     // max number of drags that can target the same element+Interactable
         |     // 1 by default
         |     maxPerElement: 2
         | });
        \*/
        draggable: function (options) {
            if (isObject(options)) {
                this.options.drag.enabled = options.enabled === false ? false : true;
                this.setPerAction('drag', options);
                this.setOnEvents('drag', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.drag.axis = options.axis;
                }
                else if (options.axis === null) {
                    delete this.options.drag.axis;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drag.enabled = options;

                return this;
            }

            return this.options.drag;
        },

        setPerAction: function (action, options) {
            // for all the default per-action options
            for (var option in options) {
                // if this option exists for this action
                if (option in defaultOptions[action]) {
                    // if the option in the options arg is an object value
                    if (isObject(options[option])) {
                        // duplicate the object
                        this.options[action][option] = extend(this.options[action][option] || {}, options[option]);

                        if (isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]) {
                            this.options[action][option].enabled = options[option].enabled === false ? false : true;
                        }
                    }
                    else if (isBool(options[option]) && isObject(defaultOptions.perAction[option])) {
                        this.options[action][option].enabled = options[option];
                    }
                    else if (options[option] !== undefined) {
                        // or if it's not undefined, do a plain assignment
                        this.options[action][option] = options[option];
                    }
                }
            }
        },

        /*\
         * Interactable.dropzone
         [ method ]
         *
         * Returns or sets whether elements can be dropped onto this
         * Interactable to trigger drop events
         *
         * Dropzones can receive the following events:
         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
         *  - `dragmove` when a draggable that has entered the dropzone is moved
         *  - `drop` when a draggable is dropped into this dropzone
         *
         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
         *
         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
         *   - `'pointer'`, the pointer must be over the dropzone (default)
         *   - `'center'`, the draggable element's center must be over the dropzone
         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
         *       e.g. `0.5` for drop to happen when half of the area of the
         *       draggable is over the dropzone
         *
         - options (boolean | object | null) #optional The new value to be set.
         | interact('.drop').dropzone({
         |   accept: '.can-drop' || document.getElementById('single-drop'),
         |   overlap: 'pointer' || 'center' || zeroToOne
         | }
         = (boolean | object) The current setting or this Interactable
        \*/
        dropzone: function (options) {
            if (isObject(options)) {
                this.options.drop.enabled = options.enabled === false ? false : true;
                this.setOnEvents('drop', options);

                if (/^(pointer|center)$/.test(options.overlap)) {
                    this.options.drop.overlap = options.overlap;
                }
                else if (isNumber(options.overlap)) {
                    this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
                }
                if ('accept' in options) {
                    this.options.drop.accept = options.accept;
                }
                if ('checker' in options) {
                    this.options.drop.checker = options.checker;
                }

                return this;
            }

            if (isBool(options)) {
                this.options.drop.enabled = options;

                return this;
            }

            return this.options.drop;
        },

        dropCheck: function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
            var dropped = false;

            // if the dropzone has no rect (eg. display: none)
            // call the custom dropChecker or just return false
            if (!(rect = rect || this.getRect(dropElement))) {
                return (this.options.drop.checker
                    ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement)
                    : false);
            }

            var dropOverlap = this.options.drop.overlap;

            if (dropOverlap === 'pointer') {
                var page = getPageXY(dragEvent),
                    origin = getOriginXY(draggable, draggableElement),
                    horizontal,
                    vertical;

                page.x += origin.x;
                page.y += origin.y;

                horizontal = (page.x > rect.left) && (page.x < rect.right);
                vertical = (page.y > rect.top) && (page.y < rect.bottom);

                dropped = horizontal && vertical;
            }

            var dragRect = draggable.getRect(draggableElement);

            if (dropOverlap === 'center') {
                var cx = dragRect.left + dragRect.width / 2,
                    cy = dragRect.top + dragRect.height / 2;

                dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
            }

            if (isNumber(dropOverlap)) {
                var overlapArea = (Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left))
                    * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top))),
                    overlapRatio = overlapArea / (dragRect.width * dragRect.height);

                dropped = overlapRatio >= dropOverlap;
            }

            if (this.options.drop.checker) {
                dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
            }

            return dropped;
        },

        /*\
         * Interactable.dropChecker
         [ method ]
         *
         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
         *
         * Gets or sets the function used to check if a dragged element is
         * over this Interactable.
         *
         - checker (function) #optional The function that will be called when checking for a drop
         = (Function | Interactable) The checker function or this Interactable
         *
         * The checker function takes the following arguments:
         *
         - dragEvent (InteractEvent) The related dragmove or dragend event
         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
         - dropped (boolean) The value from the default drop checker
         - dropzone (Interactable) The dropzone interactable
         - dropElement (Element) The dropzone element
         - draggable (Interactable) The Interactable being dragged
         - draggableElement (Element) The actual element that's being dragged
         *
         > Usage:
         | interact(target)
         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
         |                       event,             // TouchEvent/PointerEvent/MouseEvent
         |                       dropped,           // bool result of the default checker
         |                       dropzone,          // dropzone Interactable
         |                       dropElement,       // dropzone elemnt
         |                       draggable,         // draggable Interactable
         |                       draggableElement) {// draggable element
         |
         |   return dropped && event.target.hasAttribute('allow-drop');
         | }
        \*/
        dropChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.drop.checker = checker;

                return this;
            }
            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.options.drop.checker;
        },

        /*\
         * Interactable.accept
         [ method ]
         *
         * Deprecated. add an `accept` property to the options object passed to
         * @Interactable.dropzone instead.
         *
         * Gets or sets the Element or CSS selector match that this
         * Interactable accepts if it is a dropzone.
         *
         - newValue (Element | string | null) #optional
         * If it is an Element, then only that element can be dropped into this dropzone.
         * If it is a string, the element being dragged must match it as a selector.
         * If it is null, the accept options is cleared - it accepts any element.
         *
         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
        \*/
        accept: function (newValue) {
            if (isElement(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            // test if it is a valid CSS selector
            if (trySelector(newValue)) {
                this.options.drop.accept = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.drop.accept;

                return this;
            }

            return this.options.drop.accept;
        },

        /*\
         * Interactable.resizable
         [ method ]
         *
         * Gets or sets whether resize actions can be performed on the
         * Interactable
         *
         = (boolean) Indicates if this can be the target of resize elements
         | var isResizeable = interact('input[type=text]').resizable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
         = (object) This Interactable
         | interact(element).resizable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     edges: {
         |       top   : true,       // Use pointer coords to check for resize.
         |       left  : false,      // Disable resizing from left edge.
         |       bottom: '.resize-s',// Resize if pointer target matches selector
         |       right : handleEl    // Resize if pointer target is the given Element
         |     },
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height are adjusted at a 1:1 ratio.
         |     square: false,
         |
         |     // Width and height can be adjusted independently. When `true`, width and
         |     // height maintain the aspect ratio they had when resizing started.
         |     preserveAspectRatio: false,
         |
         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
         |     // 'negate' will allow the rect to have negative width/height
         |     // 'reposition' will keep the width/height positive by swapping
         |     // the top and bottom edges and/or swapping the left and right edges
         |     invert: 'none' || 'negate' || 'reposition'
         |
         |     // limit multiple resizes.
         |     // See the explanation in the @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        resizable: function (options) {
            if (isObject(options)) {
                this.options.resize.enabled = options.enabled === false ? false : true;
                this.setPerAction('resize', options);
                this.setOnEvents('resize', options);

                if (/^x$|^y$|^xy$/.test(options.axis)) {
                    this.options.resize.axis = options.axis;
                }
                else if (options.axis === null) {
                    this.options.resize.axis = defaultOptions.resize.axis;
                }

                if (isBool(options.preserveAspectRatio)) {
                    this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
                }
                else if (isBool(options.square)) {
                    this.options.resize.square = options.square;
                }

                return this;
            }
            if (isBool(options)) {
                this.options.resize.enabled = options;

                return this;
            }
            return this.options.resize;
        },

        /*\
         * Interactable.squareResize
         [ method ]
         *
         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
         *
         * Gets or sets whether resizing is forced 1:1 aspect
         *
         = (boolean) Current setting
         *
         * or
         *
         - newValue (boolean) #optional
         = (object) this Interactable
        \*/
        squareResize: function (newValue) {
            if (isBool(newValue)) {
                this.options.resize.square = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.resize.square;

                return this;
            }

            return this.options.resize.square;
        },

        /*\
         * Interactable.gesturable
         [ method ]
         *
         * Gets or sets whether multitouch gestures can be performed on the
         * Interactable's element
         *
         = (boolean) Indicates if this can be the target of gesture events
         | var isGestureable = interact(element).gesturable();
         * or
         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
         = (object) this Interactable
         | interact(element).gesturable({
         |     onstart: function (event) {},
         |     onmove : function (event) {},
         |     onend  : function (event) {},
         |
         |     // limit multiple gestures.
         |     // See the explanation in @Interactable.draggable example
         |     max: Infinity,
         |     maxPerElement: 1,
         | });
        \*/
        gesturable: function (options) {
            if (isObject(options)) {
                this.options.gesture.enabled = options.enabled === false ? false : true;
                this.setPerAction('gesture', options);
                this.setOnEvents('gesture', options);

                return this;
            }

            if (isBool(options)) {
                this.options.gesture.enabled = options;

                return this;
            }

            return this.options.gesture;
        },

        /*\
         * Interactable.autoScroll
         [ method ]
         **
         * Deprecated. Add an `autoscroll` property to the options object
         * passed to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets whether dragging and resizing near the edges of the
         * window/container trigger autoScroll for this Interactable
         *
         = (object) Object with autoScroll properties
         *
         * or
         *
         - options (object | boolean) #optional
         * options can be:
         * - an object with margin, distance and interval properties,
         * - true or false to enable or disable autoScroll or
         = (Interactable) this Interactable
        \*/
        autoScroll: function (options) {
            if (isObject(options)) {
                options = extend({ actions: ['drag', 'resize'] }, options);
            }
            else if (isBool(options)) {
                options = { actions: ['drag', 'resize'], enabled: options };
            }

            return this.setOptions('autoScroll', options);
        },

        /*\
         * Interactable.snap
         [ method ]
         **
         * Deprecated. Add a `snap` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how action coordinates are snapped. By
         * default, snapping is relative to the pointer coordinates. You can
         * change this by setting the
         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
         **
         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | interact(document.querySelector('#thing')).snap({
         |     targets: [
         |         // snap to this specific point
         |         {
         |             x: 100,
         |             y: 100,
         |             range: 25
         |         },
         |         // give this function the x and y page coords and snap to the object returned
         |         function (x, y) {
         |             return {
         |                 x: x,
         |                 y: (75 + 50 * Math.sin(x * 0.04)),
         |                 range: 40
         |             };
         |         },
         |         // create a function that snaps to a grid
         |         interact.createSnapGrid({
         |             x: 50,
         |             y: 50,
         |             range: 10,              // optional
         |             offset: { x: 5, y: 10 } // optional
         |         })
         |     ],
         |     // do not snap during normal movement.
         |     // Instead, trigger only one snapped move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     relativePoints: [
         |         { x: 0, y: 0 },  // snap relative to the top left of the element
         |         { x: 1, y: 1 },  // and also to the bottom right
         |     ],  
         |
         |     // offset the snap target coordinates
         |     // can be an object with x/y or 'startCoords'
         |     offset: { x: 50, y: 50 }
         |   }
         | });
        \*/
        snap: function (options) {
            var ret = this.setOptions('snap', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        setOptions: function (option, options) {
            var actions = options && isArray(options.actions)
                ? options.actions
                : ['drag'];

            var i;

            if (isObject(options) || isBool(options)) {
                for (i = 0; i < actions.length; i++) {
                    var action = /resize/.test(actions[i]) ? 'resize' : actions[i];

                    if (!isObject(this.options[action])) { continue; }

                    var thisOption = this.options[action][option];

                    if (isObject(options)) {
                        extend(thisOption, options);
                        thisOption.enabled = options.enabled === false ? false : true;

                        if (option === 'snap') {
                            if (thisOption.mode === 'grid') {
                                thisOption.targets = [
                                    interact.createSnapGrid(extend({
                                        offset: thisOption.gridOffset || { x: 0, y: 0 }
                                    }, thisOption.grid || {}))
                                ];
                            }
                            else if (thisOption.mode === 'anchor') {
                                thisOption.targets = thisOption.anchors;
                            }
                            else if (thisOption.mode === 'path') {
                                thisOption.targets = thisOption.paths;
                            }

                            if ('elementOrigin' in options) {
                                thisOption.relativePoints = [options.elementOrigin];
                            }
                        }
                    }
                    else if (isBool(options)) {
                        thisOption.enabled = options;
                    }
                }

                return this;
            }

            var ret = {},
                allActions = ['drag', 'resize', 'gesture'];

            for (i = 0; i < allActions.length; i++) {
                if (option in defaultOptions[allActions[i]]) {
                    ret[allActions[i]] = this.options[allActions[i]][option];
                }
            }

            return ret;
        },


        /*\
         * Interactable.inertia
         [ method ]
         **
         * Deprecated. Add an `inertia` property to the options object passed
         * to @Interactable.draggable or @Interactable.resizable instead.
         *
         * Returns or sets if and how events continue to run after the pointer is released
         **
         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
         **
         * or
         **
         - options (object | boolean | null) #optional
         = (Interactable) this Interactable
         > Usage
         | // enable and use default settings
         | interact(element).inertia(true);
         |
         | // enable and use custom settings
         | interact(element).inertia({
         |     // value greater than 0
         |     // high values slow the object down more quickly
         |     resistance     : 16,
         |
         |     // the minimum launch speed (pixels per second) that results in inertia start
         |     minSpeed       : 200,
         |
         |     // inertia will stop when the object slows down to this speed
         |     endSpeed       : 20,
         |
         |     // boolean; should actions be resumed when the pointer goes down during inertia
         |     allowResume    : true,
         |
         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
         |     zeroResumeDelta: false,
         |
         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
         |     // the pointer without triggering inertia will animate from the release
         |     // point to the snaped/restricted point in the given amount of time (ms)
         |     smoothEndDuration: 300,
         |
         |     // an array of action types that can have inertia (no gesture)
         |     actions        : ['drag', 'resize']
         | });
         |
         | // reset custom settings and use all defaults
         | interact(element).inertia(null);
        \*/
        inertia: function (options) {
            var ret = this.setOptions('inertia', options);

            if (ret === this) { return this; }

            return ret.drag;
        },

        getAction: function (pointer, event, interaction, element) {
            var action = this.defaultActionChecker(pointer, interaction, element);

            if (this.options.actionChecker) {
                return this.options.actionChecker(pointer, event, action, this, element, interaction);
            }

            return action;
        },

        defaultActionChecker: defaultActionChecker,

        /*\
         * Interactable.actionChecker
         [ method ]
         *
         * Gets or sets the function used to check action to be performed on
         * pointerDown
         *
         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
         = (Function | Interactable) The checker function or this Interactable
         *
         | interact('.resize-drag')
         |   .resizable(true)
         |   .draggable(true)
         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
         |
         |   if (interact.matchesSelector(event.target, '.drag-handle') {
         |     // force drag with handle target
         |     action.name = drag;
         |   }
         |   else {
         |     // resize from the top and right edges
         |     action.name  = 'resize';
         |     action.edges = { top: true, right: true };
         |   }
         |
         |   return action;
         | });
        \*/
        actionChecker: function (checker) {
            if (isFunction(checker)) {
                this.options.actionChecker = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.actionChecker;

                return this;
            }

            return this.options.actionChecker;
        },

        /*\
         * Interactable.getRect
         [ method ]
         *
         * The default function to get an Interactables bounding rect. Can be
         * overridden using @Interactable.rectChecker.
         *
         - element (Element) #optional The element to measure.
         = (object) The object's bounding rectangle.
         o {
         o     top   : 0,
         o     left  : 0,
         o     bottom: 0,
         o     right : 0,
         o     width : 0,
         o     height: 0
         o }
        \*/
        getRect: function rectCheck(element) {
            element = element || this._element;

            if (this.selector && !(isElement(element))) {
                element = this._context.querySelector(this.selector);
            }

            return getElementRect(element);
        },

        /*\
         * Interactable.rectChecker
         [ method ]
         *
         * Returns or sets the function used to calculate the interactable's
         * element's rectangle
         *
         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
         = (function | object) The checker function or this Interactable
        \*/
        rectChecker: function (checker) {
            if (isFunction(checker)) {
                this.getRect = checker;

                return this;
            }

            if (checker === null) {
                delete this.options.getRect;

                return this;
            }

            return this.getRect;
        },

        /*\
         * Interactable.styleCursor
         [ method ]
         *
         * Returns or sets whether the action that would be performed when the
         * mouse on the element are checked on `mousemove` so that the cursor
         * may be styled appropriately
         *
         - newValue (boolean) #optional
         = (boolean | Interactable) The current setting or this Interactable
        \*/
        styleCursor: function (newValue) {
            if (isBool(newValue)) {
                this.options.styleCursor = newValue;

                return this;
            }

            if (newValue === null) {
                delete this.options.styleCursor;

                return this;
            }

            return this.options.styleCursor;
        },

        /*\
         * Interactable.preventDefault
         [ method ]
         *
         * Returns or sets whether to prevent the browser's default behaviour
         * in response to pointer events. Can be set to:
         *  - `'always'` to always prevent
         *  - `'never'` to never prevent
         *  - `'auto'` to let interact.js try to determine what would be best
         *
         - newValue (string) #optional `true`, `false` or `'auto'`
         = (string | Interactable) The current setting or this Interactable
        \*/
        preventDefault: function (newValue) {
            if (/^(always|never|auto)$/.test(newValue)) {
                this.options.preventDefault = newValue;
                return this;
            }

            if (isBool(newValue)) {
                this.options.preventDefault = newValue ? 'always' : 'never';
                return this;
            }

            return this.options.preventDefault;
        },

        /*\
         * Interactable.origin
         [ method ]
         *
         * Gets or sets the origin of the Interactable's element.  The x and y
         * of the origin will be subtracted from action event coordinates.
         *
         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
         * OR
         - origin (Element) #optional An HTML or SVG Element whose rect will be used
         **
         = (object) The current origin or this Interactable
        \*/
        origin: function (newValue) {
            if (trySelector(newValue)) {
                this.options.origin = newValue;
                return this;
            }
            else if (isObject(newValue)) {
                this.options.origin = newValue;
                return this;
            }

            return this.options.origin;
        },

        /*\
         * Interactable.deltaSource
         [ method ]
         *
         * Returns or sets the mouse coordinate types used to calculate the
         * movement of the pointer.
         *
         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
         = (string | object) The current deltaSource or this Interactable
        \*/
        deltaSource: function (newValue) {
            if (newValue === 'page' || newValue === 'client') {
                this.options.deltaSource = newValue;

                return this;
            }

            return this.options.deltaSource;
        },

        /*\
         * Interactable.restrict
         [ method ]
         **
         * Deprecated. Add a `restrict` property to the options object passed to
         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
         *
         * Returns or sets the rectangles within which actions on this
         * interactable (after snap calculations) are restricted. By default,
         * restricting is relative to the pointer coordinates. You can change
         * this by setting the
         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
         **
         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
         = (object) The current restrictions object or this Interactable
         **
         | interact(element).restrict({
         |     // the rect will be `interact.getElementRect(element.parentNode)`
         |     drag: element.parentNode,
         |
         |     // x and y are relative to the the interactable's origin
         |     resize: { x: 100, y: 100, width: 200, height: 200 }
         | })
         |
         | interact('.draggable').restrict({
         |     // the rect will be the selected element's parent
         |     drag: 'parent',
         |
         |     // do not restrict during normal movement.
         |     // Instead, trigger only one restricted move event
         |     // immediately before the end event.
         |     endOnly: true,
         |
         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
         | });
        \*/
        restrict: function (options) {
            if (!isObject(options)) {
                return this.setOptions('restrict', options);
            }

            var actions = ['drag', 'resize', 'gesture'],
                ret;

            for (var i = 0; i < actions.length; i++) {
                var action = actions[i];

                if (action in options) {
                    var perAction = extend({
                        actions: [action],
                        restriction: options[action]
                    }, options);

                    ret = this.setOptions('restrict', perAction);
                }
            }

            return ret;
        },

        /*\
         * Interactable.context
         [ method ]
         *
         * Gets the selector context Node of the Interactable. The default is `window.document`.
         *
         = (Node) The context Node of this Interactable
         **
        \*/
        context: function () {
            return this._context;
        },

        _context: document,

        /*\
         * Interactable.ignoreFrom
         [ method ]
         *
         * If the target of the `mousedown`, `pointerdown` or `touchstart`
         * event or any of it's parents match the given CSS selector or
         * Element, no drag/resize/gesture is started.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
         = (string | Element | object) The current ignoreFrom value or this Interactable
         **
         | interact(element, { ignoreFrom: document.getElementById('no-action') });
         | // or
         | interact(element).ignoreFrom('input, textarea, a');
        \*/
        ignoreFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.ignoreFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.ignoreFrom = newValue;
                return this;
            }

            return this.options.ignoreFrom;
        },

        /*\
         * Interactable.allowFrom
         [ method ]
         *
         * A drag/resize/gesture is started only If the target of the
         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
         * parents match the given CSS selector or Element.
         *
         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
         = (string | Element | object) The current allowFrom value or this Interactable
         **
         | interact(element, { allowFrom: document.getElementById('drag-handle') });
         | // or
         | interact(element).allowFrom('.handle');
        \*/
        allowFrom: function (newValue) {
            if (trySelector(newValue)) {            // CSS selector to match event.target
                this.options.allowFrom = newValue;
                return this;
            }

            if (isElement(newValue)) {              // specific element
                this.options.allowFrom = newValue;
                return this;
            }

            return this.options.allowFrom;
        },

        /*\
         * Interactable.element
         [ method ]
         *
         * If this is not a selector Interactable, it returns the element this
         * interactable represents
         *
         = (Element) HTML / SVG Element
        \*/
        element: function () {
            return this._element;
        },

        /*\
         * Interactable.fire
         [ method ]
         *
         * Calls listeners for the given InteractEvent type bound globally
         * and directly to this Interactable
         *
         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
         = (Interactable) this Interactable
        \*/
        fire: function (iEvent) {
            if (!(iEvent && iEvent.type) || !contains(eventTypes, iEvent.type)) {
                return this;
            }

            var listeners,
                i,
                len,
                onEvent = 'on' + iEvent.type,
                funcName = '';

            // Interactable#on() listeners
            if (iEvent.type in this._iEvents) {
                listeners = this._iEvents[iEvent.type];

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            // interactable.onevent listener
            if (isFunction(this[onEvent])) {
                funcName = this[onEvent].name;
                this[onEvent](iEvent);
            }

            // interact.on() listeners
            if (iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type])) {

                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
                    funcName = listeners[i].name;
                    listeners[i](iEvent);
                }
            }

            return this;
        },

        /*\
         * Interactable.on
         [ method ]
         *
         * Binds a listener for an InteractEvent or DOM event.
         *
         - eventType  (string | array | object) The types of events to listen for
         - listener   (function) The function to be called on the given event(s)
         - useCapture (boolean) #optional useCapture flag for addEventListener
         = (object) This Interactable
        \*/
        on: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.on(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.on(prop, eventType[prop], listener);
                }

                return this;
            }

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (contains(eventTypes, eventType)) {
                // if this type of event was never bound to this Interactable
                if (!(eventType in this._iEvents)) {
                    this._iEvents[eventType] = [listener];
                }
                else {
                    this._iEvents[eventType].push(listener);
                }
            }
            // delegated event for selector
            else if (this.selector) {
                if (!delegatedEvents[eventType]) {
                    delegatedEvents[eventType] = {
                        selectors: [],
                        contexts: [],
                        listeners: []
                    };

                    // add delegate listener functions
                    for (i = 0; i < documents.length; i++) {
                        events.add(documents[i], eventType, delegateListener);
                        events.add(documents[i], eventType, delegateUseCapture, true);
                    }
                }

                var delegated = delegatedEvents[eventType],
                    index;

                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {
                        break;
                    }
                }

                if (index === -1) {
                    index = delegated.selectors.length;

                    delegated.selectors.push(this.selector);
                    delegated.contexts.push(this._context);
                    delegated.listeners.push([]);
                }

                // keep listener and useCapture flag
                delegated.listeners[index].push([listener, useCapture]);
            }
            else {
                events.add(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.off
         [ method ]
         *
         * Removes an InteractEvent or DOM event listener
         *
         - eventType  (string | array | object) The types of events that were listened for
         - listener   (function) The listener function to be removed
         - useCapture (boolean) #optional useCapture flag for removeEventListener
         = (object) This Interactable
        \*/
        off: function (eventType, listener, useCapture) {
            var i;

            if (isString(eventType) && eventType.search(' ') !== -1) {
                eventType = eventType.trim().split(/ +/);
            }

            if (isArray(eventType)) {
                for (i = 0; i < eventType.length; i++) {
                    this.off(eventType[i], listener, useCapture);
                }

                return this;
            }

            if (isObject(eventType)) {
                for (var prop in eventType) {
                    this.off(prop, eventType[prop], listener);
                }

                return this;
            }

            var eventList,
                index = -1;

            // convert to boolean
            useCapture = useCapture ? true : false;

            if (eventType === 'wheel') {
                eventType = wheelEvent;
            }

            // if it is an action event type
            if (contains(eventTypes, eventType)) {
                eventList = this._iEvents[eventType];

                if (eventList && (index = indexOf(eventList, listener)) !== -1) {
                    this._iEvents[eventType].splice(index, 1);
                }
            }
            // delegated event
            else if (this.selector) {
                var delegated = delegatedEvents[eventType],
                    matchFound = false;

                if (!delegated) { return this; }

                // count from last index of delegated to 0
                for (index = delegated.selectors.length - 1; index >= 0; index--) {
                    // look for matching selector and context Node
                    if (delegated.selectors[index] === this.selector
                        && delegated.contexts[index] === this._context) {

                        var listeners = delegated.listeners[index];

                        // each item of the listeners array is an array: [function, useCaptureFlag]
                        for (i = listeners.length - 1; i >= 0; i--) {
                            var fn = listeners[i][0],
                                useCap = listeners[i][1];

                            // check if the listener functions and useCapture flags match
                            if (fn === listener && useCap === useCapture) {
                                // remove the listener from the array of listeners
                                listeners.splice(i, 1);

                                // if all listeners for this interactable have been removed
                                // remove the interactable from the delegated arrays
                                if (!listeners.length) {
                                    delegated.selectors.splice(index, 1);
                                    delegated.contexts.splice(index, 1);
                                    delegated.listeners.splice(index, 1);

                                    // remove delegate function from context
                                    events.remove(this._context, eventType, delegateListener);
                                    events.remove(this._context, eventType, delegateUseCapture, true);

                                    // remove the arrays if they are empty
                                    if (!delegated.selectors.length) {
                                        delegatedEvents[eventType] = null;
                                    }
                                }

                                // only remove one listener
                                matchFound = true;
                                break;
                            }
                        }

                        if (matchFound) { break; }
                    }
                }
            }
            // remove listener from this Interatable's element
            else {
                events.remove(this._element, eventType, listener, useCapture);
            }

            return this;
        },

        /*\
         * Interactable.set
         [ method ]
         *
         * Reset the options of this Interactable
         - options (object) The new settings to apply
         = (object) This Interactable
        \*/
        set: function (options) {
            if (!isObject(options)) {
                options = {};
            }

            this.options = extend({}, defaultOptions.base);

            var i,
                actions = ['drag', 'drop', 'resize', 'gesture'],
                methods = ['draggable', 'dropzone', 'resizable', 'gesturable'],
                perActions = extend(extend({}, defaultOptions.perAction), options[action] || {});

            for (i = 0; i < actions.length; i++) {
                var action = actions[i];

                this.options[action] = extend({}, defaultOptions[action]);

                this.setPerAction(action, perActions);

                this[methods[i]](options[action]);
            }

            var settings = [
                'accept', 'actionChecker', 'allowFrom', 'deltaSource',
                'dropChecker', 'ignoreFrom', 'origin', 'preventDefault',
                'rectChecker', 'styleCursor'
            ];

            for (i = 0, len = settings.length; i < len; i++) {
                var setting = settings[i];

                this.options[setting] = defaultOptions.base[setting];

                if (setting in options) {
                    this[setting](options[setting]);
                }
            }

            return this;
        },

        /*\
         * Interactable.unset
         [ method ]
         *
         * Remove this interactable from the list of interactables and remove
         * it's drag, drop, resize and gesture capabilities
         *
         = (object) @interact
        \*/
        unset: function () {
            events.remove(this._element, 'all');

            if (!isString(this.selector)) {
                events.remove(this, 'all');
                if (this.options.styleCursor) {
                    this._element.style.cursor = '';
                }
            }
            else {
                // remove delegated events
                for (var type in delegatedEvents) {
                    var delegated = delegatedEvents[type];

                    for (var i = 0; i < delegated.selectors.length; i++) {
                        if (delegated.selectors[i] === this.selector
                            && delegated.contexts[i] === this._context) {

                            delegated.selectors.splice(i, 1);
                            delegated.contexts.splice(i, 1);
                            delegated.listeners.splice(i, 1);

                            // remove the arrays if they are empty
                            if (!delegated.selectors.length) {
                                delegatedEvents[type] = null;
                            }
                        }

                        events.remove(this._context, type, delegateListener);
                        events.remove(this._context, type, delegateUseCapture, true);

                        break;
                    }
                }
            }

            this.dropzone(false);

            interactables.splice(indexOf(interactables, this), 1);

            return interact;
        }
    };

    function warnOnce(method, message) {
        var warned = false;

        return function () {
            if (!warned) {
                window.console.warn(message);
                warned = true;
            }

            return method.apply(this, arguments);
        };
    }

    Interactable.prototype.snap = warnOnce(Interactable.prototype.snap,
        'Interactable#snap is deprecated. See the new documentation for snapping at https://interactjs.io/docs/snapping');
    Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict,
        'Interactable#restrict is deprecated. See the new documentation for resticting at https://interactjs.io/docs/restriction');
    Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia,
        'Interactable#inertia is deprecated. See the new documentation for inertia at https://interactjs.io/docs/inertia');
    Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll,
        'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at https://interactjs.io/docs/#autoscroll');
    Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize,
        'Interactable#squareResize is deprecated. See https://interactjs.io/docs/#resize-square');

    Interactable.prototype.accept = warnOnce(Interactable.prototype.accept,
        'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');
    Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker,
        'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');
    Interactable.prototype.context = warnOnce(Interactable.prototype.context,
        'Interactable#context as a method is deprecated. It will soon be a DOM Node instead');

    /*\
     * interact.isSet
     [ method ]
     *
     * Check if an element has been set
     - element (Element) The Element being searched for
     = (boolean) Indicates if the element or CSS selector was previously passed to interact
    \*/
    interact.isSet = function (element, options) {
        return interactables.indexOfElement(element, options && options.context) !== -1;
    };

    /*\
     * interact.on
     [ method ]
     *
     * Adds a global listener for an InteractEvent or adds a DOM event to
     * `document`
     *
     - type       (string | array | object) The types of events to listen for
     - listener   (function) The function to be called on the given event(s)
     - useCapture (boolean) #optional useCapture flag for addEventListener
     = (object) interact
    \*/
    interact.on = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.on(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.on(prop, type[prop], listener);
            }

            return interact;
        }

        // if it is an InteractEvent type, add listener to globalEvents
        if (contains(eventTypes, type)) {
            // if this type of event was never bound
            if (!globalEvents[type]) {
                globalEvents[type] = [listener];
            }
            else {
                globalEvents[type].push(listener);
            }
        }
        // If non InteractEvent type, addEventListener to document
        else {
            events.add(document, type, listener, useCapture);
        }

        return interact;
    };

    /*\
     * interact.off
     [ method ]
     *
     * Removes a global InteractEvent listener or DOM event from `document`
     *
     - type       (string | array | object) The types of events that were listened for
     - listener   (function) The listener function to be removed
     - useCapture (boolean) #optional useCapture flag for removeEventListener
     = (object) interact
     \*/
    interact.off = function (type, listener, useCapture) {
        if (isString(type) && type.search(' ') !== -1) {
            type = type.trim().split(/ +/);
        }

        if (isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                interact.off(type[i], listener, useCapture);
            }

            return interact;
        }

        if (isObject(type)) {
            for (var prop in type) {
                interact.off(prop, type[prop], listener);
            }

            return interact;
        }

        if (!contains(eventTypes, type)) {
            events.remove(document, type, listener, useCapture);
        }
        else {
            var index;

            if (type in globalEvents
                && (index = indexOf(globalEvents[type], listener)) !== -1) {
                globalEvents[type].splice(index, 1);
            }
        }

        return interact;
    };

    /*\
     * interact.enableDragging
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether dragging is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableDragging = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.drag = newValue;

            return interact;
        }
        return actionIsEnabled.drag;
    }, 'interact.enableDragging is deprecated and will soon be removed.');

    /*\
     * interact.enableResizing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether resizing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableResizing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.resize = newValue;

            return interact;
        }
        return actionIsEnabled.resize;
    }, 'interact.enableResizing is deprecated and will soon be removed.');

    /*\
     * interact.enableGesturing
     [ method ]
     *
     * Deprecated.
     *
     * Returns or sets whether gesturing is enabled for any Interactables
     *
     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
     = (boolean | object) The current setting or interact
    \*/
    interact.enableGesturing = warnOnce(function (newValue) {
        if (newValue !== null && newValue !== undefined) {
            actionIsEnabled.gesture = newValue;

            return interact;
        }
        return actionIsEnabled.gesture;
    }, 'interact.enableGesturing is deprecated and will soon be removed.');

    interact.eventTypes = eventTypes;

    /*\
     * interact.debug
     [ method ]
     *
     * Returns debugging data
     = (object) An object with properties that outline the current state and expose internal functions and variables
    \*/
    interact.debug = function () {
        var interaction = interactions[0] || new Interaction();

        return {
            interactions: interactions,
            target: interaction.target,
            dragging: interaction.dragging,
            resizing: interaction.resizing,
            gesturing: interaction.gesturing,
            prepared: interaction.prepared,
            matches: interaction.matches,
            matchElements: interaction.matchElements,

            prevCoords: interaction.prevCoords,
            startCoords: interaction.startCoords,

            pointerIds: interaction.pointerIds,
            pointers: interaction.pointers,
            addPointer: listeners.addPointer,
            removePointer: listeners.removePointer,
            recordPointer: listeners.recordPointer,

            snap: interaction.snapStatus,
            restrict: interaction.restrictStatus,
            inertia: interaction.inertiaStatus,

            downTime: interaction.downTimes[0],
            downEvent: interaction.downEvent,
            downPointer: interaction.downPointer,
            prevEvent: interaction.prevEvent,

            Interactable: Interactable,
            interactables: interactables,
            pointerIsDown: interaction.pointerIsDown,
            defaultOptions: defaultOptions,
            defaultActionChecker: defaultActionChecker,

            actionCursors: actionCursors,
            dragMove: listeners.dragMove,
            resizeMove: listeners.resizeMove,
            gestureMove: listeners.gestureMove,
            pointerUp: listeners.pointerUp,
            pointerDown: listeners.pointerDown,
            pointerMove: listeners.pointerMove,
            pointerHover: listeners.pointerHover,

            eventTypes: eventTypes,

            events: events,
            globalEvents: globalEvents,
            delegatedEvents: delegatedEvents,

            prefixedPropREs: prefixedPropREs
        };
    };

    // expose the functions used to calculate multi-touch properties
    interact.getPointerAverage = pointerAverage;
    interact.getTouchBBox = touchBBox;
    interact.getTouchDistance = touchDistance;
    interact.getTouchAngle = touchAngle;

    interact.getElementRect = getElementRect;
    interact.getElementClientRect = getElementClientRect;
    interact.matchesSelector = matchesSelector;
    interact.closest = closest;

    /*\
     * interact.margin
     [ method ]
     *
     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
     * Returns or sets the margin for autocheck resizing used in
     * @Interactable.getAction. That is the distance from the bottom and right
     * edges of an element clicking in which will start resizing
     *
     - newValue (number) #optional
     = (number | interact) The current margin value or interact
    \*/
    interact.margin = warnOnce(function (newvalue) {
        if (isNumber(newvalue)) {
            margin = newvalue;

            return interact;
        }
        return margin;
    },
        'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.');

    /*\
     * interact.supportsTouch
     [ method ]
     *
     = (boolean) Whether or not the browser supports touch input
    \*/
    interact.supportsTouch = function () {
        return supportsTouch;
    };

    /*\
     * interact.supportsPointerEvent
     [ method ]
     *
     = (boolean) Whether or not the browser supports PointerEvents
    \*/
    interact.supportsPointerEvent = function () {
        return supportsPointerEvent;
    };

    /*\
     * interact.stop
     [ method ]
     *
     * Cancels all interactions (end events are not fired)
     *
     - event (Event) An event on which to call preventDefault()
     = (object) interact
    \*/
    interact.stop = function (event) {
        for (var i = interactions.length - 1; i >= 0; i--) {
            interactions[i].stop(event);
        }

        return interact;
    };

    /*\
     * interact.dynamicDrop
     [ method ]
     *
     * Returns or sets whether the dimensions of dropzone elements are
     * calculated on every dragmove or only on dragstart for the default
     * dropChecker
     *
     - newValue (boolean) #optional True to check on each move. False to check only before start
     = (boolean | interact) The current setting or interact
    \*/
    interact.dynamicDrop = function (newValue) {
        if (isBool(newValue)) {
            //if (dragging && dynamicDrop !== newValue && !newValue) {
            //calcRects(dropzones);
            //}

            dynamicDrop = newValue;

            return interact;
        }
        return dynamicDrop;
    };

    /*\
     * interact.pointerMoveTolerance
     [ method ]
     * Returns or sets the distance the pointer must be moved before an action
     * sequence occurs. This also affects tolerance for tap events.
     *
     - newValue (number) #optional The movement from the start position must be greater than this value
     = (number | Interactable) The current setting or interact
    \*/
    interact.pointerMoveTolerance = function (newValue) {
        if (isNumber(newValue)) {
            pointerMoveTolerance = newValue;

            return this;
        }

        return pointerMoveTolerance;
    };

    /*\
     * interact.maxInteractions
     [ method ]
     **
     * Returns or sets the maximum number of concurrent interactions allowed.
     * By default only 1 interaction is allowed at a time (for backwards
     * compatibility). To allow multiple interactions on the same Interactables
     * and elements, you need to enable it in the draggable, resizable and
     * gesturable `'max'` and `'maxPerElement'` options.
     **
     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
    \*/
    interact.maxInteractions = function (newValue) {
        if (isNumber(newValue)) {
            maxInteractions = newValue;

            return this;
        }

        return maxInteractions;
    };

    interact.createSnapGrid = function (grid) {
        return function (x, y) {
            var offsetX = 0,
                offsetY = 0;

            if (isObject(grid.offset)) {
                offsetX = grid.offset.x;
                offsetY = grid.offset.y;
            }

            var gridx = Math.round((x - offsetX) / grid.x),
                gridy = Math.round((y - offsetY) / grid.y),

                newX = gridx * grid.x + offsetX,
                newY = gridy * grid.y + offsetY;

            return {
                x: newX,
                y: newY,
                range: grid.range
            };
        };
    };

    function endAllInteractions(event) {
        for (var i = 0; i < interactions.length; i++) {
            interactions[i].pointerEnd(event, event);
        }
    }

    function listenToDocument(doc) {
        if (contains(documents, doc)) { return; }

        var win = doc.defaultView || doc.parentWindow;

        // add delegate event listener
        for (var eventType in delegatedEvents) {
            events.add(doc, eventType, delegateListener);
            events.add(doc, eventType, delegateUseCapture, true);
        }

        if (supportsPointerEvent) {
            if (PointerEvent === win.MSPointerEvent) {
                pEventTypes = {
                    up: 'MSPointerUp', down: 'MSPointerDown', over: 'mouseover',
                    out: 'mouseout', move: 'MSPointerMove', cancel: 'MSPointerCancel'
                };
            }
            else {
                pEventTypes = {
                    up: 'pointerup', down: 'pointerdown', over: 'pointerover',
                    out: 'pointerout', move: 'pointermove', cancel: 'pointercancel'
                };
            }

            events.add(doc, pEventTypes.down, listeners.selectorDown);
            events.add(doc, pEventTypes.move, listeners.pointerMove);
            events.add(doc, pEventTypes.over, listeners.pointerOver);
            events.add(doc, pEventTypes.out, listeners.pointerOut);
            events.add(doc, pEventTypes.up, listeners.pointerUp);
            events.add(doc, pEventTypes.cancel, listeners.pointerCancel);

            // autoscroll
            events.add(doc, pEventTypes.move, listeners.autoScrollMove);
        }
        else {
            events.add(doc, 'mousedown', listeners.selectorDown);
            events.add(doc, 'mousemove', listeners.pointerMove);
            events.add(doc, 'mouseup', listeners.pointerUp);
            events.add(doc, 'mouseover', listeners.pointerOver);
            events.add(doc, 'mouseout', listeners.pointerOut);

            events.add(doc, 'touchstart', listeners.selectorDown);
            events.add(doc, 'touchmove', listeners.pointerMove);
            events.add(doc, 'touchend', listeners.pointerUp);
            events.add(doc, 'touchcancel', listeners.pointerCancel);

            // autoscroll
            events.add(doc, 'mousemove', listeners.autoScrollMove);
            events.add(doc, 'touchmove', listeners.autoScrollMove);
        }

        events.add(win, 'blur', endAllInteractions);

        try {
            if (win.frameElement) {
                var parentDoc = win.frameElement.ownerDocument,
                    parentWindow = parentDoc.defaultView;

                events.add(parentDoc, 'mouseup', listeners.pointerEnd);
                events.add(parentDoc, 'touchend', listeners.pointerEnd);
                events.add(parentDoc, 'touchcancel', listeners.pointerEnd);
                events.add(parentDoc, 'pointerup', listeners.pointerEnd);
                events.add(parentDoc, 'MSPointerUp', listeners.pointerEnd);
                events.add(parentWindow, 'blur', endAllInteractions);
            }
        }
        catch (error) {
            interact.windowParentError = error;
        }

        // prevent native HTML5 drag on interact.js target elements
        events.add(doc, 'dragstart', function (event) {
            for (var i = 0; i < interactions.length; i++) {
                var interaction = interactions[i];

                if (interaction.element
                    && (interaction.element === event.target
                        || nodeContains(interaction.element, event.target))) {

                    interaction.checkAndPreventDefault(event, interaction.target, interaction.element);
                    return;
                }
            }
        });

        if (events.useAttachEvent) {
            // For IE's lack of Event#preventDefault
            events.add(doc, 'selectstart', function (event) {
                var interaction = interactions[0];

                if (interaction.currentAction()) {
                    interaction.checkAndPreventDefault(event);
                }
            });

            // For IE's bad dblclick event sequence
            events.add(doc, 'dblclick', doOnInteractions('ie8Dblclick'));
        }

        documents.push(doc);
    }

    listenToDocument(document);

    function indexOf(array, target) {
        for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === target) {
                return i;
            }
        }

        return -1;
    }

    function contains(array, target) {
        return indexOf(array, target) !== -1;
    }

    function matchesSelector(element, selector, nodeList) {
        if (ie8MatchesSelector) {
            return ie8MatchesSelector(element, selector, nodeList);
        }

        // remove /deep/ from selectors if shadowDOM polyfill is used
        if (window !== realWindow) {
            selector = selector.replace(/\/deep\//g, ' ');
        }

        return element[prefixedMatchesSelector](selector);
    }

    function matchesUpTo(element, selector, limit) {
        while (isElement(element)) {
            if (matchesSelector(element, selector)) {
                return true;
            }

            element = parentElement(element);

            if (element === limit) {
                return matchesSelector(element, selector);
            }
        }

        return false;
    }

    // For IE8's lack of an Element#matchesSelector
    // taken from https://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
    if (!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])) {
        ie8MatchesSelector = function (element, selector, elems) {
            elems = elems || element.parentNode.querySelectorAll(selector);

            for (var i = 0, len = elems.length; i < len; i++) {
                if (elems[i] === element) {
                    return true;
                }
            }

            return false;
        };
    }

    // requestAnimationFrame polyfill
    (function () {
        var lastTime = 0,
            vendors = ['ms', 'moz', 'webkit', 'o'];

        for (var x = 0; x < vendors.length && !realWindow.requestAnimationFrame; ++x) {
            reqFrame = realWindow[vendors[x] + 'RequestAnimationFrame'];
            cancelFrame = realWindow[vendors[x] + 'CancelAnimationFrame'] || realWindow[vendors[x] + 'CancelRequestAnimationFrame'];
        }

        if (!reqFrame) {
            reqFrame = function (callback) {
                var currTime = new Date().getTime(),
                    timeToCall = Math.max(0, 16 - (currTime - lastTime)),
                    id = setTimeout(function () { callback(currTime + timeToCall); },
                        timeToCall);
                lastTime = currTime + timeToCall;
                return id;
            };
        }

        if (!cancelFrame) {
            cancelFrame = function (id) {
                clearTimeout(id);
            };
        }
    }());

    /* global exports: true, module, define */

    // https://documentcloud.github.io/underscore/docs/underscore.html#section-11
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = interact;
        }
        exports.interact = interact;
    }
    // AMD
    else if (typeof define === 'function' && define.amd) {
        define('interact', function () {
            return interact;
        });
    }
    else {
        realWindow.interact = interact;
    }

}(typeof window === 'undefined' ? undefined : window));
angular.module('colorpicker.module', [])
    .factory('Helper', function () {
        'use strict';
        return {
            closestSlider: function (elem) {
                var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
                if (matchesSelector.bind(elem)('I')) {
                    return elem.parentNode;
                }
                return elem;
            },
            getOffset: function (elem, fixedPosition) {
                var
                  scrollX = 0,
                  scrollY = 0,
                  rect = elem.getBoundingClientRect();
                while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
                    if (!fixedPosition && elem.tagName === 'BODY') {
                        scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
                        scrollY += document.documentElement.scrollTop || elem.scrollTop;
                    } else {
                        scrollX += elem.scrollLeft;
                        scrollY += elem.scrollTop;
                    }
                    elem = elem.offsetParent;
                }
                return {
                    top: rect.top + window.pageYOffset,
                    left: rect.left + window.pageXOffset,
                    scrollX: scrollX,
                    scrollY: scrollY
                };
            },
            // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
            stringParsers: [
              {
                  re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        execResult[1],
                        execResult[2],
                        execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                  parse: function (execResult) {
                      return [
                        2.55 * execResult[1],
                        2.55 * execResult[2],
                        2.55 * execResult[3],
                        execResult[4]
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1], 16),
                        parseInt(execResult[2], 16),
                        parseInt(execResult[3], 16)
                      ];
                  }
              },
              {
                  re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
                  parse: function (execResult) {
                      return [
                        parseInt(execResult[1] + execResult[1], 16),
                        parseInt(execResult[2] + execResult[2], 16),
                        parseInt(execResult[3] + execResult[3], 16)
                      ];
                  }
              }
            ]
        };
    })
    .factory('Color', ['Helper', function (Helper) {
        'use strict';
        return {
            value: {
                h: 1,
                s: 1,
                b: 1,
                a: 1
            },
            // translate a format from Color object to a string
            'rgb': function () {
                var rgb = this.toRGB();
                return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
            },
            'rgba': function () {
                var rgb = this.toRGB();
                return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
            },
            'hex': function () {
                return this.toHex();
            },

            // HSBtoRGB from RaphaelJS
            RGBtoHSB: function (r, g, b, a) {
                r /= 255;
                g /= 255;
                b /= 255;

                var H, S, V, C;
                V = Math.max(r, g, b);
                C = V - Math.min(r, g, b);
                H = (C === 0 ? null :
                    V === r ? (g - b) / C :
                        V === g ? (b - r) / C + 2 :
                            (r - g) / C + 4
                    );
                H = ((H + 360) % 6) * 60 / 360;
                S = C === 0 ? 0 : C / V;
                return { h: H || 1, s: S, b: V, a: a || 1 };
            },

            //parse a string to HSB
            setColor: function (val) {
                val = (val) ? val.toLowerCase() : val;
                for (var key in Helper.stringParsers) {
                    if (Helper.stringParsers.hasOwnProperty(key)) {
                        var parser = Helper.stringParsers[key];
                        var match = parser.re.exec(val),
                            values = match && parser.parse(match);
                        if (values) {
                            this.value = this.RGBtoHSB.apply(null, values);
                            return false;
                        }
                    }
                }
            },

            setHue: function (h) {
                this.value.h = 1 - h;
            },

            setSaturation: function (s) {
                this.value.s = s;
            },

            setLightness: function (b) {
                this.value.b = 1 - b;
            },

            setAlpha: function (a) {
                this.value.a = parseInt((1 - a) * 100, 10) / 100;
            },

            // HSBtoRGB from RaphaelJS
            // https://github.com/DmitryBaranovskiy/raphael/
            toRGB: function (h, s, b, a) {
                if (!h) {
                    h = this.value.h;
                    s = this.value.s;
                    b = this.value.b;
                }
                h *= 360;
                var R, G, B, X, C;
                h = (h % 360) / 60;
                C = b * s;
                X = C * (1 - Math.abs(h % 2 - 1));
                R = G = B = b - C;

                h = ~~h;
                R += [C, X, 0, 0, X, C][h];
                G += [X, C, C, X, 0, 0][h];
                B += [0, 0, X, C, C, X][h];
                return {
                    r: Math.round(R * 255),
                    g: Math.round(G * 255),
                    b: Math.round(B * 255),
                    a: a || this.value.a
                };
            },

            toHex: function (h, s, b, a) {
                var rgb = this.toRGB(h, s, b, a);
                return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
            }
        };
    }])
    .factory('Slider', ['Helper', function (Helper) {
        'use strict';
        var
            slider = {
                maxLeft: 0,
                maxTop: 0,
                callLeft: null,
                callTop: null,
                knob: {
                    top: 0,
                    left: 0
                }
            },
            pointer = {};

        return {
            getSlider: function () {
                return slider;
            },
            getLeftPosition: function (event) {
                return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
            },
            getTopPosition: function (event) {
                return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
            },
            setSlider: function (event, fixedPosition) {
                var
                  target = Helper.closestSlider(event.target),
                  targetOffset = Helper.getOffset(target, fixedPosition),
                  rect = target.getBoundingClientRect(),
                  offsetX = event.clientX - rect.left,
                  offsetY = event.clientY - rect.top;

                slider.knob = target.children[0].style;
                slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
                slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;

                pointer = {
                    left: event.pageX - (offsetX - slider.left),
                    top: event.pageY - (offsetY - slider.top)
                };
            },
            setSaturation: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: componentSize,
                    maxTop: componentSize,
                    callLeft: 'setSaturation',
                    callTop: 'setLightness'
                };
                this.setSlider(event, fixedPosition);
            },
            setHue: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setHue'
                };
                this.setSlider(event, fixedPosition);
            },
            setAlpha: function (event, fixedPosition, componentSize) {
                slider = {
                    maxLeft: 0,
                    maxTop: componentSize,
                    callLeft: false,
                    callTop: 'setAlpha'
                };
                this.setSlider(event, fixedPosition);
            },
            setKnob: function (top, left) {
                slider.knob.top = top + 'px';
                slider.knob.left = left + 'px';
            }
        };
    }])
    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
        'use strict';
        return {
            require: '?ngModel',
            restrict: 'A',
            link: function ($scope, elem, attrs, ngModel) {
                var
                    thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
                    position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
                    inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
                    fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
                    target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
                    withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
                    componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
                    componentSizePx = componentSize + 'px',
                    inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
                    closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
                    template =
                        '<div class="colorpicker dropdown">' +
                            '<div class="dropdown-menu">' +
                            '<colorpicker-saturation><i></i></colorpicker-saturation>' +
                            '<colorpicker-hue><i></i></colorpicker-hue>' +
                            '<colorpicker-alpha><i></i></colorpicker-alpha>' +
                            '<colorpicker-preview></colorpicker-preview>' +
                            inputTemplate +
                            closeButton +
                            '</div>' +
                            '</div>',
                    colorpickerTemplate = angular.element(template),
                    pickerColor = Color,
                    colorpickerValue = {
                        h: 1,
                        s: 0,
                        b: 1,
                        a: 1
                    },
                    sliderAlpha,
                    sliderHue = colorpickerTemplate.find('colorpicker-hue'),
                    sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
                    colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
                    pickerColorPointers = colorpickerTemplate.find('i'),
                    componentWidthWithToolbars = parseInt(componentSize) + 29 + (thisFormat === 'rgba' ? 15 : 0),
                    componentHeightWithToolbars = parseInt(componentSize) + 55;

                $compile(colorpickerTemplate)($scope);
                colorpickerTemplate.css('min-width', componentWidthWithToolbars + 'px');
                sliderSaturation.css({
                    'width': componentSizePx,
                    'height': componentSizePx
                });
                sliderHue.css('height', componentSizePx);

                if (withInput) {
                    var pickerColorInput = colorpickerTemplate.find('input');
                    pickerColorInput.css('width', componentSizePx);
                    pickerColorInput
                        .on('mousedown', function (event) {
                            event.stopPropagation();
                        })
                      .on('keyup', function () {
                          var newColor = this.value;
                          elem.val(newColor);
                          if (ngModel && ngModel.$modelValue !== newColor) {
                              $scope.$apply(ngModel.$setViewValue(newColor));
                              update(true);
                          }
                      });
                }

                function bindMouseEvents() {
                    $document.on('mousemove', mousemove);
                    $document.on('mouseup', mouseup);
                }

                if (thisFormat === 'rgba') {
                    colorpickerTemplate.addClass('alpha');
                    sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
                    sliderAlpha.css('height', componentSizePx);
                    sliderAlpha
                        .on('click', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            mousemove(event);
                        })
                        .on('mousedown', function (event) {
                            Slider.setAlpha(event, fixedPosition, componentSize);
                            bindMouseEvents();
                        })
                        .on('mouseup', function (event) {
                            emitEvent('colorpicker-selected-alpha');
                        });
                }

                sliderHue
                    .on('click', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        mousemove(event);
                    })
                    .on('mousedown', function (event) {
                        Slider.setHue(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-hue');
                    });

                sliderSaturation
                    .on('click', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        mousemove(event);
                        if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
                            hideColorpickerTemplate();
                        }
                    })
                    .on('mousedown', function (event) {
                        Slider.setSaturation(event, fixedPosition, componentSize);
                        bindMouseEvents();
                    })
                    .on('mouseup', function (event) {
                        emitEvent('colorpicker-selected-saturation');
                    });

                if (fixedPosition) {
                    colorpickerTemplate.addClass('colorpicker-fixed-position');
                }

                colorpickerTemplate.addClass('colorpicker-position-' + position);
                if (inline === 'true') {
                    colorpickerTemplate.addClass('colorpicker-inline');
                }

                target.append(colorpickerTemplate);

                if (ngModel) {
                    ngModel.$render = function () {
                        elem.val(ngModel.$viewValue);

                        update();
                    };
                }

                elem.on('blur keyup change', function () {
                    update();
                });

                elem.on('$destroy', function () {
                    colorpickerTemplate.remove();
                });

                function previewColor() {
                    try {
                        colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
                    } catch (e) {
                        colorpickerPreview.css('backgroundColor', pickerColor.toHex());
                    }
                    sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
                    if (thisFormat === 'rgba') {
                        sliderAlpha.css.backgroundColor = pickerColor.toHex();
                    }
                }

                function mousemove(event) {
                    var
                        left = Slider.getLeftPosition(event),
                        top = Slider.getTopPosition(event),
                        slider = Slider.getSlider();

                    Slider.setKnob(top, left);

                    if (slider.callLeft) {
                        pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
                    }
                    if (slider.callTop) {
                        pickerColor[slider.callTop].call(pickerColor, top / componentSize);
                    }
                    previewColor();
                    var newColor = pickerColor[thisFormat]();
                    elem.val(newColor);
                    if (ngModel) {
                        $scope.$apply(ngModel.$setViewValue(newColor));
                    }
                    if (withInput) {
                        pickerColorInput.val(newColor);
                    }
                    return false;
                }

                function mouseup() {
                    emitEvent('colorpicker-selected');
                    $document.off('mousemove', mousemove);
                    $document.off('mouseup', mouseup);
                }

                function update(omitInnerInput) {
                    pickerColor.value = colorpickerValue;
                    pickerColor.setColor(elem.val());
                    if (withInput && !omitInnerInput) {
                        pickerColorInput.val(elem.val());
                    }
                    pickerColorPointers.eq(0).css({
                        left: pickerColor.value.s * componentSize + 'px',
                        top: componentSize - pickerColor.value.b * componentSize + 'px'
                    });
                    pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
                    pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
                    colorpickerValue = pickerColor.value;
                    previewColor();
                }

                function getColorpickerTemplatePosition() {
                    var
                        positionValue,
                        positionOffset = Helper.getOffset(elem[0]),
                        additionalSpaceBetweenElements = 2;

                    if (angular.isDefined(attrs.colorpickerParent)) {
                        positionOffset.left = 0;
                        positionOffset.top = 0;
                    }

                    if (position === 'top') {
                        positionValue = {
                            'top': positionOffset.top - componentHeightWithToolbars - additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'right') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left + elem[0].offsetWidth + additionalSpaceBetweenElements
                        };
                    } else if (position === 'bottom') {
                        positionValue = {
                            'top': positionOffset.top + elem[0].offsetHeight + additionalSpaceBetweenElements,
                            'left': positionOffset.left
                        };
                    } else if (position === 'left') {
                        positionValue = {
                            'top': positionOffset.top,
                            'left': positionOffset.left - componentWidthWithToolbars - additionalSpaceBetweenElements
                        };
                    }
                    return {
                        'top': positionValue.top + 'px',
                        'left': positionValue.left + 'px'
                    };
                }

                function documentMousedownHandler() {
                    hideColorpickerTemplate();
                }

                function showColorpickerTemplate() {

                    if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
                        update();
                        colorpickerTemplate
                          .addClass('colorpicker-visible')
                          .css(getColorpickerTemplatePosition());
                        emitEvent('colorpicker-shown');

                        if (inline === false) {
                            // register global mousedown event to hide the colorpicker
                            $document.on('mousedown', documentMousedownHandler);
                        }

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = true;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                if (inline === false) {
                    elem.on('click', showColorpickerTemplate);
                } else {
                    showColorpickerTemplate();
                }

                colorpickerTemplate.on('mousedown', function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                });

                function emitEvent(name) {
                    if (ngModel) {
                        $scope.$emit(name, {
                            name: attrs.ngModel,
                            value: ngModel.$modelValue
                        });
                    }
                }

                function hideColorpickerTemplate() {
                    if (colorpickerTemplate.hasClass('colorpicker-visible')) {
                        colorpickerTemplate.removeClass('colorpicker-visible');
                        emitEvent('colorpicker-closed');
                        // unregister the global mousedown event
                        $document.off('mousedown', documentMousedownHandler);

                        if (attrs.colorpickerIsOpen) {
                            $scope[attrs.colorpickerIsOpen] = false;
                            if (!$scope.$$phase || !$scope.$root.$$phase) {
                                $scope.$digest(); //trigger the watcher to fire
                            }
                        }
                    }
                }

                colorpickerTemplate.find('button').on('click', function () {
                    hideColorpickerTemplate();
                });

                if (attrs.colorpickerIsOpen) {
                    $scope.$watch(attrs.colorpickerIsOpen, function (shouldBeOpen) {

                        if (shouldBeOpen === true) {
                            showColorpickerTemplate();
                        } else if (shouldBeOpen === false) {
                            hideColorpickerTemplate();
                        }

                    });
                }
            }
        };
    }]);
/**
 * angular-bootstrap-calendar - A pure AngularJS bootstrap themed responsive calendar that can display events and has views for year, month, week and day
 * @version v0.29.3
 * @link https://github.com/mattlewis92/angular-bootstrap-calendar
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else if (typeof define === 'function' && define.amd)
        define(["angular", "moment", "interact"], factory);
    else if (typeof exports === 'object')
        exports["angularBootstrapCalendarModuleName"] = factory(require("angular"), require("moment"), (function webpackLoadOptionalExternalModule() { try { return require("interactjs"); } catch (e) { } }()));
    else
        root["angularBootstrapCalendarModuleName"] = factory(root["angular"], root["moment"], root["interact"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_71__, __WEBPACK_EXTERNAL_MODULE_72__) {
    return /******/ (function (modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};
        /******/
        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {
            /******/
            /******/ 		// Check if module is in cache
            /******/ 		if (installedModules[moduleId]) {
                /******/ 			return installedModules[moduleId].exports;
                /******/
            }
            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/
            };
            /******/
            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;
            /******/
            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/
        }
        /******/
        /******/
        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;
        /******/
        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;
        /******/
        /******/ 	// identity function for calling harmony imports with the correct context
        /******/ 	__webpack_require__.i = function (value) { return value; };
        /******/
        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function (exports, name, getter) {
            /******/ 		if (!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, {
                    /******/ 				configurable: false,
                    /******/ 				enumerable: true,
                    /******/ 				get: getter
            /******/
        });
                /******/
            }
            /******/
        };
        /******/
        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function (module) {
            /******/ 		var getter = module && module.__esModule ?
            /******/ 			function getDefault() { return module['default']; } :
            /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/
        };
        /******/
        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";
        /******/
        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 60);
        /******/
    })
    /************************************************************************/
    /******/([
    /* 0 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

            /***/
        }),
    /* 1 */
    /***/ (function (module, exports, __webpack_require__) {

            var isDate = __webpack_require__(24)

            var MILLISECONDS_IN_HOUR = 3600000
            var MILLISECONDS_IN_MINUTE = 60000
            var DEFAULT_ADDITIONAL_DIGITS = 2

            var parseTokenDateTimeDelimeter = /[T ]/
            var parseTokenPlainTime = /:/

            // year tokens
            var parseTokenYY = /^(\d{2})$/
            var parseTokensYYY = [
                /^([+-]\d{2})$/, // 0 additional digits
                /^([+-]\d{3})$/, // 1 additional digit
                /^([+-]\d{4})$/ // 2 additional digits
            ]

            var parseTokenYYYY = /^(\d{4})/
            var parseTokensYYYYY = [
                /^([+-]\d{4})/, // 0 additional digits
                /^([+-]\d{5})/, // 1 additional digit
                /^([+-]\d{6})/ // 2 additional digits
            ]

            // date tokens
            var parseTokenMM = /^-(\d{2})$/
            var parseTokenDDD = /^-?(\d{3})$/
            var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
            var parseTokenWww = /^-?W(\d{2})$/
            var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

            // time tokens
            var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
            var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
            var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

            // timezone tokens
            var parseTokenTimezone = /([Z+-].*)$/
            var parseTokenTimezoneZ = /^(Z)$/
            var parseTokenTimezoneHH = /^([+-])(\d{2})$/
            var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

            /**
             * @category Common Helpers
             * @summary Convert the given argument to an instance of Date.
             *
             * @description
             * Convert the given argument to an instance of Date.
             *
             * If the argument is an instance of Date, the function returns its clone.
             *
             * If the argument is a number, it is treated as a timestamp.
             *
             * If an argument is a string, the function tries to parse it.
             * Function accepts complete ISO 8601 formats as well as partial implementations.
             * ISO 8601: https://en.wikipedia.org/wiki/ISO_8601
             *
             * If all above fails, the function passes the given argument to Date constructor.
             *
             * @param {Date|String|Number} argument - the value to convert
             * @param {Object} [options] - the object with options
             * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
             * @returns {Date} the parsed date in the local time zone
             *
             * @example
             * // Convert string '2014-02-11T11:30:30' to date:
             * var result = parse('2014-02-11T11:30:30')
             * //=> Tue Feb 11 2014 11:30:30
             *
             * @example
             * // Parse string '+02014101',
             * // if the additional number of digits in the extended year format is 1:
             * var result = parse('+02014101', {additionalDigits: 1})
             * //=> Fri Apr 11 2014 00:00:00
             */
            function parse(argument, dirtyOptions) {
                if (isDate(argument)) {
                    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
                    return new Date(argument.getTime())
                } else if (typeof argument !== 'string') {
                    return new Date(argument)
                }

                var options = dirtyOptions || {}
                var additionalDigits = options.additionalDigits
                if (additionalDigits == null) {
                    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
                } else {
                    additionalDigits = Number(additionalDigits)
                }

                var dateStrings = splitDateString(argument)

                var parseYearResult = parseYear(dateStrings.date, additionalDigits)
                var year = parseYearResult.year
                var restDateString = parseYearResult.restDateString

                var date = parseDate(restDateString, year)

                if (date) {
                    var timestamp = date.getTime()
                    var time = 0
                    var offset

                    if (dateStrings.time) {
                        time = parseTime(dateStrings.time)
                    }

                    if (dateStrings.timezone) {
                        offset = parseTimezone(dateStrings.timezone)
                    } else {
                        // get offset accurate to hour in timezones that change offset
                        offset = new Date(timestamp + time).getTimezoneOffset()
                        offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
                    }

                    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
                } else {
                    return new Date(argument)
                }
            }

            function splitDateString(dateString) {
                var dateStrings = {}
                var array = dateString.split(parseTokenDateTimeDelimeter)
                var timeString

                if (parseTokenPlainTime.test(array[0])) {
                    dateStrings.date = null
                    timeString = array[0]
                } else {
                    dateStrings.date = array[0]
                    timeString = array[1]
                }

                if (timeString) {
                    var token = parseTokenTimezone.exec(timeString)
                    if (token) {
                        dateStrings.time = timeString.replace(token[1], '')
                        dateStrings.timezone = token[1]
                    } else {
                        dateStrings.time = timeString
                    }
                }

                return dateStrings
            }

            function parseYear(dateString, additionalDigits) {
                var parseTokenYYY = parseTokensYYY[additionalDigits]
                var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

                var token

                // YYYY or Â±YYYYY
                token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
                if (token) {
                    var yearString = token[1]
                    return {
                        year: parseInt(yearString, 10),
                        restDateString: dateString.slice(yearString.length)
                    }
                }

                // YY or Â±YYY
                token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
                if (token) {
                    var centuryString = token[1]
                    return {
                        year: parseInt(centuryString, 10) * 100,
                        restDateString: dateString.slice(centuryString.length)
                    }
                }

                // Invalid ISO-formatted year
                return {
                    year: null
                }
            }

            function parseDate(dateString, year) {
                // Invalid ISO-formatted year
                if (year === null) {
                    return null
                }

                var token
                var date
                var month
                var week

                // YYYY
                if (dateString.length === 0) {
                    date = new Date(0)
                    date.setUTCFullYear(year)
                    return date
                }

                // YYYY-MM
                token = parseTokenMM.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    date.setUTCFullYear(year, month)
                    return date
                }

                // YYYY-DDD or YYYYDDD
                token = parseTokenDDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    var dayOfYear = parseInt(token[1], 10)
                    date.setUTCFullYear(year, 0, dayOfYear)
                    return date
                }

                // YYYY-MM-DD or YYYYMMDD
                token = parseTokenMMDD.exec(dateString)
                if (token) {
                    date = new Date(0)
                    month = parseInt(token[1], 10) - 1
                    var day = parseInt(token[2], 10)
                    date.setUTCFullYear(year, month, day)
                    return date
                }

                // YYYY-Www or YYYYWww
                token = parseTokenWww.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    return dayOfISOYear(year, week)
                }

                // YYYY-Www-D or YYYYWwwD
                token = parseTokenWwwD.exec(dateString)
                if (token) {
                    week = parseInt(token[1], 10) - 1
                    var dayOfWeek = parseInt(token[2], 10) - 1
                    return dayOfISOYear(year, week, dayOfWeek)
                }

                // Invalid ISO-formatted date
                return null
            }

            function parseTime(timeString) {
                var token
                var hours
                var minutes

                // hh
                token = parseTokenHH.exec(timeString)
                if (token) {
                    hours = parseFloat(token[1].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR
                }

                // hh:mm or hhmm
                token = parseTokenHHMM.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseFloat(token[2].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE
                }

                // hh:mm:ss or hhmmss
                token = parseTokenHHMMSS.exec(timeString)
                if (token) {
                    hours = parseInt(token[1], 10)
                    minutes = parseInt(token[2], 10)
                    var seconds = parseFloat(token[3].replace(',', '.'))
                    return (hours % 24) * MILLISECONDS_IN_HOUR +
                        minutes * MILLISECONDS_IN_MINUTE +
                        seconds * 1000
                }

                // Invalid ISO-formatted time
                return null
            }

            function parseTimezone(timezoneString) {
                var token
                var absoluteOffset

                // Z
                token = parseTokenTimezoneZ.exec(timezoneString)
                if (token) {
                    return 0
                }

                // Â±hh
                token = parseTokenTimezoneHH.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                // Â±hh:mm or Â±hhmm
                token = parseTokenTimezoneHHMM.exec(timezoneString)
                if (token) {
                    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
                    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
                }

                return 0
            }

            function dayOfISOYear(isoYear, week, day) {
                week = week || 0
                day = day || 0
                var date = new Date(0)
                date.setUTCFullYear(isoYear, 0, 4)
                var fourthOfJanuaryDay = date.getUTCDay() || 7
                var diff = week * 7 + day + 1 - fourthOfJanuaryDay
                date.setUTCDate(date.getUTCDate() + diff)
                return date
            }

            module.exports = parse


            /***/
        }),
    /* 2 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Add the specified number of milliseconds to the given date.
             *
             * @description
             * Add the specified number of milliseconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of milliseconds to be added
             * @returns {Date} the new date with the milliseconds added
             *
             * @example
             * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
             * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
             * //=> Thu Jul 10 2014 12:45:30.750
             */
            function addMilliseconds(dirtyDate, dirtyAmount) {
                var timestamp = parse(dirtyDate).getTime()
                var amount = Number(dirtyAmount)
                return new Date(timestamp + amount)
            }

            module.exports = addMilliseconds


            /***/
        }),
    /* 3 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the start of a day for the given date.
             *
             * @description
             * Return the start of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a day
             *
             * @example
             * // The start of a day for 2 September 2014 11:55:00:
             * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 00:00:00
             */
            function startOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfDay


            /***/
        }),
    /* 4 */
    /***/ (function (module, __webpack_exports__, __webpack_require__) {

            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__ = __webpack_require__(20);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__ = __webpack_require__(13);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__ = __webpack_require__(17);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__ = __webpack_require__(3);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__ = __webpack_require__(25);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__ = __webpack_require__(23);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__ = __webpack_require__(35);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__ = __webpack_require__(11);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_add_days__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__ = __webpack_require__(22);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__ = __webpack_require__(19);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__ = __webpack_require__(33);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__ = __webpack_require__(21);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__ = __webpack_require__(26);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__ = __webpack_require__(27);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__ = __webpack_require__(30);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__ = __webpack_require__(31);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__ = __webpack_require__(32);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__ = __webpack_require__(18);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__ = __webpack_require__(12);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__ = __webpack_require__(14);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min__ = __webpack_require__(29);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_date_fns_min__);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max__ = __webpack_require__(28);
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_date_fns_max__);
        /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDS_IN_DAY", function () { return SECONDS_IN_DAY; });
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewEventOffset"] = getWeekViewEventOffset;
        /* harmony export (immutable) */ __webpack_exports__["getWeekViewHeader"] = getWeekViewHeader;
        /* harmony export (immutable) */ __webpack_exports__["getWeekView"] = getWeekView;
        /* harmony export (immutable) */ __webpack_exports__["getMonthView"] = getMonthView;
        /* harmony export (immutable) */ __webpack_exports__["getDayView"] = getDayView;
        /* harmony export (immutable) */ __webpack_exports__["getDayViewHourGrid"] = getDayViewHourGrid;






















            var WEEKEND_DAY_NUMBERS = [0, 6];
            var DAYS_IN_WEEK = 7;
            var HOURS_IN_DAY = 24;
            var MINUTES_IN_HOUR = 60;
            var SECONDS_IN_DAY = 60 * 60 * 24;
            function getExcludedSeconds(_a) {
                var startDate = _a.startDate, seconds = _a.seconds, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b;
                if (excluded.length < 1) {
                    return 0;
                }
                var result = 0; // Calculated in seconds
                var endDate;
                var dayStart;
                var dayEnd;
                switch (precision) {
                    case 'minutes':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(startDate, seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(startDate);
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endDate, 0));
                        excluded.forEach(function (excludedDay) {
                            if (excludedDay === dayStart) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(startDate), startDate) + 1;
                            }
                            else if (excludedDay === dayEnd) {
                                result += __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(endDate, __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endDate)) + 1;
                            }
                            else if (excludedDay > dayStart && excludedDay < dayEnd) {
                                result += SECONDS_IN_DAY;
                            }
                        });
                        break;
                    case 'days':
                        endDate = __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate), seconds - 1);
                        dayStart = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startDate));
                        dayEnd = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(endDate);
                        result += excluded.filter(function (excludedDay) { return excludedDay >= dayStart && excludedDay <= dayEnd; }).length * SECONDS_IN_DAY;
                        break;
                }
                return result;
            }
            function getWeekViewEventSpan(_a) {
                var event = _a.event, offset = _a.offset, startOfWeekDate = _a.startOfWeekDate, excluded = _a.excluded, _b = _a.precision, precision = _b === void 0 ? 'days' : _b, weekStartsOn = _a.weekStartsOn;
                offset = Math.round(offset * SECONDS_IN_DAY);
                var span = SECONDS_IN_DAY;
                var begin = __WEBPACK_IMPORTED_MODULE_21_date_fns_max___default()(event.start, startOfWeekDate);
                var endOfWeekDate = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(startOfWeekDate, { weekStartsOn: weekStartsOn });
                if (event.end) {
                    switch (precision) {
                        case 'days':
                            span = (__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.end), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(endOfWeekDate)), __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(begin)) + 1) * SECONDS_IN_DAY;
                            break;
                        case 'minutes':
                            span = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(__WEBPACK_IMPORTED_MODULE_20_date_fns_min___default()(event.end, __WEBPACK_IMPORTED_MODULE_19_date_fns_add_seconds___default()(endOfWeekDate, 1)), begin);
                            break;
                    }
                }
                span -= getExcludedSeconds({ startDate: begin, seconds: span, excluded: excluded, precision: precision });
                return span / SECONDS_IN_DAY;
            }
            function getWeekViewEventOffset(_a) {
                var event = _a.event, startOfWeek = _a.startOfWeek, _b = _a.excluded, excluded = _b === void 0 ? [] : _b, _c = _a.precision, precision = _c === void 0 ? 'days' : _c;
                if (event.start < startOfWeek) {
                    return 0;
                }
                var offset;
                switch (precision) {
                    case 'days':
                        offset = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(event.start), startOfWeek) * SECONDS_IN_DAY;
                        break;
                    case 'minutes':
                        offset = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(event.start, startOfWeek);
                        break;
                }
                offset -= getExcludedSeconds({ startDate: startOfWeek, seconds: offset, excluded: excluded, precision: precision });
                return offset / SECONDS_IN_DAY;
            }
            function isEventIsPeriod(_a) {
                var event = _a.event, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                var eventStart = event.start;
                var eventEnd = event.end || event.start;
                if (eventStart > periodStart && eventStart < periodEnd) {
                    return true;
                }
                if (eventEnd > periodStart && eventEnd < periodEnd) {
                    return true;
                }
                if (eventStart < periodStart && eventEnd > periodEnd) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventStart, periodEnd)) {
                    return true;
                }
                if (__WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodStart) || __WEBPACK_IMPORTED_MODULE_13_date_fns_is_same_second___default()(eventEnd, periodEnd)) {
                    return true;
                }
                return false;
            }
            function getEventsInPeriod(_a) {
                var events = _a.events, periodStart = _a.periodStart, periodEnd = _a.periodEnd;
                return events.filter(function (event) { return isEventIsPeriod({ event: event, periodStart: periodStart, periodEnd: periodEnd }); });
            }
            function getWeekDay(_a) {
                var date = _a.date;
                var today = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(new Date());
                return {
                    date: date,
                    isPast: date < today,
                    isToday: __WEBPACK_IMPORTED_MODULE_4_date_fns_is_same_day___default()(date, today),
                    isFuture: date > today,
                    isWeekend: WEEKEND_DAY_NUMBERS.indexOf(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_day___default()(date)) > -1
                };
            }
            function getWeekViewHeader(_a) {
                var viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _b = _a.excluded, excluded = _b === void 0 ? [] : _b;
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var days = [];
                var _loop_1 = function (i) {
                    var date = __WEBPACK_IMPORTED_MODULE_7_date_fns_add_days___default()(start, i);
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        days.push(getWeekDay({ date: date }));
                    }
                };
                for (var i = 0; i < DAYS_IN_WEEK; i++) {
                    _loop_1(i);
                }
                return days;
            }
            function getWeekView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.precision, precision = _d === void 0 ? 'days' : _d, _e = _a.absolutePositionedEvents, absolutePositionedEvents = _e === void 0 ? false : _e;
                if (!events) {
                    events = [];
                }
                var startOfViewWeek = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var endOfViewWeek = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewDate, { weekStartsOn: weekStartsOn });
                var maxRange = DAYS_IN_WEEK - excluded.length;
                var eventsMapped = getEventsInPeriod({ events: events, periodStart: startOfViewWeek, periodEnd: endOfViewWeek }).map(function (event) {
                    var offset = getWeekViewEventOffset({ event: event, startOfWeek: startOfViewWeek, excluded: excluded, precision: precision });
                    var span = getWeekViewEventSpan({ event: event, offset: offset, startOfWeekDate: startOfViewWeek, excluded: excluded, precision: precision, weekStartsOn: weekStartsOn });
                    return { event: event, offset: offset, span: span };
                }).filter(function (e) { return e.offset < maxRange; }).filter(function (e) { return e.span > 0; }).map(function (entry) {
                    return ({
                        event: entry.event,
                        offset: entry.offset,
                        span: entry.span,
                        startsBeforeWeek: entry.event.start < startOfViewWeek,
                        endsAfterWeek: (entry.event.end || entry.event.start) > endOfViewWeek
                    });
                }).sort(function (itemA, itemB) {
                    var startSecondsDiff = __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemA.event.start, itemB.event.start);
                    if (startSecondsDiff === 0) {
                        return __WEBPACK_IMPORTED_MODULE_9_date_fns_difference_in_seconds___default()(itemB.event.end || itemB.event.start, itemA.event.end || itemA.event.start);
                    }
                    return startSecondsDiff;
                });
                var eventRows = [];
                var allocatedEvents = [];
                eventsMapped.forEach(function (event, index) {
                    if (allocatedEvents.indexOf(event) === -1) {
                        allocatedEvents.push(event);
                        var rowSpan_1 = event.span + event.offset;
                        var otherRowEvents = eventsMapped.slice(index + 1).filter(function (nextEvent) {
                            if (nextEvent.offset >= rowSpan_1 &&
                                rowSpan_1 + nextEvent.span <= DAYS_IN_WEEK &&
                                allocatedEvents.indexOf(nextEvent) === -1) {
                                var nextEventOffset = nextEvent.offset - rowSpan_1;
                                if (!absolutePositionedEvents) {
                                    nextEvent.offset = nextEventOffset;
                                }
                                rowSpan_1 += nextEvent.span + nextEventOffset;
                                allocatedEvents.push(nextEvent);
                                return true;
                            }
                        });
                        eventRows.push({
                            row: [
                                event
                            ].concat(otherRowEvents)
                        });
                    }
                });
                return eventRows;
            }
            function getMonthView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, weekStartsOn = _a.weekStartsOn, _c = _a.excluded, excluded = _c === void 0 ? [] : _c, _d = _a.viewStart, viewStart = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_10_date_fns_start_of_month___default()(viewDate) : _d, _e = _a.viewEnd, viewEnd = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_month___default()(viewDate) : _e;
                if (!events) {
                    events = [];
                }
                var start = __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_week___default()(viewStart, { weekStartsOn: weekStartsOn });
                var end = __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_week___default()(viewEnd, { weekStartsOn: weekStartsOn });
                var eventsInMonth = getEventsInPeriod({
                    events: events,
                    periodStart: start,
                    periodEnd: end
                });
                var days = [];
                var previousDate;
                var _loop_2 = function (i) {
                    // hacky fix for https://github.com/mattlewis92/angular-calendar/issues/173
                    var date;
                    if (previousDate) {
                        date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY));
                        if (previousDate.getTime() === date.getTime()) {
                            date = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(previousDate, HOURS_IN_DAY + 1));
                        }
                        previousDate = date;
                    }
                    else {
                        date = previousDate = start;
                    }
                    if (!excluded.some(function (e) { return date.getDay() === e; })) {
                        var day = getWeekDay({ date: date });
                        var events_1 = getEventsInPeriod({
                            events: eventsInMonth,
                            periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(date),
                            periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(date)
                        });
                        day.inMonth = __WEBPACK_IMPORTED_MODULE_12_date_fns_is_same_month___default()(date, viewDate);
                        day.events = events_1;
                        day.badgeTotal = events_1.length;
                        days.push(day);
                    }
                };
                for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_days___default()(end, start) + 1; i++) {
                    _loop_2(i);
                }
                var totalDaysVisibleInWeek = DAYS_IN_WEEK - excluded.length;
                var rows = Math.floor(days.length / totalDaysVisibleInWeek);
                var rowOffsets = [];
                for (var i = 0; i < rows; i++) {
                    rowOffsets.push(i * totalDaysVisibleInWeek);
                }
                return {
                    rowOffsets: rowOffsets,
                    totalDaysVisibleInWeek: totalDaysVisibleInWeek,
                    days: days
                };
            }
            function getDayView(_a) {
                var _b = _a.events, events = _b === void 0 ? [] : _b, viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd, eventWidth = _a.eventWidth, segmentHeight = _a.segmentHeight;
                if (!events) {
                    events = [];
                }
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var previousDayEvents = [];
                var dayViewEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return !event.allDay; }),
                    periodStart: startOfView,
                    periodEnd: endOfView
                }).sort(function (eventA, eventB) {
                    return eventA.start.valueOf() - eventB.start.valueOf();
                }).map(function (event) {
                    var eventStart = event.start;
                    var eventEnd = event.end || eventStart;
                    var startsBeforeDay = eventStart < startOfView;
                    var endsAfterDay = eventEnd > endOfView;
                    var hourHeightModifier = (hourSegments * segmentHeight) / MINUTES_IN_HOUR;
                    var top = 0;
                    if (eventStart > startOfView) {
                        top += __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(eventStart, startOfView);
                    }
                    top *= hourHeightModifier;
                    var startDate = startsBeforeDay ? startOfView : eventStart;
                    var endDate = endsAfterDay ? endOfView : eventEnd;
                    var height = __WEBPACK_IMPORTED_MODULE_17_date_fns_difference_in_minutes___default()(endDate, startDate);
                    if (!event.end) {
                        height = segmentHeight;
                    }
                    else {
                        height *= hourHeightModifier;
                    }
                    var bottom = top + height;
                    var overlappingPreviousEvents = previousDayEvents.filter(function (previousEvent) {
                        var previousEventTop = previousEvent.top;
                        var previousEventBottom = previousEvent.top + previousEvent.height;
                        if (top < previousEventBottom && previousEventBottom < bottom) {
                            return true;
                        }
                        else if (previousEventTop <= top && bottom <= previousEventBottom) {
                            return true;
                        }
                        return false;
                    });
                    var left = 0;
                    while (overlappingPreviousEvents.some(function (previousEvent) { return previousEvent.left === left; })) {
                        left += eventWidth;
                    }
                    var dayEvent = {
                        event: event,
                        height: height,
                        width: eventWidth,
                        top: top,
                        left: left,
                        startsBeforeDay: startsBeforeDay,
                        endsAfterDay: endsAfterDay
                    };
                    if (height > 0) {
                        previousDayEvents.push(dayEvent);
                    }
                    return dayEvent;
                }).filter(function (dayEvent) { return dayEvent.height > 0; });
                var width = Math.max.apply(Math, dayViewEvents.map(function (event) { return event.left + event.width; }));
                var allDayEvents = getEventsInPeriod({
                    events: events.filter(function (event) { return event.allDay; }),
                    periodStart: __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(startOfView),
                    periodEnd: __WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(endOfView)
                });
                return {
                    events: dayViewEvents,
                    width: width,
                    allDayEvents: allDayEvents
                };
            }
            function getDayViewHourGrid(_a) {
                var viewDate = _a.viewDate, hourSegments = _a.hourSegments, dayStart = _a.dayStart, dayEnd = _a.dayEnd;
                var hours = [];
                var startOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate), dayStart.hour), dayStart.minute);
                var endOfView = __WEBPACK_IMPORTED_MODULE_15_date_fns_set_minutes___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_set_hours___default()(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_minute___default()(__WEBPACK_IMPORTED_MODULE_0_date_fns_end_of_day___default()(viewDate)), dayEnd.hour), dayEnd.minute);
                var segmentDuration = MINUTES_IN_HOUR / hourSegments;
                var startOfViewDay = __WEBPACK_IMPORTED_MODULE_3_date_fns_start_of_day___default()(viewDate);
                for (var i = 0; i < HOURS_IN_DAY; i++) {
                    var segments = [];
                    for (var j = 0; j < hourSegments; j++) {
                        var date = __WEBPACK_IMPORTED_MODULE_1_date_fns_add_minutes___default()(__WEBPACK_IMPORTED_MODULE_18_date_fns_add_hours___default()(startOfViewDay, i), j * segmentDuration);
                        if (date >= startOfView && date < endOfView) {
                            segments.push({
                                date: date,
                                isStart: j === 0
                            });
                        }
                    }
                    if (segments.length > 0) {
                        hours.push({ segments: segments });
                    }
                }
                return hours;
            }
            //# sourceMappingURL=calendarUtils.js.map

            /***/
        }),
    /* 5 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Millisecond Helpers
             * @summary Get the number of milliseconds between the given dates.
             *
             * @description
             * Get the number of milliseconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of milliseconds
             *
             * @example
             * // How many milliseconds are between
             * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
             * var result = differenceInMilliseconds(
             *   new Date(2014, 6, 2, 12, 30, 21, 700),
             *   new Date(2014, 6, 2, 12, 30, 20, 600)
             * )
             * //=> 1100
             */
            function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getTime() - dateRight.getTime()
            }

            module.exports = differenceInMilliseconds


            /***/
        }),
    /* 6 */
    /***/ (function (module, exports) {

            // removed by extract-text-webpack-plugin

            /***/
        }),
    /* 7 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./mwlCalendar.js": 45,
                "./mwlCalendarDay.js": 46,
                "./mwlCalendarHourList.js": 47,
                "./mwlCalendarMonth.js": 48,
                "./mwlCalendarSlideBox.js": 49,
                "./mwlCalendarWeek.js": 50,
                "./mwlCalendarYear.js": 51,
                "./mwlCollapseFallback.js": 52,
                "./mwlDateModifier.js": 53,
                "./mwlDragSelect.js": 54,
                "./mwlDraggable.js": 55,
                "./mwlDroppable.js": 56,
                "./mwlDynamicDirectiveTemplate.js": 57,
                "./mwlElementDimensions.js": 58,
                "./mwlResizable.js": 59
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 7;

            /***/
        }),
    /* 8 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarDate.js": 61,
                "./calendarLimitTo.js": 62,
                "./calendarTruncateEventTitle.js": 63,
                "./calendarTrustAsHtml.js": 64
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 8;

            /***/
        }),
    /* 9 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendarConfig.js": 65,
                "./calendarEventTitle.js": 66,
                "./calendarHelper.js": 67,
                "./calendarTitle.js": 68,
                "./interact.js": 69,
                "./moment.js": 70
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 9;

            /***/
        }),
    /* 10 */
    /***/ (function (module, exports, __webpack_require__) {

            var map = {
                "./calendar.html": 36,
                "./calendarDayView.html": 37,
                "./calendarHourList.html": 38,
                "./calendarMonthCell.html": 39,
                "./calendarMonthCellEvents.html": 40,
                "./calendarMonthView.html": 41,
                "./calendarSlideBox.html": 42,
                "./calendarWeekView.html": 43,
                "./calendarYearView.html": 44
            };
            function webpackContext(req) {
                return __webpack_require__(webpackContextResolve(req));
            };
            function webpackContextResolve(req) {
                var id = map[req];
                if (!(id + 1)) // check for number or string
                    throw new Error("Cannot find module '" + req + "'.");
                return id;
            };
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module.exports = webpackContext;
            webpackContext.id = 10;

            /***/
        }),
    /* 11 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Add the specified number of days to the given date.
             *
             * @description
             * Add the specified number of days to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of days to be added
             * @returns {Date} the new date with the days added
             *
             * @example
             * // Add 10 days to 1 September 2014:
             * var result = addDays(new Date(2014, 8, 1), 10)
             * //=> Thu Sep 11 2014 00:00:00
             */
            function addDays(dirtyDate, dirtyAmount) {
                var date = parse(dirtyDate)
                var amount = Number(dirtyAmount)
                date.setDate(date.getDate() + amount)
                return date
            }

            module.exports = addDays


            /***/
        }),
    /* 12 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_HOUR = 3600000

            /**
             * @category Hour Helpers
             * @summary Add the specified number of hours to the given date.
             *
             * @description
             * Add the specified number of hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of hours to be added
             * @returns {Date} the new date with the hours added
             *
             * @example
             * // Add 2 hours to 10 July 2014 23:00:00:
             * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
             * //=> Fri Jul 11 2014 01:00:00
             */
            function addHours(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
            }

            module.exports = addHours


            /***/
        }),
    /* 13 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Add the specified number of minutes to the given date.
             *
             * @description
             * Add the specified number of minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of minutes to be added
             * @returns {Date} the new date with the minutes added
             *
             * @example
             * // Add 30 minutes to 10 July 2014 12:00:00:
             * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
             * //=> Thu Jul 10 2014 12:30:00
             */
            function addMinutes(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
            }

            module.exports = addMinutes


            /***/
        }),
    /* 14 */
    /***/ (function (module, exports, __webpack_require__) {

            var addMilliseconds = __webpack_require__(2)

            /**
             * @category Second Helpers
             * @summary Add the specified number of seconds to the given date.
             *
             * @description
             * Add the specified number of seconds to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} amount - the amount of seconds to be added
             * @returns {Date} the new date with the seconds added
             *
             * @example
             * // Add 30 seconds to 10 July 2014 12:45:00:
             * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
             * //=> Thu Jul 10 2014 12:45:30
             */
            function addSeconds(dirtyDate, dirtyAmount) {
                var amount = Number(dirtyAmount)
                return addMilliseconds(dirtyDate, amount * 1000)
            }

            module.exports = addSeconds


            /***/
        }),
    /* 15 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Compare the two dates and return -1, 0 or 1.
             *
             * @description
             * Compare the two dates and return 1 if the first date is after the second,
             * -1 if the first date is before the second or 0 if dates are equal.
             *
             * @param {Date|String|Number} dateLeft - the first date to compare
             * @param {Date|String|Number} dateRight - the second date to compare
             * @returns {Number} the result of the comparison
             *
             * @example
             * // Compare 11 February 1987 and 10 July 1989:
             * var result = compareAsc(
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * )
             * //=> -1
             *
             * @example
             * // Sort the array of dates:
             * var result = [
             *   new Date(1995, 6, 2),
             *   new Date(1987, 1, 11),
             *   new Date(1989, 6, 10)
             * ].sort(compareAsc)
             * //=> [
             * //   Wed Feb 11 1987 00:00:00,
             * //   Mon Jul 10 1989 00:00:00,
             * //   Sun Jul 02 1995 00:00:00
             * // ]
             */
            function compareAsc(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var timeLeft = dateLeft.getTime()
                var dateRight = parse(dirtyDateRight)
                var timeRight = dateRight.getTime()

                if (timeLeft < timeRight) {
                    return -1
                } else if (timeLeft > timeRight) {
                    return 1
                } else {
                    return 0
                }
            }

            module.exports = compareAsc


            /***/
        }),
    /* 16 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            var MILLISECONDS_IN_MINUTE = 60000
            var MILLISECONDS_IN_DAY = 86400000

            /**
             * @category Day Helpers
             * @summary Get the number of calendar days between the given dates.
             *
             * @description
             * Get the number of calendar days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of calendar days
             *
             * @example
             * // How many calendar days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInCalendarDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 366
             */
            function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
                var startOfDayLeft = startOfDay(dirtyDateLeft)
                var startOfDayRight = startOfDay(dirtyDateRight)

                var timestampLeft = startOfDayLeft.getTime() -
                    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
                var timestampRight = startOfDayRight.getTime() -
                    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

                // Round the number of days to the nearest integer
                // because the number of milliseconds in a day is not constant
                // (e.g. it's different in the day of the daylight saving time clock shift)
                return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
            }

            module.exports = differenceInCalendarDays


            /***/
        }),
    /* 17 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)
            var differenceInCalendarDays = __webpack_require__(16)
            var compareAsc = __webpack_require__(15)

            /**
             * @category Day Helpers
             * @summary Get the number of full days between the given dates.
             *
             * @description
             * Get the number of full days between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of full days
             *
             * @example
             * // How many full days are between
             * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
             * var result = differenceInDays(
             *   new Date(2012, 6, 2, 0, 0),
             *   new Date(2011, 6, 2, 23, 0)
             * )
             * //=> 365
             */
            function differenceInDays(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)

                var sign = compareAsc(dateLeft, dateRight)
                var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
                dateLeft.setDate(dateLeft.getDate() - sign * difference)

                // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
                // If so, result must be decreased by 1 in absolute value
                var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
                return sign * (difference - isLastDayNotFull)
            }

            module.exports = differenceInDays


            /***/
        }),
    /* 18 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            var MILLISECONDS_IN_MINUTE = 60000

            /**
             * @category Minute Helpers
             * @summary Get the number of minutes between the given dates.
             *
             * @description
             * Get the number of minutes between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of minutes
             *
             * @example
             * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
             * var result = differenceInMinutes(
             *   new Date(2014, 6, 2, 12, 20, 0),
             *   new Date(2014, 6, 2, 12, 7, 59)
             * )
             * //=> 12
             */
            function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInMinutes


            /***/
        }),
    /* 19 */
    /***/ (function (module, exports, __webpack_require__) {

            var differenceInMilliseconds = __webpack_require__(5)

            /**
             * @category Second Helpers
             * @summary Get the number of seconds between the given dates.
             *
             * @description
             * Get the number of seconds between the given dates.
             *
             * @param {Date|String|Number} dateLeft - the later date
             * @param {Date|String|Number} dateRight - the earlier date
             * @returns {Number} the number of seconds
             *
             * @example
             * // How many seconds are between
             * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
             * var result = differenceInSeconds(
             *   new Date(2014, 6, 2, 12, 30, 20, 0),
             *   new Date(2014, 6, 2, 12, 30, 7, 999)
             * )
             * //=> 12
             */
            function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
                var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
                return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
            }

            module.exports = differenceInSeconds


            /***/
        }),
    /* 20 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Day Helpers
             * @summary Return the end of a day for the given date.
             *
             * @description
             * Return the end of a day for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a day
             *
             * @example
             * // The end of a day for 2 September 2014 11:55:00:
             * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 02 2014 23:59:59.999
             */
            function endOfDay(dirtyDate) {
                var date = parse(dirtyDate)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfDay


            /***/
        }),
    /* 21 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the end of a month for the given date.
             *
             * @description
             * Return the end of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the end of a month
             *
             * @example
             * // The end of a month for 2 September 2014 11:55:00:
             * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Tue Sep 30 2014 23:59:59.999
             */
            function endOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                var month = date.getMonth()
                date.setFullYear(date.getFullYear(), month + 1, 0)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfMonth


            /***/
        }),
    /* 22 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the end of a week for the given date.
             *
             * @description
             * Return the end of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the end of a week
             *
             * @example
             * // The end of a week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sat Sep 06 2014 23:59:59.999
             *
             * @example
             * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
             * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Sun Sep 07 2014 23:59:59.999
             */
            function endOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

                date.setDate(date.getDate() + diff)
                date.setHours(23, 59, 59, 999)
                return date
            }

            module.exports = endOfWeek


            /***/
        }),
    /* 23 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Weekday Helpers
             * @summary Get the day of the week of the given date.
             *
             * @description
             * Get the day of the week of the given date.
             *
             * @param {Date|String|Number} date - the given date
             * @returns {Number} the day of week
             *
             * @example
             * // Which day of the week is 29 February 2012?
             * var result = getDay(new Date(2012, 1, 29))
             * //=> 3
             */
            function getDay(dirtyDate) {
                var date = parse(dirtyDate)
                var day = date.getDay()
                return day
            }

            module.exports = getDay


            /***/
        }),
    /* 24 */
    /***/ (function (module, exports) {

            /**
             * @category Common Helpers
             * @summary Is the given argument an instance of Date?
             *
             * @description
             * Is the given argument an instance of Date?
             *
             * @param {*} argument - the argument to check
             * @returns {Boolean} the given argument is an instance of Date
             *
             * @example
             * // Is 'mayonnaise' a Date?
             * var result = isDate('mayonnaise')
             * //=> false
             */
            function isDate(argument) {
                return argument instanceof Date
            }

            module.exports = isDate


            /***/
        }),
    /* 25 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfDay = __webpack_require__(3)

            /**
             * @category Day Helpers
             * @summary Are the given dates in the same day?
             *
             * @description
             * Are the given dates in the same day?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same day
             *
             * @example
             * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
             * var result = isSameDay(
             *   new Date(2014, 8, 4, 6, 0),
             *   new Date(2014, 8, 4, 18, 0)
             * )
             * //=> true
             */
            function isSameDay(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
                var dateRightStartOfDay = startOfDay(dirtyDateRight)

                return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
            }

            module.exports = isSameDay


            /***/
        }),
    /* 26 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Are the given dates in the same month?
             *
             * @description
             * Are the given dates in the same month?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same month
             *
             * @example
             * // Are 2 September 2014 and 25 September 2014 in the same month?
             * var result = isSameMonth(
             *   new Date(2014, 8, 2),
             *   new Date(2014, 8, 25)
             * )
             * //=> true
             */
            function isSameMonth(dirtyDateLeft, dirtyDateRight) {
                var dateLeft = parse(dirtyDateLeft)
                var dateRight = parse(dirtyDateRight)
                return dateLeft.getFullYear() === dateRight.getFullYear() &&
                    dateLeft.getMonth() === dateRight.getMonth()
            }

            module.exports = isSameMonth


            /***/
        }),
    /* 27 */
    /***/ (function (module, exports, __webpack_require__) {

            var startOfSecond = __webpack_require__(34)

            /**
             * @category Second Helpers
             * @summary Are the given dates in the same second?
             *
             * @description
             * Are the given dates in the same second?
             *
             * @param {Date|String|Number} dateLeft - the first date to check
             * @param {Date|String|Number} dateRight - the second date to check
             * @returns {Boolean} the dates are in the same second
             *
             * @example
             * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
             * // in the same second?
             * var result = isSameSecond(
             *   new Date(2014, 8, 4, 6, 30, 15),
             *   new Date(2014, 8, 4, 6, 30, 15, 500)
             * )
             * //=> true
             */
            function isSameSecond(dirtyDateLeft, dirtyDateRight) {
                var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
                var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

                return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
            }

            module.exports = isSameSecond


            /***/
        }),
    /* 28 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the latest of the given dates.
             *
             * @description
             * Return the latest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the latest of the dates
             *
             * @example
             * // Which of these dates is the latest?
             * var result = max(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Sun Jul 02 1995 00:00:00
             */
            function max() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var latestTimestamp = Math.max.apply(null, dates)
                return new Date(latestTimestamp)
            }

            module.exports = max


            /***/
        }),
    /* 29 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Common Helpers
             * @summary Return the earliest of the given dates.
             *
             * @description
             * Return the earliest of the given dates.
             *
             * @param {...(Date|String|Number)} dates - the dates to compare
             * @returns {Date} the earliest of the dates
             *
             * @example
             * // Which of these dates is the earliest?
             * var result = min(
             *   new Date(1989, 6, 10),
             *   new Date(1987, 1, 11),
             *   new Date(1995, 6, 2),
             *   new Date(1990, 0, 1)
             * )
             * //=> Wed Feb 11 1987 00:00:00
             */
            function min() {
                var dirtyDates = Array.prototype.slice.call(arguments)
                var dates = dirtyDates.map(function (dirtyDate) {
                    return parse(dirtyDate)
                })
                var earliestTimestamp = Math.min.apply(null, dates)
                return new Date(earliestTimestamp)
            }

            module.exports = min


            /***/
        }),
    /* 30 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Hour Helpers
             * @summary Set the hours to the given date.
             *
             * @description
             * Set the hours to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} hours - the hours of the new date
             * @returns {Date} the new date with the hours setted
             *
             * @example
             * // Set 4 hours to 1 September 2014 11:30:00:
             * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
             * //=> Mon Sep 01 2014 04:30:00
             */
            function setHours(dirtyDate, dirtyHours) {
                var date = parse(dirtyDate)
                var hours = Number(dirtyHours)
                date.setHours(hours)
                return date
            }

            module.exports = setHours


            /***/
        }),
    /* 31 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Set the minutes to the given date.
             *
             * @description
             * Set the minutes to the given date.
             *
             * @param {Date|String|Number} date - the date to be changed
             * @param {Number} minutes - the minutes of the new date
             * @returns {Date} the new date with the minutes setted
             *
             * @example
             * // Set 45 minutes to 1 September 2014 11:30:40:
             * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
             * //=> Mon Sep 01 2014 11:45:40
             */
            function setMinutes(dirtyDate, dirtyMinutes) {
                var date = parse(dirtyDate)
                var minutes = Number(dirtyMinutes)
                date.setMinutes(minutes)
                return date
            }

            module.exports = setMinutes


            /***/
        }),
    /* 32 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Minute Helpers
             * @summary Return the start of a minute for the given date.
             *
             * @description
             * Return the start of a minute for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a minute
             *
             * @example
             * // The start of a minute for 1 December 2014 22:15:45.400:
             * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:00
             */
            function startOfMinute(dirtyDate) {
                var date = parse(dirtyDate)
                date.setSeconds(0, 0)
                return date
            }

            module.exports = startOfMinute


            /***/
        }),
    /* 33 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Month Helpers
             * @summary Return the start of a month for the given date.
             *
             * @description
             * Return the start of a month for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a month
             *
             * @example
             * // The start of a month for 2 September 2014 11:55:00:
             * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfMonth(dirtyDate) {
                var date = parse(dirtyDate)
                date.setDate(1)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfMonth


            /***/
        }),
    /* 34 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Second Helpers
             * @summary Return the start of a second for the given date.
             *
             * @description
             * Return the start of a second for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @returns {Date} the start of a second
             *
             * @example
             * // The start of a second for 1 December 2014 22:15:45.400:
             * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
             * //=> Mon Dec 01 2014 22:15:45.000
             */
            function startOfSecond(dirtyDate) {
                var date = parse(dirtyDate)
                date.setMilliseconds(0)
                return date
            }

            module.exports = startOfSecond


            /***/
        }),
    /* 35 */
    /***/ (function (module, exports, __webpack_require__) {

            var parse = __webpack_require__(1)

            /**
             * @category Week Helpers
             * @summary Return the start of a week for the given date.
             *
             * @description
             * Return the start of a week for the given date.
             * The result will be in the local timezone.
             *
             * @param {Date|String|Number} date - the original date
             * @param {Object} [options] - the object with options
             * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
             * @returns {Date} the start of a week
             *
             * @example
             * // The start of a week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
             * //=> Sun Aug 31 2014 00:00:00
             *
             * @example
             * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
             * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
             * //=> Mon Sep 01 2014 00:00:00
             */
            function startOfWeek(dirtyDate, dirtyOptions) {
                var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

                var date = parse(dirtyDate)
                var day = date.getDay()
                var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

                date.setDate(date.getDate() - diff)
                date.setHours(0, 0, 0, 0)
                return date
            }

            module.exports = startOfWeek


            /***/
        }),
    /* 36 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  class=\"cal-context\"\n  ng-switch=\"vm.view\"\n  ng-if=\"vm.templatesLoaded\">\n\n  <div class=\"alert alert-danger\" ng-switch-default>The value passed to the view attribute of the calendar is not set</div>\n\n  <div class=\"alert alert-danger\" ng-hide=\"vm.viewDate\">The value passed to view-date attribute of the calendar is not set</div>\n\n  <mwl-calendar-year\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    ng-switch-when=\"year\">\n  </mwl-calendar-year>\n\n  <mwl-calendar-month\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    cell-is-open=\"vm.cellIsOpen\"\n    cell-modifier=\"vm.cellModifier\"\n    slide-box-disabled=\"vm.slideBoxDisabled\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    template-scope=\"vm.templateScope\"\n    cell-auto-open-disabled=\"vm.cellAutoOpenDisabled\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"month\">\n  </mwl-calendar-month>\n\n  <mwl-calendar-week\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-switch-when=\"week\">\n  </mwl-calendar-week>\n\n  <mwl-calendar-day\n    events=\"vm.events\"\n    view-date=\"vm.viewDate\"\n    on-event-click=\"vm.onEventClick\"\n    on-event-times-changed=\"vm.onEventTimesChanged\"\n    on-timespan-click=\"vm.onTimespanClick\"\n    on-date-range-select=\"vm.onDateRangeSelect\"\n    day-view-start=\"vm.dayViewStart\"\n    day-view-end=\"vm.dayViewEnd\"\n    day-view-split=\"vm.dayViewSplit\"\n    day-view-event-chunk-size=\"vm.dayViewEventChunkSize\"\n    day-view-event-width=\"vm.dayViewEventWidth\"\n    custom-template-urls=\"vm.customTemplateUrls\"\n    cell-modifier=\"vm.cellModifier\"\n    template-scope=\"vm.templateScope\"\n    day-view-time-position=\"vm.dayViewTimePosition || 'default'\"\n    draggable-auto-scroll=\"vm.draggableAutoScroll\"\n    ng-class=\"{\n      'time-on-side' : vm.dayViewTimePosition === 'side',\n      'time-hidden' : vm.dayViewTimePosition === 'hidden'\n    }\"\n    ng-switch-when=\"day\">\n  </mwl-calendar-day>\n</div>\n";

            /***/
        }),
    /* 37 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box cal-all-day-events-box\" ng-if=\"vm.allDayEvents.length > 0\">\n  <div class=\"cal-day-panel clearfix\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            class=\"cal-cell-6 day-highlight\"\n            ng-style=\"{backgroundColor: event.color.secondary}\"\n            data-event-class\n            ng-repeat=\"event in vm.allDayEvents track by event.calendarEventId\">\n            <strong>\n              <span ng-bind=\"event.startsAt | calendarDate:'datetime':true\"></span>\n              <span ng-if=\"event.endsAt\">\n                - <span ng-bind=\"event.endsAt | calendarDate:'datetime':true\"></span>\n              </span>\n            </strong>\n            <a\n              href=\"javascript:;\"\n              class=\"event-item\"\n              ng-bind-html=\"vm.calendarEventTitle.dayView(event) | calendarTrustAsHtml\">\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"cal-day-box\">\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.dayViewHeight + 'px', minWidth: vm.viewWidth + 'px'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      on-event-times-changed=\"vm.onEventTimesChanged\"\n      view-date=\"vm.viewDate\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      cell-modifier=\"vm.cellModifier\"\n      view=\"day\">\n    </mwl-calendar-hour-list>\n\n    <div\n      class=\"pull-left day-event day-highlight\"\n      ng-repeat=\"dayEvent in vm.nonAllDayEvents track by dayEvent.event.calendarEventId\"\n      ng-class=\"dayEvent.event.cssClass\"\n      ng-style=\"{\n        top: dayEvent.top - 1 + 'px',\n        left: dayEvent.left +  vm.dayViewTimePositionOffset + 'px',\n        height: dayEvent.height + 'px',\n        width: dayEvent.width + 'px',\n        backgroundColor: dayEvent.event.color.secondary,\n        borderColor: dayEvent.event.color.primary\n      }\"\n      mwl-draggable=\"dayEvent.event.draggable === true\"\n      axis=\"'xy'\"\n      snap-grid=\"{y: vm.dayViewEventChunkSize || 30, x: 50}\"\n      on-drag=\"vm.eventDragged(dayEvent.event, y / 30)\"\n      on-drag-end=\"vm.eventDragComplete(dayEvent.event, y / 30)\"\n      auto-scroll=\"vm.draggableAutoScroll\"\n      mwl-resizable=\"dayEvent.event.resizable === true && dayEvent.event.endsAt\"\n      resize-edges=\"{top: true, bottom: true}\"\n      on-resize=\"vm.eventResized(dayEvent.event, edge, y / 30)\"\n      on-resize-end=\"vm.eventResizeComplete(dayEvent.event, edge, y / 30)\"\n      uib-tooltip-html=\"vm.calendarEventTitle.dayViewTooltip(dayEvent.event) | calendarTrustAsHtml\"\n      tooltip-append-to-body=\"true\">\n\n      <span class=\"cal-hours\">\n        <span ng-show=\"dayEvent.top == 0\"><span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'day':true\"></span>, </span>\n        <span ng-bind=\"(dayEvent.event.tempStartsAt || dayEvent.event.startsAt) | calendarDate:'time':true\"></span>\n      </span>\n      <a\n        href=\"javascript:;\"\n        class=\"event-item\"\n        ng-click=\"vm.onEventClick({calendarEvent: dayEvent.event})\">\n        <span ng-bind-html=\"vm.calendarEventTitle.dayView(dayEvent.event) | calendarTrustAsHtml\"></span>\n      </a>\n\n      <a\n        href=\"javascript:;\"\n        class=\"event-item-action\"\n        ng-repeat=\"action in dayEvent.event.actions track by $index\"\n        ng-class=\"action.cssClass\"\n        ng-bind-html=\"action.label | calendarTrustAsHtml\"\n        ng-click=\"action.onClick({calendarEvent: dayEvent.event})\">\n      </a>\n\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 38 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-day-panel-hour\">\n\n  <div class=\"cal-day-hour\" ng-repeat=\"hour in vm.hourGrid track by $index\">\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= segment.date &&\n                segment.date < vm.dateRangeSelect.endDate }, segment.cssClass]\"\n      ng-click=\"vm.onTimespanClick({calendarDate: segment.date})\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, segment.date)\"\n      mwl-drag-select=\"!!vm.onDateRangeSelect\"\n      on-drag-select-start=\"vm.onDragSelectStart(segment.date)\"\n      on-drag-select-move=\"vm.onDragSelectMove(segment.nextSegmentDate)\"\n      on-drag-select-end=\"vm.onDragSelectEnd(segment.nextSegmentDate)\"\n      ng-if=\"!vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n      </div>\n    </div>\n\n    <div\n      class=\"cal-day-hour-part\"\n      ng-repeat=\"segment in hour.segments track by $index\"\n      ng-if=\"vm.dayWidth\">\n      <div class=\"cal-day-hour-part-time\">\n        <strong ng-bind=\"segment.date | calendarDate:'hour':true\" ng-show=\"segment.isStart\"></strong>\n        &nbsp;\n      </div>\n      <div\n        class=\"cal-day-hour-part-spacer\"\n        ng-repeat=\"day in segment.days track by $index\"\n        ng-style=\"{width: (vm.dayWidth - ($last ? vm.scrollBarWidth : 0)) + 'px'}\"\n        ng-class=\"[{ 'cal-day-hour-part-selected': vm.dateRangeSelect &&\n                vm.dateRangeSelect.startDate <= day.date &&\n                day.date < vm.dateRangeSelect.endDate }, day.cssClass]\"\n        ng-click=\"vm.onTimespanClick({calendarDate: day.date})\"\n        mwl-droppable\n        on-drop=\"vm.eventDropped(dropData.event, day.date)\"\n        mwl-drag-select=\"!!vm.onDateRangeSelect\"\n        on-drag-select-start=\"vm.onDragSelectStart(day.date)\"\n        on-drag-select-move=\"vm.onDragSelectMove(day.nextSegmentDate)\"\n        on-drag-select-end=\"vm.onDragSelectEnd(day.nextSegmentDate)\">\n      </div>\n    </div>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 39 */
    /***/ (function (module, exports) {

            module.exports = "<div\n  mwl-droppable\n  on-drop=\"vm.handleEventDrop(dropData.event, day.date, dropData.draggedFromDate)\"\n  mwl-drag-select=\"!!vm.onDateRangeSelect\"\n  on-drag-select-start=\"vm.onDragSelectStart(day)\"\n  on-drag-select-move=\"vm.onDragSelectMove(day)\"\n  on-drag-select-end=\"vm.onDragSelectEnd(day)\"\n  class=\"cal-month-day {{ day.cssClass }}\"\n  ng-class=\"{\n    'cal-day-outmonth': !day.inMonth,\n    'cal-day-inmonth': day.inMonth,\n    'cal-day-weekend': day.isWeekend,\n    'cal-day-past': day.isPast,\n    'cal-day-today': day.isToday,\n    'cal-day-future': day.isFuture,\n    'cal-day-selected': vm.dateRangeSelect && vm.dateRangeSelect.startDate <= day.date && day.date <= vm.dateRangeSelect.endDate,\n    'cal-day-open': dayIndex === vm.openDayIndex\n  }\">\n\n  <small\n    class=\"cal-events-num badge badge-important pull-left\"\n    ng-show=\"day.badgeTotal > 0 && (vm.calendarConfig.displayAllMonthEvents || day.inMonth)\"\n    ng-bind=\"day.badgeTotal\">\n  </small>\n\n  <span\n    class=\"pull-right\"\n    data-cal-date\n    ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n    ng-bind=\"day.label\">\n  </span>\n\n  <div class=\"cal-day-tick\" ng-show=\"dayIndex === vm.openDayIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\">\n    <i class=\"glyphicon glyphicon-chevron-up\"></i>\n    <i class=\"fa fa-chevron-up\"></i>\n  </div>\n\n  <ng-include src=\"vm.customTemplateUrls.calendarMonthCellEvents || vm.calendarConfig.templates.calendarMonthCellEvents\"></ng-include>\n\n  <div id=\"cal-week-box\" ng-if=\"$first && rowHovered\">\n    <span ng-bind=\"vm.getWeekNumberLabel(day)\"></span>\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 40 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"events-list\" ng-show=\"day.events.length > 0\">\n  <a\n    ng-repeat=\"event in day.events | orderBy:'startsAt' track by event.calendarEventId\"\n    href=\"javascript:;\"\n    ng-click=\"$event.stopPropagation(); vm.onEventClick({calendarEvent: event})\"\n    class=\"pull-left event\"\n    ng-class=\"event.cssClass\"\n    ng-style=\"{backgroundColor: event.color.primary}\"\n    ng-mousedown=\"$event.stopPropagation()\"\n    ng-mouseenter=\"vm.highlightEvent(event, true)\"\n    ng-mouseleave=\"vm.highlightEvent(event, false)\"\n    tooltip-append-to-body=\"true\"\n    uib-tooltip-html=\"vm.calendarEventTitle.monthViewTooltip(event) | calendarTrustAsHtml\"\n    mwl-draggable=\"event.draggable === true\"\n    drop-data=\"{event: event, draggedFromDate: day.date.toDate()}\"\n    auto-scroll=\"vm.draggableAutoScroll\">\n  </a>\n</div>\n";

            /***/
        }),
    /* 41 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-row-fluid cal-row-head\">\n\n  <div class=\"cal-cell1\" ng-repeat=\"day in vm.weekDays track by $index\" ng-bind=\"day\"></div>\n\n</div>\n<div class=\"cal-month-box\">\n\n  <div\n    ng-repeat=\"rowOffset in vm.monthOffsets track by rowOffset\"\n    ng-mouseenter=\"rowHovered = true\"\n    ng-mouseleave=\"rowHovered = false\">\n    <div class=\"cal-row-fluid cal-before-eventlist\">\n      <div\n        ng-repeat=\"day in vm.view | calendarLimitTo:7:rowOffset track by $index\"\n        ng-init=\"dayIndex = vm.view.indexOf(day)\"\n        class=\"cal-cell1 cal-cell {{ day.highlightClass }}\"\n        ng-style=\"{backgroundColor: day.backgroundColor}\"\n        ng-click=\"vm.dayClicked(day, false, $event)\"\n        ng-class=\"{pointer: day.events.length > 0}\">\n        <ng-include src=\"vm.customTemplateUrls.calendarMonthCell || vm.calendarConfig.templates.calendarMonthCell\"></ng-include>\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openDayIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openDayIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openDayIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\"\n      draggable-auto-scroll=\"vm.draggableAutoScroll\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 42 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-slide-box\" uib-collapse=\"vm.isCollapsed\" mwl-collapse-fallback=\"vm.isCollapsed\">\n  <div class=\"cal-slide-content cal-event-list\">\n    <ul class=\"unstyled list-unstyled\">\n\n      <li\n        ng-repeat=\"event in vm.events | orderBy:'startsAt' track by event.calendarEventId\"\n        ng-class=\"event.cssClass\"\n        ng-mousedown=\"$event.stopPropagation()\"\n        mwl-draggable=\"event.draggable === true\"\n        drop-data=\"{event: event}\"\n        auto-scroll=\"vm.draggableAutoScroll\">\n        <span class=\"pull-left event\" ng-style=\"{backgroundColor: event.color.primary}\"></span>\n        &nbsp;\n        <a\n          href=\"javascript:;\"\n          class=\"event-item\"\n          ng-click=\"vm.onEventClick({calendarEvent: event})\">\n          <span ng-bind-html=\"isMonthView ? vm.calendarEventTitle.monthView(event) : vm.calendarEventTitle.yearView(event) | calendarTrustAsHtml\"></span>\n        </a>\n\n        <a\n          href=\"javascript:;\"\n          class=\"event-item-action\"\n          ng-class=\"action.cssClass\"\n          ng-repeat=\"action in event.actions track by $index\"\n          ng-bind-html=\"action.label | calendarTrustAsHtml\"\n          ng-click=\"action.onClick({calendarEvent: event})\">\n        </a>\n\n      </li>\n\n    </ul>\n  </div>\n</div>\n";

            /***/
        }),
    /* 43 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-week-box\" ng-class=\"{'cal-day-box': vm.showTimes}\">\n  <div class=\"cal-row-fluid cal-row-head\">\n\n    <div\n      class=\"cal-cell1\"\n      ng-repeat=\"day in vm.view.days track by $index\"\n      ng-class=\"{\n        'cal-day-weekend': day.isWeekend,\n        'cal-day-past': day.isPast,\n        'cal-day-today': day.isToday,\n        'cal-day-future': day.isFuture}\"\n      mwl-element-dimensions=\"vm.dayColumnDimensions\"\n      mwl-droppable\n      on-drop=\"vm.eventDropped(dropData.event, day.date)\">\n\n      <span ng-bind=\"day.weekDayLabel\"></span>\n      <br>\n      <small>\n        <span\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(day.date)\"\n          class=\"pointer\"\n          ng-bind=\"day.dayLabel\">\n        </span>\n      </small>\n\n    </div>\n\n  </div>\n\n  <div class=\"cal-day-panel clearfix\" ng-style=\"{height: vm.showTimes ? (vm.dayViewHeight + 'px') : 'auto'}\">\n\n    <mwl-calendar-hour-list\n      day-view-start=\"vm.dayViewStart\"\n      day-view-end=\"vm.dayViewEnd\"\n      day-view-split=\"vm.dayViewSplit\"\n      day-width=\"vm.dayColumnDimensions.width\"\n      view-date=\"vm.viewDate\"\n      on-timespan-click=\"vm.onTimespanClick\"\n      on-date-range-select=\"vm.onDateRangeSelect\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      cell-modifier=\"vm.cellModifier\"\n      template-scope=\"vm.templateScope\"\n      view=\"week\"\n      ng-if=\"vm.showTimes\">\n    </mwl-calendar-hour-list>\n\n    <div class=\"row\" ng-repeat=\"row in vm.view.eventRows track by $index\">\n      <div class=\"col-xs-12\">\n        <div class=\"cal-row-fluid\">\n          <div\n            ng-repeat=\"eventRow in row.row track by eventRow.event.calendarEventId\"\n            ng-class=\"'cal-cell' + (vm.showTimes ? 1 : eventRow.span) + (vm.showTimes ? '' : ' cal-offset' + eventRow.offset)\"\n            ng-style=\"{\n              top: vm.showTimes ? ((eventRow.top) + 'px') : 'auto',\n              position: vm.showTimes ? 'absolute' : 'inherit',\n              width: vm.showTimes ? (vm.dayColumnDimensions.width + 'px') : '',\n              left: vm.showTimes ? (vm.dayColumnDimensions.width * eventRow.offset) + 15 + 'px' : ''\n            }\">\n            <div\n              class=\"day-highlight\"\n              ng-class=\"[eventRow.event.cssClass, !vm.showTimes && eventRow.startsBeforeWeek ? '' : 'border-left-rounded', !vm.showTimes && eventRow.endsAfterWeek ? '' : 'border-right-rounded']\"\n              ng-style=\"{backgroundColor: eventRow.event.color.secondary}\"\n              data-event-class\n              mwl-draggable=\"eventRow.event.draggable === true\"\n              axis=\"vm.showTimes ? 'xy' : 'x'\"\n              snap-grid=\"vm.showTimes ? {x: vm.dayColumnDimensions.width, y: vm.dayViewEventChunkSize || 30} : {x: vm.dayColumnDimensions.width}\"\n              auto-scroll=\"vm.draggableAutoScroll\"\n              on-drag=\"vm.tempTimeChanged(eventRow.event, y / 30)\"\n              on-drag-end=\"vm.weekDragged(eventRow.event, x / vm.dayColumnDimensions.width, y / 30)\"\n              mwl-resizable=\"eventRow.event.resizable === true && eventRow.event.endsAt && !vm.showTimes\"\n              resize-edges=\"{left: true, right: true}\"\n              on-resize-end=\"vm.weekResized(eventRow.event, edge, x / vm.dayColumnDimensions.width)\">\n              <strong ng-bind=\"(eventRow.event.tempStartsAt || eventRow.event.startsAt) | calendarDate:'time':true\" ng-show=\"vm.showTimes\"></strong>\n              <a\n                href=\"javascript:;\"\n                ng-click=\"vm.onEventClick({calendarEvent: eventRow.event})\"\n                class=\"event-item\"\n                ng-bind-html=\"vm.calendarEventTitle.weekView(eventRow.event) | calendarTrustAsHtml\"\n                uib-tooltip-html=\"vm.calendarEventTitle.weekViewTooltip(eventRow.event) | calendarTrustAsHtml\"\n                tooltip-placement=\"left\"\n                tooltip-append-to-body=\"true\">\n              </a>\n              <a\n                href=\"javascript:;\"\n                class=\"event-item-action\"\n                ng-class=\"action.cssClass\"\n                ng-repeat=\"action in eventRow.event.actions track by $index\"\n                ng-bind-html=\"action.label | calendarTrustAsHtml\"\n                ng-click=\"action.onClick({calendarEvent: eventRow.event})\">\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n";

            /***/
        }),
    /* 44 */
    /***/ (function (module, exports) {

            module.exports = "<div class=\"cal-year-box\">\n  <div ng-repeat=\"rowOffset in [0, 4, 8] track by rowOffset\">\n    <div class=\"row cal-before-eventlist\">\n      <div\n        class=\"span3 col-md-3 col-xs-6 cal-cell {{ day.cssClass }}\"\n        ng-repeat=\"month in vm.view | calendarLimitTo:4:rowOffset track by $index\"\n        ng-init=\"monthIndex = vm.view.indexOf(month)\"\n        ng-click=\"vm.monthClicked(month, false, $event)\"\n        ng-class=\"{pointer: month.events.length > 0, 'cal-day-today': month.isToday}\"\n        mwl-droppable\n        on-drop=\"vm.handleEventDrop(dropData.event, month.date)\">\n\n        <span\n          class=\"pull-right\"\n          data-cal-date\n          ng-click=\"vm.calendarCtrl.dateClicked(month.date)\"\n          ng-bind=\"month.label\">\n        </span>\n\n        <small\n          class=\"cal-events-num badge badge-important pull-left\"\n          ng-show=\"month.badgeTotal > 0\"\n          ng-bind=\"month.badgeTotal\">\n        </small>\n\n        <div\n          class=\"cal-day-tick\"\n          ng-show=\"monthIndex === vm.openMonthIndex && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\">\n          <i class=\"glyphicon glyphicon-chevron-up\"></i>\n          <i class=\"fa fa-chevron-up\"></i>\n        </div>\n\n      </div>\n    </div>\n\n    <mwl-calendar-slide-box\n      is-open=\"vm.openRowIndex === $index && (vm.cellAutoOpenDisabled || vm.view[vm.openMonthIndex].events.length > 0) && !vm.slideBoxDisabled\"\n      events=\"vm.view[vm.openMonthIndex].events\"\n      on-event-click=\"vm.onEventClick\"\n      cell=\"vm.view[vm.openMonthIndex]\"\n      custom-template-urls=\"vm.customTemplateUrls\"\n      template-scope=\"vm.templateScope\">\n    </mwl-calendar-slide-box>\n\n  </div>\n\n</div>\n";

            /***/
        }),
    /* 45 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var LOG_PREFIX = 'Bootstrap calendar:';

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarCtrl', ["$scope", "$log", "$timeout", "$attrs", "$locale", "moment", "calendarTitle", "calendarHelper", function ($scope, $log, $timeout, $attrs, $locale, moment, calendarTitle, calendarHelper) {

                    var vm = this;

                    vm.changeView = function (view, newDay) {
                        vm.view = view;
                        vm.viewDate = newDay;
                    };

                    vm.dateClicked = function (date) {

                        var rawDate = moment(date).toDate();

                        var nextView = {
                            year: 'month',
                            month: 'day',
                            week: 'day'
                        };

                        if (vm.onViewChangeClick({ calendarDate: rawDate, calendarNextView: nextView[vm.view] }) !== false) {
                            vm.changeView(nextView[vm.view], rawDate);
                        }

                    };

                    vm.$onInit = function () {

                        if (vm.slideBoxDisabled) {
                            $log.warn(LOG_PREFIX, 'The `slide-box-disabled` option is deprecated and will be removed in the next release. ' +
                                'Instead set `cell-auto-open-disabled` to true');
                        }

                        vm.events = vm.events || [];

                        var previousDate = moment(vm.viewDate);
                        var previousView = vm.view;

                        function checkEventIsValid(event) {
                            if (!event.startsAt) {
                                $log.warn(LOG_PREFIX, 'Event is missing the startsAt field', event);
                            } else if (!angular.isDate(event.startsAt)) {
                                $log.warn(LOG_PREFIX, 'Event startsAt should be a javascript date object. Do `new Date(event.startsAt)` to fix it.', event);
                            }

                            if (event.endsAt) {
                                if (!angular.isDate(event.endsAt)) {
                                    $log.warn(LOG_PREFIX, 'Event endsAt should be a javascript date object. Do `new Date(event.endsAt)` to fix it.', event);
                                }
                                if (moment(event.startsAt).isAfter(moment(event.endsAt))) {
                                    $log.warn(LOG_PREFIX, 'Event cannot start after it finishes', event);
                                }
                            }
                        }

                        function refreshCalendar() {

                            if (calendarTitle[vm.view] && angular.isDefined($attrs.viewTitle)) {
                                vm.viewTitle = calendarTitle[vm.view](vm.viewDate);
                            }

                            vm.events.forEach(function (event, index) {
                                checkEventIsValid(event);
                                event.calendarEventId = index;
                            });

                            //if on-timespan-click="calendarDay = calendarDate" is set then don't update the view as nothing needs to change
                            var currentDate = moment(vm.viewDate);
                            var shouldUpdate = true;
                            if (
                                previousDate.clone().startOf(vm.view).isSame(currentDate.clone().startOf(vm.view)) &&
                                !previousDate.isSame(currentDate) &&
                                vm.view === previousView
                            ) {
                                shouldUpdate = false;
                            }
                            previousDate = currentDate;
                            previousView = vm.view;

                            if (shouldUpdate) {
                                // a $timeout is required as $broadcast is synchronous so if a new events array is set the calendar won't update
                                $timeout(function () {
                                    $scope.$broadcast('calendar.refreshView');
                                });
                            }
                        }

                        calendarHelper.loadTemplates().then(function () {
                            vm.templatesLoaded = true;

                            var eventsWatched = false;

                            //Refresh the calendar when any of these variables change.
                            $scope.$watchGroup([
                                'vm.viewDate',
                                'vm.view',
                                'vm.cellIsOpen',
                                function () {
                                    return moment.locale() + $locale.id; //Auto update the calendar when the locale changes
                                }
                            ], function () {
                                if (!eventsWatched) {
                                    eventsWatched = true;
                                    //need to deep watch events hence why it isn't included in the watch group
                                    $scope.$watch('vm.events', refreshCalendar, true); //this will call refreshCalendar when the watcher starts (i.e. now)
                                } else {
                                    refreshCalendar();
                                }
                            });

                        }).catch(function (err) {
                            $log.error('Could not load all calendar templates', err);
                        });

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendar', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendar" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        scope: {
                            events: '=',
                            view: '=',
                            viewTitle: '=?',
                            viewDate: '=',
                            cellIsOpen: '=?',
                            cellAutoOpenDisabled: '=?',
                            slideBoxDisabled: '=?',
                            customTemplateUrls: '=?',
                            draggableAutoScroll: '=?',
                            onEventClick: '&',
                            onEventTimesChanged: '&',
                            onTimespanClick: '&',
                            onDateRangeSelect: '&?',
                            onViewChangeClick: '&',
                            cellModifier: '&',
                            dayViewStart: '@',
                            dayViewEnd: '@',
                            dayViewSplit: '@',
                            dayViewEventChunkSize: '@',
                            dayViewEventWidth: '@',
                            templateScope: '=?',
                            dayViewTimePosition: '@'
                        },
                        controller: 'MwlCalendarCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 46 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarDayCtrl', ["$scope", "moment", "calendarHelper", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarEventTitle) {

                    var vm = this;

                    vm.calendarEventTitle = calendarEventTitle;

                    function refreshView() {

                        vm.timeHidden = vm.dayViewTimePosition === 'hidden';
                        vm.dayViewTimePositionOffset = vm.dayViewTimePosition !== 'default' ? 0 : 60;

                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );

                        var view = calendarHelper.getDayView(
                            vm.events,
                            vm.viewDate,
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit,
                            vm.dayViewEventWidth
                        );

                        vm.allDayEvents = view.allDayEvents;
                        vm.nonAllDayEvents = view.events;
                        vm.viewWidth = view.width + 62;

                    }

                    $scope.$on('calendar.refreshView', refreshView);

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit'
                    ], refreshView);

                    vm.eventDragComplete = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var newStart = moment(event.startsAt).add(minutesDiff, 'minutes');
                        var newEnd = moment(event.endsAt).add(minutesDiff, 'minutes');
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDragged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                    vm.eventResizeComplete = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(minutesDiff, 'minutes');
                        } else {
                            end.add(minutesDiff, 'minutes');
                        }
                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });
                    };

                    vm.eventResized = function (event, edge, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        if (edge === 'start') {
                            event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                        }
                    };

                }])
                .directive('mwlCalendarDay', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarDayView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            dayViewEventWidth: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            dayViewTimePosition: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarDayCtrl as vm',
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 47 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarHourListCtrl', ["$scope", "$document", "moment", "calendarHelper", function ($scope, $document, moment, calendarHelper) {
                    var vm = this;

                    // source: https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
                    function getScrollbarWidth() {
                        var outer = $document[0].createElement('div');
                        outer.style.visibility = 'hidden';
                        outer.style.width = '100px';
                        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

                        $document[0].body.appendChild(outer);

                        var widthNoScroll = outer.offsetWidth;
                        // force scrollbars
                        outer.style.overflow = 'scroll';

                        // add innerdiv
                        var inner = $document[0].createElement('div');
                        inner.style.width = '100%';
                        outer.appendChild(inner);

                        var widthWithScroll = inner.offsetWidth;

                        // remove divs
                        outer.parentNode.removeChild(outer);

                        return widthNoScroll - widthWithScroll;
                    }

                    vm.scrollBarWidth = getScrollbarWidth();

                    function updateDays() {

                        vm.dayViewSplit = parseInt(vm.dayViewSplit);
                        var dayStart = (vm.dayViewStart || '00:00').split(':');
                        var dayEnd = (vm.dayViewEnd || '23:59').split(':');
                        vm.hourGrid = calendarUtils.getDayViewHourGrid({
                            viewDate: vm.view === 'week' ? moment(vm.viewDate).startOf('week').toDate() : moment(vm.viewDate).toDate(),
                            hourSegments: 60 / vm.dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            }
                        });

                        vm.hourGrid.forEach(function (hour) {
                            hour.segments.forEach(function (segment) {

                                segment.date = moment(segment.date);
                                segment.nextSegmentDate = segment.date.clone().add(vm.dayViewSplit, 'minutes');

                                if (vm.view === 'week') {

                                    segment.days = [];

                                    for (var i = 0; i < 7; i++) {
                                        var day = {
                                            date: moment(segment.date).add(i, 'days')
                                        };
                                        day.nextSegmentDate = day.date.clone().add(vm.dayViewSplit, 'minutes');
                                        vm.cellModifier({ calendarCell: day });
                                        segment.days.push(day);
                                    }

                                } else {
                                    vm.cellModifier({ calendarCell: segment });
                                }

                            });
                        });

                    }

                    var originalLocale = moment.locale();

                    $scope.$on('calendar.refreshView', function () {

                        if (originalLocale !== moment.locale()) {
                            originalLocale = moment.locale();
                            updateDays();
                        }

                    });

                    $scope.$watchGroup([
                        'vm.dayViewStart',
                        'vm.dayViewEnd',
                        'vm.dayViewSplit',
                        'vm.viewDate'
                    ], function () {
                        updateDays();
                    });

                    vm.eventDropped = function (event, date) {
                        var newStart = moment(date);
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: date,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.onDragSelectStart = function (date, dayIndex) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                active: true,
                                startDate: date,
                                endDate: date,
                                dayIndex: dayIndex
                            };
                        }
                    };

                    vm.onDragSelectMove = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                        }
                    };

                    vm.onDragSelectEnd = function (date) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                }])
                .directive('mwlCalendarHourList', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarHourList" overrides="vm.customTemplateUrls"></div>',
                        controller: 'MwlCalendarHourListCtrl as vm',
                        scope: {
                            viewDate: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayWidth: '=?',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            onEventTimesChanged: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            view: '@'
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 48 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarMonthCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;
                    vm.openRowIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openDayIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (day, dayIndex) {
                                if (moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.openDayIndex = dayIndex;
                                    vm.openRowIndex = Math.floor(dayIndex / 7);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {

                        vm.weekDays = calendarHelper.getWeekDayNames();

                        var monthView = calendarHelper.getMonthView(vm.events, vm.viewDate, vm.cellModifier);
                        vm.view = monthView.days;
                        vm.monthOffsets = monthView.rowOffsets;

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openRowIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openDayIndex = null;
                            vm.view.forEach(function (day) {
                                if (day.inMonth && moment(vm.viewDate).startOf('day').isSame(day.date)) {
                                    vm.dayClicked(day, true);
                                }
                            });
                        }

                    });

                    vm.dayClicked = function (day, dayClickedFirstRun, $event) {

                        if (!dayClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: day.date.toDate(),
                                calendarCell: day,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var dayIndex = vm.view.indexOf(day);
                            if (dayIndex === vm.openDayIndex) { //the day has been clicked and is already open
                                vm.openDayIndex = null; //close the open day
                                vm.cellIsOpen = false;
                            } else {
                                vm.openDayIndex = dayIndex;
                                vm.openRowIndex = Math.floor(dayIndex / 7);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.highlightEvent = function (event, shouldAddClass) {

                        vm.view.forEach(function (day) {
                            delete day.highlightClass;
                            delete day.backgroundColor;
                            if (shouldAddClass) {
                                var dayContainsEvent = day.events.indexOf(event) > -1;
                                if (dayContainsEvent) {
                                    day.backgroundColor = event.color ? event.color.secondary : '';
                                }
                            }
                        });

                    };

                    vm.handleEventDrop = function (event, newDayDate, draggedFromDate) {

                        var newStart = moment(event.startsAt)
                            .year(moment(newDayDate).year())
                            .month(moment(newDayDate).month())
                            .date(moment(newDayDate).date());

                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newDayDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null,
                            calendarDraggedFromDate: draggedFromDate
                        });
                    };

                    vm.getWeekNumberLabel = function (day) {
                        var weekNumber = day.date.clone().add(1, 'day').isoWeek();
                        if (typeof calendarConfig.i18nStrings.weekNumber === 'function') {
                            return calendarConfig.i18nStrings.weekNumber({ weekNumber: weekNumber });
                        } else {
                            return calendarConfig.i18nStrings.weekNumber.replace('{week}', weekNumber);
                        }
                    };

                    vm.onDragSelectStart = function (day) {
                        if (!vm.dateRangeSelect) {
                            vm.dateRangeSelect = {
                                startDate: day.date,
                                endDate: day.date
                            };
                        }
                    };

                    vm.onDragSelectMove = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                        }
                    };

                    vm.onDragSelectEnd = function (day) {
                        if (vm.dateRangeSelect) {
                            vm.dateRangeSelect.endDate = day.date;
                            if (vm.dateRangeSelect.endDate > vm.dateRangeSelect.startDate) {
                                vm.onDateRangeSelect({
                                    calendarRangeStartDate: vm.dateRangeSelect.startDate.clone().startOf('day').toDate(),
                                    calendarRangeEndDate: vm.dateRangeSelect.endDate.clone().endOf('day').toDate()
                                });
                            }
                            delete vm.dateRangeSelect;
                        }
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarMonth', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarMonthView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            onDateRangeSelect: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarMonthCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 49 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarSlideBoxCtrl', ["$scope", "$timeout", "calendarConfig", "calendarEventTitle", function ($scope, $timeout, calendarConfig, calendarEventTitle) {

                    var vm = this;
                    vm.calendarConfig = calendarConfig;
                    vm.calendarEventTitle = calendarEventTitle;

                    vm.isCollapsed = true;
                    $scope.$watch('vm.isOpen', function (isOpen) {
                        //events must be populated first to set the element height before animation will work
                        $timeout(function () {
                            vm.isCollapsed = !isOpen;
                        });
                    });

                }])
                .directive('mwlCalendarSlideBox', function () {

                    return {
                        restrict: 'E',
                        template: '<div mwl-dynamic-directive-template name="calendarSlideBox" overrides="vm.customTemplateUrls"></div>',
                        replace: true,
                        controller: 'MwlCalendarSlideBoxCtrl as vm',
                        require: ['^?mwlCalendarMonth', '^?mwlCalendarYear'],
                        link: function (scope, elm, attrs, ctrls) {
                            scope.isMonthView = !!ctrls[0];
                            scope.isYearView = !!ctrls[1];
                        },
                        scope: {
                            isOpen: '=',
                            events: '=',
                            onEventClick: '=',
                            cell: '=',
                            customTemplateUrls: '=?',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 50 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarWeekCtrl', ["$scope", "moment", "calendarHelper", "calendarConfig", "calendarEventTitle", function ($scope, moment, calendarHelper, calendarConfig, calendarEventTitle) {

                    var vm = this;

                    vm.showTimes = calendarConfig.showTimesOnWeekView;
                    vm.calendarEventTitle = calendarEventTitle;

                    $scope.$on('calendar.refreshView', function () {
                        vm.dayViewSplit = vm.dayViewSplit || 30;
                        vm.dayViewHeight = calendarHelper.getDayViewHeight(
                            vm.dayViewStart,
                            vm.dayViewEnd,
                            vm.dayViewSplit
                        );
                        if (vm.showTimes) {
                            vm.view = calendarHelper.getWeekViewWithTimes(
                                vm.events,
                                vm.viewDate,
                                vm.dayViewStart,
                                vm.dayViewEnd,
                                vm.dayViewSplit
                            );
                        } else {
                            vm.view = calendarHelper.getWeekView(vm.events, vm.viewDate);
                        }
                    });

                    vm.weekDragged = function (event, daysDiff, minuteChunksMoved) {

                        var newStart = moment(event.startsAt).add(daysDiff, 'days');
                        var newEnd = moment(event.endsAt).add(daysDiff, 'days');

                        if (minuteChunksMoved) {
                            var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                            newStart = newStart.add(minutesDiff, 'minutes');
                            newEnd = newEnd.add(minutesDiff, 'minutes');
                        }

                        delete event.tempStartsAt;

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: event.endsAt ? newEnd.toDate() : null
                        });
                    };

                    vm.eventDropped = function (event, date) {
                        var daysDiff = moment(date).diff(moment(event.startsAt), 'days');
                        vm.weekDragged(event, daysDiff);
                    };

                    vm.weekResized = function (event, edge, daysDiff) {

                        var start = moment(event.startsAt);
                        var end = moment(event.endsAt);
                        if (edge === 'start') {
                            start.add(daysDiff, 'days');
                        } else {
                            end.add(daysDiff, 'days');
                        }

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarNewEventStart: start.toDate(),
                            calendarNewEventEnd: end.toDate()
                        });

                    };

                    vm.tempTimeChanged = function (event, minuteChunksMoved) {
                        var minutesDiff = minuteChunksMoved * vm.dayViewSplit;
                        event.tempStartsAt = moment(event.startsAt).add(minutesDiff, 'minutes').toDate();
                    };

                }])
                .directive('mwlCalendarWeek', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarWeekView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            dayViewStart: '=',
                            dayViewEnd: '=',
                            dayViewSplit: '=',
                            dayViewEventChunkSize: '=',
                            onTimespanClick: '=',
                            onDateRangeSelect: '=',
                            customTemplateUrls: '=?',
                            cellModifier: '=',
                            templateScope: '=',
                            draggableAutoScroll: '='
                        },
                        controller: 'MwlCalendarWeekCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 51 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCalendarYearCtrl', ["$scope", "moment", "calendarHelper", function ($scope, moment, calendarHelper) {

                    var vm = this;
                    vm.openMonthIndex = null;

                    function toggleCell() {
                        vm.openRowIndex = null;
                        vm.openMonthIndex = null;

                        if (vm.cellIsOpen && vm.view) {
                            vm.view.forEach(function (month, monthIndex) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.openMonthIndex = monthIndex;
                                    vm.openRowIndex = Math.floor(monthIndex / 4);
                                }
                            });
                        }
                    }

                    $scope.$on('calendar.refreshView', function () {
                        vm.view = calendarHelper.getYearView(vm.events, vm.viewDate, vm.cellModifier);

                        if (vm.cellAutoOpenDisabled) {
                            toggleCell();
                        } else if (!vm.cellAutoOpenDisabled && vm.cellIsOpen && vm.openMonthIndex === null) {
                            //Auto open the calendar to the current day if set
                            vm.openMonthIndex = null;
                            vm.view.forEach(function (month) {
                                if (moment(vm.viewDate).startOf('month').isSame(month.date)) {
                                    vm.monthClicked(month, true);
                                }
                            });
                        }

                    });

                    vm.monthClicked = function (month, monthClickedFirstRun, $event) {

                        if (!monthClickedFirstRun) {
                            vm.onTimespanClick({
                                calendarDate: month.date.toDate(),
                                calendarCell: month,
                                $event: $event
                            });
                            if ($event && $event.defaultPrevented) {
                                return;
                            }
                        }

                        if (!vm.cellAutoOpenDisabled) {
                            vm.openRowIndex = null;
                            var monthIndex = vm.view.indexOf(month);
                            if (monthIndex === vm.openMonthIndex) { //the month has been clicked and is already open
                                vm.openMonthIndex = null; //close the open month
                                vm.cellIsOpen = false;
                            } else {
                                vm.openMonthIndex = monthIndex;
                                vm.openRowIndex = Math.floor(monthIndex / 4);
                                vm.cellIsOpen = true;
                            }
                        }

                    };

                    vm.handleEventDrop = function (event, newMonthDate) {
                        var newStart = moment(event.startsAt)
                            .year(moment(newMonthDate).year())
                            .month(moment(newMonthDate).month());
                        var newEnd = calendarHelper.adjustEndDateFromStartDiff(event.startsAt, newStart, event.endsAt);

                        vm.onEventTimesChanged({
                            calendarEvent: event,
                            calendarDate: newMonthDate,
                            calendarNewEventStart: newStart.toDate(),
                            calendarNewEventEnd: newEnd ? newEnd.toDate() : null
                        });
                    };

                    vm.$onInit = function () {

                        if (vm.cellAutoOpenDisabled) {
                            $scope.$watchGroup([
                                'vm.cellIsOpen',
                                'vm.viewDate'
                            ], toggleCell);
                        }

                    };

                    if (angular.version.minor < 5) {
                        vm.$onInit();
                    }

                }])
                .directive('mwlCalendarYear', function () {

                    return {
                        template: '<div mwl-dynamic-directive-template name="calendarYearView" overrides="vm.customTemplateUrls"></div>',
                        restrict: 'E',
                        require: '^mwlCalendar',
                        scope: {
                            events: '=',
                            viewDate: '=',
                            onEventClick: '=',
                            onEventTimesChanged: '=',
                            cellIsOpen: '=',
                            cellAutoOpenDisabled: '=',
                            onTimespanClick: '=',
                            cellModifier: '=',
                            slideBoxDisabled: '=',
                            customTemplateUrls: '=?',
                            templateScope: '='
                        },
                        controller: 'MwlCalendarYearCtrl as vm',
                        link: function (scope, element, attrs, calendarCtrl) {
                            scope.vm.calendarCtrl = calendarCtrl;
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 52 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlCollapseFallbackCtrl', ["$scope", "$attrs", "$element", function ($scope, $attrs, $element) {

                    $scope.$watch($attrs.mwlCollapseFallback, function (shouldCollapse) {
                        if (shouldCollapse) {
                            $element.addClass('ng-hide');
                        } else {
                            $element.removeClass('ng-hide');
                        }
                    });

                }])
                .directive('mwlCollapseFallback', ["$injector", function ($injector) {

                    if ($injector.has('uibCollapseDirective')) {
                        return {};
                    }

                    return {
                        restrict: 'A',
                        controller: 'MwlCollapseFallbackCtrl'
                    };

                }]);


            /***/
        }),
    /* 53 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDateModifierCtrl', ["$element", "$attrs", "$scope", "moment", function ($element, $attrs, $scope, moment) {

                    var vm = this;

                    function onClick() {
                        if (angular.isDefined($attrs.setToToday)) {
                            vm.date = new Date();
                        } else if (angular.isDefined($attrs.increment)) {
                            vm.date = moment(vm.date).add(1, vm.increment).toDate();
                        } else if (angular.isDefined($attrs.decrement)) {
                            vm.date = moment(vm.date).subtract(1, vm.decrement).toDate();
                        }
                        $scope.$apply();
                    }

                    $element.bind('click', onClick);

                    $scope.$on('$destroy', function () {
                        $element.unbind('click', onClick);
                    });

                }])
                .directive('mwlDateModifier', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDateModifierCtrl as vm',
                        scope: {
                            date: '=',
                            increment: '=',
                            decrement: '='
                        },
                        bindToController: true
                    };

                });


            /***/
        }),
    /* 54 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDragSelectCtrl', ["$scope", "$element", "$parse", "$attrs", function ($scope, $element, $parse, $attrs) {

                    function handleMouseEvent(callbackName) {
                        return function (event) {
                            if (callbackName && event.button !== 2) {
                                $parse(callbackName)($scope);
                                $scope.$apply();
                            }
                            event.preventDefault();
                        };
                    }

                    var onMouseDown = handleMouseEvent($attrs.onDragSelectStart);
                    var onMouseMove = handleMouseEvent($attrs.onDragSelectMove);
                    var onMouseUp = handleMouseEvent($attrs.onDragSelectEnd);

                    function enableMouseListeners() {
                        $element.on('mousedown', onMouseDown);
                        $element.on('mousemove', onMouseMove);
                        $element.on('mouseup', onMouseUp);
                    }

                    function disableMouseListeners() {
                        $element.off('mousedown', onMouseDown);
                        $element.off('mousemove', onMouseMove);
                        $element.off('mouseup', onMouseUp);
                    }

                    $scope.$watch($attrs.mwlDragSelect, function (isEnabled) {
                        if (isEnabled) {
                            enableMouseListeners();
                        } else {
                            disableMouseListeners();
                        }
                    });

                    $scope.$on('$destroy', function () {
                        disableMouseListeners();
                    });

                }])
                .directive('mwlDragSelect', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDragSelectCtrl'
                    };

                });


            /***/
        }),
    /* 55 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDraggableCtrl', ["$element", "$scope", "$window", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $window, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    function translateElement(elm, transformValue) {
                        return elm
                            .css('-ms-transform', transformValue)
                            .css('-webkit-transform', transformValue)
                            .css('transform', transformValue);
                    }

                    var autoScroll = $parse($attrs.autoScroll)($scope);
                    if (typeof autoScroll === 'undefined') {
                        autoScroll = true;
                    }

                    interact($element[0]).draggable({
                        autoScroll: autoScroll,
                        snap: snap,
                        onstart: function (event) {
                            angular.element(event.target).addClass('dragging-active');
                            event.target.dropData = $parse($attrs.dropData)($scope);
                            event.target.style.pointerEvents = 'none';
                            if ($attrs.onDragStart) {
                                $parse($attrs.onDragStart)($scope);
                                $scope.$apply();
                            }
                        },
                        onmove: function (event) {

                            var elm = angular.element(event.target);
                            var x = (parseFloat(elm.attr('data-x')) || 0) + (event.dx || 0);
                            var y = (parseFloat(elm.attr('data-y')) || 0) + (event.dy || 0);

                            switch ($parse($attrs.axis)($scope)) {
                                case 'x':
                                    y = 0;
                                    break;

                                case 'y':
                                    x = 0;
                                    break;

                                default:
                            }

                            if ($window.getComputedStyle(elm[0]).position === 'static') {
                                elm.css('position', 'relative');
                            }

                            translateElement(elm, 'translate(' + x + 'px, ' + y + 'px)')
                                .css('z-index', 50)
                                .attr('data-x', x)
                                .attr('data-y', y);

                            if ($attrs.onDrag) {
                                $parse($attrs.onDrag)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var x = elm.attr('data-x');
                            var y = elm.attr('data-y');

                            event.target.style.pointerEvents = 'auto';
                            if ($attrs.onDragEnd) {
                                $parse($attrs.onDragEnd)($scope, { x: x, y: y });
                                $scope.$apply();
                            }

                            $timeout(function () {
                                translateElement(elm, '')
                                    .css('z-index', 'auto')
                                    .removeAttr('data-x')
                                    .removeAttr('data-y')
                                    .removeClass('dragging-active');
                            });

                        }
                    });

                    $scope.$watch($attrs.mwlDraggable, function (enabled) {
                        interact($element[0]).draggable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDraggable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDraggableCtrl'
                    };

                });


            /***/
        }),
    /* 56 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDroppableCtrl', ["$element", "$scope", "$parse", "$attrs", "interact", function ($element, $scope, $parse, $attrs, interact) {

                    if (!interact) {
                        return;
                    }

                    var DROP_ACTIVE_CLASS = $attrs.dropActiveClass || 'drop-active';

                    interact($element[0]).dropzone({
                        ondragenter: function (event) {
                            angular.element(event.target).addClass(DROP_ACTIVE_CLASS);
                        },
                        ondragleave: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondropdeactivate: function (event) {
                            angular.element(event.target).removeClass(DROP_ACTIVE_CLASS);
                        },
                        ondrop: function (event) {
                            if (event.relatedTarget.dropData) {
                                $parse($attrs.onDrop)($scope, { dropData: event.relatedTarget.dropData });
                                $scope.$apply();
                            }
                        }
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlDroppable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDroppableCtrl'
                    };

                });


            /***/
        }),
    /* 57 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlDynamicDirectiveTemplateCtrl', ["$compile", "$scope", "$attrs", "$element", "$templateCache", "$log", "calendarConfig", function ($compile, $scope, $attrs, $element, $templateCache, $log, calendarConfig) {

                    $scope.$watch($attrs.overrides, function (overrides) {

                        var templateName = calendarConfig.templates[$attrs.name];
                        if (
                            overrides &&
                            angular.isObject(overrides) &&
                            overrides[$attrs.name]
                        ) {
                            if ($templateCache.get(overrides[$attrs.name])) {
                                templateName = overrides[$attrs.name];
                            } else {
                                $log.warn('Bootstrap Calendar', 'The custom template for ' + overrides[$attrs.name] +
                                    ' was not found in the template cache. Please ensure it is pre-loaded via a script tag ' +
                                    '<script type="text/ng-template" id="' + overrides[$attrs.name] + '">Custom template content</script> or ' +
                                    'via a tool such as https://www.npmjs.com/package/gulp-angular-templatecache');
                            }
                        }
                        var template = $templateCache.get(templateName);
                        $element.html(template);
                        $compile($element.contents())($scope);

                    });

                }])
                .directive('mwlDynamicDirectiveTemplate', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlDynamicDirectiveTemplateCtrl'
                    };

                });


            /***/
        }),
    /* 58 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlElementDimensionsCtrl', ["$element", "$scope", "$parse", "$attrs", "$window", function ($element, $scope, $parse, $attrs, $window) {

                    function setDimensions() {
                        $parse($attrs.mwlElementDimensions).assign($scope, {
                            width: $element[0].offsetWidth - 1,
                            height: $element[0].offsetHeight
                        });
                        $scope.$applyAsync();
                    }

                    var win = angular.element($window);

                    win.bind('resize', setDimensions);

                    setDimensions();

                    $scope.$on('$destroy', function () {
                        win.unbind('resize', setDimensions);
                    });

                }])
                .directive('mwlElementDimensions', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlElementDimensionsCtrl'
                    };

                });


            /***/
        }),
    /* 59 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .controller('MwlResizableCtrl', ["$element", "$scope", "$parse", "$attrs", "$timeout", "interact", function ($element, $scope, $parse, $attrs, $timeout, interact) {

                    if (!interact) {
                        return;
                    }

                    var snap, snapGridDimensions;
                    if ($attrs.snapGrid) {
                        snapGridDimensions = $parse($attrs.snapGrid)($scope);
                        snap = {
                            targets: [
                                interact.createSnapGrid(snapGridDimensions)
                            ]
                        };
                    }

                    var originalDimensions = {};
                    var originalDimensionsStyle = {};
                    var resizeEdge;

                    function getUnitsResized(edge, elm) {
                        var unitsResized = {};
                        unitsResized.edge = edge;
                        if (edge === 'start') {
                            unitsResized.x = elm.data('x');
                            unitsResized.y = elm.data('y');
                        } else if (edge === 'end') {
                            unitsResized.x = parseFloat(elm.css('width').replace('px', '')) - originalDimensions.width;
                            unitsResized.y = parseFloat(elm.css('height').replace('px', '')) - originalDimensions.height;
                        }
                        return unitsResized;
                    }

                    interact($element[0]).resizable({
                        edges: $parse($attrs.resizeEdges)($scope),
                        snap: snap,
                        onstart: function (event) {

                            resizeEdge = 'end';
                            var elm = angular.element(event.target);
                            originalDimensions.height = elm[0].offsetHeight;
                            originalDimensions.width = elm[0].offsetWidth;
                            originalDimensionsStyle.height = elm.css('height');
                            originalDimensionsStyle.width = elm.css('width');

                        },
                        onmove: function (event) {

                            if (event.rect.width > 0 && event.rect.height > 0) {
                                var elm = angular.element(event.target);
                                var x = parseFloat(elm.data('x') || 0);
                                var y = parseFloat(elm.data('y') || 0);

                                elm.css({
                                    width: event.rect.width + 'px',
                                    height: event.rect.height + 'px'
                                });

                                // translate when resizing from top or left edges
                                x += event.deltaRect.left;
                                y += event.deltaRect.top;

                                elm.css('transform', 'translate(' + x + 'px,' + y + 'px)');

                                elm.data('x', x);
                                elm.data('y', y);

                                if (event.deltaRect.left !== 0 || event.deltaRect.top !== 0) {
                                    resizeEdge = 'start';
                                }

                                if ($attrs.onResize) {
                                    $parse($attrs.onResize)($scope, getUnitsResized(resizeEdge, elm));
                                    $scope.$apply();
                                }

                            }

                        },
                        onend: function (event) {

                            var elm = angular.element(event.target);
                            var unitsResized = getUnitsResized(resizeEdge, elm);

                            $timeout(function () {
                                elm
                                    .data('x', null)
                                    .data('y', null)
                                    .css({
                                        transform: '',
                                        width: originalDimensionsStyle.width,
                                        height: originalDimensionsStyle.height
                                    });
                            });

                            if ($attrs.onResizeEnd) {
                                $parse($attrs.onResizeEnd)($scope, unitsResized);
                                $scope.$apply();
                            }

                        }
                    });

                    $scope.$watch($attrs.mwlResizable, function (enabled) {
                        interact($element[0]).resizable({
                            enabled: enabled
                        });
                    });

                    $scope.$on('$destroy', function () {
                        interact($element[0]).unset();
                    });

                }])
                .directive('mwlResizable', function () {

                    return {
                        restrict: 'A',
                        controller: 'MwlResizableCtrl'
                    };

                });


            /***/
        }),
    /* 60 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            __webpack_require__(6);

            var angular = __webpack_require__(0);

            function requireAll(r) {
                r.keys().forEach(r);
            }

            var templates = {};

            if (true) {

                var templatesContext = __webpack_require__(10);

                templatesContext.keys().forEach(function (templateName) {
                    var templateNameWithoutPrefix = templateName.replace('./', '');
                    var cacheTemplateName = 'mwl/' + templateNameWithoutPrefix;
                    var configTemplateName = templateNameWithoutPrefix.replace('.html', '');
                    templates[configTemplateName] = {
                        cacheTemplateName: cacheTemplateName,
                        template: templatesContext(templateName)
                    };
                });

            }

            module.exports = angular
                .module('mwl.calendar', [])
                .config(["calendarConfig", function (calendarConfig) {
                    angular.forEach(templates, function (template, templateName) {
                        if (!calendarConfig.templates[templateName]) {
                            calendarConfig.templates[templateName] = template.cacheTemplateName;
                        }
                    });
                }])
                .run(["$templateCache", "$interpolate", function ($templateCache, $interpolate) {

                    angular.forEach(templates, function (template) {
                        if (!$templateCache.get(template.cacheTemplateName)) {
                            var templateContents = template.template
                                .replace('{{', $interpolate.startSymbol())
                                .replace('}}', $interpolate.endSymbol());
                            $templateCache.put(template.cacheTemplateName, templateContents);
                        }
                    });

                }]).name;

            requireAll(__webpack_require__(7));
            requireAll(__webpack_require__(8));
            requireAll(__webpack_require__(9));


            /***/
        }),
    /* 61 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarDate', ["calendarHelper", "calendarConfig", function (calendarHelper, calendarConfig) {

                    function calendarDate(date, format, getFromConfig) {

                        if (getFromConfig === true) {
                            format = calendarConfig.dateFormats[format];
                        }

                        return calendarHelper.formatDate(date, format);

                    }

                    // This is stateful because the locale can change as well
                    // as calendarConfig.dateFormats which would change the value outside of this filter
                    calendarDate.$stateful = true;

                    return calendarDate;

                }]);


            /***/
        }),
    /* 62 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarLimitTo', ["limitToFilter", function (limitToFilter) {

                    if (angular.version.minor >= 4) { //1.4+ supports the begin attribute
                        return limitToFilter;
                    }

                    //Copied from the angular source. Only 1.4 has the begin functionality.
                    return function (input, limit, begin) {
                        if (Math.abs(Number(limit)) === Infinity) {
                            limit = Number(limit);
                        } else {
                            limit = parseInt(limit);
                        }
                        if (isNaN(limit)) {
                            return input;
                        }

                        if (angular.isNumber(input)) {
                            input = input.toString();
                        }
                        if (!angular.isArray(input) && !angular.isString(input)) {
                            return input;
                        }

                        begin = (!begin || isNaN(begin)) ? 0 : parseInt(begin);
                        begin = (begin < 0 && begin >= -input.length) ? input.length + begin : begin;

                        if (limit >= 0) {
                            return input.slice(begin, begin + limit);
                        } else if (begin === 0) {
                            return input.slice(limit, input.length);
                        } else {
                            return input.slice(Math.max(0, begin + limit), begin);
                        }
                    };

                }]);


            /***/
        }),
    /* 63 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTruncateEventTitle', function () {

                    return function (string, length, boxHeight) {
                        if (!string) {
                            return '';
                        }

                        //Only truncate if if actually needs truncating
                        if (string.length >= length && string.length / 20 > boxHeight / 30) {
                            return string.substr(0, length) + '...';
                        } else {
                            return string;
                        }
                    };

                });


            /***/
        }),
    /* 64 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .filter('calendarTrustAsHtml', ["$sce", function ($sce) {

                    return function (text) {
                        return $sce.trustAsHtml(text);
                    };

                }]);


            /***/
        }),
    /* 65 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .constant('calendarConfig', {
                    allDateFormats: {
                        angular: {
                            date: {
                                hour: 'ha',
                                day: 'd MMM',
                                month: 'MMMM',
                                weekDay: 'EEEE',
                                time: 'HH:mm',
                                datetime: 'MMM d, h:mm a'
                            },
                            title: {
                                day: 'EEEE d MMMM, yyyy',
                                week: 'Week {week} of {year}',
                                month: 'MMMM yyyy',
                                year: 'yyyy'
                            }
                        },
                        moment: {
                            date: {
                                hour: 'ha',
                                day: 'D MMM',
                                month: 'MMMM',
                                weekDay: 'dddd',
                                time: 'HH:mm',
                                datetime: 'MMM D, h:mm a'
                            },
                            title: {
                                day: 'dddd D MMMM, YYYY',
                                week: 'Week {week} of {year}',
                                month: 'MMMM YYYY',
                                year: 'YYYY'
                            }
                        }
                    },
                    get dateFormats() {
                        return this.allDateFormats[this.dateFormatter].date;
                    },
                    get titleFormats() {
                        return this.allDateFormats[this.dateFormatter].title;
                    },
                    dateFormatter: 'angular',
                    showTimesOnWeekView: false,
                    displayAllMonthEvents: false,
                    i18nStrings: {
                        weekNumber: 'Week {week}'
                    },
                    templates: {},
                    colorTypes: {
                        info: {
                            primary: '#1e90ff',
                            secondary: '#d1e8ff'
                        },
                        important: {
                            primary: '#ad2121',
                            secondary: '#fae3e3'
                        },
                        warning: {
                            primary: '#e3bc08',
                            secondary: '#fdf1ba'
                        },
                        inverse: {
                            primary: '#1b1b1b',
                            secondary: '#c1c1c1'
                        },
                        special: {
                            primary: '#800080',
                            secondary: '#ffe6ff'
                        },
                        success: {
                            primary: '#006400',
                            secondary: '#caffca'
                        }
                    }
                });


            /***/
        }),
    /* 66 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarEventTitle', ["calendarDateFilter", "calendarTruncateEventTitleFilter", function (calendarDateFilter, calendarTruncateEventTitleFilter) {

                    function yearView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'date', true) + ')';
                    }

                    function monthView(event) {
                        return event.title + ' (' + calendarDateFilter(event.startsAt, 'date', true) + ')';
                    }

                    function monthViewTooltip(event) {
                        return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
                    }

                    function weekView(event) {
                        return event.title;
                    }

                    function weekViewTooltip(event) {
                        return event.title;
                    }

                    function dayView(event) {
                        return event.allDay ? event.title : calendarTruncateEventTitleFilter(event.title, 20, event.height);
                    }

                    function dayViewTooltip(event) {
                        return event.title;
                    }

                    return {
                        yearView: yearView,
                        monthView: monthView,
                        monthViewTooltip: monthViewTooltip,
                        weekView: weekView,
                        weekViewTooltip: weekViewTooltip,
                        dayView: dayView,
                        dayViewTooltip: dayViewTooltip
                    };

                }]);


            /***/
        }),
    /* 67 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var calendarUtils = __webpack_require__(4);

            angular
                .module('mwl.calendar')
                .factory('calendarHelper', ["$q", "$templateRequest", "dateFilter", "moment", "calendarConfig", function ($q, $templateRequest, dateFilter, moment, calendarConfig) {

                    function formatDate(date, format) {
                        if (calendarConfig.dateFormatter === 'angular') {
                            return dateFilter(moment(date).toDate(), format);
                        } else if (calendarConfig.dateFormatter === 'moment') {
                            return moment(date).format(format);
                        } else {
                            throw new Error('Unknown date formatter: ' + calendarConfig.dateFormatter);
                        }
                    }

                    function adjustEndDateFromStartDiff(oldStart, newStart, oldEnd) {
                        if (!oldEnd) {
                            return oldEnd;
                        }
                        var diffInSeconds = moment(newStart).diff(moment(oldStart));
                        return moment(oldEnd).add(diffInSeconds);
                    }

                    function getRecurringEventPeriod(eventPeriod, recursOn, containerPeriodStart) {

                        var eventStart = moment(eventPeriod.start);
                        var eventEnd = moment(eventPeriod.end);
                        var periodStart = moment(containerPeriodStart);

                        if (recursOn) {

                            switch (recursOn) {
                                case 'year':
                                    eventStart.set({
                                        year: periodStart.year()
                                    });
                                    break;

                                case 'month':
                                    eventStart.set({
                                        year: periodStart.year(),
                                        month: periodStart.month()
                                    });
                                    break;

                                default:
                                    throw new Error('Invalid value (' + recursOn + ') given for recurs on. Can only be year or month.');
                            }

                            eventEnd = adjustEndDateFromStartDiff(eventPeriod.start, eventStart, eventEnd);

                        }

                        return { start: eventStart, end: eventEnd };

                    }

                    function eventIsInPeriod(event, periodStart, periodEnd) {

                        periodStart = moment(periodStart);
                        periodEnd = moment(periodEnd);

                        var eventPeriod = getRecurringEventPeriod({ start: event.startsAt, end: event.endsAt || event.startsAt }, event.recursOn, periodStart);
                        var eventStart = eventPeriod.start;
                        var eventEnd = eventPeriod.end;

                        return (eventStart.isAfter(periodStart) && eventStart.isBefore(periodEnd)) ||
                            (eventEnd.isAfter(periodStart) && eventEnd.isBefore(periodEnd)) ||
                            (eventStart.isBefore(periodStart) && eventEnd.isAfter(periodEnd)) ||
                            eventStart.isSame(periodStart) ||
                            eventEnd.isSame(periodEnd);

                    }

                    function filterEventsInPeriod(events, startPeriod, endPeriod) {
                        return events.filter(function (event) {
                            return eventIsInPeriod(event, startPeriod, endPeriod);
                        });
                    }

                    function getEventsInPeriod(calendarDate, period, allEvents) {
                        var startPeriod = moment(calendarDate).startOf(period);
                        var endPeriod = moment(calendarDate).endOf(period);
                        return filterEventsInPeriod(allEvents, startPeriod, endPeriod);
                    }

                    function getBadgeTotal(events) {
                        return events.filter(function (event) {
                            return event.incrementsBadgeTotal !== false;
                        }).length;
                    }

                    function getWeekDayNames() {
                        var weekdays = [];
                        var count = 0;
                        while (count < 7) {
                            weekdays.push(formatDate(moment().weekday(count++), calendarConfig.dateFormats.weekDay));
                        }
                        return weekdays;
                    }

                    function getYearView(events, viewDate, cellModifier) {

                        var view = [];
                        var eventsInPeriod = getEventsInPeriod(viewDate, 'year', events);
                        var month = moment(viewDate).startOf('year');
                        var count = 0;
                        while (count < 12) {
                            var startPeriod = month.clone();
                            var endPeriod = startPeriod.clone().endOf('month');
                            var periodEvents = filterEventsInPeriod(eventsInPeriod, startPeriod, endPeriod);
                            var cell = {
                                label: formatDate(startPeriod, calendarConfig.dateFormats.month),
                                isToday: startPeriod.isSame(moment().startOf('month')),
                                events: periodEvents,
                                date: startPeriod,
                                badgeTotal: getBadgeTotal(periodEvents)
                            };

                            cellModifier({ calendarCell: cell });
                            view.push(cell);
                            month.add(1, 'month');
                            count++;
                        }

                        return view;

                    }

                    function updateEventForCalendarUtils(event, eventPeriod) {
                        event.start = eventPeriod.start.toDate();
                        if (event.endsAt) {
                            event.end = eventPeriod.end.toDate();
                        }
                        return event;
                    }

                    function getMonthView(events, viewDate, cellModifier) {

                        // hack required to work with the calendar-utils api
                        events.forEach(function (event) {
                            var eventPeriod = getRecurringEventPeriod({
                                start: moment(event.startsAt),
                                end: moment(event.endsAt || event.startsAt)
                            }, event.recursOn, moment(viewDate).startOf('month'));
                            updateEventForCalendarUtils(event, eventPeriod);
                        });

                        var view = calendarUtils.getMonthView({
                            events: events,
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        });

                        view.days = view.days.map(function (day) {
                            day.date = moment(day.date);
                            day.label = day.date.date();
                            day.badgeTotal = getBadgeTotal(day.events);
                            if (!calendarConfig.displayAllMonthEvents && !day.inMonth) {
                                day.events = [];
                            }
                            cellModifier({ calendarCell: day });
                            return day;
                        });

                        // remove hack
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekView(events, viewDate) {

                        var days = calendarUtils.getWeekViewHeader({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day()
                        }).map(function (day) {
                            day.date = moment(day.date);
                            day.weekDayLabel = formatDate(day.date, calendarConfig.dateFormats.weekDay);
                            day.dayLabel = formatDate(day.date, calendarConfig.dateFormats.day);
                            return day;
                        });

                        var startOfWeek = moment(viewDate).startOf('week');
                        var endOfWeek = moment(viewDate).endOf('week');

                        var eventRows = calendarUtils.getWeekView({
                            viewDate: viewDate,
                            weekStartsOn: moment().startOf('week').day(),
                            events: filterEventsInPeriod(events, startOfWeek, endOfWeek).map(function (event) {

                                var weekViewStart = moment(startOfWeek).startOf('day');

                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, weekViewStart);

                                var calendarUtilsEvent = {
                                    originalEvent: event,
                                    start: eventPeriod.start.toDate()
                                };

                                if (event.endsAt) {
                                    calendarUtilsEvent.end = eventPeriod.end.toDate();
                                }

                                return calendarUtilsEvent;
                            })
                        }).map(function (eventRow) {

                            eventRow.row = eventRow.row.map(function (rowEvent) {
                                rowEvent.event = rowEvent.event.originalEvent;
                                return rowEvent;
                            });

                            return eventRow;

                        });

                        return { days: days, eventRows: eventRows };

                    }

                    function getDayView(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit, dayViewEventWidth) {

                        var dayStart = (dayViewStart || '00:00').split(':');
                        var dayEnd = (dayViewEnd || '23:59').split(':');

                        var view = calendarUtils.getDayView({
                            events: events.map(function (event) { // hack required to work with event API
                                var eventPeriod = getRecurringEventPeriod({
                                    start: moment(event.startsAt),
                                    end: moment(event.endsAt || event.startsAt)
                                }, event.recursOn, moment(viewDate).startOf('day'));
                                return updateEventForCalendarUtils(event, eventPeriod);
                            }),
                            viewDate: viewDate,
                            hourSegments: 60 / dayViewSplit,
                            dayStart: {
                                hour: dayStart[0],
                                minute: dayStart[1]
                            },
                            dayEnd: {
                                hour: dayEnd[0],
                                minute: dayEnd[1]
                            },
                            eventWidth: dayViewEventWidth ? +dayViewEventWidth : 150,
                            segmentHeight: 30
                        });

                        // remove hack to work with new event API
                        events.forEach(function (event) {
                            delete event.start;
                            delete event.end;
                        });

                        return view;

                    }

                    function getWeekViewWithTimes(events, viewDate, dayViewStart, dayViewEnd, dayViewSplit) {
                        var weekView = getWeekView(events, viewDate);
                        var newEvents = [];
                        var flattenedEvents = [];
                        weekView.eventRows.forEach(function (row) {
                            row.row.forEach(function (eventRow) {
                                flattenedEvents.push(eventRow.event);
                            });
                        });
                        weekView.days.forEach(function (day) {
                            var dayEvents = flattenedEvents.filter(function (event) {
                                return moment(event.startsAt).startOf('day').isSame(moment(day.date).startOf('day'));
                            });
                            var newDayEvents = getDayView(
                                dayEvents,
                                day.date,
                                dayViewStart,
                                dayViewEnd,
                                dayViewSplit
                            ).events;
                            newEvents = newEvents.concat(newDayEvents);
                        });
                        weekView.eventRows = [{
                            row: newEvents.map(function (dayEvent) {
                                var event = dayEvent.event;
                                return {
                                    event: event,
                                    top: dayEvent.top,
                                    offset: calendarUtils.getWeekViewEventOffset({
                                        event: {
                                            start: event.startsAt,
                                            end: event.endsAt
                                        },
                                        startOfWeek: moment(viewDate).startOf('week').toDate()
                                    })
                                };
                            })
                        }];
                        return weekView;
                    }

                    function getDayViewHeight(dayViewStart, dayViewEnd, dayViewSplit) {
                        var dayViewStartM = moment(dayViewStart || '00:00', 'HH:mm');
                        var dayViewEndM = moment(dayViewEnd || '23:59', 'HH:mm');
                        var hourHeight = (60 / dayViewSplit) * 30;
                        return ((dayViewEndM.diff(dayViewStartM, 'minutes') / 60) * hourHeight) + 3;
                    }

                    function loadTemplates() {

                        var templatePromises = Object.keys(calendarConfig.templates).map(function (key) {
                            var templateUrl = calendarConfig.templates[key];
                            return $templateRequest(templateUrl);
                        });

                        return $q.all(templatePromises);

                    }

                    return {
                        getWeekDayNames: getWeekDayNames,
                        getYearView: getYearView,
                        getMonthView: getMonthView,
                        getWeekView: getWeekView,
                        getDayView: getDayView,
                        getWeekViewWithTimes: getWeekViewWithTimes,
                        getDayViewHeight: getDayViewHeight,
                        adjustEndDateFromStartDiff: adjustEndDateFromStartDiff,
                        formatDate: formatDate,
                        loadTemplates: loadTemplates,
                        eventIsInPeriod: eventIsInPeriod //expose for testing only
                    };

                }]);


            /***/
        }),
    /* 68 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);

            angular
                .module('mwl.calendar')
                .factory('calendarTitle', ["moment", "calendarConfig", "calendarHelper", function (moment, calendarConfig, calendarHelper) {

                    function day(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.day);
                    }

                    function week(viewDate) {
                        return calendarConfig.titleFormats.week
                            .replace('{week}', moment(viewDate).isoWeek())
                            .replace('{year}', moment(viewDate).startOf('isoweek').format('YYYY'));
                    }

                    function month(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.month);
                    }

                    function year(viewDate) {
                        return calendarHelper.formatDate(viewDate, calendarConfig.titleFormats.year);
                    }

                    return {
                        day: day,
                        week: week,
                        month: month,
                        year: year
                    };

                }]);


            /***/
        }),
    /* 69 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var interact;
            try {
                interact = __webpack_require__(72);
            } catch (e) {
                /* istanbul ignore next */
                interact = null;
            }

            angular
                .module('mwl.calendar')
                .constant('interact', interact);


            /***/
        }),
    /* 70 */
    /***/ (function (module, exports, __webpack_require__) {

            "use strict";


            var angular = __webpack_require__(0);
            var moment = __webpack_require__(71);

            angular
                .module('mwl.calendar')
                .constant('moment', moment);


            /***/
        }),
    /* 71 */
    /***/ (function (module, exports) {

            module.exports = __WEBPACK_EXTERNAL_MODULE_71__;

            /***/
        }),
    /* 72 */
    /***/ (function (module, exports) {

            if (typeof __WEBPACK_EXTERNAL_MODULE_72__ === 'undefined') { var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e; }
            module.exports = __WEBPACK_EXTERNAL_MODULE_72__;

            /***/
        })
    /******/]);
});
(function () {
    "use strict";

    angular.module("app.operations.team", []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state("app.operations_team", {
            url: "/team",
            views: {
                "content@app": {
                    templateUrl: "app/main/apps/operations/team/team.html",
                    controller: "teamController as vm"
                }
            }
        });
        $translatePartialLoaderProvider.addPart("app/main/apps/operations/team");
    }
})();
(function () {
    "use strict";

    angular
        .module("app.operations.team")
        .controller("teamController", teamController);

    /** @ngInject */
    function teamController(
        $scope,
        $rootScope,
        $interval,
        $mdToast,
        $mdSidenav,
        $http,
        $location,
        $filter,
        $mdDateLocale,
        $mdDialog,
        $document
    ) {
        document.getElementsByTagName("title")[0].text = "Operations-Teams";
        var chkAceses = localStorage.getItem("pages");
        if (chkAceses.indexOf("Teams") > -1) {
            // do nothing
        } else {
            window.location = "NoAccess";
        }
        $scope.teamgrid = true;
        $scope.Export = true;
        $scope.teamform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Teamdatas.xlsx",{headers:true}) FROM ?', [
                $scope.Teamdatas,
            ]);
        };
        $scope.items = [
            { a: 1, b: 10 },
            { a: 2, b: 20 },
            { a: 3, b: 30 },
        ];
        $scope.Showgrid = function () {
            $scope.teamgrid = true;
            $scope.teamform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        };

        var dataGrid = "";

        $scope.dataGridOptions = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },

            dataSource: $scope.Teamdatas,
            allowColumnReordering: true,
            showBorders: true,
            bindingOptions: {
                // grouping: "grouping",
                dataSource: "Teamdatas",
            },
            // grouping: {
            //     autoExpandAll: false
            // },
            searchPanel: {
                visible: true,
            },
            paging: {
                pageSize: 30,
            },
            groupPanel: {
                visible: true,
            },
            columns: [
                {
                    caption: "Team Name",
                    dataField: "TeamName",
                    cellTemplate: function (container, options) {
                        $(
                            "<p style='color:blue;cursor: pointer;'>" +
                            options.data.TeamName +
                            "</p>"
                        ).appendTo(container);
                    },
                },
                "TeamLead",
                "TeamMembers",
                {
                    dataField: "Zone",
                    groupIndex: 0,
                },
                {
                    caption: "Inactive",
                    width: 80,
                    alignment: "center",
                    allowSorting: false,
                    cellTemplate: function (container) {
                        $("<div />")
                            .dxButton({
                                icon: "close",
                                onClick: function (e) {
                                    var row = e.element.parent().parent().data().options.key;
                                    $scope.InActive(row.id, row.TeamName);
                                },
                            })
                            .appendTo(container);
                    },
                },
                {
                    caption: "Delete",
                    width: 80,
                    alignment: "center",
                    allowSorting: false,
                    cellTemplate: function (container) {
                        $("<div />")
                            .dxButton({
                                icon: "trash",
                                onClick: function (e) {
                                    var row = e.element.parent().parent().data().options.key;
                                    $scope.DeleteTeam(row.id);
                                },
                            })
                            .appendTo(container);
                    },
                },
            ],
            onCellClick: function (data) {
                if (data.column.caption == "Team Name") {
                    $scope.teaminfo(data.data.id);
                }
            },
        };

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.teamform = true;
            $scope.teamgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.FromDate = new Date(
                new Date().setFullYear(new Date().getFullYear())
            );
            $scope.ToDate = new Date(
                new Date().setFullYear(new Date().getFullYear() + 1)
            );
            init();
        };
        $scope.teaminfo = function (teamtypeId) {
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.Export = false;
            $scope.SID = teamtypeId;
            $scope.Update = true;
            $scope.teamform = true;
            $scope.teamgrid = false;
            angular.forEach($scope.Teamdatas, function (value) {
                if (value.id == teamtypeId) {
                    $scope.uTeamName = value.TeamName;
                    $scope.TeamLead = value.TeamLead;
                    $scope.TeamMembers = value.TeamMembers;
                    if (
                        $scope.TeamMembers != null &&
                        $scope.TeamMembers != "" &&
                        $scope.TeamMembers != undefined
                    ) {
                        var array = $scope.TeamMembers.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            var item = [];
                            item = $filter("filter")($scope.Employeedatas, value);
                            if (item.length != 0) {
                                array1.push({ EmployeeName: value });
                            }
                        });
                        $scope.TeamMembers = array1;
                    }
                    $scope.CreatedBy = value.CreatedBy;
                    $scope.Zone = value.Zone;
                    $scope.FromDate = value.FromDate;
                    if ($scope.FromDate != null && $scope.FromDate != "") {
                        $scope.FromDate = new Date(value.FromDate);
                    }
                    $scope.ToDate = value.ToDate;
                    if ($scope.ToDate != null && $scope.ToDate != "") {
                        $scope.ToDate = new Date(value.ToDate);
                    }
                }
            });
        };

        function ClearForm() {
            $scope.uTeamName = "";
            $scope.TeamLead = "";
            $scope.FromDate = null;
            $scope.ToDate = null;
            $scope.TeamMembers = "";
            $scope.Zone = "";
        }

        $scope.sSubmit = function () {
            debugger;
            if (
                $scope.TeamMembers != null &&
                $scope.TeamMembers != "" &&
                $scope.TeamMembers != undefined
            ) {
                $scope.TeamMembers = $scope.TeamMembers.map(function (obj) {
                    return obj.EmployeeName;
                }).join(",");
            }
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/team/update",
                    data: {
                        _id: $scope.SID,
                        TeamName: $scope.uTeamName,
                        Zone: $scope.Zone,
                        TeamLead: $scope.TeamLead,
                        TeamMembers: $scope.TeamMembers,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        UpdatedBy: $rootScope.createdby,
                        IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(
                    function (GList) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Updated Successfully!")
                                .position("top center")
                        );
                        RefreshGrid();
                        $scope.teamgrid = true;
                        $scope.teamform = false;
                        $scope.view = false;
                        $scope.Export = true;
                        $scope.Add = true;
                    },
                    function () {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Something entered gone wrong,please try again !")
                                .position("top center")
                        );
                    }
                );
            } else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/team/add",
                    data: {
                        TeamName: $scope.uTeamName,
                        Zone: $scope.Zone,
                        TeamLead: $scope.TeamLead,
                        TeamMembers: $scope.TeamMembers,
                        FromDate: $scope.FromDate,
                        ToDate: $scope.ToDate,
                        EmployeeID: $scope.vm.EmployeeID,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });

                response.then(
                    function (GList) {
                        if (GList.data.message == "Existing TeamName") {
                            $scope.error1 = true;
                            $scope.teamgrid = false;
                            $scope.teamform = true;
                            $scope.Add = false;
                            $scope.view = true;
                            $scope.Export = false;
                        } else {
                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .textContent("Successfully Added!")
                                    .position("top center")
                            );
                            $scope.Teamdatas = [];
                            RefreshGrid();
                            $scope.teamgrid = true;
                            $scope.teamform = false;
                            $scope.Add = true;
                            $scope.view = false;
                            $scope.Export = true;
                        }
                    },
                    function () {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent("Something entered gone wrong,please try again !")
                                .position("top center")
                        );
                    }
                );
            }
        };
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
            $http
                .get($rootScope.WebURL + "/user")
                .then(function (Userdata) {
                    $scope.Userdatas = Userdata.data.data;
                    var UserEmployee = [];
                    angular.forEach($scope.Userdatas, function (value) {
                        angular.forEach($scope.Employeedatas, function (evalue) {
                            if (value.EmployeeID == evalue.EmployeeID) {
                                if (UserEmployee.indexOf(evalue.EmployeeName) == -1) {
                                    UserEmployee.push(evalue.EmployeeName);
                                }
                            }
                        });
                    });
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/team",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (teamdata) {
                        $scope.Teamdatas = teamdata.data.data;
                        var TeamEmployees = [];
                        angular.forEach($scope.Teamdatas, function (value) {
                            TeamEmployees.push(value.TeamLead);
                            if (
                                value.TeamMembers != null &&
                                value.TeamMembers != undefined &&
                                value.TeamMembers != ""
                            ) {
                                var array = value.TeamMembers.split(",");
                                angular.forEach(array, function (sub) {
                                    if (TeamEmployees.indexOf(sub) == -1) {
                                        TeamEmployees.push(sub);
                                    }
                                });
                            }
                        });
                        var resArr = [];
                        try {
                            TeamEmployees.filter(function (item) {
                                var i = resArr.findIndex(function (x) {
                                    return x == item;
                                });
                                if (i <= -1) resArr.push(item);
                            });
                            var TeamEmployees = resArr;
                            if (
                                UserEmployee.length != 0 &&
                                UserEmployee.length != undefined
                            ) {
                                $scope.UserEmployees = UserEmployee.map(function (obj) {
                                    return obj;
                                }).join(",");
                            }
                            var MissingEmployee = [];
                            angular.forEach(TeamEmployees, function (item) {
                                if ($scope.UserEmployees.indexOf(item) > -1) {
                                } else {
                                    if (MissingEmployee.indexOf(item) == -1) {
                                        MissingEmployee.push(item);
                                    }
                                }
                            });
                            angular.forEach(MissingEmployee, function (value) {
                                angular.forEach($scope.Teamdatas, function (tvalue) {
                                    if (tvalue.TeamLead == value) {
                                        tvalue.MissingUserAccounts = value;
                                    }
                                    if (tvalue.TeamMembers.indexOf(value) > -1) {
                                        if (
                                            tvalue.MissingUserAccounts != null &&
                                            tvalue.MissingUserAccounts != undefined
                                        ) {
                                            tvalue.MissingUserAccounts =
                                                tvalue.MissingUserAccounts + "," + value;
                                        } else {
                                            tvalue.MissingUserAccounts = value;
                                        }
                                    }
                                });
                            });
                        } catch (e) { }
                    });
                });
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (teamdata) {
                $scope.Teamdatas = teamdata.data.data;
            });
        }

        $scope.DeleteTeam = function (id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team/CheckForScheduler",
                data: { id: id },
            }).then(function (teamdata) {
                var TeamAray = teamdata.data.data;
                if (TeamAray == 0) {
                    var result = DevExpress.ui.dialog.confirm(
                        "Are you sure you want to delete the team?",
                        "Confirm changes"
                    );
                    result.done(function (dialogResult) {
                        if (dialogResult) {
                            $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/team/delete",
                                data: { _id: id },
                            }).then(function (teamdata) {
                                RefreshGrid();
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent("Deleted Successfully !")
                                        .position("top center")
                                );
                            });
                        }
                    });
                } else {
                    DevExpress.ui.dialog.alert("You cannot delete the team?", "Alert!");
                }
            });
        };
        $scope.InActive = function (id, name) {
            $scope.inActId = id;
            $scope.OldTeamname = name;
            var result = DevExpress.ui.dialog.confirm(
                "Are you sure you want to inactive the team?",
                "Confirm changes"
            );
            result.done(function (dialogResult) {
                if (dialogResult) {
                    $mdDialog.show({
                        multiple: true,
                        templateUrl: "app/main/apps/operations/team/TeamChange.html",
                        parent: angular.element($document.body),
                        //targetEvent: M,
                        scope: $scope.$new(),
                        controller: function teamController($scope, $mdDialog) {
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            };
                        },
                    });
                }
            });
        };

        $scope.SubmitTeamChange = function (Team) {
            var Team = JSON.parse(Team);
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team/inactive",
                data: {
                    id: $scope.inActId,
                    TeamName: Team.TeamName,
                    TeamId: Team.id,
                    OldTeamName: $scope.OldTeamname,
                },
            }).then(function (teamdata) {
                RefreshGrid();
                $mdDialog.cancel();
                $mdToast.show(
                    $mdToast
                        .simple()
                        .textContent("Team Updated Successfully !")
                        .position("top center")
                );
            });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function init() {
            var array = [];
            $scope.EmployeeFilter = [];
            if (
                $scope.Teamdatas != null &&
                $scope.Teamdatas != "" &&
                $scope.Teamdatas != undefined
            ) {
                angular.forEach($scope.Teamdatas, function (value) {
                    if (array.indexOf(value.TeamLead) == -1) {
                        array.push(value.TeamLead);
                    }
                });
                if (array != null && array != "" && array != undefined) {
                    var TL = array
                        .map(function (obj) {
                            return obj;
                        })
                        .join(",");
                }
                angular.forEach($scope.Employeedatas, function (evalue) {
                    if (TL.indexOf(evalue.EmployeeName) > -1) {
                        // do nothing
                    } else {
                        $scope.EmployeeFilter.push({
                            EmployeeName: evalue.EmployeeName,
                            EmployeeID: evalue.EmployeeID,
                        });
                    }
                });
            } else {
                angular.forEach($scope.Employeedatas, function (evalue) {
                    $scope.EmployeeFilter.push({
                        EmployeeName: evalue.EmployeeName,
                        EmployeeID: evalue.EmployeeID,
                    });
                });
            }
        }
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#forms-search");
                var table = $("#forms-dtDetails").DataTable();
                table.search("").draw();
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: "simple",
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            language: {
                lengthMenu: $rootScope.lengthMenu,
                zeroRecords: $rootScope.zeroRecords,
                info: $rootScope.info,
                infoEmpty: $rootScope.infoEmpty,
                infoFiltered: $rootScope.infoFiltered,
                Header: $rootScope.Header,
            },
        };

        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element("body").find("#forms-search");
                var table = $("#forms-dtDetails").DataTable();
                table.search("").draw();
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on("keyup", function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: "simple",
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            language: {
                lengthMenu: $rootScope.lengthMenu,
                zeroRecords: $rootScope.zeroRecords,
                info: $rootScope.info,
                infoEmpty: $rootScope.infoEmpty,
                infoFiltered: $rootScope.infoFiltered,
                Header: $rootScope.Header,
            },
            columnDefs: [{ visible: false, targets: 5 }],
            order: [[5, "asc"]],
            displayLength: 25,
            drawCallback: function (settings) {
                var api = this.api();
                var rows = api.rows({ page: "current" }).nodes();
                var last = null;

                api
                    .column(5, { page: "current" })
                    .data()
                    .each(function (group, i) {
                        if (last !== group) {
                            $(rows)
                                .eq(i)
                                .before(
                                    '<tr class="group"><td colspan="5">' + group + "</td></tr>"
                                );

                            last = group;
                        }
                    });
            },
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "";
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.operations.services-master', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.services-master', {
            url: '/Services',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/services-master/service-master.html',
                    controller: 'operationsserviceProjectController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/services-master');
    }

})();
(function () {


    'use strict';
    angular
        .module('app.operations.services-master')
        .controller('operationsserviceProjectController', operationsserviceProjectController);


    /** @ngInject */
    function operationsserviceProjectController($scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $http) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Services")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Servicesgrid = true;
        $scope.Export = true;
        $scope.Servicesform = false;
        $scope.Add = true;
        $scope.Search = true;

        $scope.sAdd = function () {
            ClearForm();
            PestArray = []
            $scope.Update = false;
            $scope.Servicesform = true;
            $scope.Servicesgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Search = false;
            $scope.error1 = false;
            $scope.Treatmentdatas = []
        }
        $scope.Showgrid = function () {
            $scope.Servicesgrid = true;
            $scope.Servicesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        var PestArray = []
        $scope.Servicesinfo = function (ServicesId) {
            $scope.SID = ServicesId;
            $scope.Update = true;
            $scope.Servicesform = true;
            $scope.Servicesgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.ServicesinfoId = ServicesId;
            var Servicesdata = $scope.Servicesdatas
            var info = $scope.Servicesdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ServicesId) {
                    $scope.uServicesName = info[i].Servicetype;
                    $scope.uservicescode = info[i].Servicecode;
                    $scope.udescription = info[i].Description;
                    $scope.vm.PestType = info[i].PestType;
                    $scope.vm.Treatment = info[i].Treatment;
                    $scope.Chemical = info[i].Chemical;
                    $scope.Dilution = info[i].Dilution;
                    $scope.SOP = info[i].SOP;
                    if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                        var array = $scope.vm.PestType.split(",");
                        PestArray = $scope.vm.PestType.split(",");
                        var array1 = [];
                        var result = $scope.Treatmentdatass.filter(function (item) {
                            return PestArray.indexOf(item.PestType) !== -1;
                        });
                        $scope.Treatmentdatas = result
                        angular.forEach(array, function (value) {
                            array1.push({ PestName: value });
                        });
                        $scope.vm.PestType = array1;
                    }

                    if ($scope.vm.Treatment != null && $scope.vm.Treatment != "" && $scope.vm.Treatment != undefined) {
                        var array = $scope.vm.Treatment.split(",");

                        var result = $scope.Treatmentdatass.filter(function (item) {
                            return array.indexOf(item.TreatmentName) !== -1;
                        });
                        if (result.length > 0) {
                            result = result.map(function (obj) { return obj.TreatmentName; }).join(',').split(',');
                        }
                        array = result
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ TreatmentName: value });
                        });
                        $scope.vm.Treatment = array1;
                    }
                }
            }
        }


        $scope.sSubmit = function () {
            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.PestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.vm.Treatment != null && $scope.vm.Treatment != "" && $scope.vm.Treatment != undefined) {
                $scope.vm.Treatment = $scope.vm.Treatment.map(function (obj) { return obj.TreatmentName; }).join(',');
            }
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/servicetypelist/update",
                    data: {
                        _id: $scope.SID,
                        Servicetype: $scope.uServicesName,
                        Servicecode: $scope.uservicescode,
                        PestType: $scope.vm.PestType,
                        Description: $scope.udescription,
                        Treatment: $scope.vm.Treatment,
                        Chemical: $scope.Chemical,
                        Dilution: $scope.Dilution,
                        SOP: $scope.SOP,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },

                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Servicesgrid = true;
                    $scope.Servicesform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/servicetypelist/add",
                    data: {
                        Servicetype: $scope.uServicesName,
                        Servicecode: $scope.uservicescode,
                        PestType: $scope.vm.PestType,
                        Description: $scope.udescription,
                        Treatment: $scope.vm.Treatment,
                        Chemical: $scope.Chemical,
                        Dilution: $scope.Dilution,
                        SOP: $scope.SOP,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing Servicetype") {
                        $scope.error1 = true;
                        $scope.Servicesform = true;
                        $scope.Servicesgrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.Servicesgrid = true;
                        $scope.Servicesform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.SOP = ""
        $scope.textAreaWithMaxLength = {
            height: 90,
            bindingOptions: {
                'value': 'SOP'
            }

        };

        $scope.GetTreatmentMethod = function (PestType) {

            if (!PestArray.includes(PestType)) PestArray.push(PestType)
            else {
                var index = PestArray.indexOf(PestType)
                PestArray.splice(index, 1)
            }
            var result = $scope.Treatmentdatass.filter(function (item) {
                return PestArray.indexOf(item.PestType) !== -1;
            });
            $scope.Treatmentdatas = result
        }

        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Servicesdata.xlsx",{headers:true}) FROM ?', [$scope.Servicesdatas]);
        };
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicetypelist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Servicesdata) {
            $scope.Servicesdatas = Servicesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/treatment",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Treatmentdata) {
            $scope.Treatmentdatass = Treatmentdata.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/servicetypelist",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Servicesdata) {
                $scope.Servicesdatas = Servicesdata.data.data;
            });
        }
        function ClearForm() {
            $scope.uServicesName = '';
            $scope.uservicescode = '';
            $scope.udescription = '';
            $scope.vm.PestType = '';
            vm.selectedItem = '';
            $scope.uCurrencyCode = '';
            $scope.uContactPerson = '';
            $scope.uRemarks = '';
            $scope.uAddress = '';
            $scope.uStartDate = null;
            $scope.uEndDate = null;
            $scope.SOP = ""
            $scope.Chemical = null
            $scope.Dilution = null
            $scope.vm.Treatment = null
        }

        var vm = this;

        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        function loadAll() {
            var allStates = 'Afghanistan,  Aland Islands,  Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Antarctica, Antigua And Barbuda, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Bosnia And Herzegovina, Botswana, Bouvet Island, Brazil, British Indian Ocean Territory, Brunei Darussalam, Bulgaria, Burkina Faso, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Cayman Islands, Central African Republic, Chad, Chile, China, Christmas Island, Cocos (Keeling) Islands, Colombia, Comoros, Congo, Congo,  The Democratic Republic Of The, Cook Islands, Costa Rica,   Croatia, Cuba, Cyprus, Czechia, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Falkland,  Islands (Malvinas), Faroe,  Islands, Fiji, Finland, France, French,  Guiana, French, Polynesia, French, Southern, \
            Territories, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guinea-bissau, Guyana, Haiti, Heard Island And Mcdonald Islands, Holy See (Vatican City State), Honduras, Hong Kong, Hungary, Iceland, India, Indonesia, Iran,  Islamic Republic Of, Iraq, Ireland, Isle Of Man, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Korea, Republic Of, Kuwait, Kyrgyzstan, LaoPeoples,  Democratic,  Republic, Latvia, Lebanon, Lesotho, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Lithuania, Luxembourg, Macao, Macedonia,  The Former Yugoslav Republic Of, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Micronesia,  Federated States Of, Moldova,  Republic Of, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, \
            Netherlands Antilles, New Caledonia, New Zealand, Nicaragua, Niger, Nigeria, Niue, Norfolk Island, Northern Mariana Islands, Norway, Oman, Pakistan, Palau, Palestinian Territory,  Occupied, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Puerto Rico, Qatar, Reunion, Romania, Russian Federation, Rwanda, Saint Helena, Saint Kitts And Nevis, Saint Lucia, Saint Pierre And Miquelon, Saint Vincent And The Grenadines, Samoa, San Marino, Sao Tome And Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Georgia And The South Sandwich Islands, Spain, Sri Lanka, Sudan, Suriname, Svalbard And Jan Mayen, Swaziland, Sweden, Switzerland, Syrian Arab Republic, Taiwan,  Province Of China, Tajikistan, Tanzania,  United Republic Of, Thailand, Timor-leste, Togo, Tokelau, Tonga, Trinidad And Tobago, Tunisia, Turkey, Turkmenistan, Turks And Caicos Islands, \
            Tuvalu, Uganda, Ukraine, United Arab,  Emirates, United Kingdom, United States, United States,  Minor Outlying,  Islands, Uruguay, Uzbekistan, Vanuatu, Venezuela, Viet Nam, Virgin Islands,  British, Virgin Islands,  U.S., Wallis And Futuna, Western Sahara, Yemen, Zambia, Zimbabwe';

            return allStates.split(/, +/g).map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.operations.scopeofwork', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.crmscopeofwork', {
            url: '/Scopeofwork',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/scopeofwork/scopeofwork.html',
                    controller: 'scopeofworkController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/divisions');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.scopeofwork')
        .controller('scopeofworkController', scopeofworkController);


    /** @ngInject */
    function scopeofworkController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, moment, alert, calendarConfig) {
        // var chkAceses = localStorage.getItem('pages');
        // if (chkAceses.split(",").includes("Division")) {   // do nothing 
        // }
        // else { window.location = 'NoAccess'; }
        $scope.SOWGrid = true;
        $scope.exportbtn = true;
        $scope.SOWform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.SOWform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.SOWGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.SOWform = false;
            $scope.SOWGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.SOWGrid = true;
            $scope.SOWform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {

            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.SOWform = true;
            $scope.SOWGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.error1 = false;
            $scope.Search = false;
        }

        $scope.SOWinfo = function (sowID) {
            debugger
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = sowID;
            $scope.Update = true;
            $scope.SOWform = true;
            $scope.SOWGrid = false;
            $scope.areainfoId = sowID;
            var info = $scope.SOWdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i]._id == sowID) {
                    $scope.PestType = info[i].PestType;
                    $scope.Scopeofwork = info[i].Scopeofwork;
                    $scope.Description = info[i].Description;

                }
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/crmscopeofwork/update",
                    data: {
                        _id: $scope.SID,
                        Scopeofwork: $scope.Scopeofwork,
                        PestType: $scope.PestType,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.addbtn = true;
                    $scope.SOWGrid = true;
                    $scope.SOWform = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/crmscopeofwork/add",
                    data: {
                        Scopeofwork: $scope.Scopeofwork,
                        PestType: $scope.PestType,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "") {
                        $scope.error1 = true;
                        $scope.SOWform = true;
                        $scope.SOWGrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.SOWGrid = true;
                        $scope.SOWform = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("SOWdatas.xlsx",{headers:true}) FROM ?', [$scope.SOWdatas]);
        };

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmscopeofwork",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (sowdata) {
            $scope.SOWdatas = sowdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item;
            } catch (e) { }
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmscopeofwork",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (sowdata) {
                $scope.SOWdatas = sowdata.data.data;
            });
        }
        function ClearForm() {
            $scope.Scopeofwork = '';
            $scope.Description = '';
            $scope.PestType = '';
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };
    }


})();







/// <reference path="pest_types.html" />
(function () {
    'use strict';

    angular
        .module('app.operations.pest-types', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.pest-types', {
            url: '/PestTypes',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/pest-types/pest_types.html',
                    controller: 'pesttypesProjectController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/pest-types');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.pest-types')
        .controller('pesttypesProjectController', pesttypesProjectController);


    /** @ngInject */
    function pesttypesProjectController($scope, $rootScope, $mdDialog, $location, $document, $mdToast, $http, moment, calendarConfig, $state) {
        document.getElementsByTagName('title')[0].text = "Operations-Pest Types"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("PestType")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        $scope.IsAdmin = IsAdmin
        $scope.pesttypeGrid = true;
        $scope.exportbtn = true;
        $scope.pesttypeform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.pesttypeform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.pesttypeGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.pesttypeform = false;
            $scope.pesttypeGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;
            $scope.vm.TreatmentMethod = null;
            $scope.vm.TreatmentName = null;
            $scope.vm.Chemical = null;
            $scope.vm.Dilution = null;
            $scope.vm.SOP = null;
            $scope.vm.Chemical1 = null;
            $scope.vm.Dilution1 = null;
        }
        $scope.vm.SOP = ""
        $scope.textAreaWithMaxLength = {
            height: 50,
            bindingOptions: {
                'value': 'vm.SOP'
            }
        };

        $scope.Showgrid = function () {
            $scope.pesttypeGrid = true;
            $scope.pesttypeform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {

            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.pesttypeform = true;
            $scope.pesttypeGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.error1 = false;
            $scope.error2 = false;
            $scope.AddTreatment = { value: false }
        }

        $scope.pestinfo = function (pesttypeId) {
            if ($scope.IsAdmin == true) {
                $scope.viewbtn = true;
                $scope.addbtn = false;
                $scope.Search = false;
                $scope.exportbtn = false;
                $scope.SID = pesttypeId;
                $scope.Update = true;
                $scope.pesttypeform = true;
                $scope.pesttypeGrid = false;
                $scope.pestinfoId = pesttypeId;
                // var Pesttypedata = $scope.pesttypedatas
                var info = $scope.pestdatas
                for (var i = 0; i < info.length; i++) {
                    if (info[i].id == pesttypeId) {

                        $scope.pesttypename = info[i].PestName;
                        $scope.pestcode = info[i].Pestcode;
                        $scope.Division = info[i].Division;
                        $scope.RateOfficeHour = info[i].RateOfficeHour;
                        $scope.RateAfterOfficeHour = info[i].RateAfterOfficeHour;

                    }
                }
                $scope.AddTreatment = { value: false }
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/pesttype/update",
                    data: {
                        _id: $scope.SID,
                        PestName: $scope.pesttypename,
                        Pestcode: $scope.pestcode,
                        Division: $scope.Division,
                        RateOfficeHour: $scope.RateOfficeHour,
                        RateAfterOfficeHour: $scope.RateAfterOfficeHour,
                        UpdatedBy: $rootScope.createdby,
                        Client_Id: $rootScope.Client_Id,

                    },
                });
                response.then(function (GList) {
                    if ($scope.AddTreatment.value) {
                        var response1 = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/treatment/add",
                            data: {
                                TreatmentMethod: $scope.vm.TreatmentMethod,
                                TreatmentName: $scope.vm.TreatmentName,
                                Description: $scope.vm.Description,
                                PestType: $scope.pesttypename,
                                //  Pestcode: $scope.pestcode,
                                Chemical: $scope.vm.Chemical,
                                Dilution: $scope.vm.Dilution,
                                Chemical1: $scope.vm.Chemical1,
                                Dilution1: $scope.vm.Dilution1,
                                Client_Id: $rootScope.Client_Id,
                                CreatedBy: $rootScope.createdby
                            },
                        });
                        response1.then(function (List) {
                            if (List.data.message == "Existing TreatmentName") {
                                $mdToast.show($mdToast.simple().textContent('Existing Treatment Name!').position('top center'));
                            }
                            else {
                                $scope.vm.TreatmentMethod = null;
                                $scope.vm.TreatmentName = null;
                                $scope.vm.Chemical = null;
                                $scope.vm.Dilution = null;
                                $scope.vm.SOP = null;
                                $scope.vm.Chemical1 = null;
                                $scope.vm.Dilution1 = null;
                                $scope.AddTreatment.value = false
                                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                RefreshGrid();
                                $scope.pesttypeGrid = true;
                                $scope.pesttypeform = false;
                                $scope.viewbtn = false;
                                $scope.exportbtn = true;
                                $scope.Search = true;
                                $scope.addbtn = true;
                            }
                        })
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        RefreshGrid();
                        $scope.pesttypeGrid = true;
                        $scope.pesttypeform = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                if ($scope.pesttypename == "") {
                    alert("Please fill the Pest Type field")
                }
                else {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/pesttype/add",

                        data: {
                            _id: $scope.SID,
                            PestName: $scope.pesttypename,
                            Pestcode: $scope.pestcode,
                            Division: $scope.Division,
                            RateOfficeHour: $scope.RateOfficeHour,
                            RateAfterOfficeHour: $scope.RateAfterOfficeHour,
                            Client_Id: $rootScope.Client_Id,
                            CreatedBy: $rootScope.createdby
                        },
                    }).then(function (GList) {
                        if (GList.data.message == "Existing PestName") {
                            $scope.error1 = true;
                            $scope.error2 = false;
                            $scope.Servicesform = true;
                            $scope.Servicesgrid = false;
                            $scope.Export = false;
                            $scope.view = true;
                            $scope.Add = false;
                            $scope.Pageform = true;
                            $scope.Search = false;
                        }

                        else if (GList.data.message == "Existing PestCode") {
                            $scope.error2 = true;
                            $scope.error1 = false;
                            $scope.Servicesform = true;
                            $scope.Servicesgrid = false;
                            $scope.Export = false;
                            $scope.view = true;
                            $scope.Add = false;
                            $scope.Pageform = true;
                            $scope.Search = false;
                        }
                        else {
                            if ($scope.AddTreatment.value) {
                                var response1 = $http({
                                    method: "POST",
                                    url: $rootScope.WebURL + "/treatment/add",
                                    data: {
                                        TreatmentMethod: $scope.vm.TreatmentMethod,
                                        TreatmentName: $scope.vm.TreatmentName,
                                        Description: $scope.vm.Description,
                                        Chemical: $scope.vm.Chemical,
                                        Dilution: $scope.vm.Dilution,
                                        Chemical1: $scope.vm.Chemical1,
                                        Dilution1: $scope.vm.Dilution1,
                                        PestType: $scope.pesttypename,
                                        Client_Id: $rootScope.Client_Id,
                                        CreatedBy: $rootScope.createdby
                                    },
                                });
                                response1.then(function (List) {
                                    if (List.data.message == "Existing TreatmentName") {
                                        $mdToast.show($mdToast.simple().textContent('Existing Treatment Name!').position('top center'));
                                        $scope.Update = true
                                    }
                                    else {
                                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                                        RefreshGrid();
                                        $scope.pesttypeGrid = true;
                                        $scope.pesttypeform = false;
                                        $scope.addbtn = true;
                                        $scope.viewbtn = false;
                                        $scope.exportbtn = true;
                                        $scope.Search = true;
                                    }
                                })
                            }
                            else {
                                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                                RefreshGrid();
                                $scope.pesttypeGrid = true;
                                $scope.pesttypeform = false;
                                $scope.addbtn = true;
                                $scope.viewbtn = false;
                                $scope.exportbtn = true;
                                $scope.Search = true;
                            }
                        }
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                    });
                }
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Pestdatas.xlsx",{headers:true}) FROM ?', [$scope.pestdatas]);
        };

        $scope.DeletePopup = function (e, id) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/sormaster/alert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function pesttypesProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.DeleteId = id;
        }
        $scope.Delete = function () {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype/delete",
                data: {
                    _id: $scope.vm.DeleteId,
                },
            }).then(function (GList) {
                $scope.vm.DeleteId = null;
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.pestdatas = pestdata.data.data;
                angular.forEach($scope.pestdatas, function (value) {
                    angular.forEach($scope.Divisiondatas, function (dvalue) {
                        if (value.Division == dvalue.id) {
                            value.DivisionName = dvalue.DivisionName;
                        }
                    })
                })
            });
        });



        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/pesttype",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (pestdata) {
                    $scope.pestdatas = pestdata.data.data;
                    angular.forEach($scope.pestdatas, function (value) {
                        angular.forEach($scope.Divisiondatas, function (dvalue) {
                            if (value.Division == dvalue.id) {
                                value.DivisionName = dvalue.DivisionName;
                            }
                        })
                    })
                });
            });
        }
        function ClearForm() {

            $scope.pesttypename = null;
            $scope.pestcode = null;
            $scope.Division = null;
            $scope.RateOfficeHour = null;
            $scope.RateAfterOfficeHour = null;
            $scope.vm.TreatmentMethod = null;
            $scope.vm.TreatmentName = null;
            $scope.vm.Chemical = null;
            $scope.vm.Dilution = null;
            $scope.vm.SOP = null;
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
    }


})();








(function ()
{
    'use strict';

    angular
        .module('app.operations.materials', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.materials', {
            url: '/Materials',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/materials/materials.html',
                    controller: 'materialsController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/materials');
    }

})();
(function () {


    'use strict';
    angular
        .module('app.operations.materials')
        .controller('materialsController', materialsController);


    /** @ngInject */
    function materialsController($scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $http) {
        //var chkAceses = localStorage.getItem('pages');
        //if (chkAceses.split(",").includes("Materials")) {   // do nothing 
        //}
        //else { $location.path("NoAccess"); }
        $scope.Materialsgrid = true;
        $scope.Export = true;
        $scope.Materialsform = false;
        $scope.Add = true;
        $scope.Search = true;

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Materialsform = true;
            $scope.Materialsgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Search = false;
            $scope.error1 = false;
        }
        $scope.Showgrid = function () {
            $scope.Materialsgrid = true;
            $scope.Materialsform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }
        $scope.Materialsinfo = function (MaterialsId) {
            $scope.SID = MaterialsId;
            $scope.Update = true;
            $scope.Materialsform = true;
            $scope.Materialsgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
            $scope.MaterialsinfoId = MaterialsId;
            var Materialsdata = $scope.Materialsdatas
            var info = $scope.Materialsdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == MaterialsId) {
                    $scope.uMaterialsName = info[i].MaterialsName;
                    $scope.uMaterialscode = info[i].Materialscode;
                    $scope.udescription = info[i].Description;
                    $scope.vm.PestType = info[i].PestType;
                    if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                        var array = $scope.vm.PestType.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ PestName: value });
                        });
                        $scope.vm.PestType = array1;
                    }
                }
            }
        }


        $scope.sSubmit = function () {
            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.PestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/materials/update",
                    data: {
                        _id: $scope.SID,
                        MaterialsName: $scope.uMaterialsName,
                        Materialscode: $scope.uMaterialscode,
                        Description: $scope.udescription,
                        PestType: $scope.vm.PestType,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },

                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Materialsgrid = true;
                    $scope.Materialsform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/materials/add",
                    data: {
                        MaterialsName: $scope.uMaterialsName,
                        Materialscode: $scope.uMaterialscode,
                        Description: $scope.udescription,
                        PestType: $scope.vm.PestType,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby

                    },


                });

                response.then(function (GList) {
                    if (GList.data.message == "Existing MaterialsName") {
                        $scope.error1 = true;
                        $scope.Materialsform = true;
                        $scope.Materialsgrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.Materialsgrid = true;
                        $scope.Materialsform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Materialsdata.xlsx",{headers:true}) FROM ?', [$scope.Materialsdatas]);
        };
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/materials",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Materialsdata) {
            $scope.Materialsdatas = Materialsdata.data.data;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/materials",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Materialsdata) {
                $scope.Materialsdatas = Materialsdata.data.data;
            });
        }
        function ClearForm() {
            $scope.uMaterialsName = '';
            $scope.uMaterialscode = '';
            $scope.udescription = '';
            $scope.vm.PestType = null;
            vm.selectedItem = '';
            $scope.uCurrencyCode = '';
            $scope.uContactPerson = '';
            $scope.uRemarks = '';
            $scope.uAddress = '';
            $scope.uStartDate = null;
            $scope.uEndDate = null;
        }

        var vm = this;

        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        function loadAll() {
            var allStates = 'Afghanistan,  Aland Islands,  Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Antarctica, Antigua And Barbuda, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Bosnia And Herzegovina, Botswana, Bouvet Island, Brazil, British Indian Ocean Territory, Brunei Darussalam, Bulgaria, Burkina Faso, Burundi, Cambodia, Cameroon, Canada, Cape Verde, Cayman Islands, Central African Republic, Chad, Chile, China, Christmas Island, Cocos (Keeling) Islands, Colombia, Comoros, Congo, Congo,  The Democratic Republic Of The, Cook Islands, Costa Rica,   Croatia, Cuba, Cyprus, Czechia, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Falkland,  Islands (Malvinas), Faroe,  Islands, Fiji, Finland, France, French,  Guiana, French, Polynesia, French, Southern, \
            Territories, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guinea-bissau, Guyana, Haiti, Heard Island And Mcdonald Islands, Holy See (Vatican City State), Honduras, Hong Kong, Hungary, Iceland, India, Indonesia, Iran,  Islamic Republic Of, Iraq, Ireland, Isle Of Man, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Korea, Republic Of, Kuwait, Kyrgyzstan, LaoPeoples,  Democratic,  Republic, Latvia, Lebanon, Lesotho, Liberia, Libyan Arab Jamahiriya, Liechtenstein, Lithuania, Luxembourg, Macao, Macedonia,  The Former Yugoslav Republic Of, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Micronesia,  Federated States Of, Moldova,  Republic Of, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, \
            Netherlands Antilles, New Caledonia, New Zealand, Nicaragua, Niger, Nigeria, Niue, Norfolk Island, Northern Mariana Islands, Norway, Oman, Pakistan, Palau, Palestinian Territory,  Occupied, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Puerto Rico, Qatar, Reunion, Romania, Russian Federation, Rwanda, Saint Helena, Saint Kitts And Nevis, Saint Lucia, Saint Pierre And Miquelon, Saint Vincent And The Grenadines, Samoa, San Marino, Sao Tome And Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Georgia And The South Sandwich Islands, Spain, Sri Lanka, Sudan, Suriname, Svalbard And Jan Mayen, Swaziland, Sweden, Switzerland, Syrian Arab Republic, Taiwan,  Province Of China, Tajikistan, Tanzania,  United Republic Of, Thailand, Timor-leste, Togo, Tokelau, Tonga, Trinidad And Tobago, Tunisia, Turkey, Turkmenistan, Turks And Caicos Islands, \
            Tuvalu, Uganda, Ukraine, United Arab,  Emirates, United Kingdom, United States, United States,  Minor Outlying,  Islands, Uruguay, Uzbekistan, Vanuatu, Venezuela, Viet Nam, Virgin Islands,  British, Virgin Islands,  U.S., Wallis And Futuna, Western Sahara, Yemen, Zambia, Zimbabwe';

            return allStates.split(/, +/g).map(function (state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        function searchTextChange(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }


    }
})();
 
(function () {
    'use strict';

    angular
        .module('app.operations.flexischeduler', []  )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.flexischeduler', {
            url: '/customscheduler',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/flexischeduler/flexischeduler.html',
                    controller: 'flexischedulerController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.flexischeduler')
        .controller('flexischedulerController', flexischedulerController);
    /** @ngInject */
    function flexischedulerController($scope, $rootScope, $interval, socket, $mdSidenav, $filter, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document, $window, $locale, NgMap, Upload) {
        document.getElementsByTagName('title')[0].text = "Operations-Daily Scheduler"
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Scheduler")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }

        // capitalize first letter
        String.prototype.capitalize = function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        }



        $rootScope.CreatedBy = localStorage.getItem('LoginID');
        var vm = this;
        vm.Formvalid = true;
        $scope.vm.ExpiredDate = 7
        $scope.StDate = new Date()
        $scope.EnDate = new Date()
        vm.Date = new Date();
        // GetCWCdatas()
        $scope.ServiceAddressarray = [];
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.ServiceAddressarray = [];
            $scope.CustomerServicedatas = [];
            $scope.vm.Location = null;
            $scope.vm.CompanyName = '';
            $scope.vm.WorkOrderNo = '';
            $scope.vm.ContractNo = '';
            $scope.vm.PestType = '';
            $scope.vm.SO = '';

        };
        $scope.Submit = function () {
            var item = $scope.calenderdata.filter(function (item) {
                // return item.Team_Id === $scope.vm.TeamName && $scope.vm.ServiceStartDate.getTime() >= item.startDate.getTime() && $scope.vm.ServiceStartDate.getTime() < item.endDate.getTime()
                if (item.Team_Id === $scope.vm.TeamName) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Team in this time slot !').position('top center'));
            }
            var item = $scope.calenderdata.filter(function (item) {
                if (item.Customer_id === $scope.vm.Customer_id) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Customer in this time slot !').position('top center'));
            }
            else {

                var ASchearray = [];

                $scope.vm.ServiceOn = $filter('date')(new Date(), 'EEEE');

                angular.forEach($scope.ServiceAddressarray, function (value) {
                    ASchearray.push({
                        JobsOrders: $scope.vm.WorkOrder_id,
                        Customer: $scope.vm.Customer_id,
                        AssignedTo: $scope.vm.TeamName,
                        ServiceOn: $scope.vm.ServiceOn,
                        Status: "Yet to Start",
                        JobType: $scope.vm.JobType,
                        Startsat: new Date($scope.vm.ServiceStartDate.getTime()),
                        Endsat: new Date($scope.vm.ServiceEndDate.getTime()),
                        PestType: $scope.vm.PestType,
                        JobContinues: 'No',
                        ContractOrder: $scope.vm.ContractOrder,
                        Types: $scope.vm.SchedulingType,
                        Location: value.getLocation,
                        ContactNumber: value.sMobile,
                        ContactPerson: value.sContactPerson,
                        CustomerService_Id: value._id,
                        ScheduleType: "Custom",
                        LatLong: value.LatLong,
                        AllowBillableExport: false,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    })
                })
                // }
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/addbyarray",
                    data: { ServiceArray: ASchearray },
                }).then(function (GList) {
                    ASchearray = [];
                    $scope.ServiceAddressarray = [];
                    $scope.vm.CompanyName = '';
                    $scope.vm.WorkOrderNo = '';
                    $scope.vm.ContractNo = '';
                    $scope.vm.PestType = '';
                    $scope.vm.JobType = '';
                    $scope.vm.Location = '';
                    $scope.vm.Location = '';
                    $scope.vm.ServiceStartDate = null;
                    $scope.vm.ServiceEndDate = null
                    $mdDialog.cancel();
                    LoadSchedulerData();
                    // GetCWCdatas()
                });
            }
        };

        $scope.AddComents = function (e, SId, CancelledTab) {
            $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            CleanAddComments();
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/addcoments.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function flexischedulerController($scope, NgMap, $locale, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.SalesOrderNo = '';
            $scope.vm.ContractReferenceNo = '';
            $scope.vm.CompanyName = '';
            $scope.vm.Types = '';
            $scope.vm.EmailSentTo = '';
            $scope.vm.ScedulId = SId;
            $scope.File_id = SId;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            $scope.Billable = { value: true };
            $scope.CollectPayment = { value: false };
            if (CancelledTab != true) {
                var item = $scope.DragScheduledJobs.filter(function (item) {
                    return item._id === SId;
                })[0];

                $scope.vm.ServiceID = item.ServiceID;
                try {
                    $scope.vm.ContractOrder = item.Contracterdetails[0].ContractReferenceNo;
                } catch (e) {
                    $scope.vm.ContractOrder = 'Ad-hoc Job'
                }
                $scope.vm.CompanyName = item.customerdetails[0].CompanyName
                $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
                $scope.vm.PestType = item.PestType;
                if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                    var array = $scope.vm.PestType.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ PestName: value });
                    });
                    $scope.Pestdatas = array1;
                    $scope.vm.PestType = array1;
                }
                getLastCompletedJob(item.JobOrdersdetails[0]._id)
                $scope.vm.Types = item.Types;
                $scope.vm.JobType = item.JobType;
                $scope.vm.PestType1 = item.PestType;
                $scope.vm.Customer_Id = item.Customer
                $scope.vm.Location = item.Location;
                $scope.vm.Status = item.Status;
                $scope.vm.Remarks = item.SpecialRemark
                $scope.CreatedBy = item.CreatedBy;
                $scope.CreatedDate = new Date(item.CreateDate);
                $scope.vm.Notes = item.AccountsNotes
                $scope.vm.Message = item.Message
                $scope.InProgressedBy = "";
                $scope.InProgresseAt = null;
                var address = $scope.vm.Location || 'Singapore';
                var geocoder = new google.maps.Geocoder();
                if (geocoder) {
                    geocoder.geocode({
                        'address': address
                    }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            $scope.latlng = [];
                            $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        }
                    });
                }
            }
            RefreshAttachmentGrid();
            Refreshcomment();
            RefreshServiceMaterials();
            RefreshMobileLogMaterials();
            RefreshSchedulerLogs();
        }

        $scope.sendEmailPop = function (e) {
            $scope.Emaildatas = []
            angular.forEach($scope.Todaydatas, function (value, key) {
                var email = []
                email.push(value.CustomerEmail)
                email.push(value.ClientEmail)
                if (value.TeamName == undefined) {
                    value.TeamName = getTeamName(value.Team_Id)
                }
                $scope.Emaildatas.push({
                    code: key + 1,
                    _id: value.id,
                    ServiceId: value.ServiceID,
                    CusName: value.CustomerName,
                    TeamName: value.TeamLead,
                    CusEmail: email.map(function (o) { return o }).join(','),
                    TeamFullName: value.TeamName,
                    Startsat: value.startDate,
                    PestType: value.PestType,
                    ContactPerson: value.SiteContactName,
                    Location: value.Location,
                    TeamLead: value.TeamLead,
                    TechnicianName: value.TeamMembers
                })
            })
            console.log($scope.Emaildatas)
            // $("#popup").dxPopup({
            //     visible: true,
            //     title: 'Send Schedule',
            //     width: 800,
            //     height: 'auto',
            //     position: {
            //         my: 'center',
            //         at: 'center',
            //         of: window
            //     },
            //     dragEnabled: true,
            //     contentTemplate: function (e) {
            //         var formContainer = $("<div id='formcont'>");

            //         formContainer.append();
            //             var grid = $("<div>");
            //             formContainer.append(grid);
            //             grid.dxDataGrid({
            //                 onInitialized: function (e) {
            //                     $scope.gridInstance = e.component;
            //                 },
            //                 dataSource: $scope.Emaildatas,
            //                 showColumnLines: true,
            //                 showRowLines: true,
            //                 rowAlternationEnabled: true,
            //                 showBorders: true,
            //                 headerFilter: false,
            //                 keyExpr: "code",
            //                 paging: {
            //                     enabled: true,
            //                     pageSize: 10
            //                 },
            //                 searchPanel: {
            //                     visible: true,
            //                     highlightCaseSensitive: true,
            //                     width: 300
            //                 },
            //                 // selection: {
            //                 //     mode: "multiple"
            //                 // },
            //                 // groupPanel: {
            //                 //     visible: false
            //                 // },
            //                 // allowColumnResizing: true,
            //                 columns: [
            //                     {
            //                         caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            //                             cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
            //                         }
            //                     },
            //                     { dataField: "CusName", caption: "Customer Name" },
            //                     { dataField: "TeamName", caption: "Team Name" },
            //                     { dataField: "ServiceId", caption: "Service Id" },
            //                     { dataField: "CusEmail", caption: "Customer Email" }
            //                     // { dataField: "TecEmail", caption: "Technician Email" }
            //                 ],
            //                 bindingOptions: {
            //                     dataSource: "Emaildatas"
            //                 },
            //                 onSelectionChanged: function (e) {
            //                     if (e.selectedRowKeys.length > 0) {
            //                         $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
            //                     }
            //                     else
            //                         $scope.SelectedMail = []
            //                 },
            //             })

            //         formContainer.append($("<br><br><div style= 'margin-left:42%'>").dxButton({
            //             text: 'Update',
            //             type: "default",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //                 UpdateSchedule($scope.vm.ID, $scope.StartDate, $scope.EndDate, $scope.TeamID, null);
            //                 showToast("Updated Successfully", ' ', "info");
            //             }
            //         }));
            //         formContainer.append($("<div style= 'margin-left:2%'>").dxButton({
            //             text: 'Cancel',
            //             type: "normal",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //             }
            //         }));
            //         e.append(formContainer);
            //     }
            // });
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/EmailConfirmation.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.Emaildatas = []
        $scope.SelectedMail = []
        vm.EmailDataGrid = {
            // onContentReady: function (e) {
            //     e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            // },
            dataSource: $scope.Emaildatas,
            columnResizingMode: "widget",
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            headerFilter: false,
            keyExpr: "code",
            paging: {
                enabled: true,
                pageSize: 10
            },
            searchPanel: {
                visible: true,
                highlightCaseSensitive: true,
                width: 300
            },
            selection: {
                mode: "multiple"
            },
            // groupPanel: {
            //     visible: false
            // },
            // allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "CusName", caption: "Customer Name" },
                { dataField: "TeamName", caption: "Team Name" },
                { dataField: "ServiceId", caption: "Service Id", sortOrder: 'asc' },
                { dataField: "CusEmail", caption: "Customer Email" }
                // { dataField: "TecEmail", caption: "Technician Email" }
            ],
            bindingOptions: {
                dataSource: "Emaildatas"
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
                }
                else
                    $scope.SelectedMail = []
            },
        }

        $scope.SendEmail = function () {
            if ($scope.SelectedMail.length > 0) {
                $scope.SelectedMail = _.uniqWith($scope.SelectedMail, _.isEqual)
                var group = _.groupBy($scope.SelectedMail, '_id')
                var SendEmaildatas = []
                angular.forEach(group, function (value) {
                    SendEmaildatas.push({
                        _id: value[0]._id,
                        ServiceID: value[0].ServiceId,
                        CusName: value[0].CusName,
                        CusEmail: value[0].CusEmail,
                        TeamName: value.map(function (o) { return o.TeamFullName }).join(','),
                        Startsat: value[0].Startsat,
                        PestType: value[0].PestType,
                        ContactPerson: value[0].ContactPerson,
                        Location: value[0].Location,
                        TeamLead: value.map(function (o) { return o.TeamLead }).join(','),
                        TechnicianName: value.map(function (o) { return o.TechnicianName }).join(',')
                    })
                })
                var response = $http({
                    method: 'POST',
                    url: $rootScope.WebURL + "/scheduler/SendEmail",
                    data: { Array: SendEmaildatas }
                })
                response.then(function (GList) {
                    $scope.SelectedMail
                })
                $mdToast.show($mdToast.simple().textContent('Email Sent.').position('top center'));
                $mdDialog.cancel()
            }
            else
                $mdToast.show($mdToast.simple().textContent('Sorry No data Available.').position('top center'));

        }


        // For Whatsapp

        $scope.SendWhatsap = function (e) {

        }

        function SubmitForDrag(ID, Start, End, Team) {
            Start = new Date(Start)
            End = new Date(End)
            var ServiceOn = $filter('date')(new Date(Start), 'EEEE');
            var Assigned = null
            var team = []
            var TeamName = null
            var TeamMembersName = null
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === ID
            })[0];
            var diffTime = moment(new Date(new moment(new Date(item.Endsat).toTimeString(), 'HH:mm:ss'))).diff(moment(new Date(new moment(new Date(item.Startsat).toTimeString(), 'HH:mm:ss'))), 'minutes')
            End = new Date(moment(Start).add(diffTime, 'minutes'))
            if (item.Team_Id != null && item.Team_Id != undefined) {
                if (item.Team_Id.length == 1) {
                    Assigned = Team
                    team.push(Team)
                    // var Estimation = parseInt(item.JobOrdersdetails[0].EstimatedHoursRequired)
                    // if(Estimation!=NaN)
                    // End = new Date(moment(Start).add(Estimation, 'hour'))
                    // else
                    // End = new Date(moment(Start).add(1, 'hour'))
                    TeamName = getTeamName(Team)
                    TeamMembersName = getTeamMembers(Team)
                }
                else {
                    team = item.Team_Id
                    Assigned = item.AssignedTo
                    TeamName = item.TeamName
                    TeamMembersName = item.TeamMembersName
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/DragandDropUpdate",
                data: {
                    _id: ID,
                    AssignedTo: Assigned,
                    Team_Id: team,
                    Startsat: Start,
                    Endsat: End,
                    TeamName: TeamName,
                    TeamMembersName: TeamMembersName,
                    ServiceOn: ServiceOn,
                    IsDropped: true,
                    OldDate: item.Startsat,
                    OldEndDate: item.Endsat,
                    UpdatedBy: $rootScope.createdby
                },
            }).then(function (item) {
                $mdToast.show($mdToast.simple().textContent('Job Scheduled Successfully.').position('top center'));
                LoadSchedulerData()
            })
            try {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                        ServiceId: ID,
                        ServiceID: item.ServiceID,
                        CustomerName: item.customerdetails[0].CompanyName,
                        Status: item.Status,
                        PreviousStartsat: item.Startsat,
                        PreviousEndsat: item.Endsat,
                        Startsat: startDate,
                        Endsat: endDate,
                        PestType: item.PestType,
                        TeamName: item.teamdetails[0].TeamName,
                        TeamLead: item.teamdetails[0].TeamLead,
                        TeamMember: item.teamdetails[0].TeamMembers,
                        Acknowledged: null,
                        AcknowledgedBy: null,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true
                    },
                }).then(function (GList) {
                });
            } catch (error) {

            }
        }

        $scope.Refresh = function () {
            $("#scheduler").dxScheduler('instance').repaint();
            $("#NewDataGrid").dxDataGrid("instance").state({})
            // angular.forEach($scope.teamdatas, function (value) {
            //     $scope.Team.push(value.id)
            // });
            RefreshGrid()

            // LoadSchedulerData();
        };



        LoadTeam();
        var resourcesData = [{
            text: "Fixed Jobs",
            id: 1,
            color: "#1e93c2"
        }, {
            text: "Contract Jobs",
            id: 2,
            color: "#29824d"
        }, {
            text: "Urgent Jobs",
            id: 3,
            color: "#FF0000"
        },
        {
            text: "Extra Jobs",
            id: 4,
            color: "#ff9747"
        },
        {
            text: "Fixed Jobs Completd",
            id: 5,
            color: "#76b3d2"
        },
        {
            text: "Contract Jobs Completd",
            id: 6,
            color: "#8dd4aa"
        },
        {
            text: "Urgent Jobs Completd",
            id: 7,
            color: "#ea9292"
        },
        {
            text: "Employee Leave",
            id: 9,
            color: "#FF9800"
        },
        {
            text: "Scheduler Service",
            id: 10,
            color: "#1527a9"
        },
        {
            text: "Scheduler Service completed",
            id: 11,
            color: "#7682de"
        }];

        $scope.Zonedata = [
            { id: 1, text: "Team South" },
            { id: 2, text: "Team East" },
            { id: 3, text: "Team West Rosdy - WEST" },
            { id: 4, text: "Richard - SOUTH" }

        ]
        $scope.uFrom = new Date();
        $scope.uTo = new Date();

        $scope.getAppointmentColor = getAppointmentColor;

        function getAppointmentColor(resourceId) {
            return DevExpress.data.query(resourcesData)
                .filter("id", resourceId)
                .toArray()[0].color;
        }

        function getTeamName(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamName
        }
        function getTeamLead(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamLead
        }
        function getTeamMembers(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamMembers
        }

        $scope.getListdata = function (s, p) {
            var item = $scope.Extradatas.filter(function (item) {
                return item.priority === p && item.startDate >= s && item.startDate <= s
            })
            return item
        }
        var sccount = 0
        function BindScheduler() {
            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }
            $scope.schedulerOptions = {
                dataSource: $scope.calenderdata,
                views: ["timelineDay", "timelineMonth"],
                currentView: "timelineDay",
                currentDate: $scope.uFrom,
                // adaptivityEnabled: true,
                firstDayOfWeek: 1,
                startDayHour: 6,
                endDayHour: 24,

                cellDuration: 30,
                crossScrollingEnabled: true,
                useDropDownViewSwitcher: false,
                showAllDayPanel: false,
                groups: ["priority"],
                resources: [{
                    fieldExpr: "ownerId",
                    allowMultiple: false,
                    deep: true,
                    dataSource: resourcesData,
                    label: "Owner",
                    useColorAsDefault: true
                }, {
                    fieldExpr: "priority",
                    allowMultiple: false,
                    dataSource: $scope.Teamdatass,
                    label: "Priority"
                }],
                dataCellTemplate: function (cellData, index, container) {
                    if ($scope.ViewOption != "timelineMonth") {
                        var date = new Date(cellData.startDate).getHours() + ":" + (new Date(cellData.startDate).getMinutes() == 0 ? '00' : new Date(cellData.startDate).getMinutes())
                        return $("<div style='color:#afacac ; padding-left: 30%;font-size: 12px;'>").text(date);
                    }
                },
                // appointmentTooltipTemplate: "appointment-template",
                // appointmentTemplate: function (data) {
                //     if (data.FLength == false) {
                //         return $("<div class='showtime-preview'>" +
                //             "<div>" + data.CustomerName + "</div>" +
                //             "<div>Team : " + data.TeamName + "</strong>" +
                //             "</div></div>");
                //     }
                //     else {
                //         return $("<div class='showtime-preview'>" +
                //             "<div><strong>" + data.Plength + " more Appointments</strong> </div> </div>");
                //     }

                // },
                onContentReady: function (e) {
                    $("#scheduler .dx-scrollable").dxScrollable({
                        showScrollbar: 'always'
                    });
                    var data = e.component.option("dataSource");
                    var Contract = 0
                    var Ad_hoc = 0
                    if (data) {
                        data.forEach(function (d) {
                            var billingAmount = d.BillingAmount || 0;
                            var jobType = (d.JobType || '').toLowerCase();

                            if (jobType === "ad-hoc") {
                                Ad_hoc += billingAmount;
                            }

                            if (jobType === "contract" || jobType === "fixed") {
                                Contract += billingAmount;
                            }
                        });
                        var $header = e.element.find(".dx-scheduler-header");

                        // Remove existing heading if present
                        $header.find(".custom-heading").remove();

                        // Add the new updated one
                        $header.append(
                            '<div class="custom-heading">Contract - S$ ' + Contract.toFixed(2) + ' & Ad-Hoc - S$ ' + Ad_hoc.toFixed(2) + '</div>'
                        );
                    }
                },
                onAppointmentClick: function (e) {
                    e.cancel = true
                    if (e.appointmentData.ownerId == 10) {
                        $scope.ServiceUpdate = true
                        $scope.ServiceUpdateID = e.appointmentData.id
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.ServiceTeamId = e.appointmentData.priority
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        $scope.vm.dateBox1 = {
                            ResheduleSSTime: {
                                type: "time",
                                value: $scope.serviceStartTime,
                                onValueChanged: function (e) {
                                    $scope.serviceStartTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'Start'
                                //   }
                            },
                            ResheduleSETime: {
                                type: "time",
                                value: new Date($scope.ServiceEndTime),
                                onValueChanged: function (e) {
                                    $scope.vm.AvoidEndTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'end'
                                //   }
                            }
                        }
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'app/main/apps/operations/flexischeduler/Popup.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function flexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    if (e.appointmentData.ownerId == 11) {
                        $scope.vm.ScheduleServiceId = e.appointmentData.id;
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        RefreshPhotos();
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'app/main/apps/operations/flexischeduler/addcoments.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function flexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    else
                        OnAppointmentClick(e);
                },
                onOptionChanged: function (sdata) {
                    // if (sdata.value == "week") {
                    //     $scope.ViewOption = "week"
                    //     $scope.WeekViewGrid = false
                    //     $scope.WeekDate = new Date()

                    // }
                    if (sdata.value == "timelineDay") {
                        $scope.WeekViewGrid = true
                        $scope.ViewOption = undefined
                        $scope.Datefilter()
                    }
                    else if (sdata.value == "timelineMonth") {
                        $scope.WeekViewGrid = true
                        $scope.ViewOption = "timelineMonth"
                        var sdate = new Date()
                        sdate.setDate(1)
                        var edate = new Date(sdate.getFullYear(), sdate.getMonth() + 1, 0);
                        LoadSchedulerDataforMonth(sdate, edate)
                    }

                    else if (sdata.value instanceof Date) {
                        if ($scope.ViewOption == "timelineMonth") {
                            var sdate = new Date(sdata.value)
                            sdate.setDate(1);
                            var edate = new Date(sdate.getFullYear(), sdate.getMonth() + 1, 0);
                            LoadSchedulerDataforMonth(sdate, edate)
                        }
                        else {
                            $scope.vm.Date = new Date(sdata.value)
                            try {
                                vm.Date = new Date(sdata.value)
                            } catch (e) { }
                            $scope.Datefilter()
                        }


                    }
                    if ($scope.ViewOption == "timelineDay") {
                        try {
                            if (sdata.element.context != undefined)
                                sdata.element.context.children[0].childNodes[0].childNodes[1].children[0].innerText = moment($scope.vm.Date).format('D MMM YYYY (ddd)');
                        } catch (e) { $scope.Refresh() }
                    }
                    //    sdata.component._header._navigator._$element[0].innerText = "sdfsd"
                },
                onCellClick: function (e) {
                    $scope.userpopup(e, e.cellData.startDate, e.cellData.endDate, e.cellData.groups.priority)
                },
                onAppointmentDblClick: function (e) {
                    $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
                    OnAppointmentClick(e);

                },
                appointmentTemplate: function (model, itemIndex, itemElement) {
                    var count = Math.floor((Math.random() * 10) + 1)
                    if (model.ClientInformed == false)
                        $scope.schedulerimage = "assets/images/logos/triangle.png"
                    else
                        $scope.schedulerimage = ""
                    var appointment = model
                    var Location = ""
                    var cssClass = "";
                    try {
                        if (appointment.text.includes('Service ID'))
                            Location = "Postal:- " + appointment.Location.substring(appointment.Location.lastIndexOf(" ") + 1)
                        if (appointment.ownerId == 10)
                            Location = "Address:- " + appointment.Description
                    } catch (error) {
                        Location = ""
                    }

                    var div = ""
                    var div1 = ""
                    if (model.Notes != undefined && model.Notes != null && model.Notes != "")
                        div = "&nbsp;<span class='dot1' style='background: #eebb4d;'></span>"

                    if (model.Message != undefined && model.Message != null && model.Message != "")
                        div1 = "&nbsp;<span class='dot1' style='background: #5f22af;'></span>"

                    if (model.IsUrgent == true || model.IsUrgent == "true")
                        cssClass = "blackcolor"
                    else
                        cssClass = "whiteColor"
                    //     return $("<div class='showtime-preview>" + 
                    //     "<div class="+cssClass+">" + appointment.text + "</div>" +

                    //     "<div class="+cssClass+"> Postal:-" + Location + "</div>" +
                    //     "<div class="+cssClass+">" +new Date(appointment.startDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+"-"+new Date(appointment.endDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+ "</div>" +
                    //    div+"</div>"); 
                    $scope.schedulerimage ? itemElement.append("<img src='" + $scope.schedulerimage + "' width='30' height='30' style='position: absolute; right: 0; top: 0;'/>") : null;
                    itemElement.append("<div class='" + cssClass + "'>" + appointment.text + "</div>");
                    itemElement.append("<div class='" + cssClass + "'>" + Location + "</div>")
                    itemElement.append("<div class='" + cssClass + "'>" + new Date(appointment.startDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + "-" + new Date(appointment.endDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + div + div1 + "</div>" +
                        "</div>");

                },
                onAppointmentRendered: function (e) {
                    var appointment = e.appointmentElement;
                    var draggableAppointment = appointment.dxDraggable("instance");
                    draggableAppointment.option("area", "body");
                    e.appointmentElement.on("dxdragstart", function (evt) {
                        appointmentData = $(evt.currentTarget).data("dxItemData");
                        e.element.find(".dx-scrollable-content").css("overflow", "visible");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "visible");
                    });
                    e.appointmentElement.on("dxdragend", function (evt) {
                        e.element.find(".dx-scrollable-content").css("overflow", "hidden");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "hidden");
                    });
                },
                onAppointmentUpdating: function (data) {
                    if (data.newData.FLength == true && (data.newData.ownerId != 5 && data.newData.ownerId != 6 && data.newData.ownerId != 7)) {
                        var _id = data.newData.id,
                            startDate = data.newData.startDate,
                            endDate = data.newData.endDate,
                            Team_Id = data.newData.priority,
                            CustomerID = data.newData.Customer_id,
                            oldTeam = data.oldData.priority;
                        UpdateSchedule(_id, startDate, endDate, Team_Id, oldTeam);
                    }
                    else {
                        data.cancel = true;
                        return;
                    }
                },
                onAppointmentDeleting: function (data) {
                    // if (data.appointmentData.ownerId == 2) {
                    //     $mdToast.show($mdToast.simple().textContent('Update not allowed, job is started !').position('top center'));
                    //     data.cancel = true;
                    //     return 
                    // }
                    // if (data.appointmentData.ownerId == 3) {
                    //     $mdToast.show($mdToast.simple().textContent('Delete not allowed,job already completed !').position('top center'));
                    //     data.cancel = true;
                    //     return;
                    // }
                    // if (data.appointmentData.ownerId == 5) {
                    //     $mdToast.show($mdToast.simple().textContent('Delete not allowed,job already completed !').position('top center'));
                    //     data.cancel = true;
                    //     return;
                    // }
                    var _id = data.appointmentData.id;
                    DeleteSchedule(_id);
                },
                onAppointmentUpdated: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully.').position('top center'));
                    // showToast("Updated Successfully", ' ', "info");
                },
                onAppointmentDeleted: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                    // showToast("Deleted Successfully", "", "warning");
                },

                bindingOptions: {
                    'dataSource': 'calenderdata',
                    "resources[1].dataSource": 'Teamdatass'

                },
                // height: $scope.Team.length>5?600: ""
            };

            $scope.vm.PreviewSpinner = false;
        }
        $timeout(function () {

            LoadSchedulerData()

        }, 3000);

        // $scope.markWeekEnd = function (cellData) {
        //     function isWeekEnd(date) {
        //         const day = date.getDay();
        //         return day === 0 || day === 6;
        //     }
        //     const classObject = {};
        //     classObject["employee-" + cellData.groups.employeeID] = true;
        //     classObject['employee-weekend-' + cellData.groups.employeeID] = isWeekEnd(cellData.startDate);
        //     return classObject;
        // };

        // $scope.markTraining = function (cellData) {
        //     const classObject = {
        //         "day-cell": true
        //     };

        //     classObject[getCurrentTraining(cellData.startDate.getDate(), cellData.groups.employeeID)] = true;
        //     return classObject;
        // };

        // function getCurrentTraining(date, employeeID) {
        //     var result = (date + employeeID) % 3,
        //         currentTraining = "training-background-" + result;

        //     return currentTraining;
        // }

        $scope.WeekViewGrid = true
        var scheduler;
        var appointmentData;
        $scope.dropped = function (e) {
            var ServiceId = e.draggingElement.outerHTML.split(':')[1].substr(1, 12).trim()
            var item = $scope.AllSchedulerDatas.filter(function (item) {
                return item.ServiceID === ServiceId
            })[0]
            if (item != undefined) {
                // if (item.ownerId != 1) {
                var ServiceOn = $filter('date')(new Date(item.Startsat), 'EEEE');
                $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/scheduler/DragandDropUpdate",
                    data: {
                        _id: item._id,
                        AssignedTo: item.AssignedTo,
                        Team_Id: item.Team_Id,
                        TeamName: item.TeamName,
                        TeamMembersName: item.TeamMembersName,
                        Startsat: item.Startsat,
                        Endsat: item.Endsat,
                        ServiceOn: ServiceOn,
                        IsDropped: false,
                        UpdatedBy: $rootScope.createdby

                    },
                }).then(function (item) {
                    $mdToast.show($mdToast.simple().textContent('Job Unscheduled Successfully.').position('top center'));
                    LoadSchedulerData()
                })
                // }
                // else {
                //     $mdToast.show($mdToast.simple().textContent('Contract (Fixed) jobs cannot be updated.').position('top center'));
                // }
            }

        };

        vm.dataGridSalesOrderNew = {
            onContentReady: function (e) {
                scheduler = e.component;
                $(".dx-scheduler-date-table-cell").on("dxdrop", function (ex) {
                    $scope.DragCount++
                    if ($scope.DragCount == 1) {
                        var cellData = $(ex.target).data("dxCellData");
                        var start = cellData.startDate.getTime();
                        var end = cellData.endDate.getTime();
                        var team = cellData.groups.priority
                        var text = $(ex.draggingElement).data("text");

                        // if(ex.draggingElement.offsetTop<750){
                        $(ex.draggingElement).css("visibility", 'hidden');
                        SubmitForDrag($scope.DragID, start, end, team)
                        // }
                        //   
                    }
                    // scheduler.addAppointment({ startDate: start, endDate: end, text: text });


                });
                // get descendant of scheduler element which is a div with class dx-scrollable-container

            },

            rowTemplate: function (container, item) {
                var data = item.data;
                // try{
                //     data.CustomerName = data.customerdetails[0].CompanyName
                //     data.SMobile = data.customerServicedetails[0].sMobile
                // }
                // catch(e){
                //     data.CustomerName =""
                //     data.SMobile =""
                // }

                var result = $("<tbody class='employee dx-row " + ((item.rowIndex % 2) ? 'dx-row-alt' : '') + "'>");
                if ((item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1) <= $scope.NewSheduledJobs.length) {
                    result.attr('id', 'drag_' + item.data._id);
                    result.on({
                        "dxdrag": dragged,
                        "dxdragstart": dragStarted,
                        "dxdragend": dragStopped
                    });
                    $("<tr class='main-row'>").appendTo(result);
                    $("<td align='center'style=' border: 1px solid #ddd'>").text(item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1).appendTo(result);
                    if (data.AccountsNotes != undefined && data.AccountsNotes != null && data.AccountsNotes != "")
                        $("<td align='center' style=' border: 1px solid #ddd ; color:orange'>").text(data.ServiceID).appendTo(result);
                    else
                        $("<td align='center' style=' border: 1px solid #ddd ; color:blue'>").text(data.ServiceID).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.TeamName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SiteName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SMobile).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.Location).appendTo(result);
                    // $("<td align='center' style=' border: 1px solid #ddd'>").text(new Date(data.Startsat)).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(new Date(data.Startsat).toLocaleDateString('en-GB')).appendTo(result);
                    // if(data.JobType=="Fixed")
                    // $("<td  align='center' style=' border: 1px solid #ddd'>").text('Contract (Fixed)').appendTo(result);
                    // else if(data.JobType=="Contract")
                    // $("<td  align='center' style=' border: 1px solid #ddd'>").text('Contract (Flexible)').appendTo(result);
                    // else
                    // $("<td  align='center' style=' border: 1px solid #ddd'>").text('Ad-hoc').appendTo(result);

                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PostalZone).appendTo(result);
                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PestCode).appendTo(result);
                    var Prefred = ""
                    var Avoid = ""
                    if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                        Prefred = new Date(data.PreferredStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.PreferredEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                        Avoid = new Date(data.AvoidStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.AvoidEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    $("<td  align='center' style=' border: 1px solid #ddd;color:green'>").text(Prefred).append('<p style="color:red"> ' + Avoid + "</p>").append('<p style="color:black"> ' + data.PreferredTime + "</p>").appendTo(result);

                    // if(data.AvoidStartTime!=null && data.AvoidStartTime!=undefined && data.AvoidStartTime!="")
                    // $("<td  align='center' style=' border: 1px solid #ddd;'>").text(new Date(data.AvoidStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) +" - "+ new Date(data.AvoidEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })).appendTo(result);
                    // else
                    // $("<td  align='center' style=' border: 1px solid #ddd;'>").text("").appendTo(result);
                    // $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.Status).appendTo(result);
                    // if (data.JobOrdersdetails[0].IsUrgent == true) {
                    //     $('<td style=" border: 1px solid #ddd">').dxButton({
                    //         height: 40,
                    //         icon: 'warning',
                    //     }).appendTo(result);
                    // }
                    // else {
                    //     $("<td  align='center' style=' border: 1px solid #ddd'>").text("").appendTo(result);
                    // }
                    $("</tr>").appendTo(result);
                }

                // else {
                //     result.attr('id', 'drag_' + i);
                //     $("<tr class='main-row'>").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     // $("<td>").text("").appendTo(result);
                //     // $("<td>").text("").appendTo(result);
                //     $("<td >").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     // $("<td >").text("").appendTo(result);
                //     // $("<td >").text("").appendTo(result);
                //     $("<td>").text("").appendTo(result);
                //     $("</tr>").appendTo(result);


                // }
                container.append(result);
            },
            dataSource: $scope.DragScheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            columnAutoWidth: false,
            wordWrapEnabled: true,
            width: "100%",
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            // pager: {
            //     showPageSizeSelector: true,
            //     allowedPageSizes: [5, 10, 20,],
            //     showInfo: true
            // },
            sorting: {
                mode: "single"
            },
            // selection: {
            //     mode: "single",
            //     showCheckBoxesMode: 'onClick',
            // },
            searchPanel: {
                visible: false,
                width: 320,
                placeholder: "Search..."
            },
            // filterRow: {
            //     visible: true,
            //     applyFilter: "onClick"
            // },
            allowColumnResizing: true,
            onRowPrepared: function (rowInfo) {
                if (rowInfo.rowType != 'data')
                    return;
                rowInfo.rowElement
                    .addClass('myRow')
                    .data('keyValue', rowInfo.key);
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "ServiceID", caption: "Service Id", alignment: 'center', width: 110 },
                { dataField: "TeamName", caption: "Team Name", alignment: 'center' },
                { dataField: "SiteName", caption: "Customer Name", alignment: 'center' },
                { dataField: "Mobile", caption: "Contact No.", alignment: 'center' },
                { dataField: "Location", caption: "Site Address", alignment: 'center' },
                { dataField: "Startsat", caption: "Scheduled Date", alignment: 'center', width: 110, dataType: "date", format: 'dd/MM/yyyy', sortOrder: 'asc' },
                // { dataField: "JobType", caption: "Job Type ", width: 110 },
                { dataField: "PostalZone", caption: "Zone", alignment: 'center', width: 110 },
                { dataField: "PestCode", caption: "Pest Types", alignment: 'center' },
                { dataField: "DateTimeofTreatment", caption: "Preferred Time", alignment: 'center', width: 150 },
                // { dataField: "DateTimeofTreatment", caption: "Avoid Time", alignment: 'center', width: 150 },
                // { dataField: "Status", caption: "Status", alignment: 'center', width: 120 },
                // {
                //     caption: 'VIP?',
                //     // fixed: true,
                //     // fixedPosition: 'right',
                //     width: 80,
                //     height: 10,
                //     alignment: 'center',
                //     allowSorting: false,
                //     // cellTemplate: function (container, options) {
                //     //     if(options.data.IsUrgent==true){
                //     //     $('<div />').dxButton({
                //     //         icon: 'warning'
                //     //     }).appendTo(container);
                //     // }
                // }
                // }
            ],
            onCellClick: function (e) {
                var ID = null
                var item = $scope.DragScheduledJobs.filter(function (item) {
                    return item.ServiceID === e.cellElement.text();
                })[0];
                if (item != undefined)
                    DragTableClick(e.event, item._id)
            },
            bindingOptions: {
                dataSource: "DragScheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",

        }
        var initialTop,
            initialLeft,
            initialPointerY,
            initialPointerX,
            draggedColor = "transparent";

        var dragStarted = function () {
            $(this).css("position", "fixed");
            $(this).css("z-index", 50000);
            $(this).find(".dx-scrollable-content").css("overflow", "visible");
            $(this).find(".dx-scheduler-work-space").css("overflow", "visible");

            $(this).css("background-color", draggedColor);
            initialTop = parseInt($(this).css("top"));
            initialLeft = parseInt($(this).css("left"));
            initialPointerY = arguments[0].clientY;
            initialPointerX = arguments[0].clientX;
        };
        var dragged = function () {
            $(this).css("top", initialTop + arguments[0].clientY - initialPointerY);
            $(this).css("left", initialLeft + arguments[0].clientX - initialPointerX);
        };
        var dragStopped = function () {
            $scope.DragID = this.id.split('_')[1]
            $scope.DragCount = 0
            if (this.offsetTop > 242 && this.offsetTop < 558)
                $(this).css("background-color", "green");
            else {
                $(this).css("background-color", "#cbe5e6");
                // $(this).fadeOut()
                // $("#NewDataGrid").dxDataGrid("instance").state({})
            }
        };
        $scope.SortSDate = true
        $scope.SortZone = true

        $scope.getSortValues = function (value) {
            $scope.SelectedMember = null
            if (value == "Sort by Scheduler Date") {
                if ($scope.SortSDate == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "Startsat")
                    $scope.SortSDate = false

                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "Startsat").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    $scope.SortSDate = true
                }
            }
            else {
                if ($scope.SortZone == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "PostalZone")
                    $scope.SortZone = false
                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "PostalZone").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    // $scope.DragScheduledJobs = (_.sortBy($scope.DragScheduledJobs, "PostalZone")).reverse() 
                    $scope.SortZone = true
                }
            }
        }

        $scope.SortValues = [
            { name: "Sort by Scheduler Date" },
            { name: "Sort by Zone" }
        ]

        // $scope.uShowAdhoc=function(value){
        //     $scope.CWCDatas=[]
        //     if(value){
        //         $http({
        //             method:'POST',
        //             url:'http://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //             data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //         }).then(function(Glist){
        //             var data = Glist.data.data
        //            var item=data.filter(function(item){
        //                return item.Status==='New' || item.Status==='On Going'
        //            })
        //            _.each(item,function(ite){
        //             ite.IsActive = ""
        //            })
        //             $scope.CWCDatas=item
        //             $scope.getSchedulerdatas($scope.TabStatus)
        //         })
        //     }
        //     else
        //     {
        //         GetCWCdatas()
        //     }
        // }

        $scope.GetCWCdatas = GetCWCdatas

        function GetCWCdatas() {
            $scope.StDate.setHours(0, 0, 0, 0)
            $scope.EnDate.setHours(23, 59, 59, 999)
            var array = []
            angular.forEach($scope.teamdatas, function (value) {
                array.push(value.id)
            })
            var response1 = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.StDate,
                    End_Date: $scope.EnDate,
                    Team: array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response1.then(function (GList) {
                var FlexiScheduler = GList.data.data
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.StDate,
                        End_Date: $scope.EnDate,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Status: null,
                        Team_Id: null
                    },
                });
                response.then(function (GList1) {
                    $http({
                        url: $rootScope.WebURL + "/scheduler/getAllOutstandingJobs",
                        method: "POST",
                        data: {
                            Client_Id: $rootScope.Client_Id,
                        },
                    }).then(function (List) {
                        var progerss = List.data.data
                        var data = GList1.data.data;
                        var item = data.filter(function (item) {
                            return item.Status != "Completed" && item.Status != "Cancelled" && item.Status != "Outstanding" && item.VerifiedBy == false
                        })
                        $scope.NewSheduledJobs = item
                        $scope.NewSheduledJobs = $scope.NewSheduledJobs.concat(progerss)
                        var newArray = []
                        if (newArray.length > 0)
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs.concat(newArray)
                        else
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs

                        if ($("#NewDataGrid").dxDataGrid("instance") != undefined)
                            $("#NewDataGrid").dxDataGrid("instance").endCustomLoading()
                        angular.forEach($scope.DragScheduledJobs, function (value) {
                            // var item = FlexiScheduler.filter(function (item) {
                            //     return item._id === value._id
                            // })[0]
                            // if (item != undefined) {
                            //     value.PostalZone = item.PostalZone
                            // }

                            var pest = []
                            var PestArray = []
                            var NewFrequency = value.Frequency.split('||')
                            var TreatmentMethod = []
                            NewFrequency.forEach(function (val) {
                                var iittem = val.split('~')
                                TreatmentMethod.push({
                                    Frequency: iittem[0],
                                    PestName: iittem[1],
                                    Treatment: iittem[2]
                                })

                            })
                            var Frequen = _.groupBy(TreatmentMethod, "Frequency")
                            var FreqString = []
                            if (Object.keys(Frequen).length) {
                                _.each(Frequen, function (Fre, key) {
                                    var data = []
                                    _.each(Fre, function (iitem) {
                                        data.push(iitem.PestName)
                                    })
                                    var PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (data.includes(pestt.PestName)) })
                                    FreqString.push(PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',') + " - " + key.replace(/ *\([^)]*\) */g, ""))

                                })
                            }

                            value.PestCode = FreqString.map(function (o) { return o }).join('; ')

                            try {
                                if (value.customerServicedetails.length > 0) {
                                    value.CustomerName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    value.SMobile = value.customerServicedetails[0].sMobile
                                    if (value.customerServicedetails[0].SName != undefined && value.customerServicedetails[0].SName != null && value.customerServicedetails[0].SName != "")
                                        value.SiteName = value.customerServicedetails[0].SName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'

                                    if (value.customerServicedetails[0].sName != undefined && value.customerServicedetails[0].sName != null && value.customerServicedetails[0].sName != "")
                                        value.SiteName = value.customerServicedetails[0].sName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    else
                                        value.SiteName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'


                                }
                                else {
                                    value.CustomerName = value.customerdetails[0].CompanyName
                                    value.SMobile = ""
                                    value.SiteName = value.customerdetails[0].CompanyName + ' - (' + customerdetails[0].ContactPerson + ')'
                                }
                            } catch (error) {
                                value.SiteName = value.customerdetails[0].CompanyName
                            }

                            try {
                                value.PostalZone = value.zonepostalcodesdetails[0].Zone
                            } catch (error) {
                                value.PostalZone = ""
                            }


                        })
                    })
                })
            })
        }
        function OnAppointmentClick(e) {

            e.cancel = true;
            var item = $scope.TotalDatas.filter(function (item) {
                return item.id === e.appointmentData.id && item.Team_Id === e.appointmentData.Team_Id
            })[0]
            var data = item
            if (data.TeamMembers == undefined) {
                data.TeamMembers = getTeamMembers(data.Team_Id)
            }
            $scope.TeamMembers = data.TeamMembers
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data.id
            $scope.StartDate = data.startDate
            $scope.EndDate = data.endDate
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.CustomerName
            $scope.vm.DServiceAddres = data.ServiceAddres
            $scope.vm.DClientContactName = data.ClientContactName
            $scope.vm.Duplicate = data.Duplicate
            $scope.vm.DuplicateRemarks = data.DuplicateRemarks
            $scope.vm.DSiteContactName = data.SiteContactName
            $scope.vm.DClientEmail = data.ClientEmail
            $scope.vm.DSiteContactNumber = data.SiteContactNumber
            $scope.vm.DCoverageArea = data.CoverageArea
            $scope.vm.DSalesOrderNo = data.SalesOrderNo
            $scope.vm.TotalTeam = data.TotalTeam
            $scope.vm.ManHour = data.ManHour
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            if (data.TeamName == undefined) {
                data.TeamName = getTeamName(data.Team_Id)
            }
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = data.startDate
            $scope.vm.ServiceEndDate = data.endDate
            $scope.vm.PreferedTime = data.PreferedTime
            $scope.vm.jobdata = data.SalesOrder_Id
            $scope.vm.Customer_Id = data.Customer_id
            $scope.vm.ScedulId = data.id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.Notes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob(data.SalesOrder_Id)
            getCustomer(data.Customer_id)
            getContract(data.Contract_Id)
            getSalesOrder(data.SalesOrder_Id)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }

        function DragTableClick(e, SId) {
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === SId;
            })[0];
            var data = item
            $scope.TeamMembers = data.TeamMembersName
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data._id
            $scope.StartDate = new Date(data.Startsat)
            $scope.EndDate = new Date(data.Endsat)
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.customerdetails[0].CompanyName
            $scope.vm.DServiceAddres = data.Location
            $scope.vm.DClientContactName = data.customerdetails[0].ContactPerson
            $scope.vm.DSiteContactName = data.customerServicedetails[0].sContactPerson
            $scope.vm.DClientEmail = data.customerdetails[0].Email
            $scope.vm.DSiteContactNumber = data.customerServicedetails[0].sMobile
            $scope.vm.DCoverageArea = data.JobOrdersdetails[0].CoverageArea
            $scope.vm.DSalesOrderNo = data.JobOrdersdetails[0].SalesOrderNo
            $scope.vm.TotalTeam = data.TeamName
            $scope.vm.ManHour = data.JobOrdersdetails[0].EstimatedHoursRequired
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = new Date(data.Startsat)
            $scope.vm.ServiceEndDate = new Date(data.Endsat)
            $scope.vm.PreferedTime = data.PreferredTime
            $scope.vm.jobdata = data.JobOrdersdetails[0]._id
            $scope.vm.Customer_Id = data.customerdetails[0]._id
            $scope.vm.ScedulId = data._id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.AccountsNotes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob($scope.vm.jobdata)
            getCustomer($scope.vm.Customer_Id)
            getContract(data.JobOrdersdetails[0].ContractNo)
            getSalesOrder($scope.vm.jobdata)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }


        $scope.getAdhocJobs = function () {
            $http({
                method: 'POST',
                url: 'http://' + $rootScope.WebURL + '/salesOrder/getAdHocjob',
                data: { Start_Date: null, Client_Id: $rootScope.Client_Id }
            }).then(function (Glist) {
                var data = Glist.data.data
                var item = data.filter(function (item) {
                    return item.Status === 'New' || item.Status === 'On Going'
                })
                _.each(item, function (ite) {
                    ite.IsActive = ""
                })
                $scope.NewSheduledJobs = item
            })
        }



        var currentTarget

        $("#appointmentContextMenu").dxContextMenu({
            target: ".dx-scheduler-appointment",
            items: [
                { text: "Duplicate Job...", icon: "edit" },
                { text: "Cancel...", icon: "trash" },
                { text: "Client Informed...", icon: "todo" },
                { text: "Client Not Informed...", icon: "close" }

            ],
            onItemClick: function (e) {
                var data = $(currentTarget).parents(".dx-item").data("dxItemData");
                if (data.ownerId != 9 && data.ownerId != 10) {
                    if (e.itemIndex == 0) {
                        clonejob(e, data)
                    }
                    else if (e.itemIndex == 1) {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to cancel the appointment?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                try {
                                    var item = data
                                    var ServiceOn = $filter('date')(new Date(item.startDate), 'EEEE');
                                    $scope.CompanyName = item.CustomerName;
                                    $scope.jobdata = item.SalesOrder_Id;
                                    $scope.CustomerID = item.Customer_id;
                                    $scope.AssignedTo = item.priority;
                                    $scope.Frequency = item.Frequency;
                                    $scope.Types = item.JobType;
                                    $scope.ServiceOn = ServiceOn;
                                    $scope.PestType = item.PestType;
                                    $scope.ContractOrder = item.Contract_Id;
                                    $scope.ServiceID = item.ServiceID;
                                    $scope.Status = item.Status;
                                    $scope.ServiceStartAt = new Date(item.startDate);
                                    $scope.ServiceEndAt = new Date(item.endDate);
                                } catch (e) { }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                                    data: {
                                        _id: data.id,
                                        Status: "Cancelled",
                                        CancelRemarks: "Cancelled from Daily Scheduler",
                                        SenderEmailAddress: "",
                                        CompanyName: $scope.CompanyName,
                                        ScheduleDate: $scope.ServiceStartAt,
                                        UpdatedBy: $rootScope.createdby
                                    },
                                });
                                response.then(function (GList) {
                                    var lresponse = $http({
                                        method: "POST",
                                        url: $rootScope.WebURL + "/schedulelog/add",
                                        data: {
                                            Client_Id: $rootScope.Client_Id,
                                            JobsOrders: $scope.jobdata,
                                            Customer: $scope.CustomerID,
                                            AssignedTo: $scope.AssignedTo,
                                            Frequency: $scope.Frequency,
                                            ServiceOn: $scope.ServiceOn,
                                            Types: $scope.Types,
                                            Status: $scope.Status,
                                            Startsat: $scope.ServiceStartAt,
                                            Endsat: $scope.ServiceEndAt,
                                            PestType: $scope.PestType,
                                            ContractOrder: $scope.ContractOrder,
                                            ServiceID: $scope.ServiceID,
                                            CancelRemarks: "Cancelled from Daily Scheduler",
                                            CreatedBy: $rootScope.createdby,
                                            IsActive: true,
                                        },
                                    });
                                    lresponse.then(function (GList) {
                                        RefreshGrid();
                                        $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                                    })
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 2) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: true
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 3) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer has not confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: false
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                }
                if (data.ownerId == 10) {
                    if (e.itemIndex != 1) {
                        $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                    }
                    else {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the Service?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/schedulerservice/delete",
                                    data: {
                                        _id: data.id,
                                        Client_Id: $rootScope.Client_Id
                                    }
                                }).then(function (List) {
                                    RefreshGrid()
                                    $mdToast.show($mdToast.simple().textContent('Service deleted successfully').position('top center'));
                                })
                            }
                        })
                    }
                }
                // else {
                //     $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                // }
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        function clonejob(e, data) {
            $scope.vm.Title = 'Clone the Job'
            $scope.Cloneschedule = data
            $scope.vm.RescheduleSpinner = false

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/Selectedschedule.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            $scope.vm.ResheduleSSTime = data.startDate
            $scope.vm.ResheduleSETime = data.endDate
            $scope.vm.AssignedTo = data.priority
            $scope.vm.ResheduleSRemarks = data.SpecialRemarks
            $scope.Pestdatas = data.MultiFrequency

            $scope.vm.dateBox = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.vm.ResheduleSSTime,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSSTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date($scope.vm.ResheduleSETime),
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSETime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
        }

        $scope.SubmitClone = function () {
            var value = $scope.Cloneschedule
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/uniqueschedulerByID",
                data: {
                    _id: value.id,
                    Client_Id: $rootScope.Client_Id
                }
            }).then(function (List) {
                var value = List.data.data[0]
                var data = ""
                $scope.vm.CPestType.forEach(function (item) {
                    if (data == "")
                        data = item.Frequency + "~" + item.PestType + "~" + item.Treatment
                    else
                        data = data + "||" + item.Frequency + "~" + item.PestType + "~" + item.Treatment
                })
                var ServiceOn = $filter('date')(new Date($scope.vm.ResheduleSFrom), 'EEEE');
                var currentDate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSSTime))
                var enddate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSETime))

                var serviceArray = [{
                    JobsOrders: (value.JobsOrders),
                    AssignedTo: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    Frequency: data,
                    ServiceOn: ServiceOn,
                    Types: value.Types,
                    Status: "Yet to Start",
                    Customer: (value.Customer),
                    Startsat: currentDate,
                    Endsat: enddate,
                    CreatedBy: $rootScope.createdBy,
                    PestType: $scope.vm.CPestType.map(function (o) { return o.PestType }).join(','),
                    ContractOrder: value.ContractOrder,
                    JobType: value.JobType,
                    ServiceReportNo: value.ServiceReportNo,
                    BillingAmount: value.BillingAmount,
                    Billable: value.Billable,
                    JobContinues: value.JobContinues,
                    CollectPayment: value.CollectPayment,
                    Location: value.Location,
                    LatLong: value.LatLong,
                    Client_Id: $rootScope.Client_Id,
                    CustomerService_Id: (value.CustomerService_Id),
                    ContactPerson: value.ContactPerson,
                    ContactNumber: value.ContactNumber,
                    Vehicle: value.Vehicle,
                    ScheduleType: value.ScheduleType,
                    SpecialRemark: $scope.vm.ResheduleSRemarks,
                    PreferredTime: value.PreferredTime,
                    PreferredStartTime: value.PreferredStartTime,
                    PreferredEndTime: value.PreferredEndTime,
                    AvoidStartTime: value.AvoidStartTime,
                    AvoidEndTime: value.AvoidEndTime,
                    Team_Id: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    TeamName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamName }).join(','),
                    TeamMembersName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamMembers }).join(','),

                }]
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/add",
                    data: {
                        ServiceArray: serviceArray
                    }
                }).then(function (List) {
                    $mdDialog.cancel()
                    $mdToast.show($mdToast.simple().textContent('Successfully Added Service Jobs').position('top center'));
                    RefreshGrid();
                })
            })
        }


        $("#emptyCellContextMenu").dxContextMenu({
            target: ".dx-scheduler-date-table-cell",
            items: [
                { text: "Add Appointment...", icon: "add" }
            ],
            onItemClick: function (e) {
                var data = $(currentTarget).data("dxCellData");
                console.log(data);
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        $scope.RefreshSchedule = function () {

            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }

            LoadSchedulerData();
        }
        $scope.CloseDialog = function () {
            $mdDialog.hide();
        }

        // $scope.Team = null;
        $scope.Datefilter = function () {
            LoadSchedulerData()
        }
        function LoadSchedulerDataforMonth(sDate, eDate) {

            var array = [];
            $scope.Teamdatass = []

            if ($scope.Team == null || $scope.Team == undefined || $scope.Team.length == 0) {
                angular.forEach($scope.teamdatas, function (value) {
                    array.push(value.id)
                })
                $scope.Team = null;
            }
            else {
                angular.forEach($scope.Team, function (value) {
                    var item = $scope.teamdatas.filter(function (item) {
                        return item.id == value
                    })
                    $scope.Teamdatass.push(item)
                    $scope.Teamdatass = _.flattenDeep($scope.Teamdatass)
                    $scope.Teamdatass = _.uniq($scope.Teamdatass)
                })
            }
            $scope.vm.PreviewSpinner = true;
            $scope.uFrom = new Date(sDate);
            $scope.uTo = new Date(eDate);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            $http({
                url: $rootScope.WebURL + "/calendar/datefilter",
                method: "POST",
                data: {
                    FilterStart_Date: $scope.uFrom,
                    FilterEnd_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,

                },
            }).then(function (List) {
                $scope.vm.Holiday = ""
                var item = List.data.data.filter(function (item) {
                    return item.EventType === "Holiday"
                })
                if (item.length > 0)
                    $scope.vm.Holiday = item.map(function (o) { return o.EventTitle }).join(',')
            })
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,
                    Customer_Id: null,
                    Team_Id: null
                },
            });
            response.then(function (GList) {
                $scope.AllSchedulerDatas = GList.data.data;
            })

            var response = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Team: $scope.Team || array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                array = [];
                $scope.AutoTeam = false;
                $scope.AllScheduleDatas = GList.data.data;
                $scope.Uniqueschedulerdatas = GList.data.data;
                $scope.AllScheduleDatas = _.uniqWith($scope.AllScheduleDatas, _.isEqual)
                $scope.Uniqueschedulerdatas = _.uniqWith($scope.Uniqueschedulerdatas, _.isEqual)
                var datapush = [];
                angular.forEach($scope.Uniqueschedulerdatas, function (value) {
                    try {
                        var ownerId = [1];
                        if (value.JobType == "Contract") {
                            ownerId = [2]
                            if (value.Status == 'Completed') ownerId = [6]
                        } else if (value.JobType.toLowerCase() == "ad-hoc") {
                            ownerId = [3]
                            if (value.Status == 'Completed') ownerId = [7]
                        }
                        else if (value.JobType.toLowerCase() == "fixed") {
                            ownerId = [1]
                            if (value.Status == 'Completed') ownerId = [5]
                        }
                        var EndTime = CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat));
                        if (new Date(EndTime).getHours() == 0) {
                            EndTime = new Date(new Date(EndTime).setDate(new Date(EndTime).getDate() + 1))
                            EndTime.setHours(new Date(EndTime).getHours(), new Date(EndTime).getMinutes() - 1, 0, 0)
                        }
                        var Duration = GetDuration(value.Startsat, EndTime);
                        if (value.Status != "Cancelled" && value.Status != "Outstanding" && value.VerifiedBy == true) {
                            if (value.SiteName == null || value.SiteName == "" || value.SiteName == undefined)
                                value.SiteName = value.CustomerName
                            datapush.push({
                                text: value.SiteName + '\n' + 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.Startsat),
                                endDate: new Date(EndTime),
                                id: value._id,
                                Customer_id: value.Customer_id,
                                priority: value.Team_Id,
                                TimeInterval: moment(new Date(EndTime)).diff(moment(new Date(value.Startsat)), 'seconds'),
                                Location: value.Location,
                                BillingAmount: value.BillingAmount,
                                PestType: value.PestType,
                                Team_Id: value.Team_Id,
                                Frequency: value.Frequency,
                                MultiFrequency: value.MultiFrequency,
                                CustomerEmail: value.CustomerEmail,
                                TechnicianEmail: value.TechnicianEmail,
                                JobType: value.JobType,
                                Duplicate: value.Duplicate,
                                DuplicateRemarks: value.DuplicateRemarks,
                                Types: value.Types,
                                Notes: value.AccountsNotes,
                                ClientInformed: value.ClientInformed,
                                TeamName: (value.TeamName),
                                ManHour: value.ManHour,
                                Status: value.Status,
                                TeamLead: getTeamLead(value.Team_Id),
                                //  TeamName: getTeamName(value.Team_Id),
                                TeamMembers: getTeamMembers(value.Team_Id),
                                Zone: value.PostalZone,
                                ownerId: ownerId,
                                FLength: true,
                                CustomerName: value.CustomerName,
                                SalesOrderNo: value.SalesOrderNo,
                                Contract: value.ContractNo,
                                ServiceAddres: value.Location,
                                ServiceID: value.ServiceID,
                                ScheduledBy: value.CreatedBy,
                                CoverageArea: value.CoverageArea,
                                ClientContactName: value.ClientContactName,
                                ClientEmail: value.ClientEmail,
                                SiteContactName: value.SiteContactName,
                                SiteContactNumber: value.SiteContactNumber,
                                PreferedTime: value.PreferredTime,
                                PreferredStartTime: value.PreferredStartTime,
                                PreferredEndTime: value.PreferredEndTime,
                                AvoidStartTime: value.AvoidStartTime,
                                AvoidEndTime: value.AvoidEndTime,
                                SpecialRemark: value.SpecialRemark,
                                SalesOrder_Id: value.SalesOrder_Id,
                                Contract_Id: value.Contract_Id,
                                Message: value.Message,
                                IsUrgent: value.IsUrgent
                            });
                        }
                    } catch (error) {
                    }
                });
                $scope.TotalDatas = datapush
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.startDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.endDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.TimeInterval);
                });
                datapush = datapush.reverse()
                $scope.Todaydatas = datapush
                GetCWCdatas()


                $scope.calenderdata = $scope.Todaydatas
                // $scope.calenderdata = PopupArray;
                // $scope.Extradatas = ExtraArray
                $scope.vm.PreviewSpinner = false;
                var response = $http({
                    url: $rootScope.WebURL + "/leaveentitlement/getByDate",
                    method: "POST",
                    data: {
                        StartDate: $scope.uFrom,
                        EndDate: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var Edata = []
                    angular.forEach(GList.data.data, function (value) {
                        var leavedata = $scope.calenderdata.filter(function (o) {
                            return o.id === value._id
                        })
                        if (leavedata.length == 0) {
                            if ($scope.uFrom.getDate() === new Date(value.StartDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else if ($scope.uFrom.getDate() === new Date(value.EndDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else {
                                if ($scope.uFrom.getDay() != 6) {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(23, 59, 59, 999)

                                }
                                else {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }

                            Edata.push({
                                text: value.Type + " " + moment(value.StartDate).format('DD-MMM-YYYY') + " - " + moment(value.EndDate).format('DD-MMM-YYYY'),
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.TeamID,
                                ownerId: [9],
                                FLength: false,
                            })
                        }
                    })
                    $scope.calenderdata = $scope.calenderdata.concat(Edata)
                    var response = $http({
                        url: $rootScope.WebURL + "/schedulerservice/datefilter",
                        method: "POST",
                        data: {
                            Start_Date: $scope.uFrom,
                            End_Date: $scope.uTo,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (gList) {
                        var Sdata = []
                        angular.forEach(gList.data.data, function (value) {
                            Sdata.push({
                                text: value.ServiceName,
                                Location: value.Description,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.Team_Id,
                                ownerId: value.Status == "Completed" ? [11] : [10],
                                FLength: false,
                            })
                        })
                        $scope.calenderdata = $scope.calenderdata.concat(Sdata)

                    })
                })
            });


        }
        function LoadSchedulerData() {
            var array = [];
            $scope.Teamdatass = []
            angular.element("#scheduler").dxScheduler('instance').option("currentDate", vm.Date)
            if ($scope.Team == null || $scope.Team == undefined || $scope.Team.length == 0) {
                angular.forEach($scope.teamdatas, function (value) {
                    array.push(value.id)
                })
                $scope.Team = null;
            }
            else {
                angular.forEach($scope.Team, function (value) {
                    var item = $scope.teamdatas.filter(function (item) {
                        return item.id == value
                    })
                    $scope.Teamdatass.push(item)
                    $scope.Teamdatass = _.flattenDeep($scope.Teamdatass)
                    $scope.Teamdatass = _.uniq($scope.Teamdatass)
                })
            }
            $scope.vm.PreviewSpinner = true;
            $scope.uFrom = new Date(vm.Date);
            $scope.uTo = new Date(vm.Date);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            $http({
                url: $rootScope.WebURL + "/calendar/datefilter",
                method: "POST",
                data: {
                    FilterStart_Date: $scope.uFrom,
                    FilterEnd_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,

                },
            }).then(function (List) {
                $scope.vm.Holiday = ""
                var item = List.data.data.filter(function (item) {
                    return item.EventType === "Holiday"
                })
                if (item.length > 0)
                    $scope.vm.Holiday = item.map(function (o) { return o.EventTitle }).join(',')
            })
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,
                    Customer_Id: null,
                    Team_Id: null
                },
            });
            response.then(function (GList) {
                $scope.AllSchedulerDatas = GList.data.data;
            })

            var response = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Team: $scope.Team || array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                array = [];
                $scope.AutoTeam = false;
                $scope.AllScheduleDatas = GList.data.data;
                $scope.Uniqueschedulerdatas = GList.data.data;
                $scope.AllScheduleDatas = _.uniqWith($scope.AllScheduleDatas, _.isEqual)
                $scope.Uniqueschedulerdatas = _.uniqWith($scope.Uniqueschedulerdatas, _.isEqual)
                var datapush = [];
                angular.forEach($scope.Uniqueschedulerdatas, function (value) {
                    try {
                        var ownerId = [1];
                        if (value.JobType == "Contract") {
                            ownerId = [2]
                            if (value.Status == 'Completed') ownerId = [6]
                        } else if (value.JobType.toLowerCase() == "ad-hoc") {
                            ownerId = [3]
                            if (value.Status == 'Completed') ownerId = [7]
                        }
                        else if (value.JobType.toLowerCase() == "fixed") {
                            ownerId = [1]
                            if (value.Status == 'Completed') ownerId = [5]
                        }
                        var EndTime = CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat));
                        if (new Date(EndTime).getHours() == 0) {
                            EndTime = new Date(new Date(EndTime).setDate(new Date(EndTime).getDate() + 1))
                            EndTime.setHours(new Date(EndTime).getHours(), new Date(EndTime).getMinutes() - 1, 0, 0)
                        }
                        var Duration = GetDuration(value.Startsat, EndTime);
                        if (value.Status != "Cancelled" && value.Status != "Outstanding" && value.VerifiedBy == true) {
                            if (value.SiteName == null || value.SiteName == "" || value.SiteName == undefined)
                                value.SiteName = value.CustomerName
                            datapush.push({
                                text: value.SiteName + '\n' + 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.Startsat),
                                endDate: new Date(EndTime),
                                id: value._id,
                                Customer_id: value.Customer_id,
                                priority: value.Team_Id,
                                TimeInterval: moment(new Date(EndTime)).diff(moment(new Date(value.Startsat)), 'seconds'),
                                Location: value.Location,
                                BillingAmount: value.BillingAmount,
                                PestType: value.PestType,
                                Team_Id: value.Team_Id,
                                Frequency: value.Frequency,
                                MultiFrequency: value.MultiFrequency,
                                CustomerEmail: value.CustomerEmail,
                                TechnicianEmail: value.TechnicianEmail,
                                JobType: value.JobType,
                                Duplicate: value.Duplicate,
                                DuplicateRemarks: value.DuplicateRemarks,
                                Types: value.Types,
                                Notes: value.AccountsNotes,
                                ClientInformed: value.ClientInformed,
                                TeamName: (value.TeamName),
                                ManHour: value.ManHour,
                                Status: value.Status,
                                TeamLead: getTeamLead(value.Team_Id),
                                //  TeamName: getTeamName(value.Team_Id),
                                TeamMembers: getTeamMembers(value.Team_Id),
                                Zone: value.PostalZone,
                                ownerId: ownerId,
                                FLength: true,
                                CustomerName: value.CustomerName,
                                SalesOrderNo: value.SalesOrderNo,
                                Contract: value.ContractNo,
                                ServiceAddres: value.Location,
                                ServiceID: value.ServiceID,
                                ScheduledBy: value.CreatedBy,
                                CoverageArea: value.CoverageArea,
                                ClientContactName: value.ClientContactName,
                                ClientEmail: value.ClientEmail,
                                SiteContactName: value.SiteContactName,
                                SiteContactNumber: value.SiteContactNumber,
                                PreferedTime: value.PreferredTime,
                                PreferredStartTime: value.PreferredStartTime,
                                PreferredEndTime: value.PreferredEndTime,
                                AvoidStartTime: value.AvoidStartTime,
                                AvoidEndTime: value.AvoidEndTime,
                                SpecialRemark: value.SpecialRemark,
                                SalesOrder_Id: value.SalesOrder_Id,
                                Contract_Id: value.Contract_Id,
                                Message: value.Message,
                                IsUrgent: value.IsUrgent
                            });
                        }
                    } catch (error) {
                    }
                });
                $scope.TotalDatas = datapush
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.startDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.endDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.TimeInterval);
                });
                datapush = datapush.reverse()
                $scope.Todaydatas = datapush
                GetCWCdatas()


                $scope.calenderdata = $scope.Todaydatas
                // $scope.calenderdata = PopupArray;
                // $scope.Extradatas = ExtraArray
                $scope.vm.PreviewSpinner = false;
                var response = $http({
                    url: $rootScope.WebURL + "/leaveentitlement/getByDate",
                    method: "POST",
                    data: {
                        StartDate: $scope.uFrom,
                        EndDate: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var Edata = []
                    angular.forEach(GList.data.data, function (value) {
                        var leavedata = $scope.calenderdata.filter(function (o) {
                            return o.id === value._id
                        })
                        if (leavedata.length == 0) {
                            if ($scope.uFrom.getDate() === new Date(value.StartDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else if ($scope.uFrom.getDate() === new Date(value.EndDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else {
                                if ($scope.uFrom.getDay() != 6) {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(23, 59, 59, 999)

                                }
                                else {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }

                            Edata.push({
                                text: value.Type + " " + moment(value.StartDate).format('DD-MMM-YYYY') + " - " + moment(value.EndDate).format('DD-MMM-YYYY'),
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.TeamID,
                                ownerId: [9],
                                FLength: false,
                            })
                        }
                    })
                    $scope.calenderdata = $scope.calenderdata.concat(Edata)
                    var response = $http({
                        url: $rootScope.WebURL + "/schedulerservice/datefilter",
                        method: "POST",
                        data: {
                            Start_Date: $scope.uFrom,
                            End_Date: $scope.uTo,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (gList) {
                        var Sdata = []
                        angular.forEach(gList.data.data, function (value) {
                            Sdata.push({
                                text: value.ServiceName,
                                Location: value.Description,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.Team_Id,
                                ownerId: value.Status == "Completed" ? [11] : [10],
                                FLength: false,
                            })
                        })
                        $scope.calenderdata = $scope.calenderdata.concat(Sdata)

                    })
                })
            });

        }

        function getLastCompletedJob(id) {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + "/scheduler/getlast",
                data: { JobId: id }
            }).then(function (List) {
                try {
                    $scope.vm.LastCompletedDate = new Date(List.data.data[0].Startsat)
                }
                catch (e) {
                    $scope.vm.LastCompletedDate = ""
                }

                try {
                    $scope.vm.LastCompletedBy = List.data.data[0].tabletschedulerrecord[0].CreatedBy.capitalize();
                } catch (error) {
                    $scope.vm.LastCompletedBy = "";
                }
            })
        }
        function getContract(Contract_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getById",
                data: { _id: Contract_Id }
            }).then(function (List) {
                var Contractdata = List.data.data
            })
        }
        function getSalesOrder(SalesOrder_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getById",
                data: { _id: SalesOrder_Id }
            }).then(function (List) {
                var SalesOrderdata = List.data.data
                $scope.vm.SalesPerson = SalesOrderdata[0].employeedetails[0].EmployeeName
                $scope.vm.OrderType = SalesOrderdata[0].OrderType
                if ($scope.vm.OrderType === "Contract") {
                    $scope.vm.ContractStart = SalesOrderdata[0].ServiceStartDate
                    $scope.vm.ContractEnd = SalesOrderdata[0].ServiceEndDate
                } else
                    $scope.vm.Occurence = SalesOrderdata[0].EnqRef
            })
        }
        function getCustomer(id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/get",
                data: { id: id }
            }).then(function (List) {
                var Customerdata = List.data.data
                $scope.vm.MarketSegment = Customerdata.MarketSection
            })
        }

        function GetDuration(StartTime, EndTime) {
            var today = new Date(StartTime);
            var Christmas = new Date(EndTime);
            var diffMs = (Christmas - today); // milliseconds between now & Christmas
            var diffDays = Math.floor(diffMs / 86400000); // days
            var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
            var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

            return diffMins + ' mins';
        }
        function CombineDateAndTime(date, time) {
            var timeString = time.getHours() + ':' + time.getMinutes() + ':00:00';
            var year = date.getFullYear();
            var month = date.getMonth() + 1; // Jan is 0, dec is 11
            var day = date.getDate();
            var dateString = '' + year + '-' + month + '-' + day;
            var combined = new Date(dateString + ' ' + timeString);
            return combined;
        };

        $scope.UpdateNewSchedule = function () {
            var _id = $scope.vm.ID
            var startDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceStartDate)
            var endDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceEndDate)
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/updateinflexi",
                method: "PUT",
                data: {
                    _id: _id,
                    Startsat: startDate,
                    Endsat: endDate,
                    Notes: $scope.vm.Notes,
                    Remark: $scope.vm.SpecialRemark,
                    Message: $scope.vm.Remarks
                },
            });
            response.then(function (GList) {
                LoadSchedulerData();
                $mdDialog.cancel()
            });
        }

        function UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam) {
            var TeamName = ""
            var TeamMembersName = ""
            if ($scope.AllSchedulerDatas == undefined) {
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.uFrom,
                        End_Date: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Team_Id: null
                    },
                });
                response.then(function (Glist) {
                    $scope.AllSchedulerDatas = Glist.data.data;
                    UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam)
                })
            }
            else {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === _id
                })[0];
                // if(Notes==null || Notes=="" || Notes==undefined )
                //  Notes = item.AccountsNotes

                if (item.Team_Id.length == 1) {
                    TeamName = getTeamName(Team_Id)
                    TeamMembersName = getTeamMembers(Team_Id)
                    var response = $http({
                        url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                        method: "PUT",
                        data: {
                            _id: _id,
                            Startsat: startDate,
                            Endsat: endDate,
                            AssignedTo: Team_Id,
                            Team_Id: [Team_Id],
                            TeamName: TeamName,
                            Remark: $scope.vm.SpecialRemark,
                            TeamMembersName: TeamMembersName,
                        },
                    });
                    response.then(function (GList) {
                        LoadSchedulerData();
                    });
                }
                else {
                    if (OldTeam != null) {
                        item.Team_Id[item.Team_Id.indexOf(OldTeam)] = Team_Id
                        item.Team_Id = _.uniq(item.Team_Id)
                        var TeamName = "";
                        var TeamMembersName = ""

                        angular.forEach(item.Team_Id, function (value) {
                            if (TeamName != "") {
                                TeamName = TeamName + "," + getTeamName(value)
                                TeamMembersName = TeamMembersName + "," + getTeamMembers(value)
                            }
                            else {
                                TeamName = getTeamName(value)
                                TeamMembersName = getTeamMembers(value)
                            }
                        })
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();

                        });
                    }
                    else {
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: item.TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: item.TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();
                        });
                    }
                }
                try {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/schedulerNotification/add",
                        data: {
                            ServiceId: _id,
                            ServiceID: item.ServiceID,
                            CustomerName: item.customerdetails[0].CompanyName,
                            Status: item.Status,
                            PreviousStartsat: item.Startsat,
                            PreviousEndsat: item.Endsat,
                            Startsat: startDate,
                            Endsat: endDate,
                            PestType: item.PestType,
                            TeamName: item.teamdetails[0].TeamName,
                            TeamLead: item.teamdetails[0].TeamLead,
                            TeamMember: item.teamdetails[0].TeamMembers,
                            Acknowledged: null,
                            AcknowledgedBy: null,
                            CreatedBy: $rootScope.createdby,
                            IsActive: true
                        },
                    }).then(function (GList) {
                    });
                } catch (error) {

                }
            }
        }


        function DeleteSchedule(_id) {
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                method: "PUT",
                data: {
                    _id: _id,
                    Status: "Cancelled",
                    CancelRemarks: "Deleted in custom scheduler",
                    UpdatedBy: $rootScope.CreatedBy,
                },
            });
            response.then(function (GList) {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                // showToast("Deleted Successfully", "", "warning");
                LoadSchedulerData();
            });
        }

        $scope.commentSubmit = function () {
            $scope.File_id = $scope.vm.ScedulId;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulercomment/add",
                data: {
                    SchedulerID: $scope.vm.ScedulId,
                    SalesOrderID: $scope.vm.jobdata,
                    CustomerID: $scope.vm.Customer_Id,
                    TableName: 'Scheduler',
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Addcomments,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                Refreshcomment();
                $scope.vm.Addcomments = '';
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function Refreshcomment() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulercomment/getByReqID",
                method: "POST",
                data: { RequestID: $scope.vm.jobdata },
            });
            response.then(function (Commentdata) {
                $scope.Commentdatas = Commentdata.data.data;
            });
        }

        $scope.DeleteAttachment = function (id) {
            $scope.delAtachId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/attachment/delete",
                        method: "POST",
                        data: { _id: $scope.delAtachId },
                    }).then(function (attachmentdata) {
                        RefreshAttachmentGrid()
                        $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
                    })
                }
            })
        }

        $scope.DeleteComment = function (id) {
            $scope.delComId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/schedulercomment/delete",
                        method: "POST",
                        data: { _id: $scope.delComId },
                    }).then(function (attachmentdata) {
                        Refreshcomment()
                        $mdToast.show($mdToast.simple().textContent('Comment deleted Successfully!').position('top center'));
                    });

                }
            })
        }

        $scope.Uploadfiles = function (file) {
            $scope.File_id = $scope.vm.ScedulId;
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/scheduler/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Operations", FileID: $scope.vm.jobdata,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        function RefreshAttachmentGrid() {
            $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.jobdata },
            }).then(function (attachmentdata) {
                var item = attachmentdata.data.data.filter(function (item) {
                    return item.TableName === 'Operations' || item.TableName === 'Sales Order'
                })
                $scope.Attachmentdatas = item;
            });
        }
        function LoadTeam() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team",
                data: {
                    Client_Id: $rootScope.Client_Id
                },
            }).then(function (teamdata) {
                $scope.teamdatas = teamdata.data.data;
                $scope.Teamdatass = []
                $scope.Team = []
                angular.forEach($scope.teamdatas, function (value) {
                    value.text = value.TeamName;
                    value.color = getRandomColor();
                    $scope.Teamdatass.push(value)
                    $scope.Team.push(value.id)
                });
                BindScheduler();

                // if ($("#container").dxScheduler("instance").option() != undefined && $("#container").dxScheduler("instance").option().resources[1] != undefined) {

                //     $("#container").dxScheduler("instance").option().resources[1].dataSource = $scope.teamdatas;

                // }
            });
        }
        function CheckNullvalue(val) {
            var string = '';
            if (val == null || val == undefined || val == " ") {

                return string;
            } else {

                return val;
            }
        }
        function getRandomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        };
        function showToast(event, value, type) {
            $mdToast.show($mdToast.simple().textContent(event).position('top center'));
        }

        //     function GetCWCdatas(){

        //     $http({
        //         method: "POST",
        //         url:  $rootScope.WebURL + "/contract",
        //         data: { Client_Id: $rootScope.Client_Id },
        //     }).then(function (contractdata) {
        //         $scope.contractdatas = contractdata.data.data;
        //         $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/salesOrder/getForScheduler",
        //             data: { Client_Id: $rootScope.Client_Id },
        //         }).then(function (salesdata) {
        //             $scope.salesdatas = salesdata.data.data;
        //             var data = $scope.salesdatas
        //             angular.forEach(data, function (cvalue) {
        //                 cvalue.IsActive = "";
        //                 cvalue.TotalOrderValue = null;
        //                 angular.forEach($scope.contractdatas, function (value) {
        //                     if (cvalue.ContractNo == value._id) {
        //                         cvalue.IsActive = value.ContractReferenceNo;
        //                         cvalue.TotalOrderValue = value._id;
        //                     }
        //                 })
        //             })
        //             $http({
        //                 method:'POST',
        //                 url:'http://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //                 data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //             }).then(function(Glist){
        //                 var Adhocdata = Glist.data.data
        //             try {
        //                 var item = []; 
        //                 if($scope.vm.ExpiredDate==undefined)$scope.vm.ExpiredDate=7
        //                 item = data.filter(function (item) {
        //                     return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && (item.Status == 'New' || item.Status == 'On Going') && new Date(new Date(new Date().setDate(new Date().getDate()-parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) <= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) && new Date(new Date(new Date().setDate(new Date().getDate()+parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) >= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) ;
        //                 });
        //                 // _.sortBy(item, 'ServiceStartDate');

        //                 item = _.sortBy(item, function(dateObj) {
        //                     return new Date(dateObj.ServiceStartDate);
        //                   });
        //                   item=_.reverse(item);
        //                   item=Adhocdata.concat(item)
        //                 $scope.CWCDatas = item;
        //                 if($scope.TabStatus==undefined) $scope.TabStatus='New'
        //                 $scope.getSchedulerdatas($scope.TabStatus)
        //             }
        //             catch (e) { }
        //         });
        //     });
        //     });
        // }
        $scope.ExpiredDateFilter = function () {
            GetCWCdatas()
        }
        function CustomerServicedatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerServicedata) {
                var resArr = [];
                try {
                    CustomerServicedata.data.data.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                            return x.sBLK == item.sBLK && x.sUnit == item.sUnit && x.sStreetName == item.sStreetName && x.sPostal == item.sPostal
                        });
                        if (i <= -1)
                            resArr.push(item);
                    });
                } catch (e) { }
                _.each(resArr, function (item) {
                    item.PreferenceDayTime = $scope.PreferenceDayTime
                })
                $scope.CustomerServicedatas = resArr;

                $scope.vm.PreviewSpinner = false;
            });
        }

        var applyFilterTypes = [{
            key: "auto",
            name: "Immediately"
        }, {
            key: "onClick",
            name: "On Button Click"
        }], dataGrid;
        $scope.filterRow = {
            visible: true,
            applyFilter: "auto"
        };
        $scope.headerFilter = {
            visible: true
        };
        vm.dataGridCustomerService = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            dataSource: $scope.CustomerServicedatas,
            keyExpr: "_id",
            width: 870,
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "sContactPerson", caption: "Contact Person" },
                //   { dataField: "sBLK", caption: "Blk" },
                //   { dataField: "sUnit", caption: "Unit" },
                { dataField: "sBuildingName", caption: "Number" },
                { dataField: "sStreetName", caption: "Address" },
                { dataField: "sPostal", caption: "Postal" },
                { dataField: "PreferenceDayTime", caption: "Preference (Day & Time)" },
            ],
            bindingOptions: {
                dataSource: "CustomerServicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.ServiceAddressarray = [];
                    $scope.ServiceAddressarray.push.apply($scope.ServiceAddressarray, e.selectedRowsData)
                    if ($scope.vm.TeamName != undefined && $scope.vm.TeamName != null && $scope.vm.TeamName != "")
                        vm.Formvalid = false;
                    $scope.vm.Location = []
                    angular.forEach($scope.ServiceAddressarray, function (value) {
                        var getLocation = "";
                        // if (value.sBLK != "" && value.sBLK != null && value.sBLK != undefined) {
                        //     getLocation = value.sBLK;
                        // }
                        // if (value.sUnit != "" && value.sUnit != null && value.sUnit != undefined) {
                        //     getLocation = getLocation + " " + value.sUnit;
                        // }
                        if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
                            getLocation = getLocation + " " + value.sBuildingName;
                        }
                        if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
                            getLocation = getLocation + " " + value.sStreetName;
                        }
                        if (value.sCountry != "" && value.sCountry != null && value.sCountry != undefined) {
                            getLocation = getLocation + " " + value.sCountry;
                        }
                        if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
                            getLocation = getLocation + " " + value.sPostal;
                        }
                        var address = getLocation;
                        value.LatLong = "103.8677,1.3554";
                        var geocoder = new google.maps.Geocoder();
                        if (geocoder) {
                            geocoder.geocode({
                                'address': address
                            }, function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                                }
                            });
                        }
                        value.getLocation = getLocation;
                        $scope.vm.Location.push(getLocation)
                    })
                    $scope.vm.Location = $scope.vm.Location.map(function (obj) { return obj; }).join(';');
                }
                else {
                    $scope.ServiceAddressarray = [];

                    vm.Formvalid = true;
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Service Address</B></div>');
            },
        };
        vm.dataGridSalesOrder = {
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            },
            dataSource: $scope.NewSheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            width: 870,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "single",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "customerdetails[0].CompanyName", caption: "Customer Name" },
                { dataField: "SalesOrderNo", caption: "Work Order #" },
                // { dataField: "IsActive", caption: "Contract #" },
                { dataField: "PestType", caption: "Pest Types" },
                { dataField: "ServiceStartDate", caption: "Service Start Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "ServiceEndDate", caption: "Service End Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "Status", caption: "Scheduling Status" },
                // {  dataField: "IsUrgent", caption: "Urgent?",cellTemplate:function(container, options){
                //     $("<div/>").dxButton({
                //         icon: "warning"
                //     }).append(container)
                // }
                // },
                {
                    caption: 'Urgent?',
                    // fixed: true,
                    // fixedPosition: 'right',
                    width: 80,
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        if (options.data.IsUrgent == true) {
                            $('<div />').dxButton({
                                icon: 'warning'
                            }).appendTo(container);
                        }
                    }
                }


            ],
            bindingOptions: {
                dataSource: "NewSheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    var item = e.selectedRowsData[0];
                    $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
                    $scope.vm.WorkOrderNo = item.SalesOrderNo;
                    $scope.vm.WorkOrder_id = item._id;
                    $scope.vm.ContractOrder = item.TotalOrderValue;
                    $scope.vm.ContractNo = item.IsActive;
                    $scope.vm.PestType = item.PestType;
                    $scope.vm.Frequency = item.Frequency;
                    $scope.vm.Customer_id = item.Customer_id;
                    $scope.vm.OrderType = item.OrderType;
                    if ($scope.vm.OrderType == "Ad-hoc")
                        $scope.vm.JobType = 'Ad-hoc';
                    else
                        $scope.vm.JobType = 'Fixed';
                    $scope.vm.Types = item.Types;

                    $scope.PreferenceDayTime = item.DateTimeofTreatment
                    $scope.vm.EstimationTime = item.EstimatedHoursRequired
                    // if (new Date(item.ServiceStartDate) < new Date()) {
                    //     item.ServiceStartDate = new Date()
                    // }
                    // var dd = item.ServiceStartDate;
                    // var hh = vm.StartTime;
                    // var mm = new Date(hh.setDate(new Date(dd).getDate()));
                    // var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                    // $scope.vm.ServiceStartDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    // var edd = item.ServiceEndDate;
                    // var ehh = vm.EndTime;
                    // var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                    // var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                    // $scope.vm.ServiceEndDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    $scope.RequestID = item.customerdetails[0].CustomerID;
                    vm.PreviewSpinner = true;
                    CustomerServicedatadetails();
                }
                else {
                    vm.CompanyName = '';
                    vm.WorkOrder_id = '';
                    vm.ContractOrder = '';
                    vm.ContractNo = '';
                    vm.PreviewSpinner = false;
                }
            },
        }

        $scope.JobType = [
            { Name: 'New Contract' }, { Name: 'Ad-hoc' }, { Name: 'Follow-Up' }, { Name: 'Reinfestation Call' }
        ]
        $scope.JType = [{ Name: "Contract (Fixed)", value: "Fixed" }, { Name: "Contract (Flexible)", value: "Contract" }, { Name: "Ad-hoc", value: "Ad-hoc" }]
        vm.FormOption = {
            readOnly: false,
            showColonAfterLabel: false,
            showValidationSummary: true,
            labelLocation: "top",
            formData: vm,
            colCount: 2,
            items: [
                {
                    dataField: "CompanyName",
                    editorType: "dxTextBox",
                    label: { text: 'Customer Name', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "WorkOrderNo",
                    editorType: "dxTextBox",
                    label: { text: 'Work Order #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ContractNo",
                    editorType: "dxTextBox",
                    label: { text: 'Contract #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                //   {
                //       editorType: "dxTextBox",
                //       label: { text: 'No. of Service Address', showColon: false },
                //       editorOptions: {
                //           readOnly: true,
                //           value: $scope.ServiceAddressarray.length
                //       }
                //   },
                {
                    dataField: "PestType",
                    editorType: "dxTextBox",
                    label: { text: 'Pest Types', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "TeamName",
                    editorType: "dxSelectBox",
                    label: { text: 'Team', showColon: false },
                    editorOptions: {
                        dataSource: $scope.teamdatas,
                        displayExpr: "TeamName",
                        valueExpr: "id",
                        readOnly: true,
                        onValueChanged: function (e) {
                            $scope.TeamMembers = e.component._options.selectedItem.TeamMembers
                            $scope.vm.Team_id = e.component._options.selectedItem.id
                            $scope.TeamID = e.component._options.selectedItem.id
                            if ($scope.ServiceAddressarray.length > 0)
                                vm.Formvalid = false;
                        }
                    },

                },
                {
                    dataField: "TeamMembers",
                    editorType: "dxTextBox",
                    label: { text: 'Team Members', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ServiceStartDate",
                    label: { text: 'Start Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "ServiceEndDate",
                    label: { text: 'End Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "JobType",
                    label: { text: 'Job Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JType,
                        displayExpr: "Name",
                        valueExpr: "value",
                        width: "100%",
                    },
                },
                {
                    dataField: "Location",
                    label: { text: 'Location', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                    },
                },
                {
                    dataField: 'EstimationTime',
                    label: { text: 'Time to Complete', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                        value: $scope.EstimationTime,
                        readOnly: true
                    },
                },
                {
                    dataField: "SchedulingType",
                    label: { text: 'Scheduling Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JobType,
                        displayExpr: "Name",
                        valueExpr: "Name",
                        width: "100%",
                    },
                },


            ],
            bindingOptions: {
                "items[4].editorOptions.dataSource": "teamdatas",
                "items[5].editorOptions.value": "TeamMembers",
            }
        }

        $scope.getForSelectedDays = function (day) {
            $("#NewDataGrid").dxDataGrid("instance").beginCustomLoading()
            day = parseInt(day)
            var date = new Date($scope.StDate)
            date = new Date(moment(new Date(date)).add(day, 'days'))
            $scope.EnDate = new Date(date)
            GetCWCdatas()
        }

        function CleanAddComments() {
            $scope.Reschedule = { value: false };
            $scope.Cancel = { value: false };
            $scope.vm.Status = "";
            $scope.vm.ServiceID = "";
            $scope.vm.SalesOrderNo = "";
            $scope.vm.ContractReferenceNo = "";
            $scope.vm.CompanyName = "";
            $scope.vm.Location = "";
            $scope.vm.TeamName = "";
            $scope.vm.ServiceStartAt = "";
            $scope.vm.ServiceEndAt = "";
            $scope.vm.PestType1 = "";
            $scope.vm.Types = "";
            $scope.vm.ServiceOn = "";
            $scope.InProgresseAt = "";
            $scope.vm.AServiceEndAt = "";
            $scope.vm.EmailSentTo = "";
            $scope.vm.EmailSentDate = "";
            $scope.InProgressedBy = "";
            $scope.CreatedBy = "";
            $scope.CreatedDate = "";
            $scope.vm.Vehicle = "";
            $scope.Billable = { value: true };
            $scope.vm.BillingAmount
            $scope.Tabletlighttracklistdatas = [];
            $scope.TabletMaterialslistdatas = [];
            $scope.vm.TeamLead = "";
            $scope.vm.TeamMembers = "";
            $scope.vm.TeamRemarks = "";
            $scope.vm.TeamSignature = "";
            $scope.PhotosBdatas = [];
            $scope.PhotosAdatas = [];
            $scope.vm.NoOfCulls = "";
            $scope.vm.MistingCariedOut = "";
            $scope.vm.NoOfBurrows = "";
            $scope.vm.Density = "";
            $scope.vm.NoOfDead = "";
            $scope.vm.Instar = "";
            $scope.vm.BreedingFound = "";
            $scope.vm.Habitat = "";
            $scope.vm.Species = "";
            $scope.vm.Action = "";
            $scope.vm.Findings = "";
            $scope.vm.Recommendation = "";
            $scope.vm.MobilEmailId = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.starRating1r = "";
            $scope.vm.CustomerRemarks = "";
            $scope.CustomerSignature = "";
            $scope.vm.Addcomments = "";
            $scope.Commentdatas = [];
            $scope.Attachmentdatas = [];
            $scope.SchedulerLogdatas = [];
            $scope.vm.ATimeIn = "";
            $scope.vm.ATimeOut = "";
            $scope.vm.ContactPerson = "";
            $scope.vm.TeamMember = "";
            $scope.vm.starRating1 = "";
            $scope.Pestdatas = [];
            $scope.vm.MServicetype = "";
            $scope.vm.MLSMPestType = [];
            $scope.vm.MMaterialsName = "";
            $scope.vm.MQuantity = "";
            $scope.vm.MUnit = "";
            $scope.vm.ImgBPestType = [];
            $scope.vm.ImgBRemarks = "";
            $scope.uCPB = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.Reason = "";
        }


        $scope.userpopup = function (e, Start, end, Team) {
            $scope.vm.ServiceName = null;
            $scope.vm.Description = null;
            $scope.ServiceTeamId = Team
            $scope.serviceStartTime = new Date(Start)
            $scope.ServiceEndTime = new Date(end)
            $scope.vm.dateBox1 = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.serviceStartTime,
                    onValueChanged: function (e) {
                        $scope.serviceStartTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date(end),
                    onValueChanged: function (e) {
                        $scope.vm.AvoidEndTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitService = function () {
            if ($scope.ServiceUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/schedulerservice/update",
                    data: {
                        _id: $scope.ServiceUpdateID,
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });

            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerservice/add",
                    data: {
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.sSubmit = function (e) {

            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.sPestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.Update == true) {
                var dd = $scope.vm.ResheduleFrom;
                var hh = $scope.vm.ResheduleStartTime;
                var mm = new Date(hh.setDate(new Date(dd).getDate()));
                var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                $scope.vm.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                var edd = $scope.vm.ResheduleFrom;
                var ehh = $scope.vm.ResheduleEndTime;
                var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                $scope.vm.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                var currentDate = new Date($scope.vm.schusdateTime);
                var enddate = new Date($scope.vm.schuedateTime);
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/forReschedule",
                    data: {
                        _id: $scope.SID,
                        AssignedTo: $scope.vm.AssignedTo,
                        Start_Date: currentDate,
                        End_Date: enddate,
                    },
                }).then(function (GList) {
                    var CheckforReschedule = GList.data.data;
                    $scope.CheckReschedule = false;
                    angular.forEach(CheckforReschedule, function (item) {
                        var edd = new Date($scope.vm.ResheduleFrom);
                        var ehh = new Date(item.Endsat);
                        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                        item.Endsat = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                        if (new Date(item.Startsat) < currentDate && currentDate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) < enddate && enddate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) >= currentDate && enddate > new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        var St = $filter('date')(currentDate, 'dd/MM/yyyy hh:mm a');
                        var Et = $filter('date')(enddate, 'dd/MM/yyyy hh:mm a');
                        var dbSt = $filter('date')(new Date(item.Startsat), 'dd/MM/yyyy hh:mm a');
                        var dbEt = $filter('date')(new Date(item.Endsat), 'dd/MM/yyyy hh:mm a');
                        if (St == dbSt && Et == dbEt) {
                            $scope.CheckReschedule = true;
                        }
                    })
                    if ($scope.CheckReschedule == true) {
                        $mdToast.show($mdToast.simple().textContent('Not Allowed! Scheduling exists for this team on the specified time.').position('top center'));
                    }
                    else {
                        $scope.Emails = null;
                        if ($scope.Reschedule.value == true) {
                            var array = [];
                            var createdBy = null;
                            var teamLead = null;
                            var teamMember = null;

                            try {
                                var gItem = $scope.Uniqueschedulerdatas.filter(function (item) {
                                    return $scope.SID === item._id;
                                })[0];
                                createdBy = gItem.CreatedBy;
                                teamLead = gItem.teamdetails[0].TeamLead;
                                teamMember = gItem.teamdetails[0].TeamMembers;
                            } catch (error) { }

                            angular.forEach($scope.Userdatas, function (uvalue) {
                                if (createdBy.indexOf(uvalue.UserID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                            })

                            if (array.length > 0) {
                                var SenderEmails = [];
                                $scope.Emailgroups = _.groupBy(array, 'EmailId');
                                angular.forEach($scope.Emailgroups, function (value) {
                                    SenderEmails.push(value[0].EmailId);
                                });
                                $scope.Emails = SenderEmails;
                            }
                        }

                        $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
                        if ($scope.uEndDate.getDay() == "0") {
                            $scope.ServiceOn = "Sunday";
                        }
                        else if ($scope.uEndDate.getDay() == "1") {
                            $scope.ServiceOn = "Monday";
                        }
                        else if ($scope.uEndDate.getDay() == "2") {
                            $scope.ServiceOn = "Tuesday";
                        }
                        else if ($scope.uEndDate.getDay() == "3") {
                            $scope.ServiceOn = "Wednesday";
                        }
                        else if ($scope.uEndDate.getDay() == "4") {
                            $scope.ServiceOn = "Thursday";
                        }
                        else if ($scope.uEndDate.getDay() == "5") {
                            $scope.ServiceOn = "Friday";
                        }
                        else if ($scope.uEndDate.getDay() == "6") {
                            $scope.ServiceOn = "Saturday";
                        }
                        $scope.status = "Yet to Start";
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                            data: {
                                _id: $scope.SID,
                                ServiceOn: $scope.ServiceOn,
                                Startsat: currentDate,
                                Endsat: enddate,
                                ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                SenderEmailAddress: $scope.Emails,
                                CompanyName: $scope.vm.CompanyName,
                                ScheduleFromDate: $scope.vm.ServiceStartAtlog,
                                UpdatedBy: $rootScope.createdby,
                                IsActive: true
                            },
                        });
                        response.then(function (GList) {
                            var lresponse = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/schedulelog/add",
                                data: {
                                    Client_Id: $rootScope.Client_Id,
                                    JobsOrders: $scope.vm.jobdata,
                                    Customer: $scope.vm.CustomerID,
                                    AssignedTo: $scope.vm.AssignedTo,
                                    Frequency: $scope.vm.Frequency,
                                    ServiceOn: $scope.ServiceOn,
                                    Types: $scope.vm.Types,
                                    Status: $scope.status,
                                    Startsat: $scope.vm.ServiceStartAtlog,
                                    Endsat: $scope.vm.ServiceEndAtlog,
                                    ScheduledStartsat: currentDate,
                                    ScheduledEndsat: enddate,
                                    PestType: $scope.vm.PestType1,
                                    ContractOrder: $scope.vm.ContractOrder,
                                    ServiceID: $scope.vm.ServiceID,
                                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                    CreatedBy: $rootScope.createdby,
                                    IsActive: true,
                                },
                            });
                            lresponse.then(function (GList) {
                                RefreshGrid()
                                $mdDialog.cancel();
                                $scope.pesttypeGrid = true;
                                $scope.shedulerform = true;
                                $scope.addbtn = true;
                                $scope.viewbtn = false;
                                $scope.exportbtn = true;
                                $scope.thdata = false;
                                $scope.schedulartab = true;
                                $mdDialog.cancel();
                                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                            })
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
            }
        }
        $scope.BillableSubmit = function () {
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/update",
                data: {
                    _id: $scope.vm.ScedulId,
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.Customer_Id,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: $scope.vm.Frequency,
                    ServiceOn: $scope.vm.ServiceOn,
                    Types: $scope.vm.Types,
                    Status: $scope.vm.Status,
                    Startsat: $scope.vm.ServiceStartAt,
                    Endsat: $scope.vm.ServiceEndAt,
                    PestType: $scope.vm.PestType1,
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: $scope.vm.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                    BillingAmount: $scope.vm.BillingAmount,
                    Billable: $scope.Billable.value,
                    CollectPayment: $scope.CollectPayment.value,
                    Vehicle: $scope.vm.Vehicle,
                    Location: $scope.vm.Location,
                    Client_Id: $rootScope.Client_Id,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.AddServiceMaterials = function () {
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.SMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletlighttracklist/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else if ($scope.vm.SMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletlighttracklist/update",
                    data: {
                        _id: $scope.SMId,
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.ServiceMaterialinfo = function (item) {
            $scope.vm.SMUpdate = true;
            $scope.SMId = item.id;
            $scope.vm.SMPestType = item.PestType;
            try {
                if (item.Services != null && item.Services != "" && item.Services != undefined) {
                    var array = item.Services.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ Servicetype: value });
                    });
                    $scope.vm.MServicetype = array1;
                }
            } catch (e) { }
        }
        $scope.EditMobileLogs = function (e, Sid) {
            $scope.vm.SMLMUpdate = false;
            $scope.vm.SMUpdate = false;
            $scope.vm.SMPestType = null;
            $scope.vm.MServicetype = null;
            $scope.vm.MLSMPestType = null;
            $scope.vm.MMaterialsName = null;
            $scope.vm.MQuantity = null;
            $scope.vm.MUnit = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/flexischeduler/Editemobilelog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function flexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.ServiceID = Sid;
            $scope.vm.starRating1 = 0;
            $scope.vm.tbsc_id = null;
            if ($scope.vm.Status == 'Completed') {
                angular.forEach($scope.Tabletschedulerrecord, function (value) {
                    try {
                        if ($scope.vm.ScedulId === value.ServiceId) {
                            $scope.vm.tbsc_id = value._id
                            $scope.vm.Pesttype = value.Pesttype
                            if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
                                var array = $scope.vm.Pesttype.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ PestName: value });
                                });
                                $scope.Pestdatas = array1;
                            }
                            $scope.vm.Services = value.Services
                            $scope.vm.Materials = value.Materials
                            if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                                var array = $scope.vm.Services.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ Servicetype: value });
                                });
                                $scope.vm.MServicetype = array1;
                            }
                            if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                                var array = $scope.vm.Materials.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ MaterialsName: value });
                                });
                                $scope.vm.MMaterialsName = array1;
                            }
                            $scope.vm.TeamMember = value.TeamMember
                            $scope.vm.TeamRemarks = value.TeamRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.TeamLead = value.TeamLead
                            $scope.vm.ATimeIn = new Date(value.Startsat);
                            $scope.vm.ATimeOut = new Date(value.Endsat);
                            $scope.vm.Scheduledate = new Date(value.Scheduledate);
                            $scope.CustomerSignature = value.CustomerSignature;
                            $scope.uPB1 = value.PB1;
                            $scope.uPB2 = value.PB2;
                            $scope.uPB3 = value.PB3;
                            $scope.uPB4 = value.PB4;
                            $scope.uPA1 = value.PA1;
                            $scope.uPA2 = value.PA2;
                            $scope.uPA3 = value.PA3;
                            $scope.uPA4 = value.PA4;
                            $scope.vm.TeamSignature = value.TeamSignature;
                            $scope.vm.Paymentmethod = value.Paymentmethod;
                            $scope.vm.MobilEmailId = value.EmailId;
                            $scope.vm.PaymentRemarks = value.PaymentRemarks;
                            $scope.vm.Totalpayment = parseInt(value.Totalpayment);
                            $scope.vm.PaymentNotes = value.PaymentNotes;
                            $scope.vm.Totalarea = parseInt(value.Totalarea);
                            $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
                            $scope.starRating1r = value.Rating;
                            $scope.vm.starRating1 = value.Rating;
                            $scope.vm.AServiceStartAt = new Date(value.Startsat);
                            $scope.vm.AServiceEndAt = new Date(value.Endsat);
                            $scope.vm.CustomerCurrentDate = new Date(CustomerCurrentDate);
                        }
                    }
                    catch (e) { }
                })
            }
            else {
                $scope.vm.tbsc_id = null;
            }
        }
        $scope.AddMobileLogMaterials = function () {

            if ($scope.vm.SMLMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletMaterials/add",
                    data: {
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        CreatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
            else if ($scope.vm.SMLMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletMaterials/update",
                    data: {
                        _id: $scope.SMLMId,
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
        }
        $scope.MobileLogMaterialinfo = function (item) {
            $scope.vm.SMLMUpdate = true;
            $scope.SMLMId = item.id;
            $scope.vm.MLSMPestType = item.PestType;
            $scope.vm.MMaterialsName = item.MaterialName;
            $scope.vm.MQuantity = parseFloat(item.Quantity);
            $scope.vm.MUnit = item.Unit;
        }
        $scope.EditmobileSubmit = function () {
            if ($scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == undefined) {
                $scope.vm.BreedingFound = null;
            }
            if ($scope.vm.Species == "" || $scope.vm.Species == "undefined" || $scope.vm.Species == undefined) {
                $scope.vm.Species = null;
            }
            if ($scope.vm.Findings == "" || $scope.vm.Findings == "undefined" || $scope.vm.Findings == undefined) {
                $scope.vm.Findings = null;
            }
            if ($scope.vm.MistingCariedOut == "" || $scope.vm.MistingCariedOut == "undefined" || $scope.vm.MistingCariedOut == undefined) {
                $scope.vm.MistingCariedOut = null;
            }
            if ($scope.vm.Reason == "" || $scope.vm.Reason == "undefined" || $scope.vm.Reason == undefined) {
                $scope.vm.Reason = null;
            }
            if ($scope.vm.Instar == "" || $scope.vm.Instar == "undefined" || $scope.vm.Instar == undefined) {
                $scope.vm.Instar = null;
            }
            if ($scope.vm.Density == "" || $scope.vm.Density == "undefined" || $scope.vm.Density == undefined) {
                $scope.vm.Density = null;
            }
            if ($scope.vm.Others == "" || $scope.vm.Others == "undefined" || $scope.vm.Others == undefined) {
                $scope.vm.Others = null;
            }
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.MMaterialsName != null && $scope.vm.MMaterialsName != "" && $scope.vm.MMaterialsName != undefined) {
                $scope.vm.MMaterialsName = $scope.vm.MMaterialsName.map(function (obj) { return obj.MaterialsName; }).join(',');
            }

            if ($scope.vm.tbsc_id != undefined && $scope.vm.tbsc_id != null && $scope.vm.tbsc_id != "") {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/update",
                    data: {
                        _id: $scope.vm.tbsc_id,
                        ServiceId: $scope.vm.ServiceID,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: $scope.vm.Startsat,
                        Endsat: $scope.vm.Endsat,
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: $scope.CustomerCurrentDate,
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: new Date(),
                        Endsat: new Date(),
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: new Date(),
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    var response1 = $http({
                        url: $rootScope.WebURL + "/scheduler/Statusupdate",
                        method: "PUT",
                        data: {
                            _id: $scope.vm.ScedulId,
                            Status: "Completed",
                            UpdatedBy: $rootScope.createdby,
                        },
                    });
                    response1.then(function (GList) {
                        $mdDialog.cancel();
                        $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
                        $mdDialog.cancel();
                        RefreshGrid();
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
        }
        $scope.Schinfodelete = function (deleteID) {
            try {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === deleteID;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                    var teamLead = item.teamdetails[0].TeamLead;
                    var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                    $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceOn = item.ServiceOn;
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
                $scope.Status = item.Status;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
            } catch (e) { }
            $scope.Emails = null;
            if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                    if (createdBy.indexOf(uvalue.UserID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                })
                if (array.length > 0) {
                    var SenderEmails = [];
                    $scope.Emailgroups = _.groupBy(array, 'EmailId');
                    angular.forEach($scope.Emailgroups, function (value) {
                        SenderEmails.push(value[0].EmailId);
                    });
                    $scope.Emails = SenderEmails;
                }
            }
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                    _id: deleteID,
                    Status: "Cancelled",
                    CancelRemarks: $scope.vm.CancelRemarks,
                    SenderEmailAddress: $scope.Emails,
                    CompanyName: $scope.CompanyName,
                    ScheduleDate: $scope.ServiceStartAt,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                var lresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulelog/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        JobsOrders: $scope.jobdata,
                        Customer: $scope.CustomerID,
                        AssignedTo: $scope.AssignedTo,
                        Frequency: $scope.Frequency,
                        ServiceOn: $scope.ServiceOn,
                        Types: $scope.Types,
                        Status: $scope.Status,
                        Startsat: $scope.ServiceStartAt,
                        Endsat: $scope.ServiceEndAt,
                        PestType: $scope.PestType,
                        ContractOrder: $scope.ContractOrder,
                        ServiceID: $scope.ServiceID,
                        CancelRemarks: $scope.vm.CancelRemarks,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true,
                    },
                });
                lresponse.then(function (GList) {
                    LoadSchedulerData();
                    $mdDialog.cancel();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                })
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshPhotos() {
            $scope.Photosdatas = [];
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulerpicafter",
                data: { ScedulId: $scope.vm.ScheduleServiceId },
            }).then(function (Glist) {
                $scope.Photosdatas = Glist.data.data;
                angular.forEach($scope.Photosdatas, function (item) {
                    item.Path = $rootScope.ServicePhotosURL + item.ServiceId + "/" + item.id + ".png";
                });
            });
        }

        function RefreshServiceMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletlighttracklist/getbyId",
                method: "POST",
                data: { ServiceId: $scope.vm.ScedulId },
            });
            response.then(function (Tabletlighttracklistdata) {
                $scope.Tabletlighttracklistdatas = Tabletlighttracklistdata.data.data;
            });
            $scope.vm.SMUpdate = false;
        }
        function RefreshMobileLogMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletMaterials/getById",
                method: "POST",
                data: { Service_Id: $scope.vm.ScedulId },
            });
            response.then(function (TabletMaterialslistdata) {

                $scope.TabletMaterialslistdatas = TabletMaterialslistdata.data.data;
            });
            $scope.vm.SMLMUpdate = false;
        }
        function RefreshSchedulerLogs() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulelog/getByServiceID",
                method: "POST",
                data: { ServiceID: $scope.vm.ServiceID },
            });
            response.then(function (SchedulerLogdata) {

                $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id }
        }).then(function (pocarddatas) {
            $scope.Pesttypedatas = pocarddatas.data.data;
        })
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/getByClientId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
                angular.forEach($scope.Userdatas, function (value) {
                    angular.forEach($scope.Employeedatas, function (evalue) {
                        if (value.EmployeeID == evalue.EmployeeID)
                            value.EmployeeID = evalue.EmployeeName;
                    })
                })
                LoadSchedulerData()
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicetypelist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Servicesdata) {
            $scope.Servicesdatas = Servicesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item1 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item1;
            }
            catch (e) { }
            try {
                var item2 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'PaymentMode';
                });
                $scope.PaymentModedatas = item2;
            }
            catch (e) { }
            try {
                var item3 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'Remarks';
                });
                $scope.Remarksdatas = item3;
            }
            catch (e) { }
            try {
                var item4 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'JobTypes';
                });
                $scope.JobTypesdatas = item4;
            }
            catch (e) { }
        });
        vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            select: {
                style: 'multi'
            },
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }

            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtdetails = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-Detailsdt');
                var table = $('#Detailsdt').DataTable();
                table.search('').draw();
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[3, "asc"]],
            lengthMenu: [5, 10, 20, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };

        // socket configurations
        socket.on("Scheduler Created by Inserting multiple", function (data) {
            var schedresult = data.result
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("scheduler dragged", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("scheduler dropped", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler specified update", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler cancelled", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Team Updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Scheduler UpdateTeam method", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Update Scheduler Line", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Completed", function (data) {
            $scope.Datefilter()
        })
        socket.on("WorkOrder unscheduled", function (data) {
            $scope.Datefilter()
        })


        // get scheduler data for socket


    }

})();
(function () {
    'use strict';

    angular
        .module('app.operations.feedback', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.operations_feedback', {
            url: '/Feedback',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/feedback/feedback.html',
                    controller: 'FeedbackController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/feedback');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operations.feedback')
        .controller('FeedbackController', FeedbackController);

    /** @ngInject */
    function FeedbackController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $mdDialog, $document, $http, $log, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("OP-Feedback")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }


        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var Client_Id = localStorage.getItem('Client_Id');

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        DefaultDatefilter();
        RefreshCustomerGrid();


        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("FeedbackDetails.xlsx",{headers:true}) FROM ?', [$scope.Feedbackdatas]);
        };

        function DefaultDatefilter() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/customerfeedback/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                debugger
                $scope.Feedbackdatas = GList.data.data;
            });
        }

        function RefreshCustomerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Customerdata) {
                $scope.Customerdatas = Customerdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/customerfeedback/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Feedbackdatas = GList.data.data;
            });
        }

        $scope.UpdateStatus = function (e, FId) {
            debugger
            $scope.FUpdate = true;
            $scope.FID = FId;
            try {
                var item = $scope.Feedbackdatas.filter(function (item) {
                    return item._id === FId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.DateofService = new Date(item.DateofService);
                $scope.WorkOrder = item.WorkOrder;
                $scope.Contract = item.Contract;
                $scope.ServiceNo = item.ServiceNo;
                $scope.PestType = item.PestType;
                $scope.Feedback = item.Feedback;
                $scope.Status = item.Status;
                $scope.Comment = item.Comment;
            } catch (err) { }

            if ($scope.Status == "Closed") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied!!! This Feedback already Closed...')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $mdDialog.show({
                    templateUrl: 'app/main/apps/operations/feedback/updatefeedbackstatus.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function FeedbackController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            }

        }

        $scope.saveCloseStatus = function () {
            debugger


            if ($scope.FUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/customerfeedback/update",
                    data: {
                        _id: $scope.FID,
                        DateofService: $scope.DateofService,
                        WorkOrder: $scope.WorkOrder,
                        Contract: $scope.Contract,
                        ServiceNo: $scope.ServiceNo,
                        PestType: $scope.PestType,
                        Feedback: $scope.Feedback,
                        Status: "Closed",
                        Comment: $scope.vm.Comment,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    DefaultDatefilter();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else { }
        }


        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();



(function () {
    'use strict';

    angular
        .module('app.operations.divisions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.crmdivisions', {
            url: '/CRMDivisions',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/divisions/divisions.html',
                    controller: 'divisionsProjectController as vm'
                }
            }
        });
         $translatePartialLoaderProvider.addPart('app/main/apps/operations/divisions');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.divisions')
        .controller('divisionsProjectController', divisionsProjectController);


    /** @ngInject */
    function divisionsProjectController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, moment, alert, calendarConfig) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Division")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }
        $scope.DivisionGrid = true;
        $scope.exportbtn = true;
        $scope.Divisionform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.Divisionform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.DivisionGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.Divisionform = false;
            $scope.DivisionGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.DivisionGrid = true;
            $scope.Divisionform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {

            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Divisionform = true;
            $scope.DivisionGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.error1 = false;
            $scope.Search = false;
        }

        $scope.Divisioninfo = function (DivisionId) {
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = DivisionId;
            $scope.Update = true;
            $scope.Divisionform = true;
            $scope.DivisionGrid = false;
            $scope.areainfoId = DivisionId;
            // var Pesttypedata = $scope.pesttypedatas
            var info = $scope.Divisiondatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == DivisionId) {

                    $scope.DivisionName = info[i].DivisionName;
                    $scope.Description = info[i].Description;

                }
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/crmdivision/update",
                    data: {
                        _id: $scope.SID,
                        DivisionName: $scope.DivisionName,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.addbtn = true;
                    $scope.DivisionGrid = true;
                    $scope.Divisionform = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/crmdivision/add",
                    data: {
                        DivisionName: $scope.DivisionName,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing DivisionName") {
                        $scope.error1 = true;
                        $scope.Divisionform = true;
                        $scope.DivisionGrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.DivisionGrid = true;
                        $scope.Divisionform = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Divisiondatas.xlsx",{headers:true}) FROM ?', [$scope.Divisiondatas]);
        };

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });
        }
        function ClearForm() {
            $scope.DivisionName = '';
            $scope.Description = '';
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };
    }


})();







(function () {
    'use strict';

    angular
      .module('app.operations.emailalert', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
      $stateProvider.state('app.operations_emailalert', {
        url: '/EmailAlertSettings',
            views: {
                'content@app': {
                  templateUrl: 'app/main/apps/operations/emailalert/emailalert.html',
                  controller: 'emailalertController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/team');
    }

})();

(function () {
  'use strict';

  angular
    .module('app.operations.emailalert')
    .controller('emailalertController', emailalertController);

  /** @ngInject */
  function emailalertController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, $location, $filter, $mdDateLocale) {
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("Teams")) {   // do nothing 
    }
    else { window.location = 'NoAccess'; }

    var Client_Id = localStorage.getItem('Client_Id');
    $rootScope.LoginedUser = localStorage.getItem('UserName');
    $rootScope.LoginID = localStorage.getItem('LoginID');

    $scope.EmailAlertgrid = true;
    $scope.EmailAlertform = false;
    $scope.Export = true;
    $scope.Add = true;
    $scope.View = false;
    $scope.Search = true;
    $scope.error1 = false;
    RefreshGrid();

    $scope.Export = function () {
      alasql('SELECT * INTO XLSX("EmailAlerts.xlsx",{headers:true}) FROM ?', [$scope.EmailAlertdatas]);
    };

    $scope.Showgrid = function () {
      $scope.EmailAlertgrid = true;
      $scope.EmailAlertform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.View = false;
      $scope.Search = true;
      $scope.error1 = false;
    }

    $scope.sAdd = function () {
      ClearForm();
      $scope.Scenario = 0;
      $scope.AlertType = "Outstanding Jobs";
      $scope.RecipientsLabel = "It will send email to team members & job creator";
      $scope.Update = false;
      $scope.EmailAlertgrid = false;
      $scope.EmailAlertform = true;
      $scope.Export = false;
      $scope.Add = false;
      $scope.View = true;
      $scope.Search = false;
      $scope.error1 = false;
      $scope.ShowRecipients = true;
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
    }

    $scope.eSubmit = function () {
      if ($scope.Scenario < 0) {
        $mdToast.show($mdToast.simple().textContent('Invalid Scenario!!').position('top center'));
        return
      }

      if ($scope.AlertType === "Outstanding Jobs" || $scope.AlertType === "Rodents Summary Report") {
        $scope.Recipients = $scope.Recipients;

        var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
        var trueEmailValid = true;
        var falseEmailValid = true;
        if ($scope.Recipients != "" && $scope.Recipients != null && $scope.Recipients != undefined) {
          angular.forEach($scope.Recipients, function (ite) {
            if (reg.test(ite)) {
              trueEmailValid = true;
            }
            else {
              falseEmailValid = false;
            }
          })
          if (falseEmailValid === false) {
            $mdToast.show($mdToast.simple().textContent('Enter valid email !').position('top center'));
            return
          }
        }
        else {
          $mdToast.show($mdToast.simple().textContent('Recipients Required !').position('top center'));
          return
        }

        if (falseEmailValid != false) {
          $scope.EmailRecipients = $scope.Recipients.map(function (obj) { return obj; }).join(',');
        }
      }
      else {
        $scope.EmailRecipients = "";
      }

      if ($scope.Update == true) {
        $scope.IndexID = $scope.IndxID;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/emailalertsettings/update",
          data: {
            _id: $scope.SID,
            AlertType: $scope.AlertType,
            Scenario: $scope.Scenario,
            Notes: $scope.Notes,
            Recipients: $scope.EmailRecipients,
            UpdatedBy: $rootScope.LoginID,
          },
        });
        response.then(function (GList) {
          $scope.EmailAlertdatas[$scope.IndexID] = GList.data.data;
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          $scope.Showgrid();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/emailalertsettings/add",
          data: {
            Client_Id: Client_Id,
            AlertType: $scope.AlertType,
            Scenario: $scope.Scenario,
            Notes: $scope.Notes,
            Recipients: $scope.EmailRecipients,
            CreatedBy: $rootScope.LoginID,
          },
        });
        response.then(function (GList) {
          if (GList.data.message == "Existing Alert Type") {
            $scope.error1 = true;
            $scope.EmailAlertgrid = false;
            $scope.EmailAlertform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.View = true;
            $scope.Search = false;
            $mdToast.show($mdToast.simple().textContent('Alert Type Is already Exist!').position('top center'));
          }
          else {
            $scope.error1 = false;
            RefreshGrid();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
            $scope.Showgrid();
          }
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
    }

    $scope.EmailAlertinfo = function (ERId, $index) {
      $scope.SID = ERId;
      $scope.IndxID = $index;
      $scope.vm.Spinner = true;

      try {
        var item = $scope.EmailAlertdatas.filter(function (item) {
          return item.id === ERId;
        })[0];
        $scope.id = item.id;
        $scope.AlertType = item.AlertType;
        $scope.Scenario = parseFloat(item.Scenario);
        $scope.Notes = item.Notes;
        $scope.EmailRecipients = item.Recipients;
      } catch (err) { }
      if ($scope.AlertType === "Outstanding Jobs" || $scope.AlertType === "Rodents Summary Report") {
        if ($scope.EmailRecipients != null && $scope.EmailRecipients != "" && $scope.EmailRecipients != undefined) {
          $scope.Recipients = $scope.EmailRecipients.split(",");
          $scope.ShowRecipients = true;
          $scope.EmailRecipients = null;
        }
      }
      else {
        $scope.RecipientsLabel = "It will send email to team members & job creator";
        $scope.ShowRecipients = false;
      }

      if ($scope.AlertType == "Outstanding Jobs") {
        $scope.LogType = "Service Outstandig Job";
      }
      else if ($scope.AlertType == "Rescheduled Jobs") {
        $scope.LogType = "Service Rescheduled Job";
      }
      else if ($scope.AlertType == "Cancelled Jobs") {
        $scope.LogType = "Service Cancelled Job";
      }
      else if ($scope.AlertType == "Rodents Summary Report") {
        $scope.LogType = "Rodents Summary Report";
      }

      $scope.EmailLogHistory = [];
      var today = new Date();
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var Lresponse = $http({
        url: $rootScope.WebURL + "/emaillogdetails/datefilterLogHistory",
        method: "POST",
        data: { Type: $scope.LogType, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
      });
      Lresponse.then(function (GList) {
        $scope.EmailLogHistory = GList.data.data;
        $scope.vm.Spinner = false;
      });

      $scope.Update = true;
      $scope.EmailAlertgrid = false;
      $scope.EmailAlertform = true;
      $scope.Export = false;
      $scope.Add = false;
      $scope.View = true;
      $scope.Search = false;
    }

    $scope.Today = function () {
      $scope.vm.Spinner = true;
      $scope.EmailLogHistory = [];
      var today = new Date();
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var Lresponse = $http({
        url: $rootScope.WebURL + "/emaillogdetails/datefilterLogHistory",
        method: "POST",
        data: { Type: $scope.LogType, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
      });
      Lresponse.then(function (GList) {
        $scope.EmailLogHistory = GList.data.data;
        $scope.vm.Spinner = false;
      });
    }

    $scope.LastWeek = function () {
      $scope.vm.Spinner = true;
      $scope.EmailLogHistory = [];
      var gettoday = new Date();
      var today = new Date(gettoday.getFullYear(), gettoday.getMonth(), gettoday.getDate() - 6);
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var Lresponse = $http({
        url: $rootScope.WebURL + "/emaillogdetails/datefilterLogHistory",
        method: "POST",
        data: { Type: $scope.LogType, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
      });
      Lresponse.then(function (GList) {
        $scope.EmailLogHistory = GList.data.data;
        $scope.vm.Spinner = false;
      });
    }

    $scope.LastMonth = function () {
      $scope.vm.Spinner = true;
      $scope.EmailLogHistory = [];
      var gettoday = new Date();
      var today = new Date(gettoday.getFullYear(), gettoday.getMonth() - 1, gettoday.getDate());
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var Lresponse = $http({
        url: $rootScope.WebURL + "/emaillogdetails/datefilterLogHistory",
        method: "POST",
        data: { Type: $scope.LogType, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
      });
      Lresponse.then(function (GList) {
        $scope.EmailLogHistory = GList.data.data;
        $scope.vm.Spinner = false;
      });
    }

    $scope.DatefilterOverallLogHistory = function () {
      $scope.vm.Spinner = true;
      $scope.EmailLogHistory = [];
      $scope.uFrom = new Date($scope.uFrom);
      $scope.uTo = new Date($scope.uTo);
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var Lresponse = $http({
        url: $rootScope.WebURL + "/emaillogdetails/datefilterLogHistory",
        method: "POST",
        data: { Type: $scope.LogType, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
      });
      Lresponse.then(function (GList) {
        $scope.EmailLogHistory = GList.data.data;
        $scope.vm.Spinner = false;
      });
    }

    $scope.AlertTypeList = [
      { Name: "Outstanding Jobs" },
      { Name: "Rescheduled Jobs" },
      { Name: "Cancelled Jobs" },
      //{ Name: "Rodents Summary Report" }
    ];

    $scope.AlertTypeChanged = function () {
      $scope.error1 = false;
      if ($scope.AlertType == "Outstanding Jobs" || $scope.AlertType == "Rodents Summary Report") {
        $scope.ShowRecipients = true;
      }
      else {
        $scope.ShowRecipients = false;
      }
    }

    function RefreshGrid() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/emailalertsettings",
        data: { Client_Id: Client_Id },
      });
      response.then(function (EmailAlertdata) {
        $scope.EmailAlertdatas = EmailAlertdata.data.data;
      });
    }

    function ClearForm() {
      $scope.AlertType = "Outstanding Jobs";
      $scope.Scenario = 0;
      $scope.Notes = "";
      $scope.Recipients = [];
      $scope.RecipientsLabel = "It will send email to team members & job creator";
    }

    var vm = this;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');
        var table = $('#forms-dtDetails').DataTable();
        table.search('').draw();
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },

      pagingType: 'simple',
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      responsive: true,
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };

    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }
  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.operations.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.operations_dashboard', {
            url      : '/DashboardOperations',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/dashboard/operations.html',
                    controller : 'DashboardOperationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/dashboard');

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function () {
  'use strict';

  angular
    .module('app.operations.dashboard')
    .filter('groupBy', function () {
      return _.memoize(function (items, field) {
        return _.groupBy(items, field);
      }
      );
    })
    .controller('DashboardOperationController', DashboardOperationController);

  function DashboardOperationController($http, $state, $scope, $rootScope, $window, $timeout, $interval, $mdSidenav, $location, $filter, $q, DashboardData, $mdDialog, $document, NgMap, moment) {
    document.getElementsByTagName('title')[0].text = "Operations-Dashboard"
    if ($rootScope.WebURL == undefined) $rootScope.WebURL = "23.108.102.7:3420"
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("DOperations")) {   // do nothing 
    }
    else { $location.path("NoAccess"); }
    var Client_Id = localStorage.getItem('Client_Id');

    $scope.totalAdHocJobs = 0;
    $scope.totalUnscheduledJobs = 0;
    $scope.totalUncompletedJobs = 0;
    $scope.YetToStartJobs = 0;
    $scope.OutstandingJobs = 0;
    $scope.totalServiceReportPendingApproval = 0;
    $scope.TodayDate = getDateonlyForDashboard(new Date());

    $scope.efficiencyJobs = [{ label: 'Time Working', value: 5 }, { label: 'Time Efficiency', value: 3 }];

    RefreshAdhocJobs();
    RefreshServiceReportStatusPendingJobs();
    RefreshUncompletedJobs();
    getCountByStatus()
    RefreshJobscompleted();
    // getTimeEfficiency()
    var TabletSchedulerforCustomrRating = []


    function RefreshAdhocJobs() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/GetAllAdhocJobs",
        data: { Client_Id: Client_Id },
      });
      response.then(function (adhocjobs) {
        $scope.getAllJobs = adhocjobs.data.data;
        if ($scope.getAllJobs.length > 0) {
          try {
            $scope.totalAdHocJobs = $scope.getAllJobs.filter(function (item) {
              return item.WorkOrderType === "Ad-hoc";
            }).length;
          } catch (e) { }
        }
      });
    }

    function RefreshServiceReportStatusPendingJobs() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/GetServiceReportStatusPending",
        data: { Client_Id: Client_Id },
      });
      response.then(function (statuspendingJobs) {
        $scope.totalServiceReportPendingApproval = statuspendingJobs.data.data;
      });
    }

    function RefreshUncompletedJobs() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/datefilter",
        data: { Start_Date: new Date(new Date().setHours(0, 0, 0, 0)), Client_Id: $rootScope.Client_Id },
      }).then(function (salesorder) {
        var item = salesorder.data.data.filter(function (item) {
          return item.Status === "New"
        });
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder/getPending",
          data: { Client_Id: $rootScope.Client_Id },
        }).then(function (salesorder) {
          var item = salesorder.data.data
          var PendingScheduledatas = item
          $scope.totalUncompletedJobs = PendingScheduledatas.length;
        })
      })
    }
    function getCountByStatus() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getCountByStatus",
        data: { Client_Id: Client_Id, Status: "Yet to Start" },
      });
      response.then(function (uncompletedJobs) {
        $scope.YetToStartJobs = uncompletedJobs.data.data;
      });
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getCountByStatus",
        data: { Client_Id: Client_Id, Status: "Outstanding" },
      });
      response.then(function (uncompletedJobs) {
        $scope.OutstandingJobs = uncompletedJobs.data.data;
      });
    }

    function RefreshJobscompleted() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/GetLastFiveDaysCompletedJobs",
        data: { Client_Id: Client_Id },
      });
      response.then(function (lastFiveDaysCompletedJobs) {
        $scope.getLastFiveDaysCompletedJobs = lastFiveDaysCompletedJobs.data.data;

        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/GetUpcomingFiveDaysJobs",
          data: { Client_Id: Client_Id },
        });
        response.then(function (upcomingFiveDaysJobs) {
          $scope.getUpcomingFiveDaysJobs = upcomingFiveDaysJobs.data.data;
          $scope.LastFiveDaysCompletedJobs = $scope.getLastFiveDaysCompletedJobs.length;
          $scope.UpcomingFiveDaysJobs = $scope.getUpcomingFiveDaysJobs.length;
          $scope.completedJobs = [{ label: 'Completed Jobs', value: $scope.LastFiveDaysCompletedJobs }, { label: 'Upcoming Jobs', value: $scope.UpcomingFiveDaysJobs }];

          vm.widget3 = {
            title: "Job Completed",
            mainChart: {
              options: {
                chart: {
                  type: 'pieChart',
                  color: ['#12c752', '#ff0000'],
                  height: 400,
                  margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                  },
                  labelType: 'percent',
                  x: function (d) {
                    return d.label;
                  },
                  y: function (d) {
                    return d.value;
                  },
                  tooltip: {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data: $scope.completedJobs
            }
          };
        });
      });
    }

    $scope.goSchedulerPage = function (value) {
      localStorage.setItem("TabFromDashboard", value)
      $state.go('app.scheduler');
    };

    var vm = this;


    $scope.WorkingMonth = [
      { name: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleString('en-us', { month: 'short' }), value: 0 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toLocaleString('en-us', { month: 'short' }), value: 1 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toLocaleString('en-us', { month: 'short' }), value: 2 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1).toLocaleString('en-us', { month: 'short' }), value: 3 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 4, 1).toLocaleString('en-us', { month: 'short' }), value: 4 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1).toLocaleString('en-us', { month: 'short' }), value: 5 },
      { name: new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1).toLocaleString('en-us', { month: 'short' }), value: 6 }]
    $scope.thismonth = 0

    $scope.CalculateWorkingHours = function (value) {
      value = parseInt(value)
      $scope.WorkingHours = []
      $scope.thismonth = value
      $scope.WorkingHours = []
      $scope.thismonth = value
      var Start_Date = new Date(new Date().getFullYear(), new Date().getMonth() - value, 1);
      var End_Date = new Date(new Date().getFullYear(), new Date().getMonth() - (value - 1), 0);
      Start_Date.setHours(0, 0, 0, 0)
      End_Date.setHours(23, 59, 59, 999)
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getfordashbord",
        data: { Start_Date: Start_Date, End_Date: End_Date }
      })
      response.then(function (GList) {

        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/team/",
          data: { Client_Id: $rootScope.Client_Id },
        })
        response.then(function (TList) {
          var Team = TList.data.data
          var AllScheduleDatas = GList.data.data;
          var Tech = _.uniq(_.map(_.map(AllScheduleDatas, function (o) { return _.pick(o, "Team_Id") }), function (e) { return e.Team_Id }).join(',').split(','))
          var data = []
          Tech.forEach(function (o) {
            var item = Team.filter(function (i) {
              return i.id === o
            })[0]
            if (item != undefined)
              data.push(item.TeamName)
          })
          Tech = data.filter(Boolean)
          $scope.WorkingHours = []

          angular.forEach(Tech, function (value) {
            var Tec = value.split(" ")
            if (Tec.length > 1)
              Tec = Tec[0] + " " + Tec[1]
            else
              Tec = Tec[0]
            var eitem = []
            var WorkingHour = 0
            var OverTime = 0
            eitem = AllScheduleDatas.filter(function (eitem) {
              return eitem.TeamMembersName.includes(value)
            })
            if (eitem.length > 0) {
              angular.forEach(eitem, function (vitem) {
                if (new Date(vitem.Startsat).getDay() >= 1 && new Date(vitem.Startsat).getDay() <= 5) {
                  vitem.Endsat = new Date(new Date(new moment(new Date(vitem.Endsat).toTimeString(), 'HH:mm:ss')).getTime())
                  vitem.Endsat = new Date(new Date(vitem.Endsat).setSeconds(0))
                  vitem.Startsat = new Date(new Date(new moment(new Date(vitem.Startsat).toTimeString(), 'HH:mm:ss')).getTime())
                  if (vitem.Startsat < new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat <= new Date(new Date().setHours(9, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                  }
                  if (vitem.Endsat > new Date(new Date().setHours(18, 0, 0, 0)) && vitem.Startsat > new Date(new Date().setHours(18, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                  }
                  if (vitem.Startsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat < new Date(new Date().setHours(18, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    WorkingHour += Time
                  }
                  if (vitem.Startsat < new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat < new Date(new Date().setHours(18, 0, 0, 0))) {
                    var Time = moment(new Date(new Date().setHours(9, 0, 0, 0))).diff(moment(vitem.Startsat), 'seconds')
                    var Time1 = moment(vitem.Endsat).diff(moment(new Date(new Date().setHours(9, 0, 0, 0))), 'seconds')
                    OverTime += Time
                    WorkingHour += Time1
                  }
                  if (vitem.Startsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Startsat < new Date(new Date().setHours(18, 0, 0, 0)) && vitem.Endsat > new Date(new Date().setHours(18, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(new Date(new Date().setHours(18, 0, 0, 0))), 'seconds')
                    var Time1 = moment(new Date(new Date().setHours(18, 0, 0, 0))).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                    WorkingHour += Time1
                  }
                }
                else if (new Date(vitem.Startsat).getDay() >= 6) {
                  vitem.Endsat = new Date(new Date(new moment(new Date(vitem.Endsat).toTimeString(), 'HH:mm:ss')).getTime())
                  vitem.Endsat = new Date(new Date(vitem.Endsat).setSeconds(0))
                  vitem.Startsat = new Date(new Date(new moment(new Date(vitem.Startsat).toTimeString(), 'HH:mm:ss')).getTime())
                  if (vitem.Startsat < new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat <= new Date(new Date().setHours(9, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                  }
                  if (vitem.Endsat > new Date(new Date().setHours(13, 0, 0, 0)) && vitem.Startsat > new Date(new Date().setHours(13, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                  }
                  if (vitem.Startsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat < new Date(new Date().setHours(13, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                    WorkingHour += Time
                  }
                  if (vitem.Startsat < new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Endsat < new Date(new Date().setHours(13, 0, 0, 0))) {
                    var Time = moment(new Date(new Date().setHours(9, 0, 0, 0))).diff(moment(vitem.Startsat), 'seconds')
                    var Time1 = moment(vitem.Endsat).diff(moment(new Date(new Date().setHours(9, 0, 0, 0))), 'seconds')
                    OverTime += Time
                    WorkingHour += Time1
                  }
                  if (vitem.Startsat > new Date(new Date().setHours(9, 0, 0, 0)) && vitem.Startsat < new Date(new Date().setHours(13, 0, 0, 0)) && vitem.Endsat > new Date(new Date().setHours(13, 0, 0, 0))) {
                    var Time = moment(vitem.Endsat).diff(moment(new Date(new Date().setHours(13, 0, 0, 0))), 'seconds')
                    var Time1 = moment(new Date(new Date().setHours(13, 0, 0, 0))).diff(moment(vitem.Startsat), 'seconds')
                    OverTime += Time
                    WorkingHour += Time1
                  }
                }
                else {
                  vitem.Endsat = new Date(new Date(new moment(new Date(vitem.Endsat).toTimeString(), 'HH:mm:ss')).getTime())
                  vitem.Endsat = new Date(new Date(vitem.Endsat).setSeconds(0))
                  vitem.Startsat = new Date(new Date(new moment(new Date(vitem.Startsat).toTimeString(), 'HH:mm:ss')).getTime())
                  var Time = moment(vitem.Endsat).diff(moment(vitem.Startsat), 'seconds')
                  OverTime += Time
                }
              })
            }
            WorkingHour = (Math.abs(WorkingHour) / 3600)
            OverTime = (Math.abs(OverTime) / 3600)
            $scope.WorkingHours.push({
              day: Tec, temperature: parseFloat(WorkingHour.toFixed(2)), overtime: parseFloat(OverTime.toFixed(2))
            })
          })
        })
      })

      // $scope.chartOptions = {
      //   dataSource: $scope.WorkingHours,
      //   commonSeriesSettings: {
      //     argumentField: "day",
      //     type: "stackedBar"
      // },
      //   customizePoint: function () {
      //     if (this.value > highAverage) {
      //       return { color: "#ff7c7c", hoverStyle: { color: "#ff7c7c" } };
      //     } else if (this.value < lowAverage) {
      //       return { color: "#8c8cff", hoverStyle: { color: "#8c8cff" } };
      //     }
      //   },
      //   customizeLabel: function () {
      //     if (this.value > highAverage) {
      //       return {
      //         visible: true,
      //         backgroundColor: "#ff7c7c",
      //         customizeText: function () {
      //           return this.valueText + " Hours";
      //         }
      //       };
      //     }
      //   },
      //   "export": {
      //     enabled: true
      //   },
      //   valueAxis: {
      //     title: {
      //       text: "Hours"
      //     },
      //     visualRange: {
      //       startValue: 0
      //     },
      //     maxValueMargin: 0.01,
      //     label: {
      //       customizeText: function () {
      //         return this.valueText;
      //       },
      //     },
      //     constantLines: [{
      //       label: {
      //         text: "Low Average"
      //       },
      //       width: 2,
      //       value: 0,
      //       color: "#8c8cff",
      //       dashStyle: "dash"
      //     }, {
      //       label: {
      //         text: "High Average"
      //       },
      //       width: 2,
      //       value: 176,
      //       color: "#ff7c7c",
      //       dashStyle: "dash"
      //     }]
      //   },
      //   series: [
      //     { valueField: "temperature", name: "Office Hours" },
      //     { valueField: "overtime", name: "Over Time" },
      // ],
      //   // title: {
      //   //   text: "Daily Temperature in May"
      //   // },
      //   legend: {
      //     visible: false
      //   },
      //   argumentAxis:{
      //     label:{
      //       overlappingBehavior: 'ignore'
      //       }
      //     },

      //   tooltip: {
      //     enabled: true
      //   },
      //   bindingOptions: {
      //     dataSource: "WorkingHours"
      //   }
      // };
      $scope.chartOptions = {
        dataSource: $scope.WorkingHours,
        commonSeriesSettings: {
          argumentField: "day",
          type: "stackedBar"
        },
        series: [
          { valueField: "temperature", name: "Office Hours" },
          { valueField: "overtime", name: "Over Time" },
        ],
        legend: {
          verticalAlignment: "bottom",
          horizontalAlignment: "center",
          itemTextPosition: 'top'
        },
        valueAxis: {
          title: {
            text: "Hours"
          },
          position: "right"
        },
        title: "Working Hours of Technician",
        "export": {
          enabled: true
        },
        argumentAxis: {
          label: {
            overlappingBehavior: 'ignore'
          }
        },
        tooltip: {
          enabled: true,
          location: "edge",
          customizeTooltip: function (arg) {
            return {
              text: arg.seriesName + " Hours : " + arg.valueText
            };
          }
        },
        bindingOptions: {
          dataSource: "WorkingHours"
        }
      };
    }
    $scope.CalculateWorkingHours(0)

    $scope.getEfficiencyofEmployees = function (Tech, value) {

      $scope.SelectedMember = Tech
      $scope.thisEmonth = value
      var TimeIdle = 0
      var Totaldays = 0
      if ($scope.thisEmonth == "This Month") {

        var StartDate = new Date(new Date().setDate(1))
        var EndDate = new Date()
      }
      else {
        value = parseInt(value)
        var StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - value, 1);
        var EndDate = new Date(new Date().getFullYear(), new Date().getMonth() - (value - 1), 0);
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/tabletschedulerrecord/getfordashbord",
        data: { Start_Date: StartDate, End_Date: EndDate }
      })
      response.then(function (Glist) {
        $scope.TabletSchedulerrecordforCurrent = Glist.data.data
        if ($scope.thisEmonth == "This Month") {
          Totaldays = new Date().getDate()

          //getTimeIdle () gets time excluding public holidays and weekends, saturdays calculation 8:30 am to 12:30 pm

          TimeIdle = getTimeIdle($scope.PHDetailsdatas, new Date(new Date().setDate(1)), new Date())
        }
        else {
          //getTimeIdle () gets time excluding public holidays and weekends, saturdays calculation 8:30 am to 12:30 pm
          TimeIdle = getTimeIdle($scope.PHDetailsdatas, new Date(new Date().getFullYear(), new Date().getMonth() - value, 1), new Date(new Date().getFullYear(), new Date().getMonth() - (value - 1), 0))
          Totaldays = new Date(new Date().getFullYear(), new Date().getMonth() - (value - 1), 0).getDate()
        }
        var TimeWorking = 0
        if (Tech == "Total Technicians") {
          angular.forEach($scope.TabletSchedulerrecordforCurrent, function (item) {
            var Time = moment(item.Endsat).diff(moment(item.Startsat), 'seconds')
            TimeWorking += Time
          })
          // Totaldays *= TimeIdle
          // TimeIdle -= TimeWorking
          $scope.CurrentefficiencyJobs = [{ label: 'Time Working', value: TimeWorking / 3600 }, { label: 'Time Idle', value: TimeIdle / 3600 }];
        }
        else {
          var item = []
          item = $scope.TabletSchedulerrecordforCurrent.filter(function (item) {
            return item.TeamMember.includes(Tech)
          })
          if (item.length > 0) {
            angular.forEach(item, function (item1) {
              var Time = moment(item1.Endsat).diff(moment(item1.Startsat), 'seconds')
              TimeWorking += Time
            })
          }
          else TimeWorking = 0

          var Totaldays = new Date().getDate()
          // Totaldays *= TimeIdle
          // TimeIdle -= TimeWorking
          $scope.CurrentefficiencyJobs = [{ label: 'Time Working', value: TimeWorking / 3600 }, { label: 'Time Idle', value: TimeIdle / 3600 }];
        }

        $scope.MonthEfficiancy = [
          { name: "This Month", value: "This Month" },
          { name: "Last Month (" + new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 1 },
          { name: "Last 2 Month (" + new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 2 },
          { name: "Last 3 Month (" + new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 3 },
        ]
        vm.widget1 = {
          mainChart: {
            options: {
              chart: {
                type: 'pieChart',
                color: ['#0080ff', '#FF8C00'],
                height: 400,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                },
                labelType: 'percent',
                x: function (d) {
                  return d.label;
                },
                y: function (d) {
                  return d.value;
                },
                tooltip: {
                  gravity: 's',
                  classes: 'gravity-s'
                }
              }
            },
            data: $scope.CurrentefficiencyJobs
          }
        };

      });
    }

    $scope.CalculatteWorkingHours = function (Tech, value) {
      value = parseInt(value)
      var Start_Date = new Date(new Date().getFullYear(), new Date().getMonth() + value, 1);
      var End_Date = new Date(new Date().getFullYear(), new Date().getMonth() + (value + 1), 0);
      Start_Date.setHours(0, 0, 0, 0)
      End_Date.setHours(23, 59, 59, 999)
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/getbyStatus",
        method: "POST",
        data: {
          Start_Date: Start_Date,
          End_Date: End_Date,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: $scope.SelectedCustomerID,
          Status: "Yet to Start",
          Team_Id: null
        },
      });
      response.then(function (GList) {
        var AllScheduleDatas = GList.data.data;
        $scope.SelectedMember = Tech
        $scope.thisNEmonth = value
        var TimeIdle = 0
        var Totaldays = 0
        //getTimeIdle () gets time excluding public holidays and weekends, saturdays calculation 8:30 am to 12:30 pm
        TimeIdle = getTimeIdle($scope.PHDetailsdatas, new Date(new Date().getFullYear(), new Date().getMonth() + value, 1), new Date(new Date().getFullYear(), new Date().getMonth() + (value + 1), 0))
        Totaldays = new Date(new Date().getFullYear(), new Date().getMonth() + (value + 1), 0).getDate()

        var TimeWorking = 0
        if (Tech == "Total Technicians") {
          angular.forEach(AllScheduleDatas, function (item) {
            item.Endsat = new Date(new Date(new moment(new Date(item.Endsat).toTimeString(), 'HH:mm:ss')).getTime())
            item.Startsat = new Date(new Date(new moment(new Date(item.Startsat).toTimeString(), 'HH:mm:ss')).getTime())
            var Time = moment(item.Endsat).diff(moment(item.Startsat), 'seconds')
            TimeWorking += Time
          })
          // Totaldays *= TimeIdle
          // TimeIdle -= TimeWorking
          $scope.LastefficiencyJobs = [{ label: 'Time Working', value: TimeWorking / 3600 }, { label: 'Time Idle', value: TimeIdle / 3600 }];
        }
        else {
          var item = []
          item = AllScheduleDatas.filter(function (item) {
            return item.teamdetails[0].TeamMembers.includes(Tech)
          })
          if (item.length > 0) {
            angular.forEach(item, function (item1) {
              item.Endsat = new Date(new Date(new moment(new Date(item.Endsat).toTimeString(), 'HH:mm:ss')).getTime())
              item.Startsat = new Date(new Date(new moment(new Date(item.Startsat).toTimeString(), 'HH:mm:ss')).getTime())
              var Time = moment(item1.Endsat).diff(moment(item1.Startsat), 'seconds')
              TimeWorking += Time
            })
          }
          else TimeWorking = 0

          var Totaldays = new Date().getDate()
          // Totaldays *= TimeIdle
          // TimeIdle -= TimeWorking
          $scope.LastefficiencyJobs = [{ label: 'Time Working', value: TimeWorking / 3600 }, { label: 'Time Idle', value: TimeIdle / 3600 }];
        }
        $scope.NMonthEfficiancy = [
          { name: "Next Month (" + new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 1 },
          { name: "Next 2 Month (" + new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 2 },
          { name: "Next 3 Month (" + new Date(new Date().getFullYear(), new Date().getMonth() + 3, 1).toLocaleString('en-us', { month: 'short' }) + ")", value: 3 },
        ]
        vm.widget2 = {
          mainChart: {
            options: {
              chart: {
                type: 'pieChart',
                color: ['#0080ff', '#FF8C00'],
                height: 400,
                margin: {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                },
                labelType: 'percent',
                x: function (d) {
                  return d.label;
                },
                y: function (d) {
                  return d.value;
                },
                tooltip: {
                  gravity: 's',
                  classes: 'gravity-s'
                }
              }
            },
            data: $scope.LastefficiencyJobs
          }
        };
      })
    }


    $scope.SelectedMember = "Total Technicians"
    $scope.thisEmonth = "This Month"
    $scope.getEfficiencyofEmployees("Total Technicians", $scope.thisEmonth)
    $scope.thisNEmonth = 1
    $scope.CalculatteWorkingHours("Total Technicians", $scope.thisNEmonth)

    $scope.CustomerRatingSelection = ["On Total", "By Technicians"]

    $scope.getCustomerStarRating = function (value) {
      $scope.CustomerRatingchartOptions = null
      $scope.CustomerRating = []
      if (value == "On Total") {
        $scope.SelectedCustomerRting = "On Total"
        try {
          $scope.CustomerRating = [
            { day: "Attitude", rating: _.round(_.meanBy($scope.CustomrRatingfor1Month, 'Attitude'), 2) },
            { day: "Appearance of Technician", rating: _.round(_.meanBy($scope.CustomrRatingfor1Month, 'TechnicianAppearance'), 2) },
            { day: "Service Quality", rating: _.round(_.meanBy($scope.CustomrRatingfor1Month, 'ServiceQuality'), 2) },
            { day: "Punctuality", rating: _.round(_.meanBy($scope.CustomrRatingfor1Month, 'Punctuality'), 2) }
          ]
        } catch (error) { }
      }
      else {
        var data = $scope.CustomrRatingfor1Month.filter(function (data) {
          return data.TeamMember.indexOf(value) > -1
        })
        try {
          $scope.SelectedCustomerRting = value
          $scope.CustomerRating = [
            { day: "Attitude", rating: _.round(_.meanBy(data, 'Attitude'), 2) },
            { day: "Appearance of Technician", rating: _.round(_.meanBy(data, 'TechnicianAppearance'), 2) },
            { day: "Service Quality", rating: _.round(_.meanBy(data, 'ServiceQuality'), 2) },
            { day: "Punctuality", rating: _.round(_.meanBy(data, 'Punctuality'), 2) }
          ]
        } catch (error) { }
      }
      $scope.CustomerRatingchartOptions1 = {
        dataSource: $scope.CustomerRating,
        series: {
          argumentField: "day",
          valueField: "rating",
          type: "bar",
          color: '#ffaa66',
        },
        legend: {
          visible: false
        },
        tooltip: {
          enabled: true
        },
        bindingOptions: {
          dataSource: "CustomerRating"
        }
      };
    }
    $scope.vm.StDate = new Date(new Date().setDate(new Date().getDate() - 30));
    $scope.vm.EnDate = new Date();
    getCustomer1StarRating()
    function getCustomer1StarRating() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/tabletschedulerrecord/getfordashbord",
        data: { Start_Date: $scope.vm.StDate, End_Date: $scope.vm.EnDate }
      })
      response.then(function (Glist) {
        TabletSchedulerforCustomrRating = Glist.data.data;
        $scope.CustomrRatingfor1Month = Glist.data.data;
        var Tech = _.uniq(_.map($scope.CustomrRatingfor1Month, 'TeamMember').join(',').split(','))
        Tech = Tech.filter(Boolean)
        $scope.CustomerTechnicMebers = ["On Total"].concat(Tech)
        $scope.getCustomerStarRating("On Total")
        var item = TabletSchedulerforCustomrRating.filter(function (item) {
          return (item.ServiceQuality == 1 || item.Attitude == 1 || item.TechnicianAppearance == 1 || item.Punctuality == 1)
        })
        $scope.LowRating = item
      })
    }
    $scope.getCustomer1StarRating = getCustomer1StarRating

    $scope.getRatingbytechnciain = function (value) {
      var item = $scope.CustomrRatingfor1Month.filter(function (item) {
        return (item.ServiceQuality == 1 || item.Attitude == 1 || item.TechnicianAppearance == 1 || item.Punctuality == 1)
      });
      $scope.LowRating = item
    }
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/team",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (teamdata) {
      $scope.teamdatas = teamdata.data.data;
      $scope.teamMemebers = _.uniq(_.map(_.map($scope.teamdatas, function (e) { return _.pick(e, "TeamMembers") }), function (o) { return o.TeamMembers }).join(',').split(','))
      $scope.TechnicMebers = ["Total Technicians"].concat($scope.teamMemebers)
      $scope.TechnicMebers = $scope.TechnicMebers.filter(Boolean)
    });
    $http({
      url: $rootScope.WebURL + "/calendar",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (GList) {
      $scope.PHDetailsdatas = GList.data.data;
    })

    function getTimeIdle(HolidayList, StartDate, EndDate) {
      try {
        var TimeIdle = 0
        for (var i = 0; i < new Date(EndDate).getDate(); i++) {
          var item = []
          var Start = new Date(moment(new Date(StartDate)).add(i, 'days'));
          item = HolidayList.filter(function (item) {
            return new Date(item.StartDate) >= Start.setHours(0, 0, 0, 0) && new Date(item.StartDate) <= Start.setHours(23, 59, 59, 999)
          })
          if (item.length == 0) {
            if (new Date(Start).getDay() == 6)
              TimeIdle += 14400
            else if (new Date(Start).getDay() == 0) TimeIdle += 0
            else TimeIdle += 32400
          }
        }
        return TimeIdle
      } catch (error) {

      }
    }

    $scope.ViewStarRating = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/dashboard/Popup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function DashboardOperationController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.StDate = new Date(new Date().setDate(new Date().getDate() - 30));
      $scope.vm.EnDate = new Date();
      getCustomer1StarRating()

      $scope.dataGridOptions = {
        dataSource: $scope.LowRating,
        columns: [{
          dataField: "Team",
          groupIndex: 0
        }, "TeamLead", "TeamMember",
        {
          dataField: "Startsat", caption: "Serviced Date", dataType: "date", format: 'dd/MM/yyyy'
        }, "CustomerName", "ServiceQuality", "Attitude", "TechnicianAppearance", "Punctuality", "CustomerRemarks", "CustomerFeedback"],
        showBorders: true,
        bindingOptions: {
          dataSource: "LowRating"
        }
      };
    }


    $scope.cancel = function () {
      $mdDialog.cancel()
    }

    function getDateonly(input) {
      if (input == null) { return ""; }
      var _date = $filter('date')(new Date(input), 'dd/MM/yyyy');
      return _date;
    };

    function getDateonlyForDashboard(input) {
      if (input == null) { return ""; }
      var _date = $filter('date')(new Date(input), 'dd-MMM-yyyy');
      return _date;
    };

  }
})();


(function () {
    'use strict';

    angular
        .module('app.operations.checklist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.checklist', {
            url: '/ServiceChecklist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/checklist/checklist.html',
                    controller: 'checklistController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/checklist');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.checklist')
        .controller('checklistController', checklistController);


    /** @ngInject */
    function checklistController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, $filter, moment, alert, calendarConfig) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("SChecklist")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }
        $scope.DivisionGrid = true;
        $scope.exportbtn = true;
        $scope.Divisionform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.Divisionform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.DivisionGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.Divisionform = false;
            $scope.DivisionGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.DivisionGrid = true;
            $scope.Divisionform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {
            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Divisionform = true;
            $scope.DivisionGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.error1 = false;
            $scope.Search = false;
        }

        $scope.Checklistinfo = function (ChecklistId) {
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = ChecklistId;
            $scope.Update = true;
            $scope.Divisionform = true;
            $scope.DivisionGrid = false;
            $scope.areainfoId = ChecklistId;
            var info = $scope.ServiceChecklist
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ChecklistId) {
                    $scope.Division = info[i].Division;
                    $scope.Description = info[i].Description;
                }
            }
        }

        $scope.fsubmit = function () {
            var item = $scope.Divisiondatas.filter(function (item) {
                return item.id === $scope.Division;
            })[0];
            $scope.DivisionName = item.DivisionName;

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/servicechecklist/update",
                    data: {
                        _id: $scope.SID,
                        Division: $scope.Division,
                        DivisionName: $scope.DivisionName,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $scope.Update = false;
                    $scope.Description = null;
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/servicechecklist/add",
                    data: {
                        Division: $scope.Division,
                        DivisionName: $scope.DivisionName,
                        Description: $scope.Description,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $scope.Update = false;
                    $scope.Description = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Delete = function (DeleteId) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/servicechecklist/delete",
                data: {
                    _id: DeleteId,
                },
            });

            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                RefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("ServiceChecklist.xlsx",{headers:true}) FROM ?', [$scope.ServiceChecklist]);
        };

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicechecklist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (serviceChecklist) {
            $scope.ServiceChecklist = serviceChecklist.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/servicechecklist",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (serviceChecklist) {
                $scope.ServiceChecklist = serviceChecklist.data.data;
            });
        }
        function ClearForm() {
            $scope.Division = '';
            $scope.Description = '';
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };
    }


})();








(function () {
    'use strict';

    angular
        .module('app.procurement.stock.vehicle', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.vehicle', {
            url: '/VehicleManagement',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/vehicle/vehicle.html',
                    controller: 'VehicleController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.stock.vehicle')
        .controller('VehicleController', VehicleController)
    // .directive('chooseFile', function () {
    //     return {
    //         restrict: 'E',
    //         link: function (scope, elem, attrs, transcludeFn) {
    //             debugger
    //             elem.append(transcludeFn());
    //             var button = angular.element(elem[0].querySelector('button#uploadButton'))
    //             var Clearbutton = angular.element(elem[0].querySelector('button#clearButton'))
    //             var input = angular.element(elem[0].querySelector('input#fileInput'));
    //             button.bind('click', function () {
    //                 input[0].click();
    //             });
    //             Clearbutton.bind('click', function () {
    //                 debugger
    //                 var input = angular.element(elem[0].querySelector('input#fileInput')).val('');
    //                 scope.fileName = '';
    //             });
    //             input.bind('change', function (e) {
    //                 scope.$apply(function () {
    //                     var files = e.target.files;
    //                     if (files[0]) {
    //                         scope.fileName = files[0].name;
    //                         scope.UploadButtonName = 'Change'
    //                         scope.UploadButton = true
    //                         scope.ClearButton = true
    //                         var reader = new FileReader();
    //                         reader.onload = function (e) {
    //                             $('#imagePreview').attr('src', e.target.result)
    //                                 .width(200)
    //                                 .height(70);
    //                         };
    //                         scope.FilePath = null;
    //                         reader.readAsDataURL(files[0]);
    //                     } else {
    //                         $('#imagePreview').attr('src', null);
    //                         scope.fileName = null;
    //                         scope.UploadButtonName = 'Upload Document'
    //                         scope.ClearButton = false
    //                     }
    //                 });
    //             });
    //         }
    //     };
    // });


    function VehicleController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, Upload, $mdDialog, $document, $http) {
        document.getElementsByTagName('title')[0].text = "Procurement-Vehicle Management"

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.createdName = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        RefreshGrid();
        $scope.Vehicleform = false;
        $scope.Vehiclegrid = true;
        $scope.vExport = true;
        $scope.vAdd = true;
        $scope.vSearch = true;
        $scope.vView = false;

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("VehicleDetails.xlsx",{headers:true}) FROM ?', [$scope.Vehicledatas]);
        };
        $scope.Uploadfiles = function (file) {

        }
        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
        }

        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Vehicleform = true;
            $scope.Vehiclegrid = false;
            $scope.vExport = false;
            $scope.vView = true;
            $scope.vAdd = false;
            $scope.vSearch = false;
            $scope.PurchaseDate = new Date();
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;
        }

        $scope.Showgrid = function () {
            $scope.Vehiclegrid = true;
            $scope.Vehicleform = false;
            $scope.vExport = true;
            $scope.vAdd = true;
            $scope.vView = false;
            $scope.vSearch = true;
            RefreshGrid();
        }

        $scope.AddVehicleLog = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/procurement/vehicle/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function VehicleController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            ClearVehicleLog()
        }

        $scope.vSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/vehicle/update",
                    data: {
                        _id: $scope.SID,
                        VehicleNumber: $scope.VehicleNumber,
                        EngineNumber: $scope.EngineNumber,
                        ChasisNumber: $scope.ChasisNumber,
                        Manufacturer: $scope.Manufacturer,
                        Model: $scope.Model,
                        YearManufactured: $scope.YearManufactured,
                        TypeofBody: $scope.TypeofBody,
                        Color: $scope.Color,
                        Remarks: $scope.Remarks,
                        UnladenWeight: $scope.UnladenWeight,
                        PurchaseDate: $scope.PurchaseDate,
                        AssignedDriver: $scope.AssignedDriver,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Vehicledatas[$scope.IndexID] = GList.data.data;
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/vehicle/add",
                    data: {
                        Client_Id: Client_Id,
                        VehicleNumber: $scope.VehicleNumber,
                        UniqueID: $scope.UniqueID,
                        EngineNumber: $scope.EngineNumber,
                        ChasisNumber: $scope.ChasisNumber,
                        Manufacturer: $scope.Manufacturer,
                        Model: $scope.Model,
                        YearManufactured: $scope.YearManufactured,
                        TypeofBody: $scope.TypeofBody,
                        Color: $scope.Color,
                        Remarks: $scope.Remarks,
                        UnladenWeight: $scope.UnladenWeight,
                        PurchaseDate: $scope.PurchaseDate,
                        AssignedDriver: $scope.AssignedDriver,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.SID = GList.data.data.id
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Vehicleinfo = function (VehicleId, $index) {
            $scope.SID = VehicleId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.Vehicleform = true;
            $scope.Vehiclegrid = false;
            $scope.vExport = false;
            $scope.vView = true;
            $scope.vAdd = false;
            $scope.vSearch = false;
            try {
                var item = $scope.Vehicledatas.filter(function (item) {
                    return item._id === VehicleId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID
                $scope.VehicleNumber = item.VehicleNumber;
                $scope.EngineNumber = item.EngineNumber;
                $scope.ChasisNumber = item.ChasisNumber;
                $scope.Manufacturer = item.Manufacturer;
                $scope.Model = item.Model;
                $scope.YearManufactured = item.YearManufactured;
                $scope.TypeofBody = item.TypeofBody;
                $scope.Color = item.Color;
                $scope.UnladenWeight = item.UnladenWeight;
                if (item.PurchaseDate != "" && item.PurchaseDate != null && item.PurchaseDate != undefined) {
                    $scope.PurchaseDate = new Date(item.PurchaseDate);
                }
                $scope.AssignedDriver = item.AssignedDriver;
                $scope.Remarks = item.Remarks;
                RefreshVehicledetail();
            } catch (err) { }
        }

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/vehicle",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Vehicledata) {
                $scope.Vehicledatas = Vehicledata.data.data;
            });
        }

        function ClearForm() {
            $scope.VehicleNumber = '';
            $scope.EngineNumber = '';
            $scope.ChasisNumber = '';
            $scope.Manufacturer = '';
            $scope.Model = '';
            $scope.YearManufactured = '';
            $scope.TypeofBody = '';
            $scope.Color = '';
            $scope.Remarks = '';
            $scope.UnladenWeight = '';
            $scope.PurchaseDate = '';
            $scope.AssignedDriver = '';
            $scope.vm.Vehicledetaildatas = []
        }

        $scope.popupClick = function (e, VehicledetailId) {
            $scope.VehicledetailId = VehicledetailId;
            $scope.ClearVehicledetail();
            $scope.Clear = false;
            $scope.VUpdate = false;
            $scope.AttachOff = false
            $mdDialog.show({
                controller: VehicleController,
                templateUrl: 'app/main/apps/procurement/vehicle/detailgrid.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        //   $scope.vm.Vehicledetaildatas=[]
        $scope.SubmitVehicleLog = function () {
            if ($scope.VUpdate == false) {
                var file = angular.element(document.querySelector('#fileInput'))[0].files[0] ? angular.element(document.querySelector('#fileInput'))[0].files : []
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/vehicledetail/add",
                    data: {
                        Type: $scope.Type,
                        UniqueID: $scope.UniqueID,
                        Description: $scope.Description,
                        TotalCost: $scope.TotalCost,
                        CompletedDate: $scope.CompletedDate,
                        Details: $scope.Details,
                        Status: $scope.Status,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var Id = GList.data.data.id
                    if (file.length != 0 && file.length != undefined) {
                        var upfile = file[0]
                        var response1 = Upload.upload({
                            url: $rootScope.WebURL + "/vehiclelog/upload",
                            data: { file: upfile }
                        }).then(function (resp) {
                            $scope.TableID = resp.data.data[0].GUIDFILENAME
                            $scope.fileName = resp.data.data[0].OriginalFileName
                            $scope.fileSize = resp.data.data[0].Size
                            $scope.Path = resp.data.data[0].Path
                            $scope.fileType = resp.data.data[0].Type
                            if (resp.data.message == "Successfully Uploaded") {
                                var response2 = $http({
                                    method: "POST",
                                    url: $rootScope.WebURL + "/attachment/add",
                                    data: {
                                        TableID: $scope.TableID,
                                        TableName: "VehicleLog",
                                        FileID: Id,
                                        FileName: $scope.fileName,
                                        FileSize: $scope.fileSize,
                                        FileType: $scope.fileType,
                                        ModuleID: $scope.Path,
                                        Data: null,
                                        IsActive: "true",
                                        CreatedBy: $rootScope.createdby,
                                    },
                                });
                                response2.then(function (GList) {
                                });
                            }
                        });
                    }
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshVehicledetail();
                    $mdDialog.cancel()
                    //   $scope.Clear = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                if ($scope.AttachOff == false) {
                    var file = angular.element(document.querySelector('#fileInput'))[0].files[0] ? angular.element(document.querySelector('#fileInput'))[0].files : []
                }
                else var file = []
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/vehicledetail/update",
                    data: {
                        _id: $scope.VSID,
                        Type: $scope.Type,
                        Description: $scope.Description,
                        TotalCost: $scope.TotalCost,
                        CompletedDate: $scope.CompletedDate,
                        Details: $scope.Details,
                        Status: $scope.Status,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (file.length != 0 && file.length != undefined) {
                        var upfile = file[0]
                        var response1 = Upload.upload({
                            url: $rootScope.WebURL + "/vehiclelog/upload",
                            data: { file: upfile }
                        }).then(function (resp) {
                            $scope.TableID = resp.data.data[0].GUIDFILENAME
                            $scope.fileName = resp.data.data[0].OriginalFileName
                            $scope.fileSize = resp.data.data[0].Size
                            $scope.Path = resp.data.data[0].Path
                            $scope.fileType = resp.data.data[0].Type
                            if (resp.data.message == "Successfully Uploaded") {
                                var response2 = $http({
                                    method: "POST",
                                    url: $rootScope.WebURL + "/attachment/add",
                                    data: {
                                        TableID: $scope.TableID,
                                        TableName: "VehicleLog",
                                        FileID: $scope.VSID,
                                        FileName: $scope.fileName,
                                        FileSize: $scope.fileSize,
                                        FileType: $scope.fileType,
                                        ModuleID: $scope.Path,
                                        Data: null,
                                        IsActive: "true",
                                        CreatedBy: $rootScope.createdby,
                                    },
                                });
                                response2.then(function (GList) {
                                });
                            }
                        });
                    }
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshVehicledetail();
                    $mdDialog.cancel()
                    $scope.Clear = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        // function SubmiteVehicleLog  () {
        //     // if ($scope.VUpdate == true) {
        //     //     var response = $http({
        //     //         method: "PUT",
        //     //         url:  $rootScope.WebURL + "/vehiclelog/update",
        //     //         data: {
        //     //             _id: $scope.SVID,
        //     //             VehicleId : $scope.SID,
        //     //             SelectDate: $scope.SelectDate,
        //     //             Millage: $scope.Millage,
        //     //             LRemarks: $scope.LRemarks,
        //     //             UpdatedBy: $rootScope.LoginID,
        //     //         },
        //     //     });
        //     //     response.then(function (GList) {
        //     //         $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
        //     //         RefreshVehicleLog();
        //     //         ClearVehicleLog();
        //     //         $scope.Clear = false;
        //     //     }, function () {
        //     //         $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //     //     });
        //     // }
        //     // else {
        // }

        $scope.VSubmitVehicleLog = function () {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/vehiclelog/add",
                data: {
                    Client_Id: Client_Id,
                    VehicleID: $scope.SID,
                    SelectDate: $scope.vm.SelectDate,
                    Millage: $scope.vm.Millage,
                    CallCost: $scope.vm.CallCost,
                    LRemarks: $scope.vm.LRemarks,
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                debugger
                RefreshVehicleLog($scope.SID);
                var Id = GList.data.data._id
                var file = angular.element(document.querySelector('#fileInput'))[0].files;
                if (file.length != 0 && file.length != undefined) {
                    var upfile = file[0]
                    var response1 = Upload.upload({
                        url: $rootScope.WebURL + "/vehiclelog/upload",
                        data: { file: upfile }
                    }).then(function (resp) {
                        $scope.TableID = resp.data.data[0].GUIDFILENAME
                        $scope.fileName = resp.data.data[0].OriginalFileName
                        $scope.fileSize = resp.data.data[0].Size
                        $scope.Path = resp.data.data[0].Path
                        $scope.fileType = resp.data.data[0].Type
                        if (resp.data.message == "Successfully Uploaded") {
                            var response2 = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/attachment/add",
                                data: {
                                    TableID: $scope.TableID,
                                    TableName: "VehicleLog",
                                    FileID: Id,
                                    FileName: $scope.fileName,
                                    FileSize: $scope.fileSize,
                                    FileType: $scope.fileType,
                                    ModuleID: $scope.Path,
                                    Data: null,
                                    IsActive: "true",
                                    CreatedBy: $rootScope.createdby,
                                },
                            });
                            response2.then(function (GList) {
                                ClearVehicleLog();
                                RefreshVehicleLog($scope.SID);
                            });
                        }
                    });
                }

                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                $scope.Clear = false;
                $mdDialog.cancel()
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });

        }
        $scope.VehicleLogdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/vehiclelog/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshVehicleLog($scope.SID);
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.VehicleDelete = function (id) {
            $scope.DelId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the Vehicle?", 'Confirm')
            result.done(function (item) {
                if (item == true) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/vehicle/delete",
                        data: {
                            _id: $scope.DelId,
                        },
                    });
                    response.then(function (GList) {
                        $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                        $scope.Showgrid();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });
        }

        function ClearVehicleLog() {
            $scope.vm.Remarks = '';
            $scope.vm.SelectDate = new Date();
            $scope.vm.Millage = '';
            $scope.vm.LRemarks = '';
            $scope.vm.CallCost = '';
            $scope.fileName = '';
        }

        function RefreshVehicleLog(VehicleID) {
            var response = $http({
                url: $rootScope.WebURL + "/vehiclelog/getByRequestID",
                method: "POST",
                data: { VehicleID: VehicleID },
            });
            response.then(function (VehicleLogdata) {
                $scope.VehicleLogdetails = VehicleLogdata.data.data;
                if ($scope.VehicleLogdetails.length > 0) {
                    $scope.VUpdate = false;
                    var response1 = $http({
                        url: $rootScope.WebURL + "/attachment/getByTableName",
                        method: "POST",
                        data: { TableName: 'VehicleLog' },
                    });
                    response1.then(function (attachmentdata) {
                        $scope.Attachmentdatas = attachmentdata.data.data;

                        angular.forEach($scope.VehicleLogdetails, function (item) {
                            var item1 = $scope.Attachmentdatas.filter(function (val) {
                                return val.FileID === item._id
                            })[0]
                            if (item1 != undefined) {
                                item.DocumentName = item1.FileName
                                item.TableID = item1.TableID
                            }
                            else {
                                item.DocumentName = ""
                                item.TableID = ""
                            }
                        })
                    });
                }
                else {
                    $scope.VehicleLogdetails = []
                }
            });

        }

        // $scope.vehicledetailSubmit = function () {
        //     if ($scope.VUpdate == true) {

        //     }
        //     else {
        //         var response = $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/vehicledetail/add",
        //             data: {
        //                 VehicleID: $scope.VehicledetailId,
        //                 Type: $scope.Type,
        //                 Description: $scope.Description,
        //                 TotalCost: $scope.TotalCost,
        //                 CompletedDate: $scope.CompletedDate,
        //                 Details: $scope.Details,
        //                 Status: $scope.Status,
        //                 CreatedBy: $rootScope.LoginID,
        //             },
        //         });
        //         response.then(function (GList) {
        //             var Id = GList.data.data.id
        //             var file = item.file
        //             if (file.length != 0 && file.length != undefined) {
        //                 var upfile = file[0]
        //                 var response1 = Upload.upload({
        //                     url:  $rootScope.WebURL + "/vehiclelog/upload",
        //                     data: { file: upfile }
        //                 }).then(function (resp) {
        //                     $scope.TableID = resp.data.data[0].GUIDFILENAME
        //                     $scope.fileName = resp.data.data[0].OriginalFileName
        //                     $scope.fileSize = resp.data.data[0].Size
        //                     $scope.Path = resp.data.data[0].Path
        //                     $scope.fileType = resp.data.data[0].Type
        //                     if (resp.data.message == "Successfully Uploaded") {
        //                         var response2 = $http({
        //                             method: "POST",
        //                             url:  $rootScope.WebURL + "/attachment/add",
        //                             data: {
        //                                 TableID: $scope.TableID,
        //                                 TableName: "VehicleLog",
        //                                 FileID: Id,
        //                                 FileName: $scope.fileName,
        //                                 FileSize: $scope.fileSize,
        //                                 FileType: $scope.fileType,
        //                                 ModuleID: $scope.Path,
        //                                 Data: null,
        //                                 IsActive: "true",
        //                                 CreatedBy: $rootScope.createdby,
        //                             },
        //                         });
        //                         response2.then(function (GList) {
        //                         });
        //                     }
        //                 });
        //             }
        //             $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //             RefreshVehicledetail();
        //             $scope.Clear = false;
        //         }, function () {
        //             $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //         });
        //     }
        // }

        $scope.Vehicledetailinfo = function (vDetailId, e) {
            $scope.VSID = vDetailId;
            $scope.Clear = true;
            $scope.VUpdate = true;
            $scope.AttachOff = true
            try {
                var item = $scope.vm.Vehicledetaildatas.filter(function (item) {
                    return item._id === vDetailId;
                })[0];
                $scope.id = item._id;
                $scope.Type = item.Type;
                $scope.Description = item.Description;
                $scope.TotalCost = parseInt(item.TotalCost);
                $scope.CompletedDate = item.CompletedDate;
                if ($scope.CompletedDate != null && $scope.CompletedDate != "") {
                    $scope.CompletedDate = new Date(item.CompletedDate);
                }
                $scope.Details = item.Details;
                $scope.Status = item.Status;
                var response = $http({
                    url: $rootScope.WebURL + "/attachment/getByFileID",
                    method: "POST",
                    data: { FileID: $scope.id },
                });
                response.then(function (attachmentdata) {
                    $scope.Attachmentdatas = attachmentdata.data.data;
                    if ($scope.Attachmentdatas.length == 0) {
                        $scope.AttachOff = false
                    }
                });
                $mdDialog.show({
                    controller: VehicleController,
                    templateUrl: 'app/main/apps/procurement/vehicle/detailgrid.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true
                });
            } catch (err) { }
        }

        function RefreshVehicledetail() {
            var response = $http({
                url: $rootScope.WebURL + "/vehicledetail/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Vehicledetaildata) {
                $scope.vm.Vehicledetaildatas = Vehicledetaildata.data.data;
            });
        }

        $scope.ClearVehicledetail = function () {
            $scope.Type = '';
            $scope.Description = '';
            $scope.TotalCost = '';
            $scope.CompletedDate = null;
            $scope.Details = '';
            $scope.Status = '';
        }


        $scope.TypeList = [
            { "name": "Regular Servicing" },
            { "name": "Repair" },
            { "name": "Top up Ad-Blue" },
            { "name": "Others" }];

        $scope.StatusList = [
            { "name": "Pending" },
            { "name": "Completed" }];

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }
})();





(function () {
    'use strict';

    angular
        .module('app.operations.areas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.areas', {
            url: '/areas',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/operations/areas-master/areas.html',
                    controller: 'areasProjectController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/areas-master');
    }

})();
(function () {

    'use strict';
    angular
        .module('app.operations.areas')
        .controller('areasProjectController', areasProjectController);


    /** @ngInject */
    function areasProjectController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, moment, alert, calendarConfig) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Areas")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }
        $scope.areasGrid = true;
        $scope.exportbtn = true;
        $scope.areasform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;
        $scope.Viewclk = function () {
            $scope.areasform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.areasGrid = true;
        }


        $scope.cancelbtnclk = function () {
            $scope.areasform = false;
            $scope.areasGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.areasGrid = true;
            $scope.areasform = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
        }


        $scope.addnameclk = function () {

            ClearForm();
            $scope.Update = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.areasform = true;
            $scope.areasGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.error1 = false;
            $scope.Search = false;
        }

        $scope.areainfo = function (areasId) {

            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = areasId;
            $scope.Update = true;
            $scope.areasform = true;
            $scope.areasGrid = false;
            $scope.areainfoId = areasId;
            // var Pesttypedata = $scope.pesttypedatas
            var info = $scope.areasdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == areasId) {

                    $scope.Areasname = info[i].AreasName;
                    $scope.Areascode = info[i].Areascode;

                }
            }
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/areas/update",
                    data: {
                        _id: $scope.SID,
                        AreasName: $scope.Areasname,
                        Areascode: $scope.Areascode,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.addbtn = true;
                    $scope.areasGrid = true;
                    $scope.areasform = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/areas/add",
                    data: {
                        AreasName: $scope.Areasname,
                        Areascode: $scope.Areascode,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing AreasName") {
                        $scope.error1 = true;
                        $scope.areasform = true;
                        $scope.areasGrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshGrid();
                        $scope.areasGrid = true;
                        $scope.areasform = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Areasdatas.xlsx",{headers:true}) FROM ?', [$scope.areasdatas]);
        };

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/areas",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (areasdata) {
            $scope.areasdatas = areasdata.data.data;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/areas",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (areasdata) {
                $scope.areasdatas = areasdata.data.data;
            });
        }
        function ClearForm() {

            $scope.Areasname = '';

            $scope.Areascode = '';
        }
        var vm = this;
        // Data


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
    }


})();







(function ()
{
    'use strict';

    angular
        .module('app.procurement.suppliers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.suppliers', {
            url: '/Suppliers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/suppliers/suppliers.html',
                    controller: 'suppliersProjectController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';

    angular
        .module('app.procurement.suppliers')
        .controller('suppliersProjectController', suppliersProjectController);

    function suppliersProjectController($mdDateLocale, $scope, $mdConstant, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, NgMap, Upload) {
        document.getElementsByTagName('title')[0].text = "Procurement-Suppliers"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Supliers")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.createdName = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        RefreshGrid();
        RefreshPaymentTermGrid();
        $scope.Supplierform = false;
        $scope.Suppliergrid = true;
        $scope.sExport = true;
        $scope.sAdd = true;
        $scope.sSearch = true;
        $scope.sView = false;

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
            $scope.vm.searchTerm4 = '';
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.sServiceStatus = "Company";
            $scope.sCountry = "Singapore";
            $scope.Update = false;
            $scope.Supplierform = true;
            $scope.Suppliergrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        }

        $scope.Showgrid = function () {
            $scope.Suppliergrid = true;
            $scope.Supplierform = false;
            $scope.sExport = true;
            $scope.sAdd = true;
            $scope.sView = false;
            $scope.sSearch = true;
        }

        $scope.Supplierinfo = function (SupplierID, $index) {
            $scope.SID = SupplierID;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.Supplierform = true;
            $scope.Suppliergrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = true;
            try {
                var item = $scope.Supplierdatas.filter(function (item) {
                    return item.id === SupplierID;
                })[0];
                $scope.id = item.id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.sName = item.Name;
                $scope.sServiceStatus = item.ServiceStatus;
                $scope.sStreet1 = item.Street1;
                $scope.sStreet2 = item.Street2;
                $scope.sCity = item.City;
                $scope.sState = item.State;
                $scope.sPostalCode = parseInt(item.PostalCode);
                $scope.sCountry = item.Country;
                $scope.sContactPerson = item.ContactPerson;
                $scope.sJobPosition = item.JobPosition;
                var phone = item.Phone
                if (phone != null && phone != undefined && phone != "")
                    $scope.sPhone = item.Phone.split(',')
                else
                    $scope.sPhone = []
                $scope.sMobile = parseInt(item.Mobile);
                $scope.sFax = parseInt(item.Fax);
                var Email = item.Email
                if (Email != "" && Email != undefined && Email != null)
                    $scope.sEmail = item.Email.split(',')
                else
                    $scope.sEmail = []

                $scope.sWebsite = item.Website;
                $scope.sSupplyList = item.SupplyList;
                $scope.sPaymentTerms = item.PaymentTerms;
            } catch (err) { }
            RefreshBillingGrid();
            RefreshSiteGrid();
            GetPurchasehistory($scope.id)
        }

        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/supplier/update",
                    data: {
                        _id: $scope.SID,
                        Name: $scope.sName,
                        ServiceStatus: $scope.sServiceStatus,
                        Street1: $scope.sStreet1,
                        Street2: $scope.sStreet2,
                        City: $scope.sCity,
                        State: $scope.sState,
                        PostalCode: $scope.sPostalCode,
                        Country: $scope.sCountry,
                        ContactPerson: $scope.sContactPerson,
                        JobPosition: $scope.sJobPosition,
                        Phone: $scope.sPhone,
                        Mobile: $scope.sMobile,
                        Fax: $scope.sFax,
                        Email: $scope.sEmail,
                        Website: $scope.sWebsite,
                        SupplyList: $scope.sSupplyList,
                        PaymentTerms: $scope.sPaymentTerms,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Supplierdatas[$scope.IndexID] = GList.data.data;
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/supplier/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        Name: $scope.sName,
                        ServiceStatus: $scope.sServiceStatus,
                        Street1: $scope.sStreet1,
                        Street2: $scope.sStreet2,
                        City: $scope.sCity,
                        State: $scope.sState,
                        PostalCode: $scope.sPostalCode,
                        Country: $scope.sCountry,
                        ContactPerson: $scope.sContactPerson,
                        JobPosition: $scope.sJobPosition,
                        Phone: $scope.sPhone,
                        Mobile: $scope.sMobile,
                        Fax: $scope.sFax,
                        Email: $scope.sEmail,
                        Website: $scope.sWebsite,
                        SupplyList: $scope.sSupplyList,
                        PaymentTerms: $scope.sPaymentTerms,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Uploadfiles = function (file, UserID) {
            debugger
            var file = file[0].file;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                file = reader.result;
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/supplieritems/upload",
                    data: { file: file, _id: UserID },
                }).then(function (GList) {
                    $scope.fileName = null;
                    RefreshBillingGrid();
                });
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };

        }
        //$scope.loadFile = function (files) {
        //    $scope.$apply(function () {
        //        $scope.selectedFile = files[0];
        //        $scope.handleFile();
        //    })
        //}

        //$scope.handleFile = function () {
        //    var file = $scope.selectedFile;
        //    if (file) {
        //        var reader = new FileReader();
        //        reader.onload = function (e) {
        //            var data = e.target.result;
        //            var workbook = XLSX.read(data, { type: 'binary' });
        //            var first_sheet_name = workbook.SheetNames[0];
        //            var dataObjects = XLSX.utils.sheet_to_json(workbook.Sheets[first_sheet_name]);
        //            //console.log(excelData);   
        //            if (dataObjects.length > 0) {
        //                $scope.save(dataObjects, first_sheet_name);
        //            } else {
        //                $scope.message = "Error : Something Wrong !";
        //                showDialog($scope.Event);
        //            }
        //        }
        //        reader.onerror = function (ex) {
        //        }
        //        reader.readAsBinaryString(file);
        //    }
        //}

        //$scope.save = function (dataObjects) {
        //    var info = dataObjects;
        //    for (var i = 0; i < info.length; i++) {
        //        if (info[i].Country == "England") {
        //            info[i].Country = "United Kingdom";
        //        }
        //        var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
        //        var pass = "";
        //        for (var x = 0; x < 8; x++) {
        //            var j = Math.floor(Math.random() * chars.length);
        //            pass += chars.charAt(j);
        //        }
        //        $scope.UniqueID = pass;
        //        var AR = "SU-";
        //        var slen = i + 1;
        //        var sinfo = $scope.Supplierdatas.length + slen;
        //        var y = pad(sinfo, 3);
        //        $scope.ReferenceNo = AR + y;
        //        var response = $http({
        //            method: "POST",
        //            url:  $rootScope.WebURL + "/supplier/addImport",
        //            data: {
        //                Client_Id: Client_Id,
        //                ReferenceNo: $scope.ReferenceNo,
        //                UniqueID: $scope.UniqueID,
        //                Name: info[i].Name,
        //                ServiceStatus: info[i].ServiceStatus,
        //                Street1: info[i].Street1,
        //                Street2: info[i].Street2,
        //                City: info[i].City,
        //                State: info[i].State,
        //                PostalCode: info[i].PostalCode,
        //                Country: info[i].Country,
        //                ContactPerson: info[i].ContactPerson,
        //                JobPosition: info[i].JobPosition,
        //                Phone: info[i].Phone,
        //                Mobile: info[i].Mobile,
        //                Fax: info[i].Fax,
        //                Email: info[i].Email,
        //                Website: info[i].Website,
        //                CreatedBy: info[i].CreatedBy,
        //            },
        //        });
        //    }
        //    response.then(function (GList) {
        //        RefreshGrid();
        //        $mdDialog.cancel();
        //        $scope.Showgrid();
        //        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //    }, function () {
        //        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //    });
        //}

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        function RefreshPaymentTermGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/paymentterm",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (PaymentTermdata) {
                $scope.PaymentTermdatas = PaymentTermdata.data.data;
            });
        }
        function RefreshAttachmentGrid(_id) {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: _id },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
                $scope.FilePath = null;
                try {
                    $scope.FilePath = $rootScope.UploadsURL + 'Procurement/SupplierItems/' + $scope.Attachmentdatas[0].TableID;
                    $scope.fileName = null;
                } catch (e) {
                    $scope.FilePath = null;
                }
            });
        }
        $scope.AD = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "A", End: "E", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.EH = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "E", End: "I", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.IL = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "I", End: "M", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.MP = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "M", End: "Q", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.QT = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "Q", End: "U", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.UX = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "U", End: "Y", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.YZ = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier/getByLetter",
                data: { Start: "Y", Client_Id: Client_Id },
            });
            response.then(function (GList) {
                $scope.Supplierdatas = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.All = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        $scope.SupplierDelete = function (id) {
            $scope.DelID = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete this Supplier?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/supplier/delete",
                        data: { _id: $scope.DelID },
                    });
                    response.then(function (Supplierdata) {
                        RefreshGrid();
                        $scope.Showgrid();
                    });
                }
            })

        }
        function ClearForm() {
            $scope.UniqueID = '';
            $scope.sName = '';
            $scope.sServiceStatus = '';
            $scope.sStreet1 = '';
            $scope.sStreet2 = '';
            $scope.sCity = '';
            $scope.sState = '';
            $scope.sPostalCode = '';
            $scope.sCountry = '';
            $scope.sContactPerson = '';
            $scope.sJobPosition = '';
            $scope.sPhone = [];
            $scope.sMobile = '';
            $scope.sFax = '';
            $scope.sEmail = []
            $scope.sWebsite = '';
            $scope.sSupplyList = '';
            $scope.sPaymentTerms = '';
            $scope.SupplierItemdatas = '';
            $scope.Suppliersiteaddressdatas = '';
        }

        $scope.Billingpopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.Item = null;
            $scope.vm.ItemCode = null;
            $scope.vm.Category = null;
            $scope.vm.Unit = null;
            $scope.vm.Price = 0;
            $scope.FilePath = null;
            $scope.vm.MinimumOrder = 0;
            $scope.vm.ThresholdLevel = 0;
            $scope.vm.Remarks = null;
            $scope.BUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/BillingAddress.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Billingadd = function () {
            if ($scope.BUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/supplieritems/update",
                    data: {
                        _id: $scope.BID,
                        UniqueID: $scope.UniqueID,
                        Item: $scope.vm.Item,
                        ItemCode: $scope.vm.ItemCode,
                        Category: $scope.vm.Category,
                        Unit: $scope.vm.Unit,
                        Price: $scope.vm.Price,
                        MinimumOrder: $scope.vm.MinimumOrder,
                        ThresholdLevel: $scope.vm.ThresholdLevel,
                        Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var UserID = $scope.BID
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $mdDialog.cancel();
                    var file = angular.element(document.querySelector('#fileInput'))[0].files;
                    if (file.length != 0 && file.length != undefined) {
                        var files = [];
                        files.push({ file: file[0] })
                        $scope.Uploadfiles(files, UserID)
                    }
                    else RefreshBillingGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/supplieritems/add",
                    data: {
                        UniqueID: $scope.UniqueID,
                        Item: $scope.vm.Item,
                        ItemCode: $scope.vm.ItemCode,
                        Category: $scope.vm.Category,
                        Unit: $scope.vm.Unit,
                        Price: $scope.vm.Price,
                        MinimumOrder: $scope.vm.MinimumOrder,
                        ThresholdLevel: $scope.vm.ThresholdLevel,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var UserID = GList.data.data.id
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $mdDialog.cancel();
                    var file = angular.element(document.querySelector('#fileInput'))[0].files;
                    if (file.length != 0 && file.length != undefined) {
                        var files = [];
                        files.push({ file: file[0] })
                        $scope.Uploadfiles(files, UserID)
                    }
                    else RefreshBillingGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Billingupdate = function (e, BillId) {
            $scope.BUpdate = true;
            $scope.BID = BillId;
            try {
                var item = $scope.SupplierItemdatas.filter(function (item) {
                    return item._id === BillId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.vm.Item = item.Item;
                $scope.vm.ItemCode = item.ItemCode;
                $scope.vm.Category = item.Category;
                $scope.vm.Unit = item.Unit;
                $scope.vm.Price = parseFloat(item.Price);
                $scope.vm.MinimumOrder = parseInt(item.MinimumOrder);
                $scope.vm.ThresholdLevel = parseInt(item.ThresholdLevel);
                $scope.vm.Remarks = item.Remarks;
                $scope.FilePath = $rootScope.UploadsURL + 'Procurement/SupplierItems/' + $scope.id + '.png';
                // RefreshAttachmentGrid(BillId)
            } catch (err) { }
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/BillingAddress.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Billingdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/BillingAddressdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Bdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplieritems/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshBillingGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshBillingGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/supplieritems/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Supplierbillingaddressdata) {
                $scope.SupplierItemdatas = Supplierbillingaddressdata.data.data;
            });
        }

        $scope.Sitepopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.sContactName = '';
            $scope.vm.sStreet1 = '';
            $scope.vm.sStreet2 = '';
            $scope.vm.sCity = '';
            $scope.vm.sState = '';
            $scope.vm.sPostalCode = '';
            $scope.vm.sCountry = "Singapore";
            $scope.vm.sPhone = '';
            $scope.vm.sMobile = '';
            $scope.vm.sEmail = '';
            $scope.vm.sNotes = '';
            $scope.SUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/SiteAddress.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Siteadd = function () {
            if ($scope.SUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/suppliersiteaddress/update",
                    data: {
                        _id: $scope.SiID,
                        UniqueID: $scope.UniqueID,
                        ContactName: $scope.vm.sContactName,
                        Street1: $scope.vm.sStreet1,
                        Street2: $scope.vm.sStreet2,
                        City: $scope.vm.sCity,
                        State: $scope.vm.sState,
                        PostalCode: $scope.vm.sPostalCode,
                        Country: $scope.vm.sCountry,
                        Phone: $scope.vm.sPhone,
                        Mobile: $scope.vm.sMobile,
                        Email: $scope.vm.sEmail,
                        Notes: $scope.vm.sNotes,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshSiteGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/suppliersiteaddress/add",
                    data: {
                        UniqueID: $scope.UniqueID,
                        ContactName: $scope.vm.sContactName,
                        Street1: $scope.vm.sStreet1,
                        Street2: $scope.vm.sStreet2,
                        City: $scope.vm.sCity,
                        State: $scope.vm.sState,
                        PostalCode: $scope.vm.sPostalCode,
                        Country: $scope.vm.sCountry,
                        Phone: $scope.vm.sPhone,
                        Mobile: $scope.vm.sMobile,
                        Email: $scope.vm.sEmail,
                        Notes: $scope.vm.sNotes,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshSiteGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Siteupdate = function (e, SiteId) {
            $scope.SUpdate = true;
            $scope.SiID = SiteId;
            try {
                var item = $scope.Suppliersiteaddressdatas.filter(function (item) {
                    return item._id === SiteId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.vm.sContactName = item.ContactName;
                $scope.vm.sStreet1 = item.Street1;
                $scope.vm.sStreet2 = item.Street2;
                $scope.vm.sCity = item.City;
                $scope.vm.sState = item.State;
                $scope.vm.sPostalCode = parseInt(item.PostalCode);
                $scope.vm.sCountry = item.Country;
                $scope.vm.sPhone = parseInt(item.Phone);
                $scope.vm.sMobile = parseInt(item.Mobile);
                $scope.vm.sEmail = item.Email;
                $scope.vm.sNotes = item.Notes;
            } catch (err) { }
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/SiteAddress.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Sitedelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/suppliers/SiteAddressdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function suppliersProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Sdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/suppliersiteaddress/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshSiteGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshSiteGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/suppliersiteaddress/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Suppliersiteaddressdata) {
                $scope.Suppliersiteaddressdatas = Suppliersiteaddressdata.data.data;
            });
        }

        var response = $http({
            url: $rootScope.WebURL + "/category",
            method: "POST",
            data: { Client_Id: Client_Id },
        });
        response.then(function (Categorydata) {
            $scope.Categorydatas = Categorydata.data.data;
        });



        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        function GetPurchasehistory(ID) {
            var response = $http({
                url: $rootScope.WebURL + "/deliverynote/getBySupplier",
                method: "POST",
                data: { Supplier: ID }
            });
            response.then(function (GList) {
                $scope.Deliverynotedatas = [];
                angular.forEach(GList.data.data, function (List) {
                    angular.forEach(List.DeliveryItemdetails, function (Lis) {
                        Lis.ReferenceNo = List.ReferenceNo
                        Lis.DODate = List.DODate
                        $scope.Deliverynotedatas.push(Lis)
                    })
                })
            });
        }
        $scope.Export = function () {
            var ExportData = [];
            angular.forEach($scope.Supplierdatas, function (value, key) {
                if ($scope.Supplierdatas.length > 0) {
                    //var PhoneNo = value.Phone;
                    //while (PhoneNo.charAt(0) === '+') {
                    //    PhoneNo = PhoneNo.substr(1);
                    //}
                    //var MobileNo = value.Mobile;
                    //while (MobileNo.charAt(0) === '+') {
                    //    MobileNo = MobileNo.substr(1);
                    //}
                    //
                    //var FaxNo = value.Fax;
                    //while (FaxNo.charAt(0) != '+') {
                    //    FaxNo = FaxNo.insert(0, "+");
                    //}
                    //
                    ExportData.push({
                        ID: value.id,
                        ReferenceNo: value.ReferenceNo,
                        SupplierName: value.Name,
                        ServiceStatus: value.ServiceStatus,
                        PaymentTerms: value.PaymentTerms,
                        ContactPerson: value.ContactPerson,
                        JobPosition: value.JobPosition,
                        Street1: value.Street1,
                        Street2: value.Street2,
                        City: value.City,
                        State: value.State,
                        Country: value.Country,
                        Phone: value.Phone,
                        Mobile: value.Mobile,
                        Fax: value.Fax,
                        Email: value.Email,
                        Website: value.Website,
                        SupplyList: value.SupplyList,
                    });
                }
            })
            alasql('SELECT * INTO XLSX("SupplierDetails.xlsx",{headers:true}) FROM ?', [ExportData]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };
        vm.dtOptions2 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            columnDefs: [
                {
                    // Target the image column
                    targets: 1,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                }],
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $http({
            url: $rootScope.WebURL + "/unit",
            method: "POST",
            data: { Client_Id: Client_Id },
        }).then(function (Unitdata) {
            $scope.Unitdatas = Unitdata.data.data;
        });

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
        var groupColumn = 1;

        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            // pagingType: 'full_numbers',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            language: { search: "" },
            order: [1, 'asc'],
            //   columnDefs: [
            //                   { type: 'date-uk', targets: 1}  // specifying date format
            //               ],
            drawCallback: function (settings) {
                var api = this.api();
                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;
                api.column(groupColumn, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr style="background-color:#dedede" class="group"><th colspan="6">' + group + '</th></tr>'
                        );
                        last = group;
                    }
                });
            }
        };
        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];

    }



})();
(function () {
    'use strict';

    angular
        .module('app.procurement.uniformrequisition', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.uniformrequisition', {
            url: '/EmailLogs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/uniformrequisition/uniformrequisition.html',
                    controller: 'UniformRequisitionController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.uniformrequisition')
        .controller('UniformRequisitionController', UniformRequisitionController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function UniformRequisitionController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log) {
        document.getElementsByTagName('title')[0].text = "Email Logs"
        //var chkAceses = localStorage.getItem('pages');
        //if (chkAceses.split(",").includes("UniformR")) {   // do nothing 
        //}
        //else { $location.path("NoAccess"); }
        var vm = this

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date1 = new Date();
        var date2 = new Date();
        $scope.uFrom = date1;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date2;
        $scope.uTo.setHours(23, 59, 59, 999);


        var dataGrid1 = ""
        vm.dataGridPending = {
            onInitialized: function (e) {
                dataGrid1 = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.SEmaillogdatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "CustomerName", caption: "Customer Name",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.CustomerName + "</p>").appendTo(container);
                    },
                },
                { dataField: "RefrenceNumber", caption: "Reference No" },
                { dataField: "Type", caption: "Type" },
                { dataField: "EmailSentTo", caption: "Email Sent To" },
                { dataField: "EmailSentDate", caption: "Email Sent Date", dataType: "datetime", format: 'dd/MM/yyyy hh:mm a', sortOrder: "desc" },
            ],
            bindingOptions: {
                dataSource: "SEmaillogdatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
        };

        var dataGrid2 = ""

        vm.dataGridCollected = {
            onInitialized: function (e) {
                dataGrid2 = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.FEmaillogdatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "CustomerName", caption: "Customer Name",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.CustomerName + "</p>").appendTo(container);
                    },
                },
                { dataField: "RefrenceNumber", caption: "Reference No" },
                { dataField: "Type", caption: "Type" },
                { dataField: "Status", caption: "Error Message" },
                { dataField: "EmailSentTo", caption: "Email Ids" },
                { dataField: "EmailSentDate", caption: "Email Failed Date", dataType: "datetime", format: 'dd/MM/yyyy hh:mm a', sortOrder: "desc" },
            ],
            bindingOptions: {
                dataSource: "FEmaillogdatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: true,
                headerFilter: true,
            },
        };
        $scope.SEmaillogdatas = []

        setTimeout(function () {
            SuccessEmailLogs()
        }, 300)

        function SuccessEmailLogs() {
            $scope.SEmaillogdatas = []
            $scope.workOrd = []
            $('#PendingContainer').dxDataGrid('instance').beginCustomLoading()
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/emaillogdetails/count",
                data: { EmailSent: "Yes" },
            }).then(function (customerlength) {

                var CustomerLength = Math.ceil(customerlength.data.data / 200)
                var Skip = 0
                var Limit = 200
                for (var i = 0; i < CustomerLength; i++) {
                    if (i == 0) Skip = 0; else Skip += 200
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/emaillogdetails/get",
                        data: { EmailSent: "Yes", Skip: Skip, Limit: Limit }
                    }).then(function (customerdata) {
                        $scope.SEmaillogdatas = $scope.SEmaillogdatas.concat(customerdata.data.data);
                        $scope.workOrd = $scope.SEmaillogdatas
                        $('#PendingContainer').dxDataGrid('instance').endCustomLoading()
                    })
                }
                if (CustomerLength == 0) $('#PendingContainer').dxDataGrid('instance').endCustomLoading()
            })
        }

        setTimeout(function () {
            FailedEmailLogs()
        }, 300)


        function FailedEmailLogs() {
            $scope.FEmaillogdatas = []
            $('#YTSContainer').dxDataGrid('instance').beginCustomLoading()
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/emaillogdetails/count",
                data: { EmailSent: "No" },
            }).then(function (customerlength) {

                var CustomerLength = Math.ceil(customerlength.data.data / 200)
                var Skip = 0
                var Limit = 200
                for (var i = 0; i < CustomerLength; i++) {
                    if (i == 0) Skip = 0; else Skip += 200
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/emaillogdetails/get",
                        data: { EmailSent: "No", Skip: Skip, Limit: Limit }
                    }).then(function (customerdata) {
                        $scope.FEmaillogdatas = $scope.FEmaillogdatas.concat(customerdata.data.data);
                        $('#YTSContainer').dxDataGrid('instance').endCustomLoading()
                    })
                }
                if (CustomerLength == 0) $('#YTSContainer').dxDataGrid('instance').endCustomLoading()
            })
        }

        $scope.SucessLog = SuccessEmailLogs
        $scope.FailedLog = FailedEmailLogs

        $scope.getRowColour = function (item) {
            if (item.EmaiSent == "No") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("EmailLogs.xlsx",{headers:true}) FROM ?', [$scope.Emaillogdatas]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.store', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.store', {
            url: '/Stores',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/store/store.html',
                    controller: 'StoreController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.store')
        .controller('StoreController', StoreController);


    /** @ngInject */
    function StoreController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $http, $log, NgMap) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Stores")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.createdName = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $scope.Storeform = false;
        $scope.Storegrid = true;
        $scope.sExport = true;
        $scope.sAdd = true;
        $scope.sSearch = true;
        $scope.sView = false;

        RefreshGrid();
        RefreshEmployeeGrid();

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Store.xlsx",{headers:true}) FROM ?', [$scope.Storedatas]);
        };

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();

            $scope.Country = "Singapore";
            $scope.Update = false;
            $scope.Storeform = true;
            $scope.Storegrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Storegrid = true;
            $scope.Storeform = false;
            $scope.sExport = true;
            $scope.sAdd = true;
            $scope.sView = false;
            $scope.sSearch = true;
        }

        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/store/update",
                    data: {
                        _id: $scope.SID,
                        StoreName: $scope.StoreName,
                        Incharge: $scope.Incharge,
                        Address1: $scope.Address1,
                        Address2: $scope.Address2,
                        City: $scope.City,
                        State: $scope.State,
                        PostalCode: $scope.PostalCode,
                        Country: $scope.Country,
                        Phone: $scope.Phone,
                        Email: $scope.Email,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Storedatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/store/add",
                    data: {
                        Client_Id: Client_Id,
                        StoreName: $scope.StoreName,
                        Incharge: $scope.Incharge,
                        Address1: $scope.Address1,
                        Address2: $scope.Address2,
                        City: $scope.City,
                        State: $scope.State,
                        PostalCode: $scope.PostalCode,
                        Country: $scope.Country,
                        Phone: $scope.Phone,
                        Email: $scope.Email,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Storeinfo = function (StoreId, $index) {
            $scope.IndxID = $index;
            $scope.SID = StoreId;
            $scope.Update = true;
            $scope.Storeform = true;
            $scope.Storegrid = false;
            $scope.sExport = false;
            $scope.sAdd = false;
            $scope.sSearch = false;
            $scope.sView = true;
            try {
                var StoreArray = $scope.Storedatas;
                var item = StoreArray.filter(function (item) {
                    return item._id === StoreId;
                })[0];
                $scope.id = item._id;
                $scope.StoreName = item.StoreName;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.Incharge = item.Incharge;
                $scope.Address1 = item.Address1;
                $scope.Address2 = item.Address2;
                $scope.City = item.City;
                $scope.State = item.State;
                $scope.PostalCode = parseInt(item.PostalCode);
                $scope.Country = item.Country;
                $scope.Phone = parseInt(item.Phone);
                $scope.Email = item.Email;
                $scope.Remarks = item.Remarks;
            } catch (err) { }
        }

        function RefreshGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function ClearForm() {
            $scope.StoreName = '';
            $scope.ReferenceNo = '';
            $scope.Incharge = '';
            $scope.Address1 = '';
            $scope.Address2 = '';
            $scope.City = '';
            $scope.State = '';
            $scope.PostalCode = '';
            $scope.Country = '';
            $scope.Phone = '';
            $scope.Email = '';
            $scope.Remarks = '';
        }

        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.Prosettings', {
            url: '/ProcurementSettings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/settings/settings.html',
                    controller: 'SettingsController as vm'
                }
            }
        });
    }

})();



(function () {
    'use strict';

    angular
        .module('app.procurement.settings')
        .controller('SettingsController', SettingsController);

    function SettingsController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        document.getElementsByTagName('title')[0].text = "Procurement-Settings"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("ProcurementSettings")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshCategory();
        RefreshUnit();
        RefreshPaymentTerm();
        RefreshTag();
        RefreshDefine();

        $scope.categoryExport = true;
        $scope.unitExport = false;
        $scope.paymenttermExport = false;
        $scope.tagExport = false;
        $scope.defineExport = false;
        $scope.Update = false;
        $scope.SearchDetails = "";
        $scope.model = {};
        $scope.Categories = function () {
            $scope.categoryExport = true;
            $scope.unitExport = false;
            $scope.paymenttermExport = false;
            $scope.tagExport = false;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearCategory();
            RefreshCategory();
        }
        $scope.cExport = function () {
            alasql('SELECT * INTO XLSX("Tags.xlsx",{headers:true}) FROM ?', [$scope.Categorydatas]);
        };

        $scope.Units = function () {
            $scope.categoryExport = false;
            $scope.unitExport = true;
            $scope.paymenttermExport = false;
            $scope.tagExport = false;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearUnit();
            RefreshUnit();
        }
        $scope.uExport = function () {
            alasql('SELECT * INTO XLSX("Defines.xlsx",{headers:true}) FROM ?', [$scope.Unitdatas]);
        };

        $scope.PaymentTerms = function () {
            $scope.categoryExport = false;
            $scope.unitExport = false;
            $scope.paymenttermExport = true;
            $scope.tagExport = false;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearPaymentTerm();
            RefreshPaymentTerm();
        }
        $scope.pExport = function () {
            alasql('SELECT * INTO XLSX("PaymentTerms.xlsx",{headers:true}) FROM ?', [$scope.PaymentTermdatas]);
        };

        $scope.Tags = function () {
            $scope.categoryExport = false;
            $scope.unitExport = false;
            $scope.paymenttermExport = false;
            $scope.tagExport = true;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearTag();
            RefreshTag();
        }
        $scope.tExport = function () {
            alasql('SELECT * INTO XLSX("Tags.xlsx",{headers:true}) FROM ?', [$scope.Tagdatas]);
        };

        $scope.Defines = function () {
            $scope.categoryExport = false;
            $scope.unitExport = false;
            $scope.paymenttermExport = false;
            $scope.tagExport = false;
            $scope.defineExport = true;
            $scope.SearchDetails = "";
            ClearTag();
            RefreshDefine();
        }
        $scope.dExport = function () {
            alasql('SELECT * INTO XLSX("Defines.xlsx",{headers:true}) FROM ?', [$scope.Definedatas]);
        };


        $scope.saveCategory = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/category/update",
                    data: {
                        _id: $scope.SID,
                        CategoryName: $scope.model.CategoryName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearCategory();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Categorydatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/category/add",
                    data: {
                        Client_Id: Client_Id,
                        CategoryName: $scope.model.CategoryName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearCategory();
                response.then(function (GList) {
                    RefreshCategory();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Categoryinfo = function (CategoryId, $index) {
            $scope.SID = CategoryId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.CategoryinfoId = CategoryId;
            try {
                var item = $scope.Categorydatas.filter(function (item) {
                    return item.id === CategoryId;
                })[0];
                $scope.id = item.id;
                $scope.model.CategoryName = item.CategoryName;
            } catch (err) { }
        }

        function RefreshCategory() {
            var response = $http({
                url: $rootScope.WebURL + "/category",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Categorydata) {
                $scope.Categorydatas = Categorydata.data.data;
            });
            $scope.Update = false;
        }

        function ClearCategory() {
            $scope.model.CategoryName = '';
            $scope.Categoryform.$setPristine();
            $scope.Categoryform.$setUntouched();
        }

        $scope.cancelCategory = function () {
            $scope.Update = false;
            ClearCategory();
        }

        $scope.saveUnit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/unit/update",
                    data: {
                        _id: $scope.SID,
                        UnitName: $scope.model.UnitName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearUnit();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Unitdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/unit/add",
                    data: {
                        Client_Id: Client_Id,
                        UnitName: $scope.model.UnitName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearUnit();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshUnit();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Unitinfo = function (UnitId, $index) {
            $scope.SID = UnitId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.UnitinfoId = UnitId;
            try {
                var item = $scope.Unitdatas.filter(function (item) {
                    return item.id === UnitId;
                })[0];
                $scope.id = item.id;
                $scope.model.UnitName = item.UnitName;
            } catch (err) { }
        }

        function RefreshUnit() {
            var response = $http({
                url: $rootScope.WebURL + "/unit",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Unitdata) {
                $scope.Unitdatas = Unitdata.data.data;
            });
            $scope.Update = false;
        }

        function ClearUnit() {
            $scope.model.UnitName = '';
            $scope.Unitform.$setPristine();
            $scope.Unitform.$setUntouched();
        }

        $scope.cancelUnit = function () {
            $scope.Update = false;
            ClearUnit();
        }

        $scope.savePaymentTerm = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentterm/update",
                    data: {
                        _id: $scope.SID,
                        PaymentTermName: $scope.model.PaymentTermName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearPaymentTerm();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.PaymentTermdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/paymentterm/add",
                    data: {
                        Client_Id: Client_Id,
                        PaymentTermName: $scope.model.PaymentTermName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearPaymentTerm();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshPaymentTerm();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.PaymentTerminfo = function (PaymentTermId, $index) {
            $scope.SID = PaymentTermId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.PaymentTerminfoId = PaymentTermId;
            try {
                var item = $scope.PaymentTermdatas.filter(function (item) {
                    return item.id === PaymentTermId;
                })[0];
                $scope.id = item.id;
                $scope.model.PaymentTermName = item.PaymentTermName;
            } catch (err) { }
        }

        function RefreshPaymentTerm() {
            var response = $http({
                url: $rootScope.WebURL + "/paymentterm",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (PaymentTermdata) {
                $scope.PaymentTermdatas = PaymentTermdata.data.data;
            });
            $scope.Update = false;
        }

        function ClearPaymentTerm() {
            $scope.model.PaymentTermName = '';
            $scope.PaymentTermform.$setPristine();
            $scope.PaymentTermform.$setUntouched();
        }

        $scope.cancelPaymentTerm = function () {
            $scope.Update = false;
            ClearPaymentTerm();
        }

        $scope.saveTag = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tag/update",
                    data: {
                        _id: $scope.SID,
                        TagName: $scope.model.TagName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearTag();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Tagdatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tag/add",
                    data: {
                        Client_Id: Client_Id,
                        TagName: $scope.model.TagName,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearTag();
                response.then(function (GList) {
                    RefreshTag();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Taginfo = function (TagId, $index) {
            $scope.SID = TagId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.TaginfoId = TagId;
            try {
                var item = $scope.Tagdatas.filter(function (item) {
                    return item.id === TagId;
                })[0];
                $scope.id = item.id;
                $scope.model.TagName = item.TagName;
            } catch (err) { }
        }

        function RefreshTag() {
            var response = $http({
                url: $rootScope.WebURL + "/tag",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Tagdata) {
                $scope.Tagdatas = Tagdata.data.data;
            });
            $scope.Update = false;
        }

        function ClearTag() {
            $scope.model.TagName = '';
            $scope.Tagform.$setPristine();
            $scope.Tagform.$setUntouched();
        }

        $scope.cancelTag = function () {
            $scope.Update = false;
            ClearTag();
        }

        $scope.saveDefine = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/define/update",
                    data: {
                        _id: $scope.SID,
                        Description: $scope.model.Description,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                ClearDefine();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Definedatas[$scope.IndexID] = GList.data.data;
                    $scope.Update = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/define/add",
                    data: {
                        Client_Id: Client_Id,
                        Description: $scope.model.Description,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                ClearDefine();
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshDefine();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Defineinfo = function (DefineId, $index) {
            $scope.SID = DefineId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.DefineinfoId = DefineId;
            try {
                var item = $scope.Definedatas.filter(function (item) {
                    return item.id === DefineId;
                })[0];
                $scope.id = item.id;
                $scope.model.Description = item.Description;
            } catch (err) { }
        }

        function RefreshDefine() {
            var response = $http({
                url: $rootScope.WebURL + "/define",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Definedata) {
                $scope.Definedatas = Definedata.data.data;
            });
            $scope.Update = false;
        }

        function ClearDefine() {
            $scope.model.Description = '';
            $scope.Defineform.$setPristine();
            $scope.Defineform.$setUntouched();
        }

        $scope.cancelDefine = function () {
            $scope.Update = false;
            ClearDefine();
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Datasearch');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.purchaseorder', ["xeditable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.purchaseorder', {
            url: '/PurchaseOrder',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/purchaseorder/purchaseorder.html',
                    controller: 'PurchaseOrderController as vm'
                }
            }
        })
        .state('app.viewpurchaseorder', {
            url: '/ViewPurchaseOrder',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/purchaseorder/viewpurchaseorder.html',
                    controller: 'PurchaseOrderController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.purchaseorder')
        .controller('PurchaseOrderController', PurchaseOrderController)
        .filter('twoDecimal', function (input, scope) {
            return function () {
                return input.toFixed(2);
            }
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function PurchaseOrderController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $state, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("PurchaseOrder")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);


        var POID = getParameterByName('ID');
        var ViewPOID = localStorage.getItem('IDforViewPO');
        if (POID != null) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: { Client_Id: Client_Id },
            });
            response.then(function (AllPurchaseorderdata) {
                $scope.AllPurchaseorderdatas = AllPurchaseorderdata.data.data;
                try {
                    var item = $scope.AllPurchaseorderdatas.filter(function (item) {
                        return item._id === POID;
                    })[0];
                    $scope.id = item._id;
                    $scope.UniqueID = item.UniqueID;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.RequisitionNo = item.PRID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.RequestedByName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                    $scope.RequestedBy = item.EmployeeID;
                    $scope.OrderDate = new Date(item.OrderDate);
                    $scope.DeliveryDate = new Date(item.DeliveryDate);
                    $scope.Remarks = item.Remarks;
                    $scope.Supplier = item.SupplierID;
                    $scope.SupplierName = item.Supplierdetails[0].Name;
                    $scope.SupplierAddress1 = item.Supplierdetails[0].Street1;
                    $scope.SupplierAddress2 = item.Supplierdetails[0].Street2;
                    $scope.SupplierCity = item.Supplierdetails[0].City;
                    $scope.SupplierState = item.Supplierdetails[0].State;
                    $scope.SupplierCountry = item.Supplierdetails[0].Country;
                    $scope.SupplierPostalCode = item.Supplierdetails[0].PostalCode;
                    $scope.SupplierPhone = item.Supplierdetails[0].Phone;
                    $scope.SupplierMobile = item.Supplierdetails[0].Mobile;
                    $scope.SupplierFax = item.Supplierdetails[0].Fax;
                    $scope.SupplierEmail = item.Supplierdetails[0].Email;
                    $scope.SupplierWebsite = item.Supplierdetails[0].Website;
                    $scope.Store = item.StoreID;
                    $scope.ClientStore = item.ClientStore;
                    $scope.StoreName = item.Storedetails[0].StoreName;
                    $scope.StoreAddress1 = item.Storedetails[0].Address1;
                    $scope.StoreAddress2 = item.Storedetails[0].Address2;
                    $scope.StoreCity = item.Storedetails[0].City;
                    $scope.StoreState = item.Storedetails[0].State;
                    $scope.StoreCountry = item.Storedetails[0].Country;
                    $scope.StorePostalCode = item.Storedetails[0].PostalCode;
                    $scope.StorePhone = item.Storedetails[0].Phone;
                    $scope.StoreEmail = item.Storedetails[0].Email;
                    $scope.Currency = item.Currency;
                    $scope.SubTotal = parseFloat(item.SubTotal);
                    $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                    $scope.GST = parseFloat(item.GST);
                    $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                    $scope.Total = parseFloat(item.Total);
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                $scope.Update = true;
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = '';
                $scope.NextLevelAction = '';
                $scope.NextApprovers = '';
                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();
                $scope.ViewPurchaseorderform = false;
                $scope.Purchaseorderform = true;
                $scope.ViewPurchaseorderform = false;
                $scope.Purchaseordergrid = false;
                $scope.poExport = false;
                $scope.poSearch = false;
                $scope.poView = true;
                $scope.Cancel = false;
                $scope.Goods = false;

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
                RefreshPurchaseorderproductGrid();
                RefreshGoodsGrid();
                if ($scope.Status != "PO Created" && $scope.Status != "PO Completed" && $scope.Status != "Rejected" && $scope.Status != "Cancelled") {
                    $scope.Goods = true;
                }
                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'Inventory Purchase Order') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.Actioned = value.Actioned;
                            $scope.ShowCancelButton = value.ShowCancelButton;
                            $scope.ShowRejectButton = value.ShowRejectButton;
                            $scope.ShowReviseButton = value.ShowReviseButton;
                            $scope.NextLevel = value.NextLevel;
                            $scope.Approvers = value.Approvers;
                            $scope.Mandatory = value.Mandatory;
                            $scope.EmailNotification = value.EmailNotification;
                            $scope.NotifyTo = value.NotifyTo;
                            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.EmailExceptions = value.EmailExceptions;
                            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                            $scope.AfterNextLevel = value.NextLevel;
                            $scope.NextLevelApprovers = value.Approvers;
                            $scope.NextLevelMandatory = value.Mandatory;
                            $scope.NextLevelEmailNotification = value.EmailNotification;
                            $scope.NextLevelNotifyTo = value.NotifyTo;
                            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                            $scope.NextLevelEmailExceptions = value.EmailExceptions;
                            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                        }
                    }
                });

                $scope.LoginedUser = localStorage.getItem('UserName');
                $scope.LoginID = localStorage.getItem('LoginID');

                if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                    var array = $scope.NextLevelApprovers.split(",");
                    for (var y = 0; y < array.length; y++) {
                        if ($scope.LoginID === array[y]) {
                            $scope.NextApprovers = array[y];
                        }
                    }
                }

                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'Inventory Purchase Order') {
                        if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                            $scope.NextLevelAction = wvalue.Action;
                            $scope.ShowWorkflowButton = true;
                            $scope.CloseButton = false;
                            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                        }
                        else if ($scope.LoginID != $scope.NextApprovers) {
                            $scope.CloseButton = false;
                            $scope.ShowWorkflowButton = false;
                            $scope.NextLevelShowRejectButton = false;
                            $scope.NextLevelShowCancelButton = false;
                            $scope.NextLevelShowReviseButton = false;
                        }
                    }
                });

                if ($scope.StatusID == "0") {
                    $scope.CloseButton = false;
                    $scope.ShowWorkflowButton = false;
                    $scope.NextLevelShowRejectButton = false;
                    $scope.NextLevelShowCancelButton = false;
                    $scope.NextLevelShowReviseButton = false;
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }
            });
        }
        if (ViewPOID != null && ViewPOID != "" && ViewPOID != undefined && ViewPOID != "null") {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: { Client_Id: Client_Id },
            });
            response.then(function (AllPurchaseorderdata) {
                $scope.AllPurchaseorderdatas = AllPurchaseorderdata.data.data;
                try {
                    var item = $scope.AllPurchaseorderdatas.filter(function (item) {
                        return item._id === ViewPOID;
                    })[0];
                    $scope.id = item._id;
                    $scope.UniqueID = item.UniqueID;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.RequisitionNo = item.PRID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.RequestedByName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                    $scope.RequestedBy = item.EmployeeID;
                    $scope.OrderDate = new Date(item.OrderDate);
                    $scope.DeliveryDate = new Date(item.DeliveryDate);
                    $scope.Remarks = item.Remarks;
                    $scope.Supplier = item.SupplierID;
                    $scope.SupplierName = item.Supplierdetails[0].Name;
                    $scope.SupplierAddress1 = item.Supplierdetails[0].Street1;
                    $scope.SupplierAddress2 = item.Supplierdetails[0].Street2;
                    $scope.SupplierCity = item.Supplierdetails[0].City;
                    $scope.SupplierState = item.Supplierdetails[0].State;
                    $scope.SupplierCountry = item.Supplierdetails[0].Country;
                    $scope.SupplierPostalCode = item.Supplierdetails[0].PostalCode;
                    $scope.SupplierPhone = item.Supplierdetails[0].Phone;
                    $scope.SupplierMobile = item.Supplierdetails[0].Mobile;
                    $scope.SupplierFax = item.Supplierdetails[0].Fax;
                    $scope.SupplierEmail = item.Supplierdetails[0].Email;
                    $scope.SupplierWebsite = item.Supplierdetails[0].Website;
                    $scope.Store = item.StoreID;
                    $scope.ClientStore = item.ClientStore;
                    $scope.StoreName = item.Storedetails[0].StoreName;
                    $scope.StoreAddress1 = item.Storedetails[0].Address1;
                    $scope.StoreAddress2 = item.Storedetails[0].Address2;
                    $scope.StoreCity = item.Storedetails[0].City;
                    $scope.StoreState = item.Storedetails[0].State;
                    $scope.StoreCountry = item.Storedetails[0].Country;
                    $scope.StorePostalCode = item.Storedetails[0].PostalCode;
                    $scope.StorePhone = item.Storedetails[0].Phone;
                    $scope.StoreEmail = item.Storedetails[0].Email;
                    $scope.Currency = item.Currency;
                    $scope.SubTotal = parseFloat(item.SubTotal);
                    $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                    $scope.GST = parseFloat(item.GST);
                    $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                    $scope.Total = parseFloat(item.Total);
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                RefreshLogdetails();
                RefreshPurchaseorderproductGrid();
                RefreshGoodsGrid();

                angular.forEach($scope.Workflowdatas, function (value) {
                    if (value.TypeName == 'Inventory Purchase Order') {
                        if ($scope.StatusID == value.LevelName) {
                            $scope.TypeName = value.TypeName;
                            $scope.LevelName = value.LevelName;
                            $scope.Action = value.Action;
                            $scope.vm.Actioned = value.Actioned;
                            $scope.NextLevel = value.NextLevel;
                        }
                        if ($scope.NextLevel == value.LevelName) {
                            $scope.NextLevelTypeName = value.TypeName;
                            $scope.NextLevelLevelName = value.LevelName;
                            $scope.vm.NextLevelAction = value.Action;
                            $scope.NextLevelActioned = value.Actioned;
                            $scope.AfterNextLevel = value.NextLevel;
                        }
                    }
                });
                angular.forEach($scope.Workflowdatas, function (wvalue) {
                    if (wvalue.TypeName == 'Inventory Purchase Order') {
                        if ($scope.NextLevelAction == wvalue.Action) {
                            $scope.NextLevelAction = wvalue.Action;
                        }
                    }
                });
                if ($scope.StatusID == "0" || $scope.Actioned == "PO Completed") {
                    $scope.Actioned = $scope.Status;
                    $scope.NextLevelAction = '';
                }

                $scope.ViewPurchaseorderform = true;
                $scope.Purchaseorderform = false;
                $scope.Purchaseordergrid = false;
                $scope.poExport = false;
                $scope.poSearch = false;
                $scope.poView = true;
            });
            $window.localStorage.setItem('IDforViewPO', "");
        }
        else {
            $scope.Purchaseorderform = false;
            $scope.ViewPurchaseorderform = false;
            $scope.Purchaseordergrid = true;
            $scope.poExport = true;
            $scope.poSearch = true;
            $scope.poView = false;
            $scope.Cancel = false;
            $scope.Supplierdet = false;
            $scope.Storedet = false;
            $window.localStorage.setItem('ID', "");
            $window.localStorage.setItem('IDforViewPO', "");
        }


        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });
        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
                try {
                    var citem = $scope.Clientdatas.filter(function (citem) {
                        return citem.id === Client_Id;
                    })[0];
                    $scope.ClientTransactionCurrencies = citem.TransactionCurrencies;
                    if ($scope.ClientTransactionCurrencies != null && $scope.ClientTransactionCurrencies != "" && $scope.ClientTransactionCurrencies != undefined) {
                        var carray = $scope.ClientTransactionCurrencies.split(",");
                        var carray1 = [];
                        angular.forEach(carray, function (value) {
                            carray1.push({ TransactionCurrencies: value });
                        });
                        $scope.CurrencyCodeList = carray1;
                    }
                } catch (err) { }
            });

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        DefaultDatefilter();
        RefreshWorkflowGrid();
        RefreshEmployeeGrid();
        RefreshGoodsuniqueGrid();

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        function DefaultDatefilter() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorder/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Purchaseorderdatas = GList.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshGoodsuniqueGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorder/datefilter",
                method: "POST",
                data: { Client_Id: Client_Id, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Purchaseorderdatas = GList.data.data;
            });
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.Showgrid = function () {
            $scope.Purchaseordergrid = true;
            $scope.Purchaseorderform = false;
            $scope.ViewPurchaseorderform = false;
            $scope.poExport = true;
            $scope.poView = false;
            $scope.poSearch = true;
            $scope.Cancel = false;
        }

        $scope.Purchaseorderinfo = function (PORequestId, $index) {
            $scope.SID = PORequestId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.CloseButton = false;
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
            $scope.NextApprovers = '';

            $scope.TypeName = "";
            $scope.LevelName = "";
            $scope.Action = "";
            $scope.Actioned = "";
            $scope.ShowCancelButton = "";
            $scope.ShowRejectButton = "";
            $scope.ShowReviseButton = "";
            $scope.NextLevel = "";
            $scope.Approvers = "";
            $scope.Mandatory = "";
            $scope.EmailNotification = "";
            $scope.NotifyTo = "";
            $scope.NotifytoCurrentApprover = "";
            $scope.NotifytoNextLevelApprover = "";
            $scope.NotifytoCreatorInitator = "";
            $scope.EmailExceptions = "";
            $scope.AlwaysNotifyTo = "";

            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

            $scope.Purchaseorderform = true;
            $scope.ViewPurchaseorderform = false;
            $scope.Purchaseordergrid = false;
            $scope.poExport = false;
            $scope.poSearch = false;
            $scope.poView = true;
            $scope.Cancel = false;
            $scope.Goods = false;

            try {
                var item = $scope.Purchaseorderdatas.filter(function (item) {
                    return item._id === PORequestId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.RequisitionNo = item.PRID;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.RequestedBy = item.EmployeeID;
                $scope.RequestedByName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                $scope.OrderDate = new Date(item.OrderDate);
                $scope.DeliveryDate = new Date(item.DeliveryDate);
                $scope.Remarks = item.Remarks;
                $scope.Supplier = item.SupplierID;
                $scope.SupplierName = item.Supplierdetails[0].Name;
                $scope.SupplierAddress1 = item.Supplierdetails[0].Street1;
                $scope.SupplierAddress2 = item.Supplierdetails[0].Street2;
                $scope.SupplierCity = item.Supplierdetails[0].City;
                $scope.SupplierState = item.Supplierdetails[0].State;
                $scope.SupplierCountry = item.Supplierdetails[0].Country;
                $scope.SupplierPostalCode = item.Supplierdetails[0].PostalCode;
                $scope.SupplierPhone = item.Supplierdetails[0].Phone;
                $scope.SupplierMobile = item.Supplierdetails[0].Mobile;
                $scope.SupplierFax = item.Supplierdetails[0].Fax;
                $scope.SupplierEmail = item.Supplierdetails[0].Email;
                $scope.SupplierWebsite = item.Supplierdetails[0].Website;
                $scope.Store = item.StoreID;
                $scope.ClientStore = item.ClientStore;
                $scope.StoreName = item.Storedetails[0].StoreName;
                $scope.StoreAddress1 = item.Storedetails[0].Address1;
                $scope.StoreAddress2 = item.Storedetails[0].Address2;
                $scope.StoreCity = item.Storedetails[0].City;
                $scope.StoreState = item.Storedetails[0].State;
                $scope.StoreCountry = item.Storedetails[0].Country;
                $scope.StorePostalCode = item.Storedetails[0].PostalCode;
                $scope.StorePhone = item.Storedetails[0].Phone;
                $scope.StoreEmail = item.Storedetails[0].Email;
                $scope.Currency = item.Currency;
                $scope.SubTotal = parseFloat(item.SubTotal);
                $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                $scope.GST = parseFloat(item.GST);
                $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                $scope.Total = parseFloat(item.Total);
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            RefreshAttachmentGrid();
            RefreshCommentGrid();
            RefreshLogdetails();
            RefreshPurchaseorderproductGrid();
            RefreshGoodsGrid();

            if ($scope.Status != "PO Created" && $scope.Status != "PO Completed" && $scope.Status != "Rejected" && $scope.Status != "Cancelled") {
                $scope.Goods = true;
            }

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Inventory Purchase Order') {
                    if ($scope.StatusID == value.LevelName) {
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });

            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                var array = $scope.NextLevelApprovers.split(",");
                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID === array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Inventory Purchase Order') {
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.CloseButton = false;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.CloseButton = false;
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0" || $scope.Status == "PO Completed") {
                $scope.CloseButton = false;
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Inventory Purchase Order",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/purchaseorder/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Purchase Order",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.workflow = function () {
            try {
                if ($scope.NextLevelAction == "Complete PO" && $scope.Goodsdatas.length == 0) {
                    $scope.alertClose();
                    return
                }
            } catch (e) { }

            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseorder/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.SupplierName = $scope.Userdata.Supplierdetails[0].Name;
                        $scope.StoreName = $scope.Userdata.Storedetails[0].StoreName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Order' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Order' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseorder/email",
                            data: {
                                POID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                Supplier: $scope.SupplierName,
                                Store: $scope.StoreName,
                                PRID: $scope.Userdata.PRID,
                                OrderDate: convertDate($scope.Userdata.OrderDate),
                                DeliveryDate: convertDate($scope.Userdata.DeliveryDate),
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Order",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Purchaseorderdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshLogdetails();
                    $scope.Showgrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.alertClose = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaseorder/goodsclose.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseOrderController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.CompletePOworkflow = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseorder/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.SupplierName = $scope.Userdata.Supplierdetails[0].Name;
                        $scope.StoreName = $scope.Userdata.Storedetails[0].StoreName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Order' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Order' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseorder/email",
                            data: {
                                POID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                Supplier: $scope.SupplierName,
                                Store: $scope.StoreName,
                                PRID: $scope.Userdata.PRID,
                                OrderDate: convertDate($scope.Userdata.OrderDate),
                                DeliveryDate: convertDate($scope.Userdata.DeliveryDate),
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Order",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Purchaseorderdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshLogdetails();
                    $scope.Showgrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.rejectReason = function (e) {
            $scope.vm.Comments = "";
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaseorder/RejectReason.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseOrderController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.reject = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseorder/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Rejected",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.SupplierName = $scope.Userdata.Supplierdetails[0].Name;
                        $scope.StoreName = $scope.Userdata.Storedetails[0].StoreName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Order' && Workflowitem.LevelName === $scope.NextLevelLevelName;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseorder/email",
                            data: {
                                POID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                Supplier: $scope.SupplierName,
                                Store: $scope.StoreName,
                                PRID: $scope.Userdata.PRID,
                                OrderDate: convertDate($scope.Userdata.OrderDate),
                                DeliveryDate: convertDate($scope.Userdata.DeliveryDate),
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/comment/add",
                        data: {
                            TableRowID: $scope.UniqueID,
                            TableName: "Inventory Purchase Order",
                            CommentedBy: $rootScope.LoginID,
                            cmt: $scope.vm.Comments,
                            ModuleID: $scope.vm.ModuleID,
                            CreatedBy: $rootScope.LoginID,
                            IsActive: "true",
                        },
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Order",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));
                    $scope.Purchaseorderdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshLogdetails();
                    $scope.Showgrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Goodspopup = function (e) {
            $scope.goodspopdata();
            var AR = "GRN-";
            var z = 1;
            var info = $scope.Goodsdatas;
            if (info.length == 0) {
                var y = z;
            }
            else if (info.length != 0) {
                var Len = info.length - 1;
                $scope.LastGRN = $scope.Goodsdatas[Len].GRN;
                var str = $scope.LastGRN;
                var zz = str.replace('GRN-', '');
                var y = parseInt(zz) + parseInt(z);
            }
            var yy = pad(y, 6);
            $scope.vm.gGRN = AR + yy;
            $scope.UniqID = $scope.UniqueID;
            $scope.RefNo = $scope.ReferenceNo;
            $scope.vm.gPOrderID = $scope.RequisitionNo;
            $scope.vm.gDONumber = "";
            $scope.vm.gReceivedDate = new Date();
            $scope.GUpdate = false;
            $scope.ShowAlert = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaseorder/goods.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseOrderController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.goodspopdata = function () {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorderproduct/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Purchaseorderproductdata) {
                $scope.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
                RefreshGUGrid();
            });
        }

        $scope.saveGoods = function (data1, id, ProductCategory, ProductCodeID, ProductName, Description, Quantity, Unit, Model) {

            $scope.ShowAlert = false;
            $scope.UID = id;
            var store = $scope.StoreName;
            try {
                var item = $scope.Purchaseorderproductdatas.filter(function (item) {
                    return item._id === $scope.UID;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.ProductCategory = item.ProductCategory;
                $scope.ProductCode = item.ProductCodeID;
                $scope.ProductName = item.ProductName;
                $scope.Description = item.Description;
                $scope.Quantity = parseFloat(item.Quantity);
                $scope.Unit = item.Unit;
                $scope.UnitPrice = item.UnitPrice;
                $scope.Model = item.Model;
                $scope.TotalCost = item.TotalCost;
                $scope.ReceivedQuantity = parseFloat(item.ReceivedQuantity);

                if (data1.ReturnQuantity == "" || data1.ReturnQuantity == null || data1.ReturnQuantity == undefined) {
                    data1.ReturnQuantity = 0;
                }
                $scope.q = parseFloat($scope.ReceivedQuantity) + (parseFloat(data1.ReceiveQuantity) - parseFloat(data1.ReturnQuantity));
                $scope.rq = parseFloat(data1.ReturnQuantity);
                $scope.srq = parseFloat(data1.ReceiveQuantity) - parseFloat(data1.ReturnQuantity);

            } catch (err) { }

            if ($scope.Quantity <= $scope.ReceivedQuantity || $scope.Quantity < $scope.q) {
                RefreshGoodsGrid();
                data1.ReceiveQuantity = '';
                data1.ReturnQuantity = '';
                data1.SerialNumber = '';
                $mdToast.show($mdToast.simple().textContent('Received quantity should not be grater than Ordered quantity!!').position('top center'));
                return
            }
            if (parseFloat(data1.ReceiveQuantity) < parseFloat(data1.ReturnQuantity)) {
                RefreshGoodsGrid();
                data1.ReceiveQuantity = '';
                data1.ReturnQuantity = '';
                data1.SerialNumber = '';
                $mdToast.show($mdToast.simple().textContent('Returned quantity should not be grater than Received quantity!').position('top center'));
                return
            }

            if (data1.SerialNumber == "" || data1.SerialNumber == null) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/goods/add",
                    data: {
                        Client_Id: Client_Id,
                        ReferenceNo: $scope.RefNo,
                        UniqueID: $scope.UniqID,
                        DONumber: $scope.vm.gDONumber,
                        GRN: $scope.vm.gGRN,
                        ReceivedDate: $scope.vm.gReceivedDate,
                        StoreName: $scope.StoreName,
                        ProductCategory: ProductCategory,
                        ProductCode: ProductCodeID,
                        ProductName: ProductName,
                        Description: Description,
                        OrderedQuantity: Quantity,
                        Unit: Unit,
                        Model: Model,
                        SerialNumber: data1.SerialNumber,
                        ReceivedQuantity: $scope.srq,
                        ReturnedQuantity: $scope.rq,
                        Status: "",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.GUUSerialNumber = GList.data.data.SerialNumber;

                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/purchaseorderproduct/updateQuantity",
                        data: {
                            _id: $scope.UID,
                            ReceivedQuantity: $scope.q,
                        },
                    });
                    data1.ReceiveQuantity = '';
                    data1.ReturnQuantity = '';
                    data1.SerialNumber = '';
                    $mdToast.show($mdToast.simple().textContent('Goods Received Successfully!').position('top center'));
                    RefreshGoodsGrid();
                    $scope.Uniquegoodsdata();
                    if ($scope.ProductCategory.toLowerCase() == "sensor" || $scope.ProductCategory.toLowerCase() == "sensors" || $scope.ProductCategory.toLowerCase() == "router" || $scope.ProductCategory.toLowerCase() == "routers" || $scope.ProductCategory.toLowerCase() == "ratsense" || $scope.ProductCategory.toLowerCase() == "gateway" || $scope.ProductCategory.toLowerCase() == "gateways" || $scope.ProductCategory.toLowerCase() == "external sensor" || $scope.ProductCategory.toLowerCase() == "external sensors") {
                        $scope.Lighttrapdata = $scope.srq;
                        $scope.saveLighttrapdatas();
                    }
                    RefreshGUGrid();
                }, function () {
                    RefreshGoodsGrid();
                    data1.ReceiveQuantity = '';
                    data1.ReturnQuantity = '';
                    data1.SerialNumber = '';
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else if (data1.SerialNumber != "" && data1.SerialNumber != null) {
                $scope.TSerialNo = data1.SerialNumber;
                if ($scope.TSerialNo != null && $scope.TSerialNo != "" && $scope.TSerialNo != undefined) {
                    var snarray = $scope.TSerialNo.split(",");
                    var snarray1 = [];
                    angular.forEach(snarray, function (value) {
                        snarray1.push({ SerialNo: value });
                    });
                    $scope.SerialNoArray = snarray1;
                }
                $scope.CheckSNo = $scope.SerialNoArray.length;
                $scope.srq = parseFloat(data1.ReceiveQuantity) - parseFloat(data1.ReturnQuantity);
                if ($scope.srq > $scope.CheckSNo) {
                    $mdToast.show($mdToast.simple().textContent('Enter Serial Number for all the receiving quantities!!').position('top center'));
                    return
                }
                if ($scope.srq < $scope.CheckSNo) {
                    $mdToast.show($mdToast.simple().textContent('Entered Serial Number for all the receiving quantities is High!!').position('top center'));
                    return
                }
                //var array = data1.SerialNumber.split(",").map(item => item.trim());
                var array = data1.SerialNumber.split(",").map(function (item) {
                    return item.trim();
                });

                var response = $http({
                    url: $rootScope.WebURL + "/goods/getBySerialNumber",
                    method: "POST",
                    data: { SerialNumber: array, ProductCode: ProductCodeID },
                });
                response.then(function (ExistingSerialNodata) {
                    $scope.ExistingSerialNodataList = ExistingSerialNodata.data.data;
                    if ($scope.ExistingSerialNodataList.length > 0) {
                        $scope.ExistingSerialNoList = $scope.ExistingSerialNodataList.map(function (obj) { return obj.SerialNumber; }).join(',');
                        $scope.ShowAlert = true;
                        $mdToast.show($mdToast.simple().textContent('Existing Serial Number(s)!!').position('top center'));
                        return
                    }
                    else {
                        var SerialNoinfo = $scope.SerialNoArray;
                        for (var i = 0; i < SerialNoinfo.length; i++) {
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/goods/add",
                                data: {
                                    Client_Id: Client_Id,
                                    ReferenceNo: $scope.RefNo,
                                    UniqueID: $scope.UniqID,
                                    DONumber: $scope.vm.gDONumber,
                                    GRN: $scope.vm.gGRN,
                                    ReceivedDate: $scope.vm.gReceivedDate,
                                    StoreName: $scope.StoreName,
                                    ProductCategory: ProductCategory,
                                    ProductCode: ProductCodeID,
                                    ProductName: ProductName,
                                    Description: Description,
                                    OrderedQuantity: 0,
                                    Unit: Unit,
                                    Model: Model,
                                    SerialNumber: SerialNoinfo[i].SerialNo,
                                    ReceivedQuantity: 1,
                                    ReturnedQuantity: 0,
                                    Status: "New",
                                    CreatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                        response.then(function (GList) {
                            $scope.GUUSerialNumber = GList.data.data.SerialNumber;
                            var presponse = $http({
                                method: "PUT",
                                url: $rootScope.WebURL + "/purchaseorderproduct/updateQuantity",
                                data: {
                                    _id: $scope.UID,
                                    ReceivedQuantity: $scope.q,
                                },
                            });

                            $scope.Uniquegoodsdata();
                            if ($scope.ProductCategory.toLowerCase() == "sensor" || $scope.ProductCategory.toLowerCase() == "sensors" || $scope.ProductCategory.toLowerCase() == "router" || $scope.ProductCategory.toLowerCase() == "routers" || $scope.ProductCategory.toLowerCase() == "ratsense" || $scope.ProductCategory.toLowerCase() == "gateway" || $scope.ProductCategory.toLowerCase() == "gateways" || $scope.ProductCategory.toLowerCase() == "external sensor" || $scope.ProductCategory.toLowerCase() == "external sensors") {
                                $scope.Lighttrapdata = $scope.srq;
                                $scope.saveLighttrapdatas();
                            }
                            RefreshGUGrid();
                            data1.ReceiveQuantity = '';
                            data1.ReturnQuantity = '';
                            data1.SerialNumber = '';
                            $mdToast.show($mdToast.simple().textContent('Goods Received Successfully!').position('top center'));
                            RefreshGoodsGrid();
                        }, function () {
                            RefreshGoodsGrid();
                            data1.ReceiveQuantity = '';
                            data1.ReturnQuantity = '';
                            data1.SerialNumber = '';
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
            }
        };

        $scope.Uniquegoodsdata = function () {
            RefreshGUGrid();
            $scope.GUStoreName = $scope.StoreName;
            $scope.GUProductCategory = $scope.ProductCategory;
            $scope.GUProductCode = $scope.ProductCode;
            $scope.GUProductName = $scope.ProductName;
            $scope.GUDescription = $scope.Description;
            $scope.GUSerialNumber = $scope.GUUSerialNumber;
            $scope.GUModel = $scope.Model;
            $scope.GUUnit = $scope.Unit;
            $scope.GUTotalQuantity = 0;
            $scope.GUReorderQuantity = 0;
            $scope.GUOnHold = 0;
            $scope.GUDatas = false;

            angular.forEach($scope.Goodsuniquedatas, function (value1) {
                if ($scope.StoreName == value1.StoreName && $scope.ProductCategory == value1.ProductCategory && $scope.ProductCode == value1.ProductCode) {
                    $scope.GUID = value1.id;
                    $scope.GUTotalQuantity = value1.TotalQuantity;
                    $scope.GUOnHold = value1.OnHold;
                    $scope.GUDatas = true;
                }
            });

            if ($scope.Goodsuniquedatas.length == 0) {
                $scope.GUStoreName = $scope.StoreName;
                $scope.GUProductCategory = $scope.ProductCategory;
                $scope.GUProductCode = $scope.ProductCode;
                $scope.GUProductName = $scope.ProductName;
                $scope.GUDescription = $scope.Description;
                $scope.GUSerialNumber = $scope.GUUSerialNumber;
                $scope.GUModel = $scope.Model;
                $scope.GUUnit = $scope.Unit;
                $scope.GUTotalQuantity = 0;
                $scope.GUReorderQuantity = 0;
                $scope.GUOnHold = 0;
                $scope.GUDatas = false;
            }

            $scope.gtq = parseFloat($scope.GUTotalQuantity) + parseFloat($scope.srq);
            if ($scope.gtq < 0 || $scope.gtq == "" || $scope.gtq == null || $scope.gtq == undefined || $scope.gtq == NaN) {
                $scope.gtq = 0;
            }

            if ($scope.GUDatas == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/goodsunique/updateQuantity",
                    data: {
                        _id: $scope.GUID,
                        TotalQuantity: $scope.gtq,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                RefreshGUGrid();
            }
            else if ($scope.GUDatas == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/goodsunique/add",
                    data: {
                        Client_Id: Client_Id,
                        StoreName: $scope.GUStoreName,
                        ProductCategory: $scope.GUProductCategory,
                        ProductCode: $scope.GUProductCode,
                        ProductName: $scope.GUProductName,
                        Description: $scope.GUDescription,
                        Model: $scope.GUModel,
                        Unit: $scope.GUUnit,
                        SerialNumber: $scope.GUSerialNumber,
                        TotalQuantity: $scope.gtq,
                        ReorderQuantity: 0,
                        OnHold: $scope.GUOnHold,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                RefreshGUGrid();
            }
            RefreshGUGrid();
        }

        $scope.saveLighttrapdatas = function () {
            if ($scope.SerialNoArray != "" && $scope.SerialNoArray != null && $scope.SerialNoArray != undefined) {
                var SerialNoinfo = $scope.SerialNoArray;
                for (var i = 0; i < SerialNoinfo.length; i++) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/lighttrap/add",
                        data: {
                            Client_Id: Client_Id,
                            StoreName: $scope.StoreName,
                            ProductCategory: $scope.ProductCategory,
                            ProductCode: $scope.ProductCode,
                            ProductName: $scope.ProductName,
                            Description: $scope.Description,
                            Model: $scope.Model,
                            Unit: $scope.Unit,
                            SerialNumber: SerialNoinfo[i].SerialNo,
                            Customer: null,
                            Location: "",
                            Status: "New",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                }
            }
            else if ($scope.SerialNoArray == "" || $scope.SerialNoArray == null || $scope.SerialNoArray == undefined) {
                for (var i = 0; i < $scope.Lighttrapdata; i++) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/lighttrap/add",
                        data: {
                            Client_Id: Client_Id,
                            StoreName: $scope.StoreName,
                            ProductCategory: $scope.ProductCategory,
                            ProductCode: $scope.ProductCode,
                            ProductName: $scope.ProductName,
                            Description: $scope.Description,
                            Model: $scope.Model,
                            Unit: $scope.Unit,
                            SerialNumber: $scope.GUUSerialNumber,
                            Customer: null,
                            Location: "",
                            Status: "New",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                }
            }

        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
                RefreshPurchaseorderproductGrid1();
            });
        }

        function RefreshGUGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        function RefreshPurchaseorderproductGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseorderproduct/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Purchaseorderproductdata) {
                $scope.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
            });
        }

        function RefreshPurchaseorderproductGrid1() {
            $http.get($rootScope.WebURL + "/purchaseorderproduct")
                .then(function (Purchaseorderproductrefdata) {
                    $scope.Purchaseorderproductrefdatas = Purchaseorderproductrefdata.data.data;
                    $scope.goodspopdata();
                });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {
            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Logdetailsdata) {
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        $scope.Export = function () {
            var ExportData = [];
            angular.forEach($scope.Purchaseorderdatas, function (value, key) {
                if ($scope.Purchaseorderdatas.length > 0) {
                    ExportData.push({
                        ID: value._id,
                        ReferenceNo: value.ReferenceNo,
                        RequisitionNo: value.PRID,
                        RequestedByEmployee: value.RequestedEmployee,
                        OrderDate: convertDate(value.OrderDate),
                        DeliveryDate: convertDate(value.DeliveryDate),
                        Remarks: value.Remarks,
                        SupplierName: value.Supplierdetails[0].Name,
                        SupplierAddress1: value.Supplierdetails[0].Street1,
                        SupplierAddress2: value.Supplierdetails[0].Street2,
                        SupplierCity: value.Supplierdetails[0].City,
                        SupplierState: value.Supplierdetails[0].State,
                        SupplierCountry: value.Supplierdetails[0].Country,
                        SupplierPostalCode: value.Supplierdetails[0].PostalCode,
                        SupplierPhone: value.Supplierdetails[0].Phone,
                        SupplierMobile: value.Supplierdetails[0].Mobile,
                        SupplierFax: value.Supplierdetails[0].Fax,
                        SupplierEmail: value.Supplierdetails[0].Email,
                        SupplierWebsite: value.Supplierdetails[0].Website,
                        StoreName: value.Storedetails[0].StoreName,
                        StoreAddress1: value.Storedetails[0].Address1,
                        StoreAddress2: value.Storedetails[0].Address2,
                        StoreCity: value.Storedetails[0].City,
                        StoreState: value.Storedetails[0].State,
                        StoreCountry: value.Storedetails[0].Country,
                        StorePostalCode: value.Storedetails[0].PostalCode,
                        StorePhone: value.Storedetails[0].Phone,
                        StoreEmail: value.Storedetails[0].Email,
                        SubTotal: parseFloat(value.SubTotal),
                        DiscountBeforeGST: parseFloat(value.DiscountBefore),
                        GST: parseFloat(value.GST),
                        DiscountAfterGST: parseFloat(value.DiscountAfter),
                        Total: parseFloat(value.Total),
                        Status: value.Status,
                    });
                }
            })
            alasql('SELECT * INTO XLSX("PurchaseOrder.xlsx",{headers:true}) FROM ?', [ExportData]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            destroy: true
        };

        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            destroy: true
        };

        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: '',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "PurchaseOrder.aspx?ID=" + PId;
            window.open(url);
        };

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.procurement.purchaserequisition', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.purchaserequisition', {
            url: '/PurchaseRequisition',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/purchaserequisition/purchaserequisition.html',
                    controller: 'PurchaseRequisitionController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.purchaserequisition')
        .controller('PurchaseRequisitionController', PurchaseRequisitionController)
        .filter('twoDecimal', function (input, scope) {
            return function () {
                return input.toFixed(2);
            }
        })
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    function PurchaseRequisitionController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("PurchaseR")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
                try {
                    var citem = $scope.Clientdatas.filter(function (citem) {
                        return citem.id === Client_Id;
                    })[0];
                    $scope.ClientStore = citem.ClientName;
                    $scope.ClientTransactionCurrencies = citem.TransactionCurrencies;
                    if ($scope.ClientTransactionCurrencies != null && $scope.ClientTransactionCurrencies != "" && $scope.ClientTransactionCurrencies != undefined) {
                        var carray = $scope.ClientTransactionCurrencies.split(",");
                        var carray1 = [];
                        angular.forEach(carray, function (value) {
                            carray1.push({ TransactionCurrencies: value });
                        });
                        $scope.CurrencyCodeList = carray1;
                    }
                } catch (err) { }
            });

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshStoreGrid();
        RefreshSupplierGrid();
        RefreshSalesOrderGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();
        RefreshDefineGrid();
        RefreshCategory();
        RefreshUnit();

        $scope.Purchaseform = false;
        $scope.ViewPurchaseform = false;
        $scope.Purchasegrid = true;
        $scope.prExport = true;
        $scope.prAdd = true;
        $scope.prSearch = true;
        $scope.prView = false;
        $scope.Cancel = false;

        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseform/LoginIdDatefilter",
                method: "POST",
                data: { LoginID: $rootScope.LoginID, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Purchaseformdata) {
                $scope.Purchaseformdatas = Purchaseformdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/purchaseform/LoginIdDatefilter",
                method: "POST",
                data: { LoginID: $rootScope.LoginID, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Purchaseformdata) {
                $scope.Purchaseformdatas = Purchaseformdata.data.data;
            });
        }

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("PurchaseRequests.xlsx",{headers:true}) FROM ?', [$scope.Purchaseformdatas]);
        };

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
            $scope.vm.searchTerm4 = '';
            $scope.vm.searchTerm5 = '';
            $scope.vm.searchTerm6 = '';
            $scope.vm.searchTerm7 = '';
            $scope.vm.searchTerm8 = '';
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        function twoDecimal(input) {
            return input.toFixed(2);
        }

        function convertToWord(amount) {
            var words = new Array();
            words[0] = '';
            words[1] = 'One';
            words[2] = 'Two';
            words[3] = 'Three';
            words[4] = 'Four';
            words[5] = 'Five';
            words[6] = 'Six';
            words[7] = 'Seven';
            words[8] = 'Eight';
            words[9] = 'Nine';
            words[10] = 'Ten';
            words[11] = 'Eleven';
            words[12] = 'Twelve';
            words[13] = 'Thirteen';
            words[14] = 'Fourteen';
            words[15] = 'Fifteen';
            words[16] = 'Sixteen';
            words[17] = 'Seventeen';
            words[18] = 'Eighteen';
            words[19] = 'Nineteen';
            words[20] = 'Twenty';
            words[30] = 'Thirty';
            words[40] = 'Forty';
            words[50] = 'Fifty';
            words[60] = 'Sixty';
            words[70] = 'Seventy';
            words[80] = 'Eighty';
            words[90] = 'Ninety';
            amount = amount.toString();
            var atemp = amount.split(".");
            var number = atemp[0].split(",").join("");
            var n_length = number.length;
            var words_string = "";
            if (n_length <= 9) {
                var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
                var received_n_array = new Array();
                for (var i = 0; i < n_length; i++) {
                    received_n_array[i] = number.substr(i, 1);
                }
                for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
                    n_array[i] = received_n_array[j];
                }
                for (var i = 0, j = 1; i < 9; i++, j++) {
                    if (i == 0 || i == 2 || i == 4 || i == 7) {
                        if (n_array[i] == 1) {
                            n_array[j] = 10 + parseInt(n_array[j]);
                            n_array[i] = 0;
                        }
                    }
                }
                var value = "";
                for (var i = 0; i < 9; i++) {
                    if (i == 0 || i == 2 || i == 4 || i == 7) {
                        value = n_array[i] * 10;
                    } else {
                        value = n_array[i];
                    }
                    if (value != 0) {
                        words_string += words[value] + " ";
                    }
                    if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
                        words_string += "Crores ";
                    }
                    if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
                        words_string += "Lakhs ";
                    }
                    if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
                        words_string += "Thousand ";
                    }
                    if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
                        words_string += "Hundred and ";
                    } else if (i == 6 && value != 0) {
                        words_string += "Hundred ";
                    }
                }
                words_string = words_string.split("  ").join(" ");
            }
            return words_string;
        }

        $scope.Add = function () {
            ClearForm();
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];

                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
            } catch (error) { }

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            try {
                $scope.Store = $scope.Storedatas[0]._id;
                $scope.Currency = $scope.CurrencyCodeList[0].TransactionCurrencies;
            } catch (error) { }

            $scope.SubTotal = 0;
            $scope.Total = 0;
            $scope.DiscountBefore = 0;
            $scope.GST = 7;
            $scope.DiscountAfter = 0;

            $scope.Purchase = false;
            $scope.Update = false;
            $scope.Purchaseform = true;
            $scope.ViewPurchaseform = false;
            $scope.Purchasegrid = false;
            $scope.prExport = false;
            $scope.prAdd = false;
            $scope.prSearch = false;
            $scope.prView = true;
            $scope.Cancel = false;
            $scope.Date = new Date();
            $scope.Deadline = new Date();
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

        }

        $scope.Showgrid = function () {
            $scope.Purchasegrid = true;
            $scope.Purchaseform = false;
            $scope.ViewPurchaseform = false;
            $scope.prExport = true;
            $scope.prAdd = true;
            $scope.prView = false;
            $scope.prSearch = true;
            $scope.Purchase = false;
            $scope.Cancel = false;
        }

        $scope.pSubmit = function () {
            if ($scope.Purchasedatas.length < 0) {
                $mdToast.show($mdToast.simple().textContent('No Required Stock Added!!').position('top center'));
                return
            }
            $scope.TotalItems = $scope.Purchasedatas.length;
            if ($scope.WorkOrder != null && $scope.WorkOrder != "" && $scope.WorkOrder != undefined) {
                $scope.WorkOrder = $scope.WorkOrder.map(function (obj) { return obj.SalesOrderNo; }).join(',');
            }
            if ($scope.Purpose != null && $scope.Purpose != "" && $scope.Purpose != undefined) {
                $scope.Purpose = $scope.Purpose.map(function (obj) { return obj.Description; }).join(',');
            }

            if ($scope.Total > 0 && $scope.Total != null && $scope.Total != "" && $scope.Total != undefined) {
                $scope.SubTotal = $scope.SubTotal.toFixed(2);
                $scope.Total = $scope.Total.toFixed(2);
            }
            else { $scope.Total = 0 }

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseform/update",
                    data: {
                        _id: $scope.SID,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        EmployeeID: $scope.Employee,
                        SupplierID: $scope.Supplier,
                        StoreID: $scope.Store,
                        WorkOrder: $scope.WorkOrder,
                        Date: $scope.Date,
                        Purpose: $scope.Purpose,
                        Deadline: $scope.Deadline,
                        Remarks: $scope.Remarks,
                        TotalItems: $scope.TotalItems,
                        ClientStore: $scope.ClientStore,
                        Currency: $scope.Currency,
                        SubTotal: $scope.SubTotal,
                        DiscountBefore: $scope.DiscountBefore,
                        GST: $scope.GST,
                        DiscountAfter: $scope.DiscountAfter,
                        Total: $scope.Total,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                        $scope.SupplierName = $scope.Userdata.Supplierdetails[0].Name;
                        $scope.StoreName = $scope.Userdata.Storedetails[0].StoreName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseform/email",
                            data: {
                                PurchaseID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Deadline: convertDate($scope.Userdata.Deadline),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Purchaseformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/purchaseform/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        EmployeeID: $scope.Employee,
                        SupplierID: $scope.Supplier,
                        StoreID: $scope.Store,
                        WorkOrder: $scope.WorkOrder,
                        Date: $scope.Date,
                        Purpose: $scope.Purpose,
                        Deadline: $scope.Deadline,
                        Remarks: $scope.Remarks,
                        TotalItems: $scope.TotalItems,
                        ClientStore: $scope.ClientStore,
                        Currency: $scope.Currency,
                        SubTotal: $scope.SubTotal,
                        DiscountBefore: $scope.DiscountBefore,
                        GST: $scope.GST,
                        DiscountAfter: $scope.DiscountAfter,
                        Total: $scope.Total,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data;

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) { }

                    //try {
                    //    var SArray = $scope.Supplierdatas;
                    //    var Sitem = SArray.filter(function (Sitem) {
                    //        return Sitem.id === $scope.Userdata.SupplierID;
                    //    })[0];
                    //    $scope.SupplierName = Sitem.Name;
                    //} catch (err) {
                    //}

                    //try {
                    //    var StArray = $scope.Storedatas;
                    //    var Stitem = StArray.filter(function (Stitem) {
                    //        return Stitem._id === $scope.Userdata.StoreID;
                    //    })[0];
                    //    $scope.StoreName = Stitem.StoreName;
                    //} catch (err) {
                    //}

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }

                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseform/email",
                            data: {
                                PurchaseID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Deadline: convertDate($scope.Userdata.Deadline),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Request",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Purchaseinfo = function (PRId, $index) {
            $scope.SID = PRId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Purchaseformdatas.filter(function (item) {
                    return item._id === PRId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.Employee = item.EmployeeID;
                    $scope.Supplier = item.SupplierID;
                    $scope.Store = item.StoreID;
                    $scope.ClientStore = item.ClientStore;
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                    $scope.WorkOrder = item.WorkOrder;
                    if ($scope.WorkOrder != null && $scope.WorkOrder != "" && $scope.WorkOrder != undefined) {
                        var array = $scope.WorkOrder.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ SalesOrderNo: value });
                        });
                        $scope.WorkOrder = array1;
                    }
                    $scope.Date = new Date(item.Date);
                    $scope.Purpose = item.Purpose;
                    if ($scope.Purpose != null && $scope.Purpose != "" && $scope.Purpose != undefined) {
                        var parray = $scope.Purpose.split(",");
                        var array2 = [];
                        angular.forEach(parray, function (value) {
                            array2.push({ Description: value });
                        });
                        $scope.Purpose = array2;
                    }
                    $scope.Deadline = new Date(item.Deadline);
                    $scope.Remarks = item.Remarks;
                    $scope.Currency = item.Currency;
                    $scope.SubTotal = parseFloat(item.SubTotal);
                    $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                    $scope.GST = parseFloat(item.GST);
                    $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                    $scope.Total = parseFloat(item.Total);
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;

                    $scope.Update = true;
                    $scope.Purchaseform = true;
                    $scope.ViewPurchaseform = false;
                    $scope.Purchasegrid = false;
                    $scope.prExport = false;
                    $scope.prAdd = false;
                    $scope.prSearch = false;
                    $scope.prView = true;
                    $scope.Cancel = false;

                    if ($scope.Status == "New" && $scope.StatusID == "1") {
                        $scope.Cancel = true;
                    }

                } catch (err) { }
                RefreshPurchaseGrid1();
            }
        }

        $scope.ViewPurchaseinfo = function (PReqId) {
            $scope.SID = PReqId;
            try {
                var item = $scope.Purchaseformdatas.filter(function (item) {
                    return item._id === PReqId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.Supplier = item.SupplierID;
                $scope.SupplierName = item.Supplierdetails[0].Name;
                $scope.Store = item.StoreID;
                $scope.StoreName = item.Storedetails[0].StoreName;
                $scope.ClientStore = item.ClientStore;
                $scope.WorkOrder = item.WorkOrder;
                $scope.Date = new Date(item.Date);
                $scope.Purpose = item.Purpose;
                $scope.Deadline = new Date(item.Deadline);
                $scope.Remarks = item.Remarks;
                $scope.Currency = item.Currency;
                $scope.SubTotal = parseFloat(item.SubTotal);
                $scope.DiscountBefore = parseFloat(item.DiscountBefore);
                $scope.GST = parseFloat(item.GST);
                $scope.DiscountAfter = parseFloat(item.DiscountAfter);
                $scope.Total = parseFloat(item.Total);
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            RefreshPurchaseGrid1();
            $scope.Update = true;
            $scope.ViewPurchaseform = true;
            $scope.Purchaseform = false;
            $scope.Purchasegrid = false;
            $scope.prExport = false;
            $scope.prAdd = false;
            $scope.prSearch = false;
            $scope.prView = true;
            $scope.Cancel = false;
        }

        $scope.ViewPurchaseItmes = function (e, VPReqId) {
            try {
                var item = $scope.Purchaseformdatas.filter(function (item) {
                    return item._id === VPReqId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
            } catch (err) { }
            RefreshPurchaseGrid1();
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaserequisition/viewItems.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.cancelrequest = function () {
            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;
            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchaseform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Purchase Request' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Purchase Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }

                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/purchaseform/email",
                            data: {
                                PurchaseID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Deadline: convertDate($scope.Userdata.Deadline),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Purchase Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Purchaseformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        function RefreshSalesOrderGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/salesOrder",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (SalesOrderdata) {
                $scope.SalesOrderdatas = SalesOrderdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
            } catch (error) { }
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshDefineGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/define",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Definedata) {
                $scope.Definedatas = Definedata.data.data;
            });
        }

        function RefreshCategory() {
            var response = $http({
                url: $rootScope.WebURL + "/category",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Categorydata) {
                $scope.ProductCategorydatas = Categorydata.data.data;
            });
        }

        function RefreshUnit() {
            var response = $http({
                url: $rootScope.WebURL + "/unit",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Unitdata) {
                $scope.Unitdatas = Unitdata.data.data;
            });
        }

        function RefreshStoreGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
            });
        }

        function RefreshSupplierGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/supplier",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Supplierdata) {
                $scope.Supplierdatas = Supplierdata.data.data;
            });
        }

        function ClearForm() {
            $scope.ReferenceNo = '';
            $scope.UniqueID = '';
            $scope.Employee = '';
            $scope.WorkOrder = '';
            $scope.Date = '';
            $scope.Purpose = '';
            $scope.Deadline = '';
            $scope.Remarks = '';
            $scope.Supplier = '';
            try {
                $scope.Store = $scope.Storedatas[0]._id;
                $scope.Currency = $scope.CurrencyCodeList[0].TransactionCurrencies;
            } catch (error) { }

            $scope.SubTotal = 0;
            $scope.Total = 0;
            $scope.DiscountBefore = 0;
            $scope.GST = 7;
            $scope.DiscountAfter = 0;
            $scope.Purchasedatas = '';
        }

        $scope.Purchasepopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.pProductCategory = '';
            $scope.vm.pProductCode = '';
            $scope.vm.pName = '';
            $scope.vm.pDescription = '';
            $scope.vm.pQuantity = '';
            $scope.vm.pUnits = '';
            $scope.PUpdate = false;
            $scope.Categorydatas = '';
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaserequisition/purchase.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.ProductNameClear = function () {
            $scope.vm.pName = '';
            $scope.vm.pProductCode = '';
            $scope.vm.pDescription = '';
            $scope.vm.pUnits = '';
        }

        $scope.ProductNamedetails = function () {
            var response = $http({
                url: $rootScope.WebURL + "/product/getByCategory",
                method: "POST",
                data: { RequestID: $scope.vm.pProductCategory },
            });
            response.then(function (Categorydata) {
                $scope.Categorydatas = Categorydata.data.data;
            });
        }

        $scope.ProductCodedetails = function () {
            try {
                var item = $scope.Categorydatas.filter(function (item) {
                    return $scope.vm.pName == item.ProductName && $scope.vm.pProductCategory == item.Category;
                })[0];
                $scope.vm.pProductCode = item.ProductCode;
                $scope.vm.pDescription = item.Description;
                $scope.vm.pUnits = item.Unit;
                if (item.UnitPrice != "" && item.UnitPrice != null && item.UnitPrice != undefined) {
                    $scope.UnitPrice = parseFloat(item.UnitPrice);
                }
                else { $scope.UnitPrice = 0; }

                $scope.Model = item.Model;
            } catch (err) { }
        }

        $scope.CalculateTotal = function () {
            $scope.TotalCost = 0.00;
            $scope.TotalCost += (parseFloat($scope.vm.pQuantity) * parseFloat($scope.UnitPrice));
        };

        $scope.ChangeTotal = function () {
            var a = $scope.SubTotal;

            if ($scope.DiscountBefore != "0" && $scope.DiscountBefore != "undefined" && $scope.DiscountBefore != "" && $scope.DiscountBefore != null) {
                $scope.db = (a * (0.01 * $scope.DiscountBefore));
            } else {
                $scope.db = 0;
            }

            $scope.db2 = a - $scope.db;

            if ($scope.DiscountBefore != "0" && $scope.DiscountBefore != "undefined" && $scope.DiscountBefore != "" && $scope.DiscountBefore != null && $scope.GST != "undefined" && $scope.GST != "" && $scope.GST != "0" && $scope.GST != null) {
                $scope.gs = ($scope.db2 * (0.01 * $scope.GST));
            } else if ($scope.DiscountBefore == "0" || $scope.DiscountBefore == "undefined" || $scope.DiscountBefore == "" || $scope.DiscountBefore == null && $scope.GST != "undefined" && $scope.GST != "" && $scope.GST != "0" && $scope.GST != null) {
                $scope.gs = (a * (0.01 * $scope.GST));
            } else {
                $scope.gs = 0;
            }

            if ($scope.gs != "0" && $scope.DiscountAfter != "undefined" && $scope.DiscountAfter != "" && $scope.DiscountAfter != "0" && $scope.DiscountAfter != null) {
                $scope.da = ($scope.gs * (0.01 * $scope.DiscountAfter));
            } else if ($scope.gs == "0" && $scope.DiscountAfter != "undefined" && $scope.DiscountAfter != "" && $scope.DiscountAfter != "0" && $scope.DiscountAfter != null) {
                $scope.da = (a * (0.01 * $scope.DiscountAfter));
            } else {
                $scope.da = 0;
            }

            $scope.Total = parseFloat(a - $scope.db + $scope.gs - $scope.da);
        }

        $scope.Purchaseadd = function () {
            if ($scope.PUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/purchase/update",
                    data: {
                        _id: $scope.PID,
                        ProductCategory: $scope.vm.pProductCategory,
                        ProductCodeID: $scope.vm.pProductCode,
                        ProductName: $scope.vm.pName,
                        Description: $scope.vm.pDescription,
                        Quantity: $scope.vm.pQuantity,
                        Unit: $scope.vm.pUnits,
                        Model: $scope.Model,
                        UnitPrice: $scope.UnitPrice,
                        TotalCost: $scope.TotalCost,
                        ReceivedQuantity: 0,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshPurchaseGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/purchase/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        ProductCategory: $scope.vm.pProductCategory,
                        ProductCodeID: $scope.vm.pProductCode,
                        ProductName: $scope.vm.pName,
                        Description: $scope.vm.pDescription,
                        Quantity: $scope.vm.pQuantity,
                        Unit: $scope.vm.pUnits,
                        Model: $scope.Model,
                        UnitPrice: $scope.UnitPrice,
                        TotalCost: $scope.TotalCost,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshPurchaseGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.PurchaseUpdate = function (data1, UniqueID, id, ProductCategory, ProductCodeID, ProductName, Unit, Model) {
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/purchase/update",
                data: {
                    _id: id,
                    ProductCategory: ProductCategory,
                    ProductCodeID: ProductCodeID,
                    ProductName: ProductName,
                    Description: data1.Description,
                    Quantity: data1.Quantity,
                    Unit: Unit,
                    Model: Model,
                    UnitPrice: data1.UnitPrice,
                    TotalCost: (data1.Quantity * data1.UnitPrice),
                    UpdatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                RefreshPurchaseGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        };

        $scope.Purchasedelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/purchaserequisition/purchasedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PurchaseRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Pdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchase/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshPurchaseGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function RefreshPurchaseGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/purchase/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Purchasedata) {
                $scope.Purchasedatas = Purchasedata.data.data;

                var total = 0;
                angular.forEach($scope.Purchasedatas, function (value) {
                    if (value.TotalCost != undefined) {
                        total += parseFloat(value.TotalCost);
                    }
                });
                $scope.SubTotal = total;
                $scope.Total = total;

                $scope.ChangeTotal();
            });
        }

        function RefreshPurchaseGrid1() {
            var response = $http({
                url: $rootScope.WebURL + "/purchase/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Purchasedata) {
                $scope.Purchasedatas = Purchasedata.data.data;
            });
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "PurchaseRequest.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            destroy: true
        };

        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: '',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.materialrequisition', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.materialrequisition', {
            url: '/StockRequisition',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/materialrequisition/materialrequisition.html',
                    controller: 'MaterialRequisitionController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.materialrequisition')
        .controller('MaterialRequisitionController', MaterialRequisitionController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });

    //.filter("htmlToPlaintext", function () {
    //    return function (input) {
    //        return input.replace(/<[^>]+>/gm, '');
    //    }
    //});

    function MaterialRequisitionController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdSidenav, $mdToast, $mdDialog, $document, $http, $log, $window) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("MaterialR")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        var date = new Date();
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
        $scope.uFrom = lastDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.RatsanseStartDate = new Date();
        $scope.RatsanseEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshCustomerGrid();
        RefreshSalesOrderGrid();
        RefreshWorkflowGrid();
        RefreshStoreGrid();
        RefreshDefineGrid();
        RefreshCategory();
        RefreshUnit();
        RefreshGoodsGrid();
        RefreshStockListGrid();

        $scope.Materialform = false;
        $scope.ViewMaterialform = false;
        $scope.Materialgrid = true;
        $scope.mrExport = true;
        $scope.mrAdd = true;
        $scope.mrSearch = true;
        $scope.mrView = false;

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("StockRequests.xlsx",{headers:true}) FROM ?', [$scope.Materialformdatas]);
        };

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
            $scope.vm.searchTerm4 = '';
            $scope.vm.searchTerm5 = '';
            $scope.vm.searchTerm6 = '';
            $scope.vm.searchTerm7 = '';
            $scope.vm.searchTerm8 = '';
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
            } catch (error) { }

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.Material = false;
            $scope.Update = false;
            $scope.Materialform = true;
            $scope.ViewMaterialform = false;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrAdd = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Date = new Date();
            $scope.Cancel = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Materialgrid = true;
            $scope.Materialform = false;
            $scope.ViewMaterialform = false;
            $scope.mrExport = true;
            $scope.mrAdd = true;
            $scope.mrView = false;
            $scope.mrSearch = true;
            $scope.Material = false;
            $scope.Cancel = false;
        }

        $scope.Materialinfo = function (MRId, $index) {
            $scope.SID = MRId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Materialformdatas.filter(function (item) {
                    return item._id === MRId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.Employee = item.EmployeeID;
                    $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                    $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                    $scope.WorkOrder = item.WorkOrder;
                    if ($scope.WorkOrder != null && $scope.WorkOrder != "" && $scope.WorkOrder != undefined) {
                        var array = $scope.WorkOrder.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ SalesOrderNo: value });
                        });
                        $scope.WorkOrder = array1;
                    }
                    $scope.Date = new Date(item.Date);
                    $scope.Purpose = item.Purpose;
                    if ($scope.Purpose != null && $scope.Purpose != "" && $scope.Purpose != undefined) {
                        var parray = $scope.Purpose.split(",");
                        var array2 = [];
                        angular.forEach(parray, function (value) {
                            array2.push({ Description: value });
                        });
                        $scope.Purpose = array2;
                    }

                    $scope.Remarks = item.Remarks;
                    $scope.TotalItems = item.TotalItems;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                    $scope.Location = item.Location;
                    $scope.Customer = item.CustomerID;
                    $scope.CustomerName = item.Customerdetails[0].CompanyName;
                } catch (err) { }

                RefreshMaterialGrid();
                RefreshStockListGrid();
                RefreshGoodsGrid();

                $scope.Update = true;
                $scope.Materialform = true;
                $scope.ViewMaterialform = false;
                $scope.Materialgrid = false;
                $scope.mrExport = false;
                $scope.mrAdd = false;
                $scope.mrSearch = false;
                $scope.mrView = true;
                $scope.Cancel = false;
                $scope.Material = true;

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

            }
        }

        $scope.ViewMaterialinfo = function (MReqId) {
            $scope.SID = MReqId;
            $scope.Update = true;
            $scope.Materialform = false;
            $scope.ViewMaterialform = true;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrAdd = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Cancel = false;
            $scope.Material = true;
            try {
                var item = $scope.Materialformdatas.filter(function (item) {
                    return item._id === MReqId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.DepartmentName = item.Employeedetails[0].EDesignation;
                $scope.WorkOrder = item.WorkOrder;
                $scope.Date = new Date(item.Date);
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                $scope.TotalItems = item.TotalItems;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.Location = item.Location;
                $scope.Customer = item.CustomerID;
                $scope.CustomerName = item.Customerdetails[0].CompanyName;
            } catch (err) { }

            RefreshMaterialGrid();
        }

        $scope.ViewMaterialItmes = function (e, VReqId) {
            try {
                var item = $scope.Materialformdatas.filter(function (item) {
                    return item._id === VReqId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
            } catch (err) { }
            RefreshMaterialGrid();
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/materialrequisition/viewItems.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MaterialRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.mSubmit = function () {
            $scope.TotalItems = $scope.Materialdatas.length;

            if ($scope.Customer == null || $scope.Customer == "" || $scope.Customer == undefined) {
                $scope.Customer == null;
            }
            if ($scope.WorkOrder != null && $scope.WorkOrder != "" && $scope.WorkOrder != undefined) {
                $scope.WorkOrder = $scope.WorkOrder.map(function (obj) { return obj.SalesOrderNo; }).join(',');
            }

            if ($scope.Purpose != null && $scope.Purpose != "" && $scope.Purpose != undefined) {
                $scope.Purpose = $scope.Purpose.map(function (obj) { return obj.Description; }).join(',');
            }

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/materialform/update",
                    data: {
                        _id: $scope.SID,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        EmployeeID: $scope.Employee,
                        CustomerID: $scope.Customer,
                        Location: $scope.Location,
                        WorkOrder: $scope.WorkOrder,
                        Date: $scope.Date,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        TotalItems: $scope.TotalItems,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }

                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/materialform/email",
                            data: {
                                MaterialID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Materialformdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/materialform/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        RequestedEmployee: $scope.RequestedByEmployee,
                        EmployeeID: $scope.Employee,
                        CustomerID: $scope.Customer,
                        Location: $scope.Location,
                        WorkOrder: $scope.WorkOrder,
                        Date: $scope.Date,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        TotalItems: $scope.TotalItems,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    angular.forEach($scope.Materialdatas, function (value1) {
                        angular.forEach($scope.Goodsuniquedatas, function (value2) {
                            if (value1.StoreName == value2.StoreName && value1.ProductCategory == value2.ProductCategory && value1.ProductCode == value2.ProductCode) {
                                $scope.aoh = (parseFloat(value2.OnHold) + parseFloat(value1.QuantityRequired));
                                if ($scope.aoh < 0 || $scope.aoh == "" || $scope.aoh == null || $scope.aoh == undefined || $scope.aoh == NaN) {
                                    $scope.aoh = 0;
                                }
                                $scope.atq = (parseFloat(value2.TotalQuantity) - parseFloat(value1.QuantityRequired));
                                if ($scope.atq < 0 || $scope.atq == "" || $scope.atq == null || $scope.atq == undefined || $scope.atq == NaN) {
                                    $scope.atq = 0;
                                }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                    data: {
                                        _id: value2.id,
                                        OnHold: $scope.aoh,
                                        TotalQuantity: $scope.atq,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });
                    var marray = [];
                    angular.forEach($scope.Materialdatas, function (value) {
                        if (value.SerialNumber != null && value.SerialNumber != "null" && value.SerialNumber != undefined && value.SerialNumber != "undefined" && value.SerialNumber != "") {
                            var Sno = value.SerialNumber.split(",");
                            angular.forEach(Sno, function (v1) {
                                marray.push({
                                    SerialNo: v1,
                                    ProCode: value.ProductCode,
                                })
                            });
                        }
                    });
                    if (marray.length != 0) {
                        angular.forEach(marray, function (value) {
                            angular.forEach($scope.Goodsdatas, function (Gvalue) {
                                if (value.SerialNo == Gvalue.SerialNumber && value.ProCode == Gvalue.ProductCode) {
                                    var response = $http({
                                        method: "PUT",
                                        url: $rootScope.WebURL + "/goods/updateIssue",
                                        data: {
                                            _id: Gvalue.id,
                                            Status: "Issued",
                                            Customer: $scope.Customer,
                                            Location: $scope.Location,
                                            StartDate: $scope.RatsanseStartDate,
                                            EndDate: $scope.RatsanseEndDate,
                                            UpdatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }
                            });
                        });
                    }
                    $scope.Userdata = GList.data.data;
                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }

                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/materialform/email",
                            data: {
                                MaterialID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Request",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    RefreshStockListGrid();
                    RefreshGoodsGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.cancelrequest = function () {
            $scope.WID = $scope.id;
            $scope.IndexID = $scope.IndxID;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/materialform/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    angular.forEach($scope.Materialdatas, function (value1) {
                        angular.forEach($scope.Goodsuniquedatas, function (value2) {
                            if (value1.StoreName == value2.StoreName && value1.ProductCategory == value2.ProductCategory && value1.ProductCode == value2.ProductCode) {
                                $scope.coh = (parseFloat(value2.OnHold) - parseFloat(value1.QuantityRequired));
                                if ($scope.coh < 0 || $scope.coh == "" || $scope.coh == null || $scope.coh == undefined || $scope.coh == NaN) {
                                    $scope.coh = 0;
                                }
                                $scope.ctq = (parseFloat(value2.TotalQuantity) + parseFloat(value1.QuantityRequired));
                                if ($scope.ctq < 0 || $scope.ctq == "" || $scope.ctq == null || $scope.ctq == undefined || $scope.ctq == NaN) {
                                    $scope.ctq = 0;
                                }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                    data: {
                                        _id: value2.id,
                                        OnHold: $scope.coh,
                                        TotalQuantity: $scope.ctq,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });

                    var marray = [];
                    angular.forEach($scope.Materialdatas, function (value) {
                        if (value.SerialNumber != null && value.SerialNumber != "null" && value.SerialNumber != undefined && value.SerialNumber != "undefined" && value.SerialNumber != "") {
                            var Sno = value.SerialNumber.split(",");
                            angular.forEach(Sno, function (v1) {
                                marray.push({
                                    SerialNo: v1,
                                    ProCode: value.ProductCode,
                                })
                            });
                        }
                    });
                    if (marray.length != 0) {
                        angular.forEach(marray, function (value) {
                            angular.forEach($scope.Goodsdatas, function (Gvalue) {
                                if (value.SerialNo == Gvalue.SerialNumber && value.ProCode == Gvalue.ProductCode) {
                                    var response = $http({
                                        method: "PUT",
                                        url: $rootScope.WebURL + "/goods/updateIssue",
                                        data: {
                                            _id: Gvalue.id,
                                            Status: "New",
                                            Customer: $scope.Customer,
                                            Location: $scope.Location,
                                            StartDate: $scope.RatsanseStartDate,
                                            EndDate: $scope.RatsanseEndDate,
                                            UpdatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }
                            });
                        });
                    }

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'Inventory Stock Request' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'Inventory Stock Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/materialform/email",
                            data: {
                                MaterialID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                WorkOrder: $scope.Userdata.WorkOrder,
                                Date: convertDate($scope.Userdata.Date),
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Inventory Stock Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Materialformdatas[$scope.IndexID] = GList.data.data[0];
                    RefreshStockListGrid();
                    RefreshGoodsGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        function RefreshCustomerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: { Client_Id: Client_Id },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }

        function RefreshSalesOrderGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/salesOrder",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (SalesOrderdata) {
                $scope.SalesOrderdatas = SalesOrderdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
            } catch (error) { }
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshDefineGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/define",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Definedata) {
                $scope.Definedatas = Definedata.data.data;
            });
        }

        function RefreshStockListGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
            });
        }

        function RefreshStoreGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/store",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Storedata) {
                $scope.Storedatas = Storedata.data.data;
            });
        }

        function RefreshGrid() {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/materialform/LoginIdDatefilter",
                method: "POST",
                data: { LoginID: $rootScope.LoginID, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Materialformdata) {
                $scope.Materialformdatas = Materialformdata.data.data;
            });
        }

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/materialform/LoginIdDatefilter",
                method: "POST",
                data: { LoginID: $rootScope.LoginID, Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Materialformdata) {
                $scope.Materialformdatas = Materialformdata.data.data;
            });
        }


        function ClearForm() {
            $scope.ReferenceNo = '';
            $scope.UniqueID = '';
            $scope.Employee = '';
            $scope.Customer = null;
            $scope.Location = '';
            $scope.Department = '';
            $scope.WorkOrder = '';
            $scope.Date = '';
            $scope.Purpose = '';
            $scope.Remarks = '';
            $scope.Status = '';
            $scope.StatusID = '';
            $scope.Materialdatas = '';
        }

        function RefreshGoodsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goods",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsdata) {
                $scope.Goodsdatas = Goodsdata.data.data;
            });
        }

        $scope.Materialpopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.mStore = $scope.Storedatas[0].StoreName;
            $scope.vm.mType = "No";
            var date = new Date();
            $scope.vm.mExpectedReturnDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);
            $scope.vm.mProductCategory = '';
            $scope.vm.mMaterial = '';
            $scope.vm.mProductCode = '';
            $scope.vm.mDescription = '';
            $scope.vm.mStockQuantity = 0;
            $scope.vm.mQuantityRequired = '';
            $scope.vm.mUnits = '';
            $scope.vm.mSerialNumber = '';
            $scope.SerialNoArray = '';
            $scope.MUpdate = false;

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/materialrequisition/material.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MaterialRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.ProductNamedetails = function () {
            $scope.vm.mMaterial = '';
            $scope.vm.mProductCode = '';
            $scope.vm.mDescription = '';
            $scope.vm.mUnits = '';
            $scope.vm.mStockQuantity = 0;
            $scope.vm.mQuantityRequired = '';
            $scope.vm.mSerialNumber = '';
            $scope.SerialNoArray = '';

            if ($scope.vm.mProductCategory.toLowerCase() == "ratsense" || $scope.vm.mProductCategory.toLowerCase() == "equipments" || $scope.vm.mProductCategory.toLowerCase() == "equipment" || $scope.vm.mProductCategory.toLowerCase() == "sensors" || $scope.vm.mProductCategory.toLowerCase() == "sensor" || $scope.vm.mProductCategory.toLowerCase() == "assets" || $scope.vm.mProductCategory.toLowerCase() == "asset") {
                $scope.vm.mType = "Yes";
                var date = new Date();
                $scope.vm.mExpectedReturnDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 3);
            }
            else {
                $scope.vm.mType = "No";
            }

            var response = $http({
                url: $rootScope.WebURL + "/product/getByCategory",
                method: "POST",
                data: { RequestID: $scope.vm.mProductCategory },
            });
            response.then(function (Categorydata) {
                $scope.Categorydatas = Categorydata.data.data;
            });
        }

        $scope.ProductCodedetails = function () {
            $scope.vm.mStockQuantity = 0;
            $scope.vm.mSerialNumber = '';
            $scope.SerialNoArray = '';

            try {
                var item = $scope.Categorydatas.filter(function (item) {
                    return $scope.vm.mProductCategory == item.Category && $scope.vm.mMaterial == item.ProductName;
                })[0];
                $scope.vm.mProductCode = item.ProductCode;
                $scope.vm.mDescription = item.Description;
                $scope.vm.mUnits = item.Unit;
                $scope.Model = item.Model;
                $scope.UnitPrice = item.UnitPrice;
                $scope.SerialNumber = item.SerialNumber;

                var gTotal = 0.00;
                angular.forEach($scope.Goodsuniquedatas, function (Gvalue) {
                    if ($scope.vm.mStore == Gvalue.StoreName && $scope.vm.mProductCategory == Gvalue.ProductCategory && $scope.vm.mProductCode == Gvalue.ProductCode) {
                        if (Gvalue.TotalQuantity != "" && Gvalue.TotalQuantity != null && Gvalue.TotalQuantity != undefined) {
                            gTotal = parseFloat(Gvalue.TotalQuantity);
                        }
                    }
                });
                if (gTotal < 0 || gTotal == "" || gTotal == null || gTotal == undefined || gTotal == NaN) {
                    gTotal = 0;
                }
                $scope.vm.mStockQuantity = gTotal;
                if ($scope.vm.mStockQuantity != null && $scope.vm.mStockQuantity != undefined && $scope.vm.mStockQuantity != "") {
                    if (parseFloat($scope.vm.mStockQuantity) % 1 == 0) {
                        if ($scope.vm.mStockQuantity < 0) {
                            $scope.vm.mStockQuantity = 0;
                        } else {
                            $scope.vm.mStockQuantity = $scope.vm.mStockQuantity;
                        }
                    }
                    else {
                        if ($scope.vm.mStockQuantity < 0) {
                            $scope.vm.mStockQuantity = 0;
                        } else {
                            $scope.vm.mStockQuantity = parseFloat($scope.vm.mStockQuantity).toFixed(1);
                        }
                    }
                }
            } catch (err) { }

            var response = $http({
                url: $rootScope.WebURL + "/goods/getByCategory",
                method: "POST",
                data: { Client_Id: Client_Id, Status: "New", StoreName: $scope.vm.mStore, ProductCategory: $scope.vm.mProductCategory, ProductCode: $scope.vm.mProductCode },
            });
            response.then(function (Serialdata) {
                debugger
                $scope.SerialCategorydatas = Serialdata.data.data;
                try {
                    $scope.SerialNoArray = $scope.SerialCategorydatas[0].SerialNumber;
                } catch (err) { }
            });
        }

        $scope.ProductNameClear = function () {
            $scope.vm.mMaterial = '';
            $scope.vm.mProductCode = '';
            $scope.vm.mDescription = '';
            $scope.vm.mUnits = '';
            $scope.vm.mStockQuantity = 0;
            $scope.vm.mQuantityRequired = '';
            $scope.vm.mSerialNumber = '';
            $scope.SerialNoArray = '';
        }

        $scope.selectAll = function () {
            $scope.CheckSelect = $scope.vm.select;
            if ($scope.CheckSelect == true) {
                $scope.SelectSerialNumber = [];
                angular.forEach($scope.SerialNoArray, function (obj) {
                    $scope.SelectSerialNumber.push({
                        AllSerialNo: obj,
                    })
                })
                if ($scope.SelectSerialNumber != null && $scope.SelectSerialNumber != "" && $scope.SelectSerialNumber != undefined) {
                    $scope.AllSerialNumber = $scope.SelectSerialNumber.map(function (obj) { return obj.AllSerialNo }).join(',');
                }
                $scope.vm.mSerialNumber = $scope.AllSerialNumber.split(",");
                $scope.vm.mQuantityRequired = $scope.vm.mSerialNumber.length;
            }
            else if ($scope.CheckSelect == false) {
                $scope.vm.mSerialNumber = "";
                $scope.vm.mQuantityRequired = "";
            }
        };

        $scope.getQuantitydetails = function () {
            if ($scope.vm.mSerialNumber != undefined) {
                $scope.vm.mQuantityRequired = $scope.vm.mSerialNumber.length;
            }
            else if ($scope.vm.mSerialNumber == undefined) {
                $scope.vm.mQuantityRequired = "";
                $scope.vm.select = false;
            }
        }

        $scope.Materialadd = function () {
            if ($scope.vm.mStockQuantity < $scope.vm.mQuantityRequired) {
                $mdToast.show($mdToast.simple().textContent('Stock Not Available!!').position('top center'));
                return
            }
            if ($scope.Materialdatas.length != 0) {
                $scope.CheckMaterialDataDuplicate = [];
                angular.forEach($scope.Materialdatas, function (value) {
                    if (value.StoreName == $scope.vm.mStore && value.ProductCategory == $scope.vm.mProductCategory && value.ProductCode == $scope.vm.mProductCode) {
                        $scope.CheckMaterialDataDuplicate.push({
                            ProductCategory: value.ProductCategory,
                            ProductCode: value.ProductCode,
                        })
                    }
                });
                if ($scope.CheckMaterialDataDuplicate.length > 0) {
                    $mdToast.show($mdToast.simple().textContent('Existing Stock(s)!!').position('top center'));
                    return
                }
            }
            if ($scope.vm.mType == "No") {
                $scope.vm.mExpectedReturnDate = null;
            }
            if ($scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != null) {
                var checkSNoLength = $scope.vm.mSerialNumber.length;
                if (checkSNoLength < parseFloat($scope.vm.mQuantityRequired)) {
                    $mdToast.show($mdToast.simple().textContent('Selected Serial No. is less than to Required Quantity!').position('top center'));
                    return
                }
                if (checkSNoLength > parseFloat($scope.vm.mQuantityRequired)) {
                    $mdToast.show($mdToast.simple().textContent('Selected Serial No. is more than to Required Quantity!').position('top center'));
                    return
                }
                if ($scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != undefined) {
                    $scope.vm.mSerialNumber = $scope.vm.mSerialNumber.map(function (obj) { return obj }).join(',');
                }
            }

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/material/add",
                data: {
                    UniqueID: $scope.UniqueID,
                    ProductType: $scope.vm.mType,
                    ExpectedReturnDate: $scope.vm.mExpectedReturnDate,
                    StoreName: $scope.vm.mStore,
                    ProductCategory: $scope.vm.mProductCategory,
                    ProductName: $scope.vm.mMaterial,
                    ProductCode: $scope.vm.mProductCode,
                    Description: $scope.vm.mDescription,
                    QuantityRequired: $scope.vm.mQuantityRequired,
                    Unit: $scope.vm.mUnits,
                    Model: $scope.Model,
                    SerialNumber: $scope.vm.mSerialNumber,
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (GList) {
                if ($scope.Update == true) {
                    angular.forEach($scope.Goodsuniquedatas, function (value2) {
                        if ($scope.vm.mStore == value2.StoreName && $scope.vm.mProductCategory == value2.ProductCategory && $scope.vm.mProductCode == value2.ProductCode) {
                            $scope.maoh = (parseFloat(value2.OnHold) + parseFloat($scope.vm.mQuantityRequired));
                            if ($scope.maoh < 0 || $scope.maoh == "" || $scope.maoh == null || $scope.maoh == undefined || $scope.maoh == NaN) {
                                $scope.maoh = 0;
                            }
                            $scope.matq = (parseFloat(value2.TotalQuantity) - parseFloat($scope.vm.mQuantityRequired));
                            if ($scope.matq < 0 || $scope.matq == "" || $scope.matq == null || $scope.matq == undefined || $scope.matq == NaN) {
                                $scope.matq = 0;
                            }
                            var response = $http({
                                method: "PUT",
                                url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                                data: {
                                    _id: value2.id,
                                    OnHold: $scope.maoh,
                                    TotalQuantity: $scope.matq,
                                    UpdatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                    });

                    if ($scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != undefined) {
                        $scope.SerialNumber = $scope.vm.mSerialNumber.split(",");
                        angular.forEach($scope.SerialNumber, function (value) {
                            angular.forEach($scope.Goodsdatas, function (Gvalue) {
                                if (value == Gvalue.SerialNumber && $scope.vm.mProductCode == Gvalue.ProductCode) {
                                    var response = $http({
                                        method: "PUT",
                                        url: $rootScope.WebURL + "/goods/updateIssue",
                                        data: {
                                            _id: Gvalue.id,
                                            Status: "Issued",
                                            Customer: $scope.Customer,
                                            Location: $scope.Location,
                                            StartDate: $scope.RatsanseStartDate,
                                            EndDate: $scope.RatsanseEndDate,
                                            UpdatedBy: $rootScope.LoginID,
                                        },
                                    });
                                }
                            });
                        });
                    }
                }
                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                RefreshMaterialGrid();
                RefreshStockListGrid();
                RefreshGoodsGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Materialupdate = function (e, RMaterialId) {
            $scope.MUpdate = true;
            $scope.MID = RMaterialId;
            try {
                var item1 = $scope.Materialdatas.filter(function (item1) {
                    return item1._id === RMaterialId;
                })[0];
                $scope.id = item1._id;
                $scope.UniqueID = item1.UniqueID;
                $scope.vm.mType = item1.ProductType;
                $scope.vm.mExpectedReturnDate = item1.ExpectedReturnDate;
                if ($scope.vm.mExpectedReturnDate != null && $scope.vm.mExpectedReturnDate != "") {
                    $scope.vm.mExpectedReturnDate = new Date(item1.ExpectedReturnDate);
                }
                $scope.vm.mStore = item1.StoreName;
                $scope.vm.mProductCategory = item1.ProductCategory;
                $scope.vm.mMaterial = item1.ProductName;
                $scope.vm.mProductCode = item1.ProductCode;
                $scope.vm.mDescription = item1.Description;
                $scope.vm.oQuantityRequired = parseFloat(item1.QuantityRequired);
                $scope.vm.mQuantityRequired = parseFloat(item1.QuantityRequired);
                $scope.vm.mUnits = item1.Unit;
                $scope.Model = item1.Model;
                $scope.vm.mSerialNumber = item1.SerialNumber;
                if ($scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != undefined) {
                    var rqnarray = $scope.vm.mSerialNumber.split(",");
                    var rqnarray1 = [];
                    angular.forEach(rqnarray, function (svalue) {
                        rqnarray1.push(svalue);
                    });
                    $scope.vm.mSerialNumber = rqnarray1;
                }
                var gTotal = 0.00;
                if ($scope.Update == true) {
                    angular.forEach($scope.Goodsuniquedatas, function (Gvalue) {
                        if ($scope.vm.mStore == Gvalue.StoreName && $scope.vm.mProductCategory == Gvalue.ProductCategory && $scope.vm.mProductCode == Gvalue.ProductCode) {
                            if (Gvalue.TotalQuantity != "" && Gvalue.TotalQuantity != null && Gvalue.TotalQuantity != undefined) {
                                gTotal = parseFloat(Gvalue.TotalQuantity) + parseFloat($scope.vm.oQuantityRequired);
                            }
                        }
                    });
                }
                else {
                    angular.forEach($scope.Goodsuniquedatas, function (Gvalue) {
                        if ($scope.vm.mStore == Gvalue.StoreName && $scope.vm.mProductCategory == Gvalue.ProductCategory && $scope.vm.mProductCode == Gvalue.ProductCode) {
                            if (Gvalue.TotalQuantity != "" && Gvalue.TotalQuantity != null && Gvalue.TotalQuantity != undefined) {
                                gTotal = parseFloat(Gvalue.TotalQuantity);
                            }
                        }
                    });
                }
                if (gTotal < 0 || gTotal == "" || gTotal == null || gTotal == undefined || gTotal == NaN) {
                    gTotal = 0;
                }
                $scope.vm.mStockQuantity = gTotal;

                $scope.ProductNamedetails();
                $scope.SerialNoArraydetails();
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/materialrequisition/material.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MaterialRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SerialNoArraydetails = function () {
            var response = $http({
                url: $rootScope.WebURL + "/goods/getByCategory",
                method: "POST",
                data: { Client_Id: Client_Id, Status: "New", StoreName: $scope.vm.mStore, ProductCategory: $scope.vm.mProductCategory, ProductName: $scope.vm.mMaterial },
            });
            response.then(function (Serialdata) {
                $scope.SerialCategorydatas = Serialdata.data.data;
                try {
                    $scope.SerialNoArray = $scope.SerialCategorydatas[0].SerialNumber;
                } catch (err) { }
            });
        }

        $scope.Materialdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/materialrequisition/materialdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function MaterialRequisitionController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Mdelete = function (deleteID) {
            try {
                var item = $scope.Materialdatas.filter(function (item) {
                    return item._id === deleteID;
                })[0];
                $scope.vm.mStore = item.StoreName;
                $scope.vm.mProductCategory = item.ProductCategory;
                $scope.vm.mMaterial = item.ProductName;
                $scope.vm.mProductCode = item.ProductCode;
                $scope.vm.mSerialNumber = item.SerialNumber;
                $scope.vm.mQuantityRequired = parseFloat(item.QuantityRequired);
            } catch (e) { }

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/material/delete",
                data: { _id: deleteID },
            });
            response.then(function (GList) {
                angular.forEach($scope.Goodsuniquedatas, function (value2) {
                    if ($scope.vm.mStore == value2.StoreName && $scope.vm.mProductCategory == value2.ProductCategory && $scope.vm.mProductCode == value2.ProductCode) {
                        $scope.doh = (parseFloat(value2.OnHold) - parseFloat($scope.vm.mQuantityRequired));
                        if ($scope.doh < 0 || $scope.doh == "" || $scope.doh == null || $scope.doh == undefined || $scope.doh == NaN) {
                            $scope.doh = 0;
                        }
                        $scope.dtq = (parseFloat(value2.TotalQuantity) + parseFloat($scope.vm.mQuantityRequired));
                        if ($scope.dtq < 0 || $scope.dtq == "" || $scope.dtq == null || $scope.dtq == undefined || $scope.dtq == NaN) {
                            $scope.dtq = 0;
                        }
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/goodsunique/updateOnHold",
                            data: {
                                _id: value2.id,
                                OnHold: $scope.doh,
                                TotalQuantity: $scope.dtq,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                });

                if ($scope.vm.mSerialNumber != "" && $scope.vm.mSerialNumber != null && $scope.vm.mSerialNumber != undefined) {
                    $scope.DSerialNumber = $scope.vm.mSerialNumber.split(",");
                    angular.forEach($scope.DSerialNumber, function (value) {
                        angular.forEach($scope.Goodsdatas, function (Gvalue) {
                            if (value == Gvalue.SerialNumber && $scope.vm.mProductCode == Gvalue.ProductCode) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/goods/updateIssue",
                                    data: {
                                        _id: Gvalue.id,
                                        Status: "New",
                                        Customer: $scope.Customer,
                                        Location: $scope.Location,
                                        StartDate: $scope.RatsanseStartDate,
                                        EndDate: $scope.RatsanseEndDate,
                                        UpdatedBy: $rootScope.LoginID,
                                    },
                                });
                            }
                        });
                    });
                }
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshMaterialGrid();
                RefreshStockListGrid();
                RefreshGoodsGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function RefreshMaterialGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/material/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Materialdata) {
                $scope.Materialdatas = Materialdata.data.data;
            });
        }

        function RefreshCategory() {
            var response = $http({
                url: $rootScope.WebURL + "/category",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Categorydata) {
                $scope.ProductCategorydatas = Categorydata.data.data;
            });
        }

        function RefreshUnit() {
            var response = $http({
                url: $rootScope.WebURL + "/unit",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Unitdata) {
                $scope.Unitdatas = Unitdata.data.data;
            });
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "StockRequest.aspx?ID=" + PId;
            window.open(url);
        };

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.product', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.product', {
            url: '/Products',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/product/product.html',
                    controller: 'ProductController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.procurement.product')
        .controller('ProductController', ProductController);


    function ProductController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, $state, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("ProcurementSettings")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshUnit();
        RefreshCategory();

        $scope.categoryExport = true;
        $scope.unitExport = false;
        $scope.paymenttermExport = false;
        $scope.tagExport = false;
        $scope.defineExport = false;
        $scope.Update = false;
        $scope.SearchDetails = "";
        $scope.model = {};

        $scope.Categories = function () {
            $scope.categoryExport = true;
            $scope.unitExport = false;
            $scope.paymenttermExport = false;
            $scope.tagExport = false;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearCategory();
            RefreshCategory();
        }
        $scope.cExport = function () {
            alasql('SELECT * INTO XLSX("Tags.xlsx",{headers:true}) FROM ?', [$scope.Chemicaldatas]);
        };

        $scope.Units = function () {
            $scope.categoryExport = false;
            $scope.unitExport = true;
            $scope.paymenttermExport = false;
            $scope.tagExport = false;
            $scope.defineExport = false;
            $scope.SearchDetails = "";
            ClearUnit();
            RefreshUnit();
        }
        $scope.uExport = function () {
            alasql('SELECT * INTO XLSX("Defines.xlsx",{headers:true}) FROM ?', [$scope.Equipmentdatas]);
        };

        $scope.saveCategory = function () {

            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/chemical/update",
                    data: {
                        _id: $scope.SID,
                        Category: $scope.model.CategoryName,
                        ChemicalName: $scope.model.ChemicalName,
                        CProductCode: $scope.vm.CProductCode,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing ChemicalName") {
                        $mdToast.show($mdToast.simple().textContent('Already Existing!').position('top center'));
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        $scope.Categorydatas[$scope.IndexID] = GList.data.data;
                        $scope.Update = false;
                        RefreshCategory();
                        ClearCategory();
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var y = ($scope.Categorydatas.length + 1).toString().padStart(5, '0')
                $scope.vm.CProductCode = 'C-' + y
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/chemical/add",
                    data: {
                        Client_Id: Client_Id,
                        Category: $scope.model.CategoryName,
                        ChemicalName: $scope.model.ChemicalName,
                        CProductCode: $scope.vm.CProductCode,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing ChemicalName") {
                        $mdToast.show($mdToast.simple().textContent('Already Existing!').position('top center'));
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshCategory();
                        ClearCategory();
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Categoryinfo = function (CategoryId, Category, Chemical, CProductCode, $index) {
            $scope.SID = CategoryId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.CategoryinfoId = CategoryId;
            try {
                $scope.model.CategoryName = Category;
                $scope.model.ChemicalName = Chemical;
                $scope.vm.CProductCode = CProductCode;
            } catch (err) { }
        }

        function RefreshCategory() {
            var response = $http({
                url: $rootScope.WebURL + "/chemical",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Categorydata) {
                $scope.Categorydatas = Categorydata.data.data;
            });
            $scope.Update = false;
        }

        function ClearCategory() {
            $scope.model.CategoryName = '';
            $scope.model.ChemicalName = '';
            $scope.Categoryform.$setPristine();
            $scope.Categoryform.$setUntouched();
        }

        $scope.cancelCategory = function () {
            $scope.Update = false;
            ClearCategory();
        }

        $scope.saveUnit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/equipment/update",
                    data: {
                        _id: $scope.SID,
                        Category: $scope.model.ECategory,
                        EquipmentName: $scope.model.EquipmentName,
                        EManufacturer: $scope.model.EManufacturer,
                        ESerialNumber: $scope.model.ESerialNumber,
                        ELocation: $scope.model.ELocation,
                        ETakeOverDate: $scope.model.ETakeOverDate,
                        ERemarks: $scope.model.ERemarks,
                        EProductCode: $scope.vm.EProductCode,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing Equipment Name") {
                        $mdToast.show($mdToast.simple().textContent('Already Existing!').position('top center'));
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        $scope.Equipmentdatas[$scope.IndexID] = GList.data.data;
                        $scope.Update = false;
                        RefreshUnit();
                        ClearUnit();
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/equipment/add",
                    data: {
                        Client_Id: Client_Id,
                        Category: $scope.model.ECategory,
                        EquipmentName: $scope.model.EquipmentName,
                        EManufacturer: $scope.model.EManufacturer,
                        ESerialNumber: $scope.model.ESerialNumber,
                        EProductCode: $scope.vm.EProductCode,
                        ELocation: $scope.model.ELocation,
                        ETakeOverDate: $scope.model.ETakeOverDate,
                        ERemarks: $scope.model.ERemarks,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing Equipment Name") {
                        $mdToast.show($mdToast.simple().textContent('Already Existing!').position('top center'));
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        RefreshUnit();
                        ClearUnit();
                    }

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Unitinfo = function (UnitId, Category, Equipment, EManufacturer, ESerialNumber, EProductCode, ELocation, ETakeOverDate, ERemarks, $index) {
            $scope.SID = UnitId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.UnitinfoId = UnitId;
            try {
                $scope.model.ECategory = Category;
                $scope.model.EquipmentName = Equipment;
                $scope.model.EManufacturer = EManufacturer,
                    $scope.model.ESerialNumber = ESerialNumber,
                    $scope.vm.EProductCode = EProductCode,
                    $scope.model.ELocation = ELocation,
                    $scope.model.ETakeOverDate = ETakeOverDate,
                    $scope.model.ERemarks = ERemarks
            } catch (err) { }
        }

        function RefreshUnit() {
            var response = $http({
                url: $rootScope.WebURL + "/equipment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Unitdata) {
                $scope.Equipmentdatas = Unitdata.data.data;
                // var c = $scope.Equipmentdatas.length + 1
                // $scope.model.EProductCode = 'E-' + ('00000' + c).slice(-5);
                var y = ($scope.Equipmentdatas.length + 1).toString().padStart(5, '0')
                $scope.vm.EProductCode = 'E-' + y
            });
            $scope.Update = false;

        }

        function ClearUnit() {
            $scope.model.ECategory = '';
            $scope.model.EquipmentName = '';
            $scope.model.EManufacturer = "",
                $scope.model.ESerialNumber = "",
                $scope.model.ELocation = "",
                $scope.model.ETakeOverDate = "",
                $scope.model.ERemarks = "",
                $scope.Unitform.$setPristine();
            $scope.Unitform.$setUntouched();
        }

        $scope.cancelUnit = function () {
            $scope.Update = false;
            ClearUnit();
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#Datasearch');
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.procurement.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.procurement_dashboard', {
            url      : '/DashboardInventry',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/dashboard/dashboard-procurement.html',
                    controller: 'DashboardProcurementController as vm'
                }
            },
            resolve: {
                DashboardData: function (msApi) {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();


(function () {
    'use strict';

    angular
        .module('app.procurement.dashboard')
        .controller('DashboardProcurementController', DashboardProcurementController);

    /** @ngInject */
    function DashboardProcurementController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {
        document.getElementsByTagName('title')[0].text = "Procurement-Dashboard"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DProcurement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $scope.totalEquipmentRequests = 0;
        $scope.totalChemicalRequests = 0;
        $scope.totalEquipmentLists = 0;
        $scope.totalChemicalLists = 0;
        $scope.ChemcialOvertakerList = []
        $scope.Legend = []
        RefreshEquipmentRequestGrid();
        RefreshChemicalRequestGrid();
        RefreshEquipmentListGrid();
        RefreshChemicalListGrid();

        $scope.Goodsuniquedatas = [];
        $scope.Minimumdetaildatas = [];
        //RefreshGoodsuniqueGrid();

        function RefreshEquipmentRequestGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/equipmentrequest/getTotalDatas",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Purchaseorderdata) {
                $scope.totalEquipmentRequests = Purchaseorderdata.data.data;
            });
        }

        function RefreshChemicalRequestGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chemicalrequest/getTotalDatas",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Purchaseorderdata) {
                $scope.totalChemicalRequests = Purchaseorderdata.data.data;
            });
        }

        function RefreshEquipmentListGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Equipment/getTotalDatas",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Equipmentdata) {
                $scope.totalEquipmentLists = Equipmentdata.data.data;
            });
        }
        var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/chemical",
            data: { Client_Id: Client_Id },
        });
        response.then(function (Storedata) {
            var data = Storedata.data.data;
            var data1 = data.filter(function (item) {
                return item.Remarks != "On-Hold"
            })
            $scope.Chemicaldatas = data1;
            var item = Storedata.data.data.filter(function (item) {
                return item.Threshold > item.CurrentStock
            })
            $scope.Minimumdetaildatas = item;

        });
        function RefreshChemicalListGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chemical/getTotalDatas",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Chemicaldata) {
                $scope.totalChemicalLists = Chemicaldata.data.data;
            });
        }

        function RefreshGoodsuniqueGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
                $scope.StockList();
            });
        }

        $scope.StockList = function () {
            var Minimumdetail = [];
            angular.forEach($scope.Goodsuniquedatas, function (value) {
                $scope.vt = parseInt(value.TotalQuantity);
                $scope.vr = parseInt(value.ReorderQuantity);
                if ($scope.vt < $scope.vr) {
                    Minimumdetail.push({
                        id: value.id,
                        StoreName: value.StoreName,
                        ProductCategory: value.ProductCategory,
                        ProductCode: value.ProductCode,
                        ProductName: value.ProductName,
                        Description: value.Description,
                        TotalQuantity: value.TotalQuantity,
                        ReorderQuantity: value.ReorderQuantity,
                        Unit: value.Unit,
                    })
                }
            });
            $scope.totalLowonStock = Minimumdetail.length;
        }

        $scope.goToRequestPage = function (state) {
            $state.go(state)
        }

        var vm = this;
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;
        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index) {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title: vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title: vm.dashboardData.widget9.title,
            weeklySpent: {
                title: vm.dashboardData.widget9.weeklySpent.title,
                count: vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent: {
                title: vm.dashboardData.widget9.totalSpent.title,
                count: vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining: {
                title: vm.dashboardData.widget9.remaining.title,
                count: vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget: vm.dashboardData.widget9.totalBudget,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#00BCD4'],
                        height: 50,
                        margin: {
                            top: 8,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yDomain: [0, 9],
                        xAxis: {
                            tickFormat: function (d) {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key: vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key: vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key: vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title: vm.dashboardData.widget11.title,
            table: vm.dashboardData.widget11.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                order: [1, 'asc'],
                columnDefs: [
                    {
                        width: '40',
                        orderable: false,
                        targets: [0]
                    },
                    {
                        width: '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        $scope.ChemicalRanges = {
            TW: "Last Month",
            LW: "Last 2 Months ago",
            FW: "Last 3 Months ago"
        }


        vm.widget5 = {
            title: vm.dashboardData.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true

                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        // color       : ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        showControls: false,
                        clipEdge: true,
                        groupSpacing: 0.1,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },

                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            ranges: $scope.ChemicalRanges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                // angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                // {
                //     vm.widget5.mainChart.data[index] = {
                //         key   : chartData.key,
                //         values: chartData.values[range]
                //     };
                // });
                $scope.ChemcialOvertakerList = $scope.ChemicalOvertaken[range]
                $scope.Legend = _.uniqBy(_.flattenDeep($scope.SeriesLegend[range]), "name")
            },
            init: function () {
                vm.widget5.changeRange('TW');
            }
        };
        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;
        $scope.chartOptions = {
            dataSource: $scope.ChemcialOvertakerList,
            commonSeriesSettings: {
                argumentField: "state",
                type: "stackedBar"
            },
            series: $scope.Legend,
            legend: {
                verticalAlignment: "bottom",
                horizontalAlignment: "center",
                itemTextPosition: 'top'
            },
            valueAxis: {
                title: {
                    text: "Chemicals"
                },
                position: "right"
            },
            // title: "Male Age Structure",
            "export": {
                enabled: true
            },
            tooltip: {
                enabled: true,
                location: "edge",
                customizeTooltip: function (arg) {
                    return {
                        text: arg.seriesName + "  - " + arg.valueText
                    };
                }
            },
            bindingOptions: {
                dataSource: "ChemcialOvertakerList",
                series: "Legend",
            }
        };
        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5


        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
        var FinalResult = {
            TW: [],
            LW: [],
            FW: [],
        }
        // var StartDate = new Date(new Date().getFullYear(), new Date().getMonth()-3,1)
        // var EndDate =  new Date(new Date().getFullYear(), new Date().getMonth(),0)

        //     var response = $http({
        //         method: "POST",
        //         url:  $rootScope.WebURL + "/chemicalrequest/datefilter",
        //         data: { Client_Id: Client_Id , StartDate:StartDate , EndDate:EndDate},
        //     });
        //     response.then(function (Chemicaldata) {
        //         var data = []
        //         var ChemicalOverTakenLists = Chemicaldata.data.data;
        //         angular.forEach(ChemicalOverTakenLists,function(item){
        //             angular.forEach(item.ChemicalItems,function(item1){
        //                 item1.RequestedBy = item.RequestedBy
        //                 item1.RequestedDate = item.UpdatedDate
        //                 data.push( item1)
        //             })
        //         })
        //         var data1 = _.groupBy(data,"RequestedBy")
        //         var data1byChe = Object.keys(_.groupBy(data,"Chemical"))
        //         _.each(data1byChe,function(ttem){
        //             _.each(data1,function(ttem1){
        //                 if(!ttem.includes(ttem1.Chemical)){
        //                     ttem1.push({
        //                         Chemical:ttem,
        //                         Quantity:0
        //                     })
        //                 }
        //             })
        //         })
        //         angular.forEach(data1,function(item,key){
        //             var data2 = _.groupBy(item,"Chemical")
        //             var array = []
        //             angular.forEach(data2,function(val,key1){
        //                 array.push({
        //                     x:key1,
        //                     y:_.sumBy(val,"Quantity")
        //                 }) 
        //             })
        //             FinalResult.TW.push({
        //                 key:key,
        //                 values:array
        //             })
        //         })

        //         var item = data.filter(function(item){
        //             return item.RequestedDate>=new Date(new Date(new Date().getFullYear(), new Date().getMonth()-2,1).setHours(0,0,0,0)) && new Date(new Date(new Date().getFullYear(), new Date().getMonth(),0).setHours(23,59,59,999))>=item.RequestedDate
        //         })
        //         data1 = _.groupBy(item,"RequestedBy")
        //         angular.forEach(data1,function(item,key){
        //             var data2 = _.groupBy(item,"Chemical")
        //             var array = []
        //             angular.forEach(data2,function(val,key1){
        //                 array.push({
        //                     x:key1,
        //                     y:_.sumBy(val,"Quantity")
        //                 }) 
        //             })
        //             FinalResult.TW.push({
        //                 key:key,
        //                 values:array
        //             })
        //         })

        //         var item = data.filter(function(item){
        //             return item.RequestedDate>=new Date(new Date(new Date().getFullYear(), new Date().getMonth()-1,1).setHours(0,0,0,0)) && new Date(new Date(new Date().getFullYear(), new Date().getMonth(),0).setHours(23,59,59,999))>=item.RequestedDate
        //         })
        //         data1 = _.groupBy(item,"RequestedBy")
        //         angular.forEach(data1,function(item,key){
        //             var data2 = _.groupBy(item,"Chemical")
        //             FinalResult.TW.key=key
        //             angular.forEach(data2,function(val,key1){
        //                 FinalResult.TW.values.push({
        //                     x:key1,
        //                     y:_.sumBy(val,"Quantity")
        //                 }) 
        //             })
        //         })


        //         $scope.ChemicalOvertaken = FinalResult
        //         vm.widget5.init();
        //     });
        $scope.SeriesLegend = {
            TW: [],
            LW: [],
            FW: [],
        }
        var StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1)
        var EndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0)

        var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/chemicalrequest/datefilter",
            data: { Client_Id: Client_Id, StartDate: StartDate, EndDate: EndDate },
        });
        response.then(function (Chemicaldata) {
            var data = []
            var ChemicalOverTakenLists = Chemicaldata.data.data;
            angular.forEach(ChemicalOverTakenLists, function (item) {
                angular.forEach(item.ChemicalItems, function (item1) {
                    item1.RequestedBy = item.RequestedBy
                    item1.RequestedDate = item.UpdatedDate
                    data.push(item1)
                })
            })
            var data1 = _.groupBy(data, "Chemical")
            var Legend = []
            var dataCH = []
            var Legend1 = Object.keys(_.groupBy(data, "Chemical"))
            angular.forEach(Legend1, function (data) {
                Legend.push({
                    valueField: data,
                    name: data
                })
            })
            angular.forEach(data1, function (item, key) {
                var dataC = []
                var data2 = _.groupBy(item, "RequestedBy")
                _.each(data2, function (item1, key1) {
                    angular.forEach(item1, function (val) {
                        val.Quantity = parseInt(val.Quantity)
                    })
                    dataC[key] = _.sumBy(item1, "Quantity")
                    dataC.state = key1
                })

                dataCH.push(Object.assign({}, dataC))
            })
            FinalResult.FW = dataCH
            $scope.SeriesLegend.FW.push(Legend)
            var StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)
            var EndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0)

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chemicalrequest/datefilter",
                data: { Client_Id: Client_Id, StartDate: StartDate, EndDate: EndDate },
            });
            response.then(function (Chemicaldata) {
                var data = []
                var ChemicalOverTakenLists = Chemicaldata.data.data;
                angular.forEach(ChemicalOverTakenLists, function (item) {
                    angular.forEach(item.ChemicalItems, function (item1) {
                        item1.RequestedBy = item.RequestedBy
                        item1.RequestedDate = item.UpdatedDate
                        data.push(item1)
                    })
                })
                var data1 = _.groupBy(data, "Chemical")
                var Legend = []
                var dataCH = []
                angular.forEach(data1, function (item, key) {
                    var dataC = []
                    var data2 = _.groupBy(item, "RequestedBy")
                    _.each(data2, function (item1, key) {
                        Legend.push({
                            valueField: key,
                            name: key
                        })
                    })
                    angular.forEach(data2, function (val, key1) {
                        dataC[key1] = _.sumBy(val, "Quantity")
                    })
                    dataC.state = key
                    dataCH.push(Object.assign({}, dataC))
                })
                FinalResult.LW = dataCH
                $scope.SeriesLegend.LW.push(Legend)
                var StartDate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
                var EndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0)

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/chemicalrequest/datefilter",
                    data: { Client_Id: Client_Id, StartDate: StartDate, EndDate: EndDate },
                });
                response.then(function (Chemicaldata) {
                    var data = []
                    var ChemicalOverTakenLists = Chemicaldata.data.data;
                    angular.forEach(ChemicalOverTakenLists, function (item) {
                        angular.forEach(item.ChemicalItems, function (item1) {
                            item1.RequestedBy = item.RequestedBy
                            item1.RequestedDate = item.UpdatedDate
                            data.push(item1)
                        })
                    })
                    var data1 = _.groupBy(data, "Chemical")
                    var Legend = []
                    var dataCH = []
                    angular.forEach(data1, function (item, key) {
                        var dataC = []
                        var data2 = _.groupBy(item, "RequestedBy")
                        _.each(data2, function (item1, key) {
                            Legend.push({
                                valueField: key,
                                name: key
                            })
                        })
                        angular.forEach(data2, function (val, key1) {
                            dataC[key1] = _.sumBy(val, "Quantity")
                        })
                        dataC.state = key
                        dataCH.push(Object.assign({}, dataC))
                    })
                    FinalResult.TW = dataCH
                    $scope.SeriesLegend.TW.push(Legend)
                    $scope.ChemicalOvertaken = FinalResult
                    vm.widget5.init();
                })
            })
        })

    }

})();


(function () {
    'use strict';

    angular
        .module('app.procurement.Chemicalrequest', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.Chemicalrequest', {
            url: '/ChemicalRequest',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/chemicalrequest/chemicalrequest.html',
                    controller: 'ChemicalRequestController as vm'
                }
            }
        });
    }

})();



(function () {
    'use strict';

    angular
        .module('app.procurement.Chemicalrequest')
        .controller('ChemicalRequestController', ChemicalRequestController);

    function ChemicalRequestController($mdDateLocale, $scope, $rootScope, socket, $interval, $mdSidenav, $mdToast, $location, $mdDialog, $document, $filter, $q, $http, $window, $log, Upload) {
        document.getElementsByTagName('title')[0].text = "Procurement-Chemical Request"
        var chkAceses = localStorage.getItem('pages');
        var EmpID = localStorage.getItem('EmployeeID');
        if (chkAceses.split(",").includes("ChemicalRequest")) {   // do nothing 
        }
        // else { $location.path("NoAccess"); }
        $scope.chemicalrequestGrid = true;
        $scope.exportbtn = true;
        $scope.chemicalrequestform = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;

        $scope.Viewclk = function () {
            $scope.chemicalrequestform = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false
            $scope.chemicalrequestGrid = true;
        }

        $scope.cancelbtnclk = function () {
            $scope.chemicalrequestform = false;
            $scope.chemicalrequestGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.cancel = function () {
            $mdDialog.cancel()
        }

        $scope.Showgrid = function () {
            $scope.chemicalrequestGrid = true;
            $scope.chemicalrequestform = false;
            $scope.ChemicalReqInfo = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            RefreshGrid();
        }

        $scope.addnameclk = function () {
            $scope.Update = false;
            $scope.chemicalrequestform = true;
            $scope.chemicalrequestGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.error1 = false;
            $scope.vm.Category = null
            $scope.vm.ChemicalName = null
            $scope.vm.ProductCode = null
            $scope.vm.Quantity = ""
            $scope.vm.Unit = ""
            $scope.vm.AssignedTo = null
            $scope.Chemicalsdatas = []
            $scope.CUpdate = false
            $scope.ChemicalItemdatas = []
            try {
                var item = $scope.Employeedatas.filter(function (item) {
                    return EmpID === item.EmployeeID
                })[0]
                $scope.vm.RequestedBy = item.EmployeeID + '-' + item.EmployeeName
                $scope.vm.JobPosition = item.EDesignation
                $scope.vm.ContactNumber = item.Mobile
                $scope.vm.RequestedDate = new Date()
                $scope.vm.Remarks = ""
                $scope.vm.VehicleNumber = ""
                $scope.Unitform.$setPristine();
                $scope.Unitform.$setUntouched();
            }
            catch (e) { }
        }

        $scope.GetChemcials = function (Category) {
            var item = $scope.ChemicalListdatas.filter(function (item) {
                return item.Category === Category
            })
            $scope.Chemicalsdatas = item
        }

        $scope.chemicalrequestinfo = function (chemicalrequestId) {

            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = chemicalrequestId;
            $scope.Update = true;
            $scope.ChemicalReqInfo = true;
            $scope.chemicalrequestform = false;
            $scope.chemicalrequestGrid = false;
            $scope.chemicalrequestinfoId = chemicalrequestId;
            var info = $scope.chemicalrequestdatas
            var item = info.filter(function (item) {
                return item.id === $scope.SID
            })[0]
            $scope.vm.Status = item.Status
            $scope.vm.ReferenceNo = item.ReferenceNo
            $scope.vm.RequestedBy = (item.RequestedBy)
            $scope.vm.JobPosition = (item.JobPosition)
            $scope.vm.ContactNumber = (item.ContactNumber)
            $scope.vm.RequestedDate = new Date(item.RequestedDate)
            $scope.vm.Remarks = item.Remarks
            $scope.vm.VehicleNumber = item.VehicleNumber
            $scope.ChemicalItemdatas = item.ChemicalItems
            $scope.vm.TeamName = item.Teamdetails[0].TeamName
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/chemicalrequest/update",
                    data: {
                        _id: $scope.SID,
                        RequestedBy: $scope.vm.RequestedBy,
                        JobPosition: $scope.vm.JobPosition,
                        VehicleNumber: $scope.vm.VehicleNumber,
                        TeamID: $scope.vm.AssignedTo,
                        ContactNumber: $scope.vm.ContactNumber,
                        RequestedDate: $scope.vm.RequestedDate,
                        Remarks: $scope.vm.Remarks,
                        ChemicalItems: $scope.ChemicalItemdatas,
                        UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.chemicalrequestGrid = true;
                    $scope.chemicalrequestform = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;
                    $scope.addbtn = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/chemicalrequest/add",
                    data: {
                        RequestedBy: EmpID,
                        JobPosition: $scope.vm.JobPosition,
                        VehicleNumber: $scope.vm.VehicleNumber,
                        ContactNumber: $scope.vm.ContactNumber,
                        RequestedDate: $scope.vm.RequestedDate,
                        TeamID: $scope.vm.AssignedTo,
                        Remarks: $scope.vm.Remarks,
                        ChemicalItems: $scope.ChemicalItemdatas,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.chemicalrequestGrid = true;
                    $scope.chemicalrequestform = false;
                    $scope.addbtn = true;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.FExport = function () {
            alasql('SELECT * INTO XLSX("Chemicalrequestdatas.xlsx",{headers:true}) FROM ?', [$scope.chemicalrequestdatas]);
        };

        $scope.RequestAccepted = function () {
            try {
                var data = _.groupBy($scope.ChemicalItemdatas, "ItemId")
                var data1 = []
                angular.forEach(data, function (item, key) {
                    data1.push({
                        Quantity: _.sumBy(item, 'Quantity'),
                        ItemId: key,
                        Chemical: item[0].Chemical
                    })
                })

                for (var i = 0; i < data1.length; i++) {
                    var item = $scope.ChemicalListdatas.filter(function (item) {
                        return item._id === data1[i].ItemId
                    })[0]
                    if (item != undefined) {
                        if (data1[i].Quantity > parseInt(item.CurrentStock)) {
                            $mdToast.show($mdToast.simple().textContent('Requested Quantity of ' + data1[i].Chemical + ' is greater than current stock!').position('top center'))
                            break;
                        }
                        else {
                            if (i + 1 == data1.length) {
                                var result = DevExpress.ui.dialog.confirm("Are you sure you want to accept this request?", "Confirm changes");
                                result.done(function (dialogResult) {
                                    if (dialogResult) {
                                        var response = $http({
                                            method: "PUT",
                                            url: $rootScope.WebURL + "/chemicalrequest/requestchange",
                                            data: {
                                                _id: $scope.SID,
                                                ChemcialList: data1,
                                                CreatedBy: $rootScope.createdby
                                            },
                                        });
                                        response.then(function (Glist) {
                                            $mdToast.show($mdToast.simple().textContent('Request Accepted!').position('top center'));
                                            RefreshGrid();
                                            $scope.chemicalrequestGrid = true;
                                            $scope.chemicalrequestform = false;
                                            $scope.ChemicalReqInfo = false;
                                            $scope.addbtn = true;
                                            $scope.viewbtn = false;
                                            $scope.exportbtn = true;
                                            $scope.Search = true;
                                            $http.get($rootScope.WebURL + "/chemicalrequest/newCount")
                                                .then(function (chemical) {
                                                    var ChemicalCount = chemical.data.data;
                                                    sessionStorage.setItem('ChemicalCount', ChemicalCount)
                                                    var element = document.getElementsByClassName('badge white-fg')
                                                    angular.forEach(element, function (ele) {
                                                        if ((ele.parentElement.innerText).includes('Chemical Request')) {
                                                            ele.innerText = ChemicalCount
                                                        }
                                                    })
                                                });
                                        })
                                    }
                                });
                            }
                        }
                    }
                }

            } catch (error) {

            }
        }

        $scope.RequestRejected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to reject this request?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/chemicalrequest/requestchange",
                        data: {
                            _id: $scope.SID,
                            ChemcialList: [],
                            CreatedBy: $rootScope.createdby
                        },
                    });
                    response.then(function (Glist) {
                        $mdToast.show($mdToast.simple().textContent('Request Rejected!').position('top center'));
                        RefreshGrid();
                        $scope.chemicalrequestGrid = true;
                        $scope.chemicalrequestform = false;
                        $scope.ChemicalReqInfo = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                        $http.get($rootScope.WebURL + "/chemicalrequest/newCount")
                            .then(function (chemical) {
                                var ChemicalCount = chemical.data.data;
                                sessionStorage.setItem('ChemicalCount', ChemicalCount)
                                var element = document.getElementsByClassName('badge white-fg')
                                angular.forEach(element, function (ele) {
                                    if ((ele.parentElement.innerText).includes('Chemical Request')) {
                                        ele.innerText = ChemicalCount
                                    }
                                })
                            });

                    })
                }
            });
        }
        RefreshGrid()

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/chemicalrequest",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (chemicalrequestdata) {
                $scope.chemicalrequestdatas = chemicalrequestdata.data.data;
            });
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/chemical",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Storedata) {
            $scope.ChemicalListdatas = Storedata.data.data;
        });

        $scope.dataGridOptions = {
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px;padding-bottom:10px;font-weight:bold;font-size:16px" class="textstyle_1">REQUESTED CHEMICALS</div>');
            },
            showBorders: true,
            paging: {
                enabled: false
            },
            editing: {
                allowUpdating: false,
                allowDeleting: false,
                allowAdding: false,
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    },
                },
                {
                    dataField: "Chemical",
                    caption: "Chemical Name",
                },
                // {
                //     dataField: "ProductCode",
                //     caption: "Product Code",
                // },
                // {
                //     dataField: "ChemicalName",
                //     caption: "Product Name",
                // },
                {
                    dataField: "Quantity",
                    caption: "Quantity",
                    calculateCellValue: function (rowData) {
                        if (rowData.Quantity != null && rowData.Quantity != undefined && rowData.Quantity != "")
                            return rowData.Quantity
                        else return 0;
                    }
                },
            ]
        };

        $scope.ViewRequestinfo = function (e, id) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/chemicalrequest/ViewChemicals.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function ChemicalRequestController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.ViewTable = true
            var info = $scope.chemicalrequestdatas
            var item = info.filter(function (item) {
                return item.id === id
            })[0]

            $scope.dataGridOptions.dataSource = item.ChemicalItems;
            // $scope.vm.ChemicalItems = "";
        }

        $scope.ChemicalItemdatas = []

        $scope.saveItems = function () {
            if ($scope.vm.Quantity > $scope.vm.Stock)
                return $mdToast.show($mdToast.simple().textContent('Requested Quantity of ' + $scope.vm.dDescription + ' is greater than current stock!').position('top center'))

            if ($scope.CUpdate == true) {
                $scope.ChemicalItemdatas[$scope.CIndex].Category = $scope.vm.Category
                $scope.ChemicalItemdatas[$scope.CIndex].Chemical = $scope.vm.dDescription
                $scope.ChemicalItemdatas[$scope.CIndex].ProductCode = $scope.vm.ProductCode
                $scope.ChemicalItemdatas[$scope.CIndex].Quantity = parseInt($scope.vm.Quantity)
                $scope.ChemicalItemdatas[$scope.CIndex].Unit = $scope.vm.Unit
                $scope.CUpdate = false
            }
            else
                $scope.ChemicalItemdatas.push({
                    ItemId: $scope.vm.ItemId,
                    Category: $scope.vm.Category,
                    Chemical: $scope.vm.dDescription,
                    ProductCode: $scope.vm.ProductCode,
                    Quantity: parseInt($scope.vm.Quantity),
                    Status: "New",
                    Unit: $scope.vm.Unit,
                })
            $scope.vm.Category = null;
            $scope.vm.ChemicalName = null;
            $scope.vm.Quantity = "";
            $scope.vm.Unit = "";
            $scope.vm.ProductCode = "";
            $scope.Chemicalsdatas = [];
            $scope.CUpdate = false;
            $mdDialog.cancel()
        }

        $scope.ItemInfo = function (Index) {
            $scope.CIndex = Index
            $scope.CUpdate = true
            $scope.vm.Category = $scope.ChemicalItemdatas[$scope.CIndex].Category
            $scope.vm.ChemicalName = $scope.ChemicalItemdatas[$scope.CIndex].Chemical
            $scope.vm.ProductCode = $scope.ChemicalItemdatas[$scope.CIndex].ProductCode
            $scope.vm.Quantity = parseInt($scope.ChemicalItemdatas[$scope.CIndex].Quantity)
            $scope.vm.Unit = $scope.ChemicalItemdatas[$scope.CIndex].Unit

            var item = $scope.ChemicalListdatas.filter(function (item) {
                return item.Category === $scope.vm.Category
            })
            $scope.Chemicalsdatas = item
        }


        $scope.DeleteItem = function (Index) {
            $scope.ChemicalItemdatas.splice(Index, 1)
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/chemicalrequest/update",
                    data: {
                        _id: $scope.SID,
                        RequestedBy: $scope.vm.RequestedBy,
                        JobPosition: $scope.vm.JobPosition,
                        VehicleNumber: $scope.vm.VehicleNumber,
                        ContactNumber: $scope.vm.ContactNumber,
                        RequestedDate: $scope.vm.RequestedDate,
                        Remarks: $scope.vm.Remarks,
                        ChemicalItems: $scope.ChemicalItemdatas,
                        UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.EditItem = function (index, quantity, e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/stock/Chemical/EditStock.html',
                parent: angular.element($document.body),
                multiple: true,
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ChemicalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.editIndex = index
            $scope.vm.Stock = parseInt(quantity)
        }

        $scope.UpdateStock = function () {
            $scope.ChemicalItemdatas[$scope.editIndex].Quantity = $scope.vm.Stock
            $mdDialog.cancel()
        }

        $scope.AddRecord = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/chemicalrequest/ViewChemicals.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function ChemicalRequestController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.ViewTable = false
            $scope.vm.dDescription = null;
            $scope.vm.Stock = null;
            $scope.vm.Quantity = null;
        }

        $http({
            url: $rootScope.WebURL + "/chemical",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Unitdata) {
            $scope.Chemicaldatas = Unitdata.data.data;
        });

        $http({
            url: $rootScope.WebURL + "/employee/detailsforTablet",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id, Employee_ID: EmpID },
        }).then(function (Unitdata) {
            $scope.Employeedatas = Unitdata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
        })

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };




        vm.dtOptions2 = {
            //dom: 'rt<"bottom">',
            dom: '',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        socket.on('Chemical Request Status Changed', function (data) {
            $http.get($rootScope.WebURL + "/chemicalrequest/newCount")
                .then(function (chemical) {
                    var ChemicalCount = chemical.data.data;
                    sessionStorage.setItem('ChemicalCount', ChemicalCount)
                    var element = document.getElementsByClassName('badge white-fg')
                    angular.forEach(element, function (ele) {
                        if ((ele.parentElement.innerText).includes('Chemical Request')) {
                            ele.innerText = ChemicalCount
                        }
                    })
                });
        })
    }


})();
(function () {
    'use strict';

    angular
        .module('app.procurement.equipmentrequest', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.equipmentrequest', {
            url: '/EquipmentRequest',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/procurement/EquipmentRequest/EquipmentRequest.html',
                    controller: 'EquipmentRequestController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';
    angular
        .module('app.procurement.equipmentrequest')
        .controller('EquipmentRequestController', EquipmentRequestController);


    /** @ngInject */
    function EquipmentRequestController($scope, $rootScope, $document, $interval, $mdDialog, $location, $mdSidenav, $mdToast, $http, moment, calendarConfig) {
        document.getElementsByTagName('title')[0].text = "Procurement-Equipment Request"
        var chkAceses = localStorage.getItem('pages');
        var EmpID = localStorage.getItem('EmployeeID');
        if (chkAceses.split(",").includes("EquipmentRequest")) {   // do nothing 
        }
        // else { $location.path("NoAccess"); }
        var Client_Id = $rootScope.Client_Id;
        $scope.EquipmentGrid = true;
        $scope.exportbtn = true;
        $scope.Equipmentform = false;
        $scope.EquipmentReqInfo = false;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.Search = true;

        $scope.Viewclk = function () {
            $scope.Equipmentform = false;
            $scope.EquipmentReqInfo = false;
            $scope.addbtn = true;
            $scope.exportbtn = true;
            $scope.viewbtn = false;
            $scope.EquipmentGrid = true;
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        }

        $scope.cancelbtnclk = function () {
            $scope.Equipmentform = false;
            $scope.EquipmentReqInfo = false;
            $scope.EquipmentGrid = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.exportbtn = true;
            $scope.Search = true;

        }

        $scope.Showgrid = function () {
            $scope.EquipmentGrid = true;
            $scope.Equipmentform = false;
            $scope.EquipmentReqInfo = false;
            $scope.exportbtn = true;
            $scope.addbtn = true;
            $scope.viewbtn = false;
            $scope.Search = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            RefreshGrid();
        }

        $scope.addnameclk = function () {
            ClearForm();
            ClearEquipment();
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Update = false;
            $scope.EUpdate = false;
            $scope.Equipmentform = true;
            $scope.EquipmentReqInfo = false;
            $scope.EquipmentGrid = false;
            $scope.exportbtn = false;
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.error1 = false;
            $scope.EquipmentItemdatas = [];
            $scope.Equipmentsdata = [];
            $scope.vm.Reference = $scope.ReferenceNo
            try {
                var item = $scope.Employeedatas.filter(function (item) {
                    return EmpID === item.EmployeeID
                })[0]
                $scope.vm.RequestedBy = item.EmployeeID + '-' + item.EmployeeName
                $scope.vm.JobPosition = item.EDesignation
                $scope.vm.ContactNumber = item.Mobile
                $scope.vm.RequestedDate = new Date()
                $scope.vm.Remarks = ""
                $scope.vm.VehicleNumber = ""
            }
            catch (e) { }
            RefreshGrid();
        }

        $scope.GetEquipments = function (Category) {
            var item = $scope.EquipmentListdatas.filter(function (item) {
                return item.Category === Category
            })
            $scope.Equipmentsdata = item
        }

        $scope.EquipmentInfo = function (Id) {
            ClearEquipment();
            RefreshGrid();
            $scope.viewbtn = true;
            $scope.addbtn = false;
            $scope.Search = false;
            $scope.exportbtn = false;
            $scope.SID = Id;
            $scope.Update = true;
            $scope.EUpdate = false;
            $scope.Equipmentform = false;
            $scope.EquipmentReqInfo = true;
            $scope.EquipmentGrid = false;
            var info = $scope.EquipmentRequestdatas
            var item = info.filter(function (item) {
                return item.id === $scope.SID
            })[0]
            $scope.vm.ReferenceNo = item.ReferenceNo;
            $scope.vm.RequestedBy = (item.RequestedBy);
            $scope.vm.RequestedDate = new Date(item.RequestedDate);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.VehicleNumber = item.VehicleNumber;
            $scope.vm.JobPosition = (item.JobPosition);
            $scope.vm.ContactNumber = (item.ContactNumber);
            if (item.Teamdetails.length > 0)
                $scope.vm.TeamName = item.Teamdetails[0].TeamName
            else
                $scope.vm.TeamName = null
            $scope.vm.Status = item.Status
            $scope.EquipmentLogform = true;
            // ClearEquipment();
            $scope.EquipmentItemdatas = item.EquipmentItems
        }

        $scope.fsubmit = function () {
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/equipmentrequest/update",
                    data: {
                        _id: $scope.SID,
                        RequestedBy: $scope.vm.RequestedBy,
                        RequestedDate: $scope.vm.RequestedDate,
                        ContactNumber: $scope.vm.ContactNumber,
                        JobPosition: $scope.vm.JobPosition,
                        TeamID: $scope.vm.AssignedTo,
                        Remarks: $scope.vm.Remarks,
                        VehicleNumber: $scope.vm.VehicleNumber,
                        EquipmentItems: $scope.EquipmentItemdatas,
                        UpdatedBy: $rootScope.createdby,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.EquipmentGrid = true;
                    $scope.Equipmentform = false;
                    $scope.EquipmentReqInfo = false;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;
                    $scope.addbtn = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/equipmentrequest/add",
                    data: {
                        RequestedBy: EmpID,
                        ReferenceNo: $scope.vm.Reference,
                        RequestedDate: $scope.vm.RequestedDate,
                        Remarks: $scope.vm.Remarks,
                        VehicleNumber: $scope.vm.VehicleNumber,
                        ContactNumber: $scope.vm.ContactNumber,
                        TeamID: $scope.vm.AssignedTo,
                        JobPosition: $scope.vm.JobPosition,
                        EquipmentItems: $scope.EquipmentItemdatas,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.EquipmentGrid = true;
                    $scope.Equipmentform = false;
                    $scope.addbtn = true;
                    $scope.viewbtn = false;
                    $scope.exportbtn = true;
                    $scope.Search = true;
                    $scope.Update = false

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });

            }
        }

        $scope.RequestRejected = function () {
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to reject this request?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/equipmentrequest/requestchange",
                        data: {
                            _id: $scope.SID,
                            EquipmentList: [],
                            RequestedBy: null,
                            CreatedBy: $rootScope.createdby
                        },
                    });
                    response.then(function (Glist) {
                        $mdToast.show($mdToast.simple().textContent('Request Rejected!').position('top center'));
                        RefreshGrid();
                        $scope.EquipmentGrid = true;
                        $scope.Equipmentform = false;
                        $scope.EquipmentReqInfo = false;
                        $scope.addbtn = true;
                        $scope.viewbtn = false;
                        $scope.exportbtn = true;
                        $scope.Search = true;
                        $scope.Update = false
                    })
                }
            });
        }

        $scope.RequestAccepted = function () {
            try {
                var data = []
                var EquipmentLog = []
                EquipmentLog.push({
                    Date: new Date(),
                    TechnicianName: $scope.vm.RequestedBy,
                    TechnicianContact: $scope.vm.ContactNumber
                })
                EquipmentLog = EquipmentLog.concat($scope.EqLogdetails)
                angular.forEach($scope.EquipmentItemdatas, function (item) {
                    data.push(item.ItemId)

                })
                var result = DevExpress.ui.dialog.confirm("Are you sure you want to accept this request?", "Confirm changes");
                result.done(function (dialogResult) {
                    if (dialogResult) {
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/equipmentrequest/requestchange",
                            data: {
                                _id: $scope.SID,
                                EquipmentList: data,
                                RequestedBy: $scope.vm.RequestedBy,
                                RecordLogdetails: EquipmentLog,
                                CreatedBy: $rootScope.createdby
                            },
                        });
                        response.then(function (Glist) {
                            $mdToast.show($mdToast.simple().textContent('Request Accepted!').position('top center'));
                            RefreshGrid();
                            $scope.EquipmentGrid = true;
                            $scope.EquipmentReqInfo = false;
                            $scope.Equipmentform = false;
                            $scope.addbtn = true;
                            $scope.viewbtn = false;
                            $scope.exportbtn = true;
                            $scope.Search = true;
                            $scope.Update = false

                        })
                    }
                });

            } catch (error) {

            }
        }

        $scope.EExport = function () {
            alasql('SELECT * INTO XLSX("EquipmentRequestdatas.xlsx",{headers:true}) FROM ?', [$scope.EquipmentRequestdatas]);
        };

        RefreshGrid();

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/equipmentrequest",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (equipmentRequestdata) {
                $scope.EquipmentRequestdatas = equipmentRequestdata.data.data;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
        })

        function ClearForm() {
            $scope.RequestedBy = null;
            $scope.RequestedDate = new Date();
            $scope.Remarks = null;
            $scope.VehicleNumber = null;
            $scope.ContactNumber = null;
            $scope.JobPosition = null;
        }

        $scope.Eqloginfo = function (Index) {
            $scope.CSID = Index;
            $scope.EUpdate = true;
            $scope.vm.Category = $scope.EquipmentItemdatas[$scope.CSID].Category
            $scope.vm.EquipmentName = $scope.EquipmentItemdatas[$scope.CSID].EquipmentName
            $scope.vm.Manufacturer = $scope.EquipmentItemdatas[$scope.CSID].Manufacturer
            $scope.vm.SerialNumber = $scope.EquipmentItemdatas[$scope.CSID].SerialNumber
            $scope.vm.ProductCode = $scope.EquipmentItemdatas[$scope.CSID].Code

            var item = $scope.EquipmentListdatas.filter(function (item) {
                return item.Category === $scope.vm.Category
            })
            $scope.Equipmentsdata = item
        }

        $scope.EquipmentItemdatas = []

        $scope.saveEquipment = function () {
            $scope.EqLogdetails = []
            angular.forEach(vm.dDescription, function (value) {
                $scope.EquipmentItemdatas.push({
                    EquipmentName: value.EquipmentName,
                    Code: value.Code,
                    Manufacturer: value.Manufacturer,
                    SerialNumber: value.SerialNumber,
                    ItemId: value.id
                })
                $scope.EqLogdetails = $scope.EqLogdetails.concat(value.RecordLogdetails)
            })


            $scope.vm.Category = null
            $scope.vm.EquipmentName = null
            $scope.vm.Manufacturer = null
            $scope.vm.SerialNumber = null
            $scope.vm.ProductCode = null
            $scope.Equipmentsdata = []
            $scope.EUpdate = false
            $scope.EquipmentItemdatas = _.uniqBy($scope.EquipmentItemdatas, "ItemId")
            $mdDialog.cancel()

        }

        function ClearEquipment() {
            $scope.vm.EquipmentName = null;
            $scope.vm.Category = null;
            $scope.vm.Manufacturer = null;
            $scope.vm.SerialNo = null;
            $scope.vm.Quantity = null;
            $scope.vm.UMO = null;
            $scope.vm.ProductCode = null;
        }

        $scope.Equipmentdelete = function (Index) {
            $scope.EquipmentItemdatas.splice(Index, 1)
        }

        $scope.ViewReqinfo = function (e, id) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/EquipmentRequest/ViewEquipments.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function EquipmentRequestController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            var info = $scope.EquipmentRequestdatas
            var item = info.filter(function (item) {
                return item.id === id
            })[0]
            $scope.dataGridOptions.dataSource = item.EquipmentItems
            $scope.ViewTable = true
        }

        $scope.dataGridOptions = {
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px;padding-bottom:10px;font-weight:bold;font-size:16px" class="textstyle_1">REQUESTED EQUIPMENTS</div>');
            },
            showBorders: true,
            paging: {
                enabled: false
            },
            editing: {
                allowUpdating: false,
                allowDeleting: false,
                allowAdding: false,

            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    },
                },
                {
                    dataField: "EquipmentName",
                    caption: "Equipment Name",
                    width: "40%"
                },
                {
                    dataField: "Manufacturer",
                    caption: "Manufacturer",
                },
                {
                    dataField: "SerialNumber",
                    caption: "Serial Number",
                },
            ],
        };
        $scope.getEquipmentSerialumber = function (EquipmentName) {
            var item = $scope.Equipmentdatas.filter(function (item) {
                return item.EquipmentName === EquipmentName && item.Quantity == 1
            })
            $scope.EquipmentSeraildatas = item
            $scope.vm.Stock = $scope.EquipmentSeraildatas.length
            $scope.vm.Quantity = 0
        }
        $scope.AddRecord = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/procurement/EquipmentRequest/ViewEquipments.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function EquipmentRequestController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.ViewTable = false
            $scope.vm.Equipment = null
            $scope.vm.dDescription = null
            $scope.vm.Stock = null
            $scope.vm.Quantity = null
            $scope.EquipmentSeraildatas = []
        }

        var response = $http({
            url: $rootScope.WebURL + "/unit",
            method: "POST",
            data: { Client_Id: Client_Id },
        });
        response.then(function (Unitdata) {
            $scope.Unitdatas = Unitdata.data.data;
        });

        $http({
            url: $rootScope.WebURL + "/employee/detailsforTablet",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id, Employee_ID: EmpID },
        }).then(function (Unitdata) {
            $scope.Employeedatas = Unitdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/supplier",
            data: { Client_Id: Client_Id },
        }).then(function (Supplierdata) {
            $scope.Supplierdatas = Supplierdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/equipment",
            method: "POST",
            data: { Client_Id: Client_Id },
        }).then(function (Unitdata) {
            $scope.EquipmentListName = _.uniqBy(Unitdata.data.data, "EquipmentName")
            var item = Unitdata.data.data.filter(function (item) {
                return item.Quantity === 1
            })
            $scope.Equipmentdatas = item;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/Equipment",
            data: { Client_Id: Client_Id },
        }).then(function (Storedata) {
            $scope.EquipmentListdatas = Storedata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/unit",
            method: "POST",
            data: { Client_Id: Client_Id },
        }).then(function (Unitdata) {
            $scope.Unitdatas = Unitdata.data.data;
        });
        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },

            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
    }


})();







(function () {
    'use strict';

    angular
        .module('app.human-resource.recruitment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.human-resource_recruitment', {
            url: '/Recruitment',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/recruitment/recruitment.html',
                    controller: 'RecruitmentController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/recruitment');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.human-resource.recruitment')
        .controller('RecruitmentController', RecruitmentController);

    /** @ngInject */
    function RecruitmentController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $mdDialog, $document, $http, $timeout, $q, $log) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Recruitment")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        debugger
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshGrid();
        RefreshEmployeedetailsGrid();
        RefreshCostCentreGrid();
        RefreshEvaluationdetailsGrid();
        RefreshContracdetailstGrid();
        RefreshJobinductiondetailsGrid();
        RefreshEmployeecontracttemplateformGrid();

        $http.get($rootScope.WebURL + "/employee/LastEId")
            .then(function (edata) {
                $scope.LastEId = edata.data.data;
            });


        $scope.Grid = true;
        $scope.rAdd = true;
        $scope.rExport = true;
        $scope.rSearch = true;
        $scope.rView = false;
        $scope.JobApplication = false;
        $scope.Evaluation = false;
        $scope.Contract = false;
        $scope.JobInduction1 = false;
        $scope.JobInduction2 = false;

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.ContractSearchTermcancel = function () {
            $scope.ContractTemplate = '';
            $scope.EmpContract = '';
        }

        $scope.ContractTemplateDetails = function () {
            $scope.TemplateId = $scope.ContractTemplate;
            try {
                var TemplateArray = $scope.Employeecontracttemplateformdatas;
                var item = TemplateArray.filter(function (item) {
                    return item._id === $scope.TemplateId;
                })[0];

                $scope.id = item._id;
                $scope.TemplateName = item.TemplateName;
                $scope.EmpContract = item.TemplateDetail;
            } catch (err) { }
        }

        $scope.Add = function () {
            ClearForm();
            $scope.Update = false;
            $scope.JobApplication = true;
            $scope.rView = true;
            $scope.Grid = false;
            $scope.rAdd = false;
            $scope.rExport = false;
            $scope.rSearch = false;
            $scope.Evaluation = false;
            $scope.Contract = false;
            $scope.JobInduction1 = false;
            $scope.JobInduction2 = false;
            $scope.Application = false;
            $scope.Sex = "Male";
            $scope.MaritalStatus = "Single";
            $scope.SingaporePR = "No";
            $scope.DrivingLicense = "No";
            $scope.Offence = "No";
            $scope.Bankruptcy = "No";
            $scope.Judgement = "No";
            $scope.Acknowledgement = "No";
            $scope.Capacity = "No";
            $scope.Position = "No";
            $scope.Competitors = "No";
            $scope.Accept = "No";

            $scope.DateofApplication = new Date();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();

            var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 6; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.JobApplicationID = pass;
        }

        $scope.Showgrid = function () {
            $scope.Grid = true;
            $scope.rAdd = true;
            $scope.rExport = true;
            $scope.rSearch = true;
            $scope.rView = false;
            $scope.JobApplication = false;
            $scope.Evaluation = false;
            $scope.Contract = false;
            $scope.JobInduction1 = false;
            $scope.JobInduction2 = false;
        }

        $scope.AcceptDetails = function () {
            if ($scope.Accept.value == true) {
                $scope.ARemarks = true;
            }
            else {
                $scope.ARemarks = false;
            }
        }

        $scope.JobApplicationinfo = function (ApplicationId, $index) {
            $scope.SID = ApplicationId;
            $scope.IndxID = $index;
            $scope.Update = true;
            $scope.JobApplication = true;
            $scope.rView = true;
            $scope.Grid = false;
            $scope.rAdd = false;
            $scope.rExport = false;
            $scope.rSearch = false;
            $scope.Evaluation = false;
            $scope.Contract = false;
            $scope.JobInduction1 = false;
            $scope.JobInduction2 = false;
            $scope.Application = true;

            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value, key) {
                if (ApplicationId == value.id) {

                    $scope.JobApplicationID = value.JobApplicationID;
                    $scope.PositionApplied = value.PositionApplied;
                    $scope.DateofApplication = value.DateofApplication;
                    if ($scope.DateofApplication != null && $scope.DateofApplication != "") {
                        $scope.DateofApplication = new Date(value.DateofApplication);
                    }
                    $scope.NameinPassport = value.NameinPassport;
                    $scope.NameinNative = value.NameinNative;
                    $scope.DOB = value.DOB;
                    if ($scope.DOB != null && $scope.DOB != "") {
                        $scope.DOB = new Date(value.DOB);
                    }
                    $scope.PlaceofBirth = value.PlaceofBirth;
                    $scope.Citizenship = value.Citizenship;
                    $scope.Race = value.Race;
                    $scope.FINNumber = value.FINNumber;
                    $scope.PassportNumber = value.PassportNumber;
                    $scope.Sex = value.Sex;
                    $scope.MaritalStatus = value.MaritalStatus;
                    $scope.SingaporePR = value.SingaporePR;

                    $scope.DateAttainedSPRStatus = value.DateAttainedSPRStatus;
                    if ($scope.DateAttainedSPRStatus != null && $scope.DateAttainedSPRStatus != "") {
                        $scope.DateAttainedSPRStatus = new Date(value.DateAttainedSPRStatus);
                    }
                    $scope.DrivingLicense = value.DrivingLicense;

                    $scope.DLPassingDate = value.DLPassingDate;
                    if ($scope.DLPassingDate != null && $scope.DLPassingDate != "") {
                        $scope.DLPassingDate = new Date(value.DLPassingDate);
                    }

                    $scope.RTelephoneNumber = parseInt(value.RTelephoneNumber);
                    $scope.MobileNumber = parseInt(value.MobileNumber);
                    $scope.Email = value.Email;
                    $scope.RAddress = value.RAddress;
                    $scope.PRAddress = value.PRAddress;
                    $scope.EmergencyContactName = value.EmergencyContactName;
                    $scope.EmergencyContactRelationship = value.EmergencyContactRelationship;
                    $scope.EmergencyContactRTelephoneNumber = parseInt(value.EmergencyContactRTelephoneNumber);
                    $scope.EmergencyContactOTelephoneNumber = parseInt(value.EmergencyContactOTelephoneNumber);
                    $scope.EmergencyContactMobileNumber = parseInt(value.EmergencyContactMobileNumber);
                    $scope.EmergencyContactEmail = value.EmergencyContactEmail;
                    $scope.EmergencyContactRAddress = value.EmergencyContactRAddress;
                    $scope.NSStatus = value.NSStatus;
                    $scope.ServiceStatus = value.ServiceStatus;
                    $scope.ExemptedReason = value.ExemptedReason;
                    $scope.ORD = value.ORD;

                    $scope.EnlistmentDate = value.EnlistmentDate;
                    if ($scope.EnlistmentDate != null && $scope.EnlistmentDate != "") {
                        $scope.EnlistmentDate = new Date(value.EnlistmentDate);
                    }

                    $scope.RankAtORD = value.RankAtORD;
                    $scope.ReservistDate = value.ReservistDate;
                    if ($scope.ReservistDate != null && $scope.ReservistDate != "") {
                        $scope.ReservistDate = new Date(value.ReservistDate);
                    }

                    $scope.ComputerLiteracy = value.ComputerLiteracy;
                    $scope.Hobbies = value.Hobbies;
                    $scope.MostEnjoyed = value.MostEnjoyed;
                    $scope.LeastEnjoyed = value.LeastEnjoyed;
                    $scope.ApplicationConsider = value.ApplicationConsider;
                    $scope.ExpectedMonthlySalary = parseInt(value.ExpectedMonthlySalary);
                    $scope.JoinUs = value.JoinUs;
                    $scope.LearnAboutThisPosition = value.LearnAboutThisPosition;
                    $scope.LearnAboutThisPositionOtherRemark = value.LearnAboutThisPositionOtherRemark;
                    $scope.Offence = value.Offence;
                    $scope.Bankruptcy = value.Bankruptcy;
                    $scope.Judgement = value.Judgement;
                    $scope.Acknowledgement = value.Acknowledgement;

                    $scope.Capacity = value.Capacity;
                    $scope.Position = value.Position;
                    $scope.Competitors = value.Competitors;
                    $scope.Declaration = value.Declaration;
                    $scope.Accept = value.Accept;
                    $scope.AcceptRemarks = value.AcceptRemarks;
                    $scope.PrivacyPolicy = value.PrivacyPolicy;
                    $scope.Status = value.Status;
                }
            });

            RefreshFamilyGrid();
            //RefreshAwardGrid();
            RefreshMembershipGrid();
            RefreshLanguageGrid();
            RefreshEducationGrid();
            RefreshEmphistoryGrid();
            RefreshCharacterGrid();
        }

        $scope.jSubmit = function () {
            if ($scope.Accept == "No") {
                $mdToast.show($mdToast.simple().textContent('You must accept declaration!!').position('top center'));
                return
            }
            if ($scope.SingaporePR == "No") {
                $scope.DateAttainedSPRStatus = null;
            }
            if ($scope.DrivingLicense == "No") {
                $scope.DLPassingDate = null;
            }
            if ($scope.Accept == "No") {
                $scope.AcceptRemarks = "";
            }
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                    data: {
                        _id: $scope.SID,
                        JobApplicationID: $scope.JobApplicationID,
                        PositionApplied: $scope.PositionApplied,
                        DateofApplication: $scope.DateofApplication,
                        NameinPassport: $scope.NameinPassport,
                        NameinNative: $scope.NameinNative,
                        DOB: $scope.DOB,
                        PlaceofBirth: $scope.PlaceofBirth,
                        Citizenship: $scope.Citizenship,
                        Race: $scope.Race,
                        FINNumber: $scope.FINNumber,
                        PassportNumber: $scope.PassportNumber,
                        Sex: $scope.Sex,
                        MaritalStatus: $scope.MaritalStatus,
                        SingaporePR: $scope.SingaporePR,
                        DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                        DrivingLicense: $scope.DrivingLicense,
                        DLPassingDate: $scope.DLPassingDate,

                        RTelephoneNumber: $scope.RTelephoneNumber,
                        MobileNumber: $scope.MobileNumber,
                        Email: $scope.Email,
                        RAddress: $scope.RAddress,
                        PRAddress: $scope.PRAddress,
                        EmergencyContactName: $scope.EmergencyContactName,
                        EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                        EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                        EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                        EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                        EmergencyContactEmail: $scope.EmergencyContactEmail,
                        EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                        NSStatus: $scope.NSStatus,
                        ServiceStatus: $scope.ServiceStatus,
                        ExemptedReason: $scope.ExemptedReason,
                        ORD: $scope.ORD,

                        EnlistmentDate: $scope.EnlistmentDate,
                        RankAtORD: $scope.RankAtORD,
                        ReservistDate: $scope.ReservistDate,
                        ComputerLiteracy: $scope.ComputerLiteracy,
                        Hobbies: $scope.Hobbies,
                        MostEnjoyed: $scope.MostEnjoyed,
                        LeastEnjoyed: $scope.LeastEnjoyed,
                        ApplicationConsider: $scope.ApplicationConsider,
                        ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                        JoinUs: $scope.JoinUs,
                        LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                        LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                        Offence: $scope.Offence,
                        Bankruptcy: $scope.Bankruptcy,
                        Judgement: $scope.Judgement,
                        Acknowledgement: $scope.Acknowledgement,

                        Capacity: $scope.Capacity,
                        Position: $scope.Position,
                        Competitors: $scope.Competitors,
                        Declaration: $scope.Declaration,
                        Accept: $scope.Accept,
                        AcceptRemarks: $scope.AcceptRemarks,
                        PrivacyPolicy: $scope.PrivacyPolicy,
                        Status: $scope.Status,

                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = GList.data.data;

                    //RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobapplication/add",
                    data: {
                        Client_Id: Client_Id,
                        JobApplicationID: $scope.JobApplicationID,
                        PositionApplied: $scope.PositionApplied,
                        DateofApplication: $scope.DateofApplication,
                        NameinPassport: $scope.NameinPassport,
                        NameinNative: $scope.NameinNative,
                        DOB: $scope.DOB,
                        PlaceofBirth: $scope.PlaceofBirth,
                        Citizenship: $scope.Citizenship,
                        Race: $scope.Race,
                        FINNumber: $scope.FINNumber,
                        PassportNumber: $scope.PassportNumber,
                        Sex: $scope.Sex,
                        MaritalStatus: $scope.MaritalStatus,
                        SingaporePR: $scope.SingaporePR,
                        DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                        DrivingLicense: $scope.DrivingLicense,
                        DLPassingDate: $scope.DLPassingDate,

                        RTelephoneNumber: $scope.RTelephoneNumber,
                        MobileNumber: $scope.MobileNumber,
                        Email: $scope.Email,
                        RAddress: $scope.RAddress,
                        PRAddress: $scope.PRAddress,
                        EmergencyContactName: $scope.EmergencyContactName,
                        EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                        EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                        EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                        EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                        EmergencyContactEmail: $scope.EmergencyContactEmail,
                        EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                        NSStatus: $scope.NSStatus,
                        ServiceStatus: $scope.ServiceStatus,
                        ExemptedReason: $scope.ExemptedReason,
                        ORD: $scope.ORD,

                        EnlistmentDate: $scope.EnlistmentDate,
                        RankAtORD: $scope.RankAtORD,
                        ReservistDate: $scope.ReservistDate,
                        ComputerLiteracy: $scope.ComputerLiteracy,
                        Hobbies: $scope.Hobbies,
                        MostEnjoyed: $scope.MostEnjoyed,
                        LeastEnjoyed: $scope.LeastEnjoyed,
                        ApplicationConsider: $scope.ApplicationConsider,
                        ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                        JoinUs: $scope.JoinUs,
                        LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                        LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                        Offence: $scope.Offence,
                        Bankruptcy: $scope.Bankruptcy,
                        Judgement: $scope.Judgement,
                        Acknowledgement: $scope.Acknowledgement,

                        Capacity: $scope.Capacity,
                        Position: $scope.Position,
                        Competitors: $scope.Competitors,
                        Declaration: $scope.Declaration,
                        Accept: $scope.Accept,
                        AcceptRemarks: $scope.AcceptRemarks,
                        PrivacyPolicy: $scope.PrivacyPolicy,
                        Status: "New",

                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    RefreshGrid();
                    $scope.Showgrid();


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobapplication",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentjobapplicationdata) {
                $scope.Recruitmentjobapplicationdatas = Recruitmentjobapplicationdata.data.data;
            });
        }

        function RefreshEmployeedetailsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshCostCentreGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/costcentre",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CostCentredata) {
                $scope.CostCentredatas = CostCentredata.data.data;
            });
        }

        function RefreshEvaluationdetailsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentevaluation",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentevaluationdata) {
                $scope.Recruitmentevaluationdatas = Recruitmentevaluationdata.data.data;
            });
        }

        function RefreshContracdetailstGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentcontract",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentcontractdata) {
                $scope.Recruitmentcontractdatas = Recruitmentcontractdata.data.data;
            });
        }

        function RefreshJobinductiondetailsGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobinduction",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentjobinductiondata) {
                $scope.Recruitmentjobinductiondatas = Recruitmentjobinductiondata.data.data;
            });
        }

        function RefreshEmployeecontracttemplateformGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employeecontracttemplateform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeecontracttemplateformdata) {
                $scope.Employeecontracttemplateformdatas = Employeecontracttemplateformdata.data.data;
            });
        }

        $http.get($rootScope.WebURL + "/recruitmentjobfamily")
            .then(function (Recruitmentjobfamilyrefdata) {
                $scope.Recruitmentjobfamilyrefdatas = Recruitmentjobfamilyrefdata.data.data;
            });

        $http.get($rootScope.WebURL + "/recruitmentjobmembership")
            .then(function (Recruitmentjobmembershiprefdata) {
                $scope.Recruitmentjobmembershiprefdatas = Recruitmentjobmembershiprefdata.data.data;
            });

        $http.get($rootScope.WebURL + "/recruitmentjobeducation")
            .then(function (Recruitmentjobeducationrefdata) {
                $scope.Recruitmentjobeducationrefdatas = Recruitmentjobeducationrefdata.data.data;
            });

        function ClearForm() {
            $scope.JobApplicationID = '';
            $scope.PositionApplied = '';
            $scope.DateofApplication = null;
            $scope.NameinPassport = '';
            $scope.NameinNative = '';
            $scope.DOB = null;
            $scope.PlaceofBirth = '';
            $scope.Citizenship = '';
            $scope.Race = '';
            $scope.FINNumber = '';
            $scope.PassportNumber = '';
            $scope.Sex = '';
            $scope.MaritalStatus = '';
            $scope.SingaporePR = '';
            $scope.DateAttainedSPRStatus = null;
            $scope.DrivingLicense = '';
            $scope.DLPassingDate = null;

            $scope.RTelephoneNumber = '';
            $scope.MobileNumber = '';
            $scope.Email = '';
            $scope.RAddress = '';
            $scope.PRAddress = '';
            $scope.EmergencyContactName = '';
            $scope.EmergencyContactRelationship = '';
            $scope.EmergencyContactRTelephoneNumber = '';
            $scope.EmergencyContactOTelephoneNumber = '';
            $scope.EmergencyContactMobileNumber = '';
            $scope.EmergencyContactEmail = '';
            $scope.EmergencyContactRAddress = '';
            $scope.NSStatus = '';
            $scope.ServiceStatus = '';
            $scope.ExemptedReason = '';
            $scope.ORD = '';

            $scope.EnlistmentDate = null;
            $scope.RankAtORD = '';
            $scope.ReservistDate = null;
            $scope.ComputerLiteracy = '';
            $scope.Hobbies = '';
            $scope.MostEnjoyed = '';
            $scope.LeastEnjoyed = '';
            $scope.ApplicationConsider = '';
            $scope.ExpectedMonthlySalary = '';
            $scope.JoinUs = '';
            $scope.LearnAboutThisPosition = '';
            $scope.LearnAboutThisPositionOtherRemark = '';
            $scope.Offence = '';
            $scope.Bankruptcy = '';
            $scope.Judgement = '';
            $scope.Acknowledgement = '';

            $scope.Capacity = '';
            $scope.Position = '';
            $scope.Competitors = '';
            $scope.Declaration = '';

            $scope.Recruitmentjobfamilydatas = '';
            $scope.Recruitmentjobawarddatas = '';
            $scope.Recruitmentjobmembershipdatas = '';
            $scope.Recruitmentjoblanguagedatas = '';
            $scope.Recruitmentjobeducationdatas = '';
            $scope.Recruitmentjobemphistorydatas = '';
            $scope.Recruitmentjobcharacterdatas = '';
            $scope.Accept = '';
            $scope.AcceptRemarks = '';

            //$scope.SignatureofApplicant = '';
            //$scope.PrivacyPolicy = '';
        }

        $scope.ConvertEmployee = function (e, ApplicationId, $index) {
            debugger
            $scope.SID = ApplicationId;
            $scope.IndxID = $index;
            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                if (ApplicationId == value1.id) {
                    $scope.id = value1.id;
                    $scope.JobApplicationID = value1.JobApplicationID;
                    $scope.Status = value1.Status;
                }
            });
            angular.forEach($scope.Recruitmentevaluationdatas, function (value2, key2) {
                if ($scope.JobApplicationID == value2.JobApplicationID) {
                    $scope.id = value2.id;
                    $scope.Result = value2.Result;
                }
            });
            if ($scope.Status == "New" || $scope.Status == "Selected" || $scope.Status == "EmployeeID Created" || $scope.Status == "Job Induction Conducted" || $scope.Result == "Not-Selected") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.ApplicationId = ApplicationId;

                $mdDialog.show({
                    templateUrl: 'app/main/apps/human-resource/recruitment/convertemployee.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function JobapplicationController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
            }
        }

        $scope.ConvertEmployeeadd = function (ApplicationId) {
            debugger
            $scope.IndexID = $scope.IndxID;
            try {
                var ApplicationArray = $scope.Recruitmentjobapplicationdatas;
                var item = ApplicationArray.filter(function (item) {
                    return item.id === ApplicationId;
                })[0];

                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.PositionApplied = item.PositionApplied;
                $scope.DateofApplication = item.DateofApplication;
                if ($scope.DateofApplication != null && $scope.DateofApplication != "") {
                    $scope.DateofApplication = new Date(item.DateofApplication);
                }
                $scope.NameinPassport = item.NameinPassport;
                $scope.NameinNative = item.NameinNative;
                $scope.DOB = item.DOB;
                if ($scope.DOB != null && $scope.DOB != "") {
                    $scope.DOB = new Date(item.DOB);
                }
                $scope.PlaceofBirth = item.PlaceofBirth;
                $scope.Citizenship = item.Citizenship;
                $scope.Race = item.Race;
                $scope.FINNumber = item.FINNumber;
                $scope.PassportNumber = item.PassportNumber;
                $scope.Sex = item.Sex;
                $scope.MaritalStatus = item.MaritalStatus;
                $scope.SingaporePR = item.SingaporePR;

                $scope.DateAttainedSPRStatus = item.DateAttainedSPRStatus;
                if ($scope.DateAttainedSPRStatus != null && $scope.DateAttainedSPRStatus != "") {
                    $scope.DateAttainedSPRStatus = new Date(item.DateAttainedSPRStatus);
                }
                $scope.DrivingLicense = item.DrivingLicense;

                $scope.DLPassingDate = item.DLPassingDate;
                if ($scope.DLPassingDate != null && $scope.DLPassingDate != "") {
                    $scope.DLPassingDate = new Date(item.DLPassingDate);
                }

                $scope.RTelephoneNumber = parseInt(item.RTelephoneNumber);
                $scope.MobileNumber = parseInt(item.MobileNumber);
                $scope.Email = item.Email;
                $scope.RAddress = item.RAddress;
                $scope.PRAddress = item.PRAddress;
                $scope.EmergencyContactName = item.EmergencyContactName;
                $scope.EmergencyContactRelationship = item.EmergencyContactRelationship;
                $scope.EmergencyContactRTelephoneNumber = parseInt(item.EmergencyContactRTelephoneNumber);
                $scope.EmergencyContactOTelephoneNumber = parseInt(item.EmergencyContactOTelephoneNumber);
                $scope.EmergencyContactMobileNumber = parseInt(item.EmergencyContactMobileNumber);
                $scope.EmergencyContactEmail = item.EmergencyContactEmail;
                $scope.EmergencyContactRAddress = item.EmergencyContactRAddress;
                $scope.NSStatus = item.NSStatus;
                $scope.ServiceStatus = item.ServiceStatus;
                $scope.ExemptedReason = item.ExemptedReason;
                $scope.ORD = item.ORD;

                $scope.EnlistmentDate = item.EnlistmentDate;
                if ($scope.EnlistmentDate != null && $scope.EnlistmentDate != "") {
                    $scope.EnlistmentDate = new Date(item.EnlistmentDate);
                }

                $scope.RankAtORD = item.RankAtORD;
                $scope.ReservistDate = item.ReservistDate;
                if ($scope.ReservistDate != null && $scope.ReservistDate != "") {
                    $scope.ReservistDate = new Date(item.ReservistDate);
                }

                $scope.ComputerLiteracy = item.ComputerLiteracy;
                $scope.Hobbies = item.Hobbies;
                $scope.MostEnjoyed = item.MostEnjoyed;
                $scope.LeastEnjoyed = item.LeastEnjoyed;
                $scope.ApplicationConsider = item.ApplicationConsider;
                $scope.ExpectedMonthlySalary = parseInt(item.ExpectedMonthlySalary);
                $scope.JoinUs = item.JoinUs;
                $scope.LearnAboutThisPosition = item.LearnAboutThisPosition;
                $scope.LearnAboutThisPositionOtherRemark = item.LearnAboutThisPositionOtherRemark;
                $scope.Offence = item.Offence;
                $scope.Bankruptcy = item.Bankruptcy;
                $scope.Judgement = item.Judgement;
                $scope.Acknowledgement = item.Acknowledgement;

                $scope.Capacity = item.Capacity;
                $scope.Position = item.Position;
                $scope.Competitors = item.Competitors;
                $scope.Declaration = item.Declaration;
                $scope.Accept = item.Accept;
                $scope.AcceptRemarks = item.AcceptRemarks;
                $scope.PrivacyPolicy = item.PrivacyPolicy;
                $scope.Status = item.Status;
            } catch (err) { }

            try {
                if ($scope.LastEId.length != 0) {
                    var y = $scope.LastEId[0].EmployeeID;
                    $scope.EmployeeID = parseInt(y) + 1;
                }
                else {
                    $scope.EmployeeID = "1001";
                }
            }
            catch (e) { }

            if ($scope.Sex == "Male") {
                $scope.Salutation = "Mr"
            }
            else if ($scope.Sex == "Female") {
                if ($scope.MaritalStatus == "Single") {
                    $scope.Salutation = "Ms"
                }
                else if ($scope.MaritalStatus == "Married") {
                    $scope.Salutation = "Mrs"
                }
            }

            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/add",
                data: {
                    Client_Id: Client_Id,
                    EmployeeID: $scope.EmployeeID,
                    Salutation: $scope.Salutation,
                    EmployeeName: $scope.NameinPassport,
                    Gender: $scope.Sex,
                    MaritalStatus: $scope.MaritalStatus,
                    Citizenship: $scope.Citizenship,
                    Race: $scope.Race,
                    VisaType: $scope.VisaType,
                    PlaceofBirth: $scope.PlaceofBirth,
                    DateofBirth: $scope.DOB,
                    Drivinglicense: $scope.DrivingLicense,
                    DrivingLicenseExpiryDate: $scope.DLPassingDate,
                    NRICNumber: $scope.FINNumber,
                    NRICIssuedDate: $scope.NRICIssuedDate,
                    NRICExpiryDate: $scope.NRICExpiryDate,
                    WorkPermitNumber: $scope.WorkPermitNumber,
                    PassportNo: $scope.PassportNumber,
                    PassportIssuedPlace: $scope.PassportIssuedPlace,
                    PassportIssuedDate: $scope.PassportIssuedDate,
                    WorkPassExpiryDate: $scope.WorkPassExpiryDate,
                    ResidentialAddress: $scope.RAddress,
                    UnitBuilding: $scope.UnitBuilding,
                    Postal: $scope.Postal,
                    Country: $scope.Country,
                    HomeTel: $scope.RTelephoneNumber,
                    Mobile: $scope.MobileNumber,
                    Email: $scope.Email,
                    PermanentResidentialAddress: $scope.PRAddress,
                    OUnitBuilding: $scope.vm.CuOUnitBuilding,
                    OPostalZip: $scope.vm.CuOPostalZip,
                    OCountry: $scope.vm.CuOCountry,
                    OContactNo: $scope.vm.CuOContactNo,
                    EDesignation: $scope.vm.EuDesignation,
                    ECostCenter: $scope.vm.EuCostCenter,
                    EDivision: $scope.vm.EuDivision,
                    EJobCategory: $scope.vm.EuJobCategory,
                    ETeam: $scope.vm.EuTeam,
                    EEmploymentStatus: $scope.vm.EuEmploymentStatus,
                    ESupervisor: $scope.vm.EuSupervisor,
                    EHOD: $scope.vm.EuHOD,
                    EPeer: $scope.vm.EuPeer,
                    EProbationStartDate: $scope.vm.EuProbationStartDate,
                    EProbationCompletionDate: $scope.vm.EuProbationCompletionDate,
                    EDateOfJoin: $scope.vm.EuDateOfJoin,
                    QQualificationsName: $scope.vm.QuQualificationsName,
                    QFrom: $scope.vm.QuFrom,
                    QTo: $scope.vm.QuTo,
                    QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                    QCountry: $scope.vm.QuCountry,
                    QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                    Skill: $scope.vm.uSkill,
                    QLicenceName: $scope.vm.QLicenceName,
                    QLicenceStartDate: $scope.vm.QLicenceStartDate,
                    QLicenceEndDate: $scope.vm.QLicenceEndDate,
                    LanguageSpoken: $scope.vm.uLanguageSpoken,
                    LanguageWritten: $scope.vm.uLanguageWritten,
                    MembershipName: $scope.vm.uMembershipName,
                    MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                    MembershipValidTo: $scope.vm.uMembershipValidTo,
                    FName: $scope.vm.FuName,
                    FDOB: $scope.vm.FuDOB,
                    FRelationship: $scope.vm.FuRelationship,
                    FOccupation: $scope.vm.FuOccupation,
                    FNationality: $scope.vm.FuNationality,
                    FHomeTel: $scope.vm.FuHomeTel,
                    FMobile: $scope.vm.FuMobile,
                    FEmail: $scope.vm.FuEmail,
                    Name: $scope.EmergencyContactName,
                    NRelationship: $scope.EmergencyContactRelationship,
                    NHomeTel: $scope.EmergencyContactRTelephoneNumber,
                    NOfficeTel: $scope.EmergencyContactOTelephoneNumber,
                    NMobile: $scope.EmergencyContactMobileNumber,
                    NEmail: $scope.EmergencyContactEmail,
                    Liability: $scope.vm.uLiability,
                    NSType: $scope.vm.uNSType,
                    Vocation: $scope.vm.uVocation,
                    UnitAttachedTo: $scope.vm.uUnitAttachedTo,
                    rrentNSStatus: $scope.NSStatus,
                    HighestRankAttained: $scope.RankAtORD,
                    EnlistmentDate: $scope.EnlistmentDate,
                    ORDDate: $scope.vm.uORDDate,
                    NextReservistDate: $scope.ReservistDate,
                    YearofAward: $scope.vm.uYearofAward,
                    Description: $scope.vm.uDescription,
                    ValueofAward: $scope.vm.uValueofAward,
                    StartDateofBond: $scope.vm.uStartDateofBond,
                    EndDateofBond: $scope.vm.uEndDateofBond,
                    Hobbies: $scope.Hobbies,
                    WorkWeekCode: $scope.vm.uWorkWeekCode,
                    WorkWeekDescription: $scope.vm.uWorkWeekDescription,
                    Annual: $scope.vm.Annual,
                    Adoption: $scope.vm.Adoption,
                    ChildCare: $scope.vm.ChildCare,
                    Maternity: $scope.vm.Maternity,
                    Paternity: $scope.vm.Paternity,
                    Sharedparentalleave: $scope.vm.Sharedparentalleave,
                    SickHospitalisation: $scope.vm.SickHospitalisation,
                    SickNonHospitalisation: $scope.vm.SickNonHospitalisation,
                    UnpaidLeavr: $scope.vm.UnpaidLeavr,
                    RResignationofDate: $scope.vm.RuResignationofDate,
                    RReason: $scope.vm.RuReason,
                    ROtherReason: $scope.vm.RuOtherReason,
                    RRemarks: $scope.vm.RuRemarks,
                    Photo: null,
                    ICFront: null,
                    ICBack: null,
                    PassportFront: null,
                    PassportBack: null,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: true,
                },
            });
            response.then(function (GList) {
                debugger
                if (GList.data.message == "Existing NRICNumber") {
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.Showgrid();
                    $mdToast.show($mdToast.simple().textContent('Existing NRIC/FIN Number!').position('top center'));
                }
                else if (GList.data.message == "Existing PassportNo") {
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.Showgrid();
                    $mdToast.show($mdToast.simple().textContent('Existing Passport Number!').position('top center'));
                }
                else {
                    $scope.AddEmployeeDetails();
                    RefreshEmployeedetailsGrid();
                    $mdDialog.cancel();
                    $scope.Showgrid();
                    //$mdToast.show($mdToast.simple().textContent('Successfully Employee Converted!').position('top center'));

                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
                $scope.Showgrid();
            });

        }

        $scope.AddEmployeeDetails = function () {
            debugger

            angular.forEach($scope.Recruitmentjobfamilyrefdatas, function (value) {

                if ($scope.JobApplicationID == value.JobApplicationID) {

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/employeeFamily/add",
                        data: {
                            EmployeeID: $scope.EmployeeID,
                            FName: value.Name,
                            FDOB: value.DOB,
                            FRelationship: value.Relationship,
                            FOccupation: value.Occupation,
                            FNationality: null,
                            FHomeTel: null,
                            FMobile: null,
                            FEmail: null,
                            CreatedBy: $rootScope.LoginID,
                            IsActive: "true",
                        },
                    });
                    response.then(function (GList) {
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });

            angular.forEach($scope.Recruitmentjobmembershiprefdatas, function (value1) {

                if ($scope.JobApplicationID == value1.JobApplicationID) {

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/employeeMembership/add",
                        data: {
                            EmployeeID: $scope.EmployeeID,
                            MembershipName: value1.Company,
                            MembershipValidFrom: value1.From,
                            MembershipValidTo: value1.To,
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });

            angular.forEach($scope.Recruitmentjobeducationrefdatas, function (value2) {

                if ($scope.JobApplicationID == value2.JobApplicationID) {

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/employeeQualification/add",
                        data: {
                            EmployeeID: $scope.EmployeeID,
                            QQualificationsName: value2.HighestQualificationsAttained,
                            QFrom: value2.From,
                            QTo: value2.To,
                            QNameofSchoolInstitution: value2.NameofInstitution,
                            QCountry: null,
                            QHighestQualificationsAttained: value2.HighestQualificationsAttained,
                            CreatedBy: $rootScope.LoginID,
                            IsActive: "true",
                        },
                    });
                    response.then(function (GList) {
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            });

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                data: {
                    _id: $scope.id,
                    JobApplicationID: $scope.JobApplicationID,
                    PositionApplied: $scope.PositionApplied,
                    DateofApplication: $scope.DateofApplication,
                    NameinPassport: $scope.NameinPassport,
                    NameinNative: $scope.NameinNative,
                    DOB: $scope.DOB,
                    PlaceofBirth: $scope.PlaceofBirth,
                    Citizenship: $scope.Citizenship,
                    Race: $scope.Race,
                    FINNumber: $scope.FINNumber,
                    PassportNumber: $scope.PassportNumber,
                    Sex: $scope.Sex,
                    MaritalStatus: $scope.MaritalStatus,
                    SingaporePR: $scope.SingaporePR,
                    DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                    DrivingLicense: $scope.DrivingLicense,
                    DLPassingDate: $scope.DLPassingDate,

                    RTelephoneNumber: $scope.RTelephoneNumber,
                    MobileNumber: $scope.MobileNumber,
                    Email: $scope.Email,
                    RAddress: $scope.RAddress,
                    PRAddress: $scope.PRAddress,
                    EmergencyContactName: $scope.EmergencyContactName,
                    EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                    EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                    EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                    EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                    EmergencyContactEmail: $scope.EmergencyContactEmail,
                    EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                    NSStatus: $scope.NSStatus,
                    ServiceStatus: $scope.ServiceStatus,
                    ExemptedReason: $scope.ExemptedReason,
                    ORD: $scope.ORD,

                    EnlistmentDate: $scope.EnlistmentDate,
                    RankAtORD: $scope.RankAtORD,
                    ReservistDate: $scope.ReservistDate,
                    ComputerLiteracy: $scope.ComputerLiteracy,
                    Hobbies: $scope.Hobbies,
                    MostEnjoyed: $scope.MostEnjoyed,
                    LeastEnjoyed: $scope.LeastEnjoyed,
                    ApplicationConsider: $scope.ApplicationConsider,
                    ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                    JoinUs: $scope.JoinUs,
                    LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                    LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                    Offence: $scope.Offence,
                    Bankruptcy: $scope.Bankruptcy,
                    Judgement: $scope.Judgement,
                    Acknowledgement: $scope.Acknowledgement,

                    Capacity: $scope.Capacity,
                    Position: $scope.Position,
                    Competitors: $scope.Competitors,
                    Declaration: $scope.Declaration,
                    Accept: $scope.Accept,
                    AcceptRemarks: $scope.AcceptRemarks,
                    PrivacyPolicy: $scope.PrivacyPolicy,
                    Status: "EmployeeID Created",
                },
            });
            debugger
            response.then(function (GList) {
                debugger
                $mdToast.show($mdToast.simple().textContent('Successfully Employee Converted!').position('top center'));
                $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = GList.data.data;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Familypopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.fName = '';
            $scope.vm.fRelationship = '';
            $scope.vm.fCountry = "Singapore";
            $scope.vm.fDOB = null;
            $scope.vm.fOccupation = '';
            $scope.vm.fCompany = '';
            $scope.FamilyUpdate = false;

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/family.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Familyadd = function () {

            if ($scope.FamilyUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobfamily/update",
                    data: {
                        _id: $scope.FID,
                        JobApplicationID: $scope.JobApplicationID,
                        Name: $scope.vm.fName,
                        Relationship: $scope.vm.fRelationship,
                        Country: $scope.vm.fCountry,
                        DOB: $scope.vm.fDOB,
                        Occupation: $scope.vm.fOccupation,
                        Company: $scope.vm.fCompany,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshFamilyGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobfamily/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        Name: $scope.vm.fName,
                        Relationship: $scope.vm.fRelationship,
                        Country: $scope.vm.fCountry,
                        DOB: $scope.vm.fDOB,
                        Occupation: $scope.vm.fOccupation,
                        Company: $scope.vm.fCompany,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshFamilyGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Familyupdate = function (e, FamilyId) {

            $scope.FamilyUpdate = true;
            $scope.FID = FamilyId;
            try {
                var RecruitmentjobfamilyArray = $scope.Recruitmentjobfamilydatas;
                var item = RecruitmentjobfamilyArray.filter(function (item) {
                    return item.id === FamilyId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.fName = item.Name;
                $scope.vm.fRelationship = item.Relationship;
                $scope.vm.fCountry = item.Country;
                $scope.vm.fDOB = item.DOB;
                if ($scope.vm.fDOB != null && $scope.vm.fDOB != "") {
                    $scope.vm.fDOB = new Date(item.DOB);
                }
                $scope.vm.fOccupation = item.Occupation;
                $scope.vm.fCompany = item.Company;
            } catch (err) { }

            //angular.forEach($scope.Recruitmentjobfamilydatas, function (value, key) {
            //    if (FamilyId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.fName = value.Name;
            //        $scope.vm.fRelationship = value.Relationship;
            //        $scope.vm.fCountry = value.Country;
            //        $scope.vm.fDOB = value.DOB;
            //        if ($scope.vm.fDOB != null && $scope.vm.fDOB != "") {
            //            $scope.vm.fDOB = new Date(value.DOB);
            //        }
            //        $scope.vm.fOccupation = value.Occupation;
            //        $scope.vm.fCompany = value.Company;
            //    }
            //});

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/family.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Familydelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/familydelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Fdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobfamily/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshFamilyGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshFamilyGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobfamily/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobfamilydata) {
                $scope.Recruitmentjobfamilydatas = Recruitmentjobfamilydata.data.data;
            });
        }

        $scope.Awardpopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.aYearofAward = '';
            $scope.vm.aDescription = '';
            $scope.vm.aValueofAward = '';
            $scope.vm.aSDOB = null;
            $scope.vm.aEDOB = null;
            $scope.AwardUpdate = false;

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/award.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Awardadd = function () {

            if ($scope.AwardUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobaward/update",
                    data: {
                        _id: $scope.AID,
                        JobApplicationID: $scope.JobApplicationID,
                        YearofAward: $scope.vm.aYearofAward,
                        Description: $scope.vm.aDescription,
                        ValueofAward: $scope.vm.aValueofAward,
                        SDOB: $scope.vm.aSDOB,
                        EDOB: $scope.vm.aEDOB,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshAwardGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobaward/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        YearofAward: $scope.vm.aYearofAward,
                        Description: $scope.vm.aDescription,
                        ValueofAward: $scope.vm.aValueofAward,
                        SDOB: $scope.vm.aSDOB,
                        EDOB: $scope.vm.aEDOB,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshAwardGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Awardupdate = function (e, AwardId) {

            $scope.AwardUpdate = true;
            $scope.AID = AwardId;
            try {
                var RecruitmentjobawardArray = $scope.Recruitmentjobawarddatas;
                var item = RecruitmentjobawardArray.filter(function (item) {
                    return item.id === AwardId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.aYearofAward = parseInt(item.YearofAward);
                $scope.vm.aDescription = item.Description;
                $scope.vm.aValueofAward = item.ValueofAward;
                $scope.vm.aSDOB = item.SDOB;
                if ($scope.vm.aSDOB != null && $scope.vm.aSDOB != "") {
                    $scope.vm.aSDOB = new Date(item.SDOB);
                }
                $scope.vm.aEDOB = item.EDOB;
                if ($scope.vm.aEDOB != null && $scope.vm.aEDOB != "") {
                    $scope.vm.aEDOB = new Date(item.EDOB);
                }
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/award.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            //angular.forEach($scope.Recruitmentjobawarddatas, function (value, key) {
            //    if (AwardId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.aYearofAward = parseInt(value.YearofAward);
            //        $scope.vm.aDescription = value.Description;
            //        $scope.vm.aValueofAward = value.ValueofAward;
            //        $scope.vm.aSDOB = value.SDOB;
            //        if ($scope.vm.aSDOB != null && $scope.vm.aSDOB != "") {
            //            $scope.vm.aSDOB = new Date(value.SDOB);
            //        }
            //        $scope.vm.aEDOB = value.EDOB;
            //        if ($scope.vm.aEDOB != null && $scope.vm.aEDOB != "") {
            //            $scope.vm.aEDOB = new Date(value.EDOB);
            //        }
            //    }
            //});
        }

        $scope.Awarddelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/awarddelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Adelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobaward/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshAwardGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshAwardGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobaward/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobawarddata) {
                $scope.Recruitmentjobawarddatas = Recruitmentjobawarddata.data.data;
            });
        }

        $scope.Membershippopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.mCompany = '';
            $scope.vm.mPositionHeld = '';
            $scope.vm.mFrom = null;
            $scope.vm.mTo = null;
            $scope.MembershipUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/membership.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Membershipadd = function () {

            if ($scope.MembershipUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobmembership/update",
                    data: {
                        _id: $scope.MID,
                        JobApplicationID: $scope.JobApplicationID,
                        Company: $scope.vm.mCompany,
                        PositionHeld: $scope.vm.mPositionHeld,
                        From: $scope.vm.mFrom,
                        To: $scope.vm.mTo,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMembershipGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobmembership/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        Company: $scope.vm.mCompany,
                        PositionHeld: $scope.vm.mPositionHeld,
                        From: $scope.vm.mFrom,
                        To: $scope.vm.mTo,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMembershipGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Membershipupdate = function (e, MembershipId) {

            $scope.MembershipUpdate = true;
            $scope.MID = MembershipId;
            try {
                var RecruitmentjobmembershipArray = $scope.Recruitmentjobmembershipdatas;
                var item = RecruitmentjobmembershipArray.filter(function (item) {
                    return item.id === MembershipId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.mCompany = item.Company;
                $scope.vm.mPositionHeld = item.PositionHeld;
                $scope.vm.mFrom = item.From;
                if ($scope.vm.mFrom != null && $scope.vm.mFrom != "") {
                    $scope.vm.mFrom = new Date(item.From);
                }
                $scope.vm.mTo = item.To;
                if ($scope.vm.mTo != null && $scope.vm.mTo != "") {
                    $scope.vm.mTo = new Date(item.To);
                }
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/membership.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            //angular.forEach($scope.Recruitmentjobmembershipdatas, function (value, key) {
            //    if (MembershipId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.mCompany = value.Company;
            //        $scope.vm.mPositionHeld = value.PositionHeld;
            //        $scope.vm.mFrom = value.From;
            //        if ($scope.vm.mFrom != null && $scope.vm.mFrom != "") {
            //            $scope.vm.mFrom = new Date(value.From);
            //        }
            //        $scope.vm.mTo = value.To;
            //        if ($scope.vm.mTo != null && $scope.vm.mTo != "") {
            //            $scope.vm.mTo = new Date(value.To);
            //        }
            //    }
            //});
        }

        $scope.Membershipdelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/membershipdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Mdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobmembership/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshMembershipGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshMembershipGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobmembership/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobmembershipdata) {
                $scope.Recruitmentjobmembershipdatas = Recruitmentjobmembershipdata.data.data;
            });
        }



        $scope.Languagepopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.lLanguage = '';
            $scope.vm.lWritten = '';
            $scope.vm.lSpoken = '';
            $scope.LanguageUpdate = false;

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/language.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Languageadd = function () {

            if ($scope.LanguageUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjoblanguage/update",
                    data: {
                        _id: $scope.LID,
                        JobApplicationID: $scope.JobApplicationID,
                        Language: $scope.vm.lLanguage,
                        Written: $scope.vm.lWritten,
                        Spoken: $scope.vm.lSpoken,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshLanguageGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjoblanguage/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        Language: $scope.vm.lLanguage,
                        Written: $scope.vm.lWritten,
                        Spoken: $scope.vm.lSpoken,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshLanguageGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Languageupdate = function (e, LanguageId) {

            $scope.LanguageUpdate = true;
            $scope.LID = LanguageId;

            try {
                var RecruitmentjoblanguageArray = $scope.Recruitmentjoblanguagedatas;
                var item = RecruitmentjoblanguageArray.filter(function (item) {
                    return item.id === LanguageId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.lLanguage = item.Language;
                $scope.vm.lWritten = item.Written;
                $scope.vm.lSpoken = item.Spoken;
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/language.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            //angular.forEach($scope.Recruitmentjoblanguagedatas, function (value, key) {
            //    if (LanguageId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.lLanguage = value.Language;
            //        $scope.vm.lWritten = value.Written;
            //        $scope.vm.lSpoken = value.Spoken;
            //    }
            //});
        }

        $scope.Languagedelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/languagedelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Ldelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjoblanguage/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshLanguageGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshLanguageGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjoblanguage/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjoblanguagedata) {
                $scope.Recruitmentjoblanguagedatas = Recruitmentjoblanguagedata.data.data;
            });
        }



        $scope.Educationpopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.eNameofInstitution = '';
            $scope.vm.eHighestQualificationsAttained = '';
            $scope.vm.eFrom = null;
            $scope.vm.eTo = null;
            $scope.EducationUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/education.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Educationadd = function () {

            if ($scope.EducationUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobeducation/update",
                    data: {
                        _id: $scope.EID,
                        JobApplicationID: $scope.JobApplicationID,
                        NameofInstitution: $scope.vm.eNameofInstitution,
                        HighestQualificationsAttained: $scope.vm.eHighestQualificationsAttained,
                        From: $scope.vm.eFrom,
                        To: $scope.vm.eTo,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshEducationGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobeducation/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        NameofInstitution: $scope.vm.eNameofInstitution,
                        HighestQualificationsAttained: $scope.vm.eHighestQualificationsAttained,
                        From: $scope.vm.eFrom,
                        To: $scope.vm.eTo,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEducationGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Educationupdate = function (e, EducationId) {

            $scope.EducationUpdate = true;
            $scope.EID = EducationId;
            try {
                var RecruitmentjobeducationArray = $scope.Recruitmentjobeducationdatas;
                var item = RecruitmentjobeducationArray.filter(function (item) {
                    return item.id === EducationId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.eNameofInstitution = item.NameofInstitution;
                $scope.vm.eHighestQualificationsAttained = item.HighestQualificationsAttained;
                $scope.vm.eFrom = item.From;
                if ($scope.vm.eFrom != null && $scope.vm.eFrom != "") {
                    $scope.vm.eFrom = new Date(item.From);
                }
                $scope.vm.eTo = item.To;
                if ($scope.vm.eTo != null && $scope.vm.eTo != "") {
                    $scope.vm.eTo = new Date(item.To);
                }
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/education.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            //angular.forEach($scope.Recruitmentjobeducationdatas, function (value, key) {
            //    if (EducationId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.eNameofInstitution = value.NameofInstitution;
            //        $scope.vm.eHighestQualificationsAttained = value.HighestQualificationsAttained;
            //        $scope.vm.eFrom = value.From;
            //        if ($scope.vm.eFrom != null && $scope.vm.eFrom != "") {
            //            $scope.vm.eFrom = new Date(value.From);
            //        }
            //        $scope.vm.eTo = value.To;
            //        if ($scope.vm.eTo != null && $scope.vm.eTo != "") {
            //            $scope.vm.eTo = new Date(value.To);
            //        }
            //    }
            //});
        }

        $scope.Educationdelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/educationdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Edudelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobeducation/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshEducationGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshEducationGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobeducation/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobeducationdata) {
                $scope.Recruitmentjobeducationdatas = Recruitmentjobeducationdata.data.data;
            });
        }



        $scope.Emphistorypopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.hNameofEmployer = '';
            $scope.vm.hAddressofEmployer = '';
            $scope.vm.hFrom = null;
            $scope.vm.hTo = null;
            $scope.vm.hLastDrawnMonthlySalary = '';
            $scope.vm.hAllowanceBonus = '';
            $scope.vm.hJobTitle = '';
            $scope.vm.hReasonforLeaving = '';
            $scope.EmphistoryUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/emphistory.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Emphistoryadd = function () {

            if ($scope.EmphistoryUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobemphistory/update",
                    data: {
                        _id: $scope.HID,
                        JobApplicationID: $scope.JobApplicationID,
                        NameofEmployer: $scope.vm.hNameofEmployer,
                        AddressofEmployer: $scope.vm.hAddressofEmployer,
                        From: $scope.vm.hFrom,
                        To: $scope.vm.hTo,
                        LastDrawnMonthlySalary: $scope.vm.hLastDrawnMonthlySalary,
                        AllowanceBonus: $scope.vm.hAllowanceBonus,
                        JobTitle: $scope.vm.hJobTitle,
                        ReasonforLeaving: $scope.vm.hReasonforLeaving,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshEmphistoryGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobemphistory/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        NameofEmployer: $scope.vm.hNameofEmployer,
                        AddressofEmployer: $scope.vm.hAddressofEmployer,
                        From: $scope.vm.hFrom,
                        To: $scope.vm.hTo,
                        LastDrawnMonthlySalary: $scope.vm.hLastDrawnMonthlySalary,
                        AllowanceBonus: $scope.vm.hAllowanceBonus,
                        JobTitle: $scope.vm.hJobTitle,
                        ReasonforLeaving: $scope.vm.hReasonforLeaving,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEmphistoryGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Emphistoryupdate = function (e, EmphistoryId) {

            $scope.EmphistoryUpdate = true;
            $scope.HID = EmphistoryId;
            try {
                var RecruitmentjobemphistoryArray = $scope.Recruitmentjobemphistorydatas;
                var item = RecruitmentjobemphistoryArray.filter(function (item) {
                    return item.id === EmphistoryId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.hNameofEmployer = item.NameofEmployer;
                $scope.vm.hAddressofEmployer = item.AddressofEmployer;
                $scope.vm.hFrom = item.From;
                if ($scope.vm.hFrom != null && $scope.vm.hFrom != "") {
                    $scope.vm.hFrom = new Date(item.From);
                }
                $scope.vm.hTo = item.To;
                if ($scope.vm.hTo != null && $scope.vm.hTo != "") {
                    $scope.vm.hTo = new Date(item.To);
                }
                $scope.vm.hLastDrawnMonthlySalary = parseInt(item.LastDrawnMonthlySalary);
                $scope.vm.hAllowanceBonus = parseInt(item.AllowanceBonus);
                $scope.vm.hJobTitle = item.JobTitle;
                $scope.vm.hReasonforLeaving = item.ReasonforLeaving;
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/emphistory.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            //angular.forEach($scope.Recruitmentjobemphistorydatas, function (value, key) {
            //    if (EmphistoryId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.hNameofEmployer = value.NameofEmployer;
            //        $scope.vm.hAddressofEmployer = value.AddressofEmployer;
            //        $scope.vm.hFrom = value.From;
            //        if ($scope.vm.hFrom != null && $scope.vm.hFrom != "") {
            //            $scope.vm.hFrom = new Date(value.From);
            //        }
            //        $scope.vm.hTo = value.To;
            //        if ($scope.vm.hTo != null && $scope.vm.hTo != "") {
            //            $scope.vm.hTo = new Date(value.To);
            //        }
            //        $scope.vm.hLastDrawnMonthlySalary = parseInt(value.LastDrawnMonthlySalary);
            //        $scope.vm.hAllowanceBonus = parseInt(value.AllowanceBonus);
            //        $scope.vm.hJobTitle = value.JobTitle;
            //        $scope.vm.hReasonforLeaving = value.ReasonforLeaving;
            //    }
            //});
        }

        $scope.Emphistorydelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/emphistorydelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Empdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobemphistory/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshEmphistoryGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshEmphistoryGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobemphistory/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobemphistorydata) {
                $scope.Recruitmentjobemphistorydatas = Recruitmentjobemphistorydata.data.data;
            });
        }



        $scope.Characterpopup = function (e, JobApplicationID) {

            $scope.JobApplicationID = JobApplicationID;

            $scope.vm.cName = '';
            $scope.vm.cOccupationName = '';
            $scope.vm.cPeriodKnown = '';
            $scope.vm.cContactNo = '';
            $scope.vm.cAddress = '';
            $scope.CharacterUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/character.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Characteradd = function () {

            if ($scope.CharacterUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobcharacter/update",
                    data: {
                        _id: $scope.CID,
                        JobApplicationID: $scope.JobApplicationID,
                        Name: $scope.vm.cName,
                        OccupationName: $scope.vm.cOccupationName,
                        PeriodKnown: $scope.vm.cPeriodKnown,
                        ContactNo: $scope.vm.cContactNo,
                        Address: $scope.vm.cAddress,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshCharacterGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobcharacter/add",
                    data: {
                        JobApplicationID: $scope.JobApplicationID,
                        Name: $scope.vm.cName,
                        OccupationName: $scope.vm.cOccupationName,
                        PeriodKnown: $scope.vm.cPeriodKnown,
                        ContactNo: $scope.vm.cContactNo,
                        Address: $scope.vm.cAddress,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshCharacterGrid();

                    $scope.JobApplication = true;
                    $scope.rView = true;
                    $scope.Grid = false;
                    $scope.rAdd = false;
                    $scope.rExport = false;
                    $scope.rSearch = false;
                    $scope.Evaluation = false;
                    $scope.Contract = false;
                    $scope.JobInduction1 = false;
                    $scope.JobInduction2 = false;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Characterupdate = function (e, CharacterId) {

            $scope.CharacterUpdate = true;
            $scope.CID = CharacterId;

            try {
                var RecruitmentjobcharacterArray = $scope.Recruitmentjobcharacterdatas;
                var item = RecruitmentjobcharacterArray.filter(function (item) {
                    return item.id === CharacterId;
                })[0];
                $scope.id = item.id;
                $scope.JobApplicationID = item.JobApplicationID;
                $scope.vm.cName = item.Name;
                $scope.vm.cOccupationName = item.OccupationName;
                $scope.vm.cPeriodKnown = item.PeriodKnown;
                $scope.vm.cContactNo = parseInt(item.ContactNo);
                $scope.vm.cAddress = item.Address;
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/character.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            //angular.forEach($scope.Recruitmentjobcharacterdatas, function (value, key) {
            //    if (CharacterId == value.id) {
            //        $scope.id = value.id;
            //        $scope.JobApplicationID = value.JobApplicationID;
            //        $scope.vm.cName = value.Name;
            //        $scope.vm.cOccupationName = value.OccupationName;
            //        $scope.vm.cPeriodKnown = value.PeriodKnown;
            //        $scope.vm.cContactNo = parseInt(value.ContactNo);
            //        $scope.vm.cAddress = value.Address;
            //    }
            //});
        }

        $scope.Characterdelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/recruitment/characterdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function JobapplicationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Cdelete = function (deleteID) {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/recruitmentjobcharacter/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshCharacterGrid();

                $scope.JobApplication = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshCharacterGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobcharacter/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.JobApplicationID },
            });
            response.then(function (Recruitmentjobcharacterdata) {
                $scope.Recruitmentjobcharacterdatas = Recruitmentjobcharacterdata.data.data;
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };


        $scope.Recruitmentevaluationinfo = function (ApplicationId, $index) {

            $scope.SID = ApplicationId;
            $scope.IndxID = $index;
            $scope.Update = false;

            $scope.Evaluation = true;
            $scope.JobApplication = false;
            $scope.rView = true;
            $scope.Grid = false;
            $scope.rAdd = false;
            $scope.rExport = false;
            $scope.rSearch = false;
            $scope.Contract = false;
            $scope.JobInduction1 = false;
            $scope.JobInduction2 = false;
            $scope.Department = '';
            $scope.Interviewer = '';
            $scope.CompletedBy = '';
            $scope.EducationalComment = '';
            $scope.Educational = '';
            $scope.Employee = '';
            $scope.ExperienceComment = '';
            $scope.Experience = '';
            $scope.QualificationsComment = '';
            $scope.Qualifications = '';
            $scope.CommunicationComment = '';
            $scope.Communication = '';
            $scope.PresentationComment = '';
            $scope.Presentation = '';
            $scope.EnthusiasmComment = '';
            $scope.Enthusiasm = '';
            $scope.StabilityComment = '';
            $scope.Stability = '';
            $scope.ImpressionComment = '';
            $scope.Impression = '';
            $scope.CandidateStrength = '';
            $scope.CandidateWeakness = '';
            $scope.AdditionalComment = '';
            $scope.Result = '';
            $scope.basicForm2.$setPristine();
            $scope.basicForm2.$setUntouched();

            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                if (ApplicationId == value1.id) {

                    $scope.JAppID = value1.id;
                    $scope.JobApplicationID = value1.JobApplicationID;
                    $scope.PositionTitle = value1.PositionApplied;
                    $scope.DateofInterview = value1.DateofApplication;
                    if ($scope.DateofInterview != null && $scope.DateofInterview != "") {
                        $scope.DateofInterview = new Date(value1.DateofApplication);
                    }
                    $scope.NameofCandidate = value1.NameinPassport;
                    $scope.NameinNative = value1.NameinNative;
                    $scope.DOB = value1.DOB;
                    if ($scope.DOB != null && $scope.DOB != "") {
                        $scope.DOB = new Date(value1.DOB);
                    }
                    $scope.PlaceofBirth = value1.PlaceofBirth;
                    $scope.Citizenship = value1.Citizenship;
                    $scope.Race = value1.Race;
                    $scope.FINNumber = value1.FINNumber;
                    $scope.PassportNumber = value1.PassportNumber;
                    $scope.Sex = value1.Sex;
                    $scope.MaritalStatus = value1.MaritalStatus;
                    $scope.SingaporePR = value1.SingaporePR;

                    $scope.DateAttainedSPRStatus = value1.DateAttainedSPRStatus;
                    if ($scope.DateAttainedSPRStatus != null && $scope.DateAttainedSPRStatus != "") {
                        $scope.DateAttainedSPRStatus = new Date(value1.DateAttainedSPRStatus);
                    }
                    $scope.DrivingLicense = value1.DrivingLicense;

                    $scope.DLPassingDate = value1.DLPassingDate;
                    if ($scope.DLPassingDate != null && $scope.DLPassingDate != "") {
                        $scope.DLPassingDate = new Date(value1.DLPassingDate);
                    }

                    $scope.RTelephoneNumber = parseInt(value1.RTelephoneNumber);
                    $scope.MobileNumber = parseInt(value1.MobileNumber);
                    $scope.Email = value1.Email;
                    $scope.RAddress = value1.RAddress;
                    $scope.PRAddress = value1.PRAddress;
                    $scope.EmergencyContactName = value1.EmergencyContactName;
                    $scope.EmergencyContactRelationship = value1.EmergencyContactRelationship;
                    $scope.EmergencyContactRTelephoneNumber = parseInt(value1.EmergencyContactRTelephoneNumber);
                    $scope.EmergencyContactOTelephoneNumber = parseInt(value1.EmergencyContactOTelephoneNumber);
                    $scope.EmergencyContactMobileNumber = parseInt(value1.EmergencyContactMobileNumber);
                    $scope.EmergencyContactEmail = value1.EmergencyContactEmail;
                    $scope.EmergencyContactRAddress = value1.EmergencyContactRAddress;
                    $scope.NSStatus = value1.NSStatus;
                    $scope.ServiceStatus = value1.ServiceStatus;
                    $scope.ExemptedReason = value1.ExemptedReason;
                    $scope.ORD = value1.ORD;

                    $scope.EnlistmentDate = value1.EnlistmentDate;
                    if ($scope.EnlistmentDate != null && $scope.EnlistmentDate != "") {
                        $scope.EnlistmentDate = new Date(value1.EnlistmentDate);
                    }

                    $scope.RankAtORD = value1.RankAtORD;
                    $scope.ReservistDate = value1.ReservistDate;
                    if ($scope.ReservistDate != null && $scope.ReservistDate != "") {
                        $scope.ReservistDate = new Date(value1.ReservistDate);
                    }

                    $scope.ComputerLiteracy = value1.ComputerLiteracy;
                    $scope.Hobbies = value1.Hobbies;
                    $scope.MostEnjoyed = value1.MostEnjoyed;
                    $scope.LeastEnjoyed = value1.LeastEnjoyed;
                    $scope.ApplicationConsider = value1.ApplicationConsider;
                    $scope.ExpectedMonthlySalary = parseInt(value1.ExpectedMonthlySalary);
                    $scope.JoinUs = value1.JoinUs;
                    $scope.LearnAboutThisPosition = value1.LearnAboutThisPosition;
                    $scope.LearnAboutThisPositionOtherRemark = value1.LearnAboutThisPositionOtherRemark;
                    $scope.Offence = value1.Offence;
                    $scope.Bankruptcy = value1.Bankruptcy;
                    $scope.Judgement = value1.Judgement;
                    $scope.Acknowledgement = value1.Acknowledgement;

                    $scope.Capacity = value1.Capacity;
                    $scope.Position = value1.Position;
                    $scope.Competitors = value1.Competitors;
                    $scope.Declaration = value1.Declaration;
                    $scope.Accept = value1.Accept;
                    $scope.AcceptRemarks = value1.AcceptRemarks;
                    $scope.PrivacyPolicy = value1.PrivacyPolicy;
                    $scope.Status = value1.Status;
                }
            });

            angular.forEach($scope.Recruitmentevaluationdatas, function (value) {

                if ($scope.Recruitmentevaluationdatas.length > "0" && $scope.JobApplicationID == value.JobApplicationID && $scope.NameofCandidate == value.NameofCandidate) {

                    $scope.EID = value.id;
                    $scope.JobAppID = value.JobApplicationID;
                    $scope.NameofCandidate = value.NameofCandidate;
                    $scope.CandidateName = value.NameofCandidate;
                    $scope.PositionTitle = value.PositionTitle;
                    $scope.Department = value.Department;
                    $scope.Interviewer = value.Interviewer;
                    $scope.DateofInterview = value.DateofInterview;
                    if ($scope.DateofInterview != null && $scope.DateofInterview != "") {
                        $scope.DateofInterview = new Date(value.DateofInterview);
                    }
                    $scope.CompletedBy = value.CompletedBy;
                    $scope.EducationalComment = value.EducationalComment;
                    $scope.Educational = value.Educational;
                    $scope.ExperienceComment = value.ExperienceComment;
                    $scope.Experience = value.Experience;
                    $scope.QualificationsComment = value.QualificationsComment;
                    $scope.Qualifications = value.Qualifications;
                    $scope.CommunicationComment = value.CommunicationComment;
                    $scope.Communication = value.Communication;
                    $scope.PresentationComment = value.PresentationComment;
                    $scope.Presentation = value.Presentation;
                    $scope.EnthusiasmComment = value.EnthusiasmComment;
                    $scope.Enthusiasm = value.Enthusiasm;
                    $scope.StabilityComment = value.StabilityComment;
                    $scope.Stability = value.Stability;
                    $scope.ImpressionComment = value.ImpressionComment;
                    $scope.Impression = value.Impression;
                    $scope.CandidateStrength = value.CandidateStrength;
                    $scope.CandidateWeakness = value.CandidateWeakness;
                    $scope.AdditionalComment = value.AdditionalComment;
                    $scope.Result = value.Result;

                    $scope.Update = true;
                }
            });
            //else {
            //    
            //    $scope.Department = '';
            //    $scope.Interviewer = '';
            //    $scope.CompletedBy = '';
            //    $scope.EducationalComment = '';
            //    $scope.Educational = '';
            //    $scope.Employee = '';
            //    $scope.ExperienceComment = '';
            //    $scope.Experience = '';
            //    $scope.QualificationsComment = '';
            //    $scope.Qualifications = '';
            //    $scope.CommunicationComment = '';
            //    $scope.Communication = '';
            //    $scope.PresentationComment = '';
            //    $scope.Presentation = '';
            //    $scope.EnthusiasmComment = '';
            //    $scope.Enthusiasm = '';
            //    $scope.StabilityComment = '';
            //    $scope.Stability = '';
            //    $scope.ImpressionComment = '';
            //    $scope.Impression = '';
            //    $scope.CandidateStrength = '';
            //    $scope.CandidateWeakness = '';
            //    $scope.AdditionalComment = '';
            //    $scope.Result = '';
            //    $scope.basicForm2.$setPristine();
            //    $scope.basicForm2.$setUntouched();
            //    $scope.Update = false;
            //}
            //if ($scope.JobApplicationID == $scope.JobAppID && $scope.NameofCandidate == $scope.CandidateName) {
            //    $scope.Department = '';
            //    $scope.Interviewer = '';
            //    $scope.CompletedBy = '';
            //    $scope.EducationalComment = '';
            //    $scope.Educational = '';
            //    $scope.Employee = '';
            //    $scope.ExperienceComment = '';
            //    $scope.Experience = '';
            //    $scope.QualificationsComment = '';
            //    $scope.Qualifications = '';
            //    $scope.CommunicationComment = '';
            //    $scope.Communication = '';
            //    $scope.PresentationComment = '';
            //    $scope.Presentation = '';
            //    $scope.EnthusiasmComment = '';
            //    $scope.Enthusiasm = '';
            //    $scope.StabilityComment = '';
            //    $scope.Stability = '';
            //    $scope.ImpressionComment = '';
            //    $scope.Impression = '';
            //    $scope.CandidateStrength = '';
            //    $scope.CandidateWeakness = '';
            //    $scope.AdditionalComment = '';
            //    $scope.Result = '';
            //    $scope.basicForm2.$setPristine();
            //    $scope.basicForm2.$setUntouched();
            //    $scope.Update = false;
            //}
            if ($scope.Recruitmentevaluationdatas.length == "0") {

                $scope.Department = '';
                $scope.Interviewer = '';
                $scope.CompletedBy = '';
                $scope.EducationalComment = '';
                $scope.Educational = '';
                $scope.Employee = '';
                $scope.ExperienceComment = '';
                $scope.Experience = '';
                $scope.QualificationsComment = '';
                $scope.Qualifications = '';
                $scope.CommunicationComment = '';
                $scope.Communication = '';
                $scope.PresentationComment = '';
                $scope.Presentation = '';
                $scope.EnthusiasmComment = '';
                $scope.Enthusiasm = '';
                $scope.StabilityComment = '';
                $scope.Stability = '';
                $scope.ImpressionComment = '';
                $scope.Impression = '';
                $scope.CandidateStrength = '';
                $scope.CandidateWeakness = '';
                $scope.AdditionalComment = '';
                $scope.Result = '';

                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();

                $scope.Update = false;

            }

            angular.forEach($scope.CostCentredatas, function (value2, key2) {
                if ($scope.Department == value2.id) {
                    $scope.DepartmentName = value2.CostCentreName;
                }
            });

            angular.forEach($scope.Employeedatas, function (value3, key3) {
                if ($scope.Interviewer == value3.id) {
                    $scope.InterviewerName = value3.EmployeeName;
                }
            });


        }

        $scope.evaluationSubmit = function () {

            $scope.IndexID = $scope.IndxID;
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentevaluation/update",
                    data: {
                        _id: $scope.EID,
                        JobApplicationID: $scope.JobApplicationID,
                        NameofCandidate: $scope.NameofCandidate,
                        PositionTitle: $scope.PositionTitle,
                        Department: $scope.Department,
                        Interviewer: $scope.Interviewer,
                        DateofInterview: $scope.DateofInterview,
                        CompletedBy: $scope.CompletedBy,
                        EducationalComment: $scope.EducationalComment,
                        Educational: $scope.Educational,
                        ExperienceComment: $scope.ExperienceComment,
                        Experience: $scope.Experience,
                        QualificationsComment: $scope.QualificationsComment,
                        Qualifications: $scope.Qualifications,
                        CommunicationComment: $scope.CommunicationComment,
                        Communication: $scope.Communication,
                        PresentationComment: $scope.PresentationComment,
                        Presentation: $scope.Presentation,
                        EnthusiasmComment: $scope.EnthusiasmComment,
                        Enthusiasm: $scope.Enthusiasm,
                        StabilityComment: $scope.StabilityComment,
                        Stability: $scope.Stability,
                        ImpressionComment: $scope.ImpressionComment,
                        Impression: $scope.Impression,
                        CandidateStrength: $scope.CandidateStrength,
                        CandidateWeakness: $scope.CandidateWeakness,
                        AdditionalComment: $scope.AdditionalComment,
                        Result: $scope.Result,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.DateofInterview,
                            NameinPassport: $scope.NameofCandidate,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.PRAddress,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: $scope.Result,
                        },
                    });
                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshEvaluation();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentevaluation/add",
                    data: {

                        Client_Id: Client_Id,
                        JobApplicationID: $scope.JobApplicationID,
                        NameofCandidate: $scope.NameofCandidate,
                        PositionTitle: $scope.PositionTitle,
                        Department: $scope.Department,
                        Interviewer: $scope.Interviewer,
                        DateofInterview: $scope.DateofInterview,
                        CompletedBy: $scope.CompletedBy,
                        EducationalComment: $scope.EducationalComment,
                        Educational: $scope.Educational,
                        ExperienceComment: $scope.ExperienceComment,
                        Experience: $scope.Experience,
                        QualificationsComment: $scope.QualificationsComment,
                        Qualifications: $scope.Qualifications,
                        CommunicationComment: $scope.CommunicationComment,
                        Communication: $scope.Communication,
                        PresentationComment: $scope.PresentationComment,
                        Presentation: $scope.Presentation,
                        EnthusiasmComment: $scope.EnthusiasmComment,
                        Enthusiasm: $scope.Enthusiasm,
                        StabilityComment: $scope.StabilityComment,
                        Stability: $scope.Stability,
                        ImpressionComment: $scope.ImpressionComment,
                        Impression: $scope.Impression,
                        CandidateStrength: $scope.CandidateStrength,
                        CandidateWeakness: $scope.CandidateWeakness,
                        AdditionalComment: $scope.AdditionalComment,
                        Result: $scope.Result,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {


                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.DateofInterview,
                            NameinPassport: $scope.NameofCandidate,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.PRAddress,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: $scope.Result,
                        },
                    });
                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshEvaluation();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshEvaluation() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentevaluation",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentevaluationdata) {
                $scope.Recruitmentevaluationdatas = Recruitmentevaluationdata.data.data;
            });
        }


        $scope.Recruitmentcontractinfo = function (ApplicationId, $index) {

            $scope.SID = ApplicationId;
            $scope.IndxID = $index;

            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                if (ApplicationId == value1.id) {

                    $scope.JAppID = value1.id;
                    $scope.JobApplicationID = value1.JobApplicationID;
                    $scope.PositionTitle = value1.PositionApplied;
                    $scope.Date1 = value1.DateofApplication;
                    if ($scope.Date1 != null && $scope.Date1 != "") {
                        $scope.Date1 = new Date(value1.DateofApplication);
                    }
                    $scope.Name = value1.NameinPassport;
                    $scope.NameinNative = value1.NameinNative;
                    $scope.DOB = value1.DOB;
                    if ($scope.DOB != null && $scope.DOB != "") {
                        $scope.DOB = new Date(value1.DOB);
                    }
                    $scope.PlaceofBirth = value1.PlaceofBirth;
                    $scope.Citizenship = value1.Citizenship;
                    $scope.Race = value1.Race;
                    $scope.FINNumber = value1.FINNumber;
                    $scope.PassportNumber = value1.PassportNumber;
                    $scope.Sex = value1.Sex;
                    $scope.MaritalStatus = value1.MaritalStatus;
                    $scope.SingaporePR = value1.SingaporePR;

                    $scope.DateAttainedSPRStatus = value1.DateAttainedSPRStatus;
                    if ($scope.DateAttainedSPRStatus != null && $scope.DateAttainedSPRStatus != "") {
                        $scope.DateAttainedSPRStatus = new Date(value1.DateAttainedSPRStatus);
                    }
                    $scope.DrivingLicense = value1.DrivingLicense;

                    $scope.DLPassingDate = value1.DLPassingDate;
                    if ($scope.DLPassingDate != null && $scope.DLPassingDate != "") {
                        $scope.DLPassingDate = new Date(value1.DLPassingDate);
                    }

                    $scope.RTelephoneNumber = parseInt(value1.RTelephoneNumber);
                    $scope.MobileNumber = parseInt(value1.MobileNumber);
                    $scope.Email = value1.Email;
                    $scope.RAddress = value1.RAddress;
                    $scope.Address = value1.PRAddress;
                    $scope.EmergencyContactName = value1.EmergencyContactName;
                    $scope.EmergencyContactRelationship = value1.EmergencyContactRelationship;
                    $scope.EmergencyContactRTelephoneNumber = parseInt(value1.EmergencyContactRTelephoneNumber);
                    $scope.EmergencyContactOTelephoneNumber = parseInt(value1.EmergencyContactOTelephoneNumber);
                    $scope.EmergencyContactMobileNumber = parseInt(value1.EmergencyContactMobileNumber);
                    $scope.EmergencyContactEmail = value1.EmergencyContactEmail;
                    $scope.EmergencyContactRAddress = value1.EmergencyContactRAddress;
                    $scope.NSStatus = value1.NSStatus;
                    $scope.ServiceStatus = value1.ServiceStatus;
                    $scope.ExemptedReason = value1.ExemptedReason;
                    $scope.ORD = value1.ORD;

                    $scope.EnlistmentDate = value1.EnlistmentDate;
                    if ($scope.EnlistmentDate != null && $scope.EnlistmentDate != "") {
                        $scope.EnlistmentDate = new Date(value1.EnlistmentDate);
                    }

                    $scope.RankAtORD = value1.RankAtORD;
                    $scope.ReservistDate = value1.ReservistDate;
                    if ($scope.ReservistDate != null && $scope.ReservistDate != "") {
                        $scope.ReservistDate = new Date(value1.ReservistDate);
                    }

                    $scope.ComputerLiteracy = value1.ComputerLiteracy;
                    $scope.Hobbies = value1.Hobbies;
                    $scope.MostEnjoyed = value1.MostEnjoyed;
                    $scope.LeastEnjoyed = value1.LeastEnjoyed;
                    $scope.ApplicationConsider = value1.ApplicationConsider;
                    $scope.ExpectedMonthlySalary = parseInt(value1.ExpectedMonthlySalary);
                    $scope.JoinUs = value1.JoinUs;
                    $scope.LearnAboutThisPosition = value1.LearnAboutThisPosition;
                    $scope.LearnAboutThisPositionOtherRemark = value1.LearnAboutThisPositionOtherRemark;
                    $scope.Offence = value1.Offence;
                    $scope.Bankruptcy = value1.Bankruptcy;
                    $scope.Judgement = value1.Judgement;
                    $scope.Acknowledgement = value1.Acknowledgement;

                    $scope.Capacity = value1.Capacity;
                    $scope.Position = value1.Position;
                    $scope.Competitors = value1.Competitors;
                    $scope.Declaration = value1.Declaration;
                    $scope.Accept = value1.Accept;
                    $scope.AcceptRemarks = value1.AcceptRemarks;
                    $scope.PrivacyPolicy = value1.PrivacyPolicy;
                    $scope.Status = value1.Status;
                }
            });


            angular.forEach($scope.Recruitmentevaluationdatas, function (value2, key2) {
                if ($scope.JobApplicationID == value2.JobApplicationID) {
                    $scope.id = value2.id;
                    $scope.Result = value2.Result;
                }
            });
            if ($scope.Status == "New" || $scope.Result == "Not-Selected") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.SID = ApplicationId;
                $scope.Update = false;


                $scope.Contract = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.JobApplication = false;
                $scope.Evaluation = false;
                $scope.JobInduction1 = false;
                $scope.JobInduction2 = false;

                $scope.Date1 = new Date();
                $scope.Date2 = null;
                $scope.Post = '';
                $scope.Date3 = null;
                $scope.ContractTemplate = '';
                $scope.EmpContract = '';
                $scope.basicForm3.$setPristine();
                $scope.basicForm3.$setUntouched();

                angular.forEach($scope.Recruitmentcontractdatas, function (value, key) {
                    if ($scope.Recruitmentcontractdatas.length > "0" && $scope.JobApplicationID == value.JobApplicationID && $scope.Name == value.Name) {

                        $scope.CID = value._id;
                        $scope.Name = value.Name;
                        $scope.Address = value.Address;
                        $scope.Date1 = value.Date1;
                        if ($scope.Date1 != null && $scope.Date1 != "") {
                            $scope.Date1 = new Date(value.Date1);
                        }
                        $scope.Date2 = value.Date2;
                        if ($scope.Date2 != null && $scope.Date2 != "") {
                            $scope.Date2 = new Date(value.Date2);
                        }
                        $scope.Post = value.Post;
                        $scope.Date3 = value.Date3;
                        if ($scope.Date3 != null && $scope.Date3 != "") {
                            $scope.Date3 = new Date(value.Date3);
                        }

                        $scope.ContractTemplate = value.ContractTemplate;
                        $scope.EmpContract = value.EmpContract;

                        $scope.Update = true;
                    }
                    //else {
                    //    
                    //    $scope.Date1 = new Date();
                    //    $scope.Date2 = null;
                    //    $scope.Post = '';
                    //    $scope.Date3 = null;
                    //    $scope.ContractTemplate = '';
                    //    $scope.EmpContract = '';
                    //    $scope.basicForm3.$setPristine();
                    //    $scope.basicForm3.$setUntouched();
                    //    $scope.Update = false;
                    //}
                });

                if ($scope.Recruitmentcontractdatas.length == "0") {

                    $scope.Date1 = new Date();
                    $scope.Date2 = null;
                    $scope.Post = '';
                    $scope.Date3 = null;
                    $scope.ContractTemplate = '';
                    $scope.EmpContract = '';

                    $scope.basicForm3.$setPristine();
                    $scope.basicForm3.$setUntouched();
                    $scope.Update = false;

                }
            }

        }

        $scope.contractSubmit = function () {
            $scope.IndexID = $scope.IndxID;
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentcontract/update",
                    data: {
                        _id: $scope.CID,
                        JobApplicationID: $scope.JobApplicationID,
                        Name: $scope.Name,
                        Address: $scope.Address,
                        Date1: $scope.Date1,
                        Date2: $scope.Date2,
                        Post: $scope.Post,
                        Date3: $scope.Date3,
                        ContractTemplate: $scope.ContractTemplate,
                        EmpContract: $scope.EmpContract,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.Date1,
                            NameinPassport: $scope.Name,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.Address,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: $scope.Status,
                        },
                    });

                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshContract();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentcontract/add",
                    data: {
                        Client_Id: Client_Id,
                        Name: $scope.Name,
                        JobApplicationID: $scope.JobApplicationID,
                        Address: $scope.Address,
                        Date1: $scope.Date1,
                        Date2: $scope.Date2,
                        Post: $scope.Post,
                        Date3: $scope.Date3,
                        ContractTemplate: $scope.ContractTemplate,
                        EmpContract: $scope.EmpContract,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.Date1,
                            NameinPassport: $scope.Name,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.Address,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: "Contract Prepared",
                        },
                    });
                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshContract();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshContract() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentcontract",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentcontractdata) {
                $scope.Recruitmentcontractdatas = Recruitmentcontractdata.data.data;
            });
        }



        $scope.JobInduction1info = function (ApplicationId, $index) {

            $scope.SID = ApplicationId;
            $scope.IndxID = $index;

            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                if (ApplicationId == value1.id) {

                    $scope.JAppID = value1.id;
                    $scope.JobApplicationID = value1.JobApplicationID;
                    $scope.PositionTitle = value1.PositionApplied;
                    $scope.DateofInterview = value1.DateofApplication;
                    if ($scope.DateofInterview != null && $scope.DateofInterview != "") {
                        $scope.DateofInterview = new Date(value1.DateofApplication);
                    }
                    $scope.Employee = value1.NameinPassport;
                    $scope.NameinNative = value1.NameinNative;
                    $scope.DOB = value1.DOB;
                    if ($scope.DOB != null && $scope.DOB != "") {
                        $scope.DOB = new Date(value1.DOB);
                    }
                    $scope.PlaceofBirth = value1.PlaceofBirth;
                    $scope.Citizenship = value1.Citizenship;
                    $scope.Race = value1.Race;
                    $scope.FINNumber = value1.FINNumber;
                    $scope.PassportNumber = value1.PassportNumber;
                    $scope.Sex = value1.Sex;
                    $scope.MaritalStatus = value1.MaritalStatus;
                    $scope.SingaporePR = value1.SingaporePR;

                    $scope.DateAttainedSPRStatus = value1.DateAttainedSPRStatus;
                    if ($scope.DateAttainedSPRStatus != null && $scope.DateAttainedSPRStatus != "") {
                        $scope.DateAttainedSPRStatus = new Date(value1.DateAttainedSPRStatus);
                    }
                    $scope.DrivingLicense = value1.DrivingLicense;

                    $scope.DLPassingDate = value1.DLPassingDate;
                    if ($scope.DLPassingDate != null && $scope.DLPassingDate != "") {
                        $scope.DLPassingDate = new Date(value1.DLPassingDate);
                    }

                    $scope.RTelephoneNumber = parseInt(value1.RTelephoneNumber);
                    $scope.MobileNumber = parseInt(value1.MobileNumber);
                    $scope.Email = value1.Email;
                    $scope.RAddress = value1.RAddress;
                    $scope.PRAddress = value1.PRAddress;
                    $scope.EmergencyContactName = value1.EmergencyContactName;
                    $scope.EmergencyContactRelationship = value1.EmergencyContactRelationship;
                    $scope.EmergencyContactRTelephoneNumber = parseInt(value1.EmergencyContactRTelephoneNumber);
                    $scope.EmergencyContactOTelephoneNumber = parseInt(value1.EmergencyContactOTelephoneNumber);
                    $scope.EmergencyContactMobileNumber = parseInt(value1.EmergencyContactMobileNumber);
                    $scope.EmergencyContactEmail = value1.EmergencyContactEmail;
                    $scope.EmergencyContactRAddress = value1.EmergencyContactRAddress;
                    $scope.NSStatus = value1.NSStatus;
                    $scope.ServiceStatus = value1.ServiceStatus;
                    $scope.ExemptedReason = value1.ExemptedReason;
                    $scope.ORD = value1.ORD;

                    $scope.EnlistmentDate = value1.EnlistmentDate;
                    if ($scope.EnlistmentDate != null && $scope.EnlistmentDate != "") {
                        $scope.EnlistmentDate = new Date(value1.EnlistmentDate);
                    }

                    $scope.RankAtORD = value1.RankAtORD;
                    $scope.ReservistDate = value1.ReservistDate;
                    if ($scope.ReservistDate != null && $scope.ReservistDate != "") {
                        $scope.ReservistDate = new Date(value1.ReservistDate);
                    }

                    $scope.ComputerLiteracy = value1.ComputerLiteracy;
                    $scope.Hobbies = value1.Hobbies;
                    $scope.MostEnjoyed = value1.MostEnjoyed;
                    $scope.LeastEnjoyed = value1.LeastEnjoyed;
                    $scope.ApplicationConsider = value1.ApplicationConsider;
                    $scope.ExpectedMonthlySalary = parseInt(value1.ExpectedMonthlySalary);
                    $scope.JoinUs = value1.JoinUs;
                    $scope.LearnAboutThisPosition = value1.LearnAboutThisPosition;
                    $scope.LearnAboutThisPositionOtherRemark = value1.LearnAboutThisPositionOtherRemark;
                    $scope.Offence = value1.Offence;
                    $scope.Bankruptcy = value1.Bankruptcy;
                    $scope.Judgement = value1.Judgement;
                    $scope.Acknowledgement = value1.Acknowledgement;

                    $scope.Capacity = value1.Capacity;
                    $scope.Position = value1.Position;
                    $scope.Competitors = value1.Competitors;
                    $scope.Declaration = value1.Declaration;
                    $scope.Accept = value1.Accept;
                    $scope.AcceptRemarks = value1.AcceptRemarks;
                    $scope.PrivacyPolicy = value1.PrivacyPolicy;
                    $scope.Status = value1.Status;
                }
            });


            angular.forEach($scope.Recruitmentevaluationdatas, function (value2, key2) {
                if ($scope.JobApplicationID == value2.JobApplicationID) {
                    $scope.id = value2.id;
                    $scope.Result = value2.Result;
                }
            });
            if ($scope.Status == "New" || $scope.Result == "Not-Selected") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.SID = ApplicationId;
                $scope.Update = false;


                $scope.JobInduction1 = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.JobApplication = false;
                $scope.Evaluation = false;
                $scope.Contract = false;
                $scope.JobInduction2 = false;

                $scope.ReturntoHRDate = new Date();
                $scope.SeniorName = '';
                $scope.DateofInduction = new Date();
                $scope.Attachement = '';

                $scope.Acknowledgment1 = '';
                $scope.Acknowledgment2 = '';
                $scope.Acknowledgment3 = '';
                $scope.Acknowledgment4 = '';
                $scope.Acknowledgment5 = '';
                $scope.Acknowledgment6 = '';
                $scope.Acknowledgment7 = '';
                $scope.Acknowledgment8 = '';
                $scope.Acknowledgment9 = '';
                $scope.Acknowledgment10 = '';
                $scope.Acknowledgment11 = '';
                $scope.Acknowledgment12 = '';
                $scope.Acknowledgment13 = '';
                $scope.Acknowledgment14 = '';
                $scope.Acknowledgment15 = '';
                $scope.Acknowledgment16 = '';
                $scope.Acknowledgment17 = '';
                $scope.Acknowledgment18 = '';
                $scope.Acknowledgment19 = '';
                $scope.Acknowledgment20 = '';
                $scope.Acknowledgment21 = '';
                $scope.Acknowledgment22 = '';
                $scope.Acknowledgment23 = '';
                $scope.Acknowledgment24 = '';
                $scope.Acknowledgment25 = '';
                $scope.Acknowledgment26 = '';
                $scope.Acknowledgment27 = '';
                $scope.Acknowledgment28 = '';
                $scope.Acknowledgment29 = '';
                $scope.Acknowledgment30 = '';
                $scope.Acknowledgment31 = '';
                $scope.Acknowledgment32 = '';
                $scope.Acknowledgment33 = '';
                $scope.Acknowledgment34 = '';
                $scope.Acknowledgment35 = '';
                $scope.Acknowledgment36 = '';
                $scope.GeneralConductAcknowledgment = '';
                $scope.StationedAcknowledgment = '';
                $scope.MobileAcknowledgment = '';
                $scope.DateofEmploymentAcknowledgment = '';

                $scope.TraineeLearn1 = '';
                $scope.TraineeLearn2 = '';
                $scope.TraineeLearn3 = '';
                $scope.TraineeLearn4 = '';
                $scope.TraineeLearn5 = '';
                $scope.TraineeLearn6 = '';
                $scope.TraineeLearn7 = '';
                $scope.TraineeLearn8 = '';
                $scope.TraineeLearn9 = '';
                $scope.TraineeLearn10 = '';
                $scope.TraineeLearn11 = '';
                $scope.TraineeLearn12 = '';
                $scope.TraineeLearn13 = '';
                $scope.TraineeLearn14 = '';
                $scope.TraineeLearn15 = '';
                $scope.TraineeLearn16 = '';
                $scope.TraineeLearn17 = '';
                $scope.TraineeLearn18 = '';
                $scope.TraineeLearn19 = '';
                $scope.TraineeLearn20 = '';
                $scope.TraineeLearn21 = '';
                $scope.TraineeLearn22 = '';
                $scope.TraineeLearn23 = '';
                $scope.TraineeLearn24 = '';
                $scope.TraineeLearn25 = '';
                $scope.TraineeLearn26 = '';
                $scope.TraineeLearn27 = '';
                $scope.TraineeLearn28 = '';
                $scope.TraineeLearn29 = '';
                $scope.TraineeLearn30 = '';
                $scope.TraineeLearn31 = '';
                $scope.TraineeLearn32 = '';
                $scope.TraineeLearn33 = '';
                $scope.TraineeLearn34 = '';
                $scope.TraineeLearn35 = '';
                $scope.TraineeLearn36 = '';
                $scope.GeneralConductTraineeLearn = '';
                $scope.StationedTraineeLearn = '';
                $scope.MobileTraineeLearn = '';
                $scope.DateofEmploymentTraineeLearn = '';

                $scope.Remarks1 = '';
                $scope.Remarks2 = '';
                $scope.Remarks3 = '';
                $scope.Remarks4 = '';
                $scope.Remarks5 = '';
                $scope.Remarks6 = '';
                $scope.Remarks7 = '';
                $scope.Remarks8 = '';
                $scope.Remarks9 = '';
                $scope.Remarks10 = '';
                $scope.Remarks11 = '';
                $scope.Remarks12 = '';
                $scope.Remarks13 = '';
                $scope.Remarks14 = '';
                $scope.Remarks15 = '';
                $scope.Remarks16 = '';
                $scope.Remarks17 = '';
                $scope.Remarks18 = '';
                $scope.Remarks19 = '';
                $scope.Remarks20 = '';
                $scope.Remarks21 = '';
                $scope.Remarks22 = '';
                $scope.Remarks23 = '';
                $scope.Remarks24 = '';
                $scope.Remarks25 = '';
                $scope.Remarks26 = '';
                $scope.Remarks27 = '';
                $scope.Remarks28 = '';
                $scope.Remarks29 = '';
                $scope.Remarks30 = '';
                $scope.Remarks31 = '';
                $scope.Remarks32 = '';
                $scope.Remarks33 = '';
                $scope.Remarks34 = '';
                $scope.Remarks35 = '';
                $scope.Remarks36 = '';
                $scope.GeneralConductRemarks = '';
                $scope.StationedRemarks = '';
                $scope.MobileRemarks = '';
                $scope.DateofEmploymentRemarks = '';

                $scope.SeniorCheckIntroduce = "No";
                $scope.SeniorCheckSeniors = "No";
                $scope.SeniorCheckEmergency = "No";
                $scope.SeniorCheckUniform = "No";
                $scope.SeniorCheckDressing = "No";
                $scope.SeniorCheckWorking = "No";
                $scope.SeniorCheckPunctuality = "No";
                $scope.SeniorCheckAbsenteesim = "No";
                $scope.SeniorCheckMedical = "No";
                $scope.SeniorCheckLunch = "No";
                $scope.SeniorCheckSafety = "No";
                $scope.SeniorCheckSubmission = "No";
                $scope.SeniorCheckOvertime = "No";
                $scope.SeniorCheckProducts = "No";
                $scope.SeniorCheckEmployee = "No";
                $scope.SeniorCheckMeeting = "No";
                $scope.SeniorCheckBoards = "No";
                $scope.SeniorCheckMinutes = "No";
                $scope.SeniorCheckHelp = "No";
                $scope.SeniorCheckHandle = "No";
                $scope.SeniorCheckVehicle = "No";
                $scope.SeniorCheckSmoking = "No";
                $scope.SeniorCheckAttendance = "No";
                $scope.SeniorCheckActivity = "No";
                $scope.SeniorCheckOvertimeAccounts = "No";
                $scope.SeniorCheckSheet = "No";
                $scope.SeniorCheckDaily = "No";
                $scope.SeniorCheckPayment = "No";
                $scope.SeniorCheckVehicleAccident = "No";
                $scope.SeniorCheckVehicleCompetition = "No";
                $scope.SeniorCheckTour = "No";
                $scope.SeniorCheckStaff = "No";
                $scope.SeniorCheckProductivity = "No";
                $scope.SeniorCheckQuality = "No";
                $scope.SeniorCheckColleagues = "No";
                $scope.SeniorCheckProcess = "No";
                $scope.GeneralConductSeniorCheck = "No";
                $scope.StationedSeniorCheck = "No";
                $scope.MobileSeniorCheck = "No";
                $scope.DateofEmploymentSeniorCheck = "No";

                $scope.basicForm4.$setPristine();
                $scope.basicForm4.$setUntouched();
                $scope.Update = false;

                //angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                //    if (ApplicationId == value1.id) {
                //        $scope.id = value1.id;
                //        $scope.JobApplicationID = value1.JobApplicationID;
                //        $scope.Employee = value1.NameinPassport;
                //        $scope.PositionTitle = value1.PositionApplied;
                //    }
                //});

                angular.forEach($scope.Recruitmentjobinductiondatas, function (value, key) {
                    if ($scope.Recruitmentjobinductiondatas.length > 0 && $scope.JobApplicationID == value.JobApplicationID && $scope.Employee == value.Employee) {

                        $scope.JID = value.id;
                        $scope.ReturntoHRDate = value.ReturntoHRDate;
                        if ($scope.ReturntoHRDate != null && $scope.ReturntoHRDate != "") {
                            $scope.ReturntoHRDate = new Date(value.ReturntoHRDate);
                        }
                        $scope.Employee = value.Employee;
                        $scope.SeniorName = value.SeniorName;
                        $scope.DateofInduction = value.DateofInduction;
                        if ($scope.DateofInduction != null && $scope.DateofInduction != "") {
                            $scope.DateofInduction = new Date(value.DateofInduction);
                        }
                        $scope.Attachement = value.Attachement;

                        $scope.Acknowledgment1 = value.Acknowledgment1;
                        $scope.Acknowledgment2 = value.Acknowledgment2;
                        $scope.Acknowledgment3 = value.Acknowledgment3;
                        $scope.Acknowledgment4 = value.Acknowledgment4;
                        $scope.Acknowledgment5 = value.Acknowledgment5;
                        $scope.Acknowledgment6 = value.Acknowledgment6;
                        $scope.Acknowledgment7 = value.Acknowledgment7;
                        $scope.Acknowledgment8 = value.Acknowledgment8;
                        $scope.Acknowledgment9 = value.Acknowledgment9;
                        $scope.Acknowledgment10 = value.Acknowledgment10;
                        $scope.Acknowledgment11 = value.Acknowledgment11;
                        $scope.Acknowledgment12 = value.Acknowledgment12;
                        $scope.Acknowledgment13 = value.Acknowledgment13;
                        $scope.Acknowledgment14 = value.Acknowledgment14;
                        $scope.Acknowledgment15 = value.Acknowledgment15;
                        $scope.Acknowledgment16 = value.Acknowledgment16;
                        $scope.Acknowledgment17 = value.Acknowledgment17;
                        $scope.Acknowledgment18 = value.Acknowledgment18;
                        $scope.Acknowledgment19 = value.Acknowledgment19;
                        $scope.Acknowledgment20 = value.Acknowledgment20;
                        $scope.Acknowledgment21 = value.Acknowledgment21;
                        $scope.Acknowledgment22 = value.Acknowledgment22;
                        $scope.Acknowledgment23 = value.Acknowledgment23;
                        $scope.Acknowledgment24 = value.Acknowledgment24;
                        $scope.Acknowledgment25 = value.Acknowledgment25;
                        $scope.Acknowledgment26 = value.Acknowledgment26;
                        $scope.Acknowledgment27 = value.Acknowledgment27;
                        $scope.Acknowledgment28 = value.Acknowledgment28;
                        $scope.Acknowledgment29 = value.Acknowledgment29;
                        $scope.Acknowledgment30 = value.Acknowledgment30;
                        $scope.Acknowledgment31 = value.Acknowledgment31;
                        $scope.Acknowledgment32 = value.Acknowledgment32;
                        $scope.Acknowledgment33 = value.Acknowledgment33;
                        $scope.Acknowledgment34 = value.Acknowledgment34;
                        $scope.Acknowledgment35 = value.Acknowledgment35;
                        $scope.Acknowledgment36 = value.Acknowledgment36;
                        $scope.GeneralConductAcknowledgment = value.GeneralConductAcknowledgment;
                        $scope.StationedAcknowledgment = value.StationedAcknowledgment;
                        $scope.MobileAcknowledgment = value.MobileAcknowledgment;
                        $scope.DateofEmploymentAcknowledgment = value.DateofEmploymentAcknowledgment;

                        $scope.TraineeLearn1 = value.TraineeLearn1;
                        $scope.TraineeLearn2 = value.TraineeLearn2;
                        $scope.TraineeLearn3 = value.TraineeLearn3;
                        $scope.TraineeLearn4 = value.TraineeLearn4;
                        $scope.TraineeLearn5 = value.TraineeLearn5;
                        $scope.TraineeLearn6 = value.TraineeLearn6;
                        $scope.TraineeLearn7 = value.TraineeLearn7;
                        $scope.TraineeLearn8 = value.TraineeLearn8;
                        $scope.TraineeLearn9 = value.TraineeLearn9;
                        $scope.TraineeLearn10 = value.TraineeLearn10;
                        $scope.TraineeLearn11 = value.TraineeLearn11;
                        $scope.TraineeLearn12 = value.TraineeLearn12;
                        $scope.TraineeLearn13 = value.TraineeLearn13;
                        $scope.TraineeLearn14 = value.TraineeLearn14;
                        $scope.TraineeLearn15 = value.TraineeLearn15;
                        $scope.TraineeLearn16 = value.TraineeLearn16;
                        $scope.TraineeLearn17 = value.TraineeLearn17;
                        $scope.TraineeLearn18 = value.TraineeLearn18;
                        $scope.TraineeLearn19 = value.TraineeLearn19;
                        $scope.TraineeLearn20 = value.TraineeLearn20;
                        $scope.TraineeLearn21 = value.TraineeLearn21;
                        $scope.TraineeLearn22 = value.TraineeLearn22;
                        $scope.TraineeLearn23 = value.TraineeLearn23;
                        $scope.TraineeLearn24 = value.TraineeLearn24;
                        $scope.TraineeLearn25 = value.TraineeLearn25;
                        $scope.TraineeLearn26 = value.TraineeLearn26;
                        $scope.TraineeLearn27 = value.TraineeLearn27;
                        $scope.TraineeLearn28 = value.TraineeLearn28;
                        $scope.TraineeLearn29 = value.TraineeLearn29;
                        $scope.TraineeLearn30 = value.TraineeLearn30;
                        $scope.TraineeLearn31 = value.TraineeLearn31;
                        $scope.TraineeLearn32 = value.TraineeLearn32;
                        $scope.TraineeLearn33 = value.TraineeLearn33;
                        $scope.TraineeLearn34 = value.TraineeLearn34;
                        $scope.TraineeLearn35 = value.TraineeLearn35;
                        $scope.TraineeLearn36 = value.TraineeLearn36;
                        $scope.GeneralConductTraineeLearn = value.GeneralConductTraineeLearn;
                        $scope.StationedTraineeLearn = value.StationedTraineeLearn;
                        $scope.MobileTraineeLearn = value.MobileTraineeLearn;
                        $scope.DateofEmploymentTraineeLearn = value.DateofEmploymentTraineeLearn;

                        $scope.Remarks1 = value.Remarks1;
                        $scope.Remarks2 = value.Remarks2;
                        $scope.Remarks3 = value.Remarks3;
                        $scope.Remarks4 = value.Remarks4;
                        $scope.Remarks5 = value.Remarks5;
                        $scope.Remarks6 = value.Remarks6;
                        $scope.Remarks7 = value.Remarks7;
                        $scope.Remarks8 = value.Remarks8;
                        $scope.Remarks9 = value.Remarks9;
                        $scope.Remarks10 = value.Remarks10;
                        $scope.Remarks11 = value.Remarks11;
                        $scope.Remarks12 = value.Remarks12;
                        $scope.Remarks13 = value.Remarks13;
                        $scope.Remarks14 = value.Remarks14;
                        $scope.Remarks15 = value.Remarks15;
                        $scope.Remarks16 = value.Remarks16;
                        $scope.Remarks17 = value.Remarks17;
                        $scope.Remarks18 = value.Remarks18;
                        $scope.Remarks19 = value.Remarks19;
                        $scope.Remarks20 = value.Remarks20;
                        $scope.Remarks21 = value.Remarks21;
                        $scope.Remarks22 = value.Remarks22;
                        $scope.Remarks23 = value.Remarks23;
                        $scope.Remarks24 = value.Remarks24;
                        $scope.Remarks25 = value.Remarks25;
                        $scope.Remarks26 = value.Remarks26;
                        $scope.Remarks27 = value.Remarks27;
                        $scope.Remarks28 = value.Remarks28;
                        $scope.Remarks29 = value.Remarks29;
                        $scope.Remarks30 = value.Remarks30;
                        $scope.Remarks31 = value.Remarks31;
                        $scope.Remarks32 = value.Remarks32;
                        $scope.Remarks33 = value.Remarks33;
                        $scope.Remarks34 = value.Remarks34;
                        $scope.Remarks35 = value.Remarks35;
                        $scope.Remarks36 = value.Remarks36;
                        $scope.GeneralConductRemarks = value.GeneralConductRemarks;
                        $scope.StationedRemarks = value.StationedRemarks;
                        $scope.MobileRemarks = value.MobileRemarks;
                        $scope.DateofEmploymentRemarks = value.DateofEmploymentRemarks;

                        $scope.SeniorCheckIntroduce = value.SeniorCheckIntroduce;
                        $scope.SeniorCheckSeniors = value.SeniorCheckSeniors;
                        $scope.SeniorCheckEmergency = value.SeniorCheckEmergency;
                        $scope.SeniorCheckUniform = value.SeniorCheckUniform;
                        $scope.SeniorCheckDressing = value.SeniorCheckDressing;
                        $scope.SeniorCheckWorking = value.SeniorCheckWorking;
                        $scope.SeniorCheckPunctuality = value.SeniorCheckPunctuality;
                        $scope.SeniorCheckAbsenteesim = value.SeniorCheckAbsenteesim;
                        $scope.SeniorCheckMedical = value.SeniorCheckMedical;
                        $scope.SeniorCheckLunch = value.SeniorCheckLunch;
                        $scope.SeniorCheckSafety = value.SeniorCheckSafety;
                        $scope.SeniorCheckSubmission = value.SeniorCheckSubmission;
                        $scope.SeniorCheckOvertime = value.SeniorCheckOvertime;
                        $scope.SeniorCheckProducts = value.SeniorCheckProducts;
                        $scope.SeniorCheckEmployee = value.SeniorCheckEmployee;
                        $scope.SeniorCheckMeeting = value.SeniorCheckMeeting;
                        $scope.SeniorCheckBoards = value.SeniorCheckBoards;
                        $scope.SeniorCheckMinutes = value.SeniorCheckMinutes;
                        $scope.SeniorCheckHelp = value.SeniorCheckHelp;
                        $scope.SeniorCheckHandle = value.SeniorCheckHandle;
                        $scope.SeniorCheckVehicle = value.SeniorCheckVehicle;
                        $scope.SeniorCheckSmoking = value.SeniorCheckSmoking;
                        $scope.SeniorCheckAttendance = value.SeniorCheckAttendance;
                        $scope.SeniorCheckActivity = value.SeniorCheckActivity;
                        $scope.SeniorCheckOvertimeAccounts = value.SeniorCheckOvertimeAccounts;
                        $scope.SeniorCheckSheet = value.SeniorCheckSheet;
                        $scope.SeniorCheckDaily = value.SeniorCheckDaily;
                        $scope.SeniorCheckPayment = value.SeniorCheckPayment;
                        $scope.SeniorCheckVehicleAccident = value.SeniorCheckVehicleAccident;
                        $scope.SeniorCheckVehicleCompetition = value.SeniorCheckVehicleCompetition;
                        $scope.SeniorCheckTour = value.SeniorCheckTour;
                        $scope.SeniorCheckStaff = value.SeniorCheckStaff;
                        $scope.SeniorCheckProductivity = value.SeniorCheckProductivity;
                        $scope.SeniorCheckQuality = value.SeniorCheckQuality;
                        $scope.SeniorCheckColleagues = value.SeniorCheckColleagues;
                        $scope.SeniorCheckProcess = value.SeniorCheckProcess;
                        $scope.GeneralConductSeniorCheck = value.GeneralConductSeniorCheck;
                        $scope.StationedSeniorCheck = value.StationedSeniorCheck;
                        $scope.MobileSeniorCheck = value.MobileSeniorCheck;
                        $scope.DateofEmploymentSeniorCheck = value.DateofEmploymentSeniorCheck;

                        $scope.Update = true;
                    }
                });

                if ($scope.Recruitmentjobinductiondatas.length == "0") {

                    $scope.ReturntoHRDate = new Date();
                    $scope.SeniorName = '';
                    $scope.DateofInduction = new Date();
                    $scope.Attachement = '';

                    $scope.Acknowledgment1 = '';
                    $scope.Acknowledgment2 = '';
                    $scope.Acknowledgment3 = '';
                    $scope.Acknowledgment4 = '';
                    $scope.Acknowledgment5 = '';
                    $scope.Acknowledgment6 = '';
                    $scope.Acknowledgment7 = '';
                    $scope.Acknowledgment8 = '';
                    $scope.Acknowledgment9 = '';
                    $scope.Acknowledgment10 = '';
                    $scope.Acknowledgment11 = '';
                    $scope.Acknowledgment12 = '';
                    $scope.Acknowledgment13 = '';
                    $scope.Acknowledgment14 = '';
                    $scope.Acknowledgment15 = '';
                    $scope.Acknowledgment16 = '';
                    $scope.Acknowledgment17 = '';
                    $scope.Acknowledgment18 = '';
                    $scope.Acknowledgment19 = '';
                    $scope.Acknowledgment20 = '';
                    $scope.Acknowledgment21 = '';
                    $scope.Acknowledgment22 = '';
                    $scope.Acknowledgment23 = '';
                    $scope.Acknowledgment24 = '';
                    $scope.Acknowledgment25 = '';
                    $scope.Acknowledgment26 = '';
                    $scope.Acknowledgment27 = '';
                    $scope.Acknowledgment28 = '';
                    $scope.Acknowledgment29 = '';
                    $scope.Acknowledgment30 = '';
                    $scope.Acknowledgment31 = '';
                    $scope.Acknowledgment32 = '';
                    $scope.Acknowledgment33 = '';
                    $scope.Acknowledgment34 = '';
                    $scope.Acknowledgment35 = '';
                    $scope.Acknowledgment36 = '';
                    $scope.GeneralConductAcknowledgment = '';
                    $scope.StationedAcknowledgment = '';
                    $scope.MobileAcknowledgment = '';
                    $scope.DateofEmploymentAcknowledgment = '';

                    $scope.TraineeLearn1 = '';
                    $scope.TraineeLearn2 = '';
                    $scope.TraineeLearn3 = '';
                    $scope.TraineeLearn4 = '';
                    $scope.TraineeLearn5 = '';
                    $scope.TraineeLearn6 = '';
                    $scope.TraineeLearn7 = '';
                    $scope.TraineeLearn8 = '';
                    $scope.TraineeLearn9 = '';
                    $scope.TraineeLearn10 = '';
                    $scope.TraineeLearn11 = '';
                    $scope.TraineeLearn12 = '';
                    $scope.TraineeLearn13 = '';
                    $scope.TraineeLearn14 = '';
                    $scope.TraineeLearn15 = '';
                    $scope.TraineeLearn16 = '';
                    $scope.TraineeLearn17 = '';
                    $scope.TraineeLearn18 = '';
                    $scope.TraineeLearn19 = '';
                    $scope.TraineeLearn20 = '';
                    $scope.TraineeLearn21 = '';
                    $scope.TraineeLearn22 = '';
                    $scope.TraineeLearn23 = '';
                    $scope.TraineeLearn24 = '';
                    $scope.TraineeLearn25 = '';
                    $scope.TraineeLearn26 = '';
                    $scope.TraineeLearn27 = '';
                    $scope.TraineeLearn28 = '';
                    $scope.TraineeLearn29 = '';
                    $scope.TraineeLearn30 = '';
                    $scope.TraineeLearn31 = '';
                    $scope.TraineeLearn32 = '';
                    $scope.TraineeLearn33 = '';
                    $scope.TraineeLearn34 = '';
                    $scope.TraineeLearn35 = '';
                    $scope.TraineeLearn36 = '';
                    $scope.GeneralConductTraineeLearn = '';
                    $scope.StationedTraineeLearn = '';
                    $scope.MobileTraineeLearn = '';
                    $scope.DateofEmploymentTraineeLearn = '';

                    $scope.Remarks1 = '';
                    $scope.Remarks2 = '';
                    $scope.Remarks3 = '';
                    $scope.Remarks4 = '';
                    $scope.Remarks5 = '';
                    $scope.Remarks6 = '';
                    $scope.Remarks7 = '';
                    $scope.Remarks8 = '';
                    $scope.Remarks9 = '';
                    $scope.Remarks10 = '';
                    $scope.Remarks11 = '';
                    $scope.Remarks12 = '';
                    $scope.Remarks13 = '';
                    $scope.Remarks14 = '';
                    $scope.Remarks15 = '';
                    $scope.Remarks16 = '';
                    $scope.Remarks17 = '';
                    $scope.Remarks18 = '';
                    $scope.Remarks19 = '';
                    $scope.Remarks20 = '';
                    $scope.Remarks21 = '';
                    $scope.Remarks22 = '';
                    $scope.Remarks23 = '';
                    $scope.Remarks24 = '';
                    $scope.Remarks25 = '';
                    $scope.Remarks26 = '';
                    $scope.Remarks27 = '';
                    $scope.Remarks28 = '';
                    $scope.Remarks29 = '';
                    $scope.Remarks30 = '';
                    $scope.Remarks31 = '';
                    $scope.Remarks32 = '';
                    $scope.Remarks33 = '';
                    $scope.Remarks34 = '';
                    $scope.Remarks35 = '';
                    $scope.Remarks36 = '';
                    $scope.GeneralConductRemarks = '';
                    $scope.StationedRemarks = '';
                    $scope.MobileRemarks = '';
                    $scope.DateofEmploymentRemarks = '';

                    $scope.SeniorCheckIntroduce = "No";
                    $scope.SeniorCheckSeniors = "No";
                    $scope.SeniorCheckEmergency = "No";
                    $scope.SeniorCheckUniform = "No";
                    $scope.SeniorCheckDressing = "No";
                    $scope.SeniorCheckWorking = "No";
                    $scope.SeniorCheckPunctuality = "No";
                    $scope.SeniorCheckAbsenteesim = "No";
                    $scope.SeniorCheckMedical = "No";
                    $scope.SeniorCheckLunch = "No";
                    $scope.SeniorCheckSafety = "No";
                    $scope.SeniorCheckSubmission = "No";
                    $scope.SeniorCheckOvertime = "No";
                    $scope.SeniorCheckProducts = "No";
                    $scope.SeniorCheckEmployee = "No";
                    $scope.SeniorCheckMeeting = "No";
                    $scope.SeniorCheckBoards = "No";
                    $scope.SeniorCheckMinutes = "No";
                    $scope.SeniorCheckHelp = "No";
                    $scope.SeniorCheckHandle = "No";
                    $scope.SeniorCheckVehicle = "No";
                    $scope.SeniorCheckSmoking = "No";
                    $scope.SeniorCheckAttendance = "No";
                    $scope.SeniorCheckActivity = "No";
                    $scope.SeniorCheckOvertimeAccounts = "No";
                    $scope.SeniorCheckSheet = "No";
                    $scope.SeniorCheckDaily = "No";
                    $scope.SeniorCheckPayment = "No";
                    $scope.SeniorCheckVehicleAccident = "No";
                    $scope.SeniorCheckVehicleCompetition = "No";
                    $scope.SeniorCheckTour = "No";
                    $scope.SeniorCheckStaff = "No";
                    $scope.SeniorCheckProductivity = "No";
                    $scope.SeniorCheckQuality = "No";
                    $scope.SeniorCheckColleagues = "No";
                    $scope.SeniorCheckProcess = "No";
                    $scope.GeneralConductSeniorCheck = "No";
                    $scope.StationedSeniorCheck = "No";
                    $scope.MobileSeniorCheck = "No";
                    $scope.DateofEmploymentSeniorCheck = "No";

                    $scope.basicForm4.$setPristine();
                    $scope.basicForm4.$setUntouched();
                    $scope.Update = false;
                }

            }

        }

        $scope.jobinductionSubmit = function () {


            $scope.IndexID = $scope.IndxID;
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/recruitmentjobinduction/update",
                    data: {
                        _id: $scope.JID,
                        JobApplicationID: $scope.JobApplicationID,

                        ReturntoHRDate: $scope.ReturntoHRDate,
                        Employee: $scope.Employee,
                        SeniorName: $scope.SeniorName,
                        DateofInduction: $scope.DateofInduction,
                        Attachement: $scope.Attachement,

                        Acknowledgment1: $scope.Acknowledgment1,
                        Acknowledgment2: $scope.Acknowledgment2,
                        Acknowledgment3: $scope.Acknowledgment3,
                        Acknowledgment4: $scope.Acknowledgment4,
                        Acknowledgment5: $scope.Acknowledgment5,
                        Acknowledgment6: $scope.Acknowledgment6,
                        Acknowledgment7: $scope.Acknowledgment7,
                        Acknowledgment8: $scope.Acknowledgment8,
                        Acknowledgment9: $scope.Acknowledgment9,
                        Acknowledgment10: $scope.Acknowledgment10,
                        Acknowledgment11: $scope.Acknowledgment11,
                        Acknowledgment12: $scope.Acknowledgment12,
                        Acknowledgment13: $scope.Acknowledgment13,
                        Acknowledgment14: $scope.Acknowledgment14,
                        Acknowledgment15: $scope.Acknowledgment15,
                        Acknowledgment16: $scope.Acknowledgment16,
                        Acknowledgment17: $scope.Acknowledgment17,
                        Acknowledgment18: $scope.Acknowledgment18,
                        Acknowledgment19: $scope.Acknowledgment19,
                        Acknowledgment20: $scope.Acknowledgment20,
                        Acknowledgment21: $scope.Acknowledgment21,
                        Acknowledgment22: $scope.Acknowledgment22,
                        Acknowledgment23: $scope.Acknowledgment23,
                        Acknowledgment24: $scope.Acknowledgment24,
                        Acknowledgment25: $scope.Acknowledgment25,
                        Acknowledgment26: $scope.Acknowledgment26,
                        Acknowledgment27: $scope.Acknowledgment27,
                        Acknowledgment28: $scope.Acknowledgment28,
                        Acknowledgment29: $scope.Acknowledgment29,
                        Acknowledgment30: $scope.Acknowledgment30,
                        Acknowledgment31: $scope.Acknowledgment31,
                        Acknowledgment32: $scope.Acknowledgment32,
                        Acknowledgment33: $scope.Acknowledgment33,
                        Acknowledgment34: $scope.Acknowledgment34,
                        Acknowledgment35: $scope.Acknowledgment35,
                        Acknowledgment36: $scope.Acknowledgment36,
                        GeneralConductAcknowledgment: $scope.GeneralConductAcknowledgment,
                        StationedAcknowledgment: $scope.StationedAcknowledgment,
                        MobileAcknowledgment: $scope.MobileAcknowledgment,
                        DateofEmploymentAcknowledgment: $scope.DateofEmploymentAcknowledgment,

                        TraineeLearn1: $scope.TraineeLearn1,
                        TraineeLearn2: $scope.TraineeLearn2,
                        TraineeLearn3: $scope.TraineeLearn3,
                        TraineeLearn4: $scope.TraineeLearn4,
                        TraineeLearn5: $scope.TraineeLearn5,
                        TraineeLearn6: $scope.TraineeLearn6,
                        TraineeLearn7: $scope.TraineeLearn7,
                        TraineeLearn8: $scope.TraineeLearn8,
                        TraineeLearn9: $scope.TraineeLearn9,
                        TraineeLearn10: $scope.TraineeLearn10,
                        TraineeLearn11: $scope.TraineeLearn11,
                        TraineeLearn12: $scope.TraineeLearn12,
                        TraineeLearn13: $scope.TraineeLearn13,
                        TraineeLearn14: $scope.TraineeLearn14,
                        TraineeLearn15: $scope.TraineeLearn15,
                        TraineeLearn16: $scope.TraineeLearn16,
                        TraineeLearn17: $scope.TraineeLearn17,
                        TraineeLearn18: $scope.TraineeLearn18,
                        TraineeLearn19: $scope.TraineeLearn19,
                        TraineeLearn20: $scope.TraineeLearn20,
                        TraineeLearn21: $scope.TraineeLearn21,
                        TraineeLearn22: $scope.TraineeLearn22,
                        TraineeLearn23: $scope.TraineeLearn23,
                        TraineeLearn24: $scope.TraineeLearn24,
                        TraineeLearn25: $scope.TraineeLearn25,
                        TraineeLearn26: $scope.TraineeLearn26,
                        TraineeLearn27: $scope.TraineeLearn27,
                        TraineeLearn28: $scope.TraineeLearn28,
                        TraineeLearn29: $scope.TraineeLearn29,
                        TraineeLearn30: $scope.TraineeLearn30,
                        TraineeLearn31: $scope.TraineeLearn31,
                        TraineeLearn32: $scope.TraineeLearn32,
                        TraineeLearn33: $scope.TraineeLearn33,
                        TraineeLearn34: $scope.TraineeLearn34,
                        TraineeLearn35: $scope.TraineeLearn35,
                        TraineeLearn36: $scope.TraineeLearn36,
                        GeneralConductTraineeLearn: $scope.GeneralConductTraineeLearn,
                        StationedTraineeLearn: $scope.StationedTraineeLearn,
                        MobileTraineeLearn: $scope.MobileTraineeLearn,
                        DateofEmploymentTraineeLearn: $scope.DateofEmploymentTraineeLearn,

                        Remarks1: $scope.Remarks1,
                        Remarks2: $scope.Remarks2,
                        Remarks3: $scope.Remarks3,
                        Remarks4: $scope.Remarks4,
                        Remarks5: $scope.Remarks5,
                        Remarks6: $scope.Remarks6,
                        Remarks7: $scope.Remarks7,
                        Remarks8: $scope.Remarks8,
                        Remarks9: $scope.Remarks9,
                        Remarks10: $scope.Remarks10,
                        Remarks11: $scope.Remarks11,
                        Remarks12: $scope.Remarks12,
                        Remarks13: $scope.Remarks13,
                        Remarks14: $scope.Remarks14,
                        Remarks15: $scope.Remarks15,
                        Remarks16: $scope.Remarks16,
                        Remarks17: $scope.Remarks17,
                        Remarks18: $scope.Remarks18,
                        Remarks19: $scope.Remarks19,
                        Remarks20: $scope.Remarks20,
                        Remarks21: $scope.Remarks21,
                        Remarks22: $scope.Remarks22,
                        Remarks23: $scope.Remarks23,
                        Remarks24: $scope.Remarks24,
                        Remarks25: $scope.Remarks25,
                        Remarks26: $scope.Remarks26,
                        Remarks27: $scope.Remarks27,
                        Remarks28: $scope.Remarks28,
                        Remarks29: $scope.Remarks29,
                        Remarks30: $scope.Remarks30,
                        Remarks31: $scope.Remarks31,
                        Remarks32: $scope.Remarks32,
                        Remarks33: $scope.Remarks33,
                        Remarks34: $scope.Remarks34,
                        Remarks35: $scope.Remarks35,
                        Remarks36: $scope.Remarks36,
                        GeneralConductRemarks: $scope.GeneralConductRemarks,
                        StationedRemarks: $scope.StationedRemarks,
                        MobileRemarks: $scope.MobileRemarks,
                        DateofEmploymentRemarks: $scope.DateofEmploymentRemarks,

                        SeniorCheckIntroduce: $scope.SeniorCheckIntroduce,
                        SeniorCheckSeniors: $scope.SeniorCheckSeniors,
                        SeniorCheckEmergency: $scope.SeniorCheckEmergency,
                        SeniorCheckUniform: $scope.SeniorCheckUniform,
                        SeniorCheckDressing: $scope.SeniorCheckDressing,
                        SeniorCheckWorking: $scope.SeniorCheckWorking,
                        SeniorCheckPunctuality: $scope.SeniorCheckPunctuality,
                        SeniorCheckAbsenteesim: $scope.SeniorCheckAbsenteesim,
                        SeniorCheckMedical: $scope.SeniorCheckMedical,
                        SeniorCheckLunch: $scope.SeniorCheckLunch,
                        SeniorCheckSafety: $scope.SeniorCheckSafety,
                        SeniorCheckSubmission: $scope.SeniorCheckSubmission,
                        SeniorCheckOvertime: $scope.SeniorCheckOvertime,
                        SeniorCheckProducts: $scope.SeniorCheckProducts,
                        SeniorCheckEmployee: $scope.SeniorCheckEmployee,
                        SeniorCheckMeeting: $scope.SeniorCheckMeeting,
                        SeniorCheckBoards: $scope.SeniorCheckBoards,
                        SeniorCheckMinutes: $scope.SeniorCheckMinutes,
                        SeniorCheckHelp: $scope.SeniorCheckHelp,
                        SeniorCheckHandle: $scope.SeniorCheckHandle,
                        SeniorCheckVehicle: $scope.SeniorCheckVehicle,
                        SeniorCheckSmoking: $scope.SeniorCheckSmoking,
                        SeniorCheckAttendance: $scope.SeniorCheckAttendance,
                        SeniorCheckActivity: $scope.SeniorCheckActivity,
                        SeniorCheckOvertimeAccounts: $scope.SeniorCheckOvertimeAccounts,
                        SeniorCheckSheet: $scope.SeniorCheckSheet,
                        SeniorCheckDaily: $scope.SeniorCheckDaily,
                        SeniorCheckPayment: $scope.SeniorCheckPayment,
                        SeniorCheckVehicleAccident: $scope.SeniorCheckVehicleAccident,
                        SeniorCheckVehicleCompetition: $scope.SeniorCheckVehicleCompetition,
                        SeniorCheckTour: $scope.SeniorCheckTour,
                        SeniorCheckStaff: $scope.SeniorCheckStaff,
                        SeniorCheckProductivity: $scope.SeniorCheckProductivity,
                        SeniorCheckQuality: $scope.SeniorCheckQuality,
                        SeniorCheckColleagues: $scope.SeniorCheckColleagues,
                        SeniorCheckProcess: $scope.SeniorCheckProcess,
                        GeneralConductSeniorCheck: $scope.GeneralConductSeniorCheck,
                        StationedSeniorCheck: $scope.StationedSeniorCheck,
                        MobileSeniorCheck: $scope.MobileSeniorCheck,
                        DateofEmploymentSeniorCheck: $scope.DateofEmploymentSeniorCheck,

                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.DateofInterview,
                            NameinPassport: $scope.Employee,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.PRAddress,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: $scope.Status,
                        },
                    });
                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshJobinductionGrid();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/recruitmentjobinduction/add",
                    data: {
                        Client_Id: Client_Id,
                        JobApplicationID: $scope.JobApplicationID,
                        ReturntoHRDate: $scope.ReturntoHRDate,
                        Employee: $scope.Employee,
                        SeniorName: $scope.SeniorName,
                        DateofInduction: $scope.DateofInduction,
                        Attachement: $scope.Attachement,
                        Acknowledgment1: $scope.Acknowledgment1,
                        Acknowledgment2: $scope.Acknowledgment2,
                        Acknowledgment3: $scope.Acknowledgment3,
                        Acknowledgment4: $scope.Acknowledgment4,
                        Acknowledgment5: $scope.Acknowledgment5,
                        Acknowledgment6: $scope.Acknowledgment6,
                        Acknowledgment7: $scope.Acknowledgment7,
                        Acknowledgment8: $scope.Acknowledgment8,
                        Acknowledgment9: $scope.Acknowledgment9,
                        Acknowledgment10: $scope.Acknowledgment10,
                        Acknowledgment11: $scope.Acknowledgment11,
                        Acknowledgment12: $scope.Acknowledgment12,
                        Acknowledgment13: $scope.Acknowledgment13,
                        Acknowledgment14: $scope.Acknowledgment14,
                        Acknowledgment15: $scope.Acknowledgment15,
                        Acknowledgment16: $scope.Acknowledgment16,
                        Acknowledgment17: $scope.Acknowledgment17,
                        Acknowledgment18: $scope.Acknowledgment18,
                        Acknowledgment19: $scope.Acknowledgment19,
                        Acknowledgment20: $scope.Acknowledgment20,
                        Acknowledgment21: $scope.Acknowledgment21,
                        Acknowledgment22: $scope.Acknowledgment22,
                        Acknowledgment23: $scope.Acknowledgment23,
                        Acknowledgment24: $scope.Acknowledgment24,
                        Acknowledgment25: $scope.Acknowledgment25,
                        Acknowledgment26: $scope.Acknowledgment26,
                        Acknowledgment27: $scope.Acknowledgment27,
                        Acknowledgment28: $scope.Acknowledgment28,
                        Acknowledgment29: $scope.Acknowledgment29,
                        Acknowledgment30: $scope.Acknowledgment30,
                        Acknowledgment31: $scope.Acknowledgment31,
                        Acknowledgment32: $scope.Acknowledgment32,
                        Acknowledgment33: $scope.Acknowledgment33,
                        Acknowledgment34: $scope.Acknowledgment34,
                        Acknowledgment35: $scope.Acknowledgment35,
                        Acknowledgment36: $scope.Acknowledgment36,
                        GeneralConductAcknowledgment: $scope.GeneralConductAcknowledgment,
                        StationedAcknowledgment: $scope.StationedAcknowledgment,
                        MobileAcknowledgment: $scope.MobileAcknowledgment,
                        DateofEmploymentAcknowledgment: $scope.DateofEmploymentAcknowledgment,

                        TraineeLearn1: $scope.TraineeLearn1,
                        TraineeLearn2: $scope.TraineeLearn2,
                        TraineeLearn3: $scope.TraineeLearn3,
                        TraineeLearn4: $scope.TraineeLearn4,
                        TraineeLearn5: $scope.TraineeLearn5,
                        TraineeLearn6: $scope.TraineeLearn6,
                        TraineeLearn7: $scope.TraineeLearn7,
                        TraineeLearn8: $scope.TraineeLearn8,
                        TraineeLearn9: $scope.TraineeLearn9,
                        TraineeLearn10: $scope.TraineeLearn10,
                        TraineeLearn11: $scope.TraineeLearn11,
                        TraineeLearn12: $scope.TraineeLearn12,
                        TraineeLearn13: $scope.TraineeLearn13,
                        TraineeLearn14: $scope.TraineeLearn14,
                        TraineeLearn15: $scope.TraineeLearn15,
                        TraineeLearn16: $scope.TraineeLearn16,
                        TraineeLearn17: $scope.TraineeLearn17,
                        TraineeLearn18: $scope.TraineeLearn18,
                        TraineeLearn19: $scope.TraineeLearn19,
                        TraineeLearn20: $scope.TraineeLearn20,
                        TraineeLearn21: $scope.TraineeLearn21,
                        TraineeLearn22: $scope.TraineeLearn22,
                        TraineeLearn23: $scope.TraineeLearn23,
                        TraineeLearn24: $scope.TraineeLearn24,
                        TraineeLearn25: $scope.TraineeLearn25,
                        TraineeLearn26: $scope.TraineeLearn26,
                        TraineeLearn27: $scope.TraineeLearn27,
                        TraineeLearn28: $scope.TraineeLearn28,
                        TraineeLearn29: $scope.TraineeLearn29,
                        TraineeLearn30: $scope.TraineeLearn30,
                        TraineeLearn31: $scope.TraineeLearn31,
                        TraineeLearn32: $scope.TraineeLearn32,
                        TraineeLearn33: $scope.TraineeLearn33,
                        TraineeLearn34: $scope.TraineeLearn34,
                        TraineeLearn35: $scope.TraineeLearn35,
                        TraineeLearn36: $scope.TraineeLearn36,
                        GeneralConductTraineeLearn: $scope.GeneralConductTraineeLearn,
                        StationedTraineeLearn: $scope.StationedTraineeLearn,
                        MobileTraineeLearn: $scope.MobileTraineeLearn,
                        DateofEmploymentTraineeLearn: $scope.DateofEmploymentTraineeLearn,

                        Remarks1: $scope.Remarks1,
                        Remarks2: $scope.Remarks2,
                        Remarks3: $scope.Remarks3,
                        Remarks4: $scope.Remarks4,
                        Remarks5: $scope.Remarks5,
                        Remarks6: $scope.Remarks6,
                        Remarks7: $scope.Remarks7,
                        Remarks8: $scope.Remarks8,
                        Remarks9: $scope.Remarks9,
                        Remarks10: $scope.Remarks10,
                        Remarks11: $scope.Remarks11,
                        Remarks12: $scope.Remarks12,
                        Remarks13: $scope.Remarks13,
                        Remarks14: $scope.Remarks14,
                        Remarks15: $scope.Remarks15,
                        Remarks16: $scope.Remarks16,
                        Remarks17: $scope.Remarks17,
                        Remarks18: $scope.Remarks18,
                        Remarks19: $scope.Remarks19,
                        Remarks20: $scope.Remarks20,
                        Remarks21: $scope.Remarks21,
                        Remarks22: $scope.Remarks22,
                        Remarks23: $scope.Remarks23,
                        Remarks24: $scope.Remarks24,
                        Remarks25: $scope.Remarks25,
                        Remarks26: $scope.Remarks26,
                        Remarks27: $scope.Remarks27,
                        Remarks28: $scope.Remarks28,
                        Remarks29: $scope.Remarks29,
                        Remarks30: $scope.Remarks30,
                        Remarks31: $scope.Remarks31,
                        Remarks32: $scope.Remarks32,
                        Remarks33: $scope.Remarks33,
                        Remarks34: $scope.Remarks34,
                        Remarks35: $scope.Remarks35,
                        Remarks36: $scope.Remarks36,
                        GeneralConductRemarks: $scope.GeneralConductRemarks,
                        StationedRemarks: $scope.StationedRemarks,
                        MobileRemarks: $scope.MobileRemarks,
                        DateofEmploymentRemarks: $scope.DateofEmploymentRemarks,


                        SeniorCheckIntroduce: $scope.SeniorCheckIntroduce,
                        SeniorCheckSeniors: $scope.SeniorCheckSeniors,
                        SeniorCheckEmergency: $scope.SeniorCheckEmergency,
                        SeniorCheckUniform: $scope.SeniorCheckUniform,
                        SeniorCheckDressing: $scope.SeniorCheckDressing,
                        SeniorCheckWorking: $scope.SeniorCheckWorking,
                        SeniorCheckPunctuality: $scope.SeniorCheckPunctuality,
                        SeniorCheckAbsenteesim: $scope.SeniorCheckAbsenteesim,
                        SeniorCheckMedical: $scope.SeniorCheckMedical,
                        SeniorCheckLunch: $scope.SeniorCheckLunch,
                        SeniorCheckSafety: $scope.SeniorCheckSafety,
                        SeniorCheckSubmission: $scope.SeniorCheckSubmission,
                        SeniorCheckOvertime: $scope.SeniorCheckOvertime,
                        SeniorCheckProducts: $scope.SeniorCheckProducts,
                        SeniorCheckEmployee: $scope.SeniorCheckEmployee,
                        SeniorCheckMeeting: $scope.SeniorCheckMeeting,
                        SeniorCheckBoards: $scope.SeniorCheckBoards,
                        SeniorCheckMinutes: $scope.SeniorCheckMinutes,
                        SeniorCheckHelp: $scope.SeniorCheckHelp,
                        SeniorCheckHandle: $scope.SeniorCheckHandle,
                        SeniorCheckVehicle: $scope.SeniorCheckVehicle,
                        SeniorCheckSmoking: $scope.SeniorCheckSmoking,
                        SeniorCheckAttendance: $scope.SeniorCheckAttendance,
                        SeniorCheckActivity: $scope.SeniorCheckActivity,
                        SeniorCheckOvertimeAccounts: $scope.SeniorCheckOvertimeAccounts,
                        SeniorCheckSheet: $scope.SeniorCheckSheet,
                        SeniorCheckDaily: $scope.SeniorCheckDaily,
                        SeniorCheckPayment: $scope.SeniorCheckPayment,
                        SeniorCheckVehicleAccident: $scope.SeniorCheckVehicleAccident,
                        SeniorCheckVehicleCompetition: $scope.SeniorCheckVehicleCompetition,
                        SeniorCheckTour: $scope.SeniorCheckTour,
                        SeniorCheckStaff: $scope.SeniorCheckStaff,
                        SeniorCheckProductivity: $scope.SeniorCheckProductivity,
                        SeniorCheckQuality: $scope.SeniorCheckQuality,
                        SeniorCheckColleagues: $scope.SeniorCheckColleagues,
                        SeniorCheckProcess: $scope.SeniorCheckProcess,
                        GeneralConductSeniorCheck: $scope.GeneralConductSeniorCheck,
                        StationedSeniorCheck: $scope.StationedSeniorCheck,
                        MobileSeniorCheck: $scope.MobileSeniorCheck,
                        DateofEmploymentSeniorCheck: $scope.DateofEmploymentSeniorCheck,

                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {

                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/recruitmentjobapplication/update",
                        data: {
                            _id: $scope.JAppID,
                            JobApplicationID: $scope.JobApplicationID,
                            PositionApplied: $scope.PositionTitle,
                            DateofApplication: $scope.DateofInterview,
                            NameinPassport: $scope.Employee,
                            NameinNative: $scope.NameinNative,
                            DOB: $scope.DOB,
                            PlaceofBirth: $scope.PlaceofBirth,
                            Citizenship: $scope.Citizenship,
                            Race: $scope.Race,
                            FINNumber: $scope.FINNumber,
                            PassportNumber: $scope.PassportNumber,
                            Sex: $scope.Sex,
                            MaritalStatus: $scope.MaritalStatus,
                            SingaporePR: $scope.SingaporePR,
                            DateAttainedSPRStatus: $scope.DateAttainedSPRStatus,
                            DrivingLicense: $scope.DrivingLicense,
                            DLPassingDate: $scope.DLPassingDate,

                            RTelephoneNumber: $scope.RTelephoneNumber,
                            MobileNumber: $scope.MobileNumber,
                            Email: $scope.Email,
                            RAddress: $scope.RAddress,
                            PRAddress: $scope.PRAddress,
                            EmergencyContactName: $scope.EmergencyContactName,
                            EmergencyContactRelationship: $scope.EmergencyContactRelationship,
                            EmergencyContactRTelephoneNumber: $scope.EmergencyContactRTelephoneNumber,
                            EmergencyContactOTelephoneNumber: $scope.EmergencyContactOTelephoneNumber,
                            EmergencyContactMobileNumber: $scope.EmergencyContactMobileNumber,
                            EmergencyContactEmail: $scope.EmergencyContactEmail,
                            EmergencyContactRAddress: $scope.EmergencyContactRAddress,
                            NSStatus: $scope.NSStatus,
                            ServiceStatus: $scope.ServiceStatus,
                            ExemptedReason: $scope.ExemptedReason,
                            ORD: $scope.ORD,

                            EnlistmentDate: $scope.EnlistmentDate,
                            RankAtORD: $scope.RankAtORD,
                            ReservistDate: $scope.ReservistDate,
                            ComputerLiteracy: $scope.ComputerLiteracy,
                            Hobbies: $scope.Hobbies,
                            MostEnjoyed: $scope.MostEnjoyed,
                            LeastEnjoyed: $scope.LeastEnjoyed,
                            ApplicationConsider: $scope.ApplicationConsider,
                            ExpectedMonthlySalary: $scope.ExpectedMonthlySalary,
                            JoinUs: $scope.JoinUs,
                            LearnAboutThisPosition: $scope.LearnAboutThisPosition,
                            LearnAboutThisPositionOtherRemark: $scope.LearnAboutThisPositionOtherRemark,
                            Offence: $scope.Offence,
                            Bankruptcy: $scope.Bankruptcy,
                            Judgement: $scope.Judgement,
                            Acknowledgement: $scope.Acknowledgement,

                            Capacity: $scope.Capacity,
                            Position: $scope.Position,
                            Competitors: $scope.Competitors,
                            Declaration: $scope.Declaration,
                            Accept: $scope.Accept,
                            AcceptRemarks: $scope.AcceptRemarks,
                            PrivacyPolicy: $scope.PrivacyPolicy,
                            Status: "Job Induction Conducted",
                        },
                    });

                    response.then(function (JAGList) {

                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        $scope.Recruitmentjobapplicationdatas[$scope.IndexID] = JAGList.data.data;
                        RefreshJobinductionGrid();
                        $scope.Showgrid();
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshJobinductionGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/recruitmentjobinduction",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Recruitmentjobinductiondata) {
                $scope.Recruitmentjobinductiondatas = Recruitmentjobinductiondata.data.data;
            });
        }


        $scope.OJT2 = function (ApplicationId) {

            $scope.SID = ApplicationId;
            angular.forEach($scope.Recruitmentjobapplicationdatas, function (value1, key1) {
                if (ApplicationId == value1.id) {
                    $scope.id = value1.id;
                    $scope.JobApplicationID = value1.JobApplicationID;
                    $scope.Status = value1.Status;
                }
            });
            angular.forEach($scope.Recruitmentevaluationdatas, function (value2, key2) {
                if ($scope.JobApplicationID == value2.JobApplicationID) {
                    $scope.id = value2.id;
                    $scope.Result = value2.Result;
                }
            });
            if ($scope.Status == "New" || $scope.Result == "Not-Selected") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.SID = ApplicationId;
                $scope.Update = false;


                $scope.JobInduction2 = true;
                $scope.rView = true;
                $scope.Grid = false;
                $scope.rAdd = false;
                $scope.rExport = false;
                $scope.rSearch = false;
                $scope.JobApplication = false;
                $scope.Contract = false;
                $scope.Evaluation = false;
                $scope.JobInduction1 = false;
            }
        }

        $scope.printJobApplication = function () {
            $scope.SID = $scope.SID;
            var url = $rootScope.ReportURL + "RecruitmentJobApplication.aspx?ID=" + $scope.SID;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.printEvaluation = function () {

            $scope.SID = $scope.EID;
            var url = $rootScope.ReportURL + "RecruitmentJobEvaluation.aspx?ID=" + $scope.SID;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.PrintContract = function () {

            $scope.SID = $scope.CID;
            var url = $rootScope.ReportURL + "RecruitmentJobContract.aspx?ID=" + $scope.SID;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.printOJT = function () {

            $scope.SID = $scope.JID;
            var url = $rootScope.ReportURL + "RecruitmentJobOjt.aspx?ID=" + $scope.SID;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };


        $scope.PrintApplication = function (JobApp, ApplicationId) {


            //RefreshGrid();
            $scope.PrintID = ApplicationId;


            var info = $scope.Recruitmentjobapplicationdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ApplicationId) {


                    $scope.JobApplicationID = info[i].JobApplicationID;
                    $scope.PositionApplied = info[i].PositionApplied;
                    $scope.DateofApplication = new Date(info[i].DateofApplication);
                    $scope.NameinPassport = info[i].NameinPassport;
                    $scope.NameinNative = info[i].NameinNative;
                    $scope.DOB = new Date(info[i].DOB);
                    $scope.PlaceofBirth = info[i].PlaceofBirth;
                    $scope.Citizenship = info[i].Citizenship;
                    $scope.Race = info[i].Race;
                    $scope.FINNumber = info[i].FINNumber;
                    $scope.PassportNumber = info[i].PassportNumber;
                    $scope.Sex = info[i].Sex;
                    $scope.MaritalStatus = info[i].MaritalStatus;
                    $scope.SingaporePR = info[i].SingaporePR;
                    $scope.DateAttainedSPRStatus = new Date(info[i].DateAttainedSPRStatus);
                    $scope.DrivingLicense = info[i].DrivingLicense;
                    $scope.DLPassingDate = new Date(info[i].DLPassingDate);

                    $scope.RTelephoneNumber = parseInt(info[i].RTelephoneNumber);
                    $scope.MobileNumber = parseInt(info[i].MobileNumber);
                    $scope.Email = info[i].Email;
                    $scope.RAddress = info[i].RAddress;
                    $scope.PRAddress = info[i].PRAddress;
                    $scope.EmergencyContactName = info[i].EmergencyContactName;
                    $scope.EmergencyContactRelationship = info[i].EmergencyContactRelationship;
                    $scope.EmergencyContactRTelephoneNumber = parseInt(info[i].EmergencyContactRTelephoneNumber);
                    $scope.EmergencyContactOTelephoneNumber = parseInt(info[i].EmergencyContactOTelephoneNumber);
                    $scope.EmergencyContactMobileNumber = parseInt(info[i].EmergencyContactMobileNumber);
                    $scope.EmergencyContactEmail = info[i].EmergencyContactEmail;
                    $scope.EmergencyContactRAddress = info[i].EmergencyContactRAddress;
                    $scope.NSStatus = info[i].NSStatus;
                    $scope.ServiceStatus = info[i].ServiceStatus;
                    $scope.ExemptedReason = info[i].ExemptedReason;
                    $scope.ORD = info[i].ORD;

                    $scope.EnlistmentDate = new Date(info[i].EnlistmentDate);
                    $scope.RankAtORD = info[i].RankAtORD;
                    $scope.ReservistDate = new Date(info[i].ReservistDate);
                    $scope.ComputerLiteracy = info[i].ComputerLiteracy;
                    $scope.Hobbies = info[i].Hobbies;
                    $scope.MostEnjoyed = info[i].MostEnjoyed;
                    $scope.LeastEnjoyed = info[i].LeastEnjoyed;
                    $scope.ApplicationConsider = info[i].ApplicationConsider;
                    $scope.ExpectedMonthlySalary = parseInt(info[i].ExpectedMonthlySalary);
                    $scope.JoinUs = info[i].JoinUs;
                    $scope.LearnAboutThisPosition = info[i].LearnAboutThisPosition;
                    $scope.LearnAboutThisPositionOtherRemark = info[i].LearnAboutThisPositionOtherRemark;
                    $scope.Offence = info[i].Offence;
                    $scope.Bankruptcy = info[i].Bankruptcy;
                    $scope.Judgement = info[i].Judgement;
                    $scope.Acknowledgement = info[i].Acknowledgement;

                    $scope.Capacity = info[i].Capacity;
                    $scope.Position = info[i].Position;
                    $scope.Competitors = info[i].Competitors;
                    $scope.Declaration = info[i].Declaration;
                    $scope.SignatureofApplicant = info[i].SignatureofApplicant;
                    $scope.PrivacyPolicy = info[i].PrivacyPolicy;
                }
            }


            //$scope.Pop = true;
            var innerContents = document.getElementById(JobApp).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        $scope.PrintEvaluationdffds = function (InterviewEval, ApplicationId) {




            //RefreshGrid();
            $scope.PrintID = ApplicationId;


            var Evaluationinfo = $scope.Recruitmentevaluationdatas

            var info = $scope.Recruitmentjobapplicationdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ApplicationId) {

                    $scope.JobApplicationID = info[i].JobApplicationID;
                    $scope.PositionTitle = info[i].PositionApplied;
                    $scope.DateofInterview = new Date(info[i].DateofApplication);
                    $scope.NameofCandidate = info[i].NameinPassport;
                    $scope.FINNumber = info[i].FINNumber;
                }

            }

            for (var j = 0; j < Evaluationinfo.length; j++) {
                if (Evaluationinfo.length > "0" && $scope.JobApplicationID == Evaluationinfo[j].JobApplicationID && $scope.NameofCandidate == Evaluationinfo[j].NameofCandidate) {

                    $scope.EID = Evaluationinfo[j].id;
                    $scope.NameofCandidate = Evaluationinfo[j].NameofCandidate;
                    $scope.PositionTitle = Evaluationinfo[j].PositionTitle;
                    $scope.Department = Evaluationinfo[j].Department;
                    $scope.Interviewer = Evaluationinfo[j].Interviewer;
                    $scope.DateofInterview = new Date(Evaluationinfo[j].DateofInterview);
                    $scope.CompletedBy = Evaluationinfo[j].CompletedBy;
                    $scope.EducationalComment = Evaluationinfo[j].EducationalComment;
                    $scope.Educational = Evaluationinfo[j].Educational;
                    $scope.ExperienceComment = Evaluationinfo[j].ExperienceComment;
                    $scope.Experience = Evaluationinfo[j].Experience;
                    $scope.QualificationsComment = Evaluationinfo[j].QualificationsComment;
                    $scope.Qualifications = Evaluationinfo[j].Qualifications;
                    $scope.CommunicationComment = Evaluationinfo[j].CommunicationComment;
                    $scope.Communication = Evaluationinfo[j].Communication;
                    $scope.PresentationComment = Evaluationinfo[j].PresentationComment;
                    $scope.Presentation = Evaluationinfo[j].Presentation;
                    $scope.EnthusiasmComment = Evaluationinfo[j].EnthusiasmComment;
                    $scope.Enthusiasm = Evaluationinfo[j].Enthusiasm;
                    $scope.StabilityComment = Evaluationinfo[j].StabilityComment;
                    $scope.Stability = Evaluationinfo[j].Stability;
                    $scope.ImpressionComment = Evaluationinfo[j].ImpressionComment;
                    $scope.Impression = Evaluationinfo[j].Impression;
                    $scope.CandidateStrength = Evaluationinfo[j].CandidateStrength;
                    $scope.CandidateWeakness = Evaluationinfo[j].CandidateWeakness;
                    $scope.AdditionalComment = Evaluationinfo[j].AdditionalComment;
                    $scope.Result = Evaluationinfo[j].Result;

                }

            }





            //$scope.Pop = true;
            var innerContents = document.getElementById(InterviewEval).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        $scope.fgfdgfractddfdsf = function (Con, ApplicationId) {




            //RefreshGrid();
            $scope.PrintID = ApplicationId;

            var Contractinfo = $scope.Recruitmentcontractdatas

            var info = $scope.Recruitmentjobapplicationdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ApplicationId) {

                    $scope.JobApplicationID = info[i].JobApplicationID;
                    $scope.Name = info[i].NameinPassport;
                    $scope.Address = info[i].PRAddress;
                    $scope.PositionTitle = info[i].PositionApplied;
                    $scope.DateofInterview = new Date(info[i].DateofApplication);
                    $scope.FINNumber = info[i].FINNumber;

                }
            }

            for (var j = 0; j < Contractinfo.length; j++) {
                if (Contractinfo.length > "0" && $scope.JobApplicationID == Contractinfo[j].JobApplicationID && $scope.Name == Contractinfo[j].Name) {

                    $scope.CID = Contractinfo[j].id;
                    $scope.Name = Contractinfo[j].Name;
                    $scope.Address = Contractinfo[j].Address;
                    $scope.Date1 = new Date(Contractinfo[j].Date1);
                    $scope.Date2 = new Date(Contractinfo[j].Date2);
                    $scope.Post = Contractinfo[j].Post;
                    $scope.Date3 = new Date(Contractinfo[j].Date3);
                    $scope.ContractTemplate = Contractinfo[j].ContractTemplate;
                    $scope.EmpContract = Contractinfo[j].EmpContract;
                }
            }





            //$scope.Pop = true;
            var innerContents = document.getElementById(Con).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        $scope.PrintJobInduction1 = function (JI1, ApplicationId) {


            //RefreshGrid();
            $scope.PrintID = ApplicationId;

            var Jobinfo = $scope.Recruitmentjobinductiondatas

            var info = $scope.Recruitmentjobapplicationdatas
            for (var i = 0; i < info.length; i++) {
                if (info[i].id == ApplicationId) {

                    $scope.JobApplicationID = info[i].JobApplicationID;
                    $scope.Employee = info[i].NameinPassport;
                    $scope.PositionTitle = info[i].PositionApplied;
                    //$scope.DateofInterview = new Date(info[i].DateofApplication);
                }
            }

            for (var j = 0; j < Jobinfo.length; j++) {

                if (Jobinfo.length > "0" && $scope.JobApplicationID == Jobinfo[j].JobApplicationID && $scope.Employee == Jobinfo[j].Employee) {

                    $scope.Update = true;

                    $scope.JID = Jobinfo[j].id;
                    $scope.ReturntoHRDate = new Date(Jobinfo[j].ReturntoHRDate);
                    $scope.Employee = Jobinfo[j].Employee;
                    $scope.SeniorName = Jobinfo[j].SeniorName;
                    $scope.DateofInduction = new Date(Jobinfo[j].DateofInduction);
                    $scope.Attachement = Jobinfo[j].Attachement;

                    $scope.Acknowledgment1 = Jobinfo[j].Acknowledgment1;
                    $scope.Acknowledgment2 = Jobinfo[j].Acknowledgment2;
                    $scope.Acknowledgment3 = Jobinfo[j].Acknowledgment3;
                    $scope.Acknowledgment4 = Jobinfo[j].Acknowledgment4;
                    $scope.Acknowledgment5 = Jobinfo[j].Acknowledgment5;
                    $scope.Acknowledgment6 = Jobinfo[j].Acknowledgment6;
                    $scope.Acknowledgment7 = Jobinfo[j].Acknowledgment7;
                    $scope.Acknowledgment8 = Jobinfo[j].Acknowledgment8;
                    $scope.Acknowledgment9 = Jobinfo[j].Acknowledgment9;
                    $scope.Acknowledgment10 = Jobinfo[j].Acknowledgment10;
                    $scope.Acknowledgment11 = Jobinfo[j].Acknowledgment11;
                    $scope.Acknowledgment12 = Jobinfo[j].Acknowledgment12;
                    $scope.Acknowledgment13 = Jobinfo[j].Acknowledgment13;
                    $scope.Acknowledgment14 = Jobinfo[j].Acknowledgment14;
                    $scope.Acknowledgment15 = Jobinfo[j].Acknowledgment15;
                    $scope.Acknowledgment16 = Jobinfo[j].Acknowledgment16;
                    $scope.Acknowledgment17 = Jobinfo[j].Acknowledgment17;
                    $scope.Acknowledgment18 = Jobinfo[j].Acknowledgment18;
                    $scope.Acknowledgment19 = Jobinfo[j].Acknowledgment19;
                    $scope.Acknowledgment20 = Jobinfo[j].Acknowledgment20;
                    $scope.Acknowledgment21 = Jobinfo[j].Acknowledgment21;
                    $scope.Acknowledgment22 = Jobinfo[j].Acknowledgment22;
                    $scope.Acknowledgment23 = Jobinfo[j].Acknowledgment23;
                    $scope.Acknowledgment24 = Jobinfo[j].Acknowledgment24;
                    $scope.Acknowledgment25 = Jobinfo[j].Acknowledgment25;
                    $scope.Acknowledgment26 = Jobinfo[j].Acknowledgment26;
                    $scope.Acknowledgment27 = Jobinfo[j].Acknowledgment27;
                    $scope.Acknowledgment28 = Jobinfo[j].Acknowledgment28;
                    $scope.Acknowledgment29 = Jobinfo[j].Acknowledgment29;
                    $scope.Acknowledgment30 = Jobinfo[j].Acknowledgment30;
                    $scope.Acknowledgment31 = Jobinfo[j].Acknowledgment31;
                    $scope.Acknowledgment32 = Jobinfo[j].Acknowledgment32;
                    $scope.Acknowledgment33 = Jobinfo[j].Acknowledgment33;
                    $scope.Acknowledgment34 = Jobinfo[j].Acknowledgment34;
                    $scope.Acknowledgment35 = Jobinfo[j].Acknowledgment35;
                    $scope.Acknowledgment36 = Jobinfo[j].Acknowledgment36;
                    $scope.GeneralConductAcknowledgment = Jobinfo[j].GeneralConductAcknowledgment;
                    $scope.StationedAcknowledgment = Jobinfo[j].StationedAcknowledgment;
                    $scope.MobileAcknowledgment = Jobinfo[j].MobileAcknowledgment;
                    $scope.DateofEmploymentAcknowledgment = Jobinfo[j].DateofEmploymentAcknowledgment;

                    $scope.TraineeLearn1 = Jobinfo[j].TraineeLearn1;
                    $scope.TraineeLearn2 = Jobinfo[j].TraineeLearn2;
                    $scope.TraineeLearn3 = Jobinfo[j].TraineeLearn3;
                    $scope.TraineeLearn4 = Jobinfo[j].TraineeLearn4;
                    $scope.TraineeLearn5 = Jobinfo[j].TraineeLearn5;
                    $scope.TraineeLearn6 = Jobinfo[j].TraineeLearn6;
                    $scope.TraineeLearn7 = Jobinfo[j].TraineeLearn7;
                    $scope.TraineeLearn8 = Jobinfo[j].TraineeLearn8;
                    $scope.TraineeLearn9 = Jobinfo[j].TraineeLearn9;
                    $scope.TraineeLearn10 = Jobinfo[j].TraineeLearn10;
                    $scope.TraineeLearn11 = Jobinfo[j].TraineeLearn11;
                    $scope.TraineeLearn12 = Jobinfo[j].TraineeLearn12;
                    $scope.TraineeLearn13 = Jobinfo[j].TraineeLearn13;
                    $scope.TraineeLearn14 = Jobinfo[j].TraineeLearn14;
                    $scope.TraineeLearn15 = Jobinfo[j].TraineeLearn15;
                    $scope.TraineeLearn16 = Jobinfo[j].TraineeLearn16;
                    $scope.TraineeLearn17 = Jobinfo[j].TraineeLearn17;
                    $scope.TraineeLearn18 = Jobinfo[j].TraineeLearn18;
                    $scope.TraineeLearn19 = Jobinfo[j].TraineeLearn19;
                    $scope.TraineeLearn20 = Jobinfo[j].TraineeLearn20;
                    $scope.TraineeLearn21 = Jobinfo[j].TraineeLearn21;
                    $scope.TraineeLearn22 = Jobinfo[j].TraineeLearn22;
                    $scope.TraineeLearn23 = Jobinfo[j].TraineeLearn23;
                    $scope.TraineeLearn24 = Jobinfo[j].TraineeLearn24;
                    $scope.TraineeLearn25 = Jobinfo[j].TraineeLearn25;
                    $scope.TraineeLearn26 = Jobinfo[j].TraineeLearn26;
                    $scope.TraineeLearn27 = Jobinfo[j].TraineeLearn27;
                    $scope.TraineeLearn28 = Jobinfo[j].TraineeLearn28;
                    $scope.TraineeLearn29 = Jobinfo[j].TraineeLearn29;
                    $scope.TraineeLearn30 = Jobinfo[j].TraineeLearn30;
                    $scope.TraineeLearn31 = Jobinfo[j].TraineeLearn31;
                    $scope.TraineeLearn32 = Jobinfo[j].TraineeLearn32;
                    $scope.TraineeLearn33 = Jobinfo[j].TraineeLearn33;
                    $scope.TraineeLearn34 = Jobinfo[j].TraineeLearn34;
                    $scope.TraineeLearn35 = Jobinfo[j].TraineeLearn35;
                    $scope.TraineeLearn36 = Jobinfo[j].TraineeLearn36;
                    $scope.GeneralConductTraineeLearn = Jobinfo[j].GeneralConductTraineeLearn;
                    $scope.StationedTraineeLearn = Jobinfo[j].StationedTraineeLearn;
                    $scope.MobileTraineeLearn = Jobinfo[j].MobileTraineeLearn;
                    $scope.DateofEmploymentTraineeLearn = Jobinfo[j].DateofEmploymentTraineeLearn;

                    $scope.Remarks1 = Jobinfo[j].Remarks1;
                    $scope.Remarks2 = Jobinfo[j].Remarks2;
                    $scope.Remarks3 = Jobinfo[j].Remarks3;
                    $scope.Remarks4 = Jobinfo[j].Remarks4;
                    $scope.Remarks5 = Jobinfo[j].Remarks5;
                    $scope.Remarks6 = Jobinfo[j].Remarks6;
                    $scope.Remarks7 = Jobinfo[j].Remarks7;
                    $scope.Remarks8 = Jobinfo[j].Remarks8;
                    $scope.Remarks9 = Jobinfo[j].Remarks9;
                    $scope.Remarks10 = Jobinfo[j].Remarks10;
                    $scope.Remarks11 = Jobinfo[j].Remarks11;
                    $scope.Remarks12 = Jobinfo[j].Remarks12;
                    $scope.Remarks13 = Jobinfo[j].Remarks13;
                    $scope.Remarks14 = Jobinfo[j].Remarks14;
                    $scope.Remarks15 = Jobinfo[j].Remarks15;
                    $scope.Remarks16 = Jobinfo[j].Remarks16;
                    $scope.Remarks17 = Jobinfo[j].Remarks17;
                    $scope.Remarks18 = Jobinfo[j].Remarks18;
                    $scope.Remarks19 = Jobinfo[j].Remarks19;
                    $scope.Remarks20 = Jobinfo[j].Remarks20;
                    $scope.Remarks21 = Jobinfo[j].Remarks21;
                    $scope.Remarks22 = Jobinfo[j].Remarks22;
                    $scope.Remarks23 = Jobinfo[j].Remarks23;
                    $scope.Remarks24 = Jobinfo[j].Remarks24;
                    $scope.Remarks25 = Jobinfo[j].Remarks25;
                    $scope.Remarks26 = Jobinfo[j].Remarks26;
                    $scope.Remarks27 = Jobinfo[j].Remarks27;
                    $scope.Remarks28 = Jobinfo[j].Remarks28;
                    $scope.Remarks29 = Jobinfo[j].Remarks29;
                    $scope.Remarks30 = Jobinfo[j].Remarks30;
                    $scope.Remarks31 = Jobinfo[j].Remarks31;
                    $scope.Remarks32 = Jobinfo[j].Remarks32;
                    $scope.Remarks33 = Jobinfo[j].Remarks33;
                    $scope.Remarks34 = Jobinfo[j].Remarks34;
                    $scope.Remarks35 = Jobinfo[j].Remarks35;
                    $scope.Remarks36 = Jobinfo[j].Remarks36;
                    $scope.GeneralConductRemarks = Jobinfo[j].GeneralConductRemarks;
                    $scope.StationedRemarks = Jobinfo[j].StationedRemarks;
                    $scope.MobileRemarks = Jobinfo[j].MobileRemarks;
                    $scope.DateofEmploymentRemarks = Jobinfo[j].DateofEmploymentRemarks;

                    $scope.SeniorCheckIntroduce = Jobinfo[j].SeniorCheckIntroduce;
                    $scope.SeniorCheckSeniors = Jobinfo[j].SeniorCheckSeniors;
                    $scope.SeniorCheckEmergency = Jobinfo[j].SeniorCheckEmergency;
                    $scope.SeniorCheckUniform = Jobinfo[j].SeniorCheckUniform;
                    $scope.SeniorCheckDressing = Jobinfo[j].SeniorCheckDressing;
                    $scope.SeniorCheckWorking = Jobinfo[j].SeniorCheckWorking;
                    $scope.SeniorCheckPunctuality = Jobinfo[j].SeniorCheckPunctuality;
                    $scope.SeniorCheckAbsenteesim = Jobinfo[j].SeniorCheckAbsenteesim;
                    $scope.SeniorCheckMedical = Jobinfo[j].SeniorCheckMedical;
                    $scope.SeniorCheckLunch = Jobinfo[j].SeniorCheckLunch;
                    $scope.SeniorCheckSafety = Jobinfo[j].SeniorCheckSafety;
                    $scope.SeniorCheckSubmission = Jobinfo[j].SeniorCheckSubmission;
                    $scope.SeniorCheckOvertime = Jobinfo[j].SeniorCheckOvertime;
                    $scope.SeniorCheckProducts = Jobinfo[j].SeniorCheckProducts;
                    $scope.SeniorCheckEmployee = Jobinfo[j].SeniorCheckEmployee;
                    $scope.SeniorCheckMeeting = Jobinfo[j].SeniorCheckMeeting;
                    $scope.SeniorCheckBoards = Jobinfo[j].SeniorCheckBoards;
                    $scope.SeniorCheckMinutes = Jobinfo[j].SeniorCheckMinutes;
                    $scope.SeniorCheckHelp = Jobinfo[j].SeniorCheckHelp;
                    $scope.SeniorCheckHandle = Jobinfo[j].SeniorCheckHandle;
                    $scope.SeniorCheckVehicle = Jobinfo[j].SeniorCheckVehicle;
                    $scope.SeniorCheckSmoking = Jobinfo[j].SeniorCheckSmoking;
                    $scope.SeniorCheckAttendance = Jobinfo[j].SeniorCheckAttendance;
                    $scope.SeniorCheckActivity = Jobinfo[j].SeniorCheckActivity;
                    $scope.SeniorCheckOvertimeAccounts = Jobinfo[j].SeniorCheckOvertimeAccounts;
                    $scope.SeniorCheckSheet = Jobinfo[j].SeniorCheckSheet;
                    $scope.SeniorCheckDaily = Jobinfo[j].SeniorCheckDaily;
                    $scope.SeniorCheckPayment = Jobinfo[j].SeniorCheckPayment;
                    $scope.SeniorCheckVehicleAccident = Jobinfo[j].SeniorCheckVehicleAccident;
                    $scope.SeniorCheckVehicleCompetition = Jobinfo[j].SeniorCheckVehicleCompetition;
                    $scope.SeniorCheckTour = Jobinfo[j].SeniorCheckTour;
                    $scope.SeniorCheckStaff = Jobinfo[j].SeniorCheckStaff;
                    $scope.SeniorCheckProductivity = Jobinfo[j].SeniorCheckProductivity;
                    $scope.SeniorCheckQuality = Jobinfo[j].SeniorCheckQuality;
                    $scope.SeniorCheckColleagues = Jobinfo[j].SeniorCheckColleagues;
                    $scope.SeniorCheckProcess = Jobinfo[j].SeniorCheckProcess;
                    $scope.GeneralConductSeniorCheck = Jobinfo[j].GeneralConductSeniorCheck;
                    $scope.StationedSeniorCheck = Jobinfo[j].StationedSeniorCheck;
                    $scope.MobileSeniorCheck = Jobinfo[j].MobileSeniorCheck;
                    $scope.DateofEmploymentSeniorCheck = Jobinfo[j].DateofEmploymentSeniorCheck;


                }
            }


            //$scope.Pop = true;
            var innerContents = document.getElementById(JI1).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;


        }

        $scope.PrintJobInduction2 = function (JI2, ApplicationId) {


            //RefreshGrid();
            $scope.PrintID = ApplicationId;


            //$scope.Pop = true;
            var innerContents = document.getElementById(JI2).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;

        }

        var vm = this;

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];

        $scope.CountyList = [
            { "name": "Afghanistan" },
            { "name": "Albania" },
            { "name": "Algeria" },
            { "name": "American Samoa" },
            { "name": "AndorrA" },
            { "name": "Angola" },
            { "name": "Anguilla" },
            { "name": "Antarctica" },
            { "name": "Antigua and Barbuda" },
            { "name": "Argentina" },
            { "name": "Armenia" },
            { "name": "Aruba" },
            { "name": "Australia" },
            { "name": "Austria" },
            { "name": "Azerbaijan" },
            { "name": "Bahamas" },
            { "name": "Bahrain" },
            { "name": "Bangladesh" },
            { "name": "Barbados" },
            { "name": "Belarus" },
            { "name": "Belgium" },
            { "name": "Belize" },
            { "name": "Benin" },
            { "name": "Bermuda" },
            { "name": "Bhutan" },
            { "name": "Bolivia" },
            { "name": "Bosnia and Herzegovina" },
            { "name": "Botswana" },
            { "name": "Bouvet Island" },
            { "name": "Brazil" },
            { "name": "British Indian Ocean Territory" },
            { "name": "Brunei Darussalam" },
            { "name": "Bulgaria" },
            { "name": "Burkina Faso" },
            { "name": "Burundi" },
            { "name": "Cambodia" },
            { "name": "Cameroon" },
            { "name": "Canada" },
            { "name": "Cape Verde" },
            { "name": "Cayman Islands" },
            { "name": "Central African Republic" },
            { "name": "Chad" },
            { "name": "Chile" },
            { "name": "China" },
            { "name": "Christmas Island" },
            { "name": "Cocos (Keeling) Islands" },
            { "name": "Colombia" },
            { "name": "Comoros" },
            { "name": "Congo" },
            { "name": "Congo, The Democratic Republic of the" },
            { "name": "Cook Islands" },
            { "name": "Costa Rica" },
            { "name": "Cote D'Ivoire" },
            { "name": "Croatia" },
            { "name": "Cuba" },
            { "name": "Cyprus" },
            { "name": "Czech Republic" },
            { "name": "Denmark" },
            { "name": "Djibouti" },
            { "name": "Dominica" },
            { "name": "Dominican Republic" },
            { "name": "Ecuador" },
            { "name": "Egypt" },
            { "name": "El Salvador" },
            { "name": "Equatorial Guinea" },
            { "name": "Eritrea" },
            { "name": "Estonia" },
            { "name": "Ethiopia" },
            { "name": "Falkland Islands (Malvinas)" },
            { "name": "Faroe Islands" },
            { "name": "Fiji" },
            { "name": "Finland" },
            { "name": "France" },
            { "name": "French Guiana" },
            { "name": "French Polynesia" },
            { "name": "French Southern Territories" },
            { "name": "Gabon" },
            { "name": "Gambia" },
            { "name": "Georgia" },
            { "name": "Germany" },
            { "name": "Ghana" },
            { "name": "Gibraltar" },
            { "name": "Greece" },
            { "name": "Greenland" },
            { "name": "Grenada" },
            { "name": "Guadeloupe" },
            { "name": "Guam" },
            { "name": "Guatemala" },
            { "name": "Guernsey" },
            { "name": "Guinea" },
            { "name": "Guinea-Bissau" },
            { "name": "Guyana" },
            { "name": "Haiti" },
            { "name": "Heard Island and Mcdonald Islands" },
            { "name": "Holy See (Vatican City State)" },
            { "name": "Honduras" },
            { "name": "Hong Kong" },
            { "name": "Hungary" },
            { "name": "Iceland" },
            { "name": "India" },
            { "name": "Indonesia" },
            { "name": "Iran, Islamic Republic Of" },
            { "name": "Iraq" },
            { "name": "Ireland" },
            { "name": "Isle of Man" },
            { "name": "Israel" },
            { "name": "Italy" },
            { "name": "Jamaica" },
            { "name": "Japan" },
            { "name": "Jersey" },
            { "name": "Jordan" },
            { "name": "Kazakhstan" },
            { "name": "Kenya" },
            { "name": "Kiribati" },
            { "name": "Korea, Democratic People'S Republic of" },
            { "name": "Korea, Republic of" },
            { "name": "Kuwait" },
            { "name": "Kyrgyzstan" },
            { "name": "Lao People'S Democratic Republic" },
            { "name": "Latvia" },
            { "name": "Lebanon" },
            { "name": "Lesotho" },
            { "name": "Liberia" },
            { "name": "Libyan Arab Jamahiriya" },
            { "name": "Liechtenstein" },
            { "name": "Lithuania" },
            { "name": "Luxembourg" },
            { "name": "Macao" },
            { "name": "Macedonia, The Former Yugoslav Republic of" },
            { "name": "Madagascar" },
            { "name": "Malawi" },
            { "name": "Malaysia" },
            { "name": "Maldives" },
            { "name": "Mali" },
            { "name": "Malta" },
            { "name": "Marshall Islands" },
            { "name": "Martinique" },
            { "name": "Mauritania" },
            { "name": "Mauritius" },
            { "name": "Mayotte" },
            { "name": "Mexico" },
            { "name": "Micronesia, Federated States of" },
            { "name": "Moldova, Republic of" },
            { "name": "Monaco" },
            { "name": "Mongolia" },
            { "name": "Montenegro" },
            { "name": "Montserrat" },
            { "name": "Morocco" },
            { "name": "Mozambique" },
            { "name": "Myanmar" },
            { "name": "Namibia" },
            { "name": "Nauru" },
            { "name": "Nepal" },
            { "name": "Netherlands" },
            { "name": "Netherlands Antilles" },
            { "name": "New Caledonia" },
            { "name": "New Zealand" },
            { "name": "Nicaragua" },
            { "name": "Niger" },
            { "name": "Nigeria" },
            { "name": "Niue" },
            { "name": "Norfolk Island" },
            { "name": "Northern Mariana Islands" },
            { "name": "Norway" },
            { "name": "Oman" },
            { "name": "Pakistan" },
            { "name": "Palau" },
            { "name": "Palestinian Territory, Occupied" },
            { "name": "Panama" },
            { "name": "Papua New Guinea" },
            { "name": "Paraguay" },
            { "name": "Peru" },
            { "name": "Philippines" },
            { "name": "Pitcairn" },
            { "name": "Poland" },
            { "name": "Portugal" },
            { "name": "Puerto Rico" },
            { "name": "Qatar" },
            { "name": "Reunion" },
            { "name": "Romania" },
            { "name": "Russian Federation" },
            { "name": "RWANDA" },
            { "name": "Saint Helena" },
            { "name": "Saint Kitts and Nevis" },
            { "name": "Saint Lucia" },
            { "name": "Saint Pierre and Miquelon" },
            { "name": "Saint Vincent and the Grenadines" },
            { "name": "Samoa" },
            { "name": "San Marino" },
            { "name": "Sao Tome and Principe" },
            { "name": "Saudi Arabia" },
            { "name": "Senegal" },
            { "name": "Serbia" },
            { "name": "Seychelles" },
            { "name": "Sierra Leone" },
            { "name": "Singapore" },
            { "name": "Slovakia" },
            { "name": "Slovenia" },
            { "name": "Solomon Islands" },
            { "name": "Somalia" },
            { "name": "South Africa" },
            { "name": "South Georgia and the South Sandwich Islands" },
            { "name": "Spain" },
            { "name": "Sri Lanka" },
            { "name": "Sudan" },
            { "name": "Suriname" },
            { "name": "Svalbard and Jan Mayen" },
            { "name": "Swaziland" },
            { "name": "Sweden" },
            { "name": "Switzerland" },
            { "name": "Syrian Arab Republic" },
            { "name": "Taiwan, Province of China" },
            { "name": "Tajikistan" },
            { "name": "Tanzania, United Republic of" },
            { "name": "Thailand" },
            { "name": "Timor-Leste" },
            { "name": "Togo" },
            { "name": "Tokelau" },
            { "name": "Tonga" },
            { "name": "Trinidad and Tobago" },
            { "name": "Tunisia" },
            { "name": "Turkey" },
            { "name": "Turkmenistan" },
            { "name": "Turks and Caicos Islands" },
            { "name": "Tuvalu" },
            { "name": "Uganda" },
            { "name": "Ukraine" },
            { "name": "United Arab Emirates" },
            { "name": "United Kingdom" },
            { "name": "United States" },
            { "name": "United States Minor Outlying Islands" },
            { "name": "Uruguay" },
            { "name": "Uzbekistan" },
            { "name": "Vanuatu" },
            { "name": "Venezuela" },
            { "name": "Viet Nam" },
            { "name": "Virgin Islands, British" },
            { "name": "Virgin Islands, U.S." },
            { "name": "Wallis and Futuna" },
            { "name": "Western Sahara" },
            { "name": "Yemen" },
            { "name": "Zambia" },
            { "name": "Zimbabwe" },
        ];

        $scope.PrivacyPolicy = '<p><b>1.&emsp; GENERAL</b><br><br>   We, PestBusters Pte Ltd, are committed to safeguard your privacy.We treat and hold all personal data provided by you in strict confidence and will only use your personal data in the manner set out in this privacy policy. \
        This policy describes how we may collect, use, process and manage your personal data. Please DO NOT provides any personal data to us if you do not accept this policy.<br><br> \
        <b>2.&emsp; Personal Data</b><br><br>  Personal Data whether true or not about you who can identified from that data or other information to which PestBusters has or is likely to have access, including data in PestBusters records which may be updated from time to time.<br><br> \
        Personal Data collected from you which may be over the phone, by email, through documents such as our order forms or contact forms,or in person when you meet our staff or representatives.<br><br> Personal Data collected may include, but is not limited to your full name, \
        telephone number(s), mailing address, email address, bank and credit card detail and any other information relating to you or any individuals whom you have provided in any forms you may have submitted to us, or via other methods of interaction with you. \
        <br><br>Data collected by automated means. Various technologies may be used on our Website in order to make it more user-friendly, effective and secure. Such technologies may lead to data being collected automatically by us or by third parties on behalf of us. This data does not generally, but may, contain a users personal data. \
        These technologies include but are not limited to cookies, web beacons, tracing links, click stream data and web analytics. You may set up your web browser to block cookies. You may also remove cookies stored from your computer or mobile device.<br><br> \
        <b>3.&emsp; How we used your personal data</b><br><br>  Administration of pay and benefits.<br>Audit of company records, including employee records.<br>Application for employment pass/work permit/visa.<br> \
        Payment of CPF.<br> Holding as part of the Companys records as to the business carried on by the Company.<br>Filing of income tax details.<br>Facilitation of communication within the Company and the Companys related companies through the use of global and local directories.<br> Monitoring of each Associates compliance with company policies, conduct of performance reviews and determination of performance requirements.<br> Establishment of training and development requirements.<br>  Management of medical leave, evaluation of employee wellness programmes, health benefits and health insurance, and <br> Investigation into complaints and disciplinary issues and conduct of disciplinary and grievance procedures, including keeping records thereof.<br>  \
        If you have contacted us with any feedback, complaints or comments, we may use and disclose your Personal Data to respond back to you .<br><br> \
        We may contact you via regular mail, email, telecommunication means or any other means for the above purposes by using your Personal Data \
        <br><br> <b>4.&emsp;Disclosure of Personal Data</b><br><br>  We will not sell any Personal Data to third parties or provide your Personal Data to third parties outside PestBusters Pte Ltd for their marketing purpose without your consent. It will only be used within any personnel from PestBusters. \
        <br><br>To provide our services or products to you and to carry out the purposes set out in this privacy policy, we have to disclose Personal Data to our specialists so as to provide necessary services to you.<br><br> \
        If you have contacted us with any feedback, complaints or comments, we may use and disclose your personal data to respond to or to facilitate a response to you. If you make a complaint and you do not want us to disclose your identity to the party you are complaining about, you must let us know immediately. However, it may not always be possible to handle your complaint on an anonymous basis.<br><br> \
        <b>5.&emsp; Our Safe guard for your personal data</b><br><br>  All Personal Data gathered are stored in our secure internal servers and under lock and key means. All precautions will be taken to ensure your Personal Data you provided to us is protected against unauthorised or unintended access. <br><br> <b>6.&emsp; Amendment of privacy policy</b><br><br> Privacy policy will be amending from time to time to stay updated with the Singapores law. \
        The updated privacy policy will always be made available at www.pestbusters.com.sg <br><br> <b>7.&emsp; Your Rights</b><br><br> If you do not accept the amended privacy policy or if you wish to withdraw any consent you have previously given to us or wish to update your Personal Data, you may bring your attention to:<br/><br/> \
        <b>Attention to:</b> Angeline Hia@Ang, Director, Human Capital <br/> <b>Email:</b> angeline@pestbusters.com.sg<br/> <b>Telephone:</b> 6288 2828<br/>  <b>Address:</b> 22 New Industrial Road, #02-03 to 08 Primax, Singapore 536208 \
        <br><br><b>8.&emsp; Governing law</b><br><br> This Policy and your use of our websites shall be governed in all respects by the laws of Singapore. You consent to submit to the exclusive jurisdiction of the Courts of Singapore in any dispute relating to this privacy policy. </p>';


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };

        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();




(function () {
    'use strict';

    angular
        .module('app.human-resource.medicalform', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_medicalform', {
            url: '/MedicalClaimForm',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/medicalform/medicalform.html',
                    controller: 'MedicalformController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.medicalform')
        .controller('MedicalformController', MedicalformController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        });


    function MedicalformController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, $filter, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Medical")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshLeaveGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/medical/getByLoginID",
                method: "POST",
                data: { LoginID: $rootScope.LoginID },
            });
            response.then(function (Medicaldata) {
                $scope.Medicaldatas = Medicaldata.data.data;
            });
        }

        function RefreshLeaveGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/leave",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.Employee = item1.id;
            } catch (error) { }
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        $scope.Medicalform = false;
        $scope.ViewMedicalform = false;
        $scope.Medicalgrid = true;
        $scope.mExport = true;
        $scope.mAdd = true;
        $scope.mSearch = true;
        $scope.mView = false;
        $scope.Medical = false;

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("MedicalClaims.xlsx",{headers:true}) FROM ?', [$scope.Medicaldatas]);
        };

        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/medical/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Medicalrefdatas = GList.data.data;
            });
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();

            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.Employee = item1.id;
                //$scope.GetLeave();
            } catch (error) { }

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueMID = pass;

            $scope.ClaimDate = new Date();

            $scope.Update = false;
            $scope.Medicalform = true;
            $scope.ViewMedicalform = false;
            $scope.Medicalgrid = false;
            $scope.mExport = false;
            $scope.mView = true;
            $scope.mAdd = false;
            $scope.mSearch = false;
            $scope.Medical = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Medicalgrid = true;
            $scope.Medicalform = false;
            $scope.ViewMedicalform = false;
            $scope.mExport = true;
            $scope.mAdd = true;
            $scope.mView = false;
            $scope.mSearch = true;
            $scope.Medical = false;
        }

        $scope.GetLeave = function () {
            $scope.Leave = $scope.VisitDate;
            $scope.adate = new Date($scope.VisitDate);
            var numberOfDaysToAdd = 5;
            $scope.afterdate = $scope.adate.setDate($scope.adate.getDate() + numberOfDaysToAdd);
            $scope.bdate = new Date($scope.VisitDate);
            var numberOfDaysToAdd = 5;
            $scope.beforedate = $scope.bdate.setDate($scope.bdate.getDate() - numberOfDaysToAdd);
            var leave = [];
            angular.forEach($scope.Leavedatas, function (value1) {
                $scope.CheckFromDate = new Date(value1.FromDate);
                $scope.CheckToDate = new Date(value1.ToDate);
                if ($scope.bdate <= $scope.CheckFromDate && $scope.CheckFromDate <= $scope.adate) {
                    if ($scope.Employee == value1.EmployeeID) {
                        leave.push({
                            id: value1._id,
                            ReferenceNo: value1.ReferenceNo,
                            FromDate: value1.FromDate,
                            ToDate: value1.ToDate,
                            EmployeeID: value1.EmployeeID,
                        })
                    }
                }
            });
            $scope.Leaverefdatas = leave;
        }

        $scope.mSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medical/update",
                    data: {
                        _id: $scope.SID,
                        EmployeeID: $scope.Employee,
                        ClaimDate: $scope.ClaimDate,
                        VisitDate: $scope.VisitDate,
                        MedicalInstitution: $scope.MedicalInstitution,
                        Amount: $scope.Amount,
                        Consultation: $scope.Consultation,
                        Reimbursable: $scope.Reimbursable,
                        MedicalLeave: $scope.MedicalLeave,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {

                    $scope.Userdata = GList.data.data[0];

                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Medical Claim Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Medical Claim Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/medical/email",
                            data: {
                                MedicalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueMID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                ClaimDate: convertDate($scope.Userdata.ClaimDate),
                                VisitDate: convertDate($scope.Userdata.VisitDate),
                                MedicalInstitution: $scope.Userdata.MedicalInstitution,
                                Amount: $scope.Userdata.Amount,
                                Consultation: $scope.Userdata.Consultation,
                                Reimbursable: $scope.Userdata.Reimbursable,
                                MedicalLeave: $scope.Userdata.MedicalLeave,
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Medicaldatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/medical/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueMID: $scope.UniqueMID,
                        EmployeeID: $scope.Employee,
                        ClaimDate: $scope.ClaimDate,
                        VisitDate: $scope.VisitDate,
                        MedicalInstitution: $scope.MedicalInstitution,
                        Amount: $scope.Amount,
                        Consultation: $scope.Consultation,
                        Reimbursable: $scope.Reimbursable,
                        MedicalLeave: $scope.MedicalLeave,
                        Purpose: $scope.Purpose,
                        Remarks: $scope.Remarks,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data;

                    try {
                        var EArray = $scope.Employeedatas;
                        var Eitem = EArray.filter(function (Eitem) {
                            return Eitem.id === $scope.Userdata.EmployeeID;
                        })[0];
                        $scope.EmployeeName = Eitem.EmployeeName;
                        $scope.EmployeeId = Eitem.EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Medical Claim Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Medical Claim Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }


                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/medical/email",
                            data: {
                                MedicalID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueMID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                ClaimDate: convertDate($scope.Userdata.ClaimDate),
                                VisitDate: convertDate($scope.Userdata.VisitDate),
                                MedicalInstitution: $scope.Userdata.MedicalInstitution,
                                Amount: $scope.Userdata.Amount,
                                Consultation: $scope.Userdata.Consultation,
                                Reimbursable: $scope.Userdata.Reimbursable,
                                MedicalLeave: $scope.Userdata.MedicalLeave,
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueMID,
                            TypeName: "HRM Medical Claim Request",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Medicalinfo = function (MedicalId, $index) {
            $scope.SID = MedicalId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Medicaldatas.filter(function (item) {
                    return item._id === MedicalId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueMID = item.UniqueMID;
                    $scope.Employee = item.EmployeeID;
                    $scope.ClaimDate = new Date(item.ClaimDate);
                    $scope.VisitDate = new Date(item.VisitDate);
                    $scope.MedicalInstitution = item.MedicalInstitution;
                    $scope.Amount = parseInt(item.Amount);
                    $scope.Consultation = parseInt(item.Consultation);
                    $scope.Reimbursable = parseInt(item.Reimbursable);
                    $scope.MedicalLeave = item.MedicalLeave;
                    $scope.Purpose = item.Purpose;
                    $scope.Remarks = item.Remarks;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

                RefreshAttachmentGrid();
                RefreshCommentGrid();
                $scope.GetLeave();

                $scope.Update = true;
                $scope.Medicalform = true;
                $scope.ViewMedicalform = false;
                $scope.Medicalgrid = false;
                $scope.mExport = false;
                $scope.mView = true;
                $scope.mAdd = false;
                $scope.mSearch = false;
                $scope.Medical = false;
                $scope.vm.Comments = '';
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();

            }
        }

        $scope.ViewMedicalinfo = function (VMedicalId) {
            $scope.SID = VMedicalId;

            try {
                var item = $scope.Medicaldatas.filter(function (item) {
                    return item._id === VMedicalId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueMID = item.UniqueMID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.ClaimDate = new Date(item.ClaimDate);
                $scope.VisitDate = new Date(item.VisitDate);
                $scope.MedicalInstitution = item.MedicalInstitution;
                $scope.Amount = parseInt(item.Amount);
                $scope.Consultation = parseInt(item.Consultation);
                $scope.Reimbursable = parseInt(item.Reimbursable);
                $scope.MedicalLeave = item.MedicalLeave;
                $scope.Purpose = item.Purpose;
                $scope.Remarks = item.Remarks;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            RefreshAttachmentGrid();
            RefreshCommentGrid();

            $scope.Update = true;
            $scope.Medicalform = false;
            $scope.ViewMedicalform = true;
            $scope.Medicalgrid = false;
            $scope.mExport = false;
            $scope.mView = true;
            $scope.mAdd = false;
            $scope.mSearch = false;
            $scope.Medical = true;
            $scope.vm.Comments = '';
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm11.$setPristine();
            $scope.basicForm11.$setUntouched();
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueMID,
                    TableName: "HRM Medical Claim Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm11.$setPristine();
                $scope.basicForm11.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/medical/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Medical Claim Request",
                            FileID: $scope.UniqueMID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancelrequest = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/medical/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Medical Claim Request' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Medical Claim Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }


                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/medical/email",
                            data: {
                                MedicalID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueMID,
                                EmployeeID: $scope.EmployeeId,
                                EmployeeName: $scope.EmployeeName,
                                ClaimDate: convertDate($scope.Userdata.ClaimDate),
                                VisitDate: convertDate($scope.Userdata.VisitDate),
                                MedicalInstitution: $scope.Userdata.MedicalInstitution,
                                Amount: $scope.Userdata.Amount,
                                Consultation: $scope.Userdata.Consultation,
                                Reimbursable: $scope.Userdata.Reimbursable,
                                MedicalLeave: $scope.Userdata.MedicalLeave,
                                Purpose: $scope.Userdata.Purpose,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueMID,
                            TypeName: "HRM Medical Claim Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Medicaldatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueMID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueMID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function ClearForm() {
            $scope.Employee = '';
            $scope.ClaimDate = '';
            $scope.VisitDate = '';
            $scope.MedicalInstitution = '';
            $scope.Amount = '';
            $scope.Consultation = '';
            $scope.Reimbursable = '';
            $scope.MedicalLeave = '';
            $scope.Purpose = '';
            $scope.Remarks = '';
            $scope.vm.Comments = '';
            $scope.Commentdatas = '';
            $scope.Attachmentdatas = '';
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Medical.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }


    }
})();





(function () {
    'use strict';

    angular
        .module('app.human-resource.leaveform', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_leaveform', {
            url: '/LeaveRequest',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/leaveform/leaveform.html',
                    controller: 'LeaveformController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.leaveform')
        .controller('LeaveformController', LeaveformController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });

    function LeaveformController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $state, $log, $filter, Upload) {
        //var chkAceses = localStorage.getItem('pages');
        //if (chkAceses.split(",").includes("LeaveR")) {   // do nothing 
        //}
        //else { $location.path("NoAccess"); }
        //$scope.model = {};
        debugger
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshRequestEmployeeGrid();
        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshLeaveEntitlementGrid();
        RefreshWorkflowGrid();
        RefreshCalendarGrid();
        $http.get($rootScope.WebURL + "/employeeFamily")
            .then(function (employeeFamilydata) {
                $scope.EmployeeFamilyatas = employeeFamilydata.data.data;
            });

        $scope.Leaveform = false;
        $scope.ViewLeaveform = false;
        $scope.Leavegrid = true;
        $scope.lExport = true;
        $scope.lAdd = true;
        $scope.lSearch = true;
        $scope.lView = false;
        $scope.Cancel = false;
        $scope.Leave = false;

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
            $scope.vm.searchTerm4 = '';
        }

        function RefreshRequestEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (RequestEmployeedata) {
                $scope.RequestEmployeedatas = RequestEmployeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.RequestEmployeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];

                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
            } catch (error) {
            }
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/leave/getByLoginID",
                method: "POST",
                data: { LoginID: $rootScope.LoginID },
            });
            response.then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshLeaveEntitlementGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/leaveentitlement",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Leaveentitlementdata) {
                $scope.Leaveentitlementdatas = Leaveentitlementdata.data.data;
            });
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshCalendarGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/calendar",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Calendardata) {
                $scope.Calendardatas = Calendardata.data.data;
                $scope.PublicHolidaydatas = $scope.Calendardatas.filter(function (item) {
                    return item.EventType === "Holiday";
                });
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("LeaveRequests.xlsx",{headers:true}) FROM ?', [$scope.Leavedatas]);
        };

        $scope.Showgrid = function () {
            $scope.Leavegrid = true;
            $scope.Leaveform = false;
            $scope.ViewLeaveform = false;
            $scope.lExport = true;
            $scope.lAdd = true;
            $scope.lView = false;
            $scope.lSearch = true;
            $scope.Cancel = false;
            //$state.reload();
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            debugger
            ClearForm();
            RefreshGrid();
            $scope.TotalDaysApplied = 0;
            $scope.TotalPaidLeaves = 0;
            $scope.TotalUnPaidLeaves = 0;
            $scope.LeaveTaken = 0;
            $scope.LeaveBalance = 0;
            $scope.LeaveEntitlement = "-";
            $scope.FromDayType = "Full Day";
            $scope.ToDayType = "Full Day";
            $scope.LeaveType = "Annual Leave";

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.RequestEmployeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.RequestedByEmployee = item1.EmployeeID + '-' + item1.EmployeeName;
                $scope.Employee = item1.id;
                $scope.InitialLeaveTypeLoad();
            } catch (error) { }

            $scope.Update = false;
            $scope.Leaveform = true;
            $scope.ViewLeaveform = false;
            $scope.Leavegrid = false;
            $scope.lExport = false;
            $scope.lView = true;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.Cancel = false;
            $scope.Leave = false;
            $scope.isDisabled = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

        }

        function momentDiff(a, b) {
            var oldDateMoment, newDateMoment, numYears, numMonths, numDays, convertyeartoMonth, totalMonths;
            oldDateMoment = moment(a);
            newDateMoment = moment(b);
            numYears = newDateMoment.diff(oldDateMoment, 'years');
            oldDateMoment = oldDateMoment.add(numYears, 'years');
            numMonths = newDateMoment.diff(oldDateMoment, 'months');
            oldDateMoment = oldDateMoment.add(numMonths, 'months');
            numDays = newDateMoment.diff(oldDateMoment, 'days');
            convertyeartoMonth = numYears * 12;
            totalMonths = convertyeartoMonth + numMonths;
            return totalMonths;
        }

        function getDateonly(input) {
            if (input == null) { return ""; }
            var _date = $filter('date')(new Date(input), 'dd/MM/yyyy');
            return _date;
        };

        $scope.InitialLeaveTypeLoad = function () {
            debugger
            $scope.AnnualLeaveEntitlement = 0;
            $scope.Earned = 0;
            $scope.Annual = 0;
            $scope.AnnualLeave = 0;
            $scope.AdoptionLeave = 0;
            $scope.ChildCareLeave = 0;
            $scope.CompassionateLeave = 0;
            $scope.MaternityLeave = 0;
            $scope.PaternityLeave = 0;
            $scope.SharedParentalLeave = 0;
            $scope.SickLeave = 0;

            $scope.LEAnnualLeaveEntitlement = 0;
            $scope.LEEarned = 0;
            $scope.LEAdoptionLeave = 0;
            $scope.LEChildCareLeave = 0;
            $scope.LECompassionateLeave = 0;
            $scope.LEMaternityLeave = 0;
            $scope.LEPaternityLeave = 0;
            $scope.LESharedParentalLeave = 0;
            $scope.LESickLeave = 0;


            $scope.ProbationCompleted = false;
            $scope.AnnualEligible = false;
            $scope.AdoptionEligible = false;
            $scope.ChildCareEligible = false;
            $scope.CompassionateEligible = false;
            $scope.MaternityEligible = false;
            $scope.PaternityEligible = false;
            $scope.SharedParentalEligible = false;
            $scope.SickEligible = false;


            //var CurrentYear = new Date().getFullYear();

            try {
                $scope.EmpID = $scope.Employee;
                var item = $scope.Leaveentitlementdatas.filter(function (item) {
                    return item.EmployeeID === $scope.EmpID;
                })[0];
                $scope.LEID = item._id;
                $scope.CHKAnnualLeaveEntitlement = item.AnnualLeaveEntitlement;
                if ($scope.CHKAnnualLeaveEntitlement != "" && $scope.CHKAnnualLeaveEntitlement != null && $scope.CHKAnnualLeaveEntitlement != undefined) {
                    $scope.AnnualLeaveEntitlement = $scope.CHKAnnualLeaveEntitlement;
                }
                $scope.CHKEarned = item.Earned;
                if ($scope.CHKEarned != "" && $scope.CHKEarned != null && $scope.CHKEarned != undefined) {
                    $scope.Earned = $scope.CHKEarned;
                }
                $scope.CHKAnnual = item.AnnualLeave;
                if ($scope.CHKAnnual != "" && $scope.CHKAnnual != null && $scope.CHKAnnual != undefined) {
                    $scope.Annual = $scope.CHKAnnual;
                }
                $scope.CHKAdoption = item.AdoptionLeave;
                if ($scope.CHKAdoption != "" && $scope.CHKAdoption != null && $scope.CHKAdoption != undefined) {
                    $scope.AdoptionLeave = $scope.CHKAdoption;
                }
                $scope.CHKChildCare = item.ChildCareLeave;
                if ($scope.CHKChildCare != "" && $scope.CHKChildCare != null && $scope.CHKChildCare != undefined) {
                    $scope.ChildCareLeave = $scope.CHKChildCare;
                }
                $scope.CHKCompassionate = item.CompassionateLeave;
                if ($scope.CHKCompassionate != "" && $scope.CHKCompassionate != null && $scope.CHKCompassionate != undefined) {
                    $scope.CompassionateLeave = $scope.CHKCompassionate;
                }
                $scope.CHKMaternity = item.MaternityLeave;
                if ($scope.CHKMaternity != "" && $scope.CHKMaternity != null && $scope.CHKMaternity != undefined) {
                    $scope.MaternityLeave = $scope.CHKMaternity;
                }
                $scope.CHKPaternity = item.PaternityLeave;
                if ($scope.CHKPaternity != "" && $scope.CHKPaternity != null && $scope.CHKPaternity != undefined) {
                    $scope.PaternityLeave = $scope.CHKPaternity;
                }
                $scope.CHKSharedParentalLeave = item.SharedParentalLeave;
                if ($scope.CHKSharedParentalLeave != "" && $scope.CHKSharedParentalLeave != null && $scope.CHKSharedParentalLeave != undefined) {
                    $scope.SharedParentalLeave = $scope.CHKSharedParentalLeave;
                }
                $scope.CHKSickLeave = item.SickLeave;
                if ($scope.CHKSickLeave != "" && $scope.CHKSickLeave != null && $scope.CHKSickLeave != undefined) {
                    $scope.SickLeave = $scope.CHKSickLeave;
                }
                $scope.LeaveEntitlementYear = item.LeaveEntitlementYear;
                debugger
                $scope.CurrentDate = new Date();
                $scope.LeaveEntitlementDetails = item.LeaveentitlementDetails;
                $scope.WorkWeekCode = item.Employeedetails[0].WorkWeekCode;
                $scope.ProbationCompletionDate = new Date(item.Employeedetails[0].EProbationCompletionDate);
                $scope.EmployeeIDforFamily = item.Employeedetails[0].EmployeeID;
                $scope.Gender = item.Employeedetails[0].Gender;
                $scope.MaritalStatus = item.Employeedetails[0].MaritalStatus;
                $scope.Citizenship = item.Employeedetails[0].Citizenship;
                $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);
                $scope.Division = item.Employeedetails[0].EDivision;
                $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.CurrentDate);
                if ($scope.TotalWorkedMonths != null && $scope.TotalWorkedMonths != undefined && $scope.TotalWorkedMonths != "") {
                    if ($scope.TotalWorkedMonths <= 12) {
                        $scope.CurrentYearTotalWorkedMonths = $scope.TotalWorkedMonths;
                    }
                    else if ($scope.TotalWorkedMonths > 12) {
                        if (parseFloat($scope.TotalWorkedMonths) % 12 == 0) {
                            $scope.CurrentYearTotalWorkedMonths = 12;
                        }
                        else if (parseFloat($scope.TotalWorkedMonths) % 12 != 0) {
                            $scope.CurrentYearTotalWorkedMonths = parseFloat($scope.TotalWorkedMonths) % 12;
                        }
                    }
                }

            } catch (err) { }

            try {
                var LEitem = $scope.LeaveEntitlementDetails.filter(function (LEitem) {
                    return (parseFloat(LEitem.LeaveEntitlementYear) === parseFloat($scope.LeaveEntitlementYear));
                })[0];
                debugger
                $scope.CHKLEAnnualLeaveEntitlement = LEitem.AnnualLeaveEntitlement;
                if ($scope.CHKLEAnnualLeaveEntitlement != "" && $scope.CHKLEAnnualLeaveEntitlement != null && $scope.CHKLEAnnualLeaveEntitlement != undefined) {
                    $scope.LEAnnualLeaveEntitlement = $scope.CHKLEAnnualLeaveEntitlement;
                }
                $scope.CHKLEEarned = LEitem.Earned;
                if ($scope.CHKLEEarned != "" && $scope.CHKLEEarned != null && $scope.CHKLEEarned != undefined) {
                    $scope.LEEarned = $scope.CHKLEEarned;
                }
                $scope.CHKLEAnnual = LEitem.AnnualLeave;
                if ($scope.CHKLEAnnual != "" && $scope.CHKLEAnnual != null && $scope.CHKLEAnnual != undefined) {
                    $scope.LEAnnual = $scope.CHKLEAnnual;
                }
                $scope.CHKLEAdoption = LEitem.AdoptionLeave;
                if ($scope.CHKLEAdoption != "" && $scope.CHKLEAdoption != null && $scope.CHKLEAdoption != undefined) {
                    $scope.LEAdoptionLeave = $scope.CHKLEAdoption;
                }
                $scope.CHKLEChildCare = LEitem.ChildCareLeave;
                if ($scope.CHKLEChildCare != "" && $scope.CHKLEChildCare != null && $scope.CHKLEChildCare != undefined) {
                    $scope.LEChildCareLeave = $scope.CHKLEChildCare;
                }
                $scope.CHKLECompassionate = LEitem.CompassionateLeave;
                if ($scope.CHKLECompassionate != "" && $scope.CHKLECompassionate != null && $scope.CHKLECompassionate != undefined) {
                    $scope.LECompassionateLeave = $scope.CHKLECompassionate;
                }
                $scope.CHKLEMaternity = LEitem.MaternityLeave;
                if ($scope.CHKLEMaternity != "" && $scope.CHKLEMaternity != null && $scope.CHKLEMaternity != undefined) {
                    $scope.LEMaternityLeave = $scope.CHKLEMaternity;
                }
                $scope.CHKLEPaternity = LEitem.PaternityLeave;
                if ($scope.CHKLEPaternity != "" && $scope.CHKLEPaternity != null && $scope.CHKLEPaternity != undefined) {
                    $scope.LEPaternityLeave = $scope.CHKLEPaternity;
                }
                $scope.CHKLESharedParentalLeave = LEitem.SharedParentalLeave;
                if ($scope.CHKLESharedParentalLeave != "" && $scope.CHKLESharedParentalLeave != null && $scope.CHKLESharedParentalLeave != undefined) {
                    $scope.LESharedParentalLeave = $scope.CHKLESharedParentalLeave;
                }
                $scope.CHKLESickLeave = LEitem.SickLeave;
                if ($scope.CHKLESickLeave != "" && $scope.CHKLESickLeave != null && $scope.CHKLESickLeave != undefined) {
                    $scope.LESickLeave = $scope.CHKLESickLeave;
                }
            } catch (err) { }

            try {
                debugger
                $scope.chkAnnualLeave = (parseFloat($scope.LEAnnualLeaveEntitlement));
                var ALE = parseFloat($scope.CurrentYearTotalWorkedMonths / 12);
                $scope.getAnnualLeave = (ALE * $scope.chkAnnualLeave);
                if ($scope.getAnnualLeave != null && $scope.getAnnualLeave != undefined && $scope.getAnnualLeave != "") {
                    if (parseFloat($scope.getAnnualLeave) % 1 == 0) {
                        $scope.getAnnualLeave = $scope.getAnnualLeave;
                    }
                    else if (parseFloat($scope.getAnnualLeave) % 1 < 0.5) {
                        $scope.getAnnualLeave = parseFloat($scope.getAnnualLeave).toFixed(0);
                    }
                    else if (parseFloat($scope.getAnnualLeave) % 1 > 0.5) {
                        $scope.getAnnualLeave = parseFloat($scope.getAnnualLeave).toFixed(0);
                    }
                }
                $scope.TotalAnnualLeave = (parseFloat($scope.getAnnualLeave) + parseFloat($scope.LEEarned));

            } catch (e) { }

            $scope.getAnnualLeaveByLeaveEntitlement = (parseFloat($scope.LEAnnualLeaveEntitlement) - parseFloat($scope.AnnualLeaveEntitlement));
            $scope.getAnnualLeaveByEarned = (parseFloat($scope.LEEarned) - parseFloat($scope.Earned));
            if ($scope.getAnnualLeaveByLeaveEntitlement >= $scope.getAnnualLeaveByEarned) {
                $scope.TotalAnnualLeaveTaken = (parseFloat($scope.getAnnualLeaveByLeaveEntitlement) + parseFloat($scope.getAnnualLeaveByEarned));
            }
            else if ($scope.getAnnualLeaveByLeaveEntitlement <= $scope.getAnnualLeaveByEarned) {
                $scope.TotalAnnualLeaveTaken = (parseFloat($scope.getAnnualLeaveByEarned) + parseFloat($scope.getAnnualLeaveByLeaveEntitlement));
            }

            $scope.LeaveEntitlement = "Annual-" + $scope.TotalAnnualLeave + "; AL-" + $scope.LEAdoptionLeave + "; CC-" + $scope.LEChildCareLeave + "; CL-" + $scope.LECompassionateLeave +
                "; ML-" + $scope.LEMaternityLeave + "; PL-" + $scope.LEPaternityLeave + "; SPL-" + $scope.LESharedParentalLeave + "; SL-" + $scope.LESickLeave;

            try {
                debugger
                $scope.Fitem = $scope.EmployeeFamilyatas.filter(function (Fitem) {
                    return Fitem.EmployeeID === $scope.EmployeeIDforFamily;
                });
                debugger
                if ($scope.Fitem.length != 0) {
                    $scope.AdoptionArray = [];
                    $scope.ChildCareArray = [];
                    angular.forEach($scope.Fitem, function (Fvalue) {
                        if (Fvalue.FNationality == "Singapore" && Fvalue.FRelationship == "Son" || Fvalue.FRelationship == "Daughter") {
                            var CheckFDOB = Fvalue.FDOB;
                            if (CheckFDOB != "" && CheckFDOB != null && CheckFDOB != undefined) {
                                CheckFDOB = new Date(Fvalue.FDOB);
                                var CheckEligibleforAdoption = new Date(CheckFDOB.getFullYear() + 1, CheckFDOB.getMonth(), CheckFDOB.getDate());
                                var CheckEligibleforChildCare = new Date(CheckFDOB.getFullYear() + 7, CheckFDOB.getMonth(), CheckFDOB.getDate());
                                debugger
                                if (CheckFDOB <= $scope.CurrentDate && CheckEligibleforAdoption >= $scope.CurrentDate) {
                                    $scope.AdoptionArray.push({
                                        ChildALDOB: CheckFDOB,
                                    })
                                }
                                if (CheckFDOB <= $scope.CurrentDate && CheckEligibleforChildCare >= $scope.CurrentDate) {
                                    $scope.ChildCareArray.push({
                                        ChildCCDOB: CheckFDOB,
                                    })
                                }
                            }
                        }
                    });
                    if ($scope.ProbationCompletionDate < $scope.CurrentDate) {
                        $scope.ProbationCompleted = true;
                        $scope.AnnualEligible = true;
                        $scope.CompassionateEligible = true;
                        $scope.SickEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true && $scope.AdoptionArray.length > 0) {
                        $scope.AdoptionEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true && $scope.ChildCareArray.length > 0) {
                        $scope.ChildCareEligible = true;
                    }
                    if ($scope.Gender == "Female" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.MaternityEligible = true;
                    }
                    if ($scope.Gender == "Male" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.PaternityEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.SharedParentalEligible = true;
                    }
                }
                else {
                    if ($scope.ProbationCompletionDate < $scope.CurrentDate) {
                        $scope.ProbationCompleted = true;
                        $scope.AnnualEligible = true;
                        $scope.CompassionateEligible = true;
                        $scope.SickEligible = true;
                    }
                    $scope.AdoptionEligible = false;
                    $scope.ChildCareEligible = false;
                    if ($scope.Gender == "Female" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.MaternityEligible = true;
                    }
                    if ($scope.Gender == "Male" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.PaternityEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.SharedParentalEligible = true;
                    }
                }
            } catch (e) { }

            try {
                if ($scope.LeaveType == "Annual Leave") {
                    $scope.LeaveTaken = parseFloat($scope.TotalAnnualLeaveTaken);
                    $scope.LeaveBalance = (parseFloat($scope.TotalAnnualLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AnnualEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.AdoptionLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AdoptionEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.ChildCareLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.ChildCareEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.CompassionateLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.CompassionateEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.MaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.MaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.PaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.PaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.SharedParentalLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SharedParentalEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESickLeave) - parseFloat($scope.SickLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESickLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SickEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Off In-Lieu") {
                    $scope.LeaveTaken = 0;
                    $scope.LeaveBalance = 0;
                    $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                    $scope.TotalUnPaidLeaves = 0;
                }
            } catch (e) { }

        }

        $scope.OnDateChange = function () {
            debugger
            $scope.AfterOnFromDateChange();

            if ($scope.ToDate == "" || $scope.ToDate == null || $scope.ToDate == undefined) {
                $scope.ToDate = $scope.FromDate;
            }

            $scope.isDisabled = false;
            var d1 = getDateonly($scope.FromDate);
            var d2 = getDateonly($scope.ToDate);
            if (d1 === d2) {
                $scope.isDisabled = true;
            }
            else {
                $scope.isDisabled = false;
            }

            var startDate = new Date($scope.FromDate);
            var endDate = new Date($scope.ToDate);
            var totalWorkingdays = 0;
            var totalWeekoffs = 0;
            if ($scope.WorkWeekCode == "Mon-Fri") {
                debugger
                for (var i = startDate; i <= endDate;) {
                    if (i.getDay() == 1 || i.getDay() == 2 || i.getDay() == 3 || i.getDay() == 4 || i.getDay() == 5) {
                        totalWorkingdays++;
                    }
                    else if (i.getDay() == 0 || i.getDay() == 6) {
                        totalWeekoffs++;
                    }
                    i.setTime(i.getTime() + 1000 * 60 * 60 * 24);
                }
            }
            else if ($scope.WorkWeekCode == "Mon-Sat") {
                debugger
                for (var i = startDate; i <= endDate;) {
                    if (i.getDay() == 1 || i.getDay() == 2 || i.getDay() == 3 || i.getDay() == 4 || i.getDay() == 5 || i.getDay() == 6) {
                        totalWorkingdays++;
                    }
                    else if (i.getDay() == 0) {
                        totalWeekoffs++;
                    }
                    i.setTime(i.getTime() + 1000 * 60 * 60 * 24);
                }
            }
            else if ($scope.WorkWeekCode == "Sun-Thursday") {
                debugger
                for (var i = startDate; i <= endDate;) {
                    if (i.getDay() == 0 || i.getDay() == 1 || i.getDay() == 2 || i.getDay() == 3 || i.getDay() == 4) {
                        totalWorkingdays++;
                    }
                    else if (i.getDay() == 5 || i.getDay() == 6) {
                        totalWeekoffs++;
                    }
                    i.setTime(i.getTime() + 1000 * 60 * 60 * 24);
                }
            }
            else {
                for (var i = startDate; i <= endDate;) {
                    if (i.getDay() == 1 || i.getDay() == 2 || i.getDay() == 3 || i.getDay() == 4 || i.getDay() == 5 || i.getDay() == 6) {
                        totalWorkingdays++;
                    }
                    else if (i.getDay() == 0) {
                        totalWeekoffs++;
                    }
                    i.setTime(i.getTime() + 1000 * 60 * 60 * 24);
                }
            }

            if ($scope.isDisabled == true) {
                if ($scope.FromDayType == "Full Day" && $scope.FromDayType != "Morning" && $scope.FromDayType != "Noon") {
                    $scope.TotalDays = totalWorkingdays;
                }
                else {
                    $scope.TotalDays = totalWorkingdays - 0.5;
                }
            }
            if ($scope.isDisabled == false) {
                if ($scope.FromDayType == "Full Day" && $scope.ToDayType == "Full Day" || $scope.FromDayType == "Morning" && $scope.ToDayType == "Morning" || $scope.FromDayType == "Noon" && $scope.ToDayType == "Noon") {
                    $scope.TotalDays = totalWorkingdays;
                }
                else {
                    $scope.TotalDays = totalWorkingdays - 0.5;
                }
            }

            var leave = [];
            angular.forEach($scope.PublicHolidaydatas, function (value) {
                $scope.CheckFromDate = new Date(value.StartDate);
                $scope.CheckFromDate.setHours(0, 0, 0, 0);
                debugger
                if ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) {
                    leave.push({
                        id: value.id,
                        StartDate: value.StartDate,
                        EndDate: value.EndDate,
                    })
                }
            });
            $scope.TotalPublicLeavedatas = leave;
            $scope.PublicLeave = leave.length;
            $scope.TotalDaysApplied = $scope.TotalDays - $scope.PublicLeave;

            $scope.OnLeaveChange();
        }

        $scope.AfterOnFromDateChange = function () {
            debugger

            try {
                debugger
                $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.FromDate);
                if ($scope.TotalWorkedMonths != null && $scope.TotalWorkedMonths != undefined && $scope.TotalWorkedMonths != "") {
                    if ($scope.TotalWorkedMonths <= 12) {
                        $scope.CurrentYearTotalWorkedMonths = $scope.TotalWorkedMonths;
                    }
                    else if ($scope.TotalWorkedMonths > 12) {
                        if (parseFloat($scope.TotalWorkedMonths) % 12 == 0) {
                            $scope.CurrentYearTotalWorkedMonths = 12;
                        }
                        else if (parseFloat($scope.TotalWorkedMonths) % 12 != 0) {
                            $scope.CurrentYearTotalWorkedMonths = parseFloat($scope.TotalWorkedMonths) % 12;
                        }
                    }
                }

            } catch (err) { }

            try {
                debugger
                $scope.chkAnnualLeave = (parseFloat($scope.LEAnnualLeaveEntitlement));
                var ALE = parseFloat($scope.CurrentYearTotalWorkedMonths / 12);
                $scope.getAnnualLeave = (ALE * $scope.chkAnnualLeave);
                if ($scope.getAnnualLeave != null && $scope.getAnnualLeave != undefined && $scope.getAnnualLeave != "") {
                    if (parseFloat($scope.getAnnualLeave) % 1 == 0) {
                        $scope.getAnnualLeave = $scope.getAnnualLeave;
                    }
                    else if (parseFloat($scope.getAnnualLeave) % 1 < 0.5) {
                        $scope.getAnnualLeave = parseFloat($scope.getAnnualLeave).toFixed(0);
                    }
                    else if (parseFloat($scope.getAnnualLeave) % 1 > 0.5) {
                        $scope.getAnnualLeave = parseFloat($scope.getAnnualLeave).toFixed(0);
                    }
                }
                $scope.TotalAnnualLeave = (parseFloat($scope.getAnnualLeave) + parseFloat($scope.LEEarned));
            } catch (e) { }

            $scope.getAnnualLeaveByLeaveEntitlement = (parseFloat($scope.LEAnnualLeaveEntitlement) - parseFloat($scope.AnnualLeaveEntitlement));
            $scope.getAnnualLeaveByEarned = (parseFloat($scope.LEEarned) - parseFloat($scope.Earned));
            if ($scope.getAnnualLeaveByLeaveEntitlement >= $scope.getAnnualLeaveByEarned) {
                $scope.TotalAnnualLeaveTaken = (parseFloat($scope.getAnnualLeaveByLeaveEntitlement) + parseFloat($scope.getAnnualLeaveByEarned));
            }
            else if ($scope.getAnnualLeaveByLeaveEntitlement <= $scope.getAnnualLeaveByEarned) {
                $scope.TotalAnnualLeaveTaken = (parseFloat($scope.getAnnualLeaveByEarned) + parseFloat($scope.getAnnualLeaveByLeaveEntitlement));
            }

            $scope.LeaveEntitlement = "Annual-" + $scope.TotalAnnualLeave + "; AL-" + $scope.LEAdoptionLeave + "; CC-" + $scope.LEChildCareLeave + "; CL-" + $scope.LECompassionateLeave +
                "; ML-" + $scope.LEMaternityLeave + "; PL-" + $scope.LEPaternityLeave + "; SPL-" + $scope.LESharedParentalLeave + "; SL-" + $scope.LESickLeave;

            try {
                debugger
                if ($scope.Fitem.length != 0) {
                    if ($scope.ProbationCompletionDate < $scope.FromDate) {
                        $scope.ProbationCompleted = true;
                        $scope.AnnualEligible = true;
                        $scope.CompassionateEligible = true;
                        $scope.SickEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true && $scope.AdoptionArray.length > 0) {
                        $scope.AdoptionEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true && $scope.ChildCareArray.length > 0) {
                        $scope.ChildCareEligible = true;
                    }
                    if ($scope.Gender == "Female" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.MaternityEligible = true;
                    }
                    if ($scope.Gender == "Male" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.PaternityEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.SharedParentalEligible = true;
                    }
                }
                else {
                    if ($scope.ProbationCompletionDate < $scope.FromDate) {
                        $scope.ProbationCompleted = true;
                        $scope.AnnualEligible = true;
                        $scope.CompassionateEligible = true;
                        $scope.SickEligible = true;
                    }
                    $scope.AdoptionEligible = false;
                    $scope.ChildCareEligible = false;
                    if ($scope.Gender == "Female" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.MaternityEligible = true;
                    }
                    if ($scope.Gender == "Male" && $scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.PaternityEligible = true;
                    }
                    if ($scope.MaritalStatus == "Married" && $scope.Citizenship == "Singapore" && $scope.ProbationCompleted == true) {
                        $scope.SharedParentalEligible = true;
                    }
                }
            } catch (e) { }

            try {
                if ($scope.LeaveType == "Annual Leave") {
                    $scope.LeaveTaken = parseFloat($scope.TotalAnnualLeaveTaken);
                    $scope.LeaveBalance = (parseFloat($scope.TotalAnnualLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AnnualEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.AdoptionLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AdoptionEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.ChildCareLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.ChildCareEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.CompassionateLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.CompassionateEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.MaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.MaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.PaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.PaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.SharedParentalLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SharedParentalEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESickLeave) - parseFloat($scope.SickLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESickLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SickEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Off In-Lieu") {
                    $scope.LeaveTaken = 0;
                    $scope.LeaveBalance = 0;
                    $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                    $scope.TotalUnPaidLeaves = 0;
                }
            } catch (e) { }

        }

        $scope.OnLeaveChange = function () {
            debugger
            try {
                if ($scope.LeaveType == "Annual Leave") {
                    $scope.LeaveTaken = parseFloat($scope.TotalAnnualLeaveTaken);
                    $scope.LeaveBalance = (parseFloat($scope.TotalAnnualLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AnnualEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.AdoptionLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEAdoptionLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.AdoptionEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.ChildCareLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEChildCareLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.ChildCareEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.CompassionateLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LECompassionateLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.CompassionateEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.MaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEMaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.MaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.PaternityLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LEPaternityLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.PaternityEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.SharedParentalLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESharedParentalLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SharedParentalEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.LeaveTaken = (parseFloat($scope.LESickLeave) - parseFloat($scope.SickLeave));
                    $scope.LeaveBalance = (parseFloat($scope.LESickLeave) - parseFloat($scope.LeaveTaken));
                    if ($scope.LeaveBalance < 0 || $scope.LeaveBalance == "" || $scope.LeaveBalance == null || $scope.LeaveBalance == undefined || $scope.LeaveBalance == NaN) {
                        $scope.LeaveBalance = 0;
                    }
                    if ($scope.SickEligible == true) {
                        if ($scope.LeaveBalance >= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                            $scope.TotalUnPaidLeaves = 0;
                        }
                        else if ($scope.LeaveBalance <= $scope.TotalDaysApplied) {
                            $scope.TotalPaidLeaves = $scope.LeaveBalance;
                            $scope.TotalUnPaidLeaves = (parseFloat($scope.TotalDaysApplied) - parseFloat($scope.LeaveBalance));
                        }
                        else if ($scope.LeaveBalance == 0) {
                            $scope.TotalPaidLeaves = 0;
                            $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                        }
                    }
                    else {
                        $scope.TotalPaidLeaves = 0;
                        $scope.TotalUnPaidLeaves = $scope.TotalDaysApplied;
                    }
                }
                else if ($scope.LeaveType == "Off In-Lieu") {
                    $scope.LeaveTaken = 0;
                    $scope.LeaveBalance = 0;
                    $scope.TotalPaidLeaves = $scope.TotalDaysApplied;
                    $scope.TotalUnPaidLeaves = 0;
                }
            } catch (e) { }
        }

        $scope.lSubmit = function () {
            debugger
            if ($scope.FromDate > $scope.ToDate) {
                $mdToast.show($mdToast.simple().textContent('Please Enter Correct Date!!!').position('top center'));
                return
            }
            $scope.CheckLeaveDetails = $scope.Leavedatas;
            var ExistingLeaves = [];
            angular.forEach($scope.CheckLeaveDetails, function (value) {
                $scope.CheckFromDate = new Date(value.FromDate);
                $scope.CheckToDate = new Date(value.ToDate);
                $scope.CheckStatus = value.Status;
                if (($scope.FromDate >= $scope.CheckFromDate && $scope.FromDate <= $scope.CheckToDate) || ($scope.FromDate <= $scope.CheckFromDate && $scope.ToDate >= $scope.CheckFromDate) || ($scope.FromDate <= $scope.CheckToDate && $scope.ToDate >= $scope.CheckToDate)) {
                    if ($scope.CheckStatus == "New" || $scope.CheckStatus == "Reviewed" || $scope.CheckStatus == "Approved") {
                        ExistingLeaves.push({
                            FromDate: value.FromDate,
                            ToDate: value.ToDate,
                            Status: value.Status,
                        })
                    }
                }
            });
            $scope.TotalExistingLeaves = ExistingLeaves.length;

            if (parseFloat($scope.TotalExistingLeaves) > 0) {
                $scope.Showgrid();
                $mdToast.show($mdToast.simple().textContent('Already leave applied on the below same date/s!!').position('top center'));
                return
            }

            if ($scope.isDisabled == true) {
                $scope.ToDayType = "";
            }

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/leave/add",
                data: {
                    Client_Id: Client_Id,
                    UniqueID: $scope.UniqueID,
                    EmployeeID: $scope.Employee,
                    FromDate: $scope.FromDate,
                    ToDate: $scope.ToDate,
                    FromDayType: $scope.FromDayType,
                    ToDayType: $scope.ToDayType,
                    LeaveType: $scope.LeaveType,
                    RequestedEmployee: $scope.RequestedByEmployee,
                    Division: $scope.Division,
                    Reason: $scope.Reason,
                    EmergencyContactNo: $scope.EmergencyContactNo,
                    TotalDaysApplied: $scope.TotalDaysApplied,
                    TotalPaidLeaves: $scope.TotalPaidLeaves,
                    TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                    LeaveTaken: $scope.LeaveTaken,
                    LeaveBalance: $scope.LeaveBalance,
                    LeaveEntitlement: $scope.LeaveEntitlement,
                    Status: "New",
                    StatusID: "1",
                    CreatedBy: $rootScope.LoginID,
                },
            });
            response.then(function (LGList) {
                debugger
                $scope.Userdata = LGList.data.data;
                $scope.UpdateLeaveEntitlement();

                try {
                    var Eitem = $scope.Employeedatas.filter(function (Eitem) {
                        return Eitem.id === $scope.Userdata.EmployeeID;
                    })[0];
                    $scope.EmployeeName = Eitem.EmployeeName;
                    $scope.EmployeeId = Eitem.EmployeeID;
                } catch (err) {
                }
                var SenderEmails = [];

                try {
                    var myArray = $scope.Workflowdatas;
                    var Workflowitem = myArray.filter(function (Workflowitem) {
                        return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                    })[0];
                } catch (err) {
                }
                try {
                    if (Workflowitem.NotifytoCurrentApprover == true) {
                        $scope.ApproversArray = Workflowitem.Approvers.split(',');
                        angular.forEach($scope.ApproversArray, function (value) {
                            var UserArray = $scope.Userdatas;
                            var Useritem = UserArray.filter(function (Useritem) {
                                return Useritem.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: Useritem.Email });
                        });
                    }
                } catch (err) {
                }
                try {
                    if (Workflowitem.NotifytoCreatorInitator == true) {
                        var UserArray2 = $scope.Userdatas;
                        var item2 = UserArray2.filter(function (item2) {
                            return item2.UserID === $scope.Userdata.CreatedBy;
                        })[0];
                        SenderEmails.push({ Email: item2.Email });
                    }
                } catch (err) {
                }
                try {
                    $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                    angular.forEach($scope.NotifyToArray, function (value) {
                        var UserArray3 = $scope.Userdatas;
                        var item3 = UserArray3.filter(function (item3) {
                            return item3.UserID === value;
                        })[0];
                        SenderEmails.push({ Email: item3.Email });
                    });
                } catch (err) {
                }
                try {
                    if (Workflowitem.NotifytoNextLevelApprover == true) {
                        try {
                            $scope.NLevel = Workflowitem.NextLevel;

                            var myArray1 = $scope.Workflowdatas;
                            var Workflowitem1 = myArray1.filter(function (item1) {
                                return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                            })[0];
                        } catch (err) {
                        }
                        try {
                            $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                            angular.forEach($scope.NApproversArray, function (value) {
                                var UserArray4 = $scope.Userdatas;
                                var item4 = UserArray4.filter(function (item4) {
                                    return item4.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: item4.Email });
                            });
                        } catch (err) {
                        }
                    }
                } catch (err) {
                }


                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                debugger
                RefreshGrid();
                RefreshLeaveEntitlementGrid();
                $scope.Showgrid();

                //$scope.Emails = SenderEmails;
                //$scope.SOgroups = _.groupBy(SenderEmails, 'Email');
                //angular.forEach($scope.SOgroups, function (Evalue) {
                //    var SendEmail = Evalue[0].Email;
                //    var response = $http({
                //        method: "POST",
                //        url:  $rootScope.WebURL + "/leave/email",
                //        data: {
                //            LeaveID: $scope.Userdata.id,
                //            SenderEmailAddress: SendEmail,
                //            ReferenceNo: $scope.Userdata.ReferenceNo,
                //            UniqueID: $scope.Userdata.UniqueID,
                //            EmployeeID: $scope.EmployeeId,
                //            EmployeeName: $scope.EmployeeName,
                //            FromDate: convertDate($scope.FromDate),
                //            ToDate: convertDate($scope.ToDate),
                //            FromDayType: $scope.FromDayType,
                //            ToDayType: $scope.ToDayType,
                //            LeaveType: $scope.LeaveType,
                //            Reason: $scope.Reason,
                //            EmergencyContactNo: $scope.EmergencyContactNo,
                //            TotalDaysApplied: $scope.TotalDaysApplied,
                //            TotalPaidLeaves: $scope.TotalPaidLeaves,
                //            TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                //            Status: $scope.Userdata.Status,
                //            StatusID: $scope.Userdata.StatusID,
                //            CreatedBy: $rootScope.LoginID,
                //            CreatedDate: convertDate(new Date()),
                //        },
                //    });
                //});

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/logdetails/add",
                    data: {
                        RequestID: $scope.UniqueID,
                        TypeName: "HRM Leave Request",
                        Action: "New",
                        ActionedBy: $rootScope.LoginID,
                    },
                });

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.UpdateLeaveEntitlement = function () {
            debugger
            try {
                if ($scope.LeaveType == "Annual Leave") {
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        if ($scope.Earned == 0) {
                            debugger
                            $scope.getEarned = $scope.Earned;
                            if ($scope.getEarned < 0 || $scope.getEarned == "" || $scope.getEarned == null || $scope.getEarned == undefined) {
                                $scope.getEarned = 0;
                            }
                            $scope.getAnnualLeaveEntitlement = $scope.TotalPaidLeaves;
                            $scope.UpdateAnnualLeaveEntitlement = (parseFloat($scope.AnnualLeaveEntitlement) - parseFloat($scope.getAnnualLeaveEntitlement));
                            if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                $scope.UpdateAnnualLeaveEntitlement = 0;
                            }
                            var response = $http({
                                method: "PUT",
                                url: $rootScope.WebURL + "/leaveentitlement/updateAnnual",
                                data: {
                                    _id: $scope.LEID,
                                    AnnualLeaveEntitlement: $scope.UpdateAnnualLeaveEntitlement,
                                    Earned: $scope.getEarned,
                                    AnnualLeave: $scope.AnnualLeave,
                                    UpdatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                        else if ($scope.Earned != 0) {
                            debugger
                            $scope.getEarned = $scope.Earned;
                            if ($scope.TotalPaidLeaves < $scope.getEarned) {
                                $scope.UpdateEarned = (parseFloat($scope.getEarned) - parseFloat($scope.TotalPaidLeaves));
                                if ($scope.UpdateEarned < 0 || $scope.UpdateEarned == "" || $scope.UpdateEarned == null || $scope.UpdateEarned == undefined) {
                                    $scope.UpdateEarned = 0;
                                }
                                $scope.UpdateAnnualLeaveEntitlement = $scope.AnnualLeaveEntitlement;
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            else if ($scope.TotalPaidLeaves > $scope.getEarned) {
                                $scope.UpdateEarned = 0;
                                $scope.CUpdateEarned = (parseFloat($scope.TotalPaidLeaves) - parseFloat($scope.getEarned));
                                $scope.getAnnualLeaveEntitlement = $scope.CUpdateEarned;
                                $scope.UpdateAnnualLeaveEntitlement = (parseFloat($scope.AnnualLeaveEntitlement) - parseFloat($scope.getAnnualLeaveEntitlement));
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            debugger
                            var response = $http({
                                method: "PUT",
                                url: $rootScope.WebURL + "/leaveentitlement/updateAnnual",
                                data: {
                                    _id: $scope.LEID,
                                    AnnualLeaveEntitlement: $scope.UpdateAnnualLeaveEntitlement,
                                    Earned: $scope.UpdateEarned,
                                    AnnualLeave: $scope.AnnualLeave,
                                    UpdatedBy: $rootScope.LoginID,
                                },
                            });
                        }
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.UpdateAdoptionLeave = (parseFloat($scope.AdoptionLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateAdoptionLeave < 0 || $scope.UpdateAdoptionLeave == "" || $scope.UpdateAdoptionLeave == null || $scope.UpdateAdoptionLeave == undefined) {
                        $scope.UpdateAdoptionLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateAdoption",
                            data: {
                                _id: $scope.LEID,
                                AdoptionLeave: $scope.UpdateAdoptionLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.UpdateChildCareLeave = (parseFloat($scope.ChildCareLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateChildCareLeave < 0 || $scope.UpdateChildCareLeave == "" || $scope.UpdateChildCareLeave == null || $scope.UpdateChildCareLeave == undefined) {
                        $scope.UpdateChildCareLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateChildCare",
                            data: {
                                _id: $scope.LEID,
                                ChildCareLeave: $scope.UpdateChildCareLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.UpdateCompassionateLeave = (parseFloat($scope.CompassionateLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateCompassionateLeave < 0 || $scope.UpdateCompassionateLeave == "" || $scope.UpdateCompassionateLeave == null || $scope.UpdateCompassionateLeave == undefined) {
                        $scope.UpdateCompassionateLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateCompassionate",
                            data: {
                                _id: $scope.LEID,
                                CompassionateLeave: $scope.UpdateCompassionateLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.UpdateMaternityLeave = (parseFloat($scope.MaternityLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateMaternityLeave < 0 || $scope.UpdateMaternityLeave == "" || $scope.UpdateMaternityLeave == null || $scope.UpdateMaternityLeave == undefined) {
                        $scope.UpdateMaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateMaternity",
                            data: {
                                _id: $scope.LEID,
                                MaternityLeave: $scope.UpdateMaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.UpdatePaternityLeave = (parseFloat($scope.PaternityLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdatePaternityLeave < 0 || $scope.UpdatePaternityLeave == "" || $scope.UpdatePaternityLeave == null || $scope.UpdatePaternityLeave == undefined) {
                        $scope.UpdatePaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updatePaternity",
                            data: {
                                _id: $scope.LEID,
                                PaternityLeave: $scope.UpdatePaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.UpdateSharedParentalLeave = (parseFloat($scope.SharedParentalLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSharedParentalLeave < 0 || $scope.UpdateSharedParentalLeave == "" || $scope.UpdateSharedParentalLeave == null || $scope.UpdateSharedParentalLeave == undefined) {
                        $scope.UpdateSharedParentalLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSharedParental",
                            data: {
                                _id: $scope.LEID,
                                SharedParentalLeave: $scope.UpdateSharedParentalLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.UpdateSickLeave = (parseFloat($scope.SickLeave) - parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSickLeave < 0 || $scope.UpdateSickLeave == "" || $scope.UpdateSickLeave == null || $scope.UpdateSickLeave == undefined) {
                        $scope.UpdateSickLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSick",
                            data: {
                                _id: $scope.LEID,
                                SickLeave: $scope.UpdateSickLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Off In-Lieu") { }
            } catch (e) { }
        }

        $scope.ViewLeaveinfo = function (VLeaveId) {
            $scope.LID = VLeaveId;
            $scope.Update = true;
            try {
                var item = $scope.Leavedatas.filter(function (item) {
                    return item._id === VLeaveId;
                })[0];
                $scope.LId = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.Employee = item.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.FromDate = new Date(item.FromDate);
                $scope.ToDate = new Date(item.ToDate);
                $scope.FromDayType = item.FromDayType;
                $scope.ToDayType = item.ToDayType;
                $scope.LeaveType = item.LeaveType;
                $scope.RequestedByEmployee = item.RequestedEmployee,
                    $scope.Reason = item.Reason;
                if (item.EmergencyContactNo != null && item.EmergencyContactNo != "" && item.EmergencyContactNo != undefined) {
                    $scope.EmergencyContactNo = parseFloat(item.EmergencyContactNo);
                }
                $scope.TotalDaysApplied = parseFloat(item.TotalDaysApplied);
                $scope.TotalPaidLeaves = parseFloat(item.TotalPaidLeaves);
                $scope.TotalUnPaidLeaves = parseFloat(item.TotalUnPaidLeaves);
                $scope.LeaveTaken = item.LeaveTaken;
                $scope.LeaveBalance = item.LeaveBalance,
                    $scope.LeaveEntitlement = item.LeaveEntitlement;
                $scope.MaleAssociate = parseFloat(item.MaleAssociate);
                $scope.FemaleAssociate = parseFloat(item.FemaleAssociate);
                $scope.TraineeAssociate = parseFloat(item.Trainee);
                $scope.Status = item.Status,
                    $scope.StatusID = item.StatusID;

                $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);
                $scope.Division = item.Employeedetails[0].EDivision;
                $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.FromDate);
            } catch (err) { }

            RefreshAttachmentGrid();
            RefreshCommentGrid();

            $scope.Leaveform = false;
            $scope.ViewLeaveform = true;
            $scope.Leavegrid = false;
            $scope.lExport = false;
            $scope.lView = true;
            $scope.lAdd = false;
            $scope.lSearch = false;
            $scope.Cancel = false;
            $scope.Leave = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm11.$setPristine();
            $scope.basicForm11.$setUntouched();
        }

        $scope.LeaveCancellPopup = function (e, CancellID, $index) {
            debugger
            $scope.LID = CancellID;
            $scope.IndxID = $index;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/leaveform/leaveCancel.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function LeaveformController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.CancellID = CancellID;
        }

        $scope.Cancelrequest = function (CancellID) {
            debugger
            $scope.WID = CancellID;
            try {
                var item = $scope.Leavedatas.filter(function (item) {
                    return item._id === CancellID;
                })[0];
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
                $scope.Employee = item.EmployeeID;
                $scope.LeaveType = item.LeaveType;
                $scope.TotalPaidLeaves = item.TotalPaidLeaves;
                $scope.FromDate = new Date(item.FromDate),
                    $scope.ToDate = new Date(item.ToDate),
                    $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);

                $scope.TotalWorkedMonths = momentDiff($scope.DateJoined, $scope.FromDate);
                if ($scope.TotalWorkedMonths != null && $scope.TotalWorkedMonths != undefined && $scope.TotalWorkedMonths != "") {
                    if ($scope.TotalWorkedMonths <= 12) {
                        $scope.CurrentYearTotalWorkedMonths = $scope.TotalWorkedMonths;
                    }
                    else if ($scope.TotalWorkedMonths > 12) {
                        if (parseFloat($scope.TotalWorkedMonths) % 12 == 0) {
                            $scope.CurrentYearTotalWorkedMonths = 12;
                        }
                        else if (parseFloat($scope.TotalWorkedMonths) % 12 != 0) {
                            $scope.CurrentYearTotalWorkedMonths = parseFloat($scope.TotalWorkedMonths) % 12;
                        }
                    }
                }
            } catch (err) { }

            $scope.IndexID = $scope.IndxID;
            if ($scope.Status == "New" && $scope.StatusID == 1) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/leave/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.Userdata = GList.data.data[0];
                    $scope.CancelUpdateLeaveEntitlement();
                    try {
                        $scope.EmployeeName = $scope.Userdata.Employeedetails[0].EmployeeName;
                        $scope.EmployeeId = $scope.Userdata.Employeedetails[0].EmployeeID;
                    } catch (err) {
                    }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Leave Request' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Leave Request' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Leavedatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                    RefreshLeaveEntitlementGrid();
                    $mdDialog.cancel();

                    //$scope.Emails = SenderEmails;
                    //$scope.SOgroups = _.groupBy(SenderEmails, 'Email');
                    //angular.forEach($scope.SOgroups, function (value) {
                    //    var SendEmail = value[0].Email;
                    //    var response = $http({
                    //        method: "POST",
                    //        url:  $rootScope.WebURL + "/leave/email",
                    //        data: {
                    //            LeaveID: $scope.Userdata._id,
                    //            SenderEmailAddress: SendEmail,
                    //            ReferenceNo: $scope.Userdata.ReferenceNo,
                    //            UniqueID: $scope.Userdata.UniqueID,
                    //            EmployeeID: $scope.EmployeeId,
                    //            EmployeeName: $scope.EmployeeName,
                    //            FromDate: convertDate($scope.FromDate),
                    //            ToDate: convertDate($scope.ToDate),
                    //            FromDayType: $scope.FromDayType,
                    //            ToDayType: $scope.ToDayType,
                    //            LeaveType: $scope.LeaveType,
                    //            Reason: $scope.Reason,
                    //            EmergencyContactNo: $scope.EmergencyContactNo,
                    //            TotalDaysApplied: $scope.TotalDaysApplied,
                    //            TotalPaidLeaves: $scope.TotalPaidLeaves,
                    //            TotalUnPaidLeaves: $scope.TotalUnPaidLeaves,
                    //            Status: $scope.Userdata.Status,
                    //            StatusID: $scope.Userdata.StatusID,
                    //            CreatedBy: $rootScope.LoginID,
                    //            CreatedDate: convertDate(new Date()),
                    //        },
                    //    });
                    //});

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Leave Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.CancelUpdateLeaveEntitlement = function () {
            debugger
            var CurrentYear = new Date().getFullYear();

            try {
                $scope.EmpID = $scope.Employee;
                var item = $scope.Leaveentitlementdatas.filter(function (item) {
                    return item.EmployeeID === $scope.EmpID;
                })[0];
                $scope.LEID = item._id;
                $scope.AnnualLeaveEntitlement = item.AnnualLeaveEntitlement;
                $scope.Earned = item.Earned;
                $scope.Annual = item.AnnualLeave;
                $scope.AdoptionLeave = item.AdoptionLeave;
                $scope.ChildCareLeave = item.ChildCareLeave;
                $scope.CompassionateLeave = item.CompassionateLeave;
                $scope.MaternityLeave = item.MaternityLeave;
                $scope.PaternityLeave = item.PaternityLeave;
                $scope.SharedParentalLeave = item.SharedParentalLeave;
                $scope.SickLeave = item.SickLeave;
                $scope.LeaveEntitlementYear = item.LeaveEntitlementYear;
                $scope.LeaveEntitlementDetails = item.LeaveentitlementDetails;
            } catch (err) { }

            try {
                var LEitem = $scope.LeaveEntitlementDetails.filter(function (LEitem) {
                    return (parseFloat(LEitem.LeaveEntitlementYear) === parseFloat($scope.LeaveEntitlementYear));
                })[0];
                debugger
                $scope.ULEAnnualLeaveEntitlement = LEitem.AnnualLeaveEntitlement;
                $scope.ULEEarned = LEitem.Earned;
                $scope.ULEAnnual = LEitem.AnnualLeave;
                $scope.ULEAdoption = LEitem.AdoptionLeave;
                $scope.ULEChildCare = LEitem.ChildCareLeave;
                $scope.ULECompassionate = LEitem.CompassionateLeave;
                $scope.ULEMaternity = LEitem.MaternityLeave;
                $scope.ULEPaternity = LEitem.PaternityLeave;
                $scope.ULESharedParentalLeave = LEitem.SharedParentalLeave;
                $scope.ULESickLeave = LEitem.SickLeave;
            } catch (err) { }

            try {
                if ($scope.LeaveType == "Annual Leave") {
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        if ($scope.ULEAnnualLeaveEntitlement == $scope.AnnualLeaveEntitlement) {
                            $scope.UpdateEarned = (parseFloat($scope.Earned) + parseFloat($scope.TotalPaidLeaves));
                            if ($scope.UpdateEarned < 0 || $scope.UpdateEarned == "" || $scope.UpdateEarned == null || $scope.UpdateEarned == undefined) {
                                $scope.UpdateEarned = 0;
                            }
                            $scope.UpdateAnnualLeaveEntitlement = $scope.AnnualLeaveEntitlement;
                            if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                $scope.UpdateAnnualLeaveEntitlement = 0;
                            }
                        }
                        else if ($scope.ULEAnnualLeaveEntitlement > $scope.AnnualLeaveEntitlement) {
                            $scope.getTotalLeave = $scope.TotalPaidLeaves;
                            $scope.CHKAnnualLeaveEntitlement = (parseFloat($scope.AnnualLeaveEntitlement) + parseFloat($scope.getTotalLeave));

                            if ($scope.CHKAnnualLeaveEntitlement == $scope.ULEAnnualLeaveEntitlement) {
                                $scope.UpdateEarned = 0;
                                $scope.UpdateAnnualLeaveEntitlement = $scope.CHKAnnualLeaveEntitlement;
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            else if ($scope.CHKAnnualLeaveEntitlement > $scope.ULEAnnualLeaveEntitlement) {
                                $scope.BUpdateEarned = (parseFloat($scope.CHKAnnualLeaveEntitlement) - parseFloat($scope.ULEAnnualLeaveEntitlement));
                                $scope.UpdateEarned = (parseFloat($scope.Earned) + parseFloat($scope.BUpdateEarned));
                                if ($scope.UpdateEarned < 0 || $scope.UpdateEarned == "" || $scope.UpdateEarned == null || $scope.UpdateEarned == undefined) {
                                    $scope.UpdateEarned = 0;
                                }
                                $scope.UpdateAnnualLeaveEntitlement = (parseFloat($scope.CHKAnnualLeaveEntitlement) - parseFloat($scope.BUpdateEarned));
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                            else if ($scope.CHKAnnualLeaveEntitlement < $scope.ULEAnnualLeaveEntitlement) {
                                $scope.UpdateEarned = 0;
                                $scope.UpdateAnnualLeaveEntitlement = $scope.CHKAnnualLeaveEntitlement;
                                if ($scope.UpdateAnnualLeaveEntitlement < 0 || $scope.UpdateAnnualLeaveEntitlement == "" || $scope.UpdateAnnualLeaveEntitlement == null || $scope.UpdateAnnualLeaveEntitlement == undefined) {
                                    $scope.UpdateAnnualLeaveEntitlement = 0;
                                }
                            }
                        }
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateAnnual",
                            data: {
                                _id: $scope.LEID,
                                AnnualLeaveEntitlement: $scope.UpdateAnnualLeaveEntitlement,
                                Earned: $scope.UpdateEarned,
                                AnnualLeave: $scope.AnnualLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Adoption Leave") {
                    $scope.UpdateAdoptionLeave = (parseFloat($scope.AdoptionLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateAdoptionLeave < 0 || $scope.UpdateAdoptionLeave == "" || $scope.UpdateAdoptionLeave == null || $scope.UpdateAdoptionLeave == undefined) {
                        $scope.UpdateAdoptionLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateAdoption",
                            data: {
                                _id: $scope.LEID,
                                AdoptionLeave: $scope.UpdateAdoptionLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Child Care Leave") {
                    $scope.UpdateChildCareLeave = (parseFloat($scope.ChildCareLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateChildCareLeave < 0 || $scope.UpdateChildCareLeave == "" || $scope.UpdateChildCareLeave == null || $scope.UpdateChildCareLeave == undefined) {
                        $scope.UpdateChildCareLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateChildCare",
                            data: {
                                _id: $scope.LEID,
                                ChildCareLeave: $scope.UpdateChildCareLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Compassionate Leave") {
                    $scope.UpdateCompassionateLeave = (parseFloat($scope.CompassionateLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateCompassionateLeave < 0 || $scope.UpdateCompassionateLeave == "" || $scope.UpdateCompassionateLeave == null || $scope.UpdateCompassionateLeave == undefined) {
                        $scope.UpdateCompassionateLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateCompassionate",
                            data: {
                                _id: $scope.LEID,
                                CompassionateLeave: $scope.UpdateCompassionateLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Maternity Leave") {
                    $scope.UpdateMaternityLeave = (parseFloat($scope.MaternityLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateMaternityLeave < 0 || $scope.UpdateMaternityLeave == "" || $scope.UpdateMaternityLeave == null || $scope.UpdateMaternityLeave == undefined) {
                        $scope.UpdateMaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateMaternity",
                            data: {
                                _id: $scope.LEID,
                                MaternityLeave: $scope.UpdateMaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Paternity Leave") {
                    $scope.UpdatePaternityLeave = (parseFloat($scope.PaternityLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdatePaternityLeave < 0 || $scope.UpdatePaternityLeave == "" || $scope.UpdatePaternityLeave == null || $scope.UpdatePaternityLeave == undefined) {
                        $scope.UpdatePaternityLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updatePaternity",
                            data: {
                                _id: $scope.LEID,
                                PaternityLeave: $scope.UpdatePaternityLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Shared Parental Leave") {
                    $scope.UpdateSharedParentalLeave = (parseFloat($scope.SharedParentalLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSharedParentalLeave < 0 || $scope.UpdateSharedParentalLeave == "" || $scope.UpdateSharedParentalLeave == null || $scope.UpdateSharedParentalLeave == undefined) {
                        $scope.UpdateSharedParentalLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSharedParental",
                            data: {
                                _id: $scope.LEID,
                                SharedParentalLeave: $scope.UpdateSharedParentalLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Sick Leave") {
                    $scope.UpdateSickLeave = (parseFloat($scope.SickLeave) + parseFloat($scope.TotalPaidLeaves));
                    if ($scope.UpdateSickLeave < 0 || $scope.UpdateSickLeave == "" || $scope.UpdateSickLeave == null || $scope.UpdateSickLeave == undefined) {
                        $scope.UpdateSickLeave = 0;
                    }
                    if ($scope.TotalPaidLeaves > 0) {
                        debugger
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/leaveentitlement/updateSick",
                            data: {
                                _id: $scope.LEID,
                                SickLeave: $scope.UpdateSickLeave,
                                UpdatedBy: $rootScope.LoginID,
                            },
                        });
                    }
                    else { }
                }
                else if ($scope.LeaveType == "Off In-Lieu") { }
            } catch (e) { }
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "HRM Leave Request",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm11.$setPristine();
                $scope.basicForm11.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/incident/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Leave Request",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function ClearForm() {
            $scope.UniqueID = '';
            $scope.Employee = '';
            $scope.RequestedByEmployee = '';
            $scope.FromDate = '';
            $scope.ToDate = '';
            $scope.FromDayType = '';
            $scope.ToDayType = '';
            $scope.LeaveType = "Annual Leave";
            $scope.Reason = '';
            $scope.EmergencyContactNo = '';
            $scope.TotalDaysApplied = '';
            $scope.TotalPaidLeaves = '';
            $scope.TotalUnPaidLeaves = '';
            $scope.LeaveTaken = '';
            $scope.LeaveBalance = '';
            $scope.LeaveEntitlement = '';
            $scope.MaleAssociate = '';
            $scope.FemaleAssociate = '';
            $scope.Trainee = '';
            $scope.id = '';
            $scope.Division = '';
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.LID = PId;
            var url = $rootScope.ReportURL + "Leave.aspx?ID=" + PId;
            window.open(url);
        };

        $scope.LeaveList = [
            { Name: "Annual Leave" },
            { Name: "Adoption Leave" },
            { Name: "Child Care Leave" },
            { Name: "Compassionate Leave" },
            { Name: "Maternity Leave" },
            { Name: "Paternity Leave" },
            { Name: "Shared Parental Leave" },
            { Name: "Sick Leave" },
            { Name: "Off In-Lieu" }];

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.Leaveinfo = function (LeaveId, $index) {
            debugger
            $scope.LID = LeaveId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Leavedatas.filter(function (item) {
                    return item._id === LeaveId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {

                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo,
                        $scope.UniqueID = item.UniqueID,
                        $scope.Employee = item.EmployeeID,
                        $scope.FromDate = new Date(item.FromDate),
                        $scope.ToDate = new Date(item.ToDate),
                        $scope.FromDayType = item.FromDayType,
                        $scope.ToDayType = item.ToDayType,
                        $scope.LeaveType = item.LeaveType,
                        $scope.RequestedByEmployee = item.RequestedEmployee,
                        $scope.OtherLeave = item.OtherLeave,
                        $scope.Reason = item.Reason,
                        $scope.EmergencyContactNo = parseFloat(item.EmergencyContactNo),
                        $scope.TotalDaysApplied = parseFloat(item.TotalDaysApplied),
                        $scope.TotalPaidLeaves = parseFloat(item.TotalPaidLeaves),
                        $scope.TotalUnPaidLeaves = parseFloat(item.TotalUnPaidLeaves),
                        $scope.LeaveTaken = item.LeaveTaken,
                        $scope.LeaveBalance = item.LeaveBalance,
                        $scope.LeaveEntitlement = item.LeaveEntitlement,
                        $scope.MaleAssociate = parseFloat(item.MaleAssociate),
                        $scope.FemaleAssociate = parseFloat(item.FemaleAssociate),
                        $scope.TraineeAssociate = parseFloat(item.Trainee),
                        $scope.Status = item.Status,
                        $scope.StatusID = item.StatusID;
                    $scope.DateJoined = new Date(item.Employeedetails[0].EDateOfJoin);
                    $scope.Division = item.Employeedetails[0].EDivision;
                    var a = $scope.DateJoined;
                    var b = new Date();
                    $scope.TotalWorkedMonths = momentDiff(a, b);
                    debugger
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }
                $scope.isDisabled = false;
                var d1 = getDateonly($scope.FromDate);
                var d2 = getDateonly($scope.ToDate);
                if (d1 === d2) {
                    $scope.isDisabled = true;
                    $scope.ToDayType = "Full Day";
                }
                else {
                    $scope.isDisabled = false;
                }

                RefreshAttachmentGrid();
                RefreshCommentGrid();

                $scope.Update = true;
                $scope.Leaveform = true;
                $scope.ViewLeaveform = false;
                $scope.Leavegrid = false;
                $scope.lExport = false;
                $scope.lView = true;
                $scope.lAdd = false;
                $scope.lSearch = false;
                $scope.Cancel = true;
                $scope.Leave = false;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();

            }
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            //stateSave: true,
            //destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

    }
})();





(function () {
    'use strict';

    angular
        .module('app.human-resource.incidentform', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_incidentform', {
            url: '/IncidentReportForm',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/incidentform/incidentform.html',
                    controller: 'IncidentformController as vm'
                }
            }
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.incidentform')
        .controller('IncidentformController', IncidentformController)
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });


    function IncidentformController($mdDateLocale, $scope, $rootScope, $interval, $mdSidenav, $location, $mdToast, $mdDialog, $document, $http, $log, $filter, Upload, NgMap) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Incident")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshWorkflowGrid();

        $scope.Incidentform = false;
        $scope.ViewIncidentform = false;
        $scope.Incidentgrid = true;
        $scope.iExport = true;
        $scope.iAdd = true;
        $scope.iSearch = true;
        $scope.iView = false;
        $scope.Incident = false;

        $scope.getRowColour = function (item) {
            if (item.Status == "Cancelled" || item.Status == "Rejected") {
                return true;
            }
            else {
                return false;
            }
        }

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
            $scope.vm.searchTerm3 = '';
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("IncidentReports.xlsx",{headers:true}) FROM ?', [$scope.Incidentdatas]);
        };

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.Add = function () {
            ClearForm();
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.InjuredName = item1.id;
            } catch (error) { }

            $scope.ReportDate = new Date();
            $scope.PPERequired = "No";
            $scope.PPEProvided = "No";
            $scope.PPEUsed = "No";
            $scope.PPETrained = "No";
            $scope.SafetyTaining = "No";
            $scope.RiskAssessmentReviewed = "No";
            $scope.RiskAssessmentRevised = "No";
            $scope.PreventiveAction = "No";

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            $scope.Update = false;
            $scope.Incidentform = true;
            $scope.ViewIncidentform = false;
            $scope.Incidentgrid = false;
            $scope.iExport = false;
            $scope.iView = true;
            $scope.iAdd = false;
            $scope.iSearch = false;
            $scope.Incident = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm1.$setPristine();
            $scope.basicForm1.$setUntouched();
        }

        $scope.Showgrid = function () {
            $scope.Incidentgrid = true;
            $scope.Incidentform = false;
            $scope.ViewIncidentform = false;
            $scope.iExport = true;
            $scope.iAdd = true;
            $scope.iView = false;
            $scope.iSearch = true;
            $scope.Incident = false;
        }

        $scope.iSubmit = function () {
            if ($scope.Update == true) {
                $scope.IndexID = $scope.IndxID;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/incident/update",
                    data: {
                        _id: $scope.SID,
                        InjuredName: $scope.InjuredName,
                        ReportedBy: $scope.ReportedBy,
                        ReportedTo: $scope.ReportedTo,
                        ReportDate: $scope.ReportDate,
                        IncidentDate: $scope.IncidentDate,
                        IncidentTime: $scope.IncidentTime,
                        IncidentLocation: $scope.IncidentLocation,
                        Remarks: $scope.Remarks,
                        NatureofInjury: $scope.NatureofInjury,
                        IncidentOccured: $scope.IncidentOccured,
                        IncidentCause: $scope.IncidentCause,
                        PPERequired: $scope.PPERequired,
                        PPEProvided: $scope.PPEProvided,
                        PPEUsed: $scope.PPEUsed,
                        PPEUsedRemarks: $scope.PPEUsedRemarks,
                        PPETrained: $scope.PPETrained,
                        PPETrainedRemarks: $scope.PPETrainedRemarks,
                        SafetyTaining: $scope.SafetyTaining,
                        SafetyTainingRemarks: $scope.SafetyTainingRemarks,
                        CorrectiveActionRefNo: $scope.CorrectiveActionRefNo,
                        RiskAssessmentReviewed: $scope.RiskAssessmentReviewed,
                        RiskAssessmentRevised: $scope.RiskAssessmentRevised,
                        PreventiveAction: $scope.PreventiveAction,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];

                    $scope.Ltime = $filter('date')($scope.Userdata.IncidentTime, 'h:mm a');
                    try {
                        $scope.InjuredEmployeeName = $scope.Userdata.InjuredEmployeedetails[0].EmployeeName;
                        $scope.InjuredEmployeeId = $scope.Userdata.InjuredEmployeedetails[0].EmployeeID;
                    } catch (err) { }

                    try {
                        $scope.ReportedByEmployeeName = $scope.Userdata.ReportedByEmployeedetails[0].EmployeeID + '-' + $scope.Userdata.ReportedByEmployeedetails[0].EmployeeName;
                    } catch (err) { }

                    try {
                        $scope.ReportedToEmployeeName = $scope.Userdata.ReportedToEmployeedetails[0].EmployeeID + '-' + $scope.Userdata.ReportedToEmployeedetails[0].EmployeeName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Incident Report' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Incident Report' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/incident/email",
                            data: {
                                IncidentID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.InjuredEmployeeId,
                                EmployeeName: $scope.InjuredEmployeeName,
                                ReportedBy: $scope.ReportedByEmployeeName,
                                ReportedTo: $scope.ReportedToEmployeeName,
                                ReportDate: convertDate($scope.Userdata.ReportDate),
                                IncidentDate: convertDate($scope.Userdata.IncidentDate),
                                IncidentTime: $scope.Ltime,
                                IncidentLocation: $scope.Userdata.IncidentLocation,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Incidentdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/incident/add",
                    data: {
                        Client_Id: Client_Id,
                        UniqueID: $scope.UniqueID,
                        InjuredName: $scope.InjuredName,
                        ReportedBy: $scope.ReportedBy,
                        ReportedTo: $scope.ReportedTo,
                        ReportDate: $scope.ReportDate,
                        IncidentDate: $scope.IncidentDate,
                        IncidentTime: $scope.IncidentTime,
                        IncidentLocation: $scope.IncidentLocation,
                        Remarks: $scope.Remarks,
                        NatureofInjury: $scope.NatureofInjury,
                        IncidentOccured: $scope.IncidentOccured,
                        IncidentCause: $scope.IncidentCause,
                        PPERequired: $scope.PPERequired,
                        PPEProvided: $scope.PPEProvided,
                        PPEUsed: $scope.PPEUsed,
                        PPEUsedRemarks: $scope.PPEUsedRemarks,
                        PPETrained: $scope.PPETrained,
                        PPETrainedRemarks: $scope.PPETrainedRemarks,
                        SafetyTaining: $scope.SafetyTaining,
                        SafetyTainingRemarks: $scope.SafetyTainingRemarks,
                        CorrectiveActionRefNo: $scope.CorrectiveActionRefNo,
                        RiskAssessmentReviewed: $scope.RiskAssessmentReviewed,
                        RiskAssessmentRevised: $scope.RiskAssessmentRevised,
                        PreventiveAction: $scope.PreventiveAction,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.Userdata = GList.data.data;
                    $scope.Ltime = $filter('date')($scope.Userdata.IncidentTime, 'h:mm a');

                    try {
                        var Eitem1 = $scope.Employeedatas.filter(function (Eitem1) {
                            return Eitem1.id === $scope.Userdata.InjuredName;
                        })[0];
                        $scope.InjuredEmployeeName = Eitem1.EmployeeName;
                        $scope.InjuredEmployeeId = Eitem1.EmployeeID;
                    } catch (err) { }

                    try {
                        var Eitem2 = $scope.Employeedatas.filter(function (Eitem2) {
                            return Eitem2.id === $scope.Userdata.ReportedBy;
                        })[0];
                        $scope.ReportedByEmployeeName = Eitem2.EmployeeID + '-' + Eitem2.EmployeeName;
                    } catch (err) { }

                    try {
                        var Eitem3 = $scope.Employeedatas.filter(function (Eitem3) {
                            return Eitem3.id === $scope.Userdata.ReportedTo;
                        })[0];
                        $scope.ReportedToEmployeeName = Eitem3.EmployeeID + '-' + Eitem3.EmployeeName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Incident Report' && Workflowitem.LevelName === $scope.Userdata.StatusID;
                        })[0];
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) {
                    }
                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) {
                    }
                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Incident Report' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) {
                            }
                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) {
                            }
                        }
                    } catch (err) {
                    }

                    RefreshGrid();
                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/incident/email",
                            data: {
                                IncidentID: $scope.Userdata.id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.InjuredEmployeeId,
                                EmployeeName: $scope.InjuredEmployeeName,
                                ReportedBy: $scope.ReportedByEmployeeName,
                                ReportedTo: $scope.ReportedToEmployeeName,
                                ReportDate: convertDate($scope.Userdata.ReportDate),
                                IncidentDate: convertDate($scope.Userdata.IncidentDate),
                                IncidentTime: $scope.Ltime,
                                IncidentLocation: $scope.Userdata.IncidentLocation,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Incident Report",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    //RefreshGrid();
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Incidentinfo = function (IncidentId, $index) {
            $scope.SID = IncidentId;
            $scope.IndxID = $index;
            try {
                var item = $scope.Incidentdatas.filter(function (item) {
                    return item._id === IncidentId;
                })[0];
                $scope.id = item._id;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }
            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {

                try {
                    $scope.id = item._id;
                    $scope.ReferenceNo = item.ReferenceNo;
                    $scope.UniqueID = item.UniqueID;
                    $scope.InjuredName = item.InjuredName;
                    $scope.ReportedBy = item.ReportedBy;
                    $scope.ReportedTo = item.ReportedTo;
                    $scope.ReportDate = new Date(item.ReportDate);
                    $scope.IncidentDate = new Date(item.IncidentDate);
                    $scope.IncidentTime = item.IncidentTime;
                    if ($scope.IncidentTime != null && $scope.IncidentTime != "") {
                        $scope.IncidentTime = new Date(item.IncidentTime);
                    }
                    $scope.IncidentLocation = item.IncidentLocation;
                    $scope.Remarks = item.Remarks;
                    $scope.NatureofInjury = item.NatureofInjury;
                    $scope.IncidentOccured = item.IncidentOccured;
                    $scope.IncidentCause = item.IncidentCause;
                    $scope.PPERequired = item.PPERequired;
                    $scope.PPEProvided = item.PPEProvided;
                    $scope.PPEUsed = item.PPEUsed;
                    $scope.PPEUsedRemarks = item.PPEUsedRemarks;
                    $scope.PPETrained = item.PPETrained;
                    $scope.PPETrainedRemarks = item.PPETrainedRemarks;
                    $scope.SafetyTaining = item.SafetyTaining;
                    $scope.SafetyTainingRemarks = item.SafetyTainingRemarks;
                    $scope.CorrectiveActionRefNo = item.CorrectiveActionRefNo;
                    $scope.RiskAssessmentReviewed = item.RiskAssessmentReviewed;
                    $scope.RiskAssessmentRevised = item.RiskAssessmentRevised;
                    $scope.PreventiveAction = item.PreventiveAction;
                    $scope.Status = item.Status;
                    $scope.StatusID = item.StatusID;
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

                RefreshIncidentwitnessGrid();
                RefreshAttachmentGrid();
                RefreshCommentGrid();

                $scope.Update = true;
                $scope.Incidentform = true;
                $scope.ViewIncidentform = false;
                $scope.Incidentgrid = false;
                $scope.iExport = false;
                $scope.iView = true;
                $scope.iAdd = false;
                $scope.iSearch = false;
                $scope.Incident = false;
                $scope.basicForm.$setPristine();
                $scope.basicForm.$setUntouched();
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
            }
        }

        $scope.ViewIncidentinfo = function (VIncidentId) {
            $scope.SID = VIncidentId;
            $scope.Update = true;
            $scope.Incidentform = false;
            $scope.ViewIncidentform = true;
            $scope.Incidentgrid = false;
            $scope.iExport = false;
            $scope.iView = true;
            $scope.iAdd = false;
            $scope.iSearch = false;
            $scope.Incident = true;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.basicForm11.$setPristine();
            $scope.basicForm11.$setUntouched();
            try {
                var item = $scope.Incidentdatas.filter(function (item) {
                    return item._id === VIncidentId;
                })[0];
                $scope.id = item._id;
                $scope.ReferenceNo = item.ReferenceNo;
                $scope.UniqueID = item.UniqueID;
                $scope.InjuredName = item.InjuredName;
                $scope.InjuredEmployeeName = item.InjuredEmployeedetails[0].EmployeeID + '-' + item.InjuredEmployeedetails[0].EmployeeName;
                $scope.ReportedBy = item.ReportedBy;
                $scope.ReportedByEmployeeName = item.ReportedByEmployeedetails[0].EmployeeID + '-' + item.ReportedByEmployeedetails[0].EmployeeName;
                $scope.ReportedTo = item.ReportedTo;
                $scope.ReportedToEmployeeName = item.ReportedToEmployeedetails[0].EmployeeID + '-' + item.ReportedToEmployeedetails[0].EmployeeName;
                $scope.ReportDate = new Date(item.ReportDate);
                $scope.IncidentDate = new Date(item.IncidentDate);
                $scope.IncidentTime = item.IncidentTime;
                if ($scope.IncidentTime != null && $scope.IncidentTime != "") {
                    $scope.IncidentTime = new Date(item.IncidentTime);
                }
                $scope.IncidentLocation = item.IncidentLocation;
                $scope.Remarks = item.Remarks;
                $scope.NatureofInjury = item.NatureofInjury;
                $scope.IncidentOccured = item.IncidentOccured;
                $scope.IncidentCause = item.IncidentCause;
                $scope.PPERequired = item.PPERequired;
                $scope.PPEProvided = item.PPEProvided,
                    $scope.PPEUsed = item.PPEUsed,
                    $scope.PPEUsedRemarks = item.PPEUsedRemarks,
                    $scope.PPETrained = item.PPETrained,
                    $scope.PPETrainedRemarks = item.PPETrainedRemarks,
                    $scope.SafetyTaining = item.SafetyTaining,
                    $scope.SafetyTainingRemarks = item.SafetyTainingRemarks,
                    $scope.CorrectiveActionRefNo = item.CorrectiveActionRefNo;
                $scope.RiskAssessmentReviewed = item.RiskAssessmentReviewed;
                $scope.RiskAssessmentRevised = item.RiskAssessmentRevised;
                $scope.PreventiveAction = item.PreventiveAction;
                $scope.Status = item.Status;
                $scope.StatusID = item.StatusID;
            } catch (err) { }

            RefreshIncidentwitnessGrid();
            RefreshAttachmentGrid();
            RefreshCommentGrid();
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "HRM Incident Report",
                    CommentedBy: $rootScope.LoginID,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.ModuleID,
                    CreatedBy: $rootScope.LoginID,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm1.$setPristine();
                $scope.basicForm1.$setUntouched();
                $scope.basicForm11.$setPristine();
                $scope.basicForm11.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Uploadfiles = function (file) {
            var upfile = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/incident/upload",
                data: { file: upfile }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Incident Report",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize,
                            FileType: $scope.fileType,
                            ModuleID: $scope.Path,
                            Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        file[0].cancel();
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                file[0].cancel();
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancelrequest = function () {
            $scope.WID = $scope.SID;
            $scope.IndexID = $scope.IndxID;
            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/incident/updateWorkflow",
                    data: {
                        _id: $scope.WID,
                        Status: "Cancelled",
                        StatusID: "0",
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.Userdata = GList.data.data[0];

                    $scope.Ltime = $filter('date')($scope.Userdata.IncidentTime, 'h:mm a');

                    try {
                        $scope.InjuredEmployeeName = $scope.Userdata.InjuredEmployeedetails[0].EmployeeName;
                        $scope.InjuredEmployeeId = $scope.Userdata.InjuredEmployeedetails[0].EmployeeID;
                    } catch (err) { }

                    try {
                        $scope.ReportedByEmployeeName = $scope.Userdata.ReportedByEmployeedetails[0].EmployeeID + '-' + $scope.Userdata.ReportedByEmployeedetails[0].EmployeeName;
                    } catch (err) { }

                    try {
                        $scope.ReportedToEmployeeName = $scope.Userdata.ReportedToEmployeedetails[0].EmployeeID + '-' + $scope.Userdata.ReportedToEmployeedetails[0].EmployeeName;
                    } catch (err) { }

                    var SenderEmails = [];

                    try {
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (Workflowitem) {
                            return Workflowitem.TypeName === 'HRM Incident Report' && Workflowitem.LevelName === $scope.StatusID;
                        })[0];
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCurrentApprover == true) {
                            $scope.ApproversArray = Workflowitem.Approvers.split(',');
                            angular.forEach($scope.ApproversArray, function (value) {
                                var UserArray = $scope.Userdatas;
                                var Useritem = UserArray.filter(function (Useritem) {
                                    return Useritem.UserID === value;
                                })[0];
                                SenderEmails.push({ Email: Useritem.Email });
                            });
                        }
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoCreatorInitator == true) {
                            var UserArray2 = $scope.Userdatas;
                            var item2 = UserArray2.filter(function (item2) {
                                return item2.UserID === $scope.Userdata.CreatedBy;
                            })[0];
                            SenderEmails.push({ Email: item2.Email });
                        }
                    } catch (err) { }

                    try {
                        $scope.NotifyToArray = Workflowitem.NotifyTo.split(',');
                        angular.forEach($scope.NotifyToArray, function (value) {
                            var UserArray3 = $scope.Userdatas;
                            var item3 = UserArray3.filter(function (item3) {
                                return item3.UserID === value;
                            })[0];
                            SenderEmails.push({ Email: item3.Email });
                        });
                    } catch (err) { }

                    try {
                        if (Workflowitem.NotifytoNextLevelApprover == true) {
                            try {
                                $scope.NLevel = Workflowitem.NextLevel;

                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (item1) {
                                    return item1.TypeName === 'HRM Incident Report' && item1.LevelName === $scope.NLevel;
                                })[0];
                            } catch (err) { }

                            try {
                                $scope.NApproversArray = Workflowitem1.Approvers.split(',');
                                angular.forEach($scope.NApproversArray, function (value) {
                                    var UserArray4 = $scope.Userdatas;
                                    var item4 = UserArray4.filter(function (item4) {
                                        return item4.UserID === value;
                                    })[0];
                                    SenderEmails.push({ Email: item4.Email });
                                });
                            } catch (err) { }
                        }
                    } catch (err) { }

                    $scope.Emails = SenderEmails;
                    $scope.SOgroups = _.groupBy(SenderEmails, 'Email');

                    angular.forEach($scope.SOgroups, function (value) {
                        var SendEmail = value[0].Email;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/incident/email",
                            data: {
                                IncidentID: $scope.Userdata._id,
                                SenderEmailAddress: SendEmail,
                                ReferenceNo: $scope.Userdata.ReferenceNo,
                                UniqueID: $scope.Userdata.UniqueID,
                                EmployeeID: $scope.InjuredEmployeeId,
                                EmployeeName: $scope.InjuredEmployeeName,
                                ReportedBy: $scope.ReportedByEmployeeName,
                                ReportedTo: $scope.ReportedToEmployeeName,
                                ReportDate: convertDate($scope.Userdata.ReportDate),
                                IncidentDate: convertDate($scope.Userdata.IncidentDate),
                                IncidentTime: $scope.Ltime,
                                IncidentLocation: $scope.Userdata.IncidentLocation,
                                Remarks: $scope.Userdata.Remarks,
                                Status: $scope.Userdata.Status,
                                StatusID: $scope.Userdata.StatusID,
                                CreatedBy: $rootScope.LoginID,
                                CreatedDate: convertDate(new Date()),
                            },
                        });
                    });

                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "HRM Incident Report",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                    $scope.Incidentdatas[$scope.IndexID] = GList.data.data[0];
                    $scope.Showgrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Witnesspopup = function (e, UniqueID) {
            $scope.UniqueID = UniqueID;
            $scope.vm.wName = '';
            $scope.vm.wAddress = '';
            $scope.vm.wContactNo = '';
            $scope.WUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/incidentform/witness.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IncidentformController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Witnessadd = function () {
            if ($scope.WUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/incidentwitness/update",
                    data: {
                        _id: $scope.WID,
                        Name: $scope.vm.wName,
                        Address: $scope.vm.wAddress,
                        ContactNo: $scope.vm.wContactNo,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshIncidentwitnessGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/incidentwitness/add",
                    data: {
                        UniqueID: $scope.UniqueID,
                        Name: $scope.vm.wName,
                        Address: $scope.vm.wAddress,
                        ContactNo: $scope.vm.wContactNo,
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshIncidentwitnessGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Witnessupdate = function (e, WitnessId) {
            $scope.WUpdate = true;
            $scope.WID = WitnessId;
            try {
                var item = $scope.Incidentwitnessdatas.filter(function (item) {
                    return item._id === WitnessId;
                })[0];
                $scope.id = item._id;
                $scope.UniqueID = item.UniqueID;
                $scope.vm.wName = item.Name;
                $scope.vm.wAddress = item.Address;
                $scope.vm.wContactNo = parseInt(item.ContactNo);
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/incidentform/witness.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IncidentformController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Witnessdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/incidentform/witnessdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function IncidentformController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Wdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/incidentwitness/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshIncidentwitnessGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function RefreshGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/incident/getByLoginID",
                method: "POST",
                data: { LoginID: $rootScope.LoginID },
            });
            response.then(function (Incidentdata) {
                debugger
                $scope.Incidentdatas = Incidentdata.data.data;
            });
        }

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee/detailsforTab",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                LoadDeafaultEmployee();
            });
        }

        function LoadDeafaultEmployee() {
            try {
                var Userdata = $scope.Userdatas.filter(function (item) {
                    return item.UserID === $rootScope.LoginID;
                })[0];

                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === Userdata.EmployeeID;
                })[0];
                $scope.InjuredName = item1.id;
            } catch (error) { }
        }

        function RefreshWorkflowGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/Workflow",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }

        function RefreshIncidentwitnessGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/incidentwitness/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Incidentwitnessdata) {
                $scope.Incidentwitnessdatas = Incidentwitnessdata.data.data;
            });
        }

        function RefreshCommentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function ClearForm() {
            $scope.UniqueID = '';
            $scope.InjuredName = '';
            $scope.ReportedBy = '';
            $scope.ReportedTo = '';
            $scope.ReportDate = '';
            $scope.IncidentDate = '';
            $scope.IncidentTime = '';
            $scope.IncidentLocation = '';
            $scope.Remarks = '';
            $scope.NatureofInjury = '';
            $scope.IncidentOccured = '';
            $scope.IncidentCause = '';
            $scope.PPERequired = '';
            $scope.PPEProvided = '';
            $scope.PPEUsed = '';
            $scope.PPEUsedRemarks = '';
            $scope.PPETrained = '';
            $scope.PPETrainedRemarks = '';
            $scope.SafetyTaining = '';
            $scope.SafetyTainingRemarks = '';
            $scope.CorrectiveActionRefNo = '';
            $scope.RiskAssessmentReviewed = '';
            $scope.RiskAssessmentRevised = '';
            $scope.PreventiveAction = '';
            $scope.Status = '';
            $scope.StatusID = '';
            $scope.vm.Comments = '';
            $scope.Commentdatas = '';
            $scope.Attachmentdatas = '';
            $scope.Incidentwitnessdatas = '';
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.printToCart = function (PId) {
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Incident.aspx?ID=" + PId;
            window.open(url);
        };

        var vm = this;

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            stateSave: true,
            destroy: true
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

    }
})();




(function ()
{
    'use strict';

    angular
        .module('app.human-resource.workflow', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.human-resource_workflow', {
            url      :'/Workflow',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/hrmworkflow/hrmworkflow.html',
                    controller: 'WorkflowHRMController as vm'
                }
            },
            resolve: {
                UserData: function (apiResolver) {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'security-user'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/hrmworkflow');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.workflow')
        .controller('WorkflowHRMController', WorkflowHRMController);

    /** @ngInject */
    function WorkflowHRMController($mdDateLocale, $filter, $scope, $rootScope, $interval, $location, $mdToast, $mdSidenav, $http, $timeout, $q, $log) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Hrmusers")) {
            // do nothing
        }
        else {
            $location.path("NoAccess");
        }

        var Client_Id = localStorage.getItem('Client_Id');

        $scope.Workflowgrid = true;
        $scope.Export = true;
        $scope.Workflowform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;
        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Workflowform = true;
            $scope.Workflowgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Search = false;
            $scope.error1 = false;
            try {
                var item = $scope.Clientdatas.filter(function (item) {
                    return item.id === $rootScope.Client_Id;
                })[0];
                $scope.uClientName = item.ClientName;
            }
            catch (e) { }

        }
        $scope.Showgrid = function () {
            $scope.Workflowgrid = true;
            $scope.Workflowform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.error1 = false;
            $scope.checkboxModel = { value: false, };
            $scope.oneWorkflow = false;
        }
        $scope.Workflowinfo = function (WorkflowId) {
            $scope.Update = true;
            $scope.Workflowform = true;
            $scope.Workflowgrid = false;
            $scope.Export = false;
            $scope.view = true
            $scope.Add = false;

            $scope.WorkflowID = WorkflowId;

            angular.forEach($scope.Workflowdatas, function (value, key) {
                if (WorkflowId == value._id) {
                    $scope.TypeName = value.TypeName;
                    $scope.LevelName = parseInt(value.LevelName);
                    $scope.Action = value.Action;
                    $scope.Actioned = value.Actioned;
                    $scope.NextLevel = parseInt(value.NextLevel);
                    $scope.uClientName = value.Client_Id;
                    $scope.Approvers = value.Approvers;
                    if ($scope.Approvers != null && $scope.Approvers != "" && $scope.Approvers != undefined) {
                        var array = $scope.Approvers.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ UserID: value });
                        });
                        $scope.Approvers = array1;
                    }
                    $scope.NotifyTo = value.NotifyTo;
                    if ($scope.NotifyTo != null && $scope.NotifyTo != "" && $scope.NotifyTo != undefined) {
                        var array = $scope.NotifyTo.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ UserID: value });
                        });
                        $scope.NotifyTo = array1;
                    }

                    $scope.EmailExceptions = value.EmailExceptions;
                    $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;

                    if (value.ShowCancelButton == true) { $scope.ShowCancelButton = { value: true, } } else { $scope.ShowCancelButton = { value: false, }; }
                    if (value.ShowRejectButton == true) { $scope.ShowRejectButton = { value: true, } } else { $scope.ShowRejectButton = { value: false, }; }
                    if (value.ShowReviseButton == true) { $scope.ShowReviseButton = { value: true, } } else { $scope.ShowReviseButton = { value: false, }; }
                    if (value.Mandatory == true) { $scope.Mandatory = { value: true, } } else { $scope.Mandatory = { value: false, }; }
                    if (value.EmailNotification == true) { $scope.EmailNotification = { value: true, } } else { $scope.EmailNotification = { value: false, }; }
                    if (value.NotifytoCurrentApprover == true) { $scope.NotifytoCurrentApprover = { value: true, } } else { $scope.NotifytoCurrentApprover = { value: false, }; }
                    if (value.NotifytoNextLevelApprover == true) { $scope.NotifytoNextLevelApprover = { value: true, } } else { $scope.NotifytoNextLevelApprover = { value: false, }; }
                    if (value.NotifytoCreatorInitator == true) { $scope.NotifytoCreatorInitator = { value: true, } } else { $scope.NotifytoCreatorInitator = { value: false, }; }

                }
            });
        }
        $scope.checkboxModel = { value: false, };
        $scope.Submit = function () {

            var ShowRejectButton = $scope.ShowRejectButton.value;
            var ShowCancelButton = $scope.ShowCancelButton.value;
            var ShowReviseButton = $scope.ShowReviseButton.value;
            var Mandatory = $scope.Mandatory.value;
            var EmailNotification = $scope.EmailNotification.value;
            var NotifytoCurrentApprover = $scope.NotifytoCurrentApprover.value;
            var NotifytoNextLevelApprover = $scope.NotifytoNextLevelApprover.value;
            var NotifytoCreatorInitator = $scope.NotifytoCreatorInitator.value;

            if ($scope.Approvers != null && $scope.Approvers != "" && $scope.Approvers != undefined) {
                $scope.Approvers = $scope.Approvers.map(function (obj) { return obj.UserID; }).join(',');
            }
            if ($scope.NotifyTo != null && $scope.NotifyTo != "" && $scope.NotifyTo != undefined) {
                $scope.NotifyTo = $scope.NotifyTo.map(function (obj) { return obj.UserID; }).join(',');
            }

            if ($scope.Update == true) {

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/Workflow/update",
                    data: {
                        _id: $scope.WorkflowID, TypeName: $scope.TypeName, LevelName: $scope.LevelName, Action: $scope.Action, Actioned: $scope.Actioned,
                        ShowCancelButton: ShowCancelButton, ShowRejectButton: ShowRejectButton, ShowReviseButton: ShowReviseButton, NextLevel: $scope.NextLevel,
                        Mandatory: Mandatory, EmailNotification: EmailNotification, NotifytoCurrentApprover: NotifytoCurrentApprover,
                        NotifytoNextLevelApprover: NotifytoNextLevelApprover, NotifytoCreatorInitator: NotifytoCreatorInitator,
                        Approvers: $scope.Approvers, NotifyTo: $scope.NotifyTo, EmailExceptions: $scope.EmailExceptions, AlwaysNotifyTo: $scope.AlwaysNotifyTo, UpdatedBy: $rootScope.ProfName
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Workflowgrid = true;
                    $scope.Workflowform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/Workflow/add",

                    data: {
                        TypeName: $scope.TypeName, LevelName: $scope.LevelName, Action: $scope.Action, Actioned: $scope.Actioned, Client_Id: $rootScope.Client_Id,
                        ShowCancelButton: ShowCancelButton, ShowRejectButton: ShowRejectButton, ShowReviseButton: ShowReviseButton, NextLevel: $scope.NextLevel,
                        Mandatory: Mandatory, EmailNotification: EmailNotification, NotifytoCurrentApprover: NotifytoCurrentApprover,
                        NotifytoNextLevelApprover: NotifytoNextLevelApprover, NotifytoCreatorInitator: NotifytoCreatorInitator, Approvers: $scope.Approvers,
                        NotifyTo: $scope.NotifyTo, EmailExceptions: $scope.EmailExceptions, AlwaysNotifyTo: $scope.AlwaysNotifyTo, CreatedBy: $rootScope.ProfName
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Workflowgrid = true;
                    $scope.Workflowform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/user/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Userdata) {
            $scope.Userdatas = Userdata.data.data;
            $scope.AllUserdatas = Userdata.data.data;
        });
        RefreshGrid();
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
                angular.forEach($scope.Workflowdatas, function (value) {
                    angular.forEach($scope.Clientdatas, function (cvalue) {
                        if (value.Client_Id == cvalue.id) {
                            value.Client_Id = cvalue.ClientName;
                        }
                    })
                })
            });
        }
        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
            });


        function ClearForm() {
            $scope.TypeName = null;
            $scope.LevelName = null;
            $scope.Action = null;
            $scope.Actioned = null;
            $scope.NextLevel = null;
            $scope.ClientID = null;
            $scope.Approvers = null;
            $scope.NotifyTo = null;
            $scope.EmailExceptions = null;
            $scope.AlwaysNotifyTo = null;

            $scope.ShowCancelButton = { value: false, };
            $scope.ShowRejectButton = { value: true, };
            $scope.ShowReviseButton = { value: false, };
            $scope.Mandatory = { value: false, };
            $scope.EmailNotification = { value: true, };
            $scope.NotifytoCurrentApprover = { value: false, };
            $scope.NotifytoNextLevelApprover = { value: true, };
            $scope.NotifytoCreatorInitator = { value: true, };
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Workflows.xlsx",{headers:true}) FROM ?', [$scope.Workflowdatas]);
        };


        $scope.clearSearchTerm = function () {
            $scope.searchTerm = null;
            $scope.searchTerm1 = null;
        }

        $scope.LoadUserByClient = function () {

            var item = $scope.AllUserdatas.filter(function (item) {
                return item.ClientID === $scope.ClientID;
            });

            $scope.Userdatas = item;
        }


        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            },
            drawCallback: function (settings) {
                var api = this.api();
                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(2, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });
            },

        };

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.human-resource.hrmusers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.human-resource_hrmusers', {
            url      : '/UserManagement',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/hrmusers/hrmusers.html',
                    controller: 'hrmusersController as vm'
                }
            },
            resolve  : {
                UserData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'security-user'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/hrmusers');
    }

})();
(function () {
    'use strict';
    angular
        .module('app.human-resource.hrmusers')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('hrmusersController', hrmusersController);
    function hrmusersController($mdDateLocale, $scope, $interval, $mdSidenav, $mdToast, $http, $mdDialog, $document, $rootScope, $state, $window, $log, $location, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Hrmusers")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Userform = false;
        $scope.Usergrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.error1 = false;
        $scope.ischanged = false;
        $scope.AllSelect = { value: false, };
        $scope.Securitydiv = false;
        $scope.Humandiv = false;
        $scope.Procurementdiv = false;
        $scope.Operationsdiv = false;
        $scope.Salediv = false;
        $scope.Accountsdiv = false;

        $scope.SelectAllchkbox = function () {
            if ($scope.AllSelect.value == true) {
                $scope.rec1 = { Users: 1 }
                $scope.rec2 = { Client: 1 }
                $scope.rec3 = { HRMAdmin: 1 }
                $scope.rec4 = { HRMCore: 1 }
                $scope.rec5 = { Products: 1 }
                $scope.rec6 = { Supliers: 1 }
                $scope.rec7 = { PestType: 1 }
                $scope.rec8 = { Services: 1 }
                $scope.rec9 = { Customers: 1 }
                $scope.rec10 = { Timelog: 1 }
                $scope.rec11 = { Recruitment: 1 }
                $scope.rec12 = { Training: 1 }
                $scope.rec13 = { CrmSettings: 1 }
                $scope.rec14 = { Lead: 1 }
                $scope.rec15 = { Quotation: 1 }
                $scope.rec16 = { Sales: 1 }
                $scope.rec17 = { Stores: 1 }
                $scope.rec18 = { Contracts: 1 }
                $scope.rec19 = { ContractsTemp: 1 }
                $scope.rec20 = { PurchaseOrder: 1 }
                $scope.rec21 = { StockManagement: 1 }
                $scope.rec22 = { Requests: 1 }
                $scope.rec23 = { Setting: 1 }
                $scope.rec24 = { Ledger: 1 }
                $scope.rec25 = { BankCash: 1 }
                $scope.rec26 = { PurchasesPayables: 1 }
                $scope.rec27 = { SalesReceivables: 1 }
                $scope.rec28 = { Asset: 1 }
                $scope.rec29 = { Uniform: 1 }
                $scope.rec30 = { Workflow: 1 }
                $scope.rec31 = { Feedback: 1 }
                $scope.rec32 = { Teams: 1 }
                $scope.rec33 = { Scheduler: 1 }
                $scope.rec34 = { Vehicle: 1 }
                $scope.rec35 = { DManagement: 1 }
                $scope.rec36 = { DHuman: 1 }
                $scope.rec37 = { DProcurement: 1 }
                $scope.rec38 = { DCRM: 1 }
                $scope.rec39 = { DOperations: 1 }
                $scope.rec40 = { DAccounts: 1 }
                $scope.rec41 = { Health: 1 }
                $scope.rec42 = { Insurance: 1 }
                $scope.rec43 = { Payroll: 1 }
                $scope.rec44 = { Hrmusers: 1 }
                $scope.rec45 = { Division: 1 }
                $scope.rec46 = { LeaveR: 1 }
                $scope.rec47 = { MaterialR: 1 }
                $scope.rec48 = { PurchaseR: 1 }
                $scope.rec49 = { UniformR: 1 }
                $scope.rec50 = { Incident: 1 }
                $scope.rec51 = { Medical: 1 }
                $scope.rec52 = { Expense: 1 }
                $scope.rec53 = { Payment: 1 }
                $scope.rec54 = { SChecklist: 1 }
                $scope.rec55 = { Estimation: 1 }
                $scope.rec56 = { Materials: 1 }
                $scope.rec57 = { OperationsReport: 1 }
                $scope.DManagement = { value: true, };
                $scope.DHuman = { value: true, };
                $scope.DProcurement = { value: true, };
                $scope.DCRM = { value: true, };
                $scope.DOperations = { value: true, };
                $scope.DAccounts = { value: true, };
                $scope.LeaveR = { value: true, };
                $scope.MaterialR = { value: true, };
                $scope.PurchaseR = { value: true, };
                $scope.Incident = { value: true, };
                $scope.Medical = { value: true, };
                $scope.Expense = { value: true, };
                $scope.Payment = { value: true, }
                $scope.Insurance = { value: true, }
                $scope.Division = { value: true, }
                $scope.Payroll = { value: true, }
                $scope.Hrmusers = { value: true, }
                $scope.SChecklist = { value: true, }
                $scope.Estimation = { value: true, }
                $scope.Materials = { value: true, }
                $scope.Treatment = { value: true, }
                $scope.Users = { value: true, };
                $scope.Client = { value: true, };
                $scope.HRMAdmin = { value: true, };
                $scope.HRMCore = { value: true, };
                $scope.Products = { value: true, };
                $scope.Supliers = { value: true, };
                $scope.PestType = { value: true, };
                $scope.Services = { value: true, };
                $scope.Customers = { value: true, };
                $scope.Timelog = { value: true, };
                $scope.Recruitment = { value: true, };
                $scope.Training = { value: true, };
                $scope.CrmSettings = { value: true, }
                $scope.Lead = { value: true, }
                $scope.Quotation = { value: true, }
                $scope.Sales = { value: true, }
                $scope.Stores = { value: true, }
                $scope.Contracts = { value: true, }
                $scope.ContractsTemp = { value: true, }
                $scope.PurchaseOrder = { value: true, }
                $scope.StockManagement = { value: true, }
                $scope.Requests = { value: true, }
                $scope.Setting = { value: true, }
                $scope.Ledger = { value: true, }
                $scope.BankCash = { value: true, }
                $scope.PurchasesPayables = { value: true, }
                $scope.SalesReceivables = { value: true, }
                $scope.Asset = { value: true, }
                $scope.Uniform = { value: true, }
                $scope.Workflow = { value: true, }
                $scope.Areas = { value: true, }
                $scope.Teams = { value: true, }
                $scope.Scheduler = { value: true, }
                $scope.Vehicle = { value: true, }
                $scope.Health = { value: true, }
                $scope.UniformR = { value: true, }
                $scope.Feedback = { value: true, }
            }
            else {
                $scope.rec1 = { Users: 0 }
                $scope.rec2 = { Client: 0 }
                $scope.rec3 = { HRMAdmin: 0 }
                $scope.rec4 = { HRMCore: 0 }
                $scope.rec5 = { Products: 0 }
                $scope.rec6 = { Supliers: 0 }
                $scope.rec7 = { PestType: 0 }
                $scope.rec8 = { Services: 0 }
                $scope.rec9 = { Customers: 0 }
                $scope.rec10 = { Timelog: 0 }
                $scope.rec11 = { Recruitment: 0 }
                $scope.rec12 = { Training: 0 }
                $scope.rec13 = { CrmSettings: 0 }
                $scope.rec14 = { Lead: 0 }
                $scope.rec15 = { Quotation: 0 }
                $scope.rec16 = { Sales: 0 }
                $scope.rec17 = { Stores: 0 }
                $scope.rec18 = { Contracts: 0 }
                $scope.rec19 = { ContractsTemp: 0 }
                $scope.rec20 = { PurchaseOrder: 0 }
                $scope.rec21 = { StockManagement: 0 }
                $scope.rec22 = { Requests: 0 }
                $scope.rec23 = { Setting: 0 }
                $scope.rec24 = { Ledger: 0 }
                $scope.rec25 = { BankCash: 0 }
                $scope.rec26 = { PurchasesPayables: 0 }
                $scope.rec27 = { SalesReceivables: 0 }
                $scope.rec28 = { Asset: 0 }
                $scope.rec29 = { Uniform: 0 }
                $scope.rec30 = { Workflow: 0 }
                $scope.rec31 = { Feedback: 0 }
                $scope.rec32 = { Teams: 0 }
                $scope.rec33 = { Scheduler: 0 }
                $scope.rec34 = { Vehicle: 0 }
                $scope.rec35 = { DManagement: 0 }
                $scope.rec36 = { DHuman: 0 }
                $scope.rec37 = { DProcurement: 0 }
                $scope.rec38 = { DCRM: 0 }
                $scope.rec39 = { DOperations: 0 }
                $scope.rec40 = { DAccounts: 0 }
                $scope.rec41 = { Health: 0 }
                $scope.rec42 = { Insurance: 0 }
                $scope.rec43 = { Payroll: 0 }
                $scope.rec44 = { Hrmusers: 0 }
                $scope.rec45 = { Division: 0 }
                $scope.rec46 = { LeaveR: 0 }
                $scope.rec47 = { MaterialR: 0 }
                $scope.rec48 = { PurchaseR: 0 }
                $scope.rec49 = { UniformR: 0 }
                $scope.rec50 = { Incident: 0 }
                $scope.rec51 = { Medical: 0 }
                $scope.rec52 = { Expense: 0 }
                $scope.rec53 = { Payment: 0 }
                $scope.rec54 = { SChecklist: 0 }
                $scope.rec55 = { Estimation: 0 }
                $scope.rec56 = { Materials: 0 }
                $scope.rec57 = { OperationsReport: 0 }
                $scope.DManagement = { value: false, };
                $scope.DHuman = { value: false, };
                $scope.DProcurement = { value: false, };
                $scope.DCRM = { value: false, };
                $scope.DOperations = { value: false, };
                $scope.DAccounts = { value: false, };
                $scope.LeaveR = { value: false, };
                $scope.MaterialR = { value: false, };
                $scope.PurchaseR = { value: false, };
                $scope.Incident = { value: false, };
                $scope.Medical = { value: false, };
                $scope.Expense = { value: false, };
                $scope.Payment = { value: false, }
                $scope.Insurance = { value: false, }
                $scope.Division = { value: false, }
                $scope.Payroll = { value: false, }
                $scope.Hrmusers = { value: false, }
                $scope.SChecklist = { value: false, }
                $scope.Estimation = { value: false, }
                $scope.Materials = { value: false, }
                $scope.Treatment = { value: false, }
                $scope.Users = { value: false, };
                $scope.Client = { value: false, };
                $scope.HRMAdmin = { value: false, };
                $scope.HRMCore = { value: false, };
                $scope.Products = { value: false, };
                $scope.Supliers = { value: false, };
                $scope.PestType = { value: false, };
                $scope.Services = { value: false, };
                $scope.Customers = { value: false, };
                $scope.Timelog = { value: false, };
                $scope.Recruitment = { value: false, };
                $scope.Training = { value: false, };
                $scope.CrmSettings = { value: false, }
                $scope.Lead = { value: false, }
                $scope.Quotation = { value: false, }
                $scope.Sales = { value: false, }
                $scope.Stores = { value: false, }
                $scope.Contracts = { value: false, }
                $scope.ContractsTemp = { value: false, }
                $scope.PurchaseOrder = { value: false, }
                $scope.StockManagement = { value: false, }
                $scope.Requests = { value: false, }
                $scope.Setting = { value: false, }
                $scope.Ledger = { value: false, }
                $scope.BankCash = { value: false, }
                $scope.PurchasesPayables = { value: false, }
                $scope.SalesReceivables = { value: false, }
                $scope.Asset = { value: false, }
                $scope.Uniform = { value: false, }
                $scope.Workflow = { value: false, }
                $scope.Areas = { value: false, }
                $scope.Teams = { value: false, }
                $scope.Scheduler = { value: false, }
                $scope.Vehicle = { value: false, }
                $scope.Health = { value: false, }
                $scope.UniformR = { value: false, }
                $scope.Feedback = { value: false, }
            }
        }
        $scope.valEmail = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
        $rootScope.ProfName = sessionStorage.getItem('UserName');
        $scope.Exportdata = function () {
            alasql('SELECT * INTO XLSX("Userdata.xlsx",{headers:true}) FROM ?', [$scope.Userdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.getNumber = function () {
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.formData.uPassword = pass;
        }
        $scope.getEmailID = function (EId) {
            try {
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === EId;
                })[0];
                $scope.formData.uEmail = item.Email;
            }
            catch (e) { }
        }
        $scope.reset = function (UserId) {
            $scope.UserInfoId = UserId;
            var item = $scope.Userdatas.filter(function (item) {
                return item.ID === UserId;
            })[0];
            $scope.uLoginID = item.UserID;
            $scope.Email = item.Email;
            $scope.UserName = item.UserName;
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var ii = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(ii);
            }
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/login/resetPassword",
                data: {
                    UserID: $scope.uLoginID,
                    rNewPassword: pass,
                },
            });
            response.then(function (GList) {
                $scope.Userdata = GList.data
                if ($scope.Userdata.UserName != null) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/user/email",
                        data: {
                            SenderEmailAddress: $scope.Userdata.EmailID, UserName: $scope.Userdata.UserName,
                            LoginID: $scope.uLoginID,
                            Password: pass,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }
                else {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                }
            });
        }
        $scope.userpopup = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/hrmusers/userpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function hrmusersController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }
        $scope.Userdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                RefreshGrid();
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.userinfo = function (UserId, e) {
            $scope.SID = UserId;
            $scope.Update = true;
            $scope.Userform = true;
            $scope.Usergrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = true;
            $scope.Search = false;
            $scope.error1 = false;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.DashBoarddiv = false;
            $scope.UserInfoId = UserId;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { Sales: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { ContractsTemp: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Setting: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { PurchasesPayables: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { Feedback: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { DAccounts: 0 }
            $scope.rec41 = { Health: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { Payroll: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { Division: 0 }
            $scope.rec46 = { LeaveR: 0 }
            $scope.rec47 = { MaterialR: 0 }
            $scope.rec48 = { PurchaseR: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { Estimation: 0 }
            $scope.rec56 = { Materials: 0 }
            $scope.rec57 = { OperationsReport: 0 }

            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.DAccounts = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.PurchaseR = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.Payroll = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.Estimation = { value: false, }
            $scope.Materials = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.Sales = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.ContractsTemp = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Setting = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.PurchasesPayables = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }

            var Roleselect = [];
            var Moduleselect = [];
            var info = $scope.Userdatas
            var st = '';

            var item = $scope.Userdatas.filter(function (item) {
                return item.id === UserId;
            })[0];
            $scope.formData.SID = UserId;
            $scope.formData.uLoginID = item.UserID;
            $scope.formData.uEmail = item.Email;
            $scope.formData.uUserName = item.UserName;
            $scope.formData.uMobileNumber = parseInt(item.MobileNumber);
            $scope.formData.uDesignation = item.Designation;
            $scope.formData.uExpiryDate = new Date(item.ExpiryDate);
            $scope.formData.uPassword = item.Password
            $scope.formData.uLastSuccess = item.LastSuccess;
            $scope.formData.uLastSuccess = item.LastFailure;
            $scope.formData.IsActive = item.IsActive;
            $scope.formData.IsLocked = item.IsLocked;
            $scope.uEmployeeID = item.EmployeeID
            $scope.uClientID = item.ClientID
            $scope.uClientName = item.ClientName;
            $scope.vm.Customer_Id = item.Customer_Id;
            $scope.vm.CustomerName = item.CustomerName;

            angular.forEach($scope.Userroledatas, function (urvalue) {
                angular.forEach($scope.Roledatas, function (rvalue) {
                    if (item.id == urvalue.UserID && item.id == $scope.UserInfoId && urvalue.RoleID == rvalue.RoleID) {
                        Roleselect.push({
                            RoleName: rvalue.RoleName,
                            RoleID: rvalue.RoleID,
                            ticked: true,
                        })
                    }
                })
            })
            st = Roleselect.map(function (obj) { return obj.RoleName; }).join(', ');
            angular.forEach($scope.userModulesdatas, function (umvalue) {
                if (st.match(umvalue.UserID)) {
                    Moduleselect.push({
                        ModuleName: umvalue.ModelID,
                    })
                }
            });
            var mtr = Moduleselect.map(function (obj) { return obj.ModuleName; }).join(', ');
            angular.forEach($scope.Roledatas, function (rvalue) {
                if (st.indexOf(rvalue.RoleName) > -1) {
                    if (mtr.split(",").includes("Security")) {
                        $scope.Securitydiv = true;
                    }
                    if (mtr.indexOf("Human Resource") > -1) {
                        $scope.Humandiv = true;
                    }
                    if (mtr.split(",").includes("Procurement")) {
                        $scope.Procurementdiv = true;
                    }
                    if (mtr.split(",").includes("Operations")) {
                        $scope.Operationsdiv = true;
                    }
                    if (mtr.indexOf("Customer Relationship") > -1) {
                        $scope.Salediv = true;
                    }
                    if (mtr.split(",").includes("Accounts")) {
                        $scope.Accountsdiv = true;
                    }
                    if (mtr.split(",").includes("Management")) {
                        $scope.DashBoarddiv = true;
                    }
                }
            });
            $scope.formData.selectedRole = Roleselect;
            $scope.Selectedrole = st;
            angular.forEach($scope.Pagedatas, function (value) {
                if (value.UserID == UserId) {
                    if (value.PageName == "Users") { $scope.rec1 = { Users: 1 } }
                    if (value.PageName == "Client") { $scope.rec2 = { Client: 1 } }
                    if (value.PageName == "HRMAdmin") { $scope.rec3 = { HRMAdmin: 1 } }
                    if (value.PageName == "HRMCore") { $scope.rec4 = { HRMCore: 1 } }
                    if (value.PageName == "Products") { $scope.rec5 = { Products: 1 } }
                    if (value.PageName == "Supliers") { $scope.rec6 = { Supliers: 1 } }
                    if (value.PageName == "PestType") { $scope.rec7 = { PestType: 1 } }
                    if (value.PageName == "Services") { $scope.rec8 = { Services: 1 } }
                    if (value.PageName == "Customers") { $scope.rec9 = { Customers: 1 } }
                    if (value.PageName == "Timelog") { $scope.rec10 = { Timelog: 1 } }
                    if (value.PageName == "Recruitment") { $scope.rec11 = { Recruitment: 1 } }
                    if (value.PageName == "Training") { $scope.rec12 = { Training: 1 } }
                    if (value.PageName == "CrmSettings") { $scope.rec13 = { CrmSettings: 1 } }
                    if (value.PageName == "Lead") { $scope.rec14 = { Lead: 1 } }
                    if (value.PageName == "Quotation") { $scope.rec15 = { Quotation: 1 } }
                    if (value.PageName == "Sales") { $scope.rec16 = { Sales: 1 } }
                    if (value.PageName == "Stores") { $scope.rec17 = { Stores: 1 } }
                    if (value.PageName == "Contracts") { $scope.rec18 = { Contracts: 1 } }
                    if (value.PageName == "ContractsTemp") { $scope.rec19 = { ContractsTemp: 1 } }
                    if (value.PageName == "PurchaseOrder") { $scope.rec20 = { PurchaseOrder: 1 } }
                    if (value.PageName == "StockManagement") { $scope.rec21 = { StockManagement: 1 } }
                    if (value.PageName == "Requests") { $scope.rec22 = { Requests: 1 } }
                    if (value.PageName == "Setting") { $scope.rec23 = { Setting: 1 } }
                    if (value.PageName == "Ledger") { $scope.rec24 = { Ledger: 1 } }
                    if (value.PageName == "BankCash") { $scope.rec25 = { BankCash: 1 } }
                    if (value.PageName == "PurchasesPayables") { $scope.rec26 = { PurchasesPayables: 1 } }
                    if (value.PageName == "SalesReceivables") { $scope.rec27 = { SalesReceivables: 1 } }
                    if (value.PageName == "Asset") { $scope.rec28 = { Asset: 1 } }
                    if (value.PageName == "Uniform") { $scope.rec29 = { Uniform: 1 } }
                    if (value.PageName == "Workflow") { $scope.rec30 = { Workflow: 1 } }
                    if (value.PageName == "Feedback") { $scope.rec31 = { Feedback: 1 } }
                    if (value.PageName == "Teams") { $scope.rec32 = { Teams: 1 } }
                    if (value.PageName == "Scheduler") { $scope.rec33 = { Scheduler: 1 } }
                    if (value.PageName == "Vehicle") { $scope.rec34 = { Vehicle: 1 } }
                    if (value.PageName == "DManagement") { $scope.rec35 = { DManagement: 1 } }
                    if (value.PageName == "DHuman") { $scope.rec36 = { DHuman: 1 } }
                    if (value.PageName == "DProcurement") { $scope.rec37 = { DProcurement: 1 } }
                    if (value.PageName == "DCRM") { $scope.rec38 = { DCRM: 1 } }
                    if (value.PageName == "DOperations") { $scope.rec39 = { DOperations: 1 } }
                    if (value.PageName == "DAccounts") { $scope.rec40 = { DAccounts: 1 } }
                    if (value.PageName == "Health") { $scope.rec41 = { Health: 1 } }
                    if (value.PageName == "Insurance") { $scope.rec42 = { Insurance: 1 } }
                    if (value.PageName == "Payroll") { $scope.rec43 = { Payroll: 1 } }
                    if (value.PageName == "Hrmusers") { $scope.rec44 = { Hrmusers: 1 } }
                    if (value.PageName == "Division") { $scope.rec45 = { Division: 1 } }
                    if (value.PageName == "LeaveR") { $scope.rec46 = { LeaveR: 1 } }
                    if (value.PageName == "MaterialR") { $scope.rec47 = { MaterialR: 1 } }
                    if (value.PageName == "PurchaseR") { $scope.rec48 = { PurchaseR: 1 } }
                    if (value.PageName == "UniformR") { $scope.rec49 = { UniformR: 1 } }
                    if (value.PageName == "Incident") { $scope.rec50 = { Incident: 1 } }
                    if (value.PageName == "Medical") { $scope.rec51 = { Medical: 1 } }
                    if (value.PageName == "Expense") { $scope.rec52 = { Expense: 1 } }
                    if (value.PageName == "Payment") { $scope.rec53 = { Payment: 1 } }
                    if (value.PageName == "SChecklist") { $scope.rec54 = { SChecklist: 1 } }
                    if (value.PageName == "Estimation") { $scope.rec55 = { Estimation: 1 } }
                    if (value.PageName == "Materials") { $scope.rec56 = { Materials: 1 } }
                    if (value.PageName == "OperationsReport") { $scope.rec57 = { OperationsReport: 1 } }
                }
            });

            if ($scope.vm.Customer_Id != null && $scope.vm.Customer_Id != "" && $scope.vm.Customer_Id != undefined && $scope.vm.Customer_Id != 'undefined') {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/customer",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (customerdata) {
                    $scope.Customerdatas = customerdata.data.data;
                    $mdDialog.show({
                        templateUrl: 'app/main/apps/human-resource/hrmusers/CustomerUser.html',
                        parent: angular.element($document.body),
                        targetEvent: e,
                        scope: $scope.$new(),
                        clickOutsideToClose: false,
                        controller: function hrmusersController($scope, $mdDialog) {
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            }
                        }
                    })
                });
                $scope.vm.SID = UserId;
                $scope.vm.cLoginID = item.UserID;
                $scope.vm.cEmail = item.Email;
                $scope.vm.cUserName = item.UserName;
                $scope.vm.cMobileNumber = parseInt(item.MobileNumber);
                $scope.vm.cDesignation = item.Designation;
                $scope.vm.cExpiryDate = new Date(item.ExpiryDate);
                $scope.vm.cPassword = item.Password
                $scope.vm.cLastSuccess = item.LastSuccess;
                $scope.vm.cLastSuccess = item.LastFailure;
                $scope.uClientID = item.ClientID
                $scope.uClientName = item.ClientName;
                $scope.vm.Customer_Id = item.Customer_Id;
                $scope.vm.CustomerName = item.CustomerName;

                $scope.Userform = false;
                $scope.Usergrid = true;
                $scope.Export = true;
                $scope.view = false;
                $scope.Add = true;
                $scope.Pageform = false;
            }
            else {
                return
            }
        }

        $scope.checkboxModel = { value: false, };
        $scope.DManagement = { value: false, };
        $scope.DHuman = { value: false, };
        $scope.DProcurement = { value: false, };
        $scope.DCRM = { value: false, };
        $scope.DOperations = { value: false, };
        $scope.DAccounts = { value: false, };
        $scope.LeaveR = { value: false, };
        $scope.MaterialR = { value: false, };
        $scope.PurchaseR = { value: false, };
        $scope.Incident = { value: false, };
        $scope.Medical = { value: false, };
        $scope.Expense = { value: false, };
        $scope.Payment = { value: false, }
        $scope.Insurance = { value: false, }
        $scope.Division = { value: false, }
        $scope.Payroll = { value: false, }
        $scope.Hrmusers = { value: false, }
        $scope.SChecklist = { value: false, }
        $scope.Estimation = { value: false, }
        $scope.Materials = { value: false, }
        $scope.OperationsReport = { value: false, }
        $scope.Users = { value: false, };
        $scope.Client = { value: false, };
        $scope.HRMAdmin = { value: false, };
        $scope.HRMCore = { value: false, };
        $scope.Products = { value: false, };
        $scope.Supliers = { value: false, };
        $scope.PestType = { value: false, };
        $scope.Services = { value: false, };
        $scope.Customers = { value: false, };
        $scope.Timelog = { value: false, };
        $scope.Recruitment = { value: false, };
        $scope.Training = { value: false, };
        $scope.CrmSettings = { value: false, }
        $scope.Lead = { value: false, }
        $scope.Quotation = { value: false, }
        $scope.Sales = { value: false, }
        $scope.Stores = { value: false, }
        $scope.Contracts = { value: false, }
        $scope.ContractsTemp = { value: false, }
        $scope.PurchaseOrder = { value: false, }
        $scope.StockManagement = { value: false, }
        $scope.Requests = { value: false, }
        $scope.Setting = { value: false, }
        $scope.Ledger = { value: false, }
        $scope.BankCash = { value: false, }
        $scope.PurchasesPayables = { value: false, }
        $scope.SalesReceivables = { value: false, }
        $scope.Asset = { value: false, }
        $scope.Uniform = { value: false, }
        $scope.Workflow = { value: false, }
        $scope.Feedback = { value: false, }
        $scope.Teams = { value: false, }
        $scope.Scheduler = { value: false, }
        $scope.Vehicle = { value: false, }
        $scope.Health = { value: false, }
        $scope.UniformR = { value: false, }
        $scope.formData = {};

        function pageSubmit(UserID) {
            $scope.CurrentID = UserID;
            var pages = [];
            try {
                if ($scope.HRMAdmin.value == true) { pages.push({ PageName: "HRMAdmin", }) }
                if ($scope.HRMCore.value == true) { pages.push({ PageName: "HRMCore", }) }
                if ($scope.Timelog.value == true) { pages.push({ PageName: "Timelog", }) }
                if ($scope.Recruitment.value == true) { pages.push({ PageName: "Recruitment", }) }
                if ($scope.Training.value == true) { pages.push({ PageName: "Training", }) }
                if ($scope.Products.value == true) { pages.push({ PageName: "Products", }) }
                if ($scope.Supliers.value == true) { pages.push({ PageName: "Supliers", }) }
                if ($scope.PestType.value == true) { pages.push({ PageName: "PestType", }) }
                if ($scope.Services.value == true) { pages.push({ PageName: "Services", }) }
                if ($scope.Customers.value == true) { pages.push({ PageName: "Customers", }) }

                if ($scope.CrmSettings.value == true) { pages.push({ PageName: "CrmSettings", }) }
                if ($scope.Lead.value == true) { pages.push({ PageName: "Lead", }) }
                if ($scope.Quotation.value == true) { pages.push({ PageName: "Quotation", }) }
                if ($scope.Sales.value == true) { pages.push({ PageName: "Sales", }) }
                if ($scope.Stores.value == true) { pages.push({ PageName: "Stores", }) }
                if ($scope.Contracts.value == true) { pages.push({ PageName: "Contracts", }) }
                if ($scope.ContractsTemp.value == true) { pages.push({ PageName: "ContractsTemp", }) }
                if ($scope.PurchaseOrder.value == true) { pages.push({ PageName: "PurchaseOrder", }) }
                if ($scope.StockManagement.value == true) { pages.push({ PageName: "StockManagement", }) }
                if ($scope.Requests.value == true) { pages.push({ PageName: "Requests", }) }
                if ($scope.Setting.value == true) { pages.push({ PageName: "Setting", }) }
                if ($scope.Ledger.value == true) { pages.push({ PageName: "Ledger", }) }
                if ($scope.BankCash.value == true) { pages.push({ PageName: "BankCash", }) }
                if ($scope.PurchasesPayables.value == true) { pages.push({ PageName: "PurchasesPayables", }) }
                if ($scope.SalesReceivables.value == true) { pages.push({ PageName: "SalesReceivables", }) }
                if ($scope.Asset.value == true) { pages.push({ PageName: "Asset", }) }
                if ($scope.Uniform.value == true) { pages.push({ PageName: "Uniform", }) }

                if ($scope.Feedback.value == true) { pages.push({ PageName: "Feedback", }) }
                if ($scope.Teams.value == true) { pages.push({ PageName: "Teams", }) }
                if ($scope.Scheduler.value == true) { pages.push({ PageName: "Scheduler", }) }
                if ($scope.Vehicle.value == true) { pages.push({ PageName: "Vehicle", }) }
                if ($scope.Health.value == true) { pages.push({ PageName: "Health", }) }

                if ($scope.DManagement.value == true) { pages.push({ PageName: "DManagement", }) }
                if ($scope.DHuman.value == true) { pages.push({ PageName: "DHuman", }) }
                if ($scope.DProcurement.value == true) { pages.push({ PageName: "DProcurement", }) }
                if ($scope.DCRM.value == true) { pages.push({ PageName: "DCRM", }) }
                if ($scope.DOperations.value == true) { pages.push({ PageName: "DOperations", }) }
                if ($scope.DAccounts.value == true) { pages.push({ PageName: "DAccounts", }) }
                if ($scope.LeaveR.value == true) { pages.push({ PageName: "LeaveR", }) }
                if ($scope.MaterialR.value == true) { pages.push({ PageName: "MaterialR", }) }
                if ($scope.PurchaseR.value == true) { pages.push({ PageName: "PurchaseR", }) }
                if ($scope.UniformR.value == true) { pages.push({ PageName: "UniformR", }) }
                if ($scope.Incident.value == true) { pages.push({ PageName: "Incident", }) }
                if ($scope.Medical.value == true) { pages.push({ PageName: "Medical", }) }
                if ($scope.Expense.value == true) { pages.push({ PageName: "Expense", }) }
                if ($scope.Payment.value == true) { pages.push({ PageName: "Payment", }) }
                if ($scope.Insurance.value == true) { pages.push({ PageName: "Insurance", }) }
                if ($scope.Payroll.value == true) { pages.push({ PageName: "Payroll", }) }
                if ($scope.Hrmusers.value == true) { pages.push({ PageName: "Hrmusers", }) }
                if ($scope.Division.value == true) { pages.push({ PageName: "Division", }) }
                if ($scope.SChecklist.value == true) { pages.push({ PageName: "SChecklist", }) }
                if ($scope.Estimation.value == true) { pages.push({ PageName: "Estimation", }) }
                if ($scope.Materials.value == true) { pages.push({ PageName: "Materials", }) }
                if ($scope.OperationsReport.value == true) { pages.push({ PageName: "OperationsReport", }) }
            }
            catch (error) {
            }
            if ($scope.Update == true) {
                var deleteresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/pagedb/delete",
                    data: {
                        UserID: $scope.CurrentID,
                    },
                });
                deleteresponse.then(function (List) {
                    if (pages.length == 0) {
                        RefreshGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated !').position('top center'));
                        $scope.Usergrid = true;
                        $scope.Userform = false;
                        $scope.Pageform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                    else {
                        for (var r = 0; r < pages.length; r++) {
                            $scope.uPages = pages[r].PageName;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/pagedb/add",
                                data: {
                                    UserID: $scope.SID,
                                    PageName: $scope.uPages,
                                },
                            });
                        }
                        response.then(function (GList) {
                            RefreshGrid();
                            $mdToast.show($mdToast.simple().textContent('Successfully Updated !').position('top center'));
                            $scope.Usergrid = true;
                            $scope.Userform = false;
                            $scope.Pageform = false;
                            $scope.Export = true;
                            $scope.Add = true;
                            $scope.view = false;
                            $scope.Search = true;
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                });
            }

            else {
                if (pages.length == 0) {
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added !').position('top center'));
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }
                for (var r = 0; r < pages.length; r++) {
                    $scope.uPages = pages[r].PageName;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/pagedb/add",
                        data: {
                            UserID: $scope.CurrentID,
                            PageName: $scope.uPages,
                        },
                    });
                }
                response.then(function (GList) {
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added !').position('top center'));
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.sSubmit = function () {
            $scope.Users = { value: false };
            $scope.Client = { value: false };
            $scope.Workflow = { value: false };

            if ($scope.Humandiv == false || $scope.Humandiv == undefined) {
                $scope.DHuman = { value: false };
                $scope.HRMAdmin = { value: false };
                $scope.HRMCore = { value: false };
                $scope.Timelog = { value: false };
                $scope.Recruitment = { value: false };
                $scope.Training = { value: false };
                $scope.Health = { value: false };
                $scope.Insurance = { value: false };
                $scope.Payroll = { value: false };
                $scope.Hrmusers = { value: false };
            }
            if ($scope.Procurementdiv == false || $scope.Procurementdiv == undefined) {
                $scope.DProcurement = { value: false };
                $scope.Stores = { value: false };
                $scope.Vehicle = { value: false };
                $scope.PurchaseOrder = { value: false };
                $scope.StockManagement = { value: false };
                $scope.Requests = { value: false };
                $scope.Products = { value: false };
                $scope.Supliers = { value: false };
                $scope.Uniform = { value: false };
            }
            if ($scope.Operationsdiv == false || $scope.Operationsdiv == undefined) {
                $scope.DOperations = { value: false };
                $scope.Services = { value: false };
                $scope.Feedback = { value: false };
                $scope.Teams = { value: false };
                $scope.Scheduler = { value: false };
                $scope.SChecklist = { value: false, }
                $scope.Division = { value: false };
                $scope.Materials = { value: false };
                $scope.OperationsReport = { value: false };
            }
            if ($scope.Salediv == false || $scope.Salediv == undefined) {
                $scope.DCRM = { value: false };
                $scope.Customers = { value: false };
                $scope.Lead = { value: false };
                $scope.Quotation = { value: false };
                $scope.Sales = { value: false };
                $scope.Contracts = { value: false };
                $scope.Estimation = { value: false };
                $scope.PestType = { value: false };
                $scope.ContractsTemp = { value: false };
                $scope.CrmSettings = { value: false };
            }
            if ($scope.Accountsdiv == false || $scope.Accountsdiv == undefined) {
                $scope.DAccounts = { value: false };
                $scope.Setting = { value: false };
                $scope.Ledger = { value: false };
                $scope.BankCash = { value: false };
                $scope.PurchasesPayables = { value: false };
                $scope.SalesReceivables = { value: false };
                $scope.Asset = { value: false };
            }
            if ($scope.checkboxModel.value == true) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/email",
                    data: {
                        SenderEmailAddress: $scope.formData.uEmail,
                        UserName: $scope.formData.uUserName,
                        UserID: $scope.formData.uLoginID,
                        Password: $scope.formData.uPassword,
                    },
                });
            }

            $scope.uRoles = $scope.formData.selectedRole;
            if ($scope.Update == true) {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/user/update",
                    data: {
                        _id: $scope.SID, UserID: $scope.formData.uLoginID, Email: $scope.formData.uEmail, UserName: $scope.formData.uUserName,
                        MobileNumber: $scope.formData.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.formData.uExpiryDate,
                        Password: $scope.formData.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked,
                        ClientID: $rootScope.Client_Id, EmployeeID: $scope.uEmployeeID,
                        ClientName: $scope.uClientName,
                        UpdatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/userrole/delete",
                        data: {
                            UserID: $scope.SID,
                        },
                    });
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/usermodel/delete",
                        data: {
                            UserID: $scope.SID,
                        },
                    });
                    var roles = $scope.uRoles;
                    for (var i = 0; i < roles.length; i++) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/userrole/add",
                            data: {
                                UserID: $scope.SID,
                                RoleID: roles[i].RoleID,
                            },
                        });
                    }
                    $scope.CurrentID = $scope.SID;
                    pageSubmit($scope.CurrentID);
                }, function () {
                });
            }
            else {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/add",
                    data: {
                        UserID: $scope.formData.uLoginID, Email: $scope.formData.uEmail, UserName: $scope.formData.uUserName,
                        MobileNumber: $scope.formData.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: "",
                        ExpiryDate: $scope.formData.uExpiryDate, Password: $scope.formData.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, CreatedBy: $rootScope.createdby,
                        ClientID: $rootScope.Client_Id, EmployeeID: $scope.uEmployeeID,
                        ClientName: $scope.uClientName,
                    },
                });

                response.then(function (GList) {
                    if (GList.data.message == "Existing UserID") {
                        $scope.error1 = true;
                        $scope.Userform = true;
                        $scope.Usergrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else { //
                    }
                    $scope.CurrentID = GList.data.data.id;
                    var roles = $scope.uRoles;
                    for (var r = 0; r < roles.length; r++) {
                        $scope.uRoles = roles[r].RoleID;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/userrole/add",
                            data: {
                                UserID: $scope.CurrentID,
                                RoleID: $scope.uRoles,
                            },
                        });
                    }
                    pageSubmit($scope.CurrentID);
                }, function () {
                });
            }
        }
        $scope.getdisabled = function (val) {
            if (val == true) { $scope.vm.chkbox = "yes" }
            else { $scope.vm.chkbox = null; }

            if ($scope.Security.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Human.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Procurement.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Operations.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.CRManagement.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Accounts.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Management.value == true) { $scope.vm.chkbox = "yes" }
            if ($scope.Tablet.value == true) { $scope.vm.chkbox = "yes" }
        }
        $scope.Security = { value: false, };
        $scope.Human = { value: false, };
        $scope.Procurement = { value: false, };
        $scope.Operations = { value: false, };
        $scope.CRManagement = { value: false, };
        $scope.Accounts = { value: false, };
        $scope.Management = { value: false, };
        $scope.Tablet = { value: false, };
        $scope.RolesSubmit = function () {
            var modules = [];
            if ($scope.Security.value == true) { modules.push({ ModuleName: "Security", }) }
            if ($scope.Human.value == true) { modules.push({ ModuleName: "Human Resource", }) }
            if ($scope.Procurement.value == true) { modules.push({ ModuleName: "Procurement", }) }
            if ($scope.Operations.value == true) { modules.push({ ModuleName: "Operations", }) }
            if ($scope.CRManagement.value == true) { modules.push({ ModuleName: "Customer Relationship", }) }
            if ($scope.Accounts.value == true) { modules.push({ ModuleName: "Accounts", }) }
            if ($scope.Management.value == true) { modules.push({ ModuleName: "Management", }) }
            if ($scope.Tablet.value == true) { modules.push({ ModuleName: "Tablet", }) }
            $scope.umodule = modules;
            var roleinfo = $scope.Roledatas;
            for (var i = 0; i <= roleinfo.length; i++) {
                $scope.vm.uNewroleID = i + 1;
            }
            if ($scope.moduleupdate == true) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/usermodel/deletebyId",
                    data: {
                        UserID: $scope.vm.uNewrole,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var modules = $scope.umodule;
                    for (var i = 0; i < modules.length; i++) {
                        var Roleresponse = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/usermodel/add",
                            data: {
                                UserID: $scope.vm.uNewrole,
                                ModelID: modules[i].ModuleName,
                                Client_Id: $rootScope.Client_Id,
                            },
                        });
                    }
                    Roleresponse.then(function (GList) {
                        $scope.moduleupdate = false;
                        $scope.vm.uNewrole = null;
                        $scope.Security = { value: false, };
                        $scope.Human = { value: false, };
                        $scope.Procurement = { value: false, };
                        $scope.Operations = { value: false, };
                        $scope.CRManagement = { value: false, };
                        $scope.Accounts = { value: false, };
                        $scope.Management = { value: false, };
                        $scope.Tablet = { value: false, };
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/role/getByClientId",
                            data: { Client_Id: $rootScope.Client_Id },
                        }).then(function (Roledata) {
                            $scope.Roledatas = Roledata.data.data;
                        });
                        $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/usermodel/getByClientId",
                            data: { Client_Id: $rootScope.Client_Id },
                        }).then(function (userModulesdata) {
                            $scope.userModulesdatas = userModulesdata.data.data;
                        });
                        $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/role/add",
                    data: {
                        RoleName: $scope.vm.uNewrole,
                        RoleID: $scope.vm.uNewroleID,
                        Description: $scope.vm.uDescription,
                        Client_Id: $rootScope.Client_Id,
                        createdBy: "System",
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing RoleName") {
                        $mdToast.show($mdToast.simple().textContent('Role Name Exist!').position('top center'));
                    }
                    else {
                        var modules = $scope.umodule;
                        for (var i = 0; i < modules.length; i++) {
                            var Roleresponse = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/usermodel/add",
                                data: {
                                    UserID: $scope.vm.uNewrole,
                                    ModelID: modules[i].ModuleName,
                                    Client_Id: $rootScope.Client_Id,
                                },
                            });
                        }

                        Roleresponse.then(function (GList) {
                            $scope.moduleupdate = false;
                            $scope.vm.uNewrole = null;
                            $scope.Security = { value: false, };
                            $scope.Human = { value: false, };
                            $scope.Procurement = { value: false, };
                            $scope.Operations = { value: false, };
                            $scope.CRManagement = { value: false, };
                            $scope.Accounts = { value: false, };
                            $scope.Management = { value: false, };
                            $scope.Tablet = { value: false, };
                            $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/role/getByClientId",
                                data: { Client_Id: $rootScope.Client_Id },
                            }).then(function (Roledata) {
                                $scope.Roledatas = Roledata.data.data;
                            });
                            $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/usermodel/getByClientId",
                                data: { Client_Id: $rootScope.Client_Id },
                            }).then(function (userModulesdata) {
                                $scope.userModulesdatas = userModulesdata.data.data;
                            });
                            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        });
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Showgrid = function (ischanged) {
            $scope.Usergrid = true;
            $scope.Userform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
            $scope.error1 = false;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { Sales: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { ContractsTemp: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Setting: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { PurchasesPayables: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { Feedback: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { DAccounts: 0 }
            $scope.rec41 = { Health: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { Payroll: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { Division: 0 }
            $scope.rec46 = { LeaveR: 0 }
            $scope.rec47 = { MaterialR: 0 }
            $scope.rec48 = { PurchaseR: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { Estimation: 0 }
            $scope.rec56 = { Materials: 0 }
            $scope.rec57 = { OperationsReport: 0 }
            $scope.checkboxModel = { value: false, };
            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.DAccounts = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.PurchaseR = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.Payroll = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.Materials = { value: false, }
            $scope.Estimation = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.Sales = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.ContractsTemp = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Setting = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.PurchasesPayables = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }
            $scope.UniformR = { value: false, }

            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            $scope.DashBoarddiv = false;
        }
        $scope.Rolesadd = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/hrmusers/addroles.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function hrmusersController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.Security = { value: false, };
            $scope.Human = { value: false, };
            $scope.Procurement = { value: false, };
            $scope.Operations = { value: false, };
            $scope.CRManagement = { value: false, };
            $scope.Accounts = { value: false, };
            $scope.Management = { value: false, };
            $scope.Tablet = { value: false, };
            $scope.ret1 = { Security: 0, };
            $scope.ret2 = { Human: 0, };
            $scope.ret3 = { Procurement: 0, };
            $scope.ret4 = { Operations: 0, };
            $scope.ret5 = { CRManagement: 0, };
            $scope.ret6 = { Accounts: 0, };
            $scope.ret7 = { Management: 0, };
            $scope.ret8 = { Tablet: 0, };
            $scope.moduleupdate = false;
            $scope.rolereadonly = false;
        }
        $scope.rolebased = function (selected) {
            if (selected == undefined || selected == null) {
                $scope.Pageform = false;
                $scope.Securitydiv = false;
                $scope.Humandiv = false;
                $scope.Procurementdiv = false;
                $scope.Operationsdiv = false;
                $scope.Salediv = false;
                $scope.Accountsdiv = false;

                $scope.DManagement = { value: false, };
                $scope.DHuman = { value: false, };
                $scope.DProcurement = { value: false, };
                $scope.DCRM = { value: false, };
                $scope.DOperations = { value: false, };
                $scope.DAccounts = { value: false, };
                $scope.LeaveR = { value: false, };
                $scope.MaterialR = { value: false, };
                $scope.PurchaseR = { value: false, };
                $scope.Incident = { value: false, };
                $scope.Medical = { value: false, };
                $scope.Expense = { value: false, };
                $scope.Payment = { value: false, }
                $scope.Insurance = { value: false, }
                $scope.Division = { value: false, }
                $scope.Payroll = { value: false, }
                $scope.Hrmusers = { value: false, }
                $scope.SChecklist = { value: false, }
                $scope.Materials = { value: false, }
                $scope.Estimation = { value: false, }
                $scope.OperationsReport = { value: false, }
                $scope.Users = { value: false, };
                $scope.Client = { value: false, };
                $scope.HRMAdmin = { value: false, };
                $scope.HRMCore = { value: false, };
                $scope.Products = { value: false, };
                $scope.Supliers = { value: false, };
                $scope.PestType = { value: false, };
                $scope.Services = { value: false, };
                $scope.Customers = { value: false, };
                $scope.Timelog = { value: false, };
                $scope.Recruitment = { value: false, };
                $scope.Training = { value: false, };
                $scope.CrmSettings = { value: false, }
                $scope.Lead = { value: false, }
                $scope.Quotation = { value: false, }
                $scope.Sales = { value: false, }
                $scope.Stores = { value: false, }
                $scope.Contracts = { value: false, }
                $scope.ContractsTemp = { value: false, }
                $scope.PurchaseOrder = { value: false, }
                $scope.StockManagement = { value: false, }
                $scope.Requests = { value: false, }
                $scope.Setting = { value: false, }
                $scope.Ledger = { value: false, }
                $scope.BankCash = { value: false, }
                $scope.PurchasesPayables = { value: false, }
                $scope.SalesReceivables = { value: false, }
                $scope.Asset = { value: false, }
                $scope.Uniform = { value: false, }
                $scope.Workflow = { value: false, }
                $scope.Feedback = { value: false, }
                $scope.Teams = { value: false, }
                $scope.Scheduler = { value: false, }
                $scope.Vehicle = { value: false, }
                $scope.Health = { value: false, }
                $scope.UniformR = { value: false, }
                return
            }
            $scope.Pageform = true;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
            var Moduleselect = [];
            angular.forEach($scope.userModulesdatas, function (umvalue) {
                angular.forEach(selected, function (rvalue) {
                    if (rvalue.RoleName == umvalue.UserID) {
                        Moduleselect.push({
                            ModuleName: umvalue.ModelID,
                        })
                    }
                });
            });
            var mtr = Moduleselect.map(function (obj) { return obj.ModuleName; }).join(', ');
            angular.forEach($scope.Roledatas, function (rvalue) {
                angular.forEach(selected, function (svalue) {
                    if (svalue.RoleName == rvalue.RoleName) {
                        if (mtr.split(",").includes("Security")) {
                            $scope.Securitydiv = true;
                        }
                        if (mtr.indexOf("Human Resource") > -1) {
                            $scope.Humandiv = true;
                        }
                        if (mtr.split(",").includes("Procurement")) {
                            $scope.Procurementdiv = true;
                        }
                        if (mtr.split(",").includes("Operations")) {
                            $scope.Operationsdiv = true;
                        }
                        if (mtr.indexOf("Customer Relationship") > -1) {
                            $scope.Salediv = true;
                        }
                        if (mtr.split(",").includes("Accounts")) {
                            $scope.Accountsdiv = true;
                        }
                    }
                });
            });
            $scope.Users = { value: false };
            $scope.Client = { value: false };
            $scope.Workflow = { value: false };
            if ($scope.Humandiv == false || $scope.Humandiv == undefined) {
                $scope.DHuman = { value: false };
                $scope.HRMAdmin = { value: false };
                $scope.HRMCore = { value: false };
                $scope.Timelog = { value: false };
                $scope.Recruitment = { value: false };
                $scope.Training = { value: false };
                $scope.Health = { value: false };
                $scope.Insurance = { value: false };
                $scope.Payroll = { value: false };
                $scope.Hrmusers = { value: false };
            }
            if ($scope.Procurementdiv == false || $scope.Procurementdiv == undefined) {
                $scope.DProcurement = { value: false };
                $scope.Stores = { value: false };
                $scope.Vehicle = { value: false };
                $scope.PurchaseOrder = { value: false };
                $scope.StockManagement = { value: false };
                $scope.Requests = { value: false };
                $scope.Products = { value: false };
                $scope.Supliers = { value: false };
                $scope.Uniform = { value: false };
            }
            if ($scope.Operationsdiv == false || $scope.Operationsdiv == undefined) {
                $scope.DOperations = { value: false };
                $scope.Services = { value: false };
                $scope.Feedback = { value: false };
                $scope.Teams = { value: false };
                $scope.Scheduler = { value: false };
                $scope.SChecklist = { value: false, }
                $scope.Division = { value: false };
                $scope.Materials = { value: false };
                $scope.OperationsReport = { value: false };
            }
            if ($scope.Salediv == false || $scope.Salediv == undefined) {
                $scope.DCRM = { value: false };
                $scope.Customers = { value: false };
                $scope.Lead = { value: false };
                $scope.Quotation = { value: false };
                $scope.Sales = { value: false };
                $scope.Contracts = { value: false };
                $scope.Estimation = { value: false };
                $scope.PestType = { value: false };
                $scope.ContractsTemp = { value: false };
                $scope.CrmSettings = { value: false };
            }
            if ($scope.Accountsdiv == false || $scope.Accountsdiv == undefined) {
                $scope.DAccounts = { value: false };
                $scope.Setting = { value: false };
                $scope.Ledger = { value: false };
                $scope.BankCash = { value: false };
                $scope.PurchasesPayables = { value: false };
                $scope.SalesReceivables = { value: false };
                $scope.Asset = { value: false };
            }
        }
        $scope.Moduleedit = function (module) {
            $scope.moduleupdate = true;
            $scope.vm.uNewrole = module;
            $scope.rolereadonly = true;
            $scope.ret1 = { Security: 0 }
            $scope.ret2 = { Human: 0 }
            $scope.ret3 = { Procurement: 0 }
            $scope.ret4 = { Operations: 0 }
            $scope.ret5 = { CRManagement: 0 }
            $scope.ret6 = { Accounts: 0 }
            $scope.ret7 = { Management: 0 }
            $scope.ret8 = { Tablet: 0 }
            var mselected = module
            var Moduleselect = [];
            angular.forEach($scope.Roledatas, function (value) {
                if (module == value.RoleName) {
                    $scope.vm.uDescription = value.Description;
                }
            })
            angular.forEach($scope.userModulesdatas, function (mvalue) {
                if (mselected == mvalue.UserID) {
                    Moduleselect.push({
                        ModuleName: mvalue.ModelID,
                    })
                }
            })
            var mtr = Moduleselect.map(function (obj) { return obj.ModuleName; }).join(', ');
            if (mtr.split(",").includes("Security")) {
                $scope.ret1 = { Security: 1 }
            }
            if (mtr.indexOf("Human Resource") > -1) {
                $scope.ret2 = { Human: 1 }
            }
            if (mtr.split(",").includes("Procurement")) {
                $scope.ret3 = { Procurement: 1 }
            }
            if (mtr.split(",").includes("Operations")) {
                $scope.ret4 = { Operations: 1 }
            }
            if (mtr.indexOf("Customer Relationship") > -1) {
                $scope.ret5 = { CRManagement: 1 }
            }
            if (mtr.split(",").includes("Accounts")) {
                $scope.ret6 = { Accounts: 1 }
            }
            if (mtr.split(",").includes("Management")) {
                $scope.ret7 = { Management: 1 }
            }
            if (mtr.split(",").includes("Tablet")) {
                $scope.ret8 = { Tablet: 1 }
            }
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.sAdd = function () {
            ClearForm();
            $scope.Update = false;
            $scope.Userform = true;
            $scope.Usergrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.error1 = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
            $scope.Pageform = false;
            $scope.Search = false;
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { Sales: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { ContractsTemp: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Setting: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { PurchasesPayables: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { Feedback: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec41 = { Health: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { Payroll: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { Division: 0 }
            $scope.rec46 = { LeaveR: 0 }
            $scope.rec47 = { MaterialR: 0 }
            $scope.rec48 = { PurchaseR: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }

            $scope.formData.uExpiryDate = new Date("2025-01-01T04:42:06.965Z");
            try {
                var item = $scope.Clientdatas.filter(function (item) {
                    return item.id === $rootScope.Client_Id;
                })[0];
                $scope.uClientName = item.ClientName;
            }
            catch (e) { }
        }
        $scope.alertcancel = function () {
            RefreshGrid();
            $scope.Usergrid = true;
            $scope.Userform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
            $mdDialog.cancel();

        }

        //Start  Customer Login
        $scope.sAddCustomer = function (e) {
            var userActive = document.getElementById('userActive');
            var userLocked = document.getElementById('userLocked');
            $scope.vm.cLoginID = null;
            $scope.vm.cEmail = null;
            $scope.vm.cUserName = null;
            $scope.vm.cMobileNumber = null
            $scope.vm.cDesignation = null;
            $scope.vm.cPassword = null;
            $scope.vm.CustomerName = null;
            $scope.vm.cExpiryDate = null;
            $scope.IsActive = null;
            $scope.IsLocked = null;
            $scope.vm.cLastSuccess = null;
            $scope.vm.cLastSuccess = null;
            $scope.uClientID = null;
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
                $mdDialog.show({
                    templateUrl: 'app/main/apps/human-resource/hrmusers/CustomerUser.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: false,
                    controller: function hrmusersController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                })
            });
            $scope.vm.cExpiryDate = new Date("2025-01-01T04:42:06.965Z");
            try {
                var item = $scope.Clientdatas.filter(function (item) {
                    return item.id === $rootScope.Client_Id;
                })[0];
                $scope.uClientName = item.ClientName;
            }
            catch (e) { }
        }
        $scope.getForCustomer = function () {
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.vm.cPassword = pass;
        }
        $scope.sCustomerSubmit = function () {

            if ($scope.checkboxModel.value == true) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/email",
                    data: {
                        SenderEmailAddress: $scope.vm.cEmail,
                        UserName: $scope.vm.cUserName,
                        UserID: $scope.vm.cLoginID,
                        Password: $scope.vm.cPassword,
                    },
                });
            }
            if ($scope.CustomerUpdate == true) {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/user/update",
                    data: {
                        _id: $scope.vm.SID,
                        UserID: $scope.vm.cLoginID,
                        Email: $scope.vm.cEmail,
                        UserName: $scope.vm.cUserName,
                        MobileNumber: $scope.vm.cMobileNumber,
                        Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.vm.cExpiryDate,
                        Password: $scope.vm.cPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked,
                        ClientID: $rootScope.Client_Id, Customer_Id: $scope.vm.Customer_Id,
                        CustomerName: $scope.vm.CustomerName,
                        ClientName: $scope.uClientName,
                        UpdatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    RefreshGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated !').position('top center'));
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                $scope.IsActive = true;
                $scope.IsLocked = false;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/user/add",
                    data: {
                        UserID: $scope.vm.cLoginID,
                        Email: $scope.vm.cEmail,
                        UserName: $scope.vm.cUserName,
                        MobileNumber: $scope.vm.cMobileNumber,
                        Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.vm.cExpiryDate,
                        Password: $scope.vm.cPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked,
                        ClientID: $rootScope.Client_Id, Customer_Id: $scope.vm.Customer_Id,
                        CustomerName: $scope.vm.CustomerName,
                        ClientName: $scope.uClientName,
                    },
                });

                response.then(function (GList) {
                    if (GList.data.message == "Existing UserID") {
                        $scope.error1 = true;
                        $scope.Userform = true;
                        $scope.Usergrid = false;
                        $scope.Export = false;
                        $scope.view = true;
                        $scope.Add = false;
                        $scope.Pageform = true;
                        $scope.Search = false;
                    }
                    else {
                        RefreshGrid();
                        $mdDialog.cancel();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added !').position('top center'));
                        $scope.Usergrid = true;
                        $scope.Userform = false;
                        $scope.Pageform = false;
                        $scope.Export = true;
                        $scope.Add = true;
                        $scope.view = false;
                        $scope.Search = true;
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        //End of Customer Login

        $scope.Actsubmit = function (UserId) {
            fetchData(UserId);
            $scope.IsActive = false;
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/user/update",
                data: {
                    _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                    Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                    IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $rootScope.Client_Id,
                    ClientName: $scope.uClientName,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;


            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.chkIsActive = function (UserId, check) {
            var Isactivemodel = check;
            if (Isactivemodel == true) {
                fetchData(UserId);
                $scope.IsActive = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/user/update",
                    data: {
                        _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                        Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                        IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $rootScope.Client_Id,
                        EmployeeID: $scope.uEmployeeID, ClientName: $scope.uClientName,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.Usergrid = true;
                    $scope.Userform = false;
                    $scope.Pageform = false;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            if (Isactivemodel == false) {
                showDialog(UserId);
            }

        }
        $scope.chkIsLocked = function (UserId, check) {
            fetchData(UserId);
            var Islockmodel = check;
            if (Islockmodel == true) {
                $scope.IsLocked = true;
            }
            if (Islockmodel == false) {
                $scope.IsLocked = false;
            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/user/update",
                data: {
                    _id: UserId, UserID: $scope.uLoginID, Email: $scope.uEmail, UserName: $scope.uUserName, MobileNumber: $scope.uMobileNumber,
                    Designation: $scope.uDesignation, Roles: "", ExpiryDate: $scope.uExpiryDate, Password: $scope.uPassword,
                    IsActive: $scope.IsActive, IsLocked: $scope.IsLocked, ClientID: $rootScope.Client_Id, EmployeeID: $scope.uEmployeeID,
                },

            });

            response.then(function (GList) {

                $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                RefreshGrid();
                $scope.Usergrid = true;
                $scope.Userform = false;
                $scope.Pageform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
            });
        $http.get($rootScope.WebURL + "/userrole")
            .then(function (Userroledata) {
                $scope.Userroledatas = Userroledata.data.data;
            });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/role/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Roledata) {
            $scope.Roledatas = Roledata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/usermodel/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (userModulesdata) {
            $scope.userModulesdatas = userModulesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/detailsforTab",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        });
        $http.get($rootScope.WebURL + "/pagedb")
            .then(function (Pagedata) {
                $scope.Pagedatas = Pagedata.data.data;
            });
        $http.get($rootScope.WebURL + "/login/usersession")
            .then(function (usersessiondata) {
                $scope.Usersessiondatadatas = usersessiondata.data.data;
            });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/user/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Userdata) {
            $scope.Userdatas = Userdata.data.data;
            UserSummary();
        });

        function UserSummary() {
            var Users = [];
            var st = '';
            try {
                angular.forEach($scope.Userdatas, function (value) {
                    var Roleselect = [];
                    angular.forEach($scope.Userroledatas, function (urvalue) {
                        angular.forEach($scope.Roledatas, function (rvalue) {
                            if (value.id == urvalue.UserID && urvalue.RoleID == rvalue.RoleID) {
                                Roleselect.push({
                                    RoleName: rvalue.RoleName,
                                })
                            }
                        });
                    });
                    angular.forEach($scope.Usersessiondatadatas, function (usersession) {
                        if (value.UserID == usersession.UserID) {
                            $scope.LastLoginDate = usersession.SessionStartDate;
                        }
                    });
                    st = Roleselect.map(function (obj) { return obj.RoleName; }).join(', ');
                    var Roleselect = [];
                    if (value.Customer_Id != null && value.Customer_Id != "" && value.Customer_Id != undefined && value.Customer_Id != 'undefined') {
                        st = 'Customer'
                    }
                    else {
                        st = st;
                    }
                    Users.push({
                        ID: value.id,
                        UserID: value.UserID,
                        Email: value.Email,
                        UserName: value.UserName,
                        MobileNumber: value.MobileNumber,
                        Designation: value.Designation,
                        ExpiryDate: value.ExpiryDate,
                        Password: value.Password,
                        LastSuccess: value.LastSuccess,
                        LastFailure: value.LastFailure,
                        IsActive: value.IsActive,
                        IsLocked: value.IsLocked,
                        EmployeeID: value.EmployeeID,
                        Roles: st,
                        LastLoginDate: $scope.LastLoginDate,
                        ClientName: value.ClientName,
                    })
                    $scope.LastLoginDate = null
                });
                $scope.UserSummary = Users;
            }
            catch (e) { }
        }
        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/userrole")
                .then(function (Userroledata) {
                    $scope.Userroledatas = Userroledata.data.data;
                });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/usermodel/getByClientId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (userModulesdata) {
                $scope.userModulesdatas = userModulesdata.data.data;
            });
            $http.get($rootScope.WebURL + "/pagedb")
                .then(function (Pagedata) {
                    $scope.Pagedatas = Pagedata.data.data;
                });
            $http.get($rootScope.WebURL + "/login/usersession")
                .then(function (usersessiondata) {
                    $scope.Usersessiondatadatas = usersessiondata.data.data;
                });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/getByClientId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
                UserSummary();
            });
            $scope.rec1 = { Users: 0 }
            $scope.rec2 = { Client: 0 }
            $scope.rec3 = { HRMAdmin: 0 }
            $scope.rec4 = { HRMCore: 0 }
            $scope.rec5 = { Products: 0 }
            $scope.rec6 = { Supliers: 0 }
            $scope.rec7 = { PestType: 0 }
            $scope.rec8 = { Services: 0 }
            $scope.rec9 = { Customers: 0 }
            $scope.rec10 = { Timelog: 0 }
            $scope.rec11 = { Recruitment: 0 }
            $scope.rec12 = { Training: 0 }
            $scope.rec13 = { CrmSettings: 0 }
            $scope.rec14 = { Lead: 0 }
            $scope.rec15 = { Quotation: 0 }
            $scope.rec16 = { Sales: 0 }
            $scope.rec17 = { Stores: 0 }
            $scope.rec18 = { Contracts: 0 }
            $scope.rec19 = { ContractsTemp: 0 }
            $scope.rec20 = { PurchaseOrder: 0 }
            $scope.rec21 = { StockManagement: 0 }
            $scope.rec22 = { Requests: 0 }
            $scope.rec23 = { Setting: 0 }
            $scope.rec24 = { Ledger: 0 }
            $scope.rec25 = { BankCash: 0 }
            $scope.rec26 = { PurchasesPayables: 0 }
            $scope.rec27 = { SalesReceivables: 0 }
            $scope.rec28 = { Asset: 0 }
            $scope.rec29 = { Uniform: 0 }
            $scope.rec30 = { Workflow: 0 }
            $scope.rec31 = { Feedback: 0 }
            $scope.rec32 = { Teams: 0 }
            $scope.rec33 = { Scheduler: 0 }
            $scope.rec34 = { Vehicle: 0 }
            $scope.rec35 = { DManagement: 0 }
            $scope.rec36 = { DHuman: 0 }
            $scope.rec37 = { DProcurement: 0 }
            $scope.rec38 = { DCRM: 0 }
            $scope.rec39 = { DOperations: 0 }
            $scope.rec40 = { DAccounts: 0 }
            $scope.rec41 = { Health: 0 }
            $scope.rec42 = { Insurance: 0 }
            $scope.rec43 = { Payroll: 0 }
            $scope.rec44 = { Hrmusers: 0 }
            $scope.rec45 = { Division: 0 }
            $scope.rec46 = { LeaveR: 0 }
            $scope.rec47 = { MaterialR: 0 }
            $scope.rec48 = { PurchaseR: 0 }
            $scope.rec49 = { UniformR: 0 }
            $scope.rec50 = { Incident: 0 }
            $scope.rec51 = { Medical: 0 }
            $scope.rec52 = { Expense: 0 }
            $scope.rec53 = { Payment: 0 }
            $scope.rec54 = { SChecklist: 0 }
            $scope.rec55 = { Materials: 0 }
            $scope.rec56 = { Estimation: 0 }
            $scope.rec57 = { OperationsReport: 0 }

            $scope.DManagement = { value: false, };
            $scope.DHuman = { value: false, };
            $scope.DProcurement = { value: false, };
            $scope.DCRM = { value: false, };
            $scope.DOperations = { value: false, };
            $scope.DAccounts = { value: false, };
            $scope.LeaveR = { value: false, };
            $scope.MaterialR = { value: false, };
            $scope.PurchaseR = { value: false, };
            $scope.Incident = { value: false, };
            $scope.Medical = { value: false, };
            $scope.Expense = { value: false, };
            $scope.Payment = { value: false, }
            $scope.Insurance = { value: false, }
            $scope.Division = { value: false, }
            $scope.Payroll = { value: false, }
            $scope.Hrmusers = { value: false, }
            $scope.SChecklist = { value: false, }
            $scope.Materials = { value: false, }
            $scope.Estimation = { value: false, }
            $scope.OperationsReport = { value: false, }
            $scope.Users = { value: false, };
            $scope.Client = { value: false, };
            $scope.HRMAdmin = { value: false, };
            $scope.HRMCore = { value: false, };
            $scope.Products = { value: false, };
            $scope.Supliers = { value: false, };
            $scope.PestType = { value: false, };
            $scope.Services = { value: false, };
            $scope.Customers = { value: false, };
            $scope.Timelog = { value: false, };
            $scope.Recruitment = { value: false, };
            $scope.Training = { value: false, };
            $scope.CrmSettings = { value: false, }
            $scope.Lead = { value: false, }
            $scope.Quotation = { value: false, }
            $scope.Sales = { value: false, }
            $scope.Stores = { value: false, }
            $scope.Contracts = { value: false, }
            $scope.ContractsTemp = { value: false, }
            $scope.PurchaseOrder = { value: false, }
            $scope.StockManagement = { value: false, }
            $scope.Requests = { value: false, }
            $scope.Setting = { value: false, }
            $scope.Ledger = { value: false, }
            $scope.BankCash = { value: false, }
            $scope.PurchasesPayables = { value: false, }
            $scope.SalesReceivables = { value: false, }
            $scope.Asset = { value: false, }
            $scope.Uniform = { value: false, }
            $scope.Workflow = { value: false, }
            $scope.Feedback = { value: false, }
            $scope.Teams = { value: false, }
            $scope.Scheduler = { value: false, }
            $scope.Vehicle = { value: false, }
            $scope.Health = { value: false, }
            $scope.UniformR = { value: false, }

            $scope.Pageform = false;
            $scope.Securitydiv = false;
            $scope.Humandiv = false;
            $scope.Procurementdiv = false;
            $scope.Operationsdiv = false;
            $scope.Salediv = false;
            $scope.Accountsdiv = false;
        }
        function ClearForm() {
            var userActive = document.getElementById('userActive');
            var userLocked = document.getElementById('userLocked');
            $scope.formData.uLoginID = null;
            $scope.formData.uEmail = null;
            $scope.formData.uUserName = null;
            $scope.formData.uMobileNumber = null
            $scope.uEmployeeID = null;
            $scope.formData.uDesignation = null;
            $scope.formData.uPassword = null;
            $scope.formData.uRoles = null;
            $scope.formData.uExpiryDate = null;
            $scope.IsActive = null;
            $scope.IsLocked = null;
            $scope.vm.searchE = '';
            $scope.formData.uLastSuccess = null;
            $scope.formData.uLastSuccess = null;
            $scope.formData.selectedRole = [];
            $scope.formData.selectedModule = [];
            $scope.uClientID = null;
        }
        function fetchData(UserId) {
            angular.forEach($scope.Userdatas, function (value) {
                if (value.id == UserId) {
                    $scope.uLoginID = value.UserID;
                    $scope.uEmail = value.Email;
                    $scope.uUserName = value.UserName;
                    $scope.uMobileNumber = value.MobileNumber;
                    $scope.uClientID = value.ClientID;
                    $scope.uClientName = value.ClientName;
                    $scope.uRoles = value.Roles;
                    $scope.uExpiryDate = value.ExpiryDate;
                    $scope.uPassword = value.Password
                    $scope.IsActive = value.IsActive;
                    $scope.IsLocked = value.IsLocked;
                    $scope.uLastSuccess = value.LastSuccess;
                    $scope.uLastSuccess = value.LastFailure;
                }
            });
        }
        function showDialog(UserId) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/human-resource/hrmusers/alertuser.html',
                parent: angular.element($document.body),
                targetEvent: UserId,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function hrmusersController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }

            });
            $scope.UserId = UserId;
        }

        var vm = this;
        vm.ischanged = 1;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.human-resource.dashboard',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.human-resource_dashboard', {
            url      : '/DashboardHumanresource',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/dashboard/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/human-resource/dashboard');

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.human-resource.dashboard')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, $location, $http, $rootScope, $filter, DashboardData) {
        document.getElementsByTagName('title')[0].text = "Human Resource-Dashboard"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DHuman")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            var item = Employeedata.data.data.filter(function (item) {
                return item.IsActive === false;
            });
            $scope.EmployeeResineddatas = item.length;
        });
        $http.get($rootScope.WebURL + "/leave")
            .then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
                var item = $scope.Leavedatas.filter(function (item) {
                    return item.Status === 'Approved';
                });
                $scope.LeaveApprovedLength = item.length;
            });
        $http.get($rootScope.WebURL + "/recruitmentjobapplication")
            .then(function (Recruitmentjobapplicationdata) {
                $scope.Recruitmentjobapplicationdatas = Recruitmentjobapplicationdata.data.data;
                var item = $scope.Recruitmentjobapplicationdatas.filter(function (item) {
                    return item.Status === 'Approved';
                });
                $scope.RecApprovedLength = item.length;
            });

        $http.get($rootScope.WebURL + "/calendar")
            .then(function (Calendardata) {
                $scope.Calendardatas = Calendardata.data.data;
                var item = $scope.Calendardatas.filter(function (item) {
                    return item.EventType === 'Event';
                });
                $scope.EventLength = item.length;
                var Hitem = $scope.Calendardatas.filter(function (Hitem) {
                    return Hitem.EventType === 'Holiday';
                });
                $scope.HolidayLength = Hitem.length;
            });

        $scope.EnrolmentsD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            $scope.Egroups = _.groupBy($scope.Enrollmentsdatas, 'CourseName');
            angular.forEach($scope.Egroups, function (value) {
                $scope.EnrolmentsD.push({ label: value[0].CourseName, value: value.length })
            })
        });

        $scope.ShiftD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
            angular.forEach($scope.Shiftdatas, function (value) {
                $scope.ShiftD.push({
                    label: value.ShiftName,
                    value: 12
                })
            });
        });
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        var vm = this;
        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.Agroups = _.groupBy($scope.Attendancedatas, 'StartDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.Agroups, function (value) {
                    var d = new Date(value[0].StartDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget5.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/attendance",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (Attendancedata) {
                    $scope.Attendancedatas = Attendancedata.data.data;
                    angular.forEach($scope.Attendancedata, function (msg) {
                        msg.StartDate = msg.StartDate.substring(0, 7) + '-01';
                    });
                    vm.widget5.changeRange('TW');
                });


            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.ShiftName;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                angular.forEach($scope.Shiftdatas, function (data, index) {
                    debugger
                    vm.widget6.mainChart.data[index] = {
                        label: data.ShiftName,
                        value: $scope.Shiftdatas.length
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };
        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        var Language = localStorage.getItem('MenuReports');

        var shifttitle = "Shift";
        var coursetitle = "Course Enrollments";
        $scope.General = "General"

        if (DefaultLanguage === "Vietnamese" || Language === "Báo cáo") {
            shifttitle = "Ngày làm việc";
            coursetitle = "Đăng ký khóa học";
            $scope.General = "Chung"

        }

        var widget8 = {
            "title": shifttitle,
            "mainChart": $scope.ShiftD
        }
        // Widget 8
        vm.widget8 = {
            title: widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget8.mainChart
            }
        };

        var widget9 = {
            "title": coursetitle,
            "mainChart": $scope.EnrolmentsD
        }
        // Widget 8
        vm.widget9 = {
            title: widget9.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget9.mainChart
            }
        };
        debugger
        // Widget 10
        vm.widget10 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.NRICgroups = _.groupBy($scope.EmployeeItems, 'NRICExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.NRICgroups, function (value) {
                    var d = new Date(value[0].NRICExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget10.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (EmployeeLengthdata) {
                    try {
                        var item = EmployeeLengthdata.data.data.filter(function (item) {
                            return item.IsActive = true
                        });
                        $scope.EmployeeItems = item;
                        $scope.Employeedatas = item.length;
                        angular.forEach($scope.EmployeeItems, function (msg) {
                            msg.NRICExpiryDate = msg.NRICExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget10.changeRange('TW');
                    }
                    catch (e) { }
                });
            }
        };

        vm.widget11 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.PPgroups = _.groupBy($scope.EmployeeItems, 'WorkPassExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.PPgroups, function (value) {
                    var d = new Date(value[0].WorkPassExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });

                vm.widget11.mainChart.data[0] = data[0];
            },
            init: function () {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (EmployeeLengthdata) {
                    try {
                        var item = EmployeeLengthdata.data.data.filter(function (item) {
                            return item.IsActive = true
                        });
                        $scope.EmployeeItems = item;
                        angular.forEach($scope.EmployeeItems, function (msg) {
                            msg.WorkPassExpiryDate = msg.WorkPassExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget11.changeRange('TW');
                    }
                    catch (e) { }
                });
            }
        };
        // Now widget
        vm.widget12 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.Passgroups = _.groupBy($scope.Passdatas, 'ExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.Passgroups, function (value) {
                    var d = new Date(value[0].ExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget12.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http.get($rootScope.WebURL + "/pass")
                    .then(function (Passdata) {
                        $scope.Passdatas = Passdata.data.data;
                        angular.forEach($scope.Passdatas, function (msg) {
                            msg.ExpiryDate = msg.ExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget12.changeRange('TW');
                    });
            }
        };
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();
        vm.widget10.init();
        vm.widget11.init();
        vm.widget12.init();
        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.sales',
            [
                // 3rd Party Dependencies
                 'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_sales', {
            url      : '/DashboardSales',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/sales/sales.html',
                    controller : 'DashboardSalesController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/sales');

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.sales')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('DashboardSalesController', DashboardSalesController);

    /** @ngInject */
    function DashboardSalesController($scope, $interval, $location, $http, $rootScope, $filter, DashboardData) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DCRM")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/Workflow",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Workflowdata) {
            var item = Workflowdata.data.data.filter(function (item) {
                return item.TypeName === "CRM Leads";
            });
            var item1 = Workflowdata.data.data.filter(function (item1) {
                return item1.TypeName === "CRM Contract";
            });
            $scope.Workflowdatas = item;
            $scope.WorkflowCdatas = item1;
        });

        $scope.ContractD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/contract",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Contractdata) {
            $scope.Contractsitem = Contractdata.data.data;
            $scope.Contractgroups = _.groupBy($scope.Contractsitem, 'Status');
            $scope.Contractdatas = Contractdata.data.data.length;
            angular.forEach($scope.WorkflowCdatas, function (wvalue) {
                var item = $scope.Contractsitem.filter(function (item) {
                    return item.Status === wvalue.Actioned;
                });
                var statuslength = item.length;
                $scope.ContractD.push({
                    label: wvalue.Actioned,
                    value: statuslength
                })
            })

            //angular.forEach($scope.Contractgroups, function (value) {

            //})
        });

        $scope.LeadD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/lead",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Leaddata) {
            $scope.Leaditem = Leaddata.data.data;
            $scope.Leaddatas = Leaddata.data.data.length;
            angular.forEach($scope.Workflowdatas, function (wvalue) {
                var item = $scope.Leaditem.filter(function (item) {
                    return item.Status === wvalue.Actioned;
                });
                var statuslength = item.length;
                $scope.LeadD.push({
                    label: wvalue.Actioned,
                    value: statuslength
                })
            })

        });

        $scope.CustomerD = [];
        var customerchart = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/customer",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Customersdata) {
            $scope.Customersitem = Customersdata.data.data;
            $scope.Customersdatas = Customersdata.data.data.length;
            var item = $scope.Customersitem.filter(function (item) {
                return item.CustomerType === "Company";
            });
            var Companylength = item.length;
            customerchart.push({ CustomerType: "Company", lengthvalue: Companylength })
            var Housing = $scope.Customersitem.filter(function (Housing) {
                return Housing.CustomerType === "Private Housing";
            });
            var Housinglength = Housing.length;
            customerchart.push({ CustomerType: "Private Housing", lengthvalue: Housinglength })

            angular.forEach(customerchart, function (value) {
                $scope.CustomerD.push({
                    label: value.CustomerType,
                    value: value.lengthvalue
                })
            });
        });
        $scope.Totla = function (uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date();
                var secondDate = new Date(uTimeOut);
                if (firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)) {
                    return 'Expiried'
                }
                else {

                    var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
                    if (res == 0) {
                        return 'Expiried'
                    }
                    else {
                        return res;
                    }
                }
            }
            else { return null }
        }
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        var vm = this;
        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        $scope.AddocD = [];
        // Widget 5
        vm.widget5 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                angular.forEach($scope.Leaditem, function (value) {
                    value.EnquiryDate = new Date(value.EnquiryDate).setHours(0, 0, 0, 0)
                })
                $scope.SOgroups = _.groupBy($scope.Leaditem, 'EnquiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.SOgroups, function (value) {
                    var d = new Date(value[0].EnquiryDate);
                    var n = $filter('date')(d, 'dd/MM/yyyy');
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget5.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                var Adh = [];
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesOrder",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (salesOrderdata) {
                    $scope.salesOrderItems = salesOrderdata.data.data;
                    var item = $scope.salesOrderItems.filter(function (item) {
                        return item.OrderType === "Ad-hoc";
                    });
                    $scope.Adhoclength = item.length;
                    $scope.salesOrderdatas = salesOrderdata.data.data.length;
                    vm.widget5.changeRange('TW');

                    Adh.push({ OrderType: "Ad-hoc", lengthvalue: $scope.Adhoclength })
                    var item1 = $scope.salesOrderItems.filter(function (item1) {
                        return item1.OrderType === "Contract";
                    });
                    var OTlength = item1.length;
                    Adh.push({ OrderType: "Contract", lengthvalue: OTlength })
                    angular.forEach(Adh, function (value) {
                        $scope.AddocD.push({
                            label: value.OrderType,
                            value: value.lengthvalue
                        })
                    });
                });
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.ShiftName;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                angular.forEach($scope.Shiftdatas, function (data, index) {
                    debugger
                    vm.widget6.mainChart.data[index] = {
                        label: data.ShiftName,
                        value: $scope.Shiftdatas.length
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };
        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        var widget8 = {
            "title": "Customer",
            "mainChart": $scope.CustomerD
        }
        // Widget 8
        vm.widget8 = {
            title: widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget8.mainChart
            }
        };

        // Widget 9
        var widget9 = {
            "title": "Enquiry",
            "mainChart": $scope.LeadD
        }
        // Widget 8
        vm.widget9 = {
            title: widget9.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget9.mainChart
            }
        };

        // Widget 10
        var widget10 = {
            "title": "Contracts",
            "mainChart": $scope.ContractD
        }
        vm.widget10 = {
            title: widget10.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget10.mainChart
            }
        };

        // Widget 11
        var widget11 = {
            "title": "Work Order",
            "mainChart": $scope.AddocD
        }
        vm.widget11 = {
            title: widget11.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget11.mainChart
            }
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();


        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });
        vm.dashboardData = DashboardData;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true
        };
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/DashboardHumanresource',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/server');
        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.server')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, $location, $http, $rootScope, $filter, DashboardData) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DHuman")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            var item = Employeedata.data.data.filter(function (item) {
                return item.IsActive === false;
            });
            $scope.EmployeeResineddatas = item.length;
        });
        $http.get($rootScope.WebURL + "/leave")
            .then(function (Leavedata) {
                $scope.Leavedatas = Leavedata.data.data;
                var item = $scope.Leavedatas.filter(function (item) {
                    return item.Status === 'Approved';
                });
                $scope.LeaveApprovedLength = item.length;
            });
        $http.get($rootScope.WebURL + "/recruitmentjobapplication")
            .then(function (Recruitmentjobapplicationdata) {
                $scope.Recruitmentjobapplicationdatas = Recruitmentjobapplicationdata.data.data;
                var item = $scope.Recruitmentjobapplicationdatas.filter(function (item) {
                    return item.Status === 'Approved';
                });
                $scope.RecApprovedLength = item.length;
            });

        $http.get($rootScope.WebURL + "/calendar")
            .then(function (Calendardata) {
                $scope.Calendardatas = Calendardata.data.data;
                var item = $scope.Calendardatas.filter(function (item) {
                    return item.EventType === 'Event';
                });
                $scope.EventLength = item.length;
                var Hitem = $scope.Calendardatas.filter(function (Hitem) {
                    return Hitem.EventType === 'Holiday';
                });
                $scope.HolidayLength = Hitem.length;
            });

        $scope.EnrolmentsD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/enrollments",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (enrollmentsdata) {
            $scope.Enrollmentsdatas = enrollmentsdata.data.data;
            $scope.Egroups = _.groupBy($scope.Enrollmentsdatas, 'CourseName');
            angular.forEach($scope.Egroups, function (value) {
                $scope.EnrolmentsD.push({ label: value[0].CourseName, value: value.length })
            })
        });

        $scope.ShiftD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/shift",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Shiftdata) {
            $scope.Shiftdatas = Shiftdata.data.data;
            angular.forEach($scope.Shiftdatas, function (value) {
                $scope.ShiftD.push({
                    label: value.ShiftName,
                    value: 12
                })
            });
        });
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        var vm = this;
        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.Agroups = _.groupBy($scope.Attendancedatas, 'StartDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.Agroups, function (value) {
                    var d = new Date(value[0].StartDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget5.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/attendance",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (Attendancedata) {
                    $scope.Attendancedatas = Attendancedata.data.data;
                    angular.forEach($scope.Attendancedata, function (msg) {
                        msg.StartDate = msg.StartDate.substring(0, 7) + '-01';
                    });
                    vm.widget5.changeRange('TW');
                });


            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.ShiftName;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                angular.forEach($scope.Shiftdatas, function (data, index) {
                    debugger
                    vm.widget6.mainChart.data[index] = {
                        label: data.ShiftName,
                        value: $scope.Shiftdatas.length
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };
        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        var widget8 = {
            "title": "Shift",
            "mainChart": $scope.ShiftD
        }
        // Widget 8
        vm.widget8 = {
            title: widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget8.mainChart
            }
        };

        var widget9 = {
            "title": "Course Enrolments",
            "mainChart": $scope.EnrolmentsD
        }
        // Widget 8
        vm.widget9 = {
            title: widget9.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget9.mainChart
            }
        };
        debugger
        // Widget 10
        vm.widget10 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.NRICgroups = _.groupBy($scope.EmployeeItems, 'NRICExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.NRICgroups, function (value) {
                    var d = new Date(value[0].NRICExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget10.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (EmployeeLengthdata) {
                    try {
                        var item = EmployeeLengthdata.data.data.filter(function (item) {
                            return item.IsActive = true
                        });
                        $scope.EmployeeItems = item;
                        $scope.Employeedatas = item.length;
                        angular.forEach($scope.EmployeeItems, function (msg) {
                            msg.NRICExpiryDate = msg.NRICExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget10.changeRange('TW');
                    }
                    catch (e) { }
                });
            }
        };

        vm.widget11 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.PPgroups = _.groupBy($scope.EmployeeItems, 'WorkPassExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.PPgroups, function (value) {
                    var d = new Date(value[0].WorkPassExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });

                vm.widget11.mainChart.data[0] = data[0];
            },
            init: function () {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (EmployeeLengthdata) {
                    try {
                        var item = EmployeeLengthdata.data.data.filter(function (item) {
                            return item.IsActive = true
                        });
                        $scope.EmployeeItems = item;
                        angular.forEach($scope.EmployeeItems, function (msg) {
                            msg.WorkPassExpiryDate = msg.WorkPassExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget11.changeRange('TW');
                    }
                    catch (e) { }
                });
            }
        };
        // Now widget
        vm.widget12 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                $scope.Passgroups = _.groupBy($scope.Passdatas, 'ExpiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.Passgroups, function (value) {
                    var d = new Date(value[0].ExpiryDate);
                    var n = monthNames[d.getMonth()] + '' + '-' + '' + d.getFullYear();
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget12.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                $http.get($rootScope.WebURL + "/pass")
                    .then(function (Passdata) {
                        $scope.Passdatas = Passdata.data.data;
                        angular.forEach($scope.Passdatas, function (msg) {
                            msg.ExpiryDate = msg.ExpiryDate.substring(0, 7) + '-01';
                        });
                        vm.widget12.changeRange('TW');
                    });
            }
        };
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();
        vm.widget10.init();
        vm.widget11.init();
        vm.widget12.init();
        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.operations',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_operations', {
            url      : '/DashboardOperations',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/operations/operations.html',
                    controller : 'DashboardOperationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/operations');

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.operations')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('DashboardOperationController', DashboardOperationController);

    /** @ngInject */
    function DashboardOperationController($http, $scope, $rootScope, $location, $window, $interval, $filter, $mdSidenav, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DOperations")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.pestdatas = pestdata.data.data.length;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicetypelist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Servicesdata) {
            $scope.Servicesdatas = Servicesdata.data.data.length;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (teamdata) {
            $scope.Teamdatas = teamdata.data.data.length;
        });

        $scope.ScheduleD = [];
        var schedulerchart = [];

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/scheduler",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (scheduler) {
            $scope.schedulerdatas = scheduler.data.data;
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.Status === "Yet to Start";
            });
            $scope.YettoStart = item;
            var Startlength = item.length;
            schedulerchart.push({ Status: "Yet to Start", lengthvalue: Startlength })
            var progress = $scope.schedulerdatas.filter(function (progress) {
                return progress.Status === "In-Progress";
            });
            $scope.InProgress = progress;
            var progresslength = progress.length;
            schedulerchart.push({ Status: "In-Progress", lengthvalue: progresslength })
            var Completed = $scope.schedulerdatas.filter(function (Completed) {
                return Completed.Status === "Completed";
            });
            $scope.Completed = Completed;
            var Completedlength = Completed.length;
            $scope.Completedlength = Completed.length;
            schedulerchart.push({ Status: "Completed", lengthvalue: Completedlength })
            angular.forEach(schedulerchart, function (value) {
                $scope.ScheduleD.push({
                    label: value.Status,
                    value: value.lengthvalue
                })
            })
            $scope.YTSdata = [];
            $scope.IPdata = [];
            $scope.CMPdata = [];
            angular.forEach($scope.YettoStart, function (msg) {
                msg.Endsat = new Date(msg.Startsat).getTime();
                msg.Startsat = msg.Startsat.substring(0, 7) + '-01';
            });
            $scope.groupYTS = _.groupBy($scope.YettoStart, 'Startsat');

            angular.forEach($scope.InProgress, function (msg) {
                msg.Endsat = new Date(msg.Startsat).getTime();
                msg.Startsat = msg.Startsat.substring(0, 7) + '-01';
            });
            $scope.groupIP = _.groupBy($scope.InProgress, 'Startsat');

            angular.forEach($scope.Completed, function (msg) {
                msg.Endsat = new Date(msg.Startsat).getTime();
                msg.Startsat = msg.Startsat.substring(0, 7) + '-01';
            });
            $scope.groupCPM = _.groupBy($scope.Completed, 'Startsat');

            angular.forEach($scope.groupYTS, function (value) {
                angular.forEach($scope.groupIP, function (ivalue) {
                    angular.forEach($scope.groupCPM, function (cvalue) {
                        $scope.YTSdata.push({
                            0: value[0].Endsat, 1: value.length
                        })
                        $scope.IPdata.push({
                            0: ivalue[0].Endsat, 1: ivalue.length
                        })

                        $scope.CMPdata.push({
                            0: cvalue[0].Endsat, 1: cvalue.length
                        })
                    })
                })
            })

            $scope.data = []
            $scope.data.push({
                key: 'Yet to Start', values: $scope.YTSdata
            })
            $scope.data.push({
                key: 'In-Progress', values: $scope.IPdata
            })
            $scope.data.push({
                key: 'Completed', values: $scope.CMPdata
            })
        });
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        $scope.ScheduleTeamD = [];
        $scope.TechD = [];
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/scheduler/uniquescheduler",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (uniquescheduler) {
            $scope.Uniqueschedulerdatas = uniquescheduler.data.data;
            var NotCompleted = $scope.Uniqueschedulerdatas.filter(function (NotCompleted) {
                return NotCompleted.Status != "Completed";
            });
            $scope.NotCompletedlength = NotCompleted.length;
            var Completed = $scope.Uniqueschedulerdatas.filter(function (Completed) {
                return Completed.Status === "Completed";
            });
            $scope.Completeddatas = Completed;
            $scope.Sgroups = _.groupBy(NotCompleted, 'AssignedTo');
            angular.forEach($scope.Sgroups, function (value) {
                $scope.ScheduleTeamD.push({ label: value[0].teamdetails[0].TeamName, value: value.length })
            })
            angular.forEach($scope.Uniqueschedulerdatas, function (value) {
                if (value.teamdetails[0] != null && value.teamdetails[0] != "" && value.teamdetails[0] != undefined) {
                    $scope.TeamMember = value.teamdetails[0].TeamMembers;
                    if ($scope.TeamMember != null && $scope.TeamMember != "" && $scope.TeamMember != undefined) {
                        var array = $scope.TeamMember.split(",");
                        angular.forEach(array, function (value) {
                            if ($scope.TechD.indexOf(value) == -1) {
                                $scope.TechD.push(value);
                            }
                        });
                    }
                }
            })
            $scope.TeamMemberlength = $scope.TechD.length;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/tabletschedulerrecord",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (tabletschedulerrecord) {
            $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
            $scope.Tabletschedule = [];
            angular.forEach($scope.Completeddatas, function (cvalue) {
                angular.forEach($scope.Tabletschedulerrecord, function (value) {
                    if (cvalue.ServiceID == value.ServiceId) {
                        $scope.Tabletschedule.push({
                            ServiceId: value.ServiceId,
                            WorkorderNo: value.WorkorderNo,
                            ContractOrderNo: value.ContractOrderNo,
                            Team: value.Team,
                            Startsat: cvalue.Startsat,
                            Endsat: cvalue.Endsat,
                            ActualStartsat: value.Startsat,
                            ActualEndsat: value.Endsat,
                        })
                    }
                })
            })
        });

        $scope.Datefilter = function () {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/tabletschedulerrecord",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (tabletschedulerrecord) {
                $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
                $scope.Tabletschedule = [];
                angular.forEach($scope.Completeddatas, function (cvalue) {
                    angular.forEach($scope.Tabletschedulerrecord, function (value) {
                        if (cvalue.ServiceID == value.ServiceId) {
                            if (new Date(cvalue.Startsat) > $scope.vm.uscFrom && new Date(cvalue.Startsat) < $scope.vm.uscTo) {
                                $scope.Tabletschedule.push({
                                    ServiceId: value.ServiceId,
                                    WorkorderNo: value.WorkorderNo,
                                    ContractOrderNo: value.ContractOrderNo,
                                    Team: value.Team,
                                    Startsat: cvalue.Startsat,
                                    Endsat: cvalue.Endsat,
                                    ActualStartsat: value.Startsat,
                                    ActualEndsat: value.Endsat,
                                })
                            }
                        }
                    })
                })
            });

        }
        $scope.Late = function (uTimeIn, uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var dd = new Date().getDate();
                var mm = new Date().getMonth() + 1;
                var yy = new Date().getFullYear();
                var hh = new Date(uTimeIn).getHours();
                var ms = new Date(uTimeIn).getMinutes();
                var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
                var uTimeIn = new Date(x);
                var edd = new Date().getDate();
                var emm = new Date().getMonth() + 1;
                var eyy = new Date().getFullYear();
                var ehh = new Date(uTimeOut).getHours();
                var ems = new Date(uTimeOut).getMinutes();
                var y = eyy + ',' + emm + ',' + edd + ' ' + ehh + ':' + ems;
                var uTimeOut = new Date(y);

                if (new Date(uTimeOut) > new Date(uTimeIn)) {
                    var t1 = moment(uTimeIn);
                    var t2 = moment(uTimeOut);
                    var seconds = t2.diff(t1, 'seconds');
                    $scope.Seconds = seconds;
                    var date = new Date(null);
                    date.setSeconds($scope.Seconds);
                    return date.toISOString().substr(11, 5);
                }
                else { }
            }
            else { return null }
        }
        $scope.Earlier = function (uTimeIn, uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var dd = new Date().getDate();
                var mm = new Date().getMonth() + 1;
                var yy = new Date().getFullYear();
                var hh = new Date(uTimeIn).getHours();
                var ms = new Date(uTimeIn).getMinutes();
                var x = yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms;
                var uTimeIn = new Date(x);
                var edd = new Date().getDate();
                var emm = new Date().getMonth() + 1;
                var eyy = new Date().getFullYear();
                var ehh = new Date(uTimeOut).getHours();
                var ems = new Date(uTimeOut).getMinutes();
                var y = eyy + ',' + emm + ',' + edd + ' ' + ehh + ':' + ems;
                var uTimeOut = new Date(y);
                if (new Date(uTimeIn) > new Date(uTimeOut)) {
                    var t1 = moment(uTimeIn);
                    var t2 = moment(uTimeOut);
                    var seconds = t1.diff(t2, 'seconds');
                    $scope.Seconds = seconds;
                    var date = new Date(null);
                    date.setSeconds($scope.Seconds);
                    return date.toISOString().substr(11, 5);
                }
                else { }
            }
            else { return null }
        }
        var vm = this;
        var tdydate = new Date();
        vm.uscFrom = new Date(tdydate.getFullYear(), tdydate.getMonth() - 1, tdydate.getDate());
        vm.uscTo = new Date(tdydate.getFullYear(), tdydate.getMonth(), tdydate.getDate());

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";
        //      totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;
                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }

        $scope.Range = function () {
            debugger
            var range = vm.widget1.currentRange;
            if (range == "All") {
                $scope.totaljobs = $scope.schedulerdatas.length;
                var item = $scope.schedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;
                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }
        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title: vm.dashboardData.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            supporting: {
                widgets: {
                    created: {
                        data: vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed: {
                        data: vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened: {
                        data: vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix: {
                        data: vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data: vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed: {
                        data: vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: ['#03A9F4'],
                            height: 50,
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            isArea: true,
                            interpolate: 'cardinal',
                            clipEdge: true,
                            duration: 500,
                            showXAxis: false,
                            showYAxis: false,
                            showLegend: false,
                            useInteractiveGuideline: true,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            yDomain: [0, 9],
                            xAxis: {
                                tickFormat: function (d) {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data: []
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index) {
                    vm.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name) {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key: widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.ShiftName;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                angular.forEach($scope.Shiftdatas, function (data, index) {
                    debugger
                    vm.widget6.mainChart.data[index] = {
                        label: data.ShiftName,
                        value: $scope.Shiftdatas.length
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };
        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        var widget8 = {
            "title": "Scheduled Team",
            "mainChart": $scope.ScheduleTeamD
        }
        // Widget 8
        vm.widget8 = {
            title: widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget8.mainChart
            }
        };

        // Widget 9
        var widget9 = {
            "title": "Scheduler Status",
            "mainChart": $scope.ScheduleD
        }
        // Widget 8
        vm.widget9 = {
            title: widget9.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget9.mainChart
            }
        };

        $scope.options = {
            chart: {
                type: 'stackedAreaChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 30,
                    left: 40
                },
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                useVoronoi: false,
                clipEdge: true,
                duration: 100,
                useInteractiveGuideline: true,
                xAxis: {
                    showMaxMin: false,
                    tickFormat: function (d) {
                        return monthNames[new Date(d).getMonth()];
                    }
                },
                yAxis: {
                    tickFormat: function (d) {
                        return d;
                    }
                },
                zoom: {
                    enabled: true,
                    scaleExtent: [1, 10],
                    useFixedDomain: false,
                    useNiceScale: false,
                    horizontalOff: false,
                    verticalOff: true,
                    unzoomEventType: 'dblclick.zoom'
                }
            }
        };




        // Widget 11
        vm.widget11 = {
            title: vm.dashboardData.widget11.title,
            table: vm.dashboardData.widget11.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                order: [1, 'asc'],
                columnDefs: [
                    {
                        width: '40',
                        orderable: false,
                        targets: [0]
                    },
                    {
                        width: '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();


        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true
        };
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/DashboardManagement',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/project');
        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();


(function () {
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData, $filter) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DManagement")) {   // do nothing 
        }
        else { return }

        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;


        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalemployees = 0;
        $scope.resignedemployees = 0;
        $scope.totalenquiries = 0;
        $scope.totalclosed = 0;
        $scope.totalorders = 0;
        $scope.totalAdhoc = 0;


        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (EmployeeLengthdata) {
            try {
                var item = EmployeeLengthdata.data.data.filter(function (item) {
                    return item.IsActive === true;
                });
                $scope.Employeedatas = item;
                $scope.totalemployees = $scope.Employeedatas.length;

                var item1 = EmployeeLengthdata.data.data.filter(function (item1) {
                    return item1.IsActive === false;
                });
                $scope.resignedemployees = item1.length;
            }
            catch (e) { }
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/lead",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (leaddata) {
            $scope.Leaddatas = leaddata.data.data;
            $scope.totalenquiries = $scope.Leaddatas.length;

            var item = $scope.Leaddatas.filter(function (item) {
                return item.EnquiryStatus === "Closed";
            });
            $scope.totalclosed = item.length;;

        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/salesOrder",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (salesOrderdata) {
            $scope.salesOrderdatas = salesOrderdata.data.data;
            $scope.totalorders = $scope.salesOrderdatas.length;

            var item = $scope.salesOrderdatas.filter(function (item) {
                return item.OrderType === "Ad-hoc";
            });
            $scope.totalAdhoc = item.length;;
        });


        // Widget 5
        vm.widget5 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {

                debugger

                //   var data=vm.dashboardData.widget5.mainChart[0];


                $scope.Salesdatas = $filter('orderBy')($scope.Salesinvoicedatas, 'Date');

                var data = [{ "values": [] }];
                angular.forEach($scope.Salesdatas, function (value) {
                    debugger

                    var d = new Date(value.Date);
                    var n = d.getFullYear();

                    data[0].values.push(
                        {
                            "x": n,
                            "y": parseInt(value.Amount)
                        }
                    )
                });

                debugger
                vm.widget5.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */

                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesinvoice",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (salesinvoicedata) {
                    debugger
                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                    vm.widget5.changeRange('TW');
                });


            }
        };


        vm.widget6 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#FF9800', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },

            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {

                $scope.Purchasedatas = $filter('orderBy')($scope.Purchaseinvoicedatas, 'Date');

                var data = [{ "values": [] }];
                angular.forEach($scope.Purchasedatas, function (value) {
                    debugger

                    var d = new Date(value.Date);
                    var n = d.getFullYear();

                    data[0].values.push(
                        {
                            "x": n,
                            "y": parseInt(value.Amount)
                        }
                    )
                });

                debugger
                vm.widget6.mainChart.data[0] = data[0];
            },
            init: function () {

                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/purchaseinvoice",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (purchaseinvoicedata) {
                    debugger
                    $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;
                    vm.widget6.changeRange('TW');
                });

            }
        };


        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();


        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.procurement',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_procurement', {
            url      : '/DashboardInventry',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/procurement/dashboard-procurement.html',
                    controller: 'DashboardProcurementController as vm'
                }
            },
            resolve: {
                DashboardData: function (msApi) {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/procurement');
        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();


(function () {
    'use strict';

    angular
        .module('app.dashboards.procurement')
        .controller('DashboardProcurementController', DashboardProcurementController);

    /** @ngInject */
    function DashboardProcurementController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DProcurement")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        RefreshPurchaseorderGrid();
        RefreshUniformformGrid();
        RefreshPurchaseformGrid();
        RefreshMaterialformGrid();
        RefreshGoodsuniqueGrid();

        var vm = this;
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        function RefreshPurchaseorderGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Purchaseorderdata) {
                $scope.TotalPurchaseorders = Purchaseorderdata.data.data;
                $scope.PODetails();
            });
        }

        function RefreshUniformformGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/uniformform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Uniformformdata) {
                $scope.TotalUniformforms = Uniformformdata.data.data;
                $scope.UniformDetails();
            });
        }

        function RefreshPurchaseformGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Purchaseformdata) {
                $scope.TotalPurchaseforms = Purchaseformdata.data.data;
                $scope.PurchaseDetails();
            });
        }

        function RefreshMaterialformGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/materialform",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Materialformdata) {
                $scope.TotalMaterialforms = Materialformdata.data.data;
                $scope.MaterialDetails();
            });
        }

        function RefreshGoodsuniqueGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/goodsunique",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Goodsuniquedata) {
                $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
                $scope.StockList();
            });
        }

        //$http.get( $rootScope.WebURL + "/purchaseorder")
        //   .then(function (Purchaseorderdata) {
        //       $scope.TotalPurchaseorders = Purchaseorderdata.data.data;
        //       $scope.PODetails();
        //   });

        //$http.get( $rootScope.WebURL + "/uniformform")
        //   .then(function (Uniformformdata) {
        //       $scope.TotalUniformforms = Uniformformdata.data.data;
        //       $scope.UniformDetails();
        //   });

        //$http.get( $rootScope.WebURL + "/materialform")
        //    .then(function (Materialformdata) {
        //        $scope.TotalMaterialforms = Materialformdata.data.data;
        //        $scope.MaterialDetails();
        //    });

        //$http.get( $rootScope.WebURL + "/purchaseform")
        //    .then(function (Purchaseformdata) {
        //        $scope.TotalPurchaseforms = Purchaseformdata.data.data;
        //        $scope.PurchaseDetails();
        //    });

        //$http.get( $rootScope.WebURL + "/goodsunique")
        // .then(function (Goodsuniquedata) {
        //     $scope.Goodsuniquedatas = Goodsuniquedata.data.data;
        //     $scope.StockList();
        // });

        $scope.PODetails = function () {
            debugger

            $scope.TotalPurchaseOrderNew = 0;
            $scope.TotalPurchaseOrderReviewed = 0;
            $scope.TotalPurchaseOrderApproved = 0;
            $scope.TotalPurchaseOrderSenttoSupplier = 0;
            $scope.TotalPurchaseOrderClosed = 0;
            $scope.TotalPurchaseOrderRejected = 0;
            $scope.TotalPurchaseOrderCancelled = 0;


            var POinfo = $scope.TotalPurchaseorders;
            for (var i = 0; i < POinfo.length; i++) {
                debugger
                if (POinfo[i].Status == "New") {
                    $scope.TotalPurchaseOrderNew++;
                }
                else if (POinfo[i].Status == "Reviewed") {
                    $scope.TotalPurchaseOrderReviewed++;
                }
                else if (POinfo[i].Status == "Approved") {
                    $scope.TotalPurchaseOrderApproved++;
                }
                else if (POinfo[i].Status == "Sent to Supplier") {
                    $scope.TotalPurchaseOrderSenttoSupplier++;
                }
                else if (POinfo[i].Status == "Closed") {
                    $scope.TotalPurchaseOrderClosed++;
                }
                else if (POinfo[i].Status == "Rejected") {
                    $scope.TotalPurchaseOrderRejected++;
                }
                else if (POinfo[i].Status == "Cancelled") {
                    $scope.TotalPurchaseOrderCancelled++;
                }
            }
        }

        $scope.UniformDetails = function () {
            debugger

            $scope.TotalUniformRequestNew = 0;
            $scope.TotalUniformRequestReviewed = 0;
            $scope.TotalUniformRequestApproved = 0;
            $scope.TotalUniformRequestRejected = 0;
            $scope.TotalUniformRequestCancelled = 0;


            var Uinfo = $scope.TotalUniformforms;
            for (var i = 0; i < Uinfo.length; i++) {
                debugger
                if (Uinfo[i].Status == "New") {
                    $scope.TotalUniformRequestNew++;
                }
                else if (Uinfo[i].Status == "Reviewed") {
                    $scope.TotalUniformRequestReviewed++;
                }
                else if (Uinfo[i].Status == "Approved") {
                    $scope.TotalUniformRequestApproved++;
                }
                else if (Uinfo[i].Status == "Rejected") {
                    $scope.TotalUniformRequestRejected++;
                }
                else if (Uinfo[i].Status == "Cancelled") {
                    $scope.TotalUniformRequestCancelled++;
                }
            }
        }

        $scope.MaterialDetails = function () {
            debugger

            $scope.TotalMaterialRequestNew = 0;
            $scope.TotalMaterialRequestReviewed = 0;
            $scope.TotalMaterialRequestApproved = 0;
            $scope.TotalMaterialRequestRejected = 0;
            $scope.TotalMaterialRequestCancelled = 0;


            var Minfo = $scope.TotalMaterialforms;
            for (var i = 0; i < Minfo.length; i++) {
                debugger
                if (Minfo[i].Status == "New") {
                    $scope.TotalMaterialRequestNew++;
                }
                else if (Minfo[i].Status == "Reviewed") {
                    $scope.TotalMaterialRequestReviewed++;
                }
                else if (Minfo[i].Status == "Approved") {
                    $scope.TotalMaterialRequestApproved++;
                }
                else if (Minfo[i].Status == "Rejected") {
                    $scope.TotalMaterialRequestRejected++;
                }
                else if (Minfo[i].Status == "Cancelled") {
                    $scope.TotalMaterialRequestCancelled++;
                }
            }
        }

        $scope.PurchaseDetails = function () {
            debugger

            $scope.TotalPurchaseRequestNew = 0;
            $scope.TotalPurchaseRequestReviewed = 0;
            $scope.TotalPurchaseRequestApproved = 0;
            $scope.TotalPurchaseRequestRejected = 0;
            $scope.TotalPurchaseRequestCancelled = 0;


            var Pinfo = $scope.TotalPurchaseforms;
            for (var i = 0; i < Pinfo.length; i++) {
                debugger
                if (Pinfo[i].Status == "New") {
                    $scope.TotalPurchaseRequestNew++;
                }
                else if (Pinfo[i].Status == "Reviewed") {
                    $scope.TotalPurchaseRequestReviewed++;
                }
                else if (Pinfo[i].Status == "Approved") {
                    $scope.TotalPurchaseRequestApproved++;
                }
                else if (Pinfo[i].Status == "Rejected") {
                    $scope.TotalPurchaseRequestRejected++;
                }
                else if (Pinfo[i].Status == "Cancelled") {
                    $scope.TotalPurchaseRequestCancelled++;
                }
            }
        }

        $scope.StockList = function () {
            debugger
            var Minimumdetail = [];
            angular.forEach($scope.Goodsuniquedatas, function (value) {
                debugger
                $scope.vb = parseInt(value.BalanceQuantity);
                $scope.vr = parseInt(value.ReorderQuantity);

                if ($scope.vb < $scope.vr) {
                    debugger
                    Minimumdetail.push({
                        id: value.id,
                        StoreName: value.StoreName,
                        ProductCategory: value.ProductCategory,
                        ProductCode: value.ProductCode,
                        ProductName: value.ProductName,
                        Description: value.Description,
                        TotalQuantity: value.TotalQuantity,
                        IssuedQuantity: value.IssuedQuantity,
                        ReceivedQuantity: value.ReceivedQuantity,
                        BalanceQuantity: value.BalanceQuantity,
                        ReorderQuantity: value.ReorderQuantity,
                        ReorderQuantityUnit: value.ReorderQuantityUnit,
                    })
                }
            });
            debugger
            $scope.Minimumdetaildatas = Minimumdetail;

            $scope.Minimumdetaildataslength = Minimumdetail.length;
        }

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };







        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title: vm.dashboardData.widget5.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'multiBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            supporting: {
                widgets: {
                    created: {
                        data: vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed: {
                        data: vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened: {
                        data: vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix: {
                        data: vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data: vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed: {
                        data: vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: ['#03A9F4'],
                            height: 50,
                            margin: {
                                top: 8,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            isArea: true,
                            interpolate: 'cardinal',
                            clipEdge: true,
                            duration: 500,
                            showXAxis: false,
                            showYAxis: false,
                            showLegend: false,
                            useInteractiveGuideline: true,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            yDomain: [0, 9],
                            xAxis: {
                                tickFormat: function (d) {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data: []
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index) {
                    vm.widget5.mainChart.data[index] = {
                        key: chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name) {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key: widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index) {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title: vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title: vm.dashboardData.widget9.title,
            weeklySpent: {
                title: vm.dashboardData.widget9.weeklySpent.title,
                count: vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent: {
                title: vm.dashboardData.widget9.totalSpent.title,
                count: vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining: {
                title: vm.dashboardData.widget9.remaining.title,
                count: vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget: vm.dashboardData.widget9.totalBudget,
            chart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'lineChart',
                        color: ['#00BCD4'],
                        height: 50,
                        margin: {
                            top: 8,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        isArea: true,
                        interpolate: 'cardinal',
                        clipEdge: true,
                        duration: 500,
                        showXAxis: false,
                        showYAxis: false,
                        showLegend: false,
                        useInteractiveGuideline: true,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yDomain: [0, 9],
                        xAxis: {
                            tickFormat: function (d) {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer: {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges: vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key: vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key: vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key: vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title: vm.dashboardData.widget11.title,
            table: vm.dashboardData.widget11.table,
            dtOptions: {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth: false,
                responsive: true,
                order: [1, 'asc'],
                columnDefs: [
                    {
                        width: '40',
                        orderable: false,
                        targets: [0]
                    },
                    {
                        width: '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app.dashboards.accounts',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dashboards_accounts', {
            url: '/DashboardAccounts',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/accounts/operations.html',
                    controller: 'DashboardaccountsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/accounts');

        // Api 
        // Api 
        
        msApiProvider.register('dashboard.server', ['app/data/dashboard/project/data.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboards.accounts')
        .controller('DashboardaccountsController', DashboardaccountsController);

    /** @ngInject */
    function DashboardaccountsController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {

        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DAccounts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        debugger
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";

        totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;
        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalpayables = 0;
        $scope.totalpaid = 0;
        $scope.totalreceivables = 0;
        $scope.totalreceived = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;

                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;

                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }


        $scope.Range = function () {
            debugger

            var range = vm.widget1.currentRange;
            if (range == "All") {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (scheduler) {
                    $scope.schedulerdatas = scheduler.data.data;
                    $scope.totaljobs = $scope.schedulerdatas.length;

                    var item = $scope.schedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }


        RefreshAssetRegister();
        RefreshAssetDisposal();
        RefreshPurchaseinvoice();
        RefreshPaysupplier();
        RefreshSalesInvoice();
        RefreshCollectPayment();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                $scope.totalassets = $scope.AssetRegisterdatas.length;
            });


        }
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;

                $scope.totaldiposed = $scope.AssetDisposaldatas.length;
            });
        }

        function RefreshPurchaseinvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (purchaseinvoicedata) {
                debugger
                $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;

                $scope.totalpayables = $scope.Purchaseinvoicedatas.length;
            });
        }

        function RefreshPaysupplier() {

            var response = $http({
                url: $rootScope.WebURL + "/paysupplier",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (paysupplierdata) {
                $scope.Paysupplierdatas = paysupplierdata.data.data;

                $scope.totalpaid = $scope.Paysupplierdatas.length;
            });

        }

        function RefreshSalesInvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                debugger
                $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                $scope.totalreceivables = $scope.Salesinvoicedatas.length;
            });
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;

                $scope.totalreceived = $scope.CollectPaymentdatas.length;
            });
        }


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100]
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];




        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('apps.crm.settings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.settings', {
            url: '/Settings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/settings/settings.html',
                    controller: 'CRMSettingsController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/settings');
    }

})();
(function () {
    'use strict';

    angular
        .module('apps.crm.settings')
        .controller('CRMSettingsController', CRMSettingsController);

    /** @ngInject */
    function CRMSettingsController($scope, $interval, $mdSidenav, $mdToast, $http, $rootScope, $location, $mdDateLocale, $mdDialog, $document) {
        document.getElementsByTagName('title')[0].text = "Customer Relationship-Settings"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("CrmSettings")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        $scope.Update = false;
        $scope.model = {};

        RefreshGrid();
        RefreshAreaGrid();

        $scope.CreditTermExport = true;
        $scope.skillExport = false;
        $scope.licenseExport = false;
        $scope.languageExport = false;
        $scope.membershipExport = false;
        $scope.BuildingTypeExport = false;
        $scope.RemarksExport = false;
        $scope.AreaExport = false;
        $scope.error1 = false;

        $scope.CreT = function () {
            $scope.CreditTermExport = true;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("CreditTerms.xlsx",{headers:true}) FROM ?', [$scope.CreditTermdatas]);
        };
        $scope.PayT = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = true;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.BuildingTypeExport = false;
            $scope.EnquiryModeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.ptExport = function () {
            alasql('SELECT * INTO XLSX("PaymentTerms.xlsx",{headers:true}) FROM ?', [$scope.PaymentTermdatas]);
        };
        $scope.BillF = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = true;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.bfExport = function () {
            alasql('SELECT * INTO XLSX("BillingFrequency.xlsx",{headers:true}) FROM ?', [$scope.BillingFrequencydatas]);
        };
        $scope.SchedF = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = true;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.sfExport = function () {
            alasql('SELECT * INTO XLSX("ScheduleFrequency.xlsx",{headers:true}) FROM ?', [$scope.ScheduleFrequencydatas]);
        };
        $scope.PayM = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = true;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.pmExport = function () {
            alasql('SELECT * INTO XLSX("PaymentModes.xlsx",{headers:true}) FROM ?', [$scope.PaymentModedatas]);
        };
        $scope.JobT = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = true;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.BuildingTypeExport = false;
            $scope.EnquiryModeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.jtExport = function () {
            alasql('SELECT * INTO XLSX("JobTypes.xlsx",{headers:true}) FROM ?', [$scope.JobTypesdatas]);
        };
        $scope.ContM = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = true;
            $scope.BuildingTypeExport = false;
            $scope.EnquiryModeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.cmExport = function () {
            alasql('SELECT * INTO XLSX("ContactMediums.xlsx",{headers:true}) FROM ?', [$scope.ContactMediumdatas]);
        };
        $scope.EnqM = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.BuildingTypeExport = false;
            $scope.EnquiryModeExport = true;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.emExport = function () {
            alasql('SELECT * INTO XLSX("EnquiryModes.xlsx",{headers:true}) FROM ?', [$scope.EnquiryModedatas]);
        };
        $scope.BType = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = true;
            $scope.RemarksExport = false;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.btExport = function () {
            alasql('SELECT * INTO XLSX("BuildingTypes.xlsx",{headers:true}) FROM ?', [$scope.BuildingTypedatas]);
        };
        $scope.Remark = function () {
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = true;
            $scope.AreaExport = false;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.model.Search = '';
        }
        $scope.rExport = function () {
            alasql('SELECT * INTO XLSX("Remarksdatas.xlsx",{headers:true}) FROM ?', [$scope.Remarksdatas]);
        };
        $scope.Area = function () {
            ClearArea();
            $scope.CreditTermExport = false;
            $scope.PaymentTermsExport = false;
            $scope.BillingFrequencyExport = false;
            $scope.ScheduleFrequencyExport = false;
            $scope.JobTypesExport = false;
            $scope.PaymentModeExport = false;
            $scope.ContactMediumExport = false;
            $scope.EnquiryModeExport = false;
            $scope.BuildingTypeExport = false;
            $scope.RemarksExport = false;
            $scope.AreaExport = true;
            $scope.Update = false;
            $scope.error1 = false;
            $scope.vm.AreaName = '';
            $scope.vm.AreaCode = '';
            $scope.model.Search = '';
        }
        $scope.aExport = function () {
            alasql('SELECT * INTO XLSX("Areadatas.xlsx",{headers:true}) FROM ?', [$scope.Areadatas]);
        };

        $scope.CreditTermSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.CTID,
                        Name: $scope.vm.CreditTerm,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.CreditTerm = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.CreditTerm,
                        Description: "CreditTerm",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.CreditTerm = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.CreditTerminfo = function (Id) {
            $scope.CTID = Id;
            $scope.Update = true;
            try {
                var item = $scope.CreditTermdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.CreditTerm = item.Name;
            } catch (err) { }
        }

        $scope.PaymentTermSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.PTID,
                        Name: $scope.vm.PaymentTerm,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.PaymentTerm = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.PaymentTerm,
                        Description: "PaymentTerm",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.PaymentTerm = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.PaymentTerminfo = function (Id) {
            $scope.PTID = Id;
            $scope.Update = true;
            try {
                var item = $scope.PaymentTermdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.PaymentTerm = item.Name;
            } catch (err) { }
        }

        $scope.BillingFrequencySubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.BFID,
                        Name: $scope.vm.BillingFrequency,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.BillingFrequency = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.BillingFrequency,
                        Description: "BillingFrequency",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.BillingFrequency = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.BillingFrequencyinfo = function (Id) {
            $scope.BFID = Id;
            $scope.Update = true;
            try {
                var item = $scope.BillingFrequencydatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.BillingFrequency = item.Name;
            } catch (err) { }
        }

        $scope.ScheduleFrequencySubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.SFID,
                        Name: $scope.vm.ScheduleFrequency,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.ScheduleFrequency = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.ScheduleFrequency,
                        Description: "ScheduleFrequency",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.ScheduleFrequency = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.ScheduleFrequencyinfo = function (Id) {
            $scope.SFID = Id;
            $scope.Update = true;
            try {
                var item = $scope.ScheduleFrequencydatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.ScheduleFrequency = item.Name;
            } catch (err) { }
        }

        $scope.PaymentModeSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.PMID,
                        Name: $scope.vm.PaymentMode,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.PaymentMode = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.PaymentMode,
                        Description: "PaymentMode",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.PaymentMode = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.PaymentModeinfo = function (Id) {
            $scope.PMID = Id;
            $scope.Update = true;
            try {
                var item = $scope.PaymentModedatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.PaymentMode = item.Name;
            } catch (err) { }
        }

        $scope.JobTypesSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.JTID,
                        Name: $scope.vm.JobTypes,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.JobTypes = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.JobTypes,
                        Description: "JobTypes",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.JobTypes = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.JobTypesinfo = function (Id) {
            $scope.JTID = Id;
            $scope.Update = true;
            try {
                var item = $scope.JobTypesdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.JobTypes = item.Name;
            } catch (err) { }
        }

        $scope.ContactMediumSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.CMID,
                        Name: $scope.vm.ContactMedium,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.ContactMedium = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.ContactMedium,
                        Description: "ContactMedium",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.ContactMedium = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.ContactMediuminfo = function (Id) {
            $scope.CMID = Id;
            $scope.Update = true;
            try {
                var item = $scope.ContactMediumdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.ContactMedium = item.Name;
            } catch (err) { }
        }

        $scope.EnquiryModeSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.EMID,
                        Name: $scope.vm.EnquiryMode,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.EnquiryMode = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.EnquiryMode,
                        Description: "EnquiryMode",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.EnquiryMode = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.EnquiryModeinfo = function (Id) {
            $scope.EMID = Id;
            $scope.Update = true;
            try {
                var item = $scope.EnquiryModedatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.EnquiryMode = item.Name;
            } catch (err) { }
        }

        $scope.BuildingTypeSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.BTID,
                        Name: $scope.vm.BuildingType,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.BuildingType = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.BuildingType,
                        Description: "BuildingType",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.BuildingType = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.BuildingTypeinfo = function (Id) {
            $scope.BTID = Id;
            $scope.Update = true;
            try {
                var item = $scope.BuildingTypedatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.BuildingType = item.Name;
            } catch (err) { }
        }

        $scope.RemarksSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/settings/update",
                    data: {
                        _id: $scope.RID,
                        Name: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.Remarks = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Update = false;
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/settings/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        Name: $scope.vm.Remarks,
                        Description: "Remarks",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.Remarks = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Remarksinfo = function (Id) {
            $scope.RID = Id;
            $scope.Update = true;
            try {
                var item = $scope.Remarksdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.Remarks = item.Name;
            } catch (err) { }
        }

        $scope.saveArea = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/areas/update",
                    data: {
                        _id: $scope.AID,
                        AreasName: $scope.vm.AreaName,
                        Areascode: $scope.vm.AreaCode,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    $scope.Update = false;
                    $scope.error1 = false;
                    ClearArea();
                    //$scope.vm.AreaName = '';
                    //$scope.vm.AreaCode = '';
                    RefreshAreaGrid();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/areas/add",
                    data: {
                        AreasName: $scope.vm.AreaName,
                        Areascode: $scope.vm.AreaCode,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing AreasName") {
                        $scope.error1 = true;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                        $scope.Update = false;
                        $scope.error1 = false;
                        ClearArea();
                        //$scope.vm.AreaName = '';
                        //$scope.vm.AreaCode = '';
                        RefreshAreaGrid();
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Emailsettinginfo = function (e, EmailsettingID) {
            $scope.ESID = EmailsettingID;
            $scope.Update = true;
            $scope.vm.EmailFrom = '';
            $scope.vm.EmailPassword = '';
            $scope.vm.EmailSMTP = '';
            $scope.vm.EnableSsl = '';
            $scope.vm.EmailPort = '';
            $scope.vm.EmailLicense = '';
            try {
                var item = $scope.Emailsettingdatas.filter(function (item) {
                    return item.id === EmailsettingID;
                })[0];
                $scope.id = item.id;
                $scope.vm.EmailFrom = item.EmailFrom;
                $scope.vm.EmailPassword = item.EmailPassword;
                $scope.vm.EmailSMTP = item.EmailSMTP;
                $scope.vm.EnableSsl = item.EnableSsl;
                $scope.vm.EmailPort = item.EmailPort;
                $scope.vm.EmailLicense = item.EmailLicense;
            } catch (e) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/crm/settings/emailsettingsPopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CRMSettingsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.EnableSSL = [
            { "name": "Yes" },
            { "name": "No" }];

        $scope.EmailSettingpopup = function (f) {
            $scope.vm.EmailFrom = "";
            $scope.vm.EmailPassword = "";
            $scope.vm.EmailSMTP = '';
            $scope.vm.EnableSsl = "Yes";
            $scope.vm.EmailPort = '';
            $scope.vm.EmailLicense = '';
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/crm/settings/emailsettingsPopup.html',
                parent: angular.element($document.body),
                targetEvent: f,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CRMSettingsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.EmailSettingadd = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/emailsetting/update",
                    data: {
                        _id: $scope.ESID,
                        EmailFrom: $scope.vm.EmailFrom,
                        EmailPassword: $scope.vm.EmailPassword,
                        EmailSMTP: $scope.vm.EmailSMTP,
                        EnableSsl: $scope.vm.EnableSsl,
                        EmailPort: $scope.vm.EmailPort,
                        EmailLicense: $scope.vm.EmailLicense,
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshEmailSetting();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/emailsetting/add",
                    data: {
                        Client_Id: Client_Id,
                        EmailFrom: $scope.vm.EmailFrom,
                        EmailPassword: $scope.vm.EmailPassword,
                        EmailSMTP: $scope.vm.EmailSMTP,
                        EnableSsl: $scope.vm.EnableSsl,
                        EmailPort: $scope.vm.EmailPort,
                        EmailLicense: $scope.vm.EmailLicense,
                        CreatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEmailSetting();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        function RefreshEmailSetting() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/emailsetting",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Emailsettingdata) {
                $scope.Emailsettingdatas = Emailsettingdata.data.data;
            });
        }

        $scope.EmailSetting = function () {
            RefreshEmailSetting()
        }

        $scope.Areainfo = function (Id) {
            $scope.AID = Id;
            $scope.Update = true;
            try {
                var item = $scope.Areadatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.AreaName = item.AreasName;
                $scope.vm.AreaCode = item.Areascode;
            } catch (err) { }
        }

        function ClearArea() {
            $scope.vm.AreaName = '';
            $scope.vm.AreaCode = '';
            $scope.qualificationform9.$setPristine();
            $scope.qualificationform9.$setUntouched();
        }

        $scope.cancelArea = function () {
            $scope.Update = false;
            ClearArea();
        }

        function RefreshGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/settings",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            });
            response.then(function (settingsdata) {
                $scope.Settingsdatas = settingsdata.data.data;
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'CreditTerm';
                    });
                    $scope.CreditTermdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'PaymentTerm';
                    });
                    $scope.PaymentTermdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'BillingFrequency';
                    });
                    $scope.BillingFrequencydatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'ScheduleFrequency';
                    });
                    $scope.ScheduleFrequencydatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'PaymentMode';
                    });
                    $scope.PaymentModedatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'JobTypes';
                    });
                    $scope.JobTypesdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'ContactMedium';
                    });
                    $scope.ContactMediumdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'EnquiryMode';
                    });
                    $scope.EnquiryModedatas = item;
                }
                catch (e) { }
                try {
                    debugger
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'BuildingType';
                    });
                    $scope.BuildingTypedatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'Remarks';
                    });
                    $scope.Remarksdatas = item;
                }
                catch (e) { }

            });
            $scope.Update = false;
        }

        $scope.DeleteSettings = function (id) {
            var response = $http({
                url: $rootScope.WebURL + "/settings/delete",
                method: "POST",
                data: { id: id },
            });
            response.then(function (Areadata) {
                RefreshGrid()
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));
            });
        }

        function RefreshAreaGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/areas",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            });
            response.then(function (Areadata) {
                $scope.Areadatas = Areadata.data.data;
            });
            $scope.Update = false;
        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('apps.crm.saleorder', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.saleorder', {
            url: '/WorkOrder',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/salesorder/saleorder.html',
                    controller: 'salesorderController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/salesorder');
    }

})();
(function () {
  "use strict";

  angular
    .module("apps.crm.saleorder")
    .controller("salesorderController", salesorderController)
    .filter('removeUploadsPath', replace_upload_path);


  /** @ngInject */
  function replace_upload_path() {
    return function (input) {
      if (!input) {
        return input;
      }
      else {
        return input.replace(/^.*Uploads[\\/]/, '');

      }
    };

  }

  /** @ngInject */
  function salesorderController(
    $scope,
    $interval,
    socket,
    $mdSidenav,
    $mdConstant,
    $mdToast,
    $http,
    $rootScope,
    $location,
    $mdDateLocale,
    $mdDialog,
    $document,
    $filter,
    NgMap,
    Upload,
    indexedDBService,
    DataSyncService,
    $timeout
  ) {
    document.getElementsByTagName("title")[0].text = "Customer Relationship-Treatment Instruction";
    var chkAceses = localStorage.getItem("pages");
    if (chkAceses.split(",").includes("WorkOrder")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }
    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    var EmpID = localStorage.getItem("EmployeeID");
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var vm = this;
    $scope.Salesform = false;
    $scope.Salesgrid = true;
    $scope.Export = true;
    $scope.Pageform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.uShowClosed = false;
    $scope.SpecialRem = "";
    // $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log("markers", map.markers);
      console.log("shapes", map.shapes);
    });

    vm.contactErrorMessage = false;

    $timeout(function () {
      var emailInput = angular.element(document.querySelector('[placeholder="Email"]'));
      var contactInput = angular.element(document.querySelector('[placeholder="Contact Number"]'));

      emailInput.on('blur', function () {
        var val = emailInput.val().trim();
        $scope.$apply(function () {
          vm.emailChipWarning = !!val;
        });
      });

      contactInput.on('blur', function () {
        var val = contactInput.val().trim();
        $scope.$apply(function () {
          vm.contactChipWarning = !!val;
        });
      });
    }, 500);

    $scope.transformChip = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    vm.onEmailChipAdd = function () {
      vm.emailChipWarning = false;
    };
    vm.onContactChipAdd = function () {
      vm.contactChipWarning = false;
    };

    vm.transformPhone = function (chip) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (regex.test(chip)) {
        vm.contactErrorMessage = false;
        return chip; // valid
      } else {
        vm.contactErrorMessage = true;
        return null; // invalid, will not be added
      }
    };

    vm.validateLive = function (input) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (!regex.test(input)) {
        vm.errorMessage = 'Invalid format. Use +60-123-4567-89';
      } else {
        vm.errorMessage = '';
      }
    };

    function getSalesOrderdata() {
      indexedDBService.getAll("work_order").then(function (data) {
        if (data && data.length > 0) {
          $scope.AllSalesOrderData = data;
          extract_salesorder_data($scope);
        } else GetEnquiryNumber();
      });
    }
    RefreshCustomerdatas();
    var dataGrid;
    vm.dataGridSales = {
      onInitialized: function (e) {
        dataGrid = e.component;
        getSalesOrderdata();
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.salesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },

        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "CreatedBy",
          caption: "Created By",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.CreatedBy.substring(0, 1).toUpperCase() +
              options.data.CreatedBy.substring(1) +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ServiceDate",
          caption: "Service Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        // { dataField: "Department", caption: "Company" },
        { dataField: "TotalPrice", caption: "Total Value" },
        {
          dataField: "Status",
          caption: "Status",
          cellTemplate: function (container, options) {
            if (options.data.Status == "New") {
              $(
                "<div class='label ng-binding ng-scope md-green-500-bg'>Pending</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Hold") {
              $(
                "<div class='label ng-binding ng-scope md-red-500-bg'>On-Hold</div>"
              ).appendTo(container);
            } else if (options.data.Status == "Completed") {
              $(
                "<div class='label ng-binding ng-scope md-purple-500-bg'>Completed</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On Going") {

              $(
                "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
              ).appendTo(container);
            }
            else if (options.data.Status == "Scheduled") {
              $(
                "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
              ).appendTo(container);
            }
            // else {
            //   $(
            //     "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
            //   ).appendTo(container);
            // }
          }
        },
        {
          caption: "Preview",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  var url =

                    $rootScope.ReportURL +
                    "WorkOrder.aspx" +
                    "?" +
                    "ID=" +
                    options.data.id;
                  window.open(url);
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       var url =
            //         
            //         $rootScope.ReportURL +
            //         "WorkOrder.aspx" +
            //         "?" +
            //         "ID=" +
            //         options.data.id +
            //         "&Type=Download";
            //       window.open(url);
            //     }
            //   })
            //   .appendTo(container);
          }
        },
        {
          caption: "Generate Calendar",
          fixed: true,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "columnchooser",
                disabled: options.data.Status === "New" ? true : false,
                onClick: function (e) {
                  var url =

                    $rootScope.ReportURL +
                    "Scheduler.aspx" +
                    "?" +
                    "ID=" +
                    options.data.id +
                    "&Department=" +
                    options.data.Department;
                  window.open(url);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "trash",
                disabled: options.data.Status != "New" ? true : false,
                onClick: function (e) {
                  $scope.DeleteWorkOrder(options.data._id);
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "salesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data.id);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    var dataGrid1;
    vm.dataGridAdhoc = {
      onInitialized: function (e) {
        dataGrid1 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.AdhocsalesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "CreatedBy",
          caption: "Created By",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.CreatedBy.substring(0, 1).toUpperCase() +
              options.data.CreatedBy.substring(1) +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        // { dataField: "Department", caption: "Company" },
        { dataField: "TotalPrice", caption: "Total Value" },

        {
          dataField: "Status",
          caption: "Status",
          cellTemplate: function (container, options) {
            if (options.data.Status == "New") {
              $(
                "<div class='label ng-binding ng-scope md-green-500-bg'>Pending</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Hold") {
              $(
                "<div class='label ng-binding ng-scope md-red-500-bg'>On-Hold</div>"
              ).appendTo(container);
            } else if (options.data.Status == "Completed") {
              $(
                "<div class='label ng-binding ng-scope md-purple-500-bg'>Completed</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Going") {
              $(
                "<div class='label ng-binding ng-scope md-blue-500-bg'>On-Going</div>"
              ).appendTo(container);
            } else {
              $(
                "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
              ).appendTo(container);
            }
          }
        },
        {
          caption: "Preview",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  var url =

                    $rootScope.ReportURL +
                    "WorkOrder.aspx" +
                    "?" +
                    "ID=" +
                    options.data.id;
                  window.open(url);
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       var url =
            //         
            //         $rootScope.ReportURL +
            //         "WorkOrder.aspx" +
            //         "?" +
            //         "ID=" +
            //         options.data.id +
            //         "&Type=Download";
            //       window.open(url);
            //     }
            //   })
            //   .appendTo(container);
          }
        },
        {
          caption: "Delete",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "trash",
                disabled: options.data.Status != "New" ? true : false,
                onClick: function (e) {
                  $scope.DeleteWorkOrder(options.data._id);
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "AdhocsalesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data.id);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    var dataGrid2;
    vm.dataGridWorkOrder = {
      onInitialized: function (e) {
        dataGrid2 = e.component;
        $scope.getDeletedWO();
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.DeletedSalesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "OrderType", caption: "Type" },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ServiceDate",
          caption: "Service Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        { dataField: "TotalPrice", caption: "Total Value" },
        // { dataField: "Department", caption: "Company" },
        {
          dataField: "UpdatedBy",
          caption: "Updated By",
          cellTemplate: function (container, options) {
            try {
              $(
                "<p style='color:black;cursor: default;'>" +
                options.data.UpdatedBy.substring(0, 1).toUpperCase() +
                options.data.UpdatedBy.substring(1) +
                "</p>"
              ).appendTo(container);
            } catch (error) {
              $(
                "<p style='color:black;cursor: default;'>" +
                options.data.UpdatedBy +
                "</p>"
              ).appendTo(container);
            }
          }
        },
        {
          dataField: "UpdatedDate",
          caption: "Updated Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          caption: "Revert",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "revert",
                disabled: false,
                onClick: function (e) {
                  $scope.RevertWorkOrder(options.data._id);
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "DeletedSalesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
      // onCellClick: function (data) {
      //     if (data.columnIndex == 1) {
      //         $scope.salesorderinfo(data.data); $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD)
      //     }
      // },
    };

    var dataGrid3;
    vm.dataGridCompletedWO = {
      onInitialized: function (e) {
        dataGrid3 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.CompletedWO,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "OrderType", caption: "Type" },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ServiceDate",
          caption: "Service Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        { dataField: "TotalPrice", caption: "Total Value" },
        // { dataField: "Department", caption: "Company" }
      ],
      bindingOptions: {
        dataSource: "CompletedWO",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    // unique ID for Attachment
    var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
    var pass = "";
    for (var x = 0; x < 6; x++) {
      var i = Math.floor(Math.random() * chars.length);
      pass += chars.charAt(i);
    }
    var UniqID = pass;

    $scope.ClearFilter = function () {
      $scope.uTo = null;
      $scope.uFrom = null;
      if (!_.isEmpty(httpservice.salesOrder.response)) {
        $scope.salesOrderdatas =
          httpservice.salesOrder.response.salesOrderdatas;
        $scope.workOrd = $scope.salesOrderdatas;
        $scope.AdhocsalesOrderdatas =
          httpservice.salesOrder.response.AdhocsalesOrderdatas;
      }
    };

    $scope.sAdd = function () {
      ClearForm();
      $scope.Commentdatas = [];
      $scope.CommentArray = [];
      $scope.Update = false;
      $scope.Salesform = true;
      $scope.Salesgrid = false;
      $scope.Export = false;
      $scope.EqUpdate = true;
      $scope.EUpdate = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.vm.AddSchedule = false;
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
      $scope.Search = false;
      $scope.vm.OrderType = "Contract";
      $scope.FrequencyArray = [];
      $scope.ArrayUploadfiles = [];
      $scope.Attachmentdatas = [];
      $scope.Frequencydatas = [];
      $scope.vm.Scheduled = "No";
      $scope.DisableServiceLocation = false;
      $scope.CustomerSServiceAddress = [];
      $scope.vm.SLocation = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.Occurence = null;
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
    };
    $scope.uTo = null;
    $scope.uFrom = null;

    $scope.vm.PreviewSpinner = false;

    $scope.Datefilter = function () {
      if (dataGrid != undefined) dataGrid.beginCustomLoading();
      $scope.contractdatas = [];
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getLengthbyDate",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "Contract",
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo
        }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url:
                  $rootScope.WebURL + "/salesOrder/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "Contract",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid != undefined) dataGrid.endCustomLoading();
                $scope.salesOrderdatas = GList.data.data;
                $scope.salesOrderdatas = _.uniqWith(
                  $scope.salesOrderdatas,
                  _.isEqual
                );
                $scope.workOrd = $scope.salesOrderdatas;
                $scope.vm.PreviewSpinner = false;
              });
            }
          } else {
            if (dataGrid != undefined) dataGrid.endCustomLoading();
            $scope.salesOrderdatas = [];
            $scope.salesOrderdatas = _.uniqWith(
              $scope.salesOrderdatas,
              _.isEqual
            );
            $scope.workOrd = $scope.salesOrderdatas;
            $scope.vm.PreviewSpinner = false;
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );

      // get for Ad-hoc WorkOrder
      if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getLengthbyDate",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "Ad-hoc",
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo
        }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url:
                  $rootScope.WebURL + "/salesOrder/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "Ad-hoc",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
                $scope.AdhocsalesOrderdatas = GList.data.data;
                $scope.AdhocsalesOrderdatas = _.uniqWith(
                  $scope.AdhocsalesOrderdatas,
                  _.isEqual
                );
              });
            }
          } else {
            dataGrid1.endCustomLoading();
            $scope.AdhocsalesOrderdatas = [];
            $scope.AdhocsalesOrderdatas = _.uniqWith(
              $scope.AdhocsalesOrderdatas,
              _.isEqual
            );
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );
    };

    $scope.Showgrid = function () {
      $scope.Salesgrid = true;
      $scope.Salesform = false;
      $scope.Pageform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
    };

    $scope.salesorderinfo = function (id, $index) {
      $scope.Update = true;
      $scope.vm.BContactPerson = null;
      $scope.EUpdate = false;
      $scope.Salesform = true;
      $scope.Salesgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.SID = id;
      $scope.vm.emailValidationError = false

      $http({
        url: $rootScope.WebURL + "/salesOrder/getSalesoderbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var item = List.data.data[0];
        if (item.Status != "New") $scope.EUpdate = true;

        $scope.File_id = item._id;
        $scope.Add = false;
        $scope.Search = false;
        $scope.IndexID = $index;
        $scope.FrequencyArray = [];
        $scope.ServiceAddressarray = [];
        $scope.vm.OrderConfirmationDate = item.OrderConfirmationDate;
        $scope.vm.SalesOrderNo = item.SalesOrderNo;
        if (
          $scope.vm.OrderConfirmationDate != null &&
          $scope.vm.OrderConfirmationDate != ""
        ) {
          $scope.vm.OrderConfirmationDate = new Date(
            item.OrderConfirmationDate
          );
        }
        var Email = item.SiteEmail;
        if (Email != "" && Email != undefined && Email != null)
          $scope.vm.SiteEmail = item.SiteEmail.split(",");
        else $scope.vm.SiteEmail = [];
        $scope.vm.SContactPerson = item.SiteContactPerson;
        $scope.vm.SalesPerson = item.SalesPerson_id;
        $scope.vm.EnquiryReferenceNo = item.EnquiryReferenceNo;
        $scope.vm.ContractNo = item.ContractNo;
        $scope.vm.ContactPerson = item.ContactPerson;
        $scope.vm.CustomerName = item.Customer_id;
        $scope.vm.Occurence = item.EnqRef;
        $scope.vm.SpecialChemical = item.SpecialChemical;
        $scope.vm.PreferredTime = item.PreferredTime;
        $scope.vm.Message = item.Message;
        try {
          var value = $scope.Customerdatas.filter(function (value) {
            return value._id === item.Customer_id;
          })[0];
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === item.Customer_id;
          });
          $scope.Leaddatas = litem;
        } catch (error) { }

        try {
          var value = $scope.Leaddatas.filter(function (value) {
            return value.LeadReferenceNo === $scope.vm.EnquiryReferenceNo;
          })[0];
          if (value != undefined) {
            $scope.EqUpdate = true;
          } else $scope.EqUpdate = false;
        } catch (error) { }

        $scope.vm.ServiceStartDate = item.ServiceStartDate;
        if (
          $scope.vm.ServiceStartDate != null &&
          $scope.vm.ServiceStartDate != ""
        ) {
          $scope.vm.ServiceStartDate = new Date(item.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
        $scope.vm.ServiceEndDate = item.ServiceEndDate;
        if (
          $scope.vm.ServiceEndDate != null &&
          $scope.vm.ServiceEndDate != ""
        ) {
          $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
        }

        if (
          item.CustomerID != undefined &&
          item.CustomerID != null &&
          item.CustomerID != ""
        ) {
          var array = [];
          array.push({ SegmentName: item.CustomerID });
          $scope.vm.SLocation = item.CustomerID;
          $scope.DisableServiceLocation = true;
        } else $scope.DisableServiceLocation = false;
        $scope.vm.SName = item.SiteName;
        $scope.vm.CreatedDate = item.CreatedDate;
        $scope.vm.CreatedBy = item.CreatedBy;
        $scope.vm.SContactNo = item.SiteContactNo;
        if (
          item.SiteContactNo != null &&
          item.SiteContactNo != undefined &&
          item.SiteContactNo != ""
        )
          $scope.vm.SiteContactNo = item.SiteContactNo.split(",");
        else $scope.vm.SiteContactNo = [];
        if (
          item.Mobile != null &&
          item.Mobile != undefined &&
          item.Mobile != ""
        )
          $scope.vm.BContactNo = item.Mobile.split(",").splice(0, 2);
        else $scope.vm.BContactNo = [];
        if (item.Email != "" && item.Email != undefined && item.Email != null)
          $scope.vm.BEmail = item.Email.split(",");
        else $scope.vm.BEmail = [];
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.OrderType = item.OrderType;
        $scope.vm.TotalSum = parseInt(item.TotalSum);
        $scope.vm.CoverageArea = item.CoverageArea;
        $scope.vm.PurchaseOrderNo = item.PurchaseOrderNo;
        $scope.vm.IsUrgent = item.IsUrgent;
        $scope.vm.Department = item.Department;
        if ($scope.vm.IsUrgent == true) $scope.vm.IsUrgent = "true";
        else $scope.vm.IsUrgent = "false";
        $scope.vm.TrendingReport = item.TrendingReport;
        if ($scope.vm.TrendingReport == true) $scope.vm.TrendingReport = "true";
        else $scope.vm.TrendingReport = "false";
        $scope.vm.DateTimeofTreatment = item.DateTimeofTreatment;
        $scope.vm.Message = item.SpecialRemarks;
        $scope.vm.PaymentMode = item.PaymentMode;
        $scope.vm.PestType = item.PestType;
        if (
          $scope.vm.PestType != null &&
          $scope.vm.PestType != "" &&
          $scope.vm.PestType != undefined
        ) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (item) {
            array1.push({ PestName: item });
          });
          $scope.vm.PestType = array1;
        }
        $scope.vm.Treatment = item.Treatment;
        if (
          $scope.vm.Treatment != null &&
          $scope.vm.Treatment != "" &&
          $scope.vm.Treatment != undefined
        ) {
          var array = $scope.vm.Treatment.split(",");
          var array1 = [];
          angular.forEach(array, function (item) {
            array1.push({ TreatmentName: item });
          });
          $scope.vm.Treatment = array1;
        }
        $scope.Frequencydatas = item.MultiFrequency;
        $scope.vm.BillingFrequency = item.BillingFrequency;
        $scope.vm.Types = item.Types;
        $scope.vm.JobsPerFrequency = parseInt(item.JobsPerFrequency);
        $scope.vm.ServicesRequired = parseInt(item.ServicesRequired);
        $scope.vm.EstimatedHoursRequired = parseFloat(
          item.EstimatedHoursRequired
        );
        $scope.vm.RemarksFinance = item.RemarksFinance;
        $scope.vm.TotalPrice = parseFloat(item.TotalPrice);
        $scope.vm.Message = item.Message;
        $scope.vm.TotalTripsPerYear = parseInt(item.TotalTripsPerYear);
        $scope.vm.BAddress = null;
        $scope.vm.CreditTerm = item.CreditTerm
        getBillingAddress(item.BillingAddress);
        RefreshAttachmentGrid();
        RefreshComments($scope.SID);
        getPaymentFrequencydata($scope.SID)
      });
    };

    $scope.getPerMonth = function (value) {
      $scope.Month = "";
      if (value == "COD") $scope.Month = "COD";
      if (value == "Monthly") $scope.Month = "Per Month";
      if (value == "Weekly") $scope.Month = "Per Week";
      if (value == "Quarterly") $scope.Month = "Per Quarter";
      if (value == "Yearly") $scope.Month = "Per Year";
      if (value == "Half Yearly (2)") $scope.Month = "Twice Year";
      if (value == "Quarterly") $scope.Month = "Per Quarter";
      if (value == "Bi Monthly (6)") $scope.Month = "Bimonthly";
    };
    function getBillingAddress(BillingId) {
      var response = $http({
        url:

          $rootScope.WebURL +
          "/customerService/getcustomerserviceaddressdetailsbyID",
        method: "POST",
        data: { _id: BillingId }
      });
      response.then(function (CustomerBillingdata) {
        var CustomerBillingdatas = CustomerBillingdata.data.data;
        if (CustomerBillingdatas.length > 0) {
          $scope.vm.BAddress =
            CustomerBillingdatas[0].bStreetName +
            " " +
            CustomerBillingdatas[0].bPostal;
          if (
            $scope.vm.BContactPerson == undefined ||
            $scope.vm.BContactPerson == null
          )
            $scope.vm.BContactPerson = CustomerBillingdatas[0].bContactPerson;
        }
      });
    }

    $scope.DeleteWorkOrder = function (ID) {
      $scope.DelID = ID;
      var result = DevExpress.ui.dialog.confirm(
        "Do you want to delete the WorkOrder?",
        "Confirm changes"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          var resp = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/salesOrder/delete",
            data: { _id: $scope.DelID, UpdatedBy: $rootScope.createdby }
          });
          resp.then(
            function (Gli) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Work Order Deleted Successfully!")
                  .position("top center")
              );

              // $rootScope.$broadcast('Delete WorkOrder', { data:$scope.DelID});
              // $scope.salesorderinfo(data.data.SalesOrderID); $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD)
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      });
    };

    $scope.RevertWorkOrder = function (ID) {
      $scope.RevID = ID;
      var result = DevExpress.ui.dialog.confirm(
        "Do you want to revert the WorkOrder?",
        "Confirm changes"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          var resp = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/salesOrder/revert",
            data: { _id: $scope.RevID, UpdatedBy: $rootScope.createdby }
          });
          resp.then(
            function (Gli) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Work Order Reverted Successfully!")
                  .position("top center")
              );
              $scope.getDeletedWO();
              DataSyncService.getSalesOrderById($scope.RevID).then(function (
                List
              ) {
                indexedDBService
                  .addAll("work_order", List.data.data)
                  .then(function (Glist) {
                    $rootScope.$broadcast(
                      "salesOrder_created",
                      List.data.data[0]
                    );
                  });
              });
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      });
    };

    $scope.sSubmit = function () {
      if ($scope.totalPercentage > 0 && $scope.totalPercentage < 100) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Total Payment Percentage has to reach 100%. It is currently " + parseInt($scope.totalPercentage) + "%"
            )
            .position("top center")
        );
        return
      }
      var salesOrderArray = [];
      if (
        $scope.Frequencydatas != null &&
        $scope.Frequencydatas != "" &&
        $scope.Frequencydatas != undefined
      ) {
        $scope.vm.Frequency = $scope.Frequencydatas.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        $scope.vm.PestType = $scope.Frequencydatas.map(function (obj) {
          return obj.PestType;
        }).join(",");
        $scope.vm.Treatment = $scope.Frequencydatas.map(function (obj) {
          return obj.Treatment;
        }).join(",");
        $scope.vm.JobsPerFrequency = $scope.Frequencydatas.map(function (obj) {
          return obj.JobsPerFrequency;
        }).join(",");
        $scope.vm.ServicesRequired = $scope.Frequencydatas.map(function (obj) {
          return obj.ServicesRequired;
        }).join(",");
      }
      angular.forEach($scope.Frequencydatas, function (value) {
        if (
          value.JobsPerFrequency == null &&
          value.JobsPerFrequency == undefined &&
          value.ServicesRequired == null &&
          value.ServicesRequired == undefined
        ) {
          salesOrderArray.push(1);
        }
      });
      if (salesOrderArray.length > 0)
        return $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please Add Jobs Per Frequency and Services Required for Treatment Frequency!"
            )
            .position("top center")
        );
      if (Array.isArray($scope.vm.BEmail)) {
        $scope.vm.BEmail = $scope.vm.BEmail.join(",");
      }
      if (Array.isArray($scope.vm.SiteEmail)) {
        $scope.vm.SiteEmail = $scope.vm.SiteEmail.join(",");
      }
      if (Array.isArray($scope.vm.SiteContactNo)) {
        $scope.vm.SiteContactNo = $scope.vm.SiteContactNo.join(",");
      }
      if (Array.isArray($scope.vm.BContactNo)) {
        $scope.vm.BContactNo = $scope.vm.BContactNo.join(",");
      }

      if ($scope.vm.OrderType == "Ad-hoc") {
        $scope.vm.ContractNo = null;
        $scope.vm.ServiceStartDate = null;
        $scope.vm.ServiceEndDate = null;
        $scope.vm.TotalTripsPerYear = null;
      }
      if ($scope.vm.IsUrgent == "true") $scope.vm.IsUrgent = true;
      else $scope.vm.IsUrgent = false;

      if ($scope.vm.TrendingReport == "true") $scope.vm.TrendingReport = true;
      else $scope.vm.TrendingReport = false;
      if ($scope.Update == true) {
        // if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
        //     $scope.vm.PestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
        // }
        // if ($scope.vm.Scopeofwork != null && $scope.vm.Scopeofwork != "" && $scope.vm.Scopeofwork != undefined) {
        //     $scope.vm.Scopeofwork = $scope.vm.Scopeofwork.map(function (obj) { return obj.Scopeofwork; }).join(',');
        // }
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/salesOrder/update",
          data: {
            _id: $scope.SID,
            EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
            SalesPerson_id: $scope.vm.SalesPerson,
            ContractNo: $scope.vm.ContractNo,
            Customer_id: $scope.vm.CustomerName,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            OrderType: $scope.vm.OrderType,
            TotalSum: $scope.vm.TotalSum,
            PaymentMode: $scope.vm.PaymentMode,
            BillingFrequency: $scope.vm.BillingFrequency,
            EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
            CreditTerm: $scope.vm.CreditTerm,
            RemarksFinance: $scope.vm.RemarksFinance,
            CoverageArea: $scope.vm.CoverageArea,
            PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
            IsUrgent: $scope.vm.IsUrgent,
            EnqRef: $scope.vm.Occurence,
            TrendingReport: $scope.vm.TrendingReport,
            Department: $scope.vm.Department,
            DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
            TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
            SpecialRemarks: $scope.vm.Message,
            TotalPrice: $scope.vm.TotalPrice,

            Frequency: $scope.vm.Frequency,
            PestType: $scope.vm.PestType,
            SiteName: $scope.vm.SName,
            SiteContactNo: $scope.vm.SiteContactNo,
            Mobile: $scope.vm.BContactNo,
            Email: $scope.vm.BEmail,
            SiteContactPerson: $scope.vm.SContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            MultiFrequency: $scope.Frequencydatas,
            ServicesRequired: $scope.vm.ServicesRequired,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            Treatment: $scope.vm.Treatment,
            SpecialChemical: $scope.vm.SpecialChemical,
            PreferredTime: $scope.vm.PreferredTime,
            UpdatedBy: $rootScope.createdby,
            Message: $scope.vm.Message
          }
        });
        response.then(
          function (GList) {
            submitPaymentFrequencytoDB($scope.SID)
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Updated!")
                .position("top center")
            );
            $scope.Salesgrid = true;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.Update = false;
            // $rootScope.$broadcast('Update WorkOrder', { data:$scope.SID});
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var salesOrderArray = [];
        angular.forEach($scope.vm.SLocation, function (Lis) {
          var Email = [];
          Email.push($scope.vm.CustomerArray.Email);
          Email.push($scope.BillingArray.bEmail);
          Email.push(Lis.sEmail);
          Email.push(Lis.sCC);
          Email = Email.map(function (o) {
            return o;
          }).join(",");
          salesOrderArray.push({
            MultiFrequency: $scope.Frequencydatas,
            SalesPerson_id: $scope.vm.SalesPerson,
            ContractNo: $scope.vm.ContractNo,
            Customer_id: $scope.vm.CustomerName,
            EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
            OrderConfirmationDate: $scope.vm.OrderConfirmationDate,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            OrderType: $scope.vm.OrderType,
            TotalSum: $scope.vm.TotalSum,
            PaymentMode: $scope.vm.PaymentMode,
            EnqRef: $scope.vm.Occurence,
            BillingFrequency: $scope.vm.BillingFrequency,
            EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
            CreditTerm: $scope.vm.CreditTerm,
            RemarksFinance: $scope.vm.RemarksFinance,
            CoverageArea: $scope.vm.CoverageArea,
            PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
            IsUrgent: $scope.vm.IsUrgent,
            TrendingReport: $scope.vm.TrendingReport,
            Department: $scope.vm.Department,
            DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
            TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
            SpecialRemarks: $scope.vm.Message,
            CreatedBy: $rootScope.createdby,
            Client_Id: $rootScope.Client_Id,
            TotalPrice: $scope.vm.TotalPrice,
            PestType: $scope.vm.PestType,
            Frequency: $scope.vm.Frequency,
            Treatment: $scope.vm.Treatment,
            CustomerID: Lis._id,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            SiteName: $scope.vm.SName,
            SiteContactNo: $scope.vm.SContactNo,
            SiteContactPerson: $scope.vm.SContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            Mobile: $scope.vm.BContactNo,
            Email: $scope.vm.BEmail,
            CommentArray: $scope.CommentArray,
            BillingAddress: $scope.vm.BAddressId,
            SpecialChemical: $scope.vm.SpecialChemical,
            PreferredTime: $scope.vm.PreferredTime,
            Message: $scope.vm.Message,
            SchedulerEmail: Email,
            UniqID: UniqID
          });
        });
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder/addbyArray",
          data: { salesOrderArray: salesOrderArray }
        });
        response.then(function (List) {
          // $rootScope.$broadcast('Add WorkOrder', { data:List.data.data});
          var sales_ids = List.data.data
          sales_ids.forEach(function (id) {
            submitPaymentFrequencytoDB(id)
          })

          $scope.CommentArray = [];
          $scope.Commentdata = [];
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Added!")
              .position("top center")
          );
          $scope.Salesgrid = true;
          $scope.Salesform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;
          $scope.FrequencyArray = [];
          $scope.CustomerServicedatas = [];
          $scope.ServiceAddressarray = [];
          $scope.vm.AddSchedule = false;
          // GetEnquiryNumber()
          // GetEnquiryNumber();
          // $scope.Datefilter();
        });
      }
    };

    $scope.DaysCalc = function (CED) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ContractStartDate);
        var secondDate = new Date($scope.vm.ContractEndDate);
        $scope.vm.ContractDuration =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
      } catch (e) { }
    };
    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.getLeaddetails = function (CustomerID) {
      try {
        var litem = $scope.Leaddetails.filter(function (litem) {
          return litem.CustomerID === CustomerID;
        });
        $scope.Leaddatas = litem;
      } catch (error) { }
      if ($scope.Leaddatas.length != 0) {
        $scope.vm.EnquiryReferenceNo =
          $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
        $scope.vm.TotalPrice = parseFloat(
          $scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue
        );
        if ($scope.vm.OrderType == "Ad-hoc") {
        } else {
          try {
            var item = $scope.contractdatas.filter(function (item) {
              return item._id === $scope.vm.ContractNo;
            })[0];
            $scope.vm.TotalPrice = parseFoat(item.ContractValue);
            $scope.vm.EnquiryReferenceNo = item.EnquiryID;
          } catch (error) { }
        }
      }
    };

    $scope.GetLead = function (CustomerID, RequestID) {
      CustomerBillingdatadetails(RequestID);
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getContractByCustomer",
        data: { Customer_id: CustomerID }
      }).then(function (contractdata) {
        $scope.contractdatas = contractdata.data.data;
        try {
          if ($scope.Update !== true) {
            $scope.vm.ContractNo =
              $scope.contractdatas[$scope.contractdatas.length - 1]._id;
            $scope.getFrequencyTable($scope.contractdatas[$scope.contractdatas.length - 1])
            if ($scope.vm.OrderType == "Contract") {
              $scope.vm.ServiceStartDate = new Date(
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].ServiceStartDate
              );
              $scope.vm.ServiceEndDate = new Date(
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].ServiceEndDate
              );
              // $scope.vm.TotalPrice = parseFloat(
              //   $scope.contractdatas[$scope.contractdatas.length - 1]
              //     .ContractValue
              // );
              // $scope.vm.BillingFrequency =
              //   $scope.contractdatas[
              //     $scope.contractdatas.length - 1
              //   ].BillingFrequency;
              $scope.Frequencydatas =
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].MultiFrequency;
              $scope.vm.EnquiryReferenceNo =
                contractdata.data.data[0].EnquiryID;
              $scope.vm.BAddressId =
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].BillingAddress;
              var Mobile = contractdata.data.data[0].SiteContact;
              if (Mobile != null && Mobile != "" && Mobile != undefined)
                $scope.vm.SiteContactNo = Mobile.split(",");
              else $scope.vm.SiteContactNo = [];
              $scope.vm.SContactPerson =
                contractdata.data.data[0].SiteContactPerson;
              $scope.vm.SName = contractdata.data.data[0].SiteName;
              var Email = contractdata.data.data[0].SiteName;
              if (Email != "" && Email != undefined && Email != null)
                $scope.vm.SiteEmail = Email.split(",");
              else $scope.vm.SiteEmail = [];
              angular.forEach($scope.Frequencydatas, function (item) {
                item.JobsPerFrequency = 1;
                $scope.calculateServices(item.Frequency, item.JobsPerFrequency);
                item.ServicesRequired = $scope.vm.ServicesRequired;
              });
            } else $scope.Frequencydatas = [];
          }
        } catch (e) {
          $scope.vm.ContractNo = null;
        }
      });
    };
    function CustomerBillingdatadetails(Requestid) {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerBillingdata) {
        var CustomerBillingdatas = CustomerBillingdata.data.data;
        $scope.CustomerBBilingAddres = CustomerBillingdatas;
        if (CustomerBillingdatas.length > 0) {
          $scope.BillingArray = CustomerBillingdatas[0];
          $scope.vm.BAddress =
            CustomerBillingdatas[0].bStreetName +
            " " +
            CustomerBillingdatas[0].bPostal;
          if (
            $scope.vm.BContactPerson == undefined ||
            $scope.vm.BContactPerson == null
          )
            $scope.vm.BContactPerson = CustomerBillingdatas[0].bContactPerson;

          // $scope.vm.BContactNo = CustomerBillingdatas[0].bMobile;
          // $scope.vm.BEmail = CustomerBillingdatas[0].sEmail;
        }
      });
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerServicedata) {
        var CustomerServicedatas = CustomerServicedata.data.data;
        $scope.CustomerSServiceAddress = CustomerServicedata.data.data;
        if (CustomerServicedatas.length > 0) {
          // $scope.vm.SLocation = CustomerServicedatas[0].sStreetName;
          $scope.vm.SContactPerson = CustomerServicedatas[0].sContactPerson;
          // if ($scope.vm.SContactNo == null || $scope.vm.SContactNo == "" || $scope.vm.SContactNo == undefined)
          var contactNumber = CustomerServicedatas[0].sMobile;
          if (
            contactNumber != "" &&
            contactNumber != null &&
            contactNumber != undefined
          )
            contactNumber = contactNumber.split(",");
          $scope.vm.SContactNo = contactNumber;
          // if ($scope.vm.SName == null || $scope.vm.SName == "" || $scope.vm.SName == undefined)
          $scope.vm.SName = CustomerServicedatas[0].sName;
        }
      });
    }
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $scope.Days = [
      { id: 0, Name: "Sunday" },
      { id: 1, Name: "Monday" },
      { id: 2, Name: "Tuesday" },
      { id: 3, Name: "Wednesday" },
      { id: 4, Name: "Thursday" },
      { id: 5, Name: "Friday" },
      { id: 6, Name: "Saturday" }
    ];
    $scope.AllSASelec = { value: false };
    $scope.SASelec = { value: false };
    $scope.svAll = { value: false };

    // Add Frequency
    $scope.FrequencyArray = [];
    $scope.AddFrequency = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/addfrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.MultiPestTypes = null;
      $scope.vm.MultiFrequency = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.TotalPrice = null;
      $scope.UpdateFrequency = false;
      $scope.vm.Scheduled = "No";
      $scope.vm.Types = null;
      $scope.vm.JobsPerFrequency = 1;
    };
    $scope.Adelete = function (e, AttachmentdeleteID, datas) {
      if ($scope.Update == false) {
        var index = $scope.Attachmentdatas.indexOf(datas);
        $scope.Attachmentdatas.splice(index, 1);
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/attachment/delete",
          data: { _id: AttachmentdeleteID }
        });
        response.then(
          function (GList) {
            RefreshAttachmentGrid();
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Deleted!")
                .position("top center")
            );
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };
    $scope.Uploadfiles = function (file) {
      if ($scope.Update == false) {
        angular.forEach(file, function (item) {
          var upfile = item.file;
          var response = Upload.upload({
            url: $rootScope.WebURL + "/salesOrder/upload",
            data: { file: upfile }
          }).then(
            function (resp) {
              $scope.TableID = resp.data.data[0].GUIDFILENAME;
              $scope.fileName = resp.data.data[0].OriginalFileName;
              $scope.fileSize = resp.data.data[0].Size;
              $scope.Path = resp.data.data[0].Path;
              $scope.fileType = resp.data.data[0].Type;
              if (resp.data.message == "Successfully Uploaded") {
                var response = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/attachment/add",
                  data: {
                    TableID: $scope.TableID,
                    TableName: "Sales Order",
                    FileID: UniqID,
                    FileName: $scope.fileName,
                    FileSize: $scope.fileSize,
                    FileType: $scope.fileType,
                    ModuleID: $scope.Path,
                    Data: null,
                    IsActive: "true",
                    CreatedBy: $rootScope.createdby
                  }
                });
                response.then(
                  function (GList) {
                    RefreshAttachmentGrid();
                  },
                  function () {
                    $mdToast.show(
                      $mdToast
                        .simple()
                        .textContent(
                          "Something entered gone wrong,please try again !"
                        )
                        .position("top center")
                    );
                  }
                );
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        });
        file[0].cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Added!")
            .position("top center")
        );
      } else {
        angular.forEach(file, function (item) {
          var upfile = item.file;
          var response = Upload.upload({
            url: $rootScope.WebURL + "/salesOrder/upload",
            data: { file: upfile }
          }).then(
            function (resp) {
              $scope.TableID = resp.data.data[0].GUIDFILENAME;
              $scope.fileName = resp.data.data[0].OriginalFileName;
              $scope.fileSize = resp.data.data[0].Size;
              $scope.Path = resp.data.data[0].Path;
              $scope.fileType = resp.data.data[0].Type;
              if (resp.data.message == "Successfully Uploaded") {
                var response = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/attachment/add",
                  data: {
                    TableID: $scope.TableID,
                    TableName: "Sales Order",
                    FileID: $scope.File_id,
                    FileName: $scope.fileName,
                    FileSize: $scope.fileSize,
                    FileType: $scope.fileType,
                    ModuleID: $scope.Path,
                    Data: null,
                    IsActive: "true",
                    CreatedBy: $rootScope.createdby
                  }
                });
                response.then(
                  function (GList) {
                    RefreshAttachmentGrid();
                  },
                  function () {
                    $mdToast.show(
                      $mdToast
                        .simple()
                        .textContent(
                          "Something entered gone wrong,please try again !"
                        )
                        .position("top center")
                    );
                  }
                );
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        });
        file[0].cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Added!")
            .position("top center")
        );
      }
    };
    $scope.Frequencydatas = [];
    $scope.FrequencyClass = function () {
      var array = [];
      try {
        angular.forEach($scope.ScheduleFrequencydatas, function (value) {
          var item = $scope.Frequencydatas.filter(function (item) {
            return value.Name == item.Frequency;
          })[0];
          if (item == undefined) {
            array.push(value);
          }
        });
        $scope.ScheduleFrequencydatas = array;
      } catch (e) { }
    };
    $scope.AddPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.PestUpdate = false;
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.Treatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.Editpest = function (e, Pestdata) {
      RefreshTreatment();
      $scope.PestUpdate = true;
      $scope.vm.Frequency = Pestdata.Frequency;
      $scope.vm.JobsPerFrequency = Pestdata.JobsPerFrequency;
      $scope.vm.ServicesRequired = Pestdata.ServicesRequired;
      $scope.vm.PestType = Pestdata.PestType;
      $scope.vm.ServiceTrap = Pestdata.ServiceTrap;
      //   $scope.vm.SelectPest =  Pestdata.PestType;
      // if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
      //     var array = $scope.vm.PestType.split(",");
      //     var array1 = [];
      //     angular.forEach(array, function (value) {
      //         array1.push({ PestName: value });
      //     });
      //     $scope.vm.PestType = array1;
      // }
      $scope.ForAlternateWeek($scope.vm.Frequency);
      // $scope.vm.SelectPest = $scope.vm.PestType
      $scope.vm.EPesttype = $scope.vm.PestType;
      $scope.ChangeTreatment(Pestdata);
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.Pestdata = Pestdata;
      $scope.vm.JobsPerFrequency = $scope.vm.JobsPerFrequency || 1;
      $scope.calculateServices($scope.vm.Frequency, $scope.vm.JobsPerFrequency);
      // $scope.Treatmentpopupdata = []
      // $scope.Treatmentpopupdata = [Pestdata];
      // var array = [];
      // var item1 = $scope.Treatmentdatas.filter(function (item1) {
      //     if (item1.PestType.indexOf(Pestdata.PestType) > -1) {
      //         array.push({ TreatmentName: item1.TreatmentName });
      //     }
      // });
      // $scope.Treatmentpopupdata=[]
      // $scope.Treatmentpopupdata.push({PestName:Pestdata.PestType,Treatment: array})
    };
    $scope.ChangeTreatment = function (Pestdata) {
      $scope.Treatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.Treatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        var OthersSelect = false;
        var ServiceTypeSelect = false;
        if (Pestdata.Others !== undefined) {
          OthersSelect = true;
        } else {
          OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          ServiceTypeSelect = true;
        } else {
          ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.Treatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          SelectServiceTrap: ServiceTypeSelect
        });
      }
    };
    $scope.SubmitPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.Treatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        var ServiceTrap = item.ServiceTrap;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }

        array = $scope.Frequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });
        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }
        if (OthersTreatment != undefined && Treatmentarray != "") {
          if (Treatmentarray != null) {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        $scope.EditFrequency = true;
        if (array.length == 0) {
          $scope.Frequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].JobsPerFrequency = $scope.vm.JobsPerFrequency;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServicesRequired = $scope.vm.ServicesRequired;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
          $scope.EditFrequency == false;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      if ($scope.Frequencydatas.length > 0) {
        var num = _.maxBy($scope.Frequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }
      $mdDialog.hide();
    };
    $scope.closepest = function () {
      $mdDialog.hide();
      $scope.Pestdata = null;
    };
    $scope.Deletepest = function (DeleteItem) {
      var index = $scope.Frequencydatas.indexOf(DeleteItem);
      $scope.Frequencydatas.splice(index, 1);
      RefreshSchedulerFrequency();
    };

    $scope.PaymentFrequencyData = []

    $scope.AddPayment = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/AddPaymentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.PaymentDate = null
      $scope.vm.PaymentPercentage = null
      $scope.vm.PaymentFrequencyMode = null
      $scope.vm.PaymentRemarks = null
      $scope.updatedPaymentFreqId = null
    }


    $scope.SubmitPaymentFrequency = function () {
      $scope.totalPercentage = 0
      var _id = null
      if ($scope.updatedPaymentFreqId) {
        _id = $scope.updatedPaymentFreqId
        angular.forEach($scope.PaymentFrequencyData, function (data) {
          if (data._id == _id) {
            data.Date = new Date($scope.vm.PaymentDate)
            data.Percentage = $scope.vm.PaymentPercentage
            data.PaymentMode = $scope.vm.PaymentFrequencyMode
            data.Remarks = $scope.vm.PaymentRemarks
            return
          }
        })
      }

      else {
        _id = parseInt($scope.PaymentFrequencyData.length) + 1
        $scope.PaymentFrequencyData.push({
          _id: _id,
          Date: new Date($scope.vm.PaymentDate),
          Percentage: $scope.vm.PaymentPercentage,
          PaymentMode: $scope.vm.PaymentFrequencyMode,
          Remarks: $scope.vm.PaymentRemarks
        })
      }



      for (var index = 0; index < $scope.PaymentFrequencyData.length; index++) {
        $scope.totalPercentage += parseInt($scope.PaymentFrequencyData[index].Percentage)
      }
      if ($scope.totalPercentage > 100) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Total Percentage of Payment exceeded 100%")
            .position("top center")
        );
        if (!$scope.updatedPaymentFreqId)
          $scope.PaymentFrequencyData.pop()
        return
      }
      $mdDialog.hide();

    }

    $scope.EditPaymentFrequency = function (e, data) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/AddPaymentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.updatedPaymentFreqId = data._id
      $scope.vm.PaymentDate = new Date(data.Date)
      $scope.vm.PaymentPercentage = parseInt(data.Percentage)
      $scope.vm.PaymentFrequencyMode = data.PaymentMode
      $scope.vm.PaymentRemarks = data.Remarks
    }

    function submitPaymentFrequencytoDB(id) {
      $scope.PaymentFrequencyData.forEach(function (data) {
        $http({
          method: "PUT",
          url: $rootScope.WebURL + "/paymentfrequencywo/update",
          data: {
            _id: data._id,
            Percentage: data.Percentage,
            PaymentMode: data.PaymentMode,
            SalesOrderId: id,
            Date: data.Date,
            Remarks: data.Remarks,
            UpdatedBy: $rootScope.CreatedBy,
            CreatedBy: $rootScope.CreatedBy
          }
        });
      });
    }

    function getPaymentFrequencydata(id) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/paymentfrequencywo/getByID",
        data: {
          ID: id,
        }
      }).then(function (GList) {
        $scope.PaymentFrequencyData = GList.data.data
        $scope.totalPercentage = $scope.PaymentFrequencyData.reduce(function (acc, v) {
          return acc + v.Percentage;
        }, 0);
      })
    }

    $scope.DeletePaymentFrequency = function (indx, data) {
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure, you want to delete ? <b>",

        "Delete Confirmation!"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          if (!isNaN(data._id)) {
            // do nothing
          }
          else {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/paymentfrequencywo/delete",
              data: {
                _id: data._id,
              }
            })
          }

          $scope.PaymentFrequencyData.splice(indx, 1);
          $scope.totalPercentage = $scope.PaymentFrequencyData.reduce(function (acc, v) {
            return acc + v.Percentage;
          }, 0);
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Deleted successfully!")
              .position("top center")
          );


        }
      })
    }
    //end Frequency
    var applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately"
      },
      {
        key: "onClick",
        name: "On Button Click"
      }
    ];

    $scope.copymain = function ($scope) {
      if ($scope.Servicecopy.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.usBLK = "";
        $scope.vm.usName = $scope.vm.uCompanyName;
        $scope.vm.usContactPerson = $scope.vm.uFirstName;
        $scope.vm.usUnit = $scope.vm.StreetName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.usPostal = $scope.vm.uPostal;
        }
        $scope.vm.usCountry = $scope.vm.uCountry;
        $scope.vm.usBuildingName = $scope.vm.BuildingName;
        $scope.vm.usStreetName = $scope.vm.StreetName;
        $scope.vm.usMobile = [];
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != undefined &&
          $scope.vm.uMobile != ""
        )
          $scope.vm.usMobile = $scope.vm.uMobile;
        if (
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.ZoneCC = $scope.vm.uEmail;

        $scope.vm.ZoneEmail = [];

        if (
          $scope.vm.usContactPerson == "" ||
          $scope.vm.usContactPerson == null ||
          $scope.vm.usContactPerson == undefined
        ) {
          try {
            var item = $scope.CustomerServicedatas.filter(function (item) {
              return item.CustomerID === $scope.RequestID;
            })[0];
            $scope.vm.usName = item.sName;
            $scope.vm.usContactPerson = item.sContactPerson;
            $scope.vm.usBLK = item.sBLK;
            $scope.vm.usUnit = item.sUnit;
            $scope.vm.usPostal = item.sPostal;
            $scope.vm.usCountry = item.sCountry;
            $scope.vm.usBuildingName = item.sBuildingName;
            $scope.vm.usStreetName = item.sStreetName;
            $scope.vm.usMobile = [];
            if (
              item.sMobile != null &&
              item.sMobile != undefined &&
              item.sMobile != ""
            )
              $scope.vm.usMobile = item.sMobile.split(",");
            if (
              item.sEmail != null &&
              item.sEmail != "" &&
              item.sEmail != undefined
            ) {
              $scope.vm.ZoneCC = item.sEmail.split(",");
            }
            if (item.sCC != null && item.sCC != "" && item.sCC != undefined) {
              $scope.vm.ZoneEmail = item.sCC.split(",");
            }
          } catch (e) { }
        }
      }
      if ($scope.Servicecopy.value == false) {
        $scope.vm.usName = "";
        $scope.vm.usContactPerson = "";
        $scope.vm.usBLK = "";
        $scope.vm.usUnit = "";
        $scope.vm.usPostal = "";
        $scope.vm.usCountry = "";
        $scope.vm.usBuildingName = "";
        $scope.vm.usStreetName = "";
        $scope.vm.usMobile = [];
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
      }
    };

    $scope.copybilling = function ($scope) {
      if ($scope.checkboxModel.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.ubContactPerson = $scope.vm.uFirstName;
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = $scope.vm.StreetName;
        $scope.vm.ubBuildingName = $scope.vm.BuildingName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.ubPostal = $scope.vm.uPostal;
        }
        $scope.vm.ubCountry = $scope.vm.uCountry;
        $scope.vm.ubMobile = $scope.vm.uMobile.join(", ");
        $scope.vm.ubEmail = $scope.vm.uEmail;
        $scope.vm.ubStreetName = $scope.vm.StreetName;
        $scope.vm.ubWebsite = "";
      }
      if ($scope.checkboxModel.value == false) {
        $scope.vm.ubContactPerson = "";
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = "";
        $scope.vm.ubBuildingName = "";
        $scope.vm.ubPostal = "";
        $scope.vm.ubCountry = "";
        $scope.vm.ubMobile = "";
        $scope.vm.ubEmail = "";
        $scope.vm.ubStreetName = "";
        $scope.vm.ubWebsite = "";
      }
    };
    $scope.checkboxModel = {
      value: false
    };
    $scope.Servicecopy = {
      value: false
    };

    $scope.Addcustomer = function (e) {
      $scope.CUpdate = false;
      $scope.vm.uCustomerID = null;
      $scope.vm.uSalutation = null;
      $scope.vm.uFirstName = null;
      $scope.vm.uLastName = null;
      $scope.vm.uCompanyName = null;
      $scope.vm.uNote = null;
      $scope.vm.uAddress = null;
      $scope.vm.uAddress1 = null;
      $scope.vm.uPostal = null;
      $scope.vm.uCountry = "Singapore";
      $scope.vm.CContactPerson = null;
      $scope.vm.uPhone = null;
      $scope.vm.uMobile = null;
      $scope.vm.uEmail = null;
      $scope.vm.CustomerSince = new Date();
      $scope.vm.ProspectFollowupDate = new Date();
      $scope.vm.Unit = null;
      $scope.vm.StreetName = null;
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.ubContactPerson = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.BuildingName = null;
      $scope.vm.ubFax = null;
      $scope.vm.ubMobile = null;
      $scope.vm.ubEmail = null;
      $scope.vm.Category = null;
      $scope.vm.MarketSection = null;
      $scope.vm.uInvoiceEmail = [];
      $scope.vm.uInvoiceCC = [];
      $scope.CustomerBillingdatas = [];
      $scope.CustomerServicedatadata = [];

      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      $scope.vm.uCustomerID = pass;
      $scope.CustomerServicedatadata = [];

      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/addcustomer.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.customerSubmit = function () {
      if (
        $scope.vm.uFirstName == null ||
        $scope.vm.uFirstName == "" ||
        $scope.vm.uFirstName == undefined
      ) {
        $scope.vm.uFirstName = $scope.vm.uCompanyName;
      }
      $scope.vm.uContactPerson = $scope.vm.uFirstName;

      if (
        $scope.vm.BuildingName != null &&
        $scope.vm.BuildingName != "" &&
        $scope.vm.BuildingName != undefined
      ) {
        $scope.vm.uAddress =
          $scope.vm.Unit +
          "," +
          $scope.vm.StreetName +
          "," +
          $scope.vm.BuildingName;
      } else {
        $scope.vm.uAddress = $scope.vm.Unit + "," + $scope.vm.StreetName;
      }
      if (
        $scope.vm.uMobile != null &&
        $scope.vm.uMobile != "" &&
        $scope.vm.uMobile != undefined
      )
        $scope.vm.uMobile = $scope.vm.uMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      if (
        $scope.vm.uEmail != null &&
        $scope.vm.uEmail != "" &&
        $scope.vm.uEmail != undefined
      )
        $scope.vm.uEmail = $scope.vm.uEmail
          .map(function (obj) {
            return obj;
          })
          .join(",");
      if (
        $scope.vm.MarketSection != null &&
        $scope.vm.MarketSection != "" &&
        $scope.vm.MarketSection != undefined
      ) {
        $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/add",
        data: {
          CustomerID: $scope.vm.uCustomerID,
          CustomerReference: $scope.vm.CustomerReference,
          Salutation: $scope.vm.uSalutation,
          FirstName: $scope.vm.uFirstName,
          LastName: $scope.vm.uLastName,
          CompanyName: $scope.vm.uCompanyName,
          Note: $scope.vm.uNote,
          Address: $scope.vm.uAddress,
          Address1: $scope.vm.uAddress1,
          Postal: $scope.vm.uPostal,
          Country: $scope.vm.uCountry,
          ContactPerson: $scope.vm.uContactPerson,
          Phone: $scope.vm.uPhone,
          Mobile: $scope.vm.uMobile,
          Email: $scope.vm.uEmail,
          ProspectFollowupDate: $scope.vm.ProspectFollowupDate,
          Unit: $scope.vm.Unit,
          StreetName: $scope.vm.StreetName,
          BuildingName: $scope.vm.BuildingName,
          CreditTerm: $scope.vm.CreditTerm,
          MarketSection: $scope.vm.MarketSection,
          ConEndDate: $scope.vm.ConEndDate,
          Category: $scope.vm.Category,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
          Client_Id: $rootScope.Client_Id,
          InvoiceEmail: $scope.vm.usInvoiceEmail,
          InvoiceCC: $scope.vm.usInvoiceCC
        }
      });
      response.then(
        function (GList) {
          if (GList.data.message == "Existing CompanyName") {
            $scope.error1 = true;
            $scope.Leadgrid = false;
            $scope.Leadform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
          } else {
            debugger;
            RefreshCustomerdatas();
            $scope.vm.CustomerID = GList.data.data.id;
            $scope.vm.ppCompanyName = GList.data.data.CompanyName;
            $scope.vm.Customer = GList.data.data.CompanyName;
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("top center")
            );
            // $scope.Leadgrid = true;
            // $scope.Leadform = false;
            // $scope.Export = true;
            // $scope.Add = true;
            // $scope.view = false;
            // $scope.Search = true;
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.placeChanged = function () {
      $scope.vm.uPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.uPostal = vm.place.address_components[i].long_name;
          }
        }
      }
    };
    $scope.Servicepopup = function (e, uCustomerID, PopupType) {
      $scope.vm.uCustomerID = uCustomerID;
      if (PopupType == "Billing") {
        $scope.Billing = true;
        $scope.Service = false;
        $scope.PopupType = "Billing";
        $scope.vm.ubBLK = null;
        $scope.vm.ubUnit = null;
        $scope.vm.ubPostal = null;
        $scope.vm.ubCountry = null;
        $scope.vm.ubContactPerson = null;
        $scope.vm.ubBuildingName = null;
        $scope.vm.ubStreetName = null;
        $scope.vm.ubMobile = null;
        $scope.vm.ubEmail = null;
        $scope.vm.sty = 45;
      }
      if (PopupType == "Service") {
        $scope.Service = true;
        $scope.Billing = false;
        $scope.PopupType = "Service";
        $scope.vm.sty = 55;
      }
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = [];
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Enter valid CC !")
              .position("top center")
          );
          return;
        }
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid email !")
            .position("top center")
        );
        return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail,
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              $scope.vm.CustomerID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
          $mdDialog.cancel();
        }
      }
    };
    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        }
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        }
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.cspopup = function (e, deleteID, Index, Type) {
      $scope.vm.deleteID = deleteID;
      $scope.vm.Index = Index;
      $scope.vm.DeleteType = Type;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/cspopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Servicedelete = function (deleteID, Index) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customerService/delete",
        data: { _id: deleteID }
      });
      response.then(
        function (GList) {
          if ($scope.vm.DeleteType == "Service") {
            $scope.CustomerServicedatadata.splice(Index, 1);
          } else {
            $scope.CustomerBillingdatas.splice(Index, 1);
          }
          //CustomerServicedatadetails();
          $scope.Servicegrid = true;
          $scope.Add = false;
          $scope.Search = false;
          $mdDialog.cancel();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Billingadd = function (Index) {
      if ($scope.BAUpdate == true) {
        $scope.BillingIndex = $scope.BillingIndex;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            bBLK: $scope.vm.ubBLK,
            bUnit: $scope.vm.ubUnit,
            bPostal: $scope.vm.ubPostal,
            bCountry: $scope.vm.ubCountry,
            bContactPerson: $scope.vm.ubContactPerson,
            bBuildingName: $scope.vm.ubBuildingName,
            bStreetName: $scope.vm.ubStreetName,
            bMobile: $scope.vm.ubMobile,
            bEmail: $scope.vm.ubEmail,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
            $scope.Add = false;
            $scope.Search = false;
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var item = [];
        try {
          item = $scope.CustomerBillingdatas.filter(function (item) {
            return (
              item.bBLK == $scope.vm.ubBLK &&
              item.bUnit == $scope.vm.ubUnit &&
              item.bStreetName == $scope.vm.ubStreetName &&
              item.bCountry == $scope.vm.ubCountry &&
              item.bMobile == $scope.vm.ubMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          if ($scope.BAUpdate == true) {
            $scope.BillingIndex = $scope.BillingIndex;
            var response = $http({
              method: "PUT",
              url: $rootScope.WebURL + "/customerService/update",
              data: {
                _id: $scope.QID,
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                UpdatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                debugger;
                $scope.CustomerBillingdatas[$scope.BillingIndex] =
                  GList.data.data;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          } else {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/customerService/add",
              data: {
                Type: "Billing",
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                CreatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.RequestID = $scope.vm.uCustomerID;
                $scope.vm.CustomerID = $scope.vm.uCustomerID;
                CustomerBillingdatadetails2();
                $scope.Servicegrid = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Billingupdate = function (e, QId, Index) {
      $scope.BAUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.BillingIndex = Index;
      $scope.Billing = true;
      $scope.Service = false;
      try {
        var item = $scope.CustomerBillingdatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.ubBLK = item.bBLK;
        $scope.vm.ubUnit = item.bUnit;
        $scope.vm.ubPostal = parseInt(item.bPostal);
        $scope.vm.ubCountry = item.bCountry;
        $scope.vm.ubContactPerson = item.bContactPerson;
        $scope.vm.ubBuildingName = item.bBuildingName;
        $scope.vm.ubStreetName = item.bStreetName;
        $scope.vm.ubMobile = parseInt(item.bMobile);
        $scope.vm.ubEmail = item.bEmail;
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function salesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.ForAlternateWeek = function (freq) {
      if (
        freq == "Alternate Week (52)" ||
        freq === "Alternate Twice a Week (104)"
      ) {
        var item = $scope.Pestdatas.filter(function (item) {
          return item.PestName === "Adult Mosquito";
        });
        $scope.Pestdatasdatas = item;
      } else $scope.Pestdatasdatas = $scope.Pestdatas;
    };
    $scope.CheckTreatment = function () {
      debugger;
      if ($scope.vm.Frequency === "Alternate Week (52)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Week frequency!"
            )
            .position("center")
        );
      }
      if ($scope.vm.Frequency === "Alternate Twice a Week (104)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Twice a Week frequency!"
            )
            .position("center")
        );
      }
    };
    $scope.CCarray = [];
    $scope.AddCC = function (email) {
      try {
        if ($scope.CCarray.indexOf(email) == -1) {
          $scope.CCarray.push(email);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };
    $scope.Removeccs = function (i) {
      try {
        if ($scope.CCarray.indexOf(i) == -1) {
          $scope.CCarray.splice(i, 1);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };

    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
    });

    RefreshSchedulerFrequency();
    function RefreshSchedulerFrequency() {
      $http({
        url: $rootScope.WebURL + "/settings",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (settingsdata) {
        $scope.Settingsdatas = settingsdata.data.data;
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "CreditTerm";
          });
          $scope.CreditTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "ScheduleFrequency";
          });
          $scope.ScheduleFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentMode";
          });
          $scope.PaymentModedatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BillingFrequency";
          });
          $scope.BillingFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentTerm";
          });
          $scope.PaymentTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "JobTypes";
          });
          $scope.JobTypesdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BuildingType";
          });
          $scope.BuildingTypedatas = item;
        } catch (e) { }
      });
    }
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    function GetEnquiryNumber() {
      if (dataGrid) dataGrid.beginCustomLoading();
      if (dataGrid1) dataGrid1.beginCustomLoading();

      $scope.AllSalesOrderData = [];

      var Limit = 1000;

      // Helper to create paginated request promises
      function getSalesOrderPages() {
        return $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder/getLength",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (res) {
          var total = parseInt(res.data.data);
          var pageCount = Math.ceil(total / Limit);

          var promises = [];
          for (var i = 0; i < pageCount; i++) {
            var Skip = i * Limit;
            promises.push(
              $http({
                method: "POST",
                url:

                  $rootScope.WebURL +
                  "/salesOrder/getSalesOrderfortable",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit
                }
              })
            );
          }
          return Promise.all(promises);
        });
      }

      // Run both contract and ad-hoc in parallel
      Promise.all([getSalesOrderPages()])
        .then(function (results) {
          var contractResults = results[0];
          for (var i = 0; i < contractResults.length; i++) {
            $scope.AllSalesOrderData = $scope.AllSalesOrderData.concat(
              contractResults[i].data.data
            );
          }

          $scope.AllSalesOrderData = _.uniqWith(
            $scope.AllSalesOrderData,
            _.isEqual
          );

          extract_salesorder_data($scope);

          indexedDBService.clearStore("work_order").then(function () {
            indexedDBService.addAll("work_order", $scope.AllSalesOrderData);
          });

          if (dataGrid) dataGrid.endCustomLoading();
          if (dataGrid1) dataGrid1.endCustomLoading();

          $scope.vm.PreviewSpinner = false;
        })
        .catch(function (err) {
          console.error("Error fetching sales orders:", err);
          if (dataGrid) dataGrid.endCustomLoading();
          if (dataGrid1) dataGrid1.endCustomLoading();
        });
    }

    $scope.getDeletedWO = function () {
      if (dataGrid2 != undefined) dataGrid2.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getDeleted",
        data: {
          Client_Id: $rootScope.Client_Id,
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(function (GList) {
        if (dataGrid2 != undefined) dataGrid2.endCustomLoading();
        $scope.DeletedSalesOrderdatas = GList.data.data;
      });
    };

    $scope.getCompleted = function () {
      if (dataGrid3 != undefined) dataGrid3.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getCompleted",
        data: {
          Client_Id: $rootScope.Client_Id,
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(function (GList) {
        if (dataGrid3 != undefined) dataGrid3.endCustomLoading();
        $scope.CompletedWO = GList.data.data;
      });
    };

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/lead",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (leaddata) {
      $scope.Leaddetails = leaddata.data.data;
    });

    function CustomerServicedatadetails2() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatadata = CustomerServicedata.data.data;
      });
    }
    function CustomerBillingdatadetails2() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
      });
    }
    RefreshTreatment();
    function RefreshTreatment() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Treatmentdata) {
        $scope.Treatmentdatas = Treatmentdata.data.data;
      });
    }
    function RefreshAttachmentGrid() {
      if ($scope.Update == false) $scope.File_id = UniqID;

      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }

    function RefreshCustomerdatas() {
      $scope.getCustomerdatas = [];
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.getCustomerdatas = customerdata;
        $scope.Customerdatas = $scope.getCustomerdatas;
        if (IsAdmin != true) {
          var item = $scope.getCustomerdatas.filter(function (item) {
            if (item.AssignedUser != null)
              return item.AssignedUser.includes($rootScope.createdby);
          });
          $scope.Customerdatasfordropdown = item;
        } else {
          $scope.Customerdatasfordropdown = $scope.getCustomerdatas;
        }
      });
    }
    function ClearForm() {
      $scope.vm.emailValidationError = false
      $scope.vm.SpecialChemical = null
      $scope.vm.SalesOrderNo = null;
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ConfirmationMode = null;
      $scope.vm.ConfirmationBy = null;
      $scope.vm.ConfirmationReceivedBy = null;
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.Remarks = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.PONumber = null;
      $scope.vm.PestType = null;
      $scope.vm.SalesPerson = null;
      $scope.vm.ContractNo = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.CustomerName = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.Frequency = null;
      $scope.vm.TotalSum = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.Types = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.vm.ServicesRequired = null;
      $scope.vm.TotalPrice = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.Message = null;
      $scope.vm.CoverageArea = null;
      $scope.vm.PurchaseOrderNo = null;
      $scope.vm.IsUrgent = "false";
      $scope.vm.TrendingReport = "false";
      $scope.vm.Department = "Pest Off";
      $scope.vm.DateTimeofTreatment = "";
      $scope.vm.TotalTripsPerYear = 0;
      $scope.vm.SpecialRemarks = null;
      $scope.vm.SpecialRemark = null;
      $scope.vm.BAddress = null;
      $scope.vm.BContactPerson = null;
      $scope.vm.BContactNo = [];
      $scope.vm.BEmail = [];
      $scope.vm.SContactPerson = null;
      $scope.vm.SContactNo = [];
      $scope.vm.SName = null;
      $scope.vm.SiteEmail = [];
      $scope.vm.SiteContactNo = [];
      $scope.PaymentFrequencyData = [];
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });

    function CustomerServicedatadetails() {
      $scope.vm.PreviewSpinner = true;
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.CustomerID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatas = CustomerServicedata.data.data;
        var resArr = [];
        try {
          $scope.CustomerServicedatas.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return (
                x.sBLK == item.sBLK &&
                x.sUnit == item.sUnit &&
                x.sStreetName == item.sStreetName &&
                x.sPostal == item.sPostal
              );
            });
            if (i <= -1) resArr.push(item);
          });
        } catch (e) { }
        $scope.CustomerServicedatas = resArr;
        $scope.vm.PreviewSpinner = false;
        if ($scope.vm.FixedTeam == "Yes") {
          if (
            $scope.vm.FixedTeamdata != null &&
            $scope.vm.FixedTeamdata != "" &&
            $scope.vm.FixedTeamdata != undefined
          ) {
            var array = $scope.vm.FixedTeamdata.split(",");
            var array1 = [];
            angular.forEach(array, function (item) {
              angular.forEach($scope.teamdatas, function (value) {
                if (item == value.TeamName) {
                  array1.push(value);
                }
              });
            });
            $scope.teamdatas = array1;
          } else {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/team",
              data: {
                Client_Id: $rootScope.Client_Id
              }
            }).then(function (teamdata) {
              $scope.teamdatas = teamdata.data.data;
            });
          }
        } else {
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id }
          }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
          });
        }
      });
    }
    $scope.CalculateTotalJob = function (Frequency) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (
          Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
          Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
          Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 14);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "WEEKLY") {
          var TotalHallfyearss = Math.round(Totaldays / 7);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "MONTHLY") {
          var TotalHallfyearss = Math.round(Totaldays / 30);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (
          Frequency.toUpperCase() == "BIMONTHLY" ||
          Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 60);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "QUARTERLY") {
          var TotalHallfyearss = Math.round(Totaldays / 90);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (
          Frequency.toUpperCase() == "HALF-YEARLY" ||
          Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 183);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "YEARLY") {
          var Totalyearss = Math.round(Totaldays / 365);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * Totalyearss;
          }
        }
        if (Frequency.toUpperCase() == "DAILY") {
          $scope.vm.ServicesRequired = Totaldays;
        }
      } catch (e) { }
    };
    $scope.CalculateTotalServices = function () {
      try {
        var Frequency = $scope.vm.MultiFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          if (Frequency.toUpperCase() == "DAILY") {
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * Totaldays;
            }
          }
          if (Frequency.toUpperCase() == "WEEKLY") {
            var TotalWeeks = Math.round(Totaldays / 7);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalWeeks;
            }
          }
          if (Frequency.toUpperCase() == "MONTHLY") {
            var TotalMonths = Math.round(Totaldays / 30);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalMonths;
            }
          }
          if (Frequency.toUpperCase() == "YEARLY") {
            var Totalyearss = Math.round(Totaldays / 365);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * Totalyearss;
            }
          }
          if (
            Frequency.toUpperCase() == "BIMONTHLY" ||
            Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 60);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
          if (
            Frequency.toUpperCase() == "HALF-YEARLY" ||
            Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 183);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
          if (
            Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
            Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
            Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 14);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
        }
      } catch (e) { }
    };
    $scope.calculateServices = function (freq, job) {
      try {
        $scope.vm.ServicesRequired = parseInt(freq.match(/\(([^)]+)\)/)[1]);
      } catch (error) {
        $scope.vm.ServicesRequired = 0;
      }
    };

    $scope.getFrequencyTable = function (data) {
      if ($scope.vm.OrderType == "Contract") {
        $scope.Frequencydatas = data.MultiFrequency;
        $scope.vm.ServiceStartDate = new Date(data.ServiceStartDate);
        $scope.vm.ServiceEndDate = new Date(data.ServiceEndDate);
        $scope.vm.TotalPrice = parseFloat(data.ContractValue);
        $scope.vm.BillingFrequency = data.BillingFrequency;
        $scope.vm.SiteContactNo = data.SiteContact;
        $scope.vm.SContactPerson = data.SiteContactPerson;
        $scope.vm.SName = data.SiteName;
        $scope.vm.BAddressId = data.BillingAddress;
        $scope.vm.PaymentMode = data.CreditTerm
        var Email = data.SiteName;
        if (Email != "" && Email != undefined && Email != null)
          $scope.vm.SiteEmail = Email.split(",");
        else $scope.vm.SiteEmail = [];
        angular.forEach($scope.Frequencydatas, function (item) {
          item.JobsPerFrequency = 1;
          $scope.calculateServices(item.Frequency, item.JobsPerFrequency);
          item.ServicesRequired = $scope.vm.ServicesRequired;
        });
        // if (data.CustomerID != null && data.CustomerID != undefined && data.CustomerID != "") {
        //     $scope.vm.SLocation = data.CustomerID
        //     $scope.DisableServiceLocation = true
        // }
      } else $scope.Frequencydatas = [];
    };
    $scope.selectBox = {
      searchBoxOptions: {
        dataSource: $scope.Customerdatasfordropdown,
        displayExpr: "CompanyName",
        valueExpr: "_id",
        searchEnabled: true,
        bindingOptions: {
          dataSource: "Customerdatasfordropdown",
          searchMode: "contains",
          searchExpr: "CompanyName",
          searchTimeout: "200",
          minSearchLength: "0",
          showDataBeforeSearch: "false"
        }
      }
    };

    function RefreshComments(ID) {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByReqID",
        method: "POST",
        data: { RequestID: ID }
      });
      response.then(function (Commentdata) {
        var Commentdatas = [];
        Commentdatas.push({ key: 0 });
        $scope.Commentdatas = [];
        if (
          $scope.vm.SpecialRemarks != undefined &&
          $scope.vm.SpecialRemarks != "" &&
          $scope.vm.SpecialRemarks != null
        ) {
          Commentdatas[0].key = 1;
          Commentdatas[0].cmt = $scope.vm.SpecialRemarks;
          Commentdatas[0].CommentedBy = $scope.vm.CreatedBy;
          Commentdatas[0].CreatedDate = $scope.vm.CreatedDate;
          // $scope.Commentdatas = Commentdatas.concat(Commentdata.data.data);
          $scope.Commentdatas = Commentdata.data.data;
        } else $scope.Commentdatas = Commentdata.data.data;
        $scope.vm.SpecialRemarks = "";
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate);
        });
        $scope.Commentdatas.reverse();
      });
    }
    $scope.CommentArray = [];
    $scope.AddComment = function (SpecialRemarks) {
      if ($scope.Update == true) {
        $scope.SpecialRem = SpecialRemarks;
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulercomment/add",
          data: {
            SalesOrderID: $scope.SID,
            CustomerID: $scope.vm.CustomerName,
            TableName: "SalesOrder",
            CommentedBy: $rootScope.createdby,
            cmt: SpecialRemarks,
            ModuleID: $scope.vm.ModuleID,
            CreatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            // $scope.vm.SpecialRemarks = '';
            RefreshComments($scope.SID);
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        if ($scope.vm.SpecialRemarks != "") {
          $scope.SpecialRem = $scope.vm.SpecialRemarks;
          $scope.CommentArray.push({
            key: $scope.CommentArray.length + 1,
            cmt: $scope.vm.SpecialRemarks,
            CommentedBy: $rootScope.createdby,
            CreatedDate: new Date()
          });
          $scope.Commentdatas = $scope.CommentArray;
          $scope.vm.SpecialRemarks = "";
        }
      }
    };

    $scope.DeleteComment = function (data) {
      if ($scope.Update == true) {
        if (data.CreatedBy === $rootScope.createdby) {
          $scope.delComId = data._id;
          var result = DevExpress.ui.dialog.confirm(
            "Are you sure, you want to delete the comment?",
            "Confirm!"
          );
          result.done(function (dialogResult) {
            if (dialogResult === true) {
              $http({
                url: $rootScope.WebURL + "/schedulercomment/delete",
                method: "POST",
                data: { _id: $scope.delComId }
              }).then(function (attachmentdata) {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Deleted Successfully!")
                    .position("top center")
                );
                RefreshComments($scope.SID);
              });
            }
          });
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("You dont have permission to delete")
              .position("top center")
          );
        }
      } else {
        $scope.delComId = data.key;
        var result = DevExpress.ui.dialog.confirm(
          "Are you sure, you want to delete the comment?",
          "Confirm!"
        );
        result.done(function (dialogResult) {
          if (dialogResult === true) {
            _.remove($scope.Commentdatas, function (o) {
              return o.key === $scope.delComId;
            });
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Deleted Successfully!")
                .position("top center")
            );
          }
        });
      }
    };

    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }
    vm.readonly = false;
    vm.ZoneCC = [];
    vm.ZoneEmail = [];
    vm.uInvoiceEmail = [];
    vm.uInvoiceCC = [];
    vm.roFruitNames = angular.copy(vm.fruitNames);

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      destroy: true,
      lengthMenu: [10, 20, 30, 50, 100],
      responsive: true,
      stateSave: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtdetails1 = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-dtdetails1");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dtdetails2 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-dtdetails2");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dataGridCustomerServiceAdd = {
      onInitialized: function (e) {
        ServicedataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatadata,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: "onClick"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sName", caption: "Name" },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sStreetName", caption: "Address" },
        { dataField: "sPostal", caption: "Postal" },
        { dataField: "sEmail", caption: "Email" },
        { dataField: "sMobile", caption: "Mobile" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = ServicedataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.Servicesupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  debugger;
                  var index = ServicedataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  debugger;
                  $scope.cspopup(e, options.data._id, index, "Service");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatadata",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = ServicedataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerBilling = {
      onInitialized: function (e) {
        BillingdataGrid = e.component;
      },
      dataSource: $scope.CustomerBillingdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "bContactPerson", caption: "Contact Person" },
        { dataField: "bBLK", caption: "Blk" },
        { dataField: "bStreetName", caption: "Address" },
        { dataField: "bPostal", caption: "Postal" },
        { dataField: "bCountry", caption: "Country" },
        { dataField: "bEmail", caption: "Email" },
        { dataField: "bMobile", caption: "Mobile" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.Billingupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.cspopup(e, options.data._id, index, "Billing");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerBillingdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = BillingdataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sBuildingName", caption: "Building Name" },
        { dataField: "sStreetName", caption: "Street Name" },
        { dataField: "sPostal", caption: "Postal" }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.ServiceAddressarray = [];
          $scope.ServiceAddressarray.push.apply(
            $scope.ServiceAddressarray,
            e.selectedRowsData
          );
        } else {
          $scope.ServiceAddressarray = [];
        }
      }
    };
    // GetEnquiryNumber()
    $scope.ShowAdhocs = function (test) {
      $scope.vm.PreviewSpinner = true;
      if (test == true) {
        $scope.uShowClosed = true;
        $("#SalesgridContainer")
          .dxDataGrid("instance")
          .option().columns[7].visible = false;
        $("#SalesgridContainer").dxDataGrid("instance").state({});
        $http({
          url: $rootScope.WebURL + "/salesorder",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (GList) {
          $scope.salesOrderdatas = GList.data.data;
          if (IsAdmin == true) {
            var item = $scope.salesOrderdatas.filter(function (item) {
              return item.OrderType === "Ad-hoc";
            });
            $scope.salesOrderdatas = item;
            $scope.vm.PreviewSpinner = false;
          } else {
            var item = $scope.salesOrderdatas.filter(function (item) {
              return (
                item.OrderType === "Ad-hoc" &&
                $scope.Emp_Id === item.SalesPerson_id
              );
            });
            $scope.salesOrderdatas = item;
            $scope.vm.PreviewSpinner = false;
          }
          angular.forEach($scope.salesOrderdatas, function (value) {
            try {
              value.ServiceDate =
                new Date(value.ServiceStartDate).toLocaleDateString("en-GB") +
                " - " +
                new Date(value.ServiceEndDate).toLocaleDateString("en-GB");
              var pest = value.PestType.split(",");
              var PestArray = [];
              PestArray = $scope.Pestdatas.filter(function (pestt) {
                return pest.includes(pestt.PestName);
              });
              value.PestCode = PestArray.map(function (obj) {
                if (
                  obj.Pestcode != null &&
                  obj.Pestcode != undefined &&
                  obj.Pestcode != ""
                )
                  return obj.Pestcode;
                else return obj.PestName;
              }).join(",");
            } catch (e) { }
          });
        });
      } else {
        GetEnquiryNumber();
        $scope.uShowClosed = false;
        $("#SalesgridContainer")
          .dxDataGrid("instance")
          .option().columns[7].visible = true;
        $("#SalesgridContainer").dxDataGrid("instance").state({});
      }
    };
    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }

    $scope.Status = function () {
      if (data) {
      }
    };

    // socket configuration

    $scope.$on("salesOrder_created", function (event, item) {
      $scope.AllSalesOrderData.push(item);
      extract_salesorder_data($scope);
      // get for Ad-hoc WorkOrder
    });

    $scope.$on("work_order_modified", function (event, item) {
      var idx = $scope.AllSalesOrderData.findIndex(function (c) {
        return c.id === item.id;
      });
      if (idx !== -1) {
        $scope.AllSalesOrderData[idx] = item;
      }
      extract_salesorder_data($scope);
      // get for Ad-hoc WorkOrder
    });

    $scope.$on("work_order_deleted", function (event, item) {
      getSalesOrderdata();
    });

    function extract_salesorder_data($scope) {
      var salesOrderdatas = $scope.AllSalesOrderData.filter(function (item) {
        return item.OrderType == "Contract";
      });
      $scope.salesOrderdatas = _.uniq(salesOrderdatas);

      $scope.workOrd = $scope.salesOrderdatas;
      angular
        .element("#PendingContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.salesOrderdatas);

      var AdhocsalesOrderdatas = $scope.AllSalesOrderData.filter(function (
        item
      ) {
        return item.OrderType == "Ad-hoc";
      });
      $scope.AdhocsalesOrderdatas = _.uniq(AdhocsalesOrderdatas);

      angular
        .element("#YTSContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.AdhocsalesOrderdatas);
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('apps.crm.preparequotation', ['wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.preparequotation', {
            url: '/PrepareQuotation',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/preparequotation/preparequotation.html',
                    controller: 'preparequotationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/preparequotation');
    }
  
})();
(function () {
    'use strict';
    angular
        .module('apps.crm.preparequotation')
        .controller('preparequotationController', preparequotationController)
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });

    /** @ngInject */
    function preparequotationController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, $window, $mdDialog, $location, $state, $log, $q, $filter, $document, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Lead")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $scope.Employeephoto = [
            { photo: false }]
        $scope.EmployeehandleUpload = function ($files, $event, $flow) {
            if (($event.srcElement !== undefined) && ($event.srcElement !== null))
                var input = angular.element($event.srcElement)
            else
                var input = angular.element($event.originalTarget)
            if (input.scope().item) {
                if (input.scope().item.photo) {
                    input.scope().item.photo.cancel();
                }
                input.scope().item.photo = $files[0];
            } else {
                for (var i = 0; i < $files.length; i++) {
                    $scope.Employeephoto.push({ photo: $files[i] });

                }
            }
        };
        var PQdatas = JSON.parse(localStorage.getItem('PQfromLead'));
        if (PQdatas != null && PQdatas != "" && PQdatas != undefined && PQdatas != "null") {
            $scope.QuotationReference = PQdatas.QuotationReference;
            $scope.LeadId = PQdatas.LeadReferenceNo;
            $scope.EnquiryID = PQdatas.LeadId; // lead onject id
            $scope.LeadReferenceNo = PQdatas.LeadReferenceNo;
            $scope.EnquiryReceivedBy = PQdatas.EnquiryReceivedBy;
            $scope.EnquiryDate = PQdatas.EnquiryDate;
            $scope.CustomerID = PQdatas.CustomerID;
            $scope.NatureofJob = PQdatas.NatureofJob;
            $scope.TreatmentMethod = PQdatas.Treatment;
            $scope.EnquiryMode = PQdatas.EnquiryMode;
            $scope.CoverageArea = PQdatas.CoverageArea;
            $scope.Customer = PQdatas.Customer;
            $scope.ContactMedium = PQdatas.ContactMedium;
            $scope.SalesPerson = PQdatas.SalesPerson;
            $scope.ExpectedResponseDate = PQdatas.ExpectedResponseDate;
            $scope.InfestationLevel = PQdatas.InfestationLevel;
            $scope.Confirmation = PQdatas.Confirmation;
            $scope.EnquiryType = PQdatas.EnquiryType
            $scope.EnquiryStatus = PQdatas.EnquiryStatus;
            $scope.Status = PQdatas.Status;
            $scope.Quote = PQdatas.Quote;
            $scope.Division = PQdatas.Division;
            $scope.CurrentStatus = PQdatas.cNextActioned;
            $scope.CurrentStatusID = PQdatas.cNextActionedID;
            $scope.NexttoNextId = PQdatas.NexttoNextId;
            $scope.TermsCondition = PQdatas.TermsCondition;
            $scope.Footer = PQdatas.Footer;
            $scope.Header = PQdatas.Header;
            $scope.Subject = PQdatas.Subject;
            $scope.TableTitle = PQdatas.TableTitle;
            $scope.TemplateID = PQdatas.TemplateID;
            $scope.QuotationUpdate = PQdatas.QuotationUpdate
            $scope._id = PQdatas._id;
        }
        $scope.Quotationform = false;
        $scope.Quotationgrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.Previewdiv = false;
        if ($scope.Header == null || $scope.Header == "" || $scope.Header == undefined) {
            $scope.Header = "<div><p><b>QUOTE FOR ANTI - TERMITE SOIL TREATMENT AT PROJECT :</b></p><p><b>EUNOSVILLE SHOWFLAT - PROPOSED ERECTION OF 1 - STOREY TEMPORARY SHOWFLAT AND SALES GALLERY FOR PROPOSED RESIDENTIAL DEVELOPMENT ON LOT 04135W MK 23 AT SIMS AVENUE (GEYLANG PLANNING AREA)​</b></p></div>";
        }
        if ($scope.Footer == null || $scope.Footer == "" || $scope.Footer == undefined) {
            $scope.Footer = "<p>We trust that the above meet your expectation and looking forward for your early favourable reply. Please feel free to contact the undersigned at 9733 8342 should you need any assistance.</p>";
        }
        if ($scope.TermsCondition11 == null || $scope.TermsCondition == "" || $scope.TermsCondition == undefined) {
        } $scope.TermsCondition11 = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'
        if ($scope.ExpectedResponseDate != null && $scope.ExpectedResponseDate != "" && $scope.ExpectedResponseDate != undefined) {
            if (new Date($scope.ExpectedResponseDate).setHours(0, 0, 0, 0) == new Date("01/01/1970").setHours(0, 0, 0, 0)) {
                $scope.ExpectedResponseDate = null;
            }
        }
        $scope.IncludeSOR = false;
        function init() {
            $scope.vm.GST = 7;
            try {
                var item = $scope.Preparedquotationdatas.filter(function (item) {
                    return item.EnquiryID === $scope.EnquiryID;
                });
                item = item[item.length - 1];
                if (item != undefined && item != null && item != "") {
                    $scope.Revision = item.Revision;
                    $scope._id = item.id;
                    $scope.vm.GSTTotal = item.GSTTotal;
                    $scope.vm.TotalPrice = item.TotalPrice;
                }
            }
            catch (e) { }
            try {
                var item1 = $scope.Quotationdatas.filter(function (item1) {
                    return item1.TableEnquiryID2 === $scope.EnquiryID;
                })[0];
                if (item1.Header != null && item1.Header != "" && item1.Header != undefined) {
                    $scope.Header = item1.Header;
                }
                if (item1.Footer != null && item1.Footer != "" && item1.Footer != undefined) {
                    $scope.Footer = item1.Footer;
                }
                if (item1.TermsCondition != null && item1.TermsCondition != "" && item1.TermsCondition != undefined) {
                    $scope.TermsCondition = item1.TermsCondition;
                }
                if (item1.Subject != null && item1.Subject != "" && item1.Subject != undefined) {
                    $scope.Subject = item1.Subject;
                }
                $scope.Inserted = item1.Inserted;
                $scope.Inserted_Id = item1.id;
            }
            catch (e) { }
            angular.forEach($scope.Quotationtemplates, function (tvalue) {
                if ($scope.Division == tvalue.Division) {
                    $scope.template_id = tvalue.id;
                }
            });
            $window.localStorage.setItem('Selected', "")
            if ($scope.template_id != null && $scope.template_id != "" && $scope.template_id != undefined) {
                $scope.SelectTemplate($scope.template_id);
            }
            angular.forEach($scope.Quotationdatas, function (pvalue) {
                try {
                    if (pvalue.TableEnquiryID1 == $scope.EnquiryID) {
                        $scope.vm.TableTitle1 = pvalue.TableTitle1;
                    }
                    if (pvalue.TableEnquiryID2 == $scope.EnquiryID) {
                        $scope.vm.TableTitle2 = pvalue.TableTitle2;
                    }
                    if (pvalue.TableEnquiryID3 == $scope.EnquiryID) {
                        $scope.vm.TableTitle3 = pvalue.TableTitle3;
                    }
                    if (pvalue.TableEnquiryID4 == $scope.EnquiryID) {
                        $scope.vm.TableTitle4 = pvalue.TableTitle4;
                    }
                    if (pvalue.TableEnquiryID5 == $scope.EnquiryID) {
                        $scope.vm.TableTitle5 = pvalue.TableTitle5;
                    }
                    if (pvalue.TableEnquiryID6 == $scope.EnquiryID) {
                        $scope.vm.TableTitle6 = pvalue.TableTitle6;
                    }
                    if (pvalue.TableEnquiryID7 == $scope.EnquiryID) {
                        $scope.vm.TableTitle7 = pvalue.TableTitle7;
                    }
                    if (pvalue.TableEnquiryID8 == $scope.EnquiryID) {
                        $scope.vm.TableTitle8 = pvalue.TableTitle8;
                    }
                }
                catch (e) { }
            });
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };

        $scope.Title1Submit = function () {
            if ($scope.QRTUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle1: $scope.vm.TableTitle1,
                        TableEnquiryID1: $scope.EnquiryID,
                        TableTempID1: $scope.TemplateID,
                        T1PestType: $scope.vm.T1PestType,
                        T1Timing: $scope.vm.T1Timing,
                        T1Frequency: $scope.vm.T1Frequency,
                        T1Pricing: $scope.vm.T1Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle1: $scope.vm.TableTitle1,
                        TableEnquiryID1: $scope.EnquiryID,
                        TableTempID1: $scope.TemplateID,
                        T1PestType: $scope.vm.T1PestType,
                        T1Timing: $scope.vm.T1Timing,
                        T1Frequency: $scope.vm.T1Frequency,
                        T1Pricing: $scope.vm.T1Pricing,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title2Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle2: $scope.vm.TableTitle2,
                        TableEnquiryID2: $scope.EnquiryID,
                        TableTempID2: $scope.TemplateID,
                        T2PestType: $scope.vm.T2PestType,
                        T2Timing: $scope.vm.T2Timing,
                        T2Quantity: $scope.vm.T2Quantity,
                        T2Frequency: $scope.vm.T2Frequency,
                        T2Pricing: $scope.vm.T2Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle2: $scope.vm.TableTitle2,
                        TableEnquiryID2: $scope.EnquiryID,
                        TableTempID2: $scope.TemplateID,
                        T2PestType: $scope.vm.T2PestType,
                        T2Timing: $scope.vm.T2Timing,
                        T2Quantity: $scope.vm.T2Quantity,
                        T2Frequency: $scope.vm.T2Frequency,
                        T2Pricing: $scope.vm.T2Pricing,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title3Submit = function () {
            if ($scope.QRTUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle3: $scope.vm.TableTitle3,
                        TableEnquiryID3: $scope.EnquiryID,
                        TableTempID3: $scope.TemplateID,
                        T3Description: $scope.vm.T3Description,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3UnitRate: $scope.vm.T3UnitRate,
                        T3Amount: ($scope.vm.T3Quantity * $scope.vm.T3UnitRate),
                        UpdatedBy: $rootScope.createdby,
                        IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle3: $scope.vm.TableTitle3,
                        TableEnquiryID3: $scope.EnquiryID,
                        TableTempID3: $scope.TemplateID,
                        T3Description: $scope.vm.T3Description,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3UnitRate: $scope.vm.T3UnitRate,
                        T3Amount: ($scope.vm.T3Quantity * $scope.vm.T3UnitRate),
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby,
                        IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title4Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle4: $scope.vm.TableTitle4,
                        TableEnquiryID4: $scope.EnquiryID,
                        TableTempID4: $scope.TemplateID,
                        T4Product: $scope.vm.T4Product,
                        T4NoOfPieces: $scope.vm.T4NoOfPieces,
                        T4Pricing: $scope.vm.T4Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle4: $scope.vm.TableTitle4,
                        TableEnquiryID4: $scope.EnquiryID,
                        TableTempID4: $scope.TemplateID,
                        T4Product: $scope.vm.T4Product,
                        T4NoOfPieces: $scope.vm.T4NoOfPieces,
                        T4Pricing: $scope.vm.T4Pricing,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title5Submit = function () {

            $scope.vm.T5Photo = document.getElementById('quotationt5photo');
            if ($scope.vm.T5Photo == null || $scope.vm.T5Photo == "") { $scope.vm.T5Photo = { src: null }; }
            else {
                //do
            }
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle5: $scope.vm.TableTitle5,
                        TableEnquiryID5: $scope.EnquiryID,
                        TableTempID5: $scope.TemplateID,
                        T5Product: $scope.vm.T5Product,
                        T5Quantity: $scope.vm.T5Quantity,
                        T5LeasingUnitPrice: $scope.vm.T5LeasingUnitPrice,
                        T5SellingUnitPrice: $scope.vm.T5SellingUnitPrice,
                        T5Photo: $scope.vm.T5Photo.src,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle5: $scope.vm.TableTitle5,
                        TableEnquiryID5: $scope.EnquiryID,
                        TableTempID5: $scope.TemplateID,
                        T5Product: $scope.vm.T5Product,
                        T5Quantity: $scope.vm.T5Quantity,
                        T5LeasingUnitPrice: $scope.vm.T5LeasingUnitPrice,
                        T5SellingUnitPrice: $scope.vm.T5SellingUnitPrice,
                        T5Photo: $scope.vm.T5Photo.src,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title6Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle6: $scope.vm.TableTitle6,
                        TableEnquiryID6: $scope.EnquiryID,
                        TableTempID6: $scope.TemplateID,
                        T6Description: $scope.vm.T6Description,
                        T6Price: $scope.vm.T6Price,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle6: $scope.vm.TableTitle6,
                        TableEnquiryID6: $scope.EnquiryID,
                        TableTempID6: $scope.TemplateID,
                        T6Description: $scope.vm.T6Description,
                        T6Price: $scope.vm.T6Price,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title7Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle7: $scope.vm.TableTitle7,
                        TableEnquiryID7: $scope.EnquiryID,
                        TableTempID7: $scope.TemplateID,
                        T7PartNo: $scope.vm.T7PartNo,
                        T7ForModelNo: $scope.vm.T7ForModelNo,
                        T7NoOfLightTubesNeed: $scope.vm.T7NoOfLightTubesNeed,
                        T7SellingPricing: $scope.vm.T7SellingPricing,
                        T7Lifespan: $scope.vm.T7Lifespan,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle7: $scope.vm.TableTitle7,
                        TableEnquiryID7: $scope.EnquiryID,
                        TableTempID7: $scope.TemplateID,
                        T7PartNo: $scope.vm.T7PartNo,
                        T7ForModelNo: $scope.vm.T7ForModelNo,
                        T7NoOfLightTubesNeed: $scope.vm.T7NoOfLightTubesNeed,
                        T7SellingPricing: $scope.vm.T7SellingPricing,
                        T7Lifespan: $scope.vm.T7Lifespan,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title8Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle8: $scope.vm.TableTitle8,
                        TableEnquiryID8: $scope.EnquiryID,
                        TableTempID8: $scope.TemplateID,
                        T8ForModelNo: $scope.vm.T8ForModelNo,
                        T8NoOfBoardsNeeded: $scope.vm.T8NoOfBoardsNeeded,
                        T8SellingPricing: $scope.vm.T8SellingPricing,
                        T8Lifespan: $scope.vm.T8Lifespan,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    QRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        TableTitle8: $scope.vm.TableTitle8,
                        TableEnquiryID8: $scope.EnquiryID,
                        TableTempID8: $scope.TemplateID,
                        T8ForModelNo: $scope.vm.T8ForModelNo,
                        T8NoOfBoardsNeeded: $scope.vm.T8NoOfBoardsNeeded,
                        T8SellingPricing: $scope.vm.T8SellingPricing,
                        T8Lifespan: $scope.vm.T8Lifespan,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    QRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.SaveasTemplatepopup = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/preparequotation/SaveasTemplatepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function preparequotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.sSubmit = function () {
            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }
            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');
            $scope.EnquiryStatus = "Open";

            if ($scope.Revision >= 0) {
                var item = $scope.Preparedquotationdatas.filter(function (item) {
                    return item.EnquiryID === $scope.EnquiryID;
                })[0];
                $scope.QuotationReference = item.PreparedquotationReference;
                $scope.Revision = $scope.Revision + 1;

                var Options = [];
                if ($scope.GetOptionsTable !== null && $scope.GetOptionsTable !== undefined) {
                    var Optval = 0;
                    angular.forEach($scope.GetOptionsTable, function (item) {
                        Optval++;
                        var Opt = "Option" + Optval;
                        angular.forEach(item, function (item1) {
                            Options.push({ PestItems: item1.PestItems, Frequency: item1.Frequency, Price: item1.Price, Option: Opt })
                        });
                    });
                }

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/preparedquotation/add",
                    data: {
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        IncludeSOR: $scope.IncludeSOR,
                        Options: Options,
                        Template: $scope.vm.TemplateName,
                        EnquiryID: $scope.EnquiryID,
                        PreparedquotationReference: $scope.QuotationReference,
                        Revision: $scope.Revision,
                        NewStatus: $scope.NewStatus,
                        GST: $scope.vm.GST,
                        GSTTotal: $scope.vm.GSTTotal,
                        TotalPrice: $scope.vm.TotalPrice,
                        StatusCreatedBy: $scope.StatusCreatedBy,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    var array = []
                    var myArray = $scope.Workflowdatas;
                    var item = [];
                    item = myArray.filter(function (item) {
                        return item.TypeName === 'CRM Leads' && item.LevelName === $scope.CurrentStatusID;
                    });
                    if (item.length != 0 && item != undefined) {
                        try {
                            if (item[0].NotifytoNextLevelApprover == true) {
                                $scope.NLevel = item[0].NextLevel;
                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                    return Workflowitem1.TypeName === 'CRM Leads' && Workflowitem1.LevelName === $scope.NexttoNextId;
                                });
                                try {
                                    if (Workflowitem1[0].EmailNotification == true) {
                                        if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                            angular.forEach($scope.Userdatas, function (value) {
                                                if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                    if (array.indexOf(value.Email) == -1) {
                                                        array.push(value.Email);
                                                    }
                                                }
                                            })
                                        }
                                        $scope.SendEmailQt = array.map(function (obj) { return obj }).join(',');
                                    }
                                } catch (err) { }
                            }
                        }
                        catch (e) { }
                    }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/lead/update",
                        data: {
                            _id: $scope.EnquiryID,
                            EnquiryReceivedBy: $scope.EnquiryReceivedBy,
                            LeadReferenceNo: $scope.LeadReferenceNo,
                            EnquiryDate: $scope.EnquiryDate,
                            Customer: $scope.Customer,
                            NatureofJob: $scope.NatureofJob,
                            Treatment: $scope.TreatmentMethod,
                            EnquiryMode: $scope.EnquiryMode,
                            CoverageArea: $scope.CoverageArea,
                            ContactMedium: $scope.ContactMedium,
                            SalesPerson: $scope.SalesPerson,
                            ExpectedResponseDate: $scope.ExpectedResponseDate,
                            InfestationLevel: $scope.InfestationLevel,
                            Confirmation: $scope.Confirmation,
                            EnquiryType: $scope.EnquiryType,
                            Quote: $scope.Quote,
                            Division: $scope.Division,
                            CustomerID: $scope.CustomerID,
                            EnquiryStatus: $scope.EnquiryStatus,
                            Status: $scope.CurrentStatus,
                            StatusID: $scope.CurrentStatusID,
                            SendEmailQt: $scope.SendEmailQt,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    $scope.CurrentStatus = $scope.Status;
                    $window.localStorage.setItem('TempQadded', "")
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationlogsubmit();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var Options = [];
                if ($scope.GetOptionsTable !== null && $scope.GetOptionsTable !== undefined) {
                    var Optval = 0;
                    angular.forEach($scope.GetOptionsTable, function (item) {
                        Optval++;
                        var Opt = "Option" + Optval;
                        angular.forEach(item, function (item1) {
                            Options.push({ PestItems: item1.PestItems, Frequency: item1.Frequency, Price: item1.Price, Option: Opt })
                        });
                    });
                }
                $scope.Revision = 0;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/preparedquotation/add",
                    data: {
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        IncludeSOR: $scope.IncludeSOR,
                        Options: Options,
                        Template: $scope.vm.TemplateName,
                        EnquiryID: $scope.EnquiryID,
                        PreparedquotationReference: $scope.QuotationReference,
                        Revision: $scope.Revision,
                        NewStatus: $scope.NewStatus,
                        GST: $scope.vm.GST,
                        GSTTotal: $scope.vm.GSTTotal,
                        TotalPrice: $scope.vm.TotalPrice,
                        StatusCreatedBy: $scope.StatusCreatedBy,
                        StatusCreatedDate: $scope.StatusCreatedDate,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    var array = []
                    var myArray = $scope.Workflowdatas;
                    var item = [];
                    item = myArray.filter(function (item) {
                        return item.TypeName === 'CRM Leads' && item.LevelName === $scope.CurrentStatusID;
                    });
                    if (item.length != 0 && item != undefined) {
                        try {
                            if (item[0].NotifytoNextLevelApprover == true) {
                                $scope.NLevel = item[0].NextLevel;
                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                    return Workflowitem1.TypeName === 'CRM Leads' && Workflowitem1.LevelName === $scope.NexttoNextId;
                                });
                                try {
                                    if (Workflowitem1[0].EmailNotification == true) {
                                        if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                            angular.forEach($scope.Userdatas, function (value) {
                                                if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                    if (array.indexOf(value.Email) == -1) {
                                                        array.push(value.Email);
                                                    }
                                                }
                                            })
                                        }
                                        $scope.SendEmailQt = array.map(function (obj) { return obj }).join(',');
                                    }
                                } catch (err) { }
                            }
                        }
                        catch (e) { }
                    }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/lead/update",
                        data: {
                            _id: $scope.EnquiryID,
                            EnquiryReceivedBy: $scope.EnquiryReceivedBy,
                            LeadReferenceNo: $scope.LeadReferenceNo,
                            EnquiryDate: $scope.EnquiryDate,
                            Customer: $scope.Customer,
                            NatureofJob: $scope.NatureofJob,
                            Treatment: $scope.TreatmentMethod,
                            EnquiryMode: $scope.EnquiryMode,
                            CoverageArea: $scope.CoverageArea,
                            ContactMedium: $scope.ContactMedium,
                            SalesPerson: $scope.SalesPerson,
                            ExpectedResponseDate: $scope.ExpectedResponseDate,
                            InfestationLevel: $scope.InfestationLevel,
                            Confirmation: $scope.Confirmation,
                            EnquiryType: $scope.EnquiryType,
                            Quote: $scope.Quote,
                            Division: $scope.Division,
                            CustomerID: $scope.CustomerID,
                            EnquiryStatus: $scope.EnquiryStatus,
                            Status: $scope.CurrentStatus,
                            StatusID: $scope.CurrentStatusID,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            SendEmailQt: $scope.SendEmailQt,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {

                        $scope.GListdata = GList.data.data;
                        var SenderEmails = [];
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (item) {
                            return item.TypeName === 'CRM Leads' && item.LevelName === $scope.GListdata.StatusID;
                        });
                        try {
                            if (Workflowitem[0].EmailNotification == true) {
                                if (Workflowitem[0].NotifytoCurrentApprover == true) {
                                    if (Workflowitem[0].Approvers != null && Workflowitem[0].Approvers != undefined && Workflowitem[0].Approvers != "") {
                                        angular.forEach($scope.Userdatas, function (value) {
                                            if (Workflowitem[0].Approvers.indexOf(value.UserID) > -1) {
                                                if (SenderEmails.indexOf(value.Email) == -1) {
                                                    SenderEmails.push(value.Email);
                                                }
                                            }
                                        })
                                    }
                                }
                                if (Workflowitem[0].NotifytoCreatorInitator == true) {
                                    var UserArray = $scope.Userdatas;
                                    var item = UserArray.filter(function (item) {
                                        return item.UserID === $scope.GListdata.CreatedBy;
                                    })[0];
                                    if (SenderEmails.indexOf(item.Email) == -1) {
                                        SenderEmails.push(item.Email);
                                    }
                                }
                                if (Workflowitem[0].NotifyTo != null && Workflowitem[0].NotifyTo != undefined && Workflowitem[0].NotifyTo != "") {
                                    angular.forEach($scope.Userdatas, function (value) {
                                        if (Workflowitem[0].NotifyTo.indexOf(value.UserID) > -1) {
                                            if (SenderEmails.indexOf(value.Email) == -1) {
                                                SenderEmails.push(value.Email);
                                            }
                                        }
                                    })
                                }
                                if (Workflowitem[0].NotifytoNextLevelApprover == true) {
                                    $scope.NLevel = Workflowitem[0].NextLevel;
                                    var myArray1 = $scope.Workflowdatas;
                                    var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                        return Workflowitem1.TypeName === 'CRM Leads' && Workflowitem1.LevelName === $scope.NexttoNextId;
                                    });
                                    if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                        angular.forEach($scope.Userdatas, function (value) {
                                            if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                if (SenderEmails.indexOf(value.Email) == -1) {
                                                    SenderEmails.push(value.Email);
                                                }
                                            }
                                        })
                                    }
                                }
                                $scope.vm.SenderEmailAddress = SenderEmails.map(function (obj) { return obj }).join(',');
                                if (SenderEmails.length != 0) {
                                    angular.forEach(SenderEmails, function (value) {
                                        var mailresponse = $http({
                                            method: "POST",
                                            url: $rootScope.WebURL + "/lead/workflowemail",
                                            data: {
                                                SenderEmailAddress: value,
                                                Enquiry: $scope.GListdata.LeadReferenceNo,
                                                EnquiryDate: $scope.EnquiryDate,
                                                CompanyName: $scope.Customer,
                                                Status: $scope.GListdata.Status,
                                                CreatedBy: $rootScope.createdby,
                                            },
                                        });
                                    })
                                }
                            }
                        } catch (e) { }
                    })
                    $window.localStorage.setItem('TempQadded', "")
                    quotationlogsubmit();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.sSave = function () {
            try {
                var item1 = $scope.Quotationdatas.filter(function (item1) {
                    return item1.TableEnquiryID2 === $scope.EnquiryID;
                })[0];
                $scope.Inserted = item1.Inserted;
                $scope.Inserted_Id = item1.id;
            }
            catch (e) { }
            if ($scope.Inserted == true || $scope.Inserted == "true") {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/delete",
                    data: {
                        _id: $scope.Inserted_Id,
                    },
                });
                response.then(function (GList) {
                    var addresponse = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/quotation/add",
                        data: {
                            Inserted: true,
                            Subject: $scope.Subject,
                            TermsCondition: $scope.TermsCondition,
                            Footer: $scope.Footer,
                            Header: $scope.Header,
                            TableEnquiryID2: $scope.EnquiryID,
                            Client_Id: $rootScope.Client_Id,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                        },
                    });
                    addresponse.then(function (GList) {
                        $mdToast.show($mdToast.simple().textContent('Successfully Saved!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                    });
                }, function () {
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotation/add",
                    data: {
                        Inserted: true,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        TableEnquiryID2: $scope.EnquiryID,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Saved!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Preview = function (invoice) {
            $scope.Previewdiv = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            popupWinindow.document.close($scope.Previewdiv = false);
        }
        $scope.Selected = localStorage.getItem('Selected')
        $scope.SelectTemplate = function (TId) {

            if ($scope.Selected == false) {
                var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
                var pass = "";
                for (var x = 0; x < 8; x++) {
                    var i = Math.floor(Math.random() * chars.length);
                    pass += chars.charAt(i);
                }
                $scope.cloneTableTempID = pass
                $scope.TemplateID = pass
                angular.forEach($scope.Quotationtemplates, function (value) {
                    if (value.id == TId) {

                        $scope.vm.TableTitleID = value.TableTitleID;
                        $scope.vm.TemplateName = value.TemplateName;
                        $scope.TableTitle = value.TableTitle;
                        $scope.Subject = value.Subject;
                        $scope.TermsCondition = value.TermsCondition;
                        $scope.Footer = value.Footer;
                        $scope.Header = value.Header;
                        $scope.TableTempID = value.TemplateID;
                    }
                });
                angular.forEach($scope.Quotationdatas, function (pvalue) {
                    if (pvalue.TableTempID3 == $scope.TableTempID) {

                        $scope.vm.TableTitle3 = pvalue.TableTitle3;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/add",
                            data: {
                                TableTitle3: pvalue.TableTitle3,
                                TableEnquiryID3: $scope.EnquiryID,
                                TableTempID3: $scope.cloneTableTempID,
                                T3Description: pvalue.T3Description,
                                T3Quantity: pvalue.T3Quantity,
                                T3UnitRate: pvalue.T3UnitRate,
                                T3Amount: pvalue.T3Amount,
                                Client_Id: $rootScope.Client_Id,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                        if (pvalue.TableTempID1 == $scope.TableTempID) {
                            $scope.vm.TableTitle1 = pvalue.TableTitle1;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle1: pvalue.TableTitle1,
                                    TableEnquiryID1: $scope.EnquiryID,
                                    TableTempID1: $scope.cloneTableTempID,
                                    T1PestType: pvalue.T1PestType,
                                    T1Timing: pvalue.T1Timing,
                                    T1Frequency: pvalue.T1Frequency,
                                    T1Pricing: pvalue.T1Pricing,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                        if (pvalue.TableTempID2 == $scope.TableTempID) {
                            $scope.vm.TableTitle2 = pvalue.TableTitle2;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle2: pvalue.TableTitle2,
                                    TableEnquiryID2: $scope.EnquiryID,
                                    TableTempID2: $scope.cloneTableTempID,
                                    T2PestType: pvalue.T2PestType,
                                    T2Timing: pvalue.T2Timing,
                                    T2Quantity: pvalue.T2Quantity,
                                    T2Frequency: pvalue.T2Frequency,
                                    T2Pricing: pvalue.T2Pricing,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                        if (pvalue.TableTempID4 == $scope.TableTempID) {
                            $scope.vm.TableTitle4 = pvalue.TableTitle4;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle4: pvalue.TableTitle4,
                                    TableEnquiryID4: $scope.EnquiryID,
                                    TableTempID4: $scope.cloneTableTempID,
                                    T4Product: pvalue.T4Product,
                                    T4NoOfPieces: pvalue.T4NoOfPieces,
                                    T4Pricing: pvalue.T4Pricing,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                        if (pvalue.TableTempID5 == $scope.TableTempID) {
                            $scope.vm.TableTitle5 = pvalue.TableTitle5;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle5: pvalue.TableTitle5,
                                    TableEnquiryID5: $scope.EnquiryID,
                                    TableTempID5: $scope.cloneTableTempID,
                                    T5Product: pvalue.T5Product,
                                    T5Quantity: pvalue.T5Quantity,
                                    T5LeasingUnitPrice: pvalue.T5LeasingUnitPrice,
                                    T5SellingUnitPrice: pvalue.T5SellingUnitPrice,
                                    T5Photo: pvalue.T5Photo.src,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                        if (pvalue.TableTempID6 == $scope.TableTempID) {
                            $scope.vm.TableTitle6 = pvalue.TableTitle6;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle6: pvalue.TableTitle6,
                                    TableEnquiryID6: $scope.EnquiryID,
                                    TableTempID6: $scope.cloneTableTempID,
                                    T6Description: pvalue.T6Description,
                                    T6Price: pvalue.T6Price,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                        if (pvalue.TableTempID7 == $scope.TableTempID) {
                            $scope.vm.TableTitle7 = pvalue.TableTitle7;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle7: pvalue.TableTitle7,
                                    TableEnquiryID7: $scope.EnquiryID,
                                    TableTempID7: $scope.cloneTableTempID,
                                    T7PartNo: pvalue.T7PartNo,
                                    T7ForModelNo: pvalue.T7ForModelNo,
                                    T7NoOfLightTubesNeed: pvalue.T7NoOfLightTubesNeed,
                                    T7SellingPricing: pvalue.T7SellingPricing,
                                    T7Lifespan: pvalue.T7Lifespan,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                        if (pvalue.TableTempID8 == $scope.TableTempID) {
                            $scope.vm.TableTitle8 = pvalue.TableTitle8;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle8: pvalue.TableTitle8,
                                    TableEnquiryID8: $scope.EnquiryID,
                                    TableTempID8: $scope.cloneTableTempID,
                                    T8ForModelNo: pvalue.T8ForModelNo,
                                    T8NoOfBoardsNeeded: pvalue.T8NoOfBoardsNeeded,
                                    T8SellingPricing: pvalue.T8SellingPricing,
                                    T8Lifespan: pvalue.T8Lifespan,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                });
                $window.localStorage.setItem('Selected', true)
                $scope.Selected = true;
            }
            else {
                angular.forEach($scope.Quotationdatas, function (pvalue) {
                    if (pvalue.TableEnquiryID1 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID2 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID3 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID4 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID5 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID6 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID7 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID8 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                });

                angular.forEach($scope.Quotationtemplates, function (value) {
                    if (value.id == TId) {
                        $scope.vm.TableTitleID = value.TableTitleID;
                        $scope.vm.TemplateName = value.TemplateName;
                        $scope.TableTitle = value.TableTitle;
                        $scope.Subject = value.Subject;
                        $scope.TermsCondition = value.TermsCondition;
                        $scope.Footer = value.Footer;
                        $scope.Header = value.Header;
                        $scope.TableTempID = value.TemplateID;
                        $scope.uEmployeeID = value.id;
                    }
                });
                angular.forEach($scope.Quotationdatas, function (pvalue) {
                    if ($scope.TableTitle.split(",").includes("TableTitle1")) {
                        if (pvalue.TableTempID1 == $scope.TableTempID) {
                            $scope.vm.TableTitle1 = pvalue.TableTitle1;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle1: pvalue.TableTitle1,
                                    TableEnquiryID1: $scope.EnquiryID,
                                    TableTempID1: $scope.cloneTableTempID,
                                    T1PestType: pvalue.T1PestType,
                                    T1Timing: pvalue.T1Timing,
                                    T1Frequency: pvalue.T1Frequency,
                                    T1Pricing: pvalue.T1Pricing,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle2")) {
                        if (pvalue.TableTempID2 == $scope.TableTempID) {
                            $scope.vm.TableTitle2 = pvalue.TableTitle2;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle2: pvalue.TableTitle2,
                                    TableEnquiryID2: $scope.EnquiryID,
                                    TableTempID2: $scope.cloneTableTempID,
                                    T2PestType: pvalue.T2PestType,
                                    T2Timing: pvalue.T2Timing,
                                    T2Quantity: pvalue.T2Quantity,
                                    T2Frequency: pvalue.T2Frequency,
                                    T2Pricing: pvalue.T2Pricing,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle3")) {
                        if (pvalue.TableTempID3 == $scope.TableTempID) {
                            $scope.vm.TableTitle3 = pvalue.TableTitle3;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle3: pvalue.TableTitle3,
                                    TableEnquiryID3: $scope.EnquiryID,
                                    TableTempID3: $scope.cloneTableTempID,
                                    T3Description: pvalue.T3Description,
                                    T3Quantity: pvalue.T3Quantity,
                                    T3UnitRate: pvalue.T3UnitRate,
                                    T3Amount: pvalue.T3Amount,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle4")) {
                        if (pvalue.TableTempID4 == $scope.TableTempID) {
                            $scope.vm.TableTitle4 = pvalue.TableTitle4;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle4: pvalue.TableTitle4,
                                    TableEnquiryID4: $scope.EnquiryID,
                                    TableTempID4: $scope.cloneTableTempID,
                                    T4Product: pvalue.T4Product,
                                    T4NoOfPieces: pvalue.T4NoOfPieces,
                                    T4Pricing: pvalue.T4Pricing,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle5")) {
                        if (pvalue.TableTempID5 == $scope.TableTempID) {
                            $scope.vm.TableTitle5 = pvalue.TableTitle5;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle5: pvalue.TableTitle5,
                                    TableEnquiryID5: $scope.EnquiryID,
                                    TableTempID5: $scope.cloneTableTempID,
                                    T5Product: pvalue.T5Product,
                                    T5Quantity: pvalue.T5Quantity,
                                    T5LeasingUnitPrice: pvalue.T5LeasingUnitPrice,
                                    T5SellingUnitPrice: pvalue.T5SellingUnitPrice,
                                    T5Photo: pvalue.T5Photo.src,
                                    Client_Id: $rootScope.Client_Id,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle6")) {
                        if (pvalue.TableTempID6 == $scope.TableTempID) {
                            $scope.vm.TableTitle6 = pvalue.TableTitle6;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle6: pvalue.TableTitle6,
                                    TableEnquiryID6: $scope.EnquiryID,
                                    TableTempID6: $scope.cloneTableTempID,
                                    T6Description: pvalue.T6Description,
                                    T6Price: pvalue.T6Price,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle7")) {
                        if (pvalue.TableTempID7 == $scope.TableTempID) {
                            $scope.vm.TableTitle7 = pvalue.TableTitle7;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle7: pvalue.TableTitle7,
                                    TableEnquiryID7: $scope.EnquiryID,
                                    TableTempID7: $scope.cloneTableTempID,
                                    T7PartNo: pvalue.T7PartNo,
                                    T7ForModelNo: pvalue.T7ForModelNo,
                                    T7NoOfLightTubesNeed: pvalue.T7NoOfLightTubesNeed,
                                    T7SellingPricing: pvalue.T7SellingPricing,
                                    T7Lifespan: pvalue.T7Lifespan,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                    if ($scope.TableTitle.split(",").includes("TableTitle8")) {
                        if (pvalue.TableTempID8 == $scope.TableTempID) {
                            $scope.vm.TableTitle8 = pvalue.TableTitle8;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/quotation/add",
                                data: {
                                    TableTitle8: pvalue.TableTitle8,
                                    TableEnquiryID8: $scope.EnquiryID,
                                    TableTempID8: $scope.cloneTableTempID,
                                    T8ForModelNo: pvalue.T8ForModelNo,
                                    T8NoOfBoardsNeeded: pvalue.T8NoOfBoardsNeeded,
                                    T8SellingPricing: pvalue.T8SellingPricing,
                                    T8Lifespan: pvalue.T8Lifespan,
                                    CreatedBy: $rootScope.createdby, IsActive: "true",
                                },
                            });
                            response.then(function (GList) {
                                QRefreshGrid();
                            }, function () {
                                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                            });
                        }
                    }
                });
                $window.localStorage.setItem('Selected', true)
                $scope.Selected = true;
            }
            $window.localStorage.setItem('TempQadded', true)
        }

        $scope.AddTermsAndCondition = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/templates/quotation/TermsAndCondition.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function preparequotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.TACUpdate = false;
            $scope.vm.Name = null;
            $scope.vm.AddTermsCondition = null;
        }
        $scope.loadtc = function (tc) {
            $scope.TermsCondition = tc;
        }
        $scope.TermsAndConditionSubmit = function () {
            if ($scope.TACUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/termsAndCondition/update",
                    data: {
                        _id: $scope.TACId,
                        Name: $scope.vm.Name,
                        TermsCondition: $scope.vm.AddTermsCondition,
                        UpdatedBy: $rootScope.createdby, IsActive: true,

                    },
                });
                response.then(function (GList) {
                    $scope.TACUpdate = false;
                    $scope.vm.Name = null;
                    $scope.vm.AddTermsCondition = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/termsAndCondition",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (termsAndConditiondata) {
                        $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/termsAndCondition/add",
                    data: {
                        Name: $scope.vm.Name,
                        TermsCondition: $scope.vm.AddTermsCondition,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    $scope.TACUpdate = false;
                    $scope.vm.Name = null;
                    $scope.vm.AddTermsCondition = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/termsAndCondition",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (termsAndConditiondata) {
                        $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                    });

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.TermsAndConditioninfo = function (Id, name, tc) {
            $scope.TACId = Id;
            $scope.vm.Name = name;
            $scope.vm.AddTermsCondition = tc;
            $scope.TACUpdate = true;
        }
        $scope.TermsAndConditionDelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/termsAndCondition/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/termsAndCondition",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (termsAndConditiondata) {
                    $scope.TermsAndConditiondatas = termsAndConditiondata.data.data;
                });
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.SaveasTemplatesubmit = function () {
            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }

            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotationtemplate/update",
                    data: {
                        _id: $scope.vm.SID,
                        TemplateID: $scope.TemplateID,
                        TemplateName: $scope.vm.TemplateName,
                        Division: $scope.vm.Division,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotationtemplate/add",
                    data: {
                        TemplateID: $scope.TemplateID,
                        TemplateName: $scope.vm.TemplateName,
                        Division: $scope.vm.Division,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    if (GList.data.message == "Existing TemplateName") {
                        $scope.Quotationform = true;
                        $scope.error1 = true;
                    }
                    else {
                        $mdToast.show($mdToast.simple().textContent('Template Saved!').position('top center'));
                        $scope.Quotationform = true;
                        $mdDialog.cancel();
                    }
                    $mdToast.show($mdToast.simple().textContent('Template Saved!').position('top center'));

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.EditAction = function (e, CTable, Id) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/preparequotation/preparequotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function preparequotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = true;
            $scope.vm.T3Description = null;
            $scope.vm.T3Quantity = 0;
            $scope.vm.T3UnitRate = 0;
            $scope.vm.T3Amount = 0;


            $scope.vm.T1PestType = null;
            $scope.vm.T1Timing = null;
            $scope.vm.T1Frequency = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Product = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5LeasingUnitPrice = null;
            $scope.vm.T5SellingUnitPrice = null;
            $scope.vm.T5Photo = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7PartNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7NoOfLightTubesNeed = null;
            $scope.vm.T7SellingPricing = null;
            $scope.vm.T7Lifespan = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;

            if (CTable == 'Title3') {
                $scope.Title3 = true;
                $scope.TableTitle = $scope.vm.TableTitle3;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Quotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T3Description = item.T3Description;
                    $scope.vm.T3Quantity = parseInt(item.T3Quantity);
                    $scope.vm.T3UnitRate = parseInt(item.T3UnitRate);
                    $scope.vm.T3Amount = parseInt(item.T3Amount);
                } catch (e) { }
            }
            else { $scope.vm.QRT_Id = null; }

        }
        $scope.PestManagement = function (e, CTable) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/preparequotation/preparequotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function preparequotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;

            $scope.TableTitle = $scope.vm.TableTitle3;
            $scope.vm.T3Description = null;
            $scope.vm.T3Quantity = 0;
            $scope.vm.T3UnitRate = 0;
            $scope.vm.T3Amount = 0;

            $scope.vm.T1PestType = null;
            $scope.vm.T1Timing = null;
            $scope.vm.T1Frequency = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Product = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5LeasingUnitPrice = null;
            $scope.vm.T5SellingUnitPrice = null;
            $scope.vm.T5Photo = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7PartNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7NoOfLightTubesNeed = null;
            $scope.vm.T7SellingPricing = null;
            $scope.vm.T7Lifespan = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;
        }
        $scope.OptionsTable = function (e) {
            $scope.vm.tPestType = null;
            $scope.vm.tFrequency = null;
            $scope.vm.tPrice = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/preparequotation/OptionsPopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function preparequotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.PestType = $scope.NatureofJob;
            $scope.Treatment = $scope.TreatmentMethod;

            if ($scope.PestType != null && $scope.PestType != "" && $scope.PestType != undefined) {
                var array = [];
                array = $scope.PestType.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                    var Test = [];
                    if ($scope.Treatment != null && $scope.Treatment != "" && $scope.Treatment != undefined) {

                        var array2 = [];
                        array2 = $scope.Treatment.split(",");
                        var FilterTreat = [];

                        angular.forEach(array2, function (item) {

                            FilterTreat = $scope.Treatmentdatas.filter(function (item1) {
                                return item === item1.TreatmentName;
                            })[0];

                            if (FilterTreat != null) {

                                if (FilterTreat.PestType != null && FilterTreat.PestType != undefined && FilterTreat.PestType != "") {
                                    var SplitPest = [];
                                    SplitPest = FilterTreat.PestType.split(",");
                                    var PestTest = SplitPest.filter(function (item1) {
                                        return value === item1;
                                    })[0];
                                    if (PestTest != undefined) {
                                        Test.push({
                                            PestName: PestTest,
                                            TreatmentName: FilterTreat.TreatmentName
                                        });

                                    }

                                }
                            }
                        });

                    }
                    if (Test != null && Test.length > 1) {
                        angular.forEach(Test, function (item) {
                            array1.push({
                                PestName: item.PestName + "~(" + item.TreatmentName + ")"
                            });
                        });
                    } else {
                        array1.push({
                            PestName: value
                        });
                    }
                });

                $scope.PestType = array1;
            }

            //Filter Pest Redudancy
            if ($scope.LeadOptionsTabledata !== null) {
                var getIndex = [];
                angular.forEach($scope.LeadOptionsTabledata, function (item) {
                    var Pest = item.PestCoverage;
                    var array = [];
                    array = Pest.split(",");
                    angular.forEach($scope.PestType, function (item1) {
                        var Filterarray = array.filter(function (value) {
                            return value === item1.PestName;
                        })[0];

                        if (item1.PestName == Filterarray) {
                            getIndex.push(item1);
                        }
                    })
                });
                if (getIndex != null) {
                    angular.forEach(getIndex, function (item) {
                        var index = $scope.PestType.indexOf(item);
                        $scope.PestType.splice(index, 1);
                    })
                }

            }
        }
        $scope.OptionsSubmit = function () {
            if ($scope.vm.tPestType != null && $scope.vm.tPestType != "" && $scope.vm.tPestType != undefined) {
                $scope.vm.tPestType = $scope.vm.tPestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/leadoptionstable/add",
                data: {
                    LeadID: $scope.EnquiryID,
                    PestCoverage: $scope.vm.tPestType,
                    Frequency: $scope.vm.tFrequency,
                    Price: $scope.vm.tPrice,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                LoadOptionsTable();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        LoadOptions();
        function LoadOptions() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/leadoptionstable",
                data: { Client_Id: $rootScope.Client_Id, LeadId: $scope.EnquiryID },
            }).then(function (data) {
                $scope.LeadTabledata = data.data.data;
                if ($scope.LeadTabledata !== null && $scope.LeadTabledata.length > 0) {
                    var OptionsTable = [];

                    var Pestdata = $scope.LeadTabledata.map(function (obj) { return obj.PestCoverage; }).join(',');
                    Pestdata = Pestdata.split(',');
                    angular.forEach(Pestdata, function (item) {
                        var split = item.split('~');
                        if (split.length > 1) {
                            OptionsTable.push(item);
                        }
                    });
                    $scope.Options = [];
                    if (OptionsTable !== null && OptionsTable.length > 0) {

                        for (i = 0; i < OptionsTable.length; i++) {

                            $scope.Options;
                            var el = OptionsTable.filter(function (item) {
                                return item !== OptionsTable[i];
                            });
                            $scope.tOptions = [];
                            angular.forEach($scope.LeadTabledata, function (item) {

                                var PestItem = item.PestCoverage;
                                PestItem = PestItem.split(',');

                                angular.forEach(el, function (item1) {

                                    var CheckItem = PestItem.filter(function (value) {
                                        return value === item1
                                    })[0];

                                    if (CheckItem !== undefined && CheckItem !== null) {
                                        var index = PestItem.indexOf(CheckItem);
                                        PestItem.splice(index, 1);

                                    }
                                });

                                PestItem = PestItem.map(function (obj) { return obj; }).join(',');
                                if (PestItem !== "" && PestItem !== undefined && PestItem !== null) {
                                    $scope.tOptions.push({ PestItems: PestItem, Frequency: item.Frequency, Price: item.Price });
                                }
                            });
                            $scope.Options[i] = $scope.tOptions;
                        }

                    } else {
                        $scope.tOptions = [];
                        angular.forEach($scope.LeadTabledata, function (item) {
                            $scope.tOptions.push({ PestItems: item.PestCoverage, Frequency: item.Frequency, Price: item.Price });

                        });
                        $scope.Options.push($scope.tOptions);
                    }

                }
            })
        }
        LoadOptionsTable();
        function LoadOptionsTable() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/leadoptionstable",
                data: { Client_Id: $rootScope.Client_Id, LeadId: $scope.EnquiryID },
            }).then(function (data) {
                $scope.LeadOptionsTabledata = data.data.data;
                LoadOptions();

            });
        }
        $scope.GetSelectedOptions = function (value, Select) {
            if ($scope.GetOptionsTable == undefined || $scope.GetOptionsTable == null) {
                $scope.GetOptionsTable = [];
            }
            if (value == true) {
                $scope.GetOptionsTable.push(Select);

            } else if (value == false) {
                var index = $scope.GetOptionsTable.indexOf(Select);
                $scope.GetOptionsTable.splice(index, 1);
            }
        }
        $scope.QDelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                quotationRefreshGrid()
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            var Added = localStorage.getItem('TempQadded')
            if (Added == "true") {
                angular.forEach($scope.Quotationdatas, function (pvalue) {
                    if (pvalue.TableEnquiryID1 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID2 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID3 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID4 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID5 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID6 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID7 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableEnquiryID8 == $scope.EnquiryID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/quotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            QRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                });
                $window.localStorage.setItem('PQfromLead', "");
                $window.localStorage.setItem('Selected', "")
                $window.localStorage.setItem('TempQadded', "")
                $state.go('app.lead');
            }
            else {
                $window.localStorage.setItem('PQfromLead', "");
                $window.localStorage.setItem('Selected', "")
                $window.localStorage.setItem('TempQadded', "")
                $state.go('app.lead');
                //$window.localStorage.setItem('idfromPQ', $scope.EnquiryID);
                //$location.path('Lead');
            }
        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/quotationtemplate/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: $scope.EnquiryID, FileID: 'PrepareQuotation',
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.productphoto = function (Pid) {
            angular.forEach($scope.Attachmentdatas, function (value) {
                if (value.TableID == Pid) {
                    $scope.uICBack = value.Data;
                }
            });
        }
        function quotationlogsubmit() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationlog/add",
                data: {
                    EnquiryID: $scope.EnquiryID,
                    Status: $scope.CurrentStatus,
                    StatusCreatedBy: $scope.createdby,
                    StatusCreatedDate: new Date(),
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                $window.localStorage.setItem('PQfromLead', "");
                $window.localStorage.setItem('Selected', "")
                //$window.localStorage.setItem('idfromPQ', $scope.EnquiryID);
                $state.go('app.lead');
                // $location.path('Lead');
                $scope.Quotationform = true;
            })
        }
        $scope.Back = function () {
            $window.localStorage.setItem('PQfromLead', "");
            $window.localStorage.setItem('Selected', "")
            $window.localStorage.setItem('idfromPQ', $scope.EnquiryID);
            $state.go('app.lead');
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/user/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Userdata) {
            $scope.Userdatas = Userdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/Workflow",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Workflowdata) {
            $scope.Workflowdatas = Workflowdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item;
            }
            catch (e) { }
        });
        $http.get($rootScope.WebURL + "/attachment")
            .then(function (Attachmentdata) {
                $scope.Attachmentdatas = Attachmentdata.data.data;
                angular.forEach($scope.Attachmentdatas, function (qvalue) {
                    if (qvalue.Data != null && qvalue.Data != '' && qvalue.Data != undefined) {
                        qvalue.Data = decode_base64(qvalue.Data);
                    }
                })
            });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/product",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Productdata) {
            $scope.Productdatas = Productdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmdivision",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Divisiondata) {
            $scope.Divisiondatas = Divisiondata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/areas",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (areasdata) {
            $scope.areasdatas = areasdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotationtemplate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (quotationtemplate) {
            $scope.Quotationtemplates = quotationtemplate.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/preparedquotation",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (preparedquotationdata) {
            $scope.Preparedquotationdatas = preparedquotationdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotation",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (preparequotationdata) {
            $scope.Quotationdatas = preparequotationdata.data.data;
            var total = 0;
            angular.forEach($scope.Quotationdatas, function (value) {
                if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                    value.T5Photo = decode_base64(value.T5Photo);
                }
                if (value.TableEnquiryID3 == $scope.EnquiryID) {
                    try {
                        if (value.T3Pricing == null || value.T3Pricing == undefined || value.T3Pricing == "" || value.T2Pricing == "undefined") {
                            value.T3Pricing = 0;
                        }
                        total += parseFloat(value.T3Pricing);
                    }
                    catch (e) { }
                }
            })
            var gst = (total * $scope.vm.GST) / 100;
            $scope.vm.TotalPrice = gst + total;
            $scope.vm.GSTTotal = gst;
            init();
        });


        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item;
            }
            catch (e) { }
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/treatment",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Treatmentdata) {
            $scope.Treatmentdatas = Treatmentdata.data.data;
            $scope.Treatmentdatalength = Treatmentdata.data.data.length;
        });
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (preparequotationdata) {
                $scope.Quotationdatas = preparequotationdata.data.data;
                var total = 0;
                angular.forEach($scope.Quotationdatas, function (value) {
                    if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                        value.T5Photo = decode_base64(value.T5Photo);
                    }
                    if (value.TableEnquiryID3 == $scope.EnquiryID) {
                        try {
                            if (value.T3Pricing == null || value.T3Pricing == undefined || value.T3Pricing == "" || value.T2Pricing == "undefined") {
                                value.T3Pricing = 0;
                            }
                            total += parseFloat(value.T3Pricing);
                        }
                        catch (e) { }
                    }
                })
                var gst = (total * $scope.vm.GST) / 100;
                $scope.vm.TotalPrice = gst + total;
                $scope.vm.GSTTotal = gst;
            });
            $http.get($rootScope.WebURL + "/attachment")
                .then(function (Attachmentdata) {
                    $scope.Attachmentdatas = Attachmentdata.data.data;
                    angular.forEach($scope.Attachmentdatas, function (qvalue) {
                        if (qvalue.Data != null && qvalue.Data != '' && qvalue.Data != undefined) {
                            qvalue.Data = decode_base64(qvalue.Data);
                        }
                    })
                });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.Pestdatas = pestdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/areas",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (areasdata) {
                $scope.areasdatas = areasdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationtemplate",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (quotationtemplate) {
                $scope.Quotationtemplates = quotationtemplate.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/crmdivision",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Divisiondata) {
                $scope.Divisiondatas = Divisiondata.data.data;
            });
        }
        function quotationRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (preparequotationdata) {
                $scope.Quotationdatas = preparequotationdata.data.data;
                var total = 0;
                angular.forEach($scope.Quotationdatas, function (value) {
                    if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                        value.T5Photo = decode_base64(value.T5Photo);
                    }
                    if (value.TableEnquiryID3 == $scope.EnquiryID) {
                        try {
                            if (value.T3Amount == null || value.T3Amount == undefined || value.T3Amount == "" || value.T3Amount == "undefined") {
                                value.T3Amount = 0;
                            }
                            total += parseFloat(value.T3Amount);
                        }
                        catch (e) { }
                    }
                })
                var gst = (total * $scope.vm.GST) / 100;
                $scope.vm.TotalPrice = gst + total;
                $scope.vm.GSTTotal = gst;
            });
        }
        function QRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (preparequotationdata) {

                $scope.Quotationdatas = preparequotationdata.data.data;
                var total = 0;
                angular.forEach($scope.Quotationdatas, function (value) {
                    if (value.T5Photo != null && value.T5Photo != '' && value.T5Photo != undefined) {
                        value.T5Photo = decode_base64(value.T5Photo);
                    }
                    if (value.TableEnquiryID3 == $scope.EnquiryID) {
                        try {
                            if (value.T3Amount == null || value.T3Amount == undefined || value.T3Amount == "" || value.T3Amount == "undefined") {
                                value.T3Amount = 0;
                            }
                            total += parseFloat(value.T3Amount);
                        }
                        catch (e) { }
                    }
                })
                var gst = (total * $scope.vm.GST) / 100;
                $scope.vm.TotalPrice = gst + total;
                $scope.vm.GSTTotal = gst;
            });
        }
        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }
        var vm = this;
        //// Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true,
            destroy: true
        };
    }

})();
(function ()
{
    'use strict';

    angular
    .module('apps.crm.lead', ['ngMaterialDatePicker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.lead', {
            url: '/Lead',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/lead/lead.html',
                    controller: 'LeadController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/lead');
    }

})();
(function () {
  'use strict';

  angular
    .module('apps.crm.lead')
    .controller('LeadController', LeadController)
    .filter('groupBy', function () {
      return _.memoize(function (items, field) {
        return _.groupBy(items, field);
      }
      );
    })
  // .directive('chooseFile', function () {
  //   return {
  //     link: function (scope, elem, attrs) {
  //       var button = angular.element(elem[0].querySelector('button#uploadButton'))
  //       var Clearbutton = angular.element(elem[0].querySelector('button#clearButton'))
  //       var input = angular.element(elem[0].querySelector('input#fileInput'));
  //       button.bind('click', function () {
  //         input[0].click();
  //       });
  //       Clearbutton.bind('click', function () {
  //         var input = angular.element(elem[0].querySelector('input#fileInput')).val('');
  //         scope.fileName = '';
  //       });
  //       input.bind('change', function (e) {
  //         scope.$apply(function () {
  //           var files = e.target.files;
  //           if (files[0]) {
  //             scope.fileName = files[0].name;
  //             scope.UploadButtonName = 'Change'
  //             scope.UploadButton = true
  //             scope.ClearButton = true
  //             var reader = new FileReader();
  //             reader.onload = function (e) {
  //               $('#imagePreview').attr('src', e.target.result)
  //                 .width(200)
  //                 .height(70);
  //             };
  //             scope.FilePath = null;
  //             reader.readAsDataURL(files[0]);
  //           } else {
  //             $('#imagePreview').attr('src', null);
  //             scope.fileName = null;
  //             scope.UploadButtonName = 'Upload Quotation'
  //             scope.ClearButton = false
  //           }
  //         });
  //       });
  //     }
  //   };
  // });

  function LeadController($mdDateLocale, $scope, $rootScope, $mdConstant, httpservice, $interval, $mdDialog, $mdSidenav, $window, $location, $document, $mdToast, $http, $log, $state, $timeout, Upload, NgMap, DataSyncService) {
    document.getElementsByTagName('title')[0].text = "Customer Relationship-Quote Management"
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("Lead")) { // do nothing 
    } else {
      $location.path("NoAccess");
    }
    var getRoleaccess = localStorage.getItem('Roles');
    var EmpID = localStorage.getItem('EmployeeID');
    $scope.Emp_Id = localStorage.getItem('EmpId');
    var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
    var vm = this;
    $scope.Leadform = false;
    $scope.Leadgrid = true;
    $scope.Export = true;
    $scope.Pageform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.uFrom = new Date(new Date().setMonth(new Date().getMonth() - 1));
    $scope.uTo = new Date();
    RefreshCustomerdatas();


    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log('markers', map.markers);
      console.log('shapes', map.shapes);
    });
    $scope.LExport = function () {
      alasql('SELECT * INTO XLSX("Leaddatas.xlsx",{headers:true}) FROM ?', [$scope.Leaddatas]);
    };
    $scope.items = [{
      a: 1,
      b: 10
    }, {
      a: 2,
      b: 20
    }, {
      a: 3,
      b: 30
    }];

    $scope.sAdd = function () {
      ClearForm();
      $scope.Update = false;
      $scope.Leadform = true;
      $scope.Leadgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.Pageform = false;
      $scope.Search = false;
      $scope.vm.EnqdateTime = new Date();

    }
    this.handleMouseEnter = function (Customer_id) {
      var info = $scope.Customerdatas
      var item = info.filter(function (item) {
        return item.id === Customer_id;
      })[0];
      $scope.vm.ppCustomerID = item.CustomerID;
      $scope.vm.ppCustomerType = item.CustomerType;
      $scope.vm.ppCustomerReference = item.CustomerReference;
      $scope.vm.ppSalutation = item.Salutation;
      $scope.vm.ppFirstName = item.FirstName;
      $scope.vm.ppLastName = item.LastName;
      $scope.vm.ppWebsite = item.Website;
      $scope.vm.ppCompanyName = item.CompanyName;
      $scope.vm.ppNote = item.Note;
      $scope.vm.ppAddress = item.Address;
      $scope.vm.ppAddress1 = item.Address1;
      $scope.vm.ppPostal = (item.Postal);
      $scope.vm.ppCountry = item.Country;
      $scope.vm.ppContactPerson = item.ContactPerson;
      $scope.vm.ppPhone = (item.Phone);
      $scope.vm.ppFax = item.Fax;
      $scope.vm.ppMobile = (item.Mobile);
      $scope.vm.ppEmail = item.Email;
      $scope.vm.ppBLK = item.BLK;
      $scope.vm.ppnit = item.Unit;
      $scope.vm.ppStreetName = item.StreetName;
      $scope.vm.ppBuildingName = item.BuildingName;
      $scope.vm.ppTypeofHouse = item.TypeofHouse;
      $scope.vm.ppOtherType = item.OtherType;
      $scope.vm.ppCategory = item.Category;
    }
    $scope.testes = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/CustomerInfo.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.Employeephoto = [{ photo: false }]
    $scope.EmployeehandleUpload = function ($files, $event, $flow) {
      if (($event.srcElement !== undefined) && ($event.srcElement !== null))
        var input = angular.element($event.srcElement)
      else
        var input = angular.element($event.originalTarget)
      if (input.scope().item) {
        if (input.scope().item.photo) {
          input.scope().item.photo.cancel();
        }
        input.scope().item.photo = $files[0];
      } else {
        for (var i = 0; i < $files.length; i++) {
          $scope.Employeephoto.push({
            photo: $files[i]
          });
        }
      }
    };
    $scope.Datefilter = function () {
      $scope.Leaddatas = [];
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/lead/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
        },
      });
      response.then(function (GList) {
        if (getRoleaccess.indexOf('Super User') > -1 || getRoleaccess.split(",").includes("Admin")) {
          $scope.Leaddatas = GList.data.data;
        }
        else {
          try {
            var item = GList.data.data.filter(function (item) {
              return item.CreatedBy == $rootScope.createdby;
            })
            $scope.Leaddatas = item;
          }
          catch (e) { }
        }
      });
    }

    $scope.placeChanged = function () {
      $scope.vm.uPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.uPostal = vm.place.address_components[i].long_name;
          }
        }
      }
    }
    $scope.Servicepopup = function (e, uCustomerID, PopupType) {
      $scope.vm.uCustomerID = uCustomerID;
      if (PopupType == 'Billing') {
        $scope.Billing = true;
        $scope.Service = false;
        $scope.PopupType = 'Billing';
        $scope.vm.ubBLK = null;
        $scope.vm.ubUnit = null;
        $scope.vm.ubPostal = null;
        $scope.vm.ubCountry = null;
        $scope.vm.ubContactPerson = null;
        $scope.vm.ubBuildingName = null;
        $scope.vm.ubStreetName = null;
        $scope.vm.ubMobile = null;
        $scope.vm.ubEmail = null;
        $scope.vm.sty = 45
      }
      if (PopupType == 'Service') {
        $scope.Service = true;
        $scope.Billing = false;
        $scope.PopupType = 'Service';
        $scope.vm.sty = 55
      }
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = [];
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false }
      $scope.Servicecopy = { value: false }
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/Service.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      })
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        })
      }
      else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) { return obj; }).join(',');
          }
          else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) { return obj; }).join(',');
          }
          else {
            $scope.vm.usCC = "";
          }
        }
        else {
          $mdToast.show($mdToast.simple().textContent('Enter valid CC !').position('top center'));
          return
        }
      }
      else {
        $mdToast.show($mdToast.simple().textContent('Enter valid email !').position('top center'));
        return
      }
      if ($scope.vm.usMobile != null && $scope.vm.usMobile != "" && $scope.vm.usMobile != undefined) {
        $scope.vm.usMobile = $scope.vm.usMobile.map(function (obj) { return obj; }).join(',');
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby, IsActive: "true",
          },
        });
        response.then(function (GList) {
          GList.data.data["_id"] = GList.data.data["id"];
          delete GList.data.data["id"];
          $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
          CustomerServicedatadetails();
          $mdDialog.cancel();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
      else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return item.sBLK == $scope.vm.usBLK && item.sUnit == $scope.vm.usUnit && item.sStreetName == $scope.vm.usStreetName && item.sCountry == $scope.vm.usCountry && item.sMobile == $scope.vm.usMobile;
          })
        }
        catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail,
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby, IsActive: "true",
            },
          });
          response.then(function (GList) {
            $scope.RequestID = $scope.vm.uCustomerID;
            CustomerServicedatadetails();
            $scope.Servicegrid = true;
            $mdDialog.cancel();
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
        else {
          $mdToast.show($mdToast.simple().textContent('Already Exist!').position('top center'));
          $mdDialog.cancel();
        }
      }
    }
    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = 'Service';
      $scope.vm.sty = 55
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = (item.sPostal);
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = []
        if (item.sMobile != null && item.sMobile != undefined && item.sMobile != "")
          $scope.vm.usMobile = item.sMobile.split(',');
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if ($scope.vm.usEmail != null && $scope.vm.usEmail != "" && $scope.vm.usEmail != undefined) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        }
        if ($scope.vm.usCC != null && $scope.vm.usCC != "" && $scope.vm.usCC != undefined) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        }
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/Service.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.cspopup = function (e, deleteID, Index, Type) {
      $scope.vm.deleteID = deleteID;
      $scope.vm.Index = Index;
      $scope.vm.DeleteType = Type;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/cspopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.Servicedelete = function (deleteID, Index) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customerService/delete",
        data: { _id: deleteID },
      });
      response.then(function (GList) {
        if ($scope.vm.DeleteType == 'Service') {
          $scope.CustomerServicedatas.splice(Index, 1);
        }
        else {
          $scope.CustomerBillingdatas.splice(Index, 1);
        }
        //CustomerServicedatadetails();
        $scope.Servicegrid = true;
        $scope.Add = false;
        $scope.Search = false;
        $mdDialog.cancel();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.Billingadd = function (Index) {
      if ($scope.BAUpdate == true) {
        $scope.BillingIndex = $scope.BillingIndex;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            bBLK: $scope.vm.ubBLK,
            bUnit: $scope.vm.ubUnit,
            bPostal: $scope.vm.ubPostal,
            bCountry: $scope.vm.ubCountry,
            bContactPerson: $scope.vm.ubContactPerson,
            bBuildingName: $scope.vm.ubBuildingName,
            bStreetName: $scope.vm.ubStreetName,
            bMobile: $scope.vm.ubMobile,
            bEmail: $scope.vm.ubEmail,
            UpdatedBy: $rootScope.createdby, IsActive: "true",
          },
        });
        response.then(function (GList) {
          GList.data.data["_id"] = GList.data.data["id"];
          delete GList.data.data["id"];
          $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
          CustomerServicedatadetails();
          $scope.Add = false;
          $scope.Search = false;
          $mdDialog.cancel();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
      else {
        var item = [];
        try {
          item = $scope.CustomerBillingdatas.filter(function (item) {
            return item.bBLK == $scope.vm.ubBLK && item.bUnit == $scope.vm.ubUnit && item.bStreetName == $scope.vm.ubStreetName && item.bCountry == $scope.vm.ubCountry && item.bMobile == $scope.vm.ubMobile
          })
        }
        catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          if ($scope.BAUpdate == true) {
            $scope.BillingIndex = $scope.BillingIndex;
            var response = $http({
              method: "PUT",
              url: $rootScope.WebURL + "/customerService/update",
              data: {
                _id: $scope.QID,
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                UpdatedBy: $rootScope.createdby, IsActive: "true",
              },
            });
            response.then(function (GList) {
              $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
              $scope.Add = false;
              $scope.Search = false;
              $mdDialog.cancel();
            }, function () {
              $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
          }
          else {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/customerService/add",
              data: {
                Type: "Billing",
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                CreatedBy: $rootScope.createdby, IsActive: "true",
              },
            });
            response.then(function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              CustomerBillingdatadetails();
              $scope.Servicegrid = true;
              $scope.Add = false;
              $scope.Search = false;
              $mdDialog.cancel();
            }, function () {
              $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
          }
        }
        else {
          $mdToast.show($mdToast.simple().textContent('Already Exist!').position('top center'));
        }
      }
    }
    $scope.Billingupdate = function (e, QId, Index) {
      $scope.BAUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.BillingIndex = Index;
      $scope.Billing = true;
      $scope.Service = false;
      $scope.vm.sty = 45
      try {
        var item = $scope.CustomerBillingdatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.ubBLK = item.bBLK;
        $scope.vm.ubUnit = item.bUnit;
        $scope.vm.ubPostal = (item.bPostal);
        $scope.vm.ubCountry = item.bCountry;
        $scope.vm.ubContactPerson = item.bContactPerson;
        $scope.vm.ubBuildingName = item.bBuildingName;
        $scope.vm.ubStreetName = item.bStreetName;
        $scope.vm.ubMobile = (item.bMobile);
        $scope.vm.ubEmail = item.bEmail;
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/Service.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.CCarray = [];
    $scope.AddCC = function (email) {
      try {
        if ($scope.CCarray.indexOf(email) == -1) {
          $scope.CCarray.push(email)
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    }
    $scope.Removeccs = function (i) {
      try {
        if ($scope.CCarray.indexOf(i) == -1) {
          $scope.CCarray.splice(i, 1)
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    }
    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }], dataGrid, ServicedataGrid, BillingdataGrid;;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $scope.leadclose = function (e, LeadId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/closealert.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.LeadId = LeadId;
    }
    $scope.CloseEnquiry = function (LeadId) {
      fetchLead(LeadId);
      $scope.vm.EnquiryStatus = "Closed";
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/lead/update",
        data: {
          _id: LeadId,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          LeadReferenceNo: $scope.vm.LeadReferenceNo,
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.Customer,
          NatureofJob: $scope.vm.NatureofJob1,
          EnquiryMode: $scope.vm.EnquiryMode,
          CoverageArea: $scope.vm.CoverageArea,
          ContactMedium: $scope.vm.ContactMedium,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          InfestationLevel: $scope.vm.InfestationLevel,
          Confirmation: $scope.vm.Confirmation,
          EnquiryType: $scope.vm.EnquiryType,
          Quote: $scope.vm.Quote,
          Division: $scope.vm.Division,
          CustomerID: $scope.vm.CustomerID,
          EnquiryStatus: $scope.vm.EnquiryStatus,
          Status: $scope.vm.CurrentStatus,
          StatusID: $scope.vm.CurrentStatusID,
          UpdatedBy: $rootScope.createdby,
          IsActive: true,
          Client_Id: $rootScope.Client_Id,
        },
      });
      response.then(function (GList) {
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Closed!').position('top center'));
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        RefreshGrid();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.Showgrid = function () {
      $scope.Leadgrid = true;
      $scope.Leadform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
      //if (!$.fn.DataTable.isDataTable('#maintable')) {
      //    //$('#maintable').dataTable();
      //}
      //else {
      //    $('#maintable').dataTable().fnDestroy();
      //}
    }
    $scope.ActionClick = function (e, LeadId) {
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/lead/update",
        data: {
          _id: $scope.SID,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          LeadReferenceNo: $scope.vm.LeadReferenceNo,
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.Customer,
          NatureofJob: $scope.vm.NatureofJob1,
          Treatment: $scope.vm.TreatmentMethod,
          EnquiryMode: $scope.vm.EnquiryMode,
          CoverageArea: $scope.vm.CoverageArea1,
          ContactMedium: $scope.vm.ContactMedium,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          InfestationLevel: $scope.vm.InfestationLevel,
          Confirmation: $scope.vm.Confirmation,
          EnquiryType: $scope.vm.EnquiryType,
          Quote: $scope.vm.Quote,
          Division: $scope.vm.Division,
          CustomerID: $scope.vm.CustomerID,
          EnquiryStatus: $scope.vm.EnquiryStatus,
          Status: $scope.cNextActioned,
          StatusID: $scope.cNextID,
          UpdatedBy: $rootScope.createdby,
          IsActive: "true",
          Client_Id: $rootScope.Client_Id,
        },
      });
      response.then(function (GList) {
        $scope.GListdata = GList.data.data;
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.Search = true;
        $scope.view = false;
        quotationlogsubmit();
        $mdToast.show($mdToast.simple().textContent('Successfully Done !').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.Addlead = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/addlead.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      })
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      ClearForm();
      $scope.UploadButtonName = 'Upload Quotation'
      $scope.vm.uCustomerID = pass;
      $scope.vm.EnquiryDate = new Date();
      var info = $scope.Leaddatas
      for (var x = 1001; x <= 1001 + info.length; x++) {
        var y = 'EQ/RN/' + x;
      }
      $scope.vm.LeadReferenceNo = y;
      $scope.UploadButton = true
      $scope.ClearButton = false
      $scope.vm.CurrentStatus = "New";
      $scope.vm.EnquiryStatus = "Open";
      $scope.vm.ppCompanyName = null;
      $scope.vm.EnquiryType = "Contract";
      $scope.vm.InfestationLevel = "Slight";
      $scope.fileName = ''
      var tdydate = new Date()
      $scope.vm.ExpectedResponseDate = new Date(tdydate.getFullYear(), tdydate.getMonth(), tdydate.getDate() + 1);
      $scope.Update = false;
      $scope.vm.SalesPerson = $scope.Emp_Id;
      $scope.Treatmentsdatadata = [];
    }
    $scope.Addcustomer = function (e) {
      $scope.CUpdate = false;
      $scope.vm.uCustomerID = null;
      $scope.vm.uSalutation = null;
      $scope.vm.uFirstName = null;
      $scope.vm.uLastName = null;
      $scope.vm.uCompanyName = null;
      $scope.vm.uNote = null;
      $scope.vm.uAddress = null;
      $scope.vm.uAddress1 = null;
      $scope.vm.uPostal = null;
      $scope.vm.uCountry = 'Singapore';
      $scope.vm.uContactPerson = null;
      $scope.vm.uPhone = null;
      $scope.vm.uMobile = [];
      $scope.vm.uEmail = [];
      $scope.vm.CustomerSince = new Date();
      $scope.vm.ProspectFollowupDate = new Date();
      $scope.vm.Unit = null;
      $scope.vm.StreetName = null;
      $scope.vm.ubCountry = 'Singapore';
      $scope.vm.ubContactPerson = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.BuildingName = null;
      $scope.vm.ubFax = null;
      $scope.vm.ubMobile = null;
      $scope.vm.ubEmail = null;
      $scope.vm.Category = null;
      $scope.vm.MarketSection = null;
      $scope.vm.uInvoiceEmail = [];
      $scope.vm.uInvoiceCC = [];
      $scope.CustomerBillingdatas = [];
      $scope.CustomerServicedatas = [];

      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      $scope.vm.uCustomerID = pass;
      $scope.CustomerServicedatas = [];

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/addcustomer.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      })
    }

    $scope.Addpesttype = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/addpesttype.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.IncludeSOR = false;
      $scope.RateOfficeHour = null;
      $scope.RateAfterOfficeHour = null;
    }

    $scope.copymain = function ($scope) {
      if ($scope.Servicecopy.value == true) {
        if ($scope.vm.uFirstName == null || $scope.vm.uFirstName == "" || $scope.vm.uFirstName == undefined) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.usBLK = '';
        $scope.vm.usName = $scope.vm.uCompanyName;
        $scope.vm.usContactPerson = $scope.vm.uFirstName;
        $scope.vm.usUnit = $scope.vm.StreetName;
        if ($scope.vm.uPostal != null || $scope.vm.uPostal != "" || $scope.vm.uPostal != undefined) {
          $scope.vm.usPostal = ($scope.vm.uPostal);
        }
        $scope.vm.usCountry = $scope.vm.uCountry;
        $scope.vm.usBuildingName = $scope.vm.BuildingName;
        $scope.vm.usStreetName = $scope.vm.StreetName;
        $scope.vm.usMobile = []
        if ($scope.vm.uMobile != null && $scope.vm.uMobile != undefined && $scope.vm.uMobile != "")
          $scope.vm.usMobile = $scope.vm.uMobile
        if ($scope.vm.uEmail != '' && $scope.vm.uEmail != null && $scope.vm.uEmail != undefined)
          $scope.vm.ZoneCC = $scope.vm.uEmail;

        $scope.vm.ZoneEmail = [];

        if ($scope.vm.usContactPerson == "" || $scope.vm.usContactPerson == null || $scope.vm.usContactPerson == undefined) {
          try {
            var item = $scope.CustomerServicedatas.filter(function (item) {
              return item.CustomerID === $scope.RequestID;
            })[0];
            $scope.vm.usName = item.sName;
            $scope.vm.usContactPerson = item.sContactPerson;
            $scope.vm.usBLK = item.sBLK;
            $scope.vm.usUnit = item.sUnit;
            $scope.vm.usPostal = (item.sPostal);
            $scope.vm.usCountry = item.sCountry;
            $scope.vm.usBuildingName = item.sBuildingName;
            $scope.vm.usStreetName = item.sStreetName;
            $scope.vm.usMobile = []
            if (item.sMobile != null && item.sMobile != undefined && item.sMobile != "")
              $scope.vm.usMobile = item.sMobile.split(',');
            if (item.sEmail != null && item.sEmail != "" && item.sEmail != undefined) {
              $scope.vm.ZoneCC = item.sEmail.split(",");
            }
            if (item.sCC != null && item.sCC != "" && item.sCC != undefined) {
              $scope.vm.ZoneEmail = item.sCC.split(",");
            }
          } catch (e) { }
        }
      }
      if ($scope.Servicecopy.value == false) {
        $scope.vm.usName = '';
        $scope.vm.usContactPerson = '';
        $scope.vm.usBLK = '';
        $scope.vm.usUnit = '';
        $scope.vm.usPostal = '';
        $scope.vm.usCountry = '';
        $scope.vm.usBuildingName = '';
        $scope.vm.usStreetName = '';
        $scope.vm.usMobile = [];
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
      }
    }

    $scope.copybilling = function ($scope) {
      if ($scope.checkboxModel.value == true) {
        if ($scope.vm.uFirstName == null || $scope.vm.uFirstName == "" || $scope.vm.uFirstName == undefined) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.ubContactPerson = $scope.vm.uFirstName;
        $scope.vm.ubBLK = '';
        $scope.vm.ubUnit = $scope.vm.StreetName;
        $scope.vm.ubBuildingName = $scope.vm.BuildingName;
        if ($scope.vm.uPostal != null || $scope.vm.uPostal != "" || $scope.vm.uPostal != undefined) {
          $scope.vm.ubPostal = ($scope.vm.uPostal);
        }
        $scope.vm.ubCountry = $scope.vm.uCountry;
        $scope.vm.ubMobile = $scope.vm.uMobile.join(', ');
        $scope.vm.ubEmail = $scope.vm.uEmail;
        $scope.vm.ubStreetName = $scope.vm.StreetName;
        $scope.vm.ubWebsite = '';
      }
      if ($scope.checkboxModel.value == false) {
        $scope.vm.ubContactPerson = '';
        $scope.vm.ubBLK = '';
        $scope.vm.ubUnit = '';
        $scope.vm.ubBuildingName = '';
        $scope.vm.ubPostal = '';
        $scope.vm.ubCountry = '';
        $scope.vm.ubMobile = '';
        $scope.vm.ubEmail = '';
        $scope.vm.ubStreetName = '';
        $scope.vm.ubWebsite = '';

      }
    }
    $scope.checkboxModel = {
      value: false
    }
    $scope.Servicecopy = {
      value: false
    }
    function getQuotationReports() {
      var response = $http({
        url: $rootScope.WebURL + "/preparedquotation/getByRequestID",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id, RequestID: $scope.LeadID },
      });
      response.then(function (QuotationReportdata) {
        $scope.QuotationReportdatas = QuotationReportdata.data.data;

        if ($scope.QuotationReportdatas.length == 0) {
          $scope.QuotationReportTab = false;
        }
        else if ($scope.QuotationReportdatas.length > 0) {
          $scope.RLeadID = $scope.QuotationReportdatas[0].EnquiryID;
          $scope.QuotationReportTab = true;
        }
      });
    }

    $scope.Leadinfo = function (LeadId) {
      $scope.SID = LeadId;
      $scope.LeadID = LeadId;
      $scope.Update = true;
      $scope.QuotationReportTab = false;
      $scope.Leadform = true;
      $scope.Leadgrid = false;
      $scope.Servicegrid = true;
      $scope.Export = false;
      $scope.view = true
      $scope.Add = false;
      $scope.Search = false;

      $scope.vm.AddSchedule = false;
      $scope.ActionButton = null;
      $scope.uNext = null;
      $scope.cNextActionedID = null;
      $scope.ShowRejectButton = false;
      $scope.ShowCancelButton = false;
      $scope.ShowReviseButton = false;
      $scope.IsAccess = false;
      // $scope.CID = CustomerID

      // var item = $scope.Commentdatas.filter(function (item) {
      //   return item.TableRowID === CID;
      // })[0];

      try {
        var item = $scope.Leaddatas.filter(function (item) {
          return item._id === LeadId;
        })[0];
        $scope.vm.LeadId = item._id;
        $scope.vm.LeadReferenceNo = item.LeadReferenceNo;
        $scope.vm.LeadReference = item.LeadReferenceNo;
        $scope.vm.Pipelinevalue = item.Pipelinevalue;
        $scope.vm.uMarketSegment = item.MarketSegment;
        $scope.vm.status = item.Status;
        // if(item.MarketSegment!=null && item.MarketSegment!='' && item.MarketSegment!=undefined){
        //   var a = item.MarketSegment.split(',')
        //   var array = []
        //   _.each(a,function(ite){
        //       array.push({SegmentName:ite})
        //   })
        //   $scope.vm.MarketSegment=array
        // }
        $scope.vm.EnquiryDate = new Date(item.EnquiryDate);
        $scope.vm.CustomerID = item.CustomerID;
        $scope.vm.NatureofJob1 = item.NatureofJob;
        $scope.vm.TreatmentMethod = item.Treatment;
        $scope.vm.EnquiryMode = item.EnquiryMode;
        $scope.vm.CoverageArea1 = item.CoverageArea;
        $scope.vm.ContactMedium = item.ContactMedium;
        $scope.vm.ServiceTime = item.ServiceTime;
        $scope.vm.SalesPerson = item.SalesPerson;
        try {
          $scope.vm.uSalesPerson = item.Employeedetails[0].EmployeeName
        } catch (error) {

        }
        $scope.vm.ExpectedResponseDate = item.ExpectedResponseDate;
        if ($scope.vm.ExpectedResponseDate != null && $scope.vm.ExpectedResponseDate != "") {
          $scope.vm.ExpectedResponseDate = new Date(item.ExpectedResponseDate);
        }
        $scope.vm.InfestationLevel = item.InfestationLevel;
        $scope.vm.Confirmation = item.Confirmation;
        $scope.vm.EnquiryType = item.EnquiryType;
        $scope.vm.Quote = item.Quote;
        $scope.vm.Division = item.Division;
        $scope.vm.Customer = item.Customer;
        $scope.vm.EnquiryStatus = item.EnquiryStatus;
        $scope.vm.CurrentStatus = item.Status;
        $scope.vm.CurrentStatusID = item.StatusID;
      } catch (err) { }
      angular.forEach($scope.Customerdatas, function (cvalue) {
        if ($scope.vm.CustomerID == cvalue.id) {
          $scope.vm.Customer_id = cvalue.id
          $scope.vm.uCustomerID = cvalue.CustomerID;
          $scope.vm.uCustomerType = cvalue.CustomerType;
          $scope.vm.uSalutation = cvalue.Salutation;
          $scope.vm.uFirstName = cvalue.FirstName;
          $scope.vm.uLastName = cvalue.LastName;
          $scope.vm.uWebsite = cvalue.Website;
          $scope.vm.uCompanyName = cvalue.CompanyName;
          $scope.vm.uNote = cvalue.Note;
          $scope.vm.uAddress = cvalue.Address;
          $scope.vm.uAddress1 = cvalue.Address1;
          if (cvalue.BuildingName !== undefined && cvalue.BuildingName !== null && cvalue.BuildingName !== "") {
            $scope.vm.uStreetName = cvalue.BuildingName + ' , ' + cvalue.StreetName;
          } else {
            $scope.vm.uStreetName = cvalue.StreetName;
          }
          $scope.vm.uPostal = (cvalue.Postal);
          $scope.vm.uCountry = cvalue.Country;
          $scope.vm.uContactPerson = cvalue.ContactPerson;
          $scope.vm.uPhone = (cvalue.Phone);
          $scope.vm.uFax = cvalue.Fax;
          if (cvalue.Mobile != "" && cvalue.Mobile != null && cvalue.Mobile != undefined)
            $scope.vm.uMobile = (cvalue.Mobile).split(',').join(' , ');
          else
            $scope.vm.uMobile = ""
          $scope.vm.uEmail = cvalue.Email;
          $scope.vm.uTypeofHouse = cvalue.TypeofHouse;
          $scope.vm.uOtherType = cvalue.OtherType;
          if (cvalue.MarketSection != null && cvalue.MarketSection != '' && cvalue.MarketSection != undefined) {
            var a = cvalue.MarketSection.split(',')
            var array = []
            _.each(a, function (ite) {
              array.push({ SegmentName: ite })
            })
            $scope.vm.CMarketSegment = array
          }
          $scope.CustomerCommentdatas = cvalue.Commentdatas
        }
      });
      angular.forEach($scope.Employeedatas, function (evalue) {
        if ($scope.vm.SalesPerson == evalue.EmployeeName) {
          $scope.vm.Employee_id = evalue.id
        }
      });
      angular.forEach($scope.Workflowdatas, function (wvalue) {
        if (wvalue.TypeName == 'CRM Leads') {
          if ($scope.vm.CurrentStatusID == wvalue.LevelName || $scope.vm.CurrentStatus == wvalue.Actioned) {
            $scope.uNext = wvalue.NextLevel;
            $scope.cNextActionedID = wvalue.LevelName;
          }
          if ($scope.uNext == wvalue.LevelName) {
            $scope.ActionButton = wvalue.Action;
            $scope.cNextActioned = wvalue.Actioned;
            $scope.cNextID = wvalue.LevelName;
            $scope.confirmID = wvalue.NextLevel;
          }
          if ($scope.ActionButton == wvalue.Action) {
            $scope.ShowRejectButton = wvalue.ShowRejectButton;
            $scope.ShowCancelButton = wvalue.ShowCancelButton;
            $scope.ShowReviseButton = wvalue.ShowReviseButton;
          }
          if ($scope.ActionButton != null && $scope.ActionButton != undefined) {
            if ($scope.ActionButton.match('Confirm')) {
              $scope.ConfirmB = true;
            }
          }
          try {
            if ($scope.uNext == wvalue.LevelName && wvalue.Approvers.indexOf($rootScope.createdby) > -1) {
              $scope.IsAccess = true;
            }
          } catch (e) { }
        }
      });
      $scope.File_id = $scope.vm.LeadReferenceNo
      $scope.Filee_id = $scope.vm.LeadId
      getQuotationReports();
      RefreshAttachmentGrid();
      Refreshcomment();
      //RefreshPreparedquotations();
    }
    $scope.leadeditinfo = function (e, LeadId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/addlead.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      })
      $scope.SID = LeadId;
      angular.forEach($scope.Leaddatas, function (value) {
        if (value._id == LeadId) {
          $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
          $scope.vm.Pipelinevalue = parseInt(value.Pipelinevalue);
          $scope.vm.pCompanyName = value.Customerdetails[0].CompanyName
          // $scope.vm.MarketSegment = value.MarketSegment;
          $scope.vm.EnquiryDate = new Date(value.EnquiryDate);
          $scope.vm.CustomerID = value.CustomerID;
          $scope.vm.NatureofJob = value.NatureofJob;
          if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
            var array = $scope.vm.NatureofJob.split(",");
            var array1 = [];
            angular.forEach(array, function (value) {
              array1.push({
                PestName: value
              });
            });
            $scope.vm.NatureofJob = array1;
          }
          $scope.vm.EnquiryMode = value.EnquiryMode;
          $scope.vm.ppCompanyName = value.Customer;
          $scope.vm.ServiceTime = value.ServiceTime;
          $scope.vm.SalesPerson = value.SalesPerson;
          try {
            $scope.vm.uSalesPerson = value.Employeedetails[0].EmployeeName
          } catch (error) {

          }
          $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
          if ($scope.vm.ExpectedResponseDate != null && $scope.vm.ExpectedResponseDate != "") {
            $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
          }
          $scope.vm.EnquiryType = value.EnquiryType;
          $scope.vm.Customer = value.Customer;
          $scope.vm.EnquiryStatus = value.EnquiryStatus;
          $scope.vm.CurrentStatus = value.Status;
          $scope.vm.Pipelinevalue = parseInt(value.Pipelinevalue);
          // $scope.vm.MarketSegment = value.MarketSegment;
          if (value.MarketSegment != null && value.MarketSegment != '' && value.MarketSegment != undefined) {
            var a = value.MarketSegment.split(',')
            var array = []
            _.each(a, function (ite) {
              array.push({ SegmentName: ite })
            })
            $scope.vm.MarketSegment = array
          }
        }
      });
    }
    $scope.QuaotationReport = function () {
      var url = $rootScope.ReportURL + 'Quotation.aspx' + '?' + 'ID=' + $scope.vm.LeadId;
      window.open(url);
    }

    function preview() {
      $scope.Previewdiv = true;
      var innerContents = document.getElementById('invoice').innerHTML;
      var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
      popupWinindow.document.close($scope.Previewdiv = false);
    }

    $scope.sSubmit = function () {
      // if ($scope.vm.MarketSegment != null && $scope.vm.MarketSegment != '' && $scope.vm.MarketSegment != undefined) {
      //   $scope.vm.MarketSegment = $scope.vm.MarketSegment.map(function (obj) { return obj.SegmentName; }).join(',');
      // }
      if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
        $scope.vm.NatureofJob = $scope.vm.NatureofJob.map(function (obj) {
          return obj.PestName;
        }).join(',');
      }
      if ($scope.vm.ppCompanyName != null && $scope.vm.ppCompanyName != "" && $scope.vm.ppCompanyName != undefined) {
        $scope.vm.CustomerID = null;
        try {
          var item = $scope.Customerdatas.filter(function (item) {
            return item.CompanyName == $scope.vm.ppCompanyName
          })[0];
          $scope.vm.CustomerID = item.id;
        } catch (e) { }
      }
      if ($scope.Update == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/lead/update",
          data: {
            _id: $scope.SID,
            EnquiryDate: $scope.vm.EnquiryDate,
            Customer: $scope.vm.ppCompanyName,
            NatureofJob: $scope.vm.NatureofJob,
            EnquiryMode: $scope.vm.EnquiryMode,
            ServiceTime: $scope.vm.ServiceTime,
            SalesPerson: $scope.vm.SalesPerson,
            Pipelinevalue: $scope.vm.Pipelinevalue,
            MarketSegment: $scope.vm.MarketSegment,
            ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
            EnquiryType: $scope.vm.EnquiryType,
            EnquiryStatus: $scope.vm.EnquiryStatus,
            CustomerID: $scope.vm.CustomerID,
            UpdatedBy: $rootScope.createdby,
          },
        });
        response.then(function (GList) {
          if (GList.data.message == "Existing CustomerName") {
            $scope.error1 = true;
            $scope.Leadgrid = false;
            $scope.Leadform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
          }
          else {
            $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
            $mdDialog.cancel();
            $scope.Leadgrid = true;
            $scope.Leadform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            RefreshGrid();
          }
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/lead/add",
          data: {
            EnquiryDate: $scope.vm.EnquiryDate,
            Customer: $scope.vm.ppCompanyName,
            NatureofJob: $scope.vm.NatureofJob,
            EnquiryMode: $scope.vm.EnquiryMode,
            ServiceTime: $scope.vm.ServiceTime,
            SalesPerson: $scope.vm.SalesPerson,
            Pipelinevalue: $scope.vm.Pipelinevalue,
            MarketSegment: $scope.vm.MarketSegment,
            ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
            EnquiryType: $scope.vm.EnquiryType,
            CustomerID: $scope.vm.CustomerID,
            CreatedBy: $rootScope.createdby,
            Client_Id: $rootScope.Client_Id,
          },
        });
        response.then(function (GList) {
          $scope.GListdata = GList.data.data;
          $scope.vm.LeadId = $scope.GListdata._id;
          $scope.vm.LeadReference = $scope.GListdata.LeadReferenceNo
          var file = angular.element(document.querySelector('#fileInput'))[0].files;
          if (file.length != 0 && file.length != undefined) {
            var files = [];
            files.push({ file: file[0] })
            $scope.Uploadfiles(files)
          }
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshGrid();
          $scope.Leadgrid = true;
          $scope.Leadform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }
    }
    $scope.SendSR = {
      value: false
    };
    $scope.FT = {
      value: false
    };

    $scope.customerSubmit = function () {
      if ($scope.vm.uFirstName == null || $scope.vm.uFirstName == "" || $scope.vm.uFirstName == undefined) {
        $scope.vm.uFirstName = $scope.vm.uCompanyName;
      }
      $scope.vm.uContactPerson = $scope.vm.uFirstName;

      if ($scope.vm.BuildingName != null && $scope.vm.BuildingName != "" && $scope.vm.BuildingName != undefined) {
        $scope.vm.uAddress = $scope.vm.Unit + ',' + $scope.vm.StreetName + ',' + $scope.vm.BuildingName;
      }
      else {
        $scope.vm.uAddress = $scope.vm.Unit + ',' + $scope.vm.StreetName;
      }
      if ($scope.vm.uMobile != null && $scope.vm.uMobile != "" && $scope.vm.uMobile != undefined) $scope.vm.uMobile = $scope.vm.uMobile.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.uEmail != null && $scope.vm.uEmail != "" && $scope.vm.uEmail != undefined) $scope.vm.uEmail = $scope.vm.uEmail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.MarketSection != null && $scope.vm.MarketSection != '' && $scope.vm.MarketSection != undefined) {
        $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) { return obj.SegmentName; }).join(',');
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/add",
        data: {
          CustomerID: $scope.vm.uCustomerID,
          CustomerReference: $scope.vm.CustomerReference,
          Salutation: $scope.vm.uSalutation,
          FirstName: $scope.vm.uFirstName,
          LastName: $scope.vm.uLastName,
          CompanyName: $scope.vm.uCompanyName,
          Note: $scope.vm.uNote,
          Address: $scope.vm.uAddress,
          Address1: $scope.vm.uAddress1,
          Postal: $scope.vm.uPostal,
          Country: $scope.vm.uCountry,
          ContactPerson: $scope.vm.uContactPerson,
          Phone: $scope.vm.uPhone,
          Mobile: $scope.vm.uMobile,
          Email: $scope.vm.uEmail,
          ProspectFollowupDate: $scope.vm.ProspectFollowupDate,
          Unit: $scope.vm.Unit,
          StreetName: $scope.vm.StreetName,
          BuildingName: $scope.vm.BuildingName,
          CreditTerm: $scope.vm.CreditTerm,
          MarketSection: $scope.vm.MarketSection,
          ConEndDate: $scope.vm.ConEndDate,
          Category: $scope.vm.Category,
          CreatedBy: $rootScope.createdby, IsActive: "true",
          Client_Id: $rootScope.Client_Id,
          InvoiceEmail: $scope.vm.usInvoiceEmail,
          InvoiceCC: $scope.vm.usInvoiceCC,
        },
      });
      response.then(function (GList) {
        if (GList.data.message == "Existing CompanyName") {
          $scope.error1 = true;
          $scope.Leadgrid = false;
          $scope.Leadform = true;
          $scope.Export = false;
          $scope.Add = false;
          $scope.Search = false;
          $scope.view = true;
        }
        else {
          debugger
          RefreshCustomerdatas();
          $scope.vm.CustomerID = GList.data.data.id;
          $scope.vm.ppCompanyName = GList.data.data.CompanyName;
          $scope.vm.Customer = GList.data.data.CompanyName;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          $scope.Leadgrid = true;
          $scope.Leadform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.pestsubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/pesttype/add",
        data: {
          _id: $scope.SID,
          PestName: $scope.vm.pesttypename,
          Pestcode: $scope.vm.pestcode,
          IncludeSOR: $scope.IncludeSOR,
          RateOfficeHour: $scope.RateOfficeHour,
          RateAfterOfficeHour: $scope.RateAfterOfficeHour,
          Client_Id: $rootScope.Client_Id,
        },
      });
      response.then(function (GList) {
        RefreshGrid();
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        if (GList.data.data.PestName != null && GList.data.data.PestName != "" && GList.data.data.PestName != undefined) {
          var array1 = [];
          array1.push({
            PestName: GList.data.data.PestName
          });
          $scope.vm.NatureofJob = array1;
        }
        $scope.Search = true;
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.commentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          LeadID: $scope.SID,
          CustomerID: $scope.vm.CustomerID,
          TableName: "Lead",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        $scope.Filee_id = $scope.vm.LeadId
        RefreshGrid();
        $scope.vm.Addcomments = '';
        $scope.Leadgrid = false;
        $scope.Leadform = true;
        $scope.Export = false;
        $scope.Add = false;
        $scope.view = true;
        $scope.Search = false;
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.Confirm = function (e, LeadId) {
      $scope.vm.JobsPerFrequency = 1;
      // $mdDialog.show({
      //   multiple: true,
      //   templateUrl: 'app/main/apps/crm/lead/saleorder.html',
      //   parent: angular.element($document.body),
      //   targetEvent: e,
      //   scope: $scope.$new(),
      //   clickOutsideToClose: false,
      //   controller: function LeadController($scope, $mdDialog) {
      //     $scope.closeDialog = function () {
      //       $mdDialog.hide();
      //     }
      //   }
      // });
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.TotalOrderValue = null;
      $scope.vm.Frequency = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractDuration = null;
      if ($scope.vm.NatureofJob1 != null && $scope.vm.NatureofJob1 != "" && $scope.vm.NatureofJob1 != undefined) {
        var array = [];
        array = $scope.vm.NatureofJob1.split(",");
        var array1 = [];
        angular.forEach(array, function (value) {
          array1.push({
            PestName: value
          });
        });
        $scope.vm.NatureofJob = array1;
      }
      var EmployeeID = localStorage.getItem('EmployeeID');
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.ConfirmationReceivedBy = item.EmployeeName;
      } catch (e) { }
      var lresponse = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/lead/update",
        data: {
          _id: $scope.SID,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          LeadReferenceNo: $scope.vm.LeadReferenceNo,
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.Customer,
          NatureofJob: $scope.vm.NatureofJob1,
          Treatment: $scope.vm.TreatmentMethod,
          EnquiryMode: $scope.vm.EnquiryMode,
          CoverageArea: $scope.vm.CoverageArea1,
          ContactMedium: $scope.vm.ContactMedium,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          InfestationLevel: $scope.vm.InfestationLevel,
          Confirmation: $scope.vm.Confirmation,
          EnquiryType: $scope.vm.EnquiryType,
          Quote: $scope.vm.Quote,
          Division: $scope.vm.Division,
          CustomerID: $scope.vm.CustomerID,
          EnquiryStatus: $scope.vm.EnquiryStatus,
          Status: $scope.cNextActioned,
          StatusID: $scope.cNextID,
          UpdatedBy: $rootScope.createdby,
          IsActive: "true",
          Client_Id: $rootScope.Client_Id,
        },
      });
      lresponse.then(function (GList) {
        $scope.FrequencyArray = [];
        $scope.CustomerServicedatas = [];
        $scope.ServiceAddressarray = [];
        $scope.vm.AddSchedule = false;
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Done!').position('top center'));
        RefreshGrid();
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        $scope.Search = true;
      });
    }
    $scope.Contract = {
      value: false
    }
    $scope.Uploadfiles = function (file) {
      var upfile = file[0].file
      var response = Upload.upload({
        url: $rootScope.WebURL + "/lead/upload",
        data: { file: upfile }
      }).then(function (resp) {
        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID,
              TableName: "Lead",
              FileID: $scope.vm.LeadReference,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize,
              FileType: $scope.fileType,
              ModuleID: $scope.Path,
              Data: null,
              IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            $scope.File_id = $scope.vm.LeadReferenceNo
            RefreshGrid();
            file[0].cancel();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.checkboxModel = {
      value: false
    }
    $scope.cancel = function (elem) {
      $mdDialog.cancel();
    };
    $scope.CalculateTotalJob = function (Frequency) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays = 1 + Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        if (Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1 || Frequency.toUpperCase().indexOf('BIWEEKLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 14);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'WEEKLY') {
          var TotalHallfyearss = Math.round(Totaldays / 7);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'MONTHLY') {
          var TotalHallfyearss = Math.round(Totaldays / 30);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'BIMONTHLY' || Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 60);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'QUARTERLY') {
          var TotalHallfyearss = Math.round(Totaldays / 90);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'HALF-YEARLY' || Frequency.toUpperCase().indexOf('HALFYEARLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 183);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'YEARLY') {
          var Totalyearss = Math.round(Totaldays / 365);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * Totalyearss;
          }
        }
        if (Frequency.toUpperCase() == 'DAILY') {
          $scope.vm.ServicesRequired = Totaldays;
        }
      }
      catch (e) { }
    }
    function quotationlogsubmit() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/quotationlog/add",
        data: {
          EnquiryID: $scope.SID,
          Status: $scope.cNextActioned,
          StatusCreatedBy: $scope.createdby,
          StatusCreatedDate: new Date(),
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        RefreshGrid();
      })
    }
    function fetchLead(LeadId) {
      angular.forEach($scope.Leaddatas, function (value) {
        try {
          if (value._id == LeadId) {
            $scope.vm.LeadId = value._id;
            $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
            $scope.vm.Pipelinevalue = value.Pipelinevalue;
            if (value.MarketSegment != null && value.MarketSegment != '' && value.MarketSegment != undefined) {
              var a = value.MarketSegment.split(',')
              var array = []
              _.each(a, function (ite) {
                array.push({ SegmentName: ite })
              })
              $scope.vm.MarketSegment = array
            }
            //  $scope.vm.MarketSegment = value.MarketSegment;
            $scope.vm.EnquiryDate = new Date(value.EnquiryDate);
            $scope.vm.CustomerID = value.CustomerID;
            $scope.vm.NatureofJob1 = value.NatureofJob;
            $scope.vm.EnquiryMode = value.EnquiryMode;
            $scope.vm.CoverageArea = value.CoverageArea;
            $scope.vm.ContactMedium = value.ContactMedium;
            $scope.vm.ServiceTime = value.ServiceTime;
            $scope.vm.SalesPerson = value.SalesPerson;
            try {
              $scope.vm.uSalesPerson = value.Employeedetails[0].EmployeeName
            } catch (error) {

            }
            $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
            if ($scope.vm.ExpectedResponseDate != null && $scope.vm.ExpectedResponseDate != "") {
              $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
            }
            $scope.vm.InfestationLevel = value.InfestationLevel;
            $scope.vm.Confirmation = value.Confirmation;
            $scope.vm.EnquiryType = value.EnquiryType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.Division = value.Division;
            $scope.vm.Customer = value.Customer;
            $scope.vm.EnquiryStatus = value.EnquiryStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
          }
        } catch (e) { }
      });
    }
    function ClearForm() {
      $scope.vm.Pipelinevalue = null;
      $scope.vm.EnquiryDate = null;
      $scope.vm.Customer = "";
      $scope.vm.CustomerID = "";
      $scope.vm.NatureofJob = "";
      $scope.vm.EnquiryMode = "";
      $scope.vm.CoverageArea = "";
      $scope.vm.ContactMedium = "";
      $scope.vm.ServiceTime = "";
      $scope.vm.SalesPerson = "";
      $scope.vm.ExpectedResponseDate = null;
      $scope.vm.InfestationLevel = "";
      $scope.vm.Confirmation = "";
      $scope.vm.EnquiryType = "";
      $scope.vm.Quote = "";
      $scope.vm.Division = "";
      $scope.vm.TreatmentMethod = null;
      $scope.vm.MarketSegment = "";
    }
    $scope.DeleteAttachement = function (e, deleteID) {
      $scope.AttachdeleteID = deleteID;
      $mdDialog.show({
        templateUrl: 'app/main/apps/crm/lead/attachmentdelete.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.Adelete = function (AttachmentdeleteID) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/attachment/delete",
        data: { _id: AttachmentdeleteID },
      });
      response.then(function (GList) {
        RefreshAttachmentGrid();
        RefreshGrid();
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    function RefreshCustomerdatas() {
      $scope.getCustomerdatas = [];
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.getCustomerdatas = customerdata;
        $scope.Customerdatas = $scope.getCustomerdatas;
        if (IsAdmin != true) {
          var item = $scope.getCustomerdatas.filter(function (item) {
            if (item.AssignedUser != null)
              return item.AssignedUser.includes($rootScope.createdby);
          });
          $scope.Customerdatasfordropdown = item;
        } else {
          $scope.Customerdatasfordropdown = $scope.getCustomerdatas;
        }
      });
    }

    $scope.SendSR = {
      value: false
    };
    $scope.FT = {
      value: false
    };
    $scope.customerSubmit = function () {
      if ($scope.vm.uFirstName == null || $scope.vm.uFirstName == "" || $scope.vm.uFirstName == undefined) {
        $scope.vm.uFirstName = $scope.vm.uCompanyName;
      }
      $scope.vm.uContactPerson = $scope.vm.uFirstName;

      if ($scope.vm.BuildingName != null && $scope.vm.BuildingName != "" && $scope.vm.BuildingName != undefined) {
        $scope.vm.uAddress = $scope.vm.Unit + ',' + $scope.vm.StreetName + ',' + $scope.vm.BuildingName;
      }
      else {
        $scope.vm.uAddress = $scope.vm.Unit + ',' + $scope.vm.StreetName;
      }
      if ($scope.vm.uMobile != null && $scope.vm.uMobile != "" && $scope.vm.uMobile != undefined) $scope.vm.uMobile = $scope.vm.uMobile.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.uEmail != null && $scope.vm.uEmail != "" && $scope.vm.uEmail != undefined) $scope.vm.uEmail = $scope.vm.uEmail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.MarketSection != null && $scope.vm.MarketSection != '' && $scope.vm.MarketSection != undefined) {
        $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) { return obj.SegmentName; }).join(',');
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/add",
        data: {
          CustomerID: $scope.vm.uCustomerID,
          CustomerReference: $scope.vm.CustomerReference,
          Salutation: $scope.vm.uSalutation,
          FirstName: $scope.vm.uFirstName,
          LastName: $scope.vm.uLastName,
          CompanyName: $scope.vm.uCompanyName,
          Note: $scope.vm.uNote,
          Address: $scope.vm.uAddress,
          Address1: $scope.vm.uAddress1,
          Postal: $scope.vm.uPostal,
          Country: $scope.vm.uCountry,
          ContactPerson: $scope.vm.uContactPerson,
          Phone: $scope.vm.uPhone,
          Mobile: $scope.vm.uMobile,
          Email: $scope.vm.uEmail,
          ProspectFollowupDate: $scope.vm.ProspectFollowupDate,
          Unit: $scope.vm.Unit,
          StreetName: $scope.vm.StreetName,
          BuildingName: $scope.vm.BuildingName,
          CreditTerm: $scope.vm.CreditTerm,
          MarketSection: $scope.vm.MarketSection,
          ConEndDate: $scope.vm.ConEndDate,
          Category: $scope.vm.Category,
          CreatedBy: $rootScope.createdby, IsActive: "true",
          Client_Id: $rootScope.Client_Id,
          InvoiceEmail: $scope.vm.usInvoiceEmail,
          InvoiceCC: $scope.vm.usInvoiceCC,
        },
      });
      response.then(function (GList) {
        if (GList.data.message == "Existing CompanyName") {
          $scope.error1 = true;
          $scope.Leadgrid = false;
          $scope.Leadform = true;
          $scope.Export = false;
          $scope.Add = false;
          $scope.Search = false;
          $scope.view = true;
        }
        else {
          httpservice.customer.response = httpservice.customer.response.concat([GList.data.data])
          RefreshCustomerdatas();
          $scope.vm.CustomerID = GList.data.data.id;
          $scope.vm.ppCompanyName = GList.data.data.CompanyName;
          $scope.vm.Customer = GList.data.data.CompanyName;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          $scope.Leadgrid = true;
          $scope.Leadform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.pestsubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/pesttype/add",
        data: {
          _id: $scope.SID,
          PestName: $scope.vm.pesttypename,
          Pestcode: $scope.vm.pestcode,
          IncludeSOR: $scope.IncludeSOR,
          RateOfficeHour: $scope.RateOfficeHour,
          RateAfterOfficeHour: $scope.RateAfterOfficeHour,
          Client_Id: $rootScope.Client_Id,
        },
      });
      response.then(function (GList) {
        RefreshGrid();
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        if (GList.data.data.PestName != null && GList.data.data.PestName != "" && GList.data.data.PestName != undefined) {
          var array1 = [];
          array1.push({
            PestName: GList.data.data.PestName
          });
          $scope.vm.NatureofJob = array1;
        }
        $scope.Search = true;
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.commentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          LeadID: $scope.SID,
          CustomerID: $scope.vm.CustomerID,
          TableName: "Lead",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        $scope.Filee_id = $scope.vm.LeadId
        RefreshGrid();
        $scope.vm.Addcomments = '';
        $scope.Leadgrid = false;
        $scope.Leadform = true;
        $scope.Export = false;
        $scope.Add = false;
        $scope.view = true;
        $scope.Search = false;
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.Confirm = function (e, LeadId) {
      $scope.vm.JobsPerFrequency = 1;
      // $mdDialog.show({
      //   multiple: true,
      //   templateUrl: 'app/main/apps/crm/lead/saleorder.html',
      //   parent: angular.element($document.body),
      //   targetEvent: e,
      //   scope: $scope.$new(),
      //   clickOutsideToClose: false,
      //   controller: function LeadController($scope, $mdDialog) {
      //     $scope.closeDialog = function () {
      //       $mdDialog.hide();
      //     }
      //   }
      // });
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.TotalOrderValue = null;
      $scope.vm.Frequency = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractDuration = null;
      if ($scope.vm.NatureofJob1 != null && $scope.vm.NatureofJob1 != "" && $scope.vm.NatureofJob1 != undefined) {
        var array = [];
        array = $scope.vm.NatureofJob1.split(",");
        var array1 = [];
        angular.forEach(array, function (value) {
          array1.push({
            PestName: value
          });
        });
        $scope.vm.NatureofJob = array1;
      }
      var EmployeeID = localStorage.getItem('EmployeeID');
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.ConfirmationReceivedBy = item.EmployeeName;
      } catch (e) { }
      var lresponse = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/lead/update",
        data: {
          _id: $scope.SID,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          LeadReferenceNo: $scope.vm.LeadReferenceNo,
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.Customer,
          NatureofJob: $scope.vm.NatureofJob1,
          Treatment: $scope.vm.TreatmentMethod,
          EnquiryMode: $scope.vm.EnquiryMode,
          CoverageArea: $scope.vm.CoverageArea1,
          ContactMedium: $scope.vm.ContactMedium,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          InfestationLevel: $scope.vm.InfestationLevel,
          Confirmation: $scope.vm.Confirmation,
          EnquiryType: $scope.vm.EnquiryType,
          Quote: $scope.vm.Quote,
          Division: $scope.vm.Division,
          CustomerID: $scope.vm.CustomerID,
          EnquiryStatus: $scope.vm.EnquiryStatus,
          Status: $scope.cNextActioned,
          StatusID: $scope.cNextID,
          UpdatedBy: $rootScope.createdby,
          IsActive: "true",
          Client_Id: $rootScope.Client_Id,
        },
      });
      lresponse.then(function (GList) {
        $scope.FrequencyArray = [];
        $scope.CustomerServicedatas = [];
        $scope.ServiceAddressarray = [];
        $scope.vm.AddSchedule = false;
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Done!').position('top center'));
        RefreshGrid();
        $scope.Leadgrid = true;
        $scope.Leadform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        $scope.Search = true;
      });
    }
    $scope.Contract = {
      value: false
    }
    $scope.Uploadfiles = function (file) {
      var upfile = file[0].file
      var response = Upload.upload({
        url: $rootScope.WebURL + "/lead/upload",
        data: { file: upfile }
      }).then(function (resp) {
        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID,
              TableName: "Lead",
              FileID: $scope.vm.LeadReference,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize,
              FileType: $scope.fileType,
              ModuleID: $scope.Path,
              Data: null,
              IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            $scope.File_id = $scope.vm.LeadReferenceNo
            RefreshGrid();
            file[0].cancel();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.checkboxModel = {
      value: false
    }
    $scope.cancel = function (elem) {
      $mdDialog.cancel();
    };
    $scope.CalculateTotalJob = function (Frequency) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays = 1 + Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        if (Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1 || Frequency.toUpperCase().indexOf('BIWEEKLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 14);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'WEEKLY') {
          var TotalHallfyearss = Math.round(Totaldays / 7);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'MONTHLY') {
          var TotalHallfyearss = Math.round(Totaldays / 30);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'BIMONTHLY' || Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 60);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'QUARTERLY') {
          var TotalHallfyearss = Math.round(Totaldays / 90);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'HALF-YEARLY' || Frequency.toUpperCase().indexOf('HALFYEARLY') > -1) {
          var TotalHallfyearss = Math.round(Totaldays / 183);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == 'YEARLY') {
          var Totalyearss = Math.round(Totaldays / 365);
          if ($scope.vm.JobsPerFrequency != null && $scope.vm.JobsPerFrequency != undefined && $scope.vm.JobsPerFrequency != "") {
            $scope.vm.ServicesRequired = $scope.vm.JobsPerFrequency * Totalyearss;
          }
        }
        if (Frequency.toUpperCase() == 'DAILY') {
          $scope.vm.ServicesRequired = Totaldays;
        }
      }
      catch (e) { }
    }
    function quotationlogsubmit() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/quotationlog/add",
        data: {
          EnquiryID: $scope.SID,
          Status: $scope.cNextActioned,
          StatusCreatedBy: $scope.createdby,
          StatusCreatedDate: new Date(),
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        RefreshGrid();
      })
    }
    function fetchLead(LeadId) {
      angular.forEach($scope.Leaddatas, function (value) {
        try {
          if (value._id == LeadId) {
            $scope.vm.LeadId = value._id;
            $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
            $scope.vm.Pipelinevalue = value.Pipelinevalue;
            if (value.MarketSegment != null && value.MarketSegment != '' && value.MarketSegment != undefined) {
              var a = value.MarketSegment.split(',')
              var array = []
              _.each(a, function (ite) {
                array.push({ SegmentName: ite })
              })
              $scope.vm.MarketSegment = array
            }
            //  $scope.vm.MarketSegment = value.MarketSegment;
            $scope.vm.EnquiryDate = new Date(value.EnquiryDate);
            $scope.vm.CustomerID = value.CustomerID;
            $scope.vm.NatureofJob1 = value.NatureofJob;
            $scope.vm.EnquiryMode = value.EnquiryMode;
            $scope.vm.CoverageArea = value.CoverageArea;
            $scope.vm.ContactMedium = value.ContactMedium;
            $scope.vm.ServiceTime = value.ServiceTime;
            $scope.vm.SalesPerson = value.SalesPerson;
            try {
              $scope.vm.uSalesPerson = value.Employeedetails[0].EmployeeName
            } catch (error) {

            }
            $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
            if ($scope.vm.ExpectedResponseDate != null && $scope.vm.ExpectedResponseDate != "") {
              $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
            }
            $scope.vm.InfestationLevel = value.InfestationLevel;
            $scope.vm.Confirmation = value.Confirmation;
            $scope.vm.EnquiryType = value.EnquiryType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.Division = value.Division;
            $scope.vm.Customer = value.Customer;
            $scope.vm.EnquiryStatus = value.EnquiryStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
          }
        } catch (e) { }
      });
    }
    function ClearForm() {
      $scope.vm.Pipelinevalue = null;
      $scope.vm.EnquiryDate = null;
      $scope.vm.Customer = "";
      $scope.vm.CustomerID = "";
      $scope.vm.NatureofJob = "";
      $scope.vm.EnquiryMode = "";
      $scope.vm.CoverageArea = "";
      $scope.vm.ContactMedium = "";
      $scope.vm.ServiceTime = "";
      $scope.vm.SalesPerson = "";
      $scope.vm.ExpectedResponseDate = null;
      $scope.vm.InfestationLevel = "";
      $scope.vm.Confirmation = "";
      $scope.vm.EnquiryType = "";
      $scope.vm.Quote = "";
      $scope.vm.Division = "";
      $scope.vm.TreatmentMethod = null;
      $scope.vm.MarketSegment = "";
    }
    $scope.DeleteAttachement = function (e, deleteID) {
      $scope.AttachdeleteID = deleteID;
      $mdDialog.show({
        templateUrl: 'app/main/apps/crm/lead/attachmentdelete.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.Adelete = function (AttachmentdeleteID) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/attachment/delete",
        data: { _id: AttachmentdeleteID },
      });
      response.then(function (GList) {
        RefreshAttachmentGrid();
        RefreshGrid();
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });



    $http({
      method: "POST",
      url: $rootScope.WebURL + "/Workflow",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Workflowdata) {
      $scope.Workflowdatas = Workflowdata.data.data;
    })
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
    });
    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'ScheduleFrequency';
        });
        $scope.ScheduleFrequencydatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'PaymentMode';
        });
        $scope.PaymentModedatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'BillingFrequency';
        });
        $scope.BillingFrequencydatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'PaymentTerm';
        });
        $scope.PaymentTermdatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'EnquiryMode';
        });
        $scope.EnquiryModedatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'ContactMedium';
        });
        $scope.ContactMediumdatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'JobTypes';
        });
        $scope.JobTypesdatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'CreditTerm';
        });
        $scope.CreditTermdatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'BuildingType';
        });
        $scope.BuildingTypedatas = item;
      } catch (e) { }
    });
    // $http({
    //   method: "POST",
    //   url:  $rootScope.WebURL + "/lead/lastupdatedrecord",
    //   data: { Client_Id: $rootScope.Client_Id },
    // }).then(function (List) {
    //   $scope.vm.LastUpdateRecord = List.data.data.id;
    //   // $scope.Datefilter();
    // });

    // function RefreshGrid1() {

    //   RefreshAttachmentGrid();
    //   Refreshcomment();
    //   RefreshGrid();
    // }

    function RefreshGrid() {
      // $http({
      //   method: "POST",
      //   url:  $rootScope.WebURL + "/lead/lastupdatedrecord",
      //   data: { Client_Id: $rootScope.Client_Id },
      // }).then(function (List) {
      //   $scope.vm.LastUpdateRecord = List.data.data.id;
      //   // $scope.Datefilter();
      // });
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/lead/get",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (List) {
        var array = []
        if (IsAdmin == false) {
          _.each(List.data.data, function (item) {
            if ($scope.Emp_Id === item.SalesPerson) {
              if (item.UpdatedDate != null && item.UpdatedDate != undefined && item.UpdatedDate != "")
                item.SortDate = item.UpdatedDate
              else
                item.SortDate = item.CreatedDate
              item.UpdateDat = new Date(item.UpdatedDate)
              array.push(item)
            }
          })
          var response1 = $http({
            url: $rootScope.WebURL + "/employee/getBySupervisor",
            method: "POST",
            data: {
              Client_Id: $rootScope.Client_Id, Supervisor: EmpID
            }
          })
          response1.then(function (GList1) {
            var data = GList1.data.data
            var Litem = List.data.data.filter(function (Litem) {
              return data.includes(Litem.SalesPerson)
            })
            array = array.concat(Litem)
            array = _.uniqWith(array, _.isEqual)

            $scope.Leaddatas = (_.reverse(_.sortBy(array, ['SortDate'])));
            if ($scope.Leaddatas.length > 0)
              $scope.vm.LastUpdateRecord = $scope.Leaddatas[0]._id
          })
        }
        else {
          _.each(List.data.data, function (item) {
            item.UpdateDat = new Date(item.UpdatedDate)
            if (item.UpdatedDate != null && item.UpdatedDate != undefined && item.UpdatedDate != "")
              item.SortDate = item.UpdatedDate
            else
              item.SortDate = item.CreatedDate
            array.push(item)
          })
          // var response1 = $http({
          //   url :"https://"+$rootScope.WebURL+"/employee/getBySupervisor",
          //   method:"POST",
          //   data:{
          //     Client_Id: $rootScope.Client_Id, Supervisor :EmpID
          //   }
          // })
          // response1.then(function(GList1){
          //   var data = GList1.data.data
          //   var Litem =  List.data.data.filter(function(Litem){
          //     return data.includes(Litem.SalesPerson)
          //   })
          //   array = array.concat(Litem)
          //   array = _.uniqWith(array,_.isEqual)
          $scope.Leaddatas = (_.reverse(_.sortBy(array, ['SortDate'])));
          if ($scope.Leaddatas.length > 0)
            $scope.vm.LastUpdateRecord = $scope.Leaddatas[0]._id

          // })
        }
        $("#LeadgridContainer").dxDataGrid('instance').repaint()
        calculateWidget10()
      });

      // RefreshGrid1()
      RefreshAttachmentGrid();
      Refreshcomment();
    }


    function CustomerBillingdatadetails() {
      var response = $http({
        url: $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID },
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
      });
    }
    function CustomerServicedatadetails() {
      var response = $http({
        url: $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID },
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatas = CustomerServicedata.data.data;
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
      });
    }
    function RefreshAttachmentGrid() {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id },
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }
    function Refreshcomment() {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByLead",
        method: "POST",
        data: { RequestID: $scope.Filee_id },
      });
      response.then(function (Commentdata) {
        if ($scope.CustomerCommentdatas != undefined)
          $scope.Commentdatas = $scope.CustomerCommentdatas.concat(Commentdata.data.data);
        else $scope.Commentdatas = Commentdata.data.data
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate)
        })
        $scope.Commentdatas = _.sortBy($scope.Commentdatas, "CreatedDate")
        $scope.Commentdatas.reverse();
      });
    }
    function calculateWidget10() {
      var SalesCustomer = []
      var Leads = []
      var Prospect = []

      var item = $scope.Leaddatas.filter(function (item) {
        return item.attachmentdetails.length > 0 && item.SalesOrderdetails.length == 0
      })
      if (item != undefined)
        Leads.push(item)
      var item = $scope.Leaddatas.filter(function (item) {
        return item.attachmentdetails.length == 0 && item.SalesOrderdetails.length == 0
      })
      if (item != undefined)
        Prospect.push(item)
      var item = $scope.Leaddatas.filter(function (item) {
        return item.SalesOrderdetails.length > 0
      })
      if (item != undefined)
        SalesCustomer.push(item)
      Leads = _.flatten(Leads)
      Prospect = _.flatten(Prospect)
      SalesCustomer = _.flatten(SalesCustomer)
      _.each(Leads, function (item) {
        item.CStatus = 'Lead'
      })
      _.each(Prospect, function (item) {
        item.CStatus = 'Prospect'
      })
      _.each(SalesCustomer, function (item) {
        item.CStatus = 'Completed'
      })
    }
    vm.dtOptions2 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#search');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      order: [[2, 'asc']],
      responsive: true,
      destroy: true,
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
      }
    };
    vm.dtdetails3 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-dtdetails2');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dataGridLead = {
      onInitialized: function (e) {
        dataGrid = e.component;
        if ($scope.Emp_Id != undefined) {

          RefreshGrid()
        }
        else {
          $scope.Leaddatas = []
          if (IsAdmin == true) {
            RefreshGrid()
          }
        }
      },
      onCellPrepared: function (e) {
        angular.forEach($scope.Leaddatas, function (value) {
          try {
            value.Followupdate = value.Commentdatas != null ? value.Commentdatas.CreatedDate : null;

          } catch (e) {
          }
        })
      },
      dataSource: $scope.Leaddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "LeadReferenceNo", caption: "Reference #",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.LeadReferenceNo + "</p>").appendTo(container);
            // if (options.data._id == $scope.vm.LastUpdateRecord) {
            //   $("<div style='display:-webkit-inline-box;padding:.2em.6em.3em;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color: #FF9800 !important;'>" + 'Last Modified' + "</div><br/>").appendTo(container);
            // }
            // if (options.data.Status == "Quotation Lost")
            //   $("<div style='display:-webkit-inline-box;padding:.2em.6em.3em;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color: #0094ac !important;'>" + 'Past Lead' + "</div>").appendTo(container);
            // else if (new Date(options.data.ExpectedResponseDate) < new Date() && moment(new Date()).diff(new Date(options.data.ExpectedResponseDate), 'days') >= 90 && options.data.attachmentdetails.length > 0) {
            //   $("<div style='display:-webkit-inline-box;padding:.2em.6em.3em;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color: #0094ac !important;'>" + 'Past Lead' + "</div>").appendTo(container);
            // }
          },
        },
        { dataField: "attachmentdetails[0].CreatedDate", caption: "Quotation Sent Date", dataType: "date", format: 'dd/MM/yyyy' },
        { dataField: "Customer", caption: "Customer" },
        {
          dataField: "Customerdetails[0].Mobile", caption: "Contact Number",
          calculateCellValue: function (rowData) {
            try {
              return rowData.Customerdetails[0].Mobile.replace(",", " , ");
            } catch (error) {
              return rowData.Customerdetails[0].Mobile;
            }
          }
        },
        // { dataField: "MarketSegment", caption: "Market Segment" },
        { dataField: "Employeedetails[0].EmployeeName", caption: "Sales Person" },
        {
          dataField: "ExpectedResponseDate", caption: "Expected Response Date", dataType: "date", format: 'dd/MM/yyyy',

        },
        { dataField: "Pipelinevalue", caption: "Pipeline Value (SGD)" },
        { dataField: "EnquiryType" },
        {
          dataField: "Followupdate", caption: "Last Contacted Date", dataType: "date", format: 'dd/MM/yyyy',
          calculateCellValue: function (data) {
            if (data.Followupdate)
              return new Date(new Date(data.Followupdate).getFullYear(), new Date(data.Followupdate).getMonth() + 3, new Date(data.Followupdate).getDate());
            else
              return new Date(data.CreatedDate);
          }
          // calculateCellValue: function ( data) {
          //   var Followup = ""
          //   if (data.Followupdate != "" && data.Followupdate != undefined && data.Followupdate != null)
          //     Followup = new Date(new Date(data.Followupdate).getFullYear(), new Date(data.Followupdate).getMonth() + 3, new Date(data.Followupdate).getDate())
          //   else Followup = new Date(data.CreatedDate)
          //   // $("<p style='color:black;cursor: default;'>" + formatDate(Followup) + "</p>").appendTo(container);
          // }
        },
        // { dataField: "ServiceTime", caption: "Service Time" },
        { dataField: "Status", caption: "Status" },
      ],
      bindingOptions: {
        dataSource: "Leaddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onEditingStart: function (e) {
        e.cancel = true
        $scope.Leadinfo(data._id)
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.Leadinfo(data.data._id)
        }
      }
    };
    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        ServicedataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: 'onClick',
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        { dataField: "sName", caption: "Name" },
        { dataField: "sContactPerson", caption: "Contact Person" },
        //   { dataField: "sBLK", caption: "Blk" },
        //   { dataField: "sUnit", caption: "Unit" },
        { dataField: "sUnit", caption: "Address" },
        { dataField: "sPostal", caption: "Postal" },
        { dataField: "sEmail", caption: "Email" },
        { dataField: "sMobile", caption: "Mobile" },
        {
          caption: 'View/Edit',
          fixed: true,
          fixedPosition: 'right',
          width: 80,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'edit',
              onClick: function (e) {
                var index = dataGrid.getRowIndexByKey(options.rowIndex);
                $scope.Servicesupdate(e, options.data._id, index)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Delete',
          fixed: true,
          fixedPosition: 'right',
          width: 60,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                var index = dataGrid.getRowIndexByKey(options.data._id);
                $scope.cspopup(e, options.data._id, index, "Service")
              }
            }).appendTo(container);
          }
        },
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
          $scope.SAdiv = true;
        }
        else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index)

      },
    };
    vm.dataGridCustomerBilling = {
      onInitialized: function (e) {
        BillingdataGrid = e.component;
      },
      dataSource: $scope.CustomerBillingdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        { dataField: "bContactPerson", caption: "Contact Person" },
        //   { dataField: "bBLK", caption: "Blk" },
        { dataField: "bUnit", caption: "Address" },
        { dataField: "bPostal", caption: "Postal" },
        { dataField: "bCountry", caption: "Country" },
        { dataField: "bEmail", caption: "Email" },
        { dataField: "bMobile", caption: "Mobile" },
        {
          caption: 'View/Edit',
          fixed: true,
          fixedPosition: 'right',
          width: 80,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'edit',
              onClick: function (e) {
                var index = BillingdataGrid.getRowIndexByKey(options.data._id);
                $scope.Billingupdate(e, options.data._id, index)
              }
            }).appendTo(container);
          }
        },
        {
          caption: 'Delete',
          fixed: true,
          fixedPosition: 'right',
          width: 60,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                var index = BillingdataGrid.getRowIndexByKey(options.data._id);
                $scope.cspopup(e, options.data._id, index, "Billing")
              }
            }).appendTo(container);
          }
        },
      ],
      bindingOptions: {
        dataSource: "CustomerBillingdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
          $scope.SAdiv = true;
        }
        else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index)

      },
    };
    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }
    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    $scope.AddCon = true
    $scope.Frequencydatas = [];
    $scope.AddContract = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/contracts.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      })
      getSor()
      $scope.AddCon = false
      $scope.vm.SEmail = []
      $scope.vm.SiteContactPerson = null;
      $scope.vm.SiteName = null;
      $scope.vm.SiteContact = [];
      $scope.vm.EnquiryID = $scope.vm.LeadReferenceNo
      $scope.vm.ppCompanyName = $scope.vm.uCompanyName;
      $scope.vm.ppSalutation = $scope.vm.uSalutation;
      $scope.vm.ppAddress = $scope.vm.uAddress;
      $scope.vm.TotalOrderValue = parseFloat($scope.vm.Pipelinevalue)
      if ($scope.vm.uEmail != "" && $scope.vm.uEmail != null && $scope.vm.uEmail != undefined)
        $scope.vm.ppEmail = $scope.vm.uEmail.split(',');
      else
        $scope.vm.ppEmail = []
      $scope.vm.ppContactPerson = $scope.vm.uContactPerson;
      if ($scope.vm.uMobile != null && $scope.vm.uMobile != undefined && $scope.vm.uMobile != "")
        $scope.vm.ppMobile = $scope.vm.uMobile.split(',').slice(0, 2);
      else
        $scope.vm.ppMobile = []
      var response = $http({
        url: $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID },
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
      })
      var response = $http({
        url: $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID },
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerBillingAddress = CustomerServicedata.data.data;
      })
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    }
    $scope.SORDerails = function (tick, e, check) {
      $scope.Disablesubmit = false
      if (tick == true) {
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/crm/contracts/AddSor.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          controller: function LeadController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
        var updating = false

        $scope.dataGridOptions = {
          dataSource: $scope.Sordatas,
          keyExpr: "_id",
          showBorders: true,
          paging: {
            enabled: false
          },

          editing: {
            mode: "batch",
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            useIcons: true
          },
          onRowUpdating: function (e) {
            updating = true;

          },
          onRowRemoving: function (e) {
            updating = true;
          },
          onRowInserting: function (e) {
            updating = true;

          },
          onContentReady: function (e) {
            if (e.component.hasEditData()) {
              $scope.Disablesubmit = true
            }
            else
              $scope.Disablesubmit = false
          },
          columns: [
            {
              caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
              }
            },
            {
              dataField: "Description",
              caption: "Description",
              width: "30%"
            },
            {
              dataField: "Unit",
              width: "10%"
            }, {
              dataField: "RateDuringOfficeHour",
              caption: "Rate ($) During Office Hour",
              width: "15%"
            },
            {
              dataField: "RateAfterOfficeHour",
              caption: "Rate ($) After Office Hour",
              width: "15%"
            },
          ]
        };
      }
      if (check == false) $scope.ShowSubmit = false
      else $scope.ShowSubmit = true
    }
    $scope.SubmitSOR = function () {
      $scope.dataSource = $('#gridContainer').dxDataGrid('instance').option('dataSource')
      if ($scope.dataSource.length == 0)
        $mdToast.show($mdToast.simple().textContent('Please Fill SOR details or Click Cancel button !').position('top center'));
      else
        $scope.cancel()
    }
    $scope.AddPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.Treatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/AddPestTypepopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      RefreshTreatment();
    }
    $scope.ChangeCustomer = function (Customerdata) {
      $scope.vm.CMarketSegment = null;
      try {
        $scope.vm.CName = Customerdata.FirstName;
        $scope.vm.CSalutation = Customerdata.Salutation;
        $scope.vm.Ccontact = Customerdata.Mobile;
        if (Customerdata.MarketSection != null && Customerdata.MarketSection != '' && Customerdata.MarketSection != undefined) {
          var a = Customerdata.MarketSection.split(',')
          var array = []
          _.each(a, function (ite) {
            array.push({ SegmentName: ite })
          })
          $scope.vm.CMarketSegment = array
        }
        $scope.CusEmail = ""
        try {
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === Customerdata._id
          })
          $scope.Leaddatas = litem
        } catch (e) { }
        if ($scope.Leaddatas.length > 0) {
          $scope.vm.EnquiryID = $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
          if ($scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == 'Day')
            $scope.vm.ServiceHours = 'During Office Hours'
          else if ($scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == 'Night')
            $scope.vm.ServiceHours = 'After Office Hours'
          else $scope.vm.ServiceHours = 'Wee Hours 11.30pm - 7am'
          $scope.vm.TotalOrderValue = parseFloat($scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue)
        }
        var response = $http({
          url: $rootScope.WebURL + "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: Customerdata.CustomerID },
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        })
      } catch (e) {
        $scope.vm.CMarketSegment = null;
      }
    }
    $scope.sContracctSubmit = function () {
      try {
        angular.forEach($scope.salesOrderdatas, function (svalue) {
          if ($scope.vm.SalesOrderID == svalue._id) {
            $scope.vm.Customer_id = svalue.customerdetails[0]._id;
          }
        });
      } catch (error) { }
      if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
        $scope.vm.NatureofJob = $scope.vm.NatureofJob.map(function (obj) { return obj.PestName; }).join(',');
      }
      if ($scope.vm.CMarketSegment != null && $scope.vm.CMarketSegment != "" && $scope.vm.CMarketSegment != undefined) {
        $scope.vm.CMarketSegment = $scope.vm.CMarketSegment.map(function (obj) { return obj.SegmentName; }).join(',');
      }
      if ($scope.vm.ppEmail != null && $scope.vm.ppEmail != "" && $scope.vm.ppEmail != undefined) {
        $scope.vm.ppEmail = $scope.vm.ppEmail.map(function (obj) { return obj; }).join(',');
      }
      if ($scope.vm.SEmail != null && $scope.vm.SEmail != "" && $scope.vm.SEmail != undefined) {
        $scope.vm.SEmail = $scope.vm.SEmail.map(function (obj) { return obj; }).join(',');
      }
      if ($scope.vm.ppMobile != null && $scope.vm.ppMobile != "" && $scope.vm.ppMobile != undefined) {
        $scope.vm.ppMobile = $scope.vm.ppMobile.map(function (obj) { return obj; }).join(',');
      }


      var ContractArray = []
      angular.forEach($scope.vm.CAddress, function (Lis) {
        try {
          var multiFrequency = $scope.Frequencydatas[0].Frequency
        } catch (e) {
          var multiFrequency = $scope.vm.Frequency
        }
        ContractArray.push({
          SalesPerson_id: $scope.vm.SalesPerson,
          Frequency: multiFrequency,
          MarketSegment: $scope.vm.CMarketSegment,
          CreditTerm: $scope.vm.CreditTerm,
          TemplateID: $scope.vm.TemplateName,
          ContactNumber: $scope.vm.ppMobile,
          IncludeSOR: $scope.vm.IncludeSOR,
          MultiFrequency: $scope.Frequencydatas,
          ContactPerson: $scope.vm.uContactPerson,
          ServiceEndDate: $scope.vm.ServiceEndDate,
          ServiceStartDate: $scope.vm.ServiceStartDate,
          ContractStartDate: $scope.vm.ContractStartDate,
          ContractEndDate: $scope.vm.ContractEndDate,
          ContractDuration: $scope.vm.ContractDuration,
          ContractValue: $scope.vm.TotalOrderValue,
          ServiceHours: $scope.vm.ServiceHours,
          BillingFrequency: $scope.vm.BillingFrequency,
          TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
          Customer_id: $scope.vm.Customer_id,
          CustomerID: Lis._id,
          EnquiryID: $scope.vm.EnquiryID,
          ContractNotes: $scope.vm.ContractNotes,
          ContractStatus: $scope.vm.ContractStatus,
          Status: $scope.vm.CurrentStatus,
          StatusID: $scope.vm.CurrentStatusID,
          CreatedBy: $rootScope.createdby, IsActive: "true",
          Client_Id: $rootScope.Client_Id,
          SORDetails: $scope.dataSource,
          Head: $scope.vm.Header,
          Head1: $scope.vm.Header1,
          Head2: $scope.vm.Header2,
          Email: $scope.vm.ppEmail,
          SiteContactPerson: $scope.vm.SiteContactPerson,
          SiteEmail: $scope.vm.SEmail,
          BillingAddress: $scope.vm.BAddress,
          SiteContact: $scope.vm.SiteContact,
        })
      })
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/addbyarray",
        data: { data: ContractArray },
      });
      response.then(function (GList) {
        $mdDialog.cancel();
        $mdToast.show($mdToast.simple().textContent('Successfully Added and Redirecting to Contract Page!').position('top center'));
        $scope.AddCon = true
        RefreshGrid();
        var response1 = $http({
          method: "POST",
          url: $rootScope.WebURL + "/sor/delete",
          data: {
            Client_Id: $rootScope.Client_Id, FieldName: 'Contract', FieldValue: $scope.SID
          },
        });
        response1.then(function (Ls) {
          var count = 0
          angular.forEach($scope.dataSource, function (item) {
            var response2 = $http({
              method: "POST",
              url: $rootScope.WebURL + "/sor/add",
              data: {
                Customer: $scope.vm.Customer_id,
                Contract: $scope.SID,
                Description: item.Description,
                Unit: item.Unit,
                RateDuringOfficeHour: item.RateDuringOfficeHour,
                RateAfterOfficeHour: item.RateAfterOfficeHour,
                Client_Id: $rootScope.Client_Id,
                CreatedBy: $rootScope.createdby
              },
            });
            response2.then(function (GList) {
              count++
              if (count == $scope.dataSource.length + 1) {
                $mdToast.show($mdToast.simple().textContent('SOR Added Successfully !').position('top center'));
              }
            })
          })
        })
        $timeout(function () {
          $state.go('app.contracts')
        }, 5000)
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });

    }

    $scope.getMonth = function (StartDate, EndDate, Frequency) {
      if (StartDate != "" && StartDate != null && StartDate != undefined && EndDate != "" && EndDate != null && EndDate != undefined) {
        EndDate = moment(EndDate).add(1, 'days')
        var a = moment(StartDate)
        var b = EndDate
        var Month = b.diff(a, 'month')
        $scope.vm.TotalMonth = Month
      }
      else
        $scope.vm.TotalMonth = 0
    }
    $scope.getServiceEndDate = function (StartDate) {
      if (StartDate != null && StartDate != undefined && StartDate != "") {
        var StartDate = new Date(StartDate)
        $scope.vm.ServiceEndDate = moment(StartDate).add(1, 'year')
        $scope.vm.ServiceEndDate = new Date($scope.vm.ServiceEndDate.add(-1, 'days'))
      }
    }

    $scope.ClickTemplate = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/PreviewTemplate.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });

      var Start = moment()._locale._months[moment($scope.vm.ServiceStartDate).month()] + " " + moment($scope.vm.ServiceStartDate).year()
      var End = moment()._locale._months[moment($scope.vm.ServiceEndDate).month()] + " " + moment($scope.vm.ServiceEndDate).year()
      if ($scope.vm.TotalMonth == undefined && $scope.vm.ServiceStartDate != "" && $scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != undefined && $scope.vm.ServiceEndDate != "" && $scope.vm.ServiceEndDate != null
        && $scope.vm.ServiceEndDate != undefined)
        $scope.getMonth($scope.vm.ServiceStartDate, $scope.vm.ServiceEndDate, null)
      var Month = $scope.vm.TotalMonth
      var Months = $scope.vm.TotalMonth
      var Frequency = $scope.vm.BillingFrequency
      var Amount = 0
      var freqbasis = ""
      if (Frequency == "COD") {
        freqbasis = " in Cash"
        Amount = parseFloat($scope.vm.TotalOrderValue) / 1
      }
      else if (Frequency == "Weekly") {
        freqbasis = " per week"
        var start = moment(new Date($scope.vm.ServiceStartDate))
        var end = moment(new Date($scope.vm.ServiceEndDate))
        var weeks = end.diff(start, "week")
        Amount = parseFloat($scope.vm.TotalOrderValue) / weeks
      }
      else if (Frequency == "Monthly") {
        freqbasis = " per month"
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month
      }
      else if (Frequency == "Quarterly") {
        freqbasis = " quarterly"
        var Month = parseInt(Month / 3)
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month
      }
      else if (Frequency == "Bi-Monthly (6)") {
        freqbasis = " bi-monthly"
        Frequency = "Bi-Monthly"
        var Month = parseInt(Month / 2)
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month
      }
      else if (Frequency == "Half Yearly (2)") {
        freqbasis = " half yearly"
        Frequency = "Half Yearly"
        var Month = parseInt(Month / 6)
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month
      }
      else if (Frequency == "Yearly") {
        freqbasis = " per year"
        var Month = parseInt(Month / 12)
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month

      }

      if (Month != 0 && Month != 1) Months = Months + " months"; else Months = Month + " month";

      if (Amount % 1 < 1 && Amount % 1 != 0) {
        Amount = Amount.toFixed(2)
      }
      var amtt = Amount
      amtt = parseFloat(amtt) * 7 / 100 + parseFloat(amtt)
      var amt = parseFloat(amtt)
      var amout = amt
      if (amt % 1 < 1 && amt % 1 != 0) {
        amt = amt.toFixed(2)
      }

      var amountt = amout.toFixed(2)

      if ($scope.vm.ServiceHours == "During Office Hours")
        var OfficeHours = "During Office Hours 9am - 5pm"
      else if ($scope.vm.ServiceHours == "After Office Hours")
        var OfficeHours = "After Office Hours 5pm - 12:00mn"
      else if ($scope.vm.ServiceHours == "Wee Hours")
        var OfficeHours = "During Wee Hours 12:00mn - 9am"

      vm.Header = "<p align='justify'>This Contract will hereby commence at the above service location from <u><b>" + Start + "</b></u> to <u><b>" + End + "</b></u> and to hold unto The Client for a period of <u><b>" + Months + "</b></u>. The Client agrees to pay for the scope of work on a <u><b>" + Frequency + "</b></u> basis, a sum of Singapore Dollars <u><b>" + toWords(amt) + " S$ " + amountt + " (inclusive of GST)</b></u> " + freqbasis + ". Payable to <b>Pest Off Pte Ltd</b> within " + $scope.vm.CreditTerm + " of invoice. Additional services will be charged separately.</p>"
      vm.Header1 = "<p align='justify'>Refer to the 'Scope of Work' as stated below will be carried out <b>" + OfficeHours + "</b>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range. </p>"
      vm.Header2 = "<div><h4><b>ACCESS TO PREMISES</b></h4></div><div><p align='justify'>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p></div><div><h4><b>LIABILITY</b></h4></div><div><p align='justify'>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div></p></div><div><h4><b>TERMINATION OF CONTRACT</b></h4></div><div><p align='justify'>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Month notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>"

    }
    $scope.EditPestControl = function (e, item) {
      RefreshTreatment();
      $scope.EditFrequency = true;
      $scope.vm.Frequency = item.Frequency;
      $scope.vm.Pesttype = item.PestType;
      $scope.vm.ServiceTrap = item.ServiceTrap;
      $scope.ChangeTreatment(item);
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/contracts/AddPestTypepopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.DeletePestControl = function (DeleteItem) {
      var index = $scope.Frequencydatas.indexOf(DeleteItem);
      $scope.Frequencydatas.splice(index, 1);
    }
    $scope.AddLostQuotation = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/lead/quotationLost.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function LeadController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    vm.taToolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
      ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
    ];
    var th = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    var dg = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    var tn = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    var tw = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    function toWords(s) {
      s = s.toString();
      s = s.replace(/[\, ]/g, '');
      if (s != parseFloat(s)) return 'not a number';
      var x = s.indexOf('.');
      if (x == -1) x = s.length;
      if (x > 15) return 'too big';
      var n = s.split('');
      var str = '';
      var sk = 0;
      for (var i = 0; i < x; i++) {
        if ((x - i) % 3 == 2) {
          if (n[i] == '1') {
            str += tn[Number(n[i + 1])] + ' ';
            i++;
            sk = 1;
          } else if (n[i] != 0) {
            str += tw[n[i] - 2] + ' ';
            sk = 1;
          }
        } else if (n[i] != 0) {
          str += dg[n[i]] + ' ';
          if ((x - i) % 3 == 0) str += 'Hundred ';
          sk = 1;
        }
        if ((x - i) % 3 == 1) {
          if (sk) str += th[(x - i - 1) / 3] + ' ';
          sk = 0;
        }
      }
      if (x != s.length) {
        if (str != "")
          str += 'and ';
        if (Number(s.charAt(x + 1)) > 1) {
          if (Number(s.charAt(x + 1)) > 1) {
            str += tw[Number(s.charAt(x + 1)) - 2] + ' '
          }
          else if (Number(s.charAt(x + 1)) == 1 && Number(s.charAt(x + 2)) > 0) {
            str += tn[Number(s.charAt(x + 2)) - 1] + ' '
          }
          else
            str += tn[0] + ' '

          if (Number(s.charAt(x + 2)) != 0)
            str += dg[Number(s.charAt(x + 2))] + ' '
        }
        else if (Number(s.charAt(x + 1)) == 1 && Number(s.charAt(x + 2)) > 0) {
          str += tn[Number(s.charAt(x + 2))] + ' '
        }
        else if (Number(s.charAt(x + 1)) == 0) {
          str += dg[Number(s.charAt(x + 2))] + ' '
        }
        else
          str += tn[0] + ' '
        str += 'cents '
      }
      return str.replace(/\s+/g, ' ');
    }
    $scope.SubmitPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.Treatmentpopupdata, function (item) {

        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        if (item.selectothers == false) { OthersTreatment = undefined; }
        var ServiceTrap = item.ServiceTrap
        if (item.SelectServiceTrap == false) { ServiceTrap = undefined; }


        if (item1 !== undefined) {
          Treatmentarray = item1.map(function (obj) { return obj.TreatmentName; }).join(', ');
        }
        array = $scope.Frequencydatas.filter(function (item2) {
          return item2.PestType == item.PestName && item2.Frequency == $scope.vm.Frequency;
        });
        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps"
          else
            Treatmentarray = "Service Light Traps"
        }

        if (array.length == 0) {
          $scope.Frequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].Treatment = Treatmentarray;
          $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].Others = OthersTreatment;
          $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].ServiceTrap = ServiceTrap;
        } else {
          $mdToast.show($mdToast.simple().textContent('Existing Data!').position('top center'));
        }
      });
      $mdDialog.hide();
    }
    $scope.ChangeTreatment = function (Pestdata) {
      $scope.Treatmentpopupdata = [];
      if ($scope.EditFrequency == false) {

        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType.indexOf(Pestname) > -1) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.Treatmentpopupdata.push({ PestName: Pestname, Treatment: array });
          })
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType.indexOf(Pestdata.PestType) > -1) {
            var selectedtreatment = Pestdata.Treatment.split(', ');
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({ TreatmentName: item1.TreatmentName, selected: item1.selected });

          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        var OthersSelect = false
        var ServiceTypeSelect = false
        if (Pestdata.Others !== undefined) { OthersSelect = true; } else { OthersSelect = false; }
        if (Pestdata.ServiceTrap !== undefined) { ServiceTypeSelect = true; } else { ServiceTypeSelect = false; }
        array.map(function (o, k) { if (o.TreatmentName === "Service Light Traps") if (k != undefined) array.splice(k) })
        $scope.Treatmentpopupdata.push({ PestName: Pestdata.PestType, Treatment: array, Others: Pestdata.Others, selectothers: OthersSelect, ServiceTrap: Pestdata.ServiceTrap, SelectServiceTrap: ServiceTypeSelect });
      }
    }
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contracttemplate",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (contracttemplate) {
      $scope.Contracttemplates = contracttemplate.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
      $scope.Pestdatasdatas = pestdata.data.data;
    });
    function RefreshTreatment() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Treatmentdata) {
        $scope.Treatmentdatas = Treatmentdata.data.data;
      });
    }

    function getSor() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/sor/get",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Sortabledata) {
        $scope.Sordatas = Sortabledata.data.data;
      })
    }

    $scope.QuotationSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          LeadID: $scope.SID,
          CustomerID: $scope.vm.CustomerID,
          TableName: "Lead",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.QuotationLost,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        var response1 = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/lead/updateStatus",
          data: {
            id: $scope.SID,
            Status: $scope.vm.status,
            UpdatedBy: $rootScope.createdby
          }
        });
        response1.then(function (GList) {
          $scope.Filee_id = $scope.vm.LeadId;
          Refreshcomment();
          clearLost();
          $mdDialog.cancel();
          $scope.Leadgrid = true;
          $scope.Leadform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.Search = true;
          $scope.view = false;
          RefreshGrid();
          $mdToast.show($mdToast.simple().textContent('Quotation ' + $scope.vm.status + '!!').position('top center'));
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      });
    }
    function clearLost() {
      $scope.vm.QuotationLost = "";
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    })


    $scope.CountyList = [
      {
        "name": "Afghanistan"
      },
      {
        "name": "Albania"
      },
      {
        "name": "Algeria"
      },
      {
        "name": "American Samoa"
      },
      {
        "name": "AndorrA"
      },
      {
        "name": "Angola"
      },
      {
        "name": "Anguilla"
      },
      {
        "name": "Antarctica"
      },
      {
        "name": "Antigua and Barbuda"
      },
      {
        "name": "Argentina"
      },
      {
        "name": "Armenia"
      },
      {
        "name": "Aruba"
      },
      {
        "name": "Australia"
      },
      {
        "name": "Austria"
      },
      {
        "name": "Azerbaijan"
      },
      {
        "name": "Bahamas"
      },
      {
        "name": "Bahrain"
      },
      {
        "name": "Bangladesh"
      },
      {
        "name": "Barbados"
      },
      {
        "name": "Belarus"
      },
      {
        "name": "Belgium"
      },
      {
        "name": "Belize"
      },
      {
        "name": "Benin"
      },
      {
        "name": "Bermuda"
      },
      {
        "name": "Bhutan"
      },
      {
        "name": "Bolivia"
      },
      {
        "name": "Bosnia and Herzegovina"
      },
      {
        "name": "Botswana"
      },
      {
        "name": "Bouvet Island"
      },
      {
        "name": "Brazil"
      },
      {
        "name": "British Indian Ocean Territory"
      },
      {
        "name": "Brunei Darussalam"
      },
      {
        "name": "Bulgaria"
      },
      {
        "name": "Burkina Faso"
      },
      {
        "name": "Burundi"
      },
      {
        "name": "Cambodia"
      },
      {
        "name": "Cameroon"
      },
      {
        "name": "Canada"
      },
      {
        "name": "Cape Verde"
      },
      {
        "name": "Cayman Islands"
      },
      {
        "name": "Central African Republic"
      },
      {
        "name": "Chad"
      },
      {
        "name": "Chile"
      },
      {
        "name": "China"
      },
      {
        "name": "Christmas Island"
      },
      {
        "name": "Cocos (Keeling) Islands"
      },
      {
        "name": "Colombia"
      },
      {
        "name": "Comoros"
      },
      {
        "name": "Congo"
      },
      {
        "name": "Congo, The Democratic Republic of the"
      },
      {
        "name": "Cook Islands"
      },
      {
        "name": "Costa Rica"
      },
      {
        "name": "Cote D'Ivoire"
      },
      {
        "name": "Croatia"
      },
      {
        "name": "Cuba"
      },
      {
        "name": "Cyprus"
      },
      {
        "name": "Czech Republic"
      },
      {
        "name": "Denmark"
      },
      {
        "name": "Djibouti"
      },
      {
        "name": "Dominica"
      },
      {
        "name": "Dominican Republic"
      },
      {
        "name": "Ecuador"
      },
      {
        "name": "Egypt"
      },
      {
        "name": "El Salvador"
      },
      {
        "name": "Equatorial Guinea"
      },
      {
        "name": "Eritrea"
      },
      {
        "name": "Estonia"
      },
      {
        "name": "Ethiopia"
      },
      {
        "name": "Falkland Islands (Malvinas)"
      },
      {
        "name": "Faroe Islands"
      },
      {
        "name": "Fiji"
      },
      {
        "name": "Finland"
      },
      {
        "name": "France"
      },
      {
        "name": "French Guiana"
      },
      {
        "name": "French Polynesia"
      },
      {
        "name": "French Southern Territories"
      },
      {
        "name": "Gabon"
      },
      {
        "name": "Gambia"
      },
      {
        "name": "Georgia"
      },
      {
        "name": "Germany"
      },
      {
        "name": "Ghana"
      },
      {
        "name": "Gibraltar"
      },
      {
        "name": "Greece"
      },
      {
        "name": "Greenland"
      },
      {
        "name": "Grenada"
      },
      {
        "name": "Guadeloupe"
      },
      {
        "name": "Guam"
      },
      {
        "name": "Guatemala"
      },
      {
        "name": "Guernsey"
      },
      {
        "name": "Guinea"
      },
      {
        "name": "Guinea-Bissau"
      },
      {
        "name": "Guyana"
      },
      {
        "name": "Haiti"
      },
      {
        "name": "Heard Island and Mcdonald Islands"
      },
      {
        "name": "Holy See (Vatican City State)"
      },
      {
        "name": "Honduras"
      },
      {
        "name": "Hong Kong"
      },
      {
        "name": "Hungary"
      },
      {
        "name": "Iceland"
      },
      {
        "name": "India"
      },
      {
        "name": "Indonesia"
      },
      {
        "name": "Iran, Islamic Republic Of"
      },
      {
        "name": "Iraq"
      },
      {
        "name": "Ireland"
      },
      {
        "name": "Isle of Man"
      },
      {
        "name": "Israel"
      },
      {
        "name": "Italy"
      },
      {
        "name": "Jamaica"
      },
      {
        "name": "Japan"
      },
      {
        "name": "Jersey"
      },
      {
        "name": "Jordan"
      },
      {
        "name": "Kazakhstan"
      },
      {
        "name": "Kenya"
      },
      {
        "name": "Kiribati"
      },
      {
        "name": "Korea, Democratic People'S Republic of"
      },
      {
        "name": "Korea, Republic of"
      },
      {
        "name": "Kuwait"
      },
      {
        "name": "Kyrgyzstan"
      },
      {
        "name": "Lao People'S Democratic Republic"
      },
      {
        "name": "Latvia"
      },
      {
        "name": "Lebanon"
      },
      {
        "name": "Lesotho"
      },
      {
        "name": "Liberia"
      },
      {
        "name": "Libyan Arab Jamahiriya"
      },
      {
        "name": "Liechtenstein"
      },
      {
        "name": "Lithuania"
      },
      {
        "name": "Luxembourg"
      },
      {
        "name": "Macao"
      },
      {
        "name": "Macedonia, The Former Yugoslav Republic of"
      },
      {
        "name": "Madagascar"
      },
      {
        "name": "Malawi"
      },
      {
        "name": "Malaysia"
      },
      {
        "name": "Maldives"
      },
      {
        "name": "Mali"
      },
      {
        "name": "Malta"
      },
      {
        "name": "Marshall Islands"
      },
      {
        "name": "Martinique"
      },
      {
        "name": "Mauritania"
      },
      {
        "name": "Mauritius"
      },
      {
        "name": "Mayotte"
      },
      {
        "name": "Mexico"
      },
      {
        "name": "Micronesia, Federated States of"
      },
      {
        "name": "Moldova, Republic of"
      },
      {
        "name": "Monaco"
      },
      {
        "name": "Mongolia"
      },
      {
        "name": "Montenegro"
      },
      {
        "name": "Montserrat"
      },
      {
        "name": "Morocco"
      },
      {
        "name": "Mozambique"
      },
      {
        "name": "Myanmar"
      },
      {
        "name": "Namibia"
      },
      {
        "name": "Nauru"
      },
      {
        "name": "Nepal"
      },
      {
        "name": "Netherlands"
      },
      {
        "name": "Netherlands Antilles"
      },
      {
        "name": "New Caledonia"
      },
      {
        "name": "New Zealand"
      },
      {
        "name": "Nicaragua"
      },
      {
        "name": "Niger"
      },
      {
        "name": "Nigeria"
      },
      {
        "name": "Niue"
      },
      {
        "name": "Norfolk Island"
      },
      {
        "name": "Northern Mariana Islands"
      },
      {
        "name": "Norway"
      },
      {
        "name": "Oman"
      },
      {
        "name": "Pakistan"
      },
      {
        "name": "Palau"
      },
      {
        "name": "Palestinian Territory, Occupied"
      },
      {
        "name": "Panama"
      },
      {
        "name": "Papua New Guinea"
      },
      {
        "name": "Paraguay"
      },
      {
        "name": "Peru"
      },
      {
        "name": "Philippines"
      },
      {
        "name": "Pitcairn"
      },
      {
        "name": "Poland"
      },
      {
        "name": "Portugal"
      },
      {
        "name": "Puerto Rico"
      },
      {
        "name": "Qatar"
      },
      {
        "name": "Reunion"
      },
      {
        "name": "Romania"
      },
      {
        "name": "Russian Federation"
      },
      {
        "name": "RWANDA"
      },
      {
        "name": "Saint Helena"
      },
      {
        "name": "Saint Kitts and Nevis"
      },
      {
        "name": "Saint Lucia"
      },
      {
        "name": "Saint Pierre and Miquelon"
      },
      {
        "name": "Saint Vincent and the Grenadines"
      },
      {
        "name": "Samoa"
      },
      {
        "name": "San Marino"
      },
      {
        "name": "Sao Tome and Principe"
      },
      {
        "name": "Saudi Arabia"
      },
      {
        "name": "Senegal"
      },
      {
        "name": "Serbia"
      },
      {
        "name": "Seychelles"
      },
      {
        "name": "Sierra Leone"
      },
      {
        "name": "Singapore"
      },
      {
        "name": "Slovakia"
      },
      {
        "name": "Slovenia"
      },
      {
        "name": "Solomon Islands"
      },
      {
        "name": "Somalia"
      },
      {
        "name": "South Africa"
      },
      {
        "name": "South Georgia and the South Sandwich Islands"
      },
      {
        "name": "Spain"
      },
      {
        "name": "Sri Lanka"
      },
      {
        "name": "Sudan"
      },
      {
        "name": "Suriname"
      },
      {
        "name": "Svalbard and Jan Mayen"
      },
      {
        "name": "Swaziland"
      },
      {
        "name": "Sweden"
      },
      {
        "name": "Switzerland"
      },
      {
        "name": "Syrian Arab Republic"
      },
      {
        "name": "Taiwan, Province of China"
      },
      {
        "name": "Tajikistan"
      },
      {
        "name": "Tanzania, United Republic of"
      },
      {
        "name": "Thailand"
      },
      {
        "name": "Timor-Leste"
      },
      {
        "name": "Togo"
      },
      {
        "name": "Tokelau"
      },
      {
        "name": "Tonga"
      },
      {
        "name": "Trinidad and Tobago"
      },
      {
        "name": "Tunisia"
      },
      {
        "name": "Turkey"
      },
      {
        "name": "Turkmenistan"
      },
      {
        "name": "Turks and Caicos Islands"
      },
      {
        "name": "Tuvalu"
      },
      {
        "name": "Uganda"
      },
      {
        "name": "Ukraine"
      },
      {
        "name": "United Arab Emirates"
      },
      {
        "name": "United Kingdom"
      },
      {
        "name": "United States"
      },
      {
        "name": "United States Minor Outlying Islands"
      },
      {
        "name": "Uruguay"
      },
      {
        "name": "Uzbekistan"
      },
      {
        "name": "Vanuatu"
      },
      {
        "name": "Venezuela"
      }];

  }

})();

(function ()
{
    'use strict';

    angular
        .module('apps.crm.customer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.customer', {
            url      : '/Customers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/customer/customer.html',
                    controller: 'customerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/customer');
    }

})();
(function () {
  "use strict";

  angular
    .module("apps.crm.customer")
    .controller("customerController", customerController)
    .filter("groupBy", function () {
      return _.memoize(function (items, field) {
        return _.groupBy(items, field);
      });
    })
    .directive("chooseFile", function () {
      return {
        link: function (scope, elem, attrs, transcludeFn) {
          var button = angular.element(
            elem[0].querySelector("button#uploadButton")
          );
          var Clearbutton = angular.element(
            elem[0].querySelector("button#clearButton")
          );
          var input = angular.element(elem[0].querySelector("input#fileInput"));
          button.bind("click", function () {
            input[0].click();
          });
          Clearbutton.bind("click", function () {
            var input = angular
              .element(elem[0].querySelector("input#fileInput"))
              .val("");
            scope.fileName = "";
          });
          input.bind("change", function (e) {
            scope.$apply(function () {
              var files = e.target.files;
              if (files[0]) {
                scope.fileName = files[0].name;
                scope.UploadButtonName = "Change";
                scope.UploadButton = true;
                scope.ClearButton = true;
                var reader = new FileReader();
                reader.onload = function (e) {
                  $("#imagePreview")
                    .attr("src", e.target.result)
                    .width(200)
                    .height(70);
                };
                scope.FilePath = null;
                reader.readAsDataURL(files[0]);
              } else {
                $("#imagePreview").attr("src", null);
                scope.fileName = null;
                scope.UploadButtonName = "Upload Quotation";
                scope.ClearButton = false;
              }
            });
          });
        }
      };
    })
    .filter("htmlToPlaintext", function () {
      return function (text) {
        if (text) return text.replace(/<[^>]+>/gm, "");
        else return "";
      };
    });

  function customerController(
    $mdDateLocale,
    $scope,
    $rootScope,
    $mdConstant,
    $interval,
    $state,
    $mdToast,
    $mdSidenav,
    $location,
    $mdDialog,
    $document,
    $http,
    $log,
    $filter,
    Upload,
    NgMap,
    DataSyncService,
    $timeout
  ) {
    document.getElementsByTagName("title")[0].text = "Customer Relationship-Customers";
    var chkAceses = localStorage.getItem("pages");
    if (chkAceses.split(",").includes("Customers")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }

    $scope.ShowCheckBox = false;
    var chkAllowCustomerExport = localStorage.getItem("AllowExport");
    var getRoleaccess = localStorage.getItem("Roles");
    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    var EmpID = localStorage.getItem("EmployeeID");
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var Emploee = "";
    var vm = this;
    $scope.ViewAllCustomer = false;
    $scope.IsAdmin = IsAdmin;
    $scope.Roleaccess = getRoleaccess;
    $scope.AllCustomersview = AllCustomersview;
    // $scope.Customerdatas = [];
    $scope.CustomerSelectedIds = [];
    $scope.Cdiv = false;
    $scope.CAll = false;
    $scope.CSelec = { value: false };
    $scope.CMSelec = { value: false };

    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log("markers", map.markers);
      console.log("shapes", map.shapes);
    });

    $scope.uFrom = new Date();
    $scope.uTo = new Date();
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo.setHours(23, 59, 59, 999);

    vm.uMobile = [];
    vm.contactErrorMessage = false;

    $timeout(function () {
      var emailInput = angular.element(document.querySelector('#Email1 input[placeholder="Email"]'));
      var contactInput = angular.element(document.querySelector('#Contact1 input[placeholder="Contact Number"]'));

      emailInput.on('blur', function () {
        var val = emailInput.val().trim();
        $scope.$apply(function () {
          vm.emailChipWarning = !!val;
        });
      });

      contactInput.on('blur', function () {
        var val = contactInput.val().trim();
        $scope.$apply(function () {
          vm.contactChipWarning = !!val;
        });
      });

    }, 500);

    $scope.transformChip = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    $scope.transformChip1 = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError1 = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError1 = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    $scope.transformChip2 = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError2 = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError2 = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    vm.onEmailChipAdd = function () {
      vm.emailChipWarning = false;
    };

    vm.onContactChipAdd = function () {
      vm.contactChipWarning = false;
    };

    vm.onEmailChipAdd1 = function () {
      vm.emailChipWarning1 = false;
    };
    vm.onContactChipAdd1 = function () {
      vm.contactChipWarning1 = false;
    };
    vm.onCCChipAdd = function () {
      vm.emailccWarning = false;
    };


    vm.transformPhone = function (chip) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (regex.test(chip)) {
        vm.contactErrorMessage = false;
        return chip; // valid
      } else {
        vm.contactErrorMessage = true;
        return null; // invalid, will not be added
      }
    };

    vm.validateLive = function (input) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (!regex.test(input)) {
        vm.errorMessage = 'Invalid format. Use +60-123-4567-89';
      } else {
        vm.errorMessage = '';
      }
    };

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getforCustomer",
      data: { Supervisor: EmpID, Client_Id: $rootScope.Client_Id }
    }).then(function (List) {
      Emploee = List.data.data.map(function (o) {
        return o.UserID;
      });
      Emploee.push($rootScope.createdby);
      getAllCustomers();
    });

    $scope.Customerdatas = [];
    var dataGrid;

    vm.dataGridOptions = {
      onInitialized: function (e) {
        dataGrid = e.component;
        getAllCustomers();
      },

      dataSource: $scope.Customerdatas,
      keyExpr: "id",
      showColumnLines: true,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      headerFilter: {
        visible: true,
        allowSearch: true
      },
      hoverStateEnabled: true,
      columnMinWidth: 50,
      columnsAutoWidth: true,
      allowColumnResizing: true,
      columnResizingMode: "widget",
      filterRow: {
        visible: true
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Customer Details",
        allowExportSelectedData: false
      },
      paging: {
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 25, 50, 100],
        showInfo: true
      },
      remoteOperations: false,
      searchPanel: {
        visible: true,
        highlightCaseSensitive: true,
        width: 300
      },
      allowColumnReordering: true,
      columnChooser: {
        enabled: false
      },
      wordWrapEnabled: false,
      noDataText: "No Customer to display...",
      selection: {
        mode: $scope.Mode,
        showCheckBoxesMode: $scope.showCheckBoxesMode
        // showCheckBoxesMode: "none"
      },
      columns: [
        // {
        //   caption: "#",
        //   width: "50",
        //   cellTemplate: function (cellElement, cellInfo) {
        //     cellElement.text(
        //       cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
        //         cellInfo.row.rowIndex +
        //         1
        //     );
        //   }
        // },
        {
          caption: "Reference #",
          dataField: "CustomerReference",
          width: 110,
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.CustomerReference +
              "</p>"
            ).appendTo(container);
            // if (options.data.id == $scope.LastModified) {
            //   $(
            //     "<div style='display:-webkit-inline-box;padding:.2em.6em.3em;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color: #FF9800 !important;'>" +
            //       "Last Modified" +
            //       "</div><br/>"
            //   ).appendTo(container);
            // }
          }
        },
        // {caption:"Customer Type",dataField:"CustomerType",visible:false},
        { caption: "Company Name", dataField: "CompanyName", width: 170 },
        { caption: "SalesPerson", dataField: "SalesPersonName" },
        { caption: "Segment", dataField: "MarketSection" },
        {
          caption: "Contact Person",
          dataField: "ContactPerson",
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              return rowData.Salutation + " " + rowData.ContactPerson;
            } else {
              if (rowData.AssignedUser != null) {
                var eeitem = rowData.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  return rowData.Salutation + " " + rowData.ContactPerson;
                } else return "";
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                return "";
              }
            }
          }
        },
        { caption: "Postal", dataField: "Postal", visible: false },
        { caption: "Type", dataField: "additionalInformation", visible: true },
        {
          caption: "Contact Number",
          dataField: "Mobile",
          visible: true,
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              return rowData.Mobile;
            } else {
              if (rowData.AssignedUser != null) {
                return rowData.Mobile;
              } else return "";
            }
            // else if(rowData.AssignedUser === null){

            // }
            // else{
            //     return "";
            // }
            // }
          }
        },
        {
          caption: "Email",
          dataField: "Email",
          width: 170,
          cellTemplate: function (e, op) {
            if (IsAdmin == true) {
              if (
                op.data.Email != "" &&
                op.data.Email != null &&
                op.data.Email != undefined
              )
                $(
                  '<a href="mailto:' +
                  op.data.Email +
                  '">' +
                  op.data.Email.replace(",", " , ") +
                  "</a>"
                ).appendTo(e);
            } else {
              if (op.data.AssignedUser != null) {
                var eeitem = op.data.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  if (
                    op.data.Email != "" &&
                    op.data.Email != null &&
                    op.data.Email != undefined
                  )
                    $(
                      '<a href="mailto:' +
                      op.data.Email +
                      '">' +
                      op.data.Email.replace(",", " , ") +
                      "</a>"
                    ).appendTo(e);
                } else $('<a href="mailto:">' + +"</a>").appendTo(e);
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                $('<a href="mailto:">' + +"</a>").appendTo(e);
              }
            }
          }
        },
        { caption: "Country", dataField: "Country", visible: false },
        { caption: "Building Name", dataField: "BuildingName", visible: false },
        {
          caption: "Work Orders",
          dataField: "bEmail",
          alignment: "center",
          visible: false
        },
        { caption: "Address", dataField: "StreetName" },
        {
          dataField: "ConEndDate",
          caption: "Current Contract End Date",
          dataType: "date",
          format: "dd/MM/yyyy",
          // calculateCellValue: function (rowData) {
          //   if (IsAdmin == true) {
          //     if (
          //       rowData.ConEndDate != null &&
          //       rowData.ConEndDate != undefined &&
          //       rowData.ConEndDate != ""
          //     )
          //       return new Date(rowData.ConEndDate);
          //     // else return undefined;
          //   } else {
          //     if (rowData.AssignedUser != null) {
          //       var eeitem = rowData.AssignedUser.split(",");
          //       if (_.intersection(eeitem, Emploee).length > 0) {
          //         if (
          //           rowData.ConEndDate != null &&
          //           rowData.ConEndDate != undefined &&
          //           rowData.ConEndDate != ""
          //         )
          //           return new Date(rowData.ConEndDate);
          //         else return undefined;
          //       } else return undefined;
          //     }
          //     // else if(rowData.AssignedUser === null){

          //     // }
          //     else {
          //       return undefined;
          //     }
          //   }
          // }
        },
        {
          caption: "Status",
          alignment: "center",
          dataField: "Tag",
          cellTemplate: function (container, options) {
            var tagClassMap = {
              "Customer": "md-green-500-bg",
              "Follow Up - Quoted": "md-orange-500-bg",
              "Prospect": "md-blue-500-bg",
              "Leads": "md-cyan-500-bg",
              "Win": "md-light-green-500-bg",
              "Lost": "md-red-500-bg",
              "Cancel": "md-gray-500-bg",
              "Follow Up - Past Customer": "md-yellow-500-bg"
            };

            var tag = options.data.Tag;
            var labelClass = tagClassMap[tag];

            if (labelClass) {
              return $("<div>")
                .addClass('label ng-binding ng-scope ' + labelClass + ' status-label')
                .text(tag)
                .appendTo(container);
            }
          }

        },
        {
          caption: "Assigned Users",
          visible: true,
          dataField: "AssignedUser",
          alignment: "center",
          cellTemplate: function (container, options) {
            try {
              if (options.data.AssignedUser != null) {
                var Str = [];
                Str = options.data.AssignedUser.split(",");
                var Sdata = [];
                _.each(Str, function (item) {
                  item = item.charAt(0).toUpperCase() + item.slice(1);
                  Sdata.push(item);
                });
                Str = Sdata.map(function (obj) {
                  return obj;
                }).join(",");
                $("<p style='color:black;'>" + Str + "</p>").appendTo(
                  container
                );
              } else {
                $(
                  "<p style='color:blue;cursor: pointer;'>UnAssigned</p>"
                ).appendTo(container);
              }
            } catch (error) { }
          }
        },
        {
          caption: "Followup Date",
          dataField: "ProspectFollowupDate",
          dataType: "date",
          format: "dd/MM/yyyy",
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              if (rowData.ProspectFollowupDate != null)
                return new Date(rowData.ProspectFollowupDate);
              else return null;
            } else {
              if (rowData.AssignedUser != null) {
                var eeitem = rowData.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  if (rowData.ProspectFollowupDate != null)
                    return new Date(rowData.ProspectFollowupDate);
                  else return null;
                } else return null;
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                return null;
              }
            }
          }
        },

        {
          caption: "Delete",
          // fixed: true,
          // fixedPosition: 'right',
          width: 80,
          alignment: "center",
          allowSorting: false,
          visible: IsAdmin,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  $scope.delID = e.element.parent().parent().data().options.key;
                  var result = DevExpress.ui.dialog.confirm(
                    "<div><span><b>Are you sure you want to delete all data for this Customer?</b></span> </div><div> <span>1. Lead</span></div><div><span>2. Contracts</span></div><div><span>3. Work Orders</span></div><div><span>4. Scheduled Jobs</span></div>",
                    "Confirm changes"
                  );
                  result.done(function (dialogResult) {
                    if (dialogResult) {
                      var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/customer/delete",
                        data: {
                          _id: $scope.delID
                        }
                      });
                      response.then(function (List) {
                        $mdToast.show(
                          $mdToast
                            .simple()
                            .textContent("Customer deleted successfully !")
                            .position("top center")
                        );
                      });
                    }
                  });
                }
              })
              .appendTo(container);
          }
        }
      ],
      onSelectionChanged: function (selectedItems) {
        var data = selectedItems.selectedRowsData;

        if (data.length > 0) {
          $scope.v = $.map(data, function (value) {
            return value.CustomerReference;
          });
          $scope.CustomerSelectedIds = $.map(data, function (value) {
            return value.id;
          });
          $scope.Cdiv = true;
          selectedItems.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          selectedItems.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.v = [];
          $scope.Cdiv = false;
          selectedItems.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onCellClick: function (data) {
        try {
          var eeitem = data.data.AssignedUser.split(",");
          eeitem.push(data.data.SalesPersonName.toLowerCase());
        } catch (error) {
          var eeitem = null;
        }

        if (
          data.column.caption == "Reference #" &&
          (_.intersection(eeitem, Emploee).length > 0
            ? true
            : false || IsAdmin == true)
        ) {
          // if (data.column.caption == "Reference #" ) {
          var index = dataGrid.getRowIndexByKey(data.data.id);
          $scope.Customerinfo(data.data.id, index);
          $scope.AllIfo(data.data.id);
        }
        if (
          data.column.caption == "Assigned Users" &&
          data.data.AssignedUser == null
        ) {
          $scope.AcceptanceforUpdateAssignedUser(event, data.data.id);
        }
      },
      onToolbarPreparing: function (e) {
        e.toolbarOptions.items.unshift({
          location: "before",
          template: "totalGroupCount"
        });
      },
      bindingOptions: {
        dataSource: "Customerdatas",
        "selection.mode": "Mode",
        "selection.showCheckBoxesMode": "showCheckBoxesMode"
      }
    };

    $scope.Datefilter = function () {
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/customer/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      });
      response.then(function (GList) {
        $scope.Customerdatas = GList.data.data;
      });
    };

    $scope.cExport = function () {
      if (chkAllowCustomerExport == true || chkAllowCustomerExport == "true") {
        alasql(
          'SELECT * INTO XLSX("CustomerDetails.xlsx",{headers:true}) FROM ?',
          [$scope.Customerdatas]
        );
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Export Option Not Enabled!")
            .position("top center")
        );
      }
    };
    $scope.items = [
      { a: 1, b: 10 },
      { a: 2, b: 20 },
      { a: 3, b: 30 }
    ];

    $scope.Customerform = false;
    $scope.Customergrid = true;
    $scope.Export = true;
    $scope.Add = true;
    $scope.Search = true;

    $scope.placeChanged = function () {
      $scope.vm.uPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.uPostal = vm.place.address_components[i].long_name;
          }
        }
      }
    };

    $scope.placeChanged1 = function () {
      $scope.vm.usPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.usPostal =
              vm.place.address_components[i].long_name

          }
        }
      }
    };

    $scope.placeChanged2 = function () {
      $scope.vm.ubPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.ubPostal =
              vm.place.address_components[i].long_name

          }
        }
      }
    };

    $scope.sAdd = function () {
      ClearForm();
      $scope.Update = false;
      $scope.Customerform = true;
      $scope.Customergrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.Search = false;
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
      $scope.vm.uCustomerID = pass;
      $scope.CustomerServicedatas = [];
      $scope.CustomerBillingdatas = [];
      $scope.CustomerCommentdatas = [];
    };

    $scope.Showgrid = function () {
      $scope.Customergrid = true;
      $scope.Customerform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.Customerinfo = function (CustomerId, Index) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/newgetbyid",
        data: {
          _id: CustomerId
        }
      }).then(function (d) {
        try {
          $scope.vm.emailValidationError = false;
          $scope.vm.emailValidationError1 = false;
          $scope.vm.emailValidationError2 = false;
          $scope.vm.emailChipWarning = false;
          $scope.vm.contactChipWarning = false;
          $scope.vm.emailChipWarning1 = false;
          $scope.vm.emailccWarning = false;
          $scope.vm.contactChipWarning1 = false;
          var item = d.data.data[0];
          $scope.SID = CustomerId;
          $scope.CustomerIndex = Index;
          $scope.Update = true;
          $scope.vm.uInvoiceEmail = [];
          $scope.vm.uInvoiceCC = [];
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          $scope.All = false;
          $scope.Selec = { value: false };
          $scope.MSelec = { value: false };
          $scope.vm.CustomerSince = new Date();
          $scope.vm.ProspectFollowDate = new Date();
          $scope.vm.uFrom = new Date();
          $scope.vm.uTo = new Date(
            new Date().setMonth(new Date().getMonth() + 1)
          );
          $scope.vm.uIFrom = new Date();
          $scope.vm.uITo = new Date(
            new Date().setMonth(new Date().getMonth() + 1)
          );
          $scope.vm.uwoFrom = new Date(
            new Date().setMonth(new Date().getMonth() - 1)
          );
          $scope.vm.uwoTo = new Date();
          $scope.vm.ucFrom = new Date(
            new Date().setMonth(new Date().getMonth() - 1)
          );
          $scope.vm.ucTo = new Date();
          $scope.vm.pvFrom = new Date(
            new Date().setDate(new Date().getDate() - 7)
          );
          $scope.vm.pvTo = new Date(
            new Date().setDate(new Date().getDate() - 1)
          );
          $scope.vm.upFrom = new Date(
            new Date().setDate(new Date().getDate() + 1)
          );
          $scope.vm.upTo = new Date(
            new Date().setDate(new Date().getDate() + 7)
          );

          $scope.vm.PaymentTerm = item.Unit;
          $scope.vm.EnquiryMode = item.EnquiryMode;
          $scope.vm.additionalInformation = item.additionalInformation;
          $scope.vm.CreditTerm = item.CreditTerm;
          $scope.vm.uCustomerID = item.CustomerID;
          $scope.RequestID = item.CustomerID;
          $scope.vm.CustomerReference = item.CustomerReference;
          $scope.vm.uSalutation = item.Salutation;
          $scope.vm.uFirstName = item.FirstName;
          $scope.vm.uLastName = item.LastName;
          $scope.vm.uCompanyName = item.CompanyName;
          $scope.vm.uNote = item.Note;
          $scope.vm.uAddress = item.Address;
          $scope.vm.uAddress1 = item.Address1;
          $scope.vm.uPostal = item.Postal;
          $scope.vm.uCountry = item.Country;
          $scope.vm.uContactPerson = item.ContactPerson;
          $scope.vm.SalesPerson = item.SalesPerson_id;
          $scope.vm.uPhone = item.Phone;
          $scope.vm.uMobile = [];
          $scope.vm.uEmail = [];
          if (
            item.Mobile != null &&
            item.Mobile != "" &&
            item.Mobile != undefined
          )
            $scope.vm.uMobile = item.Mobile.split(",");
          if (item.Email != null && item.Email != "" && item.Email != undefined)
            $scope.vm.uEmail = item.Email.split(",");
          // if (item.CustomerSince != "" && item.CustomerSince != null && item.CustomerSince != undefined) {
          //     $scope.vm.CustomerSince = new Date(item.CustomerSince);
          // } else { }
          if (
            item.ConEndDate != "" &&
            item.ConEndDate != null &&
            item.ConEndDate != undefined
          ) {
            $scope.vm.ConEndDate = new Date(item.ConEndDate);
          } else {
            $scope.vm.ConEndDate = null;
          }
          if (
            item.ProspectFollowupDate != "" &&
            item.ProspectFollowupDate != null &&
            item.ProspectFollowupDate != undefined
          ) {
            $scope.vm.ProspectFollowDate = new Date(item.ProspectFollowupDate);
          } else {
            $scope.vm.ProspectFollowDate = null;
          }
          $scope.vm.StreetName = item.StreetName;
          $scope.vm.BuildingName = item.BuildingName;
          $scope.vm.CreditTerm = item.CreditTerm;
          if (item.State == "null" || item.State == undefined) {
            $scope.vm.State = "Active";
          } else {
            $scope.vm.State = item.State;
          }
          $scope.vm.Category = item.Category;
          $scope.vm.usInvoiceEmail = item.InvoiceEmail;
          if (
            $scope.vm.usInvoiceEmail != null &&
            $scope.vm.usInvoiceEmail != "" &&
            $scope.vm.usInvoiceEmail != undefined
          ) {
            $scope.vm.uInvoiceEmail = $scope.vm.usInvoiceEmail.split(",");
            $scope.vm.usInvoiceEmail = null;
          }

          $scope.vm.usInvoiceCC = item.InvoiceCC;
          if (
            $scope.vm.usInvoiceCC != null &&
            $scope.vm.usInvoiceCC != "" &&
            $scope.vm.usInvoiceCC != undefined
          ) {
            $scope.vm.uInvoiceCC = $scope.vm.usInvoiceCC.split(",");
            $scope.vm.usInvoiceCC = null;
          }
          if (
            item.MarketSection != null &&
            item.MarketSection != "" &&
            item.MarketSection != undefined
          ) {
            var a = item.MarketSection.split(",");
            var array = [];
            _.each(a, function (ite) {
              array.push({ SegmentName: ite });
            });
            $scope.vm.MarketSection = array;
          }
          Refreshcomment($scope.SID);
          $scope.Contractdetails = item.Contractdetails[0];
          $scope.DateC();
          $scope.Leaddetails = item.Leaddetails;
          $scope.Invoiceddetails = item.Invoicedetails[0];
          $scope.DateIF();
          $scope.SalessOrderdetails = item.SalesOrderdetails[0];
          $scope.DateWO();
          $scope.Schedulerdetails = item.Schedulerdetails[0];
        } catch (e) { }

        $scope.CustomerBillingdatas = [];
        $scope.CustomerServicedatas = [];
        getUploadedDocuments($scope.SID);
        CustomerBillingdatadetails();
        CustomerServicedatadetails();
        $scope.GetSchedulerDetails($scope.SID, $scope.uFrom);
        // RefreshCommentGrid();

        $scope.Update = true;
        $scope.Customerform = true;
        $scope.Customergrid = false;
        $scope.Servicegrid = true;
        $scope.Export = false;
        $scope.view = true;
        $scope.Add = false;
        $scope.Search = false;
      });
    };

    $scope.sSubmit = function () {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueInvoiceEmailValid = true;
      var falseInvoiceEmailValid = true;
      var trueInvoiceCCValid = true;
      var falseInvoiceCCValid = true;
      angular.forEach($scope.vm.uInvoiceEmail, function (ite) {
        if (reg.test(ite)) {
          trueInvoiceEmailValid = true;
        } else {
          falseInvoiceEmailValid = true;
        }
      });
      angular.forEach($scope.vm.uInvoiceCC, function (ite) {
        if (reg.test(ite)) {
          trueInvoiceCCValid = true;
        } else {
          falseInvoiceCCValid = true;
        }
      });
      if (trueInvoiceEmailValid != false && trueInvoiceCCValid != false) {
        var InvoiceEmail = $scope.vm.uInvoiceEmail;
        if (
          InvoiceEmail != null &&
          InvoiceEmail != "" &&
          InvoiceEmail != undefined
        ) {
          $scope.vm.usInvoiceEmail = InvoiceEmail.map(function (obj) {
            return obj;
          }).join(",");
        } else {
          $scope.vm.usInvoiceEmail = "";
        }
        var InvoiceCC = $scope.vm.uInvoiceCC;
        if (InvoiceCC != null && InvoiceCC != "" && InvoiceCC != undefined) {
          $scope.vm.usInvoiceCC = InvoiceCC.map(function (obj) {
            return obj;
          }).join(",");
        } else {
          $scope.vm.usInvoiceCC = "";
        }

        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.uContactPerson = $scope.vm.uFirstName;

        if (
          $scope.vm.BuildingName != null &&
          $scope.vm.BuildingName != "" &&
          $scope.vm.BuildingName != undefined
        ) {
          $scope.vm.uAddress =
            $scope.vm.BLK +
            "," +
            "," +
            $scope.vm.StreetName +
            "," +
            $scope.vm.BuildingName;
        } else {
          $scope.vm.uAddress = $scope.vm.BLK + "," + "," + $scope.vm.StreetName;
        }
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != "" &&
          $scope.vm.uMobile != undefined
        )
          $scope.vm.uMobile = $scope.vm.uMobile
            .map(function (obj) {
              return obj;
            })
            .join(",");
        if (
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.uEmail = $scope.vm.uEmail
            .map(function (obj) {
              return obj;
            })
            .join(",");
        if (
          $scope.vm.MarketSection != null &&
          $scope.vm.MarketSection != "" &&
          $scope.vm.MarketSection != undefined
        ) {
          $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) {
            return obj.SegmentName;
          }).join(",");
        }
        if ($scope.vm.PaymentTerm != "Credit") $scope.vm.CreditTerm = 0;

        if ($scope.Update == true) {
          $scope.CustomerIndex = $scope.CustomerIndex;
          var response = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/customer/update",
            data: {
              _id: $scope.SID,
              CustomerID: $scope.vm.uCustomerID,
              CustomerReference: $scope.vm.CustomerReference,
              SalesPerson_id: $scope.vm.SalesPerson,
              Salutation: $scope.vm.uSalutation,
              FirstName: $scope.vm.uFirstName,
              LastName: $scope.vm.uLastName,
              CompanyName: $scope.vm.uCompanyName,
              Note: $scope.vm.uNote,
              Address: $scope.vm.uAddress,
              Address1: $scope.vm.uAddress1,
              Postal: $scope.vm.uPostal,
              Country: $scope.vm.uCountry,
              ContactPerson: $scope.vm.uContactPerson,
              Phone: $scope.vm.uPhone,
              Mobile: $scope.vm.uMobile,
              Email: $scope.vm.uEmail,
              // CustomerSince: $scope.vm.CustomerSince,
              ProspectFollowupDate: $scope.vm.ProspectFollowDate,
              StreetName: $scope.vm.StreetName,
              BuildingName: $scope.vm.BuildingName,
              CreditTerm: $scope.vm.CreditTerm,
              MarketSection: $scope.vm.MarketSection,
              ConEndDate: $scope.vm.ConEndDate,
              State: $scope.vm.State,
              Unit: $scope.vm.PaymentTerm,
              EnquiryMode: $scope.vm.EnquiryMode,
              additionalInformation: $scope.vm.additionalInformation,
              Category: $scope.vm.Category,
              UpdatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              InvoiceEmail: $scope.vm.usInvoiceEmail,
              InvoiceCC: $scope.vm.usInvoiceCC
            }
          });
          response.then(
            function (GList) {
              if (GList.data.message == "Existing CustomerName") {
                $scope.error1 = true;
                $scope.Customergrid = false;
                $scope.Customerform = true;
                $scope.Export = false;
                $scope.Add = false;
                $scope.Search = false;
                $scope.view = true;
              } else {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Successfully Updated!")
                    .position("top center")
                );
                $scope.Customergrid = true;
                $scope.error1 = false;
                $scope.Customerform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.Search = true;
                $scope.view = false;
                // AllInfo();
                $scope.AllCustomersview($scope.ViewAllCustomer);
                $scope.ViewAllCustomer = false;
                // $scope.Datefilter();
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customer/add",
            data: {
              CustomerID: $scope.vm.uCustomerID,
              CustomerReference: $scope.vm.CustomerReference,
              SalesPerson_id: $scope.vm.SalesPerson,
              Salutation: $scope.vm.uSalutation,
              FirstName: $scope.vm.uFirstName,
              LastName: $scope.vm.uLastName,
              CompanyName: $scope.vm.uCompanyName,
              Note: $scope.vm.uNote,
              Address: $scope.vm.uAddress,
              Address1: $scope.vm.uAddress1,
              Postal: $scope.vm.uPostal,
              Country: $scope.vm.uCountry,
              ContactPerson: $scope.vm.uContactPerson,
              Phone: $scope.vm.uPhone,
              Mobile: $scope.vm.uMobile,
              Email: $scope.vm.uEmail,
              Unit: $scope.vm.PaymentTerm,
              EnquiryMode: $scope.vm.EnquiryMode,
              additionalInformation: $scope.vm.additionalInformation,
              Creditterm: $scope.vm.CreditTerm,
              // CustomerSince: $scope.vm.CustomerSince,
              ProspectFollowupDate: $scope.vm.ProspectFollowDate,
              StreetName: $scope.vm.StreetName,
              BuildingName: $scope.vm.BuildingName,
              CreditTerm: $scope.vm.CreditTerm,
              MarketSection: $scope.vm.MarketSection,
              ConEndDate: $scope.vm.ConEndDate,
              Category: $scope.vm.Category,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              InvoiceEmail: $scope.vm.usInvoiceEmail,
              InvoiceCC: $scope.vm.usInvoiceCC
            }
          });
          response.then(
            function (GList) {
              if (GList.data.message == "Existing CompanyName") {
                $scope.error1 = true;
                $scope.Customergrid = false;
                $scope.Customerform = true;
                $scope.Export = false;
                $scope.Add = false;
                $scope.Search = false;
                $scope.view = true;
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Company Name Already Exist!")
                    .position("top center")
                );
              } else {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Successfully Added!")
                    .position("top center")
                );
                // AllInfo();
                $scope.Customergrid = true;
                $scope.Customerform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
                $scope.error1 = false;

                var response1 = $http({
                  method: "PUT",
                  url:

                    $rootScope.WebURL +
                    "/customer/updateAssignedUser",
                  data: {
                    _id: GList.data.data.id,
                    AssignedUser: $rootScope.createdby,
                    UpdatedBy: $rootScope.createdby
                  }
                });
                response1.then(function (Lis) { });
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      } else if (
        trueInvoiceEmailValid == false &&
        trueInvoiceCCValid != false
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid Email !")
            .position("top center")
        );
      } else if (
        trueInvoiceEmailValid != false &&
        trueInvoiceCCValid == false
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid CC !")
            .position("top center")
        );
      } else if (
        trueInvoiceEmailValid == false &&
        trueInvoiceCCValid == false
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid Email and CC !")
            .position("top center")
        );
      }
    };

    $scope.AddSegment = function (e) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/segment.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.errorms = false;
    };

    $scope.DeleteComment = function (data) {
      if (data.CreatedBy === $rootScope.createdby) {
        $scope.delComId = data._id;
        var result = DevExpress.ui.dialog.confirm(
          "Are you sure, you want to delete the comment?",
          "Confirm!"
        );
        result.done(function (dialogResult) {
          if (dialogResult === true) {
            $http({
              url: $rootScope.WebURL + "/schedulercomment/delete",
              method: "POST",
              data: { _id: $scope.delComId }
            }).then(function (attachmentdata) {
              var response = $http({
                url:

                  $rootScope.WebURL +
                  "/schedulercomment/getByCustomer",
                method: "POST",
                data: { RequestID: $scope.SID }
              });
              response.then(function (Commentdata) {
                $scope.CustomerCommentdatas = Commentdata.data.data;
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Comment deleted Successfully!")
                    .position("top center")
                );
              });
            });
          }
        });
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("You dont have permission to delete")
            .position("top center")
        );
      }
    };

    $scope.SegmentSubmit = function () {
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      var CustomerID = pass;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment/add",
        data: {
          SegmentName: $scope.vm.SegmentName,
          Description: $scope.vm.Description,
          Client_Id: $rootScope.Client_Id,
          CreatedBy: $rootScope.createdby,
          IsActive: true
        }
      });
      response.then(
        function (GList) {
          if (GList.data.message == "Existing SegmentName") {
            $scope.errorms = true;
          } else {
            $scope.vm.SegmentName = null;
            $scope.vm.Description = null;
            $scope.errorms = false;
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("top center")
            );
            RefreshMsgrid();
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Segmentdelete = function (deleteID) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment/delete",
        data: {
          _id: deleteID
        }
      });
      response.then(
        function (GList) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Deleted!")
              .position("top center")
          );
          RefreshMsgrid();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Servicepopup = function (e, uCustomerID, PopupType) {
      $scope.vm.uCustomerID = uCustomerID;
      if (PopupType == "Billing") {
        $scope.vm.sty = 45;
        $scope.Billing = true;
        $scope.Service = false;
        $scope.PopupType = "Billing";
        $scope.vm.ubBLK = null;
        $scope.vm.ubUnit = null;
        $scope.vm.ubPostal = null;
        $scope.vm.ubCountry = null;
        $scope.vm.ubContactPerson = null;
        $scope.vm.ubBuildingName = null;
        $scope.vm.ubStreetName = null;
        $scope.vm.ubMobile = null;
        $scope.vm.ubEmail = null;
      }
      if (PopupType == "Service") {
        $scope.vm.sty = 65;
        $scope.Service = true;
        $scope.Billing = false;
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
        $scope.PopupType = "Service";
      }
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = [];
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        },
        onComplete: function (scope, element) {
          update_contact_email_field(scope);
        }
      });



    };

    $scope.copymain = function ($scope) {
      if ($scope.Servicecopy.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.usBLK = "";
        $scope.vm.usName = $scope.vm.uCompanyName;
        $scope.vm.usContactPerson = $scope.vm.uFirstName;
        $scope.vm.usUnit = $scope.vm.StreetName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.usPostal = $scope.vm.uPostal;
        }
        $scope.vm.usCountry = $scope.vm.uCountry;
        $scope.vm.usBuildingName = $scope.vm.BuildingName;
        $scope.vm.usStreetName = $scope.vm.StreetName;
        $scope.vm.usMobile = [];
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != undefined &&
          $scope.vm.uMobile != ""
        )
          if (!Array.isArray($scope.vm.uMobile))
            $scope.vm.usMobile = $scope.vm.uMobile
              .split(",")
              .slice(2)
              .join(",");
          else $scope.vm.usMobile = $scope.vm.uMobile;
        if (
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.ZoneCC = $scope.vm.uEmail;

        $scope.vm.ZoneEmail = [];

        if (
          $scope.vm.usContactPerson == "" ||
          $scope.vm.usContactPerson == null ||
          $scope.vm.usContactPerson == undefined
        ) {
          try {
            var item = $scope.CustomerServicedatas.filter(function (item) {
              return item.CustomerID === $scope.RequestID;
            })[0];
            $scope.vm.usName = item.sName;
            $scope.vm.usContactPerson = item.sContactPerson;
            $scope.vm.usBLK = item.sBLK;
            $scope.vm.usUnit = item.sUnit;
            $scope.vm.usPostal = item.sPostal;
            $scope.vm.usCountry = item.sCountry;
            $scope.vm.usBuildingName = item.sBuildingName;
            $scope.vm.usStreetName = item.sStreetName;
            $scope.vm.usMobile = [];
            if (
              item.sMobile != null &&
              item.sMobile != undefined &&
              item.sMobile != ""
            )
              $scope.vm.usMobile = item.sMobile.split(",");
            if (
              item.sEmail != null &&
              item.sEmail != "" &&
              item.sEmail != undefined
            ) {
              $scope.vm.ZoneCC = item.sEmail.split(",");
            }
            if (item.sCC != null && item.sCC != "" && item.sCC != undefined) {
              $scope.vm.ZoneEmail = item.sCC.split(",");
            }
          } catch (e) { }
        }
      }
      if ($scope.Servicecopy.value == false) {
        $scope.vm.usName = "";
        $scope.vm.usContactPerson = "";
        $scope.vm.usBLK = "";
        $scope.vm.usUnit = "";
        $scope.vm.usPostal = "";
        $scope.vm.usCountry = "";
        $scope.vm.usBuildingName = "";
        $scope.vm.usStreetName = "";
        $scope.vm.usMobile = [];
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
      }
    };

    $scope.copybilling = function ($scope) {
      if ($scope.checkboxModel.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.ubContactPerson = $scope.vm.uFirstName;
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = $scope.vm.StreetName;
        $scope.vm.ubBuildingName = $scope.vm.BuildingName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.ubPostal = $scope.vm.uPostal;
        }
        $scope.vm.ubCountry = $scope.vm.uCountry;
        $scope.vm.ubMobile = $scope.vm.uMobile.join(", ");
        $scope.vm.ubEmail = $scope.vm.uEmail;
        $scope.vm.ubStreetName = $scope.vm.StreetName;
        $scope.vm.ubWebsite = "";
      }
      if ($scope.checkboxModel.value == false) {
        $scope.vm.ubContactPerson = "";
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = "";
        $scope.vm.ubBuildingName = "";
        $scope.vm.ubPostal = "";
        $scope.vm.ubCountry = "";
        $scope.vm.ubMobile = "";
        $scope.vm.ubEmail = "";
        $scope.vm.ubStreetName = "";
        $scope.vm.ubWebsite = "";
      }
    };

    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9A-Z]+(\.[_a-z0-9A-Z]+)*@[a-z0-9-A-Z]+(\.[a-z0-9-A-Z]+)*(\.[a-zA-Z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = true;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = true;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Enter valid CC !")
              .position("top center")
          );
          return;
        }
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid email !")
            .position("top center")
        );
        return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail.toLowerCase(),
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 65;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        } else $scope.vm.ZoneCC = [];
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        } else $scope.vm.ZoneEmail = [];
      } catch (e) { }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        },
        onComplete: function (scope, element) {
          update_contact_email_field(scope);
        }
      });
    };

    $scope.cspopup = function (e, deleteID, Index, Type) {
      $scope.vm.deleteID = deleteID;
      $scope.vm.Index = Index;
      $scope.vm.DeleteType = Type;
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/cspopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.Servicedelete = function (deleteID, Index) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customerService/delete",
        data: {
          _id: deleteID
        }
      });
      response.then(
        function (GList) {
          if ($scope.vm.DeleteType == "Service") {
            $scope.CustomerServicedatas.splice(Index, 1);
          } else {
            $scope.CustomerBillingdatas.splice(Index, 1);
          }
          //CustomerServicedatadetails();
          $scope.Servicegrid = true;
          $scope.Add = false;
          $scope.Search = false;
          $mdDialog.cancel();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Billingadd = function (Index) {
      if ($scope.BAUpdate == true) {
        $scope.BillingIndex = $scope.BillingIndex;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            bBLK: $scope.vm.ubBLK,
            bUnit: $scope.vm.ubUnit,
            bPostal: $scope.vm.ubPostal,
            bCountry: $scope.vm.ubCountry,
            bContactPerson: $scope.vm.ubContactPerson,
            bBuildingName: $scope.vm.ubBuildingName,
            bStreetName: $scope.vm.ubStreetName,
            bMobile: $scope.vm.ubMobile,
            bEmail: $scope.vm.ubEmail,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
            $scope.Add = false;
            $scope.Search = false;
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var item = [];
        try {
          item = $scope.CustomerBillingdatas.filter(function (item) {
            return (
              item.bBLK == $scope.vm.ubBLK &&
              item.bUnit == $scope.vm.ubUnit &&
              item.bStreetName == $scope.vm.ubStreetName &&
              item.bCountry == $scope.vm.ubCountry &&
              item.bMobile == $scope.vm.ubMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          if ($scope.BAUpdate == true) {
            $scope.BillingIndex = $scope.BillingIndex;
            var response = $http({
              method: "PUT",
              url: $rootScope.WebURL + "/customerService/update",
              data: {
                _id: $scope.QID,
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                UpdatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.CustomerBillingdatas[$scope.BillingIndex] =
                  GList.data.data;
                CustomerServicedatadetails();
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          } else {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/customerService/add",
              data: {
                Type: "Billing",
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                CreatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.RequestID = $scope.vm.uCustomerID;
                CustomerBillingdatadetails();
                $scope.Servicegrid = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Billingupdate = function (e, QId, Index) {
      $scope.BAUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.BillingIndex = Index;
      $scope.Billing = true;
      $scope.Service = false;
      $scope.vm.sty = 45;
      try {
        var item = $scope.CustomerBillingdatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.ubBLK = item.bBLK;
        $scope.vm.ubUnit = item.bUnit;
        $scope.vm.ubPostal = item.bPostal;
        $scope.vm.ubCountry = item.bCountry;
        $scope.vm.ubContactPerson = item.bContactPerson;
        $scope.vm.ubBuildingName = item.bBuildingName;
        $scope.vm.ubStreetName = item.bStreetName;
        $scope.vm.ubMobile = item.bMobile;
        $scope.vm.ubEmail = item.bEmail;
      } catch (e) { }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        },

      });
    };

    $scope.AD = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "A", End: "E", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.EH = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "E", End: "I", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.IL = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "I", End: "M", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.MP = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "M", End: "Q", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.QT = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "Q", End: "U", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.UX = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "U", End: "Y", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.YZ = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "Y", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }

          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    function getAllCustomers() {
      $scope.vm.PreviewSpinner = true;
      $scope.Customerdatas = [];
      $scope.getCustomerdatas = [];
      if (dataGrid != undefined)
        angular
          .element("#gridContainer")
          .dxDataGrid("instance")
          .beginCustomLoading();
      DataSyncService.getAllCustomers().then(function (data) {
        $scope.getCustomerdatas = data;
        $scope.Customerdatas = angular.copy($scope.getCustomerdatas);
        $scope.Alllcustomer = $scope.Customerdatas;
        updateCustomerLists();

        angular
          .element("#gridContainer")
          .dxDataGrid("instance")
          .endCustomLoading();
      });
    }

    $scope.AllInfo = getAllCustomers;
    $scope.ClearGrid = function () {
      $("#gridContainer").dxDataGrid("instance").clearSelection();
    };
    $scope.AcceptanceforUpdateEmail = function (e) {
      $scope.vm.UpdateEmail = [];
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/BeforeUpdateEmail.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.GetDetailsforUpdateEmail = function () {
      if (
        $scope.vm.UpdateEmail == "" ||
        $scope.vm.UpdateEmail == null ||
        $scope.vm.UpdateEmail == undefined ||
        $scope.vm.UpdateEmail == [] ||
        $scope.vm.UpdateEmail.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Email Required!!")
            .position("top center")
        );
        return;
      }
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueUpdateEmailValid = true;
      var falseUpdateEmailValid = true;
      if (
        $scope.vm.UpdateEmail != "" &&
        $scope.vm.UpdateEmail != null &&
        $scope.vm.UpdateEmail != undefined
      ) {
        angular.forEach($scope.vm.UpdateEmail, function (ite) {
          if (reg.test(ite)) {
            trueUpdateEmailValid = true;
          } else {
            falseUpdateEmailValid = true;
          }
        });
      }
      if (falseUpdateEmailValid == false) {
        // $mdToast.show(
        //   $mdToast
        //     .simple()
        //     .textContent("Valid Email Required!!")
        //     .position("top center")
        // );
        // return;
      } else {
        $scope.vm.usUpdateEmail = $scope.vm.UpdateEmail.map(function (obj) {
          return obj;
        }).join(",");
        try {
          angular.forEach($scope.SelectedIds, function (value) {
            if (value != "") {
              var response = $http({
                method: "PUT",
                url:

                  $rootScope.WebURL +
                  "/customerService/UpdateServiceAddressEmail",
                data: {
                  _id: value,
                  sEmail: $scope.vm.usUpdateEmail,
                  IsActive: "true",
                  UpdatedBy: $rootScope.createdby
                }
              });
            }
          });
        } catch (e) { }

        CustomerServicedatadetails();
        $scope.SelectedIds = [];
        $scope.Selec = { value: false };
        $scope.MSelec = { value: false };
        $scope.All = false;
        $scope.vm.All = false;
        $scope.SAdiv = false;
        $scope.vm.UpdateEmail = [];
        $scope.vm.usUpdateEmail = "";
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Email Updated!")
            .position("top center")
        );
      }
    };
    $scope.commentSubmit = function () {
      if ($scope.Update == true) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulercomment/add",
          data: {
            CustomerID: $scope.SID,
            TableName: "Customer",
            CommentedBy: $rootScope.createdby,
            cmt: $scope.vm.Comments,
            ModuleID: "",
            CreatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            var response1 = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: $scope.SID,
                AssignedUser: $rootScope.createdby,
                UpdatedBy: $rootScope.createdby
              }
            });
            response1.then(function (Lis) {
              Refreshcomment($scope.SID);
              $scope.vm.Comments = "";
            });
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulercomment/add",
          data: {
            CustomerID: null,
            TableName: "Customer",
            CommentedBy: $rootScope.createdby,
            cmt: $scope.vm.Comments,
            ModuleID: $scope.vm.uCustomerID,
            CreatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        }).then(function (List) {
          Refreshcomment($scope.vm.uCustomerID);
          $scope.vm.Comments = "";
        });
      }
    };

    $scope.AssignbyComment = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          CustomerID: $scope.CID,
          TableName: "Customer",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Comments,
          ModuleID: "",
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(
        function (GList) {
          var response1 = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/customer/updateAssignedUser",
            data: {
              _id: $scope.CID,
              AssignedUser: $rootScope.createdby,
              UpdatedBy: $rootScope.createdby
            }
          });
          response1.then(function (Lis) {
            $scope.vm.Comments = "";
            $mdDialog.cancel();
          });
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.CheckAll = function (IsTicked) {
      if (IsTicked == true) {
        angular.forEach($scope.Customerdatas, function (value) {
          if (value.id != "" && value.id != null && value.id != undefined) {
            if ($scope.CustomerSelectedIds.indexOf(value.id) == -1) {
              $scope.CustomerSelectedIds.push(value.id);
            }
          }
        });
        $scope.Cdiv = true;
        $scope.CSelec = { value: true };
        //$scope.CMSelec = { value: true };
      } else if (IsTicked == false) {
        $scope.CustomerSelectedIds = [];
        $scope.Cdiv = false;
        $scope.CSelec = { value: false };
        //$scope.CMSelec = { value: false };
      }
    };
    $scope.Check = function (SI, Ids) {
      if (SI == true) {
        if ($scope.CustomerSelectedIds.indexOf(Ids) == -1) {
          $scope.CustomerSelectedIds.push(Ids);
        }
      } else if (SI == false) {
        var index = $scope.CustomerSelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.CustomerSelectedIds.splice(index, 1);
        }
      }
      if ($scope.CustomerSelectedIds.length > 0) {
        $scope.Cdiv = true;
      } else if ($scope.CustomerSelectedIds.length == 0) {
        $scope.Cdiv = false;
        $scope.CSelec = { value: false };
        $scope.CMSelec = { value: false };
      }
    };

    $scope.AcceptanceforAssignedUser = function (e) {
      $scope.vm.UpdateAssignedUser = "";
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/BeforeAssignedUser.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.UpdateAssignedUser = function () {
      if (
        $scope.vm.UpdateAssignedUser == "" ||
        $scope.vm.UpdateAssignedUser == null ||
        $scope.vm.UpdateAssignedUser == undefined ||
        $scope.vm.UpdateAssignedUser.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Required!!")
            .position("top center")
        );
        return;
      }
      $scope.AssignedUser = $scope.vm.UpdateAssignedUser.map(function (obj) {
        return obj.UserID;
      }).join(",");
      try {
        angular.forEach($scope.CustomerSelectedIds, function (value) {
          if (value != "") {
            var response = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: value,
                AssignedUser: $scope.AssignedUser,
                UpdatedBy: $rootScope.createdby
              }
            });
          }
        });
      } catch (e) { }

      $scope.CustomerSelectedIds = [];
      $scope.Cdiv = false;
      $scope.CAll = false;
      $scope.CSelec = { value: false };
      $scope.CMSelec = { value: false };
      $scope.vm.All = false;
      $scope.vm.UpdateAssignedUser = "";
      $scope.AssignedUser = "";
      $mdDialog.cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("User Assigned Successfully!")
          .position("top center")
      );
    };

    $scope.UnAssignedUser = function () {
      try {
        angular.forEach($scope.CustomerSelectedIds, function (value) {
          if (value != "") {
            var response = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: value,
                AssignedUser: null,
                UpdatedBy: $rootScope.createdby
              }
            });
          }
          $scope.vm.PreviewSpinner = true;
        });
      } catch (e) { }
      setTimeout(function () {
        $scope.vm.PreviewSpinner = false;
        $scope.CustomerSelectedIds = [];
        $scope.Cdiv = false;
        $scope.CAll = false;
        $scope.CSelec = { value: false };
        $scope.CMSelec = { value: false };
        $scope.vm.All = false;
        $scope.vm.UpdateAssignedUser = "";
        $scope.AssignedUser = "";
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Assigned Successfully!")
            .position("top center")
        );
      }, 3000);
    };

    $scope.AcceptanceforUpdateAssignedUser = function (e, CId) {
      $scope.CID = CId;
      $scope.vm.UpdateAssignedUserforCustomer = "";
      $mdDialog.show({
        multiple: true,
        templateUrl:
          "app/main/apps/crm/customer/BeforeAssignedUserforCustomer.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.UpdateAssignedUserforCustomer = function () {
      if (
        $scope.vm.UpdateAssignedUserforCustomer == "" ||
        $scope.vm.UpdateAssignedUserforCustomer == null ||
        $scope.vm.UpdateAssignedUserforCustomer == undefined ||
        $scope.vm.UpdateAssignedUserforCustomer.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Required!!")
            .position("top center")
        );
        return;
      }
      $scope.AssignedUserforCustomer = $scope.vm.UpdateAssignedUserforCustomer.map(
        function (obj) {
          return obj.UserID;
        }
      ).join(",");
      if ($scope.AssignedUserforCustomer === "UnAssigned")
        $scope.AssignedUserforCustomer = null;
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/customer/updateAssignedUser",
        data: {
          _id: $scope.CID,
          AssignedUser: $scope.AssignedUserforCustomer,
          UpdatedBy: $rootScope.createdby
        }
      });
      response.then(
        function (GList) {
          $scope.vm.UpdateAssignedUserforCustomer = "";
          $scope.AssignedUserforCustomer = "";
          $scope.CID = "";
          $mdDialog.cancel();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("User Assigned Successfully!")
              .position("top center")
          );
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.AllIfo = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: { _id: CId }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });
          angular.forEach($scope.SalesOrderdetails, function (svalue) {
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (svalue._id == cvalue.SalesOrderID) {
                cvalue.SalesOrderID = svalue.SalesOrderNo;
              }
            });
          });
          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;
          var item1 = $scope.Invoicedetails.filter(function (item1) {
            return (
              new Date(item1.Date) >= $scope.vm.uIFrom &&
              new Date(item1.Date) <= $scope.vm.uITo
            );
          });
          $scope.Invoicedetails = item1;

          var item3 = $scope.Contracterdetails.filter(function (item3) {
            return (
              new Date(item3.ContractEndDate) >= $scope.vm.ucFrom &&
              new Date(item3.ContractEndDate) <= $scope.vm.ucTo
            );
          });
          $scope.Contracterdetails = item3;
          var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
            return (
              new Date(item4.Startsat) >= $scope.vm.pvFrom &&
              new Date(item4.Startsat) <= $scope.vm.pvTo &&
              item4.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item4;
        } catch (e) { }
      });
    };
    $scope.DateSF = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: {
          _id: CId
        }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });

          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;

          var item1 = $scope.PVSchedulerdetails.filter(function (item1) {
            return (
              new Date(item1.Startsat) >= $scope.vm.pvFrom &&
              new Date(item1.Startsat) <= $scope.vm.pvTo &&
              item1.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item1;
        } catch (e) { }
      });
    };
    $scope.DateIF = function () {
      try {
        var item = $scope.Invoiceddetails.filter(function (item) {
          return (
            new Date(item.Date) >= $scope.vm.uIFrom &&
            new Date(item.Date) <= $scope.vm.uITo
          );
        });
        $scope.Invoicedetails = item;
      } catch (e) { }
    };
    $scope.DateWO = function () {
      try {
        $scope.SalesOrderdetails;
      } catch (e) { }
    };
    $scope.DateC = function () {
      try {
        var item = $scope.Contractdetails.filter(function (item) {
          return (
            new Date(item.ServiceEndDate) >= $scope.vm.ucFrom &&
            new Date(item.ServiceStartDate) <= $scope.vm.ucTo
          );
        });
        $scope.Contracterdetails = item;
      } catch (e) { }
    };
    $scope.DatePV = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: { _id: CId }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });

          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;

          var item1 = $scope.PVSchedulerdetails.filter(function (item1) {
            return (
              new Date(item1.Startsat) >= $scope.vm.pvFrom &&
              new Date(item1.Startsat) <= $scope.vm.pvTo &&
              item1.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item1;
        } catch (e) { }
      });
    };
    $scope.Totla = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        var secondDate = new Date(uTimeOut);
        if (
          firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)
        ) {
          return "Expiried";
        } else {
          var res = Math.round(
            Math.abs((secondDate.getTime() - firstDate.getTime()) / oneDay)
          );
          if (res == 0) {
            return "Expiried";
          } else {
            return res;
          }
        }
      } else {
        return null;
      }
    };
    $scope.uShowUnpaid = false;
    $scope.ShowUnpaid = function (uShowUnpaid, CId) {
      if (uShowUnpaid == true) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/customer/getById",
          data: {
            _id: CId
          }
        });
        response.then(function (GList) {
          try {
            $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
            var item = $scope.Invoicedetails.filter(function (item) {
              return item.Status === "Unpaid";
            });
            $scope.Invoicedetails = item;
          } catch (e) { }
        });
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/customer/getById",
          data: {
            _id: CId
          }
        });
        response.then(function (GList) {
          try {
            $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
            var item = $scope.Invoicedetails.filter(function (item) {
              return (
                new Date(item.Date) >= $scope.vm.uFrom &&
                new Date(item.Date) <= $scope.vm.uTo
              );
            });
            $scope.Invoicedetails = item;
          } catch (e) { }
        });
      }
    };

    $scope.Detailsinfo = function (e, id, t) {
      if (t == "WorkOrder") {
        $scope.vm.Title = "WorkOrder";
        var info = $scope.salesOrderdatas;
        try {
          var item = info.filter(function (item) {
            return item._id === id;
          })[0];
          $scope.vm.SalesOrderNo = item.SalesOrderNo;
          $scope.vm.OrderConfirmationDate = item.OrderConfirmationDate;
          if (
            $scope.vm.OrderConfirmationDate != null &&
            $scope.vm.OrderConfirmationDate != ""
          ) {
            $scope.vm.OrderConfirmationDate = new Date(
              item.OrderConfirmationDate
            );
          }
          $scope.vm.PestType = item.PestType;
          $scope.vm.CreatedBy = item.CreatedBy;
          $scope.vm.PONumber = item.PONumber;
          $scope.vm.EnquiryID = item.EnquiryID;
          $scope.vm.SalesPerson =
            item.employeedetails[0].EmployeeID +
            "-" +
            item.employeedetails[0].EmployeeName;
          $scope.vm.EnquiryReferenceNo = item.EnquiryReferenceNo;
          $scope.vm.ContactPerson = item.ContactPerson;
          $scope.vm.CustomerName = item.Customer_id;
          $scope.vm.ServiceStartDate = item.ServiceStartDate;
          if (
            $scope.vm.ServiceStartDate != null &&
            $scope.vm.ServiceStartDate != ""
          ) {
            $scope.vm.ServiceStartDate = new Date(item.ServiceStartDate);
          }
          $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
          $scope.vm.ServiceEndDate = item.ServiceEndDate;
          if (
            $scope.vm.ServiceEndDate != null &&
            $scope.vm.ServiceEndDate != ""
          ) {
            $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
          }
          $scope.vm.EnquiryRefNo = item.EnquiryReferenceNo;
          $scope.vm.Frequency = item.Frequency;
          $scope.vm.OrderType = item.OrderType;
          $scope.vm.TotalOrderitem = item.TotalOrderitem;
          $scope.vm.PaymentTerms = item.PaymentTerms;
          $scope.vm.BillingFrequency = item.BillingFrequency;
          $scope.vm.PaymentMode = item.PaymentMode;
          $scope.vm.Types = item.Types;
          $scope.vm.JobsPerFrequency = item.JobsPerFrequency;
          $scope.vm.ServicesRequired = item.ServicesRequired;
          $scope.vm.SName = item.SiteName;
          $scope.vm.CreatedDate = item.CreatedDate;
          $scope.vm.SContactNo = item.SiteContactNo;
          $scope.vm.BContactNo = item.Mobile;
          $scope.vm.BEmail = null;
          if (item.Email != "" && item.Email != undefined && item.Email != null)
            $scope.vm.BEmail = item.Email;
          $scope.vm.TotalSum = item.TotalSum;
          $scope.vm.CoverageArea = item.CoverageArea;
          $scope.vm.IsUrgent = item.IsUrgent;
          if ($scope.vm.IsUrgent == true) $scope.vm.IsUrgent = "true";
          else $scope.vm.IsUrgent = "false";
          $scope.vm.TrendingReport = item.TrendingReport;
          if ($scope.vm.TrendingReport == true)
            $scope.vm.TrendingReport = "true";
          else $scope.vm.TrendingReport = "false";
          $scope.vm.DateTimeofTreatment = item.DateTimeofTreatment;
          $scope.vm.SpecialRemarks = item.SpecialRemarks;
          $scope.vm.SiteContactPerson = item.SiteContactPerson;
          $scope.vm.Treatment = item.Treatment;
          $scope.Frequencydatas = item.MultiFrequency;
          $scope.vm.EstimatedHoursRequired = item.EstimatedHoursRequired;
          $scope.vm.TotalPrice = item.TotalPrice;
          $scope.vm.ServiceLocation =
            item.customerServicedetails[0].sStreetName;
          $scope.vm.BillingAddress =
            item.customerdetails[0].StreetName +
            "," +
            item.customerdetails[0].Country +
            "," +
            item.customerdetails[0].Postal;
          $scope.vm.SContactPerson = item.customerdetails[0].ContactPerson;
          $scope.vm.SMobile = item.customerdetails[0].Mobile;
          $scope.vm.SEmail = item.customerdetails[0].Email;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/contract/getById",
            data: {
              _id: item.ContractNo
            }
          });
          response.then(function (GList) {
            try {
              var value = GList.data.data[0];
              $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            } catch (e) { }
          });
        } catch (e) { }
      }
      if (t == "Contract") {
        $scope.vm.Title = "Contract";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          try {
            var value = GList.data.data[0];
            $scope.vm.ContractId = value._id;
            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContractStartDate = value.ContractStartDate;
            if (
              $scope.vm.ContractStartDate != null &&
              $scope.vm.ContractStartDate != ""
            ) {
              $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
            }
            $scope.vm.ContractDuration = value.ContractDuration;
            $scope.vm.ContractEndDate = value.ContractEndDate;
            if (
              $scope.vm.ContractEndDate != null &&
              $scope.vm.ContractEndDate != ""
            ) {
              $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
            }
            $scope.vm.ContractNotes = value.ContractNotes;
            $scope.vm.CreatedBy = value.CreatedBy;
            $scope.vm.SalesPerson = value.SalesPerson_id;

            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContactPerson = value.ContactPerson;
            $scope.vm.ServiceStartDate = value.ServiceStartDate;
            if (
              $scope.vm.ServiceStartDate != null &&
              $scope.vm.ServiceStartDate != ""
            ) {
              $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
            }
            $scope.vm.ServiceEndDate = value.ServiceEndDate;
            if (
              $scope.vm.ServiceEndDate != null &&
              $scope.vm.ServiceEndDate != ""
            ) {
              $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
            }
            $scope.vm.Frequency = value.Frequency;
            $scope.vm.SalesOrderID = value.SalesOrderID;
            $scope.vm.PestType = value.PestType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.Customer = value.Customer;
            $scope.vm.ContractStatus = value.ContractStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
            $scope.RenewalN = value.Renewal;
            $scope.OldContract_Id = value.OldContract_Id;
          } catch (e) { }
          if ($scope.RenewalN == "Renewaled") {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/contract/getOld",
              data: { OldContract_Id: $scope.OldContract_Id }
            }).then(function (datas) {
              try {
                $scope.OldContractReferenceNo =
                  datas.data.data.ContractReferenceNo;
                $scope.OldContractStartDate = datas.data.data.ContractStartDate;
                $scope.OldContractEndDate = datas.data.data.ContractEndDate;
                $scope.OldUpdatedDate = datas.data.data.UpdatedDate;
                $scope.OldFrequency = datas.data.data.Frequency;
                $scope.OldContractDuration = datas.data.data.ContractDuration;
              } catch (e) { }
            });
          }
        });
      }
      if (t == "Schedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getByFileID",
          data: {
            FileID: $scope.SID,
            Start_Date: $scope.vm.uFrom,
            End_Date: $scope.vm.uTo
          }
        });
        response.then(function (GList) {
          var info = GList.data.data;
          try {
            var item = info.filter(function (item) {
              return item._id === id;
            })[0];
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ContractOrder = item.ContractOrder;
            $scope.vm.PestType = item.PestType;
            $scope.vm.Types = item.Types;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.Billable = item.Billable;
            $scope.CollectPayment = item.CollectPayment;
          } catch (e) { }
        });
      }
      if (t == "PVSchedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getByFileID",
          data: {
            FileID: $scope.SID,
            Start_Date: $scope.vm.upFrom,
            End_Date: $scope.vm.upTo
          }
        });
        response.then(function (GList) {
          var info = GList.data.data;
          try {
            var item = info.filter(function (item) {
              return item._id === id;
            })[0];
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ContractOrder = item.ContractOrder;
            $scope.vm.PestType = item.PestType;
            $scope.vm.Types = item.Types;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.Billable = item.Billable;
            $scope.vm.Vehicle = item.Vehicle;
          } catch (e) { }
        });
      }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Details.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.SchedulerDetailsinfo = function (e, id, t) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/addcoments.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      if (t == "Schedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          var item = GList.data.data[0];
          try {
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            if (
              item.Tabletschedulerdetails[0] != null &&
              item.Tabletschedulerdetails[0] != "" &&
              item.Tabletschedulerdetails[0] != undefined
            ) {
              $scope.Tabletschedulerrecord = item.Tabletschedulerdetails[0];
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ScedulId = item._id;
            $scope.vm.Types = item.Types;
            $scope.vm.PestType1 = item.PestType;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.JobContinues = item.JobContinues;
            $scope.CreatedBy = item.CreatedBy;
            $scope.CreatedDate = new Date(item.CreateDate);
            $scope.InProgressedBy = "";
            $scope.InProgresseAt = null;
            if (
              $scope.vm.Status != "Yet to Start" &&
              $scope.vm.Status != "Outstanding"
            ) {
              $scope.InProgressedBy = item.InProgressedBy;
            }
            if (
              item.EmailSentDate == null ||
              item.EmailSentDate == undefined ||
              item.EmailSentDate == "null"
            ) {
              $scope.vm.EmailSentDate = "";
            } else {
              $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
            }
            $scope.vm.EmailSentTo = item.EmailSentTo;
            var address = item.Location || "Singapore";
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
              geocoder.geocode(
                {
                  address: address
                },
                function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    $scope.latlng = [];
                    $scope.latlng.push(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng()
                    );
                  }
                }
              );
            }
          } catch (e) { }
        });
      }
      if (t == "PVSchedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          var item = GList.data.data[0];
          try {
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            if (
              item.Tabletschedulerdetails[0] != null &&
              item.Tabletschedulerdetails[0] != "" &&
              item.Tabletschedulerdetails[0] != undefined
            ) {
              $scope.Tabletschedulerrecord = item.Tabletschedulerdetails[0];
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ScedulId = item._id;
            $scope.vm.Types = item.Types;
            $scope.vm.PestType1 = item.PestType;
            $scope.vm.Location = item.Location;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.Status = item.Status;
            $scope.vm.JobContinues = item.JobContinues;
            $scope.CreatedBy = item.CreatedBy;
            $scope.CreatedDate = new Date(item.CreateDate);
            $scope.InProgressedBy = "";
            $scope.InProgresseAt = null;
            $scope.vm.BillingAmount = item.BillingAmount;
            if (
              $scope.vm.Status != "Yet to Start" &&
              $scope.vm.Status != "Outstanding"
            ) {
              $scope.InProgressedBy = item.InProgressedBy;
              if ($scope.vm.Status == "Completed") {
                $scope.InProgressedBy = item.UpdatedBy;
              }
            }
            if (
              item.EmailSentDate == null ||
              item.EmailSentDate == undefined ||
              item.EmailSentDate == "null"
            ) {
              $scope.vm.EmailSentDate = "";
            } else {
              $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
            }
            $scope.vm.EmailSentTo = item.EmailSentTo;
            try {
              var value = $scope.Tabletschedulerrecord;
              if (
                value.TeamSignature != null &&
                value.TeamSignature != "" &&
                value.TeamSignature != undefined
              ) {
                value.TeamSignature = decode_base64(value.TeamSignature);
                $scope.vm.TeamSignature = value.TeamSignature;
              }
              if (
                value.CustomerSignature != null &&
                value.CustomerSignature != "" &&
                value.CustomerSignature != undefined
              ) {
                value.CustomerSignature = decode_base64(
                  value.CustomerSignature
                );
                $scope.CustomerSignature = value.CustomerSignature;
              }
              $scope.vm.Pesttype = value.Pesttype;
              $scope.vm.Services = value.Services;
              $scope.vm.Materials = value.Materials;
              $scope.vm.TeamMember = value.TeamMember;
              $scope.vm.TeamRemarks = value.TeamRemarks;
              $scope.vm.CustomerRemarks = value.CustomerRemarks;
              $scope.vm.TeamLead = value.TeamLead;
              $scope.vm.ATimeIn = new Date(value.Startsat);
              $scope.vm.ATimeOut = new Date(value.Endsat);
              $scope.vm.Scheduledate = new Date(value.Scheduledate);
              $scope.vm.StartLocation = value.StartLocation;
              $scope.vm.EndLocation = value.EndLocation;
              $scope.vm.BreedingFound = value.BreedingFound;
              $scope.vm.Species = value.Species;
              $scope.vm.Findings = value.Findings;
              $scope.vm.MistingCariedOut = value.MistingCariedOut;
              $scope.vm.Density = value.Density;
              $scope.vm.Instar = value.Instar;
              $scope.vm.Reason = value.Reason;
              $scope.vm.TeamSignature = value.TeamSignature;
              $scope.vm.Paymentmethod = value.Paymentmethod;
              $scope.vm.PaymentNotes = value.PaymentNotes;
              $scope.vm.MobilEmailId = value.EmailId;
              $scope.vm.PaymentRemarks = value.PaymentRemarks;
              $scope.vm.starRating1 = value.Rating;
              $scope.vm.AServiceStartAt = new Date(value.Startsat);
              if ($scope.vm.Status == "Completed") {
                $scope.InProgresseAt = $scope.vm.AServiceStartAt;
              }
              $scope.vm.AServiceEndAt = new Date(value.Endsat);
              $scope.vm.Totalarea = value.Totalarea;
              $scope.vm.Totalcompleted = value.Totalcompleted;
              $scope.vm.Totalpayment = value.Totalpayment;
              if (
                $scope.vm.Totalarea == null ||
                $scope.vm.Totalarea == "" ||
                $scope.vm.Totalarea == undefined
              ) {
                $scope.vm.Totalarea = 0;
              }
              if (
                $scope.vm.Totalcompleted == "null" ||
                $scope.vm.Totalcompleted == null ||
                $scope.vm.Totalcompleted == "" ||
                $scope.vm.Totalcompleted == undefined
              ) {
                $scope.vm.Totalcompleted = 0;
              }
              if (
                $scope.vm.Totalpayment == "null" ||
                $scope.vm.Totalpayment == null ||
                $scope.vm.Totalpayment == "" ||
                $scope.vm.Totalpayment == undefined
              ) {
                $scope.vm.Totalpayment = 0;
              }
              $scope.vm.CustomerCurrentDate = new Date(
                value.CustomerCurrentDate
              );
              if (
                $scope.vm.starRating1 != "null" &&
                $scope.vm.starRating1 != null &&
                $scope.vm.starRating1 != "" &&
                $scope.vm.starRating1 != undefined
              ) {
                $scope.vm.starRating1r = parseInt(value.Rating);
              }
            } catch (e) { }
            var address = $scope.vm.Location || "Singapore";
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
              geocoder.geocode(
                {
                  address: address
                },
                function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    $scope.latlng = [];
                    $scope.latlng.push(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng()
                    );
                  }
                }
              );
            }
          } catch (e) { }
        });
      }
      RefreshAttachmentGrid(id);
      Refreshcomment(id);
      RefreshPhotos(id);
      RefreshServiceMaterials(id);
      RefreshMobileLogMaterials(id);
      RefreshSchedulerLogs(id);
    };

    $scope.getServiceReports = function (id) {
      var url =
        $rootScope.ReportURL + "Service.aspx" + "?" + "ID=" + id;
      window.open(url);
    };
    $scope.DownloadService = function (id) {
      var url =

        $rootScope.ReportURL +
        "Service.aspx" +
        "?" +
        "ID=" +
        id +
        "&Type=Download";
      window.open(url);
    };

    $scope.GetSchedulerDetails = function (CId, Status) {
      $scope.vm.Start_Date = new Date(new Date(Status).getFullYear(), 0, 1);
      $scope.vm.End_Date = new Date(new Date(Status).getFullYear(), 12, 0);
      $scope.vm.PreviewSpinner = true;
      $scope.RSchedulerdetails = [];
      $scope.PVSchedulerdetails = [];
      $http({
        url: $rootScope.WebURL + "/scheduler/getByFileID",
        method: "POST",
        data: {
          FileID: CId,
          Start_Date: $scope.vm.Start_Date,
          End_Date: $scope.vm.End_Date
        }
      }).then(function (List) {
        $scope.RSchedulerdetails = List.data.data;
        $scope.PVSchedulerdetails = List.data.data;
        var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
          return (
            new Date(item4.Startsat) >= $scope.vm.pvFrom &&
            new Date(item4.Startsat) <= $scope.vm.pvTo &&
            item4.Status === "Completed"
          );
        });
        $scope.PVSchedulerdetails = item4;
        $scope.vm.PreviewSpinner = false;
      });
    };

    $scope.CCarray = [];
    $scope.AddCC = function (email) {
      try {
        if ($scope.CCarray.indexOf(email) == -1) {
          $scope.CCarray.push(email);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };
    $scope.Removeccs = function (i) {
      try {
        if ($scope.CCarray.indexOf(i) == -1) {
          $scope.CCarray.splice(i, 1);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };

    $scope.salesorderinfo = function (e, item, $index) {
      $scope.Update = true;
      $scope.vm.BContactPerson = null;
      $scope.EUpdate = false;
      if (item.Status == "Scheduled") $scope.EUpdate = true;
      $scope.Salesform = true;
      $scope.Salesgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.SID = item._id;

      $scope.File_id = item._id;
      $scope.Add = false;
      $scope.Search = false;
      $scope.IndexID = $index;
      $scope.FrequencyArray = [];
      $scope.ServiceAddressarray = [];
      $scope.vm.OrderConfirmationDate = item.OrderConfirmationDate;
      $scope.vm.SalesOrderNo = item.SalesOrderNo;
      if (
        $scope.vm.OrderConfirmationDate != null &&
        $scope.vm.OrderConfirmationDate != ""
      ) {
        $scope.vm.OrderConfirmationDate = new Date(item.OrderConfirmationDate);
      }
      var Email = item.SiteEmail;
      if (Email != "" && Email != undefined && Email != null)
        $scope.vm.SiteEmail = item.SiteEmail;
      else $scope.vm.SiteEmail = "";
      $scope.vm.SContactPerson = item.SiteContactPerson;
      $scope.vm.SalesPerson = item.SalesPerson_id;
      $scope.vm.EnquiryReferenceNo = item.EnquiryReferenceNo;

      $scope.vm.ContactPerson = item.ContactPerson;
      $scope.vm.CustomerName = item.Customer_id;
      $scope.vm.CompanyName = $scope.vm.uCompanyName;
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.EmployeeName = item.id;
      } catch (error) { }
      try {
        var value = $scope.Customerdatas.filter(function (value) {
          return value._id === item.Customer_id;
        })[0];
        var litem = $scope.Leaddetails.filter(function (litem) {
          return litem.CustomerID === item.Customer_id;
        });
        $scope.Leaddatas = litem;
      } catch (error) { }

      try {
        var value = $scope.Leaddatas.filter(function (value) {
          return value.LeadReferenceNo === $scope.vm.EnquiryReferenceNo;
        })[0];
        if (value != undefined) {
          $scope.EqUpdate = true;
        } else $scope.EqUpdate = false;
      } catch (error) { }

      $scope.vm.ServiceStartDate = item.ServiceStartDate;
      if (
        $scope.vm.ServiceStartDate != null &&
        $scope.vm.ServiceStartDate != ""
      ) {
        $scope.vm.ServiceStartDate = new Date(item.ServiceStartDate);
      }
      $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
      $scope.vm.ServiceEndDate = item.ServiceEndDate;
      if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
        $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
      }

      if (
        item.CustomerID != undefined &&
        item.CustomerID != null &&
        item.CustomerID != ""
      ) {
        var array = [];
        array.push({ SegmentName: item.CustomerID });
        $scope.vm.SLocation = item.CustomerID;
        $scope.DisableServiceLocation = true;
      } else $scope.DisableServiceLocation = false;
      $scope.vm.SName = item.SiteName;
      $scope.vm.CreatedDate = item.CreatedDate;
      $scope.vm.CreatedBy = item.CreatedBy;
      $scope.vm.SContactNo = item.SiteContactNo;
      if (item.Mobile != null && item.Mobile != undefined && item.Mobile != "")
        $scope.vm.SiteContactNo = item.Mobile;
      else $scope.vm.SiteContactNo = "";
      if (item.Mobile != null && item.Mobile != undefined && item.Mobile != "")
        $scope.vm.BContactNo = item.Mobile;
      else $scope.vm.BContactNo = "";
      if (item.Email != "" && item.Email != undefined && item.Email != null)
        $scope.vm.BEmail = item.Email;
      else $scope.vm.BEmail = "";
      $scope.vm.Frequency = item.Frequency;
      $scope.vm.OrderType = item.OrderType;
      $scope.vm.TotalSum = item.TotalSum;
      $scope.vm.CoverageArea = item.CoverageArea;
      $scope.vm.IsUrgent = item.IsUrgent;
      $scope.vm.Department = item.Department;
      // if ($scope.vm.IsUrgent == true) $scope.vm.IsUrgent = "true"
      // else $scope.vm.IsUrgent = "false"
      $scope.vm.TrendingReport = item.TrendingReport;
      // if ($scope.vm.TrendingReport == true) $scope.vm.TrendingReport = "true"
      // else $scope.vm.TrendingReport = "false"
      $scope.vm.DateTimeofTreatment = item.DateTimeofTreatment;
      $scope.vm.SpecialRemark = item.SpecialRemarks;
      $scope.vm.PaymentMode = item.PaymentMode;
      $scope.vm.PestType = item.PestType;
      if (
        $scope.vm.PestType != null &&
        $scope.vm.PestType != "" &&
        $scope.vm.PestType != undefined
      ) {
        var array = $scope.vm.PestType.split(",");
        var array1 = [];
        angular.forEach(array, function (item) {
          array1.push({ PestName: item });
        });
        $scope.vm.PestType = array1;
      }
      $scope.vm.Treatment = item.Treatment;
      if (
        $scope.vm.Treatment != null &&
        $scope.vm.Treatment != "" &&
        $scope.vm.Treatment != undefined
      ) {
        var array = $scope.vm.Treatment.split(",");
        var array1 = [];
        angular.forEach(array, function (item) {
          array1.push({ TreatmentName: item });
        });
        $scope.vm.Treatment = array1;
      }
      $scope.vm.sStreet = item.sStreetName;
      $scope.vm.Occurence = item.EnqRef;
      $scope.vm.Message = item.Message
        ? item.Message.replace(/<[^>]+>/g, "")
        : "";
      $scope.vm.sPostal = item.sPostal;
      $scope.vm.PurchaseOrderNo = item.PurchaseOrderNo;
      $scope.vm.SpecialChemical = item.SpecialChemical;
      $scope.Frequencydatas = item.MultiFrequency;
      $scope.vm.BillingFrequency = item.BillingFrequency;
      $scope.vm.Types = item.Types;
      $scope.vm.JobsPerFrequency = parseInt(item.JobsPerFrequency);
      $scope.vm.ServicesRequired = parseInt(item.ServicesRequired);
      $scope.vm.EstimatedHoursRequired = parseFloat(
        item.EstimatedHoursRequired
      );
      $scope.vm.TotalPrice = parseFloat(item.TotalPrice);
      $scope.vm.TotalTripsPerYear = parseInt(item.TotalTripsPerYear);
      $scope.vm.BAddress = null;
      getBillingAddress(item.BillingAddress);
      RefreshWOAttachmentGrid();
      RefreshComments($scope.SID);

      // CustomerBillingdatadetails(RequestID);
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getById",
        data: { _id: item.ContractNo }
      }).then(function (contractdata) {
        $scope.contractdatas = contractdata.data.data;
        try {
          $scope.vm.ContractNo =
            $scope.contractdatas[
              $scope.contractdatas.length - 1
            ].ContractReferenceNo;
          if ($scope.vm.OrderType == "Contract") {
            $scope.vm.ServiceStartDate = new Date(
              $scope.contractdatas[
                $scope.contractdatas.length - 1
              ].ServiceStartDate
            );
            $scope.vm.ServiceEndDate = new Date(
              $scope.contractdatas[
                $scope.contractdatas.length - 1
              ].ServiceEndDate
            );
            $scope.vm.TotalPrice = parseFloat(
              $scope.contractdatas[$scope.contractdatas.length - 1]
                .ContractValue
            );
            $scope.vm.BillingFrequency =
              $scope.contractdatas[
                $scope.contractdatas.length - 1
              ].BillingFrequency;
            $scope.Frequencydatas =
              $scope.contractdatas[
                $scope.contractdatas.length - 1
              ].MultiFrequency;
            $scope.vm.EnquiryReferenceNo = contractdata.data.data[0].EnquiryID;
            var Mobile = contractdata.data.data[0].SiteContact;
            if (Mobile != null && Mobile != "" && Mobile != undefined)
              $scope.vm.SiteContactNo = Mobile.split(",");
            else $scope.vm.SiteContactNo = [];
            $scope.vm.SContactPerson =
              contractdata.data.data[0].SiteContactPerson;
            $scope.vm.SName = contractdata.data.data[0].SiteName;
            var Email = contractdata.data.data[0].SiteName;
            if (Email != "" && Email != undefined && Email != null)
              $scope.vm.SiteEmail = Email.split(",");
            else $scope.vm.SiteEmail = [];
          } else $scope.Frequencydatas = [];
        } catch (e) {
          $scope.vm.ContractNo = null;
          $scope.vm.ServiceStartDate = null;
          $scope.vm.ServiceEndDate = null;
          $scope.vm.TotalPrice = parseFloat(0);
          $scope.vm.BillingFrequency = null;
          $scope.vm.EnquiryReferenceNo = null;
          var Mobile = null;
          $scope.vm.SContactPerson = null;
          $scope.vm.SName = null;
          var Email = null;
        }
      });

      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/viewWO.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    function RefreshComments(ID) {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByReqID",
        method: "POST",
        data: { RequestID: ID }
      });
      response.then(function (Commentdata) {
        var Commentdatas = [];
        Commentdatas.push({ key: 0 });
        $scope.Commentdatas = [];
        if (
          $scope.vm.SpecialRemarks != undefined &&
          $scope.vm.SpecialRemarks != "" &&
          $scope.vm.SpecialRemarks != null
        ) {
          Commentdatas[0].key = 1;
          Commentdatas[0].cmt = $scope.vm.SpecialRemarks;
          Commentdatas[0].CommentedBy = $scope.vm.CreatedBy;
          Commentdatas[0].CreatedDate = $scope.vm.CreatedDate;
          // $scope.Commentdatas = Commentdatas.concat(Commentdata.data.data);
          $scope.Commentdatas = Commentdata.data.data;
        } else $scope.Commentdatas = Commentdata.data.data;
        $scope.vm.SpecialRemarks = "";
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate);
        });
        $scope.Commentdatas.reverse();
      });
    }
    function RefreshWOAttachmentGrid() {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id }
      });
      response.then(function (attachmentdata) {
        $scope.WoAttachmentdatas = attachmentdata.data.data;
      });
    }

    function getBillingAddress(BillingId) {
      var response = $http({
        url:

          $rootScope.WebURL +
          "/customerService/getcustomerserviceaddressdetailsbyID",
        method: "POST",
        data: { _id: BillingId }
      });
      response.then(function (CustomerBillingdata) {
        var CustomerBillingdatas = CustomerBillingdata.data.data;
        if (CustomerBillingdatas.length > 0) {
          $scope.vm.BAddress =
            CustomerBillingdatas[0].bStreetName +
            ", Singapore, " +
            CustomerBillingdatas[0].bPostal;
          if (
            $scope.vm.BContactPerson == undefined ||
            $scope.vm.BContactPerson == null
          )
            $scope.vm.BContactPerson = CustomerBillingdatas[0].bContactPerson;
        }
      });
    }

    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "CreditTerm";
        });
        $scope.CreditTermdatas = item;
      } catch (e) { }

      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "BuildingType";
        });
        $scope.BuildingTypedatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "EnquiryMode";
        });
        $scope.EnquiryModedatas = item;
      } catch (e) { }
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/team",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (teamdata) {
      $scope.Teamdatas = teamdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (salesOrderdata) {
      $scope.salesOrderdatas = salesOrderdata.data.data;
      // $scope.Datefilter();
    });

    $http
      .get($rootScope.WebURL + "/user")
      .then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/employee/Resigned",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (Employeedata) {
          $scope.ResignEmployeedatas = Employeedata.data.data;
          $scope.ResignedUsers = _.differenceBy(
            $scope.Userdatas,
            $scope.ResignEmployeedatas,
            "EmployeeID"
          );
        });
      });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });
    function RefreshMsgrid() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (marketsegmentdata) {
        $scope.Marketsegmentdatas = marketsegmentdata.data.data;
      });
    }
    function RefreshAttachmentGrid(id) {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }
    function Refreshcomment(id) {
      if ($scope.Update == false) {
        var response = $http({
          url: $rootScope.WebURL + "/schedulercomment/getbyModule",
          method: "POST",
          data: { ModuleID: id }
        });
        response.then(function (Commentdata) {
          $scope.CustomerCommentdatas = Commentdata.data.data;
        });
      } else {
        var response = $http({
          url:
            $rootScope.WebURL + "/schedulercomment/getByCustomer",
          method: "POST",
          data: { RequestID: id }
        });
        response.then(function (Commentdata) {
          $scope.CustomerCommentdatas = Commentdata.data.data;
        });
      }
    }
    function RefreshPhotos(id) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerpicafter",
        data: { ScedulId: id }
      }).then(function (Photosdatas) {
        $scope.Photosdatas = Photosdatas.data.data;
        angular.forEach($scope.Photosdatas, function (employee) {
          if (
            employee.schimgafter != null &&
            employee.schimgafter != "" &&
            employee.schimgafter != undefined
          ) {
            employee.schimgafter = decode_base64(employee.schimgafter);
          }
          if (
            employee.schimgbefore != null &&
            employee.schimgbefore != "" &&
            employee.schimgbefore != undefined
          ) {
            employee.schimgbefore = decode_base64(employee.schimgbefore);
          }
        });
        var item = $scope.Photosdatas.filter(function (item) {
          return (
            item.schimgafter != null &&
            item.schimgafter != "null" &&
            item.schimgafter != "" &&
            item.schimgafter != undefined
          );
        });
        $scope.PhotosAdatas = item;
        var item1 = $scope.Photosdatas.filter(function (item1) {
          return (
            item1.schimgbefore != null &&
            item1.schimgbefore != "null" &&
            item1.schimgbefore != "" &&
            item1.schimgbefore != undefined
          );
        });
        $scope.PhotosBdatas = item1;
      });
    }
    function RefreshServiceMaterials(id) {
      var response = $http({
        url: $rootScope.WebURL + "/tabletlighttracklist/getbyId",
        method: "POST",
        data: { ServiceId: id }
      });
      response.then(function (Tabletlighttracklistdata) {
        $scope.Tabletlighttracklistdatas = Tabletlighttracklistdata.data.data;
      });
      $scope.vm.SMUpdate = false;
    }
    function RefreshMobileLogMaterials(id) {
      var response = $http({
        url: $rootScope.WebURL + "/tabletMaterials/getById",
        method: "POST",
        data: { Service_Id: id }
      });
      response.then(function (TabletMaterialslistdata) {
        $scope.TabletMaterialslistdatas = TabletMaterialslistdata.data.data;
      });
      $scope.vm.SMLMUpdate = false;
    }
    function RefreshSchedulerLogs(id) {
      var response = $http({
        url: $rootScope.WebURL + "/schedulelog/getByServiceID",
        method: "POST",
        data: { ServiceID: id }
      });
      response.then(function (SchedulerLogdata) {
        $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
      });
    }
    function CustomerBillingdatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
      });
    }
    function CustomerServicedatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatas = CustomerServicedata.data.data;
      });
    }

    function ClearForm() {
      $scope.vm.uCustomerID = null;
      $scope.vm.uSalutation = null;
      $scope.vm.uFirstName = null;
      $scope.vm.uLastName = null;
      $scope.vm.uCompanyName = null;
      $scope.vm.uNote = null;
      $scope.vm.uAddress = null;
      $scope.vm.uAddress1 = null;
      $scope.vm.uPostal = null;
      $scope.vm.uCountry = "Singapore";
      $scope.vm.uContactPerson = null;
      $scope.vm.uPhone = null;
      $scope.vm.uMobile = [];
      $scope.vm.uEmail = [];
      // $scope.vm.CustomerSince = new Date();
      $scope.vm.ProspectFollowDate = null;
      $scope.vm.Unit = null;
      $scope.vm.EnquiryMode = null;
      $scope.vm.additionalInformation = null;
      $scope.vm.StreetName = null;
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.ubContactPerson = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.BuildingName = null;
      $scope.vm.ConEndDate = null;
      $scope.vm.ubFax = null;
      $scope.vm.ubMobile = null;
      $scope.vm.ubEmail = null;
      $scope.vm.Category = null;
      $scope.vm.MarketSection = null;
      $scope.vm.uInvoiceEmail = [];
      $scope.vm.uInvoiceCC = [];
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
      $scope.vm.emailValidationError = false;
      $scope.vm.emailValidationError1 = false;
      $scope.vm.emailValidationError2 = false;
      $scope.vm.emailChipWarning = false;
      $scope.vm.contactChipWarning = false;
      $scope.vm.emailChipWarning1 = false;
      $scope.vm.emailccWarning = false;
      $scope.vm.contactChipWarning1 = false;

    }

    $scope.printServiceWeb = function (service) {
      var url =

        $rootScope.ReportURL +
        "Service.aspx" +
        "?" +
        "ID=" +
        $scope.vm.ScedulId;
      window.open(url);
    };
    $scope.printService = function (service) {
      var myPdfUrl = $rootScope.DownloadURL + $scope.vm.ServiceID + ".pdf";
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/DownloadServiceReport",
        data: {
          _id: $scope.vm.ScedulId,
          ServiceID: $scope.vm.ServiceID
        }
      });
      response.then(function (GList) {
        setTimeout(function () {
          $window.open(myPdfUrl, "_blank");
        }, 3000);
      });
      alert(
        "Report will be opened in new window. You may have to wait for a while as the system generating the PDF. Please change your settings to allow the popup window for this URL. !"
      );
    };
    $scope.Showlocation = function (Latitude) {
      if (
        Latitude != null &&
        Latitude != "" &&
        Latitude != undefined &&
        Latitude != "undefined"
      ) {
        var array = Latitude.split(",");
        $window.open(
          "https://www.latlong.net/c/?lat=" + array[0] + "&long=" + array[1]
        );
      }
    };

    $scope.getRowColour = function (item) {
      if (item.State == "Suspend") {
        return true;
      } else {
        return false;
      }
    };
    $scope.dateBox = {
      type: "date",
      value: new Date(),
      displayFormat: "Year",
      calendarOptions: {
        zoomLevel: "decade",
        maxZoomLevel: "decade",
        mixZoomLevel: "decade"
      },
      onValueChanged: function (e) {
        $scope.GetSchedulerDetails($scope.SID, e.value);
      }
    };

    $scope.checkboxModel = { value: false };
    $scope.Servicecopy = { value: false };
    $scope.CountyList = [
      { name: "Afghanistan" },
      { name: "Albania" },
      { name: "Algeria" },
      { name: "American Samoa" },
      { name: "AndorrA" },
      { name: "Angola" },
      { name: "Anguilla" },
      { name: "Antarctica" },
      { name: "Antigua and Barbuda" },
      { name: "Argentina" },
      { name: "Armenia" },
      { name: "Aruba" },
      { name: "Australia" },
      { name: "Austria" },
      { name: "Azerbaijan" },
      { name: "Bahamas" },
      { name: "Bahrain" },
      { name: "Bangladesh" },
      { name: "Barbados" },
      { name: "Belarus" },
      { name: "Belgium" },
      { name: "Belize" },
      { name: "Benin" },
      { name: "Bermuda" },
      { name: "Bhutan" },
      { name: "Bolivia" },
      { name: "Bosnia and Herzegovina" },
      { name: "Botswana" },
      { name: "Bouvet Island" },
      { name: "Brazil" },
      { name: "British Indian Ocean Territory" },
      { name: "Brunei Darussalam" },
      { name: "Bulgaria" },
      { name: "Burkina Faso" },
      { name: "Burundi" },
      { name: "Cambodia" },
      { name: "Cameroon" },
      { name: "Canada" },
      { name: "Cape Verde" },
      { name: "Cayman Islands" },
      { name: "Central African Republic" },
      { name: "Chad" },
      { name: "Chile" },
      { name: "China" },
      { name: "Christmas Island" },
      { name: "Cocos (Keeling) Islands" },
      { name: "Colombia" },
      { name: "Comoros" },
      { name: "Congo" },
      { name: "Congo, The Democratic Republic of the" },
      { name: "Cook Islands" },
      { name: "Costa Rica" },
      { name: "Cote D'Ivoire" },
      { name: "Croatia" },
      { name: "Cuba" },
      { name: "Cyprus" },
      { name: "Czech Republic" },
      { name: "Denmark" },
      { name: "Djibouti" },
      { name: "Dominica" },
      { name: "Dominican Republic" },
      { name: "Ecuador" },
      { name: "Egypt" },
      { name: "El Salvador" },
      { name: "Equatorial Guinea" },
      { name: "Eritrea" },
      { name: "Estonia" },
      { name: "Ethiopia" },
      { name: "Falkland Islands (Malvinas)" },
      { name: "Faroe Islands" },
      { name: "Fiji" },
      { name: "Finland" },
      { name: "France" },
      { name: "French Guiana" },
      { name: "French Polynesia" },
      { name: "French Southern Territories" },
      { name: "Gabon" },
      { name: "Gambia" },
      { name: "Georgia" },
      { name: "Germany" },
      { name: "Ghana" },
      { name: "Gibraltar" },
      { name: "Greece" },
      { name: "Greenland" },
      { name: "Grenada" },
      { name: "Guadeloupe" },
      { name: "Guam" },
      { name: "Guatemala" },
      { name: "Guernsey" },
      { name: "Guinea" },
      { name: "Guinea-Bissau" },
      { name: "Guyana" },
      { name: "Haiti" },
      { name: "Heard Island and Mcdonald Islands" },
      { name: "Holy See (Vatican City State)" },
      { name: "Honduras" },
      { name: "Hong Kong" },
      { name: "Hungary" },
      { name: "Iceland" },
      { name: "India" },
      { name: "Indonesia" },
      { name: "Iran, Islamic Republic Of" },
      { name: "Iraq" },
      { name: "Ireland" },
      { name: "Isle of Man" },
      { name: "Israel" },
      { name: "Italy" },
      { name: "Jamaica" },
      { name: "Japan" },
      { name: "Jersey" },
      { name: "Jordan" },
      { name: "Kazakhstan" },
      { name: "Kenya" },
      { name: "Kiribati" },
      { name: "Korea, Democratic People'S Republic of" },
      { name: "Korea, Republic of" },
      { name: "Kuwait" },
      { name: "Kyrgyzstan" },
      { name: "Lao People'S Democratic Republic" },
      { name: "Latvia" },
      { name: "Lebanon" },
      { name: "Lesotho" },
      { name: "Liberia" },
      { name: "Libyan Arab Jamahiriya" },
      { name: "Liechtenstein" },
      { name: "Lithuania" },
      { name: "Luxembourg" },
      { name: "Macao" },
      { name: "Macedonia, The Former Yugoslav Republic of" },
      { name: "Madagascar" },
      { name: "Malawi" },
      { name: "Malaysia" },
      { name: "Maldives" },
      { name: "Mali" },
      { name: "Malta" },
      { name: "Marshall Islands" },
      { name: "Martinique" },
      { name: "Mauritania" },
      { name: "Mauritius" },
      { name: "Mayotte" },
      { name: "Mexico" },
      { name: "Micronesia, Federated States of" },
      { name: "Moldova, Republic of" },
      { name: "Monaco" },
      { name: "Mongolia" },
      { name: "Montenegro" },
      { name: "Montserrat" },
      { name: "Morocco" },
      { name: "Mozambique" },
      { name: "Myanmar" },
      { name: "Namibia" },
      { name: "Nauru" },
      { name: "Nepal" },
      { name: "Netherlands" },
      { name: "Netherlands Antilles" },
      { name: "New Caledonia" },
      { name: "New Zealand" },
      { name: "Nicaragua" },
      { name: "Niger" },
      { name: "Nigeria" },
      { name: "Niue" },
      { name: "Norfolk Island" },
      { name: "Northern Mariana Islands" },
      { name: "Norway" },
      { name: "Oman" },
      { name: "Pakistan" },
      { name: "Palau" },
      { name: "Palestinian Territory, Occupied" },
      { name: "Panama" },
      { name: "Papua New Guinea" },
      { name: "Paraguay" },
      { name: "Peru" },
      { name: "Philippines" },
      { name: "Pitcairn" },
      { name: "Poland" },
      { name: "Portugal" },
      { name: "Puerto Rico" },
      { name: "Qatar" },
      { name: "Reunion" },
      { name: "Romania" },
      { name: "Russian Federation" },
      { name: "RWANDA" },
      { name: "Saint Helena" },
      { name: "Saint Kitts and Nevis" },
      { name: "Saint Lucia" },
      { name: "Saint Pierre and Miquelon" },
      { name: "Saint Vincent and the Grenadines" },
      { name: "Samoa" },
      { name: "San Marino" },
      { name: "Sao Tome and Principe" },
      { name: "Saudi Arabia" },
      { name: "Senegal" },
      { name: "Serbia" },
      { name: "Seychelles" },
      { name: "Sierra Leone" },
      { name: "Singapore" },
      { name: "Slovakia" },
      { name: "Slovenia" },
      { name: "Solomon Islands" },
      { name: "Somalia" },
      { name: "South Africa" },
      { name: "South Georgia and the South Sandwich Islands" },
      { name: "Spain" },
      { name: "Sri Lanka" },
      { name: "Sudan" },
      { name: "Suriname" },
      { name: "Svalbard and Jan Mayen" },
      { name: "Swaziland" },
      { name: "Sweden" },
      { name: "Switzerland" },
      { name: "Syrian Arab Republic" },
      { name: "Taiwan, Province of China" },
      { name: "Tajikistan" },
      { name: "Tanzania, United Republic of" },
      { name: "Thailand" },
      { name: "Timor-Leste" },
      { name: "Togo" },
      { name: "Tokelau" },
      { name: "Tonga" },
      { name: "Trinidad and Tobago" },
      { name: "Tunisia" },
      { name: "Turkey" },
      { name: "Turkmenistan" },
      { name: "Turks and Caicos Islands" },
      { name: "Tuvalu" },
      { name: "Uganda" },
      { name: "Ukraine" },
      { name: "United Arab Emirates" },
      { name: "United Kingdom" },
      { name: "United States" },
      { name: "United States Minor Outlying Islands" },
      { name: "Uruguay" },
      { name: "Uzbekistan" },
      { name: "Vanuatu" },
      { name: "Venezuela" },
      { name: "Viet Nam" },
      { name: "Virgin Islands, British" },
      { name: "Virgin Islands, U.S." },
      { name: "Wallis and Futuna" },
      { name: "Western Sahara" },
      { name: "Yemen" },
      { name: "Zambia" },
      { name: "Zimbabwe" }
    ];

    var applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately"
      },
      {
        key: "onClick",
        name: "On Button Click"
      }
    ],
      dataGrid,
      BillingdataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };

    vm.readonly = false;
    vm.ZoneCC = [];
    vm.ZoneEmail = [];
    vm.uInvoiceEmail = [];
    vm.uInvoiceCC = [];
    vm.UpdateEmail = [];
    vm.roFruitNames = angular.copy(vm.fruitNames);
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      responsive: true,
      destroy: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtOptions2 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      stateSave: true,
      destroy: true
    };
    vm.dtOptions3 = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };
    vm.dtOptionspopup = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };

    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: "onClick"
      },
      searchPanel: {
        visible: false,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sName", caption: "Name" },
        { dataField: "sContactPerson", caption: "Contact Person" },
        //   { dataField: "sBLK", caption: "Blk" },
        //   { dataField: "sUnit", caption: "Unit" },
        { dataField: "sStreetName", caption: "Address" },
        { dataField: "sPostal", caption: "Postal" },
        { dataField: "sEmail", caption: "Email" },
        { dataField: "sMobile", caption: "Mobile to Contact" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = dataGrid.getRowIndexByKey(options.data._id);
                  $scope.Servicesupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  var index = dataGrid.getRowIndexByKey(options.data._id);
                  $scope.cspopup(e, options.data._id, index, "Service");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          e.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerBilling = {
      onInitialized: function (e) {
        BillingdataGrid = e.component;
      },
      dataSource: $scope.CustomerBillingdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: false,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "40",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "bContactPerson", caption: "Contact Person" },
        //   { dataField: "bBLK", caption: "Blk" },
        { dataField: "bStreetName", caption: "Address" },
        { dataField: "bPostal", caption: "Postal" },
        // { dataField: "bCountry", caption: "Country" },
        { dataField: "bEmail", caption: "Email" },
        { dataField: "bMobile", caption: "Mobile to Contact" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.Billingupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.cspopup(e, options.data._id, index, "Billing");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerBillingdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          e.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    if (IsAdmin) {
      $scope.Mode = "multiple";
      $scope.showCheckBoxesMode = "always";
    } else {
      $scope.Mode = "none";
      $scope.showCheckBoxesMode = "onClick";
    }

    function AllCustomersview(value) {
      $scope.ViewAllCustomer = value;
      if (value) {
        var Customer = _.sortBy($scope.Alllcustomer, "SortDate");
        $scope.Customerdatas = _.reverse(Customer);
        if ($scope.Customerdatas.length > 0)
          $scope.LastModified = $scope.Customerdatas[0].id;
        else $scope.LastModified = null;
      } else {
        var Filter = _.sortBy($scope.FilteredCustomer, "SortDate");
        $scope.Customerdatas = _.reverse(Filter);
        if ($scope.Customerdatas.length > 0)
          $scope.LastModified = $scope.Customerdatas[0].id;
        else $scope.LastModified = null;
      }
    }
    function getOrderDay(rowData) {
      return new Date(rowData.OrderDate).getDay();
    }

    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }

    $scope.Status = function () {
      if (data) {
      }
    };

    $scope.AddLead = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/addlead.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function customerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      clear();
      $scope.vm.ppCompanyName = $scope.vm.uCompanyName;
      $scope.vm.ExpectedResponseDate = $scope.vm.ConEndDate;
    };

    function clear() {
      $scope.vm.NatureofJob = "";
      $scope.vm.EnquiryMode = "";
      $scope.vm.ServiceTime = "";
      $scope.vm.SalesPerson = $scope.Emp_Id;
      $scope.vm.Pipelinevalue = 0;
      $scope.vm.EnquiryType = "Ad-hoc";
      $scope.vm.EnquiryDate = new Date();
    }
    $scope.leadSubmit = function () {
      if (
        $scope.vm.MarketSegment != null &&
        $scope.vm.MarketSegment != "" &&
        $scope.vm.MarketSegment != undefined
      ) {
        $scope.vm.MarketSegment = $scope.vm.MarketSegment.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      if (
        $scope.vm.NatureofJob != null &&
        $scope.vm.NatureofJob != "" &&
        $scope.vm.NatureofJob != undefined
      ) {
        $scope.vm.NatureofJob = $scope.vm.NatureofJob.map(function (obj) {
          return obj.PestName;
        }).join(",");
      }
      if (
        $scope.vm.ppCompanyName != null &&
        $scope.vm.ppCompanyName != "" &&
        $scope.vm.ppCompanyName != undefined
      ) {
        $scope.vm.CustomerID = null;
        try {
          var item = $scope.Customerdatas.filter(function (item) {
            return item.CompanyName == $scope.vm.ppCompanyName;
          })[0];
          $scope.vm.CustomerID = item.id;
        } catch (e) { }
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/lead/add",
        data: {
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.ppCompanyName,
          NatureofJob: $scope.vm.NatureofJob,
          EnquiryMode: $scope.vm.EnquiryMode,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          EnquiryType: $scope.vm.EnquiryType,
          CustomerID: $scope.vm.CustomerID,
          CreatedBy: $rootScope.createdby,
          Client_Id: $rootScope.Client_Id
        }
      });
      response.then(
        function (GList) {
          $scope.GListdata = GList.data.data;
          $scope.vm.LeadId = $scope.GListdata.id;
          $scope.vm.LeadReferenceNo = $scope.GListdata.LeadReferenceNo;
          clear();
          var file = angular.element(document.querySelector("#fileInput"))[0]
            .files;
          if (file.length != 0 && file.length != undefined) {
            var files = [];
            files.push({ file: file[0] });
            $scope.Uploadfiles(files);
          }
          $mdDialog.cancel();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Added!")
              .position("top center")
          );
          // $scope.Leadgrid = true;
          // $scope.Leadform = false;
          // $scope.Export = true;
          // $scope.Add = true;
          // $scope.view = false;
          // $scope.Search = true;
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Uploadfiles = function (file) {
      var upfile = file[0].file;
      var response = Upload.upload({
        url: $rootScope.WebURL + "/lead/upload",
        data: { file: upfile }
      }).then(
        function (resp) {
          $scope.TableID = resp.data.data[0].GUIDFILENAME;
          $scope.fileName = resp.data.data[0].OriginalFileName;
          $scope.fileSize = resp.data.data[0].Size;
          $scope.Path = resp.data.data[0].Path;
          $scope.fileType = resp.data.data[0].Type;
          if (resp.data.message == "Successfully Uploaded") {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/attachment/add",
              data: {
                TableID: $scope.TableID,
                TableName: "Lead",
                FileID: $scope.vm.LeadReferenceNo,
                FileName: $scope.fileName,
                FileSize: $scope.fileSize,
                FileType: $scope.fileType,
                ModuleID: $scope.Path,
                Data: null,
                IsActive: "true",
                CreatedBy: $rootScope.createdby
              }
            });
            response.then(
              function (GList) {
                $scope.File_id = $scope.vm.LeadReferenceNo;
                //   RefreshGrid();
                //file[0].cancel();
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Successfully Added and redirecting to Leads Page!"
                    )
                    .position("top center")
                );
                $state.go("app.lead");
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    function getUploadedDocuments(id) {
      $http({
        url: $rootScope.WebURL + "/customer/getAttachment",
        method: "POST",
        data: { _id: id }
      }).then(function (List) {
        $scope.UploadedDocuments = List.data.data;
      });
    }
    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "PaymentMode";
        });
        $scope.PaymentModedatas = item;
      } catch (e) { }
    });

    $scope.$on("customer_created", function (event, customer) {
      $scope.Alllcustomer.push(customer);
      // re-assign and re-render as needed
      updateCustomerLists();
    });

    $scope.$on("customer_modified", function (event, updatedCustomer) {
      const idx = $scope.Alllcustomer.findIndex(function (c) {
        return c.id === updatedCustomer.id;
      });
      if (idx !== -1) {
        $scope.Alllcustomer[idx] = updatedCustomer;
      }
      updateCustomerLists();
    });

    function updateCustomerLists() {
      if (!IsAdmin) {
        const item = $scope.Alllcustomer.filter(function (item) {
          if (item.AssignedUser != null) {
            const eeitem = item.AssignedUser.split(",");
            return _.intersection(eeitem, Emploee).length > 0;
          }
        });
        $scope.Customerdatas = item;
        $scope.FilteredCustomer = item;
        $scope.getCustomerdatas = item;
      } else {
        $scope.Customerdatas = $scope.Alllcustomer;
        $scope.FilteredCustomer = $scope.Alllcustomer;
        $scope.getCustomerdatas = $scope.Alllcustomer;
      }

      $scope.AllCustomersview($scope.ViewAllCustomer);
      angular
        .element("#gridContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.Customerdatas);
    }

    function update_contact_email_field(scope) {
      var emailInput1 = angular.element(document.querySelector('#Email2service input[placeholder="Email"]'));
      var contactInput1 = angular.element(document.querySelector('#Contact2service input[placeholder="Contact Number"]'));
      var emailcc = angular.element(document.querySelector('[placeholder="CC"]'));

      emailInput1.on('blur', function () {
        var val = emailInput1.val().trim();
        scope.$apply(function () {
          scope.vm.emailChipWarning1 = !!val;
        });
      });

      contactInput1.on('blur', function () {
        var val = contactInput1.val().trim();
        scope.$apply(function () {
          scope.vm.contactChipWarning1 = !!val;
        });
      });
      emailcc.on("blur", function () {
        var val = emailcc.val().trim();
        scope.$apply(function () {
          $scope.vm.emailccWarning = !!val
        })
      })
    }

    $scope.$on("customer_deleted", function () {
      getAllCustomers();
    });
  }
})();



 
(function () {
    'use strict';

    angular
        .module('apps.crm.crmflexischeduler', []  )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.crmflexischeduler', {
            url: '/crmscheduler',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/flexischeduler/flexischeduler.html',
                    controller: 'CRMflexischedulerController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';
    angular
        .module('apps.crm.crmflexischeduler')
        .controller('CRMflexischedulerController', CRMflexischedulerController);
    /** @ngInject */
    function CRMflexischedulerController($scope, $rootScope, $interval, socket, $mdSidenav, $filter, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document, $window, $locale, NgMap, Upload) {
        document.getElementsByTagName('title')[0].text = "Customer Relationship-Daily Scheduler"
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcDScheduler")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }

        // capitalize first letter
        String.prototype.capitalize = function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        }



        $rootScope.CreatedBy = localStorage.getItem('LoginID');
        var vm = this;
        vm.Formvalid = true;
        $scope.vm.ExpiredDate = 7
        $scope.StDate = new Date()
        $scope.EnDate = new Date()
        vm.Date = new Date();
        // GetCWCdatas()
        $scope.ServiceAddressarray = [];
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.ServiceAddressarray = [];
            $scope.CustomerServicedatas = [];
            $scope.vm.Location = null;
            $scope.vm.CompanyName = '';
            $scope.vm.WorkOrderNo = '';
            $scope.vm.ContractNo = '';
            $scope.vm.PestType = '';
            $scope.vm.SO = '';

        };
        $scope.Submit = function () {
            var item = $scope.calenderdata.filter(function (item) {
                // return item.Team_Id === $scope.vm.TeamName && $scope.vm.ServiceStartDate.getTime() >= item.startDate.getTime() && $scope.vm.ServiceStartDate.getTime() < item.endDate.getTime()
                if (item.Team_Id === $scope.vm.TeamName) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Team in this time slot !').position('top center'));
            }
            var item = $scope.calenderdata.filter(function (item) {
                if (item.Customer_id === $scope.vm.Customer_id) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Customer in this time slot !').position('top center'));
            }
            else {

                var ASchearray = [];

                $scope.vm.ServiceOn = $filter('date')(new Date(), 'EEEE');

                angular.forEach($scope.ServiceAddressarray, function (value) {
                    ASchearray.push({
                        JobsOrders: $scope.vm.WorkOrder_id,
                        Customer: $scope.vm.Customer_id,
                        AssignedTo: $scope.vm.TeamName,
                        ServiceOn: $scope.vm.ServiceOn,
                        Status: "Yet to Start",
                        JobType: $scope.vm.JobType,
                        Startsat: new Date($scope.vm.ServiceStartDate.getTime()),
                        Endsat: new Date($scope.vm.ServiceEndDate.getTime()),
                        PestType: $scope.vm.PestType,
                        JobContinues: 'No',
                        ContractOrder: $scope.vm.ContractOrder,
                        Types: $scope.vm.SchedulingType,
                        Location: value.getLocation,
                        ContactNumber: value.sMobile,
                        ContactPerson: value.sContactPerson,
                        CustomerService_Id: value._id,
                        ScheduleType: "Custom",
                        LatLong: value.LatLong,
                        AllowBillableExport: false,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    })
                })
                // }
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/addbyarray",
                    data: { ServiceArray: ASchearray },
                }).then(function (GList) {
                    ASchearray = [];
                    $scope.ServiceAddressarray = [];
                    $scope.vm.CompanyName = '';
                    $scope.vm.WorkOrderNo = '';
                    $scope.vm.ContractNo = '';
                    $scope.vm.PestType = '';
                    $scope.vm.JobType = '';
                    $scope.vm.Location = '';
                    $scope.vm.Location = '';
                    $scope.vm.ServiceStartDate = null;
                    $scope.vm.ServiceEndDate = null
                    $mdDialog.cancel();
                    LoadSchedulerData();
                    // GetCWCdatas()
                });
            }
        };

        $scope.AddComents = function (e, SId, CancelledTab) {
            $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            CleanAddComments();
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/addcoments.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, NgMap, $locale, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.SalesOrderNo = '';
            $scope.vm.ContractReferenceNo = '';
            $scope.vm.CompanyName = '';
            $scope.vm.Types = '';
            $scope.vm.EmailSentTo = '';
            $scope.vm.ScedulId = SId;
            $scope.File_id = SId;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            $scope.Billable = { value: true };
            $scope.CollectPayment = { value: false };
            if (CancelledTab != true) {
                var item = $scope.DragScheduledJobs.filter(function (item) {
                    return item._id === SId;
                })[0];

                $scope.vm.ServiceID = item.ServiceID;
                try {
                    $scope.vm.ContractOrder = item.Contracterdetails[0].ContractReferenceNo;
                } catch (e) {
                    $scope.vm.ContractOrder = 'Ad-hoc Job'
                }
                $scope.vm.CompanyName = item.customerdetails[0].CompanyName
                $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
                $scope.vm.PestType = item.PestType;
                if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                    var array = $scope.vm.PestType.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ PestName: value });
                    });
                    $scope.Pestdatas = array1;
                    $scope.vm.PestType = array1;
                }
                getLastCompletedJob(item.JobOrdersdetails[0]._id)
                $scope.vm.Types = item.Types;
                $scope.vm.JobType = item.JobType;
                $scope.vm.PestType1 = item.PestType;
                $scope.vm.Customer_Id = item.Customer
                $scope.vm.Location = item.Location;
                $scope.vm.Status = item.Status;
                $scope.vm.Remarks = item.SpecialRemark
                $scope.CreatedBy = item.CreatedBy;
                $scope.CreatedDate = new Date(item.CreateDate);
                $scope.vm.Notes = item.AccountsNotes
                $scope.vm.Message = item.Message
                $scope.InProgressedBy = "";
                $scope.InProgresseAt = null;
                var address = $scope.vm.Location || 'Singapore';
                var geocoder = new google.maps.Geocoder();
                if (geocoder) {
                    geocoder.geocode({
                        'address': address
                    }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            $scope.latlng = [];
                            $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        }
                    });
                }
            }
            RefreshAttachmentGrid();
            Refreshcomment();
            RefreshPhotos();
            RefreshServiceMaterials();
            RefreshMobileLogMaterials();
            RefreshSchedulerLogs();
        }

        $scope.sendEmailPop = function (e) {
            $scope.Emaildatas = []
            angular.forEach($scope.Todaydatas, function (value, key) {
                var email = []
                email.push(value.CustomerEmail)
                email.push(value.ClientEmail)
                if (value.TeamName == undefined) {
                    value.TeamName = getTeamName(value.Team_Id)
                }
                $scope.Emaildatas.push({
                    code: key + 1,
                    _id: value.id,
                    ServiceId: value.ServiceID,
                    CusName: value.CustomerName,
                    TeamName: value.TeamLead,
                    CusEmail: email.map(function (o) { return o }).join(','),
                    TeamFullName: value.TeamName,
                    Startsat: value.startDate,
                    PestType: value.PestType,
                    ContactPerson: value.SiteContactName,
                    Location: value.Location,
                    TeamLead: value.TeamLead,
                    TechnicianName: value.TeamMembers
                })
            })
            console.log($scope.Emaildatas)
            // $("#popup").dxPopup({
            //     visible: true,
            //     title: 'Send Schedule',
            //     width: 800,
            //     height: 'auto',
            //     position: {
            //         my: 'center',
            //         at: 'center',
            //         of: window
            //     },
            //     dragEnabled: true,
            //     contentTemplate: function (e) {
            //         var formContainer = $("<div id='formcont'>");

            //         formContainer.append();
            //             var grid = $("<div>");
            //             formContainer.append(grid);
            //             grid.dxDataGrid({
            //                 onInitialized: function (e) {
            //                     $scope.gridInstance = e.component;
            //                 },
            //                 dataSource: $scope.Emaildatas,
            //                 showColumnLines: true,
            //                 showRowLines: true,
            //                 rowAlternationEnabled: true,
            //                 showBorders: true,
            //                 headerFilter: false,
            //                 keyExpr: "code",
            //                 paging: {
            //                     enabled: true,
            //                     pageSize: 10
            //                 },
            //                 searchPanel: {
            //                     visible: true,
            //                     highlightCaseSensitive: true,
            //                     width: 300
            //                 },
            //                 // selection: {
            //                 //     mode: "multiple"
            //                 // },
            //                 // groupPanel: {
            //                 //     visible: false
            //                 // },
            //                 // allowColumnResizing: true,
            //                 columns: [
            //                     {
            //                         caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            //                             cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
            //                         }
            //                     },
            //                     { dataField: "CusName", caption: "Customer Name" },
            //                     { dataField: "TeamName", caption: "Team Name" },
            //                     { dataField: "ServiceId", caption: "Service Id" },
            //                     { dataField: "CusEmail", caption: "Customer Email" }
            //                     // { dataField: "TecEmail", caption: "Technician Email" }
            //                 ],
            //                 bindingOptions: {
            //                     dataSource: "Emaildatas"
            //                 },
            //                 onSelectionChanged: function (e) {
            //                     if (e.selectedRowKeys.length > 0) {
            //                         $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
            //                     }
            //                     else
            //                         $scope.SelectedMail = []
            //                 },
            //             })

            //         formContainer.append($("<br><br><div style= 'margin-left:42%'>").dxButton({
            //             text: 'Update',
            //             type: "default",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //                 UpdateSchedule($scope.vm.ID, $scope.StartDate, $scope.EndDate, $scope.TeamID, null);
            //                 showToast("Updated Successfully", ' ', "info");
            //             }
            //         }));
            //         formContainer.append($("<div style= 'margin-left:2%'>").dxButton({
            //             text: 'Cancel',
            //             type: "normal",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //             }
            //         }));
            //         e.append(formContainer);
            //     }
            // });
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/EmailConfirmation.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.Emaildatas = []
        $scope.SelectedMail = []
        vm.EmailDataGrid = {
            // onContentReady: function (e) {
            //     e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            // },
            dataSource: $scope.Emaildatas,
            columnResizingMode: "widget",
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            headerFilter: false,
            keyExpr: "code",
            paging: {
                enabled: true,
                pageSize: 10
            },
            searchPanel: {
                visible: true,
                highlightCaseSensitive: true,
                width: 300
            },
            selection: {
                mode: "multiple"
            },
            // groupPanel: {
            //     visible: false
            // },
            // allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "CusName", caption: "Customer Name" },
                { dataField: "TeamName", caption: "Team Name" },
                { dataField: "ServiceId", caption: "Service Id", sortOrder: 'asc' },
                { dataField: "CusEmail", caption: "Customer Email" }
                // { dataField: "TecEmail", caption: "Technician Email" }
            ],
            bindingOptions: {
                dataSource: "Emaildatas"
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
                }
                else
                    $scope.SelectedMail = []
            },
        }

        $scope.SendEmail = function () {
            if ($scope.SelectedMail.length > 0) {
                $scope.SelectedMail = _.uniqWith($scope.SelectedMail, _.isEqual)
                var group = _.groupBy($scope.SelectedMail, '_id')
                var SendEmaildatas = []
                angular.forEach(group, function (value) {
                    SendEmaildatas.push({
                        _id: value[0]._id,
                        ServiceID: value[0].ServiceId,
                        CusName: value[0].CusName,
                        CusEmail: value[0].CusEmail,
                        TeamName: value.map(function (o) { return o.TeamFullName }).join(','),
                        Startsat: value[0].Startsat,
                        PestType: value[0].PestType,
                        ContactPerson: value[0].ContactPerson,
                        Location: value[0].Location,
                        TeamLead: value.map(function (o) { return o.TeamLead }).join(','),
                        TechnicianName: value.map(function (o) { return o.TechnicianName }).join(',')
                    })
                })
                var response = $http({
                    method: 'POST',
                    url: $rootScope.WebURL + "/scheduler/SendEmail",
                    data: { Array: SendEmaildatas }
                })
                response.then(function (GList) {
                    $scope.SelectedMail
                })
                $mdToast.show($mdToast.simple().textContent('Email Sent.').position('top center'));
                $mdDialog.cancel()
            }
            else
                $mdToast.show($mdToast.simple().textContent('Sorry No data Available.').position('top center'));

        }


        // For Whatsapp

        $scope.SendWhatsap = function (e) {

        }

        function SubmitForDrag(ID, Start, End, Team) {
            Start = new Date(Start)
            End = new Date(End)
            var ServiceOn = $filter('date')(new Date(Start), 'EEEE');
            var Assigned = null
            var team = []
            var TeamName = null
            var TeamMembersName = null
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === ID
            })[0];
            var diffTime = moment(new Date(new moment(new Date(item.Endsat).toTimeString(), 'HH:mm:ss'))).diff(moment(new Date(new moment(new Date(item.Startsat).toTimeString(), 'HH:mm:ss'))), 'minutes')
            End = new Date(moment(Start).add(diffTime, 'minutes'))
            if (item.Team_Id != null && item.Team_Id != undefined) {
                if (item.Team_Id.length == 1) {
                    Assigned = Team
                    team.push(Team)
                    // var Estimation = parseInt(item.JobOrdersdetails[0].EstimatedHoursRequired)
                    // if(Estimation!=NaN)
                    // End = new Date(moment(Start).add(Estimation, 'hour'))
                    // else
                    // End = new Date(moment(Start).add(1, 'hour'))
                    TeamName = getTeamName(Team)
                    TeamMembersName = getTeamMembers(Team)
                }
                else {
                    team = item.Team_Id
                    Assigned = item.AssignedTo
                    TeamName = item.TeamName
                    TeamMembersName = item.TeamMembersName
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/DragandDropUpdate",
                data: {
                    _id: ID,
                    AssignedTo: Assigned,
                    Team_Id: team,
                    Startsat: Start,
                    Endsat: End,
                    TeamName: TeamName,
                    TeamMembersName: TeamMembersName,
                    ServiceOn: ServiceOn,
                    IsDropped: true,
                    OldDate: item.Startsat,
                    OldEndDate: item.Endsat,
                    UpdatedBy: $rootScope.createdby
                },
            }).then(function (item) {
                $mdToast.show($mdToast.simple().textContent('Job Scheduled Successfully.').position('top center'));
                LoadSchedulerData()
            })
            try {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                        ServiceId: ID,
                        ServiceID: item.ServiceID,
                        CustomerName: item.customerdetails[0].CompanyName,
                        Status: item.Status,
                        PreviousStartsat: item.Startsat,
                        PreviousEndsat: item.Endsat,
                        Startsat: startDate,
                        Endsat: endDate,
                        PestType: item.PestType,
                        TeamName: item.teamdetails[0].TeamName,
                        TeamLead: item.teamdetails[0].TeamLead,
                        TeamMember: item.teamdetails[0].TeamMembers,
                        Acknowledged: null,
                        AcknowledgedBy: null,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true
                    },
                }).then(function (GList) {
                });
            } catch (error) {

            }
        }

        $scope.Refresh = function () {
            $("#scheduler").dxScheduler('instance').repaint();
            $("#NewDataGrid").dxDataGrid("instance").state({})
            // angular.forEach($scope.teamdatas, function (value) {
            //     $scope.Team.push(value.id)
            // });
            RefreshGrid()

            // LoadSchedulerData();
        };



        LoadTeam();
        var resourcesData = [{
            text: "Fixed Jobs",
            id: 1,
            color: "#1e93c2"
        }, {
            text: "Contract Jobs",
            id: 2,
            color: "#29824d"
        }, {
            text: "Urgent Jobs",
            id: 3,
            color: "#FF0000"
        },
        {
            text: "Extra Jobs",
            id: 4,
            color: "#ff9747"
        },
        {
            text: "Fixed Jobs Completd",
            id: 5,
            color: "#76b3d2"
        },
        {
            text: "Contract Jobs Completd",
            id: 6,
            color: "#8dd4aa"
        },
        {
            text: "Urgent Jobs Completd",
            id: 7,
            color: "#ea9292"
        },
        {
            text: "Employee Leave",
            id: 9,
            color: "#FF9800"
        },
        {
            text: "Scheduler Service",
            id: 10,
            color: "#1527a9"
        },
        {
            text: "Scheduler Service completed",
            id: 11,
            color: "#7682de"
        }];


        $scope.Zonedata = [
            { id: 1, text: "Team South" },
            { id: 2, text: "Team East" },
            { id: 3, text: "Team West Rosdy - WEST" },
            { id: 4, text: "Richard - SOUTH" }

        ]
        $scope.uFrom = new Date();
        $scope.uTo = new Date();

        $scope.getAppointmentColor = getAppointmentColor;

        function getAppointmentColor(resourceId) {
            return DevExpress.data.query(resourcesData)
                .filter("id", resourceId)
                .toArray()[0].color;
        }

        function getTeamName(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamName
        }
        function getTeamLead(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamLead
        }
        function getTeamMembers(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamMembers
        }

        $scope.getListdata = function (s, p) {
            var item = $scope.Extradatas.filter(function (item) {
                return item.priority === p && item.startDate >= s && item.startDate <= s
            })
            return item
        }
        var sccount = 0
        function BindScheduler() {
            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }
            $scope.schedulerOptions = {
                dataSource: $scope.calenderdata,
                views: ["timelineDay"],
                currentView: "timelineDay",
                currentDate: $scope.uFrom,
                // adaptivityEnabled: true,
                firstDayOfWeek: 1,
                startDayHour: 6,
                endDayHour: 24,
                maxAppointmentsPerCell: "unlimited",
                cellDuration: 30,
                crossScrollingEnabled: true,
                useDropDownViewSwitcher: false,
                showAllDayPanel: false,
                groups: ["priority"],
                resources: [{
                    fieldExpr: "ownerId",
                    allowMultiple: false,
                    deep: true,
                    dataSource: resourcesData,
                    label: "Owner",
                    useColorAsDefault: true
                }, {
                    fieldExpr: "priority",
                    allowMultiple: false,
                    dataSource: $scope.Teamdatass,
                    label: "Priority"
                }],
                dataCellTemplate: function (cellData, index, container) {
                    if ($scope.ViewOption != "week") {
                        var date = new Date(cellData.startDate).getHours() + ":" + (new Date(cellData.startDate).getMinutes() == 0 ? '00' : new Date(cellData.startDate).getMinutes())
                        return $("<div style='color:#afacac ; padding-left: 30%;font-size: 12px;'>").text(date);
                    }
                },

                onContentReady: function (e) {
                    $("#scheduler .dx-scrollable").dxScrollable({
                        showScrollbar: 'always'
                    });
                    var data = e.component.option("dataSource");
                    if (data) {
                        var Ad_hoc = data.reduce(function (acc, d) {
                            if (d.Status === "Completed" && d.JobType.toLowerCase() === "ad-hoc") {
                                return acc + d.BillingAmount;
                            }
                            return acc; // <-- keep the accumulator unchanged
                        }, 0);

                        var Contract = data.reduce(function (acc, d) {
                            if (
                                d.Status === "Completed" &&
                                (d.JobType.toLowerCase() === "contract" || d.JobType.toLowerCase() === "fixed")
                            ) {
                                return acc + d.BillingAmount;
                            }
                            return acc; // <-- keep the accumulator unchanged
                        }, 0);
                        var $header = e.element.find(".dx-scheduler-header");

                        // Remove existing heading if present
                        $header.find(".custom-heading").remove();

                        // Add the new updated one
                        $header.append(
                            '<div class="custom-heading">Contract - S$ ' + Contract + ' & Ad-Hoc - S$ ' + Ad_hoc + '</div>'
                        );
                    }
                },
                onAppointmentClick: function (e) {
                    e.cancel = true
                    if (e.appointmentData.ownerId == 10) {
                        $scope.ServiceUpdate = true
                        $scope.ServiceUpdateID = e.appointmentData.id
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.ServiceTeamId = e.appointmentData.priority
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        $scope.vm.dateBox1 = {
                            ResheduleSSTime: {
                                type: "time",
                                value: $scope.serviceStartTime,
                                onValueChanged: function (e) {
                                    $scope.serviceStartTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'Start'
                                //   }
                            },
                            ResheduleSETime: {
                                type: "time",
                                value: new Date($scope.ServiceEndTime),
                                onValueChanged: function (e) {
                                    $scope.vm.AvoidEndTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'end'
                                //   }
                            }
                        }
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'SubmitService',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function ACflexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    if (e.appointmentData.ownerId == 11) {
                        $scope.vm.ScheduleServiceId = e.appointmentData.id;
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        RefreshPhotos();
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'app/main/apps/accounts/flexischeduler/addcoments.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function ACflexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    else
                        OnAppointmentClick(e);
                },
                onOptionChanged: function (sdata) {
                    if (sdata.value == "week") {
                        $scope.ViewOption = "week"
                        $scope.WeekViewGrid = false
                        $scope.WeekDate = new Date()

                    }
                    else if (sdata.value == "timelineDay") {
                        $scope.WeekViewGrid = true
                        $scope.ViewOption = undefined
                        $scope.Datefilter()
                    }
                    else if (sdata.value instanceof Date) {
                        if ($scope.ViewOption == "week") {
                            $scope.WeekDate = new Date(sdata.value)
                        }
                        else {
                            $scope.vm.Date = new Date(sdata.value)
                            try {
                                vm.Date = new Date(sdata.value)
                            } catch (e) { }
                            $scope.Datefilter()
                        }
                    }
                    if ($scope.ViewOption != "week")
                        try {
                            if (sdata.element.context != undefined)
                                sdata.element.context.children[0].childNodes[0].childNodes[1].children[0].innerText = moment($scope.vm.Date).format('D MMM YYYY (ddd)');
                        } catch (e) { $scope.Refresh() }
                    //    sdata.component._header._navigator._$element[0].innerText = "sdfsd"
                },
                onCellClick: function (e) {
                },
                onAppointmentDblClick: function (e) {
                    $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);

                },
                appointmentTemplate: function (model, itemIndex, itemElement) {
                    var count = Math.floor((Math.random() * 10) + 1)
                    if (model.ClientInformed == false)
                        $scope.schedulerimage = "assets/images/logos/triangle.png"
                    else
                        $scope.schedulerimage = ""
                    var appointment = model
                    var Location = ""
                    var cssClass = "";
                    try {
                        if (appointment.text.includes('Service ID'))
                            Location = "Postal:- " + appointment.Location.substring(appointment.Location.lastIndexOf(" ") + 1)
                        if (appointment.ownerId == 10)
                            Location = "Address:- " + appointment.Description
                    } catch (error) {
                        Location = ""
                    }

                    var div = ""
                    var div1 = ""
                    if (model.Notes != undefined && model.Notes != null && model.Notes != "")
                        div = "&nbsp;<span class='dot1' style='background: #eebb4d;'></span>"

                    if (model.Message != undefined && model.Message != null && model.Message != "")
                        div1 = "&nbsp;<span class='dot1' style='background: #5f22af;'></span>"

                    if (model.IsUrgent == true || model.IsUrgent == "true")
                        cssClass = "blackcolor"
                    else
                        cssClass = "whiteColor"
                    //     return $("<div class='showtime-preview>" + 
                    //     "<div class="+cssClass+">" + appointment.text + "</div>" +

                    //     "<div class="+cssClass+"> Postal:-" + Location + "</div>" +
                    //     "<div class="+cssClass+">" +new Date(appointment.startDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+"-"+new Date(appointment.endDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+ "</div>" +
                    //    div+"</div>"); 
                    itemElement.append("<img src='" + $scope.schedulerimage + "' width='30' height='30' style='position: absolute; right: 0; top: 0;'/>");
                    itemElement.append("<div class='" + cssClass + "'>" + appointment.text + "</div>");
                    itemElement.append("<div class='" + cssClass + "'>" + Location + "</div>")
                    itemElement.append("<div class='" + cssClass + "'>" + new Date(appointment.startDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + "-" + new Date(appointment.endDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + div + div1 + "</div>" +
                        "</div>");

                },
                onAppointmentRendered: function (e) {
                    var appointment = e.appointmentElement;
                    var draggableAppointment = appointment.dxDraggable("instance");
                    draggableAppointment.option("area", "body");
                    e.appointmentElement.on("dxdragstart", function (evt) {
                        appointmentData = $(evt.currentTarget).data("dxItemData");
                        e.element.find(".dx-scrollable-content").css("overflow", "visible");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "visible");
                    });
                    e.appointmentElement.on("dxdragend", function (evt) {
                        e.element.find(".dx-scrollable-content").css("overflow", "hidden");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "hidden");
                    });
                },
                onAppointmentUpdating: function (data) {

                    data.cancel = true;
                    return;
                },

                onAppointmentUpdated: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully.').position('top center'));
                    // showToast("Updated Successfully", ' ', "info");
                },
                onAppointmentDeleted: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                    // showToast("Deleted Successfully", "", "warning");
                },

                bindingOptions: {
                    'dataSource': 'calenderdata',
                    "resources[1].dataSource": 'Teamdatass'

                },
                // height: $scope.Team.length>5?600: ""
            };

            $scope.vm.PreviewSpinner = false;
        }
        $timeout(function () {

            LoadSchedulerData()

        }, 3000);

        $scope.WeekViewGrid = true
        var scheduler;
        var appointmentData;


        vm.dataGridSalesOrderNew = {
            onContentReady: function (e) {
                scheduler = e.component;
                $(".dx-scheduler-date-table-cell").on("dxdrop", function (ex) {
                    $scope.DragCount++
                    if ($scope.DragCount == 1) {
                        var cellData = $(ex.target).data("dxCellData");
                        var start = cellData.startDate.getTime();
                        var end = cellData.endDate.getTime();
                        var team = cellData.groups.priority
                        var text = $(ex.draggingElement).data("text");

                    }
                });
            },

            rowTemplate: function (container, item) {
                var data = item.data;
                var result = $("<tbody class='employee dx-row " + ((item.rowIndex % 2) ? 'dx-row-alt' : '') + "'>");
                if ((item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1) <= $scope.NewSheduledJobs.length) {

                    $("<tr class='main-row'>").appendTo(result);
                    $("<td align='center'style=' border: 1px solid #ddd'>").text(item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1).appendTo(result);
                    if (data.AccountsNotes != undefined && data.AccountsNotes != null && data.AccountsNotes != "")
                        $("<td align='center' style=' border: 1px solid #ddd ; color:orange'>").text(data.ServiceID).appendTo(result);
                    else
                        $("<td align='center' style=' border: 1px solid #ddd ; color:blue'>").text(data.ServiceID).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.TeamName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SiteName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SMobile).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.Location).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(new Date(data.Startsat).toLocaleDateString('en-GB')).appendTo(result);
                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PostalZone).appendTo(result);
                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PestCode).appendTo(result);
                    var Prefred = ""
                    var Avoid = ""
                    if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                        Prefred = new Date(data.PreferredStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.PreferredEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                        Avoid = new Date(data.AvoidStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.AvoidEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    $("<td  align='center' style=' border: 1px solid #ddd;color:green'>").text(Prefred).append('<p style="color:red"> ' + Avoid + "</p>").append('<p style="color:black"> ' + data.PreferredTime + "</p>").appendTo(result);
                    $("</tr>").appendTo(result);
                }
                container.append(result);
            },
            dataSource: $scope.DragScheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            columnAutoWidth: false,
            wordWrapEnabled: true,
            width: "100%",
            keyExpr: "_id",
            paging: {
                enabled: false,
                pageSize: 10
            },
            // pager: {
            //     showPageSizeSelector: true,
            //     allowedPageSizes: [5, 10, 20,],
            //     showInfo: true
            // },
            sorting: {
                mode: "single"
            },
            // selection: {
            //     mode: "single",
            //     showCheckBoxesMode: 'onClick',
            // },
            searchPanel: {
                visible: false,
                width: 320,
                placeholder: "Search..."
            },
            // filterRow: {
            //     visible: true,
            //     applyFilter: "onClick"
            // },
            allowColumnResizing: true,
            onRowPrepared: function (rowInfo) {
                if (rowInfo.rowType != 'data')
                    return;
                rowInfo.rowElement
                    .addClass('myRow')
                    .data('keyValue', rowInfo.key);
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "ServiceID", caption: "Service Id", alignment: 'center', width: 110 },
                { dataField: "TeamName", caption: "Team Name", alignment: 'center' },
                { dataField: "SiteName", caption: "Customer Name", alignment: 'center' },
                { dataField: "Mobile", caption: "Contact No.", alignment: 'center' },
                { dataField: "Location", caption: "Site Address", alignment: 'center' },
                { dataField: "Startsat", caption: "Scheduled Date", alignment: 'center', width: 110, dataType: "date", format: 'dd/MM/yyyy', sortOrder: 'asc' },
                // { dataField: "JobType", caption: "Job Type ", width: 110 },
                { dataField: "PostalZone", caption: "Zone", alignment: 'center', width: 110 },
                { dataField: "PestCode", caption: "Pest Types", alignment: 'center' },
                { dataField: "DateTimeofTreatment", caption: "Preferred Time", alignment: 'center', width: 150 },
            ],

            bindingOptions: {
                dataSource: "DragScheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",

        }
        var initialTop,
            initialLeft,
            initialPointerY,
            initialPointerX,
            draggedColor = "transparent";

        var dragStarted = function () {
            $(this).css("position", "fixed");
            $(this).css("z-index", 50000);
            $(this).find(".dx-scrollable-content").css("overflow", "visible");
            $(this).find(".dx-scheduler-work-space").css("overflow", "visible");

            $(this).css("background-color", draggedColor);
            initialTop = parseInt($(this).css("top"));
            initialLeft = parseInt($(this).css("left"));
            initialPointerY = arguments[0].clientY;
            initialPointerX = arguments[0].clientX;
        };
        var dragged = function () {
            $(this).css("top", initialTop + arguments[0].clientY - initialPointerY);
            $(this).css("left", initialLeft + arguments[0].clientX - initialPointerX);
        };
        var dragStopped = function () {
            $scope.DragID = this.id.split('_')[1]
            $scope.DragCount = 0
            if (this.offsetTop > 242 && this.offsetTop < 558)
                $(this).css("background-color", "green");
            else {
                $(this).css("background-color", "#cbe5e6");
                // $(this).fadeOut()
                // $("#NewDataGrid").dxDataGrid("instance").state({})
            }
        };
        $scope.SortSDate = true
        $scope.SortZone = true

        $scope.getSortValues = function (value) {
            $scope.SelectedMember = null
            if (value == "Sort by Scheduler Date") {
                if ($scope.SortSDate == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "Startsat")
                    $scope.SortSDate = false

                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "Startsat").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    $scope.SortSDate = true
                }
            }
            else {
                if ($scope.SortZone == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "PostalZone")
                    $scope.SortZone = false
                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "PostalZone").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    // $scope.DragScheduledJobs = (_.sortBy($scope.DragScheduledJobs, "PostalZone")).reverse() 
                    $scope.SortZone = true
                }
            }
        }

        $scope.SortValues = [
            { name: "Sort by Scheduler Date" },
            { name: "Sort by Zone" }
        ]

        // $scope.uShowAdhoc=function(value){
        //     $scope.CWCDatas=[]
        //     if(value){
        //         $http({
        //             method:'POST',
        //             url:'https://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //             data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //         }).then(function(Glist){
        //             var data = Glist.data.data
        //            var item=data.filter(function(item){
        //                return item.Status==='New' || item.Status==='On Going'
        //            })
        //            _.each(item,function(ite){
        //             ite.IsActive = ""
        //            })
        //             $scope.CWCDatas=item
        //             $scope.getSchedulerdatas($scope.TabStatus)
        //         })
        //     }
        //     else
        //     {
        //         GetCWCdatas()
        //     }
        // }

        $scope.GetCWCdatas = GetCWCdatas

        function GetCWCdatas() {
            $scope.StDate.setHours(0, 0, 0, 0)
            $scope.EnDate.setHours(23, 59, 59, 999)
            var array = []
            angular.forEach($scope.teamdatas, function (value) {
                array.push(value.id)
            })
            var response1 = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.StDate,
                    End_Date: $scope.EnDate,
                    Team: array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response1.then(function (GList) {
                var FlexiScheduler = GList.data.data
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.StDate,
                        End_Date: $scope.EnDate,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Status: null,
                        Team_Id: null
                    },
                });
                response.then(function (GList1) {
                    $http({
                        url: $rootScope.WebURL + "/scheduler/getAllOutstandingJobs",
                        method: "POST",
                        data: {
                            Client_Id: $rootScope.Client_Id,
                        },
                    }).then(function (List) {
                        var progerss = List.data.data
                        var data = GList1.data.data;
                        var item = data.filter(function (item) {
                            return item.Status != "Completed" && item.Status != "Cancelled" && item.Status != "Outstanding" && item.VerifiedBy == false
                        })
                        $scope.NewSheduledJobs = item
                        $scope.NewSheduledJobs = $scope.NewSheduledJobs.concat(progerss)
                        var newArray = []
                        if (newArray.length > 0)
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs.concat(newArray)
                        else
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs

                        if ($("#NewDataGrid").dxDataGrid("instance") != undefined)
                            $("#NewDataGrid").dxDataGrid("instance").endCustomLoading()
                        angular.forEach($scope.DragScheduledJobs, function (value) {
                            // var item = FlexiScheduler.filter(function (item) {
                            //     return item._id === value._id
                            // })[0]
                            // if (item != undefined) {
                            //     value.PostalZone = item.PostalZone
                            // }

                            var pest = []
                            var PestArray = []
                            var NewFrequency = value.Frequency.split('||')
                            var TreatmentMethod = []
                            NewFrequency.forEach(function (val) {
                                var iittem = val.split('~')
                                TreatmentMethod.push({
                                    Frequency: iittem[0],
                                    PestName: iittem[1],
                                    Treatment: iittem[2]
                                })

                            })
                            var Frequen = _.groupBy(TreatmentMethod, "Frequency")
                            var FreqString = []
                            if (Object.keys(Frequen).length) {
                                _.each(Frequen, function (Fre, key) {
                                    var data = []
                                    _.each(Fre, function (iitem) {
                                        data.push(iitem.PestName)
                                    })
                                    var PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (data.includes(pestt.PestName)) })
                                    FreqString.push(PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',') + " - " + key.replace(/ *\([^)]*\) */g, ""))

                                })
                            }

                            value.PestCode = FreqString.map(function (o) { return o }).join('; ')

                            try {
                                if (value.customerServicedetails.length > 0) {
                                    value.CustomerName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    value.SMobile = value.customerServicedetails[0].sMobile
                                    if (value.customerServicedetails[0].SName != undefined && value.customerServicedetails[0].SName != null && value.customerServicedetails[0].SName != "")
                                        value.SiteName = value.customerServicedetails[0].SName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'

                                    if (value.customerServicedetails[0].sName != undefined && value.customerServicedetails[0].sName != null && value.customerServicedetails[0].sName != "")
                                        value.SiteName = value.customerServicedetails[0].sName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    else
                                        value.SiteName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'


                                }
                                else {
                                    value.CustomerName = value.customerdetails[0].CompanyName
                                    value.SMobile = ""
                                    value.SiteName = value.customerdetails[0].CompanyName + ' - (' + customerdetails[0].ContactPerson + ')'
                                }
                            } catch (error) {
                                value.SiteName = value.customerdetails[0].CompanyName
                            }

                            try {
                                value.PostalZone = value.zonepostalcodesdetails[0].Zone
                            } catch (error) {
                                value.PostalZone = ""
                            }


                        })
                    })
                })
            })
        }
        function OnAppointmentClick(e) {

            e.cancel = true;
            var item = $scope.TotalDatas.filter(function (item) {
                return item.id === e.appointmentData.id && item.Team_Id === e.appointmentData.Team_Id
            })[0]
            var data = item
            if (data.TeamMembers == undefined) {
                data.TeamMembers = getTeamMembers(data.Team_Id)
            }
            $scope.TeamMembers = data.TeamMembers
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data.id
            $scope.StartDate = data.startDate
            $scope.EndDate = data.endDate
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.CustomerName
            $scope.vm.DServiceAddres = data.ServiceAddres
            $scope.vm.DClientContactName = data.ClientContactName
            $scope.vm.Duplicate = data.Duplicate
            $scope.vm.DuplicateRemarks = data.DuplicateRemarks
            $scope.vm.PaymentTerms = data.PaymentMode
            $scope.vm.DSiteContactName = data.SiteContactName
            $scope.vm.DClientEmail = data.ClientEmail
            $scope.vm.DSiteContactNumber = data.SiteContactNumber
            $scope.vm.DCoverageArea = data.CoverageArea
            $scope.vm.DSalesOrderNo = data.SalesOrderNo
            $scope.vm.TotalTeam = data.TotalTeam
            $scope.vm.ManHour = data.ManHour
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            if (data.TeamName == undefined) {
                data.TeamName = getTeamName(data.Team_Id)
            }
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = data.startDate
            $scope.vm.ServiceEndDate = data.endDate
            $scope.vm.PreferedTime = data.PreferedTime
            $scope.vm.jobdata = data.SalesOrder_Id
            $scope.vm.Customer_Id = data.Customer_id
            $scope.vm.ScedulId = data.id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.Notes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob(data.SalesOrder_Id)
            getCustomer(data.Customer_id)
            getContract(data.Contract_Id)
            getSalesOrder(data.SalesOrder_Id)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }

        function DragTableClick(e, SId) {
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === SId;
            })[0];
            var data = item
            $scope.TeamMembers = data.TeamMembersName
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data._id
            $scope.StartDate = new Date(data.Startsat)
            $scope.EndDate = new Date(data.Endsat)
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.customerdetails[0].CompanyName
            $scope.vm.DServiceAddres = data.Location
            $scope.vm.DClientContactName = data.customerdetails[0].ContactPerson
            $scope.vm.DSiteContactName = data.customerServicedetails[0].sContactPerson
            $scope.vm.DClientEmail = data.customerdetails[0].Email
            $scope.vm.DSiteContactNumber = data.customerServicedetails[0].sMobile
            $scope.vm.DCoverageArea = data.JobOrdersdetails[0].CoverageArea
            $scope.vm.DSalesOrderNo = data.JobOrdersdetails[0].SalesOrderNo
            $scope.vm.TotalTeam = data.TeamName
            $scope.vm.ManHour = data.JobOrdersdetails[0].EstimatedHoursRequired
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = new Date(data.Startsat)
            $scope.vm.ServiceEndDate = new Date(data.Endsat)
            $scope.vm.PreferedTime = data.PreferredTime
            $scope.vm.jobdata = data.JobOrdersdetails[0]._id
            $scope.vm.Customer_Id = data.customerdetails[0]._id
            $scope.vm.ScedulId = data._id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.AccountsNotes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob($scope.vm.jobdata)
            getCustomer($scope.vm.Customer_Id)
            getContract(data.JobOrdersdetails[0].ContractNo)
            getSalesOrder($scope.vm.jobdata)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }


        $scope.getAdhocJobs = function () {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + '/salesOrder/getAdHocjob',
                data: { Start_Date: null, Client_Id: $rootScope.Client_Id }
            }).then(function (Glist) {
                var data = Glist.data.data
                var item = data.filter(function (item) {
                    return item.Status === 'New' || item.Status === 'On Going'
                })
                _.each(item, function (ite) {
                    ite.IsActive = ""
                })
                $scope.NewSheduledJobs = item
            })
        }



        var currentTarget

        $("#appointmentContextMenu").dxContextMenu({
            target: ".dx-scheduler-appointment",
            items: [
                { text: "Duplicate Job...", icon: "edit" },
                { text: "Cancel...", icon: "trash" },
                { text: "Client Informed...", icon: "todo" },
                { text: "Client Not Informed...", icon: "close" }

            ],
            onItemClick: function (e) {
                var data = $(currentTarget).parents(".dx-item").data("dxItemData");
                if (data.ownerId != 9 && data.ownerId != 10) {
                    if (e.itemIndex == 0) {
                        clonejob(e, data)
                    }
                    else if (e.itemIndex == 1) {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to cancel the appointment?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                try {
                                    var item = data
                                    var ServiceOn = $filter('date')(new Date(item.startDate), 'EEEE');
                                    $scope.CompanyName = item.CustomerName;
                                    $scope.jobdata = item.SalesOrder_Id;
                                    $scope.CustomerID = item.Customer_id;
                                    $scope.AssignedTo = item.priority;
                                    $scope.Frequency = item.Frequency;
                                    $scope.Types = item.JobType;
                                    $scope.ServiceOn = ServiceOn;
                                    $scope.PestType = item.PestType;
                                    $scope.ContractOrder = item.Contract_Id;
                                    $scope.ServiceID = item.ServiceID;
                                    $scope.Status = item.Status;
                                    $scope.ServiceStartAt = new Date(item.startDate);
                                    $scope.ServiceEndAt = new Date(item.endDate);
                                } catch (e) { }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                                    data: {
                                        _id: data.id,
                                        Status: "Cancelled",
                                        CancelRemarks: "Cancelled from Daily Scheduler",
                                        SenderEmailAddress: "",
                                        CompanyName: $scope.CompanyName,
                                        ScheduleDate: $scope.ServiceStartAt,
                                        UpdatedBy: $rootScope.createdby
                                    },
                                });
                                response.then(function (GList) {
                                    var lresponse = $http({
                                        method: "POST",
                                        url: $rootScope.WebURL + "/schedulelog/add",
                                        data: {
                                            Client_Id: $rootScope.Client_Id,
                                            JobsOrders: $scope.jobdata,
                                            Customer: $scope.CustomerID,
                                            AssignedTo: $scope.AssignedTo,
                                            Frequency: $scope.Frequency,
                                            ServiceOn: $scope.ServiceOn,
                                            Types: $scope.Types,
                                            Status: $scope.Status,
                                            Startsat: $scope.ServiceStartAt,
                                            Endsat: $scope.ServiceEndAt,
                                            PestType: $scope.PestType,
                                            ContractOrder: $scope.ContractOrder,
                                            ServiceID: $scope.ServiceID,
                                            CancelRemarks: "Cancelled from Daily Scheduler",
                                            CreatedBy: $rootScope.createdby,
                                            IsActive: true,
                                        },
                                    });
                                    lresponse.then(function (GList) {
                                        RefreshGrid();
                                        $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                                    })
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 2) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: true
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 3) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer has not confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: false
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                }
                if (data.ownerId == 10) {
                    if (e.itemIndex != 1) {
                        $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                    }
                    else {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the Service?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/schedulerservice/delete",
                                    data: {
                                        _id: data.id,
                                        Client_Id: $rootScope.Client_Id
                                    }
                                }).then(function (List) {
                                    RefreshGrid()
                                    $mdToast.show($mdToast.simple().textContent('Service deleted successfully').position('top center'));
                                })
                            }
                        })
                    }
                }
                // else {
                //     $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                // }
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        function clonejob(e, data) {
            $scope.vm.Title = 'Clone the Job'
            $scope.Cloneschedule = data
            $scope.vm.RescheduleSpinner = false

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Selectedschedule.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            $scope.vm.ResheduleSSTime = data.startDate
            $scope.vm.ResheduleSETime = data.endDate
            $scope.vm.AssignedTo = data.priority
            $scope.vm.ResheduleSRemarks = data.SpecialRemarks
            $scope.Pestdatas = data.MultiFrequency

            $scope.vm.dateBox = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.vm.ResheduleSSTime,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSSTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date($scope.vm.ResheduleSETime),
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSETime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
        }

        $scope.SubmitClone = function () {
            var value = $scope.Cloneschedule
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/uniqueschedulerByID",
                data: {
                    _id: value.id,
                    Client_Id: $rootScope.Client_Id
                }
            }).then(function (List) {
                var value = List.data.data[0]
                var data = ""
                $scope.vm.CPestType.forEach(function (item) {
                    if (data == "")
                        data = item.Frequency + "~" + item.PestType + "~" + item.Treatment
                    else
                        data = data + "||" + item.Frequency + "~" + item.PestType + "~" + item.Treatment
                })
                var ServiceOn = $filter('date')(new Date($scope.vm.ResheduleSFrom), 'EEEE');
                var currentDate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSSTime))
                var enddate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSETime))

                var serviceArray = [{
                    JobsOrders: (value.JobsOrders),
                    AssignedTo: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    Frequency: data,
                    ServiceOn: ServiceOn,
                    Types: value.Types,
                    Status: "Yet to Start",
                    Customer: (value.Customer),
                    Startsat: currentDate,
                    Endsat: enddate,
                    CreatedBy: $rootScope.createdBy,
                    PestType: $scope.vm.CPestType.map(function (o) { return o.PestType }).join(','),
                    ContractOrder: value.ContractOrder,
                    JobType: value.JobType,
                    ServiceReportNo: value.ServiceReportNo,
                    BillingAmount: value.BillingAmount,
                    Billable: value.Billable,
                    JobContinues: value.JobContinues,
                    CollectPayment: value.CollectPayment,
                    Location: value.Location,
                    LatLong: value.LatLong,
                    Client_Id: $rootScope.Client_Id,
                    CustomerService_Id: (value.CustomerService_Id),
                    ContactPerson: value.ContactPerson,
                    ContactNumber: value.ContactNumber,
                    Vehicle: value.Vehicle,
                    ScheduleType: value.ScheduleType,
                    SpecialRemark: $scope.vm.ResheduleSRemarks,
                    PreferredTime: value.PreferredTime,
                    PreferredStartTime: value.PreferredStartTime,
                    PreferredEndTime: value.PreferredEndTime,
                    AvoidStartTime: value.AvoidStartTime,
                    AvoidEndTime: value.AvoidEndTime,
                    Team_Id: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    TeamName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamName }).join(','),
                    TeamMembersName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamMembers }).join(','),

                }]
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/add",
                    data: {
                        ServiceArray: serviceArray
                    }
                }).then(function (List) {
                    $mdDialog.cancel()
                    $mdToast.show($mdToast.simple().textContent('Successfully Added Service Jobs').position('top center'));
                    RefreshGrid();
                })
            })
        }


        $("#emptyCellContextMenu").dxContextMenu({
            target: ".dx-scheduler-date-table-cell",
            items: [
                { text: "Add Appointment...", icon: "add" }
            ],
            onItemClick: function (e) {
                var data = $(currentTarget).data("dxCellData");
                console.log(data);
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        $scope.RefreshSchedule = function () {

            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }

            LoadSchedulerData();
        }
        $scope.CloseDialog = function () {
            $mdDialog.hide();
        }

        // $scope.Team = null;
        $scope.Datefilter = function () {
            LoadSchedulerData()
        }

        function LoadSchedulerData() {
            var array = [];
            $scope.Teamdatass = []
            angular.element("#scheduler").dxScheduler('instance').option("currentDate", vm.Date)
            if ($scope.Team == null || $scope.Team == undefined || $scope.Team.length == 0) {
                angular.forEach($scope.teamdatas, function (value) {
                    array.push(value.id)
                })
                $scope.Team = null;
            }
            else {
                angular.forEach($scope.Team, function (value) {
                    var item = $scope.teamdatas.filter(function (item) {
                        return item.id == value
                    })
                    $scope.Teamdatass.push(item)
                    $scope.Teamdatass = _.flattenDeep($scope.Teamdatass)
                    $scope.Teamdatass = _.uniq($scope.Teamdatass)
                })
            }
            $scope.vm.PreviewSpinner = true;
            $scope.uFrom = new Date(vm.Date);
            $scope.uTo = new Date(vm.Date);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            $http({
                url: $rootScope.WebURL + "/calendar/datefilter",
                method: "POST",
                data: {
                    FilterStart_Date: $scope.uFrom,
                    FilterEnd_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,

                },
            }).then(function (List) {
                $scope.vm.Holiday = ""
                var item = List.data.data.filter(function (item) {
                    return item.EventType === "Holiday"
                })
                if (item.length > 0)
                    $scope.vm.Holiday = item.map(function (o) { return o.EventTitle }).join(',')
            })
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,
                    Customer_Id: null,
                    Team_Id: null
                },
            });
            response.then(function (GList) {
                $scope.AllSchedulerDatas = GList.data.data;
            })

            var response = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Team: $scope.Team || array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                array = [];
                $scope.AutoTeam = false;
                $scope.AllScheduleDatas = GList.data.data;
                $scope.Uniqueschedulerdatas = GList.data.data;
                $scope.AllScheduleDatas = _.uniqWith($scope.AllScheduleDatas, _.isEqual)
                $scope.Uniqueschedulerdatas = _.uniqWith($scope.Uniqueschedulerdatas, _.isEqual)
                var datapush = [];
                angular.forEach($scope.Uniqueschedulerdatas, function (value) {
                    try {
                        var ownerId = [1];
                        if (value.JobType == "Contract") {
                            ownerId = [2]
                            if (value.Status == 'Completed') ownerId = [6]
                        } else if (value.JobType == "Ad-hoc") {
                            ownerId = [3]
                            if (value.Status == 'Completed') ownerId = [7]
                        }
                        else if (value.JobType == "Fixed") {
                            ownerId = [1]
                            if (value.Status == 'Completed') ownerId = [5]
                        }
                        var EndTime = CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat));
                        if (new Date(EndTime).getHours() == 0) {
                            EndTime = new Date(new Date(EndTime).setDate(new Date(EndTime).getDate() + 1))
                            EndTime.setHours(new Date(EndTime).getHours(), new Date(EndTime).getMinutes() - 1, 0, 0)
                        }
                        var Duration = GetDuration(value.Startsat, EndTime);
                        if (value.Status != "Cancelled" && value.Status != "Outstanding" && value.VerifiedBy == true) {
                            if (value.SiteName == null || value.SiteName == "" || value.SiteName == undefined)
                                value.SiteName = value.CustomerName
                            datapush.push({
                                text: value.SiteName + '\n' + 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.Startsat),
                                endDate: new Date(EndTime),
                                id: value._id,
                                Customer_id: value.Customer_id,
                                priority: value.Team_Id,
                                TimeInterval: moment(new Date(EndTime)).diff(moment(new Date(value.Startsat)), 'seconds'),
                                Location: value.Location,
                                BillingAmount: value.BillingAmount,
                                PestType: value.PestType,
                                Team_Id: value.Team_Id,
                                Frequency: value.Frequency,
                                MultiFrequency: value.MultiFrequency,
                                CustomerEmail: value.CustomerEmail,
                                TechnicianEmail: value.TechnicianEmail,
                                JobType: value.JobType,
                                Duplicate: value.Duplicate,
                                DuplicateRemarks: value.DuplicateRemarks,
                                Types: value.Types,
                                Notes: value.AccountsNotes,
                                ClientInformed: value.ClientInformed,
                                TeamName: (value.TeamName),
                                ManHour: value.ManHour,
                                Status: value.Status,
                                TeamLead: getTeamLead(value.Team_Id),
                                //  TeamName: getTeamName(value.Team_Id),
                                TeamMembers: getTeamMembers(value.Team_Id),
                                Zone: value.PostalZone,
                                ownerId: ownerId,
                                FLength: true,
                                CustomerName: value.CustomerName,
                                SalesOrderNo: value.SalesOrderNo,
                                Contract: value.ContractNo,
                                ServiceAddres: value.Location,
                                ServiceID: value.ServiceID,
                                ScheduledBy: value.CreatedBy,
                                CoverageArea: value.CoverageArea,
                                ClientContactName: value.ClientContactName,
                                ClientEmail: value.ClientEmail,
                                SiteContactName: value.SiteContactName,
                                SiteContactNumber: value.SiteContactNumber,
                                PreferedTime: value.PreferredTime,
                                PreferredStartTime: value.PreferredStartTime,
                                PreferredEndTime: value.PreferredEndTime,
                                AvoidStartTime: value.AvoidStartTime,
                                AvoidEndTime: value.AvoidEndTime,
                                SpecialRemark: value.SpecialRemark,
                                SalesOrder_Id: value.SalesOrder_Id,
                                Contract_Id: value.Contract_Id,
                                Message: value.Message,
                                IsUrgent: value.IsUrgent,
                                PaymentMode: value.PaymentMode
                            });
                        }
                    } catch (error) {
                    }
                });
                $scope.TotalDatas = datapush
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.startDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.endDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.TimeInterval);
                });
                datapush = datapush.reverse()
                $scope.Todaydatas = datapush
                GetCWCdatas()


                $scope.calenderdata = $scope.Todaydatas
                // $scope.calenderdata = PopupArray;
                // $scope.Extradatas = ExtraArray
                $scope.vm.PreviewSpinner = false;
                var response = $http({
                    url: $rootScope.WebURL + "/leaveentitlement/getByDate",
                    method: "POST",
                    data: {
                        StartDate: $scope.uFrom,
                        EndDate: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var Edata = []
                    angular.forEach(GList.data.data, function (value) {
                        var leavedata = $scope.calenderdata.filter(function (o) {
                            return o.id === value._id
                        })
                        if (leavedata.length == 0) {
                            if ($scope.uFrom.getDate() === new Date(value.StartDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else if ($scope.uFrom.getDate() === new Date(value.EndDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else {
                                if ($scope.uFrom.getDay() != 6) {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(23, 59, 59, 999)

                                }
                                else {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }

                            Edata.push({
                                text: value.Type + " " + moment(value.StartDate).format('DD-MMM-YYYY') + " - " + moment(value.EndDate).format('DD-MMM-YYYY'),
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.TeamID,
                                ownerId: [9],
                                FLength: false,
                            })
                        }
                    })
                    $scope.calenderdata = $scope.calenderdata.concat(Edata)
                    var response = $http({
                        url: $rootScope.WebURL + "/schedulerservice/datefilter",
                        method: "POST",
                        data: {
                            Start_Date: $scope.uFrom,
                            End_Date: $scope.uTo,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (gList) {
                        var Sdata = []
                        angular.forEach(gList.data.data, function (value) {
                            Sdata.push({
                                text: value.ServiceName,
                                Location: value.Description,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.Team_Id,
                                ownerId: value.Status == "Completed" ? [11] : [10],
                                FLength: false,
                            })
                        })
                        $scope.calenderdata = $scope.calenderdata.concat(Sdata)

                    })
                })
            });

        }

        function getLastCompletedJob(id) {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + "/scheduler/getlast",
                data: { JobId: id }
            }).then(function (List) {
                try {
                    $scope.vm.LastCompletedDate = new Date(List.data.data[0].Startsat)
                }
                catch (e) {
                    $scope.vm.LastCompletedDate = ""
                }

                try {
                    $scope.vm.LastCompletedBy = List.data.data[0].tabletschedulerrecord[0].CreatedBy.capitalize();
                } catch (error) {
                    $scope.vm.LastCompletedBy = "";
                }
            })
        }
        function getContract(Contract_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getById",
                data: { _id: Contract_Id }
            }).then(function (List) {
                var Contractdata = List.data.data
            })
        }
        function getSalesOrder(SalesOrder_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getById",
                data: { _id: SalesOrder_Id }
            }).then(function (List) {
                var SalesOrderdata = List.data.data
                $scope.vm.SalesPerson = SalesOrderdata[0].employeedetails[0].EmployeeName
                $scope.vm.OrderType = SalesOrderdata[0].OrderType
                if ($scope.vm.OrderType === "Contract") {
                    $scope.vm.ContractStart = SalesOrderdata[0].ServiceStartDate
                    $scope.vm.ContractEnd = SalesOrderdata[0].ServiceEndDate
                } else
                    $scope.vm.Occurence = SalesOrderdata[0].EnqRef
            })
        }
        function getCustomer(id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/get",
                data: { id: id }
            }).then(function (List) {
                var Customerdata = List.data.data
                $scope.vm.MarketSegment = Customerdata.MarketSection
            })
        }

        function GetDuration(StartTime, EndTime) {
            var today = new Date(StartTime);
            var Christmas = new Date(EndTime);
            var diffMs = (Christmas - today); // milliseconds between now & Christmas
            var diffDays = Math.floor(diffMs / 86400000); // days
            var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
            var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

            return diffMins + ' mins';
        }
        function CombineDateAndTime(date, time) {
            var timeString = time.getHours() + ':' + time.getMinutes() + ':00:00';
            var year = date.getFullYear();
            var month = date.getMonth() + 1; // Jan is 0, dec is 11
            var day = date.getDate();
            var dateString = '' + year + '-' + month + '-' + day;
            var combined = new Date(dateString + ' ' + timeString);
            return combined;
        };

        $scope.UpdateNewSchedule = function () {
            var _id = $scope.vm.ID
            var startDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceStartDate)
            var endDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceEndDate)
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/updateinflexi",
                method: "PUT",
                data: {
                    _id: _id,
                    Startsat: startDate,
                    Endsat: endDate,
                    Notes: $scope.vm.Notes,
                    Remark: $scope.vm.SpecialRemark,
                    Message: $scope.vm.Remarks
                },
            });
            response.then(function (GList) {
                LoadSchedulerData();
                $mdDialog.cancel()
            });
        }

        function UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam) {
            var TeamName = ""
            var TeamMembersName = ""
            if ($scope.AllSchedulerDatas == undefined) {
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.uFrom,
                        End_Date: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Team_Id: null
                    },
                });
                response.then(function (Glist) {
                    $scope.AllSchedulerDatas = Glist.data.data;
                    UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam)
                })
            }
            else {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === _id
                })[0];
                // if(Notes==null || Notes=="" || Notes==undefined )
                //  Notes = item.AccountsNotes

                if (item.Team_Id.length == 1) {
                    TeamName = getTeamName(Team_Id)
                    TeamMembersName = getTeamMembers(Team_Id)
                    var response = $http({
                        url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                        method: "PUT",
                        data: {
                            _id: _id,
                            Startsat: startDate,
                            Endsat: endDate,
                            AssignedTo: Team_Id,
                            Team_Id: [Team_Id],
                            TeamName: TeamName,
                            Remark: $scope.vm.SpecialRemark,
                            TeamMembersName: TeamMembersName,
                        },
                    });
                    response.then(function (GList) {
                        LoadSchedulerData();
                    });
                }
                else {
                    if (OldTeam != null) {
                        item.Team_Id[item.Team_Id.indexOf(OldTeam)] = Team_Id
                        item.Team_Id = _.uniq(item.Team_Id)
                        var TeamName = "";
                        var TeamMembersName = ""

                        angular.forEach(item.Team_Id, function (value) {
                            if (TeamName != "") {
                                TeamName = TeamName + "," + getTeamName(value)
                                TeamMembersName = TeamMembersName + "," + getTeamMembers(value)
                            }
                            else {
                                TeamName = getTeamName(value)
                                TeamMembersName = getTeamMembers(value)
                            }
                        })
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();

                        });
                    }
                    else {
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: item.TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: item.TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();
                        });
                    }
                }
                try {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/schedulerNotification/add",
                        data: {
                            ServiceId: _id,
                            ServiceID: item.ServiceID,
                            CustomerName: item.customerdetails[0].CompanyName,
                            Status: item.Status,
                            PreviousStartsat: item.Startsat,
                            PreviousEndsat: item.Endsat,
                            Startsat: startDate,
                            Endsat: endDate,
                            PestType: item.PestType,
                            TeamName: item.teamdetails[0].TeamName,
                            TeamLead: item.teamdetails[0].TeamLead,
                            TeamMember: item.teamdetails[0].TeamMembers,
                            Acknowledged: null,
                            AcknowledgedBy: null,
                            CreatedBy: $rootScope.createdby,
                            IsActive: true
                        },
                    }).then(function (GList) {
                    });
                } catch (error) {

                }
            }
        }


        function DeleteSchedule(_id) {
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                method: "PUT",
                data: {
                    _id: _id,
                    Status: "Cancelled",
                    CancelRemarks: "Deleted in custom scheduler",
                    UpdatedBy: $rootScope.CreatedBy,
                },
            });
            response.then(function (GList) {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                // showToast("Deleted Successfully", "", "warning");
                LoadSchedulerData();
            });
        }

        $scope.commentSubmit = function () {
            $scope.File_id = $scope.vm.ScedulId;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulercomment/add",
                data: {
                    SchedulerID: $scope.vm.ScedulId,
                    SalesOrderID: $scope.vm.jobdata,
                    CustomerID: $scope.vm.Customer_Id,
                    TableName: 'Scheduler',
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Addcomments,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                Refreshcomment();
                $scope.vm.Addcomments = '';
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function Refreshcomment() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulercomment/getByReqID",
                method: "POST",
                data: { RequestID: $scope.vm.jobdata },
            });
            response.then(function (Commentdata) {
                $scope.Commentdatas = Commentdata.data.data;
            });
        }

        $scope.DeleteAttachment = function (id) {
            $scope.delAtachId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/attachment/delete",
                        method: "POST",
                        data: { _id: $scope.delAtachId },
                    }).then(function (attachmentdata) {
                        RefreshAttachmentGrid()
                        $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
                    })
                }
            })
        }

        $scope.DeleteComment = function (id) {
            $scope.delComId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/schedulercomment/delete",
                        method: "POST",
                        data: { _id: $scope.delComId },
                    }).then(function (attachmentdata) {
                        Refreshcomment()
                        $mdToast.show($mdToast.simple().textContent('Comment deleted Successfully!').position('top center'));
                    });

                }
            })
        }

        $scope.Uploadfiles = function (file) {
            $scope.File_id = $scope.vm.ScedulId;
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/scheduler/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Operations", FileID: $scope.vm.jobdata,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        function RefreshAttachmentGrid() {
            $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.jobdata },
            }).then(function (attachmentdata) {
                var item = attachmentdata.data.data.filter(function (item) {
                    return item.TableName === 'Operations' || item.TableName === 'Sales Order'
                })
                $scope.Attachmentdatas = item;
            });
        }
        function LoadTeam() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team",
                data: {
                    Client_Id: $rootScope.Client_Id
                },
            }).then(function (teamdata) {
                $scope.teamdatas = teamdata.data.data;
                $scope.Teamdatass = []
                $scope.Team = []
                angular.forEach($scope.teamdatas, function (value) {
                    value.text = value.TeamName;
                    value.color = getRandomColor();
                    $scope.Teamdatass.push(value)
                    $scope.Team.push(value.id)
                });
                BindScheduler();

                // if ($("#container").dxScheduler("instance").option() != undefined && $("#container").dxScheduler("instance").option().resources[1] != undefined) {

                //     $("#container").dxScheduler("instance").option().resources[1].dataSource = $scope.teamdatas;

                // }
            });
        }
        function CheckNullvalue(val) {
            var string = '';
            if (val == null || val == undefined || val == " ") {

                return string;
            } else {

                return val;
            }
        }
        function getRandomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        };
        function showToast(event, value, type) {
            $mdToast.show($mdToast.simple().textContent(event).position('top center'));
        }

        //     function GetCWCdatas(){

        //     $http({
        //         method: "POST",
        //         url:  $rootScope.WebURL + "/contract",
        //         data: { Client_Id: $rootScope.Client_Id },
        //     }).then(function (contractdata) {
        //         $scope.contractdatas = contractdata.data.data;
        //         $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/salesOrder/getForScheduler",
        //             data: { Client_Id: $rootScope.Client_Id },
        //         }).then(function (salesdata) {
        //             $scope.salesdatas = salesdata.data.data;
        //             var data = $scope.salesdatas
        //             angular.forEach(data, function (cvalue) {
        //                 cvalue.IsActive = "";
        //                 cvalue.TotalOrderValue = null;
        //                 angular.forEach($scope.contractdatas, function (value) {
        //                     if (cvalue.ContractNo == value._id) {
        //                         cvalue.IsActive = value.ContractReferenceNo;
        //                         cvalue.TotalOrderValue = value._id;
        //                     }
        //                 })
        //             })
        //             $http({
        //                 method:'POST',
        //                 url:'https://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //                 data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //             }).then(function(Glist){
        //                 var Adhocdata = Glist.data.data
        //             try {
        //                 var item = []; 
        //                 if($scope.vm.ExpiredDate==undefined)$scope.vm.ExpiredDate=7
        //                 item = data.filter(function (item) {
        //                     return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && (item.Status == 'New' || item.Status == 'On Going') && new Date(new Date(new Date().setDate(new Date().getDate()-parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) <= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) && new Date(new Date(new Date().setDate(new Date().getDate()+parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) >= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) ;
        //                 });
        //                 // _.sortBy(item, 'ServiceStartDate');

        //                 item = _.sortBy(item, function(dateObj) {
        //                     return new Date(dateObj.ServiceStartDate);
        //                   });
        //                   item=_.reverse(item);
        //                   item=Adhocdata.concat(item)
        //                 $scope.CWCDatas = item;
        //                 if($scope.TabStatus==undefined) $scope.TabStatus='New'
        //                 $scope.getSchedulerdatas($scope.TabStatus)
        //             }
        //             catch (e) { }
        //         });
        //     });
        //     });
        // }
        $scope.ExpiredDateFilter = function () {
            GetCWCdatas()
        }
        function CustomerServicedatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerServicedata) {
                var resArr = [];
                try {
                    CustomerServicedata.data.data.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                            return x.sBLK == item.sBLK && x.sUnit == item.sUnit && x.sStreetName == item.sStreetName && x.sPostal == item.sPostal
                        });
                        if (i <= -1)
                            resArr.push(item);
                    });
                } catch (e) { }
                _.each(resArr, function (item) {
                    item.PreferenceDayTime = $scope.PreferenceDayTime
                })
                $scope.CustomerServicedatas = resArr;

                $scope.vm.PreviewSpinner = false;
            });
        }

        var applyFilterTypes = [{
            key: "auto",
            name: "Immediately"
        }, {
            key: "onClick",
            name: "On Button Click"
        }], dataGrid;
        $scope.filterRow = {
            visible: true,
            applyFilter: "auto"
        };
        $scope.headerFilter = {
            visible: true
        };
        vm.dataGridCustomerService = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            dataSource: $scope.CustomerServicedatas,
            keyExpr: "_id",
            width: 870,
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "sContactPerson", caption: "Contact Person" },
                //   { dataField: "sBLK", caption: "Blk" },
                //   { dataField: "sUnit", caption: "Unit" },
                { dataField: "sBuildingName", caption: "Number" },
                { dataField: "sStreetName", caption: "Address" },
                { dataField: "sPostal", caption: "Postal" },
                { dataField: "PreferenceDayTime", caption: "Preference (Day & Time)" },
            ],
            bindingOptions: {
                dataSource: "CustomerServicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.ServiceAddressarray = [];
                    $scope.ServiceAddressarray.push.apply($scope.ServiceAddressarray, e.selectedRowsData)
                    if ($scope.vm.TeamName != undefined && $scope.vm.TeamName != null && $scope.vm.TeamName != "")
                        vm.Formvalid = false;
                    $scope.vm.Location = []
                    angular.forEach($scope.ServiceAddressarray, function (value) {
                        var getLocation = "";
                        // if (value.sBLK != "" && value.sBLK != null && value.sBLK != undefined) {
                        //     getLocation = value.sBLK;
                        // }
                        // if (value.sUnit != "" && value.sUnit != null && value.sUnit != undefined) {
                        //     getLocation = getLocation + " " + value.sUnit;
                        // }
                        if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
                            getLocation = getLocation + " " + value.sBuildingName;
                        }
                        if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
                            getLocation = getLocation + " " + value.sStreetName;
                        }
                        if (value.sCountry != "" && value.sCountry != null && value.sCountry != undefined) {
                            getLocation = getLocation + " " + value.sCountry;
                        }
                        if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
                            getLocation = getLocation + " " + value.sPostal;
                        }
                        var address = getLocation;
                        value.LatLong = "103.8677,1.3554";
                        var geocoder = new google.maps.Geocoder();
                        if (geocoder) {
                            geocoder.geocode({
                                'address': address
                            }, function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                                }
                            });
                        }
                        value.getLocation = getLocation;
                        $scope.vm.Location.push(getLocation)
                    })
                    $scope.vm.Location = $scope.vm.Location.map(function (obj) { return obj; }).join(';');
                }
                else {
                    $scope.ServiceAddressarray = [];

                    vm.Formvalid = true;
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Service Address</B></div>');
            },
        };
        vm.dataGridSalesOrder = {
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            },
            dataSource: $scope.NewSheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            width: 870,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "single",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "customerdetails[0].CompanyName", caption: "Customer Name" },
                { dataField: "SalesOrderNo", caption: "Work Order #" },
                // { dataField: "IsActive", caption: "Contract #" },
                { dataField: "PestType", caption: "Pest Types" },
                { dataField: "ServiceStartDate", caption: "Service Start Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "ServiceEndDate", caption: "Service End Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "Status", caption: "Scheduling Status" },
                // {  dataField: "IsUrgent", caption: "Urgent?",cellTemplate:function(container, options){
                //     $("<div/>").dxButton({
                //         icon: "warning"
                //     }).append(container)
                // }
                // },
                {
                    caption: 'Urgent?',
                    // fixed: true,
                    // fixedPosition: 'right',
                    width: 80,
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        if (options.data.IsUrgent == true) {
                            $('<div />').dxButton({
                                icon: 'warning'
                            }).appendTo(container);
                        }
                    }
                }


            ],
            bindingOptions: {
                dataSource: "NewSheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    var item = e.selectedRowsData[0];
                    $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
                    $scope.vm.WorkOrderNo = item.SalesOrderNo;
                    $scope.vm.WorkOrder_id = item._id;
                    $scope.vm.ContractOrder = item.TotalOrderValue;
                    $scope.vm.ContractNo = item.IsActive;
                    $scope.vm.PestType = item.PestType;
                    $scope.vm.Frequency = item.Frequency;
                    $scope.vm.Customer_id = item.Customer_id;
                    $scope.vm.OrderType = item.OrderType;
                    if ($scope.vm.OrderType == "Ad-hoc")
                        $scope.vm.JobType = 'Ad-hoc';
                    else
                        $scope.vm.JobType = 'Fixed';
                    $scope.vm.Types = item.Types;

                    $scope.PreferenceDayTime = item.DateTimeofTreatment
                    $scope.vm.EstimationTime = item.EstimatedHoursRequired
                    // if (new Date(item.ServiceStartDate) < new Date()) {
                    //     item.ServiceStartDate = new Date()
                    // }
                    // var dd = item.ServiceStartDate;
                    // var hh = vm.StartTime;
                    // var mm = new Date(hh.setDate(new Date(dd).getDate()));
                    // var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                    // $scope.vm.ServiceStartDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    // var edd = item.ServiceEndDate;
                    // var ehh = vm.EndTime;
                    // var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                    // var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                    // $scope.vm.ServiceEndDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    $scope.RequestID = item.customerdetails[0].CustomerID;
                    vm.PreviewSpinner = true;
                    CustomerServicedatadetails();
                }
                else {
                    vm.CompanyName = '';
                    vm.WorkOrder_id = '';
                    vm.ContractOrder = '';
                    vm.ContractNo = '';
                    vm.PreviewSpinner = false;
                }
            },
        }

        $scope.JobType = [
            { Name: 'New Contract' }, { Name: 'Ad-hoc' }, { Name: 'Follow-Up' }, { Name: 'Reinfestation Call' }
        ]
        $scope.JType = [{ Name: "Contract (Fixed)", value: "Fixed" }, { Name: "Contract (Flexible)", value: "Contract" }, { Name: "Ad-hoc", value: "Ad-hoc" }]
        vm.FormOption = {
            readOnly: false,
            showColonAfterLabel: false,
            showValidationSummary: true,
            labelLocation: "top",
            formData: vm,
            colCount: 2,
            items: [
                {
                    dataField: "CompanyName",
                    editorType: "dxTextBox",
                    label: { text: 'Customer Name', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "WorkOrderNo",
                    editorType: "dxTextBox",
                    label: { text: 'Work Order #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ContractNo",
                    editorType: "dxTextBox",
                    label: { text: 'Contract #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                //   {
                //       editorType: "dxTextBox",
                //       label: { text: 'No. of Service Address', showColon: false },
                //       editorOptions: {
                //           readOnly: true,
                //           value: $scope.ServiceAddressarray.length
                //       }
                //   },
                {
                    dataField: "PestType",
                    editorType: "dxTextBox",
                    label: { text: 'Pest Types', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "TeamName",
                    editorType: "dxSelectBox",
                    label: { text: 'Team', showColon: false },
                    editorOptions: {
                        dataSource: $scope.teamdatas,
                        displayExpr: "TeamName",
                        valueExpr: "id",
                        readOnly: true,
                        onValueChanged: function (e) {
                            $scope.TeamMembers = e.component._options.selectedItem.TeamMembers
                            $scope.vm.Team_id = e.component._options.selectedItem.id
                            $scope.TeamID = e.component._options.selectedItem.id
                            if ($scope.ServiceAddressarray.length > 0)
                                vm.Formvalid = false;
                        }
                    },

                },
                {
                    dataField: "TeamMembers",
                    editorType: "dxTextBox",
                    label: { text: 'Team Members', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ServiceStartDate",
                    label: { text: 'Start Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "ServiceEndDate",
                    label: { text: 'End Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "JobType",
                    label: { text: 'Job Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JType,
                        displayExpr: "Name",
                        valueExpr: "value",
                        width: "100%",
                    },
                },
                {
                    dataField: "Location",
                    label: { text: 'Location', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                    },
                },
                {
                    dataField: 'EstimationTime',
                    label: { text: 'Time to Complete', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                        value: $scope.EstimationTime,
                        readOnly: true
                    },
                },
                {
                    dataField: "SchedulingType",
                    label: { text: 'Scheduling Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JobType,
                        displayExpr: "Name",
                        valueExpr: "Name",
                        width: "100%",
                    },
                },


            ],
            bindingOptions: {
                "items[4].editorOptions.dataSource": "teamdatas",
                "items[5].editorOptions.value": "TeamMembers",
            }
        }

        $scope.getForSelectedDays = function (day) {
            $("#NewDataGrid").dxDataGrid("instance").beginCustomLoading()
            day = parseInt(day)
            var date = new Date($scope.StDate)
            date = new Date(moment(new Date(date)).add(day, 'days'))
            $scope.EnDate = new Date(date)
            GetCWCdatas()
        }

        function CleanAddComments() {
            $scope.Reschedule = { value: false };
            $scope.Cancel = { value: false };
            $scope.vm.Status = "";
            $scope.vm.ServiceID = "";
            $scope.vm.SalesOrderNo = "";
            $scope.vm.ContractReferenceNo = "";
            $scope.vm.CompanyName = "";
            $scope.vm.Location = "";
            $scope.vm.TeamName = "";
            $scope.vm.ServiceStartAt = "";
            $scope.vm.ServiceEndAt = "";
            $scope.vm.PestType1 = "";
            $scope.vm.Types = "";
            $scope.vm.ServiceOn = "";
            $scope.InProgresseAt = "";
            $scope.vm.AServiceEndAt = "";
            $scope.vm.EmailSentTo = "";
            $scope.vm.EmailSentDate = "";
            $scope.InProgressedBy = "";
            $scope.CreatedBy = "";
            $scope.CreatedDate = "";
            $scope.vm.Vehicle = "";
            $scope.Billable = { value: true };
            $scope.vm.BillingAmount
            $scope.Tabletlighttracklistdatas = [];
            $scope.TabletMaterialslistdatas = [];
            $scope.vm.TeamLead = "";
            $scope.vm.TeamMembers = "";
            $scope.vm.TeamRemarks = "";
            $scope.vm.TeamSignature = "";
            $scope.PhotosBdatas = [];
            $scope.PhotosAdatas = [];
            $scope.vm.NoOfCulls = "";
            $scope.vm.MistingCariedOut = "";
            $scope.vm.NoOfBurrows = "";
            $scope.vm.Density = "";
            $scope.vm.NoOfDead = "";
            $scope.vm.Instar = "";
            $scope.vm.BreedingFound = "";
            $scope.vm.Habitat = "";
            $scope.vm.Species = "";
            $scope.vm.Action = "";
            $scope.vm.Findings = "";
            $scope.vm.Recommendation = "";
            $scope.vm.MobilEmailId = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.starRating1r = "";
            $scope.vm.CustomerRemarks = "";
            $scope.CustomerSignature = "";
            $scope.vm.Addcomments = "";
            $scope.Commentdatas = [];
            $scope.Attachmentdatas = [];
            $scope.SchedulerLogdatas = [];
            $scope.vm.ATimeIn = "";
            $scope.vm.ATimeOut = "";
            $scope.vm.ContactPerson = "";
            $scope.vm.TeamMember = "";
            $scope.vm.starRating1 = "";
            $scope.Pestdatas = [];
            $scope.vm.MServicetype = "";
            $scope.vm.MLSMPestType = [];
            $scope.vm.MMaterialsName = "";
            $scope.vm.MQuantity = "";
            $scope.vm.MUnit = "";
            $scope.vm.ImgBPestType = [];
            $scope.vm.ImgBRemarks = "";
            $scope.uCPB = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.Reason = "";
        }


        $scope.userpopup = function (e, Start, end, Team) {
            $scope.vm.ServiceName = null;
            $scope.vm.Description = null;
            $scope.ServiceTeamId = Team
            $scope.serviceStartTime = new Date(Start)
            $scope.ServiceEndTime = new Date(end)
            $scope.vm.dateBox1 = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.serviceStartTime,
                    onValueChanged: function (e) {
                        $scope.serviceStartTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date(end),
                    onValueChanged: function (e) {
                        $scope.vm.AvoidEndTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitService = function () {
            if ($scope.ServiceUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/schedulerservice/update",
                    data: {
                        _id: $scope.ServiceUpdateID,
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.ServiceUpdate = false
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });

            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerservice/add",
                    data: {
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.sSubmit = function (e) {

            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.sPestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.Update == true) {
                var dd = $scope.vm.ResheduleFrom;
                var hh = $scope.vm.ResheduleStartTime;
                var mm = new Date(hh.setDate(new Date(dd).getDate()));
                var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                $scope.vm.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                var edd = $scope.vm.ResheduleFrom;
                var ehh = $scope.vm.ResheduleEndTime;
                var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                $scope.vm.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                var currentDate = new Date($scope.vm.schusdateTime);
                var enddate = new Date($scope.vm.schuedateTime);
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/forReschedule",
                    data: {
                        _id: $scope.SID,
                        AssignedTo: $scope.vm.AssignedTo,
                        Start_Date: currentDate,
                        End_Date: enddate,
                    },
                }).then(function (GList) {
                    var CheckforReschedule = GList.data.data;
                    $scope.CheckReschedule = false;
                    angular.forEach(CheckforReschedule, function (item) {
                        var edd = new Date($scope.vm.ResheduleFrom);
                        var ehh = new Date(item.Endsat);
                        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                        item.Endsat = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                        if (new Date(item.Startsat) < currentDate && currentDate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) < enddate && enddate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) >= currentDate && enddate > new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        var St = $filter('date')(currentDate, 'dd/MM/yyyy hh:mm a');
                        var Et = $filter('date')(enddate, 'dd/MM/yyyy hh:mm a');
                        var dbSt = $filter('date')(new Date(item.Startsat), 'dd/MM/yyyy hh:mm a');
                        var dbEt = $filter('date')(new Date(item.Endsat), 'dd/MM/yyyy hh:mm a');
                        if (St == dbSt && Et == dbEt) {
                            $scope.CheckReschedule = true;
                        }
                    })
                    if ($scope.CheckReschedule == true) {
                        $mdToast.show($mdToast.simple().textContent('Not Allowed! Scheduling exists for this team on the specified time.').position('top center'));
                    }
                    else {
                        $scope.Emails = null;
                        if ($scope.Reschedule.value == true) {
                            var array = [];
                            var createdBy = null;
                            var teamLead = null;
                            var teamMember = null;

                            try {
                                var gItem = $scope.Uniqueschedulerdatas.filter(function (item) {
                                    return $scope.SID === item._id;
                                })[0];
                                createdBy = gItem.CreatedBy;
                                teamLead = gItem.teamdetails[0].TeamLead;
                                teamMember = gItem.teamdetails[0].TeamMembers;
                            } catch (error) { }

                            angular.forEach($scope.Userdatas, function (uvalue) {
                                if (createdBy.indexOf(uvalue.UserID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                            })

                            if (array.length > 0) {
                                var SenderEmails = [];
                                $scope.Emailgroups = _.groupBy(array, 'EmailId');
                                angular.forEach($scope.Emailgroups, function (value) {
                                    SenderEmails.push(value[0].EmailId);
                                });
                                $scope.Emails = SenderEmails;
                            }
                        }

                        $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
                        if ($scope.uEndDate.getDay() == "0") {
                            $scope.ServiceOn = "Sunday";
                        }
                        else if ($scope.uEndDate.getDay() == "1") {
                            $scope.ServiceOn = "Monday";
                        }
                        else if ($scope.uEndDate.getDay() == "2") {
                            $scope.ServiceOn = "Tuesday";
                        }
                        else if ($scope.uEndDate.getDay() == "3") {
                            $scope.ServiceOn = "Wednesday";
                        }
                        else if ($scope.uEndDate.getDay() == "4") {
                            $scope.ServiceOn = "Thursday";
                        }
                        else if ($scope.uEndDate.getDay() == "5") {
                            $scope.ServiceOn = "Friday";
                        }
                        else if ($scope.uEndDate.getDay() == "6") {
                            $scope.ServiceOn = "Saturday";
                        }
                        $scope.status = "Yet to Start";
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                            data: {
                                _id: $scope.SID,
                                ServiceOn: $scope.ServiceOn,
                                Startsat: currentDate,
                                Endsat: enddate,
                                ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                SenderEmailAddress: $scope.Emails,
                                CompanyName: $scope.vm.CompanyName,
                                ScheduleFromDate: $scope.vm.ServiceStartAtlog,
                                UpdatedBy: $rootScope.createdby,
                                IsActive: true
                            },
                        });
                        response.then(function (GList) {
                            var lresponse = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/schedulelog/add",
                                data: {
                                    Client_Id: $rootScope.Client_Id,
                                    JobsOrders: $scope.vm.jobdata,
                                    Customer: $scope.vm.CustomerID,
                                    AssignedTo: $scope.vm.AssignedTo,
                                    Frequency: $scope.vm.Frequency,
                                    ServiceOn: $scope.ServiceOn,
                                    Types: $scope.vm.Types,
                                    Status: $scope.status,
                                    Startsat: $scope.vm.ServiceStartAtlog,
                                    Endsat: $scope.vm.ServiceEndAtlog,
                                    ScheduledStartsat: currentDate,
                                    ScheduledEndsat: enddate,
                                    PestType: $scope.vm.PestType1,
                                    ContractOrder: $scope.vm.ContractOrder,
                                    ServiceID: $scope.vm.ServiceID,
                                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                    CreatedBy: $rootScope.createdby,
                                    IsActive: true,
                                },
                            });
                            lresponse.then(function (GList) {
                                RefreshGrid()
                                $mdDialog.cancel();
                                $scope.pesttypeGrid = true;
                                $scope.shedulerform = true;
                                $scope.addbtn = true;
                                $scope.viewbtn = false;
                                $scope.exportbtn = true;
                                $scope.thdata = false;
                                $scope.schedulartab = true;
                                $mdDialog.cancel();
                                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                            })
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
            }
        }
        $scope.BillableSubmit = function () {
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/update",
                data: {
                    _id: $scope.vm.ScedulId,
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.Customer_Id,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: $scope.vm.Frequency,
                    ServiceOn: $scope.vm.ServiceOn,
                    Types: $scope.vm.Types,
                    Status: $scope.vm.Status,
                    Startsat: $scope.vm.ServiceStartAt,
                    Endsat: $scope.vm.ServiceEndAt,
                    PestType: $scope.vm.PestType1,
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: $scope.vm.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                    BillingAmount: $scope.vm.BillingAmount,
                    Billable: $scope.Billable.value,
                    CollectPayment: $scope.CollectPayment.value,
                    Vehicle: $scope.vm.Vehicle,
                    Location: $scope.vm.Location,
                    Client_Id: $rootScope.Client_Id,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.AddServiceMaterials = function () {
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.SMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletlighttracklist/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else if ($scope.vm.SMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletlighttracklist/update",
                    data: {
                        _id: $scope.SMId,
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.ServiceMaterialinfo = function (item) {
            $scope.vm.SMUpdate = true;
            $scope.SMId = item.id;
            $scope.vm.SMPestType = item.PestType;
            try {
                if (item.Services != null && item.Services != "" && item.Services != undefined) {
                    var array = item.Services.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ Servicetype: value });
                    });
                    $scope.vm.MServicetype = array1;
                }
            } catch (e) { }
        }
        $scope.EditMobileLogs = function (e, Sid) {
            $scope.vm.SMLMUpdate = false;
            $scope.vm.SMUpdate = false;
            $scope.vm.SMPestType = null;
            $scope.vm.MServicetype = null;
            $scope.vm.MLSMPestType = null;
            $scope.vm.MMaterialsName = null;
            $scope.vm.MQuantity = null;
            $scope.vm.MUnit = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Editemobilelog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.ServiceID = Sid;
            $scope.vm.starRating1 = 0;
            $scope.vm.tbsc_id = null;
            if ($scope.vm.Status == 'Completed') {
                angular.forEach($scope.Tabletschedulerrecord, function (value) {
                    try {
                        if ($scope.vm.ScedulId === value.ServiceId) {
                            $scope.vm.tbsc_id = value._id
                            $scope.vm.Pesttype = value.Pesttype
                            if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
                                var array = $scope.vm.Pesttype.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ PestName: value });
                                });
                                $scope.Pestdatas = array1;
                            }
                            $scope.vm.Services = value.Services
                            $scope.vm.Materials = value.Materials
                            if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                                var array = $scope.vm.Services.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ Servicetype: value });
                                });
                                $scope.vm.MServicetype = array1;
                            }
                            if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                                var array = $scope.vm.Materials.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ MaterialsName: value });
                                });
                                $scope.vm.MMaterialsName = array1;
                            }
                            $scope.vm.TeamMember = value.TeamMember
                            $scope.vm.TeamRemarks = value.TeamRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.TeamLead = value.TeamLead
                            $scope.vm.ATimeIn = new Date(value.Startsat);
                            $scope.vm.ATimeOut = new Date(value.Endsat);
                            $scope.vm.Scheduledate = new Date(value.Scheduledate);
                            $scope.CustomerSignature = value.CustomerSignature;
                            $scope.uPB1 = value.PB1;
                            $scope.uPB2 = value.PB2;
                            $scope.uPB3 = value.PB3;
                            $scope.uPB4 = value.PB4;
                            $scope.uPA1 = value.PA1;
                            $scope.uPA2 = value.PA2;
                            $scope.uPA3 = value.PA3;
                            $scope.uPA4 = value.PA4;
                            $scope.vm.TeamSignature = value.TeamSignature;
                            $scope.vm.Paymentmethod = value.Paymentmethod;
                            $scope.vm.MobilEmailId = value.EmailId;
                            $scope.vm.PaymentRemarks = value.PaymentRemarks;
                            $scope.vm.Totalpayment = parseInt(value.Totalpayment);
                            $scope.vm.PaymentNotes = value.PaymentNotes;
                            $scope.vm.Totalarea = parseInt(value.Totalarea);
                            $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
                            $scope.starRating1r = value.Rating;
                            $scope.vm.starRating1 = value.Rating;
                            $scope.vm.AServiceStartAt = new Date(value.Startsat);
                            $scope.vm.AServiceEndAt = new Date(value.Endsat);
                            $scope.vm.CustomerCurrentDate = new Date(CustomerCurrentDate);
                        }
                    }
                    catch (e) { }
                })
            }
            else {
                $scope.vm.tbsc_id = null;
            }
        }
        $scope.AddMobileLogMaterials = function () {

            if ($scope.vm.SMLMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletMaterials/add",
                    data: {
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        CreatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
            else if ($scope.vm.SMLMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletMaterials/update",
                    data: {
                        _id: $scope.SMLMId,
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
        }
        $scope.MobileLogMaterialinfo = function (item) {
            $scope.vm.SMLMUpdate = true;
            $scope.SMLMId = item.id;
            $scope.vm.MLSMPestType = item.PestType;
            $scope.vm.MMaterialsName = item.MaterialName;
            $scope.vm.MQuantity = parseFloat(item.Quantity);
            $scope.vm.MUnit = item.Unit;
        }
        $scope.EditmobileSubmit = function () {
            if ($scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == undefined) {
                $scope.vm.BreedingFound = null;
            }
            if ($scope.vm.Species == "" || $scope.vm.Species == "undefined" || $scope.vm.Species == undefined) {
                $scope.vm.Species = null;
            }
            if ($scope.vm.Findings == "" || $scope.vm.Findings == "undefined" || $scope.vm.Findings == undefined) {
                $scope.vm.Findings = null;
            }
            if ($scope.vm.MistingCariedOut == "" || $scope.vm.MistingCariedOut == "undefined" || $scope.vm.MistingCariedOut == undefined) {
                $scope.vm.MistingCariedOut = null;
            }
            if ($scope.vm.Reason == "" || $scope.vm.Reason == "undefined" || $scope.vm.Reason == undefined) {
                $scope.vm.Reason = null;
            }
            if ($scope.vm.Instar == "" || $scope.vm.Instar == "undefined" || $scope.vm.Instar == undefined) {
                $scope.vm.Instar = null;
            }
            if ($scope.vm.Density == "" || $scope.vm.Density == "undefined" || $scope.vm.Density == undefined) {
                $scope.vm.Density = null;
            }
            if ($scope.vm.Others == "" || $scope.vm.Others == "undefined" || $scope.vm.Others == undefined) {
                $scope.vm.Others = null;
            }
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.MMaterialsName != null && $scope.vm.MMaterialsName != "" && $scope.vm.MMaterialsName != undefined) {
                $scope.vm.MMaterialsName = $scope.vm.MMaterialsName.map(function (obj) { return obj.MaterialsName; }).join(',');
            }

            if ($scope.vm.tbsc_id != undefined && $scope.vm.tbsc_id != null && $scope.vm.tbsc_id != "") {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/update",
                    data: {
                        _id: $scope.vm.tbsc_id,
                        ServiceId: $scope.vm.ServiceID,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: $scope.vm.Startsat,
                        Endsat: $scope.vm.Endsat,
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: $scope.CustomerCurrentDate,
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: new Date(),
                        Endsat: new Date(),
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: new Date(),
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    var response1 = $http({
                        url: $rootScope.WebURL + "/scheduler/Statusupdate",
                        method: "PUT",
                        data: {
                            _id: $scope.vm.ScedulId,
                            Status: "Completed",
                            UpdatedBy: $rootScope.createdby,
                        },
                    });
                    response1.then(function (GList) {
                        $mdDialog.cancel();
                        $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
                        $mdDialog.cancel();
                        RefreshGrid();
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
        }
        $scope.Schinfodelete = function (deleteID) {
            try {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === deleteID;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                    var teamLead = item.teamdetails[0].TeamLead;
                    var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                    $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceOn = item.ServiceOn;
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
                $scope.Status = item.Status;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
            } catch (e) { }
            $scope.Emails = null;
            if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                    if (createdBy.indexOf(uvalue.UserID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                })
                if (array.length > 0) {
                    var SenderEmails = [];
                    $scope.Emailgroups = _.groupBy(array, 'EmailId');
                    angular.forEach($scope.Emailgroups, function (value) {
                        SenderEmails.push(value[0].EmailId);
                    });
                    $scope.Emails = SenderEmails;
                }
            }
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                    _id: deleteID,
                    Status: "Cancelled",
                    CancelRemarks: $scope.vm.CancelRemarks,
                    SenderEmailAddress: $scope.Emails,
                    CompanyName: $scope.CompanyName,
                    ScheduleDate: $scope.ServiceStartAt,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                var lresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulelog/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        JobsOrders: $scope.jobdata,
                        Customer: $scope.CustomerID,
                        AssignedTo: $scope.AssignedTo,
                        Frequency: $scope.Frequency,
                        ServiceOn: $scope.ServiceOn,
                        Types: $scope.Types,
                        Status: $scope.Status,
                        Startsat: $scope.ServiceStartAt,
                        Endsat: $scope.ServiceEndAt,
                        PestType: $scope.PestType,
                        ContractOrder: $scope.ContractOrder,
                        ServiceID: $scope.ServiceID,
                        CancelRemarks: $scope.vm.CancelRemarks,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true,
                    },
                });
                lresponse.then(function (GList) {
                    LoadSchedulerData();
                    $mdDialog.cancel();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                })
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshPhotos() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulerpicafter",
                data: { ScedulId: $scope.vm.ScedulId },
            }).then(function (Photosdatas) {
                $scope.Photosdatas = Photosdatas.data.data;
                angular.forEach($scope.Photosdatas, function (employee) {
                    if (employee.schimgafter != null && employee.schimgafter != "" && employee.schimgafter != undefined) {
                        employee.schimgafter = decode_base64(employee.schimgafter);
                    }
                    if (employee.schimgbefore != null && employee.schimgbefore != "" && employee.schimgbefore != undefined) {
                        employee.schimgbefore = decode_base64(employee.schimgbefore);
                    }
                });
                var item = $scope.Photosdatas.filter(function (item) {
                    return item.schimgafter != null && item.schimgafter != "null" && item.schimgafter != "" && item.schimgafter != undefined;
                });
                $scope.PhotosAdatas = item;
                var item1 = $scope.Photosdatas.filter(function (item1) {
                    return item1.schimgbefore != null && item1.schimgbefore != "null" && item1.schimgbefore != "" && item1.schimgbefore != undefined;
                });
                $scope.PhotosBdatas = item1;
            });
        }
        function RefreshServiceMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletlighttracklist/getbyId",
                method: "POST",
                data: { ServiceId: $scope.vm.ScedulId },
            });
            response.then(function (Tabletlighttracklistdata) {
                $scope.Tabletlighttracklistdatas = Tabletlighttracklistdata.data.data;
            });
            $scope.vm.SMUpdate = false;
        }
        function RefreshMobileLogMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletMaterials/getById",
                method: "POST",
                data: { Service_Id: $scope.vm.ScedulId },
            });
            response.then(function (TabletMaterialslistdata) {

                $scope.TabletMaterialslistdatas = TabletMaterialslistdata.data.data;
            });
            $scope.vm.SMLMUpdate = false;
        }
        function RefreshSchedulerLogs() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulelog/getByServiceID",
                method: "POST",
                data: { ServiceID: $scope.vm.ServiceID },
            });
            response.then(function (SchedulerLogdata) {

                $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id }
        }).then(function (pocarddatas) {
            $scope.Pesttypedatas = pocarddatas.data.data;
        })
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/getByClientId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
                angular.forEach($scope.Userdatas, function (value) {
                    angular.forEach($scope.Employeedatas, function (evalue) {
                        if (value.EmployeeID == evalue.EmployeeID)
                            value.EmployeeID = evalue.EmployeeName;
                    })
                })
                LoadSchedulerData()
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicetypelist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Servicesdata) {
            $scope.Servicesdatas = Servicesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item1 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item1;
            }
            catch (e) { }
            try {
                var item2 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'PaymentMode';
                });
                $scope.PaymentModedatas = item2;
            }
            catch (e) { }
            try {
                var item3 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'Remarks';
                });
                $scope.Remarksdatas = item3;
            }
            catch (e) { }
            try {
                var item4 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'JobTypes';
                });
                $scope.JobTypesdatas = item4;
            }
            catch (e) { }
        });
        vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            select: {
                style: 'multi'
            },
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }

            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtdetails = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-Detailsdt');
                var table = $('#Detailsdt').DataTable();
                table.search('').draw();
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[3, "asc"]],
            lengthMenu: [5, 10, 20, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };

        // socket configurations
        socket.on("Scheduler Created by Inserting multiple", function (data) {
            var schedresult = data.result
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("scheduler dragged", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("scheduler dropped", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler specified update", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler cancelled", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Team Updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Scheduler UpdateTeam method", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Update Scheduler Line", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Completed", function (data) {
            $scope.Datefilter()
        })
        socket.on("WorkOrder unscheduled", function (data) {
            $scope.Datefilter()
        })


        // get scheduler data for socket


    }

})();

(function ()
{
    'use strict';

    angular
        .module('apps.crm.dashboard',
            [
                // 3rd Party Dependencies
                 'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.crm_sales', {
            url      : '/DashboardSales',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/dashboard/sales.html',
                    controller : 'DashboardSalesController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/dashboard');
    }

})();
(function () {
    'use strict';

    angular
        .module('apps.crm.dashboard')
        .filter('groupBy', function () {
            return _.memoize(function (items, field) {
                return _.groupBy(items, field);
            }
            );
        })
        .controller('DashboardSalesController', DashboardSalesController);

    /** @ngInject */
    function DashboardSalesController($scope, $interval, $location, $http, $rootScope, $filter, DashboardData, $state) {
        /*
        Pest Off - Dashboard CRM

        1. Prospect-Followup - The leads with the Expected Reponse Date after 3 months. ie. ExpectedResponseDate is within today and new date()+3 Months 

        2.Leads - The no. of Customers to which they have sent Quotatin

        3.Pipeline Value - Total Pipeline value of Prospect followup

        4.Accumulated Sales -  Total Contract Value for this month


        Upcoming Clients (2 Months) - shows Completed, Lead, Propspect
            Lead - the leads with no quotation sent
            Completed - the leads with salesorder created
            Prospect - the leads with quotation sent
        */
        document.getElementsByTagName('title')[0].text = "Customer Relationship-Dashboard"
        var EmpID = localStorage.getItem('EmployeeID');
        var chkAceses = localStorage.getItem('pages');
        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        if (chkAceses.split(",").includes("DCRM")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.ContractD = [];
        $scope.AllContractsitem = [];
        $scope.ContractListdatas = [];

        $scope.ExpiredDateFilter = function () {
            $scope.ExpiredDate = $scope.vm.ExpiredDate;
            $scope.ContractListdatas = [];
            if ($scope.ExpiredDate === "EXPIRING IN 30 DAYS") {
                try {
                    $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
                        return item.ContractExpired <= 30;
                    });
                } catch (e) { }
            }
            else if ($scope.ExpiredDate === "EXPIRING IN 60 DAYS") {
                try {
                    $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
                        return item.ContractExpired <= 60;
                    });
                } catch (e) { }
            }
            else if ($scope.ExpiredDate === "EXPIRING IN 90 DAYS") {
                try {
                    $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
                        return item.ContractExpired <= 90;
                    });
                } catch (e) { }
            }
            else if ($scope.ExpiredDate === "EXPIRING ABOVE 90 DAYS") {
                try {
                    $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
                        return item.ContractExpired > 90;
                    });
                } catch (e) { }
            }
            else if ($scope.ExpiredDate === "EXPIRIED") {
                try {
                    $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
                        return item.ContractExpired === "Expiried";
                    });
                } catch (e) { }
            }
            else if ($scope.ExpiredDate === null) {
                try {
                    $scope.ContractListdatas = [];
                } catch (e) { }
            }
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/customer",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Leaddata) {
            $scope.Customeritem = Leaddata.data.data;
            calculateDashboard()
        })

        $http({
            method: "GET",
            url: $rootScope.WebURL + "/attachment",
        }).then(function (Leaddata) {
            $scope.Attachmentdata = Leaddata.data.data;
            calculateDashboard()
        })

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/lead/get",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Leaddata) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                if (IsAdmin == true) {
                    $scope.Leaditem = Leaddata.data.data;
                    $scope.TotalLeads = $scope.Leaditem.length
                }
                else {
                    $scope.Leaditem = [];
                    var item = $scope.Employeedatas.filter(function (item) {
                        return EmpID === item.EmployeeID
                    })[0]
                    if (item != undefined) {
                        $scope.Emp_Id = item.id
                        var Eitem = Leaddata.data.data.filter(function (Eitem) {
                            return Eitem.SalesPerson === $scope.Emp_Id
                        })
                        $scope.Leaditem = Eitem;
                        $scope.TotalLeads = $scope.Leaditem.length
                    }
                    else {
                        $scope.Leaditem = [];
                        $scope.TotalLeads = $scope.Leaditem.length
                    }
                }

                var item = [];
                item = $scope.Leaditem.filter(function (item) {
                    return new Date(item.ExpectedResponseDate).setHours(23, 59, 59, 999) <= new Date(new Date().setMonth(new Date().getMonth() + 3)).setHours(23, 59, 59, 999) && new Date().setHours(0, 0, 0, 0) <= new Date(item.ExpectedResponseDate).setHours(0, 0, 0, 0);
                });
                $scope.Leaddatas = Leaddata.data.data.length;
                $scope.ProspectFollowup = item.length;
                $scope.Prospectdatas = item;
                var item1 = [];
                $scope.Pipelinevaluedatas = []
                var PipelineValue = 0;
                if ($scope.Prospectdatas.length > 0) {
                    item1 = $scope.Prospectdatas.filter(function (item1) {
                        if (item1.Pipelinevalue != null && item1.Pipelinevalue != undefined && item1.Pipelinevalue != "") {
                            $scope.Pipelinevaluedatas.push(item1)

                            PipelineValue = PipelineValue + parseInt(item1.Pipelinevalue);
                            $scope.PipelineValue = PipelineValue;
                        }
                    });
                }
                else $scope.PipelineValue = PipelineValue;
                calculateDashboard()
                calculateWidget10()
            });
        });

        function calculateWidget10() {
            var SalesCustomer = []
            var Leads = []
            var Prospect = []

            var item = $scope.Leaditem.filter(function (item) {
                return item.attachmentdetails.length > 0 && item.SalesOrderdetails.length == 0
            })
            if (item != undefined)
                Leads.push(item)
            var item = $scope.Leaditem.filter(function (item) {
                return item.attachmentdetails.length == 0 && item.SalesOrderdetails.length == 0
            })
            if (item != undefined)
                Prospect.push(item)
            var item = $scope.Leaditem.filter(function (item) {
                return item.SalesOrderdetails.length > 0
            })
            if (item != undefined)
                SalesCustomer.push(item)
            Leads = _.flatten(Leads)
            Prospect = _.flatten(Prospect)
            SalesCustomer = _.flatten(SalesCustomer)


            $scope.ContractD = [{ label: 'Completed', value: SalesCustomer.length }, { label: 'Lead', value: Leads.length }, { label: 'Prospect', value: Prospect.length }]
            vm.widget10.mainChart.data = $scope.ContractD
        }

        function calculateDashboard() {
            var item1 = []
            if ($scope.Prospectdatas != undefined && $scope.Customeritem != undefined) {
                angular.forEach($scope.Prospectdatas, function (value) {
                    $scope.Customeritem.filter(function (item) {
                        if (value.CustomerID === item.id) {
                            item1.push(item)
                        }
                    })
                })
                var cutomer = _.groupBy(item1, 'id')
                var check = _.values(cutomer)
                item1 = []
                _.each(check, function (s) {
                    s[0].length = s.length
                    item1.push(s[0])
                })
                $scope.Customerdatas = item1
            }
            item1 = []
            if ($scope.Attachmentdata != undefined && $scope.Leaditem != undefined) {
                angular.forEach($scope.Leaditem, function (value) {
                    $scope.Attachmentdata.filter(function (item) {
                        if (value.LeadReferenceNo === item.FileID) {
                            item1.push(value)
                        }
                    })
                })

                $scope.SortedAttachemntLeaddata = item1
            }
            var item2 = []
            if ($scope.SortedAttachemntLeaddata != undefined && $scope.Customeritem != undefined) {
                angular.forEach($scope.SortedAttachemntLeaddata, function (value) {
                    $scope.Customeritem.filter(function (item) {
                        if (value.CustomerID === item.id) {
                            item2.push(item)
                        }
                    })
                })
                var i = _.groupBy(item2, 'id');
                $scope.QuotationLeads = Object.keys(i).length
            }
        }

        $scope.GetPipelineValue = function () {
            var Pop = $('#popupContainer').dxPopup({
                title: "Pipeline Values",
                visible: true,
                height: "auto",
                closeOnOutsideClick: true,
                contentTemplate: function (contentElement) {
                    contentElement.append();
                    var grid = $("<div>");
                    contentElement.append(grid);
                    grid.dxDataGrid({
                        onInitialized: function (e) {
                            $scope.gridInstance = e.component;
                        },
                        dataSource: $scope.Pipelinevaluedatas,
                        keyExpr: "_id",
                        showColumnLines: true,
                        showRowLines: true,
                        showBorders: true,
                        rowAlternationEnabled: true,
                        headerFilter: {
                            visible: true,
                            allowSearch: true
                        },
                        hoverStateEnabled: true,
                        columnMinWidth: 50,
                        columnsAutoWidth: true,
                        allowColumnResizing: true,
                        columnResizingMode: "widget",
                        filterRow: {
                            visible: true
                        },
                        "export": {
                            enabled: false,
                            fileName: "Customer Details",
                            allowExportSelectedData: false
                        },
                        paging: {
                            pageSize: 10
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [10, 25, 50, 100],
                            showInfo: true
                        },
                        remoteOperations: false,
                        searchPanel: {
                            visible: false,
                            highlightCaseSensitive: true,
                            width: 300
                        },
                        allowColumnReordering: true,
                        columnChooser: {
                            enabled: false
                        },
                        wordWrapEnabled: false,
                        noDataText: "No Customer to display...",
                        loadPanel: {
                            enabled: true,
                            height: 150,
                            width: 400,
                            text: 'Please wait data is loading...'
                        },
                        onInitNewRow: function (e) {
                            debugger
                        },
                        columns: [
                            {
                                caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                                    cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                                }
                            },
                            {
                                dataField: "LeadReferenceNo", caption: "Reference #",
                            },
                            { dataField: "Customer", caption: "Customer" },
                            { dataField: "MarketSegment", caption: "Market Segment" },
                            { dataField: "SalesPerson", caption: "Sales Person" },
                            { dataField: "ExpectedResponseDate", caption: "Expected Response Date", dataType: "date", format: 'dd/MM/yyyy' },
                            {
                                dataField: "Pipelinevalue", caption: "Pipeline Value (SGD)", alignment: "right",
                                format: "currency"
                            },
                        ],
                        summary: {
                            totalItems: [{
                                column: "Pipelinevalue",
                                summaryType: "sum",
                                valueFormat: "currency",
                                displayFormat: "Pipeline value: {0}",
                            }]
                        }
                    })
                },
            })
        }

        $scope.GetAccumulatedValue = function () {
            var Pop = $('#popupContainer').dxPopup({
                title: "Total Contract Value",
                visible: true,
                height: "auto",
                closeOnOutsideClick: true,
                contentTemplate: function (contentElement) {
                    contentElement.append();
                    var grid = $("<div>");
                    contentElement.append(grid);
                    grid.dxDataGrid({
                        onInitialized: function (e) {
                            $scope.gridInstance = e.component;
                        },
                        dataSource: $scope.AccumulatedvalueData,
                        keyExpr: "_id",
                        showColumnLines: true,
                        showRowLines: true,
                        showBorders: true,
                        rowAlternationEnabled: true,
                        headerFilter: {
                            visible: true,
                            allowSearch: true
                        },
                        hoverStateEnabled: true,
                        columnMinWidth: 50,
                        columnsAutoWidth: true,
                        allowColumnResizing: true,
                        columnResizingMode: "widget",
                        filterRow: {
                            visible: true
                        },
                        "export": {
                            enabled: false,
                            fileName: "Customer Details",
                            allowExportSelectedData: false
                        },
                        paging: {
                            pageSize: 10
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [10, 25, 50, 100],
                            showInfo: true
                        },
                        remoteOperations: false,
                        searchPanel: {
                            visible: false,
                            highlightCaseSensitive: true,
                            width: 300
                        },
                        allowColumnReordering: true,
                        columnChooser: {
                            enabled: false
                        },
                        wordWrapEnabled: false,
                        noDataText: "No Customer to display...",
                        loadPanel: {
                            enabled: true,
                            height: 150,
                            width: 400,
                            text: 'Please wait data is loading...'
                        },
                        onInitNewRow: function (e) {
                            debugger
                        },
                        columns: [
                            {
                                caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                                    cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                                }
                            },
                            {
                                dataField: "ContractReferenceNo", caption: "Reference #",
                            },
                            { dataField: "customerdetails[0].CompanyName", caption: "Customer" },
                            { dataField: "TempPestType", caption: "Pest Types" },
                            { dataField: "employeedetails[0].EmployeeName", caption: "Sales Person" },
                            { dataField: "ServiceStartDate", caption: "Service Start Date", dataType: "date", format: 'dd/MM/yyyy' },
                            { dataField: "ServiceEndDate", caption: "Service End Date", dataType: "date", format: 'dd/MM/yyyy' },
                            {
                                dataField: "ContractValue", caption: "Contract Value (SGD)", alignment: "right",
                                format: "currency"
                            },
                        ],
                        summary: {
                            totalItems: [{
                                column: "ContractValue",
                                summaryType: "sum",
                                valueFormat: "currency",
                                displayFormat: "Pipeline value: {0}",
                            }]
                        }
                    })
                },
            })
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/lead/getLeadsforDashboard",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Leaddata) {
            $scope.Arraydata = Leaddata.data.data;
            // getWidget10data()
        });
        function getWidget10data() {
            if ($scope.Arraydata != undefined) {
                var Arraydata = $scope.Arraydata
                var CustomerItem = Arraydata[0]
                var SalesCustomer = []
                var ContractCustomer = []
                var LeadCustomer = []
                var Leads = []
                var Prospect = []
                var Leadgroup = _.groupBy(Arraydata[1], '_id');
                var Contractgroup = _.groupBy(Arraydata[2], '_id');
                var SalesOrdergroup = _.groupBy(Arraydata[3], '_id');
                _.each(SalesOrdergroup, function (s) {
                    _.filter(CustomerItem, function (cus) {
                        if (s[0]._id === cus._id) {
                            cus.SalesOrderdetails = s
                            SalesCustomer.push(cus)
                        };
                    })
                })
                _.each(Contractgroup, function (s) {
                    _.filter(CustomerItem, function (cus) {
                        if (s[0]._id === cus._id) {
                            cus.Contractdetails = s
                            ContractCustomer.push(cus)
                        };
                    })
                })
                _.each(Leadgroup, function (s) {
                    _.filter(CustomerItem, function (cus) {
                        if (s[0]._id === cus._id) {
                            cus.Leaddetails = s
                            LeadCustomer.push(cus)
                        };
                    })
                })
                _.each(LeadCustomer, function (s) {
                    if (s.SalesOrderdetails == undefined && s.Contractdetails == undefined) {
                        _.each(s.Leaddetails, function (s1) {
                            _.each(s1.attachmentdetails, function (s2) {
                                if (s2.length > 0)
                                    Leads.push(s)
                                else
                                    Prospect.push(s)
                            })
                        })
                    }
                })
                $scope.ContractD = [{ label: 'Completed', value: SalesCustomer.length }, { label: 'Lead', value: Leads.length }, { label: 'Prospect', value: Prospect.length }]
                vm.widget10.mainChart.data = $scope.ContractD
            }
            else
                setTimeout(function () {
                    $scope.$apply(function () {
                        getWidget10data()
                    });
                }, 1);
        }

        $scope.uFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        $scope.uTo = new Date();
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo.setHours(23, 59, 59, 999);
        $http({
            url: $rootScope.WebURL + "/contract/datefilter",
            method: "POST",
            data: {
                Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id,
            },
        }).then(function (GList) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
                var item = $scope.Employeedatas.filter(function (item) {
                    return EmpID === item.EmployeeID
                })[0]
                if (item != undefined) {
                    $scope.Emp_Id = item.id
                    var Eitem = GList.data.data.filter(function (Eitem) {
                        return Eitem.SalesPerson_id === $scope.Emp_Id
                    })
                    if (Eitem.length > 0) {
                        $scope.contractdatas = Eitem;
                        var item1 = [];
                        $scope.AccumulatedvalueData = []
                        var ContractValue = 0;
                        item1 = $scope.contractdatas.filter(function (item1) {
                            if (item1.ContractValue != null && item1.ContractValue != undefined && item1.ContractValue != "") {
                                $scope.AccumulatedvalueData.push(item1)
                                ContractValue = ContractValue + parseInt(item1.ContractValue);
                                $scope.AccumulatedSales = ContractValue;
                            }
                        });
                    }
                    else $scope.AccumulatedSales = 0
                }
                else {
                    if (IsAdmin == true) {
                        $scope.contractdatas = GList.data.data
                        var item1 = [];
                        $scope.AccumulatedvalueData = []
                        var ContractValue = 0;
                        item1 = $scope.contractdatas.filter(function (item1) {
                            if (item1.ContractValue != null && item1.ContractValue != undefined && item1.ContractValue != "") {
                                $scope.AccumulatedvalueData.push(item1)
                                ContractValue = ContractValue + parseInt(item1.ContractValue);
                                $scope.AccumulatedSales = ContractValue;
                            }
                        });
                    }
                    else {
                        $scope.AccumulatedSales = 0
                    }
                }
            });
            // $scope.Crtgroups = _.groupBy($scope.contractdatas, 'SalesPerson_id');
            // angular.forEach($scope.Crtgroups, function (value) {
            //     $scope.ContractD.push({
            //         label: value[0].employeedetails[0].EmployeeID + '-' + value[0].employeedetails[0].EmployeeName,
            //         value: value.length
            //     })
            // })
        });
        $scope.ExpiredDateList = [
            { "name": "EXPIRING IN 30 DAYS" },
            { "name": "EXPIRING IN 60 DAYS" },
            { "name": "EXPIRING IN 90 DAYS" },
            { "name": "EXPIRING ABOVE 90 DAYS" },
            { "name": "EXPIRIED" },
        ];

        $scope.CustomerD = [];
        var customerchart = [];
        $scope.Totla = function (uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date();
                var secondDate = new Date(uTimeOut);
                if (firstDate > secondDate) {
                    return 'Expiried'
                }
                else {

                    var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
                    if (res == 0) {
                        return 'Expiried'
                    }
                    else {
                        return res;
                    }
                }
            }
            else { return null }
        }
        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        var Language = localStorage.getItem('MenuReports');
        var customertitle = "Customer";
        var enquirytitle = "Enquiry";
        var workordertitle = "Work Order";
        var contrattitle = "Contracts";
        $scope.General = "General"
        if (DefaultLanguage === "Vietnamese" || Language === "Báo cáo") {
            customertitle = "khách hàng";
            enquirytitle = "Yêu cầu";
            workordertitle = "Trình tự công việc";
            contrattitle = "Hợp đồng";
            $scope.General = "Chung"
        }

        var vm = this;
        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        $scope.AddocD = [];
        // Widget 5
        vm.widget5 = {
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'discreteBarChart',
                        color: ['#03a9f4', '#b3e5fc'],
                        height: 420,
                        margin: {
                            top: 8,
                            right: 16,
                            bottom: 32,
                            left: 32
                        },
                        clipEdge: true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked: true,
                        duration: 250,
                        x: function (d) {
                            return d.x;
                        },
                        y: function (d) {
                            return d.y;
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d;
                            }
                        },
                        legend: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        controls: {
                            margin: {
                                top: 8,
                                bottom: 32
                            }
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

            changeRange: function (range) {
                angular.forEach($scope.Leaditem, function (value) {
                    value.EnquiryDate = new Date(value.EnquiryDate).setHours(0, 0, 0, 0)
                })
                $scope.SOgroups = _.groupBy($scope.Leaditem, 'EnquiryDate');
                var data = [{ "values": [] }];
                angular.forEach($scope.SOgroups, function (value) {
                    var d = new Date(value[0].EnquiryDate);
                    var n = $filter('date')(d, 'dd/MM/yyyy');
                    data[0].values.push(
                        {
                            "x": n,
                            "y": value.length
                        }
                    )
                });
                vm.widget5.mainChart.data[0] = data[0];
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                var Adh = [];
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesOrder",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (salesOrderdata) {
                    $scope.salesOrderItems = salesOrderdata.data.data;
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/employee/detailsforTab",
                        data: { Client_Id: $rootScope.Client_Id },
                    }).then(function (Employeedata) {
                        $scope.Employeedatas = Employeedata.data.data;
                        var Eitem = $scope.Employeedatas.filter(function (Eitem) {
                            return EmpID === Eitem.EmployeeID
                        })[0]

                        var item = $scope.salesOrderItems.filter(function (item) {
                            return item.OrderType === "Ad-hoc" && (IsAdmin == true || Eitem.id == item.SalesPerson_id);
                        });
                        $scope.Adhoclength = item.length;
                        $scope.salesOrderdatas = salesOrderdata.data.data.length;
                        vm.widget5.changeRange('TW');

                        Adh.push({ OrderType: "Ad-hoc", lengthvalue: $scope.Adhoclength })
                        var item1 = $scope.salesOrderItems.filter(function (item1) {
                            return item1.OrderType === "Contract" && (IsAdmin == true || Eitem.id == item1.SalesPerson_id);;
                        });
                        var OTlength = item1.length;
                        Adh.push({ OrderType: "Contract", lengthvalue: OTlength })
                        angular.forEach(Adh, function (value) {
                            $scope.AddocD.push({
                                label: value.OrderType,
                                value: value.lengthvalue
                            })
                        });
                    });
                })
            }
        };

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            mainChart: {
                config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                },
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        donut: true,
                        clipEdge: true,
                        cornerRadius: 0,
                        labelType: 'percent',
                        padAngle: 0.02,
                        x: function (d) {
                            return d.ShiftName;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            },
            footerLeft: vm.dashboardData.widget6.footerLeft,
            footerRight: vm.dashboardData.widget6.footerRight,
            ranges: vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange: function (range) {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */

                angular.forEach($scope.Shiftdatas, function (data, index) {
                    debugger
                    vm.widget6.mainChart.data[index] = {
                        label: data.ShiftName,
                        value: $scope.Shiftdatas.length
                    };
                });
            },
            init: function () {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };
        // Widget 7
        vm.widget7 = {
            title: vm.dashboardData.widget7.title,
            ranges: vm.dashboardData.widget7.ranges,
            schedule: vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        var widget8 = {
            "title": customertitle,
            "mainChart": $scope.CustomerD
        }
        // Widget 8
        vm.widget8 = {
            title: widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget8.mainChart
            }
        };

        // Widget 9
        var widget9 = {
            "title": enquirytitle,
            "mainChart": $scope.LeadD
        }
        // Widget 8
        vm.widget9 = {
            title: widget9.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget9.mainChart
            }
        };

        // Widget 10
        var widget10 = {
            "title": 'Upcoming Clients (2 Months)',
            "mainChart": $scope.ContractD
        }
        vm.widget10 = {
            title: widget10.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: []
            }
        };

        // Widget 11
        var widget11 = {
            "title": workordertitle,
            "mainChart": $scope.AddocD
        }
        vm.widget11 = {
            title: widget11.title,
            mainChart: {
                options: {
                    chart: {
                        type: 'pieChart',
                        color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height: 400,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        labelType: 'percent',
                        x: function (d) {
                            return d.label;
                        },
                        y: function (d) {
                            return d.value;
                        },
                        tooltip: {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data: widget11.mainChart
            }
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();


        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });
        vm.dashboardData = DashboardData;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
        $scope.goToLead = function () {
            $state.go('app.lead')
        }
        $scope.RedirectPage = function (type) {
            $state.go('app.' + type)
        }

        $scope.getCustomerdata = function () {
            var Pop = $('#popupContainer').dxPopup({
                title: "Customer",
                visible: true,
                height: "auto",
                closeOnOutsideClick: true,
                contentTemplate: function (contentElement) {
                    contentElement.append();
                    var grid = $("<div>");
                    contentElement.append(grid);
                    grid.dxDataGrid({
                        onInitialized: function (e) {
                            $scope.gridInstance = e.component;
                        },
                        dataSource: $scope.Customerdatas,
                        keyExpr: "id",
                        showColumnLines: true,
                        showRowLines: true,
                        showBorders: true,
                        rowAlternationEnabled: true,
                        headerFilter: {
                            visible: true,
                            allowSearch: true
                        },
                        hoverStateEnabled: true,
                        columnMinWidth: 50,
                        columnsAutoWidth: true,
                        allowColumnResizing: true,
                        columnResizingMode: "widget",
                        filterRow: {
                            visible: true
                        },
                        "export": {
                            enabled: false,
                            fileName: "Customer Details",
                            allowExportSelectedData: false
                        },
                        paging: {
                            pageSize: 10
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [10, 25, 50, 100],
                            showInfo: true
                        },
                        remoteOperations: false,
                        searchPanel: {
                            visible: false,
                            highlightCaseSensitive: true,
                            width: 300
                        },
                        allowColumnReordering: true,
                        columnChooser: {
                            enabled: false
                        },
                        wordWrapEnabled: false,
                        noDataText: "No Customer to display...",
                        loadPanel: {
                            enabled: true,
                            height: 150,
                            width: 400,
                            text: 'Please wait data is loading...'
                        },
                        onInitNewRow: function (e) {
                            debugger
                        },
                        columns: [
                            {
                                caption: 'Reference #',
                                dataField: 'CustomerReference',
                                width: 110,
                                cellTemplate: function (container, options) {

                                    $("<p style='color:blue;cursor: pointer;'>" + options.data.CustomerReference + "</p>").appendTo(container);
                                    if (options.data.length > 1) {
                                        $("<div class='label ng-binding ng-scope md-green-500-bg'>" + options.data.length + " Prospects for this Client</div>").appendTo(container);
                                    }
                                },
                            },

                            "CompanyName",
                            "MarketSection", "ContactPerson",
                            "Mobile", {
                                caption: 'Email',
                                dataField: 'Email',
                                width: 200,
                            }, //"BuildingName", "Address", "Postal",
                            { caption: "Contract End Date", dataField: "ConEndDate", dataType: "date", format: 'dd/MM/yyyy' },
                        ],
                    })
                },
            })
        }

        $http({
            url: $rootScope.WebURL + "/salesOrder/getAnnualTotal",
            method: "POST",
            data: {
                Client_Id: $rootScope.Client_Id,
            },
        }).then(function (GList) {
            var data = GList.data.data;
            var Tech = _.uniq(_.map(data, 'SalesPerson_id').join(',').split(','))
            Tech = Tech.filter(Boolean)
            var array = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Employeedata) {
                var Empdata = Employeedata.data.data;
                if (IsAdmin == false) {
                    var item = Empdata.filter(function (item) {
                        return item.EmployeeID === EmpID
                    })
                    $scope.Employeedatas = item
                }
                else
                    $scope.Employeedatas = Empdata

                angular.forEach(Tech, function (item) {
                    var salesorder1 = data.filter(function (sitem) {
                        return new Date(new Date(sitem.OrderConfirmationDate).setHours(0, 0, 0, 0)) >= new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)) && new Date(new Date(sitem.OrderConfirmationDate).setHours(0, 0, 0, 0)) <= new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(0, 0, 0, 0)) && sitem.SalesPerson_id === item
                    })
                    var SalesOrderCurrent = salesorder1
                    var salesorder1 = data.filter(function (eitem) {
                        return new Date(new Date(eitem.OrderConfirmationDate).setHours(0, 0, 0, 0)) >= new Date(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).setHours(0, 0, 0, 0)) && new Date(new Date(eitem.OrderConfirmationDate).setHours(0, 0, 0, 0)) <= new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 0).setHours(0, 0, 0, 0)) && eitem.SalesPerson_id === item
                    })
                    var SalesOrderPast = salesorder1

                    var salesorder1 = data.filter(function (ditem) {
                        return new Date(new Date(ditem.OrderConfirmationDate).setHours(0, 0, 0, 0)) >= new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1).setHours(0, 0, 0, 0)) && new Date(new Date(ditem.OrderConfirmationDate).setHours(0, 0, 0, 0)) <= new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(0, 0, 0, 0)) && ditem.SalesPerson_id === item
                    })
                    var SalesOrderNext = salesorder1
                    var Eitem = $scope.Employeedatas.filter(function (Eitem) {
                        return Eitem.id === item
                    })[0];
                    if (Eitem != undefined) {
                        array.push({
                            state: Eitem.EmployeeID + '-' + Eitem.EmployeeName,
                            Past: _.sumBy(SalesOrderPast, function (item) { return parseFloat(item.TotalPrice) }),
                            Current: _.sumBy(SalesOrderCurrent, function (item) { return parseFloat(item.TotalPrice) }),
                            Next: _.sumBy(SalesOrderNext, function (item) { return parseFloat(item.TotalPrice) }),
                        })
                    }
                })

                $scope.SalesTrending = array
            })
        });
        $scope.chartOptions = {
            dataSource: $scope.SalesTrending,
            commonSeriesSettings: {
                argumentField: "state",
                type: "bar",
                hoverMode: "allArgumentPoints",
                selectionMode: "allArgumentPoints",
                label: {
                    visible: true,
                    format: "percent",
                    connector: {
                        visible: true
                    },
                    customizeText: function (arg) {
                        var com = ''
                        if (arg.value >= 0 && arg.value < 9999) com = '0%'
                        else if (arg.value > 10000 && arg.value < 24999) com = '4%'
                        else if (arg.value > 25000 && arg.value < 39999) com = '5%'
                        else if (arg.value > 40000 && arg.value < 49999) com = '6%'
                        else if (arg.value > 50000) com = '7%'
                        return 'S$' + (arg.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + '- ' + com;
                    }
                },
            },
            series: [
                { valueField: "Past", name: "Last Month", color: "#208abe" },
                { valueField: "Current", name: "This Month" },
                { valueField: "Next", name: "Next 2 Months", color: "#4e8f56" }
            ],

            legend: {
                verticalAlignment: "bottom",
                horizontalAlignment: "center"
            },
            "export": {
                enabled: true
            },
            onPointClick: function (e) {
                e.target.select();
            },
            bindingOptions: {
                dataSource: "SalesTrending"
            }
        };

        // $scope.chartOptions = {
        //     dataSource: $scope.SalesTrending,
        //     series: {
        //         argumentField: "Employee",
        //         valueField: "Sum",
        //         type: "bar",
        //         color: '#22a0d8',
        //         label: {
        //             visible: true,
        //             format: "percent",
        //             connector: {
        //                 visible: true
        //             },
        //             customizeText: function(arg) {
        //                 var com = ''
        //                 if(arg.value>0 && arg.value<9999) com = '0% Commission'
        //                 else if(arg.value>10000 && arg.value<24999) com = '4% Commission'
        //                 else if(arg.value>25000 && arg.value<39999) com = '5% Commission'
        //                 else if(arg.value>40000 && arg.value<49999) com = '6% Commission'
        //                 else if(arg.value>50000)com = '7% Commission'
        //                 return '$'+(arg.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')+' SGD - '+com ;
        //             }
        //         },
        //         showInLegend:false
        //     },
        //     bindingOptions: {
        //         dataSource: 'SalesTrending'
        //     }
        // };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('apps.crm.contracts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.contracts', {
            url: '/Contracts',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/contracts/contracts.html',
                    controller: 'contractsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/contracts');
    }

})();
(function () {
  "use strict";

  angular
    .module('apps.crm.contracts')
    .controller('contractsController', contractsController)
    .directive('ngEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter);
            });

            event.preventDefault();
          }
        });
      };
    });
  function contractsController($scope, $interval, socket, $mdSidenav, $mdToast, $http, $location, $rootScope, $window, $state, $mdDateLocale, $q, DashboardData, $document, $filter, $mdDialog, $mdConstant, Upload, indexedDBService, $timeout,
    DataSyncService) {
    document.getElementsByTagName('title')[0].text = "Customer Relationship-Contracts"
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("Contracts")) {   // do nothing 
    }
    else { $location.path("NoAccess"); }
    $window.localStorage.setItem('PQfromContract', "");

    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var EmpID = localStorage.getItem("EmployeeID");
    var vm = this;
    $scope.RenewalUpdate = false;
    $scope.Contractsform = false;
    $scope.Contractsgrid = true;
    $scope.Salesform = false;
    $scope.Export = true;
    $scope.Pageform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.ShowContractform = false;
    $scope.SpecialRem = "";
    getSor();
    RefreshCustomerdatas();

    $scope.items = [
      { a: 1, b: 10 },
      { a: 2, b: 20 },
      { a: 3, b: 30 }
    ];
    $scope.uShowClosed = false;
    $scope.sAdd = function () {
      ClearForm();
      $scope.vm.Ccontact = [];
      $scope.SID = null;
      $scope.Update = false;
      $scope.RenewalUpdate = false;
      $scope.Contractsform = true;
      $scope.Salesform = false;
      $scope.Contractsgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.vm.Header = null;
      $scope.Search = false;
      $scope.vm.CEmail = [];
      $scope.vm.SiteContactPerson = null;
      $scope.vm.SiteName = null;
      $scope.vm.SiteContact = null;
      getSor();
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    };

    vm.contactErrorMessage = false;

    $timeout(function () {
      var emailInput = angular.element(document.querySelector('[placeholder="Email"]'));
      var contactInput = angular.element(document.querySelector('[placeholder="Contact Number"]'));

      emailInput.on('blur', function () {
        var val = emailInput.val().trim();
        $scope.$apply(function () {
          vm.emailChipWarning = !!val;
        });
      });

      contactInput.on('blur', function () {
        var val = contactInput.val().trim();
        $scope.$apply(function () {
          vm.contactChipWarning = !!val;
        });
      });
    }, 500);

    $scope.transformChip = function (chip) {
      if (typeof chip === 'string') {
        chip = chip.trim();
        var isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          .test(chip);
        if (!isValid) {
          vm.emailValidationError = true;
          return null; // Reject invalid chip
        } else {
          vm.emailValidationError = false;
          return chip; // Return transformed/validated chip
        }
      }
      return chip;
    };

    vm.onEmailChipAdd = function () {
      vm.emailChipWarning = false;
    };
    vm.onContactChipAdd = function () {
      vm.contactChipWarning = false;
    };

    vm.transformPhone = function (chip) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (regex.test(chip)) {
        vm.contactErrorMessage = false;
        return chip; // valid
      } else {
        vm.contactErrorMessage = true;
        return null; // invalid, will not be added
      }
    };

    vm.validateLive = function (input) {
      var regex = /^\+60-\d{3}-\d{4}-\d{2}$/;
      if (!regex.test(input)) {
        vm.errorMessage = 'Invalid format. Use +60-123-4567-89';
      } else {
        vm.errorMessage = '';
      }
    };

    function getAllContract() {
      indexedDBService.getAll("contract").then(function (data) {
        if (data && data.length > 0) {
          $scope.AllContractdata = data;
          extract_contract_data($scope);
        } else RefreshGrid();
      });
    }

    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };

    var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
    var pass = "";
    for (var x = 0; x < 6; x++) {
      var i = Math.floor(Math.random() * chars.length);
      pass += chars.charAt(i);
    }
    var UniqID = pass;
    $scope.Showgrid = function () {
      $scope.Contractsgrid = true;
      $scope.Contractsform = false;
      $scope.Salesform = false;
      $scope.Pageform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
      $scope.ShowContractform = false;

      if ($scope.Update == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/contract/update",
          data: {
            _id: $scope.SID,
            MultiFrequency: $scope.Frequencydatas,
            UpdateFrequency: "true"
          }
        });
      }
    };
    $scope.Servicepopup = function (e, PopupType) {
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = null;
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Enter valid CC !")
              .position("top center")
          );
          return;
        }
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid email !")
            .position("top center")
        );
        return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail,
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              $scope.vm.CustomerID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
          $mdDialog.cancel();
        }
      }
    };
    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        }
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        }
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    function CustomerServicedatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
      });
    }
    //$scope.uFrom = new Date(new Date().setMonth(new Date().getMonth() - 1));
    $scope.uFrom = null;
    $scope.uTo = null;
    $scope.vm.PreviewSpinner = false;
    var dataGrid;
    var dataGrid1;
    var dataGrid2;
    var dataGrid3;
    vm.dataGridContract = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.contractdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "On-going Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Period" },
        // {
        //   dataField: "EmailSentDate",
        //   caption: "Contract Sent Date",
        //   width: "150",
        //   dataType: "datetime",
        //   format: "dd/MM/yyyy hh:mm a"
        // },
        // { dataField: "IncludeSor", caption: "Include SOR", width: "90", },
        // { dataField: "ServiceHours", caption: "Service Hours", width: "150" },
        {
          caption: "Action",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  $scope.contractinfo(options.data.id);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Preview",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  $scope.PreviewQuaotation(
                    options.data._id,
                    options.data.BillingFrequency,
                    options.data.ServiceStartDate,
                    options.data.ServiceEndDate,
                    options.data.EmployeeName,
                    "invoice"
                  );
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       $scope.PreviewQuaotation(
            //         options.data._id,
            //         options.data.BillingFrequency,
            //         options.data.ServiceStartDate,
            //         options.data.ServiceEndDate,
            //         options.data.CreatedBy,
            //         "Download"
            //       );
            //     }
            //   })
            //   .appendTo(container);
          }
        },
        // {
        //   caption: "Send Email",
        //   width: "90",
        //   fixed: false,
        //   fixedPosition: "right",
        //   alignment: "center",
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     $("<div />")
        //       .dxButton({
        //         icon: "email",
        //         onClick: function (e) {
        //           $scope.SendMail(
        //             options.data._id,
        //             options.data.Email,
        //             options.data.BillingFrequency,
        //             options.data.ServiceStartDate,
        //             options.data.ServiceEndDate,
        //             options.data.CreatedBy,
        //             "Send Email"
        //           );
        //         }
        //       })
        //       .appendTo(container);
        //   }
        // }
      ],
      bindingOptions: {
        dataSource: "contractdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          $scope.Contracteditinfo(data.event, data.data.id);
        }
      }
    };

    vm.dataGridPending = {
      onInitialized: function (e) {
        dataGrid1 = e.component;
        getAllContract();
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.Pendingcontractdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Pending Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        // { dataField: "IncludeSor", caption: "Include SOR", width: "90", },
        {
          caption: "Action",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  $scope.contractinfo(options.data.id);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Preview",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  $scope.PreviewQuaotation(
                    options.data._id,
                    options.data.BillingFrequency,
                    options.data.ServiceStartDate,
                    options.data.ServiceEndDate,
                    options.data.EmployeeName,
                    "invoice"
                  );
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       $scope.PreviewQuaotation(
            //         options.data._id,
            //         options.data.BillingFrequency,
            //         options.data.ServiceStartDate,
            //         options.data.ServiceEndDate,
            //         options.data.CreatedBy,
            //         "Download"
            //       );
            //     }
            //   })
            //   .appendTo(container);
          }
        },
        // {
        //   caption: "Send Email",
        //   width: "90",
        //   fixed: false,
        //   fixedPosition: "right",
        //   alignment: "center",
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     $("<div />")
        //       .dxButton({
        //         icon: "email",
        //         onClick: function (e) {
        //           $scope.SendMail(
        //             options.data._id,
        //             options.data.Email,
        //             options.data.BillingFrequency,
        //             options.data.ServiceStartDate,
        //             options.data.ServiceEndDate,
        //             options.data.CreatedBy,
        //             "Send Email"
        //           );
        //         }
        //       })
        //       .appendTo(container);
        //   }
        // }
      ],
      bindingOptions: {
        dataSource: "Pendingcontractdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          $scope.Contracteditinfo(data.event, data.data.id);
        }
      }
    };

    vm.dataGridRenewal = {
      onInitialized: function (e) {
        dataGrid2 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.contractRenewaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Contract Renewal Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ActualEndDate",
          caption: "Actual End Date",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        {
          caption: "Renew",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "refresh",
                onClick: function (e) {
                  $scope.RenewalUpdate = true;
                  $scope.Update = false;
                  $scope.Contracteditinfo(e.event, options.data.id);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "On-Hold",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "product",
                onClick: function (e) {
                  $scope.OnHoldID = options.data._id;
                  $scope.RenewalOnHold = true;
                  $scope.vm.ReasonforOnHold = "";
                  showOnHoldPop(e.event);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Terminate",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "close",
                onClick: function (e) {
                  $scope.TerminateID = options.data._id;
                  $scope.RenewalTermination = true;
                  $scope.vm.ReasonforReject = "";
                  ShowTerminationPopup(e.event);
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "contractRenewaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };

    vm.dataGridTerminated = {
      onInitialized: function (e) {
        dataGrid3 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.Terminateddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Terminated Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "ActualEndDate",
          caption: "Actual End Date",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        { dataField: "ReasonforReject", caption: "Reason" }
      ],
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.TerminateID = data.data._id;
          $scope.RenewalTermination = false;
          $scope.vm.ReasonforReject = "";
          ShowTerminationPopup(data.event);
        }
      },
      bindingOptions: {
        dataSource: "Terminateddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };

    var dataGrid4;
    vm.dataGridPastContract = {
      onInitialized: function (e) {
        dataGrid4 = e.component;
        // angular.forEach($scope.PastContractdatas,function(item){
        //     if(item.Renewal)
        //     if (item.Renewal == true || item.Renewal == "true")
        //     item.Renewal = "Yes"
        // else
        // item.Renewal = "No"
        // })
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.PastContractdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Past Contract Details",
        allowExportSelectedData: false
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        // {
        //     dataField: "Renewal", caption: "Renewed?",
        //     cellTemplate: function (container, options) {
        //         if (options.data.Renewal == true || options.data.Renewal == "true")
        //             $("<p style='color:black;cursor: default;'> Yes </p>").appendTo(container);
        //         else
        //             $("<p style='color:black;cursor: default;'> No </p>").appendTo(container);
        //     }
        // },
        {
          caption: "Action",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div style:border:none/>")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  $scope.contractinfo(options.data.id);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Preview",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  $scope.PreviewQuaotation(
                    options.data._id,
                    options.data.BillingFrequency,
                    options.data.ServiceStartDate,
                    options.data.ServiceEndDate,
                    options.data.EmployeeName,
                    "invoice"
                  );
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       $scope.PreviewQuaotation(
            //         options.data._id,
            //         options.data.BillingFrequency,
            //         options.data.ServiceStartDate,
            //         options.data.ServiceEndDate,
            //         options.data.CreatedBy,
            //         "Download"
            //       );
            //     }
            //   })
            //   .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "PastContractdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };

    var dataGrid5;
    vm.dataGridOnHold = {
      onInitialized: function (e) {
        dataGrid5 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.OnHolddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "On-Hold Contract Details",
        allowExportSelectedData: false
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        { dataField: "OnHoldReason", caption: "Reason" },
        {
          dataField: "On_HoldDate",
          caption: "On-Hold Date",
          dataType: "datetime",
          format: "dd/MM/yyyy"
        },
        { dataField: "OnHoldUpdatedBy", caption: "Updated By" },
        {
          caption: "Renew",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "refresh",
                onClick: function (e) {
                  $scope.RenewalUpdate = true;
                  $scope.Update = false;
                  $scope.Contracteditinfo(e.event, options.data.id);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Terminate",
          width: "90",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "close",
                onClick: function (e) {
                  $scope.TerminateID = options.data._id;
                  $scope.RenewalTermination = true;
                  $scope.vm.ReasonforReject = "";
                  ShowTerminationPopup(e.event);
                }
              })
              .appendTo(container);
          }
        }
      ],
      onCellClick: function (data) { },
      bindingOptions: {
        dataSource: "OnHolddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };

    $scope.getTerminated = function () {
      getTerminated();
    };

    function getTerminated() {
      $scope.Terminateddatas = [];
      dataGrid3.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getterminate",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (List) {
        $scope.Terminateddatas = List.data.data;
        dataGrid3.endCustomLoading();
      });
    }

    $scope.Datefilter = function () {
      if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
      $scope.contractdatas = [];
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getLength",
        data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder" }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          var Skip = 0;
          var Limit = 300;
          if (ContractLength > 0) {
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "SalesOrder",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
                var data = GList.data.data.filter(function (data) {
                  return (
                    new Date(data.ServiceEndDate).getTime() >
                    new Date().getTime()
                  );
                });
                var data1 = GList.data.data.filter(function (data) {
                  return (
                    new Date(data.ServiceEndDate).getTime() <
                    new Date().getTime()
                  );
                });
                $scope.contractdatas = data;
                $scope.PastContractdatas = data1;
                $scope.contractdatas = _.uniqWith(
                  $scope.contractdatas,
                  _.isEqual
                );
                $scope.PastContractdatas = _.uniqWith(
                  $scope.PastContractdatas,
                  _.isEqual
                );
                $scope.workOrd = $scope.contractdatas;
                $scope.vm.PreviewSpinner = false;
              });
            }
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );

      // get for Ad-hoc WorkOrder
      if (dataGrid != undefined) dataGrid.beginCustomLoading();
      $scope.Pendingcontractdatas = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getLength",
        data: { Client_Id: $rootScope.Client_Id, Type: "New" }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "New",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid != undefined) dataGrid.endCustomLoading();
                $scope.Pendingcontractdatas = GList.data.data;
                $scope.Pendingcontractdatas = _.uniqWith(
                  $scope.Pendingcontractdatas,
                  _.isEqual
                );
              });
            }
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );
    };

    $scope.Contractclose = function (e, contractId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Reject.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.contractId = contractId;
      $scope.TerminateID = contractId;
      $scope.RenewalTermination = false;
      $scope.PendingCancel = true;
      $scope.vm.ReasonforReject = "";
    };

    function ShowTerminationPopup(e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Reject.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    }

    function showOnHoldPop(e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/OnHoldPopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    }

    $scope.contractOnHold = function () {
      $http({
        method: "PUT",
        url: $rootScope.WebURL + "/contract/onHold",
        data: {
          _id: $scope.OnHoldID,
          OnHoldComments: $scope.vm.OnHoldRemarks,
          OnHoldDate: $scope.vm.OnHoldDate,
          OnHoldUpdatedBy: $rootScope.createdby
        }
      }).then(function (List) {
        // $scope.getContractRenewal();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Contract On-holded Successfully !")
            .position("top center")
        );
        $mdDialog.cancel();
      });
    };

    $scope.getOnHolddatas = function () {
      $scope.OnHolddatas = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getOnhold",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "On-Hold",
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(
        function (GList) {
          $scope.OnHolddatas = GList.data.data;
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );
    };

    $scope.RejectContract = function () {
      // $scope.getOnHolddatas();
      $http({
        method: "PUT",
        url: $rootScope.WebURL + "/contract/terminate",
        data: {
          _id: $scope.TerminateID,
          ReasonforReject: $scope.vm.ReasonforReject
        }
      }).then(function (List) {
        if ($scope.RenewalTermination) {
          // $scope.getContractRenewal();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Contract Terminated Successfully !")
              .position("top center")
          );
        } else {
          getTerminated();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Reason Updated Successfully !")
              .position("top center")
          );
          if ($scope.PendingCancel) {
            // RefreshGrid();
            $scope.PendingCancel = false;
            $scope.Contractsgrid = true;
            $scope.ShowContractform = false;
            $scope.Contractsform = false;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
          }
        }
        $mdDialog.cancel();
      });
    };

    $scope.CloseContract = function (contractId) {
      fetchContract(contractId);
      $scope.vm.ContractStatus = "Closed";
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/contract/update",
        data: {
          _id: contractId,
          SalesPerson_id: $scope.vm.SalesPerson,
          TemplateID: $scope.vm.TemplateName,
          Frequency: $scope.vm.Frequency,
          CreditTerm: $scope.vm.CreditTerm,
          IncludeSOR: $scope.vm.IncludeSOR,
          MultiFrequency: $scope.Frequencydatas,
          ContactPerson: $scope.vm.uContactPerson,
          ServiceEndDate: $scope.vm.ServiceEndDate,
          ServiceStartDate: $scope.vm.ServiceStartDate,
          Customer_id: $scope.vm.Customer_id,
          ContractStatus: $scope.vm.ContractStatus,
          Status: $scope.vm.CurrentStatus,
          StatusID: $scope.vm.CurrentStatusID,
          Email: $scope.vm.CEmail,
          BillingAddress: $scope.vm.BAddress,
          Client_Id: $rootScope.Client_Id,
          UpdatedBy: $rootScope.createdby,
          IsActive: false
        }
      });
      response.then(
        function (GList) {
          $scope.Contractsgrid = true;
          $scope.ShowContractform = false;
          $scope.Contractsform = false;
          $scope.Salesform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.Search = true;
          $scope.view = false;
          RefreshGrid();
          $mdDialog.hide();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Addcontract = function (e) {
      $scope.Contractsgrid = false;
      $scope.ShowContractform = true;
      $scope.Add = false;
      $scope.view = true;
      $scope.Export = false;
      $scope.Search = false;
      $scope.SID = null;
      getSor();
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      ClearForm();
      // $scope.vm.uCustomerID = pass;
      $scope.vm.ContractDate = new Date();
      $scope.vm.ContractReceivedBy = $rootScope.createdby;
      //var cinfo = $scope.contractdatas
      //for (var c = 1; c <= 1 + cinfo.length; c++) {
      //    var z = 'CT-' + ('0000' + c).slice(-4);
      //}
      //$scope.vm.ContractReferenceNo = z;
      $scope.vm.CurrentStatus = "New";
      $scope.vm.ContractStatus = "Open";
      $scope.vm.CurrentStatusID = 1;
      $scope.Update = false;
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
    };
    $scope.Addpesttype = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/addpesttype.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Workorderclick = function (SId) {
      if (SId != null && SId != "" && SId != undefined) {
        try {
          var eitem = $scope.salesOrderdatas.filter(function (eitem) {
            return eitem._id === SId;
          })[0];
          $scope.vm.NatureofJob = eitem.PestType;
          $scope.vm.emailSalesOrderNo = eitem.SalesOrderNo;
          if (
            eitem.customerdetails[0] != null &&
            eitem.customerdetails[0] != "" &&
            eitem.customerdetails[0] != undefined
          ) {
            $scope.vm.emailCompanyName = eitem.customerdetails[0].CompanyName;
          }
          if (
            $scope.vm.NatureofJob != null &&
            $scope.vm.NatureofJob != "" &&
            $scope.vm.NatureofJob != undefined
          ) {
            var array = $scope.vm.NatureofJob.split(",");
            var array1 = [];
            angular.forEach(array, function (value) {
              array1.push({ PestName: value });
            });
            $scope.vm.NatureofJob = array1;
          }
          $scope.vm.ContractStartDate = eitem.ContractStartDate;
          if (
            $scope.vm.ContractStartDate != null &&
            $scope.vm.ContractStartDate != ""
          ) {
            $scope.vm.ContractStartDate = new Date(eitem.ContractStartDate);
          }
          $scope.vm.ContractDuration = eitem.ContractDuration;
          $scope.vm.ContractEndDate = eitem.ContractEndDate;
          if (
            $scope.vm.ContractEndDate != null &&
            $scope.vm.ContractEndDate != ""
          ) {
            $scope.vm.ContractEndDate = new Date(eitem.ContractEndDate);
          }
          $scope.vm.SalesPerson = eitem.SalesPerson_id;
          $scope.vm.ServiceStartDate = eitem.ServiceStartDate;
          if (
            $scope.vm.ServiceStartDate != null &&
            $scope.vm.ServiceStartDate != ""
          ) {
            $scope.vm.ServiceStartDate = new Date(eitem.ServiceStartDate);
          }
          $scope.vm.ServiceEndDate = eitem.ServiceEndDate;
          if (
            $scope.vm.ServiceEndDate != null &&
            $scope.vm.ServiceEndDate != ""
          ) {
            $scope.vm.ServiceEndDate = new Date(eitem.ServiceEndDate);
          }
          $scope.vm.Frequency = eitem.Frequency;
        } catch (e) { }
      }
    };
    $scope.contractinfo = function (_id) {
      $scope.Update = true;
      $scope.Contractsform = true;
      $scope.Salesform = false;
      $scope.Contractsgrid = false;
      $scope.ContractReportTab = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.SID = _id;
      $scope.ContractID = _id;
      $scope.vm.ContractId = _id;
      $scope.Add = false;
      $scope.Search = false;
      $scope.File_id = _id;

      $scope.ActionButton = null;
      $scope.uNext = null;
      $scope.cNextActionedID = null;
      $scope.ShowRejectButton = false;
      $scope.ShowCancelButton = false;
      $scope.ShowReviseButton = false;
      $scope.IsAccess = false;
      $scope.vm.ContractNo = _id;
      $scope.vm.CAddress;
      $scope.vm.ContractId = _id;
      $http({
        url: $rootScope.WebURL + "/contract/getContractbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var value = List.data.data[0];
        $scope.vm.UpCAddress = value.CustomerID;
        $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
        $scope.vm.ContractStartDate = value.ContractStartDate;
        $scope.Frequencydatas = value.MultiFrequency;
        $scope.vm.CTotalOrderValue = parseFloat(value.ContractValue);
        $scope.vm.TotalSum = value.ContractValue;
        $scope.vm.ServiceHours = value.ServiceHours;
        $scope.vm.Customer_ID = value.Customer_Id;
        angular.forEach($scope.Frequencydatas, function (item) {
          try {
            item.Freq = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1]);
          } catch (error) { }
        });
        $scope.vm.CreditTerm = value.CreditTerm;
        if (
          $scope.vm.ContractStartDate != null &&
          $scope.vm.ContractStartDate != ""
        ) {
          $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
        }
        $scope.vm.ContractDuration = value.ContractDuration;
        $scope.vm.uCompanyName1 = value.CompanyName;
        $scope.vm.ContractEndDate = value.ContractEndDate;
        if (
          $scope.vm.ContractEndDate != null &&
          $scope.vm.ContractEndDate != ""
        ) {
          $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
        }
        $scope.BillinAddress = value.BillingAddres;
        $scope.vm.uEmail = value.Email;
        $scope.vm.Ccontact = value.ContactNumber;
        $scope.vm.CustomerID = value.CustomerID;
        $scope.vm.ContractNotes = value.ContractNotes;
        $scope.vm.CreatedBy = value.CreatedBy;
        $scope.vm.SalesPerson = value.SalesPerson_id;
        $scope.vm.SalesPerson1 = value.EmployeeName;
        $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
        $scope.vm.ContactPerson = value.ContactPerson;
        $scope.vm.ServiceStartDate = value.ServiceStartDate;
        if (
          $scope.vm.ServiceStartDate != null &&
          $scope.vm.ServiceStartDate != ""
        ) {
          $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
          $scope.ServiceStartDate = new Date(value.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = value.ServiceEndDate;
        if (
          $scope.vm.ServiceEndDate != null &&
          $scope.vm.ServiceEndDate != ""
        ) {
          $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
          $scope.ServiceEndDate = new Date(value.ServiceEndDate);
        }
        $scope.vm.Frequency = value.BillingFrequency;
        $scope.Frequency = value.BillingFrequency;
        if (value.MultiFrequency && value.MultiFrequency.length > 0) {
          $scope.TempFrequency = value.MultiFrequency.map(function (obj) {
            return obj.Frequency;
          }).join(",  ");
        } else {
          $scope.TempFrequency = $scope.vm.Frequency;
        }
        $scope.vm.SiteContactPerson = value.SiteContactPerson;
        $scope.vm.SiteName = value.SiteName;
        if (
          value.SiteContact != null &&
          value.SiteContact != undefined &&
          value.SiteContact != ""
        )
          $scope.vm.SiteContact = value.SiteContact;
        else $scope.vm.SiteContact = [];
        if (
          value.SiteEmail != null &&
          value.SiteEmail != undefined &&
          value.SiteEmail != ""
        )
          $scope.vm.SEmail = value.SiteEmail.split(",");
        else $scope.vm.SEmail = [];
        $scope.vm.EnquiryID = value.EnquiryID;
        $scope.MultiFrequencydatas = value.MultiFrequency;
        $scope.vm.TemplateName = value.TemplateID;
        $scope.vm.SalesOrderID = value.SalesOrderID;
        $scope.vm.CreditTerm = value.CreditTerm;
        $scope.CreditTerm = value.CreditTerm;
        $scope.vm.IncludeSOR = value.IncludeSOR;
        $scope.vm.Customer_id = value.Customer;
        $scope.vm.NatureofJob1 = value.PestType;
        $scope.vm.Quote = value.Quote;
        $scope.vm.Customer = value.Customer;
        $scope.vm.ContractStatus = value.ContractStatus;
        $scope.vm.CurrentStatus = value.Status;
        $scope.vm.CurrentStatusID = value.StatusID;
        $scope.RenewalN = value.Renewal;
        $scope.OldContract_Id = value.OldContract_Id;
        $scope.vm.PurchaseOrderNo = value.PurchaseOrderNo;
        //Customer

        var response1 = $http({
          url: $rootScope.WebURL + "/customer/get",
          method: "POST",
          data: { id: value.Customer_Id }
        });
        response1.then(function (customer) {
          var customer = customer.data.data;
          $scope.vm.Customer_id = customer._id;
          $scope.vm.uCustomerID = customer.CustomerID;
          $scope.CustID = customer.CustomerID;
          $scope.vm.uCustomerType = customer.CustomerType;
          $scope.vm.uSalutation = customer.Salutation;
          $scope.vm.uFirstName = customer.FirstName;
          $scope.vm.uLastName = customer.LastName;
          $scope.vm.uWebsite = customer.Website;
          $scope.vm.uCompanyName = customer.CompanyName;
          $scope.vm.uNote = customer.Note;
          $scope.vm.uAddress1 = customer.Address1;
          $scope.vm.uPostal = customer.Postal;
          $scope.vm.uCountry = customer.Country;
          $scope.vm.uContactPerson = customer.ContactPerson;
          $scope.vm.uPhone = parseInt(customer.Phone);
          $scope.vm.uFax = customer.Fax;
          $scope.Email = [];
          $scope.Email.push(customer.Email);
          var Mobile = customer.Mobile;
          if (Mobile != "" && Mobile != null && Mobile != undefined)
            $scope.vm.uMobile = Mobile.split(",").join(" , ");
          //
          $scope.vm.uTypeofHouse = customer.TypeofHouse;
          $scope.vm.uOtherType = customer.OtherType;
        });
        $scope.vm.uSAddress = value.sStreetName;
        $scope.vm.TempTemplate = value.TemplateName;

        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforBilling",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerBillingdata) {
          $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
          var item = $scope.CustomerBillingAddress.filter(function (item) {
            return item._id === value.BillingAddress;
          })[0];
          if (item != undefined) {
            $scope.vm.uAddress = item.bStreetName;
            $scope.Email.push(customer.bEmail);
          } else $scope.vm.uAddress = null;
        });
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });

        RefreshContractAttachment();
        RefreshAttachmentGrid();
        Refreshcomment();
      });
      // Refreshquotationlog();
    };

    $scope.GetEmail = function (Email) {
      if (Email != null && Email != undefined && Email != "")
        $scope.vm.CEmail = Email.split(",");
      else $scope.vm.CEmail = [];
    };

    $scope.Contracteditinfo = function (e, _id) {
      $scope.vm.emailValidationError = false
      $scope.Contractsgrid = false;
      $scope.ShowContractform = true;
      $scope.Contractsform = false;
      $scope.Salesform = false;
      $scope.Add = false;
      $scope.view = true;
      $scope.Export = false;
      $scope.Search = false;
      $scope.RenewalUpdate = false;
      $scope.SID = _id;
      $scope.ContractId = _id;
      $scope.vm.ContractId = _id;
      RefreshContractAttachment();
      $scope.ContarctAttachmentdatas = [];
      $http({
        url: $rootScope.WebURL + "/contract/getContractbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var value = List.data.data[0];

        $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
        $scope.vm.ContractReference = value.ContractReferenceNo;
        $scope.vm.ContractReceivedBy = value.ContractReceivedBy;
        $scope.vm.PurchaseOrder = value.PurchaseOrder;
        $scope.vm.ContractDate = new Date(value.ContractDate);
        $scope.vm.CustomerID = value.CustomerID;
        $scope.vm.Customer_id = value.Customer_id;
        var Requestid = value.CustomerIDD;
        getSorDetails($scope.SID);
        var Email = value.Email;
        if (Email != "" && Email != null && Email != undefined)
          $scope.vm.CEmail = value.Email.split(",");
        else $scope.vm.CEmail = [];
        $scope.vm.ppCompanyName = value.CompanyName;

        // Customer Service
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: Requestid }
        });
        response.then(function (CustomerServicedata) {
          var customerServicedetails = CustomerServicedata.data.data;
          if (customerServicedetails.length > 0) {
            $scope.vm.BAddress = customerServicedetails[0].sStreetName;
            var BillingAddres = [
              { sStreetName: customerServicedetails[0].sStreetName }
            ];
            $scope.CustomerServiceAddress = customerServicedetails;
            $scope.vm.SiteName = customerServicedetails[0].sName;
            var Mob = customerServicedetails[0].sMobile;
            if (Mob != undefined && Mob != null && Mob != "")
              $scope.vm.SiteContactNo = Mob.split(",");
            else $scope.vm.SiteContactNo = [];
            $scope.vm.SiteContactPerson =
              customerServicedetails[0].sContactPerson;
            var Email = customerServicedetails[0].sEmail;
            if (Email != undefined && Email != null && Email != "")
              $scope.vm.SEmail = Email.split(",");
            else $scope.vm.SEmail = [];
            $scope.CustomerServiceAddress = customerServicedetails;
          } else {
            $scope.CustomerServiceAddress = [];
            $scope.vm.SiteName = "";
            $scope.vm.SiteContactNo = [];
            $scope.vm.SiteContactPerson = null;
            $scope.vm.SEmail = [];
            $scope.CustomerServiceAddress = customerServicedetails;
          }
        });

        //Customer

        var response1 = $http({
          url: $rootScope.WebURL + "/customer/get",
          method: "POST",
          data: { id: value.Customer_Id }
        });
        response1.then(function (customer) {
          var customer = customer.data.data;
          $scope.vm.CSalutation = customer.Salutation;
          $scope.vm.CName = customer.FirstName;
        });

        $scope.vm.NatureofJob = value.PestType;
        $scope.vm.BillingFrequency = value.BillingFrequency;
        $scope.vm.ContractStartDate = value.ContractStartDate;
        $scope.vm.ContractEndDate = value.ContractEndDate;
        $scope.vm.ContractDuration = parseInt(value.ContractDuration);
        $scope.vm.BAdress = value.SiteName;

        $scope.vm.CAddress = value.CustomerID;
        $scope.vm.UpCAddress = value.CustomerID;

        if (
          value.MarketSegment != null &&
          value.MarketSegment != "" &&
          value.MarketSegment != undefined
        ) {
          var a = value.MarketSegment.split(",");
          var array = [];
          _.each(a, function (ite) {
            array.push({ SegmentName: ite });
          });
          $scope.vm.CMarketSegment = array;
        }

        // $scope.vm.CMarketSegment = value.MarketSegment;
        var connumber = value.ContactNumber;
        if (connumber != null && connumber != undefined && connumber != "")
          $scope.vm.Ccontact = connumber.split(",").slice(0, 3);
        else $scope.vm.Ccontact = [];
        $scope.vm.ServiceHours = value.ServiceHours;
        $scope.vm.TotalSumPerfreq = parseInt(value.TotalSumPerfreq);
        $scope.vm.TotalOrderValue = parseFloat(value.ContractValue);
        if (
          $scope.vm.NatureofJob != null &&
          $scope.vm.NatureofJob != "" &&
          $scope.vm.NatureofJob != undefined
        ) {
          var array = $scope.vm.NatureofJob.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.vm.NatureofJob = array1;
        }
        $scope.vm.SalesOrderID = value.SalesOrderID;
        $scope.vm.ContractMode = value.ContractMode;
        $scope.vm.CoverageArea = value.CoverageArea;
        $scope.vm.PurchaseOrderNo = value.PurchaseOrderNo;
        if (
          $scope.vm.CoverageArea != null &&
          $scope.vm.CoverageArea != "" &&
          $scope.vm.CoverageArea != undefined
        ) {
          var array = $scope.vm.CoverageArea.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ AreasName: value });
          });
          $scope.vm.CoverageArea = array1;
        }
        $scope.vm.Header = value.Head;
        $scope.vm.Header1 = value.Head1;
        $scope.vm.Header2 = value.Head2;
        $scope.vm.ContactMedium = value.ContactMedium;
        $scope.vm.SalesPerson = value.SalesPerson_id;
        $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
        if (
          $scope.vm.ExpectedResponseDate != null &&
          $scope.vm.ExpectedResponseDate != ""
        ) {
          $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
        }
        $scope.vm.uSAddress = value.sStreetName;
        $scope.vm.Frequency = value.Frequency;
        $scope.vm.Confirmation = value.Confirmation;
        $scope.vm.ContractType = value.ContractType;
        $scope.vm.Quote = value.Quote;
        $scope.vm.ContractStatus = value.ContractStatus;
        $scope.vm.CurrentStatus = value.Status;
        $scope.vm.CurrentStatusID = value.StatusID;
        $scope.vm.IncludeSOR = value.IncludeSOR;
        $scope.vm.ServiceEndDate = value.ServiceEndDate;
        $scope.vm.ServiceStartDate = value.ServiceStartDate;
        $scope.vm.Servicestart = value.ServiceStartDate;
        $scope.vm.Serviceend = value.ServiceEndDate;
        $scope.vm.CreditTerm = value.CreditTerm;
        $scope.vm.TemplateName = value.TemplateID;
        $scope.Frequencydatas = value.MultiFrequency;
        $scope.vm.EnquiryID = value.EnquiryID;
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforBilling",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerBillingdata) {
          $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
          $scope.vm.BAddress = value.BillingAddress;
        });
        try {
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === $scope.vm.Customer_id;
          });
          $scope.Leaddatas = litem;
        } catch (error) { }

        try {
          var item = $scope.Leaddatas.filter(function (item) {
            return item.LeadReferenceNo === $scope.vm.EnquiryID;
          })[0];
          $scope.vm.EnquiryID = item.LeadReferenceNo;
          if (
            $scope.vm.TotalOrderValue == null ||
            $scope.vm.TotalOrderValue == undefined ||
            $scope.vm.TotalOrderValue == ""
          )
            $scope.vm.TotalOrderValue = parseFloat(item.Pipelinevalue);
        } catch (error) { }

        $scope.vm.keys = [
          $mdConstant.KEY_CODE.ENTER,
          $mdConstant.KEY_CODE.COMMA
        ];
      });
    };

    $scope.SendMail = function (
      PCId,
      Email,
      BillFrequency,
      ServiceStart,
      ServiceEnd,
      EmployeeDatails,
      invoice
    ) {
      var item = $scope.contractdatas.filter(function (item) {
        return item._id === PCId;
      })[0];
      var Uitem = $scope.Userdatas.filter(function (item) {
        return item.UserID == $rootScope.createdby;
      })[0];
      $scope.MailTo = Email;
      $scope.CCTo = Uitem.Email + ",sales@pestoff.com.sg";
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure, you want to send Email ? <br><br> Mail Id: <b>" +
        $scope.MailTo +
        "</b><br> CC : <b>" +
        $scope.CCTo,
        "Email Confirmation!"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          if (
            $scope.MailTo != undefined &&
            $scope.MailTo != null &&
            $scope.MailTo != ""
          )
            var Email = $scope.MailTo.split(",");
          else
            return $mdToast.show(
              $mdToast
                .simple()
                .textContent("Mail Id is not valid!")
                .position("top center")
            );
          var item = Email.filter(function (item) {
            return validateEmail(item) == false;
          });
          if (item.length > 0) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Mail Id is not valid!")
                .position("top center")
            );
          } else {
            if (
              $scope.CCTo != undefined &&
              $scope.CCTo != null &&
              $scope.CCTo != ""
            )
              var Email = $scope.CCTo.split(",");
            else
              return $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("CC Id is not valid!")
                  .position("top center")
              );
            var item = Email.filter(function (item) {
              return validateEmail(item) == false;
            });
            if (item.length > 0) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("CC is not valid!")
                  .position("top center")
              );
            } else {
              $scope.PreviewQuaotation(
                PCId,
                BillFrequency,
                ServiceStart,
                ServiceEnd,
                EmployeeDatails,
                invoice
              );
            }
          }
        }
        //
      });
    };
    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    $scope.cancel = function () {
      $mdDialog.cancel();
    };
    $scope.Totla = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        var secondDate = new Date(uTimeOut);
        if (
          firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)
        ) {
          return "Expiried";
        } else {
          var res = Math.round(
            Math.abs((secondDate.getTime() - firstDate.getTime()) / oneDay)
          );
          if (res == 0) {
            return "Expiried";
          } else {
            return res;
          }
        }
      } else {
        return null;
      }
    };
    $scope.renewalpopup = function (e, renewalId, Cname, Crn) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/contracts/renewal.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.RenewalId = renewalId;
      $scope.vm.Cname = Cname;
      $scope.vm.Crn = Crn;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractDuration = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.Frequency = null;
    };
    $scope.RenewalSubmit = function (renewalId) {
      try {
        var item = $scope.contractdatas.filter(function (item) {
          return item._id === renewalId;
        })[0];
        $scope.item = item;
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/add",
          data: {
            PestType: item.PestType,
            SalesPerson_id: item.SalesPerson_id,
            Frequency: $scope.vm.Frequency,
            ContractDuration: $scope.vm.ContractDuration,
            ContactNumber: $scope.vm.Ccontact,
            ContactPerson: item.ContactPerson,
            ContractStartDate: $scope.vm.ContractStartDate,
            ContractEndDate: $scope.vm.ContractEndDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            Customer_id: item.Customer_id,
            CustomerID: item.CustomerID,
            ContractNotes: item.ContractNotes,
            SalesOrderID: item.SalesOrderID,
            EnquiryID: item.vm.EnquiryID,
            Email: $scope.vm.CEmail,
            ContractStatus: "Open",
            Status: "New",
            StatusID: 1,
            OldContract_Id: $scope.vm.RenewalId,
            Renewal: "Renewaled",
            SiteContactPerson: $scope.vm.SiteContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            BillingAddress: $scope.vm.BAddress,
            SiteContact: $scope.vm.SiteContact,
            CreatedBy: $rootScope.createdby,
            IsActive: true,
            Client_Id: $rootScope.Client_Id
          }
        });
      } catch (e) { }
      response.then(
        function (GList) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotationlog/add",
            data: {
              ContractID: $scope.GListdata.id,
              Status: "New",
              TableName: "Contracts",
              StatusCreatedBy: $rootScope.createdby,
              StatusCreatedDate: new Date(),
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(function (GList) {
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("center")
            );
            RefreshGrid();
            $scope.Contractsgrid = true;
            $scope.Contractsform = false;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
          });
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Renewal = function (e) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/contracts/renewal.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function EmployeeController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.RenewalDate = "";
      $scope.RenewalContractNo = "";
      $scope.CreatedDate = "";
      $scope.CreatedBy = "";
      $scope.RUpdate == false;
    };
    $scope.DaysCalc = function (CED) {
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var firstDate = new Date($scope.vm.ContractStartDate);
      var secondDate = new Date($scope.vm.ContractEndDate);
      $scope.vm.ContractDuration =
        Math.round(
          Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
        ) + 1;
    };
    $scope.ShowClosed = function (ShowClosed) {
      if (ShowClosed == true) {
        $scope.uShowClosed = true;
        $scope.contractdatas = $scope.ContractHalf;
      } else {
        // Refreshcomment();
        // RefreshAttachmentGrid();
        $scope.uShowClosed = false;
        $scope.contractdatas = $scope.ContractAll;
      }
      angular.forEach($scope.contractdatas, function (value) {
        try {
          value.ContractDate =
            new Date(value.ServiceStartDate).toLocaleDateString("en-GB") +
            " - " +
            new Date(value.ServiceEndDate).toLocaleDateString("en-GB");
          value.IncludeSor = value.IncludeSOR ? "Yes" : "No";
          value.TempPestType = value.MultiFrequency.map(function (obj) {
            return obj.PestType;
          }).join(",");
          var pest = value.TempPestType.split(",");
          var PestArray = [];
          PestArray = $scope.Pestdatas.filter(function (pestt) {
            return pest.includes(pestt.PestName);
          });
          value.PestCode = PestArray.map(function (obj) {
            if (
              obj.Pestcode != null &&
              obj.Pestcode != undefined &&
              obj.Pestcode != ""
            )
              return obj.Pestcode;
            else return obj.PestName;
          }).join(",");
        } catch (e) { }
      });
    };
    $scope.PreviewQuaotation = function (
      PCId,
      BillFrequency,
      ServiceStart,
      ServiceEnd,
      EmployeeDatails,
      invoice
    ) {
      $scope.vm.ContractDuration = " ";
      $scope.vm.BillingFrequency = BillFrequency;
      $scope.vm.ServiceStartDate = new Date(ServiceStart);
      $scope.vm.ServiceEndDate = new Date(ServiceEnd);
      $scope.UserID = EmployeeDatails;
      try {
        var employeedetails = $scope.Employeedatas.filter(function (f) {
          return f.EmployeeName === EmployeeDatails
        })[0]
        var item = $scope.Userdatas.filter(function (item) {
          return item.EmployeeID == employeedetails.EmployeeID;
        });
        angular.forEach(item, function (value) {
          $scope.UserID = value.id;
        });
      } catch (e) { }
      CalculateDuration();
      var url =

        $rootScope.ReportURL +
        "Contracts.aspx" +
        "?" +
        "ID=" +
        PCId +
        "&Duration=" +
        $scope.vm.ContractDuration +
        "&UserID=" +
        $scope.UserID +
        "&Type=" +
        invoice;
      if (invoice == "Send Email") {
        if (dataGrid != undefined) dataGrid.beginCustomLoading();
        if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/SendEmail",
          data: {
            url: url
          }
        });
        response.then(function (List) {
          // RefreshGrid();
          if (dataGrid != undefined) dataGrid.endCustomLoading();
          if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Email Sent Successfully !")
              .position("top center")
          );
        });
      }
      //  window.open(url, "_blank", "toolbar=1, scrollbars=1, resizable=1, width=" + 1015 + ", height=" + 800);
      else window.open(url);
    };
    $scope.Preview = function () {
      if ($scope.vm.Header != null) {
        $scope.Frequencygroups = _.groupBy($scope.Frequencydatas, "Frequency");
        $scope.Previewdiv = true;
        var innerContents = document.getElementById("invoice").innerHTML;
        var popupWinindow = window.open(
          "",
          "_blank",
          "width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
        );
        popupWinindow.document.open();
        popupWinindow.document.write(
          '<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body  onload="window.print()">' +
          innerContents +
          "<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>"
        );
        popupWinindow.document.close(($scope.Previewdiv = false));
      }
    };

    $scope.ContractReport = function (ContractId) {
      var url =

        $rootScope.ReportURL +
        "Contracts.aspx" +
        "?" +
        "ID=" +
        ContractId;
      window.open(url);
    };

    function CalculateDuration() {
      try {
        var Frequency = $scope.vm.BillingFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          var TotalMonths = Math.round(Totaldays / 30);
          $scope.vm.ContractDuration = TotalMonths;
          if ($scope.vm.ContractDuration > 1) {
            $scope.vm.ContractDuration = TotalMonths + " months";
          } else {
            $scope.vm.ContractDuration = TotalMonths + " month";
          }
        }
      } catch (e) { }
    }
    $scope.sSubmit = function () {
      try {
        angular.forEach($scope.salesOrderdatas, function (svalue) {
          if ($scope.vm.SalesOrderID == svalue._id) {
            $scope.vm.Customer_id = svalue.customerdetails[0]._id;
          }
        });
      } catch (error) { }
      var CEmail = "";
      var SEmail = "";
      var Ccontact = "";
      var CMarketSegment = "";
      var NatureofJob = "";
      if (
        $scope.vm.NatureofJob != null &&
        $scope.vm.NatureofJob != "" &&
        $scope.vm.NatureofJob != undefined
      ) {
        NatureofJob = $scope.vm.NatureofJob.map(function (obj) {
          return obj.PestName;
        }).join(",");
      }
      if (
        $scope.vm.CMarketSegment != null &&
        $scope.vm.CMarketSegment != "" &&
        $scope.vm.CMarketSegment != undefined
      ) {
        CMarketSegment = $scope.vm.CMarketSegment.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      if (
        $scope.vm.CEmail != null &&
        $scope.vm.CEmail != "" &&
        $scope.vm.CEmail != undefined
      ) {
        CEmail = $scope.vm.CEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != "" &&
        $scope.vm.SEmail != undefined
      ) {
        SEmail = $scope.vm.SEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.Ccontact != null &&
        $scope.vm.Ccontact != "" &&
        $scope.vm.Ccontact != undefined
      ) {
        Ccontact = $scope.vm.Ccontact.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (!$scope.dataSource) $scope.dataSource = $scope.Sordatas;
      if ($scope.RenewalUpdate == false) {
        if ($scope.Update == true) {
          var response = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/contract/update",
            data: {
              _id: $scope.SID,
              SalesPerson_id: $scope.vm.SalesPerson,
              //  Frequency: multiFrequency,
              MarketSegment: CMarketSegment,
              CreditTerm: $scope.vm.CreditTerm,
              TemplateID: $scope.vm.TemplateName,
              IncludeSOR: $scope.vm.IncludeSOR,
              MultiFrequency: $scope.Frequencydatas,
              ContactPerson: $scope.vm.uContactPerson,
              ServiceEndDate: $scope.vm.ServiceEndDate,
              ContactNumber: Ccontact,
              ServiceStartDate: $scope.vm.ServiceStartDate,
              ContractStartDate: $scope.vm.ContractStartDate,
              ContractEndDate: $scope.vm.ContractEndDate,
              ContractDuration: $scope.vm.ContractDuration,
              ContractValue: $scope.vm.TotalOrderValue,
              ServiceHours: $scope.vm.ServiceHours,
              BillingFrequency: $scope.vm.BillingFrequency,
              TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
              Customer_id: $scope.vm.Customer_id,
              CustomerID: $scope.vm.CustomerID,
              EnquiryID: $scope.vm.EnquiryID,
              ContractNotes: $scope.vm.ContractNotes,
              ContractStatus: $scope.vm.ContractStatus,
              PurchaseOrder: $scope.vm.PurchaseOrder,
              Status: $scope.vm.CurrentStatus,
              StatusID: $scope.vm.CurrentStatusID,
              Email: CEmail,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              // SiteContactPerson:$scope.vm.SiteContactPerson,
              // SiteEmail:$scope.vm.SEmail,
              // SiteName:$scope.vm.SiteName,
              BillingAddress: $scope.vm.BAddress,
              // SiteContact:$scope.vm.SiteContact,
              Head: $scope.vm.Header,
              Head1: $scope.vm.Header1,
              Head2: $scope.vm.Header2
            }
          });
          response.then(
            function (GList) {
              $scope.GListdata = GList.data.data;
              if ($scope.vm.IncludeSOR == true) {
                var response1 = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/sor/deletebyContract",
                  data: {
                    Contract_Id: $scope.GListdata.id
                  }
                });
                response1.then(function (Ls) {
                  var count = 0;
                  $scope.dataSource = _.uniqBy(
                    $scope.dataSource,
                    "Description",
                    "Unit"
                  );
                  angular.forEach($scope.dataSource, function (item) {
                    var response2 = $http({
                      method: "POST",
                      url: $rootScope.WebURL + "/sor/add",
                      data: {
                        Customer: $scope.vm.Customer_id,
                        Contract: $scope.SID,
                        Description: item.Description,
                        Unit: item.Unit,
                        RateDuringOfficeHour: item.RateDuringOfficeHour,
                        RateAfterOfficeHour: item.RateAfterOfficeHour,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                      }
                    });
                    response2.then(function (GList) {
                      count++;
                      if (count == $scope.dataSource.length + 1) {
                        $mdToast.show(
                          $mdToast
                            .simple()
                            .textContent("SOR Added Successfully !")
                            .position("top center")
                        );
                      }
                    });
                  });
                });
              }
              $mdDialog.cancel();
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Successfully Updated!")
                  .position("top center")
              );
              // RefreshGrid();
              $scope.Contractsgrid = true;
              $scope.ShowContractform = false;
              $scope.Contractsform = false;
              $scope.Salesform = false;
              $scope.Export = true;
              $scope.Add = true;
              $scope.Search = true;
              $scope.view = false;
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $scope.dataSource = _.uniqBy(
            $scope.dataSource,
            "Description",
            "Unit"
          );
          var ContractArray = [];
          angular.forEach($scope.vm.CAddress, function (Lis) {
            try {
              var multiFrequency = $scope.Frequencydatas[0].Frequency;
            } catch (e) {
              var multiFrequency = $scope.vm.Frequency;
            }
            ContractArray.push({
              SalesPerson_id: $scope.vm.SalesPerson,
              Frequency: multiFrequency,
              MarketSegment: CMarketSegment,
              CreditTerm: $scope.vm.CreditTerm,
              TemplateID: $scope.vm.TemplateName,
              IncludeSOR: $scope.vm.IncludeSOR,
              MultiFrequency: $scope.Frequencydatas,
              ContactNumber: Ccontact,
              ContactPerson: $scope.vm.uContactPerson,
              ServiceEndDate: $scope.vm.ServiceEndDate,
              ServiceStartDate: $scope.vm.ServiceStartDate,
              ContractStartDate: $scope.vm.ContractStartDate,
              ContractEndDate: $scope.vm.ContractEndDate,
              ContractDuration: $scope.vm.ContractDuration,
              ContractValue: $scope.vm.TotalOrderValue,
              ServiceHours: $scope.vm.ServiceHours,
              BillingFrequency: $scope.vm.BillingFrequency,
              TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
              Customer_id: $scope.vm.Customer_id,
              CustomerID: Lis._id,
              PurchaseOrder: $scope.vm.PurchaseOrder,
              EnquiryID: $scope.vm.EnquiryID,
              ContractNotes: $scope.vm.ContractNotes,
              ContractStatus: $scope.vm.ContractStatus,
              Status: $scope.vm.CurrentStatus,
              StatusID: $scope.vm.CurrentStatusID,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              SORDetails: $scope.dataSource,
              Head: $scope.vm.Header,
              Head1: $scope.vm.Header1,
              Head2: $scope.vm.Header2,
              Email: CEmail,
              SiteContactPerson: $scope.vm.SiteContactPerson,
              SiteEmail: SEmail,
              BillingAddress: $scope.vm.BAddress,
              SiteContact: $scope.vm.SiteContact
            });
          });

          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/contract/addbyarray",
            data: { data: ContractArray }
          });
          response.then(
            function (GList) {
              $scope.GListdata = GList.data.data;
              $mdDialog.cancel();
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Successfully Added!")
                  .position("top center")
              );

              $scope.GListdata.forEach(function (item) {
                // $scope.PreviewQuaotation(
                //   item.id,
                //   $scope.vm.BillingFrequency,
                //   $scope.vm.ServiceStartDate,
                //   $scope.vm.ServiceEndDate,
                //   $rootScope.createdby,
                //   "invoice"
                // );
              });
              $scope.ShowContractform = false;
              $scope.Contractsgrid = true;
              $scope.Contractsform = false;
              $scope.Salesform = false;
              $scope.Export = true;
              $scope.Add = true;
              $scope.view = false;
              $scope.Search = true;
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      } else {
        $scope.dataSource = _.uniqBy($scope.dataSource, "Description", "Unit");
        try {
          var multiFrequency = $scope.Frequencydatas[0].Frequency;
        } catch (e) {
          var multiFrequency = $scope.vm.Frequency;
        }
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/renewal",
          data: {
            OldContract_Id: $scope.SID,
            SalesPerson_id: $scope.vm.SalesPerson,
            Frequency: multiFrequency,
            RenewalRemarks: $scope.vm.RenewalRemarks,
            MarketSegment: $scope.vm.CMarketSegment,
            CreditTerm: $scope.vm.CreditTerm,
            TemplateID: $scope.vm.TemplateName,
            IncludeSOR: $scope.vm.IncludeSOR,
            MultiFrequency: $scope.Frequencydatas,
            ContactNumber: $scope.vm.Ccontact,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ContractStartDate: $scope.vm.ContractStartDate,
            ContractEndDate: $scope.vm.ContractEndDate,
            ContractDuration: $scope.vm.ContractDuration,
            ContractValue: $scope.vm.TotalOrderValue,
            ServiceHours: $scope.vm.ServiceHours,
            BillingFrequency: $scope.vm.BillingFrequency,
            TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
            Customer_id: $scope.vm.Customer_id,
            CustomerID: $scope.vm.CAddress,
            EnquiryID: $scope.vm.EnquiryID,
            ContractNotes: $scope.vm.ContractNotes,
            ContractStatus: $scope.vm.ContractStatus,
            Status: $scope.vm.CurrentStatus,
            StatusID: $scope.vm.CurrentStatusID,
            CreatedBy: $rootScope.createdby,
            IsActive: "true",
            Client_Id: $rootScope.Client_Id,
            SORDetails: $scope.dataSource,
            Head: $scope.vm.Header,
            Head1: $scope.vm.Header1,
            Head2: $scope.vm.Header2,
            Email: $scope.vm.CEmail,
            SiteContactPerson: $scope.vm.SiteContactPerson,
            SiteEmail: $scope.vm.SEmail,
            BillingAddress: $scope.vm.BAddress,
            SiteContact: $scope.vm.SiteContact
          }
        });
        response.then(
          function (GList) {
            $scope.GListdata = GList.data.data;
            if ($scope.vm.IncludeSOR == true) {
              var response1 = $http({
                method: "POST",
                url: $rootScope.WebURL + "/sor/deletebyContract",
                data: {
                  Contract_Id: $scope.GListdata.id
                }
              });
              response1.then(function (Ls) {
                var count = 0;
                angular.forEach($scope.dataSource, function (item) {
                  var response2 = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/sor/add",
                    data: {
                      Customer: $scope.vm.Customer_id,
                      Contract: $scope.GListdata.id,
                      Description: item.Description,
                      Unit: item.Unit,
                      RateDuringOfficeHour: item.RateDuringOfficeHour,
                      RateAfterOfficeHour: item.RateAfterOfficeHour,
                      Client_Id: $rootScope.Client_Id,
                      CreatedBy: $rootScope.createdby
                    }
                  });
                  response2.then(function (GList) {
                    count++;
                    if (count == $scope.dataSource.length + 1) {
                      $mdToast.show(
                        $mdToast
                          .simple()
                          .textContent("SOR Added Successfully !")
                          .position("top center")
                      );
                    }
                  });
                });
              });
            }
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Contract Renewed Successfully!")
                .position("top center")
            );
            RefreshGrid();
            $scope.ShowContractform = false;
            $scope.Contractsgrid = true;
            $scope.Contractsform = false;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };

    $scope.commentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          ContractID: $scope.SID,
          CustomerID: $scope.vm.CustomerID,
          TableName: "Contracts",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(
        function (GList) {
          RefreshGrid();
          $scope.vm.Addcomments = "";
          $scope.Contractsgrid = false;
          $scope.Contractsform = true;
          $scope.Salesform = false;
          $scope.Export = false;
          $scope.Add = false;
          $scope.view = true;
          $scope.Search = false;
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Frequencydatas = [];
    $scope.ChangeTreatmentType = function (item) {
      if (item.TreatmentName == "Others" && item.selected == true) {
        $scope.ShowOthersTextBox = true;
      } else if (item.TreatmentName == "Others" && item.selected !== true) {
        $scope.ShowOthersTextBox = false;
      }
    };
    $scope.AddPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.Treatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/AddPestTypepopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.ChangeTreatment = function (Pestdata) {
      $scope.Treatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.Treatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        var OthersSelect = false;
        var ServiceTypeSelect = false;
        if (Pestdata.Others !== undefined) {
          OthersSelect = true;
        } else {
          OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          ServiceTypeSelect = true;
        } else {
          ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.Treatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          SelectServiceTrap: ServiceTypeSelect
        });
      }
    };
    $scope.SubmitPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.Treatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        var ServiceTrap = item.ServiceTrap;
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }
        if (OthersTreatment != undefined) {
          if (Treatmentarray != null && Treatmentarray != "") {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        array = $scope.Frequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });

        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }
        if (OthersTreatment != undefined) {
          if (Treatmentarray != null && Treatmentarray != "") {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }

        if (array.length == 0) {
          $scope.Frequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      $mdDialog.hide();
    };
    $scope.EditPestControl = function (e, item) {
      RefreshTreatment();
      $scope.EditFrequency = true;
      $scope.vm.Frequency = item.Frequency;
      $scope.vm.Pesttype = item.PestType;
      $scope.vm.ServiceTrap = item.ServiceTrap;
      $scope.ChangeTreatment(item);
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/AddPestTypepopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.DeleteTempPest = function (DeleteItem) {
      var index = $scope.PestTreatmentdatas.indexOf(DeleteItem);
      $scope.PestTreatmentdatas.splice(index, 1);
    };
    $scope.DeletePestControl = function (DeleteItem) {
      var index = $scope.Frequencydatas.indexOf(DeleteItem);
      $scope.Frequencydatas.splice(index, 1);
    };

    $scope.UploadContractfiles = function (file) {
      angular.forEach(file, function (item) {
        var upfile = item.file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/contract/upload",
          data: { file: upfile }
        }).then(
          function (resp) {
            $scope.TableID = resp.data.data[0].GUIDFILENAME;
            $scope.fileName = resp.data.data[0].OriginalFileName;
            $scope.fileSize = resp.data.data[0].Size;
            $scope.Path = resp.data.data[0].Path;
            $scope.fileType = resp.data.data[0].Type;
            if (resp.data.message == "Successfully Uploaded") {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/add",
                data: {
                  TableID: $scope.TableID,
                  TableName: "Contracts",
                  FileID: $scope.vm.ContractId,
                  FileName: $scope.fileName,
                  FileSize: $scope.fileSize,
                  FileType: $scope.fileType,
                  ModuleID: $scope.Path,
                  Data: null,
                  IsActive: "true",
                  CreatedBy: $rootScope.createdby
                }
              });
              response.then(
                function (GList) {
                  RefreshContractAttachment();
                },
                function () {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        "Something entered gone wrong,please try again !"
                      )
                      .position("top center")
                  );
                }
              );
            }
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      });
      file[0].cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("Successfully Added!")
          .position("top center")
      );
    };

    function RefreshContractAttachment() {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.ContractId }
      });
      response.then(function (attachmentdata) {
        $scope.ContarctAttachmentdatas = attachmentdata.data.data;
      });
    }

    $scope.Uploadfiles = function (file) {
      angular.forEach(file, function (item) {
        var upfile = item.file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/salesOrder/upload",
          data: { file: upfile }
        }).then(
          function (resp) {
            $scope.TableID = resp.data.data[0].GUIDFILENAME;
            $scope.fileName = resp.data.data[0].OriginalFileName;
            $scope.fileSize = resp.data.data[0].Size;
            $scope.Path = resp.data.data[0].Path;
            $scope.fileType = resp.data.data[0].Type;
            if (resp.data.message == "Successfully Uploaded") {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/add",
                data: {
                  TableID: $scope.TableID,
                  TableName: "Sales Order",
                  FileID: UniqID,
                  FileName: $scope.fileName,
                  FileSize: $scope.fileSize,
                  FileType: $scope.fileType,
                  ModuleID: $scope.Path,
                  Data: null,
                  IsActive: "true",
                  CreatedBy: $rootScope.createdby
                }
              });
              response.then(
                function (GList) {
                  RefreshAttachmentGrid();
                },
                function () {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        "Something entered gone wrong,please try again !"
                      )
                      .position("top center")
                  );
                }
              );
            }
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      });
      file[0].cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("Successfully Added!")
          .position("top center")
      );
    };

    $scope.DeleteAttachement = function (e, deleteID) {
      $scope.AttachdeleteID = deleteID;
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/contracts/attachmentdelete.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    // $scope.Adelete = function (AttachmentdeleteID) {
    //     var response = $http({
    //         method: "POST",
    //         url:  $rootScope.WebURL + "/attachment/delete",
    //         data: { _id: AttachmentdeleteID },
    //     });
    //     response.then(function (GList) {
    //         RefreshAttachmentGrid();
    //         $mdDialog.cancel();
    //         $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
    //     }, function () {
    //         $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
    //     });
    // }

    $scope.Adelete = function (e, AttachmentdeleteID, datas) {
      if ($scope.Update == false) {
        var index = $scope.Attachmentdatas.indexOf(datas);
        $scope.Attachmentdatas.splice(index, 1);
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/attachment/delete",
          data: { _id: AttachmentdeleteID }
        });
        response.then(
          function (GList) {
            RefreshAttachmentGrid();
            RefreshContractAttachment();
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Deleted!")
                .position("top center")
            );
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };

    $scope.ChangeCustomer = function (Customerdata) {
      $scope.vm.CMarketSegment = null;
      try {
        CustomerBillingdatadetails(Customerdata.CustomerID);
        $scope.vm.CName = Customerdata.FirstName;
        $scope.vm.CSalutation = Customerdata.Salutation;
        $scope.vm.uCustomerID = Customerdata.CustomerID;
        $scope.vm.CreditTerm = Customerdata.CreditTerm;
        $scope.vm.Ccontact = [];
        var contact = Customerdata.Mobile;
        if (contact != "" && contact != null && contact != undefined) {
          contact = contact.split(",").slice(0, 3);
          $scope.vm.Ccontact = contact;
        }

        //
        // $scope.vm.CAddress = Customerdata.StreetName;
        // $scope.vm.CPostalCode = Customerdata.Postal;
        // $scope.vm.CBuildingName = Customerdata.BuildingName;
        if (
          Customerdata.MarketSection != null &&
          Customerdata.MarketSection != "" &&
          Customerdata.MarketSection != undefined
        ) {
          var a = Customerdata.MarketSection.split(",");
          var array = [];
          _.each(a, function (ite) {
            array.push({ SegmentName: ite });
          });
          $scope.vm.CMarketSegment = array;
        }
        $scope.CusEmail = [];
        $scope.GetEmail(Customerdata.Email);
        //  $scope.vm.CMarketSegment = Customerdata.MarketSection;
        //
        // $scope.vm.Ccontact = Customerdata.Mobile;
        try {
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === Customerdata._id;
          });
          $scope.Leaddatas = litem;
        } catch (e) { }
        if ($scope.Leaddatas.length > 0) {
          $scope.vm.EnquiryID =
            $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
          if (
            $scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == "Day"
          )
            $scope.vm.ServiceHours = "During Office Hours";
          else if (
            $scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == "Night"
          )
            $scope.vm.ServiceHours = "After Office Hours";
          else $scope.vm.ServiceHours = "Wee Hours 12:00pm - 8:30am";
          $scope.vm.TotalOrderValue = parseFloat(
            $scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue
          );
        }
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: Customerdata.CustomerID }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });
      } catch (e) {
        $scope.vm.CMarketSegment = null;
      }
    };
    $scope.getLeaddetails = function (row) {
      if (row.ServiceTime == "Day")
        $scope.vm.ServiceHours = "During Office Hours";
      else if (row.ServiceTime == "Night")
        $scope.vm.ServiceHours = "After Office Hours";
      else $scope.vm.ServiceHours = "Wee Hours 12:00pm - 8:30am";
      $scope.vm.TotalOrderValue = parseFloat(row.Pipelinevalue);
    };
    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }

    function RefreshCustomerdatas() {
      $scope.getCustomerdatas = [];
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.getCustomerdatas = customerdata;
        $scope.Customerdatas = $scope.getCustomerdatas;
        if (IsAdmin != true) {
          var item = $scope.getCustomerdatas.filter(function (item) {
            if (item.AssignedUser != null)
              return item.AssignedUser.includes($rootScope.createdby);
          });
          $scope.Customerdatasfordropdown = item;
        } else {
          $scope.Customerdatasfordropdown = $scope.getCustomerdatas;
        }
      });
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
      $scope.Pestdatasdatas = pestdata.data.data;
    });
    RefreshSchedulerFrequency();
    RefreshTreatment();
    function RefreshTreatment() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Treatmentdata) {
        $scope.Treatmentdatas = Treatmentdata.data.data;
      });
    }
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/user/getByClientId",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Userdata) {
      $scope.Userdatas = Userdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (salesOrderdata) {
      $scope.salesOrderdatas = salesOrderdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/Workflow",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Workflowdata) {
      $scope.Workflowdatas = Workflowdata.data.data;
      // $scope.Datefilter();
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contracttemplate",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (contracttemplate) {
      $scope.Contracttemplates = contracttemplate.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/crmscopeofwork",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (sowdata) {
      $scope.SOWdatas = sowdata.data.data;
    });
    function RefreshGrid() {
      const Limit = 500;

      $scope.contractdatas = [];
      $scope.workOrd = [];
      $scope.Pendingcontractdatas = [];

      // Start loading indicators
      if (dataGrid1) dataGrid1.beginCustomLoading();
      if (dataGrid) dataGrid.beginCustomLoading();

      // Function to fetch paginated contract data
      return $http
        .post($rootScope.WebURL + "/contract/getnewLength", {
          Client_Id: $rootScope.Client_Id
        })
        .then(function (res) {
          var total = parseInt(res.data.data);
          var totalPages = Math.ceil(total / Limit);
          var requests = [];

          for (var i = 0; i < totalPages; i++) {
            const skip = i * Limit;
            requests.push(
              $http.post(
                $rootScope.WebURL + "/contract/getfortable",
                {
                  Client_Id: $rootScope.Client_Id,
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: skip,
                  Limit: Limit
                }
              )
            );
          }

          return Promise.all(requests);
        })
        .then(function (responses) {
          const allContracts = _.uniqWith(
            responses.flatMap(function (r) {
              return r.data.data;
            }),
            _.isEqual
          );

          $scope.contractdatas = allContracts;
          $scope.workOrd = allContracts;
          $scope.AllContractdata = allContracts;

          // Save to IndexedDB
          indexedDBService.clearStore("contract").then(function () {
            indexedDBService.addAll("contract", allContracts);
          });
          $scope.vm.PreviewSpinner = false;
          extract_contract_data($scope);
        })

        .catch(function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                "Error loading SalesOrder contracts. Please refresh the page."
              )
              .position("top center")
          );
          if (dataGrid1) dataGrid1.endCustomLoading();
          if (dataGrid) dataGrid.endCustomLoading();
        });
    }

    $scope.Refresh = function () {
      $scope.Add = true;
      $scope.RenewalUpdate = false;
      $scope.uFrom = null;
      $scope.uTo = null;
      RefreshGrid();
    };

    $scope.getContractRenewal = function () {
      $scope.contractRenewaldatas = [];
      $scope.Add = false;
      var StartDate = new Date(new Date().setMonth(new Date().getMonth() + 3));
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getrenewal",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "SalesOrder",
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id,
          Skip: 0,
          Limit: 20000,
          StartDate: new Date(0),
          EndDate: StartDate
        }
      }).then(function (GList) {
        $scope.vm.PreviewSpinner = false;
        $scope.contractRenewaldatas = GList.data.data;
        $scope.workOrd = $scope.contractRenewaldatas;
      });
    };

    function RefreshAttachmentGrid() {
      if ($scope.Salesform == true) $scope.File_id = UniqID;
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
      // var response1 = $http({
      //     url:  $rootScope.WebURL + "/attachment/getByFileID",
      //     method: "POST",
      //     data: { FileID: $rootScope.ID },
      // });
      // response1.then(function (attachmentdata) {
      //     $scope.UserAttachments = attachmentdata.data.data;
      //     $scope.FilePath = null;
      //     try {
      //         $scope.FilePath = $rootScope.UploadsURL + 'Security/Users/' + $scope.Attachmentdatas[0].TableID;
      //         $scope.fileName = null;
      //     } catch (e) {
      //         $scope.FilePath = null;
      //     }
      // });
    }
    function Refreshcomment() {
      var response = $http({
        url:
          $rootScope.WebURL + "/schedulercomment/getByContractID",
        method: "POST",
        data: { RequestID: $scope.File_id }
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
      });
    }
    function Refreshquotationlog() {
      var response = $http({
        url: $rootScope.WebURL + "/quotationlog/getByRequestID",
        method: "POST",
        data: { Contract_id: $scope.File_id }
      });
      response.then(function (Quotationlogdata) {
        $scope.Quotationlogdatas = Quotationlogdata.data.data;
        var resArr = [];
        try {
          $scope.Quotationlogdatas.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return x.Status == item.Status;
            });
            if (i <= -1) resArr.push(item);
          });
        } catch (e) { }
        $scope.Quotationlogdatas = resArr;
      });
    }
    function quotationlogsubmit() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/quotationlog/add",
        data: {
          ContractID: $scope.SID,
          TableName: "Contracts",
          Status: $scope.cNextActioned,
          StatusCreatedBy: $scope.createdby,
          StatusCreatedDate: new Date(),
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(function (GList) {
        RefreshGrid();
      });
    }
    function fetchContract(contractId) {
      angular.forEach($scope.contractdatas, function (value) {
        if (value._id == contractId) {
          $scope.vm.ContractId = value._id;
          $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
          $scope.vm.ContractStartDate = value.ContractStartDate;
          if (
            $scope.vm.ContractStartDate != null &&
            $scope.vm.ContractStartDate != ""
          ) {
            $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
          }
          $scope.vm.ContractDuration = value.ContractDuration;
          $scope.vm.uCompanyName = value.CustomerName;
          $scope.vm.ContractEndDate = value.ContractEndDate;
          if (
            $scope.vm.ContractEndDate != null &&
            $scope.vm.ContractEndDate != ""
          ) {
            $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
          }
          $scope.vm.ContractNotes = value.ContractNotes;
          $scope.vm.CreatedBy = value.CreatedBy;
          $scope.vm.SalesPerson = value.SalesPerson;
          $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
          $scope.vm.ContactPerson = value.ContactPerson;
          $scope.vm.ServiceStartDate = value.ServiceStartDate;
          if (
            $scope.vm.ServiceStartDate != null &&
            $scope.vm.ServiceStartDate != ""
          ) {
            $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
          }
          $scope.vm.ServiceEndDate = value.ServiceEndDate;
          if (
            $scope.vm.ServiceEndDate != null &&
            $scope.vm.ServiceEndDate != ""
          ) {
            $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
          }
          $scope.vm.Frequency = value.Frequency;
          $scope.vm.SalesOrderID = value.SalesOrderID;
          $scope.vm.NatureofJob1 = value.PestType;
          $scope.vm.ContractStatus = value.ContractStatus;
          $scope.vm.CurrentStatus = value.Status;
          $scope.vm.CurrentStatusID = value.StatusID;
        }
        RefreshContractAttachment();
      });
    }
    $scope.CalculateTotalServices = function () {
      try {
        var Frequency = $scope.vm.BillingFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          if (Frequency.toUpperCase() == "DAILY") {
            $scope.vm.ContractDuration = Totaldays;
          } else if (Frequency.toUpperCase() == "WEEKLY") {
            var TotalWeeks = Math.round(Totaldays / 7);
            $scope.vm.ContractDuration = TotalWeeks;
          } else if (Frequency.toUpperCase() == "YEARLY") {
            var Totalyearss = Math.round(Totaldays / 365);

            $scope.vm.ContractDuration = Totalyearss;
          } else if (
            Frequency.toUpperCase() == "BIMONTHLY" ||
            Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 60);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else if (
            Frequency.toUpperCase() == "HALF-YEARLY" ||
            Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 183);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else if (
            Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
            Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
            Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 14);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else {
            //for Month
            var TotalMonths = Math.round(Totaldays / 30);

            $scope.vm.ContractDuration = TotalMonths;
          }
        }
      } catch (e) { }
    };
    function ClearForm() {
      $scope.vm.emailValidationError = false
      $scope.vm.CustomerName = null;
      $scope.OldContract_Id = null;
      $scope.vm.Customer_id = null;
      $scope.vm.SalesOrderID = null;
      $scope.vm.CMarketSegment = null;
      $scope.vm.CSalutation = null;
      $scope.vm.CName = null;
      $scope.vm.Ccontact = [];
      $scope.vm.CAddress = null;
      $scope.vm.CPostalCode = null;
      $scope.vm.CBuildingName = null;
      $scope.vm.ContractReferenceNo = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.NatureofJob = null;
      $scope.vm.ContractValue = null;
      $scope.vm.ContractDuration = null;
      $scope.vm.uContactPerson = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractNotes = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.SalesPerson = null;
      $scope.vm.Frequency = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.TemplateName = null;
      $scope.vm.CreditTerm = null;
      $scope.Frequencydatas = [];
      $scope.vm.IncludeSOR = false;
      $scope.vm.CEmail = [];
      $scope.vm.SEmail = [];
      $scope.vm.BAddress = null;
      $scope.vm.SiteContactPerson = null;
      $scope.vm.SiteName = null;
      $scope.vm.SiteContact = [];
      $scope.vm.BillingFrequency = null;
      $scope.vm.TotalOrderValue = 0
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
    }

    $scope.getRowColour = function (item) {
      if (item.MultiFrequency !== undefined && item.MultiFrequency.length > 0) {
        var Frequencies = item.MultiFrequency;
        item.TempFrequency = Frequencies.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        var PestType = item.MultiFrequency.map(function (obj) {
          return obj.PestType;
        }).join(",");
        PestType = PestType.split(",");
        var array1 = [];

        angular.forEach(PestType, function (value) {
          if (array1.indexOf(value) == -1) {
            array1.push(value);
          }
        });
        item.TempPestType = array1
          .map(function (obj) {
            return obj;
          })
          .join(", ");
      } else {
        item.TempFrequency = item.Frequency;
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var ServiceEndDate = item.ServiceEndDate;
      if (new Date(ServiceEndDate) < new Date(today)) {
        return true;
      } else {
        return false;
      }
    };

    // var vm = this;
    //// Data
    vm.dashboardData = DashboardData;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtOptions1 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      drawCallback: function (settings) {
        var api = this.api();

        var rows = api.rows({ page: "current" }).nodes();
        var last = null;

        api
          .column(1, { page: "current" })
          .data()
          .each(function (group, i) {
            if (last !== group) {
              $(rows)
                .eq(i)
                .before(
                  '<tr class="group"><td colspan="18"><b>' +
                  group +
                  "</b></td></tr>"
                );

              last = group;
            }
          });
      }
    };
    function ClearWOForm() {
      $scope.vm.SalesOrderNo = null;
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ConfirmationMode = null;
      $scope.vm.ConfirmationBy = null;
      $scope.vm.ConfirmationReceivedBy = null;
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.Remarks = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.PONumber = null;
      $scope.vm.PestType = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.CustomerName = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.Frequency = null;
      $scope.vm.TotalSum = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.Types = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.vm.ServicesRequired = null;
      $scope.vm.TotalPrice = null;
      $scope.vm.CoverageArea = null;
      $scope.vm.PurchaseOrderNo = null;
      $scope.vm.DateTimeofTreatment = "";
      $scope.vm.TotalTripsPerYear = 0;
      $scope.vm.SpecialRemarks = null;
      $scope.vm.SpecialRemark = null;
      $scope.vm.BAddress = null;
      $scope.vm.BContactPerson = null;
      $scope.vm.BContactNo = null;
      $scope.vm.BEmail = [];
      $scope.vm.SLocation = null;
      $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
      // $scope.vm.SContactNo = $scope.vm.SiteContact;
      $scope.vm.SName = $scope.vm.SiteName;
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != undefined &&
        $scope.vm.SEmail != ""
      )
        $scope.vm.SiteEmail = $scope.vm.SEmail;
      else $scope.vm.SiteEmail = [];
    }
    $scope.CreateWorkOrder = function (e) {
      $scope.Salesform = true;
      $scope.Contractsform = false;
      $scope.Contractsgrid = false;
      $scope.Export = false;
      $scope.Pageform = false;
      $scope.Add = false;
      $scope.Search = false;
      $scope.ShowContractform = false;
      $scope.view = true;
      ClearWOForm();
      // $scope.vm.uAddress = $scope.vm.CAddress
      $scope.vm.TrendingReport = "false";
      $scope.vm.Department = "Pest Off";
      $scope.vm.BAddress = $scope.vm.uAddress;
      $scope.vm.SContactPerson = null;
      $scope.Commentdatas = [];
      $scope.CommentArray = [];
      $scope.Attachmentdatas = [];
      $scope.vm.OrderType = "Contract";
      $scope.vm.IsUrgent = "false";
      // $scope.vm.ContractNo = $scope.vm.ContractReferenceNo
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.CustomerName = $scope.vm.Customer_id;
      if (
        $scope.vm.uEmail != null &&
        $scope.vm.uEmail != undefined &&
        $scope.vm.uEmail != ""
      )
        $scope.vm.BEmail = $scope.vm.uEmail.split(",");
      else $scope.vm.BEmail = [];
      $scope.vm.BContactPerson = $scope.vm.uContactPerson;
      if (
        $scope.vm.Ccontact != null &&
        $scope.vm.Ccontact != undefined &&
        $scope.vm.Ccontact != ""
      )
        $scope.vm.BContactNo = $scope.vm.Ccontact.split(",").slice(0, 3);
      else $scope.vm.BContactNo = [];
      $scope.WOFrequencydatas = $scope.MultiFrequencydatas;
      $scope.vm.ServiceStartDate = new Date($scope.ServiceStartDate);
      $scope.vm.ServiceEndDate = new Date($scope.ServiceEndDate);
      angular.forEach($scope.WOFrequencydatas, function (item) {
        item.JobsPerFrequency = 1;
        // $scope.calculateServices(item.Frequency, item.JobsPerFrequency)
        try {
          $scope.vm.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
          item.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
        } catch (error) {
          $scope.vm.ServicesRequired = 0;
          item.ServicesRequired = 0;
        }
      });
      if ($scope.WOFrequencydatas.length > 0) {
        var num = _.maxBy($scope.WOFrequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }

      $scope.vm.SLocation = $scope.vm.UpCAddress;
      $scope.vm.BillingFrequency = $scope.Frequency;
      $scope.vm.CreditTerm = $scope.CreditTerm;
      $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
      if (
        $scope.vm.SiteContact != null &&
        $scope.vm.SiteContact != undefined &&
        $scope.vm.SiteContact != ""
      )
        $scope.vm.SiteContact = $scope.vm.SiteContact.split(",");
      try {
        var litem = $scope.Leaddetails.filter(function (litem) {
          return litem.CustomerID === $scope.vm.Customer_id;
        });
        $scope.Leaddatas = litem;
      } catch (error) { }

      if (
        $scope.vm.SLocation != null &&
        $scope.vm.SLocation != "" &&
        $scope.vm.SLocation != undefined
      ) {
        $scope.DisableServiceLocation = true;
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: $scope.CustID }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });
      } else $scope.DisableServiceLocation = false;
      try {
        var item = $scope.Leaddatas.filter(function (item) {
          return item.LeadReferenceNo === $scope.vm.EnquiryID;
        })[0];

        $scope.vm.EnquiryReferenceNo = item.LeadReferenceNo;
        if (
          $scope.vm.CTotalOrderValue == null ||
          $scope.vm.CTotalOrderValue == undefined ||
          $scope.vm.CTotalOrderValue == ""
        )
          $scope.vm.TotalPrice = parseFloat(item.Pipelinevalue);
        else $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue);
      } catch (error) {
        $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue);
        $scope.vm.EnquiryReferenceNo = null;
      }

      if (item == undefined) {
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (marketsegmentdata) {
          var info = marketsegmentdata.data.data;
          var y = "";
          for (var x = 1001; x <= 1001 + info.length; x++) {
            y = "EQ/RN/" + x;
          }
          $scope.vm.EnquiryReferenceNo = y;
        });
      }
      $scope.vm.keys1 = [
        $mdConstant.KEY_CODE.ENTER,
        $mdConstant.KEY_CODE.COMMA
      ];
    };

    $scope.calculateServices = function (freq, job) {
      try {
        $scope.vm.ServicesRequired = parseInt(freq.match(/\(([^)]+)\)/)[1]);
      } catch (error) {
        $scope.vm.ServicesRequired = 0;
      }
    };

    function CustomerBillingdatadetails(Requestid) {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
        // var CustomerBillingdatas = CustomerBillingdata.data.data;
        // if (CustomerBillingdatas.length > 0) {
        //     $scope.vm.BAddress = CustomerBillingdatas[0].bStreetName;
        // $scope.vm.SContactPerson = CustomerBillingdatas[0].bContactPerson;
        // $scope.vm.SContactNo = CustomerBillingdatas[0].bMobile;
        //    $scope.vm.BEmail = CustomerBillingdatas[0].sEmail;
        // }
      });
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerServicedata) {
        var CustomerServicedatas = CustomerServicedata.data.data;
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        if (CustomerServicedatas.length > 0) {
          // $scope.vm.SLocation = CustomerServicedatas[0].sStreetName;
          $scope.vm.SContactPerson = CustomerServicedatas[0].sContactPerson;
          $scope.vm.SContactNo = CustomerServicedatas[0].sMobile;
          $scope.vm.SName = CustomerServicedatas[0].sName;
        }
      });
    }

    $scope.AddWOPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.WOTreatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.Editpest = function (e, Pestdata) {
      $scope.PestUpdate = true;
      $scope.vm.Frequency = Pestdata.Frequency;
      $scope.vm.JobsPerFrequency = Pestdata.JobsPerFrequency;
      $scope.vm.ServicesRequired = Pestdata.ServicesRequired;
      $scope.vm.PestType = Pestdata.PestType;
      //   $scope.vm.SelectPest =  Pestdata.PestType;
      if (
        $scope.vm.PestType != null &&
        $scope.vm.PestType != "" &&
        $scope.vm.PestType != undefined
      ) {
        var array = $scope.vm.PestType.split(",");
        var array1 = [];
        angular.forEach(array, function (value) {
          array1.push({ PestName: value });
        });
        $scope.vm.PestType = array1;
      }
      $scope.vm.SelectPest = $scope.vm.PestType;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.Pestdata = Pestdata;
      if ($scope.PestUpdate == true) {
        $scope.vm.JobsPerFrequency = $scope.vm.JobsPerFrequency || 1;
        // $scope.calculateServices($scope.vm.Frequency, $scope.vm.JobsPerFrequency)
        try {
          item.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
        } catch (error) {
          item.ServicesRequired = 0;
        }
      }
    };

    $scope.ForAlternateWeek = function (freq) {
      if (
        freq == "Alternate Week (52)" ||
        freq === "Alternate Twice a Week (104)"
      ) {
        var item = $scope.Pestdatas.filter(function (item) {
          return item.PestName === "Adult Mosquito";
        });
        $scope.Pestdatasdatas = item;
      } else $scope.Pestdatasdatas = $scope.Pestdatas;
    };
    $scope.CheckTreatment = function () {
      debugger;
      if ($scope.vm.Frequency === "Alternate Week (52)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Week frequency!"
            )
            .position("center")
        );
      }
      if ($scope.vm.Frequency === "Alternate Twice a Week (104)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Twice a Week frequency!"
            )
            .position("center")
        );
      }
    };

    $scope.ChangeWOTreatment = function (Pestdata) {
      $scope.WOTreatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.WOTreatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        if (Pestdata.Others !== undefined) {
          var OthersSelect = true;
        } else {
          var OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          var ServiceTypeSelect = true;
        } else {
          var ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.WOTreatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          ServiceTypeSelect: ServiceTypeSelect
        });
        if ($scope.WOFrequencydatas.length > 0) {
          $scope.Pesttypearray = [];
          $scope.WOTreatmentpopupdata = [];
          angular.forEach(Pestdata, function (pestdata) {
            angular.forEach($scope.WOFrequencydatas, function (value) {
              if (pestdata.PestName == value.PestType) {
                var Pestname = pestdata.PestName;
                var array = [];
                var selectothers = false;
                var Others = "";
                var ServiceTrap = "";
                var SelectServiceTrap = false;
                var item1 = $scope.Treatmentdatas.filter(function (item1) {
                  if (item1.PestType.indexOf(Pestname) > -1) {
                    item1.selected = false;

                    if (value.Treatment != undefined) {
                      var selectedtreatment = value.Treatment.split(", ");
                      if (
                        selectedtreatment.indexOf(item1.TreatmentName) !== -1
                      ) {
                        item1.selected = true;
                      } else item1.selected = false;
                    }
                    array.push({
                      TreatmentName: item1.TreatmentName,
                      selected: item1.selected
                    });
                  }
                  if (value.Others != undefined) {
                    selectothers = true;
                    Others = value.Others;
                  }
                  if (value.ServiceTrap != undefined) {
                    SelectServiceTrap = true;
                    ServiceTrap = value.ServiceTrap;
                  }
                });
                array.map(function (o, k) {
                  if (o.TreatmentName === "Service Light Traps")
                    if (k != undefined) array.splice(k);
                });
                $scope.WOTreatmentpopupdata.push({
                  PestName: Pestname,
                  Treatment: array,
                  selectothers: selectothers,
                  Others: Others,
                  SelectServiceTrap: SelectServiceTrap,
                  ServiceTrap: ServiceTrap
                });
              }
            });
          });
        }
      }
    };
    $scope.switchValue = true;
    $scope.IsUrgent = {
      onText: "YES",
      offText: "NO",
      bindingOptions: {
        value: "switchValue"
      }
    };
    $scope.SubmitWOPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.WOTreatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        var ServiceTrap = item.ServiceTrap;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }
        if (OthersTreatment != undefined && Treatmentarray != "") {
          if (Treatmentarray != null) {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        array = $scope.WOFrequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });
        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }

        $scope.EditFrequency = true;
        if (array.length == 0) {
          $scope.WOFrequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].JobsPerFrequency = $scope.vm.JobsPerFrequency;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].ServicesRequired = $scope.vm.ServicesRequired;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
          $scope.EditFrequency == false;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      if ($scope.WOFrequencydatas.length > 0) {
        var num = _.maxBy($scope.WOFrequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }
      $mdDialog.hide();
    };

    $scope.WOSubmit = function () {
      $scope.Email.push($scope.vm.ServiceEmail);
      $scope.Email.push($scope.vm.ServiceEmailCC);

      $scope.Email = $scope.Email.map(function (o) {
        return o;
      }).join(",");
      $scope.groupFrequency = _.groupBy($scope.WOFrequencydatas, "Frequency");
      var salesOrderArray = [];
      angular.forEach($scope.WOFrequencydatas, function (value) {
        if (
          value.JobsPerFrequency == null &&
          value.JobsPerFrequency == undefined &&
          value.ServicesRequired == null &&
          value.ServicesRequired == undefined
        ) {
          salesOrderArray.push(1);
        }
      });
      if (salesOrderArray.length > 0)
        return $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please Add Jobs Per Frequency and Services Required for Treatment Frequency!"
            )
            .position("top center")
        );

      $scope.vm.PaymentMode = $scope.vm.PaymentMode;

      if (
        $scope.Frequencydatas != null &&
        $scope.Frequencydatas != "" &&
        $scope.Frequencydatas != undefined
      ) {
        $scope.vm.Frequency = $scope.Frequencydatas.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        $scope.vm.PestType = $scope.Frequencydatas.map(function (obj) {
          return obj.PestType;
        }).join(",");
        $scope.vm.Treatment = $scope.Frequencydatas.map(function (obj) {
          return obj.Treatment;
        }).join(",");
        $scope.vm.JobsPerFrequency = $scope.Frequencydatas.map(function (obj) {
          return obj.JobsPerFrequency;
        }).join(",");
        $scope.vm.ServicesRequired = $scope.Frequencydatas.map(function (obj) {
          return obj.ServicesRequired;
        }).join(",");
      }
      if (
        $scope.vm.BEmail != null &&
        $scope.vm.BEmail != "" &&
        $scope.vm.BEmail != undefined
      ) {
        $scope.vm.BEmail = $scope.vm.BEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != "" &&
        $scope.vm.SEmail != undefined
      ) {
        $scope.vm.SEmail = $scope.vm.SEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.BContactNo != null &&
        $scope.vm.BContactNo != "" &&
        $scope.vm.BContactNo != undefined
      ) {
        $scope.vm.BContactNo = $scope.vm.BContactNo.map(function (obj) {
          return obj;
        }).join(",");
      }
      var salesOrderArray = [];

      salesOrderArray.push({
        MultiFrequency: $scope.Frequencydatas,
        SalesPerson_id: $scope.vm.SalesPerson,
        ContractNo: $scope.vm.ContractNo,
        Customer_id: $scope.vm.Customer_ID,
        EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
        OrderConfirmationDate: $scope.vm.OrderConfirmationDate,
        ContactPerson: $scope.vm.uContactPerson,
        ServiceStartDate: $scope.vm.ServiceStartDate,
        ServiceEndDate: $scope.vm.ServiceEndDate,
        OrderType: $scope.vm.OrderType,
        TotalSum: $scope.vm.TotalSum,
        IsUrgent: $scope.vm.IsUrgent,
        PaymentMode: $scope.vm.PaymentMode,
        BillingFrequency: $scope.vm.BillingFrequency,
        EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
        RemarksFinance: $scope.vm.RemarksFinance,
        CoverageArea: $scope.vm.CoverageArea,
        PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
        DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
        TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
        SpecialRemarks: $scope.vm.Message,
        CreatedBy: $rootScope.createdby,
        Client_Id: $rootScope.Client_Id,
        TotalPrice: $scope.vm.TotalPrice,
        PestType: $scope.vm.PestType,
        Frequency: $scope.vm.Frequency,
        Treatment: $scope.vm.Treatment,
        JobsPerFrequency: $scope.vm.JobsPerFrequency,
        TrendingReport: $scope.vm.TrendingReport,
        Department: $scope.vm.Department,
        ServicesRequired: $scope.vm.ServicesRequired,
        CustomerID: $scope.vm.SLocation,
        SiteContactNo: $scope.vm.SiteContact,
        Mobile: $scope.vm.BContactNo,
        Email: $scope.vm.BEmail,
        SiteContactPerson: $scope.vm.SiteContactPerson,
        SiteEmail: $scope.vm.SEmail,
        SiteName: $scope.vm.SiteName,
        SiteContact: $scope.vm.SiteContact,
        SpecialChemical: $scope.vm.SpecialChemical,
        PreferredTime: $scope.vm.PreferredTime,
        Message: $scope.vm.Message,
        CommentArray: $scope.CommentArray,
        SchedulerEmail: $scope.Email,
        BillingAddress: $scope.BillinAddress,
        UniqID: UniqID
      });
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/addbyArray",
        data: { salesOrderArray: salesOrderArray }
      });
      response.then(function (List) {
        var Id = List.data.data.id;

        // RefreshGrid();
        $scope.CommentArray = [];
        $scope.Commentdata = [];
        $scope.Attachmentdatas = [];
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Work Order Successfully Added!")
            .position("top center")
        );
        $scope.Contractsgrid = true;
        $scope.Contractsform = false;
        $scope.Salesform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        $scope.Search = true;
      });
    };

    $scope.DeleteComment = function (data) {
      $scope.delComId = data.key;
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure, you want to delete the comment?",
        "Confirm!"
      );
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          _.remove($scope.Commentdatas, function (o) {
            return o.key === $scope.delComId;
          });
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Deleted Successfully!")
              .position("top center")
          );
        }
      });
    };

    $scope.SORDerails = function (tick, e, check) {
      $scope.Disablesubmit = false;
      if (tick == true) {
        $mdDialog.show({
          multiple: true,
          templateUrl: "app/main/apps/crm/contracts/AddSor.html",
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          controller: function contractsController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            };
          }
        });
        var updating = false;
        $scope.dataGridOptions = {
          dataSource: $scope.Sordatas,
          keyExpr: "_id",
          showBorders: true,
          paging: {
            enabled: false
          },

          editing: {
            mode: "batch",
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            useIcons: true
          },
          onRowUpdating: function (e) {
            updating = true;
          },
          onRowRemoving: function (e) {
            updating = true;
          },
          onRowInserting: function (e) {
            updating = true;
          },
          onContentReady: function (e) {
            if (e.component.hasEditData()) {
              $scope.Disablesubmit = true;
            } else $scope.Disablesubmit = false;
          },
          columns: [
            {
              caption: "#",
              width: "50",
              cellTemplate: function (cellElement, cellInfo) {
                cellElement.text(
                  cellInfo.component.pageIndex() *
                  cellInfo.component.pageSize() +
                  cellInfo.row.rowIndex +
                  1
                );
              }
            },
            {
              dataField: "Description",
              caption: "Description",
              width: "30%"
            },
            {
              dataField: "Unit",
              width: "10%"
            },
            {
              dataField: "RateDuringOfficeHour",
              caption: "Rate ($) During Office Hour",
              width: "15%"
            },
            {
              dataField: "RateAfterOfficeHour",
              caption: "Rate ($) After Office Hour",
              width: "15%"
            }
          ]
        };
      }
      if (check == false) $scope.ShowSubmit = false;
      else $scope.ShowSubmit = true;
    };

    $scope.SubmitSOR = function () {
      $scope.dataSource = $("#gridContainer")
        .dxDataGrid("instance")
        .option("dataSource");
      if ($scope.dataSource.length == 0)
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Please Fill SOR details or Click Cancel button !")
            .position("top center")
        );
      else $scope.cancel();
    };

    function RefreshComments(ID) {
      var response = $http({
        url:
          $rootScope.WebURL + "/schedulercomment/getByContractID",
        method: "POST",
        data: { RequestID: ID }
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate);
        });
        $scope.Commentdatas.reverse();
      });
    }
    $scope.CommentArray = [];
    $scope.AddComment = function () {
      //     if($scope.Update==true){
      // var response = $http({
      //   method: "POST",
      //   url:  $rootScope.WebURL + "/comment/add",
      //   data: {
      //     TableRowID: $scope.SID,
      //     TableName: "SalesOrder",
      //     CommentedBy: $rootScope.createdby,
      //     cmt: $scope.vm.SpecialRemarks,
      //     ModuleID: $scope.vm.ModuleID,
      //     CreatedBy: $rootScope.createdby,
      //     IsActive: "true",
      //   },
      // });
      // response.then(function (GList) {
      //     $scope.vm.SpecialRemarks = '';
      //     RefreshComments($scope.SID)
      // }, function () {
      //   $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      // });
      // }
      // else
      // {
      if ($scope.vm.SpecialRemarks != "" && $scope.vm.SpecialRemarks != null) {
        $scope.SpecialRem = $scope.vm.SpecialRemarks;
        $scope.CommentArray.push({
          key: $scope.CommentArray.length + 1,
          cmt: $scope.vm.SpecialRemarks,
          CommentedBy: $rootScope.createdby,
          CreatedDate: new Date()
        });
        $scope.Commentdatas = $scope.CommentArray;
        $scope.vm.SpecialRemarks = null;
      }
    };
    //   }

    $scope.closepest = function () {
      $mdDialog.hide();
      $scope.Pestdata = null;
    };
    $scope.Deletepest = function (DeleteItem) {
      var index = $scope.WOFrequencydatas.indexOf(DeleteItem);
      $scope.WOFrequencydatas.splice(index, 1);
      RefreshSchedulerFrequency();
    };
    function RefreshSchedulerFrequency() {
      $http({
        url: $rootScope.WebURL + "/settings",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (settingsdata) {
        $scope.Settingsdatas = settingsdata.data.data;
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "ScheduleFrequency";
          });
          $scope.ScheduleFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentMode";
          });
          $scope.PaymentModedatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BillingFrequency";
          });
          $scope.BillingFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentTerm";
          });
          $scope.PaymentTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "JobTypes";
          });
          $scope.JobTypesdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BuildingType";
          });
          $scope.BuildingTypedatas = item;
        } catch (e) { }

        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "CreditTerm";
          });
          $scope.CreditTermdatas = item;
        } catch (e) { }
      });
    }
    function getSorDetails(Contract) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/sor/getByContract",
        data: { Client_Id: $rootScope.Client_Id, Contract: Contract }
      }).then(function (Sortabledata) {
        if (Sortabledata.data.data.length > 0)
          $scope.Sordatas = Sortabledata.data.data;
      });
    }

    function getSor() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/sor/get",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Sortabledata) {
        $scope.Sordatas = Sortabledata.data.data;
      });
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/lead",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (leaddata) {
      $scope.Leaddetails = leaddata.data.data;
    });

    $http({
      method: "GET",
      url: $rootScope.WebURL + "/client",
    }).then(function (Clientdata) {
      var data = Clientdata.data.data;
      $scope.Clientdata = data.filter(function (item) {
        return item.id == $rootScope.Client_Id
      })[0]
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });

    $scope.ClickTemplate = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/PreviewTemplate.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function contractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      var Start =
        moment()._locale._months[moment($scope.vm.ServiceStartDate).month()] +
        " " +
        moment($scope.vm.ServiceStartDate).year();
      var End =
        moment()._locale._months[moment($scope.vm.ServiceEndDate).month()] +
        " " +
        moment($scope.vm.ServiceEndDate).year();
      if (
        $scope.vm.TotalMonth == undefined &&
        $scope.vm.ServiceStartDate != "" &&
        $scope.vm.ServiceStartDate != null &&
        $scope.vm.ServiceStartDate != undefined &&
        $scope.vm.ServiceEndDate != "" &&
        $scope.vm.ServiceEndDate != null &&
        $scope.vm.ServiceEndDate != undefined
      )
        $scope.getMonth(
          $scope.vm.ServiceStartDate,
          $scope.vm.ServiceEndDate,
          null
        );
      var Month = $scope.vm.TotalMonth;
      var Months = $scope.vm.TotalMonth;
      var Frequency = $scope.vm.BillingFrequency;
      var Amount = 0;
      var freqbasis = "";
      if (Frequency == "COD") {
        freqbasis = " in Cash";
        Amount = parseFloat($scope.vm.TotalOrderValue) / 1;
      } else if (Frequency.toLowerCase().includes("weekly")) {
        freqbasis = " per week";
        var start = moment(new Date($scope.vm.ServiceStartDate));
        var end = moment(new Date($scope.vm.ServiceEndDate));
        var weeks = end.diff(start, "week");
        Amount = parseFloat($scope.vm.TotalOrderValue) / weeks;
      } else if (Frequency.toLowerCase().includes("monthly")) {
        freqbasis = " per month";
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency.toLowerCase().includes("quarterly")) {
        freqbasis = " quarterly";
        var Month = parseInt(Month / 3);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency.toLowerCase().includes("bi-monthly") || Frequency.toLowerCase().includes("bi monthly")) {
        freqbasis = " bi-monthly";
        Frequency = "Bi-Monthly";
        var Month = parseInt(Month / 2);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency.toLowerCase().includes("half yearly") | Frequency.toLowerCase().includes("half-yearly")) {
        freqbasis = " half yearly";
        Frequency = "Half Yearly";
        var Month = parseInt(Month / 6);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency.toLowerCase().includes("yearly")) {
        freqbasis = " per year";
        var Month = parseInt(Month / 12);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else {
        freqbasis = " once";
        Amount = parseFloat($scope.vm.TotalOrderValue) / 1;
      }

      if (Months != 0 && Months != 1) Months = Months + " months";
      else Months = Months + " month";

      if (Amount % 1 < 1 && Amount % 1 != 0) {
        Amount = Amount.toFixed(2);
      }
      var amtt = Amount;
      // amtt = parseFloat(amtt) * 7 / 100 + parseFloat(amtt)
      var amt = parseFloat(amtt);
      var amout = amt;
      if (amt % 1 < 1 && amt % 1 != 0) {
        amt = amt.toFixed(2);
      }

      var amountt = amout.toFixed(2);

      if ($scope.Update) {
        if (
          $scope.vm.Servicestart === $scope.vm.ServiceStartDate &&
          $scope.vm.Serviceend === $scope.vm.ServiceEndDate
        ) {
          amountt = parseFloat(vm.Header.split("$")[1].split("(")[0]);
          amt = amountt;
          amountt = amountt.toFixed(2);
        }
      }

      if ($scope.vm.ServiceHours == "During Office Hours")
        var OfficeHours = "During Office Hours 9am - 5pm";
      else if ($scope.vm.ServiceHours == "After Office Hours")
        var OfficeHours = "After Office Hours 5pm - 12:00mn";
      else if ($scope.vm.ServiceHours == "Wee Hours")
        var OfficeHours = "During Wee Hours 12:00mn - 9am";

      vm.Header =
        "<p align='justify'>This Contract will hereby commence at the above service location from <u><b>" +
        Start +
        "</b></u> to <u><b>" +
        End +
        "</b></u> and to hold unto The Client for a period of <u><b>" +
        Months +
        "</b></u>. The Client agrees to pay for the scope of work on a <u><b>" +
        Frequency +
        "</b></u> basis, a sum of Singapore Dollars <u><b>" +
        toWords(amt) +
        " S$ " +
        amountt +
        " (subjected to prevailing GST)</b></u> " +
        freqbasis +
        ". Payable to <b>" + $scope.Clientdata.ClientName + "</b> within " +
        $scope.vm.CreditTerm +
        " of invoice. Additional services will be charged separately.</p>";
      vm.Header1 =
        "<p align='justify'>Refer to the 'Scope of Work' as stated below will be carried out <b>" +
        OfficeHours +
        "</b>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range. </p>";
      vm.Header2 =
        "<div><h4><b>ACCESS TO PREMISES</b></h4></div><div><p align='justify'>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p></div><div><h4><b>LIABILITY</b></h4></div><div><p align='justify'>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div></p></div><div><h4><b>TERMINATION OF CONTRACT</b></h4></div><div><p align='justify'>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Month notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>";
    };

    vm.taToolbar = [
      [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "pre",
        "quote",
        "bold",
        "italics",
        "underline",
        "strikeThrough",
        "ul",
        "ol",
        "redo",
        "undo",
        "clear"
      ],
      [
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        "justifyFull",
        "indent",
        "outdent",
        "html",
        "insertImage",
        "insertLink",
        "insertVideo",
        "wordcount",
        "charcount"
      ]
    ];
    var th = ["", "Thousand", "Million", "Billion", "Trillion"];

    var dg = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine"
    ];
    var tn = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    var tw = [
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];
    function toWords(s) {
      s = s.toString();
      s = s.replace(/[\, ]/g, "");
      if (s != parseFloat(s)) return "not a number";
      var x = s.indexOf(".");
      if (x == -1) x = s.length;
      if (x > 15) return "too big";
      var n = s.split("");
      var str = "";
      var sk = 0;
      for (var i = 0; i < x; i++) {
        if ((x - i) % 3 == 2) {
          if (n[i] == "1") {
            str += tn[Number(n[i + 1])] + " ";
            i++;
            sk = 1;
          } else if (n[i] != 0) {
            str += tw[n[i] - 2] + " ";
            sk = 1;
          }
        } else if (n[i] != 0) {
          str += dg[n[i]] + " ";
          if ((x - i) % 3 == 0) str += "Hundred ";
          sk = 1;
        }
        if ((x - i) % 3 == 1) {
          if (sk) str += th[(x - i - 1) / 3] + " ";
          sk = 0;
        }
      }
      //    if (x != s.length) {
      //        var y = s.length;
      //        str += 'and ';
      //        for (var i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
      //        str += 'cents '
      //    }
      if (x != s.length) {
        if (str != "") str += "and ";
        if (Number(s.charAt(x + 1)) > 1) {
          if (Number(s.charAt(x + 1)) > 1) {
            str += tw[Number(s.charAt(x + 1)) - 2] + " ";
          } else if (
            Number(s.charAt(x + 1)) == 1 &&
            Number(s.charAt(x + 2)) > 0
          ) {
            str += tn[Number(s.charAt(x + 2)) - 1] + " ";
          } else str += tn[0] + " ";

          if (Number(s.charAt(x + 2)) != 0)
            str += dg[Number(s.charAt(x + 2))] + " ";
        } else if (
          Number(s.charAt(x + 1)) == 1 &&
          Number(s.charAt(x + 2)) > 0
        ) {
          str += tn[Number(s.charAt(x + 2))] + " ";
        } else if (Number(s.charAt(x + 1)) == 0) {
          str += dg[Number(s.charAt(x + 2))] + " ";
        } else str += tn[0] + " ";
        str += "Cents ";
      }
      str += "Only";
      return str.replace(/\s+/g, " ");
    }

    $scope.getMonth = function (StartDate, EndDate, Frequency) {
      if (
        StartDate != "" &&
        StartDate != null &&
        StartDate != undefined &&
        EndDate != "" &&
        EndDate != null &&
        EndDate != undefined
      ) {
        EndDate = moment(EndDate).add(1, "days");
        var a = moment(StartDate);
        var b = EndDate;
        var Month = b.diff(a, "month");
        $scope.vm.TotalMonth = Month;
      } else $scope.vm.TotalMonth = 0;
    };

    $scope.getServiceEndDate = function (StartDate) {
      if (StartDate != null && StartDate != undefined && StartDate != "") {
        var StartDate = new Date(StartDate);
        $scope.vm.ServiceEndDate = moment(StartDate).add(1, "year");
        $scope.vm.ServiceEndDate = new Date(
          $scope.vm.ServiceEndDate.add(-1, "days")
        );
      }
    };

    $scope.getMonthAmount = function (Month, value) {
      if (
        Month != "" &&
        Month != null &&
        Month != undefined &&
        value != "" &&
        value != null &&
        value != undefined
      ) {
        $scope.vm.AmountperMonth =
          Month == 0 ? parseFloat(value) / 1 : parseFloat(value) / Month;
      } else $scope.vm.AmountperMonth = 0;
    };

    // clear date filter

    $scope.ClearFilter = function () {
      $scope.uTo = null;
      $scope.uFrom = null;
      RefreshGrid();
    };

    function monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth() + 1;
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }
    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }
    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function extract_contract_data($scope) {
      $scope.contractdatas = [];
      $scope.PastContractdatas = [];
      $scope.contractRenewaldatas = [];
      var data = $scope.AllContractdata.filter(function (item) {
        return item.Status == "New";
      });
      $scope.Pendingcontractdatas = _.uniq(data);

      $scope.workOrd = $scope.Pendingcontractdatas;
      angular
        .element("#YTSContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.Pendingcontractdatas);

      var now = new Date().getTime();

      var data1 = $scope.AllContractdata.filter(function (item) {
        return item.Status == "SalesOrder";
      });
      var futureContracts = data1.filter(function (contract) {
        return new Date(contract.ServiceEndDate).getTime() > now;
      });

      var pastContracts = data1.filter(function (contract) {
        return new Date(contract.ServiceEndDate).getTime() < now;
      });

      $scope.contractdatas = _.uniqWith(
        $scope.contractdatas.concat(futureContracts),
        _.isEqual
      );

      $scope.PastContractdatas = _.uniqWith(
        $scope.PastContractdatas.concat(pastContracts),
        _.isEqual
      );
      var date_3_month_later = new Date(
        new Date().setMonth(new Date().getMonth() + 3)
      ).getTime();

      var renewal_data = data1.filter(function (contract) {
        return (
          new Date(contract.ServiceEndDate).getTime() < date_3_month_later &&
          contract.Renewal === false
        );
      });

      $scope.contractRenewaldatas = _.uniqWith(
        $scope.contractRenewaldatas.concat(renewal_data),
        _.isEqual
      );
      angular
        .element("#PendingContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.contractdatas);

      angular
        .element("#PastContractContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.PastContractdatas);

      angular
        .element("#RenewalContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.contractRenewaldatas);

      if (dataGrid1) dataGrid1.endCustomLoading();
      if (dataGrid) dataGrid.endCustomLoading();
      if (dataGrid4) dataGrid4.endCustomLoading();
      if (dataGrid2) dataGrid2.endCustomLoading();
    }

    $scope.$on("contract_created", function (event, item) {
      $scope.AllContractdata.push(item);
      extract_contract_data($scope);
    });

    $scope.$on("contract_modified", function (event, item) {
      const idx = $scope.AllContractdata.findIndex(function (c) {
        return c.id === item.id;
      });
      if (idx !== -1) {
        $scope.AllContractdata[idx] = item;
      }
      extract_contract_data($scope);
    });

    $scope.$on("contract_deleted", function (event, item) {
      getAllContract();
    });
  }
})();
angular.module("apps.crm.contracts").config(function ($mdDateLocaleProvider) {
  $mdDateLocaleProvider.firstDayOfWeek = 1;
});

(function ()
{
    'use strict';

    angular
        .module('apps.crm.costing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.costing', {
            url: '/Estimation',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/costing/costing.html',
                    controller: 'costingController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/costing');
    }
  
})();
(function () {
    'use strict';
    angular
        .module('apps.crm.costing')
        .controller('costingController', costingController)
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });

    /** @ngInject */
    function costingController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $mdDialog, $document, $http, $log, $filter, $location, $window, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Estimation")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        var Client_Id = localStorage.getItem('Client_Id');
        $scope.CostingSheetform = false;
        $scope.CostingSheetgrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        //$scope.Table = null;
        $scope.starRating1 = 2;
        $scope.sAdd = function () {
            $scope.UniqueId = null;
            $scope.vm.Customer_Id = null;
            $scope.vm.IssueDate = null;
            $scope.vm.StartDate = new Date();
            $scope.vm.EndDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            $scope.vm.BaseOtRate = null;
            $scope.vm.RegularBaseHr = null;
            $scope.vm.Duration = "12";
            $scope.vm.Subject = null;
            $scope.starRating1 = null;
            $scope.vm.uCompanyName = null;
            $scope.vm.uContactPerson = null;
            $scope.vm.Mobile = null;
            $scope.vm.uEmail = null;
            $scope.vm.TableTempID5 = null;
            $scope.vm.TableTempID6 = null;
            $scope.vm.TableTempID7 = null;
            $scope.vm.TableTempID8 = null;
            $scope.Update = false;
            $scope.CostingSheetform = true;
            $scope.CostingSheetgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = false;
            $scope.Search = false;

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueId = pass;
        }
        $scope.Costinginfo = function (CId) {
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Pageform = false;
            $scope.Search = false;
            $scope.CostingSheetform = true;
            $scope.CostingSheetgrid = false;
            $scope.Update = true;
            $scope.vm.uCompanyName = null;
            $scope.vm.uContactPerson = null;
            $scope.vm.Mobile = null;
            $scope.vm.uEmail = null;
            $scope.SID = CId;
            try {
                var item = $scope.Costingdatas.filter(function (item) {
                    return item.id === CId;
                })[0];
                $scope.UniqueId = item.UniqueId;
                $scope.vm.Customer_Id = item.Customer_Id;
                $scope.vm.CustomerInfo = item.CustomerInfo;
                $scope.vm.StartDate = new Date(item.StartDate);
                $scope.vm.EndDate = new Date(item.EndDate);
                $scope.vm.BaseOtRate = parseFloat(item.BaseOtRate);
                $scope.vm.RegularBaseHr = parseFloat(item.RegularBaseHr);
                $scope.vm.TotalPerYearNoOT = parseFloat(item.TotalPerYearNoOT);
                $scope.vm.TotalPerYearNoReg = parseFloat(item.TotalPerYearNoReg);
                $scope.vm.TotalManpowerCost = parseFloat(item.TotalManpowerCost);
                $scope.vm.TotalHrCost = parseFloat(item.TotalHrCost);
                $scope.vm.TotalOTCost = parseFloat(item.TotalOTCost);
                $scope.vm.EuipmentCost = parseFloat(item.EuipmentCost);
                $scope.vm.TotalEPerLCost = parseFloat(item.TotalEPerLCost);
                $scope.vm.COAPercentage = parseInt(item.COAPercentage);
                $scope.vm.MarkupPercentage = parseInt(item.MarkupPercentage);
                $scope.vm.COACost = parseFloat(item.COACost);
                $scope.vm.Markup = parseFloat(item.Markup);
                $scope.vm.TotalCost = parseFloat(item.TotalCost);
                $scope.vm.ContractPriceAnnual = parseFloat(item.ContractPriceAnnual);
                $scope.vm.ContractPriceMonth = parseFloat(item.ContractPriceMonth);
                $scope.starRating1 = item.StarRating;
                var item2 = $scope.Customerdatas.filter(function (item2) {
                    return item2.id === $scope.vm.Customer_Id;
                })[0];
            }
            catch (e) { }
            CSRefreshGrid();
            $scope.CustomerServicedatadetails(item2);
        }
        $scope.CustomerServicedatadetails = function (row) {
            if (row.length != 0) {
                $scope.vm.Customer_id = row._id;
                $scope.vm.uCustomerID = row.CustomerID;
                $scope.vm.uCustomerType = row.CustomerType;
                $scope.vm.uSalutation = row.Salutation;
                $scope.vm.uFirstName = row.FirstName;
                $scope.vm.uLastName = row.LastName;
                $scope.vm.uWebsite = row.Website;
                $scope.vm.CustomerInfo = row.CompanyName;
                $scope.vm.uCompanyName = row.CompanyName;
                $scope.vm.uNote = row.Note;
                $scope.vm.Mobile = row.Mobile;
                $scope.vm.uAddress = row.Address;
                $scope.vm.CustomerReference = row.CustomerReference;
                $scope.vm.uPostal = parseInt(row.Postal);
                $scope.vm.uCountry = row.Country;
                $scope.vm.MarketSection = row.MarketSection;
                $scope.vm.uContactPerson = row.ContactPerson;
                $scope.vm.uPhone = parseInt(row.Phone);
                $scope.vm.uFax = row.Fax;
                $scope.vm.uMobile = parseInt(row.Mobile);
                $scope.vm.uEmail = row.Email;
                $scope.vm.uTypeofHouse = row.TypeofHouse;
                $scope.vm.uOtherType = row.OtherType;
            }
        }
        $scope.DaysCalc = function (CED) {
            var months;
            months = ($scope.vm.EndDate.getFullYear() - $scope.vm.StartDate.getFullYear()) * 12;
            months -= $scope.vm.StartDate.getMonth() + 1;
            months += $scope.vm.EndDate.getMonth();
            $scope.vm.Duration = months <= 0 ? 0 : months;
        }
        $scope.GetCostPerYear = function () {
            try {
                $scope.vm.CostPerYear = parseFloat($scope.vm.CostPerPiece) * parseFloat($scope.vm.QtyPerYear);
            }
            catch (e) { }
        }
        $scope.CalCOA = function () {
            try {
                $scope.vm.COACost = (parseFloat($scope.vm.COAPercentage) / 100) * parseFloat($scope.vm.EuipmentCost);
                $scope.vm.Markup = (parseFloat($scope.vm.MarkupPercentage) / 100) * parseFloat($scope.vm.EuipmentCost);
                $scope.vm.TotalCost = parseFloat($scope.vm.TotalEPerLCost) + $scope.vm.COACost + $scope.vm.Markup;
                $scope.vm.ContractPriceAnnual = $scope.vm.TotalCost;
                $scope.vm.ContractPriceMonth = parseFloat($scope.vm.ContractPriceAnnual) / 12;
            }
            catch (e) { }
        }

        $scope.Delete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/costingAdd/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                CSRefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.QDelete = function (QdeleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotation/delete",
                data: {
                    _id: QdeleteID,
                },
            });
            response.then(function (GList) {
                quotationRefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            $scope.CostingSheetgrid = true;
            $scope.CostingSheetform = false;
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
        }
        $scope.AddProduct = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/costing/costingpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function costingController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;

            $scope.vm.Product = null;
            $scope.vm.CostPerPiece = null;
            $scope.vm.QtyPerYear = null;
            $scope.vm.CostPerYear = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Product = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5LeasingUnitPrice = null;
            $scope.vm.T5SellingUnitPrice = null;
            $scope.vm.T5Photo = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7PartNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7NoOfLightTubesNeed = null;
            $scope.vm.T7SellingPricing = null;
            $scope.vm.T7Lifespan = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;
        }
        $scope.AddManpower = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/costing/manpower.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function costingController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;

            $scope.vm.Frequency = null;
            $scope.vm.PestType = null;
            $scope.vm.NoTech = null;
            $scope.vm.NoReg = null;
            $scope.vm.NoOT = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;

        }
        $scope.CostSubmit = function () {
            if ($scope.vm.Frequency == 'Weekly') { $scope.vm.SvcPerYear = '52' }
            else if ($scope.vm.Frequency == 'Stationed Specialist') { $scope.vm.SvcPerYear = '287' }
            else if ($scope.vm.Frequency == 'One Time Service') { $scope.vm.SvcPerYear = '1' }
            else if ($scope.vm.Frequency == 'Monthly') { $scope.vm.SvcPerYear = '12' }
            else if ($scope.vm.Frequency == 'Twice a Month') { $scope.vm.SvcPerYear = '24' }
            else if ($scope.vm.Frequency == 'Quarterly') { $scope.vm.SvcPerYear = '4' }
            else if ($scope.vm.Frequency == 'Bi-Monthly') { $scope.vm.SvcPerYear = '6' }
            else if ($scope.vm.Frequency == 'Annual Inspection') { $scope.vm.SvcPerYear = '1' }

            var total = 0;
            var TotalNoReg = 0;
            var TotalNoOT = 0;
            try {
                angular.forEach($scope.vm.PestType, function (value) {
                    total += parseFloat(value.Price);
                });
                $scope.PestPrice = total;
                TotalNoReg = parseFloat($scope.vm.NoReg) * parseFloat($scope.vm.SvcPerYear);
                TotalNoOT = parseFloat($scope.vm.NoOT) * parseFloat($scope.vm.SvcPerYear);
            }
            catch (e) { }
            if ($scope.CSUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/quotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle1: $scope.vm.TableTitle1,
                        TableTempID1: $scope.TableTempID,
                        T1PestType: $scope.vm.T1PestType,
                        T1Timing: $scope.vm.T1Timing,
                        T1Frequency: $scope.vm.T1Frequency,
                        T1Pricing: $scope.vm.T1Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.CostingSheetform = true;
                    $scope.CostingSheetgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/costingAdd/add",
                    data: {
                        UniqueId: $scope.UniqueId,
                        Frequency: $scope.vm.Frequency,
                        PestType: $scope.vm.PestType,
                        NoTech: $scope.vm.NoTech,
                        NoReg: $scope.vm.NoReg,
                        NoOT: $scope.vm.NoOT,
                        SvcPerYear: $scope.vm.SvcPerYear,
                        TotalNoReg: TotalNoReg,
                        TotalNoOT: TotalNoOT,
                        Duration: $scope.vm.Duration,
                        PestPrice: $scope.PestPrice,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    CSRefreshGrid();
                    $mdDialog.cancel();
                    $scope.QRTUpdate = false;
                    $scope.CostingSheetform = true;
                    $scope.CostingSheetgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.ProductSubmit = function () {
            if ($scope.PUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/costingAdd/update",
                    data: {
                        _id: $scope.vm.P_Id,
                        Product: $scope.vm.Product,
                        CostPerPiece: $scope.vm.CostPerPiece,
                        CostPerYear: $scope.vm.CostPerYear,
                        QtyPerYear: $scope.vm.QtyPerYear,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $scope.PUpdate = false;
                    CSRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.CostingSheetform = true;
                    $scope.CostingSheetgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/costingAdd/add",
                    data: {
                        UniqueId: $scope.UniqueId,
                        Product: $scope.vm.Product,
                        CostPerPiece: $scope.vm.CostPerPiece,
                        CostPerYear: $scope.vm.CostPerYear,
                        QtyPerYear: $scope.vm.QtyPerYear,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $scope.QRTUpdate = false;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    CSRefreshGrid();
                    $scope.CostingSheetform = true;
                    $scope.CostingSheetgrid = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.sSubmit = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/costing/update",
                    data: {
                        _id: $scope.SID,
                        UniqueId: $scope.UniqueId,
                        Customer_Id: $scope.vm.Customer_Id,
                        CustomerInfo: $scope.vm.CustomerInfo,
                        RegularBaseHr: $scope.vm.RegularBaseHr,
                        BaseOtRate: $scope.vm.BaseOtRate,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        TotalPerYearNoReg: $scope.vm.TotalPerYearNoReg,
                        TotalPerYearNoOT: $scope.vm.TotalPerYearNoOT,
                        TotalHrCost: $scope.vm.TotalHrCost,
                        TotalOTCost: $scope.vm.TotalOTCost,
                        TotalManpowerCost: $scope.vm.TotalManpowerCost,
                        EuipmentCost: $scope.vm.EuipmentCost,
                        TotalEPerLCost: $scope.vm.TotalEPerLCost,
                        COAPercentage: $scope.vm.COAPercentage,
                        MarkupPercentage: $scope.vm.MarkupPercentage,
                        COACost: $scope.vm.COACost,
                        Markup: $scope.vm.Markup,
                        StarRating: $scope.starRating1,
                        TotalCost: $scope.vm.TotalCost,
                        ContractPriceAnnual: $scope.vm.ContractPriceAnnual,
                        ContractPriceMonth: $scope.vm.ContractPriceMonth,
                        UpdatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    RefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.CostingSheetform = false;
                    $scope.CostingSheetgrid = true;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/costing/add",
                    data: {
                        UniqueId: $scope.UniqueId,
                        Customer_Id: $scope.vm.Customer_Id,
                        CustomerInfo: $scope.vm.CustomerInfo,
                        RegularBaseHr: $scope.vm.RegularBaseHr,
                        BaseOtRate: $scope.vm.BaseOtRate,
                        StartDate: $scope.vm.StartDate,
                        EndDate: $scope.vm.EndDate,
                        TotalPerYearNoReg: $scope.vm.TotalPerYearNoReg,
                        TotalPerYearNoOT: $scope.vm.TotalPerYearNoOT,
                        TotalHrCost: $scope.vm.TotalHrCost,
                        TotalOTCost: $scope.vm.TotalOTCost,
                        TotalManpowerCost: $scope.vm.TotalManpowerCost,
                        EuipmentCost: $scope.vm.EuipmentCost,
                        TotalEPerLCost: $scope.vm.TotalEPerLCost,
                        COAPercentage: $scope.vm.COAPercentage,
                        MarkupPercentage: $scope.vm.MarkupPercentage,
                        COACost: $scope.vm.COACost,
                        Markup: $scope.vm.Markup,
                        TotalCost: $scope.vm.TotalCost,
                        StarRating: $scope.starRating1,
                        ContractPriceAnnual: $scope.vm.ContractPriceAnnual,
                        ContractPriceMonth: $scope.vm.ContractPriceMonth,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
                    RefreshGrid();
                    $scope.CostingSheetform = false;
                    $scope.CostingSheetgrid = true;
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };



        $http({
            method: "POST",
            url: $rootScope.WebURL + "/costing",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (costing) {
            $scope.Costingdatas = costing.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/customer",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (customerdata) {
            $scope.Customerdatas = customerdata.data.data;
        });
        //$http.get( $rootscope.weburl + "/customerservice")
        // .then(function (customerservicedata) {
        //     $scope.customerservicedatas = customerservicedata.data.data;
        // });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/product",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Productdata) {
            $scope.Productdatas = Productdata.data.data;
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.Pestdatas = pestdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/costing",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (costing) {
                $scope.Costingdatas = costing.data.data;
            });
        }

        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;

                try {

                    var item = $scope.Clientdatas.filter(function (item) {
                        return item.id === Client_Id;
                    })[0];

                    $scope.CurrencyCode = item.CurrencyCode;
                } catch (error) {

                }
            });

        function CSRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/costingAdd/getById",
                data: { UniqueId: $scope.UniqueId },
            }).then(function (costingAdddata) {
                debugger
                $scope.CostingAdddatas = costingAdddata.data.data;
                var total = 0;
                var total1 = 0;
                var totalpest = 0;
                var totalequipcost = 0;
                try {
                    angular.forEach($scope.CostingAdddatas, function (value) {
                        if (value.TotalNoReg != null && value.TotalNoReg != undefined && value.TotalNoOT != null && value.TotalNoOT != undefined) {
                            total += parseFloat(value.TotalNoReg);
                            total1 += parseFloat(value.TotalNoOT);
                        }

                        if (value.PestPrice != null && value.PestPrice != undefined && value.PestPrice != "") {
                            totalpest += parseFloat(value.PestPrice);
                        }
                        if (value.CostPerYear != null && value.CostPerYear != undefined && value.CostPerYear != "") {
                            totalequipcost += parseFloat(value.CostPerYear);
                        }
                    });
                    $scope.vm.TotalPerYearNoReg = total;
                    $scope.vm.TotalPerYearNoOT = total1;
                    $scope.vm.EuipmentCost = totalequipcost;

                    $scope.vm.TotalHrCost = parseFloat($scope.vm.RegularBaseHr) * totalpest;
                    $scope.vm.TotalOTCost = parseFloat($scope.vm.BaseOtRate) * totalpest;
                    $scope.vm.TotalManpowerCost = $scope.vm.TotalHrCost + $scope.vm.TotalOTCost;
                    $scope.vm.TotalEPerLCost = $scope.vm.TotalManpowerCost + $scope.vm.EuipmentCost;

                    $scope.vm.COACost = (parseFloat($scope.vm.COAPercentage) / 100) * parseFloat($scope.vm.EuipmentCost);
                    $scope.vm.Markup = (parseFloat($scope.vm.MarkupPercentage) / 100) * parseFloat($scope.vm.EuipmentCost);
                    $scope.vm.TotalCost = parseFloat($scope.vm.TotalEPerLCost) + $scope.vm.COACost + $scope.vm.Markup;
                    $scope.vm.ContractPriceAnnual = $scope.vm.TotalCost;
                    $scope.vm.ContractPriceMonth = parseFloat($scope.vm.ContractPriceAnnual) / 12;
                } catch (e) { }
            });
        }
        $scope.preview = function (CId, invoice) {


            $scope.SID = CId;
            try {
                var item = $scope.Costingdatas.filter(function (item) {
                    return item.id === CId;
                })[0];
                $scope.UniqueId = item.UniqueId;
                $scope.vm.Customer_Id = item.Customer_Id;
                $scope.vm.CustomerInfo = item.CustomerInfo;
                $scope.vm.StartDate = new Date(item.StartDate);
                $scope.vm.EndDate = new Date(item.EndDate);
                $scope.vm.BaseOtRate = parseFloat(item.BaseOtRate);
                $scope.vm.RegularBaseHr = parseFloat(item.RegularBaseHr);
                $scope.vm.TotalPerYearNoOT = parseFloat(item.TotalPerYearNoOT);
                $scope.vm.TotalPerYearNoReg = parseFloat(item.TotalPerYearNoReg);
                $scope.vm.TotalManpowerCost = parseFloat(item.TotalManpowerCost);
                $scope.vm.TotalHrCost = parseFloat(item.TotalHrCost);
                $scope.vm.TotalOTCost = parseFloat(item.TotalOTCost);
                $scope.vm.EuipmentCost = parseFloat(item.EuipmentCost);
                $scope.vm.TotalEPerLCost = parseFloat(item.TotalEPerLCost);
                $scope.vm.COAPercentage = parseInt(item.COAPercentage);
                $scope.vm.MarkupPercentage = parseInt(item.MarkupPercentage);
                $scope.vm.COACost = parseFloat(item.COACost);
                $scope.vm.Markup = parseFloat(item.Markup);
                $scope.vm.TotalCost = parseFloat(item.TotalCost);
                $scope.vm.ContractPriceAnnual = parseFloat(item.ContractPriceAnnual);
                $scope.vm.ContractPriceMonth = parseFloat(item.ContractPriceMonth);
                $scope.starRating1 = item.StarRating;
                var item2 = $scope.Customerdatas.filter(function (item2) {
                    return item2.id === $scope.vm.Customer_Id;
                })[0];
            }
            catch (e) { }
            CSRefreshGrid();
            $scope.CustomerServicedatadetails(item2);


            $scope.Previewdiv = true;
            var innerContents = document.getElementById('invoice').innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body  onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            popupWinindow.document.close($scope.Previewdiv = false);
        }

        var vm = this;
        //// Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.Header = '<p>Thank you for inviting us to quote.<br><br>We are pleased to forward our quotation for your kind acceptance.<br><br>Our quotation to the above site for common area would be as follows.</p>';
        vm.Footer = '<p>We trust that the above quotation and work proposal meet your  requirements but should you wish for a review, please do not hesitate to contact me. We hope to receive your favorable reply, soon.<br><br>Should you have any clarifications, please do not hesitate to contact me.<br><br>Thank you.</p>';
        vm.TermsCondition = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('apps.crm.contractrenewal', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.contractrenewal', {
            url: '/ContractRenewal',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/contractRenewal/contractrenewal.html',
                    controller: 'contractrenewalController as vm'
                }
            },
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/contracts');
    }

})();
(function () {
    'use strict';

    angular
        .module('apps.crm.contractrenewal')
        .controller('contractrenewalController', contractrenewalController)
        .directive('ngEnter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        });
    function contractrenewalController($scope, $interval, socket, $mdSidenav, $mdToast, $http, $location, $rootScope, $window, $state, $mdDateLocale, $q, $document, $filter, $mdDialog, $mdConstant, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Contracts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        $window.localStorage.setItem('PQfromContract', "");

        var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
        $scope.Emp_Id = localStorage.getItem('EmpId');
        var EmpID = localStorage.getItem('EmployeeID');
        var vm = this;
        $scope.Contractsform = false;
        $scope.Contractsgrid = true;
        $scope.Salesform = false
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.ShowContractform = false;
        $scope.SpecialRem = ""
        getSor()
        RefreshCustomerdatas()
        $scope.ExportContract = function () {
            alasql('SELECT * INTO XLSX("Contracts.xlsx",{headers:true}) FROM ?', [$scope.contractdatas]);
        };
        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.uShowClosed = false;
        $scope.filterRow = {
            visible: true,
            applyFilter: "auto"
        };
        $scope.headerFilter = {
            visible: true
        };
        $scope.sAdd = function () {
            ClearForm();
            $scope.vm.Ccontact = []
            $scope.SID = null
            $scope.Update = false;
            $scope.Contractsform = true;
            $scope.Salesform = false
            $scope.Contractsgrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.vm.Header = null;
            $scope.Search = false;
            $scope.vm.CEmail = []
            $scope.vm.SiteContactPerson = null;
            $scope.vm.SiteName = null;
            $scope.vm.SiteContact = null;
            getSor()
            $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        }

        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
        var pass = "";
        for (var x = 0; x < 6; x++) {
            var i = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(i);
        }
        var UniqID = pass
        $scope.Showgrid = function () {
            $scope.Contractsgrid = true;
            $scope.Contractsform = false;
            $scope.Salesform = false
            $scope.Pageform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
            $scope.ShowContractform = false;

            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contract/update",
                    data: {
                        _id: $scope.SID,
                        MultiFrequency: $scope.Frequencydatas,
                        UpdateFrequency: "true",
                    },
                });
            }
        }
        $scope.Refresh = function () {
            RefreshGrid()
        }

        $scope.Servicepopup = function (e, PopupType) {
            $scope.Service = true;
            $scope.Billing = false;
            $scope.PopupType = 'Service';
            $scope.vm.sty = 55
            $scope.vm.usBLK = null;
            $scope.vm.usUnit = null;
            $scope.vm.usPostal = null;
            $scope.vm.usCountry = "Singapore";
            $scope.vm.ubCountry = "Singapore";
            $scope.vm.usContactPerson = null;
            $scope.vm.usName = null;
            $scope.vm.usBuildingName = null;
            $scope.vm.usMobile = null;
            $scope.vm.usStreetName = null;
            $scope.vm.usEmail = null;
            $scope.vm.usBuildingType = null;
            $scope.QUpdate = false;
            $scope.BAUpdate = false;
            $scope.checkboxModel = { value: false }
            $scope.Servicecopy = { value: false }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/Service.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.Serviceadd = function (Index) {
            var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            var trueEmailValid = true;
            var falseEmailValid = true;
            var falseCCValid = true;
            angular.forEach($scope.vm.ZoneCC, function (ite) {
                if (reg.test(ite)) {
                    trueEmailValid = true;
                } else {
                    falseEmailValid = false;
                }
            })
            if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
                angular.forEach($scope.vm.ZoneEmail, function (ite) {
                    if (reg.test(ite)) {
                        trueEmailValid = true;
                    } else {
                        falseCCValid = false;
                    }
                })
            }
            else {
                var falseCCValid = true;
            }

            if (falseEmailValid != false) {
                if (falseCCValid != false) {
                    var ZoneCC = $scope.vm.ZoneCC
                    if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
                        $scope.vm.usEmail = ZoneCC.map(function (obj) { return obj; }).join(',');
                    }
                    else {
                        $scope.vm.usEmail = "";
                    }
                    var ZoneEmail = $scope.vm.ZoneEmail
                    if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
                        $scope.vm.usCC = ZoneEmail.map(function (obj) { return obj; }).join(',');
                    }
                    else {
                        $scope.vm.usCC = "";
                    }
                }
                else {
                    $mdToast.show($mdToast.simple().textContent('Enter valid CC !').position('top center'));
                    return
                }
            }
            else {
                $mdToast.show($mdToast.simple().textContent('Enter valid email !').position('top center'));
                return
            }
            if ($scope.vm.usMobile != null && $scope.vm.usMobile != "" && $scope.vm.usMobile != undefined) {
                $scope.vm.usMobile = $scope.vm.usMobile.map(function (obj) { return obj; }).join(',');
            }
            if ($scope.QUpdate == true) {
                $scope.Index = $scope.Index;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/customerService/update",
                    data: {
                        _id: $scope.QID,
                        CustomerID: $scope.vm.uCustomerID,
                        sBLK: $scope.vm.usBLK,
                        sUnit: $scope.vm.usUnit,
                        sPostal: $scope.vm.usPostal,
                        sCountry: $scope.vm.usCountry,
                        sName: $scope.vm.usName,
                        sContactPerson: $scope.vm.usContactPerson,
                        sBuildingType: $scope.vm.usBuildingType,
                        sBuildingName: $scope.vm.usBuildingName,
                        sMobile: $scope.vm.usMobile,
                        sStreetName: $scope.vm.usStreetName,
                        sEmail: $scope.vm.usEmail,
                        sCC: $scope.vm.usCC,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    GList.data.data["_id"] = GList.data.data["id"];
                    delete GList.data.data["id"];
                    $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
                    CustomerServicedatadetails();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else if ($scope.QUpdate == false) {
                var item = [];
                try {
                    item = $scope.CustomerServicedatas.filter(function (item) {
                        return item.sBLK == $scope.vm.usBLK && item.sUnit == $scope.vm.usUnit && item.sStreetName == $scope.vm.usStreetName && item.sCountry == $scope.vm.usCountry && item.sMobile == $scope.vm.usMobile;
                    })
                }
                catch (e) { }
                if (item.length == 0 || item.length == undefined) {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/customerService/add",
                        data: {
                            Type: "Service",
                            CustomerID: $scope.vm.uCustomerID,
                            sBLK: $scope.vm.usBLK,
                            sUnit: $scope.vm.usUnit,
                            sPostal: $scope.vm.usPostal,
                            sCountry: $scope.vm.usCountry,
                            sName: $scope.vm.usName,
                            sContactPerson: $scope.vm.usContactPerson,
                            sBuildingType: $scope.vm.usBuildingType,
                            sBuildingName: $scope.vm.usBuildingName,
                            sMobile: $scope.vm.usMobile,
                            sStreetName: $scope.vm.usStreetName,
                            sEmail: $scope.vm.usEmail,
                            sCC: $scope.vm.usCC,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                        },
                    });
                    response.then(function (GList) {
                        $scope.RequestID = $scope.vm.uCustomerID;
                        $scope.vm.CustomerID = $scope.vm.uCustomerID;
                        CustomerServicedatadetails();
                        $scope.Servicegrid = true;
                        $mdDialog.cancel();
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
                else {
                    $mdToast.show($mdToast.simple().textContent('Already Exist!').position('top center'));
                    $mdDialog.cancel();
                }
            }
        }
        $scope.Servicesupdate = function (e, QId, Index) {
            $scope.QUpdate = true;
            $scope.QID = QId;
            $scope.vm.Index = Index;
            $scope.Index = Index;
            $scope.Service = true;
            $scope.Billing = false;
            $scope.PopupType = 'Service';
            $scope.vm.sty = 55
            try {
                var item = $scope.CustomerServicedatas.filter(function (item) {
                    return item._id === QId;
                })[0];
                $scope.vm.uCustomerID = item.CustomerID;
                $scope.vm.usBLK = item.sBLK;
                $scope.vm.usUnit = item.sUnit;
                $scope.vm.usPostal = (item.sPostal);
                $scope.vm.usCountry = item.sCountry;
                $scope.vm.usName = item.sName;
                $scope.vm.usContactPerson = item.sContactPerson;
                $scope.vm.usBuildingType = item.sBuildingType;
                $scope.vm.usBuildingName = item.sBuildingName;
                $scope.vm.usMobile = []
                if (item.sMobile != null && item.sMobile != undefined && item.sMobile != "")
                    $scope.vm.usMobile = item.sMobile.split(',');
                $scope.vm.usStreetName = item.sStreetName;
                $scope.vm.usEmail = item.sEmail;
                $scope.vm.usCC = item.sCC;
                if ($scope.vm.usEmail != null && $scope.vm.usEmail != "" && $scope.vm.usEmail != undefined) {
                    $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
                    $scope.vm.usEmail = null;
                }
                if ($scope.vm.usCC != null && $scope.vm.usCC != "" && $scope.vm.usCC != undefined) {
                    $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
                    $scope.vm.usCC = null;
                }
            } catch (e) { }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/Service.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        function CustomerServicedatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerServicedata) {
                $scope.CustomerServiceAddress = CustomerServicedata.data.data;
            });
        }
        //$scope.uFrom = new Date(new Date().setMonth(new Date().getMonth() - 1));
        $scope.uFrom = null;
        $scope.uTo = null;
        $scope.vm.PreviewSpinner = false;
        var dataGrid
        vm.dataGridContract = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.contractdatas,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "ContractReferenceNo", caption: "Contract #", width: "85", sortOrder: 'desc',
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: defaults;'>" + options.data.ContractReferenceNo + "</p>").appendTo(container);
                    },
                },
                { dataField: "CompanyName", caption: "Customer" },
                {
                    dataField: "sStreetName", caption: "Service Location",
                    cellTemplate: function (container, options) {
                        $("<p style='color:black;cursor: default;'>" + options.data.sStreetName + ", Singapore, " + options.data.sPostal + "</p>").appendTo(container);

                    },
                },
                { dataField: "EmployeeName", caption: "Sales Person" },
                { dataField: "PestCode", caption: "Pest Type" },
                { dataField: "ContractDate", caption: "Contract Date" },
                { dataField: "EmailSentDate", caption: "Contract Sent Date", width: "150", dataType: "datetime", format: 'dd/MM/yyyy hh:mm a' },
                {
                    caption: 'Renew',
                    width: "90",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'refresh',
                            onClick: function (e) {
                                $scope.Contracteditinfo(e.event, options.data)
                            }
                        }).appendTo(container);
                    }
                }

            ],
            bindingOptions: {
                dataSource: "contractdatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
        };

        setTimeout(function () {
            RefreshGrid()
        }, 500)

        $scope.Datefilter = function () {
            var StartDate = new Date(new Date().getYear(), new Date().getMonth() + 3, 1)
            $scope.contractdatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getLength",
                data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder" }
            }).then(function (List) {
                var ContractLength = List.data.data
                var Skip = 0
                var Limit = ContractLength
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/getdatefilter",
                    data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder", IsAdmin: IsAdmin, SalesPerson: $scope.Emp_Id, Skip: Skip, Limit: Limit, StartDate: new Date(), EndDate: StartDate }
                }).then(function (GList) {
                    $scope.contractdatas = $scope.contractdatas.concat(GList.data.data)
                    $scope.workOrd = $scope.contractdatas
                    $scope.vm.PreviewSpinner = false
                })
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid != undefined)
                dataGrid.beginCustomLoading()
            $scope.Pendingcontractdatas = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getLength",
                data: { Client_Id: $rootScope.Client_Id, Type: "New" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/contract/getdatefilter",
                        data: { Client_Id: $rootScope.Client_Id, Type: "New", IsAdmin: IsAdmin, SalesPerson: $scope.Emp_Id, Skip: Skip, Limit: Limit, StartDate: new Date(), EndDate: StartDate }
                    }).then(function (GList) {
                        if (dataGrid != undefined)
                            dataGrid.endCustomLoading()
                        $scope.Pendingcontractdatas = $scope.Pendingcontractdatas.concat(GList.data.data)
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })
        }
        $scope.Contractclose = function (e, contractId) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/closealert.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.contractId = contractId;
        }
        $scope.CloseContract = function (contractId) {
            fetchContract(contractId);
            $scope.vm.ContractStatus = "Closed";
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/contract/update",
                data: {
                    _id: contractId,
                    SalesPerson_id: $scope.vm.SalesPerson,
                    TemplateID: $scope.vm.TemplateName,
                    Frequency: $scope.vm.Frequency,
                    CreditTerm: $scope.vm.CreditTerm,
                    IncludeSOR: $scope.vm.IncludeSOR,
                    MultiFrequency: $scope.Frequencydatas,
                    ContactPerson: $scope.vm.uContactPerson,
                    ServiceEndDate: $scope.vm.ServiceEndDate,
                    ServiceStartDate: $scope.vm.ServiceStartDate,
                    Customer_id: $scope.vm.Customer_id,
                    ContractStatus: $scope.vm.ContractStatus,
                    Status: $scope.vm.CurrentStatus,
                    StatusID: $scope.vm.CurrentStatusID,
                    Email: $scope.vm.CEmail,
                    BillingAddress: $scope.vm.BAddress,
                    Client_Id: $rootScope.Client_Id,
                    UpdatedBy: $rootScope.createdby, IsActive: false,
                },
            });
            response.then(function (GList) {
                $scope.Contractsgrid = true;
                $scope.ShowContractform = false;
                $scope.Contractsform = false;
                $scope.Salesform = false
                $scope.Export = true;
                $scope.Add = true;
                $scope.Search = true;
                $scope.view = false;
                RefreshGrid();
                $mdDialog.hide();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Addcontract = function (e) {
            $scope.Contractsgrid = false;
            $scope.ShowContractform = true;
            $scope.Add = false;
            $scope.view = true;
            $scope.Export = false;
            $scope.Search = false;
            $scope.SID = null
            getSor()
            var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 6; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            ClearForm();
            // $scope.vm.uCustomerID = pass;
            $scope.vm.ContractDate = new Date();
            $scope.vm.ContractReceivedBy = $rootScope.createdby;
            //var cinfo = $scope.contractdatas
            //for (var c = 1; c <= 1 + cinfo.length; c++) {
            //    var z = 'CT-' + ('0000' + c).slice(-4);
            //}
            //$scope.vm.ContractReferenceNo = z;
            $scope.vm.CurrentStatus = "New";
            $scope.vm.ContractStatus = "Open";
            $scope.vm.CurrentStatusID = 1;
            $scope.Update = false;
            var EmployeeID = localStorage.getItem('EmployeeID');
            try {
                var item = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === EmployeeID;
                })[0];
                $scope.vm.SalesPerson = item.id;
            } catch (e) { }
        }
        $scope.Addpesttype = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/addpesttype.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.Workorderclick = function (SId) {
            if (SId != null && SId != '' && SId != undefined) {
                try {
                    var eitem = $scope.salesOrderdatas.filter(function (eitem) {
                        return eitem._id === SId;
                    })[0];
                    $scope.vm.NatureofJob = eitem.PestType;
                    $scope.vm.emailSalesOrderNo = eitem.SalesOrderNo;
                    if (eitem.customerdetails[0] != null && eitem.customerdetails[0] != "" && eitem.customerdetails[0] != undefined) {
                        $scope.vm.emailCompanyName = eitem.customerdetails[0].CompanyName;
                    }
                    if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
                        var array = $scope.vm.NatureofJob.split(",");
                        var array1 = [];
                        angular.forEach(array, function (value) {
                            array1.push({ PestName: value });
                        });
                        $scope.vm.NatureofJob = array1;
                    }
                    $scope.vm.ContractStartDate = eitem.ContractStartDate;
                    if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
                        $scope.vm.ContractStartDate = new Date(eitem.ContractStartDate);
                    }
                    $scope.vm.ContractDuration = eitem.ContractDuration;
                    $scope.vm.ContractEndDate = eitem.ContractEndDate;
                    if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
                        $scope.vm.ContractEndDate = new Date(eitem.ContractEndDate);
                    }
                    $scope.vm.SalesPerson = eitem.SalesPerson_id;
                    $scope.vm.ServiceStartDate = eitem.ServiceStartDate;
                    if ($scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != "") {
                        $scope.vm.ServiceStartDate = new Date(eitem.ServiceStartDate);
                    }
                    $scope.vm.ServiceEndDate = eitem.ServiceEndDate;
                    if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
                        $scope.vm.ServiceEndDate = new Date(eitem.ServiceEndDate);
                    }
                    $scope.vm.Frequency = eitem.Frequency;
                } catch (e) { }
            }
        }
        $scope.contractinfo = function (value) {
            $scope.Update = true;
            $scope.Contractsform = true;
            $scope.Salesform = false
            $scope.Contractsgrid = false;
            $scope.ContractReportTab = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.SID = value._id;
            $scope.ContractID = value._id;
            $scope.vm.ContractId = value._id;
            $scope.Add = false;
            $scope.Search = false;
            $scope.File_id = value._id;

            $scope.ActionButton = null;
            $scope.uNext = null;
            $scope.cNextActionedID = null;
            $scope.ShowRejectButton = false;
            $scope.ShowCancelButton = false;
            $scope.ShowReviseButton = false;
            $scope.IsAccess = false;
            $scope.vm.ContractNo = value._id;
            $scope.vm.CAddress
            $scope.vm.ContractId = value._id;
            $scope.vm.UpCAddress = value.CustomerID
            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContractStartDate = value.ContractStartDate;
            $scope.Frequencydatas = value.MultiFrequency;
            $scope.vm.CTotalOrderValue = parseFloat(value.ContractValue);
            $scope.vm.Customer_ID = value.Customer_Id
            angular.forEach($scope.Frequencydatas, function (item) {
                try {
                    item.Freq = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1])
                } catch (error) { }
            })
            $scope.vm.CreditTerm = value.CreditTerm;
            if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
                $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
            }
            $scope.vm.ContractDuration = value.ContractDuration;
            $scope.vm.uCompanyName1 = value.CompanyName;
            $scope.vm.ContractEndDate = value.ContractEndDate;
            if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
                $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
            }
            $scope.vm.uEmail = value.Email;
            $scope.vm.Ccontact = value.ContactNumber
            $scope.vm.CustomerID = value.CustomerID;
            $scope.vm.ContractNotes = value.ContractNotes;
            $scope.vm.CreatedBy = value.CreatedBy;
            $scope.vm.SalesPerson = value.SalesPerson_id;
            $scope.vm.SalesPerson1 = value.EmployeeName;
            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContactPerson = value.ContactPerson;
            $scope.vm.ServiceStartDate = value.ServiceStartDate;
            if ($scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != "") {
                $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
                $scope.ServiceStartDate = new Date(value.ServiceStartDate);
            }
            $scope.vm.ServiceEndDate = value.ServiceEndDate;
            if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
                $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
                $scope.ServiceEndDate = new Date(value.ServiceEndDate);
            }
            $scope.vm.Frequency = value.Frequency;
            $scope.Frequency = value.BillingFrequency;
            if (value.MultiFrequency !== undefined && value.MultiFrequency.length > 0) {
                $scope.TempFrequency = value.MultiFrequency.map(function (obj) { return obj.Frequency; }).join(',  ');
            } else {
                $scope.TempFrequency = $scope.vm.Frequency;
            }
            $scope.vm.SiteContactPerson = value.SiteContactPerson;
            $scope.vm.SiteName = value.SiteName;
            if (value.SiteContact != null && value.SiteContact != undefined && value.SiteContact != "")
                $scope.vm.SiteContact = value.SiteContact;
            else
                $scope.vm.SiteContact = []
            if (value.SiteEmail != null && value.SiteEmail != undefined && value.SiteEmail != "")
                $scope.vm.SEmail = value.SiteEmail.split(',')
            else
                $scope.vm.SEmail = []
            $scope.vm.EnquiryID = value.EnquiryID
            $scope.MultiFrequencydatas = value.MultiFrequency
            $scope.vm.TemplateName = value.TemplateID;
            $scope.vm.SalesOrderID = value.SalesOrderID;
            $scope.vm.CreditTerm = value.CreditTerm;
            $scope.CreditTerm = value.CreditTerm;
            $scope.vm.IncludeSOR = value.IncludeSOR;
            $scope.vm.Customer_id = value.Customer;
            $scope.vm.NatureofJob1 = value.PestType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.Customer = value.Customer;
            $scope.vm.ContractStatus = value.ContractStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
            $scope.RenewalN = value.Renewal;
            $scope.OldContract_Id = value.OldContract_Id;

            //Customer 

            var response1 = $http({
                url: $rootScope.WebURL + "/customer/get",
                method: "POST",
                data: { id: value.Customer_Id },
            });
            response1.then(function (customer) {
                var customer = customer.data.data;
                $scope.vm.Customer_id = customer._id;
                $scope.vm.uCustomerID = customer.CustomerID;
                $scope.CustID = customer.CustomerID;
                $scope.vm.uCustomerType = customer.CustomerType;
                $scope.vm.uSalutation = customer.Salutation;
                $scope.vm.uFirstName = customer.FirstName;
                $scope.vm.uLastName = customer.LastName;
                $scope.vm.uWebsite = customer.Website;
                $scope.vm.uCompanyName = customer.CompanyName;
                $scope.vm.uNote = customer.Note;
                $scope.vm.uAddress1 = customer.Address1;
                $scope.vm.uPostal = (customer.Postal);
                $scope.vm.uCountry = customer.Country;
                $scope.vm.uContactPerson = customer.ContactPerson;
                $scope.vm.uPhone = parseInt(customer.Phone);
                $scope.vm.uFax = customer.Fax;
                var Mobile = customer.Mobile;
                if (Mobile != "" && Mobile != null && Mobile != undefined)
                    $scope.vm.uMobile = Mobile.split(',').join(' , ');
                // 
                $scope.vm.uTypeofHouse = customer.TypeofHouse;
                $scope.vm.uOtherType = customer.OtherType;
            });
            $scope.vm.uSAddress = value.sStreetName;
            $scope.vm.TempTemplate = value.TemplateName;

            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforBilling",
                method: "POST",
                data: { RequestID: value.CustomerIDD },
            });
            response.then(function (CustomerBillingdata) {
                $scope.CustomerBillingAddress = CustomerBillingdata.data.data
                var item = $scope.CustomerBillingAddress.filter(function (item) {
                    return item._id === value.BillingAddress
                })[0]
                if (item != undefined)
                    $scope.vm.uAddress = item.bStreetName
                else
                    $scope.vm.uAddress = null
            })
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: value.CustomerIDD },
            });
            response.then(function (CustomerServicedata) {
                $scope.CustomerServiceAddress = CustomerServicedata.data.data;
            })

            RefreshContractAttachment()
            RefreshAttachmentGrid();
            Refreshcomment();
            // Refreshquotationlog();
        }


        $scope.GetEmail = function (Email) {
            if (Email != null && Email != undefined && Email != "")
                $scope.vm.CEmail = Email.split(',')
            else
                $scope.vm.CEmail = []
        }

        $scope.Contracteditinfo = function (e, value) {
            $scope.Contractsgrid = false;
            $scope.ShowContractform = true;
            $scope.Contractsform = false;
            $scope.Salesform = false
            $scope.Add = false;
            $scope.view = true;
            $scope.Export = false;
            $scope.Search = false;
            $scope.Update = false;
            $scope.SID = value._id;
            $scope.ContractId = value._id;
            $scope.vm.ContractId = value._id;
            RefreshContractAttachment()
            $scope.ContarctAttachmentdatas = []
            $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
            $scope.vm.ContractReference = value.ContractReferenceNo
            $scope.vm.ContractReceivedBy = value.ContractReceivedBy;
            $scope.vm.ContractDate = new Date(value.ContractDate);
            $scope.vm.CustomerID = value.CustomerID;
            $scope.vm.Customer_id = value.Customer_id;
            var Requestid = value.CustomerIDD
            getSorDetails($scope.SID)
            var Email = value.Email
            if (Email != "" && Email != null && Email != undefined)
                $scope.vm.CEmail = value.Email.split(',')
            else
                $scope.vm.CEmail = []
            $scope.vm.ppCompanyName = value.CompanyName

            // Customer Service
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: Requestid },
            });
            response.then(function (CustomerServicedata) {
                var customerServicedetails = CustomerServicedata.data.data;
                if (customerServicedetails.length > 0) {
                    $scope.vm.BAddress = customerServicedetails[0].sStreetName
                    var BillingAddres = [{ sStreetName: customerServicedetails[0].sStreetName }]
                    $scope.CustomerServiceAddress = customerServicedetails
                    $scope.vm.SiteName = customerServicedetails[0].sName
                    var Mob = customerServicedetails[0].sMobile
                    if (Mob != undefined && Mob != null && Mob != "")
                        $scope.vm.SiteContactNo = Mob.split(',')
                    else
                        $scope.vm.SiteContactNo = []
                    $scope.vm.SiteContactPerson = customerServicedetails[0].sContactPerson
                    var Email = customerServicedetails[0].sEmail
                    if (Email != undefined && Email != null && Email != "")
                        $scope.vm.SEmail = Email.split(',')
                    else
                        $scope.vm.SEmail = []
                    $scope.CustomerServiceAddress = customerServicedetails
                }
                else {

                    $scope.CustomerServiceAddress = []
                    $scope.vm.SiteName = ""
                    $scope.vm.SiteContactNo = []
                    $scope.vm.SiteContactPerson = null
                    $scope.vm.SEmail = []
                    $scope.CustomerServiceAddress = customerServicedetails
                }
            });

            //Customer 

            var response1 = $http({
                url: $rootScope.WebURL + "/customer/get",
                method: "POST",
                data: { id: value.Customer_Id },
            });
            response1.then(function (customer) {
                var customer = customer.data.data;
                $scope.vm.CSalutation = customer.Salutation;
                $scope.vm.CName = customer.FirstName;
            });

            $scope.vm.NatureofJob = value.PestType;
            $scope.vm.BillingFrequency = value.BillingFrequency;
            $scope.vm.ContractStartDate = value.ContractStartDate;
            $scope.vm.ContractEndDate = value.ContractEndDate;
            $scope.vm.ContractDuration = parseInt(value.ContractDuration);
            $scope.vm.BAdress = value.SiteName;

            $scope.vm.CAddress = value.CustomerID
            $scope.vm.UpCAddress = value.CustomerID


            if (value.MarketSegment != null && value.MarketSegment != '' && value.MarketSegment != undefined) {
                var a = value.MarketSegment.split(',')
                var array = []
                _.each(a, function (ite) {
                    array.push({ SegmentName: ite })
                })
                $scope.vm.CMarketSegment = array
            }

            // $scope.vm.CMarketSegment = value.MarketSegment;
            var connumber = value.ContactNumber
            if (connumber != null && connumber != undefined && connumber != "")
                $scope.vm.Ccontact = connumber.split(',').slice(0, 3)
            else
                $scope.vm.Ccontact = []
            $scope.vm.ServiceHours = value.ServiceHours;
            $scope.vm.TotalSumPerfreq = parseInt(value.TotalSumPerfreq);
            $scope.vm.TotalOrderValue = parseFloat(value.ContractValue);
            if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
                var array = $scope.vm.NatureofJob.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                    array1.push({ PestName: value });
                });
                $scope.vm.NatureofJob = array1;
            }
            $scope.vm.SalesOrderID = value.SalesOrderID;
            $scope.vm.ContractMode = value.ContractMode;
            $scope.vm.CoverageArea = value.CoverageArea;
            if ($scope.vm.CoverageArea != null && $scope.vm.CoverageArea != "" && $scope.vm.CoverageArea != undefined) {
                var array = $scope.vm.CoverageArea.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                    array1.push({ AreasName: value });
                });
                $scope.vm.CoverageArea = array1;
            }
            $scope.vm.Header = value.Head
            $scope.vm.Header1 = value.Head1
            $scope.vm.Header2 = value.Head2
            $scope.vm.ContactMedium = value.ContactMedium;
            $scope.vm.SalesPerson = value.SalesPerson_id;
            $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
            if ($scope.vm.ExpectedResponseDate != null && $scope.vm.ExpectedResponseDate != "") {
                $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
            }
            $scope.vm.uSAddress = value.sStreetName;
            $scope.vm.Frequency = value.Frequency;
            $scope.vm.Confirmation = value.Confirmation;
            $scope.vm.ContractType = value.ContractType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.ContractStatus = value.ContractStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
            $scope.vm.IncludeSOR = value.IncludeSOR;
            $scope.vm.ServiceEndDate = value.ServiceEndDate;
            $scope.vm.ServiceStartDate = value.ServiceStartDate;
            $scope.vm.Servicestart = $filter('date')(value.ServiceStartDate, 'dd/MM/yyyy');
            $scope.vm.Serviceend = $filter('date')(value.ServiceEndDate, 'dd/MM/yyyy');
            $scope.vm.CreditTerm = value.CreditTerm;
            $scope.vm.TemplateName = value.TemplateID;
            $scope.Frequencydatas = value.MultiFrequency;
            $scope.vm.EnquiryID = value.EnquiryID
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforBilling",
                method: "POST",
                data: { RequestID: value.CustomerIDD },
            });
            response.then(function (CustomerBillingdata) {
                $scope.CustomerBillingAddress = CustomerBillingdata.data.data
                $scope.vm.BAddress = value.BillingAddress
            })
            try {
                var litem = $scope.Leaddetails.filter(function (litem) {
                    return litem.CustomerID === $scope.vm.Customer_id
                })
                $scope.Leaddatas = litem
            } catch (error) { }


            try {
                var item = $scope.Leaddatas.filter(function (item) {
                    return item.LeadReferenceNo === $scope.vm.EnquiryID
                })[0]
                $scope.vm.EnquiryID = item.LeadReferenceNo
                if ($scope.vm.TotalOrderValue == null || $scope.vm.TotalOrderValue == undefined || $scope.vm.TotalOrderValue == '')
                    $scope.vm.TotalOrderValue = parseFloat(item.Pipelinevalue)
            } catch (error) { }

            $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        }

        $scope.SendMail = function (PCId, Email, BillFrequency, ServiceStart, ServiceEnd, EmployeeDatails, invoice) {
            var item = $scope.contractdatas.filter(function (item) {
                return item._id === PCId
            })[0]
            var Uitem = $scope.Userdatas.filter(function (item) {
                return item.UserID == $rootScope.createdby;
            })[0];
            $scope.MailTo = Email
            $scope.CCTo = Uitem.Email + ",sales@pestoff.com.sg"
            var result = DevExpress.ui.dialog.confirm("Are you sure, you want to send Email ? <br><br> Mail Id: <b>" + $scope.MailTo + "</b><br> CC : <b>" + $scope.CCTo, "Email Confirmation!");
            result.done(function (dialogResult) {
                if (dialogResult == true) {
                    if ($scope.MailTo != undefined && $scope.MailTo != null && $scope.MailTo != "")
                        var Email = $scope.MailTo.split(',')
                    else
                        return $mdToast.show($mdToast.simple().textContent('Mail Id is not valid!').position('top center'))
                    var item = Email.filter(function (item) {
                        return validateEmail(item) == false
                    })
                    if (item.length > 0) {
                        $mdToast.show($mdToast.simple().textContent('Mail Id is not valid!').position('top center'))
                    }
                    else {
                        if ($scope.CCTo != undefined && $scope.CCTo != null && $scope.CCTo != "")
                            var Email = $scope.CCTo.split(',')
                        else
                            return $mdToast.show($mdToast.simple().textContent('CC Id is not valid!').position('top center'))
                        var item = Email.filter(function (item) {
                            return validateEmail(item) == false
                        })
                        if (item.length > 0) {
                            $mdToast.show($mdToast.simple().textContent('CC is not valid!').position('top center'))
                        }
                        else {
                            $scope.PreviewQuaotation(PCId, BillFrequency, ServiceStart, ServiceEnd, EmployeeDatails, invoice)
                        }
                    }
                }
                // 
            });
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.Totla = function (uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date();
                var secondDate = new Date(uTimeOut);
                if (firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)) {
                    return 'Expiried'
                }
                else {
                    var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
                    if (res == 0) {
                        return 'Expiried'
                    }
                    else {
                        return res;
                    }
                }
            }
            else { return null }
        }
        $scope.renewalpopup = function (e, renewalId, Cname, Crn) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/crm/contracts/renewal.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.RenewalId = renewalId;
            $scope.vm.Cname = Cname;
            $scope.vm.Crn = Crn;
            $scope.vm.ContractStartDate = null;
            $scope.vm.ContractEndDate = null;
            $scope.vm.ContractDuration = null;
            $scope.vm.ServiceStartDate = null;
            $scope.vm.ServiceEndDate = null;
            $scope.vm.Frequency = null;
        }
        $scope.RenewalSubmit = function (renewalId) {
            try {
                var item = $scope.contractdatas.filter(function (item) {
                    return item._id === renewalId;
                })[0];
                $scope.item = item;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/add",
                    data: {
                        PestType: item.PestType,
                        SalesPerson_id: item.SalesPerson_id,
                        Frequency: $scope.vm.Frequency,
                        ContractDuration: $scope.vm.ContractDuration,
                        ContactNumber: $scope.vm.Ccontact,
                        ContactPerson: item.ContactPerson,
                        ContractStartDate: $scope.vm.ContractStartDate,
                        ContractEndDate: $scope.vm.ContractEndDate,
                        ServiceEndDate: $scope.vm.ServiceEndDate,
                        ServiceStartDate: $scope.vm.ServiceStartDate,
                        Customer_id: item.Customer_id,
                        CustomerID: item.CustomerID,
                        ContractNotes: item.ContractNotes,
                        SalesOrderID: item.SalesOrderID,
                        EnquiryID: item.vm.EnquiryID,
                        Email: $scope.vm.CEmail,
                        ContractStatus: 'Open',
                        Status: 'New',
                        StatusID: 1,
                        OldContract_Id: $scope.vm.RenewalId,
                        Renewal: "Renewaled",
                        SiteContactPerson: $scope.vm.SiteContactPerson,
                        SiteEmail: $scope.vm.SiteEmail,
                        BillingAddress: $scope.vm.BAddress,
                        SiteContact: $scope.vm.SiteContact,
                        CreatedBy: $rootScope.createdby, IsActive: true,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
            } catch (e) { }
            response.then(function (GList) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/quotationlog/add",
                    data: {
                        ContractID: $scope.GListdata.id,
                        Status: 'New',
                        TableName: 'Contracts',
                        StatusCreatedBy: $rootScope.createdby,
                        StatusCreatedDate: new Date(),
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('center'));
                    RefreshGrid();
                    $scope.Contractsgrid = true;
                    $scope.Contractsform = false;
                    $scope.Salesform = false
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                });
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Renewal = function (e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/crm/contracts/renewal.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function EmployeeController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.RenewalDate = '';
            $scope.RenewalContractNo = '';
            $scope.CreatedDate = '';
            $scope.CreatedBy = '';
            $scope.RUpdate == false
        }
        $scope.DaysCalc = function (CED) {
            var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            var firstDate = new Date($scope.vm.ContractStartDate);
            var secondDate = new Date($scope.vm.ContractEndDate);
            $scope.vm.ContractDuration = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay))) + 1;
        }
        $scope.ShowClosed = function (ShowClosed) {
            if (ShowClosed == true) {
                $scope.uShowClosed = true
                $scope.contractdatas = $scope.ContractHalf
            }
            else {
                // Refreshcomment();
                // RefreshAttachmentGrid();
                $scope.uShowClosed = false
                $scope.contractdatas = $scope.ContractAll;
            }
            angular.forEach($scope.contractdatas, function (value) {
                try {
                    value.ContractDate = new Date(value.ServiceStartDate).toLocaleDateString('en-GB') + " - " + new Date(value.ServiceEndDate).toLocaleDateString('en-GB');
                    value.IncludeSor = value.IncludeSOR ? "Yes" : "No"
                    value.TempPestType = value.MultiFrequency.map(function (obj) { return obj.PestType; }).join(',');
                    var pest = value.TempPestType.split(',')
                    var PestArray = []
                    PestArray = $scope.Pestdatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
                    value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
                } catch (e) {
                }
            })
        }
        $scope.PreviewQuaotation = function (PCId, BillFrequency, ServiceStart, ServiceEnd, EmployeeDatails, invoice) {
            $scope.vm.ContractDuration = " ";
            $scope.vm.BillingFrequency = BillFrequency;
            $scope.vm.ServiceStartDate = new Date(ServiceStart);
            $scope.vm.ServiceEndDate = new Date(ServiceEnd);
            $scope.UserID = undefined;
            try {
                var EmployeeID = EmployeeDatails
                var item = $scope.Userdatas.filter(function (item) {
                    return item.UserID == EmployeeID;
                });
                angular.forEach(item, function (value) {
                    $scope.UserID = value.id;
                })
            } catch (e) {

            }
            CalculateDuration();
            var url = $rootScope.ReportURL + 'Contracts.aspx' + '?' + 'ID=' + PCId + '&Duration=' + $scope.vm.ContractDuration + '&UserID=' + $scope.UserID + '&Type=' + invoice;
            if (invoice == "Send Email") {
                if (dataGrid != undefined)
                    dataGrid.beginCustomLoading();
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/SendEmail",
                    data: {
                        url: url
                    },
                });
                response.then(function (List) {
                    RefreshGrid();
                    if (dataGrid != undefined)
                        dataGrid.endCustomLoading();
                    $mdToast.show($mdToast.simple().textContent('Email Sent Successfully !').position('top center'));
                })

            }
            //  window.open(url, "_blank", "toolbar=1, scrollbars=1, resizable=1, width=" + 1015 + ", height=" + 800);
            else window.open(url);
        }
        $scope.Preview = function () {
            if ($scope.vm.Header != null) {
                $scope.Frequencygroups = _.groupBy($scope.Frequencydatas, 'Frequency');
                $scope.Previewdiv = true;
                var innerContents = document.getElementById('invoice').innerHTML;
                var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWinindow.document.open();
                popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body  onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
                popupWinindow.document.close($scope.Previewdiv = false);
            }
        }

        $scope.ContractReport = function (ContractId) {
            var url = $rootScope.ReportURL + 'Contracts.aspx' + '?' + 'ID=' + ContractId;
            window.open(url);
        }

        function CalculateDuration() {
            try {
                var Frequency = $scope.vm.BillingFrequency;
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date($scope.vm.ServiceStartDate);
                var secondDate = new Date($scope.vm.ServiceEndDate);
                var Totaldays = 1 + Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
                if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
                    var TotalMonths = Math.round(Totaldays / 30);
                    $scope.vm.ContractDuration = TotalMonths;
                    if ($scope.vm.ContractDuration > 1) {
                        $scope.vm.ContractDuration = TotalMonths + " months";
                    } else { $scope.vm.ContractDuration = TotalMonths + " month"; }
                }
            } catch (e) {

            }
        }
        $scope.sSubmit = function () {
            try {
                angular.forEach($scope.salesOrderdatas, function (svalue) {
                    if ($scope.vm.SalesOrderID == svalue._id) {
                        $scope.vm.Customer_id = svalue.customerdetails[0]._id;
                    }
                });
            } catch (error) { }
            if ($scope.vm.NatureofJob != null && $scope.vm.NatureofJob != "" && $scope.vm.NatureofJob != undefined) {
                $scope.vm.NatureofJob = $scope.vm.NatureofJob.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.vm.CMarketSegment != null && $scope.vm.CMarketSegment != "" && $scope.vm.CMarketSegment != undefined) {
                $scope.vm.CMarketSegment = $scope.vm.CMarketSegment.map(function (obj) { return obj.SegmentName; }).join(',');
            }
            if ($scope.vm.CEmail != null && $scope.vm.CEmail != "" && $scope.vm.CEmail != undefined) {
                $scope.vm.CEmail = $scope.vm.CEmail.map(function (obj) { return obj; }).join(',');
            }
            if ($scope.vm.SEmail != null && $scope.vm.SEmail != "" && $scope.vm.SEmail != undefined) {
                $scope.vm.SEmail = $scope.vm.SEmail.map(function (obj) { return obj; }).join(',');
            }
            if ($scope.vm.Ccontact != null && $scope.vm.Ccontact != "" && $scope.vm.Ccontact != undefined) {
                $scope.vm.Ccontact = $scope.vm.Ccontact.map(function (obj) { return obj; }).join(',');
            }

            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contract/update",
                    data: {
                        _id: $scope.SID,
                        SalesPerson_id: $scope.vm.SalesPerson,
                        //  Frequency: multiFrequency,
                        MarketSegment: $scope.vm.CMarketSegment,
                        CreditTerm: $scope.vm.CreditTerm,
                        TemplateID: $scope.vm.TemplateName,
                        IncludeSOR: $scope.vm.IncludeSOR,
                        MultiFrequency: $scope.Frequencydatas,
                        ContactPerson: $scope.vm.uContactPerson,
                        ServiceEndDate: $scope.vm.ServiceEndDate,
                        ContactNumber: $scope.vm.Ccontact,
                        ServiceStartDate: $scope.vm.ServiceStartDate,
                        ContractStartDate: $scope.vm.ContractStartDate,
                        ContractEndDate: $scope.vm.ContractEndDate,
                        ContractDuration: $scope.vm.ContractDuration,
                        ContractValue: $scope.vm.TotalOrderValue,
                        ServiceHours: $scope.vm.ServiceHours,
                        BillingFrequency: $scope.vm.BillingFrequency,
                        TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
                        Customer_id: $scope.vm.Customer_id,
                        CustomerID: $scope.vm.CustomerID,
                        EnquiryID: $scope.vm.EnquiryID,
                        ContractNotes: $scope.vm.ContractNotes,
                        ContractStatus: $scope.vm.ContractStatus,
                        Status: $scope.vm.CurrentStatus,
                        StatusID: $scope.vm.CurrentStatusID,
                        Email: $scope.vm.CEmail,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                        // SiteContactPerson:$scope.vm.SiteContactPerson,
                        // SiteEmail:$scope.vm.SEmail,
                        // SiteName:$scope.vm.SiteName,
                        BillingAddress: $scope.vm.BAddress,
                        // SiteContact:$scope.vm.SiteContact,
                        Head: $scope.vm.Header,
                        Head1: $scope.vm.Header1,
                        Head2: $scope.vm.Header2
                    },
                });
                response.then(function (GList) {
                    if ($scope.vm.IncludeSOR == true) {
                        var response1 = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/sor/delete",
                            data: {
                                Client_Id: $rootScope.Client_Id, FieldName: 'Contract', FieldValue: $scope.SID
                            },
                        });
                        response1.then(function (Ls) {
                            var count = 0
                            angular.forEach($scope.dataSource, function (item) {
                                var response2 = $http({
                                    method: "POST",
                                    url: $rootScope.WebURL + "/sor/add",
                                    data: {
                                        Customer: $scope.vm.Customer_id,
                                        Contract: $scope.SID,
                                        Description: item.Description,
                                        Unit: item.Unit,
                                        RateDuringOfficeHour: item.RateDuringOfficeHour,
                                        RateAfterOfficeHour: item.RateAfterOfficeHour,
                                        Client_Id: $rootScope.Client_Id,
                                        CreatedBy: $rootScope.createdby
                                    },
                                });
                                response2.then(function (GList) {
                                    count++
                                    if (count == $scope.dataSource.length + 1) {
                                        $mdToast.show($mdToast.simple().textContent('SOR Added Successfully !').position('top center'));
                                    }
                                })
                            })
                        })
                    }
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid()
                    $scope.Contractsgrid = true;
                    $scope.ShowContractform = false;
                    $scope.Contractsform = false;
                    $scope.Salesform = false
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.Search = true;
                    $scope.view = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                try {
                    var multiFrequency = $scope.Frequencydatas[0].Frequency
                } catch (e) {
                    var multiFrequency = $scope.vm.Frequency
                }
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/renewal",
                    data: {
                        OldContract_Id: $scope.SID,
                        SalesPerson_id: $scope.vm.SalesPerson,
                        Frequency: multiFrequency,
                        MarketSegment: $scope.vm.CMarketSegment,
                        CreditTerm: $scope.vm.CreditTerm,
                        TemplateID: $scope.vm.TemplateName,
                        IncludeSOR: $scope.vm.IncludeSOR,
                        MultiFrequency: $scope.Frequencydatas,
                        ContactNumber: $scope.vm.Ccontact,
                        ContactPerson: $scope.vm.uContactPerson,
                        ServiceEndDate: $scope.vm.ServiceEndDate,
                        ServiceStartDate: $scope.vm.ServiceStartDate,
                        ContractStartDate: $scope.vm.ContractStartDate,
                        ContractEndDate: $scope.vm.ContractEndDate,
                        ContractDuration: $scope.vm.ContractDuration,
                        ContractValue: $scope.vm.TotalOrderValue,
                        ServiceHours: $scope.vm.ServiceHours,
                        BillingFrequency: $scope.vm.BillingFrequency,
                        TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
                        Customer_id: $scope.vm.Customer_id,
                        CustomerID: $scope.vm.CAddress,
                        EnquiryID: $scope.vm.EnquiryID,
                        ContractNotes: $scope.vm.ContractNotes,
                        ContractStatus: $scope.vm.ContractStatus,
                        Status: $scope.vm.CurrentStatus,
                        StatusID: $scope.vm.CurrentStatusID,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                        Client_Id: $rootScope.Client_Id,
                        SORDetails: $scope.dataSource,
                        Head: $scope.vm.Header,
                        Head1: $scope.vm.Header1,
                        Head2: $scope.vm.Header2,
                        Email: $scope.vm.CEmail,
                        SiteContactPerson: $scope.vm.SiteContactPerson,
                        SiteEmail: $scope.vm.SEmail,
                        BillingAddress: $scope.vm.BAddress,
                        SiteContact: $scope.vm.SiteContact,
                    },
                });
                response.then(function (GList) {
                    $scope.GListdata = GList.data.data;
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Contract Renewed Successfully!').position('top center'));
                    RefreshGrid()
                    $scope.ShowContractform = false;
                    $scope.Contractsgrid = true;
                    $scope.Contractsform = false;
                    $scope.Salesform = false
                    $scope.Export = true;
                    $scope.Add = true;
                    $scope.view = false;
                    $scope.Search = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.commentSubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulercomment/add",
                data: {
                    ContractID: $scope.SID,
                    CustomerID: $scope.vm.CustomerID,
                    TableName: "Contracts",
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Addcomments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshGrid();
                $scope.vm.Addcomments = '';
                $scope.Contractsgrid = false;
                $scope.Contractsform = true;
                $scope.Salesform = false
                $scope.Export = false;
                $scope.Add = false;
                $scope.view = true;
                $scope.Search = false;
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Frequencydatas = [];
        $scope.ChangeTreatmentType = function (item) {
            if (item.TreatmentName == "Others" && item.selected == true) {
                $scope.ShowOthersTextBox = true;
            } else if (item.TreatmentName == "Others" && item.selected !== true) {
                $scope.ShowOthersTextBox = false;
            }
        }
        $scope.AddPestType = function (e) {
            $scope.ShowPestAdd = false;
            $scope.vm.SelectFreq = null;
            $scope.vm.Frequency = null;
            $scope.PestTreatmentdatas = [];
            $scope.Pesttypearray = null;
            $scope.vm.SelectPest = null;
            $scope.vm.Scopeofwork = null;
            $scope.Treatmentpopupdata = [];
            $scope.EditFrequency = false;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/AddPestTypepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            RefreshTreatment();
        }
        $scope.ChangeTreatment = function (Pestdata) {
            $scope.Treatmentpopupdata = [];
            if ($scope.EditFrequency == false) {

                if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
                    $scope.Pesttypearray = [];
                    angular.forEach(Pestdata, function (value) {
                        var Pestname = value.PestName;
                        var array = [];
                        var item1 = $scope.Treatmentdatas.filter(function (item1) {
                            if (item1.PestType.indexOf(Pestname) > -1) {
                                if (item1.TreatmentName != "Service Light Traps")
                                    array.push({ TreatmentName: item1.TreatmentName });
                            }
                        });
                        $scope.Treatmentpopupdata.push({ PestName: Pestname, Treatment: array });
                    })
                }
            } else {
                var array = [];
                var item1 = $scope.Treatmentdatas.filter(function (item1) {
                    if (item1.PestType.indexOf(Pestdata.PestType) > -1) {
                        var selectedtreatment = Pestdata.Treatment.split(', ');
                        if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
                            item1.selected = true;
                        }
                        array.push({ TreatmentName: item1.TreatmentName, selected: item1.selected });

                    }
                    return item1.PestType.indexOf(Pestdata.PestType) > -1;
                });
                var OthersSelect = false
                var ServiceTypeSelect = false
                if (Pestdata.Others !== undefined) { OthersSelect = true; } else { OthersSelect = false; }
                if (Pestdata.ServiceTrap !== undefined) { ServiceTypeSelect = true; } else { ServiceTypeSelect = false; }
                array.map(function (o, k) { if (o.TreatmentName === "Service Light Traps") if (k != undefined) array.splice(k) })
                $scope.Treatmentpopupdata.push({ PestName: Pestdata.PestType, Treatment: array, Others: Pestdata.Others, selectothers: OthersSelect, ServiceTrap: Pestdata.ServiceTrap, SelectServiceTrap: ServiceTypeSelect });
            }
        }
        $scope.SubmitPest = function () {
            var Scopeofwork = "";
            var array = [];
            angular.forEach($scope.Treatmentpopupdata, function (item) {

                var item1 = item.Treatment.filter(function (item1) {
                    return item1.selected == true
                });
                var Treatmentarray = null;
                var OthersTreatment = item.Others;
                if (item.selectothers == false) { OthersTreatment = undefined; }
                var ServiceTrap = item.ServiceTrap
                if (item.SelectServiceTrap == false) { ServiceTrap = undefined; }


                if (item1 !== undefined) {
                    Treatmentarray = item1.map(function (obj) { return obj.TreatmentName; }).join(', ');
                }
                if (OthersTreatment != undefined) {
                    if (Treatmentarray != null && Treatmentarray != "") {
                        Treatmentarray = Treatmentarray + ', ' + OthersTreatment
                    }
                    else Treatmentarray = OthersTreatment
                }
                array = $scope.Frequencydatas.filter(function (item2) {
                    return item2.PestType == item.PestName && item2.Frequency == $scope.vm.Frequency;
                });

                if (ServiceTrap != undefined) {
                    if (Treatmentarray != "" && Treatmentarray != null)
                        Treatmentarray = Treatmentarray + ", Service Light Traps"
                    else
                        Treatmentarray = "Service Light Traps"
                }
                if (OthersTreatment != undefined) {
                    if (Treatmentarray != null && Treatmentarray != "") {
                        Treatmentarray = Treatmentarray + ', ' + OthersTreatment
                    }
                    else Treatmentarray = OthersTreatment
                }

                if (array.length == 0) {
                    $scope.Frequencydatas.push({
                        Frequency: $scope.vm.Frequency,
                        PestType: item.PestName,
                        Treatment: Treatmentarray,
                        Others: OthersTreatment,
                        ServiceTrap: ServiceTrap
                    });
                } else if ($scope.EditFrequency == true) {
                    $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].Treatment = Treatmentarray;
                    $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].Others = OthersTreatment;
                    $scope.Frequencydatas[$scope.Frequencydatas.indexOf(array[0])].ServiceTrap = ServiceTrap;
                } else {
                    $mdToast.show($mdToast.simple().textContent('Existing Data!').position('top center'));
                }
            });
            $mdDialog.hide();
        }
        $scope.EditPestControl = function (e, item) {
            RefreshTreatment();
            $scope.EditFrequency = true;
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.Pesttype = item.PestType;
            $scope.vm.ServiceTrap = item.ServiceTrap;
            $scope.ChangeTreatment(item);
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/AddPestTypepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.DeleteTempPest = function (DeleteItem) {
            var index = $scope.PestTreatmentdatas.indexOf(DeleteItem);
            $scope.PestTreatmentdatas.splice(index, 1);
        }
        $scope.DeletePestControl = function (DeleteItem) {
            var index = $scope.Frequencydatas.indexOf(DeleteItem);
            $scope.Frequencydatas.splice(index, 1);
        }

        $scope.UploadContractfiles = function (file) {
            angular.forEach(file, function (item) {
                var upfile = item.file
                var response = Upload.upload({
                    url: $rootScope.WebURL + "/contract/upload",
                    data: { file: upfile }
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME
                    $scope.fileName = resp.data.data[0].OriginalFileName
                    $scope.fileSize = resp.data.data[0].Size
                    $scope.Path = resp.data.data[0].Path
                    $scope.fileType = resp.data.data[0].Type
                    if (resp.data.message == "Successfully Uploaded") {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID, TableName: "Contracts", FileID: $scope.vm.ContractId,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize, FileType: $scope.fileType,
                                ModuleID: $scope.Path, Data: null, IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response.then(function (GList) {
                            RefreshContractAttachment();

                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            })
            file[0].cancel()
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        }

        function RefreshContractAttachment() {
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.ContractId },
            });
            response.then(function (attachmentdata) {
                $scope.ContarctAttachmentdatas = attachmentdata.data.data;
            });
        }

        $scope.Uploadfiles = function (file) {
            angular.forEach(file, function (item) {
                var upfile = item.file
                var response = Upload.upload({
                    url: $rootScope.WebURL + "/salesOrder/upload",
                    data: { file: upfile }
                }).then(function (resp) {
                    $scope.TableID = resp.data.data[0].GUIDFILENAME
                    $scope.fileName = resp.data.data[0].OriginalFileName
                    $scope.fileSize = resp.data.data[0].Size
                    $scope.Path = resp.data.data[0].Path
                    $scope.fileType = resp.data.data[0].Type
                    if (resp.data.message == "Successfully Uploaded") {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/attachment/add",
                            data: {
                                TableID: $scope.TableID,
                                TableName: "Sales Order",
                                FileID: UniqID,
                                FileName: $scope.fileName,
                                FileSize: $scope.fileSize,
                                FileType: $scope.fileType,
                                ModuleID: $scope.Path,
                                Data: null,
                                IsActive: "true",
                                CreatedBy: $rootScope.createdby,
                            },
                        });
                        response.then(function (GList) {
                            RefreshAttachmentGrid();

                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            })
            file[0].cancel();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

        }

        $scope.DeleteAttachement = function (e, deleteID) {
            $scope.AttachdeleteID = deleteID;
            $mdDialog.show({
                templateUrl: 'app/main/apps/crm/contracts/attachmentdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        // $scope.Adelete = function (AttachmentdeleteID) {
        //     var response = $http({
        //         method: "POST",
        //         url:  $rootScope.WebURL + "/attachment/delete",
        //         data: { _id: AttachmentdeleteID },
        //     });
        //     response.then(function (GList) {
        //         RefreshAttachmentGrid();
        //         $mdDialog.cancel();
        //         $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
        //     }, function () {
        //         $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //     });
        // }

        $scope.Adelete = function (e, AttachmentdeleteID, datas) {
            if ($scope.Update == false) {

                var index = $scope.Attachmentdatas.indexOf(datas);
                $scope.Attachmentdatas.splice(index, 1);

            } else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/attachment/delete",
                    data: { _id: AttachmentdeleteID },
                });
                response.then(function (GList) {
                    RefreshAttachmentGrid();
                    RefreshContractAttachment()
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.ChangeCustomer = function (Customerdata) {
            $scope.vm.CMarketSegment = null;
            try {
                CustomerBillingdatadetails(Customerdata.CustomerID)
                $scope.vm.CName = Customerdata.FirstName;
                $scope.vm.CSalutation = Customerdata.Salutation;
                $scope.vm.uCustomerID = Customerdata.CustomerID;
                $scope.vm.Ccontact = []
                var contact = Customerdata.Mobile
                if (contact != "" && contact != null && contact != undefined) {
                    contact = contact.split(',').slice(0, 3)
                    $scope.vm.Ccontact = contact;
                }

                //
                // $scope.vm.CAddress = Customerdata.StreetName;
                // $scope.vm.CPostalCode = Customerdata.Postal;
                // $scope.vm.CBuildingName = Customerdata.BuildingName;
                if (Customerdata.MarketSection != null && Customerdata.MarketSection != '' && Customerdata.MarketSection != undefined) {
                    var a = Customerdata.MarketSection.split(',')
                    var array = []
                    _.each(a, function (ite) {
                        array.push({ SegmentName: ite })
                    })
                    $scope.vm.CMarketSegment = array
                }
                $scope.CusEmail = []
                $scope.GetEmail(Customerdata.Email)
                //  $scope.vm.CMarketSegment = Customerdata.MarketSection;
                //    
                // $scope.vm.Ccontact = Customerdata.Mobile;
                try {
                    var litem = $scope.Leaddetails.filter(function (litem) {
                        return litem.CustomerID === Customerdata._id
                    })
                    $scope.Leaddatas = litem
                } catch (e) { }
                if ($scope.Leaddatas.length > 0) {
                    $scope.vm.EnquiryID = $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
                    if ($scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == 'Day')
                        $scope.vm.ServiceHours = 'During Office Hours'
                    else if ($scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == 'Night')
                        $scope.vm.ServiceHours = 'After Office Hours'
                    else $scope.vm.ServiceHours = 'Wee Hours 12:00pm - 8:30am'
                    $scope.vm.TotalOrderValue = parseFloat($scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue)
                }
                var response = $http({
                    url: $rootScope.WebURL + "/customerService/getByIDforService",
                    method: "POST",
                    data: { RequestID: Customerdata.CustomerID },
                });
                response.then(function (CustomerServicedata) {
                    $scope.CustomerServiceAddress = CustomerServicedata.data.data;
                })
            } catch (e) {
                $scope.vm.CMarketSegment = null;
            }
        }
        $scope.getLeaddetails = function (row) {
            if (row.ServiceTime == 'Day')
                $scope.vm.ServiceHours = 'During Office Hours'
            else if (row.ServiceTime == 'Night')
                $scope.vm.ServiceHours = 'After Office Hours'
            else $scope.vm.ServiceHours = 'Wee Hours 12:00pm - 8:30am'
            $scope.vm.TotalOrderValue = parseFloat(row.Pipelinevalue)
        }
        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        function RefreshCustomerdatas() {
            $scope.getCustomerdatas = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getCustomerLength",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (customerlength) {

                var CustomerLength = Math.ceil(customerlength.data.data / 500)
                var Skip = 0
                var Limit = 500
                for (var i = 0; i < CustomerLength; i++) {
                    if (i == 0) Skip = 0; else Skip += 500
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/customer/getByskipLimit",
                        data: { Client_Id: $rootScope.Client_Id, Skip: Skip, Limit: Limit }
                    }).then(function (customerdata) {
                        $scope.getCustomerdatas = $scope.getCustomerdatas.concat(customerdata.data.data);
                        if (IsAdmin != true) {
                            var item = $scope.getCustomerdatas.filter(function (item) {
                                if (item.AssignedUser != null)
                                    return item.AssignedUser.includes($rootScope.createdby)
                            })
                            $scope.Customerdatasfordropdown = item
                            $scope.Customerdatas = customerdata.data.data
                        }
                        else {
                            $scope.Customerdatas = $scope.getCustomerdatas
                            $scope.Customerdatasfordropdown = $scope.getCustomerdatas
                        }
                    })
                }

            })

        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
            $scope.Pestdatasdatas = pestdata.data.data;
        });
        RefreshSchedulerFrequency()
        RefreshTreatment();
        function RefreshTreatment() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/treatment",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Treatmentdata) {
                $scope.Treatmentdatas = Treatmentdata.data.data;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/user/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Userdata) {
            $scope.Userdatas = Userdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/salesOrder",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (salesOrderdata) {
            $scope.salesOrderdatas = salesOrderdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/Workflow",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Workflowdata) {
            $scope.Workflowdatas = Workflowdata.data.data;
            // $scope.Datefilter();
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/marketsegment",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (marketsegmentdata) {
            $scope.Marketsegmentdatas = marketsegmentdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/contracttemplate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (contracttemplate) {
            $scope.Contracttemplates = contracttemplate.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/crmscopeofwork",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (sowdata) {
            $scope.SOWdatas = sowdata.data.data;
        });

        function RefreshGrid() {
            // get for Contract 
            var StartDate = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 1)
            $scope.contractdatas = []
            $scope.Pendingcontractdatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getLength",
                data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder" }
            }).then(function (List) {
                var ContractLength = List.data.data
                var Skip = 0
                var Limit = ContractLength

                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/getdatefilter",
                    data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder", IsAdmin: IsAdmin, SalesPerson: $scope.Emp_Id, Skip: Skip, Limit: Limit, StartDate: new Date(), EndDate: StartDate }
                }).then(function (GList) {
                    var item = GList.data.data
                    $scope.vm.PreviewSpinner = false
                    if ($scope.Pendingcontractdatas.length > 0) {
                        item = item.concat($scope.Pendingcontractdatas)
                        $scope.contractRenewaldatas = item.filter(function (ite) {
                            return ite.Renewal != true
                        })
                    }
                })
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

            // get for Ad-hoc WorkOrder
            if (dataGrid != undefined)
                dataGrid.beginCustomLoading()
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getLength",
                data: { Client_Id: $rootScope.Client_Id, Type: "New" }
            }).then(function (List) {
                var ContractLength = List.data.data
                var Skip = 0
                var Limit = ContractLength

                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contract/getdatefilter",
                    data: { Client_Id: $rootScope.Client_Id, Type: "New", IsAdmin: IsAdmin, SalesPerson: $scope.Emp_Id, Skip: Skip, Limit: Limit, StartDate: new Date(), EndDate: StartDate }
                }).then(function (GList) {
                    if (dataGrid != undefined)
                        dataGrid.endCustomLoading()
                    $scope.Pendingcontractdatas = GList.data.data
                    var item = $scope.Pendingcontractdatas.filter(function (item) {
                        return item.Renewal != true
                    })
                    if ($scope.contractdatas.length > 0) {
                        $scope.contractRenewaldatas = $scope.contractdatas.concat(item)
                    }
                })

            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        }
        function RefreshAttachmentGrid() {
            if ($scope.Salesform == true) $scope.File_id = UniqID
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.File_id },
            });
            response.then(function (attachmentdata) {
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
            // var response1 = $http({
            //     url:  $rootScope.WebURL + "/attachment/getByFileID",
            //     method: "POST",
            //     data: { FileID: $rootScope.ID },
            // });
            // response1.then(function (attachmentdata) {
            //     $scope.UserAttachments = attachmentdata.data.data;
            //     $scope.FilePath = null;
            //     try {
            //         $scope.FilePath = $rootScope.UploadsURL + 'Security/Users/' + $scope.Attachmentdatas[0].TableID;
            //         $scope.fileName = null;
            //     } catch (e) {
            //         $scope.FilePath = null;
            //     }
            // });
        }
        function Refreshcomment() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulercomment/getByContractID",
                method: "POST",
                data: { RequestID: $scope.File_id },
            });
            response.then(function (Commentdata) {
                $scope.Commentdatas = Commentdata.data.data;
            });
        }
        function Refreshquotationlog() {
            var response = $http({
                url: $rootScope.WebURL + "/quotationlog/getByRequestID",
                method: "POST",
                data: { Contract_id: $scope.File_id },
            });
            response.then(function (Quotationlogdata) {
                $scope.Quotationlogdatas = Quotationlogdata.data.data;
                var resArr = [];
                try {
                    $scope.Quotationlogdatas.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                            return x.Status == item.Status
                        });
                        if (i <= -1)
                            resArr.push(item);
                    });
                } catch (e) { }
                $scope.Quotationlogdatas = resArr;
            });
        }
        function quotationlogsubmit() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationlog/add",
                data: {
                    ContractID: $scope.SID,
                    TableName: 'Contracts',
                    Status: $scope.cNextActioned,
                    StatusCreatedBy: $scope.createdby,
                    StatusCreatedDate: new Date(),
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                RefreshGrid();
            })
        }
        function fetchContract(contractId) {
            angular.forEach($scope.contractdatas, function (value) {
                if (value._id == contractId) {
                    $scope.vm.ContractId = value._id;
                    $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
                    $scope.vm.ContractStartDate = value.ContractStartDate;
                    if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
                        $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
                    }
                    $scope.vm.ContractDuration = value.ContractDuration;
                    $scope.vm.uCompanyName = value.CustomerName;
                    $scope.vm.ContractEndDate = value.ContractEndDate;
                    if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
                        $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
                    }
                    $scope.vm.ContractNotes = value.ContractNotes;
                    $scope.vm.CreatedBy = value.CreatedBy;
                    $scope.vm.SalesPerson = value.SalesPerson;
                    $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
                    $scope.vm.ContactPerson = value.ContactPerson;
                    $scope.vm.ServiceStartDate = value.ServiceStartDate;
                    if ($scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != "") {
                        $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
                    }
                    $scope.vm.ServiceEndDate = value.ServiceEndDate;
                    if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
                        $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
                    }
                    $scope.vm.Frequency = value.Frequency;
                    $scope.vm.SalesOrderID = value.SalesOrderID;
                    $scope.vm.NatureofJob1 = value.PestType;
                    $scope.vm.ContractStatus = value.ContractStatus;
                    $scope.vm.CurrentStatus = value.Status;
                    $scope.vm.CurrentStatusID = value.StatusID;
                }
                RefreshContractAttachment()
            });
        }
        $scope.CalculateTotalServices = function () {
            try {
                var Frequency = $scope.vm.BillingFrequency;
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date($scope.vm.ServiceStartDate);
                var secondDate = new Date($scope.vm.ServiceEndDate);
                var Totaldays = 1 + Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
                if (Frequency !== null && Frequency !== undefined && Frequency !== "") {

                    if (Frequency.toUpperCase() == 'DAILY') {
                        $scope.vm.ContractDuration = Totaldays;

                    } else if (Frequency.toUpperCase() == 'WEEKLY') {
                        var TotalWeeks = Math.round(Totaldays / 7);
                        $scope.vm.ContractDuration = TotalWeeks;

                    } else if (Frequency.toUpperCase() == 'YEARLY') {
                        var Totalyearss = Math.round(Totaldays / 365);

                        $scope.vm.ContractDuration = Totalyearss;

                    } else if (Frequency.toUpperCase() == 'BIMONTHLY' || Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1) {
                        var TotalHallfyearss = Math.round(Totaldays / 60);

                        $scope.vm.ContractDuration = TotalHallfyearss;

                    } else if (Frequency.toUpperCase() == 'HALF-YEARLY' || Frequency.toUpperCase().indexOf('HALFYEARLY') > -1) {
                        var TotalHallfyearss = Math.round(Totaldays / 183);

                        $scope.vm.ContractDuration = TotalHallfyearss;
                    } else if (Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1 || Frequency.toUpperCase().indexOf('BIWEEKLY') > -1) {
                        var TotalHallfyearss = Math.round(Totaldays / 14);

                        $scope.vm.ContractDuration = TotalHallfyearss;
                    } else {
                        //for Month
                        var TotalMonths = Math.round(Totaldays / 30);

                        $scope.vm.ContractDuration = TotalMonths;
                    }
                }
            } catch (e) {

            }
        }
        function ClearForm() {
            $scope.vm.CustomerName = null;
            $scope.vm.Customer_id = null;
            $scope.vm.SalesOrderID = null;
            $scope.vm.CMarketSegment = null;
            $scope.vm.CSalutation = null;
            $scope.vm.CName = null;
            $scope.vm.Ccontact = [];
            $scope.vm.CAddress = null;
            $scope.vm.CPostalCode = null;
            $scope.vm.CBuildingName = null;
            $scope.vm.ContractReferenceNo = null;
            $scope.vm.ContractStartDate = null;
            $scope.vm.NatureofJob = null;
            $scope.vm.ContractValue = null;
            $scope.vm.ContractDuration = null;
            $scope.vm.uContactPerson = null;
            $scope.vm.ContractEndDate = null;
            $scope.vm.ContractNotes = null;
            $scope.vm.CreatedBy = null;
            $scope.vm.SalesPerson = null;
            $scope.vm.Frequency = null;
            $scope.vm.ContactPerson = null;
            $scope.vm.ServiceStartDate = null;
            $scope.vm.ServiceEndDate = null;
            $scope.vm.TemplateName = null;
            $scope.vm.CreditTerm = null;
            $scope.Frequencydatas = [];
            $scope.vm.IncludeSOR = false;
            $scope.vm.CEmail = []
            $scope.vm.SEmail = []
            $scope.vm.BAddress = null
            $scope.vm.SiteContactPerson = null;
            $scope.vm.SiteName = null;
            $scope.vm.SiteContact = [];
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();
        }

        $scope.getRowColour = function (item) {
            if (item.MultiFrequency !== undefined && item.MultiFrequency.length > 0) {
                var Frequencies = item.MultiFrequency;
                item.TempFrequency = Frequencies.map(function (obj) { return obj.Frequency; }).join(',');
                var PestType = item.MultiFrequency.map(function (obj) { return obj.PestType; }).join(',');
                PestType = PestType.split(",");
                var array1 = [];

                angular.forEach(PestType, function (value) {
                    if (array1.indexOf(value) == -1) {
                        array1.push(value);
                    }

                });
                item.TempPestType = array1.map(function (obj) { return obj; }).join(', ');
            } else {
                item.TempFrequency = item.Frequency;
            }
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var ServiceEndDate = item.ServiceEndDate;
            if (new Date(ServiceEndDate) < new Date(today)) {
                return true;
            }
            else {
                return false;
            }
        }

        // var vm = this;
        //// Data
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
            }
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            responsive: true,
            drawCallback: function (settings) {
                var api = this.api();

                var rows = api.rows({ page: 'current' }).nodes();
                var last = null;

                api.column(1, { page: 'current' }).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
                        );

                        last = group;
                    }
                });
            },
        };
        function ClearWOForm() {
            $scope.vm.SalesOrderNo = null;
            $scope.vm.OrderConfirmationDate = new Date();
            $scope.vm.ConfirmationMode = null;
            $scope.vm.ConfirmationBy = null;
            $scope.vm.ConfirmationReceivedBy = null;
            $scope.vm.ConfirmationReceivedDate = new Date();
            $scope.vm.Remarks = null;
            $scope.vm.CreatedBy = null;
            $scope.vm.PONumber = null;
            $scope.vm.PestType = null;
            $scope.vm.ContactPerson = null;
            $scope.vm.CustomerName = null;
            $scope.vm.ServiceStartDate = null;
            $scope.vm.ServiceEndDate = null;
            $scope.vm.ContractStartDate = null;
            $scope.vm.ContractEndDate = null;
            $scope.vm.Frequency = null;
            $scope.vm.TotalSum = null;
            $scope.vm.PaymentTerms = null;
            $scope.vm.BillingFrequency = null;
            $scope.vm.Types = null;
            $scope.vm.EstimatedHoursRequired = null;
            $scope.vm.JobsPerFrequency = 1;
            $scope.vm.ServicesRequired = null;
            $scope.vm.TotalPrice = null;
            $scope.vm.CoverageArea = null;
            $scope.vm.DateTimeofTreatment = "";
            $scope.vm.TotalTripsPerYear = 0;
            $scope.vm.SpecialRemarks = null;
            $scope.vm.SpecialRemark = null;
            $scope.vm.BAddress = null;
            $scope.vm.BContactPerson = null;
            $scope.vm.BContactNo = null;
            $scope.vm.BEmail = []
            $scope.vm.SLocation = null;
            $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
            // $scope.vm.SContactNo = $scope.vm.SiteContact;
            $scope.vm.SName = $scope.vm.SiteName;
            if ($scope.vm.SEmail != null && $scope.vm.SEmail != undefined && $scope.vm.SEmail != "")
                $scope.vm.SiteEmail = $scope.vm.SEmail;
            else
                $scope.vm.SiteEmail = []

        }
        $scope.CreateWorkOrder = function (e) {
            $scope.Salesform = true
            $scope.Contractsform = false;
            $scope.Contractsgrid = false;
            $scope.Export = false;
            $scope.Pageform = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.ShowContractform = false;
            $scope.view = true
            ClearWOForm()
            // $scope.vm.uAddress = $scope.vm.CAddress
            $scope.vm.TrendingReport = "false";
            $scope.vm.Department = "Pest Off"
            $scope.vm.BAddress = $scope.vm.uAddress
            $scope.vm.SContactPerson = null
            $scope.Commentdatas = [];
            $scope.CommentArray = []
            $scope.Attachmentdatas = [];
            $scope.vm.OrderType = "Contract"
            $scope.vm.IsUrgent = "false";
            // $scope.vm.ContractNo = $scope.vm.ContractReferenceNo
            $scope.vm.OrderConfirmationDate = new Date()
            $scope.vm.CustomerName = $scope.vm.Customer_id
            if ($scope.vm.uEmail != null && $scope.vm.uEmail != undefined && $scope.vm.uEmail != "")
                $scope.vm.BEmail = $scope.vm.uEmail.split(',')
            else
                $scope.vm.BEmail = []
            $scope.vm.BContactPerson = $scope.vm.uContactPerson;
            if ($scope.vm.Ccontact != null && $scope.vm.Ccontact != undefined && $scope.vm.Ccontact != "")
                $scope.vm.BContactNo = $scope.vm.Ccontact.split(',').slice(0, 3)
            else
                $scope.vm.BContactNo = []
            $scope.WOFrequencydatas = $scope.MultiFrequencydatas
            $scope.vm.ServiceStartDate = new Date($scope.ServiceStartDate);
            $scope.vm.ServiceEndDate = new Date($scope.ServiceEndDate);
            angular.forEach($scope.WOFrequencydatas, function (item) {
                item.JobsPerFrequency = 1
                // $scope.calculateServices(item.Frequency, item.JobsPerFrequency)
                try {
                    $scope.vm.ServicesRequired = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1])
                    item.ServicesRequired = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1])
                } catch (error) {
                    $scope.vm.ServicesRequired = 0
                    item.ServicesRequired = 0
                }

            })
            if ($scope.WOFrequencydatas.length > 0) {
                var num = _.maxBy($scope.WOFrequencydatas, 'ServicesRequired');
                $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired)
            }

            $scope.vm.SLocation = $scope.vm.UpCAddress
            $scope.vm.BillingFrequency = $scope.Frequency;
            $scope.vm.CreditTerm = $scope.CreditTerm;
            $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
            if ($scope.vm.SiteContact != null && $scope.vm.SiteContact != undefined && $scope.vm.SiteContact != "")
                $scope.vm.SiteContact = $scope.vm.SiteContact.split(',')
            try {
                var litem = $scope.Leaddetails.filter(function (litem) {
                    return litem.CustomerID === $scope.vm.Customer_id
                })
                $scope.Leaddatas = litem
            } catch (error) { }

            if ($scope.vm.SLocation != null && $scope.vm.SLocation != "" && $scope.vm.SLocation != undefined) {

                $scope.DisableServiceLocation = true
                var response = $http({
                    url: $rootScope.WebURL + "/customerService/getByIDforService",
                    method: "POST",
                    data: { RequestID: $scope.CustID },
                });
                response.then(function (CustomerServicedata) {
                    $scope.CustomerServiceAddress = CustomerServicedata.data.data;
                });
            }
            else
                $scope.DisableServiceLocation = false
            try {
                var item = $scope.Leaddatas.filter(function (item) {
                    return item.LeadReferenceNo === $scope.vm.EnquiryID
                })[0]

                $scope.vm.EnquiryReferenceNo = item.LeadReferenceNo
                if ($scope.vm.CTotalOrderValue == null || $scope.vm.CTotalOrderValue == undefined || $scope.vm.CTotalOrderValue == '')
                    $scope.vm.TotalPrice = parseFloat(item.Pipelinevalue)
                else
                    $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue)
            } catch (error) {
                $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue)
                $scope.vm.EnquiryReferenceNo = null
            }

            if (item == undefined) {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesOrder",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (marketsegmentdata) {
                    var info = marketsegmentdata.data.data;
                    var y = "";
                    for (var x = 1001; x <= 1001 + info.length; x++) {
                        y = 'EQ/RN/' + x;
                    }
                    $scope.vm.EnquiryReferenceNo = y;
                });
            }
            $scope.vm.keys1 = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
        }

        $scope.calculateServices = function (freq, job) {
            try {
                $scope.vm.ServicesRequired = parseInt(freq.match(/\(([^)]+)\)/)[1])
            } catch (error) {
                $scope.vm.ServicesRequired = 0
            }
        }


        function CustomerBillingdatadetails(Requestid) {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforBilling",
                method: "POST",
                data: { RequestID: Requestid },
            });
            response.then(function (CustomerBillingdata) {
                $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
                // var CustomerBillingdatas = CustomerBillingdata.data.data;
                // if (CustomerBillingdatas.length > 0) {
                //     $scope.vm.BAddress = CustomerBillingdatas[0].bStreetName;
                // $scope.vm.SContactPerson = CustomerBillingdatas[0].bContactPerson;
                // $scope.vm.SContactNo = CustomerBillingdatas[0].bMobile;
                //    $scope.vm.BEmail = CustomerBillingdatas[0].sEmail;
                // }
            });
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: Requestid },
            });
            response.then(function (CustomerServicedata) {
                var CustomerServicedatas = CustomerServicedata.data.data;
                $scope.CustomerServiceAddress = CustomerServicedata.data.data;
                if (CustomerServicedatas.length > 0) {
                    // $scope.vm.SLocation = CustomerServicedatas[0].sStreetName;
                    $scope.vm.SContactPerson = CustomerServicedatas[0].sContactPerson;
                    $scope.vm.SContactNo = CustomerServicedatas[0].sMobile;
                    $scope.vm.SName = CustomerServicedatas[0].sName;
                }
            });
        }

        $scope.AddWOPestType = function (e) {
            $scope.ShowPestAdd = false;
            $scope.vm.SelectFreq = null;
            $scope.vm.Frequency = null;
            $scope.PestTreatmentdatas = [];
            $scope.Pesttypearray = null;
            $scope.vm.SelectPest = null;
            $scope.vm.Scopeofwork = null;
            $scope.vm.ServicesRequired = null;
            $scope.vm.JobsPerFrequency = 1;
            $scope.WOTreatmentpopupdata = [];
            $scope.EditFrequency = false;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/AddTreatmentFrequency.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            RefreshTreatment();
        }
        $scope.Editpest = function (e, Pestdata) {
            $scope.PestUpdate = true;
            $scope.vm.Frequency = Pestdata.Frequency;
            $scope.vm.JobsPerFrequency = Pestdata.JobsPerFrequency;
            $scope.vm.ServicesRequired = Pestdata.ServicesRequired;
            $scope.vm.PestType = Pestdata.PestType;
            //   $scope.vm.SelectPest =  Pestdata.PestType;
            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                var array = $scope.vm.PestType.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                    array1.push({ PestName: value });
                });
                $scope.vm.PestType = array1;
            }
            $scope.vm.SelectPest = $scope.vm.PestType
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/AddTreatmentFrequency.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.Pestdata = Pestdata;
            if ($scope.PestUpdate == true) {
                $scope.vm.JobsPerFrequency = $scope.vm.JobsPerFrequency || 1
                // $scope.calculateServices($scope.vm.Frequency, $scope.vm.JobsPerFrequency)
                try {
                    item.ServicesRequired = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1])
                } catch (error) {
                    item.ServicesRequired = 0
                }
            }
        }

        $scope.ForAlternateWeek = function (freq) {
            if (freq == "Alternate Week (52)" || freq === "Alternate Twice a Week (104)") {
                var item = $scope.Pestdatas.filter(function (item) {
                    return item.PestName === 'Adult Mosquito'
                })
                $scope.Pestdatasdatas = item
            }
            else
                $scope.Pestdatasdatas = $scope.Pestdatas
        }
        $scope.CheckTreatment = function () {
            debugger
            if ($scope.vm.Frequency === "Alternate Week (52)") {
                $mdToast.show($mdToast.simple().textContent('Please select only 2 Treatment for Alternate Week frequency!').position('center'));
            }
            if ($scope.vm.Frequency === "Alternate Twice a Week (104)") {
                $mdToast.show($mdToast.simple().textContent('Please select only 2 Treatment for Alternate Twice a Week frequency!').position('center'));
            }
        }

        $scope.ChangeWOTreatment = function (Pestdata) {
            $scope.WOTreatmentpopupdata = [];
            if ($scope.EditFrequency == false) {
                if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
                    $scope.Pesttypearray = [];
                    angular.forEach(Pestdata, function (value) {
                        var Pestname = value.PestName;
                        var array = [];
                        var item1 = $scope.Treatmentdatas.filter(function (item1) {
                            if (item1.PestType.indexOf(Pestname) > -1) {
                                if (item1.TreatmentName != "Service Light Traps")
                                    array.push({ TreatmentName: item1.TreatmentName });
                            }
                        });
                        $scope.WOTreatmentpopupdata.push({ PestName: Pestname, Treatment: array });
                    })
                }
            } else {

                var array = [];
                var item1 = $scope.Treatmentdatas.filter(function (item1) {
                    if (item1.PestType.indexOf(Pestdata.PestType) > -1) {
                        var selectedtreatment = Pestdata.Treatment.split(', ');
                        if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
                            item1.selected = true;
                        }
                        array.push({ TreatmentName: item1.TreatmentName, selected: item1.selected });

                    }
                    return item1.PestType.indexOf(Pestdata.PestType) > -1;
                });
                if (Pestdata.Others !== undefined) { var OthersSelect = true; } else { var OthersSelect = false; }
                if (Pestdata.ServiceTrap !== undefined) { var ServiceTypeSelect = true; } else { var ServiceTypeSelect = false; }
                array.map(function (o, k) { if (o.TreatmentName === "Service Light Traps") if (k != undefined) array.splice(k) })
                $scope.WOTreatmentpopupdata.push({ PestName: Pestdata.PestType, Treatment: array, Others: Pestdata.Others, selectothers: OthersSelect, ServiceTrap: Pestdata.ServiceTrap, ServiceTypeSelect: ServiceTypeSelect });
                if ($scope.WOFrequencydatas.length > 0) {
                    $scope.Pesttypearray = [];
                    $scope.WOTreatmentpopupdata = []
                    angular.forEach(Pestdata, function (pestdata) {
                        angular.forEach($scope.WOFrequencydatas, function (value) {
                            if (pestdata.PestName == value.PestType) {
                                var Pestname = pestdata.PestName;
                                var array = [];
                                var selectothers = false;
                                var Others = ''
                                var ServiceTrap = ''
                                var SelectServiceTrap = false
                                var item1 = $scope.Treatmentdatas.filter(function (item1) {
                                    if (item1.PestType.indexOf(Pestname) > -1) {
                                        item1.selected = false;

                                        if (value.Treatment != undefined) {
                                            var selectedtreatment = value.Treatment.split(', ');
                                            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
                                                item1.selected = true;
                                            }
                                            else item1.selected = false;
                                        }
                                        array.push({ TreatmentName: item1.TreatmentName, selected: item1.selected });
                                    }
                                    if (value.Others != undefined) {
                                        selectothers = true;
                                        Others = value.Others
                                    }
                                    if (value.ServiceTrap != undefined) {
                                        SelectServiceTrap = true;
                                        ServiceTrap = value.ServiceTrap
                                    }
                                });
                                array.map(function (o, k) { if (o.TreatmentName === "Service Light Traps") if (k != undefined) array.splice(k) })
                                $scope.WOTreatmentpopupdata.push({ PestName: Pestname, Treatment: array, selectothers: selectothers, Others: Others, SelectServiceTrap: SelectServiceTrap, ServiceTrap: ServiceTrap });
                            }
                        })
                    })
                }
            }
        }
        $scope.switchValue = true;
        $scope.IsUrgent = {
            onText: "YES",
            offText: "NO",
            bindingOptions: {
                value: "switchValue"
            }
        };
        $scope.SubmitWOPest = function () {
            var Scopeofwork = "";
            var array = [];
            angular.forEach($scope.WOTreatmentpopupdata, function (item) {
                var item1 = item.Treatment.filter(function (item1) {
                    return item1.selected == true
                });
                var Treatmentarray = null;
                var OthersTreatment = item.Others;
                var ServiceTrap = item.ServiceTrap
                if (item.selectothers == false) { OthersTreatment = undefined; }
                if (item.SelectServiceTrap == false) { ServiceTrap = undefined; }

                if (item1 !== undefined) {
                    Treatmentarray = item1.map(function (obj) { return obj.TreatmentName; }).join(', ');
                }
                if (OthersTreatment != undefined && Treatmentarray != "") {
                    if (Treatmentarray != null) {
                        Treatmentarray = Treatmentarray + ', ' + OthersTreatment
                    }
                    else Treatmentarray = OthersTreatment
                }
                array = $scope.WOFrequencydatas.filter(function (item2) {
                    return item2.PestType == item.PestName && item2.Frequency == $scope.vm.Frequency;
                });
                if (ServiceTrap != undefined) {
                    if (Treatmentarray != "" && Treatmentarray != null)
                        Treatmentarray = Treatmentarray + ", Service Light Traps"
                    else
                        Treatmentarray = "Service Light Traps"
                }

                $scope.EditFrequency = true
                if (array.length == 0) {
                    $scope.WOFrequencydatas.push({
                        Frequency: $scope.vm.Frequency,
                        PestType: item.PestName,
                        Treatment: Treatmentarray,
                        JobsPerFrequency: $scope.vm.JobsPerFrequency,
                        ServicesRequired: $scope.vm.ServicesRequired,
                        Others: OthersTreatment,
                        ServiceTrap: ServiceTrap
                    });
                } else if ($scope.EditFrequency == true) {
                    $scope.WOFrequencydatas[$scope.WOFrequencydatas.indexOf(array[0])].Treatment = Treatmentarray;
                    $scope.WOFrequencydatas[$scope.WOFrequencydatas.indexOf(array[0])].Others = OthersTreatment;
                    $scope.WOFrequencydatas[$scope.WOFrequencydatas.indexOf(array[0])].JobsPerFrequency = $scope.vm.JobsPerFrequency;
                    $scope.WOFrequencydatas[$scope.WOFrequencydatas.indexOf(array[0])].ServicesRequired = $scope.vm.ServicesRequired;
                    $scope.WOFrequencydatas[$scope.WOFrequencydatas.indexOf(array[0])].ServiceTrap = ServiceTrap;
                    $scope.EditFrequency == false
                } else {
                    $mdToast.show($mdToast.simple().textContent('Existing Data!').position('top center'));
                }
            });
            if ($scope.WOFrequencydatas.length > 0) {
                var num = _.maxBy($scope.WOFrequencydatas, 'ServicesRequired');
                $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired)
            }
            $mdDialog.hide();
        }
        $scope.WOSubmit = function () {

            $scope.groupFrequency = _.groupBy($scope.WOFrequencydatas, 'Frequency');
            var salesOrderArray = []
            angular.forEach($scope.WOFrequencydatas, function (value) {
                if (value.JobsPerFrequency == null && value.JobsPerFrequency == undefined && value.ServicesRequired == null && value.ServicesRequired == undefined) {
                    salesOrderArray.push(1)
                }
            })
            if (salesOrderArray.length > 0) return $mdToast.show($mdToast.simple().textContent('Please Add Jobs Per Frequency and Services Required for Treatment Frequency!').position('top center'));

            $scope.vm.PaymentMode = $scope.vm.PaymentMode


            if ($scope.Frequencydatas != null && $scope.Frequencydatas != "" && $scope.Frequencydatas != undefined) {
                $scope.vm.Frequency = $scope.Frequencydatas.map(function (obj) { return obj.Frequency; }).join(',');
                $scope.vm.PestType = $scope.Frequencydatas.map(function (obj) { return obj.PestType; }).join(',');
                $scope.vm.Treatment = $scope.Frequencydatas.map(function (obj) { return obj.Treatment; }).join(',');
                $scope.vm.JobsPerFrequency = $scope.Frequencydatas.map(function (obj) { return obj.JobsPerFrequency; }).join(',');
                $scope.vm.ServicesRequired = $scope.Frequencydatas.map(function (obj) { return obj.ServicesRequired; }).join(',');
            }
            if ($scope.vm.BEmail != null && $scope.vm.BEmail != "" && $scope.vm.BEmail != undefined) {
                $scope.vm.BEmail = $scope.vm.BEmail.map(function (obj) { return obj; }).join(',');
            }
            if ($scope.vm.SEmail != null && $scope.vm.SEmail != "" && $scope.vm.SEmail != undefined) {
                $scope.vm.SEmail = $scope.vm.SEmail.map(function (obj) { return obj; }).join(',');
            }
            if ($scope.vm.BContactNo != null && $scope.vm.BContactNo != "" && $scope.vm.BContactNo != undefined) {
                $scope.vm.BContactNo = $scope.vm.BContactNo.map(function (obj) { return obj; }).join(',');
            }
            var salesOrderArray = []

            salesOrderArray.push({
                MultiFrequency: $scope.Frequencydatas,
                SalesPerson_id: $scope.vm.SalesPerson,
                ContractNo: $scope.vm.ContractNo,
                Customer_id: $scope.vm.Customer_ID,
                EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
                OrderConfirmationDate: $scope.vm.OrderConfirmationDate,
                ContactPerson: $scope.vm.uContactPerson,
                ServiceStartDate: $scope.vm.ServiceStartDate,
                ServiceEndDate: $scope.vm.ServiceEndDate,
                OrderType: $scope.vm.OrderType,
                TotalSum: $scope.vm.TotalSum,
                IsUrgent: $scope.vm.IsUrgent,
                PaymentMode: $scope.vm.PaymentMode,
                BillingFrequency: $scope.vm.BillingFrequency,
                EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
                CoverageArea: $scope.vm.CoverageArea,
                DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
                TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
                SpecialRemarks: $scope.vm.Message,
                CreatedBy: $rootScope.createdby,
                Client_Id: $rootScope.Client_Id,
                TotalPrice: $scope.vm.TotalPrice,
                PestType: $scope.vm.PestType,
                Frequency: $scope.vm.Frequency,
                Treatment: $scope.vm.Treatment,
                JobsPerFrequency: $scope.vm.JobsPerFrequency,
                TrendingReport: $scope.vm.TrendingReport,
                Department: $scope.vm.Department,
                ServicesRequired: $scope.vm.ServicesRequired,
                CustomerID: $scope.vm.SLocation,
                SiteContactNo: $scope.vm.SiteContact,
                Mobile: $scope.vm.BContactNo,
                Email: $scope.vm.BEmail,
                SiteContactPerson: $scope.vm.SiteContactPerson,
                SiteEmail: $scope.vm.SEmail,
                SiteName: $scope.vm.SiteName,
                SiteContact: $scope.vm.SiteContact,
                SpecialChemical: $scope.vm.SpecialChemical,
                PreferredTime: $scope.vm.PreferredTime,
                Message: $scope.vm.Message,
                CommentArray: $scope.CommentArray,
                UniqID: UniqID
            })
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/addbyArray",
                data: { salesOrderArray: salesOrderArray },
            });
            response.then(function (List) {
                var Id = List.data.data.id

                RefreshGrid()
                $scope.CommentArray = []
                $scope.Commentdata = []
                $scope.Attachmentdatas = []
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Work Order Successfully Added!').position('top center'));
                $scope.Contractsgrid = true;
                $scope.Contractsform = false;
                $scope.Salesform = false
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
            });
        }

        $scope.DeleteComment = function (data) {

            $scope.delComId = data.key
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    _.remove($scope.Commentdatas, function (o) {
                        return o.key === $scope.delComId;
                    });
                    $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
                }
            })

        }


        $scope.SORDerails = function (tick, e, check) {
            $scope.Disablesubmit = false
            if (tick == true) {
                $mdDialog.show({
                    multiple: true,
                    templateUrl: 'app/main/apps/crm/contracts/AddSor.html',
                    parent: angular.element($document.body),
                    targetEvent: e,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    controller: function contractsController($scope, $mdDialog) {
                        $scope.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                });
                var updating = false
                $scope.dataGridOptions = {
                    dataSource: $scope.Sordatas,
                    keyExpr: "_id",
                    showBorders: true,
                    paging: {
                        enabled: false
                    },

                    editing: {
                        mode: "batch",
                        allowUpdating: true,
                        allowDeleting: true,
                        allowAdding: true,
                        useIcons: true
                    },
                    onRowUpdating: function (e) {
                        updating = true;

                    },
                    onRowRemoving: function (e) {
                        updating = true;
                    },
                    onRowInserting: function (e) {
                        updating = true;

                    },
                    onContentReady: function (e) {
                        if (e.component.hasEditData()) {
                            $scope.Disablesubmit = true
                        }
                        else
                            $scope.Disablesubmit = false
                    },
                    columns: [
                        {
                            caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                                cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                            }
                        },
                        {
                            dataField: "Description",
                            caption: "Description",
                            width: "30%"
                        },
                        {
                            dataField: "Unit",
                            width: "10%"
                        }, {
                            dataField: "RateDuringOfficeHour",
                            caption: "Rate ($) During Office Hour",
                            width: "15%"
                        },
                        {
                            dataField: "RateAfterOfficeHour",
                            caption: "Rate ($) After Office Hour",
                            width: "15%"
                        },
                    ]
                };
            }
            if (check == false) $scope.ShowSubmit = false
            else $scope.ShowSubmit = true
        }

        $scope.SubmitSOR = function () {
            $scope.dataSource = $('#gridContainer').dxDataGrid('instance').option('dataSource')
            if ($scope.dataSource.length == 0)
                $mdToast.show($mdToast.simple().textContent('Please Fill SOR details or Click Cancel button !').position('top center'));
            else
                $scope.cancel()
        }
        function RefreshComments(ID) {
            var response = $http({
                url: $rootScope.WebURL + "/schedulercomment/getByContractID",
                method: "POST",
                data: { RequestID: ID },
            });
            response.then(function (Commentdata) {

                $scope.Commentdatas = Commentdata.data.data;
                angular.forEach($scope.Commentdatas, function (item) {
                    item.CreatedDate = new Date(item.CreatedDate)
                })
                $scope.Commentdatas.reverse()

            });
        }
        $scope.CommentArray = []
        $scope.AddComment = function () {
            //     if($scope.Update==true){
            // var response = $http({
            //   method: "POST",
            //   url:  $rootScope.WebURL + "/comment/add",
            //   data: {
            //     TableRowID: $scope.SID,
            //     TableName: "SalesOrder",
            //     CommentedBy: $rootScope.createdby,
            //     cmt: $scope.vm.SpecialRemarks,
            //     ModuleID: $scope.vm.ModuleID,
            //     CreatedBy: $rootScope.createdby,
            //     IsActive: "true",
            //   },
            // });
            // response.then(function (GList) {
            //     $scope.vm.SpecialRemarks = '';
            //     RefreshComments($scope.SID)
            // }, function () {
            //   $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            // });
            // }
            // else
            // {
            if ($scope.vm.SpecialRemarks != "" && $scope.vm.SpecialRemarks != null) {
                $scope.SpecialRem = $scope.vm.SpecialRemarks
                $scope.CommentArray.push({
                    key: $scope.CommentArray.length + 1,
                    cmt: $scope.vm.SpecialRemarks,
                    CommentedBy: $rootScope.createdby,
                    CreatedDate: new Date()
                })
                $scope.Commentdatas = $scope.CommentArray
                $scope.vm.SpecialRemarks = null;
            }
        }
        //   }


        $scope.closepest = function () {
            $mdDialog.hide();
            $scope.Pestdata = null;
        }
        $scope.Deletepest = function (DeleteItem) {
            var index = $scope.WOFrequencydatas.indexOf(DeleteItem);
            $scope.WOFrequencydatas.splice(index, 1);
            RefreshSchedulerFrequency();
        }
        function RefreshSchedulerFrequency() {
            $http({
                url: $rootScope.WebURL + "/settings",
                method: "POST",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (settingsdata) {
                $scope.Settingsdatas = settingsdata.data.data;
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'ScheduleFrequency';
                    });
                    $scope.ScheduleFrequencydatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'PaymentMode';
                    });
                    $scope.PaymentModedatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'BillingFrequency';
                    });
                    $scope.BillingFrequencydatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'PaymentTerm';
                    });
                    $scope.PaymentTermdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'JobTypes';
                    });
                    $scope.JobTypesdatas = item;
                }
                catch (e) { }
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'BuildingType';
                    });
                    $scope.BuildingTypedatas = item;
                } catch (e) { }

                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'CreditTerm';
                    });
                    $scope.CreditTermdatas = item;
                } catch (e) { }
            });
        }
        function getSorDetails(Contract) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/sor/getByContract",
                data: { Client_Id: $rootScope.Client_Id, Contract: Contract },
            }).then(function (Sortabledata) {
                if (Sortabledata.data.data.length > 0)
                    $scope.Sordatas = Sortabledata.data.data;
            })
        }

        function getSor() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/sor/get",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Sortabledata) {
                $scope.Sordatas = Sortabledata.data.data;
            })
        }

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/lead",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (leaddata) {
            $scope.Leaddetails = leaddata.data.data;
        });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee/getSalesPerson",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
        })

        $scope.ClickTemplate = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contracts/PreviewTemplate.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function contractsController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            var Start = moment()._locale._months[moment($scope.vm.ServiceStartDate).month()] + " " + moment($scope.vm.ServiceStartDate).year()
            var End = moment()._locale._months[moment($scope.vm.ServiceEndDate).month()] + " " + moment($scope.vm.ServiceEndDate).year()
            if ($scope.vm.TotalMonth == undefined && $scope.vm.ServiceStartDate != "" && $scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != undefined && $scope.vm.ServiceEndDate != "" && $scope.vm.ServiceEndDate != null
                && $scope.vm.ServiceEndDate != undefined)
                $scope.getMonth($scope.vm.ServiceStartDate, $scope.vm.ServiceEndDate, null)
            var Month = $scope.vm.TotalMonth
            var Months = $scope.vm.TotalMonth
            var Frequency = $scope.vm.BillingFrequency
            var Amount = 0
            var freqbasis = ""
            if (Frequency == "COD") {
                freqbasis = " in Cash"
                Amount = parseFloat($scope.vm.TotalOrderValue) / 1
            }
            else if (Frequency == "Weekly") {
                freqbasis = " per week"
                var start = moment(new Date($scope.vm.ServiceStartDate))
                var end = moment(new Date($scope.vm.ServiceEndDate))
                var weeks = end.diff(start, "week")
                Amount = parseFloat($scope.vm.TotalOrderValue) / weeks
            }
            else if (Frequency == "Monthly") {
                freqbasis = " per month"
                Amount = parseFloat($scope.vm.TotalOrderValue) / Month
            }
            else if (Frequency == "Quarterly") {
                freqbasis = " quarterly"
                var Month = parseInt(Month / 3)
                Amount = parseFloat($scope.vm.TotalOrderValue) / Month
            }
            else if (Frequency == "Bi-Monthly (6)") {
                freqbasis = " bi-monthly"
                Frequency = "Bi-Monthly"
                var Month = parseInt(Month / 2)
                Amount = parseFloat($scope.vm.TotalOrderValue) / Month
            }
            else if (Frequency == "Half Yearly (2)") {
                freqbasis = " half yearly"
                Frequency = "Half Yearly"
                var Month = parseInt(Month / 6)
                Amount = parseFloat($scope.vm.TotalOrderValue) / Month
            }
            else if (Frequency == "Yearly") {
                freqbasis = " per year"
                var Month = parseInt(Month / 12)
                Amount = parseFloat($scope.vm.TotalOrderValue) / Month

            }

            if (Month != 0 && Month != 1) Months = Months + " months"; else Months = Month + " month";

            if (Amount % 1 < 1 && Amount % 1 != 0) {
                Amount = Amount.toFixed(2)
            }
            var amtt = Amount
            amtt = parseFloat(amtt) * 7 / 100 + parseFloat(amtt)
            var amt = parseFloat(amtt)
            var amout = amt
            if (amt % 1 < 1 && amt % 1 != 0) {
                amt = amt.toFixed(2)
            }

            var amountt = amout.toFixed(2)

            if ($scope.vm.ServiceHours == "During Office Hours")
                var OfficeHours = "During Office Hours 9am - 5pm"
            else if ($scope.vm.ServiceHours == "After Office Hours")
                var OfficeHours = "After Office Hours 5pm - 12:00mn"
            else if ($scope.vm.ServiceHours == "Wee Hours")
                var OfficeHours = "During Wee Hours 12:00mn - 9am"

            vm.Header = "<p align='justify'>This Contract will hereby commence at the above service location from <u><b>" + Start + "</b></u> to <u><b>" + End + "</b></u> and to hold unto The Client for a period of <u><b>" + Months + "</b></u>. The Client agrees to pay for the scope of work on a <u><b>" + Frequency + "</b></u> basis, a sum of Singapore Dollars <u><b>" + toWords(amt) + " S$ " + amountt + " (inclusive of GST)</b></u> " + freqbasis + ". Payable to <b>Pest Off Pte Ltd</b> within " + $scope.vm.CreditTerm + " of invoice. Additional services will be charged separately.</p>"
            vm.Header1 = "<p align='justify'>Refer to the 'Scope of Work' as stated below will be carried out <b>" + OfficeHours + "</b>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range. </p>"
            vm.Header2 = "<div><h4><b>ACCESS TO PREMISES</b></h4></div><div><p align='justify'>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p></div><div><h4><b>LIABILITY</b></h4></div><div><p align='justify'>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div></p></div><div><h4><b>TERMINATION OF CONTRACT</b></h4></div><div><p align='justify'>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Month notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>"

        }

        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        var th = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        var dg = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        var tn = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        var tw = ['Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        function toWords(s) {
            s = s.toString();
            s = s.replace(/[\, ]/g, '');
            if (s != parseFloat(s)) return 'not a number';
            var x = s.indexOf('.');
            if (x == -1) x = s.length;
            if (x > 15) return 'too big';
            var n = s.split('');
            var str = '';
            var sk = 0;
            for (var i = 0; i < x; i++) {
                if ((x - i) % 3 == 2) {
                    if (n[i] == '1') {
                        str += tn[Number(n[i + 1])] + ' ';
                        i++;
                        sk = 1;
                    } else if (n[i] != 0) {
                        str += tw[n[i] - 2] + ' ';
                        sk = 1;
                    }
                } else if (n[i] != 0) {
                    str += dg[n[i]] + ' ';
                    if ((x - i) % 3 == 0) str += 'Hundred ';
                    sk = 1;
                }
                if ((x - i) % 3 == 1) {
                    if (sk) str += th[(x - i - 1) / 3] + ' ';
                    sk = 0;
                }
            }
            //    if (x != s.length) {
            //        var y = s.length;
            //        str += 'and ';
            //        for (var i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
            //        str += 'cents '
            //    }
            if (x != s.length) {
                if (str != "")
                    str += 'and ';
                if (Number(s.charAt(x + 1)) > 1) {
                    if (Number(s.charAt(x + 1)) > 1) {
                        str += tw[Number(s.charAt(x + 1)) - 2] + ' '
                    }
                    else if (Number(s.charAt(x + 1)) == 1 && Number(s.charAt(x + 2)) > 0) {
                        str += tn[Number(s.charAt(x + 2)) - 1] + ' '
                    }
                    else
                        str += tn[0] + ' '

                    if (Number(s.charAt(x + 2)) != 0)
                        str += dg[Number(s.charAt(x + 2))] + ' '
                }
                else if (Number(s.charAt(x + 1)) == 1 && Number(s.charAt(x + 2)) > 0) {
                    str += tn[Number(s.charAt(x + 2))] + ' '
                }
                else if (Number(s.charAt(x + 1)) == 0) {
                    str += dg[Number(s.charAt(x + 2))] + ' '
                }
                else
                    str += tn[0] + ' '
                str += 'Cents '
            }
            str += 'Only'
            return str.replace(/\s+/g, ' ');
        }

        $scope.getMonth = function (StartDate, EndDate, Frequency) {
            if (StartDate != "" && StartDate != null && StartDate != undefined && EndDate != "" && EndDate != null && EndDate != undefined) {
                EndDate = moment(EndDate).add(1, 'days')
                var a = moment(StartDate)
                var b = EndDate
                var Month = b.diff(a, 'month')
                $scope.vm.TotalMonth = Month
            }
            else
                $scope.vm.TotalMonth = 0
        }

        $scope.getServiceEndDate = function (StartDate) {
            if (StartDate != null && StartDate != undefined && StartDate != "") {
                var StartDate = new Date(StartDate)
                $scope.vm.ServiceEndDate = moment(StartDate).add(1, 'year')
                $scope.vm.ServiceEndDate = new Date($scope.vm.ServiceEndDate.add(-1, 'days'))
            }
        }

        $scope.getMonthAmount = function (Month, value) {
            if (Month != "" && Month != null && Month != undefined && value != "" && value != null && value != undefined) {
                $scope.vm.AmountperMonth = Month == 0 ? parseFloat(value) / 1 : parseFloat(value) / Month
            }
            else
                $scope.vm.AmountperMonth = 0
        }

        // clear date filter

        $scope.ClearFilter = function () {
            $scope.uTo = null
            $scope.uFrom = null
            RefreshGrid()
        }

        function monthDiff(d1, d2) {
            var months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            return months <= 0 ? 0 : months;
        }
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
    }
})();
angular.module('apps.crm.contracts').config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.firstDayOfWeek = 1;
});
(function ()
{
    'use strict';

    angular
        .module('apps.crm.contractquotation', ['wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.contractquotation', {
            url: '/ContractQuotation',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/crm/contractquotation/contractquotation.html',
                    controller: 'contractquotationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
    }
  
})();
(function () {
    'use strict';
    angular
        .module('apps.crm.contractquotation')
        .controller('contractquotationController', contractquotationController)
        .filter("htmlToPlaintext", function () {
            return function (input) {
                return input.replace(/<[^>]+>/gm, '');
            }
        });
    function contractquotationController($scope, $rootScope, $interval, $mdSidenav, $mdToast, $http, $window, $mdDialog, $location, $state, $document) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Contracts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $scope.Quotationform = false;
        $scope.Quotationgrid = true;
        $scope.Export = true;
        $scope.Pageform = false;
        $scope.Add = true;
        $scope.Search = true;
        $scope.Previewdiv = false;

        RefreshFrequencyGrid();
        function RefreshFrequencyGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/settings",
                data: { Client_Id: $rootScope.Client_Id },
            });
            response.then(function (settingsdata) {
                $scope.Settingsdatas = settingsdata.data.data;
                try {
                    var item = $scope.Settingsdatas.filter(function (item) {
                        return item.Description === 'ScheduleFrequency';
                    });
                    $scope.ScheduleFrequencydatas = item;
                }
                catch (e) { }
            });
        }


        var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
        var pass = "";
        for (var x = 0; x < 8; x++) {
            var i = Math.floor(Math.random() * chars.length);
            pass += chars.charAt(i);
        }
        $scope.cloneTableTempID = pass
        $scope.TemplateID = pass

        var PQdatas = JSON.parse(localStorage.getItem('PQfromContract'));
        if (PQdatas != null && PQdatas != "" && PQdatas != undefined && PQdatas != "null") {
            $scope.AllPestType = PQdatas.AllPestType;
            $scope.ContractquotationReference = PQdatas.ContractquotationReference;
            $scope.ContractID = PQdatas.contractId;
            $scope.ContractReferenceNo = PQdatas.ContractReferenceNo;
            $scope.NatureofJob = PQdatas.PestType;
            $scope.SalesPerson = PQdatas.SalesPerson;
            $scope.Frequency = PQdatas.Frequency;
            $scope.ContractDuration = PQdatas.ContractDuration;
            $scope.ContactPerson = PQdatas.ContactPerson;
            $scope.ContractStartDate = PQdatas.ContractStartDate;
            $scope.ContractEndDate = PQdatas.ContractEndDate;
            $scope.ServiceEndDate = PQdatas.ServiceEndDate;
            $scope.ServiceStartDate = PQdatas.ServiceStartDate;
            $scope.CustomerName = PQdatas.CustomerName;
            $scope.Customer_id = PQdatas.Customer_id
            $scope.CustomerID = PQdatas.CustomerID;
            $scope.ContractNotes = PQdatas.ContractNotes;
            $scope.SalesOrderID = PQdatas.SalesOrderID;
            $scope.ContractStatus = PQdatas.ContractStatus;
            $scope.Status = PQdatas.Status;
            $scope.CurrentStatusID = PQdatas.StatusID;
            $scope.CurrentStatus = PQdatas.cNextActioned
            $scope.cNextID = PQdatas.cNextActionedID
            $scope.NexttoNextId = PQdatas.NexttoNextId;
            $scope.TemplateID = PQdatas.TemplateID;
            $scope.TermsCondition = PQdatas.TermsCondition;
            $scope.Footer = PQdatas.Footer;
            $scope.Header = PQdatas.Header;
            $scope.Subject = PQdatas.Subject;
            $scope.TableTitle = PQdatas.TableTitle;
            $scope.TemplateID = PQdatas.TemplateID;
            $scope.QuotationUpdate = PQdatas.QuotationUpdate
            $scope._id = PQdatas._id;

            var getresponse = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation/GetById",
                data: { ContractID: $scope.ContractID },
            });
            getresponse.then(function (gContractquotationdata) {

                $scope.gContractquotationdatas = gContractquotationdata.data.data;
                if ($scope.gContractquotationdatas.length > 0) {
                    angular.forEach($scope.gContractquotationdatas, function (value) {
                        if (value.TableContractID1 == $scope.ContractID) {
                            var deleteID = value.id;
                            var response = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/contractquotation/delete",
                                data: {
                                    _id: deleteID,
                                },
                            });
                        }
                    });
                }
                angular.forEach($scope.AllPestType, function (pvalue) {
                    if (pvalue.PestType != null) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle1: pvalue.TableTitle1,
                                TableContractID1: $scope.ContractID,
                                TableTempID1: $scope.cloneTableTempID,
                                T1PestType: pvalue.PestType,
                                T1ScopeofWork: pvalue.T1ScopeofWork,
                                T1Frequency: $scope.Frequency,
                                T1Pricing: pvalue.T1Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            // $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
            });
        }


        if ($scope.Header == null || $scope.Header == "" || $scope.Header == undefined) {
            $scope.Header = "<div><p>We are pleased to have been appointed to carry out pest control services at your premises mentioned above with effect form                     on the following terms and conditions.</p></div><blockquote><div><p>1. T​hat will effect from              we shall take full responsibility for providing effective pest control services at the above mentioned premises.</p><p></p><p>2. To ensure that all pest management work is carried out in accordance with industry codes of practice and regulations and with due attention to consumers, employees and the environment.</p><p>3. The employer shall make freely available access all parts of the said premises during the time and for the purposes of any inspection or treatment by the Contractor. These do not include areas which are obstructed or inaccessible. This contract does not cover repairs/replacements as a result of the activities of the said pests.</p><p>4. The Contractor undertakes to make their best endeavor to the said pests. However, they cannot guarantee their control, as whereby it might be brought in by any presents(s) furniture or bad housekeeping maintenance etc.</p><p>5. <b>A sum of SGD $          (Dollars:                ) </b>shall be payable to us for each calendar year of service provided to you.</p><p>6. Payment shall be made on completion of each month of services.</p><p>7. Any party if so desire may terminate this agreement by giving us one month notice of such desire in writing.</p><p>8. In the event of NEA dengue outbreak we will increase the misting to weekly service till outbreak closes.</p></div></blockquote><div><p><span style=\"font-size: 16px;\"></span></p></div>";
        }
        if ($scope.Footer11 == null || $scope.Footer == "" || $scope.Footer == undefined) {
            $scope.Footer11 = '<p>We trust that the above preparequotation and work proposal meet your  requirements but should you wish for a review, please do not hesitate to contact me. We hope to receive your favorable reply, soon.<br><br>Should you have any clarifications, please do not hesitate to contact me.<br><br>Thank you.</p>';
        }
        if ($scope.TermsCondition11 == null || $scope.TermsCondition == "" || $scope.TermsCondition == undefined) {
        }
        if ($scope.Scopeofwork == null || $scope.Scopeofwork == undefined || $scope.Scopeofwork == "") {
            $scope.Scopeofwork = '<p><b>Inspections</b> - We believe every property is different, our experts would do a systematic check and this<br/>would develop into a treatment plan to cater to your exact needs.</p><p><br/><b>Treatment</b> - Our technical experts would first employ mechanical control measures and to advise on<br/>prevention methods. As a last measure, we would use only NEA certified and approve pesticides which are<br/>low in toxicity to humans but packs a punch to the targeted pest.<br/><br/></p>';
        }
        $scope.IncludeSOR = false;
        $scope.TermsCondition11 = '<h3><b>GST:- Prices quoted are subject to prevailing GST rate.</b></h3><p>*Price does not include installation.</p>'
        if ($scope.ExpectedResponseDate != null) {
            if ($scope.ExpectedResponseDate.setHours(0, 0, 0, 0) == new Date("01/01/1970").setHours(0, 0, 0, 0)) {
                $scope.ExpectedResponseDate = null;
            }
        }
        function init() {
            try {
                var item = $scope.Preparedcontractdatas.filter(function (item) {
                    return item.ContractID === $scope.ContractID;
                });
                item = item[item.length - 1];
                if (item != undefined && item != null && item != "") {
                    $scope.Revision = item.Revision;
                    $scope._id = item.id;
                }
            }
            catch (e) { }
            try {
                var item1 = $scope.Contractquotationdatas.filter(function (item1) {
                    return item1.TableContractID2 === $scope.ContractID;
                })[0];
                if (item1.Header != null && item1.Header != "" && item1.Header != undefined) {
                    $scope.Header = item1.Header;
                }
                if (item1.Footer != null && item1.Footer != "" && item1.Footer != undefined) {
                    $scope.Footer = item1.Footer;
                }
                if (item1.TermsCondition != null && item1.TermsCondition != "" && item1.TermsCondition != undefined) {
                    $scope.TermsCondition = item1.TermsCondition;
                }
                if (item1.Subject != null && item1.Subject != "" && item1.Subject != undefined) {
                    $scope.Subject = item1.Subject;
                }
                $scope.Inserted = item1.Inserted;
                $scope.Inserted_Id = item1.id;
            }
            catch (e) { }
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
        };


        $scope.Title1Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle1: $scope.vm.TableTitle1,
                        TableContractID1: $scope.ContractID,
                        TableTempID1: $scope.TemplateID,
                        T1PestType: $scope.vm.T1PestType,
                        T1ScopeofWork: $scope.vm.T1ScopeofWork,
                        T1Frequency: $scope.vm.T1Frequency,
                        T1Pricing: $scope.vm.T1Pricing,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle1: $scope.vm.TableTitle1,
                        TableContractID1: $scope.ContractID,
                        TableTempID1: $scope.TemplateID,
                        T1PestType: $scope.vm.T1PestType,
                        T1ScopeofWork: $scope.vm.T1ScopeofWork,
                        T1Frequency: $scope.vm.T1Frequency,
                        T1Pricing: $scope.vm.T1Pricing,
                        Client_Id: $rootScope.Client_Id,

                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title2Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle2: $scope.vm.TableTitle2,
                        TableContractID2: $scope.ContractID,
                        TableTempID2: $scope.TemplateID,
                        T2PestType: $scope.vm.T2PestType,
                        T2Timing: $scope.vm.T2Timing,
                        T2Quantity: $scope.vm.T2Quantity,
                        T2Frequency: $scope.vm.T2Frequency,
                        T2Pricing: $scope.vm.T2Pricing,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle2: $scope.vm.TableTitle2,
                        TableContractID2: $scope.ContractID,
                        TableTempID2: $scope.TemplateID,
                        T2PestType: $scope.vm.T2PestType,
                        T2Timing: $scope.vm.T2Timing,
                        T2Quantity: $scope.vm.T2Quantity,
                        T2Frequency: $scope.vm.T2Frequency,
                        T2Pricing: $scope.vm.T2Pricing,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title3Submit = function () {
            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle3: $scope.vm.TableTitle3,
                        TableContractID3: $scope.ContractID,
                        TableTempID3: $scope.TemplateID,
                        T3Area: $scope.vm.T3Area,
                        T3PestType: $scope.vm.T3PestType,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3Timing: $scope.vm.T3Timing,
                        T3Frequency: $scope.vm.T3Frequency,
                        T3Pricing: $scope.vm.T3Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle3: $scope.vm.TableTitle3,
                        TableContractID3: $scope.ContractID,
                        TableTempID3: $scope.TemplateID,
                        T3Area: $scope.vm.T3Area,
                        T3PestType: $scope.vm.T3PestType,
                        T3Quantity: $scope.vm.T3Quantity,
                        T3Timing: $scope.vm.T3Timing,
                        T3Frequency: $scope.vm.T3Frequency,
                        T3Pricing: $scope.vm.T3Pricing,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title4Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle4: $scope.vm.TableTitle4,
                        TableContractID4: $scope.ContractID,
                        TableTempID4: $scope.TemplateID,
                        T4Product: $scope.vm.T4Product,
                        T4NoOfPieces: $scope.vm.T4NoOfPieces,
                        T4Pricing: $scope.vm.T4Pricing,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle4: $scope.vm.TableTitle4,
                        TableContractID4: $scope.ContractID,
                        TableTempID4: $scope.TemplateID,
                        T4Product: $scope.vm.T4Product,
                        T4NoOfPieces: $scope.vm.T4NoOfPieces,
                        T4Pricing: $scope.vm.T4Pricing,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title5Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle5: $scope.vm.TableTitle5,
                        TableContractID5: $scope.ContractID,
                        TableTempID5: $scope.TemplateID,
                        T5Description: $scope.vm.T5Description,
                        T5Quantity: $scope.vm.T5Quantity,
                        T5Rate: $scope.vm.T5Rate,
                        T5Amount: $scope.vm.T5Amount,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle5: $scope.vm.TableTitle5,
                        TableContractID5: $scope.ContractID,
                        TableTempID5: $scope.TemplateID,
                        T5Description: $scope.vm.T5Description,
                        T5Quantity: $scope.vm.T5Quantity,
                        T5Rate: $scope.vm.T5Rate,
                        T5Amount: $scope.vm.T5Amount,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title6Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle6: $scope.vm.TableTitle6,
                        TableContractID6: $scope.ContractID,
                        TableTempID6: $scope.TemplateID,
                        T6Description: $scope.vm.T6Description,
                        T6Price: $scope.vm.T6Price,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle6: $scope.vm.TableTitle6,
                        TableContractID6: $scope.ContractID,
                        TableTempID6: $scope.TemplateID,
                        T6Description: $scope.vm.T6Description,
                        T6Price: $scope.vm.T6Price,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title7Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle7: $scope.vm.TableTitle7,
                        TableContractID7: $scope.ContractID,
                        TableTempID7: $scope.TemplateID,
                        T7SerialNo: $scope.vm.T7SerialNo,
                        T7ForModelNo: $scope.vm.T7ForModelNo,
                        T7LeasePerAnnum: $scope.vm.T7LeasePerAnnum,
                        T7EffectiveDate: $scope.vm.T7EffectiveDate,
                        T7ExpiryDate: $scope.vm.T7ExpiryDate,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle7: $scope.vm.TableTitle7,
                        TableContractID7: $scope.ContractID,
                        TableTempID7: $scope.TemplateID,
                        T7SerialNo: $scope.vm.T7SerialNo,
                        T7ForModelNo: $scope.vm.T7ForModelNo,
                        T7LeasePerAnnum: $scope.vm.T7LeasePerAnnum,
                        T7EffectiveDate: $scope.vm.T7EffectiveDate,
                        T7ExpiryDate: $scope.vm.T7ExpiryDate,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.Title8Submit = function () {

            if ($scope.QRTUpdate == true) {
                $scope.QRTUpdate = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contractquotation/update",
                    data: {
                        _id: $scope.vm.QRT_Id,
                        TableTitle8: $scope.vm.TableTitle8,
                        TableContractID8: $scope.ContractID,
                        TableTempID8: $scope.TemplateID,
                        T8ForModelNo: $scope.vm.T8ForModelNo,
                        T8NoOfBoardsNeeded: $scope.vm.T8NoOfBoardsNeeded,
                        T8SellingPricing: $scope.vm.T8SellingPricing,
                        T8Lifespan: $scope.vm.T8Lifespan,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    quotationRefreshGrid();
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        TableTitle8: $scope.vm.TableTitle8,
                        TableContractID8: $scope.ContractID,
                        TableTempID8: $scope.TemplateID,
                        T8ForModelNo: $scope.vm.T8ForModelNo,
                        T8NoOfBoardsNeeded: $scope.vm.T8NoOfBoardsNeeded,
                        T8SellingPricing: $scope.vm.T8SellingPricing,
                        T8Lifespan: $scope.vm.T8Lifespan,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationRefreshGrid();
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                    $scope.QRTUpdate = false;
                    $scope.Export = false;
                    $scope.Add = false;
                    $scope.Search = false;
                    $scope.view = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.EditAction = function (e, CTable, Id) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;

            $scope.TableTitle = "";
            $scope.QRTUpdate = true;
            $scope.vm.T1PestType = null;
            $scope.vm.T1Frequency = null;

            $scope.vm.T1ScopeofWork = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Description = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5Rate = null;
            $scope.vm.T5Amount = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7SerialNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7LeasePerAnnum = null;
            $scope.vm.T7EffectiveDate = null;
            $scope.vm.T7ExpiryDate = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;

            if (CTable == 'Title1') {
                $scope.Title1 = true;
                $scope.TableTitle = $scope.vm.TableTitle1;
                $scope.vm.QRT_Id = Id;
                var item = $scope.Contractquotationdatas.filter(function (item) {
                    return item.id === Id;
                })[0];
                $scope.vm.T1PestType = item.T1PestType;
                $scope.vm.T1ScopeofWork = item.T1ScopeofWork;
                $scope.vm.T1Frequency = item.T1Frequency;
                $scope.vm.T1Pricing = parseInt(item.T1Pricing);
            }
            else if (CTable == 'Title2') {
                $scope.Title2 = true; $scope.TableTitle = $scope.vm.TableTitle2;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T2PestType = item.T2PestType;
                    $scope.vm.T2Timing = item.T2Timing;
                    $scope.vm.T2Quantity = parseInt(item.T2Quantity);
                    $scope.vm.T2Frequency = item.T2Frequency;
                    $scope.vm.T2Pricing = parseInt(item.T2Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title3') {
                $scope.Title3 = true; $scope.TableTitle = $scope.vm.TableTitle3;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T3Area = item.T3Area;
                    $scope.vm.T3PestType = item.T3PestType;
                    $scope.vm.T3Quantity = parseInt(item.T3Quantity);
                    $scope.vm.T3Timing = item.T3Timing;
                    $scope.vm.T3Frequency = item.T3Frequency;
                    $scope.vm.T3Pricing = parseInt(item.T3Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title4') {
                $scope.Title4 = true; $scope.TableTitle = $scope.vm.TableTitle4;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T4Product = item.T4Product;
                    $scope.vm.T4NoOfPieces = parseInt(item.T4NoOfPieces);
                    $scope.vm.T4Pricing = parseInt(item.T4Pricing);
                }
                catch (e) { }
            }
            else if (CTable == 'Title5') {
                $scope.Title5 = true; $scope.TableTitle = $scope.vm.TableTitle5;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T5Description = item.T5Description;
                    $scope.vm.T5Quantity = parseInt(item.T5Quantity);
                    $scope.vm.T5Rate = parseInt(item.T5Rate);
                    $scope.vm.T5Amount = parseInt(item.T5Amount);
                }
                catch (e) { }
            }
            else if (CTable == 'Title6') {
                $scope.Title6 = true; $scope.TableTitle = $scope.vm.TableTitle6;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T6Description = item.T6Description;
                    $scope.vm.T6Price = parseInt(item.T6Price);
                }
                catch (e) { }
            }
            else if (CTable == 'Title7') {
                $scope.Title7 = true; $scope.TableTitle = $scope.vm.TableTitle7;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T7SerialNo = item.T7SerialNo;
                    $scope.vm.T7ForModelNo = item.T7ForModelNo;
                    $scope.vm.T7LeasePerAnnum = parseInt(item.T7LeasePerAnnum);
                    if (item.T7EffectiveDate != undefined && item.T7EffectiveDate != null && item.T7EffectiveDate != "") { $scope.vm.T7EffectiveDate = new Date(item.T7EffectiveDate); }
                    if (item.T7ExpiryDate != undefined && item.T7ExpiryDate != null && item.T7ExpiryDate != "") { $scope.vm.T7ExpiryDate = new Date(item.T7ExpiryDate); }
                }
                catch (e) { }
            }
            else if (CTable == 'Title8') {
                $scope.Title8 = true; $scope.TableTitle = $scope.vm.TableTitle8;
                $scope.vm.QRT_Id = Id;
                try {
                    var item = $scope.Contractquotationdatas.filter(function (item) {
                        return item.id === Id;
                    })[0];
                    $scope.vm.T8ForModelNo = item.T8ForModelNo;
                    $scope.vm.T8NoOfBoardsNeeded = parseInt(item.T8NoOfBoardsNeeded);
                    $scope.vm.T8SellingPricing = parseInt(item.T8SellingPricing);
                    $scope.vm.T8Lifespan = item.T8Lifespan;
                }
                catch (e) { }
            }
            else { $scope.vm.QRT_Id = null; }

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contractquotation/contractquotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractquotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        $scope.SaveasTemplatepopup = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contractquotation/SaveasTemplatepopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractquotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.sSubmit = function () {

            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }
            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');
            $scope.ContractStatus = "Open";

            if ($scope.Revision >= 0) {
                var item = $scope.Preparedcontractdatas.filter(function (item) {
                    return item.ContractID === $scope.ContractID;
                })[0];
                $scope.ContractquotationReference = item.PreparedcontractReference;
                $scope.Revision = $scope.Revision + 1;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/preparedcontract/add",
                    data: {
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Scopeofwork: $scope.Scopeofwork,
                        IncludeSOR: $scope.IncludeSOR,
                        ContractID: $scope.ContractID,
                        PreparedcontractReference: $scope.ContractquotationReference,
                        Revision: $scope.Revision,
                        NewStatus: $scope.NewStatus,
                        StatusCreatedBy: $scope.StatusCreatedBy,
                        StatusCreatedDate: $scope.StatusCreatedDate,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    var array = []
                    var myArray = $scope.Workflowdatas;
                    var item = [];
                    item = myArray.filter(function (item) {
                        return item.TypeName === 'CRM Contract' && parseInt(item.LevelName) === $scope.CurrentStatusID;
                    });
                    if (item.length != 0 && item != undefined) {

                        try {
                            if (item[0].NotifytoNextLevelApprover == true) {
                                $scope.NLevel = item[0].NextLevel;
                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                    return Workflowitem1.TypeName === 'CRM Contract' && Workflowitem1.LevelName === $scope.NLevel;
                                });
                                try {
                                    if (Workflowitem1[0].EmailNotification == true) {
                                        if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                            angular.forEach($scope.Userdatas, function (value) {
                                                if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                    if (array.indexOf(value.Email) == -1) {
                                                        array.push(value.Email);
                                                    }
                                                }
                                            })
                                        }
                                        $scope.SendEmailQt = array.map(function (obj) { return obj }).join(',');
                                    }
                                } catch (err) { }
                            }
                        }
                        catch (e) { }
                    }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/contract/update",
                        data: {
                            _id: $scope.ContractID,
                            PestType: $scope.NatureofJob,
                            SalesPerson_id: $scope.SalesPerson,
                            Frequency: $scope.Frequency,
                            ContractDuration: $scope.ContractDuration,
                            ContactPerson: $scope.uContactPerson,
                            ContractStartDate: $scope.ContractStartDate,
                            ContractEndDate: $scope.ContractEndDate,
                            ServiceEndDate: $scope.ServiceEndDate,
                            ServiceStartDate: $scope.ServiceStartDate,
                            Customer_id: $scope.Customer_id,
                            CustomerID: $scope.CustomerID,
                            ContractNotes: $scope.ContractNotes,
                            SalesOrderID: $scope.SalesOrderID,
                            Status: $scope.CurrentStatus,
                            StatusID: $scope.CurrentStatusID,
                            SendEmailQt: $scope.SendEmailQt,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    $window.localStorage.setItem('ContractCadded', "");
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    quotationlogsubmit();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                $scope.Revision = 0;
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/preparedcontract/add",
                    data: {
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Scopeofwork: $scope.Scopeofwork,
                        IncludeSOR: $scope.IncludeSOR,
                        ContractID: $scope.ContractID,
                        PreparedcontractReference: $scope.ContractquotationReference,
                        Revision: $scope.Revision,
                        NewStatus: $scope.NewStatus,
                        StatusCreatedBy: $scope.StatusCreatedBy,
                        StatusCreatedDate: $scope.StatusCreatedDate,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    var array = []
                    var myArray = $scope.Workflowdatas;
                    var item = [];
                    item = myArray.filter(function (item) {
                        return item.TypeName === 'CRM Contract' && parseInt(item.LevelName) === $scope.CurrentStatusID;
                    });
                    if (item.length != 0 && item != undefined) {

                        try {
                            if (item[0].NotifytoNextLevelApprover == true) {
                                $scope.NLevel = item[0].NextLevel;
                                var myArray1 = $scope.Workflowdatas;
                                var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                    return Workflowitem1.TypeName === 'CRM Contract' && Workflowitem1.LevelName === $scope.NLevel;
                                });
                                try {
                                    if (Workflowitem1[0].EmailNotification == true) {
                                        if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                            angular.forEach($scope.Userdatas, function (value) {
                                                if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                    if (array.indexOf(value.Email) == -1) {
                                                        array.push(value.Email);
                                                    }
                                                }
                                            })
                                        }
                                        $scope.SendEmailQt = array.map(function (obj) { return obj }).join(',');
                                    }
                                } catch (err) { }
                            }
                        }
                        catch (e) { }

                    }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/contract/update",
                        data: {
                            _id: $scope.ContractID,
                            PestType: $scope.NatureofJob,
                            SalesPerson_id: $scope.SalesPerson,
                            Frequency: $scope.Frequency,
                            ContractDuration: $scope.ContractDuration,
                            ContactPerson: $scope.uContactPerson,
                            ContractStartDate: $scope.ContractStartDate,
                            ContractEndDate: $scope.ContractEndDate,
                            ServiceEndDate: $scope.ServiceEndDate,
                            ServiceStartDate: $scope.ServiceStartDate,
                            Customer_id: $scope.Customer_id,
                            CustomerID: $scope.CustomerID,
                            ContractNotes: $scope.ContractNotes,
                            SalesOrderID: $scope.SalesOrderID,
                            ContractStatus: $scope.ContractStatus,
                            Status: $scope.CurrentStatus,
                            StatusID: $scope.CurrentStatusID,
                            UpdatedBy: $rootScope.createdby, IsActive: "true",
                            SendEmailQt: $scope.SendEmailQt,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {

                        $scope.GListdata = GList.data.data;
                        var SenderEmails = [];
                        var myArray = $scope.Workflowdatas;
                        var Workflowitem = myArray.filter(function (item) {
                            return item.TypeName === 'CRM Contract' && parseInt(item.LevelName) === $scope.GListdata.StatusID;
                        });
                        try {
                            if (Workflowitem[0].EmailNotification == true) {
                                if (Workflowitem[0].NotifytoCurrentApprover == true) {
                                    if (Workflowitem[0].Approvers != null && Workflowitem[0].Approvers != undefined && Workflowitem[0].Approvers != "") {
                                        angular.forEach($scope.Userdatas, function (value) {
                                            if (Workflowitem[0].Approvers.indexOf(value.UserID) > -1) {
                                                if (SenderEmails.indexOf(value.Email) == -1) {
                                                    SenderEmails.push(value.Email);
                                                }
                                            }
                                        })
                                    }
                                }
                                if (Workflowitem[0].NotifytoCreatorInitator == true) {
                                    var UserArray = $scope.Userdatas;
                                    var item = UserArray.filter(function (item) {
                                        return item.UserID === $scope.GListdata.CreatedBy;
                                    })[0];
                                    if (SenderEmails.indexOf(item.Email) == -1) {
                                        SenderEmails.push(item.Email);
                                    }
                                }
                                if (Workflowitem[0].NotifyTo != null && Workflowitem[0].NotifyTo != undefined && Workflowitem[0].NotifyTo != "") {
                                    angular.forEach($scope.Userdatas, function (value) {
                                        if (Workflowitem[0].NotifyTo.indexOf(value.UserID) > -1) {
                                            if (SenderEmails.indexOf(value.Email) == -1) {
                                                SenderEmails.push(value.Email);
                                            }
                                        }
                                    })
                                }
                                if (Workflowitem[0].NotifytoNextLevelApprover == true) {
                                    $scope.NLevel = Workflowitem[0].NextLevel;
                                    var myArray1 = $scope.Workflowdatas;
                                    try {
                                        var Workflowitem1 = myArray1.filter(function (Workflowitem1) {
                                            return Workflowitem1.TypeName === 'CRM Contract' && Workflowitem1.LevelName === $scope.NLevel;
                                        });
                                        if (Workflowitem1[0].Approvers != null && Workflowitem1[0].Approvers != undefined && Workflowitem1[0].Approvers != "") {
                                            angular.forEach($scope.Userdatas, function (value) {
                                                if (Workflowitem1[0].Approvers.indexOf(value.UserID) > -1) {
                                                    if (SenderEmails.indexOf(value.Email) == -1) {
                                                        SenderEmails.push(value.Email);
                                                    }
                                                }
                                            })
                                        }
                                    }
                                    catch (e) { }
                                }
                                try {
                                    var sitem = $scope.salesOrderdatas.filter(function (sitem) {
                                        return sitem._id === $scope.GListdata.SalesOrderID;
                                    })[0];
                                    if (SenderEmails.length != 0) {
                                        angular.forEach(SenderEmails, function (value) {
                                            var mailresponse = $http({
                                                method: "POST",
                                                url: $rootScope.WebURL + "/contract/workflowemail",
                                                data: {
                                                    SenderEmailAddress: value,
                                                    Contract: $scope.GListdata.ContractReferenceNo,
                                                    WorkOrder: sitem.SalesOrderNo,
                                                    CustomerName: $scope.CustomerName,
                                                    Status: $scope.GListdata.Status,
                                                    CreatedBy: $rootScope.createdby,
                                                },
                                            });
                                        })
                                    }
                                }
                                catch (e) { }
                            }
                        } catch (e) { }
                        $window.localStorage.setItem('ContractCadded', "");
                        quotationlogsubmit();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                });
            }
        }
        $scope.sSave = function () {
            try {
                var item1 = $scope.Contractquotationdatas.filter(function (item1) {
                    return item1.TableContractID2 === $scope.ContractID;
                })[0];
                $scope.Inserted = item1.Inserted;
                $scope.Inserted_Id = item1.id;
            }
            catch (e) { }
            if ($scope.Inserted == true || $scope.Inserted == "true") {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/delete",
                    data: {
                        _id: $scope.Inserted_Id,
                    },
                });
                response.then(function (GList) {
                    var addresponse = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/contractquotation/add",
                        data: {
                            Inserted: true,
                            Subject: $scope.Subject,
                            TermsCondition: $scope.TermsCondition,
                            Footer: $scope.Footer,
                            Header: $scope.Header,
                            TableContractID2: $scope.ContractID,
                            Client_Id: $rootScope.Client_Id,
                            CreatedBy: $rootScope.createdby, IsActive: "true",
                        },
                    });
                    addresponse.then(function (GList) {
                        $mdToast.show($mdToast.simple().textContent('Successfully Saved!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }, function () {
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contractquotation/add",
                    data: {
                        Inserted: true,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        TableContractID2: $scope.ContractID,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Saved!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Preview = function (invoice) {
            $scope.Previewdiv = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            popupWinindow.document.close($scope.Previewdiv = false);
        }
        $scope.Selected = false

        $scope.SelectTemplate = function (TId) {
            if ($scope.Selected == false) {
                angular.forEach($scope.Contracttemplates, function (value) {
                    if (value.id == TId) {
                        $scope.vm.TableTitleID = value.TableTitleID;
                        $scope.vm.TemplateName = value.TemplateName;
                        $scope.TableTitle = value.TableTitle;
                        $scope.Subject = value.Subject;
                        $scope.TermsCondition = value.TermsCondition;
                        $scope.Footer = value.Footer;
                        $scope.Header = value.Header;
                        $scope.TableTempID = value.TemplateID;
                    }
                });

                angular.forEach($scope.Contractquotationdatas, function (pvalue) {
                    if (pvalue.TableTempID1 == $scope.TableTempID) {
                        $scope.vm.TableTitle1 = pvalue.TableTitle1;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle1: pvalue.TableTitle1,
                                TableContractID1: $scope.ContractID,
                                TableTempID1: $scope.cloneTableTempID,
                                T1PestType: pvalue.T1PestType,
                                T1ScopeofWork: pvalue.T1ScopeofWork,
                                T1Frequency: pvalue.T1Frequency,
                                T1Pricing: pvalue.T1Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
                $scope.Selected = true;
            }
            else {

                angular.forEach($scope.Contractquotationdatas, function (pvalue) {
                    if (pvalue.TableContractID1 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                    }
                });

                angular.forEach($scope.Contracttemplates, function (value) {
                    if (value.id == TId) {
                        $scope.vm.TableTitleID = value.TableTitleID;
                        $scope.vm.TemplateName = value.TemplateName;
                        $scope.TableTitle = value.TableTitle;
                        $scope.Subject = value.Subject;
                        $scope.TermsCondition = value.TermsCondition;
                        $scope.Footer = value.Footer;
                        $scope.Header = value.Header;
                        $scope.TableTempID = value.TemplateID;
                    }
                });

                angular.forEach($scope.AllPestType, function (value) {

                    if (value.PestType != null) {
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle1: value.TableTitle1,
                                TableContractID1: $scope.ContractID,
                                TableTempID1: $scope.cloneTableTempID,
                                T1PestType: value.PestType,
                                T1ScopeofWork: value.T1ScopeofWork,
                                T1Frequency: $scope.Frequency,
                                T1Pricing: value.T1Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                    }
                });

                angular.forEach($scope.Contractquotationdatas, function (pvalue) {

                    if (pvalue.TableTempID1 == $scope.TableTempID) {
                        $scope.vm.TableTitle1 = pvalue.TableTitle1;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/add",
                            data: {
                                TableTitle1: pvalue.TableTitle1,
                                TableContractID1: $scope.ContractID,
                                TableTempID1: $scope.cloneTableTempID,
                                T1PestType: pvalue.T1PestType,
                                T1ScopeofWork: pvalue.T1ScopeofWork,
                                T1Frequency: pvalue.T1Frequency,
                                T1Pricing: pvalue.T1Pricing,
                                CreatedBy: $rootScope.createdby, IsActive: "true",
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });

                $scope.Selected = true;
            }
            $window.localStorage.setItem('ContractCadded', true)
        }

        $scope.SaveasTemplatesubmit = function () {
            var tablename = [];
            if ($scope.vm.TableTitle1 != null && $scope.vm.TableTitle1 != "" && $scope.vm.TableTitle1 != undefined) { tablename.push({ TableTitle: 'TableTitle1' }) }
            if ($scope.vm.TableTitle2 != null && $scope.vm.TableTitle2 != "" && $scope.vm.TableTitle2 != undefined) { tablename.push({ TableTitle: 'TableTitle2' }) }
            if ($scope.vm.TableTitle3 != null && $scope.vm.TableTitle3 != "" && $scope.vm.TableTitle3 != undefined) { tablename.push({ TableTitle: 'TableTitle3' }) }
            if ($scope.vm.TableTitle4 != null && $scope.vm.TableTitle4 != "" && $scope.vm.TableTitle4 != undefined) { tablename.push({ TableTitle: 'TableTitle4' }) }
            if ($scope.vm.TableTitle5 != null && $scope.vm.TableTitle5 != "" && $scope.vm.TableTitle5 != undefined) { tablename.push({ TableTitle: 'TableTitle5' }) }
            if ($scope.vm.TableTitle6 != null && $scope.vm.TableTitle6 != "" && $scope.vm.TableTitle6 != undefined) { tablename.push({ TableTitle: 'TableTitle6' }) }
            if ($scope.vm.TableTitle7 != null && $scope.vm.TableTitle7 != "" && $scope.vm.TableTitle7 != undefined) { tablename.push({ TableTitle: 'TableTitle7' }) }
            if ($scope.vm.TableTitle8 != null && $scope.vm.TableTitle8 != "" && $scope.vm.TableTitle8 != undefined) { tablename.push({ TableTitle: 'TableTitle8' }) }

            $scope.vm.TableTitle = tablename.map(function (obj) { return obj.TableTitle; }).join(',');
            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/contracttemplate/update",
                    data: {
                        _id: $scope.vm.SID,
                        TemplateID: $scope.TemplateID,
                        TemplateName: $scope.vm.TemplateName,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/contracttemplate/add",
                    data: {
                        TemplateID: $scope.TemplateID,
                        TemplateName: $scope.vm.TemplateName,
                        TableTitle: $scope.vm.TableTitle,
                        TableTitleID: $scope.vm.TableTitleID,
                        Subject: $scope.Subject,
                        TermsCondition: $scope.TermsCondition,
                        Footer: $scope.Footer,
                        Header: $scope.Header,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Template Saved!').position('top center'));
                    $mdDialog.cancel();
                    $scope.Quotationform = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.PestManagement = function (e, CTable) {
            $scope.Title1 = false;
            $scope.Title2 = false;
            $scope.Title3 = false;
            $scope.Title4 = false;
            $scope.Title5 = false;
            $scope.Title6 = false;
            $scope.Title7 = false;
            $scope.Title8 = false;
            $scope.TableTitle = "";
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/crm/contractquotation/contractquotationpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function contractquotationController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.QRTUpdate = false;
            if (CTable == 'Title1') { $scope.Title1 = true; $scope.TableTitle = $scope.vm.TableTitle1 }
            if (CTable == 'Title2') { $scope.Title2 = true; $scope.TableTitle = $scope.vm.TableTitle2 }
            if (CTable == 'Title3') { $scope.Title3 = true; $scope.TableTitle = $scope.vm.TableTitle3 }
            if (CTable == 'Title4') { $scope.Title4 = true; $scope.TableTitle = $scope.vm.TableTitle4 }
            if (CTable == 'Title5') { $scope.Title5 = true; $scope.TableTitle = $scope.vm.TableTitle5 }
            if (CTable == 'Title6') { $scope.Title6 = true; $scope.TableTitle = $scope.vm.TableTitle6 }
            if (CTable == 'Title7') { $scope.Title7 = true; $scope.TableTitle = $scope.vm.TableTitle7 }
            if (CTable == 'Title8') { $scope.Title8 = true; $scope.TableTitle = $scope.vm.TableTitle8 }

            $scope.vm.T1PestType = null;
            $scope.vm.T1ScopeofWork = null;
            $scope.vm.T1Frequency = null;
            $scope.vm.T1Pricing = null;
            $scope.vm.T2PestType = null;
            $scope.vm.T2Timing = null;
            $scope.vm.T2Quantity = null;
            $scope.vm.T2Frequency = null;
            $scope.vm.T2Pricing = null;
            $scope.vm.T3Area = null;
            $scope.vm.T3PestType = null;
            $scope.vm.T3Quantity = null;
            $scope.vm.T3Timing = null;
            $scope.vm.T3Frequency = null;
            $scope.vm.T3Pricing = null;
            $scope.vm.T4Product = null;
            $scope.vm.T4NoOfPieces = null;
            $scope.vm.T4Pricing = null;
            $scope.vm.T5Description = null;
            $scope.vm.T5Quantity = null;
            $scope.vm.T5Rate = null;
            $scope.vm.T5Amount = null;
            $scope.vm.T6Description = null;
            $scope.vm.T6Price = null;
            $scope.vm.T7SerialNo = null;
            $scope.vm.T7ForModelNo = null;
            $scope.vm.T7LeasePerAnnum = null;
            $scope.vm.T7EffectiveDate = null;
            $scope.vm.T7ExpiryDate = null;
            $scope.vm.T8ForModelNo = null;
            $scope.vm.T8NoOfBoardsNeeded = null;
            $scope.vm.T8SellingPricing = null;
            $scope.vm.T8Lifespan = null;
        }
        $scope.QDelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                quotationRefreshGrid();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.Showgrid = function () {
            var Added = localStorage.getItem('ContractCadded')
            if (Added == "true") {
                angular.forEach($scope.Contractquotationdatas, function (pvalue) {
                    if (pvalue.TableContractID1 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID2 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID3 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID4 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID5 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID6 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID7 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                    if (pvalue.TableContractID8 == $scope.ContractID) {
                        var deleteID = pvalue.id;
                        var response = $http({
                            method: "POST",
                            url: $rootScope.WebURL + "/contractquotation/delete",
                            data: {
                                _id: deleteID,
                            },
                        });
                        response.then(function (GList) {
                            quotationRefreshGrid();
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                        });
                    }
                });
                $window.localStorage.setItem('PQfromContract', "");
                $window.localStorage.setItem('ContractCadded', "");
                //$window.localStorage.setItem('idfromPQContract', $scope.ContractID);
                $state.go('app.contracts');
            }
            else {
                $window.localStorage.setItem('PQfromContract', "");
                $window.localStorage.setItem('ContractCadded', "");
                // $window.localStorage.setItem('idfromPQContract', $scope.ContractID);
                $state.go('app.contracts');
                //$location.path('Contracts');
            }
        }
        $scope.Back = function () {
            $window.localStorage.setItem('PQfromContract', "");
            $window.localStorage.setItem('Selected', "")
            $window.localStorage.setItem('idfromPQContract', $scope.ContractID);
            $state.go('app.contracts');
        }
        function quotationlogsubmit() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/quotationlog/add",
                data: {
                    ContractID: $scope.ContractID,
                    TableName: 'Contracts',
                    Status: $scope.CurrentStatus,
                    StatusCreatedBy: $scope.createdby,
                    StatusCreatedDate: new Date(),
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                $window.localStorage.setItem('PQfromContract', "");
                //$window.localStorage.setItem('idfromPQContract', $scope.ContractID);
                $state.go('app.contracts');
                // $location.path('Contracts');
                $scope.Quotationform = true;
            })
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/salesOrder",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (salesOrderdata) {
            $scope.salesOrderdatas = salesOrderdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/user/getByClientId",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Userdata) {
            $scope.Userdatas = Userdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/Workflow",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Workflowdata) {
            $scope.Workflowdatas = Workflowdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/contractquotation/GetById",
            data: { ContractID: $scope.ContractID },
        }).then(function (contractquotationdata) {
            $scope.Contractquotationdatas = contractquotationdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/contracttemplate",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (contracttemplate) {
            $scope.Contracttemplates = contracttemplate.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (pestdata) {
            $scope.Pestdatas = pestdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/product",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Productdata) {
            $scope.Productdatas = Productdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/areas",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (areasdata) {
            $scope.areasdatas = areasdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/preparedcontract",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (preparedcontractdata) {
            $scope.Preparedcontractdatas = preparedcontractdata.data.data;
            init();
        });

        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contractquotationdata) {
                $scope.Contractquotationdatas = contractquotationdata.data.data;
            });

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (pestdata) {
                $scope.Pestdatas = pestdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/areas",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (areasdata) {
                $scope.areasdatas = areasdata.data.data;
            });
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contracttemplate",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contracttemplate) {
                $scope.Contracttemplates = contracttemplate.data.data;
            });
        }
        function quotationRefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contractquotation",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (contractquotationdata) {
                $scope.Contractquotationdatas = contractquotationdata.data.data;
            });
        }
        var vm = this;
        //// Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            responsive: true
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.chat', {
            url    : '/chat',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('chat.contacts@get');
                },
                User    : function (msApi)
                {
                    return msApi.resolve('chat.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/chat');

        // Api
        // Contacts data must be alphabatically ordered.
        msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);
        msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);
        msApiProvider.register('chat.user', ['app/data/chat/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.chat', {
            title : 'Chat',
            icon  : 'icon-hangouts',
            state : 'app.chat',
            badge : {
                content: 13,
                color  : '#09d261'
            },
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($q, msApi)
    {
        
        var service = {
            chats         : {},
            contacts      : [],
            getContactChat: getContactChat
        };

        /**
         * Get contact chat from the server
         *
         * @param contactId
         * @returns {*}
         */
        function getContactChat(contactId)
        {

            // Create a new deferred object
            var deferred = $q.defer();

            // If contact doesn't have lastMessage, create a new chat
            if ( !service.contacts.getById(contactId).lastMessage)
            {
                service.chats[contactId] = [];

                deferred.resolve(service.chats[contactId]);
            }

            // If the chat exist in the service data, do not request
            if ( service.chats[contactId] )
            {
                deferred.resolve(service.chats[contactId]);
                
                return deferred.promise;
            }

            // Request the chat with the contactId
            msApi.request('chat.chats@get', {id: contactId},

                // SUCCESS
                function (response)
                {
                    // Attach the chats
                    service.chats[contactId] = response.data;

                    // Resolve the promise
                    deferred.resolve(service.chats[contactId]);
                },

                // ERROR
                function (response)
                {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.pestoff.salesreceivables')
        .controller('salesreceivablesController', salesreceivablesController);


    function salesreceivablesController($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Invoice")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;
        $scope.TRCCdiv = false
        var select = 'always'
        $scope.Desc = true;
        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);
        $scope.vm.uTo = $scope.uTo;
        $scope.vm.uFrom = $scope.uFrom;

        $scope.InvoiceSelect = true;
        $scope.InvoiceGrid = true;
        $scope.InvoiceForm = false;
        $scope.CollectPaymentSelect = false;
        $scope.CreditnoteSelect = false;
        $scope.CustomerStatementSelect = false;
        $scope.CreditnoteGrid = false;
        $scope.CreditnoteForm = false;
        $scope.DebitnoteSelect = false;
        $scope.DebitnoteGrid = false;
        $scope.DebitnoteForm = false;
        $scope.InvoiceFormback = false;
        $scope.CollectPaymentGrid = false;
        $scope.CollectPaymentForm = false;
        $scope.CollectPaymentFormback = false;

        $scope.FilterByCustomer = true;
        var dataGrid = ""

        vm.dataGridContract = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            onCellPrepared: function (e) {
            },
            dataSource: $scope.Salesinvoicedatas,
            keyExpr: "_id",
            headerFilter: {
                visible: true,
                allowSearch: true
            },
            filterRow: {
                visible: true
            },
            paging: {
                enabled: true,
                pageSize: 10
            },
            allowColumnResizing: true,
            columnAutoWidth: false,
            editing: {
                allowUpdating: false,
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            wordWrapEnabled: true,
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            // selection: {
            //     mode: "multiple",
            //     showCheckBoxesMode: select,
            //   },

            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                {
                    dataField: "InvoiceNumber", caption: "Invoice No.", width: "85",
                    cellTemplate: function (container, options) {
                        $("<p style='color:blue;cursor: pointer;'>" + options.data.InvoiceNumber + "</p>").appendTo(container);
                    },
                },
                { dataField: "SalesOrderNo", caption: "Work Order#" },
                { dataField: "InvoiceDate", caption: "Invoice Date", width: "60", dataType: "datetime", format: 'dd/MM/yyyy' },
                { dataField: "SalesOrderNo", caption: "SalesOrder No", width: "100" },
                { dataField: "InvoiceAmount", caption: "Invoice Amount", width: "100" },
                { dataField: "BillingAddress", caption: "Billing Address" },
                { dataField: "ServiceAddress", caption: "Service Address" },
                { dataField: "PestType", caption: "Pest Coverage" },
                { dataField: "BillingFrequency", caption: "Billing Frequency" },
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                // { dataField: "Date", caption: "Voucher Date" , width: "150", dataType: "datetime", format: 'dd/MM/yyyy'},
                { dataField: "Status", caption: "Status", width: "100" },
                { dataField: "Xero Invoice No.", caption: "Remarks" },

                {
                    caption: 'Preview',
                    width: "70",
                    fixed: false,
                    fixedPosition: 'right',
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        $('<div />').dxButton({
                            icon: 'exportpdf',
                            onClick: function (e) {
                                $scope.Printsalesinvoice(options.data._id)
                            }
                        }).appendTo(container);
                    }
                },
                // {
                //     caption: 'Send Email',
                //     width: "90",
                //     fixed: false,
                //     fixedPosition: 'right',
                //     alignment: 'center',
                //     allowSorting: false,
                //     cellTemplate: function (container, options) {
                //         $('<div />').dxButton({
                //             icon: 'email',
                //             onClick: function (e) {
                //                 $scope.SendMail(options.data._id, options.data.BillingFrequency, options.data.ServiceStartDate, options.data.ServiceEndDate, options.data.CreatedBy, 'Send Email')
                //             }
                //         }).appendTo(container);
                //     }
                // }

            ],
            bindingOptions: {
                dataSource: "Salesinvoicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "true",
            },
            // onEditingStart: function (e) {
            //   e.cancel = true
            //   $scope.Leadinfo(data._id)
            // },
            // onToolbarPreparing: function (e) {
            //     e.toolbarOptions.items.unshift({
            //         location: "before",
            //         template: "totalGroupCount"
            //     }
            //     );
            // },
            onCellClick: function (data) {
                if (data.columnIndex == 1) {
                    var index = dataGrid.getRowIndexByKey(data.data._id);
                    $scope.SalesInvoiceInfo(data.data._id, index)
                }
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedIds = [];
                    $scope.TRCCdiv = true;
                    $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys)
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                    e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
                }
                else {
                    $scope.TRCCdiv = false;
                    $scope.SelectedIds = [];
                    e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
                }
            },
        };

        $scope.InvoiceFilter = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getCount",
                data: { Client_Id: $rootScope.Client_Id, Status: "Paid", Type: "Invoice" }
            }).then(function (List) {
                var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
                var Skip = 0
                var Limit = 300
                for (var i = 0; i < ContractLength; i++) {
                    if (i == 0) Skip = 0
                    else Skip += 300
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesinvoice/get",
                        data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", Skip: Skip, Limit: Limit }
                    }).then(function (GList) {
                        if (dataGrid != "")
                            $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                        $scope.Salesinvoicedatas = $scope.Salesinvoicedatas.concat(GList.data.data)
                        $scope.vm.PreviewSpinner = false
                    })
                }
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        $scope.InvoiceFilterByDate = function () {
            if (dataGrid != "")
                $("#ContractgridContainer").dxDataGrid('instance').beginCustomLoading()
            $scope.Salesinvoicedatas = []
            $scope.workOrd = []

            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getByDate",
                data: { Client_Id: $rootScope.Client_Id, Type: "Invoice", Status: "Paid", StartDate: $scope.uFrom, EndDate: $scope.uTo }
            }).then(function (GList) {
                if (dataGrid != "")
                    $("#ContractgridContainer").dxDataGrid('instance').endCustomLoading()
                $scope.Salesinvoicedatas = $scope.Salesinvoicedatas.concat(GList.data.data)
                $scope.vm.PreviewSpinner = false
            }, function (err) {
                $mdToast.show($mdToast.simple().textContent('Something gone wrong,please refresh the page !').position('top center'));
            })

        };

        RefreshCustomer();
        $scope.InvoiceFilter()



        $scope.PushtoXero = function () {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/pushtoxero",
                method: "PUT",
                data: { InvoiceArray: $scope.SelectedIds, CreatedBy: $rootScope.createdby },
            });
            response.then(function (salesinvoicedata) {
                $mdToast.show($mdToast.simple().textContent('Successfully Exported to Xero!').position('top center'));

            })
        }

        $scope.ChangeDate = function (Type) {
            if (Type == 'less') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
                $scope.uTo = new Date($scope.uFrom);
            }
            if (Type == 'greater') {
                $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
                $scope.uTo = new Date($scope.uFrom);
            }
        }

        GetTotalCurrentYearInvoices();
        function GetTotalCurrentYearInvoices() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearInvoices = 0 }


            });
        }

        $scope.ShowClosed = function (con) {
            $scope.DefaultInvoice = con
            if ($scope.DefaultInvoice) {
                select = 'none'
                $scope.Salesinvoicedatas = undefined;
                var FromDate = $scope.uFrom;
                var ToDate = $scope.uTo;
                var response = $http({
                    url: $rootScope.WebURL + "/salesinvoice/getByXero",
                    method: "POST",
                    data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
                });
                response.then(function (salesinvoicedata) {

                    $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                });
            }
            else {
                select = 'always'
                $scope.InvoiceFilter()
            }
        }

        $scope.Invoiceadd = function (e) {
            ClearInvoice();

            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;

            var AR = "5" + new Date().getFullYear().toString().substr(-2);

            var info = $scope.TotalCurrentYearInvoices + 1;
            var y = pad(info, 6);
            $scope.InvoiceNumber = AR + y;

            var VR = "SV" + new Date().getFullYear().toString().substr(-2);

            $scope.VoucherNumber = VR + y;

            var item = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            if (item != undefined) {
                $scope.GSTID = item._id;
            }

            $scope.Date = new Date();
            $scope.VoucherDate = new Date();
            $scope.DueDate = new Date();

            $scope.Descriptiondatas = null;
            $scope.ServiceID = null;
            $scope.ServiceIDs = null;

        }

        // $scope.SaveInvoice = function () {

        //     $scope.ServiceIDs = ""

        //     var OutStandingAmount = 0
        //     var InvoiceAmount = 0; var GSTAmount = 0;
        //     if ($scope.GSTID == "" || $scope.GSTID == undefined) {
        //         $scope.GSTID = null;
        //     }
        //     else {
        //         var item = $scope.GSTdatas.filter(function (item) {
        //             return item._id === $scope.GSTID;
        //         })[0];

        //         OutStandingAmount = parseFloat(OutStandingAmount) + (parseFloat(OutStandingAmount / 100) * parseFloat(item.TaxRate));

        //         GSTAmount = parseFloat($scope.Amount / 100) * parseFloat(item.TaxRate);
        //     }

        //     if ($scope.Amount > $scope.AmountReceived)
        //         OutStandingAmount = $scope.Amount - $scope.AmountReceived
        //     if ($scope.Amount < $scope.AmountReceived)
        //         OutStandingAmount = $scope.AmountReceived - $scope.Amount

        //     if ($scope.Update == true) {

        //         $scope.Update = true;
        //         var response = $http({
        //             method: "PUT",
        //             url:  $rootScope.WebURL + "/salesinvoice/update",
        //             data: {
        //                 _id: $scope.InvoiceID, InvoiceNumber: $scope.InvoiceNumber, CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //                 Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //                 VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, UpdatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //                 OutStandingAmount: OutStandingAmount, InvoiceAmount: $scope.Amount, GSTAmount: GSTAmount, ContractID: $scope.ConID, AmountReceived: $scope.AmountReceived
        //             },
        //         });

        //         response.then(function (GList) {
        //             $scope.InvoiceFilter()
        //             $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



        //             //RefreshInvoice();
        //             $scope.InvoiceGrid = true;
        //             $scope.InvoiceForm = false;
        //             $scope.InvoiceFormback = false;
        //             $scope.InvoiceSelect = true;
        //         }, function () {
        //             $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        //         });
        //     }
        //     else {
        //         var response = $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/salesinvoice/add",
        //             data: {
        //                 InvoiceNumber: $scope.InvoiceNumber, Client_Id: Client_Id, CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //                 Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //                 VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, CreatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //                 OutStandingAmount: OutStandingAmount, InvoiceAmount: $scope.Amount, GSTAmount: GSTAmount, ContractID: $scope.ConID
        //             },
        //         });

        //         response.then(function (GList) {

        //             if (GList.data.message == "Existing Sales invoice") {

        //                 $mdToast.show($mdToast.simple().textContent('Invoice Number is already exists, please submit again !').position('top center'));
        //             }
        //             else {
        //                 $scope.InvoiceFilter()
        //                 $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //             }

        //             RefreshInvoice();
        //             GetTotalCurrentYearInvoices();
        //             $scope.InvoiceGrid = true;
        //             $scope.InvoiceForm = false;
        //             $scope.InvoiceFormback = false;
        //             $scope.InvoiceSelect = true;
        //         }, function () {
        //             $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        //         });

        //     }
        //     // else {

        //     //     var firstDay = new Date(new Date().getFullYear(),0, 1);   
        //     //     firstDay.setHours(0, 0, 0, 0);  
        //     //     $scope.uTo.setHours(23, 59, 59, 999);
        //     //     var response = $http({
        //     //         url:  $rootScope.WebURL + "/salesinvoice/datefilter",
        //     //         method: "POST",
        //     //         data: { Start_Date: firstDay, End_Date: $scope.uTo,Client_Id: Client_Id , },
        //     //     });
        //     //     response.then(function (salesinvoicedata) {

        //     //         $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data;

        //     //         var item = $scope.TotalCurrentYearInvoices.filter(function (item) {
        //     //             return item.InvoiceNumber === $scope.InvoiceNumber;
        //     //         })[0];

        //     //         if (item != undefined) {

        //     //             var firstDay = new Date(new Date().getFullYear(),0, 1);   
        //     //             firstDay.setHours(0, 0, 0, 0);  
        //     //             $scope.uTo.setHours(23, 59, 59, 999);
        //     //             var response = $http({
        //     //                 url:  $rootScope.WebURL + "/salesinvoice/getTotalInvoicesByYear",
        //     //                 method: "POST",
        //     //                 data: { Start_Date: firstDay, End_Date:  $scope.uTo, Client_Id: Client_Id },
        //     //             });
        //     //             response.then(function (salesinvoicedata) {


        //     //                 if (salesinvoicedata.data.data.length > 0) {

        //     //                     $scope.TotalCurrentYearInvoices = salesinvoicedata.data.data[0].Total;
        //     //                 }
        //     //                 else { $scope.TotalCurrentYearInvoices = 0 }


        //     //                 var AR = "5" + new Date().getFullYear().toString().substr(-2);

        //     //                 var info = $scope.TotalCurrentYearInvoices + 1;
        //     //                 var y = pad(info, 6);
        //     //                 $scope.InvoiceNumber = AR + y;

        //     //                 var VR = "SV" + new Date().getFullYear().toString().substr(-2);
        //     //                 $scope.VoucherNumber = VR + y;

        //     //                 var response = $http({
        //     //                     method: "POST",
        //     //                     url:  $rootScope.WebURL + "/salesinvoice/add",
        //     //                     data: {
        //     //                         InvoiceNumber: $scope.InvoiceNumber,Client_Id: Client_Id , CustomerID: $scope.CustomerID, WorkOrderID: $scope.WorkOrderID, Date: $scope.Date,
        //     //                         Amount: $scope.Amount, ServiceID: $scope.ServiceIDs, GSTID: $scope.GSTID, Description: $scope.Description, VoucherNumber: $scope.VoucherNumber,
        //     //                         VoucherDate: $scope.VoucherDate, CreditTerm: $scope.CreditTerm, DueDate: $scope.DueDate, CreatedBy: $rootScope.LoginID, Remarks: $scope.Remarks,
        //     //                         OutStandingAmount: OutStandingAmount, InvoiceAmount: InvoiceAmount, GSTAmount: GSTAmount, ContractID: $scope.ConID
        //     //                     },
        //     //                 });

        //     //                 response.then(function (GList) {

        //     //                     if (GList.data.message == "Existing Sales invoice") {

        //     //                         $mdToast.show($mdToast.simple().textContent('Invoice Number is already exists, please submit again !').position('top center'));
        //     //                     }
        //     //                     else {
        //     //                         $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
        //     //                     }

        //     //                     RefreshInvoice();
        //     //                     GetTotalCurrentYearInvoices();
        //     //                     $scope.InvoiceGrid = true;
        //     //                     $scope.InvoiceForm = false;
        //     //                     $scope.InvoiceFormback = false;
        //     //                     $scope.InvoiceSelect = true;
        //     //                 }, function () {
        //     //                     $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        //     //                 });

        //     //             });

        //     //         }
        //     //     });




        //     // }
        // }

        $scope.ssubmit = function () {
            $http({
                method: 'PUT',
                url: $rootScope.WebURL + '/salesinvoice/newupdate',
                data: {
                    _id: $scope.InvoiceID,
                    DueDate: $scope.DueDate,
                    Amount: $scope.Amount,
                    Remarks: $scope.Remarks,
                    AmountReceived: $scope.AmountReceived
                }
            }).then(function (List) {
                RefreshInvoice();
                $scope.InvoiceGrid = true;
                $scope.InvoiceForm = false;
                $scope.InvoiceFormback = false;
                $scope.InvoiceSelect = true;
                $mdToast.show($mdToast.simple().textContent('Updated Successfully !').position('top center'));
            })
        }

        $scope.ClearSearch = function () {

            $scope.searchTermc = null;
            $scope.CustomerID = null;
            $scope.vm.CustomerID = null;

        }


        $scope.SalesInvoiceInfo = function (InvoiceID, Index) {

            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = true;
            $scope.InvoiceFormback = true;
            $scope.InvoiceSelect = false;
            $scope.Update = true;

            $scope.IndexUpdate = Index;

            $scope.InvoiceID = InvoiceID;
            var item = $scope.Salesinvoicedatas.filter(function (item) {
                return item._id === InvoiceID;
            })[0];

            $scope.InvoiceNumber = item.InvoiceNumber;
            $scope.WorkOrderNo = item.SalesOrderNo
            $scope.CustomerID = item.CustomerID; $scope.WorkOrderID = item.WorkOrderID; $scope.Date = new Date(item.InvoiceDate);
            $scope.VoucherNumber = item.VoucherNumber; $scope.GSTID = item.GSTID;
            $scope.Amount = parseFloat(item.InvoiceAmount); $scope.VoucherDate = new Date(item.VoucherDate);
            $scope.CreditTerm = parseInt(item.CreditTerm); $scope.DueDate = new Date(item.DueDate); $scope.Remarks = item.Remarks;
            $scope.AmountReceived = parseFloat(item.AmountReceived)
            $scope.OutStandingAmount = parseFloat(item.OutStandingAmount)
            $scope.ConID = item.ContractID
            $scope.CustomerName = item.CustomerReference + "-" + item.CustomerName
            if (isNaN($scope.AmountReceived)) $scope.AmountReceived = 0
            if (isNaN($scope.OutStandingAmount)) $scope.OutStandingAmount = 0
            $scope.TOutStandingAmount = $scope.OutStandingAmount.toString()
            // RefreshScheduler()
            // var Conitem = $scope.contractdatas.filter(function (item) {
            //     return item.SalesOrderID === $scope.WorkOrderID;
            // })[0];

            // if (Conitem != undefined) { 
            //     $scope.ConID = Conitem._id;
            // }

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
            });

            var response1 = $http({
                url: $rootScope.WebURL + "/paymenthistory",
                method: "POST",
                data: { InvoiceID: InvoiceID },
            });
            response1.then(function (GList) {

                $scope.Paymentdatas = GList.data.data;
            });
        }

        $scope.PDeletePopup = function (id, Amount) {
            $scope.PId = id
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the payment?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/paymenthistory/delete",
                        method: "POST",
                        data: { _id: $scope.PId },
                    });
                    response.then(function (GList) {
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));
                        });
                    });
                    var ReduceAmount = parseFloat($scope.AmountReceived) - parseFloat(Amount)
                    var Outstanding = parseFloat($scope.OutStandingAmount) + parseFloat(Amount)
                    $scope.TOutStandingAmount = Outstanding.toString()
                    var Status = "Paid"
                    if (Outstanding != $scope.Amount && ReduceAmount > 0)
                        Status = "Partially Paid"
                    else if (ReduceAmount == 0) Status = "Unpaid"
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: ReduceAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.AmountReceived = ReduceAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $scope.InvoiceFilter()
                    })
                }
            });
        }

        RefreshBank();
        RefreshClientBank();

        $scope.SelectScheduler = function () {
            var item = $scope.schedulerdatas.filter(function (item) {
                return item.ServiceID === $scope.ServiceID
            })[0]
            $scope.Description = moment(item.Startsat).format('DD MMMM YYYY') + " - " + item.PestType
        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshClientBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });
        }

        function RefreshInvoice() {
            $scope.InvoiceFilter()
            // var FromDate = $scope.uFrom;
            // var ToDate = $scope.uTo;
            // var response = $http({
            //     url:  $rootScope.WebURL + "/salesinvoice/datefilter",
            //     method: "POST",
            //     data: { Start_Date: FromDate, End_Date: ToDate, Client_Id: Client_Id },
            // });
            // response.then(function (salesinvoicedata) {

            //     $scope.Salesinvoicedatas = salesinvoicedata.data.data;

            // });
        }
        function ClearInvoice() {
            $scope.CustomerID = null; $scope.WorkOrderID = null; $scope.Date = null; $scope.VoucherNumber = null;
            $scope.Amount = null; $scope.ServiceIDs = null; $scope.GSTID = null; $scope.Description = null;
            $scope.VoucherDate = null; $scope.CreditTerm = null; $scope.Remarks = null;
            $scope.ContractID = null; $scope.ConID = null;
        }
        $scope.updateCustomRequest = function (data, type, res) {

        };

        $scope.OnTopInvoiceContractChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ContractID;
            })[0];

            $scope.ConID = $scope.ContractID;
            $scope.CustomerID = item.Customer_id;
            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.OnConChange = function () {

            var item = $scope.contractdatas.filter(function (item) {
                return item._id === $scope.ConID;
            })[0];

            $scope.WorkOrderID = item.SalesOrderID;
        }

        $scope.IsAmountLoaded = false;


        GetTotalCurrentYearPayments();
        function GetTotalCurrentYearPayments() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/getTotalInvoicesByYear",
                method: "POST",
                data: { Start_Date: firstDay, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearPayments = salesinvoicedata.data.data[0].Total;
                }
                else { $scope.TotalCurrentYearPayments = 0 }


            });
        }


        $scope.CollectPaymentadd = function (e) {

            $scope.InvoicefilterByCustomer();
            $scope.IsAmountLoaded = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            ClearCollectPayment();
            $scope.Update = false;

            $scope.vm.uTo = $scope.uTo;
            $scope.vm.uFrom = $scope.uFrom;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

            var itemB = $scope.Bankdatas.filter(function (item) {
                return item.BankName === "OCBC";
            })[0];

            $scope.vm.BankID = itemB._id;

            $scope.vm.Date = new Date();
            $scope.vm.VoucherDate = new Date();

            var info = $scope.TotalCurrentYearPayments + 1;
            var y = pad(info, 6);
            var VR = "CP" + new Date().getFullYear().toString().substr(-2);
            $scope.vm.VoucherNumber = VR + y;

            $scope.CPItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


        }

        $scope.SaveCollectPayment = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/collectpayment/update",
                    data: {
                        _id: $scope.CollectPaymentID, CustomerID: $scope.vm.CustomerID,
                        Description: $scope.vm.Description, Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID, ClientBankName: $scope.vm.ClientBankName, ChequeDate: $scope.vm.ChequeDate,
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.CollectPaymentdatas[$scope.CollectPaymentIndex] = GList.data.data[0];

                    RefreshInvoice();
                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {




                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                        Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                        VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                    },
                });


                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    GetTotalCurrentYearPayments()
                    RefreshCollectPayment();
                    RefreshCustomerstatement();
                    RefreshInvoice();

                    $scope.CollectPaymentGrid = true;
                    $scope.CollectPaymentForm = false;
                    $scope.CollectPaymentFormback = false;
                    $scope.CollectPaymentSelect = true;


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }


        $scope.CollectPaymentinfo = function (CollectPaymentID, Index) {

            $scope.CollectPaymentIndex = Index;
            $scope.Salesinvoicedatasdd = $scope.Salesinvoicedatas;

            $scope.CollectPaymentID = CollectPaymentID;
            $scope.Update = true;

            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = true;

            $scope.CollectPaymentFormback = true;
            $scope.CollectPaymentSelect = false;

            var item = $scope.CollectPaymentdatas.filter(function (item) {
                return item._id === CollectPaymentID;
            })[0];

            $scope.vm.CustomerID = item.CustomerID;
            $scope.vm.BankID = item.BankID;
            $scope.vm.VoucherNumber = item.VoucherNumber;
            $scope.vm.VoucherDate = new Date(item.VoucherDate);
            $scope.vm.ChequeNumber = item.ChequeNumber;
            $scope.vm.ChequeDate = new Date(item.ChequeDate);
            $scope.vm.Description = item.Description;
            $scope.vm.Date = new Date(item.Date);
            $scope.vm.Remarks = item.Remarks;
            $scope.vm.ClientBankName = item.ClientBankName;

            $scope.CPItemDetails = item.itemDetails;

            $scope.IsAmountLoaded = true;

            $scope.HideAdd = true;
            $scope.HideSave = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item.AccountCode === "2003";
            })[0];

            $scope.DNAccountID = item._id;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;

        }

        $scope.CPItemSubmit = function () {


            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/collectpayment/add",
                data: {
                    CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, Description: $scope.vm.Description, ClientBankName: $scope.vm.ClientBankName,
                    Date: $scope.vm.Date, VoucherNumber: $scope.vm.VoucherNumber, ChequeDate: $scope.vm.ChequeDate,
                    VoucherDate: $scope.vm.VoucherDate, ChequeNumber: $scope.vm.ChequeNumber, BankID: $scope.vm.BankID, CreatedBy: $rootScope.LoginID, Remarks: $scope.vm.Remarks
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Collectpayment") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/collectpayment/getByID",
                        data: {
                            VoucherNumber: $scope.vm.VoucherNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CollectPaymentID = GList.data.data[0]._id;
                        SaveCPItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CollectPaymentID = GList.data.data.id;
                    SaveCPItems(GList.data.data.id);
                    GetTotalCurrentYearPayments()
                }

            }, function () {


            });

        }


        $scope.CPItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }

            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/UpdateItem",
                data: {
                    CollectPaymentID: $scope.CollectPaymentID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    PaidAmount: $scope.PaidAmount,
                    InvoiceAmount: parseFloat(InvoiceAmount),
                    OutStandingAmount: OutStandingAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CPItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCPItems(CollectPaymentID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasdd.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;
            var InvoiceAmount = invitem.InvoiceAmount;

            var OutStandingAmount = 0;
            if ($scope.DNAmount < parseFloat(InvoiceAmount)) {
                OutStandingAmount = invitem.InvoiceAmount - $scope.DNAmount;
            }


            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "PaidAmount": $scope.PaidAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceAmount": parseFloat(InvoiceAmount),
                "OutStandingAmount": OutStandingAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "_id": undefined
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/collectpayment/addItems",
                data: {
                    _id: CollectPaymentID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.vm.VoucherNumber,
                    InvoiceNumber: InvoiceNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Date: $scope.vm.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CPItemDetails != undefined) {
                    $scope.CPItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/collectpayment/getByID",
                    data: {
                        VoucherNumber: $scope.vm.VoucherNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CPItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CPItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CPItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.ServiceSelect = function () {
            RefreshScheduler()
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }

        $scope.CollectPaymentFilter = function () {
            $scope.CollectPaymentdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/collectpayment/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;
            });
        }
        function ClearCollectPayment() {

            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.Date = null;
            $scope.vm.ChequeDate = null;
            $scope.vm.Amount = null;
            $scope.vm.InvoiceID = null;
            $scope.vm.Description = null;
            $scope.vm.Remarks = null;
            $scope.vm.ChequeNumber = null;
            $scope.vm.VoucherNumber = null;
            $scope.vm.ClientBankName = null;
        }


        GetTotalCurrentYearCreditnotes();

        function GetTotalCurrentYearCreditnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearCreditnotes = 0
                }


            });
        }

        $scope.Creditnoteadd = function (e) {
            ClearCreditnote();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;
            $scope.Update = false;
            $scope.IsAmountLoaded = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;

            $scope.CreditNote.$setPristine();
            $scope.CreditNote.$setUntouched();

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearCreditnotes + 1;
            var y = pad(info, 6);
            var VR = "CNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "CNS" + new Date().getFullYear().toString().substr(-2);
            $scope.CreditNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;


            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }
        function ClearCreditnote() {

            $scope.RefrenceNumber = null
            $scope.InvoiceID = null;
            $scope.AccountID = null
            $scope.Description = null
            $scope.Amount = null
            $scope.GSTID = null
            $scope.Remarks = null;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveCreditnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salescreditnote/update",
                    data: {
                        _id: $scope.CreditnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshInvoice();
                    RefreshCustomerstatement();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        CreditNoteNumber: $scope.CreditNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearCreditnotes();
                    RefreshCreditnote();

                    $scope.CreditnoteGrid = true;
                    $scope.CreditnoteForm = false;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Creditnoteinfo = function (CreditnoteID, index) {


            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = true;

            $scope.CreditnoteID = CreditnoteID;
            $scope.Update = true;

            var item = $scope.Creditnotedatas.filter(function (item) {
                return item._id === CreditnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)

            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.CreditNoteNumber = item.CreditNoteNumber
            $scope.CNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }


        $scope.ClearCNItems = function () {
            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        $scope.CNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salescreditnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales credit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salescreditnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveCNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveCNItems(GList.data.data.id);
                    GetTotalCurrentYearCreditnotes();
                }

            }, function () {


            });

        }


        $scope.CNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/UpdateItem",
                data: {
                    CreditnoteID: $scope.CreditnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.CNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveCNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salescreditnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    CreditNoteNumber: $scope.CreditNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.CNItemDetails != undefined) {
                    $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salescreditnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.CNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.CNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.CNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }

        function RefreshCreditnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });


        }

        $scope.CreditnoteFilter = function () {
            $scope.Creditnotedatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/salescreditnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (creditnotedata) {
                $scope.Creditnotedatas = creditnotedata.data.data;
            });
        }

        $scope.CreditnoteShowgrid = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridCollectPayment = function () {
            $scope.InvoiceSelect = false;
            $scope.InvoiceGrid = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteSelect = false;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;


        }
        function ClearCreditnote() {
            $scope.RefrenceNumber = null;
            $scope.VoucherDate = null;
            $scope.InvoiceID = null;
            $scope.Date = null;
            $scope.AccountID = null;
            $scope.Description = null;
            $scope.Amount = null;
            $scope.GSTID = null;
            $scope.Remarks = null;
        }

        RefreshGST();
        RefreshChartofAccount();

        RefreshContract();


        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {

                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshContract() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (contractdata) {
                $scope.contractdatas = contractdata.data.data;

            });
        }
        function RefreshScheduler() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getBySalesOrder",
                data: {
                    SalesOrderId: $scope.WorkOrderID,
                },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/getforinvoice",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }
        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getByCustomer",
                data: {
                    CustomerId: $scope.CustomerID
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }
        $scope.Datefilter = function () {
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (GList) {

                $scope.schedulerdatas = GList.data.data;
            });
        }

        function RefreshDescription() {

            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/getByInvoice",
                method: "POST",
                data: { InvoiceNumber: $scope.InvoiceNumber },
            });
            response.then(function (GList) {

                $scope.Descriptiondatas = GList.data.data;
                // DeleteDescription();
            });
        }
        function DeleteDescription() {

            try {
                $scope.ServiceIDs = $scope.ServiceID.map(function (obj) { return obj.ServiceID; }).join(',');
            } catch (error) {

            }

            angular.forEach($scope.Descriptiondatas, function (value, key) {

                if (aContainsB($scope.ServiceIDs.trim(), value.ServiceReportNo.trim())) {

                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: value._id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                    });
                }

            });
        }
        $scope.DeletePopup = function (ID) {
            $scope.Id = ID
            var result = DevExpress.ui.dialog.confirm("Are you sure you want to delete the description?", "Confirm changes");
            result.done(function (dialogResult) {
                if (dialogResult) {
                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/delete",
                        method: "POST",
                        data: { _id: $scope.Id },
                    });
                    response.then(function (GList) {
                        RefreshDescription();
                        $mdToast.show($mdToast.simple().textContent('Deleted Successfully !').position('top center'));

                    });
                }
            });
        }


        function aContainsB(a, b) {
            return a.indexOf(b) >= 0;
        }

        $scope.EnableDescription = function (DescID, ServiceReportNo) {
            $scope.Desc = false;
            $scope.textbar = true;
            $scope.ServiceReportNo = ServiceReportNo;
            $scope.DescID = DescID;

            var item = $scope.Descriptiondatas.filter(function (item) {
                return item._id === DescID;
            })[0];

            if (item != undefined) {
                $scope.Description = item.Description
                $scope.ServiceID = $scope.ServiceReportNo
            }

        }
        $scope.DescriptionSubmit = function () {
            var response = $http({
                url: $rootScope.WebURL + "/invoicecomment/update",
                method: "PUT",
                data: { _id: $scope.DescID, ServiceReportNo: $scope.ServiceID, Description: $scope.Description },
            });
            response.then(function (GList) {
                RefreshDescription();
                $scope.Description = null;
                $scope.Desc = true;
            });
        }

        $scope.AddPayment = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/casheInvoice/addvehiclelogs.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: false,
                controller: function cashInvoiceController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Date = new Date()
            $scope.vm.Amount = 0
        }

        $scope.SubmitPayment = function () {
            var TotalAmount = parseFloat($scope.vm.Amount) + parseFloat($scope.AmountReceived)
            if (TotalAmount > $scope.Amount)
                $mdToast.show($mdToast.simple().textContent('Amount Paid is greater than Invoice Amount!').position('top center'));
            else {
                var Outstanding = parseFloat($scope.Amount) - TotalAmount
                $scope.TOutStandingAmount = Outstanding.toString()
                var Status = "Paid"
                if (Outstanding != $scope.Amount && TotalAmount > 0)
                    Status = "Partially Paid"
                else if (TotalAmount == 0) Status = "Unpaid"
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + '/paymenthistory/add',
                    data: {
                        InvoiceID: $scope.InvoiceID,
                        Amount: $scope.vm.Amount,
                        Date: $scope.vm.Date,
                        Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.createdby
                    }
                }).then(function (List) {
                    $http({
                        method: "PUT",
                        url: $rootScope.WebURL + '/salesinvoice/updatepayment',
                        data: {
                            _id: $scope.InvoiceID,
                            AmountReceived: TotalAmount,
                            OutStandingAmount: Outstanding,
                            Status: Status,
                            CreatedBy: $rootScope.createdby
                        }
                    }).then(function (GList) {
                        $scope.InvoiceFilter()
                        $scope.AmountReceived = TotalAmount
                        $scope.OutStandingAmount = Outstanding
                        $scope.Status = Status
                        $mdDialog.cancel()
                        var response1 = $http({
                            url: $rootScope.WebURL + "/paymenthistory",
                            method: "POST",
                            data: { InvoiceID: $scope.InvoiceID },
                        });
                        response1.then(function (GList) {
                            $mdDialog.cancel()
                            $scope.Paymentdatas = GList.data.data;
                            $mdToast.show($mdToast.simple().textContent('Payment Added Successfully!').position('top center'));
                        });
                    })
                })
            }

        }

        var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        $scope.OnWorkOrderChange = function () {

            var myArray = $scope.ServiceID;

            if (myArray == undefined) {
                $scope.ServiceIDs = "null";
                RefreshDescription();
            }


            var BillingAmount = 0;
            angular.forEach(myArray, function (value, key) {

                var Description = "Being Inspection and Treatment carried out for the control of";

                try {
                    Description = "Being Inspection and Treatment carried out for the control of " + monthNames[new Date(value.Startsat).getMonth()] + " " + new Date(value.Startsat).getFullYear()

                } catch (error) {

                }

                if (value.BillingAmount != undefined) {
                    BillingAmount = BillingAmount + parseFloat(value.BillingAmount);

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: value.BillingAmount },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }
                else {

                    var response = $http({
                        url: $rootScope.WebURL + "/invoicecomment/add",
                        method: "POST",
                        data: { InvoiceNumber: $scope.InvoiceNumber, ServiceReportNo: value.ServiceID, Description: Description, Amount: 0 },
                    });
                    response.then(function (GList) {

                        RefreshDescription();
                    });
                }

            });





            $scope.Amount = BillingAmount;




            // var myArray = $scope.ServiceID;

            // var item = myArray.filter(function (item) {
            //     return item._id === $scope.WorkOrderID;
            // })[0];

            // var TotalOrderValue = item.TotalOrderValue;
            // var TotalServices = $scope.ServiceID;
            // $scope.Amount = Math.round(TotalOrderValue / (TotalServices.length), 2);

        }
        $scope.OnInvoiceChange = function () {



            if ($scope.IsAmountLoaded == false) {

                var InvoiceID = $scope.vm.InvoiceID;
                var TotalAmount = 0;
                angular.forEach(InvoiceID, function (value, key) {

                    TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);


                    // var item = $scope.GSTdatas.filter(function (item) {
                    //     return item.id === value.GSTID;
                    // })[0]; 

                    // if(item!=undefined){

                    //     if (value.Status == "Partial") { 

                    //         var Amt=TotalAmount + parseFloat(value.OutStandingAmount); 

                    //         TotalAmount=Amt + (parseFloat((Amt / 100) * parseFloat(item.TaxRate))); 
                    //     }
                    //     else { 
                    //        // TotalAmount = TotalAmount + parseFloat(value.Amount);
                    //         TotalAmount = parseFloat(TotalAmount) + parseFloat(value.Amount) + (parseFloat((value.Amount / 100) * parseFloat(item.TaxRate)));
                    //     }  

                    // }
                    //else{
                    // if (value.Status == "Partial") {
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount); 
                    // }
                    // else { 
                    //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);
                    // } 
                    // }

                });
                $scope.vm.Amount = TotalAmount;
            }

        }

        $scope.OnCNInvoiceChange = function () {


            // if($scope.IsAmountLoaded == false) {
            // var InvoiceID = $scope.InvoiceID;
            // var TotalAmount = 0;
            // angular.forEach(InvoiceID, function (value, key) {

            //     TotalAmount = TotalAmount + parseFloat(value.OutStandingAmount);

            // }); 
            // $scope.Amount = TotalAmount;
            //  }
        }
        $scope.OnCustomerChange = function () {

            var myArray = $scope.Customerdatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.CustomerID;
            })[0];

            if (item.CreditTerm != undefined) {

                $scope.CreditTerm = parseInt(item.CreditTerm);
            }
            else {
                $scope.CreditTerm = 0;
            }

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }


            RefreshSalesOrder()
        }

        $scope.OnVoucherDateChange = function () {
            $scope.Date = $scope.VoucherDate;
            if ($scope.CreditTerm != null || $scope.CreditTerm != undefined) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
            else {
                $scope.DueDate = $scope.VoucherDate;
            }
        }

        $scope.OnInvoiceDateChange = function () {
            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCreditTermChange = function () {

            if ($scope.Date != null && ($scope.CreditTerm != null || $scope.CreditTerm != undefined)) {
                var newdate = new Date($scope.Date)
                newdate.setDate(newdate.getDate() + $scope.CreditTerm);
                $scope.DueDate = newdate;
            }
        }

        $scope.OnCSStatusChange = function () {

            if ($scope.CSStatus == 'ShowAll') {

                $scope.Customerstatementdatas = $scope.Customerstatementalldatas;
            } else {

                if ($scope.Customerstatementalldatas != undefined) {
                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === $scope.CSStatus;
                    });
                    $scope.Customerstatementdatas = item;
                }

            }
        }



        function RefreshCustomerstatement() {
            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.RefreshCustomers = function () {
            $scope.Customerstatementdatas = undefined;

            if ($scope.FilterByCustomer == true) {

                if ($scope.CusID == undefined) {

                    $mdToast.show($mdToast.simple().textContent('Please Select Customer & Click Search!').position('top center'));

                    $scope.Customerstatementdatas = [];
                }
                else {
                    var response = $http({
                        url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                        method: "POST",
                        data: { CustomerID: $scope.CusID },
                    });
                    response.then(function (Customerstatementdata) {
                        $scope.Customerstatementdatas = Customerstatementdata.data.data;
                        $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                        var item = $scope.Customerstatementalldatas.filter(function (item) {
                            return item.Status === 'Unpaid';
                        });
                        $scope.Customerstatementdatas = item;
                    });
                }
            }
            else {
                var response = $http({
                    url: $rootScope.WebURL + "/customerstatement/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
                });
                response.then(function (Customerstatementdata) {
                    $scope.Customerstatementdatas = Customerstatementdata.data.data;
                    $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                    var item = $scope.Customerstatementalldatas.filter(function (item) {
                        return item.Status === 'Unpaid';
                    });
                    $scope.Customerstatementdatas = item;
                });
            }

        }

        $scope.Filter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/getbyCustomerID",
                method: "POST",
                data: { CustomerID: $scope.CusID },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });
        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        GetTotalCurrentYearDebitnotes();

        function GetTotalCurrentYearDebitnotes() {

            var firstDay = new Date(new Date().getFullYear(), 0, 1);
            firstDay.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/getTotalInvoicesByYear",
                method: "POST",
                data: {
                    Start_Date: firstDay,
                    End_Date: $scope.uTo,
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesinvoicedata) {

                if (salesinvoicedata.data.data.length > 0) {

                    $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
                } else {
                    $scope.TotalCurrentYearDebitnotes = 0
                }


            });
        }

        $scope.Debitnoteadd = function (e) {

            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;

            $scope.DebitnoteSelect = false;

            $scope.VoucherDate = new Date();
            $scope.Date = new Date();

            var info = $scope.TotalCurrentYearDebitnotes + 1;
            var y = pad(info, 6);
            var VR = "DNSV" + new Date().getFullYear().toString().substr(-2);
            $scope.RefrenceNumber = VR + y;

            var VR = "DNS" + new Date().getFullYear().toString().substr(-2);
            $scope.DebitNoteNumber = VR + y;

            $scope.CNItemDetails = [];

            $scope.HideAdd = true;
            $scope.HideSave = false;
            $scope.Update = false;

            $scope.DNInvoiceID = undefined;
            $scope.DNAmount = undefined;
            $scope.DNAccountID = undefined;
            $scope.DNGSTID = undefined;

            $scope.Description = undefined;
            $scope.Remarks = undefined;

            var taxitem = $scope.GSTdatas.filter(function (item) {
                return item.GSTTaxCode === "TX7";
            })[0];

            $scope.DNGSTID = taxitem._id;
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        $scope.SaveDebitnote = function () {

            if ($scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/salesdebitnote/update",
                    data: {
                        _id: $scope.DebitnoteID,
                        CustomerID: $scope.vm.CustomerID,
                        VoucherDate: $scope.VoucherDate,
                        RefrenceNumber: $scope.RefrenceNumber,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    // $scope.Creditnotedatas[$scope.CreditnoteIndex] = GList.data.data[0];
                    RefreshDebitnote();

                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID,
                        RefrenceNumber: $scope.RefrenceNumber,
                        VoucherDate: $scope.VoucherDate,
                        Client_Id: Client_Id,
                        Description: $scope.Description,
                        DebitNoteNumber: $scope.DebitNoteNumber,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    GetTotalCurrentYearDebitnotes();
                    RefreshDebitnote();
                    $scope.DebitnoteGrid = true;
                    $scope.DebitnoteForm = false;
                    $scope.DebitnoteSelect = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Debitnoteinfo = function (DebitnoteID, index) {

            $scope.DebitnoteID = DebitnoteID;
            $scope.Update = true;
            $scope.CreditnoteIndex = index;
            $scope.Salesinvoicedatasddf = $scope.Salesinvoicedatas;
            $scope.DebitnoteGrid = false;
            $scope.DebitnoteForm = true;

            $scope.DebitnoteSelect = false;
            $scope.DebitnoteID = DebitnoteID;

            var item = $scope.Debitnotedatas.filter(function (item) {
                return item._id === DebitnoteID;
            })[0];

            $scope.RefrenceNumber = item.RefrenceNumber
            $scope.VoucherDate = new Date(item.VoucherDate)


            $scope.Date = new Date(item.Date)
            $scope.Description = item.Description
            $scope.Remarks = item.Remarks
            $scope.vm.CustomerID = item.CustomerID
            $scope.DebitNoteNumber = item.DebitNoteNumber
            $scope.DNItemDetails = item.itemDetails
            $scope.HideAdd = true;
            $scope.HideSave = false;

        }

        function RefreshDebitnote() {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }

        $scope.DebitnoteFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/salesdebitnote/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Debitnotedata) {
                $scope.Debitnotedatas = Debitnotedata.data.data;
            });
        }


        $scope.DNItemSubmit = function () {


            var Status = "Adjust";
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesdebitnote/add",
                data: {
                    CustomerID: $scope.vm.CustomerID,
                    Client_Id: Client_Id,
                    RefrenceNumber: $scope.RefrenceNumber,
                    VoucherDate: $scope.VoucherDate,
                    Description: $scope.Description,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    Date: $scope.Date,
                    Status: Status,
                    Remarks: $scope.Remarks,
                    CreatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {

                if (GList.data.message == "Existing Sales debit note") {


                    var responses = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/salesdebitnote/getByID",
                        data: {
                            VoucherNumber: $scope.RefrenceNumber,
                            Client_Id: Client_Id
                        },
                    });

                    responses.then(function (GList) {
                        $scope.CreditnoteID = GList.data.data[0]._id;
                        SaveDNItems(GList.data.data[0]._id);
                    })
                } else {
                    $scope.CreditnoteID = GList.data.data.id;
                    SaveDNItems(GList.data.data.id);
                    GetTotalCurrentYearDebitnotes();
                }

            }, function () {


            });

        }


        $scope.DNItemUpdate = function () {


            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode

            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }
            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;


            var responses = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/UpdateItem",
                data: {
                    DebitnoteID: $scope.DebitnoteID,
                    ItemID: $scope.ItemID,
                    AccountID: $scope.DNAccountID,
                    AccountCode: AccountCode,
                    AccountDescription: AccountDescription,
                    Amount: $scope.DNAmount,
                    TaxAmount: $scope.DNTaxAmount,
                    GSTID: $scope.DNGSTID,
                    GSTCode: GSTCode,
                    InvoiceNumber: InvoiceNumber,
                    InvoiceID: $scope.DNInvoiceID,
                    VoucherNumber: $scope.RefrenceNumber,
                    PaidAmount: $scope.PaidAmount
                },
            });

            responses.then(function (GList) {

                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;
                $scope.HideAdd = true;
                $scope.HideSave = false;

                if (GList.data.data != null) {
                    $scope.DNItemDetails = GList.data.data.itemDetails;
                }


                RefreshInvoice();

            })

        }

        function SaveDNItems(DebitNoteID) {


            $scope.itemDetails = [];

            var item = $scope.ChartofAccountatas.filter(function (item) {
                return item._id === $scope.DNAccountID;
            })[0];

            var AccountCode = item.AccountCode;
            var AccountDescription = item.AccountDescription;

            var gstitem = $scope.GSTdatas.filter(function (gstitem) {
                return gstitem._id === $scope.DNGSTID;
            })[0];

            var GSTCode = gstitem.GSTTaxCode


            var TaxRate = 0;
            if (gstitem.TaxRate != null) {
                TaxRate = gstitem.TaxRate;
            }

            $scope.PaidAmount = parseFloat($scope.DNAmount);
            $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
            $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

            var invitem = $scope.Salesinvoicedatasddf.filter(function (invitem) {
                return invitem._id === $scope.DNInvoiceID;
            })[0];

            var InvoiceNumber = invitem.InvoiceNumber;

            $scope.itemDetails.push({
                "Amount": $scope.DNAmount,
                "TaxAmount": $scope.DNTaxAmount,
                "InvoiceID": $scope.DNInvoiceID,
                "AccountID": $scope.DNAccountID,
                "AccountCode": AccountCode,
                "AccountDescription": AccountDescription,
                "GSTID": $scope.DNGSTID,
                "GSTCode": GSTCode,
                "InvoiceNumber": InvoiceNumber,
                "PaidAmount": $scope.PaidAmount
            })


            var TransactionDescription = "";
            try {
                var myArray2 = $scope.Customerdatas;
                var item2 = myArray2.filter(function (item2) {
                    return item2.id === $scope.vm.CustomerID;
                })[0];
                TransactionDescription = item2.CustomerReference + '-' + item2.CompanyName;
            } catch (error) {

            }

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/salesdebitnote/addItems",
                data: {
                    _id: DebitNoteID,
                    itemDetails: $scope.itemDetails,
                    Client_Id: Client_Id,
                    TransactionDescription: TransactionDescription,
                    VoucherNumber: $scope.RefrenceNumber,
                    DebitNoteNumber: $scope.DebitNoteNumber,
                    CustomerID: $scope.vm.CustomerID,
                    InvoiceID: $scope.DNInvoiceID,
                    Amount: $scope.DNAmount,
                    Date: $scope.Date,
                    CreatedBy: $rootScope.createdby
                },
            })
            response.then(function (GList) {


                $scope.DNInvoiceID = undefined;
                $scope.DNAmount = undefined;
                $scope.DNAccountID = undefined;
                $scope.DNGSTID = undefined;

                if ($scope.DNItemDetails != undefined) {
                    $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
                }

                $scope.HideAdd = true;
                $scope.HideSave = false;

                var responses = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/salesdebitnote/getByID",
                    data: {
                        VoucherNumber: $scope.RefrenceNumber,
                        Client_Id: Client_Id
                    },
                });

                responses.then(function (GList) {

                    $scope.DNItemDetails = GList.data.data[0].itemDetails;
                })

                RefreshInvoice();

            });

        }

        $scope.DNItemInfo = function (ItemID) {


            $scope.ItemID = ItemID;
            var item = $scope.DNItemDetails.filter(function (item) {
                return item._id === ItemID;
            })[0];
            $scope.DNAmount = 0;
            if (item.Amount != null) {
                $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
                // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
            }


            $scope.DNInvoiceID = item.InvoiceID;
            $scope.DNAccountID = item.AccountID;
            $scope.DNGSTID = item.GSTID;

            $scope.HideAdd = false;
            $scope.HideSave = true;
        }


        $scope.Showgrid = function () {
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceGrid = true;
            $scope.InvoiceForm = false;
            $scope.InvoiceSelect = true;
            $scope.InvoiceFormback = false;

            $scope.CollectPaymentFormback = false;
        }

        $scope.ShowgridDebit = function () {

            $scope.DebitnoteSelect = true;
            $scope.DebitnoteGrid = true;
            $scope.DebitnoteForm = false;
            $scope.CollectPaymentFormback = false;
        }

        $scope.InvoicefilterByCustomer = function () {


            $scope.vm.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.vm.uFrom;
            var ToDate = $scope.vm.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });

            response.then(function (salesinvoicedata) {

                var myArray = salesinvoicedata.data.data;

                var item = myArray.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                $scope.Salesinvoicedatasdd = item;
            });
        };

        $scope.InvoicefilterByCustomerform = function () {


            $scope.InvoiceID = null;
            var CustomerID = $scope.vm.CustomerID;
            var FromDate = $scope.uFrom;
            var ToDate = $scope.uTo;


            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice/filterByCustomer",
                method: "POST",
                data: { Start_Date: FromDate, End_Date: ToDate, CustomerID: CustomerID },
            });
            response.then(function (salesinvoicedata) {
                $scope.Salesinvoicedatasddf = salesinvoicedata.data.data;

                var item = $scope.Salesinvoicedatasddf.filter(function (item) {
                    return item.Status !== "Paid" && parseFloat(item.OutStandingAmount) > 0;
                });

                var item2 = item.filter(function (item) {
                    return item.Status !== "Adjust" && parseFloat(item.OutStandingAmount) > 0;
                });
                $scope.Salesinvoicedatasddf = item2;
            });


        };

        $scope.InvoiceExport = function () {
            alasql('SELECT * INTO XLSX("Invoice.xlsx",{headers:true}) FROM ?', [$scope.Salesinvoicedatas]);
        };
        $scope.CollectPaymentExport = function () {
            alasql('SELECT * INTO XLSX("CollectPayment.xlsx",{headers:true}) FROM ?', [$scope.CollectPaymentdatas]);
        };
        $scope.CreditnoteExport = function () {
            alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
        };
        $scope.DebitnoteExport = function () {
            alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
        };
        $scope.CustomerStatementExport = function () {
            alasql('SELECT * INTO XLSX("CustomerStatement.xlsx",{headers:true}) FROM ?', [$scope.Customerstatementdatas]);
        };


        $scope.Printsalesinvoice = function (CreditnoteID) {
            var url = $rootScope.ReportURL + "SalesInvoice.aspx?ID=" + CreditnoteID;
            window.open(url);
        }


        $scope.getTotal = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.Amount);
                });

                return total.toFixed(2);
            } else {
                0
            }
        }
        $scope.getAccountCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var AccountCode = itemDetails.map(function (obj) {
                    return obj.AccountCode;
                }).join(',');
                return AccountCode;
            } else {
                return null;
            }
        }

        $scope.getGSTCode = function (itemDetails) {

            if (itemDetails != undefined) {
                var GSTCode = itemDetails.map(function (obj) {
                    return obj.GSTCode;
                }).join(',');
                return GSTCode;
            } else {
                return null;
            }
        }
        $scope.getInvoiceNumber = function (itemDetails) {

            if (itemDetails != undefined) {
                var InvoiceNumber = itemDetails.map(function (obj) {
                    return obj.InvoiceNumber;
                }).join(',');
                return InvoiceNumber;
            } else {
                return null;
            }
        }


        $scope.getTotalInvoiceAmount = function (itemDetails) {

            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.InvoiceAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }
        $scope.getTotalOutStandingAmount = function (itemDetails) {
            var total = 0;

            if (itemDetails != undefined) {
                angular.forEach(itemDetails, function (value) {
                    total = total + parseFloat(value.OutStandingAmount);
                });

                return total.toFixed(2);
            } else {
                return 0
            }
        }



        vm.dtOptions = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            stateSave: true,
            destroy: true,
            bProcessing: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        vm.dtOptions1 = {

            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.InvoiceTab = function () {
            $scope.InvoiceSelect = true;
            $scope.InvoiceGrid = true;

            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };

        $scope.CollectPaymentTab = function () {
            RefreshCollectPayment();
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceSelect = false;
            $scope.InvoiceForm = false;
            $scope.CollectPaymentSelect = true;
            $scope.CreditnoteSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = true;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.CreditnoteTab = function () {
            RefreshCreditnote();
            $scope.InvoiceSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CreditnoteGrid = true;
            $scope.CreditnoteForm = false;
            $scope.InvoiceForm = false;
            $scope.CustomerStatementSelect = false;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.DebitnoteForm = false;
            $scope.SearchValue = "";
        };
        $scope.DebitnoteTab = function () {
            RefreshDebitnote();
            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = true;
            $scope.CollectPaymentSelect = false;
            $scope.InvoiceForm = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = false;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.DebitnoteGrid = true;
            $scope.InvoiceFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.CollectPaymentFormback = false;
            $scope.SearchValue = "";
        };
        $scope.CustomerStatementTab = function () {

            var response = $http({
                url: $rootScope.WebURL + "/customerstatement/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Customerstatementdata) {
                $scope.Customerstatementdatas = Customerstatementdata.data.data;
                $scope.Customerstatementalldatas = Customerstatementdata.data.data;

                var item = $scope.Customerstatementalldatas.filter(function (item) {
                    return item.Status === 'Unpaid';
                });
                $scope.Customerstatementdatas = item;
            });


            $scope.InvoiceSelect = false;
            $scope.DebitnoteSelect = false;
            $scope.CollectPaymentSelect = false;
            $scope.CreditnoteSelect = false;
            $scope.CustomerStatementSelect = true;
            $scope.CreditnoteGrid = false;
            $scope.CreditnoteForm = false;
            $scope.InvoiceFormback = false;
            $scope.DebitnoteForm = false;
            $scope.InvoiceForm = false;

            $scope.CollectPaymentFormback = false;
            $scope.CollectPaymentGrid = false;
            $scope.CollectPaymentForm = false;
            $scope.SearchValue = "";
        };

        $scope.Today = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            $scope.uFrom = new Date();
            $scope.uTo = new Date();
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();

        }

        $scope.lastweek = function () {
            $scope.YettoStartdatas = undefined;
            $scope.InProgressdatas = undefined;
            $scope.Completeddatas = undefined;
            $scope.SelectedIds = [];
            $scope.Selec = { value: false }
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = new Date(from);
            $scope.uTo = new Date(to);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        $scope.lastmonth = function () {

            $scope.uFrom = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 0)
            $scope.uTo = new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);

            $scope.InvoiceFilterByDate();
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        var now = new Date();
        $scope.minDate = new Date(
            now.getFullYear() - 5,
            now.getMonth(),
            now.getDate()
        );


        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $mdDateLocale.parseDate = function (dateString) {
            var m = moment(dateString, 'D.M.YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }


})();

(function () {
    'use strict';

    angular
        .module('app.accounts.scheduler', ['ui.bootstrap'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_scheduler', {
            url: '/Acscheduler',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/scheduler/scheduler.html',
                    controller: 'AcoperationsProjectController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/operations/scheduler');
    }

})();
(function () {

  'use strict';
  angular
    .module('app.accounts.scheduler')
    .directive('starRating', function () {
      return {
        scope: {
          rating: '=',
          maxRating: '@',
          readOnly: '@',
          click: "&",
          mouseHover: "&",
          mouseLeave: "&"
        },
        restrict: 'EA',
        template:
          "<div style='display: inline-block; margin: 0px; padding: 0px; cursor:pointer;' ng-repeat='idx in maxRatings track by $index'> \
                  <img ng-src='{{((hoverValue + _rating) <= $index) && \"https://www.codeproject.com/script/ratings/images/star-empty-lg.png\" || \"https://www.codeproject.com/script/ratings/images/star-fill-lg.png\"}}' \
                  ng-Click='isolatedClick($index + 1)' \
                  ng-mouseenter='isolatedMouseHover($index + 1)' \
                  ng-mouseleave='isolatedMouseLeave($index + 1)'></img> \
          </div>",
        compile: function (element, attrs) {
          if (!attrs.maxRating || (Number(attrs.maxRating) <= 0)) {
            attrs.maxRating = '5';
          };
        },
        controller: function ($scope, $element, $attrs) {
          $scope.maxRatings = [];
          for (var i = 1; i <= $scope.maxRating; i++) {
            $scope.maxRatings.push({});
          };
          $scope._rating = $scope.rating;
          $scope.isolatedClick = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope.rating = $scope._rating = param;
            $scope.hoverValue = 0;
            $scope.click({
              param: param
            });
          };
          $scope.isolatedMouseHover = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = 0;
            $scope.hoverValue = param;
            $scope.mouseHover({
              param: param
            });
          };
          $scope.isolatedMouseLeave = function (param) {
            if ($scope.readOnly == 'true') return;
            $scope._rating = $scope.rating;
            $scope.hoverValue = 0;
            $scope.mouseLeave({
              param: param
            });
          };
        }
      };
    })
    .directive('ngMouseWheelUp', function () {
      return function ($scope, element, attrs) {
        element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

          // cross-browser wheel delta
          var event = window.event || event; // old IE support
          var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

          if (delta > 0) {
            $scope.$apply(function () {
              $scope.$eval(attrs.ngMouseWheelUp);
            });

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if (event.preventDefault) event.preventDefault();
          }
        });
      };
    })
    .directive('ngMouseWheelDown', function () {
      return function ($scope, element, attrs) {
        element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

          // cross-browser wheel delta
          var event = window.event || event; // old IE support
          var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

          if (delta < 0) {
            $scope.$apply(function () {
              $scope.$eval(attrs.ngMouseWheelDown);
            });

            // for IE
            event.returnValue = false;
            // for Chrome and Firefox
            if (event.preventDefault) event.preventDefault();
          }
        });
      };
    })
    .controller('AcoperationsProjectController', AcoperationsProjectController);
  /** @ngInject */
  function AcoperationsProjectController($scope, $rootScope, socket, $interval, $mdSidenav, $filter, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document, $window, NgMap, $locale, Upload) {
    document.getElementsByTagName('title')[0].text = "Accounts-Scheduler"
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("AcScheduler")) {   // do nothing 
    }
    else { window.location = 'NoAccess'; }
    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log('markers', map.markers);
      console.log('shapes', map.shapes);
    });
    $scope.click1 = function (param) {
      console.log('Click(' + param + ')');
    };
    $scope.CustomeScheduler = false
    var vm = this

    $scope.vm.AStartTime = new Date()
    $scope.vm.AEndTime = new Date()

    var today = new Date()
    $scope.uFrom = new Date(today);
    $scope.uTo = new Date(today);

    $scope.Exportdata = function () {
      var promises = [];
      var data = [];
      if ($scope.vm.SelectedTab == 'In-Progress') {
        data = $scope.MobileInProgressdatas;
      }
      else if ($scope.vm.SelectedTab == 'Outstanding') {
        data = $scope.InProgressdatas;
      }
      else if ($scope.vm.SelectedTab == 'Completed') {
        data = $scope.Completeddatas;
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        data = $scope.PendingApprovaldatas;
      }
      else if ($scope.vm.SelectedTab == 'Ad-hoc') {
        data = $scope.AdhocJobsdatas;
      }
      else if ($scope.vm.SelectedTab == 'Cancelled') {
        data = $scope.Cancelleddatas;
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        data = $scope.PendingScheduledatas;
      }
      else {
        data = $scope.YettoStartdatas;
      }
      var array = [];
      if ($scope.vm.SelectedTab == 'Completed') {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
            data: { _id: value._id },
          }).then(function (tabletschedulerrecord) {
            try {
              var item = tabletschedulerrecord.data.data[0];
              var uitem = [];
              uitem = $scope.Userdatas.filter(function (uitem) {
                return uitem.UserID == item.CreatedBy
              })[0];
              value.InProgressedBy = uitem.EmployeeID;
            }
            catch (e) { }
            try {
              var ContractNo = "";
              if (value.Contracterdetails.length > 0) {
                ContractNo = value.Contracterdetails[0].ContractReferenceNo;
              }
              var CustomerName = "";
              if (value.customerdetails.length > 0) {
                CustomerName = value.customerdetails[0].CompanyName;
              } else { CustomerName = value.AdhocCustomerName; }
              array.push({
                ServiceID: value.ServiceID,
                CustomerName: CustomerName,
                Address: value.customerServicedetails[0].sBLK + ',' + value.customerServicedetails[0].sStreetName,
                ContactPerson: value.ContactPerson,
                SalesOrderNo: value.JobOrdersdetails[0].SalesOrderNo,
                ContractNo: ContractNo,
                TeamName: value.teamdetails[0].TeamName,
                TeamLead: value.teamdetails[0].TeamLead,
                TeamMembers: value.teamdetails[0].TeamMembers,
                PestType: value.PestType,
                Frequency: value.Frequency,
                Status: value.Status,
                Day: $filter('date')(value.Startsat, 'EEEE'),
                ServiceDate: $filter('date')(value.Startsat, 'dd/MM/yyyy'),
                StartTime: $filter('date')(value.Startsat, 'hh:mm a'),
                EndTime: $filter('date')(value.Endsat, 'hh:mm a'),
                ActualStartTime: $filter('date')(item.Startsat, 'hh:mm a'),
                ActualEndTime: $filter('date')(item.Endsat, 'hh:mm a'),
                JobPerformedBy: value.InProgressedBy,
                CreatedBy: value.CreatedBy,
                CreatedDate: $filter('date')(value.CreateDate, 'dd/MM/yyyy'),
              })
            }
            catch (e) { }
            deferred.resolve(data);
          });
          promises.push(deferred.promise);
        });
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          try {
            array.push({
              CustomerName: value.customerdetails[0].CompanyName,
              SalesOrderNo: value.SalesOrderNo,
              PestType: value.PestType,
              DateTimeofTreatment: value.DateTimeofTreatment,
              EstimatedHoursRequired: value.EstimatedHoursRequired,
              Urgent: value.Urgent = true ? "Yes" : "No",
              CreatedBy: value.CreatedBy,
              CreatedDate: $filter('date')(value.CreatedDate, 'dd/MM/yyyy'),
            })
          }
          catch (e) {

          }
          deferred.resolve(data);
          promises.push(deferred.promise);
        });
      }
      else {
        angular.forEach(data, function (value) {
          var deferred = $q.defer();
          try {
            var ContractNo = "";
            if (value.Contracterdetails.length > 0) {
              ContractNo = value.Contracterdetails[0].ContractReferenceNo;
            }
            var CustomerName = "";
            if (value.customerdetails.length > 0) {
              CustomerName = value.customerdetails[0].CompanyName;
            } else { CustomerName = value.AdhocCustomerName; }
            array.push({
              ServiceID: value.ServiceID,
              CustomerName: CustomerName,
              Address: value.customerServicedetails[0].sBLK + ',' + value.customerServicedetails[0].sStreetName,
              ContactPerson: value.ContactPerson,
              SalesOrderNo: value.JobOrdersdetails[0].SalesOrderNo,
              ContractNo: ContractNo,
              TeamName: value.teamdetails[0].TeamName,
              TeamLead: value.teamdetails[0].TeamLead,
              TeamMembers: value.teamdetails[0].TeamMembers,
              PestType: value.PestType,
              Frequency: value.Frequency,
              Status: value.Status,
              Day: $filter('date')(value.Startsat, 'EEEE'),
              ServiceDate: $filter('date')(value.Startsat, 'dd/MM/yyyy'),
              StartTime: $filter('date')(value.Startsat, 'hh:mm a'),
              EndTime: $filter('date')(value.Startsat, 'hh:mm a'),
              CreatedBy: value.CreatedBy,
              CreatedDate: $filter('date')(value.CreateDate, 'dd/MM/yyyy'),
            })
          }
          catch (e) {

          }
          deferred.resolve(data);
          promises.push(deferred.promise);
        });
      }
      $q.all(promises).then(
        function (results) {
          alasql('SELECT * INTO XLSX("Schedulerdatas.xlsx",{headers:true}) FROM ?', [array]);
        },
        function (response) {
        }
      );
    }
    $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];

    $scope.vm.cdate = new Date().setHours(23, 59, 59, 999);
    $scope.pesttypeGrid = true;
    $scope.exportbtn = true;
    $scope.shedulerform = false;
    $scope.addbtn = true;
    $scope.viewbtn = false;
    $scope.Search = true;
    $scope.schedulartab = true;
    $scope.SelectedCustomerID = undefined;
    $scope.vm.filtercustomer = null;
    $scope.TRCCdiv = false;
    $scope.vm.YTSPreviewSpinner = false;
    $scope.CompletedSelectedIds = [];
    $scope.CheckCompletedAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.vm.YTSPreviewSpinner = true;
        angular.forEach($scope.Completeddatas, function (value) {
          var i = $scope.CompletedSelectedIds.findIndex(function (x) {
            return x.ID == value._id
          });
          if (i <= -1) {
            $scope.CompletedSelectedIds.push({
              ID: value._id,
              ServiceID: value.ServiceID,
            })
          }
        })
        $scope.CSelec = { value: true }
        $scope.vm.YTSPreviewSpinner = false;
        $scope.TRCCdiv = true;
      }
      if (IsTicked == false) {
        $scope.TRCCdiv = false;
        $scope.CompletedSelectedIds = [];
        $scope.CSelec = { value: false }
      }
    }
    $scope.CompletedCheck = function (SI, Ids, ServiceID) {
      if (SI == true) {
        $scope.vm.YTSPreviewSpinner = true;
        var i = $scope.CompletedSelectedIds.findIndex(function (x) {
          return x.ID == Ids
        });
        if (i <= -1) {
          $scope.CompletedSelectedIds.push({
            ID: Ids,
            ServiceID: ServiceID,
          })
        }
        $scope.TRCCdiv = true;
        $scope.vm.YTSPreviewSpinner = false;
      }
      if (SI == false) {
        $scope.TRCCdiv = false;
        $scope.vm.YTSPreviewSpinner = true;
        var index = $scope.CompletedSelectedIds.findIndex(function (x) {
          return x.ID == Ids
        });
        if (index > -1) {
          $scope.CompletedSelectedIds.splice(index, 1);
        }
        $scope.vm.YTSPreviewSpinner = false;
      }
      if ($scope.CompletedSelectedIds.length > 0) {
        $scope.TRCCdiv = true;
      }
    }
    $scope.ConfirmEmailforCompletedJob = function (e) {
      $scope.vm.Confirmation = true;
      $scope.vm.EmailDetails = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmEmailforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.ConfirmDownloadforCompletedJob = function (e) {
      $scope.vm.CurrentDateTimeFolder = new Date();
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmDownloadforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
      });
    }
    $scope.ConfirmVerifyforCompletedJob = function (e) {
      $scope.vm.ShowVerifySpinner = false;
      $scope.DataforCompletedService = [];
      var getGroupID = 0;
      angular.forEach($scope.CompletedSelectedIds, function (value1) {
        try {
          var item = $scope.Completeddatas.filter(function (item) {
            return item._id === value1.ID;
          })[0];
        } catch (err) { }
        if (value1.ID === item._id) {
          var PestType = "";
          var SOR = "";
          if (item.SOR != "" && item.SOR != null && item.SOR != undefined) {
            SOR = item.SOR;
            PestType = item.PestType + " (SOR: " + SOR + ")";
          }
          else {
            PestType = item.PestType;
          }


          var CustomerWoNo = "";
          if (item.CustomerWoNo != "" && item.CustomerWoNo != null && item.CustomerWoNo != undefined) {
            CustomerWoNo = item.CustomerWoNo;
          }
          var SORRate = "";
          if (item.SORRate != "" && item.SORRate != null && item.SORRate != undefined) {
            SORRate = parseFloat(item.SORRate);
          }
          var GroupID = "";
          if (item.GroupID != "" && item.GroupID != null && item.GroupID != undefined) {
            GroupID = item.GroupID;
          }

          var GroupName = "";
          if (item.customerServicedetails.length > 0) {
            if (item.customerServicedetails[0].GroupName != "" && item.customerServicedetails[0].GroupName != null && item.customerServicedetails[0].GroupName != undefined) {
              GroupName = item.customerServicedetails[0].GroupName;
            }
          }
          $scope.DataforCompletedService.push({
            ID: item._id,
            ServiceID: item.ServiceID,
            PestType: PestType,
            //SOR: SOR,
            CustomerWoNo: CustomerWoNo,
            SORRate: SORRate,
            GroupID: GroupID,
            GroupName: GroupName,
          })
        }
      })
      $scope.VerifydataGridOptions = {
        dataSource: $scope.DataforCompletedService,
        keyExpr: "ID",
        showColumnLines: true,
        showRowLines: true,
        rowAlternationEnabled: true,
        showBorders: true,
        paging: {
          enabled: true,
          pageSize: 5
        },
        editing: {
          mode: "cell",
          allowUpdating: true
        },
        allowColumnResizing: true,
        columns: [
          {
            caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
              cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
            }
          },
          {
            dataField: "ServiceID",
            caption: "Service ID",
            allowEditing: false,
          },
          {
            dataField: "PestType",
            caption: "Details",
            allowEditing: false,
          },
          {
            dataField: "GroupID",
            caption: "Group ID",
            allowEditing: false,
            width: 100
          },
          {
            dataField: "GroupName",
            caption: "Group Name",
            allowEditing: false,
          },
          {
            dataField: "CustomerWoNo",
            caption: "Customer Wo No",
            dataType: "text",
            allowEditing: true,
          },
          {
            dataField: "SORRate",
            caption: "SOR Rate",
            dataType: "number",
            allowEditing: true,
            width: 100
          }
        ],
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [5, 10, 20, 50, 100],
          showInfo: true
        },
        onCellPrepared: function (e) {
          if (e.rowType === "header" &&
            (e.column.dataField === "CustomerWoNo" ||
              e.column.dataField === "SORRate"))
            e.cellElement.css({ "backgroundColor": "#90EE90" });
        },
        onRowUpdating: function (e) {
          var getNewData = e.newData;
          var getSchID = e.key;
          var UpCustomerWoNo = "";
          var UpSORRate = 0;
          if (getNewData.CustomerWoNo != "" && getNewData.CustomerWoNo != null && getNewData.CustomerWoNo != undefined) {
            UpCustomerWoNo = getNewData.CustomerWoNo
          }
          if (getNewData.SORRate != "" && getNewData.SORRate != null && getNewData.SORRate != undefined) {
            UpSORRate = getNewData.SORRate
          }
          angular.forEach($scope.DataforCompletedService, function (value) {
            if (value.ID == getSchID) {
              if (UpCustomerWoNo != "" && UpSORRate != 0) {
                value.CustomerWoNo = UpCustomerWoNo;
                value.SORRate = UpSORRate;
              }
              else if (UpCustomerWoNo != "" && UpSORRate == 0) {
                value.CustomerWoNo = UpCustomerWoNo;
              }
              else if (UpCustomerWoNo == "" && UpSORRate != 0) {
                value.SORRate = UpSORRate;
              }
            }
          });
        },
      };
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/VerifyDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.placeChanged1 = function () {
      $scope.vm.ubPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.ubPostal = parseInt(vm.place.address_components[i].long_name);
          }
        }
      }
    }

    $scope.getConfirmationtoVerifyforSelectedCompletedJob = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmVerifyforCompletedJob.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.ConfirmServiceReportApprove = function (e) {
      $scope.vm.ServiceReportApproveSpinner = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ConfirmServiceReportApprove.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.SendEmailforSelectedCompletedJob = function () {
      $scope.ShowCompletedSelectedIds = [];
      angular.forEach($scope.CompletedSelectedIds, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          $scope.ShowCompletedSelectedIds.push({
            ID: value.ID,
            ServiceID: value.ServiceID,
            EmailStatus: "In-Progress",
            EmailSentDate: "",
            EmailSentTo: "",
            Remarks: "",
          })
        }
      });

      $scope.vm.Confirmation = false;
      $scope.vm.EmailDetails = true;
      $scope.vm.OverallEmailStatus = false;
      $scope.vm.OverallEmailStatusInitialize = false;
      var Ecount = 0;
      var promise = $q.all([]);
      if (Ecount == 0) {
        $scope.vm.EMax = $scope.CompletedSelectedIds.length;
        $scope.vm.EValue = 0;
        $scope.vm.ECount = 0;
        $scope.vm.OverallEmailStatus = true;
      }

      angular.forEach($scope.CompletedSelectedIds, function (value, index) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/SendEmailtoCompletedService",
                data: { _id: value.ID },
              });
              response.then(function (GList) {
                Ecount = Ecount + 1;
                var getEValue = (Ecount / $scope.vm.EMax) * 100;
                $scope.vm.EValue = parseInt(getEValue);
                $scope.vm.ECount = Ecount;
                var Uresponse = $http({
                  url: $rootScope.WebURL + "/scheduler/uniqueschedulerByID",
                  method: "POST",
                  data: { Client_Id: $rootScope.Client_Id, _id: value.ID },
                });
                Uresponse.then(function (GList) {
                  $scope.getCurrentSchedulerData = GList.data.data[0];

                  if ($scope.getCurrentSchedulerData.EmailSent == true) {
                    var EmailStatusMessage = "Sent";
                    var EmailSentDate = new Date($scope.getCurrentSchedulerData.EmailSentDate);
                    var EmailSentTo = $scope.getCurrentSchedulerData.EmailSentTo;
                    var EmailRemarks = "Email Sent Successfully";
                  }
                  else if ($scope.getCurrentSchedulerData.EmailSent == false) {
                    var EmailStatusMessage = "Failed";
                    var EmailSentDate = "";
                    var EmailSentTo = "";
                    var EmailRemarks = $scope.getCurrentSchedulerData.EmailSentError;
                  }

                  $scope.ShowCompletedSelectedIds[index]["EmailStatus"] = EmailStatusMessage;
                  $scope.ShowCompletedSelectedIds[index]["EmailSentDate"] = EmailSentDate;
                  $scope.ShowCompletedSelectedIds[index]["EmailSentTo"] = EmailSentTo;
                  $scope.ShowCompletedSelectedIds[index]["Remarks"] = EmailRemarks;
                });
                if (Ecount === $scope.CompletedSelectedIds.length) {
                  $scope.vm.OverallEmailStatusInitialize = false;
                  $scope.CompletedSelectedIds = [];
                  $scope.getAllCompletedID = "";
                  $scope.CSelec = { value: false };
                  $scope.AllCSelec = { value: false };
                  $scope.TRCCdiv = false;
                  $scope.vm.OverallEmailStatus = false;
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    angular.forEach(GList.data.data, function (value) {
                      try {
                        var PestCode = '';
                        var pest = value.PestType.split(',')
                        angular.forEach(pest, function (ele) {
                          var pt = $scope.Pesttypedatas.filter(function (pt) {
                            return ele == pt.PestName;
                          })[0];
                          PestCode = PestCode + pt.Pestcode + ',';
                        })
                        PestCode = PestCode.substring(0, PestCode.length - 1);
                        value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
                        // var PestArray = []
                        // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
                        //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
                      } catch (e) {
                      }
                    })
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;
                    $scope.ClearGrid();
                  });
                }
              }, function () {
                //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 8000);
          });
        }
      });
    }
    $scope.DownloadforSelectedCompletedJob = function (DTFolder, e) {
      $scope.DTFolderName = DTFolder;
      var getDTFYear = new Date($scope.DTFolderName).getFullYear();
      var getDTFMonth = new Date($scope.DTFolderName).getMonth() + 1;
      if (getDTFMonth < 10) {
        getDTFMonth = "0" + getDTFMonth.toString();
      }
      else {
        getDTFMonth = getDTFMonth;
      }
      var getDTFDate = new Date($scope.DTFolderName).getDate();
      if (getDTFDate < 10) {
        getDTFDate = "0" + getDTFDate.toString();
      }
      else {
        getDTFDate = getDTFDate;
      }
      var getDTFHour = new Date($scope.DTFolderName).getHours();
      if (getDTFHour < 10) {
        getDTFHour = "0" + getDTFHour.toString();
      }
      else {
        getDTFHour = getDTFHour;
      }
      var getDTFMins = new Date($scope.DTFolderName).getMinutes();
      if (getDTFMins < 10) {
        getDTFMins = "0" + getDTFMins.toString();
      }
      else {
        getDTFMins = getDTFMins;
      }
      var getDTFSecs = new Date($scope.DTFolderName).getSeconds();
      if (getDTFSecs < 10) {
        getDTFSecs = "0" + getDTFSecs.toString();
      }
      else {
        getDTFSecs = getDTFSecs;
      }
      var FolderName = getDTFYear.toString() + getDTFMonth.toString() + getDTFDate.toString() + getDTFHour.toString() + getDTFMins.toString() + getDTFSecs.toString();
      var count = 0;
      var promise = $q.all([]);
      if (count == 0) {
        $mdDialog.cancel();
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/operations/scheduler/ShowDownloadedHistoryDetails.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          controller: function operationsProjectController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
      }
      var TotalReports = $scope.CompletedSelectedIds.length;
      var ReportFolderName = FolderName + ".zip";
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/add",
        data: {
          Client_Id: $rootScope.Client_Id,
          RequestedBy: $scope.RequestedBy,
          RequestedDate: new Date($scope.DTFolderName),
          DownloadedDate: new Date(),
          TotalRecords: TotalReports,
          CompletedRecords: 0,
          DownloadedLink: ReportFolderName,
          CreatedBy: $rootScope.createdby,
        },
      }).then(function (SRPGList) {
        $scope.getReportID = SRPGList.data.data.id;
        RefreshSchedulerReportPathGrid();
        angular.forEach($scope.CompletedSelectedIds, function (value) {
          if (value.ID != "" && value.ID != null && value.ID != undefined) {
            promise = promise.then(function () {
              return $timeout(function () {
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/scheduler/DownloadCompletedServiceReport",
                  data: {
                    _id: value.ID,
                    ServiceID: value.ServiceID,
                    FolderName: FolderName,
                  },
                }).then(function (GList) {
                  count = count + 1;
                  //$scope.Schedulerreportpathdatas[0]["CompletedRecords"] = count;
                  var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/schedulerreportpath/updateCompleted",
                    data: {
                      _id: $scope.getReportID,
                      CompletedRecords: count,
                      UpdatedBy: $rootScope.createdby,
                    },
                  });
                  response.then(function (GList) {
                    $scope.Schedulerreportpathdatas[0] = GList.data.data;
                  });

                  if (count === $scope.CompletedSelectedIds.length) {
                    //RefreshSchedulerReportPathGrid();
                    $scope.ClearGrid();
                    $scope.CompletedSelectedIds = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $mdToast.show($mdToast.simple().textContent('Successfully Downloaded!').position('top center'));
                  }
                }, function () {
                  //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
              }, 6000);
            });
          }
        });
      });
    }
    $scope.ShowDownloadedHistory = function (e) {
      $scope.vm.DownSpinner = true;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowDownloadedHistoryDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
        $scope.vm.DownSpinner = false;
      });
    }
    $scope.RefreshReportPathHistory = function () {
      $scope.vm.DownSpinner = true;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
        $scope.vm.DownSpinner = false;
      });
    }

    $scope.VerifyforSelectedCompletedJob = function () {
      var count = 0;
      var promise = $q.all([]);
      if (count == 0) {
        $mdDialog.cancel();
        $scope.vm.ShowVerifySpinner = true;
      }
      angular.forEach($scope.DataforCompletedService, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/VerifyCompletedService",
                data: {
                  _id: value.ID,
                  CustomerWoNo: value.CustomerWoNo,
                  SORRate: value.SORRate,
                  GroupName: value.GroupName,
                  UpdatedBy: $rootScope.createdby,
                },
              });
              response.then(function (GList) {
                count = count + 1;
                if (count === $scope.DataforCompletedService.length) {
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;
                    $scope.CompletedSelectedIds = [];
                    $scope.DataforCompletedService = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $scope.vm.ShowVerifySpinner = false;
                    $scope.ClearGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Verified Successfully!').position('top center'));
                  });
                }
              }, function () {
                //$mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 300);
          });
        }
      });
    }
    $scope.ApproveServiceReportforSelectedCompletedJob = function () {
      $scope.vm.ServiceReportApproveSpinner = true;
      var Ecount = 0;
      var promise = $q.all([]);
      angular.forEach($scope.CompletedSelectedIds, function (value) {
        if (value.ID != "" && value.ID != null && value.ID != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/updateServiceReportStatus",
                data: { _id: value.ID, UpdatedBy: $rootScope.createdby },
              });
              response.then(function (GList) {
                Ecount = Ecount + 1;
                if (Ecount === $scope.CompletedSelectedIds.length) {
                  $scope.uFrom.setHours(0, 0, 0, 0);
                  $scope.uTo.setHours(23, 59, 59, 999);
                  var response = $http({
                    url: $rootScope.WebURL + "/scheduler/getbyStatus",
                    method: "POST",
                    data: {
                      Start_Date: $scope.uFrom,
                      End_Date: $scope.uTo,
                      Client_Id: $rootScope.Client_Id,
                      Customer_Id: $scope.SelectedCustomerID,
                      Status: 'Completed',
                      Team_Id: null
                    },
                  });
                  response.then(function (GList) {
                    angular.forEach(GList.data.data, function (value) {
                      try {
                        var PestCode = '';
                        var pest = value.PestType.split(',')
                        angular.forEach(pest, function (ele) {
                          var pt = $scope.Pesttypedatas.filter(function (pt) {
                            return ele == pt.PestName;
                          })[0];
                          PestCode = PestCode + pt.Pestcode + ',';
                        })
                        PestCode = PestCode.substring(0, PestCode.length - 1);
                        value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
                        // var PestArray = []
                        // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
                        //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
                      } catch (e) {
                      }
                    })
                    $scope.AllScheduleDatas = GList.data.data;
                    $scope.Uniqueschedulerdatas = GList.data.data;
                    var Completeddata = GList.data.data;
                    var resArr = [];
                    try {
                      Completeddata.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                          return x._id == item._id
                        });
                        if (i <= -1)
                          resArr.push(item);
                      });
                    } catch (e) { }
                    $scope.Completeddatas = resArr;

                    var getPending = [];
                    try {
                      getPending = resArr.filter(function (pending) {
                        return pending.ServiceReportStatus == "Pending";
                      });
                    } catch (e) { }
                    $scope.PendingApprovaldatas = getPending;

                    $scope.CompletedSelectedIds = [];
                    $scope.getAllCompletedID = "";
                    $scope.CSelec = { value: false };
                    $scope.AllCSelec = { value: false };
                    $scope.TRCCdiv = false;
                    $scope.vm.ServiceReportApproveSpinner = false;
                    $scope.ClearGrid();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Service Report Approved Successfully !').position('top center'));
                  });
                }
              }, function () { });
            }, 100);
          });
        }
      });
    }

    $scope.CloseVerification = function () {
      $scope.CompletedSelectedIds = [];
      $scope.DataforCompletedService = [];
      $scope.getAllCompletedID = "";
      $scope.CSelec = { value: false };
      $scope.AllCSelec = { value: false };
      $scope.TRCCdiv = false;
      $scope.ClearGrid();
      $mdDialog.cancel();
    };
    $scope.getVerificationRowColour = function (item) {
      if (item.Verified === true) {
        return true;
      }
      else {
        return false;
      }
    }
    $scope.ShowEmailedHistory = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowEmailedHistoryDetails.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.getRowColourforSentBulkEmail = function (item) {
      if (item.EmailStatus === "Failed") {
        return true;
      }
      else {
        return false;
      }
    }
    $scope.getRowColourforSentEmail = function (item) {
      if (item.EmailSent === false) {
        return true;
      }
      else {
        return false;
      }
    }


    RefreshUnit();


    //RefreshGroupID();
    $scope.AllSASelec = { value: false };
    $scope.SASelec = { value: false };
    $scope.svAll = { value: false };
    $scope.ServiceAddressarray = [];
    $scope.CheckAllServiceAddress = function (IsTicked) {
      if (IsTicked == true) {
        angular.forEach($scope.CustomerServicedatas, function (value) {
          if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined && value.Type == 'Service') {
            if ($scope.ServiceAddressarray.indexOf(value) == -1) { $scope.ServiceAddressarray.push(value) }
          }
        })
        $scope.AllSASelec = { value: true };
        $scope.SASelec = { value: true };
      }
      else {
        $scope.ServiceAddressarray = [];
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
      }
    }
    $scope.CheckServiceAddress = function (CheckSA, SIds) {
      if (CheckSA == true) {
        if ($scope.ServiceAddressarray.indexOf(SIds) == -1) {
          $scope.ServiceAddressarray.push(SIds)
        }
      }
      else if (CheckSA == false) {
        var index = $scope.ServiceAddressarray.indexOf(SIds);
        if (index > -1) {
          $scope.ServiceAddressarray.splice(index, 1);
        }
      }
      if ($scope.ServiceAddressarray.length <= 0) {
        $scope.AllSASelec = { value: false };
      }
    }
    $scope.mapDate = new Date();
    $scope.SelectedIds = [];
    $scope.CheckAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.TRCdiv = true;
        angular.forEach($scope.YettoStartdatas, function (value) {
          if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
        })
        $scope.Selec = { value: true }
      }
      if (IsTicked == false) {
        $scope.TRCdiv = false;
        $scope.SelectedIds = [];
        $scope.Selec = { value: false }
      }
    }
    $scope.Check = function (TrF, Ids) {
      if (TrF == true) {
        $scope.TRCdiv = true;
        if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
      }
      if (TrF == false) {
        $scope.TRCdiv = false;
        var index = $scope.SelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.SelectedIds.splice(index, 1);
        }
      }
      if ($scope.SelectedIds.length > 0) {
        $scope.TRCdiv = true;
      }
    }
    $scope.TRCdiv = false;
    $scope.Selec = { value: false }
    $scope.Update = false;
    $scope.shedulerform = true;
    $scope.pesttypeGrid = false;
    $scope.Cancel = { value: false };
    $scope.Reschedule = { value: false };
    $scope.InfestationLevel = [
      { Name: 'High' }, { Name: 'Medium' }, { Name: 'Low' }, { Name: 'Nil' }
    ]
    $scope.RescheduleSelected = function (e) {
      $scope.vm.Title = 'Reschedule';
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.RescheduleSelectedbyTime = function (e) {
      $scope.vm.Title = 'Reschedule by Time';
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.CancelSelected = function (e) {
      $scope.vm.Title = 'Cancel';
      $scope.vm.CancelSRemarks = null;
      $scope.vm.CancelSpinner = false;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.SubmitRescheduleSelected = function () {
      $scope.vm.RescheduleSpinner = true;
      var Rcount = 0;
      var promise = $q.all([]);

      var dd = $scope.vm.ResheduleSFrom;
      var hh = $scope.vm.ResheduleSSTime;
      var mm = new Date(hh.setDate(new Date(dd).getDate()));
      var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
      $scope.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));

      var edd = $scope.vm.ResheduleSFrom;
      var ehh = $scope.vm.ResheduleSETime;
      var emm = new Date(ehh.setDate(new Date(edd).getDate()));
      var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
      $scope.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));

      var currentDate = new Date($scope.schusdateTime);
      var enddate = new Date($scope.schuedateTime);
      $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
      $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
      angular.forEach($scope.SelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.YettoStartdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: value,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleFromDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item._id == value;
                  })[0];
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: value,
                      ServiceID: item.ServiceID,
                      CustomerName: item.customerdetails[0].CompanyName,
                      Status: item.Status,
                      PreviousStartsat: new Date(item.Startsat),
                      PreviousEndsat: new Date(item.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: item.PestType1,
                      TeamName: item.TeamName,
                      TeamLead: item.TeamMembersName,
                      TeamMember: item.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: "Yet to Start",
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  },
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.SelectedIds.length) {
                  $scope.SelectedIds = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.submitrescheduled = function () {
      $scope.vm.RescheduleSpinner = true;
      var Rcount = 0;
      var promise = $q.all([]);
      var currentDate = new Date()
      var enddate = new Date()
      angular.forEach($scope.Rescheduledata, function (item, index) {
        if (item != "" && item != null && item != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.ServiceOn = item.ServiceOn
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
                currentDate = CombineDateAndTime(new Date(item.Startsat), $scope.vm.ResheduleSSTime)
                enddate = CombineDateAndTime(new Date(item.Endsat), $scope.vm.ResheduleSETime)
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: item._id,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  RescheduledDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var iitem = $scope.Uniqueschedulerdatas.filter(function (iitem) {
                    return iitem._id == item._id;
                  })[0];
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: item._id,
                      ServiceID: iitem.ServiceID,
                      CustomerName: iitem.customerdetails[0].CompanyName,
                      Status: iitem.Status,
                      PreviousStartsat: new Date(iitem.Startsat),
                      PreviousEndsat: new Date(iitem.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: iitem.PestType1,
                      TeamName: iitem.TeamName,
                      TeamLead: iitem.TeamMembersName,
                      TeamMember: iitem.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: iitem.JobsOrders,
                    Customer: iitem.Customer,
                    AssignedTo: iitem.AssignedTo,
                    Frequency: iitem.Frequency,
                    ServiceOn: iitem.ServiceOn,
                    Types: iitem.Types,
                    Status: "Yet to Start",
                    Startsat: new Date(iitem.Startsat),
                    Endsat: new Date(iitem.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: iitem.PestType,
                    ContractOrder: iitem.ContractOrder,
                    ServiceID: iitem.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  },
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.Rescheduledata.length) {
                  $scope.Rescheduledata = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.SubmitCancelSelected = function () {
      $scope.vm.CancelSpinner = true;
      var Ccount = 0;
      var promise = $q.all([]);

      angular.forEach($scope.SelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.YettoStartdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                  _id: value,
                  Status: "Cancelled",
                  CancelRemarks: $scope.vm.CancelSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleDate: $scope.ServiceStartAt,
                  UpdatedBy: $rootScope.createdby
                },
              });
              response.then(function (GList) {
                var Logresponse = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: item.Status,
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    CancelRemarks: $scope.vm.CancelSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  }
                });
                //lresponse.then(function (GList) { })
                Ccount = Ccount + 1;
                if (Ccount === $scope.SelectedIds.length) {
                  $scope.SelectedIds = [];
                  $scope.TRCdiv = false;
                  $scope.Selec = { value: false }
                  RefreshGrid();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.CancelSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.getEndTime = function (StartTime) {
      if (StartTime != null && StartTime != undefined && StartTime != "") {
        $scope.vm.ResheduleEndTime = new Date(moment(StartTime).add(1, 'hours'))
      }
    }

    $scope.OutstandingSelectedIds = [];
    $scope.OutstandingCheckAll = function (IsTicked) {
      if (IsTicked == true) {
        $scope.OutstandingTRCdiv = true;
        angular.forEach($scope.InProgressdatas, function (value) {
          if ($scope.OutstandingSelectedIds.indexOf(value._id) == -1) { $scope.OutstandingSelectedIds.push(value._id) }
        })
        $scope.OutstandingSelec = { value: true }
      }
      if (IsTicked == false) {
        $scope.OutstandingTRCdiv = false;
        $scope.OutstandingSelectedIds = [];
        $scope.OutstandingSelec = { value: false }
      }
    }
    $scope.OutstandingCheck = function (TrF, Ids) {
      if (TrF == true) {
        $scope.OutstandingTRCdiv = true;
        if ($scope.OutstandingSelectedIds.indexOf(Ids) == -1) { $scope.OutstandingSelectedIds.push(Ids) }
      }
      if (TrF == false) {
        $scope.OutstandingTRCdiv = false;
        var index = $scope.OutstandingSelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.OutstandingSelectedIds.splice(index, 1);
        }
      }
      if ($scope.OutstandingSelectedIds.length > 0) {
        $scope.OutstandingTRCdiv = true;
      }
    }
    $scope.OutstandingTRCdiv = false;
    $scope.OutstandingSelec = { value: false }
    $scope.OutstandingRescheduleSelected = function (e) {
      $scope.vm.Title = 'Reschedule';
      $scope.vm.ResheduleSFrom = new Date();
      $scope.vm.ResheduleSSTime = null;
      $scope.vm.ResheduleSETime = null;
      $scope.vm.ResheduleSRemarks = null;
      $scope.vm.RescheduleSpinner = false;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OutStandingSelectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.OutstandingCancelSelected = function (e) {
      $scope.vm.Title = 'Cancel';
      $scope.vm.CancelSRemarks = null;
      $scope.vm.CancelSpinner = false;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OutStandingSelectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.OutstandingSubmitRescheduleSelected = function () {
      var Rcount = 0;
      if (Rcount == 0) {
        $scope.vm.RescheduleSpinner = true;
      }
      var promise = $q.all([]);

      var dd = $scope.vm.ResheduleSFrom;
      var hh = $scope.vm.ResheduleSSTime;
      var mm = new Date(hh.setDate(new Date(dd).getDate()));
      var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
      $scope.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));

      var edd = $scope.vm.ResheduleSFrom;
      var ehh = $scope.vm.ResheduleSETime;
      var emm = new Date(ehh.setDate(new Date(edd).getDate()));
      var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
      $scope.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));

      var currentDate = new Date($scope.schusdateTime);
      var enddate = new Date($scope.schuedateTime);
      $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
      $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
      angular.forEach($scope.OutstandingSelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {
          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.InProgressdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.ServiceStartAtlog = new Date(item.Startsat);
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceEndAtlog = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }
              $scope.Emails = null;
              if ($scope.Reschedule.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                data: {
                  _id: value,
                  ServiceOn: $scope.ServiceOn,
                  Startsat: currentDate,
                  Endsat: enddate,
                  ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleFromDate: $scope.ServiceStartAtlog,
                  UpdatedBy: $rootScope.createdby,
                  IsActive: true
                },
              }).then(function (GList) {
                try {
                  var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item._id == value;
                  })[0];
                  $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                      ServiceId: value,
                      ServiceID: item.ServiceID,
                      CustomerName: item.customerdetails[0].CompanyName,
                      Status: item.Status,
                      PreviousStartsat: new Date(item.Startsat),
                      PreviousEndsat: new Date(item.Endsat),
                      Startsat: currentDate,
                      Endsat: enddate,
                      PestType: item.PestType1,
                      TeamName: item.TeamName,
                      TeamLead: item.TeamMembersName,
                      TeamMember: item.TeamMembersName,
                      Acknowledged: null,
                      AcknowledgedBy: null,
                      CreatedBy: $rootScope.createdby,
                      IsActive: true
                    },
                  }).then(function (GList) {
                  });
                }
                catch (e) { }
                $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: "Outstanding",
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    ScheduledStartsat: currentDate,
                    ScheduledEndsat: enddate,
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  },
                });
                Rcount = Rcount + 1;
                if (Rcount === $scope.OutstandingSelectedIds.length) {
                  $scope.OutstandingSelectedIds = [];
                  $scope.OutstandingTRCdiv = false;
                  $scope.OutstandingSelec = { value: false }
                  $scope.getOutsatnding();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.RescheduleSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }
    $scope.OutstandingSubmitCancelSelected = function () {
      $scope.vm.CancelSpinner = true;
      var Ccount = 0;
      var promise = $q.all([]);

      angular.forEach($scope.OutstandingSelectedIds, function (value, index) {
        if (value != "" && value != null && value != undefined) {

          promise = promise.then(function () {
            return $timeout(function () {
              try {
                var item = $scope.InProgressdatas.filter(function (item) {
                  return item._id === value;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                  var teamLead = item.teamdetails[0].TeamLead;
                  var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                  $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
              } catch (e) { }

              $scope.Emails = null;
              if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                  if (createdBy.indexOf(uvalue.UserID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                  if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                    array.push({ EmailId: uvalue.Email })
                  }
                })
                if (array.length > 0) {
                  var SenderEmails = [];
                  $scope.Emailgroups = _.groupBy(array, 'EmailId');
                  angular.forEach($scope.Emailgroups, function (value) {
                    SenderEmails.push(value[0].EmailId);
                  });
                  $scope.Emails = SenderEmails;
                }
              }
              var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                  _id: value,
                  Status: "Cancelled",
                  CancelRemarks: $scope.vm.CancelSRemarks,
                  SenderEmailAddress: $scope.Emails,
                  CompanyName: $scope.CompanyName,
                  ScheduleDate: $scope.ServiceStartAt,
                  UpdatedBy: $rootScope.createdby
                },
              });
              response.then(function (GList) {
                var Logresponse = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/schedulelog/add",
                  data: {
                    Client_Id: $rootScope.Client_Id,
                    JobsOrders: item.JobsOrders,
                    Customer: item.Customer,
                    AssignedTo: item.AssignedTo,
                    Frequency: item.Frequency,
                    ServiceOn: item.ServiceOn,
                    Types: item.Types,
                    Status: item.Status,
                    Startsat: new Date(item.Startsat),
                    Endsat: new Date(item.Endsat),
                    PestType: item.PestType,
                    ContractOrder: item.ContractOrder,
                    ServiceID: item.ServiceID,
                    CancelRemarks: $scope.vm.CancelSRemarks,
                    IsActive: true,
                    CreatedBy: $rootScope.createdby
                  }
                });
                //lresponse.then(function (GList) { })
                Ccount = Ccount + 1;
                if (Ccount === $scope.OutstandingSelectedIds.length) {
                  $scope.OutstandingSelectedIds = [];
                  $scope.OutstandingTRCdiv = false;
                  $scope.OutstandingSelec = { value: false }
                  $scope.getOutsatnding();
                  $scope.pesttypeGrid = true;
                  $scope.shedulerform = true;
                  $scope.addbtn = true;
                  $scope.viewbtn = false;
                  $scope.exportbtn = true;
                  $scope.thdata = false;
                  $scope.vm.CancelSpinner = false;
                  $mdDialog.cancel();
                  $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));
                }
              }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
              });
            }, 500);
          });
        }
      });
    }

    $scope.Viewclk = function () {
      $scope.shedulerform = false;
      $scope.addbtn = true;
      $scope.exportbtn = true;
      $scope.viewbtn = false
      $scope.pesttypeGrid = true;
    }
    $scope.cancelbtnclk = function () {
      $scope.shedulerform = false;
      $scope.pesttypeGrid = true;
      $scope.addbtn = true;
      $scope.viewbtn = false;
      $scope.exportbtn = true;
    }
    $scope.Showgrid = function () {
      $scope.pesttypeGrid = true;
      $scope.shedulerform = false;
      $scope.exportbtn = true;
      $scope.addbtn = true;
      $scope.viewbtn = false;

      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
    }
    $scope.SelectJobOrder = function (item) {
      try {
        $scope.vm.Frequency = item.Frequency;
        item.MultiFrequency.forEach(function (value) {
          value.PestName = value.PestType;
          if (value.Frequency.toUpperCase() == 'MONTHLY' || value.Frequency.toUpperCase().indexOf('MONTHLY (12)') > -1 || value.Frequency.toUpperCase().indexOf('1 MONTH') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'BIMONTHLY' || value.Frequency.toUpperCase().indexOf('BI-MONTHLY (6)') > -1 || value.Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1 || value.Frequency.toUpperCase().indexOf('2 MONTHS') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'QUARTERLY (4)' || value.Frequency.toUpperCase() == 'QUARTERLY' || value.Frequency.toUpperCase().indexOf('3 MONTHS') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'HALF-YEARLY' || value.Frequency.toUpperCase().indexOf('HALFY-EARLY (2)') || value.Frequency.toUpperCase().indexOf('6 WEEKS') > -1 > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
          else if (value.Frequency.toUpperCase() == 'YEARLY' || value.Frequency.toUpperCase().indexOf('YEARLY (1)') > -1) {
            $scope.vm.Frequency = value.Frequency;
          }
        })
        $scope.vm.Message = item.Message
        $scope.vm.firstSpecialRemark = ""
        $scope.vm.CoverageArea = item.CoverageArea
        $scope.vm.PestType = item.MultiFrequency;
        $scope.Pestdatas = item.MultiFrequency;
        $scope.vm.BillingFrequency = item.BillingFrequency
        if (item.BillingFrequency == "Weekly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 52).toFixed(2);
        }
        else if (item.BillingFrequency == "Monthly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 12).toFixed(2);
        }
        else if (item.BillingFrequency == "Quarterly") {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 4).toFixed(2);
        }
        else {
          $scope.vm.BillingAmount = (parseFloat(item.TotalPrice) / 1).toFixed(2);
        }
        if (item.Contractdetails.length > 0)
          $scope.vm.ContractReferenceNo = item.Contractdetails[0].ContractReferenceNo;
        $scope.vm.ContractStartDate = item.ContractStartDate;
        if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
          $scope.vm.ContractStartDate = new Date(item.ContractStartDate);
        }
        $scope.vm.ContractEndDate = item.ContractEndDate;
        if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
          $scope.vm.ContractEndDate = new Date(item.ContractEndDate);
        }
        $scope.vm.SalesOrderNo = item.SalesOrderNo;
        $scope.vm.CustomerID = item.Customer_id;
        $scope.vm.OrderType = item.OrderType;
        $scope.vm.Types = item.Types;
        $scope.vm.PreferredTime = item.DateTimeofTreatment
        $scope.vm.ServiceStartDate = item.ServiceStartDate;
        if ($scope.vm.ServiceStartDate != null && $scope.vm.ServiceStartDate != "") {
          $scope.vm.ServiceStartAt = new Date(item.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = item.ServiceEndDate;
        if ($scope.vm.ServiceEndDate != null && $scope.vm.ServiceEndDate != "") {
          $scope.vm.ServiceEndAt = new Date(item.ServiceEndDate);
        }
        var today = new Date()
        $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 9, 0, 0);
        var EstimationHour = parseFloat(item.EstimatedHoursRequired)
        if (EstimationHour != NaN) {
          $scope.vm.EstimationHr = EstimationHour
          $scope.vm.TeamEstimationHr = EstimationHour
          $scope.WoEstimationHour = EstimationHour
          var End = new Date($scope.vm.ServiceStartTime);
          $scope.vm.ServiceEndTime = new Date(moment(End).add(EstimationHour, 'hours'))
        }
        else {
          $scope.WoEstimationHour = 0
          var End = new Date($scope.vm.ServiceStartTime);
          $scope.vm.ServiceEndTime = new Date(moment(End).add(EstimationHour, 'hours'))
        }
        if ($filter('date')($scope.vm.ServiceStartAt, 'dd/MM/yyyy') === $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy')) {
          var ServiceOn = $filter('date')($scope.vm.ServiceStartAt, 'EEEE');
          var ite = $scope.items.filter(function (ite) {
            return ite.names == ServiceOn
          });
          $scope.selected = ite;
        }
      }
      catch (e) { }
    }
    $scope.SelectContract = function (CId) {
      try {
        var item = $scope.contractdatas.filter(function (item) {
          return item._id === CId;
        })[0];
        $scope.vm.ContractReferenceNo = item.ContractReferenceNo;
        $scope.vm.ContractStartDate = item.ContractStartDate;
        if ($scope.vm.ContractStartDate != null && $scope.vm.ContractStartDate != "") {
          $scope.vm.ContractStartDate = new Date(item.ContractStartDate);
        }
        $scope.vm.ContractEndDate = item.ContractEndDate;
        if ($scope.vm.ContractEndDate != null && $scope.vm.ContractEndDate != "") {
          $scope.vm.ContractEndDate = new Date(item.ContractEndDate);
        }
      }
      catch (e) { }
    }
    $scope.Schinfolist = function (e, item) {
      $scope.vm.ResheduleRemarks = null;
      try {

        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        $scope.vm.Frequency = item.Frequency;
        $scope.selectedvalue = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.CustomerID = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.vm.ServiceStartAtlog = new Date(item.Startsat);
        $scope.vm.ServiceEndAtlog = new Date(item.Endsat);
        $scope.status = item.Status;
        $scope.vm.BillingAmount = null
        $scope.vm.TeamName = item.TeamName;
        $scope.vm.Teammemberdata = item.TeamMembersName;
        if (item.BillingAmount != null && item.BillingAmount != "" && item.BillingAmount != undefined) {
          $scope.vm.BillingAmount = item.BillingAmount;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName; $scope.vm.CompanyID = item.customerdetails[0].CustomerID;
          $scope.vm.CusEmail = item.customerdetails[0].Email
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) { $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo; }
        $scope.vm.ResheduleFrom = new Date(item.Startsat);
        $scope.vm.ResheduleStartTime = $scope.vm.ServiceStartAt
        $scope.vm.ResheduleEndTime = $scope.vm.ServiceEndAt

        $scope.vm.Billable = item.Billable;
        $scope.vm.CollectPayment = item.CollectPayment;
        $scope.vm.Location = item.Location;
        $scope.vm.LatLong = item.Location;
        if (item.Contracterdetails.length > 0)
          $scope.vm.ContractOrderNo = item.Contracterdetails[0].ContractReferenceNo
        if (item.customerdetails.length > 0)
          $scope.vm.CustomerName = item.customerdetails[0].CompanyName
        $scope.vm.ContactPerson = item.SiteContactPerson

        var teamdata = []
        $scope.teamdatas.filter(function (val) {
          if (item.Team_Id.includes(val.id)) {
            teamdata.push(val)
          }
        })
        $scope.vm.UTeam = teamdata
        $scope.vm.UTeam1 = teamdata[0].TeamName
        $scope.vm.TEamLead = teamdata[0].TeamLead
      } catch (e) { }
      $scope.SID = item._id;
      $scope.schedulerId = item._id;
      $scope.Update = true;
      $scope.Reschedule.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Scheduler_list_popup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/customerService/getByID',
        data: { RequestID: $scope.vm.CompanyID }
      }).then(function (List) {
        var semail = List.data.data.map(function (o) { if (o.sEmail != null && o.sEmail != undefined && o.sEmail != "") { return o.sEmail } })
        var bemail = List.data.data.map(function (o) { if (o.bEmail != null && o.bEmail != undefined && o.bEmail != "") { return o.bEmail } })
        semail = semail.concat(bemail)
        if ($scope.vm.CusEmail != null && $scope.vm.CusEmail != "" && $scope.vm.CusEmail != undefined) {
          semail.push($scope.vm.CusEmail)
        }
        $scope.vm.CusEmail = semail.join(',')
      })
    }
    $scope.userpopup = function (e, deleteID) {
      $scope.deleteID = deleteID;
      $scope.vm.CancelRemarks = null;
      $scope.Cancel.value = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Scheduler-popup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    function OnHold(e, id) {
      $scope.OnholdId = id
      $scope.vm.OnHoldRemarks = null
      $scope.vm.OnHoldDate = new Date()

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/OnHoldPopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.SubmitOnHold = function () {
      var status = "From Pending Schedule"
      if ($scope.vm.SelectedTab === "ScheduledWorkOrder")
        status = "From Scheduled WorkOrder"
      $http({
        url: $rootScope.WebURL + "/salesOrder/OnHold",
        method: "PUT",
        data: { _id: $scope.OnholdId, OnHoldComments: $scope.vm.OnHoldRemarks, OnHoldDate: $scope.vm.OnHoldDate, status: status },
      }).then(function (attachmentdata) {
        $scope.NewGetByStatus()
        $scope.OnHoldFlag = false
        $mdDialog.cancel()
        $mdToast.show($mdToast.simple().textContent('Updated On-Hold Successfully!').position('top center'));
      })
    }

    $scope.cancel = function () {
      $mdDialog.cancel();
      $('#PendingContainer').dxDataGrid("instance").clearSelection();
      $scope.OnHoldFlag = false
    };

    $scope.pcancel = function () {
      $mdDialog.cancel();
    }

    $scope.Schinfodelete = function (deleteID) {
      try {
        var item = $scope.AllScheduleDatas.filter(function (item) {
          return item._id === deleteID;
        })[0];
        var createdBy = item.CreatedBy;
        if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
          var teamLead = item.teamdetails[0].TeamLead;
          var teamMember = item.teamdetails[0].TeamMembers;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.CompanyName = item.customerdetails[0].CompanyName;
        }
        $scope.jobdata = item.JobsOrders;
        $scope.CustomerID = item.Customer;
        $scope.AssignedTo = item.AssignedTo;
        $scope.Frequency = item.Frequency;
        $scope.Types = item.Types;
        $scope.ServiceOn = item.ServiceOn;
        $scope.PestType = item.PestType;
        $scope.ContractOrder = item.ContractOrder;
        $scope.ServiceID = item.ServiceID;
        $scope.Status = item.Status;
        $scope.ServiceStartAt = new Date(item.Startsat);
        $scope.ServiceEndAt = new Date(item.Endsat);
      } catch (e) { }
      $scope.Emails = null;
      if ($scope.Cancel.value == true) {
        var array = [];
        angular.forEach($scope.Userdatas, function (uvalue) {
          if (createdBy.indexOf(uvalue.UserID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
          if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
          if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
            array.push({ EmailId: uvalue.Email })
          }
        })
        if (array.length > 0) {
          var SenderEmails = [];
          $scope.Emailgroups = _.groupBy(array, 'EmailId');
          angular.forEach($scope.Emailgroups, function (value) {
            SenderEmails.push(value[0].EmailId);
          });
          $scope.Emails = SenderEmails;
        }
      }
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/Cancelupdate",
        data: {
          _id: deleteID,
          Status: "Cancelled",
          CancelRemarks: $scope.vm.CancelRemarks,
          SenderEmailAddress: $scope.Emails,
          CompanyName: $scope.CompanyName,
          ScheduleDate: $scope.ServiceStartAt,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        var lresponse = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulelog/add",
          data: {
            Client_Id: $rootScope.Client_Id,
            JobsOrders: $scope.jobdata,
            Customer: $scope.CustomerID,
            AssignedTo: $scope.AssignedTo,
            Frequency: $scope.Frequency,
            ServiceOn: $scope.ServiceOn,
            Types: $scope.Types,
            Status: $scope.Status,
            Startsat: $scope.ServiceStartAt,
            Endsat: $scope.ServiceEndAt,
            PestType: $scope.PestType,
            ContractOrder: $scope.ContractOrder,
            ServiceID: $scope.ServiceID,
            CancelRemarks: $scope.vm.CancelRemarks,
            CreatedBy: $rootScope.createdby,
            IsActive: true,
          },
        });
        lresponse.then(function (GList) {
          if ($scope.vm.SelectedTab == 'Outstanding') {
            $scope.getOutsatnding();
          }
          else { RefreshGrid(); }
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.schedulartab = true;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
        })
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.vm.CancelledPreviewSpinner = false;

    $scope.getCancelled = function () {
      $scope.Cancelleddatas = [];
      $scope.vm.CancelledPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getCancelled",
        data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
      }).then(function (Cancelled) {
        angular.forEach(Cancelled.data.data, function (value) {
          try {
            var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.Cancelleddatas = Cancelled.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.CancelledPreviewSpinner = false;
      });
    }
    $scope.vm.PendingSchedulespinner = false
    $scope.getPendingSchedule = function () {
      $scope.PendingScheduledatas = []
      $scope.vm.PendingSchedulespinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getPending",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (salesorder) {
        var item = salesorder.data.data
        angular.forEach(item, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              if (pt != undefined)
                PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            $scope.vm.PendingSchedulespinner = false;
          }
        })
        $scope.PendingScheduledatas = item
        $scope.vm.PendingSchedulespinner = false;

      })
    }

    $scope.getPendingSchedule()
    $scope.AddComments = function (e, SId, CancelledTab) {
      CleanAddComments();

      $scope.vm.SalesOrderNo = '';
      $scope.vm.ContractReferenceNo = '';
      $scope.vm.CompanyName = '';
      $scope.vm.Types = '';
      $scope.vm.Remarks = '';
      $scope.vm.SiteCcontactName = '';
      $scope.vm.SiteContactNo = '';
      $scope.vm.SiteEmail = '';
      $scope.vm.EmailSentTo = '';
      $scope.vm.PaymentRemarks = "";
      $scope.vm.ServiceReportStatus = "Pending";
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/infestation",
        data: { ServiceID: SId._id },
      }).then(function (Materialsdata) {
        $scope.Materialsdatas = Materialsdata.data.data;
      });
      $scope.vm.ScedulId = SId._id;
      $scope.File_id = SId._id;
      $scope.center = [];
      $scope.latlng = [];
      $scope.Billable = { value: true };
      $scope.CollectPayment = { value: false };
      if (CancelledTab != true) {
        var item = SId
        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        $scope.vm.PreferredTime = item.PreferredTime
        $scope.vm.Message = item.Message
        $scope.vm.TeamName = item.TeamName;
        $scope.vm.TeamMembers = item.TeamMembersName;
        $scope.vm.SiteCcontactName = '';
        $scope.vm.SiteContactNo = '';
        $scope.vm.SiteEmail = '';
        $scope.vm.Remarks = item.SpecialRemark
        $scope.vm.PreferredStartTime = item.PreferredStartTime;
        $scope.vm.PreferredEndTime = item.PreferredEndTime;
        $scope.vm.AvoidStartTime = item.AvoidStartTime;
        $scope.vm.AvoidEndTime = item.AvoidEndTime;
        var item1 = $scope.teamdatas.filter(function (item1) {
          return $scope.vm.TeamName.includes(item1.TeamName)
        })
        $scope.vm.TeamLead = item1.map(function (obj) { return obj.TeamLead }).join(',')
        try {
          if (item.Adhocdata[0] != null && item.Adhocdata[0] != "" && item.Adhocdata[0] != undefined) {
            $scope.vm.CompanyName = item.Adhocdata[0].CompanyName;
            $scope.vm.Address = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        try {
          $scope.vm.SiteCcontactName = item.customerServicedetails[0].sContactPerson;
          $scope.vm.SiteContactNo = item.customerServicedetails[0].sMobile;
          $scope.vm.SiteEmail = item.customerServicedetails[0].sEmail;

        }
        catch (e) { }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
          $scope.vm.Address = item.customerdetails[0].Address;
          $scope.vm.Mobile = item.customerdetails[0].Mobile;
          $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) {
          $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
          $scope.vm.WPaymentMethod = item.JobOrdersdetails[0].PaymentMode
          $scope.MultiFrequency = item.JobOrdersdetails[0].MultiFrequency
          $scope.vm.IsUrgent = item.JobOrdersdetails[0].IsUrgent;
        }
        $scope.MultiFrequencydatas = []
        angular.forEach($scope.MultiFrequency, function (value) {
          var item1 = $scope.Treatmentdatas.filter(function (item1) {
            return value.Treatment.indexOf(item1.TreatmentMethod) > -1
          })[0];
          var Chemcial = ""
          var Dilution = ""
          if (item1 != undefined && item1 != null) {
            Chemcial = item1.Chemical
            Dilution = item1.Dilution
          }
          $scope.MultiFrequencydatas.push({
            Frequency: value.Frequency,
            PestType: value.PestType,
            TreatmentMethod: value.Treatment,
            Chemical: Chemcial,
            Dilution: Dilution,
          })
        })
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.ServiceOn = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.Pestdatas = array1;
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.Customer_Id = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.AssignedTo = item.AssignedTo;
        $scope.vm.BillingAmount = item.BillingAmount;
        $scope.vm.Location = item.Location;
        if (item.ServiceReportStatus != null && item.ServiceReportStatus != "" && item.ServiceReportStatus != undefined) {
          $scope.vm.ServiceReportStatus = item.ServiceReportStatus;
        }
        else { $scope.vm.ServiceReportStatus = "Pending"; }
        //
        try {
          if (item.Adhocdata.length > 0) {
            $scope.vm.Location = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        $scope.vm.Status = item.Status;
        $scope.vm.JobContinues = item.JobContinues;
        $scope.CreatedBy = item.CreatedBy;
        $scope.CreatedDate = new Date(item.CreateDate);

        $scope.InProgressedBy = "";
        $scope.InProgresseAt = null;
        if ($scope.vm.Status != "Yet to Start" && $scope.vm.Status != "Outstanding") {
          var uitem = [];
          try {
            uitem = $scope.Userdatas.filter(function (uitem) {
              return uitem.UserID == item.InProgressedBy
            })[0];
            $scope.InProgressedBy = uitem.EmployeeID;
            $scope.InProgresseAt = new Date(item.UpdatedDate);
          }
          catch (e) { }
          if ($scope.vm.Status == "Completed") {
            try {
              var uitem = [];
              uitem = $scope.Userdatas.filter(function (uitem) {
                return uitem.UserID == item.UpdatedBy
              })[0];
              $scope.InProgressedBy = uitem.EmployeeID;
            }
            catch (e) { }
          }
        }
        if (item.CollectPayment == "true") {
          $scope.CollectPayment = { value: true }
        }
        if (item.EmailSentDate == null || item.EmailSentDate == undefined || item.EmailSentDate == "null") {
          $scope.vm.EmailSentDate = "";
        }
        else {
          $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
        }
        try {
          $scope.vm.EmailSentTo = item.EmailSentTo.replace(",", ", ");
        }
        catch (e) { }
        $scope.vm.Pesttype = null;
        $scope.vm.Services = null;
        $scope.CustomerSignature = null;
        $scope.vm.Paymentmethod = null
        $scope.vm.Totalpayment = null
        $scope.vm.PaymentNotes = null
        $scope.vm.MobilEmailId = null;
        $scope.vm.PaymentRemarks = null;
        $scope.vm.Totalarea = null
        $scope.vm.TeamSignature = null;
        $scope.vm.AServiceStartAt = null;
        $scope.vm.AServiceEndAt = null;
        $scope.vm.starRating1r = 0;
        $scope.vm.Attitude = 0;
        $scope.vm.Appearance = 0;
        $scope.vm.ServiceQuality = 0;
        $scope.vm.Punctuality = 0;
        $scope.vm.CDate = new Date();

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (tabletschedulerrecord) {
          $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
          angular.forEach($scope.Tabletschedulerrecord, function (value) {
            try {
              if (value.TeamSignature != null && value.TeamSignature != '' && value.TeamSignature != undefined) {
                value.TeamSignature = decode_base64(value.TeamSignature);
              }
              if (value.CustomerSignature != null && value.CustomerSignature != '' && value.CustomerSignature != undefined) {
                value.CustomerSignature = decode_base64(value.CustomerSignature);
              }
              $scope.vm.CustomerPresent = value.IsCustomerPresent
              if ($scope.vm.CustomerPresent == "true" || $scope.vm.CustomerPresent == true) $scope.vm.CustomerPresent = 'Yes'
              else $scope.vm.CustomerPresent = 'No'
              if ($scope.vm.ScedulId === value.ServiceId) {
                $scope.vm.Pesttype = value.Pesttype
                $scope.vm.Services = value.Services
                $scope.vm.Materials = value.Materials
                if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                  var array = $scope.vm.Services.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ Servicetype: value });
                  });
                  $scope.vm.RServicetype = array1;
                }
                if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                  var array = $scope.vm.Materials.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ MaterialsName: value });
                  });
                  $scope.vm.RMaterialsName = array1;
                }
                $scope.vm.TeamMember = value.TeamMember
                $scope.vm.TeamRemarks = value.TeamRemarks
                $scope.vm.CustomerRemarks = value.CustomerFeedback;
                $scope.vm.TeamLead = value.TeamLead
                $scope.vm.ATimeIn = new Date(value.Startsat);
                $scope.vm.ATimeOut = new Date(value.Endsat);
                $scope.vm.Scheduledate = new Date(value.Scheduledate);
                $scope.CustomerSignature = value.CustomerSignature;
                $scope.vm.StartLocation = value.StartLocation;
                $scope.vm.EndLocation = value.EndLocation;
                $scope.vm.BreedingFound = value.BreedingFound;
                $scope.vm.Species = value.Species;
                $scope.vm.Findings = value.Findings;
                $scope.vm.MistingCariedOut = value.MistingCariedOut;
                $scope.vm.Density = value.Density;
                $scope.vm.Instar = value.Instar;
                $scope.vm.Reason = value.Reason;
                $scope.vm.TeamSignature = value.TeamSignature;
                $scope.vm.Paymentmethod = value.Paymentmethod;
                $scope.vm.PaymentMode = value.PaymentMode;
                $scope.vm.PaymentNotes = value.PaymentNotes;
                $scope.vm.MobilEmailId = value.EmailId;
                $scope.vm.PaymentRemarks = value.PaymentRemarks;
                $scope.vm.starRating1 = value.Rating;
                $scope.vm.AmountReceived = value.AmountReceived
                $scope.vm.BankName = value.BankName
                $scope.vm.ChequeNo = value.ChequeNo
                $scope.vm.AServiceStartAt = new Date(value.Startsat);
                if ($scope.vm.Status == "Completed") { $scope.InProgresseAt = $scope.vm.AServiceStartAt; }
                $scope.vm.AServiceEndAt = new Date(value.Endsat);
                $scope.vm.Totalarea = value.Totalarea;
                $scope.vm.Totalcompleted = value.Totalcompleted;
                $scope.vm.Totalpayment = value.Totalpayment;
                if ($scope.vm.Totalarea == null || $scope.vm.Totalarea == "" || $scope.vm.Totalarea == undefined) {
                  $scope.vm.Totalarea = 0;
                }
                if ($scope.vm.Totalcompleted == "null" || $scope.vm.Totalcompleted == null || $scope.vm.Totalcompleted == "" || $scope.vm.Totalcompleted == undefined) {
                  $scope.vm.Totalcompleted = 0;
                }
                if ($scope.vm.Totalpayment == "null" || $scope.vm.Totalpayment == null || $scope.vm.Totalpayment == "" || $scope.vm.Totalpayment == undefined) {
                  $scope.vm.Totalpayment = 0;
                }
                $scope.vm.CustomerCurrentDate = new Date(value.CustomerCurrentDate);
                // if ($scope.vm.Attitude != "null" && $scope.vm.Attitude != null && $scope.vm.Attitude != "" && $scope.vm.Attitude != undefined) {
                $scope.vm.Attitude = parseInt(value.Attitude);
                //    }
                // if ($scope.vm.Appearance != "null" && $scope.vm.Appearance != null && $scope.vm.Appearance != "" && $scope.vm.Appearance != undefined) {
                $scope.vm.Appearance = parseInt(value.TechnicianAppearance);
                // }
                // if ($scope.vm.ServiceQuality != "null" && $scope.vm.ServiceQuality != null && $scope.vm.ServiceQuality != "" && $scope.vm.ServiceQuality != undefined) {
                $scope.vm.ServiceQuality = parseInt(value.ServiceQuality);
                // }
                // if ($scope.vm.Punctuality != "null" && $scope.vm.Punctuality != null && $scope.vm.Punctuality != "" && $scope.vm.Punctuality != undefined) {
                $scope.vm.Punctuality = parseInt(value.Punctuality);
                // }

              }
            }
            catch (e) { }
          })
        });
        var address = $scope.vm.Location || 'Singapore';
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              $scope.latlng = [];
              $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
              $scope.center = [];
              $scope.center.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
            }
          });
        }
      }
      else if (CancelledTab == true) {
        var item = $scope.Cancelleddatas.filter(function (item) {
          return item._id === SId._id;
        })[0];
        $scope.vm.jobdata = item.JobsOrders;
        $scope.vm.AssignedTo = item.AssignedTo;
        if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
          $scope.vm.TeamName = item.teamdetails[0].TeamName;
          $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
          $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
        }
        if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
          $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
          $scope.vm.Address = item.customerdetails[0].Address;
          $scope.vm.Mobile = item.customerdetails[0].Mobile;
          $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
        }
        if (item.Contracterdetails[0] != null && item.Contracterdetails[0] != "" && item.Contracterdetails[0] != undefined) { $scope.vm.ContractReferenceNo = item.Contracterdetails[0].ContractReferenceNo; }
        if (item.JobOrdersdetails[0] != null && item.JobOrdersdetails[0] != "" && item.JobOrdersdetails[0] != undefined) {
          $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
        }
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.ServiceOn = item.ServiceOn;
        $scope.vm.ServiceID = item.ServiceID;
        $scope.vm.ContractOrder = item.ContractOrder;
        $scope.vm.PestType = item.PestType;
        if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.Pestdatas = array1;
          $scope.vm.PestType = array1;
        }
        $scope.vm.Types = item.Types;
        $scope.vm.JobType = item.JobType;
        $scope.vm.PestType1 = item.PestType;
        $scope.vm.Customer_Id = item.Customer;
        $scope.vm.ServiceStartAt = new Date(item.Startsat);
        $scope.vm.ServiceEndAt = new Date(item.Endsat);
        $scope.AssignedTo = item.AssignedTo;
        $scope.vm.BillingAmount = item.BillingAmount;
        $scope.vm.Location = item.Location;
        if (item.ServiceReportStatus != null && item.ServiceReportStatus != "" && item.ServiceReportStatus != undefined) {
          $scope.vm.ServiceReportStatus = item.ServiceReportStatus;
        }
        else { $scope.vm.ServiceReportStatus = "Pending"; }
        try {
          if (item.Adhocdata.length > 0) {
            $scope.vm.Location = item.Adhocdata[0].Address;
          }
        } catch (e) { }
        $scope.vm.Status = item.Status;
        $scope.vm.JobContinues = item.JobContinues;
        $scope.CreatedBy = item.CreatedBy;
        $scope.CreatedDate = new Date(item.CreateDate);
        if (item.EmailSentDate == null || item.EmailSentDate == undefined || item.EmailSentDate == "null") {
          $scope.vm.EmailSentDate = "";
        }
        else {
          $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
        }
        try {
          $scope.vm.EmailSentTo = item.EmailSentTo.replace(",", ", ");
        }
        catch (e) { }
        $scope.Billable = { value: true };
        $scope.CollectPayment = { value: false };
        $scope.vm.Pesttype = null;
        $scope.vm.Services = null;
        $scope.CustomerSignature = null;
        $scope.vm.Paymentmethod = null
        $scope.vm.Totalpayment = null
        $scope.vm.PaymentNotes = null
        $scope.vm.MobilEmailId = null;
        $scope.vm.PaymentRemarks = null;
        $scope.vm.Totalarea = null
        $scope.vm.TeamSignature = null;
        $scope.vm.CDate = new Date();
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/getById",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (tabletschedulerrecord) {
          $scope.Tabletschedulerrecord = tabletschedulerrecord.data.data;
          angular.forEach($scope.Tabletschedulerrecord, function (value) {
            try {
              if (value.TeamSignature != null && value.TeamSignature != '' && value.TeamSignature != undefined) {
                value.TeamSignature = decode_base64(value.TeamSignature);
              }
              if (value.CustomerSignature != null && value.CustomerSignature != '' && value.CustomerSignature != undefined) {
                value.CustomerSignature = decode_base64(value.CustomerSignature);
              }
              if ($scope.vm.ScedulId === value.ServiceId) {
                $scope.vm.Pesttype = value.Pesttype
                $scope.vm.Services = value.Services
                $scope.vm.Materials = value.Materials
                if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                  var array = $scope.vm.Services.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ Servicetype: value });
                  });
                  $scope.vm.RServicetype = array1;
                }
                if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                  var array = $scope.vm.Materials.split(",");
                  var array1 = [];
                  angular.forEach(array, function (value) {
                    array1.push({ MaterialsName: value });
                  });
                  $scope.vm.RMaterialsName = array1;
                }
                $scope.vm.TeamMember = value.TeamMember
                $scope.vm.TeamRemarks = value.TeamRemarks
                $scope.vm.CustomerRemarks = value.CustomerRemarks
                $scope.vm.CustomerRemarks = value.CustomerRemarks
                $scope.vm.TeamLead = value.TeamLead
                $scope.vm.ATimeIn = new Date(value.Startsat);
                $scope.vm.ATimeOut = new Date(value.Endsat);
                $scope.vm.Scheduledate = new Date(value.Scheduledate);
                $scope.CustomerSignature = value.CustomerSignature;
                $scope.vm.StartLocation = value.StartLocation;
                $scope.vm.EndLocation = value.EndLocation;
                $scope.vm.BreedingFound = value.BreedingFound;
                $scope.vm.Species = value.Species;
                $scope.vm.Findings = value.Findings;
                $scope.vm.MistingCariedOut = value.MistingCariedOut;
                $scope.vm.Density = value.Density;
                $scope.vm.Instar = value.Instar;
                $scope.vm.Reason = value.Reason;
                $scope.vm.MistingCariedOutNo = value.MistingCariedOutNo;
                $scope.vm.NoOfCulls = value.NoOfCulls;
                $scope.vm.NoOfBurrows = value.NoOfBurrows;
                $scope.vm.NoOfDead = value.NoOfDead;
                $scope.vm.Habitat = value.Habitat;
                $scope.vm.Action = value.Action;
                $scope.vm.Recommendation = value.Recommendation;
                $scope.vm.SOR = value.SOR;
                $scope.vm.OthersReason = value.Others;
                $scope.vm.TeamSignature = value.TeamSignature;
                $scope.vm.Paymentmethod = value.Paymentmethod;
                $scope.vm.PaymentNotes = value.PaymentNotes;
                $scope.vm.MobilEmailId = value.EmailId;
                $scope.vm.PaymentRemarks = value.PaymentRemarks;
                $scope.vm.starRating1 = value.Rating;
                $scope.vm.AServiceStartAt = new Date(value.Startsat);
                $scope.vm.AServiceEndAt = new Date(value.Endsat);
                $scope.vm.Totalarea = value.Totalarea;
                $scope.vm.Totalcompleted = value.Totalcompleted;
                $scope.vm.Totalpayment = value.Totalpayment;
                if ($scope.vm.Totalarea == null || $scope.vm.Totalarea == "" || $scope.vm.Totalarea == undefined) {
                  $scope.vm.Totalarea = 0;
                }
                if ($scope.vm.Totalcompleted == "null" || $scope.vm.Totalcompleted == null || $scope.vm.Totalcompleted == "" || $scope.vm.Totalcompleted == undefined) {
                  $scope.vm.Totalcompleted = 0;
                }
                if ($scope.vm.Totalpayment == "null" || $scope.vm.Totalpayment == null || $scope.vm.Totalpayment == "" || $scope.vm.Totalpayment == undefined) {
                  $scope.vm.Totalpayment = 0;
                }
                $scope.vm.CustomerCurrentDate = new Date(value.CustomerCurrentDate);
                if ($scope.vm.starRating1 != "null" && $scope.vm.starRating1 != null && $scope.vm.starRating1 != "" && $scope.vm.starRating1 != undefined) {
                  $scope.vm.starRating1r = parseInt(value.Rating);
                }
              }
            }
            catch (e) { }
          })
        });

        var address = $scope.vm.Location || 'Singapore';
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              $scope.latlng = [];
              $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
            }
          });
        }
      }
      RefreshAttachmentGrid();
      Refreshcomment();
      RefreshPhotos();
      RefreshSchedulerLogs();

      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/accounts/scheduler/addcoments.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function AcoperationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
          // $('#DetailsdtLog').DataTable({
          // });
          //vm.dtLogdetails = {
          //    dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          //    initComplete: function () {
          //        var api = this.api(),
          //            searchBox = angular.element('body').find('#DetailsdtLog');
          //        // Bind an external input as a table wide search box
          //        if (searchBox.length > 0) {
          //            searchBox.on('keyup', function (event) {
          //                api.search(event.target.value).draw();
          //            });
          //        }
          //    },
          //    pagingType: 'simple',
          //    autoWidth: false,
          //    //responsive: true,
          //    //destroy: true
          //};
        }
      });

    }

    $scope.RemarkSubmit = function () {
      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/scheduler/postRemark',
        data: { _id: $scope.vm.ScedulId, Remark: $scope.vm.Remarks }
      }).then(function (item) {
        $scope.vm.ssRemark = $scope.vm.Remarks;
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
      })
    }

    $scope.updateServiceReportStatus = function () {
      $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/updateServiceReportStatus",
        data: { _id: $scope.vm.ScedulId, UpdatedBy: $rootScope.createdby },
      }).then(function (GList) {
        $scope.vm.ServiceReportStatus = "Approved";
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/SendEmailtoCompletedService",
          data: { _id: $scope.vm.ScedulId },
        }).then(function (GList) {
        });
        $scope.NewGetByStatus();
      }, function () { });
    }

    function CleanAddComments() {
      $scope.vm.CustomerPresent = ""
      $scope.vm.Status = "";
      $scope.vm.ServiceID = "";
      $scope.vm.SalesOrderNo = "";
      $scope.vm.ContractReferenceNo = "";
      $scope.vm.CompanyName = "";
      $scope.vm.Location = "";
      $scope.vm.TeamName = "";
      $scope.vm.ServiceStartAt = "";
      $scope.vm.ServiceEndAt = "";
      $scope.vm.PestType1 = "";
      $scope.vm.Types = "";
      $scope.vm.ServiceOn = "";
      $scope.InProgresseAt = "";
      $scope.vm.AServiceEndAt = "";
      $scope.vm.EmailSentTo = "";
      $scope.vm.EmailSentDate = "";
      $scope.InProgressedBy = "";
      $scope.CreatedBy = "";
      $scope.CreatedDate = "";
      $scope.vm.Vehicle = "";
      $scope.Billable = { value: true };
      $scope.vm.BillingAmount = 0
      $scope.Tabletlighttracklistdatas = [];
      $scope.TabletMaterialslistdatas = [];
      $scope.vm.TeamLead = "";
      $scope.vm.TeamMembers = "";
      $scope.vm.TeamRemarks = "";
      $scope.vm.TeamSignature = "";
      $scope.PhotosBdatas = [];
      $scope.Photosdatas = [];
      $scope.vm.NoOfCulls = "";
      $scope.vm.MistingCariedOut = "";
      $scope.vm.NoOfBurrows = "";
      $scope.vm.Density = "";
      $scope.vm.NoOfDead = "";
      $scope.vm.Instar = "";
      $scope.vm.BreedingFound = "";
      $scope.vm.Habitat = "";
      $scope.vm.Species = "";
      $scope.vm.Action = "";
      $scope.vm.Findings = "";
      $scope.vm.Recommendation = "";
      $scope.vm.MobilEmailId = "";
      $scope.vm.Paymentmethod = "";
      $scope.vm.Totalpayment = "";
      $scope.vm.PaymentNotes = "";
      $scope.vm.PaymentRemarks = "";
      $scope.vm.Totalarea = "";
      $scope.vm.Totalcompleted = "";
      $scope.vm.starRating1r = "";
      $scope.vm.CustomerRemarks = "";
      $scope.CustomerSignature = "";
      $scope.vm.Addcomments = "";
      $scope.Commentdatas = [];
      $scope.Attachmentdatas = [];
      $scope.SchedulerLogdatas = [];
      $scope.vm.ATimeIn = "";
      $scope.vm.ATimeOut = "";
      $scope.vm.ContactPerson = "";
      $scope.vm.TeamMember = "";
      $scope.vm.starRating1 = "";
      $scope.Pestdatas = [];
      $scope.vm.MServicetype = "";
      $scope.vm.MLSMPestType = [];
      $scope.vm.MMaterialsName = "";
      $scope.vm.MQuantity = "";
      $scope.vm.MUnit = "";
      $scope.vm.ImgBPestType = [];
      $scope.vm.ImgBRemarks = "";
      $scope.uCPB = "";
      $scope.vm.Paymentmethod = "";
      $scope.vm.Totalpayment = "";
      $scope.vm.PaymentNotes = "";
      $scope.vm.PaymentRemarks = "";
      $scope.vm.Totalarea = "";
      $scope.vm.Totalcompleted = "";
      $scope.vm.Reason = "";
      $scope.vm.PreferredStartTime = "";
      $scope.vm.PreferredEndTime = "";
      $scope.vm.AvoidStartTime = "";
      $scope.vm.AvoidEndTime = "";

    }

    $scope.getWorkOrderDetails = function () {
      try {
        $scope.getSalesOrderdatas = $scope.salesdatas.filter(function (item) {
          return item.Customer_id === $scope.vm.CustomerID;
        });
      } catch (e) { }
      try {
        $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
          return item1.Customer_id === $scope.vm.CustomerID;
        });
      } catch (e) { }
      $scope.vm.WorkOrderID = null;
      $scope.vm.ContractID = null;
      $scope.vm.Types = null;
    }
    $scope.getContractDetails = function () {
      if ($scope.vm.CustomerID != "" && $scope.vm.CustomerID != null && $scope.vm.CustomerID != undefined && $scope.vm.WorkOrderID != "" && $scope.vm.WorkOrderID != null && $scope.vm.WorkOrderID != undefined) {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.Customer_id === $scope.vm.CustomerID && item1.SalesOrderID === $scope.vm.WorkOrderID;
          });
        } catch (e) { }
      }
      else if ($scope.vm.CustomerID != "" && $scope.vm.WorkOrderID == "") {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.Customer_id === $scope.vm.CustomerID;
          });
        } catch (e) { }
      }
      else if ($scope.vm.CustomerID == "" && $scope.vm.WorkOrderID != "") {
        try {
          $scope.getContractdatas = $scope.contractdatas.filter(function (item1) {
            return item1.SalesOrderID === $scope.vm.WorkOrderID;
          });
        } catch (e) { }
      }
      if ($scope.vm.WorkOrderID != "" && $scope.vm.WorkOrderID != null && $scope.vm.WorkOrderID != undefined) {
        try {
          var getSalesOrderType = $scope.salesdatas.filter(function (item) {
            return item._id === $scope.vm.WorkOrderID;
          })[0];
        } catch (e) { }
        $scope.vm.Types = getSalesOrderType.Types;
      }
      else {
        $scope.vm.Types = "";
      }
    }
    $scope.AdhocUpdate = function () {
      $scope.IndexID = $scope.IndxID;
      if ($scope.vm.CustomerID == "" || $scope.vm.CustomerID == undefined) { $scope.vm.CustomerID = null }
      if ($scope.vm.WorkOrderID == "" || $scope.vm.WorkOrderID == undefined) { $scope.vm.WorkOrderID = null }
      if ($scope.vm.ContractID == "" || $scope.vm.ContractID == undefined) { $scope.vm.ContractID = null }
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/updateAdhocdetail",
        data: {
          _id: $scope.vm.ScedulId,
          Customer: $scope.vm.CustomerID,
          JobsOrders: $scope.vm.WorkOrderID,
          ContractOrder: $scope.vm.ContractID,
          Types: $scope.vm.Types,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
        $scope.AdhocJobsdatas[$scope.IndexID] = GList.data.data[0];
        //RefreshGrid();
        $mdDialog.cancel();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.BillableSubmit = function () {
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/scheduler/update",
        data: {
          _id: $scope.vm.ScedulId,
          Types: $scope.vm.Types,
          JobType: $scope.vm.JobType,
          PreferredTime: $scope.vm.PreferredTime,
          SpecialRemark: $scope.vm.SpecialRemark,
          UpdatedBy: $rootScope.createdby
        },
      });
      response.then(function (GList) {
        $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
        RefreshGrid();
        $mdDialog.cancel();
      });
    }
    $scope.EditmobileSubmit = function () {
      if ($scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == undefined) {
        $scope.vm.BreedingFound = null;
      }
      if ($scope.vm.Species == "" || $scope.vm.Species == "undefined" || $scope.vm.Species == undefined) {
        $scope.vm.Species = null;
      }
      if ($scope.vm.Findings == "" || $scope.vm.Findings == "undefined" || $scope.vm.Findings == undefined) {
        $scope.vm.Findings = null;
      }
      if ($scope.vm.MistingCariedOut == "" || $scope.vm.MistingCariedOut == "undefined" || $scope.vm.MistingCariedOut == undefined) {
        $scope.vm.MistingCariedOut = null;
      }
      if ($scope.vm.Reason == "" || $scope.vm.Reason == "undefined" || $scope.vm.Reason == undefined) {
        $scope.vm.Reason = null;
      }
      if ($scope.vm.Instar == "" || $scope.vm.Instar == "undefined" || $scope.vm.Instar == undefined) {
        $scope.vm.Instar = null;
      }
      if ($scope.vm.Density == "" || $scope.vm.Density == "undefined" || $scope.vm.Density == undefined) {
        $scope.vm.Density = null;
      }
      if ($scope.vm.Others == "" || $scope.vm.Others == "undefined" || $scope.vm.Others == undefined) {
        $scope.vm.Others = null;
      }
      if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
        $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
      }
      if ($scope.vm.MMaterialsName != null && $scope.vm.MMaterialsName != "" && $scope.vm.MMaterialsName != undefined) {
        $scope.vm.MMaterialsName = $scope.vm.MMaterialsName.map(function (obj) { return obj.MaterialsName; }).join(',');
      }

      if ($scope.vm.tbsc_id != undefined && $scope.vm.tbsc_id != null && $scope.vm.tbsc_id != "") {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletschedulerrecord/update",
          data: {
            _id: $scope.vm.tbsc_id,
            ServiceId: $scope.vm.ServiceID,
            Team: $scope.vm.TeamName,
            Scheduledate: $scope.vm.ServiceStartAt,
            WorkorderNo: $scope.vm.SalesOrderNo,
            ContractOrderNo: $scope.vm.ContractReferenceNo,
            CustomerName: $scope.vm.CompanyName,
            Location: $scope.vm.Location,
            Startsat: $scope.vm.Startsat,
            Endsat: $scope.vm.Endsat,
            Pesttype: $scope.vm.PestType1,
            Services: $scope.vm.MServicetype,
            TeamLead: $scope.vm.TeamLead,
            TeamMember: $scope.vm.TeamMembers,
            TeamRemarks: $scope.vm.TeamRemarks,
            TeamSignature: $scope.vm.TeamSignature,
            BreedingFound: $scope.vm.BreedingFound,
            Species: $scope.vm.Species,
            Findings: $scope.vm.Findings,
            MistingCariedOut: $scope.vm.MistingCariedOut,
            Density: $scope.vm.Density,
            Instar: $scope.vm.Instar,
            Reason: $scope.vm.Reason,
            CustomerCurrentDate: $scope.CustomerCurrentDate,
            Rating: $scope.vm.starRating1,
            Materials: $scope.vm.MMaterialsName,
            CustomerRemarks: $scope.vm.CustomerRemarks,
            CustomerSignature: $scope.vm.CustomerSignature,
            Paymentmethod: $scope.vm.Paymentmethod,
            Totalpayment: $scope.vm.Totalpayment,
            PaymentNotes: $scope.vm.PaymentNotes,
            Totalarea: $scope.vm.Totalarea,
            EmailId: $scope.vm.MobilEmailId,
            PaymentRemarks: $scope.vm.PaymentRemarks,
            Totalcompleted: $scope.vm.Totalcompleted,
          },
        });
        response.then(function (GList) {
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          $mdDialog.cancel();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        })
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/add",
          data: {
            ServiceId: $scope.vm.ScedulId,
            Team: $scope.vm.TeamName,
            Scheduledate: $scope.vm.ServiceStartAt,
            WorkorderNo: $scope.vm.SalesOrderNo,
            ContractOrderNo: $scope.vm.ContractReferenceNo,
            CustomerName: $scope.vm.CompanyName,
            Location: $scope.vm.Location,
            Startsat: new Date(),
            Endsat: new Date(),
            Pesttype: $scope.vm.PestType1,
            Services: $scope.vm.MServicetype,
            TeamLead: $scope.vm.TeamLead,
            TeamMember: $scope.vm.TeamMembers,
            TeamRemarks: $scope.vm.TeamRemarks,
            TeamSignature: $scope.vm.TeamSignature,
            BreedingFound: $scope.vm.BreedingFound,
            Species: $scope.vm.Species,
            Findings: $scope.vm.Findings,
            MistingCariedOut: $scope.vm.MistingCariedOut,
            Density: $scope.vm.Density,
            Instar: $scope.vm.Instar,
            Reason: $scope.vm.Reason,
            CustomerCurrentDate: new Date(),
            Rating: $scope.vm.starRating1,
            Materials: $scope.vm.MMaterialsName,
            CustomerRemarks: $scope.vm.CustomerRemarks,
            CustomerSignature: $scope.vm.CustomerSignature,
            Paymentmethod: $scope.vm.Paymentmethod,
            Totalpayment: $scope.vm.Totalpayment,
            PaymentNotes: $scope.vm.PaymentNotes,
            Totalarea: $scope.vm.Totalarea,
            EmailId: $scope.vm.MobilEmailId,
            PaymentRemarks: $scope.vm.PaymentRemarks,
            Totalcompleted: $scope.vm.Totalcompleted,
            CreatedBy: $rootScope.createdby,
          },
        });
        response.then(function (GList) {
          var response1 = $http({
            url: $rootScope.WebURL + "/scheduler/Statusupdate",
            method: "PUT",
            data: {
              _id: $scope.vm.ScedulId,
              Status: "Completed",
              UpdatedBy: $rootScope.createdby,
            },
          });
          response1.then(function (GList) {
            $mdDialog.cancel();
            $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
            $mdDialog.cancel();
            RefreshGrid();
          });
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        })
      }
    }
    $scope.getpos = function (event) {
      $scope.lat = event.latLng.lat();
      $scope.lng = event.latLng.lng();
      $scope.latlng = [event.latLng.lat(), event.latLng.lng()];
    };
    $scope.placeMarker = function () {
      console.log(this.getPlace());
      var loc = this.getPlace().geometry.location;
      $scope.latlng = [loc.lat(), loc.lng()];
      $scope.center = [loc.lat(), loc.lng()];
    };
    $scope.EditMobileLogs = function (e, Sid) {
      $scope.vm.SMLMUpdate = false;
      $scope.vm.SMUpdate = false;
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.MLSMPestType = null;
      $scope.vm.MMaterialsName = null;
      $scope.vm.MQuantity = null;
      $scope.vm.MUnit = null;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Editemobilelog.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ServiceID = Sid;
      $scope.vm.starRating1 = 0;
      $scope.vm.tbsc_id = null;
      if ($scope.vm.Status == 'Completed') {
        angular.forEach($scope.Tabletschedulerrecord, function (value) {
          try {
            if ($scope.vm.ScedulId === value.ServiceId) {
              $scope.vm.tbsc_id = value._id
              $scope.vm.Pesttype = value.Pesttype
              if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
                var array = $scope.vm.Pesttype.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ PestName: value });
                });
                $scope.Pestdatas = array1;
              }
              $scope.vm.Services = value.Services
              $scope.vm.Materials = value.Materials
              if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                var array = $scope.vm.Services.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ Servicetype: value });
                });
                $scope.vm.MServicetype = array1;
              }
              if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                var array = $scope.vm.Materials.split(",");
                var array1 = [];
                angular.forEach(array, function (value) {
                  array1.push({ MaterialsName: value });
                });
                $scope.vm.MMaterialsName = array1;
              }
              $scope.vm.TeamMember = value.TeamMember
              $scope.vm.TeamRemarks = value.TeamRemarks
              $scope.vm.CustomerRemarks = value.CustomerRemarks
              $scope.vm.CustomerRemarks = value.CustomerRemarks
              $scope.vm.TeamLead = value.TeamLead
              $scope.vm.ATimeIn = new Date(value.Startsat);
              $scope.vm.ATimeOut = new Date(value.Endsat);
              $scope.vm.Scheduledate = new Date(value.Scheduledate);
              $scope.CustomerSignature = value.CustomerSignature;
              $scope.uPB1 = value.PB1;
              $scope.uPB2 = value.PB2;
              $scope.uPB3 = value.PB3;
              $scope.uPB4 = value.PB4;
              $scope.uPA1 = value.PA1;
              $scope.uPA2 = value.PA2;
              $scope.uPA3 = value.PA3;
              $scope.uPA4 = value.PA4;
              $scope.vm.TeamSignature = value.TeamSignature;
              $scope.vm.Paymentmethod = value.Paymentmethod;
              $scope.vm.MobilEmailId = value.EmailId;
              $scope.vm.PaymentRemarks = value.PaymentRemarks;
              $scope.vm.Totalpayment = parseInt(value.Totalpayment);
              $scope.vm.PaymentNotes = value.PaymentNotes;
              $scope.vm.Totalarea = parseInt(value.Totalarea);
              $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
              $scope.starRating1r = value.Rating;
              $scope.vm.starRating1 = value.Rating;
              $scope.vm.AServiceStartAt = new Date(value.Startsat);
              $scope.vm.AServiceEndAt = new Date(value.Endsat);
              $scope.vm.CustomerCurrentDate = new Date(CustomerCurrentDate);
            }
          }
          catch (e) { }
        })
      }
      else {
        $scope.vm.tbsc_id = null;
      }
    }
    $scope.vm.AStartTime = new Date()
    $scope.vm.AEndTime = new Date()

    $scope.dateBox = {
      ServiceStartTime: {
        type: "time",
        value: $scope.vm.ServiceStartTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceStartTime = e.value
          $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.ServiceStartTime'
        }
      },
      ServiceEndTime: {
        type: "time",
        value: $scope.vm.ServiceEndTime,
        onValueChanged: function (e) {
          $scope.vm.ServiceEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ServiceEndTime'
        }
      },
      PreferredStartTime: {
        type: "time",
        value: $scope.vm.PreferredStartTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredStartTime = e.value
          // $scope.vm.PreferredEndTime = new Date(moment(e.value).add(1, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.PreferredStartTime'
        }
      },
      PreferredEndTime: {
        type: "time",
        value: $scope.vm.PreferredEndTime,
        onValueChanged: function (e) {
          $scope.vm.PreferredEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.PreferredEndTime'
        }
      },
      AvoidStartTime: {
        type: "time",
        value: $scope.vm.AvoidStartTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidStartTime = e.value
          // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
        },
        bindingOptions: {
          'value': 'vm.AvoidStartTime'
        }
      },
      AvoidEndTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.AvoidEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AvoidEndTime'
        }
      },
      ResheduleSSTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleSSTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSSTime'
        }
      },
      ResheduleSETime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleSETime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleSETime'
        }
      },
      ResheduleStartTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleStartTime = e.value
          $scope.vm.ResheduleEndTime = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
        },
        bindingOptions: {
          'value': 'vm.ResheduleStartTime'
        }
      },
      ResheduleEndTime: {
        type: "time",
        value: $scope.vm.AvoidEndTime,
        onValueChanged: function (e) {
          $scope.vm.ResheduleEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleEndTime'
        }
      },
      ResheduleFrom: {
        type: "date",
        displayFormat: "dd/MM/yyy",
        value: $scope.vm.ResheduleFrom,
        onValueChanged: function (e) {
          $scope.vm.ResheduleFrom = e.value
        },
        bindingOptions: {
          'value': 'vm.ResheduleFrom'
        }
      },
      AStartTime: {
        type: "datetime",
        value: $scope.vm.AStartTime,
        onValueChanged: function (e) {
          $scope.vm.AStartTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AStartTime'
        }
      },
      AEndTime: {
        type: "datetime",
        value: $scope.vm.AEndTime,
        onValueChanged: function (e) {
          $scope.vm.AEndTime = e.value
        },
        bindingOptions: {
          'value': 'vm.AEndTime'
        }
      },
    },
      // Add function for new design..............
      $scope.addNewSchedule = function (e) {
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/operations/scheduler/NewAdd.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          controller: function operationsProjectController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
        $scope.vm.Twiceday = null
        $scope.vm.uContactPerson = null
        $scope.vm.ClientEmail = null
        $scope.vm.SiteContactName = null
        $scope.vm.SiteAddress = null
        $scope.vm.SiteContactNumber = null
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
        $scope.ServiceAddressarray = [];
        $scope.thdata = true;
        $scope.vm.Types = 'Follow-up'
        $scope.vm.JobType = 'Fixed'
        $scope.vm.SFOPH = "Next Day";
        $scope.vm.jobdata = null;
        $scope.vm.SearchGetCW = null;
        $scope.customer = null;
        $scope.vm.AssignedTo = null;
        $scope.vm.ContractOrder = null;
        $scope.vm.PreferredTime = null;
        $scope.vm.SpecialRemark = null;
        $scope.vm.firstSpecialRemark = null;
        $scope.vm.PreferredStartTime = null;
        $scope.vm.PreferredEndTime = null;
        $scope.vm.AvoidStartTime = null;
        $scope.vm.AvoidEndTime = null;
        $scope.vm.ppZone = '';
        var today = new Date();
        $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 9, 0, 0);
        $scope.vm.ServiceEndTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 10, 0, 0);
        $scope.vm.Frequency = "";
        if ($scope.selected.length === $scope.items.length) {
          $scope.selected = [];
        } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
          $scope.selected = [];
        }

        $scope.vm.AStartTime = new Date()
        $scope.vm.AEndTime = new Date()

        $scope.dateBox = {
          ServiceStartTime: {
            type: "time",
            value: $scope.vm.ServiceStartTime,
            onValueChanged: function (e) {
              $scope.vm.ServiceStartTime = e.value
              // $scope.vm.ServiceEndTime.setHours(e.value.getHours() + 1, e.value.getMinutes(), e.value.getSeconds())
              $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
            },
            bindingOptions: {
              'value': 'vm.ServiceStartTime'
            }
          },
          ServiceEndTime: {
            type: "time",
            value: $scope.vm.ServiceEndTime,
            onValueChanged: function (e) {
              $scope.vm.ServiceEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.ServiceEndTime'
            }
          },
          PreferredStartTime: {
            type: "time",
            value: $scope.vm.PreferredStartTime,
            onValueChanged: function (e) {
              $scope.vm.PreferredStartTime = e.value
              // $scope.vm.PreferredEndTime = new Date(moment(e.value).add(1, 'hours'))
            },
            bindingOptions: {
              'value': 'vm.PreferredStartTime'
            }
          },
          PreferredEndTime: {
            type: "time",
            value: $scope.vm.PreferredEndTime,
            onValueChanged: function (e) {
              $scope.vm.PreferredEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.PreferredEndTime'
            }
          },
          AvoidStartTime: {
            type: "time",
            value: $scope.vm.AvoidStartTime,
            onValueChanged: function (e) {
              $scope.vm.AvoidStartTime = e.value
              // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
            },
            bindingOptions: {
              'value': 'vm.AvoidStartTime'
            }
          },
          AvoidEndTime: {
            type: "time",
            value: $scope.vm.AvoidEndTime,
            onValueChanged: function (e) {
              $scope.vm.AvoidEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.AvoidEndTime'
            }
          },
          ResheduleSSTime: {
            type: "time",
            value: $scope.vm.AvoidEndTime,
            onValueChanged: function (e) {
              $scope.vm.AvoidEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.ResheduleSSTime'
            }
          },
          ResheduleSETime: {
            type: "time",
            value: $scope.vm.AvoidEndTime,
            onValueChanged: function (e) {
              $scope.vm.AvoidEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.ResheduleSETime'
            }
          },
          ResheduleStartTime: {
            type: "time",
            value: $scope.vm.AvoidEndTime,
            onValueChanged: function (e) {
              $scope.vm.ResheduleStartTime = e.value
              $scope.vm.ResheduleEndTime = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
            },
            bindingOptions: {
              'value': 'vm.ResheduleStartTime'
            }
          },
          ResheduleEndTime: {
            type: "time",
            value: $scope.vm.AvoidEndTime,
            onValueChanged: function (e) {
              $scope.vm.ResheduleEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.ResheduleEndTime'
            }
          },
          ResheduleFrom: {
            type: "date",
            displayFormat: "dd/MM/yyy",
            value: $scope.vm.ResheduleFrom,
            onValueChanged: function (e) {
              $scope.vm.ResheduleFrom = e.value
            },
            bindingOptions: {
              'value': 'vm.ResheduleFrom'
            }
          },
          AStartTime: {
            type: "datetime",
            value: $scope.vm.AStartTime,
            onValueChanged: function (e) {
              $scope.vm.AStartTime = e.value
            },
            bindingOptions: {
              'value': 'vm.AStartTime'
            }
          },
          AEndTime: {
            type: "datetime",
            value: $scope.vm.AEndTime,
            onValueChanged: function (e) {
              $scope.vm.AEndTime = e.value
            },
            bindingOptions: {
              'value': 'vm.AEndTime'
            }
          },
        }
        $scope.vm.GetCWCType = "Customers";
        $scope.vm.ServiceStartAt = null;
        $scope.vm.ServiceEndAt = null;
        $scope.vm.PestType = null;
        $scope.vm.ppCompanyName = null;
        $scope.vm.ppWorkOrder = null;
        $scope.vm.ppContractNo = null;
        $scope.vm.TM = null;
        $scope.vm.JobsPerFrequency = null;
        $scope.vm.ServicesRequired = null;
        $scope.vm.ForBiWeekly = '';
        $scope.vm.ForMonthly = '';
        $scope.vm.ForBiMonthly = '';
        $scope.vm.ForYearlyWeek = '';
        $scope.vm.ForYearly = '';
        $scope.vm.ForQuaterlyWeek = '';
        $scope.vm.ForQuaterly = '';
        $scope.vm.ForHalfYearlyWeek = '';
        $scope.vm.ForHalfYearly = '';
        $scope.Update = false;
        $scope.Holidays = { value: true };
        $scope.Summary = '';
        $scope.vm.ScheduleType = "Fixed";
      };
    $scope.addCustomSchedule = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomAdd.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.AllSASelec = { value: false };
      $scope.SASelec = { value: false };
      $scope.svAll = { value: false };
      $scope.ServiceAddressarray = [];
      $scope.thdata = true;
      $scope.vm.Types = 'Follow-up'
      $scope.vm.SFOPH = "Skip";
      $scope.vm.jobdata = null;
      $scope.vm.SearchGetCW = null;
      $scope.customer = null;
      $scope.vm.AssignedTo = null;
      $scope.vm.ContractOrder = null;
      var today = new Date();
      $scope.vm.ServiceStartTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 30, 0);
      $scope.vm.ServiceEndTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 17, 30, 0);
      $scope.vm.Frequency = "";
      if ($scope.selected.length === $scope.items.length) {
        $scope.selected = [];
      } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = [];
      }
      $scope.vm.GetCWCType = "Customers";
      $scope.vm.ServiceStartAt = null;
      $scope.vm.ServiceEndAt = null;
      $scope.vm.PestType = null;
      $scope.vm.ppCompanyName = null;
      $scope.Update = false;
      $scope.vm.ForQuaterlyWeek = '';
      $scope.Holidays = { value: true };
      $scope.vm.ppWorkOrder = null;
      $scope.vm.ppContractNo = null;
      $scope.vm.TM = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.ForBiWeekly = '';
      $scope.vm.ForMonthly = '';
      $scope.vm.ForBiMonthly = '';
      $scope.vm.ForYearlyWeek = '';
      $scope.vm.ForYearly = '';
      $scope.vm.ForQuaterlyWeek = '';
      $scope.vm.ForQuaterly = '';
      $scope.vm.ForHalfYearlyWeek = '';
      $scope.vm.ForHalfYearly = '';
      $scope.Summary = '';
      $scope.vm.ScheduleType = "Custom";
    };
    $scope.GetCWC = function (a) {
      $scope.vm.SO = null;
      $scope.vm.ServiceEndAt = null;
      $scope.AllSASelec = { value: false };
      $scope.SASelec = { value: false };
      $scope.svAll = { value: false };
      $scope.ServiceAddressarray = [];
      $scope.CustomerServicedatas = [];
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/GetCWC.html',
        parent: angular.element($document.body),
        targetEvent: a,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          },
            $('#Detailsdt').DataTable({
            });
          vm.dtdetails = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
              var api = this.api(),
                searchBox = angular.element('body').find('#forms-Detailsdt');
              var table = $('#Detailsdt').DataTable();
              table.search('').draw();
              // Bind an external input as a table wide search box
              if (searchBox.length > 0) {
                searchBox.on('keyup', function (event) {
                  api.search(event.target.value).draw();
                });
              }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[3, "asc"]],
            lengthMenu: [5, 10, 20, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
              "lengthMenu": $rootScope.lengthMenu,
              "zeroRecords": $rootScope.zeroRecords,
              "info": $rootScope.info,
              "infoEmpty": $rootScope.infoEmpty,
              "infoFiltered": $rootScope.infoFiltered,
              "Header": $rootScope.Header,
            }

          };
        }
      });

      $scope.vm.Location = null;
      $scope.vm.SO = null;
      $scope.vm.ppCompanyName = null;
      $scope.vm.Customersearch = null;
      $scope.vm.jobdata = null;
      $scope.vm.ContractOrder = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.ppWorkOrder = null;
      $scope.vm.ppContractNo = null;
      $scope.vm.ShowScheduledStatus = "New";
      $scope.vm.ShowScheduled = false;
      $scope.vm.ForBiWeekly = '';
      $scope.vm.ForMonthly = '';
      $scope.vm.ForBiMonthly = '';
      $scope.vm.ForYearlyWeek = '';
      $scope.vm.ForYearly = '';
      $scope.vm.ForQuaterlyWeek = '';
      $scope.vm.ForQuaterly = '';
      $scope.vm.ForHalfYearlyWeek = '';
      $scope.vm.ForHalfYearly = '';
      $scope.vm.PreferredTime = null;
      $scope.vm.ppZone = '';
      $scope.vm.SpecialRemark = null;
      $scope.vm.firstSpecialRemark = null;
      if ($scope.vm.SearchGetCW != null && $scope.vm.SearchGetCW != undefined && $scope.vm.SearchGetCW != "") {
        $scope.vm.SearchGetCW = $scope.vm.SearchGetCW.toUpperCase();
        if ($scope.vm.GetCWCType == "Customers") {
          try {
            var item = $scope.Customerdatas.filter(function (item) {
              return item.CompanyName.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            var SOarray = [];
            var Carray = [];
            angular.forEach(data, function (value) {
              var item1 = $scope.salesdatas.filter(function (item1) {
                return item1.Customer_id === value.id;
              });
              var item2 = $scope.contractdatas.filter(function (item2) {
                return item2.Customer_id === value.id;
              });
              SOarray.push(item1);
            })
            angular.forEach(SOarray, function (value) {
              angular.forEach(value, function (innervalue) {
                Carray.push(innervalue);
              })
            })
            angular.forEach(Carray, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach($scope.contractdatas, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = Carray.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = Carray.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
        if ($scope.vm.GetCWCType == "WorkOrder") {
          try {
            var item = $scope.salesdatas.filter(function (item) {
              return item.SalesOrderNo.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            angular.forEach(data, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach($scope.contractdatas, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
        if ($scope.vm.GetCWCType == "Contracts") {
          try {
            var item = $scope.contractdatas.filter(function (item) {
              return item.ContractReferenceNo.toUpperCase().indexOf($scope.vm.SearchGetCW) > -1;
            });
            var data = item;
            angular.forEach($scope.salesdatas, function (cvalue) {
              cvalue.IsActive = "";
              cvalue.TotalOrderValue = null;
              angular.forEach(data, function (value) {
                if (cvalue.ContractNo == value._id) {
                  cvalue.IsActive = value.ContractReferenceNo;
                  cvalue.TotalOrderValue = value._id;
                }
              })
            })
            try {
              var item = [];
              if ($scope.vm.ScheduleType == 'Fixed') {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && item.Status != 'Scheduled' && item.Status != 'Completed';
                });
              }
              else {
                item = data.filter(function (item) {
                  return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
                });
              }
              $scope.CWCDatas = item;
            }
            catch (e) { }
          }
          catch (e) { }
        }
      }
      else {
        var data = $scope.salesdatas
        angular.forEach(data, function (cvalue) {
          cvalue.IsActive = "";
          cvalue.TotalOrderValue = null;
          angular.forEach($scope.contractdatas, function (value) {
            if (cvalue.ContractNo == value._id) {
              cvalue.IsActive = value.ContractReferenceNo;
              cvalue.TotalOrderValue = value._id;
            }
          })
        })
        try {
          var item = [];
          if ($scope.vm.ScheduleType == 'Fixed') {
            item = data.filter(function (item) {
              return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
          }
          else {
            item = data.filter(function (item) {
              return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
          }
          $scope.CWCDatas = item;
        }
        catch (e) { }
      }
    }
    $scope.PHDetails = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/PublicHolidays.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      if ($scope.vm.ServiceStartAt != null && $scope.vm.ServiceStartAt != undefined && $scope.vm.ServiceStartAt != "") {
        var FilterStart_Date = new Date($scope.vm.ServiceStartAt);
        var FilterEnd_Date = new Date($scope.vm.ServiceEndAt);
        FilterStart_Date.setHours(0, 0, 0, 0);
        FilterEnd_Date.setHours(23, 59, 59, 999);
        var response = $http({
          url: $rootScope.WebURL + "/calendar/datefilter",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id, FilterStart_Date: FilterStart_Date, FilterEnd_Date: FilterEnd_Date },
        });
        response.then(function (GList) {
          $scope.PHDetailsdatas = GList.data.data;
        });
      }
      else {
        $http({
          url: $rootScope.WebURL + "/calendar",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Calendardata) {
          $scope.PHDetailsdatas = Calendardata.data.data;
        });
      }
    }
    $scope.GetSummary = function (sm) {
      var days = ''
      var Includes = '';
      if ($scope.Holidays.value == true) { Includes = 'Excludes' }
      if ($scope.Holidays.value == false) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      if (sm == 'FORTNIGHTLY') {
        $scope.Summary = 'Occurs every two week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'MONTHLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'BIMONTHLY') {
        $scope.Summary = 'Occurs every two months ' + $scope.vm.ForBiMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'QUARTERLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForQuaterly + ' month of ' + $scope.vm.ForQuaterlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'HALFYEARLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForHalfYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      if (sm == 'YEARLY') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForYearly + ' month of ' + $scope.vm.ForYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
    }
    $scope.GetSummaryforP = function (ph) {
      var days = ''
      var Includes = '';
      if (ph == false) { Includes = 'Excludes' }
      if (ph == true) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      $scope.Summary = 'Occurs every week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
    }
    $scope.sNewSubmit = function (M) {

      if ($scope.vm.Twiceday != null && $scope.selected[0].id === $scope.vm.Twiceday.id) {
        $mdToast.show($mdToast.simple().textContent('Please select different days for Twice of Week!').position('top center'));
      } else {
        $scope.vm.PreviewSpinner = true;
        $http({
          url: $rootScope.WebURL + "/scheduler/checkWorkOrer",
          method: "POST",
          data: { JobsOrders: $scope.vm.jobdata },
        }).then(function (WList) {
          var ServicesRequiredper = 0;
          $scope.vm.CheckWorkOrerCount = WList.data.data;
          if ($scope.vm.ServicesRequired != null && $scope.vm.ServicesRequired != undefined && $scope.vm.ServicesRequired != "") {
            var ServicesRequiredper = parseInt($scope.vm.ServicesRequired);
          }
          setTimeout(function () {
            $scope.vm.PreviewSpinner = false;
            if ($scope.vm.CheckWorkOrerCount > ServicesRequiredper) {
              $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/scheduler/workordercheck.html',
                parent: angular.element($document.body),
                targetEvent: M,
                scope: $scope.$new(),
                controller: function operationsProjectController($scope, $mdDialog) {
                  $scope.closeDialog = function () {
                    $mdDialog.hide();
                  }
                }
              });
            }
            else {
              $scope.SchedulerCalculation(M)
              // $scope.CheckWorkOrderYes(M)
            }
          }, 2000)
        });
      }
    }

    $scope.CheckWorkOrderYes = function (M) {
      $scope.vm.PreviewSpinner = true;
      $http.get($rootScope.WebURL + "/scheduler/getLength")
        .then(function (scheduler) {
          var schedulerdatasforlength = scheduler.data.data;
          if (new Date($scope.vm.ServiceStartAt) < new Date()) {
            $scope.vm.ServiceStartAt = new Date();
          }
          $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
          $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
          var previewdata = [];
          $scope.previewdatas = [];
          var oneDay = 24 * 60 * 60 * 1000;
          var datecount = Math.round(Math.abs(($scope.vm.SSAt.getTime() - $scope.vm.SSEt.getTime()) / (oneDay)));
          var daysId = $scope.selected.map(function (obj) { return obj.id; }).join(',');
          var fqw = 1;
          var t = 1;
          var twm = 0;
          angular.forEach($scope.vm.PestType, function (value) {
            try {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return value.PestName == pt.PestName;
              })[0];
              value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
            } catch (e) { }
          })
          var groupedFrequency = _.groupBy($scope.vm.PestType, 'Frequency');
          var Fnum = 0;
          try {
            Fnum = $scope.vm.PestType.map(function (Fnum) {
              return parseInt(Fnum["ServicesRequired"])
            });
            Fnum = Math.max.apply(null, Fnum);
          }
          catch (e) { }
          var Assigned = $scope.vm.AssignedTo.map(function (obj) { return obj.id; }).join(',');
          Assigned = Assigned.split(',')
          angular.forEach(groupedFrequency, function (element) {
            element.Frequency = element[0].Frequency;
            element.PestName = element.map(function (obj) { return obj.PestName; }).join(',');
            element.PestCode = element.map(function (obj) { return obj.PestCode; }).join(',');
            $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
            $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
            for (var i = 0; i <= datecount; i++) {
              if (element.Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || element.Frequency.toUpperCase().indexOf('DAILY') > -1 || element.Frequency.toUpperCase().indexOf('WEEKLY') > -1
                || element.Frequency.toUpperCase().indexOf('1 WEEK') > -1 || element.Frequency.toUpperCase().indexOf('2 WEEKS') > -1 || element.Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1
                || element.Frequency.toUpperCase().indexOf('BIWEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1
                || element.Frequency.toUpperCase().indexOf('10 DAYS') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A WEEK (104)') > -1 || element.Frequency.toUpperCase().indexOf('TWICE A WEEK') > -1
                || element.Frequency.toUpperCase().indexOf('AD-HOC') > -1) {
                var currentDate = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + i));
                if ((element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1) && previewdata.length > 0) {
                  var LastStartsat = new Date(previewdata[previewdata.length - 1].Startsat);
                  // if (LastStartsat.getDate() >= 15) {
                  //   var fday = (new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay() == 0) ? 7 : new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
                  //   var fistdate = (7 - fday) + parseInt($scope.selected[0].id)
                  //   currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), fistdate + 1);
                  // }
                  if (twm >= 2) {
                    i = i + (37 - LastStartsat.getDate());
                    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, fqw, currentDate);
                    twm = 0;
                  }
                }
                var endDate = new Date($scope.vm.SSEt);
                if (currentDate <= endDate) {
                  var SameTeam = 'No';
                  try {
                    angular.forEach($scope.Teamtabledata, function (items) {
                      if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(currentDate, 'dd/MM/yyyy')) {
                        var edd = new Date(items.Startsat);
                        var ehh = $scope.vm.ServiceStartTime;
                        var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        var edd = new Date(items.Startsat);
                        var ehh = $scope.vm.ServiceEndTime;
                        var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        var edd = new Date(items.Startsat);
                        var ehh = new Date(items.Endsat);
                        var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                        if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
                          SameTeam = 'Yes';
                        }
                        else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
                          SameTeam = 'Yes';
                        }
                        else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
                          SameTeam = 'Yes';
                        }
                        else if (startTime < EndDate && endTime >= EndDate) {
                          SameTeam = 'Yes';
                        }
                        else {
                          //SameTeam = 'No';
                        }
                      }
                    });
                  }
                  catch (e) { }
                  if (daysId.indexOf(currentDate.getDay()) > -1) {
                    var ServiceOn = $filter('date')(currentDate, 'EEEE');
                    var dd = currentDate;
                    var hh = $scope.vm.ServiceStartTime;
                    var mm = new Date(hh.setMonth(new Date(dd).getMonth()));
                    var yy = new Date(mm.setDate(new Date(dd).getDate()));
                    currentDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    var edd = endDate;
                    var ehh = $scope.vm.ServiceEndTime;
                    var emm = new Date(ehh.setMonth(new Date(edd).getMonth()));
                    var eyy = new Date(emm.setDate(new Date(edd).getDate()));
                    endDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    previewdata.push({
                      PestType: element.PestName,
                      PestCode: element.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: currentDate,
                      Endsat: endDate,
                      Frequency: element.Frequency,
                      SameTeam: SameTeam
                    })
                    if (element.Frequency.toUpperCase().indexOf('FORTNIGHTLY') > -1 || element.Frequency.toUpperCase().indexOf('BI-WEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('2 WEEKS') > -1 || element.Frequency.toUpperCase().indexOf('BIWEEKLY') > -1 || element.Frequency.toUpperCase().indexOf('FORTNIGHTLY (26)') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        i = i + 13;
                      }
                      else { t++; }
                    }
                    if (element.Frequency.toUpperCase().indexOf('TWICE A MONTH (24)') > -1 || element.Frequency.toUpperCase().indexOf('15 DAYS') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        if ($filter('date')(previewdata[previewdata.length - 1].Startsat, 'MM') == $filter('date')(currentDate, 'MM')) {
                          twm++;
                        }
                        if (twm == 1) {
                          i = i + 7;
                        }
                      }
                      else { t++; }
                    }
                    if (element.Frequency.toUpperCase().indexOf('10 DAYS') > -1) {
                      if (t == $scope.selected.length) {
                        t = 1;
                        i = i + 10;
                      }
                      else { t++; }
                    }
                  }
                }
              }
              else {
                angular.forEach($scope.selected, function (value, key) {
                  fqw = 1;
                  // if (key == 0) {
                  //   if ($scope.vm.SSAt.setHours(23, 59, 59, 999) <= new Date().setHours(23, 59, 59, 999)) {
                  //     fqw = ($scope.vm.SSAt.getWeekOfMonth() == 6) ? $scope.vm.SSAt.getWeekOfMonth() - 1 : $scope.vm.SSAt.getWeekOfMonth();
                  //   }
                  // }
                  var wc = (getWeekOfMonth($scope.vm.SSAt) == 6) ? getWeekOfMonth($scope.vm.SSAt) - 1 : getWeekOfMonth($scope.vm.SSAt);
                  fqw = (daysInMonth($scope.vm.SSAt, value.id).length < wc) ? daysInMonth($scope.vm.SSAt, value.id).length : wc;
                  var currentDate = nthWeekdayOfMonth(value.id, fqw, $scope.vm.SSAt);
                  var endDate = new Date($scope.vm.SSEt);
                  if (currentDate <= endDate) {
                    var SameTeam = 'No';
                    try {
                      angular.forEach($scope.Teamtabledata, function (items) {
                        if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(currentDate, 'dd/MM/yyyy')) {
                          var edd = new Date(items.Startsat);
                          var ehh = $scope.vm.ServiceStartTime;
                          var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                          var edd = new Date(items.Startsat);
                          var ehh = $scope.vm.ServiceEndTime;
                          var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

                          var edd = new Date(items.Startsat);
                          var ehh = new Date(items.Endsat);
                          var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));
                          if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
                            SameTeam = 'Yes';
                          }
                          else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
                            SameTeam = 'Yes';
                          }
                          else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
                            SameTeam = 'Yes';
                          }
                          else if (startTime < EndDate && endTime >= EndDate) {
                            SameTeam = 'Yes';
                          }
                          else {
                            //SameTeam = 'No';
                          }
                        }
                      })
                    }
                    catch (e) { SameTeam = 'No' }
                    var ServiceOn = $filter('date')(currentDate, 'EEEE');
                    var dd = currentDate;
                    var hh = $scope.vm.ServiceStartTime;
                    var mm = new Date(hh.setMonth(new Date(dd).getMonth()));
                    var yy = new Date(mm.setDate(new Date(dd).getDate()));
                    currentDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    var edd = endDate;
                    var ehh = $scope.vm.ServiceEndTime;
                    var emm = new Date(ehh.setMonth(new Date(edd).getMonth()));
                    var eyy = new Date(emm.setDate(new Date(edd).getDate()));
                    endDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    previewdata.push({
                      PestType: element.PestName,
                      PestCode: element.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: currentDate,
                      Endsat: endDate,
                      Frequency: element.Frequency,
                      SameTeam: SameTeam
                    })
                    if (key == $scope.selected.length - 1) {
                      if (element.Frequency.toUpperCase() == 'MONTHLY' || element.Frequency.toUpperCase().indexOf('MONTHLY (12)') > -1 || element.Frequency.toUpperCase().indexOf('1 MONTH') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 1));
                      }
                      else if (element.Frequency.toUpperCase() == 'BIMONTHLY' || element.Frequency.toUpperCase().indexOf('BI-MONTHLY (6)') > -1 || element.Frequency.toUpperCase().indexOf('BI-MONTHLY') > -1 || element.Frequency.toUpperCase().indexOf('2 MONTHS') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 2));
                      }
                      else if (element.Frequency.toUpperCase() == 'QUARTERLY (4)' || element.Frequency.toUpperCase() == 'QUARTERLY' || element.Frequency.toUpperCase().indexOf('3 MONTHS') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 3));
                      }
                      else if (element.Frequency.toUpperCase() == 'HALF-YEARLY' || element.Frequency.toUpperCase().indexOf('HALFY-EARLY (2)') || element.Frequency.toUpperCase().indexOf('6 WEEKS') > -1 > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 6));
                      }
                      else if (element.Frequency.toUpperCase() == 'YEARLY' || element.Frequency.toUpperCase().indexOf('YEARLY (1)') > -1) {
                        $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setMonth(new Date($scope.vm.SSAt).getMonth() + 12));
                      }
                    }
                  }
                })
              }
            }
          })
          if ($scope.Holidays.value == true) {
            angular.forEach(previewdata, function (value, key) {
              var HollydayDate = new Date(value.Startsat).setHours(0, 0, 0, 0);
              if ($scope.vm.SFOPH == "Next Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  value.Startsat = new Date(value.Startsat.setDate(value.Startsat.getDate() + 1));
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Previous Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  value.Startsat = new Date(value.Startsat.setDate(value.Startsat.getDate() - 1));
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Skip") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  previewdata.splice(key, 1)
                }
              }
            })
          }
          try {
            previewdata = _.uniqWith(previewdata, _.isEqual);
            var item = previewdata.filter(function (item) {
              return new Date(item.Startsat).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
            var ASchearray = [];
            var PreferDays = ""
            if ($scope.vm.PreferredDays != undefined && $scope.vm.PreferredDays != "" && $scope.vm.PreferredDays != null) {
              $scope.vm.PreferredDays = _.sortBy($scope.vm.PreferredDays, "id")
              PreferDays = $scope.vm.PreferredDays.map(function (obj) { return obj.names; }).join(',');
            }
            else
              PreferDays = ""
            var sd = 0;
            angular.forEach($scope.vm.PestType, function (Freq) {
              var key = 0;
              angular.forEach(item, function (value, index) {
                if (value.Frequency == Freq.Frequency) {
                  key++;
                  if (Freq.ServicesRequired > 0 && key > (Freq.ServicesRequired * $scope.selected.length)) {
                    item.splice(index, 1);
                  }
                }
              })
            });
            angular.forEach($scope.ServiceAddressarray, function (value) {
              angular.forEach(item, function (subvalue, key) {
                var sz = 'SVC-' + ('000000' + (1 + sd + schedulerdatasforlength)).slice(-6);
                var isSameDate = false;
                angular.forEach(ASchearray, function (ditem) {
                  if ($filter('date')(ditem.Startsat, 'dd/MM/yyyy') == $filter('date')(subvalue.Startsat, 'dd/MM/yyyy')
                    && ditem.Frequency != subvalue.Frequency) {
                    try {
                      // var array = (ditem.PestType + ',' + subvalue.PestType).split(',');
                      // var filteredArray = array.filter(function (item, pos) {
                      //   return array.indexOf(item) == pos;
                      // }); 
                      ditem.PestType = ditem.PestType + ',' + subvalue.PestType;
                      ditem.PestCode = ditem.PestCode + ',' + subvalue.PestCode;
                      // ditem.PestType = filteredArray.map(function (obj) { return obj; }).join(',');
                    } catch (e) { }
                    isSameDate = true;
                  }
                })
                if (isSameDate == false) {
                  ASchearray.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: Assigned,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    BillingAmount: $scope.vm.BillingAmount,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    TeamName: $scope.vm.ppTeamName,
                    TeamMembersName: $scope.vm.TM,
                    PreferredTime: PreferDays,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    Message: $scope.vm.Message,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  $scope.previewdatas.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    PreferredTime: $scope.vm.PreferredTime,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    Message: $scope.vm.Message,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  console.log(sd)
                  sd++;
                }
              })
            })
          } catch (e) { }
          $scope.previewGridDatas = ASchearray;
          $scope.AllPreviewGridDatas = ASchearray;
          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/f.html',
            parent: angular.element($document.body),
            targetEvent: M,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
          try {
            var dupitem = [];
            dupitem = ASchearray.filter(function (dupitem) {
              return dupitem.Duplicate === true;
            });
            $scope.vm.DuplicateCount = dupitem.length;
          } catch (e) { }
          $scope.vm.ServiceID = null;
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.vm.PreviewSpinner = false;
          $scope.vm.ShowDuplicate = false;
          $scope.vm.RemoveDuplicate = false;
        });
    }
    $scope.Rpd = function (e, i, t) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/PreviewAlert.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.RemovePData = t;
      $scope.vm.RemovePindex = i;
      if (t == 'RemovePData') { $scope.vm.RemovePTitle = 'Remove'; }
      if (t == 'ReschedulePData') {
        $scope.vm.RemovePTitle = 'Reschedule';
        var today = new Date();
        $scope.vm.RPDservicStime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 30, 0);
        $scope.vm.RPDservicEtime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 17, 30, 0);
      }
    }
    $scope.RemovePData = function (d) {
      try {
        $scope.previewdatas.splice(d, 1);
        $mdDialog.cancel();
      }
      catch (e) { }
    }
    $scope.ReSchedulePData = function (d) {
      try {
        //var dd = new Date($scope.vm.RPDservicat).getDate();
        //var mm = new Date($scope.vm.RPDservicat).getMonth() + 1;
        //var yy = new Date($scope.vm.RPDservicat).getFullYear();
        //var hh = new Date($scope.vm.RPDservicStime).getHours();
        //var ms = new Date($scope.vm.RPDservicStime).getMinutes();
        //new Date(yy + ',' + mm + ',' + dd + ' ' + hh + ':' + ms);

        var dd = $scope.vm.RPDservicat;
        var hh = $scope.vm.RPDservicStime;
        var mm = new Date(hh.setDate(new Date(dd).getDate()));
        var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
        var x = new Date(yy.setFullYear(new Date(dd).getFullYear()));

        //var edd = new Date($scope.vm.ServiceEndAt).getDate();
        //var emm = new Date($scope.vm.ServiceEndAt).getMonth() + 1;
        //var eyy = new Date($scope.vm.ServiceEndAt).getFullYear();
        //var ehh = new Date($scope.vm.RPDservicEtime).getHours();
        //var ems = new Date($scope.vm.RPDservicEtime).getMinutes();
        // new Date(eyy + ',' + emm + ',' + edd + ' ' + ehh + ':' + ems);

        var edd = $scope.vm.ServiceEndAt;
        var ehh = $scope.vm.RPDservicEtime;
        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
        var y = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
        var z = x;
        var items = $scope.previewdatas.filter(function (items) {
          return new Date(items.Startsat).setHours(0, 0, 0, 0) == z.setHours(0, 0, 0, 0);
        });
        if (items.length != 0) {
          $mdToast.show($mdToast.simple().textContent('Already Exist!').position('top center'));
        }
        else {
          angular.forEach($scope.previewdatas, function (item, key) {
            if (key == d) {
              var HcurrentDate = new Date(item.Startsat).setHours(0, 0, 0, 0);
              if ($scope.HolidaySelectedon.indexOf(HcurrentDate) > -1) {
                $mdToast.show($mdToast.simple().textContent('Selected date is holiday').position('top center'));
              }
              else {
                item.Startsat = x;
                item.Endsat = y;
              }
            }
          });
          $mdDialog.cancel();
        }
      }
      catch (e) { }
    }
    $scope.ReDo = function () {
      $mdDialog.cancel();
    }
    $scope.NewcommentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/add",
        data: {
          TableRowID: $scope.vm.jobdata,
          TableName: "Scheduler",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.NewComments,
          ModuleID: "",
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {
        RefreshAllJobComment()
        $mdToast.show($mdToast.simple().textContent('Comment Added Successfully').position('top center'));

      })
    }

    function RefreshAllJobComment() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/comment/getByRequestID",
        data: {
          RequestID: $scope.vm.jobdata,
        },
      });
      response.then(function (GList) {
        var item = GList.data.data.filter(function (item) {
          return item.TableName === 'Scheduler'
        })
        $scope.NewCommentdatas = item
      })
    }

    $scope.vm.PreviewSpinner = false;
    $scope.PreviewConfirm = function () {
      $scope.vm.PreviewSpinner = true;
      $mdDialog.cancel();
      $mdDialog.cancel();
      $scope.previewdatas = $scope.AllPreviewGridDatas;
      if ($scope.vm.RemoveDuplicate === true) {
        var item = [];
        item = $scope.AllPreviewGridDatas.filter(function (item) {
          return item.Duplicate === false;
        })
        $scope.previewdatas = item;
      }
      else {
        $scope.previewdatas = $scope.AllPreviewGridDatas;
      }
      $scope.previewdatas[0].Types = 'Initial Service';
      $scope.previewdatas[0].SpecialRemark = $scope.vm.firstSpecialRemark;
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/addbyarray",
        data: { ServiceArray: $scope.previewdatas },
      }).then(function (List) {
        $scope.vm.PreviewSpinner = false;
        $scope.vm.ServiceID = null;
        $mdToast.show($mdToast.simple().textContent('Successfully Added' + ' ' + $scope.previewdatas.length + ' ' + 'Service Jobs').position('top center'));
        $scope.previewdatas = [];
        RefreshGrid();
        $scope.getPendingSchedule()
        $scope.pesttypeGrid = true;
        $scope.shedulerform = true;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.exportbtn = true;
        $scope.thdata = false;
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
        $scope.ServiceAddressarray = [];
      });
    }
    $scope.ShowPhotoinfo = function (e, photo) {
      $scope.uShowImage = photo;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.PhotoBeforeinfo = function (e, id, p) {
      $scope.PhotoBeforeinfoId = id;
      $scope.PhotoBeforeinfoUpdate = true;
      $scope.uCPB = p;
      $scope.uShowImage = p;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.UploadPhotoBefore = function (flow) {
      $scope.CPB1 = document.getElementById('CPB1');
      if ($scope.CPB1.src == null || $scope.CPB1.src == "" || $scope.CPB1.src == undefined) {
        $scope.CPB1 = { src: null };
        if ($scope.uCPB != null || $scope.uCPB != "" || $scope.uCPB != undefined) {
          $scope.CPB1 = { src: $scope.uCPB };
        }
      }

      if ($scope.UpdatePhoto == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletschedulerrecord/UpdatePhoto",
          data: {
            _id: $scope.UploadPhotoid,
            data: $scope.CPB1.src,
            ServiceId: $scope.vm.ScedulId,
            Remarks: $scope.vm.ImgBRemarks,
            Client_Id: $rootScope.Client_Id,
            CreatedBy: $rootScope.CreatedBy
          }
        });
        response.then(function (GList) {
          $scope.vm.flow.files = [];
          flow.cancel();
          $scope.PhotoBeforeinfoUpdate = false;
          $scope.UpdatePhoto = false
          $scope.uCPB = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletschedulerrecord/AddPhotoOld",
          data: {
            ServiceId: $scope.vm.ScedulId,
            data: $scope.CPB1.src,
            PestType: $scope.vm.ImgBPestType,
            Remarks: $scope.vm.ImgBRemarks,
            Client_Id: $rootScope.Client_Id,
            CreatedBy: $rootScope.CreatedBy
          }
        });
        response.then(function (GList) {
          $scope.vm.flow.files = [];
          flow.cancel();
          $scope.PhotoBeforeinfoUpdate = false;
          $scope.UpdatePhoto = false
          $scope.vm.ImgBRemarks = null;
          $scope.uCPB = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }

    }
    $scope.DeletePhotosBeforeReport = function (id) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/tabletschedulerrecord/DeletePhoto",
        data: {
          _id: id,
          ServiceId: $scope.vm.ScedulId,
        }
      })
      response.then(function (List) {
        $scope.PhotoBeforeinfoUpdate = false;
        $scope.UpdatePhoto = false
        $scope.vm.ImgBRemarks = null;
        $mdToast.show($mdToast.simple().textContent('Deleted Successfully!').position('top center'));
        RefreshPhotos();
      })
    }
    $scope.Photoinfo = function (e, id, p) {
      $scope.PhotoinfoId = id;
      $scope.PhotoinfoUpdate = true;
      $scope.uCP = p;
      $scope.uShowImage = p;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowImages.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.UploadPhoto = function () {
      $scope.CP1 = document.getElementById('CP1');
      if ($scope.CP1.src == null || $scope.CP1.src == "" || $scope.CP1.src == undefined) {
        $scope.CP1 = { src: null };
        if ($scope.uCP != null || $scope.uCP != "" || $scope.uCP != undefined) {
          $scope.CP1 = { src: $scope.uCP };
        }
      }
      if ($scope.PhotoinfoUpdate == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/schedulerpicafter/update",
          data: {
            _id: $scope.PhotoinfoId,
            ServiceId: $scope.vm.ScedulId,
            schimgafter: $scope.CP1.src,
            PestType: $scope.vm.ImgAPestType,
            Remarks: $scope.vm.ImgARemarks,
            CreatedBy: $rootScope.createdBy,
            schimgbefore: null,
          }
        });
        response.then(function (GList) {
          $scope.PhotoinfoUpdate = false;
          $scope.vm.ImgARemarks = null;
          $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulerpicafter/add",
          data: {
            ServiceId: $scope.vm.ScedulId,
            schimgafter: $scope.CP1.src,
            PestType: $scope.vm.ImgAPestType,
            Remarks: $scope.vm.ImgARemarks,
          }
        });
        response.then(function (GList) {
          $scope.PhotoinfoUpdate = false;
          $scope.vm.ImgARemarks = null;
          $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
          RefreshPhotos();
        });
      }
    }
    $scope.UpdatePhotosBeforeReport = function (row) {
      $scope.uCPB = row.Path
      $scope.vm.ImgBRemarks = row.Remarks
      $scope.UploadPhotoid = row.id
      $scope.UpdatePhoto = true
    }
    $scope.AddServicesReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Services";
      $scope.vm.ReportEditTtlte = "Add Services";
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.Finding = null;
      $scope.vm.Recommendation = null;
      RefreshRecommendationGrid();
      RefreshFindingGrid();
    }
    $scope.EditServicesReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.SMPestType = null;
      $scope.vm.MServicetype = null;
      $scope.vm.Finding = null;
      $scope.vm.Recommendation = null;
      $scope.vm.ReportEditType = "Services";
      $scope.vm.ReportEditTtlte = "Edit Services";
      $scope.SMId = item.id;
      $scope.vm.SMPestType = item.PestType;
      try {
        if (item.Services != null && item.Services != "" && item.Services != undefined) {
          var array = item.Services.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Servicetype: value });
          });
          $scope.vm.MServicetype = array1;
        }
      } catch (e) { }
      try {
        if (item.Finding != null && item.Finding != "" && item.Finding != undefined) {
          var array = item.Finding.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Description: value });
          });
          $scope.vm.Finding = array1;
        }
      } catch (e) { }
      try {
        if (item.Recommendation != null && item.Recommendation != "" && item.Recommendation != undefined) {
          var array = item.Recommendation.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ Description: value });
          });
          $scope.vm.Recommendation = array1;
        }
      } catch (e) { }
      RefreshRecommendationGrid();
      RefreshFindingGrid();

    }
    $scope.EditInfestationReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Edit Infestation";
      $scope.vm.ReportEditTtlte = "Edit Infestation";
      $scope.InfestationPest = $scope.Materialsdatas
      if ($scope.Materialsdatas.length == 0) {
        var Pest = $scope.vm.PestType1.split(',')
        var PEstType = []
        angular.forEach(Pest, function (List) {
          PEstType.push({
            PestType: List,
            InvestationLevel: 'Nil'
          })
        })
        $scope.InfestationPest = PEstType
      }
    }

    $scope.SubmitInfestation = function () {
      var len = $scope.InfestationPest.length
      angular.forEach($scope.InfestationPest, function (item, key) {
        var id = null
        if (item.id != null && item.id != undefined)
          id = item.id
        $http({
          method: 'PUT',
          url: $rootScope.WebURL + '/infestation/upsert',
          data: {
            _id: id,
            ServiceID: $scope.vm.ScedulId,
            PestType: item.PestType,
            Infestationlevel: item.InvestationLevel
          }
        })
        if (key == len - 1) {
          $mdDialog.cancel();
          $scope.Materialsdatas = $scope.InfestationPest
        }
      })

    }
    $scope.EditMaterialReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.MLSMPestType = null;
      $scope.vm.MMaterialsName = null;
      $scope.vm.MQuantity = null;
      $scope.vm.MUnit = null;
      $scope.vm.MDilution = null;
      $scope.vm.ReportEditType = "Materials";
      $scope.vm.ReportEditTtlte = "Edit Materials";
      $scope.SMLMId = item.id;
      try {
        $scope.vm.MLSMPestType = item.PestType;
        $scope.vm.MMaterialsName = item.MaterialName;
        $scope.vm.Dilution = item.Dilution;
        $scope.vm.Unit = item.Unit;
        $scope.vm.Quantity = parseInt(item.Quantity);
      } catch (e) { }

    }
    $scope.SubmitMaterialsReport = function (e) {
      if ($scope.vm.ReportEditTtlte == 'Edit Materials') {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletMaterials/update",
          data: {
            _id: $scope.SMLMId,
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            Dilution: $scope.vm.MDilution,
            UpdatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $scope.vm.MDilution = null;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshMobileLogMaterials();
        });

      }
      else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletMaterials/add",
          data: {
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            Dilution: $scope.vm.MDilution,
            CreatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $scope.vm.MDilution = null;
          $mdDialog.cancel();
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
    }
    $scope.EditPhotoBeforeReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.UpdatePhoto = false
      $scope.vm.MLSMPestType = null;
      $scope.uCPBt = null;
      $scope.uCPB = null;
      $scope.vm.ImgBRemarks = null;
      $scope.vm.ReportEditType = "Photo Before";
      $scope.vm.ReportEditTtlte = "Edit Photo Before";
    }
    $scope.EditPhotoAfterReport = function (e, item) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.MLSMPestType = null;
      $scope.uCPBt = null;
      $scope.vm.ReportEditType = "Photo After";
      $scope.vm.ReportEditTtlte = "Edit Photo After";
    }
    $scope.EditReport = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ReportEdit.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ReportEditType = "Edit Report";
      $scope.vm.ReportEditTtlte = "Edit Report";
      angular.forEach($scope.Tabletschedulerrecord, function (value) {
        try {
          if ($scope.vm.ScedulId === value.ServiceId) {
            $scope.vm.tbsc_id = value._id
            $scope.vm.Pesttype = value.Pesttype
            if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
              var array = $scope.vm.Pesttype.split(",");
              var array1 = [];
              angular.forEach(array, function (value) {
                array1.push({ PestName: value });
              });
              $scope.Pestdatas = array1;
            }
            $scope.vm.PerformedBy = value.TeamLead;
            if (value.TeamMember != null && value.TeamMember != "" && value.TeamMember != undefined) {
              var array = value.TeamMember.split(",");
              var array1 = [];
              angular.forEach(array, function (value) {
                array1.push({ EmployeeName: value });
              });
              $scope.vm.CoTechnicians = array1;
            }
            $scope.vm.TeamSignature = value.TeamSignature;
            $scope.vm.Paymentmethod = value.Paymentmethod;
            $scope.vm.PaymentRemarks = value.PaymentRemarks;
            $scope.vm.PaymentNotes = value.PaymentNotes;
            $scope.vm.BreedingFound = value.BreedingFound;
            $scope.vm.Species = value.Species;
            $scope.vm.Findings = value.Findings;
            $scope.vm.MistingCariedOut = value.MistingCariedOut;
            $scope.vm.Instar = value.Instar;
            $scope.vm.AServiceStartAt = new Date(value.Startsat);
            $scope.vm.AServiceEndAt = new Date(value.Endsat);
            $scope.vm.Totalarea = parseInt(value.Totalarea);
            $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
            $scope.vm.Totalpayment = parseInt(value.Totalpayment);
            $scope.vm.Density = parseInt(value.Density);
          }
        }
        catch (e) { }
      })
    }
    $scope.getTeamTable = function (TeamId) {
      if (TeamId != undefined) {
        var TeamID = TeamId.map(function (obj) { return obj.id; }).join(',');
        $scope.vm.TM = _.uniq(TeamId.map(function (obj) { return obj.TeamMembers; }).join(',').split(','))
        $scope.vm.ppTeamName = TeamId.map(function (obj) { return obj.TeamName; }).join(',');
        $scope.vm.TeamEstimationHr = ($scope.vm.EstimationHr / TeamId.length) % 1 == 0 ? $scope.vm.EstimationHr / TeamId.length : ($scope.vm.EstimationHr / TeamId.length).toFixed(2)
        $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
      }
      else {
        var TeamID = []
        $scope.vm.TM = null
        $scope.vm.ppTeamName = null
      }


      try {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getTeamforDate",
          method: "POST",
          data: {
            Start_Date: $scope.vm.ServiceStartAt, End_Date: $scope.vm.ServiceEndAt,
            Client_Id: $rootScope.Client_Id, Team_Id: TeamID
          },
        });
        response.then(function (GList) {
          var Fteam = GList.data.data;
          $scope.Teamtabledata = Fteam;
        });
      }
      catch (e) { }
    }
    $scope.AddMobileLogMaterials = function () {
      //$http({
      //    method: "POST",
      //    url:  $rootScope.WebURL + "/tabletMaterials/delete",
      //    data: { Service_Id: $scope.vm.ScedulId }, 
      //}).then(function (TSdata) {
      //});
      if ($scope.vm.SMLMUpdate == false) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/tabletMaterials/add",
          data: {
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            CreatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
      else if ($scope.vm.SMLMUpdate == true) {
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/tabletMaterials/update",
          data: {
            _id: $scope.SMLMId,
            Service_Id: $scope.vm.ScedulId,
            PestType: $scope.vm.MLSMPestType,
            MaterialName: $scope.vm.MMaterialsName,
            Quantity: $scope.vm.MQuantity,
            Unit: $scope.vm.MUnit,
            UpdatedBy: $rootScope.createdby,
          }
        });
        response.then(function (GList) {
          $scope.vm.MLSMPestType = null;
          $scope.vm.MMaterialsName = null;
          $scope.vm.MQuantity = null;
          $scope.vm.MUnit = null;
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshMobileLogMaterials();
        });
      }
    }
    $scope.MobileLogMaterialinfo = function (item) {
      $scope.vm.SMLMUpdate = true;
      $scope.SMLMId = item.id;
      $scope.vm.MLSMPestType = item.PestType;
      $scope.vm.MMaterialsName = item.MaterialName;
      $scope.vm.MQuantity = parseFloat(item.Quantity);
      $scope.vm.MUnit = item.Unit;
    }
    $scope.ChangeDate = function (Type) {
      if (Type == 'less') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() - 1));
        $scope.uTo = new Date($scope.uFrom);
      }
      if (Type == 'greater') {
        $scope.uFrom = new Date(new Date($scope.uFrom).setDate(new Date($scope.uFrom).getDate() + 1));
        $scope.uTo = new Date($scope.uFrom);
      }
    }
    $scope.RevertPopup = function (r, Id, ServiceID) {
      $scope.vm.RevertId = Id;
      $scope.vm.RevertServiceID = ServiceID;
      $scope.vm.EditTeamdiv = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/RevertPopup.html',
        parent: angular.element($document.body),
        targetEvent: r,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }
    $scope.RevertSubmit = function () {
      $http({
        url: $rootScope.WebURL + "/scheduler/Statusupdate",
        method: "PUT",
        data: {
          _id: $scope.vm.RevertId,
          Status: "Yet to Start",
          UpdatedBy: $rootScope.createdby,
        },
      }).then(function (GList) {
        $http({
          url: $rootScope.WebURL + "/tabletschedulerrecord/delete",
          method: "PUT",
          data: {
            ServiceId: $scope.vm.RevertId,
          },
        }).then(function (GList) {
        })
        $mdDialog.cancel();
        $scope.NewGetByStatus();
      });
    }
    $scope.EditTeam = function (r, item) {
      $scope.vm.EditTeamdiv = true;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/RevertPopup.html',
        parent: angular.element($document.body),
        targetEvent: r,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ServiceId = item._id;
      $scope.vm.ServiceID = item.ServiceID;
      $scope.vm.TeamName = item.TeamName;
      $scope.vm.TeamMembers = item.TeamMembersName;
      $scope.vm.CustomerName = item.customerdetails[0].CompanyName || row.AdhocCustomerName;
      $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
      $scope.vm.Team_id = null;
      $scope.vm.TM = null;
      var item = $scope.teamdatas.filter(function (item) {
        return $scope.vm.TeamName.includes(item.TeamName)
      })
      $scope.vm.Team_id = item
      $scope.vm.TeamLead = item.map(function (obj) { return obj.TeamLead }).join(',')
    }
    $scope.TeamEditSubmit = function () {
      var Team = $scope.vm.Team_id.map(function (obj) { return obj.id })
      $http({
        url: $rootScope.WebURL + "/scheduler/updateteam",
        method: "PUT",
        data: {
          _id: $scope.vm.ServiceId,
          AssignedTo: Team,
          TeamName: $scope.vm.ppTeamName,
          TeamMembersName: $scope.vm.TM,
          UpdatedBy: $rootScope.createdby,
        },
      }).then(function (GList) {
        $mdDialog.cancel();
        $scope.vm.Team_id = null;
        $scope.vm.TM = null;
        $scope.vm.ServiceId = null;
        $scope.vm.ServiceID = null;
        $scope.vm.TeamName = null;
        $scope.vm.TeamLead = null;
        $scope.vm.TeamMembers = null;
        $scope.vm.CustomerName = null;
        $scope.vm.SalesOrderNo = null;
        $scope.NewGetByStatus();
      });
    }
    $scope.GetLatlong = function () {
      angular.forEach($scope.ServiceAddressarray, function (value) {
        var getLocation = "";
        if (value.sBLK != "" && value.sBLK != null && value.sBLK != undefined) {
          getLocation = value.sBLK;
        }
        if (value.sUnit != "" && value.sUnit != null && value.sUnit != undefined) {
          getLocation = getLocation + " " + value.sUnit;
        }
        if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
          getLocation = getLocation + " " + value.sBuildingName;
        }
        if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
          getLocation = getLocation + " " + value.sStreetName;
        }
        if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
          getLocation = getLocation + " " + value.sPostal;
        }
        var address = getLocation;
        value.LatLong = "103.8677,1.3554";
        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({
            'address': address
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
            }
          });
        }
        value.getLocation = getLocation;
      })
      $mdDialog.cancel();
    }
    $scope.ShowScheduled = function (ShowScheduled) {
      if (ShowScheduled == true) {
        $scope.vm.ShowScheduledStatus = "Scheduled"
      } else {
        $scope.vm.ShowScheduledStatus = "New"
      }
    }
    var applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }], dataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $scope.ShowDuplicate = function (value) {
      if (value === true) {
        var item = [];
        item = $scope.previewGridDatas.filter(function (item) {
          return item.Duplicate === true;
        });
        $scope.previewGridDatas = item
      }
      else {
        $scope.previewGridDatas = $scope.AllPreviewGridDatas;
      }
    }
    // End function for new design..............

    $scope.viewCustomerInfo = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomerInfo.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.Customersearch = null;
      $scope.vm.uContactPerson = null;
      $scope.vm.CustomerID = null;
      $scope.vm.Location = null;
      $scope.CustomerServicedatas = [];
    }
    $scope.GetCinfo = function (item) {

      $scope.vm.uCustomerType = item.CustomerType;
      $scope.RequestID = item.CustomerID;
      $scope.vm.uPostal = item.Postal;
      $scope.vm.uCountry = item.Country;
      $scope.vm.uContactPerson = item.ContactPerson;
      $scope.vm.ppCompanyName = item.CompanyName;
      $scope.vm.BLK = item.BLK;
      $scope.vm.Unit = item.Unit;
      $scope.vm.StreetName = item.StreetName;
      $scope.vm.BuildingName = item.BuildingName;
      $scope.vm.FixedTeam = item.FixedTeam;
      $scope.vm.FixedTeamdata = item.FixedTeamdata;
      try {
        $scope.vm.ClientEmail = item.Email.replace(',', ', ')
      }
      catch (e) { }
      CustomerServicedatadetails();
    }
    $scope.ViewSchedule = function (e, TeamId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/scheduleview.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.TeamFilterId = TeamId;
      try {
        var item = $scope.teamdatas.filter(function (item) {
          return item.id === TeamId;
        })[0];
        $scope.vm.sTeamName = item.TeamName;
        $scope.vm.sTeamLead = item.TeamLead;
      }
      catch (e) { }
    }
    $scope.getNewDate = function (d) {
      if (d != null && d != undefined && d != "") {
        try {
          $scope.vm.ServiceStartAt = new Date(d);
          $scope.vm.ServiceEndAt = new Date(d.setDate(new Date(d).getDate() + $scope.skippeddatas.length - 1));
        }
        catch (e) { }
      }
    }
    $scope.sSubmit = function (e) {
      if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
        $scope.vm.sPestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
      }
      var Team = $scope.vm.UTeam.map(function (obj) { return obj.id; }).join(',');
      Team = Team.split(',')
      if ($scope.Update == true) {
        var dd = $scope.vm.ResheduleFrom;
        var hh = $scope.vm.ResheduleStartTime;
        var mm = new Date(hh.setDate(new Date(dd).getDate()));
        var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
        $scope.vm.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));
        var edd = $scope.vm.ResheduleFrom;
        var ehh = $scope.vm.ResheduleEndTime;
        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
        $scope.vm.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
        var currentDate = new Date($scope.vm.schusdateTime);
        var enddate = new Date($scope.vm.schuedateTime);
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/forReschedule",
          data: {
            _id: $scope.SID,
            AssignedTo: $scope.vm.AssignedTo,
            Start_Date: currentDate,
            End_Date: enddate,
          },
        }).then(function (GList) {
          var CheckforReschedule = GList.data.data;
          $scope.CheckReschedule = false;
          angular.forEach(CheckforReschedule, function (item) {
            var edd = new Date($scope.vm.ResheduleFrom);
            var ehh = new Date(item.Endsat);
            var emm = new Date(ehh.setDate(new Date(edd).getDate()));
            var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
            item.Endsat = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
            if (new Date(item.Startsat) < currentDate && currentDate < new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            if (new Date(item.Startsat) < enddate && enddate < new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            if (new Date(item.Startsat) >= currentDate && enddate > new Date(item.Endsat)) {
              $scope.CheckReschedule = true;
            }
            var St = $filter('date')(currentDate, 'dd/MM/yyyy hh:mm a');
            var Et = $filter('date')(enddate, 'dd/MM/yyyy hh:mm a');
            var dbSt = $filter('date')(new Date(item.Startsat), 'dd/MM/yyyy hh:mm a');
            var dbEt = $filter('date')(new Date(item.Endsat), 'dd/MM/yyyy hh:mm a');
            if (St == dbSt && Et == dbEt) {
              $scope.CheckReschedule = true;
            }
          });
          $scope.Emails = null;
          if ($scope.Reschedule.value == true) {
            var array = [];
            var createdBy = null;
            var teamLead = null;
            var teamMember = null;
            try {
              var gItem = $scope.Uniqueschedulerdatas.filter(function (item) {
                return $scope.SID === item._id;
              })[0];
              createdBy = gItem.CreatedBy;
              teamLead = gItem.teamdetails[0].TeamLead;
              teamMember = gItem.teamdetails[0].TeamMembers;
            } catch (error) { }
            angular.forEach($scope.Userdatas, function (uvalue) {
              if (createdBy.indexOf(uvalue.UserID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
              if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
              if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                array.push({ EmailId: uvalue.Email })
              }
            })
            if (array.length > 0) {
              var SenderEmails = [];
              $scope.Emailgroups = _.groupBy(array, 'EmailId');
              angular.forEach($scope.Emailgroups, function (value) {
                SenderEmails.push(value[0].EmailId);
              });
              $scope.Emails = SenderEmails;
            }
          }
          $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
          $scope.ServiceOn = $filter('date')($scope.uEndDate, 'EEEE');
          $http({
            method: "PUT",
            url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
            data: {
              _id: $scope.SID,
              ServiceOn: $scope.ServiceOn,
              Startsat: currentDate,
              Endsat: enddate,
              ResheduleRemarks: $scope.vm.ResheduleRemarks,
              SenderEmailAddress: $scope.Emails,
              CompanyName: $scope.vm.CompanyName,
              ScheduleFromDate: $scope.vm.ServiceStartAtlog,
              UpdatedBy: $rootScope.createdby,
              AssignedTo: Team[0],
              Team_Id: Team,
              TeamName: $scope.vm.ppTeamName,
              TeamMembersName: $scope.vm.TM,
              IsActive: true
            },
          }).then(function (GList) {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/schedulerNotification/add",
              data: {
                ServiceId: $scope.SID,
                ServiceID: $scope.vm.ServiceID,
                CustomerName: $scope.vm.CompanyName,
                Status: $scope.status,
                PreviousStartsat: $scope.vm.ServiceStartAtlog,
                PreviousEndsat: $scope.vm.ServiceEndAtlog,
                Startsat: currentDate,
                Endsat: enddate,
                PestType: $scope.vm.PestType1,
                TeamName: $scope.vm.TeamName,
                TeamLead: $scope.vm.Teammemberdata,
                TeamMember: $scope.vm.Teammemberdata,
                Acknowledged: null,
                AcknowledgedBy: null,
                CreatedBy: $rootScope.createdby,
                IsActive: true
              },
            }).then(function (GList) {
            });
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/schedulelog/add",
              data: {
                Client_Id: $rootScope.Client_Id,
                JobsOrders: $scope.vm.jobdata,
                Customer: $scope.vm.CustomerID,
                AssignedTo: $scope.vm.AssignedTo,
                Frequency: $scope.vm.Frequency,
                ServiceOn: $scope.ServiceOn,
                Types: $scope.vm.Types,
                Status: "Yet to Start",
                Startsat: $scope.vm.ServiceStartAtlog,
                Endsat: $scope.vm.ServiceEndAtlog,
                ScheduledStartsat: currentDate,
                ScheduledEndsat: enddate,
                PestType: $scope.vm.PestType1,
                ContractOrder: $scope.vm.ContractOrder,
                ServiceID: $scope.vm.ServiceID,
                ResheduleRemarks: $scope.vm.ResheduleRemarks,
                CreatedBy: $rootScope.createdby,
                IsActive: true,
              },
            }).then(function (GList) {
              if ($scope.vm.SelectedTab == 'Outstanding') {
                $scope.getOutsatnding();
              }
              else { RefreshGrid(); }
              $mdDialog.cancel();
              $scope.pesttypeGrid = true;
              $scope.shedulerform = true;
              $scope.addbtn = true;
              $scope.viewbtn = false;
              $scope.exportbtn = true;
              $scope.thdata = false;
              $scope.schedulartab = true;
              $mdDialog.cancel();
              $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
            });
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        });
      }
    }
    $scope.commentSubmit = function () {
      $scope.File_id = $scope.vm.ScedulId;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          SchedulerID: $scope.vm.ScedulId,
          SalesOrderID: $scope.vm.jobdata,
          CustomerID: $scope.vm.Customer_Id,
          TableName: 'Scheduler',
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          CreatedBy: $rootScope.createdby, IsActive: "true",
        },
      });
      response.then(function (GList) {
        Refreshcomment();
        $scope.vm.Addcomments = '';
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.NcommentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          SalesOrderID: $scope.vm.jobdata,
          CustomerID: $scope.vm.Customersearch,
          TableName: 'Scheduler',
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.NAddcomments,
          CreatedBy: $rootScope.createdby, IsActive: "true",
        },
      });
      response.then(function (GList) {
        var response = $http({
          url: $rootScope.WebURL + "/schedulercomment/getByCustomer",
          method: "POST",
          data: { RequestID: $scope.vm.Customersearch },
        });
        response.then(function (Commentdata) {
          $scope.NCommentdatas = Commentdata.data.data;
        });
        $scope.vm.NAddcomments = '';
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.Uploadfiles = function (file) {
      $scope.File_id = $scope.vm.ScedulId;
      var file = file[0].file
      var response = Upload.upload({
        url: $rootScope.WebURL + "/scheduler/upload",
        data: { file: file }
      }).then(function (resp) {
        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID, TableName: "Operations", FileID: $scope.vm.jobdata,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize, FileType: $scope.fileType,
              ModuleID: $scope.Path, Data: null, IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            RefreshAttachmentGrid();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }
    $scope.printToCart = function (Sanitation) {
      var innerContents = document.getElementById(Sanitation).innerHTML;
      var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
      popupWinindow.document.close();
    };
    $scope.printService = function (service) {
      var myPdfUrl = $rootScope.DownloadURL + $scope.vm.ServiceID + '.pdf';
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/DownloadServiceReport",
        data: {
          _id: $scope.vm.ScedulId,
          ServiceID: $scope.vm.ServiceID
        },
      });
      response.then(function (GList) {
        setTimeout(function () {
          $window.open(myPdfUrl, '_blank');
        }, 3000);
      });
      alert("Report will be opened in new window. You may have to wait for a while as the system generating the PDF. Please change your settings to allow the popup window for this URL. !")
      //var url =  $rootScope.ReportURL + 'Service.aspx' + '?' + 'ID=' + $scope.vm.ScedulId;
      //window.open(url) 
    };
    $scope.printServiceWeb = function (service) {
      var url = $rootScope.ReportURL + 'Service.aspx' + '?' + 'ID=' + $scope.vm.ScedulId;
      window.open(url);
    };


    $scope.printWork = function (Work) {
      var innerContents = document.getElementById(Work).innerHTML;
      var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
      popupWinindow.document.close();
    };

    $scope.Showlocation = function (e, Latitude) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/MapView.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, NgMap, $locale, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      NgMap.getMap().then(function (map) {
        vm.map = map;
      });
      $scope.CenterMapView = [];
      vm.stores = [];
      var array = Latitude.split(",");
      // angular.forEach($scope.YettoStartdatas, function (Mapviewprog) {
      // if (Mapviewprog.customerdetails.length > 0) {
      var lati = 1.3554;
      var lngi = 103.8677;
      // if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
      // var array = Mapviewprog.LatLong.split(",");
      lati = parseFloat(array[0]);
      lngi = parseFloat(array[1]);
      if ($scope.CenterMapView.length == 0) {
        $scope.CenterMapView = [lati, lngi];
      }
      // }
      var lat = lati + (Math.random() / 100);
      var lng = lngi + (Math.random() / 100);
      vm.stores.push({
        position: [lat, lng],
        items: [{
          ServiceId: $scope.vm.ServiceID,
          Customer: $scope.vm.CompanyName,
          Team: $scope.vm.TeamName,
          Time: $filter('date')(new Date($scope.vm.ATimeIn), 'hh:m a') + " - " + $filter('date')(new Date($scope.vm.ATimeOut), 'hh:m a'),
        }],
      })
      // }
      if ($scope.CenterMapView.length == 0) {
        $scope.CenterMapView = [1.3554, 103.8677];
      }
      vm.showStore = function (evt, storeId) {
        vm.store = vm.stores[storeId];
        vm.map.showInfoWindow('foo', this);
      };
      vm.mouseover = function () {
        console.log('mouseover');
      };
    }

    $scope.thdata = false;
    $scope.shouldDateBeShown = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        $scope.uTo = new Date(uTimeOut);
        var secondDate = $scope.uTo;
        if (firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)) {
          return 'Expiried'
        }
        else {
          var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
          if (res == 0) {
            return 'Expiried'
          }
          else {
            return res;
          }
        }
      }
      else { return null }
    }
    $scope.splice = function (event) {
      $scope.vm.events = "";
      $scope.thdata = false;
      $scope.schedulartab = true;
    }

    $scope.Today = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      $scope.uFrom = new Date();
      $scope.uTo = new Date();
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);

    }
    $scope.lastweek = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var d = new Date();
      var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
      var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = new Date(from);
      $scope.uTo = new Date(to);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }
    $scope.NextWeek = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var d = new Date();
      var dayIndex = [1];
      var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
      var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = new Date(from);
      $scope.uTo = new Date(to);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);

    }
    $scope.NextMonth = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      firstDay = $filter('date')(firstDay);
      lastDay = $filter('date')(lastDay);
      $scope.uFrom = new Date(firstDay);
      $scope.uTo = new Date(lastDay);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }
    $scope.lastmonth = function () {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      $scope.SelectedIds = [];
      $scope.Selec = { value: false }
      var now = new Date();
      var nowDayOfWeek = now.getDay();
      var nowDay = now.getDate();
      var nowMonth = now.getMonth();
      var nowYear = now.getFullYear();
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastYear = lastMonthDate.getFullYear();
      var lastMonth = lastMonthDate.getMonth();
      var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
      var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
      lastMonthStartDate = $filter('date')(lastMonthStartDate);
      lastMonthEndDate = $filter('date')(lastMonthEndDate);
      $scope.uFrom = new Date(lastMonthStartDate);
      $scope.uTo = new Date(lastMonthEndDate);
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") { $scope.vm.filtercustomer = null }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") { $scope.vm.filterteam = null }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      $scope.NewGetByStatus(null);
    }

    $scope.jobname = false;
    $scope.showjoblist = function () {
      $scope.jobname = true;
      if ($scope.vm.jobdata == "" | $scope.vm.jobdata == null) {
        $scope.jobname = false;
      }
    }
    $scope.jobval = function (name, customer) {
      var str = name;
      $scope.vm.jobdata = name;
      $scope.customer = customer;
      $scope.jobname = false;

    }
    $scope.Holidays = { value: false }
    $scope.contacts = [{
      'id': 1,
      'Name': 'Daily',

    }, {
      'id': 2,
      'Name': 'Weekly',

    }, {
      'id': 3,
      'Name': 'Fortnightly',

    }, {
      'id': 4,
      'Name': 'Monthly',

    }, {
      'id': 5,
      'Name': 'Quarterly',

    }, {
      'id': 6,
      'Name': 'Half-Yearly',

    }, {
      'id': 7,
      'Name': 'Yearly',

    }];
    $scope.Typeslist = [{
      'id': 1,
      'TyName': 'Follow-up',

    }, {
      'id': 2,
      'TyName': 'Routine',

    }, {
      'id': 3,
      'TyName': 'Non-Contractual',

    },
    {
      'id': 4,
      'TyName': 'Feedback',

    }, {
      'id': 5,
      'TyName': 'FOC',

    }];
    $scope.items = [
      { id: 1, names: 'Monday' },
      { id: 2, names: 'Tuesday' },
      { id: 3, names: 'Wednesday' },
      { id: 4, names: 'Thursday' },
      { id: 5, names: 'Friday' },
      { id: 6, names: 'Saturday' },
      { id: 0, names: 'Sunday' },
    ];
    $scope.Prefitems = [
      { id: 1, names: 'Mon' },
      { id: 2, names: 'Tue' },
      { id: 3, names: 'Wed' },
      { id: 4, names: 'Thur' },
      { id: 5, names: 'Fri' },
      { id: 6, names: 'Sat' },
      { id: 0, names: 'Sun' },
    ];
    $scope.dayitem = [
      { id: 1, names: 'Mon' },
      { id: 2, names: 'Tue' },
      { id: 3, names: 'Wed' },
      { id: 4, names: 'Thur' },
      { id: 5, names: 'Fri' },
      { id: 6, names: 'Sat' },
      { id: 0, names: 'Sun' },
    ];
    $scope.selected = [{ id: 0, names: 'Sunday' }];
    $scope.vm.Twiceday = null
    $scope.toggle = function (item, list, e) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
      var count = 0
      $scope.vm.PestType.filter(function (item) {
        if (item.Frequency.includes('Twice a Week')) {
          count++
        }
      })
      // if($scope.vm.Twiceday!=null && $scope.items[0].id===$scope.vm.Twiceday.id) $scope.vm.Twiceday=null
      $scope.dayitem1 = _.differenceBy($scope.items, list, "id")
      $scope.dayitem2 = _.differenceBy($scope.items, list, "id")
      if (count > 0 && $scope.vm.Twiceday == null) {
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          controller: function operationsProjectController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            }
          }
        });
        $scope.vm.Tittle = "Select Other Day for Twice a Week"
      }
      //if (list.length > 5) {
      //    $mdDialog.show({
      //        multiple: true,
      //        templateUrl: 'app/main/apps/operations/scheduler/ServiceOnalert.html',
      //        parent: angular.element($document.body),
      //        targetEvent: e,
      //        scope: $scope.$new(),
      //        controller: function operationsProjectController($scope, $mdDialog) {
      //            $scope.closeDialog = function () {
      //                $mdDialog.hide();
      //            }
      //        }
      //    });
      //}
      var days = ''
      var Includes = '';
      if ($scope.Holidays.value == true) { Includes = 'Excludes' }
      if ($scope.Holidays.value == false) { Includes = 'Includes' }
      if ($scope.selected != null && $scope.selected != "" && $scope.selected != undefined) {
        days = $scope.selected.map(function (obj) { return obj.names; }).join(',');
      }
      var ServiceStartAt = $scope.vm.ServiceStartAt;
      if (new Date($scope.vm.ServiceStartAt) < new Date()) { ServiceStartAt = new Date() }
      if ($scope.vm.ForMonthly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForBiMonthly != '') {
        $scope.Summary = 'Occurs every two months ' + $scope.vm.ForBiMonthly + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForHalfYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForQuaterlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForHalfYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForHalfYearly + ' month of ' + $scope.vm.ForHalfYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForYearly != '') {
        $scope.Summary = 'Occurs every ' + $scope.vm.ForYearly + ' month of ' + $scope.vm.ForYearlyWeek + ' week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else if ($scope.vm.ForBiWeekly != '') {
        $scope.Summary = 'Occurs every two weeks on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
      else {
        $scope.Summary = 'Occurs every week on ' + days + ' between ' + $filter('date')(ServiceStartAt, 'dd/MM/yyyy') + ' to ' + $filter('date')($scope.vm.ServiceEndAt, 'dd/MM/yyyy') + '.  [' + Includes + ' Public Holiday].'
      }
    };
    $scope.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };
    $scope.isIndeterminate = function () {
      return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.items.length);
    };
    $scope.isChecked = function () {
      return $scope.selected.length === $scope.items.length;
    };
    $scope.toggleAll = function (e) {
      if ($scope.selected.length === $scope.items.length) {
        $scope.selected = [];
      } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
        $scope.selected = $scope.items.slice(0);
        //$mdDialog.show({
        //    multiple: true,
        //    templateUrl: 'app/main/apps/operations/scheduler/ServiceOnalert.html',
        //    parent: angular.element($document.body),
        //    targetEvent: e,
        //    scope: $scope.$new(),
        //    controller: function operationsProjectController($scope, $mdDialog) {
        //        $scope.closeDialog = function () {
        //            $mdDialog.hide();
        //        }
        //    }
        //});
      }
    };
    $scope.NoNotAll = function () {
      $mdDialog.cancel();
      return $scope.selected.length = [];
    }
    $scope.FilterByTeam = function (FC, FT, FZ) {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      if (FC != undefined && FC != null || FT != undefined && FT != null) {
        var FilteredData = null;
        if (FC != undefined && FC != null && FT != undefined && FT != null) {
          var FilterByTeam = $scope.Uniqueschedulerdatas.filter(function (FilterByTeam) {
            return FT.indexOf(FilterByTeam.AssignedTo) > -1 && FC.indexOf(FilterByTeam.Customer) > -1;
          });
          FilteredData = FilterByTeam;
        }
        if (FC == undefined || FC == null || FC == "") {
          var FilterByTeam = $scope.Uniqueschedulerdatas.filter(function (FilterByTeam) {
            return FT.indexOf(FilterByTeam.AssignedTo) > -1;
          });
          FilteredData = FilterByTeam;
        }
        if (FT == undefined || FT == null || FT == "") {
          var FilterByC = $scope.Uniqueschedulerdatas.filter(function (FilterByC) {
            return FC.indexOf(FilterByC.Customer) > -1;
          });
          FilteredData = FilterByC;
        }
        var yet = FilteredData.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = FilteredData.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        $scope.MobileInProgressdatas = InProgres;
        var completed = FilteredData.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;
        var datapush = [];
        angular.forEach(FilteredData, function (value) {
          try {
            if (value.Contracterdetails[0] != null && value.Contracterdetails[0] != '' && value.Contracterdetails[0] != undefined) {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Contract : ' + value.Contracterdetails[0].ContractReferenceNo,
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true, resizable: true,
              });
            }
            else {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;',
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true, resizable: true,
              });
            }
          } catch (error) {
          }
        })
        $scope.calenderdata = datapush;
      }
    }
    $scope.Datefilter = function (FC, FT, FZ) {
      $scope.YettoStartdatas = undefined;
      $scope.InProgressdatas = undefined;
      $scope.Completeddatas = undefined;
      if ($scope.vm.filtercustomer == null || $scope.vm.filtercustomer == undefined || $scope.vm.filtercustomer == "") {
        $scope.vm.filtercustomer = null
      }
      if ($scope.vm.filterteam == null || $scope.vm.filterteam == undefined || $scope.vm.filterteam == "") {
        $scope.vm.filterteam = null
      }
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: $scope.vm.filtercustomer,
          Team_Id: $scope.vm.filterteam
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.AllScheduleDatas = GList.data.data;
        $scope.Uniqueschedulerdatas = GList.data.data;
        var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = $scope.Uniqueschedulerdatas.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        $scope.MobileInProgressdatas = InProgres;
        var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;

        var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
          return adhoc.AdhocType === "Adhoc";
        });
        $scope.AdhocJobsdatas = adhoc;
        var datapush = [];
        angular.forEach($scope.Uniqueschedulerdatas, function (value) {
          try {
            datapush.push({
              title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
              startsAt: new Date(value.Startsat),
              endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
              id: value._id,
              draggable: true,
              resizable: true,
            });
          } catch (error) { }
        })
        $scope.calenderdata = datapush;
      });
    }
    $scope.DatefilterMulti = function (FC, FT) {
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      if (FC != null && FC != "" && FC != undefined) {
        FC = FC.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: null,
          Team_Id: null
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType; var PestCode = '';
            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.AllScheduleDatas = GList.data.data;
        $scope.Uniqueschedulerdatas = GList.data.data;
        if (FC != null && FC != undefined && FC != "" && FT != null && FT != undefined && FT != "") {
          var item = $scope.Uniqueschedulerdatas.filter(function (item) {
            return FC.indexOf(item.Customer) > -1 && FT.indexOf(item.AssignedTo) > -1;
          });
          $scope.Uniqueschedulerdatas = item;
        } else if (FC != undefined && FC != null && FC != "") {
          if (FT == undefined || FT == null || FT == "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FC.indexOf(item.Customer) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
        } else if (FT != undefined && FT != null && FT != "") {
          if (FC == undefined || FC == null || FC == "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
        }
        var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        $scope.YettoStartdatas = yet;
        var progerss = $scope.Uniqueschedulerdatas.filter(function (progerss) {
          return progerss.Status === "Outstanding";
        });
        $scope.InProgressdatas = progerss;
        var InProgres = $scope.Uniqueschedulerdatas.filter(function (InProgres) {
          return InProgres.Status === "In-Progress";
        });
        //$scope.MobileInProgressdatas = InProgres;
        var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
          return completed.Status === "Completed";
        });
        $scope.Completeddatas = completed;
        var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
          return adhoc.AdhocType === "Adhoc";
        });
        $scope.AdhocJobsdatas = adhoc;
        var datapush = [];
        angular.forEach($scope.Uniqueschedulerdatas, function (value) {
          try {
            datapush.push({
              title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
              startsAt: new Date(value.Startsat),
              endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
              id: value._id,
              draggable: true,
              resizable: true,
            });
          } catch (error) { }
        })
        $scope.calenderdata = datapush;
      });
    }
    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item1 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'ScheduleFrequency';
        });
        $scope.ScheduleFrequencydatas = item1;
      }
      catch (e) { }
      try {
        var item2 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'PaymentMode';
        });
        $scope.PaymentModedatas = item2;
      }
      catch (e) { }
      try {
        var item3 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'BillingFrequency';
        });
        $scope.BillingFrequencydatas = item3;
      }
      catch (e) { }
      try {
        var item3 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'Remarks';
        });
        $scope.Remarksdatas = item3;
      }
      catch (e) { }
      try {
        var item4 = $scope.Settingsdatas.filter(function (item) {
          return item.Description === 'JobTypes';
        });
        $scope.JobTypesdatas = item4;
      }
      catch (e) { }
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/servicetypelist",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Servicesdata) {
      $scope.Servicesdatas = Servicesdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/vehicle",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Vehicledata) {
      $scope.Vehicledatas = Vehicledata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/customer",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (customerdata) {
      $scope.Customerdatas = customerdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/detailsforTab",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/user/getByClientId",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        try {
          var Userdata = $scope.Userdatas.filter(function (item) {
            return item.UserID === $rootScope.createdby;
          })[0];

          var item1 = $scope.Employeedatas.filter(function (item) {
            return item.EmployeeID === Userdata.EmployeeID;
          })[0];
          $scope.RequestedBy = item1.EmployeeID + '-' + item1.EmployeeName;
        } catch (error) { }
        angular.forEach($scope.Userdatas, function (value) {
          angular.forEach($scope.Employeedatas, function (evalue) {
            if (value.EmployeeID == evalue.EmployeeID)
              value.EmployeeID = evalue.EmployeeName;
          })
        })
      });
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/calendar",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Calendardata) {
      $scope.Holidaysdatas = Calendardata.data.data;
      var item = $scope.Holidaysdatas.filter(function (item) {
        return item.EventType === 'Holiday';
      });
      $scope.HolidaySelectedon = [];
      angular.forEach(item, function (value) {
        $scope.HolidaySelectedon.push(new Date(value.StartDate).setHours(0, 0, 0, 0))
      })
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder/getForScheduler",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (salesdata) {
      $scope.salesdatas = salesdata.data.data;
      // var array = [];
      // angular.forEach($scope.Customerdatas, function (value, key) {
      //   angular.forEach($scope.salesdatas, function (svalue, skey) {
      //     try {
      //       if (value.id == svalue.Customer_id) {
      //         array.push(value);
      //       }
      //     }
      //     catch (e) { }
      //   })
      // })
      // if (array.length != 0) {
      //   try {
      //     var newArr = [];
      //     angular.forEach(array, function (value, key) {
      //       var exists = false;
      //       angular.forEach(newArr, function (val2, key) {
      //         if (angular.equals(value.id, val2.id)) { exists = true };
      //       });
      //       if (exists == false && value.id != "") { newArr.push(value); }
      //     });
      //     $scope.Customerdatas = newArr;
      //   }
      //   catch (e) { }
      // }
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contract",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (contractdata) {
      $scope.contractdatas = contractdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/team",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (teamdata) {
      $scope.teamdatas = teamdata.data.data;
      var tdydate = new Date()
      var today = new Date();
      var end = new Date();
      $scope.uFrom = new Date(today);
      $scope.uTo = new Date(end);
    });
    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }
    function RefreshGrid() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/user/getByClientId",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        angular.forEach($scope.Userdatas, function (value) {
          angular.forEach($scope.Employeedatas, function (evalue) {
            if (value.EmployeeID == evalue.EmployeeID)
              value.EmployeeID = evalue.EmployeeName;
          })
        })
        $scope.NewGetByStatus()
      });
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
      $("#PendingContainer").dxDataGrid("instance").clearSelection();
    }
    $scope.uoFrom = new Date(new Date().setDate(new Date().getDate() - 1));
    $scope.uoTo = new Date(new Date().setDate(new Date().getDate() - 1));
    $scope.vm.OutstandingPreviewSpinner = false;
    $scope.vm.InProgressPreviewSpinner = false;
    $scope.vm.AdhocJobPreviewSpinner = false;
    $scope.getOutsatnding = function () {
      $scope.InProgressdatas = [];
      $scope.vm.OutstandingPreviewSpinner = true;
      $scope.vm.filtercustomer = null
      $scope.vm.filterteam = null
      $scope.uoFrom.setHours(0, 0, 0, 0);
      $scope.uoTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/scheduler/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uoFrom,
          End_Date: $scope.uoTo,
          Client_Id: $rootScope.Client_Id,
          Customer_Id: $scope.vm.filtercustomer,
          Team_Id: $scope.vm.filterteam
        },
      });
      response.then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',');
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          }
          catch (e) { }
        })
        $scope.Uniqueschedulerdatas = GList.data.data;
        var idarry = [];
        try {
          var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
            return yet.Status === "Yet to Start";
          });
        } catch (e) { }
        angular.forEach(yet, function (value) {
          var dd = new Date(value.Startsat);
          var hh = new Date(value.Endsat);
          var mm = new Date(hh.setDate(new Date(dd).getDate()));
          var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
          var x = new Date(yy.setFullYear(new Date(dd).getFullYear()));
          var e = new Date(x).getTime();
          var c = new Date().getTime();
          if (e < c) {
            idarry.push(value._id)
          }
        })
        $http({
          url: $rootScope.WebURL + "/scheduler/getAllOutstandingJobs",
          method: "POST",
          data: {
            Client_Id: $rootScope.Client_Id,
          },
        }).then(function (List) {
          $scope.vm.OutstandingPreviewSpinner = false;
          angular.forEach(List.data.data, function (value) {
            try {

              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              try {
                value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
              } catch (error) {
                value.NewSiteName = value.customerdetails[0].CompanyName
                $scope.vm.OutstandingPreviewSpinner = false;
                console.log(error)
              }
            }
            catch (e) { $scope.vm.OutstandingPreviewSpinner = false; console.log(e) }
          })
          var progerss = List.data.data
          $scope.InProgressdatas = progerss;
          $scope.AllScheduleDatas = $scope.AllScheduleDatas.concat(progerss);
          $scope.vm.OutstandingPreviewSpinner = false;
        })
        try {
          $scope.DeleteMarkers();
        } catch (e) { }

      });
    }
    $scope.getAllInProgress = function () {
      $scope.MobileInProgressdatas = [];
      $scope.vm.InProgressPreviewSpinner = true;
      $scope.iFrom = new Date($scope.uFrom);
      $scope.iTo = new Date($scope.uTo);
      $scope.iFrom.setHours(0, 0, 0, 0);
      $scope.iTo.setHours(23, 59, 59, 999);
      $http({
        url: $rootScope.WebURL + "/scheduler/getInProgress",
        method: "POST",
        data: {
          Start_Date: $scope.iFrom,
          End_Date: $scope.iTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (GList) {
        angular.forEach(GList.data.data, function (value) {
          try {

            var NewFrequency = value.Frequency.split('||')
            var TreatmentMethod = []
            NewFrequency.forEach(function (val) {
              var iittem = val.split('~')
              TreatmentMethod.push({
                Frequency: iittem[0],
                PestName: iittem[1],
                Treatment: iittem[2]
              })
            })
            var Pestcode = ""
            angular.forEach(TreatmentMethod, function (item) {
              var pt = ""
              if (item.Frequency.includes("Alternate")) {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
              else {
                pt = $scope.Pesttypedatas.filter(function (pt) {
                  return item.PestName == pt.PestName;
                })[0].Pestcode
                if (Pestcode != "")
                  Pestcode = Pestcode + "," + pt
                else Pestcode = pt
              }
            })
            value.PestCode = Pestcode
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
            // var PestArray = []
            // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
          } catch (e) {
          }
        })
        $scope.MobileInProgressdatas = GList.data.data;
        $scope.AllScheduleDatas = GList.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.InProgressPreviewSpinner = false;
      });
    }
    $scope.getAdhocJobs = function () {
      $scope.AdhocJobsdatas = [];
      $scope.vm.AdhocJobPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $http({
        url: $rootScope.WebURL + "/scheduler/getAdhocJobs",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (GList) {
        $scope.AdhocJobsdatas = GList.data.data;
        try {
          $scope.DeleteMarkers();
        } catch (e) { }
        $scope.vm.AdhocJobPreviewSpinner = false;
      });
    }
    $scope.ShowEmailSent = function (EmailSent) {
      if (EmailSent != null && EmailSent != undefined && EmailSent != "") {
        if (EmailSent == true) {
          return "Yes";
        }
        else if (EmailSent == false) {
          return "No";
        }
        else {
          return "No";
        }
      }
      else {
        return "No";
      }
    }
    $scope.vm.PreviewSpinner = false;
    $scope.GetByStatus = function (Status, FT) {
      $scope.TRCCdiv = false;
      $scope.CompletedSelectedIds = [];
      $scope.AllCSelec = { value: false };
      $scope.CSelec = { value: false }
      $scope.YettoStartdatas = [];
      $scope.vm.YTSPreviewSpinner = true;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);

      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      else {
        // do nothing
      }
      if (Status == 'Completed') {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {

              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Completeddata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Completeddata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          $scope.Completeddatas = resArr;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if (Status == 'Pending Approval') {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatusCompleted",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Pendingdata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Pendingdata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }

          var getPending = [];
          try {
            getPending = resArr.filter(function (pending) {
              return pending.ServiceReportStatus == "Pending";
            });
          } catch (e) { }

          $scope.PendingApprovaldatas = getPending;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FC.indexOf(item.Customer) > -1 && FT.indexOf(item.AssignedTo) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
          var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
            return yet.Status === "Yet to Start";
          });
          $scope.YettoStartdatas = yet;
          var completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
            return completed.Status === "Completed";
          });
          $scope.Completeddatas = completed;
          var adhoc = $scope.Uniqueschedulerdatas.filter(function (adhoc) {
            return adhoc.AdhocType === "Adhoc";
          });
          $scope.AdhocJobsdatas = adhoc;
          var datapush = [];
          angular.forEach($scope.Uniqueschedulerdatas, function (value) {
            try {
              datapush.push({
                title: 'Customer : ' + value.customerdetails[0].CompanyName + '&emsp;&emsp;&emsp;' + "Work Order : " + value.JobOrdersdetails[0].SalesOrderNo + '&emsp;&emsp;&emsp;' + 'Service ID : ' + value.ServiceID,
                startsAt: new Date(value.Startsat),
                endsAt: CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat)),
                id: value._id,
                draggable: true,
                resizable: true,
              });
            } catch (error) { }
          })
          $scope.calenderdata = datapush;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }
    $scope.StatusDatefilterMulti = function (FT) {
      var Status = 'Yet to Start'
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      $scope.Completeddatas = [];
      $scope.YettoStartdatas = [];
      $scope.vm.YTSPreviewSpinner = true;
      if (FT != null && FT != "" && FT != undefined) {
        FT = FT.map(function (obj) {
          return obj.id;
        }).join(',');
      }
      if ($scope.vm.SelectedTab == 'Completed') {
        Status = 'Completed'
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var Completeddata = Uniqueschedulerdatas;
          var resArr = [];
          try {
            Completeddata.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          $scope.Completeddatas = resArr;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        Status = 'Completed'
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatusCompleted",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: 'Completed',
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          var Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.AssignedTo) > -1;
            });
            Uniqueschedulerdatas = item;
          }
          var PendingData = Uniqueschedulerdatas;
          var resArr = [];
          try {
            PendingData.filter(function (item) {
              var i = resArr.findIndex(function (x) {
                return x._id == item._id
              });
              if (i <= -1)
                resArr.push(item);
            });
          } catch (e) { }
          var getPending = [];
          try {
            getPending = resArr.filter(function (pending) {
              return pending.ServiceReportStatus == "Pending";
            });
          } catch (e) { }

          $scope.PendingApprovaldatas = getPending;
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      else if ($scope.vm.SelectedTab == 'PendingSchedule') {
        $scope.getPendingSchedule()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else if ($scope.vm.SelectedTab == 'In-Progress') {
        $scope.getAllInProgress()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else if ($scope.vm.SelectedTab == 'ScheduledWorkOrder') {
        $scope.getScheduledWorkOrder()
        $scope.vm.YTSPreviewSpinner = false;
      }
      else {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getbyStatus",
          method: "POST",
          data: {
            Start_Date: $scope.uFrom,
            End_Date: $scope.uTo,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: $scope.SelectedCustomerID,
            Status: Status,
            Team_Id: null
          },
        });
        response.then(function (GList) {
          angular.forEach(GList.data.data, function (value) {
            try {
              var PestCode = '';
              var NewFrequency = value.Frequency.split('||')
              var TreatmentMethod = []
              NewFrequency.forEach(function (val) {
                var iittem = val.split('~')
                TreatmentMethod.push({
                  Frequency: iittem[0],
                  PestName: iittem[1],
                  Treatment: iittem[2]
                })
              })
              var Pestcode = ""
              angular.forEach(TreatmentMethod, function (item) {
                var pt = ""
                if (item.Frequency.includes("Alternate")) {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode + " (" + item.Treatment.trim().substr(0, 1) + ")"
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
                else {
                  pt = $scope.Pesttypedatas.filter(function (pt) {
                    return item.PestName == pt.PestName;
                  })[0].Pestcode
                  if (Pestcode != "")
                    Pestcode = Pestcode + "," + pt
                  else Pestcode = pt
                }
              })
              value.PestCode = Pestcode
              // var PestArray = []
              // PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
              //  value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            } catch (e) {
            }
          })
          $scope.AllScheduleDatas = GList.data.data;
          $scope.Uniqueschedulerdatas = GList.data.data;
          if (FT != null && FT != undefined && FT != "") {
            var item = $scope.Uniqueschedulerdatas.filter(function (item) {
              return FT.indexOf(item.Team_Id) > -1;
            });
            $scope.Uniqueschedulerdatas = item;
          }
          else if (Status == "Completed") {
            var completed = []
            try {
              completed = $scope.Uniqueschedulerdatas.filter(function (completed) {
                return completed.Status === "Completed";
              });
            } catch (e) { }
            $scope.Completeddatas = completed;

            var pendingApproval = []
            try {
              pendingApproval = $scope.Uniqueschedulerdatas.filter(function (pending) {
                return pending.Status === "Completed" && pending.ServiceReportStatus == "Pending";
              });
            } catch (e) { }
            $scope.PendingApprovaldatas = pendingApproval;
          }
          else {
            var yet = $scope.Uniqueschedulerdatas.filter(function (yet) {
              return yet.Status === "Yet to Start";
            });
            $scope.YettoStartdatas = yet;
          }
          $scope.vm.YTSPreviewSpinner = false;
        });
      }
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }
    function getMonthDays(myMonth) {
      var now = new Date();
      var nowYear = now.getFullYear();
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    }
    function RefreshAttachmentGrid() {
      $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.jobdata },
      }).then(function (attachmentdata) {
        var item = attachmentdata.data.data.filter(function (item) {
          return item.TableName === 'Operations'
        })
        $scope.Attachmentdatas = item;
      });
      $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.jobdata },
      }).then(function (attachmentdata) {
        var item = attachmentdata.data.data.filter(function (item) {
          return item.TableName === 'Sales Order' || item.TableName === 'Operations'
        })
        $scope.NAttachmentdatas = item;
      });
    }
    $scope.DeleteAttachment = function (id) {
      $scope.delAtachId = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          $http({
            url: $rootScope.WebURL + "/attachment/delete",
            method: "POST",
            data: { _id: $scope.delAtachId },
          }).then(function (attachmentdata) {
            RefreshAttachmentGrid()
            $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
          })
        }
      })
    }

    $scope.DeleteComment = function (id) {
      $scope.delComId = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          $http({
            url: $rootScope.WebURL + "/schedulercomment/delete",
            method: "POST",
            data: { _id: $scope.delComId },
          }).then(function (attachmentdata) {
            var response = $http({
              url: $rootScope.WebURL + "/schedulercomment/getByCustomer",
              method: "POST",
              data: { RequestID: $scope.vm.Customersearch },
            });
            response.then(function (Commentdata) {
              $scope.NCommentdatas = Commentdata.data.data;
              $mdToast.show($mdToast.simple().textContent('Comment deleted Successfully!').position('top center'));
            });
          })
        }
      })
    }

    $scope.makeComplete = function () {
      var Startdate = CombineDateAndTime($scope.vm.ResheduleFrom, $scope.vm.ResheduleStartTime)
      var Enddate = CombineDateAndTime($scope.vm.ResheduleFrom, $scope.vm.ResheduleEndTime)
      var item = $scope.teamdatas.filter(function (item) {
        return item.TeamName === $scope.vm.UTeam1
      })[0]
      var TeamMem = item.TeamMembers
      var TeamLead = item.TeamLead
      $http({
        method: 'PUT',
        url: $rootScope.WebURL + '/tabletschedulerrecord/tocomplete',
        data: {
          ServiceId: $scope.SID,
          Team: $scope.vm.UTeam1,
          Scheduledate: new Date(Startdate),
          WorkorderNo: $scope.vm.SalesOrderNo,
          ContractOrderNo: $scope.vm.ContractOrderNo,
          ContactPerson: $scope.vm.ContactPerson,
          Startsat: Startdate,
          Endsat: Enddate,
          Location: $scope.vm.Location,
          StartLocation: $scope.vm.LatLong,
          EndLocation: $scope.vm.LatLong,
          Pesttype: $scope.vm.PestType1,
          TeamLead: TeamLead,
          BillingAmount: $scope.vm.BillingAmount,
          TeamMember: TeamMem,
          JobType: $scope.vm.JobType,
          CustomerName: $scope.vm.CustomerName,
          EmailId: $scope.vm.CusEmail,
          CreatedBy: $rootScope.createdBy
        }
      }).then(function (Glist) {
        $scope.getOutsatnding()
        $mdToast.show($mdToast.simple().textContent('Outstanding updated Successfully!').position('top center'));
        $mdDialog.cancel()
      })
    }
    $scope.PestTreatmentMethod = []
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pocarddatas) {
      $scope.Pesttypedatas = pocarddatas.data.data;
      $scope.Pestdatasdatas = pocarddatas.data.data;
      angular.forEach($scope.Pesttypedatas, function (value, key) {
        $scope.PestTreatmentMethod.push({
          "ID": value.PestName,
          "name": value.PestName,
          "expanded": false
        })
      })
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (treatment) {
        $scope.Treatmentdatas = treatment.data.data
        angular.forEach($scope.Treatmentdatas, function (value) {
          $scope.PestTreatmentMethod.push({
            "ID": value.TreatmentName + '~' + value.PestType,
            "categoryId": value.PestType,
            "name": value.TreatmentName,
          })
        })
      })
    })
    function Refreshcomment() {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByReqID",
        method: "POST",
        data: { RequestID: $scope.vm.jobdata },
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
      });
    }
    function CustomerServicedatadetails() {
      var response = $http({
        url: $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.RequestID },
      });
      response.then(function (CustomerServicedata) {
        //$scope.CustomerServicedatas = CustomerServicedata.data.data;
        var resArr = [];
        try {
          CustomerServicedata.data.data.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return x.sBLK == item.sBLK && x.sUnit == item.sUnit && x.sStreetName == item.sStreetName && x.sPostal == item.sPostal
            });
            if (i <= -1)
              resArr.push(item);
          });
        } catch (e) { }
        $scope.CustomerServicedatas = resArr;
        $scope.vm.PreviewSpinner = false;
        if ($scope.vm.FixedTeam == "Yes") {
          if ($scope.vm.FixedTeamdata != null && $scope.vm.FixedTeamdata != "" && $scope.vm.FixedTeamdata != undefined) {
            var array = $scope.vm.FixedTeamdata.split(",");
            var array1 = [];
            angular.forEach(array, function (item) {
              angular.forEach($scope.teamdatas, function (value) {
                if (item == value.TeamName) {
                  array1.push(value);
                }
              });
            });
            $scope.teamdatas = array1;
          } else {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/team",
              data: {
                Client_Id: $rootScope.Client_Id
              },
            }).then(function (teamdata) {
              $scope.teamdatas = teamdata.data.data;
            });
          }
        }
        else {
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id },
          }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
          });
        }
      });
    }
    function RefreshPhotos() {
      $scope.Photosdatas = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerpicafter",
        data: { ScedulId: $scope.vm.ScedulId },
      }).then(function (Glist) {
        $scope.Photosdatas = Glist.data.data;
        angular.forEach($scope.Photosdatas, function (item) {
          item.Path = $rootScope.ServicePhotosURL + item.ServiceId + "/" + item.id + ".png";
        });
      });
    }


    function RefreshSchedulerLogs() {
      var response = $http({
        url: $rootScope.WebURL + "/schedulelog/getByServiceID",
        method: "POST",
        data: { ServiceID: $scope.vm.ServiceID },
      });
      response.then(function (SchedulerLogdata) {

        $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
      });
    }
    function RefreshUnit() {
      var response = $http({
        url: $rootScope.WebURL + "/unit",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Unitdata) {
        $scope.Unitdatas = Unitdata.data.data;
      });
    }
    function CombineDateAndTime(date, time) {
      var timeString = time.getHours() + ':' + time.getMinutes() + ':00';
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // Jan is 0, dec is 11
      var day = date.getDate();
      var dateString = '' + year + '-' + month + '-' + day;
      var combined = new Date(dateString + ' ' + timeString);
      return combined;
    };
    function RefreshSchedulerReportPathGrid() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerreportpath/getLast10",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Schedulerreportpathdata) {
        $scope.Schedulerreportpathdatas = Schedulerreportpathdata.data.data;
      });
    }
    function RefreshGroupID() {
      var response = $http({
        url: $rootScope.WebURL + "/groupid/LastOne",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id },
      });
      response.then(function (Groupiddata) {
        $scope.Groupiddatas = Groupiddata.data.data;
      });
    }
    function pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    function nthWeekdayOfMonth(weekday, n, date) {
      var count = 0,
        idate = new Date(date.getFullYear(), date.getMonth(), 1);
      while (true) {
        if (idate.getDay() === weekday) {
          if (++count == n) {
            break;
          }
        }
        idate.setDate(idate.getDate() + 1);
      }
      if (idate.getMonth() === new Date(date).getMonth())
        return idate;
      else {
        return new Date(idate.setDate(idate.getDate() - 7));
      }
    }
    function daysInMonth(d, day) {
      var days = [];
      var getTot = new Date(d.getFullYear(), d.getMonth(), 0).getDate();
      for (var i = 1; i <= getTot; i++) {
        var newDate = new Date(d.getFullYear(), d.getMonth(), i)
        if (newDate.getDay() == 1 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 2 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 3 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 4 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 5 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 6 && day == newDate.getDay()) {
          days.push(i)
        }
        if (newDate.getDay() == 0 && day == newDate.getDay()) {
          days.push(i)
        }
      }
      return days;
    }
    function CheckNotEmpty(value) {
      if (value != null && value != undefined && value != "")
        return true;
      else
        return false
    }
    function getWeekOfMonth(exact) {
      var month = exact.getMonth()
        , year = exact.getFullYear()
        , firstWeekday = new Date(year, month, 1).getDay()
        , lastDateOfMonth = new Date(year, month + 1, 0).getDate()
        , offsetDate = exact.getDate() + firstWeekday - 1
        , index = 1 // start index at 0 or 1, your choice
        , weeksInMonth = index + Math.ceil((lastDateOfMonth + firstWeekday - 7) / 7)
        , week = index + Math.floor(offsetDate / 7)
        ;
      if (exact || week < 2 + index) return week;
      return week === weeksInMonth ? index + 5 : week;
    }
    $scope.ShowType = function (gCR, gRSR) {
      if (gCR != null && gCR != undefined && gCR != "") {
        return "Cancelled";
      }
      else if (gRSR != null && gRSR != undefined && gRSR != "") {
        return "Rescheduled";
      }
      else {
        return null;
      }
    }
    var vm = this;
    vm.searchInit = true;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');
        if (vm.searchInit == true) {
          var table = $('#example').DataTable();
          table.search('').draw();
          vm.searchInit = false;
        }
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      destroy: true,
      pagingType: 'simple',
      autoWidth: false,
      order: [[1, "asc"]],
      lengthMenu: [10, 20, 30, 50, 100],
      responsive: true,
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };
    vm.dtOptions1 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#search');
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      destroy: true
    };
    vm.dtdetails1 = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-dtdetails1');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dtOptions2 = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#ReportSearch');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };
    vm.dtpreviewdetails = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-dtpreviewdetails');
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 50, 100, 1000],
      destroy: true
    };

    vm.dtOptions5 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      drawCallback: function (settings) {
        var api = this.api();

        var rows = api.rows({ page: 'current' }).nodes();
        var last = null;

        api.column(1, { page: 'current' }).data().each(function (group, i) {
          if (last !== group) {
            $(rows).eq(i).before(
              '<tr class="group"><td colspan="18"><b>' + group + '</b></td></tr>'
            );

            last = group;
          }
        });
      },
    }

    vm.calendarView = 'day';
    vm.viewDate = new Date();
    var actions = [{
      label: '<i class=\'glyphicon glyphicon-pencil\'></i>',
      onClick: function (args) {
        alert.show('Edited', args.calendarEvent);
      }
    }, {
      label: '<i class=\'glyphicon glyphicon-remove\'></i>',
      onClick: function (args) {
        alert.show('Deleted', args.calendarEvent);
      }
    }];
    vm.cellIsOpen = false;

    vm.eventClicked = function (event) {


      alert.show('Clicked', event);
    };
    vm.eventEdited = function (event) {

      alert.show('Edited', event);
    };
    vm.eventDeleted = function (event) {
      alert.show('Deleted', event);
    };
    vm.toggle = function ($event, field, event) {
      $event.preventDefault();
      $event.stopPropagation();
      event[field] = !event[field];
    };
    vm.timespanClicked = function (date, cell) {
      if (vm.calendarView === 'month') {
        if ((vm.cellIsOpen && moment(date).startOf('day').isSame(moment(vm.viewDate).startOf('day'))) || cell.events.length === 0 || !cell.inMonth) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      } else if (vm.calendarView === 'year') {
        if ((vm.cellIsOpen && moment(date).startOf('month').isSame(moment(vm.viewDate).startOf('month'))) || cell.events.length === 0) {
          vm.cellIsOpen = false;
        } else {
          vm.cellIsOpen = true;
          vm.viewDate = date;
        }
      }

    };
    $scope.mapFilter = function () {
      NgMap.getMap().then(function (map) {
        for (var key in map.markers) {
          map.markers[key].setMap(null);
          // map.directionsRenderers[key].setMap(null);
        };

      });
      var Start_Date = new Date($scope.mapDate.setHours(0, 0, 0, 0));
      var End_Date = new Date($scope.mapDate.setHours(23, 59, 59, 999));

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/routemapfilter",
        data: { Client_Id: $rootScope.Client_Id, Team: $scope.vm.mapTeam, Start_Date: Start_Date, End_Date: End_Date },
      }).then(function (uniquescheduler) {
        $scope.Routemapdatas = uniquescheduler.data.data;
        GetRouteByTeam();
      });
    }
    $scope.Maping = function () {
      $scope.MapViewProgresdatas = [];
      $scope.DeleteMarkers();
      $http({
        url: $rootScope.WebURL + "/scheduler/getforMaping",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id,
        },
      }).then(function (GList) {
        $scope.MapViewProgresdatas = GList.data.data;
        NgMap.getMap().then(function (map) {
          if (map.markers != "" && map.markers != null && map.markers != undefined) {

            for (var i in map.markers) {
              i = parseFloat(i);
              map.markers[i].setMap(null);
              map.markers[i].setPosition(null);
              map.markers[i].setTitle(null);
              map.markers[i].setIcon(null);
              map.markers[i].setVisible(false);
            }
          }
          //map.markers = null;
          //map.markers.length = 0;
          //map.markers = new Array();
          //google.maps.Map.prototype.markers = new Array();
          $scope.Mapingpositions = [];
          var getmarkers = [];
          var Mapviewprog = $scope.MapViewProgresdatas;
          angular.forEach($scope.MapViewProgresdatas, function (Mapviewprog) {
            var address = Mapviewprog.Location;
            var Colour = "#2D11E0";
            var Customer = "";
            var TeamLead = "";
            var latitude = 1.3554;
            var longitude = 103.8677;
            var LatLong = "103.8677,1.3554"
            if (Mapviewprog.Status == "In-Progress") {
              Colour = '/assets/images/logos/personGreen.png';
            }
            if (Mapviewprog.Status == "Completed") {
              Colour = '/assets/images/logos/personRed.png';
            }
            if (Mapviewprog.AdhocType == "Adhoc") {
              if (Mapviewprog.CompanyName != null && Mapviewprog.CompanyName != undefined) {
                try {
                  Customer = Mapviewprog.CompanyName;
                  TeamLead = Mapviewprog.TeamLead;
                  if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                    LatLong = Mapviewprog.LatLong;
                  }
                }
                catch (e) { }
              }
              else {
                try {
                  Customer = Mapviewprog.AdhocCustomerName;
                  TeamLead = Mapviewprog.TeamLead;
                  if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                    LatLong = Mapviewprog.LatLong;
                  }
                }
                catch (e) { }
              }
            }
            else {
              try {
                Customer = Mapviewprog.CompanyName;
                TeamLead = Mapviewprog.TeamLead;
                if (Mapviewprog.LatLong != "" && Mapviewprog.LatLong != null && Mapviewprog.LatLong != undefined) {
                  LatLong = Mapviewprog.LatLong;
                }
              }
              catch (e) { }
            }
            var j = getmarkers.findIndex(function (x) {
              return x.LatLong == LatLong && x.icon == Colour;
            });
            if (j <= -1) {
              var len = getmarkers.length;
              getmarkers[len] = new google.maps.Marker({
                title: TeamLead + " - " + $filter('date')(new Date(Mapviewprog.Startsat), 'hh:m a') + " - " + $filter('date')(new Date(Mapviewprog.Endsat), 'hh:m a') + " - " + Mapviewprog.ServiceID,
                icon: Colour,
                LatLong: LatLong,
                //onRoute: false,
                //map: null,
                //id: len,
                //trigger: 'active',
              })
            }
            else {
              angular.forEach(getmarkers, function (item, key) {
                if (item.LatLong === Mapviewprog.LatLong && item.icon === Colour) {
                  item.title = item.title + '\n' + TeamLead + " - " + $filter('date')(new Date(Mapviewprog.Startsat), 'hh:m a') + " - " + $filter('date')(new Date(Mapviewprog.Endsat), 'hh:m a') + " - " + Mapviewprog.ServiceID;
                }
              });
            }
          })
          angular.forEach(getmarkers, function (gmvalue) {
            var lati = 1.3554;
            var lngi = 103.8677;
            if (gmvalue.LatLong != "" && gmvalue.LatLong != null && gmvalue.LatLong != undefined) {
              var array = gmvalue.LatLong.split(",")
              lati = parseFloat(array[1]);
              lngi = parseFloat(array[0]);
            }
            var lat = lati + (Math.random() / 100);
            var lng = lngi + (Math.random() / 100);
            var latlng = new google.maps.LatLng(lat, lng);
            gmvalue.setPosition(latlng);
            gmvalue.setMap(map);
            gmvalue.setVisible(true);
          })
          $scope.Mapingpositions = getmarkers;
        });
      });
    }
    $scope.DeleteMarkers = function () {
      var markers = $scope.Mapingpositions;
      if (markers != undefined) {
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(null);
          markers[i].setPosition(null);
          markers[i].setTitle(null);
          markers[i].setIcon(null);
          markers[i].setVisible(false);
        }
      }
      $scope.Mapingpositions = [];
      var getmarkers = [];
    };
    function GetRouteByTeam() {
      $scope.positions = [];
      var route = 1;
      angular.forEach($scope.Routemapdatas, function (evalue) {
        var geocoder = new google.maps.Geocoder();
        var address = evalue.Location;

        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();

            $scope.positions.push({ title: evalue.ServiceID, pos: [latitude, longitude], onRoute: false, id: route })
            route++;
            DisplayRoute();
          }
        });
      });
    }
    function DisplayRoute() {
      $scope.route = $scope.positions;
      $scope.start = $scope.positions[0];
      $scope.theWaypoints = [];
      if ($scope.route.length > 1) {
        for (var i = 1; i < $scope.route.length - 1; i++) {
          var obj = {
            location: {
              lat: $scope.route[i].pos[0],
              lng: $scope.route[i].pos[1]
            },
            stopover: true
          };
          $scope.theWaypoints.push(obj);
        }
      }
      $scope.end = $scope.route[$scope.route.length - 1];
      if ($scope.positions.length > 0) {
        NgMap.getMap().then(function (map) {
          $scope.map = map;
          google.maps.event.trigger($scope.map, "resize");
        });
      }
    }
    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "single",
        showCheckBoxesMode: 'onClick',
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sBuildingName", caption: "Building Name" },
        { dataField: "sStreetName", caption: "Street Name" },
        { dataField: "sPostal", caption: "Postal" },
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.ServiceAddressarray = [];
          $scope.vm.SiteContactName = e.selectedRowsData[0].sContactPerson;
          $scope.vm.SiteAddress = e.selectedRowsData[0].sBuildingName + " " + e.selectedRowsData[0].sStreetName + " " + e.selectedRowsData[0].sPostal;
          $scope.vm.SiteContactNumber = e.selectedRowsData[0].sMobile;
          $scope.ServiceAddressarray.push.apply($scope.ServiceAddressarray, e.selectedRowsData);
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
          e.element.find("tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection").find('.dx-button .dx-icon').css('background-color', '#83878a!important').css('color', '#ffff !important')
          if (e.selectedRowsData[0].sPostal) {
            var PostalCode = e.selectedRowsData[0].sPostal.substring(0, 2);
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/scheduler/getZone",
              data: { PostalCode: PostalCode }
            }).then(function (List) {
              try {
                $scope.vm.ppZone = List.data.data.Zone;
              }
              catch (e) { $scope.vm.ppZone = "" }
            })
          }
        }
        else {
          $scope.ServiceAddressarray = [];
          e.element.find('.dx-button .dx-icon').css('background-color', '#ffff!important').css('color', '#83878a !important')
        }
      },
    };
    var resourcesData = [{
      text: "Yet to Start",
      id: 1,
      color: "#CB6BB2"
    }, {
      text: "In-Progress",
      id: 2,
      color: "#56CA85"
    }, {
      text: "Completed",
      id: 3,
      color: "#000000"
    }, {
      text: "Outstanding",
      id: 4,
      color: "#FF9747"
    }, {
      text: "Cancelled",
      id: 5,
      color: "#FF0000"
    }, {
      text: "Blocked",
      id: 6,
      color: "#696969"
    }];

    $scope.FoggingList = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.Tittle = "Select Month to Export"
    }
    $scope.dateBox1 = {
      type: "date",
      width: 200,
      value: new Date(),
      displayFormat: 'monthAndYear',
      calendarOptions: {
        zoomLevel: 'month',
        maxZoomLevel: 'year',
        minZoomLevel: 'century',
      },
      onValueChanged: function (e) {
        var StartDate = new Date(e.value)
        var EndDate = new Date(new Date(e.value).getFullYear(), new Date(e.value).getMonth() + 1, 0)
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getforfogging",
          method: "POST",
          data: {
            Start_Date: StartDate,
            End_Date: EndDate,
            Client_Id: $rootScope.Client_Id,
            Customer_Id: null,
            Status: "Yet to Start",
            Team_Id: null
          },
        });
        response.then(function (GList) {
          $mdDialog.cancel()
          GList.data.data = _.sortBy(GList.data.data, "Startsat")
          var promises = [];
          var data = [];
          var array = [];
          angular.forEach(GList.data.data, function (value) {
            var deferred = $q.defer();
            try {
              // var MultiFrequency = value.JobOrdersdetails[0].MultiFrequency
              // var ite = MultiFrequency.filter(function (ite) {
              //   return ite.PestType == "Adult Mosquito" && ite.Treatment == "Fogging"
              // })
              // if (ite.length > 0) {
              var Blok = "NA"
              var Floor = "NA"
              var addressarray = value.sStreetName.split(' ')
              var Building = value.sBuildingName
              var StreetName = value.sStreetName
              Blok = _.isInteger(addressarray[0]) ? addressarray[0] : "NA"
              angular.forEach(addressarray, function (value) {
                if (value.includes('#')) {
                  Floor = value
                }
              })

              if (parseInt(moment(value.Endsat).diff(moment(value.Startsat), 'hours')) > 3) {
                value.Endsat = new Date(moment(value.Startsat).add(3, 'hours'))
              }
              if (value.TeamLeadContact == null || value.TeamLeadContact == undefined || value.TeamLeadContact == "null" || value.TeamLeadContact == "undefined") {
                value.TeamLeadContact = ""
              }

              if (Building == null || Building == undefined || Building == "null" || Building == "undefined")
                Building = "";
              var land = "Others"
              if (value.MarketSection.includes('Residential - Landed') || value.MarketSection.includes('Condominium'))
                land = "Landed"
              else if (value.MarketSection.includes('Industrial') || value.MarketSection.includes('Food Manufacturing') || value.MarketSection.includes('Construction'))
                land = "Industrial"
              if (Blok != "NA")
                StreetName = StreetName.replace(Blok, '').trim()
              if (Floor != "NA")
                StreetName = StreetName.replace(Floor, '').trim()
              StreetName = StreetName.replace(',', ' ').trim()

              array.push({
                Date: $filter('date')(value.Startsat, 'd/MM/yyyy'),
                "Time Start": $filter('date')(value.Startsat, 'hh:mm a'),
                "Time End": $filter('date')(value.Endsat, 'hh:mm a'),
                "Block/House No": Blok,
                "Floor/Unit No": Floor,
                "Street Name": StreetName.substring(0, 50),
                "Building Name": Building,
                "Postal Code": value.sPostal,
                "Land Use Type": land,
                "Other Land Use Type": "NA",
                Product: "Able Max",
                "Conc Amt": "25",
                "Mode of Aplication": "Oil-Based",
                "Purpose of Fogging (Adult Mosquito)": "Y",
                "Purpose of Fogging (Cockroach)": "Y",
                "Purpose of Fogging (Mosquito Larva)": "N",
                "Purpose of Fogging (Other Pests)": "N",
                "Source Reduction": 'Y',
                "Immediate Neighbour": "Y",
                "Immediate Reason for not Informing": '',
                "Contact Person": value.TeamLead,
                "Contact No": value.TeamLeadContact,
              })
              // }
            }
            catch (e) {

            }
            deferred.resolve(data);
            promises.push(deferred.promise);
          });
          $q.all(promises).then(
            function (results) {
              alasql('SELECT * INTO XLSX("Fogging List.csv",{headers:true}) FROM ?', [array]);
            },
            function (response) {
            }
          );
        })
      },

    }


    vm.dataGridYTS = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.YettoStartdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      export: {
        enabled: false,
        allowExportSelectedData: false,
        fileName: "Yet to Start Datas"
      },
      sorting: {
        mode: "multiple",
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          caption: "Work Order#", dataField: "JobOrdersdetails[0].SalesOrderNo",

        },
        {

          dataField: "Location", caption: "Address",
        },

        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
          cellTemplate: function (container, options) {
            try {
              $("<p style='color:blue;cursor: pointer;'>" + options.data.TeamName + "</p>").appendTo(container);
            } catch (e) { }
          },
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
      ],
      bindingOptions: {
        dataSource: "YettoStartdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onExporting: function (e) {
        e.cancel = true
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };

    vm.dataGridOnHold = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.OnHolddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      export: {
        enabled: false,
        allowExportSelectedData: false,
        fileName: "On Hold Datas"
      },
      sorting: {
        mode: "multiple",
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "CompanyName",
        },
        { dataField: "SiteAddress", caption: "Site Name" },
        { dataField: "SalesOrderNo", caption: "Work Order#" },
        {
          caption: "Reminder Date", dataField: "OnHoldDate", dataType: "date", format: 'dd/MM/yyyy'
        },
        {
          caption: "Status", dataField: "OnHoldStatus",
        },
        {
          caption: "Reason", dataField: "OnHoldComments",
        },
        { dataField: "PestCode", caption: "Pest Types" },
        { dataField: "RemainingStartJobs", caption: "Remaining Jobs" },
        {
          caption: "On-Hold Date", dataField: "OnHoldUpdatedDate", dataType: "date", format: 'dd/MM/yyyy hh:mm a'
        },
      ],
      bindingOptions: {
        dataSource: "OnHolddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onExporting: function (e) {
        e.cancel = true
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };


    vm.dataGridINP = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.MobileInProgressdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {

          dataField: "Location", caption: "Address",
        },

        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
      ],
      bindingOptions: {
        dataSource: "MobileInProgressdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };

    vm.dataGridOTS = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.InProgressdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {

          dataField: "Location", caption: "Address",
        },
        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
      ],
      bindingOptions: {
        dataSource: "InProgressdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };

    vm.dataGridCMP = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.Completeddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },

      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
            if (options.data.ImagesAvaliable == true) {
              $('<img />')
                .height(25)
                .attr('src', '../../../../../../assets/images/logos/Camera.png')
                .appendTo(container);
            }
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          dataField: "Location", caption: "Address",
        },
        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "tabletschedulerrecord[0].Team", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          dataField: "EmailSentTo", caption: "Emailed To",
          cellTemplate: function (container, options) {
            $("<p>" + $scope.removeLastComma(options.data.EmailSentTo) + "</p>").appendTo(container);
          },
        },
        { dataField: "EmailSentDate", caption: "Email Sent On", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        {
          caption: 'Service Report',
          fixed: false,
          fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'exportpdf',
              onClick: function (e) {
                var url = $rootScope.ReportURL + 'Service.aspx' + '?' + 'ID=' + options.data._id;
                window.open(url);
              }
            }).appendTo(container);
          }
        }
      ],
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
      bindingOptions: {
        dataSource: "Completeddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };
    vm.dataGridPASR = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      onCellPrepared: function (e) {
        angular.forEach($scope.PendingApprovaldatas, function (value) {
          try {
            var PestCode = '';
            var pest = value.PestType.split(',')
            angular.forEach(pest, function (ele) {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return ele == pt.PestName;
              })[0];
              PestCode = PestCode + pt.Pestcode + ',';
            })
            PestCode = PestCode.substring(0, PestCode.length - 1);
            value.PestCode = (PestCode != null && PestCode != undefined && PestCode != "") ? PestCode : value.PestType;
          } catch (e) {
          }
        })
      },
      dataSource: $scope.PendingApprovaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
            if (options.data.ImagesAvaliable == true) {
              $('<img />')
                .height(25)
                .attr('src', '../../../../../../assets/images/logos/Camera.png')
                .appendTo(container);
            }
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "JobCompletedDate", caption: "Job Completed Date & Time", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
      ],
      bindingOptions: {
        dataSource: "PendingApprovaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };
    vm.dataGridCNL = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.Cancelleddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          dataField: "ServiceID", width: "110", caption: "Service ID",
          cellTemplate: function (container, options) {
            $("<p style='color:blue;cursor: pointer;'>" + options.data.ServiceID + "</p>").appendTo(container);
          },
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        {
          dataField: "Location", caption: "Address",
        },

        { dataField: "JobOrdersdetails[0].SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        {
          dataField: "TeamName", caption: "Team",
        },
        { dataField: "ServiceOn", caption: "Day" },
        { dataField: "Startsat", caption: "Scheduled Date", dataType: "date", format: 'dd/MM/yyyy hh:mm a' },
        { dataField: "Startsat", caption: "Start Time", dataType: "date", format: 'hh:mm a' },
        { dataField: "Endsat", caption: "End Time", dataType: "date", format: 'hh:mm a' },
        { dataField: "Status", caption: "Status" },
        { dataField: "CancelRemarks", caption: "Remarks" },
      ],
      bindingOptions: {
        dataSource: "Cancelleddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.AddComments(data, data.data, false)
        }
      },
    };
    vm.PendingSchedulerdataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      onCellPrepared: function (e) {

      },
      dataSource: $scope.PendingScheduledatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "single"
      },
      allowColumnResizing: true,
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "NewSiteName",

        },
        { dataField: "SalesOrderNo", caption: "Work Order #" },
        { dataField: "PestCode", caption: "Pest Types" },
        { dataField: "DateTimeofTreatment", caption: "Prefered Date & Time" },
        { dataField: "EstimatedHoursRequired", caption: "Time Needed" },
        {
          caption: 'VIP ?',
          // fixed: true,
          // fixedPosition: 'right',
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            if (options.data.IsUrgent == true) {
              // $('<div><md-icon md-font-icon="icon-alert-circle" ng-if="row.IsUrgent" style="color: orangered;"></md-icon>').appendTo(container);
              $('<div />').dxButton({
                icon: 'warning'
              }).appendTo(container);
            }
          }
        },
      ],
      bindingOptions: {
        dataSource: "PendingScheduledatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };
    vm.ScheduledWorkOrderdataGrid = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.ScheduledWorkOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      selection: {
        mode: "single"
      },
      allowColumnResizing: true,
      OnCellPrepared: function (e) {
        if (e.rowType !== "data")
          return
        if (e.data.Status === "Scheduled") {
          e.rowElement.css("background-color", "red");
        }
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          }
        },
        {
          caption: "Customer Name", dataField: "CompanyName",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.CompanyName + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.CompanyName + "</p>").appendTo(container);
          },
        },
        {
          dataField: "SalesOrderNo", caption: "Work Order #",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.SalesOrderNo + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.SalesOrderNo + "</p>").appendTo(container);
          },
        },
        {
          dataField: "PestCode", caption: "Pest Types",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.PestCode + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.PestCode + "</p>").appendTo(container);
          },
        },
        {
          dataField: "SiteAddress", caption: "Site Name",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.SiteAddress + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.SiteAddress + "</p>").appendTo(container);
          },
        },
        {
          dataField: "TotalJob", caption: "Remaining Jobs",
          cellTemplate: function (container, options) {
            if (options.data.Status === "Completed")
              $("<p style='color:orange;cursor: pointer;'>" + options.data.TotalJob + "</p>").appendTo(container);
            else
              $("<p style='color:black;cursor: pointer;'>" + options.data.TotalJob + "</p>").appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "ScheduledWorkOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter",
      },
    };

    $scope.grouping = {
      autoExpandAll: false
    };
    vm.dataGridOptions = {
      // onInitialized: function (e) {
      //   dataGrid = e.component;
      // },
      dataSource: $scope.previewGridDatas,
      keyExpr: "ServiceID",
      paging: {
        enabled: true,
        pageSize: 100
      },
      editing: {
        mode: "cell",
        allowUpdating: true
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      groupPanel: {
        visible: true
      },
      columns: [
        {
          caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
          },
          allowEditing: false
        },
        { dataField: "ServiceID", caption: "Service ID", allowEditing: false },
        { dataField: "PestCode", width: "350", caption: "Pest Type", allowEditing: false },
        { dataField: "ServiceOn", caption: "Day", allowEditing: false },
        { dataField: "Startsat", caption: "Schedule Date", dataType: "date", format: 'dd/MM/yyyy', showEditorAlways: true, },
        {
          dataField: "Startsat", caption: "Start Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          dataField: "Endsat", caption: "End Time", dataType: "datetime", format: 'hh:mm a', showEditorAlways: true,
        },
        {
          caption: 'Delete',
          fixed: true,
          fixedPosition: 'right',
          width: 60,
          alignment: 'center',
          allowSorting: false,
          cellTemplate: function (container, options) {
            $('<div />').dxButton({
              icon: 'trash',
              onClick: function (e) {
                $scope.previewGridDatas.splice(options.rowIndex, 1)
              }
            }).appendTo(container);
          },
        },
      ],
      bindingOptions: {
        dataSource: "previewGridDatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "false",
        // filterRow: "filterRow",
        // headerFilter: "headerFilter",
        // grouping: "grouping"
      },
      onRowPrepared: function (e) {
        try {
          if (e.data.SameTeam == 'Yes') {
            e.rowElement.css('background', '#a8dea8');
          }
          else if (e.data.SameTeam == 'Fixed') {
            e.rowElement.css('background', '#ffa500ab');
          }
          // if (e.data.Duplicate == true) {
          //   e.rowElement.css('background', '#ffa500ab');
          // }
        }
        catch (e) { }
      },
      onRowUpdating: function (e) {

        // e.cancel=true
        try {
          $scope.vm.PreviewSchedulespinner = true
          var StartDate = null
          if (e.newData.Startsat != undefined) {
            StartDate = new Date(e.newData.Startsat)
            StartDate.setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.newData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.oldData.Endsat).getHours(), new Date(e.oldData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Startsat = new Date(e.newData.Startsat).setHours(new Date(e.newData.Startsat).getHours(), new Date(e.newData.Startsat).getMinutes() - 1, 0, 0)
          }
          if (e.newData.Endsat != undefined) {
            StartDate = new Date(e.oldData.Startsat)
            StartDate.setHours(new Date(e.oldData.Startsat).getHours(), new Date(e.oldData.Startsat).getMinutes() + 1, 0, 0)
            e.oldData.ServiceOn = $filter('date')(new Date(e.oldData.Startsat), 'EEEE');
            EndDate = new Date(e.newData.Startsat)
            EndDate.setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() - 1, 0, 0)
            e.oldData.SameTeam = getSameTeam(StartDate, EndDate)
            e.oldData.Endsat = new Date(e.newData.Endsat).setHours(new Date(e.newData.Endsat).getHours(), new Date(e.newData.Endsat).getMinutes() + 1, 0, 0)
          }

          $scope.vm.PreviewSchedulespinner = false
        }
        catch (e) { $scope.vm.PreviewSchedulespinner = false }

        //   if (e.newData.Startsat) {
        //     try {
        //       e.oldData.ServiceOn = $filter('date')(new Date(e.newData.Startsat), 'EEEE');
        //       e.oldData.SameTeam = 'No';
        //       angular.forEach($scope.Teamtabledata, function (items) {
        //         if ($filter('date')(items.Startsat, 'dd/MM/yyyy') == $filter('date')(e.newData.Startsat, 'dd/MM/yyyy')) {
        //           var edd = new Date(items.Startsat);
        //           var ehh = $scope.vm.ServiceStartTime;
        //           var startTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           var edd = new Date(items.Startsat);
        //           var ehh = $scope.vm.ServiceEndTime;
        //           var endTime = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           var edd = new Date(items.Startsat);
        //           var ehh = new Date(items.Endsat);
        //           var EndDate = new Date(edd.setHours(ehh.getHours(), ehh.getMinutes()));

        //           if (new Date(items.Startsat) <= startTime && startTime < EndDate) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (new Date(items.Startsat) < endTime && EndDate >= endTime) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (startTime <= new Date(items.Startsat) && new Date(items.Startsat) < endTime) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else if (startTime < EndDate && endTime >= EndDate) {
        //             e.oldData.SameTeam = 'Yes';
        //           }
        //           else {
        //             //SameTeam = 'No';
        //           }
        //         }
        //       });
        //     }
        //     catch (e) { }
        //   }
        //   else
        //     e.oldData.ServiceOn = $filter('date')(new Date(e.oldData.Startsat), 'EEEE');
      },
    };
    $scope.CheckNullvalue = function (val) {
      var string = '';
      if (val == null || val == undefined || val == " ") {

        return string;
      } else {

        return val;
      }
    }
    $scope.TrimleadingComma = function (val) {

      var string = val;
      if (string.substring(0, 1) == ',') {
        string = string.substring(1);
        return string;
      } else {
        return val;
      }
    }
    $scope.removeLastComma = function (str) {
      if (str != undefined) {
        return str.replace(/,(\s+)?$/, '');
      } else {
        return "";
      }
    }
    $scope.Checkrowhasvalues = function (val) {

      if (val == null || val == undefined || val == " ") {
        return false;
      }
      else if (val.length > 2) {
        return true;
      } else {
        return false;
      }
    }
    $scope.CheckNullvalueBurrows = function (val) {
      var string = 0;
      if (val == null || val == undefined || val == " ") {

        return string;
      } else {

        return val;
      }
    }
    $scope.removeLastComma = function (str) {
      if (str != undefined) {
        return str.replace(/,(\s+)?$/, '');
      } else {
        return "";
      }
    }
    $scope.ShowVerified = function (EmailSent) {
      if (EmailSent != null && EmailSent != undefined && EmailSent != "") {
        if (EmailSent == true) {
          return "Verified";
        }
        else if (EmailSent == false) {
          return "Not Verified";
        }
        else {
          return "Not Verified";
        }
      }
      else {
        return "Not Verified";
      }
    }
    $scope.ClearGrid = function () {
      $("#YTSContainer").dxDataGrid("instance").clearSelection();
      $("#OTSContainer").dxDataGrid("instance").clearSelection();
      $("#CMPContainer").dxDataGrid("instance").clearSelection();
      $("#PASRContainer").dxDataGrid("instance").clearSelection();
    }

    $scope.getScheduledWorkOrder = function () {
      $scope.vm.ScheduledWorkOrderspinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getscheduledjobs",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Glist) {
        var data = Glist.data.data
        angular.forEach(data, function (value) {
          try {
            value.SiteAddress = (value.SBuildingName == null ? "" : value.SBuildingName) + " " + value.SStreetName + " " + value.SPostal
            var pest = value.PestName.split(',')
            var PestArray = []
            PestArray = $scope.Pestdatasdatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            $scope.vm.ScheduledWorkOrderspinner = true
          }
        })
        $scope.ScheduledWorkOrderdatas = data
        $scope.vm.ScheduledWorkOrderspinner = false
      })
    }

    $scope.getOnHoldWorkOrder = function () {
      $scope.vm.OnholdPreviewSpinner = true
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getOnhold",
        data: { Client_Id: $rootScope.Client_Id },
      }).then(function (Glist) {
        var data = Glist.data.data
        angular.forEach(data, function (value) {
          try {
            value.SiteAddress = (value.SBuildingName == null ? "" : value.SBuildingName) + " " + value.SStreetName + " " + value.SPostal
            var pest = value.PestName.split(',')
            var PestArray = []
            PestArray = $scope.Pestdatasdatas.filter(function (pestt) { return (pest.includes(pestt.PestName)) })
            value.PestCode = PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',')
            try {
              value.NewSiteName = value.customerServicedetails[0].sName + " - " + value.customerdetails[0].CompanyName
            } catch (error) {
              value.NewSiteName = value.customerdetails[0].CompanyName
            }
          } catch (e) {
            $scope.vm.OnholdPreviewSpinner = true
          }
        })
        $scope.OnHolddatas = data
        $scope.vm.OnholdPreviewSpinner = false
      })
    }

    $scope.UnscheduleWorkOrder = function (id) {
      $scope.UnschedulerID = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to Unschedule all the jobs', 'Unschedule Jobs');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          var resp = $http({
            method: 'PUT',
            url: $rootScope.WebURL + "/salesOrder/unschedulejobs",
            data: { _id: $scope.UnschedulerID, UpdatedBy: $rootScope.createdby }
          });
          resp.then(function (Gli) {
            $mdToast.show($mdToast.simple().textContent('Unscheduled all jobs Successfully!').position('top center'));
            $scope.NewGetByStatus()
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      })
    }

    $scope.EditSchedulerLine = function (data) {
      $scope.vm.ScheduledWorkOrderspinner = true
      $scope.EditSO_Id = data
      $scope.PdateBox = {}
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyWO",
        data: { SlesOrderId: data },
      }).then(function (Glist) {
        var SchedulerJob = Glist.data.data
        if (SchedulerJob != null) {
          $scope.vm.PPreferredStartTime = SchedulerJob.PreferredStartTime
          $scope.vm.PPreferredEndTime = SchedulerJob.PreferredEndTime
          $scope.vm.PAvoidStartTime = SchedulerJob.AvoidStartTime
          $scope.vm.PAvoidEndTime = SchedulerJob.AvoidEndTime
          var preferday = SchedulerJob.PreferredTime.split(',')
          var item = $scope.teamdatas.filter(function (item) {
            return SchedulerJob.Team_Id.includes(item.id)
          })
          $scope.vm.TeamList = item
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/salesOrder/getById",
            data: { _id: SchedulerJob.JobsOrders },
          }).then(function (Glist) {
            console.log(Glist.data.data)
            $scope.vm.ManHour = parseFloat(Glist.data.data[0].EstimatedHoursRequired)
          })

          $scope.vm.PPreferredDays = []
          preferday.forEach(function (item) {
            var value = $filter('filter')($scope.Prefitems, item);
            $scope.vm.PPreferredDays = $scope.vm.PPreferredDays.concat(value)
          })
          $scope.PdateBox = {

            PreferredStartTime: {
              type: "time",
              value: $scope.vm.PPreferredStartTime,
              onValueChanged: function (e) {
                $scope.vm.PPreferredStartTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PPreferredStartTime'
              }
            },
            PreferredEndTime: {
              type: "time",
              value: $scope.vm.PPreferredEndTime,
              onValueChanged: function (e) {
                $scope.vm.PPreferredEndTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PPreferredEndTime'
              }
            },
            AvoidStartTime: {
              type: "time",
              value: $scope.vm.PAvoidStartTime,
              onValueChanged: function (e) {
                $scope.vm.PAvoidStartTime = e.value
                // $scope.vm.AvoidEndTime = new Date(moment(e.value).add(1, 'hours'))
              },
              bindingOptions: {
                'value': 'vm.PAvoidStartTime'
              }
            },
            AvoidEndTime: {
              type: "time",
              value: $scope.vm.PAvoidEndTime,
              onValueChanged: function (e) {
                $scope.vm.PAvoidEndTime = e.value
              },
              bindingOptions: {
                'value': 'vm.PAvoidEndTime'
              }
            },
          }
          $scope.vm.ScheduledWorkOrderspinner = false
          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/EditServiceLine.html',
            parent: angular.element($document.body),
            //targetEvent: e,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
        }
        else {
          $scope.vm.ScheduledWorkOrderspinner = false
          $mdToast.show($mdToast.simple().textContent('All jobs are completed. You cant edit Scheduler Line !').position('top center'));
        }
        $scope.vm.ScheduledWorkOrderspinner = false
      })
    }

    $scope.SubmitSchedulerLine = function () {
      var TeamName = $scope.vm.TeamList.map(function (obj) { return obj.TeamLead }).join(',')
      var TeamId = $scope.vm.TeamList.map(function (obj) { return obj.id })
      $scope.vm.PPreferredDays = _.sortBy($scope.vm.PPreferredDays, "id")
      var PreferDays = $scope.vm.PPreferredDays.map(function (obj) { return obj.names; }).join(',');
      var resp = $http({
        method: 'PUT',
        url: $rootScope.WebURL + "/scheduler/updateLine",
        data: {
          _id: $scope.EditSO_Id,
          PreferredTime: PreferDays,
          PreferredStartTime: $scope.vm.PPreferredStartTime,
          PreferredEndTime: $scope.vm.PPreferredEndTime,
          AvoidStartTime: $scope.vm.PAvoidStartTime,
          AvoidEndTime: $scope.vm.PAvoidEndTime,
          TeamName: TeamName,
          TeamId: TeamId,
          ManHour: $scope.vm.ManHour,
          UpdatedBy: $rootScope.createdby
        }
      });
      resp.then(function (Gli) {
        $mdToast.show($mdToast.simple().textContent('Scheduler Line updated Successfully!').position('top center'));
        $mdDialog.cancel()
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });

    }

    $scope.OpenCustomScheduler = function () {
      $mdDialog.cancel();
      var $popup = $window.open('customscheduler');
    }

    $scope.ShowTimetoAvoid = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/ShowPreferenceTime.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      try {
        var Fteam = $scope.Teamtabledata;
        var yet = Fteam.filter(function (yet) {
          return yet.Status === "Yet to Start";
        });
        var newArray = _.uniqBy(yet, "JobsOrders")
        newArray = _.uniqWith(_.map(newArray, _.partialRight(_.pick, ['ServiceOn', 'Startsat', 'Endsat'])), _.isEqual);
        angular.forEach(newArray, function (item) {
          var Startsat1 = new Date(item.Startsat).toTimeString()
          var Endsat1 = new Date(item.Endsat).toTimeString()
          item.StartTime = new Date(new moment(Startsat1, 'HH:mm:ss')).toTimeString();
          item.EndTime = new Date(new moment(Endsat1, 'HH:mm:ss')).toTimeString();
          item.STime = new Date(new moment(Startsat1, 'HH:mm:ss')).getTime()
          item.ETime = new Date(new moment(Endsat1, 'HH:mm:ss')).getTime()
          item.Active = false
        })
        newArray = _.uniqBy(newArray, function (elem) { return [elem.StartTime, elem.EndTime].join(); });
        newArray = _.sortBy(newArray, "StartTime")
        var array = _.groupBy(newArray, "StartTime")
        var groupedarray = []
        console.log(array)
        _.each(array, function (item) {
          if (item.length == 2) {
            var a = ""
            _.each(item, function (subitem) {
              if (a == "")
                a = subitem
              else if (subitem.ETime > a.ETime) {
                a = subitem
              }
            })
            item = a
          }
          groupedarray.push(item)
        })
        groupedarray = _.flattenDeep(groupedarray)
        console.log(groupedarray)
        _.each(groupedarray, function (item) {
          var a = item.STime, b = item.ETime;
          for (var i = 1; i < groupedarray.length; i++) {
            if (a > groupedarray[i].STime && b < groupedarray[i].ETime) {
              a = groupedarray[i].STime;
              b = groupedarray[i].ETime
              groupedarray[i].Active = true
            }

            if (b > groupedarray[i].ETime && a < groupedarray[i].STime) {
              groupedarray[i].Active = true
            }
          }
          item.STime = a
          item.ETime = b
        })
        _.each(groupedarray, function (item) {
          for (var i = 1; i < groupedarray.length; i++) {
            if (item.ETime >= groupedarray[i].STime) {
              item.ETime = groupedarray[i].ETime
              groupedarray[i].Active = true
            }
          }
        })

        var newArray = []
        _.each(groupedarray, function (item) {
          if (item.Active == false) {
            item.CheckStartTime = new Date(item.STime)
            item.CheckEndTime = new Date(item.ETime)
            newArray.push(item)
          }
        })
        $scope.TimetoAvoiddatas = newArray

        $scope.PreferedTime = []
        var StartTime = new Date(new Date().setHours(8, 30, 0, 0))
        var EndTime = new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0))
        var value = $scope.TimetoAvoiddatas
        if (value.length > 0) {
          for (var i = 0; i < value.length; i++) {
            if (value.length == i + 1 && value.length == 1) {
              if (value[i].CheckStartTime > StartTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: StartTime,
                  CheckEndTime: value[i].CheckStartTime
                })
              }
              if (value[i].CheckEndTime < EndTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: value[i].CheckEndTime,
                  CheckEndTime: EndTime
                })
              }
            }
            else if (value.length == i + 1) {
              if (value[i - 1].CheckEndTime <= value[i].CheckStartTime) {
                $scope.PreferedTime.push({
                  CheckStartTime: value[i - 1].CheckEndTime,
                  CheckEndTime: value[i].CheckStartTime
                })
                if (value[i].CheckStartTime < EndTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: value[i].CheckEndTime,
                    CheckEndTime: EndTime
                  })
                }
              }
              //   else
              //   {
              //     $scope.PreferedTime.push({
              //       CheckStartTime: value[i].CheckStartTime,
              //       CheckEndTime: EndTime
              //   })
              // }
            }
            else {
              if (i == 0) {
                if (value[i].CheckStartTime >= StartTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: StartTime,
                    CheckEndTime: value[i].CheckStartTime
                  })
                }
              }
              else {
                if (value[i - 1].CheckEndTime <= value[i].CheckStartTime) {
                  $scope.PreferedTime.push({
                    CheckStartTime: value[i - 1].CheckEndTime,
                    CheckEndTime: value[i].CheckStartTime
                  })
                }
              }
            }
          }
        }
        else {
          $scope.PreferedTime.push({
            CheckStartTime: new Date(new Date().setHours(8, 30, 0, 0)),
            CheckEndTime: new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0))
          })
        }
      }
      catch (e) { }
    }

    $scope.SchedulerCalculation = function (M) {
      $scope.vm.PreviewSpinner = true;
      $http.get($rootScope.WebURL + "/scheduler/getLength")
        .then(function (scheduler) {
          var schedulerdatasforlength = scheduler.data.data;
          // if (new Date($scope.vm.ServiceStartAt) < new Date()) {
          //   $scope.vm.ServiceStartAt = new Date();
          // }
          $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
          $scope.vm.SSEt = new Date($scope.vm.ServiceEndAt);
          var previewdata = [];
          $scope.previewdatas = [];
          angular.forEach($scope.vm.PestType, function (value) {
            try {
              var pt = $scope.Pesttypedatas.filter(function (pt) {
                return value.PestName == pt.PestName;
              })[0];
              value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
            } catch (e) { }
          })
          angular.forEach($scope.vm.PestType, function (item) {
            if (item.Frequency == "Ad-Hoc") item.ServicesRequired = 365
            else if (item.Frequency == "10 Days") item.ServicesRequired = 36
          })
          $scope.vm.PestType = _.sortBy($scope.vm.PestType, "ServicesRequired").reverse()
          var groupedFrequency = _.groupBy($scope.vm.PestType, 'Frequency');

          var groupFreq = []
          angular.forEach(groupedFrequency, function (item, key) {
            var PestTreatment = ""
            angular.forEach(item, function (item1) {
              if (item1.Others != "" && item1.Others != null && item1.Others != undefined) {
                item1.Treatment = item1.Others
              }
              if (PestTreatment != "")
                PestTreatment = PestTreatment + "||" + item1.Frequency + '~' + item1.PestName + "~" + item1.Treatment
              else
                PestTreatment = item1.Frequency + '~' + item1.PestName + "~" + item1.Treatment
            })
            groupFreq.push({
              Frequency: key,
              PestName: item.map(function (obj) { return obj.PestName; }).join(','),
              PestCode: item.map(function (obj) { return obj.PestCode; }).join(','),
              Treatment: item.map(function (obj) { return obj.Treatment; }).join(','),
              PestTreatment: PestTreatment
            })
          })

          var Assigned = $scope.vm.AssignedTo.map(function (obj) { return obj.id; }).join(',');
          Assigned = Assigned.split(',')

          var firstScheduledData = []

          angular.forEach(groupFreq, function (item) {
            if (firstScheduledData.length == 0) {
              if (item.Frequency.toLocaleLowerCase() == "ad-hoc") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt)
                ettime.setHours(23, 59, 59, 999)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 1)) {
                  var currentDate = new Date(i)
                  // if (currentDate.getDay() != 0) {
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  firstScheduledData.push({
                    id: firstScheduledData.length + 1,
                    PestType: item.PestName,
                    PestCode: item.PestCode,
                    ServiceOn: ServiceOn,
                    Startsat: new Date(currentDate),
                    Endsat: endDate,
                    Frequency: item.PestTreatment,
                    SameTeam: getSameTeam(Stdate, eendDate)
                  })
                  i = new Date(currentDate)
                  // }
                  // else {
                  //   if (currentDate.getDay() == 0)
                  //     var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                  //   var Stime = new Date($scope.vm.ServiceStartTime)
                  //   var Etime = new Date($scope.vm.ServiceEndTime)
                  //   j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  //   var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                  //   var endDate = new Date($scope.vm.SSEt)
                  //   endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  //   var Stdate = new Date(j)
                  //   Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                  //   var eendDate = new Date(j)
                  //   if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  //   eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  //   firstScheduledData.push({
                  //     id: firstScheduledData.length + 1,
                  //     PestType: item.PestName,
                  //     PestCode: item.PestCode,
                  //     ServiceOn: ServiceOn,
                  //     Startsat: new Date(j),
                  //     Endsat: endDate,
                  //     Frequency: item.PestTreatment,
                  //     SameTeam: getSameTeam(Stdate, eendDate)
                  //   })
                  //   i = new Date(j)
                  // }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }
              else if (item.Frequency === "10 Days") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt)
                ettime.setHours(23, 59, 59, 999)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 10)) {
                  var currentDate = new Date(i)
                  if (currentDate.getDay() != 0 && currentDate.getDay() != 6) {
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(currentDate)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                    var eendDate = new Date(currentDate)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                  else {
                    if (currentDate.getDay() == 0)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    else if (currentDate.getDay() == 6)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 2))
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(j)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(j),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }
              else if (item.Frequency === 'Twice a Week (104)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Alternate Twice a Week')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0

                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")",
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""

                    Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")",
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")",
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""

                    Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")",
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Weekly')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency === 'Alternate Week (52)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var fnum = 0
                var ccount = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 104
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 78
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 52
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      var Treatmet = item.Treatment.split(',')
                      var Treatmet1 = ""
                      var PestCode = ""
                      if (ccount % 2 == 0) {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                        PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      }
                      else {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                        PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      }
                      ccount++
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: Treatmet1,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  }
                  else {
                    var Treatmet = item.Treatment.split(',')
                    var Treatmet1 = ""
                    var PestCode = ""
                    if (ccount % 2 == 0) {
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                      PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                    }
                    else {
                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                      PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                    }
                    ccount++
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: Treatmet1,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                  }
                }
              }
              else if (item.Frequency.includes('Fortnightly')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 52
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 39
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 26
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 14)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate)
                    }
                  } else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate)
                  }

                }
              }
              else if (item.Frequency.includes('Twice a Month (24)')) {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                var WeekofMonth = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 48
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 36
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 24
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // if(count>0){
                  //   while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                  //   WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                  //     currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                  //   }
                  // }
                  // else{
                  //    WeekofMonth = Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7);
                  //    if(WeekofMonth==5) WeekofMonth=4
                  // }
                  // if(new Date(currentDate).getDate()>15) currentDate.setDate(j.getDate() - 7)
                  if (count > 0) {
                    //  if(WeekofMonth>=3)WeekofMonth=2
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = parseInt((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1
                    if (WeekofMonth == 1) WeekofMonth = 1
                    else if (WeekofMonth == 2) WeekofMonth = 2
                    else if (WeekofMonth == 3) {
                      WeekofMonth = 1
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)

                      var Stime = new Date($scope.vm.ServiceStartTime)
                      var Etime = new Date($scope.vm.ServiceEndTime)
                      currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                      var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                      var endDate = new Date($scope.vm.SSEt)
                      endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                      var Stdate = new Date(currentDate)
                      Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                      var eendDate = new Date(currentDate)
                      if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                      eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      currentDate = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    }
                    else if (WeekofMonth == 4) {
                      WeekofMonth = 2
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)

                      var Stime = new Date($scope.vm.ServiceStartTime)
                      var Etime = new Date($scope.vm.ServiceEndTime)
                      currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                      var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                      var endDate = new Date($scope.vm.SSEt)
                      endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                      var Stdate = new Date(currentDate)
                      Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                      var eendDate = new Date(currentDate)
                      if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                      eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      currentDate = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    }
                    else if (WeekofMonth == 5) {
                      WeekofMonth = 1
                      i = new Date(new Date(currentDate).setMonth(new Date(currentDate).getMonth() + 1, 1))
                      while ($scope.selected[0].id != new Date(i).getDay()) {
                        i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                      }
                      currentDate = new Date(i)
                    }
                  }
                  var monthcount = 0
                  var monthEnd = new Date(new Date(currentDate).getFullYear(), new Date(currentDate).getMonth() + 1, 0)
                  monthEnd.setHours(23, 59, 59, 999)
                  for (var j = new Date(currentDate); monthcount < 2 && j < monthEnd; j.setDate(j.getDate() + 14)) {
                    if (firstScheduledData.length > 0 && moment(j).diff(moment(firstScheduledData[firstScheduledData.length - 1].Startsat), 'days') == 7) { j < monthEnd; j.setDate(j.getDate() + 7) }

                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(j)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    if (fnum > 0) {
                      if (count < fnum) {
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Stdate, eendDate)
                        })
                      }
                      count++
                      monthcount++;
                    } else {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(j),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      monthcount++;
                    }

                  }
                  i = new Date(currentDate.setDate(1))
                }
              }
              else if (item.Frequency === 'Monthly (12)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var WeekofMonth = 0
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 24
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 18
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 12
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // get week of the month

                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                    // WeekofMonth = Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7);
                    // if(WeekofMonth==5) WeekofMonth=4
                  }

                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Bi-Monthly (6)") {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 12
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 9
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 6
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  // get week of the month

                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency.includes('Quarterly')) {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 8
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 6
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 4
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Half Yearly (2)") {
                var count = 0
                var WeekofMonth = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 4
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 3
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 2
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  if (count > 0) {
                    currentDate = nthWeekdayOfMonth($scope.selected[0].id, WeekofMonth, currentDate)
                    // while(WeekofMonth != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7) && 
                    // WeekofMonth+1 != Math.ceil((new Date(currentDate).getDate() + 6 - new Date(currentDate).getDay())/7)){
                    //   currentDate =  new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 7)) 
                    // }
                  }
                  else {
                    var startofthedata = new Date(new Date(currentDate).setDate(1))
                    while ($scope.selected[0].id != new Date(startofthedata).getDay()) {
                      startofthedata = new Date(new Date(startofthedata).setDate(new Date(startofthedata).getDate() + 1))
                    }
                    WeekofMonth = ((new Date(currentDate).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  }
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }
              else if (item.Frequency === "Yearly (1)") {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 2
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 1
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {
                  while ($scope.selected[0].id != new Date(i).getDay()) {
                    i = new Date(new Date(i).setDate(new Date(i).getDate() + 1))
                  }
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  var Etime = new Date($scope.vm.ServiceEndTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                  var endDate = new Date($scope.vm.SSEt)
                  endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                  var Stdate = new Date(currentDate)
                  Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 999)
                  var eendDate = new Date(currentDate)
                  if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                  if (fnum > 0) {
                    if (count < fnum) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Stdate, eendDate)
                      })
                      count++
                      i = new Date(currentDate.setDate(1))
                    }
                  }
                  else {
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    count++
                    i = new Date(currentDate.setDate(1))
                  }
                }
              }

            }
            else {
              if (item.Frequency === 'Twice a Week (104)') {
                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency === 'Alternate Twice a Week (104)') {

                var count = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++

                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]

                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.vm.Twiceday.id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++

                      Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]

                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Weekly')) {

                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency === 'Alternate Week (52)') {
                var ccount = 0
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=52){
                  var Treatmet = item.Treatment.split(',')
                  var Treatmet1 = ""

                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      var PestCode = ""
                      if (ccount % 2 == 0) {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[0]
                        PestCode = item.PestCode + "(" + Treatmet[0].trim().substr(0, 1) + ")"
                      }
                      else {
                        Treatmet1 = item.Frequency + '~' + item.PestName + '~' + Treatmet[1]
                        PestCode = item.PestCode + "(" + Treatmet[1].trim().substr(0, 1) + ")"
                      }
                      ccount++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + PestCode
                      vitem.Frequency = vitem.Frequency + "||" + Treatmet1
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Fortnightly')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                while ($scope.selected[0].id != new Date($scope.vm.SSAt).getDay()) {
                  $scope.vm.SSAt = new Date(new Date($scope.vm.SSAt).setDate(new Date($scope.vm.SSAt).getDate() + 1))
                }
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 14)) {
                  var currentDate = new Date(i)
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  // if(count<=26){
                  angular.forEach(firstScheduledData, function (vitem) {
                    if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                      // count++
                      vitem.PestType = vitem.PestType + "," + item.PestName
                      vitem.PestCode = vitem.PestCode + "," + item.PestCode
                      vitem.Frequency = vitem.Frequency + "||" + item.PestTreatment
                    }
                  })
                  // }
                }
              }
              else if (item.Frequency.includes('Twice a Month (24)')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var STDate = new Date($scope.vm.SSAt)
                var fnum = 0
                if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 24 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 23) fnum = 48
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 18 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 17) fnum = 36
                else if (moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 12 || moment($scope.vm.SSEt).diff($scope.vm.SSAt, 'months') == 11) fnum = 24
                var data = []
                var currentDate = new Date(new Date(STDate).setDate(1))
                var startofthedata = new Date(new Date(currentDate).setDate(1))
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var fiitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                fiitem = _.sortBy(fiitem, "Startsat")
                var a = 1, b = 3
                if (fiitem.length) {
                  var WeekofMonth = parseInt((new Date(fiitem[0].Startsat).getDate() - new Date(startofthedata).getDate()) / 7) + 1

                  if (WeekofMonth == 2 || WeekofMonth == 4) {
                    a = 2, b = 4
                  }
                  var fdate1 = nthWeekdayOfMonth($scope.selected[0].id, a, currentDate)
                  var item1 = fiitem.filter(function (item1) {
                    return (new Date(item1.Startsat).getDate() === new Date(fdate1).getDate())
                  })
                  var fdate2 = nthWeekdayOfMonth($scope.selected[0].id, b, currentDate)
                  var item2 = fiitem.filter(function (item2) {
                    return (new Date(item2.Startsat).getDate() === new Date(fdate2).getDate())
                  })
                  if (item1.length > 0) {
                    item1[0].PestType = item1[0].PestType + "," + item.PestName
                    item1[0].PestCode = item1[0].PestCode + "," + item.PestCode
                    item1[0].Frequency = item1[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item1)
                  } else {
                    fiitem[0].PestType = fiitem[0].PestType + "," + item.PestName
                    fiitem[0].PestCode = fiitem[0].PestCode + "," + item.PestCode
                    fiitem[0].Frequency = fiitem[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(fiitem)
                  }
                  if (item2.length > 0) {
                    if (item2[0].Startsat != fiitem[0].Startsat) {
                      item2[0].PestType = item2[0].PestType + "," + item.PestName
                      item2[0].PestCode = item2[0].PestCode + "," + item.PestCode
                      item2[0].Frequency = item2[0].Frequency + "||" + item.PestTreatment
                      data = data.concat(item2)
                    }

                  } else {
                    var stdate = new Date(moment(new Date(fiitem[0].Startsat)).add(14, 'days'))
                    if (new Date(stdate).getMonth() === new Date(fiitem[0].Startsat).getMonth()) {
                      var bitem1 = fiitem.filter(function (bitem1) {
                        return (new Date(bitem1.Startsat).getDate() === new Date(stdate).getDate())
                      })
                      if (bitem1.length > 0) {
                        bitem1[0].PestType = bitem1[0].PestType + "," + item.PestName
                        bitem1[0].PestCode = bitem1[0].PestCode + "," + item.PestCode
                        bitem1[0].Frequency = bitem1[0].Frequency + "||" + item.PestTreatment
                        data = data.concat(bitem1)
                      }
                    }
                  }
                }
                STDate = new Date(new Date(STDate).setMonth(new Date(STDate).getMonth() + 1, 1))
                for (var i = new Date(STDate); i < new Date($scope.vm.SSEt); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  var fdate1 = nthWeekdayOfMonth($scope.selected[0].id, a, currentDate)
                  var item1 = iitem.filter(function (item1) {
                    return (new Date(item1.Startsat).getDate() === new Date(fdate1).getDate())
                  })
                  var fdate2 = nthWeekdayOfMonth($scope.selected[0].id, b, currentDate)
                  var item2 = iitem.filter(function (item2) {
                    return (new Date(item2.Startsat).getDate() === new Date(fdate2).getDate())
                  })
                  if (item1.length > 0) {
                    item1[0].PestType = item1[0].PestType + "," + item.PestName
                    item1[0].PestCode = item1[0].PestCode + "," + item.PestCode
                    item1[0].Frequency = item1[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item1)
                  } else {
                    if (iitem.length > 0) {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      data = data.concat(fiitem)
                    }
                  }
                  if (item2.length > 0) {
                    item2[0].PestType = item2[0].PestType + "," + item.PestName
                    item2[0].PestCode = item2[0].PestCode + "," + item.PestCode
                    item2[0].Frequency = item2[0].Frequency + "||" + item.PestTreatment
                    data = data.concat(item2)
                  } else {
                    if (iitem.length > 0) {
                      var stdate = new Date(moment(new Date(iitem[0].Startsat)).add(14, 'days'))
                      if (new Date(stdate).getMonth() === new Date(iitem[0].Startsat).getMonth()) {
                        var bitem1 = iitem.filter(function (bitem1) {
                          return (new Date(bitem1.Startsat).getDate() === new Date(stdate).getDate())
                        })
                        if (bitem1.length > 0) {
                          bitem1[0].PestType = bitem1[0].PestType + "," + item.PestName
                          bitem1[0].PestCode = bitem1[0].PestCode + "," + item.PestCode
                          bitem1[0].Frequency = bitem1[0].Frequency + "||" + item.PestTreatment
                          data = data.concat(bitem1)
                        }
                      }
                    }
                  }
                  firstScheduledData = _.differenceBy(firstScheduledData, data, "id")
                  firstScheduledData = firstScheduledData.concat(data)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  i = new Date(currentDate.setDate(1))
                }
              }
              else if (item.Frequency === 'Monthly (12)') {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var firstDate = new Date(firstScheduledData[0].Startsat)
                var count = 0
                var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                  if (WeekofMonth == 5) {
                    var y = new Date(i).getFullYear()
                    var m = new Date(i).getMonth()
                    var w = $scope.selected[0].id
                    if (DaysinWeek(y, m, w) != 5) {
                      WeekofMonth = 4
                    }
                  }
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      count++
                    }
                    catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                  else {
                    var iitem = firstScheduledData.filter(function (iitem) {
                      return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                    })
                    if (iitem.length > 0) {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                        count++
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }
                    else {
                      if (count > 0) {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date(i)
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var sdate = new Date(j)
                        sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(sdate, eendDate)
                        })
                        count++
                      }
                      else {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date($scope.vm.SSAt)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var eendDate = new Date(j)
                        var sdate = new Date(j)
                        sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                    }
                  }

                }
              }
              else if (item.Frequency === "Bi-Monthly (6)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var firstDate = new Date(firstScheduledData[0].Startsat)
                var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                  if (WeekofMonth == 5) {
                    var y = new Date(i).getFullYear()
                    var m = new Date(i).getMonth()
                    var w = $scope.selected[0].id
                    if (DaysinWeek(y, m, w) != 5) {
                      WeekofMonth = 4
                    }
                  }
                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                      iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                      iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                    } catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                  else {
                    var iitem = firstScheduledData.filter(function (iitem) {
                      return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                    })
                    if (iitem.length > 0) {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      } catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }
                    else {
                      if (count > 0) {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date(i)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var Sdate = new Date(j)
                        Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                      else {
                        var Etime = new Date($scope.vm.ServiceEndTime)
                        var endDate = new Date($scope.vm.SSEt)
                        endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                        var j = new Date($scope.vm.SSAt)
                        while ($scope.selected[0].id != new Date(j).getDay()) {
                          j = new Date(new Date(j).setDate(new Date(j).getDate() + 1))
                        }
                        var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                        var Stime = new Date($scope.vm.ServiceStartTime)
                        j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                        var Sdate = new Date(j)
                        Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                        var eendDate = new Date(j)
                        if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                        eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                        firstScheduledData.push({
                          id: firstScheduledData.length + 1,
                          PestType: item.PestName,
                          PestCode: item.PestCode,
                          ServiceOn: ServiceOn,
                          Startsat: new Date(j),
                          Endsat: endDate,
                          Frequency: item.PestTreatment,
                          SameTeam: getSameTeam(Sdate, eendDate)
                        })
                        count++
                      }
                    }

                  }
                }
              }
              else if (item.Frequency.includes('Quarterly')) {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  }
                  catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "Half Yearly (2)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "Yearly (1)") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {

                  var currentDate = new Date(new Date(i).setDate(1))
                  var Stime = new Date($scope.vm.ServiceStartTime)
                  currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                  var stdate = new Date(currentDate)
                  stdate.setHours(0, 0, 0, 0)
                  var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                  endate.setHours(23, 59, 59, 999)
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 0)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                    iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                    iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
              }
              else if (item.Frequency === "10 Days") {
                $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
                var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
                for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 10)) {
                  var currentDate = new Date(i)
                  if (currentDate.getDay() != 0 && currentDate.getDay() != 6) {
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Sdate = new Date(currentDate)
                    Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                    var eendDate = new Date(i)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                    var iitem = []
                    iitem = firstScheduledData.filter(function (iitem) {
                      return new Date(iitem.Startsat).getTime() === new Date(currentDate).getTime()
                    })
                    if (iitem.length == 0) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(currentDate),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Sdate, eendDate)
                      })
                      i = new Date(currentDate)
                    }
                    else {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                    }

                  }
                  else {
                    if (currentDate.getDay() == 0)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    else if (currentDate.getDay() == 6)
                      var j = new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() + 1))
                    var Stime = new Date($scope.vm.ServiceStartTime)
                    var Etime = new Date($scope.vm.ServiceEndTime)
                    j.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(j), 'EEEE');
                    var Sdate = new Date(j)
                    Sdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 59, 999)
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var eendDate = new Date(j)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)

                    var iitem = []
                    iitem = firstScheduledData.filter(function (iitem) {
                      return new Date(iitem.Startsat).getTime() === new Date(j).getTime()
                    })
                    if (iitem.length == 0) {
                      firstScheduledData.push({
                        id: firstScheduledData.length + 1,
                        PestType: item.PestName,
                        PestCode: item.PestCode,
                        ServiceOn: ServiceOn,
                        Startsat: new Date(j),
                        Endsat: endDate,
                        Frequency: item.PestTreatment,
                        SameTeam: getSameTeam(Sdate, eendDate)
                      })
                      i = new Date(currentDate)
                    }
                    else {
                      iitem = _.sortBy(iitem, "Startsat")
                      if (iitem.length > 1)
                        iitem = iitem.slice(0, 1)
                      firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                      try {
                        iitem[0].PestType = iitem[0].PestType + "," + item.PestName
                        iitem[0].PestCode = iitem[0].PestCode + "," + item.PestCode
                        iitem[0].Frequency = iitem[0].Frequency + "||" + item.PestTreatment
                      }
                      catch (e) { }
                      firstScheduledData = firstScheduledData.concat(iitem)
                      firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                      i = new Date(currentDate)
                    }
                  }
                }
                firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
              }

            }
          })
          firstScheduledData = _.sortBy(firstScheduledData, "Startsat")

          try {
            if ($scope.vm.BillingFrequency == "COD") {
              var count = 0
              angular.forEach(firstScheduledData, function (item) {
                count++;
                item.XeroInvoice = true
                item.XeroCount = count
              })
            }
            else if ($scope.vm.BillingFrequency == "Weekly") {
              var count = 0
              var SSAt = new Date(firstScheduledData[0].Startsat);

              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date(SSAt); i < new Date(ettime); i.setDate(i.getDate() + 7)) {
                var currentDate = new Date(i)
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                // if(count<=52){
                angular.forEach(firstScheduledData, function (vitem) {
                  if (new Date(vitem.Startsat).getTime() === new Date(currentDate).getTime()) {
                    count++
                    vitem.XeroInvoice = true
                    vitem.XeroCount = count
                  }
                })
                // }
              }
            }
            else if ($scope.vm.BillingFrequency == "Monthly") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var firstDate = new Date(firstScheduledData[0].Startsat)
              var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 1))) {
                if (WeekofMonth == 5) {
                  var y = new Date(i).getFullYear()
                  var m = new Date(i).getMonth()
                  var w = $scope.selected[0].id
                  if (DaysinWeek(y, m, w) != 5) {
                    WeekofMonth = 4
                  }
                }
                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                })
                if (iitem.length > 0) {
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    count++
                    iitem[0].XeroInvoice = true
                    iitem[0].XeroCount = count

                  }
                  catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
                else {
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      count++
                      iitem[0].XeroInvoice = true
                      iitem[0].XeroCount = count
                    }
                    catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }

                }

              }

            }
            else if ($scope.vm.BillingFrequency === "Bi-Monthly (6)") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var firstDate = new Date(firstScheduledData[0].Startsat)
              var WeekofMonth = Math.ceil((new Date(firstDate).getDate() + 6 - new Date(firstDate).getDay()) / 7);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 2))) {
                if (WeekofMonth == 5) {
                  var y = new Date(i).getFullYear()
                  var m = new Date(i).getMonth()
                  var w = $scope.selected[0].id
                  if (DaysinWeek(y, m, w) != 5) {
                    WeekofMonth = 4
                  }
                }
                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay() && Math.ceil((new Date(iitem.Startsat).getDate() + 6 - new Date(iitem.Startsat).getDay()) / 7) === WeekofMonth)
                })
                if (iitem.length > 0) {
                  iitem = _.sortBy(iitem, "Startsat")
                  if (iitem.length > 1)
                    iitem = iitem.slice(0, 1)
                  firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                  try {
                    count++
                    iitem[0].XeroInvoice = true
                    iitem[0].XeroCount = count
                  } catch (e) { }
                  firstScheduledData = firstScheduledData.concat(iitem)
                  firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                }
                else {
                  var iitem = firstScheduledData.filter(function (iitem) {
                    return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                  })
                  if (iitem.length > 0) {
                    iitem = _.sortBy(iitem, "Startsat")
                    if (iitem.length > 1)
                      iitem = iitem.slice(0, 1)
                    firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                    try {
                      count++
                      iitem[0].XeroInvoice = true
                      iitem[0].XeroCount = count
                    } catch (e) { }
                    firstScheduledData = firstScheduledData.concat(iitem)
                    firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
                  }
                }
              }
            } else if ($scope.vm.BillingFrequency === "Quarterly") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 3))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 1)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count++
                }
                catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
            else if ($scope.vm.BillingFrequency === "Half Yearly (2)") {
              var count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 6))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 1)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count
                } catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
            else if ($scope.vm.BillingFrequency === "Yearly") {
              var Count = 0
              $scope.vm.SSAt = new Date($scope.vm.ServiceStartAt);
              var ettime = new Date($scope.vm.SSEt).setDate(new Date($scope.vm.SSEt).getDate() + 1)
              for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i = new Date(i.setMonth(i.getMonth() + 12))) {

                var currentDate = new Date(new Date(i).setDate(1))
                var Stime = new Date($scope.vm.ServiceStartTime)
                currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                var stdate = new Date(currentDate)
                stdate.setHours(0, 0, 0, 0)
                var endate = new Date(new Date(stdate).getFullYear(), new Date(stdate).getMonth() + 1, 0)
                endate.setHours(23, 59, 59, 999)
                var iitem = firstScheduledData.filter(function (iitem) {
                  return (new Date(iitem.Startsat) > new Date(stdate) && new Date(endate) >= new Date(iitem.Startsat) && $scope.selected[0].id == new Date(iitem.Startsat).getDay())
                })
                iitem = _.sortBy(iitem, "Startsat")
                if (iitem.length > 0)
                  iitem = iitem.slice(0, 1)
                firstScheduledData = _.differenceBy(firstScheduledData, iitem, "id")
                try {
                  count++
                  iitem[0].XeroInvoice = true
                  iitem[0].XeroCount = Count
                } catch (e) { }
                firstScheduledData = firstScheduledData.concat(iitem)
                firstScheduledData = _.sortBy(firstScheduledData, "Startsat")
              }
            }
          } catch (error) {

          }


          previewdata = firstScheduledData
          if ($scope.Holidays.value == true) {
            angular.forEach(previewdata, function (value, key) {
              var HollydayDate = new Date(value.Startsat).setHours(0, 0, 0, 0);
              if ($scope.vm.SFOPH == "Next Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  var Startsat = new Date(new Date(value.Startsat).setDate(new Date(value.Startsat).getDate() + 1));
                  var item = []
                  item = previewdata.filter(function (item) {
                    return new Date(item.Startsat).getTime() == new Date(Startsat).getTime()
                  })
                  if (item.length > 0) {
                    value.Startsat = new Date(new Date(Startsat).setDate(new Date(Startsat).getDate() + 1));
                  }
                  else {
                    value.Startsat = new Date(Startsat)
                  }
                  var Sdate = new Date(value.Startsat)
                  Sdate.setHours(Sdate.getHours(), Sdate.getMinutes() + 1, 59, 999)
                  var eendDate = new Date(Sdate)
                  if (new Date(value.Endsat) == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(value.Endsat.getHours(), value.Endsat.getMinutes() - 1, 0, 0)
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Previous Day") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  var Startsat = new Date(new Date(value.Startsat).setDate(new Date(value.Startsat).getDate() - 1));
                  var item = []
                  item = previewdata.filter(function (item) {
                    return new Date(item.Startsat).getTime() == new Date(Startsat).getTime()
                  })
                  if (item.length > 0) {
                    value.Startsat = new Date(new Date(Startsat).setDate(new Date(Startsat).getDate() - 1));
                  }
                  else {
                    value.Startsat = new Date(Startsat)
                  }
                  var Sdate = new Date(value.Startsat)
                  Sdate.setHours(Sdate.getHours(), Sdate.getMinutes() + 1, 59, 999)
                  var eendDate = new Date(Sdate)
                  if (new Date(value.Endsat) == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                  eendDate.setHours(value.Endsat.getHours(), value.Endsat.getMinutes() - 1, 0, 0)
                  value.SameTeam = getSameTeam(Sdate, eendDate)
                  value.ServiceOn = $filter('date')(value.Startsat, 'EEEE');
                }
              }
              if ($scope.vm.SFOPH == "Skip") {
                if ($scope.HolidaySelectedon.indexOf(HollydayDate) > -1) {
                  previewdata.splice(key, 1)
                }
              }
            })
          }
          previewdata = _.uniqBy(previewdata, function (o) { return new Date(o.Startsat).getTime() })
          try {
            //previewdata = _.uniqWith(previewdata, _32.isEqual);
            var item = previewdata.filter(function (item) {
              return new Date(item.Startsat).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0);
            });
            //  var item = previewdata
            var ASchearray = [];
            var PreferDays = ""
            if ($scope.vm.PreferredDays != undefined && $scope.vm.PreferredDays != "" && $scope.vm.PreferredDays != null) {
              $scope.vm.PreferredDays = _.sortBy($scope.vm.PreferredDays, "id")
              PreferDays = $scope.vm.PreferredDays.map(function (obj) { return obj.names; }).join(',');
            }

            else
              PreferDays = ""
            var sd = 0;
            // angular.forEach($scope.vm.PestType, function (Freq) {
            //   var key = 0;
            //   angular.forEach(item, function (value, index) {
            //     if (value.Frequency == Freq.Frequency) {
            //       key++;
            //       if (Freq.ServicesRequired > 0 && key > (Freq.ServicesRequired * $scope.selected.length)) {
            //         item.splice(index, 1);
            //       }
            //     }
            //   })
            // });
            angular.forEach($scope.ServiceAddressarray, function (value) {
              angular.forEach(item, function (subvalue, key) {
                var sz = 'SVC-' + ('000000' + (1 + sd + schedulerdatasforlength)).slice(-6);
                var isSameDate = false;
                angular.forEach(ASchearray, function (ditem) {
                  if ($filter('date')(ditem.Startsat, 'dd/MM/yyyy') == $filter('date')(subvalue.Startsat, 'dd/MM/yyyy')
                    && ditem.Frequency != subvalue.Frequency) {
                    try {
                      // var array = (ditem.PestType + ',' + subvalue.PestType).split(',');
                      // var filteredArray = array.filter(function (item, pos) {
                      //   return array.indexOf(item) == pos;
                      // }); 
                      ditem.PestType = ditem.PestType + ',' + subvalue.PestType;
                      ditem.PestCode = ditem.PestCode + ',' + subvalue.PestCode;
                      // ditem.PestType = filteredArray.map(function (obj) { return obj; }).join(',');
                    } catch (e) { }
                    isSameDate = true;
                  }
                })
                if (isSameDate == false) {
                  ASchearray.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: Assigned,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    XeroInvoice: subvalue.XeroInvoice == true ? true : false,
                    JobContinues: 'No',
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    BillingAmount: $scope.vm.BillingAmount,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    AccountsNotes: $scope.vm.Notes,
                    Message: $scope.vm.Message,
                    TeamName: $scope.vm.ppTeamName,
                    TeamMembersName: $scope.vm.TM,
                    PreferredTime: PreferDays,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  $scope.previewdatas.push({
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.CustomerID,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: subvalue.Frequency,
                    ServiceOn: subvalue.ServiceOn,
                    Status: "Yet to Start",
                    Types: $scope.vm.Types,
                    Startsat: subvalue.Startsat,
                    Endsat: subvalue.Endsat,
                    PestType: subvalue.PestType,
                    PestCode: subvalue.PestCode,
                    JobContinues: 'No',
                    XeroInvoice: subvalue.XeroInvoice == true ? true : false,
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: sz,
                    Location: value.getLocation,
                    ContactNumber: value.sMobile,
                    ContactPerson: value.sContactPerson,
                    CustomerService_Id: value._id,
                    SameTeam: subvalue.SameTeam,
                    ScheduleType: $scope.vm.ScheduleType,
                    JobType: $scope.vm.JobType,
                    Duplicate: false,
                    LatLong: value.LatLong,
                    SpecialRemark: "",
                    AccountsNotes: $scope.vm.Notes,
                    Message: $scope.vm.Message,
                    PreferredTime: $scope.vm.PreferredTime,
                    PreferredStartTime: $scope.vm.PreferredStartTime,
                    AvoidStartTime: $scope.vm.AvoidStartTime,
                    AvoidEndTime: $scope.vm.AvoidEndTime,
                    PreferredEndTime: $scope.vm.PreferredEndTime,
                    Client_Id: $rootScope.Client_Id,
                    CreatedBy: $rootScope.createdby
                  })
                  console.log(sd)
                  sd++;
                }
              })
            })
          } catch (e) { }
          $scope.previewGridDatas = ASchearray;
          $scope.AllPreviewGridDatas = ASchearray;
          $mdDialog.show({
            multiple: true,
            templateUrl: 'app/main/apps/operations/scheduler/Previewschedule.html',
            parent: angular.element($document.body),
            targetEvent: M,
            scope: $scope.$new(),
            controller: function operationsProjectController($scope, $mdDialog) {
              $scope.closeDialog = function () {
                $mdDialog.hide();
              }
            }
          });
          try {
            var dupitem = [];
            dupitem = ASchearray.filter(function (dupitem) {
              return dupitem.Duplicate === true;
            });
            $scope.vm.DuplicateCount = dupitem.length;
          } catch (e) { }
          $scope.vm.ServiceID = null;
          $scope.pesttypeGrid = true;
          $scope.shedulerform = true;
          $scope.addbtn = true;
          $scope.viewbtn = false;
          $scope.exportbtn = true;
          $scope.thdata = false;
          $scope.vm.PreviewSpinner = false;
          $scope.vm.ShowDuplicate = false;
          $scope.vm.RemoveDuplicate = false;
        });


    }

    function DaysinWeek(year, month, week) {

      var day, counter, date;

      day = 1;
      counter = 0;
      date = new Date(year, month, day);
      while (date.getMonth() === month) {
        if (date.getDay() === week) { // Sun=0, Mon=1, Tue=2, etc.
          counter += 1;
        }
        day += 1;
        date = new Date(year, month, day);
      }
      return counter;
    }

    $scope.addadhoc = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/CustomAdd.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ABEMail = []
      $scope.vm.ASEmail = []
      $scope.vm.ACompanyName = ""
      $scope.vm.AContactName = ""
      $scope.vm.ATotalPrice = 0
      $scope.vm.APaymentMode = ""
      $scope.vm.ABillingFrequency = ""
      $scope.vm.AAssignedTo = ""
      $scope.vm.ASalesperson = ""
      $scope.vm.AManHour = 0
      $scope.vm.ARemarks = ""
      $scope.treeBoxValue = []
      $scope.AStartTime = new Date()
      $scope.AEndTime = new Date()
      $scope.vm.ABillingAddress = ""
      $scope.vm.ABPostal = null
      $scope.vm.AServicesAddress = ""
      $scope.vm.ASPostal = null

    }


    var treeView;

    var syncTreeViewSelection = function (treeView) {
      if (!treeView) return;

      if (!$scope.treeBoxValue) {
        treeView.unselectAll();
        return;
      }

      $scope.treeBoxValue.forEach(function (key) {
        treeView.selectItem(key);

      });

    };

    $scope.treeBoxValue = [];
    $scope.ApestType = [];

    $scope.treeBoxOptions = {
      bindingOptions: {
        value: 'treeBoxValue',
        dataSource: "PestTreatmentMethod",
        'treeView.dataSource': "PestTreatmentMethod"
      },
      valueExpr: "ID",
      displayExpr: "name",
      placeholder: "Select a value...",
      showClearButton: true,
      grouped: true,
      dataSource: $scope.PestTreatmentMethod,
      onValueChanged: function () {
        syncTreeViewSelection(treeView);
      },
      treeView: {
        dataSource: $scope.PestTreatmentMethod,
        dataStructure: "plain",
        keyExpr: "ID",
        parentIdExpr: "categoryId",
        displayExpr: "name",
        selectByClick: true,
        selectNodesRecursive: false,
        showCheckBoxesMode: "normal",
        // searchEnabled: true,
        grouped: true,
        bindingOptions: {
          selectionMode: "selectionMode"
        },
        onContentReady: function (e) {
          treeView = e.component;

          syncTreeViewSelection(treeView);
        },
        onItemSelectionChanged: function (args) {
          $scope.treeBoxValue = args.component.getSelectedNodesKeys()
          // var selected = args.node.itemData
          // if(!selected.ID.includes('~')){
          //   if(selected.selected){
          //     var child = args.node.children
          //     var childelem = []
          //     child.forEach(function(item){
          //       childelem.push(item.key)
          //     })
          //     childelem = childelem.concat($scope.treeBoxValue)
          //     $scope.treeBoxValue = [selected.name].concat(childelem)
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          //   else{
          //     var child = args.node.children
          //     var childelem = []
          //     child.forEach(function(item){
          //       childelem.push(item.key)
          //     })
          //     var removeitem = [selected.name].concat(childelem)
          //     $scope.treeBoxValue =  _.differenceWith(removeitem, $scope.treeBoxValue, _.isEqual);
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //     removeitem.forEach(function(item){
          //       treeView.unselectItem(item)
          //     })
          //   }
          // }
          // else{
          //   if(selected.selected){
          //     $scope.treeBoxValue = [selected.name].concat($scope.treeBoxValue)
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          //   else{

          //     var removeitem = [selected.name]
          //     $scope.treeBoxValue =  _.differenceWith(removeitem, $scope.treeBoxValue, _.isEqual);
          //     $scope.treeBoxValue = _.uniqWith($scope.treeBoxValue, _.isEqual)
          //   }
          // }

        }
      },

    };

    $scope.CheckForFrequency = function (pesttType) {
      var item = pesttType.filter(function (item) {
        return item.Frequency.includes('Twice a Week')
      })
      if (item.length > 0) {
        $scope.vm.Twiceday = null;
        $scope.selected = []
      }
      else {
        if ($scope.vm.Twiceday != null) $scope.vm.Twiceday = null
      }
    }

    function getSameTeam(a, b) {
      var item = []
      item = $scope.Teamtabledata.filter(function (item) {
        //  a = new Date(a)
        //  a.setHours(new Date(a).getHours(),new Date(a).getMinutes()+1,new Date(a).getSeconds(),new Date(a).getMilliseconds())
        if (new Date(a).getHours() == 0) {
          a = new Date(new Date(a).setDate(new Date(a).getDate() + 1))
          a.setHours(new Date(a).getHours(), new Date(a).getMinutes(), 0, 0)
          a = new Date(a).getTime()
        }
        if (new Date(b).getHours() == 0) {
          b = new Date(new Date(b).setDate(new Date(b).getDate() + 1))
          b.setHours(new Date(b).getHours(), new Date(b).getMinutes(), 0, 0)
          b = new Date(b).getTime()
        }

        //  b = new Date(b)
        //  b.setHours(new Date(b).getHours(),new Date(b).getMinutes()-1,new Date(b).getSeconds(),new Date(b).getMilliseconds())
        b = new Date(b).getTime()

        var x = new Date(item.Startsat).getTime()
        var y = new Date(item.Startsat)
        y.setHours(new Date(item.Endsat).getHours(), new Date(item.Endsat).getMinutes(), new Date(item.Endsat).getSeconds(), new Date(item.Endsat).getMilliseconds())
        y = y.getTime()
        return (Math.min(x, y) <= Math.max(a, b) && Math.max(x, y) >= Math.min(a, b) && item.Status == "Yet to Start" && item.VerifiedBy == true && item.IsActive == true)
      })
      if (item.length == 0) return "No";
      else {
        var iitem = item.filter(function (iitem) {
          return iitem.JobType === "Fixed"
        })
        if (iitem.length == 0) return "Yes"
        else return "Fixed"
      }

    }
    var ALatLong = "103.8677,1.3554";
    $scope.sCustomScheduler = function (M) {
      $scope.vm.PreviewSpinner = true;
      var TeamId = $scope.vm.AAssignedTo
      $scope.vm.EstimationHr = $scope.vm.AManHour
      $scope.vm.ServiceStartTime = $scope.vm.AStartTime
      if (TeamId != undefined) {
        var TeamID = TeamId.map(function (obj) { return obj.id; }).join(',');
        $scope.vm.TM = _.uniq(TeamId.map(function (obj) { return obj.TeamMembers; }).join(',').split(','))
        $scope.vm.ppTeamName = TeamId.map(function (obj) { return obj.TeamName; }).join(',');
        $scope.vm.TeamEstimationHr = ($scope.vm.EstimationHr / TeamId.length) % 1 == 0 ? $scope.vm.EstimationHr / TeamId.length : ($scope.vm.EstimationHr / TeamId.length).toFixed(2)
        $scope.vm.ServiceEndTime = new Date(moment($scope.vm.ServiceStartTime).add($scope.vm.TeamEstimationHr, 'hours'))
      }
      else {
        var TeamID = []
        $scope.vm.TM = null
        $scope.vm.ppTeamName = null
      }
      try {
        var response = $http({
          url: $rootScope.WebURL + "/scheduler/getTeamforDate",
          method: "POST",
          data: {
            Start_Date: $scope.vm.ServiceStartAt, End_Date: $scope.vm.ServiceEndAt,
            Client_Id: $rootScope.Client_Id, Team_Id: TeamID
          },
        });
        response.then(function (GList) {
          var Fteam = GList.data.data;
          $scope.Teamtabledata = Fteam;

          $http.get($rootScope.WebURL + "/scheduler/getLength")
            .then(function (scheduler) {
              var schedulerdatasforlength = scheduler.data.data;
              var sd = 1
              var sz = 'SVC-' + ('000000' + (sd + schedulerdatasforlength)).slice(-6);

              var firstScheduledData = []
              $scope.ApestType = []
              var arr = treeView._getOptionValue().dataSource.filter(function (o) { return o.selected === true })
              arr.forEach(function (item) {
                if (item.ID.includes('~')) {
                  $scope.ApestType.push({
                    Frequency: 'Ad-Hoc',
                    PestType: item.ID.split('~')[1],
                    Treatment: item.ID.split('~')[0]
                  })
                }
              })
              angular.forEach($scope.ApestType, function (value) {
                try {
                  var pt = $scope.Pesttypedatas.filter(function (pt) {
                    return value.PestType == pt.PestName;
                  })[0];
                  value.PestCode = pt.Pestcode; // + ' (' + value.ServicesRequired + ')';
                } catch (e) { }
              })
              $scope.vm.APest = $scope.ApestType.map(function (o) { return o.PestType }).join(',')
              var groupedFrequency = _.groupBy($scope.ApestType, 'PestType');

              var groupFreq = []
              angular.forEach(groupedFrequency, function (item) {
                var PestTreatment = ""
                angular.forEach(item, function (item1) {

                  if (PestTreatment != "")
                    PestTreatment = PestTreatment + "||Ad-Hoc~" + item1.PestType + "~" + item1.Treatment
                  else
                    PestTreatment = "Ad-Hoc" + '~' + item1.PestType + "~" + item1.Treatment
                })
                groupFreq.push({
                  Frequency: "Ad-Hoc",
                  PestName: item.map(function (obj) { return obj.PestType; }).join(','),
                  PestCode: item.map(function (obj) { return obj.PestCode; }).join(','),
                  Treatment: item.map(function (obj) { return obj.Treatment; }).join(','),
                  PestTreatment: PestTreatment
                })
              })
              angular.forEach(groupFreq, function (item) {
                if (item.Frequency.toLocaleLowerCase() == "ad-hoc") {
                  var sz = 'SVC-' + ('000000' + (sd + schedulerdatasforlength)).slice(-6);
                  $scope.vm.SSAt = new Date($scope.vm.AStartTime);
                  $scope.vm.SSEt = new Date($scope.vm.AEndTime);
                  var ettime = new Date($scope.vm.AEndTime)
                  ettime.setHours(23, 59, 59, 999)
                  for (var i = new Date($scope.vm.SSAt); i < new Date(ettime); i.setDate(i.getDate() + 1)) {
                    var currentDate = new Date(i)
                    // if (currentDate.getDay() != 0) {
                    var Stime = new Date($scope.vm.AStartTime)
                    var Etime = new Date($scope.vm.AEndTime)
                    currentDate.setHours(Stime.getHours(), Stime.getMinutes(), 0, 0)
                    var ServiceOn = $filter('date')(new Date(currentDate), 'EEEE');
                    var endDate = new Date($scope.vm.SSEt)
                    endDate.setHours(Etime.getHours(), Etime.getMinutes(), 0, 0)
                    var Stdate = new Date(currentDate)
                    Stdate.setHours(Stime.getHours(), Stime.getMinutes() + 1, 0, 0)
                    var eendDate = new Date(currentDate)
                    if (Etime.getHours() == 0) eendDate = new Date(new Date(eendDate).setDate(new Date(eendDate).getDate() + 1))
                    eendDate.setHours(Etime.getHours(), Etime.getMinutes() - 1, 0, 0)
                    firstScheduledData.push({
                      id: firstScheduledData.length + 1,
                      ServiceID: sz,
                      PestType: item.PestName,
                      PestCode: item.PestCode,
                      ServiceOn: ServiceOn,
                      Startsat: new Date(currentDate),
                      Endsat: endDate,
                      Frequency: item.PestTreatment,
                      SameTeam: getSameTeam(Stdate, eendDate)
                    })
                    i = new Date(currentDate)
                    sd++
                  }
                  firstScheduledData = _.uniqBy(firstScheduledData, function (o) { return new Date(o.Startsat).getTime() })
                }
              })
              var address = $scope.vm.AServicesAddress;

              var geocoder = new google.maps.Geocoder();
              if (geocoder) {
                geocoder.geocode({
                  'address': address
                }, function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    ALatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                  }
                });
              }
              $scope.previewdatas = firstScheduledData
              $scope.previewGridDatas = $scope.previewdatas
              $scope.vm.PreviewSpinner = false;
              $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/operations/scheduler/CustomPreview.html',
                parent: angular.element($document.body),
                targetEvent: M,
                scope: $scope.$new(),
                controller: function operationsProjectController($scope, $mdDialog) {
                  $scope.closeDialog = function () {
                    $mdDialog.hide();
                  }
                }
              });

            })
        });
      }
      catch (e) {
        console.log(e)
      }
    }

    $scope.customPreviewsubmit = function () {
      $scope.vm.PreviewSpinner = true;
      var teaam = $scope.vm.AAssignedTo.map(function (obj) { return obj.id })
      var TeamName = $scope.vm.AAssignedTo.map(function (obj) { return obj.TeamName })
      if ($scope.vm.ABEMail != null && $scope.vm.ABEMail != "" && $scope.vm.ABEMail != undefined) $scope.vm.ABEMail = $scope.vm.ABEMail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.ASEmail != null && $scope.vm.ASEmail != "" && $scope.vm.ASEmail != undefined) $scope.vm.ASEmail = $scope.vm.ASEmail.map(function (obj) { return obj; }).join(',');
      if ($scope.vm.ASEmail.length == 0) $scope.vm.ASEmail = ""
      if ($scope.vm.ABEMail.length == 0) $scope.vm.ABEMail = ""
      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/scheduler/createadhoc',
        data: {
          CustomerName: $scope.vm.ACompanyName,
          ContactName: $scope.vm.AContactName,
          TotalPrice: $scope.vm.ATotalPrice,
          PaymentMode: $scope.vm.APaymentMode,
          BillingFrequency: $scope.vm.ABillingFrequency,
          TeamId: teaam,
          TeamName: TeamName,
          Manhour: $scope.vm.AManHour,
          Remarks: $scope.vm.ARemarks,
          SalesPerson: $scope.vm.ASalesperson,
          Pest: $scope.vm.APest,
          StartTime: $scope.vm.AStartTime,
          EndTime: $scope.vm.AEndTime,
          BAddress: $scope.vm.ABillingAddress,
          BPostal: $scope.vm.ABPostal,
          BEmail: $scope.vm.ABEMail,
          SAddress: $scope.vm.AServicesAddress,
          SEmail: $scope.vm.ASEmail,
          SPostal: $scope.vm.ASPostal,
          MultiFrequency: $scope.ApestType,
          Client_Id: $rootScope.Client_Id,
          CreatedBy: $rootScope.createdby,
          SchedulerArray: $scope.previewGridDatas,
          LatLong: ALatLong,
          SameTeam: getSameTeam(Stdate, eendDate)
        }
      }).then(function (List) {
        $mdDialog.cancel()
        $mdDialog.cancel()
        $scope.vm.PreviewSpinner = false;
        $scope.vm.ServiceID = null;
        $scope.previewdatas = [];
        RefreshGrid();
        $scope.getPendingSchedule()
        $scope.pesttypeGrid = true;
        $scope.shedulerform = true;
        $scope.addbtn = true;
        $scope.viewbtn = false;
        $scope.exportbtn = true;
        $scope.thdata = false;
        $scope.AllSASelec = { value: false };
        $scope.SASelec = { value: false };
        $scope.svAll = { value: false };
        $scope.ServiceAddressarray = [];
        $mdToast.show($mdToast.simple().textContent('Custom Schedule for ' + $scope.vm.ACompanyName + ' is created successfully!').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      })
    }

    function clonejob(e, data) {
      $scope.vm.Title = 'Clone the Job'
      $scope.Cloneschedule = data
      $scope.vm.RescheduleSpinner = false
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/operations/scheduler/Selectedschedule.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),

        controller: function operationsProjectController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
      $scope.vm.ResheduleSSTime = data.Startsat
      $scope.vm.ResheduleSETime = data.Endsat
      $scope.vm.AssignedTo = data.Team_Id
      $scope.vm.ResheduleSRemarks = data.SpecialRemarks
      $scope.Pestdatas = data.JobOrdersdetails[0].MultiFrequency
    }

    $scope.SubmitClone = function () {
      var value = $scope.Cloneschedule
      var data = ""
      $scope.vm.CPestType.forEach(function (item) {
        if (data == "")
          data = item.Frequency + "~" + item.PestType + "~" + item.Treatment
        else
          data = data + "||" + item.Frequency + "~" + item.PestType + "~" + item.Treatment
      })
      var ServiceOn = $filter('date')(new Date($scope.vm.ResheduleSFrom), 'EEEE');
      var currentDate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSSTime))
      var enddate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSETime))

      var serviceArray = [{
        JobsOrders: (value.JobsOrders),
        AssignedTo: ($scope.vm.CAssignedTo[0].id),
        Frequency: data,
        ServiceOn: ServiceOn,
        Types: value.Types,
        Status: "Yet to Start",
        Customer: (value.Customer),
        Startsat: currentDate,
        Endsat: enddate,
        CreatedBy: $rootScope.createdBy,
        PestType: $scope.vm.CPestType.map(function (o) { return o.PestType }).join(','),
        ContractOrder: value.ContractOrder,
        JobType: value.JobType,
        ServiceReportNo: value.ServiceReportNo,
        BillingAmount: value.BillingAmount,
        Billable: value.Billable,
        JobContinues: value.JobContinues,
        CollectPayment: value.CollectPayment,
        Location: value.Location,
        LatLong: value.LatLong,
        Client_Id: $rootScope.Client_Id,
        CustomerService_Id: (value.CustomerService_Id),
        ContactPerson: value.ContactPerson,
        ContactNumber: value.ContactNumber,
        Vehicle: value.Vehicle,
        ScheduleType: value.ScheduleType,
        SpecialRemark: $scope.vm.ResheduleSRemarks,
        PreferredTime: value.PreferredTime,
        PreferredStartTime: value.PreferredStartTime,
        PreferredEndTime: value.PreferredEndTime,
        AvoidStartTime: value.AvoidStartTime,
        AvoidEndTime: value.AvoidEndTime,
        Team_Id: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
        TeamName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamName }).join(','),
        TeamMembersName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamMembers }).join(','),

      }]
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/add",
        data: {
          ServiceArray: serviceArray
        }
      }).then(function (List) {
        $mdDialog.cancel()
        $mdToast.show($mdToast.simple().textContent('Successfully Added Service Jobs').position('top center'));
        RefreshGrid();
      })
    }



    $scope.NewGetByStatus = function () {
      if ($scope.vm.SelectedTab == 'PendingSchedule') {
        $scope.getPendingSchedule()
      }
      else if ($scope.vm.SelectedTab == 'Yet to Start') {
        NewGetScheduler("Yet to Start")
      }
      else if ($scope.vm.SelectedTab == "In-Progress") {
        $scope.getAllInProgress();
      }
      else if ($scope.vm.SelectedTab == 'Outstanding') {
        $scope.getOutsatnding();
      }
      else if ($scope.vm.SelectedTab == 'Completed') {
        NewGetScheduler("Completed")
      }
      else if ($scope.vm.SelectedTab == 'Pending Approval') {
        NewGetScheduler("Pending Approval")
      }
      else if ($scope.vm.SelectedTab == 'ScheduledWorkOrder') {
        $scope.getScheduledWorkOrder()
      }
      else if ($scope.vm.SelectedTab == 'Cancelled') {
        $scope.getCancelled()
      }
      else if ($scope.vm.SelectedTab == 'On-Hold') {
        $scope.getOnHoldWorkOrder()
      }
    }

    function NewGetScheduler(status) {

      if (status == "Pending Approval") {
        $scope.vm.YTSPreviewSpinner = true
        $scope.PendingApprovaldatas = []
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/lengthbystatus",
          data: {
            Client_Id: $rootScope.Client_Id, Status: "Completed", StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
          }
        }).then(function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
          var Skip = 0
          var Limit = 300
          if (ContractLength == 0) $scope.vm.YTSPreviewSpinner = false
          for (var i = 0; i < ContractLength; i++) {
            if (i == 0) Skip = 0
            else Skip += 300
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/scheduler/get",
              data: {
                StartDate: $scope.uFrom,
                EndDate: $scope.uTo,
                Client_Id: $rootScope.Client_Id,
                Skip: Skip,
                Limit: Limit,
                Status: "Completed",
                Team_Id: $scope.vm.filterteam,
                Customer: $scope.SelectedCustomerID,
                SalesOrder: $scope.Salesorderselected
              }
            }).then(function (GList) {
              var item = GList.data.data.filter(function (item) {
                return item.ServiceReportStatus == "Pending";
              })
              $scope.PendingApprovaldatas = $scope.PendingApprovaldatas.concat(item)
              $scope.PendingApprovaldatas = _.uniqWith($scope.PendingApprovaldatas, _.isEqual)
              $scope.vm.YTSPreviewSpinner = false
            })
          }
        })

      }
      else {
        $scope.vm.YTSPreviewSpinner = true
        $scope.vm.CancelledPreviewSpinner = true
        $scope.YettoStartdatas = []
        $scope.Completeddatas = []
        $scope.Cancelleddatas = []
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/lengthbystatus",
          data: {
            Client_Id: $rootScope.Client_Id, Status: status, StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
          }
        }).then(function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300)
          var Skip = 0
          var Limit = 500
          if (ContractLength == 0) { $scope.vm.YTSPreviewSpinner = false; $scope.vm.CancelledPreviewSpinner = false }
          for (var i = 0; i < ContractLength; i++) {
            if (i == 0) Skip = 0
            else Skip += 500
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/scheduler/get",
              data: {
                StartDate: $scope.uFrom,
                EndDate: $scope.uTo,
                Skip: Skip,
                Limit: Limit,
                Client_Id: $rootScope.Client_Id,
                Status: status,
                Team_Id: $scope.vm.filterteam,
                Customer: $scope.SelectedCustomerID,
                SalesOrder: $scope.Salesorderselected
              }
            }).then(function (GList) {
              if (status == "Yet to Start") {
                var item = GList.data.data
                $scope.YettoStartdatas = $scope.YettoStartdatas.concat(item)
                $scope.YettoStartdatas = _.uniqWith($scope.YettoStartdatas, _.isEqual)
                $scope.vm.YTSPreviewSpinner = false
              }
              else if (status == "Completed") {
                var item = GList.data.data
                $scope.Completeddatas = $scope.Completeddatas.concat(item)
                $scope.Completeddatas = _.uniqWith($scope.Completeddatas, _.isEqual)
                $scope.vm.YTSPreviewSpinner = false
              }
              else if (status == "Cancelled") {
                var item = GList.data.data
                $scope.Cancelleddatas = $scope.Cancelleddatas.concat(item)
                $scope.Cancelleddatas = _.uniqWith($scope.Cancelleddatas, _.isEqual)
                $scope.vm.CancelledPreviewSpinner = false
              }
            })

          }
        })
      }

    }



    $scope.selectedIndex = 0;
    var selectedIndex = localStorage.getItem("TabFromDashboard");
    if (selectedIndex != null && selectedIndex != undefined && selectedIndex != "null" && selectedIndex != "undefined" && selectedIndex != "") {
      try {
        $scope.selectedIndex = parseInt(selectedIndex);
        if ($scope.selectedIndex == 1) {
          NewGetScheduler("Yet to Start");
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 4) {
          $scope.getOutsatnding()
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 6) {
          NewGetScheduler("Pending Approval")
          localStorage.setItem("TabFromDashboard", null)
        }
        else if ($scope.selectedIndex == 0) {
          $scope.getPendingSchedule()
          localStorage.setItem("TabFromDashboard", null)
        }

        localStorage.setItem("TabFromDashboard", "");
      }
      catch (e) { $scope.selectedIndex = 0; NewGetScheduler("Yet to Start"); localStorage.setItem("TabFromDashboard", null) }
    }
    else { $scope.selectedIndex = 0; }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/customer/getCustomer",
      data: {
        Client_Id: $rootScope.Client_Id,
      }
    }).then(function (List) {
      $scope.CustomerSearchdatas = List.data.data
    })

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder/getSO",
      data: {
        Client_Id: $rootScope.Client_Id,
      }
    }).then(function (List) {
      $scope.AllSalesOrderSearchdatas = List.data.data
    })

    function CancelOnHoldDatas(id) {
      $scope.cancelonhold = id
      var result = DevExpress.ui.dialog.confirm('Are you sure, you want to Remove the jobs', 'Remove Jobs');
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          var resp = $http({
            method: 'PUT',
            url: $rootScope.WebURL + "/scheduler/cancelschedulerline",
            data: { id: $scope.cancelonhold, UpdatedBy: $rootScope.createdby }
          });
          resp.then(function (Gli) {
            $mdToast.show($mdToast.simple().textContent('Removed the jobs Successfully!').position('top center'));
            $scope.NewGetByStatus()
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }
      })
    }

    $scope.getSalesOrderforCustomer = function (customer) {

    }
    /// Socket Configuration for Scheduler

    socket.on("Scheduler Created by Inserting multiple", function (data) {
      if (data.result.length > 0) {
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var updatedData = data.result.map(function (o) { return o.id })

          $http({
            method: "POST",
            url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
            data: {
              id: updatedData,
              StartDate: $scope.uFrom,
              EndDate: $scope.uTo,
              Client_Id: $rootScope.Client_Id
            }
          }).then(function (List) {
            var data = List.data.data
            $scope.YettoStartdatas = $scope.YettoStartdatas.concat(data)
            $scope.YettoStartdatas = _.uniqWith($scope.YettoStartdatas, _.isEqual)
          })
        }
        if ($scope.vm.SelectedTab == "PendingSchedule") {
          var item = $scope.PendingScheduledatas.filter(function (item) {
            return item._id != data.result[0].JobsOrders
          })
          item = _.uniqWith(item, _.isEqual)
          $scope.PendingScheduledatas = item
        }
      }
    })

    socket.on("scheduler dragged", function (data) {
      if ($scope.vm.SelectedTab == "Yet to Start") {
        var updatedData = [data.data.id]

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
          data: {
            id: updatedData,
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
            Client_Id: $rootScope.Client_Id
          }
        }).then(function (List) {
          var data = List.data.data
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        })
      }
    })
    socket.on("scheduler dropped", function (data) {
      if ($scope.vm.SelectedTab == "Yet to Start") {
        var updatedData = [data.data.id]

        $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
          data: {
            id: updatedData,
            StartDate: $scope.uFrom,
            EndDate: $scope.uTo,
            Client_Id: $rootScope.Client_Id
          }
        }).then(function (List) {
          var data = List.data.data
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        })
      }
    })
    socket.on("Scheduler updated", function (data) {
      var updatedData = [data.result.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler specified updated", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler cancelled", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")

          $scope.YettoStartdatas = rmdata
        }

        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")

          $scope.MobileInProgressdatas = rmdata
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
      })
    })

    socket.on("Scheduler Team Updated", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Scheduler UpdateTeam method", function (data) {
      var updatedData = [data.data.id]

      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          if (rmdata.length != $scope.YettoStartdatas)
            $scope.YettoStartdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Completed") {
          var rmdata = _.differenceBy($scope.Completeddatas, data, "_id")
          if (rmdata.length != $scope.Completeddatas)
            $scope.Completeddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Cancelled") {
          var rmdata = _.differenceBy($scope.Cancelleddatas, data, "_id")
          if (rmdata.length != $scope.Cancelleddatas)
            $scope.Cancelleddatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          var rmdata = _.differenceBy($scope.PendingApprovaldatas, data, "_id")
          if (rmdata.length != $scope.PendingApprovaldatas)
            $scope.PendingApprovaldatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          if (rmdata.length != $scope.MobileInProgressdatas)
            $scope.MobileInProgressdatas = rmdata.concat(data)
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          if (rmdata.length != $scope.InProgressdatas)
            $scope.InProgressdatas = rmdata.concat(data)
        }
      })
    })
    socket.on("Update Scheduler Line", function (data) {
      //   $scope.NewGetByStatus(null)
    })
    socket.on("Scheduler Completed", function (data) {
      var updatedData = [data.data.id]
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/getSchedulerbyId",
        data: {
          id: updatedData,
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      }).then(function (List) {
        var data = List.data.data
        if ($scope.vm.SelectedTab == "Yet to Start") {
          var rmdata = _.differenceBy($scope.YettoStartdatas, data, "_id")
          $scope.YettoStartdatas = rmdata
        }
        if ($scope.vm.SelectedTab == "Completed") {
          if (data[0].ServiceReportStatus != "Pending")
            $scope.Completeddatas = $scope.Completeddatas.concat(data)
        }
        if ($scope.vm.SelectedTab == "Pending Approval") {
          if (data[0].ServiceReportStatus == "Pending")
            $scope.PendingApprovaldatas = $scope.PendingApprovaldatas.concat(data)
        }
        if ($scope.vm.SelectedTab == "In-Progress") {
          var rmdata = _.differenceBy($scope.MobileInProgressdatas, data, "_id")
          $scope.MobileInProgressdatas = rmdata
        }
        if ($scope.vm.SelectedTab == 'Outstanding') {
          var rmdata = _.differenceBy($scope.InProgressdatas, data, "_id")
          $scope.InProgressdatas = rmdata
        }
      })
    })
    socket.on("WorkOrder unscheduled", function (data) {
      // $scope.NewGetByStatus(null)
    })

  }

  angular
    .module('app.operations.scheduler')
    .factory('alert', function ($uibModal) {
      function show(action, event) {
        return $uibModal.open({
          templateUrl: 'modalContent.html',
          controller: function () {
            var vm = this;
            vm.action = action;
            vm.event = event;
          },
          controllerAs: 'vm'
        });
      }
      return {
        show: show
      };


    });
  angular.module('app.operations.scheduler').config(function ($mdDateLocaleProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return moment(date).format('DD/MM/YYYY');
    };
  });
})();

(function ()
{
    'use strict';

    angular
        .module('app.accounts.saleorder', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.accounts_saleorder', {
            url: '/AccountsWO',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/salesorder/saleorder.html',
                    controller: 'acsalesorderController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/salesorder');
    }

})();
(function () {
  "use strict";

  angular
    .module("app.accounts.saleorder")
    .controller("acsalesorderController", acsalesorderController)
    .filter('removeUploadsPath', replace_upload_path);


  /** @ngInject */
  function replace_upload_path() {
    return function (input) {
      if (!input) {
        return input;
      }
      else {
        return input.replace(/^.*Uploads[\\/]/, '');

      }
    };

  }

  /** @ngInject */
  function acsalesorderController(
    $scope,
    $interval,
    socket,
    $mdSidenav,
    $mdConstant,
    $mdToast,
    $http,
    $rootScope,
    $location,
    $mdDateLocale,
    $mdDialog,
    $document,
    $filter,
    NgMap,
    Upload,
    indexedDBService,
    DataSyncService
  ) {
    document.getElementsByTagName("title")[0].text = "Accounts-Work Order";
    var chkAceses = localStorage.getItem("pages");
    if (chkAceses.split(",").includes("AccountsWorkOrder")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }
    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    var EmpID = localStorage.getItem("EmployeeID");
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var vm = this;
    $scope.Salesform = false;
    $scope.Salesgrid = true;
    $scope.Export = true;
    $scope.Pageform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.uShowClosed = false;
    $scope.SpecialRem = "";
    // $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log("markers", map.markers);
      console.log("shapes", map.shapes);
    });
    function getSalesOrderdata() {
      indexedDBService.getAll("work_order").then(function (data) {
        if (data && data.length > 0) {
          $scope.AllSalesOrderData = data;
          extract_salesorder_data($scope);
        } else GetEnquiryNumber();
      });
    }
    RefreshCustomerdatas();
    var dataGrid;
    vm.dataGridSales = {
      onInitialized: function (e) {
        dataGrid = e.component;
        getSalesOrderdata();
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.salesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },

        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "CreatedBy",
          caption: "Created By",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.CreatedBy.substring(0, 1).toUpperCase() +
              options.data.CreatedBy.substring(1) +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ServiceDate",
          caption: "Service Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        { dataField: "PurchaseOrderNo", caption: "Purchase Order No" },
        // { dataField: "Department", caption: "Company" },

        {
          dataField: "Status",
          caption: "Status",
          cellTemplate: function (container, options) {
            if (options.data.Status == "New") {
              $(
                "<div class='label ng-binding ng-scope md-green-500-bg'>Pending</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Hold") {
              $(
                "<div class='label ng-binding ng-scope md-red-500-bg'>On-Hold</div>"
              ).appendTo(container);
            } else if (options.data.Status == "Completed") {
              $(
                "<div class='label ng-binding ng-scope md-purple-500-bg'>Completed</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Going") {
              $(
                "<div class='label ng-binding ng-scope md-blue-500-bg'>On-Going</div>"
              ).appendTo(container);
            } else {
              $(
                "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
              ).appendTo(container);
            }
          }
        },
        {
          caption: "Preview",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  var url =

                    $rootScope.ReportURL +
                    "WorkOrder.aspx" +
                    "?" +
                    "ID=" +
                    options.data.id;
                  window.open(url);
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       var url =
            //         
            //         $rootScope.ReportURL +
            //         "WorkOrder.aspx" +
            //         "?" +
            //         "ID=" +
            //         options.data.id +
            //         "&Type=Download";
            //       window.open(url);
            //     }
            //   })
            //   .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "salesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data.id);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    var dataGrid1;
    vm.dataGridAdhoc = {
      onInitialized: function (e) {
        dataGrid1 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.AdhocsalesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "CreatedBy",
          caption: "Created By",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.CreatedBy.substring(0, 1).toUpperCase() +
              options.data.CreatedBy.substring(1) +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "PurchaseOrderNo", caption: "Purchase Order No" },
        // { dataField: "Department", caption: "Company" },

        {
          dataField: "Status",
          caption: "Status",
          cellTemplate: function (container, options) {
            if (options.data.Status == "New") {
              $(
                "<div class='label ng-binding ng-scope md-green-500-bg'>Pending</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Hold") {
              $(
                "<div class='label ng-binding ng-scope md-red-500-bg'>On-Hold</div>"
              ).appendTo(container);
            } else if (options.data.Status == "Completed") {
              $(
                "<div class='label ng-binding ng-scope md-purple-500-bg'>Completed</div>"
              ).appendTo(container);
            } else if (options.data.Status == "On-Going") {
              $(
                "<div class='label ng-binding ng-scope md-blue-500-bg'>On-Going</div>"
              ).appendTo(container);
            } else {
              $(
                "<div class='label ng-binding ng-scope md-orange-500-bg'>Scheduled</div>"
              ).appendTo(container);
            }
          }
        },
        {
          caption: "Preview",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  var url =

                    $rootScope.ReportURL +
                    "WorkOrder.aspx" +
                    "?" +
                    "ID=" +
                    options.data.id;
                  window.open(url);
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       var url =
            //         
            //         $rootScope.ReportURL +
            //         "WorkOrder.aspx" +
            //         "?" +
            //         "ID=" +
            //         options.data.id +
            //         "&Type=Download";
            //       window.open(url);
            //     }
            //   })
            //   .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "AdhocsalesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data.id);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    var dataGrid2;
    vm.dataGridWorkOrder = {
      onInitialized: function (e) {
        dataGrid2 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.DeletedSalesOrderdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      wordWrapEnabled: true,
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "SalesOrderNo",
          caption: "Work Order #",
          width: "110",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.SalesOrderNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "CreatedBy",
          caption: "Created By",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.CreatedBy.substring(0, 1).toUpperCase() +
              options.data.CreatedBy.substring(1) +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "OrderConfirmationDate",
          caption: "Order Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "OrderType", caption: "Type" },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ServiceDate",
          caption: "Service Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        },
        { dataField: "PurchaseOrderNo", caption: "Purchase Order No" },
        // { dataField: "Department", caption: "Company" },
        {
          dataField: "UpdatedBy",
          caption: "Updated By",
          cellTemplate: function (container, options) {
            try {
              $(
                "<p style='color:black;cursor: default;'>" +
                options.data.UpdatedBy.substring(0, 1).toUpperCase() +
                options.data.UpdatedBy.substring(1) +
                "</p>"
              ).appendTo(container);
            } catch (error) {
              $(
                "<p style='color:black;cursor: default;'>" +
                options.data.UpdatedBy +
                "</p>"
              ).appendTo(container);
            }
          }
        },
        {
          dataField: "UpdatedDate",
          caption: "Updated Date",
          width: "100",
          dataType: "date",
          format: "dd/MM/yyyy"
        }
      ],
      bindingOptions: {
        dataSource: "DeletedSalesOrderdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onCellClick: function (data) {
        if (data.columnIndex == 1) {
          $scope.salesorderinfo(data.data.id);
          $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD);
        }
      }
    };

    $scope.sAdd = function () {
      ClearForm();
      $scope.Commentdatas = [];
      $scope.CommentArray = [];
      $scope.Update = false;
      $scope.Salesform = true;
      $scope.Salesgrid = false;
      $scope.Export = false;
      $scope.EqUpdate = true;
      $scope.EUpdate = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.vm.AddSchedule = false;
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
      $scope.Search = false;
      $scope.vm.OrderType = "Contract";
      $scope.FrequencyArray = [];
      $scope.ArrayUploadfiles = [];
      $scope.Attachmentdatas = [];
      $scope.Frequencydatas = [];
      $scope.vm.Scheduled = "No";
      $scope.DisableServiceLocation = false;
      $scope.CustomerSServiceAddress = [];
      $scope.vm.SLocation = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.Occurence = null;
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
    };
    $scope.uTo = null;
    $scope.uFrom = null;

    $scope.vm.PreviewSpinner = false;

    $scope.Datefilter = function () {
      if (dataGrid != undefined) dataGrid.beginCustomLoading();
      $scope.contractdatas = [];
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getLengthbyDate",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "Contract",
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo
        }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url:
                  $rootScope.WebURL + "/salesOrder/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "Contract",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid != undefined) dataGrid.endCustomLoading();
                $scope.salesOrderdatas = GList.data.data;
                $scope.salesOrderdatas = _.uniqWith(
                  $scope.salesOrderdatas,
                  _.isEqual
                );
                $scope.workOrd = $scope.salesOrderdatas;
                $scope.vm.PreviewSpinner = false;
              });
            }
          } else {
            if (dataGrid != undefined) dataGrid.endCustomLoading();
            $scope.salesOrderdatas = [];
            $scope.salesOrderdatas = _.uniqWith(
              $scope.salesOrderdatas,
              _.isEqual
            );
            $scope.workOrd = $scope.salesOrderdatas;
            $scope.vm.PreviewSpinner = false;
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );

      // get for Ad-hoc WorkOrder
      if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getLengthbyDate",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "Ad-hoc",
          StartDate: $scope.uFrom,
          EndDate: $scope.uTo
        }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url:
                  $rootScope.WebURL + "/salesOrder/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "Ad-hoc",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
                $scope.AdhocsalesOrderdatas = GList.data.data;
                $scope.AdhocsalesOrderdatas = _.uniqWith(
                  $scope.AdhocsalesOrderdatas,
                  _.isEqual
                );
              });
            }
          } else {
            dataGrid1.endCustomLoading();
            $scope.AdhocsalesOrderdatas = [];
            $scope.AdhocsalesOrderdatas = _.uniqWith(
              $scope.AdhocsalesOrderdatas,
              _.isEqual
            );
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );
    };

    $scope.Showgrid = function () {
      $scope.Salesgrid = true;
      $scope.Salesform = false;
      $scope.Pageform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
    };

    $scope.salesorderinfo = function (id, $index) {
      $scope.Update = true;
      $scope.vm.BContactPerson = null;
      $scope.EUpdate = false;
      $scope.Salesform = true;
      $scope.Salesgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.SID = id;

      $http({
        url: $rootScope.WebURL + "/salesOrder/getSalesoderbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var item = List.data.data[0];
        if (item.Status == "Scheduled") $scope.EUpdate = true;

        $scope.File_id = item._id;
        $scope.Add = false;
        $scope.Search = false;
        $scope.IndexID = $index;
        $scope.FrequencyArray = [];
        $scope.ServiceAddressarray = [];
        $scope.vm.OrderConfirmationDate = item.OrderConfirmationDate;
        $scope.vm.CompanyName = item.CompanyName
        $scope.vm.SalesOrderNo = item.SalesOrderNo;
        $scope.vm.EmployeeName = item.EmployeeName
        if (
          $scope.vm.OrderConfirmationDate != null &&
          $scope.vm.OrderConfirmationDate != ""
        ) {
          $scope.vm.OrderConfirmationDate = new Date(
            item.OrderConfirmationDate
          );
        }
        var Email = item.SiteEmail;
        if (Email != "" && Email != undefined && Email != null)
          $scope.vm.SiteEmail = item.SiteEmail.split(",");
        else $scope.vm.SiteEmail = [];
        $scope.vm.SContactPerson = item.SiteContactPerson;
        $scope.vm.SalesPerson = item.SalesPerson_id;
        $scope.vm.EnquiryReferenceNo = item.EnquiryReferenceNo;
        $scope.vm.ContractNo = item.ContractNo;
        $scope.vm.ContactPerson = item.ContactPerson;
        $scope.vm.CustomerName = item.Customer_id;
        $scope.vm.Occurence = item.EnqRef;
        $scope.vm.SpecialChemical = item.SpecialChemical;
        $scope.vm.PreferredTime = item.PreferredTime;
        $scope.vm.Message = item.Message;
        try {
          var value = $scope.Customerdatas.filter(function (value) {
            return value._id === item.Customer_id;
          })[0];
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === item.Customer_id;
          });
          $scope.Leaddatas = litem;
        } catch (error) { }

        try {
          var value = $scope.Leaddatas.filter(function (value) {
            return value.LeadReferenceNo === $scope.vm.EnquiryReferenceNo;
          })[0];
          if (value != undefined) {
            $scope.EqUpdate = true;
          } else $scope.EqUpdate = false;
        } catch (error) { }

        $scope.vm.ServiceStartDate = item.ServiceStartDate;
        if (
          $scope.vm.ServiceStartDate != null &&
          $scope.vm.ServiceStartDate != ""
        ) {
          $scope.vm.ServiceStartDate = new Date(item.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
        $scope.vm.ServiceEndDate = item.ServiceEndDate;
        if (
          $scope.vm.ServiceEndDate != null &&
          $scope.vm.ServiceEndDate != ""
        ) {
          $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
        }

        if (
          item.CustomerID != undefined &&
          item.CustomerID != null &&
          item.CustomerID != ""
        ) {
          var array = [];
          array.push({ SegmentName: item.CustomerID });
          $scope.vm.SLocation = item.CustomerID;
          $scope.DisableServiceLocation = true;
        } else $scope.DisableServiceLocation = false;
        $scope.vm.SName = item.SiteName;
        $scope.vm.CreatedDate = item.CreatedDate;
        $scope.vm.CreatedBy = item.CreatedBy;
        $scope.vm.SContactNo = item.SiteContactNo;
        if (
          item.SiteContactNo != null &&
          item.SiteContactNo != undefined &&
          item.SiteContactNo != ""
        )
          $scope.vm.SiteContactNo = item.SiteContactNo;
        else $scope.vm.SiteContactNo = "";
        if (
          item.Mobile != null &&
          item.Mobile != undefined &&
          item.Mobile != ""
        )
          $scope.vm.BContactNo = item.Mobile.split(",").splice(0, 2);
        else $scope.vm.BContactNo = [];
        if (item.Email != "" && item.Email != undefined && item.Email != null)
          $scope.vm.BEmail = item.Email;
        else $scope.vm.BEmail = "";
        $scope.vm.Frequency = item.Frequency;
        $scope.vm.OrderType = item.OrderType;
        $scope.vm.TotalSum = parseInt(item.TotalSum);
        $scope.vm.CoverageArea = item.CoverageArea
          ? item.CoverageArea.replace(/<[^>]+>/gm, '')
          : '';
        $scope.vm.PurchaseOrderNo = item.PurchaseOrderNo;
        $scope.vm.IsUrgent = item.IsUrgent;
        $scope.vm.Department = item.Department;
        if ($scope.vm.IsUrgent == true) $scope.vm.IsUrgent = "true";
        else $scope.vm.IsUrgent = "false";
        $scope.vm.TrendingReport = item.TrendingReport;
        if ($scope.vm.TrendingReport == true) $scope.vm.TrendingReport = "true";
        else $scope.vm.TrendingReport = "false";
        $scope.vm.DateTimeofTreatment = item.DateTimeofTreatment;
        $scope.vm.Message = item.SpecialRemarks;
        $scope.vm.PaymentMode = item.PaymentMode;
        $scope.vm.PestType = item.PestType;
        if (
          $scope.vm.PestType != null &&
          $scope.vm.PestType != "" &&
          $scope.vm.PestType != undefined
        ) {
          var array = $scope.vm.PestType.split(",");
          var array1 = [];
          angular.forEach(array, function (item) {
            array1.push({ PestName: item });
          });
          $scope.vm.PestType = array1;
        }
        $scope.vm.Treatment = item.Treatment;
        if (
          $scope.vm.Treatment != null &&
          $scope.vm.Treatment != "" &&
          $scope.vm.Treatment != undefined
        ) {
          var array = $scope.vm.Treatment.split(",");
          var array1 = [];
          angular.forEach(array, function (item) {
            array1.push({ TreatmentName: item });
          });
          $scope.vm.Treatment = array1;
        }
        $scope.vm.sStreet = item.sStreetName;
        $scope.vm.Occurence = item.EnqRef;
        $scope.vm.Message = item.Message
          ? item.Message.replace(/<[^>]+>/g, "")
          : "";
        $scope.vm.sPostal = item.sPostal;
        $scope.vm.PurchaseOrderNo = item.PurchaseOrderNo;
        $scope.vm.SpecialChemical = item.SpecialChemical;
        $scope.Frequencydatas = item.MultiFrequency;
        $scope.vm.BillingFrequency = item.BillingFrequency;
        $scope.vm.Types = item.Types;
        $scope.vm.JobsPerFrequency = parseInt(item.JobsPerFrequency);
        $scope.vm.ServicesRequired = parseInt(item.ServicesRequired);
        $scope.vm.EstimatedHoursRequired = parseFloat(
          item.EstimatedHoursRequired
        );
        $scope.vm.RemarksFinance = item.RemarksFinance;
        $scope.vm.TotalPrice = parseFloat(item.TotalPrice);
        $scope.vm.TotalTripsPerYear = parseInt(item.TotalTripsPerYear);
        $scope.vm.BAddress = null;
        getBillingAddress(item.BillingAddress);
        RefreshAttachmentGrid();
        RefreshComments($scope.SID);
      });
    };

    $scope.getPerMonth = function (value) {
      $scope.Month = "";
      if (value == "COD") $scope.Month = "COD";
      if (value == "Monthly") $scope.Month = "Per Month";
      if (value == "Weekly") $scope.Month = "Per Week";
      if (value == "Quarterly") $scope.Month = "Per Quarter";
      if (value == "Yearly") $scope.Month = "Per Year";
      if (value == "Half Yearly (2)") $scope.Month = "Twice Year";
      if (value == "Quarterly") $scope.Month = "Per Quarter";
      if (value == "Bi Monthly (6)") $scope.Month = "Bimonthly";
    };
    function getBillingAddress(BillingId) {
      var response = $http({
        url:

          $rootScope.WebURL +
          "/customerService/getcustomerserviceaddressdetailsbyID",
        method: "POST",
        data: { _id: BillingId }
      });
      response.then(function (CustomerBillingdata) {
        var CustomerBillingdatas = CustomerBillingdata.data.data;
        if (CustomerBillingdatas.length > 0) {
          $scope.vm.BAddress =
            CustomerBillingdatas[0].bStreetName +
            " " +
            CustomerBillingdatas[0].bPostal;
          if (
            $scope.vm.BContactPerson == undefined ||
            $scope.vm.BContactPerson == null
          )
            $scope.vm.BContactPerson = CustomerBillingdatas[0].bContactPerson;
        }
      });
    }

    $scope.DeleteWorkOrder = function (ID) {
      $scope.DelID = ID;
      var result = DevExpress.ui.dialog.confirm(
        "Do you want to delete the WorkOrder?",
        "Confirm changes"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          var resp = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/salesOrder/delete",
            data: { _id: $scope.DelID, UpdatedBy: $rootScope.createdby }
          });
          resp.then(
            function (Gli) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Work Order Deleted Successfully!")
                  .position("top center")
              );

              // $rootScope.$broadcast('Delete WorkOrder', { data:$scope.DelID});
              // $scope.salesorderinfo(data.data.SalesOrderID); $scope.GetLead(data.data.Customer_Id, data.data.CustomerIDD)
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      });
    };

    $scope.sSubmit = function () {
      var salesOrderArray = [];
      if (
        $scope.Frequencydatas != null &&
        $scope.Frequencydatas != "" &&
        $scope.Frequencydatas != undefined
      ) {
        $scope.vm.Frequency = $scope.Frequencydatas.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        $scope.vm.PestType = $scope.Frequencydatas.map(function (obj) {
          return obj.PestType;
        }).join(",");
        $scope.vm.Treatment = $scope.Frequencydatas.map(function (obj) {
          return obj.Treatment;
        }).join(",");
        $scope.vm.JobsPerFrequency = $scope.Frequencydatas.map(function (obj) {
          return obj.JobsPerFrequency;
        }).join(",");
        $scope.vm.ServicesRequired = $scope.Frequencydatas.map(function (obj) {
          return obj.ServicesRequired;
        }).join(",");
      }
      angular.forEach($scope.Frequencydatas, function (value) {
        if (
          value.JobsPerFrequency == null &&
          value.JobsPerFrequency == undefined &&
          value.ServicesRequired == null &&
          value.ServicesRequired == undefined
        ) {
          salesOrderArray.push(1);
        }
      });
      if (salesOrderArray.length > 0)
        return $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please Add Jobs Per Frequency and Services Required for Treatment Frequency!"
            )
            .position("top center")
        );

      if (
        $scope.vm.BEmail != null &&
        $scope.vm.BEmail != "" &&
        $scope.vm.BEmail != undefined
      ) {
        $scope.vm.BEmail = $scope.vm.BEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SiteEmail != null &&
        $scope.vm.SiteEmail != "" &&
        $scope.vm.SiteEmail != undefined
      ) {
        $scope.vm.SiteEmail = $scope.vm.SiteEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SiteContactNo != null &&
        $scope.vm.SiteContactNo != "" &&
        $scope.vm.SiteContactNo != undefined
      ) {
        $scope.vm.SiteContactNo = $scope.vm.SiteContactNo.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.BContactNo != null &&
        $scope.vm.BContactNo != "" &&
        $scope.vm.BContactNo != undefined
      ) {
        $scope.vm.BContactNo = $scope.vm.BContactNo.map(function (obj) {
          return obj;
        }).join(",");
      }

      if ($scope.vm.OrderType == "Ad-hoc") {
        $scope.vm.ContractNo = null;
        $scope.vm.ServiceStartDate = null;
        $scope.vm.ServiceEndDate = null;
        $scope.vm.TotalTripsPerYear = null;
      }
      if ($scope.vm.IsUrgent == "true") $scope.vm.IsUrgent = true;
      else $scope.vm.IsUrgent = false;

      if ($scope.vm.TrendingReport == "true") $scope.vm.TrendingReport = true;
      else $scope.vm.TrendingReport = false;
      if ($scope.Update == true) {
        // if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
        //     $scope.vm.PestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
        // }
        // if ($scope.vm.Scopeofwork != null && $scope.vm.Scopeofwork != "" && $scope.vm.Scopeofwork != undefined) {
        //     $scope.vm.Scopeofwork = $scope.vm.Scopeofwork.map(function (obj) { return obj.Scopeofwork; }).join(',');
        // }
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/salesOrder/update",
          data: {
            _id: $scope.SID,
            EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
            SalesPerson_id: $scope.vm.SalesPerson,
            ContractNo: $scope.vm.ContractNo,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            OrderType: $scope.vm.OrderType,
            TotalSum: $scope.vm.TotalSum,
            PaymentMode: $scope.vm.PaymentMode,
            BillingFrequency: $scope.vm.BillingFrequency,
            EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
            RemarksFinance: $scope.vm.RemarksFinance,
            CoverageArea: $scope.vm.CoverageArea,
            PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
            IsUrgent: $scope.vm.IsUrgent,
            EnqRef: $scope.vm.Occurence,
            TrendingReport: $scope.vm.TrendingReport,
            Department: $scope.vm.Department,
            DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
            TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
            SpecialRemarks: $scope.vm.Message,
            TotalPrice: $scope.vm.TotalPrice,
            Frequency: $scope.vm.Frequency,
            PestType: $scope.vm.PestType,
            SiteName: $scope.vm.SName,
            SiteContactNo: $scope.vm.SiteContactNo,
            Mobile: $scope.vm.BContactNo,
            Email: $scope.vm.BEmail,
            SiteContactPerson: $scope.vm.SContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            MultiFrequency: $scope.Frequencydatas,
            ServicesRequired: $scope.vm.ServicesRequired,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            Treatment: $scope.vm.Treatment,
            SpecialChemical: $scope.vm.SpecialChemical,
            PreferredTime: $scope.vm.PreferredTime,
            UpdatedBy: $rootScope.createdby,
            Message: $scope.vm.Message
          }
        });
        response.then(
          function (GList) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Updated!")
                .position("top center")
            );
            $scope.Salesgrid = true;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
            $scope.Update = false;
            // $rootScope.$broadcast('Update WorkOrder', { data:$scope.SID});
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var salesOrderArray = [];
        angular.forEach($scope.vm.SLocation, function (Lis) {
          var Email = [];
          Email.push($scope.vm.CustomerArray.Email);
          Email.push($scope.BillingArray.bEmail);
          Email.push(Lis.sEmail);
          Email.push(Lis.sCC);
          Email = Email.map(function (o) {
            return o;
          }).join(",");
          salesOrderArray.push({
            MultiFrequency: $scope.Frequencydatas,
            SalesPerson_id: $scope.vm.SalesPerson,
            ContractNo: $scope.vm.ContractNo,
            Customer_id: $scope.vm.CustomerName,
            EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
            OrderConfirmationDate: $scope.vm.OrderConfirmationDate,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            OrderType: $scope.vm.OrderType,
            TotalSum: $scope.vm.TotalSum,
            PaymentMode: $scope.vm.PaymentMode,
            EnqRef: $scope.vm.Occurence,
            BillingFrequency: $scope.vm.BillingFrequency,
            EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
            RemarksFinance: $scope.vm.RemarksFinance,
            CoverageArea: $scope.vm.CoverageArea,
            PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
            IsUrgent: $scope.vm.IsUrgent,
            TrendingReport: $scope.vm.TrendingReport,
            Department: $scope.vm.Department,
            DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
            TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
            SpecialRemarks: $scope.vm.Message,
            CreatedBy: $rootScope.createdby,
            Client_Id: $rootScope.Client_Id,
            TotalPrice: $scope.vm.TotalPrice,
            PestType: $scope.vm.PestType,
            Frequency: $scope.vm.Frequency,
            Treatment: $scope.vm.Treatment,
            CustomerID: Lis._id,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            SiteName: $scope.vm.SName,
            SiteContactNo: $scope.vm.SContactNo,
            SiteContactPerson: $scope.vm.SContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            Mobile: $scope.vm.BContactNo,
            Email: $scope.vm.BEmail,
            CommentArray: $scope.CommentArray,
            BillingAddress: $scope.vm.BAddressId,
            SpecialChemical: $scope.vm.SpecialChemical,
            PreferredTime: $scope.vm.PreferredTime,
            Message: $scope.vm.Message,
            SchedulerEmail: Email,
            UniqID: UniqID
          });
        });
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder/addbyArray",
          data: { salesOrderArray: salesOrderArray }
        });
        response.then(function (List) {
          // $rootScope.$broadcast('Add WorkOrder', { data:List.data.data});
          $scope.CommentArray = [];
          $scope.Commentdata = [];
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Added!")
              .position("top center")
          );
          $scope.Salesgrid = true;
          $scope.Salesform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.view = false;
          $scope.Search = true;
          $scope.FrequencyArray = [];
          $scope.CustomerServicedatas = [];
          $scope.ServiceAddressarray = [];
          $scope.vm.AddSchedule = false;
          // GetEnquiryNumber()
          // GetEnquiryNumber();
          // $scope.Datefilter();
        });
      }
    };

    $scope.DaysCalc = function (CED) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ContractStartDate);
        var secondDate = new Date($scope.vm.ContractEndDate);
        $scope.vm.ContractDuration =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
      } catch (e) { }
    };
    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.getLeaddetails = function (CustomerID) {
      try {
        var litem = $scope.Leaddetails.filter(function (litem) {
          return litem.CustomerID === CustomerID;
        });
        $scope.Leaddatas = litem;
      } catch (error) { }
      if ($scope.Leaddatas.length != 0) {
        $scope.vm.EnquiryReferenceNo =
          $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
        $scope.vm.TotalPrice = parseFloat(
          $scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue
        );
        if ($scope.vm.OrderType == "Ad-hoc") {
        } else {
          try {
            var item = $scope.contractdatas.filter(function (item) {
              return item._id === $scope.vm.ContractNo;
            })[0];
            $scope.vm.TotalPrice = parseFoat(item.ContractValue);
            $scope.vm.EnquiryReferenceNo = item.EnquiryID;
          } catch (error) { }
        }
      }
    };

    $scope.GetLead = function (CustomerID, RequestID) {
      CustomerBillingdatadetails(RequestID);
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getContractByCustomer",
        data: { Customer_id: CustomerID }
      }).then(function (contractdata) {
        $scope.contractdatas = contractdata.data.data;
        try {
          if ($scope.Update !== true) {
            $scope.vm.ContractNo =
              $scope.contractdatas[$scope.contractdatas.length - 1]._id;
            if ($scope.vm.OrderType == "Contract") {
              $scope.vm.ServiceStartDate = new Date(
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].ServiceStartDate
              );
              $scope.vm.ServiceEndDate = new Date(
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].ServiceEndDate
              );
              $scope.vm.TotalPrice = parseFloat(
                $scope.contractdatas[$scope.contractdatas.length - 1]
                  .ContractValue
              );
              $scope.vm.BillingFrequency =
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].BillingFrequency;
              $scope.Frequencydatas =
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].MultiFrequency;
              $scope.vm.EnquiryReferenceNo =
                contractdata.data.data[0].EnquiryID;
              $scope.vm.BAddressId =
                $scope.contractdatas[
                  $scope.contractdatas.length - 1
                ].BillingAddress;
              var Mobile = contractdata.data.data[0].SiteContact;
              if (Mobile != null && Mobile != "" && Mobile != undefined)
                $scope.vm.SiteContactNo = Mobile;
              else $scope.vm.SiteContactNo = "";
              $scope.vm.SContactPerson =
                contractdata.data.data[0].SiteContactPerson;
              $scope.vm.SName = contractdata.data.data[0].SiteName;
              var Email = contractdata.data.data[0].SiteName;
              if (Email != "" && Email != undefined && Email != null)
                $scope.vm.SiteEmail = Email.split(",");
              else $scope.vm.SiteEmail = [];
              angular.forEach($scope.Frequencydatas, function (item) {
                item.JobsPerFrequency = 1;
                $scope.calculateServices(item.Frequency, item.JobsPerFrequency);
                item.ServicesRequired = $scope.vm.ServicesRequired;
              });
            } else $scope.Frequencydatas = [];
          }
        } catch (e) {
          $scope.vm.ContractNo = null;
        }
      });
    };
    function CustomerBillingdatadetails(Requestid) {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerBillingdata) {
        var CustomerBillingdatas = CustomerBillingdata.data.data;
        $scope.CustomerBBilingAddres = CustomerBillingdatas;
        if (CustomerBillingdatas.length > 0) {
          $scope.BillingArray = CustomerBillingdatas[0];
          $scope.vm.BAddress =
            CustomerBillingdatas[0].bStreetName +
            " " +
            CustomerBillingdatas[0].bPostal;
          if (
            $scope.vm.BContactPerson == undefined ||
            $scope.vm.BContactPerson == null
          )
            $scope.vm.BContactPerson = CustomerBillingdatas[0].bContactPerson;

          // $scope.vm.BContactNo = CustomerBillingdatas[0].bMobile;
          // $scope.vm.BEmail = CustomerBillingdatas[0].sEmail;
        }
      });
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerServicedata) {
        var CustomerServicedatas = CustomerServicedata.data.data;
        $scope.CustomerSServiceAddress = CustomerServicedata.data.data;
        if (CustomerServicedatas.length > 0) {
          // $scope.vm.SLocation = CustomerServicedatas[0].sStreetName;
          $scope.vm.SContactPerson = CustomerServicedatas[0].sContactPerson;
          // if ($scope.vm.SContactNo == null || $scope.vm.SContactNo == "" || $scope.vm.SContactNo == undefined)
          var contactNumber = CustomerServicedatas[0].sMobile;
          if (
            contactNumber != "" &&
            contactNumber != null &&
            contactNumber != undefined
          )
            contactNumber = contactNumber.split(",");
          $scope.vm.SContactNo = contactNumber;
          // if ($scope.vm.SName == null || $scope.vm.SName == "" || $scope.vm.SName == undefined)
          $scope.vm.SName = CustomerServicedatas[0].sName;
        }
      });
    }
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $scope.Days = [
      { id: 0, Name: "Sunday" },
      { id: 1, Name: "Monday" },
      { id: 2, Name: "Tuesday" },
      { id: 3, Name: "Wednesday" },
      { id: 4, Name: "Thursday" },
      { id: 5, Name: "Friday" },
      { id: 6, Name: "Saturday" }
    ];
    $scope.AllSASelec = { value: false };
    $scope.SASelec = { value: false };
    $scope.svAll = { value: false };

    // Add Frequency
    $scope.FrequencyArray = [];
    $scope.AddFrequency = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/addfrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.MultiPestTypes = null;
      $scope.vm.MultiFrequency = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.JobsPerFrequency = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.TotalPrice = null;
      $scope.UpdateFrequency = false;
      $scope.vm.Scheduled = "No";
      $scope.vm.Types = null;
      $scope.vm.JobsPerFrequency = 1;
    };
    $scope.Adelete = function (e, AttachmentdeleteID, datas) {
      if ($scope.Update == false) {
        var index = $scope.Attachmentdatas.indexOf(datas);
        $scope.Attachmentdatas.splice(index, 1);
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/attachment/delete",
          data: { _id: AttachmentdeleteID }
        });
        response.then(
          function (GList) {
            RefreshAttachmentGrid();
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Deleted!")
                .position("top center")
            );
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };
    $scope.Uploadfiles = function (file) {
      if ($scope.Update == false) {
        var count = file.length - 1;
        var upfile = file[count].file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/salesOrder/upload",
          data: { file: upfile }
        }).then(function (resp) {
          var UTableID = resp.data.data[0].GUIDFILENAME;
          var UfileName = resp.data.data[0].OriginalFileName;
          var UfileSize = resp.data.data[0].Size;
          var UPath = resp.data.data[0].Path;
          var UfileType = resp.data.data[0].Type;
          $scope.Attachmentdatas.push({
            TableID: UTableID,
            FileName: UfileName,
            FileSize: UfileSize,
            FileType: UfileType,
            ModuleID: UPath,
            CreatedBy: $rootScope.createdby,
            CreatedDate: new Date()
          });
        });
      } else {
        var upfile = file[0].file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/salesOrder/upload",
          data: { file: upfile }
        }).then(
          function (resp) {
            $scope.TableID = resp.data.data[0].GUIDFILENAME;
            $scope.fileName = resp.data.data[0].OriginalFileName;
            $scope.fileSize = resp.data.data[0].Size;
            $scope.Path = resp.data.data[0].Path;
            $scope.fileType = resp.data.data[0].Type;
            if (resp.data.message == "Successfully Uploaded") {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/add",
                data: {
                  TableID: $scope.TableID,
                  TableName: "Sales Order",
                  FileID: $scope.File_id,
                  FileName: $scope.fileName,
                  FileSize: $scope.fileSize,
                  FileType: $scope.fileType,
                  ModuleID: $scope.Path,
                  Data: null,
                  IsActive: "true",
                  CreatedBy: $rootScope.createdby
                }
              });
              response.then(
                function (GList) {
                  RefreshAttachmentGrid();
                  file[0].cancel();
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent("Successfully Added!")
                      .position("top center")
                  );
                },
                function () {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        "Something entered gone wrong,please try again !"
                      )
                      .position("top center")
                  );
                }
              );
            }
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };
    $scope.Frequencydatas = [];
    $scope.FrequencyClass = function () {
      var array = [];
      try {
        angular.forEach($scope.ScheduleFrequencydatas, function (value) {
          var item = $scope.Frequencydatas.filter(function (item) {
            return value.Name == item.Frequency;
          })[0];
          if (item == undefined) {
            array.push(value);
          }
        });
        $scope.ScheduleFrequencydatas = array;
      } catch (e) { }
    };
    $scope.AddPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.PestUpdate = false;
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.Treatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl:
          "app/main/apps/accounts/salesorder/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.Editpest = function (e, Pestdata) {
      RefreshTreatment();
      $scope.PestUpdate = true;
      $scope.vm.Frequency = Pestdata.Frequency;
      $scope.vm.JobsPerFrequency = Pestdata.JobsPerFrequency;
      $scope.vm.ServicesRequired = Pestdata.ServicesRequired;
      $scope.vm.PestType = Pestdata.PestType;
      $scope.vm.ServiceTrap = Pestdata.ServiceTrap;
      //   $scope.vm.SelectPest =  Pestdata.PestType;
      // if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
      //     var array = $scope.vm.PestType.split(",");
      //     var array1 = [];
      //     angular.forEach(array, function (value) {
      //         array1.push({ PestName: value });
      //     });
      //     $scope.vm.PestType = array1;
      // }
      $scope.ForAlternateWeek($scope.vm.Frequency);
      // $scope.vm.SelectPest = $scope.vm.PestType
      $scope.vm.EPesttype = $scope.vm.PestType;
      $scope.ChangeTreatment(Pestdata);
      $mdDialog.show({
        multiple: true,
        templateUrl:
          "app/main/apps/accounts/salesorder/AddTreatmentFrequency.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.Pestdata = Pestdata;
      $scope.vm.JobsPerFrequency = $scope.vm.JobsPerFrequency || 1;
      $scope.calculateServices($scope.vm.Frequency, $scope.vm.JobsPerFrequency);
      // $scope.Treatmentpopupdata = []
      // $scope.Treatmentpopupdata = [Pestdata];
      // var array = [];
      // var item1 = $scope.Treatmentdatas.filter(function (item1) {
      //     if (item1.PestType.indexOf(Pestdata.PestType) > -1) {
      //         array.push({ TreatmentName: item1.TreatmentName });
      //     }
      // });
      // $scope.Treatmentpopupdata=[]
      // $scope.Treatmentpopupdata.push({PestName:Pestdata.PestType,Treatment: array})
    };
    $scope.ChangeTreatment = function (Pestdata) {
      $scope.Treatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.Treatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        var OthersSelect = false;
        var ServiceTypeSelect = false;
        if (Pestdata.Others !== undefined) {
          OthersSelect = true;
        } else {
          OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          ServiceTypeSelect = true;
        } else {
          ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.Treatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          SelectServiceTrap: ServiceTypeSelect
        });
      }
    };
    $scope.SubmitPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.Treatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        var ServiceTrap = item.ServiceTrap;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }

        array = $scope.Frequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });
        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }
        if (OthersTreatment != undefined && Treatmentarray != "") {
          if (Treatmentarray != null) {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        $scope.EditFrequency = true;
        if (array.length == 0) {
          $scope.Frequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].JobsPerFrequency = $scope.vm.JobsPerFrequency;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServicesRequired = $scope.vm.ServicesRequired;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
          $scope.EditFrequency == false;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      if ($scope.Frequencydatas.length > 0) {
        var num = _.maxBy($scope.Frequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }
      $mdDialog.hide();
    };
    $scope.closepest = function () {
      $mdDialog.hide();
      $scope.Pestdata = null;
    };
    $scope.Deletepest = function (DeleteItem) {
      var index = $scope.Frequencydatas.indexOf(DeleteItem);
      $scope.Frequencydatas.splice(index, 1);
      RefreshSchedulerFrequency();
    };

    //end Frequency
    var applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately"
      },
      {
        key: "onClick",
        name: "On Button Click"
      }
    ],
      dataGrid,
      ServicedataGrid,
      BillingdataGrid;

    $scope.copymain = function ($scope) {
      if ($scope.Servicecopy.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.usBLK = "";
        $scope.vm.usName = $scope.vm.uCompanyName;
        $scope.vm.usContactPerson = $scope.vm.uFirstName;
        $scope.vm.usUnit = $scope.vm.StreetName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.usPostal = $scope.vm.uPostal;
        }
        $scope.vm.usCountry = $scope.vm.uCountry;
        $scope.vm.usBuildingName = $scope.vm.BuildingName;
        $scope.vm.usStreetName = $scope.vm.StreetName;
        $scope.vm.usMobile = [];
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != undefined &&
          $scope.vm.uMobile != ""
        )
          $scope.vm.usMobile = $scope.vm.uMobile;
        if (
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.ZoneCC = $scope.vm.uEmail;

        $scope.vm.ZoneEmail = [];

        if (
          $scope.vm.usContactPerson == "" ||
          $scope.vm.usContactPerson == null ||
          $scope.vm.usContactPerson == undefined
        ) {
          try {
            var item = $scope.CustomerServicedatas.filter(function (item) {
              return item.CustomerID === $scope.RequestID;
            })[0];
            $scope.vm.usName = item.sName;
            $scope.vm.usContactPerson = item.sContactPerson;
            $scope.vm.usBLK = item.sBLK;
            $scope.vm.usUnit = item.sUnit;
            $scope.vm.usPostal = item.sPostal;
            $scope.vm.usCountry = item.sCountry;
            $scope.vm.usBuildingName = item.sBuildingName;
            $scope.vm.usStreetName = item.sStreetName;
            $scope.vm.usMobile = [];
            if (
              item.sMobile != null &&
              item.sMobile != undefined &&
              item.sMobile != ""
            )
              $scope.vm.usMobile = item.sMobile.split(",");
            if (
              item.sEmail != null &&
              item.sEmail != "" &&
              item.sEmail != undefined
            ) {
              $scope.vm.ZoneCC = item.sEmail.split(",");
            }
            if (item.sCC != null && item.sCC != "" && item.sCC != undefined) {
              $scope.vm.ZoneEmail = item.sCC.split(",");
            }
          } catch (e) { }
        }
      }
      if ($scope.Servicecopy.value == false) {
        $scope.vm.usName = "";
        $scope.vm.usContactPerson = "";
        $scope.vm.usBLK = "";
        $scope.vm.usUnit = "";
        $scope.vm.usPostal = "";
        $scope.vm.usCountry = "";
        $scope.vm.usBuildingName = "";
        $scope.vm.usStreetName = "";
        $scope.vm.usMobile = [];
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
      }
    };

    $scope.copybilling = function ($scope) {
      if ($scope.checkboxModel.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.ubContactPerson = $scope.vm.uFirstName;
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = $scope.vm.StreetName;
        $scope.vm.ubBuildingName = $scope.vm.BuildingName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.ubPostal = $scope.vm.uPostal;
        }
        $scope.vm.ubCountry = $scope.vm.uCountry;
        $scope.vm.ubMobile = $scope.vm.uMobile.join(", ");
        $scope.vm.ubEmail = $scope.vm.uEmail;
        $scope.vm.ubStreetName = $scope.vm.StreetName;
        $scope.vm.ubWebsite = "";
      }
      if ($scope.checkboxModel.value == false) {
        $scope.vm.ubContactPerson = "";
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = "";
        $scope.vm.ubBuildingName = "";
        $scope.vm.ubPostal = "";
        $scope.vm.ubCountry = "";
        $scope.vm.ubMobile = "";
        $scope.vm.ubEmail = "";
        $scope.vm.ubStreetName = "";
        $scope.vm.ubWebsite = "";
      }
    };
    $scope.checkboxModel = {
      value: false
    };
    $scope.Servicecopy = {
      value: false
    };

    $scope.Addcustomer = function (e) {
      $scope.CUpdate = false;
      $scope.vm.uCustomerID = null;
      $scope.vm.uSalutation = null;
      $scope.vm.uFirstName = null;
      $scope.vm.uLastName = null;
      $scope.vm.uCompanyName = null;
      $scope.vm.uNote = null;
      $scope.vm.uAddress = null;
      $scope.vm.uAddress1 = null;
      $scope.vm.uPostal = null;
      $scope.vm.uCountry = "Singapore";
      $scope.vm.CContactPerson = null;
      $scope.vm.uPhone = null;
      $scope.vm.uMobile = null;
      $scope.vm.uEmail = null;
      $scope.vm.CustomerSince = new Date();
      $scope.vm.ProspectFollowupDate = new Date();
      $scope.vm.Unit = null;
      $scope.vm.StreetName = null;
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.ubContactPerson = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.BuildingName = null;
      $scope.vm.ubFax = null;
      $scope.vm.ubMobile = null;
      $scope.vm.ubEmail = null;
      $scope.vm.Category = null;
      $scope.vm.MarketSection = null;
      $scope.vm.uInvoiceEmail = [];
      $scope.vm.uInvoiceCC = [];
      $scope.CustomerBillingdatas = [];
      $scope.CustomerServicedatadata = [];

      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      $scope.vm.uCustomerID = pass;
      $scope.CustomerServicedatadata = [];

      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/accounts/salesorder/addcustomer.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.customerSubmit = function () {
      if (
        $scope.vm.uFirstName == null ||
        $scope.vm.uFirstName == "" ||
        $scope.vm.uFirstName == undefined
      ) {
        $scope.vm.uFirstName = $scope.vm.uCompanyName;
      }
      $scope.vm.uContactPerson = $scope.vm.uFirstName;

      if (
        $scope.vm.BuildingName != null &&
        $scope.vm.BuildingName != "" &&
        $scope.vm.BuildingName != undefined
      ) {
        $scope.vm.uAddress =
          $scope.vm.Unit +
          "," +
          $scope.vm.StreetName +
          "," +
          $scope.vm.BuildingName;
      } else {
        $scope.vm.uAddress = $scope.vm.Unit + "," + $scope.vm.StreetName;
      }
      if (
        $scope.vm.uMobile != null &&
        $scope.vm.uMobile != "" &&
        $scope.vm.uMobile != undefined
      )
        $scope.vm.uMobile = $scope.vm.uMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      if (
        $scope.vm.uEmail != null &&
        $scope.vm.uEmail != "" &&
        $scope.vm.uEmail != undefined
      )
        $scope.vm.uEmail = $scope.vm.uEmail
          .map(function (obj) {
            return obj;
          })
          .join(",");
      if (
        $scope.vm.MarketSection != null &&
        $scope.vm.MarketSection != "" &&
        $scope.vm.MarketSection != undefined
      ) {
        $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/add",
        data: {
          CustomerID: $scope.vm.uCustomerID,
          CustomerReference: $scope.vm.CustomerReference,
          Salutation: $scope.vm.uSalutation,
          FirstName: $scope.vm.uFirstName,
          LastName: $scope.vm.uLastName,
          CompanyName: $scope.vm.uCompanyName,
          Note: $scope.vm.uNote,
          Address: $scope.vm.uAddress,
          Address1: $scope.vm.uAddress1,
          Postal: $scope.vm.uPostal,
          Country: $scope.vm.uCountry,
          ContactPerson: $scope.vm.uContactPerson,
          Phone: $scope.vm.uPhone,
          Mobile: $scope.vm.uMobile,
          Email: $scope.vm.uEmail,
          ProspectFollowupDate: $scope.vm.ProspectFollowupDate,
          Unit: $scope.vm.Unit,
          StreetName: $scope.vm.StreetName,
          BuildingName: $scope.vm.BuildingName,
          CreditTerm: $scope.vm.CreditTerm,
          MarketSection: $scope.vm.MarketSection,
          ConEndDate: $scope.vm.ConEndDate,
          Category: $scope.vm.Category,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
          Client_Id: $rootScope.Client_Id,
          InvoiceEmail: $scope.vm.usInvoiceEmail,
          InvoiceCC: $scope.vm.usInvoiceCC
        }
      });
      response.then(
        function (GList) {
          if (GList.data.message == "Existing CompanyName") {
            $scope.error1 = true;
            $scope.Leadgrid = false;
            $scope.Leadform = true;
            $scope.Export = false;
            $scope.Add = false;
            $scope.Search = false;
            $scope.view = true;
          } else {
            debugger;
            RefreshCustomerdatas();
            $scope.vm.CustomerID = GList.data.data.id;
            $scope.vm.ppCompanyName = GList.data.data.CompanyName;
            $scope.vm.Customer = GList.data.data.CompanyName;
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("top center")
            );
            // $scope.Leadgrid = true;
            // $scope.Leadform = false;
            // $scope.Export = true;
            // $scope.Add = true;
            // $scope.view = false;
            // $scope.Search = true;
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.placeChanged = function () {
      $scope.vm.uPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.uPostal = vm.place.address_components[i].long_name;
          }
        }
      }
    };
    $scope.Servicepopup = function (e, uCustomerID, PopupType) {
      $scope.vm.uCustomerID = uCustomerID;
      if (PopupType == "Billing") {
        $scope.Billing = true;
        $scope.Service = false;
        $scope.PopupType = "Billing";
        $scope.vm.ubBLK = null;
        $scope.vm.ubUnit = null;
        $scope.vm.ubPostal = null;
        $scope.vm.ubCountry = null;
        $scope.vm.ubContactPerson = null;
        $scope.vm.ubBuildingName = null;
        $scope.vm.ubStreetName = null;
        $scope.vm.ubMobile = null;
        $scope.vm.ubEmail = null;
        $scope.vm.sty = 45;
      }
      if (PopupType == "Service") {
        $scope.Service = true;
        $scope.Billing = false;
        $scope.PopupType = "Service";
        $scope.vm.sty = 55;
      }
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = [];
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Enter valid CC !")
              .position("top center")
          );
          return;
        }
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid email !")
            .position("top center")
        );
        return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail,
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              $scope.vm.CustomerID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
          $mdDialog.cancel();
        }
      }
    };
    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        }
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        }
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.cspopup = function (e, deleteID, Index, Type) {
      $scope.vm.deleteID = deleteID;
      $scope.vm.Index = Index;
      $scope.vm.DeleteType = Type;
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/accounts/salesorder/cspopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Servicedelete = function (deleteID, Index) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customerService/delete",
        data: { _id: deleteID }
      });
      response.then(
        function (GList) {
          if ($scope.vm.DeleteType == "Service") {
            $scope.CustomerServicedatadata.splice(Index, 1);
          } else {
            $scope.CustomerBillingdatas.splice(Index, 1);
          }
          //CustomerServicedatadetails();
          $scope.Servicegrid = true;
          $scope.Add = false;
          $scope.Search = false;
          $mdDialog.cancel();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Billingadd = function (Index) {
      if ($scope.BAUpdate == true) {
        $scope.BillingIndex = $scope.BillingIndex;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            bBLK: $scope.vm.ubBLK,
            bUnit: $scope.vm.ubUnit,
            bPostal: $scope.vm.ubPostal,
            bCountry: $scope.vm.ubCountry,
            bContactPerson: $scope.vm.ubContactPerson,
            bBuildingName: $scope.vm.ubBuildingName,
            bStreetName: $scope.vm.ubStreetName,
            bMobile: $scope.vm.ubMobile,
            bEmail: $scope.vm.ubEmail,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
            $scope.Add = false;
            $scope.Search = false;
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var item = [];
        try {
          item = $scope.CustomerBillingdatas.filter(function (item) {
            return (
              item.bBLK == $scope.vm.ubBLK &&
              item.bUnit == $scope.vm.ubUnit &&
              item.bStreetName == $scope.vm.ubStreetName &&
              item.bCountry == $scope.vm.ubCountry &&
              item.bMobile == $scope.vm.ubMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          if ($scope.BAUpdate == true) {
            $scope.BillingIndex = $scope.BillingIndex;
            var response = $http({
              method: "PUT",
              url: $rootScope.WebURL + "/customerService/update",
              data: {
                _id: $scope.QID,
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                UpdatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                debugger;
                $scope.CustomerBillingdatas[$scope.BillingIndex] =
                  GList.data.data;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          } else {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/customerService/add",
              data: {
                Type: "Billing",
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                CreatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.RequestID = $scope.vm.uCustomerID;
                $scope.vm.CustomerID = $scope.vm.uCustomerID;
                CustomerBillingdatadetails2();
                $scope.Servicegrid = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Billingupdate = function (e, QId, Index) {
      $scope.BAUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.BillingIndex = Index;
      $scope.Billing = true;
      $scope.Service = false;
      try {
        var item = $scope.CustomerBillingdatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.ubBLK = item.bBLK;
        $scope.vm.ubUnit = item.bUnit;
        $scope.vm.ubPostal = parseInt(item.bPostal);
        $scope.vm.ubCountry = item.bCountry;
        $scope.vm.ubContactPerson = item.bContactPerson;
        $scope.vm.ubBuildingName = item.bBuildingName;
        $scope.vm.ubStreetName = item.bStreetName;
        $scope.vm.ubMobile = parseInt(item.bMobile);
        $scope.vm.ubEmail = item.bEmail;
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/accounts/salesorder/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function acsalesorderController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.ForAlternateWeek = function (freq) {
      if (
        freq == "Alternate Week (52)" ||
        freq === "Alternate Twice a Week (104)"
      ) {
        var item = $scope.Pestdatas.filter(function (item) {
          return item.PestName === "Adult Mosquito";
        });
        $scope.Pestdatasdatas = item;
      } else $scope.Pestdatasdatas = $scope.Pestdatas;
    };
    $scope.CheckTreatment = function () {
      debugger;
      if ($scope.vm.Frequency === "Alternate Week (52)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Week frequency!"
            )
            .position("center")
        );
      }
      if ($scope.vm.Frequency === "Alternate Twice a Week (104)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Twice a Week frequency!"
            )
            .position("center")
        );
      }
    };
    $scope.CCarray = [];
    $scope.AddCC = function (email) {
      try {
        if ($scope.CCarray.indexOf(email) == -1) {
          $scope.CCarray.push(email);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };
    $scope.Removeccs = function (i) {
      try {
        if ($scope.CCarray.indexOf(i) == -1) {
          $scope.CCarray.splice(i, 1);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };

    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
    });

    RefreshSchedulerFrequency();
    function RefreshSchedulerFrequency() {
      $http({
        url: $rootScope.WebURL + "/settings",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (settingsdata) {
        $scope.Settingsdatas = settingsdata.data.data;
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "CreditTerm";
          });
          $scope.CreditTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "ScheduleFrequency";
          });
          $scope.ScheduleFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentMode";
          });
          $scope.PaymentModedatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BillingFrequency";
          });
          $scope.BillingFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentTerm";
          });
          $scope.PaymentTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "JobTypes";
          });
          $scope.JobTypesdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BuildingType";
          });
          $scope.BuildingTypedatas = item;
        } catch (e) { }
      });
    }

    $scope.getDeletedWO = function () {
      if (dataGrid2 != undefined) dataGrid2.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getDeleted",
        data: {
          Client_Id: $rootScope.Client_Id,
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(function (GList) {
        if (dataGrid2 != undefined) dataGrid2.endCustomLoading();
        $scope.DeletedSalesOrderdatas = GList.data.data;
      });
    };

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    function GetEnquiryNumber() {
      if (dataGrid) dataGrid.beginCustomLoading();
      if (dataGrid1) dataGrid1.beginCustomLoading();

      $scope.AllSalesOrderData = [];

      var Limit = 1000;

      // Helper to create paginated request promises
      function getSalesOrderPages() {
        return $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder/getLength",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (res) {
          var total = parseInt(res.data.data);
          var pageCount = Math.ceil(total / Limit);

          var promises = [];
          for (var i = 0; i < pageCount; i++) {
            var Skip = i * Limit;
            promises.push(
              $http({
                method: "POST",
                url:

                  $rootScope.WebURL +
                  "/salesOrder/getSalesOrderfortable",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit
                }
              })
            );
          }
          return Promise.all(promises);
        });
      }

      // Run both contract and ad-hoc in parallel
      Promise.all([getSalesOrderPages()])
        .then(function (results) {
          var contractResults = results[0];
          for (var i = 0; i < contractResults.length; i++) {
            $scope.AllSalesOrderData = $scope.AllSalesOrderData.concat(
              contractResults[i].data.data
            );
          }

          $scope.AllSalesOrderData = _.uniqWith(
            $scope.AllSalesOrderData,
            _.isEqual
          );

          extract_salesorder_data($scope);

          indexedDBService.clearStore("work_order").then(function () {
            indexedDBService.addAll("work_order", $scope.AllSalesOrderData);
          });

          if (dataGrid) dataGrid.endCustomLoading();
          if (dataGrid1) dataGrid1.endCustomLoading();

          $scope.vm.PreviewSpinner = false;
        })
        .catch(function (err) {
          console.error("Error fetching sales orders:", err);
          if (dataGrid) dataGrid.endCustomLoading();
          if (dataGrid1) dataGrid1.endCustomLoading();
        });
    }

    $scope.getDeletedWO = function () {
      if (dataGrid2 != undefined) dataGrid2.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getDeleted",
        data: {
          Client_Id: $rootScope.Client_Id,
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(function (GList) {
        if (dataGrid2 != undefined) dataGrid2.endCustomLoading();
        $scope.DeletedSalesOrderdatas = GList.data.data;
      });
    };

    $scope.getCompleted = function () {
      if (dataGrid3 != undefined) dataGrid3.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/getCompleted",
        data: {
          Client_Id: $rootScope.Client_Id,
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id
        }
      }).then(function (GList) {
        if (dataGrid3 != undefined) dataGrid3.endCustomLoading();
        $scope.CompletedWO = GList.data.data;
      });
    };

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/lead",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (leaddata) {
      $scope.Leaddetails = leaddata.data.data;
    });

    function CustomerServicedatadetails2() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatadata = CustomerServicedata.data.data;
      });
    }
    function CustomerBillingdatadetails2() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.vm.uCustomerID }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
      });
    }
    RefreshTreatment();
    function RefreshTreatment() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Treatmentdata) {
        $scope.Treatmentdatas = Treatmentdata.data.data;
      });
    }
    function RefreshAttachmentGrid() {
      if ($scope.Update == false) $scope.File_id = UniqID;

      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }

    function RefreshCustomerdatas() {
      $scope.getCustomerdatas = [];
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.getCustomerdatas = customerdata;
        $scope.Customerdatas = $scope.getCustomerdatas;
        if (IsAdmin != true) {
          var item = $scope.getCustomerdatas.filter(function (item) {
            if (item.AssignedUser != null)
              return item.AssignedUser.includes($rootScope.createdby);
          });
          $scope.Customerdatasfordropdown = item;
        } else {
          $scope.Customerdatasfordropdown = $scope.getCustomerdatas;
        }
      });
    }
    function ClearForm() {
      $scope.vm.SalesOrderNo = null;
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ConfirmationMode = null;
      $scope.vm.ConfirmationBy = null;
      $scope.vm.ConfirmationReceivedBy = null;
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.Remarks = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.PONumber = null;
      $scope.vm.PestType = null;
      $scope.vm.SalesPerson = null;
      $scope.vm.ContractNo = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.CustomerName = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.Frequency = null;
      $scope.vm.TotalSum = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.Types = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.vm.ServicesRequired = null;
      $scope.vm.TotalPrice = null;
      $scope.vm.Message = null;
      $scope.vm.CoverageArea = null;
      $scope.vm.PurchaseOrderNo = null;
      $scope.vm.IsUrgent = "false";
      $scope.vm.TrendingReport = "false";
      $scope.vm.Department = "Pest Off";
      $scope.vm.DateTimeofTreatment = "";
      $scope.vm.TotalTripsPerYear = 0;
      $scope.vm.SpecialRemarks = null;
      $scope.vm.SpecialRemark = null;
      $scope.vm.BAddress = null;
      $scope.vm.BContactPerson = null;
      $scope.vm.BContactNo = [];
      $scope.vm.BEmail = [];
      $scope.vm.SContactPerson = null;
      $scope.vm.SContactNo = [];
      $scope.vm.SName = null;
      $scope.vm.SiteEmail = [];
      $scope.vm.SiteContactNo = [];
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });

    function CustomerServicedatadetails() {
      $scope.vm.PreviewSpinner = true;
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.vm.CustomerID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatas = CustomerServicedata.data.data;
        var resArr = [];
        try {
          $scope.CustomerServicedatas.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return (
                x.sBLK == item.sBLK &&
                x.sUnit == item.sUnit &&
                x.sStreetName == item.sStreetName &&
                x.sPostal == item.sPostal
              );
            });
            if (i <= -1) resArr.push(item);
          });
        } catch (e) { }
        $scope.CustomerServicedatas = resArr;
        $scope.vm.PreviewSpinner = false;
        if ($scope.vm.FixedTeam == "Yes") {
          if (
            $scope.vm.FixedTeamdata != null &&
            $scope.vm.FixedTeamdata != "" &&
            $scope.vm.FixedTeamdata != undefined
          ) {
            var array = $scope.vm.FixedTeamdata.split(",");
            var array1 = [];
            angular.forEach(array, function (item) {
              angular.forEach($scope.teamdatas, function (value) {
                if (item == value.TeamName) {
                  array1.push(value);
                }
              });
            });
            $scope.teamdatas = array1;
          } else {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/team",
              data: {
                Client_Id: $rootScope.Client_Id
              }
            }).then(function (teamdata) {
              $scope.teamdatas = teamdata.data.data;
            });
          }
        } else {
          $http({
            method: "POST",
            url: $rootScope.WebURL + "/team",
            data: { Client_Id: $rootScope.Client_Id }
          }).then(function (teamdata) {
            $scope.teamdatas = teamdata.data.data;
          });
        }
      });
    }
    $scope.CalculateTotalJob = function (Frequency) {
      try {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (
          Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
          Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
          Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 14);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "WEEKLY") {
          var TotalHallfyearss = Math.round(Totaldays / 7);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "MONTHLY") {
          var TotalHallfyearss = Math.round(Totaldays / 30);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (
          Frequency.toUpperCase() == "BIMONTHLY" ||
          Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 60);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "QUARTERLY") {
          var TotalHallfyearss = Math.round(Totaldays / 90);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (
          Frequency.toUpperCase() == "HALF-YEARLY" ||
          Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
        ) {
          var TotalHallfyearss = Math.round(Totaldays / 183);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * TotalHallfyearss;
          }
        }
        if (Frequency.toUpperCase() == "YEARLY") {
          var Totalyearss = Math.round(Totaldays / 365);
          if (
            $scope.vm.JobsPerFrequency != null &&
            $scope.vm.JobsPerFrequency != undefined &&
            $scope.vm.JobsPerFrequency != ""
          ) {
            $scope.vm.ServicesRequired =
              $scope.vm.JobsPerFrequency * Totalyearss;
          }
        }
        if (Frequency.toUpperCase() == "DAILY") {
          $scope.vm.ServicesRequired = Totaldays;
        }
      } catch (e) { }
    };
    $scope.CalculateTotalServices = function () {
      try {
        var Frequency = $scope.vm.MultiFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          if (Frequency.toUpperCase() == "DAILY") {
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * Totaldays;
            }
          }
          if (Frequency.toUpperCase() == "WEEKLY") {
            var TotalWeeks = Math.round(Totaldays / 7);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalWeeks;
            }
          }
          if (Frequency.toUpperCase() == "MONTHLY") {
            var TotalMonths = Math.round(Totaldays / 30);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalMonths;
            }
          }
          if (Frequency.toUpperCase() == "YEARLY") {
            var Totalyearss = Math.round(Totaldays / 365);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * Totalyearss;
            }
          }
          if (
            Frequency.toUpperCase() == "BIMONTHLY" ||
            Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 60);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
          if (
            Frequency.toUpperCase() == "HALF-YEARLY" ||
            Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 183);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
          if (
            Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
            Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
            Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 14);
            if (
              $scope.vm.JobsPerFrequency != null &&
              $scope.vm.JobsPerFrequency != undefined &&
              $scope.vm.JobsPerFrequency != ""
            ) {
              $scope.vm.ServicesRequired =
                $scope.vm.JobsPerFrequency * TotalHallfyearss;
            }
          }
        }
      } catch (e) { }
    };
    $scope.calculateServices = function (freq, job) {
      try {
        $scope.vm.ServicesRequired = parseInt(freq.match(/\(([^)]+)\)/)[1]);
      } catch (error) {
        $scope.vm.ServicesRequired = 0;
      }
    };

    $scope.getFrequencyTable = function (data) {
      if ($scope.vm.OrderType == "Contract") {
        $scope.Frequencydatas = data.MultiFrequency;
        $scope.vm.ServiceStartDate = new Date(data.ServiceStartDate);
        $scope.vm.ServiceEndDate = new Date(data.ServiceEndDate);
        $scope.vm.TotalPrice = parseFloat(data.ContractValue);
        $scope.vm.BillingFrequency = data.BillingFrequency;
        $scope.vm.SiteContactNo = data.SiteContact;
        $scope.vm.SContactPerson = data.SiteContactPerson;
        $scope.vm.SName = data.SiteName;
        $scope.vm.BAddressId = data.BillingAddress;
        var Email = data.SiteName;
        if (Email != "" && Email != undefined && Email != null)
          $scope.vm.SiteEmail = Email.split(",");
        else $scope.vm.SiteEmail = [];
        angular.forEach($scope.Frequencydatas, function (item) {
          item.JobsPerFrequency = 1;
          $scope.calculateServices(item.Frequency, item.JobsPerFrequency);
          item.ServicesRequired = $scope.vm.ServicesRequired;
        });
        // if (data.CustomerID != null && data.CustomerID != undefined && data.CustomerID != "") {
        //     $scope.vm.SLocation = data.CustomerID
        //     $scope.DisableServiceLocation = true
        // }
      } else $scope.Frequencydatas = [];
    };

    function RefreshComments(ID) {
      var response = $http({
        url: $rootScope.WebURL + "/schedulercomment/getByReqID",
        method: "POST",
        data: { RequestID: ID }
      });
      response.then(function (Commentdata) {
        var Commentdatas = [];
        Commentdatas.push({ key: 0 });
        $scope.Commentdatas = [];
        if (
          $scope.vm.SpecialRemarks != undefined &&
          $scope.vm.SpecialRemarks != "" &&
          $scope.vm.SpecialRemarks != null
        ) {
          Commentdatas[0].key = 1;
          Commentdatas[0].cmt = $scope.vm.SpecialRemarks;
          Commentdatas[0].CommentedBy = $scope.vm.CreatedBy;
          Commentdatas[0].CreatedDate = $scope.vm.CreatedDate;
          // $scope.Commentdatas = Commentdatas.concat(Commentdata.data.data);
          $scope.Commentdatas = Commentdata.data.data;
        } else $scope.Commentdatas = Commentdata.data.data;
        $scope.vm.SpecialRemarks = "";
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate);
        });
        $scope.Commentdatas.reverse();
      });
    }
    $scope.CommentArray = [];
    $scope.CountyList = [
      {
        name: "Afghanistan"
      },
      {
        name: "Albania"
      },
      {
        name: "Algeria"
      },
      {
        name: "American Samoa"
      },
      {
        name: "AndorrA"
      },
      {
        name: "Angola"
      },
      {
        name: "Anguilla"
      },
      {
        name: "Antarctica"
      },
      {
        name: "Antigua and Barbuda"
      },
      {
        name: "Argentina"
      },
      {
        name: "Armenia"
      },
      {
        name: "Aruba"
      },
      {
        name: "Australia"
      },
      {
        name: "Austria"
      },
      {
        name: "Azerbaijan"
      },
      {
        name: "Bahamas"
      },
      {
        name: "Bahrain"
      },
      {
        name: "Bangladesh"
      },
      {
        name: "Barbados"
      },
      {
        name: "Belarus"
      },
      {
        name: "Belgium"
      },
      {
        name: "Belize"
      },
      {
        name: "Benin"
      },
      {
        name: "Bermuda"
      },
      {
        name: "Bhutan"
      },
      {
        name: "Bolivia"
      },
      {
        name: "Bosnia and Herzegovina"
      },
      {
        name: "Botswana"
      },
      {
        name: "Bouvet Island"
      },
      {
        name: "Brazil"
      },
      {
        name: "British Indian Ocean Territory"
      },
      {
        name: "Brunei Darussalam"
      },
      {
        name: "Bulgaria"
      },
      {
        name: "Burkina Faso"
      },
      {
        name: "Burundi"
      },
      {
        name: "Cambodia"
      },
      {
        name: "Cameroon"
      },
      {
        name: "Canada"
      },
      {
        name: "Cape Verde"
      },
      {
        name: "Cayman Islands"
      },
      {
        name: "Central African Republic"
      },
      {
        name: "Chad"
      },
      {
        name: "Chile"
      },
      {
        name: "China"
      },
      {
        name: "Christmas Island"
      },
      {
        name: "Cocos (Keeling) Islands"
      },
      {
        name: "Colombia"
      },
      {
        name: "Comoros"
      },
      {
        name: "Congo"
      },
      {
        name: "Congo, The Democratic Republic of the"
      },
      {
        name: "Cook Islands"
      },
      {
        name: "Costa Rica"
      },
      {
        name: "Cote D'Ivoire"
      },
      {
        name: "Croatia"
      },
      {
        name: "Cuba"
      },
      {
        name: "Cyprus"
      },
      {
        name: "Czech Republic"
      },
      {
        name: "Denmark"
      },
      {
        name: "Djibouti"
      },
      {
        name: "Dominica"
      },
      {
        name: "Dominican Republic"
      },
      {
        name: "Ecuador"
      },
      {
        name: "Egypt"
      },
      {
        name: "El Salvador"
      },
      {
        name: "Equatorial Guinea"
      },
      {
        name: "Eritrea"
      },
      {
        name: "Estonia"
      },
      {
        name: "Ethiopia"
      },
      {
        name: "Falkland Islands (Malvinas)"
      },
      {
        name: "Faroe Islands"
      },
      {
        name: "Fiji"
      },
      {
        name: "Finland"
      },
      {
        name: "France"
      },
      {
        name: "French Guiana"
      },
      {
        name: "French Polynesia"
      },
      {
        name: "French Southern Territories"
      },
      {
        name: "Gabon"
      },
      {
        name: "Gambia"
      },
      {
        name: "Georgia"
      },
      {
        name: "Germany"
      },
      {
        name: "Ghana"
      },
      {
        name: "Gibraltar"
      },
      {
        name: "Greece"
      },
      {
        name: "Greenland"
      },
      {
        name: "Grenada"
      },
      {
        name: "Guadeloupe"
      },
      {
        name: "Guam"
      },
      {
        name: "Guatemala"
      },
      {
        name: "Guernsey"
      },
      {
        name: "Guinea"
      },
      {
        name: "Guinea-Bissau"
      },
      {
        name: "Guyana"
      },
      {
        name: "Haiti"
      },
      {
        name: "Heard Island and Mcdonald Islands"
      },
      {
        name: "Holy See (Vatican City State)"
      },
      {
        name: "Honduras"
      },
      {
        name: "Hong Kong"
      },
      {
        name: "Hungary"
      },
      {
        name: "Iceland"
      },
      {
        name: "India"
      },
      {
        name: "Indonesia"
      },
      {
        name: "Iran, Islamic Republic Of"
      },
      {
        name: "Iraq"
      },
      {
        name: "Ireland"
      },
      {
        name: "Isle of Man"
      },
      {
        name: "Israel"
      },
      {
        name: "Italy"
      },
      {
        name: "Jamaica"
      },
      {
        name: "Japan"
      },
      {
        name: "Jersey"
      },
      {
        name: "Jordan"
      },
      {
        name: "Kazakhstan"
      },
      {
        name: "Kenya"
      },
      {
        name: "Kiribati"
      },
      {
        name: "Korea, Democratic People'S Republic of"
      },
      {
        name: "Korea, Republic of"
      },
      {
        name: "Kuwait"
      },
      {
        name: "Kyrgyzstan"
      },
      {
        name: "Lao People'S Democratic Republic"
      },
      {
        name: "Latvia"
      },
      {
        name: "Lebanon"
      },
      {
        name: "Lesotho"
      },
      {
        name: "Liberia"
      },
      {
        name: "Libyan Arab Jamahiriya"
      },
      {
        name: "Liechtenstein"
      },
      {
        name: "Lithuania"
      },
      {
        name: "Luxembourg"
      },
      {
        name: "Macao"
      },
      {
        name: "Macedonia, The Former Yugoslav Republic of"
      },
      {
        name: "Madagascar"
      },
      {
        name: "Malawi"
      },
      {
        name: "Malaysia"
      },
      {
        name: "Maldives"
      },
      {
        name: "Mali"
      },
      {
        name: "Malta"
      },
      {
        name: "Marshall Islands"
      },
      {
        name: "Martinique"
      },
      {
        name: "Mauritania"
      },
      {
        name: "Mauritius"
      },
      {
        name: "Mayotte"
      },
      {
        name: "Mexico"
      },
      {
        name: "Micronesia, Federated States of"
      },
      {
        name: "Moldova, Republic of"
      },
      {
        name: "Monaco"
      },
      {
        name: "Mongolia"
      },
      {
        name: "Montenegro"
      },
      {
        name: "Montserrat"
      },
      {
        name: "Morocco"
      },
      {
        name: "Mozambique"
      },
      {
        name: "Myanmar"
      },
      {
        name: "Namibia"
      },
      {
        name: "Nauru"
      },
      {
        name: "Nepal"
      },
      {
        name: "Netherlands"
      },
      {
        name: "Netherlands Antilles"
      },
      {
        name: "New Caledonia"
      },
      {
        name: "New Zealand"
      },
      {
        name: "Nicaragua"
      },
      {
        name: "Niger"
      },
      {
        name: "Nigeria"
      },
      {
        name: "Niue"
      },
      {
        name: "Norfolk Island"
      },
      {
        name: "Northern Mariana Islands"
      },
      {
        name: "Norway"
      },
      {
        name: "Oman"
      },
      {
        name: "Pakistan"
      },
      {
        name: "Palau"
      },
      {
        name: "Palestinian Territory, Occupied"
      },
      {
        name: "Panama"
      },
      {
        name: "Papua New Guinea"
      },
      {
        name: "Paraguay"
      },
      {
        name: "Peru"
      },
      {
        name: "Philippines"
      },
      {
        name: "Pitcairn"
      },
      {
        name: "Poland"
      },
      {
        name: "Portugal"
      },
      {
        name: "Puerto Rico"
      },
      {
        name: "Qatar"
      },
      {
        name: "Reunion"
      },
      {
        name: "Romania"
      },
      {
        name: "Russian Federation"
      },
      {
        name: "RWANDA"
      },
      {
        name: "Saint Helena"
      },
      {
        name: "Saint Kitts and Nevis"
      },
      {
        name: "Saint Lucia"
      },
      {
        name: "Saint Pierre and Miquelon"
      },
      {
        name: "Saint Vincent and the Grenadines"
      },
      {
        name: "Samoa"
      },
      {
        name: "San Marino"
      },
      {
        name: "Sao Tome and Principe"
      },
      {
        name: "Saudi Arabia"
      },
      {
        name: "Senegal"
      },
      {
        name: "Serbia"
      },
      {
        name: "Seychelles"
      },
      {
        name: "Sierra Leone"
      },
      {
        name: "Singapore"
      },
      {
        name: "Slovakia"
      },
      {
        name: "Slovenia"
      },
      {
        name: "Solomon Islands"
      },
      {
        name: "Somalia"
      },
      {
        name: "South Africa"
      },
      {
        name: "South Georgia and the South Sandwich Islands"
      },
      {
        name: "Spain"
      },
      {
        name: "Sri Lanka"
      },
      {
        name: "Sudan"
      },
      {
        name: "Suriname"
      },
      {
        name: "Svalbard and Jan Mayen"
      },
      {
        name: "Swaziland"
      },
      {
        name: "Sweden"
      },
      {
        name: "Switzerland"
      },
      {
        name: "Syrian Arab Republic"
      },
      {
        name: "Taiwan, Province of China"
      },
      {
        name: "Tajikistan"
      },
      {
        name: "Tanzania, United Republic of"
      },
      {
        name: "Thailand"
      },
      {
        name: "Timor-Leste"
      },
      {
        name: "Togo"
      },
      {
        name: "Tokelau"
      },
      {
        name: "Tonga"
      },
      {
        name: "Trinidad and Tobago"
      },
      {
        name: "Tunisia"
      },
      {
        name: "Turkey"
      },
      {
        name: "Turkmenistan"
      },
      {
        name: "Turks and Caicos Islands"
      },
      {
        name: "Tuvalu"
      },
      {
        name: "Uganda"
      },
      {
        name: "Ukraine"
      },
      {
        name: "United Arab Emirates"
      },
      {
        name: "United Kingdom"
      },
      {
        name: "United States"
      },
      {
        name: "United States Minor Outlying Islands"
      },
      {
        name: "Uruguay"
      },
      {
        name: "Uzbekistan"
      },
      {
        name: "Vanuatu"
      },
      {
        name: "Venezuela"
      },
      {
        name: "Viet Nam"
      },
      {
        name: "Virgin Islands, British"
      },
      {
        name: "Virgin Islands, U.S."
      },
      {
        name: "Wallis and Futuna"
      },
      {
        name: "Western Sahara"
      },
      {
        name: "Yemen"
      },
      {
        name: "Zambia"
      },
      {
        name: "Zimbabwe"
      }
    ];

    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }
    vm.readonly = false;
    vm.ZoneCC = [];
    vm.ZoneEmail = [];
    vm.uInvoiceEmail = [];
    vm.uInvoiceCC = [];
    vm.roFruitNames = angular.copy(vm.fruitNames);

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      destroy: true,
      lengthMenu: [10, 20, 30, 50, 100],
      responsive: true,
      stateSave: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtdetails1 = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-dtdetails1");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dtdetails2 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-dtdetails2");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      destroy: true
    };
    vm.dataGridCustomerServiceAdd = {
      onInitialized: function (e) {
        ServicedataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatadata,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: "onClick"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sName", caption: "Name" },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sStreetName", caption: "Address" },
        { dataField: "sPostal", caption: "Postal" },
        { dataField: "sEmail", caption: "Email" },
        { dataField: "sMobile", caption: "Mobile" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = ServicedataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.Servicesupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  debugger;
                  var index = ServicedataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  debugger;
                  $scope.cspopup(e, options.data._id, index, "Service");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatadata",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = ServicedataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerBilling = {
      onInitialized: function (e) {
        BillingdataGrid = e.component;
      },
      dataSource: $scope.CustomerBillingdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "bContactPerson", caption: "Contact Person" },
        { dataField: "bBLK", caption: "Blk" },
        { dataField: "bStreetName", caption: "Address" },
        { dataField: "bPostal", caption: "Postal" },
        { dataField: "bCountry", caption: "Country" },
        { dataField: "bEmail", caption: "Email" },
        { dataField: "bMobile", caption: "Mobile" },
        {
          caption: "View/Edit",
          fixed: true,
          fixedPosition: "right",
          width: 80,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "edit",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.Billingupdate(e, options.data._id, index);
                }
              })
              .appendTo(container);
          }
        },
        {
          caption: "Delete",
          fixed: true,
          fixedPosition: "right",
          width: 60,
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "trash",
                onClick: function (e) {
                  var index = BillingdataGrid.getRowIndexByKey(
                    options.data._id
                  );
                  $scope.cspopup(e, options.data._id, index, "Billing");
                }
              })
              .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "CustomerBillingdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = BillingdataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple"
      },
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sContactPerson", caption: "Contact Person" },
        { dataField: "sBLK", caption: "Blk" },
        { dataField: "sUnit", caption: "Unit" },
        { dataField: "sBuildingName", caption: "Building Name" },
        { dataField: "sStreetName", caption: "Street Name" },
        { dataField: "sPostal", caption: "Postal" }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.ServiceAddressarray = [];
          $scope.ServiceAddressarray.push.apply(
            $scope.ServiceAddressarray,
            e.selectedRowsData
          );
        } else {
          $scope.ServiceAddressarray = [];
        }
      }
    };
    // GetEnquiryNumber()
    $scope.ShowAdhocs = function (test) {
      $scope.vm.PreviewSpinner = true;
      if (test == true) {
        $scope.uShowClosed = true;
        $("#SalesgridContainer")
          .dxDataGrid("instance")
          .option().columns[7].visible = false;
        $("#SalesgridContainer").dxDataGrid("instance").state({});
        $http({
          url: $rootScope.WebURL + "/salesorder",
          method: "POST",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (GList) {
          $scope.salesOrderdatas = GList.data.data;
          if (IsAdmin == true) {
            var item = $scope.salesOrderdatas.filter(function (item) {
              return item.OrderType === "Ad-hoc";
            });
            $scope.salesOrderdatas = item;
            $scope.vm.PreviewSpinner = false;
          } else {
            var item = $scope.salesOrderdatas.filter(function (item) {
              return (
                item.OrderType === "Ad-hoc" &&
                $scope.Emp_Id === item.SalesPerson_id
              );
            });
            $scope.salesOrderdatas = item;
            $scope.vm.PreviewSpinner = false;
          }
          angular.forEach($scope.salesOrderdatas, function (value) {
            try {
              value.ServiceDate =
                new Date(value.ServiceStartDate).toLocaleDateString("en-GB") +
                " - " +
                new Date(value.ServiceEndDate).toLocaleDateString("en-GB");
              var pest = value.PestType.split(",");
              var PestArray = [];
              PestArray = $scope.Pestdatas.filter(function (pestt) {
                return pest.includes(pestt.PestName);
              });
              value.PestCode = PestArray.map(function (obj) {
                if (
                  obj.Pestcode != null &&
                  obj.Pestcode != undefined &&
                  obj.Pestcode != ""
                )
                  return obj.Pestcode;
                else return obj.PestName;
              }).join(",");
            } catch (e) { }
          });
        });
      } else {
        GetEnquiryNumber();
        $scope.uShowClosed = false;
        $("#SalesgridContainer")
          .dxDataGrid("instance")
          .option().columns[7].visible = true;
        $("#SalesgridContainer").dxDataGrid("instance").state({});
      }
    };
    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }

    $scope.Status = function () {
      if (data) {
      }
    };

    // socket configuration

    $scope.$on("salesOrder_created", function (event, item) {
      $scope.AllSalesOrderData.push(item);
      extract_salesorder_data($scope);
      // get for Ad-hoc WorkOrder
    });

    $scope.$on("work_order_modified", function (event, item) {
      var idx = $scope.AllSalesOrderData.findIndex(function (c) {
        return c.id === item.id;
      });
      if (idx !== -1) {
        $scope.AllSalesOrderData[idx] = item;
      }
      extract_salesorder_data($scope);
      // get for Ad-hoc WorkOrder
    });

    $scope.$on("work_order_deleted", function (event, item) {
      getSalesOrderdata();
    });

    function extract_salesorder_data($scope) {
      var salesOrderdatas = $scope.AllSalesOrderData.filter(function (item) {
        return item.OrderType == "Contract";
      });
      $scope.salesOrderdatas = _.uniq(salesOrderdatas);

      $scope.workOrd = $scope.salesOrderdatas;
      angular
        .element("#PendingContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.salesOrderdatas);

      var AdhocsalesOrderdatas = $scope.AllSalesOrderData.filter(function (
        item
      ) {
        return item.OrderType == "Ad-hoc";
      });
      $scope.AdhocsalesOrderdatas = _.uniq(AdhocsalesOrderdatas);

      angular
        .element("#YTSContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.AdhocsalesOrderdatas);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.accounts.purchasespayables', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_purchasespayables', {
            url: '/purchasespayables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/purchasespayables/purchasespayables.html',
                    controller: 'purchasespayablesController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/purchasespayables');
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.accounts.purchasespayables')
    .controller('purchasespayablesController', purchasespayablescontroller);

  function purchasespayablescontroller($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $mdDateLocale, $timeout, $q, $log, $filter, Upload) {
    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("PurchasesPayables")) { // do nothing 
    } else {
      $location.path("NoAccess");
    }

    var Client_Id = localStorage.getItem('Client_Id');
    var LoggedEmployeeID = localStorage.getItem('EmployeeID');

    var date = new Date();
    var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
    $scope.uFrom = firstDay;
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo = date;
    $scope.uTo.setHours(23, 59, 59, 999);

    $scope.InvoiceGrid = true;
    $scope.InvoiceForm = false;
    $scope.InvoiceFormback = false;
    $scope.PurchaseInvoicegrid = true;

    $scope.PurchaseInvoiceform = false;
    $scope.PaySuppliergrid = false;
    $scope.PaySupplierform = false;
    $scope.CreditnoteGrid = false;
    $scope.CreditnoteForm = false;
    $scope.DebitnoteGrid = false;
    $scope.DebitnoteForm = false;
    $scope.CancelPI = false;

    $scope.InvoiceTab = function () {
      $scope.PurchaseInvoicegrid = true;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
      $scope.SearchValue = "";
      $scope.InvoiceGrid = true;
      $scope.InvoiceForm = false;
      $scope.InvoiceFormback = false;
    };
    $scope.Showinvoicegrid = function () {
      $scope.PurchaseInvoicegrid = true;
      $scope.InvoiceGrid = true;
      $scope.InvoiceForm = false;
      $scope.InvoiceFormback = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
    }

    GetTotalCurrentYearInvoices();

    function GetTotalCurrentYearInvoices() {

      var firstDay = new Date(new Date().getFullYear(), 0, 1);
      firstDay.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/purchaseinvoice/getTotalInvoicesByYear",
        method: "POST",
        data: {
          Start_Date: firstDay,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (purchaseinvoicedata) {

        if (purchaseinvoicedata.data.data.length > 0) {

          $scope.TotalCurrentYearInvoices = purchaseinvoicedata.data.data[0].Total;
        } else {
          $scope.TotalCurrentYearInvoices = 0
        }


      });
    }

    $scope.Invoiceadd = function (e) {
      ClearInvoice();
      $scope.Update = false;
      $scope.CancelPI = false;
      $scope.InvoiceFormback = true;
      $scope.InvoiceGrid = false;
      $scope.InvoiceForm = true;
      $scope.PurchaseInvoicegrid = false;

      $scope.vm.VoucherDate = new Date();
      $scope.vm.Date = new Date();

      var info = $scope.TotalCurrentYearInvoices + 1;
      var y = pad(info, 6);
      var VR = "PV" + new Date().getFullYear().toString().substr(-2);
      $scope.vm.VoucherNumber = VR + y;
      $scope.Purchaseorderproductdatas = null;
      LoadDeafaultEmployee();
    }

    $scope.OnPOChange = function () {

      var myArray = $scope.vm.POID;
      var BillingAmount = 0;

      if (myArray == undefined) {
        $scope.Purchaseorderproductdatas = null;
      }

      angular.forEach(myArray, function (value, key) {
        if (value.Total != undefined) {
          BillingAmount = BillingAmount + parseFloat(value.Total).toFixed(2);
          $scope.vm.Description = value.Remarks;
          $scope.vm.ReceivedDate = new Date(value.OrderDate);
        }
        if (value.UniqueID != undefined) {
          Purchaseorderproducts(value.UniqueID);
        }
      });

      $scope.vm.Amount = parseFloat(BillingAmount);

    }

    function Purchaseorderproducts(UniqueID) {
      var response = $http({
        url: $rootScope.WebURL + "/purchaseorderproduct/getByRequestID",
        method: "POST",
        data: {
          RequestID: UniqueID
        },
      });
      response.then(function (Purchaseorderproductdata) {

        //     if ($scope.Purchaseorderproductdatas != undefined && $scope.Purchaseorderproductdatas.length > 0) {

        //         var item =Purchaseorderproductdata.data.data;

        //         if(item.length>1){

        // angular.forEach(item, function (value, key) {
        //     $scope.Purchaseorderproductdatas.push(value);
        // });
        //         }
        //         else
        //         {
        //             $scope.Purchaseorderproductdatas.push(Purchaseorderproductdata.data.data[0]); 
        //         }

        //     }
        //     else {

        //         $scope.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
        //     }
        $scope.Purchaseorderproductdatas = Purchaseorderproductdata.data.data;
      });
    }

    $scope.SaveInvoice = function () {

      var OutStandingAmount = $scope.vm.Amount;
      var InvoiceAmount = 0;
      var GSTAmount = 0;
      if ($scope.vm.GSTID == "" || $scope.vm.GSTID == undefined) {
        $scope.vm.GSTID = null;
      } else {
        var item = $scope.GSTdatas.filter(function (item) {
          return item._id === $scope.vm.GSTID;
        })[0];

        OutStandingAmount = parseFloat(OutStandingAmount) + (parseFloat(OutStandingAmount / 100) * parseFloat(item.TaxRate));

        GSTAmount = parseFloat($scope.vm.Amount / 100) * parseFloat(item.TaxRate);
      }

      InvoiceAmount = OutStandingAmount;


      $scope.POID = $scope.vm.POID.map(function (obj) {
        return obj.ReferenceNo;
      }).join(',');

      if ($scope.Update == true) {

        $scope.Update = true;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchaseinvoice/update",
          data: {
            _id: $scope.InvoiceID,
            POID: $scope.POID,
            SupplierID: $scope.vm.SupplierID,
            Description: $scope.vm.Description,
            VoucherNumber: $scope.vm.VoucherNumber,
            VoucherDate: $scope.vm.VoucherDate,
            InvoiceNumber: $scope.vm.InvoiceNumber,
            Date: $scope.vm.Date,
            Amount: $scope.vm.Amount,
            OutStandingAmount: OutStandingAmount,
            InvoiceAmount: InvoiceAmount,
            GSTAmount: GSTAmount,
            GSTID: $scope.vm.GSTID,
            ReceivedBy: $scope.vm.ReceivedBy,
            ReceivedDate: $scope.vm.ReceivedDate,
            Remarks: $scope.vm.Remarks,
            Status: $scope.Status,
            StatusID: $scope.StatusID,
            UpdatedBy: $rootScope.createdby
          },
        });

        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshInvoice();
          GetTotalCurrentYearInvoices();
          $mdDialog.hide();

          $scope.InvoiceGrid = true;
          $scope.InvoiceForm = false;
          $scope.InvoiceFormback = false;
          $scope.InvoiceSelect = true;
          $scope.PurchaseInvoicegrid = true;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      } else {

        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/purchaseinvoice/add",
          data: {
            POID: $scope.POID,
            SupplierID: $scope.vm.SupplierID,
            Description: $scope.vm.Description,
            VoucherNumber: $scope.vm.VoucherNumber,
            VoucherDate: $scope.vm.VoucherDate,
            InvoiceNumber: $scope.vm.InvoiceNumber,
            Date: $scope.vm.Date,
            Amount: $scope.vm.Amount,
            OutStandingAmount: OutStandingAmount,
            InvoiceAmount: InvoiceAmount,
            GSTAmount: GSTAmount,
            GSTID: $scope.vm.GSTID,
            ReceivedBy: $scope.vm.ReceivedBy,
            ReceivedDate: $scope.vm.ReceivedDate,
            Remarks: $scope.vm.Remarks,
            Status: "New",
            StatusID: "1",
            Client_Id: Client_Id,
            CreatedBy: $rootScope.createdby
          },
        });

        response.then(function (GList) {

          $scope.LogID = GList.data.data.id;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/logdetails/add",
            data: {
              RequestID: $scope.LogID,
              TypeName: "Accounts Purchase Invoice",
              Action: "New",
              ActionedBy: $rootScope.createdby,
            },
          });

          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshInvoice();
          GetTotalCurrentYearInvoices();
          $mdDialog.hide();
          $scope.InvoiceGrid = true;
          $scope.InvoiceForm = false;
          $scope.InvoiceFormback = false;
          $scope.InvoiceSelect = true;
          $scope.PurchaseInvoicegrid = true;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      }
    }

    function LoadDeafaultEmployee() {

      try {
        var item1 = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === LoggedEmployeeID;
        })[0];
        $scope.vm.ReceivedBy = item1.EmployeeName;
      } catch (error) { }
    }

    $scope.OnInvoiceDateChange = function () {

      $scope.vm.VoucherDate = $scope.vm.Date;
    }
    $scope.Invoiceinfo = function (e, InvoiceID) {

      $scope.InvoiceID = InvoiceID;

      var Array = $scope.Purchaseinvoicedatas;
      var item = Array.filter(function (item) {
        return item._id === InvoiceID;
      })[0];

      $scope.id = item._id;
      $scope.Status = item.Status;
      $scope.StatusID = parseInt(item.StatusID);

      if ($scope.Status != "New" && $scope.StatusID != "1") {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.querySelector('#popupContainer')))
            .clickOutsideToClose(true)
            .title('Alert')
            .textContent('Access Denied')
            .ariaLabel('Alert Dialog Demo')
            .ok('OK')
        );
      } else {
        $scope.Update = true;


        var value = $scope.Purchaseinvoicedatas.filter(function (item) {
          return item._id === InvoiceID;
        })[0];
        $scope.id = value._id;
        $scope.vm.POID = value.POID;
        $scope.vm.GSTID = value.GSTID;
        $scope.vm.Description = value.Description;
        $scope.vm.VoucherNumber = value.VoucherNumber;
        $scope.vm.VoucherDate = new Date(value.VoucherDate);
        $scope.vm.InvoiceNumber = value.InvoiceNumber;
        $scope.vm.Date = new Date(value.Date);
        $scope.vm.Amount = parseFloat(value.Amount);
        $scope.vm.ReceivedDate = new Date(value.ReceivedDate);
        $scope.vm.Remarks = value.Remarks;
        $scope.vm.ReceivedBy = value.ReceivedBy;
        $scope.Status = value.Status;
        $scope.StatusID = parseInt(value.StatusID);
        $scope.vm.SupplierID = value.SupplierID;
        if (value.POID != null && value.POID != "" && value.POID != undefined) {
          var array = value.POID.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({
              ReferenceNo: value
            });
          });
          $scope.vm.POID = array1;
        }

        if ($scope.Status == "New" && $scope.StatusID == "1") {
          $scope.CancelPI = true;
        }
        $scope.InvoiceGrid = false;
        $scope.InvoiceForm = true;
        $scope.InvoiceFormback = true;
        $scope.InvoiceSelect = false;
        $scope.PurchaseInvoicegrid = false;
        // $mdDialog.show({
        //     templateUrl: 'app/main/apps/accounts/purchasespayables/invoice.html',
        //     parent: angular.element($document.body),
        //     targetEvent: e,
        //     scope: $scope.$new(),
        //     clickOutsideToClose: true,
        //     controller: function generalsettingcontroller($scope, $mdDialog) {
        //         $scope.closeDialog = function () {
        //             $mdDialog.hide();
        //         }
        //     }
        // });


      }

    }

    $scope.ViewPurchaseinvoiceinfo = function (PIReqId) {


      $scope.SID = PIReqId;

      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = true;
      $scope.CancelPI = false;
      $scope.Update = true;
      $scope.NextApprovers = '';
      $scope.ShowWorkflowButton = false;
      $scope.NextLevelShowRejectButton = false;
      $scope.NextLevelShowCancelButton = false;
      $scope.NextLevelShowReviseButton = false;
      $scope.Actioned = '';
      $scope.NextLevelAction = '';
      $scope.Payment = true;

      var Purchaseinvoicearray = $scope.Purchaseinvoicedatas;
      var item = Purchaseinvoicearray.filter(function (item) {
        return item._id === PIReqId;
      })[0];

      $scope.id = item._id;
      $scope.POID = item.POID;
      $scope.SupplierID = item.SupplierID;
      $scope.Description = item.Description;
      $scope.VoucherNumber = item.VoucherNumber;
      $scope.VoucherDate = new Date(item.VoucherDate);
      $scope.InvoiceNumber = item.InvoiceNumber;
      $scope.Date = new Date(item.Date);
      $scope.Amount = parseFloat(item.Amount);
      $scope.ReceivedDate = new Date(item.ReceivedDate);
      $scope.Remarks = item.Remarks;
      $scope.ReceivedBy = item.ReceivedBy;
      $scope.Status = item.Status;
      $scope.StatusID = parseInt(item.StatusID);



      Purchaseorderproducts(item.POID);

      // var myArray = $scope.Purchaseorderdatas;
      // var item1 = myArray.filter(function (item1) {
      //     return item1._id === $scope.POID;
      // })[0];
      $scope.POrderID = $scope.POID;

      angular.forEach($scope.Workflowdatas, function (value) {
        if (value.TypeName == 'Accounts Purchase Invoice') {

          if ($scope.StatusID == value.LevelName) {

            $scope.TypeName = value.TypeName;
            $scope.LevelName = value.LevelName;
            $scope.Action = value.Action;
            $scope.Actioned = value.Actioned;
            $scope.ShowCancelButton = value.ShowCancelButton;
            $scope.ShowRejectButton = value.ShowRejectButton;
            $scope.ShowReviseButton = value.ShowReviseButton;
            $scope.NextLevel = value.NextLevel;
            $scope.Approvers = value.Approvers;
            $scope.Mandatory = value.Mandatory;
            $scope.EmailNotification = value.EmailNotification;
            $scope.NotifyTo = value.NotifyTo;
            $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
            $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
            $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
            $scope.EmailExceptions = value.EmailExceptions;
            $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
          }
          if ($scope.NextLevel == value.LevelName) {

            $scope.NextLevelTypeName = value.TypeName;
            $scope.NextLevelLevelName = value.LevelName;
            $scope.NextLevelAction = value.Action;
            $scope.NextLevelActioned = value.Actioned;
            $scope.NextLevelShowCancelButton = value.ShowCancelButton;
            $scope.NextLevelShowRejectButton = value.ShowRejectButton;
            $scope.NextLevelShowReviseButton = value.ShowReviseButton;
            $scope.AfterNextLevel = value.NextLevel;
            $scope.NextLevelApprovers = value.Approvers;
            $scope.NextLevelMandatory = value.Mandatory;
            $scope.NextLevelEmailNotification = value.EmailNotification;
            $scope.NextLevelNotifyTo = value.NotifyTo;
            $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
            $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
            $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
            $scope.NextLevelEmailExceptions = value.EmailExceptions;
            $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
          }
        }
      });
      $scope.LoginedUser = localStorage.getItem('UserName');
      $scope.LoginID = localStorage.getItem('LoginID');

      if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {

        var array = $scope.NextLevelApprovers.split(",");

        for (var y = 0; y < array.length; y++) {
          if ($scope.LoginID == array[y]) {
            $scope.NextApprovers = array[y];
          }
        }
      }

      angular.forEach($scope.Workflowdatas, function (wvalue) {
        if (wvalue.TypeName == 'Accounts Purchase Invoice') {

          if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {

            $scope.NextLevelAction = wvalue.Action;
            $scope.ShowWorkflowButton = true;
            $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
            $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
            $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
          } else if ($scope.LoginID != $scope.NextApprovers) {
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
          }
        }
      });

      if ($scope.StatusID == "0") {

        $scope.ShowWorkflowButton = false;
        $scope.NextLevelShowRejectButton = false;
        $scope.NextLevelShowCancelButton = false;
        $scope.NextLevelShowReviseButton = false;
        $scope.Actioned = $scope.Status;
        $scope.NextLevelAction = '';
      }


      RefreshLogdetails();
      RefreshCommentGrid();
      RefreshAttachmentGrid();


    }

    $scope.workflow = function () {

      $scope.WID = $scope.id;

      if ($scope.NextLevel >= 2 && $scope.Update == true) {
        $scope.Update = true;

        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchaseinvoice/updateworkflow",
          data: {
            _id: $scope.WID,
            Status: $scope.NextLevelActioned,
            StatusID: $scope.NextLevelLevelName,

          },
        });
        response.then(function (GList) {


          $scope.LogID = GList.data.data.id;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/logdetails/add",
            data: {
              RequestID: $scope.id,
              TypeName: "Accounts Purchase Invoice",
              Action: $scope.NextLevelActioned,
              ActionedBy: $rootScope.createdby,
            },
          });

          if ($scope.NextLevelActioned == "Approved") {
            $scope.PaysupplierData(GList.data.data);
            RefreshPaysupplier();
          }

          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

          RefreshInvoice();
          $scope.PurchaseInvoiceShowgrid();

        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }

    }

    $scope.PaySupplierItemInfo = function (ItemID) {


      $scope.ItemID = ItemID;
      var item = $scope.PaySuppliersItemDetails.filter(function (item) {
        return item._id === ItemID;
      })[0];

      $scope.vm.ItemAmount = parseFloat(item.Amount.toFixed(2));
      $scope.vm.ItemAccountID = item.AccountID;

      $scope.HideAdd = false;
      $scope.HideSave = true;
    }

    $scope.getTotal = function (itemDetails) {
      var total = 0;

      if (itemDetails != undefined) {
        angular.forEach(itemDetails, function (value) {
          total = total + value.Amount;
        });

        return total.toFixed(2);
      } else {
        0
      }
    }
    $scope.getAccountCode = function (itemDetails) {

      if (itemDetails != undefined) {
        var AccountCode = itemDetails.map(function (obj) {
          return obj.AccountCode;
        }).join(',');
        return AccountCode;
      } else {
        return null;
      }
    }

    $scope.getGSTCode = function (itemDetails) {

      if (itemDetails != undefined) {
        var GSTCode = itemDetails.map(function (obj) {
          return obj.GSTCode;
        }).join(',');
        return GSTCode;
      } else {
        return null;
      }
    }
    $scope.getInvoiceNumber = function (itemDetails) {

      if (itemDetails != undefined) {
        var InvoiceNumber = itemDetails.map(function (obj) {
          return obj.InvoiceNumber;
        }).join(',');
        return InvoiceNumber;
      } else {
        return null;
      }
    }


    $scope.PaysupplierData = function (data) {


      $scope.itemDetails = [];
      var info = $scope.Paysupplierdatas.length + 1;
      var y = pad(info, 6);
      var VR = "PSV" + new Date().getFullYear().toString().substr(-2);
      var VoucherNumber = VR + y;


      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item.AccountCode === "2004";
      })[0];

      var AccountID = item._id;
      var AccountDescription = item.AccountDescription;

      $scope.itemDetails.push({
        "Amount": data.InvoiceAmount,
        "InvoiceNumber": data.InvoiceNumber,
        "AccountID": AccountID,
        "AccountCode": "2004",
        "AccountDescription": AccountDescription
      })



      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/paysupplier/add",
        data: {
          VoucherNumber: VoucherNumber,
          InvoiceNo: $scope.WID,
          Client_Id: Client_Id,
          SupplierID: $scope.SupplierID,
          AccountID: null,
          BankID: null,
          Date: $scope.Date,
          Amount: data.InvoiceAmount,
          PaymentMode: null,
          CreatedBy: $rootScope.createdby,
          itemDetails: $scope.itemDetails
        },
      });

    }

    $scope.reject = function () {

      $scope.WID = $scope.id;

      if ($scope.NextLevel >= 2 && $scope.Update == true) {
        $scope.Update = true;

        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchaseinvoice/update",
          data: {
            _id: $scope.WID,
            Status: "Rejected",
            StatusID: "0",
          },
        });
        response.then(function (GList) {


          $scope.LogID = GList.data.data.id;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/logdetails/add",
            data: {
              RequestID: $scope.id,
              TypeName: "Accounts Purchase Invoice",
              Action: "Rejected",
              ActionedBy: $rootScope.createdby,
            },
          });

          $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));

          RefreshInvoice();
          $scope.PurchaseInvoiceShowgrid();

        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }

    }

    $scope.revise = function () {

      $scope.WID = $scope.id;

      if ($scope.LevelName != 1 && $scope.StatusID != 1 && $scope.Update == true) {
        //if ($scope.NextLevel >= 2 && $scope.Update == true) {
        $scope.Update = true;

        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchaseinvoice/update",
          data: {
            _id: $scope.WID,
            Status: $scope.NextLevelActioned,
            StatusID: $scope.NextLevelLevelName,
          },
        });
        response.then(function (GList) {


          $scope.LogID = GList.data.data.id;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/logdetails/add",
            data: {
              RequestID: $scope.id,
              TypeName: "Accounts Purchase Invoice",
              Action: $scope.NextLevelActioned,
              ActionedBy: $rootScope.createdby,
            },
          });

          $mdToast.show($mdToast.simple().textContent('Successfully Revised!').position('top center'));

          RefreshInvoice();
          $scope.PurchaseInvoiceShowgrid();

        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }

    }

    $scope.cancelpurchaseinvoice = function () {

      $scope.WID = $scope.id;

      if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
        $scope.Update = true;

        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchaseinvoice/update",
          data: {
            _id: $scope.WID,
            Status: "Cancelled",
            StatusID: "0",
          },
        });
        response.then(function (GList) {


          $scope.LogID = GList.data.data.id;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/logdetails/add",
            data: {
              RequestID: $scope.id,
              TypeName: "Accounts Purchase Invoice",
              Action: "Cancelled",
              ActionedBy: $rootScope.createdby,
            },
          });

          $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));

          RefreshInvoice();
          $scope.PurchaseInvoiceShowgrid();
          $mdDialog.hide();

        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      }

    }

    $scope.commentSubmit = function () {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/comment/add",
        data: {
          TableRowID: $scope.id,
          TableName: "Accounts Purchase Invoice",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Comments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {

        RefreshCommentGrid();
        $scope.vm.Comments = null;
        $scope.PurchaseInvoice.$setPristine();
        $scope.PurchaseInvoice.$setUntouched();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.PaySupplierCommentSubmit = function () {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/comment/add",
        data: {
          TableRowID: $scope.PaySupplierID,
          TableName: "Accounts PaySupplier",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.PaySupplierComments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true",
        },
      });
      response.then(function (GList) {

        RefreshPaySupplierCommentGrid();
        $scope.vm.PaySupplierComments = null;
        $scope.PaySupplier.$setPristine();
        $scope.PaySupplier.$setUntouched();
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.Uploadfiles = function (file) {
      var file = file[0].file

      var response = Upload.upload({
        url: $rootScope.WebURL + "/purchaseinvoice/upload",
        data: {
          file: file
        }
      }).then(function (resp) {

        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID,
              TableName: "Purchase Invoice",
              FileID: $scope.id,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize,
              FileType: $scope.fileType,
              ModuleID: $scope.Path,
              Data: null,
              IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            RefreshAttachmentGrid();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }

      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

      });
    }

    $scope.PurchaseInvoiceShowgrid = function () {

      $scope.PurchaseInvoicegrid = true;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
    }

    $scope.PaySupplierShowgrid = function () {

      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = true;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
    }

    $scope.CreditnoteShowgrid = function () {

      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = true;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
    }

    $scope.DebitnoteShowgrid = function () {

      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = true;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
    }

    function RefreshInvoice() {
      var response = $http({
        url: $rootScope.WebURL + "/purchaseinvoice/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (purchaseinvoicedata) {

        $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;
      });
    }

    function ClearInvoice() {
      $scope.vm.POID = null;
      $scope.vm.Description = null;
      $scope.vm.InvoiceNumber = null;
      $scope.vm.Date = null;
      $scope.vm.Amount = null;
      $scope.vm.ReceivedDate = null;
      $scope.vm.ReceivedBy = null;
      $scope.CancelPI = false;
      $scope.vm.Remarks = null;
      $scope.vm.VoucherNumber = null;
      $scope.vm.VoucherDate = null;
      $scope.vm.GSTID = null;
      $scope.vm.SupplierID = null;
    }

    function RefreshCommentGrid() {

      var response = $http({
        url: $rootScope.WebURL + "/comment/getByRequestID",
        method: "POST",
        data: {
          RequestID: $scope.id
        },
      });
      response.then(function (commentdata) {
        $scope.Commentdatas = commentdata.data.data;
      });
    }

    function RefreshPaySupplierCommentGrid() {

      var response = $http({
        url: $rootScope.WebURL + "/comment/getByRequestID",
        method: "POST",
        data: {
          RequestID: $scope.PaySupplierID
        },
      });
      response.then(function (commentdata) {
        $scope.PaySupplierCommentdatas = commentdata.data.data;
      });
    }

    function RefreshAttachmentGrid() {

      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: {
          FileID: $scope.id
        },
      });
      response.then(function (attachmentdata) {

        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }

    function RefreshLogdetails() {

      var response = $http({
        url: $rootScope.WebURL + "/logdetails/getByRequestID",
        method: "POST",
        data: {
          RequestID: $scope.id
        },
      });
      response.then(function (Logdetailsdata) {

        $scope.Logdetailsdatas = Logdetailsdata.data.data;
      });
    }

    $scope.InvoiceFilter = function () {
      $scope.Purchaseinvoicedatas = undefined;
      var response = $http({
        url: $rootScope.WebURL + "/purchaseinvoice/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (purchaseinvoicedata) {

        $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;
      });
    }

    var response = $http({
      url: $rootScope.WebURL + "/purchaseinvoice/datefilter",
      method: "POST",
      data: {
        Start_Date: $scope.uFrom,
        End_Date: $scope.uTo,
        Client_Id: Client_Id
      },
    });
    response.then(function (purchaseinvoicedata) {

      $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;
    });

    var response = $http({
      method: "POST",
      url: $rootScope.WebURL + "/Workflow",
      data: {
        Client_Id: Client_Id
      },
    });
    response.then(function (Workflowdata) {
      $scope.Workflowdatas = Workflowdata.data.data;
    });


    $scope.PaysupplierTab = function () {
      RefreshPaysupplier();
      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = true;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
      $scope.SearchValue = "";
      $scope.InvoiceGrid = false;
      $scope.InvoiceForm = false;
      $scope.InvoiceFormback = false;
    };

    $scope.ChequeNumberField = function () {

      if ($scope.vm.PaymentMode == "Cheque") {
        $scope.ShowChequeNumberField = true;
      } else {
        $scope.ShowChequeNumberField = false;
      }

    }

    $scope.Paysupplieradd = function (e) {
      ClearPaysupplier();
      $scope.Update = false;
      $scope.ShowChequeNumberField = false;
      $mdDialog.show({
        templateUrl: 'app/main/apps/accounts/purchasespayables/paysupplier.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function bankcashcontroller($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });
    }

    $scope.SavePaysupplier = function () {


      if ($scope.vm.PaymentMode == "Cheque") {
        $scope.vm.ChequeNumber = $scope.vm.ChequeNumber;
      } else {
        $scope.vm.ChequeNumber = '';
      }

      var myArray1 = $scope.Purchaseinvoicedatas;
      var item1 = myArray1.filter(function (item1) {
        return item1._id === $scope.vm.InvoiceNo;
      })[0];

      $scope.InvoiceNumber = item1.InvoiceNumber;
      var OutStandingAmount = 0;
      var InvoiceStatus = "Paid";

      if (parseFloat($scope.vm.Amount) < parseFloat(item1.InvoiceAmount)) {
        OutStandingAmount = parseFloat(item1.InvoiceAmount) - parseFloat($scope.vm.Amount);
        InvoiceStatus = "Partially Paid";
      }


      if (!$scope.vm.BankID.length > 2) {
        $scope.vm.BankID = undefined;
      }

      if ($scope.Update == true) {
        $scope.Update = true;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/paysupplier/update",
          data: {
            _id: $scope.PaySupplierID,
            BankID: $scope.vm.BankID,
            VoucherNumber: $scope.vm.VoucherNumber,
            InvoiceNumber: $scope.InvoiceNumber,
            InvoiceID: $scope.vm.InvoiceNo,
            VoucherDate: $scope.vm.VoucherDate,
            PaymentMode: $scope.vm.PaymentMode,
            ChequeNumber: $scope.vm.ChequeNumber,
            Remarks: $scope.vm.Remarks,
            Date: $scope.vm.Date,
            Amount: $scope.vm.Amount,
            OutStandingAmount: OutStandingAmount,
            InvoiceStatus: InvoiceStatus,
            UpdatedBy: $rootScope.createdby
          },
        });
        response.then(function (GList) {

          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshPaysupplier();
          $scope.PaySupplierShowgrid();
          RefreshInvoice();
          $mdDialog.hide();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      } else {


        var info = $scope.vm.InvoiceNo;

        for (var i = 0; i < info.length; i++) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/paysupplier/add",
            data: {
              SupplierID: $scope.vm.SupplierID,
              BankID: $scope.vm.BankID,
              AccountID: $scope.vm.AccountID,
              Client_Id: Client_Id,
              InvoiceNo: info[i]._id,
              PaymentMode: $scope.vm.PaymentMode,
              ChequeNumber: $scope.vm.ChequeNumber,
              VoucherNumber: $scope.vm.VoucherNumber,
              VoucherDate: $scope.vm.VoucherDate,
              Remarks: $scope.vm.Remarks,
              Date: $scope.vm.Date,
              Amount: $scope.vm.Amount,
              CreatedBy: $rootScope.createdby
            },
          });
        }
        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshPaysupplier();
          $scope.PaySupplierShowgrid();
          RefreshInvoice();
          $mdDialog.hide();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      }
    }

    $scope.Paysupplierinfo = function (e, PaySupplierID) {

      $scope.PaySupplierID = PaySupplierID;
      $scope.Update = true;
      $scope.ShowChequeNumberField = false;

      $scope.HideAdd = true;
      $scope.HideSave = false;

      angular.forEach($scope.Paysupplierdatas, function (value, key) {
        if (PaySupplierID == value._id) {

          $scope.vm.SupplierID = value.SupplierID;
          $scope.vm.BankID = value.BankID;
          $scope.vm.AccountID = value.AccountID;
          $scope.vm.InvoiceNo = value.InvoiceNo;
          $scope.vm.VoucherNumber = value.VoucherNumber;
          $scope.vm.VoucherDate = new Date(value.VoucherDate);
          $scope.vm.PaymentMode = value.PaymentMode;
          $scope.vm.ChequeNumber = value.ChequeNumber;
          $scope.vm.Remarks = value.Remarks;
          $scope.vm.Date = new Date(value.Date);
          $scope.vm.Amount = parseFloat(value.Amount);

          $scope.PaySuppliersItemDetails = value.itemDetails;
        }
      });
      try {
        var myArray1 = $scope.Purchaseinvoicedatas;
        var item1 = myArray1.filter(function (item1) {
          return item1._id === $scope.vm.InvoiceNo;
        })[0];
        $scope.InvoiceNumber = item1.InvoiceNumber;
        $scope.InvoiceDate = convertDate(item1.Date);
      } catch (error) {

      }

      try {
        var myArray2 = $scope.Supplierdatas;
        var item2 = myArray2.filter(function (item2) {
          return item2.id === $scope.vm.SupplierID;
        })[0];
        $scope.SupplierName = item2.ReferenceNo + '-' + item2.Name;
      } catch (error) {

      }


      if ($scope.vm.PaymentMode != "Cheque" || $scope.vm.PaymentMode == null) {
        $scope.ShowChequeNumberField = false;
      } else {
        $scope.ShowChequeNumberField = true;
      }

      $mdDialog.show({
        templateUrl: 'app/main/apps/accounts/purchasespayables/Editpaysupplier.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function generalsettingcontroller($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
        }
      });


    }

    $scope.ClearPaySupplierItems = function () {
      $scope.vm.ItemAmount = null;
      $scope.vm.ItemAccountID = null;
    }

    $scope.PaySupplierItemSubmit = function () {

      $scope.itemDetails = [];

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.vm.ItemAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      $scope.itemDetails.push({
        "Amount": $scope.vm.ItemAmount,
        "InvoiceNumber": $scope.vm.InvoiceNo,
        "AccountID": $scope.vm.ItemAccountID,
        "AccountCode": AccountCode,
        "AccountDescription": AccountDescription
      })


      var TransactionDescription = "";
      try {
        var myArray2 = $scope.Supplierdatas;
        var item2 = myArray2.filter(function (item2) {
          return item2.id === $scope.vm.SupplierID;
        })[0];
        TransactionDescription = item2.ReferenceNo + '-' + item2.Name;
      } catch (error) {

      }
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/paysupplier/addItems",
        data: {
          _id: $scope.PaySupplierID,
          itemDetails: $scope.itemDetails,
          Client_Id: Client_Id,
          TransactionDescription: TransactionDescription,
          VoucherNumber: $scope.vm.VoucherNumber,
          SupplierID: $scope.vm.SupplierID,
          InvoiceID: $scope.vm.InvoiceNo,
          Amount: $scope.vm.ItemAmount,
          Date: $scope.vm.Date,
          CreatedBy: $rootScope.createdby
        },
      })
      response.then(function (GList) {

        $scope.vm.ItemAmount = null;
        $scope.vm.ItemAccountID = null;
        $scope.PaySuppliersItemDetails.push(GList.config.data.itemDetails[0]);

        $scope.HideAdd = true;
        $scope.HideSave = false;
        RefreshInvoice();
      });


    }

    $scope.PaySupplierItemUpdate = function () {

      var ID = $scope.ItemID;

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.vm.ItemAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      debugger

      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/paysupplier/UpdateItem",
        data: {
          PaySupplierID: $scope.PaySupplierID,
          ItemID: $scope.ItemID,
          Amount: vm.ItemAmount,
          AccountID: vm.ItemAccountID,
          AccountCode: AccountCode,
          AccountDescription: AccountDescription,
          InvoiceID: $scope.vm.InvoiceNo
        },
      })
      response.then(function (GList) {
        debugger
        $scope.vm.ItemAmount = null;
        $scope.vm.ItemAccountID = null;

        $scope.HideAdd = true;
        $scope.HideSave = false;

        try {

          $scope.PaySuppliersItemDetails = GList.data.data.itemDetails;
        } catch (error) {

        }

        RefreshInvoice();
      });
    }


    function convertDate(inputFormat) {
      function pad(s) {
        return (s < 10) ? '0' + s : s;
      }
      var d = new Date(inputFormat);
      return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
    }

    $scope.ViewPaysupplierinfo = function (PaySupplierID) {
      $scope.InvoiceNumber = '';
      $scope.InvoiceDate = '';
      $scope.SupplierName = '';
      $scope.PaymentMode = '';
      $scope.ChequeNumber = '';
      $scope.BankName = '';
      $scope.AccountCode = '';
      $scope.AccountDescription = '';
      $scope.Amount = '';
      $scope.Date = '';

      $scope.PaySupplierID = PaySupplierID;

      $scope.Update = true;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = true;

      angular.forEach($scope.Paysupplierdatas, function (value, key) {
        if (PaySupplierID == value._id) {
          $scope.id = value._id;
          $scope.vm.SupplierID = value.SupplierID;
          $scope.vm.BankID = value.BankID;
          $scope.vm.AccountID = value.AccountID;
          $scope.vm.InvoiceNo = value.InvoiceNo;
          $scope.vm.VoucherNumber = value.VoucherNumber;
          $scope.vm.VoucherDate = new Date(value.VoucherDate);

          $scope.PaymentMode = value.PaymentMode;
          $scope.vm.ChequeNumber = value.ChequeNumber;
          if ($scope.vm.ChequeNumber == "" || $scope.vm.ChequeNumber == "undefined" || $scope.vm.ChequeNumber == null) {
            $scope.vm.ChequeNumber = value.ChequeNumber;
          } else {
            $scope.vm.ChequeNumber = parseInt(value.ChequeNumber);
          }
          $scope.ChequeNumber = $scope.vm.ChequeNumber;
          $scope.Remarks = value.Remarks;
          $scope.Date = new Date(value.Date);
          $scope.Amount = parseFloat(value.Amount);

          $scope.PaySuppliersItemDetails = value.itemDetails;
        }
      });

      angular.forEach($scope.Purchaseinvoicedatas, function (value1) {
        if ($scope.vm.InvoiceNo == value1._id) {
          $scope.InvoiceNumber = value1.InvoiceNumber;
          $scope.InvoiceDate = new Date(value1.Date);
        }
      });

      angular.forEach($scope.Supplierdatas, function (value2) {

        if ($scope.vm.SupplierID == value2.id) {

          $scope.SupplierName = value2.ReferenceNo + '-' + value2.Name;
        }
      });

      angular.forEach($scope.Bankdatas, function (value3) {
        if ($scope.vm.BankID == value3.id) {
          $scope.BankName = value3.BankName;
        }
      });

      angular.forEach($scope.ChartofAccountatas, function (value4) {
        if ($scope.vm.AccountID == value4.id) {
          $scope.AccountCode = value4.AccountCode;
          $scope.AccountDescription = value4.AccountDescription;
        }
      });



      RefreshPaySupplierAttachmentGrid();

      RefreshPaySupplierCommentGrid();
    }

    $scope.PaysupplierUploadfiles = function (file) {

      var file = file[0].file

      var response = Upload.upload({
        url: $rootScope.WebURL + "/paysupplier/upload",
        data: {
          file: file
        }
      }).then(function (resp) {

        $scope.TableID = resp.data.data[0].GUIDFILENAME
        $scope.fileName = resp.data.data[0].OriginalFileName
        $scope.fileSize = resp.data.data[0].Size
        $scope.Path = resp.data.data[0].Path
        $scope.fileType = resp.data.data[0].Type
        if (resp.data.message == "Successfully Uploaded") {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/attachment/add",
            data: {
              TableID: $scope.TableID,
              TableName: "Pay Supplier",
              FileID: $scope.id,
              FileName: $scope.fileName,
              FileSize: $scope.fileSize,
              FileType: $scope.fileType,
              ModuleID: $scope.Path,
              Data: null,
              IsActive: "true",
              CreatedBy: $rootScope.createdby,
            },
          });
          response.then(function (GList) {
            RefreshPaySupplierAttachmentGrid();
            $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          }, function () {
            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
          });
        }

      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

      });
    }

    function RefreshPaySupplierAttachmentGrid() {

      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: {
          FileID: $scope.id
        },
      });
      response.then(function (PaySupplierattachmentdata) {

        $scope.PaySupplierAttachmentdatas = PaySupplierattachmentdata.data.data;
      });
    }

    $scope.InvoicefilterBySupplier = function () {


      $scope.vm.InvoiceNo = null;
      var SupplierID = $scope.vm.SupplierID;
      var FromDate = $scope.vm.uFrom;
      var ToDate = $scope.vm.uTo;


      var response = $http({
        url: $rootScope.WebURL + "/purchaseinvoice/filterBySupplier",
        method: "POST",
        data: {
          Start_Date: FromDate,
          End_Date: ToDate,
          SupplierID: SupplierID
        },
      });
      response.then(function (purchaseinvoicedata) {

        $scope.Purchaseinvoicedatasdd = purchaseinvoicedata.data.data;
      });


    };

    $scope.InvoicefilterBySupplierform = function () {


      $scope.vm.InvoiceNo = null;
      var SupplierID = $scope.vm.SupplierID;
      var FromDate = $scope.uFrom;
      var ToDate = $scope.uTo;


      var response = $http({
        url: $rootScope.WebURL + "/purchaseinvoice/filterBySupplier",
        method: "POST",
        data: {
          Start_Date: FromDate,
          End_Date: ToDate,
          SupplierID: SupplierID
        },
      });
      response.then(function (purchaseinvoicedata) {

        $scope.Purchaseinvoicedatasddf = purchaseinvoicedata.data.data;
      });


    };

    $scope.InvoiceExport = function () {
      alasql('SELECT * INTO XLSX("PurchaseInvoice.xlsx",{headers:true}) FROM ?', [$scope.Purchaseinvoicedatas]);
    };

    $scope.PaysupplierExport = function () {
      alasql('SELECT * INTO XLSX("Paysupplier.xlsx",{headers:true}) FROM ?', [$scope.Paysupplierdatas]);
    };


    function RefreshPaysupplier() {

      $scope.Paysupplierdatas = undefined;
      var response = $http({
        url: $rootScope.WebURL + "/paysupplier/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (paysupplierdata) {
        $scope.Paysupplierdatas = paysupplierdata.data.data;
      });

    }

    $scope.PaysupplierFilter = function () {
      $scope.Paysupplierdatas = undefined;
      var response = $http({
        url: $rootScope.WebURL + "/paysupplier/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (paysupplierdata) {
        $scope.Paysupplierdatas = paysupplierdata.data.data;
      });
    }

    function ClearPaysupplier() {
      $scope.vm.SupplierID = null;
      $scope.vm.BankID = null;
      $scope.vm.AccountID = null;
      $scope.vm.Date = null;
      $scope.vm.Amount = null;
      $scope.vm.InvoiceNo = null;
      $scope.vm.PaymentMode = null;
      $scope.vm.ChequeNumber = null;
      $scope.vm.Remarks = null;
      $scope.vm.VoucherNumber = null;
      $scope.vm.VoucherDate = null;
    }


    GetTotalCurrentYearCreditnotes();

    function GetTotalCurrentYearCreditnotes() {

      var firstDay = new Date(new Date().getFullYear(), 0, 1);
      firstDay.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/purchasecreditnote/getTotalInvoicesByYear",
        method: "POST",
        data: {
          Start_Date: firstDay,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (salesinvoicedata) {
        debugger
        if (salesinvoicedata.data.data.length > 0) {

          $scope.TotalCurrentYearCreditnotes = salesinvoicedata.data.data[0].Total;
        } else {
          $scope.TotalCurrentYearCreditnotes = 0
        }


      });
    }

    $scope.Creditnoteadd = function (e) {

      ClearDebitnote()
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = true;

      $scope.CreditnoteSelect = false;
      $scope.HideAdd = true;
      $scope.HideSave = false;


      var info = $scope.TotalCurrentYearCreditnotes + 1;
      var y = pad(info, 6);
      var VR = "CNPV" + new Date().getFullYear().toString().substr(-2);
      $scope.VoucherNumber = VR + y;

      var VR = "CNP" + new Date().getFullYear().toString().substr(-2);
      $scope.CreditNoteNumber = VR + y;

      $scope.Date = new Date();
      $scope.VoucherDate = new Date();

      $scope.Update = false;
      $scope.CNItemDetails = [];

    }

    function pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    $scope.SaveCreditnote = function () {

      debugger
      if ($scope.Update == true) {
        $scope.Update = true;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchasecreditnote/update",
          data: {
            _id: $scope.CreditnoteID,
            VoucherNumber: $scope.VoucherNumber,
            VoucherDate: $scope.VoucherDate,
            Description: $scope.Description,
            CreditNoteNumber: $scope.CreditNoteNumber,
            Date: $scope.Date,
            Remarks: $scope.Remarks,
            UpdatedBy: $rootScope.LoginID
          },
        });
        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshCreditnote();
          $scope.CreditnoteGrid = true;
          $scope.CreditnoteForm = false;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      } else {


        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/purchasecreditnote/add",
          data: {

            SupplierID: $scope.vm.SupplierID,
            Client_Id: Client_Id,
            VoucherNumber: $scope.VoucherNumber,
            VoucherDate: $scope.VoucherDate,
            Description: $scope.Description,
            CreditNoteNumber: $scope.CreditNoteNumber,
            Date: $scope.Date,
            Remarks: $scope.Remarks,
            CreatedBy: $rootScope.LoginID
          },
        });
        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshCreditnote();
          GetTotalCurrentYearCreditnotes();

          $scope.CreditnoteGrid = true;
          $scope.CreditnoteForm = false;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      }
    }

    $scope.Creditnoteinfo = function (CreditnoteID) {

      $scope.CreditnoteID = CreditnoteID;
      $scope.Update = true;

      $scope.DNInvoiceID = undefined;
      $scope.DNAmount = undefined;
      $scope.DNAccountID = undefined;
      $scope.DNGSTID = undefined;

      $scope.Purchaseinvoicedatasddf = $scope.Purchaseinvoicedatas;
      $scope.Update = true;

      $scope.HideAdd = true;
      $scope.HideSave = false;

      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = true;

      $scope.CreditnoteSelect = false;

      var value = $scope.Creditnotedatas.filter(function (item) {
        return item._id === CreditnoteID;
      })[0];


      $scope.Description = value.Description;
      $scope.VoucherNumber = value.VoucherNumber;
      $scope.VoucherDate = new Date(value.VoucherDate);
      $scope.Date = new Date(value.Date);
      $scope.vm.SupplierID = value.SupplierID;
      $scope.Remarks = value.Remarks;
      $scope.CreditNoteNumber = value.CreditNoteNumber;
      $scope.CNItemDetails = value.itemDetails;

    }


    $scope.ClearCNItems = function () {
      $scope.DNInvoiceID = undefined;
      $scope.DNAmount = undefined;
      $scope.DNAccountID = undefined;
      $scope.DNGSTID = undefined;

      $scope.HideAdd = true;
      $scope.HideSave = false;

    }

    $scope.CNItemSubmit = function () {


      var Status = "Adjust";
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/purchasecreditnote/add",
        data: {
          SupplierID: $scope.vm.SupplierID,
          Client_Id: Client_Id,
          VoucherNumber: $scope.VoucherNumber,
          VoucherDate: $scope.VoucherDate,
          Description: $scope.Description,
          CreditNoteNumber: $scope.CreditNoteNumber,
          Date: $scope.Date,
          Status: Status,
          Remarks: $scope.Remarks,
          CreatedBy: $rootScope.LoginID
        },
      });

      response.then(function (GList) {
        debugger
        if (GList.data.message == "Existing Purchase credit note") {


          var responses = $http({
            method: "POST",
            url: $rootScope.WebURL + "/purchasecreditnote/getByID",
            data: {
              VoucherNumber: $scope.VoucherNumber,
              Client_Id: Client_Id
            },
          });

          responses.then(function (GList) {
            $scope.CreditnoteID = GList.data.data[0]._id;
            SaveCNItems(GList.data.data[0]._id);
          })
        } else {
          $scope.CreditnoteID = GList.data.data.id;
          SaveCNItems(GList.data.data.id);
          GetTotalCurrentYearCreditnotes();
        }

      }, function () {


      });

    }


    $scope.CNItemUpdate = function () {
      debugger

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.DNAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      var gstitem = $scope.GSTdatas.filter(function (gstitem) {
        return gstitem._id === $scope.DNGSTID;
      })[0];

      var GSTCode = gstitem.GSTTaxCode

      var TaxRate = 0;
      if (gstitem.TaxRate != null) {
        TaxRate = gstitem.TaxRate;
      }
      $scope.PaidAmount = parseFloat($scope.DNAmount);
      $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
      $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));
      debugger
      var invitem = $scope.Purchaseinvoicedatasddf.filter(function (invitem) {
        return invitem._id === $scope.DNInvoiceID;
      })[0];

      var InvoiceNumber = invitem.InvoiceNumber;


      var responses = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/purchasecreditnote/UpdateItem",
        data: {
          CreditnoteID: $scope.CreditnoteID,
          ItemID: $scope.ItemID,
          AccountID: $scope.DNAccountID,
          AccountCode: AccountCode,
          AccountDescription: AccountDescription,
          Amount: $scope.DNAmount,
          TaxAmount: $scope.DNTaxAmount,
          GSTID: $scope.DNGSTID,
          GSTCode: GSTCode,
          InvoiceNumber: InvoiceNumber,
          InvoiceID: $scope.DNInvoiceID,
          VoucherNumber: $scope.VoucherNumber,
          PaidAmount: $scope.PaidAmount
        },
      });

      responses.then(function (GList) {

        $scope.DNInvoiceID = undefined;
        $scope.DNAmount = undefined;
        $scope.DNAccountID = undefined;
        $scope.DNGSTID = undefined;
        $scope.HideAdd = true;
        $scope.HideSave = false;

        if (GList.data.data != null) {
          $scope.CNItemDetails = GList.data.data.itemDetails;
        }


        RefreshInvoice();

      })

    }

    function SaveCNItems(DebitNoteID) {
      debugger

      $scope.itemDetails = [];

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.DNAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      var gstitem = $scope.GSTdatas.filter(function (gstitem) {
        return gstitem._id === $scope.DNGSTID;
      })[0];

      var GSTCode = gstitem.GSTTaxCode
      debugger

      var TaxRate = 0;
      if (gstitem.TaxRate != null) {
        TaxRate = gstitem.TaxRate;
      }

      $scope.PaidAmount = parseFloat($scope.DNAmount);
      $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
      $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

      var invitem = $scope.Purchaseinvoicedatasddf.filter(function (invitem) {
        return invitem._id === $scope.DNInvoiceID;
      })[0];

      var InvoiceNumber = invitem.InvoiceNumber;

      $scope.itemDetails.push({
        "Amount": $scope.DNAmount,
        "TaxAmount": $scope.DNTaxAmount,
        "InvoiceID": $scope.DNInvoiceID,
        "AccountID": $scope.DNAccountID,
        "AccountCode": AccountCode,
        "AccountDescription": AccountDescription,
        "GSTID": $scope.DNGSTID,
        "GSTCode": GSTCode,
        "InvoiceNumber": InvoiceNumber,
        "PaidAmount": $scope.PaidAmount
      })


      var TransactionDescription = "";
      try {
        var myArray2 = $scope.Supplierdatas;
        var item2 = myArray2.filter(function (item2) {
          return item2.id === $scope.vm.SupplierID;
        })[0];
        TransactionDescription = item2.ReferenceNo + '-' + item2.Name;
      } catch (error) {

      }

      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/purchasecreditnote/addItems",
        data: {
          _id: DebitNoteID,
          itemDetails: $scope.itemDetails,
          Client_Id: Client_Id,
          TransactionDescription: TransactionDescription,
          VoucherNumber: $scope.VoucherNumber,
          DebitNoteNumber: $scope.DebitNoteNumber,
          SupplierID: $scope.vm.SupplierID,
          InvoiceID: $scope.DNInvoiceID,
          Amount: $scope.DNAmount,
          Date: $scope.Date,
          CreatedBy: $rootScope.createdby
        },
      })
      response.then(function (GList) {


        $scope.DNInvoiceID = undefined;
        $scope.DNAmount = undefined;
        $scope.DNAccountID = undefined;
        $scope.DNGSTID = undefined;

        if ($scope.CNItemDetails != undefined) {
          $scope.CNItemDetails.push(GList.config.data.itemDetails[0]);
        }

        $scope.HideAdd = true;
        $scope.HideSave = false;

        var responses = $http({
          method: "POST",
          url: $rootScope.WebURL + "/purchasecreditnote/getByID",
          data: {
            VoucherNumber: $scope.VoucherNumber,
            Client_Id: Client_Id
          },
        });

        responses.then(function (GList) {
          debugger
          $scope.CNItemDetails = GList.data.data[0].itemDetails;
        })

        RefreshInvoice();

      });

    }

    $scope.CNItemInfo = function (ItemID) {


      $scope.ItemID = ItemID;
      var item = $scope.CNItemDetails.filter(function (item) {
        return item._id === ItemID;
      })[0];
      $scope.DNAmount = 0;
      if (item.Amount != null) {
        $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
        // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
      }


      $scope.DNInvoiceID = item.InvoiceID;
      $scope.DNAccountID = item.AccountID;
      $scope.DNGSTID = item.GSTID;

      $scope.HideAdd = false;
      $scope.HideSave = true;
    }


    $scope.Showgrid = function () {

      $scope.CreditnoteGrid = true;
      $scope.CreditnoteForm = false;
      $scope.CreditnoteSelect = true;
    }






    function RefreshCreditnote() {

      var response = $http({
        url: $rootScope.WebURL + "/purchasecreditnote/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (creditnotedata) {
        $scope.Creditnotedatas = creditnotedata.data.data;
      });
    }

    $scope.CreditnoteFilter = function () {

      var response = $http({
        url: $rootScope.WebURL + "/purchasecreditnote/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (creditnotedata) {
        $scope.Creditnotedatas = creditnotedata.data.data;
      });
    }

    function ClearCreditnote() {
      $scope.vm.InvoiceID = null;
      $scope.vm.InvoiceDate = null;
      $scope.vm.InvoiceAmount = null;
      $scope.vm.CreditNoteAmount = null;
      $scope.vm.RefrenceNo = null;
      $scope.vm.Description = null;
      $scope.vm.Remarks = null;
      $scope.VoucherNumber = null;
      $scope.VoucherDate = null;

      $scope.VoucherNumber = null;
      $scope.VoucherDate = null;
    }

    $scope.closeDialog = function () {
      $mdDialog.cancel();
    };


    GetTotalCurrentYearDebitnotes();

    function GetTotalCurrentYearDebitnotes() {

      var firstDay = new Date(new Date().getFullYear(), 0, 1);
      firstDay.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/purchasedebitnote/getTotalInvoicesByYear",
        method: "POST",
        data: {
          Start_Date: firstDay,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (salesinvoicedata) {
        debugger
        if (salesinvoicedata.data.data.length > 0) {

          $scope.TotalCurrentYearDebitnotes = salesinvoicedata.data.data[0].Total;
        } else {
          $scope.TotalCurrentYearDebitnotes = 0
        }


      });
    }


    $scope.Debitnoteadd = function (e) {

      ClearCreditnote();
      ClearDebitnote();
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = true;
      $scope.HideAdd = true;
      $scope.HideSave = false;
      $scope.DebitnoteSelect = false;

      var info = $scope.TotalCurrentYearDebitnotes + 1;
      var y = pad(info, 6);
      var VR = "DNPV" + new Date().getFullYear().toString().substr(-2);
      $scope.VoucherNumber = VR + y;

      var VR = "DNP" + new Date().getFullYear().toString().substr(-2);
      $scope.DebitNoteNumber = VR + y;

      $scope.Date = new Date();
      $scope.VoucherDate = new Date();

      $scope.DNItemDetails = [];
    }

    $scope.OnVoucherDateChange = function () {

      $scope.Date = $scope.VoucherDate;
    }

    $scope.ClearDNItems = function () {
      $scope.DNInvoiceID = undefined;
      $scope.DNAmount = undefined;
      $scope.DNAccountID = undefined;
      $scope.DNGSTID = undefined;

      $scope.HideAdd = true;
      $scope.HideSave = false;

    }

    $scope.DNItemSubmit = function () {


      var Status = "Adjust";
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/purchasedebitnote/add",
        data: {
          SupplierID: $scope.vm.SupplierID,
          Client_Id: Client_Id,
          VoucherNumber: $scope.VoucherNumber,
          VoucherDate: $scope.VoucherDate,
          Description: $scope.Description,
          DebitNoteNumber: $scope.DebitNoteNumber,
          Date: $scope.Date,
          Status: Status,
          Remarks: $scope.Remarks,
          CreatedBy: $rootScope.LoginID
        },
      });

      response.then(function (GList) {
        debugger
        if (GList.data.message == "Existing Purchase debit note") {


          var responses = $http({
            method: "POST",
            url: $rootScope.WebURL + "/purchasedebitnote/getByID",
            data: {
              VoucherNumber: $scope.VoucherNumber,
              Client_Id: Client_Id
            },
          });

          responses.then(function (GList) {
            $scope.DebitNoteID = GList.data.data[0]._id;
            $scope.DebitnoteID = GList.data.data[0]._id;
            SaveDNItems(GList.data.data[0]._id);
          })
        } else {
          $scope.DebitNoteID = GList.data.data.id;
          $scope.DebitnoteID = GList.data.data.id;
          SaveDNItems(GList.data.data.id);
          GetTotalCurrentYearDebitnotes();
        }

      }, function () {


      });

    }


    $scope.DNItemUpdate = function () {
      debugger

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.DNAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      var gstitem = $scope.GSTdatas.filter(function (gstitem) {
        return gstitem._id === $scope.DNGSTID;
      })[0];

      var GSTCode = gstitem.GSTTaxCode

      var TaxRate = 0;
      if (gstitem.TaxRate != null) {
        TaxRate = gstitem.TaxRate;
      }
      $scope.PaidAmount = parseFloat($scope.DNAmount);
      $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
      $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));
      debugger
      var invitem = $scope.Purchaseinvoicedatasddf.filter(function (invitem) {
        return invitem._id === $scope.DNInvoiceID;
      })[0];

      var InvoiceNumber = invitem.InvoiceNumber;


      var responses = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/purchasedebitnote/UpdateItem",
        data: {
          DebitNoteID: $scope.DebitnoteID,
          ItemID: $scope.ItemID,
          AccountID: $scope.DNAccountID,
          AccountCode: AccountCode,
          AccountDescription: AccountDescription,
          Amount: $scope.DNAmount,
          TaxAmount: $scope.DNTaxAmount,
          GSTID: $scope.DNGSTID,
          GSTCode: GSTCode,
          InvoiceNumber: InvoiceNumber,
          InvoiceID: $scope.DNInvoiceID,
          VoucherNumber: $scope.VoucherNumber,
          PaidAmount: $scope.PaidAmount
        },
      });

      responses.then(function (GList) {

        $scope.DNInvoiceID = undefined;
        $scope.DNAmount = undefined;
        $scope.DNAccountID = undefined;
        $scope.DNGSTID = undefined;
        $scope.HideAdd = true;
        $scope.HideSave = false;

        if (GList.data.data != null) {
          $scope.DNItemDetails = GList.data.data.itemDetails;
        }


        RefreshInvoice();

      })

    }

    function SaveDNItems(DebitNoteID) {


      $scope.itemDetails = [];

      var item = $scope.ChartofAccountatas.filter(function (item) {
        return item._id === $scope.DNAccountID;
      })[0];

      var AccountCode = item.AccountCode;
      var AccountDescription = item.AccountDescription;

      var gstitem = $scope.GSTdatas.filter(function (gstitem) {
        return gstitem._id === $scope.DNGSTID;
      })[0];

      var GSTCode = gstitem.GSTTaxCode
      debugger

      var TaxRate = 0;
      if (gstitem.TaxRate != null) {
        TaxRate = gstitem.TaxRate;
      }

      $scope.PaidAmount = parseFloat($scope.DNAmount);
      $scope.DNAmount = parseFloat($scope.DNAmount) + ((parseFloat($scope.DNAmount / 100) * parseFloat(TaxRate)));
      $scope.DNTaxAmount = ((parseFloat($scope.PaidAmount / 100) * parseFloat(TaxRate)));

      var invitem = $scope.Purchaseinvoicedatasddf.filter(function (invitem) {
        return invitem._id === $scope.DNInvoiceID;
      })[0];

      var InvoiceNumber = invitem.InvoiceNumber;

      $scope.itemDetails.push({
        "Amount": $scope.DNAmount,
        "TaxAmount": $scope.DNTaxAmount,
        "InvoiceID": $scope.DNInvoiceID,
        "AccountID": $scope.DNAccountID,
        "AccountCode": AccountCode,
        "AccountDescription": AccountDescription,
        "GSTID": $scope.DNGSTID,
        "GSTCode": GSTCode,
        "InvoiceNumber": InvoiceNumber,
        "PaidAmount": $scope.PaidAmount
      })


      var TransactionDescription = "";
      try {
        var myArray2 = $scope.Supplierdatas;
        var item2 = myArray2.filter(function (item2) {
          return item2.id === $scope.vm.SupplierID;
        })[0];
        TransactionDescription = item2.ReferenceNo + '-' + item2.Name;
      } catch (error) {

      }

      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/purchasedebitnote/addItems",
        data: {
          _id: DebitNoteID,
          itemDetails: $scope.itemDetails,
          Client_Id: Client_Id,
          TransactionDescription: TransactionDescription,
          VoucherNumber: $scope.VoucherNumber,
          DebitNoteNumber: $scope.DebitNoteNumber,
          SupplierID: $scope.vm.SupplierID,
          InvoiceID: $scope.DNInvoiceID,
          Amount: $scope.DNAmount,
          Date: $scope.Date,
          CreatedBy: $rootScope.createdby
        },
      })
      response.then(function (GList) {


        $scope.DNInvoiceID = undefined;
        $scope.DNAmount = undefined;
        $scope.DNAccountID = undefined;
        $scope.DNGSTID = undefined;

        if ($scope.DNItemDetails != undefined) {
          $scope.DNItemDetails.push(GList.config.data.itemDetails[0]);
        }

        $scope.HideAdd = true;
        $scope.HideSave = false;

        var responses = $http({
          method: "POST",
          url: $rootScope.WebURL + "/purchasedebitnote/getByID",
          data: {
            VoucherNumber: $scope.VoucherNumber,
            Client_Id: Client_Id
          },
        });

        responses.then(function (GList) {
          debugger
          $scope.DNItemDetails = GList.data.data[0].itemDetails;
        })

        RefreshInvoice();

      });

    }

    $scope.DNItemInfo = function (ItemID) {


      $scope.ItemID = ItemID;
      var item = $scope.DNItemDetails.filter(function (item) {
        return item._id === ItemID;
      })[0];
      $scope.DNAmount = 0;
      if (item.Amount != null) {
        $scope.DNAmount = parseFloat(item.PaidAmount.toFixed(2));
        // $scope.DNAmount = parseFloat(item.Amount.toFixed(2)) - parseFloat(item.TaxAmount.toFixed(2));
      }


      $scope.DNInvoiceID = item.InvoiceID;
      $scope.DNAccountID = item.AccountID;
      $scope.DNGSTID = item.GSTID;

      $scope.HideAdd = false;
      $scope.HideSave = true;
    }


    $scope.SaveDebitnote = function () {

      debugger
      if ($scope.Update == true) {
        $scope.Update = true;


        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/purchasedebitnote/update",
          data: {
            _id: $scope.DebitnoteID,
            VoucherNumber: $scope.VoucherNumber,
            VoucherDate: $scope.VoucherDate,
            Description: $scope.Description,
            DebitNoteNumber: $scope.DebitNoteNumber,
            Date: $scope.Date,
            Remarks: $scope.Remarks,
            UpdatedBy: $rootScope.LoginID
          },
        });
        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
          RefreshDebitnote();
          $scope.DebitnoteGrid = true;
          $scope.DebitnoteForm = false;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
        });
      } else {



        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/purchasedebitnote/add",
          data: {
            SupplierID: $scope.vm.SupplierID,
            Client_Id: Client_Id,
            VoucherNumber: $scope.VoucherNumber,
            VoucherDate: $scope.VoucherDate,
            Description: $scope.Description,
            DebitNoteNumber: $scope.DebitNoteNumber,
            Date: $scope.Date,
            Remarks: $scope.Remarks,
            CreatedBy: $rootScope.LoginID
          },
        });

        response.then(function (GList) {
          $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
          RefreshDebitnote();
          GetTotalCurrentYearDebitnotes();
          $scope.DebitnoteGrid = true;
          $scope.DebitnoteForm = false;
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      }
    }

    $scope.Debitnoteinfo = function (DebitnoteID) {

      $scope.DNInvoiceID = undefined;
      $scope.DNAmount = undefined;
      $scope.DNAccountID = undefined;
      $scope.DNGSTID = undefined;


      $scope.Purchaseinvoicedatasddf = $scope.Purchaseinvoicedatas;
      $scope.DebitnoteID = DebitnoteID;
      $scope.DebitNoteID = DebitnoteID;
      $scope.Update = true;

      $scope.HideAdd = true;
      $scope.HideSave = false;

      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = true;

      $scope.DebitnoteSelect = false;

      var value = $scope.Debitnotedatas.filter(function (item) {
        return item._id === DebitnoteID;
      })[0];


      $scope.Description = value.Description;
      $scope.VoucherNumber = value.VoucherNumber;
      $scope.VoucherDate = new Date(value.VoucherDate);
      $scope.Date = new Date(value.Date);
      $scope.vm.SupplierID = value.SupplierID;
      $scope.Remarks = value.Remarks;
      $scope.DebitNoteNumber = value.DebitNoteNumber;
      $scope.DNItemDetails = value.itemDetails;

    }

    $scope.ShowgridDebit = function () {

      $scope.DebitnoteGrid = true;
      $scope.DebitnoteForm = false;
      $scope.DebitnoteSelect = true;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
    }


    function RefreshDebitnote() {

      $scope.Debitnotedatas = undefined;
      var response = $http({
        url: $rootScope.WebURL + "/purchasedebitnote/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (Debitnotedata) {
        $scope.Debitnotedatas = Debitnotedata.data.data;
      });
    }

    $scope.DebitnoteFilter = function () {
      $scope.Debitnotedatas = undefined;
      var response = $http({
        url: $rootScope.WebURL + "/purchasedebitnote/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: Client_Id
        },
      });
      response.then(function (Debitnotedata) {
        $scope.Debitnotedatas = Debitnotedata.data.data;
      });
    }

    function ClearDebitnote() {
      $scope.InvoiceNo = null;
      $scope.Date = null;
      $scope.Description = null;
      $scope.Amount = null;
      $scope.GSTID = null;
      $scope.Remarks = null;
      $scope.VoucherNumber = null;
      $scope.VoucherDate = null;
      $scope.DebitNoteNumber = null;

    }
    RefreshBank();
    RefreshChartofAccount();
    RefreshGST();
    RefreshEmployee();
    RefreshPO();

    function RefreshBank() {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/bank",
        data: {
          Client_Id: Client_Id
        },
      });
      response.then(function (Bankdata) {
        $scope.Bankdatas = Bankdata.data.data;
      });
    }


    var response = $http({
      method: "POST",
      url: $rootScope.WebURL + "/supplier",
      data: {
        Client_Id: Client_Id
      },
    });
    response.then(function (Supplierdata) {
      $scope.Supplierdatas = Supplierdata.data.data;
    });


    function RefreshChartofAccount() {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/chartofaccount",
        data: {
          Client_Id: Client_Id
        },
      });
      response.then(function (ChartofAccountdata) {

        $scope.ChartofAccountatas = ChartofAccountdata.data.data;
      });
    }


    function RefreshGST() {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/gsttax",
        data: {
          Client_Id: Client_Id
        },
      });
      response.then(function (GSTdata) {
        $scope.GSTdatas = GSTdata.data.data;
      });
    }

    function RefreshPO() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/purchaseorder",
        data: {
          Client_Id: Client_Id
        },
      });
      response.then(function (Purchaseorderdata) {
        $scope.Purchaseorderdatas = Purchaseorderdata.data.data;
      });

    }

    function RefreshEmployee() {

      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/employee/detailsforTab",
        data: {
          Client_Id: Client_Id
        },
      });
      response.then(function (Employeedata) {

        $scope.Employeedatas = Employeedata.data.data;

      });
    }

    $scope.closeDialog = function () {
      $mdDialog.cancel();
    };

    $scope.CreditnoteExport = function () {
      alasql('SELECT * INTO XLSX("CreditNote.xlsx",{headers:true}) FROM ?', [$scope.Creditnotedatas]);
    };

    $scope.DebitnoteExport = function () {
      alasql('SELECT * INTO XLSX("DebitNote.xlsx",{headers:true}) FROM ?', [$scope.Debitnotedatas]);
    };


    var vm = this;

    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

      initComplete: function () {

        var api = this.api(),
          searchBox = angular.element('body').find('#search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 30, 50, 100],
      retrieve: true,
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };



    vm.dtOptions4 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      destroy: true,
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      },

      initComplete: function () {

        var api = this.api(),
          searchBox = angular.element('body').find('#search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }

      },


    };



    vm.dtOptions2 = {
      //dom: 'rt<"bottom">',
      dom: '',

      initComplete: function () {

        var api = this.api(),
          searchBox = angular.element('body').find('#search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };


    vm.dtOptions3 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

      initComplete: function () {

        var api = this.api(),
          searchBox = angular.element('body').find('#search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      processing: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };


    $scope.CreditnoteTab = function () {
      RefreshCreditnote();
      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = true;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = false;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
      $scope.SearchValue = "";

      $scope.InvoiceGrid = false;
      $scope.InvoiceForm = false;
      $scope.InvoiceFormback = false;
    };

    $scope.DebitnoteTab = function () {

      RefreshDebitnote();
      $scope.PurchaseInvoicegrid = false;
      $scope.PurchaseInvoiceform = false;
      $scope.PaySuppliergrid = false;
      $scope.PaySupplierform = false;
      $scope.CreditnoteGrid = false;
      $scope.CreditnoteForm = false;
      $scope.DebitnoteGrid = true;
      $scope.DebitnoteForm = false;
      $scope.CancelPI = false;
      $scope.SearchValue = "";
      $scope.InvoiceGrid = false;
      $scope.InvoiceForm = false;
      $scope.InvoiceFormback = false;
    };

    $scope.Today = function () {
      var today = new Date();
      var end = new Date();
      $scope.uFrom = today;
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo = end;
      $scope.uTo.setHours(23, 59, 59, 999);
      $scope.vm.uFrom = $scope.uFrom;
      $scope.vm.uTo = $scope.uTo;
    }

    $scope.lastweek = function () {
      var d = new Date();
      var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
      var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = from;
      $scope.uTo = to;

      $scope.vm.uFrom = $scope.uFrom;
      $scope.vm.uTo = $scope.uTo;
    }

    $scope.NextWeek = function () {
      var d = new Date();
      var dayIndex = [1];
      var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
      var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
      from = $filter('date')(from);
      to = $filter('date')(to);
      $scope.uFrom = from;
      $scope.uTo = to;

      $scope.vm.uFrom = $scope.uFrom;
      $scope.vm.uTo = $scope.uTo;

    }

    $scope.NextMonth = function () {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      firstDay = $filter('date')(firstDay);
      lastDay = $filter('date')(lastDay);
      $scope.uFrom = firstDay;
      $scope.uTo = lastDay;

      $scope.vm.uFrom = $scope.uFrom;
      $scope.vm.uTo = $scope.uTo;
    }

    $scope.lastmonth = function () {
      var now = new Date();
      var nowDayOfWeek = now.getDay();
      var nowDay = now.getDate();
      var nowMonth = now.getMonth();
      var nowYear = now.getFullYear();
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastYear = lastMonthDate.getFullYear();
      var lastMonth = lastMonthDate.getMonth();
      var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
      var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
      lastMonthStartDate = $filter('date')(lastMonthStartDate);
      lastMonthEndDate = $filter('date')(lastMonthEndDate);
      $scope.uFrom = lastMonthStartDate;
      $scope.uTo = lastMonthEndDate;

      $scope.vm.uFrom = $scope.uFrom;
      $scope.vm.uTo = $scope.uTo;
    }

    function getMonthDays(myMonth) {
      var now = new Date();
      var nowYear = now.getFullYear();
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    }
    var now = new Date();
    $scope.minDate = new Date(
      now.getFullYear() - 5,
      now.getMonth(),
      now.getDate()
    );

    $mdDateLocale.formatDate = formatDate;

    function formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    }

    $mdDateLocale.parseDate = function (dateString) {
      var m = moment(dateString, 'D.M.YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
  }

})();

(function () {
    'use strict';

    angular

        .module('app.accounts.payment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_payment', {
            url: '/PaymentVoucher',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/payment/payment.html',
                    controller: 'PaymentController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/payment');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.payment')
        .controller('PaymentController', PaymentController);


    /** @ngInject */
    function PaymentController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdSidenav, $mdToast, $mdDialog, $document, $http, $log, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Payment")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');

        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var LoggedEmployeeID = localStorage.getItem('EmployeeID');

        RefreshGrid();
        RefreshGrid1();
        RefreshEmployeeGrid();
        RefreshGSTGrid();
        RefreshClaimCategory();

        $scope.Paymentform = false;
        $scope.ViewPaymentform = false;
        $scope.Paymentgrid = true;
        $scope.pExport = true;
        $scope.pAdd = true;
        $scope.pSearch = true;
        $scope.pView = false;

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.Add = function () {
            debugger
            ClearForm();
            $scope.Paymentdetailsdatas = [];
            $scope.Attachmentdatas = [];
            $scope.Payment = false;
            $scope.Update = false;
            $scope.Paymentform = true;
            $scope.ViewPaymentform = false;
            $scope.Paymentgrid = false;
            $scope.pExport = false;
            $scope.pAdd = false;
            $scope.pSearch = false;
            $scope.pView = true;
            $scope.Date = new Date();
            $scope.Cancel = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.UniqueID = pass;

            var AR = "PV-";
            var info = $scope.Paymentformrefdatas
            for (var x = 0; x <= 1 + info.length; x++) {
                if (x < 10) {
                    var y = "00000" + x;
                }
                else if (y < 100) {
                    y = "0000" + x;
                }
                else if (y < 1000) {
                    y = "000" + x;
                }
                else if (y < 10000) {
                    y = "00" + x;
                }
                else if (y < 100000) {
                    y = "0" + x;
                }
                else {
                    y = x;
                }
            }
            $scope.ReferenceNumber = AR + y;
            LoadDeafaultEmployee();
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Paymentdetailsdatas.xlsx",{headers:true}) FROM ?', [$scope.Paymentdetailsdatas]);
        };

        $scope.Showgrid = function () {
            $scope.Paymentgrid = true;
            $scope.Paymentform = false;
            $scope.ViewPaymentform = false;
            $scope.pExport = true;
            $scope.pAdd = true;
            $scope.pView = false;
            $scope.pSearch = true;
            $scope.Payment = false;
            $scope.Cancel = false;
        }

        $scope.Paymentinfo = function (PaymentId) {
            debugger
            $scope.SID = PaymentId;
            try {
                var Paymentarray = $scope.Paymentformdatas;
                var Paymentitem = Paymentarray.filter(function (item) {
                    return item._id === PaymentId;
                })[0];

                $scope.id = Paymentitem._id;
                $scope.Status = Paymentitem.Status;
                $scope.StatusID = parseInt(Paymentitem.StatusID);
            } catch (err) { }

            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.Update = true;

                $scope.Paymentform = true;
                $scope.ViewPaymentform = false;
                $scope.Paymentgrid = false;
                $scope.pExport = false;
                $scope.pAdd = false;
                $scope.pSearch = false;
                $scope.pView = true;
                $scope.Cancel = false;
                $scope.Payment = true;
                try {
                    var Paymentarray = $scope.Paymentformdatas;
                    var Paymentitem = Paymentarray.filter(function (item) {
                        return item._id === PaymentId;
                    })[0];

                    $scope.id = Paymentitem._id;
                    $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
                    $scope.UniqueID = Paymentitem.UniqueID;
                    $scope.EmployeeID = Paymentitem.EmployeeID;
                    $scope.Date = new Date(Paymentitem.Date);
                    $scope.Remarks = Paymentitem.Remarks;
                    $scope.Status = Paymentitem.Status;
                    $scope.StatusID = parseInt(Paymentitem.StatusID);
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

                RefreshPaymentdetailGrid();
                RefreshAttachmentGrid();
            }
        }

        $scope.ViewPaymentinfo = function (ReqId) {

            debugger
            $scope.SID = ReqId;

            $scope.Update = true;

            $scope.Paymentform = false;
            $scope.ViewPaymentform = true;
            $scope.Paymentgrid = false;
            $scope.pExport = false;
            $scope.pAdd = false;
            $scope.pSearch = false;
            $scope.pView = true;
            $scope.Cancel = false;
            $scope.Payment = true;
            try {
                var Paymentarray = $scope.Paymentformdatas;
                var Paymentitem = Paymentarray.filter(function (item) {
                    return item._id === ReqId;
                })[0];

                $scope.id = Paymentitem._id;
                $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
                $scope.UniqueID = Paymentitem.UniqueID;
                $scope.EmployeeID = Paymentitem.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeID + '-' + item.Employeedetails[0].EmployeeName;
                $scope.Date = new Date(Paymentitem.Date);
                $scope.Remarks = Paymentitem.Remarks;
                if (Paymentitem.QRCode != null && Paymentitem.QRCode != "" && Paymentitem.QRCode != undefined) {
                    $scope.QRCode = decode_base64(Paymentitem.QRCode);
                }
                $scope.Status = Paymentitem.Status;
                $scope.StatusID = parseInt(Paymentitem.StatusID);
            } catch (err) { }

            //var myArray = $scope.Employeedatas;

            //var item = myArray.filter(function (item) {
            //    return item.id === $scope.EmployeeID;
            //})[0];

            //$scope.EmployeeName = item.EmployeeID + '-' + item.EmployeeName;

            RefreshPaymentdetailGrid();
            RefreshAttachmentGrid();
        }

        $scope.mSubmit = function () {
            debugger
            if ($scope.Attachmentdatas == undefined || $scope.Attachmentdatas.length == 0) {
                $mdToast.show($mdToast.simple().textContent('Please Attach Supporting Documents & Click Submit!').position('top center'));
                return;
            }


            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGrid();
                    RefreshGrid1();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/paymentform/add",
                    data: {
                        Client_Id: Client_Id,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger
                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Payment Voucher",
                            Action: "New",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    RefreshGrid1();
                    $scope.Showgrid();


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }

        }

        $scope.cancelrequest = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Cancelled",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Accounts Payment Voucher",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));

                    RefreshGrid();
                    RefreshGrid1();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            debugger
            var response = Upload.upload({
                url: $rootScope.WebURL + "/paymentform/upload",
                data: { file: file }
            }).then(function (resp) {
                debugger
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Payment Voucher",
                            FileID: $scope.UniqueID,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        // $http.get( $rootScope.WebURL + "/employee")
        // .then(function (Employeedata) {
        //     debugger
        //     $scope.Employeedatas = Employeedata.data.data;
        // });

        // $http.get( $rootScope.WebURL + "/gsttax")
        //.then(function (GSTdata) {
        //    $scope.GSTdatas = GSTdata.data.data;
        //});

        //$http.get( $rootScope.WebURL + "/paymentform")
        //.then(function (Paymentformrefdata) {
        //    $scope.Paymentformrefdatas = Paymentformrefdata.data.data;
        //});

        function RefreshGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/paymentform/getByLoginID",
                method: "POST",
                data: { LoginID: $rootScope.LoginID },
            });
            response.then(function (Paymentformdata) {
                $scope.Paymentformdatas = Paymentformdata.data.data;
            });

        }

        function RefreshGrid1() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/paymentform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Paymentformrefdata) {
                $scope.Paymentformrefdatas = Paymentformrefdata.data.data;
            });

            //$http.get( $rootScope.WebURL + "/paymentform")
            //     .then(function (Paymentformrefdata) {
            //         $scope.Paymentformrefdatas = Paymentformrefdata.data.data;
            //     });
        }
        function RefreshEmployeeGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Employeedata) {

                $scope.Employeedatas = Employeedata.data.data;

            });
        }
        function LoadDeafaultEmployee() {
            debugger
            try {
                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === LoggedEmployeeID;
                })[0];
                $scope.EmployeeID = item1.id;
            } catch (error) {
            }
        }

        function RefreshGSTGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/gsttax",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function RefreshPaymentdetailGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/paymentdetails/getbyExpenseID",
                method: "POST",
                data: { UniqueID: $scope.UniqueID },
            });
            response.then(function (Paymentdetailsdata) {
                $scope.Paymentdetailsdatas = Paymentdetailsdata.data.data;
            });
        }

        function RefreshAttachmentGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (attachmentdata) {
                debugger
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshClaimCategory() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/claimcategory",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ClaimCategorydata) {

                $scope.ClaimCategorydatas = ClaimCategorydata.data.data;
            });

        }

        function ClearForm() {
            $scope.ReferenceNumber = '';
            $scope.UniqueID = '';
            $scope.EmployeeID = '';
            $scope.Date = '';
            $scope.Remarks = '';
            $scope.Status = '';
            $scope.StatusID = '';
            $scope.Attachmentdatas = '';
            $scope.Paymentdetailsdatas = '';
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.Paymentdetailpopup = function (e, UniqueID, ReferenceNumber) {
            debugger
            $scope.vm.Description = '';
            $scope.vm.Amount = '';
            $scope.vm.Notes = '';
            $scope.vm.GSTID = '';
            $scope.vm.BillAttached = null;
            $scope.ReferenceNumber = ReferenceNumber;
            $scope.UniqueID = UniqueID;
            $scope.PUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/payment/paymentdetailpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PaymentController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.PaymentdetailAdd = function () {
            debugger
            var GST = null;
            if ($scope.vm.GSTID == undefined) {
            }
            else {
                GST = $scope.vm.GSTID;
            }
            if ($scope.PUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentdetails/update",
                    data: {
                        _id: $scope.MID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        Description: $scope.vm.Description,
                        Amount: $scope.vm.Amount,
                        Notes: $scope.vm.Notes,
                        BillAttached: $scope.vm.BillAttached,
                        GSTID: GST,
                        CategoryID: $scope.vm.ClaimCategoryID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshPaymentdetailGrid();

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/paymentdetails/add",
                    data: {
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        Description: $scope.vm.Description,
                        Amount: $scope.vm.Amount,
                        Notes: $scope.vm.Notes,
                        BillAttached: $scope.vm.BillAttached,
                        GSTID: GST,
                        CategoryID: $scope.vm.ClaimCategoryID,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshPaymentdetailGrid();

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Paymentdetailupdate = function (e, PaymentdetailId) {
            debugger
            $scope.PUpdate = true;
            $scope.MID = PaymentdetailId;
            try {
                var Paymentarray = $scope.Paymentdetailsdatas;
                var Paymentitem = Paymentarray.filter(function (item) {
                    return item._id === PaymentdetailId;
                })[0];

                $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
                $scope.UniqueID = Paymentitem.UniqueID;
                $scope.vm.Description = Paymentitem.Description;
                $scope.vm.Notes = Paymentitem.Notes;
                $scope.vm.Amount = parseInt(Paymentitem.Amount);
                $scope.vm.GSTID = Paymentitem.GSTID;
                $scope.vm.ClaimCategoryID = Paymentitem.CategoryID;
            } catch (err) { }
            if (Paymentitem.BillAttached == true) { $scope.vm.BillAttached = { value: true, } } else { $scope.vm.BillAttached = { value: false, }; }

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/payment/paymentdetailpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PaymentController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Paymentdetaildelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/payment/paymentdetaildelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function PaymentController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Pdelete = function (deleteID) {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/paymentdetails/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                debugger
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshPaymentdetailGrid();

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.printToCart = function (PId) {
            debugger
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "PaymentVoucher.aspx?ID=" + PId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.Print = function (invoice, PId) {
            debugger

            $scope.PrintID = PId;

            var Paymentarray = $scope.Paymentformdatas;
            var Paymentitem = Paymentarray.filter(function (item) {
                return item._id === PId;
            })[0];

            $scope.id = Paymentitem._id;
            $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
            $scope.UniqueID = Paymentitem.UniqueID;
            $scope.EmployeeID = Paymentitem.EmployeeID;
            $scope.Date = new Date(Paymentitem.Date);
            $scope.Remarks = Paymentitem.Remarks;
            if (Paymentitem.QRCode != null && Paymentitem.QRCode != "" && Paymentitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Paymentitem.QRCode);
            }
            $scope.Status = Paymentitem.Status;
            $scope.StatusID = parseInt(Paymentitem.StatusID);


            var myArray = $scope.Employeedatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];

            $scope.EmployeeName = item.EmployeeID + '-' + item.EmployeeName;


            RefreshPaymentdetailGrid();

            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;
        }

        $scope.PrintMaterial = function (printpaymentvoucher, UniqID) {
            debugger
            $scope.PrintID = UniqID;


            var Paymentarray = $scope.Paymentformdatas;
            var Paymentitem = Paymentarray.filter(function (item) {
                return item.UniqueID === UniqID;
            })[0];

            $scope.id = Paymentitem._id;
            $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
            $scope.UniqueID = Paymentitem.UniqueID;
            $scope.EmployeeID = Paymentitem.EmployeeID;
            $scope.Date = new Date(Paymentitem.Date);
            $scope.Remarks = Paymentitem.Remarks;
            if (Paymentitem.QRCode != null && Paymentitem.QRCode != "" && Paymentitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Paymentitem.QRCode);
            }
            $scope.Status = Paymentitem.Status;
            $scope.StatusID = parseInt(Paymentitem.StatusID);


            var myArray = $scope.Employeedatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];

            $scope.EmployeeName = item.EmployeeID + '-' + item.EmployeeName;


            RefreshPaymentdetailGrid();

            //$scope.Pop = true;
            var innerContents = document.getElementById(printpaymentvoucher).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.generalsetting', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_generalsetting', {
            url: '/GeneralSetting',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/generalsetting/generalsetting.html',
                    controller: 'generalsettingController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/generalsetting');
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.generalsetting')
        .controller('generalsettingController', generalsettingcontroller);

    function generalsettingcontroller($scope, $location, $rootScope, $interval, $mdToast, $http, $mdDialog, $document, $state, $filter, $mdDateLocale, $timeout, $q, $log) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcLumiair")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        $rootScope.createdName = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');

        $scope.Update = false;

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.FinancialYearSelect = false;
        $scope.FinancialPeriodSelect = false;
        $scope.ChartofAccountSelect = false;
        $scope.AccountCodeSetupSelect = false;
        $scope.EmailSettingSelect = false;
        $scope.ClaimCategorySelect = false;
        $scope.GSTSelect = true;
        $scope.BankSelect = false;
        getXeroData()

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm1 = '';
            $scope.vm.searchTerm2 = '';
        }

        RefreshFinancialYear();
        RefreshFinancialPeriod();
        RefreshBank();
        RefreshGST();
        RefreshClientbank();
        RefreshChartofAccount();
        RefreshAccountCodeSetup();
        RefreshEmailSetting();
        RefreshClaimCategory();


        $scope.Bankadd = function (e) {

            ClearBank();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/managebank.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SaveBank = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/bank/update",
                    data: {
                        _id: $scope.BID, BankName: $scope.vm.Bank, AccountNumber: $scope.vm.AccountNumber, Name: $scope.vm.Name,
                        OpeningDate: $scope.vm.OpeningDate, CurrentBalance: $scope.vm.CurrentBalance, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshBank();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/bank/add",
                    data: {
                        BankName: $scope.vm.Bank, AccountNumber: $scope.vm.AccountNumber, Name: $scope.vm.Name, Client_Id: Client_Id,
                        OpeningDate: $scope.vm.OpeningDate, CurrentBalance: $scope.vm.CurrentBalance, Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshBank();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Bankinfo = function (e, BID) {

            $scope.BID = BID;
            $scope.Update = true;
            angular.forEach($scope.Bankdatas, function (value, key) {
                if (BID == value._id) {

                    $scope.vm.Bank = value.BankName;
                    $scope.vm.Name = value.Name;
                    $scope.vm.CurrentBalance = parseFloat(value.CurrentBalance);
                    $scope.vm.AccountNumber = value.AccountNumber;
                    $scope.vm.OpeningDate = new Date(value.OpeningDate);
                    $scope.vm.Remarks = value.Remarks;
                }
            });


            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/managebank.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        $scope.BankFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/bank/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function ClearBank() {
            $scope.vm.Bank = null;
            $scope.vm.AccountNumber = null;
            $scope.vm.Name = null;
            $scope.vm.OpeningDate = new Date();
            $scope.vm.CurrentBalance = null;
            $scope.vm.Remarks = null;
        }



        $scope.Financialadd = function (e) {

            ClearFinancialYear();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/financialyearAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });


        }

        $scope.SaveFinancialYear = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/financialyear/update",
                    data: {
                        _id: $scope.FYID, FiscalYear: $scope.vm.FiscalYear, Code: $scope.vm.Code, AccountingBasis: $scope.vm.AccountingBasis,
                        StartDate: $scope.vm.StartDate, EndDate: $scope.vm.EndDate, OpeningBalance: $scope.vm.OpeningBalance, ClosingBalance: $scope.vm.ClosingBalance,
                        Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshFinancialYear();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/financialyear/add",
                    data: {
                        FiscalYear: $scope.vm.FiscalYear, Code: $scope.vm.Code, AccountingBasis: $scope.vm.AccountingBasis, Client_Id: Client_Id,
                        StartDate: $scope.vm.StartDate, EndDate: $scope.vm.EndDate, OpeningBalance: $scope.vm.OpeningBalance, ClosingBalance: $scope.vm.ClosingBalance,
                        Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshFinancialYear();
                    RefreshFinancialPeriod();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.FinancialYearinfo = function (e, FYID) {

            $scope.FYID = FYID;
            $scope.Update = true;
            angular.forEach($scope.FinancialYeardatas, function (value, key) {
                if (FYID == value._id) {
                    $scope.vm.Code = value.Code;
                    $scope.vm.FiscalYear = parseInt(value.FiscalYear);
                    $scope.vm.OpeningBalance = parseFloat(value.OpeningBalance);
                    $scope.vm.ClosingBalance = parseFloat(value.ClosingBalance);
                    $scope.vm.AccountingBasis = value.AccountingBasis;
                    $scope.vm.StartDate = new Date(value.StartDate);
                    $scope.vm.EndDate = new Date(value.EndDate);
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/financialyear.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        function RefreshFinancialYear() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/financialyear",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (FinancialYeardata) {
                $scope.FinancialYeardatas = FinancialYeardata.data.data;
            });
        }

        function ClearFinancialYear() {
            $scope.vm.Code = null;
            $scope.vm.FiscalYear = null;
            $scope.vm.OpeningBalance = null;
            $scope.vm.ClosingBalance = null;
            $scope.vm.AccountingBasis = "Accrual";
            $scope.vm.StartDate = new Date();
            $scope.vm.EndDate = new Date();
            $scope.vm.Remarks = null;
        }



        $scope.FinancialPeriodadd = function (e) {
            ClearFinancialPeriod();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/financialperoid.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SaveFinancialPeriod = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/financialperiod/update",
                    data: {
                        _id: $scope.FPID, PeriodName: $scope.vm.PeriodName, OpenPeriod: $scope.vm.OpenPeriod.value, ClosePeriod: $scope.vm.ClosePeriod.value,
                        StartDate: $scope.vm.StartDate, EndDate: $scope.vm.EndDate, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshFinancialPeriod();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/financialperiod/add",
                    data: {
                        PeriodName: $scope.vm.PeriodName, OpenPeriod: $scope.vm.OpenPeriod.value, ClosePeriod: $scope.vm.ClosePeriod.value, Client_Id: Client_Id,
                        StartDate: $scope.vm.StartDate, EndDate: $scope.vm.EndDate, Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshFinancialPeriod();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.FinancialPeriodinfo = function (e, FPID) {

            $scope.FPID = FPID;
            $scope.Update = true;
            angular.forEach($scope.FinancialPerioddatas, function (value, key) {
                if (FPID == value._id) {
                    $scope.vm.PeriodName = value.PeriodName;
                    $scope.vm.StartDate = new Date(value.StartDate);
                    $scope.vm.EndDate = new Date(value.EndDate);
                    $scope.vm.Remarks = value.Remarks;

                    if (value.OpenPeriod == true) { $scope.vm.OpenPeriod = { value: true, } } else { $scope.vm.OpenPeriod = { value: false, }; }
                    if (value.ClosePeriod == true) { $scope.vm.ClosePeriod = { value: true, } } else { $scope.vm.ClosePeriod = { value: false, }; }
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/financialperoid.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        function RefreshFinancialPeriod() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/financialperiod",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (FinancialPerioddata) {
                $scope.FinancialPerioddatas = FinancialPerioddata.data.data;
            });
        }

        function ClearFinancialPeriod() {
            $scope.vm.PeriidName = null;
            $scope.vm.OpenPeriod = { value: false, };
            $scope.vm.ClosePeriod = { value: false, };
            $scope.vm.StartDate = new Date();
            $scope.vm.EndDate = new Date();
            $scope.vm.Remarks = null;
        }

        $scope.ChartofAccountadd = function (e) {
            ClearChartofAccount();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/ChartofAccount.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SaveChartofAccount = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/chartofaccount/update",
                    data: {
                        _id: $scope.CAID, AccountCode: $scope.vm.AccountCode, AccountDescription: $scope.vm.AccountDescription, AccountClassification: $scope.vm.AccountClassification,
                        Grouping: $scope.vm.Grouping, SubGrouping: $scope.vm.SubGrouping, Nature: $scope.vm.Nature, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshChartofAccount();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/chartofaccount/add",
                    data: {
                        AccountCode: $scope.vm.AccountCode, AccountDescription: $scope.vm.AccountDescription, AccountClassification: $scope.vm.AccountClassification, Client_Id: Client_Id,
                        Grouping: $scope.vm.Grouping, SubGrouping: $scope.vm.SubGrouping, Nature: $scope.vm.Nature, Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshChartofAccount();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.ChartofAccountinfo = function (e, CAID) {

            $scope.CAID = CAID;
            $scope.Update = true;
            angular.forEach($scope.ChartofAccountatas, function (value, key) {
                if (CAID == value._id) {
                    $scope.vm.AccountCode = value.AccountCode;
                    $scope.vm.AccountDescription = value.AccountDescription;
                    $scope.vm.AccountClassification = value.AccountClassification;
                    $scope.vm.Grouping = value.Grouping;
                    $scope.vm.SubGrouping = value.SubGrouping;
                    $scope.vm.Nature = value.Nature;
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/ChartofAccount.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        $scope.UpdateStatusAlert = function (e, CAID) {


            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/alertuser.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            $scope.CAID = CAID;

        }

        $scope.UpdateStatus = function (e, CAID) {

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/financialyear/updatestatus",
                data: {
                    _id: $scope.CAID, Status: "Closed", UpdatedBy: $rootScope.LoginID
                },
            });

            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully closed!').position('top center'));


            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });

            var item = $scope.FinancialYeardatas.filter(function (item) {
                return item._id === $scope.CAID;
            })[0];

            $scope.Update = false;
            RefreshChartofAccount();
            ClearFinancialYear();

            $scope.vm.FiscalYear = parseInt(item.FiscalYear) + 1;
            $scope.vm.Code = item.Code;
            $scope.vm.OpeningBalance = parseFloat(item.ClosingBalance);
            $scope.vm.AccountingBasis = item.AccountingBasis;
            $scope.vm.StartDate = new Date(item.StartDate);
            $scope.vm.EndDate = new Date(item.EndDate);
            $scope.vm.Remarks = item.Remarks;

            $mdDialog.hide();

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/financialyearclone.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });


        }

        $scope.CheckStatus = function (status) {

            if (status == "Closed") {
                return false;
            }
            else { return true; }

        }

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }

        function ClearChartofAccount() {
            $scope.vm.AccountCode = null;
            $scope.vm.AccountDescription = null;
            $scope.vm.AccountClassification = null;
            $scope.vm.Grouping = null;
            $scope.vm.SubGrouping = null;
            $scope.vm.Nature = null;
            $scope.vm.Remarks = null;
        }

        function GSTPopup(e) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/GST.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            var default_value_exists = $scope.GSTdatas.filter(function (f) {
                return f.TaxType == "Yes"
            })
            if (default_value_exists.length > 0) {
                $scope.disable_default = true
            }
            else {
                $scope.disable_default = false
                $scope.vm.TaxType = "No";
            }

        }

        $scope.GSTadd = function (e) {
            ClearGST();
            $scope.Update = false;
            GSTPopup(e)

        }

        $scope.SaveGST = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/gsttax/update",
                    data: {
                        _id: $scope.GID, GSTTaxCode: $scope.vm.GSTTaxCode, Description: $scope.vm.Description, TaxType: $scope.vm.TaxType,
                        TaxRate: $scope.vm.TaxRate, LinkToGST: $scope.vm.LinkToGST, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshGST();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/gsttax/add",
                    data: {
                        GSTTaxCode: $scope.vm.GSTTaxCode, Description: $scope.vm.Description, TaxType: $scope.vm.TaxType, Client_Id: Client_Id,
                        TaxRate: $scope.vm.TaxRate, LinkToGST: $scope.vm.LinkToGST, Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGST();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.GSTinfo = function (e, GID) {

            $scope.GID = GID;
            $scope.Update = true;
            angular.forEach($scope.GSTdatas, function (value, key) {
                if (GID == value._id) {
                    $scope.vm.GSTTaxCode = value.GSTTaxCode;
                    $scope.vm.Description = value.Description;
                    $scope.vm.TaxType = value.TaxType;
                    $scope.vm.TaxRate = parseFloat(value.TaxRate);
                    $scope.vm.LinkToGST = value.LinkToGST;
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            GSTPopup(e)
            if ($scope.vm.TaxType == "Yes")
                $scope.disable_default = false
        }

        function RefreshGST() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/gsttax",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }

        function ClearGST() {
            $scope.vm.GSTTaxCode = null;
            $scope.vm.Description = null;
            $scope.vm.TaxType = "No";
            $scope.vm.TaxRate = null;
            $scope.vm.LinkToGST = null;
            $scope.vm.Remarks = null;
        }


        $scope.Accountcodesetuppopup = function (e) {

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/accountcodesettings.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            $scope.vm.Type = '';
            $scope.vm.DebtorCode = '';
            $scope.vm.SalesCode = '';
            $scope.vm.CreditorCode = '';
            $scope.vm.PurchaseCode = '';
            $scope.vm.BankCode = '';
            $scope.vm.CashCode = '';
            $scope.vm.GSTInputCode = '';
            $scope.vm.GSTOutputCode = '';
            $scope.vm.Wages = '';
            $scope.vm.CPFContribution = '';
            $scope.vm.StaffIncentives = '';
            $scope.Update = false;
        }

        $scope.Accountcodesetupadd = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/accountcodesetup/update",
                    data: {
                        _id: $scope.SID,
                        Type: $scope.vm.Type,
                        DebtorCode: $scope.vm.DebtorCode,
                        SalesCode: $scope.vm.SalesCode,
                        CreditorCode: $scope.vm.CreditorCode,
                        PurchaseCode: $scope.vm.PurchaseCode,
                        BankCode: $scope.vm.BankCode,
                        CashCode: $scope.vm.CashCode,
                        GSTInputCode: $scope.vm.GSTInputCode,
                        GSTOutputCode: $scope.vm.GSTOutputCode,
                        Wages: $scope.vm.Wages,
                        CPFContribution: $scope.vm.CPFContribution,
                        StaffIncentives: $scope.vm.StaffIncentives,
                        UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshAccountCodeSetup();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/accountcodesetup/add",
                    data: {
                        Type: $scope.vm.Type,
                        DebtorCode: $scope.vm.DebtorCode,
                        SalesCode: $scope.vm.SalesCode,
                        CreditorCode: $scope.vm.CreditorCode,
                        PurchaseCode: $scope.vm.PurchaseCode,
                        BankCode: $scope.vm.BankCode,
                        CashCode: $scope.vm.CashCode,
                        GSTInputCode: $scope.vm.GSTInputCode,
                        GSTOutputCode: $scope.vm.GSTOutputCode,
                        Wages: $scope.vm.Wages, Client_Id: Client_Id,
                        CPFContribution: $scope.vm.CPFContribution,
                        StaffIncentives: $scope.vm.StaffIncentives,
                        CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshAccountCodeSetup();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Accountcodesetupinfo = function (e, SetupID) {

            $scope.SID = SetupID;
            $scope.Update = true;

            var SetupArray = $scope.Accountcodesetupdatas;
            var item1 = SetupArray.filter(function (item1) {
                return item1._id === SetupID;
            })[0];

            $scope.id = item1._id;
            $scope.vm.Type = item1.Type;
            $scope.vm.DebtorCode = item1.DebtorCode;
            $scope.vm.SalesCode = item1.SalesCode;
            $scope.vm.CreditorCode = item1.CreditorCode;
            $scope.vm.PurchaseCode = item1.PurchaseCode;
            $scope.vm.BankCode = item1.BankCode;
            $scope.vm.CashCode = item1.CashCode;
            $scope.vm.GSTInputCode = item1.GSTInputCode;
            $scope.vm.GSTOutputCode = item1.GSTOutputCode;;
            $scope.vm.Wages = item1.Wages;
            $scope.vm.CPFContribution = item1.CPFContribution;
            $scope.vm.StaffIncentives = item1.StaffIncentives;


            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/accountcodesettings.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });


        }

        function RefreshAccountCodeSetup() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/accountcodesetup",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Accountcodesetupdata) {
                $scope.Accountcodesetupdatas = Accountcodesetupdata.data.data;
            });
        }


        $scope.EmailSettingpopup = function (f) {
            $scope.vm.EmailFrom = "";
            $scope.vm.EmailPassword = "";
            $scope.vm.EmailSMTP = '';
            $scope.vm.EnableSsl = "Yes";
            $scope.vm.EmailPort = '';
            $scope.vm.EmailLicense = '';
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/emailsettingsPopup.html',
                parent: angular.element($document.body),
                targetEvent: f,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.EmailSettingadd = function () {
            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/emailsetting/update",
                    data: {
                        _id: $scope.ESID,
                        EmailFrom: $scope.vm.EmailFrom,
                        EmailPassword: $scope.vm.EmailPassword,
                        EmailSMTP: $scope.vm.EmailSMTP,
                        EnableSsl: $scope.vm.EnableSsl,
                        EmailPort: $scope.vm.EmailPort,
                        EmailLicense: $scope.vm.EmailLicense,
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshEmailSetting();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/emailsetting/add",
                    data: {
                        Client_Id: Client_Id,
                        EmailFrom: $scope.vm.EmailFrom,
                        EmailPassword: $scope.vm.EmailPassword,
                        EmailSMTP: $scope.vm.EmailSMTP,
                        EnableSsl: $scope.vm.EnableSsl,
                        EmailPort: $scope.vm.EmailPort,
                        EmailLicense: $scope.vm.EmailLicense,
                        CreatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshEmailSetting();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Emailsettinginfo = function (e, EmailsettingID) {
            $scope.ESID = EmailsettingID;
            $scope.Update = true;
            $scope.vm.EmailFrom = '';
            $scope.vm.EmailPassword = '';
            $scope.vm.EmailSMTP = '';
            $scope.vm.EnableSsl = '';
            $scope.vm.EmailPort = '';
            $scope.vm.EmailLicense = '';
            try {
                var item = $scope.Emailsettingdatas.filter(function (item) {
                    return item.id === EmailsettingID;
                })[0];
                $scope.id = item.id;
                $scope.vm.EmailFrom = item.EmailFrom;
                $scope.vm.EmailPassword = item.EmailPassword;
                $scope.vm.EmailSMTP = item.EmailSMTP;
                $scope.vm.EnableSsl = item.EnableSsl;
                $scope.vm.EmailPort = item.EmailPort;
                $scope.vm.EmailLicense = item.EmailLicense;
            } catch (e) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/generalsetting/emailsettingsPopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function generalsettingcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        function RefreshEmailSetting() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/emailsetting",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Emailsettingdata) {
                $scope.Emailsettingdatas = Emailsettingdata.data.data;
            });
        }

        $scope.EnableSSL = [
            { "name": "Yes" },
            { "name": "No" }];


        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.saveClientBank = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/clientbank/update",
                    data: {
                        _id: $scope.SID,
                        BankName: $scope.vm.BankName,
                        AccountNumber: $scope.vm.AccountNumber,
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $scope.vm.BankName = "";
                    $scope.vm.AccountNumber = "";
                    $scope.ClientBankform.$setPristine();
                    $scope.ClientBankform.$setUntouched();
                    RefreshClientbank();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/clientbank/add",
                    data: {
                        BankName: $scope.vm.BankName, Client_Id: Client_Id,
                        AccountNumber: $scope.vm.AccountNumber,
                        CreatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    $scope.vm.BankName = "";
                    $scope.vm.AccountNumber = "";
                    $scope.ClientBankform.$setPristine();
                    $scope.ClientBankform.$setUntouched();
                    RefreshClientbank();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Clientbankinfo = function (CID) {

            $scope.SID = CID;
            $scope.Update = true;
            try {
                var CBArray = $scope.Clientbankdatas;
                var item = CBArray.filter(function (item) {
                    return item._id === CID;
                })[0];

                $scope.id = item._id;
                $scope.vm.BankName = item.BankName;
                $scope.vm.AccountNumber = item.AccountNumber;
            } catch (err) { }

        }

        function RefreshClientbank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/clientbank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Clientbankdata) {
                $scope.Clientbankdatas = Clientbankdata.data.data;
            });

            $scope.Update = false;
        }
        $scope.saveClaimCategory = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/claimcategory/update",
                    data: {
                        _id: $scope.SID,
                        CategoryName: $scope.vm.CategoryName,
                        Description: $scope.vm.Description,
                        UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    $scope.vm.CategoryName = "";
                    $scope.vm.Description = "";
                    $scope.ClaimCategoryform.$setPristine();
                    $scope.ClaimCategoryform.$setUntouched();
                    RefreshClaimCategory();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/claimcategory/add",
                    data: {
                        Client_Id: Client_Id,
                        CategoryName: $scope.vm.CategoryName,
                        Description: $scope.vm.Description,
                        CreatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    $scope.vm.CategoryName = "";
                    $scope.vm.Description = "";
                    $scope.ClaimCategoryform.$setPristine();
                    $scope.ClaimCategoryform.$setUntouched();
                    RefreshClaimCategory();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }
        $scope.ClaimCategoryinfo = function (CID) {

            $scope.SID = CID;
            $scope.Update = true;
            try {
                var CBArray = $scope.ClaimCategorydatas;
                var item = CBArray.filter(function (item) {
                    return item._id === CID;
                })[0];

                $scope.id = item._id;
                $scope.vm.CategoryName = item.CategoryName;
                $scope.vm.Description = item.Description;

            } catch (err) { }

        }

        function RefreshClaimCategory() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/claimcategory",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ClaimCategorydata) {

                $scope.ClaimCategorydatas = ClaimCategorydata.data.data;
            });

            $scope.Update = false;
        }

        $scope.FinancialYearTab = function () {

            $scope.FinancialYearSelect = true;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.ClientBankSelect = false;
            $scope.ClaimCategorySelect = false;
            $scope.SearchValue = "";
        };

        $scope.FinancialPeriodTab = function () {
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = true;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };

        $scope.ChartofAccountTab = function () {

            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = true;
            $scope.ClaimCategorySelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };

        $scope.GSTTab = function () {
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.ClaimCategorySelect = false;
            $scope.BankSelect = false;
            $scope.GSTSelect = true;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };

        $scope.BankTab = function () {
            $scope.BankSelect = true;
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.ClaimCategorySelect = false;
            $scope.GSTSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };

        $scope.ClientBankTab = function () {

            $scope.ClientBankform.$setPristine();
            $scope.ClientBankform.$setUntouched();
            $scope.ClientBankSelect = true;
            $scope.ClaimCategorySelect = false;
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.SearchValue = "";
            $scope.vm.BankName = "";
            $scope.vm.AccountNumber = "";
            $scope.Update = false;
        };

        $scope.ClaimCategoryTab = function () {

            $scope.ClaimCategoryform.$setPristine();
            $scope.ClaimCategoryform.$setUntouched();
            $scope.ClientBankSelect = false;
            $scope.ClaimCategorySelect = true;
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.SearchValue = "";
            $scope.vm.CategoryName = "";
            $scope.vm.Description = "";
            $scope.Update = false;
        };

        $scope.AccountCodeSetup = function () {

            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = true;
            $scope.EmailSettingSelect = false;
            $scope.ClaimCategorySelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };

        $scope.EmailSetting = function () {
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = true;
            $scope.ClaimCategorySelect = false;
            $scope.GSTSelect = false;
            $scope.BankSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        };


        $scope.FinancialYearExport = function () {
            alasql('SELECT * INTO XLSX("FinancialYear.xlsx",{headers:true}) FROM ?', [$scope.FinancialYeardatas]);
        };
        $scope.FinancialPeriodExport = function () {
            alasql('SELECT * INTO XLSX("FinancialPeriod.xlsx",{headers:true}) FROM ?', [$scope.FinancialPerioddatas]);
        };
        $scope.ChartofAccountExport = function () {
            alasql('SELECT * INTO XLSX("ChartofAccount.xlsx",{headers:true}) FROM ?', [$scope.ChartofAccountatas]);
        };
        $scope.GSTExport = function () {
            alasql('SELECT * INTO XLSX("GST.xlsx",{headers:true}) FROM ?', [$scope.GSTdatas]);
        };
        $scope.BankExport = function () {
            alasql('SELECT * INTO XLSX("Banks.xlsx",{headers:true}) FROM ?', [$scope.Bankdatas]);
        };

        $scope.ClientBankExport = function () {
            alasql('SELECT * INTO XLSX("ClientBanks.xlsx",{headers:true}) FROM ?', [$scope.Clientbankdatas]);
        };
        $scope.AccountCodeSetupExport = function () {
            alasql('SELECT * INTO XLSX("Accountcodesetup.xlsx",{headers:true}) FROM ?', [$scope.Accountcodesetupdatas]);
        };
        $scope.EmailSettingExport = function () {
            alasql('SELECT * INTO XLSX("EmailSettings.xlsx",{headers:true}) FROM ?', [$scope.Emailsettingdatas]);
        };
        $scope.ClaimCategoryExport = function () {
            alasql('SELECT * INTO XLSX("ClaimCategories.xlsx",{headers:true}) FROM ?', [$scope.ClaimCategorydatas]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $scope.XeroTab = function () {
            $scope.FinancialYearSelect = false;
            $scope.FinancialPeriodSelect = false;
            $scope.ChartofAccountSelect = false;
            $scope.AccountCodeSetupSelect = false;
            $scope.EmailSettingSelect = false;
            $scope.ClaimCategorySelect = false;
            $scope.BankSelect = false;
            $scope.GSTSelect = false;
            $scope.ClientBankSelect = false;
            $scope.SearchValue = "";
        }

        function getXeroData() {
            $http
                .get($rootScope.WebURL + "/xeroConnections/getbyClientId")
                .then(function (Glist) {
                    if (Glist.data.data.length > 0) {
                        $scope.TennatName = Glist.data.data.map(function (m) { return m.tenantName }).join(", ")
                        $scope.xeroStatus = "connected";
                    }

                    else
                        $scope.xeroStatus = "not connected";
                })
        }

        $scope.RemoveXero = function () {
            $http
                .get($rootScope.WebURL + "/xeroConnections/delete")
                .then(function (data) {
                    getXeroData()
                })
        }


        $scope.ConnectXero = function () {
            $http
                .get($rootScope.WebURL + "/xeroConnections/connectXero")
                .then(function (response) {
                    const connectUrl = response.data;

                    // ✅ open new popup window for OAuth consent
                    const authWindow = window.open(connectUrl, "_blank", "width=600,height=700");

                    // ✅ listen for message from popup
                    const expectedOrigin = $rootScope.XerobURL;
                    console.log("expectedOrigin:", expectedOrigin);
                    const handleMessage = function (event) {
                        console.log("Received message from:", event, "and event origin:", event.origin, "with data:", event.data);
                        if (event.origin !== expectedOrigin) return;

                        if (event.data === "xero-connected") {
                            $scope.$applyAsync(function () {
                                $scope.xeroStatus = "connected";
                                getXeroData()
                            });
                        } else if (event.data === "xero-failed") {
                            $scope.$applyAsync(function () {
                                alert("❌ Xero connection failed");
                            });
                        }

                        // ✅ close popup and remove listener
                        if (authWindow) authWindow.close();
                        window.removeEventListener("message", handleMessage);
                    };

                    window.addEventListener("message", handleMessage);
                })
                .catch(function (error) {
                    console.error("Error connecting to Xero:", error);
                    $mdToast.show($mdToast.simple().textContent('❌ Failed to start Xero connection').position('top center'));
                });
        };


    }

})();
(function () {
    'use strict';

    angular

        .module('app.accounts.expenseclaim', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_expenseclaim', {
            url: '/Expenseclaim',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/expenseclaim/expenseclaim.html',
                    controller: 'ExpenseclaimController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/expenseclaim');
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.expenseclaim')
        .controller('ExpenseclaimController', ExpenseclaimController);
    /** @ngInject */
    function ExpenseclaimController($mdDateLocale, $scope, $rootScope, $interval, $location, $mdSidenav, $mdToast, $mdDialog, $document, $http, $log, $window, Upload) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Expense")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }


        $rootScope.LoginedUser = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');
        var LoggedEmployeeID = localStorage.getItem('EmployeeID');

        RefreshGrid();
        RefreshEmployeeGrid();
        RefreshGSTGrid();
        RefreshClaimCategory();

        $scope.Materialform = false;
        $scope.ViewMaterialform = false;
        $scope.Materialgrid = true;
        $scope.mrExport = true;
        $scope.mrAdd = true;
        $scope.mrSearch = true;
        $scope.mrView = false;

        $scope.clearSearchTerm = function () {
            $scope.vm.searchTerm = '';
        }

        $scope.printToCart = function (PId) {
            debugger
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "ExpenseClaim.aspx?ID=" + PId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.Add = function () {
            debugger
            ClearForm();
            $scope.Expenseclaimdetailsdatas = null;
            $scope.Material = false;
            $scope.Update = false;
            $scope.Materialform = true;
            $scope.ViewMaterialform = false;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrAdd = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Date = new Date();
            $scope.Cancel = false;
            $scope.basicForm.$setPristine();
            $scope.basicForm.$setUntouched();

            var AR = "EXP-";

            var info = $scope.Expenseclaimdatas
            for (var x = 0; x <= 1 + info.length; x++) {
                if (x < 10) {
                    var y = "00000" + x;
                }
                else if (y < 100) {
                    y = "0000" + x;
                }
                else if (y < 1000) {
                    y = "000" + x;
                }
                else if (y < 10000) {
                    y = "00" + x;
                }
                else if (y < 100000) {
                    y = "0" + x;
                }
                else {
                    y = x;
                }
            }

            $scope.ReferenceNumber = AR + y;
            LoadDeafaultEmployee();
        }

        $scope.Export = function () {
            alasql('SELECT * INTO XLSX("Expenseclaimdetailsdatas.xlsx",{headers:true}) FROM ?', [$scope.Expenseclaimdetailsdatas]);
        };

        $scope.Showgrid = function () {
            $scope.Materialgrid = true;
            $scope.Materialform = false;
            $scope.ViewMaterialform = false;
            $scope.mrExport = true;
            $scope.mrAdd = true;
            $scope.mrView = false;
            $scope.mrSearch = true;
            $scope.Material = false;
            $scope.Cancel = false;
        }

        $scope.Expenseclaiminfo = function (MRId) {
            debugger
            $scope.SID = MRId;
            try {
                var Expenseclaimarray = $scope.Expenseclaimdatas;
                var Expenseclaimitem = Expenseclaimarray.filter(function (item) {
                    return item._id === MRId;
                })[0];

                $scope.Status = Expenseclaimitem.Status;
                $scope.StatusID = parseInt(Expenseclaimitem.StatusID);
            } catch (err) { }

            if ($scope.Status != "New" && $scope.StatusID != "1") {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Alert')
                        .textContent('Access Denied')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                );
            }
            else {
                $scope.Update = true;

                $scope.Materialform = true;
                $scope.ViewMaterialform = false;
                $scope.Materialgrid = false;
                $scope.mrExport = false;
                $scope.mrAdd = false;
                $scope.mrSearch = false;
                $scope.mrView = true;
                $scope.Cancel = false;
                $scope.Material = true;
                try {
                    var Expenseclaimarray = $scope.Expenseclaimdatas;
                    var Expenseclaimitem = Expenseclaimarray.filter(function (item) {
                        return item._id === MRId;
                    })[0];

                    $scope.id = Expenseclaimitem._id;
                    $scope.ReferenceNumber = Expenseclaimitem.ReferenceNumber;
                    $scope.EmployeeID = Expenseclaimitem.EmployeeID;
                    $scope.Date = new Date(Expenseclaimitem.Date);
                    $scope.Remarks = Expenseclaimitem.Remarks;
                    $scope.Status = Expenseclaimitem.Status;
                    $scope.StatusID = parseInt(Expenseclaimitem.StatusID);
                } catch (err) { }

                if ($scope.Status == "New" && $scope.StatusID == "1") {
                    $scope.Cancel = true;
                }

                var response = $http({
                    url: $rootScope.WebURL + "/expenseclaimdetails/getbyExpenseID",
                    method: "POST",
                    data: { ExpenseclaimID: $scope.ReferenceNumber },
                });
                response.then(function (Expenseclaimdetailsdata) {
                    $scope.Expenseclaimdetailsdatas = Expenseclaimdetailsdata.data.data;
                });
                RefreshAttachmentGrid();
            }
        }

        $scope.ViewExpenseclaiminfo = function (ReqId) {

            debugger
            $scope.SID = ReqId;

            $scope.Update = true;

            $scope.Materialform = false;
            $scope.ViewMaterialform = true;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrAdd = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Cancel = false;

            $scope.Material = true;
            try {
                var Expenseclaimarray = $scope.Expenseclaimdatas;
                var Expenseclaimitem = Expenseclaimarray.filter(function (item) {
                    return item._id === ReqId;
                })[0];

                $scope.id = Expenseclaimitem._id;
                $scope.ExpenseclaimID = Expenseclaimitem._id;
                $scope.ReferenceNumber = Expenseclaimitem.ReferenceNumber;
                $scope.EmployeeID = Expenseclaimitem.EmployeeID;
                $scope.EmployeeName = item.Employeedetails[0].EmployeeName
                $scope.EID = item.Employeedetails[0].EmployeeID
                $scope.Date = new Date(Expenseclaimitem.Date);
                $scope.Remarks = Expenseclaimitem.Remarks;
                if (Expenseclaimitem.QRCode != null && Expenseclaimitem.QRCode != "" && Expenseclaimitem.QRCode != undefined) {
                    $scope.QRCode = decode_base64(Expenseclaimitem.QRCode);
                }
                $scope.Status = Expenseclaimitem.Status;
                $scope.StatusID = parseInt(Expenseclaimitem.StatusID);
            } catch (err) { }

            //var myArray = $scope.Employeedatas;

            //var item = myArray.filter(function (item) {
            //    return item.id === $scope.EmployeeID;
            //})[0];
            //$scope.EmployeeName = item.EmployeeName
            //$scope.EID = item.EmployeeID

            var response = $http({
                url: $rootScope.WebURL + "/expenseclaimdetails/getbyExpenseID",
                method: "POST",
                data: { ExpenseclaimID: $scope.ReferenceNumber },
            });
            response.then(function (Expenseclaimdetailsdata) {
                $scope.Expenseclaimdetailsdatas = Expenseclaimdetailsdata.data.data;
            });
            RefreshAttachmentGrid()
        }

        $scope.mSubmit = function () {
            debugger


            if ($scope.Attachmentdatas == undefined || $scope.Attachmentdatas.length == 0) {
                $mdToast.show($mdToast.simple().textContent('Please Attach Supporting Documents & Click Submit!').position('top center'));
                return;
            }


            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.SID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.Status,
                        StatusID: $scope.StatusID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/expenseclaim/add",
                    data: {
                        Client_Id: Client_Id,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "New",
                        StatusID: "1",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim Request",
                            Action: "New",
                            ActionedBy: $rootScope.createdName,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));

                    RefreshGrid();
                    $scope.Showgrid();


                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }

        }

        $scope.cancelrequest = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Cancelled",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim Request",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));

                    RefreshGrid();
                    $scope.Showgrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Uploadfiles = function (file) {
            var file = file[0].file
            debugger
            var response = Upload.upload({
                url: $rootScope.WebURL + "/expenseclaim/upload",
                data: { file: file }
            }).then(function (resp) {
                debugger
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID,
                            TableName: "Expense Claim Request",
                            FileID: $scope.ReferenceNumber,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null,
                            IsActive: "true",
                            CreatedBy: $rootScope.LoginID,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }

            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }

        function RefreshEmployeeGrid() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Employeedata) {

                $scope.Employeedatas = Employeedata.data.data;

            });
        }
        function LoadDeafaultEmployee() {
            debugger
            try {
                var item1 = $scope.Employeedatas.filter(function (item) {
                    return item.EmployeeID === LoggedEmployeeID;
                })[0];
                $scope.EmployeeID = item1.id;
            } catch (error) {
            }
        }

        function RefreshGSTGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/gsttax",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (GSTdata) {
                $scope.GSTdatas = GSTdata.data.data;
            });
        }


        function RefreshAttachmentGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.ReferenceNumber },
            });
            response.then(function (attachmentdata) {
                debugger
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expenseclaim/getByLoginID",
                method: "POST",
                data: { LoginID: $rootScope.LoginID },
            });
            response.then(function (Expenseclaimdata) {
                $scope.Expenseclaimdatas = Expenseclaimdata.data.data;
            });

        }

        function RefreshClaimCategory() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/claimcategory",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ClaimCategorydata) {

                $scope.ClaimCategorydatas = ClaimCategorydata.data.data;
            });

        }
        function ClearForm() {
            $scope.ReferenceNumber = '';
            $scope.EmployeeID = '';
            $scope.Date = '';
            $scope.Remarks = '';
            $scope.Status = '';
            $scope.StatusID = '';
        }

        $scope.Materialpopup = function (e) {
            debugger
            $scope.vm.Description = '';
            $scope.vm.Amount = '';
            $scope.vm.Notes = '';
            $scope.vm.GSTID = '';
            $scope.vm.BillAttached = null;
            $scope.CreatePaymentVoucher = false;
            $scope.MUpdate = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/expenseclaim/expenseclaimpop.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ExpenseclaimController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.CheckAmount = function (e) {
            debugger

            if ($scope.vm.Amount > 100) {
                $scope.CreatePaymentVoucher = true;
            }
            else {
                $scope.CreatePaymentVoucher = false;
            }
        }


        //$http.get( $rootScope.WebURL + "/employee")
        //    .then(function (Employeedata) {
        //        debugger
        //        $scope.Employeedatas = Employeedata.data.data;
        //    });

        //$scope.GoPaymentVoucher = function (e) {
        //    debugger
        //    $mdDialog.cancel();
        //    var $popup = $window.open('PaymentVoucher', "popup");
        //}

        $scope.ExpenseclaimdetailsAdd = function () {
            debugger
            if ($scope.vm.Amount > 100) {
                $mdToast.show($mdToast.simple().textContent('Maximum Amount you can claim is 100$!!!').position('top center'));
                return
            }

            var GST = null;
            if ($scope.vm.GSTID == undefined) {
            }
            else {
                GST = $scope.vm.GSTID;
            }

            if ($scope.MUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaimdetails/update",
                    data: {
                        _id: $scope.MID,
                        ExpenseclaimID: $scope.ReferenceNumber,
                        Description: $scope.vm.Description,
                        Amount: $scope.vm.Amount,
                        Notes: $scope.vm.Notes,
                        BillAttached: $scope.vm.BillAttached,
                        GSTID: GST,
                        CategoryID: $scope.vm.ClaimCategoryID,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMaterialGrid();

                    $scope.Materialform = true;
                    $scope.ViewMaterialform = false;
                    $scope.Materialgrid = false;
                    $scope.mrExport = false;
                    $scope.mrAdd = false;
                    $scope.mrSearch = false;
                    $scope.mrView = true;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                debugger
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/expenseclaimdetails/add",
                    data: {
                        ExpenseclaimID: $scope.ReferenceNumber,
                        Description: $scope.vm.Description,
                        Amount: $scope.vm.Amount,
                        Notes: $scope.vm.Notes,
                        BillAttached: $scope.vm.BillAttached,
                        GSTID: GST,
                        CategoryID: $scope.vm.ClaimCategoryID,
                        CreatedBy: $rootScope.LoginID,
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMaterialGrid();

                    $scope.Materialform = true;
                    $scope.ViewMaterialform = false;
                    $scope.Materialgrid = false;
                    $scope.mrExport = false;
                    $scope.mrAdd = false;
                    $scope.mrSearch = false;
                    $scope.mrView = true;

                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.Expenseclaimdetailsupdate = function (e, RMaterialId) {
            debugger
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/expenseclaim/expenseclaimpop.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ExpenseclaimController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.CreatePaymentVoucher = false;
            $scope.MUpdate = true;
            $scope.MID = RMaterialId;
            angular.forEach($scope.Expenseclaimdetailsdatas, function (value, key) {
                if (RMaterialId == value._id) {

                    $scope.ExpenseclaimID = value.ExpenseclaimID,
                        $scope.vm.Description = value.Description;
                    $scope.vm.Notes = value.Notes;
                    $scope.vm.Amount = parseInt(value.Amount);
                    $scope.vm.GSTID = value.GSTID;
                    $scope.vm.ClaimCategoryID = value.CategoryID;
                    if (value.BillAttached == true) { $scope.vm.BillAttached = { value: true, } } else { $scope.vm.BillAttached = { value: false, }; }
                }
            });
        }

        $scope.Expenseclaimdetailsdelete = function (e, deleteID) {
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/expenseclaim/expenseclaimdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function ExpenseclaimController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deleteID = deleteID;
        }

        $scope.Mdelete = function (deleteID) {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/expenseclaimdetails/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                debugger
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshMaterialGrid();

                $scope.Materialform = true;
                $scope.ViewMaterialform = false;
                $scope.Materialgrid = false;
                $scope.mrExport = false;
                $scope.mrAdd = false;
                $scope.mrSearch = false;
                $scope.mrView = true;

                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        function RefreshMaterialGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expenseclaimdetails/getbyExpenseID",
                method: "POST",
                data: { ExpenseclaimID: $scope.ReferenceNumber },
            });
            response.then(function (Expenseclaimdetailsdata) {
                $scope.Expenseclaimdetailsdatas = Expenseclaimdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }


        //$http.get( $rootScope.WebURL + "/gsttax")
        //.then(function (GSTdata) {
        //    $scope.GSTdatas = GSTdata.data.data;
        //});

        $scope.Print = function (invoice, PId) {
            debugger

            $scope.PrintID = PId;

            var Expenseclaimarray = $scope.Expenseclaimdatas;
            var Expenseclaimitem = Expenseclaimarray.filter(function (item) {
                return item._id === PId;
            })[0];

            $scope.id = Expenseclaimitem._id;
            $scope.ReferenceNumber = Expenseclaimitem.ReferenceNumber;
            $scope.EmployeeID = Expenseclaimitem.EmployeeID;
            $scope.Date = new Date(Expenseclaimitem.Date);
            $scope.Remarks = Expenseclaimitem.Remarks;
            if (Expenseclaimitem.QRCode != null && Expenseclaimitem.QRCode != "" && Expenseclaimitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Expenseclaimitem.QRCode);
            }
            $scope.Status = Expenseclaimitem.Status;
            $scope.StatusID = parseInt(Expenseclaimitem.StatusID);

            var myArray = $scope.Employeedatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];
            $scope.EmployeeName = item.EmployeeName
            $scope.EID = item.EmployeeID


            var response = $http({
                url: $rootScope.WebURL + "/expenseclaimdetails/getbyExpenseID",
                method: "POST",
                data: { ExpenseclaimID: $scope.ReferenceNumber },
            });
            response.then(function (Expenseclaimdetailsdata) {
                $scope.Expenseclaimdetailsdatas = Expenseclaimdetailsdata.data.data;
            });



            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;
        }

        $scope.PrintMaterial = function (invoice, MaterialID) {
            debugger
            $scope.PrintID = MaterialID;

            angular.forEach($scope.Expenseclaimdatas, function (value, key) {
                if (MaterialID == value.MaterialID) {
                    $scope.id = value._id;
                    $scope.MaterialID = value.MaterialID;
                    $scope.Employee = value.EmployeeID;
                    $scope.WorkOrder = value.WorkOrder;
                    $scope.Date = new Date(value.Date);
                    $scope.Purpose = value.Purpose;
                    $scope.Remarks = value.Remarks;
                    if (value.QRCode != null && value.QRCode != "" && value.QRCode != undefined) {
                        $scope.QRCode = decode_base64(value.QRCode);
                    }
                    $scope.Status = value.Status;
                    $scope.StatusID = parseInt(value.StatusID);
                }
            });
            angular.forEach($scope.Employeedatas, function (value1, key1) {
                if ($scope.Employee == value1.id) {
                    $scope.EmployeeName = value1.EmployeeName;
                }
            });
            angular.forEach($scope.SalesOrderdatas, function (value2, key2) {
                if ($scope.WorkOrder == value2.id) {
                    $scope.WorkOrderName = value2.SalesOrderNo;
                }
            });

            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;



        }

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();
 
(function () {
    'use strict';

    angular
        .module('app.accounts.flexischeduler', []  )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.accounts_flexischeduler', {
            url: '/Accustomscheduler',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/flexischeduler/flexischeduler.html',
                    controller: 'ACflexischedulerController as vm'
                }
            }
        });
    }

})();
(function () {

    'use strict';
    angular
        .module('app.accounts.flexischeduler')
        .controller('ACflexischedulerController', ACflexischedulerController);
    /** @ngInject */
    function ACflexischedulerController($scope, $rootScope, $interval, socket, $mdSidenav, $filter, $location, $mdToast, $http, moment, calendarConfig, $timeout, $q, $log, $mdDialog, $document, $window, $locale, NgMap, Upload) {
        document.getElementsByTagName('title')[0].text = "Accounts-Daily Scheduler"
        NgMap.getMap().then(function (map) {
            console.log(map.getCenter());
            console.log('markers', map.markers);
            console.log('shapes', map.shapes);
        });
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("AcDScheduler")) {   // do nothing 
        }
        else { window.location = 'NoAccess'; }

        // capitalize first letter
        String.prototype.capitalize = function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        }



        $rootScope.CreatedBy = localStorage.getItem('LoginID');
        var vm = this;
        vm.Formvalid = true;
        $scope.vm.ExpiredDate = 7
        $scope.StDate = new Date()
        $scope.EnDate = new Date()
        vm.Date = new Date();
        // GetCWCdatas()
        $scope.ServiceAddressarray = [];
        $scope.cancel = function () {
            $mdDialog.cancel();
            $scope.ServiceAddressarray = [];
            $scope.CustomerServicedatas = [];
            $scope.vm.Location = null;
            $scope.vm.CompanyName = '';
            $scope.vm.WorkOrderNo = '';
            $scope.vm.ContractNo = '';
            $scope.vm.PestType = '';
            $scope.vm.SO = '';

        };
        $scope.Submit = function () {
            var item = $scope.calenderdata.filter(function (item) {
                // return item.Team_Id === $scope.vm.TeamName && $scope.vm.ServiceStartDate.getTime() >= item.startDate.getTime() && $scope.vm.ServiceStartDate.getTime() < item.endDate.getTime()
                if (item.Team_Id === $scope.vm.TeamName) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Team in this time slot !').position('top center'));
            }
            var item = $scope.calenderdata.filter(function (item) {
                if (item.Customer_id === $scope.vm.Customer_id) {
                    if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                        return true
                    else
                        if (_.inRange(new Date($scope.vm.ServiceStartDate.getTime()).getTime(), parseInt(item.startDate.getTime()) + 1, parseInt(item.endDate.getTime()) - 1))
                            return true
                        else false
                }
                else false
            })
            if (item.length > 0) {
                return $mdToast.show($mdToast.simple().textContent('Already Appointment has for same Customer in this time slot !').position('top center'));
            }
            else {

                var ASchearray = [];

                $scope.vm.ServiceOn = $filter('date')(new Date(), 'EEEE');

                angular.forEach($scope.ServiceAddressarray, function (value) {
                    ASchearray.push({
                        JobsOrders: $scope.vm.WorkOrder_id,
                        Customer: $scope.vm.Customer_id,
                        AssignedTo: $scope.vm.TeamName,
                        ServiceOn: $scope.vm.ServiceOn,
                        Status: "Yet to Start",
                        JobType: $scope.vm.JobType,
                        Startsat: new Date($scope.vm.ServiceStartDate.getTime()),
                        Endsat: new Date($scope.vm.ServiceEndDate.getTime()),
                        PestType: $scope.vm.PestType,
                        JobContinues: 'No',
                        ContractOrder: $scope.vm.ContractOrder,
                        Types: $scope.vm.SchedulingType,
                        Location: value.getLocation,
                        ContactNumber: value.sMobile,
                        ContactPerson: value.sContactPerson,
                        CustomerService_Id: value._id,
                        ScheduleType: "Custom",
                        LatLong: value.LatLong,
                        AllowBillableExport: false,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    })
                })
                // }
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/addbyarray",
                    data: { ServiceArray: ASchearray },
                }).then(function (GList) {
                    ASchearray = [];
                    $scope.ServiceAddressarray = [];
                    $scope.vm.CompanyName = '';
                    $scope.vm.WorkOrderNo = '';
                    $scope.vm.ContractNo = '';
                    $scope.vm.PestType = '';
                    $scope.vm.JobType = '';
                    $scope.vm.Location = '';
                    $scope.vm.Location = '';
                    $scope.vm.ServiceStartDate = null;
                    $scope.vm.ServiceEndDate = null
                    $mdDialog.cancel();
                    LoadSchedulerData();
                    // GetCWCdatas()
                });
            }
        };

        $scope.AddComents = function (e, SId, CancelledTab) {
            $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            CleanAddComments();
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/addcoments.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, NgMap, $locale, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.SalesOrderNo = '';
            $scope.vm.ContractReferenceNo = '';
            $scope.vm.CompanyName = '';
            $scope.vm.Types = '';
            $scope.vm.EmailSentTo = '';
            $scope.vm.ScedulId = SId;
            $scope.File_id = SId;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            $scope.Billable = { value: true };
            $scope.CollectPayment = { value: false };
            if (CancelledTab != true) {
                var item = $scope.DragScheduledJobs.filter(function (item) {
                    return item._id === SId;
                })[0];

                $scope.vm.ServiceID = item.ServiceID;
                try {
                    $scope.vm.ContractOrder = item.Contracterdetails[0].ContractReferenceNo;
                } catch (e) {
                    $scope.vm.ContractOrder = 'Ad-hoc Job'
                }
                $scope.vm.CompanyName = item.customerdetails[0].CompanyName
                $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
                $scope.vm.PestType = item.PestType;
                if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                    var array = $scope.vm.PestType.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ PestName: value });
                    });
                    $scope.Pestdatas = array1;
                    $scope.vm.PestType = array1;
                }
                getLastCompletedJob(item.JobOrdersdetails[0]._id)
                $scope.vm.Types = item.Types;
                $scope.vm.JobType = item.JobType;
                $scope.vm.PestType1 = item.PestType;
                $scope.vm.Customer_Id = item.Customer
                $scope.vm.Location = item.Location;
                $scope.vm.Status = item.Status;
                $scope.vm.Remarks = item.SpecialRemark
                $scope.CreatedBy = item.CreatedBy;
                $scope.CreatedDate = new Date(item.CreateDate);
                $scope.vm.Notes = item.AccountsNotes
                $scope.vm.Message = item.Message
                $scope.InProgressedBy = "";
                $scope.InProgresseAt = null;
                var address = $scope.vm.Location || 'Singapore';
                var geocoder = new google.maps.Geocoder();
                if (geocoder) {
                    geocoder.geocode({
                        'address': address
                    }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            $scope.latlng = [];
                            $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        }
                    });
                }
            }
            RefreshAttachmentGrid();
            Refreshcomment();
            RefreshPhotos();
            RefreshServiceMaterials();
            RefreshMobileLogMaterials();
            RefreshSchedulerLogs();
        }

        $scope.sendEmailPop = function (e) {
            $scope.Emaildatas = []
            angular.forEach($scope.Todaydatas, function (value, key) {
                var email = []
                email.push(value.CustomerEmail)
                email.push(value.ClientEmail)
                if (value.TeamName == undefined) {
                    value.TeamName = getTeamName(value.Team_Id)
                }
                $scope.Emaildatas.push({
                    code: key + 1,
                    _id: value.id,
                    ServiceId: value.ServiceID,
                    CusName: value.CustomerName,
                    TeamName: value.TeamLead,
                    CusEmail: email.map(function (o) { return o }).join(','),
                    TeamFullName: value.TeamName,
                    Startsat: value.startDate,
                    PestType: value.PestType,
                    ContactPerson: value.SiteContactName,
                    Location: value.Location,
                    TeamLead: value.TeamLead,
                    TechnicianName: value.TeamMembers
                })
            })
            console.log($scope.Emaildatas)
            // $("#popup").dxPopup({
            //     visible: true,
            //     title: 'Send Schedule',
            //     width: 800,
            //     height: 'auto',
            //     position: {
            //         my: 'center',
            //         at: 'center',
            //         of: window
            //     },
            //     dragEnabled: true,
            //     contentTemplate: function (e) {
            //         var formContainer = $("<div id='formcont'>");

            //         formContainer.append();
            //             var grid = $("<div>");
            //             formContainer.append(grid);
            //             grid.dxDataGrid({
            //                 onInitialized: function (e) {
            //                     $scope.gridInstance = e.component;
            //                 },
            //                 dataSource: $scope.Emaildatas,
            //                 showColumnLines: true,
            //                 showRowLines: true,
            //                 rowAlternationEnabled: true,
            //                 showBorders: true,
            //                 headerFilter: false,
            //                 keyExpr: "code",
            //                 paging: {
            //                     enabled: true,
            //                     pageSize: 10
            //                 },
            //                 searchPanel: {
            //                     visible: true,
            //                     highlightCaseSensitive: true,
            //                     width: 300
            //                 },
            //                 // selection: {
            //                 //     mode: "multiple"
            //                 // },
            //                 // groupPanel: {
            //                 //     visible: false
            //                 // },
            //                 // allowColumnResizing: true,
            //                 columns: [
            //                     {
            //                         caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
            //                             cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
            //                         }
            //                     },
            //                     { dataField: "CusName", caption: "Customer Name" },
            //                     { dataField: "TeamName", caption: "Team Name" },
            //                     { dataField: "ServiceId", caption: "Service Id" },
            //                     { dataField: "CusEmail", caption: "Customer Email" }
            //                     // { dataField: "TecEmail", caption: "Technician Email" }
            //                 ],
            //                 bindingOptions: {
            //                     dataSource: "Emaildatas"
            //                 },
            //                 onSelectionChanged: function (e) {
            //                     if (e.selectedRowKeys.length > 0) {
            //                         $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
            //                     }
            //                     else
            //                         $scope.SelectedMail = []
            //                 },
            //             })

            //         formContainer.append($("<br><br><div style= 'margin-left:42%'>").dxButton({
            //             text: 'Update',
            //             type: "default",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //                 UpdateSchedule($scope.vm.ID, $scope.StartDate, $scope.EndDate, $scope.TeamID, null);
            //                 showToast("Updated Successfully", ' ', "info");
            //             }
            //         }));
            //         formContainer.append($("<div style= 'margin-left:2%'>").dxButton({
            //             text: 'Cancel',
            //             type: "normal",
            //             onClick: function () {
            //                 $scope.vm.CompanyName = '';
            //                 $scope.vm.WorkOrderNo = '';
            //                 $scope.vm.ContractNo = '';
            //                 $scope.vm.PestType = '';
            //                 $scope.ServiceAddressarray = [];
            //                 $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            //                 $("#popup").dxPopup("instance").option("visible", false);
            //             }
            //         }));
            //         e.append(formContainer);
            //     }
            // });
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/EmailConfirmation.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }
        $scope.Emaildatas = []
        $scope.SelectedMail = []
        vm.EmailDataGrid = {
            // onContentReady: function (e) {
            //     e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            // },
            dataSource: $scope.Emaildatas,
            columnResizingMode: "widget",
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            headerFilter: false,
            keyExpr: "code",
            paging: {
                enabled: true,
                pageSize: 10
            },
            searchPanel: {
                visible: true,
                highlightCaseSensitive: true,
                width: 300
            },
            selection: {
                mode: "multiple"
            },
            // groupPanel: {
            //     visible: false
            // },
            // allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "CusName", caption: "Customer Name" },
                { dataField: "TeamName", caption: "Team Name" },
                { dataField: "ServiceId", caption: "Service Id", sortOrder: 'asc' },
                { dataField: "CusEmail", caption: "Customer Email" }
                // { dataField: "TecEmail", caption: "Technician Email" }
            ],
            bindingOptions: {
                dataSource: "Emaildatas"
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.SelectedMail.push.apply($scope.SelectedMail, e.selectedRowsData)
                }
                else
                    $scope.SelectedMail = []
            },
        }

        $scope.SendEmail = function () {
            if ($scope.SelectedMail.length > 0) {
                $scope.SelectedMail = _.uniqWith($scope.SelectedMail, _.isEqual)
                var group = _.groupBy($scope.SelectedMail, '_id')
                var SendEmaildatas = []
                angular.forEach(group, function (value) {
                    SendEmaildatas.push({
                        _id: value[0]._id,
                        ServiceID: value[0].ServiceId,
                        CusName: value[0].CusName,
                        CusEmail: value[0].CusEmail,
                        TeamName: value.map(function (o) { return o.TeamFullName }).join(','),
                        Startsat: value[0].Startsat,
                        PestType: value[0].PestType,
                        ContactPerson: value[0].ContactPerson,
                        Location: value[0].Location,
                        TeamLead: value.map(function (o) { return o.TeamLead }).join(','),
                        TechnicianName: value.map(function (o) { return o.TechnicianName }).join(',')
                    })
                })
                var response = $http({
                    method: 'POST',
                    url: $rootScope.WebURL + "/scheduler/SendEmail",
                    data: { Array: SendEmaildatas }
                })
                response.then(function (GList) {
                    $scope.SelectedMail
                })
                $mdToast.show($mdToast.simple().textContent('Email Sent.').position('top center'));
                $mdDialog.cancel()
            }
            else
                $mdToast.show($mdToast.simple().textContent('Sorry No data Available.').position('top center'));

        }


        // For Whatsapp

        $scope.SendWhatsap = function (e) {

        }

        function SubmitForDrag(ID, Start, End, Team) {
            Start = new Date(Start)
            End = new Date(End)
            var ServiceOn = $filter('date')(new Date(Start), 'EEEE');
            var Assigned = null
            var team = []
            var TeamName = null
            var TeamMembersName = null
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === ID
            })[0];
            var diffTime = moment(new Date(new moment(new Date(item.Endsat).toTimeString(), 'HH:mm:ss'))).diff(moment(new Date(new moment(new Date(item.Startsat).toTimeString(), 'HH:mm:ss'))), 'minutes')
            End = new Date(moment(Start).add(diffTime, 'minutes'))
            if (item.Team_Id != null && item.Team_Id != undefined) {
                if (item.Team_Id.length == 1) {
                    Assigned = Team
                    team.push(Team)
                    // var Estimation = parseInt(item.JobOrdersdetails[0].EstimatedHoursRequired)
                    // if(Estimation!=NaN)
                    // End = new Date(moment(Start).add(Estimation, 'hour'))
                    // else
                    // End = new Date(moment(Start).add(1, 'hour'))
                    TeamName = getTeamName(Team)
                    TeamMembersName = getTeamMembers(Team)
                }
                else {
                    team = item.Team_Id
                    Assigned = item.AssignedTo
                    TeamName = item.TeamName
                    TeamMembersName = item.TeamMembersName
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/DragandDropUpdate",
                data: {
                    _id: ID,
                    AssignedTo: Assigned,
                    Team_Id: team,
                    Startsat: Start,
                    Endsat: End,
                    TeamName: TeamName,
                    TeamMembersName: TeamMembersName,
                    ServiceOn: ServiceOn,
                    IsDropped: true,
                    OldDate: item.Startsat,
                    OldEndDate: item.Endsat,
                    UpdatedBy: $rootScope.createdby
                },
            }).then(function (item) {
                $mdToast.show($mdToast.simple().textContent('Job Scheduled Successfully.').position('top center'));
                LoadSchedulerData()
            })
            try {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerNotification/add",
                    data: {
                        ServiceId: ID,
                        ServiceID: item.ServiceID,
                        CustomerName: item.customerdetails[0].CompanyName,
                        Status: item.Status,
                        PreviousStartsat: item.Startsat,
                        PreviousEndsat: item.Endsat,
                        Startsat: startDate,
                        Endsat: endDate,
                        PestType: item.PestType,
                        TeamName: item.teamdetails[0].TeamName,
                        TeamLead: item.teamdetails[0].TeamLead,
                        TeamMember: item.teamdetails[0].TeamMembers,
                        Acknowledged: null,
                        AcknowledgedBy: null,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true
                    },
                }).then(function (GList) {
                });
            } catch (error) {

            }
        }

        $scope.Refresh = function () {
            $("#scheduler").dxScheduler('instance').repaint();
            $("#NewDataGrid").dxDataGrid("instance").state({})
            // angular.forEach($scope.teamdatas, function (value) {
            //     $scope.Team.push(value.id)
            // });
            RefreshGrid()

            // LoadSchedulerData();
        };



        LoadTeam();
        var resourcesData = [{
            text: "Fixed Jobs",
            id: 1,
            color: "#1e93c2"
        }, {
            text: "Contract Jobs",
            id: 2,
            color: "#29824d"
        }, {
            text: "Urgent Jobs",
            id: 3,
            color: "#FF0000"
        },
        {
            text: "Extra Jobs",
            id: 4,
            color: "#ff9747"
        },
        {
            text: "Fixed Jobs Completd",
            id: 5,
            color: "#76b3d2"
        },
        {
            text: "Contract Jobs Completd",
            id: 6,
            color: "#8dd4aa"
        },
        {
            text: "Urgent Jobs Completd",
            id: 7,
            color: "#ea9292"
        },
        {
            text: "Employee Leave",
            id: 9,
            color: "#FF9800"
        },
        {
            text: "Scheduler Service",
            id: 10,
            color: "#1527a9"
        },
        {
            text: "Scheduler Service completed",
            id: 11,
            color: "#7682de"
        }];


        $scope.Zonedata = [
            { id: 1, text: "Team South" },
            { id: 2, text: "Team East" },
            { id: 3, text: "Team West Rosdy - WEST" },
            { id: 4, text: "Richard - SOUTH" }

        ]
        $scope.uFrom = new Date();
        $scope.uTo = new Date();

        $scope.getAppointmentColor = getAppointmentColor;

        function getAppointmentColor(resourceId) {
            return DevExpress.data.query(resourcesData)
                .filter("id", resourceId)
                .toArray()[0].color;
        }

        function getTeamName(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamName
        }
        function getTeamLead(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamLead
        }
        function getTeamMembers(TeamId) {
            return DevExpress.data.query($scope.teamdatas).filter('id', TeamId).toArray()[0].TeamMembers
        }

        $scope.getListdata = function (s, p) {
            var item = $scope.Extradatas.filter(function (item) {
                return item.priority === p && item.startDate >= s && item.startDate <= s
            })
            return item
        }
        var sccount = 0
        function BindScheduler() {
            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }
            $scope.schedulerOptions = {
                dataSource: $scope.calenderdata,
                views: ["timelineDay"],
                currentView: "timelineDay",
                currentDate: $scope.uFrom,
                // adaptivityEnabled: true,
                firstDayOfWeek: 1,
                startDayHour: 6,
                endDayHour: 24,
                maxAppointmentsPerCell: "unlimited",
                cellDuration: 30,
                crossScrollingEnabled: true,
                useDropDownViewSwitcher: false,
                showAllDayPanel: false,
                groups: ["priority"],
                resources: [{
                    fieldExpr: "ownerId",
                    allowMultiple: false,
                    deep: true,
                    dataSource: resourcesData,
                    label: "Owner",
                    useColorAsDefault: true
                }, {
                    fieldExpr: "priority",
                    allowMultiple: false,
                    dataSource: $scope.Teamdatass,
                    label: "Priority"
                }],
                dataCellTemplate: function (cellData, index, container) {
                    if ($scope.ViewOption != "week") {
                        var date = new Date(cellData.startDate).getHours() + ":" + (new Date(cellData.startDate).getMinutes() == 0 ? '00' : new Date(cellData.startDate).getMinutes())
                        return $("<div style='color:#afacac ; padding-left: 30%;font-size: 12px;'>").text(date);
                    }
                },

                onContentReady: function (e) {
                    $("#scheduler .dx-scrollable").dxScrollable({
                        showScrollbar: 'always'
                    });
                    var data = e.component.option("dataSource");
                    if (data) {
                        var Ad_hoc = data.reduce(function (acc, d) {
                            if (d.Status === "Completed" && d.JobType.toLowerCase() === "ad-hoc") {
                                return acc + d.BillingAmount;
                            }
                            return acc; // <-- keep the accumulator unchanged
                        }, 0);

                        var Contract = data.reduce(function (acc, d) {
                            if (
                                d.Status === "Completed" &&
                                (d.JobType.toLowerCase() === "contract" || d.JobType.toLowerCase() === "fixed")
                            ) {
                                return acc + d.BillingAmount;
                            }
                            return acc; // <-- keep the accumulator unchanged
                        }, 0);
                        var $header = e.element.find(".dx-scheduler-header");

                        // Remove existing heading if present
                        $header.find(".custom-heading").remove();

                        // Add the new updated one
                        $header.append(
                            '<div class="custom-heading">Contract - S$ ' + Contract + ' & Ad-Hoc - S$ ' + Ad_hoc + '</div>'
                        );
                    }
                },
                onAppointmentClick: function (e) {
                    e.cancel = true
                    if (e.appointmentData.ownerId == 10) {
                        $scope.ServiceUpdate = true
                        $scope.ServiceUpdateID = e.appointmentData.id
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.ServiceTeamId = e.appointmentData.priority
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        $scope.vm.dateBox1 = {
                            ResheduleSSTime: {
                                type: "time",
                                value: $scope.serviceStartTime,
                                onValueChanged: function (e) {
                                    $scope.serviceStartTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'Start'
                                //   }
                            },
                            ResheduleSETime: {
                                type: "time",
                                value: new Date($scope.ServiceEndTime),
                                onValueChanged: function (e) {
                                    $scope.vm.AvoidEndTime = e.value
                                },
                                //   bindingOptions: {
                                //     'value': 'end'
                                //   }
                            }
                        }
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'SubmitService',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function ACflexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    if (e.appointmentData.ownerId == 11) {
                        $scope.vm.ScheduleServiceId = e.appointmentData.id;
                        $scope.vm.ServiceName = e.appointmentData.text;
                        $scope.vm.Description = e.appointmentData.Location;
                        $scope.serviceStartTime = new Date(e.appointmentData.startDate)
                        $scope.ServiceEndTime = new Date(e.appointmentData.endDate)
                        RefreshPhotos();
                        $mdDialog.show({
                            multiple: true,
                            templateUrl: 'app/main/apps/accounts/flexischeduler/addcoments.html',
                            parent: angular.element($document.body),
                            targetEvent: e,
                            scope: $scope.$new(),

                            controller: function ACflexischedulerController($scope, $mdDialog) {
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        });
                    }
                    else
                        OnAppointmentClick(e);
                },
                onOptionChanged: function (sdata) {
                    if (sdata.value == "week") {
                        $scope.ViewOption = "week"
                        $scope.WeekViewGrid = false
                        $scope.WeekDate = new Date()

                    }
                    else if (sdata.value == "timelineDay") {
                        $scope.WeekViewGrid = true
                        $scope.ViewOption = undefined
                        $scope.Datefilter()
                    }
                    else if (sdata.value instanceof Date) {
                        if ($scope.ViewOption == "week") {
                            $scope.WeekDate = new Date(sdata.value)
                        }
                        else {
                            $scope.vm.Date = new Date(sdata.value)
                            try {
                                vm.Date = new Date(sdata.value)
                            } catch (e) { }
                            $scope.Datefilter()
                        }
                    }
                    if ($scope.ViewOption != "week")
                        try {
                            if (sdata.element.context != undefined)
                                sdata.element.context.children[0].childNodes[0].childNodes[1].children[0].innerText = moment($scope.vm.Date).format('D MMM YYYY (ddd)');
                        } catch (e) { $scope.Refresh() }
                    //    sdata.component._header._navigator._$element[0].innerText = "sdfsd"
                },
                onCellClick: function (e) {
                },
                onAppointmentDblClick: function (e) {
                    $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);

                },
                appointmentTemplate: function (model, itemIndex, itemElement) {
                    var count = Math.floor((Math.random() * 10) + 1)
                    if (model.ClientInformed == false)
                        $scope.schedulerimage = "assets/images/logos/triangle.png"
                    else
                        $scope.schedulerimage = ""
                    var appointment = model
                    var Location = ""
                    var cssClass = "";
                    try {
                        if (appointment.text.includes('Service ID'))
                            Location = "Postal:- " + appointment.Location.substring(appointment.Location.lastIndexOf(" ") + 1)
                        if (appointment.ownerId == 10)
                            Location = "Address:- " + appointment.Description
                    } catch (error) {
                        Location = ""
                    }

                    var div = ""
                    var div1 = ""
                    if (model.Notes != undefined && model.Notes != null && model.Notes != "")
                        div = "&nbsp;<span class='dot1' style='background: #eebb4d;'></span>"

                    if (model.Message != undefined && model.Message != null && model.Message != "")
                        div1 = "&nbsp;<span class='dot1' style='background: #5f22af;'></span>"

                    if (model.IsUrgent == true || model.IsUrgent == "true")
                        cssClass = "blackcolor"
                    else
                        cssClass = "whiteColor"
                    //     return $("<div class='showtime-preview>" + 
                    //     "<div class="+cssClass+">" + appointment.text + "</div>" +

                    //     "<div class="+cssClass+"> Postal:-" + Location + "</div>" +
                    //     "<div class="+cssClass+">" +new Date(appointment.startDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+"-"+new Date(appointment.endDate).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})+ "</div>" +
                    //    div+"</div>"); 
                    itemElement.append("<img src='" + $scope.schedulerimage + "' width='30' height='30' style='position: absolute; right: 0; top: 0;'/>");
                    itemElement.append("<div class='" + cssClass + "'>" + appointment.text + "</div>");
                    itemElement.append("<div class='" + cssClass + "'>" + Location + "</div>")
                    itemElement.append("<div class='" + cssClass + "'>" + new Date(appointment.startDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + "-" + new Date(appointment.endDate).toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }) + div + div1 + "</div>" +
                        "</div>");

                },
                onAppointmentRendered: function (e) {
                    var appointment = e.appointmentElement;
                    var draggableAppointment = appointment.dxDraggable("instance");
                    draggableAppointment.option("area", "body");
                    e.appointmentElement.on("dxdragstart", function (evt) {
                        appointmentData = $(evt.currentTarget).data("dxItemData");
                        e.element.find(".dx-scrollable-content").css("overflow", "visible");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "visible");
                    });
                    e.appointmentElement.on("dxdragend", function (evt) {
                        e.element.find(".dx-scrollable-content").css("overflow", "hidden");
                        e.element.find(".dx-scheduler-work-space").css("overflow", "hidden");
                    });
                },
                onAppointmentUpdating: function (data) {

                    data.cancel = true;
                    return;
                },

                onAppointmentUpdated: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully.').position('top center'));
                    // showToast("Updated Successfully", ' ', "info");
                },
                onAppointmentDeleted: function (e) {
                    $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                    // showToast("Deleted Successfully", "", "warning");
                },

                bindingOptions: {
                    'dataSource': 'calenderdata',
                    "resources[1].dataSource": 'Teamdatass'

                },
                // height: $scope.Team.length>5?600: ""
            };

            $scope.vm.PreviewSpinner = false;
        }
        $timeout(function () {

            LoadSchedulerData()

        }, 3000);

        $scope.WeekViewGrid = true
        var scheduler;
        var appointmentData;


        vm.dataGridSalesOrderNew = {
            onContentReady: function (e) {
                scheduler = e.component;
                $(".dx-scheduler-date-table-cell").on("dxdrop", function (ex) {
                    $scope.DragCount++
                    if ($scope.DragCount == 1) {
                        var cellData = $(ex.target).data("dxCellData");
                        var start = cellData.startDate.getTime();
                        var end = cellData.endDate.getTime();
                        var team = cellData.groups.priority
                        var text = $(ex.draggingElement).data("text");

                    }
                });
            },

            rowTemplate: function (container, item) {
                var data = item.data;
                var result = $("<tbody class='employee dx-row " + ((item.rowIndex % 2) ? 'dx-row-alt' : '') + "'>");
                if ((item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1) <= $scope.NewSheduledJobs.length) {

                    $("<tr class='main-row'>").appendTo(result);
                    $("<td align='center'style=' border: 1px solid #ddd'>").text(item.component.pageIndex() * item.component.pageSize() + item.rowIndex + 1).appendTo(result);
                    if (data.AccountsNotes != undefined && data.AccountsNotes != null && data.AccountsNotes != "")
                        $("<td align='center' style=' border: 1px solid #ddd ; color:orange'>").text(data.ServiceID).appendTo(result);
                    else
                        $("<td align='center' style=' border: 1px solid #ddd ; color:blue'>").text(data.ServiceID).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.TeamName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SiteName).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.SMobile).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(data.Location).appendTo(result);
                    $("<td align='center' style=' border: 1px solid #ddd'>").text(new Date(data.Startsat).toLocaleDateString('en-GB')).appendTo(result);
                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PostalZone).appendTo(result);
                    $("<td  align='center' style=' border: 1px solid #ddd'>").text(data.PestCode).appendTo(result);
                    var Prefred = ""
                    var Avoid = ""
                    if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                        Prefred = new Date(data.PreferredStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.PreferredEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                        Avoid = new Date(data.AvoidStartTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) + " - " + new Date(data.AvoidEndTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
                    $("<td  align='center' style=' border: 1px solid #ddd;color:green'>").text(Prefred).append('<p style="color:red"> ' + Avoid + "</p>").append('<p style="color:black"> ' + data.PreferredTime + "</p>").appendTo(result);
                    $("</tr>").appendTo(result);
                }
                container.append(result);
            },
            dataSource: $scope.DragScheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            columnAutoWidth: false,
            wordWrapEnabled: true,
            width: "100%",
            keyExpr: "_id",
            paging: {
                enabled: false,
                pageSize: 10
            },
            // pager: {
            //     showPageSizeSelector: true,
            //     allowedPageSizes: [5, 10, 20,],
            //     showInfo: true
            // },
            sorting: {
                mode: "single"
            },
            // selection: {
            //     mode: "single",
            //     showCheckBoxesMode: 'onClick',
            // },
            searchPanel: {
                visible: false,
                width: 320,
                placeholder: "Search..."
            },
            // filterRow: {
            //     visible: true,
            //     applyFilter: "onClick"
            // },
            allowColumnResizing: true,
            onRowPrepared: function (rowInfo) {
                if (rowInfo.rowType != 'data')
                    return;
                rowInfo.rowElement
                    .addClass('myRow')
                    .data('keyValue', rowInfo.key);
            },
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "ServiceID", caption: "Service Id", alignment: 'center', width: 110 },
                { dataField: "TeamName", caption: "Team Name", alignment: 'center' },
                { dataField: "SiteName", caption: "Customer Name", alignment: 'center' },
                { dataField: "Mobile", caption: "Contact No.", alignment: 'center' },
                { dataField: "Location", caption: "Site Address", alignment: 'center' },
                { dataField: "Startsat", caption: "Scheduled Date", alignment: 'center', width: 110, dataType: "date", format: 'dd/MM/yyyy', sortOrder: 'asc' },
                // { dataField: "JobType", caption: "Job Type ", width: 110 },
                { dataField: "PostalZone", caption: "Zone", alignment: 'center', width: 110 },
                { dataField: "PestCode", caption: "Pest Types", alignment: 'center' },
                { dataField: "DateTimeofTreatment", caption: "Preferred Time", alignment: 'center', width: 150 },
            ],

            bindingOptions: {
                dataSource: "DragScheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",

        }
        var initialTop,
            initialLeft,
            initialPointerY,
            initialPointerX,
            draggedColor = "transparent";

        var dragStarted = function () {
            $(this).css("position", "fixed");
            $(this).css("z-index", 50000);
            $(this).find(".dx-scrollable-content").css("overflow", "visible");
            $(this).find(".dx-scheduler-work-space").css("overflow", "visible");

            $(this).css("background-color", draggedColor);
            initialTop = parseInt($(this).css("top"));
            initialLeft = parseInt($(this).css("left"));
            initialPointerY = arguments[0].clientY;
            initialPointerX = arguments[0].clientX;
        };
        var dragged = function () {
            $(this).css("top", initialTop + arguments[0].clientY - initialPointerY);
            $(this).css("left", initialLeft + arguments[0].clientX - initialPointerX);
        };
        var dragStopped = function () {
            $scope.DragID = this.id.split('_')[1]
            $scope.DragCount = 0
            if (this.offsetTop > 242 && this.offsetTop < 558)
                $(this).css("background-color", "green");
            else {
                $(this).css("background-color", "#cbe5e6");
                // $(this).fadeOut()
                // $("#NewDataGrid").dxDataGrid("instance").state({})
            }
        };
        $scope.SortSDate = true
        $scope.SortZone = true

        $scope.getSortValues = function (value) {
            $scope.SelectedMember = null
            if (value == "Sort by Scheduler Date") {
                if ($scope.SortSDate == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "Startsat")
                    $scope.SortSDate = false

                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "Startsat").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    $scope.SortSDate = true
                }
            }
            else {
                if ($scope.SortZone == true) {
                    $scope.DragScheduledJobs = _.sortBy($scope.DragScheduledJobs, "PostalZone")
                    $scope.SortZone = false
                }
                else {
                    var data = _.sortBy($scope.DragScheduledJobs, "PostalZone").reverse()
                    data = data.slice($scope.NewSheduledJobs.length)
                    data = data.concat($scope.NewSheduledJobs)
                    $scope.DragScheduledJobs = data
                    // $scope.DragScheduledJobs = (_.sortBy($scope.DragScheduledJobs, "PostalZone")).reverse() 
                    $scope.SortZone = true
                }
            }
        }

        $scope.SortValues = [
            { name: "Sort by Scheduler Date" },
            { name: "Sort by Zone" }
        ]

        // $scope.uShowAdhoc=function(value){
        //     $scope.CWCDatas=[]
        //     if(value){
        //         $http({
        //             method:'POST',
        //             url:'https://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //             data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //         }).then(function(Glist){
        //             var data = Glist.data.data
        //            var item=data.filter(function(item){
        //                return item.Status==='New' || item.Status==='On Going'
        //            })
        //            _.each(item,function(ite){
        //             ite.IsActive = ""
        //            })
        //             $scope.CWCDatas=item
        //             $scope.getSchedulerdatas($scope.TabStatus)
        //         })
        //     }
        //     else
        //     {
        //         GetCWCdatas()
        //     }
        // }

        $scope.GetCWCdatas = GetCWCdatas

        function GetCWCdatas() {
            $scope.StDate.setHours(0, 0, 0, 0)
            $scope.EnDate.setHours(23, 59, 59, 999)
            var array = []
            angular.forEach($scope.teamdatas, function (value) {
                array.push(value.id)
            })
            var response1 = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.StDate,
                    End_Date: $scope.EnDate,
                    Team: array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response1.then(function (GList) {
                var FlexiScheduler = GList.data.data
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.StDate,
                        End_Date: $scope.EnDate,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Status: null,
                        Team_Id: null
                    },
                });
                response.then(function (GList1) {
                    $http({
                        url: $rootScope.WebURL + "/scheduler/getAllOutstandingJobs",
                        method: "POST",
                        data: {
                            Client_Id: $rootScope.Client_Id,
                        },
                    }).then(function (List) {
                        var progerss = List.data.data
                        var data = GList1.data.data;
                        var item = data.filter(function (item) {
                            return item.Status != "Completed" && item.Status != "Cancelled" && item.Status != "Outstanding" && item.VerifiedBy == false
                        })
                        $scope.NewSheduledJobs = item
                        $scope.NewSheduledJobs = $scope.NewSheduledJobs.concat(progerss)
                        var newArray = []
                        if (newArray.length > 0)
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs.concat(newArray)
                        else
                            $scope.DragScheduledJobs = $scope.NewSheduledJobs

                        if ($("#NewDataGrid").dxDataGrid("instance") != undefined)
                            $("#NewDataGrid").dxDataGrid("instance").endCustomLoading()
                        angular.forEach($scope.DragScheduledJobs, function (value) {
                            // var item = FlexiScheduler.filter(function (item) {
                            //     return item._id === value._id
                            // })[0]
                            // if (item != undefined) {
                            //     value.PostalZone = item.PostalZone
                            // }

                            var pest = []
                            var PestArray = []
                            var NewFrequency = value.Frequency.split('||')
                            var TreatmentMethod = []
                            NewFrequency.forEach(function (val) {
                                var iittem = val.split('~')
                                TreatmentMethod.push({
                                    Frequency: iittem[0],
                                    PestName: iittem[1],
                                    Treatment: iittem[2]
                                })

                            })
                            var Frequen = _.groupBy(TreatmentMethod, "Frequency")
                            var FreqString = []
                            if (Object.keys(Frequen).length) {
                                _.each(Frequen, function (Fre, key) {
                                    var data = []
                                    _.each(Fre, function (iitem) {
                                        data.push(iitem.PestName)
                                    })
                                    var PestArray = $scope.Pesttypedatas.filter(function (pestt) { return (data.includes(pestt.PestName)) })
                                    FreqString.push(PestArray.map(function (obj) { if (obj.Pestcode != null && obj.Pestcode != undefined && obj.Pestcode != "") return obj.Pestcode; else return obj.PestName; }).join(',') + " - " + key.replace(/ *\([^)]*\) */g, ""))

                                })
                            }

                            value.PestCode = FreqString.map(function (o) { return o }).join('; ')

                            try {
                                if (value.customerServicedetails.length > 0) {
                                    value.CustomerName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    value.SMobile = value.customerServicedetails[0].sMobile
                                    if (value.customerServicedetails[0].SName != undefined && value.customerServicedetails[0].SName != null && value.customerServicedetails[0].SName != "")
                                        value.SiteName = value.customerServicedetails[0].SName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'

                                    if (value.customerServicedetails[0].sName != undefined && value.customerServicedetails[0].sName != null && value.customerServicedetails[0].sName != "")
                                        value.SiteName = value.customerServicedetails[0].sName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'
                                    else
                                        value.SiteName = value.customerdetails[0].CompanyName + ' - (' + value.customerServicedetails[0].sContactPerson + ')'


                                }
                                else {
                                    value.CustomerName = value.customerdetails[0].CompanyName
                                    value.SMobile = ""
                                    value.SiteName = value.customerdetails[0].CompanyName + ' - (' + customerdetails[0].ContactPerson + ')'
                                }
                            } catch (error) {
                                value.SiteName = value.customerdetails[0].CompanyName
                            }

                            try {
                                value.PostalZone = value.zonepostalcodesdetails[0].Zone
                            } catch (error) {
                                value.PostalZone = ""
                            }


                        })
                    })
                })
            })
        }
        function OnAppointmentClick(e) {

            e.cancel = true;
            var item = $scope.TotalDatas.filter(function (item) {
                return item.id === e.appointmentData.id && item.Team_Id === e.appointmentData.Team_Id
            })[0]
            var data = item
            if (data.TeamMembers == undefined) {
                data.TeamMembers = getTeamMembers(data.Team_Id)
            }
            $scope.TeamMembers = data.TeamMembers
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data.id
            $scope.StartDate = data.startDate
            $scope.EndDate = data.endDate
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.CustomerName
            $scope.vm.DServiceAddres = data.ServiceAddres
            $scope.vm.DClientContactName = data.ClientContactName
            $scope.vm.Duplicate = data.Duplicate
            $scope.vm.DuplicateRemarks = data.DuplicateRemarks
            $scope.vm.PaymentTerms = data.PaymentMode
            $scope.vm.DSiteContactName = data.SiteContactName
            $scope.vm.DClientEmail = data.ClientEmail
            $scope.vm.DSiteContactNumber = data.SiteContactNumber
            $scope.vm.DCoverageArea = data.CoverageArea
            $scope.vm.DSalesOrderNo = data.SalesOrderNo
            $scope.vm.TotalTeam = data.TotalTeam
            $scope.vm.ManHour = data.ManHour
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            if (data.TeamName == undefined) {
                data.TeamName = getTeamName(data.Team_Id)
            }
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = data.startDate
            $scope.vm.ServiceEndDate = data.endDate
            $scope.vm.PreferedTime = data.PreferedTime
            $scope.vm.jobdata = data.SalesOrder_Id
            $scope.vm.Customer_Id = data.Customer_id
            $scope.vm.ScedulId = data.id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.Notes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob(data.SalesOrder_Id)
            getCustomer(data.Customer_id)
            getContract(data.Contract_Id)
            getSalesOrder(data.SalesOrder_Id)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }

        function DragTableClick(e, SId) {
            var item = $scope.DragScheduledJobs.filter(function (item) {
                return item._id === SId;
            })[0];
            var data = item
            $scope.TeamMembers = data.TeamMembersName
            try {
                var Freq = data.Frequency.split('||')
                var Fdata = []
                var count = 0
                angular.forEach(Freq, function (item) {
                    var treat = item.split('~')
                    Fdata.push({
                        id: count++,
                        Frequency: treat[0],
                        PestType: treat[1],
                        Treatment: treat[2],
                    })
                })
                $scope.Freqq = Fdata
            } catch (e) { }

            $scope.TeamID = data.Team_Id
            $scope.vm.ID = data._id
            $scope.StartDate = new Date(data.Startsat)
            $scope.EndDate = new Date(data.Endsat)
            if (data.PreferredStartTime != null && data.PreferredStartTime != undefined && data.PreferredStartTime != "")
                $scope.vm.PreferenceTime = $filter('date')(new Date(data.PreferredStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.PreferredEndTime), 'hh:mm a');
            if (data.AvoidStartTime != null && data.AvoidStartTime != undefined && data.AvoidStartTime != "")
                $scope.vm.AvoidTime = $filter('date')(new Date(data.AvoidStartTime), 'hh:mm a') + ' - ' + $filter('date')(new Date(data.AvoidEndTime), 'hh:mm a');
            $scope.vm.DServiceID = data.ServiceID
            $scope.vm.DCustomerName = data.customerdetails[0].CompanyName
            $scope.vm.DServiceAddres = data.Location
            $scope.vm.DClientContactName = data.customerdetails[0].ContactPerson
            $scope.vm.DSiteContactName = data.customerServicedetails[0].sContactPerson
            $scope.vm.DClientEmail = data.customerdetails[0].Email
            $scope.vm.DSiteContactNumber = data.customerServicedetails[0].sMobile
            $scope.vm.DCoverageArea = data.JobOrdersdetails[0].CoverageArea
            $scope.vm.DSalesOrderNo = data.JobOrdersdetails[0].SalesOrderNo
            $scope.vm.TotalTeam = data.TeamName
            $scope.vm.ManHour = data.JobOrdersdetails[0].EstimatedHoursRequired
            $scope.vm.TeamMembers = data.TeamMembers
            $scope.vm.DTypes = data.Types
            $scope.vm.DTeamName = data.TeamName
            $scope.vm.ServiceStartDate = new Date(data.Startsat)
            $scope.vm.ServiceEndDate = new Date(data.Endsat)
            $scope.vm.PreferedTime = data.PreferredTime
            $scope.vm.jobdata = data.JobOrdersdetails[0]._id
            $scope.vm.Customer_Id = data.customerdetails[0]._id
            $scope.vm.ScedulId = data._id
            $scope.vm.SpecialRemark = data.SpecialRemark
            $scope.vm.Notes = data.AccountsNotes
            $scope.vm.Remarks = data.Message
            $scope.vm.PestType1 = data.PestType;
            $scope.center = [1.3554, 103.8677];
            $scope.latlng = [1.3554, 103.8677];
            var address = data.Location || 'Singapore';
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        $scope.latlng = [];
                        $scope.latlng.push(results[0].geometry.location.lat(), results[0].geometry.location.lng())
                        $scope.center = $scope.latlng
                    }
                });
            }
            getLastCompletedJob($scope.vm.jobdata)
            getCustomer($scope.vm.Customer_Id)
            getContract(data.JobOrdersdetails[0].ContractNo)
            getSalesOrder($scope.vm.jobdata)
            RefreshAttachmentGrid()
            Refreshcomment()
            $scope.dateBox = {
                ResheduleStartTime: {
                    type: "time",
                    value: $scope.vm.ServiceStartDate,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleStartTime = e.value
                        $scope.vm.ServiceStartDate = e.value
                        $scope.vm.ServiceEndDate = new Date(new Date($scope.vm.ResheduleStartTime).setHours(new Date($scope.vm.ResheduleStartTime).getHours() + 1))
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceStartDate'
                    }
                },
                ResheduleEndTime: {
                    type: "time",
                    value: $scope.vm.ServiceEndDate,
                    onValueChanged: function (e) {
                        $scope.vm.ServiceEndDate = e.value
                    },
                    bindingOptions: {
                        'value': 'vm.ServiceEndDate'
                    }
                },
                ResheduleFrom: {
                    type: "date",
                    displayFormat: "dd/MM/yyy",
                    value: $scope.StartDate,
                    onValueChanged: function (e) {
                        $scope.StartDate = e.value
                    },
                    bindingOptions: {
                        'value': 'StartDate'
                    }
                }
            }
            $scope.vm.dataGridFreqGrid = {
                onInitialized: function (e) {
                    dataGrid = e.component;
                },
                dataSource: $scope.Freqq,
                keyExpr: "id",
                //  height: '50%',
                paging: {
                    enabled: false,
                    pageSize: 5
                },
                pager: {
                    showPageSizeSelector: false,
                    allowedPageSizes: [10, 20, 50, 100],
                    showInfo: false
                },
                searchPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                            cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                        },
                        allowEditing: false
                    },
                    { dataField: "Frequency", caption: "Frequency" },
                    { dataField: "PestType", caption: "Pest Type" },
                    { dataField: "Treatment", caption: "Treatments" },
                ],
                bindingOptions: {
                    dataSource: "Freqq",
                    showColumnLines: "true",
                    showRowLines: "true",
                    showBorders: "true",
                    rowAlternationEnabled: "false",
                    filterRow: "false",
                },
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/NewAdd.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $timeout(function () {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
            }, 199, false);

        }


        $scope.getAdhocJobs = function () {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + '/salesOrder/getAdHocjob',
                data: { Start_Date: null, Client_Id: $rootScope.Client_Id }
            }).then(function (Glist) {
                var data = Glist.data.data
                var item = data.filter(function (item) {
                    return item.Status === 'New' || item.Status === 'On Going'
                })
                _.each(item, function (ite) {
                    ite.IsActive = ""
                })
                $scope.NewSheduledJobs = item
            })
        }



        var currentTarget

        $("#appointmentContextMenu").dxContextMenu({
            target: ".dx-scheduler-appointment",
            items: [
                { text: "Duplicate Job...", icon: "edit" },
                { text: "Cancel...", icon: "trash" },
                { text: "Client Informed...", icon: "todo" },
                { text: "Client Not Informed...", icon: "close" }

            ],
            onItemClick: function (e) {
                var data = $(currentTarget).parents(".dx-item").data("dxItemData");
                if (data.ownerId != 9 && data.ownerId != 10) {
                    if (e.itemIndex == 0) {
                        clonejob(e, data)
                    }
                    else if (e.itemIndex == 1) {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to cancel the appointment?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                try {
                                    var item = data
                                    var ServiceOn = $filter('date')(new Date(item.startDate), 'EEEE');
                                    $scope.CompanyName = item.CustomerName;
                                    $scope.jobdata = item.SalesOrder_Id;
                                    $scope.CustomerID = item.Customer_id;
                                    $scope.AssignedTo = item.priority;
                                    $scope.Frequency = item.Frequency;
                                    $scope.Types = item.JobType;
                                    $scope.ServiceOn = ServiceOn;
                                    $scope.PestType = item.PestType;
                                    $scope.ContractOrder = item.Contract_Id;
                                    $scope.ServiceID = item.ServiceID;
                                    $scope.Status = item.Status;
                                    $scope.ServiceStartAt = new Date(item.startDate);
                                    $scope.ServiceEndAt = new Date(item.endDate);
                                } catch (e) { }
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                                    data: {
                                        _id: data.id,
                                        Status: "Cancelled",
                                        CancelRemarks: "Cancelled from Daily Scheduler",
                                        SenderEmailAddress: "",
                                        CompanyName: $scope.CompanyName,
                                        ScheduleDate: $scope.ServiceStartAt,
                                        UpdatedBy: $rootScope.createdby
                                    },
                                });
                                response.then(function (GList) {
                                    var lresponse = $http({
                                        method: "POST",
                                        url: $rootScope.WebURL + "/schedulelog/add",
                                        data: {
                                            Client_Id: $rootScope.Client_Id,
                                            JobsOrders: $scope.jobdata,
                                            Customer: $scope.CustomerID,
                                            AssignedTo: $scope.AssignedTo,
                                            Frequency: $scope.Frequency,
                                            ServiceOn: $scope.ServiceOn,
                                            Types: $scope.Types,
                                            Status: $scope.Status,
                                            Startsat: $scope.ServiceStartAt,
                                            Endsat: $scope.ServiceEndAt,
                                            PestType: $scope.PestType,
                                            ContractOrder: $scope.ContractOrder,
                                            ServiceID: $scope.ServiceID,
                                            CancelRemarks: "Cancelled from Daily Scheduler",
                                            CreatedBy: $rootScope.createdby,
                                            IsActive: true,
                                        },
                                    });
                                    lresponse.then(function (GList) {
                                        RefreshGrid();
                                        $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                                    })
                                }, function () {
                                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 2) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: true
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                    else if (e.itemIndex == 3) {
                        var result = DevExpress.ui.dialog.confirm('Does Customer has not confirm this job?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                var response = $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/scheduler/clientinformed",
                                    data: {
                                        _id: data.id,
                                        ClientInformed: false
                                    },
                                });
                                response.then(function (GList) {
                                    RefreshGrid();
                                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                                });
                            }
                        })
                    }
                }
                if (data.ownerId == 10) {
                    if (e.itemIndex != 1) {
                        $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                    }
                    else {
                        var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the Service?', 'Confirm!');
                        result.done(function (dialogResult) {
                            if (dialogResult) {
                                $http({
                                    method: "PUT",
                                    url: $rootScope.WebURL + "/schedulerservice/delete",
                                    data: {
                                        _id: data.id,
                                        Client_Id: $rootScope.Client_Id
                                    }
                                }).then(function (List) {
                                    RefreshGrid()
                                    $mdToast.show($mdToast.simple().textContent('Service deleted successfully').position('top center'));
                                })
                            }
                        })
                    }
                }
                // else {
                //     $mdToast.show($mdToast.simple().textContent('You can not do any action to this Appointment').position('top center'));
                // }
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        function clonejob(e, data) {
            $scope.vm.Title = 'Clone the Job'
            $scope.Cloneschedule = data
            $scope.vm.RescheduleSpinner = false

            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Selectedschedule.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

            $scope.vm.ResheduleSSTime = data.startDate
            $scope.vm.ResheduleSETime = data.endDate
            $scope.vm.AssignedTo = data.priority
            $scope.vm.ResheduleSRemarks = data.SpecialRemarks
            $scope.Pestdatas = data.MultiFrequency

            $scope.vm.dateBox = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.vm.ResheduleSSTime,
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSSTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date($scope.vm.ResheduleSETime),
                    onValueChanged: function (e) {
                        $scope.vm.ResheduleSETime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
        }

        $scope.SubmitClone = function () {
            var value = $scope.Cloneschedule
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/uniqueschedulerByID",
                data: {
                    _id: value.id,
                    Client_Id: $rootScope.Client_Id
                }
            }).then(function (List) {
                var value = List.data.data[0]
                var data = ""
                $scope.vm.CPestType.forEach(function (item) {
                    if (data == "")
                        data = item.Frequency + "~" + item.PestType + "~" + item.Treatment
                    else
                        data = data + "||" + item.Frequency + "~" + item.PestType + "~" + item.Treatment
                })
                var ServiceOn = $filter('date')(new Date($scope.vm.ResheduleSFrom), 'EEEE');
                var currentDate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSSTime))
                var enddate = CombineDateAndTime($scope.vm.ResheduleSFrom, new Date($scope.vm.ResheduleSETime))

                var serviceArray = [{
                    JobsOrders: (value.JobsOrders),
                    AssignedTo: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    Frequency: data,
                    ServiceOn: ServiceOn,
                    Types: value.Types,
                    Status: "Yet to Start",
                    Customer: (value.Customer),
                    Startsat: currentDate,
                    Endsat: enddate,
                    CreatedBy: $rootScope.createdBy,
                    PestType: $scope.vm.CPestType.map(function (o) { return o.PestType }).join(','),
                    ContractOrder: value.ContractOrder,
                    JobType: value.JobType,
                    ServiceReportNo: value.ServiceReportNo,
                    BillingAmount: value.BillingAmount,
                    Billable: value.Billable,
                    JobContinues: value.JobContinues,
                    CollectPayment: value.CollectPayment,
                    Location: value.Location,
                    LatLong: value.LatLong,
                    Client_Id: $rootScope.Client_Id,
                    CustomerService_Id: (value.CustomerService_Id),
                    ContactPerson: value.ContactPerson,
                    ContactNumber: value.ContactNumber,
                    Vehicle: value.Vehicle,
                    ScheduleType: value.ScheduleType,
                    SpecialRemark: $scope.vm.ResheduleSRemarks,
                    PreferredTime: value.PreferredTime,
                    PreferredStartTime: value.PreferredStartTime,
                    PreferredEndTime: value.PreferredEndTime,
                    AvoidStartTime: value.AvoidStartTime,
                    AvoidEndTime: value.AvoidEndTime,
                    Team_Id: $scope.vm.CAssignedTo.map(function (o) { return o.id }),
                    TeamName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamName }).join(','),
                    TeamMembersName: $scope.vm.CAssignedTo.map(function (o) { return o.TeamMembers }).join(','),

                }]
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/add",
                    data: {
                        ServiceArray: serviceArray
                    }
                }).then(function (List) {
                    $mdDialog.cancel()
                    $mdToast.show($mdToast.simple().textContent('Successfully Added Service Jobs').position('top center'));
                    RefreshGrid();
                })
            })
        }


        $("#emptyCellContextMenu").dxContextMenu({
            target: ".dx-scheduler-date-table-cell",
            items: [
                { text: "Add Appointment...", icon: "add" }
            ],
            onItemClick: function (e) {
                var data = $(currentTarget).data("dxCellData");
                console.log(data);
            },
            onShowing: function (e) {
                currentTarget = e.jQEvent.target;
            }
        });

        $scope.RefreshSchedule = function () {

            if ($scope.teamdatas == undefined) {
                LoadTeam();
            }

            LoadSchedulerData();
        }
        $scope.CloseDialog = function () {
            $mdDialog.hide();
        }

        // $scope.Team = null;
        $scope.Datefilter = function () {
            LoadSchedulerData()
        }

        function LoadSchedulerData() {
            var array = [];
            $scope.Teamdatass = []
            angular.element("#scheduler").dxScheduler('instance').option("currentDate", vm.Date)
            if ($scope.Team == null || $scope.Team == undefined || $scope.Team.length == 0) {
                angular.forEach($scope.teamdatas, function (value) {
                    array.push(value.id)
                })
                $scope.Team = null;
            }
            else {
                angular.forEach($scope.Team, function (value) {
                    var item = $scope.teamdatas.filter(function (item) {
                        return item.id == value
                    })
                    $scope.Teamdatass.push(item)
                    $scope.Teamdatass = _.flattenDeep($scope.Teamdatass)
                    $scope.Teamdatass = _.uniq($scope.Teamdatass)
                })
            }
            $scope.vm.PreviewSpinner = true;
            $scope.uFrom = new Date(vm.Date);
            $scope.uTo = new Date(vm.Date);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            $http({
                url: $rootScope.WebURL + "/calendar/datefilter",
                method: "POST",
                data: {
                    FilterStart_Date: $scope.uFrom,
                    FilterEnd_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,

                },
            }).then(function (List) {
                $scope.vm.Holiday = ""
                var item = List.data.data.filter(function (item) {
                    return item.EventType === "Holiday"
                })
                if (item.length > 0)
                    $scope.vm.Holiday = item.map(function (o) { return o.EventTitle }).join(',')
            })
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,
                    Customer_Id: null,
                    Team_Id: null
                },
            });
            response.then(function (GList) {
                $scope.AllSchedulerDatas = GList.data.data;
            })

            var response = $http({
                url: $rootScope.WebURL + "/scheduler/dateFilterFlexiSchedule",
                method: "POST",
                data: {
                    Start_Date: $scope.uFrom,
                    End_Date: $scope.uTo,
                    Team: $scope.Team || array,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                array = [];
                $scope.AutoTeam = false;
                $scope.AllScheduleDatas = GList.data.data;
                $scope.Uniqueschedulerdatas = GList.data.data;
                $scope.AllScheduleDatas = _.uniqWith($scope.AllScheduleDatas, _.isEqual)
                $scope.Uniqueschedulerdatas = _.uniqWith($scope.Uniqueschedulerdatas, _.isEqual)
                var datapush = [];
                angular.forEach($scope.Uniqueschedulerdatas, function (value) {
                    try {
                        var ownerId = [1];
                        if (value.JobType == "Contract") {
                            ownerId = [2]
                            if (value.Status == 'Completed') ownerId = [6]
                        } else if (value.JobType == "Ad-hoc") {
                            ownerId = [3]
                            if (value.Status == 'Completed') ownerId = [7]
                        }
                        else if (value.JobType == "Fixed") {
                            ownerId = [1]
                            if (value.Status == 'Completed') ownerId = [5]
                        }
                        var EndTime = CombineDateAndTime(new Date(value.Startsat), new Date(value.Endsat));
                        if (new Date(EndTime).getHours() == 0) {
                            EndTime = new Date(new Date(EndTime).setDate(new Date(EndTime).getDate() + 1))
                            EndTime.setHours(new Date(EndTime).getHours(), new Date(EndTime).getMinutes() - 1, 0, 0)
                        }
                        var Duration = GetDuration(value.Startsat, EndTime);
                        if (value.Status != "Cancelled" && value.Status != "Outstanding" && value.VerifiedBy == true) {
                            if (value.SiteName == null || value.SiteName == "" || value.SiteName == undefined)
                                value.SiteName = value.CustomerName
                            datapush.push({
                                text: value.SiteName + '\n' + 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.Startsat),
                                endDate: new Date(EndTime),
                                id: value._id,
                                Customer_id: value.Customer_id,
                                priority: value.Team_Id,
                                TimeInterval: moment(new Date(EndTime)).diff(moment(new Date(value.Startsat)), 'seconds'),
                                Location: value.Location,
                                BillingAmount: value.BillingAmount,
                                PestType: value.PestType,
                                Team_Id: value.Team_Id,
                                Frequency: value.Frequency,
                                MultiFrequency: value.MultiFrequency,
                                CustomerEmail: value.CustomerEmail,
                                TechnicianEmail: value.TechnicianEmail,
                                JobType: value.JobType,
                                Duplicate: value.Duplicate,
                                DuplicateRemarks: value.DuplicateRemarks,
                                Types: value.Types,
                                Notes: value.AccountsNotes,
                                ClientInformed: value.ClientInformed,
                                TeamName: (value.TeamName),
                                ManHour: value.ManHour,
                                Status: value.Status,
                                TeamLead: getTeamLead(value.Team_Id),
                                //  TeamName: getTeamName(value.Team_Id),
                                TeamMembers: getTeamMembers(value.Team_Id),
                                Zone: value.PostalZone,
                                ownerId: ownerId,
                                FLength: true,
                                CustomerName: value.CustomerName,
                                SalesOrderNo: value.SalesOrderNo,
                                Contract: value.ContractNo,
                                ServiceAddres: value.Location,
                                ServiceID: value.ServiceID,
                                ScheduledBy: value.CreatedBy,
                                CoverageArea: value.CoverageArea,
                                ClientContactName: value.ClientContactName,
                                ClientEmail: value.ClientEmail,
                                SiteContactName: value.SiteContactName,
                                SiteContactNumber: value.SiteContactNumber,
                                PreferedTime: value.PreferredTime,
                                PreferredStartTime: value.PreferredStartTime,
                                PreferredEndTime: value.PreferredEndTime,
                                AvoidStartTime: value.AvoidStartTime,
                                AvoidEndTime: value.AvoidEndTime,
                                SpecialRemark: value.SpecialRemark,
                                SalesOrder_Id: value.SalesOrder_Id,
                                Contract_Id: value.Contract_Id,
                                Message: value.Message,
                                IsUrgent: value.IsUrgent,
                                PaymentMode: value.PaymentMode
                            });
                        }
                    } catch (error) {
                    }
                });
                $scope.TotalDatas = datapush
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.startDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.endDate);
                });
                datapush = _.sortBy(datapush, function (dateObj) {
                    return new Date(dateObj.TimeInterval);
                });
                datapush = datapush.reverse()
                $scope.Todaydatas = datapush
                GetCWCdatas()


                $scope.calenderdata = $scope.Todaydatas
                // $scope.calenderdata = PopupArray;
                // $scope.Extradatas = ExtraArray
                $scope.vm.PreviewSpinner = false;
                var response = $http({
                    url: $rootScope.WebURL + "/leaveentitlement/getByDate",
                    method: "POST",
                    data: {
                        StartDate: $scope.uFrom,
                        EndDate: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                    },
                });
                response.then(function (GList) {
                    var Edata = []
                    angular.forEach(GList.data.data, function (value) {
                        var leavedata = $scope.calenderdata.filter(function (o) {
                            return o.id === value._id
                        })
                        if (leavedata.length == 0) {
                            if ($scope.uFrom.getDate() === new Date(value.StartDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else if ($scope.uFrom.getDate() === new Date(value.EndDate).getDate() && $scope.uFrom.getDay() != 0) {
                                if ($scope.uFrom.getDay() != 6) {
                                    if (value.FLeaveDay === "HalfDayMorning") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(13, 30, 0, 0)
                                    }
                                    else if (value.FLeaveDay === "HalfDayAftn") {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(13, 30, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(18, 0, 0, 0)
                                    }
                                    else {
                                        value.StartDate = new Date(value.StartDate)
                                        value.StartDate.setHours(6, 0, 0, 0)
                                        value.EndDate = new Date(value.EndDate)
                                        value.EndDate.setHours(23, 59, 59, 999)
                                    }
                                }
                                else {
                                    value.StartDate = new Date(value.StartDate)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date(value.EndDate)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }
                            else {
                                if ($scope.uFrom.getDay() != 6) {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(23, 59, 59, 999)

                                }
                                else {
                                    value.StartDate = new Date($scope.uFrom)
                                    value.StartDate.setHours(6, 0, 0, 0)
                                    value.EndDate = new Date($scope.uFrom)
                                    value.EndDate.setHours(13, 30, 0, 0)
                                }
                            }

                            Edata.push({
                                text: value.Type + " " + moment(value.StartDate).format('DD-MMM-YYYY') + " - " + moment(value.EndDate).format('DD-MMM-YYYY'),
                                // text: 'Service ID : ' + value.ServiceID + '\n' + 'Work Order # : ' + value.SalesOrderNo + '\n' + 'Customer Name : ' + value.CustomerName + '\n' + "Address : " + value.Location + '\n' + "Pest Type : " + value.PestType + '\n' + 'Status : ' + value.Status + '\n' + 'Scheduled By :' + value.CreatedBy,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.TeamID,
                                ownerId: [9],
                                FLength: false,
                            })
                        }
                    })
                    $scope.calenderdata = $scope.calenderdata.concat(Edata)
                    var response = $http({
                        url: $rootScope.WebURL + "/schedulerservice/datefilter",
                        method: "POST",
                        data: {
                            Start_Date: $scope.uFrom,
                            End_Date: $scope.uTo,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (gList) {
                        var Sdata = []
                        angular.forEach(gList.data.data, function (value) {
                            Sdata.push({
                                text: value.ServiceName,
                                Location: value.Description,
                                startDate: new Date(value.StartDate),
                                endDate: new Date(value.EndDate),
                                id: value._id,
                                priority: value.Team_Id,
                                ownerId: value.Status == "Completed" ? [11] : [10],
                                FLength: false,
                            })
                        })
                        $scope.calenderdata = $scope.calenderdata.concat(Sdata)

                    })
                })
            });

        }

        function getLastCompletedJob(id) {
            $http({
                method: 'POST',
                url: $rootScope.WebURL + "/scheduler/getlast",
                data: { JobId: id }
            }).then(function (List) {
                try {
                    $scope.vm.LastCompletedDate = new Date(List.data.data[0].Startsat)
                }
                catch (e) {
                    $scope.vm.LastCompletedDate = ""
                }

                try {
                    $scope.vm.LastCompletedBy = List.data.data[0].tabletschedulerrecord[0].CreatedBy.capitalize();
                } catch (error) {
                    $scope.vm.LastCompletedBy = "";
                }
            })
        }
        function getContract(Contract_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getById",
                data: { _id: Contract_Id }
            }).then(function (List) {
                var Contractdata = List.data.data
            })
        }
        function getSalesOrder(SalesOrder_Id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder/getById",
                data: { _id: SalesOrder_Id }
            }).then(function (List) {
                var SalesOrderdata = List.data.data
                $scope.vm.SalesPerson = SalesOrderdata[0].employeedetails[0].EmployeeName
                $scope.vm.OrderType = SalesOrderdata[0].OrderType
                if ($scope.vm.OrderType === "Contract") {
                    $scope.vm.ContractStart = SalesOrderdata[0].ServiceStartDate
                    $scope.vm.ContractEnd = SalesOrderdata[0].ServiceEndDate
                } else
                    $scope.vm.Occurence = SalesOrderdata[0].EnqRef
            })
        }
        function getCustomer(id) {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer/get",
                data: { id: id }
            }).then(function (List) {
                var Customerdata = List.data.data
                $scope.vm.MarketSegment = Customerdata.MarketSection
            })
        }

        function GetDuration(StartTime, EndTime) {
            var today = new Date(StartTime);
            var Christmas = new Date(EndTime);
            var diffMs = (Christmas - today); // milliseconds between now & Christmas
            var diffDays = Math.floor(diffMs / 86400000); // days
            var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
            var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

            return diffMins + ' mins';
        }
        function CombineDateAndTime(date, time) {
            var timeString = time.getHours() + ':' + time.getMinutes() + ':00:00';
            var year = date.getFullYear();
            var month = date.getMonth() + 1; // Jan is 0, dec is 11
            var day = date.getDate();
            var dateString = '' + year + '-' + month + '-' + day;
            var combined = new Date(dateString + ' ' + timeString);
            return combined;
        };

        $scope.UpdateNewSchedule = function () {
            var _id = $scope.vm.ID
            var startDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceStartDate)
            var endDate = CombineDateAndTime($scope.StartDate, $scope.vm.ServiceEndDate)
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/updateinflexi",
                method: "PUT",
                data: {
                    _id: _id,
                    Startsat: startDate,
                    Endsat: endDate,
                    Notes: $scope.vm.Notes,
                    Remark: $scope.vm.SpecialRemark,
                    Message: $scope.vm.Remarks
                },
            });
            response.then(function (GList) {
                LoadSchedulerData();
                $mdDialog.cancel()
            });
        }

        function UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam) {
            var TeamName = ""
            var TeamMembersName = ""
            if ($scope.AllSchedulerDatas == undefined) {
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: {
                        Start_Date: $scope.uFrom,
                        End_Date: $scope.uTo,
                        Client_Id: $rootScope.Client_Id,
                        Customer_Id: null,
                        Team_Id: null
                    },
                });
                response.then(function (Glist) {
                    $scope.AllSchedulerDatas = Glist.data.data;
                    UpdateSchedule(_id, startDate, endDate, Team_Id, OldTeam)
                })
            }
            else {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === _id
                })[0];
                // if(Notes==null || Notes=="" || Notes==undefined )
                //  Notes = item.AccountsNotes

                if (item.Team_Id.length == 1) {
                    TeamName = getTeamName(Team_Id)
                    TeamMembersName = getTeamMembers(Team_Id)
                    var response = $http({
                        url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                        method: "PUT",
                        data: {
                            _id: _id,
                            Startsat: startDate,
                            Endsat: endDate,
                            AssignedTo: Team_Id,
                            Team_Id: [Team_Id],
                            TeamName: TeamName,
                            Remark: $scope.vm.SpecialRemark,
                            TeamMembersName: TeamMembersName,
                        },
                    });
                    response.then(function (GList) {
                        LoadSchedulerData();
                    });
                }
                else {
                    if (OldTeam != null) {
                        item.Team_Id[item.Team_Id.indexOf(OldTeam)] = Team_Id
                        item.Team_Id = _.uniq(item.Team_Id)
                        var TeamName = "";
                        var TeamMembersName = ""

                        angular.forEach(item.Team_Id, function (value) {
                            if (TeamName != "") {
                                TeamName = TeamName + "," + getTeamName(value)
                                TeamMembersName = TeamMembersName + "," + getTeamMembers(value)
                            }
                            else {
                                TeamName = getTeamName(value)
                                TeamMembersName = getTeamMembers(value)
                            }
                        })
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();

                        });
                    }
                    else {
                        var response = $http({
                            url: $rootScope.WebURL + "/scheduler/updateDateTeam",
                            method: "PUT",
                            data: {
                                _id: _id,
                                Startsat: startDate,
                                Endsat: endDate,
                                AssignedTo: item.AssignedTo,
                                Team_Id: item.Team_Id,
                                TeamName: item.TeamName,
                                Remark: $scope.vm.SpecialRemark,
                                TeamMembersName: item.TeamMembersName,
                            },
                        });
                        response.then(function (GList) {
                            LoadSchedulerData();
                        });
                    }
                }
                try {
                    $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/schedulerNotification/add",
                        data: {
                            ServiceId: _id,
                            ServiceID: item.ServiceID,
                            CustomerName: item.customerdetails[0].CompanyName,
                            Status: item.Status,
                            PreviousStartsat: item.Startsat,
                            PreviousEndsat: item.Endsat,
                            Startsat: startDate,
                            Endsat: endDate,
                            PestType: item.PestType,
                            TeamName: item.teamdetails[0].TeamName,
                            TeamLead: item.teamdetails[0].TeamLead,
                            TeamMember: item.teamdetails[0].TeamMembers,
                            Acknowledged: null,
                            AcknowledgedBy: null,
                            CreatedBy: $rootScope.createdby,
                            IsActive: true
                        },
                    }).then(function (GList) {
                    });
                } catch (error) {

                }
            }
        }


        function DeleteSchedule(_id) {
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                method: "PUT",
                data: {
                    _id: _id,
                    Status: "Cancelled",
                    CancelRemarks: "Deleted in custom scheduler",
                    UpdatedBy: $rootScope.CreatedBy,
                },
            });
            response.then(function (GList) {
                $("#scheduler").dxScheduler('instance').hideAppointmentTooltip(true);
                $mdToast.show($mdToast.simple().textContent('Deleted Successfully.').position('top center'));
                // showToast("Deleted Successfully", "", "warning");
                LoadSchedulerData();
            });
        }

        $scope.commentSubmit = function () {
            $scope.File_id = $scope.vm.ScedulId;
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulercomment/add",
                data: {
                    SchedulerID: $scope.vm.ScedulId,
                    SalesOrderID: $scope.vm.jobdata,
                    CustomerID: $scope.vm.Customer_Id,
                    TableName: 'Scheduler',
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Addcomments,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                },
            });
            response.then(function (GList) {
                Refreshcomment();
                $scope.vm.Addcomments = '';
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function Refreshcomment() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulercomment/getByReqID",
                method: "POST",
                data: { RequestID: $scope.vm.jobdata },
            });
            response.then(function (Commentdata) {
                $scope.Commentdatas = Commentdata.data.data;
            });
        }

        $scope.DeleteAttachment = function (id) {
            $scope.delAtachId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the attachment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/attachment/delete",
                        method: "POST",
                        data: { _id: $scope.delAtachId },
                    }).then(function (attachmentdata) {
                        RefreshAttachmentGrid()
                        $mdToast.show($mdToast.simple().textContent('Attachment deleted Successfully!').position('top center'));
                    })
                }
            })
        }

        $scope.DeleteComment = function (id) {
            $scope.delComId = id
            var result = DevExpress.ui.dialog.confirm('Are you sure, you want to delete the comment?', 'Confirm!');
            result.done(function (dialogResult) {
                if (dialogResult === true) {
                    $http({
                        url: $rootScope.WebURL + "/schedulercomment/delete",
                        method: "POST",
                        data: { _id: $scope.delComId },
                    }).then(function (attachmentdata) {
                        Refreshcomment()
                        $mdToast.show($mdToast.simple().textContent('Comment deleted Successfully!').position('top center'));
                    });

                }
            })
        }

        $scope.Uploadfiles = function (file) {
            $scope.File_id = $scope.vm.ScedulId;
            var file = file[0].file
            var response = Upload.upload({
                url: $rootScope.WebURL + "/scheduler/upload",
                data: { file: file }
            }).then(function (resp) {
                $scope.TableID = resp.data.data[0].GUIDFILENAME
                $scope.fileName = resp.data.data[0].OriginalFileName
                $scope.fileSize = resp.data.data[0].Size
                $scope.Path = resp.data.data[0].Path
                $scope.fileType = resp.data.data[0].Type
                if (resp.data.message == "Successfully Uploaded") {
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/attachment/add",
                        data: {
                            TableID: $scope.TableID, TableName: "Operations", FileID: $scope.vm.jobdata,
                            FileName: $scope.fileName,
                            FileSize: $scope.fileSize, FileType: $scope.fileType,
                            ModuleID: $scope.Path, Data: null, IsActive: "true",
                            CreatedBy: $rootScope.createdby,
                        },
                    });
                    response.then(function (GList) {
                        RefreshAttachmentGrid();
                        $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    }, function () {
                        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                    });
                }
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        function RefreshAttachmentGrid() {
            $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.vm.jobdata },
            }).then(function (attachmentdata) {
                var item = attachmentdata.data.data.filter(function (item) {
                    return item.TableName === 'Operations' || item.TableName === 'Sales Order'
                })
                $scope.Attachmentdatas = item;
            });
        }
        function LoadTeam() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/team",
                data: {
                    Client_Id: $rootScope.Client_Id
                },
            }).then(function (teamdata) {
                $scope.teamdatas = teamdata.data.data;
                $scope.Teamdatass = []
                $scope.Team = []
                angular.forEach($scope.teamdatas, function (value) {
                    value.text = value.TeamName;
                    value.color = getRandomColor();
                    $scope.Teamdatass.push(value)
                    $scope.Team.push(value.id)
                });
                BindScheduler();

                // if ($("#container").dxScheduler("instance").option() != undefined && $("#container").dxScheduler("instance").option().resources[1] != undefined) {

                //     $("#container").dxScheduler("instance").option().resources[1].dataSource = $scope.teamdatas;

                // }
            });
        }
        function CheckNullvalue(val) {
            var string = '';
            if (val == null || val == undefined || val == " ") {

                return string;
            } else {

                return val;
            }
        }
        function getRandomColor() {
            return '#' + Math.floor(Math.random() * 16777215).toString(16);
        };
        function showToast(event, value, type) {
            $mdToast.show($mdToast.simple().textContent(event).position('top center'));
        }

        //     function GetCWCdatas(){

        //     $http({
        //         method: "POST",
        //         url:  $rootScope.WebURL + "/contract",
        //         data: { Client_Id: $rootScope.Client_Id },
        //     }).then(function (contractdata) {
        //         $scope.contractdatas = contractdata.data.data;
        //         $http({
        //             method: "POST",
        //             url:  $rootScope.WebURL + "/salesOrder/getForScheduler",
        //             data: { Client_Id: $rootScope.Client_Id },
        //         }).then(function (salesdata) {
        //             $scope.salesdatas = salesdata.data.data;
        //             var data = $scope.salesdatas
        //             angular.forEach(data, function (cvalue) {
        //                 cvalue.IsActive = "";
        //                 cvalue.TotalOrderValue = null;
        //                 angular.forEach($scope.contractdatas, function (value) {
        //                     if (cvalue.ContractNo == value._id) {
        //                         cvalue.IsActive = value.ContractReferenceNo;
        //                         cvalue.TotalOrderValue = value._id;
        //                     }
        //                 })
        //             })
        //             $http({
        //                 method:'POST',
        //                 url:'https://'+$rootScope.WebURL+'/salesOrder/getAdHocjob',
        //                 data:{Start_Date:null,Client_Id:$rootScope.Client_Id}
        //             }).then(function(Glist){
        //                 var Adhocdata = Glist.data.data
        //             try {
        //                 var item = []; 
        //                 if($scope.vm.ExpiredDate==undefined)$scope.vm.ExpiredDate=7
        //                 item = data.filter(function (item) {
        //                     return new Date(item.ServiceEndDate).setHours(23, 59, 59, 999) >= new Date().setHours(0, 0, 0, 0) && (item.Status == 'New' || item.Status == 'On Going') && new Date(new Date(new Date().setDate(new Date().getDate()-parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) <= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) && new Date(new Date(new Date().setDate(new Date().getDate()+parseInt($scope.vm.ExpiredDate))).setHours(0,0,0,0)) >= new Date(new Date(item.ServiceStartDate).setHours(23, 59, 59, 999)) ;
        //                 });
        //                 // _.sortBy(item, 'ServiceStartDate');

        //                 item = _.sortBy(item, function(dateObj) {
        //                     return new Date(dateObj.ServiceStartDate);
        //                   });
        //                   item=_.reverse(item);
        //                   item=Adhocdata.concat(item)
        //                 $scope.CWCDatas = item;
        //                 if($scope.TabStatus==undefined) $scope.TabStatus='New'
        //                 $scope.getSchedulerdatas($scope.TabStatus)
        //             }
        //             catch (e) { }
        //         });
        //     });
        //     });
        // }
        $scope.ExpiredDateFilter = function () {
            GetCWCdatas()
        }
        function CustomerServicedatadetails() {
            var response = $http({
                url: $rootScope.WebURL + "/customerService/getByIDforService",
                method: "POST",
                data: { RequestID: $scope.RequestID },
            });
            response.then(function (CustomerServicedata) {
                var resArr = [];
                try {
                    CustomerServicedata.data.data.filter(function (item) {
                        var i = resArr.findIndex(function (x) {
                            return x.sBLK == item.sBLK && x.sUnit == item.sUnit && x.sStreetName == item.sStreetName && x.sPostal == item.sPostal
                        });
                        if (i <= -1)
                            resArr.push(item);
                    });
                } catch (e) { }
                _.each(resArr, function (item) {
                    item.PreferenceDayTime = $scope.PreferenceDayTime
                })
                $scope.CustomerServicedatas = resArr;

                $scope.vm.PreviewSpinner = false;
            });
        }

        var applyFilterTypes = [{
            key: "auto",
            name: "Immediately"
        }, {
            key: "onClick",
            name: "On Button Click"
        }], dataGrid;
        $scope.filterRow = {
            visible: true,
            applyFilter: "auto"
        };
        $scope.headerFilter = {
            visible: true
        };
        vm.dataGridCustomerService = {
            onInitialized: function (e) {
                dataGrid = e.component;
            },
            dataSource: $scope.CustomerServicedatas,
            keyExpr: "_id",
            width: 870,
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "multiple",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "sContactPerson", caption: "Contact Person" },
                //   { dataField: "sBLK", caption: "Blk" },
                //   { dataField: "sUnit", caption: "Unit" },
                { dataField: "sBuildingName", caption: "Number" },
                { dataField: "sStreetName", caption: "Address" },
                { dataField: "sPostal", caption: "Postal" },
                { dataField: "PreferenceDayTime", caption: "Preference (Day & Time)" },
            ],
            bindingOptions: {
                dataSource: "CustomerServicedatas",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    $scope.ServiceAddressarray = [];
                    $scope.ServiceAddressarray.push.apply($scope.ServiceAddressarray, e.selectedRowsData)
                    if ($scope.vm.TeamName != undefined && $scope.vm.TeamName != null && $scope.vm.TeamName != "")
                        vm.Formvalid = false;
                    $scope.vm.Location = []
                    angular.forEach($scope.ServiceAddressarray, function (value) {
                        var getLocation = "";
                        // if (value.sBLK != "" && value.sBLK != null && value.sBLK != undefined) {
                        //     getLocation = value.sBLK;
                        // }
                        // if (value.sUnit != "" && value.sUnit != null && value.sUnit != undefined) {
                        //     getLocation = getLocation + " " + value.sUnit;
                        // }
                        if (value.sBuildingName != "" && value.sBuildingName != null && value.sBuildingName != undefined) {
                            getLocation = getLocation + " " + value.sBuildingName;
                        }
                        if (value.sStreetName != "" && value.sStreetName != null && value.sStreetName != undefined) {
                            getLocation = getLocation + " " + value.sStreetName;
                        }
                        if (value.sCountry != "" && value.sCountry != null && value.sCountry != undefined) {
                            getLocation = getLocation + " " + value.sCountry;
                        }
                        if (value.sPostal != "" && value.sPostal != null && value.sPostal != undefined) {
                            getLocation = getLocation + " " + value.sPostal;
                        }
                        var address = getLocation;
                        value.LatLong = "103.8677,1.3554";
                        var geocoder = new google.maps.Geocoder();
                        if (geocoder) {
                            geocoder.geocode({
                                'address': address
                            }, function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    value.LatLong = results[0].geometry.location.lng() + "," + results[0].geometry.location.lat();
                                }
                            });
                        }
                        value.getLocation = getLocation;
                        $scope.vm.Location.push(getLocation)
                    })
                    $scope.vm.Location = $scope.vm.Location.map(function (obj) { return obj; }).join(';');
                }
                else {
                    $scope.ServiceAddressarray = [];

                    vm.Formvalid = true;
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Service Address</B></div>');
            },
        };
        vm.dataGridSalesOrder = {
            onContentReady: function (e) {
                e.element.find(".dx-datagrid-header-panel").find(".dx-toolbar-before").html('<div style="padding-top: 10px" class="textstyle_1"><B>Select Service</B></div>');
            },
            dataSource: $scope.NewSheduledJobs,
            showColumnLines: true,
            showRowLines: true,
            rowAlternationEnabled: true,
            showBorders: true,
            width: 870,
            keyExpr: "_id",
            paging: {
                enabled: true,
                pageSize: 5
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20, 50, 100],
                showInfo: true
            },
            sorting: {
                mode: "multiple"
            },
            selection: {
                mode: "single",
                showCheckBoxesMode: 'onClick',
            },
            searchPanel: {
                visible: true,
                width: 320,
                placeholder: "Search..."
            },
            allowColumnResizing: true,
            columns: [
                {
                    caption: '#', width: "50", cellTemplate: function (cellElement, cellInfo) {
                        cellElement.text(cellInfo.component.pageIndex() * cellInfo.component.pageSize() + cellInfo.row.rowIndex + 1)
                    }
                },
                { dataField: "customerdetails[0].CompanyName", caption: "Customer Name" },
                { dataField: "SalesOrderNo", caption: "Work Order #" },
                // { dataField: "IsActive", caption: "Contract #" },
                { dataField: "PestType", caption: "Pest Types" },
                { dataField: "ServiceStartDate", caption: "Service Start Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "ServiceEndDate", caption: "Service End Date", dataType: "date", format: 'dd/MM/yyyy' },
                { dataField: "Status", caption: "Scheduling Status" },
                // {  dataField: "IsUrgent", caption: "Urgent?",cellTemplate:function(container, options){
                //     $("<div/>").dxButton({
                //         icon: "warning"
                //     }).append(container)
                // }
                // },
                {
                    caption: 'Urgent?',
                    // fixed: true,
                    // fixedPosition: 'right',
                    width: 80,
                    alignment: 'center',
                    allowSorting: false,
                    cellTemplate: function (container, options) {
                        if (options.data.IsUrgent == true) {
                            $('<div />').dxButton({
                                icon: 'warning'
                            }).appendTo(container);
                        }
                    }
                }


            ],
            bindingOptions: {
                dataSource: "NewSheduledJobs",
                showColumnLines: "true",
                showRowLines: "true",
                showBorders: "true",
                rowAlternationEnabled: "true",
                filterRow: "filterRow",
                headerFilter: "headerFilter",
            },
            noDataText: "No Services to display...",
            onSelectionChanged: function (e) {
                if (e.selectedRowKeys.length > 0) {
                    var item = e.selectedRowsData[0];
                    $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
                    $scope.vm.WorkOrderNo = item.SalesOrderNo;
                    $scope.vm.WorkOrder_id = item._id;
                    $scope.vm.ContractOrder = item.TotalOrderValue;
                    $scope.vm.ContractNo = item.IsActive;
                    $scope.vm.PestType = item.PestType;
                    $scope.vm.Frequency = item.Frequency;
                    $scope.vm.Customer_id = item.Customer_id;
                    $scope.vm.OrderType = item.OrderType;
                    if ($scope.vm.OrderType == "Ad-hoc")
                        $scope.vm.JobType = 'Ad-hoc';
                    else
                        $scope.vm.JobType = 'Fixed';
                    $scope.vm.Types = item.Types;

                    $scope.PreferenceDayTime = item.DateTimeofTreatment
                    $scope.vm.EstimationTime = item.EstimatedHoursRequired
                    // if (new Date(item.ServiceStartDate) < new Date()) {
                    //     item.ServiceStartDate = new Date()
                    // }
                    // var dd = item.ServiceStartDate;
                    // var hh = vm.StartTime;
                    // var mm = new Date(hh.setDate(new Date(dd).getDate()));
                    // var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                    // $scope.vm.ServiceStartDate = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                    // var edd = item.ServiceEndDate;
                    // var ehh = vm.EndTime;
                    // var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                    // var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                    // $scope.vm.ServiceEndDate = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                    $scope.RequestID = item.customerdetails[0].CustomerID;
                    vm.PreviewSpinner = true;
                    CustomerServicedatadetails();
                }
                else {
                    vm.CompanyName = '';
                    vm.WorkOrder_id = '';
                    vm.ContractOrder = '';
                    vm.ContractNo = '';
                    vm.PreviewSpinner = false;
                }
            },
        }

        $scope.JobType = [
            { Name: 'New Contract' }, { Name: 'Ad-hoc' }, { Name: 'Follow-Up' }, { Name: 'Reinfestation Call' }
        ]
        $scope.JType = [{ Name: "Contract (Fixed)", value: "Fixed" }, { Name: "Contract (Flexible)", value: "Contract" }, { Name: "Ad-hoc", value: "Ad-hoc" }]
        vm.FormOption = {
            readOnly: false,
            showColonAfterLabel: false,
            showValidationSummary: true,
            labelLocation: "top",
            formData: vm,
            colCount: 2,
            items: [
                {
                    dataField: "CompanyName",
                    editorType: "dxTextBox",
                    label: { text: 'Customer Name', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "WorkOrderNo",
                    editorType: "dxTextBox",
                    label: { text: 'Work Order #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ContractNo",
                    editorType: "dxTextBox",
                    label: { text: 'Contract #', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                //   {
                //       editorType: "dxTextBox",
                //       label: { text: 'No. of Service Address', showColon: false },
                //       editorOptions: {
                //           readOnly: true,
                //           value: $scope.ServiceAddressarray.length
                //       }
                //   },
                {
                    dataField: "PestType",
                    editorType: "dxTextBox",
                    label: { text: 'Pest Types', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "TeamName",
                    editorType: "dxSelectBox",
                    label: { text: 'Team', showColon: false },
                    editorOptions: {
                        dataSource: $scope.teamdatas,
                        displayExpr: "TeamName",
                        valueExpr: "id",
                        readOnly: true,
                        onValueChanged: function (e) {
                            $scope.TeamMembers = e.component._options.selectedItem.TeamMembers
                            $scope.vm.Team_id = e.component._options.selectedItem.id
                            $scope.TeamID = e.component._options.selectedItem.id
                            if ($scope.ServiceAddressarray.length > 0)
                                vm.Formvalid = false;
                        }
                    },

                },
                {
                    dataField: "TeamMembers",
                    editorType: "dxTextBox",
                    label: { text: 'Team Members', showColon: false },
                    editorOptions: {
                        readOnly: true,
                    }
                },
                {
                    dataField: "ServiceStartDate",
                    label: { text: 'Start Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "ServiceEndDate",
                    label: { text: 'End Time', showColon: false },
                    editorType: "dxDateBox",
                    editorOptions: {
                        type: "time",
                        displayFormat: 'h:mm a',
                        width: "100%",
                    },
                },
                {
                    dataField: "JobType",
                    label: { text: 'Job Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JType,
                        displayExpr: "Name",
                        valueExpr: "value",
                        width: "100%",
                    },
                },
                {
                    dataField: "Location",
                    label: { text: 'Location', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                    },
                },
                {
                    dataField: 'EstimationTime',
                    label: { text: 'Time to Complete', showColon: false },
                    editorType: "dxTextBox",
                    editorOptions: {
                        width: "100%",
                        value: $scope.EstimationTime,
                        readOnly: true
                    },
                },
                {
                    dataField: "SchedulingType",
                    label: { text: 'Scheduling Type', showColon: false },
                    editorType: "dxSelectBox",
                    editorOptions: {
                        dataSource: $scope.JobType,
                        displayExpr: "Name",
                        valueExpr: "Name",
                        width: "100%",
                    },
                },


            ],
            bindingOptions: {
                "items[4].editorOptions.dataSource": "teamdatas",
                "items[5].editorOptions.value": "TeamMembers",
            }
        }

        $scope.getForSelectedDays = function (day) {
            $("#NewDataGrid").dxDataGrid("instance").beginCustomLoading()
            day = parseInt(day)
            var date = new Date($scope.StDate)
            date = new Date(moment(new Date(date)).add(day, 'days'))
            $scope.EnDate = new Date(date)
            GetCWCdatas()
        }

        function CleanAddComments() {
            $scope.Reschedule = { value: false };
            $scope.Cancel = { value: false };
            $scope.vm.Status = "";
            $scope.vm.ServiceID = "";
            $scope.vm.SalesOrderNo = "";
            $scope.vm.ContractReferenceNo = "";
            $scope.vm.CompanyName = "";
            $scope.vm.Location = "";
            $scope.vm.TeamName = "";
            $scope.vm.ServiceStartAt = "";
            $scope.vm.ServiceEndAt = "";
            $scope.vm.PestType1 = "";
            $scope.vm.Types = "";
            $scope.vm.ServiceOn = "";
            $scope.InProgresseAt = "";
            $scope.vm.AServiceEndAt = "";
            $scope.vm.EmailSentTo = "";
            $scope.vm.EmailSentDate = "";
            $scope.InProgressedBy = "";
            $scope.CreatedBy = "";
            $scope.CreatedDate = "";
            $scope.vm.Vehicle = "";
            $scope.Billable = { value: true };
            $scope.vm.BillingAmount
            $scope.Tabletlighttracklistdatas = [];
            $scope.TabletMaterialslistdatas = [];
            $scope.vm.TeamLead = "";
            $scope.vm.TeamMembers = "";
            $scope.vm.TeamRemarks = "";
            $scope.vm.TeamSignature = "";
            $scope.PhotosBdatas = [];
            $scope.PhotosAdatas = [];
            $scope.vm.NoOfCulls = "";
            $scope.vm.MistingCariedOut = "";
            $scope.vm.NoOfBurrows = "";
            $scope.vm.Density = "";
            $scope.vm.NoOfDead = "";
            $scope.vm.Instar = "";
            $scope.vm.BreedingFound = "";
            $scope.vm.Habitat = "";
            $scope.vm.Species = "";
            $scope.vm.Action = "";
            $scope.vm.Findings = "";
            $scope.vm.Recommendation = "";
            $scope.vm.MobilEmailId = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.starRating1r = "";
            $scope.vm.CustomerRemarks = "";
            $scope.CustomerSignature = "";
            $scope.vm.Addcomments = "";
            $scope.Commentdatas = [];
            $scope.Attachmentdatas = [];
            $scope.SchedulerLogdatas = [];
            $scope.vm.ATimeIn = "";
            $scope.vm.ATimeOut = "";
            $scope.vm.ContactPerson = "";
            $scope.vm.TeamMember = "";
            $scope.vm.starRating1 = "";
            $scope.Pestdatas = [];
            $scope.vm.MServicetype = "";
            $scope.vm.MLSMPestType = [];
            $scope.vm.MMaterialsName = "";
            $scope.vm.MQuantity = "";
            $scope.vm.MUnit = "";
            $scope.vm.ImgBPestType = [];
            $scope.vm.ImgBRemarks = "";
            $scope.uCPB = "";
            $scope.vm.Paymentmethod = "";
            $scope.vm.Totalpayment = "";
            $scope.vm.PaymentNotes = "";
            $scope.vm.PaymentRemarks = "";
            $scope.vm.Totalarea = "";
            $scope.vm.Totalcompleted = "";
            $scope.vm.Reason = "";
        }


        $scope.userpopup = function (e, Start, end, Team) {
            $scope.vm.ServiceName = null;
            $scope.vm.Description = null;
            $scope.ServiceTeamId = Team
            $scope.serviceStartTime = new Date(Start)
            $scope.ServiceEndTime = new Date(end)
            $scope.vm.dateBox1 = {
                ResheduleSSTime: {
                    type: "time",
                    value: $scope.serviceStartTime,
                    onValueChanged: function (e) {
                        $scope.serviceStartTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'Start'
                    //   }
                },
                ResheduleSETime: {
                    type: "time",
                    value: new Date(end),
                    onValueChanged: function (e) {
                        $scope.vm.AvoidEndTime = e.value
                    },
                    //   bindingOptions: {
                    //     'value': 'end'
                    //   }
                }
            }
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Popup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SubmitService = function () {
            if ($scope.ServiceUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/schedulerservice/update",
                    data: {
                        _id: $scope.ServiceUpdateID,
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                    $scope.ServiceUpdate = false
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });

            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulerservice/add",
                    data: {
                        ServiceName: $scope.vm.ServiceName,
                        Description: $scope.vm.Description,
                        StartDate: $scope.serviceStartTime,
                        EndDate: $scope.ServiceEndTime,
                        Team_Id: $scope.ServiceTeamId,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    RefreshGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.sSubmit = function (e) {

            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.sPestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }
            if ($scope.Update == true) {
                var dd = $scope.vm.ResheduleFrom;
                var hh = $scope.vm.ResheduleStartTime;
                var mm = new Date(hh.setDate(new Date(dd).getDate()));
                var yy = new Date(mm.setMonth(new Date(dd).getMonth()));
                $scope.vm.schusdateTime = new Date(yy.setFullYear(new Date(dd).getFullYear()));
                var edd = $scope.vm.ResheduleFrom;
                var ehh = $scope.vm.ResheduleEndTime;
                var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                $scope.vm.schuedateTime = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                var currentDate = new Date($scope.vm.schusdateTime);
                var enddate = new Date($scope.vm.schuedateTime);
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler/forReschedule",
                    data: {
                        _id: $scope.SID,
                        AssignedTo: $scope.vm.AssignedTo,
                        Start_Date: currentDate,
                        End_Date: enddate,
                    },
                }).then(function (GList) {
                    var CheckforReschedule = GList.data.data;
                    $scope.CheckReschedule = false;
                    angular.forEach(CheckforReschedule, function (item) {
                        var edd = new Date($scope.vm.ResheduleFrom);
                        var ehh = new Date(item.Endsat);
                        var emm = new Date(ehh.setDate(new Date(edd).getDate()));
                        var eyy = new Date(emm.setMonth(new Date(edd).getMonth()));
                        item.Endsat = new Date(eyy.setFullYear(new Date(edd).getFullYear()));
                        if (new Date(item.Startsat) < currentDate && currentDate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) < enddate && enddate < new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        if (new Date(item.Startsat) >= currentDate && enddate > new Date(item.Endsat)) {
                            $scope.CheckReschedule = true;
                        }
                        var St = $filter('date')(currentDate, 'dd/MM/yyyy hh:mm a');
                        var Et = $filter('date')(enddate, 'dd/MM/yyyy hh:mm a');
                        var dbSt = $filter('date')(new Date(item.Startsat), 'dd/MM/yyyy hh:mm a');
                        var dbEt = $filter('date')(new Date(item.Endsat), 'dd/MM/yyyy hh:mm a');
                        if (St == dbSt && Et == dbEt) {
                            $scope.CheckReschedule = true;
                        }
                    })
                    if ($scope.CheckReschedule == true) {
                        $mdToast.show($mdToast.simple().textContent('Not Allowed! Scheduling exists for this team on the specified time.').position('top center'));
                    }
                    else {
                        $scope.Emails = null;
                        if ($scope.Reschedule.value == true) {
                            var array = [];
                            var createdBy = null;
                            var teamLead = null;
                            var teamMember = null;

                            try {
                                var gItem = $scope.Uniqueschedulerdatas.filter(function (item) {
                                    return $scope.SID === item._id;
                                })[0];
                                createdBy = gItem.CreatedBy;
                                teamLead = gItem.teamdetails[0].TeamLead;
                                teamMember = gItem.teamdetails[0].TeamMembers;
                            } catch (error) { }

                            angular.forEach($scope.Userdatas, function (uvalue) {
                                if (createdBy.indexOf(uvalue.UserID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                                if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                                    array.push({ EmailId: uvalue.Email })
                                }
                            })

                            if (array.length > 0) {
                                var SenderEmails = [];
                                $scope.Emailgroups = _.groupBy(array, 'EmailId');
                                angular.forEach($scope.Emailgroups, function (value) {
                                    SenderEmails.push(value[0].EmailId);
                                });
                                $scope.Emails = SenderEmails;
                            }
                        }

                        $scope.uEndDate = new Date(currentDate.setDate(currentDate.getDate()));
                        if ($scope.uEndDate.getDay() == "0") {
                            $scope.ServiceOn = "Sunday";
                        }
                        else if ($scope.uEndDate.getDay() == "1") {
                            $scope.ServiceOn = "Monday";
                        }
                        else if ($scope.uEndDate.getDay() == "2") {
                            $scope.ServiceOn = "Tuesday";
                        }
                        else if ($scope.uEndDate.getDay() == "3") {
                            $scope.ServiceOn = "Wednesday";
                        }
                        else if ($scope.uEndDate.getDay() == "4") {
                            $scope.ServiceOn = "Thursday";
                        }
                        else if ($scope.uEndDate.getDay() == "5") {
                            $scope.ServiceOn = "Friday";
                        }
                        else if ($scope.uEndDate.getDay() == "6") {
                            $scope.ServiceOn = "Saturday";
                        }
                        $scope.status = "Yet to Start";
                        var response = $http({
                            method: "PUT",
                            url: $rootScope.WebURL + "/scheduler/Specifiedupdate",
                            data: {
                                _id: $scope.SID,
                                ServiceOn: $scope.ServiceOn,
                                Startsat: currentDate,
                                Endsat: enddate,
                                ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                SenderEmailAddress: $scope.Emails,
                                CompanyName: $scope.vm.CompanyName,
                                ScheduleFromDate: $scope.vm.ServiceStartAtlog,
                                UpdatedBy: $rootScope.createdby,
                                IsActive: true
                            },
                        });
                        response.then(function (GList) {
                            var lresponse = $http({
                                method: "POST",
                                url: $rootScope.WebURL + "/schedulelog/add",
                                data: {
                                    Client_Id: $rootScope.Client_Id,
                                    JobsOrders: $scope.vm.jobdata,
                                    Customer: $scope.vm.CustomerID,
                                    AssignedTo: $scope.vm.AssignedTo,
                                    Frequency: $scope.vm.Frequency,
                                    ServiceOn: $scope.ServiceOn,
                                    Types: $scope.vm.Types,
                                    Status: $scope.status,
                                    Startsat: $scope.vm.ServiceStartAtlog,
                                    Endsat: $scope.vm.ServiceEndAtlog,
                                    ScheduledStartsat: currentDate,
                                    ScheduledEndsat: enddate,
                                    PestType: $scope.vm.PestType1,
                                    ContractOrder: $scope.vm.ContractOrder,
                                    ServiceID: $scope.vm.ServiceID,
                                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                                    CreatedBy: $rootScope.createdby,
                                    IsActive: true,
                                },
                            });
                            lresponse.then(function (GList) {
                                RefreshGrid()
                                $mdDialog.cancel();
                                $scope.pesttypeGrid = true;
                                $scope.shedulerform = true;
                                $scope.addbtn = true;
                                $scope.viewbtn = false;
                                $scope.exportbtn = true;
                                $scope.thdata = false;
                                $scope.schedulartab = true;
                                $mdDialog.cancel();
                                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                            })
                        }, function () {
                            $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                        });
                    }
                });
            }
        }
        $scope.BillableSubmit = function () {
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/update",
                data: {
                    _id: $scope.vm.ScedulId,
                    JobsOrders: $scope.vm.jobdata,
                    Customer: $scope.vm.Customer_Id,
                    AssignedTo: $scope.vm.AssignedTo,
                    Frequency: $scope.vm.Frequency,
                    ServiceOn: $scope.vm.ServiceOn,
                    Types: $scope.vm.Types,
                    Status: $scope.vm.Status,
                    Startsat: $scope.vm.ServiceStartAt,
                    Endsat: $scope.vm.ServiceEndAt,
                    PestType: $scope.vm.PestType1,
                    ContractOrder: $scope.vm.ContractOrder,
                    ServiceID: $scope.vm.ServiceID,
                    ResheduleRemarks: $scope.vm.ResheduleRemarks,
                    BillingAmount: $scope.vm.BillingAmount,
                    Billable: $scope.Billable.value,
                    CollectPayment: $scope.CollectPayment.value,
                    Vehicle: $scope.vm.Vehicle,
                    Location: $scope.vm.Location,
                    Client_Id: $rootScope.Client_Id,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                RefreshGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

            });
        }
        $scope.AddServiceMaterials = function () {
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.SMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletlighttracklist/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else if ($scope.vm.SMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletlighttracklist/update",
                    data: {
                        _id: $scope.SMId,
                        ServiceId: $scope.vm.ScedulId,
                        PestType: $scope.vm.SMPestType,
                        Services: $scope.vm.MServicetype,
                        Status: "Services",
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.SMPestType = null;
                    $scope.vm.MServicetype = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshServiceMaterials();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.ServiceMaterialinfo = function (item) {
            $scope.vm.SMUpdate = true;
            $scope.SMId = item.id;
            $scope.vm.SMPestType = item.PestType;
            try {
                if (item.Services != null && item.Services != "" && item.Services != undefined) {
                    var array = item.Services.split(",");
                    var array1 = [];
                    angular.forEach(array, function (value) {
                        array1.push({ Servicetype: value });
                    });
                    $scope.vm.MServicetype = array1;
                }
            } catch (e) { }
        }
        $scope.EditMobileLogs = function (e, Sid) {
            $scope.vm.SMLMUpdate = false;
            $scope.vm.SMUpdate = false;
            $scope.vm.SMPestType = null;
            $scope.vm.MServicetype = null;
            $scope.vm.MLSMPestType = null;
            $scope.vm.MMaterialsName = null;
            $scope.vm.MQuantity = null;
            $scope.vm.MUnit = null;
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/flexischeduler/Editemobilelog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                controller: function ACflexischedulerController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.ServiceID = Sid;
            $scope.vm.starRating1 = 0;
            $scope.vm.tbsc_id = null;
            if ($scope.vm.Status == 'Completed') {
                angular.forEach($scope.Tabletschedulerrecord, function (value) {
                    try {
                        if ($scope.vm.ScedulId === value.ServiceId) {
                            $scope.vm.tbsc_id = value._id
                            $scope.vm.Pesttype = value.Pesttype
                            if ($scope.vm.Pesttype != null && $scope.vm.Pesttype != "" && $scope.vm.Pesttype != undefined) {
                                var array = $scope.vm.Pesttype.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ PestName: value });
                                });
                                $scope.Pestdatas = array1;
                            }
                            $scope.vm.Services = value.Services
                            $scope.vm.Materials = value.Materials
                            if ($scope.vm.Services != null && $scope.vm.Services != "" && $scope.vm.Services != undefined) {
                                var array = $scope.vm.Services.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ Servicetype: value });
                                });
                                $scope.vm.MServicetype = array1;
                            }
                            if ($scope.vm.Materials != null && $scope.vm.Materials != "" && $scope.vm.Materials != undefined) {
                                var array = $scope.vm.Materials.split(",");
                                var array1 = [];
                                angular.forEach(array, function (value) {
                                    array1.push({ MaterialsName: value });
                                });
                                $scope.vm.MMaterialsName = array1;
                            }
                            $scope.vm.TeamMember = value.TeamMember
                            $scope.vm.TeamRemarks = value.TeamRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.CustomerRemarks = value.CustomerRemarks
                            $scope.vm.TeamLead = value.TeamLead
                            $scope.vm.ATimeIn = new Date(value.Startsat);
                            $scope.vm.ATimeOut = new Date(value.Endsat);
                            $scope.vm.Scheduledate = new Date(value.Scheduledate);
                            $scope.CustomerSignature = value.CustomerSignature;
                            $scope.uPB1 = value.PB1;
                            $scope.uPB2 = value.PB2;
                            $scope.uPB3 = value.PB3;
                            $scope.uPB4 = value.PB4;
                            $scope.uPA1 = value.PA1;
                            $scope.uPA2 = value.PA2;
                            $scope.uPA3 = value.PA3;
                            $scope.uPA4 = value.PA4;
                            $scope.vm.TeamSignature = value.TeamSignature;
                            $scope.vm.Paymentmethod = value.Paymentmethod;
                            $scope.vm.MobilEmailId = value.EmailId;
                            $scope.vm.PaymentRemarks = value.PaymentRemarks;
                            $scope.vm.Totalpayment = parseInt(value.Totalpayment);
                            $scope.vm.PaymentNotes = value.PaymentNotes;
                            $scope.vm.Totalarea = parseInt(value.Totalarea);
                            $scope.vm.Totalcompleted = parseInt(value.Totalcompleted);
                            $scope.starRating1r = value.Rating;
                            $scope.vm.starRating1 = value.Rating;
                            $scope.vm.AServiceStartAt = new Date(value.Startsat);
                            $scope.vm.AServiceEndAt = new Date(value.Endsat);
                            $scope.vm.CustomerCurrentDate = new Date(CustomerCurrentDate);
                        }
                    }
                    catch (e) { }
                })
            }
            else {
                $scope.vm.tbsc_id = null;
            }
        }
        $scope.AddMobileLogMaterials = function () {

            if ($scope.vm.SMLMUpdate == false) {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletMaterials/add",
                    data: {
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        CreatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
            else if ($scope.vm.SMLMUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletMaterials/update",
                    data: {
                        _id: $scope.SMLMId,
                        Service_Id: $scope.vm.ScedulId,
                        PestType: $scope.vm.MLSMPestType,
                        MaterialName: $scope.vm.MMaterialsName,
                        Quantity: $scope.vm.MQuantity,
                        Unit: $scope.vm.MUnit,
                        UpdatedBy: $rootScope.createdby,
                    }
                });
                response.then(function (GList) {
                    $scope.vm.MLSMPestType = null;
                    $scope.vm.MMaterialsName = null;
                    $scope.vm.MQuantity = null;
                    $scope.vm.MUnit = null;
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshMobileLogMaterials();
                });
            }
        }
        $scope.MobileLogMaterialinfo = function (item) {
            $scope.vm.SMLMUpdate = true;
            $scope.SMLMId = item.id;
            $scope.vm.MLSMPestType = item.PestType;
            $scope.vm.MMaterialsName = item.MaterialName;
            $scope.vm.MQuantity = parseFloat(item.Quantity);
            $scope.vm.MUnit = item.Unit;
        }
        $scope.EditmobileSubmit = function () {
            if ($scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == "" || $scope.vm.BreedingFound == undefined) {
                $scope.vm.BreedingFound = null;
            }
            if ($scope.vm.Species == "" || $scope.vm.Species == "undefined" || $scope.vm.Species == undefined) {
                $scope.vm.Species = null;
            }
            if ($scope.vm.Findings == "" || $scope.vm.Findings == "undefined" || $scope.vm.Findings == undefined) {
                $scope.vm.Findings = null;
            }
            if ($scope.vm.MistingCariedOut == "" || $scope.vm.MistingCariedOut == "undefined" || $scope.vm.MistingCariedOut == undefined) {
                $scope.vm.MistingCariedOut = null;
            }
            if ($scope.vm.Reason == "" || $scope.vm.Reason == "undefined" || $scope.vm.Reason == undefined) {
                $scope.vm.Reason = null;
            }
            if ($scope.vm.Instar == "" || $scope.vm.Instar == "undefined" || $scope.vm.Instar == undefined) {
                $scope.vm.Instar = null;
            }
            if ($scope.vm.Density == "" || $scope.vm.Density == "undefined" || $scope.vm.Density == undefined) {
                $scope.vm.Density = null;
            }
            if ($scope.vm.Others == "" || $scope.vm.Others == "undefined" || $scope.vm.Others == undefined) {
                $scope.vm.Others = null;
            }
            if ($scope.vm.MServicetype != null && $scope.vm.MServicetype != "" && $scope.vm.MServicetype != undefined) {
                $scope.vm.MServicetype = $scope.vm.MServicetype.map(function (obj) { return obj.Servicetype; }).join(',');
            }
            if ($scope.vm.MMaterialsName != null && $scope.vm.MMaterialsName != "" && $scope.vm.MMaterialsName != undefined) {
                $scope.vm.MMaterialsName = $scope.vm.MMaterialsName.map(function (obj) { return obj.MaterialsName; }).join(',');
            }

            if ($scope.vm.tbsc_id != undefined && $scope.vm.tbsc_id != null && $scope.vm.tbsc_id != "") {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/update",
                    data: {
                        _id: $scope.vm.tbsc_id,
                        ServiceId: $scope.vm.ServiceID,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: $scope.vm.Startsat,
                        Endsat: $scope.vm.Endsat,
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: $scope.CustomerCurrentDate,
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                    },
                });
                response.then(function (GList) {
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Updated Successfully!').position('top center'));
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/tabletschedulerrecord/add",
                    data: {
                        ServiceId: $scope.vm.ScedulId,
                        Team: $scope.vm.TeamName,
                        Scheduledate: $scope.vm.ServiceStartAt,
                        WorkorderNo: $scope.vm.SalesOrderNo,
                        ContractOrderNo: $scope.vm.ContractReferenceNo,
                        CustomerName: $scope.vm.CompanyName,
                        Location: $scope.vm.Location,
                        Startsat: new Date(),
                        Endsat: new Date(),
                        Pesttype: $scope.vm.PestType1,
                        Services: $scope.vm.MServicetype,
                        TeamLead: $scope.vm.TeamLead,
                        TeamMember: $scope.vm.TeamMembers,
                        TeamRemarks: $scope.vm.TeamRemarks,
                        TeamSignature: $scope.vm.TeamSignature,
                        BreedingFound: $scope.vm.BreedingFound,
                        Species: $scope.vm.Species,
                        Findings: $scope.vm.Findings,
                        MistingCariedOut: $scope.vm.MistingCariedOut,
                        Density: $scope.vm.Density,
                        Instar: $scope.vm.Instar,
                        Reason: $scope.vm.Reason,
                        CustomerCurrentDate: new Date(),
                        Rating: $scope.vm.starRating1,
                        Materials: $scope.vm.MMaterialsName,
                        CustomerRemarks: $scope.vm.CustomerRemarks,
                        CustomerSignature: $scope.vm.CustomerSignature,
                        Paymentmethod: $scope.vm.Paymentmethod,
                        Totalpayment: $scope.vm.Totalpayment,
                        PaymentNotes: $scope.vm.PaymentNotes,
                        Totalarea: $scope.vm.Totalarea,
                        EmailId: $scope.vm.MobilEmailId,
                        PaymentRemarks: $scope.vm.PaymentRemarks,
                        Totalcompleted: $scope.vm.Totalcompleted,
                        CreatedBy: $rootScope.createdby,
                    },
                });
                response.then(function (GList) {
                    var response1 = $http({
                        url: $rootScope.WebURL + "/scheduler/Statusupdate",
                        method: "PUT",
                        data: {
                            _id: $scope.vm.ScedulId,
                            Status: "Completed",
                            UpdatedBy: $rootScope.createdby,
                        },
                    });
                    response1.then(function (GList) {
                        $mdDialog.cancel();
                        $mdToast.show($mdToast.simple().textContent('Added Successfully!').position('top center'));
                        $mdDialog.cancel();
                        RefreshGrid();
                    });
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                })
            }
        }
        $scope.Schinfodelete = function (deleteID) {
            try {
                var item = $scope.AllSchedulerDatas.filter(function (item) {
                    return item._id === deleteID;
                })[0];
                var createdBy = item.CreatedBy;
                if (item.teamdetails[0] != null && item.teamdetails[0] != "" && item.teamdetails[0] != undefined) {
                    var teamLead = item.teamdetails[0].TeamLead;
                    var teamMember = item.teamdetails[0].TeamMembers;
                }
                if (item.customerdetails[0] != null && item.customerdetails[0] != "" && item.customerdetails[0] != undefined) {
                    $scope.CompanyName = item.customerdetails[0].CompanyName;
                }
                $scope.jobdata = item.JobsOrders;
                $scope.CustomerID = item.Customer;
                $scope.AssignedTo = item.AssignedTo;
                $scope.Frequency = item.Frequency;
                $scope.Types = item.Types;
                $scope.ServiceOn = item.ServiceOn;
                $scope.PestType = item.PestType;
                $scope.ContractOrder = item.ContractOrder;
                $scope.ServiceID = item.ServiceID;
                $scope.Status = item.Status;
                $scope.ServiceStartAt = new Date(item.Startsat);
                $scope.ServiceEndAt = new Date(item.Endsat);
            } catch (e) { }
            $scope.Emails = null;
            if ($scope.Cancel.value == true) {
                var array = [];
                angular.forEach($scope.Userdatas, function (uvalue) {
                    if (createdBy.indexOf(uvalue.UserID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamLead.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                    if (teamMember.indexOf(uvalue.EmployeeID) > -1) {
                        array.push({ EmailId: uvalue.Email })
                    }
                })
                if (array.length > 0) {
                    var SenderEmails = [];
                    $scope.Emailgroups = _.groupBy(array, 'EmailId');
                    angular.forEach($scope.Emailgroups, function (value) {
                        SenderEmails.push(value[0].EmailId);
                    });
                    $scope.Emails = SenderEmails;
                }
            }
            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/scheduler/Cancelupdate",
                data: {
                    _id: deleteID,
                    Status: "Cancelled",
                    CancelRemarks: $scope.vm.CancelRemarks,
                    SenderEmailAddress: $scope.Emails,
                    CompanyName: $scope.CompanyName,
                    ScheduleDate: $scope.ServiceStartAt,
                    UpdatedBy: $rootScope.createdby
                },
            });
            response.then(function (GList) {
                var lresponse = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/schedulelog/add",
                    data: {
                        Client_Id: $rootScope.Client_Id,
                        JobsOrders: $scope.jobdata,
                        Customer: $scope.CustomerID,
                        AssignedTo: $scope.AssignedTo,
                        Frequency: $scope.Frequency,
                        ServiceOn: $scope.ServiceOn,
                        Types: $scope.Types,
                        Status: $scope.Status,
                        Startsat: $scope.ServiceStartAt,
                        Endsat: $scope.ServiceEndAt,
                        PestType: $scope.PestType,
                        ContractOrder: $scope.ContractOrder,
                        ServiceID: $scope.ServiceID,
                        CancelRemarks: $scope.vm.CancelRemarks,
                        CreatedBy: $rootScope.createdby,
                        IsActive: true,
                    },
                });
                lresponse.then(function (GList) {
                    LoadSchedulerData();
                    $mdDialog.cancel();
                    $mdDialog.cancel();
                    $mdToast.show($mdToast.simple().textContent('Cancelled Successfully!').position('top center'));
                })
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshPhotos() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/schedulerpicafter",
                data: { ScedulId: $scope.vm.ScedulId },
            }).then(function (Photosdatas) {
                $scope.Photosdatas = Photosdatas.data.data;
                angular.forEach($scope.Photosdatas, function (employee) {
                    if (employee.schimgafter != null && employee.schimgafter != "" && employee.schimgafter != undefined) {
                        employee.schimgafter = decode_base64(employee.schimgafter);
                    }
                    if (employee.schimgbefore != null && employee.schimgbefore != "" && employee.schimgbefore != undefined) {
                        employee.schimgbefore = decode_base64(employee.schimgbefore);
                    }
                });
                var item = $scope.Photosdatas.filter(function (item) {
                    return item.schimgafter != null && item.schimgafter != "null" && item.schimgafter != "" && item.schimgafter != undefined;
                });
                $scope.PhotosAdatas = item;
                var item1 = $scope.Photosdatas.filter(function (item1) {
                    return item1.schimgbefore != null && item1.schimgbefore != "null" && item1.schimgbefore != "" && item1.schimgbefore != undefined;
                });
                $scope.PhotosBdatas = item1;
            });
        }
        function RefreshServiceMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletlighttracklist/getbyId",
                method: "POST",
                data: { ServiceId: $scope.vm.ScedulId },
            });
            response.then(function (Tabletlighttracklistdata) {
                $scope.Tabletlighttracklistdatas = Tabletlighttracklistdata.data.data;
            });
            $scope.vm.SMUpdate = false;
        }
        function RefreshMobileLogMaterials() {
            var response = $http({
                url: $rootScope.WebURL + "/tabletMaterials/getById",
                method: "POST",
                data: { Service_Id: $scope.vm.ScedulId },
            });
            response.then(function (TabletMaterialslistdata) {

                $scope.TabletMaterialslistdatas = TabletMaterialslistdata.data.data;
            });
            $scope.vm.SMLMUpdate = false;
        }
        function RefreshSchedulerLogs() {
            var response = $http({
                url: $rootScope.WebURL + "/schedulelog/getByServiceID",
                method: "POST",
                data: { ServiceID: $scope.vm.ServiceID },
            });
            response.then(function (SchedulerLogdata) {

                $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/pesttype",
            data: { Client_Id: $rootScope.Client_Id }
        }).then(function (pocarddatas) {
            $scope.Pesttypedatas = pocarddatas.data.data;
        })
        function RefreshGrid() {
            $http({
                method: "POST",
                url: $rootScope.WebURL + "/user/getByClientId",
                data: { Client_Id: $rootScope.Client_Id },
            }).then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
                angular.forEach($scope.Userdatas, function (value) {
                    angular.forEach($scope.Employeedatas, function (evalue) {
                        if (value.EmployeeID == evalue.EmployeeID)
                            value.EmployeeID = evalue.EmployeeName;
                    })
                })
                LoadSchedulerData()
            });
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/servicetypelist",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Servicesdata) {
            $scope.Servicesdatas = Servicesdata.data.data;
        });
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/vehicle",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Vehicledata) {
            $scope.Vehicledatas = Vehicledata.data.data;
        });
        $http({
            url: $rootScope.WebURL + "/settings",
            method: "POST",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (settingsdata) {
            $scope.Settingsdatas = settingsdata.data.data;
            try {
                var item1 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'ScheduleFrequency';
                });
                $scope.ScheduleFrequencydatas = item1;
            }
            catch (e) { }
            try {
                var item2 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'PaymentMode';
                });
                $scope.PaymentModedatas = item2;
            }
            catch (e) { }
            try {
                var item3 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'Remarks';
                });
                $scope.Remarksdatas = item3;
            }
            catch (e) { }
            try {
                var item4 = $scope.Settingsdatas.filter(function (item) {
                    return item.Description === 'JobTypes';
                });
                $scope.JobTypesdatas = item4;
            }
            catch (e) { }
        });
        vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtOptions1 = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            select: {
                style: 'multi'
            },
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-search');
                if (vm.searchInit == true) {
                    var table = $('#example').DataTable();
                    table.search('').draw();
                    vm.searchInit = false;
                }
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }

            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[1, "asc"]],
            lengthMenu: [10, 20, 30, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        vm.dtdetails = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#forms-Detailsdt');
                var table = $('#Detailsdt').DataTable();
                table.search('').draw();
                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            destroy: true,
            pagingType: 'simple',
            autoWidth: false,
            order: [[3, "asc"]],
            lengthMenu: [5, 10, 20, 50, 100],
            responsive: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }

        };

        // socket configurations
        socket.on("Scheduler Created by Inserting multiple", function (data) {
            var schedresult = data.result
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("scheduler dragged", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("scheduler dropped", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler specified update", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })
        socket.on("Scheduler cancelled", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Team Updated", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Scheduler UpdateTeam method", function (data) {
            var schedresult = [data.data]
            var count = 0
            schedresult.forEach(function (item) {
                if (new Date(item.Startsat).getTime() >= $scope.uFrom && new Date(item.Endsat).getTime() <= $scope.uTo) {
                    count++
                }
            })
            if (count > 0)
                $scope.Datefilter()
        })

        socket.on("Update Scheduler Line", function (data) {
            $scope.Datefilter()
        })
        socket.on("Scheduler Completed", function (data) {
            $scope.Datefilter()
        })
        socket.on("WorkOrder unscheduled", function (data) {
            $scope.Datefilter()
        })


        // get scheduler data for socket


    }

})();

(function () {
    'use strict';

    angular
        .module('app.accounts.bankcash', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_bankcash', {
            url: '/bankcash',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/bankcash/bankcash.html',
                    controller: 'bankcashController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/bankcash');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.bankcash')
        .controller('bankcashController', bankcashcontroller);

    function bankcashcontroller($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $mdDateLocale, $timeout, $q, $log, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("BankCash")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');

        $scope.IsPending = false;

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $rootScope.LoginID = localStorage.getItem('LoginID');
        $rootScope.ActionedBy = localStorage.getItem('UserName');
        $rootScope.LoginedUser = localStorage.getItem('UserName');
        var Client_Id = localStorage.getItem('Client_Id');
        $scope.Update = false;

        $scope.ifCheque = false;
        $scope.PettyCashSelect = true;
        $scope.PettyCashClaimgrid = true;
        $scope.PettyCashClaimform = false;
        $scope.DepositSelect = false;
        $scope.TransferSelect = false;
        $scope.ReconciliationSelect = false;

        $scope.PaymentVoucherprintToCart = function (PVId) {
            debugger
            $scope.SID = PVId;
            var url = $rootScope.ReportURL + "PaymentVoucher.aspx?ID=" + PVId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.ExpenseClaimprintToCart = function (ECId) {
            debugger
            $scope.SID = ECId;
            var url = $rootScope.ReportURL + "ExpenseClaim.aspx?ID=" + ECId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.ShowGrid = function () {
            $scope.PettyCashClaimgrid = true;
            $scope.PettyCashClaimform = false;
            $scope.PaymentVouchergrid = false;
            $scope.PaymentVoucherform = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
        }

        function ShowGrid() {
            $scope.PettyCashClaimgrid = true;
            $scope.PettyCashClaimform = false;
            $scope.PaymentVouchergrid = false;
            $scope.PaymentVoucherform = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
        }

        $scope.PaymentShowGrid = function () {
            $scope.PaymentVouchergrid = true;
            $scope.PaymentVoucherform = false;
            $scope.PettyCashClaimgrid = false;
            $scope.PettyCashClaimform = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
        }

        $scope.PettyCashTab = function () {
            //$scope.PettyCashSelect = true;
            $scope.PettyCashClaimgrid = true;
            $scope.PettyCashClaimform = false;
            $scope.PaymentVouchergrid = false;
            $scope.PaymentVoucherform = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.SearchValue = "";
        }

        $scope.PaymentVoucherTab = function () {
            //$scope.PaymentVoucherSelect = true;
            $scope.PaymentVouchergrid = true;
            $scope.PaymentVoucherform = false;
            $scope.PettyCashClaimgrid = false;
            $scope.PettyCashClaimform = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.SearchValue = "";
        }

        $scope.DepositTab = function () {
            //$scope.PettyCashSelect = false;
            $scope.PettyCashClaimgrid = false;
            $scope.PettyCashClaimform = false;
            $scope.PaymentVouchergrid = false;
            $scope.PaymentVoucherform = false;
            $scope.DepositSelect = true;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = false;
            $scope.SearchValue = "";
        }

        $scope.TransferTab = function () {
            $scope.PettyCashSelect = false;
            $scope.PettyCashClaimgrid = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = true;
            $scope.ReconciliationSelect = false;
            $scope.SearchValue = "";
        }

        $scope.ReconciliationTab = function () {
            $scope.PettyCashSelect = false;
            $scope.PettyCashClaimgrid = false;
            $scope.DepositSelect = false;
            $scope.TransferSelect = false;
            $scope.ReconciliationSelect = true;
            $scope.SearchValue = "";
        }


        RefreshBank();
        function RefreshBank() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/bank",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Bankdata) {
                $scope.Bankdatas = Bankdata.data.data;
            });
        }

        function RefreshSalesOrder() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesOrder",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (salesOrderdata) {
                $scope.salesOrderdatas = salesOrderdata.data.data;
            });
        }

        $scope.Depositadd = function (e) {

            ClearDeposit();

            $scope.ifCheque = false;
            var AR = "DM-";
            var info = $scope.Depositdatas.length + 1;
            var y = pad(info, 6);
            $scope.vm.RefrenceNo = AR + y;

            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/bankcash/deposit.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });


        }

        $scope.OnDepositModeChange = function () {

            if (vm.DepositMode == "Cheque") {
                $scope.ifCheque = true;
            }

        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveDeposit = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/deposit/update",
                    data: {
                        _id: $scope.DID, RefrenceNo: $scope.vm.RefrenceNo, ReceiptNo: $scope.vm.ReceiptNo, BankID: $scope.vm.BankID,
                        Date: $scope.vm.Date, Amount: $scope.vm.Amount, DepositMode: $scope.vm.DepositMode, InvoiceNo: $scope.vm.InvoiceNo,
                        CustomerID: $scope.vm.CustomerID, AccountID: $scope.vm.AccountID, ChequeNo: $scope.vm.ChequeNo, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshDeposit();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/deposit/add",
                    data: {
                        RefrenceNo: $scope.vm.RefrenceNo, ReceiptNo: $scope.vm.ReceiptNo, BankID: $scope.vm.BankID, Client_Id: Client_Id,
                        Date: $scope.vm.Date, Amount: $scope.vm.Amount, DepositMode: $scope.vm.DepositMode, InvoiceNo: $scope.vm.InvoiceNo,
                        CustomerID: $scope.vm.CustomerID, AccountID: $scope.vm.AccountID, ChequeNo: $scope.vm.ChequeNo, Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshDeposit();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.AlertDepositMoneyStatus = function (e, DepositID) {
            $scope.DepositID = DepositID;
            debugger

            $scope.IsPending = false;
            var item = $scope.Depositdatas.filter(function (item) {
                return item._id === $scope.DepositID;
            })[0];

            if (item.Status == "Pending") {

                $scope.IsPending = true;
            }
            else {
                $scope.vm.Status = item.Status;
            }

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/bankcash/alertuser.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.UpdateDepositMoneyClearedStatus = function () {

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/deposit/updatestatus",
                data: {
                    _id: $scope.DepositID, Status: "Cleared", UpdatedBy: $rootScope.LoginID
                },
            });
            response.then(function (GList) {
                $mdDialog.hide();
                $mdToast.show($mdToast.simple().textContent('Successfully updated!').position('top center'));
                RefreshDeposit();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.UpdateDepositMoneyReturnedStatus = function () {

            var response = $http({
                method: "PUT",
                url: $rootScope.WebURL + "/deposit/updatestatus",
                data: {
                    _id: $scope.DepositID, Status: "Returned", UpdatedBy: $rootScope.LoginID
                },
            });
            response.then(function (GList) {
                $mdDialog.hide();
                $mdToast.show($mdToast.simple().textContent('Successfully updated!').position('top center'));
                RefreshDeposit();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Depositinfo = function (e, DID) {

            $scope.DID = DID;

            $scope.Update = true;
            angular.forEach($scope.Depositdatas, function (value, key) {
                if (DID == value._id) {
                    $scope.vm.RefrenceNo = value.RefrenceNo;
                    $scope.vm.ReceiptNo = value.ReceiptNo;;
                    $scope.vm.BankID = value.BankID;
                    $scope.vm.Date = new Date();
                    $scope.vm.CustomerID = value.CustomerID;
                    $scope.vm.AccountID = value.AccountID;
                    $scope.vm.ChequeNo = value.ChequeNo;
                    $scope.vm.InvoiceNo = value.InvoiceNo;
                    $scope.vm.Amount = parseFloat(value.Amount);
                    $scope.vm.DepositMode = value.DepositMode;
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/bankcash/deposit.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        RefreshDeposit();

        function RefreshDeposit() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/deposit",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Depositdata) {
                $scope.Depositdatas = Depositdata.data.data;
            });
        }

        $scope.DepositFilter = function () {
            $scope.Depositdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/deposit/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Depositdata) {
                $scope.Depositdatas = Depositdata.data.data;
            });
        }
        function ClearDeposit() {
            $scope.vm.RefrenceNo = null;
            $scope.vm.ReceiptNo = null;
            $scope.vm.Bank = null;
            $scope.vm.Date = new Date();
            $scope.vm.InvoiceNo = null;
            $scope.vm.Amount = null;
            $scope.vm.DepositMode = null;
            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.ChequeNo = null;
            $scope.vm.Remarks = null;
        }
        RefreshChartofAccount();
        RefreshCustomer();

        function RefreshChartofAccount() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/chartofaccount",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (ChartofAccountdata) {
                debugger
                $scope.ChartofAccountatas = ChartofAccountdata.data.data;
            });
        }
        function RefreshCustomer() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customer",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (customerdata) {
                $scope.Customerdatas = customerdata.data.data;
            });
        }
        $scope.Transferadd = function (e) {

            ClearTransfer();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/bankcash/transfer.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SaveTransfer = function () {

            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/spend/update",
                    data: {
                        _id: $scope.TID, CustomerID: $scope.vm.CustomerID, AccountID: $scope.vm.AccountID, ReferenceNumber: $scope.vm.ReferenceNumber,
                        Date: $scope.vm.Date, Amount: $scope.vm.Amount, TransactionMode: $scope.vm.TransactionMode, UpdatedBy: $rootScope.LoginID
                    },
                });
                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshTransfer();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/spend/add",
                    data: {
                        CustomerID: $scope.vm.CustomerID, Client_Id: Client_Id, AccountID: $scope.vm.AccountID, ReferenceNumber: $scope.vm.ReferenceNumber,
                        Date: $scope.vm.Date, Amount: $scope.vm.Amount, TransactionMode: $scope.vm.TransactionMode, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshTransfer();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Transferinfo = function (e, TID) {

            $scope.TID = TID;

            $scope.Update = true;
            angular.forEach($scope.Spenddatas, function (value, key) {
                if (TID == value._id) {
                    $scope.vm.CustomerID = value.CustomerID;
                    $scope.vm.AccountID = value.AccountID;;
                    $scope.vm.ReferenceNumber = value.ReferenceNumber;
                    $scope.vm.Date = new Date();
                    $scope.vm.TransactionMode = value.TransactionMode;
                    $scope.vm.Amount = parseFloat(value.Amount);
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/bankcash/transfer.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function bankcashcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        RefreshTransfer();
        function RefreshTransfer() {


            var response = $http({
                url: $rootScope.WebURL + "/spend",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Spenddata) {
                $scope.Spenddatas = Spenddata.data.data;
            });
        }

        $scope.TransferFilter = function () {

            var response = $http({
                url: $rootScope.WebURL + "/spend/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Spenddata) {
                $scope.Spenddatas = Spenddata.data.data;
            });
        }

        function ClearTransfer() {
            $scope.vm.CustomerID = null;
            $scope.vm.AccountID = null;
            $scope.vm.ReferenceNumber = null;
            $scope.vm.Date = new Date();
            $scope.vm.Amount = null;
            $scope.vm.TransactionMode = null;
        }

        RefreshEmployee(); RefreshWorkflow();
        function RefreshEmployee() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/employee/detailsforTab",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        function RefreshWorkflow() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/Workflow",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Workflowdata) {
                $scope.Workflowdatas = Workflowdata.data.data;
            });
        }
        function RefreshExpenseclaims() {
            var response = $http({
                url: $rootScope.WebURL + "/expenseclaim",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Expenseclaimdata) {
                $scope.Expenseclaimdatas = Expenseclaimdata.data.data;
            });
        }
        RefreshExpenseclaims();

        $scope.RefreshExpenseclaim = function () {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/expenseclaim",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Expenseclaimdata) {
                $scope.Expenseclaimdatas = Expenseclaimdata.data.data;
            });
        }

        $scope.PettyCashFilter = function () {
            $scope.Expenseclaimdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/expenseclaim/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Expenseclaimdata) {
                $scope.Expenseclaimdatas = Expenseclaimdata.data.data;

            });
        }

        $scope.ViewExpenseclaiminfo = function (ReqId) {

            debugger

            $scope.PettyCashClaimgrid = false;
            $scope.PettyCashClaimform = true;
            $scope.SID = ReqId;

            $scope.Update = true;

            $scope.Materialform = false;
            $scope.ViewMaterialform = true;
            $scope.Materialgrid = false;
            $scope.mrExport = false;
            $scope.mrAdd = false;
            $scope.mrSearch = false;
            $scope.mrView = true;
            $scope.Cancel = false;

            $scope.Material = true;

            var Expenseclaimarray = $scope.Expenseclaimdatas;
            var Expenseclaimitem = Expenseclaimarray.filter(function (item) {
                return item._id === ReqId;
            })[0];

            $scope.id = Expenseclaimitem._id;
            $scope.ExpenseclaimID = Expenseclaimitem._id;
            $scope.ReferenceNumber = Expenseclaimitem.ReferenceNumber;
            $scope.EmployeeID = Expenseclaimitem.EmployeeID;
            $scope.Date = new Date(Expenseclaimitem.Date);
            $scope.Remarks = Expenseclaimitem.Remarks;
            if (Expenseclaimitem.QRCode != null && Expenseclaimitem.QRCode != "" && Expenseclaimitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Expenseclaimitem.QRCode);
            }
            $scope.Status = Expenseclaimitem.Status;
            $scope.StatusID = parseInt(Expenseclaimitem.StatusID);


            var myArray = $scope.Employeedatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];
            $scope.EmployeeName = item.EmployeeName
            $scope.EID = item.EmployeeID


            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Accounts Expense Claim') {
                    debugger
                    if ($scope.StatusID == value.LevelName) {
                        debugger
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        debugger
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });
            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                debugger
                var array = $scope.NextLevelApprovers.split(",");

                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Accounts Expense Claim') {
                    debugger
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        debugger
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                debugger
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }



            var response = $http({
                url: $rootScope.WebURL + "/expenseclaimdetails/getbyExpenseID",
                method: "POST",
                data: { ExpenseclaimID: $scope.ReferenceNumber },
            });
            response.then(function (Expenseclaimdetailsdata) {
                $scope.Expenseclaimdetailsdatas = Expenseclaimdetailsdata.data.data;
            });
            RefreshAttachmentGrid();
            RefreshLogdetails();
            RefreshCommentGrid();
        }

        function RefreshAttachmentGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.ReferenceNumber },
            });
            response.then(function (attachmentdata) {
                debugger
                $scope.Attachmentdatas = attachmentdata.data.data;
            });
        }

        function RefreshLogdetails() {

            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.ReferenceNumber },
            });
            response.then(function (Logdetailsdata) {
                debugger
                $scope.Logdetailsdatas = Logdetailsdata.data.data;
            });
        }

        $scope.commentSubmit = function () {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.ReferenceNumber,
                    TableName: "Accounts Expense Claim Request",
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.createdby,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                debugger
                RefreshCommentGrid();
                $scope.vm.Comments = '';
                $scope.basicForm2.$setPristine();
                $scope.basicForm2.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshCommentGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.ReferenceNumber },
            });
            response.then(function (commentdata) {
                $scope.Commentdatas = commentdata.data.data;
            });
        }

        $scope.workflow = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.ExpenseclaimID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,

                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    RefreshExpenseclaims();
                    ShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.reject = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.ExpenseclaimID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Rejected",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));

                    RefreshExpenseclaims();
                    ShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.revise = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.LevelName != 1 && $scope.StatusID != 1 && $scope.Update == true) {
                //if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.ExpenseclaimID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Revised!').position('top center'));

                    RefreshExpenseclaims();
                    ShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.cancel = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/expenseclaim/update",
                    data: {
                        _id: $scope.ExpenseclaimID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Cancelled",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.ReferenceNumber,
                            TypeName: "Accounts Expense Claim",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));

                    RefreshExpenseclaims();
                    ShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Print = function (invoice) {
            debugger

            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;
        }

        RefreshPaymentGrid()



        $scope.PaymentVoucherFilter = function () {
            $scope.Paymentformdatas = undefined;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/paymentform/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (Paymentformdata) {
                $scope.Paymentformdatas = Paymentformdata.data.data;
            });
        }

        $scope.ViewPaymentinfo = function (PVReqId) {

            debugger
            $scope.SID = PVReqId;

            $scope.PaymentVouchergrid = false;
            $scope.PaymentVoucherform = true;
            $scope.Update = true;
            $scope.NextApprovers = '';
            $scope.ShowWorkflowButton = false;
            $scope.NextLevelShowRejectButton = false;
            $scope.NextLevelShowCancelButton = false;
            $scope.NextLevelShowReviseButton = false;
            $scope.Actioned = '';
            $scope.NextLevelAction = '';
            $scope.Payment = true;

            var Paymentarray = $scope.Paymentformdatas;
            var Paymentitem = Paymentarray.filter(function (item) {
                return item._id === PVReqId;
            })[0];

            $scope.id = Paymentitem._id;
            $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
            $scope.UniqueID = Paymentitem.UniqueID;
            $scope.EmployeeID = Paymentitem.EmployeeID;
            $scope.Date = new Date(Paymentitem.Date);
            $scope.Remarks = Paymentitem.Remarks;
            if (Paymentitem.QRCode != null && Paymentitem.QRCode != "" && Paymentitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Paymentitem.QRCode);
            }
            $scope.Status = Paymentitem.Status;
            $scope.StatusID = parseInt(Paymentitem.StatusID);


            var myArray = $scope.Employeedatas;
            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];
            $scope.EmployeeName = item.EmployeeID + '-' + item.EmployeeName;

            angular.forEach($scope.Workflowdatas, function (value) {
                if (value.TypeName == 'Accounts Payment Voucher') {
                    debugger
                    if ($scope.StatusID == value.LevelName) {
                        debugger
                        $scope.TypeName = value.TypeName;
                        $scope.LevelName = value.LevelName;
                        $scope.Action = value.Action;
                        $scope.Actioned = value.Actioned;
                        $scope.ShowCancelButton = value.ShowCancelButton;
                        $scope.ShowRejectButton = value.ShowRejectButton;
                        $scope.ShowReviseButton = value.ShowReviseButton;
                        $scope.NextLevel = value.NextLevel;
                        $scope.Approvers = value.Approvers;
                        $scope.Mandatory = value.Mandatory;
                        $scope.EmailNotification = value.EmailNotification;
                        $scope.NotifyTo = value.NotifyTo;
                        $scope.NotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.EmailExceptions = value.EmailExceptions;
                        $scope.AlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                    if ($scope.NextLevel == value.LevelName) {
                        debugger
                        $scope.NextLevelTypeName = value.TypeName;
                        $scope.NextLevelLevelName = value.LevelName;
                        $scope.NextLevelAction = value.Action;
                        $scope.NextLevelActioned = value.Actioned;
                        $scope.NextLevelShowCancelButton = value.ShowCancelButton;
                        $scope.NextLevelShowRejectButton = value.ShowRejectButton;
                        $scope.NextLevelShowReviseButton = value.ShowReviseButton;
                        $scope.AfterNextLevel = value.NextLevel;
                        $scope.NextLevelApprovers = value.Approvers;
                        $scope.NextLevelMandatory = value.Mandatory;
                        $scope.NextLevelEmailNotification = value.EmailNotification;
                        $scope.NextLevelNotifyTo = value.NotifyTo;
                        $scope.NextLevelNotifytoCurrentApprover = value.NotifytoCurrentApprover;
                        $scope.NextLevelNotifytoNextLevelApprover = value.NotifytoNextLevelApprover;
                        $scope.NextLevelNotifytoCreatorInitator = value.NotifytoCreatorInitator;
                        $scope.NextLevelEmailExceptions = value.EmailExceptions;
                        $scope.NextLevelAlwaysNotifyTo = value.AlwaysNotifyTo;
                    }
                }
            });
            $scope.LoginedUser = localStorage.getItem('UserName');
            $scope.LoginID = localStorage.getItem('LoginID');

            if ($scope.NextLevelApprovers != null && $scope.NextLevelApprovers != "" && $scope.NextLevelApprovers != undefined) {
                debugger
                var array = $scope.NextLevelApprovers.split(",");

                for (var y = 0; y < array.length; y++) {
                    if ($scope.LoginID == array[y]) {
                        $scope.NextApprovers = array[y];
                    }
                }
            }

            angular.forEach($scope.Workflowdatas, function (wvalue) {
                if (wvalue.TypeName == 'Accounts Payment Voucher') {
                    debugger
                    if ($scope.NextLevelAction == wvalue.Action && $scope.LoginID == $scope.NextApprovers) {
                        debugger
                        $scope.NextLevelAction = wvalue.Action;
                        $scope.ShowWorkflowButton = true;
                        $scope.NextLevelShowRejectButton = wvalue.ShowRejectButton;
                        $scope.NextLevelShowCancelButton = wvalue.ShowCancelButton;
                        $scope.NextLevelShowReviseButton = wvalue.ShowReviseButton;
                    }
                    else if ($scope.LoginID != $scope.NextApprovers) {
                        $scope.ShowWorkflowButton = false;
                        $scope.NextLevelShowRejectButton = false;
                        $scope.NextLevelShowCancelButton = false;
                        $scope.NextLevelShowReviseButton = false;
                    }
                }
            });

            if ($scope.StatusID == "0") {
                debugger
                $scope.ShowWorkflowButton = false;
                $scope.NextLevelShowRejectButton = false;
                $scope.NextLevelShowCancelButton = false;
                $scope.NextLevelShowReviseButton = false;
                $scope.Actioned = $scope.Status;
                $scope.NextLevelAction = '';
            }

            RefreshPaymentdetailGrid();
            RefreshPaymentVoucherAttachmentGrid();
            RefreshPaymentVoucherLogdetails();
            RefreshPaymentVoucherCommentGrid();


        }

        function RefreshPaymentGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/paymentform",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Paymentformdata) {
                $scope.Paymentformdatas = Paymentformdata.data.data;
            });
        }

        function RefreshPaymentdetailGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/paymentdetails/getbyExpenseID",
                method: "POST",
                data: { UniqueID: $scope.UniqueID },
            });
            response.then(function (Paymentdetailsdata) {
                $scope.Paymentdetailsdatas = Paymentdetailsdata.data.data;
            });
        }

        function RefreshPaymentVoucherAttachmentGrid() {
            debugger
            var response = $http({
                url: $rootScope.WebURL + "/attachment/getByFileID",
                method: "POST",
                data: { FileID: $scope.UniqueID },
            });
            response.then(function (Paymentattachmentdata) {
                debugger
                $scope.Paymentattachmentdatas = Paymentattachmentdata.data.data;
            });
        }

        function RefreshPaymentVoucherCommentGrid() {

            var response = $http({
                url: $rootScope.WebURL + "/comment/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Paymentcommentdata) {
                $scope.Paymentcommentdatas = Paymentcommentdata.data.data;
            });
        }

        function RefreshPaymentVoucherLogdetails() {

            var response = $http({
                url: $rootScope.WebURL + "/logdetails/getByRequestID",
                method: "POST",
                data: { RequestID: $scope.UniqueID },
            });
            response.then(function (Paymentlogdetailsdata) {
                debugger
                $scope.Paymentlogdetailsdatas = Paymentlogdetailsdata.data.data;
            });
        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        $scope.PaymentcommentSubmit = function () {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/comment/add",
                data: {
                    TableRowID: $scope.UniqueID,
                    TableName: "Accounts Payment Voucher",
                    CommentedBy: $rootScope.createdby,
                    cmt: $scope.vm.Comments,
                    ModuleID: $scope.vm.ModuleID,
                    CreatedBy: $rootScope.createdby,
                    IsActive: "true",
                },
            });
            response.then(function (GList) {
                debugger
                RefreshPaymentVoucherCommentGrid();
                $scope.vm.Comments = '';
                $scope.PaymentVoucher.$setPristine();
                $scope.PaymentVoucher.$setUntouched();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        $scope.Paymentworkflow = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,

                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Accounts Payment Voucher",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    RefreshPaymentGrid();
                    $scope.PaymentShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Paymentreject = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Rejected",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Accounts Payment Voucher",
                            Action: "Rejected",
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Rejected!').position('top center'));

                    RefreshPaymentGrid();
                    $scope.PaymentShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Paymentrevise = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.LevelName != 1 && $scope.StatusID != 1 && $scope.Update == true) {
                //if ($scope.NextLevel >= 2 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: $scope.NextLevelActioned,
                        StatusID: $scope.NextLevelLevelName,

                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Accounts Payment Voucher",
                            Action: $scope.NextLevelActioned,
                            ActionedBy: $rootScope.LoginedUser,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));

                    RefreshPaymentGrid();
                    $scope.PaymentShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.Paymentcancel = function () {
            debugger
            $scope.WID = $scope.id;

            if ($scope.Status == "New" && $scope.StatusID == 1 && $scope.Update == true) {
                $scope.Update = true;

                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/paymentform/update",
                    data: {
                        _id: $scope.WID,
                        ReferenceNumber: $scope.ReferenceNumber,
                        UniqueID: $scope.UniqueID,
                        EmployeeID: $scope.EmployeeID,
                        Date: $scope.Date,
                        Remarks: $scope.Remarks,
                        Status: "Cancelled",
                        StatusID: "0",
                    },
                });
                response.then(function (GList) {
                    debugger

                    $scope.LogID = GList.data.data.id;
                    var response = $http({
                        method: "POST",
                        url: $rootScope.WebURL + "/logdetails/add",
                        data: {
                            RequestID: $scope.UniqueID,
                            TypeName: "Accounts Payment Voucher",
                            Action: "Cancelled",
                            ActionedBy: $rootScope.LoginID,
                        },
                    });

                    $mdToast.show($mdToast.simple().textContent('Successfully Cancelled!').position('top center'));

                    RefreshPaymentGrid();
                    $scope.PaymentShowGrid();

                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }

        }

        $scope.PrintPayment = function (invoice, UniqID) {
            debugger
            $scope.PrintID = UniqID;


            var Paymentarray = $scope.Paymentformdatas;
            var Paymentitem = Paymentarray.filter(function (item) {
                return item.UniqueID === UniqID;
            })[0];

            $scope.id = Paymentitem._id;
            $scope.ReferenceNumber = Paymentitem.ReferenceNumber;
            $scope.UniqueID = Paymentitem.UniqueID;
            $scope.EmployeeID = Paymentitem.EmployeeID;
            $scope.Date = new Date(Paymentitem.Date);
            $scope.Remarks = Paymentitem.Remarks;
            if (Paymentitem.QRCode != null && Paymentitem.QRCode != "" && Paymentitem.QRCode != undefined) {
                $scope.QRCode = decode_base64(Paymentitem.QRCode);
            }
            $scope.Status = Paymentitem.Status;
            $scope.StatusID = parseInt(Paymentitem.StatusID);


            var myArray = $scope.Employeedatas;

            var item = myArray.filter(function (item) {
                return item.id === $scope.EmployeeID;
            })[0];

            $scope.EmployeeName = item.EmployeeID + '-' + item.EmployeeName;


            RefreshPaymentdetailGrid();

            //$scope.Pop = true;
            var innerContents = document.getElementById(invoice).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            popupWinindow.document.close();
            //$scope.Pop = false;

        }

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        $scope.PettyCashadd = function (e) {

            $mdDialog.show({
                controller: bankcashcontroller,
                templateUrl: 'app/main/apps/accounts/bankcash/pettycash.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true
            });
            $scope.moduleupdate = false;
            $scope.rolereadonly = false;
        }

        var vm = this;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };


        $scope.PettyCashExport = function () {
            alasql('SELECT * INTO XLSX("PettyCash.xlsx",{headers:true}) FROM ?', [$scope.Expenseclaimdatas]);
        };

        $scope.PaymentVoucherExport = function () {
            alasql('SELECT * INTO XLSX("PaymentVoucher.xlsx",{headers:true}) FROM ?', [$scope.Paymentformdatas]);
        };

        $scope.DepositExport = function () {
            alasql('SELECT * INTO XLSX("Deposit.xlsx",{headers:true}) FROM ?', [$scope.Depositdatas]);
        };
        $scope.TransferExport = function () {
            alasql('SELECT * INTO XLSX("Transfer.xlsx",{headers:true}) FROM ?', [$scope.Spenddatas]);
        };


        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.accounts.contracts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.accounts_contracts', {
            url: '/AcContracts',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/contracts/contracts.html',
                    controller: 'AccontractsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/contracts');
    }

})();
(function () {
  "use strict";

  angular
    .module("app.accounts.contracts")
    .controller("AccontractsController", AccontractsController);
  // .directive('ngEnter', function () {
  //     return function (scope, element, attrs) {
  //         element.bind("keydown keypress", function (event) {
  //             if (event.which === 13) {
  //                 scope.$apply(function () {
  //                     scope.$eval(attrs.ngEnter);
  //                 });

  //                 event.preventDefault();
  //             }
  //         });
  //     };
  // });
  function AccontractsController(
    $scope,
    $interval,
    socket,
    $mdSidenav,
    $mdToast,
    $http,
    $location,
    $rootScope,
    $window,
    $state,
    $mdDateLocale,
    $q,
    DashboardData,
    $document,
    $filter,
    $mdDialog,
    $mdConstant,
    Upload,
    indexedDBService,
    DataSyncService
  ) {
    document.getElementsByTagName("title")[0].text = "Accounts-Contracts";
    var chkAceses = localStorage.getItem("pages");
    if (chkAceses.split(",").includes("AcContract")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }
    $window.localStorage.setItem("PQfromContract", "");

    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var EmpID = localStorage.getItem("EmployeeID");
    var vm = this;
    $scope.RenewalUpdate = false;
    $scope.Contractsform = false;
    $scope.Contractsgrid = true;
    $scope.Salesform = false;
    $scope.Export = true;
    $scope.Pageform = false;
    $scope.Add = true;
    $scope.Search = true;
    $scope.ShowContractform = false;
    $scope.SpecialRem = "";
    getSor();
    RefreshCustomerdatas();

    $scope.items = [
      { a: 1, b: 10 },
      { a: 2, b: 20 },
      { a: 3, b: 30 }
    ];
    $scope.uShowClosed = false;
    $scope.sAdd = function () {
      ClearForm();
      $scope.vm.Ccontact = [];
      $scope.SID = null;
      $scope.Update = false;
      $scope.Contractsform = true;
      $scope.Salesform = false;
      $scope.Contractsgrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.vm.Header = null;
      $scope.Search = false;
      $scope.vm.CEmail = [];
      $scope.vm.SiteContactPerson = null;
      $scope.vm.SiteName = null;
      $scope.vm.SiteContact = null;
      getSor();
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    };

    function getAllContract() {
      indexedDBService.getAll("contract").then(function (data) {
        if (data && data.length > 0) {
          $scope.AllContractdata = data;
          extract_contract_data($scope);
        } else RefreshGrid();
      });
    }

    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };

    var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
    var pass = "";
    for (var x = 0; x < 6; x++) {
      var i = Math.floor(Math.random() * chars.length);
      pass += chars.charAt(i);
    }
    var UniqID = pass;
    $scope.Showgrid = function () {
      $scope.Contractsgrid = true;
      $scope.Contractsform = false;
      $scope.Salesform = false;
      $scope.Pageform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
      $scope.ShowContractform = false;

      // if ($scope.Update == true) {
      //   var response = $http({
      //     method: "PUT",
      //     url:  $rootScope.WebURL + "/contract/update",
      //     data: {
      //       _id: $scope.SID,
      //       MultiFrequency: $scope.Frequencydatas,
      //       UpdateFrequency: "true"
      //     }
      //   });
      // }
    };
    $scope.Servicepopup = function (e, PopupType) {
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = null;
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Enter valid CC !")
              .position("top center")
          );
          return;
        }
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Enter valid email !")
            .position("top center")
        );
        return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail,
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              $scope.vm.CustomerID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
          $mdDialog.cancel();
        }
      }
    };
    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 55;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        }
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        }
      } catch (e) { }
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    function CustomerServicedatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
      });
    }
    //$scope.uFrom = new Date(new Date().setMonth(new Date().getMonth() - 1));
    $scope.uFrom = null;
    $scope.uTo = null;
    $scope.vm.PreviewSpinner = false;
    var dataGrid;
    var dataGrid1;
    var dataGrid2;
    var dataGrid3;
    vm.dataGridContract = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.contractdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "On-going Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Period" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        // { dataField: "IncludeSor", caption: "Include SOR", width: "90", },
        // { dataField: "ServiceHours", caption: "Service Hours", width: "150" },

        {
          caption: "Preview",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  $scope.PreviewQuaotation(
                    options.data._id,
                    options.data.BillingFrequency,
                    options.data.ServiceStartDate,
                    options.data.ServiceEndDate,
                    options.data.CreatedBy,
                    "invoice"
                  );
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       $scope.PreviewQuaotation(
            //         options.data._id,
            //         options.data.BillingFrequency,
            //         options.data.ServiceStartDate,
            //         options.data.ServiceEndDate,
            //         options.data.CreatedBy,
            //         "Download"
            //       );
            //     }
            //   })
            //   .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "contractdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          $scope.Contracteditinfo(data.event, data.data.id);
        }
      }
    };

    vm.dataGridPending = {
      onInitialized: function (e) {
        dataGrid1 = e.component;
        getAllContract();
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.Pendingcontractdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Pending Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "EmployeeName", caption: "Sales Person" },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        // { dataField: "IncludeSor", caption: "Include SOR", width: "90", },

        {
          caption: "Preview",
          width: "70",
          fixed: false,
          fixedPosition: "right",
          alignment: "center",
          allowSorting: false,
          cellTemplate: function (container, options) {
            $("<div />")
              .dxButton({
                icon: "exportpdf",
                onClick: function (e) {
                  $scope.PreviewQuaotation(
                    options.data._id,
                    options.data.BillingFrequency,
                    options.data.ServiceStartDate,
                    options.data.ServiceEndDate,
                    options.data.CreatedBy,
                    "invoice"
                  );
                }
              })
              .appendTo(container);
            // $('<div class="buttonss"/>')
            //   .dxButton({
            //     icon: "download",
            //     onClick: function (e) {
            //       $scope.PreviewQuaotation(
            //         options.data._id,
            //         options.data.BillingFrequency,
            //         options.data.ServiceStartDate,
            //         options.data.ServiceEndDate,
            //         options.data.CreatedBy,
            //         "Download"
            //       );
            //     }
            //   })
            //   .appendTo(container);
          }
        }
      ],
      bindingOptions: {
        dataSource: "Pendingcontractdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      // onEditingStart: function (e) {
      //   e.cancel = true
      //   $scope.Leadinfo(data._id)
      // },
      // onToolbarPreparing: function (e) {
      //     e.toolbarOptions.items.unshift({
      //         location: "before",
      //         template: "totalGroupCount"
      //     }
      //     );
      // },
      onCellClick: function (data) {
        if (data.columnIndex == 1 && data.rowType == "data") {
          $scope.Update = true;
          $scope.Contracteditinfo(data.event, data.data.id);
        }
      }
    };

    vm.dataGridRenewal = {
      onInitialized: function (e) {
        dataGrid2 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.contractRenewaldatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Contract Renewal Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "PestCode", caption: "Pest Type" },
        {
          dataField: "ActualEndDate",
          caption: "Actual End Date",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        }
      ],
      bindingOptions: {
        dataSource: "contractRenewaldatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };

    vm.dataGridTerminated = {
      onInitialized: function (e) {
        dataGrid3 = e.component;
      },
      onCellPrepared: function (e) { },
      dataSource: $scope.Terminateddatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Terminated Contract Details",
        allowExportSelectedData: false
      },
      allowColumnResizing: true,
      columnAutoWidth: false,
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      wordWrapEnabled: true,
      searchPanel: {
        visible: true,
        width: 320,
        placeholder: "Search..."
      },

      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        {
          dataField: "ContractReferenceNo",
          caption: "Contract #",
          width: "85",
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: defaults;'>" +
              options.data.ContractReferenceNo +
              "</p>"
            ).appendTo(container);
          }
        },
        { dataField: "CompanyName", caption: "Customer" },
        {
          dataField: "sStreetName",
          caption: "Service Location",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:black;cursor: default;'>" +
              options.data.sStreetName +
              ", Singapore, " +
              options.data.sPostal +
              "</p>"
            ).appendTo(container);
          }
        },
        {
          dataField: "ActualEndDate",
          caption: "Actual End Date",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        },
        { dataField: "PestCode", caption: "Pest Type" },
        { dataField: "ContractDate", caption: "Contract Date" },
        {
          dataField: "EmailSentDate",
          caption: "Contract Sent Date",
          width: "150",
          dataType: "datetime",
          format: "dd/MM/yyyy hh:mm a"
        }
      ],
      bindingOptions: {
        dataSource: "Terminateddatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      }
    };


    $scope.getTerminated = function () {
      getTerminated();
    };

    function getTerminated() {
      $scope.Terminateddatas = [];
      dataGrid3.beginCustomLoading();
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getterminate",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (List) {
        $scope.Terminateddatas = List.data.data;
        dataGrid3.endCustomLoading();
      });
    }

    $scope.Datefilter = function () {
      if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
      $scope.contractdatas = [];
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getLength",
        data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder" }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          var Skip = 0;
          var Limit = 300;
          if (ContractLength > 0) {
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "SalesOrder",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
                var data = GList.data.data.filter(function (data) {
                  return (
                    new Date(data.ServiceEndDate).getTime() >
                    new Date().getTime()
                  );
                });
                var data1 = GList.data.data.filter(function (data) {
                  return (
                    new Date(data.ServiceEndDate).getTime() <
                    new Date().getTime()
                  );
                });
                $scope.contractdatas = data;
                $scope.PastContractdatas = data1;
                $scope.contractdatas = _.uniqWith(
                  $scope.contractdatas,
                  _.isEqual
                );
                $scope.PastContractdatas = _.uniqWith(
                  $scope.PastContractdatas,
                  _.isEqual
                );
                $scope.workOrd = $scope.contractdatas;
                $scope.vm.PreviewSpinner = false;
              });
            }
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );

      // get for Ad-hoc WorkOrder
      if (dataGrid != undefined) dataGrid.beginCustomLoading();
      $scope.Pendingcontractdatas = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getLength",
        data: { Client_Id: $rootScope.Client_Id, Type: "New" }
      }).then(
        function (List) {
          var ContractLength = Math.ceil(parseInt(List.data.data) / 300);
          if (ContractLength > 0) {
            var Skip = 0;
            var Limit = 300;
            for (var i = 0; i < ContractLength; i++) {
              if (i == 0) Skip = 0;
              else Skip += 300;
              $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getdatefilter",
                data: {
                  Client_Id: $rootScope.Client_Id,
                  Type: "New",
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: Skip,
                  Limit: Limit,
                  StartDate: $scope.uFrom,
                  EndDate: $scope.uTo
                }
              }).then(function (GList) {
                if (dataGrid != undefined) dataGrid.endCustomLoading();
                $scope.Pendingcontractdatas = GList.data.data;
                $scope.Pendingcontractdatas = _.uniqWith(
                  $scope.Pendingcontractdatas,
                  _.isEqual
                );
              });
            }
          }
        },
        function (err) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something gone wrong,please refresh the page !")
              .position("top center")
          );
        }
      );
    };

    $scope.Contractclose = function (e, contractId) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/closealert.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.contractId = contractId;
    };
    $scope.CloseContract = function (contractId) {
      fetchContract(contractId);
      $scope.vm.ContractStatus = "Closed";
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/contract/update",
        data: {
          _id: contractId,
          SalesPerson_id: $scope.vm.SalesPerson,
          TemplateID: $scope.vm.TemplateName,
          Frequency: $scope.vm.Frequency,
          CreditTerm: $scope.vm.CreditTerm,
          IncludeSOR: $scope.vm.IncludeSOR,
          MultiFrequency: $scope.Frequencydatas,
          ContactPerson: $scope.vm.uContactPerson,
          ServiceEndDate: $scope.vm.ServiceEndDate,
          ServiceStartDate: $scope.vm.ServiceStartDate,
          Customer_id: $scope.vm.Customer_id,
          ContractStatus: $scope.vm.ContractStatus,
          Status: $scope.vm.CurrentStatus,
          StatusID: $scope.vm.CurrentStatusID,
          Email: $scope.vm.CEmail,
          BillingAddress: $scope.vm.BAddress,
          Client_Id: $rootScope.Client_Id,
          UpdatedBy: $rootScope.createdby,
          IsActive: false
        }
      });
      response.then(
        function (GList) {
          $scope.Contractsgrid = true;
          $scope.ShowContractform = false;
          $scope.Contractsform = false;
          $scope.Salesform = false;
          $scope.Export = true;
          $scope.Add = true;
          $scope.Search = true;
          $scope.view = false;
          RefreshGrid();
          $mdDialog.hide();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Addcontract = function (e) {
      $scope.Contractsgrid = false;
      $scope.ShowContractform = true;
      $scope.Add = false;
      $scope.view = true;
      $scope.Export = false;
      $scope.Search = false;
      $scope.SID = null;
      getSor();
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      ClearForm();
      // $scope.vm.uCustomerID = pass;
      $scope.vm.ContractDate = new Date();
      $scope.vm.ContractReceivedBy = $rootScope.createdby;
      //var cinfo = $scope.contractdatas
      //for (var c = 1; c <= 1 + cinfo.length; c++) {
      //    var z = 'CT-' + ('0000' + c).slice(-4);
      //}
      //$scope.vm.ContractReferenceNo = z;
      $scope.vm.CurrentStatus = "New";
      $scope.vm.ContractStatus = "Open";
      $scope.vm.CurrentStatusID = 1;
      $scope.Update = false;
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
    };
    $scope.Addpesttype = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/addpesttype.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.contractinfo = function (_id) {
      $scope.Update = true;
      $scope.Contractsform = true;
      $scope.Salesform = false;
      $scope.Contractsgrid = false;
      $scope.ContractReportTab = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.SID = _id;
      $scope.ContractID = _id;
      $scope.vm.ContractId = _id;
      $scope.Add = false;
      $scope.Search = false;
      $scope.File_id = _id;

      $scope.ActionButton = null;
      $scope.uNext = null;
      $scope.cNextActionedID = null;
      $scope.ShowRejectButton = false;
      $scope.ShowCancelButton = false;
      $scope.ShowReviseButton = false;
      $scope.IsAccess = false;
      $scope.vm.ContractNo = _id;
      $scope.vm.CAddress;
      $scope.vm.ContractId = _id;
      $http({
        url: $rootScope.WebURL + "/contract/getContractbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var value = List.data.data[0];
        $scope.vm.UpCAddress = value.CustomerID;
        $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
        $scope.vm.ContractStartDate = value.ContractStartDate;
        $scope.Frequencydatas = value.MultiFrequency;
        $scope.vm.CTotalOrderValue = parseFloat(value.ContractValue);
        $scope.vm.TotalSum = value.ContractValue;
        $scope.vm.ServiceHours = value.ServiceHours;
        $scope.vm.Customer_ID = value.Customer_Id;
        angular.forEach($scope.Frequencydatas, function (item) {
          try {
            item.Freq = parseInt(item.Frequency.match(/\(([^)]+)\)/)[1]);
          } catch (error) { }
        });
        $scope.vm.CreditTerm = value.CreditTerm;
        if (
          $scope.vm.ContractStartDate != null &&
          $scope.vm.ContractStartDate != ""
        ) {
          $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
        }
        $scope.vm.ContractDuration = value.ContractDuration;
        $scope.vm.uCompanyName1 = value.CompanyName;
        $scope.vm.ContractEndDate = value.ContractEndDate;
        if (
          $scope.vm.ContractEndDate != null &&
          $scope.vm.ContractEndDate != ""
        ) {
          $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
        }
        $scope.BillinAddress = value.BillingAddres;
        $scope.vm.uEmail = value.Email;
        $scope.vm.Ccontact = value.ContactNumber;
        $scope.vm.CustomerID = value.CustomerID;
        $scope.vm.ContractNotes = value.ContractNotes;
        $scope.vm.CreatedBy = value.CreatedBy;
        $scope.vm.SalesPerson = value.SalesPerson_id;
        $scope.vm.SalesPerson1 = value.EmployeeName;
        $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
        $scope.vm.ContactPerson = value.ContactPerson;
        $scope.vm.ServiceStartDate = value.ServiceStartDate;
        if (
          $scope.vm.ServiceStartDate != null &&
          $scope.vm.ServiceStartDate != ""
        ) {
          $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
          $scope.ServiceStartDate = new Date(value.ServiceStartDate);
        }
        $scope.vm.ServiceEndDate = value.ServiceEndDate;
        if (
          $scope.vm.ServiceEndDate != null &&
          $scope.vm.ServiceEndDate != ""
        ) {
          $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
          $scope.ServiceEndDate = new Date(value.ServiceEndDate);
        }
        $scope.vm.Frequency = value.BillingFrequency;
        $scope.Frequency = value.BillingFrequency;
        if (value.MultiFrequency && value.MultiFrequency.length > 0) {
          $scope.TempFrequency = value.MultiFrequency.map(function (obj) {
            return obj.Frequency;
          }).join(",  ");
        } else {
          $scope.TempFrequency = $scope.vm.Frequency;
        }
        $scope.vm.SiteContactPerson = value.SiteContactPerson;
        $scope.vm.SiteName = value.SiteName;
        if (
          value.SiteContact != null &&
          value.SiteContact != undefined &&
          value.SiteContact != ""
        )
          $scope.vm.SiteContact = value.SiteContact;
        else $scope.vm.SiteContact = [];
        if (
          value.SiteEmail != null &&
          value.SiteEmail != undefined &&
          value.SiteEmail != ""
        )
          $scope.vm.SEmail = value.SiteEmail.split(",");
        else $scope.vm.SEmail = [];
        $scope.vm.EnquiryID = value.EnquiryID;
        $scope.MultiFrequencydatas = value.MultiFrequency;
        $scope.vm.TemplateName = value.TemplateID;
        $scope.vm.SalesOrderID = value.SalesOrderID;
        $scope.vm.CreditTerm = value.CreditTerm;
        $scope.CreditTerm = value.CreditTerm;
        $scope.vm.IncludeSOR = value.IncludeSOR;
        $scope.vm.Customer_id = value.Customer;
        $scope.vm.NatureofJob1 = value.PestType;
        $scope.vm.Quote = value.Quote;
        $scope.vm.Customer = value.Customer;
        $scope.vm.ContractStatus = value.ContractStatus;
        $scope.vm.CurrentStatus = value.Status;
        $scope.vm.CurrentStatusID = value.StatusID;
        $scope.RenewalN = value.Renewal;
        $scope.OldContract_Id = value.OldContract_Id;
        $scope.vm.PurchaseOrderNo = value.PurchaseOrderNo;
        //Customer

        var response1 = $http({
          url: $rootScope.WebURL + "/customer/get",
          method: "POST",
          data: { id: value.Customer_Id }
        });
        response1.then(function (customer) {
          var customer = customer.data.data;
          $scope.vm.Customer_id = customer._id;
          $scope.vm.uCustomerID = customer.CustomerID;
          $scope.CustID = customer.CustomerID;
          $scope.vm.uCustomerType = customer.CustomerType;
          $scope.vm.uSalutation = customer.Salutation;
          $scope.vm.uFirstName = customer.FirstName;
          $scope.vm.uLastName = customer.LastName;
          $scope.vm.uWebsite = customer.Website;
          $scope.vm.uCompanyName = customer.CompanyName;
          $scope.vm.uNote = customer.Note;
          $scope.vm.uAddress1 = customer.Address1;
          $scope.vm.uPostal = customer.Postal;
          $scope.vm.uCountry = customer.Country;
          $scope.vm.uContactPerson = customer.ContactPerson;
          $scope.vm.uPhone = parseInt(customer.Phone);
          $scope.vm.uFax = customer.Fax;
          $scope.Email = [];
          $scope.Email.push(customer.Email);
          var Mobile = customer.Mobile;
          if (Mobile != "" && Mobile != null && Mobile != undefined)
            $scope.vm.uMobile = Mobile.split(",").join(" , ");
          //
          $scope.vm.uTypeofHouse = customer.TypeofHouse;
          $scope.vm.uOtherType = customer.OtherType;
        });
        $scope.vm.uSAddress = value.sStreetName;
        $scope.vm.TempTemplate = value.TemplateName;

        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforBilling",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerBillingdata) {
          $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
          var item = $scope.CustomerBillingAddress.filter(function (item) {
            return item._id === value.BillingAddress;
          })[0];
          if (item != undefined) {
            $scope.vm.uAddress = item.bStreetName;
            $scope.Email.push(customer.bEmail);
          } else $scope.vm.uAddress = null;
        });
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });

        RefreshContractAttachment();
        RefreshAttachmentGrid();
        Refreshcomment();
      });
      // Refreshquotationlog();
    };

    $scope.GetEmail = function (Email) {
      if (Email != null && Email != undefined && Email != "")
        $scope.vm.CEmail = Email.split(",");
      else $scope.vm.CEmail = [];
    };

    $scope.Contracteditinfo = function (e, _id) {
      $scope.Contractsgrid = false;
      $scope.ShowContractform = true;
      $scope.Contractsform = false;
      $scope.Salesform = false;
      $scope.Add = false;
      $scope.view = true;
      $scope.Export = false;
      $scope.Search = false;
      $scope.SID = _id;
      $scope.ContractId = _id;
      $scope.vm.ContractId = _id;
      RefreshContractAttachment();
      $scope.ContarctAttachmentdatas = [];
      $http({
        url: $rootScope.WebURL + "/contract/getContractbyId",
        method: "POST",
        data: {
          id: $scope.SID
        }
      }).then(function (List) {
        var value = List.data.data[0];

        $scope.vm.LeadReferenceNo = value.LeadReferenceNo;
        $scope.vm.ContractReference = value.ContractReferenceNo;
        $scope.vm.ContractReceivedBy = value.ContractReceivedBy;
        $scope.vm.CName = value.ContactPerson
        $scope.vm.PurchaseOrder = value.PurchaseOrder;
        $scope.vm.ContractDate = new Date(value.ContractDate);
        $scope.vm.CustomerID = value.CustomerID;
        $scope.vm.Customer_id = value.Customer_id;
        var Requestid = value.CustomerIDD;
        getSorDetails($scope.SID);
        var Email = value.Email;
        if (Email != "" && Email != null && Email != undefined)
          $scope.vm.CEmail = value.Email.split(",");
        else $scope.vm.CEmail = [];
        $scope.vm.ppCompanyName = value.CompanyName;

        // Customer Service
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: Requestid }
        });
        response.then(function (CustomerServicedata) {
          var customerServicedetails = CustomerServicedata.data.data;
          if (customerServicedetails.length > 0) {
            $scope.vm.BAddress = customerServicedetails[0].sStreetName;
            var BillingAddres = [
              { sStreetName: customerServicedetails[0].sStreetName }
            ];
            $scope.CustomerServiceAddress = customerServicedetails;
            $scope.vm.SiteName = customerServicedetails[0].sName;
            var Mob = customerServicedetails[0].sMobile;
            if (Mob != undefined && Mob != null && Mob != "")
              $scope.vm.SiteContactNo = Mob.split(",");
            else $scope.vm.SiteContactNo = [];
            $scope.vm.SiteContactPerson =
              customerServicedetails[0].sContactPerson;
            var Email = customerServicedetails[0].sEmail;
            if (Email != undefined && Email != null && Email != "")
              $scope.vm.SEmail = Email.split(",");
            else $scope.vm.SEmail = [];
            $scope.CustomerServiceAddress = customerServicedetails;
          } else {
            $scope.CustomerServiceAddress = [];
            $scope.vm.SiteName = "";
            $scope.vm.SiteContactNo = [];
            $scope.vm.SiteContactPerson = null;
            $scope.vm.SEmail = [];
            $scope.CustomerServiceAddress = customerServicedetails;
          }
        });

        //Customer

        var response1 = $http({
          url: $rootScope.WebURL + "/customer/get",
          method: "POST",
          data: { id: value.Customer_Id }
        });
        response1.then(function (customer) {
          var customer = customer.data.data;
          $scope.vm.CSalutation = customer.Salutation;
          // $scope.vm.CName = customer.FirstName;
        });

        $scope.vm.NatureofJob = value.PestType;
        $scope.vm.BillingFrequency = value.BillingFrequency;
        $scope.vm.ContractStartDate = value.ContractStartDate;
        $scope.vm.ContractEndDate = value.ContractEndDate;
        $scope.vm.ContractDuration = parseInt(value.ContractDuration);
        $scope.vm.BAdress = value.SiteName;

        $scope.vm.CAddress = value.CustomerID;
        $scope.vm.UpCAddress = value.CustomerID;

        if (
          value.MarketSegment != null &&
          value.MarketSegment != "" &&
          value.MarketSegment != undefined
        ) {
          var a = value.MarketSegment.split(",");
          var array = [];
          _.each(a, function (ite) {
            array.push({ SegmentName: ite });
          });
          $scope.vm.CMarketSegment = array;
        }

        // $scope.vm.CMarketSegment = value.MarketSegment;
        var connumber = value.ContactNumber;
        if (connumber != null && connumber != undefined && connumber != "")
          $scope.vm.Ccontact = connumber.split(",").slice(0, 3);
        else $scope.vm.Ccontact = [];
        $scope.vm.ServiceHours = value.ServiceHours;
        $scope.vm.TotalSumPerfreq = parseInt(value.TotalSumPerfreq);
        $scope.vm.TotalOrderValue = parseFloat(value.ContractValue);
        if (
          $scope.vm.NatureofJob != null &&
          $scope.vm.NatureofJob != "" &&
          $scope.vm.NatureofJob != undefined
        ) {
          var array = $scope.vm.NatureofJob.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ PestName: value });
          });
          $scope.vm.NatureofJob = array1;
        }
        $scope.vm.SalesOrderID = value.SalesOrderID;
        $scope.vm.ContractMode = value.ContractMode;
        $scope.vm.CoverageArea = value.CoverageArea;
        $scope.vm.PurchaseOrderNo = value.PurchaseOrderNo;
        if (
          $scope.vm.CoverageArea != null &&
          $scope.vm.CoverageArea != "" &&
          $scope.vm.CoverageArea != undefined
        ) {
          var array = $scope.vm.CoverageArea.split(",");
          var array1 = [];
          angular.forEach(array, function (value) {
            array1.push({ AreasName: value });
          });
          $scope.vm.CoverageArea = array1;
        }
        $scope.vm.Header = value.Head;
        $scope.vm.Header1 = value.Head1;
        $scope.vm.Header2 = value.Head2;
        $scope.vm.ContactMedium = value.ContactMedium;
        $scope.vm.SalesPerson = value.SalesPerson_id;
        $scope.vm.ExpectedResponseDate = value.ExpectedResponseDate;
        if (
          $scope.vm.ExpectedResponseDate != null &&
          $scope.vm.ExpectedResponseDate != ""
        ) {
          $scope.vm.ExpectedResponseDate = new Date(value.ExpectedResponseDate);
        }
        $scope.vm.uSAddress = value.sStreetName;
        $scope.vm.Frequency = value.Frequency;
        $scope.vm.Confirmation = value.Confirmation;
        $scope.vm.ContractType = value.ContractType;
        $scope.vm.Quote = value.Quote;
        $scope.vm.ContractStatus = value.ContractStatus;
        $scope.vm.CurrentStatus = value.Status;
        $scope.vm.CurrentStatusID = value.StatusID;
        $scope.vm.IncludeSOR = value.IncludeSOR;
        $scope.vm.ServiceEndDate = value.ServiceEndDate;
        $scope.vm.ServiceStartDate = value.ServiceStartDate;
        $scope.vm.Servicestart = value.ServiceStartDate;
        $scope.vm.Serviceend = value.ServiceEndDate;
        $scope.vm.CreditTerm = value.CreditTerm;
        $scope.vm.TemplateName = value.TemplateID;
        $scope.Frequencydatas = value.MultiFrequency;
        $scope.vm.EnquiryID = value.EnquiryID;
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforBilling",
          method: "POST",
          data: { RequestID: value.CustomerIDD }
        });
        response.then(function (CustomerBillingdata) {
          $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
          $scope.vm.BAddress = value.BillingAddress;
        });
        try {
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === $scope.vm.Customer_id;
          });
          $scope.Leaddatas = litem;
        } catch (error) { }

        try {
          var item = $scope.Leaddatas.filter(function (item) {
            return item.LeadReferenceNo === $scope.vm.EnquiryID;
          })[0];
          $scope.vm.EnquiryID = item.LeadReferenceNo;
          if (
            $scope.vm.TotalOrderValue == null ||
            $scope.vm.TotalOrderValue == undefined ||
            $scope.vm.TotalOrderValue == ""
          )
            $scope.vm.TotalOrderValue = parseFloat(item.Pipelinevalue);
        } catch (error) { }

        $scope.vm.keys = [
          $mdConstant.KEY_CODE.ENTER,
          $mdConstant.KEY_CODE.COMMA
        ];
      });
    };

    $scope.SendMail = function (
      PCId,
      Email,
      BillFrequency,
      ServiceStart,
      ServiceEnd,
      EmployeeDatails,
      invoice
    ) {
      var item = $scope.contractdatas.filter(function (item) {
        return item._id === PCId;
      })[0];
      var Uitem = $scope.Userdatas.filter(function (item) {
        return item.UserID == $rootScope.createdby;
      })[0];
      $scope.MailTo = Email;
      $scope.CCTo = Uitem.Email + ",sales@pestoff.com.sg";
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure, you want to send Email ? <br><br> Mail Id: <b>" +
        $scope.MailTo +
        "</b><br> CC : <b>" +
        $scope.CCTo,
        "Email Confirmation!"
      );
      result.done(function (dialogResult) {
        if (dialogResult == true) {
          if (
            $scope.MailTo != undefined &&
            $scope.MailTo != null &&
            $scope.MailTo != ""
          )
            var Email = $scope.MailTo.split(",");
          else
            return $mdToast.show(
              $mdToast
                .simple()
                .textContent("Mail Id is not valid!")
                .position("top center")
            );
          var item = Email.filter(function (item) {
            return validateEmail(item) == false;
          });
          if (item.length > 0) {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Mail Id is not valid!")
                .position("top center")
            );
          } else {
            if (
              $scope.CCTo != undefined &&
              $scope.CCTo != null &&
              $scope.CCTo != ""
            )
              var Email = $scope.CCTo.split(",");
            else
              return $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("CC Id is not valid!")
                  .position("top center")
              );
            var item = Email.filter(function (item) {
              return validateEmail(item) == false;
            });
            if (item.length > 0) {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("CC is not valid!")
                  .position("top center")
              );
            } else {
              $scope.PreviewQuaotation(
                PCId,
                BillFrequency,
                ServiceStart,
                ServiceEnd,
                EmployeeDatails,
                invoice
              );
            }
          }
        }
        //
      });
    };
    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    $scope.cancel = function () {
      $mdDialog.cancel();
    };
    $scope.Totla = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        var secondDate = new Date(uTimeOut);
        if (
          firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)
        ) {
          return "Expiried";
        } else {
          var res = Math.round(
            Math.abs((secondDate.getTime() - firstDate.getTime()) / oneDay)
          );
          if (res == 0) {
            return "Expiried";
          } else {
            return res;
          }
        }
      } else {
        return null;
      }
    };
    $scope.renewalpopup = function (e, renewalId, Cname, Crn) {
      $mdDialog.show({
        templateUrl: 'app/main/apps/crm/contracts/renewal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.vm.RenewalId = renewalId;
      $scope.vm.Cname = Cname;
      $scope.vm.Crn = Crn;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractDuration = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.Frequency = null;
    };
    $scope.RenewalSubmit = function (renewalId) {
      try {
        var item = $scope.contractdatas.filter(function (item) {
          return item._id === renewalId;
        })[0];
        $scope.item = item;
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/add",
          data: {
            PestType: item.PestType,
            SalesPerson_id: item.SalesPerson_id,
            Frequency: $scope.vm.Frequency,
            ContractDuration: $scope.vm.ContractDuration,
            ContactNumber: $scope.vm.Ccontact,
            ContactPerson: item.ContactPerson,
            ContractStartDate: $scope.vm.ContractStartDate,
            ContractEndDate: $scope.vm.ContractEndDate,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            Customer_id: item.Customer_id,
            CustomerID: item.CustomerID,
            ContractNotes: item.ContractNotes,
            SalesOrderID: item.SalesOrderID,
            EnquiryID: item.vm.EnquiryID,
            Email: $scope.vm.CEmail,
            ContractStatus: "Open",
            Status: "New",
            StatusID: 1,
            OldContract_Id: $scope.vm.RenewalId,
            Renewal: "Renewaled",
            SiteContactPerson: $scope.vm.SiteContactPerson,
            SiteEmail: $scope.vm.SiteEmail,
            BillingAddress: $scope.vm.BAddress,
            SiteContact: $scope.vm.SiteContact,
            CreatedBy: $rootScope.createdby,
            IsActive: true,
            Client_Id: $rootScope.Client_Id
          }
        });
      } catch (e) { }
      response.then(
        function (GList) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/quotationlog/add",
            data: {
              ContractID: $scope.GListdata.id,
              Status: "New",
              TableName: "Contracts",
              StatusCreatedBy: $rootScope.createdby,
              StatusCreatedDate: new Date(),
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(function (GList) {
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("center")
            );
            RefreshGrid();
            $scope.Contractsgrid = true;
            $scope.Contractsform = false;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
          });
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Renewal = function (e) {
      $mdDialog.show({
        templateUrl: 'app/main/apps/crm/contracts/renewal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: true,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.RenewalDate = "";
      $scope.RenewalContractNo = "";
      $scope.CreatedDate = "";
      $scope.CreatedBy = "";
      $scope.RUpdate == false;
    };
    $scope.DaysCalc = function (CED) {
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var firstDate = new Date($scope.vm.ContractStartDate);
      var secondDate = new Date($scope.vm.ContractEndDate);
      $scope.vm.ContractDuration =
        Math.round(
          Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
        ) + 1;
    };
    $scope.ShowClosed = function (ShowClosed) {
      if (ShowClosed == true) {
        $scope.uShowClosed = true;
        $scope.contractdatas = $scope.ContractHalf;
      } else {
        // Refreshcomment();
        // RefreshAttachmentGrid();
        $scope.uShowClosed = false;
        $scope.contractdatas = $scope.ContractAll;
      }
      angular.forEach($scope.contractdatas, function (value) {
        try {
          value.ContractDate =
            new Date(value.ServiceStartDate).toLocaleDateString("en-GB") +
            " - " +
            new Date(value.ServiceEndDate).toLocaleDateString("en-GB");
          value.IncludeSor = value.IncludeSOR ? "Yes" : "No";
          value.TempPestType = value.MultiFrequency.map(function (obj) {
            return obj.PestType;
          }).join(",");
          var pest = value.TempPestType.split(",");
          var PestArray = [];
          PestArray = $scope.Pestdatas.filter(function (pestt) {
            return pest.includes(pestt.PestName);
          });
          value.PestCode = PestArray.map(function (obj) {
            if (
              obj.Pestcode != null &&
              obj.Pestcode != undefined &&
              obj.Pestcode != ""
            )
              return obj.Pestcode;
            else return obj.PestName;
          }).join(",");
        } catch (e) { }
      });
    };
    $scope.PreviewQuaotation = function (
      PCId,
      BillFrequency,
      ServiceStart,
      ServiceEnd,
      EmployeeDatails,
      invoice
    ) {
      $scope.vm.ContractDuration = " ";
      $scope.vm.BillingFrequency = BillFrequency;
      $scope.vm.ServiceStartDate = new Date(ServiceStart);
      $scope.vm.ServiceEndDate = new Date(ServiceEnd);
      $scope.UserID = undefined;
      try {
        var EmployeeID = EmployeeDatails;
        var item = $scope.Userdatas.filter(function (item) {
          return item.UserID == EmployeeID;
        });
        angular.forEach(item, function (value) {
          $scope.UserID = value.id;
        });
      } catch (e) { }
      CalculateDuration();
      var url =

        $rootScope.ReportURL +
        "Contracts.aspx" +
        "?" +
        "ID=" +
        PCId +
        "&Duration=" +
        $scope.vm.ContractDuration +
        "&UserID=" +
        $scope.UserID +
        "&Type=" +
        invoice;
      if (invoice == "Send Email") {
        if (dataGrid != undefined) dataGrid.beginCustomLoading();
        if (dataGrid1 != undefined) dataGrid1.beginCustomLoading();
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/SendEmail",
          data: {
            url: url
          }
        });
        response.then(function (List) {
          // RefreshGrid();
          if (dataGrid != undefined) dataGrid.endCustomLoading();
          if (dataGrid1 != undefined) dataGrid1.endCustomLoading();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Email Sent Successfully !")
              .position("top center")
          );
        });
      }
      //  window.open(url, "_blank", "toolbar=1, scrollbars=1, resizable=1, width=" + 1015 + ", height=" + 800);
      else window.open(url);
    };
    $scope.Preview = function () {
      if ($scope.vm.Header != null) {
        $scope.Frequencygroups = _.groupBy($scope.Frequencydatas, "Frequency");
        $scope.Previewdiv = true;
        var innerContents = document.getElementById("invoice").innerHTML;
        var popupWinindow = window.open(
          "",
          "_blank",
          "width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
        );
        popupWinindow.document.open();
        popupWinindow.document.write(
          '<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body  onload="window.print()">' +
          innerContents +
          "<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>"
        );
        popupWinindow.document.close(($scope.Previewdiv = false));
      }
    };

    $scope.ContractReport = function (ContractId) {
      var url =

        $rootScope.ReportURL +
        "Contracts.aspx" +
        "?" +
        "ID=" +
        ContractId;
      window.open(url);
    };

    function CalculateDuration() {
      try {
        var Frequency = $scope.vm.BillingFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          var TotalMonths = Math.round(Totaldays / 30);
          $scope.vm.ContractDuration = TotalMonths;
          if ($scope.vm.ContractDuration > 1) {
            $scope.vm.ContractDuration = TotalMonths + " months";
          } else {
            $scope.vm.ContractDuration = TotalMonths + " month";
          }
        }
      } catch (e) { }
    }
    $scope.sSubmit = function () {
      try {
        angular.forEach($scope.salesOrderdatas, function (svalue) {
          if ($scope.vm.SalesOrderID == svalue._id) {
            $scope.vm.Customer_id = svalue.customerdetails[0]._id;
          }
        });
      } catch (error) { }
      var CEmail = "";
      var SEmail = "";
      var Ccontact = "";
      var CMarketSegment = "";
      var NatureofJob = "";
      if (
        $scope.vm.NatureofJob != null &&
        $scope.vm.NatureofJob != "" &&
        $scope.vm.NatureofJob != undefined
      ) {
        NatureofJob = $scope.vm.NatureofJob.map(function (obj) {
          return obj.PestName;
        }).join(",");
      }
      if (
        $scope.vm.CMarketSegment != null &&
        $scope.vm.CMarketSegment != "" &&
        $scope.vm.CMarketSegment != undefined
      ) {
        CMarketSegment = $scope.vm.CMarketSegment.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      if (
        $scope.vm.CEmail != null &&
        $scope.vm.CEmail != "" &&
        $scope.vm.CEmail != undefined
      ) {
        CEmail = $scope.vm.CEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != "" &&
        $scope.vm.SEmail != undefined
      ) {
        SEmail = $scope.vm.SEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.Ccontact != null &&
        $scope.vm.Ccontact != "" &&
        $scope.vm.Ccontact != undefined
      ) {
        Ccontact = $scope.vm.Ccontact.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (!$scope.dataSource) $scope.dataSource = $scope.Sordatas;
      if ($scope.RenewalUpdate == false) {
        if ($scope.Update == true) {
          var response = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/contract/update",
            data: {
              _id: $scope.SID,
              SalesPerson_id: $scope.vm.SalesPerson,
              //  Frequency: multiFrequency,
              MarketSegment: CMarketSegment,
              CreditTerm: $scope.vm.CreditTerm,
              TemplateID: $scope.vm.TemplateName,
              IncludeSOR: $scope.vm.IncludeSOR,
              MultiFrequency: $scope.Frequencydatas,
              ContactPerson: $scope.vm.uContactPerson,
              ServiceEndDate: $scope.vm.ServiceEndDate,
              ContactNumber: Ccontact,
              ServiceStartDate: $scope.vm.ServiceStartDate,
              ContractStartDate: $scope.vm.ContractStartDate,
              ContractEndDate: $scope.vm.ContractEndDate,
              ContractDuration: $scope.vm.ContractDuration,
              ContractValue: $scope.vm.TotalOrderValue,
              ServiceHours: $scope.vm.ServiceHours,
              BillingFrequency: $scope.vm.BillingFrequency,
              TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
              Customer_id: $scope.vm.Customer_id,
              CustomerID: $scope.vm.CustomerID,
              EnquiryID: $scope.vm.EnquiryID,
              ContractNotes: $scope.vm.ContractNotes,
              ContractStatus: $scope.vm.ContractStatus,
              PurchaseOrder: $scope.vm.PurchaseOrder,
              Status: $scope.vm.CurrentStatus,
              StatusID: $scope.vm.CurrentStatusID,
              Email: CEmail,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              // SiteContactPerson:$scope.vm.SiteContactPerson,
              // SiteEmail:$scope.vm.SEmail,
              // SiteName:$scope.vm.SiteName,
              BillingAddress: $scope.vm.BAddress,
              // SiteContact:$scope.vm.SiteContact,
              Head: $scope.vm.Header,
              Head1: $scope.vm.Header1,
              Head2: $scope.vm.Header2
            }
          });
          response.then(
            function (GList) {
              $scope.GListdata = GList.data.data;
              if ($scope.vm.IncludeSOR == true) {
                var response1 = $http({
                  method: "POST",
                  url: $rootScope.WebURL + "/sor/deletebyContract",
                  data: {
                    Contract_Id: $scope.GListdata.id
                  }
                });
                response1.then(function (Ls) {
                  var count = 0;
                  $scope.dataSource = _.uniqBy(
                    $scope.dataSource,
                    "Description",
                    "Unit"
                  );
                  angular.forEach($scope.dataSource, function (item) {
                    var response2 = $http({
                      method: "POST",
                      url: $rootScope.WebURL + "/sor/add",
                      data: {
                        Customer: $scope.vm.Customer_id,
                        Contract: $scope.SID,
                        Description: item.Description,
                        Unit: item.Unit,
                        RateDuringOfficeHour: item.RateDuringOfficeHour,
                        RateAfterOfficeHour: item.RateAfterOfficeHour,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby
                      }
                    });
                    response2.then(function (GList) {
                      count++;
                      if (count == $scope.dataSource.length + 1) {
                        $mdToast.show(
                          $mdToast
                            .simple()
                            .textContent("SOR Added Successfully !")
                            .position("top center")
                        );
                      }
                    });
                  });
                });
              }
              $mdDialog.cancel();
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Successfully Updated!")
                  .position("top center")
              );
              // RefreshGrid();
              $scope.Contractsgrid = true;
              $scope.ShowContractform = false;
              $scope.Contractsform = false;
              $scope.Salesform = false;
              $scope.Export = true;
              $scope.Add = true;
              $scope.Search = true;
              $scope.view = false;
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $scope.dataSource = _.uniqBy(
            $scope.dataSource,
            "Description",
            "Unit"
          );
          var ContractArray = [];
          angular.forEach($scope.vm.CAddress, function (Lis) {
            try {
              var multiFrequency = $scope.Frequencydatas[0].Frequency;
            } catch (e) {
              var multiFrequency = $scope.vm.Frequency;
            }
            ContractArray.push({
              SalesPerson_id: $scope.vm.SalesPerson,
              Frequency: multiFrequency,
              MarketSegment: CMarketSegment,
              CreditTerm: $scope.vm.CreditTerm,
              TemplateID: $scope.vm.TemplateName,
              IncludeSOR: $scope.vm.IncludeSOR,
              MultiFrequency: $scope.Frequencydatas,
              ContactNumber: Ccontact,
              ContactPerson: $scope.vm.uContactPerson,
              ServiceEndDate: $scope.vm.ServiceEndDate,
              ServiceStartDate: $scope.vm.ServiceStartDate,
              ContractStartDate: $scope.vm.ContractStartDate,
              ContractEndDate: $scope.vm.ContractEndDate,
              ContractDuration: $scope.vm.ContractDuration,
              ContractValue: $scope.vm.TotalOrderValue,
              ServiceHours: $scope.vm.ServiceHours,
              BillingFrequency: $scope.vm.BillingFrequency,
              TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
              Customer_id: $scope.vm.Customer_id,
              CustomerID: Lis._id,
              PurchaseOrder: $scope.vm.PurchaseOrder,
              EnquiryID: $scope.vm.EnquiryID,
              ContractNotes: $scope.vm.ContractNotes,
              ContractStatus: $scope.vm.ContractStatus,
              Status: $scope.vm.CurrentStatus,
              StatusID: $scope.vm.CurrentStatusID,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              SORDetails: $scope.dataSource,
              Head: $scope.vm.Header,
              Head1: $scope.vm.Header1,
              Head2: $scope.vm.Header2,
              Email: CEmail,
              SiteContactPerson: $scope.vm.SiteContactPerson,
              SiteEmail: SEmail,
              BillingAddress: $scope.vm.BAddress,
              SiteContact: $scope.vm.SiteContact
            });
          });

          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/contract/addbyarray",
            data: { data: ContractArray }
          });
          response.then(
            function (GList) {
              $scope.GListdata = GList.data.data;
              $mdDialog.cancel();
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent("Successfully Added!")
                  .position("top center")
              );

              $scope.GListdata.forEach(function (item) {
                $scope.PreviewQuaotation(
                  item.id,
                  $scope.vm.BillingFrequency,
                  $scope.vm.ServiceStartDate,
                  $scope.vm.ServiceEndDate,
                  $rootScope.createdby,
                  "invoice"
                );
              });
              $scope.ShowContractform = false;
              $scope.Contractsgrid = true;
              $scope.Contractsform = false;
              $scope.Salesform = false;
              $scope.Export = true;
              $scope.Add = true;
              $scope.view = false;
              $scope.Search = true;
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      } else {
        $scope.dataSource = _.uniqBy($scope.dataSource, "Description", "Unit");
        try {
          var multiFrequency = $scope.Frequencydatas[0].Frequency;
        } catch (e) {
          var multiFrequency = $scope.vm.Frequency;
        }
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/renewal",
          data: {
            OldContract_Id: $scope.SID,
            SalesPerson_id: $scope.vm.SalesPerson,
            Frequency: multiFrequency,
            RenewalRemarks: $scope.vm.RenewalRemarks,
            MarketSegment: $scope.vm.CMarketSegment,
            CreditTerm: $scope.vm.CreditTerm,
            TemplateID: $scope.vm.TemplateName,
            IncludeSOR: $scope.vm.IncludeSOR,
            MultiFrequency: $scope.Frequencydatas,
            ContactNumber: $scope.vm.Ccontact,
            ContactPerson: $scope.vm.uContactPerson,
            ServiceEndDate: $scope.vm.ServiceEndDate,
            ServiceStartDate: $scope.vm.ServiceStartDate,
            ContractStartDate: $scope.vm.ContractStartDate,
            ContractEndDate: $scope.vm.ContractEndDate,
            ContractDuration: $scope.vm.ContractDuration,
            ContractValue: $scope.vm.TotalOrderValue,
            ServiceHours: $scope.vm.ServiceHours,
            BillingFrequency: $scope.vm.BillingFrequency,
            TotalSumPerfreq: $scope.vm.TotalSumPerfreq,
            Customer_id: $scope.vm.Customer_id,
            CustomerID: $scope.vm.CAddress,
            EnquiryID: $scope.vm.EnquiryID,
            ContractNotes: $scope.vm.ContractNotes,
            ContractStatus: $scope.vm.ContractStatus,
            Status: $scope.vm.CurrentStatus,
            StatusID: $scope.vm.CurrentStatusID,
            CreatedBy: $rootScope.createdby,
            IsActive: "true",
            Client_Id: $rootScope.Client_Id,
            SORDetails: $scope.dataSource,
            Head: $scope.vm.Header,
            Head1: $scope.vm.Header1,
            Head2: $scope.vm.Header2,
            Email: $scope.vm.CEmail,
            SiteContactPerson: $scope.vm.SiteContactPerson,
            SiteEmail: $scope.vm.SEmail,
            BillingAddress: $scope.vm.BAddress,
            SiteContact: $scope.vm.SiteContact
          }
        });
        response.then(
          function (GList) {
            $scope.GListdata = GList.data.data;
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Contract Renewed Successfully!")
                .position("top center")
            );
            RefreshGrid();
            $scope.ShowContractform = false;
            $scope.Contractsgrid = true;
            $scope.Contractsform = false;
            $scope.Salesform = false;
            $scope.Export = true;
            $scope.Add = true;
            $scope.view = false;
            $scope.Search = true;
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };

    $scope.commentSubmit = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          ContractID: $scope.SID,
          CustomerID: $scope.vm.CustomerID,
          TableName: "Contracts",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Addcomments,
          ModuleID: $scope.vm.ModuleID,
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(
        function (GList) {
          RefreshGrid();
          $scope.vm.Addcomments = "";
          $scope.Contractsgrid = false;
          $scope.Contractsform = true;
          $scope.Salesform = false;
          $scope.Export = false;
          $scope.Add = false;
          $scope.view = true;
          $scope.Search = false;
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Frequencydatas = [];
    $scope.ChangeTreatmentType = function (item) {
      if (item.TreatmentName == "Others" && item.selected == true) {
        $scope.ShowOthersTextBox = true;
      } else if (item.TreatmentName == "Others" && item.selected !== true) {
        $scope.ShowOthersTextBox = false;
      }
    };
    $scope.AddPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.Treatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/contracts/AddPestTypepopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.ChangeTreatment = function (Pestdata) {
      $scope.Treatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.Treatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        var OthersSelect = false;
        var ServiceTypeSelect = false;
        if (Pestdata.Others !== undefined) {
          OthersSelect = true;
        } else {
          OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          ServiceTypeSelect = true;
        } else {
          ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.Treatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          SelectServiceTrap: ServiceTypeSelect
        });
      }
    };
    $scope.SubmitPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.Treatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        var ServiceTrap = item.ServiceTrap;
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }
        if (OthersTreatment != undefined) {
          if (Treatmentarray != null && Treatmentarray != "") {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        array = $scope.Frequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });

        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }
        if (OthersTreatment != undefined) {
          if (Treatmentarray != null && Treatmentarray != "") {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }

        if (array.length == 0) {
          $scope.Frequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.Frequencydatas[
            $scope.Frequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      $mdDialog.hide();
    };
    $scope.EditPestControl = function (e, item) {
      RefreshTreatment();
      $scope.EditFrequency = true;
      $scope.vm.Frequency = item.Frequency;
      $scope.vm.Pesttype = item.PestType;
      $scope.vm.ServiceTrap = item.ServiceTrap;
      $scope.ChangeTreatment(item);
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/contracts/AddPestTypepopup.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.DeleteTempPest = function (DeleteItem) {
      var index = $scope.PestTreatmentdatas.indexOf(DeleteItem);
      $scope.PestTreatmentdatas.splice(index, 1);
    };
    $scope.DeletePestControl = function (DeleteItem) {
      var index = $scope.Frequencydatas.indexOf(DeleteItem);
      $scope.Frequencydatas.splice(index, 1);
    };

    $scope.UploadContractfiles = function (file) {
      angular.forEach(file, function (item) {
        var upfile = item.file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/contract/upload",
          data: { file: upfile }
        }).then(
          function (resp) {
            $scope.TableID = resp.data.data[0].GUIDFILENAME;
            $scope.fileName = resp.data.data[0].OriginalFileName;
            $scope.fileSize = resp.data.data[0].Size;
            $scope.Path = resp.data.data[0].Path;
            $scope.fileType = resp.data.data[0].Type;
            if (resp.data.message == "Successfully Uploaded") {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/add",
                data: {
                  TableID: $scope.TableID,
                  TableName: "Contracts",
                  FileID: $scope.vm.ContractId,
                  FileName: $scope.fileName,
                  FileSize: $scope.fileSize,
                  FileType: $scope.fileType,
                  ModuleID: $scope.Path,
                  Data: null,
                  IsActive: "true",
                  CreatedBy: $rootScope.createdby
                }
              });
              response.then(
                function (GList) {
                  RefreshContractAttachment();
                },
                function () {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        "Something entered gone wrong,please try again !"
                      )
                      .position("top center")
                  );
                }
              );
            }
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      });
      file[0].cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("Successfully Added!")
          .position("top center")
      );
    };

    function RefreshContractAttachment() {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.vm.ContractId }
      });
      response.then(function (attachmentdata) {
        $scope.ContarctAttachmentdatas = attachmentdata.data.data;
      });
    }

    $scope.Uploadfiles = function (file) {
      angular.forEach(file, function (item) {
        var upfile = item.file;
        var response = Upload.upload({
          url: $rootScope.WebURL + "/salesOrder/upload",
          data: { file: upfile }
        }).then(
          function (resp) {
            $scope.TableID = resp.data.data[0].GUIDFILENAME;
            $scope.fileName = resp.data.data[0].OriginalFileName;
            $scope.fileSize = resp.data.data[0].Size;
            $scope.Path = resp.data.data[0].Path;
            $scope.fileType = resp.data.data[0].Type;
            if (resp.data.message == "Successfully Uploaded") {
              var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/attachment/add",
                data: {
                  TableID: $scope.TableID,
                  TableName: "Sales Order",
                  FileID: UniqID,
                  FileName: $scope.fileName,
                  FileSize: $scope.fileSize,
                  FileType: $scope.fileType,
                  ModuleID: $scope.Path,
                  Data: null,
                  IsActive: "true",
                  CreatedBy: $rootScope.createdby
                }
              });
              response.then(
                function (GList) {
                  RefreshAttachmentGrid();
                },
                function () {
                  $mdToast.show(
                    $mdToast
                      .simple()
                      .textContent(
                        "Something entered gone wrong,please try again !"
                      )
                      .position("top center")
                  );
                }
              );
            }
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      });
      file[0].cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("Successfully Added!")
          .position("top center")
      );
    };

    $scope.DeleteAttachement = function (e, deleteID) {
      $scope.AttachdeleteID = deleteID;
      $mdDialog.show({
        templateUrl: 'app/main/apps/crm/contracts/attachmentdelete.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    // $scope.Adelete = function (AttachmentdeleteID) {
    //     var response = $http({
    //         method: "POST",
    //         url:  $rootScope.WebURL + "/attachment/delete",
    //         data: { _id: AttachmentdeleteID },
    //     });
    //     response.then(function (GList) {
    //         RefreshAttachmentGrid();
    //         $mdDialog.cancel();
    //         $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
    //     }, function () {
    //         $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
    //     });
    // }

    $scope.Adelete = function (e, AttachmentdeleteID, datas) {
      if ($scope.Update == false) {
        var index = $scope.Attachmentdatas.indexOf(datas);
        $scope.Attachmentdatas.splice(index, 1);
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/attachment/delete",
          data: { _id: AttachmentdeleteID }
        });
        response.then(
          function (GList) {
            RefreshAttachmentGrid();
            RefreshContractAttachment();
            $mdDialog.cancel();
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Deleted!")
                .position("top center")
            );
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      }
    };

    $scope.ChangeCustomer = function (Customerdata) {
      $scope.vm.CMarketSegment = null;
      try {
        CustomerBillingdatadetails(Customerdata.CustomerID);
        $scope.vm.CName = Customerdata.FirstName;
        $scope.vm.CSalutation = Customerdata.Salutation;
        $scope.vm.uCustomerID = Customerdata.CustomerID;
        $scope.vm.CreditTerm = Customerdata.CreditTerm;
        $scope.vm.Ccontact = [];
        var contact = Customerdata.Mobile;
        if (contact != "" && contact != null && contact != undefined) {
          contact = contact.split(",").slice(0, 3);
          $scope.vm.Ccontact = contact;
        }

        //
        // $scope.vm.CAddress = Customerdata.StreetName;
        // $scope.vm.CPostalCode = Customerdata.Postal;
        // $scope.vm.CBuildingName = Customerdata.BuildingName;
        if (
          Customerdata.MarketSection != null &&
          Customerdata.MarketSection != "" &&
          Customerdata.MarketSection != undefined
        ) {
          var a = Customerdata.MarketSection.split(",");
          var array = [];
          _.each(a, function (ite) {
            array.push({ SegmentName: ite });
          });
          $scope.vm.CMarketSegment = array;
        }
        $scope.CusEmail = [];
        $scope.GetEmail(Customerdata.Email);
        //  $scope.vm.CMarketSegment = Customerdata.MarketSection;
        //
        // $scope.vm.Ccontact = Customerdata.Mobile;
        try {
          var litem = $scope.Leaddetails.filter(function (litem) {
            return litem.CustomerID === Customerdata._id;
          });
          $scope.Leaddatas = litem;
        } catch (e) { }
        if ($scope.Leaddatas.length > 0) {
          $scope.vm.EnquiryID =
            $scope.Leaddatas[$scope.Leaddatas.length - 1].LeadReferenceNo;
          if (
            $scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == "Day"
          )
            $scope.vm.ServiceHours = "During Office Hours";
          else if (
            $scope.Leaddatas[$scope.Leaddatas.length - 1].ServiceTime == "Night"
          )
            $scope.vm.ServiceHours = "After Office Hours";
          else $scope.vm.ServiceHours = "Wee Hours 12:00pm - 8:30am";
          $scope.vm.TotalOrderValue = parseFloat(
            $scope.Leaddatas[$scope.Leaddatas.length - 1].Pipelinevalue
          );
        }
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: Customerdata.CustomerID }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });
      } catch (e) {
        $scope.vm.CMarketSegment = null;
      }
    };
    $scope.getLeaddetails = function (row) {
      if (row.ServiceTime == "Day")
        $scope.vm.ServiceHours = "During Office Hours";
      else if (row.ServiceTime == "Night")
        $scope.vm.ServiceHours = "After Office Hours";
      else $scope.vm.ServiceHours = "Wee Hours 12:00pm - 8:30am";
      $scope.vm.TotalOrderValue = parseFloat(row.Pipelinevalue);
    };
    function decode_base64(str) {
      return decodeURIComponent(escape(window.atob(str)));
    }

    function RefreshCustomerdatas() {
      $scope.getCustomerdatas = [];
      DataSyncService.getAllCustomers().then(function (customerdata) {
        $scope.getCustomerdatas = customerdata;
        $scope.Customerdatas = $scope.getCustomerdatas;
        if (IsAdmin != true) {
          var item = $scope.getCustomerdatas.filter(function (item) {
            if (item.AssignedUser != null)
              return item.AssignedUser.includes($rootScope.createdby);
          });
          $scope.Customerdatasfordropdown = item;
        } else {
          $scope.Customerdatasfordropdown = $scope.getCustomerdatas;
        }
      });
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/pesttype",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (pestdata) {
      $scope.Pestdatas = pestdata.data.data;
      $scope.Pestdatasdatas = pestdata.data.data;
    });
    RefreshSchedulerFrequency();
    RefreshTreatment();
    function RefreshTreatment() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/treatment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Treatmentdata) {
        $scope.Treatmentdatas = Treatmentdata.data.data;
      });
    }
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/user/getByClientId",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Userdata) {
      $scope.Userdatas = Userdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/Workflow",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Workflowdata) {
      $scope.Workflowdatas = Workflowdata.data.data;
      // $scope.Datefilter();
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contracttemplate",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (contracttemplate) {
      $scope.Contracttemplates = contracttemplate.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/crmscopeofwork",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (sowdata) {
      $scope.SOWdatas = sowdata.data.data;
    });

    function RefreshGrid() {
      const Limit = 500;

      $scope.contractdatas = [];
      $scope.workOrd = [];
      $scope.Pendingcontractdatas = [];

      // Start loading indicators
      if (dataGrid1) dataGrid1.beginCustomLoading();
      if (dataGrid) dataGrid.beginCustomLoading();

      // Function to fetch paginated contract data
      return $http
        .post($rootScope.WebURL + "/contract/getnewLength", {
          Client_Id: $rootScope.Client_Id
        })
        .then(function (res) {
          const total = parseInt(res.data.data);
          const totalPages = Math.ceil(total / Limit);
          const requests = [];

          for (var i = 0; i < totalPages; i++) {
            const skip = i * Limit;
            requests.push(
              $http.post(
                $rootScope.WebURL + "/contract/getfortable",
                {
                  Client_Id: $rootScope.Client_Id,
                  IsAdmin: IsAdmin,
                  SalesPerson: $scope.Emp_Id,
                  Skip: skip,
                  Limit: Limit
                }
              )
            );
          }

          return Promise.all(requests);
        })
        .then(function (responses) {
          var allContracts = _.uniqWith(
            responses.flatMap(function (r) {
              return r.data.data;
            }),
            _.isEqual
          );

          $scope.contractdatas = allContracts;
          $scope.workOrd = allContracts;
          $scope.AllContractdata = allContracts;

          // Save to IndexedDB
          indexedDBService.clearStore("contract").then(function () {
            indexedDBService.addAll("contract", allContracts);
          });
          $scope.vm.PreviewSpinner = false;
          extract_contract_data($scope);
        }).catch(function (err) {
          console.log(err)
          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                "Error loading contracts. Please refresh the page."
              )
              .position("top center")
          );
          if (dataGrid1) dataGrid1.endCustomLoading();
          if (dataGrid) dataGrid.endCustomLoading();
        });
    }

    $scope.Refresh = function () {
      $scope.Add = true;
      $scope.RenewalUpdate = false;
      $scope.uFrom = null;
      $scope.uTo = null;
      RefreshGrid();
    };

    $scope.getContractRenewal = function () {
      $scope.contractRenewaldatas = [];
      $scope.Add = false;
      var StartDate = new Date(new Date().setMonth(new Date().getMonth() + 3));
      $scope.workOrd = [];
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getrenewal",
        data: {
          Client_Id: $rootScope.Client_Id,
          Type: "SalesOrder",
          IsAdmin: IsAdmin,
          SalesPerson: $scope.Emp_Id,
          Skip: 0,
          Limit: 20000,
          StartDate: new Date(0),
          EndDate: StartDate
        }
      }).then(function (GList) {
        $scope.vm.PreviewSpinner = false;
        $scope.contractRenewaldatas = GList.data.data;
        $scope.workOrd = $scope.contractRenewaldatas;
      });
    };

    function RefreshAttachmentGrid() {
      if ($scope.Salesform == true) $scope.File_id = UniqID;
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: $scope.File_id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
      // var response1 = $http({
      //     url:  $rootScope.WebURL + "/attachment/getByFileID",
      //     method: "POST",
      //     data: { FileID: $rootScope.ID },
      // });
      // response1.then(function (attachmentdata) {
      //     $scope.UserAttachments = attachmentdata.data.data;
      //     $scope.FilePath = null;
      //     try {
      //         $scope.FilePath = $rootScope.UploadsURL + 'Security/Users/' + $scope.Attachmentdatas[0].TableID;
      //         $scope.fileName = null;
      //     } catch (e) {
      //         $scope.FilePath = null;
      //     }
      // });
    }
    function Refreshcomment() {
      var response = $http({
        url:
          $rootScope.WebURL + "/schedulercomment/getByContractID",
        method: "POST",
        data: { RequestID: $scope.File_id }
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
      });
    }
    function Refreshquotationlog() {
      var response = $http({
        url: $rootScope.WebURL + "/quotationlog/getByRequestID",
        method: "POST",
        data: { Contract_id: $scope.File_id }
      });
      response.then(function (Quotationlogdata) {
        $scope.Quotationlogdatas = Quotationlogdata.data.data;
        var resArr = [];
        try {
          $scope.Quotationlogdatas.filter(function (item) {
            var i = resArr.findIndex(function (x) {
              return x.Status == item.Status;
            });
            if (i <= -1) resArr.push(item);
          });
        } catch (e) { }
        $scope.Quotationlogdatas = resArr;
      });
    }
    function quotationlogsubmit() {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/quotationlog/add",
        data: {
          ContractID: $scope.SID,
          TableName: "Contracts",
          Status: $scope.cNextActioned,
          StatusCreatedBy: $scope.createdby,
          StatusCreatedDate: new Date(),
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(function (GList) {
        RefreshGrid();
      });
    }
    function fetchContract(contractId) {
      angular.forEach($scope.contractdatas, function (value) {
        if (value._id == contractId) {
          $scope.vm.ContractId = value._id;
          $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
          $scope.vm.ContractStartDate = value.ContractStartDate;
          if (
            $scope.vm.ContractStartDate != null &&
            $scope.vm.ContractStartDate != ""
          ) {
            $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
          }
          $scope.vm.ContractDuration = value.ContractDuration;
          $scope.vm.uCompanyName = value.CustomerName;
          $scope.vm.ContractEndDate = value.ContractEndDate;
          if (
            $scope.vm.ContractEndDate != null &&
            $scope.vm.ContractEndDate != ""
          ) {
            $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
          }
          $scope.vm.ContractNotes = value.ContractNotes;
          $scope.vm.CreatedBy = value.CreatedBy;
          $scope.vm.SalesPerson = value.SalesPerson;
          $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
          $scope.vm.ContactPerson = value.ContactPerson;
          $scope.vm.ServiceStartDate = value.ServiceStartDate;
          if (
            $scope.vm.ServiceStartDate != null &&
            $scope.vm.ServiceStartDate != ""
          ) {
            $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
          }
          $scope.vm.ServiceEndDate = value.ServiceEndDate;
          if (
            $scope.vm.ServiceEndDate != null &&
            $scope.vm.ServiceEndDate != ""
          ) {
            $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
          }
          $scope.vm.Frequency = value.Frequency;
          $scope.vm.SalesOrderID = value.SalesOrderID;
          $scope.vm.NatureofJob1 = value.PestType;
          $scope.vm.ContractStatus = value.ContractStatus;
          $scope.vm.CurrentStatus = value.Status;
          $scope.vm.CurrentStatusID = value.StatusID;
        }
        RefreshContractAttachment();
      });
    }
    $scope.CalculateTotalServices = function () {
      try {
        var Frequency = $scope.vm.BillingFrequency;
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date($scope.vm.ServiceStartDate);
        var secondDate = new Date($scope.vm.ServiceEndDate);
        var Totaldays =
          1 +
          Math.round(
            Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
          );
        if (Frequency !== null && Frequency !== undefined && Frequency !== "") {
          if (Frequency.toUpperCase() == "DAILY") {
            $scope.vm.ContractDuration = Totaldays;
          } else if (Frequency.toUpperCase() == "WEEKLY") {
            var TotalWeeks = Math.round(Totaldays / 7);
            $scope.vm.ContractDuration = TotalWeeks;
          } else if (Frequency.toUpperCase() == "YEARLY") {
            var Totalyearss = Math.round(Totaldays / 365);

            $scope.vm.ContractDuration = Totalyearss;
          } else if (
            Frequency.toUpperCase() == "BIMONTHLY" ||
            Frequency.toUpperCase().indexOf("BI-MONTHLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 60);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else if (
            Frequency.toUpperCase() == "HALF-YEARLY" ||
            Frequency.toUpperCase().indexOf("HALFYEARLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 183);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else if (
            Frequency.toUpperCase().indexOf("FORTNIGHTLY") > -1 ||
            Frequency.toUpperCase().indexOf("BI-WEEKLY") > -1 ||
            Frequency.toUpperCase().indexOf("BIWEEKLY") > -1
          ) {
            var TotalHallfyearss = Math.round(Totaldays / 14);

            $scope.vm.ContractDuration = TotalHallfyearss;
          } else {
            //for Month
            var TotalMonths = Math.round(Totaldays / 30);

            $scope.vm.ContractDuration = TotalMonths;
          }
        }
      } catch (e) { }
    };
    function ClearForm() {
      $scope.vm.CustomerName = null;
      $scope.vm.Customer_id = null;
      $scope.vm.SalesOrderID = null;
      $scope.vm.CMarketSegment = null;
      $scope.vm.CSalutation = null;
      $scope.vm.CName = null;
      $scope.vm.Ccontact = [];
      $scope.vm.CAddress = null;
      $scope.vm.CPostalCode = null;
      $scope.vm.CBuildingName = null;
      $scope.vm.ContractReferenceNo = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.NatureofJob = null;
      $scope.vm.ContractValue = null;
      $scope.vm.ContractDuration = null;
      $scope.vm.uContactPerson = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.ContractNotes = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.SalesPerson = null;
      $scope.vm.Frequency = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.TemplateName = null;
      $scope.vm.CreditTerm = null;
      $scope.Frequencydatas = [];
      $scope.vm.IncludeSOR = false;
      $scope.vm.CEmail = [];
      $scope.vm.SEmail = [];
      $scope.vm.BAddress = null;
      $scope.vm.SiteContactPerson = null;
      $scope.vm.SiteName = null;
      $scope.vm.SiteContact = [];
      $scope.basicForm.$setPristine();
      $scope.basicForm.$setUntouched();
    }

    $scope.getRowColour = function (item) {
      if (item.MultiFrequency !== undefined && item.MultiFrequency.length > 0) {
        var Frequencies = item.MultiFrequency;
        item.TempFrequency = Frequencies.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        var PestType = item.MultiFrequency.map(function (obj) {
          return obj.PestType;
        }).join(",");
        PestType = PestType.split(",");
        var array1 = [];

        angular.forEach(PestType, function (value) {
          if (array1.indexOf(value) == -1) {
            array1.push(value);
          }
        });
        item.TempPestType = array1
          .map(function (obj) {
            return obj;
          })
          .join(", ");
      } else {
        item.TempFrequency = item.Frequency;
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var ServiceEndDate = item.ServiceEndDate;
      if (new Date(ServiceEndDate) < new Date(today)) {
        return true;
      } else {
        return false;
      }
    };

    // var vm = this;
    //// Data
    vm.dashboardData = DashboardData;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtOptions1 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      destroy: true,
      responsive: true,
      drawCallback: function (settings) {
        var api = this.api();

        var rows = api.rows({ page: "current" }).nodes();
        var last = null;

        api
          .column(1, { page: "current" })
          .data()
          .each(function (group, i) {
            if (last !== group) {
              $(rows)
                .eq(i)
                .before(
                  '<tr class="group"><td colspan="18"><b>' +
                  group +
                  "</b></td></tr>"
                );

              last = group;
            }
          });
      }
    };
    function ClearWOForm() {
      $scope.vm.SalesOrderNo = null;
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.ConfirmationMode = null;
      $scope.vm.ConfirmationBy = null;
      $scope.vm.ConfirmationReceivedBy = null;
      $scope.vm.ConfirmationReceivedDate = new Date();
      $scope.vm.Remarks = null;
      $scope.vm.CreatedBy = null;
      $scope.vm.PONumber = null;
      $scope.vm.PestType = null;
      $scope.vm.ContactPerson = null;
      $scope.vm.CustomerName = null;
      $scope.vm.ServiceStartDate = null;
      $scope.vm.ServiceEndDate = null;
      $scope.vm.ContractStartDate = null;
      $scope.vm.ContractEndDate = null;
      $scope.vm.Frequency = null;
      $scope.vm.TotalSum = null;
      $scope.vm.PaymentTerms = null;
      $scope.vm.BillingFrequency = null;
      $scope.vm.Types = null;
      $scope.vm.EstimatedHoursRequired = null;
      $scope.vm.RemarksFinance = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.vm.ServicesRequired = null;
      $scope.vm.TotalPrice = null;
      $scope.vm.CoverageArea = null;
      $scope.vm.PurchaseOrderNo = null;
      $scope.vm.DateTimeofTreatment = "";
      $scope.vm.TotalTripsPerYear = 0;
      $scope.vm.SpecialRemarks = null;
      $scope.vm.SpecialRemark = null;
      $scope.vm.BAddress = null;
      $scope.vm.BContactPerson = null;
      $scope.vm.BContactNo = null;
      $scope.vm.BEmail = [];
      $scope.vm.SLocation = null;
      $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
      // $scope.vm.SContactNo = $scope.vm.SiteContact;
      $scope.vm.SName = $scope.vm.SiteName;
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != undefined &&
        $scope.vm.SEmail != ""
      )
        $scope.vm.SiteEmail = $scope.vm.SEmail;
      else $scope.vm.SiteEmail = [];
    }
    $scope.CreateWorkOrder = function (e) {
      $scope.Salesform = true;
      $scope.Contractsform = false;
      $scope.Contractsgrid = false;
      $scope.Export = false;
      $scope.Pageform = false;
      $scope.Add = false;
      $scope.Search = false;
      $scope.ShowContractform = false;
      $scope.view = true;
      ClearWOForm();
      // $scope.vm.uAddress = $scope.vm.CAddress
      $scope.vm.TrendingReport = "false";
      $scope.vm.Department = "Pest Off";
      $scope.vm.BAddress = $scope.vm.uAddress;
      $scope.vm.SContactPerson = null;
      $scope.Commentdatas = [];
      $scope.CommentArray = [];
      $scope.Attachmentdatas = [];
      $scope.vm.OrderType = "Contract";
      $scope.vm.IsUrgent = "false";
      // $scope.vm.ContractNo = $scope.vm.ContractReferenceNo
      $scope.vm.OrderConfirmationDate = new Date();
      $scope.vm.CustomerName = $scope.vm.Customer_id;
      if (
        $scope.vm.uEmail != null &&
        $scope.vm.uEmail != undefined &&
        $scope.vm.uEmail != ""
      )
        $scope.vm.BEmail = $scope.vm.uEmail.split(",");
      else $scope.vm.BEmail = [];
      $scope.vm.BContactPerson = $scope.vm.uContactPerson;
      if (
        $scope.vm.Ccontact != null &&
        $scope.vm.Ccontact != undefined &&
        $scope.vm.Ccontact != ""
      )
        $scope.vm.BContactNo = $scope.vm.Ccontact.split(",").slice(0, 3);
      else $scope.vm.BContactNo = [];
      $scope.WOFrequencydatas = $scope.MultiFrequencydatas;
      $scope.vm.ServiceStartDate = new Date($scope.ServiceStartDate);
      $scope.vm.ServiceEndDate = new Date($scope.ServiceEndDate);
      angular.forEach($scope.WOFrequencydatas, function (item) {
        item.JobsPerFrequency = 1;
        // $scope.calculateServices(item.Frequency, item.JobsPerFrequency)
        try {
          $scope.vm.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
          item.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
        } catch (error) {
          $scope.vm.ServicesRequired = 0;
          item.ServicesRequired = 0;
        }
      });
      if ($scope.WOFrequencydatas.length > 0) {
        var num = _.maxBy($scope.WOFrequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }

      $scope.vm.SLocation = $scope.vm.UpCAddress;
      $scope.vm.BillingFrequency = $scope.Frequency;
      $scope.vm.CreditTerm = $scope.CreditTerm;
      $scope.vm.SContactPerson = $scope.vm.SiteContactPerson;
      if (
        $scope.vm.SiteContact != null &&
        $scope.vm.SiteContact != undefined &&
        $scope.vm.SiteContact != ""
      )
        $scope.vm.SiteContact = $scope.vm.SiteContact.split(",");
      try {
        var litem = $scope.Leaddetails.filter(function (litem) {
          return litem.CustomerID === $scope.vm.Customer_id;
        });
        $scope.Leaddatas = litem;
      } catch (error) { }

      if (
        $scope.vm.SLocation != null &&
        $scope.vm.SLocation != "" &&
        $scope.vm.SLocation != undefined
      ) {
        $scope.DisableServiceLocation = true;
        var response = $http({
          url:

            $rootScope.WebURL +
            "/customerService/getByIDforService",
          method: "POST",
          data: { RequestID: $scope.CustID }
        });
        response.then(function (CustomerServicedata) {
          $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        });
      } else $scope.DisableServiceLocation = false;
      try {
        var item = $scope.Leaddatas.filter(function (item) {
          return item.LeadReferenceNo === $scope.vm.EnquiryID;
        })[0];

        $scope.vm.EnquiryReferenceNo = item.LeadReferenceNo;
        if (
          $scope.vm.CTotalOrderValue == null ||
          $scope.vm.CTotalOrderValue == undefined ||
          $scope.vm.CTotalOrderValue == ""
        )
          $scope.vm.TotalPrice = parseFloat(item.Pipelinevalue);
        else $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue);
      } catch (error) {
        $scope.vm.TotalPrice = parseFloat($scope.vm.CTotalOrderValue);
        $scope.vm.EnquiryReferenceNo = null;
      }

      if (item == undefined) {
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/salesOrder",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (marketsegmentdata) {
          var info = marketsegmentdata.data.data;
          var y = "";
          for (var x = 1001; x <= 1001 + info.length; x++) {
            y = "EQ/RN/" + x;
          }
          $scope.vm.EnquiryReferenceNo = y;
        });
      }
      $scope.vm.keys1 = [
        $mdConstant.KEY_CODE.ENTER,
        $mdConstant.KEY_CODE.COMMA
      ];
    };

    $scope.calculateServices = function (freq, job) {
      try {
        $scope.vm.ServicesRequired = parseInt(freq.match(/\(([^)]+)\)/)[1]);
      } catch (error) {
        $scope.vm.ServicesRequired = 0;
      }
    };

    function CustomerBillingdatadetails(Requestid) {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingAddress = CustomerBillingdata.data.data;
        // var CustomerBillingdatas = CustomerBillingdata.data.data;
        // if (CustomerBillingdatas.length > 0) {
        //     $scope.vm.BAddress = CustomerBillingdatas[0].bStreetName;
        // $scope.vm.SContactPerson = CustomerBillingdatas[0].bContactPerson;
        // $scope.vm.SContactNo = CustomerBillingdatas[0].bMobile;
        //    $scope.vm.BEmail = CustomerBillingdatas[0].sEmail;
        // }
      });
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: Requestid }
      });
      response.then(function (CustomerServicedata) {
        var CustomerServicedatas = CustomerServicedata.data.data;
        $scope.CustomerServiceAddress = CustomerServicedata.data.data;
        if (CustomerServicedatas.length > 0) {
          // $scope.vm.SLocation = CustomerServicedatas[0].sStreetName;
          $scope.vm.SContactPerson = CustomerServicedatas[0].sContactPerson;
          $scope.vm.SContactNo = CustomerServicedatas[0].sMobile;
          $scope.vm.SName = CustomerServicedatas[0].sName;
        }
      });
    }

    $scope.AddWOPestType = function (e) {
      $scope.ShowPestAdd = false;
      $scope.vm.SelectFreq = null;
      $scope.vm.Frequency = null;
      $scope.PestTreatmentdatas = [];
      $scope.Pesttypearray = null;
      $scope.vm.SelectPest = null;
      $scope.vm.Scopeofwork = null;
      $scope.vm.ServicesRequired = null;
      $scope.vm.JobsPerFrequency = 1;
      $scope.WOTreatmentpopupdata = [];
      $scope.EditFrequency = false;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/contracts/AddTreatmentFrequency.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      RefreshTreatment();
    };
    $scope.Editpest = function (e, Pestdata) {
      $scope.PestUpdate = true;
      $scope.vm.Frequency = Pestdata.Frequency;
      $scope.vm.JobsPerFrequency = Pestdata.JobsPerFrequency;
      $scope.vm.ServicesRequired = Pestdata.ServicesRequired;
      $scope.vm.PestType = Pestdata.PestType;
      //   $scope.vm.SelectPest =  Pestdata.PestType;
      if (
        $scope.vm.PestType != null &&
        $scope.vm.PestType != "" &&
        $scope.vm.PestType != undefined
      ) {
        var array = $scope.vm.PestType.split(",");
        var array1 = [];
        angular.forEach(array, function (value) {
          array1.push({ PestName: value });
        });
        $scope.vm.PestType = array1;
      }
      $scope.vm.SelectPest = $scope.vm.PestType;
      $mdDialog.show({
        multiple: true,
        templateUrl: 'app/main/apps/crm/contracts/AddTreatmentFrequency.html',
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.Pestdata = Pestdata;
      if ($scope.PestUpdate == true) {
        $scope.vm.JobsPerFrequency = $scope.vm.JobsPerFrequency || 1;
        // $scope.calculateServices($scope.vm.Frequency, $scope.vm.JobsPerFrequency)
        try {
          item.ServicesRequired = parseInt(
            item.Frequency.match(/\(([^)]+)\)/)[1]
          );
        } catch (error) {
          item.ServicesRequired = 0;
        }
      }
    };

    $scope.ForAlternateWeek = function (freq) {
      if (
        freq == "Alternate Week (52)" ||
        freq === "Alternate Twice a Week (104)"
      ) {
        var item = $scope.Pestdatas.filter(function (item) {
          return item.PestName === "Adult Mosquito";
        });
        $scope.Pestdatasdatas = item;
      } else $scope.Pestdatasdatas = $scope.Pestdatas;
    };
    $scope.CheckTreatment = function () {
      debugger;
      if ($scope.vm.Frequency === "Alternate Week (52)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Week frequency!"
            )
            .position("center")
        );
      }
      if ($scope.vm.Frequency === "Alternate Twice a Week (104)") {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please select only 2 Treatment for Alternate Twice a Week frequency!"
            )
            .position("center")
        );
      }
    };

    $scope.ChangeWOTreatment = function (Pestdata) {
      $scope.WOTreatmentpopupdata = [];
      if ($scope.EditFrequency == false) {
        if (Pestdata !== null && Pestdata !== undefined && Pestdata !== "") {
          $scope.Pesttypearray = [];
          angular.forEach(Pestdata, function (value) {
            var Pestname = value.PestName;
            var array = [];
            var item1 = $scope.Treatmentdatas.filter(function (item1) {
              if (item1.PestType == Pestname) {
                if (item1.TreatmentName != "Service Light Traps")
                  array.push({ TreatmentName: item1.TreatmentName });
              }
            });
            $scope.WOTreatmentpopupdata.push({
              PestName: Pestname,
              Treatment: array
            });
          });
        }
      } else {
        var array = [];
        var item1 = $scope.Treatmentdatas.filter(function (item1) {
          if (item1.PestType == Pestdata.PestType) {
            var selectedtreatment = Pestdata.Treatment.split(", ");
            if (selectedtreatment.indexOf(item1.TreatmentName) !== -1) {
              item1.selected = true;
            }
            array.push({
              TreatmentName: item1.TreatmentName,
              selected: item1.selected
            });
          }
          return item1.PestType.indexOf(Pestdata.PestType) > -1;
        });
        if (Pestdata.Others !== undefined) {
          var OthersSelect = true;
        } else {
          var OthersSelect = false;
        }
        if (Pestdata.ServiceTrap !== undefined) {
          var ServiceTypeSelect = true;
        } else {
          var ServiceTypeSelect = false;
        }
        array.map(function (o, k) {
          if (o.TreatmentName === "Service Light Traps")
            if (k != undefined) array.splice(k);
        });
        $scope.WOTreatmentpopupdata.push({
          PestName: Pestdata.PestType,
          Treatment: array,
          Others: Pestdata.Others,
          selectothers: OthersSelect,
          ServiceTrap: Pestdata.ServiceTrap,
          ServiceTypeSelect: ServiceTypeSelect
        });
        if ($scope.WOFrequencydatas.length > 0) {
          $scope.Pesttypearray = [];
          $scope.WOTreatmentpopupdata = [];
          angular.forEach(Pestdata, function (pestdata) {
            angular.forEach($scope.WOFrequencydatas, function (value) {
              if (pestdata.PestName == value.PestType) {
                var Pestname = pestdata.PestName;
                var array = [];
                var selectothers = false;
                var Others = "";
                var ServiceTrap = "";
                var SelectServiceTrap = false;
                var item1 = $scope.Treatmentdatas.filter(function (item1) {
                  if (item1.PestType.indexOf(Pestname) > -1) {
                    item1.selected = false;

                    if (value.Treatment != undefined) {
                      var selectedtreatment = value.Treatment.split(", ");
                      if (
                        selectedtreatment.indexOf(item1.TreatmentName) !== -1
                      ) {
                        item1.selected = true;
                      } else item1.selected = false;
                    }
                    array.push({
                      TreatmentName: item1.TreatmentName,
                      selected: item1.selected
                    });
                  }
                  if (value.Others != undefined) {
                    selectothers = true;
                    Others = value.Others;
                  }
                  if (value.ServiceTrap != undefined) {
                    SelectServiceTrap = true;
                    ServiceTrap = value.ServiceTrap;
                  }
                });
                array.map(function (o, k) {
                  if (o.TreatmentName === "Service Light Traps")
                    if (k != undefined) array.splice(k);
                });
                $scope.WOTreatmentpopupdata.push({
                  PestName: Pestname,
                  Treatment: array,
                  selectothers: selectothers,
                  Others: Others,
                  SelectServiceTrap: SelectServiceTrap,
                  ServiceTrap: ServiceTrap
                });
              }
            });
          });
        }
      }
    };
    $scope.switchValue = true;
    $scope.IsUrgent = {
      onText: "YES",
      offText: "NO",
      bindingOptions: {
        value: "switchValue"
      }
    };
    $scope.SubmitWOPest = function () {
      var Scopeofwork = "";
      var array = [];
      angular.forEach($scope.WOTreatmentpopupdata, function (item) {
        var item1 = item.Treatment.filter(function (item1) {
          return item1.selected == true;
        });
        var Treatmentarray = null;
        var OthersTreatment = item.Others;
        var ServiceTrap = item.ServiceTrap;
        if (item.selectothers == false) {
          OthersTreatment = undefined;
        }
        if (item.SelectServiceTrap == false) {
          ServiceTrap = undefined;
        }

        if (item1 !== undefined) {
          Treatmentarray = item1
            .map(function (obj) {
              return obj.TreatmentName;
            })
            .join(", ");
        }
        if (OthersTreatment != undefined && Treatmentarray != "") {
          if (Treatmentarray != null) {
            Treatmentarray = Treatmentarray + ", " + OthersTreatment;
          } else Treatmentarray = OthersTreatment;
        }
        array = $scope.WOFrequencydatas.filter(function (item2) {
          return (
            item2.PestType == item.PestName &&
            item2.Frequency == $scope.vm.Frequency
          );
        });
        if (ServiceTrap != undefined) {
          if (Treatmentarray != "" && Treatmentarray != null)
            Treatmentarray = Treatmentarray + ", Service Light Traps";
          else Treatmentarray = "Service Light Traps";
        }

        $scope.EditFrequency = true;
        if (array.length == 0) {
          $scope.WOFrequencydatas.push({
            Frequency: $scope.vm.Frequency,
            PestType: item.PestName,
            Treatment: Treatmentarray,
            JobsPerFrequency: $scope.vm.JobsPerFrequency,
            ServicesRequired: $scope.vm.ServicesRequired,
            Others: OthersTreatment,
            ServiceTrap: ServiceTrap
          });
        } else if ($scope.EditFrequency == true) {
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].Treatment = Treatmentarray;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].Others = OthersTreatment;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].JobsPerFrequency = $scope.vm.JobsPerFrequency;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].ServicesRequired = $scope.vm.ServicesRequired;
          $scope.WOFrequencydatas[
            $scope.WOFrequencydatas.indexOf(array[0])
          ].ServiceTrap = ServiceTrap;
          $scope.EditFrequency == false;
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Existing Data!")
              .position("top center")
          );
        }
      });
      if ($scope.WOFrequencydatas.length > 0) {
        var num = _.maxBy($scope.WOFrequencydatas, "ServicesRequired");
        $scope.vm.TotalTripsPerYear = parseInt(num.ServicesRequired);
      }
      $mdDialog.hide();
    };

    $scope.WOSubmit = function () {
      $scope.Email.push($scope.vm.ServiceEmail);
      $scope.Email.push($scope.vm.ServiceEmailCC);

      $scope.Email = $scope.Email.map(function (o) {
        return o;
      }).join(",");
      $scope.groupFrequency = _.groupBy($scope.WOFrequencydatas, "Frequency");
      var salesOrderArray = [];
      angular.forEach($scope.WOFrequencydatas, function (value) {
        if (
          value.JobsPerFrequency == null &&
          value.JobsPerFrequency == undefined &&
          value.ServicesRequired == null &&
          value.ServicesRequired == undefined
        ) {
          salesOrderArray.push(1);
        }
      });
      if (salesOrderArray.length > 0)
        return $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              "Please Add Jobs Per Frequency and Services Required for Treatment Frequency!"
            )
            .position("top center")
        );

      $scope.vm.PaymentMode = $scope.vm.PaymentMode;

      if (
        $scope.Frequencydatas != null &&
        $scope.Frequencydatas != "" &&
        $scope.Frequencydatas != undefined
      ) {
        $scope.vm.Frequency = $scope.Frequencydatas.map(function (obj) {
          return obj.Frequency;
        }).join(",");
        $scope.vm.PestType = $scope.Frequencydatas.map(function (obj) {
          return obj.PestType;
        }).join(",");
        $scope.vm.Treatment = $scope.Frequencydatas.map(function (obj) {
          return obj.Treatment;
        }).join(",");
        $scope.vm.JobsPerFrequency = $scope.Frequencydatas.map(function (obj) {
          return obj.JobsPerFrequency;
        }).join(",");
        $scope.vm.ServicesRequired = $scope.Frequencydatas.map(function (obj) {
          return obj.ServicesRequired;
        }).join(",");
      }
      if (
        $scope.vm.BEmail != null &&
        $scope.vm.BEmail != "" &&
        $scope.vm.BEmail != undefined
      ) {
        $scope.vm.BEmail = $scope.vm.BEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.SEmail != null &&
        $scope.vm.SEmail != "" &&
        $scope.vm.SEmail != undefined
      ) {
        $scope.vm.SEmail = $scope.vm.SEmail.map(function (obj) {
          return obj;
        }).join(",");
      }
      if (
        $scope.vm.BContactNo != null &&
        $scope.vm.BContactNo != "" &&
        $scope.vm.BContactNo != undefined
      ) {
        $scope.vm.BContactNo = $scope.vm.BContactNo.map(function (obj) {
          return obj;
        }).join(",");
      }
      var salesOrderArray = [];

      salesOrderArray.push({
        MultiFrequency: $scope.Frequencydatas,
        SalesPerson_id: $scope.vm.SalesPerson,
        ContractNo: $scope.vm.ContractNo,
        Customer_id: $scope.vm.Customer_ID,
        EnquiryReferenceNo: $scope.vm.EnquiryReferenceNo,
        OrderConfirmationDate: $scope.vm.OrderConfirmationDate,
        ContactPerson: $scope.vm.uContactPerson,
        ServiceStartDate: $scope.vm.ServiceStartDate,
        ServiceEndDate: $scope.vm.ServiceEndDate,
        OrderType: $scope.vm.OrderType,
        TotalSum: $scope.vm.TotalSum,
        IsUrgent: $scope.vm.IsUrgent,
        PaymentMode: $scope.vm.PaymentMode,
        BillingFrequency: $scope.vm.BillingFrequency,
        EstimatedHoursRequired: $scope.vm.EstimatedHoursRequired,
        RemarksFinance: $scope.vm.RemarksFinance,
        CoverageArea: $scope.vm.CoverageArea,
        PurchaseOrderNo: $scope.vm.PurchaseOrderNo,
        DateTimeofTreatment: $scope.vm.DateTimeofTreatment,
        TotalTripsPerYear: $scope.vm.TotalTripsPerYear,
        SpecialRemarks: $scope.vm.Message,
        CreatedBy: $rootScope.createdby,
        Client_Id: $rootScope.Client_Id,
        TotalPrice: $scope.vm.TotalPrice,
        PestType: $scope.vm.PestType,
        Frequency: $scope.vm.Frequency,
        Treatment: $scope.vm.Treatment,
        JobsPerFrequency: $scope.vm.JobsPerFrequency,
        TrendingReport: $scope.vm.TrendingReport,
        Department: $scope.vm.Department,
        ServicesRequired: $scope.vm.ServicesRequired,
        CustomerID: $scope.vm.SLocation,
        SiteContactNo: $scope.vm.SiteContact,
        Mobile: $scope.vm.BContactNo,
        Email: $scope.vm.BEmail,
        SiteContactPerson: $scope.vm.SiteContactPerson,
        SiteEmail: $scope.vm.SEmail,
        SiteName: $scope.vm.SiteName,
        SiteContact: $scope.vm.SiteContact,
        SpecialChemical: $scope.vm.SpecialChemical,
        PreferredTime: $scope.vm.PreferredTime,
        Message: $scope.vm.Message,
        CommentArray: $scope.CommentArray,
        SchedulerEmail: $scope.Email,
        BillingAddress: $scope.BillinAddress,
        UniqID: UniqID
      });
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/salesOrder/addbyArray",
        data: { salesOrderArray: salesOrderArray }
      });
      response.then(function (List) {
        var Id = List.data.data.id;

        // RefreshGrid();
        $scope.CommentArray = [];
        $scope.Commentdata = [];
        $scope.Attachmentdatas = [];
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Work Order Successfully Added!")
            .position("top center")
        );
        $scope.Contractsgrid = true;
        $scope.Contractsform = false;
        $scope.Salesform = false;
        $scope.Export = true;
        $scope.Add = true;
        $scope.view = false;
        $scope.Search = true;
      });
    };

    $scope.DeleteComment = function (data) {
      $scope.delComId = data.key;
      var result = DevExpress.ui.dialog.confirm(
        "Are you sure, you want to delete the comment?",
        "Confirm!"
      );
      result.done(function (dialogResult) {
        if (dialogResult === true) {
          _.remove($scope.Commentdatas, function (o) {
            return o.key === $scope.delComId;
          });
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Deleted Successfully!")
              .position("top center")
          );
        }
      });
    };

    $scope.SORDerails = function (tick, e, check) {
      $scope.Disablesubmit = false;
      if (tick == true) {
        $mdDialog.show({
          multiple: true,
          templateUrl: 'app/main/apps/accounts/contracts/AddSor.html',
          parent: angular.element($document.body),
          targetEvent: e,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          controller: function AccontractsController($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            };
          }
        });
        var updating = false;
        $scope.dataGridOptions = {
          dataSource: $scope.Sordatas,
          keyExpr: "_id",
          showBorders: true,
          paging: {
            enabled: false
          },

          editing: {
            mode: "batch",
            allowUpdating: true,
            allowDeleting: true,
            allowAdding: true,
            useIcons: true
          },
          onRowUpdating: function (e) {
            updating = true;
          },
          onRowRemoving: function (e) {
            updating = true;
          },
          onRowInserting: function (e) {
            updating = true;
          },
          onContentReady: function (e) {
            if (e.component.hasEditData()) {
              $scope.Disablesubmit = true;
            } else $scope.Disablesubmit = false;
          },
          columns: [
            {
              caption: "#",
              width: "50",
              cellTemplate: function (cellElement, cellInfo) {
                cellElement.text(
                  cellInfo.component.pageIndex() *
                  cellInfo.component.pageSize() +
                  cellInfo.row.rowIndex +
                  1
                );
              }
            },
            {
              dataField: "Description",
              caption: "Description",
              width: "30%"
            },
            {
              dataField: "Unit",
              width: "10%"
            },
            {
              dataField: "RateDuringOfficeHour",
              caption: "Rate ($) During Office Hour",
              width: "15%"
            },
            {
              dataField: "RateAfterOfficeHour",
              caption: "Rate ($) After Office Hour",
              width: "15%"
            }
          ]
        };
      }
      if (check == false) $scope.ShowSubmit = false;
      else $scope.ShowSubmit = true;
    };

    $scope.SubmitSOR = function () {
      $scope.dataSource = $("#gridContainer")
        .dxDataGrid("instance")
        .option("dataSource");
      if ($scope.dataSource.length == 0)
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Please Fill SOR details or Click Cancel button !")
            .position("top center")
        );
      else $scope.cancel();
    };

    function RefreshComments(ID) {
      var response = $http({
        url:
          $rootScope.WebURL + "/schedulercomment/getByContractID",
        method: "POST",
        data: { RequestID: ID }
      });
      response.then(function (Commentdata) {
        $scope.Commentdatas = Commentdata.data.data;
        angular.forEach($scope.Commentdatas, function (item) {
          item.CreatedDate = new Date(item.CreatedDate);
        });
        $scope.Commentdatas.reverse();
      });
    }
    $scope.CommentArray = [];
    $scope.AddComment = function () {
      //     if($scope.Update==true){
      // var response = $http({
      //   method: "POST",
      //   url:  $rootScope.WebURL + "/comment/add",
      //   data: {
      //     TableRowID: $scope.SID,
      //     TableName: "SalesOrder",
      //     CommentedBy: $rootScope.createdby,
      //     cmt: $scope.vm.SpecialRemarks,
      //     ModuleID: $scope.vm.ModuleID,
      //     CreatedBy: $rootScope.createdby,
      //     IsActive: "true",
      //   },
      // });
      // response.then(function (GList) {
      //     $scope.vm.SpecialRemarks = '';
      //     RefreshComments($scope.SID)
      // }, function () {
      //   $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      // });
      // }
      // else
      // {
      if ($scope.vm.SpecialRemarks != "" && $scope.vm.SpecialRemarks != null) {
        $scope.SpecialRem = $scope.vm.SpecialRemarks;
        $scope.CommentArray.push({
          key: $scope.CommentArray.length + 1,
          cmt: $scope.vm.SpecialRemarks,
          CommentedBy: $rootScope.createdby,
          CreatedDate: new Date()
        });
        $scope.Commentdatas = $scope.CommentArray;
        $scope.vm.SpecialRemarks = null;
      }
    };
    //   }

    $scope.closepest = function () {
      $mdDialog.hide();
      $scope.Pestdata = null;
    };
    $scope.Deletepest = function (DeleteItem) {
      var index = $scope.WOFrequencydatas.indexOf(DeleteItem);
      $scope.WOFrequencydatas.splice(index, 1);
      RefreshSchedulerFrequency();
    };
    function RefreshSchedulerFrequency() {
      $http({
        url: $rootScope.WebURL + "/settings",
        method: "POST",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (settingsdata) {
        $scope.Settingsdatas = settingsdata.data.data;
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "ScheduleFrequency";
          });
          $scope.ScheduleFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentMode";
          });
          $scope.PaymentModedatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BillingFrequency";
          });
          $scope.BillingFrequencydatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "PaymentTerm";
          });
          $scope.PaymentTermdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "JobTypes";
          });
          $scope.JobTypesdatas = item;
        } catch (e) { }
        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "BuildingType";
          });
          $scope.BuildingTypedatas = item;
        } catch (e) { }

        try {
          var item = $scope.Settingsdatas.filter(function (item) {
            return item.Description === "CreditTerm";
          });
          $scope.CreditTermdatas = item;
        } catch (e) { }
      });
    }
    function getSorDetails(Contract) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/sor/getByContract",
        data: { Client_Id: $rootScope.Client_Id, Contract: Contract }
      }).then(function (Sortabledata) {
        if (Sortabledata.data.data.length > 0)
          $scope.Sordatas = Sortabledata.data.data;
      });
    }

    function getSor() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/sor/get",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (Sortabledata) {
        $scope.Sordatas = Sortabledata.data.data;
      });
    }

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/lead",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (leaddata) {
      $scope.Leaddetails = leaddata.data.data;
    });

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });

    $scope.ClickTemplate = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/contracts/PreviewTemplate.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function AccontractsController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      var Start =
        moment()._locale._months[moment($scope.vm.ServiceStartDate).month()] +
        " " +
        moment($scope.vm.ServiceStartDate).year();
      var End =
        moment()._locale._months[moment($scope.vm.ServiceEndDate).month()] +
        " " +
        moment($scope.vm.ServiceEndDate).year();
      if (
        $scope.vm.TotalMonth == undefined &&
        $scope.vm.ServiceStartDate != "" &&
        $scope.vm.ServiceStartDate != null &&
        $scope.vm.ServiceStartDate != undefined &&
        $scope.vm.ServiceEndDate != "" &&
        $scope.vm.ServiceEndDate != null &&
        $scope.vm.ServiceEndDate != undefined
      )
        $scope.getMonth(
          $scope.vm.ServiceStartDate,
          $scope.vm.ServiceEndDate,
          null
        );
      var Month = $scope.vm.TotalMonth;
      var Months = $scope.vm.TotalMonth;
      var Frequency = $scope.vm.BillingFrequency;
      var Amount = 0;
      var freqbasis = "";
      if (Frequency == "COD") {
        freqbasis = " in Cash";
        Amount = parseFloat($scope.vm.TotalOrderValue) / 1;
      } else if (Frequency == "Weekly") {
        freqbasis = " per week";
        var start = moment(new Date($scope.vm.ServiceStartDate));
        var end = moment(new Date($scope.vm.ServiceEndDate));
        var weeks = end.diff(start, "week");
        Amount = parseFloat($scope.vm.TotalOrderValue) / weeks;
      } else if (Frequency == "Monthly") {
        freqbasis = " per month";
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency == "Quarterly") {
        freqbasis = " quarterly";
        var Month = parseInt(Month / 3);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency == "Bi-Monthly (6)") {
        freqbasis = " bi-monthly";
        Frequency = "Bi-Monthly";
        var Month = parseInt(Month / 2);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency == "Half Yearly (2)") {
        freqbasis = " half yearly";
        Frequency = "Half Yearly";
        var Month = parseInt(Month / 6);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else if (Frequency == "Yearly") {
        freqbasis = " per year";
        var Month = parseInt(Month / 12);
        Amount = parseFloat($scope.vm.TotalOrderValue) / Month;
      } else {
        freqbasis = " once";
        Amount = parseFloat($scope.vm.TotalOrderValue) / 1;
      }

      if (Months != 0 && Months != 1) Months = Months + " months";
      else Months = Months + " month";

      if (Amount % 1 < 1 && Amount % 1 != 0) {
        Amount = Amount.toFixed(2);
      }
      var amtt = Amount;
      // amtt = parseFloat(amtt) * 7 / 100 + parseFloat(amtt)
      var amt = parseFloat(amtt);
      var amout = amt;
      if (amt % 1 < 1 && amt % 1 != 0) {
        amt = amt.toFixed(2);
      }

      var amountt = amout.toFixed(2);

      if ($scope.Update) {
        if (
          $scope.vm.Servicestart === $scope.vm.ServiceStartDate &&
          $scope.vm.Serviceend === $scope.vm.ServiceEndDate
        ) {
          amountt = parseFloat(vm.Header.split("$")[1].split("(")[0]);
          amt = amountt;
          amountt = amountt.toFixed(2);
        }
      }

      if ($scope.vm.ServiceHours == "During Office Hours")
        var OfficeHours = "During Office Hours 9am - 5pm";
      else if ($scope.vm.ServiceHours == "After Office Hours")
        var OfficeHours = "After Office Hours 5pm - 12:00mn";
      else if ($scope.vm.ServiceHours == "Wee Hours")
        var OfficeHours = "During Wee Hours 12:00mn - 9am";

      vm.Header =
        "<p align='justify'>This Contract will hereby commence at the above service location from <u><b>" +
        Start +
        "</b></u> to <u><b>" +
        End +
        "</b></u> and to hold unto The Client for a period of <u><b>" +
        Months +
        "</b></u>. The Client agrees to pay for the scope of work on a <u><b>" +
        Frequency +
        "</b></u> basis, a sum of Singapore Dollars <u><b>" +
        toWords(amt) +
        " S$ " +
        amountt +
        " (subjected to prevailing GST)</b></u> " +
        freqbasis +
        ". Payable to <b>Pest Off Pte Ltd</b> within " +
        $scope.vm.CreditTerm +
        " of invoice. Additional services will be charged separately.</p>";
      vm.Header1 =
        "<p align='justify'>Refer to the 'Scope of Work' as stated below will be carried out <b>" +
        OfficeHours +
        "</b>, the schedule and time is stated as such below. Additional charges will apply upon changing to different time range. </p>";
      vm.Header2 =
        "<div><h4><b>ACCESS TO PREMISES</b></h4></div><div><p align='justify'>The Client shall provide free access to all parts of the premises for any inspection or treatment to be carried out. The Contractor will not be liable for any services not carried out to areas which are inaccessible, restricted or obstructed.</p></div><div><h4><b>LIABILITY</b></h4></div><div><p align='justify'>This contract is not enforceable by third parties. The Contractor shall not be liable to the Client or any third party for any special, punitive, consequential, incidental, exemplary damages or by any treatment undertaken to exterminate the pest due to negligence or omission on the part of the contractor or any of its employees or otherwise (including lost or anticipated revenues or profits relating to the same) arising from any claim relating to this Agreement, whether such claim is based on warranty, contract, tort (including negligence or strict liability) or otherwise,  even if the Contractor is advised of the possibility or likelihood of the same.<br><div>This Contract shall be subjected to the laws of the Republic of Singapore.</div></p></div><div><h4><b>TERMINATION OF CONTRACT</b></h4></div><div><p align='justify'>The contract is binding for a period term as stated above and shall not be terminated by either party.Upon completion of the contract, a new contract may be re-drafted and signed by both parties. Until the contract is signed or termination is given the contract will be enforced on a month to month basis until either party terminates. (1) Month notice will be given in writing by either party after the expiry of the contract to terminate.</p></div>";
    };

    vm.taToolbar = [
      [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "pre",
        "quote",
        "bold",
        "italics",
        "underline",
        "strikeThrough",
        "ul",
        "ol",
        "redo",
        "undo",
        "clear"
      ],
      [
        "justifyLeft",
        "justifyCenter",
        "justifyRight",
        "justifyFull",
        "indent",
        "outdent",
        "html",
        "insertImage",
        "insertLink",
        "insertVideo",
        "wordcount",
        "charcount"
      ]
    ];
    var th = ["", "Thousand", "Million", "Billion", "Trillion"];

    var dg = [
      "Zero",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine"
    ];
    var tn = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen"
    ];
    var tw = [
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety"
    ];
    function toWords(s) {
      s = s.toString();
      s = s.replace(/[\, ]/g, "");
      if (s != parseFloat(s)) return "not a number";
      var x = s.indexOf(".");
      if (x == -1) x = s.length;
      if (x > 15) return "too big";
      var n = s.split("");
      var str = "";
      var sk = 0;
      for (var i = 0; i < x; i++) {
        if ((x - i) % 3 == 2) {
          if (n[i] == "1") {
            str += tn[Number(n[i + 1])] + " ";
            i++;
            sk = 1;
          } else if (n[i] != 0) {
            str += tw[n[i] - 2] + " ";
            sk = 1;
          }
        } else if (n[i] != 0) {
          str += dg[n[i]] + " ";
          if ((x - i) % 3 == 0) str += "Hundred ";
          sk = 1;
        }
        if ((x - i) % 3 == 1) {
          if (sk) str += th[(x - i - 1) / 3] + " ";
          sk = 0;
        }
      }
      //    if (x != s.length) {
      //        var y = s.length;
      //        str += 'and ';
      //        for (var i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
      //        str += 'cents '
      //    }
      if (x != s.length) {
        if (str != "") str += "and ";
        if (Number(s.charAt(x + 1)) > 1) {
          if (Number(s.charAt(x + 1)) > 1) {
            str += tw[Number(s.charAt(x + 1)) - 2] + " ";
          } else if (
            Number(s.charAt(x + 1)) == 1 &&
            Number(s.charAt(x + 2)) > 0
          ) {
            str += tn[Number(s.charAt(x + 2)) - 1] + " ";
          } else str += tn[0] + " ";

          if (Number(s.charAt(x + 2)) != 0)
            str += dg[Number(s.charAt(x + 2))] + " ";
        } else if (
          Number(s.charAt(x + 1)) == 1 &&
          Number(s.charAt(x + 2)) > 0
        ) {
          str += tn[Number(s.charAt(x + 2))] + " ";
        } else if (Number(s.charAt(x + 1)) == 0) {
          str += dg[Number(s.charAt(x + 2))] + " ";
        } else str += tn[0] + " ";
        str += "Cents ";
      }
      str += "Only";
      return str.replace(/\s+/g, " ");
    }

    $scope.getMonth = function (StartDate, EndDate, Frequency) {
      if (
        StartDate != "" &&
        StartDate != null &&
        StartDate != undefined &&
        EndDate != "" &&
        EndDate != null &&
        EndDate != undefined
      ) {
        EndDate = moment(EndDate).add(1, "days");
        var a = moment(StartDate);
        var b = EndDate;
        var Month = b.diff(a, "month");
        $scope.vm.TotalMonth = Month;
      } else $scope.vm.TotalMonth = 0;
    };

    $scope.getServiceEndDate = function (StartDate) {
      if (StartDate != null && StartDate != undefined && StartDate != "") {
        var StartDate = new Date(StartDate);
        $scope.vm.ServiceEndDate = moment(StartDate).add(1, "year");
        $scope.vm.ServiceEndDate = new Date(
          $scope.vm.ServiceEndDate.add(-1, "days")
        );
      }
    };

    $scope.getMonthAmount = function (Month, value) {
      if (
        Month != "" &&
        Month != null &&
        Month != undefined &&
        value != "" &&
        value != null &&
        value != undefined
      ) {
        $scope.vm.AmountperMonth =
          Month == 0 ? parseFloat(value) / 1 : parseFloat(value) / Month;
      } else $scope.vm.AmountperMonth = 0;
    };

    // clear date filter

    $scope.ClearFilter = function () {
      $scope.uTo = null;
      $scope.uFrom = null;
      // RefreshGrid();
    };

    function monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth() + 1;
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    }
    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }
    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // socket configuration

    function extract_contract_data($scope) {
      $scope.contractdatas = [];
      $scope.PastContractdatas = [];
      $scope.contractRenewaldatas = [];
      var data = $scope.AllContractdata.filter(function (item) {
        return item.Status == "New";
      });
      $scope.Pendingcontractdatas = _.uniq(data);

      $scope.workOrd = $scope.Pendingcontractdatas;
      angular
        .element("#YTSContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.Pendingcontractdatas);

      var now = new Date().getTime();

      var data1 = $scope.AllContractdata.filter(function (item) {
        return item.Status == "SalesOrder";
      });
      var futureContracts = data1.filter(function (contract) {
        return new Date(contract.ServiceEndDate).getTime() > now;
      });

      var pastContracts = data1.filter(function (contract) {
        return new Date(contract.ServiceEndDate).getTime() < now;
      });

      $scope.contractdatas = _.uniqWith(
        $scope.contractdatas.concat(futureContracts),
        _.isEqual
      );

      $scope.PastContractdatas = _.uniqWith(
        $scope.PastContractdatas.concat(pastContracts),
        _.isEqual
      );
      var date_3_month_later = new Date(
        new Date().setMonth(new Date().getMonth() + 3)
      ).getTime();

      var renewal_data = data1.filter(function (contract) {
        return (
          new Date(contract.ServiceEndDate).getTime() < date_3_month_later &&
          contract.Renewal === false
        );
      });

      $scope.contractRenewaldatas = _.uniqWith(
        $scope.contractRenewaldatas.concat(renewal_data),
        _.isEqual
      );
      angular
        .element("#PendingContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.contractdatas);



      angular
        .element("#RenewalContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.contractRenewaldatas);

      if (dataGrid1) dataGrid1.endCustomLoading();
      if (dataGrid) dataGrid.endCustomLoading();
      if (dataGrid2) dataGrid2.endCustomLoading();
    }

    $scope.$on("contract_created", function (event, item) {
      $scope.AllContractdata.push(item);
      extract_contract_data($scope);
    });

    $scope.$on("contract_modified", function (event, item) {
      var idx = $scope.AllContractdata.findIndex(function (c) {
        return c.id === item.id;
      });
      if (idx !== -1) {
        $scope.AllContractdata[idx] = item;
      }
      extract_contract_data($scope);
    });

    $scope.$on("contract_deleted", function (event, item) {
      getAllContract();
    });
  }
})();
angular.module("apps.crm.contracts").config(function ($mdDateLocaleProvider) {
  $mdDateLocaleProvider.firstDayOfWeek = 1;
});

(function () {
    'use strict';

    angular
        .module('app.accounts.dashboard')
        .controller('DashboardaccountsController', DashboardaccountsController);

    /** @ngInject */
    function DashboardaccountsController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData) {
        document.getElementsByTagName('title')[0].text = "Accounts-Dashboard"
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("DAccounts")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var Client_Id = localStorage.getItem('Client_Id');
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;
        debugger
        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;
        vm.widget1.ranges = {
            "All": "All",
            "Yesterday": "Yesterday",
            "Today": "Today",
            "Tomorrow": "Tomorrow"
        }
        vm.widget1.currentRange = "Today";

        totaljobs();
        $scope.totaljobs = 0;
        $scope.completedjobs = 0;
        $scope.totalassets = 0;
        $scope.totaldiposed = 0;
        $scope.totalpayables = 0;
        $scope.totalpaid = 0;
        $scope.totalreceivables = 0;
        $scope.totalreceived = 0;


        function totaljobs() {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = new Date(today);
            $scope.uTo = new Date(end);
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo.setHours(23, 59, 59, 999);
            var response = $http({
                url: $rootScope.WebURL + "/scheduler/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
            });
            response.then(function (GList) {
                $scope.Uniqueschedulerdatas = GList.data.data;

                $scope.totaljobs = $scope.Uniqueschedulerdatas.length;

                var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                    return item.Status === "Completed";
                });
                $scope.completedjobs = item.length;
            });
        }


        $scope.Range = function () {
            debugger

            var range = vm.widget1.currentRange;
            if (range == "All") {
                $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/scheduler",
                    data: { Client_Id: $rootScope.Client_Id },
                }).then(function (scheduler) {
                    $scope.schedulerdatas = scheduler.data.data;
                    $scope.totaljobs = $scope.schedulerdatas.length;

                    var item = $scope.schedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Yesterday") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);

                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Today") {
                var today = new Date();
                var end = new Date();
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
            else if (range == "Tomorrow") {
                var today = new Date();
                var end = new Date();
                today.setDate(today.getDate() + 1);
                end.setDate(today.getDate() + 1);
                $scope.uFrom = new Date(today);
                $scope.uTo = new Date(end);
                $scope.uFrom.setHours(0, 0, 0, 0);
                $scope.uTo.setHours(23, 59, 59, 999);
                var response = $http({
                    url: $rootScope.WebURL + "/scheduler/datefilter",
                    method: "POST",
                    data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: $rootScope.Client_Id },
                });
                response.then(function (GList) {
                    $scope.Uniqueschedulerdatas = GList.data.data;

                    $scope.totaljobs = $scope.Uniqueschedulerdatas.length;
                    var item = $scope.Uniqueschedulerdatas.filter(function (item) {
                        return item.Status === "Completed";
                    });
                    $scope.completedjobs = item.length;
                });

            }
        }


        RefreshAssetRegister();
        RefreshAssetDisposal();
        RefreshPurchaseinvoice();
        RefreshPaysupplier();
        RefreshSalesInvoice();
        RefreshCollectPayment();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                $scope.totalassets = $scope.AssetRegisterdatas.length;
            });


        }
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;

                $scope.totaldiposed = $scope.AssetDisposaldatas.length;
            });
        }

        function RefreshPurchaseinvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/purchaseinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (purchaseinvoicedata) {
                debugger
                $scope.Purchaseinvoicedatas = purchaseinvoicedata.data.data;

                $scope.totalpayables = $scope.Purchaseinvoicedatas.length;
            });
        }

        function RefreshPaysupplier() {

            var response = $http({
                url: $rootScope.WebURL + "/paysupplier",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (paysupplierdata) {
                $scope.Paysupplierdatas = paysupplierdata.data.data;

                $scope.totalpaid = $scope.Paysupplierdatas.length;
            });

        }

        function RefreshSalesInvoice() {
            var response = $http({
                url: $rootScope.WebURL + "/salesinvoice",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (salesinvoicedata) {
                debugger
                $scope.Salesinvoicedatas = salesinvoicedata.data.data;
                $scope.totalreceivables = $scope.Salesinvoicedatas.length;
            });
        }

        function RefreshCollectPayment() {

            var response = $http({
                url: $rootScope.WebURL + "/collectpayment",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (CollectPaymentdata) {
                $scope.CollectPaymentdatas = CollectPaymentdata.data.data;

                $scope.totalreceived = $scope.CollectPaymentdatas.length;
            });
        }


        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };
        // Now widget
        vm.nowWidget = {
            now: {
                second: '',
                minute: '',
                hour: '',
                day: '',
                month: '',
                year: ''
            },
            ticker: function () {
                var now = moment();
                vm.nowWidget.now = {
                    second: now.format('ss'),
                    minute: now.format('mm'),
                    hour: now.format('HH'),
                    day: now.format('D'),
                    weekDay: now.format('dddd'),
                    month: now.format('MMMM'),
                    year: now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        //vm.selectedProject = vm.projects[0];




        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function () {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.accounts.customer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.accounts_customer', {
            url      : '/AcCustomers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/customer/customer.html',
                    controller: 'ACcustomerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/crm/customer');
    }

})();
(function () {
  "use strict";

  angular
    .module("app.accounts.customer")
    .controller("ACcustomerController", ACcustomerController)
    .filter("groupBy", function () {
      return _.memoize(function (items, field) {
        return _.groupBy(items, field);
      });
    })
    .directive("chooseFile", function () {
      return {
        link: function (scope, elem, attrs, transcludeFn) {
          var button = angular.element(
            elem[0].querySelector("button#uploadButton")
          );
          var Clearbutton = angular.element(
            elem[0].querySelector("button#clearButton")
          );
          var input = angular.element(elem[0].querySelector("input#fileInput"));
          button.bind("click", function () {
            input[0].click();
          });
          Clearbutton.bind("click", function () {
            var input = angular
              .element(elem[0].querySelector("input#fileInput"))
              .val("");
            scope.fileName = "";
          });
          input.bind("change", function (e) {
            scope.$apply(function () {
              var files = e.target.files;
              if (files[0]) {
                scope.fileName = files[0].name;
                scope.UploadButtonName = "Change";
                scope.UploadButton = true;
                scope.ClearButton = true;
                var reader = new FileReader();
                reader.onload = function (e) {
                  $("#imagePreview")
                    .attr("src", e.target.result)
                    .width(200)
                    .height(70);
                };
                scope.FilePath = null;
                reader.readAsDataURL(files[0]);
              } else {
                $("#imagePreview").attr("src", null);
                scope.fileName = null;
                scope.UploadButtonName = "Upload Quotation";
                scope.ClearButton = false;
              }
            });
          });
        }
      };
    })
    .filter("htmlToPlaintext", function () {
      return function (text) {
        if (text) return text.replace(/<[^>]+>/gm, "");
        else return "";
      };
    });

  function ACcustomerController(
    $mdDateLocale,
    $scope,
    $rootScope,
    $mdConstant,
    $interval,
    $state,
    $mdToast,
    $mdSidenav,
    $location,
    $mdDialog,
    $document,
    $http,
    $log,
    $filter,
    Upload,
    NgMap,
    DataSyncService
  ) {
    document.getElementsByTagName("title")[0].text = "Accounts-Customers";
    var chkAceses = localStorage.getItem("pages");
    if (chkAceses.split(",").includes("AcCustomer")) {
      // do nothing
    } else {
      $location.path("NoAccess");
    }

    $scope.ShowCheckBox = false;
    var chkAllowCustomerExport = localStorage.getItem("AllowExport");
    var getRoleaccess = localStorage.getItem("Roles");
    var IsAdmin = JSON.parse(localStorage.getItem("IsAdmin"));
    var EmpID = localStorage.getItem("EmployeeID");
    $scope.Emp_Id = localStorage.getItem("EmpId");
    var Emploee = "";
    var vm = this;
    $scope.ViewAllCustomer = false;
    $scope.IsAdmin = IsAdmin;
    $scope.Roleaccess = getRoleaccess;
    $scope.AllCustomersview = AllCustomersview;
    // $scope.Customerdatas = [];
    $scope.CustomerSelectedIds = [];
    $scope.Cdiv = false;
    $scope.CAll = false;
    $scope.CSelec = { value: false };
    $scope.CMSelec = { value: false };

    NgMap.getMap().then(function (map) {
      console.log(map.getCenter());
      console.log("markers", map.markers);
      console.log("shapes", map.shapes);
    });

    $scope.uFrom = new Date();
    $scope.uTo = new Date();
    $scope.uFrom.setHours(0, 0, 0, 0);
    $scope.uTo.setHours(23, 59, 59, 999);

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getforCustomer",
      data: { Supervisor: EmpID, Client_Id: $rootScope.Client_Id }
    }).then(function (List) {
      Emploee = List.data.data.map(function (o) {
        return o.UserID;
      });
      Emploee.push($rootScope.createdby);
    });

    $scope.Customerdatas = [];
    var dataGrid;

    vm.dataGridOptions = {
      onInitialized: function (e) {
        dataGrid = e.component;
        getAllCustomers();
      },

      dataSource: $scope.Customerdatas,
      keyExpr: "id",
      showColumnLines: true,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      headerFilter: {
        visible: true,
        allowSearch: true
      },
      hoverStateEnabled: true,
      columnMinWidth: 50,
      columnsAutoWidth: true,
      allowColumnResizing: true,
      columnResizingMode: "widget",
      filterRow: {
        visible: true
      },
      export: {
        enabled: JSON.parse($rootScope.AllowExport),
        fileName: "Customer Details",
        allowExportSelectedData: false
      },
      paging: {
        pageSize: 10
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 25, 50, 100],
        showInfo: true
      },
      remoteOperations: false,
      searchPanel: {
        visible: true,
        highlightCaseSensitive: true,
        width: 300
      },
      allowColumnReordering: true,
      columnChooser: {
        enabled: false
      },
      wordWrapEnabled: false,
      noDataText: "No Customer to display...",
      loadPanel: {
        enabled: true,
        height: 150,
        width: 400,
        text: "Please wait data is loading..."
      },
      columns: [
        // {
        //   caption: "#",
        //   width: "50",
        //   cellTemplate: function (cellElement, cellInfo) {
        //     cellElement.text(
        //       cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
        //         cellInfo.row.rowIndex +
        //         1
        //     );
        //   }
        // },
        {
          caption: "Reference #",
          dataField: "CustomerReference",
          width: 110,
          sortOrder: "desc",
          cellTemplate: function (container, options) {
            $(
              "<p style='color:blue;cursor: pointer;'>" +
              options.data.CustomerReference +
              "</p>"
            ).appendTo(container);
            if (options.data.id == $scope.LastModified) {
              $(
                "<div style='display:-webkit-inline-box;padding:.2em.6em.3em;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em;background-color: #FF9800 !important;'>" +
                "Last Modified" +
                "</div><br/>"
              ).appendTo(container);
            }
          }
        },
        // {caption:"Customer Type",dataField:"CustomerType",visible:false},
        { caption: "Company Name", dataField: "CompanyName", width: 170 },
        { caption: "SalesPerson", dataField: "SalesPersonName" },
        { caption: "Segment", dataField: "MarketSection" },
        {
          caption: "Contact Person",
          dataField: "ContactPerson",
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              return rowData.Salutation + " " + rowData.ContactPerson;
            } else {
              if (rowData.AssignedUser != null) {
                var eeitem = rowData.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  return rowData.Salutation + " " + rowData.ContactPerson;
                } else return "";
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                return "";
              }
            }
          }
        },
        { caption: "Postal", dataField: "Postal", visible: false },
        {
          caption: "Contact Number",
          dataField: "Mobile",
          visible: true,
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              return rowData.Mobile;
            } else {
              if (rowData.AssignedUser != null) {
                return rowData.Mobile;
              } else return "";
            }
            // else if(rowData.AssignedUser === null){

            // }
            // else{
            //     return "";
            // }
            // }
          }
        },
        {
          caption: "Email",
          dataField: "Email",
          width: 170,
          cellTemplate: function (e, op) {
            if (IsAdmin == true) {
              if (
                op.data.Email != "" &&
                op.data.Email != null &&
                op.data.Email != undefined
              )
                $(
                  '<a href="mailto:' +
                  op.data.Email +
                  '">' +
                  op.data.Email.replace(",", " , ") +
                  "</a>"
                ).appendTo(e);
            } else {
              if (op.data.AssignedUser != null) {
                var eeitem = op.data.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  if (
                    op.data.Email != "" &&
                    op.data.Email != null &&
                    op.data.Email != undefined
                  )
                    $(
                      '<a href="mailto:' +
                      op.data.Email +
                      '">' +
                      op.data.Email.replace(",", " , ") +
                      "</a>"
                    ).appendTo(e);
                } else $('<a href="mailto:">' + +"</a>").appendTo(e);
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                $('<a href="mailto:">' + +"</a>").appendTo(e);
              }
            }
          }
        },
        { caption: "Country", dataField: "Country", visible: false },
        { caption: "Building Name", dataField: "BuildingName", visible: false },
        {
          caption: "Work Orders",
          dataField: "bEmail",
          alignment: "center",
          visible: false
        },
        { caption: "Address", dataField: "StreetName" },
        {
          dataField: "ConEndDate",
          caption: "Current Contract End Date",
          dataType: "date",
          format: "dd/MM/yyyy",
          // calculateCellValue: function (rowData) {
          //   if (IsAdmin == true) {
          //     if (
          //       rowData.ConEndDate != null &&
          //       rowData.ConEndDate != undefined &&
          //       rowData.ConEndDate != ""
          //     )
          //       return new Date(rowData.ConEndDate);
          //     else return null;
          //   } else {
          //     if (rowData.AssignedUser != null) {
          //       var eeitem = rowData.AssignedUser.split(",");
          //       if (_.intersection(eeitem, Emploee).length > 0) {
          //         if (
          //           rowData.ConEndDate != null &&
          //           rowData.ConEndDate != undefined &&
          //           rowData.ConEndDate != ""
          //         )
          //           return new Date(rowData.ConEndDate);
          //         else return null;
          //       } else return null;
          //     }
          //     // else if(rowData.AssignedUser === null){

          //     // }
          //     else {
          //       return null;
          //     }
          //   }
          // }
        },
        {
          caption: "Tags",
          alignment: "center",
          dataField: "Tag",
          cellTemplate: function (container, options) {
            if (options.data.Tag === "Customer") {
              $(
                "<div class='label ng-binding ng-scope md-green-500-bg'>&nbsp;&nbsp;&nbsp;Customer &nbsp;&nbsp;&nbsp;</div>"
              ).appendTo(container);
            }
            if (options.data.Tag === "Past Leads") {
              return angular
                .element(
                  "<div class='label ng-binding ng-scope md-yellow-500-bg'>&nbsp;&nbsp;&nbsp;Past Leads&nbsp;&nbsp;&nbsp;</div>"
                )
                .appendTo(container);
            }
            if (options.data.Tag === "Prospect") {
              return $(
                "<div class='label ng-binding ng-scope md-blue-500-bg'>&nbsp;&nbsp;&nbsp;Prospect &nbsp;&nbsp;&nbsp;</div>"
              ).appendTo(container);
            }
            if (options.data.Tag === "Leads") {
              return $(
                "<div class='label ng-binding ng-scope md-cyan-500-bg'>&nbsp;&nbsp;&nbsp;&nbsp;Leads &nbsp;&nbsp;&nbsp;&nbsp;</div>"
              ).appendTo(container);
            }
            if (options.data.Tag === "Past Customer") {
              $(
                "<div class='label ng-binding ng-scope md-violet-500-bg'>Past Customer</div>"
              ).appendTo(container);
            }
          }
        },
        {
          caption: "Assigned Users",
          visible: true,
          dataField: "AssignedUser",
          alignment: "center",
          cellTemplate: function (container, options) {
            try {
              if (options.data.AssignedUser != null) {
                var Str = [];
                Str = options.data.AssignedUser.split(",");
                var Sdata = [];
                _.each(Str, function (item) {
                  item = item.charAt(0).toUpperCase() + item.slice(1);
                  Sdata.push(item);
                });
                Str = Sdata.map(function (obj) {
                  return obj;
                }).join(",");
                $("<p style='color:black;'>" + Str + "</p>").appendTo(
                  container
                );
              } else {
                $(
                  "<p style='color:blue;cursor: pointer;'>UnAssigned</p>"
                ).appendTo(container);
              }
            } catch (error) { }
          }
        },
        {
          caption: "Followup Date",
          dataField: "ProspectFollowupDate",
          dataType: "date",
          format: "dd/MM/yyyy",
          calculateCellValue: function (rowData) {
            if (IsAdmin == true) {
              if (rowData.ProspectFollowupDate != null)
                return new Date(rowData.ProspectFollowupDate);
              else return null;
            } else {
              if (rowData.AssignedUser != null) {
                var eeitem = rowData.AssignedUser.split(",");
                if (_.intersection(eeitem, Emploee).length > 0) {
                  if (rowData.ProspectFollowupDate != null)
                    return new Date(rowData.ProspectFollowupDate);
                  else return null;
                } else return null;
              }
              // else if(rowData.AssignedUser === null){

              // }
              else {
                return null;
              }
            }
          }
        }
      ],
      onSelectionChanged: function (selectedItems) {
        var data = selectedItems.selectedRowsData;

        if (data.length > 0) {
          $scope.v = $.map(data, function (value) {
            return value.CustomerReference;
          });
          $scope.CustomerSelectedIds = $.map(data, function (value) {
            return value.id;
          });
          $scope.Cdiv = true;
          selectedItems.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          selectedItems.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.v = [];
          $scope.Cdiv = false;
          selectedItems.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onCellClick: function (data) {
        try {
          var eeitem = data.data.AssignedUser.split(",");
          eeitem.push(data.data.SalesPersonName.toLowerCase());
        } catch (error) {
          var eeitem = null;
        }

        if (
          data.column.caption == "Reference #" &&
          (_.intersection(eeitem, Emploee).length > 0
            ? true
            : false || IsAdmin == true)
        ) {
          // if (data.column.caption == "Reference #" ) {
          var index = dataGrid.getRowIndexByKey(data.data.id);
          $scope.Customerinfo(data.data.id, index);
          $scope.AllIfo(data.data.id);
        }
        if (
          data.column.caption == "Assigned Users" &&
          data.data.AssignedUser == null
        ) {
          $scope.AcceptanceforUpdateAssignedUser(event, data.data.id);
        }
      },
      bindingOptions: {
        dataSource: "Customerdatas"
      }
    };

    $scope.Datefilter = function () {
      $scope.uFrom.setHours(0, 0, 0, 0);
      $scope.uTo.setHours(23, 59, 59, 999);
      var response = $http({
        url: $rootScope.WebURL + "/customer/datefilter",
        method: "POST",
        data: {
          Start_Date: $scope.uFrom,
          End_Date: $scope.uTo,
          Client_Id: $rootScope.Client_Id
        }
      });
      response.then(function (GList) {
        $scope.Customerdatas = GList.data.data;
      });
    };

    $scope.cExport = function () {
      if (chkAllowCustomerExport == true || chkAllowCustomerExport == "true") {
        alasql(
          'SELECT * INTO XLSX("CustomerDetails.xlsx",{headers:true}) FROM ?',
          [$scope.Customerdatas]
        );
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Export Option Not Enabled!")
            .position("top center")
        );
      }
    };
    $scope.items = [
      { a: 1, b: 10 },
      { a: 2, b: 20 },
      { a: 3, b: 30 }
    ];

    $scope.Customerform = false;
    $scope.Customergrid = true;
    $scope.Export = true;
    $scope.Add = true;
    $scope.Search = true;

    $scope.placeChanged = function () {
      $scope.vm.uPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.uPostal = vm.place.address_components[i].long_name;
          }
        }
      }
    };

    $scope.placeChanged1 = function () {
      $scope.vm.ubPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.ubPostal = parseInt(
              vm.place.address_components[i].long_name
            );
          }
        }
      }
    };

    $scope.placeChanged2 = function () {
      $scope.vm.usPostal = "";
      vm.place = this.getPlace();
      for (var i = 0; i < vm.place.address_components.length; i++) {
        for (var j = 0; j < vm.place.address_components[i].types.length; j++) {
          if (vm.place.address_components[i].types[j] == "postal_code") {
            $scope.vm.usPostal = parseInt(
              vm.place.address_components[i].long_name
            );
          }
        }
      }
    };

    $scope.sAdd = function () {
      ClearForm();
      $scope.Update = false;
      $scope.Customerform = true;
      $scope.Customergrid = false;
      $scope.Export = false;
      $scope.view = true;
      $scope.Add = false;
      $scope.Search = false;
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      var EmployeeID = localStorage.getItem("EmployeeID");
      try {
        var item = $scope.Employeedatas.filter(function (item) {
          return item.EmployeeID === EmployeeID;
        })[0];
        $scope.vm.SalesPerson = item.id;
      } catch (e) { }
      $scope.vm.uCustomerID = pass;
      $scope.CustomerServicedatas = [];
      $scope.CustomerBillingdatas = [];
      $scope.CustomerCommentdatas = [];
    };

    $scope.Showgrid = function () {
      $scope.Customergrid = true;
      $scope.Customerform = false;
      $scope.Export = true;
      $scope.Add = true;
      $scope.view = false;
      $scope.Search = true;
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.Customerinfo = function (CustomerId, Index) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/newgetbyid",
        data: {
          _id: CustomerId
        }
      }).then(function (d) {
        try {
          var item = d.data.data[0];
          $scope.SID = CustomerId;
          $scope.CustomerIndex = Index;
          $scope.Update = true;
          $scope.vm.uInvoiceEmail = [];
          $scope.vm.uInvoiceCC = [];
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          $scope.All = false;
          $scope.Selec = { value: false };
          $scope.MSelec = { value: false };
          $scope.vm.CustomerSince = new Date();
          $scope.vm.ProspectFollowDate = new Date();
          $scope.vm.uFrom = new Date();
          $scope.vm.uTo = new Date(
            new Date().setMonth(new Date().getMonth() + 1)
          );
          $scope.vm.uIFrom = new Date();
          $scope.vm.uITo = new Date(
            new Date().setMonth(new Date().getMonth() + 1)
          );
          $scope.vm.uwoFrom = new Date(
            new Date().setMonth(new Date().getMonth() - 1)
          );
          $scope.vm.uwoTo = new Date();
          $scope.vm.ucFrom = new Date(
            new Date().setMonth(new Date().getMonth() - 1)
          );
          $scope.vm.ucTo = new Date();
          $scope.vm.pvFrom = new Date(
            new Date().setDate(new Date().getDate() - 7)
          );
          $scope.vm.pvTo = new Date(
            new Date().setDate(new Date().getDate() - 1)
          );
          $scope.vm.upFrom = new Date(
            new Date().setDate(new Date().getDate() + 1)
          );
          $scope.vm.upTo = new Date(
            new Date().setDate(new Date().getDate() + 7)
          );

          $scope.vm.PaymentTerm = item.Unit;
          $scope.vm.EnquiryMode = item.EnquiryMode;
          $scope.vm.CreditTerm = item.CreditTerm;
          $scope.vm.uCustomerID = item.CustomerID;
          $scope.RequestID = item.CustomerID;
          $scope.vm.CustomerReference = item.CustomerReference;
          $scope.vm.uSalutation = item.Salutation;
          $scope.vm.uFirstName = item.FirstName;
          $scope.vm.uLastName = item.LastName;
          $scope.vm.uCompanyName = item.CompanyName;
          $scope.vm.uNote = item.Note;
          $scope.vm.uAddress = item.Address;
          $scope.vm.uAddress1 = item.Address1;
          $scope.vm.uPostal = item.Postal;
          $scope.vm.uCountry = item.Country;
          $scope.vm.uContactPerson = item.ContactPerson;
          $scope.vm.SalesPerson = item.SalesPerson_id;
          $scope.vm.uPhone = item.Phone;
          $scope.vm.uMobile = "";
          $scope.vm.uEmail = "";
          if (
            item.Mobile != null &&
            item.Mobile != "" &&
            item.Mobile != undefined
          )
            $scope.vm.uMobile = item.Mobile;
          if (item.Email != null && item.Email != "" && item.Email != undefined)
            $scope.vm.uEmail = item.Email;
          // if (item.CustomerSince != "" && item.CustomerSince != null && item.CustomerSince != undefined) {
          //     $scope.vm.CustomerSince = new Date(item.CustomerSince);
          // } else { }
          if (
            item.ConEndDate != "" &&
            item.ConEndDate != null &&
            item.ConEndDate != undefined
          ) {
            $scope.vm.ConEndDate = new Date(item.ConEndDate);
          } else {
            $scope.vm.ConEndDate = null;
          }
          if (
            item.ProspectFollowupDate != "" &&
            item.ProspectFollowupDate != null &&
            item.ProspectFollowupDate != undefined
          ) {
            $scope.vm.ProspectFollowDate = new Date(item.ProspectFollowupDate);
          } else {
            $scope.vm.ProspectFollowDate = null;
          }
          $scope.vm.StreetName = item.StreetName;
          $scope.vm.BuildingName = item.BuildingName;
          $scope.vm.CreditTerm = item.CreditTerm;
          if (item.State == "null" || item.State == undefined) {
            $scope.vm.State = "Active";
          } else {
            $scope.vm.State = item.State;
          }
          $scope.vm.Category = item.Category;
          $scope.vm.usInvoiceEmail = item.InvoiceEmail;
          if (
            $scope.vm.usInvoiceEmail != null &&
            $scope.vm.usInvoiceEmail != "" &&
            $scope.vm.usInvoiceEmail != undefined
          ) {
            $scope.vm.uInvoiceEmail = $scope.vm.usInvoiceEmail.split(",");
            $scope.vm.usInvoiceEmail = null;
          }

          $scope.vm.usInvoiceCC = item.InvoiceCC;
          if (
            $scope.vm.usInvoiceCC != null &&
            $scope.vm.usInvoiceCC != "" &&
            $scope.vm.usInvoiceCC != undefined
          ) {
            $scope.vm.uInvoiceCC = $scope.vm.usInvoiceCC.split(",");
            $scope.vm.usInvoiceCC = null;
          }
          if (
            item.MarketSection != null &&
            item.MarketSection != "" &&
            item.MarketSection != undefined
          ) {
            var a = item.MarketSection.split(",");
            var array = [];
            _.each(a, function (ite) {
              array.push({ SegmentName: ite });
            });
            $scope.vm.MarketSection = array;
          }
          Refreshcomment($scope.SID);
          $scope.Contractdetails = item.Contractdetails[0];
          $scope.DateC();
          $scope.Leaddetails = item.Leaddetails;
          $scope.Invoiceddetails = item.Invoicedetails[0];
          $scope.DateIF();
          $scope.SalessOrderdetails = item.SalesOrderdetails[0];
          $scope.DateWO();
          $scope.Schedulerdetails = item.Schedulerdetails[0];
        } catch (e) { }

        $scope.CustomerBillingdatas = [];
        $scope.CustomerServicedatas = [];
        getUploadedDocuments($scope.SID);
        CustomerBillingdatadetails();
        CustomerServicedatadetails();
        // $scope.GetSchedulerDetails($scope.SID,$scope.uFrom)
        // RefreshCommentGrid();

        $scope.Update = true;
        $scope.Customerform = true;
        $scope.Customergrid = false;
        $scope.Servicegrid = true;
        $scope.Export = false;
        $scope.view = true;
        $scope.Add = false;
        $scope.Search = false;
      });
    };

    $scope.sSubmit = function () {
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueInvoiceEmailValid = true;
      var falseInvoiceEmailValid = true;
      var trueInvoiceCCValid = true;
      var falseInvoiceCCValid = true;
      angular.forEach($scope.vm.uInvoiceEmail, function (ite) {
        if (reg.test(ite)) {
          trueInvoiceEmailValid = true;
        } else {
          falseInvoiceEmailValid = false;
        }
      });
      angular.forEach($scope.vm.uInvoiceCC, function (ite) {
        if (reg.test(ite)) {
          trueInvoiceCCValid = true;
        } else {
          falseInvoiceCCValid = false;
        }
      });
      if (trueInvoiceEmailValid != false && trueInvoiceCCValid != false) {
        var InvoiceEmail = $scope.vm.uInvoiceEmail;
        if (
          InvoiceEmail != null &&
          InvoiceEmail != "" &&
          InvoiceEmail != undefined
        ) {
          $scope.vm.usInvoiceEmail = InvoiceEmail.map(function (obj) {
            return obj;
          }).join(",");
        } else {
          $scope.vm.usInvoiceEmail = "";
        }
        var InvoiceCC = $scope.vm.uInvoiceCC;
        if (InvoiceCC != null && InvoiceCC != "" && InvoiceCC != undefined) {
          $scope.vm.usInvoiceCC = InvoiceCC.map(function (obj) {
            return obj;
          }).join(",");
        } else {
          $scope.vm.usInvoiceCC = "";
        }

        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.uContactPerson = $scope.vm.uFirstName;

        if (
          $scope.vm.BuildingName != null &&
          $scope.vm.BuildingName != "" &&
          $scope.vm.BuildingName != undefined
        ) {
          $scope.vm.uAddress =
            $scope.vm.BLK +
            "," +
            "," +
            $scope.vm.StreetName +
            "," +
            $scope.vm.BuildingName;
        } else {
          $scope.vm.uAddress = $scope.vm.BLK + "," + "," + $scope.vm.StreetName;
        }
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != "" &&
          $scope.vm.uMobile != undefined
        )
          $scope.vm.uMobile = $scope.vm.uMobile
            .map(function (obj) {
              return obj;
            })
            .join(",");
        if (
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.uEmail = $scope.vm.uEmail
            .map(function (obj) {
              return obj;
            })
            .join(",");
        if (
          $scope.vm.MarketSection != null &&
          $scope.vm.MarketSection != "" &&
          $scope.vm.MarketSection != undefined
        ) {
          $scope.vm.MarketSection = $scope.vm.MarketSection.map(function (obj) {
            return obj.SegmentName;
          }).join(",");
        }
        if ($scope.vm.PaymentTerm != "Credit") $scope.vm.CreditTerm = 0;

        if ($scope.Update == true) {
          $scope.CustomerIndex = $scope.CustomerIndex;
          var response = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/customer/update",
            data: {
              _id: $scope.SID,
              CustomerID: $scope.vm.uCustomerID,
              CustomerReference: $scope.vm.CustomerReference,
              SalesPerson_id: $scope.vm.SalesPerson,
              Salutation: $scope.vm.uSalutation,
              FirstName: $scope.vm.uFirstName,
              LastName: $scope.vm.uLastName,
              CompanyName: $scope.vm.uCompanyName,
              Note: $scope.vm.uNote,
              Address: $scope.vm.uAddress,
              Address1: $scope.vm.uAddress1,
              Postal: $scope.vm.uPostal,
              Country: $scope.vm.uCountry,
              ContactPerson: $scope.vm.uContactPerson,
              Phone: $scope.vm.uPhone,
              Mobile: $scope.vm.uMobile,
              Email: $scope.vm.uEmail,
              // CustomerSince: $scope.vm.CustomerSince,
              ProspectFollowupDate: $scope.vm.ProspectFollowDate,
              StreetName: $scope.vm.StreetName,
              BuildingName: $scope.vm.BuildingName,
              CreditTerm: $scope.vm.CreditTerm,
              MarketSection: $scope.vm.MarketSection,
              ConEndDate: $scope.vm.ConEndDate,
              State: $scope.vm.State,
              Unit: $scope.vm.PaymentTerm,
              EnquiryMode: $scope.vm.EnquiryMode,
              Category: $scope.vm.Category,
              UpdatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              InvoiceEmail: $scope.vm.usInvoiceEmail,
              InvoiceCC: $scope.vm.usInvoiceCC
            }
          });
          response.then(
            function (GList) {
              if (GList.data.message == "Existing CustomerName") {
                $scope.error1 = true;
                $scope.Customergrid = false;
                $scope.Customerform = true;
                $scope.Export = false;
                $scope.Add = false;
                $scope.Search = false;
                $scope.view = true;
              } else {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Successfully Updated!")
                    .position("top center")
                );
                $scope.Customergrid = true;
                $scope.error1 = false;
                $scope.Customerform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.Search = true;
                $scope.view = false;
                // AllInfo();
                $scope.AllCustomersview($scope.ViewAllCustomer);
                $scope.ViewAllCustomer = false;
                // $scope.Datefilter();
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customer/add",
            data: {
              CustomerID: $scope.vm.uCustomerID,
              CustomerReference: $scope.vm.CustomerReference,
              SalesPerson_id: $scope.vm.SalesPerson,
              Salutation: $scope.vm.uSalutation,
              FirstName: $scope.vm.uFirstName,
              LastName: $scope.vm.uLastName,
              CompanyName: $scope.vm.uCompanyName,
              Note: $scope.vm.uNote,
              Address: $scope.vm.uAddress,
              Address1: $scope.vm.uAddress1,
              Postal: $scope.vm.uPostal,
              Country: $scope.vm.uCountry,
              ContactPerson: $scope.vm.uContactPerson,
              Phone: $scope.vm.uPhone,
              Mobile: $scope.vm.uMobile,
              Email: $scope.vm.uEmail,
              Unit: $scope.vm.PaymentTerm,
              EnquiryMode: $scope.vm.EnquiryMode,
              Creditterm: $scope.vm.CreditTerm,
              // CustomerSince: $scope.vm.CustomerSince,
              ProspectFollowupDate: $scope.vm.ProspectFollowDate,
              StreetName: $scope.vm.StreetName,
              BuildingName: $scope.vm.BuildingName,
              CreditTerm: $scope.vm.CreditTerm,
              MarketSection: $scope.vm.MarketSection,
              ConEndDate: $scope.vm.ConEndDate,
              Category: $scope.vm.Category,
              CreatedBy: $rootScope.createdby,
              IsActive: "true",
              Client_Id: $rootScope.Client_Id,
              InvoiceEmail: $scope.vm.usInvoiceEmail,
              InvoiceCC: $scope.vm.usInvoiceCC
            }
          });
          response.then(
            function (GList) {
              if (GList.data.message == "Existing CompanyName") {
                $scope.error1 = true;
                $scope.Customergrid = false;
                $scope.Customerform = true;
                $scope.Export = false;
                $scope.Add = false;
                $scope.Search = false;
                $scope.view = true;
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Company Name Already Exist!")
                    .position("top center")
                );
              } else {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Successfully Added!")
                    .position("top center")
                );
                // AllInfo();
                $scope.Customergrid = true;
                $scope.Customerform = false;
                $scope.Export = true;
                $scope.Add = true;
                $scope.view = false;
                $scope.Search = true;
                $scope.error1 = false;

                var response1 = $http({
                  method: "PUT",
                  url:

                    $rootScope.WebURL +
                    "/customer/updateAssignedUser",
                  data: {
                    _id: GList.data.data.id,
                    AssignedUser: $rootScope.createdby,
                    UpdatedBy: $rootScope.createdby
                  }
                });
                response1.then(function (Lis) { });
              }
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        }
      } else if (
        trueInvoiceEmailValid == false &&
        trueInvoiceCCValid != false
      ) {
        // $mdToast.show(
        //   $mdToast
        //     .simple()
        //     .textContent("Enter valid Email !")
        //     .position("top center")
        // );
      } else if (
        trueInvoiceEmailValid != false &&
        trueInvoiceCCValid == false
      ) {
        // $mdToast.show(
        //   $mdToast
        //     .simple()
        //     .textContent("Enter valid CC !")
        //     .position("top center")
        // );
      } else if (
        trueInvoiceEmailValid == false &&
        trueInvoiceCCValid == false
      ) {
        // $mdToast.show(
        //   $mdToast
        //     .simple()
        //     .textContent("Enter valid Email and CC !")
        //     .position("top center")
        // );
      }
    };

    $scope.AddSegment = function (e) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/segment.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      $scope.errorms = false;
    };

    $scope.DeleteComment = function (data) {
      if (data.CreatedBy === $rootScope.createdby) {
        $scope.delComId = data._id;
        var result = DevExpress.ui.dialog.confirm(
          "Are you sure, you want to delete the comment?",
          "Confirm!"
        );
        result.done(function (dialogResult) {
          if (dialogResult === true) {
            $http({
              url: $rootScope.WebURL + "/schedulercomment/delete",
              method: "POST",
              data: { _id: $scope.delComId }
            }).then(function (attachmentdata) {
              var response = $http({
                url:

                  $rootScope.WebURL +
                  "/schedulercomment/getByCustomer",
                method: "POST",
                data: { RequestID: $scope.SID }
              });
              response.then(function (Commentdata) {
                $scope.CustomerCommentdatas = Commentdata.data.data;
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent("Comment deleted Successfully!")
                    .position("top center")
                );
              });
            });
          }
        });
      } else {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("You dont have permission to delete")
            .position("top center")
        );
      }
    };

    $scope.SegmentSubmit = function () {
      var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP1234567890";
      var pass = "";
      for (var x = 0; x < 6; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
      }
      var CustomerID = pass;
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment/add",
        data: {
          SegmentName: $scope.vm.SegmentName,
          Description: $scope.vm.Description,
          Client_Id: $rootScope.Client_Id,
          CreatedBy: $rootScope.createdby,
          IsActive: true
        }
      });
      response.then(
        function (GList) {
          if (GList.data.message == "Existing SegmentName") {
            $scope.errorms = true;
          } else {
            $scope.vm.SegmentName = null;
            $scope.vm.Description = null;
            $scope.errorms = false;
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Successfully Added!")
                .position("top center")
            );
            RefreshMsgrid();
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Segmentdelete = function (deleteID) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment/delete",
        data: {
          _id: deleteID
        }
      });
      response.then(
        function (GList) {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Deleted!")
              .position("top center")
          );
          RefreshMsgrid();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Servicepopup = function (e, uCustomerID, PopupType) {
      $scope.vm.uCustomerID = uCustomerID;
      if (PopupType == "Billing") {
        $scope.vm.sty = 45;
        $scope.Billing = true;
        $scope.Service = false;
        $scope.PopupType = "Billing";
        $scope.vm.ubBLK = null;
        $scope.vm.ubUnit = null;
        $scope.vm.ubPostal = null;
        $scope.vm.ubCountry = null;
        $scope.vm.ubContactPerson = null;
        $scope.vm.ubBuildingName = null;
        $scope.vm.ubStreetName = null;
        $scope.vm.ubMobile = null;
        $scope.vm.ubEmail = null;
      }
      if (PopupType == "Service") {
        $scope.vm.sty = 65;
        $scope.Service = true;
        $scope.Billing = false;
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
        $scope.PopupType = "Service";
      }
      $scope.vm.usBLK = null;
      $scope.vm.usUnit = null;
      $scope.vm.usPostal = null;
      $scope.vm.usCountry = "Singapore";
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.usContactPerson = null;
      $scope.vm.usName = null;
      $scope.vm.usBuildingName = null;
      $scope.vm.usMobile = [];
      $scope.vm.usStreetName = null;
      $scope.vm.usEmail = null;
      $scope.vm.usBuildingType = null;
      $scope.QUpdate = false;
      $scope.BAUpdate = false;
      $scope.checkboxModel = { value: false };
      $scope.Servicecopy = { value: false };
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.copymain = function ($scope) {
      if ($scope.Servicecopy.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.usBLK = "";
        $scope.vm.usName = $scope.vm.uCompanyName;
        $scope.vm.usContactPerson = $scope.vm.uFirstName;
        $scope.vm.usUnit = $scope.vm.StreetName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.usPostal = $scope.vm.uPostal;
        }
        $scope.vm.usCountry = $scope.vm.uCountry;
        $scope.vm.usBuildingName = $scope.vm.BuildingName;
        $scope.vm.usStreetName = $scope.vm.StreetName;
        $scope.vm.usMobile = [];
        if (
          $scope.vm.uMobile != null &&
          $scope.vm.uMobile != undefined &&
          $scope.vm.uMobile != ""
        )
          if (!Array.isArray($scope.vm.uMobile))
            $scope.vm.usMobile = $scope.vm.uMobile
              .split(",")
              .slice(2)
              .join(",");
          else $scope.vm.usMobile = $scope.vm.uMobile;
        if (
          $scope.vm.uEmail != "" &&
          $scope.vm.uEmail != null &&
          $scope.vm.uEmail != undefined
        )
          $scope.vm.ZoneCC = $scope.vm.uEmail;

        $scope.vm.ZoneEmail = [];

        if (
          $scope.vm.usContactPerson == "" ||
          $scope.vm.usContactPerson == null ||
          $scope.vm.usContactPerson == undefined
        ) {
          try {
            var item = $scope.CustomerServicedatas.filter(function (item) {
              return item.CustomerID === $scope.RequestID;
            })[0];
            $scope.vm.usName = item.sName;
            $scope.vm.usContactPerson = item.sContactPerson;
            $scope.vm.usBLK = item.sBLK;
            $scope.vm.usUnit = item.sUnit;
            $scope.vm.usPostal = item.sPostal;
            $scope.vm.usCountry = item.sCountry;
            $scope.vm.usBuildingName = item.sBuildingName;
            $scope.vm.usStreetName = item.sStreetName;
            $scope.vm.usMobile = [];
            if (
              item.sMobile != null &&
              item.sMobile != undefined &&
              item.sMobile != ""
            )
              $scope.vm.usMobile = item.sMobile.split(",");
            if (
              item.sEmail != null &&
              item.sEmail != "" &&
              item.sEmail != undefined
            ) {
              $scope.vm.ZoneCC = item.sEmail.split(",");
            }
            if (item.sCC != null && item.sCC != "" && item.sCC != undefined) {
              $scope.vm.ZoneEmail = item.sCC.split(",");
            }
          } catch (e) { }
        }
      }
      if ($scope.Servicecopy.value == false) {
        $scope.vm.usName = "";
        $scope.vm.usContactPerson = "";
        $scope.vm.usBLK = "";
        $scope.vm.usUnit = "";
        $scope.vm.usPostal = "";
        $scope.vm.usCountry = "";
        $scope.vm.usBuildingName = "";
        $scope.vm.usStreetName = "";
        $scope.vm.usMobile = [];
        $scope.vm.ZoneCC = [];
        $scope.vm.ZoneEmail = [];
      }
    };

    $scope.copybilling = function ($scope) {
      if ($scope.checkboxModel.value == true) {
        if (
          $scope.vm.uFirstName == null ||
          $scope.vm.uFirstName == "" ||
          $scope.vm.uFirstName == undefined
        ) {
          $scope.vm.uFirstName = $scope.vm.uCompanyName;
        }
        $scope.vm.ubContactPerson = $scope.vm.uFirstName;
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = $scope.vm.StreetName;
        $scope.vm.ubBuildingName = $scope.vm.BuildingName;
        if (
          $scope.vm.uPostal != null ||
          $scope.vm.uPostal != "" ||
          $scope.vm.uPostal != undefined
        ) {
          $scope.vm.ubPostal = $scope.vm.uPostal;
        }
        $scope.vm.ubCountry = $scope.vm.uCountry;
        $scope.vm.ubMobile = $scope.vm.uMobile.join(", ");
        $scope.vm.ubEmail = $scope.vm.uEmail;
        $scope.vm.ubStreetName = $scope.vm.StreetName;
        $scope.vm.ubWebsite = "";
      }
      if ($scope.checkboxModel.value == false) {
        $scope.vm.ubContactPerson = "";
        $scope.vm.ubBLK = "";
        $scope.vm.ubUnit = "";
        $scope.vm.ubBuildingName = "";
        $scope.vm.ubPostal = "";
        $scope.vm.ubCountry = "";
        $scope.vm.ubMobile = "";
        $scope.vm.ubEmail = "";
        $scope.vm.ubStreetName = "";
        $scope.vm.ubWebsite = "";
      }
    };

    $scope.Serviceadd = function (Index) {
      var reg = /^[_a-z0-9A-Z]+(\.[_a-z0-9A-Z]+)*@[a-z0-9-A-Z]+(\.[a-z0-9-A-Z]+)*(\.[a-zA-Z]{2,4})$/;
      var trueEmailValid = true;
      var falseEmailValid = true;
      var falseCCValid = true;
      angular.forEach($scope.vm.ZoneCC, function (ite) {
        if (reg.test(ite)) {
          trueEmailValid = true;
        } else {
          falseEmailValid = false;
        }
      });
      if ($scope.vm.ZoneEmail != null && $scope.vm.ZoneEmail != undefined) {
        angular.forEach($scope.vm.ZoneEmail, function (ite) {
          if (reg.test(ite)) {
            trueEmailValid = true;
          } else {
            falseCCValid = false;
          }
        });
      } else {
        var falseCCValid = true;
      }

      if (falseEmailValid != false) {
        if (falseCCValid != false) {
          var ZoneCC = $scope.vm.ZoneCC;
          if (ZoneCC != null && ZoneCC != "" && ZoneCC != undefined) {
            $scope.vm.usEmail = ZoneCC.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usEmail = "";
          }
          var ZoneEmail = $scope.vm.ZoneEmail;
          if (ZoneEmail != null && ZoneEmail != "" && ZoneEmail != undefined) {
            $scope.vm.usCC = ZoneEmail.map(function (obj) {
              return obj;
            }).join(",");
          } else {
            $scope.vm.usCC = "";
          }
        } else {
          // $mdToast.show(
          //   $mdToast
          //     .simple()
          //     .textContent("Enter valid CC !")
          //     .position("top center")
          // );
          // return;
        }
      } else {
        // $mdToast.show(
        //   $mdToast
        //     .simple()
        //     .textContent("Enter valid email !")
        //     .position("top center")
        // );
        // return;
      }
      if (
        $scope.vm.usMobile != null &&
        $scope.vm.usMobile != "" &&
        $scope.vm.usMobile != undefined
      ) {
        $scope.vm.usMobile = $scope.vm.usMobile
          .map(function (obj) {
            return obj;
          })
          .join(",");
      }
      if ($scope.QUpdate == true) {
        $scope.Index = $scope.Index;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            sBLK: $scope.vm.usBLK,
            sUnit: $scope.vm.usUnit,
            sPostal: $scope.vm.usPostal,
            sCountry: $scope.vm.usCountry,
            sName: $scope.vm.usName,
            sContactPerson: $scope.vm.usContactPerson,
            sBuildingType: $scope.vm.usBuildingType,
            sBuildingName: $scope.vm.usBuildingName,
            sMobile: $scope.vm.usMobile,
            sStreetName: $scope.vm.usStreetName,
            sEmail: $scope.vm.usEmail,
            sCC: $scope.vm.usCC,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerServicedatas[$scope.Index] = GList.data.data;
            CustomerServicedatadetails();
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else if ($scope.QUpdate == false) {
        var item = [];
        try {
          item = $scope.CustomerServicedatas.filter(function (item) {
            return (
              item.sBLK == $scope.vm.usBLK &&
              item.sUnit == $scope.vm.usUnit &&
              item.sStreetName == $scope.vm.usStreetName &&
              item.sCountry == $scope.vm.usCountry &&
              item.sMobile == $scope.vm.usMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/customerService/add",
            data: {
              Type: "Service",
              CustomerID: $scope.vm.uCustomerID,
              sBLK: $scope.vm.usBLK,
              sUnit: $scope.vm.usUnit,
              sPostal: $scope.vm.usPostal,
              sCountry: $scope.vm.usCountry,
              sName: $scope.vm.usName,
              sContactPerson: $scope.vm.usContactPerson,
              sBuildingType: $scope.vm.usBuildingType,
              sBuildingName: $scope.vm.usBuildingName,
              sMobile: $scope.vm.usMobile,
              sStreetName: $scope.vm.usStreetName,
              sEmail: $scope.vm.usEmail.toLowerCase(),
              sCC: $scope.vm.usCC,
              CreatedBy: $rootScope.createdby,
              IsActive: "true"
            }
          });
          response.then(
            function (GList) {
              $scope.RequestID = $scope.vm.uCustomerID;
              CustomerServicedatadetails();
              $scope.Servicegrid = true;
              $mdDialog.cancel();
            },
            function () {
              $mdToast.show(
                $mdToast
                  .simple()
                  .textContent(
                    "Something entered gone wrong,please try again !"
                  )
                  .position("top center")
              );
            }
          );
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Servicesupdate = function (e, QId, Index) {
      $scope.QUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.Index = Index;
      $scope.Service = true;
      $scope.Billing = false;
      $scope.PopupType = "Service";
      $scope.vm.sty = 65;
      try {
        var item = $scope.CustomerServicedatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.uCustomerID = item.CustomerID;
        $scope.vm.usBLK = item.sBLK;
        $scope.vm.usUnit = item.sUnit;
        $scope.vm.usPostal = item.sPostal;
        $scope.vm.usCountry = item.sCountry;
        $scope.vm.usName = item.sName;
        $scope.vm.usContactPerson = item.sContactPerson;
        $scope.vm.usBuildingType = item.sBuildingType;
        $scope.vm.usBuildingName = item.sBuildingName;
        $scope.vm.usMobile = [];
        if (
          item.sMobile != null &&
          item.sMobile != undefined &&
          item.sMobile != ""
        )
          $scope.vm.usMobile = item.sMobile.split(",");
        $scope.vm.usStreetName = item.sStreetName;
        $scope.vm.usEmail = item.sEmail;
        $scope.vm.usCC = item.sCC;
        if (
          $scope.vm.usEmail != null &&
          $scope.vm.usEmail != "" &&
          $scope.vm.usEmail != undefined
        ) {
          $scope.vm.ZoneCC = $scope.vm.usEmail.split(",");
          $scope.vm.usEmail = null;
        } else $scope.vm.ZoneCC = [];
        if (
          $scope.vm.usCC != null &&
          $scope.vm.usCC != "" &&
          $scope.vm.usCC != undefined
        ) {
          $scope.vm.ZoneEmail = $scope.vm.usCC.split(",");
          $scope.vm.usCC = null;
        } else $scope.vm.ZoneEmail = [];
      } catch (e) { }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.cspopup = function (e, deleteID, Index, Type) {
      $scope.vm.deleteID = deleteID;
      $scope.vm.Index = Index;
      $scope.vm.DeleteType = Type;
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/cspopup.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.Servicedelete = function (deleteID, Index) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customerService/delete",
        data: {
          _id: deleteID
        }
      });
      response.then(
        function (GList) {
          if ($scope.vm.DeleteType == "Service") {
            $scope.CustomerServicedatas.splice(Index, 1);
          } else {
            $scope.CustomerBillingdatas.splice(Index, 1);
          }
          //CustomerServicedatadetails();
          $scope.Servicegrid = true;
          $scope.Add = false;
          $scope.Search = false;
          $mdDialog.cancel();
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.Billingadd = function (Index) {
      if ($scope.BAUpdate == true) {
        $scope.BillingIndex = $scope.BillingIndex;
        var response = $http({
          method: "PUT",
          url: $rootScope.WebURL + "/customerService/update",
          data: {
            _id: $scope.QID,
            CustomerID: $scope.vm.uCustomerID,
            bBLK: $scope.vm.ubBLK,
            bUnit: $scope.vm.ubUnit,
            bPostal: $scope.vm.ubPostal,
            bCountry: $scope.vm.ubCountry,
            bContactPerson: $scope.vm.ubContactPerson,
            bBuildingName: $scope.vm.ubBuildingName,
            bStreetName: $scope.vm.ubStreetName,
            bMobile: $scope.vm.ubMobile,
            bEmail: $scope.vm.ubEmail,
            UpdatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            GList.data.data["_id"] = GList.data.data["id"];
            delete GList.data.data["id"];
            $scope.CustomerBillingdatas[$scope.BillingIndex] = GList.data.data;
            $scope.Add = false;
            $scope.Search = false;
            $mdDialog.cancel();
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var item = [];
        try {
          item = $scope.CustomerBillingdatas.filter(function (item) {
            return (
              item.bBLK == $scope.vm.ubBLK &&
              item.bUnit == $scope.vm.ubUnit &&
              item.bStreetName == $scope.vm.ubStreetName &&
              item.bCountry == $scope.vm.ubCountry &&
              item.bMobile == $scope.vm.ubMobile
            );
          });
        } catch (e) { }
        if (item.length == 0 || item.length == undefined) {
          if ($scope.BAUpdate == true) {
            $scope.BillingIndex = $scope.BillingIndex;
            var response = $http({
              method: "PUT",
              url: $rootScope.WebURL + "/customerService/update",
              data: {
                _id: $scope.QID,
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                UpdatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.CustomerBillingdatas[$scope.BillingIndex] =
                  GList.data.data;
                CustomerServicedatadetails();
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          } else {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/customerService/add",
              data: {
                Type: "Billing",
                CustomerID: $scope.vm.uCustomerID,
                bBLK: $scope.vm.ubBLK,
                bUnit: $scope.vm.ubUnit,
                bPostal: $scope.vm.ubPostal,
                bCountry: $scope.vm.ubCountry,
                bContactPerson: $scope.vm.ubContactPerson,
                bBuildingName: $scope.vm.ubBuildingName,
                bStreetName: $scope.vm.ubStreetName,
                bMobile: $scope.vm.ubMobile,
                bEmail: $scope.vm.ubEmail,
                CreatedBy: $rootScope.createdby,
                IsActive: "true"
              }
            });
            response.then(
              function (GList) {
                $scope.RequestID = $scope.vm.uCustomerID;
                CustomerBillingdatadetails();
                $scope.Servicegrid = true;
                $scope.Add = false;
                $scope.Search = false;
                $mdDialog.cancel();
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        } else {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Already Exist!")
              .position("top center")
          );
        }
      }
    };

    $scope.Billingupdate = function (e, QId, Index) {
      $scope.BAUpdate = true;
      $scope.QID = QId;
      $scope.vm.Index = Index;
      $scope.BillingIndex = Index;
      $scope.Billing = true;
      $scope.Service = false;
      $scope.vm.sty = 45;
      try {
        var item = $scope.CustomerBillingdatas.filter(function (item) {
          return item._id === QId;
        })[0];
        $scope.vm.ubBLK = item.bBLK;
        $scope.vm.ubUnit = item.bUnit;
        $scope.vm.ubPostal = item.bPostal;
        $scope.vm.ubCountry = item.bCountry;
        $scope.vm.ubContactPerson = item.bContactPerson;
        $scope.vm.ubBuildingName = item.bBuildingName;
        $scope.vm.ubStreetName = item.bStreetName;
        $scope.vm.ubMobile = item.bMobile;
        $scope.vm.ubEmail = item.bEmail;
      } catch (e) { }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Service.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.AD = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "A", End: "E", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.EH = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "E", End: "I", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.IL = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "I", End: "M", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.MP = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "M", End: "Q", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.QT = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "Q", End: "U", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.UX = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "U", End: "Y", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }
          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.YZ = function () {
      $("#gridContainer").dxDataGrid("instance").beginCustomLoading();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getByLetter",
        data: { Start: "Y", Client_Id: $rootScope.Client_Id }
      });
      response.then(
        function (customerdata) {
          $scope.getCustomerdatas = customerdata.data.data;
          if (IsAdmin != true) {
            var item = $scope.getCustomerdatas.filter(function (item) {
              if (item.AssignedUser != null) {
                item.AssignedUser = item.AssignedUser;
                var eeitem = item.AssignedUser.split(",");
                eeitem.push(item.CreatedBy);
                try {
                  var et = item.SalesPersonName.toLowerCase();
                  eeitem.push(et);
                } catch (error) { }

                return _.intersection(eeitem, Emploee).length > 0
                  ? true
                  : false;
              }
            });
            $scope.Customerdatas = item;
            $scope.FilteredCustomer = item;
            $scope.vm.PreviewSpinner = false;
            $scope.Alllcustomer = customerdata.data.data;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          } else {
            $scope.Customerdatas = $scope.getCustomerdatas;
            $scope.FilteredCustomer = $scope.getCustomerdatas;
            $scope.Alllcustomer = $scope.getCustomerdatas;
            $scope.vm.PreviewSpinner = false;
            $("#gridContainer").dxDataGrid("instance").endCustomLoading();
          }

          $scope.AllCustomersview($scope.ViewAllCustomer);
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    function getAllCustomers() {
      $scope.vm.PreviewSpinner = true;
      $scope.Customerdatas = [];
      $scope.getCustomerdatas = [];
      if (dataGrid != undefined)
        angular
          .element("#gridContainer")
          .dxDataGrid("instance")
          .beginCustomLoading();
      DataSyncService.getAllCustomers().then(function (data) {
        $scope.getCustomerdatas = data;
        $scope.Customerdatas = angular.copy($scope.getCustomerdatas);
        $scope.Alllcustomer = $scope.Customerdatas;
        updateCustomerLists();

        angular
          .element("#gridContainer")
          .dxDataGrid("instance")
          .endCustomLoading();
      });
    }

    $scope.AllInfo = getAllCustomers;
    $scope.ClearGrid = function () {
      $("#gridContainer").dxDataGrid("instance").clearSelection();
    };
    $scope.AcceptanceforUpdateEmail = function (e) {
      $scope.vm.UpdateEmail = [];
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/BeforeUpdateEmail.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.GetDetailsforUpdateEmail = function () {
      if (
        $scope.vm.UpdateEmail == "" ||
        $scope.vm.UpdateEmail == null ||
        $scope.vm.UpdateEmail == undefined ||
        $scope.vm.UpdateEmail == [] ||
        $scope.vm.UpdateEmail.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Email Required!!")
            .position("top center")
        );
        return;
      }
      var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      var trueUpdateEmailValid = true;
      var falseUpdateEmailValid = true;
      if (
        $scope.vm.UpdateEmail != "" &&
        $scope.vm.UpdateEmail != null &&
        $scope.vm.UpdateEmail != undefined
      ) {
        angular.forEach($scope.vm.UpdateEmail, function (ite) {
          if (reg.test(ite)) {
            trueUpdateEmailValid = true;
          } else {
            falseUpdateEmailValid = false;
          }
        });
      }
      if (falseUpdateEmailValid == false) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Valid Email Required!!")
            .position("top center")
        );
        return;
      } else {
        $scope.vm.usUpdateEmail = $scope.vm.UpdateEmail.map(function (obj) {
          return obj;
        }).join(",");
        try {
          angular.forEach($scope.SelectedIds, function (value) {
            if (value != "") {
              var response = $http({
                method: "PUT",
                url:

                  $rootScope.WebURL +
                  "/customerService/UpdateServiceAddressEmail",
                data: {
                  _id: value,
                  sEmail: $scope.vm.usUpdateEmail,
                  IsActive: "true",
                  UpdatedBy: $rootScope.createdby
                }
              });
            }
          });
        } catch (e) { }

        CustomerServicedatadetails();
        $scope.SelectedIds = [];
        $scope.Selec = { value: false };
        $scope.MSelec = { value: false };
        $scope.All = false;
        $scope.vm.All = false;
        $scope.SAdiv = false;
        $scope.vm.UpdateEmail = [];
        $scope.vm.usUpdateEmail = "";
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("Successfully Email Updated!")
            .position("top center")
        );
      }
    };
    $scope.commentSubmit = function () {
      if ($scope.Update == true) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulercomment/add",
          data: {
            CustomerID: $scope.SID,
            TableName: "Customer",
            CommentedBy: $rootScope.createdby,
            cmt: $scope.vm.Comments,
            ModuleID: "",
            CreatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        });
        response.then(
          function (GList) {
            var response1 = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: $scope.SID,
                AssignedUser: $rootScope.createdby,
                UpdatedBy: $rootScope.createdby
              }
            });
            response1.then(function (Lis) {
              Refreshcomment($scope.SID);
              $scope.vm.Comments = "";
            });
          },
          function () {
            $mdToast.show(
              $mdToast
                .simple()
                .textContent("Something entered gone wrong,please try again !")
                .position("top center")
            );
          }
        );
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/schedulercomment/add",
          data: {
            CustomerID: null,
            TableName: "Customer",
            CommentedBy: $rootScope.createdby,
            cmt: $scope.vm.Comments,
            ModuleID: $scope.vm.uCustomerID,
            CreatedBy: $rootScope.createdby,
            IsActive: "true"
          }
        }).then(function (List) {
          Refreshcomment($scope.vm.uCustomerID);
          $scope.vm.Comments = "";
        });
      }
    };

    $scope.AssignbyComment = function () {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulercomment/add",
        data: {
          CustomerID: $scope.CID,
          TableName: "Customer",
          CommentedBy: $rootScope.createdby,
          cmt: $scope.vm.Comments,
          ModuleID: "",
          CreatedBy: $rootScope.createdby,
          IsActive: "true"
        }
      });
      response.then(
        function (GList) {
          var response1 = $http({
            method: "PUT",
            url: $rootScope.WebURL + "/customer/updateAssignedUser",
            data: {
              _id: $scope.CID,
              AssignedUser: $rootScope.createdby,
              UpdatedBy: $rootScope.createdby
            }
          });
          response1.then(function (Lis) {
            $scope.vm.Comments = "";
            $mdDialog.cancel();
          });
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.CheckAll = function (IsTicked) {
      if (IsTicked == true) {
        angular.forEach($scope.Customerdatas, function (value) {
          if (value.id != "" && value.id != null && value.id != undefined) {
            if ($scope.CustomerSelectedIds.indexOf(value.id) == -1) {
              $scope.CustomerSelectedIds.push(value.id);
            }
          }
        });
        $scope.Cdiv = true;
        $scope.CSelec = { value: true };
        //$scope.CMSelec = { value: true };
      } else if (IsTicked == false) {
        $scope.CustomerSelectedIds = [];
        $scope.Cdiv = false;
        $scope.CSelec = { value: false };
        //$scope.CMSelec = { value: false };
      }
    };
    $scope.Check = function (SI, Ids) {
      if (SI == true) {
        if ($scope.CustomerSelectedIds.indexOf(Ids) == -1) {
          $scope.CustomerSelectedIds.push(Ids);
        }
      } else if (SI == false) {
        var index = $scope.CustomerSelectedIds.indexOf(Ids);
        if (index > -1) {
          $scope.CustomerSelectedIds.splice(index, 1);
        }
      }
      if ($scope.CustomerSelectedIds.length > 0) {
        $scope.Cdiv = true;
      } else if ($scope.CustomerSelectedIds.length == 0) {
        $scope.Cdiv = false;
        $scope.CSelec = { value: false };
        $scope.CMSelec = { value: false };
      }
    };

    $scope.AcceptanceforAssignedUser = function (e) {
      $scope.vm.UpdateAssignedUser = "";
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/BeforeAssignedUser.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.UpdateAssignedUser = function () {
      if (
        $scope.vm.UpdateAssignedUser == "" ||
        $scope.vm.UpdateAssignedUser == null ||
        $scope.vm.UpdateAssignedUser == undefined ||
        $scope.vm.UpdateAssignedUser.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Required!!")
            .position("top center")
        );
        return;
      }
      $scope.AssignedUser = $scope.vm.UpdateAssignedUser.map(function (obj) {
        return obj.UserID;
      }).join(",");
      try {
        angular.forEach($scope.CustomerSelectedIds, function (value) {
          if (value != "") {
            var response = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: value,
                AssignedUser: $scope.AssignedUser,
                UpdatedBy: $rootScope.createdby
              }
            });
          }
        });
      } catch (e) { }

      $scope.CustomerSelectedIds = [];
      $scope.Cdiv = false;
      $scope.CAll = false;
      $scope.CSelec = { value: false };
      $scope.CMSelec = { value: false };
      $scope.vm.All = false;
      $scope.vm.UpdateAssignedUser = "";
      $scope.AssignedUser = "";
      $mdDialog.cancel();
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("User Assigned Successfully!")
          .position("top center")
      );
    };

    $scope.UnAssignedUser = function () {
      try {
        angular.forEach($scope.CustomerSelectedIds, function (value) {
          if (value != "") {
            var response = $http({
              method: "PUT",
              url:
                $rootScope.WebURL + "/customer/updateAssignedUser",
              data: {
                _id: value,
                AssignedUser: null,
                UpdatedBy: $rootScope.createdby
              }
            });
          }
          $scope.vm.PreviewSpinner = true;
        });
      } catch (e) { }
      setTimeout(function () {
        $scope.vm.PreviewSpinner = false;
        $scope.CustomerSelectedIds = [];
        $scope.Cdiv = false;
        $scope.CAll = false;
        $scope.CSelec = { value: false };
        $scope.CMSelec = { value: false };
        $scope.vm.All = false;
        $scope.vm.UpdateAssignedUser = "";
        $scope.AssignedUser = "";
        $mdDialog.cancel();
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Assigned Successfully!")
            .position("top center")
        );
      }, 3000);
    };

    $scope.AcceptanceforUpdateAssignedUser = function (e, CId) {
      $scope.CID = CId;
      $scope.vm.UpdateAssignedUserforCustomer = "";
      $mdDialog.show({
        multiple: true,
        templateUrl:
          "app/main/apps/crm/customer/BeforeAssignedUserforCustomer.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };

    $scope.UpdateAssignedUserforCustomer = function () {
      if (
        $scope.vm.UpdateAssignedUserforCustomer == "" ||
        $scope.vm.UpdateAssignedUserforCustomer == null ||
        $scope.vm.UpdateAssignedUserforCustomer == undefined ||
        $scope.vm.UpdateAssignedUserforCustomer.length == 0
      ) {
        $mdToast.show(
          $mdToast
            .simple()
            .textContent("User Required!!")
            .position("top center")
        );
        return;
      }
      $scope.AssignedUserforCustomer = $scope.vm.UpdateAssignedUserforCustomer.map(
        function (obj) {
          return obj.UserID;
        }
      ).join(",");
      if ($scope.AssignedUserforCustomer === "UnAssigned")
        $scope.AssignedUserforCustomer = null;
      var response = $http({
        method: "PUT",
        url: $rootScope.WebURL + "/customer/updateAssignedUser",
        data: {
          _id: $scope.CID,
          AssignedUser: $scope.AssignedUserforCustomer,
          UpdatedBy: $rootScope.createdby
        }
      });
      response.then(
        function (GList) {
          $scope.vm.UpdateAssignedUserforCustomer = "";
          $scope.AssignedUserforCustomer = "";
          $scope.CID = "";
          $mdDialog.cancel();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("User Assigned Successfully!")
              .position("top center")
          );
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    $scope.AllIfo = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: { _id: CId }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });
          angular.forEach($scope.SalesOrderdetails, function (svalue) {
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (svalue._id == cvalue.SalesOrderID) {
                cvalue.SalesOrderID = svalue.SalesOrderNo;
              }
            });
          });
          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;
          var item1 = $scope.Invoicedetails.filter(function (item1) {
            return (
              new Date(item1.Date) >= $scope.vm.uIFrom &&
              new Date(item1.Date) <= $scope.vm.uITo
            );
          });
          $scope.Invoicedetails = item1;

          var item3 = $scope.Contracterdetails.filter(function (item3) {
            return (
              new Date(item3.ContractEndDate) >= $scope.vm.ucFrom &&
              new Date(item3.ContractEndDate) <= $scope.vm.ucTo
            );
          });
          $scope.Contracterdetails = item3;
          var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
            return (
              new Date(item4.Startsat) >= $scope.vm.pvFrom &&
              new Date(item4.Startsat) <= $scope.vm.pvTo &&
              item4.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item4;
        } catch (e) { }
      });
    };
    $scope.DateSF = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: {
          _id: CId
        }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });

          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;

          var item1 = $scope.PVSchedulerdetails.filter(function (item1) {
            return (
              new Date(item1.Startsat) >= $scope.vm.pvFrom &&
              new Date(item1.Startsat) <= $scope.vm.pvTo &&
              item1.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item1;
        } catch (e) { }
      });
    };
    $scope.DateIF = function () {
      try {
        var item = $scope.Invoiceddetails.filter(function (item) {
          return (
            new Date(item.Date) >= $scope.vm.uIFrom &&
            new Date(item.Date) <= $scope.vm.uITo
          );
        });
        $scope.Invoicedetails = item;
      } catch (e) { }
    };
    $scope.DateWO = function () {
      try {
        $scope.SalesOrderdetails;
      } catch (e) { }
    };
    $scope.DateC = function () {
      try {
        var item = $scope.Contractdetails.filter(function (item) {
          return (
            new Date(item.ServiceEndDate) >= $scope.vm.ucFrom &&
            new Date(item.ServiceStartDate) <= $scope.vm.ucTo
          );
        });
        $scope.Contracterdetails = item;
      } catch (e) { }
    };
    $scope.DatePV = function (CId) {
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/customer/getById",
        data: { _id: CId }
      });
      response.then(function (GList) {
        try {
          $scope.SalesOrderdetails = GList.data.data[0].SalesOrderdetails;
          $scope.Contracterdetails = GList.data.data[0].Contracterdetails;
          $scope.Schedulerdetails = GList.data.data[0].Schedulerdetails;
          $scope.PVSchedulerdetails = GList.data.data[0].Schedulerdetails;
          angular.forEach($scope.Schedulerdetails, function (value) {
            angular.forEach($scope.SalesOrderdetails, function (svalue) {
              if (value.JobsOrders == svalue._id) {
                value.JobsOrders = svalue.SalesOrderNo;
              }
            });
            angular.forEach($scope.Contracterdetails, function (cvalue) {
              if (value.ContractOrder == cvalue._id) {
                value.ContractOrder = cvalue.ContractReferenceNo;
              }
            });
          });

          var item = $scope.Schedulerdetails.filter(function (item) {
            return (
              new Date(item.Startsat) >= $scope.vm.upFrom &&
              new Date(item.Startsat) <= $scope.vm.upTo &&
              item.Status === "Yet to Start"
            );
          });
          $scope.Schedulerdetails = item;

          var item1 = $scope.PVSchedulerdetails.filter(function (item1) {
            return (
              new Date(item1.Startsat) >= $scope.vm.pvFrom &&
              new Date(item1.Startsat) <= $scope.vm.pvTo &&
              item1.Status === "Completed"
            );
          });
          $scope.PVSchedulerdetails = item1;
        } catch (e) { }
      });
    };
    $scope.Totla = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        var secondDate = new Date(uTimeOut);
        if (
          firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)
        ) {
          return "Expiried";
        } else {
          var res = Math.round(
            Math.abs((secondDate.getTime() - firstDate.getTime()) / oneDay)
          );
          if (res == 0) {
            return "Expiried";
          } else {
            return res;
          }
        }
      } else {
        return null;
      }
    };
    $scope.uShowUnpaid = false;
    $scope.ShowUnpaid = function (uShowUnpaid, CId) {
      if (uShowUnpaid == true) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/customer/getById",
          data: {
            _id: CId
          }
        });
        response.then(function (GList) {
          try {
            $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
            var item = $scope.Invoicedetails.filter(function (item) {
              return item.Status === "Unpaid";
            });
            $scope.Invoicedetails = item;
          } catch (e) { }
        });
      } else {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/customer/getById",
          data: {
            _id: CId
          }
        });
        response.then(function (GList) {
          try {
            $scope.Invoicedetails = GList.data.data[0].Invoicedetails;
            var item = $scope.Invoicedetails.filter(function (item) {
              return (
                new Date(item.Date) >= $scope.vm.uFrom &&
                new Date(item.Date) <= $scope.vm.uTo
              );
            });
            $scope.Invoicedetails = item;
          } catch (e) { }
        });
      }
    };

    $scope.Detailsinfo = function (e, id, t) {
      if (t == "WorkOrder") {
        $scope.vm.Title = "WorkOrder";
        var info = $scope.salesOrderdatas;
        try {
          var item = info.filter(function (item) {
            return item._id === id;
          })[0];
          $scope.vm.SalesOrderNo = item.SalesOrderNo;
          $scope.vm.OrderConfirmationDate = item.OrderConfirmationDate;
          if (
            $scope.vm.OrderConfirmationDate != null &&
            $scope.vm.OrderConfirmationDate != ""
          ) {
            $scope.vm.OrderConfirmationDate = new Date(
              item.OrderConfirmationDate
            );
          }
          $scope.vm.PestType = item.PestType;
          $scope.vm.CreatedBy = item.CreatedBy;
          $scope.vm.PONumber = item.PONumber;
          $scope.vm.EnquiryID = item.EnquiryID;
          $scope.vm.SalesPerson =
            item.employeedetails[0].EmployeeID +
            "-" +
            item.employeedetails[0].EmployeeName;
          $scope.vm.EnquiryReferenceNo = item.EnquiryReferenceNo;
          $scope.vm.ContactPerson = item.ContactPerson;
          $scope.vm.CustomerName = item.Customer_id;
          $scope.vm.ServiceStartDate = item.ServiceStartDate;
          if (
            $scope.vm.ServiceStartDate != null &&
            $scope.vm.ServiceStartDate != ""
          ) {
            $scope.vm.ServiceStartDate = new Date(item.ServiceStartDate);
          }
          $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
          $scope.vm.ServiceEndDate = item.ServiceEndDate;
          if (
            $scope.vm.ServiceEndDate != null &&
            $scope.vm.ServiceEndDate != ""
          ) {
            $scope.vm.ServiceEndDate = new Date(item.ServiceEndDate);
          }
          $scope.vm.EnquiryRefNo = item.EnquiryReferenceNo;
          $scope.vm.Frequency = item.Frequency;
          $scope.vm.OrderType = item.OrderType;
          $scope.vm.TotalOrderitem = item.TotalOrderitem;
          $scope.vm.PaymentTerms = item.PaymentTerms;
          $scope.vm.BillingFrequency = item.BillingFrequency;
          $scope.vm.PaymentMode = item.PaymentMode;
          $scope.vm.Types = item.Types;
          $scope.vm.JobsPerFrequency = item.JobsPerFrequency;
          $scope.vm.ServicesRequired = item.ServicesRequired;
          $scope.vm.SName = item.SiteName;
          $scope.vm.CreatedDate = item.CreatedDate;
          $scope.vm.SContactNo = item.SiteContactNo;
          $scope.vm.BContactNo = item.Mobile;
          $scope.vm.BEmail = null;
          if (item.Email != "" && item.Email != undefined && item.Email != null)
            $scope.vm.BEmail = item.Email;
          $scope.vm.TotalSum = item.TotalSum;
          $scope.vm.CoverageArea = item.CoverageArea;
          $scope.vm.IsUrgent = item.IsUrgent;
          if ($scope.vm.IsUrgent == true) $scope.vm.IsUrgent = "true";
          else $scope.vm.IsUrgent = "false";
          $scope.vm.TrendingReport = item.TrendingReport;
          if ($scope.vm.TrendingReport == true)
            $scope.vm.TrendingReport = "true";
          else $scope.vm.TrendingReport = "false";
          $scope.vm.DateTimeofTreatment = item.DateTimeofTreatment;
          $scope.vm.SpecialRemarks = item.SpecialRemarks;
          $scope.vm.SiteContactPerson = item.SiteContactPerson;
          $scope.vm.Treatment = item.Treatment;
          $scope.Frequencydatas = item.MultiFrequency;
          $scope.vm.EstimatedHoursRequired = item.EstimatedHoursRequired;
          $scope.vm.TotalPrice = item.TotalPrice;
          $scope.vm.ServiceLocation =
            item.customerServicedetails[0].sStreetName;
          $scope.vm.BillingAddress =
            item.customerdetails[0].StreetName +
            "," +
            item.customerdetails[0].Country +
            "," +
            item.customerdetails[0].Postal;
          $scope.vm.SContactPerson = item.customerdetails[0].ContactPerson;
          $scope.vm.SMobile = item.customerdetails[0].Mobile;
          $scope.vm.SEmail = item.customerdetails[0].Email;
          var response = $http({
            method: "POST",
            url: $rootScope.WebURL + "/contract/getById",
            data: {
              _id: item.ContractNo
            }
          });
          response.then(function (GList) {
            try {
              var value = GList.data.data[0];
              $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            } catch (e) { }
          });
        } catch (e) { }
      }
      if (t == "Contract") {
        $scope.vm.Title = "Contract";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/contract/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          try {
            var value = GList.data.data[0];
            $scope.vm.ContractId = value._id;
            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContractStartDate = value.ContractStartDate;
            if (
              $scope.vm.ContractStartDate != null &&
              $scope.vm.ContractStartDate != ""
            ) {
              $scope.vm.ContractStartDate = new Date(value.ContractStartDate);
            }
            $scope.vm.ContractDuration = value.ContractDuration;
            $scope.vm.ContractEndDate = value.ContractEndDate;
            if (
              $scope.vm.ContractEndDate != null &&
              $scope.vm.ContractEndDate != ""
            ) {
              $scope.vm.ContractEndDate = new Date(value.ContractEndDate);
            }
            $scope.vm.ContractNotes = value.ContractNotes;
            $scope.vm.CreatedBy = value.CreatedBy;
            $scope.vm.SalesPerson = value.SalesPerson_id;

            $scope.vm.ContractReferenceNo = value.ContractReferenceNo;
            $scope.vm.ContactPerson = value.ContactPerson;
            $scope.vm.ServiceStartDate = value.ServiceStartDate;
            if (
              $scope.vm.ServiceStartDate != null &&
              $scope.vm.ServiceStartDate != ""
            ) {
              $scope.vm.ServiceStartDate = new Date(value.ServiceStartDate);
            }
            $scope.vm.ServiceEndDate = value.ServiceEndDate;
            if (
              $scope.vm.ServiceEndDate != null &&
              $scope.vm.ServiceEndDate != ""
            ) {
              $scope.vm.ServiceEndDate = new Date(value.ServiceEndDate);
            }
            $scope.vm.Frequency = value.Frequency;
            $scope.vm.SalesOrderID = value.SalesOrderID;
            $scope.vm.PestType = value.PestType;
            $scope.vm.Quote = value.Quote;
            $scope.vm.Customer = value.Customer;
            $scope.vm.ContractStatus = value.ContractStatus;
            $scope.vm.CurrentStatus = value.Status;
            $scope.vm.CurrentStatusID = value.StatusID;
            $scope.RenewalN = value.Renewal;
            $scope.OldContract_Id = value.OldContract_Id;
          } catch (e) { }
          if ($scope.RenewalN == "Renewaled") {
            $http({
              method: "POST",
              url: $rootScope.WebURL + "/contract/getOld",
              data: { OldContract_Id: $scope.OldContract_Id }
            }).then(function (datas) {
              try {
                $scope.OldContractReferenceNo =
                  datas.data.data.ContractReferenceNo;
                $scope.OldContractStartDate = datas.data.data.ContractStartDate;
                $scope.OldContractEndDate = datas.data.data.ContractEndDate;
                $scope.OldUpdatedDate = datas.data.data.UpdatedDate;
                $scope.OldFrequency = datas.data.data.Frequency;
                $scope.OldContractDuration = datas.data.data.ContractDuration;
              } catch (e) { }
            });
          }
        });
      }
      if (t == "Schedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getByFileID",
          data: {
            FileID: $scope.SID,
            Start_Date: $scope.vm.uFrom,
            End_Date: $scope.vm.uTo
          }
        });
        response.then(function (GList) {
          var info = GList.data.data;
          try {
            var item = info.filter(function (item) {
              return item._id === id;
            })[0];
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ContractOrder = item.ContractOrder;
            $scope.vm.PestType = item.PestType;
            $scope.vm.Types = item.Types;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.Billable = item.Billable;
            $scope.CollectPayment = item.CollectPayment;
          } catch (e) { }
        });
      }
      if (t == "PVSchedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getByFileID",
          data: {
            FileID: $scope.SID,
            Start_Date: $scope.vm.upFrom,
            End_Date: $scope.vm.upTo
          }
        });
        response.then(function (GList) {
          var info = GList.data.data;
          try {
            var item = info.filter(function (item) {
              return item._id === id;
            })[0];
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ContractOrder = item.ContractOrder;
            $scope.vm.PestType = item.PestType;
            $scope.vm.Types = item.Types;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.Billable = item.Billable;
            $scope.vm.Vehicle = item.Vehicle;
          } catch (e) { }
        });
      }
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/Details.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
    };
    $scope.SchedulerDetailsinfo = function (e, id, t) {
      $mdDialog.show({
        templateUrl: "app/main/apps/crm/customer/addcoments.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      if (t == "Schedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          var item = GList.data.data[0];
          try {
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            if (
              item.Tabletschedulerdetails[0] != null &&
              item.Tabletschedulerdetails[0] != "" &&
              item.Tabletschedulerdetails[0] != undefined
            ) {
              $scope.Tabletschedulerrecord = item.Tabletschedulerdetails[0];
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ScedulId = item._id;
            $scope.vm.Types = item.Types;
            $scope.vm.PestType1 = item.PestType;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.BillingAmount = item.BillingAmount;
            $scope.vm.Location = item.Location;
            $scope.vm.Status = item.Status;
            $scope.vm.JobContinues = item.JobContinues;
            $scope.CreatedBy = item.CreatedBy;
            $scope.CreatedDate = new Date(item.CreateDate);
            $scope.InProgressedBy = "";
            $scope.InProgresseAt = null;
            if (
              $scope.vm.Status != "Yet to Start" &&
              $scope.vm.Status != "Outstanding"
            ) {
              $scope.InProgressedBy = item.InProgressedBy;
            }
            if (
              item.EmailSentDate == null ||
              item.EmailSentDate == undefined ||
              item.EmailSentDate == "null"
            ) {
              $scope.vm.EmailSentDate = "";
            } else {
              $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
            }
            $scope.vm.EmailSentTo = item.EmailSentTo;
            var address = item.Location || "Singapore";
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
              geocoder.geocode(
                {
                  address: address
                },
                function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    $scope.latlng = [];
                    $scope.latlng.push(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng()
                    );
                  }
                }
              );
            }
          } catch (e) { }
        });
      }
      if (t == "PVSchedule") {
        $scope.vm.Title = "Schedule";
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/scheduler/getById",
          data: {
            _id: id
          }
        });
        response.then(function (GList) {
          var item = GList.data.data[0];
          try {
            if (
              item.teamdetails[0] != null &&
              item.teamdetails[0] != "" &&
              item.teamdetails[0] != undefined
            ) {
              $scope.vm.TeamName = item.teamdetails[0].TeamName;
              $scope.vm.TeamLead = item.teamdetails[0].TeamLead;
              $scope.vm.TeamMembers = item.teamdetails[0].TeamMembers;
            }
            if (
              item.customerdetails[0] != null &&
              item.customerdetails[0] != "" &&
              item.customerdetails[0] != undefined
            ) {
              $scope.vm.CompanyName = item.customerdetails[0].CompanyName;
              $scope.vm.Address = item.customerdetails[0].Address;
              $scope.vm.Mobile = item.customerdetails[0].Mobile;
              $scope.vm.ContactPerson = item.customerdetails[0].ContactPerson;
            }
            if (
              item.Contracterdetails[0] != null &&
              item.Contracterdetails[0] != "" &&
              item.Contracterdetails[0] != undefined
            ) {
              $scope.vm.ContractReferenceNo =
                item.Contracterdetails[0].ContractReferenceNo;
            }
            if (
              item.JobOrdersdetails[0] != null &&
              item.JobOrdersdetails[0] != "" &&
              item.JobOrdersdetails[0] != undefined
            ) {
              $scope.vm.SalesOrderNo = item.JobOrdersdetails[0].SalesOrderNo;
            }
            if (
              item.Tabletschedulerdetails[0] != null &&
              item.Tabletschedulerdetails[0] != "" &&
              item.Tabletschedulerdetails[0] != undefined
            ) {
              $scope.Tabletschedulerrecord = item.Tabletschedulerdetails[0];
            }
            $scope.vm.Frequency = item.Frequency;
            $scope.vm.ServiceOn = item.ServiceOn;
            $scope.vm.ServiceID = item.ServiceID;
            $scope.vm.ScedulId = item._id;
            $scope.vm.Types = item.Types;
            $scope.vm.PestType1 = item.PestType;
            $scope.vm.Location = item.Location;
            $scope.vm.ServiceStartAt = new Date(item.Startsat);
            $scope.vm.ServiceEndAt = new Date(item.Endsat);
            $scope.vm.Status = item.Status;
            $scope.vm.JobContinues = item.JobContinues;
            $scope.CreatedBy = item.CreatedBy;
            $scope.CreatedDate = new Date(item.CreateDate);
            $scope.InProgressedBy = "";
            $scope.InProgresseAt = null;
            $scope.vm.BillingAmount = item.BillingAmount;
            if (
              $scope.vm.Status != "Yet to Start" &&
              $scope.vm.Status != "Outstanding"
            ) {
              $scope.InProgressedBy = item.InProgressedBy;
              if ($scope.vm.Status == "Completed") {
                $scope.InProgressedBy = item.UpdatedBy;
              }
            }
            if (
              item.EmailSentDate == null ||
              item.EmailSentDate == undefined ||
              item.EmailSentDate == "null"
            ) {
              $scope.vm.EmailSentDate = "";
            } else {
              $scope.vm.EmailSentDate = new Date(item.EmailSentDate);
            }
            $scope.vm.EmailSentTo = item.EmailSentTo;
            try {
              var value = $scope.Tabletschedulerrecord;
              if (
                value.TeamSignature != null &&
                value.TeamSignature != "" &&
                value.TeamSignature != undefined
              ) {
                value.TeamSignature = decode_base64(value.TeamSignature);
                $scope.vm.TeamSignature = value.TeamSignature;
              }
              if (
                value.CustomerSignature != null &&
                value.CustomerSignature != "" &&
                value.CustomerSignature != undefined
              ) {
                value.CustomerSignature = decode_base64(
                  value.CustomerSignature
                );
                $scope.CustomerSignature = value.CustomerSignature;
              }
              $scope.vm.Pesttype = value.Pesttype;
              $scope.vm.Services = value.Services;
              $scope.vm.Materials = value.Materials;
              $scope.vm.TeamMember = value.TeamMember;
              $scope.vm.TeamRemarks = value.TeamRemarks;
              $scope.vm.CustomerRemarks = value.CustomerRemarks;
              $scope.vm.TeamLead = value.TeamLead;
              $scope.vm.ATimeIn = new Date(value.Startsat);
              $scope.vm.ATimeOut = new Date(value.Endsat);
              $scope.vm.Scheduledate = new Date(value.Scheduledate);
              $scope.vm.StartLocation = value.StartLocation;
              $scope.vm.EndLocation = value.EndLocation;
              $scope.vm.BreedingFound = value.BreedingFound;
              $scope.vm.Species = value.Species;
              $scope.vm.Findings = value.Findings;
              $scope.vm.MistingCariedOut = value.MistingCariedOut;
              $scope.vm.Density = value.Density;
              $scope.vm.Instar = value.Instar;
              $scope.vm.Reason = value.Reason;
              $scope.vm.TeamSignature = value.TeamSignature;
              $scope.vm.Paymentmethod = value.Paymentmethod;
              $scope.vm.PaymentNotes = value.PaymentNotes;
              $scope.vm.MobilEmailId = value.EmailId;
              $scope.vm.PaymentRemarks = value.PaymentRemarks;
              $scope.vm.starRating1 = value.Rating;
              $scope.vm.AServiceStartAt = new Date(value.Startsat);
              if ($scope.vm.Status == "Completed") {
                $scope.InProgresseAt = $scope.vm.AServiceStartAt;
              }
              $scope.vm.AServiceEndAt = new Date(value.Endsat);
              $scope.vm.Totalarea = value.Totalarea;
              $scope.vm.Totalcompleted = value.Totalcompleted;
              $scope.vm.Totalpayment = value.Totalpayment;
              if (
                $scope.vm.Totalarea == null ||
                $scope.vm.Totalarea == "" ||
                $scope.vm.Totalarea == undefined
              ) {
                $scope.vm.Totalarea = 0;
              }
              if (
                $scope.vm.Totalcompleted == "null" ||
                $scope.vm.Totalcompleted == null ||
                $scope.vm.Totalcompleted == "" ||
                $scope.vm.Totalcompleted == undefined
              ) {
                $scope.vm.Totalcompleted = 0;
              }
              if (
                $scope.vm.Totalpayment == "null" ||
                $scope.vm.Totalpayment == null ||
                $scope.vm.Totalpayment == "" ||
                $scope.vm.Totalpayment == undefined
              ) {
                $scope.vm.Totalpayment = 0;
              }
              $scope.vm.CustomerCurrentDate = new Date(
                value.CustomerCurrentDate
              );
              if (
                $scope.vm.starRating1 != "null" &&
                $scope.vm.starRating1 != null &&
                $scope.vm.starRating1 != "" &&
                $scope.vm.starRating1 != undefined
              ) {
                $scope.vm.starRating1r = parseInt(value.Rating);
              }
            } catch (e) { }
            var address = $scope.vm.Location || "Singapore";
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
              geocoder.geocode(
                {
                  address: address
                },
                function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    $scope.latlng = [];
                    $scope.latlng.push(
                      results[0].geometry.location.lat(),
                      results[0].geometry.location.lng()
                    );
                  }
                }
              );
            }
          } catch (e) { }
        });
      }
      RefreshAttachmentGrid(id);
      Refreshcomment(id);
      RefreshPhotos(id);
      RefreshServiceMaterials(id);
      RefreshMobileLogMaterials(id);
      RefreshSchedulerLogs(id);
    };

    $scope.getServiceReports = function (id) {
      var url =
        $rootScope.ReportURL + "Service.aspx" + "?" + "ID=" + id;
      window.open(url);
    };
    $scope.DownloadService = function (id) {
      var url =

        $rootScope.ReportURL +
        "Service.aspx" +
        "?" +
        "ID=" +
        id +
        "&Type=Download";
      window.open(url);
    };

    $scope.GetSchedulerDetails = function (CId, Status) {
      $scope.vm.Start_Date = new Date(new Date(Status).getFullYear(), 0, 1);
      $scope.vm.End_Date = new Date(new Date(Status).getFullYear(), 12, 0);
      $scope.vm.PreviewSpinner = true;
      $scope.RSchedulerdetails = [];
      $scope.PVSchedulerdetails = [];
      $http({
        url: $rootScope.WebURL + "/scheduler/getByFileID",
        method: "POST",
        data: {
          FileID: CId,
          Start_Date: $scope.vm.Start_Date,
          End_Date: $scope.vm.End_Date
        }
      }).then(function (List) {
        $scope.RSchedulerdetails = List.data.data;
        $scope.PVSchedulerdetails = List.data.data;
        var item4 = $scope.PVSchedulerdetails.filter(function (item4) {
          return (
            new Date(item4.Startsat) >= $scope.vm.pvFrom &&
            new Date(item4.Startsat) <= $scope.vm.pvTo &&
            item4.Status === "Completed"
          );
        });
        $scope.PVSchedulerdetails = item4;
        $scope.vm.PreviewSpinner = false;
      });
    };

    $scope.CCarray = [];
    $scope.AddCC = function (email) {
      try {
        if ($scope.CCarray.indexOf(email) == -1) {
          $scope.CCarray.push(email);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };
    $scope.Removeccs = function (i) {
      try {
        if ($scope.CCarray.indexOf(i) == -1) {
          $scope.CCarray.splice(i, 1);
        }
        $scope.vm.CCs = $scope.CCarray;
      } catch (e) { }
      $scope.vm.usEmail = null;
    };

    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "CreditTerm";
        });
        $scope.CreditTermdatas = item;
      } catch (e) { }

      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "BuildingType";
        });
        $scope.BuildingTypedatas = item;
      } catch (e) { }
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "EnquiryMode";
        });
        $scope.EnquiryModedatas = item;
      } catch (e) { }
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/marketsegment",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (marketsegmentdata) {
      $scope.Marketsegmentdatas = marketsegmentdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/team",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (teamdata) {
      $scope.Teamdatas = teamdata.data.data;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (salesOrderdata) {
      $scope.salesOrderdatas = salesOrderdata.data.data;
      // $scope.Datefilter();
    });

    $http
      .get($rootScope.WebURL + "/user")
      .then(function (Userdata) {
        $scope.Userdatas = Userdata.data.data;
        $http({
          method: "POST",
          url: $rootScope.WebURL + "/employee/Resigned",
          data: { Client_Id: $rootScope.Client_Id }
        }).then(function (Employeedata) {
          $scope.ResignEmployeedatas = Employeedata.data.data;
          $scope.ResignedUsers = _.differenceBy(
            $scope.Userdatas,
            $scope.ResignEmployeedatas,
            "EmployeeID"
          );
        });
      });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/employee/getSalesPerson",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (Employeedata) {
      $scope.Employeedatas = Employeedata.data.data;
    });
    function RefreshMsgrid() {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/marketsegment",
        data: { Client_Id: $rootScope.Client_Id }
      }).then(function (marketsegmentdata) {
        $scope.Marketsegmentdatas = marketsegmentdata.data.data;
      });
    }
    function RefreshAttachmentGrid(id) {
      var response = $http({
        url: $rootScope.WebURL + "/attachment/getByFileID",
        method: "POST",
        data: { FileID: id }
      });
      response.then(function (attachmentdata) {
        $scope.Attachmentdatas = attachmentdata.data.data;
      });
    }
    function Refreshcomment(id) {
      if ($scope.Update == false) {
        var response = $http({
          url: $rootScope.WebURL + "/schedulercomment/getbyModule",
          method: "POST",
          data: { ModuleID: id }
        });
        response.then(function (Commentdata) {
          $scope.CustomerCommentdatas = Commentdata.data.data;
        });
      } else {
        var response = $http({
          url:
            $rootScope.WebURL + "/schedulercomment/getByCustomer",
          method: "POST",
          data: { RequestID: id }
        });
        response.then(function (Commentdata) {
          $scope.CustomerCommentdatas = Commentdata.data.data;
        });
      }
    }
    function RefreshPhotos(id) {
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/schedulerpicafter",
        data: { ScedulId: id }
      }).then(function (Photosdatas) {
        $scope.Photosdatas = Photosdatas.data.data;
        angular.forEach($scope.Photosdatas, function (employee) {
          if (
            employee.schimgafter != null &&
            employee.schimgafter != "" &&
            employee.schimgafter != undefined
          ) {
            employee.schimgafter = decode_base64(employee.schimgafter);
          }
          if (
            employee.schimgbefore != null &&
            employee.schimgbefore != "" &&
            employee.schimgbefore != undefined
          ) {
            employee.schimgbefore = decode_base64(employee.schimgbefore);
          }
        });
        var item = $scope.Photosdatas.filter(function (item) {
          return (
            item.schimgafter != null &&
            item.schimgafter != "null" &&
            item.schimgafter != "" &&
            item.schimgafter != undefined
          );
        });
        $scope.PhotosAdatas = item;
        var item1 = $scope.Photosdatas.filter(function (item1) {
          return (
            item1.schimgbefore != null &&
            item1.schimgbefore != "null" &&
            item1.schimgbefore != "" &&
            item1.schimgbefore != undefined
          );
        });
        $scope.PhotosBdatas = item1;
      });
    }
    function RefreshServiceMaterials(id) {
      var response = $http({
        url: $rootScope.WebURL + "/tabletlighttracklist/getbyId",
        method: "POST",
        data: { ServiceId: id }
      });
      response.then(function (Tabletlighttracklistdata) {
        $scope.Tabletlighttracklistdatas = Tabletlighttracklistdata.data.data;
      });
      $scope.vm.SMUpdate = false;
    }
    function RefreshMobileLogMaterials(id) {
      var response = $http({
        url: $rootScope.WebURL + "/tabletMaterials/getById",
        method: "POST",
        data: { Service_Id: id }
      });
      response.then(function (TabletMaterialslistdata) {
        $scope.TabletMaterialslistdatas = TabletMaterialslistdata.data.data;
      });
      $scope.vm.SMLMUpdate = false;
    }
    function RefreshSchedulerLogs(id) {
      var response = $http({
        url: $rootScope.WebURL + "/schedulelog/getByServiceID",
        method: "POST",
        data: { ServiceID: id }
      });
      response.then(function (SchedulerLogdata) {
        $scope.SchedulerLogdatas = SchedulerLogdata.data.data;
      });
    }
    function CustomerBillingdatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforBilling",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerBillingdata) {
        $scope.CustomerBillingdatas = CustomerBillingdata.data.data;
      });
    }
    function CustomerServicedatadetails() {
      var response = $http({
        url:
          $rootScope.WebURL + "/customerService/getByIDforService",
        method: "POST",
        data: { RequestID: $scope.RequestID }
      });
      response.then(function (CustomerServicedata) {
        $scope.CustomerServicedatas = CustomerServicedata.data.data;
      });
    }

    function ClearForm() {
      $scope.vm.uCustomerID = null;
      $scope.vm.uSalutation = null;
      $scope.vm.uFirstName = null;
      $scope.vm.uLastName = null;
      $scope.vm.uCompanyName = null;
      $scope.vm.uNote = null;
      $scope.vm.uAddress = null;
      $scope.vm.uAddress1 = null;
      $scope.vm.uPostal = null;
      $scope.vm.uCountry = "Singapore";
      $scope.vm.uContactPerson = null;
      $scope.vm.uPhone = null;
      $scope.vm.uMobile = [];
      $scope.vm.uEmail = [];
      // $scope.vm.CustomerSince = new Date();
      $scope.vm.ProspectFollowDate = null;
      $scope.vm.Unit = null;
      $scope.vm.EnquiryMode = null;
      $scope.vm.StreetName = null;
      $scope.vm.ubCountry = "Singapore";
      $scope.vm.ubContactPerson = null;
      $scope.vm.CreditTerm = null;
      $scope.vm.BuildingName = null;
      $scope.vm.ConEndDate = null;
      $scope.vm.ubFax = null;
      $scope.vm.ubMobile = null;
      $scope.vm.ubEmail = null;
      $scope.vm.Category = null;
      $scope.vm.MarketSection = null;
      $scope.vm.uInvoiceEmail = [];
      $scope.vm.uInvoiceCC = [];
      $scope.vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    }

    $scope.printServiceWeb = function (service) {
      var url =

        $rootScope.ReportURL +
        "Service.aspx" +
        "?" +
        "ID=" +
        $scope.vm.ScedulId;
      window.open(url);
    };
    $scope.printService = function (service) {
      var myPdfUrl = $rootScope.DownloadURL + $scope.vm.ServiceID + ".pdf";
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/scheduler/DownloadServiceReport",
        data: {
          _id: $scope.vm.ScedulId,
          ServiceID: $scope.vm.ServiceID
        }
      });
      response.then(function (GList) {
        setTimeout(function () {
          $window.open(myPdfUrl, "_blank");
        }, 3000);
      });
      alert(
        "Report will be opened in new window. You may have to wait for a while as the system generating the PDF. Please change your settings to allow the popup window for this URL. !"
      );
    };
    $scope.Showlocation = function (Latitude) {
      if (
        Latitude != null &&
        Latitude != "" &&
        Latitude != undefined &&
        Latitude != "undefined"
      ) {
        var array = Latitude.split(",");
        $window.open(
          "https://www.latlong.net/c/?lat=" + array[0] + "&long=" + array[1]
        );
      }
    };

    $scope.getRowColour = function (item) {
      if (item.State == "Suspend") {
        return true;
      } else {
        return false;
      }
    };
    $scope.dateBox = {
      type: "date",
      value: new Date(),
      displayFormat: "Year",
      calendarOptions: {
        zoomLevel: "decade",
        maxZoomLevel: "decade",
        mixZoomLevel: "decade"
      },
      onValueChanged: function (e) {
        $scope.GetSchedulerDetails($scope.SID, e.value);
      }
    };

    $scope.checkboxModel = { value: false };
    $scope.Servicecopy = { value: false };
    $scope.CountyList = [
      { name: "Afghanistan" },
      { name: "Albania" },
      { name: "Algeria" },
      { name: "American Samoa" },
      { name: "AndorrA" },
      { name: "Angola" },
      { name: "Anguilla" },
      { name: "Antarctica" },
      { name: "Antigua and Barbuda" },
      { name: "Argentina" },
      { name: "Armenia" },
      { name: "Aruba" },
      { name: "Australia" },
      { name: "Austria" },
      { name: "Azerbaijan" },
      { name: "Bahamas" },
      { name: "Bahrain" },
      { name: "Bangladesh" },
      { name: "Barbados" },
      { name: "Belarus" },
      { name: "Belgium" },
      { name: "Belize" },
      { name: "Benin" },
      { name: "Bermuda" },
      { name: "Bhutan" },
      { name: "Bolivia" },
      { name: "Bosnia and Herzegovina" },
      { name: "Botswana" },
      { name: "Bouvet Island" },
      { name: "Brazil" },
      { name: "British Indian Ocean Territory" },
      { name: "Brunei Darussalam" },
      { name: "Bulgaria" },
      { name: "Burkina Faso" },
      { name: "Burundi" },
      { name: "Cambodia" },
      { name: "Cameroon" },
      { name: "Canada" },
      { name: "Cape Verde" },
      { name: "Cayman Islands" },
      { name: "Central African Republic" },
      { name: "Chad" },
      { name: "Chile" },
      { name: "China" },
      { name: "Christmas Island" },
      { name: "Cocos (Keeling) Islands" },
      { name: "Colombia" },
      { name: "Comoros" },
      { name: "Congo" },
      { name: "Congo, The Democratic Republic of the" },
      { name: "Cook Islands" },
      { name: "Costa Rica" },
      { name: "Cote D'Ivoire" },
      { name: "Croatia" },
      { name: "Cuba" },
      { name: "Cyprus" },
      { name: "Czech Republic" },
      { name: "Denmark" },
      { name: "Djibouti" },
      { name: "Dominica" },
      { name: "Dominican Republic" },
      { name: "Ecuador" },
      { name: "Egypt" },
      { name: "El Salvador" },
      { name: "Equatorial Guinea" },
      { name: "Eritrea" },
      { name: "Estonia" },
      { name: "Ethiopia" },
      { name: "Falkland Islands (Malvinas)" },
      { name: "Faroe Islands" },
      { name: "Fiji" },
      { name: "Finland" },
      { name: "France" },
      { name: "French Guiana" },
      { name: "French Polynesia" },
      { name: "French Southern Territories" },
      { name: "Gabon" },
      { name: "Gambia" },
      { name: "Georgia" },
      { name: "Germany" },
      { name: "Ghana" },
      { name: "Gibraltar" },
      { name: "Greece" },
      { name: "Greenland" },
      { name: "Grenada" },
      { name: "Guadeloupe" },
      { name: "Guam" },
      { name: "Guatemala" },
      { name: "Guernsey" },
      { name: "Guinea" },
      { name: "Guinea-Bissau" },
      { name: "Guyana" },
      { name: "Haiti" },
      { name: "Heard Island and Mcdonald Islands" },
      { name: "Holy See (Vatican City State)" },
      { name: "Honduras" },
      { name: "Hong Kong" },
      { name: "Hungary" },
      { name: "Iceland" },
      { name: "India" },
      { name: "Indonesia" },
      { name: "Iran, Islamic Republic Of" },
      { name: "Iraq" },
      { name: "Ireland" },
      { name: "Isle of Man" },
      { name: "Israel" },
      { name: "Italy" },
      { name: "Jamaica" },
      { name: "Japan" },
      { name: "Jersey" },
      { name: "Jordan" },
      { name: "Kazakhstan" },
      { name: "Kenya" },
      { name: "Kiribati" },
      { name: "Korea, Democratic People'S Republic of" },
      { name: "Korea, Republic of" },
      { name: "Kuwait" },
      { name: "Kyrgyzstan" },
      { name: "Lao People'S Democratic Republic" },
      { name: "Latvia" },
      { name: "Lebanon" },
      { name: "Lesotho" },
      { name: "Liberia" },
      { name: "Libyan Arab Jamahiriya" },
      { name: "Liechtenstein" },
      { name: "Lithuania" },
      { name: "Luxembourg" },
      { name: "Macao" },
      { name: "Macedonia, The Former Yugoslav Republic of" },
      { name: "Madagascar" },
      { name: "Malawi" },
      { name: "Malaysia" },
      { name: "Maldives" },
      { name: "Mali" },
      { name: "Malta" },
      { name: "Marshall Islands" },
      { name: "Martinique" },
      { name: "Mauritania" },
      { name: "Mauritius" },
      { name: "Mayotte" },
      { name: "Mexico" },
      { name: "Micronesia, Federated States of" },
      { name: "Moldova, Republic of" },
      { name: "Monaco" },
      { name: "Mongolia" },
      { name: "Montenegro" },
      { name: "Montserrat" },
      { name: "Morocco" },
      { name: "Mozambique" },
      { name: "Myanmar" },
      { name: "Namibia" },
      { name: "Nauru" },
      { name: "Nepal" },
      { name: "Netherlands" },
      { name: "Netherlands Antilles" },
      { name: "New Caledonia" },
      { name: "New Zealand" },
      { name: "Nicaragua" },
      { name: "Niger" },
      { name: "Nigeria" },
      { name: "Niue" },
      { name: "Norfolk Island" },
      { name: "Northern Mariana Islands" },
      { name: "Norway" },
      { name: "Oman" },
      { name: "Pakistan" },
      { name: "Palau" },
      { name: "Palestinian Territory, Occupied" },
      { name: "Panama" },
      { name: "Papua New Guinea" },
      { name: "Paraguay" },
      { name: "Peru" },
      { name: "Philippines" },
      { name: "Pitcairn" },
      { name: "Poland" },
      { name: "Portugal" },
      { name: "Puerto Rico" },
      { name: "Qatar" },
      { name: "Reunion" },
      { name: "Romania" },
      { name: "Russian Federation" },
      { name: "RWANDA" },
      { name: "Saint Helena" },
      { name: "Saint Kitts and Nevis" },
      { name: "Saint Lucia" },
      { name: "Saint Pierre and Miquelon" },
      { name: "Saint Vincent and the Grenadines" },
      { name: "Samoa" },
      { name: "San Marino" },
      { name: "Sao Tome and Principe" },
      { name: "Saudi Arabia" },
      { name: "Senegal" },
      { name: "Serbia" },
      { name: "Seychelles" },
      { name: "Sierra Leone" },
      { name: "Singapore" },
      { name: "Slovakia" },
      { name: "Slovenia" },
      { name: "Solomon Islands" },
      { name: "Somalia" },
      { name: "South Africa" },
      { name: "South Georgia and the South Sandwich Islands" },
      { name: "Spain" },
      { name: "Sri Lanka" },
      { name: "Sudan" },
      { name: "Suriname" },
      { name: "Svalbard and Jan Mayen" },
      { name: "Swaziland" },
      { name: "Sweden" },
      { name: "Switzerland" },
      { name: "Syrian Arab Republic" },
      { name: "Taiwan, Province of China" },
      { name: "Tajikistan" },
      { name: "Tanzania, United Republic of" },
      { name: "Thailand" },
      { name: "Timor-Leste" },
      { name: "Togo" },
      { name: "Tokelau" },
      { name: "Tonga" },
      { name: "Trinidad and Tobago" },
      { name: "Tunisia" },
      { name: "Turkey" },
      { name: "Turkmenistan" },
      { name: "Turks and Caicos Islands" },
      { name: "Tuvalu" },
      { name: "Uganda" },
      { name: "Ukraine" },
      { name: "United Arab Emirates" },
      { name: "United Kingdom" },
      { name: "United States" },
      { name: "United States Minor Outlying Islands" },
      { name: "Uruguay" },
      { name: "Uzbekistan" },
      { name: "Vanuatu" },
      { name: "Venezuela" },
      { name: "Viet Nam" },
      { name: "Virgin Islands, British" },
      { name: "Virgin Islands, U.S." },
      { name: "Wallis and Futuna" },
      { name: "Western Sahara" },
      { name: "Yemen" },
      { name: "Zambia" },
      { name: "Zimbabwe" }
    ];

    var applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately"
      },
      {
        key: "onClick",
        name: "On Button Click"
      }
    ],
      dataGrid,
      BillingdataGrid;
    $scope.filterRow = {
      visible: true,
      applyFilter: "auto"
    };
    $scope.headerFilter = {
      visible: true
    };

    vm.readonly = false;
    vm.ZoneCC = [];
    vm.ZoneEmail = [];
    vm.uInvoiceEmail = [];
    vm.uInvoiceCC = [];
    vm.UpdateEmail = [];
    vm.roFruitNames = angular.copy(vm.fruitNames);
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      responsive: true,
      destroy: true,
      language: {
        lengthMenu: $rootScope.lengthMenu,
        zeroRecords: $rootScope.zeroRecords,
        info: $rootScope.info,
        infoEmpty: $rootScope.infoEmpty,
        infoFiltered: $rootScope.infoFiltered
      }
    };
    vm.dtOptions2 = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");
        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      lengthMenu: [5, 10, 20, 50, 100],
      stateSave: true,
      destroy: true
    };
    vm.dtOptions3 = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element("body").find("#forms-search");
        if (searchBox.length > 0) {
          searchBox.on("keyup", function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };
    vm.dtOptionspopup = {
      dom:
        '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      pagingType: "simple",
      autoWidth: false,
      responsive: true,
      stateSave: true,
      destroy: true
    };

    vm.dataGridCustomerService = {
      onInitialized: function (e) {
        dataGrid = e.component;
      },
      dataSource: $scope.CustomerServicedatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      selection: {
        mode: "multiple",
        showCheckBoxesMode: "onClick"
      },
      searchPanel: {
        visible: false,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "50",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "sName", caption: "Name" },
        { dataField: "sContactPerson", caption: "Contact Person" },
        //   { dataField: "sBLK", caption: "Blk" },
        //   { dataField: "sUnit", caption: "Unit" },
        { dataField: "sStreetName", caption: "Address" },
        { dataField: "sPostal", caption: "Postal" },
        { dataField: "sEmail", caption: "Email" },
        { dataField: "sMobile", caption: "Mobile to Contact" },
        // {
        //   caption: "View/Edit",
        //   fixed: true,
        //   fixedPosition: "right",
        //   width: 80,
        //   alignment: "center",
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     $("<div />")
        //       .dxButton({
        //         icon: "edit",
        //         onClick: function (e) {
        //           var index = dataGrid.getRowIndexByKey(options.data._id);
        //           $scope.Servicesupdate(e, options.data._id, index);
        //         }
        //       })
        //       .appendTo(container);
        //   }
        // }
      ],
      bindingOptions: {
        dataSource: "CustomerServicedatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          e.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    vm.dataGridCustomerBilling = {
      onInitialized: function (e) {
        BillingdataGrid = e.component;
      },
      dataSource: $scope.CustomerBillingdatas,
      keyExpr: "_id",
      paging: {
        enabled: true,
        pageSize: 10
      },
      editing: {
        allowUpdating: false
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      },
      sorting: {
        mode: "multiple"
      },
      searchPanel: {
        visible: false,
        width: 320,
        placeholder: "Search..."
      },
      columns: [
        {
          caption: "#",
          width: "40",
          cellTemplate: function (cellElement, cellInfo) {
            cellElement.text(
              cellInfo.component.pageIndex() * cellInfo.component.pageSize() +
              cellInfo.row.rowIndex +
              1
            );
          }
        },
        { dataField: "bContactPerson", caption: "Contact Person" },
        //   { dataField: "bBLK", caption: "Blk" },
        { dataField: "bStreetName", caption: "Address" },
        { dataField: "bPostal", caption: "Postal" },
        // { dataField: "bCountry", caption: "Country" },
        { dataField: "bEmail", caption: "Email" },
        { dataField: "bMobile", caption: "Mobile to Contact" },
        // {
        //   caption: "View/Edit",
        //   fixed: true,
        //   fixedPosition: "right",
        //   width: 80,
        //   alignment: "center",
        //   allowSorting: false,
        //   cellTemplate: function (container, options) {
        //     $("<div />")
        //       .dxButton({
        //         icon: "edit",
        //         onClick: function (e) {
        //           var index = BillingdataGrid.getRowIndexByKey(
        //             options.data._id
        //           );
        //           $scope.Billingupdate(e, options.data._id, index);
        //         }
        //       })
        //       .appendTo(container);
        //   }
        // }
      ],
      bindingOptions: {
        dataSource: "CustomerBillingdatas",
        showColumnLines: "true",
        showRowLines: "true",
        showBorders: "true",
        rowAlternationEnabled: "true",
        filterRow: "filterRow",
        headerFilter: "headerFilter"
      },
      onSelectionChanged: function (e) {
        if (e.selectedRowKeys.length > 0) {
          $scope.SelectedIds = [];
          $scope.SelectedIds.push.apply($scope.SelectedIds, e.selectedRowKeys);
          $scope.SAdiv = true;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
          e.element
            .find(
              "tr.dx-row.dx-data-row.dx-row-lines.dx-column-lines.dx-selection"
            )
            .find(".dx-button .dx-icon")
            .css("background-color", "#83878a!important")
            .css("color", "#ffff !important");
        } else {
          $scope.SelectedIds = [];
          $scope.SAdiv = false;
          e.element
            .find(".dx-button .dx-icon")
            .css("background-color", "#ffff!important")
            .css("color", "#83878a !important");
        }
      },
      onEditingStart: function (e) {
        e.cancel = true;
        var index = dataGrid.getRowIndexByKey(e.data._id);
        $scope.Servicesupdate(e, e.data._id, index);
      }
    };
    if (IsAdmin) {
      $scope.Mode = "multiple";
      $scope.showCheckBoxesMode = "always";
    } else {
      $scope.Mode = "none";
      $scope.showCheckBoxesMode = "onClick";
    }

    function AllCustomersview(value) {
      $scope.ViewAllCustomer = value;
      if (value) {
        var Customer = _.sortBy($scope.Alllcustomer, "SortDate");
        $scope.Customerdatas = _.reverse(Customer);
        if ($scope.Customerdatas.length > 0)
          $scope.LastModified = $scope.Customerdatas[0].id;
        else $scope.LastModified = null;
      } else {
        var Filter = _.sortBy($scope.FilteredCustomer, "SortDate");
        $scope.Customerdatas = _.reverse(Filter);
        if ($scope.Customerdatas.length > 0)
          $scope.LastModified = $scope.Customerdatas[0].id;
        else $scope.LastModified = null;
      }
    }
    function getOrderDay(rowData) {
      return new Date(rowData.OrderDate).getDay();
    }

    $mdDateLocale.formatDate = formatDate;
    function formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    }

    $scope.Status = function () {
      if (data) {
      }
    };

    $scope.AddLead = function (e) {
      $mdDialog.show({
        multiple: true,
        templateUrl: "app/main/apps/crm/customer/addlead.html",
        parent: angular.element($document.body),
        targetEvent: e,
        scope: $scope.$new(),
        clickOutsideToClose: false,
        controller: function ACcustomerController($scope, $mdDialog) {
          $scope.closeDialog = function () {
            $mdDialog.hide();
          };
        }
      });
      clear();
      $scope.vm.ppCompanyName = $scope.vm.uCompanyName;
      $scope.vm.ExpectedResponseDate = $scope.vm.ConEndDate;
    };

    function clear() {
      $scope.vm.NatureofJob = "";
      $scope.vm.EnquiryMode = "";
      $scope.vm.ServiceTime = "";
      $scope.vm.SalesPerson = $scope.Emp_Id;
      $scope.vm.Pipelinevalue = 0;
      $scope.vm.EnquiryType = "Ad-hoc";
      $scope.vm.EnquiryDate = new Date();
    }
    $scope.leadSubmit = function () {
      if (
        $scope.vm.MarketSegment != null &&
        $scope.vm.MarketSegment != "" &&
        $scope.vm.MarketSegment != undefined
      ) {
        $scope.vm.MarketSegment = $scope.vm.MarketSegment.map(function (obj) {
          return obj.SegmentName;
        }).join(",");
      }
      if (
        $scope.vm.NatureofJob != null &&
        $scope.vm.NatureofJob != "" &&
        $scope.vm.NatureofJob != undefined
      ) {
        $scope.vm.NatureofJob = $scope.vm.NatureofJob.map(function (obj) {
          return obj.PestName;
        }).join(",");
      }
      if (
        $scope.vm.ppCompanyName != null &&
        $scope.vm.ppCompanyName != "" &&
        $scope.vm.ppCompanyName != undefined
      ) {
        $scope.vm.CustomerID = null;
        try {
          var item = $scope.Customerdatas.filter(function (item) {
            return item.CompanyName == $scope.vm.ppCompanyName;
          })[0];
          $scope.vm.CustomerID = item.id;
        } catch (e) { }
      }
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/lead/add",
        data: {
          EnquiryDate: $scope.vm.EnquiryDate,
          Customer: $scope.vm.ppCompanyName,
          NatureofJob: $scope.vm.NatureofJob,
          EnquiryMode: $scope.vm.EnquiryMode,
          ServiceTime: $scope.vm.ServiceTime,
          SalesPerson: $scope.vm.SalesPerson,
          Pipelinevalue: $scope.vm.Pipelinevalue,
          MarketSegment: $scope.vm.MarketSegment,
          ExpectedResponseDate: $scope.vm.ExpectedResponseDate,
          EnquiryType: $scope.vm.EnquiryType,
          CustomerID: $scope.vm.CustomerID,
          CreatedBy: $rootScope.createdby,
          Client_Id: $rootScope.Client_Id
        }
      });
      response.then(
        function (GList) {
          $scope.GListdata = GList.data.data;
          $scope.vm.LeadId = $scope.GListdata.id;
          $scope.vm.LeadReferenceNo = $scope.GListdata.LeadReferenceNo;
          clear();
          var file = angular.element(document.querySelector("#fileInput"))[0]
            .files;
          if (file.length != 0 && file.length != undefined) {
            var files = [];
            files.push({ file: file[0] });
            $scope.Uploadfiles(files);
          }
          $mdDialog.cancel();
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Successfully Added!")
              .position("top center")
          );
          // $scope.Leadgrid = true;
          // $scope.Leadform = false;
          // $scope.Export = true;
          // $scope.Add = true;
          // $scope.view = false;
          // $scope.Search = true;
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };
    $scope.Uploadfiles = function (file) {
      var upfile = file[0].file;
      var response = Upload.upload({
        url: $rootScope.WebURL + "/lead/upload",
        data: { file: upfile }
      }).then(
        function (resp) {
          $scope.TableID = resp.data.data[0].GUIDFILENAME;
          $scope.fileName = resp.data.data[0].OriginalFileName;
          $scope.fileSize = resp.data.data[0].Size;
          $scope.Path = resp.data.data[0].Path;
          $scope.fileType = resp.data.data[0].Type;
          if (resp.data.message == "Successfully Uploaded") {
            var response = $http({
              method: "POST",
              url: $rootScope.WebURL + "/attachment/add",
              data: {
                TableID: $scope.TableID,
                TableName: "Lead",
                FileID: $scope.vm.LeadReferenceNo,
                FileName: $scope.fileName,
                FileSize: $scope.fileSize,
                FileType: $scope.fileType,
                ModuleID: $scope.Path,
                Data: null,
                IsActive: "true",
                CreatedBy: $rootScope.createdby
              }
            });
            response.then(
              function (GList) {
                $scope.File_id = $scope.vm.LeadReferenceNo;
                //   RefreshGrid();
                //file[0].cancel();
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Successfully Added and redirecting to Leads Page!"
                    )
                    .position("top center")
                );
                $state.go("app.lead");
              },
              function () {
                $mdToast.show(
                  $mdToast
                    .simple()
                    .textContent(
                      "Something entered gone wrong,please try again !"
                    )
                    .position("top center")
                );
              }
            );
          }
        },
        function () {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent("Something entered gone wrong,please try again !")
              .position("top center")
          );
        }
      );
    };

    function getUploadedDocuments(id) {
      $http({
        url: $rootScope.WebURL + "/customer/getAttachment",
        method: "POST",
        data: { _id: id }
      }).then(function (List) {
        $scope.UploadedDocuments = List.data.data;
      });
    }
    $http({
      url: $rootScope.WebURL + "/settings",
      method: "POST",
      data: { Client_Id: $rootScope.Client_Id }
    }).then(function (settingsdata) {
      $scope.Settingsdatas = settingsdata.data.data;
      try {
        var item = $scope.Settingsdatas.filter(function (item) {
          return item.Description === "PaymentMode";
        });
        $scope.PaymentModedatas = item;
      } catch (e) { }
    });

    $scope.$on("customer_created", function (event, customer) {
      $scope.Alllcustomer.push(customer);
      // re-assign and re-render as needed
      updateCustomerLists();
    });

    $scope.$on("customer_modified", function (event, updatedCustomer) {
      const idx = $scope.Alllcustomer.findIndex(function (c) {
        return c.id === updatedCustomer.id;
      });
      if (idx !== -1) {
        $scope.Alllcustomer[idx] = updatedCustomer;
      }
      updateCustomerLists();
    });

    function updateCustomerLists() {
      if (!IsAdmin) {
        const item = $scope.Alllcustomer.filter(function (item) {
          if (item.AssignedUser != null) {
            const eeitem = item.AssignedUser.split(",");
            return _.intersection(eeitem, Emploee).length > 0;
          }
        });
        $scope.Customerdatas = item;
        $scope.FilteredCustomer = item;
        $scope.getCustomerdatas = item;
      } else {
        $scope.Customerdatas = $scope.Alllcustomer;
        $scope.FilteredCustomer = $scope.Alllcustomer;
        $scope.getCustomerdatas = $scope.Alllcustomer;
      }

      $scope.AllCustomersview($scope.ViewAllCustomer);
      angular
        .element("#gridContainer")
        .dxDataGrid("instance")
        .option("dataSource", $scope.Customerdatas);
    }
    $scope.$on("customer_deleted", function () {
      getAllCustomers();
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.accounts.assetmanagement', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_assetmanagement', {
            url: '/assetmanagement',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/assetmanagement/assetmanagement.html',
                    controller: 'assetmanagementController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/assetmanagement');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts.assetmanagement')
        .controller('assetmanagementController', assetmanagementcontroller);

    function assetmanagementcontroller($scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http, $mdDialog, $document, $state, $mdDateLocale, $timeout, $q, $log, $filter) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("Asset")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        $rootScope.LoginID = localStorage.getItem('LoginID');

        var Client_Id = localStorage.getItem('Client_Id');

        var date = new Date();
        var firstDay = new Date(new Date().setDate(new Date().getDate() - 30));
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, date.getDate());
        $scope.uFrom = firstDay;
        $scope.uFrom.setHours(0, 0, 0, 0);
        $scope.uTo = date;
        $scope.uTo.setHours(23, 59, 59, 999);

        $scope.AssetRegisterSelect = true;
        $scope.AssetDisposalSelect = false;
        $scope.AssetDepreciationSelect = false;

        $scope.AssetRegisteradd = function (e) {

            ClearAssetRegister();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/assetmanagement/assetregister.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function assetmanagementcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        $scope.SaveAssetRegister = function () {
            debugger
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/assetregister/update",
                    data: {
                        _id: $scope.AssetRegisterID, ReferenceNumber: $scope.vm.ReferenceNumber, Description: $scope.vm.Description, PurchaseOrderID: $scope.vm.PurchaseOrderID,
                        SerialNumber: $scope.vm.SerialNumber, Brand: $scope.vm.Brand, ReceivedBy: $scope.vm.ReceivedBy, ReceivedDate: $scope.vm.ReceivedDate,
                        ProductID: $scope.vm.ProductID, PurchaseDate: $scope.vm.PurchaseDate, Location: $scope.vm.Location, Remarks: $scope.vm.Remarks,
                        UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshAssetRegister();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/assetregister/add",
                    data: {
                        ReferenceNumber: $scope.vm.ReferenceNumber, Description: $scope.vm.Description, PurchaseOrderID: $scope.vm.PurchaseOrderID,
                        SerialNumber: $scope.vm.SerialNumber, Brand: $scope.vm.Brand, ReceivedBy: $scope.vm.ReceivedBy, ReceivedDate: $scope.vm.ReceivedDate,
                        ProductID: $scope.vm.ProductID, PurchaseDate: $scope.vm.PurchaseDate, Location: $scope.vm.Location, Remarks: $scope.vm.Remarks,
                        CreatedBy: $rootScope.LoginID, Client_Id: Client_Id
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshAssetRegister();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.AssetRegisterinfo = function (e, AssetRegisterID) {
            debugger
            $scope.AssetRegisterID = AssetRegisterID;
            $scope.Update = true;
            angular.forEach($scope.AssetRegisterdatas, function (value, key) {
                if (AssetRegisterID == value._id) {
                    $scope.vm.ReferenceNumber = value.ReferenceNumber;
                    $scope.vm.Description = value.Description;
                    $scope.vm.ProductID = value.ProductID;
                    $scope.vm.PurchaseOrderID = value.PurchaseOrderID;
                    $scope.vm.SerialNumber = value.SerialNumber;
                    $scope.vm.ReceivedDate = value.ReceivedDate;
                    if ($scope.vm.ReceivedDate != null && $scope.vm.ReceivedDate != "") {
                        $scope.vm.ReceivedDate = new Date(value.ReceivedDate);
                    }
                    $scope.vm.ReceivedBy = value.ReceivedBy;
                    $scope.vm.Brand = value.Brand;
                    $scope.vm.PurchaseDate = value.PurchaseDate;
                    if ($scope.vm.PurchaseDate != null && $scope.vm.PurchaseDate != "") {
                        $scope.vm.PurchaseDate = new Date(value.PurchaseDate);
                    }
                    $scope.vm.Location = value.Location;
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/assetmanagement/assetregister.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function assetmanagementcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }

        RefreshAssetRegister();

        function RefreshAssetRegister() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetregister",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                var item = $scope.AssetRegisterdatas.filter(function (item) {
                    return item.IsDisposed === false;
                });
                $scope.AssetDepreciationdatas = item;
            });


        }
        $scope.AssetRegisterFilter = function () {
            $scope.AssetRegisterdatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/assetregister/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (AssetRegisterdata) {
                $scope.AssetRegisterdatas = AssetRegisterdata.data.data;

                var item = $scope.AssetRegisterdatas.filter(function (item) {
                    return item.IsDisposed === false;
                });
                $scope.AssetDepreciationdatas = item;
            });
        }

        function ClearAssetRegister() {

            var AR = "AST-";
            var info = $scope.AssetRegisterdatas.length + 1;
            var y = pad(info, 5);
            $scope.vm.ReferenceNumber = AR + y;
            $scope.vm.ProductID = null;
            $scope.vm.PurchaseOrderID = null;
            $scope.vm.Description = null;
            $scope.vm.SerialNumber = null;
            $scope.vm.Brand = null;
            $scope.vm.PurchaseDate = null;
            $scope.vm.Location = null;
            $scope.vm.ReceivedDate = null;
            $scope.vm.ReceivedBy = null;
            $scope.vm.Remarks = null;
        }

        $scope.AssetDisposaladd = function (e) {

            RefreshAssetRegister();
            ClearAssetDisposal();
            $scope.Update = false;
            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/assetmanagement/disposal.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function assetmanagementcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.SaveAssetDisposal = function () {
            debugger
            if ($scope.Update == true) {

                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/assetdisposal/update",
                    data: {
                        _id: $scope.AssetDisposalID, AssetID: $scope.vm.AssetID, AssetValue: $scope.vm.AssetValue, DisposalReason: $scope.vm.DisposalReason,
                        DisposalDate: $scope.vm.DisposalDate, Item: $scope.vm.Item, Remarks: $scope.vm.Remarks, UpdatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshAssetDisposal();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/assetdisposal/add",
                    data: {
                        AssetID: $scope.vm.AssetID, AssetValue: $scope.vm.AssetValue, DisposalReason: $scope.vm.DisposalReason, Client_Id: Client_Id,
                        DisposalDate: $scope.vm.DisposalDate, Item: $scope.vm.Item, Remarks: $scope.vm.Remarks, CreatedBy: $rootScope.LoginID
                    },
                });

                response.then(function (GList) {
                    debugger
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshAssetDisposal();
                    $mdDialog.hide();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.AssetDisposalinfo = function (e, AssetDisposalID) {

            $scope.AssetDisposalID = AssetDisposalID;
            $scope.Update = true;
            angular.forEach($scope.AssetDisposaldatas, function (value, key) {
                if (AssetDisposalID == value._id) {
                    $scope.vm.AssetID = value.AssetID;
                    $scope.vm.Item = value.Item;;
                    $scope.vm.AssetValue = parseInt(value.AssetValue);
                    $scope.vm.DisposalReason = value.DisposalReason;
                    $scope.vm.DisposalDate = value.DisposalDate;
                    if ($scope.vm.DisposalDate != null && $scope.vm.DisposalDate != "") {
                        $scope.vm.DisposalDate = new Date(value.DisposalDate);
                    }
                    $scope.vm.Remarks = value.Remarks;
                }
            });

            $mdDialog.show({
                templateUrl: 'app/main/apps/accounts/assetmanagement/disposal.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function assetmanagementcontroller($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });

        }


        RefreshAssetDisposal();
        function RefreshAssetDisposal() {

            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/assetdisposal",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;
            });
        }

        $scope.AssetDisposalFilter = function () {
            $scope.AssetDisposaldatas = undefined;
            var response = $http({
                url: $rootScope.WebURL + "/assetdisposal/datefilter",
                method: "POST",
                data: { Start_Date: $scope.uFrom, End_Date: $scope.uTo, Client_Id: Client_Id },
            });
            response.then(function (AssetDisposaldata) {
                $scope.AssetDisposaldatas = AssetDisposaldata.data.data;
            });
        }

        function ClearAssetDisposal() {
            $scope.vm.AssetID = null;
            $scope.vm.Item = null;
            $scope.vm.AssetValue = null;
            $scope.vm.DisposalReason = null;
            $scope.vm.DisposalDate = null;
            $scope.vm.Remarks = null;
        }

        $scope.AssetIDclear = function () {
            debugger
            $scope.vm.AssetID = "";
            $scope.vm.Item = "";
        };

        $scope.OnAssetTagChange = function () {
            debugger
            var myArray = $scope.AssetRegisterdatas;
            var item = myArray.filter(function (item) {
                return item._id === $scope.vm.AssetID;
            })[0];
            $scope.vm.Item = item.Productdetails[0].ProductCode;
        };

        $scope.closeDialog = function () {
            $mdDialog.cancel();
        };

        RefreshGridpurchaseorder();

        function RefreshGridpurchaseorder() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/purchaseorder",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Purchaseorderdata) {
                $scope.Purchaseorderdatas = Purchaseorderdata.data.data;
            });
        }

        RefreshProductGrid();

        function RefreshProductGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/product",
                data: {
                    Client_Id: Client_Id
                },
            });
            response.then(function (Productdata) {
                $scope.Productdatas = Productdata.data.data;
            });
        }

        $scope.AssetRegisterExport = function () {
            alasql('SELECT * INTO XLSX("AssetRegister.xlsx",{headers:true}) FROM ?', [$scope.AssetRegisterdatas]);
        };

        $scope.AssetDisposalExport = function () {
            alasql('SELECT * INTO XLSX("AssetDisposal.xlsx",{headers:true}) FROM ?', [$scope.AssetDisposaldatas]);
        };

        $scope.AssetDepreciationExport = function () {
            alasql('SELECT * INTO XLSX("AssetDepreciation.xlsx",{headers:true}) FROM ?', [$scope.AssetDepreciationdatas]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {

                var api = this.api(),
                    searchBox = angular.element('body').find('#search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            lengthMenu: [10, 20, 30, 50, 100],
            retrieve: true,
            stateSave: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $scope.AssetRegisterTab = function () {
            $scope.AssetRegisterSelect = true;
            $scope.AssetDisposalSelect = false;
            $scope.AssetDepreciationSelect = false;
            $scope.SearchValue = "";
            RefreshAssetDisposal();
            RefreshAssetRegister();
        };

        $scope.AssetDisposalTab = function () {
            $scope.AssetRegisterSelect = false;
            $scope.AssetDisposalSelect = true;
            $scope.AssetDepreciationSelect = false;
            $scope.SearchValue = "";
            RefreshAssetDisposal();
            RefreshAssetRegister();
        };

        $scope.AssetDepreciationTab = function () {
            $scope.AssetRegisterSelect = false;
            $scope.AssetDisposalSelect = false;
            $scope.AssetDepreciationSelect = true;
            $scope.SearchValue = "";
            RefreshAssetDisposal();
            RefreshAssetRegister();
        };
        $scope.TRCdiv = false;
        $scope.SelectedIds = [];
        $scope.CheckAll = function (IsTicked) {
            if (IsTicked == true) {
                $scope.TRCdiv = true;
                angular.forEach($scope.AssetDepreciationdatas, function (value) {
                    if ($scope.SelectedIds.indexOf(value._id) == -1) { $scope.SelectedIds.push(value._id) }
                })
                $scope.Selec = { value: true }
            }
            if (IsTicked == false) {
                $scope.TRCdiv = false;
                $scope.SelectedIds = [];
                $scope.Selec = { value: false }
            }
        }
        $scope.Check = function (TrF, Ids) {
            if (TrF == true) {
                $scope.TRCdiv = true;
                if ($scope.SelectedIds.indexOf(Ids) == -1) { $scope.SelectedIds.push(Ids) }
            }
            if (TrF == false) {
                $scope.TRCdiv = false;
                var index = $scope.SelectedIds.indexOf(Ids);
                if (index > -1) {
                    $scope.SelectedIds.splice(index, 1);
                }
            }
            if ($scope.SelectedIds.length > 0) {
                $scope.TRCdiv = true;
            }
        }

        $scope.ViewDepreciationHistory = function (e, value) {
            $scope.deatilgrid = [];
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/assetmanagement/Depreciationhistory.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.deatilgrid = value;
        }

        $scope.Depreciation = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/apps/accounts/assetmanagement/Depreciation.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),

                controller: function operationsProjectController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            $scope.vm.Title = 'Calculate Depreciation';
            $scope.vm.DepreciationMethod = undefined;
            $scope.vm.DepreciationValue = undefined;
            $scope.vm.DepreciationStartDate = undefined;
            $scope.vm.DepreciationEndDate = undefined;
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.SubmitDepreciation = function () {

            angular.forEach($scope.SelectedIds, function (value) {
                $scope.itemDetails = [];
                $scope.AssetID = value;
                var PurchaseCost = 0; var OldValue = 0; var CurrentValue = 0;

                var item = $scope.AssetDepreciationdatas.filter(function (item) {
                    return item._id === value;
                })[0];
                try {
                    PurchaseCost = item.PurchaseOrderdetails[0].Total;
                    OldValue = item.CurrentValue;

                } catch (error) {

                }
                if (OldValue == 0 || OldValue == null || OldValue == undefined) {

                    CurrentValue = parseFloat(PurchaseCost) - ((parseFloat(PurchaseCost) / 100) * ($scope.vm.DepreciationValue));
                }
                else {

                    CurrentValue = parseFloat(OldValue) - ((parseFloat(OldValue) / 100) * ($scope.vm.DepreciationValue));
                }

                $scope.itemDetails.push({
                    "DepreciationMethod": $scope.vm.DepreciationMethod,
                    "DepreciationValue": $scope.vm.DepreciationValue,
                    "DepreciationStartDate": $scope.vm.DepreciationStartDate,
                    "DepreciationEndDate": $scope.vm.DepreciationEndDate,
                    "PurchaseCost": PurchaseCost,
                    "CurrentValue": CurrentValue
                })

                var response = $http({
                    url: $rootScope.WebURL + "/assetregister/depreciation",
                    method: "POST",
                    data: {
                        AssetID: $scope.AssetID,
                        CurrentValue: CurrentValue,
                        itemDetails: $scope.itemDetails,
                        UpdatedBy: $rootScope.createdby
                    },
                });
                response.then(function (AssetDisposaldata) {
                    RefreshAssetRegister();
                    $mdDialog.cancel();
                });
            })
        }

        $scope.getYearsActive = function (date) {
            var bthDate, curDate, ageYears, ageMonths, ageWeeks, ageDays, ageText;
            bthDate = new Date(date); // Change the birth date here!
            curDate = new Date();
            if (bthDate > curDate) return;
            ageYears = curDate.getFullYear() - bthDate.getFullYear();
            ageMonths = curDate.getMonth() - bthDate.getMonth();
            ageDays = curDate.getDate() - bthDate.getDate();
            if (ageDays < 0) {
                ageMonths = ageMonths - 1;
                ageDays = ageDays + 31;
            }
            ageWeeks = Math.ceil(ageDays / 7);
            if (ageMonths < 0) {
                ageYears = ageYears - 1;
                ageMonths = ageMonths + 12;
            }
            ageText = "";
            if (ageYears > 0) {
                ageText = ageText + ageYears + " year";
                if (ageYears > 1) ageText = ageText + "s";
            }
            if (ageMonths > 0) {
                if (ageYears > 0) {
                    if (ageWeeks > 0) ageText = ageText + ", ";
                    else if (ageWeeks == 0) ageText = ageText + " and ";
                }
                ageText = ageText + ageMonths + " month";
                if (ageMonths > 1) ageText = ageText + "s";
            }
            if (ageWeeks > 0) {
                if ((ageYears > 0) || (ageMonths > 0)) ageText = ageText + " and ";
                ageText = ageText + ageWeeks + " week";
                if (ageWeeks > 1) ageText = ageText + "s";
            }

            return ageText;
        }

        $scope.Today = function () {
            var today = new Date();
            var end = new Date();
            $scope.uFrom = today;
            $scope.uFrom.setHours(0, 0, 0, 0);
            $scope.uTo = end;
            $scope.uTo.setHours(23, 59, 59, 999);
            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;

            $scope.AssetRegisterFilter();
            $scope.AssetDisposalFilter();
        }

        $scope.lastweek = function () {
            var d = new Date();
            var to = d.setTime(d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000);
            var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
            $scope.AssetRegisterFilter();
            $scope.AssetDisposalFilter();
        }

        $scope.NextWeek = function () {
            var d = new Date();
            var dayIndex = [1];
            var from = d.setDate(d.getDate() + (dayIndex - 1 - d.getDay() + 7) % 7 + 1);
            var to = d.setTime(d.getTime() + 6 * 24 * 60 * 60 * 1000);
            from = $filter('date')(from);
            to = $filter('date')(to);
            $scope.uFrom = from;
            $scope.uTo = to;

            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
            $scope.AssetRegisterFilter();
            $scope.AssetDisposalFilter();

        }

        $scope.NextMonth = function () {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
            firstDay = $filter('date')(firstDay);
            lastDay = $filter('date')(lastDay);
            $scope.uFrom = firstDay;
            $scope.uTo = lastDay;

            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
            $scope.AssetRegisterFilter();
            $scope.AssetDisposalFilter();
        }

        $scope.lastmonth = function () {
            var now = new Date();
            var nowDayOfWeek = now.getDay();
            var nowDay = now.getDate();
            var nowMonth = now.getMonth();
            var nowYear = now.getFullYear();
            var lastMonthDate = new Date();
            lastMonthDate.setDate(1);
            lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
            var lastYear = lastMonthDate.getFullYear();
            var lastMonth = lastMonthDate.getMonth();
            var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
            var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
            lastMonthStartDate = $filter('date')(lastMonthStartDate);
            lastMonthEndDate = $filter('date')(lastMonthEndDate);
            $scope.uFrom = lastMonthStartDate;
            $scope.uTo = lastMonthEndDate;

            $scope.vm.uFrom = $scope.uFrom;
            $scope.vm.uTo = $scope.uTo;
            $scope.AssetRegisterFilter();
            $scope.AssetDisposalFilter();
        }

        function getMonthDays(myMonth) {
            var now = new Date();
            var nowYear = now.getFullYear();
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        }

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }

})();





(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            }
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }
            
else{
           return 
    }
}
})();
(function () {
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($scope, $rootScope, $interval, $mdToast, $mdSidenav, $http) {
        debugger

        function convertDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            if (d == 'Thu Jan 01 1970 05:30:00 GMT+0530 (India Standard Time)') {
                return null;
            }
            else {
                return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
            }
        }


        $rootScope.Roles = localStorage.getItem('RoleName');
        $rootScope.UserName = localStorage.getItem('UserName');
        $rootScope.UserID = localStorage.getItem('LoginID');
        var Client_Id = localStorage.getItem('Client_Id');

        RefreshEmployeeGrid();

        function RefreshEmployeeGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/employee",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        }

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });
        $http.get($rootScope.WebURL + "/userrole")
            .then(function (Userroledata) {
                $scope.Userroledatas = Userroledata.data.data;
            });

        $http.get($rootScope.WebURL + "/role")
            .then(function (Roledata) {
                $scope.Roledatas = Roledata.data.data;
            });
        $http.get($rootScope.WebURL + "/client")
            .then(function (Clientdata) {
                $scope.Clientdatas = Clientdata.data.data;
            });
        //$http.get( $rootScope.WebURL + "/employee")
        //.then(function (Employeedata) {
        //    debugger
        //    $scope.Employeedatas = Employeedata.data.data;
        //});
        $http.get($rootScope.WebURL + "/login/usersession")
            .then(function (Usersessiondata) {
                $scope.Usersessiondatas = Usersessiondata.data.data;
                profile();
            });


        function profile() {
            debugger

            $scope.LoginID = localStorage.getItem('LoginID');

            var info = $scope.Userdatas;
            var userroleinfo = $scope.Userroledatas;
            var rolerinfo = $scope.Roledatas;
            var sessioninfo = $scope.Usersessiondatas;
            var clientinfo = $scope.Clientdatas;
            var Employeeinfo = $scope.Employeedatas;

            var Roleselect = [];
            var st = '';

            for (var i = 0; i < info.length; i++) {
                if ($scope.LoginID == info[i].UserID) {
                    $scope.UserID = info[i].UserID;
                    $scope.ClientID = info[i].ClientID;
                    $scope.UserName = info[i].UserName;
                    $scope.Roles = info[i].Roles;
                    $scope.Email = info[i].Email;
                    $scope.ExpiryDate = convertDate(info[i].ExpiryDate);
                    $scope.CreatedDate = info[i].CreatedDate;
                    $scope.UpdatedDate = convertDate(info[i].UpdatedDate);
                    $scope.UserRoleID = info[i].id;
                    $scope.EmployeeID = info[i].EmployeeID;
                }
            }

            for (var u = 0; u < userroleinfo.length; u++) {
                for (var r = 0; r < rolerinfo.length; r++) {
                    if ($scope.UserRoleID == userroleinfo[u].UserID && userroleinfo[u].RoleID == rolerinfo[r].RoleID) {
                        Roleselect.push({
                            RoleName: rolerinfo[r].RoleName,
                            RoleID: rolerinfo[r].RoleID,
                        })
                    }
                }
            }
            st = Roleselect.map(function (obj) { return obj.RoleName; }).join(', ');
            $scope.Role = st;

            for (var e = 0; e < clientinfo.length; e++) {
                if ($scope.ClientID == clientinfo[e].id) {
                    $scope.ClientName = clientinfo[e].ClientName;
                }
            }

            for (var d = 0; d < sessioninfo.length; d++) {
                if ($scope.LoginID == sessioninfo[d].UserID) {
                    $scope.SessionEndDate = sessioninfo[d].SessionEndDate;
                }
            }

            for (var r = 0; r < Employeeinfo.length; r++) {
                if ($scope.EmployeeID == Employeeinfo[r].EmployeeID) {
                    $scope.Data = decode_base64(Employeeinfo[r].Photo);
                }
            }

            //angular.forEach($scope.Userdatas, function (value) {
            //    if ($scope.LoginID == value.UserID) {
            //        $scope.SID = value.id;
            //        $scope.UserID = value.UserID;
            //        $scope.ClientID = value.ClientID;
            //        $scope.UserName = value.UserName;
            //        //$scope.Roles = value.Roles;
            //        $scope.Email = value.Email;
            //        $scope.ExpiryDate = convertDate(value.ExpiryDate);
            //        $scope.CreatedDate = convertDate(value.CreatedDate);
            //        $scope.UpdatedDate = convertDate(value.UpdatedDate);
            //        $scope.UserRoleID = value.id;
            //        $scope.EmployeeID = value.EmployeeID;
            //        $scope.ProfilePicture = decode_base64(value.ProfilePicture);
            //    }
            //});
            //angular.forEach($scope.Clientdatas, function (value1) {
            //    if ($scope.ClientID == value1.id) {
            //        $scope.ClientName = value1.ClientName;
            //    }
            //});
            //angular.forEach($scope.Usersessiondatas, function (value2) {
            //    if ($scope.LoginID == value2.UserID) {
            //        $scope.SessionEndDate = convertDate(value2.SessionEndDate);
            //    }
            //});
            //angular.forEach($scope.Employeedatas, function (value3) {
            //    if ($scope.EmployeeID == value3.EmployeeID) {
            //        $scope.Data = decode_base64(value3.Photo);
            //    }
            //});

            //var Roleselect = [];
            //var st = '';
            //angular.forEach($scope.Userroledatas, function (value4) {
            //    angular.forEach($scope.Roledatas, function (value5) {
            //        if ($scope.UserRoleID == value4.UserID && value4.RoleID == value5.RoleID) {
            //            Roleselect.push({
            //                RoleName: value5.RoleName,
            //                RoleID: value5.RoleID,
            //            })
            //        }
            //    });
            //});
            //var RData = Roleselect;
            //st = RData.map(function (obj) { return obj.RoleName; }).join(', ');
            //$scope.Role = st;   

        }

        function decode_base64(str) {
            return decodeURIComponent(escape(window.atob(str)));
        }

        var vm = this;

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/NoAccess',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');
        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 6
        });
    }
else {
            return
    }
}
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController(indexedDBService,$window)
    {
        // Data

        // Methods
        var vm = this

        //////////
         if (localStorage.getItem("logo_url")) {
      var logo_string = indexedDBService.decryptString(
        localStorage.getItem("logo_url")
      );
      vm.logo = logo_string;
    }
        
    vm.goPreviousPage = function() {
        $window.history.back();
    };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.interview', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_interview', {
            url: '/pages/interview',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/interview/interview.html',
                    controller: 'InterviewController as vm'
                }
            },
            resolve  : {
                Invoice: function (apiResolver)
                {
                    return apiResolver.resolve('invoice@get');
                }
            },
            bodyClass: 'invoice'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/interview');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.interview', {
            title: 'Interview',
            icon  : 'icon-receipt',
            state: 'app.pages_interview',
            weight: 4
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.interview')
        .controller('InterviewController', InterviewController);

    /** @ngInject */
    function InterviewController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, Invoice) {


        $http.get($rootScope.WebURL + "/employee")
            .then(function (Employeedata) {

                $scope.Employeedatas = Employeedata.data.data;
            });

        //$scope.printToCart = function (invoice) {
        //    var innerContents = document.getElementById(invoice).innerHTML;
        //    var popupWindow = window.open('', '_blank', 'width=1500,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        //    popupWindow.document.open();
        //    popupWindow.document.write('<html><body onload="window.print()">' + innerContents + '</html>');
        //    popupWindow.document.close();
        //}


        //$scope.printToCart = function (invoice) {
        //}





        $scope.printToCart = function (invoice) {
            var printButton = document.getElementById("printpagebutton");
            printButton.style.visibility = 'hidden';
            window.focus(invoice);
            window.print(invoice);
            printButton.style.visibility = 'visible';
        };




        //$scope.printToCart = function (invoice) {
        //    var docHead = document.head.outerHTML;
        //    var printContents = document.getElementById(invoice).outerHTML;
        //    var winAttr = "location=yes, statusbar=no, menubar=no, titlebar=no, toolbar=no,dependent=no, width=865, height=600, resizable=yes, screenX=200, screenY=200, personalbar=no, scrollbars=yes";
        //    var newWin = window.open("", "_blank", winAttr);
        //    var writeDoc = newWin.document;
        //    writeDoc.open();
        //    writeDoc.write('<!doctype html><html>' + docHead + '<body onLoad="window.print()">' + printContents + '</body></html>');
        //    writeDoc.close();
        //    newWin.focus();
        //}



        //$scope.printToCart = function (invoice) {
        //var printButton = document.getElementById("printpagebutton");
        //printButton.style.visibility = 'hidden';
        //window.print(invoice);
        //printButton.style.visibility = 'visible';
        //};

        var vm = this;

        vm.invoice = Invoice.data;

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.pages_form_exit', {
                url: '/ExitInterview',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/form/views/exit/exit.html',
                        controller: 'FormController as vm'
                    }
                },
                resolve: {
                    Invoice: function (msApi) {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })

            .state('app.pages_form_resign', {
                url: '/ResignationForm',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/form/views/resign/resign.html',
                        controller: 'FormController as vm'
                    }
                },
                resolve: {
                    Invoice: function (msApi) {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/form');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages.form', {
            title : 'Forms',
            icon  : 'icon-receipt',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('pages.form.exit', {
            title: 'Exit Interview',
            state: 'app.pages_form_exit'
        });

        msNavigationServiceProvider.saveItem('pages.form.resign', {
            title : 'Resignation Form',
            state: 'app.pages_form_resign'
        });
        
    }

        else {
            return
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.form')
        .controller('FormController', FormController);

    /** @ngInject */
    function FormController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $http, $window, $state, $mdDialog, $document, Invoice) {
        var chkAceses = localStorage.getItem('pages');
        if (chkAceses.split(",").includes("HRMCore")) {   // do nothing 
        }
        else { $location.path("NoAccess"); }

        var EIdatas = JSON.parse(localStorage.getItem('idForExitInterview'));
        if (EIdatas != null && EIdatas != "" && EIdatas != undefined && EIdatas != "null") {
            $scope.Employee_id = EIdatas.Employee_id;
            $scope.ResignationStatus = EIdatas.ResignationStatus;
            $scope.RuResignationofDate = EIdatas.RuResignationofDate;
            $scope.RuReason = EIdatas.RuReason;
            $scope.RuOtherReason = EIdatas.RuOtherReason;
            $scope.vm.RuRemarks = EIdatas.RuRemarks;
        }
        $scope.Update = false;
        function init() {
            var item = $scope.Userdatas.filter(function (item) {
                return item;
            })[0];
            $scope.vm.SenderEmailAddress = item.Email;
            $scope.vm.UserName = item.UserName;
            var temitem = $scope.Exitinterviewdatas.filter(function (temitem) {
                return temitem.TemplateID != null && temitem.TemplateID != '' && temitem.TemplateID != undefined;
            });
            $scope.templatedatas = temitem;
            var eitem = $scope.Exitinterviewdatas.filter(function (eitem) {
                if (eitem.Employee_id != null && eitem.Employee_id != '' && eitem.Employee_id != undefined) {
                    return eitem.Employee_id === $scope.Employee_id;
                }
            })[0];
            if (eitem != null && eitem != undefined && eitem != "") {
                $scope._id = eitem.id;
                $scope.EI1 = eitem.EI1;
                $scope.EI2 = eitem.EI2;
                $scope.EI3 = eitem.EI3;
                $scope.EI4 = eitem.EI4;
                $scope.EI5 = eitem.EI5;
                $scope.ResignationStatus = eitem.ResignationStatus;
                $scope.Remarks = eitem.Remarks;
                $scope.InterviewerComment = eitem.InterviewerComment;
                $scope.EmployeeComment = eitem.EmployeeComment;
                $scope.Header = eitem.Header;
                $scope.RuReason = eitem.Reason;
            }
            angular.forEach($scope.Employeedatas, function (evalue) {
                if ($scope.Employee_id == evalue.id) {
                    $scope.EmployeeName = evalue.EmployeeName;
                    $scope.vm.uEmployeeID = evalue.EmployeeID;
                    $scope.vm.uSalutation = evalue.Salutation;
                    $scope.vm.uEmployeeName = evalue.EmployeeName;
                    $scope.vm.uGender = evalue.Gender;
                    $scope.vm.uMaritalStatus = evalue.MaritalStatus;
                    $scope.vm.uCitizenship = evalue.Citizenship;
                    $scope.vm.uRace = evalue.Race;
                    $scope.vm.uVisaType = evalue.VisaType;
                    $scope.vm.uPlaceofBirth = evalue.PlaceofBirth;
                    $scope.vm.uDateofBirth = evalue.DateofBirth;
                    $scope.vm.uDrivinglicense = evalue.Drivinglicense;
                    $scope.vm.uDrivingLicenseExpiryDate = evalue.DrivingLicenseExpiryDate;
                    $scope.vm.uNRICNumber = evalue.NRICNumber;
                    $scope.vm.uNRICIssuedDate = evalue.NRICIssuedDate;
                    $scope.vm.uNRICExpiryDate = evalue.NRICExpiryDate;
                    $scope.vm.uWorkPermitNumber = evalue.WorkPermitNumber;
                    $scope.vm.uPassportNo = evalue.PassportNo;
                    $scope.vm.uPassportIssuedPlace = evalue.PassportIssuedPlace;
                    $scope.vm.uPassportIssuedDate = evalue.PassportIssuedDate;
                    $scope.vm.uWorkPassExpiryDate = evalue.WorkPassExpiryDate;
                    $scope.vm.CuResidentialAddress = evalue.ResidentialAddress;
                    $scope.vm.CuUnitBuilding = evalue.UnitBuilding;
                    $scope.vm.CuPostal = parseInt(evalue.Postal);
                    $scope.vm.CuCountry = evalue.Country;
                    $scope.vm.CuHomeTel = parseInt(evalue.HomeTel);
                    $scope.vm.CuMobile = parseInt(evalue.Mobile);
                    $scope.vm.CuEmail = evalue.Email;
                    $scope.vm.uPermanentResidentialAddress = evalue.PermanentResidentialAddress;
                    $scope.vm.CuOUnitBuilding = evalue.OUnitBuilding;
                    $scope.vm.CuOPostalZip = parseInt(evalue.OPostalZip);
                    $scope.vm.CuOCountry = evalue.OCountry;
                    $scope.vm.CuOContactNo = parseInt(evalue.OContactNo);
                    $scope.vm.EuDesignation = evalue.EDesignation;
                    $scope.vm.EuCostCenter = evalue.ECostCenter;
                    $scope.vm.EuDivision = evalue.EDivision;
                    $scope.vm.EuJobCategory = evalue.EJobCategory;
                    $scope.vm.EuTeam = evalue.ETeam;

                    $scope.vm.EuEmploymentStatus = evalue.EEmploymentStatus;
                    $scope.vm.EuSupervisor = evalue.ESupervisor;
                    $scope.vm.EuHOD = evalue.EHOD;
                    $scope.vm.EuPeer = evalue.EPeer;
                    $scope.vm.EuProbationStartDate = evalue.EProbationStartDate;
                    $scope.vm.EuProbationCompletionDate = evalue.EProbationCompletionDate;
                    $scope.vm.EuDateOfJoin = evalue.EDateOfJoin;
                    $scope.vm.uSkill = evalue.Skill;
                    $scope.vm.QLicenceName = evalue.QLicenceName;
                    $scope.vm.QLicenceStartDate = evalue.QLicenceStartDate;
                    $scope.vm.QLicenceEndDate = evalue.QLicenceEndDate;
                    $scope.vm.uLanguageSpoken = evalue.LanguageSpoken;
                    $scope.vm.uLanguageWritten = evalue.LanguageWritten;
                    $scope.vm.uName = evalue.Name;
                    $scope.vm.NRelationship = evalue.NRelationship;
                    $scope.vm.NHomeTel = parseInt(evalue.NHomeTel);
                    $scope.vm.NOfficeTel = parseInt(evalue.NOfficeTel);
                    $scope.vm.NMobile = parseInt(evalue.NMobile);
                    $scope.vm.NEmail = evalue.NEmail;
                    $scope.vm.uLiability = evalue.Liability;
                    $scope.vm.uNSType = evalue.NSType;
                    $scope.vm.uVocation = evalue.Vocation;
                    $scope.vm.uUnitAttachedTo = evalue.UnitAttachedTo;
                    $scope.vm.uCurrentNSStatus = evalue.rrentNSStatus;
                    $scope.vm.uHighestRankAttained = evalue.HighestRankAttained;
                    $scope.vm.uEnlistmentDate = evalue.EnlistmentDate;
                    $scope.vm.uORDDate = evalue.ORDDate;
                    $scope.vm.uNextReservistDate = evalue.NextReservistDate;
                    $scope.vm.uYearofAward = parseInt(evalue.YearofAward);
                    $scope.vm.uDescription = evalue.Description;
                    $scope.vm.uValueofAward = evalue.ValueofAward;
                    $scope.vm.uStartDateofBond = evalue.StartDateofBond;
                    $scope.vm.uEndDateofBond = evalue.EndDateofBond;
                    $scope.vm.uHobbies = evalue.Hobbies;
                    $scope.vm.uWorkWeekCode = evalue.WorkWeekCode;
                    $scope.vm.uWorkWeekDescription = evalue.WorkWeekDescription;
                    $scope.vm.Annual = parseInt(evalue.Annual);
                    $scope.vm.Adoption = parseInt(evalue.Adoption);
                    $scope.vm.ChildCare = parseInt(evalue.ChildCare);
                    $scope.vm.Maternity = parseInt(evalue.Maternity);
                    $scope.vm.Paternity = parseInt(evalue.Paternity);
                    $scope.vm.Sharedparentalleave = parseInt(evalue.Sharedparentalleave);
                    $scope.vm.SickHospitalisation = parseInt(evalue.SickHospitalisation);
                    $scope.vm.SickNonHospitalisation = parseInt(evalue.SickNonHospitalisation);
                    $scope.vm.UnpaidLeavr = parseInt(evalue.UnpaidLeavr);
                    $scope.vm.RuResignationofDate = evalue.RResignationofDate;
                    $scope.vm.RuReason = evalue.RReason;
                    $scope.vm.RuOtherReason = evalue.ROtherReason;
                    $scope.vm.RuRemarks = evalue.RRemarks;

                    $scope.Photo = evalue.Photo;
                    $scope.ICFront = evalue.ICFront;
                    $scope.ICBack = evalue.ICBack;
                    $scope.PassportFront = evalue.PassportFront;
                    $scope.PassportBack = evalue.PassportBack;
                }
            })
        }
        $scope.EISave = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/exitinterview/email",
                data: {
                    SenderEmailAddress: $scope.vm.SenderEmailAddress,
                    EmployeeName: $scope.EmployeeName,
                    EmployeeID: $scope.vm.uEmployeeID,
                    ResignedDate: $scope.RuResignationofDate,
                    Reason: $scope.RuReason,
                    CreatedBy: $rootScope.createdby,
                },
            });

            if ($scope.Update == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/exitinterview/update",
                    data: {
                        _id: $scope.SID,
                        CP_id: $scope.CP_id,
                        Name: $scope.Name,
                        From: $scope.From,
                        To: $scope.To,
                        Status: 'Completed',
                        UpdatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    $window.localStorage.setItem('idForCertification', "");
                    $state.go('app.human-resource_training_administration');
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/exitinterview/add",
                    data: {
                        Employee_id: $scope.Employee_id,
                        Rehire: $scope.Rehire,
                        Reason: $scope.vm.RuReason,
                        EmployeeComment: $scope.EmployeeComment,
                        EI1: $scope.EI1,
                        EI2: $scope.EI2,
                        TerminationDate: $scope.RuResignationofDate,
                        EI3: $scope.EI3,
                        EIStatus: $scope.ResignationStatus,
                        EmployeeName: $scope.EmployeeName,
                        InterviewerComment: $scope.InterviewerComment,
                        EI4: $scope.EI4,
                        EI5: $scope.EI5,
                        Header: $scope.Header,
                        JobTitle: $scope.vm.EuJobCategory,
                        Client_Id: $rootScope.Client_Id,
                        CreatedBy: $rootScope.createdby, IsActive: "true",
                    },
                });
                response.then(function (GList) {
                    try {
                        $scope._id = GList.data.data.id
                    }
                    catch (e) { }
                    var response = $http({
                        method: "PUT",
                        url: $rootScope.WebURL + "/employee/update",
                        data: {
                            _id: $scope.Employee_id,
                            EmployeeID: $scope.vm.uEmployeeID,
                            Salutation: $scope.vm.uSalutation,
                            EmployeeName: $scope.vm.uEmployeeName,
                            Gender: $scope.vm.uGender,
                            MaritalStatus: $scope.vm.uMaritalStatus,
                            Citizenship: $scope.vm.uCitizenship,
                            Race: $scope.vm.uRace,
                            VisaType: $scope.vm.uVisaType,
                            PlaceofBirth: $scope.vm.uPlaceofBirth,
                            DateofBirth: $scope.vm.uDateofBirth,
                            Drivinglicense: $scope.vm.uDrivinglicense,
                            DrivingLicenseExpiryDate: $scope.vm.uDrivingLicenseExpiryDate,
                            NRICNumber: $scope.vm.uNRICNumber,
                            NRICIssuedDate: $scope.vm.uNRICIssuedDate,
                            NRICExpiryDate: $scope.vm.uNRICExpiryDate,
                            WorkPermitNumber: $scope.vm.uWorkPermitNumber,
                            PassportNo: $scope.vm.uPassportNo,
                            PassportIssuedPlace: $scope.vm.uPassportIssuedPlace,
                            PassportIssuedDate: $scope.vm.uPassportIssuedDate,
                            WorkPassExpiryDate: $scope.vm.uWorkPassExpiryDate,
                            ResidentialAddress: $scope.vm.CuResidentialAddress,
                            UnitBuilding: $scope.vm.CuUnitBuilding,
                            Postal: $scope.vm.CuPostal,
                            Country: $scope.vm.CuCountry,
                            HomeTel: $scope.vm.CuHomeTel,
                            Mobile: $scope.vm.CuMobile,
                            Email: $scope.vm.CuEmail,
                            PermanentResidentialAddress: $scope.vm.uPermanentResidentialAddress,
                            OUnitBuilding: $scope.vm.CuOUnitBuilding,
                            OPostalZip: $scope.vm.CuOPostalZip,
                            OCountry: $scope.vm.CuOCountry,
                            OContactNo: $scope.vm.CuOContactNo,
                            EDesignation: $scope.vm.EuDesignation,
                            ECostCenter: $scope.vm.EuCostCenter,
                            EDivision: $scope.vm.EuDivision,
                            EJobCategory: $scope.vm.EuJobCategory,
                            ETeam: $scope.vm.EuTeam,
                            EEmploymentStatus: $scope.ResignationStatus,
                            ESupervisor: $scope.vm.EuSupervisor,
                            EHOD: $scope.vm.EuHOD,
                            EPeer: $scope.vm.EuPeer,
                            EProbationStartDate: $scope.vm.EuProbationStartDate,
                            EProbationCompletionDate: $scope.vm.EuProbationCompletionDate,
                            EDateOfJoin: $scope.vm.EuDateOfJoin,
                            QQualificationsName: $scope.vm.QuQualificationsName,
                            QFrom: $scope.vm.QuFrom,
                            QTo: $scope.vm.QuTo,
                            QNameofSchoolInstitution: $scope.vm.QuNameofSchoolInstitution,
                            QCountry: $scope.vm.QuCountry,
                            QHighestQualificationsAttained: $scope.vm.QuHighestQualificationsAttained,
                            Skill: $scope.vm.uSkill,
                            QLicenceName: $scope.vm.QLicenceName,
                            QLicenceStartDate: $scope.vm.QLicenceStartDate,
                            QLicenceEndDate: $scope.vm.QLicenceEndDate,
                            LanguageSpoken: $scope.vm.uLanguageSpoken,
                            LanguageWritten: $scope.vm.uLanguageWritten,
                            MembershipName: $scope.vm.uMembershipName,
                            MembershipValidFrom: $scope.vm.uMembershipValidFrom,
                            MembershipValidTo: $scope.vm.uMembershipValidTo,
                            FName: $scope.vm.FuName,
                            FDOB: $scope.vm.FuDOB,
                            FRelationship: $scope.vm.FuRelationship,
                            FOccupation: $scope.vm.FuOccupation,
                            FNationality: $scope.vm.FuNationality,
                            FHomeTel: $scope.vm.FuHomeTel,
                            FMobile: $scope.vm.FuMobile,
                            FEmail: $scope.vm.FuEmail,
                            Name: $scope.vm.uName,
                            NRelationship: $scope.vm.NRelationship,
                            NHomeTel: $scope.vm.NHomeTel,
                            NOfficeTel: $scope.vm.NOfficeTel,
                            NMobile: $scope.vm.NMobile,
                            NEmail: $scope.vm.NEmail,
                            Liability: $scope.vm.uLiability,
                            NSType: $scope.vm.uNSType,
                            Vocation: $scope.vm.uVocation,
                            UnitAttachedTo: $scope.vm.uUnitAttachedTo,
                            rrentNSStatus: $scope.vm.uCurrentNSStatus,
                            HighestRankAttained: $scope.vm.uHighestRankAttained,
                            EnlistmentDate: $scope.vm.uEnlistmentDate,
                            ORDDate: $scope.vm.uORDDate,
                            NextReservistDate: $scope.vm.uNextReservistDate,
                            YearofAward: $scope.vm.uYearofAward,
                            Description: $scope.vm.uDescription,
                            ValueofAward: $scope.vm.uValueofAward,
                            StartDateofBond: $scope.vm.uStartDateofBond,
                            EndDateofBond: $scope.vm.uEndDateofBond,
                            Hobbies: $scope.vm.uHobbies,
                            WorkWeekCode: $scope.vm.uWorkWeekCode,
                            WorkWeekDescription: $scope.vm.uWorkWeekDescription,
                            Annual: $scope.vm.Annual,
                            Adoption: $scope.vm.Adoption,
                            ChildCare: $scope.vm.ChildCare,
                            Maternity: $scope.vm.Maternity,
                            Paternity: $scope.vm.Paternity,
                            Sharedparentalleave: $scope.vm.Sharedparentalleave,
                            SickHospitalisation: $scope.vm.SickHospitalisation,
                            SickNonHospitalisation: $scope.vm.SickNonHospitalisation,
                            UnpaidLeavr: $scope.vm.UnpaidLeavr,
                            RResignationofDate: $scope.RuResignationofDate,
                            RReason: $scope.RuReason,
                            ROtherReason: $scope.RuOtherReason,
                            RRemarks: $scope.vm.RuRemarks,
                            ResignationStatus: $scope.ResignationStatus,

                            Photo: $scope.Photo,
                            ICFront: $scope.ICFront,
                            ICBack: $scope.ICBack,
                            PassportFront: $scope.PassportFront,
                            PassportBack: $scope.PassportBack,
                            UpdatedBy: $rootScope.createdby,
                            IsActive: false,
                            Client_Id: $rootScope.Client_Id,
                        },
                    });
                    response.then(function (GList) {
                    })
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }
        $scope.Reason = { value1: false }
        $scope.Reason = { value2: false }
        $scope.Reason = { value3: false }
        $scope.Reason = { value4: false }
        $scope.Reason = { value5: false }
        $scope.Reason = { value6: false }
        $scope.Reason = { value7: false }
        $scope.Reason = { value8: false }
        $scope.Reason = { value9: false }
        $scope.Reason = { value10: false }

        $scope.SaveasTemplate = function (e) {
            $mdDialog.show({
                multiple: true,
                templateUrl: 'app/main/pages/form/views/exit/temppopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function salesorderController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
            var chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
            var pass = "";
            for (var x = 0; x < 8; x++) {
                var i = Math.floor(Math.random() * chars.length);
                pass += chars.charAt(i);
            }
            $scope.TemplateID = pass
        }
        $scope.SaveasTemplatesubmit = function () {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/exitinterview/addTemplate",
                data: {
                    TemplateID: $scope.TemplateID,
                    TemplateName: $scope.vm.TemplateName,
                    EI1: $scope.EI1,
                    EI2: $scope.EI2,
                    EI3: $scope.EI3,
                    EI4: $scope.EI4,
                    EI5: $scope.EI5,
                    EIStatus: $scope.ResignationStatus,
                    Remarks: $scope.Remarks,
                    InterviewerComment: $scope.InterviewerComment,
                    EmployeeComment: $scope.EmployeeComment,
                    Header: $scope.Header,
                    Reason: $scope.Reason,
                    CreatedBy: $rootScope.createdby, IsActive: "true",
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                $mdDialog.cancel();
                $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }
        $scope.SelectTemplate = function (TId) {
            var temitem = $scope.Exitinterviewdatas.filter(function (temitem) {
                return temitem.id === TId;
            })[0];
            $scope.EI1 = temitem.EI1;
            $scope.EI2 = temitem.EI2;
            $scope.EI3 = temitem.EI3;
            $scope.EI4 = temitem.EI4;
            $scope.EI5 = temitem.EI5;
            $scope.ResignationStatus = temitem.ResignationStatus;
            $scope.Remarks = temitem.Remarks;
            $scope.InterviewerComment = temitem.InterviewerComment;
            $scope.EmployeeComment = temitem.EmployeeComment;
            $scope.Header = temitem.Header;
        }
        $scope.cancel = function () {
            $mdDialog.cancel();
        }
        $scope.EIBack = function () {
            $window.localStorage.setItem('idForExitInterview', "");
            $state.go('app.human-resource_HcmCore_employee');
        }
        $http({
            method: "POST",
            url: $rootScope.WebURL + "/exitinterview",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (exitinterviewdata) {
            $scope.Exitinterviewdatas = exitinterviewdata.data.data;
        });

        $http.get($rootScope.WebURL + "/user")
            .then(function (Userdata) {
                $scope.Userdatas = Userdata.data.data;
            });

        $http({
            method: "POST",
            url: $rootScope.WebURL + "/employee",
            data: { Client_Id: $rootScope.Client_Id },
        }).then(function (Employeedata) {
            $scope.Employeedatas = Employeedata.data.data;
            init();
        });

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

        $scope.printToCart = function (invoice) {
            window.open($rootScope.ReportURL + 'ExitInterview.aspx' + '?' + 'ID=' + $scope._id, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
            //$scope.Previewdiv = true
            //var innercontents = document.getElementById(invoice).innerHTML;
            //var popupwinindow = window.open('', '_blank', 'width=2400,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            //popupwinindow.document.open();
            //popupwinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innercontents + '<style>.printtextarea > text-angular > div.ng-scope.ng-isolate-scope.ta-toolbar {display:none;} .printtextarea > text-angular > textarea  {display : none; }</style></html>');
            //popupwinindow.document.close($scope.previewdiv = false);
        }
        //$scope.printToCart = function (printe) {
        //    var printButton = document.getElementById("printpagebutton");
        //    var printButton1 = document.getElementById("printpagebutton1");
        //    var printButton2 = document.getElementById("printpagebutton2");
        //    printButton.style.visibility = 'hidden';
        //    printButton1.style.visibility = 'hidden';
        //    printButton2.style.visibility = 'hidden';
        //    window.focus(printe);
        //    window.print(printe);
        //    printButton.style.visibility = 'visible';
        //    printButton1.style.visibility = 'visible';
        //    printButton2.style.visibility = 'visible';
        //};

        var vm = this;
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        $scope.Header = '<p>We would appreciate your taking the time to answer the following questions as honestly as possible. Your individual responses are treated as confidential.<br /><br />        We believe that this information is of vital importance and it will assist us in analyzing the factors contributing to turnover. Thank you for your cooperation.  </p>';
        vm.invoice = Invoice.data;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, $mdToast, $state, Tags, $scope, $rootScope, $http) {
        var vm = this;

        debugger

        // Data
        // vm.tasks = Tasks.data;
        // vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond': 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };

        vm.selectedFilter = {
            filter: 'Start Date',
            dueDate: 'Next 3 days'
        };

        vm.selectedProject = 'creapond';


        $http.get($rootScope.WebURL + "/todo")
            .then(function (ToDo) {
                debugger
                vm.tasks = ToDo.data.data;
                RefreshGrid();
            });

        // Tasks will be filtered against these models
        // tags     : [],
        debugger
        vm.taskFilters = {

            search: '',
            completed: '',
            deleted: 'false',
            important: '',
            starred: '',
            startDate: '',
            dueDate: ''
        };

        debugger

        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);


        vm.showAllTasks = true;

        vm.taskOrder = '';

        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle: '.handle',
            forceFallback: true,
            ghostClass: 'todo-item-placeholder',
            fallbackClass: 'todo-item-ghost',
            fallbackOnBody: true,
            sort: true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init() {

            // debugger
            // angular.forEach(vm.tasks, function (task)
            // {
            //     if ( task.startDate )
            //     {
            //         task.startDate = new Date(task.startDate);
            //         task.startDateTimestamp = task.startDate.getTime();
            //     }

            //     if ( task.dueDate )
            //     {
            //         task.dueDate = new Date(task.dueDate);
            //         task.dueDateTimestamp = task.dueDate.getTime();
            //     }
            // });
        }


        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/todo")
                .then(function (ToDo) {
                    debugger
                    vm.tasks = ToDo.data.data;

                });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task) {

            debugger

            $mdDialog.show({
                controller: 'TaskDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Task: task,
                    //Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         * 
         * 
         */
        function toggleCompleted(task, event) {

            debugger
            Completed(task, event);


        }



        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         * 
         * 
         */
        $scope.MarkasDone = function (task, event) {
            debugger
            Completed(task, event);

        }


        // completed:true, starred :false,important:false,deleted:false,

        $scope.MarkasImportant = function (task, event) {
            debugger


            if (task.important == true) {

                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, important: false, completed: task.completed, starred: task.starred,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby

                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
                $state.reload();
                event.stopPropagation();

            }
            else {

                debugger
                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, important: true, completed: task.completed, starred: task.starred,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });

                $state.reload();
                event.stopPropagation();


            }
        }


        $scope.MarkasStar = function (task, event) {

            debugger

            if (task.starred == true) {

                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, starred: false, completed: task.completed, important: task.important,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby

                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
                $state.reload();
                event.stopPropagation();

            }
            else {

                debugger
                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, starred: true, completed: task.completed, important: task.important,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });

                $state.reload();
                event.stopPropagation();


            }



        }




        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter) {

            debugger

            resetFilters();

            vm.taskFilters[filter] = !vm.taskFilters[filter];



            // if ( vm.taskFilters[filter] === '' )
            // {
            //     vm.taskFilters[filter] = true;
            // }
            // else
            // {
            //     vm.taskFilters[filter] = '';
            // }



            checkFilters();


        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter) {
            debugger
            resetFilters();

            if (vm.taskFilters[filter] === '') {
                vm.taskFilters[filter] = true;
            }
            else {
                vm.taskFilters[filter] = '';
            }



            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters() {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters() {
            debugger
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);



        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item) {


            if (vm.taskFilters.startDate === true) {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */


        function filterByDueDate(item) {
            if (vm.taskFilters.dueDate === true) {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag) {
            var i = vm.taskFilters.tags.indexOf(tag);

            if (i > -1) {
                vm.taskFilters.tags.splice(i, 1);
            }
            else {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag) {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }


        function Completed(task, event) {

            if (task.completed == true) {

                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, completed: false,

                        starred: task.starred, important: task.important,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby

                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
                $state.reload();
                event.stopPropagation();

            }
            else {

                debugger
                var response;
                response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/todo/update",
                    data: {

                        _id: task.id, Title: task.Title, StartDate: task.StartDate, Notes: task.Notes,
                        DueDate: task.DueDate, AssignedTo: task.AssignedTo, completed: true,
                        starred: task.starred, important: task.important,
                        deleted: task.deleted, UpdatedBy: $rootScope.createdby
                    },
                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));



                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });

                $state.reload();
                event.stopPropagation();


            }



        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('apps.dashboard',
            [
                // 3rd Party Dependencies
                 'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        var Dashboard = 'Dashboard';

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var Dashboard = 'bảng điều khiển';
        }
        // State
        $stateProvider.state('app._dashboard', {
            url: '/Dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            resolve: {
                DashboardData: function (msApi) {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards');

        var IsAccess = localStorage.getItem('pages');
        if (IsAccess == null) {
            return
        }
        var Customer_Aceses = localStorage.getItem('Customer_Id');
        if (Customer_Aceses == null || Customer_Aceses == "null" || Customer_Aceses == "" || Customer_Aceses == undefined || Customer_Aceses == "undefined") {   // do nothing 
            msNavigationServiceProvider.saveItem('apps.dashboard', {
                title: Dashboard,
                icon: 'icon-tile-four',
                state: 'app._dashboard',
            });
        }
        
    }

})();
(function () {
  'use strict';

  angular
    .module('apps.dashboard')
    .filter('groupBy', function () {
      return _.memoize(function (items, field) {
        return _.groupBy(items, field);
      }
      );
    })
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($http, $state, $scope, $rootScope, $window, $interval, $mdSidenav, $location, DashboardData, $filter, socket) {
    document.getElementsByTagName('title')[0].text = "Dashboard"
    var Customer_Aceses = localStorage.getItem('Customer_Id');
    if (Customer_Aceses == null || Customer_Aceses == "null" || Customer_Aceses == "" || Customer_Aceses == undefined || Customer_Aceses == "undefined") {   // do nothing 
    }
    else { $location.path("NoAccess"); }

    var Client_Id = localStorage.getItem('Client_Id');
    var IsAdmin = JSON.parse(localStorage.getItem('IsAdmin'))
    RefreshTodayActivities()

    $http.get($rootScope.WebURL + "/client")
      .then(function (Userdata) {
        $scope.Clientdatas = Userdata.data.data;
        var item = $scope.Clientdatas.filter(function (value) {
          return value.id === Client_Id;
        })[0];
        $window.localStorage.setItem('DefaultLanguage', item.Language);
      });

    $http.get($rootScope.WebURL + "/client")
      .then(function (Userdata) {
        $scope.Clientdatas = Userdata.data.data;
      });

    $scope.ContractD = [];
    $scope.AllContractsitem = [];
    $scope.ContractListdatas = [];
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contract",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Contractdata) {
      $scope.Contractsitem = Contractdata.data.data;


      angular.forEach($scope.Contractsitem, function (cvalue) {
        if (cvalue.Status == "New") {
          cvalue.Status = "New Contracts"
        }
        var SalesOrderNo = "";
        if (cvalue.workorderdetails.length > 0) {
          SalesOrderNo = cvalue.workorderdetails[0].SalesOrderNo;
        }
        $scope.AllContractsitem.push({
          ContractReferenceNo: cvalue.ContractReferenceNo,
          SalesOrderNo: SalesOrderNo,
          ContractStartDate: new Date(cvalue.ContractStartDate),
          ContractEndDate: new Date(cvalue.ContractEndDate),
          ContractDuration: cvalue.ContractDuration,
          ContractExpired: $scope.Totla(new Date(cvalue.ContractEndDate)),
        })
      })
      $scope.vm.ExpiredDate = "EXPIRING IN 30 DAYS";
      try {
        $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
          return item.ContractExpired < 30;
        });
      } catch (e) { }
      $scope.Contractgroups = _.groupBy($scope.Contractsitem, 'Status');
      $scope.Contractdatas = Contractdata.data.data.length;
    });

    $scope.ExpiredDateFilter = function () {
      $scope.ExpiredDate = $scope.vm.ExpiredDate;
      $scope.ContractListdatas = [];
      if ($scope.ExpiredDate === "EXPIRING IN 30 DAYS") {
        try {
          $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
            return item.ContractExpired <= 30;
          });
        } catch (e) { }
      }
      else if ($scope.ExpiredDate === "EXPIRING IN 60 DAYS") {
        try {
          $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
            return item.ContractExpired <= 60;
          });
        } catch (e) { }
      }
      else if ($scope.ExpiredDate === "EXPIRING IN 90 DAYS") {
        try {
          $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
            return item.ContractExpired <= 90;
          });
        } catch (e) { }
      }
      else if ($scope.ExpiredDate === "EXPIRING ABOVE 90 DAYS") {
        try {
          $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
            return item.ContractExpired > 90;
          });
        } catch (e) { }
      }
      else if ($scope.ExpiredDate === "EXPIRED") {
        try {
          $scope.ContractListdatas = $scope.AllContractsitem.filter(function (item) {
            return item.ContractExpired === "Expiried";
          });
        } catch (e) { }
      }
      else if ($scope.ExpiredDate === null) {
        try {
          $scope.ContractListdatas = [];
        } catch (e) { }
      }
    }

    $scope.LeadD = [];
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/lead/dashboard",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Leaddata) {
      $scope.Leaddatas = Leaddata.data.data.length;
    });
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/customer/getCustomerLength",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Leaddata) {
      $scope.customerdatas = Leaddata.data.data;
    });

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/contract/getLength",
      data: { Client_Id: $rootScope.Client_Id, Type: "New" },
    }).then(function (Leaddata) {
      var contract1 = Leaddata.data.data;
      $http({
        method: "POST",
        url: $rootScope.WebURL + "/contract/getLength",
        data: { Client_Id: $rootScope.Client_Id, Type: "SalesOrder" },
      }).then(function (Leaddata1) {
        var contract2 = Leaddata1.data.data;
        $scope.Contractdatas = parseInt(contract2) + parseInt(contract1)
      });
    });

    $http({
      method: "POST",
      url: $rootScope.WebURL + "/salesOrder/getLength",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Leaddata) {
      $scope.salesOrderdatas = Leaddata.data.data;
    });



    $scope.CustomerD = [];
    var customerchart = [];
    $http({
      method: "POST",
      url: $rootScope.WebURL + "/customer",
      data: { Client_Id: $rootScope.Client_Id },
    }).then(function (Customersdata) {
      $scope.Customersitem = Customersdata.data.data;
      $scope.Customersdatas = Customersdata.data.data.length;
      var item = $scope.Customersitem.filter(function (item) {
        return item.CustomerType === "Company";
      });
      var Companylength = item.length;
      customerchart.push({ CustomerType: "Company", lengthvalue: Companylength })
      var Housing = $scope.Customersitem.filter(function (Housing) {
        return Housing.CustomerType === "Private Housing";
      });
      var Housinglength = Housing.length;
      customerchart.push({ CustomerType: "Private Housing", lengthvalue: Housinglength })

      angular.forEach(customerchart, function (value) {
        $scope.CustomerD.push({
          label: value.CustomerType,
          value: value.lengthvalue
        })
      });
    });

    $scope.ExpiredDateList = [
      { "name": "EXPIRING IN 30 DAYS" },
      { "name": "EXPIRING IN 60 DAYS" },
      { "name": "EXPIRING IN 90 DAYS" },
      { "name": "EXPIRING ABOVE 90 DAYS" },
      { "name": "EXPIRED" },
    ];

    $scope.Totla = function (uTimeOut) {
      if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date();
        var secondDate = new Date(uTimeOut);
        if (firstDate > secondDate) {
          return 'Expiried'
        }
        else {

          var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
          if (res == 0) {
            return 'Expiried'
          }
          else {
            return res;
          }
        }
      }
      else { return null }
    }

    var DefaultLanguage = localStorage.getItem('DefaultLanguage');
    var Language = localStorage.getItem('MenuReports');
    var customertitle = "Customer";
    var enquirytitle = "Enquiry";
    var workordertitle = "Work Order";
    var contrattitle = "Contracts";
    $scope.General = "General";

    if (DefaultLanguage === "Vietnamese" || Language === "Báo cáo") {
      customertitle = "khách hàng";
      enquirytitle = "Yêu cầu";
      workordertitle = "Trình tự công việc";
      contrattitle = "Hợp đồng";
      $scope.General = "Chung"
    }

    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    var vm = this;
    // Data
    vm.dashboardData = DashboardData;
    vm.projects = vm.dashboardData.projects;
    // Widget 1
    vm.widget1 = vm.dashboardData.widget1;
    // Widget 2
    vm.widget2 = vm.dashboardData.widget2;

    // Widget 3
    vm.widget3 = vm.dashboardData.widget3;

    // Widget 4
    $scope.AddocD = [];
    // Widget 5
    // vm.widget5 = {
    //   mainChart: {
    //     config: {
    //       refreshDataOnly: true,
    //       deepWatchData: true
    //     },
    //     options: {
    //       chart: {
    //         type: 'discreteBarChart',
    //         color: ['#03a9f4', '#b3e5fc'],
    //         height: 420,
    //         margin: {
    //           top: 8,
    //           right: 16,
    //           bottom: 32,
    //           left: 32
    //         },
    //         clipEdge: true,
    //         groupSpacing: 0.3,
    //         reduceXTicks: false,
    //         stacked: true,
    //         duration: 250,
    //         x: function (d) {
    //           return d.x;
    //         },
    //         y: function (d) {
    //           return d.y;
    //         },
    //         yAxis: {
    //           tickFormat: function (d) {
    //             return d;
    //           }
    //         },
    //         legend: {
    //           margin: {
    //             top: 8,
    //             bottom: 32
    //           }
    //         },
    //         controls: {
    //           margin: {
    //             top: 8,
    //             bottom: 32
    //           }
    //         },
    //         tooltip: {
    //           gravity: 's',
    //           classes: 'gravity-s'
    //         }
    //       }
    //     },
    //     data: []
    //   },

    //   days: ['2015', '2016', '2017', '2018', '2019', '2020', '2021'],

    //   changeRange: function (range) {
    //     angular.forEach($scope.Leaditem, function (value) {
    //       value.EnquiryDate = new Date(value.EnquiryDate).setHours(0, 0, 0, 0)
    //     })
    //     $scope.SOgroups = _.groupBy($scope.Leaditem, 'EnquiryDate');
    //     var data = [{ "values": [] }];
    //     angular.forEach($scope.SOgroups, function (value) {
    //       var d = new Date(value[0].EnquiryDate);
    //       var n = $filter('date')(d, 'dd/MM/yyyy');
    //       data[0].values.push(
    //         {
    //           "x": n,
    //           "y": value.length
    //         }
    //       )
    //     });
    //     vm.widget5.mainChart.data[0] = data[0];
    //   },
    //   init: function () {
    //     // Run this function once to initialize widget

    //     /**
    //      * Update the range for the first time
    //      */
    //     var Adh = [];
    //     $http({
    //       method: "POST",
    //       url:  $rootScope.WebURL + "/salesOrder",
    //       data: { Client_Id: $rootScope.Client_Id },
    //     }).then(function (salesOrderdata) {
    //       $scope.salesOrderItems = salesOrderdata.data.data;
    //       var item = $scope.salesOrderItems.filter(function (item) {
    //         return item.OrderType === "Ad-hoc";
    //       });
    //       $scope.Adhoclength = item.length;
    //       $scope.salesOrderdatas = salesOrderdata.data.data.length;
    //       vm.widget5.changeRange('TW');

    //       Adh.push({ OrderType: "Ad-hoc", lengthvalue: $scope.Adhoclength })
    //       var item1 = $scope.salesOrderItems.filter(function (item1) {
    //         return item1.OrderType === "Contract";
    //       });
    //       var OTlength = item1.length;
    //       Adh.push({ OrderType: "Contract", lengthvalue: OTlength })
    //       angular.forEach(Adh, function (value) {
    //         $scope.AddocD.push({
    //           label: value.OrderType,
    //           value: value.lengthvalue
    //         })
    //       });
    //     });
    //   }
    // };

    // Widget 6
    vm.widget6 = {
      title: vm.dashboardData.widget6.title,
      mainChart: {
        config: {
          refreshDataOnly: true,
          deepWatchData: true
        },
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            donut: true,
            clipEdge: true,
            cornerRadius: 0,
            labelType: 'percent',
            padAngle: 0.02,
            x: function (d) {
              return d.ShiftName;
            },
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: []
      },
      footerLeft: vm.dashboardData.widget6.footerLeft,
      footerRight: vm.dashboardData.widget6.footerRight,
      ranges: vm.dashboardData.widget6.ranges,
      currentRange: '',
      changeRange: function (range) {
        vm.widget6.currentRange = range;

        /**
         * Update main chart data by iterating through the
         * chart dataset and separately adding every single
         * dataset by hand.
         *
         * You MUST NOT swap the entire data object by doing
         * something similar to this:
         * vm.widget.mainChart.data = chartData
         *
         * It would be easier but it won't work with the
         * live updating / animated charts due to how d3
         * works.
         *
         * If you don't need animated / live updating charts,
         * you can simplify these greatly.
         */

        angular.forEach($scope.Shiftdatas, function (data, index) {
          vm.widget6.mainChart.data[index] = {
            label: data.ShiftName,
            value: $scope.Shiftdatas.length
          };
        });
      },
      init: function () {
        // Run this function once to initialize widget

        /**
         * Update the range for the first time
         */
        vm.widget6.changeRange('TW');
      }
    };
    // Widget 7
    vm.widget7 = {
      title: vm.dashboardData.widget7.title,
      ranges: vm.dashboardData.widget7.ranges,
      schedule: vm.dashboardData.widget7.schedule,
      currentRange: 'T'
    };

    var widget8 = {
      "title": customertitle,
      "mainChart": $scope.CustomerD
    }
    // Widget 8
    vm.widget8 = {
      title: widget8.title,
      mainChart: {
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            labelType: 'percent',
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: widget8.mainChart
      }
    };

    // Widget 9
    var widget9 = {
      "title": enquirytitle,
      "mainChart": $scope.LeadD
    }
    // Widget 8
    vm.widget9 = {
      title: widget9.title,
      mainChart: {
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            labelType: 'percent',
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: widget9.mainChart
      }
    };

    // Widget 10
    var widget10 = {
      "title": contrattitle,
      "mainChart": $scope.ContractD
    }
    vm.widget10 = {
      title: widget10.title,
      mainChart: {
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            labelType: 'percent',
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: widget10.mainChart
      }
    };

    // Widget 11
    var widget11 = {
      "title": workordertitle,
      "mainChart": $scope.AddocD
    }
    vm.widget11 = {
      title: widget11.title,
      mainChart: {
        options: {
          chart: {
            type: 'pieChart',
            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
            height: 400,
            margin: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            labelType: 'percent',
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            }
          }
        },
        data: widget11.mainChart
      }
    };

    // Now widget
    vm.nowWidget = {
      now: {
        second: '',
        minute: '',
        hour: '',
        day: '',
        month: '',
        year: ''
      },
      ticker: function () {
        var now = moment();
        vm.nowWidget.now = {
          second: now.format('ss'),
          minute: now.format('mm'),
          hour: now.format('HH'),
          day: now.format('D'),
          weekDay: now.format('dddd'),
          month: now.format('MMMM'),
          year: now.format('YYYY')
        };
      }
    };

    // Weather widget
    vm.weatherWidget = vm.dashboardData.weatherWidget;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.selectProject = selectProject;

    //////////
    //vm.selectedProject = vm.projects[0];

    // Initialize Widget 5
    // vm.widget5.init();

    // Initialize Widget 6
    vm.widget6.init();


    // Now widget ticker
    vm.nowWidget.ticker();

    var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

    $scope.$on('$destroy', function () {
      $interval.cancel(nowWidgetTicker);
    });
    vm.dashboardData = DashboardData;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#forms-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'simple',
      autoWidth: false,
      lengthMenu: [10, 20, 30, 50, 100],
      stateSave: true,
      responsive: true,
      "language": {
        "lengthMenu": $rootScope.lengthMenu,
        "zeroRecords": $rootScope.zeroRecords,
        "info": $rootScope.info,
        "infoEmpty": $rootScope.infoEmpty,
        "infoFiltered": $rootScope.infoFiltered,
        "Header": $rootScope.Header,
      }
    };


    //Socket Refresh for todays activities

    socket.on("Customer Created", function (data) {
      RefreshTodayActivities()
    })
    socket.on("Contract Created", function (data) {
      RefreshTodayActivities()
    })
    socket.on("salesOrder Created", function (data) {
      RefreshTodayActivities()
    })

    function RefreshTodayActivities() {
      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/customer/getToday',
        data: { Client_Id: $rootScope.Client_Id, StartDate: new Date(), EndDate: new Date() }
      }).then(function (List) {
        $scope.TCustomerdatas = List.data.data
      })

      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/contract/getToday',
        data: { Client_Id: $rootScope.Client_Id, FieldName: "CreatedDate", StartDate: new Date(), EndDate: new Date() },
      }).then(function (List) {
        $scope.TContractdatas = List.data.data
      })

      $http({
        method: 'POST',
        url: $rootScope.WebURL + '/salesOrder/getToday',
        data: { Client_Id: $rootScope.Client_Id, StartDate: new Date(), EndDate: new Date() }
      }).then(function (List) {
        $scope.TSalesOrderdatas = List.data.data
      })
    }
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Select project
     */
    function selectProject(project) {
      vm.selectedProject = project;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.customerportal',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        
        var CustomePortal = 'Customer Portal'

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var CustomePortal = 'cổng thông tin khách hàng'
        }
        // State
        $stateProvider.state('app.customerportal', {
            url: '/CustomerPortal',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/customerportal/customerportal.html',
                    controller: 'CustomerportalController as vm'
                }
            },
            bodyClass: 'calendar'
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/customerportal');

        var IsAccess = localStorage.getItem('pages');
        if (IsAccess == null) {
            return
        }
        // var Customer_Aceses = localStorage.getItem('Customer_Id');
        // if (Customer_Aceses != null && Customer_Aceses != "null" && Customer_Aceses != "" && Customer_Aceses != undefined && Customer_Aceses != "undefined") {   // do nothing 
        //     msNavigationServiceProvider.saveItem('apps.customerportal', {
        //         title: CustomePortal,
        //         icon: 'icon-account-multiple',
        //         state: 'app.customerportal',
        //         weight: 1
        //     });
        // }
        // else
         {
            return
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.customerportal')
        .controller('CustomerportalController', CustomerportalController);


    function CustomerportalController($mdDateLocale, $scope, $rootScope, $interval, $mdToast, $mdSidenav, $location, $mdDialog, $document, $http, $log, $filter) {
        var Customer_Aceses = localStorage.getItem('Customer_Id');
        if (Customer_Aceses != null && Customer_Aceses != "null" && Customer_Aceses != "" && Customer_Aceses != undefined && Customer_Aceses != "undefined") {   // do nothing 
        }
        else { $location.path("NoAccess"); }
        var Client_Id = localStorage.getItem('Client_Id');
        var Customer_Id = localStorage.getItem('Customer_Id');

        $rootScope.createdName = localStorage.getItem('UserName');
        $rootScope.LoginID = localStorage.getItem('LoginID');
        RefreshSchedulerGrid();
        RefreshInvoiceGrid();
        RefreshContractGrid();
        RefreshCustomerFeedbackGrid();
        RefreshWorkOrderNumberGrid();
        RefreshContractNumberGrid();
        RefreshServiceNumberGrid();
        RefreshPestTypeGrid();

        $scope.Add = false;
        $scope.ScheduleExport = true;
        $scope.InvoiceExport = false;
        $scope.ContractExport = false;
        $scope.ServiceReportExport = false;
        $scope.FeedbackExport = false;
        $scope.model = {};

        $scope.Schedules = function () {
            debugger
            $scope.Add = false;
            $scope.ScheduleExport = true;
            $scope.InvoiceExport = false;
            $scope.ContractExport = false;
            $scope.ServiceReportExport = false;
            $scope.FeedbackExport = false;
            $scope.model.Search = "";
            RefreshSchedulerGrid();
        }

        $scope.Invoices = function () {
            debugger
            $scope.Add = false;
            $scope.ScheduleExport = false;
            $scope.InvoiceExport = true;
            $scope.ContractExport = false;
            $scope.ServiceReportExport = false;
            $scope.FeedbackExport = false;
            $scope.model.Search = "";
            RefreshInvoiceGrid();
        }

        $scope.Contracts = function () {
            debugger
            $scope.Add = false;
            $scope.ScheduleExport = false;
            $scope.InvoiceExport = false;
            $scope.ContractExport = true;
            $scope.ServiceReportExport = false;
            $scope.FeedbackExport = false;
            $scope.model.Search = "";
            RefreshContractGrid();
        }

        $scope.ServiceReports = function () {
            debugger
            $scope.Add = false;
            $scope.ScheduleExport = false;
            $scope.InvoiceExport = false;
            $scope.ContractExport = false;
            $scope.ServiceReportExport = true;
            $scope.FeedbackExport = false;
            $scope.model.Search = "";
            RefreshSchedulerGrid();
        }

        $scope.Feedback = function () {
            debugger
            $scope.Add = true;
            $scope.ScheduleExport = false;
            $scope.InvoiceExport = false;
            $scope.ContractExport = false;
            $scope.ServiceReportExport = false;
            $scope.FeedbackExport = true;
            $scope.model.Search = "";
            RefreshCustomerFeedbackGrid();
        }

        $scope.FeedbackPopup = function (e) {

            $scope.vm.DateofService = new Date();
            $scope.vm.WorkOrder = "";
            $scope.vm.Contract = "";
            $scope.vm.ServiceNo = "";
            $scope.vm.PestType = "";
            $scope.vm.Status = "Open";
            $scope.vm.Feedback = "";
            $scope.FUpdate = false;

            $mdDialog.show({
                templateUrl: 'app/main/apps/customerportal/feedbackpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CustomerportalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.FeedbackAdd = function () {
            debugger
            if ($scope.vm.WorkOrder != null && $scope.vm.WorkOrder != "" && $scope.vm.WorkOrder != undefined) {
                $scope.vm.WorkOrder = $scope.vm.WorkOrder.map(function (obj) { return obj.SalesOrderNo; }).join(',');
            }
            if ($scope.vm.Contract != null && $scope.vm.Contract != "" && $scope.vm.Contract != undefined) {
                $scope.vm.Contract = $scope.vm.Contract.map(function (obj) { return obj.ContractReferenceNo; }).join(',');
            }
            if ($scope.vm.ServiceNo != null && $scope.vm.ServiceNo != "" && $scope.vm.ServiceNo != undefined) {
                $scope.vm.ServiceNo = $scope.vm.ServiceNo.map(function (obj) { return obj.ServiceID; }).join(',');
            }
            if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                $scope.vm.PestType = $scope.vm.PestType.map(function (obj) { return obj.PestName; }).join(',');
            }

            if ($scope.FUpdate == true) {
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/customerfeedback/update",
                    data: {
                        _id: $scope.FID,
                        DateofService: $scope.vm.DateofService,
                        WorkOrder: $scope.vm.WorkOrder,
                        Contract: $scope.vm.Contract,
                        ServiceNo: $scope.vm.ServiceNo,
                        PestType: $scope.vm.PestType,
                        Feedback: $scope.vm.Feedback,
                        Status: $scope.vm.Status,
                        Comment: $scope.Comment,
                        UpdatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Updated!').position('top center'));
                    RefreshCustomerFeedbackGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
            else {
                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/customerfeedback/add",
                    data: {
                        Client_Id: Client_Id,
                        Customer_Id: Customer,
                        DateofService: $scope.vm.DateofService,
                        WorkOrder: $scope.vm.WorkOrder,
                        Contract: $scope.vm.Contract,
                        ServiceNo: $scope.vm.ServiceNo,
                        PestType: $scope.vm.PestType,
                        Feedback: $scope.vm.Feedback,
                        Status: $scope.vm.Status,
                        Comment: "",
                        CreatedBy: $rootScope.LoginID,
                    },
                });
                response.then(function (GList) {
                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshCustomerFeedbackGrid();
                    $mdDialog.cancel();
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
                });
            }
        }

        $scope.FeedbackUpdate = function (e, FId) {

            $scope.FUpdate = true;
            $scope.FID = FId;
            try {
                var item = $scope.Feedbackdatas.filter(function (item) {
                    return item._id === FId;
                })[0];
                $scope.id = item._id;
                $scope.vm.DateofService = new Date(item.DateofService);
                $scope.vm.WorkOrder = item.WorkOrder;
                if ($scope.vm.WorkOrder != null && $scope.vm.WorkOrder != "" && $scope.vm.WorkOrder != undefined) {
                    var warray = $scope.vm.WorkOrder.split(",");
                    var warray1 = [];
                    angular.forEach(warray, function (value) {
                        warray1.push({ SalesOrderNo: value });
                    });
                    $scope.vm.WorkOrder = warray1;
                }
                $scope.vm.Contract = item.Contract;
                if ($scope.vm.Contract != null && $scope.vm.Contract != "" && $scope.vm.Contract != undefined) {
                    var carray = $scope.vm.Contract.split(",");
                    var carray1 = [];
                    angular.forEach(carray, function (value) {
                        carray1.push({ ContractReferenceNo: value });
                    });
                    $scope.vm.Contract = carray1;
                }
                $scope.vm.ServiceNo = item.ServiceNo;
                if ($scope.vm.ServiceNo != null && $scope.vm.ServiceNo != "" && $scope.vm.ServiceNo != undefined) {
                    var sarray = $scope.vm.ServiceNo.split(",");
                    var sarray1 = [];
                    angular.forEach(sarray, function (value) {
                        sarray1.push({ ServiceID: value });
                    });
                    $scope.vm.ServiceNo = sarray1;
                }
                $scope.vm.PestType = item.PestType;
                if ($scope.vm.PestType != null && $scope.vm.PestType != "" && $scope.vm.PestType != undefined) {
                    var parray = $scope.vm.PestType.split(",");
                    var parray1 = [];
                    angular.forEach(parray, function (value) {
                        parray1.push({ PestName: value });
                    });
                    $scope.vm.PestType = parray1;
                }
                $scope.vm.Feedback = item.Feedback;
                $scope.vm.Status = item.Status;
                $scope.Comment = item.Comment;
            } catch (err) { }

            $mdDialog.show({
                templateUrl: 'app/main/apps/customerportal/feedbackpopup.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CustomerportalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Feedbackdelete = function (e, deleteID) {
            $scope.deleteID = deleteID;

            $mdDialog.show({
                templateUrl: 'app/main/apps/customerportal/feedbackdelete.html',
                parent: angular.element($document.body),
                targetEvent: e,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                controller: function CustomerportalController($scope, $mdDialog) {
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    }
                }
            });
        }

        $scope.Fdelete = function (deleteID) {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customerfeedback/delete",
                data: {
                    _id: deleteID,
                },
            });
            response.then(function (GList) {
                $mdToast.show($mdToast.simple().textContent('Successfully Deleted!').position('top center'));
                RefreshCustomerFeedbackGrid();
                $mdDialog.cancel();
            }, function () {
                $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
            });
        }

        function RefreshSchedulerGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler/getSchedulerByCustomer",
                data: { Client_Id: Client_Id, Customer: Customer_Id },
            });
            response.then(function (Schedulerdata) {
                $scope.Schedulerdatas = Schedulerdata.data.data;
            });
        }

        function RefreshInvoiceGrid() {
            debugger
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/salesinvoice/getSalesinvoiceByCustomer",
                data: { Client_Id: Client_Id, CustomerID: Customer_Id },
            });
            response.then(function (Invoicedata) {
                debugger
                $scope.Invoicedatas = Invoicedata.data.data;
            });
        }

        function RefreshContractGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract/getContractByCustomer",
                data: { Client_Id: Client_Id, Customer_id: Customer_Id },
            });
            response.then(function (Contractdata) {
                $scope.Contractdatas = Contractdata.data.data;
            });
        }

        function RefreshWorkOrderNumberGrid() {
            var response = $http({
                url: $rootScope.WebURL + "/salesOrder",
                method: "POST",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Workordernumberdata) {
                $scope.Workordernumberdatas = Workordernumberdata.data.data;
            });
        }

        function RefreshContractNumberGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/contract",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Contractnumberdata) {
                $scope.Contractnumberdatas = Contractnumberdata.data.data;
            });
        }

        function RefreshServiceNumberGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/scheduler",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Servicenumberdata) {
                $scope.Servicenumberdatas = Servicenumberdata.data.data;
            });
        }

        function RefreshPestTypeGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/pesttype",
                data: { Client_Id: Client_Id },
            });
            response.then(function (Pesttypedata) {
                $scope.Pesttypedatas = Pesttypedata.data.data;
            });
        }

        function RefreshCustomerFeedbackGrid() {
            var response = $http({
                method: "POST",
                url: $rootScope.WebURL + "/customerfeedback/getByCustomerID",
                data: { Client_Id: Client_Id, Customer_Id: Customer_Id },
            });
            response.then(function (Feedbackdata) {
                $scope.Feedbackdatas = Feedbackdata.data.data;
            });
        }

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.Totla = function (uTimeOut) {
            if (uTimeOut != null && uTimeOut != undefined && uTimeOut != "") {
                var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                var firstDate = new Date();
                var secondDate = new Date(uTimeOut);
                if (firstDate.setHours(0, 0, 0, 0) > secondDate.setHours(23, 59, 59, 999)) {
                    return 'Expiried'
                }
                else {

                    var res = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / (oneDay)));
                    if (res == 0) {
                        return 'Expiried'
                    }
                    else {
                        return res;
                    }
                }
            }
            else { return null }
        }

        $scope.printServiceReport = function (PId) {
            debugger
            $scope.SID = PId;
            var url = $rootScope.ReportURL + "Service.aspx?ID=" + PId;
            window.open(url, 'winView', 'titlebar=0,toolbar=0,location=0,left=0,top=0,status=0,menubar=0,scrollbars=yes,resizable=yes,width=1000,height=600');
        };

        $scope.sExport = function () {
            alasql('SELECT * INTO XLSX("ScheduleDetails.xlsx",{headers:true}) FROM ?', [$scope.Schedulerdatas]);
        };

        $scope.iExport = function () {
            alasql('SELECT * INTO XLSX("InvoiceDetails.xlsx",{headers:true}) FROM ?', [$scope.Invoicedatas]);
        };

        $scope.cExport = function () {
            alasql('SELECT * INTO XLSX("ContractDetails.xlsx",{headers:true}) FROM ?', [$scope.Contractdatas]);
        };

        $scope.srExport = function () {
            alasql('SELECT * INTO XLSX("ServiceReportDetails.xlsx",{headers:true}) FROM ?', [$scope.Schedulerdatas]);
        };

        $scope.fExport = function () {
            alasql('SELECT * INTO XLSX("FeedbackDetails.xlsx",{headers:true}) FROM ?', [$scope.Feedbackdatas]);
        };

        var vm = this;

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#datasearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true,
            "language": {
                "lengthMenu": $rootScope.lengthMenu,
                "zeroRecords": $rootScope.zeroRecords,
                "info": $rootScope.info,
                "infoEmpty": $rootScope.infoEmpty,
                "infoFiltered": $rootScope.infoFiltered,
                "Header": $rootScope.Header,
            }
        };

        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController(Contacts, ChatsService, $mdSidenav, User, $http, $rootScope, $scope,$timeout, $document, $mdMedia)
    {
      
        var vm = this;

        // Data
        vm.contacts = ChatsService.contacts = Contacts.data;
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = undefined;

        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;

        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contactId)
        {
            ChatsService.getContactChat(contactId).then(function (response)
            {
                vm.chatContactId = contactId;
                vm.chat = response;

                // Reset the reply textarea
                resetReplyTextarea();

                // Scroll to the last message
                scrollToBottomOfChat();

                if ( !$mdMedia('gt-md') )
                {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                vm.toggleLeftSidenavView(false);

            });
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                message: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);

            // Update Contact's lastMessage
            vm.contacts.getById(vm.chatContactId).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.applyleave', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_HcmCore_applyleave', {
            url: '/Applyleave',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/Applyleave/applyleave.html',
                    controller: 'payrollController as vm'
                }
            }
        });
}
})();

(function () {
    'use strict';

    angular
        .module('app.applyleave')
        .controller('payrollController', payrollController);

    /** @ngInject */
    function payrollController($mdDateLocale, $scope, $location, $rootScope, $interval, $mdToast, $mdSidenav, $http) {
        $scope.Employeegrid = false;
        $scope.Export = true;
        $scope.Employeeform = true;
        $scope.Add = true;
        $scope.Search = true;



        $scope.sExport = function () {

            alasql('SELECT * INTO XLSX("Employeedata.xlsx",{headers:true}) FROM ?', [$scope.EmployeeSammury]);
        };

        $scope.items = [{ a: 1, b: 10 }, { a: 2, b: 20 }, { a: 3, b: 30 }];
        $scope.Employeeinfo = function (EmployeeId) {

            $scope.SID = EmployeeId;
            $scope.Update = true;
            $scope.Employeeform = true;
            $scope.Employeegrid = false;
            $scope.tabnext = true;
            $scope.tabsubmit = false;
            $scope.tabnext1 = false;
            $scope.EmployeeinfoId = EmployeeId;
            var Employeedata = $scope.EmployeeSammury

            var info = $scope.EmployeeSammury

            for (var i = 0; i < info.length; i++) {
                if (info[i].ID == EmployeeId) {

                    $scope.uEmployeeID = info[i].EmployeeID;
                    $scope.uEmployeeName = info[i].EmployeeName;
                    $scope.uBusinessUnit = info[i].BusinessUnit;
                    $scope.uCostCentre = info[i].CostCentre;
                    $scope.uDivision = info[i].Division;
                    $scope.uTeam = info[i].Team;
                    $scope.uJobTitle = info[i].JobTitle;
                    $scope.uJobCategory = info[i].JobCategory;
                    $scope.uLeaveType = info[i].LeaveType;
                    $scope.uDateApply = info[i].DateApply;
                    $scope.uFrom = info[i].From;
                    $scope.uTo = info[i].To;
                    $scope.uApplyFor = info[i].ApplyFor;
                    $scope.uReason = info[i].Reason;
                    $scope.uDateResumeWork = info[i].DateResumeWork;
                    $scope.uRelietPersonalDuringLeave = info[i].RelietPersonalDuringLeave;
                    $scope.uStatus = info[i].Status;
                }
            }
            if ($scope.uStatus == "Active") {
                $scope.uStatus = true;
            }
            else {

                $scope.uStatus = false;
            }
        }

        $scope.sSubmit = function () {

            if ($scope.Update == true) {
                $scope.Update = true;
                var response = $http({
                    method: "PUT",
                    url: $rootScope.WebURL + "/employee/update",
                    data: {
                        ID: $scope.SID,
                        EmployeeID: $scope.uEmployeeID, EmployeeName: $scope.uEmployeeName,
                        BusinessUnit: $scope.uBusinessUnit,
                        CostCentre: $scope.uCostCentre,
                        Division: $scope.uDivision,
                        Team: $scope.uTeam,
                        JobTitle: $scope.uJobTitle,
                        JobCategory: $scope.uJobCategory,
                        LeaveType: $scope.uLeaveType,
                        DateApply: $scope.uDateApply,
                        From: $scope.uFrom,
                        To: $scope.uTo,
                        ApplyFor: $scope.uApplyFor,
                        Reason: $scope.uReason,
                        DateResumeWork: $scope.uDateResumeWork,
                        RelietPersonalDuringLeave: $scope.uRelietPersonalDuringLeave,
                        Status: $scope.uStatus,
                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Employeegrid = true;
                    $scope.Employeeform = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
            else {

                var response = $http({
                    method: "POST",
                    url: $rootScope.WebURL + "/employee/add",
                    data: {
                        EmployeeID: $scope.uEmployeeID,
                        EmployeeName: $scope.uEmployeeName,
                        BusinessUnit: $scope.uBusinessUnit,
                        CostCentre: $scope.uCostCentre,
                        Division: $scope.uDivision,
                        Team: $scope.uTeam,
                        JobTitle: $scope.uJobTitle,
                        JobCategory: $scope.uJobCategory,
                        LeaveType: $scope.uLeaveType,
                        DateApply: $scope.uDateApply,
                        From: $scope.uFrom,
                        To: $scope.uTo,
                        ApplyFor: $scope.uApplyFor,
                        Reason: $scope.uReason,
                        DateResumeWork: $scope.uDateResumeWork,
                        RelietPersonalDuringLeave: $scope.uRelietPersonalDuringLeave,
                        Status: $scope.uStatus,

                    },

                });

                response.then(function (GList) {

                    $mdToast.show($mdToast.simple().textContent('Successfully Added!').position('top center'));
                    RefreshGrid();
                    $scope.Employeegrid = true;
                    $scope.Employeeform = true;
                }, function () {
                    $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

                });
            }
        }

        $scope.Showgrid = function () {
            $scope.Employeegrid = true;
            $scope.Employeeform = true;
            $scope.Export = true;
            $scope.Add = true;
            $scope.Search = true;
            $scope.view = false;
        }

        $scope.sAdd = function () {

            ClearForm();
            $scope.Update = false;
            $scope.Employeeform = true;
            $scope.Employeegrid = false;
            $scope.Export = false;
            $scope.view = true;
            $scope.Add = false;
            $scope.Search = false;
        }

        $http.get($rootScope.WebURL + "/employee")
            .then(function (Employeedata) {
                $scope.Employeedatas = Employeedata.data.data;
            });
        function RefreshGrid() {
            $http.get($rootScope.WebURL + "/employee")
                .then(function (Employeedata) {
                    $scope.Employeedatas = Employeedata.data;
                });
        }

        function ClearForm() {
            $scope.uEmployeeName = '';
            $scope.uBusinessUnit = '';
            $scope.uJobCategory = '';
            $scope.uCostCentre = '';
            $scope.uDesignation = '';
            $scope.uJobTitle = '';
            $scope.uTeam = '';
            $scope.uDivision = '';
            $scope.uLeaveType = '';
            $scope.uDateApply = '';
            $scope.uFrom = '';
            $scope.uTo = '';
            $scope.uApplyFor = '';
            $scope.uReason = '';
            $scope.uDateResumeWork = '';
            $scope.uRelietPersonalDuringLeave = '';
            $scope.uStatus = '';
        }

        var vm = this;
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) {
                return { abbrev: state };
            });

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',

            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#employee-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };
        $mdDateLocale.formatDate = formatDate;
        function formatDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
               'btford.socket-io'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'fuse-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation', 
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar', 
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2', 
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation', 
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar', 
            },
            {
                label : 'Content Only',
                value : 'contentOnly', 
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .value('version', '0.1')
        .factory('socket', ['socketFactory', function (socketFactory) {

            return socketFactory({
                ioSocket: io.connect(window.appConfig.WebURL)
                // ioSocket: io.connect('https://staging.schedule-x.co:3420')
                // ioSocket: io.connect('https://localhost:3420')
            });
        }]);

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at https://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [
                {
                    string: $window.navigator.userAgent,
                    subString: 'Edge',
                    versionSearch: 'Edge',
                    identity: 'Edge'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity: 'Chrome'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity: 'OmniWeb'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Apple',
                    versionSearch: 'Version',
                    identity: 'Safari'
                },
                {
                    prop: $window.opera,
                    identity: 'Opera'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'iCab',
                    identity: 'iCab'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'KDE',
                    identity: 'Konqueror'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'Firefox'
                },
                {
                    string: $window.navigator.vendor,
                    subString: 'Camino',
                    identity: 'Camino'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity: 'Netscape'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Trident/7',
                    identity: 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Gecko',
                    identity: 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string: $window.navigator.userAgent,
                    subString: 'Mozilla',
                    identity: 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string: $window.navigator.platform,
                    subString: 'Win',
                    identity: 'Windows'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Mac',
                    identity: 'Mac'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Linux',
                    identity: 'Linux'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPhone',
                    identity: 'iPhone'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPod',
                    identity: 'iPod'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'iPad',
                    identity: 'iPad'
                },
                {
                    string: $window.navigator.platform,
                    subString: 'Android',
                    identity: 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;

                        }
                    }
                    else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function () {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            }
            else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('httpservice', ['$http',function($http) {
        var myService = {
          customer:{
            response : {}
          },
          lead:{
            response:{}
          },
          contract:{
            response:{}
          },
          salesOrder:{
            response:{}
          }
        };
        return myService;
            
        }])
        

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();


(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($scope, $window, $rootScope, $interval, $mdToast, $mdDialog, $document, $location, $mdSidenav, $http, $translate) {
    var IsAccess = localStorage.getItem('IsAuthenticated');
    if (IsAccess == "false" || IsAccess == '' || IsAccess == undefined) {
      $location.path("login");
    }

    $rootScope.TrackURL = "";

    $scope.TrackURL = $rootScope.TrackURL + "login?";

    $scope.LeaveRequest = false;
    $scope.MaterialRequest = false;
    $scope.PurchaseRequest = false;
    $scope.UniformRequest = false;
    $scope.IncidentReporting = false;
    $scope.MedicalClaim = false;
    $scope.ExpenseClaim = false;
    $scope.PaymentVoucher = false

    var chkAceses = localStorage.getItem('pages');
    if (chkAceses.split(",").includes("LeaveR")) {
      $scope.LeaveRequest = true;
    } else {
      $scope.LeaveRequest = false;
    }
    if (chkAceses.split(",").includes("MaterialR")) {
      $scope.MaterialRequest = true;
    } else {
      $scope.MaterialRequest = false;
    }
    if (chkAceses.split(",").includes("PurchaseR")) {
      $scope.PurchaseRequest = true;
    } else {
      $scope.PurchaseRequest = false;
    }
    if (chkAceses.split(",").includes("UniformR")) {
      $scope.UniformRequest = true;
    } else {
      $scope.UniformRequest = false;
    }
    if (chkAceses.split(",").includes("Incident")) {
      $scope.IncidentReporting = true;
    } else {
      $scope.IncidentReporting = false;
    }
    if (chkAceses.split(",").includes("Medical")) {
      $scope.MedicalClaim = true;
    } else {
      $scope.MedicalClaim = false;
    }
    if (chkAceses.split(",").includes("Expense")) {
      $scope.ExpenseClaim = true;
    } else {
      $scope.ExpenseClaim = false;
    }
    if (chkAceses.split(",").includes("Payment")) {
      $scope.PaymentVoucher = true;
    } else {
      $scope.PaymentVoucher = false;
    }


    if (chkAceses.split(",").includes("Customers")) { $scope.CustomersTool = true; }
    else { $scope.CustomersTool = false }
    if (chkAceses.split(",").includes("Contracts")) { $scope.ContractsTool = true; }
    else { $scope.ContractsTool = false }
    if (chkAceses.split(",").includes("Sales")) { $scope.WorkOrdersTool = true; }
    else { $scope.WorkOrdersTool = false }
    if (chkAceses.split(",").includes("Scheduler")) { $scope.SchedulerTool = true; }
    else { $scope.SchedulerTool = false }

    $scope.uLoginID = localStorage.getItem('LoginID');
    $rootScope.UserName = localStorage.getItem('UserName');

    $scope.HelpOpen = function () {
      window.open($rootScope.HelptURL)
    }
    $scope.logout = function () {
      localStorage.clear();
      var response = $http({
        method: "POST",
        url: $rootScope.WebURL + "/login/logout",
        data: {
          UserID: $scope.uLoginID,
        },
      });
      response.then(function (GList) {

        $location.path("login");
        //window.location = "login";
        $mdToast.show($mdToast.simple().textContent('Successfully Logged Out!').position('top center'));
      }, function () {
        $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));
      });
    }

    $scope.cpSubmit = function () {

      if ($scope.uCNewPassword == $scope.uNewPassword) {
        var response = $http({
          method: "POST",
          url: $rootScope.WebURL + "/login/changePassword",
          data: {
            UserID: $scope.uLoginID,
            CNewPassword: $scope.uCNewPassword,
            oPassword: $scope.uOldPassword,
          },
        });

        response.then(function (GList) {

          if (GList.data.message == 'Invalid Old Password') {
            $scope.Error9 = true;
            $scope.Error8 = false;

            return;
          }
          $mdToast.show($mdToast.simple().textContent('Successfully Changed!').position('top center'));
          $mdDialog.cancel();
        }, function () {
          $mdToast.show($mdToast.simple().textContent('Something entered gone wrong,please try again !').position('top center'));

        });
      } else {
        $scope.Error9 = false;
        $scope.Error8 = true;
        return;
      }
    }

    $scope.cpmodal = function (e) {

      $mdDialog.show({
        controller: ToolbarController,
        templateUrl: 'app/toolbar/layouts/cpmodal.html',
        parent: angular.element($document.body),
        targetEvent: e,
        $scope: $scope,
        clickOutsideToClose: true
      });
    }
    $scope.cancel = function () {
      $mdDialog.cancel();
    };


    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    $rootScope.global = {
      search: ''
    };

    vm.languages = [{
      'title': 'English',
      'translation': 'TOOLBAR.ENGLISH',
      'code': 'en',
      'flag': 'gb'
    },
    {
      'title': 'Spanish',
      'translation': 'TOOLBAR.SPANISH',
      'code': 'vt',
      'flag': 'es'
    },
      //{
      //    'title'      : 'Turkish',
      //    'translation': 'TOOLBAR.TURKISH',
      //    'code'       : 'tr',
      //    'flag'       : 'tr'
      //}
    ];

    // Methods
    vm.toggleSidenav = toggleSidenav;

    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    //////////

    //vm.userStatus = vm.userStatusOptions[0];
    vm.selectedLanguage = vm.languages[0];

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Change Language
     
     */
    var DefaultLanguage = localStorage.getItem('DefaultLanguage');

    if (DefaultLanguage === 'Vietnamese') {
      vm.selectedLanguage = vm.languages[1];
      $translate.use('es');

      $rootScope.lengthMenu = "Hiển thị _MENU_ bản ghi cho mỗi trang";
      $rootScope.zeroRecords = "Không tìm thấy gì - xin lỗi";
      $rootScope.info = "Đang hiển thị trang _PAGE_ của _PAGES_";
      $rootScope.infoEmpty = "Không có hồ sơ nào";
      $rootScope.infoFiltered = "(được lọc từ _MAX_ tổng số hồ sơ)";
      $rootScope.Header = "Cảm ơn bạn đã chấp nhận chúng tôi cho dự án trên.";
      $rootScope.Footer = "Theo thoả thuận này, CLIENT sẽ thanh toán trước cho thỏa thuận bảo trì hàng năm theo quy định trong bảng được chỉ định và tất cả các mức giá được trích đều phải tuân theo GST hiện hành. <br> <br> Nếu bạn có bất kỳ lời giải thích nào, xin đừng ngần ngại liên hệ với tôi. <br> <br> Cảm ơn bạn. </ p> '";
      $window.localStorage.setItem('MenuReports', 'Báo cáo');
    }


    function changeLanguage(lang) {
      debugger
      vm.selectedLanguage = lang;



      $window.localStorage.setItem('currentlanguage', lang.code);
      debugger
      $rootScope.lengthMenu = "Display _MENU_ records per page";
      $rootScope.zeroRecords = "Nothing found - sorry";
      $rootScope.info = "Showing page _PAGE_ of _PAGES_";
      $rootScope.infoEmpty = "No records available";
      $rootScope.infoFiltered = "(filtered from _MAX_ total records)";
      $rootScope.Header = "Thank you for accepting us for the above project.";
      $rootScope.Footer = "It is hereby agreed that the CLIENT will make annual payments in advance for the maintenance agreement as stipulated in the table indicated and all prices quoted are subjected to prevailing GST.<br><br>Should you have any clarifications, please do not hesitate to contact me.<br><br>Thank you.</p>'";
      $window.localStorage.setItem('MenuReports', 'Reports');

      if (lang.code === 'vt') {
        $translate.use('es');

        $rootScope.lengthMenu = "Hiển thị _MENU_ bản ghi cho mỗi trang";
        $rootScope.zeroRecords = "Không tìm thấy gì - xin lỗi";
        $rootScope.info = "Đang hiển thị trang _PAGE_ của _PAGES_";
        $rootScope.infoEmpty = "Không có hồ sơ nào";
        $rootScope.infoFiltered = "(được lọc từ _MAX_ tổng số hồ sơ)";
        $rootScope.Header = "Cảm ơn bạn đã chấp nhận chúng tôi cho dự án trên.";
        $rootScope.Footer = "Theo thoả thuận này, CLIENT sẽ thanh toán trước cho thỏa thuận bảo trì hàng năm theo quy định trong bảng được chỉ định và tất cả các mức giá được trích đều phải tuân theo GST hiện hành. <br> <br> Nếu bạn có bất kỳ lời giải thích nào, xin đừng ngần ngại liên hệ với tôi. <br> <br> Cảm ơn bạn. </ p> '";
        $window.localStorage.setItem('MenuReports', 'Báo cáo');

      } else {
        $translate.use(lang.code);
      }
      //Change the language
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();
 
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($http, $rootScope, $scope, $mdToast, $timeout, $document, msApi, socket) {


        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud: false,
            retro: true
        };
        Refresh()

        function Refresh() {
            // get Employee  Leave Details
            $scope.uFrom = new Date()
            $scope.uTo = new Date()
            var response = $http({
                url: $rootScope.WebURL + "/leaveentitlement/getByDate",
                method: "POST",
                data: {
                    StartDate: $scope.uFrom,
                    EndDate: $scope.uTo,
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                $scope.Leavedetails = GList.data.data
            })

            // get customers follow up date

            var response = $http({
                url: $rootScope.WebURL + "/customer/getByFollowup",
                method: "POST",
                data: {
                    Client_Id: $rootScope.Client_Id,
                },
            });
            response.then(function (GList) {
                $scope.Followupdate = GList.data.data
            })
            // Lead expected response date 
            var response = $http({
                url: $rootScope.WebURL + "/lead/getbyresponsedate",
                method: "POST",
                data: {
                    Client_Id: $rootScope.Client_Id, StartDate: new Date(), EndDate: new Date()
                },
            });
            response.then(function (GList) {
                $scope.Leaddata = GList.data.data
            })
            var response = $http({
                url: $rootScope.WebURL + "/contract/getToday",
                method: "POST",
                data: {
                    Client_Id: $rootScope.Client_Id, StartDate: new Date(), EndDate: new Date(), FieldName: "ServiceStartDate"
                },
            });
            response.then(function (GList) {
                $scope.ContractStartdata = GList.data.data
            })
            var response = $http({
                url: $rootScope.WebURL + "/contract/getToday",
                method: "POST",
                data: {
                    Client_Id: $rootScope.Client_Id, StartDate: new Date(), EndDate: new Date(), FieldName: "ServiceEndDate"
                },
            });
            response.then(function (GList) {
                $scope.ContractEndData = GList.data.data
            })
        }

        function RefreshAttachments() {

        }

        socket.on('Chemical Request Status Changed', function (data) {
            $http.get($rootScope.WebURL + "/chemicalrequest/newCount")
                .then(function (chemical) {
                    var ChemicalCount = chemical.data.data;
                    sessionStorage.setItem('ChemicalCount', ChemicalCount)
                    var element = document.getElementsByClassName('badge white-fg')
                    angular.forEach(element, function (ele) {
                        if ((ele.parentElement.innerText).includes('Chemical Request')) {
                            ele.innerText = ChemicalCount
                        }
                    })
                });
        })

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response) {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response) {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response) {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'dx',
            'ngMap',
            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Apps
            'apps.dashboard',
            'app.customerportal',
            'app.security',
            'app.human-resource',
            'app.crm',
            'app.operations',
            'app.procurement',
            'app.applyleave',
           'app.accounts',
            // Pages
            'app.pages',
             
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $http)
    {
       
        $rootScope.createdby = localStorage.getItem('LoginID');
        $rootScope.currentPage = '';
        $rootScope.itemsPerPage = '';
        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
//! AlaSQL v0.4.0 | © 2014-2016 Andrey Gershun & Mathias Rangel Wulff | License: MIT 
!function (e, t) { "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : e.alasql = t() }(this, function () {
    function e(e) { return "(y=" + e + ",y===y?y:undefined)" } function t(e, t) { return "(y=" + e + ',typeof y=="undefined"?undefined:' + t + ")" } function r() { return !0 } function n() { } function a() { var e = navigator.userAgent.toLowerCase(); return -1 !== e.indexOf("msie") && parseInt(e.split("msie")[1]) } function i(e, t, r) { function n(e, r, a) { var o, u, c, l = e[r]; if (l.selid) { if ("PATH" === l.selid) { for (var h = [{ node: a, stack: [] }], d = {}, f = A.databases[A.useid].objects; h.length > 0;) { var p = h.shift(), b = p.node, E = p.stack, c = n(l.args, 0, b); if (c.length > 0) { if (r + 1 + 1 > e.length) return E; var g = []; return E && E.length > 0 && E.forEach(function (t) { g = g.concat(n(e, r + 1, t)) }), g } void 0 === d[b.$id] && (d[b.$id] = !0, b.$out && b.$out.length > 0 && b.$out.forEach(function (e) { var t = f[e], r = E.concat(t); r.push(f[t.$out[0]]), h.push({ node: f[t.$out[0]], stack: r }) })) } return [] } if ("NOT" === l.selid) { var u = n(l.args, 0, a); return u.length > 0 ? [] : r + 1 + 1 > e.length ? [a] : n(e, r + 1, a) } if ("DISTINCT" === l.selid) { var u; if (u = void 0 === l.args || 0 === l.args.length ? q(a) : n(l.args, 0, a), 0 === u.length) return []; var m = q(u); return r + 1 + 1 > e.length ? m : n(e, r + 1, m) } if ("AND" === l.selid) { var m = !0; return l.args.forEach(function (e) { m = m && n(e, 0, a).length > 0 }), m ? r + 1 + 1 > e.length ? [a] : n(e, r + 1, a) : [] } if ("OR" === l.selid) { var m = !1; return l.args.forEach(function (e) { m = m || n(e, 0, a).length > 0 }), m ? r + 1 + 1 > e.length ? [a] : n(e, r + 1, a) : [] } if ("ALL" === l.selid) { var u = n(l.args[0], 0, a); return 0 === u.length ? [] : r + 1 + 1 > e.length ? u : n(e, r + 1, u) } if ("ANY" === l.selid) { var u = n(l.args[0], 0, a); return 0 === u.length ? [] : r + 1 + 1 > e.length ? [u[0]] : n(e, r + 1, [u[0]]) } if ("UNIONALL" === l.selid) { var u = []; return l.args.forEach(function (e) { u = u.concat(n(e, 0, a)) }), 0 === u.length ? [] : r + 1 + 1 > e.length ? u : n(e, r + 1, u) } if ("UNION" === l.selid) { var u = []; l.args.forEach(function (e) { u = u.concat(n(e, 0, a)) }); var u = q(u); return 0 === u.length ? [] : r + 1 + 1 > e.length ? u : n(e, r + 1, u) } if ("IF" === l.selid) { var u = n(l.args, 0, a); return 0 === u.length ? [] : r + 1 + 1 > e.length ? [a] : n(e, r + 1, a) } if ("REPEAT" === l.selid) { var v, S, T = l.args[0].value; S = l.args[1] ? l.args[1].value : T, l.args[2] && (v = l.args[2].variable); var y = []; if (0 === T && (r + 1 + 1 > e.length ? y = [a] : (v && (A.vars[v] = 0), y = y.concat(n(e, r + 1, a)))), S > 0) for (var N = [{ value: a, lvl: 1 }], C = 0; N.length > 0;) { var u = N[0]; if (N.shift(), u.lvl <= S) { v && (A.vars[v] = u.lvl); var R = n(l.sels, 0, u.value); R.forEach(function (e) { N.push({ value: e, lvl: u.lvl + 1 }) }), u.lvl >= T && (r + 1 + 1 > e.length ? y = y.concat(R) : R.forEach(function (t) { y = y.concat(n(e, r + 1, t)) })) } if (++C > 1e5) throw new Error("Security brake. Number of iterations = " + C) } return y } if ("OF" === l.selid) { if (r + 1 + 1 > e.length) return [a]; var O = []; return Object.keys(a).forEach(function (t) { A.vars[l.args[0].variable] = t, O = O.concat(n(e, r + 1, a[t])) }), O } if ("TO" === l.selid) { var w = A.vars[l.args[0]], I = []; if (I = void 0 !== w ? w.slice(0) : [], I.push(a), r + 1 + 1 > e.length) return [a]; A.vars[l.args[0]] = I; var O = n(e, r + 1, a); return A.vars[l.args[0]] = w, O } if ("ARRAY" === l.selid) { var u = n(l.args, 0, a); return u.length > 0 ? (o = u, r + 1 + 1 > e.length ? [o] : n(e, r + 1, o)) : [] } if ("SUM" === l.selid) { var u = n(l.args, 0, a); if (!(u.length > 0)) return []; var o = u.reduce(function (e, t) { return e + t }, 0); return r + 1 + 1 > e.length ? [o] : n(e, r + 1, o) } if ("AVG" === l.selid) return u = n(l.args, 0, a), u.length > 0 ? (o = u.reduce(function (e, t) { return e + t }, 0) / u.length, r + 1 + 1 > e.length ? [o] : n(e, r + 1, o)) : []; if ("COUNT" === l.selid) return u = n(l.args, 0, a), u.length > 0 ? (o = u.length, r + 1 + 1 > e.length ? [o] : n(e, r + 1, o)) : []; if ("FIRST" === l.selid) return u = n(l.args, 0, a), u.length > 0 ? (o = u[0], r + 1 + 1 > e.length ? [o] : n(e, r + 1, o)) : []; if ("LAST" === l.selid) return u = n(l.args, 0, a), u.length > 0 ? (o = u[u.length - 1], r + 1 + 1 > e.length ? [o] : n(e, r + 1, o)) : []; if ("MIN" === l.selid) { if (u = n(l.args, 0, a), 0 === u.length) return []; var o = u.reduce(function (e, t) { return Math.min(e, t) }, 1 / 0); return r + 1 + 1 > e.length ? [o] : n(e, r + 1, o) } if ("MAX" === l.selid) { var u = n(l.args, 0, a); if (0 === u.length) return []; var o = u.reduce(function (e, t) { return Math.max(e, t) }, -1 / 0); return r + 1 + 1 > e.length ? [o] : n(e, r + 1, o) } if ("PLUS" === l.selid) { var y = [], N = n(l.args, 0, a).slice(); r + 1 + 1 > e.length ? y = y.concat(N) : N.forEach(function (t) { y = y.concat(n(e, r + 1, t)) }); for (var C = 0; N.length > 0;) { var u = N.shift(); if (u = n(l.args, 0, u), N = N.concat(u), r + 1 + 1 > e.length ? y = y.concat(u) : u.forEach(function (t) { var a = n(e, r + 1, t); y = y.concat(a) }), ++C > 1e5) throw new Error("Security brake. Number of iterations = " + C) } return y } if ("STAR" === l.selid) { var y = []; y = n(e, r + 1, a); var N = n(l.args, 0, a).slice(); r + 1 + 1 > e.length ? y = y.concat(N) : N.forEach(function (t) { y = y.concat(n(e, r + 1, t)) }); for (var C = 0; N.length > 0;) { var u = N[0]; if (N.shift(), u = n(l.args, 0, u), N = N.concat(u), r + 1 + 1 <= e.length && u.forEach(function (t) { y = y.concat(n(e, r + 1, t)) }), ++C > 1e5) throw new Error("Loop brake. Number of iterations = " + C) } return y } if ("QUESTION" === l.selid) { var y = []; y = y.concat(n(e, r + 1, a)); var u = n(l.args, 0, a); return r + 1 + 1 <= e.length && u.forEach(function (t) { y = y.concat(n(e, r + 1, t)) }), y } if ("WITH" !== l.selid) { if ("ROOT" === l.selid) return r + 1 + 1 > e.length ? [a] : n(e, r + 1, s); throw new Error("Wrong selector " + l.selid) } var u = n(l.args, 0, a); if (0 === u.length) return []; var c = { status: 1, values: u } } else { if (!l.srchid) throw new Error("Selector not found"); var c = A.srch[l.srchid.toUpperCase()](a, l.args, i, t) } void 0 === c && (c = { status: 1, values: [a] }); var m = []; if (1 === c.status) { var x = c.values; if (r + 1 + 1 > e.length) m = x; else for (var C = 0; C < c.values.length; C++)m = m.concat(n(e, r + 1, x[C])) } return m } var a, s, i = {}, o = F(this.selectors); if (void 0 !== o && o.length > 0 && (o && o[0] && "PROP" === o[0].srchid && o[0].args && o[0].args[0] && ("XML" === o[0].args[0].toUpperCase() ? (i.mode = "XML", o.shift()) : "HTML" === o[0].args[0].toUpperCase() ? (i.mode = "HTML", o.shift()) : "JSON" === o[0].args[0].toUpperCase() && (i.mode = "JSON", o.shift())), o.length > 0 && "VALUE" === o[0].srchid && (i.value = !0, o.shift())), this.from instanceof Q.Column) { var u = this.from.databaseid || e; s = A.databases[u].tables[this.from.columnid].data } else if (this.from instanceof Q.FuncValue && A.from[this.from.funcid.toUpperCase()]) { var c = this.from.args.map(function (e) { var r = e.toJS(); return new Function("params,alasql", "var y;return " + r).bind(this)(t, A) }); s = A.from[this.from.funcid.toUpperCase()].apply(this, c) } else if (void 0 === this.from) s = A.databases[e].objects; else { var l = new Function("params,alasql", "var y;return " + this.from.toJS()); s = l(t, A), "object" == typeof Mongo && "object" != typeof Mongo.Collection && s instanceof Mongo.Collection && (s = s.find().fetch()) } if (a = void 0 !== o && o.length > 0 ? n(o, 0, s) : s, this.into) { var h, d; void 0 !== this.into.args[0] && (h = new Function("params,alasql", "var y;return " + this.into.args[0].toJS())(t, A)), void 0 !== this.into.args[1] && (d = new Function("params,alasql", "var y;return " + this.into.args[1].toJS())(t, A)), a = A.into[this.into.funcid.toUpperCase()](h, d, a, [], r) } else i.value && a.length > 0 && (a = a[0]), r && (a = r(a)); return a } function o(e, t, r, n, a) { e.sources.length; e.sourceslen = e.sources.length; var s = e.sourceslen; e.query = e, e.A = n, e.B = a, e.cb = r, e.oldscope = t, e.queriesfn && (e.sourceslen += e.queriesfn.length, s += e.queriesfn.length, e.queriesdata = [], e.queriesfn.forEach(function (t, r) { t.query.params = e.params, u([], -r - 1, e) })); var i; i = t ? F(t) : {}, e.scope = i; var o; return e.sources.forEach(function (t, r) { t.query = e; var n = t.datafn(e, e.params, u, r, A); void 0 !== n && ((e.intofn || e.intoallfn) && Array.isArray(n) && (n = n.length), o = n), t.queriesdata = e.queriesdata }), 0 != e.sources.length && 0 !== s || (o = c(e)), o } function u(e, t, r) { if (t >= 0) { var n = r.sources[t]; n.data = e, "function" == typeof n.data && (n.getfn = n.data, n.dontcache = n.getfn.dontcache, "OUTER" != n.joinmode && "RIGHT" != n.joinmode && "ANTI" != n.joinmode || (n.dontcache = !1), n.data = {}) } else r.queriesdata[-t - 1] = V(e); if (!(--r.sourceslen > 0)) return c(r) } function c(e) { var t, r = e.scope; ee(e), e.data = [], e.xgroups = {}, e.groups = []; if (d(e, r, 0), e.groupfn) { if (e.data = [], 0 === e.groups.length) { var n = {}; e.selectGroup.length > 0 && e.selectGroup.forEach(function (e) { "COUNT" == e.aggregatorid || "SUM" == e.aggregatorid ? n[e.nick] = 0 : n[e.nick] = void 0 }), e.groups = [n] } if (e.aggrKeys.length > 0) { var a = ""; e.aggrKeys.forEach(function (e) { a += "g['" + e.nick + "']=alasql.aggr['" + e.funcid + "'](undefined,g['" + e.nick + "'],3);" }); var s = new Function("g,params,alasql", "var y;" + a) } for (var i = 0, o = e.groups.length; i < o; i++) { var n = e.groups[i]; if (s && s(n, e.params, A), !e.havingfn || e.havingfn(n, e.params, A)) { var u = e.selectgfn(n, e.params, A); e.data.push(u) } } } if (h(e), e.unionallfn) { var c, f; if (e.corresponding) e.unionallfn.query.modifier || (e.unionallfn.query.modifier = void 0), c = e.unionallfn(e.params); else { e.unionallfn.query.modifier || (e.unionallfn.query.modifier = "RECORDSET"), f = e.unionallfn(e.params), c = [], o = f.data.length; for (var i = 0; i < o; i++) { for (var p = {}, b = Math.min(e.columns.length, f.columns.length) - 1; 0 <= b; b--)p[e.columns[b].columnid] = f.data[i][f.columns[b].columnid]; c.push(p) } } e.data = e.data.concat(c) } else if (e.unionfn) { if (e.corresponding) e.unionfn.query.modifier || (e.unionfn.query.modifier = "ARRAY"), c = e.unionfn(e.params); else { e.unionfn.query.modifier || (e.unionfn.query.modifier = "RECORDSET"), f = e.unionfn(e.params), c = [], o = f.data.length; for (var i = 0; i < o; i++) { p = {}, t = Math.min(e.columns.length, f.columns.length); for (var b = 0; b < t; b++)p[e.columns[b].columnid] = f.data[i][f.columns[b].columnid]; c.push(p) } } e.data = M(e.data, c) } else if (e.exceptfn) { if (e.corresponding) { e.exceptfn.query.modifier || (e.exceptfn.query.modifier = "ARRAY"); var c = e.exceptfn(e.params) } else { e.exceptfn.query.modifier || (e.exceptfn.query.modifier = "RECORDSET"); for (var f = e.exceptfn(e.params), c = [], i = 0, o = f.data.length; i < o; i++) { for (var p = {}, b = Math.min(e.columns.length, f.columns.length) - 1; 0 <= b; b--)p[e.columns[b].columnid] = f.data[i][f.columns[b].columnid]; c.push(p) } } e.data = U(e.data, c) } else if (e.intersectfn) { if (e.corresponding) e.intersectfn.query.modifier || (e.intersectfn.query.modifier = void 0), c = e.intersectfn(e.params); else for (e.intersectfn.query.modifier || (e.intersectfn.query.modifier = "RECORDSET"), f = e.intersectfn(e.params), c = [], o = f.data.length, i = 0; i < o; i++) { for (p = {}, t = Math.min(e.columns.length, f.columns.length), b = 0; b < t; b++)p[e.columns[b].columnid] = f.data[i][f.columns[b].columnid]; c.push(p) } e.data = _(e.data, c) } if (e.orderfn) { if (e.explain) var E = Date.now(); e.data = e.data.sort(e.orderfn), e.explain && e.explaination.push({ explid: e.explid++, description: "QUERY BY", ms: Date.now() - E }) } if (l(e), "undefined" != typeof angular && e.removeKeys.push("$$hashKey"), e.removeKeys.length > 0) { var g = e.removeKeys; if ((t = g.length) > 0) for (o = e.data.length, i = 0; i < o; i++)for (b = 0; b < t; b++)delete e.data[i][g[b]]; e.columns.length > 0 && (e.columns = e.columns.filter(function (e) { var t = !1; return g.forEach(function (r) { e.columnid == r && (t = !0) }), !t })) } if (void 0 !== e.removeLikeKeys && e.removeLikeKeys.length > 0) { for (var m = e.removeLikeKeys, i = 0, o = e.data.length; i < o; i++) { p = e.data[i]; for (var v in p) for (b = 0; b < e.removeLikeKeys.length; b++)A.utils.like(e.removeLikeKeys[b], v) && delete p[v] } e.columns.length > 0 && (e.columns = e.columns.filter(function (e) { var t = !1; return m.forEach(function (r) { A.utils.like(r, e.columnid) && (t = !0) }), !t })) } if (e.pivotfn && e.pivotfn(), e.unpivotfn && e.unpivotfn(), e.intoallfn) { var S = e.intoallfn(e.columns, e.cb, e.params, e.alasql); return S } if (e.intofn) { for (o = e.data.length, i = 0; i < o; i++)e.intofn(e.data[i], i, e.params, e.alasql); return e.cb && e.cb(e.data.length, e.A, e.B), e.data.length } return S = e.data, e.cb && (S = e.cb(e.data, e.A, e.B)), S } function l(e) { if (e.limit) { var t = 0; e.offset && (t = 0 | e.offset || 0, t = t < 0 ? 0 : t); var r; r = e.percent ? (e.data.length * e.limit / 100 | 0) + t : (0 | e.limit) + t, e.data = e.data.slice(t, r) } } function h(e) { if (e.distinct) { for (var t = {}, r = 0, n = e.data.length; r < n; r++) { t[Object.keys(e.data[r]).map(function (t) { return e.data[r][t] }).join("`")] = e.data[r] } e.data = []; for (var a in t) e.data.push(t[a]) } } function d(e, t, r) { if (r >= e.sources.length) e.wherefn(t, e.params, A) && (e.groupfn ? e.groupfn(t, e.params, A) : e.data.push(e.selectfn(t, e.params, A))); else if (e.sources[r].applyselect) { var n = e.sources[r]; n.applyselect(e.params, function (a) { if (a.length > 0) for (var s = 0; s < a.length; s++)t[n.alias] = a[s], d(e, t, r + 1); else "OUTER" == n.applymode && (t[n.alias] = {}, d(e, t, r + 1)) }, t) } else { var n = e.sources[r], a = e.sources[r + 1], s = n.alias || n.tableid, i = !1, o = n.data, u = !1; (!n.getfn || n.getfn && !n.dontcache) && "RIGHT" != n.joinmode && "OUTER" != n.joinmode && "ANTI" != n.joinmode && "ix" == n.optimization && (o = n.ix[n.onleftfn(t, e.params, A)] || [], u = !0); var c = 0; if (void 0 === o) throw new Error("Data source number " + r + " in undefined"); for (var l, h = o.length; (l = o[c]) || !u && n.getfn && (l = n.getfn(c)) || c < h;)u || !n.getfn || n.dontcache || (o[c] = l), t[s] = l, n.onleftfn && n.onleftfn(t, e.params, A) != n.onrightfn(t, e.params, A) || n.onmiddlefn(t, e.params, A) && ("SEMI" != n.joinmode && "ANTI" != n.joinmode && d(e, t, r + 1), "LEFT" != n.joinmode && "INNER" != n.joinmode && (l._rightjoin = !0), i = !0), c++; if ("LEFT" != n.joinmode && "OUTER" != n.joinmode && "SEMI" != n.joinmode || i || (t[s] = {}, d(e, t, r + 1)), r + 1 < e.sources.length && ("OUTER" == a.joinmode || "RIGHT" == a.joinmode || "ANTI" == a.joinmode)) { t[n.alias] = {}; for (var l, f = 0, p = a.data.length; (l = a.data[f]) || a.getfn && (l = a.getfn(f)) || f < p;)a.getfn && !a.dontcache && (a.data[f] = l), l._rightjoin ? delete l._rightjoin : 0 == r && (t[a.alias] = l, d(e, t, r + 2)), f++ } t[s] = void 0 } } function f(e, t) { if (void 0 === t || "number" == typeof t || "string" == typeof t || "boolean" == typeof t) return t; var r = e.modifier || A.options.modifier, n = e.columns; if (void 0 === n || 0 == n.length) if (t.length > 0) { for (var a = {}, s = Math.min(t.length, A.options.columnlookup || 10) - 1; 0 <= s; s--)for (var i in t[s]) a[i] = !0; n = Object.keys(a).map(function (e) { return { columnid: e } }) } else n = []; if ("VALUE" === r) if (t.length > 0) { var i; i = n && n.length > 0 ? n[0].columnid : Object.keys(t[0])[0], t = t[0][i] } else t = void 0; else if ("ROW" === r) if (t.length > 0) { var i, o = []; for (var i in t[0]) o.push(t[0][i]); t = o } else t = void 0; else if ("COLUMN" === r) { var u = []; if (t.length > 0) { var i; i = n && n.length > 0 ? n[0].columnid : Object.keys(t[0])[0]; for (var s = 0, c = t.length; s < c; s++)u.push(t[s][i]) } t = u } else if ("MATRIX" === r) { for (var u = [], s = 0; s < t.length; s++) { for (var o = [], l = t[s], h = 0; h < n.length; h++)o.push(l[n[h].columnid]); u.push(o) } t = u } else if ("INDEX" === r) { var i, d, u = {}; if (n && n.length > 0) i = n[0].columnid, d = n[1].columnid; else { var f = Object.keys(t[0]); i = f[0], d = f[1] } for (var s = 0, c = t.length; s < c; s++)u[t[s][i]] = t[s][d]; t = u } else if ("RECORDSET" === r) t = new A.Recordset({ columns: n, data: t }); else if ("TEXTSTRING" === r) { var i; i = n && n.length > 0 ? n[0].columnid : Object.keys(t[0])[0]; for (var s = 0, c = t.length; s < c; s++)t[s] = t[s][i]; t = t.join("\n") } return t } function p(e, t, r) { var n = "", a = []; e.ixsources = {}, e.sources.forEach(function (t) { e.ixsources[t.alias] = t }); var s; if (e.ixsources[t]) var s = e.ixsources[t].columns; return r && "json" == A.options.joinstar && (n += "r['" + t + "']={};"), s && s.length > 0 ? s.forEach(function (s) { r && "underscore" == A.options.joinstar ? a.push("'" + t + "_" + s.columnid + "':p['" + t + "']['" + s.columnid + "']") : r && "json" == A.options.joinstar ? n += "r['" + t + "']['" + s.columnid + "']=p['" + t + "']['" + s.columnid + "'];" : a.push("'" + s.columnid + "':p['" + t + "']['" + s.columnid + "']"), e.selectColumns[R(s.columnid)] = !0; var i = { columnid: s.columnid, dbtypeid: s.dbtypeid, dbsize: s.dbsize, dbprecision: s.dbprecision, dbenum: s.dbenum }; e.columns.push(i), e.xcolumns[i.columnid] = i }) : (n += 'var w=p["' + t + '"];for(var k in w){r[k]=w[k]};', e.dirtyColumns = !0), { s: a.join(","), sp: n } } function b(e, t) { if (Array.isArray(e)) { for (var r = [[]], n = 0; n < e.length; n++)if (e[n] instanceof Q.Column) e[n].nick = R(e[n].columnid), t.groupColumns[e[n].nick] = e[n].nick, r = r.map(function (r) { return r.concat(e[n].nick + "\t" + e[n].toJS("p", t.sources[0].alias, t.defcols)) }); else if (e[n] instanceof Q.FuncValue) t.groupColumns[R(e[n].toString())] = R(e[n].toString()), r = r.map(function (r) { return r.concat(R(e[n].toString()) + "\t" + e[n].toJS("p", t.sources[0].alias, t.defcols)) }); else if (e[n] instanceof Q.GroupExpression) if ("ROLLUP" == e[n].type) r = ae(r, te(e[n].group, t)); else if ("CUBE" == e[n].type) r = ae(r, re(e[n].group, t)); else { if ("GROUPING SETS" != e[n].type) throw new Error("Unknown grouping function"); r = ae(r, ne(e[n].group, t)) } else r = "" === e[n] ? [["1\t1"]] : r.map(function (r) { return t.groupColumns[R(e[n].toString())] = R(e[n].toString()), r.concat(R(e[n].toString()) + "\t" + e[n].toJS("p", t.sources[0].alias, t.defcols)) }); return r } return e instanceof Q.FuncValue ? (t.groupColumns[R(e.toString())] = R(e.toString()), [e.toString() + "\t" + e.toJS("p", t.sources[0].alias, t.defcols)]) : e instanceof Q.Column ? (e.nick = R(e.columnid), t.groupColumns[e.nick] = e.nick, [e.nick + "\t" + e.toJS("p", t.sources[0].alias, t.defcols)]) : (t.groupColumns[R(e.toString())] = R(e.toString()), [R(e.toString()) + "\t" + e.toJS("p", t.sources[0].alias, t.defcols)]) } function E(e, t, r, n) { var a = ""; if ("string" == typeof e) a = '"' + e + '"'; else if ("number" == typeof e) a = "(" + e + ")"; else if ("boolean" == typeof e) a = e; else { if ("object" != typeof e) throw new Error("2Can not parse JSON object " + JSON.stringify(e)); if (Array.isArray(e)) a += "[" + e.map(function (e) { return E(e, t, r, n) }).join(",") + "]"; else if (!e.toJS || e instanceof Q.Json) { a = "{"; var s = []; for (var i in e) { var o = ""; if ("string" == typeof i) o += '"' + i + '"'; else if ("number" == typeof i) o += i; else { if ("boolean" != typeof i) throw new Error("THis is not ES6... no expressions on left side yet"); o += i } o += ":" + E(e[i], t, r, n), s.push(o) } a += s.join(",") + "}" } else { if (!e.toJS) throw new Error("1Can not parse JSON object " + JSON.stringify(e)); a = e.toJS(t, r, n) } } return a } function g(e) { var t = ""; if (void 0 === e) t += "undefined"; else if (Array.isArray(e)) { t += "<style>", t += "table {border:1px black solid; border-collapse: collapse; border-spacing: 0px;}", t += "td,th {border:1px black solid; padding-left:5px; padding-right:5px}", t += "th {background-color: #EEE}", t += "</style>", t += "<table>"; var r = []; for (var n in e[0]) r.push(n); t += "<tr><th>#", r.forEach(function (e) { t += "<th>" + e }); for (var a = 0, s = e.length; a < s; a++)t += "<tr><th>" + (a + 1), r.forEach(function (r) { t += "<td> ", e[a][r] == +e[a][r] ? (t += '<div style="text-align:right">', void 0 === e[a][r] ? t += "NULL" : t += e[a][r], t += "</div>") : void 0 === e[a][r] ? t += "NULL" : "string" == typeof e[a][r] ? t += e[a][r] : t += ce(e[a][r]) }); t += "</table>" } else t += "<p>" + ce(e) + "</p>"; return t } function m(e, t, r) { if (!(r <= 0)) { var n = t - e.scrollTop, a = n / r * 10; setTimeout(function () { e.scrollTop !== t && (e.scrollTop = e.scrollTop + a, m(e, t, r - 10)) }, 10) } } function S(e, t, r, n, a, s) { function i(e) { for (var t = "", r = 0, n = 10240; r < e.byteLength / n; ++r)t += String.fromCharCode.apply(null, new Uint8Array(e.slice(r * n, r * n + n))); return t += String.fromCharCode.apply(null, new Uint8Array(e.slice(r * n))) } var o = {}; r = r || {}, A.utils.extend(o, r), void 0 === o.headers && (o.headers = !0); t = A.utils.autoExtFilename(t, "xls", r), A.utils.loadBinaryFile(t, !!n, function (t) { if (t instanceof ArrayBuffer) var r = i(t), u = e.read(btoa(r), { type: "base64" }); else var u = e.read(t, { type: "binary" }); var c; c = void 0 === o.sheetid ? u.SheetNames[0] : o.sheetid; var l; void 0 === o.range ? l = u.Sheets[c]["!ref"] : (l = o.range, u.Sheets[c][l] && (l = u.Sheets[c][l])); for (var h = l.split(":"), d = h[0].match(/[A-Z]+/)[0], f = +h[0].match(/[0-9]+/)[0], p = h[1].match(/[A-Z]+/)[0], b = +h[1].match(/[0-9]+/)[0], E = {}, g = A.utils.xlscn(d), m = A.utils.xlscn(p), v = g; v <= m; v++) { var S = A.utils.xlsnc(v); o.headers && u.Sheets[c][S + "" + f] ? E[S] = u.Sheets[c][S + "" + f].v : E[S] = S } var T = []; o.headers && f++; for (var y = f; y <= b; y++) { for (var N = {}, v = g; v <= m; v++) { var S = A.utils.xlsnc(v); u.Sheets[c][S + "" + y] && (N[E[S]] = u.Sheets[c][S + "" + y].v) } T.push(N) } T.length > 0 && T[T.length - 1] && 0 == Object.keys(T[T.length - 1]).length && T.pop(), n && (T = n(T, a, s)) }, function (e) { throw e }) } function T(e) { function t() { if (i(/^<\?xml\s*/)) { for (var e = { attributes: {} }; !o() && !u("?>");) { var t = a(); if (!t) return e; e.attributes[t.name] = t.value } return i(/\?>\s*/), e } } function r() { var e = i(/^<([\w-:.]+)\s*/); if (e) { for (var t = { name: e[1], attributes: {}, children: [] }; !(o() || u(">") || u("?>") || u("/>"));) { var s = a(); if (!s) return t; t.attributes[s.name] = s.value } if (i(/^\s*\/>\s*/)) return t; i(/\??>\s*/), t.content = n(); for (var c; c = r();)t.children.push(c); return i(/^<\/[\w-:.]+>\s*/), t } } function n() { var e = i(/^([^<]*)/); return e ? e[1] : "" } function a() { var e = i(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/); if (e) return { name: e[1], value: s(e[2]) } } function s(e) { return e.replace(/^['"]|['"]$/g, "") } function i(t) { var r = e.match(t); if (r) return e = e.slice(r[0].length), r } function o() { return 0 == e.length } function u(t) { return 0 == e.indexOf(t) } return e = e.trim(), e = e.replace(/<!--[\s\S]*?-->/g, ""), function () { return { declaration: t(), root: r() } }() } var A = function (e, t, r, n) { if (t = t || [], "function" != typeof importScripts && A.webworker) { var a = A.lastid++; return A.buffer[a] = r, void A.webworker.postMessage({ id: a, sql: e, params: t }) } return 0 === arguments.length ? new Q.Select({ columns: [new Q.Column({ columnid: "*" })], from: [new Q.ParamValue({ param: 0 })] }) : 1 === arguments.length && e.constructor === Array ? A.promise(e) : ("function" == typeof t && (n = r, r = t, t = []), "object" != typeof t && (t = [t]), "string" == typeof e && "#" === e[0] && "object" == typeof document ? e = document.querySelector(e).textContent : "object" == typeof e && e instanceof HTMLElement ? e = e.textContent : "function" == typeof e && (e = e.toString().slice(14, -3)), A.exec(e, t, r, n)) }; A.version = "0.4.0", A.debug = void 0; var y = function () { return null }, N = function () {
        function e() { this.yy = {} } var t = function (e, t, r, n) {
            for (r = r || {}, n = e.length; n--; r[e[n]] = t); return r
        }, r = [2, 13], n = [1, 104], a = [1, 102], s = [1, 103], i = [1, 6], o = [1, 42], u = [1, 79], c = [1, 76], l = [1, 94], h = [1, 93], d = [1, 69], f = [1, 101], p = [1, 85], b = [1, 64], E = [1, 71], g = [1, 84], m = [1, 66], v = [1, 70], S = [1, 68], T = [1, 61], y = [1, 74], N = [1, 62], C = [1, 67], R = [1, 83], O = [1, 77], I = [1, 86], x = [1, 87], D = [1, 81], k = [1, 82], L = [1, 80], $ = [1, 88], M = [1, 89], U = [1, 90], _ = [1, 91], F = [1, 92], P = [1, 98], q = [1, 65], G = [1, 78], V = [1, 72], B = [1, 96], j = [1, 97], H = [1, 63], J = [1, 73], Y = [1, 108], W = [1, 107], X = [10, 306, 602, 764], K = [10, 306, 310, 602, 764], Q = [1, 115], z = [1, 116], Z = [1, 117], ee = [1, 118], te = [1, 119], re = [130, 353, 410], ne = [1, 127], ae = [1, 126], se = [1, 134], ie = [1, 164], oe = [1, 175], ue = [1, 178], ce = [1, 173], le = [1, 181], he = [1, 185], de = [1, 160], fe = [1, 182], pe = [1, 169], be = [1, 171], Ee = [1, 174], ge = [1, 183], me = [1, 166], ve = [1, 193], Se = [1, 188], Te = [1, 189], Ae = [1, 194], ye = [1, 195], Ne = [1, 196], Ce = [1, 197], Re = [1, 198], Oe = [1, 199], we = [1, 200], Ie = [1, 201], xe = [1, 202], De = [1, 176], ke = [1, 177], Le = [1, 179], $e = [1, 180], Me = [1, 186], Ue = [1, 192], _e = [1, 184], Fe = [1, 187], Pe = [1, 172], qe = [1, 170], Ge = [1, 191], Ve = [1, 203], Be = [2, 4, 5], je = [2, 471], He = [1, 206], Je = [1, 211], Ye = [1, 220], We = [1, 216], Xe = [10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 183, 198, 232, 245, 247, 306, 310, 602, 764], Ke = [2, 4, 5, 10, 72, 76, 77, 78, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 183, 185, 187, 198, 280, 281, 282, 283, 284, 285, 286, 287, 288, 306, 310, 420, 424, 602, 764], Qe = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], ze = [1, 249], Ze = [1, 256], et = [1, 265], tt = [1, 270], rt = [1, 269], nt = [2, 4, 5, 10, 72, 77, 78, 93, 98, 107, 118, 128, 131, 132, 137, 143, 145, 149, 152, 154, 156, 162, 168, 169, 179, 180, 181, 183, 198, 232, 245, 247, 265, 266, 270, 271, 273, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 302, 303, 306, 310, 312, 317, 420, 424, 602, 764], at = [2, 162], st = [1, 281], it = [10, 74, 78, 306, 310, 505, 602, 764], ot = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 193, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 302, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 344, 356, 368, 369, 370, 373, 374, 386, 389, 396, 400, 401, 402, 403, 404, 405, 406, 408, 409, 417, 418, 420, 424, 426, 433, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 514, 515, 516, 517, 602, 764], ut = [2, 4, 5, 10, 53, 72, 89, 124, 146, 156, 189, 266, 267, 290, 306, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 517, 602, 764], ct = [1, 562], lt = [1, 564], ht = [2, 503], dt = [1, 569], ft = [1, 580], pt = [1, 583], bt = [1, 584], Et = [10, 78, 89, 132, 137, 146, 189, 296, 306, 310, 470, 602, 764], gt = [10, 74, 306, 310, 602, 764], mt = [2, 567], vt = [1, 602], St = [2, 4, 5, 156], Tt = [1, 640], At = [1, 612], yt = [1, 646], Nt = [1, 647], Ct = [1, 620], Rt = [1, 631], Ot = [1, 618], wt = [1, 626], It = [1, 619], xt = [1, 627], Dt = [1, 629], kt = [1, 621], Lt = [1, 622], $t = [1, 641], Mt = [1, 638], Ut = [1, 639], _t = [1, 615], Ft = [1, 617], Pt = [1, 609], qt = [1, 610], Gt = [1, 611], Vt = [1, 613], Bt = [1, 614], jt = [1, 616], Ht = [1, 623], Jt = [1, 624], Yt = [1, 628], Wt = [1, 630], Xt = [1, 632], Kt = [1, 633], Qt = [1, 634], zt = [1, 635], Zt = [1, 636], er = [1, 642], tr = [1, 643], rr = [1, 644], nr = [1, 645], ar = [2, 287], sr = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], ir = [2, 359], or = [1, 668], ur = [1, 678], cr = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], lr = [1, 694], hr = [1, 703], dr = [1, 702], fr = [2, 4, 5, 10, 72, 74, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], pr = [10, 72, 74, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], br = [2, 202], Er = [1, 725], gr = [10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 183, 232, 245, 247, 306, 310, 602, 764], mr = [2, 163], vr = [1, 728], Sr = [2, 4, 5, 112], Tr = [1, 741], Ar = [1, 760], yr = [1, 740], Nr = [1, 739], Cr = [1, 734], Rr = [1, 735], Or = [1, 737], wr = [1, 738], Ir = [1, 742], xr = [1, 743], Dr = [1, 744], kr = [1, 745], Lr = [1, 746], $r = [1, 747], Mr = [1, 748], Ur = [1, 749], _r = [1, 750], Fr = [1, 751], Pr = [1, 752], qr = [1, 753], Gr = [1, 754], Vr = [1, 755], Br = [1, 756], jr = [1, 757], Hr = [1, 759], Jr = [1, 761], Yr = [1, 762], Wr = [1, 763], Xr = [1, 764], Kr = [1, 765], Qr = [1, 766], zr = [1, 767], Zr = [1, 770], en = [1, 771], tn = [1, 772], rn = [1, 773], nn = [1, 774], an = [1, 775], sn = [1, 776], on = [1, 777], un = [1, 778], cn = [1, 779], ln = [1, 780], hn = [1, 781], dn = [74, 89, 189], fn = [10, 74, 78, 154, 187, 230, 297, 306, 310, 343, 356, 368, 369, 373, 374, 602, 764], pn = [1, 798], bn = [10, 74, 78, 300, 306, 310, 602, 764], En = [1, 799], gn = [1, 805], mn = [1, 806], vn = [1, 810], Sn = [10, 74, 78, 306, 310, 602, 764], Tn = [2, 4, 5, 77, 131, 132, 137, 143, 145, 149, 152, 154, 156, 179, 180, 181, 265, 266, 270, 271, 273, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 302, 303, 312, 317, 420, 424], An = [10, 72, 78, 93, 98, 107, 118, 128, 162, 168, 169, 183, 198, 232, 245, 247, 306, 310, 602, 764], yn = [2, 4, 5, 10, 72, 77, 78, 93, 98, 107, 118, 128, 131, 132, 137, 143, 145, 149, 152, 154, 156, 162, 164, 168, 169, 179, 180, 181, 183, 185, 187, 195, 198, 232, 245, 247, 265, 266, 270, 271, 273, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 302, 303, 306, 310, 312, 317, 420, 424, 602, 764], Nn = [2, 4, 5, 132, 296], Cn = [1, 844], Rn = [10, 74, 76, 78, 306, 310, 602, 764], On = [2, 738], wn = [10, 74, 76, 78, 132, 139, 141, 145, 152, 306, 310, 420, 424, 602, 764], In = [2, 1161], xn = [10, 74, 76, 78, 139, 141, 145, 152, 306, 310, 420, 424, 602, 764], Dn = [10, 74, 76, 78, 139, 141, 145, 306, 310, 420, 424, 602, 764], kn = [10, 74, 78, 139, 141, 306, 310, 602, 764], Ln = [10, 78, 89, 132, 146, 189, 296, 306, 310, 470, 602, 764], $n = [335, 338, 339], Mn = [2, 764], Un = [1, 869], _n = [1, 870], Fn = [1, 871], Pn = [1, 872], qn = [1, 881], Gn = [1, 880], Vn = [164, 166, 334], Bn = [2, 444], jn = [1, 936], Hn = [2, 4, 5, 77, 131, 156, 290, 291, 292, 293], Jn = [1, 951], Yn = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 314, 315, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Wn = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Xn = [2, 375], Kn = [1, 958], Qn = [306, 308, 310], zn = [74, 300], Zn = [74, 300, 426], ea = [1, 965], ta = [2, 4, 5, 10, 53, 72, 74, 76, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], ra = [74, 426], na = [1, 978], aa = [1, 977], sa = [1, 984], ia = [10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 232, 245, 247, 306, 310, 602, 764], oa = [1, 1010], ua = [10, 72, 78, 306, 310, 602, 764], ca = [1, 1016], la = [1, 1017], ha = [1, 1018], da = [2, 4, 5, 10, 72, 74, 76, 77, 78, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 198, 280, 281, 282, 283, 284, 285, 286, 287, 288, 306, 310, 420, 424, 602, 764], fa = [1, 1068], pa = [1, 1067], ba = [1, 1081], Ea = [1, 1080], ga = [1, 1088], ma = [10, 72, 74, 78, 93, 98, 107, 118, 128, 162, 168, 169, 183, 198, 232, 245, 247, 306, 310, 602, 764], va = [1, 1119], Sa = [10, 78, 89, 146, 189, 306, 310, 470, 602, 764], Ta = [1, 1139], Aa = [1, 1138], ya = [1, 1137], Na = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Ca = [1, 1153], Ra = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 314, 315, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Oa = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 315, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], wa = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 124, 128, 129, 130, 131, 132, 133, 134, 135, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 314, 315, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Ia = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 314, 315, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], xa = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 314, 320, 321, 322, 323, 324, 325, 326, 330, 331, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Da = [2, 406], ka = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 107, 118, 122, 128, 129, 130, 131, 132, 134, 135, 137, 143, 145, 146, 148, 149, 150, 152, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 314, 330, 331, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], La = [2, 285], $a = [2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], Ma = [10, 78, 306, 310, 602, 764], Ua = [1, 1189], _a = [10, 77, 78, 143, 145, 152, 181, 302, 306, 310, 420, 424, 602, 764], Fa = [10, 74, 78, 306, 308, 310, 464, 602, 764], Pa = [1, 1200], qa = [10, 72, 78, 118, 128, 162, 168, 169, 232, 245, 247, 306, 310, 602, 764], Ga = [10, 72, 74, 78, 93, 98, 118, 128, 162, 168, 169, 183, 198, 232, 245, 247, 306, 310, 602, 764], Va = [2, 4, 5, 72, 76, 77, 78, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 185, 187, 280, 281, 282, 283, 284, 285, 286, 287, 288, 420, 424], Ba = [2, 4, 5, 72, 74, 76, 77, 78, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 185, 187, 280, 281, 282, 283, 284, 285, 286, 287, 288, 420, 424], ja = [2, 1085], Ha = [2, 4, 5, 72, 74, 76, 77, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 185, 187, 280, 281, 282, 283, 284, 285, 286, 287, 288, 420, 424], Ja = [1, 1252], Ya = [10, 74, 78, 128, 306, 308, 310, 464, 602, 764], Wa = [115, 116, 124], Xa = [2, 584], Ka = [1, 1280], Qa = [76, 139], za = [2, 724], Za = [1, 1297], es = [1, 1298], ts = [2, 4, 5, 10, 53, 72, 76, 89, 124, 146, 156, 189, 230, 266, 267, 290, 306, 310, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 517, 602, 764], rs = [2, 330], ns = [1, 1322], as = [1, 1336], ss = [1, 1338], is = [2, 487], os = [74, 78], us = [10, 306, 308, 310, 464, 602, 764], cs = [10, 72, 78, 118, 162, 168, 169, 232, 245, 247, 306, 310, 602, 764], ls = [1, 1354], hs = [1, 1358], ds = [1, 1359], fs = [1, 1361], ps = [1, 1362], bs = [1, 1363], Es = [1, 1364], gs = [1, 1365], ms = [1, 1366], vs = [1, 1367], Ss = [1, 1368], Ts = [10, 72, 74, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 245, 247, 306, 310, 602, 764], As = [1, 1393], ys = [10, 72, 78, 118, 162, 168, 169, 245, 247, 306, 310, 602, 764], Ns = [10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 245, 247, 306, 310, 602, 764], Cs = [1, 1490], Rs = [1, 1492], Os = [2, 4, 5, 77, 143, 145, 152, 156, 181, 290, 291, 292, 293, 302, 420, 424], ws = [1, 1506], Is = [10, 72, 74, 78, 162, 168, 169, 245, 247, 306, 310, 602, 764], xs = [1, 1524], Ds = [1, 1526], ks = [1, 1527], Ls = [1, 1523], $s = [1, 1522], Ms = [1, 1521], Us = [1, 1528], _s = [1, 1518], Fs = [1, 1519], Ps = [1, 1520], qs = [1, 1545], Gs = [2, 4, 5, 10, 53, 72, 89, 124, 146, 156, 189, 266, 267, 290, 306, 310, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 517, 602, 764], Vs = [1, 1556], Bs = [1, 1564], js = [1, 1563], Hs = [10, 72, 78, 162, 168, 169, 245, 247, 306, 310, 602, 764], Js = [10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], Ys = [2, 4, 5, 10, 72, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], Ws = [1, 1621], Xs = [1, 1623], Ks = [1, 1620], Qs = [1, 1622], zs = [187, 193, 368, 369, 370, 373], Zs = [2, 515], ei = [1, 1628], ti = [1, 1647], ri = [10, 72, 78, 162, 168, 169, 306, 310, 602, 764], ni = [1, 1657], ai = [1, 1658], si = [1, 1659], ii = [1, 1678], oi = [4, 10, 243, 306, 310, 343, 356, 602, 764], ui = [1, 1726], ci = [10, 72, 74, 78, 118, 162, 168, 169, 239, 245, 247, 306, 310, 602, 764], li = [2, 4, 5, 77], hi = [1, 1820], di = [1, 1832], fi = [1, 1851], pi = [10, 72, 78, 162, 168, 169, 306, 310, 415, 602, 764], bi = [10, 74, 78, 230, 306, 310, 602, 764], Ei = {
            trace: function () { }, yy: {}, symbols_: { error: 2, Literal: 3, LITERAL: 4, BRALITERAL: 5, NonReserved: 6, LiteralWithSpaces: 7, main: 8, Statements: 9, EOF: 10, Statements_group0: 11, AStatement: 12, ExplainStatement: 13, EXPLAIN: 14, QUERY: 15, PLAN: 16, Statement: 17, AlterTable: 18, AttachDatabase: 19, Call: 20, CreateDatabase: 21, CreateIndex: 22, CreateGraph: 23, CreateTable: 24, CreateView: 25, CreateEdge: 26, CreateVertex: 27, Declare: 28, Delete: 29, DetachDatabase: 30, DropDatabase: 31, DropIndex: 32, DropTable: 33, DropView: 34, If: 35, Insert: 36, Merge: 37, Reindex: 38, RenameTable: 39, Select: 40, ShowCreateTable: 41, ShowColumns: 42, ShowDatabases: 43, ShowIndex: 44, ShowTables: 45, TruncateTable: 46, WithSelect: 47, CreateTrigger: 48, DropTrigger: 49, BeginTransaction: 50, CommitTransaction: 51, RollbackTransaction: 52, EndTransaction: 53, UseDatabase: 54, Update: 55, JavaScript: 56, Source: 57, Assert: 58, While: 59, Continue: 60, Break: 61, BeginEnd: 62, Print: 63, Require: 64, SetVariable: 65, ExpressionStatement: 66, AddRule: 67, Query: 68, Echo: 69, CreateFunction: 70, CreateAggregate: 71, WITH: 72, WithTablesList: 73, COMMA: 74, WithTable: 75, AS: 76, LPAR: 77, RPAR: 78, SelectClause: 79, Select_option0: 80, IntoClause: 81, FromClause: 82, Select_option1: 83, WhereClause: 84, GroupClause: 85, OrderClause: 86, LimitClause: 87, UnionClause: 88, SEARCH: 89, Select_repetition0: 90, Select_option2: 91, PivotClause: 92, PIVOT: 93, Expression: 94, FOR: 95, PivotClause_option0: 96, PivotClause_option1: 97, UNPIVOT: 98, IN: 99, ColumnsList: 100, PivotClause_option2: 101, PivotClause2: 102, AsList: 103, AsLiteral: 104, AsPart: 105, RemoveClause: 106, REMOVE: 107, RemoveClause_option0: 108, RemoveColumnsList: 109, RemoveColumn: 110, Column: 111, LIKE: 112, StringValue: 113, ArrowDot: 114, ARROW: 115, DOT: 116, SearchSelector: 117, ORDER: 118, BY: 119, OrderExpressionsList: 120, SearchSelector_option0: 121, DOTDOT: 122, CARET: 123, EQ: 124, SearchSelector_repetition_plus0: 125, SearchSelector_repetition_plus1: 126, SearchSelector_option1: 127, WHERE: 128, OF: 129, CLASS: 130, NUMBER: 131, STRING: 132, SLASH: 133, VERTEX: 134, EDGE: 135, EXCLAMATION: 136, SHARP: 137, MODULO: 138, GT: 139, LT: 140, GTGT: 141, LTLT: 142, DOLLAR: 143, Json: 144, AT: 145, SET: 146, SetColumnsList: 147, TO: 148, VALUE: 149, ROW: 150, ExprList: 151, COLON: 152, PlusStar: 153, NOT: 154, SearchSelector_repetition2: 155, IF: 156, SearchSelector_repetition3: 157, Aggregator: 158, SearchSelector_repetition4: 159, SearchSelector_group0: 160, SearchSelector_repetition5: 161, UNION: 162, SearchSelectorList: 163, ALL: 164, SearchSelector_repetition6: 165, ANY: 166, SearchSelector_repetition7: 167, INTERSECT: 168, EXCEPT: 169, AND: 170, OR: 171, PATH: 172, RETURN: 173, ResultColumns: 174, REPEAT: 175, SearchSelector_repetition8: 176, SearchSelectorList_repetition0: 177, SearchSelectorList_repetition1: 178, PLUS: 179, STAR: 180, QUESTION: 181, SearchFrom: 182, FROM: 183, SelectModifier: 184, DISTINCT: 185, TopClause: 186, UNIQUE: 187, SelectClause_option0: 188, SELECT: 189, COLUMN: 190, MATRIX: 191, TEXTSTRING: 192, INDEX: 193, RECORDSET: 194, TOP: 195, NumValue: 196, TopClause_option0: 197, INTO: 198, Table: 199, FuncValue: 200, ParamValue: 201, VarValue: 202, FromTablesList: 203, JoinTablesList: 204, ApplyClause: 205, CROSS: 206, APPLY: 207, OUTER: 208, FromTable: 209, FromTable_option0: 210, FromTable_option1: 211, INDEXED: 212, INSERTED: 213, FromString: 214, JoinTable: 215, JoinMode: 216, JoinTableAs: 217, OnClause: 218, JoinTableAs_option0: 219, JoinTableAs_option1: 220, JoinModeMode: 221, NATURAL: 222, JOIN: 223, INNER: 224, LEFT: 225, RIGHT: 226, FULL: 227, SEMI: 228, ANTI: 229, ON: 230, USING: 231, GROUP: 232, GroupExpressionsList: 233, HavingClause: 234, GroupExpression: 235, GROUPING: 236, ROLLUP: 237, CUBE: 238, HAVING: 239, CORRESPONDING: 240, OrderExpression: 241, DIRECTION: 242, COLLATE: 243, NOCASE: 244, LIMIT: 245, OffsetClause: 246, OFFSET: 247, LimitClause_option0: 248, FETCH: 249, LimitClause_option1: 250, LimitClause_option2: 251, LimitClause_option3: 252, ResultColumn: 253, Star: 254, AggrValue: 255, Op: 256, LogicValue: 257, NullValue: 258, ExistsValue: 259, CaseValue: 260, CastClause: 261, ArrayValue: 262, NewClause: 263, Expression_group0: 264, CURRENT_TIMESTAMP: 265, JAVASCRIPT: 266, CREATE: 267, FUNCTION: 268, AGGREGATE: 269, NEW: 270, CAST: 271, ColumnType: 272, CONVERT: 273, PrimitiveValue: 274, OverClause: 275, OVER: 276, OverPartitionClause: 277, OverOrderByClause: 278, PARTITION: 279, SUM: 280, COUNT: 281, MIN: 282, MAX: 283, AVG: 284, FIRST: 285, LAST: 286, AGGR: 287, ARRAY: 288, FuncValue_option0: 289, REPLACE: 290, DATEADD: 291, DATEDIFF: 292, INTERVAL: 293, TRUE: 294, FALSE: 295, NSTRING: 296, NULL: 297, EXISTS: 298, ARRAYLBRA: 299, RBRA: 300, ParamValue_group0: 301, BRAQUESTION: 302, CASE: 303, WhensList: 304, ElseClause: 305, END: 306, When: 307, WHEN: 308, THEN: 309, ELSE: 310, REGEXP: 311, TILDA: 312, GLOB: 313, ESCAPE: 314, NOT_LIKE: 315, BARBAR: 316, MINUS: 317, AMPERSAND: 318, BAR: 319, GE: 320, LE: 321, EQEQ: 322, EQEQEQ: 323, NE: 324, NEEQEQ: 325, NEEQEQEQ: 326, CondOp: 327, AllSome: 328, ColFunc: 329, BETWEEN: 330, NOT_BETWEEN: 331, IS: 332, DOUBLECOLON: 333, SOME: 334, UPDATE: 335, SetColumn: 336, SetColumn_group0: 337, DELETE: 338, INSERT: 339, Into: 340, Values: 341, ValuesListsList: 342, DEFAULT: 343, VALUES: 344, ValuesList: 345, Value: 346, DateValue: 347, TemporaryClause: 348, TableClass: 349, IfNotExists: 350, CreateTableDefClause: 351, CreateTableOptionsClause: 352, TABLE: 353, CreateTableOptions: 354, CreateTableOption: 355, IDENTITY: 356, TEMP: 357, ColumnDefsList: 358, ConstraintsList: 359, Constraint: 360, ConstraintName: 361, PrimaryKey: 362, ForeignKey: 363, UniqueKey: 364, IndexKey: 365, Check: 366, CONSTRAINT: 367, CHECK: 368, PRIMARY: 369, KEY: 370, PrimaryKey_option0: 371, ColsList: 372, FOREIGN: 373, REFERENCES: 374, ForeignKey_option0: 375, OnForeignKeyClause: 376, ParColsList: 377, OnDeleteClause: 378, OnUpdateClause: 379, NO: 380, ACTION: 381, UniqueKey_option0: 382, UniqueKey_option1: 383, ColumnDef: 384, ColumnConstraintsClause: 385, ColumnConstraints: 386, SingularColumnType: 387, NumberMax: 388, ENUM: 389, MAXNUM: 390, ColumnConstraintsList: 391, ColumnConstraint: 392, ParLiteral: 393, ColumnConstraint_option0: 394, ColumnConstraint_option1: 395, DROP: 396, DropTable_group0: 397, IfExists: 398, TablesList: 399, ALTER: 400, RENAME: 401, ADD: 402, MODIFY: 403, ATTACH: 404, DATABASE: 405, DETACH: 406, AsClause: 407, USE: 408, SHOW: 409, VIEW: 410, CreateView_option0: 411, CreateView_option1: 412, SubqueryRestriction: 413, READ: 414, ONLY: 415, OPTION: 416, SOURCE: 417, ASSERT: 418, JsonObject: 419, ATLBRA: 420, JsonArray: 421, JsonValue: 422, JsonPrimitiveValue: 423, LCUR: 424, JsonPropertiesList: 425, RCUR: 426, JsonElementsList: 427, JsonProperty: 428, OnOff: 429, SetPropsList: 430, AtDollar: 431, SetProp: 432, OFF: 433, COMMIT: 434, TRANSACTION: 435, ROLLBACK: 436, BEGIN: 437, ElseStatement: 438, WHILE: 439, CONTINUE: 440, BREAK: 441, PRINT: 442, REQUIRE: 443, StringValuesList: 444, PluginsList: 445, Plugin: 446, ECHO: 447, DECLARE: 448, DeclaresList: 449, DeclareItem: 450, TRUNCATE: 451, MERGE: 452, MergeInto: 453, MergeUsing: 454, MergeOn: 455, MergeMatchedList: 456, OutputClause: 457, MergeMatched: 458, MergeNotMatched: 459, MATCHED: 460, MergeMatchedAction: 461, MergeNotMatchedAction: 462, TARGET: 463, OUTPUT: 464, CreateVertex_option0: 465, CreateVertex_option1: 466, CreateVertex_option2: 467, CreateVertexSet: 468, SharpValue: 469, CONTENT: 470, CreateEdge_option0: 471, GRAPH: 472, GraphList: 473, GraphVertexEdge: 474, GraphElement: 475, GraphVertexEdge_option0: 476, GraphVertexEdge_option1: 477, GraphElementVar: 478, GraphVertexEdge_option2: 479, GraphVertexEdge_option3: 480, GraphVertexEdge_option4: 481, GraphVar: 482, GraphAsClause: 483, GraphAtClause: 484, GraphElement2: 485, GraphElement2_option0: 486, GraphElement2_option1: 487, GraphElement2_option2: 488, GraphElement2_option3: 489, GraphElement_option0: 490, GraphElement_option1: 491, GraphElement_option2: 492, SharpLiteral: 493, GraphElement_option3: 494, GraphElement_option4: 495, GraphElement_option5: 496, ColonLiteral: 497, DeleteVertex: 498, DeleteVertex_option0: 499, DeleteEdge: 500, DeleteEdge_option0: 501, DeleteEdge_option1: 502, DeleteEdge_option2: 503, Term: 504, COLONDASH: 505, TermsList: 506, QUESTIONDASH: 507, CALL: 508, TRIGGER: 509, BeforeAfter: 510, InsertDeleteUpdate: 511, CreateTrigger_option0: 512, CreateTrigger_option1: 513, BEFORE: 514, AFTER: 515, INSTEAD: 516, REINDEX: 517, A: 518, ABSENT: 519, ABSOLUTE: 520, ACCORDING: 521, ADA: 522, ADMIN: 523, ALWAYS: 524, ASC: 525, ASSERTION: 526, ASSIGNMENT: 527, ATTRIBUTE: 528, ATTRIBUTES: 529, BASE64: 530, BERNOULLI: 531, BLOCKED: 532, BOM: 533, BREADTH: 534, C: 535, CASCADE: 536, CATALOG: 537, CATALOG_NAME: 538, CHAIN: 539, CHARACTERISTICS: 540, CHARACTERS: 541, CHARACTER_SET_CATALOG: 542, CHARACTER_SET_NAME: 543, CHARACTER_SET_SCHEMA: 544, CLASS_ORIGIN: 545, COBOL: 546, COLLATION: 547, COLLATION_CATALOG: 548, COLLATION_NAME: 549, COLLATION_SCHEMA: 550, COLUMNS: 551, COLUMN_NAME: 552, COMMAND_FUNCTION: 553, COMMAND_FUNCTION_CODE: 554, COMMITTED: 555, CONDITION_NUMBER: 556, CONNECTION: 557, CONNECTION_NAME: 558, CONSTRAINTS: 559, CONSTRAINT_CATALOG: 560, CONSTRAINT_NAME: 561, CONSTRAINT_SCHEMA: 562, CONSTRUCTOR: 563, CONTROL: 564, CURSOR_NAME: 565, DATA: 566, DATETIME_INTERVAL_CODE: 567, DATETIME_INTERVAL_PRECISION: 568, DB: 569, DEFAULTS: 570, DEFERRABLE: 571, DEFERRED: 572, DEFINED: 573, DEFINER: 574, DEGREE: 575, DEPTH: 576, DERIVED: 577, DESC: 578, DESCRIPTOR: 579, DIAGNOSTICS: 580, DISPATCH: 581, DOCUMENT: 582, DOMAIN: 583, DYNAMIC_FUNCTION: 584, DYNAMIC_FUNCTION_CODE: 585, EMPTY: 586, ENCODING: 587, ENFORCED: 588, EXCLUDE: 589, EXCLUDING: 590, EXPRESSION: 591, FILE: 592, FINAL: 593, FLAG: 594, FOLLOWING: 595, FORTRAN: 596, FOUND: 597, FS: 598, G: 599, GENERAL: 600, GENERATED: 601, GO: 602, GOTO: 603, GRANTED: 604, HEX: 605, HIERARCHY: 606, ID: 607, IGNORE: 608, IMMEDIATE: 609, IMMEDIATELY: 610, IMPLEMENTATION: 611, INCLUDING: 612, INCREMENT: 613, INDENT: 614, INITIALLY: 615, INPUT: 616, INSTANCE: 617, INSTANTIABLE: 618, INTEGRITY: 619, INVOKER: 620, ISOLATION: 621, K: 622, KEY_MEMBER: 623, KEY_TYPE: 624, LENGTH: 625, LEVEL: 626, LIBRARY: 627, LINK: 628, LOCATION: 629, LOCATOR: 630, M: 631, MAP: 632, MAPPING: 633, MAXVALUE: 634, MESSAGE_LENGTH: 635, MESSAGE_OCTET_LENGTH: 636, MESSAGE_TEXT: 637, MINVALUE: 638, MORE: 639, MUMPS: 640, NAME: 641, NAMES: 642, NAMESPACE: 643, NESTING: 644, NEXT: 645, NFC: 646, NFD: 647, NFKC: 648, NFKD: 649, NIL: 650, NORMALIZED: 651, NULLABLE: 652, NULLS: 653, OBJECT: 654, OCTETS: 655, OPTIONS: 656, ORDERING: 657, ORDINALITY: 658, OTHERS: 659, OVERRIDING: 660, P: 661, PAD: 662, PARAMETER_MODE: 663, PARAMETER_NAME: 664, PARAMETER_ORDINAL_POSITION: 665, PARAMETER_SPECIFIC_CATALOG: 666, PARAMETER_SPECIFIC_NAME: 667, PARAMETER_SPECIFIC_SCHEMA: 668, PARTIAL: 669, PASCAL: 670, PASSING: 671, PASSTHROUGH: 672, PERMISSION: 673, PLACING: 674, PLI: 675, PRECEDING: 676, PRESERVE: 677, PRIOR: 678, PRIVILEGES: 679, PUBLIC: 680, RECOVERY: 681, RELATIVE: 682, REPEATABLE: 683, REQUIRING: 684, RESPECT: 685, RESTART: 686, RESTORE: 687, RESTRICT: 688, RETURNED_CARDINALITY: 689, RETURNED_LENGTH: 690, RETURNED_OCTET_LENGTH: 691, RETURNED_SQLSTATE: 692, RETURNING: 693, ROLE: 694, ROUTINE: 695, ROUTINE_CATALOG: 696, ROUTINE_NAME: 697, ROUTINE_SCHEMA: 698, ROW_COUNT: 699, SCALE: 700, SCHEMA: 701, SCHEMA_NAME: 702, SCOPE_CATALOG: 703, SCOPE_NAME: 704, SCOPE_SCHEMA: 705, SECTION: 706, SECURITY: 707, SELECTIVE: 708, SELF: 709, SEQUENCE: 710, SERIALIZABLE: 711, SERVER: 712, SERVER_NAME: 713, SESSION: 714, SETS: 715, SIMPLE: 716, SIZE: 717, SPACE: 718, SPECIFIC_NAME: 719, STANDALONE: 720, STATE: 721, STATEMENT: 722, STRIP: 723, STRUCTURE: 724, STYLE: 725, SUBCLASS_ORIGIN: 726, T: 727, TABLE_NAME: 728, TEMPORARY: 729, TIES: 730, TOKEN: 731, TOP_LEVEL_COUNT: 732, TRANSACTIONS_COMMITTED: 733, TRANSACTIONS_ROLLED_BACK: 734, TRANSACTION_ACTIVE: 735, TRANSFORM: 736, TRANSFORMS: 737, TRIGGER_CATALOG: 738, TRIGGER_NAME: 739, TRIGGER_SCHEMA: 740, TYPE: 741, UNBOUNDED: 742, UNCOMMITTED: 743, UNDER: 744, UNLINK: 745, UNNAMED: 746, UNTYPED: 747, URI: 748, USAGE: 749, USER_DEFINED_TYPE_CATALOG: 750, USER_DEFINED_TYPE_CODE: 751, USER_DEFINED_TYPE_NAME: 752, USER_DEFINED_TYPE_SCHEMA: 753, VALID: 754, VERSION: 755, WHITESPACE: 756, WORK: 757, WRAPPER: 758, WRITE: 759, XMLDECLARATION: 760, XMLSCHEMA: 761, YES: 762, ZONE: 763, SEMICOLON: 764, PERCENT: 765, ROWS: 766, FuncValue_option0_group0: 767, $accept: 0, $end: 1 }, terminals_: {
                2: "error", 4: "LITERAL", 5: "BRALITERAL", 10: "EOF", 14: "EXPLAIN", 15: "QUERY", 16: "PLAN", 53: "EndTransaction", 72: "WITH", 74: "COMMA", 76: "AS", 77: "LPAR", 78: "RPAR", 89: "SEARCH", 93: "PIVOT", 95: "FOR", 98: "UNPIVOT", 99: "IN", 107: "REMOVE", 112: "LIKE", 115: "ARROW", 116: "DOT", 118: "ORDER", 119: "BY", 122: "DOTDOT", 123: "CARET", 124: "EQ", 128: "WHERE", 129: "OF", 130: "CLASS", 131: "NUMBER", 132: "STRING", 133: "SLASH", 134: "VERTEX", 135: "EDGE", 136: "EXCLAMATION", 137: "SHARP", 138: "MODULO", 139: "GT", 140: "LT", 141: "GTGT", 142: "LTLT", 143: "DOLLAR", 145: "AT", 146: "SET", 148: "TO", 149: "VALUE", 150: "ROW", 152: "COLON", 154: "NOT", 156: "IF", 162: "UNION", 164: "ALL", 166: "ANY", 168: "INTERSECT", 169: "EXCEPT", 170: "AND", 171: "OR", 172: "PATH", 173: "RETURN", 175: "REPEAT", 179: "PLUS", 180: "STAR", 181: "QUESTION", 183: "FROM", 185: "DISTINCT", 187: "UNIQUE", 189: "SELECT", 190: "COLUMN", 191: "MATRIX", 192: "TEXTSTRING", 193: "INDEX", 194: "RECORDSET", 195: "TOP", 198: "INTO", 206: "CROSS", 207: "APPLY", 208: "OUTER", 212: "INDEXED", 213: "INSERTED", 222: "NATURAL", 223: "JOIN", 224: "INNER", 225: "LEFT", 226: "RIGHT", 227: "FULL", 228: "SEMI", 229: "ANTI", 230: "ON", 231: "USING", 232: "GROUP", 236: "GROUPING", 237: "ROLLUP", 238: "CUBE", 239: "HAVING", 240: "CORRESPONDING", 242: "DIRECTION", 243: "COLLATE", 244: "NOCASE", 245: "LIMIT", 247: "OFFSET", 249: "FETCH", 265: "CURRENT_TIMESTAMP", 266: "JAVASCRIPT", 267: "CREATE", 268: "FUNCTION", 269: "AGGREGATE", 270: "NEW", 271: "CAST", 273: "CONVERT", 276: "OVER", 279: "PARTITION", 280: "SUM", 281: "COUNT", 282: "MIN", 283: "MAX", 284: "AVG", 285: "FIRST", 286: "LAST", 287: "AGGR", 288: "ARRAY", 290: "REPLACE", 291: "DATEADD", 292: "DATEDIFF", 293: "INTERVAL", 294: "TRUE", 295: "FALSE", 296: "NSTRING", 297: "NULL", 298: "EXISTS", 299: "ARRAYLBRA", 300: "RBRA", 302: "BRAQUESTION", 303: "CASE", 306: "END", 308: "WHEN", 309: "THEN", 310: "ELSE", 311: "REGEXP", 312: "TILDA", 313: "GLOB", 314: "ESCAPE", 315: "NOT_LIKE", 316: "BARBAR", 317: "MINUS", 318: "AMPERSAND", 319: "BAR", 320: "GE", 321: "LE", 322: "EQEQ", 323: "EQEQEQ", 324: "NE", 325: "NEEQEQ", 326: "NEEQEQEQ", 330: "BETWEEN", 331: "NOT_BETWEEN", 332: "IS", 333: "DOUBLECOLON", 334: "SOME", 335: "UPDATE", 338: "DELETE", 339: "INSERT", 343: "DEFAULT", 344: "VALUES", 347: "DateValue", 353: "TABLE", 356: "IDENTITY", 357: "TEMP", 367: "CONSTRAINT", 368: "CHECK", 369: "PRIMARY", 370: "KEY", 373: "FOREIGN", 374: "REFERENCES", 380: "NO", 381: "ACTION", 386: "ColumnConstraints", 389: "ENUM", 390: "MAXNUM", 396: "DROP", 400: "ALTER", 401: "RENAME", 402: "ADD", 403: "MODIFY", 404: "ATTACH", 405: "DATABASE", 406: "DETACH", 408: "USE", 409: "SHOW", 410: "VIEW", 414: "READ", 415: "ONLY", 416: "OPTION", 417: "SOURCE", 418: "ASSERT", 420: "ATLBRA", 424: "LCUR", 426: "RCUR", 433: "OFF", 434: "COMMIT", 435: "TRANSACTION", 436: "ROLLBACK", 437: "BEGIN", 439: "WHILE", 440: "CONTINUE", 441: "BREAK", 442: "PRINT", 443: "REQUIRE", 447: "ECHO", 448: "DECLARE", 451: "TRUNCATE", 452: "MERGE", 460: "MATCHED", 463: "TARGET", 464: "OUTPUT", 470: "CONTENT", 472: "GRAPH", 505: "COLONDASH", 507: "QUESTIONDASH", 508: "CALL", 509: "TRIGGER", 514: "BEFORE", 515: "AFTER", 516: "INSTEAD", 517: "REINDEX", 518: "A", 519: "ABSENT", 520: "ABSOLUTE", 521: "ACCORDING", 522: "ADA", 523: "ADMIN", 524: "ALWAYS", 525: "ASC", 526: "ASSERTION", 527: "ASSIGNMENT", 528: "ATTRIBUTE", 529: "ATTRIBUTES", 530: "BASE64", 531: "BERNOULLI", 532: "BLOCKED", 533: "BOM", 534: "BREADTH", 535: "C", 536: "CASCADE", 537: "CATALOG", 538: "CATALOG_NAME", 539: "CHAIN", 540: "CHARACTERISTICS", 541: "CHARACTERS", 542: "CHARACTER_SET_CATALOG", 543: "CHARACTER_SET_NAME", 544: "CHARACTER_SET_SCHEMA", 545: "CLASS_ORIGIN", 546: "COBOL", 547: "COLLATION", 548: "COLLATION_CATALOG", 549: "COLLATION_NAME", 550: "COLLATION_SCHEMA", 551: "COLUMNS", 552: "COLUMN_NAME",
                553: "COMMAND_FUNCTION", 554: "COMMAND_FUNCTION_CODE", 555: "COMMITTED", 556: "CONDITION_NUMBER", 557: "CONNECTION", 558: "CONNECTION_NAME", 559: "CONSTRAINTS", 560: "CONSTRAINT_CATALOG", 561: "CONSTRAINT_NAME", 562: "CONSTRAINT_SCHEMA", 563: "CONSTRUCTOR", 564: "CONTROL", 565: "CURSOR_NAME", 566: "DATA", 567: "DATETIME_INTERVAL_CODE", 568: "DATETIME_INTERVAL_PRECISION", 569: "DB", 570: "DEFAULTS", 571: "DEFERRABLE", 572: "DEFERRED", 573: "DEFINED", 574: "DEFINER", 575: "DEGREE", 576: "DEPTH", 577: "DERIVED", 578: "DESC", 579: "DESCRIPTOR", 580: "DIAGNOSTICS", 581: "DISPATCH", 582: "DOCUMENT", 583: "DOMAIN", 584: "DYNAMIC_FUNCTION", 585: "DYNAMIC_FUNCTION_CODE", 586: "EMPTY", 587: "ENCODING", 588: "ENFORCED", 589: "EXCLUDE", 590: "EXCLUDING", 591: "EXPRESSION", 592: "FILE", 593: "FINAL", 594: "FLAG", 595: "FOLLOWING", 596: "FORTRAN", 597: "FOUND", 598: "FS", 599: "G", 600: "GENERAL", 601: "GENERATED", 602: "GO", 603: "GOTO", 604: "GRANTED", 605: "HEX", 606: "HIERARCHY", 607: "ID", 608: "IGNORE", 609: "IMMEDIATE", 610: "IMMEDIATELY", 611: "IMPLEMENTATION", 612: "INCLUDING", 613: "INCREMENT", 614: "INDENT", 615: "INITIALLY", 616: "INPUT", 617: "INSTANCE", 618: "INSTANTIABLE", 619: "INTEGRITY", 620: "INVOKER", 621: "ISOLATION", 622: "K", 623: "KEY_MEMBER", 624: "KEY_TYPE", 625: "LENGTH", 626: "LEVEL", 627: "LIBRARY", 628: "LINK", 629: "LOCATION", 630: "LOCATOR", 631: "M", 632: "MAP", 633: "MAPPING", 634: "MAXVALUE", 635: "MESSAGE_LENGTH", 636: "MESSAGE_OCTET_LENGTH", 637: "MESSAGE_TEXT", 638: "MINVALUE", 639: "MORE", 640: "MUMPS", 641: "NAME", 642: "NAMES", 643: "NAMESPACE", 644: "NESTING", 645: "NEXT", 646: "NFC", 647: "NFD", 648: "NFKC", 649: "NFKD", 650: "NIL", 651: "NORMALIZED", 652: "NULLABLE", 653: "NULLS", 654: "OBJECT", 655: "OCTETS", 656: "OPTIONS", 657: "ORDERING", 658: "ORDINALITY", 659: "OTHERS", 660: "OVERRIDING", 661: "P", 662: "PAD", 663: "PARAMETER_MODE", 664: "PARAMETER_NAME", 665: "PARAMETER_ORDINAL_POSITION", 666: "PARAMETER_SPECIFIC_CATALOG", 667: "PARAMETER_SPECIFIC_NAME", 668: "PARAMETER_SPECIFIC_SCHEMA", 669: "PARTIAL", 670: "PASCAL", 671: "PASSING", 672: "PASSTHROUGH", 673: "PERMISSION", 674: "PLACING", 675: "PLI", 676: "PRECEDING", 677: "PRESERVE", 678: "PRIOR", 679: "PRIVILEGES", 680: "PUBLIC", 681: "RECOVERY", 682: "RELATIVE", 683: "REPEATABLE", 684: "REQUIRING", 685: "RESPECT", 686: "RESTART", 687: "RESTORE", 688: "RESTRICT", 689: "RETURNED_CARDINALITY", 690: "RETURNED_LENGTH", 691: "RETURNED_OCTET_LENGTH", 692: "RETURNED_SQLSTATE", 693: "RETURNING", 694: "ROLE", 695: "ROUTINE", 696: "ROUTINE_CATALOG", 697: "ROUTINE_NAME", 698: "ROUTINE_SCHEMA", 699: "ROW_COUNT", 700: "SCALE", 701: "SCHEMA", 702: "SCHEMA_NAME", 703: "SCOPE_CATALOG", 704: "SCOPE_NAME", 705: "SCOPE_SCHEMA", 706: "SECTION", 707: "SECURITY", 708: "SELECTIVE", 709: "SELF", 710: "SEQUENCE", 711: "SERIALIZABLE", 712: "SERVER", 713: "SERVER_NAME", 714: "SESSION", 715: "SETS", 716: "SIMPLE", 717: "SIZE", 718: "SPACE", 719: "SPECIFIC_NAME", 720: "STANDALONE", 721: "STATE", 722: "STATEMENT", 723: "STRIP", 724: "STRUCTURE", 725: "STYLE", 726: "SUBCLASS_ORIGIN", 727: "T", 728: "TABLE_NAME", 729: "TEMPORARY", 730: "TIES", 731: "TOKEN", 732: "TOP_LEVEL_COUNT", 733: "TRANSACTIONS_COMMITTED", 734: "TRANSACTIONS_ROLLED_BACK", 735: "TRANSACTION_ACTIVE", 736: "TRANSFORM", 737: "TRANSFORMS", 738: "TRIGGER_CATALOG", 739: "TRIGGER_NAME", 740: "TRIGGER_SCHEMA", 741: "TYPE", 742: "UNBOUNDED", 743: "UNCOMMITTED", 744: "UNDER", 745: "UNLINK", 746: "UNNAMED", 747: "UNTYPED", 748: "URI", 749: "USAGE", 750: "USER_DEFINED_TYPE_CATALOG", 751: "USER_DEFINED_TYPE_CODE", 752: "USER_DEFINED_TYPE_NAME", 753: "USER_DEFINED_TYPE_SCHEMA", 754: "VALID", 755: "VERSION", 756: "WHITESPACE", 757: "WORK", 758: "WRAPPER", 759: "WRITE", 760: "XMLDECLARATION", 761: "XMLSCHEMA", 762: "YES", 763: "ZONE", 764: "SEMICOLON", 765: "PERCENT", 766: "ROWS"
            }, productions_: [0, [3, 1], [3, 1], [3, 2], [7, 1], [7, 2], [8, 2], [9, 3], [9, 1], [9, 1], [13, 2], [13, 4], [12, 1], [17, 0], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [17, 1], [47, 3], [73, 3], [73, 1], [75, 5], [40, 10], [40, 4], [92, 8], [92, 11], [102, 4], [104, 2], [104, 1], [103, 3], [103, 1], [105, 1], [105, 3], [106, 3], [109, 3], [109, 1], [110, 1], [110, 2], [114, 1], [114, 1], [117, 1], [117, 5], [117, 5], [117, 1], [117, 2], [117, 1], [117, 2], [117, 2], [117, 3], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 1], [117, 1], [117, 1], [117, 1], [117, 1], [117, 1], [117, 2], [117, 2], [117, 2], [117, 1], [117, 1], [117, 1], [117, 1], [117, 1], [117, 1], [117, 2], [117, 3], [117, 4], [117, 3], [117, 1], [117, 4], [117, 2], [117, 2], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 5], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 4], [117, 6], [163, 3], [163, 1], [153, 1], [153, 1], [153, 1], [182, 2], [79, 4], [79, 4], [79, 4], [79, 3], [184, 1], [184, 2], [184, 2], [184, 2], [184, 2], [184, 2], [184, 2], [184, 2], [186, 3], [186, 4], [186, 0], [81, 0], [81, 2], [81, 2], [81, 2], [81, 2], [81, 2], [82, 2], [82, 3], [82, 5], [82, 0], [205, 6], [205, 7], [205, 6], [205, 7], [203, 1], [203, 3], [209, 4], [209, 5], [209, 3], [209, 3], [209, 2], [209, 3], [209, 1], [209, 3], [209, 2], [209, 3], [209, 1], [209, 1], [209, 2], [209, 3], [209, 1], [209, 1], [209, 2], [209, 3], [209, 1], [209, 2], [209, 3], [214, 1], [199, 3], [199, 1], [204, 2], [204, 2], [204, 1], [204, 1], [215, 3], [217, 1], [217, 2], [217, 3], [217, 3], [217, 2], [217, 3], [217, 4], [217, 5], [217, 1], [217, 2], [217, 3], [217, 1], [217, 2], [217, 3], [216, 1], [216, 2], [221, 1], [221, 2], [221, 2], [221, 3], [221, 2], [221, 3], [221, 2], [221, 3], [221, 2], [221, 2], [221, 2], [218, 2], [218, 2], [218, 0], [84, 0], [84, 2], [85, 0], [85, 4], [233, 1], [233, 3], [235, 5], [235, 4], [235, 4], [235, 1], [234, 0], [234, 2], [88, 0], [88, 2], [88, 3], [88, 2], [88, 2], [88, 3], [88, 4], [88, 3], [88, 3], [86, 0], [86, 3], [120, 1], [120, 3], [241, 1], [241, 2], [241, 3], [241, 4], [87, 0], [87, 3], [87, 8], [246, 0], [246, 2], [174, 3], [174, 1], [253, 3], [253, 2], [253, 3], [253, 2], [253, 3], [253, 2], [253, 1], [254, 5], [254, 3], [254, 1], [111, 5], [111, 3], [111, 3], [111, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 1], [94, 3], [94, 3], [94, 3], [94, 1], [94, 1], [56, 1], [70, 5], [71, 5], [263, 2], [263, 2], [261, 6], [261, 8], [261, 6], [261, 8], [274, 1], [274, 1], [274, 1], [274, 1], [274, 1], [274, 1], [274, 1], [255, 5], [255, 6], [255, 6], [275, 0], [275, 4], [275, 4], [275, 5], [277, 3], [278, 3], [158, 1], [158, 1], [158, 1], [158, 1], [158, 1], [158, 1], [158, 1], [158, 1], [158, 1], [200, 5], [200, 3], [200, 4], [200, 4], [200, 8], [200, 8], [200, 8], [200, 8], [200, 3], [151, 1], [151, 3], [196, 1], [257, 1], [257, 1], [113, 1], [113, 1], [258, 1], [202, 2], [259, 4], [262, 3], [201, 2], [201, 2], [201, 1], [201, 1], [260, 5], [260, 4], [304, 2], [304, 1], [307, 4], [305, 2], [305, 0], [256, 3], [256, 3], [256, 3], [256, 3], [256, 5], [256, 3], [256, 5], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 5], [256, 3], [256, 3], [256, 3], [256, 5], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [256, 6], [256, 6], [256, 3], [256, 3], [256, 2], [256, 2], [256, 2], [256, 2], [256, 2], [256, 3], [256, 5], [256, 6], [256, 5], [256, 6], [256, 4], [256, 5], [256, 3], [256, 4], [256, 3], [256, 4], [256, 3], [256, 3], [256, 3], [256, 3], [256, 3], [329, 1], [329, 1], [329, 4], [327, 1], [327, 1], [327, 1], [327, 1], [327, 1], [327, 1], [328, 1], [328, 1], [328, 1], [55, 6], [55, 4], [147, 1], [147, 3], [336, 3], [336, 4], [29, 5], [29, 3], [36, 5], [36, 4], [36, 7], [36, 6], [36, 5], [36, 4], [36, 5], [36, 8], [36, 7], [36, 4], [36, 6], [36, 7], [341, 1], [341, 1], [340, 0], [340, 1], [342, 3], [342, 1], [342, 1], [342, 5], [342, 3], [342, 3], [345, 1], [345, 3], [346, 1], [346, 1], [346, 1], [346, 1], [346, 1], [346, 1], [100, 1], [100, 3], [24, 9], [24, 5], [349, 1], [349, 1], [352, 0], [352, 1], [354, 2], [354, 1], [355, 1], [355, 3], [355, 3], [355, 3], [348, 0], [348, 1], [350, 0], [350, 3], [351, 3], [351, 1], [351, 2], [359, 1], [359, 3], [360, 2], [360, 2], [360, 2], [360, 2], [360, 2], [361, 0], [361, 2], [366, 4], [362, 6], [363, 9], [377, 3], [376, 0], [376, 2], [378, 4], [379, 4], [364, 6], [365, 5], [365, 5], [372, 1], [372, 1], [372, 3], [372, 3], [358, 1], [358, 3], [384, 3], [384, 2], [384, 1], [387, 6], [387, 4], [387, 1], [387, 4], [272, 2], [272, 1], [388, 1], [388, 1], [385, 0], [385, 1], [391, 2], [391, 1], [393, 3], [392, 2], [392, 5], [392, 3], [392, 6], [392, 1], [392, 2], [392, 4], [392, 2], [392, 1], [392, 2], [392, 1], [392, 1], [392, 3], [392, 5], [33, 4], [399, 3], [399, 1], [398, 0], [398, 2], [18, 6], [18, 6], [18, 6], [18, 8], [18, 6], [39, 5], [19, 4], [19, 7], [19, 6], [19, 9], [30, 3], [21, 4], [21, 6], [21, 9], [21, 6], [407, 0], [407, 2], [54, 3], [54, 2], [31, 4], [31, 5], [31, 5], [22, 8], [22, 9], [32, 3], [43, 2], [43, 4], [43, 3], [43, 5], [45, 2], [45, 4], [45, 4], [45, 6], [42, 4], [42, 6], [44, 4], [44, 6], [41, 4], [41, 6], [25, 11], [25, 8], [413, 3], [413, 3], [413, 5], [34, 4], [66, 2], [57, 2], [58, 2], [58, 2], [58, 4], [144, 4], [144, 2], [144, 2], [144, 2], [144, 2], [144, 1], [144, 2], [144, 2], [422, 1], [422, 1], [423, 1], [423, 1], [423, 1], [423, 1], [423, 1], [423, 1], [423, 1], [423, 3], [419, 3], [419, 4], [419, 2], [421, 2], [421, 3], [421, 1], [425, 3], [425, 1], [428, 3], [428, 3], [428, 3], [427, 3], [427, 1], [65, 4], [65, 3], [65, 4], [65, 5], [65, 5], [65, 6], [431, 1], [431, 1], [430, 3], [430, 2], [432, 1], [432, 1], [432, 3], [429, 1], [429, 1], [51, 2], [52, 2], [50, 2], [35, 4], [35, 3], [438, 2], [59, 3], [60, 1], [61, 1], [62, 3], [63, 2], [63, 2], [64, 2], [64, 2], [446, 1], [446, 1], [69, 2], [444, 3], [444, 1], [445, 3], [445, 1], [28, 2], [449, 1], [449, 3], [450, 3], [450, 4], [450, 5], [450, 6], [46, 3], [37, 6], [453, 1], [453, 2], [454, 2], [455, 2], [456, 2], [456, 2], [456, 1], [456, 1], [458, 4], [458, 6], [461, 1], [461, 3], [459, 5], [459, 7], [459, 7], [459, 9], [459, 7], [459, 9], [462, 3], [462, 6], [462, 3], [462, 6], [457, 0], [457, 2], [457, 5], [457, 4], [457, 7], [27, 6], [469, 2], [468, 0], [468, 2], [468, 2], [468, 1], [26, 8], [23, 3], [23, 4], [473, 3], [473, 1], [474, 3], [474, 7], [474, 6], [474, 3], [474, 4], [478, 1], [478, 1], [482, 2], [483, 3], [484, 2], [485, 4], [475, 4], [475, 3], [475, 2], [475, 1], [497, 2], [493, 2], [493, 2], [498, 4], [500, 6], [67, 3], [67, 2], [506, 3], [506, 1], [504, 1], [504, 4], [68, 2], [20, 2], [48, 9], [48, 8], [48, 9], [510, 0], [510, 1], [510, 1], [510, 1], [510, 2], [511, 1], [511, 1], [511, 1], [49, 3], [38, 2], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [11, 1], [11, 1], [80, 0], [80, 1], [83, 0], [83, 1], [90, 0], [90, 2], [91, 0], [91, 1], [96, 0], [96, 1], [97, 0], [97, 1], [101, 0], [101, 1], [108, 0], [108, 1], [121, 0], [121, 1], [125, 1], [125, 2], [126, 1], [126, 2], [127, 0], [127, 1], [155, 0], [155, 2], [157, 0], [157, 2], [159, 0], [159, 2], [160, 1], [160, 1], [161, 0], [161, 2], [165, 0], [165, 2], [167, 0], [167, 2], [176, 0], [176, 2], [177, 0], [177, 2], [178, 0], [178, 2], [188, 0], [188, 1], [197, 0], [197, 1], [210, 0], [210, 1], [211, 0], [211, 1], [219, 0], [219, 1], [220, 0], [220, 1], [248, 0], [248, 1], [250, 0], [250, 1], [251, 0], [251, 1], [252, 0], [252, 1], [264, 1], [264, 1], [767, 1], [767, 1], [289, 0], [289, 1], [301, 1], [301, 1], [337, 1], [337, 1], [371, 0], [371, 1], [375, 0], [375, 1], [382, 0], [382, 1], [383, 0], [383, 1], [394, 0], [394, 1], [395, 0], [395, 1], [397, 1], [397, 1], [411, 0], [411, 1], [412, 0], [412, 1], [465, 0], [465, 1], [466, 0], [466, 1], [467, 0], [467, 1], [471, 0], [471, 1], [476, 0], [476, 1], [477, 0], [477, 1], [479, 0], [479, 1], [480, 0], [480, 1], [481, 0], [481, 1], [486, 0], [486, 1], [487, 0], [487, 1], [488, 0], [488, 1], [489, 0], [489, 1], [490, 0], [490, 1], [491, 0], [491, 1], [492, 0], [492, 1], [494, 0], [494, 1], [495, 0], [495, 1], [496, 0], [496, 1], [499, 0], [499, 2], [501, 0], [501, 2], [502, 0], [502, 2], [503, 0], [503, 2], [512, 0], [512, 1], [513, 0], [513, 1]], performAction: function (e, t, r, n, a, s, i) {
                var o = s.length - 1; switch (a) {
                    case 1: n.casesensitive ? this.$ = s[o] : this.$ = s[o].toLowerCase(); break; case 2: this.$ = w(s[o].substr(1, s[o].length - 2)); break; case 3: this.$ = s[o].toLowerCase(); break; case 4: this.$ = s[o]; break; case 5: this.$ = s[o] ? s[o - 1] + " " + s[o] : s[o - 1]; break; case 6: return new n.Statements({ statements: s[o - 1] }); case 7: this.$ = s[o - 2], s[o] && s[o - 2].push(s[o]); break; case 8: case 9: case 70: case 80: case 85: case 143: case 177: case 205: case 206: case 242: case 261: case 273: case 354: case 372: case 451: case 474: case 475: case 479: case 487: case 528: case 529: case 566: case 649: case 659: case 683: case 685: case 687: case 701: case 702: case 732: case 756: this.$ = [s[o]]; break; case 10: case 11: this.$ = s[o], s[o].explain = !0; break; case 12: this.$ = s[o], n.exists && (this.$.exists = n.exists), delete n.exists, n.queries && (this.$.queries = n.queries), delete n.queries; break; case 13: case 162: case 172: case 237: case 238: case 240: case 248: case 250: case 259: case 267: case 270: case 375: case 491: case 501: case 503: case 515: case 521: case 522: case 567: this.$ = void 0; break; case 68: this.$ = new n.WithSelect({ withs: s[o - 1], select: s[o] }); break; case 69: case 565: s[o - 2].push(s[o]), this.$ = s[o - 2]; break; case 71: this.$ = { name: s[o - 4], select: s[o - 1] }; break; case 72: n.extend(this.$, s[o - 9]), n.extend(this.$, s[o - 8]), n.extend(this.$, s[o - 7]), n.extend(this.$, s[o - 6]), n.extend(this.$, s[o - 5]), n.extend(this.$, s[o - 4]), n.extend(this.$, s[o - 3]), n.extend(this.$, s[o - 2]), n.extend(this.$, s[o - 1]), n.extend(this.$, s[o]), this.$ = s[o - 9]; break; case 73: this.$ = new n.Search({ selectors: s[o - 2], from: s[o] }), n.extend(this.$, s[o - 1]); break; case 74: this.$ = { pivot: { expr: s[o - 5], columnid: s[o - 3], inlist: s[o - 2], as: s[o] } }; break; case 75: this.$ = { unpivot: { tocolumnid: s[o - 8], forcolumnid: s[o - 6], inlist: s[o - 3], as: s[o] } }; break; case 76: case 520: case 549: case 585: case 619: case 636: case 637: case 640: case 662: this.$ = s[o - 1]; break; case 77: case 78: case 86: case 147: case 185: case 247: case 280: case 288: case 289: case 290: case 291: case 292: case 293: case 294: case 295: case 296: case 297: case 298: case 299: case 300: case 301: case 304: case 305: case 320: case 321: case 322: case 323: case 324: case 325: case 374: case 440: case 441: case 442: case 443: case 444: case 445: case 516: case 542: case 546: case 548: case 623: case 624: case 625: case 626: case 627: case 628: case 632: case 634: case 635: case 644: case 660: case 661: case 723: case 738: case 739: case 741: case 742: case 748: case 749: this.$ = s[o]; break; case 79: case 84: case 731: case 755: this.$ = s[o - 2], this.$.push(s[o]); break; case 81: this.$ = { expr: s[o] }; break; case 82: this.$ = { expr: s[o - 2], as: s[o] }; break; case 83: this.$ = { removecolumns: s[o] }; break; case 87: this.$ = { like: s[o] }; break; case 90: case 104: this.$ = { srchid: "PROP", args: [s[o]] }; break; case 91: this.$ = { srchid: "ORDERBY", args: s[o - 1] }; break; case 92: var u = s[o - 1]; u || (u = "ASC"), this.$ = { srchid: "ORDERBY", args: [{ expression: new n.Column({ columnid: "_" }), direction: u }] }; break; case 93: this.$ = { srchid: "PARENT" }; break; case 94: this.$ = { srchid: "APROP", args: [s[o]] }; break; case 95: this.$ = { selid: "ROOT" }; break; case 96: this.$ = { srchid: "EQ", args: [s[o]] }; break; case 97: this.$ = { srchid: "LIKE", args: [s[o]] }; break; case 98: case 99: this.$ = { selid: "WITH", args: s[o - 1] }; break; case 100: this.$ = { srchid: s[o - 3].toUpperCase(), args: s[o - 1] }; break; case 101: this.$ = { srchid: "WHERE", args: [s[o - 1]] }; break; case 102: this.$ = { selid: "OF", args: [s[o - 1]] }; break; case 103: this.$ = { srchid: "CLASS", args: [s[o - 1]] }; break; case 105: this.$ = { srchid: "NAME", args: [s[o].substr(1, s[o].length - 2)] }; break; case 106: this.$ = { srchid: "CHILD" }; break; case 107: this.$ = { srchid: "VERTEX" }; break; case 108: this.$ = { srchid: "EDGE" }; break; case 109: this.$ = { srchid: "REF" }; break; case 110: this.$ = { srchid: "SHARP", args: [s[o]] }; break; case 111: this.$ = { srchid: "ATTR", args: void 0 === s[o] ? void 0 : [s[o]] }; break; case 112: this.$ = { srchid: "ATTR" }; break; case 113: this.$ = { srchid: "OUT" }; break; case 114: this.$ = { srchid: "IN" }; break; case 115: this.$ = { srchid: "OUTOUT" }; break; case 116: this.$ = { srchid: "ININ" }; break; case 117: this.$ = { srchid: "CONTENT" }; break; case 118: this.$ = { srchid: "EX", args: [new n.Json({ value: s[o] })] }; break; case 119: this.$ = { srchid: "AT", args: [s[o]] }; break; case 120: this.$ = { srchid: "AS", args: [s[o]] }; break; case 121: this.$ = { srchid: "SET", args: s[o - 1] }; break; case 122: this.$ = { selid: "TO", args: [s[o]] }; break; case 123: this.$ = { srchid: "VALUE" }; break; case 124: this.$ = { srchid: "ROW", args: s[o - 1] }; break; case 125: this.$ = { srchid: "CLASS", args: [s[o]] }; break; case 126: this.$ = { selid: s[o], args: [s[o - 1]] }; break; case 127: this.$ = { selid: "NOT", args: s[o - 1] }; break; case 128: this.$ = { selid: "IF", args: s[o - 1] }; break; case 129: this.$ = { selid: s[o - 3], args: s[o - 1] }; break; case 130: this.$ = { selid: "DISTINCT", args: s[o - 1] }; break; case 131: this.$ = { selid: "UNION", args: s[o - 1] }; break; case 132: this.$ = { selid: "UNIONALL", args: s[o - 1] }; break; case 133: this.$ = { selid: "ALL", args: [s[o - 1]] }; break; case 134: this.$ = { selid: "ANY", args: [s[o - 1]] }; break; case 135: this.$ = { selid: "INTERSECT", args: s[o - 1] }; break; case 136: this.$ = { selid: "EXCEPT", args: s[o - 1] }; break; case 137: this.$ = { selid: "AND", args: s[o - 1] }; break; case 138: this.$ = { selid: "OR", args: s[o - 1] }; break; case 139: this.$ = { selid: "PATH", args: [s[o - 1]] }; break; case 140: this.$ = { srchid: "RETURN", args: s[o - 1] }; break; case 141: this.$ = { selid: "REPEAT", sels: s[o - 3], args: s[o - 1] }; break; case 142: this.$ = s[o - 2], this.$.push(s[o]); break; case 144: this.$ = "PLUS"; break; case 145: this.$ = "STAR"; break; case 146: this.$ = "QUESTION"; break; case 148: case 149: this.$ = new n.Select({ columns: s[o], distinct: !0 }), n.extend(this.$, s[o - 3]), n.extend(this.$, s[o - 1]); break; case 150: this.$ = new n.Select({ columns: s[o], all: !0 }), n.extend(this.$, s[o - 3]), n.extend(this.$, s[o - 1]); break; case 151: s[o] ? (this.$ = new n.Select({ columns: s[o] }), n.extend(this.$, s[o - 2]), n.extend(this.$, s[o - 1])) : this.$ = new n.Select({ columns: [new n.Column({ columnid: "_" })], modifier: "COLUMN" }); break; case 152: "SELECT" == s[o] ? this.$ = void 0 : this.$ = { modifier: s[o] }; break; case 153: this.$ = { modifier: "VALUE" }; break; case 154: this.$ = { modifier: "ROW" }; break; case 155: this.$ = { modifier: "COLUMN" }; break; case 156: this.$ = { modifier: "MATRIX" }; break; case 157: this.$ = { modifier: "TEXTSTRING" }; break; case 158: this.$ = { modifier: "INDEX" }; break; case 159: this.$ = { modifier: "RECORDSET" }; break; case 160: this.$ = { top: s[o - 1], percent: void 0 !== s[o] || void 0 }; break; case 161: this.$ = { top: s[o - 1] }; break; case 163: case 330: case 523: case 524: case 724: this.$ = void 0; break; case 164: case 165: case 166: case 167: this.$ = { into: s[o] }; break; case 168: var c = s[o]; c = c.substr(1, c.length - 2); var l = c.substr(-3).toUpperCase(), h = c.substr(-4).toUpperCase(); "#" == c[0] ? this.$ = { into: new n.FuncValue({ funcid: "HTML", args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }) } : "XLS" == l || "CSV" == l || "TAB" == l ? this.$ = { into: new n.FuncValue({ funcid: l, args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }) } : "XLSX" != h && "JSON" != h || (this.$ = { into: new n.FuncValue({ funcid: h, args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }) }); break; case 169: this.$ = { from: s[o] }; break; case 170: this.$ = { from: s[o - 1], joins: s[o] }; break; case 171: this.$ = { from: s[o - 2], joins: s[o - 1] }; break; case 173: this.$ = new n.Apply({ select: s[o - 2], applymode: "CROSS", as: s[o] }); break; case 174: this.$ = new n.Apply({ select: s[o - 3], applymode: "CROSS", as: s[o] }); break; case 175: this.$ = new n.Apply({ select: s[o - 2], applymode: "OUTER", as: s[o] }); break; case 176: this.$ = new n.Apply({ select: s[o - 3], applymode: "OUTER", as: s[o] }); break; case 178: case 243: case 452: case 530: case 531: this.$ = s[o - 2], s[o - 2].push(s[o]); break; case 179: this.$ = s[o - 2], this.$.as = s[o]; break; case 180: this.$ = s[o - 3], this.$.as = s[o]; break; case 181: this.$ = s[o - 1], this.$.as = "default"; break; case 182: this.$ = new n.Json({ value: s[o - 2] }), s[o - 2].as = s[o]; break; case 183: this.$ = s[o - 1], s[o - 1].as = s[o]; break; case 184: this.$ = s[o - 2], s[o - 2].as = s[o]; break; case 186: case 638: case 641: this.$ = s[o - 2]; break; case 187: case 191: case 195: case 198: this.$ = s[o - 1], s[o - 1].as = s[o]; break; case 188: case 192: case 196: case 199: this.$ = s[o - 2], s[o - 2].as = s[o]; break; case 189: case 190: case 194: case 197: this.$ = s[o], s[o].as = "default"; break; case 193: this.$ = { inserted: !0 }, s[o].as = "default"; break; case 200: var c = s[o]; c = c.substr(1, c.length - 2); var d, l = c.substr(-3).toUpperCase(), h = c.substr(-4).toUpperCase(); if ("#" == c[0]) d = new n.FuncValue({ funcid: "HTML", args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }); else if ("XLS" == l || "CSV" == l || "TAB" == l) d = new n.FuncValue({ funcid: l, args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }); else { if ("XLSX" != h && "JSON" != h) throw new Error("Unknown string in FROM clause"); d = new n.FuncValue({ funcid: h, args: [new n.StringValue({ value: c }), new n.Json({ value: { headers: !0 } })] }) } this.$ = d; break; case 201: "INFORMATION_SCHEMA" == s[o - 2] ? this.$ = new n.FuncValue({ funcid: s[o - 2], args: [new n.StringValue({ value: s[o] })] }) : this.$ = new n.Table({ databaseid: s[o - 2], tableid: s[o] }); break; case 202: this.$ = new n.Table({ tableid: s[o] }); break; case 203: case 204: this.$ = s[o - 1], s[o - 1].push(s[o]); break; case 207: this.$ = new n.Join(s[o - 2]), n.extend(this.$, s[o - 1]), n.extend(this.$, s[o]); break; case 208: this.$ = { table: s[o] }; break; case 209: this.$ = { table: s[o - 1], as: s[o] }; break; case 210: this.$ = { table: s[o - 2], as: s[o] }; break; case 211: this.$ = { json: new n.Json({ value: s[o - 2], as: s[o] }) }; break; case 212: this.$ = { param: s[o - 1], as: s[o] }; break; case 213: this.$ = { param: s[o - 2], as: s[o] }; break; case 214: this.$ = { select: s[o - 2], as: s[o] }; break; case 215: this.$ = { select: s[o - 3], as: s[o] }; break; case 216: this.$ = { funcid: s[o], as: "default" }; break; case 217: this.$ = { funcid: s[o - 1], as: s[o] }; break; case 218: this.$ = { funcid: s[o - 2], as: s[o] }; break; case 219: this.$ = { variable: s[o], as: "default" }; break; case 220: this.$ = { variable: s[o - 1], as: s[o] }; break; case 221: this.$ = { variable: s[o - 2], as: s[o] }; break; case 222: this.$ = { joinmode: s[o] }; break; case 223: this.$ = { joinmode: s[o - 1], natural: !0 }; break; case 224: case 225: this.$ = "INNER"; break; case 226: case 227: this.$ = "LEFT"; break; case 228: case 229: this.$ = "RIGHT"; break; case 230: case 231: this.$ = "OUTER"; break; case 232: this.$ = "SEMI"; break; case 233: this.$ = "ANTI"; break; case 234: this.$ = "CROSS"; break; case 235: this.$ = { on: s[o] }; break; case 236: case 697: this.$ = { using: s[o] }; break; case 239: this.$ = { where: new n.Expression({ expression: s[o] }) }; break; case 241: this.$ = { group: s[o - 1] }, n.extend(this.$, s[o]); break; case 244: this.$ = new n.GroupExpression({ type: "GROUPING SETS", group: s[o - 1] }); break; case 245: this.$ = new n.GroupExpression({ type: "ROLLUP", group: s[o - 1] }); break; case 246: this.$ = new n.GroupExpression({ type: "CUBE", group: s[o - 1] }); break; case 249: this.$ = { having: s[o] }; break; case 251: this.$ = { union: s[o] }; break; case 252: this.$ = { unionall: s[o] }; break; case 253: this.$ = { except: s[o] }; break; case 254: this.$ = { intersect: s[o] }; break; case 255: this.$ = { union: s[o], corresponding: !0 }; break; case 256: this.$ = { unionall: s[o], corresponding: !0 }; break; case 257: this.$ = { except: s[o], corresponding: !0 }; break; case 258: this.$ = { intersect: s[o], corresponding: !0 }; break; case 260: this.$ = { order: s[o] }; break; case 262: this.$ = s[o - 2], s[o - 2].push(s[o]); break; case 263: this.$ = new n.Expression({ expression: s[o], direction: "ASC" }); break; case 264: this.$ = new n.Expression({ expression: s[o - 1], direction: s[o].toUpperCase() }); break; case 265: this.$ = new n.Expression({ expression: s[o - 2], direction: "ASC", nocase: !0 }); break; case 266: this.$ = new n.Expression({ expression: s[o - 3], direction: s[o].toUpperCase(), nocase: !0 }); break; case 268: this.$ = { limit: s[o - 1] }, n.extend(this.$, s[o]); break; case 269: this.$ = { limit: s[o - 2], offset: s[o - 6] }; break; case 271: this.$ = { offset: s[o] }; break; case 272: case 509: case 533: case 648: case 658: case 682: case 684: case 688: s[o - 2].push(s[o]), this.$ = s[o - 2]; break; case 274: case 276: case 278: s[o - 2].as = s[o], this.$ = s[o - 2]; break; case 275: case 277: case 279: s[o - 1].as = s[o], this.$ = s[o - 1]; break; case 281: this.$ = new n.Column({ columid: s[o], tableid: s[o - 2], databaseid: s[o - 4] }); break; case 282: this.$ = new n.Column({ columnid: s[o], tableid: s[o - 2] }); break; case 283: this.$ = new n.Column({ columnid: s[o] }); break; case 284: this.$ = new n.Column({ columnid: s[o], tableid: s[o - 2], databaseid: s[o - 4] }); break; case 285: case 286: this.$ = new n.Column({ columnid: s[o], tableid: s[o - 2] }); break; case 287: this.$ = new n.Column({ columnid: s[o] }); break; case 302: this.$ = new n.DomainValueValue; break; case 303: this.$ = new n.Json({ value: s[o] }); break; case 306: case 307: case 308: n.queries || (n.queries = []), n.queries.push(s[o - 1]), s[o - 1].queriesidx = n.queries.length, this.$ = s[o - 1]; break; case 309: this.$ = s[o]; break; case 310: this.$ = new n.FuncValue({ funcid: "CURRENT_TIMESTAMP" }); break; case 311: this.$ = new n.JavaScript({ value: s[o].substr(2, s[o].length - 4) }); break; case 312: this.$ = new n.JavaScript({ value: 'alasql.fn["' + s[o - 2] + '"] = ' + s[o].substr(2, s[o].length - 4) }); break; case 313: this.$ = new n.JavaScript({ value: 'alasql.aggr["' + s[o - 2] + '"] = ' + s[o].substr(2, s[o].length - 4) }); break; case 314: this.$ = new n.FuncValue({ funcid: s[o], newid: !0 }); break; case 315: this.$ = s[o], n.extend(this.$, { newid: !0 }); break; case 316: this.$ = new n.Convert({ expression: s[o - 3] }), n.extend(this.$, s[o - 1]); break; case 317: this.$ = new n.Convert({ expression: s[o - 5], style: s[o - 1] }), n.extend(this.$, s[o - 3]); break; case 318: this.$ = new n.Convert({ expression: s[o - 1] }), n.extend(this.$, s[o - 3]); break; case 319: this.$ = new n.Convert({ expression: s[o - 3], style: s[o - 1] }), n.extend(this.$, s[o - 5]); break; case 326: this.$ = new n.FuncValue({ funcid: "CURRENT_TIMESTAMP" }); break; case 327: s[o - 2].length > 1 && ("MAX" == s[o - 4].toUpperCase() || "MIN" == s[o - 4].toUpperCase()) ? this.$ = new n.FuncValue({ funcid: s[o - 4], args: s[o - 2] }) : this.$ = new n.AggrValue({ aggregatorid: s[o - 4].toUpperCase(), expression: s[o - 2].pop(), over: s[o] }); break; case 328: this.$ = new n.AggrValue({ aggregatorid: s[o - 5].toUpperCase(), expression: s[o - 2], distinct: !0, over: s[o] }); break; case 329: this.$ = new n.AggrValue({ aggregatorid: s[o - 5].toUpperCase(), expression: s[o - 2], over: s[o] }); break; case 331: case 332: this.$ = new n.Over, n.extend(this.$, s[o - 1]); break; case 333: this.$ = new n.Over, n.extend(this.$, s[o - 2]), n.extend(this.$, s[o - 1]); break; case 334: this.$ = { partition: s[o] }; break; case 335: this.$ = { order: s[o] }; break; case 336: this.$ = "SUM"; break; case 337: this.$ = "COUNT"; break; case 338: this.$ = "MIN"; break; case 339: case 544: this.$ = "MAX"; break; case 340: this.$ = "AVG"; break; case 341: this.$ = "FIRST"; break; case 342: this.$ = "LAST"; break; case 343: this.$ = "AGGR"; break; case 344: this.$ = "ARRAY"; break; case 345: var f = s[o - 4], p = s[o - 1]; p.length > 1 && ("MIN" == f.toUpperCase() || "MAX" == f.toUpperCase()) ? this.$ = new n.FuncValue({ funcid: f, args: p }) : A.aggr[s[o - 4]] ? this.$ = new n.AggrValue({ aggregatorid: "REDUCE", funcid: f, expression: p.pop(), distinct: "DISTINCT" == s[o - 2] }) : this.$ = new n.FuncValue({ funcid: f, args: p }); break; case 346: this.$ = new n.FuncValue({ funcid: s[o - 2] }); break; case 347: this.$ = new n.FuncValue({ funcid: "IIF", args: s[o - 1] }); break; case 348: this.$ = new n.FuncValue({ funcid: "REPLACE", args: s[o - 1] }); break; case 349: this.$ = new n.FuncValue({ funcid: "DATEADD", args: [new n.StringValue({ value: s[o - 5] }), s[o - 3], s[o - 1]] }); break; case 350: this.$ = new n.FuncValue({ funcid: "DATEADD", args: [s[o - 5], s[o - 3], s[o - 1]] }); break; case 351: this.$ = new n.FuncValue({ funcid: "DATEDIFF", args: [new n.StringValue({ value: s[o - 5] }), s[o - 3], s[o - 1]] }); break; case 352: this.$ = new n.FuncValue({ funcid: "DATEDIFF", args: [s[o - 5], s[o - 3], s[o - 1]] }); break; case 353: this.$ = new n.FuncValue({ funcid: "INTERVAL", args: [s[o - 1], new n.StringValue({ value: s[o].toLowerCase() })] }); break; case 355: s[o - 2].push(s[o]), this.$ = s[o - 2]; break; case 356: this.$ = new n.NumValue({ value: +s[o] }); break; case 357: this.$ = new n.LogicValue({ value: !0 }); break; case 358: this.$ = new n.LogicValue({ value: !1 }); break; case 359: this.$ = new n.StringValue({ value: s[o].substr(1, s[o].length - 2).replace(/(\\\')/g, "'").replace(/(\'\')/g, "'") }); break; case 360: this.$ = new n.StringValue({ value: s[o].substr(2, s[o].length - 3).replace(/(\\\')/g, "'").replace(/(\'\')/g, "'") }); break; case 361: this.$ = new n.NullValue({ value: void 0 }); break; case 362: this.$ = new n.VarValue({ variable: s[o] }); break; case 363: n.exists || (n.exists = []), this.$ = new n.ExistsValue({ value: s[o - 1], existsidx: n.exists.length }), n.exists.push(s[o - 1]); break; case 364: this.$ = new n.ArrayValue({ value: s[o - 1] }); break; case 365: case 366: this.$ = new n.ParamValue({ param: s[o] }); break; case 367: void 0 === n.question && (n.question = 0), this.$ = new n.ParamValue({ param: n.question++ }); break; case 368: void 0 === n.question && (n.question = 0), this.$ = new n.ParamValue({ param: n.question++, array: !0 }); break; case 369: this.$ = new n.CaseValue({ expression: s[o - 3], whens: s[o - 2], elses: s[o - 1] }); break; case 370: this.$ = new n.CaseValue({ whens: s[o - 2], elses: s[o - 1] }); break; case 371: case 699: case 700: this.$ = s[o - 1], this.$.push(s[o]); break; case 373: this.$ = { when: s[o - 2], then: s[o] }; break; case 376: case 377: this.$ = new n.Op({ left: s[o - 2], op: "REGEXP", right: s[o] }); break; case 378: this.$ = new n.Op({ left: s[o - 2], op: "GLOB", right: s[o] }); break; case 379: this.$ = new n.Op({ left: s[o - 2], op: "LIKE", right: s[o] }); break; case 380: this.$ = new n.Op({ left: s[o - 4], op: "LIKE", right: s[o - 2], escape: s[o] }); break; case 381: this.$ = new n.Op({ left: s[o - 2], op: "NOT LIKE", right: s[o] }); break; case 382: this.$ = new n.Op({ left: s[o - 4], op: "NOT LIKE", right: s[o - 2], escape: s[o] }); break; case 383: this.$ = new n.Op({ left: s[o - 2], op: "||", right: s[o] }); break; case 384: this.$ = new n.Op({ left: s[o - 2], op: "+", right: s[o] }); break; case 385: this.$ = new n.Op({ left: s[o - 2], op: "-", right: s[o] }); break; case 386: this.$ = new n.Op({ left: s[o - 2], op: "*", right: s[o] }); break; case 387: this.$ = new n.Op({ left: s[o - 2], op: "/", right: s[o] }); break; case 388: this.$ = new n.Op({ left: s[o - 2], op: "%", right: s[o] }); break; case 389: this.$ = new n.Op({ left: s[o - 2], op: "^", right: s[o] }); break; case 390: this.$ = new n.Op({ left: s[o - 2], op: ">>", right: s[o] }); break; case 391: this.$ = new n.Op({ left: s[o - 2], op: "<<", right: s[o] }); break; case 392: this.$ = new n.Op({ left: s[o - 2], op: "&", right: s[o] }); break; case 393: this.$ = new n.Op({ left: s[o - 2], op: "|", right: s[o] }); break; case 394: case 395: case 397: this.$ = new n.Op({ left: s[o - 2], op: "->", right: s[o] }); break; case 396: this.$ = new n.Op({ left: s[o - 4], op: "->", right: s[o - 1] }); break; case 398: case 399: case 401: this.$ = new n.Op({ left: s[o - 2], op: "!", right: s[o] }); break; case 400: this.$ = new n.Op({ left: s[o - 4], op: "!", right: s[o - 1] }); break; case 402: this.$ = new n.Op({ left: s[o - 2], op: ">", right: s[o] }); break; case 403: this.$ = new n.Op({ left: s[o - 2], op: ">=", right: s[o] }); break; case 404: this.$ = new n.Op({ left: s[o - 2], op: "<", right: s[o] }); break; case 405: this.$ = new n.Op({ left: s[o - 2], op: "<=", right: s[o] }); break; case 406: this.$ = new n.Op({ left: s[o - 2], op: "=", right: s[o] }); break; case 407: this.$ = new n.Op({ left: s[o - 2], op: "==", right: s[o] }); break; case 408: this.$ = new n.Op({ left: s[o - 2], op: "===", right: s[o] }); break; case 409: this.$ = new n.Op({ left: s[o - 2], op: "!=", right: s[o] }); break; case 410: this.$ = new n.Op({ left: s[o - 2], op: "!==", right: s[o] }); break; case 411: this.$ = new n.Op({ left: s[o - 2], op: "!===", right: s[o] }); break; case 412: n.queries || (n.queries = []), this.$ = new n.Op({ left: s[o - 5], op: s[o - 4], allsome: s[o - 3], right: s[o - 1], queriesidx: n.queries.length }), n.queries.push(s[o - 1]); break; case 413: this.$ = new n.Op({ left: s[o - 5], op: s[o - 4], allsome: s[o - 3], right: s[o - 1] }); break; case 414: "BETWEEN1" == s[o - 2].op ? "AND" == s[o - 2].left.op ? this.$ = new n.Op({ left: s[o - 2].left.left, op: "AND", right: new n.Op({ left: s[o - 2].left.right, op: "BETWEEN", right1: s[o - 2].right, right2: s[o] }) }) : this.$ = new n.Op({ left: s[o - 2].left, op: "BETWEEN", right1: s[o - 2].right, right2: s[o] }) : "NOT BETWEEN1" == s[o - 2].op ? "AND" == s[o - 2].left.op ? this.$ = new n.Op({ left: s[o - 2].left.left, op: "AND", right: new n.Op({ left: s[o - 2].left.right, op: "NOT BETWEEN", right1: s[o - 2].right, right2: s[o] }) }) : this.$ = new n.Op({ left: s[o - 2].left, op: "NOT BETWEEN", right1: s[o - 2].right, right2: s[o] }) : this.$ = new n.Op({ left: s[o - 2], op: "AND", right: s[o] }); break; case 415: this.$ = new n.Op({ left: s[o - 2], op: "OR", right: s[o] }); break; case 416: this.$ = new n.UniOp({ op: "NOT", right: s[o] }); break; case 417: this.$ = new n.UniOp({ op: "-", right: s[o] }); break; case 418: this.$ = new n.UniOp({ op: "+", right: s[o] }); break; case 419: this.$ = new n.UniOp({ op: "~", right: s[o] }); break; case 420: this.$ = new n.UniOp({ op: "#", right: s[o] }); break; case 421: this.$ = new n.UniOp({ right: s[o - 1] }); break; case 422: n.queries || (n.queries = []), this.$ = new n.Op({ left: s[o - 4], op: "IN", right: s[o - 1], queriesidx: n.queries.length }), n.queries.push(s[o - 1]); break; case 423: n.queries || (n.queries = []), this.$ = new n.Op({
                        left: s[o - 5], op: "NOT IN", right: s[o - 1],
                        queriesidx: n.queries.length
                    }), n.queries.push(s[o - 1]); break; case 424: this.$ = new n.Op({ left: s[o - 4], op: "IN", right: s[o - 1] }); break; case 425: this.$ = new n.Op({ left: s[o - 5], op: "NOT IN", right: s[o - 1] }); break; case 426: this.$ = new n.Op({ left: s[o - 3], op: "IN", right: [] }); break; case 427: this.$ = new n.Op({ left: s[o - 4], op: "NOT IN", right: [] }); break; case 428: case 430: this.$ = new n.Op({ left: s[o - 2], op: "IN", right: s[o] }); break; case 429: case 431: this.$ = new n.Op({ left: s[o - 3], op: "NOT IN", right: s[o] }); break; case 432: this.$ = new n.Op({ left: s[o - 2], op: "BETWEEN1", right: s[o] }); break; case 433: this.$ = new n.Op({ left: s[o - 2], op: "NOT BETWEEN1", right: s[o] }); break; case 434: this.$ = new n.Op({ op: "IS", left: s[o - 2], right: s[o] }); break; case 435: this.$ = new n.Op({ op: "IS", left: s[o - 2], right: new n.UniOp({ op: "NOT", right: new n.NullValue({ value: void 0 }) }) }); break; case 436: this.$ = new n.Convert({ expression: s[o - 2] }), n.extend(this.$, s[o]); break; case 437: case 438: this.$ = s[o]; break; case 439: this.$ = s[o - 1]; break; case 446: this.$ = "ALL"; break; case 447: this.$ = "SOME"; break; case 448: this.$ = "ANY"; break; case 449: this.$ = new n.Update({ table: s[o - 4], columns: s[o - 2], where: s[o] }); break; case 450: this.$ = new n.Update({ table: s[o - 2], columns: s[o] }); break; case 453: this.$ = new n.SetColumn({ column: s[o - 2], expression: s[o] }); break; case 454: this.$ = new n.SetColumn({ variable: s[o - 2], expression: s[o], method: s[o - 3] }); break; case 455: this.$ = new n.Delete({ table: s[o - 2], where: s[o] }); break; case 456: this.$ = new n.Delete({ table: s[o] }); break; case 457: this.$ = new n.Insert({ into: s[o - 2], values: s[o] }); break; case 458: this.$ = new n.Insert({ into: s[o - 1], values: s[o] }); break; case 459: case 461: this.$ = new n.Insert({ into: s[o - 2], values: s[o], orreplace: !0 }); break; case 460: case 462: this.$ = new n.Insert({ into: s[o - 1], values: s[o], orreplace: !0 }); break; case 463: this.$ = new n.Insert({ into: s[o - 2], default: !0 }); break; case 464: this.$ = new n.Insert({ into: s[o - 5], columns: s[o - 3], values: s[o] }); break; case 465: this.$ = new n.Insert({ into: s[o - 4], columns: s[o - 2], values: s[o] }); break; case 466: this.$ = new n.Insert({ into: s[o - 1], select: s[o] }); break; case 467: this.$ = new n.Insert({ into: s[o - 1], select: s[o], orreplace: !0 }); break; case 468: this.$ = new n.Insert({ into: s[o - 4], columns: s[o - 2], select: s[o] }); break; case 473: this.$ = [s[o - 1]]; break; case 476: this.$ = s[o - 4], s[o - 4].push(s[o - 1]); break; case 477: case 478: case 480: case 488: this.$ = s[o - 2], s[o - 2].push(s[o]); break; case 489: this.$ = new n.CreateTable({ table: s[o - 4] }), n.extend(this.$, s[o - 7]), n.extend(this.$, s[o - 6]), n.extend(this.$, s[o - 5]), n.extend(this.$, s[o - 2]), n.extend(this.$, s[o]); break; case 490: this.$ = new n.CreateTable({ table: s[o] }), n.extend(this.$, s[o - 3]), n.extend(this.$, s[o - 2]), n.extend(this.$, s[o - 1]); break; case 492: this.$ = { class: !0 }; break; case 502: this.$ = { temporary: !0 }; break; case 504: this.$ = { ifnotexists: !0 }; break; case 505: this.$ = { columns: s[o - 2], constraints: s[o] }; break; case 506: this.$ = { columns: s[o] }; break; case 507: this.$ = { as: s[o] }; break; case 508: case 532: this.$ = [s[o]]; break; case 510: case 511: case 512: case 513: case 514: s[o].constraintid = s[o - 1], this.$ = s[o]; break; case 517: this.$ = { type: "CHECK", expression: s[o - 1] }; break; case 518: this.$ = { type: "PRIMARY KEY", columns: s[o - 1], clustered: (s[o - 3] + "").toUpperCase() }; break; case 519: this.$ = { type: "FOREIGN KEY", columns: s[o - 5], fktable: s[o - 2], fkcolumns: s[o - 1] }; break; case 525: this.$ = { type: "UNIQUE", columns: s[o - 1], clustered: (s[o - 3] + "").toUpperCase() }; break; case 534: this.$ = new n.ColumnDef({ columnid: s[o - 2] }), n.extend(this.$, s[o - 1]), n.extend(this.$, s[o]); break; case 535: this.$ = new n.ColumnDef({ columnid: s[o - 1] }), n.extend(this.$, s[o]); break; case 536: this.$ = new n.ColumnDef({ columnid: s[o], dbtypeid: "" }); break; case 537: this.$ = { dbtypeid: s[o - 5], dbsize: s[o - 3], dbprecision: +s[o - 1] }; break; case 538: this.$ = { dbtypeid: s[o - 3], dbsize: s[o - 1] }; break; case 539: this.$ = { dbtypeid: s[o] }; break; case 540: this.$ = { dbtypeid: "ENUM", enumvalues: s[o - 1] }; break; case 541: this.$ = s[o - 1], s[o - 1].dbtypeid += "[" + s[o] + "]"; break; case 543: case 750: this.$ = +s[o]; break; case 545: this.$ = void 0; break; case 547: n.extend(s[o - 1], s[o]), this.$ = s[o - 1]; break; case 550: this.$ = { primarykey: !0 }; break; case 551: case 552: this.$ = { foreignkey: { table: s[o - 1], columnid: s[o] } }; break; case 553: this.$ = { identity: { value: s[o - 3], step: s[o - 1] } }; break; case 554: this.$ = { identity: { value: 1, step: 1 } }; break; case 555: case 557: this.$ = { default: s[o] }; break; case 556: this.$ = { default: s[o - 1] }; break; case 558: this.$ = { null: !0 }; break; case 559: this.$ = { notnull: !0 }; break; case 560: this.$ = { check: s[o] }; break; case 561: this.$ = { unique: !0 }; break; case 562: this.$ = { onupdate: s[o] }; break; case 563: this.$ = { onupdate: s[o - 1] }; break; case 564: this.$ = new n.DropTable({ tables: s[o], type: s[o - 2] }), n.extend(this.$, s[o - 1]); break; case 568: this.$ = { ifexists: !0 }; break; case 569: this.$ = new n.AlterTable({ table: s[o - 3], renameto: s[o] }); break; case 570: this.$ = new n.AlterTable({ table: s[o - 3], addcolumn: s[o] }); break; case 571: this.$ = new n.AlterTable({ table: s[o - 3], modifycolumn: s[o] }); break; case 572: this.$ = new n.AlterTable({ table: s[o - 5], renamecolumn: s[o - 2], to: s[o] }); break; case 573: this.$ = new n.AlterTable({ table: s[o - 3], dropcolumn: s[o] }); break; case 574: this.$ = new n.AlterTable({ table: s[o - 2], renameto: s[o] }); break; case 575: this.$ = new n.AttachDatabase({ databaseid: s[o], engineid: s[o - 2].toUpperCase() }); break; case 576: this.$ = new n.AttachDatabase({ databaseid: s[o - 3], engineid: s[o - 5].toUpperCase(), args: s[o - 1] }); break; case 577: this.$ = new n.AttachDatabase({ databaseid: s[o - 2], engineid: s[o - 4].toUpperCase(), as: s[o] }); break; case 578: this.$ = new n.AttachDatabase({ databaseid: s[o - 5], engineid: s[o - 7].toUpperCase(), as: s[o], args: s[o - 3] }); break; case 579: this.$ = new n.DetachDatabase({ databaseid: s[o] }); break; case 580: this.$ = new n.CreateDatabase({ databaseid: s[o] }), n.extend(this.$, s[o]); break; case 581: this.$ = new n.CreateDatabase({ engineid: s[o - 4].toUpperCase(), databaseid: s[o - 1], as: s[o] }), n.extend(this.$, s[o - 2]); break; case 582: this.$ = new n.CreateDatabase({ engineid: s[o - 7].toUpperCase(), databaseid: s[o - 4], args: s[o - 2], as: s[o] }), n.extend(this.$, s[o - 5]); break; case 583: this.$ = new n.CreateDatabase({ engineid: s[o - 4].toUpperCase(), as: s[o], args: [s[o - 1]] }), n.extend(this.$, s[o - 2]); break; case 584: this.$ = void 0; break; case 586: case 587: this.$ = new n.UseDatabase({ databaseid: s[o] }); break; case 588: this.$ = new n.DropDatabase({ databaseid: s[o] }), n.extend(this.$, s[o - 1]); break; case 589: case 590: this.$ = new n.DropDatabase({ databaseid: s[o], engineid: s[o - 3].toUpperCase() }), n.extend(this.$, s[o - 1]); break; case 591: this.$ = new n.CreateIndex({ indexid: s[o - 5], table: s[o - 3], columns: s[o - 1] }); break; case 592: this.$ = new n.CreateIndex({ indexid: s[o - 5], table: s[o - 3], columns: s[o - 1], unique: !0 }); break; case 593: this.$ = new n.DropIndex({ indexid: s[o] }); break; case 594: this.$ = new n.ShowDatabases; break; case 595: this.$ = new n.ShowDatabases({ like: s[o] }); break; case 596: this.$ = new n.ShowDatabases({ engineid: s[o - 1].toUpperCase() }); break; case 597: this.$ = new n.ShowDatabases({ engineid: s[o - 3].toUpperCase(), like: s[o] }); break; case 598: this.$ = new n.ShowTables; break; case 599: this.$ = new n.ShowTables({ like: s[o] }); break; case 600: this.$ = new n.ShowTables({ databaseid: s[o] }); break; case 601: this.$ = new n.ShowTables({ like: s[o], databaseid: s[o - 2] }); break; case 602: this.$ = new n.ShowColumns({ table: s[o] }); break; case 603: this.$ = new n.ShowColumns({ table: s[o - 2], databaseid: s[o] }); break; case 604: this.$ = new n.ShowIndex({ table: s[o] }); break; case 605: this.$ = new n.ShowIndex({ table: s[o - 2], databaseid: s[o] }); break; case 606: this.$ = new n.ShowCreateTable({ table: s[o] }); break; case 607: this.$ = new n.ShowCreateTable({ table: s[o - 2], databaseid: s[o] }); break; case 608: this.$ = new n.CreateTable({ table: s[o - 6], view: !0, select: s[o - 1], viewcolumns: s[o - 4] }), n.extend(this.$, s[o - 9]), n.extend(this.$, s[o - 7]); break; case 609: this.$ = new n.CreateTable({ table: s[o - 3], view: !0, select: s[o - 1] }), n.extend(this.$, s[o - 6]), n.extend(this.$, s[o - 4]); break; case 613: this.$ = new n.DropTable({ tables: s[o], view: !0 }), n.extend(this.$, s[o - 1]); break; case 614: case 760: this.$ = new n.ExpressionStatement({ expression: s[o] }); break; case 615: this.$ = new n.Source({ url: s[o].value }); break; case 616: this.$ = new n.Assert({ value: s[o] }); break; case 617: this.$ = new n.Assert({ value: s[o].value }); break; case 618: this.$ = new n.Assert({ value: s[o], message: s[o - 2] }); break; case 620: case 631: case 633: this.$ = s[o].value; break; case 621: case 629: this.$ = +s[o].value; break; case 622: this.$ = !!s[o].value; break; case 630: this.$ = "" + s[o].value; break; case 639: this.$ = {}; break; case 642: this.$ = []; break; case 643: n.extend(s[o - 2], s[o]), this.$ = s[o - 2]; break; case 645: this.$ = {}, this.$[s[o - 2].substr(1, s[o - 2].length - 2)] = s[o]; break; case 646: case 647: this.$ = {}, this.$[s[o - 2]] = s[o]; break; case 650: this.$ = new n.SetVariable({ variable: s[o - 2].toLowerCase(), value: s[o] }); break; case 651: this.$ = new n.SetVariable({ variable: s[o - 1].toLowerCase(), value: s[o] }); break; case 652: this.$ = new n.SetVariable({ variable: s[o - 2], expression: s[o] }); break; case 653: this.$ = new n.SetVariable({ variable: s[o - 3], props: s[o - 2], expression: s[o] }); break; case 654: this.$ = new n.SetVariable({ variable: s[o - 2], expression: s[o], method: s[o - 3] }); break; case 655: this.$ = new n.SetVariable({ variable: s[o - 3], props: s[o - 2], expression: s[o], method: s[o - 4] }); break; case 656: this.$ = "@"; break; case 657: this.$ = "$"; break; case 663: this.$ = !0; break; case 664: this.$ = !1; break; case 665: this.$ = new n.CommitTransaction; break; case 666: this.$ = new n.RollbackTransaction; break; case 667: this.$ = new n.BeginTransaction; break; case 668: this.$ = new n.If({ expression: s[o - 2], thenstat: s[o - 1], elsestat: s[o] }), s[o - 1].exists && (this.$.exists = s[o - 1].exists), s[o - 1].queries && (this.$.queries = s[o - 1].queries); break; case 669: this.$ = new n.If({ expression: s[o - 1], thenstat: s[o] }), s[o].exists && (this.$.exists = s[o].exists), s[o].queries && (this.$.queries = s[o].queries); break; case 670: this.$ = s[o]; break; case 671: this.$ = new n.While({ expression: s[o - 1], loopstat: s[o] }), s[o].exists && (this.$.exists = s[o].exists), s[o].queries && (this.$.queries = s[o].queries); break; case 672: this.$ = new n.Continue; break; case 673: this.$ = new n.Break; break; case 674: this.$ = new n.BeginEnd({ statements: s[o - 1] }); break; case 675: this.$ = new n.Print({ exprs: s[o] }); break; case 676: this.$ = new n.Print({ select: s[o] }); break; case 677: this.$ = new n.Require({ paths: s[o] }); break; case 678: this.$ = new n.Require({ plugins: s[o] }); break; case 679: case 680: this.$ = s[o].toUpperCase(); break; case 681: this.$ = new n.Echo({ expr: s[o] }); break; case 686: this.$ = new n.Declare({ declares: s[o] }); break; case 689: this.$ = { variable: s[o - 1] }, n.extend(this.$, s[o]); break; case 690: this.$ = { variable: s[o - 2] }, n.extend(this.$, s[o]); break; case 691: this.$ = { variable: s[o - 3], expression: s[o] }, n.extend(this.$, s[o - 2]); break; case 692: this.$ = { variable: s[o - 4], expression: s[o] }, n.extend(this.$, s[o - 2]); break; case 693: this.$ = new n.TruncateTable({ table: s[o] }); break; case 694: this.$ = new n.Merge, n.extend(this.$, s[o - 4]), n.extend(this.$, s[o - 3]), n.extend(this.$, s[o - 2]), n.extend(this.$, { matches: s[o - 1] }), n.extend(this.$, s[o]); break; case 695: case 696: this.$ = { into: s[o] }; break; case 698: this.$ = { on: s[o] }; break; case 703: this.$ = { matched: !0, action: s[o] }; break; case 704: this.$ = { matched: !0, expr: s[o - 2], action: s[o] }; break; case 705: this.$ = { delete: !0 }; break; case 706: this.$ = { update: s[o] }; break; case 707: case 708: this.$ = { matched: !1, bytarget: !0, action: s[o] }; break; case 709: case 710: this.$ = { matched: !1, bytarget: !0, expr: s[o - 2], action: s[o] }; break; case 711: this.$ = { matched: !1, bysource: !0, action: s[o] }; break; case 712: this.$ = { matched: !1, bysource: !0, expr: s[o - 2], action: s[o] }; break; case 713: this.$ = { insert: !0, values: s[o] }; break; case 714: this.$ = { insert: !0, values: s[o], columns: s[o - 3] }; break; case 715: this.$ = { insert: !0, defaultvalues: !0 }; break; case 716: this.$ = { insert: !0, defaultvalues: !0, columns: s[o - 3] }; break; case 718: this.$ = { output: { columns: s[o] } }; break; case 719: this.$ = { output: { columns: s[o - 3], intovar: s[o], method: s[o - 1] } }; break; case 720: this.$ = { output: { columns: s[o - 2], intotable: s[o] } }; break; case 721: this.$ = { output: { columns: s[o - 5], intotable: s[o - 3], intocolumns: s[o - 1] } }; break; case 722: this.$ = new n.CreateVertex({ class: s[o - 3], sharp: s[o - 2], name: s[o - 1] }), n.extend(this.$, s[o]); break; case 725: this.$ = { sets: s[o] }; break; case 726: this.$ = { content: s[o] }; break; case 727: this.$ = { select: s[o] }; break; case 728: this.$ = new n.CreateEdge({ from: s[o - 3], to: s[o - 1], name: s[o - 5] }), n.extend(this.$, s[o]); break; case 729: this.$ = new n.CreateGraph({ graph: s[o] }); break; case 730: this.$ = new n.CreateGraph({ from: s[o] }); break; case 733: this.$ = s[o - 2], s[o - 1] && (this.$.json = new n.Json({ value: s[o - 1] })), s[o] && (this.$.as = s[o]); break; case 734: this.$ = { source: s[o - 6], target: s[o] }, s[o - 3] && (this.$.json = new n.Json({ value: s[o - 3] })), s[o - 2] && (this.$.as = s[o - 2]), n.extend(this.$, s[o - 4]); break; case 735: this.$ = { source: s[o - 5], target: s[o] }, s[o - 2] && (this.$.json = new n.Json({ value: s[o - 3] })), s[o - 1] && (this.$.as = s[o - 2]); break; case 736: this.$ = { source: s[o - 2], target: s[o] }; break; case 740: this.$ = { vars: s[o], method: s[o - 1] }; break; case 743: case 744: var b = s[o - 1]; this.$ = { prop: s[o - 3], sharp: s[o - 2], name: void 0 === b ? void 0 : b.substr(1, b.length - 2), class: s[o] }; break; case 745: var E = s[o - 1]; this.$ = { sharp: s[o - 2], name: void 0 === E ? void 0 : E.substr(1, E.length - 2), class: s[o] }; break; case 746: var g = s[o - 1]; this.$ = { name: void 0 === g ? void 0 : g.substr(1, g.length - 2), class: s[o] }; break; case 747: this.$ = { class: s[o] }; break; case 753: this.$ = new n.AddRule({ left: s[o - 2], right: s[o] }); break; case 754: this.$ = new n.AddRule({ right: s[o] }); break; case 757: this.$ = new n.Term({ termid: s[o] }); break; case 758: this.$ = new n.Term({ termid: s[o - 3], args: s[o - 1] }); break; case 761: this.$ = new n.CreateTrigger({ trigger: s[o - 6], when: s[o - 5], action: s[o - 4], table: s[o - 2], statement: s[o] }), s[o].exists && (this.$.exists = s[o].exists), s[o].queries && (this.$.queries = s[o].queries); break; case 762: this.$ = new n.CreateTrigger({ trigger: s[o - 5], when: s[o - 4], action: s[o - 3], table: s[o - 1], funcid: s[o] }); break; case 763: this.$ = new n.CreateTrigger({ trigger: s[o - 6], when: s[o - 4], action: s[o - 3], table: s[o - 5], statement: s[o] }), s[o].exists && (this.$.exists = s[o].exists), s[o].queries && (this.$.queries = s[o].queries); break; case 764: case 765: case 767: this.$ = "AFTER"; break; case 766: this.$ = "BEFORE"; break; case 768: this.$ = "INSTEADOF"; break; case 769: this.$ = "INSERT"; break; case 770: this.$ = "DELETE"; break; case 771: this.$ = "UPDATE"; break; case 772: this.$ = new n.DropTrigger({ trigger: s[o] }); break; case 773: this.$ = new n.Reindex({ indexid: s[o] }); break; case 1047: case 1067: case 1069: case 1071: case 1075: case 1077: case 1079: case 1081: case 1083: case 1085: this.$ = []; break; case 1048: case 1062: case 1064: case 1068: case 1070: case 1072: case 1076: case 1078: case 1080: case 1082: case 1084: case 1086: s[o - 1].push(s[o]); break; case 1061: case 1063: this.$ = [s[o]]
                }
            }, table: [t([10, 602, 764], r, { 8: 1, 9: 2, 12: 3, 13: 4, 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 2: n, 4: a, 5: s, 14: i, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), { 1: [3] }, { 10: [1, 105], 11: 106, 602: Y, 764: W }, t(X, [2, 8]), t(X, [2, 9]), t(K, [2, 12]), t(X, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 109, 2: n, 4: a, 5: s, 15: [1, 110], 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(K, [2, 14]), t(K, [2, 15]), t(K, [2, 16]), t(K, [2, 17]), t(K, [2, 18]), t(K, [2, 19]), t(K, [2, 20]), t(K, [2, 21]), t(K, [2, 22]), t(K, [2, 23]), t(K, [2, 24]), t(K, [2, 25]), t(K, [2, 26]), t(K, [2, 27]), t(K, [2, 28]), t(K, [2, 29]), t(K, [2, 30]), t(K, [2, 31]), t(K, [2, 32]), t(K, [2, 33]), t(K, [2, 34]), t(K, [2, 35]), t(K, [2, 36]), t(K, [2, 37]), t(K, [2, 38]), t(K, [2, 39]), t(K, [2, 40]), t(K, [2, 41]), t(K, [2, 42]), t(K, [2, 43]), t(K, [2, 44]), t(K, [2, 45]), t(K, [2, 46]), t(K, [2, 47]), t(K, [2, 48]), t(K, [2, 49]), t(K, [2, 50]), t(K, [2, 51]), t(K, [2, 52]), t(K, [2, 53]), t(K, [2, 54]), t(K, [2, 55]), t(K, [2, 56]), t(K, [2, 57]), t(K, [2, 58]), t(K, [2, 59]), t(K, [2, 60]), t(K, [2, 61]), t(K, [2, 62]), t(K, [2, 63]), t(K, [2, 64]), t(K, [2, 65]), t(K, [2, 66]), t(K, [2, 67]), { 353: [1, 111] }, { 2: n, 3: 112, 4: a, 5: s }, { 2: n, 3: 114, 4: a, 5: s, 156: Q, 200: 113, 290: z, 291: Z, 292: ee, 293: te }, t(re, [2, 501], { 3: 121, 348: 125, 2: n, 4: a, 5: s, 134: ne, 135: ae, 187: [1, 123], 193: [1, 122], 268: [1, 129], 269: [1, 130], 357: [1, 131], 405: [1, 120], 472: [1, 124], 509: [1, 128] }), { 145: se, 449: 132, 450: 133 }, { 183: [1, 135] }, { 405: [1, 136] }, { 2: n, 3: 138, 4: a, 5: s, 130: [1, 144], 193: [1, 139], 353: [1, 143], 397: 140, 405: [1, 137], 410: [1, 141], 509: [1, 142] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 145, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Be, je, { 340: 204, 171: [1, 205], 198: He }), t(Be, je, { 340: 207, 198: He }), { 2: n, 3: 219, 4: a, 5: s, 77: Je, 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 198: [1, 210], 199: 213, 200: 215, 201: 214, 202: 217, 209: 209, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve, 453: 208 }, { 2: n, 3: 221, 4: a, 5: s }, { 353: [1, 222] }, t(Xe, [2, 1043], { 80: 223, 106: 224, 107: [1, 225] }), t(Ke, [2, 1047], { 90: 226 }), { 2: n, 3: 230, 4: a, 5: s, 190: [1, 228], 193: [1, 231], 267: [1, 227], 353: [1, 232], 405: [1, 229] }, { 353: [1, 233] }, { 2: n, 3: 236, 4: a, 5: s, 73: 234, 75: 235 }, t([306, 602, 764], r, { 12: 3, 13: 4, 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 9: 238, 2: n, 4: a, 5: s, 14: i, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 435: [1, 237], 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), { 435: [1, 239] }, { 435: [1, 240] }, { 2: n, 3: 242, 4: a, 5: s, 405: [1, 241] }, { 2: n, 3: 244, 4: a, 5: s, 199: 243 }, t(Qe, [2, 311]), { 113: 245, 132: ue, 296: Le }, { 2: n, 3: 114, 4: a, 5: s, 113: 251, 131: oe, 132: [1, 248], 143: le, 144: 246, 145: ze, 152: fe, 156: Q, 181: ge, 196: 250, 200: 255, 201: 254, 257: 252, 258: 253, 265: Ze, 274: 247, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 257, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(K, [2, 672]), t(K, [2, 673]), { 2: n, 3: 168, 4: a, 5: s, 40: 259, 56: 165, 77: ie, 79: 75, 89: c, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 258, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 184: 99, 189: f, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 266, 4: a, 5: s, 113: 263, 132: ue, 296: Le, 444: 261, 445: 262, 446: 264, 447: et }, { 2: n, 3: 267, 4: a, 5: s, 143: tt, 145: rt, 431: 268 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 271, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 505: [1, 272] }, { 2: n, 3: 100, 4: a, 5: s, 504: 274, 506: 273 }, { 2: n, 3: 114, 4: a, 5: s, 156: Q, 200: 275, 290: z, 291: Z, 292: ee, 293: te }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 276, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(nt, at, { 186: 280, 164: [1, 279], 185: [1, 277], 187: [1, 278], 195: st }), t(it, [2, 757], { 77: [1, 282] }), t([2, 4, 5, 10, 72, 77, 78, 93, 98, 107, 118, 128, 131, 132, 137, 143, 145, 152, 154, 156, 162, 164, 168, 169, 179, 180, 181, 183, 185, 187, 195, 198, 232, 245, 247, 265, 266, 270, 271, 273, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 302, 303, 306, 310, 312, 317, 420, 424, 602, 764], [2, 152], { 149: [1, 283], 150: [1, 284], 190: [1, 285], 191: [1, 286], 192: [1, 287], 193: [1, 288], 194: [1, 289] }), t(ot, [2, 1]), t(ot, [2, 2]), { 6: 290, 131: [1, 439], 172: [1, 462], 245: [1, 411], 285: [1, 373], 286: [1, 407], 370: [1, 404], 381: [1, 295], 402: [1, 297], 410: [1, 549], 414: [1, 471], 416: [1, 443], 417: [1, 509], 433: [1, 442], 435: [1, 525], 440: [1, 342], 460: [1, 418], 464: [1, 448], 470: [1, 341], 514: [1, 307], 515: [1, 299], 516: [1, 399], 518: [1, 291], 519: [1, 292], 520: [1, 293], 521: [1, 294], 522: [1, 296], 523: [1, 298], 524: [1, 300], 525: [1, 301], 526: [1, 302], 527: [1, 303], 528: [1, 304], 529: [1, 305], 530: [1, 306], 531: [1, 308], 532: [1, 309], 533: [1, 310], 534: [1, 311], 535: [1, 312], 536: [1, 313], 537: [1, 314], 538: [1, 315], 539: [1, 316], 540: [1, 317], 541: [1, 318], 542: [1, 319], 543: [1, 320], 544: [1, 321], 545: [1, 322], 546: [1, 323], 547: [1, 324], 548: [1, 325], 549: [1, 326], 550: [1, 327], 551: [1, 328], 552: [1, 329], 553: [1, 330], 554: [1, 331], 555: [1, 332], 556: [1, 333], 557: [1, 334], 558: [1, 335], 559: [1, 336], 560: [1, 337], 561: [1, 338], 562: [1, 339], 563: [1, 340], 564: [1, 343], 565: [1, 344], 566: [1, 345], 567: [1, 346], 568: [1, 347], 569: [1, 348], 570: [1, 349], 571: [1, 350], 572: [1, 351], 573: [1, 352], 574: [1, 353], 575: [1, 354], 576: [1, 355], 577: [1, 356], 578: [1, 357], 579: [1, 358], 580: [1, 359], 581: [1, 360], 582: [1, 361], 583: [1, 362], 584: [1, 363], 585: [1, 364], 586: [1, 365], 587: [1, 366], 588: [1, 367], 589: [1, 368], 590: [1, 369], 591: [1, 370], 592: [1, 371], 593: [1, 372], 594: [1, 374], 595: [1, 375], 596: [1, 376], 597: [1, 377], 598: [1, 378], 599: [1, 379], 600: [1, 380], 601: [1, 381], 602: [1, 382], 603: [1, 383], 604: [1, 384], 605: [1, 385], 606: [1, 386], 607: [1, 387], 608: [1, 388], 609: [1, 389], 610: [1, 390], 611: [1, 391], 612: [1, 392], 613: [1, 393], 614: [1, 394], 615: [1, 395], 616: [1, 396], 617: [1, 397], 618: [1, 398], 619: [1, 400], 620: [1, 401], 621: [1, 402], 622: [1, 403], 623: [1, 405], 624: [1, 406], 625: [1, 408], 626: [1, 409], 627: [1, 410], 628: [1, 412], 629: [1, 413], 630: [1, 414], 631: [1, 415], 632: [1, 416], 633: [1, 417], 634: [1, 419], 635: [1, 420], 636: [1, 421], 637: [1, 422], 638: [1, 423], 639: [1, 424], 640: [1, 425], 641: [1, 426], 642: [1, 427], 643: [1, 428], 644: [1, 429], 645: [1, 430], 646: [1, 431], 647: [1, 432], 648: [1, 433], 649: [1, 434], 650: [1, 435], 651: [1, 436], 652: [1, 437], 653: [1, 438], 654: [1, 440], 655: [1, 441], 656: [1, 444], 657: [1, 445], 658: [1, 446], 659: [1, 447], 660: [1, 449], 661: [1, 450], 662: [1, 451], 663: [1, 452], 664: [1, 453], 665: [1, 454], 666: [1, 455], 667: [1, 456], 668: [1, 457], 669: [1, 458], 670: [1, 459], 671: [1, 460], 672: [1, 461], 673: [1, 463], 674: [1, 464], 675: [1, 465], 676: [1, 466], 677: [1, 467], 678: [1, 468], 679: [1, 469], 680: [1, 470], 681: [1, 472], 682: [1, 473], 683: [1, 474], 684: [1, 475], 685: [1, 476], 686: [1, 477], 687: [1, 478], 688: [1, 479], 689: [1, 480], 690: [1, 481], 691: [1, 482], 692: [1, 483], 693: [1, 484], 694: [1, 485], 695: [1, 486], 696: [1, 487], 697: [1, 488], 698: [1, 489], 699: [1, 490], 700: [1, 491], 701: [1, 492], 702: [1, 493], 703: [1, 494], 704: [1, 495], 705: [1, 496], 706: [1, 497], 707: [1, 498], 708: [1, 499], 709: [1, 500], 710: [1, 501], 711: [1, 502], 712: [1, 503], 713: [1, 504], 714: [1, 505], 715: [1, 506], 716: [1, 507], 717: [1, 508], 718: [1, 510], 719: [1, 511], 720: [1, 512], 721: [1, 513], 722: [1, 514], 723: [1, 515], 724: [1, 516], 725: [1, 517], 726: [1, 518], 727: [1, 519], 728: [1, 520], 729: [1, 521], 730: [1, 522], 731: [1, 523], 732: [1, 524], 733: [1, 526], 734: [1, 527], 735: [1, 528], 736: [1, 529], 737: [1, 530], 738: [1, 531], 739: [1, 532], 740: [1, 533], 741: [1, 534], 742: [1, 535], 743: [1, 536], 744: [1, 537], 745: [1, 538], 746: [1, 539], 747: [1, 540], 748: [1, 541], 749: [1, 542], 750: [1, 543], 751: [1, 544], 752: [1, 545], 753: [1, 546], 754: [1, 547], 755: [1, 548], 756: [1, 550], 757: [1, 551], 758: [1, 552], 759: [1, 553], 760: [1, 554], 761: [1, 555], 762: [1, 556], 763: [1, 557] }, { 1: [2, 6] }, t(X, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 558, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(ut, [2, 1041]), t(ut, [2, 1042]), t(X, [2, 10]), { 16: [1, 559] }, { 2: n, 3: 244, 4: a, 5: s, 199: 560 }, { 405: [1, 561] }, t(K, [2, 760]), { 77: ct }, { 77: [1, 563] }, { 77: lt }, { 77: [1, 565] }, { 77: [1, 566] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 567, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Be, ht, { 350: 568, 156: dt }), { 405: [1, 570] }, { 2: n, 3: 571, 4: a, 5: s }, { 193: [1, 572] }, { 2: n, 3: 578, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 183: [1, 574], 431: 585, 473: 573, 474: 575, 475: 576, 478: 577, 482: 582, 493: 579, 497: 581 }, { 130: [1, 589], 349: 586, 353: [1, 588], 410: [1, 587] }, { 113: 591, 132: ue, 183: [2, 1141], 296: Le, 471: 590 }, t(Et, [2, 1135], { 465: 592, 3: 593, 2: n, 4: a, 5: s }), { 2: n, 3: 594, 4: a, 5: s }, { 4: [1, 595] }, { 4: [1, 596] }, t(re, [2, 502]), t(K, [2, 686], { 74: [1, 597] }), t(gt, [2, 687]), { 2: n, 3: 598, 4: a, 5: s }, { 2: n, 3: 244, 4: a, 5: s, 199: 599 }, { 2: n, 3: 600, 4: a, 5: s }, t(Be, mt, { 398: 601, 156: vt }), { 405: [1, 603] }, { 2: n, 3: 604, 4: a, 5: s }, t(Be, mt, { 398: 605, 156: vt }), t(Be, mt, { 398: 606, 156: vt }), { 2: n, 3: 607, 4: a, 5: s }, t(St, [2, 1129]), t(St, [2, 1130]), t(K, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 608, 114: 625, 327: 637, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: Rt, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 146: h, 154: $t, 156: d, 170: Mt, 171: Ut, 179: _t, 180: Ft, 189: f, 266: p, 267: b, 290: E, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(Qe, [2, 288]), t(Qe, [2, 289]), t(Qe, [2, 290]), t(Qe, [2, 291]), t(Qe, [2, 292]), t(Qe, [2, 293]), t(Qe, [2, 294]), t(Qe, [2, 295]), t(Qe, [2, 296]), t(Qe, [2, 297]), t(Qe, [2, 298]), t(Qe, [2, 299]), t(Qe, [2, 300]), t(Qe, [2, 301]), t(Qe, [2, 302]), t(Qe, [2, 303]), t(Qe, [2, 304]), t(Qe, [2, 305]), { 2: n, 3: 168, 4: a, 5: s, 26: 654, 27: 653, 36: 649, 40: 648, 56: 165, 77: ie, 79: 75, 89: c, 94: 651, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 184: 99, 189: f, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 264: 650, 265: me, 266: p, 267: [1, 655], 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: [1, 652], 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 339: v, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 309]), t(Qe, [2, 310]), { 77: [1, 656] }, t([2, 4, 5, 10, 53, 72, 74, 76, 78, 89, 93, 95, 98, 99, 107, 112, 115, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], ar, { 77: ct, 116: [1, 657] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 658, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 659, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 661, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, {
                2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 662, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve
            }, t(Qe, [2, 283]), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 239, 242, 243, 245, 247, 249, 265, 266, 267, 270, 271, 273, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 302, 303, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 415, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764, 765, 766], [2, 356]), t(sr, [2, 357]), t(sr, [2, 358]), t(sr, ir), t(sr, [2, 360]), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 361]), { 2: n, 3: 664, 4: a, 5: s, 131: [1, 665], 301: 663 }, { 2: n, 3: 666, 4: a, 5: s }, t(sr, [2, 367]), t(sr, [2, 368]), { 2: n, 3: 667, 4: a, 5: s, 77: or, 113: 669, 131: oe, 132: ue, 143: le, 152: fe, 181: ge, 196: 670, 201: 672, 257: 671, 294: De, 295: ke, 296: Le, 302: _e, 419: 673, 424: Ve }, { 77: [1, 674] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 675, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 304: 676, 307: 677, 308: ur, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 77: [1, 679] }, { 77: [1, 680] }, t(cr, [2, 624]), { 2: n, 3: 695, 4: a, 5: s, 77: lr, 111: 690, 113: 688, 131: oe, 132: ue, 143: le, 144: 685, 145: ze, 152: fe, 156: Q, 181: ge, 196: 687, 200: 693, 201: 692, 257: 689, 258: 691, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 300: [1, 683], 302: _e, 419: 190, 420: Ge, 421: 681, 422: 684, 423: 686, 424: Ve, 427: 682 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 696, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 697, 4: a, 5: s, 156: Q, 200: 698, 290: z, 291: Z, 292: ee, 293: te }, { 77: [2, 336] }, { 77: [2, 337] }, { 77: [2, 338] }, { 77: [2, 339] }, { 77: [2, 340] }, { 77: [2, 341] }, { 77: [2, 342] }, { 77: [2, 343] }, { 77: [2, 344] }, { 2: n, 3: 704, 4: a, 5: s, 131: hr, 132: dr, 425: 699, 426: [1, 700], 428: 701 }, { 2: n, 3: 244, 4: a, 5: s, 199: 705 }, { 290: [1, 706] }, t(Be, [2, 472]), { 2: n, 3: 244, 4: a, 5: s, 199: 707 }, { 231: [1, 709], 454: 708 }, { 231: [2, 695] }, { 2: n, 3: 219, 4: a, 5: s, 77: Je, 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 199: 213, 200: 215, 201: 214, 202: 217, 209: 710, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, { 40: 711, 79: 75, 89: c, 184: 99, 189: f }, t(fr, [2, 1091], { 210: 712, 76: [1, 713] }), t(pr, [2, 185], { 3: 714, 2: n, 4: a, 5: s, 76: [1, 715], 154: [1, 716] }), t(pr, [2, 189], { 3: 717, 2: n, 4: a, 5: s, 76: [1, 718] }), t(pr, [2, 190], { 3: 719, 2: n, 4: a, 5: s, 76: [1, 720] }), t(pr, [2, 193]), t(pr, [2, 194], { 3: 721, 2: n, 4: a, 5: s, 76: [1, 722] }), t(pr, [2, 197], { 3: 723, 2: n, 4: a, 5: s, 76: [1, 724] }), t([2, 4, 5, 10, 72, 74, 76, 78, 93, 98, 118, 128, 154, 162, 168, 169, 183, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], br, { 77: ct, 116: Er }), t([2, 4, 5, 10, 72, 74, 76, 78, 93, 98, 118, 128, 162, 168, 169, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 306, 310, 602, 764], [2, 200]), t(K, [2, 773]), { 2: n, 3: 244, 4: a, 5: s, 199: 726 }, t(gr, mr, { 81: 727, 198: vr }), t(Xe, [2, 1044]), t(Sr, [2, 1057], { 108: 729, 190: [1, 730] }), t([10, 78, 183, 306, 310, 602, 764], mr, { 419: 190, 81: 731, 117: 732, 3: 733, 114: 736, 144: 758, 158: 768, 160: 769, 2: n, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 115: yt, 116: Nt, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 198: vr, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 420: Ge, 424: Ve }), { 353: [1, 782] }, { 183: [1, 783] }, t(K, [2, 594], { 112: [1, 784] }), { 405: [1, 785] }, { 183: [1, 786] }, t(K, [2, 598], { 112: [1, 787], 183: [1, 788] }), { 2: n, 3: 244, 4: a, 5: s, 199: 789 }, { 40: 790, 74: [1, 791], 79: 75, 89: c, 184: 99, 189: f }, t(dn, [2, 70]), { 76: [1, 792] }, t(K, [2, 667]), { 11: 106, 306: [1, 793], 602: Y, 764: W }, t(K, [2, 665]), t(K, [2, 666]), { 2: n, 3: 794, 4: a, 5: s }, t(K, [2, 587]), { 146: [1, 795] }, t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 95, 124, 128, 143, 145, 146, 148, 149, 152, 154, 156, 181, 183, 187, 189, 230, 266, 267, 290, 297, 302, 306, 310, 335, 338, 339, 343, 344, 356, 368, 369, 373, 374, 396, 400, 401, 402, 403, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 514, 515, 516, 517, 602, 764], br, { 116: Er }), t(K, [2, 615]), t(K, [2, 616]), t(K, [2, 617]), t(K, ir, { 74: [1, 796] }), { 77: or, 113: 669, 131: oe, 132: ue, 143: le, 152: fe, 181: ge, 196: 670, 201: 672, 257: 671, 294: De, 295: ke, 296: Le, 302: _e, 419: 673, 424: Ve }, t(fn, [2, 320]), t(fn, [2, 321]), t(fn, [2, 322]), t(fn, [2, 323]), t(fn, [2, 324]), t(fn, [2, 325]), t(fn, [2, 326]), t(K, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 114: 625, 327: 637, 12: 797, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: Rt, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 146: h, 154: $t, 156: d, 170: Mt, 171: Ut, 179: _t, 180: Ft, 189: f, 266: p, 267: b, 290: E, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(K, [2, 675], { 74: pn }), t(K, [2, 676]), t(bn, [2, 354], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(K, [2, 677], { 74: [1, 800] }), t(K, [2, 678], { 74: [1, 801] }), t(gt, [2, 683]), t(gt, [2, 685]), t(gt, [2, 679]), t(gt, [2, 680]), { 114: 807, 115: yt, 116: Nt, 124: [1, 802], 230: gn, 429: 803, 430: 804, 433: mn }, { 2: n, 3: 808, 4: a, 5: s }, t(Be, [2, 656]), t(Be, [2, 657]), t(K, [2, 614], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 100, 4: a, 5: s, 504: 274, 506: 809 }, t(K, [2, 754], { 74: vn }), t(Sn, [2, 756]), t(K, [2, 759]), t(K, [2, 681], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Tn, at, { 186: 811, 195: st }), t(Tn, at, { 186: 812, 195: st }), t(Tn, at, { 186: 813, 195: st }), t(An, [2, 1087], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 188: 814, 174: 815, 253: 816, 94: 817, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), { 77: [1, 819], 131: oe, 196: 818 }, { 2: n, 3: 100, 4: a, 5: s, 504: 274, 506: 820 }, t(yn, [2, 153]), t(yn, [2, 154]), t(yn, [2, 155]), t(yn, [2, 156]), t(yn, [2, 157]), t(yn, [2, 158]), t(yn, [2, 159]), t(ot, [2, 3]), t(ot, [2, 774]), t(ot, [2, 775]), t(ot, [2, 776]), t(ot, [2, 777]), t(ot, [2, 778]), t(ot, [2, 779]), t(ot, [2, 780]), t(ot, [2, 781]), t(ot, [2, 782]), t(ot, [2, 783]), t(ot, [2, 784]), t(ot, [2, 785]), t(ot, [2, 786]), t(ot, [2, 787]), t(ot, [2, 788]), t(ot, [2, 789]), t(ot, [2, 790]), t(ot, [2, 791]), t(ot, [2, 792]), t(ot, [2, 793]), t(ot, [2, 794]), t(ot, [2, 795]), t(ot, [2, 796]), t(ot, [2, 797]), t(ot, [2, 798]), t(ot, [2, 799]), t(ot, [2, 800]), t(ot, [2, 801]), t(ot, [2, 802]), t(ot, [2, 803]), t(ot, [2, 804]), t(ot, [2, 805]), t(ot, [2, 806]), t(ot, [2, 807]), t(ot, [2, 808]), t(ot, [2, 809]), t(ot, [2, 810]), t(ot, [2, 811]), t(ot, [2, 812]), t(ot, [2, 813]), t(ot, [2, 814]), t(ot, [2, 815]), t(ot, [2, 816]), t(ot, [2, 817]), t(ot, [2, 818]), t(ot, [2, 819]), t(ot, [2, 820]), t(ot, [2, 821]), t(ot, [2, 822]), t(ot, [2, 823]), t(ot, [2, 824]), t(ot, [2, 825]), t(ot, [2, 826]), t(ot, [2, 827]), t(ot, [2, 828]), t(ot, [2, 829]), t(ot, [2, 830]), t(ot, [2, 831]), t(ot, [2, 832]), t(ot, [2, 833]), t(ot, [2, 834]), t(ot, [2, 835]), t(ot, [2, 836]), t(ot, [2, 837]), t(ot, [2, 838]), t(ot, [2, 839]), t(ot, [2, 840]), t(ot, [2, 841]), t(ot, [2, 842]), t(ot, [2, 843]), t(ot, [2, 844]), t(ot, [2, 845]), t(ot, [2, 846]), t(ot, [2, 847]), t(ot, [2, 848]), t(ot, [2, 849]), t(ot, [2, 850]), t(ot, [2, 851]), t(ot, [2, 852]), t(ot, [2, 853]), t(ot, [2, 854]), t(ot, [2, 855]), t(ot, [2, 856]), t(ot, [2, 857]), t(ot, [2, 858]), t(ot, [2, 859]), t(ot, [2, 860]), t(ot, [2, 861]), t(ot, [2, 862]), t(ot, [2, 863]), t(ot, [2, 864]), t(ot, [2, 865]), t(ot, [2, 866]), t(ot, [2, 867]), t(ot, [2, 868]), t(ot, [2, 869]), t(ot, [2, 870]), t(ot, [2, 871]), t(ot, [2, 872]), t(ot, [2, 873]), t(ot, [2, 874]), t(ot, [2, 875]), t(ot, [2, 876]), t(ot, [2, 877]), t(ot, [2, 878]), t(ot, [2, 879]), t(ot, [2, 880]), t(ot, [2, 881]), t(ot, [2, 882]), t(ot, [2, 883]), t(ot, [2, 884]), t(ot, [2, 885]), t(ot, [2, 886]), t(ot, [2, 887]), t(ot, [2, 888]), t(ot, [2, 889]), t(ot, [2, 890]), t(ot, [2, 891]), t(ot, [2, 892]), t(ot, [2, 893]), t(ot, [2, 894]), t(ot, [2, 895]), t(ot, [2, 896]), t(ot, [2, 897]), t(ot, [2, 898]), t(ot, [2, 899]), t(ot, [2, 900]), t(ot, [2, 901]), t(ot, [2, 902]), t(ot, [2, 903]), t(ot, [2, 904]), t(ot, [2, 905]), t(ot, [2, 906]), t(ot, [2, 907]), t(ot, [2, 908]), t(ot, [2, 909]), t(ot, [2, 910]), t(ot, [2, 911]), t(ot, [2, 912]), t(ot, [2, 913]), t(ot, [2, 914]), t(ot, [2, 915]), t(ot, [2, 916]), t(ot, [2, 917]), t(ot, [2, 918]), t(ot, [2, 919]), t(ot, [2, 920]), t(ot, [2, 921]), t(ot, [2, 922]), t(ot, [2, 923]), t(ot, [2, 924]), t(ot, [2, 925]), t(ot, [2, 926]), t(ot, [2, 927]), t(ot, [2, 928]), t(ot, [2, 929]), t(ot, [2, 930]), t(ot, [2, 931]), t(ot, [2, 932]), t(ot, [2, 933]), t(ot, [2, 934]), t(ot, [2, 935]), t(ot, [2, 936]), t(ot, [2, 937]), t(ot, [2, 938]), t(ot, [2, 939]), t(ot, [2, 940]), t(ot, [2, 941]), t(ot, [2, 942]), t(ot, [2, 943]), t(ot, [2, 944]), t(ot, [2, 945]), t(ot, [2, 946]), t(ot, [2, 947]), t(ot, [2, 948]), t(ot, [2, 949]), t(ot, [2, 950]), t(ot, [2, 951]), t(ot, [2, 952]), t(ot, [2, 953]), t(ot, [2, 954]), t(ot, [2, 955]), t(ot, [2, 956]), t(ot, [2, 957]), t(ot, [2, 958]), t(ot, [2, 959]), t(ot, [2, 960]), t(ot, [2, 961]), t(ot, [2, 962]), t(ot, [2, 963]), t(ot, [2, 964]), t(ot, [2, 965]), t(ot, [2, 966]), t(ot, [2, 967]), t(ot, [2, 968]), t(ot, [2, 969]), t(ot, [2, 970]), t(ot, [2, 971]), t(ot, [2, 972]), t(ot, [2, 973]), t(ot, [2, 974]), t(ot, [2, 975]), t(ot, [2, 976]), t(ot, [2, 977]), t(ot, [2, 978]), t(ot, [2, 979]), t(ot, [2, 980]), t(ot, [2, 981]), t(ot, [2, 982]), t(ot, [2, 983]), t(ot, [2, 984]), t(ot, [2, 985]), t(ot, [2, 986]), t(ot, [2, 987]), t(ot, [2, 988]), t(ot, [2, 989]), t(ot, [2, 990]), t(ot, [2, 991]), t(ot, [2, 992]), t(ot, [2, 993]), t(ot, [2, 994]), t(ot, [2, 995]), t(ot, [2, 996]), t(ot, [2, 997]), t(ot, [2, 998]), t(ot, [2, 999]), t(ot, [2, 1e3]), t(ot, [2, 1001]), t(ot, [2, 1002]), t(ot, [2, 1003]), t(ot, [2, 1004]), t(ot, [2, 1005]), t(ot, [2, 1006]), t(ot, [2, 1007]), t(ot, [2, 1008]), t(ot, [2, 1009]), t(ot, [2, 1010]), t(ot, [2, 1011]), t(ot, [2, 1012]), t(ot, [2, 1013]), t(ot, [2, 1014]), t(ot, [2, 1015]), t(ot, [2, 1016]), t(ot, [2, 1017]), t(ot, [2, 1018]), t(ot, [2, 1019]), t(ot, [2, 1020]), t(ot, [2, 1021]), t(ot, [2, 1022]), t(ot, [2, 1023]), t(ot, [2, 1024]), t(ot, [2, 1025]), t(ot, [2, 1026]), t(ot, [2, 1027]), t(ot, [2, 1028]), t(ot, [2, 1029]), t(ot, [2, 1030]), t(ot, [2, 1031]), t(ot, [2, 1032]), t(ot, [2, 1033]), t(ot, [2, 1034]), t(ot, [2, 1035]), t(ot, [2, 1036]), t(ot, [2, 1037]), t(ot, [2, 1038]), t(ot, [2, 1039]), t(ot, [2, 1040]), t(X, [2, 7]), t(X, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 821, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), { 396: [1, 825], 401: [1, 822], 402: [1, 823], 403: [1, 824] }, { 2: n, 3: 826, 4: a, 5: s }, t(Tn, [2, 1111], { 289: 827, 767: 829, 78: [1, 828], 164: [1, 831], 185: [1, 830] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 832, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 833, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 834, 4: a, 5: s, 132: [1, 835] }, { 2: n, 3: 836, 4: a, 5: s, 132: [1, 837] }, { 2: n, 3: 838, 4: a, 5: s, 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 839, 4: a, 5: s }, { 154: [1, 840] }, t(Nn, ht, { 350: 841, 156: dt }), { 230: [1, 842] }, { 2: n, 3: 843, 4: a, 5: s }, t(K, [2, 729], { 74: Cn }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 845, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Sn, [2, 732]), t(Rn, [2, 1143], { 419: 190, 476: 846, 144: 847, 139: On, 141: On, 145: ze, 420: Ge, 424: Ve }), { 139: [1, 848], 141: [1, 849] }, t(wn, In, { 490: 851, 493: 852, 77: [1, 850], 137: pt }), t(xn, [2, 1167], { 494: 853, 132: [1, 854] }), t(Dn, [2, 1171], { 496: 855, 497: 856, 152: bt }), t(Dn, [2, 747]), t(kn, [2, 739]), { 2: n, 3: 857, 4: a, 5: s, 131: [1, 858] }, { 2: n, 3: 859, 4: a, 5: s }, { 2: n, 3: 860, 4: a, 5: s }, t(Be, ht, { 350: 861, 156: dt }), t(Be, ht, { 350: 862, 156: dt }), t(St, [2, 491]), t(St, [2, 492]), { 183: [1, 863] }, { 183: [2, 1142] }, t(Ln, [2, 1137], { 466: 864, 469: 865, 137: [1, 866] }), t(Et, [2, 1136]), t($n, Mn, { 510: 867, 95: Un, 230: [1, 868], 514: _n, 515: Fn, 516: Pn }), { 76: [1, 873] }, { 76: [1, 874] }, { 145: se, 450: 875 }, { 4: qn, 7: 879, 76: [1, 877], 272: 876, 387: 878, 389: Gn }, t(K, [2, 456], { 128: [1, 882] }), t(K, [2, 579]), { 2: n, 3: 883, 4: a, 5: s }, { 298: [1, 884] }, t(Nn, mt, { 398: 885, 156: vt }), t(K, [2, 593]), { 2: n, 3: 244, 4: a, 5: s, 199: 887, 399: 886 }, { 2: n, 3: 244, 4: a, 5: s, 199: 887, 399: 888 }, t(K, [2, 772]), t(X, [2, 669], { 438: 889, 310: [1, 890] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 891, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 892, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 893, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 894, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 895, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 896, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 897, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 898, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 899, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 900, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 901, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 902, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 903, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 904, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 905, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 906, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 907, 4: a, 5: s, 77: [1, 909], 131: oe, 156: Q, 196: 908, 200: 910, 290: z, 291: Z, 292: ee, 293: te }, { 2: n, 3: 911, 4: a, 5: s, 77: [1, 913], 131: oe, 156: Q, 196: 912, 200: 914, 290: z, 291: Z, 292: ee, 293: te }, t(Vn, [2, 440], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 915, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), t(Vn, [2, 441], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 916, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), t(Vn, [2, 442], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 917, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), t(Vn, [2, 443], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 918, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), t(Vn, Bn, { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 919, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 920, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 921, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Vn, [2, 445], { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 922, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 923, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 924, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 164: [1, 926], 166: [1, 928], 328: 925, 334: [1, 927] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 929, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 930, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 695, 4: a, 5: s, 77: [1, 931], 111: 934, 145: jn, 156: Q, 200: 935, 202: 933, 290: z, 291: Z, 292: ee, 293: te, 329: 932 }, { 99: [1, 937], 297: [1, 938] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 939, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 940, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 941, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 4: qn, 7: 879, 272: 942, 387: 878, 389: Gn }, t(Hn, [2, 88]), t(Hn, [2, 89]), { 78: [1, 943] }, { 78: [1, 944] }, { 78: [1, 945] }, { 78: [1, 946], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(Be, je, { 340: 207, 77: lt, 198: He }), { 78: [2, 1107] }, { 78: [2, 1108] }, { 134: ne, 135: ae }, {
                2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 947, 152: fe, 154: pe, 156: Q, 158: 167, 164: [1, 949], 179: be, 180: Ee, 181: ge, 185: [1, 948], 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163,
                265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve
            }, { 2: n, 3: 950, 4: a, 5: s, 149: Jn, 180: [1, 952] }, t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 118, 122, 128, 129, 130, 131, 132, 134, 135, 137, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 314, 330, 331, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 416], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 332: rr }), t(Yn, [2, 417], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 180: Ft, 312: qt, 316: Bt }), t(Yn, [2, 418], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 180: Ft, 312: qt, 316: Bt }), t(Wn, [2, 419], { 114: 625, 327: 637, 316: Bt }), t(Wn, [2, 420], { 114: 625, 327: 637, 316: Bt }), t(sr, [2, 365]), t(sr, [2, 1113]), t(sr, [2, 1114]), t(sr, [2, 366]), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 362]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 953, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(cr, [2, 620]), t(cr, [2, 621]), t(cr, [2, 622]), t(cr, [2, 623]), t(cr, [2, 625]), { 40: 954, 79: 75, 89: c, 184: 99, 189: f }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 304: 955, 307: 677, 308: ur, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 305: 956, 306: Xn, 307: 957, 308: ur, 310: Kn }, t(Qn, [2, 372]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 959, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 960, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 4: qn, 7: 879, 272: 961, 387: 878, 389: Gn }, t(cr, [2, 626]), { 74: [1, 963], 300: [1, 962] }, t(cr, [2, 642]), t(zn, [2, 649]), t(Zn, [2, 627]), t(Zn, [2, 628]), t(Zn, [2, 629]), t(Zn, [2, 630]), t(Zn, [2, 631]), t(Zn, [2, 632]), t(Zn, [2, 633]), t(Zn, [2, 634]), t(Zn, [2, 635]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 964, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t([2, 4, 5, 10, 53, 72, 74, 76, 78, 89, 93, 95, 98, 99, 107, 112, 115, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 426, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], ar, { 77: ct, 116: ea }), { 74: pn, 300: [1, 966] }, t(ta, [2, 314], { 77: ct }), t(Qe, [2, 315]), { 74: [1, 968], 426: [1, 967] }, t(cr, [2, 639]), t(ra, [2, 644]), { 152: [1, 969] }, { 152: [1, 970] }, { 152: [1, 971] }, { 40: 976, 77: [1, 975], 79: 75, 89: c, 143: le, 144: 979, 145: ze, 149: na, 152: fe, 181: ge, 184: 99, 189: f, 201: 980, 302: _e, 341: 972, 342: 973, 343: [1, 974], 344: aa, 419: 190, 420: Ge, 424: Ve }, t(Be, je, { 340: 981, 198: He }), { 77: sa, 143: le, 144: 979, 145: ze, 149: na, 152: fe, 181: ge, 201: 980, 302: _e, 341: 982, 342: 983, 344: aa, 419: 190, 420: Ge, 424: Ve }, { 230: [1, 986], 455: 985 }, { 2: n, 3: 219, 4: a, 5: s, 77: Je, 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 199: 213, 200: 215, 201: 214, 202: 217, 209: 987, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, { 231: [2, 696] }, { 78: [1, 988] }, t(pr, [2, 1093], { 211: 989, 3: 990, 2: n, 4: a, 5: s }), t(fr, [2, 1092]), t(pr, [2, 183]), { 2: n, 3: 991, 4: a, 5: s }, { 212: [1, 992] }, t(pr, [2, 187]), { 2: n, 3: 993, 4: a, 5: s }, t(pr, [2, 191]), { 2: n, 3: 994, 4: a, 5: s }, t(pr, [2, 195]), { 2: n, 3: 995, 4: a, 5: s }, t(pr, [2, 198]), { 2: n, 3: 996, 4: a, 5: s }, { 2: n, 3: 997, 4: a, 5: s }, { 148: [1, 998] }, t(ia, [2, 172], { 82: 999, 183: [1, 1e3] }), { 2: n, 3: 219, 4: a, 5: s, 132: [1, 1005], 143: le, 145: [1, 1006], 152: fe, 156: Q, 181: ge, 199: 1001, 200: 1002, 201: 1003, 202: 1004, 290: z, 291: Z, 292: ee, 293: te, 302: _e }, { 2: n, 3: 1011, 4: a, 5: s, 109: 1007, 110: 1008, 111: 1009, 112: oa }, t(Sr, [2, 1058]), t(ua, [2, 1049], { 91: 1012, 182: 1013, 183: [1, 1014] }), t(Ke, [2, 1048], { 153: 1015, 179: ca, 180: la, 181: ha }), t([2, 4, 5, 10, 72, 74, 76, 78, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 198, 280, 281, 282, 283, 284, 285, 286, 287, 288, 306, 310, 420, 424, 602, 764], [2, 90], { 77: [1, 1019] }), { 119: [1, 1020] }, t(da, [2, 93]), { 2: n, 3: 1021, 4: a, 5: s }, t(da, [2, 95]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1022, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1023, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1025, 118: Cr, 122: Rr, 123: Or, 124: wr, 125: 1024, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 77: [1, 1026] }, { 77: [1, 1027] }, { 77: [1, 1028] }, { 77: [1, 1029] }, t(da, [2, 104]), t(da, [2, 105]), t(da, [2, 106]), t(da, [2, 107]), t(da, [2, 108]), t(da, [2, 109]), { 2: n, 3: 1030, 4: a, 5: s }, { 2: n, 3: 1031, 4: a, 5: s, 133: [1, 1032] }, t(da, [2, 113]), t(da, [2, 114]), t(da, [2, 115]), t(da, [2, 116]), t(da, [2, 117]), t(da, [2, 118]), { 2: n, 3: 1033, 4: a, 5: s, 77: or, 113: 669, 131: oe, 132: ue, 143: le, 152: fe, 181: ge, 196: 670, 201: 672, 257: 671, 294: De, 295: ke, 296: Le, 302: _e, 419: 673, 424: Ve }, { 145: [1, 1034] }, { 77: [1, 1035] }, { 145: [1, 1036] }, t(da, [2, 123]), { 77: [1, 1037] }, { 2: n, 3: 1038, 4: a, 5: s }, { 77: [1, 1039] }, { 77: [1, 1040] }, { 77: [1, 1041] }, { 77: [1, 1042] }, { 77: [1, 1043], 164: [1, 1044] }, { 77: [1, 1045] }, { 77: [1, 1046] }, { 77: [1, 1047] }, { 77: [1, 1048] }, { 77: [1, 1049] }, { 77: [1, 1050] }, { 77: [1, 1051] }, { 77: [1, 1052] }, { 77: [1, 1053] }, { 77: [2, 1073] }, { 77: [2, 1074] }, { 2: n, 3: 244, 4: a, 5: s, 199: 1054 }, { 2: n, 3: 244, 4: a, 5: s, 199: 1055 }, { 113: 1056, 132: ue, 296: Le }, t(K, [2, 596], { 112: [1, 1057] }), { 2: n, 3: 244, 4: a, 5: s, 199: 1058 }, { 113: 1059, 132: ue, 296: Le }, { 2: n, 3: 1060, 4: a, 5: s }, t(K, [2, 693]), t(K, [2, 68]), { 2: n, 3: 236, 4: a, 5: s, 75: 1061 }, { 77: [1, 1062] }, t(K, [2, 674]), t(K, [2, 586]), { 2: n, 3: 1011, 4: a, 5: s, 111: 1065, 143: fa, 145: pa, 147: 1063, 336: 1064, 337: 1066 }, { 144: 1069, 145: ze, 419: 190, 420: Ge, 424: Ve }, t(K, [2, 671]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1070, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Vn, Bn, { 255: 146, 200: 147, 256: 148, 111: 149, 254: 150, 196: 151, 257: 152, 113: 153, 258: 154, 201: 155, 202: 156, 259: 157, 260: 158, 261: 159, 144: 161, 262: 162, 263: 163, 56: 165, 158: 167, 3: 168, 419: 190, 94: 1071, 2: n, 4: a, 5: s, 77: ie, 131: oe, 132: ue, 137: ce, 143: le, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 179: be, 180: Ee, 181: ge, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 420: Ge, 424: Ve }), { 113: 1072, 132: ue, 296: Le }, { 2: n, 3: 266, 4: a, 5: s, 446: 1073, 447: et }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1075, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 230: gn, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve, 429: 1074, 433: mn }, t(K, [2, 651]), { 114: 1077, 115: yt, 116: Nt, 124: [1, 1076] }, t(K, [2, 663]), t(K, [2, 664]), { 2: n, 3: 1079, 4: a, 5: s, 77: ba, 131: Ea, 432: 1078 }, { 114: 807, 115: yt, 116: Nt, 124: [1, 1082], 430: 1083 }, t(K, [2, 753], { 74: vn }), { 2: n, 3: 100, 4: a, 5: s, 504: 1084 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 174: 1085, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 816, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 174: 1086, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 816, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 174: 1087, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 816, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(An, [2, 151]), t(An, [2, 1088], { 74: ga }), t(ma, [2, 273]), t(ma, [2, 280], { 114: 625, 327: 637, 3: 1090, 113: 1092, 2: n, 4: a, 5: s, 76: [1, 1089], 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 131: [1, 1091], 132: ue, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 296: Le, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(nt, [2, 1089], { 197: 1093, 765: [1, 1094] }), { 131: oe, 196: 1095 }, { 74: vn, 78: [1, 1096] }, t(X, [2, 11]), { 148: [1, 1097], 190: [1, 1098] }, { 190: [1, 1099] }, { 190: [1, 1100] }, { 190: [1, 1101] }, t(K, [2, 575], { 76: [1, 1103], 77: [1, 1102] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1104, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(sr, [2, 346]), t(Tn, [2, 1112]), t(Tn, [2, 1109]), t(Tn, [2, 1110]), { 74: pn, 78: [1, 1105] }, { 74: pn, 78: [1, 1106] }, { 74: [1, 1107] }, { 74: [1, 1108] }, { 74: [1, 1109] }, { 74: [1, 1110] }, t(sr, [2, 353]), t(K, [2, 580]), { 298: [1, 1111] }, { 2: n, 3: 1112, 4: a, 5: s, 113: 1113, 132: ue, 296: Le }, { 2: n, 3: 244, 4: a, 5: s, 199: 1114 }, { 230: [1, 1115] }, { 2: n, 3: 578, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 431: 585, 474: 1116, 475: 576, 478: 577, 482: 582, 493: 579, 497: 581 }, t(K, [2, 730], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Sn, [2, 1145], { 477: 1117, 483: 1118, 76: va }), t(Rn, [2, 1144]), { 2: n, 3: 1122, 4: a, 5: s, 132: ft, 137: pt, 144: 1121, 145: ze, 152: bt, 419: 190, 420: Ge, 424: Ve, 475: 1120, 493: 579, 497: 581 }, { 2: n, 3: 1122, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 431: 585, 475: 1124, 478: 1123, 482: 582, 493: 579, 497: 581 }, { 2: n, 3: 578, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 431: 585, 473: 1125, 474: 575, 475: 576, 478: 577, 482: 582, 493: 579, 497: 581 }, t(xn, [2, 1163], { 491: 1126, 132: [1, 1127] }), t(wn, [2, 1162]), t(Dn, [2, 1169], { 495: 1128, 497: 1129, 152: bt }), t(xn, [2, 1168]), t(Dn, [2, 746]), t(Dn, [2, 1172]), t(wn, [2, 749]), t(wn, [2, 750]), t(Dn, [2, 748]), t(kn, [2, 740]), { 2: n, 3: 244, 4: a, 5: s, 199: 1130 }, { 2: n, 3: 244, 4: a, 5: s, 199: 1131 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1132, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Sa, [2, 1139], { 467: 1133, 113: 1134, 132: ue, 296: Le }), t(Ln, [2, 1138]), { 2: n, 3: 1135, 4: a, 5: s }, { 335: Ta, 338: Aa, 339: ya, 511: 1136 }, { 2: n, 3: 244, 4: a, 5: s, 199: 1140 }, t($n, [2, 765]), t($n, [2, 766]), t($n, [2, 767]), { 129: [1, 1141] }, { 266: [1, 1142] }, { 266: [1, 1143] }, t(gt, [2, 688]), t(gt, [2, 689], { 124: [1, 1144] }), { 4: qn, 7: 879, 272: 1145, 387: 878, 389: Gn }, t([2, 4, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 542], { 5: [1, 1146] }), t([2, 5, 10, 53, 72, 74, 76, 78, 89, 93, 95, 98, 99, 107, 112, 115, 116, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 297, 300, 306, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 343, 356, 368, 369, 373, 374, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 539], { 4: [1, 1148], 77: [1, 1147] }), { 77: [1, 1149] }, t(Na, [2, 4]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1150, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(K, [2, 588]), t(Nn, [2, 568]), { 2: n, 3: 1151, 4: a, 5: s, 113: 1152, 132: ue, 296: Le }, t(K, [2, 564], { 74: Ca }), t(gt, [2, 566]), t(K, [2, 613], { 74: Ca }), t(K, [2, 668]), t(K, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 1154, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(Ra, [2, 376], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Wn, [2, 377], { 114: 625, 327: 637, 316: Bt }), t(Ra, [2, 378], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Oa, [2, 379], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 314: [1, 1155], 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Oa, [2, 381], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 314: [1, 1156], 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Qe, [2, 383], { 114: 625, 327: 637 }), t(Yn, [2, 384], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 180: Ft, 312: qt, 316: Bt }), t(Yn, [2, 385], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 180: Ft, 312: qt, 316: Bt }), t(wa, [2, 386], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 136: wt, 312: qt, 316: Bt }), t(wa, [2, 387], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 136: wt, 312: qt, 316: Bt }), t(wa, [2, 388], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 136: wt, 312: qt, 316: Bt }), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 112, 118, 122, 123, 124, 128, 129, 130, 131, 132, 133, 134, 135, 137, 138, 139, 140, 141, 142, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 179, 180, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 311, 313, 314, 315, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 389], { 114: 625, 327: 637, 115: yt, 116: Nt, 136: wt, 312: qt, 316: Bt }), t(Ia, [2, 390], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt }), t(Ia, [2, 391], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt }), t(Ia, [2, 392], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt }), t(Ia, [2, 393], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt }), t(ta, [2, 394], { 77: ct }), t(Qe, [2, 395]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1157, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 397]), t(ta, [2, 398], { 77: ct }), t(Qe, [2, 399]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1158, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 401]), t(xa, [2, 402], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 403], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 404], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 405], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t([2, 4, 5, 10, 53, 72, 89, 99, 124, 139, 140, 146, 154, 156, 170, 171, 189, 266, 267, 290, 306, 310, 320, 321, 322, 323, 324, 325, 326, 330, 331, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 517, 602, 764], Da, { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 407], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 408], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 409], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 410], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(xa, [2, 411], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), { 77: [1, 1159] }, { 77: [2, 446] }, { 77: [2, 447] }, { 77: [2, 448] }, t(ka, [2, 414], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 332: rr }), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 107, 118, 122, 128, 129, 130, 131, 132, 134, 135, 137, 143, 145, 146, 148, 149, 150, 152, 156, 162, 164, 166, 168, 169, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 314, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 415], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr }), { 2: n, 3: 168, 4: a, 5: s, 40: 1160, 56: 165, 77: ie, 78: [1, 1162], 79: 75, 89: c, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1161, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 184: 99, 189: f, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 428]), t(Qe, [2, 430]), t(Qe, [2, 437]), t(Qe, [2, 438]), { 2: n, 3: 667, 4: a, 5: s, 77: [1, 1163] }, { 2: n, 3: 695, 4: a, 5: s, 77: [1, 1164], 111: 934, 145: jn, 156: Q, 200: 935, 202: 1166, 290: z, 291: Z, 292: ee, 293: te, 329: 1165 }, t(Qe, [2, 435]), t(ka, [2, 432], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 332: rr }), t(ka, [2, 433], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 332: rr }), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 99, 107, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 189, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 239, 242, 243, 245, 247, 266, 267, 280, 281, 282, 283, 284, 285, 286, 287, 288, 290, 296, 300, 306, 308, 309, 310, 314, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 464, 470, 505, 507, 508, 517, 602, 764], [2, 434], { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Qe, [2, 436]), t(Qe, [2, 306]), t(Qe, [2, 307]), t(Qe, [2, 308]), t(Qe, [2, 421]), { 74: pn, 78: [1, 1167] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1168, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1169, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, La), t($a, [2, 286]), t(Qe, [2, 282]), { 78: [1, 1171], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1172] }, { 305: 1173, 306: Xn, 307: 957, 308: ur, 310: Kn }, { 306: [1, 1174] }, t(Qn, [2, 371]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1175, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 309: [1, 1176], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 76: [1, 1177], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 74: [1, 1178] }, t(cr, [2, 640]), { 2: n, 3: 695, 4: a, 5: s, 77: lr, 111: 690, 113: 688, 131: oe, 132: ue, 143: le, 144: 685, 145: ze, 152: fe, 156: Q, 181: ge, 196: 687, 200: 693, 201: 692, 257: 689, 258: 691, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 300: [1, 1179], 302: _e, 419: 190, 420: Ge, 422: 1180, 423: 686, 424: Ve }, { 78: [1, 1181], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 1182, 4: a, 5: s, 149: Jn }, t(Qe, [2, 364]), t(cr, [2, 637]), { 2: n, 3: 704, 4: a, 5: s, 131: hr, 132: dr, 426: [1, 1183], 428: 1184 }, { 2: n, 3: 695, 4: a, 5: s, 77: lr, 111: 690, 113: 688, 131: oe, 132: ue, 143: le, 144: 685, 145: ze, 152: fe, 156: Q, 181: ge, 196: 687, 200: 693, 201: 692, 257: 689, 258: 691, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e, 419: 190, 420: Ge, 422: 1185, 423: 686, 424: Ve }, { 2: n, 3: 695, 4: a, 5: s, 77: lr, 111: 690, 113: 688, 131: oe, 132: ue, 143: le, 144: 685, 145: ze, 152: fe, 156: Q, 181: ge, 196: 687, 200: 693, 201: 692, 257: 689, 258: 691, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e, 419: 190, 420: Ge, 422: 1186, 423: 686, 424: Ve }, { 2: n, 3: 695, 4: a, 5: s, 77: lr, 111: 690, 113: 688, 131: oe, 132: ue, 143: le, 144: 685, 145: ze, 152: fe, 156: Q, 181: ge, 196: 687, 200: 693, 201: 692, 257: 689, 258: 691, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e, 419: 190, 420: Ge, 422: 1187, 423: 686, 424: Ve }, { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1188, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 458], { 74: Ua }), { 149: na, 341: 1190, 344: aa }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1194, 100: 1191, 111: 1193, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 345: 1192, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 466]), t(_a, [2, 469]), t(_a, [2, 470]), t(Fa, [2, 474]), t(Fa, [2, 475]), { 2: n, 3: 244, 4: a, 5: s, 199: 1195 }, { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1196, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 462], { 74: Ua }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1194, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 345: 1192, 419: 190, 420: Ge, 424: Ve }, { 308: Pa, 456: 1197, 458: 1198, 459: 1199 }, {
                2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1201, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge,
                196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve
            }, { 230: [2, 697] }, t(pr, [2, 181], { 3: 1202, 2: n, 4: a, 5: s, 76: [1, 1203] }), t(pr, [2, 182]), t(pr, [2, 1094]), t(pr, [2, 184]), t(pr, [2, 186]), t(pr, [2, 188]), t(pr, [2, 192]), t(pr, [2, 196]), t(pr, [2, 199]), t([2, 4, 5, 10, 53, 72, 74, 76, 77, 78, 89, 93, 95, 98, 118, 124, 128, 143, 145, 146, 148, 149, 152, 154, 156, 162, 168, 169, 181, 183, 187, 189, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 245, 247, 266, 267, 290, 297, 302, 306, 310, 335, 338, 339, 343, 344, 356, 368, 369, 373, 374, 396, 400, 401, 402, 403, 404, 406, 408, 409, 417, 418, 420, 424, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 514, 515, 516, 517, 602, 764], [2, 201]), { 2: n, 3: 1204, 4: a, 5: s }, t(qa, [2, 1045], { 83: 1205, 92: 1206, 93: [1, 1207], 98: [1, 1208] }), { 2: n, 3: 219, 4: a, 5: s, 77: [1, 1210], 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 199: 213, 200: 215, 201: 214, 202: 217, 203: 1209, 209: 1211, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, t(gr, [2, 164]), t(gr, [2, 165]), t(gr, [2, 166]), t(gr, [2, 167]), t(gr, [2, 168]), { 2: n, 3: 667, 4: a, 5: s }, t(Xe, [2, 83], { 74: [1, 1212] }), t(Ga, [2, 85]), t(Ga, [2, 86]), { 113: 1213, 132: ue, 296: Le }, t([10, 72, 74, 78, 93, 98, 118, 124, 128, 162, 168, 169, 183, 198, 206, 208, 222, 223, 224, 225, 226, 227, 228, 229, 232, 245, 247, 306, 310, 602, 764], ar, { 116: ea }), t(ua, [2, 73]), t(ua, [2, 1050]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1214, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(da, [2, 126]), t(da, [2, 144]), t(da, [2, 145]), t(da, [2, 146]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 78: [2, 1065], 94: 260, 111: 149, 113: 153, 127: 1215, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1216, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 77: [1, 1217] }, t(da, [2, 94]), t([2, 4, 5, 10, 72, 74, 76, 77, 78, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 198, 280, 281, 282, 283, 284, 285, 286, 287, 288, 306, 310, 420, 424, 602, 764], [2, 96], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t([2, 4, 5, 10, 72, 74, 76, 77, 78, 112, 118, 122, 124, 128, 129, 130, 131, 132, 134, 135, 137, 139, 140, 143, 145, 146, 148, 149, 150, 152, 154, 156, 162, 164, 166, 168, 169, 170, 171, 172, 173, 175, 181, 183, 185, 187, 198, 280, 281, 282, 283, 284, 285, 286, 287, 288, 306, 310, 420, 424, 602, 764], [2, 97], { 114: 625, 327: 637, 99: Tt, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1218], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1219, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, t(Va, [2, 1061], { 153: 1015, 179: ca, 180: la, 181: ha }), { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1221, 118: Cr, 122: Rr, 123: Or, 124: wr, 126: 1220, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1222, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1223, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1224, 4: a, 5: s }, t(da, [2, 110]), t(da, [2, 111]), t(da, [2, 112]), t(da, [2, 119]), { 2: n, 3: 1225, 4: a, 5: s }, { 2: n, 3: 1011, 4: a, 5: s, 111: 1065, 143: fa, 145: pa, 147: 1226, 336: 1064, 337: 1066 }, { 2: n, 3: 1227, 4: a, 5: s }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1228, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(da, [2, 125]), t(Va, [2, 1067], { 155: 1229 }), t(Va, [2, 1069], { 157: 1230 }), t(Va, [2, 1071], { 159: 1231 }), t(Va, [2, 1075], { 161: 1232 }), t(Ba, ja, { 163: 1233, 178: 1234 }), { 77: [1, 1235] }, t(Va, [2, 1077], { 165: 1236 }), t(Va, [2, 1079], { 167: 1237 }), t(Ba, ja, { 178: 1234, 163: 1238 }), t(Ba, ja, { 178: 1234, 163: 1239 }), t(Ba, ja, { 178: 1234, 163: 1240 }), t(Ba, ja, { 178: 1234, 163: 1241 }), { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1242, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 174: 1243, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 816, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Ha, [2, 1081], { 176: 1244 }), t(K, [2, 606], { 183: [1, 1245] }), t(K, [2, 602], { 183: [1, 1246] }), t(K, [2, 595]), { 113: 1247, 132: ue, 296: Le }, t(K, [2, 604], { 183: [1, 1248] }), t(K, [2, 599]), t(K, [2, 600], { 112: [1, 1249] }), t(dn, [2, 69]), { 40: 1250, 79: 75, 89: c, 184: 99, 189: f }, t(K, [2, 450], { 74: Ja, 128: [1, 1251] }), t(Ya, [2, 451]), { 124: [1, 1253] }, { 2: n, 3: 1254, 4: a, 5: s }, t(Be, [2, 1115]), t(Be, [2, 1116]), t(K, [2, 618]), t(bn, [2, 355], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(xa, Da, { 114: 625, 327: 637, 112: At, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 332: rr }), t(gt, [2, 682]), t(gt, [2, 684]), t(K, [2, 650]), t(K, [2, 652], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1255, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1079, 4: a, 5: s, 77: ba, 131: Ea, 432: 1256 }, t(Wa, [2, 659]), t(Wa, [2, 660]), t(Wa, [2, 661]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1257, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1258, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 114: 1077, 115: yt, 116: Nt, 124: [1, 1259] }, t(Sn, [2, 755]), t(An, [2, 148], { 74: ga }), t(An, [2, 149], { 74: ga }), t(An, [2, 150], { 74: ga }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 1260, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1261, 4: a, 5: s, 113: 1263, 131: [1, 1262], 132: ue, 296: Le }, t(ma, [2, 275]), t(ma, [2, 277]), t(ma, [2, 279]), t(nt, [2, 160]), t(nt, [2, 1090]), { 78: [1, 1264] }, t(it, [2, 758]), { 2: n, 3: 1265, 4: a, 5: s }, { 2: n, 3: 1266, 4: a, 5: s }, { 2: n, 3: 1268, 4: a, 5: s, 384: 1267 }, { 2: n, 3: 1268, 4: a, 5: s, 384: 1269 }, { 2: n, 3: 1270, 4: a, 5: s }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1271, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1272, 4: a, 5: s }, { 74: pn, 78: [1, 1273] }, t(sr, [2, 347]), t(sr, [2, 348]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1274, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1275, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1276, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1277, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Nn, [2, 504]), t(K, Xa, { 407: 1278, 76: Ka, 77: [1, 1279] }), t(K, Xa, { 407: 1281, 76: Ka }), { 77: [1, 1282] }, { 2: n, 3: 244, 4: a, 5: s, 199: 1283 }, t(Sn, [2, 731]), t(Sn, [2, 733]), t(Sn, [2, 1146]), { 143: tt, 145: rt, 431: 1284 }, t(Qa, [2, 1147], { 419: 190, 479: 1285, 144: 1286, 145: ze, 420: Ge, 424: Ve }), { 76: va, 139: [2, 1151], 481: 1287, 483: 1288 }, t([10, 74, 76, 78, 132, 139, 145, 152, 306, 310, 420, 424, 602, 764], In, { 490: 851, 493: 852, 137: pt }), t(Sn, [2, 736]), t(Sn, On), { 74: Cn, 78: [1, 1289] }, t(Dn, [2, 1165], { 492: 1290, 497: 1291, 152: bt }), t(xn, [2, 1164]), t(Dn, [2, 745]), t(Dn, [2, 1170]), t(K, [2, 490], { 77: [1, 1292] }), { 76: [1, 1294], 77: [1, 1293] }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 148: [1, 1295], 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(Ma, za, { 79: 75, 184: 99, 468: 1296, 40: 1299, 89: c, 146: Za, 189: f, 470: es }), t(Sa, [2, 1140]), t(Ln, [2, 723]), { 230: [1, 1300] }, t(ts, [2, 769]), t(ts, [2, 770]), t(ts, [2, 771]), t($n, Mn, { 510: 1301, 95: Un, 514: _n, 515: Fn, 516: Pn }), t($n, [2, 768]), t(K, [2, 312]), t(K, [2, 313]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1302, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(gt, [2, 690], { 124: [1, 1303] }), t(Na, [2, 541]), { 131: [1, 1305], 388: 1304, 390: [1, 1306] }, t(Na, [2, 5]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1194, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 345: 1307, 419: 190, 420: Ge, 424: Ve }, t(K, [2, 455], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(K, [2, 589]), t(K, [2, 590]), { 2: n, 3: 244, 4: a, 5: s, 199: 1308 }, t(K, [2, 670]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1309, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1310, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 78: [1, 1311], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1312], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 168, 4: a, 5: s, 40: 1313, 56: 165, 77: ie, 79: 75, 89: c, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1314, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 184: 99, 189: f, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 78: [1, 1315] }, { 74: pn, 78: [1, 1316] }, t(Qe, [2, 426]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1317, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 40: 1318, 56: 165, 77: ie, 78: [1, 1320], 79: 75, 89: c, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1319, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 184: 99, 189: f, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 429]), t(Qe, [2, 431]), t(Qe, rs, { 275: 1321, 276: ns }), { 78: [1, 1323], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1324], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 1325, 4: a, 5: s, 180: [1, 1326] }, t(cr, [2, 619]), t(Qe, [2, 363]), { 306: [1, 1327] }, t(Qe, [2, 370]), { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 306: [2, 374], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1328, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 4: qn, 7: 879, 272: 1329, 387: 878, 389: Gn }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1330, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(cr, [2, 641]), t(zn, [2, 648]), t(Zn, [2, 636]), t($a, La), t(cr, [2, 638]), t(ra, [2, 643]), t(ra, [2, 645]), t(ra, [2, 646]), t(ra, [2, 647]), t(Ma, [2, 457], { 74: Ua }), { 77: [1, 1332], 143: le, 144: 1333, 145: ze, 152: fe, 181: ge, 201: 1334, 302: _e, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 463]), { 74: as, 78: [1, 1335] }, { 74: ss, 78: [1, 1337] }, t([74, 78, 99, 112, 115, 116, 123, 124, 133, 136, 138, 139, 140, 141, 142, 154, 170, 171, 179, 180, 311, 312, 313, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 330, 331, 332, 333], is), t(os, [2, 479], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 40: 1341, 77: sa, 79: 75, 89: c, 143: le, 144: 979, 145: ze, 149: na, 152: fe, 181: ge, 184: 99, 189: f, 201: 980, 302: _e, 341: 1339, 342: 1340, 344: aa, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 461], { 74: Ua }), t(K, [2, 717], { 457: 1342, 458: 1343, 459: 1344, 308: Pa, 464: [1, 1345] }), t(us, [2, 701]), t(us, [2, 702]), { 154: [1, 1347], 460: [1, 1346] }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 308: [2, 698], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(pr, [2, 179]), { 2: n, 3: 1348, 4: a, 5: s }, t(K, [2, 574]), t(cs, [2, 238], { 84: 1349, 128: [1, 1350] }), t(qa, [2, 1046]), { 77: [1, 1351] }, { 77: [1, 1352] }, t(ia, [2, 169], { 204: 1353, 215: 1355, 205: 1356, 216: 1357, 221: 1360, 74: ls, 206: hs, 208: ds, 222: fs, 223: ps, 224: bs, 225: Es, 226: gs, 227: ms, 228: vs, 229: Ss }), { 2: n, 3: 219, 4: a, 5: s, 40: 711, 77: Je, 79: 75, 89: c, 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 184: 99, 189: f, 199: 213, 200: 215, 201: 214, 202: 217, 203: 1369, 209: 1211, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, t(Ts, [2, 177]), { 2: n, 3: 1011, 4: a, 5: s, 110: 1370, 111: 1009, 112: oa }, t(Ga, [2, 87]), t(ua, [2, 147], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 78: [1, 1371] }, { 74: pn, 78: [2, 1066] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 78: [2, 1059], 94: 1376, 111: 149, 113: 153, 120: 1372, 121: 1373, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1374, 242: [1, 1375], 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(da, [2, 98]), t(Va, [2, 1062], { 153: 1015, 179: ca, 180: la, 181: ha }), { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1377], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1378, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, t(Va, [2, 1063], { 153: 1015, 179: ca, 180: la, 181: ha }), { 78: [1, 1379], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1380], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1381] }, t(da, [2, 120]), { 74: Ja, 78: [1, 1382] }, t(da, [2, 122]), { 74: pn, 78: [1, 1383] }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1384], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1385, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1386], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1387, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1388], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1389, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1390], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1391, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 74: As, 78: [1, 1392] }, t(os, [2, 143], { 419: 190, 3: 733, 114: 736, 144: 758, 158: 768, 160: 769, 117: 1394, 2: n, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 115: yt, 116: Nt, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 420: Ge, 424: Ve }), t(Ba, ja, { 178: 1234, 163: 1395 }), { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1396], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1397, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 78: [1, 1398], 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1399, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 74: As, 78: [1, 1400] }, { 74: As, 78: [1, 1401] }, { 74: As, 78: [1, 1402] }, { 74: As, 78: [1, 1403] }, { 78: [1, 1404], 153: 1015, 179: ca, 180: la, 181: ha }, { 74: ga, 78: [1, 1405] }, { 2: n, 3: 733, 4: a, 5: s, 72: Tr, 74: [1, 1406], 76: Ar, 77: yr, 112: Nr, 114: 736, 115: yt, 116: Nt, 117: 1407, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 144: 758, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 158: 768, 160: 769, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1408, 4: a, 5: s }, { 2: n, 3: 1409, 4: a, 5: s }, t(K, [2, 597]), { 2: n, 3: 1410, 4: a, 5: s }, { 113: 1411, 132: ue, 296: Le }, { 78: [1, 1412] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1413, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1011, 4: a, 5: s, 111: 1065, 143: fa, 145: pa, 336: 1414, 337: 1066 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1415, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 124: [1, 1416] }, t(K, [2, 653], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Wa, [2, 658]), { 78: [1, 1417], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(K, [2, 654], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1418, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(ma, [2, 272]), t(ma, [2, 274]), t(ma, [2, 276]), t(ma, [2, 278]), t(nt, [2, 161]), t(K, [2, 569]), { 148: [1, 1419] }, t(K, [2, 570]), t(Sn, [2, 536], { 387: 878, 7: 879, 272: 1420, 4: qn, 386: [1, 1421], 389: Gn }), t(K, [2, 571]), t(K, [2, 573]), { 74: pn, 78: [1, 1422] }, t(K, [2, 577]), t(sr, [2, 345]), {
                74: [1, 1423], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct,
                124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr
            }, { 74: [1, 1424], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 74: [1, 1425], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 74: [1, 1426], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(K, [2, 581]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1427, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1428, 4: a, 5: s }, t(K, [2, 583]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1376, 111: 149, 113: 153, 120: 1429, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1374, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 77: [1, 1430] }, { 2: n, 3: 1431, 4: a, 5: s }, { 76: va, 139: [2, 1149], 480: 1432, 483: 1433 }, t(Qa, [2, 1148]), { 139: [1, 1434] }, { 139: [2, 1152] }, t(Sn, [2, 737]), t(Dn, [2, 744]), t(Dn, [2, 1166]), { 2: n, 3: 1268, 4: a, 5: s, 76: [1, 1437], 351: 1435, 358: 1436, 384: 1438 }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1439, 111: 1440 }, { 40: 1441, 79: 75, 89: c, 184: 99, 189: f }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1442, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 722]), { 2: n, 3: 1011, 4: a, 5: s, 111: 1065, 143: fa, 145: pa, 147: 1443, 336: 1064, 337: 1066 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1444, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 727]), { 2: n, 3: 244, 4: a, 5: s, 199: 1445 }, { 335: Ta, 338: Aa, 339: ya, 511: 1446 }, t(gt, [2, 691], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1447, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 74: [1, 1448], 78: [1, 1449] }, t(os, [2, 543]), t(os, [2, 544]), { 74: ss, 78: [1, 1450] }, t(gt, [2, 565]), t(Ra, [2, 380], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Ra, [2, 382], { 114: 625, 327: 637, 115: yt, 116: Nt, 123: Ct, 133: Ot, 136: wt, 138: It, 141: kt, 142: Lt, 179: _t, 180: Ft, 312: qt, 316: Bt, 317: jt, 318: Ht, 319: Jt }), t(Qe, [2, 396]), t(Qe, [2, 400]), { 78: [1, 1451] }, { 74: pn, 78: [1, 1452] }, t(Qe, [2, 422]), t(Qe, [2, 424]), { 78: [1, 1453], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1454] }, { 74: pn, 78: [1, 1455] }, t(Qe, [2, 427]), t(Qe, [2, 327]), { 77: [1, 1456] }, t(Qe, rs, { 275: 1457, 276: ns }), t(Qe, rs, { 275: 1458, 276: ns }), t($a, [2, 284]), t(Qe, [2, 281]), t(Qe, [2, 369]), t(Qn, [2, 373], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 74: [1, 1460], 78: [1, 1459] }, { 74: [1, 1462], 78: [1, 1461], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 2: n, 3: 1325, 4: a, 5: s }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1194, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 345: 1463, 419: 190, 420: Ge, 424: Ve }, t(Fa, [2, 477]), t(Fa, [2, 478]), { 40: 1466, 77: sa, 79: 75, 89: c, 143: le, 144: 979, 145: ze, 149: na, 152: fe, 181: ge, 184: 99, 189: f, 201: 980, 302: _e, 341: 1464, 342: 1465, 344: aa, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1011, 4: a, 5: s, 111: 1467 }, t(Fa, [2, 473]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1468, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1469, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 460], { 74: Ua }), t(Ma, [2, 467]), t(K, [2, 694]), t(us, [2, 699]), t(us, [2, 700]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 817, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 174: 1470, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 253: 816, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 170: [1, 1472], 309: [1, 1471] }, { 460: [1, 1473] }, t(pr, [2, 180]), t(ys, [2, 240], { 85: 1474, 232: [1, 1475] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1476, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1477, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1478, 4: a, 5: s }, t(ia, [2, 170], { 216: 1357, 221: 1360, 215: 1479, 205: 1480, 206: hs, 208: ds, 222: fs, 223: ps, 224: bs, 225: Es, 226: gs, 227: ms, 228: vs, 229: Ss }), { 2: n, 3: 219, 4: a, 5: s, 77: Je, 132: Ye, 143: le, 144: 212, 145: he, 152: fe, 156: Q, 181: ge, 199: 213, 200: 215, 201: 214, 202: 217, 209: 1481, 213: We, 214: 218, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, t(Ns, [2, 205]), t(Ns, [2, 206]), { 2: n, 3: 219, 4: a, 5: s, 77: [1, 1486], 143: le, 144: 1484, 145: he, 152: fe, 156: Q, 181: ge, 199: 1483, 200: 1487, 201: 1485, 202: 1488, 217: 1482, 290: z, 291: Z, 292: ee, 293: te, 302: _e, 419: 190, 420: Ge, 424: Ve }, { 207: [1, 1489], 223: Cs }, { 207: [1, 1491], 223: Rs }, t(Os, [2, 222]), { 206: [1, 1495], 208: [1, 1494], 221: 1493, 223: ps, 224: bs, 225: Es, 226: gs, 227: ms, 228: vs, 229: Ss }, t(Os, [2, 224]), { 223: [1, 1496] }, { 208: [1, 1498], 223: [1, 1497] }, { 208: [1, 1500], 223: [1, 1499] }, { 208: [1, 1501] }, { 223: [1, 1502] }, { 223: [1, 1503] }, { 74: ls, 204: 1504, 205: 1356, 206: hs, 208: ds, 215: 1355, 216: 1357, 221: 1360, 222: fs, 223: ps, 224: bs, 225: Es, 226: gs, 227: ms, 228: vs, 229: Ss }, t(Ga, [2, 84]), t(da, [2, 100]), { 74: ws, 78: [1, 1505] }, { 78: [1, 1507] }, t(Is, [2, 261]), { 78: [2, 1060] }, t(Is, [2, 263], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 242: [1, 1508], 243: [1, 1509], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(da, [2, 99]), t(Va, [2, 1064], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 101]), t(da, [2, 102]), t(da, [2, 103]), t(da, [2, 121]), t(da, [2, 124]), t(da, [2, 127]), t(Va, [2, 1068], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 128]), t(Va, [2, 1070], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 129]), t(Va, [2, 1072], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 130]), t(Va, [2, 1076], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 131]), t(Ba, [2, 1083], { 177: 1510 }), t(Ba, [2, 1086], { 153: 1015, 179: ca, 180: la, 181: ha }), { 74: As, 78: [1, 1511] }, t(da, [2, 133]), t(Va, [2, 1078], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 134]), t(Va, [2, 1080], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 135]), t(da, [2, 136]), t(da, [2, 137]), t(da, [2, 138]), t(da, [2, 139]), t(da, [2, 140]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 260, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 151: 1512, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Ha, [2, 1082], { 153: 1015, 179: ca, 180: la, 181: ha }), t(K, [2, 607]), t(K, [2, 603]), t(K, [2, 605]), t(K, [2, 601]), t(dn, [2, 71]), t(K, [2, 449], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Ya, [2, 452]), t(Ya, [2, 453], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1513, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Wa, [2, 662]), t(K, [2, 655], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 1514, 4: a, 5: s }, t(Sn, [2, 545], { 385: 1515, 391: 1516, 392: 1517, 366: 1525, 154: xs, 187: Ds, 230: ks, 297: Ls, 343: $s, 356: Ms, 368: Us, 369: _s, 373: Fs, 374: Ps }), t(Sn, [2, 535]), t(K, [2, 576], { 76: [1, 1529] }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1530, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1531, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1532, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1533, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 74: pn, 78: [1, 1534] }, t(K, [2, 585]), { 74: ws, 78: [1, 1535] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1376, 111: 149, 113: 153, 120: 1536, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1374, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t([10, 74, 78, 139, 306, 310, 602, 764], [2, 741]), { 139: [1, 1537] }, { 139: [2, 1150] }, { 2: n, 3: 1122, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 431: 585, 475: 1124, 478: 1538, 482: 582, 493: 579, 497: 581 }, { 78: [1, 1539] }, { 74: [1, 1540], 78: [2, 506] }, { 40: 1541, 79: 75, 89: c, 184: 99, 189: f }, t(os, [2, 532]), { 74: as, 78: [1, 1542] }, t(Ts, is), t(K, [2, 1133], { 412: 1543, 413: 1544, 72: qs }), t(Ma, za, { 79: 75, 184: 99, 114: 625, 327: 637, 40: 1299, 468: 1546, 89: c, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 146: Za, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 189: f, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr, 470: es }), t(Ma, [2, 725], { 74: Ja }), t(Ma, [2, 726], { 74: pn }), t([10, 53, 72, 89, 124, 146, 156, 189, 266, 267, 290, 306, 310, 335, 338, 339, 396, 400, 401, 404, 406, 408, 409, 417, 418, 434, 436, 437, 439, 440, 441, 442, 443, 447, 448, 451, 452, 505, 507, 508, 517, 602, 764], [2, 1181], { 512: 1547, 3: 1548, 2: n, 4: a, 5: s, 76: [1, 1549] }), t(Gs, [2, 1183], { 513: 1550, 76: [1, 1551] }), t(gt, [2, 692], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 131: [1, 1552] }, t(Na, [2, 538]), t(Na, [2, 540]), t(Qe, [2, 412]), t(Qe, [2, 413]), t(Qe, [2, 439]), t(Qe, [2, 423]), t(Qe, [2, 425]), { 118: Vs, 277: 1553, 278: 1554, 279: [1, 1555] }, t(Qe, [2, 328]), t(Qe, [2, 329]), t(Qe, [2, 316]), { 131: [1, 1557] }, t(Qe, [2, 318]), { 131: [1, 1558] }, { 74: ss, 78: [1, 1559] }, { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1560, 419: 190, 420: Ge, 424: Ve }, t(Ma, [2, 465], { 74: Ua }), t(Ma, [2, 468]), t(Ts, [2, 488]), t(os, [2, 480], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Ma, [2, 459], { 74: Ua }), t(K, [2, 718], { 74: ga, 198: [1, 1561] }), { 335: Bs, 338: js, 461: 1562 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1565, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 119: [1, 1567], 170: [1, 1568], 309: [1, 1566] }, t(Hs, [2, 259], { 86: 1569, 118: [1, 1570] }), { 119: [1, 1571] }, t(cs, [2, 239], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 95: [1, 1572], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 95: [1, 1573] }, t(Ns, [2, 203]), t(Ns, [2, 204]), t(Ts, [2, 178]), t(Ns, [2, 237], { 218: 1574, 230: [1, 1575], 231: [1, 1576] }), t(Js, [2, 208], { 3: 1577, 2: n, 4: a, 5: s, 76: [1, 1578] }), t(Ys, [2, 1095], { 219: 1579, 76: [1, 1580] }), { 2: n, 3: 1581, 4: a, 5: s, 76: [1, 1582] }, { 40: 1583, 79: 75, 89: c, 184: 99, 189: f }, t(Js, [2, 216], { 3: 1584, 2: n, 4: a, 5: s, 76: [1, 1585] }), t(Js, [2, 219], { 3: 1586, 2: n, 4: a, 5: s, 76: [1, 1587] }), { 77: [1, 1588] }, t(Os, [2, 234]), { 77: [1, 1589] }, t(Os, [2, 230]), t(Os, [2, 223]), { 223: Rs }, { 223: Cs }, t(Os, [2, 225]), t(Os, [2, 226]), { 223: [1, 1590] }, t(Os, [2, 228]), { 223: [1, 1591] }, { 223: [1, 1592] }, t(Os, [2, 232]), t(Os, [2, 233]), { 78: [1, 1593], 205: 1480, 206: hs, 208: ds, 215: 1479, 216: 1357, 221: 1360, 222: fs, 223: ps, 224: bs, 225: Es, 226: gs, 227: ms, 228: vs, 229: Ss }, t(da, [2, 91]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1376, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1594, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(da, [2, 92]), t(Is, [2, 264]), { 244: [1, 1595] }, t(os, [2, 142], { 419: 190, 3: 733, 114: 736, 144: 758, 158: 768, 160: 769, 117: 1596, 2: n, 4: a, 5: s, 72: Tr, 76: Ar, 77: yr, 112: Nr, 115: yt, 116: Nt, 118: Cr, 122: Rr, 123: Or, 124: wr, 128: Ir, 129: xr, 130: Dr, 131: kr, 132: Lr, 133: $r, 134: Mr, 135: Ur, 136: _r, 137: Fr, 138: Pr, 139: qr, 140: Gr, 141: Vr, 142: Br, 143: jr, 145: Hr, 146: Jr, 148: Yr, 149: Wr, 150: Xr, 152: Kr, 154: Qr, 156: zr, 162: Zr, 164: en, 166: tn, 168: rn, 169: nn, 170: an, 171: sn, 172: on, 173: un, 175: cn, 185: ln, 187: hn, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 420: Ge, 424: Ve }), t(da, [2, 132]), { 74: pn, 78: [1, 1597] }, t(Ya, [2, 454], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(K, [2, 572]), t(Sn, [2, 534]), t(Sn, [2, 546], { 366: 1525, 392: 1598, 154: xs, 187: Ds, 230: ks, 297: Ls, 343: $s, 356: Ms, 368: Us, 369: _s, 373: Fs, 374: Ps }), t(fn, [2, 548]), { 370: [1, 1599] }, { 370: [1, 1600] }, { 2: n, 3: 244, 4: a, 5: s, 199: 1601 }, t(fn, [2, 554], { 77: [1, 1602] }), { 2: n, 3: 114, 4: a, 5: s, 77: [1, 1604], 113: 251, 131: oe, 132: ue, 143: le, 152: fe, 156: Q, 181: ge, 196: 250, 200: 1605, 201: 254, 257: 252, 258: 253, 265: Ze, 274: 1603, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e }, t(fn, [2, 558]), { 297: [1, 1606] }, t(fn, [2, 560]), t(fn, [2, 561]), { 335: [1, 1607] }, { 77: [1, 1608] }, { 2: n, 3: 1609, 4: a, 5: s }, { 78: [1, 1610], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1611], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1612], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 78: [1, 1613], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(K, Xa, { 407: 1614, 76: Ka }), t(K, [2, 591]), { 74: ws, 78: [1, 1615] }, { 2: n, 3: 1122, 4: a, 5: s, 132: ft, 137: pt, 143: tt, 145: rt, 152: bt, 431: 585, 475: 1124, 478: 1616, 482: 582, 493: 579, 497: 581 }, t(Sn, [2, 735]), t(K, [2, 493], { 352: 1617, 354: 1618, 355: 1619, 4: Ws, 243: Xs, 343: Ks, 356: Qs }), t(zs, Zs, { 3: 1268, 359: 1624, 384: 1625, 360: 1626, 361: 1627, 2: n, 4: a, 5: s, 367: ei }), { 78: [2, 507] }, { 76: [1, 1629] }, t(K, [2, 609]), t(K, [2, 1134]), { 368: [1, 1631], 414: [1, 1630] }, t(Ma, [2, 728]), t(K, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 1632, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(K, [2, 762]), t(Gs, [2, 1182]), t(K, r, { 17: 5, 18: 7, 19: 8, 20: 9, 21: 10, 22: 11, 23: 12, 24: 13, 25: 14, 26: 15, 27: 16, 28: 17, 29: 18, 30: 19, 31: 20, 32: 21, 33: 22, 34: 23, 35: 24, 36: 25, 37: 26, 38: 27, 39: 28, 40: 29, 41: 30, 42: 31, 43: 32, 44: 33, 45: 34, 46: 35, 47: 36, 48: 37, 49: 38, 50: 39, 51: 40, 52: 41, 54: 43, 55: 44, 56: 45, 57: 46, 58: 47, 59: 48, 60: 49, 61: 50, 62: 51, 63: 52, 64: 53, 65: 54, 66: 55, 67: 56, 68: 57, 69: 58, 70: 59, 71: 60, 79: 75, 504: 95, 184: 99, 3: 100, 12: 1633, 2: n, 4: a, 5: s, 53: o, 72: u, 89: c, 124: l, 146: h, 156: d, 189: f, 266: p, 267: b, 290: E, 335: g, 338: m, 339: v, 396: S, 400: T, 401: y, 404: N, 406: C, 408: R, 409: O, 417: I, 418: x, 434: D, 436: k, 437: L, 439: $, 440: M, 441: U, 442: _, 443: F, 447: P, 448: q, 451: G, 452: V, 505: B, 507: j, 508: H, 517: J }), t(Gs, [2, 1184]), { 78: [1, 1634] }, { 78: [1, 1635], 118: Vs, 278: 1636 }, { 78: [1, 1637] }, { 119: [1, 1638] }, { 119: [1, 1639] }, { 78: [1, 1640] }, { 78: [1, 1641] }, t(Fa, [2, 476]), t(Ma, [2, 464], { 74: Ua }), { 2: n, 3: 244, 4: a, 5: s, 143: tt, 145: rt, 199: 1643, 431: 1642 }, t(us, [2, 703]), t(us, [2, 705]), { 146: [1, 1644] }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 309: [1, 1645], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, { 339: ti, 462: 1646 }, { 417: [1, 1649], 463: [1, 1648] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1650, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(ri, [2, 267], { 87: 1651, 245: [1, 1652], 247: [1, 1653] }), { 119: [1, 1654] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 233: 1655, 235: 1656, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1661, 4: a, 5: s }, { 2: n, 3: 1662, 4: a, 5: s }, t(Ns, [2, 207]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1663, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1664, 111: 1440 }, t(Js, [2, 209]), { 2: n, 3: 1665, 4: a, 5: s }, t(Js, [2, 1097], { 220: 1666, 3: 1667, 2: n, 4: a, 5: s }), t(Ys, [2, 1096]), t(Js, [2, 212]), { 2: n, 3: 1668, 4: a, 5: s }, { 78: [1, 1669] }, t(Js, [2, 217]), { 2: n, 3: 1670, 4: a, 5: s }, t(Js, [2, 220]), { 2: n, 3: 1671, 4: a, 5: s }, { 40: 1672, 79: 75, 89: c, 184: 99, 189: f }, { 40: 1673, 79: 75, 89: c, 184: 99, 189: f }, t(Os, [2, 227]), t(Os, [2, 229]), t(Os, [2, 231]), t(ia, [2, 171]), t(Is, [2, 262]), t(Is, [2, 265], { 242: [1, 1674] }), t(Ba, [2, 1084], { 153: 1015, 179: ca, 180: la, 181: ha }), t(da, [2, 141]), t(fn, [2, 547]), t(fn, [2, 550]), { 374: [1, 1675] }, t(fn, [2, 1127], { 395: 1676, 393: 1677, 77: ii }), { 131: oe, 196: 1679 }, t(fn, [2, 555]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1680, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(fn, [2, 557]), t(fn, [2, 559]), { 2: n, 3: 114, 4: a, 5: s, 77: [1, 1682], 113: 251, 131: oe, 132: ue, 143: le, 152: fe, 156: Q, 181: ge, 196: 250, 200: 255, 201: 254, 257: 252, 258: 253, 265: Ze, 274: 1681, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 302: _e }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1683, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(K, [2, 578]), t(sr, [2, 349]), t(sr, [2, 350]), t(sr, [2, 351]), t(sr, [2, 352]), t(K, [2, 582]), t(K, [2, 592]), t(Sn, [2, 734]), t(K, [2, 489]), t(K, [2, 494], { 355: 1684, 4: Ws, 243: Xs, 343: Ks, 356: Qs }), t(oi, [2, 496]), t(oi, [2, 497]), { 124: [1, 1685] }, { 124: [1, 1686] }, { 124: [1, 1687] }, { 74: [1, 1688], 78: [2, 505] }, t(os, [2, 533]), t(os, [2, 508]), { 187: [1, 1696], 193: [1, 1697], 362: 1689, 363: 1690, 364: 1691, 365: 1692, 366: 1693, 368: Us, 369: [1, 1694], 370: [1, 1698], 373: [1, 1695] }, { 2: n, 3: 1699, 4: a, 5: s }, { 40: 1700, 79: 75, 89: c, 184: 99, 189: f }, { 415: [1, 1701] }, { 416: [1, 1702] }, t(K, [2, 761]), t(K, [2, 763]), t(Na, [2, 537]), t(Qe, [2, 331]), { 78: [1, 1703] }, t(Qe, [2, 332]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 233: 1704, 235: 1656, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1376, 111: 149, 113: 153, 120: 1705, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1374, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(Qe, [2, 317]), t(Qe, [2, 319]), { 2: n, 3: 1706, 4: a, 5: s }, t(K, [2, 720], { 77: [1, 1707] }), { 2: n, 3: 1011, 4: a, 5: s, 111: 1065, 143: fa, 145: pa, 147: 1708, 336: 1064, 337: 1066 }, { 335: Bs, 338: js, 461: 1709 }, t(us, [2, 707]), { 77: [1, 1711], 343: [1, 1712], 344: [1, 1710] }, { 170: [1, 1714], 309: [1, 1713] }, { 170: [1, 1716], 309: [1, 1715] }, { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 309: [1, 1717], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(ua, [2, 250], { 88: 1718, 162: [1, 1719], 168: [1, 1721], 169: [1, 1720] }), { 131: oe, 196: 1722 }, { 131: oe, 196: 1723 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1376, 111: 149, 113: 153, 120: 1724, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 241: 1374, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, t(ys, [2, 248], { 234: 1725, 74: ui, 239: [1, 1727] }), t(ci, [2, 242]), { 146: [1, 1728] }, { 77: [1, 1729] }, { 77: [1, 1730] }, t(ci, [2, 247], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 78: [2, 1051], 96: 1731, 99: [1, 1733], 102: 1732 }, { 99: [1, 1734] }, t(Ns, [2, 235], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), t(Ns, [2, 236], { 74: as }), t(Js, [2, 210]), t(Js, [2, 211]), t(Js, [2, 1098]), t(Js, [2, 213]), { 2: n, 3: 1735, 4: a, 5: s, 76: [1, 1736] }, t(Js, [2, 218]), t(Js, [2, 221]), { 78: [1, 1737] }, { 78: [1, 1738] }, t(Is, [2, 266]), { 2: n, 3: 244, 4: a, 5: s, 199: 1739 }, t(fn, [2, 552]), t(fn, [2, 1128]), { 2: n, 3: 1740, 4: a, 5: s }, { 74: [1, 1741] }, {
                78: [1, 1742], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt,
                317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr
            }, t(fn, [2, 562]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1743, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 78: [1, 1744], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(oi, [2, 495]), { 2: n, 3: 1745, 4: a, 5: s }, { 131: oe, 196: 1746 }, { 2: n, 3: 1747, 4: a, 5: s }, t(zs, Zs, { 361: 1627, 360: 1748, 367: ei }), t(Sn, [2, 510]), t(Sn, [2, 511]), t(Sn, [2, 512]), t(Sn, [2, 513]), t(Sn, [2, 514]), { 370: [1, 1749] }, { 370: [1, 1750] }, t(li, [2, 1121], { 382: 1751, 370: [1, 1752] }), { 2: n, 3: 1753, 4: a, 5: s }, { 2: n, 3: 1754, 4: a, 5: s }, t(zs, [2, 516]), t(K, [2, 1131], { 411: 1755, 413: 1756, 72: qs }), t(K, [2, 610]), t(K, [2, 611], { 367: [1, 1757] }), t(Qe, [2, 333]), t([78, 118], [2, 334], { 74: ui }), { 74: ws, 78: [2, 335] }, t(K, [2, 719]), { 2: n, 3: 1011, 4: a, 5: s, 100: 1758, 111: 1440 }, t(us, [2, 706], { 74: Ja }), t(us, [2, 704]), { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1759, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1760, 111: 1440 }, { 344: [1, 1761] }, { 339: ti, 462: 1762 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1763, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 339: ti, 462: 1764 }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1765, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 339: ti, 462: 1766 }, t(ua, [2, 72]), { 40: 1767, 79: 75, 89: c, 164: [1, 1768], 184: 99, 189: f, 240: [1, 1769] }, { 40: 1770, 79: 75, 89: c, 184: 99, 189: f, 240: [1, 1771] }, { 40: 1772, 79: 75, 89: c, 184: 99, 189: f, 240: [1, 1773] }, t(ri, [2, 270], { 246: 1774, 247: [1, 1775] }), { 248: 1776, 249: [2, 1099], 766: [1, 1777] }, t(Hs, [2, 260], { 74: ws }), t(ys, [2, 241]), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 235: 1778, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1779, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 77: [1, 1780] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 233: 1781, 235: 1656, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 233: 1782, 235: 1656, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 78: [1, 1783] }, { 78: [2, 1052] }, { 77: [1, 1784] }, { 77: [1, 1785] }, t(Js, [2, 214]), { 2: n, 3: 1786, 4: a, 5: s }, { 2: n, 3: 1787, 4: a, 5: s, 76: [1, 1788] }, { 2: n, 3: 1789, 4: a, 5: s, 76: [1, 1790] }, t(fn, [2, 1125], { 394: 1791, 393: 1792, 77: ii }), { 78: [1, 1793] }, { 131: oe, 196: 1794 }, t(fn, [2, 556]), { 78: [1, 1795], 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(fn, [2, 517]), t(oi, [2, 498]), t(oi, [2, 499]), t(oi, [2, 500]), t(os, [2, 509]), { 2: n, 3: 1797, 4: a, 5: s, 77: [2, 1117], 371: 1796 }, { 77: [1, 1798] }, { 2: n, 3: 1800, 4: a, 5: s, 77: [2, 1123], 383: 1799 }, t(li, [2, 1122]), { 77: [1, 1801] }, { 77: [1, 1802] }, t(K, [2, 608]), t(K, [2, 1132]), t(zs, Zs, { 361: 1627, 360: 1803, 367: ei }), { 74: as, 78: [1, 1804] }, t(us, [2, 713], { 74: Ua }), { 74: as, 78: [1, 1805] }, t(us, [2, 715]), t(us, [2, 708]), { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 309: [1, 1806], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(us, [2, 711]), { 99: Tt, 112: At, 114: 625, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 309: [1, 1807], 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 327: 637, 330: er, 331: tr, 332: rr, 333: nr }, t(us, [2, 709]), t(ua, [2, 251]), { 40: 1808, 79: 75, 89: c, 184: 99, 189: f, 240: [1, 1809] }, { 40: 1810, 79: 75, 89: c, 184: 99, 189: f }, t(ua, [2, 253]), { 40: 1811, 79: 75, 89: c, 184: 99, 189: f }, t(ua, [2, 254]), { 40: 1812, 79: 75, 89: c, 184: 99, 189: f }, t(ri, [2, 268]), { 131: oe, 196: 1813 }, { 249: [1, 1814] }, { 249: [2, 1100] }, t(ci, [2, 243]), t(ys, [2, 249], { 114: 625, 327: 637, 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1660, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 233: 1815, 235: 1656, 236: ni, 237: ai, 238: si, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 74: ui, 78: [1, 1816] }, { 74: ui, 78: [1, 1817] }, t(qa, [2, 1053], { 97: 1818, 104: 1819, 3: 1821, 2: n, 4: a, 5: s, 76: hi }), { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1824, 103: 1822, 105: 1823, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1825, 111: 1440 }, t(Js, [2, 215]), t(Ns, [2, 173]), { 2: n, 3: 1826, 4: a, 5: s }, t(Ns, [2, 175]), { 2: n, 3: 1827, 4: a, 5: s }, t(fn, [2, 551]), t(fn, [2, 1126]), t(fn, [2, 549]), { 78: [1, 1828] }, t(fn, [2, 563]), { 77: [1, 1829] }, { 77: [2, 1118] }, { 2: n, 3: 1831, 4: a, 5: s, 132: di, 372: 1830 }, { 77: [1, 1833] }, { 77: [2, 1124] }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1834, 111: 1440 }, { 2: n, 3: 1011, 4: a, 5: s, 100: 1835, 111: 1440 }, t(K, [2, 612]), t(K, [2, 721]), { 343: [1, 1837], 344: [1, 1836] }, { 339: ti, 462: 1838 }, { 335: Bs, 338: js, 461: 1839 }, t(ua, [2, 252]), { 40: 1840, 79: 75, 89: c, 184: 99, 189: f }, t(ua, [2, 255]), t(ua, [2, 257]), t(ua, [2, 258]), t(ri, [2, 271]), { 131: [2, 1101], 250: 1841, 645: [1, 1842] }, { 74: ui, 78: [1, 1843] }, t(ci, [2, 245]), t(ci, [2, 246]), t(qa, [2, 74]), t(qa, [2, 1054]), { 2: n, 3: 1844, 4: a, 5: s }, t(qa, [2, 78]), { 74: [1, 1846], 78: [1, 1845] }, t(os, [2, 80]), t(os, [2, 81], { 114: 625, 327: 637, 76: [1, 1847], 99: Tt, 112: At, 115: yt, 116: Nt, 123: Ct, 124: En, 133: Ot, 136: wt, 138: It, 139: xt, 140: Dt, 141: kt, 142: Lt, 154: $t, 170: Mt, 171: Ut, 179: _t, 180: Ft, 311: Pt, 312: qt, 313: Gt, 315: Vt, 316: Bt, 317: jt, 318: Ht, 319: Jt, 320: Yt, 321: Wt, 322: Xt, 323: Kt, 324: Qt, 325: zt, 326: Zt, 330: er, 331: tr, 332: rr, 333: nr }), { 74: as, 78: [1, 1848] }, t(Ns, [2, 174]), t(Ns, [2, 176]), t(fn, [2, 553]), { 2: n, 3: 1831, 4: a, 5: s, 132: di, 372: 1849 }, { 74: fi, 78: [1, 1850] }, t(os, [2, 528]), t(os, [2, 529]), { 2: n, 3: 1011, 4: a, 5: s, 100: 1852, 111: 1440 }, { 74: as, 78: [1, 1853] }, { 74: as, 78: [1, 1854] }, { 77: sa, 143: le, 144: 979, 145: ze, 152: fe, 181: ge, 201: 980, 302: _e, 342: 1855, 419: 190, 420: Ge, 424: Ve }, { 344: [1, 1856] }, t(us, [2, 710]), t(us, [2, 712]), t(ua, [2, 256]), { 131: oe, 196: 1857 }, { 131: [2, 1102] }, t(ci, [2, 244]), t(qa, [2, 77]), { 78: [2, 76] }, { 2: n, 3: 168, 4: a, 5: s, 56: 165, 77: ie, 94: 1824, 105: 1858, 111: 149, 113: 153, 131: oe, 132: ue, 137: ce, 143: le, 144: 161, 145: he, 149: de, 152: fe, 154: pe, 156: Q, 158: 167, 179: be, 180: Ee, 181: ge, 196: 151, 200: 147, 201: 155, 202: 156, 254: 150, 255: 146, 256: 148, 257: 152, 258: 154, 259: 157, 260: 158, 261: 159, 262: 162, 263: 163, 265: me, 266: p, 270: ve, 271: Se, 273: Te, 280: Ae, 281: ye, 282: Ne, 283: Ce, 284: Re, 285: Oe, 286: we, 287: Ie, 288: xe, 290: z, 291: Z, 292: ee, 293: te, 294: De, 295: ke, 296: Le, 297: $e, 298: Me, 299: Ue, 302: _e, 303: Fe, 312: Pe, 317: qe, 419: 190, 420: Ge, 424: Ve }, { 2: n, 3: 1859, 4: a, 5: s }, { 78: [1, 1860] }, { 74: fi, 78: [1, 1861] }, { 374: [1, 1862] }, { 2: n, 3: 1863, 4: a, 5: s, 132: [1, 1864] }, { 74: as, 78: [1, 1865] }, t(Sn, [2, 526]), t(Sn, [2, 527]), t(us, [2, 714], { 74: Ua }), t(us, [2, 716]), t(pi, [2, 1103], { 251: 1866, 766: [1, 1867] }), t(os, [2, 79]), t(os, [2, 82]), t(qa, [2, 1055], { 3: 1821, 101: 1868, 104: 1869, 2: n, 4: a, 5: s, 76: hi }), t(Sn, [2, 518]), { 2: n, 3: 244, 4: a, 5: s, 199: 1870 }, t(os, [2, 530]), t(os, [2, 531]), t(Sn, [2, 525]), t(ri, [2, 1105], { 252: 1871, 415: [1, 1872] }), t(pi, [2, 1104]), t(qa, [2, 75]), t(qa, [2, 1056]), t(bi, [2, 1119], { 375: 1873, 377: 1874, 77: [1, 1875] }), t(ri, [2, 269]), t(ri, [2, 1106]), t(Sn, [2, 521], { 376: 1876, 378: 1877, 230: [1, 1878] }), t(bi, [2, 1120]), { 2: n, 3: 1831, 4: a, 5: s, 132: di, 372: 1879 }, t(Sn, [2, 519]), { 230: [1, 1881], 379: 1880 }, { 338: [1, 1882] }, { 74: fi, 78: [1, 1883] }, t(Sn, [2, 522]), { 335: [1, 1884] }, { 380: [1, 1885] }, t(bi, [2, 520]), { 380: [1, 1886] }, { 381: [1, 1887] }, { 381: [1, 1888] }, { 230: [2, 523] }, t(Sn, [2, 524])], defaultActions: { 105: [2, 6], 194: [2, 336], 195: [2, 337], 196: [2, 338], 197: [2, 339], 198: [2, 340], 199: [2, 341], 200: [2, 342], 201: [2, 343], 202: [2, 344], 209: [2, 695], 591: [2, 1142], 653: [2, 1107], 654: [2, 1108], 710: [2, 696], 780: [2, 1073], 781: [2, 1074], 926: [2, 446], 927: [2, 447], 928: [2, 448], 987: [2, 697], 1288: [2, 1152], 1375: [2, 1060], 1433: [2, 1150], 1541: [2, 507], 1732: [2, 1052], 1777: [2, 1100], 1797: [2, 1118], 1800: [2, 1124], 1842: [2, 1102], 1845: [2, 76], 1887: [2, 523] }, parseError: function (e, t) { function r(e, t) { this.message = e, this.hash = t } if (!t.recoverable) throw r.prototype = Error, new r(e, t); this.trace(e) }, parse: function (e) { function t(e) { for (var t = n.length - 1, r = 0; ;) { if (h.toString() in i[e]) return r; if (0 === e || t < 2) return !1; t -= 2, e = n[t], ++r } } var r = this, n = [0], a = [null], s = [], i = this.table, o = "", u = 0, c = 0, l = 0, h = 2, d = s.slice.call(arguments, 1), f = Object.create(this.lexer), p = { yy: {} }; for (var b in this.yy) Object.prototype.hasOwnProperty.call(this.yy, b) && (p.yy[b] = this.yy[b]); f.setInput(e, p.yy), p.yy.lexer = f, p.yy.parser = this, void 0 === f.yylloc && (f.yylloc = {}); var E = f.yylloc; s.push(E); var g = f.options && f.options.ranges; "function" == typeof p.yy.parseError ? this.parseError = p.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError; for (var m, v, S, T, A, y, N, C, R, O = function () { var e; return e = f.lex() || 1, "number" != typeof e && (e = r.symbols_[e] || e), e }, w = {}; ;) { if (S = n[n.length - 1], this.defaultActions[S] ? T = this.defaultActions[S] : (null !== m && void 0 !== m || (m = O()), T = i[S] && i[S][m]), void 0 === T || !T.length || !T[0]) { var I, x = ""; if (l) 1 !== v && (I = t(S)); else { I = t(S), R = []; for (y in i[S]) this.terminals_[y] && y > h && R.push("'" + this.terminals_[y] + "'"); x = f.showPosition ? "Parse error on line " + (u + 1) + ":\n" + f.showPosition() + "\nExpecting " + R.join(", ") + ", got '" + (this.terminals_[m] || m) + "'" : "Parse error on line " + (u + 1) + ": Unexpected " + (1 == m ? "end of input" : "'" + (this.terminals_[m] || m) + "'"), this.parseError(x, { text: f.match, token: this.terminals_[m] || m, line: f.yylineno, loc: E, expected: R, recoverable: !1 !== I }) } if (3 == l) { if (1 === m || 1 === v) throw new Error(x || "Parsing halted while starting to recover from another error."); c = f.yyleng, o = f.yytext, u = f.yylineno, E = f.yylloc, m = O() } if (!1 === I) throw new Error(x || "Parsing halted. No suitable error recovery rule available."); !function (e) { n.length = n.length - 2 * e, a.length = a.length - e, s.length = s.length - e }(I), v = m == h ? null : m, m = h, S = n[n.length - 1], T = i[S] && i[S][h], l = 3 } if (T[0] instanceof Array && T.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + S + ", token: " + m); switch (T[0]) { case 1: n.push(m), a.push(f.yytext), s.push(f.yylloc), n.push(T[1]), m = null, v ? (m = v, v = null) : (c = f.yyleng, o = f.yytext, u = f.yylineno, E = f.yylloc, l > 0 && l--); break; case 2: if (N = this.productions_[T[1]][1], w.$ = a[a.length - N], w._$ = { first_line: s[s.length - (N || 1)].first_line, last_line: s[s.length - 1].last_line, first_column: s[s.length - (N || 1)].first_column, last_column: s[s.length - 1].last_column }, g && (w._$.range = [s[s.length - (N || 1)].range[0], s[s.length - 1].range[1]]), void 0 !== (A = this.performAction.apply(w, [o, c, u, p.yy, T[1], a, s].concat(d)))) return A; N && (n = n.slice(0, -1 * N * 2), a = a.slice(0, -1 * N), s = s.slice(0, -1 * N)), n.push(this.productions_[T[1]][0]), a.push(w.$), s.push(w._$), C = i[n[n.length - 2]][n[n.length - 1]], n.push(C); break; case 3: return !0 } } return !0 }
        }, gi = ["A", "ABSENT", "ABSOLUTE", "ACCORDING", "ACTION", "ADA", "ADD", "ADMIN", "AFTER", "ALWAYS", "ASC", "ASSERTION", "ASSIGNMENT", "ATTRIBUTE", "ATTRIBUTES", "BASE64", "BEFORE", "BERNOULLI", "BLOCKED", "BOM", "BREADTH", "C", "CASCADE", "CATALOG", "CATALOG_NAME", "CHAIN", "CHARACTERISTICS", "CHARACTERS", "CHARACTER_SET_CATALOG", "CHARACTER_SET_NAME", "CHARACTER_SET_SCHEMA", "CLASS_ORIGIN", "COBOL", "COLLATION", "COLLATION_CATALOG", "COLLATION_NAME", "COLLATION_SCHEMA", "COLUMNS", "COLUMN_NAME", "COMMAND_FUNCTION", "COMMAND_FUNCTION_CODE", "COMMITTED", "CONDITION_NUMBER", "CONNECTION", "CONNECTION_NAME", "CONSTRAINTS", "CONSTRAINT_CATALOG", "CONSTRAINT_NAME", "CONSTRAINT_SCHEMA", "CONSTRUCTOR", "CONTENT", "CONTINUE", "CONTROL", "CURSOR_NAME", "DATA", "DATETIME_INTERVAL_CODE", "DATETIME_INTERVAL_PRECISION", "DB", "DEFAULTS", "DEFERRABLE", "DEFERRED", "DEFINED", "DEFINER", "DEGREE", "DEPTH", "DERIVED", "DESC", "DESCRIPTOR", "DIAGNOSTICS", "DISPATCH", "DOCUMENT", "DOMAIN", "DYNAMIC_FUNCTION", "DYNAMIC_FUNCTION_CODE", "EMPTY", "ENCODING", "ENFORCED", "EXCLUDE", "EXCLUDING", "EXPRESSION", "FILE", "FINAL", "FIRST", "FLAG", "FOLLOWING", "FORTRAN", "FOUND", "FS", "G", "GENERAL", "GENERATED", "GO", "GOTO", "GRANTED", "HEX", "HIERARCHY", "ID", "IGNORE", "IMMEDIATE", "IMMEDIATELY", "IMPLEMENTATION", "INCLUDING", "INCREMENT", "INDENT", "INITIALLY", "INPUT", "INSTANCE", "INSTANTIABLE", "INSTEAD", "INTEGRITY", "INVOKER", "ISOLATION", "K", "KEY", "KEY_MEMBER", "KEY_TYPE", "LAST", "LENGTH", "LEVEL", "LIBRARY", "LIMIT", "LINK", "LOCATION", "LOCATOR", "M", "MAP", "MAPPING", "MATCHED", "MAXVALUE", "MESSAGE_LENGTH", "MESSAGE_OCTET_LENGTH", "MESSAGE_TEXT", "MINVALUE", "MORE", "MUMPS", "NAME", "NAMES", "NAMESPACE", "NESTING", "NEXT", "NFC", "NFD", "NFKC", "NFKD", "NIL", "NORMALIZED", "NULLABLE", "NULLS", "NUMBER", "OBJECT", "OCTETS", "OFF", "OPTION", "OPTIONS", "ORDERING", "ORDINALITY", "OTHERS", "OUTPUT", "OVERRIDING", "P", "PAD", "PARAMETER_MODE", "PARAMETER_NAME", "PARAMETER_ORDINAL_POSITION", "PARAMETER_SPECIFIC_CATALOG", "PARAMETER_SPECIFIC_NAME", "PARAMETER_SPECIFIC_SCHEMA", "PARTIAL", "PASCAL", "PASSING", "PASSTHROUGH", "PATH", "PERMISSION", "PLACING", "PLI", "PRECEDING", "PRESERVE", "PRIOR", "PRIVILEGES", "PUBLIC", "READ", "RECOVERY", "RELATIVE", "REPEATABLE", "REQUIRING", "RESPECT", "RESTART", "RESTORE", "RESTRICT", "RETURNED_CARDINALITY", "RETURNED_LENGTH", "RETURNED_OCTET_LENGTH", "RETURNED_SQLSTATE", "RETURNING", "ROLE", "ROUTINE", "ROUTINE_CATALOG", "ROUTINE_NAME", "ROUTINE_SCHEMA", "ROW_COUNT", "SCALE", "SCHEMA", "SCHEMA_NAME", "SCOPE_CATALOG", "SCOPE_NAME", "SCOPE_SCHEMA", "SECTION", "SECURITY", "SELECTIVE", "SELF", "SEQUENCE", "SERIALIZABLE", "SERVER", "SERVER_NAME", "SESSION", "SETS", "SIMPLE", "SIZE", "SOURCE", "SPACE", "SPECIFIC_NAME", "STANDALONE", "STATE", "STATEMENT", "STRIP", "STRUCTURE", "STYLE", "SUBCLASS_ORIGIN", "T", "TABLE_NAME", "TEMPORARY", "TIES", "TOKEN", "TOP_LEVEL_COUNT", "TRANSACTION", "TRANSACTIONS_COMMITTED", "TRANSACTIONS_ROLLED_BACK", "TRANSACTION_ACTIVE", "TRANSFORM", "TRANSFORMS", "TRIGGER_CATALOG", "TRIGGER_NAME", "TRIGGER_SCHEMA", "TYPE", "UNBOUNDED", "UNCOMMITTED", "UNDER", "UNLINK", "UNNAMED", "UNTYPED", "URI", "USAGE", "USER_DEFINED_TYPE_CATALOG", "USER_DEFINED_TYPE_CODE", "USER_DEFINED_TYPE_NAME", "USER_DEFINED_TYPE_SCHEMA", "VALID", "VERSION", "VIEW", "WHITESPACE", "WORK", "WRAPPER", "WRITE", "XMLDECLARATION", "XMLSCHEMA", "YES", "ZONE"]; Ei.parseError = function (e, t) { if (!(t.expected && t.expected.indexOf("'LITERAL'") > -1 && /[a-zA-Z_][a-zA-Z_0-9]*/.test(t.token) && gi.indexOf(t.token) > -1)) throw new SyntaxError(e) }; var mi = function () {
            return {
                EOF: 1, parseError: function (e, t) { if (!this.yy.parser) throw new Error(e); this.yy.parser.parseError(e, t) }, setInput: function (e, t) { return this.yy = t || this.yy || {}, this._input = e, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this }, input: function () { var e = this._input[0]; return this.yytext += e, this.yyleng++, this.offset++, this.match += e, this.matched += e, e.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), e }, unput: function (e) { var t = e.length, r = e.split(/(?:\r\n?|\n)/g); this._input = e + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - t), this.offset -= t; var n = this.match.split(/(?:\r\n?|\n)/g); this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), r.length - 1 && (this.yylineno -= r.length - 1); var a = this.yylloc.range; return this.yylloc = { first_line: this.yylloc.first_line, last_line: this.yylineno + 1, first_column: this.yylloc.first_column, last_column: r ? (r.length === n.length ? this.yylloc.first_column : 0) + n[n.length - r.length].length - r[0].length : this.yylloc.first_column - t }, this.options.ranges && (this.yylloc.range = [a[0], a[0] + this.yyleng - t]), this.yyleng = this.yytext.length, this }, more: function () { return this._more = !0, this }, reject: function () { return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), { text: "", token: null, line: this.yylineno }) }, less: function (e) { this.unput(this.match.slice(e)) }, pastInput: function () { var e = this.matched.substr(0, this.matched.length - this.match.length); return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "") }, upcomingInput: function () { var e = this.match; return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "") }, showPosition: function () { var e = this.pastInput(), t = new Array(e.length + 1).join("-"); return e + this.upcomingInput() + "\n" + t + "^" }, test_match: function (e, t) { var r, n, a; if (this.options.backtrack_lexer && (a = { yylineno: this.yylineno, yylloc: { first_line: this.yylloc.first_line, last_line: this.last_line, first_column: this.yylloc.first_column, last_column: this.yylloc.last_column }, yytext: this.yytext, match: this.match, matches: this.matches, matched: this.matched, yyleng: this.yyleng, offset: this.offset, _more: this._more, _input: this._input, yy: this.yy, conditionStack: this.conditionStack.slice(0), done: this.done }, this.options.ranges && (a.yylloc.range = this.yylloc.range.slice(0))), n = e[0].match(/(?:\r\n?|\n).*/g), n && (this.yylineno += n.length), this.yylloc = { first_line: this.yylloc.last_line, last_line: this.yylineno + 1, first_column: this.yylloc.last_column, last_column: n ? n[n.length - 1].length - n[n.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length }, this.yytext += e[0], this.match += e[0], this.matches = e, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(e[0].length), this.matched += e[0], r = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), r) return r; if (this._backtrack) { for (var s in a) this[s] = a[s]; return !1 } return !1 }, next: function () { if (this.done) return this.EOF; this._input || (this.done = !0); var e, t, r, n; this._more || (this.yytext = "", this.match = ""); for (var a = this._currentRules(), s = 0; s < a.length; s++)if ((r = this._input.match(this.rules[a[s]])) && (!t || r[0].length > t[0].length)) { if (t = r, n = s, this.options.backtrack_lexer) { if (!1 !== (e = this.test_match(r, a[s]))) return e; if (this._backtrack) { t = !1; continue } return !1 } if (!this.options.flex) break } return t ? !1 !== (e = this.test_match(t, a[n])) && e : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno }) }, lex: function () { var e = this.next(); return e || this.lex() }, begin: function (e) { this.conditionStack.push(e) }, popState: function () { return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0] }, _currentRules: function () { return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules }, topState: function (e) { return e = this.conditionStack.length - 1 - Math.abs(e || 0), e >= 0 ? this.conditionStack[e] : "INITIAL" }, pushState: function (e) { this.begin(e) }, stateStackSize: function () { return this.conditionStack.length }, options: { "case-insensitive": !0 }, performAction: function (e, t, r, n) { switch (r) { case 0: return 266; case 1: return 302; case 2: return 420; case 3: return 299; case 4: case 5: return 5; case 6: case 7: return 296; case 8: case 9: return 132; case 10: return; case 11: break; case 12: return 316; case 13: return 319; case 14: return t.yytext = "VALUE", 89; case 15: return t.yytext = "VALUE", 189; case 16: return t.yytext = "ROW", 189; case 17: return t.yytext = "COLUMN", 189; case 18: return t.yytext = "MATRIX", 189; case 19: return t.yytext = "INDEX", 189; case 20: return t.yytext = "RECORDSET", 189; case 21: return t.yytext = "TEXT", 189; case 22: return t.yytext = "SELECT", 189; case 23: return 520; case 24: return 381; case 25: return 402; case 26: return 515; case 27: return 287; case 28: case 29: return 269; case 30: return 164; case 31: return 400; case 32: return 170; case 33: return 229; case 34: return 166; case 35: return 207; case 36: return 288; case 37: return 76; case 38: return 418; case 39: return 242; case 40: return 404; case 41: return 356; case 42: return 284; case 43: return 514; case 44: return 437; case 45: return 330; case 46: return 441; case 47: return 331; case 48: return 315; case 49: return 119; case 50: return 112; case 51: return 315; case 52: return 112; case 53: return 315; case 54: return 112; case 55: return 315; case 56: return 508; case 57: return 303; case 58: return 271; case 59: return 368; case 60: return 130; case 61: return "CLOSE"; case 62: return 243; case 63: case 64: return 190; case 65: return 434; case 66: return 367; case 67: return 470; case 68: return 440; case 69: return 273; case 70: return 240; case 71: return 281; case 72: return 267; case 73: return 206; case 74: return 238; case 75: return 265; case 76: return "CURSOR"; case 77: return 405; case 78: return 291; case 79: return 292; case 80: return 448; case 81: return 343; case 82: return 338; case 83: return "DELETED"; case 84: return 242; case 85: return 406; case 86: return 185; case 87: return 396; case 88: return 447; case 89: return 135; case 90: return 306; case 91: return 389; case 92: return 310; case 93: return 314; case 94: return 169; case 95: case 96: return 508; case 97: return 298; case 98: return 14; case 99: return 295; case 100: return 249; case 101: return 285; case 102: return 95; case 103: return 373; case 104: return 183; case 105: return 227; case 106: return 268; case 107: return 313; case 108: return 602; case 109: return 472; case 110: return 232; case 111: return 236; case 112: return 239; case 113: return 156; case 114: return 356; case 115: return 332; case 116: return 99; case 117: return 193; case 118: return 212; case 119: return 224; case 120: return 516; case 121: return 339; case 122: return 213; case 123: return 168; case 124: return 293; case 125: return 198; case 126: return 223; case 127: return 370; case 128: return 286; case 129: return "LET"; case 130: return 225; case 131: return 112; case 132: return 245; case 133: return 460; case 134: return 191; case 135: return 283; case 136: return 390; case 137: return 282; case 138: return 452; case 139: return 169; case 140: return 403; case 141: return 222; case 142: return 645; case 143: return 270; case 144: return 244; case 145: return 380; case 146: return 154; case 147: return 297; case 148: return 433; case 149: return 230; case 150: return 415; case 151: return 129; case 152: return 247; case 153: return "OPEN"; case 154: return 416; case 155: return 171; case 156: return 118; case 157: return 208; case 158: return 276; case 159: return 172; case 160: return 279; case 161: return 765; case 162: return 93; case 163: return 16; case 164: return 369; case 165: return 442; case 166: return 678; case 167: return 15; case 168: return 414; case 169: return 194; case 170: return "REDUCE"; case 171: return 374; case 172: return 311; case 173: return 517; case 174: return 682; case 175: return 107; case 176: return 401; case 177: return 175; case 178: return 290; case 179: return 443; case 180: return 687; case 181: case 182: return 173; case 183: return 226; case 184: return 436; case 185: return 237; case 186: return 150; case 187: return 766; case 188: return 405; case 189: return 89; case 190: return 228; case 191: case 192: return 146; case 193: return 409; case 194: return 334; case 195: return 417; case 196: return "STRATEGY"; case 197: return "STORE"; case 198: return 280; case 199: case 200: return 353; case 201: return 463; case 202: case 203: return 357; case 204: return 192; case 205: return 309; case 206: return "TIMEOUT"; case 207: return 148; case 208: return 195; case 209: case 210: return 435; case 211: return 509; case 212: return 294; case 213: return 451; case 214: return 162; case 215: return 187; case 216: return 98; case 217: return 335; case 218: return 408; case 219: return 231; case 220: return 149; case 221: return 344; case 222: return 134; case 223: return 410; case 224: return 308; case 225: return 128; case 226: return 439; case 227: return 72; case 228: return 435; case 229: case 230: return 131; case 231: return 115; case 232: return 137; case 233: return 179; case 234: return 317; case 235: return 180; case 236: return 133; case 237: return 138; case 238: return 326; case 239: return 323; case 240: return 325; case 241: return 322; case 242: return 320; case 243: return 318; case 244: return 319; case 245: return 142; case 246: return 141; case 247: return 139; case 248: return 321; case 249: return 324; case 250: return 140; case 251: return 124; case 252: return 324; case 253: return 77; case 254: return 78; case 255: return 145; case 256: return 424; case 257: return 426; case 258: return 300; case 259: return 505; case 260: return 507; case 261: return 122; case 262: return 116; case 263: return 74; case 264: return 333; case 265: return 152; case 266: return 764; case 267: return 143; case 268: return 181; case 269: return 136; case 270: return 123; case 271: return 312; case 272: return 4; case 273: return 10; case 274: return "INVALID" } },
                rules: [/^(?:``([^\`])+``)/i, /^(?:\[\?\])/i, /^(?:@\[)/i, /^(?:ARRAY\[)/i, /^(?:\[([^\]])*?\])/i, /^(?:`([^\`])*?`)/i, /^(?:N(['](\\.|[^']|\\')*?['])+)/i, /^(?:X(['](\\.|[^']|\\')*?['])+)/i, /^(?:(['](\\.|[^']|\\')*?['])+)/i, /^(?:(["](\\.|[^"]|\\")*?["])+)/i, /^(?:--(.*?)($|\r\n|\r|\n))/i, /^(?:\s+)/i, /^(?:\|\|)/i, /^(?:\|)/i, /^(?:VALUE\s+OF\s+SEARCH\b)/i, /^(?:VALUE\s+OF\s+SELECT\b)/i, /^(?:ROW\s+OF\s+SELECT\b)/i, /^(?:COLUMN\s+OF\s+SELECT\b)/i, /^(?:MATRIX\s+OF\s+SELECT\b)/i, /^(?:INDEX\s+OF\s+SELECT\b)/i, /^(?:RECORDSET\s+OF\s+SELECT\b)/i, /^(?:TEXT\s+OF\s+SELECT\b)/i, /^(?:SELECT\b)/i, /^(?:ABSOLUTE\b)/i, /^(?:ACTION\b)/i, /^(?:ADD\b)/i, /^(?:AFTER\b)/i, /^(?:AGGR\b)/i, /^(?:AGGREGATE\b)/i, /^(?:AGGREGATOR\b)/i, /^(?:ALL\b)/i, /^(?:ALTER\b)/i, /^(?:AND\b)/i, /^(?:ANTI\b)/i, /^(?:ANY\b)/i, /^(?:APPLY\b)/i, /^(?:ARRAY\b)/i, /^(?:AS\b)/i, /^(?:ASSERT\b)/i, /^(?:ASC\b)/i, /^(?:ATTACH\b)/i, /^(?:AUTO(_)?INCREMENT\b)/i, /^(?:AVG\b)/i, /^(?:BEFORE\b)/i, /^(?:BEGIN\b)/i, /^(?:BETWEEN\b)/i, /^(?:BREAK\b)/i, /^(?:NOT\s+BETWEEN\b)/i, /^(?:NOT\s+LIKE\b)/i, /^(?:BY\b)/i, /^(?:~~\*)/i, /^(?:!~~\*)/i, /^(?:~~)/i, /^(?:!~~)/i, /^(?:ILIKE\b)/i, /^(?:NOT\s+ILIKE\b)/i, /^(?:CALL\b)/i, /^(?:CASE\b)/i, /^(?:CAST\b)/i, /^(?:CHECK\b)/i, /^(?:CLASS\b)/i, /^(?:CLOSE\b)/i, /^(?:COLLATE\b)/i, /^(?:COLUMN\b)/i, /^(?:COLUMNS\b)/i, /^(?:COMMIT\b)/i, /^(?:CONSTRAINT\b)/i, /^(?:CONTENT\b)/i, /^(?:CONTINUE\b)/i, /^(?:CONVERT\b)/i, /^(?:CORRESPONDING\b)/i, /^(?:COUNT\b)/i, /^(?:CREATE\b)/i, /^(?:CROSS\b)/i, /^(?:CUBE\b)/i, /^(?:CURRENT_TIMESTAMP\b)/i, /^(?:CURSOR\b)/i, /^(?:DATABASE(S)?)/i, /^(?:DATEADD\b)/i, /^(?:DATEDIFF\b)/i, /^(?:DECLARE\b)/i, /^(?:DEFAULT\b)/i, /^(?:DELETE\b)/i, /^(?:DELETED\b)/i, /^(?:DESC\b)/i, /^(?:DETACH\b)/i, /^(?:DISTINCT\b)/i, /^(?:DROP\b)/i, /^(?:ECHO\b)/i, /^(?:EDGE\b)/i, /^(?:END\b)/i, /^(?:ENUM\b)/i, /^(?:ELSE\b)/i, /^(?:ESCAPE\b)/i, /^(?:EXCEPT\b)/i, /^(?:EXEC\b)/i, /^(?:EXECUTE\b)/i, /^(?:EXISTS\b)/i, /^(?:EXPLAIN\b)/i, /^(?:FALSE\b)/i, /^(?:FETCH\b)/i, /^(?:FIRST\b)/i, /^(?:FOR\b)/i, /^(?:FOREIGN\b)/i, /^(?:FROM\b)/i, /^(?:FULL\b)/i, /^(?:FUNCTION\b)/i, /^(?:GLOB\b)/i, /^(?:GO\b)/i, /^(?:GRAPH\b)/i, /^(?:GROUP\b)/i, /^(?:GROUPING\b)/i, /^(?:HAVING\b)/i, /^(?:IF\b)/i, /^(?:IDENTITY\b)/i, /^(?:IS\b)/i, /^(?:IN\b)/i, /^(?:INDEX\b)/i, /^(?:INDEXED\b)/i, /^(?:INNER\b)/i, /^(?:INSTEAD\b)/i, /^(?:INSERT\b)/i, /^(?:INSERTED\b)/i, /^(?:INTERSECT\b)/i, /^(?:INTERVAL\b)/i, /^(?:INTO\b)/i, /^(?:JOIN\b)/i, /^(?:KEY\b)/i, /^(?:LAST\b)/i, /^(?:LET\b)/i, /^(?:LEFT\b)/i, /^(?:LIKE\b)/i, /^(?:LIMIT\b)/i, /^(?:MATCHED\b)/i, /^(?:MATRIX\b)/i, /^(?:MAX(\s+)?(?=\())/i, /^(?:MAX(\s+)?(?=(,|\))))/i, /^(?:MIN(\s+)?(?=\())/i, /^(?:MERGE\b)/i, /^(?:MINUS\b)/i, /^(?:MODIFY\b)/i, /^(?:NATURAL\b)/i, /^(?:NEXT\b)/i, /^(?:NEW\b)/i, /^(?:NOCASE\b)/i, /^(?:NO\b)/i, /^(?:NOT\b)/i, /^(?:NULL\b)/i, /^(?:OFF\b)/i, /^(?:ON\b)/i, /^(?:ONLY\b)/i, /^(?:OF\b)/i, /^(?:OFFSET\b)/i, /^(?:OPEN\b)/i, /^(?:OPTION\b)/i, /^(?:OR\b)/i, /^(?:ORDER\b)/i, /^(?:OUTER\b)/i, /^(?:OVER\b)/i, /^(?:PATH\b)/i, /^(?:PARTITION\b)/i, /^(?:PERCENT\b)/i, /^(?:PIVOT\b)/i, /^(?:PLAN\b)/i, /^(?:PRIMARY\b)/i, /^(?:PRINT\b)/i, /^(?:PRIOR\b)/i, /^(?:QUERY\b)/i, /^(?:READ\b)/i, /^(?:RECORDSET\b)/i, /^(?:REDUCE\b)/i, /^(?:REFERENCES\b)/i, /^(?:REGEXP\b)/i, /^(?:REINDEX\b)/i, /^(?:RELATIVE\b)/i, /^(?:REMOVE\b)/i, /^(?:RENAME\b)/i, /^(?:REPEAT\b)/i, /^(?:REPLACE\b)/i, /^(?:REQUIRE\b)/i, /^(?:RESTORE\b)/i, /^(?:RETURN\b)/i, /^(?:RETURNS\b)/i, /^(?:RIGHT\b)/i, /^(?:ROLLBACK\b)/i, /^(?:ROLLUP\b)/i, /^(?:ROW\b)/i, /^(?:ROWS\b)/i, /^(?:SCHEMA(S)?)/i, /^(?:SEARCH\b)/i, /^(?:SEMI\b)/i, /^(?:SET\b)/i, /^(?:SETS\b)/i, /^(?:SHOW\b)/i, /^(?:SOME\b)/i, /^(?:SOURCE\b)/i, /^(?:STRATEGY\b)/i, /^(?:STORE\b)/i, /^(?:SUM\b)/i, /^(?:TABLE\b)/i, /^(?:TABLES\b)/i, /^(?:TARGET\b)/i, /^(?:TEMP\b)/i, /^(?:TEMPORARY\b)/i, /^(?:TEXTSTRING\b)/i, /^(?:THEN\b)/i, /^(?:TIMEOUT\b)/i, /^(?:TO\b)/i, /^(?:TOP\b)/i, /^(?:TRAN\b)/i, /^(?:TRANSACTION\b)/i, /^(?:TRIGGER\b)/i, /^(?:TRUE\b)/i, /^(?:TRUNCATE\b)/i, /^(?:UNION\b)/i, /^(?:UNIQUE\b)/i, /^(?:UNPIVOT\b)/i, /^(?:UPDATE\b)/i, /^(?:USE\b)/i, /^(?:USING\b)/i, /^(?:VALUE\b)/i, /^(?:VALUES\b)/i, /^(?:VERTEX\b)/i, /^(?:VIEW\b)/i, /^(?:WHEN\b)/i, /^(?:WHERE\b)/i, /^(?:WHILE\b)/i, /^(?:WITH\b)/i, /^(?:WORK\b)/i, /^(?:(\d*[.])?\d+[eE]\d+)/i, /^(?:(\d*[.])?\d+)/i, /^(?:->)/i, /^(?:#)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:\*)/i, /^(?:\/)/i, /^(?:%)/i, /^(?:!===)/i, /^(?:===)/i, /^(?:!==)/i, /^(?:==)/i, /^(?:>=)/i, /^(?:&)/i, /^(?:\|)/i, /^(?:<<)/i, /^(?:>>)/i, /^(?:>)/i, /^(?:<=)/i, /^(?:<>)/i, /^(?:<)/i, /^(?:=)/i, /^(?:!=)/i, /^(?:\()/i, /^(?:\))/i, /^(?:@)/i, /^(?:\{)/i, /^(?:\})/i, /^(?:\])/i, /^(?::-)/i, /^(?:\?-)/i, /^(?:\.\.)/i, /^(?:\.)/i, /^(?:,)/i, /^(?:::)/i, /^(?::)/i, /^(?:;)/i, /^(?:\$)/i, /^(?:\?)/i, /^(?:!)/i, /^(?:\^)/i, /^(?:~)/i, /^(?:[a-zA-Z_][a-zA-Z_0-9]*)/i, /^(?:$)/i, /^(?:.)/i], conditions: { INITIAL: { rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274], inclusive: !0 } }
            }
        }(); return Ei.lexer = mi, e.prototype = Ei, Ei.Parser = e, new e
    }(); void 0 !== y && "undefined" != typeof exports && (exports.parser = N, exports.Parser = N.Parser, exports.parse = function () { return N.parse.apply(N, arguments) }, exports.main = function (e) { e[1] || (console.log("Usage: " + e[0] + " FILE"), process.exit(1)); var t = y("fs").readFileSync(y("path").normalize(e[1]), "utf8"); return exports.parser.parse(t) }, "undefined" != typeof module && y.main === module && exports.main(process.argv.slice(1))), A.prettyflag = !1, A.pretty = function (e, t) { var r = A.prettyflag; A.prettyflag = !t; var n = A.parse(e).toString(); return A.prettyflag = r, n }; var C = A.utils = {}, R = C.escapeq = function (e) { return ("" + e).replace(/["'\\\n\r\u2028\u2029]/g, function (e) { switch (e) { case '"': case "'": case "\\": return "\\" + e; case "\n": return "\\n"; case "\r": return "\\r"; case "\u2028": return "\\u2028"; case "\u2029": return "\\u2029" } }) }, O = C.undoubleq = function (e) { return e.replace(/(\')/g, "''") }, w = C.doubleq = function (e) { return e.replace(/(\'\')/g, "\\'") }, I = (C.doubleqq = function (e) { return e.replace(/\'/g, "'") }, function (e) { return e[0] === String.fromCharCode(65279) && (e = e.substr(1)), e }); C.global = function () { try { return Function("return this")() } catch (t) { var e = self || window || e; if (e) return e; throw new Error("Unable to locate global object") } }(); C.isNativeFunction = function (e) { return "function" == typeof e && !!~e.toString().indexOf("[native code]") }; C.isWebWorker = function () { try { var e = C.global.importScripts; return C.isNativeFunction(e) } catch (e) { return !1 } }(), C.isNode = function () { try { return C.isNativeFunction(C.global.process.reallyExit) } catch (e) { return !1 } }(), C.isBrowser = function () { try { return C.isNativeFunction(C.global.location.reload) } catch (e) { return !1 } }(), C.isBrowserify = function () { return C.isBrowser && "undefined" != typeof process && process.browser }(), C.isRequireJS = function () { return C.isBrowser && "function" == typeof y && "function" == typeof y.specified }(), C.isMeteor = function () { return "undefined" != typeof Meteor && Meteor.release }(), C.isMeteorClient = C.isMeteorClient = function () { return C.isMeteor && Meteor.isClient }(), C.isMeteorServer = function () { return C.isMeteor && Meteor.isServer }(), C.isCordova = function () { return "object" == typeof cordova }(), C.isReactNative = function () { return !1 }(), C.hasIndexedDB = function () { return !!C.global.indexedDB }(), C.isArray = function (e) { return "[object Array]" === Object.prototype.toString.call(e) }; var x = C.loadFile = function (e, t, r, n) { var a; if (C.isNode || C.isMeteorServer); else if (C.isCordova) C.global.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (t) { t.root.getFile(e, { create: !1 }, function (e) { e.file(function (e) { var t = new FileReader; t.onloadend = function (e) { r(I(this.result)) }, t.readAsText(e) }) }) }); else if ("string" == typeof e) if ("#" === e.substr(0, 1) && "undefined" != typeof document) a = document.querySelector(e).textContent, r(a); else { var s = new XMLHttpRequest; s.onreadystatechange = function () { 4 === s.readyState && (200 === s.status ? r && r(I(s.responseText)) : n && n(s)) }, s.open("GET", e, t), s.responseType = "text", s.send() } else if (e instanceof Event) { var i = e.target.files, o = new FileReader; i[0].name; o.onload = function (e) { var t = e.target.result; r(I(t)) }, o.readAsText(i[0]) } }; C.loadBinaryFile = function (e, t, r, n) { if (C.isNode || C.isMeteorServer); else if ("string" == typeof e) { var a = new XMLHttpRequest; a.open("GET", e, t), a.responseType = "arraybuffer", a.onload = function () { for (var e = new Uint8Array(a.response), t = [], n = 0; n < e.length; ++n)t[n] = String.fromCharCode(e[n]); r(t.join("")) }, a.send() } else if (e instanceof Event) { var s = e.target.files, i = new FileReader; s[0].name; i.onload = function (e) { var t = e.target.result; r(t) }, i.readAsArrayBuffer(s[0]) } else e instanceof Blob && r(e) }, C.removeFile = function (e, t) { if (!C.isNode) throw new Error("You can remove files only in Node.js and Apache Cordova") }, C.deleteFile = function (e, t) { }; C.autoExtFilename = function (e, t, r) { return r = r || {}, "string" != typeof e || e.match(/^[A-z]+:\/\/|\n|\..{2,4}$/) || 0 === r.autoExt || !1 === r.autoExt ? e : e + "." + t }; var D = (C.fileExists = function (e, t) { if (!C.isNode) throw new Error("You can use exists() only in Node.js or Apach Cordova") }, C.saveFile = function (e, t, r, n) { var s = 1; if (void 0 === e) s = t, r && (s = r(s)); else if (C.isNode); else if (9 === a()) { var i = t.replace(/\r\n/g, "&#A;&#D;"); i = i.replace(/\n/g, "&#D;"), i = i.replace(/\t/g, "&#9;"); var o = C.global.open("about:blank", "_blank"); o.document.write(i), o.document.close(), o.document.execCommand("SaveAs", !1, e), o.close() } else { var u = { disableAutoBom: !1 }; A.utils.extend(u, n); var c = new Blob([t], { type: "text/plain;charset=utf-8" }); Ee(c, e, u.disableAutoBom), r && (s = r(s)) } return s }, C.hash = function (e) { for (var t = 5381, r = e.length; r;)t = 33 * t ^ e.charCodeAt(--r); return t }), k = C.arrayUnion = function (e, t) { var r = t.slice(0); return e.forEach(function (e) { r.indexOf(e) < 0 && r.push(e) }), r }, L = C.arrayDiff = function (e, t) { return e.filter(function (e) { return t.indexOf(e) < 0 }) }, $ = C.arrayIntersect = function (e, t) { var r = []; return e.forEach(function (e) { var n = !1; t.forEach(function (t) { n = n || e === t }), n && r.push(e) }), r }, M = C.arrayUnionDeep = function (e, t) { var r = t.slice(0); return e.forEach(function (e) { var t = !1; r.forEach(function (r) { t = t || P(e, r) }), t || r.push(e) }), r }, U = C.arrayExceptDeep = function (e, t) { var r = []; return e.forEach(function (e) { var n = !1; t.forEach(function (t) { n = n || P(e, t) }), n || r.push(e) }), r }, _ = C.arrayIntersectDeep = function (e, t) { var r = []; return e.forEach(function (e) { var n = !1; t.forEach(function (t) { n = n || P(e, t, !0) }), n && r.push(e) }), r }, F = C.cloneDeep = function e(t) { if (null === t || "object" != typeof t) return t; if (t instanceof Date) return new Date(t); var r = t.constructor(); for (var n in t) t.hasOwnProperty(n) && (r[n] = e(t[n])); return r }, P = C.deepEqual = function (e, t) { if (e === t) return !0; if ("object" == typeof e && null !== e && "object" == typeof t && null !== t) { if (Object.keys(e).length !== Object.keys(t).length) return !1; for (var r in e) if (!P(e[r], t[r])) return !1; return !0 } return !1 }, q = C.distinctArray = function (e) { for (var t = {}, r = 0, n = e.length; r < n; r++) { var a; a = "object" == typeof e[r] ? Object.keys(e[r]).sort().map(function (t) { return t + "`" + e[r][t] }).join("`") : e[r], t[a] = e[r] } var s = []; for (var i in t) s.push(t[i]); return s }, G = C.extend = function (e, t) { e = e || {}; for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]); return e }, V = C.flatArray = function (e) { if (!e || 0 === e.length) return []; if ("object" == typeof e && e instanceof A.Recordset) return e.data.map(function (t) { return t[e.columns[0].columnid] }); var t = Object.keys(e[0])[0]; return void 0 === t ? [] : e.map(function (e) { return e[t] }) }; C.arrayOfArrays = function (e) { return e.map(function (e) { var t = []; for (var r in e) t.push(e[r]); return t }) }; Array.isArray || (Array.isArray = function (e) { return "[object Array]" === Object.prototype.toString.call(e) }); C.xlsnc = function (e) { var t = String.fromCharCode(65 + e % 26); return e >= 26 && (e = (e / 26 | 0) - 1, t = String.fromCharCode(65 + e % 26) + t, e > 26 && (e = (e / 26 | 0) - 1, t = String.fromCharCode(65 + e % 26) + t)), t }, C.xlscn = function (e) { var t = e.charCodeAt(0) - 65; return e.length > 1 && (t = 26 * (t + 1) + e.charCodeAt(1) - 65, e.length > 2 && (t = 26 * (t + 1) + e.charCodeAt(2) - 65)), t }, C.domEmptyChildren = function (e) { for (var t = e.childNodes.length; t--;)e.removeChild(e.lastChild) }, C.like = function (e, t, r) { r || (r = ""); for (var n = 0, a = "^"; n < e.length;) { var s = e[n], i = ""; n < e.length - 1 && (i = e[n + 1]), s === r ? (a += "\\" + i, n++) : "[" === s && "^" === i ? (a += "[^", n++) : "[" === s || "]" === s ? a += s : "%" === s ? a += ".*" : "_" === s ? a += "." : "/.*+?|(){}".indexOf(s) > -1 ? a += "\\" + s : a += s, n++ } return a += "$", ("" + (t || "")).toUpperCase().search(RegExp(a.toUpperCase())) > -1 }; C.glob = function (e, t) { for (var r = 0, n = "^"; r < t.length;) { var a = t[r], s = ""; r < t.length - 1 && (s = t[r + 1]), "[" === a && "^" === s ? (n += "[^", r++) : "[" === a || "]" === a ? n += a : "*" === a ? n += ".*" : "?" === a ? n += "." : "/.*+?|(){}".indexOf(a) > -1 ? n += "\\" + a : n += a, r++ } return n += "$", ("" + (e || "")).toUpperCase().search(RegExp(n.toUpperCase())) > -1 }, C.findAlaSQLPath = function () { if (C.isWebWorker) return ""; if (C.isMeteorClient) return "/packages/dist/"; if (C.isMeteorServer) return "assets/packages/dist/"; if (C.isNode) return ""; if (C.isBrowser) for (var e = document.getElementsByTagName("script"), t = 0; t < e.length; t++) { if ("alasql-worker.js" === e[t].src.substr(-16).toLowerCase()) return e[t].src.substr(0, e[t].src.length - 16); if ("alasql-worker.min.js" === e[t].src.substr(-20).toLowerCase()) return e[t].src.substr(0, e[t].src.length - 20); if ("alasql.js" === e[t].src.substr(-9).toLowerCase()) return e[t].src.substr(0, e[t].src.length - 9); if ("alasql.min.js" === e[t].src.substr(-13).toLowerCase()) return e[t].src.substr(0, e[t].src.length - 13) } return "" }; var B = function () { var e = null; if (C.isNode || C.isBrowserify || C.isMeteorServer || (e = C.global.XLSX || null), null === e) throw new Error("Please include the xlsx.js library"); return e }, j = function () { return B() }; A.path = A.utils.findAlaSQLPath(), A.utils.uncomment = function (e) { e = ("__" + e + "__").split(""); for (var t, r = !1, n = !1, a = !1, s = 0, i = e.length; s < i; s++) { var o = "\\" !== e[s - 1] || "\\" === e[s - 2]; r ? e[s] === t && o && (r = !1) : n ? "*" === e[s] && "/" === e[s + 1] ? (e[s] = e[s + 1] = "", n = !1, s++) : e[s] = "" : a ? ("\n" !== e[s + 1] && "\r" !== e[s + 1] || (a = !1), e[s] = "") : '"' === e[s] || "'" === e[s] ? (r = !0, t = e[s]) : "[" === e[s] && "@" !== e[s - 1] ? (r = !0, t = "]") : "/" === e[s] && "*" === e[s + 1] && (e[s] = "", n = !0) } return e = e.join("").slice(2, -2) }, A.parser = N, A.parser.parseError = function (e, t) { throw new Error("Have you used a reserved keyword without `escaping` it?\n" + e) }, A.parse = function (e) { return N.parse(A.utils.uncomment(e)) }, A.engines = {}, A.databases = {}, A.databasenum = 0, A.options = {}, A.options.errorlog = !1, A.options.valueof = !1, A.options.dropifnotexists = !1, A.options.datetimeformat = "sql", A.options.casesensitive = !0, A.options.logtarget = "output", A.options.logprompt = !0, A.options.progress = !1, A.options.modifier = void 0, A.options.columnlookup = 10, A.options.autovertex = !0, A.options.usedbo = !0, A.options.autocommit = !0, A.options.cache = !0, A.options.tsql = !0, A.options.mysql = !0, A.options.postgres = !0, A.options.oracle = !0, A.options.sqlite = !0, A.options.orientdb = !0, A.options.nocount = !1, A.options.nan = !1, A.options.joinstar = "overwrite", A.vars = {}, A.declares = {}, A.prompthistory = [], A.plugins = {}, A.from = {}, A.into = {}, A.fn = {}, A.aggr = {}, A.busy = 0, A.MAXSQLCACHESIZE = 1e4, A.DEFAULTDATABASEID = "alasql", A.lastid = 0, A.buffer = {}, A.use = function (e) { if (e || (e = A.DEFAULTDATABASEID), A.useid !== e) { A.useid = e; var t = A.databases[A.useid]; A.tables = t.tables, t.resetSqlCache(), A.options.usedbo && (A.databases.dbo = t) } }, A.autoval = function (e, t, r, n) { var a = n ? A.databases[n] : A.databases[A.useid]; if (!a.tables[e]) throw new Error("Tablename not found: " + e); if (!a.tables[e].identities[t]) throw new Error("Colname not found: " + t); return r ? a.tables[e].identities[t].value || null : a.tables[e].identities[t].value - a.tables[e].identities[t].step || null }, A.exec = function (e, t, r, n) { if ("function" == typeof t && (n = r, r = t, t = {}), delete A.error, t = t || {}, !A.options.errorlog) return A.dexec(A.useid, e, t, r, n); try { return A.dexec(A.useid, e, t, r, n) } catch (e) { A.error = e, r && r(null, A.error) } }, A.dexec = function (e, t, r, n, a) { var s, i = A.databases[e]; if (A.options.cache) { s = D(t); var o = i.sqlCache[s]; if (o && i.dbversion === o.dbversion) return o(r, n) } var u = A.parse(t); if (u.statements) { if (0 === u.statements.length) return 0; if (1 === u.statements.length) { if (u.statements[0].compile) { var o = u.statements[0].compile(e, r); if (!o) return; o.sql = t, o.dbversion = i.dbversion, A.options.cache && (i.sqlCacheSize > A.MAXSQLCACHESIZE && i.resetSqlCache(), i.sqlCacheSize++, i.sqlCache[s] = o); var c = A.res = o(r, n, a); return c } A.precompile(u.statements[0], A.useid, r); var c = A.res = u.statements[0].execute(e, r, n, a); return c } if (!n) return A.drun(e, u, r, n, a); A.adrun(e, u, r, n, a) } }, A.drun = function (e, t, r, n, a) { var s = A.useid; s !== e && A.use(e); for (var i = [], o = 0, u = t.statements.length; o < u; o++)if (t.statements[o]) if (t.statements[o].compile) { var c = t.statements[o].compile(A.useid); i.push(A.res = c(r, null, a)) } else A.precompile(t.statements[o], A.useid, r), i.push(A.res = t.statements[o].execute(A.useid, r)); return s !== e && A.use(s), n && n(i), A.res = i, i }, A.adrun = function (e, t, r, n, a) { function s(l) { void 0 !== l && c.push(l); var h = t.statements.shift(); if (h) if (h.compile) { var d = h.compile(A.useid); d(r, s, a), !1 !== A.options.progress && A.options.progress(o, i++) } else A.precompile(t.statements[0], A.useid, r), h.execute(A.useid, r, s), !1 !== A.options.progress && A.options.progress(o, i++); else u !== e && A.use(u), n(c) } var i = 0, o = t.statements.length; !1 !== A.options.progress && A.options.progress(o, i++); var u = A.useid; u !== e && A.use(e); var c = []; s() }, A.compile = function (e, t) { t = t || A.useid; var r = A.parse(e); if (1 === r.statements.length) { var n = r.statements[0].compile(t); return n.promise = function (e) { return new Promise(function (t, r) { n(e, function (e, n) { n ? r(n) : t(e) }) }) }, n } throw new Error("Cannot compile, because number of statements in SQL is not equal to 1") }, C.global.Promise || C.isNode || function () { "use strict"; function e(e) { return "function" == typeof e || "object" == typeof e && null !== e } function t(e) { return "function" == typeof e } function r(e) { G = e } function n(e) { H = e } function a() { return function () { q(i) } } function s() { return function () { setTimeout(i, 1) } } function i() { for (var e = 0; j > e; e += 2) { (0, Q[e])(Q[e + 1]), Q[e] = void 0, Q[e + 1] = void 0 } j = 0 } function o(e, t) { var r = this, n = new this.constructor(c); void 0 === n[ee] && I(n); var a = r._state; if (a) { var s = arguments[a - 1]; H(function () { R(a, n, s, r._result) }) } else T(r, n, e, t); return n } function u(e) { var t = this; if (e && "object" == typeof e && e.constructor === t) return e; var r = new t(c); return g(r, e), r } function c() { } function l() { return new TypeError("You cannot resolve a promise with itself") } function h() { return new TypeError("A promises callback cannot return that same promise.") } function d(e) { try { return e.then } catch (e) { return ae.error = e, ae } } function f(e, t, r, n) { try { e.call(t, r, n) } catch (e) { return e } } function p(e, t, r) { H(function (e) { var n = !1, a = f(r, t, function (r) { n || (n = !0, t !== r ? g(e, r) : v(e, r)) }, function (t) { n || (n = !0, S(e, t)) }, "Settle: " + (e._label || " unknown promise")); !n && a && (n = !0, S(e, a)) }, e) } function b(e, t) { t._state === re ? v(e, t._result) : t._state === ne ? S(e, t._result) : T(t, void 0, function (t) { g(e, t) }, function (t) { S(e, t) }) } function E(e, r, n) { r.constructor === e.constructor && n === z && constructor.resolve === Z ? b(e, r) : n === ae ? S(e, ae.error) : void 0 === n ? v(e, r) : t(n) ? p(e, r, n) : v(e, r) } function g(t, r) { t === r ? S(t, l()) : e(r) ? E(t, r, d(r)) : v(t, r) } function m(e) { e._onerror && e._onerror(e._result), A(e) } function v(e, t) { e._state === te && (e._result = t, e._state = re, 0 !== e._subscribers.length && H(A, e)) } function S(e, t) { e._state === te && (e._state = ne, e._result = t, H(m, e)) } function T(e, t, r, n) { var a = e._subscribers, s = a.length; e._onerror = null, a[s] = t, a[s + re] = r, a[s + ne] = n, 0 === s && e._state && H(A, e) } function A(e) { var t = e._subscribers, r = e._state; if (0 !== t.length) { for (var n, a, s = e._result, i = 0; i < t.length; i += 3)n = t[i], a = t[i + r], n ? R(r, n, a, s) : a(s); e._subscribers.length = 0 } } function N() { this.error = null } function C(e, t) { try { return e(t) } catch (e) { return se.error = e, se } } function R(e, r, n, a) { var s, i, o, u, c = t(n); if (c) { if (s = C(n, a), s === se ? (u = !0, i = s.error, s = null) : o = !0, r === s) return void S(r, h()) } else s = a, o = !0; r._state !== te || (c && o ? g(r, s) : u ? S(r, i) : e === re ? v(r, s) : e === ne && S(r, s)) } function O(e, t) { try { t(function (t) { g(e, t) }, function (t) { S(e, t) }) } catch (t) { S(e, t) } } function w() { return ie++ } function I(e) { e[ee] = ie++, e._state = void 0, e._result = void 0, e._subscribers = [] } function x(e) { return new he(this, e).promise } function D(e) { var t = this; return new t(B(e) ? function (r, n) { for (var a = e.length, s = 0; a > s; s++)t.resolve(e[s]).then(r, n) } : function (e, t) { t(new TypeError("You must pass an array to race.")) }) } function k(e) { var t = this, r = new t(c); return S(r, e), r } function L() { throw new TypeError("You must pass a resolver function as the first argument to the promise constructor") } function $() { throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.") } function M(e) { this[ee] = w(), this._result = this._state = void 0, this._subscribers = [], c !== e && ("function" != typeof e && L(), this instanceof M ? O(this, e) : $()) } function U(e, t) { this._instanceConstructor = e, this.promise = new e(c), this.promise[ee] || I(this.promise), Array.isArray(t) ? (this._input = t, this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 === this.length ? v(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(), 0 === this._remaining && v(this.promise, this._result))) : S(this.promise, _()) } function _() { return new Error("Array Methods must be provided an Array") } function F() { var e; if ("undefined" != typeof global) e = global; else if ("undefined" != typeof self) e = self; else try { e = Function("return this")() } catch (e) { throw new Error("polyfill failed because global object is unavailable in this environment") } var t = e.Promise; (!t || "[object Promise]" !== Object.prototype.toString.call(t.resolve()) || t.cast) && (e.Promise = le) } var P; P = Array.isArray ? Array.isArray : function (e) { return "[object Array]" === Object.prototype.toString.call(e) }; var q, G, V, B = P, j = 0, H = function (e, t) { Q[j] = e, Q[j + 1] = t, 2 === (j += 2) && (G ? G(i) : V()) }, J = "undefined" != typeof window ? window : void 0, Y = J || {}, W = Y.MutationObserver || Y.WebKitMutationObserver, X = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process), K = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel, Q = new Array(1e3); V = X ? function () { return function () { process.nextTick(i) } }() : W ? function () { var e = 0, t = new W(i), r = document.createTextNode(""); return t.observe(r, { characterData: !0 }), function () { r.data = e = ++e % 2 } }() : K ? function () { var e = new MessageChannel; return e.port1.onmessage = i, function () { e.port2.postMessage(0) } }() : void 0 === J && "function" == typeof y ? function () { try { var e = y, t = e("vertx"); return q = t.runOnLoop || t.runOnContext, a() } catch (e) { return s() } }() : s(); var z = o, Z = u, ee = Math.random().toString(36).substring(16), te = void 0, re = 1, ne = 2, ae = new N, se = new N, ie = 0, oe = x, ue = D, ce = k, le = M; M.all = oe, M.race = ue, M.resolve = Z, M.reject = ce, M._setScheduler = r, M._setAsap = n, M._asap = H, M.prototype = { constructor: M, then: z, catch: function (e) { return this.then(null, e) } }; var he = U; U.prototype._enumerate = function () { for (var e = this.length, t = this._input, r = 0; this._state === te && e > r; r++)this._eachEntry(t[r], r) }, U.prototype._eachEntry = function (e, t) { var r = this._instanceConstructor, n = r.resolve; if (n === Z) { var a = d(e); if (a === z && e._state !== te) this._settledAt(e._state, t, e._result); else if ("function" != typeof a) this._remaining--, this._result[t] = e; else if (r === le) { var s = new r(c); E(s, e, a), this._willSettleAt(s, t) } else this._willSettleAt(new r(function (t) { t(e) }), t) } else this._willSettleAt(n(e), t) }, U.prototype._settledAt = function (e, t, r) { var n = this.promise; n._state === te && (this._remaining--, e === ne ? S(n, r) : this._result[t] = r), 0 === this._remaining && v(n, this._result) }, U.prototype._willSettleAt = function (e, t) { var r = this; T(e, void 0, function (e) { r._settledAt(re, t, e) }, function (e) { r._settledAt(ne, t, e) }) }; var de = F, fe = { Promise: le, polyfill: de }; "function" == typeof define && define.amd ? define(function () { return fe }) : "undefined" != typeof module && module.exports ? module.exports = fe : void 0 !== this && (this.ES6Promise = fe), de() }.call(this); var H = function (e, t, r, n) { return new C.global.Promise(function (a, s) { A(e, t, function (e, t) { t ? s(t) : (r && n && !1 !== A.options.progress && A.options.progress(r, n), a(e)) }) }) }, J = function (e) { if (!(e.length < 1)) { for (var t, r, n, a = [], s = 0; s < e.length; s++) { if (t = e[s], "string" == typeof t && (t = [t]), !C.isArray(t) || t.length < 1 || 2 < t.length) throw new Error("Error in .promise parameter"); r = t[0], n = t[1] || void 0, a.push(H(r, n, s, e.length)) } return C.global.Promise.all(a) } }; A.promise = function (e, t) { if ("undefined" == typeof Promise) throw new Error("Please include a Promise/A+ library"); if ("string" == typeof e) return H(e, t); if (!C.isArray(e) || e.length < 1 || void 0 !== t) throw new Error("Error in .promise parameters"); return J(e) }; var Y = A.Database = function (e) { var t = this; if (t === A) if (e) { if (t = A.databases[e], A.databases[e] = t, !t) throw new Error('Database "' + e + '" not found') } else t = A.databases.alasql, A.options.tsql && (A.databases.tempdb = A.databases.alasql); return e || (e = "db" + A.databasenum++), t.databaseid = e, A.databases[e] = t, t.dbversion = 0, t.tables = {}, t.views = {}, t.triggers = {}, t.indices = {}, t.objects = {}, t.counter = 0, t.resetSqlCache(), t }; Y.prototype.resetSqlCache = function () { this.sqlCache = {}, this.sqlCacheSize = 0 }, Y.prototype.exec = function (e, t, r) { return A.dexec(this.databaseid, e, t, r) }, Y.prototype.autoval = function (e, t, r) { return A.autoval(e, t, r, this.databaseid) }, Y.prototype.transaction = function (e) { return e(new A.Transaction(this.databaseid)) }; var W = A.Transaction = function (e) { return this.transactionid = Date.now(), this.databaseid = e, this.commited = !1, this.dbversion = A.databases[e].dbversion, this.bank = JSON.stringify(A.databases[e]), this }; W.prototype.commit = function () { this.commited = !0, A.databases[this.databaseid].dbversion = Date.now(), delete this.bank }, W.prototype.rollback = function () { if (this.commited) throw new Error("Transaction already commited"); A.databases[this.databaseid] = JSON.parse(this.bank), delete this.bank }, W.prototype.exec = function (e, t, r) { return A.dexec(this.databaseid, e, t, r) }, W.prototype.executeSQL = W.prototype.exec; var X = A.Table = function (e) { this.data = [], this.columns = [], this.xcolumns = {}, this.inddefs = {}, this.indices = {}, this.uniqs = {}, this.uniqdefs = {}, this.identities = {}, this.checks = [], this.checkfns = [], this.beforeinsert = {}, this.afterinsert = {}, this.insteadofinsert = {}, this.beforedelete = {}, this.afterdelete = {}, this.insteadofdelete = {}, this.beforeupdate = {}, this.afterupdate = {}, this.insteadofupdate = {}, G(this, e) }; X.prototype.indexColumns = function () { var e = this; e.xcolumns = {}, e.columns.forEach(function (t) { e.xcolumns[t.columnid] = t }) }; var K = (A.View = function (e) { this.columns = [], this.xcolumns = {}, this.query = [], G(this, e) }, A.Query = function (e) { this.alasql = A, this.columns = [], this.xcolumns = {}, this.selectGroup = [], this.groupColumns = {}, G(this, e) }), Q = (A.Recordset = function (e) { G(this, e) }, N.yy = A.yy = {}); Q.extend = G, Q.casesensitive = A.options.casesensitive; var z = Q.Base = function (e) { return Q.extend(this, e) }; z.prototype.toString = function () { }, z.prototype.toType = function () { }, z.prototype.toJS = function () { }, z.prototype.compile = n, z.prototype.exec = function () { }, z.prototype.compile = n, z.prototype.exec = function () { }, Q.Statements = function (e) { return Q.extend(this, e) }, Q.Statements.prototype.toString = function () { return this.statements.map(function (e) { return e.toString() }).join("; ") }, Q.Statements.prototype.compile = function (e) { var t = this.statements.map(function (t) { return t.compile(e) }); return 1 === t.length ? t[0] : function (e, r) { var n = t.map(function (t) { return t(e) }); return r && r(n), n } }, Q.Search = function (e) { return Q.extend(this, e) }, Q.Search.prototype.toString = function () { var e = "SEARCH "; return this.selectors && (e += this.selectors.toString()), this.from && (e += "FROM " + this.from.toString()), e }, Q.Search.prototype.toJS = function (e) { return "this.queriesfn[" + (this.queriesidx - 1) + "](this.params,null," + e + ")" }, Q.Search.prototype.compile = function (e) { var t = e, r = this, n = function (e, a) { var s; return i.bind(r)(t, e, function (e) { s = f(n.query, e), a && (s = a(s)) }), s }; return n.query = {}, n }, A.srch = {}, A.srch.PROP = function (e, t, r) { if ("XML" === r.mode) { var n = []; return e.children.forEach(function (e) { e.name.toUpperCase() === t[0].toUpperCase() && n.push(e) }), n.length > 0 ? { status: 1, values: n } : { status: -1, values: [] } } return "object" != typeof e || null === e || "object" != typeof t || void 0 === e[t[0]] ? { status: -1, values: [] } : { status: 1, values: [e[t[0]]] } }, A.srch.APROP = function (e, t) { return "object" != typeof e || null === e || "object" != typeof t || void 0 === e[t[0]] ? { status: 1, values: [void 0] } : { status: 1, values: [e[t[0]]] } }, A.srch.EQ = function (e, t, r, n) { var a = t[0].toJS("x", ""); return e === new Function("x,alasql,params", "return " + a)(e, A, n) ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.LIKE = function (e, t, r, n) { var a = t[0].toJS("x", ""), s = new Function("x,alasql,params", "return " + a); return e.toUpperCase().match(new RegExp("^" + s(e, A, n).toUpperCase().replace(/%/g, ".*").replace(/\?|_/g, ".") + "$"), "g") ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.ATTR = function (e, t, r) { if ("XML" === r.mode) return void 0 === t ? { status: 1, values: [e.attributes] } : "object" == typeof e && "object" == typeof e.attributes && void 0 !== e.attributes[t[0]] ? { status: 1, values: [e.attributes[t[0]]] } : { status: -1, values: [] }; throw new Error("ATTR is not using in usual mode") }, A.srch.CONTENT = function (e, t, r) { if ("XML" === r.mode) return { status: 1, values: [e.content] }; throw new Error("ATTR is not using in usual mode") }, A.srch.SHARP = function (e, t) { var r = A.databases[A.useid].objects[t[0]]; return void 0 !== e && e === r ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.PARENT = function () { return console.log("PARENT not implemented", arguments), { status: -1, values: [] } }, A.srch.CHILD = function (e, t, r) { return "object" == typeof e ? Array.isArray(e) ? { status: 1, values: e } : "XML" === r.mode ? { status: 1, values: Object.keys(e.children).map(function (t) { return e.children[t] }) } : { status: 1, values: Object.keys(e).map(function (t) { return e[t] }) } : { status: 1, values: [] } }, A.srch.KEYS = function (e) { return "object" == typeof e && null !== e ? { status: 1, values: Object.keys(e) } : { status: 1, values: [] } }, A.srch.WHERE = function (e, t, r, n) { var a = t[0].toJS("x", ""); return new Function("x,alasql,params", "return " + a)(e, A, n) ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.NAME = function (e, t) { return e.name === t[0] ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.CLASS = function (e, t) { return e.$class == t ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.VERTEX = function (e) { return "VERTEX" === e.$node ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.INSTANCEOF = function (e, t) { return e instanceof A.fn[t[0]] ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.EDGE = function (e) { return "EDGE" === e.$node ? { status: 1, values: [e] } : { status: -1, values: [] } }, A.srch.EX = function (e, t, r, n) { var a = t[0].toJS("x", ""); return { status: 1, values: [new Function("x,alasql,params", "return " + a)(e, A, n)] } }, A.srch.RETURN = function (e, t, r, n) { var a = {}; return t && t.length > 0 && t.forEach(function (t) { var r = t.toJS("x", ""), s = new Function("x,alasql,params", "return " + r); void 0 === t.as && (t.as = t.toString()), a[t.as] = s(e, A, n) }), { status: 1, values: [a] } }, A.srch.REF = function (e) { return { status: 1, values: [A.databases[A.useid].objects[e]] } }, A.srch.OUT = function (e) { if (e.$out && e.$out.length > 0) { return { status: 1, values: e.$out.map(function (e) { return A.databases[A.useid].objects[e] }) } } return { status: -1, values: [] } }, A.srch.OUTOUT = function (e) { if (e.$out && e.$out.length > 0) { var t = []; return e.$out.forEach(function (e) { var r = A.databases[A.useid].objects[e]; r && r.$out && r.$out.length > 0 && r.$out.forEach(function (e) { t = t.concat(A.databases[A.useid].objects[e]) }) }), { status: 1, values: t } } return { status: -1, values: [] } }, A.srch.IN = function (e) { if (e.$in && e.$in.length > 0) { return { status: 1, values: e.$in.map(function (e) { return A.databases[A.useid].objects[e] }) } } return { status: -1, values: [] } }, A.srch.ININ = function (e) { if (e.$in && e.$in.length > 0) { var t = []; return e.$in.forEach(function (e) { var r = A.databases[A.useid].objects[e]; r && r.$in && r.$in.length > 0 && r.$in.forEach(function (e) { t = t.concat(A.databases[A.useid].objects[e]) }) }), { status: 1, values: t } } return { status: -1, values: [] } }, A.srch.AS = function (e, t) { return A.vars[t[0]] = e, { status: 1, values: [e] } }, A.srch.AT = function (e, t) { return { status: 1, values: [A.vars[t[0]]] } }, A.srch.CLONEDEEP = function (e) {
        return {
            status: 1, values: [F(e)]
        }
    }, A.srch.SET = function (e, t, r, n) { var a = t.map(function (e) { return "@" === e.method ? "alasql.vars['" + e.variable + "']=" + e.expression.toJS("x", "") : "$" === e.method ? "params['" + e.variable + "']=" + e.expression.toJS("x", "") : "x['" + e.column.columnid + "']=" + e.expression.toJS("x", "") }).join(";"); return new Function("x,params,alasql", a)(e, n, A), { status: 1, values: [e] } }, A.srch.ROW = function (e, t, r, n) { var a = "var y;return ["; return a += t.map(function (e) { return e.toJS("x", "") }).join(","), a += "]", { status: 1, values: [new Function("x,params,alasql", a)(e, n, A)] } }, A.srch.D3 = function (e) { return "VERTEX" !== e.$node && "EDGE" === e.$node && (e.source = e.$in[0], e.target = e.$out[0]), { status: 1, values: [e] } }; var Z = function (e) { if (e) { if (e && 1 === e.length && e[0].expression && "function" == typeof e[0].expression) { var t = e[0].expression; return function (e, r) { var n = t(e), a = t(r); return n > a ? 1 : n === a ? 0 : -1 } } var r = "", n = ""; return e.forEach(function (e) { var t = ""; if (e.expression instanceof Q.NumValue && (e.expression = self.columns[e.expression.value - 1]), e.expression instanceof Q.Column) { var a = e.expression.columnid; A.options.valueof && (t = ".valueOf()"), e.nocase && (t += ".toUpperCase()"), "_" === a ? (r += "if(a" + t + ("ASC" === e.direction ? ">" : "<") + "b" + t + ")return 1;", r += "if(a" + t + "==b" + t + "){") : (r += "if((a['" + a + "']||'')" + t + ("ASC" === e.direction ? ">" : "<") + "(b['" + a + "']||'')" + t + ")return 1;", r += "if((a['" + a + "']||'')" + t + "==(b['" + a + "']||'')" + t + "){") } else t = ".valueOf()", e.nocase && (t += ".toUpperCase()"), r += "if((" + e.toJS("a", "") + "||'')" + t + ("ASC" === e.direction ? ">(" : "<(") + e.toJS("b", "") + "||'')" + t + ")return 1;", r += "if((" + e.toJS("a", "") + "||'')" + t + "==(" + e.toJS("b", "") + "||'')" + t + "){"; n += "}" }), r += "return 0;", r += n + "return -1", new Function("a,b", r) } }; A.srch.ORDERBY = function (e, t) { return { status: 1, values: e.sort(Z(t)) } }; var ee = function (e) { for (var t = 0, r = e.sources.length; t < r; t++) { var n = e.sources[t]; if (delete n.ix, t > 0 && "ix" == n.optimization && n.onleftfn && n.onrightfn) { if (n.databaseid && A.databases[n.databaseid].tables[n.tableid]) { A.databases[n.databaseid].tables[n.tableid].indices || (e.database.tables[n.tableid].indices = {}); var a = A.databases[n.databaseid].tables[n.tableid].indices[D(n.onrightfns + "`" + n.srcwherefns)]; !A.databases[n.databaseid].tables[n.tableid].dirty && a && (n.ix = a) } if (!n.ix) { n.ix = {}; for (var s, i = {}, o = 0, u = n.data.length; (s = n.data[o]) || n.getfn && (s = n.getfn(o)) || o < u;) { if (n.getfn && !n.dontcache && (n.data[o] = s), i[n.alias || n.tableid] = s, n.srcwherefn(i, e.params, A)) { var c = n.onrightfn(i, e.params, A), l = n.ix[c]; l || (l = n.ix[c] = []), l.push(s) } o++ } n.databaseid && A.databases[n.databaseid].tables[n.tableid] && (A.databases[n.databaseid].tables[n.tableid].indices[D(n.onrightfns + "`" + n.srcwherefns)] = n.ix) } } else if (n.wxleftfn) { if (A.databases[n.databaseid].engineid || (a = A.databases[n.databaseid].tables[n.tableid].indices[D(n.wxleftfns + "`")]), !A.databases[n.databaseid].tables[n.tableid].dirty && a) n.ix = a, n.data = n.ix[n.wxrightfn(null, e.params, A)]; else { for (n.ix = {}, i = {}, o = 0, u = n.data.length; (s = n.data[o]) || n.getfn && (s = n.getfn(o)) || o < u;)n.getfn && !n.dontcache && (n.data[o] = s), i[n.alias || n.tableid] = n.data[o], c = n.wxleftfn(i, e.params, A), l = n.ix[c], l || (l = n.ix[c] = []), l.push(n.data[o]), o++; A.databases[n.databaseid].engineid || (A.databases[n.databaseid].tables[n.tableid].indices[D(n.wxleftfns + "`")] = n.ix) } n.srcwherefns && (n.data ? (i = {}, n.data = n.data.filter(function (t) { return i[n.alias] = t, n.srcwherefn(i, e.params, A) })) : n.data = []) } else if (n.srcwherefns && !n.dontcache) if (n.data) { var i = {}; n.data = n.data.filter(function (t) { return i[n.alias] = t, n.srcwherefn(i, e.params, A) }), i = {}, o = 0, u = n.data.length; for (var h = []; (s = n.data[o]) || n.getfn && (s = n.getfn(o)) || o < u;)n.getfn && !n.dontcache && (n.data[o] = s), i[n.alias] = s, n.srcwherefn(i, e.params, A) && h.push(s), o++; n.data = h } else n.data = []; n.databaseid && A.databases[n.databaseid].tables[n.tableid] } }; Q.Select = function (e) { return Q.extend(this, e) }, Q.Select.prototype.toString = function () { var e; return e = "", this.explain && (e += "EXPLAIN "), e += "SELECT ", this.modifier && (e += this.modifier + " "), this.distinct && (e += "DISTINCT "), this.top && (e += "TOP " + this.top.value + " ", this.percent && (e += "PERCENT ")), e += this.columns.map(function (e) { var t; return t = e.toString(), void 0 !== e.as && (t += " AS " + e.as), t }).join(", "), this.from && (e += " FROM " + this.from.map(function (e) { var t; return t = e.toString(), e.as && (t += " AS " + e.as), t }).join(",")), this.joins && (e += this.joins.map(function (e) { var t; if (t = " ", e.joinmode && (t += e.joinmode + " "), e.table) t += "JOIN " + e.table.toString(); else if (e.select) t += "JOIN (" + e.select.toString() + ")"; else { if (!(e instanceof A.yy.Apply)) throw new Error("Wrong type in JOIN mode"); t += e.toString() } return e.as && (t += " AS " + e.as), e.using && (t += " USING " + e.using.toString()), e.on && (t += " ON " + e.on.toString()), t })), this.where && (e += " WHERE " + this.where.toString()), this.group && this.group.length > 0 && (e += " GROUP BY " + this.group.map(function (e) { return e.toString() }).join(", ")), this.having && (e += " HAVING " + this.having.toString()), this.order && this.order.length > 0 && (e += " ORDER BY " + this.order.map(function (e) { return e.toString() }).join(", ")), this.limit && (e += " LIMIT " + this.limit.value), this.offset && (e += " OFFSET " + this.offset.value), this.union && (e += " UNION " + (this.corresponding ? "CORRESPONDING " : "") + this.union.toString()), this.unionall && (e += " UNION ALL " + (this.corresponding ? "CORRESPONDING " : "") + this.unionall.toString()), this.except && (e += " EXCEPT " + (this.corresponding ? "CORRESPONDING " : "") + this.except.toString()), this.intersect && (e += " INTERSECT " + (this.corresponding ? "CORRESPONDING " : "") + this.intersect.toString()), e }, Q.Select.prototype.toJS = function (e) { return "alasql.utils.flatArray(this.queriesfn[" + (this.queriesidx - 1) + "](this.params,null," + e + "))[0]" }, Q.Select.prototype.compile = function (e, t) { var r = A.databases[e], n = new K; if (n.removeKeys = [], n.aggrKeys = [], n.explain = this.explain, n.explaination = [], n.explid = 1, n.modifier = this.modifier, n.database = r, this.compileWhereExists(n), this.compileQueries(n), n.defcols = this.compileDefCols(n, e), n.fromfn = this.compileFrom(n), this.joins && this.compileJoins(n), n.rownums = [], this.compileSelectGroup0(n), this.group || n.selectGroup.length > 0 ? n.selectgfns = this.compileSelectGroup1(n) : n.selectfns = this.compileSelect1(n, t), this.compileRemoveColumns(n), this.where && this.compileWhereJoins(n), n.wherefn = this.compileWhere(n), (this.group || n.selectGroup.length > 0) && (n.groupfn = this.compileGroup(n)), this.having && (n.havingfn = this.compileHaving(n)), this.order && (n.orderfn = this.compileOrder(n)), this.group || n.selectGroup.length > 0 ? n.selectgfn = this.compileSelectGroup2(n) : n.selectfn = this.compileSelect2(n), n.distinct = this.distinct, this.pivot && (n.pivotfn = this.compilePivot(n)), this.unpivot && (n.pivotfn = this.compileUnpivot(n)), this.top ? n.limit = this.top.value : this.limit && (n.limit = this.limit.value, this.offset && (n.offset = this.offset.value)), n.percent = this.percent, n.corresponding = this.corresponding, this.union ? (n.unionfn = this.union.compile(e), this.union.order ? n.orderfn = this.union.compileOrder(n) : n.orderfn = null) : this.unionall ? (n.unionallfn = this.unionall.compile(e), this.unionall.order ? n.orderfn = this.unionall.compileOrder(n) : n.orderfn = null) : this.except ? (n.exceptfn = this.except.compile(e), this.except.order ? n.orderfn = this.except.compileOrder(n) : n.orderfn = null) : this.intersect && (n.intersectfn = this.intersect.compile(e), this.intersect.order ? n.intersectfn = this.intersect.compileOrder(n) : n.orderfn = null), this.into) { if (this.into instanceof Q.Table) A.options.autocommit && A.databases[this.into.databaseid || e].engineid ? n.intoallfns = 'return alasql.engines["' + A.databases[this.into.databaseid || e].engineid + '"].intoTable("' + (this.into.databaseid || e) + '","' + this.into.tableid + '",this.data, columns, cb);' : n.intofns = "alasql.databases['" + (this.into.databaseid || e) + "'].tables['" + this.into.tableid + "'].data.push(r);"; else if (this.into instanceof Q.VarValue) n.intoallfns = 'alasql.vars["' + this.into.variable + '"]=this.data;res=this.data.length;if(cb)res=cb(res);return res;'; else if (this.into instanceof Q.FuncValue) { var a = "return alasql.into['" + this.into.funcid.toUpperCase() + "']("; this.into.args && this.into.args.length > 0 ? (a += this.into.args[0].toJS() + ",", this.into.args.length > 1 ? a += this.into.args[1].toJS() + "," : a += "undefined,") : a += "undefined, undefined,", n.intoallfns = a + "this.data,columns,cb)" } else this.into instanceof Q.ParamValue && (n.intofns = "params['" + this.into.param + "'].push(r)"); n.intofns ? n.intofn = new Function("r,i,params,alasql", "var y;" + n.intofns) : n.intoallfns && (n.intoallfn = new Function("columns,cb,params,alasql", "var y;" + n.intoallfns)) } var s = function (e, t, r) { return n.params = e, o(n, r, function (e) { if (n.rownums.length > 0) for (var r = 0, a = e.length; r < a; r++)for (var s = 0, i = n.rownums.length; s < i; s++)e[r][n.rownums[s]] = r + 1; var o = f(n, e); return t && t(o), o }) }; return s.query = n, s }, Q.Select.prototype.execute = function (e, t, r) { return this.compile(e)(t, r) }, Q.ExistsValue = function (e) { return Q.extend(this, e) }, Q.ExistsValue.prototype.toString = function () { return "EXISTS(" + this.value.toString() + ")" }, Q.ExistsValue.prototype.toType = function () { return "boolean" }, Q.ExistsValue.prototype.toJS = function (e, t, r) { return "this.existsfn[" + this.existsidx + "](params,null," + e + ").data.length" }, Q.Select.prototype.compileWhereExists = function (e) { this.exists && (e.existsfn = this.exists.map(function (t) { var r = t.compile(e.database.databaseid); return r.query.modifier = "RECORDSET", r })) }, Q.Select.prototype.compileQueries = function (e) { this.queries && (e.queriesfn = this.queries.map(function (t) { var r = t.compile(e.database.databaseid); return r.query.modifier = "RECORDSET", r })) }, A.precompile = function (e, t, r) { e && (e.params = r, e.queries && (e.queriesfn = e.queries.map(function (r) { var n = r.compile(t || e.database.databaseid); return n.query.modifier = "RECORDSET", n })), e.exists && (e.existsfn = e.exists.map(function (r) { var n = r.compile(t || e.database.databaseid); return n.query.modifier = "RECORDSET", n }))) }, Q.Select.prototype.compileFrom = function (e) { var t = this; e.sources = [], e.aliases = {}, t.from && (t.from.forEach(function (t) { var n = t.as || t.tableid; if (t instanceof Q.Table) e.aliases[n] = { tableid: t.tableid, databaseid: t.databaseid || e.database.databaseid, type: "table" }; else if (t instanceof Q.Select) e.aliases[n] = { type: "subquery" }; else if (t instanceof Q.Search) e.aliases[n] = { type: "subsearch" }; else if (t instanceof Q.ParamValue) e.aliases[n] = { type: "paramvalue" }; else if (t instanceof Q.FuncValue) e.aliases[n] = { type: "funcvalue" }; else if (t instanceof Q.VarValue) e.aliases[n] = { type: "varvalue" }; else if (t instanceof Q.FromData) e.aliases[n] = { type: "fromdata" }; else if (t instanceof Q.Json) e.aliases[n] = { type: "json" }; else { if (!t.inserted) throw new Error("Wrong table at FROM"); e.aliases[n] = { type: "inserted" } } var a = { alias: n, databaseid: t.databaseid || e.database.databaseid, tableid: t.tableid, joinmode: "INNER", onmiddlefn: r, srcwherefns: "", srcwherefn: r }; if (t instanceof Q.Table) a.columns = A.databases[a.databaseid].tables[a.tableid].columns, A.options.autocommit && A.databases[a.databaseid].engineid && !A.databases[a.databaseid].tables[a.tableid].view ? a.datafn = function (e, t, r, n, s) { return s.engines[s.databases[a.databaseid].engineid].fromTable(a.databaseid, a.tableid, r, n, e) } : A.databases[a.databaseid].tables[a.tableid].view ? a.datafn = function (e, t, r, n, s) { var i = s.databases[a.databaseid].tables[a.tableid].select(t); return r && (i = r(i, n, e)), i } : a.datafn = function (e, t, r, n, s) { var i = s.databases[a.databaseid].tables[a.tableid].data; return r && (i = r(i, n, e)), i }; else if (t instanceof Q.Select) a.subquery = t.compile(e.database.databaseid), void 0 === a.subquery.query.modifier && (a.subquery.query.modifier = "RECORDSET"), a.columns = a.subquery.query.columns, a.datafn = function (e, t, r, n, s) { var i; return a.subquery(e.params, function (t) { return i = t.data, r && (i = r(i, n, e)), i }), i }; else if (t instanceof Q.Search) a.subsearch = t, a.columns = [], a.datafn = function (e, t, r, n, s) { var i; return a.subsearch.execute(e.database.databaseid, e.params, function (t) { return i = t, r && (i = r(i, n, e)), i }), i }; else if (t instanceof Q.ParamValue) { var s = "var res = alasql.prepareFromData(params['" + t.param + "']"; t.array && (s += ",true"), s += ");if(cb)res=cb(res,idx,query);return res", a.datafn = new Function("query,params,cb,idx,alasql", s) } else if (t.inserted) { var s = "var res = alasql.prepareFromData(alasql.inserted"; t.array && (s += ",true"), s += ");if(cb)res=cb(res,idx,query);return res", a.datafn = new Function("query,params,cb,idx,alasql", s) } else if (t instanceof Q.Json) { var s = "var res = alasql.prepareFromData(" + t.toJS(); t.array && (s += ",true"), s += ");if(cb)res=cb(res,idx,query);return res", a.datafn = new Function("query,params,cb,idx,alasql", s) } else if (t instanceof Q.VarValue) { var s = "var res = alasql.prepareFromData(alasql.vars['" + t.variable + "']"; t.array && (s += ",true"), s += ");if(cb)res=cb(res,idx,query);return res", a.datafn = new Function("query,params,cb,idx,alasql", s) } else if (t instanceof Q.FuncValue) { var i = "var res=alasql.from['" + t.funcid.toUpperCase() + "']("; t.args && t.args.length > 0 ? (t.args[0] ? i += t.args[0].toJS("query.oldscope") + "," : i += "null,", t.args[1] ? i += t.args[1].toJS("query.oldscope") + "," : i += "null,") : i += "null,null,", i += "cb,idx,query", i += ");/*if(cb)res=cb(res,idx,query);*/return res", a.datafn = new Function("query, params, cb, idx, alasql", i) } else { if (!(t instanceof Q.FromData)) throw new Error("Wrong table at FROM"); a.datafn = function (e, r, n, a, s) { var i = t.data; return n && (i = n(i, a, e)), i } } e.sources.push(a) }), e.defaultTableid = e.sources[0].alias) }, A.prepareFromData = function (e, t) { var r = e; if ("string" == typeof e) { if (r = e.split(/\r?\n/), t) for (var n = 0, a = r.length; n < a; n++)r[n] = [r[n]] } else if (t) { r = []; for (var n = 0, a = e.length; n < a; n++)r.push([e[n]]) } else if ("object" == typeof e && !Array.isArray(e)) if ("undefined" != typeof Mongo && void 0 !== Mongo.Collection && e instanceof Mongo.Collection) r = e.find().fetch(); else { r = []; for (var s in e) e.hasOwnProperty(s) && r.push([s, e[s]]) } return r }, Q.Select.prototype.compileJoins = function (e) { this.joins.forEach(function (t) { if ("CROSS" == t.joinmode) { if (t.using || t.on) throw new Error("CROSS JOIN cannot have USING or ON clauses"); t.joinmode } var n, a; if (t instanceof Q.Apply) n = { alias: t.as, applymode: t.applymode, onmiddlefn: r, srcwherefns: "", srcwherefn: r, columns: [] }, n.applyselect = t.select.compile(e.database.databaseid), n.columns = n.applyselect.query.columns, n.datafn = function (e, t, r, n, a) { var s; return r && (s = r(s, n, e)), s }, e.sources.push(n); else { if (t.table) { if (a = t.table, n = { alias: t.as || a.tableid, databaseid: a.databaseid || e.database.databaseid, tableid: a.tableid, joinmode: t.joinmode, onmiddlefn: r, srcwherefns: "", srcwherefn: r, columns: [] }, !A.databases[n.databaseid].tables[n.tableid]) throw new Error("Table '" + n.tableid + "' is not exists in database '" + n.databaseid) + "'"; n.columns = A.databases[n.databaseid].tables[n.tableid].columns, A.options.autocommit && A.databases[n.databaseid].engineid ? n.datafn = function (e, t, r, a, s) { return s.engines[s.databases[n.databaseid].engineid].fromTable(n.databaseid, n.tableid, r, a, e) } : A.databases[n.databaseid].tables[n.tableid].view ? n.datafn = function (e, t, r, a, s) { var i = s.databases[n.databaseid].tables[n.tableid].select(t); return r && (i = r(i, a, e)), i } : n.datafn = function (e, t, r, a, s) { var i = s.databases[n.databaseid].tables[n.tableid].data; return r && (i = r(i, a, e)), i }, e.aliases[n.alias] = { tableid: a.tableid, databaseid: a.databaseid || e.database.databaseid } } else if (t.select) { var a = t.select; n = { alias: t.as, joinmode: t.joinmode, onmiddlefn: r, srcwherefns: "", srcwherefn: r, columns: [] }, n.subquery = a.compile(e.database.databaseid), void 0 === n.subquery.query.modifier && (n.subquery.query.modifier = "RECORDSET"), n.columns = n.subquery.query.columns, n.datafn = function (e, t, r, a, s) { return n.subquery(e.params, null, r, a).data }, e.aliases[n.alias] = { type: "subquery" } } else if (t.param) { n = { alias: t.as, joinmode: t.joinmode, onmiddlefn: r, srcwherefns: "", srcwherefn: r }; var s = t.param.param, i = "var res=alasql.prepareFromData(params['" + s + "']"; t.array && (i += ",true"), i += ");if(cb)res=cb(res, idx, query);return res", n.datafn = new Function("query,params,cb,idx, alasql", i), e.aliases[n.alias] = { type: "paramvalue" } } else if (t.variable) { n = { alias: t.as, joinmode: t.joinmode, onmiddlefn: r, srcwherefns: "", srcwherefn: r }; var i = "var res=alasql.prepareFromData(alasql.vars['" + t.variable + "']"; t.array && (i += ",true"), i += ");if(cb)res=cb(res, idx, query);return res", n.datafn = new Function("query,params,cb,idx, alasql", i), e.aliases[n.alias] = { type: "varvalue" } } else if (t.funcid) { n = { alias: t.as, joinmode: t.joinmode, onmiddlefn: r, srcwherefns: "", srcwherefn: r }; var o = "var res=alasql.from['" + js.funcid.toUpperCase() + "']("; t.args && t.args.length > 0 ? (t.args[0] ? o += t.args[0].toJS("query.oldscope") + "," : o += "null,", t.args[1] ? o += t.args[1].toJS("query.oldscope") + "," : o += "null,") : o += "null,null,", o += "cb,idx,query", o += ");/*if(cb)res=cb(res,idx,query);*/return res", n.datafn = new Function("query, params, cb, idx, alasql", o), e.aliases[n.alias] = { type: "funcvalue" } } var u = n.alias; if (t.natural) { if (t.using || t.on) throw new Error("NATURAL JOIN cannot have USING or ON clauses"); if (e.sources.length > 0) { var c = e.sources[e.sources.length - 1], l = A.databases[c.databaseid].tables[c.tableid], h = A.databases[n.databaseid].tables[n.tableid]; if (!l || !h) throw new Error("In this version of Alasql NATURAL JOIN works for tables with predefined columns only"); var d = l.columns.map(function (e) { return e.columnid }), f = h.columns.map(function (e) { return e.columnid }); t.using = $(d, f).map(function (e) { return { columnid: e } }) } } if (t.using) { var c = e.sources[e.sources.length - 1]; n.onleftfns = t.using.map(function (e) { return "p['" + (c.alias || c.tableid) + "']['" + e.columnid + "']" }).join('+"`"+'), n.onleftfn = new Function("p,params,alasql", "var y;return " + n.onleftfns), n.onrightfns = t.using.map(function (e) { return "p['" + (n.alias || n.tableid) + "']['" + e.columnid + "']" }).join('+"`"+'), n.onrightfn = new Function("p,params,alasql", "var y;return " + n.onrightfns), n.optimization = "ix" } else if (t.on) if (t.on instanceof Q.Op && "=" == t.on.op && !t.on.allsome) { n.optimization = "ix"; var p = "", b = "", E = "", g = !1, m = t.on.left.toJS("p", e.defaultTableid, e.defcols), v = t.on.right.toJS("p", e.defaultTableid, e.defcols); m.indexOf("p['" + u + "']") > -1 && !(v.indexOf("p['" + u + "']") > -1) ? (m.match(/p\[\'.*?\'\]/g) || []).every(function (e) { return e == "p['" + u + "']" }) ? b = m : g = !0 : !(m.indexOf("p['" + u + "']") > -1) && v.indexOf("p['" + u + "']") > -1 && (v.match(/p\[\'.*?\'\]/g) || []).every(function (e) { return e == "p['" + u + "']" }) ? p = m : g = !0, v.indexOf("p['" + u + "']") > -1 && !(m.indexOf("p['" + u + "']") > -1) ? (v.match(/p\[\'.*?\'\]/g) || []).every(function (e) { return e == "p['" + u + "']" }) ? b = v : g = !0 : !(v.indexOf("p['" + u + "']") > -1) && m.indexOf("p['" + u + "']") > -1 && (m.match(/p\[\'.*?\'\]/g) || []).every(function (e) { return e == "p['" + u + "']" }) ? p = v : g = !0, g && (b = "", p = "", E = t.on.toJS("p", e.defaultTableid, e.defcols), n.optimization = "no"), n.onleftfns = p, n.onrightfns = b, n.onmiddlefns = E || "true", n.onleftfn = new Function("p,params,alasql", "var y;return " + n.onleftfns), n.onrightfn = new Function("p,params,alasql", "var y;return " + n.onrightfns), n.onmiddlefn = new Function("p,params,alasql", "var y;return " + n.onmiddlefns) } else n.optimization = "no", n.onmiddlefns = t.on.toJS("p", e.defaultTableid, e.defcols), n.onmiddlefn = new Function("p,params,alasql", "var y;return " + t.on.toJS("p", e.defaultTableid, e.defcols)); e.sources.push(n) } }) }, Q.Select.prototype.compileWhere = function (e) { if (this.where) { if ("function" == typeof this.where) return this.where; var t = this.where.toJS("p", e.defaultTableid, e.defcols); return e.wherefns = t, new Function("p,params,alasql", "var y;return " + t) } return function () { return !0 } }, Q.Select.prototype.compileWhereJoins = function (e) { }, Q.Select.prototype.compileGroup = function (e) { if (e.sources.length > 0) var t = e.sources[0].alias; else var t = ""; var r = e.defcols, n = [[]]; this.group && (n = b(this.group, e)); var a = []; n.forEach(function (e) { a = k(a, e) }), e.allgroups = a, e.ingroup = []; var s = ""; return n.forEach(function (n) { s += "var g=this.xgroups["; var i = n.map(function (t) { var r = t.split("\t")[0], n = t.split("\t")[1]; return "" === r ? "1" : (e.ingroup.push(r), n) }); 0 === i.length && (i = ["''"]), s += i.join('+"`"+'), s += "];if(!g) {this.groups.push((g=this.xgroups[", s += i.join('+"`"+'), s += "] = {", s += n.map(function (e) { var t = e.split("\t")[0], r = e.split("\t")[1]; return "" === t ? "" : "'" + t + "':" + r + "," }).join(""); var o = L(a, n); s += o.map(function (e) { return "'" + e.split("\t")[0] + "':null," }).join(""); var u = "", c = ""; void 0 !== e.groupStar && (c += "for(var f in p['" + e.groupStar + "']) {g[f]=p['" + e.groupStar + "'][f];};"), s += e.selectGroup.map(function (n) { var a = n.expression.toJS("p", t, r), s = n.nick; return n instanceof Q.AggrValue ? (n.distinct && (u += ",g['$$_VALUES_" + s + "']={},g['$$_VALUES_" + s + "'][" + a + "]=true"), "SUM" === n.aggregatorid ? "'" + s + "':(" + a + ")||0," : "MIN" === n.aggregatorid || "MAX" === n.aggregatorid || "FIRST" === n.aggregatorid || "LAST" === n.aggregatorid ? "'" + s + "':" + a + "," : "ARRAY" === n.aggregatorid ? "'" + s + "':[" + a + "]," : "COUNT" === n.aggregatorid ? "*" === n.expression.columnid ? "'" + s + "':1," : "'" + s + "':(typeof " + a + ' != "undefined")?1:0,' : "AVG" === n.aggregatorid ? (e.removeKeys.push("_SUM_" + s), e.removeKeys.push("_COUNT_" + s), "'" + s + "':" + a + ",'_SUM_" + s + "':(" + a + ")||0,'_COUNT_" + s + "':(typeof " + a + ' != "undefined")?1:0,') : "AGGR" === n.aggregatorid ? (u += ",g['" + s + "']=" + n.expression.toJS("g", -1), "") : "REDUCE" === n.aggregatorid ? (e.aggrKeys.push(n), "'" + s + "':alasql.aggr['" + n.funcid + "'](" + a + ",undefined,1),") : "") : "" }).join(""), s += "}" + u + ",g));" + c + "} else {", s += e.selectGroup.map(function (e) { var n = e.nick, a = e.expression.toJS("p", t, r); if (e instanceof Q.AggrValue) { var s = "", i = ""; if (e.distinct) var s = "if(typeof " + a + '!="undefined" && (!g[\'$$_VALUES_' + n + "'][" + a + "])) \t\t\t\t \t\t {", i = "g['$$_VALUES_" + n + "'][" + a + "]=true;}"; return "SUM" === e.aggregatorid ? s + "g['" + n + "']+=(" + a + "||0);" + i : "COUNT" === e.aggregatorid ? "*" === e.expression.columnid ? s + "g['" + n + "']++;" + i : s + "if(typeof " + a + '!="undefined") g[\'' + n + "']++;" + i : "ARRAY" === e.aggregatorid ? s + "g['" + n + "'].push(" + a + ");" + i : "MIN" === e.aggregatorid ? s + "g['" + n + "']=Math.min(g['" + n + "']," + a + ");" + i : "MAX" === e.aggregatorid ? s + "g['" + n + "']=Math.max(g['" + n + "']," + a + ");" + i : "FIRST" === e.aggregatorid ? "" : "LAST" === e.aggregatorid ? s + "g['" + n + "']=" + a + ";" + i : "AVG" === e.aggregatorid ? s + "g['_SUM_" + n + "']+=(y=" + a + ")||0;g['_COUNT_" + n + "']+=(typeof y!=\"undefined\")?1:0;g['" + n + "']=g['_SUM_" + n + "']/g['_COUNT_" + n + "'];" + i : "AGGR" === e.aggregatorid ? s + "g['" + n + "']=" + e.expression.toJS("g", -1) + ";" + i : "REDUCE" === e.aggregatorid ? s + "g['" + n + "']=alasql.aggr." + e.funcid + "(" + a + ",g['" + n + "'],2);" + i : "" } return "" }).join(""), s += "}" }), new Function("p,params,alasql", "var y;" + s) }, Q.Select.prototype.compileSelect1 = function (t, r) { var n = this; t.columns = [], t.xcolumns = {}, t.selectColumns = {}, t.dirtyColumns = !1; var a = "var r={", s = "", i = []; return this.columns.forEach(function (a) { if (a instanceof Q.Column) if ("*" === a.columnid) if (a.func) s += "r=params['" + a.param + "'](p['" + t.sources[0].alias + "'],p,params,alasql);"; else if (a.tableid) { var o = p(t, a.tableid, !1); o.s && (i = i.concat(o.s)), s += o.sp } else for (var u in t.aliases) { var o = p(t, u, !0); o.s && (i = i.concat(o.s)), s += o.sp } else { var c = a.tableid, l = a.databaseid || t.sources[0].databaseid || t.database.databaseid; if (c || (c = t.defcols[a.columnid]), c || (c = t.defaultTableid), "_" !== a.columnid) { var h = r && r.length > 1 && Array.isArray(r[0]) && r[0].length >= 1 && r[0][0].hasOwnProperty("sheetid"); h ? s = 'var r={};var w=p["' + c + '"];var cols=[' + n.columns.map(function (e) { return "'" + e.columnid + "'" }).join(",") + "];var colas=[" + n.columns.map(function (e) { return "'" + (e.as || e.columnid) + "'" }).join(",") + "];for (var i=0;i<Object.keys(p['" + c + "']).length;i++) for(var k=0;k<cols.length;k++){if (!r.hasOwnProperty(i)) r[i]={}; r[i][colas[k]]=w[i][cols[k]];}" : i.push("'" + R(a.as || a.columnid) + "':p['" + c + "']['" + a.columnid + "']") } else i.push("'" + R(a.as || a.columnid) + "':p['" + c + "']"); if (t.selectColumns[R(a.as || a.columnid)] = !0, t.aliases[c] && "table" === t.aliases[c].type) { if (!A.databases[l].tables[t.aliases[c].tableid]) throw new Error("Table '" + c + "' does not exists in database"); var d = A.databases[l].tables[t.aliases[c].tableid].columns, f = A.databases[l].tables[t.aliases[c].tableid].xcolumns; if (f && d.length > 0) { var b = f[a.columnid]; if (void 0 === b) throw new Error("Column does not exists: " + a.columnid); var E = { columnid: a.as || a.columnid, dbtypeid: b.dbtypeid, dbsize: b.dbsize, dbpecision: b.dbprecision, dbenum: b.dbenum }; t.columns.push(E), t.xcolumns[E.columnid] = E } else { var E = { columnid: a.as || a.columnid }; t.columns.push(E), t.xcolumns[E.columnid] = E, t.dirtyColumns = !0 } } else { var E = { columnid: a.as || a.columnid }; t.columns.push(E), t.xcolumns[E.columnid] = E } } else if (a instanceof Q.AggrValue) { n.group || (n.group = [""]), a.as || (a.as = R(a.toString())), "SUM" === a.aggregatorid || "MAX" === a.aggregatorid || "MIN" === a.aggregatorid || "FIRST" === a.aggregatorid || "LAST" === a.aggregatorid || "AVG" === a.aggregatorid || "ARRAY" === a.aggregatorid || "REDUCE" === a.aggregatorid ? i.push("'" + R(a.as) + "':" + e(a.expression.toJS("p", t.defaultTableid, t.defcols))) : "COUNT" === a.aggregatorid && i.push("'" + R(a.as) + "':1"); var E = { columnid: a.as || a.columnid || a.toString() }; t.columns.push(E), t.xcolumns[E.columnid] = E } else { i.push("'" + R(a.as || a.columnid || a.toString()) + "':" + e(a.toJS("p", t.defaultTableid, t.defcols))), t.selectColumns[R(a.as || a.columnid || a.toString())] = !0; var E = { columnid: a.as || a.columnid || a.toString() }; t.columns.push(E), t.xcolumns[E.columnid] = E } }), a += i.join(",") + "};" + s }, Q.Select.prototype.compileSelect2 = function (e) { var t = e.selectfns; return this.orderColumns && this.orderColumns.length > 0 && this.orderColumns.forEach(function (r, n) { var a = "$$$" + n; r instanceof Q.Column && e.xcolumns[r.columnid] ? t += "r['" + a + "']=r['" + r.columnid + "'];" : t += "r['" + a + "']=" + r.toJS("p", e.defaultTableid, e.defcols) + ";", e.removeKeys.push(a) }), new Function("p,params,alasql", "var y;" + t + "return r") }, Q.Select.prototype.compileSelectGroup0 = function (e) { var t = this; t.columns.forEach(function (r, n) { if (r instanceof Q.Column && "*" === r.columnid) e.groupStar = r.tableid || "default"; else { var a; a = R(r instanceof Q.Column ? r.columnid : r.toString(!0)); for (var s = 0; s < n; s++)if (a === t.columns[s].nick) { a = t.columns[s].nick + ":" + n; break } r.nick = a, !r.funcid || "ROWNUM" !== r.funcid.toUpperCase() && "ROW_NUMBER" !== r.funcid.toUpperCase() || e.rownums.push(r.as) } }), this.columns.forEach(function (t) { t.findAggregator && t.findAggregator(e) }), this.having && this.having.findAggregator && this.having.findAggregator(e) }, Q.Select.prototype.compileSelectGroup1 = function (t) { var r = this, n = "var r = {};"; return r.columns.forEach(function (r) { if (r instanceof Q.Column && "*" === r.columnid) return n += "for(var k in g) {r[k]=g[k]};", ""; var a = r.as; void 0 === a && (a = r instanceof Q.Column ? R(r.columnid) : r.nick), t.groupColumns[a] = r.nick, n += "r['" + a + "']=", n += e(r.toJS("g", "")) + ";"; for (var s = 0; s < t.removeKeys.length; s++)if (t.removeKeys[s] === a) { t.removeKeys.splice(s, 1); break } }), n }, Q.Select.prototype.compileSelectGroup2 = function (e) { var t = this, r = e.selectgfns; return t.columns.forEach(function (t) { e.ingroup.indexOf(t.nick) > -1 && (r += "r['" + (t.as || t.nick) + "']=g['" + t.nick + "'];") }), this.orderColumns && this.orderColumns.length > 0 && this.orderColumns.forEach(function (t, n) { var a = "$$$" + n; t instanceof Q.Column && e.groupColumns[t.columnid] ? r += "r['" + a + "']=r['" + t.columnid + "'];" : r += "r['" + a + "']=" + t.toJS("g", "") + ";", e.removeKeys.push(a) }), new Function("g,params,alasql", "var y;" + r + "return r") }, Q.Select.prototype.compileRemoveColumns = function (e) { void 0 !== this.removecolumns && (e.removeKeys = e.removeKeys.concat(this.removecolumns.filter(function (e) { return void 0 === e.like }).map(function (e) { return e.columnid })), e.removeLikeKeys = this.removecolumns.filter(function (e) { return void 0 !== e.like }).map(function (e) { return e.like.value })) }, Q.Select.prototype.compileHaving = function (e) { return this.having ? (s = this.having.toJS("g", -1), e.havingfns = s, new Function("g,params,alasql", "var y;return " + s)) : function () { return !0 } }, Q.Select.prototype.compileOrder = function (e) { var t = this; if (t.orderColumns = [], this.order) { if (this.order && 1 == this.order.length && this.order[0].expression && "function" == typeof this.order[0].expression) { var r = this.order[0].expression; return function (e, t) { var n = r(e), a = r(t); return n > a ? 1 : n == a ? 0 : -1 } } var n = "", a = ""; return this.order.forEach(function (r, s) { if (r.expression instanceof Q.NumValue) var i = t.columns[r.expression.value - 1]; else var i = r.expression; t.orderColumns.push(i); var o = "$$$" + s, u = ""; if (r.expression instanceof Q.Column) { var c = r.expression.columnid; if (e.xcolumns[c]) { var l = e.xcolumns[c].dbtypeid; "DATE" != l && "DATETIME" != l && "DATETIME2" != l || (u = ".valueOf()") } else A.options.valueof && (u = ".valueOf()") } r.nocase && (u += ".toUpperCase()"), n += "if((a['" + o + "']||'')" + u + ("ASC" == r.direction ? ">" : "<") + "(b['" + o + "']||'')" + u + ")return 1;", n += "if((a['" + o + "']||'')" + u + "==(b['" + o + "']||'')" + u + "){", a += "}" }), n += "return 0;", n += a + "return -1", e.orderfns = n, new Function("a,b", "var y;" + n) } }, Q.Select.prototype.compilePivot = function (e) { var t = this, r = t.pivot.columnid, n = t.pivot.expr.expression.columnid, a = t.pivot.expr.aggregatorid, s = t.pivot.inlist; return s && (s = s.map(function (e) { return e.expr.columnid })), function () { var e = this, t = e.columns.filter(function (e) { return e.columnid != r && e.columnid != n }).map(function (e) { return e.columnid }), i = [], o = {}, u = {}, c = {}, l = []; if (e.data.forEach(function (e) { if (!s || s.indexOf(e[r]) > -1) { var h = t.map(function (t) { return e[t] }).join("`"), d = u[h]; if (d || (d = {}, u[h] = d, l.push(d), t.forEach(function (t) { d[t] = e[t] })), c[h] || (c[h] = {}), c[h][e[r]] ? c[h][e[r]]++ : c[h][e[r]] = 1, o[e[r]] || (o[e[r]] = !0, i.push(e[r])), "SUM" == a || "AVG" == a) void 0 === d[e[r]] && (d[e[r]] = 0), d[e[r]] += e[n]; else if ("COUNT" == a) void 0 === d[e[r]] && (d[e[r]] = 0), d[e[r]]++; else if ("MIN" == a) void 0 === d[e[r]] && (d[e[r]] = 1 / 0), e[n] < d[e[r]] && (d[e[r]] = e[n]); else if ("MAX" == a) void 0 === d[e[r]] && (d[e[r]] = -1 / 0), e[n] > d[e[r]] && (d[e[r]] = e[n]); else if ("FIRST" == a) void 0 === d[e[r]] && (d[e[r]] = e[n]); else if ("LAST" == a) d[e[r]] = e[n]; else { if (!A.aggr[a]) throw new Error("Wrong aggregator in PIVOT clause"); A.aggr[a](d[e[r]], e[n]) } } }), "AVG" == a) for (var h in u) { var d = u[h]; for (var f in d) -1 == t.indexOf(f) && f != n && (d[f] = d[f] / c[h][f]) } e.data = l, s && (i = s); var p = e.columns.filter(function (e) { return e.columnid == n })[0]; e.columns = e.columns.filter(function (e) { return !(e.columnid == r || e.columnid == n) }), i.forEach(function (t) { var r = F(p); r.columnid = t, e.columns.push(r) }) } }, Q.Select.prototype.compileUnpivot = function (e) { var t = this, r = t.unpivot.tocolumnid, n = t.unpivot.forcolumnid, a = t.unpivot.inlist.map(function (e) { return e.columnid }); return function () { var t = [], s = e.columns.map(function (e) { return e.columnid }).filter(function (e) { return -1 == a.indexOf(e) && e != n && e != r }); e.data.forEach(function (e) { a.forEach(function (a) { var i = {}; s.forEach(function (t) { i[t] = e[t] }), i[n] = a, i[r] = e[a], t.push(i) }) }), e.data = t } }; var te = function (e, t) { for (var r = [], n = 0, a = e.length, s = 0; s < a + 1; s++) { for (var i = [], o = 0; o < a; o++) { if (e[o] instanceof Q.Column) { e[o].nick = R(e[o].columnid), t.groupColumns[R(e[o].columnid)] = e[o].nick; var u = e[o].nick + "\t" + e[o].toJS("p", t.sources[0].alias, t.defcols) } else { t.groupColumns[R(e[o].toString())] = R(e[o].toString()); var u = R(e[o].toString()) + "\t" + e[o].toJS("p", t.sources[0].alias, t.defcols) } n & 1 << o && i.push(u) } r.push(i), n = 1 + (n << 1) } return r }, re = function (e, t) { for (var r = [], n = e.length, a = 1 << n, s = 0; s < a; s++) { for (var i = [], o = 0; o < n; o++)s & 1 << o && (i = i.concat(b(e[o], t))); r.push(i) } return r }, ne = function (e, t) { return e.reduce(function (e, r) { return e = e.concat(b(r, t)) }, []) }, ae = function (e, t) { for (var r = [], n = 0; n < e.length; n++)for (var a = 0; a < t.length; a++)r.push(e[n].concat(t[a])); return r }; Q.Select.prototype.compileDefCols = function (e, t) { var r = { ".": {} }; return this.from && this.from.forEach(function (e) { if (r["."][e.as || e.tableid] = !0, e instanceof Q.Table) { var n = e.as || e.tableid, a = A.databases[e.databaseid || t].tables[e.tableid]; if (void 0 === a) throw new Error("Table does not exists: " + e.tableid); a.columns && a.columns.forEach(function (e) { r[e.columnid] ? r[e.columnid] = "-" : r[e.columnid] = n }) } else if (e instanceof Q.Select); else if (e instanceof Q.Search); else if (e instanceof Q.ParamValue); else if (e instanceof Q.VarValue); else if (e instanceof Q.FuncValue); else if (e instanceof Q.FromData); else if (e instanceof Q.Json); else if (!e.inserted) throw new Error("Unknown type of FROM clause") }), this.joins && this.joins.forEach(function (e) { if (r["."][e.as || e.table.tableid] = !0, e.table) { var n = e.table.tableid; e.as && (n = e.as); var n = e.as || e.table.tableid, a = A.databases[e.table.databaseid || t].tables[e.table.tableid]; a.columns && a.columns.forEach(function (e) { r[e.columnid] ? r[e.columnid] = "-" : r[e.columnid] = n }) } else if (e.select); else if (e.param); else if (!e.func) throw new Error("Unknown type of FROM clause") }), r }, Q.Union = function (e) { return Q.extend(this, e) }, Q.Union.prototype.toString = function () { return "UNION" }, Q.Union.prototype.compile = function (e) { return null }, Q.Apply = function (e) { return Q.extend(this, e) }, Q.Apply.prototype.toString = function () { var e = this.applymode + " APPLY (" + this.select.toString() + ")"; return this.as && (e += " AS " + this.as), e }, Q.Over = function (e) { return Q.extend(this, e) },
        Q.Over.prototype.toString = function () { var e = "OVER ("; return this.partition && (e += "PARTITION BY " + this.partition.toString(), this.order && (e += " ")), this.order && (e += "ORDER BY " + this.order.toString()), e += ")" }, Q.ExpressionStatement = function (e) { return Q.extend(this, e) }, Q.ExpressionStatement.prototype.toString = function () { return this.expression.toString() }, Q.ExpressionStatement.prototype.execute = function (e, t, r) { if (this.expression) { A.precompile(this, e, t); var n = new Function("params,alasql,p", "var y;return " + this.expression.toJS("({})", "", null)).bind(this), a = n(t, A); return r && (a = r(a)), a } }, Q.Expression = function (e) { return Q.extend(this, e) }, Q.Expression.prototype.toString = function (e) { var t = this.expression.toString(e); return this.order && (t += " " + this.order.toString()), this.nocase && (t += " COLLATE NOCASE"), t }, Q.Expression.prototype.findAggregator = function (e) { this.expression.findAggregator && this.expression.findAggregator(e) }, Q.Expression.prototype.toJS = function (e, t, r) { return this.expression.reduced ? "true" : this.expression.toJS(e, t, r) }, Q.Expression.prototype.compile = function (e, t, r) { return !!this.reduced || new Function("p", "var y;return " + this.toJS(e, t, r)) }, Q.JavaScript = function (e) { return Q.extend(this, e) }, Q.JavaScript.prototype.toString = function () { return "``" + this.value + "``" }, Q.JavaScript.prototype.toJS = function () { return "(" + this.value + ")" }, Q.JavaScript.prototype.execute = function (e, t, r) { var n = 1; return new Function("params,alasql,p", this.value)(t, A), r && (n = r(n)), n }, Q.Literal = function (e) { return Q.extend(this, e) }, Q.Literal.prototype.toString = function (e) { var t = this.value; return this.value1 && (t = this.value1 + "." + t), this.alias && !e && (t += " AS " + this.alias), t }, Q.Join = function (e) { return Q.extend(this, e) }, Q.Join.prototype.toString = function () { var e = " "; return this.joinmode && (e += this.joinmode + " "), e += "JOIN " + this.table.toString() }, Q.Table = function (e) { return Q.extend(this, e) }, Q.Table.prototype.toString = function () { var e = this.tableid; return this.databaseid && (e = this.databaseid + "." + e), e }, Q.View = function (e) { return Q.extend(this, e) }, Q.View.prototype.toString = function () { var e = this.viewid; return this.databaseid && (e = this.databaseid + "." + e), e }, Q.Op = function (e) { return Q.extend(this, e) }, Q.Op.prototype.toString = function () { if ("IN" === this.op || "NOT IN" === this.op) return this.left.toString() + " " + this.op + " (" + this.right.toString() + ")"; if (this.allsome) return this.left.toString() + " " + this.op + " " + this.allsome + " (" + this.right.toString() + ")"; if ("->" === this.op || "!" === this.op) { var e = this.left.toString() + this.op; return "string" != typeof this.right && "number" != typeof this.right && (e += "("), e += this.right.toString(), "string" != typeof this.right && "number" != typeof this.right && (e += ")"), e } return this.left.toString() + " " + this.op + " " + (this.allsome ? this.allsome + " " : "") + this.right.toString() }, Q.Op.prototype.findAggregator = function (e) { this.left && this.left.findAggregator && this.left.findAggregator(e), this.right && this.right.findAggregator && !this.allsome && this.right.findAggregator(e) }, Q.Op.prototype.toType = function (e) { if (["-", "*", "/", "%", "^"].indexOf(this.op) > -1) return "number"; if (["||"].indexOf(this.op) > -1) return "string"; if ("+" === this.op) { if ("string" === this.left.toType(e) || "string" === this.right.toType(e)) return "string"; if ("number" === this.left.toType(e) || "number" === this.right.toType(e)) return "number" } return ["AND", "OR", "NOT", "=", "==", "===", "!=", "!==", "!===", ">", ">=", "<", "<=", "IN", "NOT IN", "LIKE", "NOT LIKE", "REGEXP", "GLOB"].indexOf(this.op) > -1 ? "boolean" : "BETWEEN" === this.op || "NOT BETWEEN" === this.op || "IS NULL" === this.op || "IS NOT NULL" === this.op ? "boolean" : this.allsome ? "boolean" : this.op ? "unknown" : this.left.toType() }, Q.Op.prototype.toJS = function (e, t, r) { var n, a = [], s = this.op, i = this, o = function (n) { return n.toJS && (n = n.toJS(e, t, r)), "y[" + (a.push(n) - 1) + "]" }, u = function () { return o(i.left) }, c = function () { return o(i.right) }; if ("=" === this.op ? s = "===" : "<>" === this.op ? s = "!=" : "OR" === this.op && (s = "||"), "->" === this.op) { var l = "(" + u() + "||{})"; if ("string" == typeof this.right) n = l + '["' + this.right + '"]'; else if ("number" == typeof this.right) n = l + "[" + this.right + "]"; else if (this.right instanceof Q.FuncValue) { var h = []; if (this.right.args && 0 !== this.right.args.length) var h = this.right.args.map(o); n = l + "['" + this.right.funcid + "'](" + h.join(",") + ")" } else n = l + "[" + c() + "]" } if ("!" === this.op && "string" == typeof this.right && (n = "alasql.databases[alasql.useid].objects[" + u() + ']["' + this.right + '"]'), "IS" === this.op && (n = "((" + u() + "==null) === (" + c() + "==null))"), "==" === this.op && (n = "alasql.utils.deepEqual(" + u() + "," + c() + ")"), "===" !== this.op && "!===" !== this.op || (n = "(" + ("!===" === this.op ? "!" : "") + "((" + u() + ").valueOf()===(" + c() + ").valueOf()))"), "!==" === this.op && (n = "(!alasql.utils.deepEqual(" + u() + "," + c() + "))"), "||" === this.op && (n = "(''+(" + u() + "||'')+(" + c() + '||""))'), "LIKE" === this.op || "NOT LIKE" === this.op) { var n = "(" + ("NOT LIKE" === this.op ? "!" : "") + "alasql.utils.like(" + c() + "," + u(); this.escape && (n += "," + o(this.escape)), n += "))" } if ("REGEXP" === this.op && (n = "alasql.stdfn.REGEXP_LIKE(" + u() + "," + c() + ")"), "GLOB" === this.op && (n = "alasql.utils.glob(" + u() + "," + c() + ")"), "BETWEEN" === this.op || "NOT BETWEEN" === this.op) { var d = u(); n = "(" + ("NOT BETWEEN" === this.op ? "!" : "") + "((" + o(this.right1) + "<=" + d + ") && (" + d + "<=" + o(this.right2) + ")))" } if ("IN" === this.op && (this.right instanceof Q.Select ? (n = "(", n += "alasql.utils.flatArray(this.queriesfn[" + this.queriesidx + "](params,null," + e + "))", n += ".indexOf(", n += u() + ")>-1)") : n = Array.isArray(this.right) ? "([" + this.right.map(o).join(",") + "].indexOf(" + u() + ")>-1)" : "(" + c() + ".indexOf(" + u() + ")>-1)"), "NOT IN" === this.op && (this.right instanceof Q.Select ? (n = "(", n += "alasql.utils.flatArray(this.queriesfn[" + this.queriesidx + "](params,null,p))", n += ".indexOf(", n += u() + ")<0)") : Array.isArray(this.right) ? (n = "([" + this.right.map(o).join(",") + "].indexOf(", n += u() + ")<0)") : (n = "(" + c() + ".indexOf(", n += u() + ")==-1)")), "ALL" === this.allsome) { var n; if (this.right instanceof Q.Select) n = "alasql.utils.flatArray(this.query.queriesfn[" + this.queriesidx + "](params,null,p))", n += ".every(function(b){return (", n += u() + ")" + s + "b})"; else { if (!Array.isArray(this.right)) throw new Error("NOT IN operator without SELECT"); n = "" + (1 == this.right.length ? o(this.right[0]) : "[" + this.right.map(o).join(",") + "]"), n += ".every(function(b){return (", n += u() + ")" + s + "b})" } } if ("SOME" === this.allsome || "ANY" === this.allsome) { var n; if (this.right instanceof Q.Select) n = "alasql.utils.flatArray(this.query.queriesfn[" + this.queriesidx + "](params,null,p))", n += ".some(function(b){return (", n += u() + ")" + s + "b})"; else { if (!Array.isArray(this.right)) throw new Error("SOME/ANY operator without SELECT"); n = "" + (1 == this.right.length ? o(this.right[0]) : "[" + this.right.map(o).join(",") + "]"), n += ".some(function(b){return (", n += u() + ")" + s + "b})" } } if ("AND" === this.op) { if (this.left.reduced) { if (this.right.reduced) return "true"; n = c() } else this.right.reduced && (n = u()); s = "&&" } var f = n || "(" + u() + s + c() + ")", p = "y=[(" + a.join("), (") + ")]"; return "&&" == s || "||" == s || "IS" == s || "IS NULL" == s || "IS NOT NULL" == s ? "(" + p + ", " + f + ")" : "(" + p + ", y.some(function(e){return e == null}) ? void 0 : " + f + ")" }, Q.VarValue = function (e) { return Q.extend(this, e) }, Q.VarValue.prototype.toString = function () { return "@" + this.variable }, Q.VarValue.prototype.toType = function () { return "unknown" }, Q.VarValue.prototype.toJS = function () { return "alasql.vars['" + this.variable + "']" }, Q.NumValue = function (e) { return Q.extend(this, e) }, Q.NumValue.prototype.toString = function () { return this.value.toString() }, Q.NumValue.prototype.toType = function () { return "number" }, Q.NumValue.prototype.toJS = function () { return "" + this.value }, Q.StringValue = function (e) { return Q.extend(this, e) }, Q.StringValue.prototype.toString = function () { return "'" + this.value.toString() + "'" }, Q.StringValue.prototype.toType = function () { return "string" }, Q.StringValue.prototype.toJS = function () { return "'" + R(this.value) + "'" }, Q.DomainValueValue = function (e) { return Q.extend(this, e) }, Q.DomainValueValue.prototype.toString = function () { return "VALUE" }, Q.DomainValueValue.prototype.toType = function () { return "object" }, Q.DomainValueValue.prototype.toJS = function (e, t, r) { return e }, Q.ArrayValue = function (e) { return Q.extend(this, e) }, Q.ArrayValue.prototype.toString = function () { return "ARRAY[]" }, Q.ArrayValue.prototype.toType = function () { return "object" }, Q.ArrayValue.prototype.toJS = function (e, t, r) { return "[(" + this.value.map(function (n) { return n.toJS(e, t, r) }).join("), (") + ")]" }, Q.LogicValue = function (e) { return Q.extend(this, e) }, Q.LogicValue.prototype.toString = function () { return this.value ? "TRUE" : "FALSE" }, Q.LogicValue.prototype.toType = function () { return "boolean" }, Q.LogicValue.prototype.toJS = function () { return this.value ? "true" : "false" }, Q.NullValue = function (e) { return Q.extend(this, e) }, Q.NullValue.prototype.toString = function () { return "NULL" }, Q.NullValue.prototype.toJS = function () { return "undefined" }, Q.ParamValue = function (e) { return Q.extend(this, e) }, Q.ParamValue.prototype.toString = function () { return "$" + this.param }, Q.ParamValue.prototype.toJS = function () { return "string" == typeof this.param ? "params['" + this.param + "']" : "params[" + this.param + "]" }, Q.UniOp = function (e) { return Q.extend(this, e) }, Q.UniOp.prototype.toString = function () { var e; return e = void 0, "~" === this.op && (e = this.op + this.right.toString()), "-" === this.op && (e = this.op + this.right.toString()), "+" === this.op && (e = this.op + this.right.toString()), "#" === this.op && (e = this.op + this.right.toString()), "NOT" === this.op && (e = this.op + "(" + this.right.toString() + ")"), null === this.op && (e = "(" + this.right.toString() + ")"), e || (e = "(" + this.right.toString() + ")"), e }, Q.UniOp.prototype.findAggregator = function (e) { this.right.findAggregator && this.right.findAggregator(e) }, Q.UniOp.prototype.toType = function () { return "-" === this.op ? "number" : "+" === this.op ? "number" : "NOT" === this.op ? "boolean" : void 0 }, Q.UniOp.prototype.toJS = function (e, t, r) { return "~" === this.op ? "(~(" + this.right.toJS(e, t, r) + "))" : "-" === this.op ? "(-(" + this.right.toJS(e, t, r) + "))" : "+" === this.op ? "(" + this.right.toJS(e, t, r) + ")" : "NOT" === this.op ? "!(" + this.right.toJS(e, t, r) + ")" : "#" === this.op ? this.right instanceof Q.Column ? "(alasql.databases[alasql.useid].objects['" + this.right.columnid + "'])" : "(alasql.databases[alasql.useid].objects[" + this.right.toJS(e, t, r) + "])" : null == this.op ? "(" + this.right.toJS(e, t, r) + ")" : void 0 }, Q.Column = function (e) { return Q.extend(this, e) }, Q.Column.prototype.toString = function (e) { var t; return t = this.columnid == +this.columnid ? "[" + this.columnid + "]" : this.columnid, this.tableid && (t = +this.columnid === this.columnid ? this.tableid + t : this.tableid + "." + t, this.databaseid && (t = this.databaseid + "." + t)), this.alias && !e && (t += " AS " + this.alias), t }, Q.Column.prototype.toJS = function (e, t, r) { var n = ""; if (this.tableid || "" !== t || r) if ("g" === e) n = "g['" + this.nick + "']"; else if (this.tableid) n = "_" !== this.columnid ? e + "['" + this.tableid + "']['" + this.columnid + "']" : "g" === e ? "g['_']" : e + "['" + this.tableid + "']"; else if (r) { var a = r[this.columnid]; if ("-" === a) throw new Error('Cannot resolve column "' + this.columnid + '" because it exists in two source tables'); n = a ? "_" !== this.columnid ? e + "['" + a + "']['" + this.columnid + "']" : e + "['" + a + "']" : "_" !== this.columnid ? e + "['" + (this.tableid || t) + "']['" + this.columnid + "']" : e + "['" + (this.tableid || t) + "']" } else n = -1 === t ? e + "['" + this.columnid + "']" : "_" !== this.columnid ? e + "['" + (this.tableid || t) + "']['" + this.columnid + "']" : e + "['" + (this.tableid || t) + "']"; else n = "_" !== this.columnid ? e + "['" + this.columnid + "']" : "g" === e ? "g['_']" : e; return n }, Q.AggrValue = function (e) { return Q.extend(this, e) }, Q.AggrValue.prototype.toString = function (e) { var t = ""; return "REDUCE" === this.aggregatorid ? t += this.funcid + "(" : t += this.aggregatorid + "(", this.distinct && (t += "DISTINCT "), this.expression && (t += this.expression.toString()), t += ")", this.over && (t += " " + this.over.toString()), this.alias && !e && (t += " AS " + this.alias), t }, Q.AggrValue.prototype.findAggregator = function (e) { var t = R(this.toString()) + ":" + e.selectGroup.length, r = !1; if (!r) { if (!this.nick) { this.nick = t; for (var r = !1, n = 0; n < e.removeKeys.length; n++)if (e.removeKeys[n] === t) { r = !0; break } r || e.removeKeys.push(t) } e.selectGroup.push(this) } }, Q.AggrValue.prototype.toType = function () { return ["SUM", "COUNT", "AVG", "MIN", "MAX", "AGGR", "VAR", "STDDEV"].indexOf(this.aggregatorid) > -1 ? "number" : ["ARRAY"].indexOf(this.aggregatorid) > -1 ? "array" : ["FIRST", "LAST"].indexOf(this.aggregatorid) > -1 ? this.expression.toType() : void 0 }, Q.AggrValue.prototype.toJS = function () { var e = this.nick; return void 0 === e && (e = this.toString()), "g['" + e + "']" }, Q.OrderExpression = function (e) { return Q.extend(this, e) }, Q.OrderExpression.prototype.toString = Q.Expression.prototype.toString, Q.GroupExpression = function (e) { return Q.extend(this, e) }, Q.GroupExpression.prototype.toString = function () { return this.type + "(" + this.group.toString() + ")" }, Q.FromData = function (e) { return Q.extend(this, e) }, Q.FromData.prototype.toString = function () { return this.data ? "DATA(" + (1e16 * Math.random() | 0) + ")" : "?" }, Q.FromData.prototype.toJS = function () { }, Q.Select.prototype.exec = function (e, t) { this.preparams && (e = this.preparams.concat(e)); var r = A.useid; db = A.databases[r]; var n = this.toString(), a = D(n), s = this.compile(r); if (s) { s.sql = n, s.dbversion = db.dbversion, db.sqlCacheSize > A.MAXSQLCACHESIZE && db.resetSqlCache(), db.sqlCacheSize++, db.sqlCache[a] = s; return A.res = s(e, t) } }, Q.Select.prototype.Select = function () { var e = this; if (arguments.length > 1) args = Array.prototype.slice.call(arguments); else { if (1 != arguments.length) throw new Error("Wrong number of arguments of Select() function"); Array.isArray(arguments[0]) ? args = arguments[0] : args = [arguments[0]] } return e.columns = [], args.forEach(function (t) { if ("string" == typeof t) e.columns.push(new Q.Column({ columnid: t })); else if ("function" == typeof t) { var r = 0; e.preparams ? r = e.preparams.length : e.preparams = [], e.preparams.push(t), e.columns.push(new Q.Column({ columnid: "*", func: t, param: r })) } }), e }, Q.Select.prototype.From = function (e) { var t = this; if (t.from || (t.from = []), Array.isArray(e)) { var r = 0; t.preparams ? r = t.preparams.length : t.preparams = [], t.preparams.push(e), t.from.push(new Q.ParamValue({ param: r })) } else { if ("string" != typeof e) throw new Error("Unknown arguments in From() function"); t.from.push(new Q.Table({ tableid: e })) } return t }, Q.Select.prototype.OrderBy = function () { var e = this; if (e.order = [], 0 == arguments.length) args = ["_"]; else if (arguments.length > 1) args = Array.prototype.slice.call(arguments); else { if (1 != arguments.length) throw new Error("Wrong number of arguments of Select() function"); Array.isArray(arguments[0]) ? args = arguments[0] : args = [arguments[0]] } return args.length > 0 && args.forEach(function (t) { var r = new Q.Column({ columnid: t }); "function" == typeof t && (r = t), e.order.push(new Q.OrderExpression({ expression: r, direction: "ASC" })) }), e }, Q.Select.prototype.Top = function (e) { var t = this; return t.top = new Q.NumValue({ value: e }), t }, Q.Select.prototype.GroupBy = function () { var e = this; if (arguments.length > 1) args = Array.prototype.slice.call(arguments); else { if (1 != arguments.length) throw new Error("Wrong number of arguments of Select() function"); Array.isArray(arguments[0]) ? args = arguments[0] : args = [arguments[0]] } return e.group = [], args.forEach(function (t) { var r = new Q.Column({ columnid: t }); e.group.push(r) }), e }, Q.Select.prototype.Where = function (e) { var t = this; return "function" == typeof e && (t.where = e), t }, Q.FuncValue = function (e) { return Q.extend(this, e) }, Q.FuncValue.prototype.toString = function (e) { var t = ""; return A.fn[this.funcid] ? t += this.funcid : A.aggr[this.funcid] ? t += this.funcid : (A.stdlib[this.funcid.toUpperCase()] || A.stdfn[this.funcid.toUpperCase()]) && (t += this.funcid.toUpperCase()), t += "(", this.args && this.args.length > 0 && (t += this.args.map(function (e) { return e.toString() }).join(",")), t += ")", this.as && !e && (t += " AS " + this.as.toString()), t }, Q.FuncValue.prototype.execute = function (e, t, r) { var n = 1; return A.precompile(this, e, t), new Function("params,alasql", "var y;return " + this.toJS("", "", null))(t, A), r && (n = r(n)), n }, Q.FuncValue.prototype.findAggregator = function (e) { this.args && this.args.length > 0 && this.args.forEach(function (t) { t.findAggregator && t.findAggregator(e) }) }, Q.FuncValue.prototype.toJS = function (e, t, r) { var n = "", a = this.funcid; return !A.fn[a] && A.stdlib[a.toUpperCase()] ? this.args && this.args.length > 0 ? n += A.stdlib[a.toUpperCase()].apply(this, this.args.map(function (r) { return r.toJS(e, t) })) : n += A.stdlib[a.toUpperCase()]() : !A.fn[a] && A.stdfn[a.toUpperCase()] ? (this.newid && (n += "new "), n += "alasql.stdfn." + this.funcid.toUpperCase() + "(", this.args && this.args.length > 0 && (n += this.args.map(function (n) { return n.toJS(e, t, r) }).join(",")), n += ")") : (this.newid && (n += "new "), n += "alasql.fn." + this.funcid + "(", this.args && this.args.length > 0 && (n += this.args.map(function (n) { return n.toJS(e, t, r) }).join(",")), n += ")"), n }; var se = A.stdlib = {}, ie = A.stdfn = {}; se.ABS = function (e) { return "Math.abs(" + e + ")" }, se.CLONEDEEP = function (e) { return "alasql.utils.cloneDeep(" + e + ")" }, ie.CONCAT = function () { return Array.prototype.slice.call(arguments).join("") }, se.EXP = function (e) { return "Math.pow(Math.E," + e + ")" }, se.IIF = function (e, t, r) { if (3 == arguments.length) return "((" + e + ")?(" + t + "):(" + r + "))"; throw new Error("Number of arguments of IFF is not equals to 3") }, se.IFNULL = function (e, t) { return "(" + e + "||" + t + ")" }, se.INSTR = function (e, t) { return "((" + e + ").indexOf(" + t + ")+1)" }, se.LEN = se.LENGTH = function (e) { return t(e, "y.length") }, se.LOWER = se.LCASE = function (e) { return t(e, "String(y).toLowerCase()") }, se.MAX = se.GREATEST = function () { return "Math.max(" + Array.prototype.join.call(arguments, ",") + ")" }, se.MIN = se.LEAST = function () { return "Math.min(" + Array.prototype.join.call(arguments, ",") + ")" }, se.SUBSTRING = se.SUBSTR = se.MID = function (e, r, n) { return 2 == arguments.length ? t(e, "y.substr(" + r + "-1)") : 3 == arguments.length ? t(e, "y.substr(" + r + "-1," + n + ")") : void 0 }, ie.REGEXP_LIKE = function (e, t, r) { return (e || "").search(RegExp(t, r)) > -1 }, se.ISNULL = se.NULLIF = function (e, t) { return "(" + e + "==" + t + "?undefined:" + e + ")" }, se.POWER = function (e, t) { return "Math.pow(" + e + "," + t + ")" }, se.RANDOM = function (e) { return 0 == arguments.length ? "Math.random()" : "(Math.random()*(" + e + ")|0)" }, se.ROUND = function (e, t) { return 2 == arguments.length ? "Math.round((" + e + ")*Math.pow(10,(" + t + ")))/Math.pow(10,(" + t + "))" : "Math.round(" + e + ")" }, se.CEIL = se.CEILING = function (e) { return "Math.ceil(" + e + ")" }, se.FLOOR = function (e) { return "Math.floor(" + e + ")" }, se.ROWNUM = function () { return "1" }, se.ROW_NUMBER = function () { return "1" }, se.SQRT = function (e) { return "Math.sqrt(" + e + ")" }, se.TRIM = function (e) { return t(e, "y.trim()") }, se.UPPER = se.UCASE = function (e) { return t(e, "String(y).toUpperCase()") }, ie.CONCAT_WS = function () { return args = Array.prototype.slice.call(arguments), args.slice(1, args.length).join(args[0]) }, A.aggr.GROUP_CONCAT = function (e, t, r) { return 1 == r ? e : 2 == r ? t + "," + e : void 0 }, A.aggr.MEDIAN = function (e, t, r) { if (2 === r) return null !== e && t.push(e), t; if (1 === r) return null === e ? [] : [e]; if (!t.length) return t; var n = t.sort(), a = (n.length + 1) / 2; return Number.isInteger(a) ? n[a - 1] : (n[Math.floor(a - 1)] + n[Math.ceil(a - 1)]) / 2 }, A.aggr.QUART = function (e, t, r, n) { if (2 === r) return null !== e && t.push(e), t; if (1 === r) return null === e ? [] : [e]; if (!t.length) return t; n = n || 1; var a = t.sort(), s = n * (a.length + 1) / 4; return Number.isInteger(s) ? a[s - 1] : a[Math.floor(s)] }, A.aggr.QUART2 = function (e, t, r) { return A.aggr.QUART(e, t, r, 2) }, A.aggr.QUART3 = function (e, t, r) { return A.aggr.QUART(e, t, r, 3) }, A.aggr.VAR = function (e, t, r) { if (1 === r) return null === e ? { arr: [], sum: 0 } : { arr: [e], sum: e }; if (2 === r) return null === e ? t : (t.arr.push(e), t.sum += e, t); for (var n = t.arr.length, a = t.sum / n, s = 0, i = 0; i < n; i++)s += (t.arr[i] - a) * (t.arr[i] - a); return s /= n - 1 }, A.aggr.STDEV = function (e, t, r) { return 1 === r || 2 === r ? A.aggr.VAR(e, t, r) : Math.sqrt(A.aggr.VAR(e, t, r)) }, A.aggr.VARP = function (e, t, r) { if (1 == r) return { arr: [e], sum: e }; if (2 == r) return t.arr.push(e), t.sum += e, t; for (var n = t.arr.length, a = t.sum / n, s = 0, i = 0; i < n; i++)s += (t.arr[i] - a) * (t.arr[i] - a); return s /= n }, A.aggr.STD = A.aggr.STDDEV = A.aggr.STDEVP = function (e, t, r) { return 1 == r || 2 == r ? A.aggr.VARP(e, t, r) : Math.sqrt(A.aggr.VARP(e, t, r)) }, ie.REPLACE = function (e, t, r) { return (e || "").split(t).join(r) }; for (var oe = [], ue = 0; ue < 256; ue++)oe[ue] = (ue < 16 ? "0" : "") + ue.toString(16); ie.NEWID = ie.UUID = ie.GEN_RANDOM_UUID = function () { var e = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, r = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0; return oe[255 & e] + oe[e >> 8 & 255] + oe[e >> 16 & 255] + oe[e >> 24 & 255] + "-" + oe[255 & t] + oe[t >> 8 & 255] + "-" + oe[t >> 16 & 15 | 64] + oe[t >> 24 & 255] + "-" + oe[63 & r | 128] + oe[r >> 8 & 255] + "-" + oe[r >> 16 & 255] + oe[r >> 24 & 255] + oe[255 & n] + oe[n >> 8 & 255] + oe[n >> 16 & 255] + oe[n >> 24 & 255] }, Q.CaseValue = function (e) { return Q.extend(this, e) }, Q.CaseValue.prototype.toString = function () { var e = "CASE "; return this.expression && (e += this.expression.toString()), this.whens && (e += this.whens.map(function (e) { return " WHEN " + e.when.toString() + " THEN " + e.then.toString() }).join()), e += " END" }, Q.CaseValue.prototype.findAggregator = function (e) { this.expression && this.expression.findAggregator && this.expression.findAggregator(e), this.whens && this.whens.length > 0 && this.whens.forEach(function (t) { t.when.findAggregator && t.when.findAggregator(e), t.then.findAggregator && t.then.findAggregator(e) }), this.elses && this.elses.findAggregator && this.elses.findAggregator(e) }, Q.CaseValue.prototype.toJS = function (e, t, r) { var n = "((function(" + e + ",params,alasql){var y,r;"; return this.expression ? (n += "v=" + this.expression.toJS(e, t, r) + ";", n += (this.whens || []).map(function (n) { return " if(v==" + n.when.toJS(e, t, r) + ") {r=" + n.then.toJS(e, t, r) + "}" }).join(" else "), this.elses && (n += " else {r=" + this.elses.toJS(e, t, r) + "}")) : (n += (this.whens || []).map(function (n) { return " if(" + n.when.toJS(e, t, r) + ") {r=" + n.then.toJS(e, t, r) + "}" }).join(" else "), this.elses && (n += " else {r=" + this.elses.toJS(e, t, r) + "}")), n += ";return r;}).bind(this))(" + e + ",params,alasql)" }, Q.Json = function (e) { return Q.extend(this, e) }, Q.Json.prototype.toString = function () { var e = ""; return e += ce(this.value), e += "" }; var ce = A.utils.JSONtoString = function (e) { var t = ""; if ("string" == typeof e) t = '"' + e + '"'; else if ("number" == typeof e) t = e; else if ("boolean" == typeof e) t = e; else { if ("object" != typeof e) throw new Error("2Can not show JSON object " + JSON.stringify(e)); if (Array.isArray(e)) t += "[" + e.map(function (e) { return ce(e) }).join(",") + "]"; else if (!e.toJS || e instanceof Q.Json) { t = "{"; var r = []; for (var n in e) { var a = ""; if ("string" == typeof n) a += '"' + n + '"'; else if ("number" == typeof n) a += n; else { if ("boolean" != typeof n) throw new Error("THis is not ES6... no expressions on left side yet"); a += n } a += ":" + ce(e[n]), r.push(a) } t += r.join(",") + "}" } else { if (!e.toString) throw new Error("1Can not show JSON object " + JSON.stringify(e)); t = e.toString() } } return t }; Q.Json.prototype.toJS = function (e, t, r) { return E(this.value, e, t, r) }, Q.Convert = function (e) { return Q.extend(this, e) }, Q.Convert.prototype.toString = function () { var e = "CONVERT("; return e += this.dbtypeid, void 0 !== this.dbsize && (e += "(" + this.dbsize, this.dbprecision && (e += "," + dbprecision), e += ")"), e += "," + this.expression.toString(), this.style && (e += "," + this.style), e += ")" }, Q.Convert.prototype.toJS = function (e, t, r) { return "alasql.stdfn.CONVERT(" + this.expression.toJS(e, t, r) + ',{dbtypeid:"' + this.dbtypeid + '",dbsize:' + this.dbsize + ",style:" + this.style + "})" }, A.stdfn.CONVERT = function (e, t) { var r = e; if (t.style) { var n; switch (n = /\d{8}/.test(r) ? new Date(+r.substr(0, 4), +r.substr(4, 2) - 1, +r.substr(6, 2)) : new Date(r), t.style) { case 1: r = ("0" + (n.getMonth() + 1)).substr(-2) + "/" + ("0" + n.getDate()).substr(-2) + "/" + ("0" + n.getYear()).substr(-2); break; case 2: r = ("0" + n.getYear()).substr(-2) + "." + ("0" + (n.getMonth() + 1)).substr(-2) + "." + ("0" + n.getDate()).substr(-2); break; case 3: r = ("0" + n.getDate()).substr(-2) + "/" + ("0" + (n.getMonth() + 1)).substr(-2) + "/" + ("0" + n.getYear()).substr(-2); break; case 4: r = ("0" + n.getDate()).substr(-2) + "." + ("0" + (n.getMonth() + 1)).substr(-2) + "." + ("0" + n.getYear()).substr(-2); break; case 5: r = ("0" + n.getDate()).substr(-2) + "-" + ("0" + (n.getMonth() + 1)).substr(-2) + "-" + ("0" + n.getYear()).substr(-2); break; case 6: r = ("0" + n.getDate()).substr(-2) + " " + n.toString().substr(4, 3).toLowerCase() + " " + ("0" + n.getYear()).substr(-2); break; case 7: r = n.toString().substr(4, 3) + " " + ("0" + n.getDate()).substr(-2) + "," + ("0" + n.getYear()).substr(-2); break; case 8: case 108: r = ("0" + n.getHours()).substr(-2) + ":" + ("0" + n.getMinutes()).substr(-2) + ":" + ("0" + n.getSeconds()).substr(-2); break; case 10: r = ("0" + (n.getMonth() + 1)).substr(-2) + "-" + ("0" + n.getDate()).substr(-2) + "-" + ("0" + n.getYear()).substr(-2); break; case 11: r = ("0" + n.getYear()).substr(-2) + "/" + ("0" + (n.getMonth() + 1)).substr(-2) + "/" + ("0" + n.getDate()).substr(-2); break; case 12: r = ("0" + n.getYear()).substr(-2) + ("0" + (n.getMonth() + 1)).substr(-2) + ("0" + n.getDate()).substr(-2); break; case 101: r = ("0" + (n.getMonth() + 1)).substr(-2) + "/" + ("0" + n.getDate()).substr(-2) + "/" + n.getFullYear(); break; case 102: r = n.getFullYear() + "." + ("0" + (n.getMonth() + 1)).substr(-2) + "." + ("0" + n.getDate()).substr(-2); break; case 103: r = ("0" + n.getDate()).substr(-2) + "/" + ("0" + (n.getMonth() + 1)).substr(-2) + "/" + n.getFullYear(); break; case 104: r = ("0" + n.getDate()).substr(-2) + "." + ("0" + (n.getMonth() + 1)).substr(-2) + "." + n.getFullYear(); break; case 105: r = ("0" + n.getDate()).substr(-2) + "-" + ("0" + (n.getMonth() + 1)).substr(-2) + "-" + n.getFullYear(); break; case 106: r = ("0" + n.getDate()).substr(-2) + " " + n.toString().substr(4, 3).toLowerCase() + " " + n.getFullYear(); break; case 107: r = n.toString().substr(4, 3) + " " + ("0" + n.getDate()).substr(-2) + "," + n.getFullYear(); break; case 110: r = ("0" + (n.getMonth() + 1)).substr(-2) + "-" + ("0" + n.getDate()).substr(-2) + "-" + n.getFullYear(); break; case 111: r = n.getFullYear() + "/" + ("0" + (n.getMonth() + 1)).substr(-2) + "/" + ("0" + n.getDate()).substr(-2); break; case 112: r = n.getFullYear() + ("0" + (n.getMonth() + 1)).substr(-2) + ("0" + n.getDate()).substr(-2); break; default: throw new Error("The CONVERT style " + t.style + " is not realized yet.") } } var a = t.dbtypeid.toUpperCase(); if ("Date" == t.dbtypeid) return new Date(r); if ("DATE" == a) { var s = new Date(r), i = s.getFullYear() + "." + ("0" + (s.getMonth() + 1)).substr(-2) + "." + ("0" + s.getDate()).substr(-2); return i } if ("DATETIME" == a || "DATETIME2" == a) { var s = new Date(r), i = s.getFullYear() + "." + ("0" + (s.getMonth() + 1)).substr(-2) + "." + ("0" + s.getDate()).substr(-2); return i += " " + ("0" + s.getHours()).substr(-2) + ":" + ("0" + s.getMinutes()).substr(-2) + ":" + ("0" + s.getSeconds()).substr(-2), i += "." + ("00" + s.getMilliseconds()).substr(-3) } if (["MONEY"].indexOf(a) > -1) { var o = +r; return (0 | o) + 100 * o % 100 / 100 } if (["BOOLEAN"].indexOf(a) > -1) return !!r; if (["INT", "INTEGER", "SMALLINT", "BIGINT", "SERIAL", "SMALLSERIAL", "BIGSERIAL"].indexOf(t.dbtypeid.toUpperCase()) > -1) return 0 | r; if (["STRING", "VARCHAR", "NVARCHAR", "CHARACTER VARIABLE"].indexOf(t.dbtypeid.toUpperCase()) > -1) return t.dbsize ? ("" + r).substr(0, t.dbsize) : "" + r; if (["CHAR", "CHARACTER", "NCHAR"].indexOf(a) > -1) return (r + new Array(t.dbsize + 1).join(" ")).substr(0, t.dbsize); if (["NUMBER", "FLOAT"].indexOf(a) > -1) { if (void 0 !== t.dbprecision) { var o = +r, u = Math.pow(10, t.dbprecision); return (0 | o) + o * u % u / u } return +r } if (["DECIMAL", "NUMERIC"].indexOf(a) > -1) { var o = +r, u = Math.pow(10, t.dbprecision); return (0 | o) + o * u % u / u } if (["JSON"].indexOf(a) > -1) { if ("object" == typeof r) return r; try { return JSON.parse(r) } catch (e) { throw new Error("Cannot convert string to JSON") } } return r }, Q.ColumnDef = function (e) { return Q.extend(this, e) }, Q.ColumnDef.prototype.toString = function () { var e = this.columnid; return this.dbtypeid && (e += " " + this.dbtypeid), this.dbsize && (e += "(" + this.dbsize, this.dbprecision && (e += "," + this.dbprecision), e += ")"), this.primarykey && (e += " PRIMARY KEY"), this.notnull && (e += " NOT NULL"), e }, Q.CreateTable = function (e) { return Q.extend(this, e) }, Q.CreateTable.prototype.toString = function () { var e = "CREATE"; if (this.temporary && (e += " TEMPORARY"), this.view ? e += " VIEW" : e += " " + (this.class ? "CLASS" : "TABLE"), this.ifnotexists && (e += " IF  NOT EXISTS"), e += " " + this.table.toString(), this.viewcolumns && (e += "(" + this.viewcolumns.map(function (e) { return e.toString() }).join(",") + ")"), this.as) e += " AS " + this.as; else { e += " (" + this.columns.map(function (e) { return e.toString() }).join(",") + ")" } return this.view && this.select && (e += " AS " + this.select.toString()), e }, Q.CreateTable.prototype.execute = function (e, t, r) {
            var n = A.databases[this.table.databaseid || e], a = this.table.tableid; if (!a) throw new Error("Table name is not defined"); var s = this.columns, i = this.constraints || []; if (this.ifnotexists && n.tables[a]) return r ? r(0) : 0; if (n.tables[a]) throw new Error("Can not create table '" + a + "', because it already exists in the database '" + n.databaseid + "'"); var o = n.tables[a] = new A.Table; this.class && (o.isclass = !0); var u = [], c = []; if (s && s.forEach(function (e) { var t = e.dbtypeid; A.fn[t] || (t = t.toUpperCase()), ["SERIAL", "SMALLSERIAL", "BIGSERIAL"].indexOf(t) > -1 && (e.identity = { value: 1, step: 1 }); var r = { columnid: e.columnid, dbtypeid: t, dbsize: e.dbsize, dbprecision: e.dbprecision, notnull: e.notnull, identity: e.identity }; if (e.identity && (o.identities[e.columnid] = { value: +e.identity.value, step: +e.identity.step }), e.check && o.checks.push({ id: e.check.constrantid, fn: new Function("r", "var y;return " + e.check.expression.toJS("r", "")) }), e.default && u.push("'" + e.columnid + "':" + e.default.toJS("r", "")), e.primarykey) { var n = o.pk = {}; n.columns = [e.columnid], n.onrightfns = "r['" + e.columnid + "']", n.onrightfn = new Function("r", "var y;return " + n.onrightfns), n.hh = D(n.onrightfns), o.uniqs[n.hh] = {} } if (e.unique) { var a = {}; o.uk = o.uk || [], o.uk.push(a), a.columns = [e.columnid], a.onrightfns = "r['" + e.columnid + "']", a.onrightfn = new Function("r", "var y;return " + a.onrightfns), a.hh = D(a.onrightfns), o.uniqs[a.hh] = {} } if (e.foreignkey) { var s = e.foreignkey.table, i = A.databases[s.databaseid || A.useid].tables[s.tableid]; if (void 0 === s.columnid) { if (!(i.pk.columns && i.pk.columns.length > 0)) throw new Error("FOREIGN KEY allowed only to tables with PRIMARY KEYs"); s.columnid = i.pk.columns[0] } var l = function (t) { var r = {}; if (void 0 === t[e.columnid]) return !0; r[s.columnid] = t[e.columnid]; var n = i.pk.onrightfn(r); if (!i.uniqs[i.pk.hh][n]) throw new Error('Foreign key "' + t[e.columnid] + '" is not found in table ' + i.tableid); return !0 }; o.checks.push({ fn: l }) } e.onupdate && c.push("r['" + e.columnid + "']=" + e.onupdate.toJS("r", "")), o.columns.push(r), o.xcolumns[r.columnid] = r }), o.defaultfns = u.join(","), o.onupdatefns = c.join(";"), i.forEach(function (e) { var t; if ("PRIMARY KEY" === e.type) { if (o.pk) throw new Error("Primary key already exists"); var r = o.pk = {}; r.columns = e.columns, r.onrightfns = r.columns.map(function (e) { return "r['" + e + "']" }).join("+'`'+"), r.onrightfn = new Function("r", "var y;return " + r.onrightfns), r.hh = D(r.onrightfns), o.uniqs[r.hh] = {} } else if ("CHECK" === e.type) t = new Function("r", "var y;return " + e.expression.toJS("r", "")); else if ("UNIQUE" === e.type) { var n = {}; o.uk = o.uk || [], o.uk.push(n), n.columns = e.columns, n.onrightfns = n.columns.map(function (e) { return "r['" + e + "']" }).join("+'`'+"), n.onrightfn = new Function("r", "var y;return " + n.onrightfns), n.hh = D(n.onrightfns), o.uniqs[n.hh] = {} } else if ("FOREIGN KEY" === e.type) { var a = o.xcolumns[e.columns[0]], s = e.fktable; e.fkcolumns && e.fkcolumns.length > 0 && (s.columnid = e.fkcolumns[0]); var i = A.databases[s.databaseid || A.useid].tables[s.tableid]; void 0 === s.columnid && (s.columnid = i.pk.columns[0]), t = function (e) { var t = {}; if (void 0 === e[a.columnid]) return !0; t[s.columnid] = e[a.columnid]; var r = i.pk.onrightfn(t); if (!i.uniqs[i.pk.hh][r]) throw new Error('Foreign key "' + e[a.columnid] + '" is not found in table ' + i.tableid); return !0 } } t && o.checks.push({ fn: t, id: e.constraintid, fk: "FOREIGN KEY" === e.type }) }), this.view && this.viewcolumns) { var l = this; this.viewcolumns.forEach(function (e, t) { l.select.columns[t].as = e.columnid }) } if (this.view && this.select && (o.view = !0, o.select = this.select.compile(this.table.databaseid || e)), n.engineid) return A.engines[n.engineid].createTable(this.table.databaseid || e, a, this.ifnotexists, r); o.insert = function (r, n) {
                var a = A.inserted; A.inserted = [r]; var s = this, i = !1, o = !1; for (var u in s.beforeinsert) { var c = s.beforeinsert[u]; c && (c.funcid ? !1 === A.fn[c.funcid](r) && (o = o || !0) : c.statement && !1 === c.statement.execute(e) && (o = o || !0)) } if (!o) {
                    var l = !1; for (var u in s.insteadofinsert) { l = !0; var c = s.insteadofinsert[u]; c && (c.funcid ? A.fn[c.funcid](r) : c.statement && c.statement.execute(e)) } if (!l) {
                        for (var h in s.identities) { var d = s.identities[h]; r[h] = d.value } if (s.checks && s.checks.length > 0 && s.checks.forEach(function (e) { if (!e.fn(r)) throw new Error("Violation of CHECK constraint " + (e.id || "")) }), s.columns.forEach(function (e) { if (e.notnull && void 0 === r[e.columnid]) throw new Error("Wrong NULL value in NOT NULL column " + e.columnid) }), s.pk) { var f = s.pk, p = f.onrightfn(r); if (void 0 !== s.uniqs[f.hh][p]) { if (!n) throw new Error("Cannot insert record, because it already exists in primary key index"); i = s.uniqs[f.hh][p] } } if (s.uk && s.uk.length && s.uk.forEach(function (e) { var t = e.onrightfn(r); if (void 0 !== s.uniqs[e.hh][t]) { if (!n) throw new Error("Cannot insert record, because it already exists in unique index"); i = s.uniqs[e.hh][t] } }), i) s.update(function (e) { for (var t in r) e[t] = r[t] }, s.data.indexOf(i), t); else {
                            s.data.push(r); for (var h in s.identities) {
                                var d = s.identities[h]; d.value += d.step
                            } if (s.pk) { var f = s.pk, p = f.onrightfn(r); s.uniqs[f.hh][p] = r } s.uk && s.uk.length && s.uk.forEach(function (e) { var t = e.onrightfn(r); s.uniqs[e.hh][t] = r })
                        } for (var u in s.afterinsert) { var c = s.afterinsert[u]; c && (c.funcid ? A.fn[c.funcid](r) : c.statement && c.statement.execute(e)) } A.inserted = a
                    }
                }
            }, o.delete = function (t) { var r = this, n = r.data[t], a = !1; for (var s in r.beforedelete) { var i = r.beforedelete[s]; i && (i.funcid ? !1 === A.fn[i.funcid](n) && (a = a || !0) : i.statement && !1 === i.statement.execute(e) && (a = a || !0)) } if (a) return !1; var o = !1; for (var s in r.insteadofdelete) { o = !0; var i = r.insteadofdelete[s]; i && (i.funcid ? A.fn[i.funcid](n) : i.statement && i.statement.execute(e)) } if (!o) { if (this.pk) { var u = this.pk, c = u.onrightfn(n); if (void 0 === this.uniqs[u.hh][c]) throw new Error("Something wrong with primary key index on table"); this.uniqs[u.hh][c] = void 0 } r.uk && r.uk.length && r.uk.forEach(function (e) { var t = e.onrightfn(n); if (void 0 === r.uniqs[e.hh][t]) throw new Error("Something wrong with unique index on table"); r.uniqs[e.hh][t] = void 0 }) } }, o.deleteall = function () { this.data.length = 0, this.pk && (this.uniqs[this.pk.hh] = {}), o.uk && o.uk.length && o.uk.forEach(function (e) { o.uniqs[e.hh] = {} }) }, o.update = function (t, r, n) { var a, s = F(this.data[r]); if (this.pk && (a = this.pk, a.pkaddr = a.onrightfn(s, n), void 0 === this.uniqs[a.hh][a.pkaddr])) throw new Error("Something wrong with index on table"); o.uk && o.uk.length && o.uk.forEach(function (e) { if (e.ukaddr = e.onrightfn(s), void 0 === o.uniqs[e.hh][e.ukaddr]) throw new Error("Something wrong with unique index on table") }), t(s, n, A); var i = !1; for (var u in o.beforeupdate) { var c = o.beforeupdate[u]; c && (c.funcid ? !1 === A.fn[c.funcid](this.data[r], s) && (i = i || !0) : c.statement && !1 === c.statement.execute(e) && (i = i || !0)) } if (i) return !1; var l = !1; for (var u in o.insteadofupdate) { l = !0; var c = o.insteadofupdate[u]; c && (c.funcid ? A.fn[c.funcid](this.data[r], s) : c.statement && c.statement.execute(e)) } if (!l) { if (o.checks && o.checks.length > 0 && o.checks.forEach(function (e) { if (!e.fn(s)) throw new Error("Violation of CHECK constraint " + (e.id || "")) }), o.columns.forEach(function (e) { if (e.notnull && void 0 === s[e.columnid]) throw new Error("Wrong NULL value in NOT NULL column " + e.columnid) }), this.pk && (a.newpkaddr = a.onrightfn(s), void 0 !== this.uniqs[a.hh][a.newpkaddr] && a.newpkaddr !== a.pkaddr)) throw new Error("Record already exists"); o.uk && o.uk.length && o.uk.forEach(function (e) { if (e.newukaddr = e.onrightfn(s), void 0 !== o.uniqs[e.hh][e.newukaddr] && e.newukaddr !== e.ukaddr) throw new Error("Record already exists") }), this.pk && (this.uniqs[a.hh][a.pkaddr] = void 0, this.uniqs[a.hh][a.newpkaddr] = s), o.uk && o.uk.length && o.uk.forEach(function (e) { o.uniqs[e.hh][e.ukaddr] = void 0, o.uniqs[e.hh][e.newukaddr] = s }), this.data[r] = s; for (var u in o.afterupdate) { var c = o.afterupdate[u]; c && (c.funcid ? A.fn[c.funcid](this.data[r], s) : c.statement && c.statement.execute(e)) } } }; var h; return A.options.nocount || (h = 1), r && (h = r(h)), h
        }, A.fn.Date = Object, A.fn.Date = Date, A.fn.Number = Number, A.fn.String = String, A.fn.Boolean = Boolean, ie.EXTEND = A.utils.extend, ie.CHAR = String.fromCharCode.bind(String), ie.ASCII = function (e) { return e.charCodeAt(0) }, ie.COALESCE = function () { for (var e = 0; e < arguments.length; e++)if (void 0 !== arguments[e] && ("number" != typeof arguments[e] || !isNaN(arguments[e]))) return arguments[e] }, ie.USER = function () { return "alasql" }, ie.OBJECT_ID = function (e) { return !!A.tables[e] }, ie.DATE = function (e) { return /\d{8}/.test(e) ? new Date(+e.substr(0, 4), +e.substr(4, 2) - 1, +e.substr(6, 2)) : new Date(e) }, ie.NOW = function () { var e = new Date, t = e.getFullYear() + "." + ("0" + (e.getMonth() + 1)).substr(-2) + "." + ("0" + e.getDate()).substr(-2); return t += " " + ("0" + e.getHours()).substr(-2) + ":" + ("0" + e.getMinutes()).substr(-2) + ":" + ("0" + e.getSeconds()).substr(-2), t += "." + ("00" + e.getMilliseconds()).substr(-3) }, ie.GETDATE = ie.NOW, ie.CURRENT_TIMESTAMP = ie.NOW, ie.SECOND = function (e) { var e = new Date(e); return e.getSeconds() }, ie.MINUTE = function (e) { var e = new Date(e); return e.getMinutes() }, ie.HOUR = function (e) { var e = new Date(e); return e.getHours() }, ie.DAYOFWEEK = ie.WEEKDAY = function (e) { var e = new Date(e); return e.getDay() }, ie.DAY = ie.DAYOFMONTH = function (e) { var e = new Date(e); return e.getDate() }, ie.MONTH = function (e) { var e = new Date(e); return e.getMonth() + 1 }, ie.YEAR = function (e) { var e = new Date(e); return e.getFullYear() }; var le = { year: 31536e6, quarter: 7884e6, month: 2592e6, week: 6048e5, day: 864e5, dayofyear: 864e5, weekday: 864e5, hour: 36e5, minute: 6e4, second: 1e3, millisecond: 1, microsecond: .001 }; A.stdfn.DATEDIFF = function (e, t, r) { return (new Date(r).getTime() - new Date(t).getTime()) / le[e.toLowerCase()] }, A.stdfn.DATEADD = function (e, t, r) { var n = new Date(r).getTime() + t * le[e.toLowerCase()]; return new Date(n) }, A.stdfn.INTERVAL = function (e, t) { return e * le[t.toLowerCase()] }, A.stdfn.DATE_ADD = A.stdfn.ADDDATE = function (e, t) { var r = new Date(e).getTime() + t; return new Date(r) }, A.stdfn.DATE_SUB = A.stdfn.SUBDATE = function (e, t) { var r = new Date(e).getTime() - t; return new Date(r) }, Q.DropTable = function (e) { return Q.extend(this, e) }, Q.DropTable.prototype.toString = function () { var e = "DROP "; return this.view ? e += "VIEW" : e += "TABLE", this.ifexists && (e += " IF EXISTS"), e += " " + this.tables.toString() }, Q.DropTable.prototype.execute = function (e, t, r) { var n = this.ifexists, a = 0, s = 0, i = this.tables.length; return this.tables.forEach(function (t) { var o = A.databases[t.databaseid || e], u = t.tableid; if (!n || n && o.tables[u]) { if (o.tables[u]) o.engineid ? A.engines[o.engineid].dropTable(t.databaseid || e, u, n, function (e) { delete o.tables[u], a += e, ++s == i && r && r(a) }) : (delete o.tables[u], a++, ++s == i && r && r(a)); else if (!A.options.dropifnotexists) throw new Error("Can not drop table '" + t.tableid + "', because it does not exist in the database.") } else ++s == i && r && r(a) }), a }, Q.TruncateTable = function (e) { return Q.extend(this, e) }, Q.TruncateTable.prototype.toString = function () { var e = "TRUNCATE TABLE"; return e += " " + this.table.toString() }, Q.TruncateTable.prototype.execute = function (e, t, r) { var n = A.databases[this.table.databaseid || e], a = this.table.tableid; if (n.engineid) return A.engines[n.engineid].truncateTable(this.table.databaseid || e, a, this.ifexists, r); if (!n.tables[a]) throw new Error("Cannot truncate table becaues it does not exist"); return n.tables[a].data = [], r ? r(0) : 0 }, Q.CreateVertex = function (e) { return Q.extend(this, e) }, Q.CreateVertex.prototype.toString = function () { var e = "CREATE VERTEX "; return this.class && (e += this.class + " "), this.sharp && (e += "#" + this.sharp + " "), this.sets ? e += this.sets.toString() : this.content ? e += this.content.toString() : this.select && (e += this.select.toString()), e }, Q.CreateVertex.prototype.toJS = function (e) { return "this.queriesfn[" + (this.queriesidx - 1) + "](this.params,null," + e + ")" }, Q.CreateVertex.prototype.compile = function (e) { var t = e, r = this.sharp; if (void 0 !== this.name) var n = "x.name=" + this.name.toJS(), a = new Function("x", n); if (this.sets && this.sets.length > 0) var n = this.sets.map(function (e) { return "x['" + e.column.columnid + "']=" + e.expression.toJS("x", "") }).join(";"), s = new Function("x,params,alasql", n); return function (e, n) { var i, o, u = A.databases[t]; o = void 0 !== r ? r : u.counter++; var c = { $id: o, $node: "VERTEX" }; return u.objects[c.$id] = c, i = c, a && a(c), s && s(c, e, A), n && (i = n(i)), i } }, Q.CreateEdge = function (e) { return Q.extend(this, e) }, Q.CreateEdge.prototype.toString = function () { var e = "CREATE EDGE "; return this.class && (e += this.class + " "), e }, Q.CreateEdge.prototype.toJS = function (e) { return "this.queriesfn[" + (this.queriesidx - 1) + "](this.params,null," + e + ")" }, Q.CreateEdge.prototype.compile = function (e) { var t = e, r = new Function("params,alasql", "var y;return " + this.from.toJS()), n = new Function("params,alasql", "var y;return " + this.to.toJS()); if (void 0 !== this.name) var a = "x.name=" + this.name.toJS(), s = new Function("x", a); if (this.sets && this.sets.length > 0) var a = this.sets.map(function (e) { return "x['" + e.column.columnid + "']=" + e.expression.toJS("x", "") }).join(";"), i = new Function("x,params,alasql", "var y;" + a); return function (e, a) { var o = 0, u = A.databases[t], c = { $id: u.counter++, $node: "EDGE" }, l = r(e, A), h = n(e, A); return c.$in = [l.$id], c.$out = [h.$id], void 0 === l.$out && (l.$out = []), l.$out.push(c.$id), void 0 === typeof h.$in && (h.$in = []), h.$in.push(c.$id), u.objects[c.$id] = c, o = c, s && s(c), i && i(c, e, A), a && (o = a(o)), o } }, Q.CreateGraph = function (e) { return Q.extend(this, e) }, Q.CreateGraph.prototype.toString = function () { var e = "CREATE GRAPH "; return this.class && (e += this.class + " "), e }, Q.CreateGraph.prototype.execute = function (e, t, r) { function n(e) { var t = A.databases[A.useid].objects; for (var r in t) if (t[r].name === e) return t[r] } function a(r) { var n = {}; void 0 !== r.as && (A.vars[r.as] = n), void 0 !== r.prop && (n.$id = r.prop, n.name = r.prop), void 0 !== r.sharp && (n.$id = r.sharp), void 0 !== r.name && (n.name = r.name), void 0 !== r.class && (n.$class = r.class); var a = A.databases[e]; if (void 0 === n.$id && (n.$id = a.counter++), n.$node = "VERTEX", void 0 !== r.json && G(n, new Function("params,alasql", "var y;return " + r.json.toJS())(t, A)), a.objects[n.$id] = n, void 0 !== n.$class) { if (void 0 === A.databases[e].tables[n.$class]) throw new Error("No such class. Pleace use CREATE CLASS"); A.databases[e].tables[n.$class].data.push(n) } return s.push(n.$id), n } var s = []; return this.from && A.from[this.from.funcid] && (this.graph = A.from[this.from.funcid.toUpperCase()]), this.graph.forEach(function (r) { if (r.source) { var i = {}; void 0 !== r.as && (A.vars[r.as] = i), void 0 !== r.prop && (i.name = r.prop), void 0 !== r.sharp && (i.$id = r.sharp), void 0 !== r.name && (i.name = r.name), void 0 !== r.class && (i.$class = r.class); var o = A.databases[e]; void 0 === i.$id && (i.$id = o.counter++), i.$node = "EDGE", void 0 !== r.json && G(i, new Function("params,alasql", "var y;return " + r.json.toJS())(t, A)); var u; if (r.source.vars) { var c = A.vars[r.source.vars]; u = "object" == typeof c ? c : o.objects[c] } else { var l = r.source.sharp; void 0 === l && (l = r.source.prop), u = A.databases[e].objects[l], void 0 !== u || !A.options.autovertex || void 0 === r.source.prop && void 0 === r.source.name || void 0 === (u = n(r.source.prop || r.source.name)) && (u = a(r.source)) } var h; if (r.source.vars) { var c = A.vars[r.target.vars]; h = "object" == typeof c ? c : o.objects[c] } else { var d = r.target.sharp; void 0 === d && (d = r.target.prop), h = A.databases[e].objects[d], void 0 !== h || !A.options.autovertex || void 0 === r.target.prop && void 0 === r.target.name || void 0 === (h = n(r.target.prop || r.target.name)) && (h = a(r.target)) } if (i.$in = [u.$id], i.$out = [h.$id], void 0 === u.$out && (u.$out = []), u.$out.push(i.$id), void 0 === h.$in && (h.$in = []), h.$in.push(i.$id), o.objects[i.$id] = i, void 0 !== i.$class) { if (void 0 === A.databases[e].tables[i.$class]) throw new Error("No such class. Pleace use CREATE CLASS"); A.databases[e].tables[i.$class].data.push(i) } s.push(i.$id) } else a(r) }), r && (s = r(s)), s }, Q.CreateGraph.prototype.compile1 = function (e) { var t = e, r = new Function("params,alasql", "var y;return " + this.from.toJS()), n = new Function("params,alasql", "var y;return " + this.to.toJS()); if (void 0 !== this.name) var a = "x.name=" + this.name.toJS(), s = new Function("x", a); if (this.sets && this.sets.length > 0) var a = this.sets.map(function (e) { return "x['" + e.column.columnid + "']=" + e.expression.toJS("x", "") }).join(";"), i = new Function("x,params,alasql", "var y;" + a); return function (e, a) { var o = 0, u = A.databases[t], c = { $id: u.counter++, $node: "EDGE" }, l = r(e, A), h = n(e, A); return c.$in = [l.$id], c.$out = [h.$id], void 0 === l.$out && (l.$out = []), l.$out.push(c.$id), void 0 === h.$in && (h.$in = []), h.$in.push(c.$id), u.objects[c.$id] = c, o = c, s && s(c), i && i(c, e, A), a && (o = a(o)), o } }, Q.AlterTable = function (e) { return Q.extend(this, e) }, Q.AlterTable.prototype.toString = function () { var e = "ALTER TABLE " + this.table.toString(); return this.renameto && (e += " RENAME TO " + this.renameto), e }, Q.AlterTable.prototype.execute = function (e, t, r) { var n = A.databases[e]; if (n.dbversion = Date.now(), this.renameto) { var a = this.table.tableid, s = this.renameto, i = 1; if (n.tables[s]) throw new Error("Can not rename a table '" + a + "' to '" + s + "', because the table with this name already exists"); if (s == a) throw new Error("Can not rename a table '" + a + "' to itself"); return n.tables[s] = n.tables[a], delete n.tables[a], i = 1, r && r(i), i } if (this.addcolumn) { var n = A.databases[this.table.databaseid || e]; n.dbversion++; var o = this.table.tableid, u = n.tables[o], c = this.addcolumn.columnid; if (u.xcolumns[c]) throw new Error('Cannot add column "' + c + '", because it already exists in the table "' + o + '"'); var l = { columnid: c, dbtypeid: this.dbtypeid, dbsize: this.dbsize, dbprecision: this.dbprecision, dbenum: this.dbenum, defaultfns: null }; u.columns.push(l), u.xcolumns[c] = l; for (var h = 0, d = u.data.length; h < d; h++)u.data[h][c] = void 0; return r ? r(1) : 1 } if (this.modifycolumn) { var n = A.databases[this.table.databaseid || e]; n.dbversion++; var o = this.table.tableid, u = n.tables[o], c = this.modifycolumn.columnid; if (!u.xcolumns[c]) throw new Error('Cannot modify column "' + c + '", because it was not found in the table "' + o + '"'); var l = u.xcolumns[c]; return l.dbtypeid = this.dbtypeid, l.dbsize = this.dbsize, l.dbprecision = this.dbprecision, l.dbenum = this.dbenum, r ? r(1) : 1 } if (this.renamecolumn) { var n = A.databases[this.table.databaseid || e]; n.dbversion++; var l, o = this.table.tableid, u = n.tables[o], c = this.renamecolumn, f = this.to; if (!u.xcolumns[c]) throw new Error('Column "' + c + '" is not found in the table "' + o + '"'); if (u.xcolumns[f]) throw new Error('Column "' + f + '" already exists in the table "' + o + '"'); if (c != f) { for (var p = 0; p < u.columns.length; p++)u.columns[p].columnid == c && (u.columns[p].columnid = f); u.xcolumns[f] = u.xcolumns[c], delete u.xcolumns[c]; for (var h = 0, d = u.data.length; h < d; h++)u.data[h][f] = u.data[h][c], delete u.data[h][c]; return u.data.length } return r ? r(0) : 0 } if (this.dropcolumn) { var n = A.databases[this.table.databaseid || e]; n.dbversion++; for (var o = this.table.tableid, u = n.tables[o], c = this.dropcolumn, b = !1, p = 0; p < u.columns.length; p++)if (u.columns[p].columnid == c) { b = !0, u.columns.splice(p, 1); break } if (!b) throw new Error('Cannot drop column "' + c + '", because it was not found in the table "' + o + '"'); delete u.xcolumns[c]; for (var h = 0, d = u.data.length; h < d; h++)delete u.data[h][c]; return r ? r(u.data.length) : u.data.length } throw Error("Unknown ALTER TABLE method") }, Q.CreateIndex = function (e) { return Q.extend(this, e) }, Q.CreateIndex.prototype.toString = function () { var e = "CREATE"; return this.unique && (e += " UNIQUE"), e += " INDEX " + this.indexid + " ON " + this.table.toString(), e += "(" + this.columns.toString() + ")" }, Q.CreateIndex.prototype.execute = function (e, t, r) { var n = A.databases[e], a = this.table.tableid, s = n.tables[a], i = this.indexid; n.indices[i] = a; var o = this.columns.map(function (e) { return e.expression.toJS("r", "") }).join("+'`'+"), u = new Function("r,params,alasql", "return " + o); if (this.unique) { s.uniqdefs[i] = { rightfns: o }; var c = s.uniqs[i] = {}; if (s.data.length > 0) for (var l = 0, h = s.data.length; l < h; l++) { var d = o(s.data[l]); c[d] || (c[d] = { num: 0 }), c[d].num++ } } else { var f = D(o); s.inddefs[i] = { rightfns: o, hh: f }, s.indices[f] = {}; var p = s.indices[f] = {}; if (s.data.length > 0) for (var l = 0, h = s.data.length; l < h; l++) { var d = u(s.data[l], t, A); p[d] || (p[d] = []), p[d].push(s.data[l]) } } var b = 1; return r && (b = r(b)), b }, Q.Reindex = function (e) { return Q.extend(this, e) }, Q.Reindex.prototype.toString = function () { return "REINDEX " + this.indexid }, Q.Reindex.prototype.execute = function (e, t, r) { var n = A.databases[e], a = this.indexid, s = n.indices[a]; n.tables[s].indexColumns(); var i = 1; return r && (i = r(i)), i }, Q.DropIndex = function (e) { return Q.extend(this, e) }, Q.DropIndex.prototype.toString = function () { return "DROP INDEX" + this.indexid }, Q.DropIndex.prototype.compile = function (e) { this.indexid; return function () { return 1 } }, Q.WithSelect = function (e) { return Q.extend(this, e) }, Q.WithSelect.prototype.toString = function () { var e = "WITH "; return e += this.withs.map(function (e) { return e.name + " AS (" + e.select.toString() + ")" }).join(",") + " ", e += this.select.toString() }, Q.WithSelect.prototype.execute = function (e, t, r) { var n = this, a = []; n.withs.forEach(function (r) { a.push(A.databases[e].tables[r.name]), (A.databases[e].tables[r.name] = new X({ tableid: r.name })).data = r.select.execute(e, t) }); return this.select.execute(e, t, function (t) { return n.withs.forEach(function (t, r) { a[r] ? A.databases[e].tables[t.name] = a[r] : delete A.databases[e].tables[t.name] }), r && (t = r(t)), t }) }, Q.If = function (e) { return Q.extend(this, e) }, Q.If.prototype.toString = function () { var e = "IF "; return e += this.expression.toString(), e += " " + this.thenstat.toString(), this.elsestat && (e += " ELSE " + this.thenstat.toString()), e }, Q.If.prototype.execute = function (e, t, r) { var n; return new Function("params,alasql,p", "var y;return " + this.expression.toJS("({})", "", null)).bind(this)(t, A) ? n = this.thenstat.execute(e, t, r) : this.elsestat ? n = this.elsestat.execute(e, t, r) : r && (n = r(n)), n }, Q.While = function (e) { return Q.extend(this, e) }, Q.While.prototype.toString = function () { var e = "WHILE "; return e += this.expression.toString(), e += " " + this.loopstat.toString() }, Q.While.prototype.execute = function (e, t, r) { function n(u) { o ? s.push(u) : o = !0, setTimeout(function () { i(t, A) ? a.loopstat.execute(e, t, n) : s = r(s) }, 0) } var a = this, s = [], i = new Function("params,alasql,p", "var y;return " + this.expression.toJS()); if (r) { var o = !1; n() } else for (; i(t, A);) { var u = a.loopstat.execute(e, t); s.push(u) } return s }, Q.Break = function (e) { return Q.extend(this, e) }, Q.Break.prototype.toString = function () { return "BREAK" }, Q.Break.prototype.execute = function (e, t, r, n) { var a = 1; return r && (a = r(a)), a }, Q.Continue = function (e) { return Q.extend(this, e) }, Q.Continue.prototype.toString = function () { return "CONTINUE" }, Q.Continue.prototype.execute = function (e, t, r, n) { var a = 1; return r && (a = r(a)), a }, Q.BeginEnd = function (e) { return Q.extend(this, e) }, Q.BeginEnd.prototype.toString = function () { return "BEGIN " + this.statements.toString() + " END" }, Q.BeginEnd.prototype.execute = function (e, t, r, n) { function a() { s.statements[o].execute(e, t, function (e) { if (i.push(e), ++o < s.statements.length) return a(); r && (i = r(i)) }) } var s = this, i = [], o = 0; return a(), i }, Q.Insert = function (e) { return Q.extend(this, e) }, Q.Insert.prototype.toString = function () { var e = "INSERT "; return this.orreplace && (e += "OR REPLACE "), this.replaceonly && (e = "REPLACE "), e += "INTO " + this.into.toString(), this.columns && (e += "(" + this.columns.toString() + ")"), this.values && (e += " VALUES " + this.values.toString()), this.select && (e += " " + this.select.toString()), e }, Q.Insert.prototype.toJS = function (e, t, r) { return "this.queriesfn[" + (this.queriesidx - 1) + "](this.params,null," + e + ")" }, Q.Insert.prototype.compile = function (e) { var t = this; e = t.into.databaseid || e; var r = A.databases[e], n = t.into.tableid, a = r.tables[n]; if (!a) throw "Table '" + n + "' could not be found"; var s, i = "", o = "", i = "db.tables['" + n + "'].dirty=true;", u = "var a,aa=[],x;"; if (this.values) { this.exists && (this.existsfn = this.exists.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })), this.queries && (this.queriesfn = this.queries.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })), t.values.forEach(function (s) { var u = []; t.columns ? t.columns.forEach(function (e, t) { var r = "'" + e.columnid + "':"; a.xcolumns && a.xcolumns[e.columnid] ? ["INT", "FLOAT", "NUMBER", "MONEY"].indexOf(a.xcolumns[e.columnid].dbtypeid) >= 0 ? r += "(x=" + s[t].toJS() + ",x==undefined?undefined:+x)" : A.fn[a.xcolumns[e.columnid].dbtypeid] ? (r += "(new " + a.xcolumns[e.columnid].dbtypeid + "(", r += s[t].toJS(), r += "))") : r += s[t].toJS() : r += s[t].toJS(), u.push(r) }) : Array.isArray(s) && a.columns && a.columns.length > 0 ? a.columns.forEach(function (e, t) { var r = "'" + e.columnid + "':";["INT", "FLOAT", "NUMBER", "MONEY"].indexOf(e.dbtypeid) >= 0 ? r += "+" + s[t].toJS() : A.fn[e.dbtypeid] ? (r += "(new " + e.dbtypeid + "(", r += s[t].toJS(), r += "))") : r += s[t].toJS(), u.push(r) }) : o = E(s), r.tables[n].defaultfns && u.unshift(r.tables[n].defaultfns), i += o ? "a=" + o + ";" : "a={" + u.join(",") + "};", r.tables[n].isclass && (i += "var db=alasql.databases['" + e + "'];", i += 'a.$class="' + n + '";', i += "a.$id=db.counter++;", i += "db.objects[a.$id]=a;"), r.tables[n].insert ? (i += "var db=alasql.databases['" + e + "'];", i += "db.tables['" + n + "'].insert(a," + (t.orreplace ? "true" : "false") + ");") : i += "aa.push(a);" }), s = u + i, r.tables[n].insert || (i += "alasql.databases['" + e + "'].tables['" + n + "'].data=alasql.databases['" + e + "'].tables['" + n + "'].data.concat(aa);"), r.tables[n].insert && r.tables[n].isclass ? i += "return a.$id;" : i += "return " + t.values.length; var c = new Function("db, params, alasql", "var y;" + u + i).bind(this) } else if (this.select) { this.select.modifier = "RECORDSET"; var l = this.select.compile(e); if (r.engineid && A.engines[r.engineid].intoTable) { var h = function (e, t) { var a = l(e); return A.engines[r.engineid].intoTable(r.databaseid, n, a.data, null, t) }; return h } var d = "return alasql.utils.extend(r,{" + a.defaultfns + "})", f = new Function("r,db,params,alasql", d), c = function (e, r, a) { var s = l(r).data; if (e.tables[n].insert) for (var i = 0, o = s.length; i < o; i++) { var u = F(s[i]); f(u, e, r, a), e.tables[n].insert(u, t.orreplace) } else e.tables[n].data = e.tables[n].data.concat(s); return a.options.nocount ? void 0 : s.length } } else { if (!this.default) throw new Error("Wrong INSERT parameters"); var p = "db.tables['" + n + "'].data.push({" + a.defaultfns + "});return 1;", c = new Function("db,params,alasql", p) } if (r.engineid && A.engines[r.engineid].intoTable && A.options.autocommit) var h = function (e, t) { var a = new Function("db,params", "var y;" + s + "return aa;")(r, e); return A.engines[r.engineid].intoTable(r.databaseid, n, a, null, t) }; else var h = function (t, r) { var a = A.databases[e]; A.options.autocommit && a.engineid && A.engines[a.engineid].loadTableData(e, n); var s = c(a, t, A); return A.options.autocommit && a.engineid && A.engines[a.engineid].saveTableData(e, n), A.options.nocount && (s = void 0), r && r(s), s }; return h }, Q.Insert.prototype.execute = function (e, t, r) { return this.compile(e)(t, r) }, Q.CreateTrigger = function (e) { return Q.extend(this, e) }, Q.CreateTrigger.prototype.toString = function () { var e = "CREATE TRIGGER " + this.trigger + " "; return this.when && (e += this.when + " "), e += this.action + " ON ", this.table.databaseid && (e += this.table.databaseid + "."), e += this.table.tableid + " ", e += this.statement.toString() }, Q.CreateTrigger.prototype.execute = function (e, t, r) { var n = 1, a = this.trigger; e = this.table.databaseid || e; var s = A.databases[e], i = this.table.tableid, o = { action: this.action, when: this.when, statement: this.statement, funcid: this.funcid }; return s.triggers[a] = o, "INSERT" == o.action && "BEFORE" == o.when ? s.tables[i].beforeinsert[a] = o : "INSERT" == o.action && "AFTER" == o.when ? s.tables[i].afterinsert[a] = o : "INSERT" == o.action && "INSTEADOF" == o.when ? s.tables[i].insteadofinsert[a] = o : "DELETE" == o.action && "BEFORE" == o.when ? s.tables[i].beforedelete[a] = o : "DELETE" == o.action && "AFTER" == o.when ? s.tables[i].afterdelete[a] = o : "DELETE" == o.action && "INSTEADOF" == o.when ? s.tables[i].insteadofdelete[a] = o : "UPDATE" == o.action && "BEFORE" == o.when ? s.tables[i].beforeupdate[a] = o : "UPDATE" == o.action && "AFTER" == o.when ? s.tables[i].afterupdate[a] = o : "UPDATE" == o.action && "INSTEADOF" == o.when && (s.tables[i].insteadofupdate[a] = o), r && (n = r(n)), n }, Q.DropTrigger = function (e) { return Q.extend(this, e) }, Q.DropTrigger.prototype.toString = function () { return "DROP TRIGGER " + this.trigger }, Q.DropTrigger.prototype.execute = function (e, t, r) { var n = 0, a = A.databases[e], s = this.trigger, i = a.triggers[s]; if (!i) throw new Error("Trigger not found"); return n = 1, delete a.tables[i].beforeinsert[s], delete a.tables[i].afterinsert[s], delete a.tables[i].insteadofinsert[s], delete a.tables[i].beforedelte[s], delete a.tables[i].afterdelete[s], delete a.tables[i].insteadofdelete[s], delete a.tables[i].beforeupdate[s], delete a.tables[i].afterupdate[s], delete a.tables[i].insteadofupdate[s], delete a.triggers[s], r && (n = r(n)), n }, Q.Delete = function (e) { return Q.extend(this, e) }, Q.Delete.prototype.toString = function () { var e = "DELETE FROM " + this.table.toString(); return this.where && (e += " WHERE " + this.where.toString()), e }, Q.Delete.prototype.compile = function (e) { e = this.table.databaseid || e; var t, r = this.table.tableid, n = A.databases[e]; if (this.where) { this.exists && (this.existsfn = this.exists.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })), this.queries && (this.queriesfn = this.queries.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })); var a = new Function("r,params,alasql", "var y;return (" + this.where.toJS("r", "") + ")").bind(this); t = function (t, s) { if (n.engineid && A.engines[n.engineid].deleteFromTable) return A.engines[n.engineid].deleteFromTable(e, r, a, t, s); A.options.autocommit && n.engineid && "LOCALSTORAGE" == n.engineid && A.engines[n.engineid].loadTableData(e, r); for (var i = n.tables[r], o = i.data.length, u = [], c = 0, l = i.data.length; c < l; c++)a(i.data[c], t, A) ? i.delete && i.delete(c, t, A) : u.push(i.data[c]); i.data = u; for (var h in i.afterdelete) { var d = i.afterdelete[h]; d && (d.funcid ? A.fn[d.funcid]() : d.statement && d.statement.execute(e)) } var f = o - i.data.length; return A.options.autocommit && n.engineid && "LOCALSTORAGE" == n.engineid && A.engines[n.engineid].saveTableData(e, r), s && s(f), f } } else t = function (t, a) { A.options.autocommit && n.engineid && A.engines[n.engineid].loadTableData(e, r), n.tables[r].dirty = !0; var s = n.tables[r].data.length; n.tables[r].data.length = 0; for (var i in n.tables[r].uniqs) n.tables[r].uniqs[i] = {}; for (var i in n.tables[r].indices) n.tables[r].indices[i] = {}; return A.options.autocommit && n.engineid && A.engines[n.engineid].saveTableData(e, r), a && a(s), s }; return t }, Q.Delete.prototype.execute = function (e, t, r) { return this.compile(e)(t, r) }, Q.Update = function (e) { return Q.extend(this, e) }, Q.Update.prototype.toString = function () { var e = "UPDATE " + this.table.toString(); return this.columns && (e += " SET " + this.columns.toString()), this.where && (e += " WHERE " + this.where.toString()), e }, Q.SetColumn = function (e) { return Q.extend(this, e) }, Q.SetColumn.prototype.toString = function () { return this.column.toString() + "=" + this.expression.toString() }, Q.Update.prototype.compile = function (e) { e = this.table.databaseid || e; var t = this.table.tableid; if (this.where) { this.exists && (this.existsfn = this.exists.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })), this.queries && (this.queriesfn = this.queries.map(function (t) { var r = t.compile(e); return r.query.modifier = "RECORDSET", r })); var r = new Function("r,params,alasql", "var y;return " + this.where.toJS("r", "")).bind(this) } var n = A.databases[e].tables[t].onupdatefns || ""; n += ";", this.columns.forEach(function (e) { n += "r['" + e.column.columnid + "']=" + e.expression.toJS("r", "") + ";" }); var a = new Function("r,params,alasql", "var y;" + n); return function (n, s) { var i = A.databases[e]; if (i.engineid && A.engines[i.engineid].updateTable) return A.engines[i.engineid].updateTable(e, t, a, r, n, s); A.options.autocommit && i.engineid && A.engines[i.engineid].loadTableData(e, t); var o = i.tables[t]; if (!o) throw new Error("Table '" + t + "' not exists"); for (var u = 0, c = 0, l = o.data.length; c < l; c++)r && !r(o.data[c], n, A) || (o.update ? o.update(a, c, n) : a(o.data[c], n, A), u++); return A.options.autocommit && i.engineid && A.engines[i.engineid].saveTableData(e, t), s && s(u), u } }, Q.Update.prototype.execute = function (e, t, r) { return this.compile(e)(t, r) }, Q.Merge = function (e) { return Q.extend(this, e) }, Q.Merge.prototype.toString = function () { var e = "MERGE "; return e += this.into.tableid + " ", this.into.as && (e += "AS " + this.into.as + " "), e += "USING " + this.using.tableid + " ", this.using.as && (e += "AS " + this.using.as + " "), e += "ON " + this.on.toString() + " ", this.matches.forEach(function (t) { e += "WHEN ", t.matched || (e += "NOT "), e += "MATCHED ", t.bytarget && (e += "BY TARGET "), t.bysource && (e += "BY SOURCE "), t.expr && (e += "AND " + t.expr.toString() + " "), e += "THEN ", t.action.delete && (e += "DELETE "), t.action.insert && (e += "INSERT ", t.action.columns && (e += "(" + t.action.columns.toString() + ") "), t.action.values && (e += "VALUES (" + t.action.values.toString() + ") "), t.action.defaultvalues && (e += "DEFAULT VALUES ")), t.action.update && (e += "UPDATE ", e += t.action.update.map(function (e) { return e.toString() }).join(",") + " ") }), e }, Q.Merge.prototype.execute = function (e, t, r) { var n = 1; return r && (n = r(n)), n }, Q.CreateDatabase = function (e) { return Q.extend(this, e) }, Q.CreateDatabase.prototype.toString = function () { var e = "CREATE"; return this.engineid && (e += " " + this.engineid), e += " DATABASE", this.ifnotexists && (e += " IF NOT EXISTS"), e += " " + this.databaseid, this.args && this.args.length > 0 && (e += "(" + this.args.map(function (e) { return e.toString() }).join(", ") + ")"), this.as && (e += " AS " + this.as), e }, Q.CreateDatabase.prototype.execute = function (e, t, r) { if (this.args && this.args.length > 0 && this.args.map(function (e) { return new Function("params,alasql", "var y;return " + e.toJS())(t, A) }), this.engineid) { var n = A.engines[this.engineid].createDatabase(this.databaseid, this.args, this.ifnotexists, this.as, r); return n } var a = this.databaseid; if (A.databases[a]) throw new Error("Database '" + a + "' already exists"); var n = (new A.Database(a), 1); return r ? r(n) : n }, Q.AttachDatabase = function (e) { return Q.extend(this, e) }, Q.AttachDatabase.prototype.toString = function () { var e = "ATTACH"; return this.engineid && (e += " " + this.engineid), e += " DATABASE " + this.databaseid, args && (e += "(", args.length > 0 && (e += args.map(function (e) { return e.toString() }).join(", ")), e += ")"), this.as && (e += " AS " + this.as), e }, Q.AttachDatabase.prototype.execute = function (e, t, r) { if (!A.engines[this.engineid]) throw new Error('Engine "' + this.engineid + '" is not defined.'); return A.engines[this.engineid].attachDatabase(this.databaseid, this.as, this.args, t, r) }, Q.DetachDatabase = function (e) { return Q.extend(this, e) }, Q.DetachDatabase.prototype.toString = function () { var e = "DETACH"; return e += " DATABASE " + this.databaseid }, Q.DetachDatabase.prototype.execute = function (e, t, r) { if (!A.databases[this.databaseid].engineid) throw new Error('Cannot detach database "' + this.engineid + '", because it was not attached.'); var n, a = this.databaseid; if (a == A.DEFAULTDATABASEID) throw new Error("Drop of default database is prohibited"); if (A.databases[a]) delete A.databases[a], a == A.useid && A.use(), n = 1; else { if (!this.ifexists) throw new Error("Database '" + a + "' does not exist"); n = 0 } return r && r(n), n }, Q.UseDatabase = function (e) { return Q.extend(this, e) }, Q.UseDatabase.prototype.toString = function () { return "USE DATABASE " + this.databaseid }, Q.UseDatabase.prototype.execute = function (e, t, r) { var n = this.databaseid; if (!A.databases[n]) throw new Error("Database '" + n + "' does not exist"); A.use(n); return r && r(1), 1 }, Q.DropDatabase = function (e) { return Q.extend(this, e) }, Q.DropDatabase.prototype.toString = function () { var e = "DROP"; return this.ifexists && (e += " IF EXISTS"), e += " DATABASE " + this.databaseid }, Q.DropDatabase.prototype.execute = function (e, t, r) { if (this.engineid) return A.engines[this.engineid].dropDatabase(this.databaseid, this.ifexists, r); var n, a = this.databaseid; if (a == A.DEFAULTDATABASEID) throw new Error("Drop of default database is prohibited"); if (A.databases[a]) { if (A.databases[a].engineid) throw new Error("Cannot drop database '" + a + "', because it is attached. Detach it."); delete A.databases[a], a == A.useid && A.use(), n = 1 } else { if (!this.ifexists) throw new Error("Database '" + a + "' does not exist"); n = 0 } return r && r(n), n }, Q.Declare = function (e) { return Q.extend(this, e) }, Q.Declare.prototype.toString = function () { var e = "DECLARE "; return this.declares && this.declares.length > 0 && (e = this.declares.map(function (e) { var t = ""; return t += "@" + e.variable + " ", t += e.dbtypeid, this.dbsize && (t += "(" + this.dbsize, this.dbprecision && (t += "," + this.dbprecision), t += ")"), e.expression && (t += " = " + e.expression.toString()), t }).join(",")), e }, Q.Declare.prototype.execute = function (e, t, r) { var n = 1; return this.declares && this.declares.length > 0 && this.declares.map(function (e) { var r = e.dbtypeid; A.fn[r] || (r = r.toUpperCase()), A.declares[e.variable] = { dbtypeid: r, dbsize: e.dbsize, dbprecision: e.dbprecision }, e.expression && (A.vars[e.variable] = new Function("params,alasql", "return " + e.expression.toJS("({})", "", null))(t, A), A.declares[e.variable] && (A.vars[e.variable] = A.stdfn.CONVERT(A.vars[e.variable], A.declares[e.variable]))) }), r && (n = r(n)), n }, Q.ShowDatabases = function (e) { return Q.extend(this, e) }, Q.ShowDatabases.prototype.toString = function () { var e = "SHOW DATABASES"; return this.like && (e += "LIKE " + this.like.toString()), e }, Q.ShowDatabases.prototype.execute = function (e, t, r) { if (this.engineid) return A.engines[this.engineid].showDatabases(this.like, r); var n = this, a = []; for (dbid in A.databases) a.push({ databaseid: dbid }); return n.like && a && a.length > 0 && (a = a.filter(function (e) { return A.utils.like(n.like.value, e.databaseid) })), r && r(a), a }, Q.ShowTables = function (e) { return Q.extend(this, e) }, Q.ShowTables.prototype.toString = function () { var e = "SHOW TABLES"; return this.databaseid && (e += " FROM " + this.databaseid), this.like && (e += " LIKE " + this.like.toString()), e }, Q.ShowTables.prototype.execute = function (e, t, r) { var n = A.databases[this.databaseid || e], a = this, s = []; for (tableid in n.tables) s.push({ tableid: tableid }); return a.like && s && s.length > 0 && (s = s.filter(function (e) { return A.utils.like(a.like.value, e.tableid) })), r && r(s), s }, Q.ShowColumns = function (e) { return Q.extend(this, e) }, Q.ShowColumns.prototype.toString = function () { var e = "SHOW COLUMNS"; return this.table.tableid && (e += " FROM " + this.table.tableid), this.databaseid && (e += " FROM " + this.databaseid), e },
            Q.ShowColumns.prototype.execute = function (e, t, r) { var n = A.databases[this.databaseid || e], a = n.tables[this.table.tableid]; if (a && a.columns) { var s = a.columns.map(function (e) { return { columnid: e.columnid, dbtypeid: e.dbtypeid, dbsize: e.dbsize } }); return r && r(s), s } return r && r([]), [] }, Q.ShowIndex = function (e) { return Q.extend(this, e) }, Q.ShowIndex.prototype.toString = function () { var e = "SHOW INDEX"; return this.table.tableid && (e += " FROM " + this.table.tableid), this.databaseid && (e += " FROM " + this.databaseid), e }, Q.ShowIndex.prototype.execute = function (e, t, r) { var n = A.databases[this.databaseid || e], a = n.tables[this.table.tableid], s = []; if (a && a.indices) for (var i in a.indices) s.push({ hh: i, len: Object.keys(a.indices[i]).length }); return r && r(s), s }, Q.ShowCreateTable = function (e) { return Q.extend(this, e) }, Q.ShowCreateTable.prototype.toString = function () { var e = "SHOW CREATE TABLE " + this.table.tableid; return this.databaseid && (e += " FROM " + this.databaseid), e }, Q.ShowCreateTable.prototype.execute = function (e) { var t = A.databases[this.databaseid || e], r = t.tables[this.table.tableid]; if (r) { var n = "CREATE TABLE " + this.table.tableid + " (", a = []; return r.columns && (r.columns.forEach(function (e) { var t = e.columnid + " " + e.dbtypeid; e.dbsize && (t += "(" + e.dbsize + ")"), e.primarykey && (t += " PRIMARY KEY"), a.push(t) }), n += a.join(", ")), n += ")" } throw new Error('There is no such table "' + this.table.tableid + '"') }, Q.SetVariable = function (e) { return Q.extend(this, e) }, Q.SetVariable.prototype.toString = function () { var e = "SET "; return void 0 !== this.value && (e += this.variable.toUpperCase() + " " + (this.value ? "ON" : "OFF")), this.expression && (e += this.method + this.variable + " = " + this.expression.toString()), e }, Q.SetVariable.prototype.execute = function (e, t, r) { if (void 0 !== this.value) { var n = this.value; "ON" == n ? n = !0 : "OFF" == n && (n = !1), A.options[this.variable] = n } else if (this.expression) { this.exists && (this.existsfn = this.exists.map(function (t) { var r = t.compile(e); return r.query && !r.query.modifier && (r.query.modifier = "RECORDSET"), r })), this.queries && (this.queriesfn = this.queries.map(function (t) { var r = t.compile(e); return r.query && !r.query.modifier && (r.query.modifier = "RECORDSET"), r })); var a = new Function("params,alasql", "return " + this.expression.toJS("({})", "", null)).bind(this)(t, A); if (A.declares[this.variable] && (a = A.stdfn.CONVERT(a, A.declares[this.variable])), this.props && this.props.length > 0) { if ("@" == this.method) var s = "alasql.vars['" + this.variable + "']"; else var s = "params['" + this.variable + "']"; s += this.props.map(function (e) { return "string" == typeof e ? "['" + e + "']" : "number" == typeof e ? "[" + e + "]" : "[" + e.toJS() + "]" }).join(), new Function("value,params,alasql", "var y;" + s + "=value")(a, t, A) } else "@" == this.method ? A.vars[this.variable] = a : t[this.variable] = a } var a = 1; return r && (a = r(a)), a }, A.test = function (e, t, r) { if (0 === arguments.length) return void A.log(A.con.results); if (1 === arguments.length) { var n = Date.now(); return r(), void A.con.log(Date.now() - n) } 2 === arguments.length && (r = t, t = 1); for (var n = Date.now(), a = 0; a < t; a++)r(); A.con.results[e] = Date.now() - n }, A.log = function (e, t) { var r = A.useid, n = A.options.logtarget; C.isNode && (n = "console"); var a; if (a = "string" == typeof e ? A(e, t) : e, "console" === n || C.isNode) "string" == typeof e && A.options.logprompt && console.log(r + ">", e), Array.isArray(a) && console.table ? console.table(a) : console.log(ce(a)); else { var s; s = "output" === n ? document.getElementsByTagName("output")[0] : "string" == typeof n ? document.getElementById(n) : n; var i = ""; if ("string" == typeof e && A.options.logprompt && (i += "<pre><code>" + A.pretty(e) + "</code></pre>"), Array.isArray(a)) if (0 === a.length) i += "<p>[ ]</p>"; else if ("object" != typeof a[0] || Array.isArray(a[0])) for (var o = 0, u = a.length; o < u; o++)i += "<p>" + g(a[o]) + "</p>"; else i += g(a); else i += g(a); s.innerHTML += i } }, A.clear = function () { var e = A.options.logtarget; if (C.isNode || C.isMeteorServer) console.clear && console.clear(); else { var t; t = "output" === e ? document.getElementsByTagName("output")[0] : "string" == typeof e ? document.getElementById(e) : e, t.innerHTML = "" } }, A.write = function (e) { var t = A.options.logtarget; if (C.isNode || C.isMeteorServer) console.log && console.log(e); else { var r; r = "output" === t ? document.getElementsByTagName("output")[0] : "string" == typeof t ? document.getElementById(t) : t, r.innerHTML += e } }, A.prompt = function (e, t, r) { if (C.isNode) throw new Error("The prompt not realized for Node.js"); var n = 0; if ("string" == typeof e && (e = document.getElementById(e)), "string" == typeof t && (t = document.getElementById(t)), t.textContent = A.useid, r) { A.prompthistory.push(r), n = A.prompthistory.length; try { var a = Date.now(); A.log(r), A.write('<p style="color:blue">' + (Date.now() - a) + " ms</p>") } catch (e) { A.write("<p>" + olduseid + "&gt;&nbsp;<b>" + sql + "</b></p>"), A.write('<p style="color:red">' + e + "<p>") } } var s = e.getBoundingClientRect().top + document.getElementsByTagName("body")[0].scrollTop; m(document.getElementsByTagName("body")[0], s, 500), e.onkeydown = function (r) { if (13 === r.which) { var a = e.value, s = A.useid; e.value = "", A.prompthistory.push(a), n = A.prompthistory.length; try { var i = Date.now(); A.log(a), A.write('<p style="color:blue">' + (Date.now() - i) + " ms</p>") } catch (e) { A.write("<p>" + s + "&gt;&nbsp;" + A.pretty(a, !1) + "</p>"), A.write('<p style="color:red">' + e + "<p>") } e.focus(), t.textContent = A.useid; var o = e.getBoundingClientRect().top + document.getElementsByTagName("body")[0].scrollTop; m(document.getElementsByTagName("body")[0], o, 500) } else 38 === r.which ? (n--, n < 0 && (n = 0), A.prompthistory[n] && (e.value = A.prompthistory[n], r.preventDefault())) : 40 === r.which && (n++, n >= A.prompthistory.length ? (n = A.prompthistory.length, e.value = "") : A.prompthistory[n] && (e.value = A.prompthistory[n], r.preventDefault())) } }, Q.BeginTransaction = function (e) { return Q.extend(this, e) }, Q.BeginTransaction.prototype.toString = function () { return "BEGIN TRANSACTION" }, Q.BeginTransaction.prototype.execute = function (e, t, r) { return A.databases[e].engineid ? A.engines[A.databases[A.useid].engineid].begin(e, r) : (r && r(1), 1) }, Q.CommitTransaction = function (e) { return Q.extend(this, e) }, Q.CommitTransaction.prototype.toString = function () { return "COMMIT TRANSACTION" }, Q.CommitTransaction.prototype.execute = function (e, t, r) { return A.databases[e].engineid ? A.engines[A.databases[A.useid].engineid].commit(e, r) : (r && r(1), 1) }, Q.RollbackTransaction = function (e) { return Q.extend(this, e) }, Q.RollbackTransaction.prototype.toString = function () { return "ROLLBACK TRANSACTION" }, Q.RollbackTransaction.prototype.execute = function (e, t, r) { return A.databases[e].engineid ? A.engines[A.databases[e].engineid].rollback(e, r) : (r && r(1), 1) }, A.options.tsql && (A.stdfn.OBJECT_ID = function (e, t) { void 0 === t && (t = "T"), t = t.toUpperCase(); var r = e.split("."), n = A.useid, a = r[0]; 2 == r.length && (n = r[0], a = r[1]); var s = A.databases[n].tables; n = A.databases[n].databaseid; for (var i in s) if (i == a) { if (s[i].view && "V" == t) return n + "." + i; if (!s[i].view && "T" == t) return n + "." + i; return } }), A.options.mysql, (A.options.mysql || A.options.sqlite) && (A.from.INFORMATION_SCHEMA = function (e, t, r, n, a) { if ("VIEWS" == e || "TABLES" == e) { var s = []; for (var i in A.databases) { var o = A.databases[i].tables; for (var u in o) (o[u].view && "VIEWS" == e || !o[u].view && "TABLES" == e) && s.push({ TABLE_CATALOG: i, TABLE_NAME: u }) } return r && (s = r(s, n, a)), s } throw new Error("Unknown INFORMATION_SCHEMA table") }), A.options.postgres, A.options.oracle, A.options.sqlite, A.into.SQL = function (e, t, r, n, a) { var s; "object" == typeof e && (t = e, e = void 0); var i = {}; if (A.utils.extend(i, t), void 0 === i.tableid) throw new Error("Table for INSERT TO is not defined."); var o = ""; 0 === n.length && "object" == typeof r[0] && (n = Object.keys(r[0]).map(function (e) { return { columnid: e } })); for (var u = 0, c = r.length; u < c; u++)o += "INSERT INTO " + t.tableid + "(", o += n.map(function (e) { return e.columnid }).join(","), o += ") VALUES (", o += n.map(function (e) { var t = r[u][e.columnid]; return e.typeid ? "STRING" !== e.typeid && "VARCHAR" !== e.typeid && "NVARCHAR" !== e.typeid && "CHAR" !== e.typeid && "NCHAR" !== e.typeid || (t = "'" + O(t) + "'") : "string" == typeof t && (t = "'" + O(t) + "'"), t }), o += ");\n"; return e = A.utils.autoExtFilename(e, "sql", t), s = A.utils.saveFile(e, o), a && (s = a(s)), s }, A.into.HTML = function (e, t, r, n, a) { var s = 1; if ("object" != typeof exports) { var i = { headers: !0 }; A.utils.extend(i, t); var o = document.querySelector(e); if (!o) throw new Error("Selected HTML element is not found"); 0 === n.length && "object" == typeof r[0] && (n = Object.keys(r[0]).map(function (e) { return { columnid: e } })); var u = document.createElement("table"), c = document.createElement("thead"); if (u.appendChild(c), i.headers) { for (var l = document.createElement("tr"), h = 0; h < n.length; h++) { var d = document.createElement("th"); d.textContent = n[h].columnid, l.appendChild(d) } c.appendChild(l) } var f = document.createElement("tbody"); u.appendChild(f); for (var p = 0; p < r.length; p++) { for (var l = document.createElement("tr"), h = 0; h < n.length; h++) { var d = document.createElement("td"); d.textContent = r[p][n[h].columnid], l.appendChild(d) } f.appendChild(l) } A.utils.domEmptyChildren(o), o.appendChild(u) } return a && (s = a(s)), s }, A.into.JSON = function (e, t, r, n, a) { var s = 1; "object" == typeof e && (t = e, e = void 0); var i = JSON.stringify(r); return e = A.utils.autoExtFilename(e, "json", t), s = A.utils.saveFile(e, i), a && (s = a(s)), s }, A.into.TXT = function (e, t, r, n, a) { 0 === n.length && r.length > 0 && (n = Object.keys(r[0]).map(function (e) { return { columnid: e } })), "object" == typeof e && (t = e, e = void 0); var s = r.length, i = ""; if (r.length > 0) { var o = n[0].columnid; i += r.map(function (e) { return e[o] }).join("\n") } return e = A.utils.autoExtFilename(e, "txt", t), s = A.utils.saveFile(e, i), a && (s = a(s)), s }, A.into.TAB = A.into.TSV = function (e, t, r, n, a) { var s = {}; return A.utils.extend(s, t), s.separator = "\t", e = A.utils.autoExtFilename(e, "tab", t), s.autoExt = !1, A.into.CSV(e, s, r, n, a) }, A.into.CSV = function (e, t, r, n, a) { 0 === n.length && r.length > 0 && (n = Object.keys(r[0]).map(function (e) { return { columnid: e } })), "object" == typeof e && (t = e, e = void 0); var s = { headers: !0 }; s.separator = ";", s.quote = '"', s.utf8Bom = !0, t && !t.headers && void 0 !== t.headers && (s.utf8Bom = !1), A.utils.extend(s, t); var i = r.length, o = s.utf8Bom ? "\ufeff" : ""; return s.headers && (o += s.quote + n.map(function (e) { return e.columnid.trim() }).join(s.quote + s.separator + s.quote) + s.quote + "\r\n"), r.forEach(function (e) { o += n.map(function (t) { var r = e[t.columnid]; return "" !== s.quote && (r = (r + "").replace(new RegExp("\\" + s.quote, "g"), s.quote + s.quote)), +r != r && (r = s.quote + r + s.quote), r }).join(s.separator) + "\r\n" }), e = A.utils.autoExtFilename(e, "csv", t), i = A.utils.saveFile(e, o, null, { disableAutoBom: !0 }), a && (i = a(i)), i }, A.into.XLS = function (e, t, r, n, a) { "object" == typeof e && (t = e, e = void 0); var s = {}; t && t.sheets && (s = t.sheets); var i = { headers: !0 }; void 0 !== s.Sheet1 ? i = s[0] : void 0 !== t && (i = t), void 0 === i.sheetid && (i.sheetid = "Sheet1"); var o = function () { var e = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" \t\txmlns="https://www.w3.org/TR/REC-html40"><head> \t\t<meta charset="utf-8" /> \t\t\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets> '; if (e += " <x:ExcelWorksheet><x:Name>" + i.sheetid + "</x:Name><x:WorksheetOptions><x:DisplayGridlines/>     </x:WorksheetOptions> \t\t</x:ExcelWorksheet>", e += "</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e</head>", e += "<body", void 0 !== i.style && (e += ' style="', "function" == typeof i.style ? e += i.style(i) : e += i.style, e += '"'), e += ">", e += "<table>", void 0 !== i.caption) { var a = i.caption; "string" == typeof a && (a = { title: a }), e += "<caption", void 0 !== a.style && (e += ' style="', "function" == typeof a.style ? e += a.style(i, a) : e += a.style, e += '" '), e += ">", e += a.title, e += "</caption>" } return void 0 !== i.columns ? n = i.columns : 0 == n.length && r.length > 0 && "object" == typeof r[0] && (n = Array.isArray(r[0]) ? r[0].map(function (e, t) { return { columnid: t } }) : Object.keys(r[0]).map(function (e) { return { columnid: e } })), n.forEach(function (e, t) { void 0 !== i.column && G(e, i.column), void 0 === e.width && (i.column && "undefined" != i.column.width ? e.width = i.column.width : e.width = "120px"), "number" == typeof e.width && (e.width = e.width + "px"), void 0 === e.columnid && (e.columnid = t), void 0 === e.title && (e.title = "" + e.columnid.trim()), i.headers && Array.isArray(i.headers) && (e.title = i.headers[t]) }), e += "<colgroups>", n.forEach(function (t) { e += '<col style="width: ' + t.width + '"></col>' }), e += "</colgroups>", i.headers && (e += "<thead>", e += "<tr>", n.forEach(function (t, r) { e += "<th ", void 0 !== t.style && (e += ' style="', "function" == typeof t.style ? e += t.style(i, t, r) : e += t.style, e += '" '), e += ">", void 0 !== t.title && ("function" == typeof t.title ? e += t.title(i, t, r) : e += t.title), e += "</th>" }), e += "</tr>", e += "</thead>"), e += "<tbody>", r && r.length > 0 && r.forEach(function (r, a) { if (!(a > i.limit)) { e += "<tr"; var s = {}; G(s, i.row), i.rows && i.rows[a] && G(s, i.rows[a]), void 0 !== s && void 0 !== s.style && (e += ' style="', "function" == typeof s.style ? e += s.style(i, r, a) : e += s.style, e += '" '), e += ">", n.forEach(function (n, o) { var u = {}; G(u, i.cell), G(u, s.cell), void 0 !== i.column && G(u, i.column.cell), G(u, n.cell), i.cells && i.cells[a] && i.cells[a][o] && G(u, i.cells[a][o]); var c = r[n.columnid]; "function" == typeof u.value && (c = u.value(c, i, r, n, u, a, o)); var l = u.typeid; "function" == typeof l && (l = l(c, i, r, n, u, a, o)), void 0 === l && ("number" == typeof c ? l = "number" : "string" == typeof c ? l = "string" : "boolean" == typeof c ? l = "boolean" : "object" == typeof c && c instanceof Date && (l = "date")); var h = ""; "money" == l ? h = 'mso-number-format:"\\#\\,\\#\\#0\\\\ _р_\\.";white-space:normal;' : "number" == l ? h = " " : "date" == l ? h = 'mso-number-format:"Short Date";' : t.types && t.types[l] && t.types[l].typestyle && (h = t.types[l].typestyle), h = h || 'mso-number-format:"\\@";', e += "<td style='" + h + "' ", void 0 !== u.style && (e += ' style="', "function" == typeof u.style ? e += u.style(c, i, r, n, a, o) : e += u.style, e += '" '), e += ">"; var d = u.format; if (void 0 === c) e += ""; else if (void 0 !== d) if ("function" == typeof d) e += d(c); else { if ("string" != typeof d) throw new Error("Unknown format type. Should be function or string"); e += c } else e += "number" == l || "date" == l ? c.toString() : "money" == l ? (+c).toFixed(2) : c; e += "</td>" }), e += "</tr>" } }), e += "</tbody>", e += "</table>", e += "</body>", e += "</html>" }(); e = A.utils.autoExtFilename(e, "xls", t); var u = A.utils.saveFile(e, o); return a && (u = a(u)), u }, A.into.XLSXML = function (e, t, r, n, a) { t = t || {}, "object" == typeof e && (t = e, e = void 0); var s = {}; t && t.sheets ? s = t.sheets : s.Sheet1 = t, e = A.utils.autoExtFilename(e, "xls", t); var i = A.utils.saveFile(e, function () { function e(e) { var t = ""; for (var r in e) { t += "<" + r; for (var n in e[r]) t += " ", "x:" == n.substr(0, 2) ? t += n : t += "ss:", t += n + '="' + e[r][n] + '"'; t += "/>" } var s = D(t); return o[s] || (o[s] = { styleid: u }, a += '<Style ss:ID="s' + u + '">', a += t, a += "</Style>", u++), "s" + o[s].styleid } var a = "", i = " </Styles>", o = {}, u = 62; for (var c in s) { var l = s[c]; void 0 !== l.columns ? n = l.columns : 0 == n.length && r.length > 0 && "object" == typeof r[0] && (n = Array.isArray(r[0]) ? r[0].map(function (e, t) { return { columnid: t } }) : Object.keys(r[0]).map(function (e) { return { columnid: e } })), n.forEach(function (e, t) { void 0 !== l.column && G(e, l.column), void 0 === e.width && (l.column && void 0 !== l.column.width ? e.width = l.column.width : e.width = 120), "number" == typeof e.width && (e.width = e.width), void 0 === e.columnid && (e.columnid = t), void 0 === e.title && (e.title = "" + e.columnid.trim()), l.headers && Array.isArray(l.headers) && (e.title = l.headers[idx]) }), i += '<Worksheet ss:Name="' + c + '"> \t  \t\t\t<Table ss:ExpandedColumnCount="' + n.length + '" ss:ExpandedRowCount="' + ((l.headers ? 1 : 0) + Math.min(r.length, l.limit || r.length)) + '" x:FullColumns="1" \t   \t\t\tx:FullRows="1" ss:DefaultColumnWidth="65" ss:DefaultRowHeight="15">', n.forEach(function (e, t) { i += '<Column ss:Index="' + (t + 1) + '" ss:AutoFitWidth="0" ss:Width="' + e.width + '"/>' }), l.headers && (i += '<Row ss:AutoFitHeight="0">', n.forEach(function (t, r) { if (i += "<Cell ", void 0 !== t.style) { var n = {}; "function" == typeof t.style ? G(n, t.style(l, t, r)) : G(n, t.style), i += 'ss:StyleID="' + e(n) + '"' } i += '><Data ss:Type="String">', void 0 !== t.title && ("function" == typeof t.title ? i += t.title(l, t, r) : i += t.title), i += "</Data></Cell>" }), i += "</Row>"), r && r.length > 0 && r.forEach(function (r, a) { if (!(a > l.limit)) { var s = {}; if (G(s, l.row), l.rows && l.rows[a] && G(s, l.rows[a]), i += "<Row ", void 0 !== s) { var o = {}; void 0 !== s.style && ("function" == typeof s.style ? G(o, s.style(l, r, a)) : G(o, s.style), i += 'ss:StyleID="' + e(o) + '"') } i += ">", n.forEach(function (n, o) { var u = {}; G(u, l.cell), G(u, s.cell), void 0 !== l.column && G(u, l.column.cell), G(u, n.cell), l.cells && l.cells[a] && l.cells[a][o] && G(u, l.cells[a][o]); var c = r[n.columnid]; "function" == typeof u.value && (c = u.value(c, l, r, n, u, a, o)); var h = u.typeid; "function" == typeof h && (h = h(c, l, r, n, u, a, o)), void 0 === h && ("number" == typeof c ? h = "number" : "string" == typeof c ? h = "string" : "boolean" == typeof c ? h = "boolean" : "object" == typeof c && c instanceof Date && (h = "date")); var d = "String"; "number" == h ? d = "Number" : "date" == h && (d = "Date"); var f = ""; "money" == h ? f = 'mso-number-format:"\\#\\,\\#\\#0\\\\ _р_\\.";white-space:normal;' : "number" == h ? f = " " : "date" == h ? f = 'mso-number-format:"Short Date";' : t.types && t.types[h] && t.types[h].typestyle && (f = t.types[h].typestyle), f = f || 'mso-number-format:"\\@";', i += "<Cell "; var p = {}; void 0 !== u.style && ("function" == typeof u.style ? G(p, u.style(c, l, r, n, a, o)) : G(p, u.style), i += 'ss:StyleID="' + e(p) + '"'), i += ">", i += '<Data ss:Type="' + d + '">'; var b = u.format; if (void 0 === c) i += ""; else if (void 0 !== b) if ("function" == typeof b) i += b(c); else { if ("string" != typeof b) throw new Error("Unknown format type. Should be function or string"); i += c } else i += "number" == h || "date" == h ? c.toString() : "money" == h ? (+c).toFixed(2) : c; i += "</Data></Cell>" }), i += "</Row>" } }), i += "</Table></Worksheet>" } return i += "</Workbook>", '<?xml version="1.0"?> \t\t<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" \t\t xmlns:o="urn:schemas-microsoft-com:office:office" \t\t xmlns:x="urn:schemas-microsoft-com:office:excel" \t\t xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" \t\t xmlns:html="https://www.w3.org/TR/REC-html40"> \t\t <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"> \t\t </DocumentProperties> \t\t <OfficeDocumentSettings xmlns="urn:schemas-microsoft-com:office:office"> \t\t  <AllowPNG/> \t\t </OfficeDocumentSettings> \t\t <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"> \t\t  <ActiveSheet>0</ActiveSheet> \t\t </ExcelWorkbook> \t\t <Styles> \t\t  <Style ss:ID="Default" ss:Name="Normal"> \t\t   <Alignment ss:Vertical="Bottom"/> \t\t   <Borders/> \t\t   <Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="12" ss:Color="#000000"/> \t\t   <Interior/> \t\t   <NumberFormat/> \t\t   <Protection/> \t\t  </Style>' + a + i }()); return a && (i = a(i)), i }, A.into.XLSX = function (e, t, r, n, s) { function i() { "object" == typeof t && Array.isArray(t) ? r && r.length > 0 && r.forEach(function (e, r) { o(t[r], e, void 0, r + 1) }) : o(t, r, n, 1), u(s) } function o(e, t, r, n) { var a = { sheetid: "Sheet " + n, headers: !0 }; A.utils.extend(a, e); var s = Object.keys(t).length; (!r || 0 == r.length) && s > 0 && (r = Object.keys(t[0]).map(function (e) { return { columnid: e } })); var i = {}; h.SheetNames.indexOf(a.sheetid) > -1 ? i = h.Sheets[a.sheetid] : (h.SheetNames.push(a.sheetid), h.Sheets[a.sheetid] = {}, i = h.Sheets[a.sheetid]); var o = "A1"; a.range && (o = a.range); var u = A.utils.xlscn(o.match(/[A-Z]+/)[0]), c = +o.match(/[0-9]+/)[0] - 1; if (h.Sheets[a.sheetid]["!ref"]) var l = h.Sheets[a.sheetid]["!ref"], d = A.utils.xlscn(l.match(/[A-Z]+/)[0]), f = +l.match(/[0-9]+/)[0] - 1; else var d = 1, f = 1; var p = Math.max(u + r.length, d), b = Math.max(c + s + 2, f), E = c + 1; h.Sheets[a.sheetid]["!ref"] = "A1:" + A.utils.xlsnc(p) + b, a.headers && (r.forEach(function (e, t) { i[A.utils.xlsnc(u + t) + "" + E] = { v: e.columnid.trim() } }), E++); for (var g = 0; g < s; g++)r.forEach(function (e, r) { var n = { v: t[g][e.columnid] }; "number" == typeof t[g][e.columnid] ? n.t = "n" : "string" == typeof t[g][e.columnid] ? n.t = "s" : "boolean" == typeof t[g][e.columnid] ? n.t = "b" : "object" == typeof t[g][e.columnid] && t[g][e.columnid] instanceof Date && (n.t = "d"), i[A.utils.xlsnc(u + r) + "" + E] = n }), E++ } function u(t) { var r; if (void 0 === e) c = h; else if (r = B(), C.isNode || C.isMeteorServer) r.writeFile(h, e); else { var n = { bookType: "xlsx", bookSST: !1, type: "binary" }, s = r.write(h, n); if (9 == a()) throw new Error("Cannot save XLSX files in IE9. Please use XLS() export function"); Ee(new Blob([function (e) { for (var t = new ArrayBuffer(e.length), r = new Uint8Array(t), n = 0; n != e.length; ++n)r[n] = 255 & e.charCodeAt(n); return t }(s)], { type: "application/octet-stream" }), e) } } var c = 1; P(n, [{ columnid: "_" }]) && (r = r.map(function (e) { return e._ }), n = void 0), e = A.utils.autoExtFilename(e, "xlsx", t); var l = B(); "object" == typeof e && (t = e, e = void 0); var h = { SheetNames: [], Sheets: {} }; return t.sourcefilename ? A.utils.loadBinaryFile(t.sourcefilename, !!s, function (e) { h = l.read(e, { type: "binary" }), i() }) : i(), s && (c = s(c)), c }, A.from.METEOR = function (e, t, r, n, a) { var s = e.find(t).fetch(); return r && (s = r(s, n, a)), s }, A.from.TABLETOP = function (e, t, r, n, a) { var s = [], i = { headers: !0, simpleSheet: !0, key: e }; return A.utils.extend(i, t), i.callback = function (e) { for (var t = 0; t < e.length; t++)for (var i in e[t]) e[t][i] == +e[t][i] && e[t].hasOwnProperty(i) && (e[t][i] = +e[t][i]); s = e, r && (s = r(s, n, a)) }, Tabletop.init(i), null }, A.from.HTML = function (e, t, r, n, a) { var s = {}; A.utils.extend(s, t); var i = document.querySelector(e); if (!i && "TABLE" !== i.tagName) throw new Error("Selected HTML element is not a TABLE"); var o = [], u = s.headers; if (u && !Array.isArray(u)) { u = []; for (var c = i.querySelector("thead tr").children, l = 0; l < c.length; l++)c.item(l).style && "none" === c.item(l).style.display && s.skipdisplaynone ? u.push(void 0) : u.push(c.item(l).textContent) } for (var h = i.querySelectorAll("tbody tr"), d = 0; d < h.length; d++) { for (var f = h.item(d).children, p = {}, l = 0; l < f.length; l++)f.item(l).style && "none" === f.item(l).style.display && s.skipdisplaynone || (u ? p[u[l]] = f.item(l).textContent : p[l] = f.item(l).textContent); o.push(p) } return r && (o = r(o, n, a)), o }, A.from.RANGE = function (e, t, r, n, a) { for (var s = [], i = e; i <= t; i++)s.push(i); return r && (s = r(s, n, a)), s }, A.from.FILE = function (e, t, r, n, a) { var s; if ("string" == typeof e) s = e; else { if (!(e instanceof Event)) throw new Error("Wrong usage of FILE() function"); s = e.target.files[0].name } var i = s.split("."), o = i[i.length - 1].toUpperCase(); if (A.from[o]) return A.from[o](e, t, r, n, a); throw new Error("Cannot recognize file type for loading") }, A.from.JSON = function (e, t, r, n, a) { var s; return e = A.utils.autoExtFilename(e, "json", t), A.utils.loadFile(e, !!r, function (e) { s = JSON.parse(e), r && (s = r(s, n, a)) }), s }, A.from.TXT = function (e, t, r, n, a) { var s; return e = A.utils.autoExtFilename(e, "txt", t), A.utils.loadFile(e, !!r, function (e) { s = e.split(/\r?\n/), "" === s[s.length - 1] && s.pop(); for (var t = 0, i = s.length; t < i; t++)s[t] == +s[t] && (s[t] = +s[t]), s[t] = [s[t]]; r && (s = r(s, n, a)) }), s }, A.from.TAB = A.from.TSV = function (e, t, r, n, a) { return t = t || {}, t.separator = "\t", e = A.utils.autoExtFilename(e, "tab", t), t.autoext = !1, A.from.CSV(e, t, r, n, a) }, A.from.CSV = function (e, t, r, n, a) { function s(e) { function t() { if (E >= b) return f; if (c) return c = !1, d; var t = E; if (e.charCodeAt(t) === h) { for (var r = t; r++ < b;)if (e.charCodeAt(r) === h) { if (e.charCodeAt(r + 1) !== h) break; ++r } E = r + 2; var n = e.charCodeAt(r + 1); return 13 === n ? (c = !0, 10 === e.charCodeAt(r + 2) && ++E) : 10 === n && (c = !0), e.substring(t + 1, r).replace(/""/g, '"') } for (; E < b;) { var n = e.charCodeAt(E++), a = 1; if (10 === n) c = !0; else if (13 === n) c = !0, 10 === e.charCodeAt(E) && (++E, ++a); else if (n !== l) continue; return e.substring(t, E - a) } return e.substring(t) } for (var s, c, l = i.separator.charCodeAt(0), h = i.quote.charCodeAt(0), d = {}, f = {}, p = [], b = e.length, E = 0, g = 0; (s = t()) !== f;) { for (var m = []; s !== d && s !== f;)m.push(s.trim()), s = t(); if (i.headers) { if (0 === g) { if ("boolean" == typeof i.headers) u = m; else if (Array.isArray(i.headers)) { u = i.headers; var v = {}; u.forEach(function (e, t) { v[e] = m[t], void 0 !== v[e] && 0 !== v[e].length && v[e].trim() == +v[e] && (v[e] = +v[e]) }), p.push(v) } } else { var v = {}; u.forEach(function (e, t) { v[e] = m[t], void 0 !== v[e] && 0 !== v[e].length && v[e].trim() == +v[e] && (v[e] = +v[e]) }), p.push(v) } g++ } else p.push(m) } if (o = p, i.headers && a && a.sources && a.sources[n]) { var S = a.sources[n].columns = []; u.forEach(function (e) { S.push({ columnid: e }) }) } r && (o = r(o, n, a)) } var i = { separator: ",", quote: '"', headers: !0 }; A.utils.extend(i, t); var o, u = []; return new RegExp("\n").test(e) ? s(e) : (e = A.utils.autoExtFilename(e, "csv", t), A.utils.loadFile(e, !!r, s)), o }, A.from.XLS = function (e, t, r, n, a) { return t = t || {}, e = A.utils.autoExtFilename(e, "xls", t), t.autoExt = !1, S(j(), e, t, r, n, a) }, A.from.XLSX = function (e, t, r, n, a) { return t = t || {}, e = A.utils.autoExtFilename(e, "xlsx", t), t.autoExt = !1, S(B(), e, t, r, n, a) }, A.from.XML = function (e, t, r, n, a) { var s; return A.utils.loadFile(e, !!r, function (e) { s = T(e).root, r && (s = r(s, n, a)) }), s }, A.from.GEXF = function (e, t, r, n, a) { var s; return A("SEARCH FROM XML(" + e + ")", [], function (e) { s = e, console.log(s), r && (s = r(s)) }), s }, Q.Print = function (e) { return Q.extend(this, e) }, Q.Print.prototype.toString = function () { var e = "PRINT"; return this.statement && (e += " " + this.statement.toString()), e }, Q.Print.prototype.execute = function (e, t, r) { var n = this, a = 1; if (A.precompile(this, e, t), this.exprs && this.exprs.length > 0) { var s = this.exprs.map(function (e) { var r = new Function("params,alasql,p", "var y;return " + e.toJS("({})", "", null)).bind(n), a = r(t, A); return ce(a) }); console.log.apply(console, s) } else if (this.select) { var i = this.select.execute(e, t); console.log(ce(i)) } else console.log(); return r && (a = r(a)), a }, Q.Source = function (e) { return Q.extend(this, e) }, Q.Source.prototype.toString = function () { var e = "SOURCE"; return this.url && (e += " '" + this.url + " '"), e }, Q.Source.prototype.execute = function (e, t, r) { var n; return x(this.url, !!r, function (e) { return n = A(e), r && (n = r(n)), n }, function (e) { throw e }), n }, Q.Require = function (e) { return Q.extend(this, e) }, Q.Require.prototype.toString = function () { var e = "REQUIRE"; return this.paths && this.paths.length > 0 && (e += this.paths.map(function (e) { return e.toString() }).join(",")), this.plugins && this.plugins.length > 0 && (e += this.plugins.map(function (e) { return e.toUpperCase() }).join(",")), e }, Q.Require.prototype.execute = function (e, t, r) { var n = this, a = 0, s = ""; return this.paths && this.paths.length > 0 ? this.paths.forEach(function (e) { x(e.value, !!r, function (e) { a++, s += e, a < n.paths.length || (new Function("params,alasql", s)(t, A), r && (a = r(a))) }) }) : this.plugins && this.plugins.length > 0 ? this.plugins.forEach(function (e) { A.plugins[e] || x(A.path + "/alasql-" + e.toLowerCase() + ".js", !!r, function (i) { a++, s += i, a < n.plugins.length || (new Function("params,alasql", s)(t, A), A.plugins[e] = !0, r && (a = r(a))) }) }) : r && (a = r(a)), a }, Q.Assert = function (e) { return Q.extend(this, e) }, Q.Source.prototype.toString = function () { var e = "ASSERT"; return this.value && (e += " " + JSON.stringify(this.value)), e }, Q.Assert.prototype.execute = function (e) { if (!P(A.res, this.value)) throw new Error((this.message || "Assert wrong") + ": " + JSON.stringify(A.res) + " == " + JSON.stringify(this.value)); return 1 }; var he = A.engines.WEBSQL = function () { }; he.createDatabase = function (e, t, r, n) { var a = openDatabase(e, t[0], t[1], t[2]); if (this.dbid) { var s = A.createDatabase(this.dbid); s.engineid = "WEBSQL", s.wdbid = e, sb.wdb = s } if (!a) throw new Error('Cannot create WebSQL database "' + databaseid + '"'); return n && n(1), 1 }, he.dropDatabase = function (e) { throw new Error("This is impossible to drop WebSQL database.") }, he.attachDatabase = function (e, t, r, n, a) { if (A.databases[t]) throw new Error('Unable to attach database as "' + t + '" because it already exists'); return alasqlopenDatabase(e, r[0], r[1], r[2]), 1 }; var de = A.engines.INDEXEDDB = function () { }; C.hasIndexedDB && ("function" == typeof C.global.indexedDB.webkitGetDatabaseNames ? de.getDatabaseNames = C.global.indexedDB.webkitGetDatabaseNames.bind(C.global.indexedDB) : (de.getDatabaseNames = function () { var e = {}, t = { contains: function (e) { return !0 }, notsupported: !0 }; return setTimeout(function () { var r = { target: { result: t } }; e.onsuccess(r) }, 0), e }, de.getDatabaseNamesNotSupported = !0)), de.showDatabases = function (e, t) { de.getDatabaseNames().onsuccess = function (r) { var n = r.target.result; if (de.getDatabaseNamesNotSupported) throw new Error("SHOW DATABASE is not supported in this browser"); var a = []; if (e) var s = new RegExp(e.value.replace(/\%/g, ".*"), "g"); for (var i = 0; i < n.length; i++)e && !n[i].match(s) || a.push({ databaseid: n[i] }); t(a) } }, de.createDatabase = function (e, t, r, n, a) { console.log(arguments); var s = C.global.indexedDB; if (r) { s.open(e, 1).onsuccess = function (e) { e.target.result.close(), a && a(1) } } else { var i = s.open(e, 1); i.onupgradeneeded = function (e) { console.log("abort"), e.target.transaction.abort() }, i.onsuccess = function (t) { if (console.log("success"), !r) throw new Error('IndexedDB: Cannot create new database "' + e + '" because it already exists'); a && a(0) } } }, de.createDatabase = function (e, t, r, n, a) { var s = C.global.indexedDB; if (de.getDatabaseNamesNotSupported) if (r) { var i = !0, o = s.open(e); o.onupgradeneeded = function (e) { i = !1 }, o.onsuccess = function (e) { e.target.result.close(), i ? a && a(0) : a && a(1) } } else { var u = s.open(e); u.onupgradeneeded = function (e) { e.target.transaction.abort() }, u.onabort = function (e) { a && a(1) }, u.onsuccess = function (t) { throw t.target.result.close(), new Error('IndexedDB: Cannot create new database "' + e + '" because it already exists') } } else { var u = de.getDatabaseNames(); u.onsuccess = function (t) { if (t.target.result.contains(e)) { if (r) return void (a && a(0)); throw new Error('IndexedDB: Cannot create new database "' + e + '" because it already exists') } s.open(e, 1).onsuccess = function (e) { e.target.result.close(), a && a(1) } } } }, de.dropDatabase = function (e, t, r) { var n = C.global.indexedDB; de.getDatabaseNames().onsuccess = function (a) { if (!a.target.result.contains(e)) { if (t) return void (r && r(0)); throw new Error('IndexedDB: Cannot drop new database "' + e + '" because it does not exist') } n.deleteDatabase(e).onsuccess = function (e) { r && r(1) } } }, de.attachDatabase = function (e, t, r, n, a) { if (!C.hasIndexedDB) throw new Error("The current browser does not support IndexedDB"); var s = C.global.indexedDB; de.getDatabaseNames().onsuccess = function (r) { if (!r.target.result.contains(e)) throw new Error('IndexedDB: Cannot attach database "' + e + '" because it does not exist'); s.open(e).onsuccess = function (r) { var n = r.target.result, s = new A.Database(t || e); s.engineid = "INDEXEDDB", s.ixdbid = e, s.tables = []; for (var i = n.objectStoreNames, o = 0; o < i.length; o++)s.tables[i[o]] = {}; r.target.result.close(), a && a(1) } } }, de.createTable = function (e, t, r, n) { var a = C.global.indexedDB, s = A.databases[e].ixdbid; de.getDatabaseNames().onsuccess = function (r) { if (!r.target.result.contains(s)) throw new Error('IndexedDB: Cannot create table in database "' + s + '" because it does not exist'); var i = a.open(s); i.onversionchange = function (e) { e.target.result.close() }, i.onsuccess = function (r) { var i = r.target.result.version; r.target.result.close(); var o = a.open(s, i + 1); o.onupgradeneeded = function (e) { e.target.result.createObjectStore(t, { autoIncrement: !0 }) }, o.onsuccess = function (e) { e.target.result.close(), n && n(1) }, o.onerror = function (e) { throw e }, o.onblocked = function (r) { throw new Error('Cannot create table "' + t + '" because database "' + e + '"  is blocked') } } } }, de.dropTable = function (e, t, r, n) { var a = C.global.indexedDB, s = A.databases[e].ixdbid; de.getDatabaseNames().onsuccess = function (i) { if (!i.target.result.contains(s)) throw new Error('IndexedDB: Cannot drop table in database "' + s + '" because it does not exist'); var o = a.open(s); o.onversionchange = function (e) { e.target.result.close() }, o.onsuccess = function (i) { var o = i.target.result.version; i.target.result.close(); var u = a.open(s, o + 1); u.onupgradeneeded = function (n) { var a = n.target.result; if (a.objectStoreNames.contains(t)) a.deleteObjectStore(t), delete A.databases[e].tables[t]; else if (!r) throw new Error('IndexedDB: Cannot drop table "' + t + '" because it does not exist') }, u.onsuccess = function (e) { e.target.result.close(), n && n(1) }, u.onerror = function (e) { throw e }, u.onblocked = function (r) { throw new Error('Cannot drop table "' + t + '" because database "' + e + '" is blocked') } } } }, de.intoTable = function (e, t, r, n, a) { var s = C.global.indexedDB, i = A.databases[e].ixdbid; s.open(i).onsuccess = function (e) { for (var n = e.target.result, s = n.transaction([t], "readwrite"), i = s.objectStore(t), o = 0, u = r.length; o < u; o++)i.add(r[o]); s.oncomplete = function () { n.close(), a && a(u) } } }, de.fromTable = function (e, t, r, n, a) { var s = C.global.indexedDB, i = A.databases[e].ixdbid; s.open(i).onsuccess = function (e) { var s = [], i = e.target.result, o = i.transaction([t]), u = o.objectStore(t), c = u.openCursor(); c.onblocked = function (e) { }, c.onerror = function (e) { }, c.onsuccess = function (e) { var t = e.target.result; t ? (s.push(t.value), t.continue()) : (i.close(), r && r(s, n, a)) } } }, de.deleteFromTable = function (e, t, r, n, a) { var s = C.global.indexedDB, i = A.databases[e].ixdbid; s.open(i).onsuccess = function (e) { var s = e.target.result, i = s.transaction([t], "readwrite"), o = i.objectStore(t), u = o.openCursor(), c = 0; u.onblocked = function (e) { }, u.onerror = function (e) { }, u.onsuccess = function (e) { var t = e.target.result; t ? (r && !r(t.value, n) || (t.delete(), c++), t.continue()) : (s.close(), a && a(c)) } } }, de.updateTable = function (e, t, r, n, a, s) {
                var i = C.global.indexedDB, o = A.databases[e].ixdbid; i.open(o).onsuccess = function (e) {
                    var i = e.target.result, o = i.transaction([t], "readwrite"), u = o.objectStore(t), c = u.openCursor(), l = 0; c.onblocked = function (e) { }, c.onerror = function (e) { }, c.onsuccess = function (e) {
                        var t = e.target.result; if (t) {
                            if (!n || n(t.value, a)) {
                                var o = t.value; r(o, a),
                                    t.update(o), l++
                            } t.continue()
                        } else i.close(), s && s(l)
                    }
                }
            }; var fe = A.engines.LOCALSTORAGE = function () { }; fe.get = function (e) { var t = localStorage.getItem(e); if (void 0 !== t) { var r = void 0; try { r = JSON.parse(t) } catch (e) { throw new Error("Cannot parse JSON object from localStorage" + t) } return r } }, fe.set = function (e, t) { void 0 === t ? localStorage.removeItem(e) : localStorage.setItem(e, JSON.stringify(t)) }, fe.storeTable = function (e, t) { var r = A.databases[e], n = r.tables[t], a = {}; a.columns = n.columns, a.data = n.data, a.identities = n.identities, fe.set(r.lsdbid + "." + t, a) }, fe.restoreTable = function (e, t) { var r = A.databases[e], n = fe.get(r.lsdbid + "." + t), a = new A.Table; for (var s in n) a[s] = n[s]; return r.tables[t] = a, a.indexColumns(), a }, fe.removeTable = function (e, t) { var r = A.databases[e]; localStorage.removeItem(r.lsdbid + "." + t) }, fe.createDatabase = function (e, t, r, n, a) { var s = 1, i = fe.get("alasql"); if (r && i && i.databases && i.databases[e]) s = 0; else { if (i || (i = { databases: {} }), i.databases && i.databases[e]) throw new Error('localStorage: Cannot create new database "' + e + '" because it already exists'); i.databases[e] = !0, fe.set("alasql", i), fe.set(e, { databaseid: e, tables: {} }) } return a && (s = a(s)), s }, fe.dropDatabase = function (e, t, r) { var n = 1, a = fe.get("alasql"); if (t && a && a.databases && !a.databases[e]) n = 0; else { if (!a) { if (t) return r ? r(0) : 0; throw new Error("There is no any AlaSQL databases in localStorage") } if (a.databases && !a.databases[e]) throw new Error('localStorage: Cannot drop database "' + e + '" because there is no such database'); delete a.databases[e], fe.set("alasql", a); var s = fe.get(e); for (var i in s.tables) localStorage.removeItem(e + "." + i); localStorage.removeItem(e) } return r && (n = r(n)), n }, fe.attachDatabase = function (e, t, r, n, a) { var s = 1; if (A.databases[t]) throw new Error('Unable to attach database as "' + t + '" because it already exists'); t || (t = e); var i = new A.Database(t); if (i.engineid = "LOCALSTORAGE", i.lsdbid = e, i.tables = fe.get(e).tables, !A.options.autocommit && i.tables) for (var o in i.tables) fe.restoreTable(t, o); return a && (s = a(s)), s }, fe.showDatabases = function (e, t) { var r = [], n = fe.get("alasql"); if (e) var a = new RegExp(e.value.replace(/\%/g, ".*"), "g"); if (n && n.databases) { for (dbid in n.databases) r.push({ databaseid: dbid }); e && r && r.length > 0 && (r = r.filter(function (e) { return e.databaseid.match(a) })) } return t && (r = t(r)), r }, fe.createTable = function (e, t, r, n) { var a = 1, s = A.databases[e].lsdbid; if (fe.get(s + "." + t) && !r) throw new Error('Table "' + t + '" alsready exists in localStorage database "' + s + '"'); var i = fe.get(s); A.databases[e].tables[t]; return i.tables[t] = !0, fe.set(s, i), fe.storeTable(e, t), n && (a = n(a)), a }, fe.truncateTable = function (e, t, r, n) { var a = 1, s = A.databases[e].lsdbid; if (A.options.autocommit) var i = fe.get(s); else var i = A.databases[e]; if (!r && !i.tables[t]) throw new Error('Cannot truncate table "' + t + '" in localStorage, because it does not exist'); return fe.restoreTable(e, t).data = [], fe.storeTable(e, t), n && (a = n(a)), a }, fe.dropTable = function (e, t, r, n) { var a = 1, s = A.databases[e].lsdbid; if (A.options.autocommit) var i = fe.get(s); else var i = A.databases[e]; if (!r && !i.tables[t]) throw new Error('Cannot drop table "' + t + '" in localStorage, because it does not exist'); return delete i.tables[t], fe.set(s, i), fe.removeTable(e, t), n && (a = n(a)), a }, fe.fromTable = function (e, t, r, n, a) { var s = (A.databases[e].lsdbid, fe.restoreTable(e, t).data); return r && (s = r(s, n, a)), s }, fe.intoTable = function (e, t, r, n, a) { var s = (A.databases[e].lsdbid, r.length), i = fe.restoreTable(e, t); return i.data || (i.data = []), i.data = i.data.concat(r), fe.storeTable(e, t), a && (s = a(s)), s }, fe.loadTableData = function (e, t) { A.databases[e], A.databases[e].lsdbid; fe.restoreTable(e, t) }, fe.saveTableData = function (e, t) { var r = A.databases[e], n = A.databases[e].lsdbid; fe.storeTable(n, t), r.tables[t].data = void 0 }, fe.commit = function (e, t) { var r = A.databases[e], n = A.databases[e].lsdbid, a = { databaseid: n, tables: {} }; if (r.tables) for (var s in r.tables) a.tables[s] = !0, fe.storeTable(e, s); return fe.set(n, a), t ? t(1) : 1 }, fe.begin = fe.commit, fe.rollback = function (e, t) { return }; var pe = A.engines.SQLITE = function () { }; pe.createDatabase = function (e, t, r, n, a) { throw new Error("Connot create SQLITE database in memory. Attach it.") }, pe.dropDatabase = function (e) { throw new Error("This is impossible to drop SQLite database. Detach it.") }, pe.attachDatabase = function (e, t, r, n, a) { if (A.databases[t]) throw new Error('Unable to attach database as "' + t + '" because it already exists'); if (r[0] && r[0] instanceof Q.StringValue || r[0] instanceof Q.ParamValue) { if (r[0] instanceof Q.StringValue) var s = r[0].value; else if (r[0] instanceof Q.ParamValue) var s = n[r[0].param]; return A.utils.loadBinaryFile(s, !0, function (r) { var n = new A.Database(t || e); n.engineid = "SQLITE", n.sqldbid = e; var s = n.sqldb = new SQL.Database(r); n.tables = [], s.exec("SELECT * FROM sqlite_master WHERE type='table'")[0].values.forEach(function (e) { n.tables[e[1]] = {}; var t = n.tables[e[1]].columns = [], r = A.parse(e[4]), a = r.statements[0].columns; a && a.length > 0 && a.forEach(function (e) { t.push(e) }) }), a(1) }, function (e) { throw new Error('Cannot open SQLite database file "' + r[0].value + '"') }), 1 } throw new Error("Cannot attach SQLite database without a file") }, pe.fromTable = function (e, t, r, n, a) { var s = A.databases[e].sqldb.exec("SELECT * FROM " + t), i = a.sources[n].columns = []; s[0].columns.length > 0 && s[0].columns.forEach(function (e) { i.push({ columnid: e }) }); var o = []; s[0].values.length > 0 && s[0].values.forEach(function (e) { var t = {}; i.forEach(function (r, n) { t[r.columnid] = e[n] }), o.push(t) }), r && r(o, n, a) }, pe.intoTable = function (e, t, r, n, a) { for (var s = A.databases[e].sqldb, i = 0, o = r.length; i < o; i++) { var u = "INSERT INTO " + t + " (", c = r[i], l = Object.keys(c); u += l.join(","), u += ") VALUES (", u += l.map(function (e) { return v = c[e], "string" == typeof v && (v = "'" + v + "'"), v }).join(","), u += ")", s.exec(u) } var h = o; return a && a(h), h }; var be = A.engines.FILESTORAGE = A.engines.FILE = function () { }; if (be.createDatabase = function (e, t, r, n, a) { var s = 1, i = t[0].value; return A.utils.fileExists(i, function (e) { if (e) { if (r) return s = 0, a && (s = a(s)), s; throw new Error("Cannot create new database file, because it alreagy exists") } var t = { tables: {} }; A.utils.saveFile(i, JSON.stringify(t), function (e) { a && (s = a(s)) }) }), s }, be.dropDatabase = function (e, t, r) { var n, a = e.value; return A.utils.fileExists(a, function (e) { if (e) n = 1, A.utils.deleteFile(a, function () { n = 1, r && (n = r(n)) }); else { if (!t) throw new Error("Cannot drop database file, because it does not exist"); n = 0, r && (n = r(n)) } }), n }, be.attachDatabase = function (e, t, r, n, a) { var s = 1; if (A.databases[t]) throw new Error('Unable to attach database as "' + t + '" because it already exists'); var i = new A.Database(t || e); return i.engineid = "FILESTORAGE", i.filename = r[0].value, x(i.filename, !!a, function (e) { try { i.data = JSON.parse(e) } catch (e) { throw new Error("Data in FileStorage database are corrupted") } if (i.tables = i.data.tables, !A.options.autocommit && i.tables) for (var t in i.tables) i.tables[t].data = i.data[t]; a && (s = a(s)) }), s }, be.createTable = function (e, t, r, n) { var a = A.databases[e], s = a.data[t]; if (s && !r) throw new Error('Table "' + t + '" alsready exists in the database "' + fsdbid + '"'); var i = A.databases[e].tables[t]; return a.data.tables[t] = { columns: i.columns }, a.data[t] = [], be.updateFile(e), n && n(1), 1 }, be.updateFile = function (e) { var t = A.databases[e]; if (t.issaving) return void (t.postsave = !0); t.issaving = !0, t.postsave = !1, A.utils.saveFile(t.filename, JSON.stringify(t.data), function () { t.issaving = !1, t.postsave && setTimeout(function () { be.updateFile(e) }, 50) }) }, be.dropTable = function (e, t, r, n) { var a = A.databases[e]; if (!r && !a.tables[t]) throw new Error('Cannot drop table "' + t + '" in fileStorage, because it does not exist'); return delete a.tables[t], delete a.data.tables[t], delete a.data[t], be.updateFile(e), n && n(1), 1 }, be.fromTable = function (e, t, r, n, a) { var s = A.databases[e], i = s.data[t]; return r && (i = r(i, n, a)), i }, be.intoTable = function (e, t, r, n, a) { var s = A.databases[e], i = r.length, o = s.data[t]; return o || (o = []), s.data[t] = o.concat(r), be.updateFile(e), a && a(i), i }, be.loadTableData = function (e, t) { var r = A.databases[e]; r.tables[t].data = r.data[t] }, be.saveTableData = function (e, t) { var r = A.databases[e]; r.data[t] = r.tables[t].data, r.tables[t].data = null, be.updateFile(e) }, be.commit = function (e, t) { var r = A.databases[e]; if (r.tables) for (var n in r.tables) r.data.tables[n] = { columns: r.tables[n].columns }, r.data[n] = r.tables[n].data; return be.updateFile(e), t ? t(1) : 1 }, be.begin = be.commit, be.rollback = function (e, t) { function r() { setTimeout(function () { if (a.issaving) return r(); A.loadFile(a.filename, !!t, function (r) { a.data = r, a.tables = {}; for (var s in a.data.tables) { var i = new A.Table({ columns: a.data.tables[s].columns }); G(i, a.data.tables[s]), a.tables[s] = i, A.options.autocommit || (a.tables[s].data = a.data[s]), a.tables[s].indexColumns() } delete A.databases[e], A.databases[e] = new A.Database(e), G(A.databases[e], a), A.databases[e].engineid = "FILESTORAGE", A.databases[e].filename = a.filename, t && (n = t(n)) }) }, 100) } var n = 1, a = A.databases[e]; a.dbversion++, r() }, C.isBrowser && !C.isWebWorker) { if (!(A = A || !1)) throw new Error("alasql was not found"); A.worker = function () { throw new Error("Can find webworker in this enviroment") }, "undefined" != typeof Worker && (A.worker = function (e, t, r) { if (!0 === e && (e = void 0), void 0 === e) for (var n = document.getElementsByTagName("script"), a = 0; a < n.length; a++) { if ("alasql-worker.js" === n[a].src.substr(-16).toLowerCase()) { e = n[a].src.substr(0, n[a].src.length - 16) + "alasql.js"; break } if ("alasql-worker.min.js" === n[a].src.substr(-20).toLowerCase()) { e = n[a].src.substr(0, n[a].src.length - 20) + "alasql.min.js"; break } if ("alasql.js" === n[a].src.substr(-9).toLowerCase()) { e = n[a].src; break } if ("alasql.min.js" === n[a].src.substr(-13).toLowerCase()) { e = n[a].src.substr(0, n[a].src.length - 13) + "alasql.min.js"; break } } if (void 0 === e) throw new Error("Path to alasql.js is not specified"); if (!1 !== e) { var s = "importScripts('"; s += e, s += "');self.onmessage = function(event) {alasql(event.data.sql,event.data.params, function(data){postMessage({id:event.data.id, data:data});});}"; var i = new Blob([s], { type: "text/plain" }); if (A.webworker = new Worker(URL.createObjectURL(i)), A.webworker.onmessage = function (e) { var t = e.data.id; A.buffer[t](e.data.data), delete A.buffer[t] }, A.webworker.onerror = function (e) { throw e }, arguments.length > 1) { var o = "REQUIRE " + t.map(function (e) { return '"' + e + '"' }).join(","); A(o, [], r) } } else if (!1 === e) return void delete A.webworker }); var Ee = Ee || function (e) { "use strict"; if (!(void 0 === e || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) { var t = e.document, r = function () { return e.URL || e.webkitURL || e }, n = t.createElementNS("https://www.w3.org/1999/xhtml", "a"), a = "download" in n, s = function (e) { var t = new MouseEvent("click"); e.dispatchEvent(t) }, i = /constructor/i.test(e.HTMLElement) || e.safari, o = /CriOS\/[\d]+/.test(navigator.userAgent), u = function (t) { (e.setImmediate || e.setTimeout)(function () { throw t }, 0) }, c = function (e) { var t = function () { "string" == typeof e ? r().revokeObjectURL(e) : e.remove() }; setTimeout(t, 4e4) }, l = function (e, t, r) { t = [].concat(t); for (var n = t.length; n--;) { var a = e["on" + t[n]]; if ("function" == typeof a) try { a.call(e, r || e) } catch (e) { u(e) } } }, h = function (e) { return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([String.fromCharCode(65279), e], { type: e.type }) : e }, d = function (t, u, d) { d || (t = h(t)); var f, p = this, b = t.type, E = "application/octet-stream" === b, g = function () { l(p, "writestart progress write writeend".split(" ")) }; if (p.readyState = p.INIT, a) return f = r().createObjectURL(t), void setTimeout(function () { n.href = f, n.download = u, s(n), g(), c(f), p.readyState = p.DONE }); !function () { if ((o || E && i) && e.FileReader) { var n = new FileReader; return n.onloadend = function () { var t = o ? n.result : n.result.replace(/^data:[^;]*;/, "data:attachment/file;"); e.open(t, "_blank") || (e.location.href = t), t = void 0, p.readyState = p.DONE, g() }, n.readAsDataURL(t), void (p.readyState = p.INIT) } if (f || (f = r().createObjectURL(t)), E) e.location.href = f; else { e.open(f, "_blank") || (e.location.href = f) } p.readyState = p.DONE, g(), c(f) }() }, f = d.prototype, p = function (e, t, r) { return new d(e, t || e.name || "download", r) }; return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function (e, t, r) { return t = t || e.name || "download", r || (e = h(e)), navigator.msSaveOrOpenBlob(e, t) } : (f.abort = function () { }, f.readyState = f.INIT = 0, f.WRITING = 1, f.DONE = 2, f.error = f.onwritestart = f.onprogress = f.onwrite = f.onabort = f.onerror = f.onwriteend = null, p) } }("undefined" != typeof self && self || "undefined" != typeof window && window || this.content); "undefined" != typeof module && module.exports ? module.exports.saveAs = Ee : "undefined" != typeof define && null !== define && null !== define.amd && define("FileSaver.js", function () { return Ee }), (C.isCordova || C.isMeteorServer || C.isNode) && console.warn("It looks like you are using the browser version of AlaSQL. Please use the alasql.fs.js file instead."), A.utils.saveAs = Ee } return new Y("alasql"), A.use("alasql"), A
});
﻿/* xlsx.js (C) 2013-2014 SheetJS -- https://sheetjs.com */
!function (e) { if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else { var f; "undefined" != typeof window ? f = window : "undefined" != typeof global ? f = global : "undefined" != typeof self && (f = self), f.JSZip = e() } }(function () {
    var define, module, exports; return function e(t, n, r) { function s(o, u) { if (!n[o]) { if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); throw new Error("Cannot find module '" + o + "'") } var f = n[o] = { exports: {} }; t[o][0].call(f.exports, function (e) { var n = t[o][1][e]; return s(n ? n : e) }, f, f.exports, e, t, n, r) } return n[o].exports } var i = typeof require == "function" && require; for (var o = 0; o < r.length; o++) s(r[o]); return s }({
        1: [function (_dereq_, module, exports) { "use strict"; var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="; exports.encode = function (input, utf8) { var output = ""; var chr1, chr2, chr3, enc1, enc2, enc3, enc4; var i = 0; while (i < input.length) { chr1 = input.charCodeAt(i++); chr2 = input.charCodeAt(i++); chr3 = input.charCodeAt(i++); enc1 = chr1 >> 2; enc2 = (chr1 & 3) << 4 | chr2 >> 4; enc3 = (chr2 & 15) << 2 | chr3 >> 6; enc4 = chr3 & 63; if (isNaN(chr2)) { enc3 = enc4 = 64 } else if (isNaN(chr3)) { enc4 = 64 } output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4) } return output }; exports.decode = function (input, utf8) { var output = ""; var chr1, chr2, chr3; var enc1, enc2, enc3, enc4; var i = 0; input = input.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (i < input.length) { enc1 = _keyStr.indexOf(input.charAt(i++)); enc2 = _keyStr.indexOf(input.charAt(i++)); enc3 = _keyStr.indexOf(input.charAt(i++)); enc4 = _keyStr.indexOf(input.charAt(i++)); chr1 = enc1 << 2 | enc2 >> 4; chr2 = (enc2 & 15) << 4 | enc3 >> 2; chr3 = (enc3 & 3) << 6 | enc4; output = output + String.fromCharCode(chr1); if (enc3 != 64) { output = output + String.fromCharCode(chr2) } if (enc4 != 64) { output = output + String.fromCharCode(chr3) } } return output } }, {}], 2: [function (_dereq_, module, exports) { "use strict"; function CompressedObject() { this.compressedSize = 0; this.uncompressedSize = 0; this.crc32 = 0; this.compressionMethod = null; this.compressedContent = null } CompressedObject.prototype = { getContent: function () { return null }, getCompressedContent: function () { return null } }; module.exports = CompressedObject }, {}], 3: [function (_dereq_, module, exports) { "use strict"; exports.STORE = { magic: "\x00\x00", compress: function (content) { return content }, uncompress: function (content) { return content }, compressInputType: null, uncompressInputType: null }; exports.DEFLATE = _dereq_("./flate") }, { "./flate": 8 }], 4: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); var table = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117]; module.exports = function crc32(input, crc) { if (typeof input === "undefined" || !input.length) { return 0 } var isArray = utils.getTypeOf(input) !== "string"; if (typeof crc == "undefined") { crc = 0 } var x = 0; var y = 0; var b = 0; crc = crc ^ -1; for (var i = 0, iTop = input.length; i < iTop; i++) { b = isArray ? input[i] : input.charCodeAt(i); y = (crc ^ b) & 255; x = table[y]; crc = crc >>> 8 ^ x } return crc ^ -1 } }, { "./utils": 21 }], 5: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); function DataReader(data) { this.data = null; this.length = 0; this.index = 0 } DataReader.prototype = { checkOffset: function (offset) { this.checkIndex(this.index + offset) }, checkIndex: function (newIndex) { if (this.length < newIndex || newIndex < 0) { throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?") } }, setIndex: function (newIndex) { this.checkIndex(newIndex); this.index = newIndex }, skip: function (n) { this.setIndex(this.index + n) }, byteAt: function (i) { }, readInt: function (size) { var result = 0, i; this.checkOffset(size); for (i = this.index + size - 1; i >= this.index; i--) { result = (result << 8) + this.byteAt(i) } this.index += size; return result }, readString: function (size) { return utils.transformTo("string", this.readData(size)) }, readData: function (size) { }, lastIndexOfSignature: function (sig) { }, readDate: function () { var dostime = this.readInt(4); return new Date((dostime >> 25 & 127) + 1980, (dostime >> 21 & 15) - 1, dostime >> 16 & 31, dostime >> 11 & 31, dostime >> 5 & 63, (dostime & 31) << 1) } }; module.exports = DataReader }, { "./utils": 21 }], 6: [function (_dereq_, module, exports) { "use strict"; exports.base64 = false; exports.binary = false; exports.dir = false; exports.createFolders = false; exports.date = null; exports.compression = null; exports.comment = null }, {}], 7: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); exports.string2binary = function (str) { return utils.string2binary(str) }; exports.string2Uint8Array = function (str) { return utils.transformTo("uint8array", str) }; exports.uint8Array2String = function (array) { return utils.transformTo("string", array) }; exports.string2Blob = function (str) { var buffer = utils.transformTo("arraybuffer", str); return utils.arrayBuffer2Blob(buffer) }; exports.arrayBuffer2Blob = function (buffer) { return utils.arrayBuffer2Blob(buffer) }; exports.transformTo = function (outputType, input) { return utils.transformTo(outputType, input) }; exports.getTypeOf = function (input) { return utils.getTypeOf(input) }; exports.checkSupport = function (type) { return utils.checkSupport(type) }; exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS; exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS; exports.pretty = function (str) { return utils.pretty(str) }; exports.findCompression = function (compressionMethod) { return utils.findCompression(compressionMethod) }; exports.isRegExp = function (object) { return utils.isRegExp(object) } }, { "./utils": 21 }], 8: [function (_dereq_, module, exports) { "use strict"; var USE_TYPEDARRAY = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Uint32Array !== "undefined"; var pako = _dereq_("pako"); exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array"; exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array"; exports.magic = "\b\x00"; exports.compress = function (input) { return pako.deflateRaw(input) }; exports.uncompress = function (input) { return pako.inflateRaw(input) } }, { pako: 24 }], 9: [function (_dereq_, module, exports) { "use strict"; var base64 = _dereq_("./base64"); function JSZip(data, options) { if (!(this instanceof JSZip)) return new JSZip(data, options); this.files = {}; this.comment = null; this.root = ""; if (data) { this.load(data, options) } this.clone = function () { var newObj = new JSZip; for (var i in this) { if (typeof this[i] !== "function") { newObj[i] = this[i] } } return newObj } } JSZip.prototype = _dereq_("./object"); JSZip.prototype.load = _dereq_("./load"); JSZip.support = _dereq_("./support"); JSZip.defaults = _dereq_("./defaults"); JSZip.utils = _dereq_("./deprecatedPublicUtils"); JSZip.base64 = { encode: function (input) { return base64.encode(input) }, decode: function (input) { return base64.decode(input) } }; JSZip.compressions = _dereq_("./compressions"); module.exports = JSZip }, { "./base64": 1, "./compressions": 3, "./defaults": 6, "./deprecatedPublicUtils": 7, "./load": 10, "./object": 13, "./support": 17 }], 10: [function (_dereq_, module, exports) { "use strict"; var base64 = _dereq_("./base64"); var ZipEntries = _dereq_("./zipEntries"); module.exports = function (data, options) { var files, zipEntries, i, input; options = options || {}; if (options.base64) { data = base64.decode(data) } zipEntries = new ZipEntries(data, options); files = zipEntries.files; for (i = 0; i < files.length; i++) { input = files[i]; this.file(input.fileName, input.decompressed, { binary: true, optimizedBinaryString: true, date: input.date, dir: input.dir, comment: input.fileComment.length ? input.fileComment : null, createFolders: options.createFolders }) } if (zipEntries.zipComment.length) { this.comment = zipEntries.zipComment } return this } }, { "./base64": 1, "./zipEntries": 22 }], 11: [function (_dereq_, module, exports) { (function (Buffer) { "use strict"; module.exports = function (data, encoding) { return new Buffer(data, encoding) }; module.exports.test = function (b) { return Buffer.isBuffer(b) } }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined) }, {}], 12: [function (_dereq_, module, exports) { "use strict"; var Uint8ArrayReader = _dereq_("./uint8ArrayReader"); function NodeBufferReader(data) { this.data = data; this.length = this.data.length; this.index = 0 } NodeBufferReader.prototype = new Uint8ArrayReader; NodeBufferReader.prototype.readData = function (size) { this.checkOffset(size); var result = this.data.slice(this.index, this.index + size); this.index += size; return result }; module.exports = NodeBufferReader }, { "./uint8ArrayReader": 18 }], 13: [function (_dereq_, module, exports) { "use strict"; var support = _dereq_("./support"); var utils = _dereq_("./utils"); var crc32 = _dereq_("./crc32"); var signature = _dereq_("./signature"); var defaults = _dereq_("./defaults"); var base64 = _dereq_("./base64"); var compressions = _dereq_("./compressions"); var CompressedObject = _dereq_("./compressedObject"); var nodeBuffer = _dereq_("./nodeBuffer"); var utf8 = _dereq_("./utf8"); var StringWriter = _dereq_("./stringWriter"); var Uint8ArrayWriter = _dereq_("./uint8ArrayWriter"); var getRawData = function (file) { if (file._data instanceof CompressedObject) { file._data = file._data.getContent(); file.options.binary = true; file.options.base64 = false; if (utils.getTypeOf(file._data) === "uint8array") { var copy = file._data; file._data = new Uint8Array(copy.length); if (copy.length !== 0) { file._data.set(copy, 0) } } } return file._data }; var getBinaryData = function (file) { var result = getRawData(file), type = utils.getTypeOf(result); if (type === "string") { if (!file.options.binary) { if (support.nodebuffer) { return nodeBuffer(result, "utf-8") } } return file.asBinary() } return result }; var dataToString = function (asUTF8) { var result = getRawData(this); if (result === null || typeof result === "undefined") { return "" } if (this.options.base64) { result = base64.decode(result) } if (asUTF8 && this.options.binary) { result = out.utf8decode(result) } else { result = utils.transformTo("string", result) } if (!asUTF8 && !this.options.binary) { result = utils.transformTo("string", out.utf8encode(result)) } return result }; var ZipObject = function (name, data, options) { this.name = name; this.dir = options.dir; this.date = options.date; this.comment = options.comment; this._data = data; this.options = options; this._initialMetadata = { dir: options.dir, date: options.date } }; ZipObject.prototype = { asText: function () { return dataToString.call(this, true) }, asBinary: function () { return dataToString.call(this, false) }, asNodeBuffer: function () { var result = getBinaryData(this); return utils.transformTo("nodebuffer", result) }, asUint8Array: function () { var result = getBinaryData(this); return utils.transformTo("uint8array", result) }, asArrayBuffer: function () { return this.asUint8Array().buffer } }; var decToHex = function (dec, bytes) { var hex = "", i; for (i = 0; i < bytes; i++) { hex += String.fromCharCode(dec & 255); dec = dec >>> 8 } return hex }; var extend = function () { var result = {}, i, attr; for (i = 0; i < arguments.length; i++) { for (attr in arguments[i]) { if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") { result[attr] = arguments[i][attr] } } } return result }; var prepareFileAttrs = function (o) { o = o || {}; if (o.base64 === true && (o.binary === null || o.binary === undefined)) { o.binary = true } o = extend(o, defaults); o.date = o.date || new Date; if (o.compression !== null) o.compression = o.compression.toUpperCase(); return o }; var fileAdd = function (name, data, o) { var dataType = utils.getTypeOf(data), parent; o = prepareFileAttrs(o); if (o.createFolders && (parent = parentFolder(name))) { folderAdd.call(this, parent, true) } if (o.dir || data === null || typeof data === "undefined") { o.base64 = false; o.binary = false; data = null } else if (dataType === "string") { if (o.binary && !o.base64) { if (o.optimizedBinaryString !== true) { data = utils.string2binary(data) } } } else { o.base64 = false; o.binary = true; if (!dataType && !(data instanceof CompressedObject)) { throw new Error("The data of '" + name + "' is in an unsupported format !") } if (dataType === "arraybuffer") { data = utils.transformTo("uint8array", data) } } var object = new ZipObject(name, data, o); this.files[name] = object; return object }; var parentFolder = function (path) { if (path.slice(-1) == "/") { path = path.substring(0, path.length - 1) } var lastSlash = path.lastIndexOf("/"); return lastSlash > 0 ? path.substring(0, lastSlash) : "" }; var folderAdd = function (name, createFolders) { if (name.slice(-1) != "/") { name += "/" } createFolders = typeof createFolders !== "undefined" ? createFolders : false; if (!this.files[name]) { fileAdd.call(this, name, null, { dir: true, createFolders: createFolders }) } return this.files[name] }; var generateCompressedObjectFrom = function (file, compression) { var result = new CompressedObject, content; if (file._data instanceof CompressedObject) { result.uncompressedSize = file._data.uncompressedSize; result.crc32 = file._data.crc32; if (result.uncompressedSize === 0 || file.dir) { compression = compressions["STORE"]; result.compressedContent = ""; result.crc32 = 0 } else if (file._data.compressionMethod === compression.magic) { result.compressedContent = file._data.getCompressedContent() } else { content = file._data.getContent(); result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content)) } } else { content = getBinaryData(file); if (!content || content.length === 0 || file.dir) { compression = compressions["STORE"]; content = "" } result.uncompressedSize = content.length; result.crc32 = crc32(content); result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content)) } result.compressedSize = result.compressedContent.length; result.compressionMethod = compression.magic; return result }; var generateZipParts = function (name, file, compressedObject, offset) { var data = compressedObject.compressedContent, utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)), comment = file.comment || "", utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)), useUTF8ForFileName = utfEncodedFileName.length !== file.name.length, useUTF8ForComment = utfEncodedComment.length !== comment.length, o = file.options, dosTime, dosDate, extraFields = "", unicodePathExtraField = "", unicodeCommentExtraField = "", dir, date; if (file._initialMetadata.dir !== file.dir) { dir = file.dir } else { dir = o.dir } if (file._initialMetadata.date !== file.date) { date = file.date } else { date = o.date } dosTime = date.getHours(); dosTime = dosTime << 6; dosTime = dosTime | date.getMinutes(); dosTime = dosTime << 5; dosTime = dosTime | date.getSeconds() / 2; dosDate = date.getFullYear() - 1980; dosDate = dosDate << 4; dosDate = dosDate | date.getMonth() + 1; dosDate = dosDate << 5; dosDate = dosDate | date.getDate(); if (useUTF8ForFileName) { unicodePathExtraField = decToHex(1, 1) + decToHex(crc32(utfEncodedFileName), 4) + utfEncodedFileName; extraFields += "up" + decToHex(unicodePathExtraField.length, 2) + unicodePathExtraField } if (useUTF8ForComment) { unicodeCommentExtraField = decToHex(1, 1) + decToHex(this.crc32(utfEncodedComment), 4) + utfEncodedComment; extraFields += "uc" + decToHex(unicodeCommentExtraField.length, 2) + unicodeCommentExtraField } var header = ""; header += "\n\x00"; header += useUTF8ForFileName || useUTF8ForComment ? "\x00\b" : "\x00\x00"; header += compressedObject.compressionMethod; header += decToHex(dosTime, 2); header += decToHex(dosDate, 2); header += decToHex(compressedObject.crc32, 4); header += decToHex(compressedObject.compressedSize, 4); header += decToHex(compressedObject.uncompressedSize, 4); header += decToHex(utfEncodedFileName.length, 2); header += decToHex(extraFields.length, 2); var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields; var dirRecord = signature.CENTRAL_FILE_HEADER + "\x00" + header + decToHex(utfEncodedComment.length, 2) + "\x00\x00" + "\x00\x00" + (dir === true ? "\x00\x00\x00" : "\x00\x00\x00\x00") + decToHex(offset, 4) + utfEncodedFileName + extraFields + utfEncodedComment; return { fileRecord: fileRecord, dirRecord: dirRecord, compressedObject: compressedObject } }; var out = { load: function (stream, options) { throw new Error("Load method is not defined. Is the file jszip-load.js included ?") }, filter: function (search) { var result = [], filename, relativePath, file, fileClone; for (filename in this.files) { if (!this.files.hasOwnProperty(filename)) { continue } file = this.files[filename]; fileClone = new ZipObject(file.name, file._data, extend(file.options)); relativePath = filename.slice(this.root.length, filename.length); if (filename.slice(0, this.root.length) === this.root && search(relativePath, fileClone)) { result.push(fileClone) } } return result }, file: function (name, data, o) { if (arguments.length === 1) { if (utils.isRegExp(name)) { var regexp = name; return this.filter(function (relativePath, file) { return !file.dir && regexp.test(relativePath) }) } else { return this.filter(function (relativePath, file) { return !file.dir && relativePath === name })[0] || null } } else { name = this.root + name; fileAdd.call(this, name, data, o) } return this }, folder: function (arg) { if (!arg) { return this } if (utils.isRegExp(arg)) { return this.filter(function (relativePath, file) { return file.dir && arg.test(relativePath) }) } var name = this.root + arg; var newFolder = folderAdd.call(this, name); var ret = this.clone(); ret.root = newFolder.name; return ret }, remove: function (name) { name = this.root + name; var file = this.files[name]; if (!file) { if (name.slice(-1) != "/") { name += "/" } file = this.files[name] } if (file && !file.dir) { delete this.files[name] } else { var kids = this.filter(function (relativePath, file) { return file.name.slice(0, name.length) === name }); for (var i = 0; i < kids.length; i++) { delete this.files[kids[i].name] } } return this }, generate: function (options) { options = extend(options || {}, { base64: true, compression: "STORE", type: "base64", comment: null }); utils.checkSupport(options.type); var zipData = [], localDirLength = 0, centralDirLength = 0, writer, i, utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || "")); for (var name in this.files) { if (!this.files.hasOwnProperty(name)) { continue } var file = this.files[name]; var compressionName = file.options.compression || options.compression.toUpperCase(); var compression = compressions[compressionName]; if (!compression) { throw new Error(compressionName + " is not a valid compression method !") } var compressedObject = generateCompressedObjectFrom.call(this, file, compression); var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength); localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize; centralDirLength += zipPart.dirRecord.length; zipData.push(zipPart) } var dirEnd = ""; dirEnd = signature.CENTRAL_DIRECTORY_END + "\x00\x00" + "\x00\x00" + decToHex(zipData.length, 2) + decToHex(zipData.length, 2) + decToHex(centralDirLength, 4) + decToHex(localDirLength, 4) + decToHex(utfEncodedComment.length, 2) + utfEncodedComment; var typeName = options.type.toLowerCase(); if (typeName === "uint8array" || typeName === "arraybuffer" || typeName === "blob" || typeName === "nodebuffer") { writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length) } else { writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length) } for (i = 0; i < zipData.length; i++) { writer.append(zipData[i].fileRecord); writer.append(zipData[i].compressedObject.compressedContent) } for (i = 0; i < zipData.length; i++) { writer.append(zipData[i].dirRecord) } writer.append(dirEnd); var zip = writer.finalize(); switch (options.type.toLowerCase()) { case "uint8array": case "arraybuffer": case "nodebuffer": return utils.transformTo(options.type.toLowerCase(), zip); case "blob": return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip)); case "base64": return options.base64 ? base64.encode(zip) : zip; default: return zip } }, crc32: function (input, crc) { return crc32(input, crc) }, utf8encode: function (string) { return utils.transformTo("string", utf8.utf8encode(string)) }, utf8decode: function (input) { return utf8.utf8decode(input) } }; module.exports = out }, { "./base64": 1, "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./defaults": 6, "./nodeBuffer": 11, "./signature": 14, "./stringWriter": 16, "./support": 17, "./uint8ArrayWriter": 19, "./utf8": 20, "./utils": 21 }], 14: [function (_dereq_, module, exports) { "use strict"; exports.LOCAL_FILE_HEADER = "PK"; exports.CENTRAL_FILE_HEADER = "PK"; exports.CENTRAL_DIRECTORY_END = "PK"; exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK"; exports.ZIP64_CENTRAL_DIRECTORY_END = "PK"; exports.DATA_DESCRIPTOR = "PK\b" }, {}], 15: [function (_dereq_, module, exports) { "use strict"; var DataReader = _dereq_("./dataReader"); var utils = _dereq_("./utils"); function StringReader(data, optimizedBinaryString) { this.data = data; if (!optimizedBinaryString) { this.data = utils.string2binary(this.data) } this.length = this.data.length; this.index = 0 } StringReader.prototype = new DataReader; StringReader.prototype.byteAt = function (i) { return this.data.charCodeAt(i) }; StringReader.prototype.lastIndexOfSignature = function (sig) { return this.data.lastIndexOf(sig) }; StringReader.prototype.readData = function (size) { this.checkOffset(size); var result = this.data.slice(this.index, this.index + size); this.index += size; return result }; module.exports = StringReader }, { "./dataReader": 5, "./utils": 21 }], 16: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); var StringWriter = function () { this.data = [] }; StringWriter.prototype = { append: function (input) { input = utils.transformTo("string", input); this.data.push(input) }, finalize: function () { return this.data.join("") } }; module.exports = StringWriter }, { "./utils": 21 }], 17: [function (_dereq_, module, exports) { (function (Buffer) { "use strict"; exports.base64 = true; exports.array = true; exports.string = true; exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined"; exports.nodebuffer = typeof Buffer !== "undefined"; exports.uint8array = typeof Uint8Array !== "undefined"; if (typeof ArrayBuffer === "undefined") { exports.blob = false } else { var buffer = new ArrayBuffer(0); try { exports.blob = new Blob([buffer], { type: "application/zip" }).size === 0 } catch (e) { try { var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder; var builder = new Builder; builder.append(buffer); exports.blob = builder.getBlob("application/zip").size === 0 } catch (e) { exports.blob = false } } } }).call(this, typeof Buffer !== "undefined" ? Buffer : undefined) }, {}], 18: [function (_dereq_, module, exports) { "use strict"; var DataReader = _dereq_("./dataReader"); function Uint8ArrayReader(data) { if (data) { this.data = data; this.length = this.data.length; this.index = 0 } } Uint8ArrayReader.prototype = new DataReader; Uint8ArrayReader.prototype.byteAt = function (i) { return this.data[i] }; Uint8ArrayReader.prototype.lastIndexOfSignature = function (sig) { var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3); for (var i = this.length - 4; i >= 0; --i) { if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) { return i } } return -1 }; Uint8ArrayReader.prototype.readData = function (size) { this.checkOffset(size); if (size === 0) { return new Uint8Array(0) } var result = this.data.subarray(this.index, this.index + size); this.index += size; return result }; module.exports = Uint8ArrayReader }, { "./dataReader": 5 }], 19: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); var Uint8ArrayWriter = function (length) { this.data = new Uint8Array(length); this.index = 0 }; Uint8ArrayWriter.prototype = { append: function (input) { if (input.length !== 0) { input = utils.transformTo("uint8array", input); this.data.set(input, this.index); this.index += input.length } }, finalize: function () { return this.data } }; module.exports = Uint8ArrayWriter }, { "./utils": 21 }], 20: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./utils"); var support = _dereq_("./support"); var nodeBuffer = _dereq_("./nodeBuffer"); var _utf8len = new Array(256); for (var i = 0; i < 256; i++) { _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1 } _utf8len[254] = _utf8len[254] = 1; var string2buf = function (str) { var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0; for (m_pos = 0; m_pos < str_len; m_pos++) { c = str.charCodeAt(m_pos); if ((c & 64512) === 55296 && m_pos + 1 < str_len) { c2 = str.charCodeAt(m_pos + 1); if ((c2 & 64512) === 56320) { c = 65536 + (c - 55296 << 10) + (c2 - 56320); m_pos++ } } buf_len += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4 } if (support.uint8array) { buf = new Uint8Array(buf_len) } else { buf = new Array(buf_len) } for (i = 0, m_pos = 0; i < buf_len; m_pos++) { c = str.charCodeAt(m_pos); if ((c & 64512) === 55296 && m_pos + 1 < str_len) { c2 = str.charCodeAt(m_pos + 1); if ((c2 & 64512) === 56320) { c = 65536 + (c - 55296 << 10) + (c2 - 56320); m_pos++ } } if (c < 128) { buf[i++] = c } else if (c < 2048) { buf[i++] = 192 | c >>> 6; buf[i++] = 128 | c & 63 } else if (c < 65536) { buf[i++] = 224 | c >>> 12; buf[i++] = 128 | c >>> 6 & 63; buf[i++] = 128 | c & 63 } else { buf[i++] = 240 | c >>> 18; buf[i++] = 128 | c >>> 12 & 63; buf[i++] = 128 | c >>> 6 & 63; buf[i++] = 128 | c & 63 } } return buf }; var utf8border = function (buf, max) { var pos; max = max || buf.length; if (max > buf.length) { max = buf.length } pos = max - 1; while (pos >= 0 && (buf[pos] & 192) === 128) { pos-- } if (pos < 0) { return max } if (pos === 0) { return max } return pos + _utf8len[buf[pos]] > max ? pos : max }; var buf2string = function (buf) { var str, i, out, c, c_len; var len = buf.length; var utf16buf = new Array(len * 2); for (out = 0, i = 0; i < len;) { c = buf[i++]; if (c < 128) { utf16buf[out++] = c; continue } c_len = _utf8len[c]; if (c_len > 4) { utf16buf[out++] = 65533; i += c_len - 1; continue } c &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7; while (c_len > 1 && i < len) { c = c << 6 | buf[i++] & 63; c_len-- } if (c_len > 1) { utf16buf[out++] = 65533; continue } if (c < 65536) { utf16buf[out++] = c } else { c -= 65536; utf16buf[out++] = 55296 | c >> 10 & 1023; utf16buf[out++] = 56320 | c & 1023 } } if (utf16buf.length !== out) { if (utf16buf.subarray) { utf16buf = utf16buf.subarray(0, out) } else { utf16buf.length = out } } return utils.applyFromCharCode(utf16buf) }; exports.utf8encode = function utf8encode(str) { if (support.nodebuffer) { return nodeBuffer(str, "utf-8") } return string2buf(str) }; exports.utf8decode = function utf8decode(buf) { if (support.nodebuffer) { return utils.transformTo("nodebuffer", buf).toString("utf-8") } buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf); var result = [], k = 0, len = buf.length, chunk = 65536; while (k < len) { var nextBoundary = utf8border(buf, Math.min(k + chunk, len)); if (support.uint8array) { result.push(buf2string(buf.subarray(k, nextBoundary))) } else { result.push(buf2string(buf.slice(k, nextBoundary))) } k = nextBoundary } return result.join("") } }, { "./nodeBuffer": 11, "./support": 17, "./utils": 21 }], 21: [function (_dereq_, module, exports) {
            "use strict"; var support = _dereq_("./support"); var compressions = _dereq_("./compressions"); var nodeBuffer = _dereq_("./nodeBuffer"); exports.string2binary = function (str) { var result = ""; for (var i = 0; i < str.length; i++) { result += String.fromCharCode(str.charCodeAt(i) & 255) } return result }; exports.arrayBuffer2Blob = function (buffer) { exports.checkSupport("blob"); try { return new Blob([buffer], { type: "application/zip" }) } catch (e) { try { var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder; var builder = new Builder; builder.append(buffer); return builder.getBlob("application/zip") } catch (e) { throw new Error("Bug : can't construct the Blob.") } } }; function identity(input) { return input } function stringToArrayLike(str, array) { for (var i = 0; i < str.length; ++i) { array[i] = str.charCodeAt(i) & 255 } return array } function arrayLikeToString(array) { var chunk = 65536; var result = [], len = array.length, type = exports.getTypeOf(array), k = 0, canUseApply = true; try { switch (type) { case "uint8array": String.fromCharCode.apply(null, new Uint8Array(0)); break; case "nodebuffer": String.fromCharCode.apply(null, nodeBuffer(0)); break } } catch (e) { canUseApply = false } if (!canUseApply) { var resultStr = ""; for (var i = 0; i < array.length; i++) { resultStr += String.fromCharCode(array[i]) } return resultStr } while (k < len && chunk > 1) { try { if (type === "array" || type === "nodebuffer") { result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len)))) } else { result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len)))) } k += chunk } catch (e) { chunk = Math.floor(chunk / 2) } } return result.join("") } exports.applyFromCharCode = arrayLikeToString; function arrayLikeToArrayLike(arrayFrom, arrayTo) { for (var i = 0; i < arrayFrom.length; i++) { arrayTo[i] = arrayFrom[i] } return arrayTo } var transform = {}; transform["string"] = { string: identity, array: function (input) { return stringToArrayLike(input, new Array(input.length)) }, arraybuffer: function (input) { return transform["string"]["uint8array"](input).buffer }, uint8array: function (input) { return stringToArrayLike(input, new Uint8Array(input.length)) }, nodebuffer: function (input) { return stringToArrayLike(input, nodeBuffer(input.length)) } }; transform["array"] = { string: arrayLikeToString, array: identity, arraybuffer: function (input) { return new Uint8Array(input).buffer }, uint8array: function (input) { return new Uint8Array(input) }, nodebuffer: function (input) { return nodeBuffer(input) } }; transform["arraybuffer"] = { string: function (input) { return arrayLikeToString(new Uint8Array(input)) }, array: function (input) { return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength)) }, arraybuffer: identity, uint8array: function (input) { return new Uint8Array(input) }, nodebuffer: function (input) { return nodeBuffer(new Uint8Array(input)) } }; transform["uint8array"] = { string: arrayLikeToString, array: function (input) { return arrayLikeToArrayLike(input, new Array(input.length)) }, arraybuffer: function (input) { return input.buffer }, uint8array: identity, nodebuffer: function (input) { return nodeBuffer(input) } }; transform["nodebuffer"] = { string: arrayLikeToString, array: function (input) { return arrayLikeToArrayLike(input, new Array(input.length)) }, arraybuffer: function (input) { return transform["nodebuffer"]["uint8array"](input).buffer }, uint8array: function (input) { return arrayLikeToArrayLike(input, new Uint8Array(input.length)) }, nodebuffer: identity }; exports.transformTo = function (outputType, input) { if (!input) { input = "" } if (!outputType) { return input } exports.checkSupport(outputType); var inputType = exports.getTypeOf(input); var result = transform[inputType][outputType](input); return result }; exports.getTypeOf = function (input) { if (typeof input === "string") { return "string" } if (Object.prototype.toString.call(input) === "[object Array]") { return "array" } if (support.nodebuffer && nodeBuffer.test(input)) { return "nodebuffer" } if (support.uint8array && input instanceof Uint8Array) { return "uint8array" } if (support.arraybuffer && input instanceof ArrayBuffer) { return "arraybuffer" } }; exports.checkSupport = function (type) { var supported = support[type.toLowerCase()]; if (!supported) { throw new Error(type + " is not supported by this browser") } }; exports.MAX_VALUE_16BITS = 65535; exports.MAX_VALUE_32BITS = -1; exports.pretty = function (str) {
                var res = "", code, i; for (i = 0; i < (str || "").length; i++) {
                    code = str.charCodeAt(i); res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase()
                } return res
            }; exports.findCompression = function (compressionMethod) { for (var method in compressions) { if (!compressions.hasOwnProperty(method)) { continue } if (compressions[method].magic === compressionMethod) { return compressions[method] } } return null }; exports.isRegExp = function (object) { return Object.prototype.toString.call(object) === "[object RegExp]" }
        }, { "./compressions": 3, "./nodeBuffer": 11, "./support": 17 }], 22: [function (_dereq_, module, exports) { "use strict"; var StringReader = _dereq_("./stringReader"); var NodeBufferReader = _dereq_("./nodeBufferReader"); var Uint8ArrayReader = _dereq_("./uint8ArrayReader"); var utils = _dereq_("./utils"); var sig = _dereq_("./signature"); var ZipEntry = _dereq_("./zipEntry"); var support = _dereq_("./support"); var jszipProto = _dereq_("./object"); function ZipEntries(data, loadOptions) { this.files = []; this.loadOptions = loadOptions; if (data) { this.load(data) } } ZipEntries.prototype = { checkSignature: function (expectedSignature) { var signature = this.reader.readString(4); if (signature !== expectedSignature) { throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")") } }, readBlockEndOfCentral: function () { this.diskNumber = this.reader.readInt(2); this.diskWithCentralDirStart = this.reader.readInt(2); this.centralDirRecordsOnThisDisk = this.reader.readInt(2); this.centralDirRecords = this.reader.readInt(2); this.centralDirSize = this.reader.readInt(4); this.centralDirOffset = this.reader.readInt(4); this.zipCommentLength = this.reader.readInt(2); this.zipComment = this.reader.readString(this.zipCommentLength); this.zipComment = jszipProto.utf8decode(this.zipComment) }, readBlockZip64EndOfCentral: function () { this.zip64EndOfCentralSize = this.reader.readInt(8); this.versionMadeBy = this.reader.readString(2); this.versionNeeded = this.reader.readInt(2); this.diskNumber = this.reader.readInt(4); this.diskWithCentralDirStart = this.reader.readInt(4); this.centralDirRecordsOnThisDisk = this.reader.readInt(8); this.centralDirRecords = this.reader.readInt(8); this.centralDirSize = this.reader.readInt(8); this.centralDirOffset = this.reader.readInt(8); this.zip64ExtensibleData = {}; var extraDataSize = this.zip64EndOfCentralSize - 44, index = 0, extraFieldId, extraFieldLength, extraFieldValue; while (index < extraDataSize) { extraFieldId = this.reader.readInt(2); extraFieldLength = this.reader.readInt(4); extraFieldValue = this.reader.readString(extraFieldLength); this.zip64ExtensibleData[extraFieldId] = { id: extraFieldId, length: extraFieldLength, value: extraFieldValue } } }, readBlockZip64EndOfCentralLocator: function () { this.diskWithZip64CentralDirStart = this.reader.readInt(4); this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8); this.disksCount = this.reader.readInt(4); if (this.disksCount > 1) { throw new Error("Multi-volumes zip are not supported") } }, readLocalFiles: function () { var i, file; for (i = 0; i < this.files.length; i++) { file = this.files[i]; this.reader.setIndex(file.localHeaderOffset); this.checkSignature(sig.LOCAL_FILE_HEADER); file.readLocalPart(this.reader); file.handleUTF8() } }, readCentralDir: function () { var file; this.reader.setIndex(this.centralDirOffset); while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) { file = new ZipEntry({ zip64: this.zip64 }, this.loadOptions); file.readCentralPart(this.reader); this.files.push(file) } }, readEndOfCentral: function () { var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END); if (offset === -1) { throw new Error("Corrupted zip : can't find end of central directory") } this.reader.setIndex(offset); this.checkSignature(sig.CENTRAL_DIRECTORY_END); this.readBlockEndOfCentral(); if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) { this.zip64 = true; offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR); if (offset === -1) { throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator") } this.reader.setIndex(offset); this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR); this.readBlockZip64EndOfCentralLocator(); this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir); this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END); this.readBlockZip64EndOfCentral() } }, prepareReader: function (data) { var type = utils.getTypeOf(data); if (type === "string" && !support.uint8array) { this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString) } else if (type === "nodebuffer") { this.reader = new NodeBufferReader(data) } else { this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data)) } }, load: function (data) { this.prepareReader(data); this.readEndOfCentral(); this.readCentralDir(); this.readLocalFiles() } }; module.exports = ZipEntries }, { "./nodeBufferReader": 12, "./object": 13, "./signature": 14, "./stringReader": 15, "./support": 17, "./uint8ArrayReader": 18, "./utils": 21, "./zipEntry": 23 }], 23: [function (_dereq_, module, exports) { "use strict"; var StringReader = _dereq_("./stringReader"); var utils = _dereq_("./utils"); var CompressedObject = _dereq_("./compressedObject"); var jszipProto = _dereq_("./object"); function ZipEntry(options, loadOptions) { this.options = options; this.loadOptions = loadOptions } ZipEntry.prototype = { isEncrypted: function () { return (this.bitFlag & 1) === 1 }, useUTF8: function () { return (this.bitFlag & 2048) === 2048 }, prepareCompressedContent: function (reader, from, length) { return function () { var previousIndex = reader.index; reader.setIndex(from); var compressedFileData = reader.readData(length); reader.setIndex(previousIndex); return compressedFileData } }, prepareContent: function (reader, from, length, compression, uncompressedSize) { return function () { var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent()); var uncompressedFileData = compression.uncompress(compressedFileData); if (uncompressedFileData.length !== uncompressedSize) { throw new Error("Bug : uncompressed data size mismatch") } return uncompressedFileData } }, readLocalPart: function (reader) { var compression, localExtraFieldsLength; reader.skip(22); this.fileNameLength = reader.readInt(2); localExtraFieldsLength = reader.readInt(2); this.fileName = reader.readString(this.fileNameLength); reader.skip(localExtraFieldsLength); if (this.compressedSize == -1 || this.uncompressedSize == -1) { throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)") } compression = utils.findCompression(this.compressionMethod); if (compression === null) { throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")") } this.decompressed = new CompressedObject; this.decompressed.compressedSize = this.compressedSize; this.decompressed.uncompressedSize = this.uncompressedSize; this.decompressed.crc32 = this.crc32; this.decompressed.compressionMethod = this.compressionMethod; this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression); this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize); if (this.loadOptions.checkCRC32) { this.decompressed = utils.transformTo("string", this.decompressed.getContent()); if (jszipProto.crc32(this.decompressed) !== this.crc32) { throw new Error("Corrupted zip : CRC32 mismatch") } } }, readCentralPart: function (reader) { this.versionMadeBy = reader.readString(2); this.versionNeeded = reader.readInt(2); this.bitFlag = reader.readInt(2); this.compressionMethod = reader.readString(2); this.date = reader.readDate(); this.crc32 = reader.readInt(4); this.compressedSize = reader.readInt(4); this.uncompressedSize = reader.readInt(4); this.fileNameLength = reader.readInt(2); this.extraFieldsLength = reader.readInt(2); this.fileCommentLength = reader.readInt(2); this.diskNumberStart = reader.readInt(2); this.internalFileAttributes = reader.readInt(2); this.externalFileAttributes = reader.readInt(4); this.localHeaderOffset = reader.readInt(4); if (this.isEncrypted()) { throw new Error("Encrypted zip are not supported") } this.fileName = reader.readString(this.fileNameLength); this.readExtraFields(reader); this.parseZIP64ExtraField(reader); this.fileComment = reader.readString(this.fileCommentLength); this.dir = this.externalFileAttributes & 16 ? true : false }, parseZIP64ExtraField: function (reader) { if (!this.extraFields[1]) { return } var extraReader = new StringReader(this.extraFields[1].value); if (this.uncompressedSize === utils.MAX_VALUE_32BITS) { this.uncompressedSize = extraReader.readInt(8) } if (this.compressedSize === utils.MAX_VALUE_32BITS) { this.compressedSize = extraReader.readInt(8) } if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) { this.localHeaderOffset = extraReader.readInt(8) } if (this.diskNumberStart === utils.MAX_VALUE_32BITS) { this.diskNumberStart = extraReader.readInt(4) } }, readExtraFields: function (reader) { var start = reader.index, extraFieldId, extraFieldLength, extraFieldValue; this.extraFields = this.extraFields || {}; while (reader.index < start + this.extraFieldsLength) { extraFieldId = reader.readInt(2); extraFieldLength = reader.readInt(2); extraFieldValue = reader.readString(extraFieldLength); this.extraFields[extraFieldId] = { id: extraFieldId, length: extraFieldLength, value: extraFieldValue } } }, handleUTF8: function () { if (this.useUTF8()) { this.fileName = jszipProto.utf8decode(this.fileName); this.fileComment = jszipProto.utf8decode(this.fileComment) } else { var upath = this.findExtraFieldUnicodePath(); if (upath !== null) { this.fileName = upath } var ucomment = this.findExtraFieldUnicodeComment(); if (ucomment !== null) { this.fileComment = ucomment } } }, findExtraFieldUnicodePath: function () { var upathField = this.extraFields[28789]; if (upathField) { var extraReader = new StringReader(upathField.value); if (extraReader.readInt(1) !== 1) { return null } if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) { return null } return jszipProto.utf8decode(extraReader.readString(upathField.length - 5)) } return null }, findExtraFieldUnicodeComment: function () { var ucommentField = this.extraFields[25461]; if (ucommentField) { var extraReader = new StringReader(ucommentField.value); if (extraReader.readInt(1) !== 1) { return null } if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) { return null } return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5)) } return null } }; module.exports = ZipEntry }, { "./compressedObject": 2, "./object": 13, "./stringReader": 15, "./utils": 21 }], 24: [function (_dereq_, module, exports) { "use strict"; var assign = _dereq_("./lib/utils/common").assign; var deflate = _dereq_("./lib/deflate"); var inflate = _dereq_("./lib/inflate"); var constants = _dereq_("./lib/zlib/constants"); var pako = {}; assign(pako, deflate, inflate, constants); module.exports = pako }, { "./lib/deflate": 25, "./lib/inflate": 26, "./lib/utils/common": 27, "./lib/zlib/constants": 30 }], 25: [function (_dereq_, module, exports) { "use strict"; var zlib_deflate = _dereq_("./zlib/deflate.js"); var utils = _dereq_("./utils/common"); var strings = _dereq_("./utils/strings"); var msg = _dereq_("./zlib/messages"); var zstream = _dereq_("./zlib/zstream"); var Z_NO_FLUSH = 0; var Z_FINISH = 4; var Z_OK = 0; var Z_STREAM_END = 1; var Z_DEFAULT_COMPRESSION = -1; var Z_DEFAULT_STRATEGY = 0; var Z_DEFLATED = 8; var Deflate = function (options) { this.options = utils.assign({ level: Z_DEFAULT_COMPRESSION, method: Z_DEFLATED, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: Z_DEFAULT_STRATEGY, to: "" }, options || {}); var opt = this.options; if (opt.raw && opt.windowBits > 0) { opt.windowBits = -opt.windowBits } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) { opt.windowBits += 16 } this.err = 0; this.msg = ""; this.ended = false; this.chunks = []; this.strm = new zstream; this.strm.avail_out = 0; var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy); if (status !== Z_OK) { throw new Error(msg[status]) } if (opt.header) { zlib_deflate.deflateSetHeader(this.strm, opt.header) } }; Deflate.prototype.push = function (data, mode) { var strm = this.strm; var chunkSize = this.options.chunkSize; var status, _mode; if (this.ended) { return false } _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH; if (typeof data === "string") { strm.input = strings.string2buf(data) } else { strm.input = data } strm.next_in = 0; strm.avail_in = strm.input.length; do { if (strm.avail_out === 0) { strm.output = new utils.Buf8(chunkSize); strm.next_out = 0; strm.avail_out = chunkSize } status = zlib_deflate.deflate(strm, _mode); if (status !== Z_STREAM_END && status !== Z_OK) { this.onEnd(status); this.ended = true; return false } if (strm.avail_out === 0 || strm.avail_in === 0 && _mode === Z_FINISH) { if (this.options.to === "string") { this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out))) } else { this.onData(utils.shrinkBuf(strm.output, strm.next_out)) } } } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END); if (_mode === Z_FINISH) { status = zlib_deflate.deflateEnd(this.strm); this.onEnd(status); this.ended = true; return status === Z_OK } return true }; Deflate.prototype.onData = function (chunk) { this.chunks.push(chunk) }; Deflate.prototype.onEnd = function (status) { if (status === Z_OK) { if (this.options.to === "string") { this.result = this.chunks.join("") } else { this.result = utils.flattenChunks(this.chunks) } } this.chunks = []; this.err = status; this.msg = this.strm.msg }; function deflate(input, options) { var deflator = new Deflate(options); deflator.push(input, true); if (deflator.err) { throw deflator.msg } return deflator.result } function deflateRaw(input, options) { options = options || {}; options.raw = true; return deflate(input, options) } function gzip(input, options) { options = options || {}; options.gzip = true; return deflate(input, options) } exports.Deflate = Deflate; exports.deflate = deflate; exports.deflateRaw = deflateRaw; exports.gzip = gzip }, { "./utils/common": 27, "./utils/strings": 28, "./zlib/deflate.js": 32, "./zlib/messages": 37, "./zlib/zstream": 39 }], 26: [function (_dereq_, module, exports) { "use strict"; var zlib_inflate = _dereq_("./zlib/inflate.js"); var utils = _dereq_("./utils/common"); var strings = _dereq_("./utils/strings"); var c = _dereq_("./zlib/constants"); var msg = _dereq_("./zlib/messages"); var zstream = _dereq_("./zlib/zstream"); var gzheader = _dereq_("./zlib/gzheader"); var Inflate = function (options) { this.options = utils.assign({ chunkSize: 16384, windowBits: 0, to: "" }, options || {}); var opt = this.options; if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) { opt.windowBits = -opt.windowBits; if (opt.windowBits === 0) { opt.windowBits = -15 } } if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) { opt.windowBits += 32 } if (opt.windowBits > 15 && opt.windowBits < 48) { if ((opt.windowBits & 15) === 0) { opt.windowBits |= 15 } } this.err = 0; this.msg = ""; this.ended = false; this.chunks = []; this.strm = new zstream; this.strm.avail_out = 0; var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits); if (status !== c.Z_OK) { throw new Error(msg[status]) } this.header = new gzheader; zlib_inflate.inflateGetHeader(this.strm, this.header) }; Inflate.prototype.push = function (data, mode) { var strm = this.strm; var chunkSize = this.options.chunkSize; var status, _mode; var next_out_utf8, tail, utf8str; if (this.ended) { return false } _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH; if (typeof data === "string") { strm.input = strings.binstring2buf(data) } else { strm.input = data } strm.next_in = 0; strm.avail_in = strm.input.length; do { if (strm.avail_out === 0) { strm.output = new utils.Buf8(chunkSize); strm.next_out = 0; strm.avail_out = chunkSize } status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH); if (status !== c.Z_STREAM_END && status !== c.Z_OK) { this.onEnd(status); this.ended = true; return false } if (strm.next_out) { if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && _mode === c.Z_FINISH) { if (this.options.to === "string") { next_out_utf8 = strings.utf8border(strm.output, strm.next_out); tail = strm.next_out - next_out_utf8; utf8str = strings.buf2string(strm.output, next_out_utf8); strm.next_out = tail; strm.avail_out = chunkSize - tail; if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0) } this.onData(utf8str) } else { this.onData(utils.shrinkBuf(strm.output, strm.next_out)) } } } } while (strm.avail_in > 0 && status !== c.Z_STREAM_END); if (status === c.Z_STREAM_END) { _mode = c.Z_FINISH } if (_mode === c.Z_FINISH) { status = zlib_inflate.inflateEnd(this.strm); this.onEnd(status); this.ended = true; return status === c.Z_OK } return true }; Inflate.prototype.onData = function (chunk) { this.chunks.push(chunk) }; Inflate.prototype.onEnd = function (status) { if (status === c.Z_OK) { if (this.options.to === "string") { this.result = this.chunks.join("") } else { this.result = utils.flattenChunks(this.chunks) } } this.chunks = []; this.err = status; this.msg = this.strm.msg }; function inflate(input, options) { var inflator = new Inflate(options); inflator.push(input, true); if (inflator.err) { throw inflator.msg } return inflator.result } function inflateRaw(input, options) { options = options || {}; options.raw = true; return inflate(input, options) } exports.Inflate = Inflate; exports.inflate = inflate; exports.inflateRaw = inflateRaw; exports.ungzip = inflate }, { "./utils/common": 27, "./utils/strings": 28, "./zlib/constants": 30, "./zlib/gzheader": 33, "./zlib/inflate.js": 35, "./zlib/messages": 37, "./zlib/zstream": 39 }], 27: [function (_dereq_, module, exports) { "use strict"; var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined"; exports.assign = function (obj) { var sources = Array.prototype.slice.call(arguments, 1); while (sources.length) { var source = sources.shift(); if (!source) { continue } if (typeof source !== "object") { throw new TypeError(source + "must be non-object") } for (var p in source) { if (source.hasOwnProperty(p)) { obj[p] = source[p] } } } return obj }; exports.shrinkBuf = function (buf, size) { if (buf.length === size) { return buf } if (buf.subarray) { return buf.subarray(0, size) } buf.length = size; return buf }; var fnTyped = { arraySet: function (dest, src, src_offs, len, dest_offs) { if (src.subarray && dest.subarray) { dest.set(src.subarray(src_offs, src_offs + len), dest_offs); return } for (var i = 0; i < len; i++) { dest[dest_offs + i] = src[src_offs + i] } }, flattenChunks: function (chunks) { var i, l, len, pos, chunk, result; len = 0; for (i = 0, l = chunks.length; i < l; i++) { len += chunks[i].length } result = new Uint8Array(len); pos = 0; for (i = 0, l = chunks.length; i < l; i++) { chunk = chunks[i]; result.set(chunk, pos); pos += chunk.length } return result } }; var fnUntyped = { arraySet: function (dest, src, src_offs, len, dest_offs) { for (var i = 0; i < len; i++) { dest[dest_offs + i] = src[src_offs + i] } }, flattenChunks: function (chunks) { return [].concat.apply([], chunks) } }; exports.setTyped = function (on) { if (on) { exports.Buf8 = Uint8Array; exports.Buf16 = Uint16Array; exports.Buf32 = Int32Array; exports.assign(exports, fnTyped) } else { exports.Buf8 = Array; exports.Buf16 = Array; exports.Buf32 = Array; exports.assign(exports, fnUntyped) } }; exports.setTyped(TYPED_OK) }, {}], 28: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("./common"); var STR_APPLY_OK = true; var STR_APPLY_UIA_OK = true; try { String.fromCharCode.apply(null, [0]) } catch (__) { STR_APPLY_OK = false } try { String.fromCharCode.apply(null, new Uint8Array(1)) } catch (__) { STR_APPLY_UIA_OK = false } var _utf8len = new utils.Buf8(256); for (var i = 0; i < 256; i++) { _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1 } _utf8len[254] = _utf8len[254] = 1; exports.string2buf = function (str) { var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0; for (m_pos = 0; m_pos < str_len; m_pos++) { c = str.charCodeAt(m_pos); if ((c & 64512) === 55296 && m_pos + 1 < str_len) { c2 = str.charCodeAt(m_pos + 1); if ((c2 & 64512) === 56320) { c = 65536 + (c - 55296 << 10) + (c2 - 56320); m_pos++ } } buf_len += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4 } buf = new utils.Buf8(buf_len); for (i = 0, m_pos = 0; i < buf_len; m_pos++) { c = str.charCodeAt(m_pos); if ((c & 64512) === 55296 && m_pos + 1 < str_len) { c2 = str.charCodeAt(m_pos + 1); if ((c2 & 64512) === 56320) { c = 65536 + (c - 55296 << 10) + (c2 - 56320); m_pos++ } } if (c < 128) { buf[i++] = c } else if (c < 2048) { buf[i++] = 192 | c >>> 6; buf[i++] = 128 | c & 63 } else if (c < 65536) { buf[i++] = 224 | c >>> 12; buf[i++] = 128 | c >>> 6 & 63; buf[i++] = 128 | c & 63 } else { buf[i++] = 240 | c >>> 18; buf[i++] = 128 | c >>> 12 & 63; buf[i++] = 128 | c >>> 6 & 63; buf[i++] = 128 | c & 63 } } return buf }; function buf2binstring(buf, len) { if (len < 65537) { if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) { return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len)) } } var result = ""; for (var i = 0; i < len; i++) { result += String.fromCharCode(buf[i]) } return result } exports.buf2binstring = function (buf) { return buf2binstring(buf, buf.length) }; exports.binstring2buf = function (str) { var buf = new utils.Buf8(str.length); for (var i = 0, len = buf.length; i < len; i++) { buf[i] = str.charCodeAt(i) } return buf }; exports.buf2string = function (buf, max) { var i, out, c, c_len; var len = max || buf.length; var utf16buf = new Array(len * 2); for (out = 0, i = 0; i < len;) { c = buf[i++]; if (c < 128) { utf16buf[out++] = c; continue } c_len = _utf8len[c]; if (c_len > 4) { utf16buf[out++] = 65533; i += c_len - 1; continue } c &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7; while (c_len > 1 && i < len) { c = c << 6 | buf[i++] & 63; c_len-- } if (c_len > 1) { utf16buf[out++] = 65533; continue } if (c < 65536) { utf16buf[out++] = c } else { c -= 65536; utf16buf[out++] = 55296 | c >> 10 & 1023; utf16buf[out++] = 56320 | c & 1023 } } return buf2binstring(utf16buf, out) }; exports.utf8border = function (buf, max) { var pos; max = max || buf.length; if (max > buf.length) { max = buf.length } pos = max - 1; while (pos >= 0 && (buf[pos] & 192) === 128) { pos-- } if (pos < 0) { return max } if (pos === 0) { return max } return pos + _utf8len[buf[pos]] > max ? pos : max } }, { "./common": 27 }], 29: [function (_dereq_, module, exports) { "use strict"; function adler32(adler, buf, len, pos) { var s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n = 0; while (len !== 0) { n = len > 2e3 ? 2e3 : len; len -= n; do { s1 = s1 + buf[pos++] | 0; s2 = s2 + s1 | 0 } while (--n); s1 %= 65521; s2 %= 65521 } return s1 | s2 << 16 | 0 } module.exports = adler32 }, {}], 30: [function (_dereq_, module, exports) { module.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 } }, {}], 31: [function (_dereq_, module, exports) { "use strict"; function makeTable() { var c, table = []; for (var n = 0; n < 256; n++) { c = n; for (var k = 0; k < 8; k++) { c = c & 1 ? 3988292384 ^ c >>> 1 : c >>> 1 } table[n] = c } return table } var crcTable = makeTable(); function crc32(crc, buf, len, pos) { var t = crcTable, end = pos + len; crc = crc ^ -1; for (var i = pos; i < end; i++) { crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 255] } return crc ^ -1 } module.exports = crc32 }, {}], 32: [function (_dereq_, module, exports) {
            "use strict"; var utils = _dereq_("../utils/common"); var trees = _dereq_("./trees"); var adler32 = _dereq_("./adler32"); var crc32 = _dereq_("./crc32"); var msg = _dereq_("./messages"); var Z_NO_FLUSH = 0; var Z_PARTIAL_FLUSH = 1; var Z_FULL_FLUSH = 3; var Z_FINISH = 4; var Z_BLOCK = 5; var Z_OK = 0; var Z_STREAM_END = 1; var Z_STREAM_ERROR = -2; var Z_DATA_ERROR = -3; var Z_BUF_ERROR = -5; var Z_DEFAULT_COMPRESSION = -1; var Z_FILTERED = 1; var Z_HUFFMAN_ONLY = 2; var Z_RLE = 3; var Z_FIXED = 4; var Z_DEFAULT_STRATEGY = 0; var Z_UNKNOWN = 2; var Z_DEFLATED = 8; var MAX_MEM_LEVEL = 9; var MAX_WBITS = 15; var DEF_MEM_LEVEL = 8; var LENGTH_CODES = 29; var LITERALS = 256; var L_CODES = LITERALS + 1 + LENGTH_CODES; var D_CODES = 30; var BL_CODES = 19; var HEAP_SIZE = 2 * L_CODES + 1; var MAX_BITS = 15; var MIN_MATCH = 3; var MAX_MATCH = 258; var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1; var PRESET_DICT = 32; var INIT_STATE = 42; var EXTRA_STATE = 69; var NAME_STATE = 73; var COMMENT_STATE = 91; var HCRC_STATE = 103; var BUSY_STATE = 113; var FINISH_STATE = 666; var BS_NEED_MORE = 1; var BS_BLOCK_DONE = 2; var BS_FINISH_STARTED = 3; var BS_FINISH_DONE = 4; var OS_CODE = 3; function err(strm, errorCode) { strm.msg = msg[errorCode]; return errorCode } function rank(f) { return (f << 1) - (f > 4 ? 9 : 0) } function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0 } } function flush_pending(strm) { var s = strm.state; var len = s.pending; if (len > strm.avail_out) { len = strm.avail_out } if (len === 0) { return } utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out); strm.next_out += len; s.pending_out += len; strm.total_out += len; strm.avail_out -= len; s.pending -= len; if (s.pending === 0) { s.pending_out = 0 } } function flush_block_only(s, last) { trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last); s.block_start = s.strstart; flush_pending(s.strm) } function put_byte(s, b) { s.pending_buf[s.pending++] = b } function putShortMSB(s, b) { s.pending_buf[s.pending++] = b >>> 8 & 255; s.pending_buf[s.pending++] = b & 255 } function read_buf(strm, buf, start, size) { var len = strm.avail_in; if (len > size) { len = size } if (len === 0) { return 0 } strm.avail_in -= len; utils.arraySet(buf, strm.input, strm.next_in, len, start); if (strm.state.wrap === 1) { strm.adler = adler32(strm.adler, buf, len, start) } else if (strm.state.wrap === 2) { strm.adler = crc32(strm.adler, buf, len, start) } strm.next_in += len; strm.total_in += len; return len } function longest_match(s, cur_match) { var chain_length = s.max_chain_length; var scan = s.strstart; var match; var len; var best_len = s.prev_length; var nice_match = s.nice_match; var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0; var _win = s.window; var wmask = s.w_mask; var prev = s.prev; var strend = s.strstart + MAX_MATCH; var scan_end1 = _win[scan + best_len - 1]; var scan_end = _win[scan + best_len]; if (s.prev_length >= s.good_match) { chain_length >>= 2 } if (nice_match > s.lookahead) { nice_match = s.lookahead } do { match = cur_match; if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) { continue } scan += 2; match++; do { } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend); len = MAX_MATCH - (strend - scan); scan = strend - MAX_MATCH; if (len > best_len) { s.match_start = cur_match; best_len = len; if (len >= nice_match) { break } scan_end1 = _win[scan + best_len - 1]; scan_end = _win[scan + best_len] } } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0); if (best_len <= s.lookahead) { return best_len } return s.lookahead } function fill_window(s) { var _w_size = s.w_size; var p, n, m, more, str; do { more = s.window_size - s.lookahead - s.strstart; if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) { utils.arraySet(s.window, s.window, _w_size, _w_size, 0); s.match_start -= _w_size; s.strstart -= _w_size; s.block_start -= _w_size; n = s.hash_size; p = n; do { m = s.head[--p]; s.head[p] = m >= _w_size ? m - _w_size : 0 } while (--n); n = _w_size; p = n; do { m = s.prev[--p]; s.prev[p] = m >= _w_size ? m - _w_size : 0 } while (--n); more += _w_size } if (s.strm.avail_in === 0) { break } n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more); s.lookahead += n; if (s.lookahead + s.insert >= MIN_MATCH) { str = s.strstart - s.insert; s.ins_h = s.window[str]; s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask; while (s.insert) { s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask; s.prev[str & s.w_mask] = s.head[s.ins_h]; s.head[s.ins_h] = str; str++; s.insert--; if (s.lookahead + s.insert < MIN_MATCH) { break } } } } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0) } function deflate_stored(s, flush) { var max_block_size = 65535; if (max_block_size > s.pending_buf_size - 5) { max_block_size = s.pending_buf_size - 5 } for (; ;) { if (s.lookahead <= 1) { fill_window(s); if (s.lookahead === 0 && flush === Z_NO_FLUSH) { return BS_NEED_MORE } if (s.lookahead === 0) { break } } s.strstart += s.lookahead; s.lookahead = 0; var max_start = s.block_start + max_block_size; if (s.strstart === 0 || s.strstart >= max_start) { s.lookahead = s.strstart - max_start; s.strstart = max_start; flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } } s.insert = 0; if (flush === Z_FINISH) { flush_block_only(s, true); if (s.strm.avail_out === 0) { return BS_FINISH_STARTED } return BS_FINISH_DONE } if (s.strstart > s.block_start) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } return BS_NEED_MORE } function deflate_fast(s, flush) { var hash_head; var bflush; for (; ;) { if (s.lookahead < MIN_LOOKAHEAD) { fill_window(s); if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) { return BS_NEED_MORE } if (s.lookahead === 0) { break } } hash_head = 0; if (s.lookahead >= MIN_MATCH) { s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask; hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h]; s.head[s.ins_h] = s.strstart } if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) { s.match_length = longest_match(s, hash_head) } if (s.match_length >= MIN_MATCH) { bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH); s.lookahead -= s.match_length; if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH) { s.match_length--; do { s.strstart++; s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask; hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h]; s.head[s.ins_h] = s.strstart } while (--s.match_length !== 0); s.strstart++ } else { s.strstart += s.match_length; s.match_length = 0; s.ins_h = s.window[s.strstart]; s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask } } else { bflush = trees._tr_tally(s, 0, s.window[s.strstart]); s.lookahead--; s.strstart++ } if (bflush) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } } s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1; if (flush === Z_FINISH) { flush_block_only(s, true); if (s.strm.avail_out === 0) { return BS_FINISH_STARTED } return BS_FINISH_DONE } if (s.last_lit) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } return BS_BLOCK_DONE } function deflate_slow(s, flush) { var hash_head; var bflush; var max_insert; for (; ;) { if (s.lookahead < MIN_LOOKAHEAD) { fill_window(s); if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) { return BS_NEED_MORE } if (s.lookahead === 0) { break } } hash_head = 0; if (s.lookahead >= MIN_MATCH) { s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask; hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h]; s.head[s.ins_h] = s.strstart } s.prev_length = s.match_length; s.prev_match = s.match_start; s.match_length = MIN_MATCH - 1; if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) { s.match_length = longest_match(s, hash_head); if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096)) { s.match_length = MIN_MATCH - 1 } } if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) { max_insert = s.strstart + s.lookahead - MIN_MATCH; bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH); s.lookahead -= s.prev_length - 1; s.prev_length -= 2; do { if (++s.strstart <= max_insert) { s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask; hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h]; s.head[s.ins_h] = s.strstart } } while (--s.prev_length !== 0); s.match_available = 0; s.match_length = MIN_MATCH - 1; s.strstart++; if (bflush) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } } else if (s.match_available) { bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]); if (bflush) { flush_block_only(s, false) } s.strstart++; s.lookahead--; if (s.strm.avail_out === 0) { return BS_NEED_MORE } } else { s.match_available = 1; s.strstart++; s.lookahead-- } } if (s.match_available) { bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]); s.match_available = 0 } s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1; if (flush === Z_FINISH) { flush_block_only(s, true); if (s.strm.avail_out === 0) { return BS_FINISH_STARTED } return BS_FINISH_DONE } if (s.last_lit) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } return BS_BLOCK_DONE } function deflate_rle(s, flush) { var bflush; var prev; var scan, strend; var _win = s.window; for (; ;) { if (s.lookahead <= MAX_MATCH) { fill_window(s); if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) { return BS_NEED_MORE } if (s.lookahead === 0) { break } } s.match_length = 0; if (s.lookahead >= MIN_MATCH && s.strstart > 0) { scan = s.strstart - 1; prev = _win[scan]; if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) { strend = s.strstart + MAX_MATCH; do { } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend); s.match_length = MAX_MATCH - (strend - scan); if (s.match_length > s.lookahead) { s.match_length = s.lookahead } } } if (s.match_length >= MIN_MATCH) { bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH); s.lookahead -= s.match_length; s.strstart += s.match_length; s.match_length = 0 } else { bflush = trees._tr_tally(s, 0, s.window[s.strstart]); s.lookahead--; s.strstart++ } if (bflush) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } } s.insert = 0; if (flush === Z_FINISH) { flush_block_only(s, true); if (s.strm.avail_out === 0) { return BS_FINISH_STARTED } return BS_FINISH_DONE } if (s.last_lit) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } return BS_BLOCK_DONE } function deflate_huff(s, flush) {
                var bflush;
                for (; ;) { if (s.lookahead === 0) { fill_window(s); if (s.lookahead === 0) { if (flush === Z_NO_FLUSH) { return BS_NEED_MORE } break } } s.match_length = 0; bflush = trees._tr_tally(s, 0, s.window[s.strstart]); s.lookahead--; s.strstart++; if (bflush) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } } s.insert = 0; if (flush === Z_FINISH) { flush_block_only(s, true); if (s.strm.avail_out === 0) { return BS_FINISH_STARTED } return BS_FINISH_DONE } if (s.last_lit) { flush_block_only(s, false); if (s.strm.avail_out === 0) { return BS_NEED_MORE } } return BS_BLOCK_DONE
            } var Config = function (good_length, max_lazy, nice_length, max_chain, func) { this.good_length = good_length; this.max_lazy = max_lazy; this.nice_length = nice_length; this.max_chain = max_chain; this.func = func }; var configuration_table; configuration_table = [new Config(0, 0, 0, 0, deflate_stored), new Config(4, 4, 8, 4, deflate_fast), new Config(4, 5, 16, 8, deflate_fast), new Config(4, 6, 32, 32, deflate_fast), new Config(4, 4, 16, 16, deflate_slow), new Config(8, 16, 32, 32, deflate_slow), new Config(8, 16, 128, 128, deflate_slow), new Config(8, 32, 128, 256, deflate_slow), new Config(32, 128, 258, 1024, deflate_slow), new Config(32, 258, 258, 4096, deflate_slow)]; function lm_init(s) { s.window_size = 2 * s.w_size; zero(s.head); s.max_lazy_match = configuration_table[s.level].max_lazy; s.good_match = configuration_table[s.level].good_length; s.nice_match = configuration_table[s.level].nice_length; s.max_chain_length = configuration_table[s.level].max_chain; s.strstart = 0; s.block_start = 0; s.lookahead = 0; s.insert = 0; s.match_length = s.prev_length = MIN_MATCH - 1; s.match_available = 0; s.ins_h = 0 } function DeflateState() { this.strm = null; this.status = 0; this.pending_buf = null; this.pending_buf_size = 0; this.pending_out = 0; this.pending = 0; this.wrap = 0; this.gzhead = null; this.gzindex = 0; this.method = Z_DEFLATED; this.last_flush = -1; this.w_size = 0; this.w_bits = 0; this.w_mask = 0; this.window = null; this.window_size = 0; this.prev = null; this.head = null; this.ins_h = 0; this.hash_size = 0; this.hash_bits = 0; this.hash_mask = 0; this.hash_shift = 0; this.block_start = 0; this.match_length = 0; this.prev_match = 0; this.match_available = 0; this.strstart = 0; this.match_start = 0; this.lookahead = 0; this.prev_length = 0; this.max_chain_length = 0; this.max_lazy_match = 0; this.level = 0; this.strategy = 0; this.good_match = 0; this.nice_match = 0; this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2); this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2); this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2); zero(this.dyn_ltree); zero(this.dyn_dtree); zero(this.bl_tree); this.l_desc = null; this.d_desc = null; this.bl_desc = null; this.bl_count = new utils.Buf16(MAX_BITS + 1); this.heap = new utils.Buf16(2 * L_CODES + 1); zero(this.heap); this.heap_len = 0; this.heap_max = 0; this.depth = new utils.Buf16(2 * L_CODES + 1); zero(this.depth); this.l_buf = 0; this.lit_bufsize = 0; this.last_lit = 0; this.d_buf = 0; this.opt_len = 0; this.static_len = 0; this.matches = 0; this.insert = 0; this.bi_buf = 0; this.bi_valid = 0 } function deflateResetKeep(strm) { var s; if (!strm || !strm.state) { return err(strm, Z_STREAM_ERROR) } strm.total_in = strm.total_out = 0; strm.data_type = Z_UNKNOWN; s = strm.state; s.pending = 0; s.pending_out = 0; if (s.wrap < 0) { s.wrap = -s.wrap } s.status = s.wrap ? INIT_STATE : BUSY_STATE; strm.adler = s.wrap === 2 ? 0 : 1; s.last_flush = Z_NO_FLUSH; trees._tr_init(s); return Z_OK } function deflateReset(strm) { var ret = deflateResetKeep(strm); if (ret === Z_OK) { lm_init(strm.state) } return ret } function deflateSetHeader(strm, head) { if (!strm || !strm.state) { return Z_STREAM_ERROR } if (strm.state.wrap !== 2) { return Z_STREAM_ERROR } strm.state.gzhead = head; return Z_OK } function deflateInit2(strm, level, method, windowBits, memLevel, strategy) { if (!strm) { return Z_STREAM_ERROR } var wrap = 1; if (level === Z_DEFAULT_COMPRESSION) { level = 6 } if (windowBits < 0) { wrap = 0; windowBits = -windowBits } else if (windowBits > 15) { wrap = 2; windowBits -= 16 } if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) { return err(strm, Z_STREAM_ERROR) } if (windowBits === 8) { windowBits = 9 } var s = new DeflateState; strm.state = s; s.strm = strm; s.wrap = wrap; s.gzhead = null; s.w_bits = windowBits; s.w_size = 1 << s.w_bits; s.w_mask = s.w_size - 1; s.hash_bits = memLevel + 7; s.hash_size = 1 << s.hash_bits; s.hash_mask = s.hash_size - 1; s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH); s.window = new utils.Buf8(s.w_size * 2); s.head = new utils.Buf16(s.hash_size); s.prev = new utils.Buf16(s.w_size); s.lit_bufsize = 1 << memLevel + 6; s.pending_buf_size = s.lit_bufsize * 4; s.pending_buf = new utils.Buf8(s.pending_buf_size); s.d_buf = s.lit_bufsize >> 1; s.l_buf = (1 + 2) * s.lit_bufsize; s.level = level; s.strategy = strategy; s.method = method; return deflateReset(strm) } function deflateInit(strm, level) { return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY) } function deflate(strm, flush) { var old_flush, s; var beg, val; if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) { return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR } s = strm.state; if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) { return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR) } s.strm = strm; old_flush = s.last_flush; s.last_flush = flush; if (s.status === INIT_STATE) { if (s.wrap === 2) { strm.adler = 0; put_byte(s, 31); put_byte(s, 139); put_byte(s, 8); if (!s.gzhead) { put_byte(s, 0); put_byte(s, 0); put_byte(s, 0); put_byte(s, 0); put_byte(s, 0); put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0); put_byte(s, OS_CODE); s.status = BUSY_STATE } else { put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16)); put_byte(s, s.gzhead.time & 255); put_byte(s, s.gzhead.time >> 8 & 255); put_byte(s, s.gzhead.time >> 16 & 255); put_byte(s, s.gzhead.time >> 24 & 255); put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0); put_byte(s, s.gzhead.os & 255); if (s.gzhead.extra && s.gzhead.extra.length) { put_byte(s, s.gzhead.extra.length & 255); put_byte(s, s.gzhead.extra.length >> 8 & 255) } if (s.gzhead.hcrc) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0) } s.gzindex = 0; s.status = EXTRA_STATE } } else { var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8; var level_flags = -1; if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) { level_flags = 0 } else if (s.level < 6) { level_flags = 1 } else if (s.level === 6) { level_flags = 2 } else { level_flags = 3 } header |= level_flags << 6; if (s.strstart !== 0) { header |= PRESET_DICT } header += 31 - header % 31; s.status = BUSY_STATE; putShortMSB(s, header); if (s.strstart !== 0) { putShortMSB(s, strm.adler >>> 16); putShortMSB(s, strm.adler & 65535) } strm.adler = 1 } } if (s.status === EXTRA_STATE) { if (s.gzhead.extra) { beg = s.pending; while (s.gzindex < (s.gzhead.extra.length & 65535)) { if (s.pending === s.pending_buf_size) { if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } flush_pending(strm); beg = s.pending; if (s.pending === s.pending_buf_size) { break } } put_byte(s, s.gzhead.extra[s.gzindex] & 255); s.gzindex++ } if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } if (s.gzindex === s.gzhead.extra.length) { s.gzindex = 0; s.status = NAME_STATE } } else { s.status = NAME_STATE } } if (s.status === NAME_STATE) { if (s.gzhead.name) { beg = s.pending; do { if (s.pending === s.pending_buf_size) { if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } flush_pending(strm); beg = s.pending; if (s.pending === s.pending_buf_size) { val = 1; break } } if (s.gzindex < s.gzhead.name.length) { val = s.gzhead.name.charCodeAt(s.gzindex++) & 255 } else { val = 0 } put_byte(s, val) } while (val !== 0); if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } if (val === 0) { s.gzindex = 0; s.status = COMMENT_STATE } } else { s.status = COMMENT_STATE } } if (s.status === COMMENT_STATE) { if (s.gzhead.comment) { beg = s.pending; do { if (s.pending === s.pending_buf_size) { if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } flush_pending(strm); beg = s.pending; if (s.pending === s.pending_buf_size) { val = 1; break } } if (s.gzindex < s.gzhead.comment.length) { val = s.gzhead.comment.charCodeAt(s.gzindex++) & 255 } else { val = 0 } put_byte(s, val) } while (val !== 0); if (s.gzhead.hcrc && s.pending > beg) { strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg) } if (val === 0) { s.status = HCRC_STATE } } else { s.status = HCRC_STATE } } if (s.status === HCRC_STATE) { if (s.gzhead.hcrc) { if (s.pending + 2 > s.pending_buf_size) { flush_pending(strm) } if (s.pending + 2 <= s.pending_buf_size) { put_byte(s, strm.adler & 255); put_byte(s, strm.adler >> 8 & 255); strm.adler = 0; s.status = BUSY_STATE } } else { s.status = BUSY_STATE } } if (s.pending !== 0) { flush_pending(strm); if (strm.avail_out === 0) { s.last_flush = -1; return Z_OK } } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) { return err(strm, Z_BUF_ERROR) } if (s.status === FINISH_STATE && strm.avail_in !== 0) { return err(strm, Z_BUF_ERROR) } if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) { var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush); if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) { s.status = FINISH_STATE } if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) { if (strm.avail_out === 0) { s.last_flush = -1 } return Z_OK } if (bstate === BS_BLOCK_DONE) { if (flush === Z_PARTIAL_FLUSH) { trees._tr_align(s) } else if (flush !== Z_BLOCK) { trees._tr_stored_block(s, 0, 0, false); if (flush === Z_FULL_FLUSH) { zero(s.head); if (s.lookahead === 0) { s.strstart = 0; s.block_start = 0; s.insert = 0 } } } flush_pending(strm); if (strm.avail_out === 0) { s.last_flush = -1; return Z_OK } } } if (flush !== Z_FINISH) { return Z_OK } if (s.wrap <= 0) { return Z_STREAM_END } if (s.wrap === 2) { put_byte(s, strm.adler & 255); put_byte(s, strm.adler >> 8 & 255); put_byte(s, strm.adler >> 16 & 255); put_byte(s, strm.adler >> 24 & 255); put_byte(s, strm.total_in & 255); put_byte(s, strm.total_in >> 8 & 255); put_byte(s, strm.total_in >> 16 & 255); put_byte(s, strm.total_in >> 24 & 255) } else { putShortMSB(s, strm.adler >>> 16); putShortMSB(s, strm.adler & 65535) } flush_pending(strm); if (s.wrap > 0) { s.wrap = -s.wrap } return s.pending !== 0 ? Z_OK : Z_STREAM_END } function deflateEnd(strm) { var status; if (!strm || !strm.state) { return Z_STREAM_ERROR } status = strm.state.status; if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) { return err(strm, Z_STREAM_ERROR) } strm.state = null; return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK } exports.deflateInit = deflateInit; exports.deflateInit2 = deflateInit2; exports.deflateReset = deflateReset; exports.deflateResetKeep = deflateResetKeep; exports.deflateSetHeader = deflateSetHeader; exports.deflate = deflate; exports.deflateEnd = deflateEnd; exports.deflateInfo = "pako deflate (from Nodeca project)"
        }, { "../utils/common": 27, "./adler32": 29, "./crc32": 31, "./messages": 37, "./trees": 38 }], 33: [function (_dereq_, module, exports) { "use strict"; function GZheader() { this.text = 0; this.time = 0; this.xflags = 0; this.os = 0; this.extra = null; this.extra_len = 0; this.name = ""; this.comment = ""; this.hcrc = 0; this.done = false } module.exports = GZheader }, {}], 34: [function (_dereq_, module, exports) { "use strict"; var BAD = 30; var TYPE = 12; module.exports = function inflate_fast(strm, start) { var state; var _in; var last; var _out; var beg; var end; var dmax; var wsize; var whave; var wnext; var window; var hold; var bits; var lcode; var dcode; var lmask; var dmask; var here; var op; var len; var dist; var from; var from_source; var input, output; state = strm.state; _in = strm.next_in; input = strm.input; last = _in + (strm.avail_in - 5); _out = strm.next_out; output = strm.output; beg = _out - (start - strm.avail_out); end = _out + (strm.avail_out - 257); dmax = state.dmax; wsize = state.wsize; whave = state.whave; wnext = state.wnext; window = state.window; hold = state.hold; bits = state.bits; lcode = state.lencode; dcode = state.distcode; lmask = (1 << state.lenbits) - 1; dmask = (1 << state.distbits) - 1; top: do { if (bits < 15) { hold += input[_in++] << bits; bits += 8; hold += input[_in++] << bits; bits += 8 } here = lcode[hold & lmask]; dolen: for (; ;) { op = here >>> 24; hold >>>= op; bits -= op; op = here >>> 16 & 255; if (op === 0) { output[_out++] = here & 65535 } else if (op & 16) { len = here & 65535; op &= 15; if (op) { if (bits < op) { hold += input[_in++] << bits; bits += 8 } len += hold & (1 << op) - 1; hold >>>= op; bits -= op } if (bits < 15) { hold += input[_in++] << bits; bits += 8; hold += input[_in++] << bits; bits += 8 } here = dcode[hold & dmask]; dodist: for (; ;) { op = here >>> 24; hold >>>= op; bits -= op; op = here >>> 16 & 255; if (op & 16) { dist = here & 65535; op &= 15; if (bits < op) { hold += input[_in++] << bits; bits += 8; if (bits < op) { hold += input[_in++] << bits; bits += 8 } } dist += hold & (1 << op) - 1; if (dist > dmax) { strm.msg = "invalid distance too far back"; state.mode = BAD; break top } hold >>>= op; bits -= op; op = _out - beg; if (dist > op) { op = dist - op; if (op > whave) { if (state.sane) { strm.msg = "invalid distance too far back"; state.mode = BAD; break top } } from = 0; from_source = window; if (wnext === 0) { from += wsize - op; if (op < len) { len -= op; do { output[_out++] = window[from++] } while (--op); from = _out - dist; from_source = output } } else if (wnext < op) { from += wsize + wnext - op; op -= wnext; if (op < len) { len -= op; do { output[_out++] = window[from++] } while (--op); from = 0; if (wnext < len) { op = wnext; len -= op; do { output[_out++] = window[from++] } while (--op); from = _out - dist; from_source = output } } } else { from += wnext - op; if (op < len) { len -= op; do { output[_out++] = window[from++] } while (--op); from = _out - dist; from_source = output } } while (len > 2) { output[_out++] = from_source[from++]; output[_out++] = from_source[from++]; output[_out++] = from_source[from++]; len -= 3 } if (len) { output[_out++] = from_source[from++]; if (len > 1) { output[_out++] = from_source[from++] } } } else { from = _out - dist; do { output[_out++] = output[from++]; output[_out++] = output[from++]; output[_out++] = output[from++]; len -= 3 } while (len > 2); if (len) { output[_out++] = output[from++]; if (len > 1) { output[_out++] = output[from++] } } } } else if ((op & 64) === 0) { here = dcode[(here & 65535) + (hold & (1 << op) - 1)]; continue dodist } else { strm.msg = "invalid distance code"; state.mode = BAD; break top } break } } else if ((op & 64) === 0) { here = lcode[(here & 65535) + (hold & (1 << op) - 1)]; continue dolen } else if (op & 32) { state.mode = TYPE; break top } else { strm.msg = "invalid literal/length code"; state.mode = BAD; break top } break } } while (_in < last && _out < end); len = bits >> 3; _in -= len; bits -= len << 3; hold &= (1 << bits) - 1; strm.next_in = _in; strm.next_out = _out; strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last); strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end); state.hold = hold; state.bits = bits; return } }, {}], 35: [function (_dereq_, module, exports) {
            "use strict"; var utils = _dereq_("../utils/common"); var adler32 = _dereq_("./adler32"); var crc32 = _dereq_("./crc32"); var inflate_fast = _dereq_("./inffast"); var inflate_table = _dereq_("./inftrees"); var CODES = 0; var LENS = 1; var DISTS = 2; var Z_FINISH = 4; var Z_BLOCK = 5; var Z_TREES = 6; var Z_OK = 0; var Z_STREAM_END = 1; var Z_NEED_DICT = 2; var Z_STREAM_ERROR = -2; var Z_DATA_ERROR = -3; var Z_MEM_ERROR = -4; var Z_BUF_ERROR = -5; var Z_DEFLATED = 8; var HEAD = 1; var FLAGS = 2; var TIME = 3; var OS = 4; var EXLEN = 5; var EXTRA = 6; var NAME = 7; var COMMENT = 8; var HCRC = 9; var DICTID = 10; var DICT = 11; var TYPE = 12; var TYPEDO = 13; var STORED = 14; var COPY_ = 15; var COPY = 16; var TABLE = 17; var LENLENS = 18; var CODELENS = 19; var LEN_ = 20; var LEN = 21; var LENEXT = 22; var DIST = 23; var DISTEXT = 24; var MATCH = 25; var LIT = 26; var CHECK = 27; var LENGTH = 28; var DONE = 29; var BAD = 30; var MEM = 31; var SYNC = 32; var ENOUGH_LENS = 852; var ENOUGH_DISTS = 592; var MAX_WBITS = 15; var DEF_WBITS = MAX_WBITS; function ZSWAP32(q) { return (q >>> 24 & 255) + (q >>> 8 & 65280) + ((q & 65280) << 8) + ((q & 255) << 24) } function InflateState() { this.mode = 0; this.last = false; this.wrap = 0; this.havedict = false; this.flags = 0; this.dmax = 0; this.check = 0; this.total = 0; this.head = null; this.wbits = 0; this.wsize = 0; this.whave = 0; this.wnext = 0; this.window = null; this.hold = 0; this.bits = 0; this.length = 0; this.offset = 0; this.extra = 0; this.lencode = null; this.distcode = null; this.lenbits = 0; this.distbits = 0; this.ncode = 0; this.nlen = 0; this.ndist = 0; this.have = 0; this.next = null; this.lens = new utils.Buf16(320); this.work = new utils.Buf16(288); this.lendyn = null; this.distdyn = null; this.sane = 0; this.back = 0; this.was = 0 } function inflateResetKeep(strm) { var state; if (!strm || !strm.state) { return Z_STREAM_ERROR } state = strm.state; strm.total_in = strm.total_out = state.total = 0; strm.msg = ""; if (state.wrap) { strm.adler = state.wrap & 1 } state.mode = HEAD; state.last = 0; state.havedict = 0; state.dmax = 32768; state.head = null; state.hold = 0; state.bits = 0; state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS); state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS); state.sane = 1; state.back = -1; return Z_OK } function inflateReset(strm) { var state; if (!strm || !strm.state) { return Z_STREAM_ERROR } state = strm.state; state.wsize = 0; state.whave = 0; state.wnext = 0; return inflateResetKeep(strm) } function inflateReset2(strm, windowBits) { var wrap; var state; if (!strm || !strm.state) { return Z_STREAM_ERROR } state = strm.state; if (windowBits < 0) { wrap = 0; windowBits = -windowBits } else { wrap = (windowBits >> 4) + 1; if (windowBits < 48) { windowBits &= 15 } } if (windowBits && (windowBits < 8 || windowBits > 15)) { return Z_STREAM_ERROR } if (state.window !== null && state.wbits !== windowBits) { state.window = null } state.wrap = wrap; state.wbits = windowBits; return inflateReset(strm) } function inflateInit2(strm, windowBits) { var ret; var state; if (!strm) { return Z_STREAM_ERROR } state = new InflateState; strm.state = state; state.window = null; ret = inflateReset2(strm, windowBits); if (ret !== Z_OK) { strm.state = null } return ret } function inflateInit(strm) { return inflateInit2(strm, DEF_WBITS) } var virgin = true; var lenfix, distfix; function fixedtables(state) { if (virgin) { var sym; lenfix = new utils.Buf32(512); distfix = new utils.Buf32(32); sym = 0; while (sym < 144) { state.lens[sym++] = 8 } while (sym < 256) { state.lens[sym++] = 9 } while (sym < 280) { state.lens[sym++] = 7 } while (sym < 288) { state.lens[sym++] = 8 } inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 }); sym = 0; while (sym < 32) { state.lens[sym++] = 5 } inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 }); virgin = false } state.lencode = lenfix; state.lenbits = 9; state.distcode = distfix; state.distbits = 5 } function updatewindow(strm, src, end, copy) { var dist; var state = strm.state; if (state.window === null) { state.wsize = 1 << state.wbits; state.wnext = 0; state.whave = 0; state.window = new utils.Buf8(state.wsize) } if (copy >= state.wsize) { utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0); state.wnext = 0; state.whave = state.wsize } else { dist = state.wsize - state.wnext; if (dist > copy) { dist = copy } utils.arraySet(state.window, src, end - copy, dist, state.wnext); copy -= dist; if (copy) { utils.arraySet(state.window, src, end - copy, copy, 0); state.wnext = copy; state.whave = state.wsize } else { state.wnext += dist; if (state.wnext === state.wsize) { state.wnext = 0 } if (state.whave < state.wsize) { state.whave += dist } } } return 0 } function inflate(strm, flush) { var state; var input, output; var next; var put; var have, left; var hold; var bits; var _in, _out; var copy; var from; var from_source; var here = 0; var here_bits, here_op, here_val; var last_bits, last_op, last_val; var len; var ret; var hbuf = new utils.Buf8(4); var opts; var n; var order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]; if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) { return Z_STREAM_ERROR } state = strm.state; if (state.mode === TYPE) { state.mode = TYPEDO } put = strm.next_out; output = strm.output; left = strm.avail_out; next = strm.next_in; input = strm.input; have = strm.avail_in; hold = state.hold; bits = state.bits; _in = have; _out = left; ret = Z_OK; inf_leave: for (; ;) { switch (state.mode) { case HEAD: if (state.wrap === 0) { state.mode = TYPEDO; break } while (bits < 16) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (state.wrap & 2 && hold === 35615) { state.check = 0; hbuf[0] = hold & 255; hbuf[1] = hold >>> 8 & 255; state.check = crc32(state.check, hbuf, 2, 0); hold = 0; bits = 0; state.mode = FLAGS; break } state.flags = 0; if (state.head) { state.head.done = false } if (!(state.wrap & 1) || (((hold & 255) << 8) + (hold >> 8)) % 31) { strm.msg = "incorrect header check"; state.mode = BAD; break } if ((hold & 15) !== Z_DEFLATED) { strm.msg = "unknown compression method"; state.mode = BAD; break } hold >>>= 4; bits -= 4; len = (hold & 15) + 8; if (state.wbits === 0) { state.wbits = len } else if (len > state.wbits) { strm.msg = "invalid window size"; state.mode = BAD; break } state.dmax = 1 << len; strm.adler = state.check = 1; state.mode = hold & 512 ? DICTID : TYPE; hold = 0; bits = 0; break; case FLAGS: while (bits < 16) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.flags = hold; if ((state.flags & 255) !== Z_DEFLATED) { strm.msg = "unknown compression method"; state.mode = BAD; break } if (state.flags & 57344) { strm.msg = "unknown header flags set"; state.mode = BAD; break } if (state.head) { state.head.text = hold >> 8 & 1 } if (state.flags & 512) { hbuf[0] = hold & 255; hbuf[1] = hold >>> 8 & 255; state.check = crc32(state.check, hbuf, 2, 0) } hold = 0; bits = 0; state.mode = TIME; case TIME: while (bits < 32) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (state.head) { state.head.time = hold } if (state.flags & 512) { hbuf[0] = hold & 255; hbuf[1] = hold >>> 8 & 255; hbuf[2] = hold >>> 16 & 255; hbuf[3] = hold >>> 24 & 255; state.check = crc32(state.check, hbuf, 4, 0) } hold = 0; bits = 0; state.mode = OS; case OS: while (bits < 16) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (state.head) { state.head.xflags = hold & 255; state.head.os = hold >> 8 } if (state.flags & 512) { hbuf[0] = hold & 255; hbuf[1] = hold >>> 8 & 255; state.check = crc32(state.check, hbuf, 2, 0) } hold = 0; bits = 0; state.mode = EXLEN; case EXLEN: if (state.flags & 1024) { while (bits < 16) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.length = hold; if (state.head) { state.head.extra_len = hold } if (state.flags & 512) { hbuf[0] = hold & 255; hbuf[1] = hold >>> 8 & 255; state.check = crc32(state.check, hbuf, 2, 0) } hold = 0; bits = 0 } else if (state.head) { state.head.extra = null } state.mode = EXTRA; case EXTRA: if (state.flags & 1024) { copy = state.length; if (copy > have) { copy = have } if (copy) { if (state.head) { len = state.head.extra_len - state.length; if (!state.head.extra) { state.head.extra = new Array(state.head.extra_len) } utils.arraySet(state.head.extra, input, next, copy, len) } if (state.flags & 512) { state.check = crc32(state.check, input, copy, next) } have -= copy; next += copy; state.length -= copy } if (state.length) { break inf_leave } } state.length = 0; state.mode = NAME; case NAME: if (state.flags & 2048) { if (have === 0) { break inf_leave } copy = 0; do { len = input[next + copy++]; if (state.head && len && state.length < 65536) { state.head.name += String.fromCharCode(len) } } while (len && copy < have); if (state.flags & 512) { state.check = crc32(state.check, input, copy, next) } have -= copy; next += copy; if (len) { break inf_leave } } else if (state.head) { state.head.name = null } state.length = 0; state.mode = COMMENT; case COMMENT: if (state.flags & 4096) { if (have === 0) { break inf_leave } copy = 0; do { len = input[next + copy++]; if (state.head && len && state.length < 65536) { state.head.comment += String.fromCharCode(len) } } while (len && copy < have); if (state.flags & 512) { state.check = crc32(state.check, input, copy, next) } have -= copy; next += copy; if (len) { break inf_leave } } else if (state.head) { state.head.comment = null } state.mode = HCRC; case HCRC: if (state.flags & 512) { while (bits < 16) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (hold !== (state.check & 65535)) { strm.msg = "header crc mismatch"; state.mode = BAD; break } hold = 0; bits = 0 } if (state.head) { state.head.hcrc = state.flags >> 9 & 1; state.head.done = true } strm.adler = state.check = 0; state.mode = TYPE; break; case DICTID: while (bits < 32) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } strm.adler = state.check = ZSWAP32(hold); hold = 0; bits = 0; state.mode = DICT; case DICT: if (state.havedict === 0) { strm.next_out = put; strm.avail_out = left; strm.next_in = next; strm.avail_in = have; state.hold = hold; state.bits = bits; return Z_NEED_DICT } strm.adler = state.check = 1; state.mode = TYPE; case TYPE: if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave } case TYPEDO: if (state.last) { hold >>>= bits & 7; bits -= bits & 7; state.mode = CHECK; break } while (bits < 3) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.last = hold & 1; hold >>>= 1; bits -= 1; switch (hold & 3) { case 0: state.mode = STORED; break; case 1: fixedtables(state); state.mode = LEN_; if (flush === Z_TREES) { hold >>>= 2; bits -= 2; break inf_leave } break; case 2: state.mode = TABLE; break; case 3: strm.msg = "invalid block type"; state.mode = BAD } hold >>>= 2; bits -= 2; break; case STORED: hold >>>= bits & 7; bits -= bits & 7; while (bits < 32) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if ((hold & 65535) !== (hold >>> 16 ^ 65535)) { strm.msg = "invalid stored block lengths"; state.mode = BAD; break } state.length = hold & 65535; hold = 0; bits = 0; state.mode = COPY_; if (flush === Z_TREES) { break inf_leave } case COPY_: state.mode = COPY; case COPY: copy = state.length; if (copy) { if (copy > have) { copy = have } if (copy > left) { copy = left } if (copy === 0) { break inf_leave } utils.arraySet(output, input, next, copy, put); have -= copy; next += copy; left -= copy; put += copy; state.length -= copy; break } state.mode = TYPE; break; case TABLE: while (bits < 14) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.nlen = (hold & 31) + 257; hold >>>= 5; bits -= 5; state.ndist = (hold & 31) + 1; hold >>>= 5; bits -= 5; state.ncode = (hold & 15) + 4; hold >>>= 4; bits -= 4; if (state.nlen > 286 || state.ndist > 30) { strm.msg = "too many length or distance symbols"; state.mode = BAD; break } state.have = 0; state.mode = LENLENS; case LENLENS: while (state.have < state.ncode) { while (bits < 3) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.lens[order[state.have++]] = hold & 7; hold >>>= 3; bits -= 3 } while (state.have < 19) { state.lens[order[state.have++]] = 0 } state.lencode = state.lendyn; state.lenbits = 7; opts = { bits: state.lenbits }; ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts); state.lenbits = opts.bits; if (ret) { strm.msg = "invalid code lengths set"; state.mode = BAD; break } state.have = 0; state.mode = CODELENS; case CODELENS: while (state.have < state.nlen + state.ndist) { for (; ;) { here = state.lencode[hold & (1 << state.lenbits) - 1]; here_bits = here >>> 24; here_op = here >>> 16 & 255; here_val = here & 65535; if (here_bits <= bits) { break } if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (here_val < 16) { hold >>>= here_bits; bits -= here_bits; state.lens[state.have++] = here_val } else { if (here_val === 16) { n = here_bits + 2; while (bits < n) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } hold >>>= here_bits; bits -= here_bits; if (state.have === 0) { strm.msg = "invalid bit length repeat"; state.mode = BAD; break } len = state.lens[state.have - 1]; copy = 3 + (hold & 3); hold >>>= 2; bits -= 2 } else if (here_val === 17) { n = here_bits + 3; while (bits < n) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } hold >>>= here_bits; bits -= here_bits; len = 0; copy = 3 + (hold & 7); hold >>>= 3; bits -= 3 } else { n = here_bits + 7; while (bits < n) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } hold >>>= here_bits; bits -= here_bits; len = 0; copy = 11 + (hold & 127); hold >>>= 7; bits -= 7 } if (state.have + copy > state.nlen + state.ndist) { strm.msg = "invalid bit length repeat"; state.mode = BAD; break } while (copy--) { state.lens[state.have++] = len } } } if (state.mode === BAD) { break } if (state.lens[256] === 0) { strm.msg = "invalid code -- missing end-of-block"; state.mode = BAD; break } state.lenbits = 9; opts = { bits: state.lenbits }; ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts); state.lenbits = opts.bits; if (ret) { strm.msg = "invalid literal/lengths set"; state.mode = BAD; break } state.distbits = 6; state.distcode = state.distdyn; opts = { bits: state.distbits }; ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts); state.distbits = opts.bits; if (ret) { strm.msg = "invalid distances set"; state.mode = BAD; break } state.mode = LEN_; if (flush === Z_TREES) { break inf_leave } case LEN_: state.mode = LEN; case LEN: if (have >= 6 && left >= 258) { strm.next_out = put; strm.avail_out = left; strm.next_in = next; strm.avail_in = have; state.hold = hold; state.bits = bits; inflate_fast(strm, _out); put = strm.next_out; output = strm.output; left = strm.avail_out; next = strm.next_in; input = strm.input; have = strm.avail_in; hold = state.hold; bits = state.bits; if (state.mode === TYPE) { state.back = -1 } break } state.back = 0; for (; ;) { here = state.lencode[hold & (1 << state.lenbits) - 1]; here_bits = here >>> 24; here_op = here >>> 16 & 255; here_val = here & 65535; if (here_bits <= bits) { break } if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (here_op && (here_op & 240) === 0) { last_bits = here_bits; last_op = here_op; last_val = here_val; for (; ;) { here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)]; here_bits = here >>> 24; here_op = here >>> 16 & 255; here_val = here & 65535; if (last_bits + here_bits <= bits) { break } if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } hold >>>= last_bits; bits -= last_bits; state.back += last_bits } hold >>>= here_bits; bits -= here_bits; state.back += here_bits; state.length = here_val; if (here_op === 0) { state.mode = LIT; break } if (here_op & 32) { state.back = -1; state.mode = TYPE; break } if (here_op & 64) { strm.msg = "invalid literal/length code"; state.mode = BAD; break } state.extra = here_op & 15; state.mode = LENEXT; case LENEXT: if (state.extra) { n = state.extra; while (bits < n) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.length += hold & (1 << state.extra) - 1; hold >>>= state.extra; bits -= state.extra; state.back += state.extra } state.was = state.length; state.mode = DIST; case DIST: for (; ;) { here = state.distcode[hold & (1 << state.distbits) - 1]; here_bits = here >>> 24; here_op = here >>> 16 & 255; here_val = here & 65535; if (here_bits <= bits) { break } if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if ((here_op & 240) === 0) { last_bits = here_bits; last_op = here_op; last_val = here_val; for (; ;) { here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)]; here_bits = here >>> 24; here_op = here >>> 16 & 255; here_val = here & 65535; if (last_bits + here_bits <= bits) { break } if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } hold >>>= last_bits; bits -= last_bits; state.back += last_bits } hold >>>= here_bits; bits -= here_bits; state.back += here_bits; if (here_op & 64) { strm.msg = "invalid distance code"; state.mode = BAD; break } state.offset = here_val; state.extra = here_op & 15; state.mode = DISTEXT; case DISTEXT: if (state.extra) { n = state.extra; while (bits < n) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } state.offset += hold & (1 << state.extra) - 1; hold >>>= state.extra; bits -= state.extra; state.back += state.extra } if (state.offset > state.dmax) { strm.msg = "invalid distance too far back"; state.mode = BAD; break } state.mode = MATCH; case MATCH: if (left === 0) { break inf_leave } copy = _out - left; if (state.offset > copy) { copy = state.offset - copy; if (copy > state.whave) { if (state.sane) { strm.msg = "invalid distance too far back"; state.mode = BAD; break } } if (copy > state.wnext) { copy -= state.wnext; from = state.wsize - copy } else { from = state.wnext - copy } if (copy > state.length) { copy = state.length } from_source = state.window } else { from_source = output; from = put - state.offset; copy = state.length } if (copy > left) { copy = left } left -= copy; state.length -= copy; do { output[put++] = from_source[from++] } while (--copy); if (state.length === 0) { state.mode = LEN } break; case LIT: if (left === 0) { break inf_leave } output[put++] = state.length; left--; state.mode = LEN; break; case CHECK: if (state.wrap) { while (bits < 32) { if (have === 0) { break inf_leave } have--; hold |= input[next++] << bits; bits += 8 } _out -= left; strm.total_out += _out; state.total += _out; if (_out) { strm.adler = state.check = state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out) } _out = left; if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) { strm.msg = "incorrect data check"; state.mode = BAD; break } hold = 0; bits = 0 } state.mode = LENGTH; case LENGTH: if (state.wrap && state.flags) { while (bits < 32) { if (have === 0) { break inf_leave } have--; hold += input[next++] << bits; bits += 8 } if (hold !== (state.total & 4294967295)) { strm.msg = "incorrect length check"; state.mode = BAD; break } hold = 0; bits = 0 } state.mode = DONE; case DONE: ret = Z_STREAM_END; break inf_leave; case BAD: ret = Z_DATA_ERROR; break inf_leave; case MEM: return Z_MEM_ERROR; case SYNC: default: return Z_STREAM_ERROR } } strm.next_out = put; strm.avail_out = left; strm.next_in = next; strm.avail_in = have; state.hold = hold; state.bits = bits; if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) { if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) { state.mode = MEM; return Z_MEM_ERROR } } _in -= strm.avail_in; _out -= strm.avail_out; strm.total_in += _in; strm.total_out += _out; state.total += _out; if (state.wrap && _out) { strm.adler = state.check = state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out) } strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0); if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) { ret = Z_BUF_ERROR } return ret } function inflateEnd(strm) { if (!strm || !strm.state) { return Z_STREAM_ERROR } var state = strm.state; if (state.window) { state.window = null } strm.state = null; return Z_OK } function inflateGetHeader(strm, head) { var state; if (!strm || !strm.state) { return Z_STREAM_ERROR } state = strm.state; if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR } state.head = head; head.done = false; return Z_OK } exports.inflateReset = inflateReset; exports.inflateReset2 = inflateReset2; exports.inflateResetKeep = inflateResetKeep; exports.inflateInit = inflateInit; exports.inflateInit2 = inflateInit2; exports.inflate = inflate; exports.inflateEnd = inflateEnd; exports.inflateGetHeader = inflateGetHeader;
            exports.inflateInfo = "pako inflate (from Nodeca project)"
        }, { "../utils/common": 27, "./adler32": 29, "./crc32": 31, "./inffast": 34, "./inftrees": 36 }], 36: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("../utils/common"); var MAXBITS = 15; var ENOUGH_LENS = 852; var ENOUGH_DISTS = 592; var CODES = 0; var LENS = 1; var DISTS = 2; var lbase = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]; var lext = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]; var dbase = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]; var dext = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]; module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) { var bits = opts.bits; var len = 0; var sym = 0; var min = 0, max = 0; var root = 0; var curr = 0; var drop = 0; var left = 0; var used = 0; var huff = 0; var incr; var fill; var low; var mask; var next; var base = null; var base_index = 0; var end; var count = new utils.Buf16(MAXBITS + 1); var offs = new utils.Buf16(MAXBITS + 1); var extra = null; var extra_index = 0; var here_bits, here_op, here_val; for (len = 0; len <= MAXBITS; len++) { count[len] = 0 } for (sym = 0; sym < codes; sym++) { count[lens[lens_index + sym]]++ } root = bits; for (max = MAXBITS; max >= 1; max--) { if (count[max] !== 0) { break } } if (root > max) { root = max } if (max === 0) { table[table_index++] = 1 << 24 | 64 << 16 | 0; table[table_index++] = 1 << 24 | 64 << 16 | 0; opts.bits = 1; return 0 } for (min = 1; min < max; min++) { if (count[min] !== 0) { break } } if (root < min) { root = min } left = 1; for (len = 1; len <= MAXBITS; len++) { left <<= 1; left -= count[len]; if (left < 0) { return -1 } } if (left > 0 && (type === CODES || max !== 1)) { return -1 } offs[1] = 0; for (len = 1; len < MAXBITS; len++) { offs[len + 1] = offs[len] + count[len] } for (sym = 0; sym < codes; sym++) { if (lens[lens_index + sym] !== 0) { work[offs[lens[lens_index + sym]]++] = sym } } if (type === CODES) { base = extra = work; end = 19 } else if (type === LENS) { base = lbase; base_index -= 257; extra = lext; extra_index -= 257; end = 256 } else { base = dbase; extra = dext; end = -1 } huff = 0; sym = 0; len = min; next = table_index; curr = root; drop = 0; low = -1; used = 1 << root; mask = used - 1; if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) { return 1 } var i = 0; for (; ;) { i++; here_bits = len - drop; if (work[sym] < end) { here_op = 0; here_val = work[sym] } else if (work[sym] > end) { here_op = extra[extra_index + work[sym]]; here_val = base[base_index + work[sym]] } else { here_op = 32 + 64; here_val = 0 } incr = 1 << len - drop; fill = 1 << curr; min = fill; do { fill -= incr; table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0 } while (fill !== 0); incr = 1 << len - 1; while (huff & incr) { incr >>= 1 } if (incr !== 0) { huff &= incr - 1; huff += incr } else { huff = 0 } sym++; if (--count[len] === 0) { if (len === max) { break } len = lens[lens_index + work[sym]] } if (len > root && (huff & mask) !== low) { if (drop === 0) { drop = root } next += min; curr = len - drop; left = 1 << curr; while (curr + drop < max) { left -= count[curr + drop]; if (left <= 0) { break } curr++; left <<= 1 } used += 1 << curr; if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) { return 1 } low = huff & mask; table[low] = root << 24 | curr << 16 | next - table_index | 0 } } if (huff !== 0) { table[next + huff] = len - drop << 24 | 64 << 16 | 0 } opts.bits = root; return 0 } }, { "../utils/common": 27 }], 37: [function (_dereq_, module, exports) { "use strict"; module.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" } }, {}], 38: [function (_dereq_, module, exports) { "use strict"; var utils = _dereq_("../utils/common"); var Z_FIXED = 4; var Z_BINARY = 0; var Z_TEXT = 1; var Z_UNKNOWN = 2; function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0 } } var STORED_BLOCK = 0; var STATIC_TREES = 1; var DYN_TREES = 2; var MIN_MATCH = 3; var MAX_MATCH = 258; var LENGTH_CODES = 29; var LITERALS = 256; var L_CODES = LITERALS + 1 + LENGTH_CODES; var D_CODES = 30; var BL_CODES = 19; var HEAP_SIZE = 2 * L_CODES + 1; var MAX_BITS = 15; var Buf_size = 16; var MAX_BL_BITS = 7; var END_BLOCK = 256; var REP_3_6 = 16; var REPZ_3_10 = 17; var REPZ_11_138 = 18; var extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]; var extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]; var extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]; var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]; var DIST_CODE_LEN = 512; var static_ltree = new Array((L_CODES + 2) * 2); zero(static_ltree); var static_dtree = new Array(D_CODES * 2); zero(static_dtree); var _dist_code = new Array(DIST_CODE_LEN); zero(_dist_code); var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1); zero(_length_code); var base_length = new Array(LENGTH_CODES); zero(base_length); var base_dist = new Array(D_CODES); zero(base_dist); var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) { this.static_tree = static_tree; this.extra_bits = extra_bits; this.extra_base = extra_base; this.elems = elems; this.max_length = max_length; this.has_stree = static_tree && static_tree.length }; var static_l_desc; var static_d_desc; var static_bl_desc; var TreeDesc = function (dyn_tree, stat_desc) { this.dyn_tree = dyn_tree; this.max_code = 0; this.stat_desc = stat_desc }; function d_code(dist) { return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)] } function put_short(s, w) { s.pending_buf[s.pending++] = w & 255; s.pending_buf[s.pending++] = w >>> 8 & 255 } function send_bits(s, value, length) { if (s.bi_valid > Buf_size - length) { s.bi_buf |= value << s.bi_valid & 65535; put_short(s, s.bi_buf); s.bi_buf = value >> Buf_size - s.bi_valid; s.bi_valid += length - Buf_size } else { s.bi_buf |= value << s.bi_valid & 65535; s.bi_valid += length } } function send_code(s, c, tree) { send_bits(s, tree[c * 2], tree[c * 2 + 1]) } function bi_reverse(code, len) { var res = 0; do { res |= code & 1; code >>>= 1; res <<= 1 } while (--len > 0); return res >>> 1 } function bi_flush(s) { if (s.bi_valid === 16) { put_short(s, s.bi_buf); s.bi_buf = 0; s.bi_valid = 0 } else if (s.bi_valid >= 8) { s.pending_buf[s.pending++] = s.bi_buf & 255; s.bi_buf >>= 8; s.bi_valid -= 8 } } function gen_bitlen(s, desc) { var tree = desc.dyn_tree; var max_code = desc.max_code; var stree = desc.stat_desc.static_tree; var has_stree = desc.stat_desc.has_stree; var extra = desc.stat_desc.extra_bits; var base = desc.stat_desc.extra_base; var max_length = desc.stat_desc.max_length; var h; var n, m; var bits; var xbits; var f; var overflow = 0; for (bits = 0; bits <= MAX_BITS; bits++) { s.bl_count[bits] = 0 } tree[s.heap[s.heap_max] * 2 + 1] = 0; for (h = s.heap_max + 1; h < HEAP_SIZE; h++) { n = s.heap[h]; bits = tree[tree[n * 2 + 1] * 2 + 1] + 1; if (bits > max_length) { bits = max_length; overflow++ } tree[n * 2 + 1] = bits; if (n > max_code) { continue } s.bl_count[bits]++; xbits = 0; if (n >= base) { xbits = extra[n - base] } f = tree[n * 2]; s.opt_len += f * (bits + xbits); if (has_stree) { s.static_len += f * (stree[n * 2 + 1] + xbits) } } if (overflow === 0) { return } do { bits = max_length - 1; while (s.bl_count[bits] === 0) { bits-- } s.bl_count[bits]--; s.bl_count[bits + 1] += 2; s.bl_count[max_length]--; overflow -= 2 } while (overflow > 0); for (bits = max_length; bits !== 0; bits--) { n = s.bl_count[bits]; while (n !== 0) { m = s.heap[--h]; if (m > max_code) { continue } if (tree[m * 2 + 1] !== bits) { s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2]; tree[m * 2 + 1] = bits } n-- } } } function gen_codes(tree, max_code, bl_count) { var next_code = new Array(MAX_BITS + 1); var code = 0; var bits; var n; for (bits = 1; bits <= MAX_BITS; bits++) { next_code[bits] = code = code + bl_count[bits - 1] << 1 } for (n = 0; n <= max_code; n++) { var len = tree[n * 2 + 1]; if (len === 0) { continue } tree[n * 2] = bi_reverse(next_code[len]++, len) } } function tr_static_init() { var n; var bits; var length; var code; var dist; var bl_count = new Array(MAX_BITS + 1); length = 0; for (code = 0; code < LENGTH_CODES - 1; code++) { base_length[code] = length; for (n = 0; n < 1 << extra_lbits[code]; n++) { _length_code[length++] = code } } _length_code[length - 1] = code; dist = 0; for (code = 0; code < 16; code++) { base_dist[code] = dist; for (n = 0; n < 1 << extra_dbits[code]; n++) { _dist_code[dist++] = code } } dist >>= 7; for (; code < D_CODES; code++) { base_dist[code] = dist << 7; for (n = 0; n < 1 << extra_dbits[code] - 7; n++) { _dist_code[256 + dist++] = code } } for (bits = 0; bits <= MAX_BITS; bits++) { bl_count[bits] = 0 } n = 0; while (n <= 143) { static_ltree[n * 2 + 1] = 8; n++; bl_count[8]++ } while (n <= 255) { static_ltree[n * 2 + 1] = 9; n++; bl_count[9]++ } while (n <= 279) { static_ltree[n * 2 + 1] = 7; n++; bl_count[7]++ } while (n <= 287) { static_ltree[n * 2 + 1] = 8; n++; bl_count[8]++ } gen_codes(static_ltree, L_CODES + 1, bl_count); for (n = 0; n < D_CODES; n++) { static_dtree[n * 2 + 1] = 5; static_dtree[n * 2] = bi_reverse(n, 5) } static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS); static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS); static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS) } function init_block(s) { var n; for (n = 0; n < L_CODES; n++) { s.dyn_ltree[n * 2] = 0 } for (n = 0; n < D_CODES; n++) { s.dyn_dtree[n * 2] = 0 } for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2] = 0 } s.dyn_ltree[END_BLOCK * 2] = 1; s.opt_len = s.static_len = 0; s.last_lit = s.matches = 0 } function bi_windup(s) { if (s.bi_valid > 8) { put_short(s, s.bi_buf) } else if (s.bi_valid > 0) { s.pending_buf[s.pending++] = s.bi_buf } s.bi_buf = 0; s.bi_valid = 0 } function copy_block(s, buf, len, header) { bi_windup(s); if (header) { put_short(s, len); put_short(s, ~len) } utils.arraySet(s.pending_buf, s.window, buf, len, s.pending); s.pending += len } function smaller(tree, n, m, depth) { var _n2 = n * 2; var _m2 = m * 2; return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m] } function pqdownheap(s, tree, k) { var v = s.heap[k]; var j = k << 1; while (j <= s.heap_len) { if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) { j++ } if (smaller(tree, v, s.heap[j], s.depth)) { break } s.heap[k] = s.heap[j]; k = j; j <<= 1 } s.heap[k] = v } function compress_block(s, ltree, dtree) { var dist; var lc; var lx = 0; var code; var extra; if (s.last_lit !== 0) { do { dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1]; lc = s.pending_buf[s.l_buf + lx]; lx++; if (dist === 0) { send_code(s, lc, ltree) } else { code = _length_code[lc]; send_code(s, code + LITERALS + 1, ltree); extra = extra_lbits[code]; if (extra !== 0) { lc -= base_length[code]; send_bits(s, lc, extra) } dist--; code = d_code(dist); send_code(s, code, dtree); extra = extra_dbits[code]; if (extra !== 0) { dist -= base_dist[code]; send_bits(s, dist, extra) } } } while (lx < s.last_lit) } send_code(s, END_BLOCK, ltree) } function build_tree(s, desc) { var tree = desc.dyn_tree; var stree = desc.stat_desc.static_tree; var has_stree = desc.stat_desc.has_stree; var elems = desc.stat_desc.elems; var n, m; var max_code = -1; var node; s.heap_len = 0; s.heap_max = HEAP_SIZE; for (n = 0; n < elems; n++) { if (tree[n * 2] !== 0) { s.heap[++s.heap_len] = max_code = n; s.depth[n] = 0 } else { tree[n * 2 + 1] = 0 } } while (s.heap_len < 2) { node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0; tree[node * 2] = 1; s.depth[node] = 0; s.opt_len--; if (has_stree) { s.static_len -= stree[node * 2 + 1] } } desc.max_code = max_code; for (n = s.heap_len >> 1; n >= 1; n--) { pqdownheap(s, tree, n) } node = elems; do { n = s.heap[1]; s.heap[1] = s.heap[s.heap_len--]; pqdownheap(s, tree, 1); m = s.heap[1]; s.heap[--s.heap_max] = n; s.heap[--s.heap_max] = m; tree[node * 2] = tree[n * 2] + tree[m * 2]; s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1; tree[n * 2 + 1] = tree[m * 2 + 1] = node; s.heap[1] = node++; pqdownheap(s, tree, 1) } while (s.heap_len >= 2); s.heap[--s.heap_max] = s.heap[1]; gen_bitlen(s, desc); gen_codes(tree, max_code, s.bl_count) } function scan_tree(s, tree, max_code) { var n; var prevlen = -1; var curlen; var nextlen = tree[0 * 2 + 1]; var count = 0; var max_count = 7; var min_count = 4; if (nextlen === 0) { max_count = 138; min_count = 3 } tree[(max_code + 1) * 2 + 1] = 65535; for (n = 0; n <= max_code; n++) { curlen = nextlen; nextlen = tree[(n + 1) * 2 + 1]; if (++count < max_count && curlen === nextlen) { continue } else if (count < min_count) { s.bl_tree[curlen * 2] += count } else if (curlen !== 0) { if (curlen !== prevlen) { s.bl_tree[curlen * 2]++ } s.bl_tree[REP_3_6 * 2]++ } else if (count <= 10) { s.bl_tree[REPZ_3_10 * 2]++ } else { s.bl_tree[REPZ_11_138 * 2]++ } count = 0; prevlen = curlen; if (nextlen === 0) { max_count = 138; min_count = 3 } else if (curlen === nextlen) { max_count = 6; min_count = 3 } else { max_count = 7; min_count = 4 } } } function send_tree(s, tree, max_code) { var n; var prevlen = -1; var curlen; var nextlen = tree[0 * 2 + 1]; var count = 0; var max_count = 7; var min_count = 4; if (nextlen === 0) { max_count = 138; min_count = 3 } for (n = 0; n <= max_code; n++) { curlen = nextlen; nextlen = tree[(n + 1) * 2 + 1]; if (++count < max_count && curlen === nextlen) { continue } else if (count < min_count) { do { send_code(s, curlen, s.bl_tree) } while (--count !== 0) } else if (curlen !== 0) { if (curlen !== prevlen) { send_code(s, curlen, s.bl_tree); count-- } send_code(s, REP_3_6, s.bl_tree); send_bits(s, count - 3, 2) } else if (count <= 10) { send_code(s, REPZ_3_10, s.bl_tree); send_bits(s, count - 3, 3) } else { send_code(s, REPZ_11_138, s.bl_tree); send_bits(s, count - 11, 7) } count = 0; prevlen = curlen; if (nextlen === 0) { max_count = 138; min_count = 3 } else if (curlen === nextlen) { max_count = 6; min_count = 3 } else { max_count = 7; min_count = 4 } } } function build_bl_tree(s) { var max_blindex; scan_tree(s, s.dyn_ltree, s.l_desc.max_code); scan_tree(s, s.dyn_dtree, s.d_desc.max_code); build_tree(s, s.bl_desc); for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) { if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) { break } } s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; return max_blindex } function send_all_trees(s, lcodes, dcodes, blcodes) { var rank; send_bits(s, lcodes - 257, 5); send_bits(s, dcodes - 1, 5); send_bits(s, blcodes - 4, 4); for (rank = 0; rank < blcodes; rank++) { send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3) } send_tree(s, s.dyn_ltree, lcodes - 1); send_tree(s, s.dyn_dtree, dcodes - 1) } function detect_data_type(s) { var black_mask = 4093624447; var n; for (n = 0; n <= 31; n++, black_mask >>>= 1) { if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) { return Z_BINARY } } if (s.dyn_ltree[9 * 2] !== 0 || s.dyn_ltree[10 * 2] !== 0 || s.dyn_ltree[13 * 2] !== 0) { return Z_TEXT } for (n = 32; n < LITERALS; n++) { if (s.dyn_ltree[n * 2] !== 0) { return Z_TEXT } } return Z_BINARY } var static_init_done = false; function _tr_init(s) { if (!static_init_done) { tr_static_init(); static_init_done = true } s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc); s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc); s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc); s.bi_buf = 0; s.bi_valid = 0; init_block(s) } function _tr_stored_block(s, buf, stored_len, last) { send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); copy_block(s, buf, stored_len, true) } function _tr_align(s) { send_bits(s, STATIC_TREES << 1, 3); send_code(s, END_BLOCK, static_ltree); bi_flush(s) } function _tr_flush_block(s, buf, stored_len, last) { var opt_lenb, static_lenb; var max_blindex = 0; if (s.level > 0) { if (s.strm.data_type === Z_UNKNOWN) { s.strm.data_type = detect_data_type(s) } build_tree(s, s.l_desc); build_tree(s, s.d_desc); max_blindex = build_bl_tree(s); opt_lenb = s.opt_len + 3 + 7 >>> 3; static_lenb = s.static_len + 3 + 7 >>> 3; if (static_lenb <= opt_lenb) { opt_lenb = static_lenb } } else { opt_lenb = static_lenb = stored_len + 5 } if (stored_len + 4 <= opt_lenb && buf !== -1) { _tr_stored_block(s, buf, stored_len, last) } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) { send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3); compress_block(s, static_ltree, static_dtree) } else { send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3); send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1); compress_block(s, s.dyn_ltree, s.dyn_dtree) } init_block(s); if (last) { bi_windup(s) } } function _tr_tally(s, dist, lc) { s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 255; s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 255; s.pending_buf[s.l_buf + s.last_lit] = lc & 255; s.last_lit++; if (dist === 0) { s.dyn_ltree[lc * 2]++ } else { s.matches++; dist--; s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++; s.dyn_dtree[d_code(dist) * 2]++ } return s.last_lit === s.lit_bufsize - 1 } exports._tr_init = _tr_init; exports._tr_stored_block = _tr_stored_block; exports._tr_flush_block = _tr_flush_block; exports._tr_tally = _tr_tally; exports._tr_align = _tr_align }, { "../utils/common": 27 }], 39: [function (_dereq_, module, exports) { "use strict"; function ZStream() { this.input = null; this.next_in = 0; this.avail_in = 0; this.total_in = 0; this.output = null; this.next_out = 0; this.avail_out = 0; this.total_out = 0; this.msg = ""; this.state = null; this.data_type = 2; this.adler = 0 } module.exports = ZStream }, {}]
    }, {}, [9])(9)
}); var XLSX = {}; (function (XLSX) {
    XLSX.version = "0.7.12"; var current_codepage = 1252, current_cptable; if (typeof module !== "undefined" && typeof require !== "undefined") { if (typeof cptable === "undefined") cptable = require("./dist/cpexcel"); current_cptable = cptable[current_codepage] } function reset_cp() { set_cp(1252) } var set_cp = function (cp) { current_codepage = cp }; function char_codes(data) { var o = []; for (var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o } var debom_xml = function (data) { return data }; if (typeof cptable !== "undefined") { set_cp = function (cp) { current_codepage = cp; current_cptable = cptable[cp] }; debom_xml = function (data) { if (data.charCodeAt(0) === 255 && data.charCodeAt(1) === 254) { return cptable.utils.decode(1200, char_codes(data.substr(2))) } return data } } var SSF = {}; var make_ssf = function make_ssf(SSF) {
        SSF.version = "0.8.1"; function _strrev(x) { var o = "", i = x.length - 1; while (i >= 0) o += x.charAt(i--); return o } function fill(c, l) { var o = ""; while (o.length < l) o += c; return o } function pad0(v, d) { var t = "" + v; return t.length >= d ? t : fill("0", d - t.length) + t } function pad_(v, d) { var t = "" + v; return t.length >= d ? t : fill(" ", d - t.length) + t } function rpad_(v, d) { var t = "" + v; return t.length >= d ? t : t + fill(" ", d - t.length) } function pad0r1(v, d) { var t = "" + Math.round(v); return t.length >= d ? t : fill("0", d - t.length) + t } function pad0r2(v, d) { var t = "" + v; return t.length >= d ? t : fill("0", d - t.length) + t } var p2_32 = Math.pow(2, 32); function pad0r(v, d) { if (v > p2_32 || v < -p2_32) return pad0r1(v, d); var i = Math.round(v); return pad0r2(i, d) } function isgeneral(s, i) { return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108 } var opts_fmt = [["date1904", 0], ["output", ""], ["WTF", false]]; function fixopts(o) { for (var y = 0; y != opts_fmt.length; ++y) if (o[opts_fmt[y][0]] === undefined) o[opts_fmt[y][0]] = opts_fmt[y][1] } SSF.opts = opts_fmt; var table_fmt = { 0: "General", 1: "0", 2: "0.00", 3: "#,##0", 4: "#,##0.00", 9: "0%", 10: "0.00%", 11: "0.00E+00", 12: "# ?/?", 13: "# ??/??", 14: "m/d/yy", 15: "d-mmm-yy", 16: "d-mmm", 17: "mmm-yy", 18: "h:mm AM/PM", 19: "h:mm:ss AM/PM", 20: "h:mm", 21: "h:mm:ss", 22: "m/d/yy h:mm", 37: "#,##0 ;(#,##0)", 38: "#,##0 ;[Red](#,##0)", 39: "#,##0.00;(#,##0.00)", 40: "#,##0.00;[Red](#,##0.00)", 45: "mm:ss", 46: "[h]:mm:ss", 47: "mmss.0", 48: "##0.0E+0", 49: "@", 56: '"上午/下午 "hh"時"mm"分"ss"秒 "', 65535: "General" }; var days = [["Sun", "Sunday"], ["Mon", "Monday"], ["Tue", "Tuesday"], ["Wed", "Wednesday"], ["Thu", "Thursday"], ["Fri", "Friday"], ["Sat", "Saturday"]]; var months = [["J", "Jan", "January"], ["F", "Feb", "February"], ["M", "Mar", "March"], ["A", "Apr", "April"], ["M", "May", "May"], ["J", "Jun", "June"], ["J", "Jul", "July"], ["A", "Aug", "August"], ["S", "Sep", "September"], ["O", "Oct", "October"], ["N", "Nov", "November"], ["D", "Dec", "December"]]; function frac(x, D, mixed) { var sgn = x < 0 ? -1 : 1; var B = x * sgn; var P_2 = 0, P_1 = 1, P = 0; var Q_2 = 1, Q_1 = 0, Q = 0; var A = Math.floor(B); while (Q_1 < D) { A = Math.floor(B); P = A * P_1 + P_2; Q = A * Q_1 + Q_2; if (B - A < 5e-10) break; B = 1 / (B - A); P_2 = P_1; P_1 = P; Q_2 = Q_1; Q_1 = Q } if (Q > D) { Q = Q_1; P = P_1 } if (Q > D) { Q = Q_2; P = P_2 } if (!mixed) return [0, sgn * P, Q]; if (Q === 0) throw "Unexpected state: " + P + " " + P_1 + " " + P_2 + " " + Q + " " + Q_1 + " " + Q_2; var q = Math.floor(sgn * P / Q); return [q, sgn * P - q * Q, Q] } function general_fmt_int(v, opts) { return "" + v } SSF._general_int = general_fmt_int; var general_fmt_num = function make_general_fmt_num() { var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/; function gfn2(v) { var w = v < 0 ? 12 : 11; var o = gfn5(v.toFixed(12)); if (o.length <= w) return o; o = v.toPrecision(10); if (o.length <= w) return o; return v.toExponential(5) } function gfn3(v) { var o = v.toFixed(11).replace(gnr1, ".$1"); if (o.length > (v < 0 ? 12 : 11)) o = v.toPrecision(6); return o } function gfn4(o) { for (var i = 0; i != o.length; ++i) if ((o.charCodeAt(i) | 32) === 101) return o.replace(gnr4, ".$1").replace(gnr5, "E").replace("e", "E").replace(gnr6, "$10$2"); return o } function gfn5(o) { return o.indexOf(".") > -1 ? o.replace(gnr2, "").replace(gnr1, ".$1") : o } return function general_fmt_num(v, opts) { var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o; if (V >= -4 && V <= -1) o = v.toPrecision(10 + V); else if (Math.abs(V) <= 9) o = gfn2(v); else if (V === 10) o = v.toFixed(10).substr(0, 12); else o = gfn3(v); return gfn5(gfn4(o)) } }(); SSF._general_num = general_fmt_num; function general_fmt(v, opts) { switch (typeof v) { case "string": return v; case "boolean": return v ? "TRUE" : "FALSE"; case "number": return (v | 0) === v ? general_fmt_int(v, opts) : general_fmt_num(v, opts) } throw new Error("unsupported value in General format: " + v) } SSF._general = general_fmt; function fix_hijri(date, o) { return 0 } function parse_date_code(v, opts, b2) { if (v > 2958465 || v < 0) return null; var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0; var dout = []; var out = { D: date, T: time, u: 86400 * (v - date) - time, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 }; if (Math.abs(out.u) < 1e-6) out.u = 0; fixopts(opts != null ? opts : opts = []); if (opts.date1904) date += 1462; if (out.u > .999) { out.u = 0; if (++time == 86400) { time = 0; ++date } } if (date === 60) { dout = b2 ? [1317, 10, 29] : [1900, 2, 29]; dow = 3 } else if (date === 0) { dout = b2 ? [1317, 8, 29] : [1900, 1, 0]; dow = 6 } else { if (date > 60) --date; var d = new Date(1900, 0, 1); d.setDate(d.getDate() + date - 1); dout = [d.getFullYear(), d.getMonth() + 1, d.getDate()]; dow = d.getDay(); if (date < 60) dow = (dow + 6) % 7; if (b2) dow = fix_hijri(d, dout) } out.y = dout[0]; out.m = dout[1]; out.d = dout[2]; out.S = time % 60; time = Math.floor(time / 60); out.M = time % 60; time = Math.floor(time / 60); out.H = time; out.q = dow; return out } SSF.parse_date_code = parse_date_code; function write_date(type, fmt, val, ss0) { var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0; switch (type) { case 98: y = val.y + 543; case 121: switch (fmt.length) { case 1: case 2: out = y % 100; outl = 2; break; default: out = y % 1e4; outl = 4; break } break; case 109: switch (fmt.length) { case 1: case 2: out = val.m; outl = fmt.length; break; case 3: return months[val.m - 1][1]; case 5: return months[val.m - 1][0]; default: return months[val.m - 1][2] } break; case 100: switch (fmt.length) { case 1: case 2: out = val.d; outl = fmt.length; break; case 3: return days[val.q][0]; default: return days[val.q][1] } break; case 104: switch (fmt.length) { case 1: case 2: out = 1 + (val.H + 11) % 12; outl = fmt.length; break; default: throw "bad hour format: " + fmt } break; case 72: switch (fmt.length) { case 1: case 2: out = val.H; outl = fmt.length; break; default: throw "bad hour format: " + fmt } break; case 77: switch (fmt.length) { case 1: case 2: out = val.M; outl = fmt.length; break; default: throw "bad minute format: " + fmt } break; case 115: if (val.u === 0) switch (fmt) { case "s": case "ss": return pad0(val.S, fmt.length); case ".0": case ".00": case ".000": } switch (fmt) { case "s": case "ss": case ".0": case ".00": case ".000": if (ss0 >= 2) tt = ss0 === 3 ? 1e3 : 100; else tt = ss0 === 1 ? 10 : 1; ss = Math.round(tt * (val.S + val.u)); if (ss >= 60 * tt) ss = 0; if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt; o = pad0(ss, 2 + ss0); if (fmt === "ss") return o.substr(0, 2); return "." + o.substr(2, fmt.length - 1); default: throw "bad second format: " + fmt } case 90: switch (fmt) { case "[h]": case "[hh]": out = val.D * 24 + val.H; break; case "[m]": case "[mm]": out = (val.D * 24 + val.H) * 60 + val.M; break; case "[s]": case "[ss]": out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u); break; default: throw "bad abstime format: " + fmt } outl = fmt.length === 3 ? 1 : 2; break; case 101: out = y; outl = 1 } if (outl > 0) return pad0(out, outl); else return "" } function commaify(s) { if (s.length <= 3) return s; var j = s.length % 3, o = s.substr(0, j); for (; j != s.length; j += 3) o += (o.length > 0 ? "," : "") + s.substr(j, 3); return o } var write_num = function make_write_num() {
            var pct1 = /%/g; function write_num_pct(type, fmt, val) { var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length; return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul) } function write_num_cm(type, fmt, val) { var idx = fmt.length - 1; while (fmt.charCodeAt(idx - 1) === 44) --idx; return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx))) } function write_num_exp(fmt, val) { var o; var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1; if (fmt.match(/^#+0.0E\+0$/)) { var period = fmt.indexOf("."); if (period === -1) period = fmt.indexOf("E"); var ee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E) % period; if (ee < 0) ee += period; o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period); if (o.indexOf("e") === -1) { var fakee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E); if (o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length + ee); else o += "E+" + (fakee - ee); while (o.substr(0, 2) === "0.") { o = o[0] + o.substr(2, period) + "." + o.substr(2 + period); o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.") } o = o.replace(/\+-/, "-") } o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) { return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E" }) } else o = val.toExponential(idx); if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o[o.length - 1]; if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e"); return o.replace("e", "E") } var frac1 = /# (\?+)( ?)\/( ?)(\d+)/; function write_num_f1(r, aval, sign) { var den = parseInt(r[4]), rr = Math.round(aval * den), base = Math.floor(rr / den); var myn = rr - base * den, myd = den; return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn, r[1].length) + r[2] + "/" + r[3] + pad0(myd, r[4].length)) } function write_num_f2(r, aval, sign) { return sign + (aval === 0 ? "" : "" + aval) + fill(" ", r[1].length + 2 + r[4].length) } var dec1 = /^#*0*\.(0+)/; var closeparen = /\).*[0#]/; var phone = /\(###\) ###\\?-####/; function hashq(str) { var o = "", cc; for (var i = 0; i != str.length; ++i) switch (cc = str.charCodeAt(i)) { case 35: break; case 63: o += " "; break; case 48: o += "0"; break; default: o += String.fromCharCode(cc) } return o } function rnd(val, d) { var dd = Math.pow(10, d); return "" + Math.round(val * dd) / dd } function dec(val, d) { return Math.round((val - Math.floor(val)) * Math.pow(10, d)) } function flr(val) { if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0); return "" + Math.floor(val) } function write_num_flt(type, fmt, val) { if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) { var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, ""); if (val >= 0) return write_num_flt("n", ffmt, val); return "(" + write_num_flt("n", ffmt, -val) + ")" } if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val); if (fmt.indexOf("%") !== -1) return write_num_pct(type, fmt, val); if (fmt.indexOf("E") !== -1) return write_num_exp(fmt, val); if (fmt.charCodeAt(0) === 36) return "$" + write_num_flt(type, fmt.substr(fmt[1] == " " ? 2 : 1), val); var o, oo; var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : ""; if (fmt.match(/^00+$/)) return sign + pad0r(aval, fmt.length); if (fmt.match(/^[#?]+$/)) { o = pad0r(val, 0); if (o === "0") o = ""; return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o } if ((r = fmt.match(frac1)) !== null) return write_num_f1(r, aval, sign); if (fmt.match(/^#+0+$/) !== null) return sign + pad0r(aval, fmt.length - fmt.indexOf("0")); if ((r = fmt.match(dec1)) !== null) { o = rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + r[1]).replace(/\.$/, "." + r[1]).replace(/\.(\d*)$/, function ($$, $1) { return "." + $1 + fill("0", r[1].length - $1.length) }); return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".") } fmt = fmt.replace(/^#+([0.])/, "$1"); if ((r = fmt.match(/^(0*)\.(#*)$/)) !== null) { return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".") } if ((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify(pad0r(aval, 0)); if ((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) { return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify("" + Math.floor(val)) + "." + pad0(dec(val, r[1].length), r[1].length) } if ((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_flt(type, fmt.replace(/^#,#*,/, ""), val); if ((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) { o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g, ""), val)); ri = 0; return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) { return ri < o.length ? o[ri++] : x === "0" ? "0" : "" })) } if (fmt.match(phone) !== null) { o = write_num_flt(type, "##########", val); return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6) } var oa = ""; if ((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) { ri = Math.min(r[4].length, 7); ff = frac(aval, Math.pow(10, ri) - 1, false); o = "" + sign; oa = write_num("n", r[1], ff[1]); if (oa[oa.length - 1] == " ") oa = oa.substr(0, oa.length - 1) + "0"; o += oa + r[2] + "/" + r[3]; oa = rpad_(ff[2], ri); if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa; o += oa; return o } if ((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) { ri = Math.min(Math.max(r[1].length, r[4].length), 7); ff = frac(aval, Math.pow(10, ri) - 1, true); return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length)) } if ((r = fmt.match(/^[#0?]+$/)) !== null) { o = pad0r(val, 0); if (fmt.length <= o.length) return o; return hashq(fmt.substr(0, fmt.length - o.length)) + o } if ((r = fmt.match(/^([#0?]+)\.([#0]+)$/)) !== null) { o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1"); ri = o.indexOf("."); var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres; return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres)) } if ((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) { ri = dec(val, r[1].length); return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function ($$) { return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$ }) + "." + pad0(ri, r[1].length) } switch (fmt) { case "#,###": var x = commaify(pad0r(aval, 0)); return x !== "0" ? sign + x : ""; default: } throw new Error("unsupported format |" + fmt + "|") } function write_num_cm2(type, fmt, val) { var idx = fmt.length - 1; while (fmt.charCodeAt(idx - 1) === 44) --idx; return write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx))) } function write_num_pct2(type, fmt, val) { var sfmt = fmt.replace(pct1, ""), mul = fmt.length - sfmt.length; return write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + fill("%", mul) } function write_num_exp2(fmt, val) { var o; var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1; if (fmt.match(/^#+0.0E\+0$/)) { var period = fmt.indexOf("."); if (period === -1) period = fmt.indexOf("E"); var ee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E) % period; if (ee < 0) ee += period; o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period); if (!o.match(/[Ee]/)) { var fakee = Math.floor(Math.log(Math.abs(val)) * Math.LOG10E); if (o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length + ee); else o += "E+" + (fakee - ee); o = o.replace(/\+-/, "-") } o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function ($$, $1, $2, $3) { return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E" }) } else o = val.toExponential(idx); if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o[o.length - 1]; if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e"); return o.replace("e", "E") } function write_num_int(type, fmt, val) {
                if (type.charCodeAt(0) === 40 && !fmt.match(closeparen)) { var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, ""); if (val >= 0) return write_num_int("n", ffmt, val); return "(" + write_num_int("n", ffmt, -val) + ")" } if (fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val); if (fmt.indexOf("%") !== -1) return write_num_pct2(type, fmt, val); if (fmt.indexOf("E") !== -1) return write_num_exp2(fmt, val); if (fmt.charCodeAt(0) === 36) return "$" + write_num_int(type, fmt.substr(fmt[1] == " " ? 2 : 1), val); var o; var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : ""; if (fmt.match(/^00+$/)) return sign + pad0(aval, fmt.length); if (fmt.match(/^[#?]+$/)) { o = "" + val; if (val === 0) o = ""; return o.length > fmt.length ? o : hashq(fmt.substr(0, fmt.length - o.length)) + o } if ((r = fmt.match(frac1)) !== null) return write_num_f2(r, aval, sign); if (fmt.match(/^#+0+$/) !== null) return sign + pad0(aval, fmt.length - fmt.indexOf("0")); if ((r = fmt.match(dec1)) !== null) { o = ("" + val).replace(/^([^\.]+)$/, "$1." + r[1]).replace(/\.$/, "." + r[1]).replace(/\.(\d*)$/, function ($$, $1) { return "." + $1 + fill("0", r[1].length - $1.length) }); return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".") } fmt = fmt.replace(/^#+([0.])/, "$1"); if ((r = fmt.match(/^(0*)\.(#*)$/)) !== null) { return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".") } if ((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify("" + aval); if ((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) { return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val) + "." + fill("0", r[1].length) } if ((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_int(type, fmt.replace(/^#,#*,/, ""), val); if ((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) { o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g, ""), val)); ri = 0; return _strrev(_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function (x) { return ri < o.length ? o[ri++] : x === "0" ? "0" : "" })) } if (fmt.match(phone) !== null) { o = write_num_int(type, "##########", val); return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6) } var oa = ""; if ((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) { ri = Math.min(r[4].length, 7); ff = frac(aval, Math.pow(10, ri) - 1, false); o = "" + sign; oa = write_num("n", r[1], ff[1]); if (oa[oa.length - 1] == " ") oa = oa.substr(0, oa.length - 1) + "0"; o += oa + r[2] + "/" + r[3]; oa = rpad_(ff[2], ri); if (oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length - oa.length)) + oa; o += oa; return o } if ((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
                    ri = Math.min(Math.max(r[1].length, r[4].length), 7); ff = frac(aval, Math.pow(10, ri) - 1, true); return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1], ri) + r[2] + "/" + r[3] + rpad_(ff[2], ri) : fill(" ", 2 * ri + 1 + r[2].length + r[3].length))
                } if ((r = fmt.match(/^[#0?]+$/)) !== null) { o = "" + val; if (fmt.length <= o.length) return o; return hashq(fmt.substr(0, fmt.length - o.length)) + o } if ((r = fmt.match(/^([#0]+)\.([#0]+)$/)) !== null) { o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1"); ri = o.indexOf("."); var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres; return hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres)) } if ((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) { return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function ($$) { return "00," + ($$.length < 3 ? pad0(0, 3 - $$.length) : "") + $$ }) + "." + pad0(0, r[1].length) } switch (fmt) { case "#,###": var x = commaify("" + aval); return x !== "0" ? sign + x : ""; default: } throw new Error("unsupported format |" + fmt + "|")
            } return function write_num(type, fmt, val) { return (val | 0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val) }
        }(); function split_fmt(fmt) { var out = []; var in_str = false, cc; for (var i = 0, j = 0; i < fmt.length; ++i) switch (cc = fmt.charCodeAt(i)) { case 34: in_str = !in_str; break; case 95: case 42: case 92: ++i; break; case 59: out[out.length] = fmt.substr(j, i - j); j = i + 1 } out[out.length] = fmt.substr(j); if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string "); return out } SSF._split = split_fmt; var abstime = /\[[HhMmSs]*\]/; function eval_fmt(fmt, v, opts, flen) { var out = [], o = "", i = 0, c = "", lst = "t", q, dt, j, cc; var hr = "H"; while (i < fmt.length) { switch (c = fmt[i]) { case "G": if (!isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt); out[out.length] = { t: "G", v: "General" }; i += 7; break; case '"': for (o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc); out[out.length] = { t: "t", v: o }; ++i; break; case "\\": var w = fmt[++i], t = w === "(" || w === ")" ? w : "t"; out[out.length] = { t: t, v: w }; ++i; break; case "_": out[out.length] = { t: "t", v: " " }; i += 2; break; case "@": out[out.length] = { t: "T", v: v }; ++i; break; case "B": case "b": if (fmt[i + 1] === "1" || fmt[i + 1] === "2") { if (dt == null) { dt = parse_date_code(v, opts, fmt[i + 1] === "2"); if (dt == null) return "" } out[out.length] = { t: "X", v: fmt.substr(i, 2) }; lst = c; i += 2; break } case "M": case "D": case "Y": case "H": case "S": case "E": c = c.toLowerCase(); case "m": case "d": case "y": case "h": case "s": case "e": case "g": if (v < 0) return ""; if (dt == null) { dt = parse_date_code(v, opts); if (dt == null) return "" } o = c; while (++i < fmt.length && fmt[i].toLowerCase() === c) o += c; if (c === "m" && lst.toLowerCase() === "h") c = "M"; if (c === "h") c = hr; out[out.length] = { t: c, v: o }; lst = c; break; case "A": q = { t: c, v: "A" }; if (dt == null) dt = parse_date_code(v, opts); if (fmt.substr(i, 3) === "A/P") { if (dt != null) q.v = dt.H >= 12 ? "P" : "A"; q.t = "T"; hr = "h"; i += 3 } else if (fmt.substr(i, 5) === "AM/PM") { if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = "T"; i += 5; hr = "h" } else { q.t = "t"; ++i } if (dt == null && q.t === "T") return ""; out[out.length] = q; lst = c; break; case "[": o = c; while (fmt[i++] !== "]" && i < fmt.length) o += fmt[i]; if (o.substr(-1) !== "]") throw 'unterminated "[" block: |' + o + "|"; if (o.match(abstime)) { if (dt == null) { dt = parse_date_code(v, opts); if (dt == null) return "" } out[out.length] = { t: "Z", v: o.toLowerCase() } } else { o = "" } break; case ".": if (dt != null) { o = c; while ((c = fmt[++i]) === "0") o += c; out[out.length] = { t: "s", v: o }; break } case "0": case "#": o = c; while ("0#?.,E+-%".indexOf(c = fmt[++i]) > -1 || c == "\\" && fmt[i + 1] == "-" && "0#".indexOf(fmt[i + 2]) > -1) o += c; out[out.length] = { t: "n", v: o }; break; case "?": o = c; while (fmt[++i] === c) o += c; q = { t: c, v: o }; out[out.length] = q; lst = c; break; case "*": ++i; if (fmt[i] == " " || fmt[i] == "*") ++i; break; case "(": case ")": out[out.length] = { t: flen === 1 ? "t" : c, v: c }; ++i; break; case "1": case "2": case "3": case "4": case "5": case "6": case "7": case "8": case "9": o = c; while ("0123456789".indexOf(fmt[++i]) > -1) o += fmt[i]; out[out.length] = { t: "D", v: o }; break; case " ": out[out.length] = { t: c, v: c }; ++i; break; default: if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxz".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt); out[out.length] = { t: "t", v: c }; ++i; break } } var bt = 0, ss0 = 0, ssm; for (i = out.length - 1, lst = "t"; i >= 0; --i) { switch (out[i].t) { case "h": case "H": out[i].t = hr; lst = "h"; if (bt < 1) bt = 1; break; case "s": if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1); if (bt < 3) bt = 3; case "d": case "y": case "M": case "e": lst = out[i].t; break; case "m": if (lst === "s") { out[i].t = "M"; if (bt < 2) bt = 2 } break; case "X": if (out[i].v === "B2"); break; case "Z": if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1; if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2; if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3 } } switch (bt) { case 0: break; case 1: if (dt.u >= .5) { dt.u = 0; ++dt.S } if (dt.S >= 60) { dt.S = 0; ++dt.M } if (dt.M >= 60) { dt.M = 0; ++dt.H } break; case 2: if (dt.u >= .5) { dt.u = 0; ++dt.S } if (dt.S >= 60) { dt.S = 0; ++dt.M } break } var nstr = "", jj; for (i = 0; i < out.length; ++i) { switch (out[i].t) { case "t": case "T": case " ": case "D": break; case "X": out[i] = undefined; break; case "d": case "m": case "y": case "h": case "H": case "M": case "s": case "e": case "b": case "Z": out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0); out[i].t = "t"; break; case "n": case "(": case "?": jj = i + 1; while (out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || "$€".indexOf(out[jj].v) > -1 || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))) { out[i].v += out[jj].v; out[jj] = undefined; ++jj } nstr += out[i].v; i = jj - 1; break; case "G": out[i].t = "t"; out[i].v = general_fmt(v, opts); break } } var vv = "", myv, ostr; if (nstr.length > 0) { myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v; ostr = write_num(nstr.charCodeAt(0) === 40 ? "(" : "n", nstr, myv); jj = ostr.length - 1; var decpt = out.length; for (i = 0; i < out.length; ++i) if (out[i] != null && out[i].v.indexOf(".") > -1) { decpt = i; break } var lasti = out.length; if (decpt === out.length && ostr.indexOf("E") === -1) { for (i = out.length - 1; i >= 0; --i) { if (out[i] == null || "n?(".indexOf(out[i].t) === -1) continue; if (jj >= out[i].v.length - 1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj + 1, out[i].v.length) } else if (jj < 0) out[i].v = ""; else { out[i].v = ostr.substr(0, jj + 1); jj = -1 } out[i].t = "t"; lasti = i } if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v } else if (decpt !== out.length && ostr.indexOf("E") === -1) { jj = ostr.indexOf(".") - 1; for (i = decpt; i >= 0; --i) { if (out[i] == null || "n?(".indexOf(out[i].t) === -1) continue; j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1; vv = out[i].v.substr(j + 1); for (; j >= 0; --j) { if (jj >= 0 && (out[i].v[j] === "0" || out[i].v[j] === "#")) vv = ostr[jj--] + vv } out[i].v = vv; out[i].t = "t"; lasti = i } if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v; jj = ostr.indexOf(".") + 1; for (i = decpt; i < out.length; ++i) { if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue; j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0; vv = out[i].v.substr(0, j); for (; j < out[i].v.length; ++j) { if (jj < ostr.length) vv += ostr[jj++] } out[i].v = vv; out[i].t = "t"; lasti = i } } } for (i = 0; i < out.length; ++i) if (out[i] != null && "n(?".indexOf(out[i].t) > -1) { myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v; out[i].v = write_num(out[i].t, out[i].v, myv); out[i].t = "t" } var retval = ""; for (i = 0; i !== out.length; ++i) if (out[i] != null) retval += out[i].v; return retval } SSF._eval = eval_fmt; var cfregex = /\[[=<>]/; var cfregex2 = /\[([=<>]*)(-?\d+\.?\d*)\]/; function chkcond(v, rr) { if (rr == null) return false; var thresh = parseFloat(rr[2]); switch (rr[1]) { case "=": if (v == thresh) return true; break; case ">": if (v > thresh) return true; break; case "<": if (v < thresh) return true; break; case "<>": if (v != thresh) return true; break; case ">=": if (v >= thresh) return true; break; case "<=": if (v <= thresh) return true; break } return false } function choose_fmt(f, v) { var fmt = split_fmt(f); var l = fmt.length, lat = fmt[l - 1].indexOf("@"); if (l < 4 && lat > -1) --l; if (fmt.length > 4) throw "cannot find right format for |" + fmt + "|"; if (typeof v !== "number") return [4, fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"]; switch (fmt.length) { case 1: fmt = lat > -1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break; case 2: fmt = lat > -1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break; case 3: fmt = lat > -1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break; case 4: break } var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2]; if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff]; if (fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) { var m1 = fmt[0].match(cfregex2); var m2 = fmt[1].match(cfregex2); return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]] } return [l, ff] } function format(fmt, v, o) { fixopts(o != null ? o : o = []); var sfmt = ""; switch (typeof fmt) { case "string": sfmt = fmt; break; case "number": sfmt = (o.table != null ? o.table : table_fmt)[fmt]; break } if (isgeneral(sfmt, 0)) return general_fmt(v, o); var f = choose_fmt(sfmt, v); if (isgeneral(f[1])) return general_fmt(v, o); if (v === true) v = "TRUE"; else if (v === false) v = "FALSE"; else if (v === "" || v == null) return ""; return eval_fmt(f[1], v, o, f[0]) } SSF._table = table_fmt; SSF.load = function load_entry(fmt, idx) { table_fmt[idx] = fmt }; SSF.format = format; SSF.get_table = function get_table() { return table_fmt }; SSF.load_table = function load_table(tbl) { for (var i = 0; i != 392; ++i) if (tbl[i] !== undefined) SSF.load(tbl[i], i) }
    }; make_ssf(SSF); function isval(x) { return x !== undefined && x !== null } function keys(o) { return Object.keys(o) } function evert_key(obj, key) { var o = [], K = keys(obj); for (var i = 0; i !== K.length; ++i) o[obj[K[i]][key]] = K[i]; return o } function evert(obj) { var o = [], K = keys(obj); for (var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i]; return o } function evert_num(obj) { var o = [], K = keys(obj); for (var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i], 10); return o } function evert_arr(obj) { var o = [], K = keys(obj); for (var i = 0; i !== K.length; ++i) { if (o[obj[K[i]]] == null) o[obj[K[i]]] = []; o[obj[K[i]]].push(K[i]) } return o } function datenum(v, date1904) { if (date1904) v += 1462; var epoch = Date.parse(v); return (epoch + 22091616e5) / (24 * 60 * 60 * 1e3) } function cc2str(arr) { var o = ""; for (var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]); return o } var has_buf = typeof Buffer !== "undefined"; function getdata(data) { if (!data) return null; if (data.name.substr(-4) === ".bin") { if (data.data) return char_codes(data.data); if (data.asNodeBuffer && has_buf) return data.asNodeBuffer(); if (data._data && data._data.getContent) return Array.prototype.slice.call(data._data.getContent()) } else { if (data.data) return data.name.substr(-4) !== ".bin" ? debom_xml(data.data) : char_codes(data.data); if (data.asNodeBuffer && has_buf) return debom_xml(data.asNodeBuffer().toString("binary")); if (data.asBinary) return debom_xml(data.asBinary()); if (data._data && data._data.getContent) return debom_xml(cc2str(Array.prototype.slice.call(data._data.getContent(), 0))) } return null } function safegetzipfile(zip, file) { var f = file; if (zip.files[f]) return zip.files[f]; f = file.toLowerCase(); if (zip.files[f]) return zip.files[f]; f = f.replace(/\//g, "\\"); if (zip.files[f]) return zip.files[f]; return null } function getzipfile(zip, file) { var o = safegetzipfile(zip, file); if (o == null) throw new Error("Cannot find file " + file + " in zip"); return o } function getzipdata(zip, file, safe) { if (!safe) return getdata(getzipfile(zip, file)); if (!file) return null; try { return getzipdata(zip, file) } catch (e) { return null } } var _fs, jszip; if (typeof JSZip !== "undefined") jszip = JSZip; if (typeof exports !== "undefined") { if (typeof module !== "undefined" && module.exports) { if (has_buf && typeof jszip === "undefined") jszip = require("js" + "zip"); if (typeof jszip === "undefined") jszip = require("./js" + "zip").JSZip; _fs = require("f" + "s") } } var attregexg = /\b[\w:]+=["'][^"]*['"]/g; var tagregex = /<[^>]*>/g; var nsregex = /<\w*:/, nsregex2 = /<(\/?)\w+:/; function parsexmltag(tag, skip_root) { var z = []; var eq = 0, c = 0; for (; eq !== tag.length; ++eq) if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break; if (!skip_root) z[0] = tag.substr(0, eq); if (eq === tag.length) return z; var m = tag.match(attregexg), j = 0, w = "", v = "", i = 0, q = "", cc = ""; if (m) for (i = 0; i != m.length; ++i) { cc = m[i]; for (c = 0; c != cc.length; ++c) if (cc.charCodeAt(c) === 61) break; q = cc.substr(0, c); v = cc.substring(c + 2, cc.length - 1); for (j = 0; j != q.length; ++j) if (q.charCodeAt(j) === 58) break; if (j === q.length) z[q] = v; else z[(j === 5 && q.substr(0, 5) === "xmlns" ? "xmlns" : "") + q.substr(j + 1)] = v } return z } function strip_ns(x) { return x.replace(nsregex2, "<$1") } var encodings = { "&quot;": '"', "&apos;": "'", "&gt;": ">", "&lt;": "<", "&amp;": "&" }; var rencoding = evert(encodings); var rencstr = "&<>'\"".split(""); var encregex = /&[a-z]*;/g, coderegex = /_x([\da-fA-F]+)_/g; function unescapexml(text) { var s = text + ""; return s.replace(encregex, function ($$) { return encodings[$$] }).replace(coderegex, function (m, c) { return String.fromCharCode(parseInt(c, 16)) }) } var decregex = /[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g; function escapexml(text) { var s = text + ""; return s.replace(decregex, function (y) { return rencoding[y] }).replace(charegex, function (s) { return "_x" + ("000" + s.charCodeAt(0).toString(16)).substr(-4) + "_" }) } function parsexmlbool(value, tag) { switch (value) { case "1": case "true": case "TRUE": return true; default: return false } } var utf8read = function utf8reada(orig) { var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0; while (i < orig.length) { c = orig.charCodeAt(i++); if (c < 128) { out += String.fromCharCode(c); continue } d = orig.charCodeAt(i++); if (c > 191 && c < 224) { out += String.fromCharCode((c & 31) << 6 | d & 63); continue } e = orig.charCodeAt(i++); if (c < 240) { out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63); continue } f = orig.charCodeAt(i++); w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536; out += String.fromCharCode(55296 + (w >>> 10 & 1023)); out += String.fromCharCode(56320 + (w & 1023)) } return out }; if (has_buf) { var utf8readb = function utf8readb(data) { var out = new Buffer(2 * data.length), w, i, j = 1, k = 0, ww = 0, c; for (i = 0; i < data.length; i += j) { j = 1; if ((c = data.charCodeAt(i)) < 128) w = c; else if (c < 224) { w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63); j = 2 } else if (c < 240) { w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63); j = 3 } else { j = 4; w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63); w -= 65536; ww = 55296 + (w >>> 10 & 1023); w = 56320 + (w & 1023) } if (ww !== 0) { out[k++] = ww & 255; out[k++] = ww >>> 8; ww = 0 } out[k++] = w % 256; out[k++] = w >>> 8 } out.length = k; return out.toString("ucs2") }; var corpus = "foo bar bazâð£"; if (utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb; var utf8readc = function utf8readc(data) { return Buffer(data, "binary").toString("utf8") }; if (utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc } var matchtag = function () { var mtcache = {}; return function matchtag(f, g) { var t = f + "|" + g; if (mtcache[t] !== undefined) return mtcache[t]; return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([^☃]*)</(?:\\w+:)?' + f + ">", g || "") } }(); var vtregex = function () { var vt_cache = {}; return function vt_regex(bt) { if (vt_cache[bt] !== undefined) return vt_cache[bt]; return vt_cache[bt] = new RegExp("<vt:" + bt + ">(.*?)</vt:" + bt + ">", "g") } }(); var vtvregex = /<\/?vt:variant>/g, vtmregex = /<vt:([^>]*)>(.*)</; function parseVector(data) { var h = parsexmltag(data); var matches = data.match(vtregex(h.baseType)) || []; if (matches.length != h.size) throw "unexpected vector length " + matches.length + " != " + h.size; var res = []; matches.forEach(function (x) { var v = x.replace(vtvregex, "").match(vtmregex); res.push({ v: v[2], t: v[1] }) }); return res } var wtregex = /(^\s|\s$|\n)/; function writetag(f, g) { return "<" + f + (g.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">" } function wxt_helper(h) { return keys(h).map(function (k) { return " " + k + '="' + h[k] + '"' }).join("") } function writextag(f, g, h) { return "<" + f + (isval(h) ? wxt_helper(h) : "") + (isval(g) ? (g.match(wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">" } function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/, "") } catch (e) { if (t) throw e } } function write_vt(s) { switch (typeof s) { case "string": return writextag("vt:lpwstr", s); case "number": return writextag((s | 0) == s ? "vt:i4" : "vt:r8", String(s)); case "boolean": return writextag("vt:bool", s ? "true" : "false") } if (s instanceof Date) return writextag("vt:filetime", write_w3cdtf(s)); throw new Error("Unable to serialize " + s) } var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n'; var XMLNS = { dc: "https://purl.org/dc/elements/1.1/", dcterms: "https://purl.org/dc/terms/", dcmitype: "https://purl.org/dc/dcmitype/", mx: "https://schemas.microsoft.com/office/mac/excel/2008/main", r: "https://schemas.openxmlformats.org/officeDocument/2006/relationships", sjs: "https://schemas.openxmlformats.org/package/2006/sheetjs/core-properties", vt: "https://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes", xsi: "https://www.w3.org/2001/XMLSchema-instance", xsd: "https://www.w3.org/2001/XMLSchema" }; XMLNS.main = ["https://schemas.openxmlformats.org/spreadsheetml/2006/main", "https://purl.oclc.org/ooxml/spreadsheetml/main", "https://schemas.microsoft.com/office/excel/2006/main", "https://schemas.microsoft.com/office/excel/2006/2"]; function readIEEE754(buf, idx, isLE, nl, ml) { if (isLE === undefined) isLE = true; if (!nl) nl = 8; if (!ml && nl === 8) ml = 52; var e, m, el = nl * 8 - ml - 1, eMax = (1 << el) - 1, eBias = eMax >> 1; var bits = -7, d = isLE ? -1 : 1, i = isLE ? nl - 1 : 0, s = buf[idx + i]; i += d; e = s & (1 << -bits) - 1; s >>>= -bits; bits += el; for (; bits > 0; e = e * 256 + buf[idx + i], i += d, bits -= 8); m = e & (1 << -bits) - 1; e >>>= -bits; bits += ml; for (; bits > 0; m = m * 256 + buf[idx + i], i += d, bits -= 8); if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity; else if (e === 0) e = 1 - eBias; else { m = m + Math.pow(2, ml); e = e - eBias } return (s ? -1 : 1) * m * Math.pow(2, e - ml) } var __toBuffer, ___toBuffer; __toBuffer = ___toBuffer = function toBuffer_(bufs) { var x = []; for (var i = 0; i < bufs[0].length; ++i) { x.push.apply(x, bufs[0][i]) } return x }; var __double, ___double; __double = ___double = function (b, idx) { return readIEEE754(b, idx) }; var is_buf = function is_buf_a(a) { return Array.isArray(a) }; if (has_buf) { __toBuffer = function (bufs) { return bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0]) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs) }; __double = function double_(b, i) { if (Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b, i) }; is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) } } var __readUInt8 = function (b, idx) { return b[idx] }; var __readUInt16LE = function (b, idx) { return b[idx + 1] * (1 << 8) + b[idx] }; var __readInt16LE = function (b, idx) { var u = b[idx + 1] * (1 << 8) + b[idx]; return u < 32768 ? u : (65535 - u + 1) * -1 }; var __readUInt32LE = function (b, idx) { return b[idx + 3] * (1 << 24) + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx] }; var __readInt32LE = function (b, idx) { return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx] }; function ReadShift(size, t) { var o = "", oo = [], w, vv, i, loc; if (t === "dbcs") { loc = this.l; if (has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le"); else for (i = 0; i != size; ++i) { o += String.fromCharCode(__readUInt16LE(this, loc)); loc += 2 } size *= 2 } else switch (size) { case 1: o = __readUInt8(this, this.l); break; case 2: o = (t === "i" ? __readInt16LE : __readUInt16LE)(this, this.l); break; case 4: o = __readUInt32LE(this, this.l); break; case 8: if (t === "f") { o = __double(this, this.l); break } } this.l += size; return o } function WriteShift(t, val, f) { var size, i; if (f === "dbcs") { for (i = 0; i != val.length; ++i) this.writeUInt16LE(val.charCodeAt(i), this.l + 2 * i); size = 2 * val.length } else switch (t) { case 1: size = 1; this[this.l] = val & 255; break; case 3: size = 3; this[this.l + 2] = val & 255; val >>>= 8; this[this.l + 1] = val & 255; val >>>= 8; this[this.l] = val & 255; break; case 4: size = 4; this.writeUInt32LE(val, this.l); break; case 8: size = 8; if (f === "f") { this.writeDoubleLE(val, this.l); break } case 16: break; case -4: size = 4; this.writeInt32LE(val, this.l); break } this.l += size; return this } function prep_blob(blob, pos) { blob.l = pos; blob.read_shift = ReadShift; blob.write_shift = WriteShift } function parsenoop(blob, length) { blob.l += length } function writenoop(blob, length) { blob.l += length } function new_buf(sz) { var o = has_buf ? new Buffer(sz) : new Array(sz); prep_blob(o, 0); return o } function recordhopper(data, cb, opts) { var tmpbyte, cntbyte, length; prep_blob(data, data.l || 0); while (data.l < data.length) { var RT = data.read_shift(1); if (RT & 128) RT = (RT & 127) + ((data.read_shift(1) & 127) << 7); var R = RecordEnum[RT] || RecordEnum[65535]; tmpbyte = data.read_shift(1); length = tmpbyte & 127; for (cntbyte = 1; cntbyte < 4 && tmpbyte & 128; ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 127) << 7 * cntbyte; var d = R.f(data, length, opts); if (cb(d, R, RT)) return } } function buf_array() { var bufs = [], blksz = 2048; var newblk = function ba_newblk(sz) { var o = new_buf(sz); prep_blob(o, 0); return o }; var curbuf = newblk(blksz); var endbuf = function ba_endbuf() { curbuf.length = curbuf.l; if (curbuf.length > 0) bufs.push(curbuf); curbuf = null }; var next = function ba_next(sz) { if (sz < curbuf.length - curbuf.l) return curbuf; endbuf(); return curbuf = newblk(Math.max(sz + 1, blksz)) }; var end = function ba_end() { endbuf(); return __toBuffer([bufs]) }; var push = function ba_push(buf) { endbuf(); curbuf = buf; next(blksz) }; return { next: next, push: push, end: end, _bufs: bufs } } function write_record(ba, type, payload, length) { var t = evert_RE[type], l; if (!length) length = RecordEnum[t].p || (payload || []).length || 0; l = 1 + (t >= 128 ? 1 : 0) + 1 + length; if (length >= 128) ++l; if (length >= 16384) ++l; if (length >= 2097152) ++l; var o = ba.next(l); if (t <= 127) o.write_shift(1, t); else { o.write_shift(1, (t & 127) + 128); o.write_shift(1, t >> 7) } for (var i = 0; i != 4; ++i) { if (length >= 128) { o.write_shift(1, (length & 127) + 128); length >>= 7 } else { o.write_shift(1, length); break } } if (length > 0 && is_buf(payload)) ba.push(payload) } function parse_StrRun(data, length) { return { ich: data.read_shift(2), ifnt: data.read_shift(2) } } function parse_RichStr(data, length) { var start = data.l; var flags = data.read_shift(1); var str = parse_XLWideString(data); var rgsStrRun = []; var z = { t: str, h: str }; if ((flags & 1) !== 0) { var dwSizeStrRun = data.read_shift(4); for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data)); z.r = rgsStrRun } else z.r = "<t>" + escapexml(str) + "</t>"; if ((flags & 2) !== 0) { } data.l = start + length; return z } function write_RichStr(str, o) { if (o == null) o = new_buf(5 + 2 * str.t.length); o.write_shift(1, 0); write_XLWideString(str.t, o); return o } function parse_Cell(data) { var col = data.read_shift(4); var iStyleRef = data.read_shift(2); iStyleRef += data.read_shift(1) << 16; var fPhShow = data.read_shift(1); return { c: col, iStyleRef: iStyleRef } } function write_Cell(cell, o) { if (o == null) o = new_buf(8); o.write_shift(-4, cell.c); o.write_shift(3, cell.iStyleRef === undefined ? cell.iStyleRef : cell.s); o.write_shift(1, 0); return o } function parse_CodeName(data, length) { return parse_XLWideString(data, length) } function parse_XLNullableWideString(data) { var cchCharacters = data.read_shift(4); return cchCharacters === 0 || cchCharacters === 4294967295 ? "" : data.read_shift(cchCharacters, "dbcs") } function write_XLNullableWideString(data, o) { if (!o) o = new_buf(127); o.write_shift(4, data.length > 0 ? data.length : 4294967295); if (data.length > 0) o.write_shift(0, data, "dbcs"); return o } function parse_XLWideString(data) { var cchCharacters = data.read_shift(4); return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs") } function write_XLWideString(data, o) { if (o == null) o = new_buf(4 + 2 * data.length); o.write_shift(4, data.length); if (data.length > 0) o.write_shift(0, data, "dbcs"); return o } var parse_RelID = parse_XLNullableWideString; var write_RelID = write_XLNullableWideString; function parse_RkNumber(data) { var b = data.slice(data.l, data.l + 4); var fX100 = b[0] & 1, fInt = b[0] & 2; data.l += 4; b[0] &= 252; var RK = fInt === 0 ? __double([0, 0, 0, 0, b[0], b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2; return fX100 ? RK / 100 : RK } function parse_UncheckedRfX(data) { var cell = { s: {}, e: {} }; cell.s.r = data.read_shift(4); cell.e.r = data.read_shift(4); cell.s.c = data.read_shift(4); cell.e.c = data.read_shift(4); return cell } function write_UncheckedRfX(r, o) { if (!o) o = new_buf(16); o.write_shift(4, r.s.r); o.write_shift(4, r.e.r); o.write_shift(4, r.s.c); o.write_shift(4, r.e.c); return o } function parse_Xnum(data, length) { return data.read_shift(8, "f") } function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, "f", data) } var BErr = { 0: "#NULL!", 7: "#DIV/0!", 15: "#VALUE!", 23: "#REF!", 29: "#NAME?", 36: "#NUM!", 42: "#N/A", 43: "#GETTING_DATA", 255: "#WTF?" }; var RBErr = evert_num(BErr); function parse_BrtColor(data, length) { var out = {}; var d = data.read_shift(1); out.fValidRGB = d & 1; out.xColorType = d >>> 1; out.index = data.read_shift(1); out.nTintAndShade = data.read_shift(2, "i"); out.bRed = data.read_shift(1); out.bGreen = data.read_shift(1); out.bBlue = data.read_shift(1); out.bAlpha = data.read_shift(1) } function parse_FontFlags(data, length) { var d = data.read_shift(1); data.l++; var out = { fItalic: d & 2, fStrikeout: d & 8, fOutline: d & 16, fShadow: d & 32, fCondense: d & 64, fExtend: d & 128 }; return out } var ct2type = { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks", "application/vnd.ms-excel.binIndexWs": "TODO", "application/vnd.ms-excel.chartsheet": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "TODO", "application/vnd.ms-excel.dialogsheet": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "TODO", "application/vnd.ms-excel.macrosheet": "TODO", "application/vnd.ms-excel.macrosheet+xml": "TODO", "application/vnd.ms-excel.intlmacrosheet": "TODO", "application/vnd.ms-excel.binIndexMs": "TODO", "application/vnd.openxmlformats-package.core-properties+xml": "coreprops", "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops", "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops", "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO", "application/vnd.ms-excel.comments": "comments", "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments", "application/vnd.ms-excel.pivotTable": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO", "application/vnd.ms-excel.calcChain": "calcchains", "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains", "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO", "application/vnd.ms-office.activeX": "TODO", "application/vnd.ms-office.activeX+xml": "TODO", "application/vnd.ms-excel.attachedToolbars": "TODO", "application/vnd.ms-excel.connections": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO", "application/vnd.ms-excel.externalLink": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "TODO", "application/vnd.ms-excel.sheetMetadata": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO", "application/vnd.ms-excel.pivotCacheDefinition": "TODO", "application/vnd.ms-excel.pivotCacheRecords": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO", "application/vnd.ms-excel.queryTable": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO", "application/vnd.ms-excel.userNames": "TODO", "application/vnd.ms-excel.revisionHeaders": "TODO", "application/vnd.ms-excel.revisionLog": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO", "application/vnd.ms-excel.tableSingleCells": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO", "application/vnd.ms-excel.slicer": "TODO", "application/vnd.ms-excel.slicerCache": "TODO", "application/vnd.ms-excel.slicer+xml": "TODO", "application/vnd.ms-excel.slicerCache+xml": "TODO", "application/vnd.ms-excel.wsSortMap": "TODO", "application/vnd.ms-excel.table": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO", "application/vnd.openxmlformats-officedocument.theme+xml": "themes", "application/vnd.ms-excel.Timeline+xml": "TODO", "application/vnd.ms-excel.TimelineCache+xml": "TODO", "application/vnd.ms-office.vbaProject": "vba", "application/vnd.ms-office.vbaProjectSignature": "vba", "application/vnd.ms-office.volatileDependencies": "TODO", "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO", "application/vnd.ms-excel.controlproperties+xml": "TODO", "application/vnd.openxmlformats-officedocument.model+data": "TODO", "application/vnd.ms-excel.Survey+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawing+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO", "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO", "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO", "application/vnd.openxmlformats-package.relationships+xml": "rels", "application/vnd.openxmlformats-officedocument.oleObject": "TODO", sheet: "js" }; var CT_LIST = function () { var o = { workbooks: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml", xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml", xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main", xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml" }, strs: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml", xlsb: "application/vnd.ms-excel.sharedStrings" }, sheets: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml", xlsb: "application/vnd.ms-excel.worksheet" }, styles: { xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml", xlsb: "application/vnd.ms-excel.styles" } }; keys(o).forEach(function (k) { if (!o[k].xlsm) o[k].xlsm = o[k].xlsx }); keys(o).forEach(function (k) { keys(o[k]).forEach(function (v) { ct2type[o[k][v]] = k }) }); return o }(); var type2ct = evert_arr(ct2type); XMLNS.CT = "https://schemas.openxmlformats.org/package/2006/content-types"; function parse_ct(data, opts) { var ctext = {}; if (!data || !data.match) return data; var ct = { workbooks: [], sheets: [], calcchains: [], themes: [], styles: [], coreprops: [], extprops: [], custprops: [], strs: [], comments: [], vba: [], TODO: [], rels: [], xmlns: "" }; (data.match(tagregex) || []).forEach(function (x) { var y = parsexmltag(x); switch (y[0].replace(nsregex, "<")) { case "<?xml": break; case "<Types": ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || ["", ""])[1]]; break; case "<Default": ctext[y.Extension] = y.ContentType; break; case "<Override": if (ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName); else if (opts.WTF) console.error(y); break } }); if (ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns); ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : ""; ct.sst = ct.strs.length > 0 ? ct.strs[0] : ""; ct.style = ct.styles.length > 0 ? ct.styles[0] : ""; ct.defaults = ctext; delete ct.calcchains; return ct } var CTYPE_XML_ROOT = writextag("Types", null, { xmlns: XMLNS.CT, "xmlns:xsd": XMLNS.xsd, "xmlns:xsi": XMLNS.xsi }); var CTYPE_DEFAULTS = [["xml", "application/xml"], ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"], ["rels", type2ct.rels[0]]].map(function (x) { return writextag("Default", null, { Extension: x[0], ContentType: x[1] }) }); function write_ct(ct, opts) { var o = [], v; o[o.length] = XML_HEADER; o[o.length] = CTYPE_XML_ROOT; o = o.concat(CTYPE_DEFAULTS); var f1 = function (w) { if (ct[w] && ct[w].length > 0) { v = ct[w][0]; o[o.length] = writextag("Override", null, { PartName: (v[0] == "/" ? "" : "/") + v, ContentType: CT_LIST[w][opts.bookType || "xlsx"] }) } }; var f2 = function (w) { ct[w].forEach(function (v) { o[o.length] = writextag("Override", null, { PartName: (v[0] == "/" ? "" : "/") + v, ContentType: CT_LIST[w][opts.bookType || "xlsx"] }) }) }; var f3 = function (t) { (ct[t] || []).forEach(function (v) { o[o.length] = writextag("Override", null, { PartName: (v[0] == "/" ? "" : "/") + v, ContentType: type2ct[t][0] }) }) }; f1("workbooks"); f2("sheets"); f3("themes");["strs", "styles"].forEach(f1);["coreprops", "extprops", "custprops"].forEach(f3); if (o.length > 2) { o[o.length] = "</Types>"; o[1] = o[1].replace("/>", ">") } return o.join("") } var RELS = { WB: "https://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", SHEET: "https://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument" }; function parse_rels(data, currentFilePath) {
        if (!data) return data; if (currentFilePath.charAt(0) !== "/") { currentFilePath = "/" + currentFilePath } var rels = {}; var hash = {}; var resolveRelativePathIntoAbsolute = function (to) { var toksFrom = currentFilePath.split("/"); toksFrom.pop(); var toksTo = to.split("/"); var reversed = []; while (toksTo.length !== 0) { var tokTo = toksTo.shift(); if (tokTo === "..") { toksFrom.pop() } else if (tokTo !== ".") { toksFrom.push(tokTo) } } return toksFrom.join("/") }; data.match(tagregex).forEach(function (x) {
            var y = parsexmltag(x); if (y[0] === "<Relationship") {
                var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode; var canonictarget = y.TargetMode === "External" ? y.Target : resolveRelativePathIntoAbsolute(y.Target); rels[canonictarget] = rel;
                hash[y.Id] = rel
            }
        }); rels["!id"] = hash; return rels
    } XMLNS.RELS = "https://schemas.openxmlformats.org/package/2006/relationships"; var RELS_ROOT = writextag("Relationships", null, { xmlns: XMLNS.RELS }); function write_rels(rels) { var o = []; o[o.length] = XML_HEADER; o[o.length] = RELS_ROOT; keys(rels["!id"]).forEach(function (rid) { var rel = rels["!id"][rid]; o[o.length] = writextag("Relationship", null, rel) }); if (o.length > 2) { o[o.length] = "</Relationships>"; o[1] = o[1].replace("/>", ">") } return o.join("") } var CORE_PROPS = [["cp:category", "Category"], ["cp:contentStatus", "ContentStatus"], ["cp:keywords", "Keywords"], ["cp:lastModifiedBy", "LastAuthor"], ["cp:lastPrinted", "LastPrinted"], ["cp:revision", "RevNumber"], ["cp:version", "Version"], ["dc:creator", "Author"], ["dc:description", "Comments"], ["dc:identifier", "Identifier"], ["dc:language", "Language"], ["dc:subject", "Subject"], ["dc:title", "Title"], ["dcterms:created", "CreatedDate", "date"], ["dcterms:modified", "ModifiedDate", "date"]]; XMLNS.CORE_PROPS = "https://schemas.openxmlformats.org/package/2006/metadata/core-properties"; RELS.CORE_PROPS = "https://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties"; var CORE_PROPS_REGEX = function () { var r = new Array(CORE_PROPS.length); for (var i = 0; i < CORE_PROPS.length; ++i) { var f = CORE_PROPS[i]; var g = "(?:" + f[0].substr(0, f[0].indexOf(":")) + ":)" + f[0].substr(f[0].indexOf(":") + 1); r[i] = new RegExp("<" + g + "[^>]*>(.*)</" + g + ">") } return r }(); function parse_core_props(data) { var p = {}; for (var i = 0; i < CORE_PROPS.length; ++i) { var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]); if (cur != null && cur.length > 0) p[f[1]] = cur[1]; if (f[2] === "date" && p[f[1]]) p[f[1]] = new Date(p[f[1]]) } return p } var CORE_PROPS_XML_ROOT = writextag("cp:coreProperties", null, { "xmlns:cp": XMLNS.CORE_PROPS, "xmlns:dc": XMLNS.dc, "xmlns:dcterms": XMLNS.dcterms, "xmlns:dcmitype": XMLNS.dcmitype, "xmlns:xsi": XMLNS.xsi }); function cp_doit(f, g, h, o, p) { if (p[f] != null || g == null || g === "") return; p[f] = g; o[o.length] = h ? writextag(f, g, h) : writetag(f, g) } function write_core_props(cp, opts) { var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {}; if (!cp) return o.join(""); if (cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), { "xsi:type": "dcterms:W3CDTF" }, o, p); if (cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), { "xsi:type": "dcterms:W3CDTF" }, o, p); for (var i = 0; i != CORE_PROPS.length; ++i) { var f = CORE_PROPS[i]; cp_doit(f[0], cp[f[1]], null, o, p) } if (o.length > 2) { o[o.length] = "</cp:coreProperties>"; o[1] = o[1].replace("/>", ">") } return o.join("") } var EXT_PROPS = [["Application", "Application", "string"], ["AppVersion", "AppVersion", "string"], ["Company", "Company", "string"], ["DocSecurity", "DocSecurity", "string"], ["Manager", "Manager", "string"], ["HyperlinksChanged", "HyperlinksChanged", "bool"], ["SharedDoc", "SharedDoc", "bool"], ["LinksUpToDate", "LinksUpToDate", "bool"], ["ScaleCrop", "ScaleCrop", "bool"], ["HeadingPairs", "HeadingPairs", "raw"], ["TitlesOfParts", "TitlesOfParts", "raw"]]; XMLNS.EXT_PROPS = "https://schemas.openxmlformats.org/officeDocument/2006/extended-properties"; RELS.EXT_PROPS = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties"; function parse_ext_props(data, p) { var q = {}; if (!p) p = {}; EXT_PROPS.forEach(function (f) { switch (f[2]) { case "string": p[f[1]] = (data.match(matchtag(f[0])) || [])[1]; break; case "bool": p[f[1]] = (data.match(matchtag(f[0])) || [])[1] === "true"; break; case "raw": var cur = data.match(new RegExp("<" + f[0] + "[^>]*>(.*)</" + f[0] + ">")); if (cur && cur.length > 0) q[f[1]] = cur[1]; break } }); if (q.HeadingPairs && q.TitlesOfParts) { var v = parseVector(q.HeadingPairs); var j = 0, widx = 0; for (var i = 0; i !== v.length; ++i) { switch (v[i].v) { case "Worksheets": widx = j; p.Worksheets = +v[++i].v; break; case "Named Ranges": ++i; break } } var parts = parseVector(q.TitlesOfParts).map(function (x) { return utf8read(x.v) }); p.SheetNames = parts.slice(widx, widx + p.Worksheets) } return p } var EXT_PROPS_XML_ROOT = writextag("Properties", null, { xmlns: XMLNS.EXT_PROPS, "xmlns:vt": XMLNS.vt }); function write_ext_props(cp, opts) { var o = [], p = {}, W = writextag; if (!cp) cp = {}; cp.Application = "SheetJS"; o[o.length] = XML_HEADER; o[o.length] = EXT_PROPS_XML_ROOT; EXT_PROPS.forEach(function (f) { if (cp[f[1]] === undefined) return; var v; switch (f[2]) { case "string": v = cp[f[1]]; break; case "bool": v = cp[f[1]] ? "true" : "false"; break } if (v !== undefined) o[o.length] = W(f[0], v) }); o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), { size: 2, baseType: "variant" })); o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function (s) { return "<vt:lpstr>" + s + "</vt:lpstr>" }).join(""), { size: cp.Worksheets, baseType: "lpstr" })); if (o.length > 2) { o[o.length] = "</Properties>"; o[1] = o[1].replace("/>", ">") } return o.join("") } XMLNS.CUST_PROPS = "https://schemas.openxmlformats.org/officeDocument/2006/custom-properties"; RELS.CUST_PROPS = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties"; var custregex = /<[^>]+>[^<]*/g; function parse_cust_props(data, opts) { var p = {}, name; var m = data.match(custregex); if (m) for (var i = 0; i != m.length; ++i) { var x = m[i], y = parsexmltag(x); switch (y[0]) { case "<?xml": break; case "<Properties": if (y.xmlns !== XMLNS.CUST_PROPS) throw "unrecognized xmlns " + y.xmlns; if (y.xmlnsvt && y.xmlnsvt !== XMLNS.vt) throw "unrecognized vt " + y.xmlnsvt; break; case "<property": name = y.name; break; case "</property>": name = null; break; default: if (x.indexOf("<vt:") === 0) { var toks = x.split(">"); var type = toks[0].substring(4), text = toks[1]; switch (type) { case "lpstr": case "lpwstr": case "bstr": case "lpwstr": p[name] = unescapexml(text); break; case "bool": p[name] = parsexmlbool(text, "<vt:bool>"); break; case "i1": case "i2": case "i4": case "i8": case "int": case "uint": p[name] = parseInt(text, 10); break; case "r4": case "r8": case "decimal": p[name] = parseFloat(text); break; case "filetime": case "date": p[name] = new Date(text); break; case "cy": case "error": p[name] = unescapexml(text); break; default: if (typeof console !== "undefined") console.warn("Unexpected", x, type, toks) } } else if (x.substr(0, 2) === "</") { } else if (opts.WTF) throw new Error(x) } } return p } var CUST_PROPS_XML_ROOT = writextag("Properties", null, { xmlns: XMLNS.CUST_PROPS, "xmlns:vt": XMLNS.vt }); function write_cust_props(cp, opts) { var o = [XML_HEADER, CUST_PROPS_XML_ROOT]; if (!cp) return o.join(""); var pid = 1; keys(cp).forEach(function custprop(k) { ++pid; o[o.length] = writextag("property", write_vt(cp[k]), { fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}", pid: pid, name: k }) }); if (o.length > 2) { o[o.length] = "</Properties>"; o[1] = o[1].replace("/>", ">") } return o.join("") } var CS2CP = { 0: 1252, 1: 65001, 2: 65001, 77: 1e4, 128: 932, 129: 949, 130: 1361, 134: 936, 136: 950, 161: 1253, 162: 1254, 163: 1258, 177: 1255, 178: 1256, 186: 1257, 204: 1251, 222: 874, 238: 1250, 255: 1252, 69: 6969 }; var parse_rs = function parse_rs_factory() { var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<r>/g, rend = /<\/r>/, nlregex = /\r\n/g; var parse_rpr = function parse_rpr(rpr, intro, outro) { var font = {}, cp = 65001; var m = rpr.match(tagregex), i = 0; if (m) for (; i != m.length; ++i) { var y = parsexmltag(m[i]); switch (y[0]) { case "<condense": break; case "<extend": break; case "<shadow": case "<shadow/>": break; case "<charset": if (y.val == "1") break; cp = CS2CP[parseInt(y.val, 10)]; break; case "<outline": case "<outline/>": break; case "<rFont": font.name = y.val; break; case "<sz": font.sz = y.val; break; case "<strike": if (!y.val) break; case "<strike/>": font.strike = 1; break; case "</strike>": break; case "<u": if (!y.val) break; case "<u/>": font.u = 1; break; case "</u>": break; case "<b": if (!y.val) break; case "<b/>": font.b = 1; break; case "</b>": break; case "<i": if (!y.val) break; case "<i/>": font.i = 1; break; case "</i>": break; case "<color": if (y.rgb) font.color = y.rgb.substr(2, 6); break; case "<family": font.family = y.val; break; case "<vertAlign": break; case "<scheme": break; default: if (y[0].charCodeAt(1) !== 47) throw "Unrecognized rich format " + y[0] } } var style = []; if (font.b) style.push("font-weight: bold;"); if (font.i) style.push("font-style: italic;"); intro.push('<span style="' + style.join("") + '">'); outro.push("</span>"); return cp }; function parse_r(r) { var terms = [[], "", []]; var t = r.match(tregex), cp = 65001; if (!isval(t)) return ""; terms[1] = t[1]; var rpr = r.match(rpregex); if (isval(rpr)) cp = parse_rpr(rpr[1], terms[0], terms[2]); return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("") } return function parse_rs(rs) { return rs.replace(rregex, "").split(rend).map(parse_r).join("") } }(); var sitregex = /<t[^>]*>([^<]*)<\/t>/g, sirregex = /<r>/; function parse_si(x, opts) { var html = opts ? opts.cellHTML : true; var z = {}; if (!x) return null; var y; if (x.charCodeAt(1) === 116) { z.t = utf8read(unescapexml(x.substr(x.indexOf(">") + 1).split(/<\/t>/)[0])); z.r = x; if (html) z.h = z.t } else if (y = x.match(sirregex)) { z.r = x; z.t = utf8read(unescapexml(x.match(sitregex).join("").replace(tagregex, ""))); if (html) z.h = parse_rs(x) } return z } var sstr0 = /<sst([^>]*)>([\s\S]*)<\/sst>/; var sstr1 = /<(?:si|sstItem)>/g; var sstr2 = /<\/(?:si|sstItem)>/; function parse_sst_xml(data, opts) { var s = [], ss; var sst = data.match(sstr0); if (isval(sst)) { ss = sst[2].replace(sstr1, "").split(sstr2); for (var i = 0; i != ss.length; ++i) { var o = parse_si(ss[i], opts); if (o != null) s[s.length] = o } sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount } return s } RELS.SST = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings"; var straywsregex = /^\s|\s$|[\t\n\r]/; function write_sst_xml(sst, opts) { if (!opts.bookSST) return ""; var o = [XML_HEADER]; o[o.length] = writextag("sst", null, { xmlns: XMLNS.main[0], count: sst.Count, uniqueCount: sst.Unique }); for (var i = 0; i != sst.length; ++i) { if (sst[i] == null) continue; var s = sst[i]; var sitag = "<si>"; if (s.r) sitag += s.r; else { sitag += "<t"; if (s.t.match(straywsregex)) sitag += ' xml:space="preserve"'; sitag += ">" + escapexml(s.t) + "</t>" } sitag += "</si>"; o[o.length] = sitag } if (o.length > 2) { o[o.length] = "</sst>"; o[1] = o[1].replace("/>", ">") } return o.join("") } function parse_BrtBeginSst(data, length) { return [data.read_shift(4), data.read_shift(4)] } function parse_sst_bin(data, opts) { var s = []; var pass = false; recordhopper(data, function hopper_sst(val, R, RT) { switch (R.n) { case "BrtBeginSst": s.Count = val[0]; s.Unique = val[1]; break; case "BrtSSTItem": s.push(val); break; case "BrtEndSst": return true; case "BrtFRTBegin": pass = true; break; case "BrtFRTEnd": pass = false; break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n) } }); return s } function write_BrtBeginSst(sst, o) { if (!o) o = new_buf(8); o.write_shift(4, sst.Count); o.write_shift(4, sst.Unique); return o } var write_BrtSSTItem = write_RichStr; function write_sst_bin(sst, opts) { var ba = buf_array(); write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst)); for (var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i])); write_record(ba, "BrtEndSst"); return ba.end() } function hex2RGB(h) { var o = h.substr(h[0] === "#" ? 1 : 0, 6); return [parseInt(o.substr(0, 2), 16), parseInt(o.substr(0, 2), 16), parseInt(o.substr(0, 2), 16)] } function rgb2Hex(rgb) { for (var i = 0, o = 1; i != 3; ++i) o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]); return o.toString(16).toUpperCase().substr(1) } function rgb2HSL(rgb) { var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255; var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m; if (C === 0) return [0, 0, R]; var H6 = 0, S = 0, L2 = M + m; S = C / (L2 > 1 ? 2 - L2 : L2); switch (M) { case R: H6 = ((G - B) / C + 6) % 6; break; case G: H6 = (B - R) / C + 2; break; case B: H6 = (R - G) / C + 4; break } return [H6 / 6, S, L2 / 2] } function hsl2RGB(hsl) { var H = hsl[0], S = hsl[1], L = hsl[2]; var C = S * 2 * (L < .5 ? L : 1 - L), m = L - C / 2; var rgb = [m, m, m], h6 = 6 * H; var X; if (S !== 0) switch (h6 | 0) { case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break; case 1: X = C * (2 - h6); rgb[0] += X; rgb[1] += C; break; case 2: X = C * (h6 - 2); rgb[1] += C; rgb[2] += X; break; case 3: X = C * (4 - h6); rgb[1] += X; rgb[2] += C; break; case 4: X = C * (h6 - 4); rgb[2] += C; rgb[0] += X; break; case 5: X = C * (6 - h6); rgb[2] += X; rgb[0] += C; break } for (var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i] * 255); return rgb } function rgb_tint(hex, tint) { if (tint === 0) return hex; var hsl = rgb2HSL(hex2RGB(hex)); if (tint < 0) hsl[2] = hsl[2] * (1 + tint); else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint); return rgb2Hex(hsl2RGB(hsl)) } var DEF_MDW = 7, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW; function width2px(width) { return (width + (128 / MDW | 0) / 256) * MDW | 0 } function px2char(px) { return ((px - 5) / MDW * 100 + .5 | 0) / 100 } function char2width(chr) { return ((chr * MDW + 5) / MDW * 256 | 0) / 256 } function cycle_width(collw) { return char2width(px2char(width2px(collw))) } function find_mdw(collw, coll) { if (cycle_width(collw) != collw) { for (MDW = DEF_MDW; MDW > MIN_MDW; --MDW) if (cycle_width(collw) === collw) break; if (MDW === MIN_MDW) for (MDW = DEF_MDW + 1; MDW < MAX_MDW; ++MDW) if (cycle_width(collw) === collw) break; if (MDW === MAX_MDW) MDW = DEF_MDW } } var styles = {}; var themes = {}; function parse_fills(t, opts) { styles.Fills = []; var fill = {}; t[0].match(tagregex).forEach(function (x) { var y = parsexmltag(x); switch (y[0]) { case "<fills": case "<fills>": case "</fills>": break; case "<fill>": break; case "</fill>": styles.Fills.push(fill); fill = {}; break; case "<patternFill": if (y.patternType) fill.patternType = y.patternType; break; case "<patternFill/>": case "</patternFill>": break; case "<bgColor": if (!fill.bgColor) fill.bgColor = {}; if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10); if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10); if (y.tint) fill.bgColor.tint = parseFloat(y.tint); if (y.rgb) fill.bgColor.rgb = y.rgb.substring(y.rgb.length - 6); break; case "<bgColor/>": case "</bgColor>": break; case "<fgColor": if (!fill.fgColor) fill.fgColor = {}; if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10); if (y.tint) fill.fgColor.tint = parseFloat(y.tint); if (y.rgb) fill.fgColor.rgb = y.rgb.substring(y.rgb.length - 6); break; case "<fgColor/>": case "</fgColor>": break; default: if (opts.WTF) throw "unrecognized " + y[0] + " in fills" } }) } function parse_numFmts(t, opts) { styles.NumberFmt = []; var k = keys(SSF._table); for (var i = 0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]]; var m = t[0].match(tagregex); for (i = 0; i < m.length; ++i) { var y = parsexmltag(m[i]); switch (y[0]) { case "<numFmts": case "</numFmts>": case "<numFmts/>": case "<numFmts>": break; case "<numFmt": { var f = unescapexml(utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10); styles.NumberFmt[j] = f; if (j > 0) SSF.load(f, j) } break; default: if (opts.WTF) throw "unrecognized " + y[0] + " in numFmts" } } } function write_numFmts(NF, opts) { var o = ["<numFmts>"];[[5, 8], [23, 26], [41, 44], [63, 66], [164, 392]].forEach(function (r) { for (var i = r[0]; i <= r[1]; ++i) if (NF[i] !== undefined) o[o.length] = writextag("numFmt", null, { numFmtId: i, formatCode: escapexml(NF[i]) }) }); if (o.length === 1) return ""; o[o.length] = "</numFmts>"; o[0] = writextag("numFmts", null, { count: o.length - 2 }).replace("/>", ">"); return o.join("") } function parse_cellXfs(t, opts) { styles.CellXf = []; t[0].match(tagregex).forEach(function (x) { var y = parsexmltag(x); switch (y[0]) { case "<cellXfs": case "<cellXfs>": case "<cellXfs/>": case "</cellXfs>": break; case "<xf": delete y[0]; if (y.numFmtId) y.numFmtId = parseInt(y.numFmtId, 10); if (y.fillId) y.fillId = parseInt(y.fillId, 10); styles.CellXf.push(y); break; case "</xf>": break; case "<alignment": case "<alignment/>": break; case "<protection": case "</protection>": case "<protection/>": break; case "<extLst": case "</extLst>": break; case "<ext": break; default: if (opts.WTF) throw "unrecognized " + y[0] + " in cellXfs" } }) } function write_cellXfs(cellXfs) { var o = []; o[o.length] = writextag("cellXfs", null); cellXfs.forEach(function (c) { o[o.length] = writextag("xf", null, c) }); o[o.length] = "</cellXfs>"; if (o.length === 2) return ""; o[0] = writextag("cellXfs", null, { count: o.length - 2 }).replace("/>", ">"); return o.join("") } var parse_sty_xml = function make_pstyx() { var numFmtRegex = /<numFmts([^>]*)>.*<\/numFmts>/; var cellXfRegex = /<cellXfs([^>]*)>.*<\/cellXfs>/; var fillsRegex = /<fills([^>]*)>.*<\/fills>/; return function parse_sty_xml(data, opts) { var t; if (t = data.match(numFmtRegex)) parse_numFmts(t, opts); if (t = data.match(fillsRegex)) parse_fills(t, opts); if (t = data.match(cellXfRegex)) parse_cellXfs(t, opts); return styles } }(); var STYLES_XML_ROOT = writextag("styleSheet", null, { xmlns: XMLNS.main[0], "xmlns:vt": XMLNS.vt }); RELS.STY = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/styles"; function write_sty_xml(wb, opts) { var o = [XML_HEADER, STYLES_XML_ROOT], w; if ((w = write_numFmts(wb.SSF)) != null) o[o.length] = w; o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>'; o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>'; o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>'; o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>'; if (w = write_cellXfs(opts.cellXfs)) o[o.length] = w; o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>'; o[o.length] = '<dxfs count="0"/>'; o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>'; if (o.length > 2) { o[o.length] = "</styleSheet>"; o[1] = o[1].replace("/>", ">") } return o.join("") } function parse_BrtFmt(data, length) { var ifmt = data.read_shift(2); var stFmtCode = parse_XLWideString(data, length - 2); return [ifmt, stFmtCode] } function parse_BrtFont(data, length) { var out = { flags: {} }; out.dyHeight = data.read_shift(2); out.grbit = parse_FontFlags(data, 2); out.bls = data.read_shift(2); out.sss = data.read_shift(2); out.uls = data.read_shift(1); out.bFamily = data.read_shift(1); out.bCharSet = data.read_shift(1); data.l++; out.brtColor = parse_BrtColor(data, 8); out.bFontScheme = data.read_shift(1); out.name = parse_XLWideString(data, length - 21); out.flags.Bold = out.bls === 700; out.flags.Italic = out.grbit.fItalic; out.flags.Strikeout = out.grbit.fStrikeout; out.flags.Outline = out.grbit.fOutline; out.flags.Shadow = out.grbit.fShadow; out.flags.Condense = out.grbit.fCondense; out.flags.Extend = out.grbit.fExtend; out.flags.Sub = out.sss & 2; out.flags.Sup = out.sss & 1; return out } function parse_BrtXF(data, length) { var ixfeParent = data.read_shift(2); var ifmt = data.read_shift(2); parsenoop(data, length - 4); return { ixfe: ixfeParent, ifmt: ifmt } } function parse_sty_bin(data, opts) { styles.NumberFmt = []; for (var y in SSF._table) styles.NumberFmt[y] = SSF._table[y]; styles.CellXf = []; var state = ""; var pass = false; recordhopper(data, function hopper_sty(val, R, RT) { switch (R.n) { case "BrtFmt": styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]); break; case "BrtFont": break; case "BrtKnownFonts": break; case "BrtFill": break; case "BrtBorder": break; case "BrtXF": if (state === "CELLXFS") { styles.CellXf.push(val) } break; case "BrtStyle": break; case "BrtDXF": break; case "BrtMRUColor": break; case "BrtIndexedColor": break; case "BrtBeginStyleSheet": break; case "BrtEndStyleSheet": break; case "BrtBeginTableStyle": break; case "BrtTableStyleElement": break; case "BrtEndTableStyle": break; case "BrtBeginFmts": state = "FMTS"; break; case "BrtEndFmts": state = ""; break; case "BrtBeginFonts": state = "FONTS"; break; case "BrtEndFonts": state = ""; break; case "BrtACBegin": state = "ACFONTS"; break; case "BrtACEnd": state = ""; break; case "BrtBeginFills": state = "FILLS"; break; case "BrtEndFills": state = ""; break; case "BrtBeginBorders": state = "BORDERS"; break; case "BrtEndBorders": state = ""; break; case "BrtBeginCellStyleXFs": state = "CELLSTYLEXFS"; break; case "BrtEndCellStyleXFs": state = ""; break; case "BrtBeginCellXFs": state = "CELLXFS"; break; case "BrtEndCellXFs": state = ""; break; case "BrtBeginStyles": state = "STYLES"; break; case "BrtEndStyles": state = ""; break; case "BrtBeginDXFs": state = "DXFS"; break; case "BrtEndDXFs": state = ""; break; case "BrtBeginTableStyles": state = "TABLESTYLES"; break; case "BrtEndTableStyles": state = ""; break; case "BrtBeginColorPalette": state = "COLORPALETTE"; break; case "BrtEndColorPalette": state = ""; break; case "BrtBeginIndexedColors": state = "INDEXEDCOLORS"; break; case "BrtEndIndexedColors": state = ""; break; case "BrtBeginMRUColors": state = "MRUCOLORS"; break; case "BrtEndMRUColors": state = ""; break; case "BrtFRTBegin": pass = true; break; case "BrtFRTEnd": pass = false; break; case "BrtBeginStyleSheetExt14": break; case "BrtBeginSlicerStyles": break; case "BrtEndSlicerStyles": break; case "BrtBeginTimelineStylesheetExt15": break; case "BrtEndTimelineStylesheetExt15": break; case "BrtBeginTimelineStyles": break; case "BrtEndTimelineStyles": break; case "BrtEndStyleSheetExt14": break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n) } }); return styles } function write_sty_bin(data, opts) { var ba = buf_array(); write_record(ba, "BrtBeginStyleSheet"); write_record(ba, "BrtEndStyleSheet"); return ba.end() } RELS.THEME = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/theme"; function parse_clrScheme(t, opts) { themes.themeElements.clrScheme = []; var color = {}; t[0].match(tagregex).forEach(function (x) { var y = parsexmltag(x); switch (y[0]) { case "<a:clrScheme": case "</a:clrScheme>": break; case "<a:srgbClr": color.rgb = y.val; break; case "<a:sysClr": color.rgb = y.lastClr; break; case "<a:dk1>": case "</a:dk1>": case "<a:dk2>": case "</a:dk2>": case "<a:lt1>": case "</a:lt1>": case "<a:lt2>": case "</a:lt2>": case "<a:accent1>": case "</a:accent1>": case "<a:accent2>": case "</a:accent2>": case "<a:accent3>": case "</a:accent3>": case "<a:accent4>": case "</a:accent4>": case "<a:accent5>": case "</a:accent5>": case "<a:accent6>": case "</a:accent6>": case "<a:hlink>": case "</a:hlink>": case "<a:folHlink>": case "</a:folHlink>": if (y[0][1] === "/") { themes.themeElements.clrScheme.push(color); color = {} } else { color.name = y[0].substring(3, y[0].length - 1) } break; default: if (opts.WTF) throw "unrecognized " + y[0] + " in clrScheme" } }) } function parse_fontScheme(t, opts) { } function parse_fmtScheme(t, opts) { } var clrsregex = /<a:clrScheme([^>]*)>[^\u2603]*<\/a:clrScheme>/; var fntsregex = /<a:fontScheme([^>]*)>[^\u2603]*<\/a:fontScheme>/; var fmtsregex = /<a:fmtScheme([^>]*)>[^\u2603]*<\/a:fmtScheme>/; function parse_themeElements(data, opts) { themes.themeElements = {}; var t;[["clrScheme", clrsregex, parse_clrScheme], ["fontScheme", fntsregex, parse_fontScheme], ["fmtScheme", fmtsregex, parse_fmtScheme]].forEach(function (m) { if (!(t = data.match(m[1]))) throw m[0] + " not found in themeElements"; m[2](t, opts) }) } var themeltregex = /<a:themeElements([^>]*)>[^\u2603]*<\/a:themeElements>/; function parse_theme_xml(data, opts) { if (!data || data.length === 0) return themes; var t; if (!(t = data.match(themeltregex))) throw "themeElements not found in theme"; parse_themeElements(t[0], opts); return themes } function write_theme() { return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="https://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>' } function parse_cc_xml(data, opts) { var d = []; var l = 0, i = 1; (data.match(tagregex) || []).forEach(function (x) { var y = parsexmltag(x); switch (y[0]) { case "<?xml": break; case "<calcChain": case "<calcChain>": case "</calcChain>": break; case "<c": delete y[0]; if (y.i) i = y.i; else y.i = i; d.push(y); break } }); return d } function write_cc_xml(data, opts) { } function parse_BrtCalcChainItem$(data, length) { var out = {}; out.i = data.read_shift(4); var cell = {}; cell.r = data.read_shift(4); cell.c = data.read_shift(4); out.r = encode_cell(cell); var flags = data.read_shift(1); if (flags & 2) out.l = "1"; if (flags & 8) out.a = "1"; return out } function parse_cc_bin(data, opts) { var out = []; var pass = false; recordhopper(data, function hopper_cc(val, R, RT) { switch (R.n) { case "BrtCalcChainItem$": out.push(val); break; case "BrtBeginCalcChain$": break; case "BrtEndCalcChain$": break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n) } }); return out } function write_cc_bin(data, opts) { } function parse_comments(zip, dirComments, sheets, sheetRels, opts) { for (var i = 0; i != dirComments.length; ++i) { var canonicalpath = dirComments[i]; var comments = parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//, ""), true), canonicalpath, opts); if (!comments || !comments.length) continue; var sheetNames = keys(sheets); for (var j = 0; j != sheetNames.length; ++j) { var sheetName = sheetNames[j]; var rels = sheetRels[sheetName]; if (rels) { var rel = rels[canonicalpath]; if (rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments) } } } } function insertCommentsIntoSheet(sheetName, sheet, comments) { comments.forEach(function (comment) { var cell = sheet[comment.ref]; if (!cell) { cell = {}; sheet[comment.ref] = cell; var range = safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1"); var thisCell = decode_cell(comment.ref); if (range.s.r > thisCell.r) range.s.r = thisCell.r; if (range.e.r < thisCell.r) range.e.r = thisCell.r; if (range.s.c > thisCell.c) range.s.c = thisCell.c; if (range.e.c < thisCell.c) range.e.c = thisCell.c; var encoded = encode_range(range); if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded } if (!cell.c) cell.c = []; var o = { a: comment.author, t: comment.t, r: comment.r }; if (comment.h) o.h = comment.h; cell.c.push(o) }) } function parse_comments_xml(data, opts) {
        if (data.match(/<(?:\w+:)?comments *\/>/)) return []; var authors = []; var commentList = []; data.match(/<(?:\w+:)?authors>([^\u2603]*)<\/(?:\w+:)?authors>/)[1].split(/<\/\w*:?author>/).forEach(function (x) { if (x === "" || x.trim() === "") return; authors.push(x.match(/<(?:\w+:)?author[^>]*>(.*)/)[1]) }); (data.match(/<(?:\w+:)?commentList>([^\u2603]*)<\/(?:\w+:)?commentList>/) || ["", ""])[1].split(/<\/\w*:?comment>/).forEach(function (x, index) {
            if (x === "" || x.trim() === "") return; var y = parsexmltag(x.match(/<(?:\w+:)?comment[^>]*>/)[0]); var comment = { author: y.authorId && authors[y.authorId] ? authors[y.authorId] : undefined, ref: y.ref, guid: y.guid };
            var cell = decode_cell(y.ref); if (opts.sheetRows && opts.sheetRows <= cell.r) return; var textMatch = x.match(/<text>([^\u2603]*)<\/text>/); if (!textMatch || !textMatch[1]) return; var rt = parse_si(textMatch[1]); comment.r = rt.r; comment.t = rt.t; if (opts.cellHTML) comment.h = rt.h; commentList.push(comment)
        }); return commentList
    } function write_comments_xml(data, opts) { } function parse_BrtBeginComment(data, length) { var out = {}; out.iauthor = data.read_shift(4); var rfx = parse_UncheckedRfX(data, 16); out.rfx = rfx.s; out.ref = encode_cell(rfx.s); data.l += 16; return out } var parse_BrtCommentAuthor = parse_XLWideString; var parse_BrtCommentText = parse_RichStr; function parse_comments_bin(data, opts) { var out = []; var authors = []; var c = {}; var pass = false; recordhopper(data, function hopper_cmnt(val, R, RT) { switch (R.n) { case "BrtCommentAuthor": authors.push(val); break; case "BrtBeginComment": c = val; break; case "BrtCommentText": c.t = val.t; c.h = val.h; c.r = val.r; break; case "BrtEndComment": c.author = authors[c.iauthor]; delete c.iauthor; if (opts.sheetRows && opts.sheetRows <= c.rfx.r) break; delete c.rfx; out.push(c); break; case "BrtBeginComments": break; case "BrtEndComments": break; case "BrtBeginCommentAuthors": break; case "BrtEndCommentAuthors": break; case "BrtBeginCommentList": break; case "BrtEndCommentList": break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n) } }); return out } function write_comments_bin(data, opts) { } function parse_CellParsedFormula(data, length) { var cce = data.read_shift(4); return parsenoop(data, length - 4) } var strs = {}; var _ssfopts = {}; RELS.WS = "https://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"; function get_sst_id(sst, str) { for (var i = 0, len = sst.length; i < len; ++i) if (sst[i].t === str) { sst.Count++; return i } sst[len] = { t: str }; sst.Count++; sst.Unique++; return len } function get_cell_style(styles, cell, opts) { var z = opts.revssf[cell.z != null ? cell.z : "General"]; for (var i = 0, len = styles.length; i != len; ++i) if (styles[i].numFmtId === z) return i; styles[len] = { numFmtId: z, fontId: 0, fillId: 0, borderId: 0, xfId: 0, applyNumberFormat: 1 }; return len } function safe_format(p, fmtid, fillid, opts) { try { if (p.t === "e") p.w = p.w || BErr[p.v]; else if (fmtid === 0) { if (p.t === "n") { if ((p.v | 0) === p.v) p.w = SSF._general_int(p.v, _ssfopts); else p.w = SSF._general_num(p.v, _ssfopts) } else if (p.t === "d") { var dd = datenum(p.v); if ((dd | 0) === dd) p.w = SSF._general_int(dd, _ssfopts); else p.w = SSF._general_num(dd, _ssfopts) } else if (p.v === undefined) return ""; else p.w = SSF._general(p.v, _ssfopts) } else if (p.t === "d") p.w = SSF.format(fmtid, datenum(p.v), _ssfopts); else p.w = SSF.format(fmtid, p.v, _ssfopts); if (opts.cellNF) p.z = SSF._table[fmtid] } catch (e) { if (opts.WTF) throw e } if (fillid) try { p.s = styles.Fills[fillid]; if (p.s.fgColor && p.s.fgColor.theme) { p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0); if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb } if (p.s.bgColor && p.s.bgColor.theme) { p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0); if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb } } catch (e) { if (opts.WTF) throw e } } function parse_ws_xml_dim(ws, s) { var d = safe_decode_range(s); if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = encode_range(d) } var mergecregex = /<mergeCell ref="[A-Z0-9:]+"\s*\/>/g; var sheetdataregex = /<(?:\w+:)?sheetData>([^\u2603]*)<\/(?:\w+:)?sheetData>/; var hlinkregex = /<hyperlink[^>]*\/>/g; var dimregex = /"(\w*:\w*)"/; var colregex = /<col[^>]*\/>/g; function parse_ws_xml(data, opts, rels) { if (!data) return data; var s = {}; var ridx = data.indexOf("<dimension"); if (ridx > 0) { var ref = data.substr(ridx, 50).match(dimregex); if (ref != null) parse_ws_xml_dim(s, ref[1]) } var mergecells = []; if (data.indexOf("</mergeCells>") !== -1) { var merges = data.match(mergecregex); for (ridx = 0; ridx != merges.length; ++ridx) mergecells[ridx] = safe_decode_range(merges[ridx].substr(merges[ridx].indexOf('"') + 1)) } var columns = []; if (opts.cellStyles && data.indexOf("</cols>") !== -1) { var cols = data.match(colregex); parse_ws_xml_cols(columns, cols) } var refguess = { s: { r: 1e6, c: 1e6 }, e: { r: 0, c: 0 } }; var mtch = data.match(sheetdataregex); if (mtch) parse_ws_xml_data(mtch[1], s, opts, refguess); if (data.indexOf("</hyperlinks>") !== -1) parse_ws_xml_hlinks(s, data.match(hlinkregex), rels); if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess); if (opts.sheetRows > 0 && s["!ref"]) { var tmpref = safe_decode_range(s["!ref"]); if (opts.sheetRows < +tmpref.e.r) { tmpref.e.r = opts.sheetRows - 1; if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r; if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r; if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c; if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c; s["!fullref"] = s["!ref"]; s["!ref"] = encode_range(tmpref) } } if (mergecells.length > 0) s["!merges"] = mergecells; if (columns.length > 0) s["!cols"] = columns; return s } function write_ws_xml_merges(merges) { if (merges.length == 0) return ""; var o = '<mergeCells count="' + merges.length + '">'; for (var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>'; return o + "</mergeCells>" } function parse_ws_xml_hlinks(s, data, rels) { for (var i = 0; i != data.length; ++i) { var val = parsexmltag(data[i], true); if (!val.ref) return; var rel = rels["!id"][val.id]; if (rel) { val.Target = rel.Target; if (val.location) val.Target += "#" + val.location; val.Rel = rel } var rng = safe_decode_range(val.ref); for (var R = rng.s.r; R <= rng.e.r; ++R) for (var C = rng.s.c; C <= rng.e.c; ++C) { var addr = encode_cell({ c: C, r: R }); if (!s[addr]) s[addr] = { t: "stub", v: undefined }; s[addr].l = val } } } function parse_ws_xml_cols(columns, cols) { var seencol = false; for (var coli = 0; coli != cols.length; ++coli) { var coll = parsexmltag(cols[coli], true); var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1; delete coll.min; delete coll.max; if (!seencol && coll.width) { seencol = true; find_mdw(+coll.width, coll) } if (coll.width) { coll.wpx = width2px(+coll.width); coll.wch = px2char(coll.wpx); coll.MDW = MDW } while (colm <= colM) columns[colm++] = coll } } function write_ws_xml_cols(ws, cols) { var o = ["<cols>"], col, width; for (var i = 0; i != cols.length; ++i) { if (!(col = cols[i])) continue; var p = { min: i + 1, max: i + 1 }; width = -1; if (col.wpx) width = px2char(col.wpx); else if (col.wch) width = col.wch; if (width > -1) { p.width = char2width(width); p.customWidth = 1 } o[o.length] = writextag("col", null, p) } o[o.length] = "</cols>"; return o.join("") } function write_ws_xml_cell(cell, ref, ws, opts, idx, wb) { if (cell.v === undefined) return ""; var vv = ""; var oldt = cell.t, oldv = cell.v; switch (cell.t) { case "b": vv = cell.v ? "1" : "0"; break; case "n": vv = "" + cell.v; break; case "e": vv = BErr[cell.v]; break; case "d": if (opts.cellDates) vv = new Date(cell.v).toISOString(); else { cell.t = "n"; vv = "" + (cell.v = datenum(cell.v)); if (typeof cell.z === "undefined") cell.z = SSF._table[14] } break; default: vv = cell.v; break } var v = writetag("v", escapexml(vv)), o = { r: ref }; var os = get_cell_style(opts.cellXfs, cell, opts); if (os !== 0) o.s = os; switch (cell.t) { case "n": break; case "d": o.t = "d"; break; case "b": o.t = "b"; break; case "e": o.t = "e"; break; default: if (opts.bookSST) { v = writetag("v", "" + get_sst_id(opts.Strings, cell.v)); o.t = "s"; break } o.t = "str"; break } if (cell.t != oldt) { cell.t = oldt; cell.v = oldv } return writextag("c", v, o) } var parse_ws_xml_data = function parse_ws_xml_data_factory() { var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/; var rregex = /r=["']([^"']*)["']/, isregex = /<is>([\S\s]*?)<\/is>/; var match_v = matchtag("v"), match_f = matchtag("f"); return function parse_ws_xml_data(sdata, s, opts, guess) { var ri = 0, x = "", cells = [], cref = [], idx = 0, i = 0, cc = 0, d = "", p; var tag, tagr = 0, tagc = 0; var sstr; var fmtid = 0, fillid = 0, do_format = Array.isArray(styles.CellXf), cf; for (var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) { x = marr[mt].trim(); var xlen = x.length; if (xlen === 0) continue; for (ri = 0; ri < xlen; ++ri) if (x.charCodeAt(ri) === 62) break; ++ri; tag = parsexmltag(x.substr(0, ri), true); tagr = typeof tag.r !== "undefined" ? parseInt(tag.r, 10) : tagr + 1; tagc = -1; if (opts.sheetRows && opts.sheetRows < tagr) continue; if (guess.s.r > tagr - 1) guess.s.r = tagr - 1; if (guess.e.r < tagr - 1) guess.e.r = tagr - 1; cells = x.substr(ri).split(cellregex); for (ri = typeof tag.r === "undefined" ? 0 : 1; ri != cells.length; ++ri) { x = cells[ri].trim(); if (x.length === 0) continue; cref = x.match(rregex); idx = ri; i = 0; cc = 0; x = "<c " + (x.substr(0, 1) == "<" ? ">" : "") + x; if (cref !== null && cref.length === 2) { idx = 0; d = cref[1]; for (i = 0; i != d.length; ++i) { if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break; idx = 26 * idx + cc } --idx; tagc = idx } else ++tagc; for (i = 0; i != x.length; ++i) if (x.charCodeAt(i) === 62) break; ++i; tag = parsexmltag(x.substr(0, i), true); if (!tag.r) tag.r = utils.encode_cell({ r: tagr - 1, c: tagc }); d = x.substr(i); p = { t: "" }; if ((cref = d.match(match_v)) !== null && cref[1] !== "") p.v = unescapexml(cref[1]); if (opts.cellFormula && (cref = d.match(match_f)) !== null) p.f = unescapexml(cref[1]); if (tag.t === undefined && p.v === undefined) { if (!opts.sheetStubs) continue; p.t = "stub" } else p.t = tag.t || "n"; if (guess.s.c > idx) guess.s.c = idx; if (guess.e.c < idx) guess.e.c = idx; switch (p.t) { case "n": p.v = parseFloat(p.v); break; case "s": sstr = strs[parseInt(p.v, 10)]; p.v = sstr.t; p.r = sstr.r; if (opts.cellHTML) p.h = sstr.h; break; case "str": p.t = "s"; p.v = p.v != null ? utf8read(p.v) : ""; if (opts.cellHTML) p.h = p.v; break; case "inlineStr": cref = d.match(isregex); p.t = "s"; if (cref !== null) { sstr = parse_si(cref[1]); p.v = sstr.t } else p.v = ""; break; case "b": p.v = parsexmlbool(p.v); break; case "d": if (!opts.cellDates) { p.v = datenum(p.v); p.t = "n" } break; case "e": p.w = p.v; p.v = RBErr[p.v]; break } fmtid = fillid = 0; if (do_format && tag.s !== undefined) { cf = styles.CellXf[tag.s]; if (cf != null) { if (cf.numFmtId != null) fmtid = cf.numFmtId; if (opts.cellStyles && cf.fillId != null) fillid = cf.fillId } } safe_format(p, fmtid, fillid, opts); s[tag.r] = p } } } }(); function write_ws_xml_data(ws, opts, idx, wb) { var o = [], r = [], range = safe_decode_range(ws["!ref"]), cell, ref, rr = "", cols = [], R, C; for (C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C); for (R = range.s.r; R <= range.e.r; ++R) { r = []; rr = encode_row(R); for (C = range.s.c; C <= range.e.c; ++C) { ref = cols[C] + rr; if (ws[ref] === undefined) continue; if ((cell = write_ws_xml_cell(ws[ref], ref, ws, opts, idx, wb)) != null) r.push(cell) } if (r.length > 0) o[o.length] = writextag("row", r.join(""), { r: rr }) } return o.join("") } var WS_XML_ROOT = writextag("worksheet", null, { xmlns: XMLNS.main[0], "xmlns:r": XMLNS.r }); function write_ws_xml(idx, opts, wb) { var o = [XML_HEADER, WS_XML_ROOT]; var s = wb.SheetNames[idx], sidx = 0, rdata = ""; var ws = wb.Sheets[s]; if (ws === undefined) ws = {}; var ref = ws["!ref"]; if (ref === undefined) ref = "A1"; o[o.length] = writextag("dimension", null, { ref: ref }); if (ws["!cols"] !== undefined && ws["!cols"].length > 0) o[o.length] = write_ws_xml_cols(ws, ws["!cols"]); o[sidx = o.length] = "<sheetData/>"; if (ws["!ref"] !== undefined) { rdata = write_ws_xml_data(ws, opts, idx, wb); if (rdata.length > 0) o[o.length] = rdata } if (o.length > sidx + 1) { o[o.length] = "</sheetData>"; o[sidx] = o[sidx].replace("/>", ">") } if (ws["!merges"] !== undefined && ws["!merges"].length > 0) o[o.length] = write_ws_xml_merges(ws["!merges"]); if (o.length > 2) { o[o.length] = "</worksheet>"; o[1] = o[1].replace("/>", ">") } return o.join("") } function parse_BrtRowHdr(data, length) { var z = []; z.r = data.read_shift(4); data.l += length - 4; return z } var parse_BrtWsDim = parse_UncheckedRfX; var write_BrtWsDim = write_UncheckedRfX; function parse_BrtWsProp(data, length) { var z = {}; data.l += 19; z.name = parse_CodeName(data, length - 19); return z } function parse_BrtCellBlank(data, length) { var cell = parse_Cell(data); return [cell] } function write_BrtCellBlank(cell, val, o) { if (o == null) o = new_buf(8); return write_Cell(val, o) } function parse_BrtCellBool(data, length) { var cell = parse_Cell(data); var fBool = data.read_shift(1); return [cell, fBool, "b"] } function parse_BrtCellError(data, length) { var cell = parse_Cell(data); var fBool = data.read_shift(1); return [cell, fBool, "e"] } function parse_BrtCellIsst(data, length) { var cell = parse_Cell(data); var isst = data.read_shift(4); return [cell, isst, "s"] } function parse_BrtCellReal(data, length) { var cell = parse_Cell(data); var value = parse_Xnum(data); return [cell, value, "n"] } function parse_BrtCellRk(data, length) { var cell = parse_Cell(data); var value = parse_RkNumber(data); return [cell, value, "n"] } function parse_BrtCellSt(data, length) { var cell = parse_Cell(data); var value = parse_XLWideString(data); return [cell, value, "str"] } function parse_BrtFmlaBool(data, length, opts) { var cell = parse_Cell(data); var value = data.read_shift(1); var o = [cell, value, "b"]; if (opts.cellFormula) { var formula = parse_CellParsedFormula(data, length - 9); o[3] = "" } else data.l += length - 9; return o } function parse_BrtFmlaError(data, length, opts) { var cell = parse_Cell(data); var value = data.read_shift(1); var o = [cell, value, "e"]; if (opts.cellFormula) { var formula = parse_CellParsedFormula(data, length - 9); o[3] = "" } else data.l += length - 9; return o } function parse_BrtFmlaNum(data, length, opts) { var cell = parse_Cell(data); var value = parse_Xnum(data); var o = [cell, value, "n"]; if (opts.cellFormula) { var formula = parse_CellParsedFormula(data, length - 16); o[3] = "" } else data.l += length - 16; return o } function parse_BrtFmlaString(data, length, opts) { var start = data.l; var cell = parse_Cell(data); var value = parse_XLWideString(data); var o = [cell, value, "str"]; if (opts.cellFormula) { var formula = parse_CellParsedFormula(data, start + length - data.l) } else data.l = start + length; return o } var parse_BrtMergeCell = parse_UncheckedRfX; function parse_BrtHLink(data, length, opts) { var end = data.l + length; var rfx = parse_UncheckedRfX(data, 16); var relId = parse_XLNullableWideString(data); var loc = parse_XLWideString(data); var tooltip = parse_XLWideString(data); var display = parse_XLWideString(data); data.l = end; return { rfx: rfx, relId: relId, loc: loc, tooltip: tooltip, display: display } } function parse_ws_bin(data, opts, rels) { if (!data) return data; if (!rels) rels = { "!id": {} }; var s = {}; var ref; var refguess = { s: { r: 1e6, c: 1e6 }, e: { r: 0, c: 0 } }; var pass = false, end = false; var row, p, cf, R, C, addr, sstr, rr; var mergecells = []; recordhopper(data, function ws_parse(val, R) { if (end) return; switch (R.n) { case "BrtWsDim": ref = val; break; case "BrtRowHdr": row = val; if (opts.sheetRows && opts.sheetRows <= row.r) end = true; rr = encode_row(row.r); break; case "BrtFmlaBool": case "BrtFmlaError": case "BrtFmlaNum": case "BrtFmlaString": case "BrtCellBool": case "BrtCellError": case "BrtCellIsst": case "BrtCellReal": case "BrtCellRk": case "BrtCellSt": p = { t: val[2] }; switch (val[2]) { case "n": p.v = val[1]; break; case "s": sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break; case "b": p.v = val[1] ? true : false; break; case "e": p.v = val[1]; p.w = BErr[p.v]; break; case "str": p.t = "s"; p.v = utf8read(val[1]); break } if (opts.cellFormula && val.length > 3) p.f = val[3]; if (cf = styles.CellXf[val[0].iStyleRef]) safe_format(p, cf.ifmt, null, opts); s[encode_col(C = val[0].c) + rr] = p; if (refguess.s.r > row.r) refguess.s.r = row.r; if (refguess.s.c > C) refguess.s.c = C; if (refguess.e.r < row.r) refguess.e.r = row.r; if (refguess.e.c < C) refguess.e.c = C; break; case "BrtCellBlank": if (!opts.sheetStubs) break; p = { t: "s", v: undefined }; s[encode_col(C = val[0].c) + rr] = p; if (refguess.s.r > row.r) refguess.s.r = row.r; if (refguess.s.c > C) refguess.s.c = C; if (refguess.e.r < row.r) refguess.e.r = row.r; if (refguess.e.c < C) refguess.e.c = C; break; case "BrtBeginMergeCells": break; case "BrtEndMergeCells": break; case "BrtMergeCell": mergecells.push(val); break; case "BrtHLink": var rel = rels["!id"][val.relId]; if (rel) { val.Target = rel.Target; if (val.loc) val.Target += "#" + val.loc; val.Rel = rel } for (R = val.rfx.s.r; R <= val.rfx.e.r; ++R) for (C = val.rfx.s.c; C <= val.rfx.e.c; ++C) { addr = encode_cell({ c: C, r: R }); if (!s[addr]) s[addr] = { t: "s", v: undefined }; s[addr].l = val } break; case "BrtArrFmla": break; case "BrtShrFmla": break; case "BrtBeginSheet": break; case "BrtWsProp": break; case "BrtSheetCalcProp": break; case "BrtBeginWsViews": break; case "BrtBeginWsView": break; case "BrtPane": break; case "BrtSel": break; case "BrtEndWsView": break; case "BrtEndWsViews": break; case "BrtACBegin": break; case "BrtRwDescent": break; case "BrtACEnd": break; case "BrtWsFmtInfoEx14": break; case "BrtWsFmtInfo": break; case "BrtBeginColInfos": break; case "BrtColInfo": break; case "BrtEndColInfos": break; case "BrtBeginSheetData": break; case "BrtEndSheetData": break; case "BrtSheetProtection": break; case "BrtPrintOptions": break; case "BrtMargins": break; case "BrtPageSetup": break; case "BrtFRTBegin": pass = true; break; case "BrtFRTEnd": pass = false; break; case "BrtEndSheet": break; case "BrtDrawing": break; case "BrtLegacyDrawing": break; case "BrtLegacyDrawingHF": break; case "BrtPhoneticInfo": break; case "BrtBeginHeaderFooter": break; case "BrtEndHeaderFooter": break; case "BrtBrk": break; case "BrtBeginRwBrk": break; case "BrtEndRwBrk": break; case "BrtBeginColBrk": break; case "BrtEndColBrk": break; case "BrtBeginUserShViews": break; case "BrtBeginUserShView": break; case "BrtEndUserShView": break; case "BrtEndUserShViews": break; case "BrtBkHim": break; case "BrtBeginOleObjects": break; case "BrtOleObject": break; case "BrtEndOleObjects": break; case "BrtBeginListParts": break; case "BrtListPart": break; case "BrtEndListParts": break; case "BrtBeginSortState": break; case "BrtBeginSortCond": break; case "BrtEndSortCond": break; case "BrtEndSortState": break; case "BrtBeginConditionalFormatting": break; case "BrtEndConditionalFormatting": break; case "BrtBeginCFRule": break; case "BrtEndCFRule": break; case "BrtBeginDVals": break; case "BrtDVal": break; case "BrtEndDVals": break; case "BrtRangeProtection": break; case "BrtBeginDCon": break; case "BrtEndDCon": break; case "BrtBeginDRefs": break; case "BrtDRef": break; case "BrtEndDRefs": break; case "BrtBeginActiveXControls": break; case "BrtActiveX": break; case "BrtEndActiveXControls": break; case "BrtBeginAFilter": break; case "BrtEndAFilter": break; case "BrtBeginFilterColumn": break; case "BrtBeginFilters": break; case "BrtFilter": break; case "BrtEndFilters": break; case "BrtEndFilterColumn": break; case "BrtDynamicFilter": break; case "BrtTop10Filter": break; case "BrtBeginCustomFilters": break; case "BrtCustomFilter": break; case "BrtEndCustomFilters": break; case "BrtBeginSmartTags": break; case "BrtBeginCellSmartTags": break; case "BrtBeginCellSmartTag": break; case "BrtCellSmartTagProperty": break; case "BrtEndCellSmartTag": break; case "BrtEndCellSmartTags": break; case "BrtEndSmartTags": break; case "BrtBeginCellWatches": break; case "BrtCellWatch": break; case "BrtEndCellWatches": break; case "BrtTable": break; case "BrtBeginCellIgnoreECs": break; case "BrtCellIgnoreEC": break; case "BrtEndCellIgnoreECs": break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + R.n) } }, opts); if (!s["!ref"] && (refguess.s.r < 1e6 || ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0)) s["!ref"] = encode_range(ref); if (opts.sheetRows && s["!ref"]) { var tmpref = safe_decode_range(s["!ref"]); if (opts.sheetRows < +tmpref.e.r) { tmpref.e.r = opts.sheetRows - 1; if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r; if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r; if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c; if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c; s["!fullref"] = s["!ref"]; s["!ref"] = encode_range(tmpref) } } if (mergecells.length > 0) s["!merges"] = mergecells; return s } function write_ws_bin_cell(ba, cell, R, C, opts) { if (cell.v === undefined) return ""; var vv = ""; switch (cell.t) { case "b": vv = cell.v ? "1" : "0"; break; case "n": case "e": vv = "" + cell.v; break; default: vv = cell.v; break } var o = { r: R, c: C }; o.s = get_cell_style(opts.cellXfs, cell, opts); switch (cell.t) { case "s": case "str": if (opts.bookSST) { vv = get_sst_id(opts.Strings, cell.v); o.t = "s"; break } o.t = "str"; break; case "n": break; case "b": o.t = "b"; break; case "e": o.t = "e"; break } write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o)) } function write_CELLTABLE(ba, ws, idx, opts, wb) { var range = safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols = []; write_record(ba, "BrtBeginSheetData"); for (var R = range.s.r; R <= range.e.r; ++R) { rr = encode_row(R); for (var C = range.s.c; C <= range.e.c; ++C) { if (R === range.s.r) cols[C] = encode_col(C); ref = cols[C] + rr; if (!ws[ref]) continue; write_ws_bin_cell(ba, ws[ref], R, C, opts) } } write_record(ba, "BrtEndSheetData") } function write_ws_bin(idx, opts, wb) { var ba = buf_array(); var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {}; var r = safe_decode_range(ws["!ref"] || "A1"); write_record(ba, "BrtBeginSheet"); write_record(ba, "BrtWsDim", write_BrtWsDim(r)); write_CELLTABLE(ba, ws, idx, opts, wb); write_record(ba, "BrtEndSheet"); return ba.end() } var WBPropsDef = [["allowRefreshQuery", "0"], ["autoCompressPictures", "1"], ["backupFile", "0"], ["checkCompatibility", "0"], ["codeName", ""], ["date1904", "0"], ["dateCompatibility", "1"], ["filterPrivacy", "0"], ["hidePivotFieldList", "0"], ["promptedSolutions", "0"], ["publishItems", "0"], ["refreshAllConnections", false], ["saveExternalLinkValues", "1"], ["showBorderUnselectedTables", "1"], ["showInkAnnotation", "1"], ["showObjects", "all"], ["showPivotChartFilter", "0"]]; var WBViewDef = [["activeTab", "0"], ["autoFilterDateGrouping", "1"], ["firstSheet", "0"], ["minimized", "0"], ["showHorizontalScroll", "1"], ["showSheetTabs", "1"], ["showVerticalScroll", "1"], ["tabRatio", "600"], ["visibility", "visible"]]; var SheetDef = [["state", "visible"]]; var CalcPrDef = [["calcCompleted", "true"], ["calcMode", "auto"], ["calcOnSave", "true"], ["concurrentCalc", "true"], ["fullCalcOnLoad", "false"], ["fullPrecision", "true"], ["iterate", "false"], ["iterateCount", "100"], ["iterateDelta", "0.001"], ["refMode", "A1"]]; var CustomWBViewDef = [["autoUpdate", "false"], ["changesSavedWin", "false"], ["includeHiddenRowCol", "true"], ["includePrintSettings", "true"], ["maximized", "false"], ["minimized", "false"], ["onlySync", "false"], ["personalView", "false"], ["showComments", "commIndicator"], ["showFormulaBar", "true"], ["showHorizontalScroll", "true"], ["showObjects", "all"], ["showSheetTabs", "true"], ["showStatusbar", "true"], ["showVerticalScroll", "true"], ["tabRatio", "600"], ["xWindow", "0"], ["yWindow", "0"]]; function push_defaults_array(target, defaults) { for (var j = 0; j != target.length; ++j) { var w = target[j]; for (var i = 0; i != defaults.length; ++i) { var z = defaults[i]; if (w[z[0]] == null) w[z[0]] = z[1] } } } function push_defaults(target, defaults) { for (var i = 0; i != defaults.length; ++i) { var z = defaults[i]; if (target[z[0]] == null) target[z[0]] = z[1] } } function parse_wb_defaults(wb) { push_defaults(wb.WBProps, WBPropsDef); push_defaults(wb.CalcPr, CalcPrDef); push_defaults_array(wb.WBView, WBViewDef); push_defaults_array(wb.Sheets, SheetDef); _ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904, "date1904") } var wbnsregex = /<\w+:workbook/; function parse_wb_xml(data, opts) { var wb = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }; var pass = false, xmlns = "xmlns"; data.match(tagregex).forEach(function xml_wb(x) { var y = parsexmltag(x); switch (strip_ns(y[0])) { case "<?xml": break; case "<workbook": if (x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1]; wb.xmlns = y[xmlns]; break; case "</workbook>": break; case "<fileVersion": delete y[0]; wb.AppVersion = y; break; case "<fileVersion/>": break; case "<fileSharing": case "<fileSharing/>": break; case "<workbookPr": delete y[0]; wb.WBProps = y; break; case "<workbookPr/>": delete y[0]; wb.WBProps = y; break; case "<workbookProtection": break; case "<workbookProtection/>": break; case "<bookViews>": case "</bookViews>": break; case "<workbookView": delete y[0]; wb.WBView.push(y); break; case "<sheets>": case "</sheets>": break; case "<sheet": delete y[0]; y.name = utf8read(y.name); wb.Sheets.push(y); break; case "<functionGroups": case "<functionGroups/>": break; case "<functionGroup": break; case "<externalReferences": case "</externalReferences>": case "<externalReferences>": break; case "<externalReference": break; case "<definedNames/>": break; case "<definedNames>": case "<definedNames": pass = true; break; case "</definedNames>": pass = false; break; case "<definedName": case "<definedName/>": case "</definedName>": break; case "<calcPr": delete y[0]; wb.CalcPr = y; break; case "<calcPr/>": delete y[0]; wb.CalcPr = y; break; case "<oleSize": break; case "<customWorkbookViews>": case "</customWorkbookViews>": case "<customWorkbookViews": break; case "<customWorkbookView": case "</customWorkbookView>": break; case "<pivotCaches>": case "</pivotCaches>": case "<pivotCaches": break; case "<pivotCache": break; case "<smartTagPr": case "<smartTagPr/>": break; case "<smartTagTypes": case "<smartTagTypes>": case "</smartTagTypes>": break; case "<smartTagType": break; case "<webPublishing": case "<webPublishing/>": break; case "<fileRecoveryPr": case "<fileRecoveryPr/>": break; case "<webPublishObjects>": case "<webPublishObjects": case "</webPublishObjects>": break; case "<webPublishObject": break; case "<extLst>": case "</extLst>": case "<extLst/>": break; case "<ext": pass = true; break; case "</ext>": pass = false; break; case "<ArchID": break; case "<AlternateContent": pass = true; break; case "</AlternateContent>": pass = false; break; default: if (!pass && opts.WTF) throw "unrecognized " + y[0] + " in workbook" } }); if (XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns); parse_wb_defaults(wb); return wb } var WB_XML_ROOT = writextag("workbook", null, { xmlns: XMLNS.main[0], "xmlns:r": XMLNS.r }); function safe1904(wb) { try { return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false" } catch (e) { return "false" } } function write_wb_xml(wb, opts) { var o = [XML_HEADER]; o[o.length] = WB_XML_ROOT; o[o.length] = writextag("workbookPr", null, { date1904: safe1904(wb) }); o[o.length] = "<sheets>"; for (var i = 0; i != wb.SheetNames.length; ++i) o[o.length] = writextag("sheet", null, { name: wb.SheetNames[i].substr(0, 31), sheetId: "" + (i + 1), "r:id": "rId" + (i + 1) }); o[o.length] = "</sheets>"; if (o.length > 2) { o[o.length] = "</workbook>"; o[1] = o[1].replace("/>", ">") } return o.join("") } function parse_BrtBundleSh(data, length) { var z = {}; z.hsState = data.read_shift(4); z.iTabID = data.read_shift(4); z.strRelID = parse_RelID(data, length - 8); z.name = parse_XLWideString(data); return z } function write_BrtBundleSh(data, o) { if (!o) o = new_buf(127); o.write_shift(4, data.hsState); o.write_shift(4, data.iTabID); write_RelID(data.strRelID, o); write_XLWideString(data.name.substr(0, 31), o); return o } function parse_BrtWbProp(data, length) { data.read_shift(4); var dwThemeVersion = data.read_shift(4); var strName = length > 8 ? parse_XLWideString(data) : ""; return [dwThemeVersion, strName] } function write_BrtWbProp(data, o) { if (!o) o = new_buf(8); o.write_shift(4, 0); o.write_shift(4, 0); return o } function parse_BrtFRTArchID$(data, length) { var o = {}; data.read_shift(4); o.ArchID = data.read_shift(4); data.l += length - 8; return o } function parse_wb_bin(data, opts) { var wb = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }; var pass = false, z; recordhopper(data, function hopper_wb(val, R) { switch (R.n) { case "BrtBundleSh": wb.Sheets.push(val); break; case "BrtBeginBook": break; case "BrtFileVersion": break; case "BrtWbProp": break; case "BrtACBegin": break; case "BrtAbsPath15": break; case "BrtACEnd": break; case "BrtWbFactoid": break; case "BrtBookProtection": break; case "BrtBeginBookViews": break; case "BrtBookView": break; case "BrtEndBookViews": break; case "BrtBeginBundleShs": break; case "BrtEndBundleShs": break; case "BrtBeginFnGroup": break; case "BrtEndFnGroup": break; case "BrtBeginExternals": break; case "BrtSupSelf": break; case "BrtSupBookSrc": break; case "BrtExternSheet": break; case "BrtEndExternals": break; case "BrtName": break; case "BrtCalcProp": break; case "BrtUserBookView": break; case "BrtBeginPivotCacheIDs": break; case "BrtBeginPivotCacheID": break; case "BrtEndPivotCacheID": break; case "BrtEndPivotCacheIDs": break; case "BrtWebOpt": break; case "BrtFileRecover": break; case "BrtFileSharing": break; case "BrtBeginSmartTagTypes": break; case "BrtSmartTagType": break; case "BrtEndSmartTagTypes": break; case "BrtFRTBegin": pass = true; break; case "BrtFRTArchID$": break; case "BrtWorkBookPr15": break; case "BrtFRTEnd": pass = false; break; case "BrtEndBook": break; default: if (!pass || opts.WTF) throw new Error("Unexpected record " + R.n) } }); parse_wb_defaults(wb); return wb } function write_BUNDLESHS(ba, wb, opts) { write_record(ba, "BrtBeginBundleShs"); for (var idx = 0; idx != wb.SheetNames.length; ++idx) { var d = { hsState: 0, iTabID: idx + 1, strRelID: "rId" + (idx + 1), name: wb.SheetNames[idx] }; write_record(ba, "BrtBundleSh", write_BrtBundleSh(d)) } write_record(ba, "BrtEndBundleShs") } function write_BrtFileVersion(data, o) { if (!o) o = new_buf(127); for (var i = 0; i != 4; ++i) o.write_shift(4, 0); write_XLWideString("SheetJS", o); write_XLWideString(XLSX.version, o); write_XLWideString(XLSX.version, o); write_XLWideString("7262", o); o.length = o.l; return o } function write_BOOKVIEWS(ba, wb, opts) { write_record(ba, "BrtBeginBookViews"); write_record(ba, "BrtEndBookViews") } function write_BrtCalcProp(data, o) { if (!o) o = new_buf(26); o.write_shift(4, 0); o.write_shift(4, 1); o.write_shift(4, 0); write_Xnum(0, o); o.write_shift(-4, 1023); o.write_shift(1, 51); o.write_shift(1, 0); return o } function write_BrtFileRecover(data, o) { if (!o) o = new_buf(1); o.write_shift(1, 0); return o } function write_wb_bin(wb, opts) { var ba = buf_array(); write_record(ba, "BrtBeginBook"); write_record(ba, "BrtFileVersion", write_BrtFileVersion()); write_record(ba, "BrtWbProp", write_BrtWbProp()); write_BOOKVIEWS(ba, wb, opts); write_BUNDLESHS(ba, wb, opts); write_record(ba, "BrtCalcProp", write_BrtCalcProp()); write_record(ba, "BrtFileRecover", write_BrtFileRecover()); write_record(ba, "BrtEndBook"); return ba.end() } function parse_wb(data, name, opts) { return (name.substr(-4) === ".bin" ? parse_wb_bin : parse_wb_xml)(data, opts) } function parse_ws(data, name, opts, rels) { return (name.substr(-4) === ".bin" ? parse_ws_bin : parse_ws_xml)(data, opts, rels) } function parse_sty(data, name, opts) { return (name.substr(-4) === ".bin" ? parse_sty_bin : parse_sty_xml)(data, opts) } function parse_theme(data, name, opts) { return parse_theme_xml(data, opts) } function parse_sst(data, name, opts) { return (name.substr(-4) === ".bin" ? parse_sst_bin : parse_sst_xml)(data, opts) } function parse_cmnt(data, name, opts) { return (name.substr(-4) === ".bin" ? parse_comments_bin : parse_comments_xml)(data, opts) } function parse_cc(data, name, opts) { return (name.substr(-4) === ".bin" ? parse_cc_bin : parse_cc_xml)(data, opts) } function write_wb(wb, name, opts) { return (name.substr(-4) === ".bin" ? write_wb_bin : write_wb_xml)(wb, opts) } function write_ws(data, name, opts, wb) { return (name.substr(-4) === ".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb) } function write_sty(data, name, opts) { return (name.substr(-4) === ".bin" ? write_sty_bin : write_sty_xml)(data, opts) } function write_sst(data, name, opts) { return (name.substr(-4) === ".bin" ? write_sst_bin : write_sst_xml)(data, opts) } var RecordEnum = { 0: { n: "BrtRowHdr", f: parse_BrtRowHdr }, 1: { n: "BrtCellBlank", f: parse_BrtCellBlank }, 2: { n: "BrtCellRk", f: parse_BrtCellRk }, 3: { n: "BrtCellError", f: parse_BrtCellError }, 4: { n: "BrtCellBool", f: parse_BrtCellBool }, 5: { n: "BrtCellReal", f: parse_BrtCellReal }, 6: { n: "BrtCellSt", f: parse_BrtCellSt }, 7: { n: "BrtCellIsst", f: parse_BrtCellIsst }, 8: { n: "BrtFmlaString", f: parse_BrtFmlaString }, 9: { n: "BrtFmlaNum", f: parse_BrtFmlaNum }, 10: { n: "BrtFmlaBool", f: parse_BrtFmlaBool }, 11: { n: "BrtFmlaError", f: parse_BrtFmlaError }, 16: { n: "BrtFRTArchID$", f: parse_BrtFRTArchID$ }, 19: { n: "BrtSSTItem", f: parse_RichStr }, 20: { n: "BrtPCDIMissing", f: parsenoop }, 21: { n: "BrtPCDINumber", f: parsenoop }, 22: { n: "BrtPCDIBoolean", f: parsenoop }, 23: { n: "BrtPCDIError", f: parsenoop }, 24: { n: "BrtPCDIString", f: parsenoop }, 25: { n: "BrtPCDIDatetime", f: parsenoop }, 26: { n: "BrtPCDIIndex", f: parsenoop }, 27: { n: "BrtPCDIAMissing", f: parsenoop }, 28: { n: "BrtPCDIANumber", f: parsenoop }, 29: { n: "BrtPCDIABoolean", f: parsenoop }, 30: { n: "BrtPCDIAError", f: parsenoop }, 31: { n: "BrtPCDIAString", f: parsenoop }, 32: { n: "BrtPCDIADatetime", f: parsenoop }, 33: { n: "BrtPCRRecord", f: parsenoop }, 34: { n: "BrtPCRRecordDt", f: parsenoop }, 35: { n: "BrtFRTBegin", f: parsenoop }, 36: { n: "BrtFRTEnd", f: parsenoop }, 37: { n: "BrtACBegin", f: parsenoop }, 38: { n: "BrtACEnd", f: parsenoop }, 39: { n: "BrtName", f: parsenoop }, 40: { n: "BrtIndexRowBlock", f: parsenoop }, 42: { n: "BrtIndexBlock", f: parsenoop }, 43: { n: "BrtFont", f: parse_BrtFont }, 44: { n: "BrtFmt", f: parse_BrtFmt }, 45: { n: "BrtFill", f: parsenoop }, 46: { n: "BrtBorder", f: parsenoop }, 47: { n: "BrtXF", f: parse_BrtXF }, 48: { n: "BrtStyle", f: parsenoop }, 49: { n: "BrtCellMeta", f: parsenoop }, 50: { n: "BrtValueMeta", f: parsenoop }, 51: { n: "BrtMdb", f: parsenoop }, 52: { n: "BrtBeginFmd", f: parsenoop }, 53: { n: "BrtEndFmd", f: parsenoop }, 54: { n: "BrtBeginMdx", f: parsenoop }, 55: { n: "BrtEndMdx", f: parsenoop }, 56: { n: "BrtBeginMdxTuple", f: parsenoop }, 57: { n: "BrtEndMdxTuple", f: parsenoop }, 58: { n: "BrtMdxMbrIstr", f: parsenoop }, 59: { n: "BrtStr", f: parsenoop }, 60: { n: "BrtColInfo", f: parsenoop }, 62: { n: "BrtCellRString", f: parsenoop }, 63: { n: "BrtCalcChainItem$", f: parse_BrtCalcChainItem$ }, 64: { n: "BrtDVal", f: parsenoop }, 65: { n: "BrtSxvcellNum", f: parsenoop }, 66: { n: "BrtSxvcellStr", f: parsenoop }, 67: { n: "BrtSxvcellBool", f: parsenoop }, 68: { n: "BrtSxvcellErr", f: parsenoop }, 69: { n: "BrtSxvcellDate", f: parsenoop }, 70: { n: "BrtSxvcellNil", f: parsenoop }, 128: { n: "BrtFileVersion", f: parsenoop }, 129: { n: "BrtBeginSheet", f: parsenoop }, 130: { n: "BrtEndSheet", f: parsenoop }, 131: { n: "BrtBeginBook", f: parsenoop, p: 0 }, 132: { n: "BrtEndBook", f: parsenoop }, 133: { n: "BrtBeginWsViews", f: parsenoop }, 134: { n: "BrtEndWsViews", f: parsenoop }, 135: { n: "BrtBeginBookViews", f: parsenoop }, 136: { n: "BrtEndBookViews", f: parsenoop }, 137: { n: "BrtBeginWsView", f: parsenoop }, 138: { n: "BrtEndWsView", f: parsenoop }, 139: { n: "BrtBeginCsViews", f: parsenoop }, 140: { n: "BrtEndCsViews", f: parsenoop }, 141: { n: "BrtBeginCsView", f: parsenoop }, 142: { n: "BrtEndCsView", f: parsenoop }, 143: { n: "BrtBeginBundleShs", f: parsenoop }, 144: { n: "BrtEndBundleShs", f: parsenoop }, 145: { n: "BrtBeginSheetData", f: parsenoop }, 146: { n: "BrtEndSheetData", f: parsenoop }, 147: { n: "BrtWsProp", f: parse_BrtWsProp }, 148: { n: "BrtWsDim", f: parse_BrtWsDim, p: 16 }, 151: { n: "BrtPane", f: parsenoop }, 152: { n: "BrtSel", f: parsenoop }, 153: { n: "BrtWbProp", f: parse_BrtWbProp }, 154: { n: "BrtWbFactoid", f: parsenoop }, 155: { n: "BrtFileRecover", f: parsenoop }, 156: { n: "BrtBundleSh", f: parse_BrtBundleSh }, 157: { n: "BrtCalcProp", f: parsenoop }, 158: { n: "BrtBookView", f: parsenoop }, 159: { n: "BrtBeginSst", f: parse_BrtBeginSst }, 160: { n: "BrtEndSst", f: parsenoop }, 161: { n: "BrtBeginAFilter", f: parsenoop }, 162: { n: "BrtEndAFilter", f: parsenoop }, 163: { n: "BrtBeginFilterColumn", f: parsenoop }, 164: { n: "BrtEndFilterColumn", f: parsenoop }, 165: { n: "BrtBeginFilters", f: parsenoop }, 166: { n: "BrtEndFilters", f: parsenoop }, 167: { n: "BrtFilter", f: parsenoop }, 168: { n: "BrtColorFilter", f: parsenoop }, 169: { n: "BrtIconFilter", f: parsenoop }, 170: { n: "BrtTop10Filter", f: parsenoop }, 171: { n: "BrtDynamicFilter", f: parsenoop }, 172: { n: "BrtBeginCustomFilters", f: parsenoop }, 173: { n: "BrtEndCustomFilters", f: parsenoop }, 174: { n: "BrtCustomFilter", f: parsenoop }, 175: { n: "BrtAFilterDateGroupItem", f: parsenoop }, 176: { n: "BrtMergeCell", f: parse_BrtMergeCell }, 177: { n: "BrtBeginMergeCells", f: parsenoop }, 178: { n: "BrtEndMergeCells", f: parsenoop }, 179: { n: "BrtBeginPivotCacheDef", f: parsenoop }, 180: { n: "BrtEndPivotCacheDef", f: parsenoop }, 181: { n: "BrtBeginPCDFields", f: parsenoop }, 182: { n: "BrtEndPCDFields", f: parsenoop }, 183: { n: "BrtBeginPCDField", f: parsenoop }, 184: { n: "BrtEndPCDField", f: parsenoop }, 185: { n: "BrtBeginPCDSource", f: parsenoop }, 186: { n: "BrtEndPCDSource", f: parsenoop }, 187: { n: "BrtBeginPCDSRange", f: parsenoop }, 188: { n: "BrtEndPCDSRange", f: parsenoop }, 189: { n: "BrtBeginPCDFAtbl", f: parsenoop }, 190: { n: "BrtEndPCDFAtbl", f: parsenoop }, 191: { n: "BrtBeginPCDIRun", f: parsenoop }, 192: { n: "BrtEndPCDIRun", f: parsenoop }, 193: { n: "BrtBeginPivotCacheRecords", f: parsenoop }, 194: { n: "BrtEndPivotCacheRecords", f: parsenoop }, 195: { n: "BrtBeginPCDHierarchies", f: parsenoop }, 196: { n: "BrtEndPCDHierarchies", f: parsenoop }, 197: { n: "BrtBeginPCDHierarchy", f: parsenoop }, 198: { n: "BrtEndPCDHierarchy", f: parsenoop }, 199: { n: "BrtBeginPCDHFieldsUsage", f: parsenoop }, 200: { n: "BrtEndPCDHFieldsUsage", f: parsenoop }, 201: { n: "BrtBeginExtConnection", f: parsenoop }, 202: { n: "BrtEndExtConnection", f: parsenoop }, 203: { n: "BrtBeginECDbProps", f: parsenoop }, 204: { n: "BrtEndECDbProps", f: parsenoop }, 205: { n: "BrtBeginECOlapProps", f: parsenoop }, 206: { n: "BrtEndECOlapProps", f: parsenoop }, 207: { n: "BrtBeginPCDSConsol", f: parsenoop }, 208: { n: "BrtEndPCDSConsol", f: parsenoop }, 209: { n: "BrtBeginPCDSCPages", f: parsenoop }, 210: { n: "BrtEndPCDSCPages", f: parsenoop }, 211: { n: "BrtBeginPCDSCPage", f: parsenoop }, 212: { n: "BrtEndPCDSCPage", f: parsenoop }, 213: { n: "BrtBeginPCDSCPItem", f: parsenoop }, 214: { n: "BrtEndPCDSCPItem", f: parsenoop }, 215: { n: "BrtBeginPCDSCSets", f: parsenoop }, 216: { n: "BrtEndPCDSCSets", f: parsenoop }, 217: { n: "BrtBeginPCDSCSet", f: parsenoop }, 218: { n: "BrtEndPCDSCSet", f: parsenoop }, 219: { n: "BrtBeginPCDFGroup", f: parsenoop }, 220: { n: "BrtEndPCDFGroup", f: parsenoop }, 221: { n: "BrtBeginPCDFGItems", f: parsenoop }, 222: { n: "BrtEndPCDFGItems", f: parsenoop }, 223: { n: "BrtBeginPCDFGRange", f: parsenoop }, 224: { n: "BrtEndPCDFGRange", f: parsenoop }, 225: { n: "BrtBeginPCDFGDiscrete", f: parsenoop }, 226: { n: "BrtEndPCDFGDiscrete", f: parsenoop }, 227: { n: "BrtBeginPCDSDTupleCache", f: parsenoop }, 228: { n: "BrtEndPCDSDTupleCache", f: parsenoop }, 229: { n: "BrtBeginPCDSDTCEntries", f: parsenoop }, 230: { n: "BrtEndPCDSDTCEntries", f: parsenoop }, 231: { n: "BrtBeginPCDSDTCEMembers", f: parsenoop }, 232: { n: "BrtEndPCDSDTCEMembers", f: parsenoop }, 233: { n: "BrtBeginPCDSDTCEMember", f: parsenoop }, 234: { n: "BrtEndPCDSDTCEMember", f: parsenoop }, 235: { n: "BrtBeginPCDSDTCQueries", f: parsenoop }, 236: { n: "BrtEndPCDSDTCQueries", f: parsenoop }, 237: { n: "BrtBeginPCDSDTCQuery", f: parsenoop }, 238: { n: "BrtEndPCDSDTCQuery", f: parsenoop }, 239: { n: "BrtBeginPCDSDTCSets", f: parsenoop }, 240: { n: "BrtEndPCDSDTCSets", f: parsenoop }, 241: { n: "BrtBeginPCDSDTCSet", f: parsenoop }, 242: { n: "BrtEndPCDSDTCSet", f: parsenoop }, 243: { n: "BrtBeginPCDCalcItems", f: parsenoop }, 244: { n: "BrtEndPCDCalcItems", f: parsenoop }, 245: { n: "BrtBeginPCDCalcItem", f: parsenoop }, 246: { n: "BrtEndPCDCalcItem", f: parsenoop }, 247: { n: "BrtBeginPRule", f: parsenoop }, 248: { n: "BrtEndPRule", f: parsenoop }, 249: { n: "BrtBeginPRFilters", f: parsenoop }, 250: { n: "BrtEndPRFilters", f: parsenoop }, 251: { n: "BrtBeginPRFilter", f: parsenoop }, 252: { n: "BrtEndPRFilter", f: parsenoop }, 253: { n: "BrtBeginPNames", f: parsenoop }, 254: { n: "BrtEndPNames", f: parsenoop }, 255: { n: "BrtBeginPName", f: parsenoop }, 256: { n: "BrtEndPName", f: parsenoop }, 257: { n: "BrtBeginPNPairs", f: parsenoop }, 258: { n: "BrtEndPNPairs", f: parsenoop }, 259: { n: "BrtBeginPNPair", f: parsenoop }, 260: { n: "BrtEndPNPair", f: parsenoop }, 261: { n: "BrtBeginECWebProps", f: parsenoop }, 262: { n: "BrtEndECWebProps", f: parsenoop }, 263: { n: "BrtBeginEcWpTables", f: parsenoop }, 264: { n: "BrtEndECWPTables", f: parsenoop }, 265: { n: "BrtBeginECParams", f: parsenoop }, 266: { n: "BrtEndECParams", f: parsenoop }, 267: { n: "BrtBeginECParam", f: parsenoop }, 268: { n: "BrtEndECParam", f: parsenoop }, 269: { n: "BrtBeginPCDKPIs", f: parsenoop }, 270: { n: "BrtEndPCDKPIs", f: parsenoop }, 271: { n: "BrtBeginPCDKPI", f: parsenoop }, 272: { n: "BrtEndPCDKPI", f: parsenoop }, 273: { n: "BrtBeginDims", f: parsenoop }, 274: { n: "BrtEndDims", f: parsenoop }, 275: { n: "BrtBeginDim", f: parsenoop }, 276: { n: "BrtEndDim", f: parsenoop }, 277: { n: "BrtIndexPartEnd", f: parsenoop }, 278: { n: "BrtBeginStyleSheet", f: parsenoop }, 279: { n: "BrtEndStyleSheet", f: parsenoop }, 280: { n: "BrtBeginSXView", f: parsenoop }, 281: { n: "BrtEndSXVI", f: parsenoop }, 282: { n: "BrtBeginSXVI", f: parsenoop }, 283: { n: "BrtBeginSXVIs", f: parsenoop }, 284: { n: "BrtEndSXVIs", f: parsenoop }, 285: { n: "BrtBeginSXVD", f: parsenoop }, 286: { n: "BrtEndSXVD", f: parsenoop }, 287: { n: "BrtBeginSXVDs", f: parsenoop }, 288: { n: "BrtEndSXVDs", f: parsenoop }, 289: { n: "BrtBeginSXPI", f: parsenoop }, 290: { n: "BrtEndSXPI", f: parsenoop }, 291: { n: "BrtBeginSXPIs", f: parsenoop }, 292: { n: "BrtEndSXPIs", f: parsenoop }, 293: { n: "BrtBeginSXDI", f: parsenoop }, 294: { n: "BrtEndSXDI", f: parsenoop }, 295: { n: "BrtBeginSXDIs", f: parsenoop }, 296: { n: "BrtEndSXDIs", f: parsenoop }, 297: { n: "BrtBeginSXLI", f: parsenoop }, 298: { n: "BrtEndSXLI", f: parsenoop }, 299: { n: "BrtBeginSXLIRws", f: parsenoop }, 300: { n: "BrtEndSXLIRws", f: parsenoop }, 301: { n: "BrtBeginSXLICols", f: parsenoop }, 302: { n: "BrtEndSXLICols", f: parsenoop }, 303: { n: "BrtBeginSXFormat", f: parsenoop }, 304: { n: "BrtEndSXFormat", f: parsenoop }, 305: { n: "BrtBeginSXFormats", f: parsenoop }, 306: { n: "BrtEndSxFormats", f: parsenoop }, 307: { n: "BrtBeginSxSelect", f: parsenoop }, 308: { n: "BrtEndSxSelect", f: parsenoop }, 309: { n: "BrtBeginISXVDRws", f: parsenoop }, 310: { n: "BrtEndISXVDRws", f: parsenoop }, 311: { n: "BrtBeginISXVDCols", f: parsenoop }, 312: { n: "BrtEndISXVDCols", f: parsenoop }, 313: { n: "BrtEndSXLocation", f: parsenoop }, 314: { n: "BrtBeginSXLocation", f: parsenoop }, 315: { n: "BrtEndSXView", f: parsenoop }, 316: { n: "BrtBeginSXTHs", f: parsenoop }, 317: { n: "BrtEndSXTHs", f: parsenoop }, 318: { n: "BrtBeginSXTH", f: parsenoop }, 319: { n: "BrtEndSXTH", f: parsenoop }, 320: { n: "BrtBeginISXTHRws", f: parsenoop }, 321: { n: "BrtEndISXTHRws", f: parsenoop }, 322: { n: "BrtBeginISXTHCols", f: parsenoop }, 323: { n: "BrtEndISXTHCols", f: parsenoop }, 324: { n: "BrtBeginSXTDMPS", f: parsenoop }, 325: { n: "BrtEndSXTDMPs", f: parsenoop }, 326: { n: "BrtBeginSXTDMP", f: parsenoop }, 327: { n: "BrtEndSXTDMP", f: parsenoop }, 328: { n: "BrtBeginSXTHItems", f: parsenoop }, 329: { n: "BrtEndSXTHItems", f: parsenoop }, 330: { n: "BrtBeginSXTHItem", f: parsenoop }, 331: { n: "BrtEndSXTHItem", f: parsenoop }, 332: { n: "BrtBeginMetadata", f: parsenoop }, 333: { n: "BrtEndMetadata", f: parsenoop }, 334: { n: "BrtBeginEsmdtinfo", f: parsenoop }, 335: { n: "BrtMdtinfo", f: parsenoop }, 336: { n: "BrtEndEsmdtinfo", f: parsenoop }, 337: { n: "BrtBeginEsmdb", f: parsenoop }, 338: { n: "BrtEndEsmdb", f: parsenoop }, 339: { n: "BrtBeginEsfmd", f: parsenoop }, 340: { n: "BrtEndEsfmd", f: parsenoop }, 341: { n: "BrtBeginSingleCells", f: parsenoop }, 342: { n: "BrtEndSingleCells", f: parsenoop }, 343: { n: "BrtBeginList", f: parsenoop }, 344: { n: "BrtEndList", f: parsenoop }, 345: { n: "BrtBeginListCols", f: parsenoop }, 346: { n: "BrtEndListCols", f: parsenoop }, 347: { n: "BrtBeginListCol", f: parsenoop }, 348: { n: "BrtEndListCol", f: parsenoop }, 349: { n: "BrtBeginListXmlCPr", f: parsenoop }, 350: { n: "BrtEndListXmlCPr", f: parsenoop }, 351: { n: "BrtListCCFmla", f: parsenoop }, 352: { n: "BrtListTrFmla", f: parsenoop }, 353: { n: "BrtBeginExternals", f: parsenoop }, 354: { n: "BrtEndExternals", f: parsenoop }, 355: { n: "BrtSupBookSrc", f: parsenoop }, 357: { n: "BrtSupSelf", f: parsenoop }, 358: { n: "BrtSupSame", f: parsenoop }, 359: { n: "BrtSupTabs", f: parsenoop }, 360: { n: "BrtBeginSupBook", f: parsenoop }, 361: { n: "BrtPlaceholderName", f: parsenoop }, 362: { n: "BrtExternSheet", f: parsenoop }, 363: { n: "BrtExternTableStart", f: parsenoop }, 364: { n: "BrtExternTableEnd", f: parsenoop }, 366: { n: "BrtExternRowHdr", f: parsenoop }, 367: { n: "BrtExternCellBlank", f: parsenoop }, 368: { n: "BrtExternCellReal", f: parsenoop }, 369: { n: "BrtExternCellBool", f: parsenoop }, 370: { n: "BrtExternCellError", f: parsenoop }, 371: { n: "BrtExternCellString", f: parsenoop }, 372: { n: "BrtBeginEsmdx", f: parsenoop }, 373: { n: "BrtEndEsmdx", f: parsenoop }, 374: { n: "BrtBeginMdxSet", f: parsenoop }, 375: { n: "BrtEndMdxSet", f: parsenoop }, 376: { n: "BrtBeginMdxMbrProp", f: parsenoop }, 377: { n: "BrtEndMdxMbrProp", f: parsenoop }, 378: { n: "BrtBeginMdxKPI", f: parsenoop }, 379: { n: "BrtEndMdxKPI", f: parsenoop }, 380: { n: "BrtBeginEsstr", f: parsenoop }, 381: { n: "BrtEndEsstr", f: parsenoop }, 382: { n: "BrtBeginPRFItem", f: parsenoop }, 383: { n: "BrtEndPRFItem", f: parsenoop }, 384: { n: "BrtBeginPivotCacheIDs", f: parsenoop }, 385: { n: "BrtEndPivotCacheIDs", f: parsenoop }, 386: { n: "BrtBeginPivotCacheID", f: parsenoop }, 387: { n: "BrtEndPivotCacheID", f: parsenoop }, 388: { n: "BrtBeginISXVIs", f: parsenoop }, 389: { n: "BrtEndISXVIs", f: parsenoop }, 390: { n: "BrtBeginColInfos", f: parsenoop }, 391: { n: "BrtEndColInfos", f: parsenoop }, 392: { n: "BrtBeginRwBrk", f: parsenoop }, 393: { n: "BrtEndRwBrk", f: parsenoop }, 394: { n: "BrtBeginColBrk", f: parsenoop }, 395: { n: "BrtEndColBrk", f: parsenoop }, 396: { n: "BrtBrk", f: parsenoop }, 397: { n: "BrtUserBookView", f: parsenoop }, 398: { n: "BrtInfo", f: parsenoop }, 399: { n: "BrtCUsr", f: parsenoop }, 400: { n: "BrtUsr", f: parsenoop }, 401: { n: "BrtBeginUsers", f: parsenoop }, 403: { n: "BrtEOF", f: parsenoop }, 404: { n: "BrtUCR", f: parsenoop }, 405: { n: "BrtRRInsDel", f: parsenoop }, 406: { n: "BrtRREndInsDel", f: parsenoop }, 407: { n: "BrtRRMove", f: parsenoop }, 408: { n: "BrtRREndMove", f: parsenoop }, 409: { n: "BrtRRChgCell", f: parsenoop }, 410: { n: "BrtRREndChgCell", f: parsenoop }, 411: { n: "BrtRRHeader", f: parsenoop }, 412: { n: "BrtRRUserView", f: parsenoop }, 413: { n: "BrtRRRenSheet", f: parsenoop }, 414: { n: "BrtRRInsertSh", f: parsenoop }, 415: { n: "BrtRRDefName", f: parsenoop }, 416: { n: "BrtRRNote", f: parsenoop }, 417: { n: "BrtRRConflict", f: parsenoop }, 418: { n: "BrtRRTQSIF", f: parsenoop }, 419: { n: "BrtRRFormat", f: parsenoop }, 420: { n: "BrtRREndFormat", f: parsenoop }, 421: { n: "BrtRRAutoFmt", f: parsenoop }, 422: { n: "BrtBeginUserShViews", f: parsenoop }, 423: { n: "BrtBeginUserShView", f: parsenoop }, 424: { n: "BrtEndUserShView", f: parsenoop }, 425: { n: "BrtEndUserShViews", f: parsenoop }, 426: { n: "BrtArrFmla", f: parsenoop }, 427: { n: "BrtShrFmla", f: parsenoop }, 428: { n: "BrtTable", f: parsenoop }, 429: { n: "BrtBeginExtConnections", f: parsenoop }, 430: { n: "BrtEndExtConnections", f: parsenoop }, 431: { n: "BrtBeginPCDCalcMems", f: parsenoop }, 432: { n: "BrtEndPCDCalcMems", f: parsenoop }, 433: { n: "BrtBeginPCDCalcMem", f: parsenoop }, 434: { n: "BrtEndPCDCalcMem", f: parsenoop }, 435: { n: "BrtBeginPCDHGLevels", f: parsenoop }, 436: { n: "BrtEndPCDHGLevels", f: parsenoop }, 437: { n: "BrtBeginPCDHGLevel", f: parsenoop }, 438: { n: "BrtEndPCDHGLevel", f: parsenoop }, 439: { n: "BrtBeginPCDHGLGroups", f: parsenoop }, 440: { n: "BrtEndPCDHGLGroups", f: parsenoop }, 441: { n: "BrtBeginPCDHGLGroup", f: parsenoop }, 442: { n: "BrtEndPCDHGLGroup", f: parsenoop }, 443: { n: "BrtBeginPCDHGLGMembers", f: parsenoop }, 444: { n: "BrtEndPCDHGLGMembers", f: parsenoop }, 445: { n: "BrtBeginPCDHGLGMember", f: parsenoop }, 446: { n: "BrtEndPCDHGLGMember", f: parsenoop }, 447: { n: "BrtBeginQSI", f: parsenoop }, 448: { n: "BrtEndQSI", f: parsenoop }, 449: { n: "BrtBeginQSIR", f: parsenoop }, 450: { n: "BrtEndQSIR", f: parsenoop }, 451: { n: "BrtBeginDeletedNames", f: parsenoop }, 452: { n: "BrtEndDeletedNames", f: parsenoop }, 453: { n: "BrtBeginDeletedName", f: parsenoop }, 454: { n: "BrtEndDeletedName", f: parsenoop }, 455: { n: "BrtBeginQSIFs", f: parsenoop }, 456: { n: "BrtEndQSIFs", f: parsenoop }, 457: { n: "BrtBeginQSIF", f: parsenoop }, 458: { n: "BrtEndQSIF", f: parsenoop }, 459: { n: "BrtBeginAutoSortScope", f: parsenoop }, 460: { n: "BrtEndAutoSortScope", f: parsenoop }, 461: { n: "BrtBeginConditionalFormatting", f: parsenoop }, 462: { n: "BrtEndConditionalFormatting", f: parsenoop }, 463: { n: "BrtBeginCFRule", f: parsenoop }, 464: { n: "BrtEndCFRule", f: parsenoop }, 465: { n: "BrtBeginIconSet", f: parsenoop }, 466: { n: "BrtEndIconSet", f: parsenoop }, 467: { n: "BrtBeginDatabar", f: parsenoop }, 468: { n: "BrtEndDatabar", f: parsenoop }, 469: { n: "BrtBeginColorScale", f: parsenoop }, 470: { n: "BrtEndColorScale", f: parsenoop }, 471: { n: "BrtCFVO", f: parsenoop }, 472: { n: "BrtExternValueMeta", f: parsenoop }, 473: { n: "BrtBeginColorPalette", f: parsenoop }, 474: { n: "BrtEndColorPalette", f: parsenoop }, 475: { n: "BrtIndexedColor", f: parsenoop }, 476: { n: "BrtMargins", f: parsenoop }, 477: { n: "BrtPrintOptions", f: parsenoop }, 478: { n: "BrtPageSetup", f: parsenoop }, 479: { n: "BrtBeginHeaderFooter", f: parsenoop }, 480: { n: "BrtEndHeaderFooter", f: parsenoop }, 481: { n: "BrtBeginSXCrtFormat", f: parsenoop }, 482: { n: "BrtEndSXCrtFormat", f: parsenoop }, 483: { n: "BrtBeginSXCrtFormats", f: parsenoop }, 484: { n: "BrtEndSXCrtFormats", f: parsenoop }, 485: { n: "BrtWsFmtInfo", f: parsenoop }, 486: { n: "BrtBeginMgs", f: parsenoop }, 487: { n: "BrtEndMGs", f: parsenoop }, 488: { n: "BrtBeginMGMaps", f: parsenoop }, 489: { n: "BrtEndMGMaps", f: parsenoop }, 490: { n: "BrtBeginMG", f: parsenoop }, 491: { n: "BrtEndMG", f: parsenoop }, 492: { n: "BrtBeginMap", f: parsenoop }, 493: { n: "BrtEndMap", f: parsenoop }, 494: { n: "BrtHLink", f: parse_BrtHLink }, 495: { n: "BrtBeginDCon", f: parsenoop }, 496: { n: "BrtEndDCon", f: parsenoop }, 497: { n: "BrtBeginDRefs", f: parsenoop }, 498: { n: "BrtEndDRefs", f: parsenoop }, 499: { n: "BrtDRef", f: parsenoop }, 500: { n: "BrtBeginScenMan", f: parsenoop }, 501: { n: "BrtEndScenMan", f: parsenoop }, 502: { n: "BrtBeginSct", f: parsenoop }, 503: { n: "BrtEndSct", f: parsenoop }, 504: { n: "BrtSlc", f: parsenoop }, 505: { n: "BrtBeginDXFs", f: parsenoop }, 506: { n: "BrtEndDXFs", f: parsenoop }, 507: { n: "BrtDXF", f: parsenoop }, 508: { n: "BrtBeginTableStyles", f: parsenoop }, 509: { n: "BrtEndTableStyles", f: parsenoop }, 510: { n: "BrtBeginTableStyle", f: parsenoop }, 511: { n: "BrtEndTableStyle", f: parsenoop }, 512: { n: "BrtTableStyleElement", f: parsenoop }, 513: { n: "BrtTableStyleClient", f: parsenoop }, 514: { n: "BrtBeginVolDeps", f: parsenoop }, 515: { n: "BrtEndVolDeps", f: parsenoop }, 516: { n: "BrtBeginVolType", f: parsenoop }, 517: { n: "BrtEndVolType", f: parsenoop }, 518: { n: "BrtBeginVolMain", f: parsenoop }, 519: { n: "BrtEndVolMain", f: parsenoop }, 520: { n: "BrtBeginVolTopic", f: parsenoop }, 521: { n: "BrtEndVolTopic", f: parsenoop }, 522: { n: "BrtVolSubtopic", f: parsenoop }, 523: { n: "BrtVolRef", f: parsenoop }, 524: { n: "BrtVolNum", f: parsenoop }, 525: { n: "BrtVolErr", f: parsenoop }, 526: { n: "BrtVolStr", f: parsenoop }, 527: { n: "BrtVolBool", f: parsenoop }, 528: { n: "BrtBeginCalcChain$", f: parsenoop }, 529: { n: "BrtEndCalcChain$", f: parsenoop }, 530: { n: "BrtBeginSortState", f: parsenoop }, 531: { n: "BrtEndSortState", f: parsenoop }, 532: { n: "BrtBeginSortCond", f: parsenoop }, 533: { n: "BrtEndSortCond", f: parsenoop }, 534: { n: "BrtBookProtection", f: parsenoop }, 535: { n: "BrtSheetProtection", f: parsenoop }, 536: { n: "BrtRangeProtection", f: parsenoop }, 537: { n: "BrtPhoneticInfo", f: parsenoop }, 538: { n: "BrtBeginECTxtWiz", f: parsenoop }, 539: { n: "BrtEndECTxtWiz", f: parsenoop }, 540: { n: "BrtBeginECTWFldInfoLst", f: parsenoop }, 541: { n: "BrtEndECTWFldInfoLst", f: parsenoop }, 542: { n: "BrtBeginECTwFldInfo", f: parsenoop }, 548: { n: "BrtFileSharing", f: parsenoop }, 549: { n: "BrtOleSize", f: parsenoop }, 550: { n: "BrtDrawing", f: parsenoop }, 551: { n: "BrtLegacyDrawing", f: parsenoop }, 552: { n: "BrtLegacyDrawingHF", f: parsenoop }, 553: { n: "BrtWebOpt", f: parsenoop }, 554: { n: "BrtBeginWebPubItems", f: parsenoop }, 555: { n: "BrtEndWebPubItems", f: parsenoop }, 556: { n: "BrtBeginWebPubItem", f: parsenoop }, 557: { n: "BrtEndWebPubItem", f: parsenoop }, 558: { n: "BrtBeginSXCondFmt", f: parsenoop }, 559: { n: "BrtEndSXCondFmt", f: parsenoop }, 560: { n: "BrtBeginSXCondFmts", f: parsenoop }, 561: { n: "BrtEndSXCondFmts", f: parsenoop }, 562: { n: "BrtBkHim", f: parsenoop }, 564: { n: "BrtColor", f: parsenoop }, 565: { n: "BrtBeginIndexedColors", f: parsenoop }, 566: { n: "BrtEndIndexedColors", f: parsenoop }, 569: { n: "BrtBeginMRUColors", f: parsenoop }, 570: { n: "BrtEndMRUColors", f: parsenoop }, 572: { n: "BrtMRUColor", f: parsenoop }, 573: { n: "BrtBeginDVals", f: parsenoop }, 574: { n: "BrtEndDVals", f: parsenoop }, 577: { n: "BrtSupNameStart", f: parsenoop }, 578: { n: "BrtSupNameValueStart", f: parsenoop }, 579: { n: "BrtSupNameValueEnd", f: parsenoop }, 580: { n: "BrtSupNameNum", f: parsenoop }, 581: { n: "BrtSupNameErr", f: parsenoop }, 582: { n: "BrtSupNameSt", f: parsenoop }, 583: { n: "BrtSupNameNil", f: parsenoop }, 584: { n: "BrtSupNameBool", f: parsenoop }, 585: { n: "BrtSupNameFmla", f: parsenoop }, 586: { n: "BrtSupNameBits", f: parsenoop }, 587: { n: "BrtSupNameEnd", f: parsenoop }, 588: { n: "BrtEndSupBook", f: parsenoop }, 589: { n: "BrtCellSmartTagProperty", f: parsenoop }, 590: { n: "BrtBeginCellSmartTag", f: parsenoop }, 591: { n: "BrtEndCellSmartTag", f: parsenoop }, 592: { n: "BrtBeginCellSmartTags", f: parsenoop }, 593: { n: "BrtEndCellSmartTags", f: parsenoop }, 594: { n: "BrtBeginSmartTags", f: parsenoop }, 595: { n: "BrtEndSmartTags", f: parsenoop }, 596: { n: "BrtSmartTagType", f: parsenoop }, 597: { n: "BrtBeginSmartTagTypes", f: parsenoop }, 598: { n: "BrtEndSmartTagTypes", f: parsenoop }, 599: { n: "BrtBeginSXFilters", f: parsenoop }, 600: { n: "BrtEndSXFilters", f: parsenoop }, 601: { n: "BrtBeginSXFILTER", f: parsenoop }, 602: { n: "BrtEndSXFilter", f: parsenoop }, 603: { n: "BrtBeginFills", f: parsenoop }, 604: { n: "BrtEndFills", f: parsenoop }, 605: { n: "BrtBeginCellWatches", f: parsenoop }, 606: { n: "BrtEndCellWatches", f: parsenoop }, 607: { n: "BrtCellWatch", f: parsenoop }, 608: { n: "BrtBeginCRErrs", f: parsenoop }, 609: { n: "BrtEndCRErrs", f: parsenoop }, 610: { n: "BrtCrashRecErr", f: parsenoop }, 611: { n: "BrtBeginFonts", f: parsenoop }, 612: { n: "BrtEndFonts", f: parsenoop }, 613: { n: "BrtBeginBorders", f: parsenoop }, 614: { n: "BrtEndBorders", f: parsenoop }, 615: { n: "BrtBeginFmts", f: parsenoop }, 616: { n: "BrtEndFmts", f: parsenoop }, 617: { n: "BrtBeginCellXFs", f: parsenoop }, 618: { n: "BrtEndCellXFs", f: parsenoop }, 619: { n: "BrtBeginStyles", f: parsenoop }, 620: { n: "BrtEndStyles", f: parsenoop }, 625: { n: "BrtBigName", f: parsenoop }, 626: { n: "BrtBeginCellStyleXFs", f: parsenoop }, 627: { n: "BrtEndCellStyleXFs", f: parsenoop }, 628: { n: "BrtBeginComments", f: parsenoop }, 629: { n: "BrtEndComments", f: parsenoop }, 630: { n: "BrtBeginCommentAuthors", f: parsenoop }, 631: { n: "BrtEndCommentAuthors", f: parsenoop }, 632: { n: "BrtCommentAuthor", f: parse_BrtCommentAuthor }, 633: { n: "BrtBeginCommentList", f: parsenoop }, 634: { n: "BrtEndCommentList", f: parsenoop }, 635: { n: "BrtBeginComment", f: parse_BrtBeginComment }, 636: { n: "BrtEndComment", f: parsenoop }, 637: { n: "BrtCommentText", f: parse_BrtCommentText }, 638: { n: "BrtBeginOleObjects", f: parsenoop }, 639: { n: "BrtOleObject", f: parsenoop }, 640: { n: "BrtEndOleObjects", f: parsenoop }, 641: { n: "BrtBeginSxrules", f: parsenoop }, 642: { n: "BrtEndSxRules", f: parsenoop }, 643: { n: "BrtBeginActiveXControls", f: parsenoop }, 644: { n: "BrtActiveX", f: parsenoop }, 645: { n: "BrtEndActiveXControls", f: parsenoop }, 646: { n: "BrtBeginPCDSDTCEMembersSortBy", f: parsenoop }, 648: { n: "BrtBeginCellIgnoreECs", f: parsenoop }, 649: { n: "BrtCellIgnoreEC", f: parsenoop }, 650: { n: "BrtEndCellIgnoreECs", f: parsenoop }, 651: { n: "BrtCsProp", f: parsenoop }, 652: { n: "BrtCsPageSetup", f: parsenoop }, 653: { n: "BrtBeginUserCsViews", f: parsenoop }, 654: { n: "BrtEndUserCsViews", f: parsenoop }, 655: { n: "BrtBeginUserCsView", f: parsenoop }, 656: { n: "BrtEndUserCsView", f: parsenoop }, 657: { n: "BrtBeginPcdSFCIEntries", f: parsenoop }, 658: { n: "BrtEndPCDSFCIEntries", f: parsenoop }, 659: { n: "BrtPCDSFCIEntry", f: parsenoop }, 660: { n: "BrtBeginListParts", f: parsenoop }, 661: { n: "BrtListPart", f: parsenoop }, 662: { n: "BrtEndListParts", f: parsenoop }, 663: { n: "BrtSheetCalcProp", f: parsenoop }, 664: { n: "BrtBeginFnGroup", f: parsenoop }, 665: { n: "BrtFnGroup", f: parsenoop }, 666: { n: "BrtEndFnGroup", f: parsenoop }, 667: { n: "BrtSupAddin", f: parsenoop }, 668: { n: "BrtSXTDMPOrder", f: parsenoop }, 669: { n: "BrtCsProtection", f: parsenoop }, 671: { n: "BrtBeginWsSortMap", f: parsenoop }, 672: { n: "BrtEndWsSortMap", f: parsenoop }, 673: { n: "BrtBeginRRSort", f: parsenoop }, 674: { n: "BrtEndRRSort", f: parsenoop }, 675: { n: "BrtRRSortItem", f: parsenoop }, 676: { n: "BrtFileSharingIso", f: parsenoop }, 677: { n: "BrtBookProtectionIso", f: parsenoop }, 678: { n: "BrtSheetProtectionIso", f: parsenoop }, 679: { n: "BrtCsProtectionIso", f: parsenoop }, 680: { n: "BrtRangeProtectionIso", f: parsenoop }, 1024: { n: "BrtRwDescent", f: parsenoop }, 1025: { n: "BrtKnownFonts", f: parsenoop }, 1026: { n: "BrtBeginSXTupleSet", f: parsenoop }, 1027: { n: "BrtEndSXTupleSet", f: parsenoop }, 1028: { n: "BrtBeginSXTupleSetHeader", f: parsenoop }, 1029: { n: "BrtEndSXTupleSetHeader", f: parsenoop }, 1030: { n: "BrtSXTupleSetHeaderItem", f: parsenoop }, 1031: { n: "BrtBeginSXTupleSetData", f: parsenoop }, 1032: { n: "BrtEndSXTupleSetData", f: parsenoop }, 1033: { n: "BrtBeginSXTupleSetRow", f: parsenoop }, 1034: { n: "BrtEndSXTupleSetRow", f: parsenoop }, 1035: { n: "BrtSXTupleSetRowItem", f: parsenoop }, 1036: { n: "BrtNameExt", f: parsenoop }, 1037: { n: "BrtPCDH14", f: parsenoop }, 1038: { n: "BrtBeginPCDCalcMem14", f: parsenoop }, 1039: { n: "BrtEndPCDCalcMem14", f: parsenoop }, 1040: { n: "BrtSXTH14", f: parsenoop }, 1041: { n: "BrtBeginSparklineGroup", f: parsenoop }, 1042: { n: "BrtEndSparklineGroup", f: parsenoop }, 1043: { n: "BrtSparkline", f: parsenoop }, 1044: { n: "BrtSXDI14", f: parsenoop }, 1045: { n: "BrtWsFmtInfoEx14", f: parsenoop }, 1046: { n: "BrtBeginConditionalFormatting14", f: parsenoop }, 1047: { n: "BrtEndConditionalFormatting14", f: parsenoop }, 1048: { n: "BrtBeginCFRule14", f: parsenoop }, 1049: { n: "BrtEndCFRule14", f: parsenoop }, 1050: { n: "BrtCFVO14", f: parsenoop }, 1051: { n: "BrtBeginDatabar14", f: parsenoop }, 1052: { n: "BrtBeginIconSet14", f: parsenoop }, 1053: { n: "BrtDVal14", f: parsenoop }, 1054: { n: "BrtBeginDVals14", f: parsenoop }, 1055: { n: "BrtColor14", f: parsenoop }, 1056: { n: "BrtBeginSparklines", f: parsenoop }, 1057: { n: "BrtEndSparklines", f: parsenoop }, 1058: { n: "BrtBeginSparklineGroups", f: parsenoop }, 1059: { n: "BrtEndSparklineGroups", f: parsenoop }, 1061: { n: "BrtSXVD14", f: parsenoop }, 1062: { n: "BrtBeginSxview14", f: parsenoop }, 1063: { n: "BrtEndSxview14", f: parsenoop }, 1066: { n: "BrtBeginPCD14", f: parsenoop }, 1067: { n: "BrtEndPCD14", f: parsenoop }, 1068: { n: "BrtBeginExtConn14", f: parsenoop }, 1069: { n: "BrtEndExtConn14", f: parsenoop }, 1070: { n: "BrtBeginSlicerCacheIDs", f: parsenoop }, 1071: { n: "BrtEndSlicerCacheIDs", f: parsenoop }, 1072: { n: "BrtBeginSlicerCacheID", f: parsenoop }, 1073: { n: "BrtEndSlicerCacheID", f: parsenoop }, 1075: { n: "BrtBeginSlicerCache", f: parsenoop }, 1076: { n: "BrtEndSlicerCache", f: parsenoop }, 1077: { n: "BrtBeginSlicerCacheDef", f: parsenoop }, 1078: { n: "BrtEndSlicerCacheDef", f: parsenoop }, 1079: { n: "BrtBeginSlicersEx", f: parsenoop }, 1080: { n: "BrtEndSlicersEx", f: parsenoop }, 1081: { n: "BrtBeginSlicerEx", f: parsenoop }, 1082: { n: "BrtEndSlicerEx", f: parsenoop }, 1083: { n: "BrtBeginSlicer", f: parsenoop }, 1084: { n: "BrtEndSlicer", f: parsenoop }, 1085: { n: "BrtSlicerCachePivotTables", f: parsenoop }, 1086: { n: "BrtBeginSlicerCacheOlapImpl", f: parsenoop }, 1087: { n: "BrtEndSlicerCacheOlapImpl", f: parsenoop }, 1088: { n: "BrtBeginSlicerCacheLevelsData", f: parsenoop }, 1089: { n: "BrtEndSlicerCacheLevelsData", f: parsenoop }, 1090: { n: "BrtBeginSlicerCacheLevelData", f: parsenoop }, 1091: { n: "BrtEndSlicerCacheLevelData", f: parsenoop }, 1092: { n: "BrtBeginSlicerCacheSiRanges", f: parsenoop }, 1093: { n: "BrtEndSlicerCacheSiRanges", f: parsenoop }, 1094: { n: "BrtBeginSlicerCacheSiRange", f: parsenoop }, 1095: { n: "BrtEndSlicerCacheSiRange", f: parsenoop }, 1096: { n: "BrtSlicerCacheOlapItem", f: parsenoop }, 1097: { n: "BrtBeginSlicerCacheSelections", f: parsenoop }, 1098: { n: "BrtSlicerCacheSelection", f: parsenoop }, 1099: { n: "BrtEndSlicerCacheSelections", f: parsenoop }, 1100: { n: "BrtBeginSlicerCacheNative", f: parsenoop }, 1101: { n: "BrtEndSlicerCacheNative", f: parsenoop }, 1102: { n: "BrtSlicerCacheNativeItem", f: parsenoop }, 1103: { n: "BrtRangeProtection14", f: parsenoop }, 1104: { n: "BrtRangeProtectionIso14", f: parsenoop }, 1105: { n: "BrtCellIgnoreEC14", f: parsenoop }, 1111: { n: "BrtList14", f: parsenoop }, 1112: { n: "BrtCFIcon", f: parsenoop }, 1113: { n: "BrtBeginSlicerCachesPivotCacheIDs", f: parsenoop }, 1114: { n: "BrtEndSlicerCachesPivotCacheIDs", f: parsenoop }, 1115: { n: "BrtBeginSlicers", f: parsenoop }, 1116: { n: "BrtEndSlicers", f: parsenoop }, 1117: { n: "BrtWbProp14", f: parsenoop }, 1118: { n: "BrtBeginSXEdit", f: parsenoop }, 1119: { n: "BrtEndSXEdit", f: parsenoop }, 1120: { n: "BrtBeginSXEdits", f: parsenoop }, 1121: { n: "BrtEndSXEdits", f: parsenoop }, 1122: { n: "BrtBeginSXChange", f: parsenoop }, 1123: { n: "BrtEndSXChange", f: parsenoop }, 1124: { n: "BrtBeginSXChanges", f: parsenoop }, 1125: { n: "BrtEndSXChanges", f: parsenoop }, 1126: { n: "BrtSXTupleItems", f: parsenoop }, 1128: { n: "BrtBeginSlicerStyle", f: parsenoop }, 1129: { n: "BrtEndSlicerStyle", f: parsenoop }, 1130: { n: "BrtSlicerStyleElement", f: parsenoop }, 1131: { n: "BrtBeginStyleSheetExt14", f: parsenoop }, 1132: { n: "BrtEndStyleSheetExt14", f: parsenoop }, 1133: { n: "BrtBeginSlicerCachesPivotCacheID", f: parsenoop }, 1134: { n: "BrtEndSlicerCachesPivotCacheID", f: parsenoop }, 1135: { n: "BrtBeginConditionalFormattings", f: parsenoop }, 1136: { n: "BrtEndConditionalFormattings", f: parsenoop }, 1137: { n: "BrtBeginPCDCalcMemExt", f: parsenoop }, 1138: { n: "BrtEndPCDCalcMemExt", f: parsenoop }, 1139: { n: "BrtBeginPCDCalcMemsExt", f: parsenoop }, 1140: { n: "BrtEndPCDCalcMemsExt", f: parsenoop }, 1141: { n: "BrtPCDField14", f: parsenoop }, 1142: { n: "BrtBeginSlicerStyles", f: parsenoop }, 1143: { n: "BrtEndSlicerStyles", f: parsenoop }, 1144: { n: "BrtBeginSlicerStyleElements", f: parsenoop }, 1145: { n: "BrtEndSlicerStyleElements", f: parsenoop }, 1146: { n: "BrtCFRuleExt", f: parsenoop }, 1147: { n: "BrtBeginSXCondFmt14", f: parsenoop }, 1148: { n: "BrtEndSXCondFmt14", f: parsenoop }, 1149: { n: "BrtBeginSXCondFmts14", f: parsenoop }, 1150: { n: "BrtEndSXCondFmts14", f: parsenoop }, 1152: { n: "BrtBeginSortCond14", f: parsenoop }, 1153: { n: "BrtEndSortCond14", f: parsenoop }, 1154: { n: "BrtEndDVals14", f: parsenoop }, 1155: { n: "BrtEndIconSet14", f: parsenoop }, 1156: { n: "BrtEndDatabar14", f: parsenoop }, 1157: { n: "BrtBeginColorScale14", f: parsenoop }, 1158: { n: "BrtEndColorScale14", f: parsenoop }, 1159: { n: "BrtBeginSxrules14", f: parsenoop }, 1160: { n: "BrtEndSxrules14", f: parsenoop }, 1161: { n: "BrtBeginPRule14", f: parsenoop }, 1162: { n: "BrtEndPRule14", f: parsenoop }, 1163: { n: "BrtBeginPRFilters14", f: parsenoop }, 1164: { n: "BrtEndPRFilters14", f: parsenoop }, 1165: { n: "BrtBeginPRFilter14", f: parsenoop }, 1166: { n: "BrtEndPRFilter14", f: parsenoop }, 1167: { n: "BrtBeginPRFItem14", f: parsenoop }, 1168: { n: "BrtEndPRFItem14", f: parsenoop }, 1169: { n: "BrtBeginCellIgnoreECs14", f: parsenoop }, 1170: { n: "BrtEndCellIgnoreECs14", f: parsenoop }, 1171: { n: "BrtDxf14", f: parsenoop }, 1172: { n: "BrtBeginDxF14s", f: parsenoop }, 1173: { n: "BrtEndDxf14s", f: parsenoop }, 1177: { n: "BrtFilter14", f: parsenoop }, 1178: { n: "BrtBeginCustomFilters14", f: parsenoop }, 1180: { n: "BrtCustomFilter14", f: parsenoop }, 1181: { n: "BrtIconFilter14", f: parsenoop }, 1182: { n: "BrtPivotCacheConnectionName", f: parsenoop }, 2048: { n: "BrtBeginDecoupledPivotCacheIDs", f: parsenoop }, 2049: { n: "BrtEndDecoupledPivotCacheIDs", f: parsenoop }, 2050: { n: "BrtDecoupledPivotCacheID", f: parsenoop }, 2051: { n: "BrtBeginPivotTableRefs", f: parsenoop }, 2052: { n: "BrtEndPivotTableRefs", f: parsenoop }, 2053: { n: "BrtPivotTableRef", f: parsenoop }, 2054: { n: "BrtSlicerCacheBookPivotTables", f: parsenoop }, 2055: { n: "BrtBeginSxvcells", f: parsenoop }, 2056: { n: "BrtEndSxvcells", f: parsenoop }, 2057: { n: "BrtBeginSxRow", f: parsenoop }, 2058: { n: "BrtEndSxRow", f: parsenoop }, 2060: { n: "BrtPcdCalcMem15", f: parsenoop }, 2067: { n: "BrtQsi15", f: parsenoop }, 2068: { n: "BrtBeginWebExtensions", f: parsenoop }, 2069: { n: "BrtEndWebExtensions", f: parsenoop }, 2070: { n: "BrtWebExtension", f: parsenoop }, 2071: { n: "BrtAbsPath15", f: parsenoop }, 2072: { n: "BrtBeginPivotTableUISettings", f: parsenoop }, 2073: { n: "BrtEndPivotTableUISettings", f: parsenoop }, 2075: { n: "BrtTableSlicerCacheIDs", f: parsenoop }, 2076: { n: "BrtTableSlicerCacheID", f: parsenoop }, 2077: { n: "BrtBeginTableSlicerCache", f: parsenoop }, 2078: { n: "BrtEndTableSlicerCache", f: parsenoop }, 2079: { n: "BrtSxFilter15", f: parsenoop }, 2080: { n: "BrtBeginTimelineCachePivotCacheIDs", f: parsenoop }, 2081: { n: "BrtEndTimelineCachePivotCacheIDs", f: parsenoop }, 2082: { n: "BrtTimelineCachePivotCacheID", f: parsenoop }, 2083: { n: "BrtBeginTimelineCacheIDs", f: parsenoop }, 2084: { n: "BrtEndTimelineCacheIDs", f: parsenoop }, 2085: { n: "BrtBeginTimelineCacheID", f: parsenoop }, 2086: { n: "BrtEndTimelineCacheID", f: parsenoop }, 2087: { n: "BrtBeginTimelinesEx", f: parsenoop }, 2088: { n: "BrtEndTimelinesEx", f: parsenoop }, 2089: { n: "BrtBeginTimelineEx", f: parsenoop }, 2090: { n: "BrtEndTimelineEx", f: parsenoop }, 2091: { n: "BrtWorkBookPr15", f: parsenoop }, 2092: { n: "BrtPCDH15", f: parsenoop }, 2093: { n: "BrtBeginTimelineStyle", f: parsenoop }, 2094: { n: "BrtEndTimelineStyle", f: parsenoop }, 2095: { n: "BrtTimelineStyleElement", f: parsenoop }, 2096: { n: "BrtBeginTimelineStylesheetExt15", f: parsenoop }, 2097: { n: "BrtEndTimelineStylesheetExt15", f: parsenoop }, 2098: { n: "BrtBeginTimelineStyles", f: parsenoop }, 2099: { n: "BrtEndTimelineStyles", f: parsenoop }, 2100: { n: "BrtBeginTimelineStyleElements", f: parsenoop }, 2101: { n: "BrtEndTimelineStyleElements", f: parsenoop }, 2102: { n: "BrtDxf15", f: parsenoop }, 2103: { n: "BrtBeginDxfs15", f: parsenoop }, 2104: { n: "brtEndDxfs15", f: parsenoop }, 2105: { n: "BrtSlicerCacheHideItemsWithNoData", f: parsenoop }, 2106: { n: "BrtBeginItemUniqueNames", f: parsenoop }, 2107: { n: "BrtEndItemUniqueNames", f: parsenoop }, 2108: { n: "BrtItemUniqueName", f: parsenoop }, 2109: { n: "BrtBeginExtConn15", f: parsenoop }, 2110: { n: "BrtEndExtConn15", f: parsenoop }, 2111: { n: "BrtBeginOledbPr15", f: parsenoop }, 2112: { n: "BrtEndOledbPr15", f: parsenoop }, 2113: { n: "BrtBeginDataFeedPr15", f: parsenoop }, 2114: { n: "BrtEndDataFeedPr15", f: parsenoop }, 2115: { n: "BrtTextPr15", f: parsenoop }, 2116: { n: "BrtRangePr15", f: parsenoop }, 2117: { n: "BrtDbCommand15", f: parsenoop }, 2118: { n: "BrtBeginDbTables15", f: parsenoop }, 2119: { n: "BrtEndDbTables15", f: parsenoop }, 2120: { n: "BrtDbTable15", f: parsenoop }, 2121: { n: "BrtBeginDataModel", f: parsenoop }, 2122: { n: "BrtEndDataModel", f: parsenoop }, 2123: { n: "BrtBeginModelTables", f: parsenoop }, 2124: { n: "BrtEndModelTables", f: parsenoop }, 2125: { n: "BrtModelTable", f: parsenoop }, 2126: { n: "BrtBeginModelRelationships", f: parsenoop }, 2127: { n: "BrtEndModelRelationships", f: parsenoop }, 2128: { n: "BrtModelRelationship", f: parsenoop }, 2129: { n: "BrtBeginECTxtWiz15", f: parsenoop }, 2130: { n: "BrtEndECTxtWiz15", f: parsenoop }, 2131: { n: "BrtBeginECTWFldInfoLst15", f: parsenoop }, 2132: { n: "BrtEndECTWFldInfoLst15", f: parsenoop }, 2133: { n: "BrtBeginECTWFldInfo15", f: parsenoop }, 2134: { n: "BrtFieldListActiveItem", f: parsenoop }, 2135: { n: "BrtPivotCacheIdVersion", f: parsenoop }, 2136: { n: "BrtSXDI15", f: parsenoop }, 65535: { n: "", f: parsenoop } };
    var evert_RE = evert_key(RecordEnum, "n"); function parse_ods(zip, opts) { if (typeof module !== "undefined" && typeof require !== "undefined" && typeof ODS === "undefined") ODS = require("./dist/od" + "s"); if (typeof ODS === "undefined" || !ODS.parse_ods) throw new Error("Unsupported ODS"); return ODS.parse_ods(zip, opts) } function fix_opts_func(defaults) { return function fix_opts(opts) { for (var i = 0; i != defaults.length; ++i) { var d = defaults[i]; if (opts[d[0]] === undefined) opts[d[0]] = d[1]; if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]) } } } var fix_read_opts = fix_opts_func([["cellNF", false], ["cellHTML", true], ["cellFormula", true], ["cellStyles", false], ["cellDates", false], ["sheetStubs", false], ["sheetRows", 0, "n"], ["bookDeps", false], ["bookSheets", false], ["bookProps", false], ["bookFiles", false], ["bookVBA", false], ["WTF", false]]); var fix_write_opts = fix_opts_func([["cellDates", false], ["bookSST", false], ["bookType", "xlsx"], ["WTF", false]]); function safe_parse_wbrels(wbrels, sheets) { if (!wbrels) return 0; try { wbrels = sheets.map(function pwbr(w) { return [w.name, wbrels["!id"][w.id].Target] }) } catch (e) { return null } return !wbrels || wbrels.length === 0 ? null : wbrels } function safe_parse_ws(zip, path, relsPath, sheet, sheetRels, sheets, opts) { try { sheetRels[sheet] = parse_rels(getzipdata(zip, relsPath, true), path); sheets[sheet] = parse_ws(getzipdata(zip, path), path, opts, sheetRels[sheet]) } catch (e) { if (opts.WTF) throw e } } var nodirs = function nodirs(x) { return x.substr(-1) != "/" }; function parse_zip(zip, opts) { make_ssf(SSF); opts = opts || {}; fix_read_opts(opts); reset_cp(); if (safegetzipfile(zip, "META-INF/manifest.xml")) return parse_ods(zip, opts); var entries = keys(zip.files).filter(nodirs).sort(); var dir = parse_ct(getzipdata(zip, "[Content_Types].xml"), opts); var xlsb = false; var sheets, binname; if (dir.workbooks.length === 0) { binname = "xl/workbook.xml"; if (getzipdata(zip, binname, true)) dir.workbooks.push(binname) } if (dir.workbooks.length === 0) { binname = "xl/workbook.bin"; if (!getzipfile(zip, binname, true)) throw new Error("Could not find workbook"); dir.workbooks.push(binname); xlsb = true } if (dir.workbooks[0].substr(-3) == "bin") xlsb = true; if (xlsb) set_cp(1200); if (!opts.bookSheets && !opts.bookProps) { strs = []; if (dir.sst) strs = parse_sst(getzipdata(zip, dir.sst.replace(/^\//, "")), dir.sst, opts); styles = {}; if (dir.style) styles = parse_sty(getzipdata(zip, dir.style.replace(/^\//, "")), dir.style, opts); themes = {}; if (opts.cellStyles && dir.themes.length) themes = parse_theme(getzipdata(zip, dir.themes[0].replace(/^\//, ""), true), dir.themes[0], opts) } var wb = parse_wb(getzipdata(zip, dir.workbooks[0].replace(/^\//, "")), dir.workbooks[0], opts); var props = {}, propdata = ""; if (dir.coreprops.length !== 0) { propdata = getzipdata(zip, dir.coreprops[0].replace(/^\//, ""), true); if (propdata) props = parse_core_props(propdata); if (dir.extprops.length !== 0) { propdata = getzipdata(zip, dir.extprops[0].replace(/^\//, ""), true); if (propdata) parse_ext_props(propdata, props) } } var custprops = {}; if (!opts.bookSheets || opts.bookProps) { if (dir.custprops.length !== 0) { propdata = getzipdata(zip, dir.custprops[0].replace(/^\//, ""), true); if (propdata) custprops = parse_cust_props(propdata, opts) } } var out = {}; if (opts.bookSheets || opts.bookProps) { if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames; else if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) { return x.name }); if (opts.bookProps) { out.Props = props; out.Custprops = custprops } if (typeof sheets !== "undefined") out.SheetNames = sheets; if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out } sheets = {}; var deps = {}; if (opts.bookDeps && dir.calcchain) deps = parse_cc(getzipdata(zip, dir.calcchain.replace(/^\//, "")), dir.calcchain, opts); var i = 0; var sheetRels = {}; var path, relsPath; if (!props.Worksheets) { var wbsheets = wb.Sheets; props.Worksheets = wbsheets.length; props.SheetNames = []; for (var j = 0; j != wbsheets.length; ++j) { props.SheetNames[j] = wbsheets[j].name } } var wbext = xlsb ? "bin" : "xml"; var wbrelsfile = "xl/_rels/workbook." + wbext + ".rels"; var wbrels = parse_rels(getzipdata(zip, wbrelsfile, true), wbrelsfile); if (wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets); var nmode = getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0; for (i = 0; i != props.Worksheets; ++i) { if (wbrels) path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, ""); else { path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext; path = path.replace(/sheet0\./, "sheet.") } relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"); safe_parse_ws(zip, path, relsPath, props.SheetNames[i], sheetRels, sheets, opts) } if (dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts); out = { Directory: dir, Workbook: wb, Props: props, Custprops: custprops, Deps: deps, Sheets: sheets, SheetNames: props.SheetNames, Strings: strs, Styles: styles, Themes: themes, SSF: SSF.get_table() }; if (opts.bookFiles) { out.keys = entries; out.files = zip.files } if (opts.bookVBA) { if (dir.vba.length > 0) out.vbaraw = getzipdata(zip, dir.vba[0], true); else if (dir.defaults.bin === "application/vnd.ms-office.vbaProject") out.vbaraw = getzipdata(zip, "xl/vbaProject.bin", true) } return out } function add_rels(rels, rId, f, type, relobj) { if (!relobj) relobj = {}; if (!rels["!id"]) rels["!id"] = {}; relobj.Id = "rId" + rId; relobj.Type = type; relobj.Target = f; if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId); rels["!id"][relobj.Id] = relobj; rels[("/" + relobj.Target).replace("//", "/")] = relobj } function write_zip(wb, opts) { if (wb && !wb.SSF) { wb.SSF = SSF.get_table() } if (wb && wb.SSF) { make_ssf(SSF); SSF.load_table(wb.SSF); opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0 } opts.rels = {}; opts.wbrels = {}; opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0; var wbext = opts.bookType == "xlsb" ? "bin" : "xml"; var ct = { workbooks: [], sheets: [], calcchains: [], themes: [], styles: [], coreprops: [], extprops: [], custprops: [], strs: [], comments: [], vba: [], TODO: [], rels: [], xmlns: "" }; fix_write_opts(opts = opts || {}); var zip = new jszip; var f = "", rId = 0; opts.cellXfs = []; get_cell_style(opts.cellXfs, {}, { revssf: { General: 0 } }); f = "docProps/core.xml"; zip.file(f, write_core_props(wb.Props, opts)); ct.coreprops.push(f); add_rels(opts.rels, 2, f, RELS.CORE_PROPS); f = "docProps/app.xml"; if (!wb.Props) wb.Props = {}; wb.Props.SheetNames = wb.SheetNames; wb.Props.Worksheets = wb.SheetNames.length; zip.file(f, write_ext_props(wb.Props, opts)); ct.extprops.push(f); add_rels(opts.rels, 3, f, RELS.EXT_PROPS); if (wb.Custprops !== wb.Props && keys(wb.Custprops || {}).length > 0) { f = "docProps/custom.xml"; zip.file(f, write_cust_props(wb.Custprops, opts)); ct.custprops.push(f); add_rels(opts.rels, 4, f, RELS.CUST_PROPS) } f = "xl/workbook." + wbext; zip.file(f, write_wb(wb, f, opts)); ct.workbooks.push(f); add_rels(opts.rels, 1, f, RELS.WB); for (rId = 1; rId <= wb.SheetNames.length; ++rId) { f = "xl/worksheets/sheet" + rId + "." + wbext; zip.file(f, write_ws(rId - 1, f, opts, wb)); ct.sheets.push(f); add_rels(opts.wbrels, rId, "worksheets/sheet" + rId + "." + wbext, RELS.WS) } if (opts.Strings != null && opts.Strings.length > 0) { f = "xl/sharedStrings." + wbext; zip.file(f, write_sst(opts.Strings, f, opts)); ct.strs.push(f); add_rels(opts.wbrels, ++rId, "sharedStrings." + wbext, RELS.SST) } f = "xl/theme/theme1.xml"; zip.file(f, write_theme()); ct.themes.push(f); add_rels(opts.wbrels, ++rId, "theme/theme1.xml", RELS.THEME); f = "xl/styles." + wbext; zip.file(f, write_sty(wb, f, opts)); ct.styles.push(f); add_rels(opts.wbrels, ++rId, "styles." + wbext, RELS.STY); zip.file("[Content_Types].xml", write_ct(ct, opts)); zip.file("_rels/.rels", write_rels(opts.rels)); zip.file("xl/_rels/workbook." + wbext + ".rels", write_rels(opts.wbrels)); return zip } function readSync(data, opts) { var zip, d = data; var o = opts || {}; if (!o.type) o.type = has_buf && Buffer.isBuffer(data) ? "buffer" : "base64"; switch (o.type) { case "base64": zip = new jszip(d, { base64: true }); break; case "binary": zip = new jszip(d, { base64: false }); break; case "buffer": zip = new jszip(d); break; case "file": zip = new jszip(d = _fs.readFileSync(data)); break; default: throw new Error("Unrecognized type " + o.type) } return parse_zip(zip, o) } function readFileSync(data, opts) { var o = opts || {}; o.type = "file"; return readSync(data, o) } function writeSync(wb, opts) { var o = opts || {}; var z = write_zip(wb, o); switch (o.type) { case "base64": return z.generate({ type: "base64" }); case "binary": return z.generate({ type: "string" }); case "buffer": return z.generate({ type: "nodebuffer" }); case "file": return _fs.writeFileSync(o.file, z.generate({ type: "nodebuffer" })); default: throw new Error("Unrecognized type " + o.type) } } function writeFileSync(wb, filename, opts) { var o = opts || {}; o.type = "file"; o.file = filename; switch (o.file.substr(-5).toLowerCase()) { case ".xlsm": o.bookType = "xlsm"; break; case ".xlsb": o.bookType = "xlsb"; break } return writeSync(wb, o) } function decode_row(rowstr) { return parseInt(unfix_row(rowstr), 10) - 1 } function encode_row(row) { return "" + (row + 1) } function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2") } function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/, "$1") } function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for (; i !== c.length; ++i) d = 26 * d + c.charCodeAt(i) - 64; return d - 1 } function encode_col(col) { var s = ""; for (++col; col; col = Math.floor((col - 1) / 26)) s = String.fromCharCode((col - 1) % 26 + 65) + s; return s } function fix_col(cstr) { return cstr.replace(/^([A-Z])/, "$$$1") } function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/, "$1") } function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",") } function decode_cell(cstr) { var splt = split_cell(cstr); return { c: decode_col(splt[0]), r: decode_row(splt[1]) } } function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r) } function fix_cell(cstr) { return fix_col(fix_row(cstr)) } function unfix_cell(cstr) { return unfix_col(unfix_row(cstr)) } function decode_range(range) { var x = range.split(":").map(decode_cell); return { s: x[0], e: x[x.length - 1] } } function encode_range(cs, ce) { if (ce === undefined || typeof ce === "number") return encode_range(cs.s, cs.e); if (typeof cs !== "string") cs = encode_cell(cs); if (typeof ce !== "string") ce = encode_cell(ce); return cs == ce ? cs : cs + ":" + ce } function safe_decode_range(range) { var o = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }; var idx = 0, i = 0, cc = 0; var len = range.length; for (idx = 0; i < len; ++i) { if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break; idx = 26 * idx + cc } o.s.c = --idx; for (idx = 0; i < len; ++i) { if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break; idx = 10 * idx + cc } o.s.r = --idx; if (i === len || range.charCodeAt(++i) === 58) { o.e.c = o.s.c; o.e.r = o.s.r; return o } for (idx = 0; i != len; ++i) { if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break; idx = 26 * idx + cc } o.e.c = --idx; for (idx = 0; i != len; ++i) { if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break; idx = 10 * idx + cc } o.e.r = --idx; return o } function safe_format_cell(cell, v) { if (cell.z !== undefined) try { return cell.w = SSF.format(cell.z, v) } catch (e) { } if (!cell.XF) return v; try { return cell.w = SSF.format(cell.XF.ifmt || 0, v) } catch (e) { return "" + v } } function format_cell(cell, v) { if (cell == null || cell.t == null) return ""; if (cell.w !== undefined) return cell.w; if (v === undefined) return safe_format_cell(cell, cell.v); return safe_format_cell(cell, v) } function sheet_to_json(sheet, opts) { var val, row, range, header = 0, offset = 1, r, hdr = [], isempty, R, C, v; var o = opts != null ? opts : {}; var raw = o.raw; if (sheet == null || sheet["!ref"] == null) return []; range = o.range !== undefined ? o.range : sheet["!ref"]; if (o.header === 1) header = 1; else if (o.header === "A") header = 2; else if (Array.isArray(o.header)) header = 3; switch (typeof range) { case "string": r = safe_decode_range(range); break; case "number": r = safe_decode_range(sheet["!ref"]); r.s.r = range; break; default: r = range } if (header > 0) offset = 0; var rr = encode_row(r.s.r); var cols = new Array(r.e.c - r.s.c + 1); var out = new Array(r.e.r - r.s.r - offset + 1); var outi = 0; for (C = r.s.c; C <= r.e.c; ++C) { cols[C] = encode_col(C); val = sheet[cols[C] + rr]; switch (header) { case 1: hdr[C] = C; break; case 2: hdr[C] = cols[C]; break; case 3: hdr[C] = o.header[C - r.s.c]; break; default: if (val === undefined) continue; hdr[C] = format_cell(val) } } for (R = r.s.r + offset; R <= r.e.r; ++R) { rr = encode_row(R); isempty = true; row = header === 1 ? [] : Object.create({ __rowNum__: R }); for (C = r.s.c; C <= r.e.c; ++C) { val = sheet[cols[C] + rr]; if (val === undefined || val.t === undefined) continue; v = val.v; switch (val.t) { case "e": continue; case "s": break; case "b": case "n": break; default: throw "unrecognized type " + val.t } if (v !== undefined) { row[hdr[C]] = raw ? v : format_cell(val, v); isempty = false } } if (isempty === false) out[outi++] = row } out.length = outi; return out } function sheet_to_row_object_array(sheet, opts) { return sheet_to_json(sheet, opts != null ? opts : {}) } function sheet_to_csv(sheet, opts) { var out = "", txt = "", qreg = /"/g; var o = opts == null ? {} : opts; if (sheet == null || sheet["!ref"] == null) return ""; var r = safe_decode_range(sheet["!ref"]); var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0); var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0); var row = "", rr = "", cols = []; var i = 0, cc = 0, val; var R = 0, C = 0; for (C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C); for (R = r.s.r; R <= r.e.r; ++R) { row = ""; rr = encode_row(R); for (C = r.s.c; C <= r.e.c; ++C) { val = sheet[cols[C] + rr]; txt = val !== undefined ? "" + format_cell(val) : ""; for (i = 0, cc = 0; i !== txt.length; ++i) if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) { txt = '"' + txt.replace(qreg, '""') + '"'; break } row += (C === r.s.c ? "" : FS) + txt } out += row + RS } return out } var make_csv = sheet_to_csv; function sheet_to_formulae(sheet) { var cmds, y = "", x, val = ""; if (sheet == null || sheet["!ref"] == null) return ""; var r = safe_decode_range(sheet["!ref"]), rr = "", cols = [], C; cmds = new Array((r.e.r - r.s.r + 1) * (r.e.c - r.s.c + 1)); var i = 0; for (C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C); for (var R = r.s.r; R <= r.e.r; ++R) { rr = encode_row(R); for (C = r.s.c; C <= r.e.c; ++C) { y = cols[C] + rr; x = sheet[y]; val = ""; if (x === undefined) continue; if (x.f != null) val = x.f; else if (x.w !== undefined) val = "'" + x.w; else if (x.v === undefined) continue; else val = "" + x.v; cmds[i++] = y + "=" + val } } cmds.length = i; return cmds } var utils = { encode_col: encode_col, encode_row: encode_row, encode_cell: encode_cell, encode_range: encode_range, decode_col: decode_col, decode_row: decode_row, split_cell: split_cell, decode_cell: decode_cell, decode_range: decode_range, format_cell: format_cell, get_formulae: sheet_to_formulae, make_csv: sheet_to_csv, make_json: sheet_to_json, make_formulae: sheet_to_formulae, sheet_to_csv: sheet_to_csv, sheet_to_json: sheet_to_json, sheet_to_formulae: sheet_to_formulae, sheet_to_row_object_array: sheet_to_row_object_array }; XLSX.parseZip = parse_zip; XLSX.read = readSync; XLSX.readFile = readFileSync; XLSX.write = writeSync; XLSX.writeFile = writeFileSync; XLSX.utils = utils; XLSX.SSF = SSF
})(typeof exports !== "undefined" ? exports : XLSX);
//# sourceMappingURL=dist/xlsx.core.min.map
(function () {
  "use strict";

  angular.module("fuse").controller("MainController", MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $http) {
    // $rootScope.WebURL = '23.108.102.7:3820';
    // // $rootScope.WebURL = "localhost:3420";

    // $rootScope.UploadsURL = "https://23.108.102.7/PestOffUploads/";
    // $rootScope.ReportURL = "23.108.102.7/PestOff.Reports/Reports/";
    // $rootScope.DownloadURL = "https://23.108.102.7/PestOffReports/";
    // $rootScope.HelptURL = "https://23.108.102.7/PestOff/Help/";
    // $rootScope.ServicePhotosURL = "https://23.108.102.7/PestOffSchedulerPhotos/";

    // training

    // $rootScope.WebURL = '23.108.102.7:4002';
    // $rootScope.UploadsURL = 'https://23.108.102.7/PestOffTrainingUploads/'
    // $rootScope.ReportURL = '23.108.102.7/PestOffTraining.Reports/Reports/';
    // $rootScope.DownloadURL = 'https://23.108.102.7/PestOffTrainingReports/'
    // $rootScope.HelptURL = 'https://23.108.102.7/PestOff/Help/';
    // $rootScope.ServicePhotosURL = 'https://23.108.102.7/PestOffTrainingSchedulerPhotos/';

    // $rootScope.WebURL = 'localhost:3002';
    // $rootScope.UploadsURL = 'localhost/uploads/';
    // $rootScope.ReportURL = 'localhost/PestBusters.Reports/Reports/';
    // $rootScope.DownloadURL = 'E:\PestOff';

    $rootScope.createdby = localStorage.getItem("LoginID");
    $rootScope.Client_Id = localStorage.getItem("Client_Id");
    $rootScope.AllowExport = localStorage.getItem("AllowExport");
    $rootScope.currentPage = "";
    $rootScope.itemsPerPage = "";

    // Remove the splash screen
    $scope.$on("$viewContentAnimationEnded", function (event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast("msSplashScreen::remove");
      }
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  "use strict";

  angular
    .module("app.navigation")
    .controller("NavigationController", NavigationController);

  /** @ngInject */
  function NavigationController($scope, indexedDBService) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element("body");
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    if (localStorage.getItem("logo_url")) {
      var logo_string = indexedDBService.decryptString(
        localStorage.getItem("logo_url")
      );
      vm.logo = logo_string;
    }
    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on("$stateChangeSuccess", function () {
      vm.bodyEl.removeClass("ms-navigation-horizontal-mobile-menu-active");
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $qProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        $qProvider.errorOnUnhandledRejections(false);

        /*eslint-enable */
    }
})();
angular.module("fuse").factory("indexedDBService", function ($q) {
  var dbName = "PestoffDB";
  var dbVersion = 1;
  var encryptionKey = "SGT%&*sh(*^"; // Change to your secret key!
  // var TTL_DURATION = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
  var TTL_DURATION = 2 * 1000; // 2 seconds in milliseconds


  var db;

  // Open or create DB and stores
  function openDB() {
    var deferred = $q.defer();
    if (db) {
      deferred.resolve(db);
      return deferred.promise;
    }

    var request = indexedDB.open(dbName, dbVersion);

    request.onupgradeneeded = function (event) {
      db = event.target.result;
      var stores = ["customers", "contract", "work_order"];
      stores.forEach(function (store) {
        if (!db.objectStoreNames.contains(store)) {
          db.createObjectStore(store, { keyPath: "id" });
        }
      });
    };

    request.onsuccess = function (event) {
      db = event.target.result;
      deferred.resolve(db);
    };

    request.onerror = function (event) {
      deferred.reject(event.target.error);
    };

    return deferred.promise;
  }

  // Encrypt data using AES
  function encryptData(obj) {
    var stringified = JSON.stringify(obj);
    return CryptoJS.AES.encrypt(stringified, encryptionKey).toString();
  }

  // Decrypt data using AES
  function decryptData(cipherText) {
    try {
      var bytes = CryptoJS.AES.decrypt(cipherText, encryptionKey);
      var decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (err) {
      console.warn("Decryption failed", err);
      return null;
    }
  }

  function encryptString(str) {
    return CryptoJS.AES.encrypt(str, encryptionKey).toString();
  }

  function decryptString(cipherText) {
    try {
      var bytes = CryptoJS.AES.decrypt(cipherText, encryptionKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (err) {
      console.error("Failed to decrypt string:", err);
      return null;
    }
  }

  // Add or update multiple items
  function addAll(storeName, dataArray) {
    return openDB().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(storeName, "readwrite");
        var store = tx.objectStore(storeName);
        var now = Date.now();

        dataArray.forEach(function (item) {
          store.put({ id: item.id, data: encryptData(item), createdAt: now });
        });

        tx.oncomplete = function () {
          resolve();
        };
        tx.onerror = function (e) {
          reject(e.target.error);
        };
      });
    });
  }

  // Get all items and decrypt
  function getAll(storeName) {
    var deferred = $q.defer();
    openDB().then(function (db) {
      var tx = db.transaction(storeName, "readwrite");
      var store = tx.objectStore(storeName);
      var request = store.getAll();
      var now = Date.now();
      request.onsuccess = function () {
        var validItems = [];
        var expiredKeys = [];

        request.result.forEach(function (item) {
          if (now - item.createdAt < TTL_DURATION) {
            validItems.push(decryptData(item.data));
          } else {
            expiredKeys.push(item.id);
          }
        });

        // Delete expired items
        expiredKeys.forEach(function (key) {
          store.delete(key);
        });

        deferred.resolve(validItems);
      };
      request.onerror = function () {
        deferred.reject(request.error);
      };
    });

    return deferred.promise;
  }

  // Clear a store
  function clearStore(storeName) {
    return openDB().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(storeName, "readwrite");
        var store = tx.objectStore(storeName);
        var request = store.clear();

        request.onsuccess = function () {
          resolve();
        };
        request.onerror = function (e) {
          reject(e.target.error);
        };
      });
    });
  }

  // Update a single item
  function updateItem(storeName, item) {
    return openDB().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(storeName, "readwrite");
        var store = tx.objectStore(storeName);
        var now = Date.now();
        var request = store.put({
          id: item.id,
          data: encryptData(item),
          createdAt: now
        });
        request.onsuccess = function () {
          resolve();
        };
        request.onerror = function (e) {
          reject(e.target.error);
        };
      });
    });
  }

  // Delete a single item by key
  function deleteItem(storeName, key) {
    return openDB().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(storeName, "readwrite");
        var store = tx.objectStore(storeName);
        var request = store.delete(key);

        request.onsuccess = function () {
          resolve();
        };
        request.onerror = function (e) {
          reject(e.target.error);
        };
      });
    });
  }

  function clearAllStores() {
    var storeNames = ["customers", "contract", "work_order"];
    var clearPromises = storeNames.map(clearStore);
    return Promise.all(clearPromises);
  }


  return {
    addAll: addAll,
    getAll: getAll,
    clearStore: clearStore,
    updateItem: updateItem,
    deleteItem: deleteItem,
    encryptString: encryptString,
    decryptString: decryptString,
    clearAllStores: clearAllStores
  };
});

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes, DataSyncService) 
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;   

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function () {
  "use strict";

  angular.module("fuse").controller("IndexController", IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $http, $rootScope, indexedDBService) {
    var vm = this;
    // $rootScope.WebURL = "localhost:3420";
    // $rootScope.UploadsURL = "https://23.108.102.7/PestOffUploads/";
    var config = window.appConfig;
    $rootScope.WebURL = config.WebURL;
    $rootScope.UploadsURL = config.UploadsURL;
    $rootScope.ReportURL = config.ReportURL;
    $rootScope.DownloadURL = config.DownloadURL;
    // $rootScope.HelptURL = "https://23.108.102.7/DemoApp/Help/";
    $rootScope.ServicePhotosURL = config.ServicePhotosURL;
    $rootScope.XerobURL = config.popupUrl;
    // Data


    vm.themes = fuseTheming.themes;
    if (localStorage.getItem("logo_url")) {
      var logo_string = indexedDBService.decryptString(
        localStorage.getItem("logo_url")
      );
      vm.logo = logo_string;
      $rootScope.logo = logo_string;
    } else {
      $http
        .get($rootScope.WebURL + "/user/getUserInfo")
        .then(function (Clientdata) {
          var client = Clientdata.data.data[0];
          var logo_string =
            $rootScope.UploadsURL +
            "Security/Client/" +
            client.ClientID +
            ".png";
          var encrypted_log = indexedDBService.encryptString(logo_string);

          localStorage.setItem("logo_url", encrypted_log);

          vm.logo = logo_string;
          $rootScope.logo = logo_string;
        });
    }

    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide)
    {
        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('https://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('https://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('https://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('https://api.example.com/blog'),
         *                   getById  : $resource('https://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('https://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */


        api.dashboard = {
            project: $resource(api.baseUrl + 'dashboard/project/data.json'),
            server: $resource(api.baseUrl + 'dashboard/server/data.json'),
            analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
        };



        api.quickPanel = {
            activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
            contacts: $resource(api.baseUrl + 'quick-panel/contacts.json'),
            events: $resource(api.baseUrl + 'quick-panel/events.json'),
            notes: $resource(api.baseUrl + 'quick-panel/notes.json')
        };


        api.todo = {
            tasks: $resource(api.baseUrl + 'todo/tasks.json'),
            tags: $resource(api.baseUrl + 'todo/tags.json')
        };


        return api;
    }

})();
(function () {
  "use strict";

  angular.module("fuse").factory("authInterceptor", authInterceptor);

  /** @ngInject */
  function authInterceptor($q, $injector, $rootScope, $window) {
    var isRefreshing = false;
    var refreshPromise = null;
    var retryQueue = [];

    // Reject all queued requests
    function cancelAllQueuedRequests(reason) {
      retryQueue.forEach(function (deferred) {
        deferred.reject(reason);
      });
      retryQueue.length = 0;
    }

    return {
      request: function (config) {
        var token = localStorage.getItem("access_token");
        if (token) {
          config.headers.Authorization = "Bearer " + token;
        }
        config.withCredentials = true;
        return config;
      },

      responseError: function (rejection) {
        var $http = $injector.get("$http");
        var originalRequest = rejection.config;

        var isTokenIssue =
          rejection.status === 401 ||
          rejection.status === 403;

        if (isTokenIssue && !originalRequest.__isRetryRequest) {
          if (!isRefreshing) {
            isRefreshing = true;

            // Start refresh token request
            refreshPromise = $http.get($rootScope.WebURL + "/login/refresh_acces_token", {
              withCredentials: true
            }).then(function (res) {
              var newToken = res.data.data.token;
              localStorage.setItem("access_token", newToken);

              // Clear all queued requests
              cancelAllQueuedRequests("Page will reload to apply new token.");

              // Reload page so all requests start fresh
              $window.location.reload();
            }).catch(function (err) {
              cancelAllQueuedRequests(err || "Token refresh failed.");
              $rootScope.$broadcast("token:expired");
              return $q.reject(err);
            }).finally(function () {
              isRefreshing = false;
            });
          }

          // Queue up all requests while refresh is in progress
          var deferred = $q.defer();
          retryQueue.push(deferred);
          return deferred.promise; // This will not retry, just blocked/rejected
        }

        return $q.reject(rejection);
      }
    };
  }

  // Register the interceptor
  angular.module("fuse").config(function ($httpProvider) {
    $httpProvider.interceptors.push("authInterceptor");
  });
})();

angular
  .module("fuse")
  .factory(
    "DataSyncService",
    function (socket, indexedDBService, $rootScope, $log, $http, $q) {
      var storeEvents = {
        customer_change: "customers",
        contract_change: "contract",
        workorder_change: "work_order"
      };
      var CustomerCache = null;

      function getAllCustomers() {
        var deferred = $q.defer();

        indexedDBService.getAll("customers").then(function (data) {
          if (data && data.length > 0) {
            CustomerCache = data;
            $log.log("Customer loaded from IndexedDB");
            deferred.resolve(CustomerCache);
          } else {
            // Step 1: Get total length
            $http({
              method: "POST",
              url:
                $rootScope.WebURL + "/customer/getCustomerLength",
              data: { Client_Id: $rootScope.Client_Id },
            }).then(function (customerlength) {
              var total = customerlength.data.data;
              var limit = 1000;
              var totalChunks = Math.ceil(total / limit);
              var requests = [];

              for (var i = 0; i < totalChunks; i++) {
                var skip = i * limit;
                requests.push(
                  $http.post(

                    $rootScope.WebURL +
                    "/customer/newgetByskipLimit",
                    {
                      Client_Id: $rootScope.Client_Id,
                      Skip: skip,
                      Limit: limit,
                    }
                  )
                );
              }

              // Step 2: Fetch all chunks in parallel
              $q.all(requests).then(function (responses) {
                var customer_data = [];
                responses.forEach(function (res) {
                  customer_data = customer_data.concat(res.data.data);
                });

                CustomerCache = customer_data;

                // Step 3: Store in IndexedDB
                indexedDBService.clearStore("customers").then(function () {
                  indexedDBService
                    .addAll("customers", CustomerCache)
                    .then(function (data) {
                      deferred.resolve(CustomerCache);
                    });
                });
              });
            });
          }
        });

        return deferred.promise;
      }

      function getSalesOrderById(id) {
        return $http({
          url:
            $rootScope.WebURL + "/salesOrder/getSalesoderforsocket",
          method: "POST",
          data: { id: id },
        });
      }

      function getContractById(id) {
        return $http({
          url: $rootScope.WebURL + "/contract/getforSocket",
          method: "POST",
          data: { id: id },
        });
      }

      socket.on("Customer Created", function (newCustomer) {
        $http({
          url: $rootScope.WebURL + "/customer/getbyidforsocket",
          method: "POST",
          data: { _id: newCustomer.customer.id },
        }).then(function (List) {
          indexedDBService
            .addAll("customers", List.data.data)
            .then(function (data) {
              $log.log("New customer added to IndexedDB");
              $rootScope.$broadcast("customer_created", List.data.data[0]); // Broadcast to controllers
            });
        });
      });
      socket.on("Customer Modified", function (updatedCustomer) {
        $http({
          url: $rootScope.WebURL + "/customer/getbyidforsocket",
          method: "POST",
          data: { _id: updatedCustomer.data.id },
        }).then(function (List) {
          indexedDBService
            .updateItem("customers", List.data.data[0])
            .then(function (e) {
              $log.log("Customer updated in IndexedDB");
              $rootScope.$broadcast("customer_modified", List.data.data[0]);
            });
        });
      });

      socket.on("Customer Deleted", function (data) {
        indexedDBService.deleteItem("customers", data.List.id);
        remove_sales_order_data(data.List.id);
        $rootScope.$broadcast("customer_deleted", data.List.id); // Broadcast to controllers
      });

      // salesorder socket changes

      socket.on("salesOrder Created", function (item) {
        getSalesOrderById(item.salesorderid[0]).then(function (List) {
          indexedDBService
            .addAll("work_order", List.data.data)
            .then(function (data) {
              $log.log("New work_order added to IndexedDB");
              $rootScope.$broadcast("salesOrder_created", List.data.data[0]); // Broadcast to controllers
            });
        });
      });
      socket.on("salesOrder Modifies", function (item) {
        getSalesOrderById(item.data.id).then(function (List) {
          indexedDBService
            .updateItem("work_order", List.data.data[0])
            .then(function (e) {
              $log.log("work_order updated in IndexedDB");
              $rootScope.$broadcast("work_order_modified", List.data.data[0]);
            });
        });
      });
      socket.on("SalesOrder deleted", function (item) {
        indexedDBService.deleteItem("work_order", item.id);
        $rootScope.$broadcast("work_order_deleted"); // Broadcast to controllers
      });

      function remove_sales_order_data(customer_id) {
        indexedDBService.getAll("work_order").then(function (data) {
          if (data && data.length > 0) {
            // Keep only those entries that DO NOT match the customer_id
            var remainingData = data.filter(function (item) {
              return item.Customer_Id !== customer_id;
            });

            // Clear the store and re-save the filtered data
            indexedDBService.clearStore("work_order").then(function () {
              if (remainingData.length > 0) {
                indexedDBService
                  .addAll("work_order", remainingData)
                  .then(function () {
                    $log.log("Filtered data saved back to IndexedDB");
                    $rootScope.$broadcast("work_order_deleted"); // Broadcast to controllers
                  });
              } else {
                $log.log("No remaining data to save.");
              }
            });
          }
        });
      }

      socket.on("Contract Created", function (item) {
        getContractById(item.contracts[0].id).then(function (List) {
          indexedDBService
            .addAll("contract", List.data.data)
            .then(function (e) {
              $log.log("New contract added to IndexedDB");
              $rootScope.$broadcast("contract_created", List.data.data[0]); // Broadcast to controllers
            });
        });
      });
      socket.on("Contract Modified", function (item) {
        getContractById(item.data.id).then(function (List) {
          indexedDBService
            .updateItem("contract", List.data.data[0])
            .then(function (e) {
              $log.log("contract updated in IndexedDB");
              $rootScope.$broadcast("contract_modified", List.data.data[0]);
            });
        });
      });

      socket.on("Contract Terminated", function (item) {
        indexedDBService.deleteItem("contract", item.List.id);
        $rootScope.$broadcast("contract_deleted");
      });

      return {
        getAllCustomers: getAllCustomers,
        getSalesOrderById: getSalesOrderById,
        getContractById: getContractById
      };
    }
  );

(function () {
    'use strict';
    angular
        .module('app.human-resource.ttraining.training', [])
        .config(config);
    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.human-resource_ttraining_training', {
            url: '/Evaluation',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/human-resource/training/evaluation/evaluation.html',
                    controller: 'TtrainingController as vm'
                }
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accounts.pestoff.salesreceivables', ['ui.tree'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.accounts_psalesreceivables', {
            url: '/salesreceivables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/accounts/salesreceivables/salesreceivables.html',
                    controller: 'salesreceivablesController as vm'
                }
            }
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/accounts/salesreceivables');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.sales', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard_sales', {
            url      : '/dashboard-sales',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/sales/sales.html',
                    controller : 'SalesController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.operation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard_operation', {
            url      : '/dashboard-operation',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/operation/operation.html',
                    controller : 'OperationController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.management', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard_management', {
            url      : '/dashboard-management',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/management/management.html',
                    controller : 'ManagementController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.inventry', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard_inventry', {
            url      : '/dashboard-inventry',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/inventry/inventry.html',
                    controller : 'InventryController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.humanresource', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboard_humanresource', {
            url      : '/dashboard-humanresource',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboard/humanresource/humanresource.html',
                    controller : 'HumanresourceController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.security', [
            'app.security.clients',
            'app.security.user',
            'app.security.email',
            // 'app.security.workflow'
        ])
        .config(config)

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        //// Navigation
        var Security = 'Security';
        var Client_Licensor = 'Client/Licensor';
        var Users = 'Users';
        var Workflow = 'Workflow';
        
        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var Security = 'Bảo vệ';
            var Client_Licensor = 'Khách hàng / Người cấp phép';
            var Users = 'Người sử dụng';
            var Workflow = 'Quy trình làm việc';
        }

        var IsAccess = localStorage.getItem('pages');
            if (IsAccess == null) {
            return
            }
            if (IsAccess.split(",").includes("Client")) {
                msNavigationServiceProvider.saveItem('apps', {
                    title: 'APPS',
                    group: true,
                    weight: 1
                });
                msNavigationServiceProvider.saveItem('apps.security', {
                    title: Security,
                    icon: 'icon-security',
                    weight: 1
                });
                msNavigationServiceProvider.saveItem('apps.security.clients', {
                    title: Client_Licensor,
                    icon: ' icon-account-multiple-outline',
                    state: 'app.clients'
                });
            }
        if (IsAccess.split(",").includes("Users")) {
                msNavigationServiceProvider.saveItem('apps', {
                    title: 'APPS',
                    group: true,
                    weight: 1
                });
            msNavigationServiceProvider.saveItem('apps.security', {
                title: Security,
                icon: 'icon-security',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.security.user', {
                title: Users,
                icon: ' icon-account-circle',
                state: 'app.user'
            });
        }

        // if (IsAccess.split(",").includes("Workflow")) {
        //         msNavigationServiceProvider.saveItem('apps', {
        //             title: 'APPS',
        //             group: true,
        //             weight: 1
        //         });
        //     msNavigationServiceProvider.saveItem('apps.security', {
        //         title: Security,
        //         icon: 'icon-security',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.security.workflow', {
        //         title: Workflow,
        //         icon: 'icon-cube-outline',
        //         state: 'app.workflow'
        //     });
        // }
            if (IsAccess.split(",").includes("Email")) {
                msNavigationServiceProvider.saveItem('apps', {
                    title: 'APPS',
                    group: true,
                    weight: 1
                });
                msNavigationServiceProvider.saveItem('apps.security', {
                    title: Security,
                    icon: 'icon-security',
                    weight: 1
                });
                msNavigationServiceProvider.saveItem('apps.security.email', {
                  //  title: 'Email Notification',
                    icon: ' icon-email',
                    state: 'app.email'
                });
            }
      
        else{
           return 
        }
    }
        
    /** @ngInject */
     
})();


(function () {
  'use strict';

  angular
    .module('app.operations', [
      'app.operations.scheduler',
      'app.operations.services-master', 'app.operations.dashboard',
      'app.operations.feedback',
      'app.operations.report.detailanalytical',
      'app.operations.report.ConsumptionReport',
      'app.operations.report.BirdsCount',
      'app.operations.trendingReports.pastTrendingReports',
      'app.operations.trendingReports.pendingReports',
      'app.operations.trendingReports.setup',
      'app.human-resource.HcmAdmin.calendar',
      'mwl.calendar', 'ngAnimate', 'ui.bootstrap', 'colorpicker.module', 'app.operations.treatment',
      'app.operations.team', 'app.operations.services-jobs', 'app.operations.materials',
      'app.operations.areas', 'app.operations.checklist', 'app.operations.divisions', 'app.operations.scopeofwork',
      'app.operations.report.rodentsSummary',
      'app.operations.flexischeduler',
      'app.operations.pest-types',
      'app.operations.emailalert', 'ngMaterial'
    ])
    .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

    var Operations = 'Operations';
    var Dashboard = 'Dashboard';
    var Treatment = 'Treatment Methods';
    var Feedback = 'Feedback';
    var Teams = 'Teams';
    var Scheduler = 'Scheduler'; 
    var EmailAlert = 'Email Alerts';

    // Navigation
    var IsAccess = localStorage.getItem('pages');
    if (IsAccess == null) {
      return
    }
    msNavigationServiceProvider.saveItem('apps', {
      title: 'APPS',
      group: true,
      weight: 1
    });
    if (IsAccess.split(",").includes("DOperations")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-tile-four',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.dashboard', {
        title: Dashboard,
        icon: 'icon-view-dashboard',
        state: 'app.operations_dashboard',
        weight: 0
      });
    }
    if (IsAccess.split(",").includes("Scheduler")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.scheduler', {
        title: Scheduler,
        icon: 'icon-calendar',
        state: 'app.scheduler',
        weight: 1
      });

    }
    if (IsAccess.split(",").includes("Scheduler")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.flexischeduler', {
        title: 'Daily Scheduler',
        icon: 'icon-calendar',
        weight: 1,
        state: 'app.flexischeduler',
      });
    }

    if (IsAccess.split(",").includes("Teams")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.team', {
        title: Teams,
        icon: 'icon-sitemap',
        state: 'app.operations_team',
        weight: 2
      });
      msNavigationServiceProvider.saveItem('apps.operations.services-jobs', {
        icon: 'icon-clipboard-text',
        state: 'app.servicesjobs',
        weight: 2
      });
    }
    if (IsAccess.split(",").includes("PestType")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.pest-types', {
        title: 'Pest Types',
        state: 'app.pest-types',
        icon: 'icon icon-bug',
        weight: 3
      });
    }
    if (IsAccess.split(",").includes("Treatment")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.treatment', {
        title: Treatment,
        icon: 'icon-flattr',
        state: 'app.treatment',
        weight: 4
      });
    }
    // if (IsAccess.split(",").includes("Treatment")) {
    //   msNavigationServiceProvider.saveItem('apps.operations', {
    //     title: Operations,
    //     icon: 'icon-cog-box',
    //     weight: 1
    //   });
    //   msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.calendar', {
    //     title: 'Calendar',
    //     icon: 'icon icon-calendar',
    //     state: 'app.human-resource_HcmAdmin_calendar',
    //     weight: 2
    // });
    // }
   
    if (IsAccess.split(",").includes("Feedback")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.feedback', {
        title: Feedback,
        icon: 'icon-sitemap',
        state: 'app.operations_feedback',
        weight: 5
      });
    }
    if (IsAccess.split(",").includes("EmailAlerts")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.emailalert', {
        title: EmailAlert,
        icon: 'icon-message-alert',
        state: 'app.operations_emailalert',
        weight: 6
      });
    }
 
    if (IsAccess.split(",").includes("TrendingReport")) {
      msNavigationServiceProvider.saveItem('apps.operations', {
        title: Operations,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.operations.trendingReports', {
        title: 'Trending Reports',
        icon: 'icon-file-multiple',
        weight: 6
      });
      msNavigationServiceProvider.saveItem('apps.operations.trendingReports.setup', {
        title: 'Setup', 
        state: 'app.operations_trendingreport_setup'
      });
      msNavigationServiceProvider.saveItem('apps.operations.trendingReports.pendingReports', {
        title: 'Pending Reports',
        state: 'app.operations_trendingreport_pendingreports'
      });
      msNavigationServiceProvider.saveItem('apps.operations.trendingReports.pastTrendingReports', {
        title: 'Past Trending Reports',
        state: 'app.operations_trendingreport_pasttrendingreports'
      }); 
    }
    else {
      return
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.procurement', [

             'app.procurement.dashboard',
             'app.procurement.settings',
             'app.procurement.product',
             'app.procurement.suppliers',
             'app.procurement.store',
             'app.procurement.purchaserequisition',
             'app.procurement.materialrequisition',
             'app.procurement.uniformrequisition',
             'app.procurement.request.material',
             'app.procurement.request.purchase',
             'app.procurement.purchaseorder',
             'app.procurement.stock.stocklist',
             'app.procurement.stock.lighttraplist',
             'app.procurement.stock.issuance',
             'app.procurement.stock.return',
             'app.procurement.stock.deliverynote',
             'app.procurement.stock.vehicle',
             'app.procurement.equipmentrequest',
             'app.procurement.Chemicalrequest',
             'app.procurement.stock.Equipment',
             'app.procurement.stock.Chemical',
             'app.procurement.stock.EquipmentReturn',

        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {

        var Procurement = 'Procurement';
        var Dashboard = 'Dashboard';
        var Setting = 'Settings';
        var Products = 'Products';
        var Suppliers = 'Suppliers';
        var Stores ='Stores';
        var Requests = 'Requests';
        var StockRequest = 'Stock Requisition';
        var PurchaseRequest = 'Purchase Requisition';
        var PurchaseOrder = 'Purchase Order';
        var StockManagement = 'Stock Management';
        var StockList = 'Stock List';
        var StockReturn = 'Stock Return';
        var StockIssuance = 'Stock Issuance';
        var LightTrap = 'RATSENSE';
        var DeliveryNote = 'Delivery Note';
        var Vehicle = 'Vehicle Management'
        var ChemicalRequest = 'Chemical Request';

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var Procurement = 'Tạp vụ';
            var Dashboard = 'bảng điều khiển';
            var Setting = 'bảng điều khiển';
            var Products = 'Các sản phẩm';
            var Suppliers = 'Các nhà cung cấp';
            var Stores ='Cửa hàng';
            var Requests = 'Yêu cầu';
            var StockRequest = 'Yêu cầu vật liệu';
            var PurchaseRequest = 'Yêu cầu Mua';
            var PurchaseOrder = 'Đơn mua hàng';
            var StockManagement = 'Quản lý chứng khoán';
            var StockList = 'Danh mục chứng khoán';
            var StockReturn = 'Trả lại cổ phiếu';
            var StockIssuance = 'Phát hành cổ phiếu';
            var LightTrap = 'Danh sách bẫy ánh sáng';
            var Vehicle = 'Quản lý xe'
            var ChemicalRequest = 'Hóa chất';
        }



        // Navigation
        var IsAccess = localStorage.getItem('pages');
        
        if (IsAccess == null) {
            return
        }
        if (IsAccess.split(",").includes("DProcurement")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-tile-four',
                weight: 1,
                badge:{
                    content : (parseInt(sessionStorage.getItem('ChemicalCount')) + parseInt(sessionStorage.getItem('ChemicalInvCount'))) >0 ? (parseInt(sessionStorage.getItem('ChemicalCount')) + parseInt(sessionStorage.getItem('ChemicalInvCount'))) : '',
                    color:'#0094ac'
                }
            });
            msNavigationServiceProvider.saveItem('apps.procurement.dashboard', {
                title: Dashboard,
                icon: ' icon-view-dashboard',
                state: 'app.procurement_dashboard'
            });
        }
        if (IsAccess.split(",").includes("Supliers")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-document',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.procurement.suppliers', {
                title: Suppliers,
                icon: 'icon-account-multiple',
                state: 'app.suppliers'
            });
        }
        if (IsAccess.split(",").includes("EquipmentRequest")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-document',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.procurement.equipmentrequest', {
                title: 'Equipment Request',
                icon: 'icon-houzz-box',
                state: 'app.equipmentrequest'
            });
        }
        if (IsAccess.split(",").includes("ChemicalRequest")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-document',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.procurement.Chemicalrequest', {
                title: ChemicalRequest,
                icon: 'icon-basket-unfill',
                state: 'app.Chemicalrequest',
                weight: 1,
                badge:{
                    content :parseInt(sessionStorage.getItem('ChemicalCount')) >0 ? sessionStorage.getItem('ChemicalCount') : '',
                    color:'red'
                }
            });
        }
      
        if (IsAccess.split(",").includes("StockManagement")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-document',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.procurement.stock', {
                title: StockManagement,
                icon: 'icon-package-variant-closed',
                badge:{
                    content :parseInt(sessionStorage.getItem('ChemicalInvCount')) >0 ? sessionStorage.getItem('ChemicalInvCount') : '',
                    color:'#0094ac'
                }
            });
            // msNavigationServiceProvider.saveItem('apps.procurement.stock.stocklist', {
            //     title: StockList,
            //     icon: 'icon-format-list-bulleted',
            //     state: 'app.procurement_stock_stocklist'
            // });
            // msNavigationServiceProvider.saveItem('apps.procurement.stock.lighttraplist', {
            //     title: LightTrap,
            //     icon: 'icon-houzz-box',
            //     state: 'app.procurement_stock_lighttraplist'
            // });
            // msNavigationServiceProvider.saveItem('apps.procurement.stock.issuance', {
            //     title: StockIssuance,
            //     icon: 'icon-home-modern',
            //     state: 'app.procurement_stock_issuance'
            // });
            // msNavigationServiceProvider.saveItem('apps.procurement.stock.return', {
            //     title: StockReturn,
            //     icon: 'icon-hops',
            //     state: 'app.procurement_stock_return'
            // });
            msNavigationServiceProvider.saveItem('apps.procurement.stock.Equipment', {
                title: 'Equipment Inventory',
                icon: 'icon-trello',
                state: 'app.stock_Equipment'
            });
            msNavigationServiceProvider.saveItem('apps.procurement.stock.Chemical', {
                title: 'Chemical Inventory',
                icon: 'icon-delete-variant',
                state: 'app.stock_Chemical',
                badge:{
                    content :parseInt(sessionStorage.getItem('ChemicalInvCount')) >0 ? sessionStorage.getItem('ChemicalInvCount') : '',
                    color:'red'
                }
            });
            msNavigationServiceProvider.saveItem('apps.procurement.stock.deliverynote', {
                title: 'Delivery Order',
                icon: 'icon-hops',
                state: 'app.procurement_stock_deliverynote'
            });
            msNavigationServiceProvider.saveItem('apps.procurement.stock.vehicle', {
                    title: Vehicle,
                    icon: 'icon-bus',
                    state: 'app.vehicle'
                });
                msNavigationServiceProvider.saveItem('apps.procurement.stock.EquipmentReturn', {
                    title: "Technician Inventory",
                    icon: 'icon-trello',
                    state: 'app.stock_EquipmentReturn'
                });
            }
        //if (IsAccess.split(",").includes("ProSettings")) {
        if (IsAccess.split(",").includes("ProcurementSettings")) {
            msNavigationServiceProvider.saveItem('apps.procurement', {
                title: Procurement,
                icon: 'icon-document',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.procurement.settings', {
                title: Setting,
                icon: 'icon-store',
                state: 'app.Prosettings',
                weight: 1
            });
        }
    //     if (IsAccess.split(",").includes("Products")) {
    //     msNavigationServiceProvider.saveItem('apps', {
    //         title: 'APPS',
    //         group: true,
    //         weight: 1
    //     });
    //     msNavigationServiceProvider.saveItem('apps.procurement', {
    //         title: Procurement,
    //         icon: 'icon-document',
    //         weight: 1
    //     });
    //     msNavigationServiceProvider.saveItem('apps.procurement.product', {
    //         title:Products,
    //         icon: 'icon-wallet-membership',
    //         state: 'app.product'
    //     });
    // }
        
        // if (IsAccess.split(",").includes("Stores")) {
        // msNavigationServiceProvider.saveItem('apps.procurement', {
        //     title: Procurement,
        //     icon: 'icon-document',
        //     weight: 1
        // });
        // msNavigationServiceProvider.saveItem('apps.procurement.store', {
        //     title: Stores,
        //     icon: 'icon-store',
        //     state: 'app.store'
        // });
        // }
        
       
        // if (IsAccess.split(",").includes("Requests")) {
        // msNavigationServiceProvider.saveItem('apps.procurement.request', {
        //     title: Requests,
        //     icon: 'icon-package-variant',
        // });
        // msNavigationServiceProvider.saveItem('apps.procurement.request.material', {
        //     title: StockRequest,
        //     icon: 'icon-layers',
        //     state: 'app.procurement_request_material'
        // });
        // msNavigationServiceProvider.saveItem('apps.procurement.request.purchase', {
        //     title: PurchaseRequest,
        //     icon: 'icon-keg',
        //     state: 'app.procurement_request_purchase'
        // });
        // }
    //     if (IsAccess.split(",").includes("PurchaseOrder")) {
    //     msNavigationServiceProvider.saveItem('apps.procurement', {
    //         title: Procurement,
    //         icon: 'icon-document',
    //         weight: 1
    //     });
    //     msNavigationServiceProvider.saveItem('apps.procurement.purchaseorder', {
    //         title: PurchaseOrder,
    //         icon: 'icon-package',
    //         state: 'app.purchaseorder'
    //     });
    // }
       
       
      
        else{
           return 
        }
      
    }

})();
(function () {
    'use strict';
    angular
        .module('app.human-resource', [

             'app.human-resource.dashboard',
             'app.human-resource.hrmusers',
             'app.human-resource.workflow',

            'app.human-resource.HcmAdmin.organization',
            'app.human-resource.HcmAdmin.job',
            'app.human-resource.HcmAdmin.qualification',
            'app.human-resource.HcmAdmin.data',
            // 'app.human-resource.HcmAdmin.hrpolicy',
            'app.human-resource.HcmAdmin.workweek',
            'app.human-resource.HcmAdmin.calendar',
            // 'app.human-resource.HcmAdmin.autoattendance',

            'app.human-resource.HcmAdmin.employee',
            'app.human-resource.HcmCore.leave',
            // 'app.human-resource.HcmCore.appraisal.template',
            // 'app.human-resource.HcmCore.appraisal.eappraisal',
            // 'app.human-resource.HcmAdmin.contracttemplate',
            // 'app.human-resource.HcmCore.expirydetails',
            'app.human-resource.HcmAdmin.pass',

            'app.human-resource.leaveentitlement',
            // 'app.human-resource.HcmLeave.leaveapproval',
             
            // 'app.human-resource.payroll.payrollsetting',
            // 'app.human-resource.payroll.allowances',
            // 'app.human-resource.payroll.payslip',
            //     'app.human-resource.payroll.endmonth',
            // 'app.human-resource.payroll.midmonth',
            // 'app.human-resource.payroll.iras',
            // 'app.human-resource.payroll.cpf',

            'app.human-resource.health.checkup',
            //'app.human-resource.HcmAdmin.medical',
            'app.human-resource.HcmAdmin.incident',
            'app.human-resource.health.eshbreifing',
            'app.human-resource.health.eshattendance',

            // 'app.human-resource.timelog.attendance',
            // 'app.human-resource.timelog.monthlyplan',
            // 'app.human-resource.timelog.shift',

            'app.human-resource.performance.review',
            'app.human-resource.performance.tracker',
            // 'app.human-resource.performance.template',

            'app.human-resource.insurance.master',
            'app.human-resource.insurance.items',

            'app.human-resource.training.training',
            'app.human-resource.training.traininglist',
            // 'app.human-resource.training.training',
            // 'app.human-resource.training.calender',
            // 'app.human-resource.training.administration',
            // 'app.human-resource.training.administration.courseschedule',
            // 'app.human-resource.training.report',

            // 'app.human-resource.recruitment', 
            // 'app.human-resource.HcmCore.contracttemplate',

            'app.human-resource.incidentform',
            'app.human-resource.medicalform',
            'app.human-resource.leaveform',
           
            
        ])
        .config(config);

    /* @ngInject */
    function config(msNavigationServiceProvider) {
        // Navigation

        var HumanResource = 'Human Resource';
        var Dashboard = 'Dashboard';
        var Users = 'Users';
        var Workflow = 'Workflow';
        var Hrmadmin = 'HRM Admin';
        var Organization = 'Organization Setup';
        var Job = 'Job Categories';
        var Qualification = 'Qualification & Skills';
        var Hrpolicy = 'HR Policy';
        var Workweek = 'Work Week Settings';
        var calendar = 'Calendar';
        var AutoAttendance = 'AutoAttendance';
        var Hrmcore = 'HRM Core';
        var Employee = 'Employee Profile';
        var Eleaves = 'E-Leaves';
        var Appraisals = 'Appraisals';
        var ApprasisalTemplate = 'Appraisal Templates';
        var EmployeeAppraisals = 'Employee Appraisals';
        var ContractTemplate = 'Templates';
        var ELeaves = 'E-Leaves';
        var LeaveEntitlement = 'Leave Entitlement';
        var LeaveApproval = 'Leave Approval';
        var PassManagement = 'Pass Management';
        var ExpiryDetails = 'Expiry Details';
        var Health_Safety = 'Health & Safety';
        var MedicalClaims = 'Medical Claims';
        var MedicalCheckup = 'Medical Checkup';
        var IncidentReports = 'Incident Reports';
        var ESHBriefing = 'ESH Briefing';
        var ESHAttendance = 'ESH Attendance';
        var Training ='Training';
        var CourseProgress = 'Course Progress';
        var CourseAdministration = 'Course Administration';
        var Insurance = 'Insurance';
        var InsuranceMaster = 'Insurance Master';
        var InsuranceItems = 'Insurance Items';
        var Recruitment = 'Recruitment';
        var Timelog = 'Timelog';
        var Shift = 'Shift';
        var MothlyPlan = 'Monthly Plan';
        var Attendance = 'Attendance';
        var Payroll = 'Payroll';
        var PayrollSettings = 'Payroll Settings';
        var Allowance = 'Allowances/Deductions';
        var PayrollSummary = 'Payroll Summary Report';
        var PerformanceReview = 'Performance Review';
        var PerformanceTracker = 'Performance Tracker';
        var Template = 'Template'

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var HumanResource = 'Nguồn nhân lực';
            var Dashboard = 'bảng điều khiển';
            var Users = 'Người sử dụng';
            var Workflow = 'Quy trình làm việc';
            var Hrmadmin = 'Quản trị nhân sự';
            var Organization = 'Thiết lập tổ chức';
            var Job = 'Danh mục Công việc';
            var Qualification = 'Văn bằng & Kỹ năng';
            var Hrpolicy = 'Chính sách Nhân sự';
            var Workweek = 'Cài đặt Tuần Làm việc';
            var calendar = 'Lịch';
            var Hrmcore = 'Nhân lực cốt lõi';
            var Employee = 'Hồ sơ nhân viên';
            var Eleaves = 'E-Lá';
            var Appraisals = 'Đánh giá';
            var ApprasisalTemplate = 'Mẫu Thẩm định';
            var EmployeeAppraisals = 'Đánh giá nhân viên';
            var ContractTemplate = 'Mẫu Hợp đồng';
            var PassManagement = 'Quản lý qua';
            var ExpiryDetails = 'Chi tiết Hết hạn';
            var Health_Safety = 'sức khỏe và an toàn';
            var MedicalClaims = 'Yêu cầu Y khoa';
            var MedicalCheckup = 'Kiểm tra sức khỏe';
            var IncidentReports = 'Báo cáo sự cố';
            var ESHBriefing = 'ESH Cuộc họp';
            var ESHAttendance = 'ESH Tham dự';
            var Training ='Đào tạo';
            var CourseProgress = 'Tiến độ khóa học';
            var CourseAdministration = 'Quản trị Khóa học';
            var Insurance = 'Bảo hiểm';
            var InsuranceMaster = 'Bảo hiểm Master';
            var InsuranceItems = 'Các hạng mục bảo hiểm';
            var Recruitment = 'Tuyển dụng';
            var Timelog = 'Đăng nhập lần';
            var Shift = 'ngày làm việc';
            var MothlyPlan = 'Kế hoạch hàng tháng';
            var Attendance = 'Tham dự';
            var Payroll = 'Lương bổng';
            var PayrollSettings = 'Cài đặt biên chế';
            var Allowance = 'Các khoản trợ cấp / khấu trừ';
            var PayrollSummary = 'Báo cáo tóm tắt biên chế';
            var PerformanceReview = 'Đánh giá hiệu suất';
            var PerformanceTracker = 'Tracker Hiệu suất';
            var Template = 'Bản mẫu'
        }

        msNavigationServiceProvider.saveItem('apps', {
            title: 'APPS',
            group: true,
            weight: 1
        });
        var IsAccess = localStorage.getItem('pages');
        if (IsAccess == null) {
            return
        }
      
        if (IsAccess.split(",").includes("DHuman")) {
            msNavigationServiceProvider.saveItem('apps.human-resource', {
                title: HumanResource,
                icon: 'icon-tile-four',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.dashboard', {
                title: Dashboard,
                state: 'app.human-resource_dashboard',
                weight: 0
            });
        }
        if (IsAccess.split(",").includes("ELeaves")) {
            // if (IsAccess.split(",").includes("HRMCore")) {
                // msNavigationServiceProvider.saveItem('apps.human-resource', {
                //     title: HumanResource,
                //     icon: 'icon-account-box-outline',
                //     weight: 1
                // });
                // msNavigationServiceProvider.saveItem('apps.human-resource.HcmLeave', {
                //     title: ELeaves,
                //     weight: 5,
                //     //icon: 'icon-worker',
                // });
                msNavigationServiceProvider.saveItem('apps.human-resource.leaveentitlement', {
                    title: LeaveApproval,
                    //icon: 'icon-account-box',
                    state: 'app.human-resource_HcmLeave_leaveentitlement',
                    weight: 2,
                });
                // msNavigationServiceProvider.saveItem('apps.human-resource.HcmLeave.leaveapproval', {
                //     title: LeaveApproval,
                //     //icon: 'icon-worker',
                //     state: 'app.human-resource_HcmLeave_leaveapproval'
                // });
            }
        // if (IsAccess.split(",").includes("Hrmusers")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.hrmusers', {
        //         title: Users,
        //         weight: 1,
        //         state: 'app.human-resource_hrmusers',
        //     });
        // }
        // if (IsAccess.split(",").includes("Hrmusers")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.workflow', {
        //         title: Workflow,
        //         weight: 2,
        //         state: 'app.human-resource_workflow',
        //     });
        // }
        if (IsAccess.split(",").includes("HRMAdmin")) {
            msNavigationServiceProvider.saveItem('apps.human-resource', {
                title: HumanResource,
                icon: 'icon-account-box-outline',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin', {
                title: Hrmadmin,
                weight: 3,
                //icon: 'icon-verified'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.employee', {
                title: Employee,
                //icon: 'icon-account-box',
                state: 'app.human-resource_HcmAdmin_employee'
            });
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.contracttemplate', {
            //     title: ContractTemplate,
            //     //icon: 'icon-worker',
            //     state: 'app.human-resource_HcmAdmin_contracttemplate'
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.pass', {
            //     title: PassManagement,
            //     //icon: 'icon-clock',
            //     state: 'app.human-resource_HcmAdmin_pass'
            // });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.qualification', {
                title: Qualification,
                //icon: 'icon-school',
                state: 'app.human-resource_HcmAdmin_qualification'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.calendar', {
                title: calendar,
                //icon: 'icon-data',
                state: 'app.human-resource_HcmAdmin_calendar'
            });
           
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.organization', {
                title: Organization,
                //icon: 'icon-home-variant',
                state: 'app.human-resource_HcmAdmin_organization'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.job', {
                title: Job,
                //icon: 'icon-home-variant',
                state: 'app.human-resource_HcmAdmin_job'
            });
          
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.data', {
                // title: 'Data Import',
                //icon: 'icon-data',
                state: 'app.human-resource_HcmAdmin_data'
            });

            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.medical', {
            //     title: "Medical Certificate",
            //     state: 'app.human-resource_health_medical'
            // });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.incident', {
                title: IncidentReports,
                state: 'app.human-resource_health_incident'
            });
            
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.hrpolicy', {
            //     title: Hrpolicy,
            //     //icon: 'icon-data',
            //     state: 'app.human-resource_HcmAdmin_hrpolicy'
            // });
            msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.workweek', {
                title: Workweek,
                //icon: 'icon-data',
                state: 'app.human-resource_HcmAdmin_workweek'
            });
         
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmAdmin.autoattendance', {
            //     title: AutoAttendance,
            //     //icon: 'icon-data',
            //     state: 'app.human-resource_HcmAdmin_autoattendance'
            // });
           
        }
        if (IsAccess.split(",").includes("Training")) {
            msNavigationServiceProvider.saveItem('apps.human-resource', {
                title: HumanResource,
                icon: 'icon-account-box-outline',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.training', {
                title: "Training",
                weight: 4,
                //icon: 'icon-worker'
            });
            // msNavigationServiceProvider.saveItem('apps.human-resource.training', {
            //     title: Training,
            //     weight: 7,
            //     //icon: 'icon-worker'
            // });
            msNavigationServiceProvider.saveItem('apps.human-resource.training.training', {
                 title: 'Personnel Training',
                //icon: 'icon-worker',
                state: 'app.human-resource_training_training'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.training.traininglist', {
                title: 'Training List',
               //icon: 'icon-worker',
               state: 'app.human-resource_training_traininglist'
           });
            // msNavigationServiceProvider.saveItem('apps.human-resource.training.calender', {
            //     title: CourseAdministration,
            //     //icon: 'icon-calendar',
            //     state: 'app.human-resource_training_calender'
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.training.administration', {
            //     title: CourseProgress,
            //     //icon: 'icon-worker',
            //     state: 'app.human-resource_training_administration'
            // });
             
            // msNavigationServiceProvider.saveItem('apps.human-resource', {
            //     title: HumanResource,
            //     icon: 'icon-account-box-outline',
            //     weight: 1
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.training.report', {
            //     //  title: 'Reports',
            //     //icon: 'icon-note',
            //     state: 'app.human-resource_training_report'
            // });
        }
        if (IsAccess.split(",").includes("Insurance")) {
            msNavigationServiceProvider.saveItem('apps.human-resource', {
                title: HumanResource,
                icon: 'icon-account-box-outline',
                weight: 1
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.insurance', {
                title: Insurance,
                weight: 5,
                //icon: 'icon-worker'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.insurance.master', {
                title: "General Insurance",
                //icon: 'icon-worker',
                state: 'app.human-resource_insurance_master'
            });
            msNavigationServiceProvider.saveItem('apps.human-resource.insurance.items', {
                title: "Vehicle Insurance",
                //icon: 'icon-calendar',
                state: 'app.human-resource_insurance_items'
            });
            
        }
        // if (IsAccess.split(",").includes("HRMCore")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore', {
        //         title: Hrmcore,
        //         weight: 4,
        //         //icon: 'icon-worker',
        //     });
           

            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore.appraisal', {
            //     title: Appraisals,
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore.appraisal.template', {
            //     title: ApprasisalTemplate,
            //     //icon: 'icon-note',
            //     state: 'app.human-resource_HcmCore_appraisal_template'
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore.appraisal.eappraisal', {
            //     title: EmployeeAppraisals,
            //     //icon: 'icon-note',
            //     state: 'app.human-resource_HcmCore_appraisal_eappraisal'
            // });

           
            
            // 
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore.expirydetails', {
            //    title: ExpiryDetails,
            //     //icon: 'icon-worker',
            //     state: 'app.human-resource_HcmCore_expirydetails'
            // });
            // msNavigationServiceProvider.saveItem('apps.human-resource.HcmCore.contracttemplate', {
            //     title: ContractTemplate,
            //     //icon: 'icon-worker',
            //     state: 'app.human-resource_contracttemplate'
            // });
        // }
     
        // if (IsAccess.split(",").includes("Health")) {
        // msNavigationServiceProvider.saveItem('apps.human-resource.health', {
        //     title: Health_Safety,
        //     weight: 6,
        // });
        // msNavigationServiceProvider.saveItem('apps.human-resource.health.checkup', {
        //     title: MedicalCheckup,
        //     state: 'app.human-resource_health_checkup'
        // });
       
        //msNavigationServiceProvider.saveItem('apps.human-resource.health.eshbreifing', {
        //    title: ESHBriefing,
        //    state: 'app.human-resource_health_eshbreifing'
        //});
        //msNavigationServiceProvider.saveItem('apps.human-resource.health.eshattendance', {
        //    title: ESHAttendance,
        //    state: 'app.human-resource_health_eshattendance'
        //});
        // }
       
       
       
        // if (IsAccess.split(",").includes("Recruitment")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.recruitment', {
        //         title: Recruitment,
        //         weight: 9,
        //         state: 'app.human-resource_recruitment'
        //     });
        // }
        // if (IsAccess.split(",").includes("Timelog")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.timelog', {
        //         title: Timelog,
        //         weight: 10,
        //         //icon: 'icon-worker',
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.timelog.shift', {
        //         title: Shift,
        //         //icon: 'icon-clock',
        //         state: 'app.human-resource_timelog_shift'
        //     });
       
        //     msNavigationServiceProvider.saveItem('apps.human-resource.timelog.monthlyplan', {
        //         title: MothlyPlan,
        //      //icon: 'icon-clock',
        //         state: 'app.human-resource_timelog_monthlyplan'
        //  });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.timelog.attendance', {
        //         title: Attendance,
        //         //icon: 'icon-clock',
        //         state: 'app.human-resource_timelog_attendance'
        //     });
        // }
        // if (IsAccess.split(",").includes("Payroll")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll', {
        //         title: Payroll,
        //         weight: 11,
        //     });
           
        //     // msNavigationServiceProvider.saveItem('apps.human-resource.payroll.allowances', {
        //     //     title: 'Settings',
        //     //     state: 'app.human-resource_payroll_allowances'
        //     // });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.payrollsetting', {
        //         title: 'Payroll Settings',
        //         state: 'app.human-resource_payroll_payrollsetting'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.payslip', {
        //         //title: 'Payroll Summary Report',
        //         state: 'app.human-resource_payroll_payslip'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.endmonth', {
        //         title: 'End Month Payroll',
        //         state: 'app.human-resource_payroll_endmonth'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.midmonth', {
        //         title: 'Mid Month Payroll',
        //         state: 'app.human-resource_payroll_midmonth'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.cpf', {
        //         title: 'Payroll/CPF Submission',
        //         state: 'app.human-resource_payroll_cpf'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.payroll.iras', {
        //         title: 'IRAS Submission',
        //         state: 'app.human-resource_payroll_iras'
        //     });
        //   }
        // if (IsAccess.split(",").includes("Performance")) {
        //     msNavigationServiceProvider.saveItem('apps.human-resource', {
        //         title: HumanResource,
        //         icon: 'icon-account-box-outline',
        //         weight: 1
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.performance', {
        //         //  title: 'Performance Assessment',
        //         //weight: 12,
        //         //icon: 'icon-worker'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.performance.review', {
        //         title: PerformanceReview,
        //         //icon: 'icon-worker',
        //         state: 'app.human-resource_performance_review'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.performance.tracker', {
        //         title: PerformanceTracker,
        //         //icon: 'icon-worker',
        //         state: 'app.human-resource_performance_tracker'
        //     });
        //     msNavigationServiceProvider.saveItem('apps.human-resource.performance.template', {
        //         title: Template,
        //         //icon: 'icon-worker',
        //         state: 'app.human-resource_performance_template'
        //     });
        // }
        else {
            return
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project',
            'app.dashboards.server',
            'app.dashboards.procurement',
            'app.dashboards.sales',
            'app.dashboards.operations', 
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        var Dashboard = 'Dashboards';
        var Management = 'Management';
        var HumanResource = 'Human Resource';
        var Procurement = 'Procurement';
        var Sales = 'Sales';
        var Operations = 'Operations';
        var Accounts = 'Accounts'

        var DefaultLanguage = localStorage.getItem('DefaultLanguage');
        if(DefaultLanguage=='Vietnamese')
        {
            var Dashboard = 'bảng điều khiển';
            var Management = 'Sự quản lý';
            var HumanResource = 'Nguồn nhân lực';
            var Procurement = 'Tạp vụ';
            var Sales = 'Bán hàng';
            var Operations = 'Các hoạt động';
            var Accounts = 'Tài khoản'
        }

        var IsAccess = localStorage.getItem('pages');
        if (IsAccess == null) {
            return
        }
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });
         
        if (IsAccess.split(",").includes("DManagement")) {
            msNavigationServiceProvider.saveItem('apps.dashboards', {
                title: Dashboard,
                icon: 'icon-tile-four',
                weight: 1
            });
                    msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: Management,
            icon: ' icon-home',
            state: 'app.dashboards_project'
        });
        }
        if (IsAccess.split(",").includes("DHuman")) {
            msNavigationServiceProvider.saveItem('apps.dashboards', {
                title: Dashboard,
                icon: 'icon-tile-four',
                weight: 1
            });
                msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: HumanResource,
            icon: ' icon-account-box-outline',
            state: 'app.dashboards_server'
        });

            }
        if (IsAccess.split(",").includes("DProcurement")) {
            msNavigationServiceProvider.saveItem('apps.dashboards', {
                title: Dashboard,
                icon: 'icon-tile-four',
                weight: 1
            });
                msNavigationServiceProvider.saveItem('apps.dashboards.procurement', {
            title: Procurement,
            icon: ' icon-document',
            state: 'app.dashboards_procurement'
        });

                }
        if (IsAccess.split(",").includes("DCRM")) {
            msNavigationServiceProvider.saveItem('apps.dashboards', {
                title: Dashboard,
                icon: 'icon-tile-four',
                weight: 1
            });
                msNavigationServiceProvider.saveItem('apps.dashboards.sales', {
          title: Sales,
            icon: ' icon-sale',
            state: 'app.dashboards_sales'
        });
        }
        if (IsAccess.split(",").includes("DOperations")) {
            msNavigationServiceProvider.saveItem('apps.dashboards', {
                title: Dashboard,
                icon: 'icon-tile-four',
                weight: 1
            });
                msNavigationServiceProvider.saveItem('apps.dashboards.operations', {
           title: Operations,
            icon: ' icon-cog-box',
            state: 'app.dashboards_operations'
        }); 
     }
      else {
          return
      }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.crm', [
      'apps.crm.dashboard',
      // 'app.crm.sormaster',
      'apps.crm.settings',
      'apps.crm.customer',
      'apps.crm.lead',
      'apps.crm.saleorder',
      'apps.crm.contracts',
      // 'apps.crm.templates.quotation',
      'apps.crm.templates.contractstemplates',
      'apps.crm.templates.sormaster',
      'apps.crm.preparequotation',
      'apps.crm.contractquotation',
      'apps.crm.crmflexischeduler',
      // 'apps.crm.contractrenewal'
    ])
    .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

    var CustomerRelationship = 'Customer Relationship';
    var Dashboard = 'Dashboard'; 
    var Settings = 'Settings';
    var Customers = 'Customers';
    var LeadManagement = 'Quote Management';
    var Workorder = 'Treatment Instructions';
    var Contracts = 'Contracts';
    var Templates = 'Templates'
    // Navigation
    msNavigationServiceProvider.saveItem('apps', {
      title: 'APPS',
      group: true,
      weight: 1
    });
    var IsAccess = localStorage.getItem('pages')
    if (IsAccess == null) {
      return
    }
    if (IsAccess.split(",").includes("DCRM")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-tile-four',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.dashboard', {
        title: Dashboard,
        state: 'app.crm_sales',
        weight: 0
      });
    }

    if (IsAccess.split(",").includes("Customers")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-sale',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.customer', {
        title: Customers,
        state: 'app.customer',
        weight: 1
      });
    }
    if (IsAccess.split(",").includes("Lead")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-sale',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.lead', {
        title: LeadManagement,
        state: 'app.lead',
        weight: 2
      });
    }
    if (IsAccess.split(",").includes("WorkOrder")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-sale',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.saleorder', {
        title: Workorder,
        state: 'app.saleorder',
        weight: 4
      });
    }

    if (IsAccess.split(",").includes("Contracts")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-sale',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.contracts', {
        title: Contracts,
        state: 'app.contracts',
        weight: 3
      });
      // msNavigationServiceProvider.saveItem('apps.crm.contractrenewal', {
      //   title: 'Contract Renewal',
      //   state: 'app.contractrenewal',
      // });
    }
   
    if (IsAccess.split(",").includes("Lead")) {
      msNavigationServiceProvider.saveItem('apps.crm.preparequotation', {
        state: 'app.preparequotation'
      });
    }
    if (IsAccess.split(",").includes("Contracts")) {
      msNavigationServiceProvider.saveItem('apps.crm.contractquotation', {
        state: 'app.contractquotation'
      });
    }
    // msNavigationServiceProvider.saveItem('apps.crm.sormaster', {
      //   title: "SOR",
      //   state: 'app.sormaster',
      //   weight: 1
      // });
    if (IsAccess.split(",").includes("CrmSettings")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-cog-box',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.settings', {
        title: Settings,
        state: 'app.settings',
        weight: 5
      });
    }
    if (IsAccess.split(",").includes("Quotation")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-tile-four',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.templates', {
        title: Templates,
        weight: 6
      });
      // msNavigationServiceProvider.saveItem('apps.crm.templates.quotation', {
      //   title: Quotation,
      //   state: 'app.quotation'
      // });
      msNavigationServiceProvider.saveItem('apps.crm.templates.contractstemplates', {
        title: 'Contract Templates',
        state: 'app.contractstemplates'
      });
      msNavigationServiceProvider.saveItem('apps.crm.templates.sormaster', {
        title: "Standard Schedule of Rates",
        state: 'app.sormaster'
      });
    }
    if (IsAccess.split(",").includes("Services")) {
      msNavigationServiceProvider.saveItem('apps.crm', {
        title: CustomerRelationship,
        icon: 'icon-tile-four',
        weight: 1
      });
      msNavigationServiceProvider.saveItem('apps.crm.crmflexischeduler', {
        title: "Daily Scheduler",
        state: 'app.crmflexischeduler',
        weight: 7
      });
      
    }
     else {
      return
    }
  }

})();
(function () {
    'use strict';

    angular
        .module('app.accounts', [

            'app.accounts.generalsetting',
            'app.accounts.purchasespayables',
            'app.accounts.bankcash',
            'app.accounts.reports.generalledger',
            'app.accounts.reports.viewgeneralledger',
            'app.accounts.reports.trailbalance',
            'app.accounts.reports.balancesheet',
            'app.accounts.reports.profitloss',
            'app.accounts.reports.reconciliation',
            'app.accounts.reports.billingreport',
            'app.accounts.assetmanagement',
            'app.accounts.expenseclaim',
            'app.accounts.payment',
            'app.accounts.dashboard',
            'app.accounts.cashInvoice',
            'app.accounts.customer',
            'app.accounts.contracts',
            'app.accounts.flexischeduler',
            'app.accounts.scheduler',
            'app.accounts.saleorder',
            'app.accounts.lumair.cashInvoice',
            'app.accounts.salesreceivables'

        ])
        .config(config);


    function config(msNavigationServiceProvider) {

        var Dashboardtitle = 'Dashboard';
        var AccountTitle = 'Accounts';
        var GeneralSettingstitle = 'General Settings';
        var Accountspayabletitle = 'Accounts Payables';
        var Accountsreceivabletitle = 'Accounts Receivables';
        var Bank_Cash = 'Bank & Cash';
        var JournalEntry = 'Journal Entry';
        var GeneralLedger = 'General Ledger';
        var Reports = 'Reports';
        var TrailBalance = 'Trail Balance';
        var BalanceSheet = 'Balance Sheet';
        var Profit_Loss = 'Profit & Loss';
        var BankReconciliation = 'Bank Reconciliation';
        var BillingReport = 'Billing Report';
        var FixedAssetManagement = 'Fixed Asset Management'


        var Currentlanguage = localStorage.getItem('DefaultLanguage');

        if (Currentlanguage == 'Vietnamese') {
            Dashboardtitle = 'bảng điều khiển';
            AccountTitle = 'Tài khoản';
            GeneralSettingstitle = 'Cài đặt chung';
            Accountspayabletitle = 'Tài khoản phải trả';
            Accountsreceivabletitle = 'Các khoản phải thu';
            Bank_Cash = 'Ngân hàng & Tiền mặt';
            JournalEntry = 'Entry tạp chí';
            GeneralLedger = 'Sổ cái';
            Reports = 'Báo cáo';
            TrailBalance = 'Vạch cân';
            BalanceSheet = 'Bảng cân đối kế toán';
            Profit_Loss = 'Mất lợi nhuận';
            BankReconciliation = 'Hoà giải ngân hàng';
            BillingReport = 'Báo cáo Thanh toán';
            FixedAssetManagement = 'Quản lý Tài sản cố định'

        }

        // Navigation
        var IsAccess = localStorage.getItem('pages');
        if (IsAccess == null) {
            return
        }
        if (IsAccess.split(",").includes("AcCustomer")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.customer', {
                title: 'Customer',
                //icon: 'icon-home-variant',
                state: 'app.accounts_customer'
            });
        }
        if (IsAccess.split(",").includes("AcContract")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.contracts', {
                title: 'Contract',
                //icon: 'icon-home-variant',
                state: 'app.accounts_contracts'
            });
        }
        if (IsAccess.split(",").includes("AccountsWorkOrder")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.saleorder', {
                title: 'Treatment Instructions',
                //icon: 'icon-home-variant',
                state: 'app.accounts_saleorder'
            });
        }

        if (IsAccess.split(",").includes("AcScheduler")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.scheduler', {
                title: 'Scheduler',
                //icon: 'icon-home-variant',
                state: 'app.accounts_scheduler'
            });
        }
        if (IsAccess.split(",").includes("AcDScheduler")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.flexischeduler', {
                title: 'Daily Scheduler',
                state: 'app.accounts_flexischeduler'
            });
        }

        if (IsAccess.split(",").includes("AcPestOff")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.cashInvoice', {
                title: 'Cash/Cheque',
                state: 'app.accounts_cashInvoice'
            });

        }

        if (IsAccess.split(",").includes("AcLumiair")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });

            msNavigationServiceProvider.saveItem('apps.accounts.salesreceivables', {
                title: 'Invoice',
                state: 'app.accounts_Lsalesreceivables'
            });
        }
        if (IsAccess.split(",").includes("AcLumiair")) {
            msNavigationServiceProvider.saveItem('apps.accounts', {
                title: AccountTitle,
                icon: 'icon-account',
                weight: 2
            });
            msNavigationServiceProvider.saveItem('apps.accounts.accounts_generalsetting', {
                title: 'Settings',
                //icon: 'icon-home-variant',
                state: 'app.accounts_generalsetting'
            });
        }
        else {
            return
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [
            'app.dashboard.management',
            'app.dashboard.humanresource',
            'app.dashboard.inventry',
            'app.dashboard.sales',
            'app.dashboard.operation'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboard', {
            title : 'Dashboard',
            icon  : 'icon-tile-four',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboard.management', {
            title: 'Management',
            icon: ' ',
            state: 'app.dashboard_management'
        });

        msNavigationServiceProvider.saveItem('apps.dashboard.humanresource', {
            title: 'Human Resource',
            icon: ' icon-account-box-outline',
            state: 'app.dashboard_humanresource'
        });
        
        msNavigationServiceProvider.saveItem('apps.dashboard.inventry',{
            title: 'Inventry',
            icon: ' icon-document',
            state: 'app.dashboard_inventry'
        });
        
        msNavigationServiceProvider.saveItem('apps.dashboard.sales', {
            title: 'Sales',
            icon: ' icon-sale',
            state: 'app.dashboard_sales'
        });
        
        msNavigationServiceProvider.saveItem('apps.dashboard.operation', {
            title: 'Operation',
            icon: ' icon-cog-box',
            state: 'app.dashboard_operation'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login', 
            'app.pages.auth.forgot-password', 
            'app.pages.form', 
            'app.pages.maintenance',
            'app.pages.profile',  
             'app.pages.administration'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        var IsAccess = 0;
        if (IsAccess == 1) {
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
   }
else{
           return 
    }
}
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/toolbar/layouts/cpmodal.html","<md-dialog style=\"width:400px\"><form ng-cloak name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools header md-accent-bg\"><h2 translate=\"TOOLBAR.Change_Password\">Change Password</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 70px\"><md-input-container flex><input type=\"password\" \nname=\"OldPassword\" ng-model=\"uOldPassword\" placeholder=\"{{\'TOOLBAR.OLD_PASSWORD\' | translate}}\" required><div \nng-messages=\"basicForm.OldPassword.$error\" ng-show=\"basicForm.OldPassword.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TOOLBAR.OLDPASSWORD_FIELD_IS_REQUIRED\">Old Password field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 70px\"><md-input-container\n flex><input type=\"password\" name=\"NewPassword\" ng-model=\"uNewPassword\" \nplaceholder=\"{{\'TOOLBAR.NEW_PASSWORD\' | translate}}\" required><div ng-messages=\"basicForm.NewPassword.$error\" \nng-show=\"basicForm.NewPassword.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TOOLBAR.NEW_PASSWORD_FIELD_IS_CHANGED\">New Password field is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 60px\"><md-input-container flex><input\n type=\"password\" ng-model=\"uCNewPassword\" placeholder=\"{{\'TOOLBAR.CONFIRM_NEW_PASSWORD\' | translate}}\">\n</md-input-container></div><div ng-show=\"Error8\"><p style=\"color:red\" translate=\"TOOLBAR.NEW_PASSWORDS_ARE_NOT_SAME\">\nNew passwords are not same</p></div><div ng-show=\"Error9\"><p style=\"color:red\" \ntranslate=\"TOOLBAR.OLD_PASSWORDS_ARE_NOT_SAME\">Old passwords are not same</p></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cpSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\" class=\"md-raised md-accent\"><span translate=\"TOOLBAR.SUBMIT\">Submit</span></md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\"><span translate=\"TOOLBAR.CANCEL\">Cancel</span></md-button>\n</md-dialog-actions></form></md-dialog><style>\n.ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item {\r\n    opacity: 1 !important;\r\n    padding: 24px;\r\n}\r\n\r\n        .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n            border-bottom:none !important;\r\n        }\r\n\r\n        .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after{\r\n            border-bottom:none !important;\r\n        }\n</style>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/data/dashboard/humanresource/humanresource.html","");
$templateCache.put("app/data/dashboard/inventry/inventry.html","");
$templateCache.put("app/data/dashboard/management/management.html","");
$templateCache.put("app/data/dashboard/operation/operation.html","");
$templateCache.put("app/data/dashboard/sales/sales.html","");
$templateCache.put("app/main/apps/Applyleave/applyleave.html","<div id=\"employee\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Leave Apply</span></div><div \nclass=\"product-count secondary-text\"><span>Total Leaves:</span> <span>{{EmployeeSammury.length}}</span></div></div>\n</div><div class=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Employeeform\" flex><form name=\"basicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" name=\"EmployeeID\" ng-model=\"uEmployeeID\" placeholder=\"Employee ID\" \nrequired><div ng-messages=\"wizardStep1.EmployeeID.$error\" ng-show=\"wizardStep1.EmployeeID.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Employee ID field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"EmployeeName\" ng-model=\"uEmployeeName\" placeholder=\"Employee Name\"><div \nng-messages=\"wizardStep1.EmployeeName.$error\" ng-show=\"wizardStep1.EmployeeName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Employee Name field is required.</span></div></div></md-input-container><md-input-container\n flex><input type=\"text\" name=\"BusinessUnit\" ng-model=\"uBusinessUnit\" placeholder=\"Business Unit\"><div \nng-messages=\"wizardStep1.BusinessUnit.$error\" ng-show=\"wizardStep1.BusinessUnit.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Business Unit field is required.</span></div></div></md-input-container><md-input-container\n flex><input type=\"text\" ng-model=\"uJobCategory\" placeholder=\"Job Category\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"uCostCentre\" \nplaceholder=\"Cost Centre\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"uDivision\" \nplaceholder=\"Division\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"uTeam\" \nplaceholder=\"Team\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"uJobTitle\" placeholder=\"Job Title\"></md-input-container><md-date-container flex \nstyle=\"margin-top:1.5%\"><md-datepicker onkeydown=\"return false\" ng-model=\"uDateApply\" md-placeholder=\"Date Apply\">\n</md-datepicker></md-date-container><md-input-container flex><label>Leave Type</label><md-select ng-model=\"uLeaveType\">\n<md-option value=\"Sick\">Sick</md-option><md-option value=\"Annual\">Annual</md-option><md-option value=\"Maternity\">\nMaternity</md-option><md-option value=\"Paternity\">Paternity</md-option><md-option value=\"Child Care\">Child Care\n</md-option><md-option value=\"Compassionate\">Compassionate</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label>Apply For</label><md-select \nng-model=\"uApplyFor\"><md-option value=\"FullDay\">Full Day</md-option><md-option value=\"HalfDay\">Half Day</md-option>\n</md-select></md-input-container><md-date-container flex style=\"margin-top:1.5%\"><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\" md-placeholder=\"From\"></md-datepicker></md-date-container><md-input-container\n flex><md-radio-group ng-model=\"FromMorning\" layout=\"row\"><md-radio-button value=\"FMorning\">Morning</md-radio-button>\n<md-radio-button value=\"FNoon\">Noon</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"uReason\" \nplaceholder=\"Reason\"></md-input-container><md-date-container flex style=\"margin-top:1.5%\"><md-datepicker \nonkeydown=\"return false\" ng-model=\"uTo\" md-placeholder=\"To\"></md-datepicker></md-date-container><md-input-container \nflex><md-radio-group ng-model=\"ToMorning\" layout=\"row\"><md-radio-button value=\"Morning\">Morning</md-radio-button>\n<md-radio-button value=\"Noon\">Noon</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label>Reliet Personal During Leave</label><md-select \nng-model=\"uRelietPersonalDuringLeave\"><md-option value=\"FullDay\">Full Day</md-option><md-option value=\"HalfDay\">\nHalf Day</md-option></md-select></md-input-container><md-date-container flex style=\"margin-top:1.5%\"><md-datepicker \nonkeydown=\"return false\" ng-model=\"uDateResumeWork\" md-placeholder=\"Date Resume Work\"></md-datepicker>\n</md-date-container><md-input-container flex><label>Status</label><md-select ng-model=\"uStatus\"><md-option \nvalue=\"Approved\">Approved</md-option><md-option value=\"PendingApprovel\">Pending Approvel</md-option><md-option \nvalue=\"Rejected\">Rejected</md-option><md-option value=\"Canceled\">Canceled</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"uAttachment\" \nplaceholder=\"Attachment\"></md-input-container></div></form><table class=\"dataTable\"><thead><tr><th \nclass=\"secondary-text\"><span>Leave Type</span></th><th class=\"secondary-text\"><span>Entitlement</span></th><th \nclass=\"secondary-text\"><span>Bring Forward</span></th><th class=\"secondary-text\"><span>Earned</span></th><th \nclass=\"secondary-text\"><span>Leave Taken</span></th><th class=\"secondary-text\"><span>Burnt</span></th><th \nclass=\"secondary-text\"><span>Balance</span></th></tr></thead><tbody><tr><td style=\"color: #939393\"><b>Advanced Leave\n</b></td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td style=\"color: #939393\"><b>Annual Leave</b>\n</td><td></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(23vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #seprate md-datepicker .md-datepicker-input {\r\n        width: calc(36vw - 54px);\r\n        max-width: calc(45vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n            .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n            border-bottom-color: rgba(0, 0, 0, 0.15);\r\n        }\r\n        .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n    border-bottom-color: rgba(0, 0, 0, 0.14);\r\n}\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\ntable.dataTable thead th {\r\n  border-bottom: 0;\r\n        background: #f5f5f5;\r\n}\r\ntable.dataTable {\r\n  border-bottom: 0;\r\n  border-top: 0;\r\n\r\n}\n</style>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"vm.contacts.getById(vm.chatContactId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.clearMessages()\" translate=\"CHAT.CLEAR_MESSAGES\">Clear Messages</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" \nng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.who\">\n<img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.message}}</div><div \nclass=\"time secondary-text\">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\n\r\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\">\n</md-icon></md-button></form></div></div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" \nmd-component-id=\"right-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\">\n</md-sidenav></div></div></div>");
$templateCache.put("app/main/apps/customerportal/customerportal.html","<div id=\"customerportal\" class=\"page-layout carded fullwidth single-scroll\" ng-cloak><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple-outline\"></md-icon><span \ntranslate=\"CUSTOMERPORTAL.CUSTOMER PORTAL\">Customer Portal</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"datasearch\" ng-model=\"model.Search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"ScheduleExport && AllowExport==\'true\'\" ng-click=\"sExport()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"CUSTOMERPORTAL.EXPORT\">Export</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"InvoiceExport && AllowExport==\'true\'\" ng-click=\"iExport()\"><md-icon\n md-font-icon=\"icon-export\"></md-icon><span translate=\"CUSTOMERPORTAL.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"ContractExport && AllowExport==\'true\'\" ng-click=\"cExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CUSTOMERPORTAL.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"ServiceReportExport && AllowExport==\'true\'\" ng-click=\"srExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CUSTOMERPORTAL.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"FeedbackExport && AllowExport==\'true\'\" ng-click=\"fExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CUSTOMERPORTAL.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"false\"><md-tab><div ng-click=\"Schedules()\"><md-tab-label translate=\"CUSTOMERPORTAL.SCHEDULES\"><span \nng-if=\"wizardStep1.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Schedules</span></md-tab-label></div>\n<md-tab-body><form name=\"wizardStep1\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\" class=\"md-inline-form\">\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.SERVICE_ID\" class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"CUSTOMERPORTAL.WORK_ORDER_#\" class=\"column-title\">Work Order #</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.CONTRACT_#\" class=\"column-title\">Contract #</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.PEST_TYPE\" class=\"column-title\">Pest Types</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.TEAM\" class=\"column-title\">Team</span></div>\n</th><th class=\"secondary-text\" nowrap=\"nowrap\"><div><span translate=\"CUSTOMERPORTAL.DAY\" class=\"column-title\">Day\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.SCHEDULE_DATE\" class=\"column-title\">\nSchedule Date</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.START_TIME\" \nclass=\"column-title\">Start Time</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.END_TIME\" class=\"column-title\">End Time</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"CUSTOMERPORTAL.STATUS\" class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Schedulerdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{row.ServiceID }}</td><td>\n{{row.JobOrdersdetails[0].SalesOrderNo }}</td><td>{{row.Contracterdetails[0].ContractReferenceNo }}</td><td>\n{{row.PestType }}</td><td>{{row.teamdetails[0].TeamName }}</td><td>{{row.ServiceOn}}</td><td>\n{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'hh:mm a\'}}</td><td>{{row.Endsat | date:\'hh:mm a\'}}\n</td><td>{{row.Status}}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab><div ng-click=\"Invoices()\">\n<md-tab-label translate=\"CUSTOMERPORTAL.INVOICE\"><span ng-if=\"wizardStep2.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Invoices</span></md-tab-label></div><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate style=\"padding-bottom:0px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.VOUCHER_NO\" class=\"column-title\">\nVoucher No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.VOUCHER_DATE\" class=\"column-title\">Voucher Date</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.INVOICE_NO\" class=\"column-title\">Invoice No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.INVOICE_DATE\" \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.STATUS\" class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"CUSTOMERPORTAL.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.CUSTOMER_NAME\" \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.SITE_ADDRESS\" class=\"column-title\">Site Address</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.AGENT_NAME\" class=\"column-title\">Agent Name</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.WORKORDER\" class=\"column-title\">\nWorkOrder</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.SALES_AMOUNT\" class=\"column-title\">\nSales Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.GST_AMOUNT\" class=\"column-title\">GST Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"CUSTOMERPORTAL.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">Outstanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.GST_CODE\" class=\"column-title\">GST Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.CREDIT_TERM\" class=\"column-title\">\nCredit Term</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.DUE_DATE\" class=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"CUSTOMERPORTAL.CREDIT_NOTE_NUMBER\" class=\"column-title\">Credit Note Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.DEBIT_NOTE_NUMBER\" \nclass=\"column-title\">Debit Note Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"CUSTOMERPORTAL.WORKFLOW_STATUS\" class=\"column-title\">Workflow Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"CUSTOMERPORTAL.REMARKS\" class=\"column-title\">Remarks\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Invoicedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">{{ row.VoucherNumber }}</td><td>\n{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.InvoiceNumber }}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Status }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CompanyName }}</td><td\n nowrap=\"nowrap\">\n{{ row.Customerdetails[0].BLK }} {{ row.Customerdetails[0].StreetName }} {{ row.Customerdetails[0].Unit }} {{ row.Customerdetails[0].BuildingName }} {{ row.Customerdetails[0].Country }} {{ row.Customerdetails[0].Postal }}\n</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].ContactPerson }}</td><td nowrap=\"nowrap\">\n{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td nowrap=\"nowrap\">\n$ {{ row.Amount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.GSTAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">\n{{ row.Invoicecomment[0].Description }} {{ row.Invoicecomment[1].Description }} {{ row.Invoicecomment[2].Description }} {{ row.Invoicecomment[3].Description }} {{ row.Invoicecomment[4].Description }}\n</td><td nowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }}</td><td nowrap=\"nowrap\">{{ row.CreditTerm }}</td><td>\n{{ row.DueDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber }}</td><td nowrap=\"nowrap\">\n{{ row.DebitNoteNumber }}</td><td nowrap=\"nowrap\">{{ row.WorkflowStatus }}</td><td nowrap=\"nowrap\">{{ row.Remarks }}\n</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab><div ng-click=\"Contracts()\"><md-tab-label \ntranslate=\"CUSTOMERPORTAL.HEADER\"><span ng-if=\"wizardStep3.$valid\"></span> <span class=\"ms-form-wizard-step-text\">\nContracts</span></md-tab-label></div><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate \nstyle=\"padding-bottom:0px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span\n translate=\"CUSTOMERPORTAL.CONTRACT_#\" class=\"column-title\">Contract #</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"CUSTOMERPORTAL.WORK_ORDER_#\" class=\"column-title\">Work #</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.CUSTOMER\" class=\"column-title\">Customer</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.SALES_PERSON\" class=\"column-title\">Sales Person</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.PEST_TYPE\" class=\"column-title\">Pest Types\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.START_DATE\" class=\"column-title\">\nStart Date</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.END_DATE\" \nclass=\"column-title\">End Date</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.EXPIRES_IN_DAYS\" class=\"column-title\">Expires In (Days)</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.STATUS\" class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.SIGNED\" class=\"column-title\">Signed?</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Contractdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ContractReferenceNo }}</td><td>{{ row.workorderdetails[0].SalesOrderNo }}</td><td>\n{{ row.customerdetails[0].CompanyName }}</td><td>{{ row.employeedetails[0].EmployeeName }}</td><td>{{ row.PestType }}\n</td><td>{{ row.ContractStartDate | date:\'dd/MM/y\'}}</td><td>{{ row.ContractEndDate | date:\'dd/MM/y\'}}</td><td>\n{{ Totla(row.ContractEndDate) }}</td><td>{{ row.Status }}</td><td>{{ row.Signed }}</td></tr></tbody></table></form>\n</md-tab-body></md-tab><md-tab><div ng-click=\"ServiceReports()\"><md-tab-label \ntranslate=\"CUSTOMERPORTAL.SERVICE REPORTS\"><span ng-if=\"wizardStep4.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Service Reports</span></md-tab-label></div><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate style=\"padding-bottom:0px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.REPORT\" class=\"column-title\">Report</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.SERVICE_ID\" class=\"column-title\">Service ID</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.WORK_ORDER_#\" class=\"column-title\">Work Order #\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.CONTRACT_#\" class=\"column-title\">\nContract #</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.PEST_TYPE\" \nclass=\"column-title\">Pest Types</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.TEAM\" \nclass=\"column-title\">Team</span></div></th><th class=\"secondary-text\" nowrap=\"nowrap\"><div><span \ntranslate=\"CUSTOMERPORTAL.DAY\" class=\"column-title\">Day</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.SCHEDULE_DATE\" class=\"column-title\">Schedule Date</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.START_TIME\" class=\"column-title\">Start Time</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.END_TIME\" class=\"column-title\">End Time</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.STATUS\" class=\"column-title\">Status</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Schedulerdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printServiceReport(row.ServiceID)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{row.ServiceID }}</td><td>{{row.JobOrdersdetails[0].SalesOrderNo }}</td><td>\n{{row.Contracterdetails[0].ContractReferenceNo }}</td><td>{{row.PestType }}</td><td>{{row.teamdetails[0].TeamName }}\n</td><td>{{row.ServiceOn}}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'hh:mm a\'}}</td><td>\n{{row.Endsat | date:\'hh:mm a\'}}</td><td>{{row.Status}}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab>\n<div ng-click=\"Feedback()\"><md-tab-label translate=\"CUSTOMERPORTAL.FEEDBACK (NOTIFY TO OPERATIONS)\"><span \nng-if=\"wizardStep5.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Feedback (Notify to Operations)</span>\n</md-tab-label></div><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<md-button class=\"md-raised md-background\" ng-click=\"FeedbackPopup(e)\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CUSTOMERPORTAL.ADD\">Add</span></md-button><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.EDIT\" \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.DELETE\" \nclass=\"column-title\">Delete</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.REFERENCE_NO\" class=\"column-title\">Reference No.</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"CUSTOMERPORTAL.CUSTOMER_NAME\" class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.DATE OF SERVICE\" class=\"column-title\">Date of Service\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.WORK ORDER NO\" class=\"column-title\">\nWork Order No.</span></div></th><th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.CONTRACT_NO\" \nclass=\"column-title\">Contract No.</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"CUSTOMERPORTAL.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No.</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.PEST_TYPE\" class=\"column-title\">Pest Type</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.FEEDBACK\" class=\"column-title\">Feedback</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">User Comment</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"CUSTOMERPORTAL.STATUS\" class=\"column-title\">Status</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Feedbackdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"FeedbackUpdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Feedbackdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td><td><a \nng-click=\"FeedbackUpdate($event, row._id)\" style=\"cursor:pointer\">{{ row.ReferenceNo }}</a></td><td>\n{{ row.Customerdetails[0].CompanyName }}</td><td>{{ row.DateofService | date:\'dd/MM/y\' }}</td><td>{{ row.WorkOrder }}\n</td><td>{{ row.Contract }}</td><td>{{ row.ServiceNo }}</td><td>{{ row.PestType }}</td><td>{{ row.Feedback }}</td><td>\n{{ row.Comment }}</td><td>{{ row.Status }}</td></tr></tbody></table></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"padding: 0\"><md-button class=\"md-raised\" \nng-click=\"msWizard.previousStep()\">{{\'CUSTOMERPORTAL.PREVIOUS\'|translate}}</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">{{\'CUSTOMERPORTAL.NEXT\'|translate}}</md-button></div><br><br>\n</ms-form-wizard></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/customerportal/feedbackdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"CUSTOMERPORTAL.DELETE THIS FEEDBACK\" class=\"title\">Delete this Feedback?</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Fdelete(deleteID)\" class=\"md-raised md-accent\">{{\'CUSTOMERPORTAL.YES\'|translate}}</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'CUSTOMERPORTAL.NO\'|translate}}</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/customerportal/feedbackpopup.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"CUSTOMERPORTAL.FEEDBACK DETAIL\" class=\"title\">FEEDBACK DETAIL</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label translate=\"CUSTOMERPORTAL.DATE OF SERVICE\">Date of Service</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.DateofService\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex><label translate=\"CUSTOMERPORTAL.WORK ORDER NO\">Work Order No.</label>\n<md-select ng-model=\"vm.WorkOrder\" ng-model-options=\"{trackBy: \'$value.SalesOrderNo\'}\" md-on-close=\"clearSearchTerm()\" \nmultiple=\"\"><md-select-header><input ng-model=\"searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'CUSTOMERPORTAL.SEARCH FOR A WORK ORDER NO\'|translate}}...\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.WorkOrder=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.SalesOrderNo\" ng-repeat=\"row in Workordernumberdatas  | filter:searchTerm\">{{row.SalesOrderNo}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container style=\"margin-top: -6px\" flex><label translate=\"CUSTOMERPORTAL.CONTRACT_NO\">Contract No.</label>\n<md-select ng-model=\"vm.Contract\" ng-model-options=\"{trackBy: \'$value.ContractReferenceNo\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input ng-model=\"searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'CUSTOMERPORTAL.SEARCH FOR A CONTRACT NO\'|translate}}...\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.Contract=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-optgroup><md-option ng-value=\"row\" ng-model=\"row.ContractReferenceNo\" \nng-repeat=\"row in Contractnumberdatas  | filter:searchTerm\">{{row.ContractReferenceNo}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"CUSTOMERPORTAL.SERVICE_REPORT_NO\">Service Report No.</label><md-select ng-model=\"vm.ServiceNo\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input \nng-model=\"searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'CUSTOMERPORTAL.SEARCH FOR A SERVICE REPORT NO\'|translate}}...\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.ServiceNo=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.ServiceID\" ng-repeat=\"row in Servicenumberdatas  | filter:searchTerm\">{{row.ServiceID}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nflex><label translate=\"CUSTOMERPORTAL.PEST_TYPE\">Pest Type</label><md-select ng-model=\"vm.PestType\" \nng-model-options=\"{trackBy: \'$value.PestName\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-select-header>\n<input ng-model=\"searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'CUSTOMERPORTAL.SEARCH_FOR_A_PEST_TYPE\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.PestType=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.PestName\" ng-repeat=\"row in Pesttypedatas  | filter:searchTerm\">{{row.PestName}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><label>{{\'CUSTOMERPORTAL.STATUS\'|translate}}\n</label><md-select ng-model=\"vm.Status\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-option>\n{{\'CUSTOMERPORTAL.SELECT STATUS\'|translate}}<md-button class=\"md-icon-button\" ng-click=\"vm.Status=\'\'\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-option>\n<md-option value=\"{{\'CUSTOMERPORTAL.OPEN\'|translate}}\">{{\'CUSTOMERPORTAL.OPEN\'|translate}}</md-option><md-option \nvalue=\"{{\'CUSTOMERPORTAL.CLOSED\'|translate}}\">{{\'CUSTOMERPORTAL.CLOSED\'|translate}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom:-20px\" flex><md-input-container\n flex><input type=\"text\" name=\"Feedback\" ng-model=\"vm.Feedback\" placeholder=\"{{\'CUSTOMERPORTAL.FEEDBACK\'|translate}}\" \nrequired></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"FeedbackAdd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'CUSTOMERPORTAL.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">{{\'CUSTOMERPORTAL.CANCEL\'|translate}}</md-button></div></md-dialog-content>\n</form></md-dialog><style>#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/dashboards/dashboard.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, {{UserName}}!</span></div>\n</div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"{{General}}\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Customers</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"green-fg font-size-72 line-height-72\">{{customerdatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Customers</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Leads</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"pink-fg font-size-72 line-height-72\">{{Leaddatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Leads</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Contracts</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{Contractdatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Contracts</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget4.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Work Orders</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{salesOrderdatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Work Orders</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3\">TODAYS ACTIVITIES</span></div></div><md-tabs md-dynamic-height \nmd-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab ng-click=\"workOrd=salesOrderdatas\"><md-tab-label><span>\nCustomer</span></md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer #</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Follow-up Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created By</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in TCustomerdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.CustomerReference }}</td><td>{{ row.CompanyName }}</td><td>{{ row.Email}}</td><td>{{ row.Mobile}}</td><td>\n{{ row.ProspectFollowupDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}</td></tr></tbody></table></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Contract</span></md-tab-label><md-tab-body><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Contract #</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Contract Duration</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Sales Person</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Created By</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in TContractdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ContractReferenceNo }}</td><td>\n{{ row.customerdetails[0].CompanyName }}</td><td>\n{{ row.ServiceStartDate | date:\'dd/MM/y\'}} - {{ row.ServiceEndDate | date:\'dd/MM/y\'}}</td><td>\n{{ row.employeedetails[0].EmployeeName }}</td><td>{{ row.CreatedBy}}</td></tr></tbody></table></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Work Order</span></md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Work Order #</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Company Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Sales Person</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duration</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created By</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in TSalesOrderdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.SalesOrderNo }}</td><td>{{ row.customerdetails[0].CompanyName }}</td><td>{{ row.OrderType }}</td><td>\n{{ row.employeedetails[0].EmployeeName }}</td><td>\n{{ row.ServiceStartDate | date:\'dd/MM/y\'}} - {{ row.ServiceEndDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy}}</td>\n</tr></tbody></table></md-tab-body></md-tab></md-tabs></ms-widget-front></ms-widget></div></md-tab></md-tabs></div>\n</div></div><style>.color-red {\r\n        color: red;\r\n    }</style>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task or tag\" translate \ntranslate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div></div>\n</div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img ng-src=\"{{vm.logo}}\"></span><span \nclass=\"logo-text\"><img ng-src=\"{{vm.logo}}\"></span></div><md-icon class=\"fold-toggle s18\" style=\"color:gray\" \nmd-font-icon=\"icon-menu\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation \nclass=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/pages/interview/interview.html","<div id=\"invoice\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\"></div></div><div \nclass=\"content\"><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>Exit Interview</b></div><br><div \nstyle=\"text-align:justify;font-size:17px\">\nWe would appreciate your taking the time to answer the following questions as honestly as possible. Your individual responses are treated as confidential.\n<br><br>\nWe believe that this information is of vital importance and it will assist us in analyzing the factors contributing to turnover. Thank you for your cooperation\n<br><br></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px\"><label style=\"width:130px\">Employee Name</label>&emsp;<md-input-container \nflex=\"25\"><label>Employee Name</label><md-select ng-model=\"Employee\" id=\"Employee\"><md-option \nng-repeat=\"row in Employeedatas\" value=\"{{row.id}}\">{{row.EmployeeName}}</md-option></md-select></md-input-container>\n&emsp;&emsp;<label style=\"width:140px\">Termination Date</label>&emsp;<md-date-container flex=\"25\"><md-datepicker \nng-model=\"TerminationDate\" md-date-format=\"dd/MM/y\" md-placeholder=\"Termination Date\"></md-datepicker>\n</md-date-container></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\"><label style=\"width:130px\">Job Title</label>&emsp;\n<md-input-container flex=\"25\"><input type=\"text\" name=\"JobTitle\" ng-model=\"JobTitle\" placeholder=\"Job Title\">\n</md-input-container>&emsp;&emsp;<label style=\"width:140px\">Eligible for Rehire</label>&emsp;&nbsp;&nbsp;\n<md-radio-group ng-model=\"Rehire\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button><md-radio-button \nvalue=\"false\">No</md-radio-button></md-radio-group></div><div style=\"text-align:center;font-size:20px;font-weight:500\">\n<b>Reason for Resignation</b></div><br><div style=\"text-align:justify;font-size:17px;height:35px\"><md-checkbox \nng-model=\"value1\" type=\"checkbox\">Better job offer</md-checkbox>\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;<md-checkbox \nng-model=\"value2\" type=\"checkbox\">Health reasons</md-checkbox><br></div><div \nstyle=\"text-align:justify;font-size:17px;height:35px\"><md-checkbox ng-model=\"value3\" type=\"checkbox\">Type of work\n</md-checkbox>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;\n<md-checkbox ng-model=\"value4\" type=\"checkbox\">Too much pressure to meet targets</md-checkbox><br></div><div \nstyle=\"text-align:justify;font-size:17px;height:35px\"><md-checkbox ng-model=\"value5\" type=\"checkbox\">Work conditions\n</md-checkbox>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;<md-checkbox \nng-model=\"value6\" type=\"checkbox\">Uncertainty over job continuation</md-checkbox><br></div><div \nstyle=\"text-align:justify;font-size:17px;height:0px\"><md-checkbox ng-model=\"value7\" type=\"checkbox\">Lack of recognition\n</md-checkbox>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<md-checkbox ng-model=\"value8\" \ntype=\"checkbox\">Relationship with boss</md-checkbox><br></div><div \nstyle=\"text-align:justify;font-size:17px;height:60px\"><md-checkbox ng-model=\"value9\" type=\"checkbox\">\nFamil circumstances</md-checkbox>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;<md-checkbox \nng-model=\"value10\" type=\"checkbox\">Other&emsp;</md-checkbox><md-input-container flex><input type=\"text\" name=\"Other\" \nng-model=\"Other\"></md-input-container></div><h3 style=\"font-weight: 600\">Employee Comments:</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"eComment\"></text-angular><h3 style=\"font-weight: 600\">Interviewer Comments:</h3>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"iComment\"></text-angular><br><br><br><br><br><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 40px\"><label \nstyle=\"width:190px;font-weight: 600\">Employee\'s Signature</label>&emsp;<md-input-container flex=\"25\"><input \ntype=\"text\" name=\"eSignature\" ng-model=\"eSignature\" placeholder=\"Employee\'s Signature\"></md-input-container>\n&emsp;&emsp;<label style=\"width:50px;font-weight: 600\">Date</label>&emsp;<md-date-container flex=\"25\"><md-datepicker \nng-model=\"eDate\" md-date-format=\"dd/MM/y\" md-placeholder=\"Date\"></md-datepicker></md-date-container></div><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px\"><label \nstyle=\"width:190px;padding-bottom: 20px;font-weight: 600\">Interviewer\'s Signature</label>&emsp;<md-input-container \nflex=\"25\"><input type=\"text\" name=\"iSignature\" ng-model=\"iSignature\" placeholder=\"Interviewer\'s Signature\">\n</md-input-container>&emsp;&emsp;<label style=\"width:50px;padding-bottom: 20px;font-weight: 600\">Date</label>&emsp;\n<md-date-container style=\"padding-bottom: 20px\" flex=\"25\"><md-datepicker ng-model=\"iDate\" md-date-format=\"dd/MM/y\" \nmd-placeholder=\"Date\"></md-datepicker></md-date-container></div><br><br><br><br><br><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>Exit Interview</b></div><br><div \nstyle=\"text-align:center;font-size:20px;font-weight:500\"><b>Questionnaire</b></div><div \nstyle=\"text-align:justify;font-size:17px\"><h3 style=\"font-weight: 600\">1. What are your primary reasons for leaving?\n</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Questionnaire1\"></text-angular><h3 style=\"font-weight: 600\">\n2. What did you find most satisfying about your job?</h3><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"Questionnaire2\"></text-angular><h3 style=\"font-weight: 600\">\n3. What did you find most frustrating about your job?</h3><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"Questionnaire3\"></text-angular><h3 style=\"font-weight: 600\">\n4. Would you consider returning to this company in the future?</h3><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"Questionnaire4\"></text-angular><h3 style=\"font-weight: 600\">\n5. Is there anything the company could have done to prevent you from leaving?</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"Questionnaire5\" class=\"pb-32\"></text-angular></div></div><div class=\"footer\"></div>\n</div><div class=\"page-break\"></div></div></div><style>\n.ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 120px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img src=\"{{vm.logo}}\"></div><div class=\"title\">Access Not Allowed !</div><div \nclass=\"subtitle\">Please contact Administration</div><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><a ng-click=\"vm.goPreviousPage()\">Back To Previous Page</a></div></div>\n</div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"PROFILE.MY_PROFILE\">My Profile</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/pages/profile/about/about.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span>Friends</span></md-subheader><md-list-item \nclass=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img ng-src=\"{{friend.avatar}}\" class=\"md-avatar\" \nalt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div ng-if=\"contact.unread\" \nclass=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3 class=\"message\">\n{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div></md-list-item></md-list><md-divider></md-divider>\n<md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.APP_SERVERS\">\nApplication Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts></div><div layout=\"row\" layout-align=\"start center\">\n<div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"LeaveRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.human-resource_leaveform\" \naria-label=\"User settings\" title=\"Leave Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-layers\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Leave Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"MaterialRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.materialrequisition\" aria-label=\"User settings\" title=\"Material Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-material-ui\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Material Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"PurchaseRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.purchaserequisition\" \naria-label=\"User settings\" title=\"Purchase Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-tile-four\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Purchase Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"UniformRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.uniformrequisition\" aria-label=\"User settings\" title=\"Uniform Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-ungroup\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Uniform Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"IncidentReporting\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.human-resource_incidentform\" \naria-label=\"User settings\" title=\"Incident Reporting\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-checkerboard\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Incident Reporting</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/vincent.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.uniformrequisition\"><md-icon md-font-icon=\"icon-laptop\" class=\"icon\"></md-icon>\n<md-button>IT Support</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"icon\"></md-icon><md-button ng-click=\"cpmodal($event)\">Change Password</md-button></md-menu-item><md-menu-divider\n ng-show=\"MedicalClaim == true || ExpenseClaim == true  || PaymentVoucher == true \"></md-menu-divider><md-menu-item \nng-show=\"MedicalClaim\" class=\"md-indent\" ui-sref=\"app.human-resource_medicalform\"><md-icon \nmd-font-icon=\"icon-hospital\" class=\"icon\"></md-icon><md-button>Medical Claim Submission</md-button></md-menu-item>\n<md-menu-item ng-show=\"ExpenseClaim\" class=\"md-indent\" ui-sref=\"app.accounts_expenseclaim\"><md-icon \nmd-font-icon=\"icon-file-document-box\" class=\"icon\"></md-icon><md-button>Expense Claim Submission</md-button>\n</md-menu-item><md-menu-item ng-show=\"PaymentVoucher\" class=\"md-indent\" ui-sref=\"app.accounts_payment\"><md-icon \nmd-font-icon=\"icon-cash-usd\" class=\"icon\"></md-icon><md-button>Payment Voucher</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><style>\n#toolbar #user-menu .user-button {\r\n        margin: 0;\r\n        padding: 0px 14px !important;\r\n        height: 64px;\r\n        text-transform: none;\r\n    }\n</style>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div></div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"LeaveRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.human-resource_leaveform\" aria-label=\"User settings\" title=\"Leave Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-layers\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Leave Request</span></div></md-button></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"MaterialRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.materialrequisition\" \naria-label=\"User settings\" title=\"Material Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-material-ui\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Material Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"PurchaseRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.purchaserequisition\" aria-label=\"User settings\" title=\"Purchase Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-tile-four\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Purchase Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"UniformRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.uniformrequisition\" \naria-label=\"User settings\" title=\"Uniform Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-ungroup\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Uniform Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"IncidentReporting\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.human-resource_incidentform\" aria-label=\"User settings\" title=\"Incident Reporting\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-checkerboard\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Incident Reporting</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/vincent.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.uniformrequisition\"><md-icon md-font-icon=\"icon-laptop\" class=\"icon\"></md-icon>\n<md-button>IT Support</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"icon\"></md-icon><md-button ng-click=\"cpmodal($event)\">Change Password</md-button></md-menu-item><md-menu-divider\n ng-show=\"MedicalClaim == true || ExpenseClaim == true  || PaymentVoucher == true \"></md-menu-divider><md-menu-item \nng-show=\"MedicalClaim\" class=\"md-indent\" ui-sref=\"app.human-resource_medicalform\"><md-icon \nmd-font-icon=\"icon-hospital\" class=\"icon\"></md-icon><md-button>Medical Claim Submission</md-button></md-menu-item>\n<md-menu-item ng-show=\"ExpenseClaim\" class=\"md-indent\" ui-sref=\"app.accounts_expenseclaim\"><md-icon \nmd-font-icon=\"icon-file-document-box\" class=\"icon\"></md-icon><md-button>Expense Claim Submission</md-button>\n</md-menu-item><md-menu-item ng-show=\"PaymentVoucher\" class=\"md-indent\" ui-sref=\"app.accounts_payment\"><md-icon \nmd-font-icon=\"icon-cash-usd\" class=\"icon\"></md-icon><md-button>Payment Voucher</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div><style>\n#toolbar #user-menu .user-button {\r\n        margin: 0;\r\n        padding: 0px 14px !important;\r\n        height: 64px;\r\n        text-transform: none;\r\n    }\n</style>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list \nng-if=\"Leavedetails.length>0\"><md-subheader class=\"md-no-sticky\"><span>Employees on Leave</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"event in Leavedetails\"><div class=\"md-list-item-text\"><h3>{{event.TeamLead}}\n</h3><p>{{event.Type}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list \nng-if=\"Followupdate.length>0\"><md-subheader class=\"md-no-sticky\"><span>Customer Follow-up Date </span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in Followupdate\"><div class=\"md-list-item-text\"><h3>\n{{note.CustomerReference}} - {{note.CompanyName}}</h3><p>{{note.Mobile}}</p><p>{{note.Email}}</p></div></md-list-item>\n</md-list><md-divider></md-divider><md-list ng-if=\"Leaddata.length>0\"><md-subheader class=\"md-no-sticky\"><span>\nLead Expected Response Date </span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in Leaddata\"><div \nclass=\"md-list-item-text\"><h3>{{note.customerdetails[0].CustomerReference}} - {{event.customerdetails[0].CompanyName}}\n</h3><p>Lead#-{{note.LeadReferenceNo}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list \nng-if=\"ContractStartdata.length>0\"><md-subheader class=\"md-no-sticky\"><span>Contract Starts Today</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"event in ContractStartdata\"><div class=\"md-list-item-text\"><h3>\n{{event.customerdetails[0].CustomerReference}} - {{event.customerdetails[0].CompanyName}}</h3><p>\nContract#-{{event.ContractReferenceNo}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list \nng-if=\"ContractEndData.length>0\"><md-subheader class=\"md-no-sticky\"><span>Contract Ends Today</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"event in ContractEndData\"><div class=\"md-list-item-text\"><h3>\n{{event.customerdetails[0].CustomerReference}} - {{event.customerdetails[0].CompanyName}}</h3><p>\nContract#-{{event.ContractReferenceNo}}</p></div></md-list-item></md-list><md-divider></md-divider>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-show=\"CustomersTool\" ui-sref=\"app.customer\" aria-label=\"User settings\" \ntitle=\"Customer\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon></md-button><md-button ng-show=\"ContractsTool\" \nui-sref=\"app.contracts\" aria-label=\"User settings\" title=\"Contracts\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon></md-button>\n<md-button ng-show=\"WorkOrdersTool\" ui-sref=\"app.saleorder\" aria-label=\"User settings\" title=\"Work Orders\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon></md-button>\n<md-button ng-show=\"SchedulerTool\" ui-sref=\"app.scheduler\" aria-label=\"Scheduler\" title=\"Scheduler\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><md-icon md-font-icon=\"icon-calendar\" class=\"icon\"></md-icon>\n</md-button><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide-xs>{{UserName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-button \nng-click=\"cpmodal($event)\"><span translate=\"TOOLBAR.Change_Password\">Change Password</span></md-button></md-menu-item>\n<md-menu-item class=\"md-indent\" ui-sref=\"app.uniformrequisition\"><md-icon md-font-icon=\"icon-email\" class=\"icon\">\n</md-icon><md-button><span>Email Log</span></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\"><span \ntranslate=\"TOOLBAR.Logout\">Logout</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><style>\n#toolbar #user-menu .user-button {\r\n        margin: 0;\r\n        padding: 0px 14px !important;\r\n        height: 64px;\r\n        text-transform: none;\r\n    }\r\n    .md-button{\r\n        min-width: 50px!important;\r\n    }\n</style>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\" ng-show=\"LeaveRequest\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ui-sref=\"app.human-resource_leaveform\" aria-label=\"User settings\" title=\"Leave Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-layers\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Leave Request</span></div></md-button></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"MaterialRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.materialrequisition\" \naria-label=\"User settings\" title=\"Material Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-material-ui\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Material Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"PurchaseRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.purchaserequisition\" aria-label=\"User settings\" title=\"Purchase Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-tile-four\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Purchase Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"UniformRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.uniformrequisition\" \naria-label=\"User settings\" title=\"Uniform Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-ungroup\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Uniform Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"IncidentReporting\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.human-resource_incidentform\" aria-label=\"User settings\" title=\"Incident Reporting\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-checkerboard\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Incident Reporting</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/vincent.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.uniformrequisition\"><md-icon md-font-icon=\"icon-laptop\" class=\"icon\"></md-icon>\n<md-button>IT Support</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"icon\"></md-icon><md-button ng-click=\"cpmodal($event)\">Change Password</md-button></md-menu-item><md-menu-divider\n ng-show=\"MedicalClaim == true || ExpenseClaim == true  || PaymentVoucher == true \"></md-menu-divider><md-menu-item \nng-show=\"MedicalClaim\" class=\"md-indent\" ui-sref=\"app.human-resource_medicalform\"><md-icon \nmd-font-icon=\"icon-hospital\" class=\"icon\"></md-icon><md-button>Medical Claim Submission</md-button></md-menu-item>\n<md-menu-item ng-show=\"ExpenseClaim\" class=\"md-indent\" ui-sref=\"app.accounts_expenseclaim\"><md-icon \nmd-font-icon=\"icon-file-document-box\" class=\"icon\"></md-icon><md-button>Expense Claim Submission</md-button>\n</md-menu-item><md-menu-item ng-show=\"PaymentVoucher\" class=\"md-indent\" ui-sref=\"app.accounts_payment\"><md-icon \nmd-font-icon=\"icon-cash-usd\" class=\"icon\"></md-icon><md-button>Payment Voucher</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><style>\n#toolbar #user-menu .user-button {\r\n        margin: 0;\r\n        padding: 0px 14px !important;\r\n        height: 64px;\r\n        text-transform: none;\r\n    }\n</style>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\" ng-show=\"LeaveRequest\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ui-sref=\"app.human-resource_leaveform\" aria-label=\"User settings\" title=\"Leave Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-layers\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Leave Request</span></div></md-button></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"MaterialRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.materialrequisition\" aria-label=\"User settings\" title=\"Material Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-material-ui\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Material Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"PurchaseRequest\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.purchaserequisition\" \naria-label=\"User settings\" title=\"Purchase Request\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-tile-four\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Purchase Request</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" \nng-show=\"UniformRequest\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nui-sref=\"app.uniformrequisition\" aria-label=\"User settings\" title=\"Uniform Request\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-ungroup\" class=\"icon\"></md-icon><span \nstyle=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Uniform Request</span></div></md-button></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\" ng-show=\"IncidentReporting\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ui-sref=\"app.human-resource_incidentform\" \naria-label=\"User settings\" title=\"Incident Reporting\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 18px\"><md-icon md-font-icon=\"icon-checkerboard\" \nclass=\"icon\"></md-icon><span style=\"color: rgba(0,0,0,0.87)\" class=\"username\" hide-xs>Incident Reporting</span></div>\n</md-button></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/vincent.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.uniformrequisition\"><md-icon md-font-icon=\"icon-laptop\" class=\"icon\"></md-icon>\n<md-button>IT Support</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"icon\"></md-icon><md-button ng-click=\"cpmodal($event)\">Change Password</md-button></md-menu-item><md-menu-divider\n ng-show=\"MedicalClaim == true || ExpenseClaim == true  || PaymentVoucher == true \"></md-menu-divider><md-menu-item \nng-show=\"MedicalClaim\" class=\"md-indent\" ui-sref=\"app.human-resource_medicalform\"><md-icon \nmd-font-icon=\"icon-hospital\" class=\"icon\"></md-icon><md-button>Medical Claim Submission</md-button></md-menu-item>\n<md-menu-item ng-show=\"ExpenseClaim\" class=\"md-indent\" ui-sref=\"app.accounts_expenseclaim\"><md-icon \nmd-font-icon=\"icon-file-document-box\" class=\"icon\"></md-icon><md-button>Expense Claim Submission</md-button>\n</md-menu-item><md-menu-item ng-show=\"PaymentVoucher\" class=\"md-indent\" ui-sref=\"app.accounts_payment\"><md-icon \nmd-font-icon=\"icon-cash-usd\" class=\"icon\"></md-icon><md-button>Payment Voucher</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><style>\n#toolbar #user-menu .user-button {\r\n        margin: 0;\r\n        padding: 0px 14px !important;\r\n        height: 64px;\r\n        text-transform: none;\r\n    }\n</style>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/apps/accounts/assetmanagement/Depreciation.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.Title}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.DepreciationMethod\" \nplaceholder=\"{{\'ASSETMANAGEMENT.DEPRECIATION METHOD\'|translate}}\" required></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.DepreciationValue\" \nplaceholder=\"{{\'ASSETMANAGEMENT.DEPRECIATION VALUE (%)\'|translate}}\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"ASSETMANAGEMENT.START DATE\" \nstyle=\"margin-right: 10px\">Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.DepreciationStartDate\" required></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"ASSETMANAGEMENT.END DATE\" style=\"margin-right: 10px\">End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.DepreciationEndDate\" required></md-datepicker></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"SubmitDepreciation()\" \nng-disabled=\"!vm.DepreciationMethod||!vm.DepreciationValue||!vm.DepreciationStartDate||!vm.DepreciationEndDate\" \nclass=\"md-raised md-accent\">{{\'ASSETMANAGEMENT.SUBMIT\'|translate}}</md-button><md-button \nstyle=\"height: 36px !important\" class=\"md-raised\" ng-click=\"cancel()\">{{\'ASSETMANAGEMENT.NO\'|translate}}</md-button>\n</div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/assetmanagement/Depreciationhistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"ASSETMANAGEMENT.DEPRECIATION HISTORY\" class=\"title\">DEPRECIATION HISTORY</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.PURCHASE COST\" class=\"column-title\">Purchase Cost</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DEPRECIATION VALUE (%)\" \nclass=\"column-title\">Depreciation Value (%)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n translate=\"ASSETMANAGEMENT.CURRENT VALUE\" class=\"column-title\">Current Value</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DEPRECIATION METHOD\" \nclass=\"column-title\">Depreciation Method</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.DEPRECIATION START DATE\" class=\"column-title\">Depreciation Start Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DEPRECIATION END DATE\" \nclass=\"column-title\">Depreciation End Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in deatilgrid\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>$ {{ row.PurchaseCost || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n{{ row.DepreciationValue || 0 |number:2 }}</td><td>$ {{ row.CurrentValue || 0 |number:2 }}</td><td>\n{{ row.DepreciationMethod }}</td><td nowrap=\"nowrap\">{{ row.DepreciationStartDate| date:\'dd/MM/y\' }}</td><td \nnowrap=\"nowrap\">{{ row.DepreciationEndDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></div><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\" class=\"md-raised md-accent\">\n{{\'ASSETMANAGEMENT.CLOSE\'|translate}}</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/accounts/assetmanagement/assetmanagement.html","<div id=\"assetmanagement\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"ASSETMANAGEMENT.HEADER\">Asset Management</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'ASSETMANAGEMENT.SEARCH\'|translate}}\" flex></div>\n<div><md-button class=\"md-raised md-background\" ng-click=\"AssetRegisteradd($event)\" ng-show=\"AssetRegisterSelect\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon><span translate=\"ASSETMANAGEMENT.ADD\">Add</span></md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"AssetDisposaladd($event)\" ng-show=\"AssetDisposalSelect\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"ASSETMANAGEMENT.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"AssetRegisterExport()\" ng-show=\"AssetRegisterSelect && AllowExport==\'true\'\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"ASSETMANAGEMENT.EXPORT\">Export</span></md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"AssetDisposalExport()\" \nng-show=\"AssetDisposalSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"ASSETMANAGEMENT.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"AssetDepreciationExport()\" ng-show=\"AssetDepreciationSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"ASSETMANAGEMENT.EXPORT\">Export</span></md-button></div></div><div\n class=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab ng-click=\"AssetRegisterTab()\"><md-tab-label>\n<span translate=\"ASSETMANAGEMENT.ASSET_REGISTER\">Asset Register</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" novalidate><div\n layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span\n translate=\"ASSETMANAGEMENT.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"ASSETMANAGEMENT.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"ASSETMANAGEMENT.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"ASSETMANAGEMENT.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"ASSETMANAGEMENT.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"ASSETMANAGEMENT.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"ASSETMANAGEMENT.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"ASSETMANAGEMENT.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"AssetRegisterdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.REFERENCE_NUMBER\" class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DESCRIPTION_OF_ASSETS\" \nclass=\"column-title\">Description of Assets</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.PRODUCT_CODE\" class=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.SERIAL_NUMBER\" class=\"column-title\">Serial Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DATE_OF_PURCHASE\" \nclass=\"column-title\">Date of Purchase</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.MAKE/BRAND\" class=\"column-title\">Make / Brand</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.PURCHASE_ORDER_NO\" class=\"column-title\">Purchase Order No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.SUPPLIER_NAME\" \nclass=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.LOCATION\" class=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"ASSETMANAGEMENT.RECEIVED_BY\" class=\"column-title\">Received By</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"ASSETMANAGEMENT.RECEIVED_DATE\" class=\"column-title\">Received Date</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in AssetRegisterdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td nowrap=\"nowrap\"><a href=\"\" ng-click=\"AssetRegisterinfo($event,row._id)\" title=\"View/Edit\" style=\"border:none\">\n{{ row.ReferenceNumber }}</a></td><td nowrap=\"nowrap\">{{ row.Description }}</td><td nowrap=\"nowrap\">\n{{ row.Productdetails[0].ProductCode }}</td><td nowrap=\"nowrap\">{{ row.SerialNumber }}</td><td nowrap=\"nowrap\">\n{{ row.PurchaseDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Brand }}</td><td nowrap=\"nowrap\">\n{{ row.PurchaseOrderdetails[0].ReferenceNo }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}</td><td \nnowrap=\"nowrap\">{{ row.Location }}</td><td nowrap=\"nowrap\">{{ row.ReceivedBy}}</td><td nowrap=\"nowrap\">\n{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab>\n<md-tab ng-click=\"AssetDisposalTab()\"><md-tab-label><span translate=\"ASSETMANAGEMENT.ASSET DISPOSAL / WRITE-OFF\">\nAsset Disposal / Write-off</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" novalidate><div\n layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span\n translate=\"ASSETMANAGEMENT.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"ASSETMANAGEMENT.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"ASSETMANAGEMENT.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"ASSETMANAGEMENT.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"ASSETMANAGEMENT.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"ASSETMANAGEMENT.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"ASSETMANAGEMENT.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"ASSETMANAGEMENT.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"AssetDisposaldatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.ASSET_TAG\" class=\"column-title\">Asset Tag</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"ASSETMANAGEMENT.ITEM\" class=\"column-title\">Item</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.ASSET_VALUE\" class=\"column-title\">\nAsset Value</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.DISPOSAL_REASON\" class=\"column-title\">Disposal Reason</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.DISPOSAL_DATE\" class=\"column-title\">\nDisposal Date</span></div></th><th class=\"secondary-text\"><div><span translate=\"ASSETMANAGEMENT.VIEW/EDIT\" \nclass=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in AssetDisposaldatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Assetdetails[0].ReferenceNumber }}</td><td>{{ row.Item }}\n</td><td>$ {{ row.AssetValue || 0 |number:2 }}</td><td>{{ row.DisposalReason }}</td><td>\n{{ row.DisposalDate | date:\'dd/MM/y\' }}</td><td class=\"editMe\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"AssetDisposalinfo($event,row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab ng-click=\"AssetDepreciationTab()\">\n<md-tab-label><span translate=\"ASSETMANAGEMENT.ASSET_DEPRECIAION\">Asset Depreciation</span></md-tab-label><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" \nnovalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"lastmonth()\"><span translate=\"ASSETMANAGEMENT.LAST_MONTH\">Last Month</span></md-button><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"ASSETMANAGEMENT.LAST_WEEK\">Last Week\n</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"ASSETMANAGEMENT.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"ASSETMANAGEMENT.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"ASSETMANAGEMENT.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"ASSETMANAGEMENT.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"ASSETMANAGEMENT.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"ASSETMANAGEMENT.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"AssetRegisterdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><div \nstyle=\"padding:0 0% 0 1%;float:right;width: 60%\" layout=\"column\" layout-gt-xs=\"row\" ng-show=\"TRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:15%\">\n{{\'ASSETMANAGEMENT.TOTAL ASSETS SELECTED\'|translate}}: {{SelectedIds.length}}</a> <a ng-click=\"Depreciation($event)\" \nstyle=\"cursor:pointer;color: orangered;font-size:13.5px;padding-right:5%\">\n{{\'ASSETMANAGEMENT.CALCULATE DEPRECIATION\'|translate}}</a></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\" nowrap=\"nowrap\"><div><md-checkbox ng-change=\"CheckAll(All)\" ng-model=\"All\" \nstyle=\"margin-bottom:0\" type=\"checkbox\"></md-checkbox></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span translate=\"ASSETMANAGEMENT.ASSET_CODE\" class=\"column-title\">Asset Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.ASSET_DESCRIPTION\" \nclass=\"column-title\">Asset Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.PRODUCT_CODE\" class=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.SERIAL_NUMBER\" class=\"column-title\">Serial Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.MAKE/BRAND\" \nclass=\"column-title\">Make / Brand</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.ASSET LOCATION\" class=\"column-title\">Asset Location</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.YEARS ACTIVE\" class=\"column-title\">\nYears Active</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.PURCHASE_ORDER_NO\" \nclass=\"column-title\">Purchase Order No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.DATE_OF_PURCHASE\" class=\"column-title\">Purchase Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"ASSETMANAGEMENT.PURCHASE COST\" class=\"column-title\">\nPurchase Cost</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"ASSETMANAGEMENT.CURRENT VALUE\" class=\"column-title\">Current Value</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"ASSETMANAGEMENT.UPDATED BY\" class=\"column-title\">Updated By</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"ASSETMANAGEMENT.UPDATED DATE\" class=\"column-title\">Updated Date\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in AssetDepreciationdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><md-checkbox style=\"margin: 0\" ng-change=\"Check(All ,row._id)\" \nng-checked=\"Selec.value\" ng-model=\"All\" type=\"checkbox\"></md-checkbox></td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"ViewDepreciationHistory($event,row.itemDetails)\" title=\"View Depreciation History\" style=\"border:none\">\n{{ row.ReferenceNumber }}</a></td><td nowrap=\"nowrap\">{{ row.Description }}</td><td nowrap=\"nowrap\">\n{{ row.Productdetails[0].ProductCode }}</td><td nowrap=\"nowrap\">{{ row.SerialNumber }}</td><td nowrap=\"nowrap\">\n{{ row.Brand }}</td><td nowrap=\"nowrap\">{{ row.Location }}</td><td nowrap=\"nowrap\">\n{{ getYearsActive(row.PurchaseDate) }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}</td><td \nnowrap=\"nowrap\">{{ row.PurchaseOrderdetails[0].ReferenceNo }}</td><td nowrap=\"nowrap\">\n{{ row.PurchaseDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.PurchaseOrderdetails[0].Total || 0 |number:2}}\n</td><td nowrap=\"nowrap\">{{ row.CurrentValue || 0 |number:2}}</td><td nowrap=\"nowrap\">{{ row.UpdatedBy}}</td><td \nnowrap=\"nowrap\">{{ row.UpdatedDate | date:\'dd/MM/y hh:MM:ss\' }}</td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none!important;\r\n        visibility: hidden!important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\n</style><style>\n/* md-datepicker .md-datepicker-input {\r\n            width: calc(23vw - 35px);\r\n            max-width: calc(35vw - 54px);\r\n        } */\r\n    \r\n        .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n        }\r\n    \r\n        .hidden {\r\n            display: none!important;\r\n            visibility: hidden!important;\r\n        }\r\n    \r\n    \r\n        .group-title {\r\n            background-color: #687074 !important;\r\n            color: #FFF !important;\r\n        }\r\n    \r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n    \r\n        .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n        .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n        .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n        .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n            border-bottom-color: rgba(0, 0, 0, 0.15);\r\n        }\r\n    \r\n        .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n        .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n        .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n        .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n            border-bottom-color: rgba(0, 0, 0, 0.14);\r\n        }\r\n    \r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n    \r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            width: 1;\r\n        }\r\n    \r\n        #pdate md-datepicker .md-datepicker-input {\r\n            width: calc(23vw - 35px);\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n    \r\n        .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n            border-top-color: green !important;\r\n        }\r\n    \r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: green !important;\r\n            border-bottom-color: red !important;\r\n        }\r\n    \r\n        #Supplierfilter md-select .md-select-value {\r\n            color: green !important;\r\n            border-bottom-color: red !important;\r\n        }\r\n    \r\n    \r\n        button#button {\r\n            margin-bottom: 50px;\r\n        }\r\n    \r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/assetmanagement/assetregister.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"ASSETMANAGEMENT.ASSET_REGISTER\" class=\"title\">Asset Register</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ReferenceNumber\" placeholder=\"{{\'ASSETMANAGEMENT.REFERENCE_NUMBER\'|translate}}\" required \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" \nng-model=\"vm.Description\" placeholder=\"{{\'ASSETMANAGEMENT.DESCRIPTION\'|translate}}\" required><div \nng-messages=\"eventForm.Description.$error\" ng-show=\"eventForm.Description.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ASSETMANAGEMENT.DESCRIPTION_FIELD_IS_REQUIRED\">Description field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"ASSETMANAGEMENT.PRODUCT\">Product</label><md-select ng-model=\"vm.ProductID\" id=\"searchmodule\" required>\n<md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'ASSETMANAGEMENT.SEARCH_FOR_A_PRODUCT\'|translate}}.\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ProductID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Productdatas | filter:vm.searchTerm1\" value=\"{{row._id}}\">{{row.ProductCode}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"SerialNumber\" ng-model=\"vm.SerialNumber\" \nplaceholder=\"{{\'ASSETMANAGEMENT.SERIAL_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Brand\" ng-model=\"vm.Brand\" \nplaceholder=\"{{\'ASSETMANAGEMENT.MAKE/BRAND\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Location\" ng-model=\"vm.Location\" placeholder=\"{{\'ASSETMANAGEMENT.LOCATION\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"ASSETMANAGEMENT.PURCHASE_ORDER\">Purchase Order</label><md-select ng-model=\"vm.PurchaseOrderID\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'ASSETMANAGEMENT.SEARCH_FOR_A_PURCHASE_ORDER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.PurchaseOrderID=null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Purchaseorderdatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.ReferenceNo}}</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\" id=\"DateFilterWidth\"><label \ntranslate=\"ASSETMANAGEMENT.DATE_OF_PURCHASE\">Purchased Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.PurchaseDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"ReceivedBy\" ng-model=\"vm.ReceivedBy\" \nplaceholder=\"{{\'ASSETMANAGEMENT.RECEIVED_BY\'|translate}}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\" id=\"DateFilterWidth\"><label translate=\"ASSETMANAGEMENT.RECEIVED_DATE\">Received Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.ReceivedDate\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'ASSETMANAGEMENT.REMARKS\'|translate}}\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveAssetRegister()\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'ASSETMANAGEMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"closeDialog()\" \naria-label=\"CANCEL\">{{\'ASSETMANAGEMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog>\n<style>\n#DateFilterWidth md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 2px);\r\n    max-width: calc(21vw - 35px);\r\n    margin-left: -11px;\r\n}\n</style>");
$templateCache.put("app/main/apps/accounts/assetmanagement/disposal.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"ASSETMANAGEMENT.ASSET_DISPOSAL\" class=\"title\">Asset Disposal</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"ASSETMANAGEMENT.ASSET_TAG\">Asset Tag</label><md-select ng-model=\"vm.AssetID\" id=\"searchmodule\" required \nng-change=\"OnAssetTagChange()\"><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'ASSETMANAGEMENT.SEARCH FOR A ASSET\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"AssetIDclear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in AssetRegisterdatas | filter:vm.searchTerm1\" value=\"{{row._id}}\">{{row.ReferenceNumber}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"Item\" ng-model=\"vm.Item\" \nplaceholder=\"{{\'ASSETMANAGEMENT.ITEM\'|translate}}\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Asset Value\" ng-model=\"vm.AssetValue\" \nplaceholder=\"{{\'ASSETMANAGEMENT.ASSET_VALUE\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Disposal Reason\" ng-model=\"vm.DisposalReason\" \nplaceholder=\"{{\'ASSETMANAGEMENT.DISPOSAL_REASON\'|translate}}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"ASSETMANAGEMENT.DISPOSAL_DATE\">Disposal Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.DisposalDate\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'ASSETMANAGEMENT.REMARKS\'|translate}}\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveAssetDisposal()\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'ASSETMANAGEMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"closeDialog()\" \naria-label=\"CANCEL\">{{\'ASSETMANAGEMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog>\n<style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 2px);\r\n        max-width: calc(20vw - 38px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/bankcash/alertuser.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"BANKANDCASH.UPDATE DEPOSITED MONEY STATUS\" class=\"title\">\nUpdate Deposited Money Status</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><br><label layout-align=\"space-between center\" \nstyle=\"color:red;padding-left:80px\" ng-show=\"!IsPending\"><b>\n{{\'BANKANDCASH.CHEQUE HAS BEEN ALREADY\'|translate}} {{vm.Status}} <b></b></b></label><br><md-dialog-actions><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"UpdateDepositMoneyClearedStatus()\" class=\"md-raised md-accent\" ng-show=\"IsPending\">\n{{\'BANKANDCASH.CLEARED\'|translate}}</md-button><md-button ng-click=\"UpdateDepositMoneyReturnedStatus()\" \nclass=\"md-raised md-accent\" ng-show=\"IsPending\">{{\'BANKANDCASH.RETURNED\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"closeDialog()\" style=\"margin-top:-40px\">{{\'BANKANDCASH.CANCEL\'|translate}}</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/accounts/bankcash/bankcash.html","<div id=\"bankcash\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"BANKANDCASH.HEADER\">Bank & Cash</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowGrid()\" ng-show=\"PettyCashClaimform\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"BANKANDCASH.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"PaymentShowGrid()\" ng-show=\"PaymentVoucherform\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"BANKANDCASH.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background pull-18\" ng-click=\"Depositadd($event)\" ng-show=\"DepositSelect\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"BANKANDCASH.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background pull-18\" ng-click=\"Transferadd($event)\" ng-show=\"TransferSelect\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"BANKANDCASH.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"PettyCashExport()\" ng-show=\"PettyCashClaimgrid && AllowExport==\'true\'\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"BANKANDCASH.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"PaymentVoucherExport()\" ng-show=\"PaymentVouchergrid && AllowExport==\'true\'\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"BANKANDCASH.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"DepositExport()\" ng-show=\"DepositSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"BANKANDCASH.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"TransferExport()\" ng-show=\"TransferSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"BANKANDCASH.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab ng-click=\"PettyCashTab()\"><md-tab-label><span\n translate=\"BANKANDCASH.PETTY_CASH_CLAIM\">Petty Cash Claim</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"PettyCashClaimgrid\"><form \nname=\"organizationform1\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"BANKANDCASH.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"BANKANDCASH.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"Today()\"><span translate=\"BANKANDCASH.TODAY\">Today</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextWeek()\"><span translate=\"BANKANDCASH.NEXT_WEEK\">Next Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextMonth()\"><span \ntranslate=\"BANKANDCASH.NEXT_MONTH\">Next Month</span></md-button><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BANKANDCASH.FROM\" style=\"color:green;font-size: 14px\">\nFrom</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\">\n</md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BANKANDCASH.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"BANKANDCASH.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Expenseclaimdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.REFERENCE_NUMBER\" class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.EMPLOYEE_ID\" class=\"column-title\">\nEmployee ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.EMPLOYEE_NAME\" class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BANKANDCASH.DATE\" class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.REMARKS\" class=\"column-title\">Remarks\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span translate=\"BANKANDCASH.REPORT\" \nclass=\"column-title\">Report</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Expenseclaimdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewExpenseclaiminfo(row._id)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNumber }}</a></td><td>{{ row.Employeedetails[0].EmployeeID }}\n</td><td>{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Remarks}}\n</td><td>{{ row.Status }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"ExpenseClaimprintToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon></md-button></td></tr></tbody></table></div></div></form><div class=\"content\" id=\"invoice\" ng-show=\"Pop\"><div\n style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b>\n{{\'BANKANDCASH.EXPENSE CLAIM REQUEST\'|translate}}</b> <img ng-if=\"QRCode\" \nstyle=\"height:20%; width:20%;float:right;margin-top:-1%\" src=\"{{QRCode}}\"></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Reference #:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{ReferenceNumber}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Date:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{Date | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Employee ID:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EID}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Name:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EmployeeName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Remarks:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Remarks}}</th></tr></thead><tbody></tbody><tfoot>\n</tfoot></table><br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">DESCRIPTION</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">AMOUNT</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">NOTES</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">BILL ATTACHED</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Expenseclaimdetailsdatas\" ng-if=\"row.MaterialID == MaterialID\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Amount }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Notes }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><br><br><br><br><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Received By<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Date Prepared<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Date Received<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Verified/ Issued By</th><th \nstyle=\"border-collapse: collapse;width:700px\">Delivered By</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"PettyCashClaimform\" flex><form \nname=\"basicForm2\"><div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;{{\'BANKANDCASH.EXPENSE CLAIM DETAILS\'|translate}}</h2>\n<hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">{{\'BANKANDCASH.REFERENCE_NUMBER\'|translate}}#</label>\n&nbsp; : &nbsp; {{ReferenceNumber}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'BANKANDCASH.REQUESTED BY\'|translate}}</label>&nbsp; :&nbsp; {{EID}} - {{EmployeeName}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'BANKANDCASH.DATE\'|translate}}</label>\n&nbsp; :&nbsp; {{Date | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'BANKANDCASH.REMARKS\'|translate}}</label>&nbsp; : &nbsp; {{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">\n&nbsp;{{\'BANKANDCASH.WORKFLOW\'|translate}}</h2><hr><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" flex><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label \nstyle=\"width:110px;font-weight:500\">{{\'BANKANDCASH.CURRENT_STATUS\'|translate}}</label>: &emsp; {{Actioned}}</div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><label style=\"width:100px;font-weight:500\">\n{{\'BANKANDCASH.NEXT_STATUS\'|translate}}</label>: &emsp; {{NextLevelAction}}</div></div><br><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button class=\"md-accent md-raised\" \nid=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span></md-button></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowRejectButton\"><md-button \nclass=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" ng-click=\"reject()\"><span translate=\"BANKANDCASH.REJECT\">Reject\n</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" value=\"Cancel\" \nng-click=\"cancel()\"><span translate=\"BANKANDCASH.CANCEL\">Cancel</span></md-button></div><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" \nid=\"revise\" value=\"Revise\" ng-click=\"revise()\"><span translate=\"BANKANDCASH.REVISE\">Revise</span></md-button></div>\n</div><br><table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.ACTION\" class=\"column-title\">Action</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.ACTIONED_BY\" class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.ACTIONED_DATE\" class=\"column-title\">\nActioned Date</span></div></th></tr></thead><tbody class=\"css-serial\"><tr ng-repeat=\"row in Logdetailsdatas\"><td>&nbsp;\n</td><td>{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div><br><br><div class=\"form-wrapper md-whiteframe-1dp\" flex \nstyle=\"width:100%;float:left\"><h1 style=\"text-align:left\">&nbsp;{{\'BANKANDCASH.CLAIM DETAILS\'|translate}}</h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.AMOUNT\" class=\"column-title\">Amount\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.NOTES\" \nclass=\"column-title\">Notes</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.BILL_ATTACHED\" class=\"column-title\">Bill Attached</span></div></th></tr></thead><tbody \nclass=\"css-serial\"><tr ng-repeat=\"row in Expenseclaimdetailsdatas\"><td>&nbsp;</td><td>{{ row.Description }}</td><td \nnowrap=\"nowrap\">$ {{ row.Amount || 0 |number:2 }}</td><td>{{ row.Notes }}</td><td>\n{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody></table></div></div><br><div class=\"content-card\" \nstyle=\"width:100%\"><br><div class=\"white-bg md-whiteframe-4dp\" style=\"width:39.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;{{\'BANKANDCASH.COMMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"{{\'BANKANDCASH.COMMENT_HERE..\'|translate}}\" required></md-input-container></div>\n<div style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm2.$invalid || basicForm2.$pristine\"><span translate=\"BANKANDCASH.SAVE\">Save</span></md-button>\n</div><table class=\"dataTable row-border hover\" id=\"tb2\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.COMMENT\" class=\"column-title\">Comment</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.COMMENTED_BY\" class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.COMMENTED_DATE\" class=\"column-title\">\nCommented Date</span></div></th></tr></thead><tbody class=\"css-serial\"><tr ng-repeat=\"row in Commentdatas\"><td>&nbsp;\n</td><td>{{ row.cmt }}</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:59.5%;float:right\"><h2 \nstyle=\"text-align:left\">&nbsp;{{\'BANKANDCASH.ATTACHMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" id=\"tb3\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.FILE_NAME\" \nclass=\"column-title\">File Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.FILE_SIZE(KB)\" class=\"column-title\">File Size(KB)</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BANKANDCASH.UPLOADED_BY\" class=\"column-title\">Uploaded By</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.UPLOADED_DATE\" class=\"column-title\">\nUploaded Date</span></div></th></tr></thead><tbody class=\"css-serial\"><tr ng-repeat=\"row in Attachmentdatas\" \nng-if=\"row.FileID == ReferenceNumber\"><td></td><td><a href=\"{{UploadsURL}}Accounts/Expense Claim/{{row.TableID}}\" \ndownload style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div></div><br><br></form><br></div>\n</div></md-tab-body></md-tab><md-tab ng-click=\"PaymentVoucherTab()\"><md-tab-label><span \ntranslate=\"BANKANDCASH.PAYMENT_VOUCHER\">Payment Voucher</span></md-tab-label><md-tab-body><form name=\"PaymentVoucher\" \nclass=\"md-inline-form\" novalidate><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nclass=\"content-card\" ng-show=\"PaymentVouchergrid\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"BANKANDCASH.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"BANKANDCASH.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"Today()\"><span translate=\"BANKANDCASH.TODAY\">Today</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextWeek()\"><span translate=\"BANKANDCASH.NEXT_WEEK\">Next Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextMonth()\"><span \ntranslate=\"BANKANDCASH.NEXT_MONTH\">Next Month</span></md-button><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BANKANDCASH.FROM\" style=\"color:green;font-size: 14px\">\nFrom</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\">\n</md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BANKANDCASH.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"BANKANDCASH.SEARCH\">\n{{\'BANKANDCASH.SEARCH\'}}</span></md-button></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Paymentformdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.REFERENCE_NUMBER\" class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.EMPLOYEE_ID\" class=\"column-title\">\nEmployee ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.EMPLOYEE_NAME\" class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BANKANDCASH.DATE\" class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.REMARKS\" class=\"column-title\">Remarks\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span translate=\"BANKANDCASH.REPORT\" \nclass=\"column-title\">Report</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paymentformdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewPaymentinfo(row._id)\" title=\"Detail Grid\" \nstyle=\"border:none\">{{ row.ReferenceNumber }}</a></td><td>{{ row.Employeedetails[0].EmployeeID }}</td><td>\n{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Remarks}}</td><td>\n{{ row.Status }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"PaymentVoucherprintToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon></md-button></td></tr></tbody></table></div><div class=\"content\" id=\"printpaymentvoucher\" ng-show=\"Pop\"><div \nstyle=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\"><b>PAYMENT VOUCHER REQUEST</b> <img\n ng-if=\"QRCode\" style=\"height:20%; width:20%;float:right;margin-top:-1%\" src=\"{{QRCode}}\"></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Reference #:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{ReferenceNumber}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Date:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{Date | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Name:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EmployeeName}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Remarks:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Remarks}}</th></tr></thead><tbody></tbody></table>\n<br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">DESCRIPTION</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">AMOUNT</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">GST</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">NOTES</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">BILL ATTACHED</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Paymentdetailsdatas\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Amount }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">\n{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Notes }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><br><br><br><br><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Received By<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Date Prepared<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Date Received<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Verified/ Issued By</th><th \nstyle=\"border-collapse: collapse;width:700px\">Delivered By</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div layout=\"column\" ng-show=\"PaymentVoucherform\"><div class=\"form-wrapper md-whiteframe-1dp\" \nstyle=\"margin-top:-30px\" flex><div class=\"content-card\" style=\"width:100%;padding:-1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;{{\'BANKANDCASH.PAYMENT VOUCHER DETAILS\'|translate}}</h2><hr>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'BANKANDCASH.REFERENCE_NUMBER\'|translate}}#</label>\n&nbsp; :&nbsp; {{ReferenceNumber}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'BANKANDCASH.REQUESTED BY\'|translate}}</label>&nbsp; :&nbsp; {{EmployeeName}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'BANKANDCASH.DATE\'|translate}}</label>\n&nbsp; :&nbsp;{{Date | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'BANKANDCASH.REMARKS\'|translate}}</label>&nbsp; :&nbsp; {{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">\n&nbsp;{{\'BANKANDCASH.WORKFLOW\'|translate}}</h2><hr><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" flex><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label \nstyle=\"width:110px;font-weight:500\">{{\'BANKANDCASH.CURRENT_STATUS\'|translate}}</label>: &emsp; {{Actioned}}</div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><label style=\"width:100px;font-weight:500\">\n{{\'BANKANDCASH.NEXT_STATUS\'|translate}}</label>: &emsp; {{NextLevelAction}}</div></div><br><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button class=\"md-accent md-raised\" \nid=\"review\" value=\"Review\" ng-click=\"Paymentworkflow()\"><span>{{NextLevelAction}}</span></md-button></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowRejectButton\"><md-button \nclass=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" ng-click=\"Paymentreject()\"><span>Reject</span></md-button></div>\n<div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button \nclass=\"md-accent md-raised\" id=\"cancel\" value=\"Cancel\" ng-click=\"Paymentcancel()\"><span translate=\"BANKANDCASH.CANCEL\">\nCancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" value=\"Revise\" \nng-click=\"Paymentrevise()\"><span>Revise</span></md-button></div></div><br><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.ACTION\" class=\"column-title\">Action\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.ACTIONED_BY\" \nclass=\"column-title\">Actioned By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.ACTIONED_DATE\" class=\"column-title\">Actioned Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Paymentlogdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Action }}</td>\n<td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div>\n</div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h2 style=\"text-align:left\">\n&nbsp;{{\'BANKANDCASH.PAYMENT DETAILS\'|translate}}</h2><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.AMOUNT\" class=\"column-title\">Amount\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.NOTES\" \nclass=\"column-title\">Notes</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.BILL_ATTACHED\" class=\"column-title\">Bill Attached</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Paymentdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Description }}\n</td><td>$ {{ row.Amount || 0 |number:2 }}</td><td>{{ row.Notes }}</td><td>{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td>\n</tr></tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content-card\" \nstyle=\"width:100%;padding:-1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:39.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;{{\'BANKANDCASH.COMMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"{{\'BANKANDCASH.COMMENT_HERE..\'|translate}}..\" required></md-input-container></div>\n<div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button class=\"md-raised md-accent\" \nng-click=\"PaymentcommentSubmit()\" ng-disabled=\"PaymentVoucher.$invalid || PaymentVoucher.$pristine\"><span \ntranslate=\"BANKANDCASH.SAVE\">Save</span></md-button></div><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.COMMENT\" class=\"column-title\">Comment\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.COMMENTED_BY\" \nclass=\"column-title\">Commented By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.COMMENTED_DATE\" class=\"column-title\">Commented Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Paymentcommentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}</td><td>\n{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:59.5%;float:right\"><h2 style=\"text-align:left\">\n&nbsp;{{\'BANKANDCASH.ATTACHMENTS\'|translate}}</h2><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.FILE_NAME\" class=\"column-title\">File Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.FILE_SIZE(KB)\" class=\"column-title\">File Size(KB)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.UPLOADED_BY\" class=\"column-title\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.UPLOADED_DATE\" class=\"column-title\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Paymentattachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Accounts/Payment Voucher/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div></div></div></div></form></md-tab-body></md-tab><md-tab ng-click=\"DepositTab()\">\n<md-tab-label><span translate=\"BANKANDCASH.DEPOSIT_MONEY\">Deposit Money</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" novalidate><div\n layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span\n translate=\"BANKANDCASH.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"BANKANDCASH.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"BANKANDCASH.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"BANKANDCASH.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"BANKANDCASH.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"BANKANDCASH.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\" id=\"Datefilter\"><label translate=\"BANKANDCASH.TO\" style=\"color:green;font-size: 14px\">To</label><md-datepicker\n onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"BANKANDCASH.SEARCH\">\nSearch</span></md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><md-progress-linear ng-hide=\"Depositdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.REFERENCE_NUMBER\" class=\"column-title\">Refrence No</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Receipt No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.INVOICE_NUMBER\" class=\"column-title\">Invoice No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.DATE\" class=\"column-title\">Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.AMOUNT\" \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.CHEQUE_NUMBER\" class=\"column-title\">Cheque No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANKANDCASH.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span translate=\"BANKANDCASH.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANKANDCASH.BANK\" \nclass=\"column-title\">Bank</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANKANDCASH.DEPOSIT_MODE\" class=\"column-title\">Deposit Mode</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span translate=\"BANKANDCASH.STATUS\" class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Depositdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"AlertDepositMoneyStatus($event,row._id)\" title=\"Update Status\" style=\"border:none\">{{ row.RefrenceNo }}</a>\n</td><td nowrap=\"nowrap\">{{ row.ReceiptNo }}</td><td>{{ row.InvoiceNo }}</td><td>{{ row.Date | date:\"dd/MM/y\" }}</td>\n<td nowrap=\"nowrap\">$ {{ row.Amount || 0 |number:2 }}</td><td>{{ row.ChequeNo }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CompanyName }}</td>\n<td>{{ row.Accountdetails[0].AccountCode}}</td><td>{{row.Accountdetails[0].AccountDescription}}</td><td \nnowrap=\"nowrap\">{{ row.Bankdetails[0].BankName }}</td><td>{{ row.DepositMode }}</td><td>{{ row.Status }}</td></tr>\n</tbody></table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .hidden {\r\n        display: none!important;\r\n        visibility: hidden!important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .css-serial {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    .css-serial td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/bankcash/deposit.html","<div id=\"assetregister\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"BANKANDCASH.DEPOSIT_MONEY\" class=\"title\">Deposit Money</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"ReferenceNumber\" \nng-model=\"vm.RefrenceNo\" placeholder=\"{{\'BANKANDCASH.REFERENCE_NUMBER\'|translate}}\" required><div \nng-messages=\"eventForm.ReferenceNumber.$error\" ng-show=\"eventForm.ReferenceNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BANKANDCASH.REFERENCE_NUMBER_IS_REQUIRED\">Reference Number is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"ReceiptNo\" ng-model=\"vm.ReceiptNo\" \nplaceholder=\"{{\'BANKANDCASH.RECEIPT_NO\'|translate}}\"><div ng-messages=\"eventForm.ReceiptNo.$error\" \nng-show=\"eventForm.ReceiptNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BANKANDCASH.RECEIPT_NUMBER_IS_REQUIRED\">Receipt No is required.</span></div></div></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"BANKANDCASH.DATE\">Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"BANKANDCASH.ACCOUNTING_CODE\">Accounting Code</label>\n<md-select ng-model=\"vm.AccountID\" id=\"searchmodule\"><md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'BANKANDCASH.SEARCH_FOR_A_ACCOUNT..\'|translate}} \" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row._id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Amount\" ng-model=\"vm.Amount\" placeholder=\"{{\'BANKANDCASH.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex><label translate=\"BANKANDCASH.DEPOSIT_MODE\">Deposit Mode</label>\n<md-select ng-model=\"vm.DepositMode\" required ng-change=\"OnDepositModeChange()\" required><md-option \nvalue=\"{{\'BANKANDCASH.CASH\'|translate}}\">{{\'BANKANDCASH.CASH\'|translate}}</md-option><md-option \nvalue=\"{{\'BANKANDCASH.CHEQUE\'|translate}}\">{{\'BANKANDCASH.CHEQUE\'|translate}}</md-option><md-option \nvalue=\"{{\'BANKANDCASH.NET_BANKING\'|translate}}\">{{\'BANKANDCASH.NET_BANKING\'|translate}}</md-option><md-option \nvalue=\"{{\'BANKANDCASH.TELEGRAPHIC_TRANSFER\'|translate}}\">{{\'BANKANDCASH.TELEGRAPHIC_TRANSFER\'|translate}}</md-option>\n<md-option value=\"{{\'BANKANDCASH.OTHERS\'|translate}}\">{{\'BANKANDCASH.OTHERS\'|translate}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"BANKANDCASH.BANK_NAME\">Bank Name</label><md-select ng-model=\"vm.BankID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{\'BANKANDCASH.SEARCH_FOR_A_BANK..\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Bankdatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.BankName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"ifCheque\"><md-input-container flex \nng-show=\"ifCheque\"><input type=\"text\" name=\"Cheque Number\" ng-model=\"vm.ChequeNo\" \nplaceholder=\"{{\'BANKANDCASH.CHEQUE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex \nng-show=\"ifCheque\"></md-input-container><md-input-container flex ng-show=\"ifCheque\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'BANKANDCASH.REMARKS\'|translate}}\"></md-input-container></div></form></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveDeposit()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">\n{{\'BANKANDCASH.SAVE\'|translate}}</md-button><md-button ng-click=\"closeDialog()\" \nclass=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">{{\'BANKANDCASH.CANCEL\'|translate}}</md-button>\n</md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/bankcash/managebank.html","<div id=\"assetregister\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"BANKANDCASH.MANGE BANK & CASH ACCOUNT\" class=\"title\">Mange Bank & Cash Account</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"Bank\" ng-model=\"vm.Bank\" placeholder=\"{{\'BANKANDCASH.BANK\'|translate}}\" required><div \nng-messages=\"eventForm.Bank.$error\" ng-show=\"eventForm.Bank.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BANKANDCASH.BANK FIELD IS REQUIRED\">Bank field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"AccountNumber\" ng-model=\"vm.AccountNumber\" \nplaceholder=\"{{\'BANKANDCASH.ACCOUNT NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.AccountNumber.$error\" \nng-show=\"eventForm.AccountNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BANKANDCASH.ACCOUNT NUMBER FIELD IS REQUIRED\">Account Number field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.Name\" \nplaceholder=\"{{\'BANKANDCASH.NAME\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"BANKANDCASH.OPENING DATE\">Opening Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.OpeningDate\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Current Balance\" ng-model=\"vm.CurrentBalance\" \nplaceholder=\"{{\'BANKANDCASH.CURRENT BALANCE\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveBank()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'BANKANDCASH.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'BANKANDCASH.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/bankcash/pettycash.html","<div id=\"pettycash\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"BANKANDCASH.PETTY_CASH_CLAIM\" class=\"title\">petty Cash Claim</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"BANKANDCASH.DATE\">Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"Purchased\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"Name\" \nplaceholder=\"{{\'BANKANDCASH.NAME\'|translate}}\" required><div ng-messages=\"basicForm.Name.$error\" \nng-show=\"basicForm.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BANKANDCASH.NAME FIELD IS REQUIRED\">Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"ReferenceNumber\" ng-model=\"ReferenceNumber\" \nplaceholder=\"{{\'BANKANDCASH.REFERENCE_NUMBER\'|translate}}\" required><div \nng-messages=\"basicForm.ReferenceNumber.$error\" ng-show=\"basicForm.ReferenceNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BANKANDCASH.REFERENCE_NUMBER_IS_REQUIRED\">Reference Number field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"Particulars\" ng-model=\"Particulars\" placeholder=\"{{\'BANKANDCASH.PARTICULARS\'|translate}}\" required>\n<div ng-messages=\"basicForm.Particulars.$error\" ng-show=\"basicForm.Particulars.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BANKANDCASH.PARTICULARS_FIELD_IS_REQUIRED\">Particulars field is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" name=\"Veh. No\" ng-model=\"VehNo\" \nplaceholder=\"Veh. No\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Receipts\" \nng-model=\"Receipts\" placeholder=\"{{\'BANKANDCASH.RECEIPTS\'|translate}}\"></md-input-container></div><md-input-container \nflex><input type=\"text\" name=\"Payments Excld GST\" ng-model=\"Payment\" \nplaceholder=\"{{\'BANKANDCASH.PAYMENTS EXCLD GST\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Gross\" ng-model=\"Gross\" placeholder=\"{{\'BANKANDCASH.GROSS\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Balance\" ng-model=\"Balance\" \nplaceholder=\"{{\'BANKANDCASH.BALANCE\'|translate}}\"></md-input-container></form></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">{{\'BANKANDCASH.SAVE\'|translate}}</md-button>\n<md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'BANKANDCASH.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/bankcash/transfer.html","<div id=\"assetregister\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"BANKANDCASH.SPEND / TRANSFER MONEY\" class=\"title\">Spend / Transfer Money</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"BANKANDCASH.CUSTOMER_NAME\">Customer Name</label><md-select ng-model=\"vm.CustomerID\" required>\n<md-select-header><input ng-model=\"searchTerm1\" type=\"text\" \nplaceholder=\"{{\'BANKANDCASH.SEARCH_FOR_A_CUSTOMER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:searchTerm1\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"BANKANDCASH.ACCOUNTING_CODE\">Accounting Code</label><md-select ng-model=\"vm.AccountID\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'BANKANDCASH.SEARCH_FOR_A_ACCOUNT..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row.id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"BANKANDCASH.DATE\">Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"ReferenceNumber\" ng-model=\"vm.ReferenceNumber\" \nplaceholder=\"{{\'BANKANDCASH.REFERENCE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Amount\" ng-model=\"vm.Amount\" placeholder=\"{{\'BANKANDCASH.AMOUNT\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Transaction Mode\" ng-model=\"vm.TransactionMode\" \nplaceholder=\"{{\'BANKANDCASH.TRANSACTION MODE\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveTransfer()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'BANKANDCASH.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'BANKANDCASH.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/contracts/AddSor.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">SOR Details</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"gridContainer\" \ndx-data-grid=\"dataGridOptions\"></div></md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog><style>\n.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/accounts/contracts/addcoments.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Customer Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Company Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Sales Person</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SalesPerson}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Market Segment</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.MarketSegment}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ContactPerson}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Followup Date</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.FollowupDate | date:\"dd/MM/yyyy\" }}</span></div>\n<div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Address</label></div>\n:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Email</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;{{vm.SiteCcontactName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Number</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteContactNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract End Date</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteEmail | date:\"dd/MM/yyyy\"}}</span></div>\n</div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Term</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt }}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"></label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"></label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;</span></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;border:1px solid rgb(224, 224, 224)\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments:</label></div>\n</div><div style=\"background-color:whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item \nclass=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ vm.ssRemark }}</p></div></md-list-item>\n</md-list></div></div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nBilling & Service Address</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate \nstyle=\"padding-bottom:0px\"><div><span class=\"h3\" style=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}\n</span></div><div style=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div>\n<div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div \nstyle=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div id=\"customerservicegrid\" dx-data-grid=\"vm.dataGridCustomerService\"></div></div>\n<br></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\">UPLOADED DOCUMENTS\n</span></md-tab-label><md-tab-body><form name=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div><span class=\"h3\" style=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table \nid=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference No #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Uploaded Document</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nUploaded Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in UploadedDocuments\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nstyle=\"cursor:pointer\">{{ row.FileID }}</a></td><td>{{ row.TableName==\'Lead\'?\"Quotation\":\"Contract\" }}</td><td><a \nhref=\"{{UploadsURL}}CRM/{{row.TableName}}/{{row.TableID}}\" download=\"{{row.FileName}}\" target=\"_blank\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}\n</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.WORK_ORDERS\">WORK ORDERS</span></md-tab-label><md-tab-body><form name=\"wizardStep4\" \nms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" style=\"color:#7f9593\"><b>\nCustomer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.WORK_ORDER\">Work Order #\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.ENQUIRY_TYPE\">\nEnquiry Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.ENQUIRY\">Enquiry #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.PEST_TYPES\">Pest Types</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_MODE\">Payment Mode</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_TERMS\">Payment Terms</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.SERVICE_START_DATE\">Service Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMSALESORDER.SERVICE_END_DATE\">Service End Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in SalesOrderdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Detailsinfo($event, row._id, \'WorkOrder\')\" style=\"cursor:pointer\">{{ row.SalesOrderNo }}</a></td><td>\n{{ row.OrderType }}</td><td>{{ row.EnquiryReferenceNo }}</td><td>{{ row.PestType }}</td><td>{{row.PaymentTerms}}</td>\n<td>{{row.PaymentMode }}</td><td>{{ row.ServiceStartDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.ServiceEndDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab \nng-click=\"GetSchedulerDetails(SID,vm.uFrom)\"><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.UPCOMING_SCHEDULES\">UPCOMING SCHEDULES</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\"><div dx-date-box=\"dateBox\"></div></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Service Location</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Schedule Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Technician\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Attachment</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Schedulerdetails | orderBy: \'+Startsat\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><a ng-click=\"SchedulerDetailsinfo($event, row._id,  \'Schedule\')\" style=\"cursor:pointer\">{{row.ServiceID }}</a>\n</td><td>{{row.Location}}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Status}}</td><td>\n{{row.teamdetails[0].TeamMembers}}</td><td ng-if=\"row.Status==\'Completed\'\"><a ng-click=\"getServiceReports(row._id)\" \nstyle=\"cursor:pointer\">Service Report</a></td><td ng-if=\"row.Status!=\'Completed\'\"></td></tr></tbody></table></form>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n  .chipsdemoContactChips md-content.autocomplete input {\r\n    min-width: 400px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected h3 {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text {\r\n    padding: 14px 0;\r\n    max-width: 190px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n    line-height: 1.2em !important;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n  .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon,\r\n  md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n  }\r\n\r\n  .star {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .filled {\r\n    color: #fd0;\r\n  }\r\n\r\n\r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/contracts/contracts.html","<div id=\"contract\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><span \nng-show=\"Contractsgrid || Contractsform || ShowContractform\" translate=\"CRMCONTRACTS.HEADER\">Contracts</span> <span \nng-show=\"!Contractsgrid && !Contractsform && !ShowContractform\">Work Order</span></div><div \nng-show=\"Contractsgrid || Contractsform || ShowContractform\" class=\"product-count secondary-text\"><span \ntranslate=\"CRMCONTRACTS.TOTAL_CONTRACTS\">Total Contracts:</span> <span>{{workOrd.length}}</span></div></div><br><div \nclass=\"search\" layout=\"row\" style=\"margin-top: 15px\" ng-show=\"Add\" layout-align=\"start center\" flex><md-input-container\n flex=\"40\" id=\"Datefilter\"><label style=\"color:white;font-size: 14px\" translate=\"CRMSALESORDER.FROM\">From</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-change=\"uTo = uFrom\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label style=\"color:white;font-size: 14px\" \ntranslate=\"CRMSALESORDER.TO\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\">\n</md-datepicker></md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ClearFilter()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"CRMCONTRACTS.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"ExportContract()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CRMCONTRACTS.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\" ng-show=\"Contractsgrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\">\n<md-tab ng-click=\"workOrd=Pendingcontractdatas ;\"><md-tab-label><span>Pending</span></md-tab-label><md-tab-body><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridPending\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=contractdatas;\"><md-tab-label><span>On-Going</span></md-tab-label><md-tab-body><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridContract\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=contractRenewaldatas;\"><md-tab-label><span>Renewal</span></md-tab-label><md-tab-body><div \nid=\"RenewalContainer\" dx-data-grid=\"vm.dataGridRenewal\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=Terminateddatas; getTerminated()\"><md-tab-label><span>Terminated</span></md-tab-label><md-tab-body>\n<div id=\"TerminateContainer\" dx-data-grid=\"vm.dataGridTerminated\"></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"content\" style=\"padding-top:30px\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"ShowContractform\" flex><span ng-if=\"Update\" style=\"font-size: 18px; font-weight: 500\">{{vm.ContractReference}}\n</span><form name=\"basicForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex ng-hide=\"Update\"><label>Customer Name</label><md-select ng-model=\"vm.Customer_id\" \nname=\"CustomerName\" md-on-close=\"vm.searchTermC = \'\'\" id=\"searchmodule\" disabled=\"disabled\"><md-select-header><input \nng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_CUSTOMER\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Customer_id = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatasfordropdown | filter:vm.searchTermC\" ng-click=\"ChangeCustomer(row)\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"CRMCONTRACTS.SALES_PERSON\">Sales Person</label><md-select ng-model=\"vm.SalesPerson\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" disabled=\"disabled\"><md-select-header><input ng-model=\"vm.searchTermS\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{ \'CRMCONTRACTS.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SalesPerson = null;vm.searchTermS=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.CMarketSegment\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" disabled=\"disabled\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CMarketSegment = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">{{row.SegmentName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.CSalutation\" readonly=\"readonly\" placeholder=\"Salutation\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.CName\" readonly=\"readonly\" placeholder=\"Name\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -15px\"><md-input-container flex>\n<label>Billing Address</label><md-select ng-model=\"vm.BAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" \nrequired><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Billing Address\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerBillingAddress | filter:vm.searchTermC\" \nvalue=\"{{row._id}}\" \nng-click=\"vm.CEmail=row.bEmail.split(\',\') ; vm.CName=row.bContactPerson ; vm.Ccontact=row.bMobile.split(\',\')\">\n{{row.bStreetName}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" disabled=\"disabled\"><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Biiling Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"Ccontact\" ng-model=\"vm.Ccontact\" placeholder=\"Contact No\" readonly=\"readonly\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 47px\"><md-input-container flex><input type=\"text\" \nname=\"Email\" ng-model=\"vm.CEmail\" placeholder=\"Email\" readonly=\"readonly\"></md-input-container></div><span \nstyle=\"color:#7f9593\"><h3>Site Details</h3></span><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"RenewalUpdate==false\">\n<md-input-container flex ng-if=\"Update==false\"><label>Service Address</label><md-select ng-model=\"vm.CAddress\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" multiple=\"\" disabled=\"disabled\"><md-select-header><input \nng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For Service Address\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.CAddress = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nng-value=\"row\">{{row.sName}} {{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container><md-button\n style=\"margin: 12px -8px\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\" ng-if=\"Update==false && !(!vm.Customer_id)\"><md-icon \nmd-font-icon=\"icon-tooltip-outline-plus\"></md-icon></md-button><md-input-container flex ng-if=\"Update==true\"><label>\nService Address</label><md-select ng-model=\"vm.UpCAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" \nng-disabled=\"Update==true\" required><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.UpCAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nvalue=\"{{row._id}}\">{{row.sStreetName}} {{row.sPostal}} {{row.sName}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"RenewalUpdate==true\"><md-input-container flex \nng-if=\"Update==false\"><label>Service Address</label><md-select ng-model=\"vm.CAddress\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermC = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nvalue=\"{{row._id}}\">{{row.sName}} {{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 27px\"><md-input-container flex><label>Service Hours\n</label><md-select ng-model=\"vm.ServiceHours\" id=\"searchmodule\" md-on-close=\"vm.searchTerm2 = \'\'\" disabled=\"disabled\">\n<md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Service Hours\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ServiceHours = null;vm.searchTerm2=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"During Office Hours\">\nOffice Hours 9am - 5pm</md-option><md-option value=\"After Office Hours\">After Office Hours 5:00pm - 12:00mn</md-option>\n<md-option value=\"Wee Hours\">Wee Hours 12:00mn - 9am</md-option></md-select></md-input-container><md-input-container \nflex style=\"margin-top: 18px;margin-left:10px\"><label>Service Start Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" disabled=\"disabled\" \nng-change=\"getServiceEndDate(vm.ServiceStartDate);getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\" \nstyle=\"margin-left: -10px\"></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Service End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" disabled=\"disabled\" style=\"margin-left: -10px\" \nng-change=\"getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\"></md-datepicker></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Payment Term</label><md-select \nng-model=\"vm.CreditTerm\" id=\"searchmodule\" md-on-close=\"vm.searchTermcc = \'\'\" disabled=\"disabled\"><md-select-header>\n<input ng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" placeholder=\"Payment Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentTermdatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><input type=\"number\" \nng-model=\"vm.TotalOrderValue\" placeholder=\"Total Contract Sum\" \nng-change=\"getMonthAmount(vm.TotalMonth,vm.TotalOrderValue)\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><input type=\"text\" ng-model=\"vm.PurchaseOrder\" \nplaceholder=\"Purchase Order\" disabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"RenewalUpdate==true\"><input type=\"text\" ng-model=\"vm.RenewalRemarks\" placeholder=\"Renewal Remarks\" \ndisabled=\"disabled\"></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin: 0;padding-left:1%\"><md-checkbox ng-model=\"vm.IncludeSOR\" \nng-change=\"SORDerails(vm.IncludeSOR,$event,true)\" type=\"checkbox\"><span>Include SOR? </span>&emsp;</md-checkbox><span \nid=\"viewsor\" ng-show=\"vm.IncludeSOR\" ng-click=\"SORDerails(true,$event,false)\">View/Edit SOR Details </span>&emsp;\n</md-input-container><md-input-container flex style=\"margin: 0;padding-left:1%\" ng-show=\"Update == false\">\n</md-input-container></div><div style=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\"><b>\nPEST CONTROL SERVICES :</b></span></div><table class=\"table dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions1\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment Method</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}</td><td>\n{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td></tr></tbody>\n</table><div style=\"padding-bottom:2%\" ng-if=\"Update == true\"><span class=\"h3\" style=\"color:#7f9593\"><b>\nATTACH SIGNED CONTRACT :</b></span></div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"Update == true\" \nstyle=\"border:1px solid rgb(224, 224, 224)\"><table id=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ContarctAttachmentdatas\"><td></td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y\' }}</td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel\n</md-button></div></form></div></div></div><div class=\"content\" ng-show=\"Contractsform\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" novalidate style=\"padding-bottom:0px\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%;border:1px solid rgb(224, 224, 224);float:left\"><div layout=\"row\"><div layout=\"column\" \nstyle=\"width:45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">Contract Details :\n</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract Reference #</b></span></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:13px;padding-left:2%\"><b>{{vm.ContractReferenceNo}}</b></span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Cutsomer Name</b></label></div><label\n style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uCompanyName1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Sales Person</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SalesPerson1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Payment Term</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.CreditTerm}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Template</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.TempTemplate}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service Start Date</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service End Date</b></label></div>\n<label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceEndDate| date:\'dd/MM/y\'}}</span></div></div></div><div \nlayout=\"column\" style=\"width:45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">\nContact Information :</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contact Person</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:\n</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{vm.uContactPerson}}\n</b></span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Phone</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b>\n</label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.Ccontact}}</span></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Email</b>\n</label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uEmail}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Billing Address</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service Address</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uSAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:70%\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"CreateWorkOrder($event)\" aria-label=\"Submit\">Create Work Order</md-button></div><label \nstyle=\"font-size:15px;color:#7f9593\"></label><div class=\"p-4\" style=\"width:60%\"></div></div></div><div layout=\"column\" \nstyle=\"width:15%;margin-top:10px;float: right\"><a ng-click=\"Contractclose($event, vm.ContractId)\" \nstyle=\"cursor:pointer;font-size: 14px;color:orangered\" ng-hide=\"vm.ContractStatus == \'Closed\'\">Cancel Contract</a>\n</div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" \nstyle=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span \nclass=\"h3\" style=\"color:#7f9593\"><b>ATTACH SIGNED CONTRACT :</b></span></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input2\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input2\" flow-btn id=\"file-input2\"><md-button class=\"md-raised md-accent\" \nng-click=\"UploadContractfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span>\n</md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nclass=\"dataTable row-border hover\" style=\"border: 1px solid #d0d3d3\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ContarctAttachmentdatas\">\n<td></td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" \nstyle=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span \nclass=\"h3\" style=\"color:#7f9593\"><b>PEST CONTROL SERVICES :</b></span></div><table class=\"dataTable row-border hover\" \nstyle=\"border: 1px solid #d0d3d3\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nTreatment Method</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas | orderBy:\'-Freq\'\"><td \nstyle=\"font-size:14px\">{{$index+1}}</td><td style=\"font-size:14px\">{{ row.Frequency }}</td><td style=\"font-size:14px\">\n{{ row.PestType }}</td><td style=\"font-size:14px\">{{ row.Treatment }}</td></tr></tbody></table></div></div></form>\n</div><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Salesform\" flex><form name=\"SbasicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-radio-container flex style=\"height:70px\">\n<span style=\"color:#7f9593;padding-top: 5px;float: left\">Type : <span>Work Order</span></span></md-radio-container>\n<md-radio-container flex style=\"height:70px\"><md-radio-group ng-model=\"vm.IsUrgent\" layout=\"row\" \nstyle=\"padding-left:20px;margin: 0 !important\" required><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right:10px\">VIP ? :</span><md-radio-button value=\"true\">Yes\n</md-radio-button><md-radio-button value=\"false\">No</md-radio-button></md-radio-group><md-radio-group \nng-model=\"vm.TrendingReport\" layout=\"row\" style=\"margin: 20px 0 0 0px;margin-left: -35px\"><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 10px\">Trending Reports? :</span><md-radio-button \nvalue=\"true\">Yes</md-radio-button><md-radio-button value=\"false\">No</md-radio-button></md-radio-group>\n</md-radio-container></div><br><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Salesperson\n</label><md-select ng-model=\"vm.SalesPerson\" name=\"SalesPerson\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" \nrequired><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.uCompanyName\" \nreadonly=\"readonly\" placeholder=\"Customer Name\"></md-input-container><md-input-container flex><label>Contract #</label>\n<input type=\"text\" ng-model=\"vm.ContractReferenceNo\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Contact Person</label><input type=\"text\" \nng-model=\"vm.BContactPerson\" readonly=\"readonly\"></md-input-container><md-input-container flex><label>Billing Address\n</label><input type=\"text\" ng-model=\"vm.BAddress1\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -17px\"><md-chips flex style=\"height: 13% !important\" ng-model=\"vm.BContactNo\" \nname=\"BContactNo\" md-separator-keys=\"vm.keys1\" md-max-chips=\"4\" input-aria-label=\"Ccontact\"><input type=\"number\" \nname=\"BContactNo\" placeholder=\"Contact No (max 3)\"></md-chips></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 47px\"><md-chips ng-model=\"vm.BEmail\" placeholder=\"Email\" \nstyle=\"width: 100%; margin-top: -2%;margin-bottom: 30px\"></md-chips></div><div class=\"h4\" \nstyle=\"color:#7f9593; margin-top: -15px\">Type Email and Press Enter</div><span style=\"color:#7f9593\"><h3>Site Details\n</h3></span><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 27px\"><md-input-container flex><label>\nService Address</label><md-select ng-model=\"vm.SLocation\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required \nng-disabled=\"DisableServiceLocation\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Location\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SLocation = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nvalue=\"{{row._id}}\" ng-init=\"vm.ServiceEmail=row.sEmail; vm.ServiceEmailCC=row.sCC\">{{row.sStreetName}}</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;flex: 0.5\"><label>Billing Frequency\n</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" md-on-close=\"vm.searchTerm1 = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Credit Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 27px\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Payment Term</label><md-select ng-model=\"vm.PaymentMode\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermPm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'CRMSALESORDER.PAYMENT_MODE\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PaymentMode = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentTermdatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" placeholder=\"Total Price\" ng-model=\"vm.TotalPrice\" \nrequired></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"Special Chemical/Equipments\" \nng-model=\"vm.SpecialChemical\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nid=\"date4\" flex style=\"margin-top: 18px\"><label>Service Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceStartDate\" ng-change=\"getServiceEndDate(vm.ServiceStartDate)\" required md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label>\nService End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" required \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container \nflex style=\"margin-top: 18px\"><input type=\"number\" placeholder=\"Estimated Man Hours Needed\" \nng-model=\"vm.EstimatedHoursRequired\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Coverage Area</label><input type=\"text\" \nng-model=\"vm.CoverageArea\"></md-input-container><md-input-container flex></md-input-container><md-input-container \nid=\"date4\" flex style=\"margin-top: 18px\"></md-input-container></div><label \nstyle=\"width:21%;font-weight:bold;color:#7f9593\">Message to Operation</label><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Message\"></text-angular><br><div><span class=\"h3\" style=\"color:#7f9593\"><b>TREATMENT FREQUENCY :</b>\n</span><md-button id=\"viewedit\" class=\"md-raised md-button md-ink-ripple md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddWOPestType($event)\" style=\"float:right\">Add Frequency</md-button></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin-top:10px\"><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Methods</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">No of Job/Frequency</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Total Services Required</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in WOFrequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}\n</td><td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td>\n{{ row.JobsPerFrequency }}</td><td>{{ row.ServicesRequired }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Editpest($event, row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"WOFrequencydatas.length == 1\" ng-click=\"Deletepest(row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:49%;border:1px solid rgb(224, 224, 224);float:left;height:30%\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments\n</label></div></div><md-input-container flex style=\"width: 95.9%;margin-left:15px;margin-right:15px\"><input \ntype=\"text\" placeholder=\"Comments\" ng-model=\"vm.SpecialRemarks\" ng-enter=\"AddComment()\"></md-input-container><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{$index+1}}.{{ item.CommentedBy }}\n</h3><md-button style=\"position: absolute;left: 60%;margin: 0\" id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeleteComment(item)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><h4>{{ item.CreatedDate | date:\'d/MM/y HH:mm:ss\'}}</h4><p>{{ item.cmt }}</p></div></md-list-item>\n</md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49%;border:1px solid rgb(224, 224, 224);float:right;margin-left:20px\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\" \ntranslate=\"CRMLEAD.ATTACHMENTS\">Attachments :</label></div></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input1\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input1\" flow-btn id=\"file-input1\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload Attachments\n</span></md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>&nbsp;</td>\n<td><a href=\"{{UploadsURL}}CRM/SalesOrder/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"WOSubmit()\" aria-label=\"Submit\" \nng-disabled=\"SbasicForm.$invalid || WOFrequencydatas.length == 0\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\" translate=\"CRMSALESORDER.CANCEL\">Cancel</md-button></div></form></div></div>\n<div class=\"content\" id=\"invoice\" ng-show=\"Previewdiv\"><div style=\"height:100px\"><div style=\"width:auto\"></div><div \nstyle=\"font-size:25px;font-weight:500;float:right\"><img src=\"assets/images/logos/pest_logo.png\" \nstyle=\"width:200px;height:100px\"></div></div><h3 style=\"font-weight: 600;text-align:center\"><b>\nPEST MANAGEMENT SERVICE CONTRACT</b></h3><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.Message\" ng-disabled class=\"pb-32\"></text-angular></div><br><h3 style=\"font-weight: 500\"><b>SCOPE OF WORK\n</b></h3><ul style=\"width: 100%\" ng-repeat=\"items in Frequencygroups\"><h4 style=\"font-weight: 500\"><b>\n{{items[0].Frequency}}</b></h4><li style=\"list-style-type: none;padding-left:3%\" ng-repeat=\"row in items\"><h5 \nstyle=\"font-weight: 500\"><u>{{row.PestType}}</u></h5><ul ng-repeat=\"rows in SOWdatas\" \nng-if=\"rows.PestType == row.PestType\" style=\"padding-left: 3%\"><li>{{rows.Scopeofwork}}</li></ul></li></ul></div>\n<style>\n@media only screen and (max-width: 2200px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(27vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(4.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1600px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(24.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(3.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1150px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(18vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(2.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(30vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .label {\r\n        margin-top: -5px !important;\r\n        margin-bottom: -5px !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n        min-height: 250px;\r\n    }\r\n\r\n    .chipsdemoContactChips md-content.autocomplete input {\r\n        min-width: 400px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-item-text.compact {\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text {\r\n        padding: 14px 0;\r\n        max-width: 190px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n        margin: 0 !important;\r\n        padding: 0;\r\n        line-height: 1.2em !important;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n    .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n        .chipsdemoContactChips .contact-item {\r\n            float: left;\r\n            width: 33%;\r\n        }\r\n    }\r\n\r\n    .chipsdemoContactChips md-contact-chips {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-chips {\r\n        padding: 5px 0 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .fixedRows {\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-input1 {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-input2 {\r\n        display: none !important;\r\n    }\r\n\r\n    #attachmenthref label:hover {\r\n        border-bottom: 1px solid #23527c;\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    /* #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n    } */\r\n\r\n    #workflow .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    .dx-switch-handle:before {\r\n        background-color: #039be5de !important;\r\n    }\r\n\r\n    #viewsor:hover {\r\n        color: rgb(3, 155, 229) !important;\r\n        font-style: italic;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n\r\n    }\r\n\r\n    #viewsor {\r\n        color: rgb(181, 219, 238) !important;\r\n        font-style: italic;\r\n        font-size: 14px\r\n    }\r\n        .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/customer/customer.html","<div id=\"customer\" class=\"page-layout carded fullwidth single-scroll\" ng-cloak><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple-outline\"></md-icon><span translate=\"CRMCUSTOMER.HEADER\">Customers</span>\n</div><div class=\"product-count secondary-text\"><span translate=\"CRMCUSTOMER.HEADER\">Total Customers:</span> <span>\n{{Customerdatas.length}}</span></div></div></div><div class=\"content-card\" ng-show=\"Customergrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 40px;padding-top: 1%\"><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"AD()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">A - D</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"EH()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">E - H</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"IL()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">I - L</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"MP()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">M - P</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"QT()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Q - T</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"UX()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">U -X</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"YZ()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Y -Z</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"AllInfo()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">{{\'CRMCUSTOMER.ALL\'|translate}}</a>\n</div></div><div style=\"padding:10px 0% 0 1%;float: initial;width: 60%\" ng-show=\"Cdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Customer Selected: {{v.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforAssignedUser($event)\">\n<span>Assign Users</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"UnAssignedUser()\"><span>Make UnAssign</span></md-button></div><div style=\"padding: 10px 10px 10px 10px\" \nid=\"gridContainer\" dx-data-grid=\"vm.dataGridOptions\"></div></div></div><div class=\"content\"><div layout=\"row\">\n<ms-form-wizard flex ng-show=\"Customerform\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\">Customer Details</span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form \nstyle=\"padding-bottom:0px\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" \nname=\"CompanyName\" ng-model=\"vm.uCompanyName\" placeholder=\"Company Name\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><label>Salesperson</label><md-select ng-model=\"vm.SalesPerson\" name=\"SalesPerson\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" disabled=\"disabled\"><md-select-header><input \nng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" placeholder=\"\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.MarketSection\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" \nng-model-options=\"{trackBy: \'$value.SegmentName\'}\" multiple=\"\" disabled=\"disabled\"><md-select-header><input \nng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.MarketSection = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">\n{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><label>Salutation</label><md-select ng-model=\"vm.uSalutation\" disabled=\"disabled\"><md-option \nvalue=\"\">None</md-option><md-option value=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option \nvalue=\"Mdm\">Mdm</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Dr\">Dr</md-option></md-select>\n</md-input-container><md-input-container flex><label>Name</label><input type=\"text\" name=\"FirstName\" \nng-model=\"vm.uFirstName\" readonly=\"readonly\"><div ng-messages=\"wizardStep1.FirstName.$error\" \nng-show=\"wizardStep1.FirstName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name is required.</span></div>\n</div></md-input-container><md-input-container id=\"date4\" flex><label style=\"margin-left: -10px\">Follow-up Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.ProspectFollowDate\" md-date-format=\"dd/MM/y\" disabled=\"disabled\">\n</md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex \nstyle=\"flex: 2\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \non-place-changed=\"placeChanged()\" ng-model=\"vm.StreetName\" placeholder=\"\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"BuildingName\" ng-model=\"vm.BuildingName\" placeholder=\"Building Name\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" ng-model=\"vm.uPostal\" \nplaceholder=\"Postal Code\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><input type=\"text\" name=\"Email\" ng-model=\"vm.uEmail\" placeholder=\"Email\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" \nname=\"ContactNum\" ng-model=\"vm.uMobile\" placeholder=\"Contact Number\" readonly=\"readonly\"></md-input-container>\n<md-input-container id=\"date4\" flex><label style=\"margin-left: -10px\">Current Contract End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ConEndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Payment Term</label><md-select \nng-model=\"vm.PaymentTerm\"><md-option value=\"Advance\">Advance</md-option><md-option value=\"COD\">COD</md-option>\n<md-option value=\"Credit\">Credit</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.PaymentTerm==\'Credit\'\"><label>Credit Term</label><md-select ng-model=\"vm.CreditTerm\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermcc = \'\'\"><md-select-header><input ng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Credit Term\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CreditTermdatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Source of Enquiry</label><md-select ng-model=\"vm.EnquiryMode\" \nid=\"searchmodule\" md-on-close=\"vm.searcem = \'\'\"><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searcem\" \ntype=\"text\" placeholder=\"Enquiry source..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.EnquiryMode = null;vm.searcem = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EnquiryModedatas | filter:vm.searcem\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select><div \nng-messages=\"eventForm.EnquiryMode.$error\" ng-show=\"eventForm.EnquiryMode.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Source of Enquiry field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex style=\"margin-top:1%;width:100%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);margin-right:1%\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments:</label></div>\n</div><div style=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item \nng-repeat=\"item in CustomerCommentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y h:mm a\'}}</h3><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><p>{{ item.cmt }}</p></div></md-list-item></md-list></div></div></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\">\n</span> <span class=\"ms-form-wizard-step-text\">Billing & Service Address</span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><div \nstyle=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div><div \nlayout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID, \'Billing\')\"><span>Add</span></md-button>\n</div></div><div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div\n style=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div layout=\"row\" \nstyle=\"padding-bottom:0.5%\"><div flex><div ng-show=\"SAdiv\" flex style=\"padding-left: 40%\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">\nTotal Service Address Selected: {{SelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforUpdateEmail($event)\"><span>\nUPDATE EMAILID</span></md-button></div></div><div><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><span>Add</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" \ndx-data-grid=\"vm.dataGridCustomerService\"></div></div><br></form></md-tab-body></md-tab><md-tab ng-if=\"Update\">\n<md-tab-label><span class=\"ms-form-wizard-step-text\">UPLOADED DOCUMENTS</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" \nclass=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference No #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Uploaded Document</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nUploaded Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in UploadedDocuments\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nstyle=\"cursor:pointer\">{{ row.FileID }}</a></td><td>{{ row.TableName==\'Lead\'?\"Quotation\":\"Contract\" }}</td><td><a \nhref=\"{{UploadsURL}}CRM/{{row.TableName}}/{{row.TableID}}\" download=\"{{row.FileName}}\" target=\"_blank\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}\n</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab ng-if=\"Update\"><md-tab-label><span \nclass=\"ms-form-wizard-step-text\" translate=\"CRMCUSTOMER.WORK_ORDERS\">WORK ORDERS</span></md-tab-label><md-tab-body>\n<form name=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" \nclass=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.WORK_ORDER\">Work Order #\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.ENQUIRY_TYPE\">\nEnquiry Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.ENQUIRY\">Enquiry #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.PEST_TYPES\">Pest Types</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_MODE\">Payment Mode</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_TERMS\">Payment Terms</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.SERVICE_START_DATE\">Service Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMSALESORDER.SERVICE_END_DATE\">Service End Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in SalesOrderdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Detailsinfo($event, row._id, \'WorkOrder\')\" style=\"cursor:pointer\">{{ row.SalesOrderNo }}</a></td><td>\n{{ row.OrderType }}</td><td>{{ row.EnquiryReferenceNo }}</td><td>{{ row.PestType }}</td><td>{{row.PaymentTerms}}</td>\n<td>{{row.PaymentMode }}</td><td>{{ row.ServiceStartDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.ServiceEndDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab \nng-if=\"Update\" ng-click=\"GetSchedulerDetails(SID,vm.uFrom)\"><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.UPCOMING_SCHEDULES\">UPCOMING SCHEDULES</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\"><div dx-date-box=\"dateBox\"></div></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Service Location</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Schedule Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Technician\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Attachment</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Schedulerdetails | orderBy: \'+Startsat\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><a ng-click=\"SchedulerDetailsinfo($event, row._id,  \'Schedule\')\" style=\"cursor:pointer\">{{row.ServiceID }}</a>\n</td><td>{{row.Location}}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Status}}</td><td>\n{{row.teamdetails[0].TeamMembers}}</td><td ng-if=\"row.Status==\'Completed\'\"><a ng-click=\"getServiceReports(row._id)\" \nstyle=\"cursor:pointer\">Service Report</a></td><td ng-if=\"row.Status!=\'Completed\'\"></td></tr></tbody></table></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"end right\" \nstyle=\"padding:0px\"><md-button class=\"md-raised\" ng-click=\"msWizard.previousStep()\">Previous</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" style=\"padding: 0\"><md-button class=\"md-raised md-raised\" ng-click=\"Showgrid()\">Cancel\n</md-button></div></ms-form-wizard></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\n    width: calc(12vw - 35px);\n    max-width: calc(35vw - 54px);\n  }\n\n  .dataTables_wrapper .dataTables_filter {\n    float: right !important;\n  }\n\n  div.dataTables_filter input {\n    width: 30em !important;\n  }\n\n  #viewedit.md-button {\n    margin: -16px 8px;\n  }\n\n  .md-datepicker-button {\n    display: none;\n  }\n\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\n    left: 10px;\n  }\n\n  .md-default-theme.md-hue-1 .md-datepicker-input,\n  .md-hue-1 .md-datepicker-input {\n    background: none !important;\n  }\n\n  .md-tab.md-active {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\n    border-bottom: none !important;\n  }\n\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\n    border-bottom: none !important;\n  }\n\n  .file-input {\n    display: none !important;\n  }\n\n  .dx-checkbox-icon {\n    border: 1px solid #606b73 !important;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\n    background-color: #83878a !important;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\n    border-bottom-color: #606a71;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\n    border-left-color: #606a71 !important;\n    border-right-color: #606a71 !important;\n  }\n\n  .dx-button {\n    border-width: 0 !important;\n  }\n\n  .dx-button-has-icon .dx-button-content {\n    padding: 0 !important;\n  }\n\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\n    color: #535858 !important;\n    font-weight: bold !important;\n  }\n\n  md-datepicker .md-datepicker-input {\n    width: calc(1.3vw - 20px) !important;\n    max-width: calc(35vw - 54px);\n    margin-left: -11px;\n  }\n\n  #Datefilter md-datepicker .md-datepicker-input {\n    color: white !important;\n    border-bottom-color: white !important;\n    width: calc(2.3vw - 20px) !important;\n    max-width: calc(25vw - 54px);\n  }\n\n  #date4 md-datepicker .md-datepicker-input {\n    width: calc(26vw - 30px) !important;\n    max-width: calc(35vw - 54px);\n    margin-left: -11px;\n  }\n\n  /* .dx-datagrid-content .dx-datagrid-table .dx-row > td, .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td{\n    vertical-align: baseline;\n  } */\n\n  .md-violet-500-bg {\n    background-color: #7030a0 !important;\n    color: white;\n  }\n\n  .md-yellow-500-bg {\n    background-color: #ffc000 !important;\n    color: white;\n  }\n\n  .md-blue-500-bg {\n    background-color: #0070c0 !important;\n    color: white;\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/dashboard/operations.html","<div id=\"styleacc\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'OPERATIONS.WELCOME BACK\'|translate}}, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" \nng-change=\"Range()\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">\n{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{totaljobs}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL JOBS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL COMPLETED\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{completedjobs}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.DUE\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{totalpayables}}</div>\n<div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL PAYABLES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL PAID\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{totalpaid}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button\n class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.UNDUE\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{totalreceivables}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL RECEIVABLES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL RECEIVED\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{totalreceived}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.FEATURES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{totalassets}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL ASSETS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL DISPOSED\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{totaldiposed}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">\n{{\'OPERATIONS.PAYABLES DETAILS\'|translate}}</div><table class=\"dataTable simple\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.PURCHASE_ORDER\" class=\"column-title\">Purchase Order</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"OPERATIONS.INVOICE_NUMBER\" class=\"column-title\">Invoice No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.INVOICE_DATE\" class=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.AMOUNT\" class=\"column-title\">Amount</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Purchaseinvoicedatas\"><td nowrap=\"nowrap\">{{ row.Purchaseorderdetails[0].POID }}</td><td \nnowrap=\"nowrap\">{{ row.InvoiceNumber }}</td><td>{{ row.Description }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>\n$ {{ row.Amount || 0 |number:2}}</td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">\n{{\'OPERATIONS.RECEIVABLES DETAILS\'|translate}}</div><table class=\"dataTable simple\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.INVOICE_NUMBER\" class=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.WORKORDER\" class=\"column-title\">WorkOrder</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.INVOICE_DATE\" \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.AMOUNT\" class=\"column-title\">Amount</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Salesinvoicedatas\"><td>{{ row.InvoiceNumber }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CompanyName }}</td><td\n nowrap=\"nowrap\">{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td>$ {{ row.Amount || 0 |number:2}}</td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></div></div><md-sidenav ng-hide=\"true\" class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>\n{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">\n{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\">\n<ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon>\n<span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/accounts/flexischeduler/NewAdd.html","<md-dialog style=\"width:85%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.DServiceID}} - {{vm.DCustomerName}} - {{vm.DServiceAddres}}</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span>Details</span></md-tab-label><md-tab-body><br><label \nng-if=\"vm.Duplicate\" \nstyle=\"font-size:15px;font-weight: bold;margin-left: 90%;position: absolute; margin-top: -20px;color: #d01313\">\nDuplicate</label><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;height:auto;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:99.5%; border:1px solid rgb(224, 224, 224);float:left\"><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Work Order :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Client Contact :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DClientContactName}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Site Contact Name :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSiteContactName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width: 16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Site Contact Number :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSiteContactNumber}}</span></div><div class=\"p-4\" style=\"width:4%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Email :</label></div><div class=\"p-4\" style=\"width:28%\"><span \nstyle=\"font-size:14px\">{{vm.DClientEmail}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Sales Person :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.SalesPerson}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Coverage Area :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DCoverageArea}}</span></div><div class=\"p-4\" style=\"width:16%\" \nng-if=\"vm.OrderType==\'Contract\'\"><label style=\"font-size:15px;font-weight: bold\">Contract Duration :</label></div><div \nclass=\"p-4\" style=\"width:16%\" ng-if=\"vm.OrderType==\'Contract\'\"><span style=\"font-size:14px\">\n{{vm.ContractStart| date:\"dd/MM/y\"}}-{{vm.ContractEnd| date:\"dd/MM/y\"}}</span></div><div class=\"p-4\" style=\"width:16%\" \nng-if=\"vm.OrderType!=\'Contract\'\"><label style=\"font-size:15px;font-weight: bold\">Ad-hoc Occurence :</label></div><div \nclass=\"p-4\" style=\"width:16%\" ng-if=\"vm.OrderType!=\'Contract\'\"><span style=\"font-size:14px\">{{vm.Occurence}}</span>\n</div><div class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Market Segment :</label></div>\n<div class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.MarketSegment}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label\n style=\"font-size:15px;font-weight: bold\">Team :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DTeamName}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Team Members :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.TeamMembers}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Job Type :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DTypes}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Prefered Days :\n</label></div><div class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PreferedTime}}</span></div><div \nclass=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Preference Time :</label></div><div \nclass=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PreferenceTime}}</span></div><div class=\"p-4\" \nstyle=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Avoid Time :</label></div><div class=\"p-4\" \nstyle=\"width:16%\"><span style=\"font-size:14px\">{{vm.AvoidTime}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Man Hour :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.ManHour}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Last Completed Date :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.LastCompletedDate | date:\'dd/MM/y hh:mm a\'}} - {{vm.LastCompletedBy}}</span></div><div \nng-if=\"vm.DuplicateRemarks\" class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">\nDuplicate Remarks :</label></div><div ng-if=\"vm.DuplicateRemarks\" class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DuplicateRemarks}}</span></div><div ng-if=\"!vm.DuplicateRemarks\" class=\"p-4\" \nstyle=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Payment Terms :</label></div><div \nng-if=\"!vm.DuplicateRemarks\" class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PaymentTerms}}</span>\n</div></div><div ng-if=\"vm.DuplicateRemarks\" layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Payment Terms :\n</label></div><div class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PaymentTerms}}</span></div><div \nclass=\"p-4\" style=\"width:16%\"></div><div class=\"p-4\" style=\"width:16%\"></div><div class=\"p-4\" style=\"width:16%\"></div>\n<div class=\"p-4\" style=\"width:16%\"></div></div></div></div></div><div class=\"navigation\"><br><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><div class=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" \nclass=\"dx-field-label\">Date :</div><div class=\"dx-field-value\"><div style=\"width: 30%\" \ndx-date-box=\"dateBox.ResheduleFrom\" displayformat=\"dd-MM-yyyy\"></div></div></div><div style=\"margin-left: 10px\" \nclass=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div \nclass=\"dx-field-value\"><div dx-date-box=\"dateBox.ResheduleStartTime\"></div></div></div><div style=\"margin-left: 10px\" \nclass=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">End Time :</div><div \nclass=\"dx-field-value\"><div dx-date-box=\"dateBox.ResheduleEndTime\"></div></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" name=\"SpecialRemark\" \nng-model=\"vm.SpecialRemark\" placeholder=\"Remarks to this service\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"notes\" ng-model=\"vm.Notes\" placeholder=\"Neighbouring Job\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><label style=\"width:21%;font-weight:bold;color:#7f9593\">Message to Operation</label>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Remarks\"></text-angular></div><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"UpdateNewSchedule()\" style=\"float:right\" \nclass=\"md-raised md-accent\">Update</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button></div>\n<div id=\"dataGridFreq\" dx-data-grid=\"vm.dataGridFreqGrid\"></div></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<span>Comments</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Addcomments\" placeholder=\"Comment Here..\"></md-input-container></div><div \nstyle=\"float: right;padding: 2%;\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"!vm.Addcomments\"><span>Save</span></md-button></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.CommentedBy }} @ {{ item.CreatedDate | date:\'dd/MM/y hh:mm a\'}}</h3><md-button \nstyle=\"position: absolute;left: 60%;margin: 0\" id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"DeleteComment(item._id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding><div flow-init=\"{singleFile: true}\" flow-name=\"uploader.flow\"><div \nid=\"attachmenthref\"><label for=\"file-input\" style=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\" style=\"float:right\"><span>Upload</span></md-button><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"font-size:smaller\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>\n&nbsp;</td><td><a \nhref=\"{{UploadsURL}}{{row.TableName==\'Operations\'?\'Operations/Scheduler\':\'CRM/SalesOrder\'}}/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeleteAttachment(row._id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\n.dx-field-item-required-mark {\r\n        color: #f74d61 !important;\r\n        margin: 0;\r\n        margin-left: 90%;\r\n        margin-top: -25px;\r\n    }\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-left: -8px;\r\n    }\r\n\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 97%;\r\n    }\r\n    .file-input {\r\n    display: none !important;\r\n  }\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n    .ms-scroll {\r\n        position: relative;\r\n    }\r\n\r\n    #viewsor:hover {\r\n        color: rgb(3, 155, 229) !important;\r\n        font-style: italic;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n\r\n    }\r\n\r\n    #viewsor {\r\n        color: rgb(148, 194, 218) !important;\r\n        font-style: italic;\r\n        font-size: 14px\r\n    }\r\n\r\n    #date1 .md-datepicker-input {\r\n        max-width: 100% !important;\r\n        min-width: 50% !important;\r\n        margin-left: -10px;\r\n    }\r\n\r\n    #date1 md-datepicker .md-datepicker-input {\r\n        width: calc(13vw - 20px);\r\n        max-width: calc(15vw - 20px);\r\n    }\r\n\r\n    label {\r\n        padding-left: 10px !important;\r\n        font-size: 15px !important;\r\n    }\r\n    .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n        min-width: 1200px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/flexischeduler/addcoments.html","<md-dialog style=\"width:70%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Service Job</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Duration</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.StartDate | date:\'hh:mm a\'}}-{{vm.EndDate | date:\'hh:mm a\'}}\n</span></div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Address\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Description}}</span></div>\n</div></div></div><br><div layout=\"column\"><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div \nclass=\"p-4\" style=\"width:10%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div>\n<div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"column\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" \nng-repeat=\"row in Photosdatas\" ng-switch on=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" \nng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n</div></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n    .chipsdemoContactChips md-content.autocomplete input {\r\n      min-width: 400px;\r\n    }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n    .chipsdemoContactChips .contact-item.selected {\r\n      opacity: 0.5;\r\n    }\r\n\r\n      .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text {\r\n      padding: 14px 0;\r\n      max-width: 190px;\r\n    }\r\n\r\n      .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n        margin: 0 !important;\r\n        padding: 0;\r\n        line-height: 1.2em !important;\r\n      }\r\n\r\n      .chipsdemoContactChips .contact-item .md-list-item-text h3, .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n      }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n  }\r\n\r\n    #tb2 td:first-child:before {\r\n      counter-increment: serial-number; /* Increment the serial number counter */\r\n      content: counter(serial-number); /* Display the counter */\r\n    }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon, md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n   }\r\n    .star\r\n\r\n  {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n  .filled\r\n\r\n  {\r\n    color: #fd0;\r\n  }\r\n\r\n  \r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/flexischeduler/flexischeduler.html","<div id=\"shedular\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span>Daily Scheduler</span></div><div\n class=\"product-count secondary-text\"><span>Total Schedules:</span> <span>{{calenderdata.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex ng-show=\"WeekViewGrid\"><md-input-container flex \nid=\"Datefilter\" style=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" \nid=\"searchmodule\" style=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex ng-show=\"!WeekViewGrid\"><md-input-container flex id=\"Datefilter\" \nstyle=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" id=\"searchmodule\" \nstyle=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div><md-button class=\"md-raised md-background\" \nng-click=\"Refresh()\"><span>Refresh</span></md-button></div></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"border:1px solid rgb(224, 224, 224);padding:1.5% 1% 1.5% 1%\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><span class=\"dot\" style=\"background: #1e93c2\"></span> <span \nstyle=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Fixed)</b></span> <span class=\"dot\" style=\"background: #29824d\"></span> \n<span style=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Flexible)</b> </span><span class=\"dot\" style=\"background: red\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Ad-Hoc</b> </span><span class=\"dot\" style=\"background: #1527a9\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Service</b></span><div \nstyle=\"width:28%;margin: auto;display:inline-block\"></div><span style=\"font-size:14.5px\"><b>Date :</b> </span><span \nstyle=\"font-size:14.5px\">{{vm.Date | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><span class=\"calendarspan\">{{vm.Holiday}}<span><div id=\"scheduler\" \ndx-scheduler=\"schedulerOptions\"></div><div id=\"appointmentContextMenu\"></div><br><md-input-container \nng-show=\"WeekViewGrid\" flex=\"31\" style=\"margin-top: 39px\"><label style=\"color:black;font-size: 14px\">From</label><br>\n<md-datepicker onkeydown=\"return false\" ng-model=\"StDate\" ng-change=\"getForSelectedDays(1)\"></md-datepicker>\n</md-input-container><md-button class=\"md-raised md-button md-ink-ripple md-default-theme\" \nng-click=\"getForSelectedDays(3)\" ng-show=\"WeekViewGrid\"><span>3 Days</span></md-button><md-button \nclass=\"md-raised md-button md-ink-ripple md-default-theme\" ng-click=\"getForSelectedDays(5)\" ng-show=\"WeekViewGrid\">\n<span>5 Days</span></md-button><div id=\"NewDataGrid\" ng-show=\"WeekViewGrid\" style=\"margin-top: -39px\" \ndx-data-grid=\"vm.dataGridSalesOrderNew\"></div></span></span></div></div></div></div><div id=\"popup\" \nstyle=\"height: 99%; overflow-y: scroll\"></div><style>\n.blackcolor {\r\n        color: black;\r\n    }\r\n\r\n    .whiteColor {\r\n        color: white;\r\n    }\r\n\r\n    .dot {\r\n        height: 20px;\r\n        width: 20px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    .dot1 {\r\n        height: 10px;\r\n        width: 10px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        padding-top: 1.5%;\r\n        border-bottom: 1px solid #c2c8cc;\r\n    } */\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-value,\r\n    #Datefilter md-select .md-select-value {\r\n        border-bottom-color: rgb(255, 255, 255) !important;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-icon,\r\n    md-select .md-select-icon {\r\n        color: rgb(255, 255, 255);\r\n    }\r\n\r\n    /* md-select.md-default-theme:not([disabled]):focus .md-select-value, md-select:not([disabled]):focus .md-select-value{\r\n    color:white !important;\r\n} */\r\n    /* .dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n} */\r\n    /* .day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    /* .dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n} */\r\n\r\n    /* .dx-scheduler-group-header {\r\n    position: relative;\r\n} */\r\n\r\n    /* .dx-scheduler-timeline .dx-scheduler-appointment, .dx-scheduler-work-space-month .dx-scheduler-appointment, .dx-scheduler-all-day-appointment\r\n{\r\n  \r\n  \r\n    height: 73.5019px!important;\r\n   \r\n}\r\n.dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n}\r\n.dx-scheduler-dropdown-appointments{\r\n    position: absolute;\r\n    display: block;\r\n    height: 20px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    margin: 3px 0 0 3px;\r\n}\r\n.dx-scheduler-group-header {\r\n    position: relative;\r\n}\r\n\r\n.dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n\r\n.avatar {\r\n    width: 155px;\r\n    float: left;\r\n    overflow: hidden;\r\n    position: relative;\r\n    height: 125px;\r\n}\r\n\r\n.name {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.name h2 {\r\n    color: #fff;\r\n    text-align: left;\r\n    padding: 0 0 5px 175px;\r\n    margin: 0;    \r\n}\r\n\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n\r\n.info {\r\n    width: auto;\r\n    text-align: left;\r\n    height: 100%;\r\n    font-size: 11pt;\r\n    font-weight: normal;\r\n    padding: 25px 20px;\r\n    color: #707070;\r\n}\r\n\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n}\r\n\r\n.userInfo div {\r\n    margin: 20px;\r\n}\r\n\r\n.day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    .training-background-0 {\r\n        background-image: url(\"https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/gym/icon-abs.png\");\r\n    }\r\n\r\n    .appointment-content {\r\n        width: 360px;\r\n        margin-top: 3px;\r\n    }\r\n\r\n    .dx-popup-content .appointment-content {\r\n        margin-top: 7px;\r\n        height: 50px;\r\n    }\r\n\r\n    .dx-scheduler-header-panel-cell .dx-scheduler-cell-sizes-horizontal {\r\n        width: 100px\r\n    }\r\n\r\n    .appointment-badge {\r\n        text-align: center;\r\n        float: left;\r\n        margin-right: 12px;\r\n        color: white;\r\n        width: 28px;\r\n        height: 28px;\r\n        font-size: 20px;\r\n        line-height: 20px;\r\n        border-radius: 28px;\r\n        margin-top: 5px;\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    /* .appointment-dates {\r\n        color: #959595;\r\n        font-size: 12px;\r\n        text-align: left;\r\n        float: left;\r\n    }  */\r\n\r\n    .appointment-text {\r\n        overflow: hidden;\r\n        /* text-overflow: ellipsis; */\r\n        /* white-space: nowrap; */\r\n        width: 270px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        float: left;\r\n\r\n    }\r\n\r\n    .delete-appointment {\r\n        position: relative;\r\n        border: none;\r\n        box-shadow: none;\r\n        top: -8px;\r\n        height: 50px;\r\n    }\r\n\r\n    .showtime-preview>div:first-child {\r\n        font-size: 12px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .showtime-preview>div:not(:first-child) {\r\n        font-size: 11px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-button-content {\r\n        width: 50px;\r\n        height: 50px;\r\n        padding-left: 4px;\r\n    }\r\n\r\n    .delete-appointment.dx-state-hover,\r\n    .dx-list-item.dx-state-hover .dx-button {\r\n        box-shadow: none;\r\n        background-color: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-icon-trash {\r\n        color: #337ab7 !important;\r\n        font-size: 23px !important;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-group-table, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable:before{\r\n        content: \'TEAMS\'\r\n    } */\r\n    .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        border-bottom: 1px solid #c2c8cc;\r\n        content: \'TEAMS\';\r\n        font-size: larger;\r\n        font-weight: 700;\r\n        padding-left: 20px;\r\n        padding-top: 20px;\r\n\r\n    }\r\n\r\n    .dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        background-color: rgb(240, 102, 51);\r\n    }\r\n\r\n    .dx-scrollable-scroll-content {\r\n        background-color: rgb(240, 102, 51) !important;\r\n    }\r\n\r\n    .dx-icon-warning:before {\r\n        color: #d01e1e;\r\n        border: none\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable {\r\n        height: 15px !important;\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        height: 15px !important;\r\n    }\r\n\r\n    #dataGridFreq>div.dx-datagrid {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-rowsview .dx-row {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-top: none !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-headers {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-bottom: none !important;\r\n    }\r\n\r\n\r\n    #scheduler .dx-scheduler-cell-sizes-horizontal {\r\n        width: 80px;\r\n    }\r\n\r\n    .calendarspan {\r\n        padding-left: 50%;\r\n        font-weight: 800;\r\n        font-size: x-large;\r\n        color: maroon;\r\n    }\r\n\r\n    .custom-heading {\r\n        margin-top: 10px;\r\n        /* pushes it slightly down inside */\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        color: #333;\r\n        position: relative;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/expenseclaim/expenseclaim.html","<div id=\"expenseclaim\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><span \ntranslate=\"EXPENSECLAIM.EXPENSE CLAIM\">Expense Claim</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"mrSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'EXPENSECLAIM.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"mrAdd\" ng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"EXPENSECLAIM.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" ng-show=\"mrView\" \nng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"EXPENSECLAIM.BACK\">Back\n</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"mrExport && AllowExport==\'true\'\" \nng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"EXPENSECLAIM.EXPORT\">Export</span>\n</md-button></div></div><div class=\"content-card\" ng-show=\"Materialgrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Expenseclaimdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"EXPENSECLAIM.REFERENCE_NUMBER\" class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.EMPLOYEE_NAME\" class=\"column-title\">\nEmployee Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"EXPENSECLAIM.DATE\" class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"EXPENSECLAIM.REMARKS\" class=\"column-title\">Remarks</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.STATUS\" class=\"column-title\">Status\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"EXPENSECLAIM.EDIT_REQUEST\" class=\"column-title\">\nEdit Request</span></div></th><th class=\"secondary-text\"><div><span translate=\"EXPENSECLAIM.REPORT\" \nclass=\"column-title\">Report</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Expenseclaimdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewExpenseclaiminfo(row._id)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNumber }}</a></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Remarks}}</td><td>{{ row.Status }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Expenseclaiminfo(row._id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"content\" \nid=\"invoice\" ng-show=\"Pop\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">\n&emsp;&emsp;<b>EXPENSE CLAIM REQUEST</b> <img ng-if=\"QRCode\" style=\"height:20%; width:20%;float:right;margin-top:-1%\" \nsrc=\"{{QRCode}}\"></div><br><table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Reference #:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{ReferenceNumber}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Date:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{Date | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Employee ID:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EID}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Name:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EmployeeName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Remarks:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Remarks}}</th></tr></thead><tbody></tbody><tfoot>\n</tfoot></table><br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">DESCRIPTION</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">AMOUNT</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">GST</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">NOTES</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">BILL ATTACHED</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Expenseclaimdetailsdatas\" ng-if=\"row.MaterialID == MaterialID\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Amount }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">\n{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Notes }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><br><br><br><br><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Received By<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Date Prepared<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Date Received<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Verified/ Issued By</th><th \nstyle=\"border-collapse: collapse;width:700px\">Delivered By</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Materialform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span \ntranslate=\"EXPENSECLAIM.CANCEL_REQUEST\">Cancel Request</span></md-button></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"ReferenceNumber\" \nng-model=\"ReferenceNumber\" placeholder=\"{{\'EXPENSECLAIM.REFERENCE_NUMBER_#\'|translate}}\" readonly=\"readonly\"><div \nng-messages=\"basicForm.ReferenceNumber.$error\" ng-show=\"basicForm.ReferenceNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EXPENSECLAIM.REFERENCE NUMBER REQUIRED\">Reference Number Required.</span></div>\n</div></md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"EXPENSECLAIM.REQUESTED BY\">Requested By</label><md-select ng-model=\"EmployeeID\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'EXPENSECLAIM.SEARCH FOR A REQUESTER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"EmployeeID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.EmployeeID}} - {{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label\n translate=\"EXPENSECLAIM.DATE\">Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"Date\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"{{\'EXPENSECLAIM.REMARKS\'|translate}}\"><div ng-messages=\"basicForm.Remarks.$error\" \nng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"EXPENSECLAIM.REMARKS REQUIRED\">Remarks Required.</span></div></div></md-input-container></div></div></div>\n<br><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;{{\'EXPENSECLAIM.CLAIM DETAILS\'|translate}}</h1><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"Materialpopup($event, MaterialID)\" \nstyle=\"float:right\"><span translate=\"EXPENSECLAIM.ADD\">Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"EXPENSECLAIM.CATEGORY\" class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"EXPENSECLAIM.AMOUNT\" class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">GST</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"EXPENSECLAIM.NOTES\" class=\"column-title\">Notes</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.BILL_ATTACHED\" class=\"column-title\">\nBill Attached</span></div></th><th class=\"secondary-text\"><div><span translate=\"EXPENSECLAIM.VIEW/EDIT\" \nclass=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span translate=\"EXPENSECLAIM.DELETE\" \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Expenseclaimdetailsdatas\"><td>\n&nbsp;</td><td>{{ row.Categorydetails[0].CategoryName }}</td><td>{{ row.Description }}</td><td>{{ row.Amount }}</td><td\n nowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td>{{ row.Notes }}</td>\n<td>{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Expenseclaimdetailsupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Expenseclaimdetailsdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td>\n</tr></tbody></table></div></div><br><br></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"mSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">\n{{\'EXPENSECLAIM.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\n{{\'EXPENSECLAIM.CANCEL\'|translate}}</md-button></div><h2 style=\"text-align:left\">\n&nbsp;{{\'EXPENSECLAIM.ATTACHMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content \nlayout-padding><div flow-init flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label translate=\"EXPENSECLAIM.BROWSE\" for=\"file-input\" \nstyle=\"margin-bottom:0px\">Browse</label><input class=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"tb3\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPENSECLAIM.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPENSECLAIM.FILE_SIZE(KB)\">File Size(KB)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EXPENSECLAIM.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPENSECLAIM.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody class=\"css-serial\"><tr \nng-repeat=\"row in Attachmentdatas\" ng-if=\"row.FileID == ReferenceNumber\"><td></td><td><a \nhref=\"{{UploadsURL}}Accounts/Expense Claim/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div></div><div class=\"content\"></div><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewMaterialform\" flex><form name=\"basicForm2\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"ReferenceNumber#\" \nng-model=\"ReferenceNumber\" placeholder=\"{{\'EXPENSECLAIM.REFERENCE_NUMBER_#\'|translate}}\" readonly=\"readonly\">\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label translate=\"EXPENSECLAIM.REQUESTED BY\">\nRequested By</label><md-select ng-model=\"EmployeeID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" \nreadonly=\"readonly\"><md-option ng-repeat=\"row in Employeedatas \" value=\"{{row.id}}\" readonly=\"readonly\">\n{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"Date\" ng-model=\"Date | date:\'dd/MM/y\'\" \nplaceholder=\"{{\'EXPENSECLAIM.DATE\'|translate}}\" readonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"{{\'EXPENSECLAIM.REMARKS\'|translate}}\" readonly=\"readonly\"></md-input-container></div></div></div><br><br>\n<div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;{{\'EXPENSECLAIM.CLAIM DETAILS\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"EXPENSECLAIM.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"EXPENSECLAIM.AMOUNT\" class=\"column-title\">Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GST</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.NOTES\" class=\"column-title\">Notes</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"EXPENSECLAIM.BILL_ATTACHED\" \nclass=\"column-title\">Bill Attached</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Expenseclaimdetailsdatas\"><td>&nbsp;</td><td>{{ row.Description }}</td><td>{{ row.Amount }}</td><td \nnowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td>{{ row.Notes }}</td>\n<td>{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody></table></div><h2 style=\"text-align:left\">\n&nbsp;{{\'EXPENSECLAIM.ATTACHMENTS\'|translate}}</h2><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" id=\"tb3\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPENSECLAIM.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPENSECLAIM.FILE_SIZE(KB)\">File Size(KB)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EXPENSECLAIM.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPENSECLAIM.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody class=\"css-serial\"><tr \nng-repeat=\"row in Attachmentdatas\" ng-if=\"row.FileID == ReferenceNumber\"><td></td><td><a \nhref=\"{{UploadsURL}}Accounts/Expense Claim/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><br></form><br></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb1 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    /*md-datepicker .md-datepicker-input {\r\n        min-width: 325px;\r\n    }*/\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .css-serial {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    .css-serial td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/expenseclaim/expenseclaimdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"EXPENSECLAIM.ARE YOU SURE YOU WANT TO DELETE THIS ITEM\" class=\"title\">\nAre you sure you want to delete this item?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Mdelete(deleteID)\" class=\"md-raised md-accent\">{{\'EXPENSECLAIM.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'EXPENSECLAIM.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/accounts/expenseclaim/expenseclaimpop.html","<div class=\"content\"><div layout=\"row\" style=\"width:800px\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<span translate=\"EXPENSECLAIM.CLAIM DETAILS\" style=\"color:#617d7b\"><b>Claim Details</b></span></md-input-container>\n</div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"EXPENSECLAIM.CATEGORY\">Category</label><md-select ng-model=\"vm.ClaimCategoryID\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"searchTermCC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'EXPENSECLAIM.SEARCH FOR A CATEGORY\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.ClaimCategoryID=undefined\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in ClaimCategorydatas  | filter:searchTermCC\" value=\"{{row._id}}\">\n{{row.CategoryName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Description\" ng-model=\"vm.Description\" placeholder=\"{{\'EXPENSECLAIM.DESCRIPTION\'|translate}}\" required><div \nng-messages=\"basicForm.Description.$error\" ng-show=\"basicForm.Description.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EXPENSECLAIM.DESCRIPTION REQUIRED\">Description Required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" \nname=\"Amount\" ng-model=\"vm.Amount\" ng-change=\"CheckAmount()\" placeholder=\"{{\'EXPENSECLAIM.AMOUNT\'|translate}}\" \nrequired><div ng-messages=\"basicForm.Amount.$error\" ng-show=\"basicForm.Amount.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"EXPENSECLAIM.AMOUNT REQUIRED\">Amount Required.</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"EXPENSECLAIM.GST_CODE\">GST Code</label><md-select \nng-model=\"vm.GSTID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"searchTermGST\" style=\"flex: auto\" type=\"text\" placeholder=\"{{\'EXPENSECLAIM.SEARCH FOR A GST\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.GSTID=undefined\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.Description}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width:100%;margin-top: -35px;margin-bottom: -35px\" ng-show=\"CreatePaymentVoucher\"><div \nstyle=\"width:50%;float:left\"></div><div layout=\"column\" style=\"width:50%;float:left\"><label style=\"color:red\"><b>\n{{\'EXPENSECLAIM.MAXIMUM AMOUNT YOU CAN CLAIM IS 100$\'|translate}}.</b></label><br><br><label style=\"margin-top: -45px\">\n<b>{{\'EXPENSECLAIM.PLEASE\'|translate}} <a href=\"\" ui-sref=\"app.accounts_payment\" style=\"border:none\">\n{{\'EXPENSECLAIM.CLICK HERE\'|translate}}</a> {{\'EXPENSECLAIM.TO CREATE PAYMENT VOCHER\'|translate}}.</b></label><br><br>\n</div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"Notes\" \nng-model=\"vm.Notes\" placeholder=\"{{\'EXPENSECLAIM.NOTES\'|translate}}\"></md-input-container></div><md-input-container \nflex style=\"margin-top:5px\"><md-checkbox ng-model=\"vm.BillAttached.value\" type=\"checkbox\">\n{{\'EXPENSECLAIM.BILL_ATTACHED\'|translate}}</md-checkbox></md-input-container></div></form><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ExpenseclaimdetailsAdd()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">{{\'EXPENSECLAIM.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">{{\'EXPENSECLAIM.CANCEL\'|translate}}</md-button></div></div></div></div><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/accounts/purchasespayables/Editpaysupplier.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"PURCHASESPAYABLES.PAY_SUPPLIER\" class=\"title\">PAY SUPPLIER</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: -25px\">\n<md-input-container flex><input type=\"text\" name=\"InvoiceNumber\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" readonly=\"readonly\" ng-disabled=\"Update\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" \nname=\"InvoiceDate\" ng-model=\"InvoiceDate\" placeholder=\"{{\'PURCHASESPAYABLES.VOUCHER_DATE\'|translate}}\" \nreadonly=\"readonly\" ng-disabled=\"Update\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Supplier\" ng-model=\"SupplierName\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SUPPLIER\'|translate}}\" readonly=\"readonly\" ng-disabled=\"Update\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.VoucherNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 18px\">\n<label translate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nclass=\"pdate\" ng-model=\"vm.VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker></md-input-container>\n<md-input-container id=\"date1\" flex style=\"margin-top:18px;margin-left:-10px\"><label \ntranslate=\"PURCHASESPAYABLES.PAYMENT_DATE\">Payment Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"PURCHASESPAYABLES.PAYMENT_MODE\">Payment Mode</label><md-select \nng-model=\"vm.PaymentMode\" ng-change=\"ChequeNumberField()\"><md-option value=\"Cheque\">\n{{\'PURCHASESPAYABLES.CHEQUE\'|translate}}</md-option><md-option value=\"Cash\">{{\'PURCHASESPAYABLES.CASH\'|translate}}\n</md-option><md-option value=\"NETS\">{{\'PURCHASESPAYABLES.GIRO\'|translate}}</md-option><md-option value=\"Card Payment\">\n{{\'PURCHASESPAYABLES.CARD_PAYMENT\'|translate}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"PURCHASESPAYABLES.BANK_NAME\">Bank Name</label><md-select ng-model=\"vm.BankID\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_BANK\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"vm.BankID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Bankdatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.BankName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"ShowChequeNumberField\" \nstyle=\"margin-bottom:-20px\"><md-input-container flex><input type=\"text\" name=\"ChequeNumber\" ng-model=\"vm.ChequeNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.CHEQUE_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><form name=\"PaySupplierItem\" class=\"md-inline-form\" novalidate><md-input-container flex><input \ntype=\"number\" name=\"Amount Paid\" ng-model=\"vm.ItemAmount\" placeholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex><label translate=\"PURCHASESPAYABLES.ACCOUNTING_CODE\">Accounting Code\n</label><md-select ng-model=\"vm.ItemAccountID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.ItemAccountID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row._id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-button \nstyle=\"Height: 36px !important\" class=\"md-raised md-accent\" ng-click=\"PaySupplierItemSubmit()\" ng-show=\"HideAdd\" \nng-disabled=\"PaySupplierItem.$invalid || PaySupplierItem.$pristine\"><span translate=\"PURCHASESPAYABLES.ADD\">Add</span>\n</md-button><md-button style=\"Height: 36px !important\" class=\"md-raised md-accent\" ng-click=\"PaySupplierItemUpdate()\" \nng-show=\"HideSave\" ng-disabled=\"PaySupplierItem.$invalid || PaySupplierItem.$pristine\"><span \ntranslate=\"PURCHASESPAYABLES.SAVE\">Save</span></md-button><md-button style=\"Height: 36px !important\" \nclass=\"md-raised md-accent\" ng-click=\"ClearPaySupplierItems()\" \nng-disabled=\"PaySupplierItem.$invalid || PaySupplierItem.$pristine\"><span translate=\"PURCHASESPAYABLES.CLEAR\">Clear\n</span></md-button></form></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.AMOUNT\" class=\"column-title\">Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" class=\"column-title\">\nAccount Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.AMOUNT_DESCRIPTION\" class=\"column-title\">Account Description</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PaySuppliersItemDetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Amount || 0 |number:2 }}</td><td>{{ row.AccountCode }}</td><td>{{ row.AccountDescription }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"PaySupplierItemInfo(row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table><hr><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SavePaysupplier()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'PURCHASESPAYABLES.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"closeDialog()\" \naria-label=\"Submit\">{{\'PURCHASESPAYABLES.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog>\n<style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n        width: 160px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/purchasespayables/creditnote.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"PURCHASESPAYABLES.CREDIT_NOTE\" class=\"title\">Credit Note</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PURCHASESPAYABLES.INVOICE_NUMBER\">\nInvoice Number</label><md-select ng-model=\"vm.InvoiceID\" id=\"searchmodule\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Purchaseinvoicedatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.InvoiceNumber}}</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"PURCHASESPAYABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.InvoiceDate\" required></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"number\" name=\"Invoice Amount\" ng-model=\"vm.InvoiceAmount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.INVOICE_AMOUNT\'|translate}} \" required><div \nng-messages=\"eventForm.InvoiceAmount.$error\" ng-show=\"eventForm.InvoiceAmount.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PURCHASESPAYABLES.INVOICE_AMOUNT_FIELD_IS_REQUIRED\">\nInvoice Amount field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"number\" \nname=\"Credit Note Amount\" ng-model=\"vm.CreditNoteAmount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.CREDIT_NOTE_AMOUNT\'|translate}}\" required><div \nng-messages=\"eventForm.CreditNoteAmount.$error\" ng-show=\"eventForm.CreditNoteAmount.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PURCHASESPAYABLES.INVOICE_AMOUNT_FIELD_IS_REQUIRED\">\nInvoice Amount field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Credit Note No\" ng-model=\"vm.RefrenceNo\" \nplaceholder=\"{{\'PURCHASESPAYABLES.CREDIT_NOTE_NO\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" \nplaceholder=\"{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}Description\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveCreditNote()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'PURCHASESPAYABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'PURCHASESPAYABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/purchasespayables/invoice.html","<div id=\"purchasespayables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"PURCHASESPAYABLES.INVOICE\" class=\"title\">Invoice</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" style=\"margin-top: -30px\"><md-button \nng-click=\"cancelpurchaseinvoice()\" ng-show=\"CancelPI\" class=\"cancel-button md-accent md-raised\" \naria-label=\"CANCEL INVOICE\">{{\'PURCHASESPAYABLES.CANCEL_INVOICE\'|translate}}</md-button></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: 20px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.InvoiceNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"PURCHASESPAYABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.Date\"></md-datepicker></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.VoucherNumber\" placeholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required \nng-disabled=\"Update\"><div ng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span>\n</div></div></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" class=\"pdate\" \nng-model=\"vm.VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PURCHASESPAYABLES.PURCHASE_ORDER\">\nPurchase Order</label><md-select ng-model=\"vm.POID\" id=\"searchmodule\" required ng-change=\"OnPOChange()\">\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH FOR A PURCHASE ORDER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.POID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Purchaseorderdatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.ReferenceNo}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"number\" name=\"Amount\" ng-model=\"vm.Amount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"vm.Description\" placeholder=\"{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}\">\n</md-input-container><md-input-container flex><label translate=\"PURCHASESPAYABLES.GST_CODE\">GST Code</label><md-select \nng-model=\"vm.GSTID\" id=\"searchmodule\"><md-select-header><input ng-model=\"searchTermGST\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_GST\'|translate}}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"GSTID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row.id}}\">{{row.GSTTaxCode}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 18px\">\n<label translate=\"PURCHASESPAYABLES.RECEIVED_BY\">Received By</label><md-select ng-model=\"vm.ReceivedBy\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_EMPLOYEE\'|translate}}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ReceivedBy=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.EmployeeName}}\">\n{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"PURCHASESPAYABLES.RECEIVED_DATE\">Received Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ReceivedDate\"></md-datepicker></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container>\n<md-input-container flex></md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveInvoice()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"SAVE\" \ntranslate-attr-aria-label=\"SAVE\">{{\'PURCHASESPAYABLES.SAVE\'|translate}}</md-button><md-button ng-click=\"closeDialog()\" \nclass=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">{{\'PURCHASESPAYABLES.CANCEL\'|translate}}</md-button>\n</md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/purchasespayables/paysupplier.html","<div id=\"purchasespayables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"PURCHASESPAYABLES.PAY_SUPPLIER\" class=\"title\">Pay Supplier</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month\n</span></md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"vm.uFrom\"></md-datepicker></md-input-container>\n<md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>\n{{\'PURCHASESPAYABLES.SUPPLIER\'|translate}}</b></label><md-select class=\"Supplierfilter\" ng-model=\"vm.SupplierID\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_SUPPLIER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:vm.searchTerm\" \nvalue=\"{{row.id}}\">{{row.ReferenceNo}} - {{row.Name}}</md-option></md-select></md-input-container><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"InvoicefilterBySupplier()\"><span \ntranslate=\"PURCHASESPAYABLES.SEARCH\">Search</span></md-button></div></div><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.VoucherNumber\" placeholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" class=\"pdate\" \nng-model=\"vm.VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PURCHASESPAYABLES.INVOICE_NUMBER\">\nInvoice Number</label><md-select ng-model=\"vm.InvoiceNo\" ng-model-options=\"{trackBy: \'$value._id\'}\" multiple=\"\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_INVOICE_NO\'|translate}}Search for a invoice no..\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" \nng-click=\"vm.InvoiceNo=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-select-header><b>\n{{\'PURCHASESPAYABLES.INVOICE_NUMBER\'|translate}} - {{\'PURCHASESPAYABLES.INVOICE_DATE\'|translate}}</b>\n</md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Purchaseinvoicedatasdd | filter:SupplierID :SupplierID | filter:vm.searchTerm1\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container flex><label translate=\"PURCHASESPAYABLES.PAYMENT_MODE\">Payment Mode</label><md-select \nng-model=\"vm.PaymentMode\" ng-change=\"ChequeNumberField()\"><md-option value=\"Cheque\">\n{{\'PURCHASESPAYABLES.CHEQUE\'|translate}}</md-option><md-option value=\"Cash\">{{\'PURCHASESPAYABLES.CASH\'|translate}}\n</md-option><md-option value=\"NETS\">{{\'PURCHASESPAYABLES.NETS\'|translate}}</md-option><md-option value=\"Card Payment\">\n{{\'PURCHASESPAYABLES.CARD_PAYMENT\'|translate}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-show=\"ShowChequeNumberField\" style=\"margin-bottom:-20px\"><md-input-container flex><input \ntype=\"number\" name=\"ChequeNumber\" ng-model=\"vm.ChequeNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.CHEQUE_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"PURCHASESPAYABLES.ACCOUNTING_CODE\">Accounting Code\n</label><md-select ng-model=\"vm.AccountID\" id=\"searchmodule\" required><md-select-header><input \nng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nng-disabled=\"Update\"><md-button class=\"md-icon-button\" ng-click=\"vm.AccountID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row.id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"PURCHASESPAYABLES.BANK_NAME\">Bank Name</label><md-select ng-model=\"vm.BankID\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_BANK\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"vm.BankID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Bankdatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.BankName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" \nname=\"Amount Paid\" ng-model=\"vm.Amount\" placeholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\"></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"PURCHASESPAYABLES.PAYMENT_DATE\">Payment Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SavePaysupplier()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'PURCHASESPAYABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'PURCHASESPAYABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/purchasespayables/purchasespayables.html","<div id=\"purchasespayables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.ACCOUNTS PAYABLES\">Accounts Payables</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" ng-mode=\"SearchValue\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"Invoiceadd($event)\" ng-show=\"PurchaseInvoicegrid\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Creditnoteadd($event)\" ng-show=\"CreditnoteGrid\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Debitnoteadd($event)\" ng-show=\"DebitnoteGrid\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"InvoiceExport()\" ng-show=\"PurchaseInvoicegrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"PURCHASESPAYABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"PaysupplierExport()\" ng-show=\"PaySuppliergrid && AllowExport==\'true\'\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"PURCHASESPAYABLES.EXPORT\">Export</span></md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"CreditnoteExport()\" \nng-show=\"CreditnoteGrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"DebitnoteExport()\" ng-show=\"DebitnoteGrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"PURCHASESPAYABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"PurchaseInvoiceShowgrid()\" \nng-show=\"PurchaseInvoiceform && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"PaySupplierShowgrid()\" ng-show=\"PaySupplierform && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"PURCHASESPAYABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CreditnoteShowgrid()\" ng-show=\"CreditnoteForm && AllowExport==\'true\'\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"PURCHASESPAYABLES.BACK\">Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"DebitnoteShowgrid()\" \nng-show=\"DebitnoteForm && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"PURCHASESPAYABLES.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showinvoicegrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"PURCHASESPAYABLES.BACK\">Back</span></md-button></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab ng-click=\"InvoiceTab()\"><md-tab-label>\n<span translate=\"PURCHASESPAYABLES.PURCHASE_INVOICE\">Purchase Invoice</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceGrid\"><form \nname=\"PurchaseInvoice\" class=\"md-inline-form\" novalidate><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"content-card\" \nng-show=\"PurchaseInvoicegrid\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">Search</span>\n</md-button></div></div><md-progress-linear ng-hide=\"Purchaseinvoicedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions4\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"PURCHASESPAYABLES.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span translate=\"PURCHASESPAYABLES.VOUCHER_NO\" class=\"column-title\">Voucher_No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.VOUCHER_DATE\" \nclass=\"column-title\">Voucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.PURCHASE_ORDER\" class=\"column-title\">Purchase Order</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.INVOICE_NO\" class=\"column-title\">\nInvoice No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.INVOICE_DATE\" class=\"column-title\">Invoice Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.INVOICE_STATUS\" \nclass=\"column-title\">Invoice Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.WORKFLOW_STATUS\" class=\"column-title\">Workflow Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_CODE\" \nclass=\"column-title\">Supplier Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.PURCHASE_AMOUNT\" \nclass=\"column-title\">Purchase Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.GST_AMOUNT\" class=\"column-title\">GST Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">OutStanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.GST_CODE\" class=\"column-title\">GST Code</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.RECEIVED_DATE\" \nclass=\"column-title\">Received Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.RECEIVED_BY\" class=\"column-title\">Received By</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.CREDIT_NOTE_NUMBER\" class=\"column-title\">\nCredit Note Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.DEBIT_NOTE_NUMBER\" class=\"column-title\">Debit Note Number</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Purchaseinvoicedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nclass=\"editMe\"><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Invoiceinfo($event,row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td nowrap=\"nowrap\"><a href=\"\" ng-click=\"ViewPurchaseinvoiceinfo(row._id)\" title=\"Details\" \nstyle=\"border:none\">{{ row.VoucherNumber }}</a></td><td nowrap=\"nowrap\">{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td \nnowrap=\"nowrap\">{{ row.POID }}</td><td nowrap=\"nowrap\">{{ row.InvoiceNumber }}</td><td nowrap=\"nowrap\">\n{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.InvoiceStatus}}</td><td nowrap=\"nowrap\">{{ row.Status}}\n</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].ReferenceNo }}</td><td nowrap=\"nowrap\">\n{{ row.Supplierdetails[0].Name }}</td><td nowrap=\"nowrap\">$ {{ row.Amount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.GSTAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">{{ row.Description }}</td><td \nnowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }}</td><td nowrap=\"nowrap\">{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td>\n<td nowrap=\"nowrap\">{{ row.ReceivedBy}}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber}}</td><td nowrap=\"nowrap\">\n{{ row.DebitNoteNumber}}</td></tr></tbody></table></div><div layout=\"column\" ng-show=\"PurchaseInvoiceform\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content-card\" style=\"width:100%;padding:-1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;{{\'PURCHASESPAYABLES.PURCHASE_INVOICE_DETAILS\'|translate}}</h2><hr>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'PURCHASESPAYABLES.PURCHASE_ORDER\'|translate}}</label>\n&nbsp; :&nbsp; {{POrderID}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'PURCHASESPAYABLES.INVOICE_NO\'|translate}}</label>&nbsp; :&nbsp; {{InvoiceNumber}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}</label>\n&nbsp; :&nbsp; {{Description}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'PURCHASESPAYABLES.INVOICE_DATE\'|translate}}</label>&nbsp; :&nbsp; {{Date | date:\'dd/MM/y\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}</label>\n&nbsp; :&nbsp;$ {{Amount|| 0 |number:2 }}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\n{{\'PURCHASESPAYABLES.RECEIVED_DATE\'|translate}}</label>&nbsp; :&nbsp; {{ReceivedDate | date:\'dd/MM/y\'}}<br><br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:150px\">{{\'PURCHASESPAYABLES.RECEIVED_BY\'|translate}}</label>\n&nbsp; :&nbsp; {{ReceivedBy}}<br><br></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 \nstyle=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.WORKFLOW\'|translate}}</h2><hr><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">\n{{\'PURCHASESPAYABLES.CURRENT_STATUS\'|translate}}</label>: &emsp; {{Actioned}}</div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\"><label style=\"width:100px;font-weight:500\">{{\'PURCHASESPAYABLES.NEXT_STATUS\'|translate}}\n</label>: &emsp; {{NextLevelAction}}</div></div><br><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" flex><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"ShowWorkflowButton\"><md-button class=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\">\n<span>{{NextLevelAction}}</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span translate=\"PURCHASESPAYABLES.REJECT\">Reject</span></md-button></div><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" \nid=\"cancel\" value=\"Cancel\" ng-click=\"cancel()\"><span translate=\"PURCHASESPAYABLES.CANCEL\">Cancel</span></md-button>\n</div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button \nclass=\"md-accent md-raised\" id=\"revise\" value=\"Revise\" ng-click=\"revise()\"><span translate=\"PURCHASESPAYABLES.REVISE\">\nRevise</span></md-button></div></div><br><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACTION\" class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACTIONED_BY\" class=\"column-title\">\nActioned By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.ACTIONED_DATE\" class=\"column-title\">Actioned Date</span></div></th></tr></thead><tbody><tr\n ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Action }}</td><td>\n{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div>\n</div><br><h2 style=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.PURCHASE_ORDER\'|translate}}</h2><hr><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.CATEGORY\" class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.CODE\" class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.NAME\" class=\"column-title\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.QUANTITY\" class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.UNIT\" class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.UNIT_PRICE\" class=\"column-title\">\nUnit Price</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.TOTAL_COST\" class=\"column-title\">Total Cost</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseorderproductdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost }}</td></tr>\n</tbody></table><br><hr><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content-card\" \nstyle=\"width:100%;padding:-1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:39.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.COMMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"{{\'PURCHASESPAYABLES.COMMENT_HERE..\'|translate}}..\" required></md-input-container>\n</div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button class=\"md-raised md-accent\" \nng-click=\"commentSubmit()\" ng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span \ntranslate=\"PURCHASESPAYABLES.SAVE\">SAVE</span></md-button></div><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.COMMENT\" class=\"column-title\">\nComment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.COMMENTED_BY\" class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.COMMENTED_DATE\" \nclass=\"column-title\">Commented Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}</td><td>{{ row.CommentedBy }}</td><td>\n{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.ATTACHMENTS\'|translate}}</h2>\n<hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button \nclass=\"md-accent md-raised\"><label translate=\"PURCHASESPAYABLES.BROWSE\" for=\"file-input\" style=\"margin-bottom:0px\">\nBROWSE</label><input class=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span translate=\"PURCHASESPAYABLES.UPLOAD\">UPLOAD</span></md-button></div>\n<table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">\n{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.FILE_NAME\" class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.FILE_SIZE(KB)\" \nclass=\"column-title\">File Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.UPLOADED_BY\" class=\"column-title\">Uploaded By</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.UPLOADED_DATE\" class=\"column-title\">Uploaded Date</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><a href=\"{{UploadsURL}}Accounts/Purchase Invoice/{{row.TableID}}\" download style=\"cursor:pointer\">\n{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div></div></div></div></div></form>\n</div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form \nname=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" style=\"margin-top: -30px\"><md-button ng-click=\"cancelpurchaseinvoice()\" ng-show=\"CancelPI\" \nclass=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL INVOICE\">{{\'PURCHASESPAYABLES.CANCEL_INVOICE\'|translate}}\n</md-button></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 20px\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.InvoiceNumber\" placeholder=\"{{\'PURCHASESPAYABLES.INVOICE_NUMBER\'|translate}}\" required><div \nng-messages=\"basicForm1.Item.$error\" ng-show=\"basicForm1.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" ng-model=\"vm.Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.VoucherNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"basicForm1.Item.$error\" ng-show=\"basicForm1.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"vm.VoucherDate\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label><b>{{\'PURCHASESPAYABLES.SUPPLIER\'|translate}}</b>\n</label><md-select class=\"Supplierfilter\" ng-model=\"vm.SupplierID\" id=\"searchmodule\"><md-select-header><input \nng-model=\"searchTerm3\" type=\"text\" style=\"flex: auto\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_SUPPLIER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"vm.SupplierID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Supplierdatas | filter:searchTerm3\" value=\"{{row.id}}\">{{row.ReferenceNo}} - {{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"PURCHASESPAYABLES.PURCHASE_ORDER\">\nPurchase Order</label><md-select ng-model=\"vm.POID\" ng-model-options=\"{trackBy: \'$value.ReferenceNo\'}\" multiple=\"\" \nrequired ng-change=\"OnPOChange()\"><md-select-header><input ng-model=\"vm.searchTerm11\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_PURCHASE_ORDER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"vm.POID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option\n ng-value=\"row\" ng-repeat=\"row in Purchaseorderdatas  |filter:{SupplierID:vm.SupplierID} | filter:vm.searchTerm11\">\n{{row.ReferenceNo}} - Total Amount ({{row.Total || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount\" ng-model=\"vm.Amount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"vm.Description\" placeholder=\"{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"PURCHASESPAYABLES.GST_CODE\">GST Code</label><md-select ng-model=\"vm.GSTID\" id=\"searchmodule\" required>\n<md-select-header><input ng-model=\"searchTermGST\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_GST..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">{{row.GSTTaxCode}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"PURCHASESPAYABLES.RECEIVED_BY\">Received By</label>\n<md-select ng-model=\"vm.ReceivedBy\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_EMPLOYEE\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" \nng-click=\"vm.ReceivedBy=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" \nvalue=\"{{row.EmployeeName}}\">{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container>\n<md-input-container flex style=\"margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.RECEIVED_DATE\">Received Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" ng-model=\"vm.ReceivedDate\"></md-datepicker></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.Remarks\" placeholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div>\n</div><div class=\"bottom\" layout=\"row\" layout-align=\"center\"><md-button style=\"Height: 36px !important\" type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'PURCHASESPAYABLES.SUBMIT\'|translate}}</md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showinvoicegrid()\"><span \ntranslate=\"PURCHASESPAYABLES.CANCEL\">Cancel</span></md-button></div></div></form><h2 style=\"text-align:left\">\n&nbsp;{{\'PURCHASESPAYABLES.PURCHASE_ORDER\'|translate}}</h2><hr><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.CATEGORY\" class=\"column-title\">\nCategory</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.CODE\" class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.NAME\" class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.QUANTITY\" class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.UNIT\" class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.UNIT_PRICE\" class=\"column-title\">\nUnit Price</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.TOTAL_COST\" class=\"column-title\">Total Cost</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseorderproductdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost }}</td></tr>\n</tbody></table></div></md-tab-body></md-tab><md-tab ng-click=\"PaysupplierTab()\"><md-tab-label><span \ntranslate=\"PURCHASESPAYABLES.PAY_SUPPLIER\">Pay Supplier</span></md-tab-label><md-tab-body><form name=\"PaySupplier\" \nclass=\"md-inline-form\" novalidate><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nclass=\"content-card\" ng-show=\"PaySuppliergrid\"><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Paysupplierdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions4\"><thead><tr><th class=\"secondary-text\">\n<div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"PURCHASESPAYABLES.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"PURCHASESPAYABLES.INVOICE_NO\" class=\"column-title\">Invoice Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.VOUCHER_NO\" class=\"column-title\">\nVoucher No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\" class=\"column-title\">Voucher Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_CODE\" \nclass=\"column-title\">Supplier Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" class=\"column-title\">\nAccount Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.AMOUNT\" class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.BANK\" class=\"column-title\">Bank</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.PAYMENT_MODE\" class=\"column-title\">\nPayment Mode</span></div></th><th class=\"secondary-text\"><div><span translate=\"PURCHASESPAYABLES.PAYMENT_DATE\" \nclass=\"column-title\">Payment Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paysupplierdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Paysupplierinfo($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><a \nhref=\"\" ng-click=\"ViewPaysupplierinfo(row._id)\" title=\"Click here to Attachement\" style=\"border:none\">\n{{ row.Invoicedetails[0].InvoiceNumber}}</a></td><td nowrap=\"nowrap\">{{ row.VoucherNumber }}</td><td>\n{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].ReferenceNo }}</td><td \nnowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}</td><td>{{ getAccountCode (row.itemDetails)}}</td><td \nnowrap=\"nowrap\">$ {{ getTotal(row.itemDetails) || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n{{ row.Bankdetails[0].BankName }}</td><td>{{ row.PaymentMode}}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td></tr>\n</tbody></table></div></div><div layout=\"column\" ng-show=\"PaySupplierform\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex><div class=\"content-card\" style=\"width:100%;padding:-1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.PAY_SUPPLIER_DETAILS\'|translate}}\n</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">{{\'PURCHASESPAYABLES.INVOICE_NO\'|translate}}\n</label>&nbsp; :&nbsp; {{InvoiceNumber}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">\n{{\'PURCHASESPAYABLES.INVOICE_DATE\'|translate}}</label>&nbsp; :&nbsp; {{InvoiceDate | date:\'dd/MM/y\'}}<br><br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:165px\">{{\'PURCHASESPAYABLES.SUPPLIER_NAME\'|translate}}</label>\n&nbsp; :&nbsp; {{SupplierName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">\n{{\'PURCHASESPAYABLES.PAYMENT_MODE\'|translate}}</label>&nbsp; :&nbsp; {{PaymentMode}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:165px\">{{\'PURCHASESPAYABLES.CHEQUE_NUMBER\'|translate}}</label>\n&nbsp; :&nbsp; {{ChequeNumber}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">\n{{\'PURCHASESPAYABLES.BANK_NAME\'|translate}}</label>&nbsp; :&nbsp; {{BankName}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:165px\">{{\'PURCHASESPAYABLES.ACCOUNT_CODE\'|translate}}</label>\n&nbsp; :&nbsp; {{AccountCode}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">\n{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}</label>&nbsp; :&nbsp; {{AccountDescription}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:165px\">{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}</label>\n&nbsp; :&nbsp;$ {{Amount|| 0 |number:2 }}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:165px\">\n{{\'PURCHASESPAYABLES.PAYMENT_DATE\'|translate}}</label>&nbsp; :&nbsp; {{Date | date:\'dd/MM/y\'}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">\n&nbsp;{{\'PURCHASESPAYABLES.COMMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.PaySupplierComments\" \nplaceholder=\"{{\'PURCHASESPAYABLES.COMMENT HERE\'|translate}}..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button class=\"md-raised md-accent\" \nng-click=\"PaySupplierCommentSubmit()\" ng-disabled=\"PaySupplier.$invalid || PaySupplier.$pristine\"><span \ntranslate=\"PURCHASESPAYABLES.SAVE\">Save</span></md-button></div><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.COMMENT\" class=\"column-title\">\nComment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.COMMENTED_BY\" class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.COMMENTED_DATE\" \nclass=\"column-title\">Commented Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PaySupplierCommentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}</td>\n<td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table><br><br><hr>\n<h2 style=\"text-align:left\">&nbsp;{{\'PURCHASESPAYABLES.ATTACHMENTS\'|translate}}</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-content layout-padding><div flow-init flow-name=\"uploader.flow\"><div \nlayout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button class=\"md-accent md-raised\"><label \ntranslate=\"PURCHASESPAYABLES.BROWSE\" for=\"file-inputs\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-inputs\" flow-btn id=\"file-inputs\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"PaysupplierUploadfiles(uploader.flow.files)\"><span translate=\"PURCHASESPAYABLES.UPLOAD\">Upload</span>\n</md-button></div><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.FILE_NAME\" class=\"column-title\">\nFile Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.FILE_SIZE(KB)\" class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.UPLOADED_BY\" class=\"column-title\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.UPLOADED_DATE\" class=\"column-title\">Uploaded Date</span></div></th></tr></thead><tbody><tr\n ng-repeat=\"row in PaySupplierAttachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Accounts/Pay Supplier/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div></div></div></div></div></form></md-tab-body></md-tab><md-tab ng-click=\"DebitnoteTab()\">\n<md-tab-label><span translate=\"PURCHASESPAYABLES.DEBIT_NOTE\">Debit Note</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"DebitnoteGrid\"><form \nname=\"organizationform1d\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Debitnotedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\">\n<span translate=\"PURCHASESPAYABLES.VOUCHER_NO\" class=\"column-title\">Voucher Number</span></div></th><th \nnowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.VOUCHER_DATE\" \nclass=\"column-title\">Voucher Date</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.DEBIT_NOTE_NUMBER\" class=\"column-title\">Debit Note Number\n</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div><span translate=\"PURCHASESPAYABLES.DEBIT_NOTE_DATE\" \nclass=\"column-title\">Debit Note Date</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div><span \ntranslate=\"PURCHASESPAYABLES.INVOICE_NO\" class=\"column-title\">Invoice Number</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_CODE\" \nclass=\"column-title\">Supplier Code</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div>\n</th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.GST_CODE\" class=\"column-title\">\nGST Code</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.AMOUNT\" class=\"column-title\">Amount</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.REMARKS\" class=\"column-title\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Debitnotedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"Debitnoteinfo(row._id)\" title=\"View/Edit\" style=\"border:none\">{{ row.VoucherNumber }}</a></td><td \nnowrap=\"nowrap\">{{ row.VoucherDate | date:\'dd/MM/y\'}}</td><td nowrap=\"nowrap\">{{ row.DebitNoteNumber}}</td><td \nnowrap=\"nowrap\">{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ getInvoiceNumber (row.itemDetails) }}</td>\n<td nowrap=\"nowrap\">{{ row.Supplierdetails[0].ReferenceNo }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}\n</td><td nowrap=\"nowrap\">{{ getAccountCode (row.itemDetails) }}</td><td nowrap=\"nowrap\">\n{{ getGSTCode(row.itemDetails) }}</td><td nowrap=\"nowrap\">$ {{ getTotal(row.itemDetails) || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">{{ row.Description}}</td><td nowrap=\"nowrap\">{{ row.Remarks}}</td></tr></tbody></table></div></div>\n</form></div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"DebitnoteForm\">\n<form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">\nLast Month</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>\n{{\'PURCHASESPAYABLES.SUPPLIER\'|translate}}</b></label><md-select class=\"Supplierfilter\" ng-model=\"vm.SupplierID\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"searchTerm3\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_SUPPLIER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:searchTerm3\" \nvalue=\"{{row.id}}\">{{row.ReferenceNo}} - {{row.Name}}</md-option></md-select></md-input-container><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">\nSearch</span></md-button></div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"DebitNoteNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.DEBIT_NOTE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.DEBIT_NOTE_NUMBER_IS_REQUIRED\">Debit Note Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.DEBIT_NOTE_DATE\">Debit Note Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Description\" \nplaceholder=\"{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"PURCHASESPAYABLES.INVOICE_NUMBER\">Invoice Number</label><md-select ng-model=\"DNInvoiceID\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNInvoiceID=undefined\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Purchaseinvoicedatasddf  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"DNAmount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\"></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"PURCHASESPAYABLES.ACCOUNTING_CODE\">Accounting Code</label><md-select \nng-model=\"DNAccountID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNAccountID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row._id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"PURCHASESPAYABLES.GST_CODE\">GST Code</label><md-select \nng-model=\"DNGSTID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_GST..\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNGSTID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">{{row.GSTTaxCode}} - {{row.Description}}\n</md-option></md-select></md-input-container><md-button style=\"margin-top: -6px\" class=\"md-raised md-accent\" \nng-show=\"HideAdd\" ng-click=\"DNItemSubmit()\"><span translate=\"PURCHASESPAYABLES.ADD\">Add</span></md-button><md-button \nstyle=\"margin-top: -6px\" class=\"md-raised md-accent\" ng-show=\"HideSave\" ng-click=\"DNItemUpdate()\"><span \ntranslate=\"PURCHASESPAYABLES.SAVE\">Save</span></md-button><md-button style=\"margin-top: -6px\" \nclass=\"md-raised md-accent\" ng-click=\"ClearDNItems()\"><span translate=\"PURCHASESPAYABLES.CLEAR\">Clear</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.INVOICE_NUMBER\" class=\"column-title\">Invoice Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.AMOUNT\" \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.TAX_AMOUNT\" class=\"column-title\">Tax Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.TOTAL_AMOUNT\" class=\"column-title\">Total Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" \nclass=\"column-title\">Account Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.GST_CODE\" class=\"column-title\">\nGST Code</span></div></th><th class=\"secondary-text\"><div><span translate=\"PURCHASESPAYABLES.EDIT\" \nclass=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in DNItemDetails\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.InvoiceNumber }}</td><td>{{ row.PaidAmount || 0 |number:2 }}\n</td><td>{{ row.TaxAmount || 0 |number:2 }}</td><td>{{ row.Amount || 0 |number:2 }}</td><td>{{ row.AccountCode }}</td>\n<td>{{ row.AccountDescription }}</td><td>{{ row.GSTCode }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DNItemInfo(row._id)\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" \nlayout-align=\"center\"><md-button style=\"Height: 36px !important\" type=\"button\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveDebitnote()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">{{\'PURCHASESPAYABLES.SUBMIT\'|translate}}</md-button><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"ShowgridDebit()\"><span translate=\"PURCHASESPAYABLES.CANCEL\">\nCancel</span></md-button></div></div></form></div></md-tab-body></md-tab><md-tab ng-click=\"CreditnoteTab()\">\n<md-tab-label><span translate=\"PURCHASESPAYABLES.CREDIT_NOTE\">Credit Note</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"CreditnoteGrid\"><form \nname=\"CreditnotebasicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\">\n<span translate=\"PURCHASESPAYABLES.VOUCHER_NO\" class=\"column-title\">Voucher Number</span></div></th><th \nnowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.VOUCHER_DATE\" \nclass=\"column-title\">Voucher Date</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.CREDIT_NOTE_NUMBER\" class=\"column-title\">Credit Note Number\n</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div><span translate=\"PURCHASESPAYABLES.CREDIT_NOTE_DATE\" \nclass=\"column-title\">Credit Note Date</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div><span \ntranslate=\"PURCHASESPAYABLES.INVOICE_NO\" class=\"column-title\">Invoice Number</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_CODE\" \nclass=\"column-title\">Supplier Code</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div>\n</th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.GST_CODE\" class=\"column-title\">\nGST Code</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.AMOUNT\" class=\"column-title\">Amount</span></div></th><th nowrap=\"nowrap\" \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th nowrap=\"nowrap\" class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.REMARKS\" class=\"column-title\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Creditnotedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"Creditnoteinfo(row._id)\" title=\"View/Edit\" style=\"border:none\">{{ row.VoucherNumber }}</a></td><td \nnowrap=\"nowrap\">{{ row.VoucherDate | date:\'dd/MM/y\'}}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber}}</td><td \nnowrap=\"nowrap\">{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ getInvoiceNumber (row.itemDetails) }}</td>\n<td nowrap=\"nowrap\">{{ row.Supplierdetails[0].ReferenceNo }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}\n</td><td>{{ getAccountCode (row.itemDetails) }}</td><td nowrap=\"nowrap\">{{ getGSTCode(row.itemDetails) }}</td><td \nnowrap=\"nowrap\">$ {{ getTotal(row.itemDetails) || 0 |number:2 }}</td><td nowrap=\"nowrap\">{{ row.Description}}</td><td \nnowrap=\"nowrap\">{{ row.Remarks}}</td></tr></tbody></table></div></div></form></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"CreditnoteForm\"><form \nname=\"Creditnoteform\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>\n{{\'PURCHASESPAYABLES.SUPPLIER\'|translate}}</b></label><md-select class=\"Supplierfilter\" ng-model=\"vm.SupplierID\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"searchTerm3\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_SUPPLIER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:searchTerm3\" \nvalue=\"{{row.id}}\">{{row.ReferenceNo}} - {{row.Name}}</md-option></md-select></md-input-container><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">\nSearch</span></md-button></div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"CreditNoteNumber\" \nplaceholder=\"{{\'PURCHASESPAYABLES.CREDIT_NOTE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PURCHASESPAYABLES.CREDIT_NOTE_NUMBER_IS_REQUIRED\">Credit Note Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"PURCHASESPAYABLES.CREDIT_NOTE_DATE\">Credit Note Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Description\" \nplaceholder=\"{{\'PURCHASESPAYABLES.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'PURCHASESPAYABLES.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"PURCHASESPAYABLES.INVOICE_NUMBER\">Invoice Number</label><md-select ng-model=\"DNInvoiceID\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNInvoiceID=undefined\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Purchaseinvoicedatasddf  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"DNAmount\" \nplaceholder=\"{{\'PURCHASESPAYABLES.AMOUNT\'|translate}}\"></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"PURCHASESPAYABLES.ACCOUNTING_CODE\">Accounting Code</label><md-select \nng-model=\"DNAccountID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_A_ACCOUNT..\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNAccountID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row._id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"PURCHASESPAYABLES.GST_CODE\">GST Code</label><md-select \nng-model=\"DNGSTID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PURCHASESPAYABLES.SEARCH_FOR_GST..\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"DNGSTID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">{{row.GSTTaxCode}} - {{row.Description}}\n</md-option></md-select></md-input-container><md-button style=\"margin-top: -6px\" class=\"md-raised md-accent\" \nng-show=\"HideAdd\" ng-click=\"DNItemSubmit()\"><span translate=\"PURCHASESPAYABLES.ADD\">Add</span></md-button><md-button \nstyle=\"margin-top: -6px\" class=\"md-raised md-accent\" ng-show=\"HideSave\" ng-click=\"DNItemUpdate()\"><span \ntranslate=\"PURCHASESPAYABLES.SAVE\">Save</span></md-button><md-button style=\"margin-top: -6px\" \nclass=\"md-raised md-accent\" ng-click=\"ClearDNItems()\"><span translate=\"PURCHASESPAYABLES.CLEAR\">Clear</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PURCHASESPAYABLES.INVOICE_NUMBER\" class=\"column-title\">Invoice Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.AMOUNT\" \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.TAX_AMOUNT\" class=\"column-title\">Tax Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.TOTAL_AMOUNT\" class=\"column-title\">Total Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.ACCOUNT_CODE\" \nclass=\"column-title\">Account Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PURCHASESPAYABLES.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PURCHASESPAYABLES.GST_CODE\" class=\"column-title\">\nGST Code</span></div></th><th class=\"secondary-text\"><div><span translate=\"PURCHASESPAYABLES.EDIT\" \nclass=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in CNItemDetails\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.InvoiceNumber }}</td><td>{{ row.PaidAmount || 0 |number:2 }}\n</td><td>{{ row.TaxAmount || 0 |number:2 }}</td><td>{{ row.Amount || 0 |number:2 }}</td><td>{{ row.AccountCode }}</td>\n<td>{{ row.AccountDescription }}</td><td>{{ row.GSTCode }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"CNItemInfo(row._id)\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" \nlayout-align=\"center\"><md-button style=\"Height: 36px !important\" type=\"button\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveCreditnote()\" aria-label=\"Submit\" \nng-disabled=\"Creditnoteform.$invalid || Creditnoteform.$pristine\">{{\'PURCHASESPAYABLES.SUBMIT\'|translate}}</md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span \ntranslate=\"PURCHASESPAYABLES.CANCEL\">Cancel</span></md-button></div></div></form></div></md-tab-body></md-tab>\n</md-tabs></div></div><style>\n#DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n      }\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  .file-inputs {\r\n    display: none !important;\r\n  }\r\n\r\n  button.md-default-theme.md-accent.md-raised,\r\n  .md-button.md-accent.md-raised {\r\n    margin-bottom: 40px !important;\r\n  }\r\n\r\n  .secondary-text {\r\n    font-size: 15px !important;\r\n  }\r\n\r\n  td.dataTables_empty {\r\n    height: 30px !important;\r\n    text-align: center !important;\r\n  }\r\n\r\n  .dataTables_wrapper {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .md-tab.md-active {\r\n    background-color: #9E9E9E;\r\n  }\n</style><style>\n/* md-datepicker .md-datepicker-input {\r\n        width: calc(23vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } */\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  .hidden {\r\n    display: none!important;\r\n    visibility: hidden!important;\r\n  }\r\n\r\n\r\n  .group-title {\r\n    background-color: #687074 !important;\r\n    color: #FFF !important;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n  .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n  .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n  .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n    border-bottom-color: rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n  .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n  .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n  .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n    border-bottom-color: rgba(0, 0, 0, 0.14);\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 1;\r\n  }\r\n\r\n  #pdate md-datepicker .md-datepicker-input {\r\n    width: calc(23vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: green !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: green !important;\r\n    border-bottom-color: red !important;\r\n  }\r\n\r\n  #Supplierfilter md-select .md-select-value {\r\n    color: green !important;\r\n    border-bottom-color: red !important;\r\n  }\r\n\r\n\r\n  button#button {\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/payment/payment.html","<div id=\"payment\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><span \ntranslate=\"PAYMENT.PAYMENT_VOUCHER\">Payment Voucher</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"pSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'PAYMENT.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"pAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span translate=\"PAYMENT.ADD\">Add</span>\n</md-button><md-button class=\"md-raised reference-button\" ng-show=\"pView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"PAYMENT.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"pExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"PAYMENT.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card\" ng-show=\"Paymentgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Paymentformdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PAYMENT.REFERENCE_NUMBER\" class=\"column-title\">Reference Number</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"PAYMENT.EMPLOYEE_NAME\" class=\"column-title\">Employee Name</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.DATE\" class=\"column-title\">Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.REMARKS\" class=\"column-title\">\nRemarks</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span translate=\"PAYMENT.EDIT_REQUEST\" \nclass=\"column-title\">Edit Request</span></div></th><th class=\"secondary-text\"><div><span translate=\"PAYMENT.REPORT\" \nclass=\"column-title\">Report</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paymentformdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewPaymentinfo(row._id)\" title=\"Detail Grid\" \nstyle=\"border:none\">{{ row.ReferenceNumber }}</a></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Remarks}}</td><td>{{ row.Status }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Paymentinfo(row._id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"content\" \nid=\"invoice\" ng-show=\"Pop\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\"><b>\nPAYMENT VOUCHER REQUEST</b> <img ng-if=\"QRCode\" style=\"height:20%; width:20%;float:right;margin-top:-1%\" \nsrc=\"{{QRCode}}\"></div><br><table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Reference #:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{ReferenceNumber}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Date:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{Date | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Name:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{EmployeeName}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Remarks:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Remarks}}</th></tr></thead><tbody></tbody></table>\n<br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">DESCRIPTION</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">AMOUNT</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">GST</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">NOTES</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">BILL ATTACHED</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Paymentdetailsdatas\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Amount }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">\n{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Notes }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><br><br><br><br><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Received By<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Date Prepared<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Date Received<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Verified/ Issued By</th><th \nstyle=\"border-collapse: collapse;width:700px\">Delivered By</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Paymentform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span \ntranslate=\"CANCEL_REQUEST\">Cancel Request</span></md-button></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div\n class=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" name=\"ReferenceNumber\" ng-model=\"ReferenceNumber\" \nplaceholder=\"{{\'PAYMENT.REFERENCE_NUMBER_#\'|translate}}\" readonly=\"readonly\"></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"PAYMENT.REQUESTED BY\">Requested By</label><md-select \nng-model=\"EmployeeID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"{{\'PAYMENT.SEARCH FOR A REQUESTER\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"EmployeeID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">\n{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label translate=\"PAYMENT.DATE\">Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"Date\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"Remarks\" placeholder=\"{{\'PAYMENT.REMARKS\'|translate}}\"><div ng-messages=\"basicForm.Remarks.$error\" \nng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PAYMENT.REMARKS REQUIRED\">Remarks Required.</span></div></div></md-input-container></div></div></div><br>\n<br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;{{\'PAYMENT.PAYMENT VOUCHER DETAILS\'|translate}}</h1><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Paymentdetailpopup($event, UniqueID, ReferenceNumber)\" style=\"float:right\"><span translate=\"PAYMENT.ADD\">Add\n</span></md-button></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Paymentdetailsdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PAYMENT.CATEGORY\" class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PAYMENT.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.AMOUNT\" class=\"column-title\">Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GST</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.NOTES\" class=\"column-title\">Notes</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.BILL_ATTACHED\" \nclass=\"column-title\">Bill Attached</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"PAYMENT.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"PAYMENT.DELETE\" class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Paymentdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Categorydetails[0].CategoryName }}</td><td>{{ row.Description }}</td><td>{{ row.Amount }}</td><td \nnowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td>{{ row.Notes }}</td>\n<td>{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Paymentdetailupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Paymentdetaildelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><br><br></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"mSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">\n{{\'PAYMENT.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\n{{\'PAYMENT.CANCEL\'|translate}}</md-button></div><h2 style=\"text-align:left\">&nbsp;{{\'PAYMENT.ATTACHMENTS\'|translate}}\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button \nclass=\"md-accent md-raised\"><label translate=\"PAYMENT.BROWSE\" for=\"file-input\" style=\"margin-bottom:0px\">Browse</label>\n<input class=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span translate=\"PAYMENT.UPLOAD\">Upload</span></md-button></div><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PAYMENT.FILE_NAME\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PAYMENT.FILE_SIZE(KB)\">\nFile Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PAYMENT.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"PAYMENT.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Accounts/Payment Voucher/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div><div class=\"content\"></div><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewPaymentform\" flex><form name=\"basicForm2\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"ReferenceNumber#\" \nng-model=\"ReferenceNumber\" placeholder=\"{{\'PAYMENT.REFERENCE_NUMBER_#\'|translate}}\" readonly=\"readonly\">\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label translate=\"PAYMENT.REQUESTED BY\">\nRequested By</label><md-select ng-model=\"EmployeeID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" \nreadonly=\"readonly\"><md-option ng-repeat=\"row in Employeedatas \" value=\"{{row.id}}\" readonly=\"readonly\">\n{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"Date\" ng-model=\"Date | date:\'dd/MM/y\'\" \nplaceholder=\"{{\'PAYMENT.DATE\'|translate}}\" readonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"{{\'PAYMENT.REMARKS\'|translate}}\" readonly=\"readonly\"></md-input-container></div></div></div><br><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;{{\'PAYMENT.PAYMENT VOUCHER DETAILS\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PAYMENT.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.AMOUNT\" class=\"column-title\">Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">GST</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.NOTES\" class=\"column-title\">Notes</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PAYMENT.BILL_ATTACHED\" \nclass=\"column-title\">Bill Attached</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paymentdetailsdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Description }}</td><td>{{ row.Amount }}</td><td \nnowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }} - {{ row.GSTdetails[0].Description }}</td><td>{{ row.Notes }}</td>\n<td>{{ row.BillAttached ? \'Yes\' : \'No\'; }}</td></tr></tbody></table></div><h2 style=\"text-align:left\">\n&nbsp;{{\'PAYMENT.ATTACHMENTS\'|translate}}</h2><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PAYMENT.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PAYMENT.FILE_SIZE(KB)\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PAYMENT.UPLOADED_BY\">Uploaded By\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PAYMENT.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Accounts/Payment Voucher/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div><br><br></form><br></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    \r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    /*md-datepicker .md-datepicker-input {\r\n        min-width: 325px;\r\n    }*/\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    /*.css-serial {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    /* } */\r\n\r\n    .css-serial td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/payment/paymentdetaildelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"PAYMENT.ARE YOU SURE YOU WANT TO DELETE THIS ITEM\" class=\"title\">Are you sure you want to delete this item?\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Pdelete(deleteID)\" \nclass=\"md-raised md-accent\">{{\'PAYMENT.YES\'|translate}}</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">\n{{\'PAYMENT.NO\'|translate}}</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/accounts/payment/paymentdetailpopup.html","<div class=\"content\"><div layout=\"row\" style=\"width:800px\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<span translate=\"PAYMENT.PAYMENT VOUCHER DETAILS\" style=\"color:#617d7b\"><b>Payment Voucher Details</b></span>\n</md-input-container></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"PAYMENT.CATEGORY\">Category</label><md-select ng-model=\"vm.ClaimCategoryID\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"searchTermCC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'PAYMENT.SEARCH FOR A CATEGORY\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.ClaimCategoryID=undefined\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in ClaimCategorydatas  | filter:searchTermCC\" value=\"{{row._id}}\">\n{{row.CategoryName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Description\" ng-model=\"vm.Description\" placeholder=\"{{\'PAYMENT.DESCRIPTION\'|translate}}\" required><div \nng-messages=\"basicForm.Description.$error\" ng-show=\"basicForm.Description.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PAYMENT.DESCRIPTION REQUIRED\">Description Required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" \nname=\"Amount\" ng-model=\"vm.Amount\" placeholder=\"{{\'PAYMENT.AMOUNT\'|translate}}\" required><div \nng-messages=\"basicForm.Amount.$error\" ng-show=\"basicForm.Amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"PAYMENT.AMOUNT REQUIRED\">Amount Required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"PAYMENT.GST_CODE\">GST Code</label><md-select ng-model=\"vm.GSTID\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"searchTermGST\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'PAYMENT.SEARCH FOR A GST\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.GSTID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">{{row.GSTTaxCode}} - {{row.Description}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"Notes\" ng-model=\"vm.Notes\" placeholder=\"{{\'PAYMENT.NOTES\'|translate}}\"></md-input-container>\n</div><md-input-container flex style=\"margin-top:5px\"><md-checkbox ng-model=\"vm.BillAttached.value\" type=\"checkbox\">\n{{\'PAYMENT.BILL_ATTACHED\'|translate}}</md-checkbox></md-input-container></div></form><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"PaymentdetailAdd()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">{{\'PAYMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'PAYMENT.CANCEL\'|translate}}</md-button></div></div></div></div><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/collectpayment.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Collect Payment</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span>Last Month\n</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span>Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span>Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span>Next Week</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\" NextMonth()\"><span>Next Month</span></md-button><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>Customer</b></label><md-select \nclass=\"Supplierfilter\" ng-model=\"vm.CustomerID\" id=\"searchmodule\" required ng-change=\"InvoicefilterByCustomer()\">\n<md-select-header><input ng-model=\"searchTermc\" type=\"text\" placeholder=\"Search for a customer..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc\" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoicefilterByCustomer()\"><span>Search</span></md-button></div></div><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SALESRECEIVABLES.INVOICE_NUMBER\">Invoice Number</label><md-select ng-model=\"vm.InvoiceID\" \nng-model-options=\"{trackBy: \'$value._id\'}\" ng-change=\"OnInvoiceChange()\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-select-header><b>\n{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}} - {{\'SALESRECEIVABLES.INVOICE_DATE\'|translate}}</b></md-select-header>\n<md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Salesinvoicedatasdd | filter:{CustomerID :vm.CustomerID}  | filter:vm.searchTerm1\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" class=\"pdate\" \nng-model=\"vm.VoucherDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SALESRECEIVABLES.ACCOUNTING_CODE\">Accounting Code</label><md-select \nng-model=\"vm.AccountID\" id=\"searchmodule\" required><md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm \" value=\"{{row.id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Amount Paid\" ng-model=\"vm.Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SALESRECEIVABLES.BANK_NAME\">Bank Name</label><md-select \nng-model=\"vm.BankID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTermb\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH FOR A BANK\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Bankdatas | filter:vm.searchTermb\" value=\"{{row.id}}\">{{row.BankName}}\n</md-option></md-select></md-input-container><md-input-container flex><input \ntranslate=\"SALESRECEIVABLES.CHEQUE_NUMBER\" type=\"text\" ng-model=\"vm.ChequeNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.CHEQUE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.COLLECTION_DATE\">Collection Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveCollectPayment()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n        width: 160px\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/creditnote.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.CREDIT_NOT\" class=\"title\">Credit Note</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Invoice No\" ng-model=\"InvoiceNo\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"basicForm.InvoiceNo.$error\" \nng-show=\"basicForm.InvoiceNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO_FIELD_IS_REQUIRED\">Invoice No field is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"DisposalDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Invoice Amount\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_AMOUNT\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_AMOUNT_FIELD_IS_REQUIRED\">Invoice Amount field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Credit Note Amount\" ng-model=\"Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Credit Note No\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\">\n</md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/invoice.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE\" class=\"title\">Invoice</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Contract No\" \nng-model=\"ContractNo\" placeholder=\"{{\'SALESRECEIVABLE.CONTRACT NO\'|translate}}\" required><div \nng-messages=\"basicForm.ContractNo.$error\" ng-show=\"basicForm.ContractNo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Contract No field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Service Report No\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.SERVICE_REPORT_NO\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO_FIELD_IS_REQUIRED\">Service Report No field is required.</span></div>\n</div></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.DATE\">\nDate</label><md-datepicker onkeydown=\"return false\" ng-model=\"DisposalDate\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Description\" \nng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Amount\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button>\n<md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/newsalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" ng-mode=\"SearchValue\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ExporttoXero()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export to Xero</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Contractsgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"contractdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"ContractgridContainer\" \ndx-data-grid=\"vm.dataGridContract\"><div class=\"SchedulerLabels\" data-options=\"dxTemplate:{ name:\'totalGroupCount\' }\">\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"width: fit-content !important\"><md-checkbox-container flex><md-checkbox \nng-model=\"uShowClosed\" ng-change=\"ShowClosed(uShowClosed)\" type=\"checkbox\"><b>Show Exported Invoices</b></md-checkbox>\n</md-checkbox-container></div></div></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label><b>\n{{\'SALESRECEIVABLES.CONTRACT\'|translate}}</b></label><md-select ng-model=\"ConID\" id=\"searchmodule\" \nng-change=\"OnConChange()\"><md-select-header><input force-select-focus ng-model=\"searchTerm32\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_CONTRACT\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ConID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in contractdatas |filter:{Customer_id:CustomerID}| filter:searchTerm32\" value=\"{{row._id}}\">\n{{row.ContractReferenceNo}} - {{row.customerdetails[0].CompanyName}}</md-option></md-select></md-input-container></div>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select ng-model=\"WorkOrderID\" id=\"searchmodule\" required>\n<md-select-header><input force-select-focus ng-model=\"searchTermw\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/osalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.ACCOUNTS RECEIVABLES\">Accounts Receivables</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"search\" class=\"search-input\" type=\"text\" ng-mode=\"SearchValue\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CollectPaymentExport()\" \nng-show=\"CollectPaymentSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteExport()\" ng-show=\"CreditnoteGrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"DebitnoteExport()\" ng-show=\"DebitnoteSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CustomerStatementExport()\" \nng-show=\"CustomerStatementSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteShowgrid()\" ng-show=\"CreditnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridDebit()\" ng-show=\"DebitnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridCollectPayment()\" \nng-show=\"CollectPaymentFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab ng-click=\"InvoiceTab()\"><md-tab-label><span translate=\"SALESRECEIVABLES.INVOICE\">Invoice\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" \nng-show=\"InvoiceGrid\"><form name=\"organizationform1\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"SALESRECEIVABLES.LAST_MONTH\">\nLast Month</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"SALESRECEIVABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"SALESRECEIVABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"SALESRECEIVABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"SALESRECEIVABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"SALESRECEIVABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"SALESRECEIVABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"SALESRECEIVABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" id=\"MainWrap\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Salesinvoicedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SALESRECEIVABLES.PRINT\" class=\"column-title\">Print</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_NO\" class=\"column-title\">Voucher No</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_DATE\" class=\"column-title\">\nVoucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO\" class=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_DATE\" class=\"column-title\">Invoice Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SITE_ADDRESS\" class=\"column-title\">Site Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.AGENT_NAME\" class=\"column-title\">\nAgent Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.WORKORDER\" class=\"column-title\">WorkOrder</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.SALES_AMOUNT\" \nclass=\"column-title\">Sales Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.GST_AMOUNT\" class=\"column-title\">GST Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">OutStanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.GST_CODE\" class=\"column-title\">GST Code</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_TERM\" \nclass=\"column-title\">Credit Term</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DUE_DATE\" class=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_NOTE_NUMBER\" class=\"column-title\">Credit Note Number\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DEBIT_NOTE_NUMBER\" class=\"column-title\">Debit Note Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.REMARKS\" class=\"column-title\">\nRemarks</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Salesinvoicedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><md-button \nclass=\"md-flat md-icon-button reference-button\" id=\"target\" aria-label=\"Custom Icon Button\" \nng-click=\"Printsalesinvoice(\'salesinvoice\', row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td>\n<td nowrap=\"nowrap\"><a href=\"\" ng-click=\"SalesInvoiceInfo(row._id,$index)\" title=\"View/Edit\" style=\"border:none\">\n{{ row.VoucherNumber }}</a></td><td>{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">\n{{ row.InvoiceNumber }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Status }}</td><td \nnowrap=\"nowrap\">{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CompanyName }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].BLK }} {{ row.Customerdetails[0].StreetName }} {{ row.Customerdetails[0].Unit }} {{ row.Customerdetails[0].BuildingName }} {{ row.Customerdetails[0].Country }} {{ row.Customerdetails[0].Postal }}\n</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].ContactPerson }}</td><td nowrap=\"nowrap\">\n{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td nowrap=\"nowrap\">\n$ {{ row.Amount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.GSTAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">\n{{ row.Invoicecomment[0].Description }} {{ row.Invoicecomment[1].Description }} {{ row.Invoicecomment[2].Description }} {{ row.Invoicecomment[3].Description }} {{ row.Invoicecomment[4].Description }}\n</td><td nowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }}</td><td nowrap=\"nowrap\">{{ row.CreditTerm }}</td><td>\n{{ row.DueDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber }}</td><td nowrap=\"nowrap\">\n{{ row.DebitNoteNumber }}</td><td nowrap=\"nowrap\">{{ row.Remarks }}</td></tr></tbody></table></div></div></form></div>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form \nname=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select \nng-model=\"WorkOrderID\" id=\"searchmodule\" required><md-select-header><input force-select-focus ng-model=\"searchTermw\" \ntype=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/salesreceivables/salesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div><div class=\"product-count secondary-text\"><span>Total Invoice:</span> <span>{{Salesinvoicedatas.length}}\n</span></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"InvoiceExport()\" \nng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\" ng-show=\"InvoiceGrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 5%\"><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"lastmonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nLast Month</a></div><div style=\"padding:0 1% 0 1%\"><a ng-click=\"lastweek()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Week</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"Today()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today</a></div></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container flex=\"1\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"InvoiceFilterByDate()\"><span>Search</span></md-button></div><br><div id=\"ContractgridContainer\" \ndx-data-grid=\"vm.dataGridContract\"></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" readonly=\"readonly\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input \ntype=\"text\" ng-model=\"CustomerName\" placeholder=\"Customer Name\" readonly=\"readonly\" required></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input type=\"text\" ng-model=\"WorkOrderNo\" \nplaceholder=\"Work Order No\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Invoice Amount\" ng-model=\"Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"pdate\" ng-model=\"DueDate\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ssubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button></div><div\n class=\"white-bg md-whiteframe-4dp\"><b><h3 style=\"margin: 2px;font-weight: bold\">SERVICE DESCRIPTION</h3></b><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup( row.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" layout-align=\"center\">\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">\nCancel</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/salesorder/AddTreatmentFrequency.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required \nng-disabled=\"PestUpdate\"><md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Frequency..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" \nng-click=\"calculateServices(row.Name,vm.JobsPerFrequency)\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"PestUpdate==false\"><label>Pest Types</label><md-select \nng-model=\"vm.SelectPest\" name=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required \nng-disabled=\"PestUpdate\"><md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"PestUpdate==true\"><input type=\"text\" name=\"Pesttype\" \nng-model=\"vm.EPesttype\" placeholder=\"Pest Types\" ng-disabled=\"PestUpdate==true\"></md-input-container></div><div \nstyle=\"width: 100%\"><span style=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" \nng-if=\"Treatmentpopupdata.length > 0\"><u>Treatment Methods:</u></span></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex ng-if=\"Treatmentpopupdata.length > 0\" ng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n    li:first-letter {\r\n    text-transform:capitalize;\r\n}\n</style>");
$templateCache.put("app/main/apps/accounts/salesorder/Service.html","<md-dialog ng-style=\"{width:vm.sty + \'%\'}\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0 2% 0 2%\"><div ng-show=\"Service\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-checkbox \nng-model=\"Servicecopy.value\" ng-change=\"copymain(this)\" type=\"checkbox\"><span>Copy from main address?</span>\n</md-checkbox><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0;flex: 0.5\">\n<input type=\"text\" ng-model=\"vm.usName\" placeholder=\"Name\"></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \non-place-changed=\"placeChanged1()\" ng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nng-model=\"vm.usContactPerson\" placeholder=\"Site Contact Person\"></md-input-container><md-chips \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" name=\"sContactNum\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" name=\"sContactNum\" \nplaceholder=\"Contact Number\"></md-chips></div><p style=\"margin-left: 35%;margin-top: -23px !important\" \nclass=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.ZoneCC\" placeholder=\"Email\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips \nng-model=\"vm.ZoneEmail\" placeholder=\"CC\" readonly=\"vm.readonly\" style=\"width: 100%;padding:0!important\"></md-chips>\n</div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">Type CC and Press Enter</span><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Serviceadd(vm.Index);ClearGrid();\" \nng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div>\n</form></div><div ng-show=\"Billing\"><form name=\"BillingForm\" class=\"md-inline-form\" novalidate><md-checkbox-container \nflex><md-checkbox ng-model=\"checkboxModel.value\" ng-change=\"copybilling(this)\" type=\"checkbox\"><span \ntranslate=\"CRMCUSTOMER.COPY_FROM_MAIN_ADDRESS\">Copy from main address?</span></md-checkbox></md-checkbox-container><div\n layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubContactPerson\" \nplaceholder=\"{{ \'CRMCUSTOMER.CONTACT_PERSON\' | translate }}\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.ubMobile\" placeholder=\"{{ \'CRMCUSTOMER.MOBILE\' | translate }}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubEmail\" \nplaceholder=\"{{ \'CRMCUSTOMER.EMAIL\' | translate }}\"></md-input-container><md-input-container flex><label>Address\n</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged2()\" ng-model=\"vm.ubStreetName\" \nplaceholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ubBuildingName\" placeholder=\"{{ \'CRMCUSTOMER.BUILDING_NAME\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.ubPostal\" \nplaceholder=\"{{ \'CRMCUSTOMER.POSTAL_CODE\' | translate }}\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Billingadd(vm.Index)\" \nng-disabled=\"BillingForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div></form></div>\n</md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n  .ms-scroll{\r\n    position: relative;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/salesorder/addcustomer.html","<md-dialog style=\"width:100%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CREATE_CUSTOMER\">\nCreate Customer</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><div layout=\"row\"><ms-form-wizard flex>\n<md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"false\"><md-tab><md-tab-label><span \nng-if=\"wizardStep1.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Customer Details</span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"CompanyName\" \nng-model=\"vm.uCompanyName\" placeholder=\"Company Name\" required><div ng-messages=\"wizardStep1.CompanyName.$error\" \nng-show=\"wizardStep1.CompanyName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div><p ng-show=\"error1\" style=\"color:red\">Company Name Is already Exist.</p></md-input-container>\n<md-input-container flex><label>Market Segment</label><md-select ng-model=\"vm.MarketSection\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermC = \'\'\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" multiple=\"\"><md-select-header>\n<input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.MarketSection = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">\n{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><label>Salutation</label><md-select ng-model=\"vm.uSalutation\" required><md-option value=\"Mr\">\nMr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Mdm\">Mdm</md-option><md-option value=\"Ms\">Ms\n</md-option><md-option value=\"Mr\">Dr</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"FirstName\" ng-model=\"vm.uFirstName\" placeholder=\"Name\" required><div \nng-messages=\"wizardStep1.FirstName.$error\" ng-show=\"wizardStep1.FirstName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Full Name is required.</span></div></div></md-input-container><md-input-container \nid=\"date4\" flex><label style=\"margin-left: -10px\">Follow-up Date</label><md-datepicker \nng-model=\"vm.ProspectFollowupDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Address</label><input places-auto-complete \ntypes=\"[\'geocode\']\" on-place-changed=\"placeChanged()\" ng-model=\"vm.StreetName\" placeholder=\"\" required>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"BuildingName\" ng-model=\"vm.BuildingName\" \nplaceholder=\"Building Name\"></md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" \nng-model=\"vm.uPostal\" placeholder=\"Postal Code\" required><div ng-messages=\"wizardStep1.PostalCode.$error\" \nng-show=\"wizardStep1.PostalCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Postal Code is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.uEmail\" \nplaceholder=\"Email\" ng-init=\"vm.uEmail=[]\" style=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h5\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-chips style=\"width: 68% !important ; height: 13% !important\" ng-model=\"vm.uMobile\" ng-init=\"vm.uMobile=[]\" \nname=\"ContactNum\" md-separator-keys=\"vm.keys\" md-max-chips=\"5\" input-aria-label=\"ContactNum\"><input type=\"number\" \nname=\"ContactNum\" placeholder=\"Contact Number\"></md-chips><md-input-container id=\"date4\" flex><label \nstyle=\"margin-left: -10px\">Current Contract End Date</label><md-datepicker ng-model=\"vm.ConEndDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><p \nstyle=\"float: left; margin-top:-33px !important\" class=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 5 Contact Numbers are allowed.</p></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\">\n</span> <span class=\"ms-form-wizard-step-text\">Billing & Service Address</span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div \nstyle=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div><div \nlayout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID, \'Billing\')\"><span>Add</span></md-button>\n</div></div><div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div\n style=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div layout=\"row\" \nstyle=\"padding-bottom:0.5%\"><div flex><div ng-show=\"SAdiv\" flex style=\"padding-left:40%\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Service Address Selected: {{SelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforUpdateEmail($event)\"><span>\nUPDATE EMAILID</span></md-button></div></div><div><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><span>Add</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" \ndx-data-grid=\"vm.dataGridCustomerService\"></div></div><br></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"padding: 0\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"customerSubmit()\" ng-disabled=\"msWizard.currentStepInvalid()\" \ntranslate=\"CRMLEAD.SUBMIT\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></ms-form-wizard></div></md-dialog-content></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n    width: calc(20vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .dataTables_wrapper .dataTables_filter {\r\n    float: right !important;\r\n  }\r\n\r\n  div.dataTables_filter input {\r\n    width: 30em !important;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  .md-tab.md-active {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n    background-color: #83878a !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\r\n    border-bottom-color: #606a71;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n    border-left-color: #606a71 !important;\r\n    border-right-color: #606a71 !important;\r\n  }\r\n\r\n  .dx-button {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  .dx-button-has-icon .dx-button-content {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n    color: #535858 !important;\r\n    font-weight: bold !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/salesorder/cspopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMLEAD.DELETE_THIS_ADDRESS?\">Delete this Address?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Servicedelete(vm.deleteID)\" \nclass=\"md-raised md-accent\" translate=\"CRMLEAD.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.NO\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/accounts/salesorder/saleorder.html","<div id=\"salesOrder\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>\nTreatment Instructions</span></div><div class=\"product-count secondary-text\"><span>Total Treatment Instructions:</span>\n <span>{{workOrd.length}}</span></div></div><div><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" \nng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"CRMSALESORDER.BACK\">Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"CRMSALESORDER.EXPORT\">Export</span></md-button></div>\n</div><div class=\"content\" ng-show=\"Salesgrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" \nmd-selected=\"selectedIndex\"><md-tab ng-click=\"workOrd=salesOrderdatas\"><md-tab-label><span>Contract</span>\n</md-tab-label><md-tab-body><div id=\"PendingContainer\" dx-data-grid=\"vm.dataGridSales\"></div></md-tab-body></md-tab>\n<md-tab ng-click=\"workOrd=AdhocsalesOrderdatas\"><md-tab-label><span>Ad-hoc</span></md-tab-label><md-tab-body><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridAdhoc\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=DeletedSalesOrderdatas; getDeletedWO()\"><md-tab-label><span>Deleted Work Orders</span></md-tab-label>\n<md-tab-body><div id=\"DeletedWO\" dx-data-grid=\"vm.dataGridWorkOrder\"></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Salesform\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"column\">\n<div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Order Type</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color: #7f9593\">&nbsp;{{vm.OrderType}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">VIP ?</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.IsUrgent ? \'Yes\' : \'No\'}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Trending Reports?</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.TrendingReport ? \'Yes\' :\'No\'}}</span></div><div class=\"p-4\" \nstyle=\"width:13%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Occurence</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Occurence}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Salesperson</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.EmployeeName}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact #</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.SiteContactNo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.BContactPerson}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Billing Address</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.BAddress}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Address</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.sStreet}} Singapore {{vm.sPostal}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Email</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.BEmail}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Billing Frequency</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.BillingFrequency}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Term</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PaymentMode}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Total Price</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.TotalPrice}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Start Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartDate | date :\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service End Date</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceEndDate| date :\"dd/MM/yyyy\" }}\n</span></div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">\nEstimated Man Hours Needed</label></div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.EstimatedHoursRequired}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\">\n<div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Coverage Area</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.CoverageArea}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Message to Operation\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Message}}</span></div></div>\n</div></div></div></div><div><br><span class=\"h3\" style=\"color:#7f9593\"><b>TREATMENT FREQUENCY :</b></span></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin-top:10px\"><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Methods</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">No of Job/Frequency</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Total Services Required</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}</td><td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td>\n{{ row.JobsPerFrequency }}</td><td>{{ row.ServicesRequired }}</td></tr></tbody></table></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49%;border:1px solid rgb(224, 224, 224);float:left;height:30%\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments</label></div>\n</div><div style=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in Commentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y HH:mm:ss\'}}</h3><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49%;border:1px solid rgb(224, 224, 224);float:right;margin-left:20px\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\" \ntranslate=\"CRMLEAD.ATTACHMENTS\">Attachments :</label></div></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>{{$index+1}}&nbsp;</td><td><a \nng-href=\"{{UploadsURL}}{{ row.ModuleID | removeUploadsPath }}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td></tr>\n</tbody></table></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"CRMSALESORDER.CANCEL\">Cancel</md-button></div></form>\n</div></div></div></div><style>\n@media only screen and (max-width: 2200px) {\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(4.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1600px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(19.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(3.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1150px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(1.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(2.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(21.3vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #date5 md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 30px) !important;\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    /* #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    } */\r\n\r\n    .dtp div.dtp-picker {\r\n        padding: 12px 12px 12px 12px !important;\r\n        overflow: unset !important;\r\n    }\r\n\r\n    .md-inline-form md-radio-group {\r\n        margin: 31px 0 0 9px;\r\n    }\r\n\r\n    .dx-switch-handle:before {\r\n        background-color: #039be5de !important;\r\n    }\r\n\r\n    /* .dx-switch-on, .dx-switch-off {\r\n    float: left;\r\n    flex-shrink: 0;\r\n    width: 50%;\r\n    padding-right: 16px;\r\n    line-height: 22px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    overflow: hidden;\r\n    -o-text-overflow: ellipsis;\r\n    -ms-text-overflow: ellipsis;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n.dx-switch-container {\r\n    overflow: hidden;\r\n    margin: 0 -6px 0 0;\r\n    padding: 0 2px;\r\n    height: 29px;\r\n    border: 1px solid #dee1e3;\r\n    background: #fff;\r\n    -webkit-border-radius: 0px;\r\n    -moz-border-radius: 0px;\r\n    -ms-border-radius: 0px;\r\n    -o-border-radius: 0px;\r\n    border-radius: 7px;\r\n    width: 60px;\r\n}\r\n.dx-switch-handle {\r\n    position: relative;\r\n    float: left;\r\n    flex-basis: 14px;\r\n    flex-shrink: 0;\r\n    width: 14px;\r\n    height: 21px;\r\n    margin-top: 2px;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n} */\n</style>");
$templateCache.put("app/main/apps/accounts/scheduler/addcoments.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Service Job Preview ({{vm.ServiceID}})</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract #</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ContractReferenceNo}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Contact Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteCcontactName}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Contact Number</label></div>:<div\n class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteContactNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Email</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteEmail}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Start Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">End Time\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.ServiceEndAt | date:\"hh:mm a\"}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PestType1}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.JobType}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service On</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceOn}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Special Remarks</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SpecialRemark}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Type</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Types}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Present</label></div><div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.CustomerPresent}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Preferred Days</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PreferredTime}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Preference Time</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.PreferredStartTime | date : \"hh:mm a\"}} - {{vm.PreferredEndTime | date : \"hh:mm a\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Avoid Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.AvoidStartTime | date : \"hh:mm a\"}} - {{vm.AvoidEndTime | date : \"hh:mm a\"}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Time</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"hh:mm:ss a\"}}\n</span> &emsp;<a href=\"\" style=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" \nng-click=\"Showlocation($event , vm.StartLocation)\">Show Location</a></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual End Time</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.AServiceEndAt | date:\"hh:mm:ss a\"}}</span> &emsp;<a href=\"\" \nstyle=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" ng-click=\"Showlocation($event ,vm.EndLocation)\">Show Location\n</a></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed To</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;width:25%\">&nbsp;{{vm.EmailSentTo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed Date</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.EmailSentDate | date:\"dd/MM/y hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Remarks\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PaymentRemarks}}</span></div>\n</div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Performed By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgressedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedDate | date:\"dd/MM/y hh:mm a\"}}</span></div></div></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:39.5%;border:1px solid rgb(224, 224, 224);float:right\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">\nRemarks for {{vm.ServiceID}}:</label><label style=\"font-size:14px\">{{vm.Remarks}}</label></div></div><div \nstyle=\"background-color:whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><p>{{ vm.ssRemark }}</p></div></md-list-item></md-list></div></div></div>\n</div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Mobile Logs</span></md-tab-label><md-tab-body><div\n layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;height:auto;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><label style=\"width:16%;font-weight:bold;color:#7f9593\">Services:</label><table\n id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Chemical</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Dilution</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in MultiFrequencydatas\"><td>\n&nbsp;</td><td>{{ row.Frequency }}</td><td>{{ row.PestType }}</td><td>{{ row.TreatmentMethod }}</td><td>\n{{ row.Chemical }}</td><td>{{ row.Dilution }}</td></tr></tbody></table></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><label style=\"width:16%;font-weight:bold;color:#7f9593\">Infestation Level:\n</label><table id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nInfestation Level</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialsdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.Infestation }}</td></tr></tbody></table></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"column\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in Photosdatas\" ng-switch \non=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" ng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <span>\n{{row.Remarks}}</span></div></div><br><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:12%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Details</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Mode</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentMode}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Amount Received</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.AmountReceived}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Name of Bank</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.BankName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Cheque No.</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.ChequeNo}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Remarks</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Details</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Email ID</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.MobilEmailId}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Ratings</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Attitude</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Attitude >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 2\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 3\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 4\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 5\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Attitude == null || vm.Attitude == undefined || vm.Attitude == 0 || vm.Attitude == \'\'\" style=\"height: 30px\" \nstar-rating rating=\"vm.Attitude\" read-only=\"true\" max-rating=\"5\"></div></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Appearance of Technician</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Appearance >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Appearance == null || vm.Appearance == undefined || vm.Appearance == 0 || vm.Appearance == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.Appearance\" read-only=\"true\" max-rating=\"5\"></div></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Quality</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.ServiceQuality >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.ServiceQuality == null || vm.ServiceQuality == undefined || vm.ServiceQuality == 0 || vm.ServiceQuality == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.ServiceQuality\" read-only=\"true\" max-rating=\"5\"></div></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Punctuality</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Punctuality >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Punctuality == null || vm.Punctuality == undefined || vm.Punctuality == 0 || vm.Punctuality == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.Punctuality\" read-only=\"true\" max-rating=\"5\"></div></div></div><br><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Feedback</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CustomerRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:15%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Csutomer Signature :</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:200px; width:40%; border:1px solid rgba(0, 0, 0, 0.12)\"><img \ndata-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" style=\"height:200px\" ng-if=\"CustomerSignature\" alt=\"\"></div>\n</div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Comments</span></md-tab-label>\n<md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Addcomments\" placeholder=\"Comment Here..\"></md-input-container></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.CommentedBy }} @ {{ item.CreatedDate | date:\'dd/MM/y hh:mm a\'}}</h3><p>{{ item.cmt }}</p></div></md-list-item>\n</md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding></md-content><table id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"font-size:smaller\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>&nbsp;</td><td><a href=\"{{UploadsURL}}Operations/Scheduler/{{row.TableID}}\" \ndownload style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td></tr></tbody></table></div></div></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Logs</span></md-tab-label><md-tab-body><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Scheduled Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Scheduled<br>\nStart Time | End Time</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Rescheduled Date\n</span></div></th><th ng-hide=\"row.ScheduledStartsat == \'\'\" class=\"secondary-text\"><div><span class=\"column-title\">\n&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div></th><th ng-hide=\"row.ScheduledStartsat != \'\'\" \nclass=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDate & Time</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in SchedulerLogdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ShowType(row.CancelRemarks,row.ResheduleRemarks) }}</td><td>\n{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'hh:mm a\'}} | {{row.Endsat | date:\'hh:mm a\'}}</td><td>\n{{row.ScheduledStartsat | date:\'dd/MM/y\'}}</td><td ng-hide=\"row.ScheduledStartsat == \'\'\">\n{{row.ScheduledStartsat | date:\'hh:mm a\'}} | {{row.ScheduledEndsat | date:\'hh:mm a\'}}</td><td \nng-hide=\"row.ScheduledStartsat != \'\'\"></td><td>{{row.CancelRemarks || row.ResheduleRemarks}}</td><td>{{row.CreatedBy }}\n</td><td>{{row.CreateDate | date:\'dd/MM/y hh:mm a\'}}</td></tr></tbody></table></md-tab-body></md-tab><md-tab \nng-if=\"vm.Status == \'Completed\'\"><md-tab-label><span>Service Report</span></md-tab-label><md-tab-body><div \nlayout=\"column\"><div layout=\"row\" flex style=\"margin-top: 15px;margin-bottom: -10px\"><div layout=\"column\" \nstyle=\"text-align:left\" flex ng-if=\"vm.IsUrgent\"><label \nstyle=\"font-size:15px;margin-left: 5%;font-weight:bold;color: rgb(3,155,229)\">\nService Report Status - {{vm.ServiceReportStatus}}<md-button class=\"md-raised md-accent md-button md-ink-ripple\" \nng-if=\"vm.ServiceReportStatus == \'Pending\'\" ng-click=\"updateServiceReportStatus()\"><span>Approve & Send Email</span>\n</md-button></label></div><div layout=\"column\" style=\"text-align:right\" flex><label \nstyle=\"font-size:15px;margin-right: 5%;font-weight:bold;color: rgb(3,155,229)\">Print Report - <a \nng-click=\"printServiceWeb(\'Service\')\" style=\"cursor:pointer;font-size:15px;font-weight:bold\">PDF</a></label></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"content\" id=\"Service\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img ng-src=\"{{logo}}\"></div></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>SERVICE REPORT</b></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Date</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px;color:blue\">&emsp;{{vm.ServiceStartAt | date:\'dd/MM/y\'}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Time In</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ServiceStartAt | date:\'hh:mm a\'}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Team</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Time In\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeIn | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Company Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Time Out\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeOut | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ContactPerson}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&emsp;{{vm.JobType}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nstyle=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div><div \nstyle=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex style=\"padding:1%\"><label \nstyle=\"width:16%;font-weight:bold;color:#7f9593\">Services:</label><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Chemical</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Dilution</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in MultiFrequencydatas\"><td>&nbsp;</td><td>{{ row.PestType }}</td><td>{{ row.TreatmentMethod }}</td><td>\n{{ row.Chemical }}</td><td>{{ row.Dilution }}</td></tr></tbody></table></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><div style=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\" \nstyle=\"color:#7f9593\"><b>Infestation Level :</b></span></div><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nInfestation Level</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialsdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.InvestationLevel }}</td></tr></tbody></table></div><div style=\"padding:1% 1% 0 1%\">\n<div style=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div><div \nstyle=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div><div layout-gt-sm=\"column\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in Photosdatas\" ng-switch \non=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" ng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <span>\n{{row.Remarks}}</span></div></div><br><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\"><div style=\"width:58%;float:left\"><label \nstyle=\"width:21%;font-weight:bold;color:#7f9593\">Prepared By</label></div><div style=\"width:32.5%;float:right\"><label \nstyle=\"width:35%;font-weight:bold;color:#7f9593\">Customer</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&emsp;{{vm.TeamLead}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:8%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Co-technicians</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamMember}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:8%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Signature\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><img style=\"height: 70px;width: 100%\" \ndata-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" ng-if=\"CustomerSignature\" alt=\"\"></div></div></div></div>\n</div></div></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n  .chipsdemoContactChips md-content.autocomplete input {\r\n    min-width: 400px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected h3 {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text {\r\n    padding: 14px 0;\r\n    max-width: 190px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n    line-height: 1.2em !important;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n  .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon,\r\n  md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n  }\r\n\r\n  .star {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .filled {\r\n    color: #fd0;\r\n  }\r\n\r\n\r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/scheduler/scheduler.html","<div id=\"shedular\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span>Scheduler</span></div><div \nclass=\"product-count secondary-text\" ng-init=\"vm.TabTitle = \'PendingSchedule\';getPendingSchedule() \"><span>\nTotal Records :</span> <span ng-if=\"vm.TabTitle == \'To be Started\'\">{{YettoStartdatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'On-Hold\'\">{{OnHolddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'In-Progress\'\">\n{{MobileInProgressdatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Outstanding\'\">{{InProgressdatas.length}}</span> \n<span ng-if=\"vm.TabTitle == \'Completed\'\">{{Completeddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Cancelled\'\">\n{{Cancelleddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Ad-hoc\'\">{{AdhocJobsdatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'PendingSchedule\'\">{{PendingScheduledatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'ScheduledWorkOrder\'\">{{ScheduledWorkOrderdatas.length}}</span></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"FoggingList($event)\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nFogging List</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" \nng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div class=\"row\"><div \nclass=\"col-md-12 text-center\"></div></div><br><div layout=\"column\" layout-gt-xs=\"row\"><div style=\"padding:0 1% 0 1%\"><a\n ng-click=\"lastmonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Month</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"lastweek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nLast Week</a></div><div style=\"padding:0 1% 0 1%\"><a ng-click=\"Today()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"NextWeek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Next Week</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"NextMonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nNext Month</a></div></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container style=\"flex:  0.25\" flex><label>Search Customer\n</label><md-select ng-model=\"SelectedCustomerID\" md-on-close=\"vm.searchTermC = \'\'\"><md-select-header><input \nstyle=\"flex: auto\" ng-model=\"vm.searchTermC\" type=\"text\" placeholder=\"Search For a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"SelectedCustomerID = undefined\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CustomerSearchdatas | filter:vm.searchTermC\" \nng-click=\"uFrom=\'\' ; uTo=\'\'\" ng-value=\"row.id\">{{row.CompanyName}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"1\"><label>From</label><md-datepicker onkeydown=\"return false\" ng-model=\"uFrom\">\n</md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"NewGetByStatus(vm.filterteam)\"><span>Search</span></md-button></div><md-tabs md-dynamic-height \nmd-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab \nng-click=\"vm.SelectedTab = \'PendingSchedule\';getPendingSchedule();vm.TabTitle = \'PendingSchedule\';vm.JobCount = PendingScheduledatas.length;\">\n<md-tab-label><span>Pending Schedule</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PendingSchedulespinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PendingContainer\" dx-data-grid=\"vm.PendingSchedulerdataGrid\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Yet to Start\';DeleteMarkers();NewGetByStatus(\'Yet to Start\');vm.TabTitle = \'To be Started\';\">\n<md-tab-label><span>TO BE STARTED</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridYTS\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'On-Hold\';vm.TabTitle = \'On-Hold\'; getOnHoldWorkOrder();vm.JobCount = OnHolddatas.length;\">\n<md-tab-label><span>On-Hold</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.OnholdPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"OnHoldContainer\" dx-data-grid=\"vm.dataGridOnHold\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'In-Progress\';getAllInProgress();vm.TabTitle = \'In-Progress\';vm.JobCount = MobileInProgressdatas.length;\">\n<md-tab-label><span>In-Progress</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.InProgressPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"INPContainer\" dx-data-grid=\"vm.dataGridINP\"></div><div flex \nstyle=\"width:99%;padding-left:2%; padding-bottom: 15px\"><span style=\"font-size:15px;color:#7f9593\"><b>Note&nbsp;:</b> \n</span><span style=\"font-size:14px;font-style:italic\">This list is NOT filtered by any search parameters.</span></div>\n</md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Outstanding\';getOutsatnding();vm.TabTitle = \'Outstanding\';vm.JobCount = InProgressdatas.length;\">\n<md-tab-label><span>Outstanding</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.OutstandingPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"OTSContainer\" dx-data-grid=\"vm.dataGridOTS\"></div><div flex style=\"width:99%;padding-left:2%;padding-bottom: 15px\">\n</div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Completed\';DeleteMarkers();NewGetByStatus(\'Completed\',vm.filtercustomer, vm.filterteam);vm.TabTitle = \'Completed\';vm.JobCount = Completeddatas.length;\">\n<md-tab-label><span>Completed</span></md-tab-label><md-tab-body><div \nstyle=\"padding:10px 0% 0px 24px;float:left;width: 100%;margin-bottom:5px\"><a ng-if=\"TRCCdiv\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:5%\">\nTotal Services Selected: {{CompletedSelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple\" ng-if=\"TRCCdiv\" ng-click=\"ConfirmDownloadforCompletedJob($event)\">\n<span>Download Reports</span></md-button><md-button id=\"button\" \nstyle=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \ntitle=\"Download History\" ng-click=\"ShowDownloadedHistory($event)\"><span>Download History</span></md-button></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"CMPContainer\" dx-data-grid=\"vm.dataGridCMP\"></div></md-tab-body></md-tab><md-tab \nng-click=\"DeleteMarkers();vm.SelectedTab = \'Pending Approval\';NewGetByStatus(\'Pending Approval\',vm.filtercustomer, vm.filterteam);vm.TabTitle = \'Pending Approval\';vm.JobCount = PendingApprovaldatas.length;\">\n<md-tab-label><span>Pending Approval</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PASRContainer\" dx-data-grid=\"vm.dataGridPASR\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'ScheduledWorkOrder\';getScheduledWorkOrder();vm.TabTitle = \'ScheduledWorkOrder\';vm.JobCount = ScheduledWorkOrderdatas.length;\">\n<md-tab-label><span>Scheduled WorkOrders</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.ScheduledWorkOrderspinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"ScheduledWorkOrderContainer\" dx-data-grid=\"vm.ScheduledWorkOrderdataGrid\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Cancelled\';getCancelled(cancelled);vm.TabTitle = \'Cancelled\';vm.JobCount = Cancelleddatas.length;\">\n<md-tab-label><span>CANCELLED</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.CancelledPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"CNLContainer\" dx-data-grid=\"vm.dataGridCNL\"></div></md-tab-body></md-tab></md-tabs></div></div></div><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n\r\n  md-input-container.md-default-theme .md-placeholder,\r\n  md-input-container .md-placeholder,\r\n  md-input-container.md-default-theme label,\r\n  md-input-container label {\r\n    color: none;\r\n  }\r\n\r\n  #content .header md-input-container {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-input-container {\r\n    display: inline-block;\r\n    position: relative;\r\n    /*padding: 10px !important;*/\r\n    margin: 18px 0;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  md-tabs-canvas.md-center-tabs {\r\n    display: none;\r\n  }\r\n\r\n  .md-button {\r\n    margin: 6px 0 0 15px;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n    height: 0px;\r\n  }\r\n\r\n  .txtbox ::-webkit-input-placeholder {\r\n    /* WebKit, Blink, Edge */\r\n    color: #909;\r\n  }\r\n\r\n  md-input-container.md-block.md-default-theme {\r\n    display: inherit !important;\r\n  }\r\n\r\n  md-toast.md-default-theme .md-toast-content,\r\n  md-toast .md-toast-content {\r\n    background: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n\r\n  .simple.fullwidth>.header {\r\n    height: auto;\r\n  }\r\n\r\n  md-content.md-default-theme,\r\n  md-content {\r\n    background-color: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n    height: 0;\r\n  }\r\n\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  .dataTables_filter {\r\n    display: none !important;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-legend {\r\n    color: #3F51B5;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-fieldset {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    height: 100%;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 1;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-select-all-checkboxes {\r\n    padding-left: 30px;\r\n  }\r\n\r\n  mwl-calendar .badge-important {\r\n    background-color: #27B1A6 !important;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n\r\n  .cal-day-tick {\r\n    display: none !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n    border-left-color: #606a71 !important;\r\n    border-right-color: #606a71 !important;\r\n  }\r\n\r\n  .dx-button {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  .dx-button-has-icon .dx-button-content {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n    color: #535858 !important;\r\n    font-weight: bold !important;\r\n  }\r\n\r\n  .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n    background-color: #83878a !important;\r\n  }\r\n\r\n  .dx-datagrid .dx-header-filter {\r\n    color: red !important;\r\n  }\r\n\r\n  .dx-datagrid .dx-header-filter-empty {\r\n    color: rgba(149, 149, 149, 0.5) !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/ChartofAccount.html","<div id=\"GENERALSETTING\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ADD_CHART_OF_ACCOUNT\" class=\"title\">Add Chart of Account</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"AccountCode\" ng-model=\"vm.AccountCode\" \nplaceholder=\"{{\'GENERALSETTING.ACCOUNT_CODE\'|translate}}\" required><div ng-messages=\"basicForm.AccountCode.$error\" \nng-show=\"basicForm.AccountCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.ACCOUNT_CODE_FIELD_IS_REQUIRED\">Account Code field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"AccountDescription\" \nng-model=\"vm.AccountDescription\" placeholder=\"{{\'GENERALSETTING.ACCOUNT_DESCRIPTION\'|translate}}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"GENERALSETTING.ACCOUNT_CLASSIFICATION\">ACCOUNT_CLASSIFICATION</label><md-select \nng-model=\"vm.AccountClassification\" id=\"searchmodule\"><md-option value=\"\">\n{{\'GENERALSETTING.SELECT_CLASSIFICATION\'|translate}}</md-option><md-option value=\"Balance Sheet\">\n{{\'GENERALSETTING.BALANCE_SHEET\'|translate}}</md-option><md-option value=\"P&L\">P&L</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Grouping\" ng-model=\"vm.Grouping\" \nplaceholder=\"{{\'GENERALSETTING.GROUPING\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"SubGrouping\" ng-model=\"vm.SubGrouping\" \nplaceholder=\"{{\'GENERALSETTING.SUB_GROUPING\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Nature\" ng-model=\"vm.Nature\" placeholder=\"{{\'GENERALSETTING.NATURE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div></form></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\" center\"><md-button \nng-click=\"SaveChartofAccount()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n			color: rgba(0, 0, 0, 0.87);\r\n			background: none;\r\n		}\r\n\r\n		#viewedit.md-button {\r\n			margin: -16px 8px;\r\n		}\r\n\r\n		.md-datepicker-button {\r\n			display: none;\r\n		}\r\n\r\n		._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n			right: 74px;\r\n		}\r\n\r\n		.md-dialog {\r\n\r\n			max-width: 60%;\r\n		}\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/GST.html","<div id=\"generalsetting\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.GST_TAX_CODE\" class=\"title\">GST Tax Code</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"GSTTaxCode\" \nng-model=\"vm.GSTTaxCode\" placeholder=\"{{\'GENERALSETTING.GST_TAX_CODE\'|translate}}\" required><div \nng-messages=\"basicForm.GSTTaxCode.$error\" ng-show=\"basicForm.GSTTaxCode.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"GENERALSETTING.GST_TAX_CODE_IS_REQUIRED\">GST Tax Code is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"vm.Description\" \nplaceholder=\"{{\'GENERALSETTING.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" name=\"TaxRate\" ng-model=\"vm.TaxRate\" \nplaceholder=\"{{\'GENERALSETTING.TAX_RATE_%\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-radio-container flex><span style=\"color:#a8bfbd\">Default ?</span><md-radio-group \nng-model=\"vm.TaxType\" layout=\"row\" style=\"padding-left:20px\" ng-disabled=\"disable_default\"><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group></md-radio-container>\n</div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button \nng-click=\"SaveGST()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/accountcodesettings.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ACCOUNT_CODE_SETUP\" class=\"title\">ACCOUNT CODE SETUP</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input \ntype=\"text\" name=\"Type\" ng-model=\"vm.Type\" placeholder=\"{{\'GENERALSETTING.TYPE\'|translate}}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"DebtorCode\" \nng-model=\"vm.DebtorCode\" placeholder=\"{{\'GENERALSETTING.DEBTOR_CODE\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"SalesCode\" ng-model=\"vm.SalesCode\" \nplaceholder=\"{{\'GENERALSETTING.SALES_CODE\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"CreditorCode\" ng-model=\"vm.CreditorCode\" \nplaceholder=\"{{\'GENERALSETTING.CREDITOR_CODE\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"PurchaseCode\" ng-model=\"vm.PurchaseCode\" placeholder=\"{{\'GENERALSETTING.PURCHASE_CODE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" \nname=\"BankCode\" ng-model=\"vm.BankCode\" placeholder=\"{{\'GENERALSETTING.BANK_CODE\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"CashCode\" ng-model=\"vm.CashCode\" \nplaceholder=\"{{\'GENERALSETTING.CASH_CODE\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"GSTInputCode\" ng-model=\"vm.GSTInputCode\" \nplaceholder=\"{{\'GENERALSETTING.GST_INPUT_CODE\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"GSTOutputCode\" ng-model=\"vm.GSTOutputCode\" \nplaceholder=\"{{\'GENERALSETTING.GST_OUTPUT_CODE\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"Wages\" ng-model=\"vm.Wages\" \nplaceholder=\"{{\'GENERALSETTING.SALARIES/WAGES\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"CPFContribution\" ng-model=\"vm.CPFContribution\" \nplaceholder=\"{{\'GENERALSETTING.CPF_CONTRIBUTION_EMPLOYER\'|translate}}\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"StaffIncentives\" ng-model=\"vm.StaffIncentives\" \nplaceholder=\"{{\'GENERALSETTING.STAFF_INCENTIVES\'|translate}}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Accountcodesetupadd()\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"closeDialog()\" aria-label=\"CANCEL\">{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></div>\n</md-dialog-content></form></md-dialog><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/alertuser.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"GENERALSETTING.FINANCIAL_YEAR_CLOSING\" class=\"title\">\nFinancial Year Closing</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-actions><label \ntranslate=\"GENERALSETTING.ARE_YOU_SURE_WANT_TO_CLOSE_THIS_FINANCIAL_YEAR?\" nowrap=\"nowrap\"><b>\nAre you sure,want to close this Financial Year ? Once Closed you cannot edit. </b></label></md-dialog-actions>\n<md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"UpdateStatus(CAID)\" class=\"md-raised md-accent\">{{\'GENERALSETTING.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"closeDialog()\" style=\"margin-top:-40px\">{{\'GENERALSETTING.NO\'|translate}}</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/accounts/generalsetting/financialperoid.html","<div id=\"generalsetting\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ADD_FINANCIAL_PERIOD\" class=\"title\">Add Financial Period</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"PeroidName\" ng-model=\"vm.PeriodName\" placeholder=\"{{\'GENERALSETTING.PERIOD_NAME\'|translate}}\" \nrequired><div ng-messages=\"basicForm.PeriodName.$error\" ng-show=\"basicForm.PeriodName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"\'GENERALSETTING.PERIOD_NAME_IS_REQUIRED\">Period Name field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"GENERALSETTING.START_PERIOD\">Start Period</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"GENERALSETTING.END_PERIOD\">End Period</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox ng-model=\"vm.OpenPeriod.value\" \ntype=\"checkbox\">{{\'GENERALSETTING.OPEN_PERIOD\'|translate}}</md-checkbox></md-input-container><md-input-container flex>\n<md-checkbox ng-model=\"vm.ClosePeriod.value\" type=\"checkbox\">{{\'GENERALSETTING.CLOSE_PERIOD\'|translate}}</md-checkbox>\n</md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"SaveFinancialPeriod()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}\n</md-button><md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/financialyear.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ADD_FINANCIAL_YEAR\" class=\"title\">Add Financial Year</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.FiscalYear\" \nplaceholder=\"{{\'GENERALSETTING.FISCAL_YEAR\'|translate}}\" required><div ng-messages=\"eventForm.FiscalYear.$error\" \nng-show=\"eventForm.FiscalYear.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.FISCAL_YEAR_IS_REQUIRED\">Fiscal Year is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Code\" ng-model=\"vm.Code\" \nplaceholder=\"{{\'GENERALSETTING.CODE\'|translate}}\" required><div ng-messages=\"eventForm.Code.$error\" \nng-show=\"eventForm.Code.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.CODE_IS_REQUIRED\">Code is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.OpeningBalance\" \nplaceholder=\"{{\'GENERALSETTING.OPENING_BALANCE\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.ClosingBalance\" placeholder=\"{{\'GENERALSETTING.CLOSING_BALANCE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\">\n<label translate=\"GENERALSETTING.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"GENERALSETTING.END_DATE\">End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div><div \nstyle=\"height: 70px;margin-top: -22px\"><md-radio-container flex><span style=\"color:#a8bfbd\">\n{{\'GENERALSETTING.ACCOUNTING_BASIS\'|translate}}</span><md-radio-group ng-model=\"vm.AccountingBasis\" layout=\"row\" \nstyle=\"padding-left:20px\"><md-radio-button value=\"Accrual\">{{\'GENERALSETTING.ACCRUAL\'|translate}}</md-radio-button>\n<md-radio-button value=\"Cash\">{{\'GENERALSETTING.CASH\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"SaveFinancialYear()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}\n</md-button><md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/financialyearAdd.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ADD_FINANCIAL_YEAR\" class=\"title\">Add Financial Year</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.FiscalYear\" \nplaceholder=\"{{\'GENERALSETTING.FISCAL_YEAR\'|translate}}\" required><div ng-messages=\"eventForm.FiscalYear.$error\" \nng-show=\"eventForm.FiscalYear.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.FISCAL_YEAR_IS_REQUIRED\">Fiscal Year is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Code\" ng-model=\"vm.Code\" \nplaceholder=\"{{\'GENERALSETTING.CODE\'|translate}}\" required><div ng-messages=\"eventForm.Code.$error\" \nng-show=\"eventForm.Code.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.CODE_IS_REQUIRED\">Code is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.OpeningBalance\" \nplaceholder=\"{{\'GENERALSETTING.OPENING_BALANCE\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.ClosingBalance\" placeholder=\"{{\'GENERALSETTING.CLOSING_BALANCE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\">\n<label translate=\"GENERALSETTING.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"GENERALSETTING.END_DATE\">End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div><div \nstyle=\"height: 70px;margin-top: -22px\"><md-radio-container flex><span style=\"color:#a8bfbd\">\n{{\'GENERALSETTING.ACCOUNTING_BASIS\'|translate}}</span><md-radio-group ng-model=\"vm.AccountingBasis\" layout=\"row\" \nstyle=\"padding-left:20px\"><md-radio-button value=\"Accrual\">{{\'GENERALSETTING.ACCRUAL\'|translate}}</md-radio-button>\n<md-radio-button value=\"Cash\">{{\'GENERALSETTING.CASH\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"SaveFinancialYear()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}\n</md-button><md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/financialyearclone.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar class=\"md-accent md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.ADD_FINANCIAL_YEAR\" class=\"title\">Add Financial Year</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.FiscalYear\" \nplaceholder=\"{{\'GENERALSETTING.FISCAL_YEAR\'|translate}}\" required><div ng-messages=\"eventForm.FiscalYear.$error\" \nng-show=\"eventForm.FiscalYear.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.FISCAL_YEAR_IS_REQUIRED\">Fiscal Year is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Code\" ng-model=\"vm.Code\" \nplaceholder=\"{{\'GENERALSETTING.CODE\'|translate}}\" required><div ng-messages=\"eventForm.Code.$error\" \nng-show=\"eventForm.Code.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.CODE_IS_REQUIRED\">Code is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.OpeningBalance\" \nplaceholder=\"{{\'GENERALSETTING.OPENING_BALANCE\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.ClosingBalance\" placeholder=\"{{\'GENERALSETTING.CLOSING_BALANCE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\">\n<label translate=\"GENERALSETTING.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"GENERALSETTING.END_DATE\">End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div><div \nstyle=\"height: 70px;margin-top: -22px\"><md-radio-container flex><span style=\"color:#a8bfbd\">\n{{\'GENERALSETTING.ACCOUNTING_BASIS\'|translate}}</span><md-radio-group ng-model=\"vm.AccountingBasis\" layout=\"row\" \nstyle=\"padding-left:20px\"><md-radio-button value=\"Accrual\">{{\'GENERALSETTING.ACCRUAL\'|translate}}</md-radio-button>\n<md-radio-button value=\"Cash\">{{\'GENERALSETTING.CASH\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"SaveFinancialYear()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'GENERALSETTING.SAVE\'|translate}}\n</md-button><md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'GENERALSETTING.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/generalsetting.html","<div id=\"generalsetting\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>\nGeneral Settings</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" ng-mode=\"SearchValue\" placeholder=\"{{\'GENERALSETTING.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"GSTadd($event)\" ng-show=\"GSTSelect\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"GENERALSETTING.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"GSTExport()\" ng-show=\"GSTSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"GENERALSETTING.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab ng-click=\"GSTTab()\"><md-tab-label><span \ntranslate=\"GENERALSETTING.GST_TAX_CODE\">GST Tax Code</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" novalidate><div\n class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"GSTdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALSETTING.GST_TAX_CODE\" class=\"column-title\">GST Tax Code</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"GENERALSETTING.DESCRIPTION\" class=\"column-title\">Description</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALSETTING.TAX_RATE_%\" \nclass=\"column-title\">Tax Rate %</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Default\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"GENERALSETTING.VIEW/EDIT\" class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in GSTdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">{{ row.GSTTaxCode }}</td><td nowrap=\"nowrap\">\n{{ row.Description }}</td><td nowrap=\"nowrap\">{{ row.TaxRate || 0 |number:2 }} %</td><td>{{ row.TaxType }}</td><td \nclass=\"editMe\"><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"GSTinfo($event,row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab ng-click=\"XeroTab()\">\n<md-tab-label><span>Xero</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" novalidate><div\n class=\"content-card\" ng-if=\"xeroStatus != \'connected\'\"><md-button style=\"left: 40%\" class=\"md-raised md-background\" \nng-click=\"ConnectXero()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Connect to Xero</span></md-button></div>\n<div ng-if=\"xeroStatus === \'connected\'\"><div class=\"text-success\" \nstyle=\"text-align:center; font-weight:500; padding-bottom: 20px\">Your Xero account is connected to Org: <span \nstyle=\"font-weight: 800\">{{TennatName}}</span></div><md-button style=\"left: 40%\" class=\"md-raised md-background\" \nng-click=\"RemoveXero()\"><md-icon md-font-icon=\"icon-close\"></md-icon><span>Remove Connection</span></md-button></div>\n</form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/generalsetting/managebank.html","<div id=\"assetregister\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALSETTING.MANAGE_BANK&CASH_ACCOUNT\" class=\"title\">Mange Bank & Cash Account</span><md-button \nclass=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"Bank\" ng-model=\"vm.Bank\" placeholder=\"{{\'GENERALSETTING.BANK\'|translate}}\" required><div \nng-messages=\"eventForm.Bank.$error\" ng-show=\"eventForm.Bank.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.BANK_FIELD_IS_REQUIRED\">Bank field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"AccountNumber\" ng-model=\"vm.AccountNumber\" \nplaceholder=\"{{\'GENERALSETTING.ACCOUNT_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.AccountNumber.$error\" \nng-show=\"eventForm.AccountNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"GENERALSETTING.ACCOUNT_NUMBER_FIELD_IS_REQUIRED\">Account Number field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.Name\" \nplaceholder=\"{{\'GENERALSETTING.NAME\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"MAdd\"><label \ntranslate=\"GENERALSETTING.OPENING_DATE\">Opening Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.OpeningDate\"></md-datepicker></md-input-container><md-input-container flex><input type=\"number\" \nname=\"Current Balance\" ng-model=\"vm.CurrentBalance\" placeholder=\"{{\'GENERALSETTING.CURRENT_BALANCE\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"{{\'GENERALSETTING.REMARKS\'|translate}}\"></md-input-container></div></form></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveBank()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">\n{{\'GENERALSETTING.SAVE\'|translate}}</md-button><md-button ng-click=\"closeDialog()\" \nclass=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">{{\'GENERALSETTING.CANCEL\'|translate}}</md-button>\n</md-dialog-actions></div></div><style>\n#MAdd md-datepicker .md-datepicker-input {\r\n            width: calc(15.5vw - 30px);\r\n            max-width: calc(35vw - 54px);\r\n        } \r\n        .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width: 160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/crm/contractquotation/SaveasTemplatepopup.html","<md-dialog style=\"width:40%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Template</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.TemplateName\" placeholder=\"Template Name\" required></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveasTemplatesubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\">Cancel</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/crm/contractquotation/contractquotation.html","<div class=\"content\" id=\"invoice\" ng-show=\"Previewdiv\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b style=\"padding-left:5%\">CONTRACT</b></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:25%\">Contract Reference # :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{ContractReferenceNo}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">Cutsomer Name:</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{CustomerName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:25%\">Service Start Date :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{ServiceStartDate| date:\'dd/MM/y\'}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">Service End Date :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{ServiceEndDate| date:\'dd/MM/y\'}}</th></tr></thead>\n</table><br><h3 style=\"font-weight: 600;margin:0px\">{{Subject}}</h3><h3 style=\"font-weight: 600;margin:0px\">\nPEST CONTROL SERVICES</h3><div style=\"font-size:17px;text-align:left\"><h4 style=\"font-weight: 600;margin-bottom:0px\">\n{{vm.TableTitle1}}</h4><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Pest Type</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Frequency</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Contractquotationdatas\" ng-if=\"row.TableContractID1 == ContractID && ContractID != null\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:left\">{{ row.T1PestType }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:left\">{{ row.T1Frequency}}</td></tr></tbody>\n</table></div><br><h3 style=\"font-weight: 600;margin:0px\">BODY :</h3><div class=\"printtextarea\"><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" ng-disabled class=\"pb-32\"></text-angular></div><br></div><div id=\"forms\" \nclass=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span>\nPrepare Contract</span></div></div><md-button type=\"submit\" ng-click=\"Back()\" class=\"md-raised\">Back</md-button></div>\n<div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"p-8\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"padding-bottom:0\"><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Contract #</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span \nstyle=\"font-size:14px\">{{ContractReferenceNo}}</span></div><div class=\"p-4\" style=\"width:14%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Cutsomer Name </b></label></div>:&emsp;<div class=\"p-4\" style=\"width:30%\"><span\n style=\"font-size:14px\">{{CustomerName}}</span></div><md-input-container style=\"width:17%;margin:0\">\n</md-input-container></div><div class=\"p-8\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:17px;color:#7f9593\"><b>\nStart Date</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span style=\"font-size:14px\">\n{{ContractStartDate| date:\'dd/MM/y\'}}</span></div><div class=\"p-4\" style=\"width:14%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>End Date </b></label></div>:&emsp;<div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:14px\">{{ContractEndDate| date:\'dd/MM/y\'}}</span></div><md-input-container style=\"width:17%;margin:0\">\n</md-input-container></div><div class=\"p-8\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Duration </b></label></div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span \nstyle=\"font-size:14px\">{{ContractDuration}}</span></div><div class=\"p-4\" style=\"width:14%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Frequency</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:14px\">{{Frequency}}</span></div><md-input-container style=\"margin:0\" flex><label>Select Template\n</label><md-select ng-model=\"uEmployeeID\" id=\"searchmodule\" md-on-close=\"vm.searchct = \'\'\"><md-select-header><input \nstyle=\"flex: auto\" ng-model=\"vm.searchct\" type=\"text\" placeholder=\"Select Template..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"uEmployeeID = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-click=\"SelectTemplate(row.id)\" \nng-repeat=\"row in Contracttemplates  | filter:vm.searchct\" value=\"{{row.id}}\">{{row.TemplateName}}</md-option>\n</md-select></md-input-container></div><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><span flex=\"7\" class=\"h3\" style=\"color:#7f9593\"><b>Subject:</b></span>&emsp;<md-input-container \nstyle=\"margin-top: 9px\" flex><input type=\"text\" style=\"font-weight:bold;border-bottom:1px solid #ddd\" \nng-model=\"Subject\" flex></md-input-container></material-input-group><span class=\"h3\" style=\"color:#7f9593\"><b>\nPEST CONTROL SERVICES :</b></span><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" id=\"tb2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pest Type</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Frequency</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Contractquotationdatas\" ng-if=\"row.TableContractID1 == ContractID && ContractID != null\"><td>&nbsp;\n</td><td>{{ row.T1PestType }}</td><td>{{ row.T1Frequency }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EditAction($index, Table= \'Title1\', row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td>\n</tr></tbody></table></div><br><span class=\"h3\" style=\"color:#7f9593\"><b>SCOPE OF WORK :</b></span><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"Scopeofwork\" class=\"pb-32\"></text-angular><span class=\"h3\" style=\"color:#7f9593\">\n<b>BODY :</b></span><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" class=\"pb-32\"></text-angular>\n<material-input-group layout=\"horizontal\"><md-checkbox ng-model=\"IncludeSOR\" type=\"checkbox\"><span flex=\"2\" class=\"h3\" \nstyle=\"color:#7f9593\"><b>Include SOR?</b></span>&emsp;</md-checkbox></material-input-group><div class=\"bottom\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"sSave()\" \nclass=\"md-raised\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div><div><md-button \ntype=\"submit\" ng-click=\"Back()\" class=\"md-raised\">Back</md-button><md-button type=\"submit\" \nng-click=\"Preview(\'invoice\')\" class=\"md-raised\">Preview</md-button><md-button type=\"submit\" \nng-click=\"SaveasTemplatepopup($event)\" class=\"md-raised\">Save as Template</md-button></div></div></form></div><br>\n</div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label > md-datepicker .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px -6px;\r\n    }\r\n\r\n    table {\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    #example table.dataTable tbody td {\r\n        padding: 2px 8px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    table.dataTable {\r\n        border-bottom: 0;\r\n        border-top: 0;\r\n    }\r\n\r\n    textarea {\r\n        width: 85%;\r\n        height: 100px;\r\n        padding: 30px 20px;\r\n        resize: none;\r\n        font-size: 17px;\r\n    }\r\n\r\n    [disabled] md-input-container.md-default-theme .md-input, [disabled] md-input-container .md-input, md-input-container.md-default-theme .md-input[disabled], md-input-container .md-input[disabled] {\r\n        border-bottom-color: transparent;\r\n        border-bottom: 1px solid #e0e0e0;\r\n        color: rgba(0,0,0,0.38);\r\n        background-image: linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0);\r\n        background-image: -ms-linear-gradient(left,transparent 0,rgba(0,0,0,0.38) 100%);\r\n    }\r\n\r\n    .md-button.md-default-theme.md-primary.md-fab, .md-button.md-primary.md-fab, .md-button.md-default-theme.md-primary.md-raised, .md-button.md-primary.md-raised {\r\n        color: rgb(255, 255, 255);\r\n        background-color: rgba(8, 73, 68, 0.75);\r\n    }\r\n\r\n    .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #qmaintable .dataTables_wrapper .bottom {\r\n        display: flex;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    div.printtextarea > text-angular {\r\n        border: 1px solid black !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractquotation/contractquotationpopup.html","<md-dialog style=\"width:60%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">PEST CONTROL SERVICES</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><form name=\"basicForm1\" flex \nclass=\"md-inline-form\" novalidate ng-show=\"Title1\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nflex><input type=\"text\" name=\"PestType\" ng-model=\"vm.T1PestType\" placeholder=\"Pest Types\" readonly=\"readonly\">\n</md-input-container><md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select \nng-model=\"vm.T1Frequency\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Title1Submit()\" aria-label=\"Submit\" ng-disabled=\"basicForm1.$invalid\" \ntranslate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form name=\"basicForm3\" flex \nclass=\"md-inline-form\" novalidate ng-show=\"Title3\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\">\n<md-input-container flex><label>Area</label><md-select ng-model=\"vm.T3Area\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP5 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermP5\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Area..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.T3Area = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in areasdatas | filter: vm.searchTermP5\" \nvalue=\"{{row.AreasName}}\">{{row.AreasName}}</md-option></md-select></md-input-container><md-input-container flex>\n<label>Pest Type</label><md-select ng-model=\"vm.T3PestType\" id=\"searchmodule\"><md-select-header><input \nng-model=\"vm.searchTermP4\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.T3PestType = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Pestdatas | filter: vm.searchTermP4\" value=\"{{row.PestName}}\">\n{{row.PestName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3Quantity\" placeholder=\"Quantity\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.T3Timing\" placeholder=\"Timing\">\n</md-input-container><md-input-container flex><label>Frequency</label><md-select ng-model=\"vm.T3Frequency\" \nid=\"searchmodule\"><md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Frequency..</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.T3Frequency = null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Daily\">Daily</md-option>\n<md-option value=\"Weekly\">Weekly</md-option><md-option value=\"Fortnightly\">Fortnightly</md-option><md-option \nvalue=\"Monthly\">Monthly</md-option><md-option value=\"Quarterly\">Quarterly</md-option><md-option value=\"Half-Yearly\">\nHalf-Yearly</md-option><md-option value=\"Yearly\">Yearly</md-option></md-select></md-input-container><md-input-container\n flex><input type=\"number\" ng-model=\"vm.T3Pricing\" placeholder=\"Pricing\"></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title3Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm3.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></form><form name=\"basicForm4\" flex class=\"md-inline-form\" novalidate ng-show=\"Title4\"><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><label>Product</label><md-select \nng-model=\"vm.T4Product\" id=\"searchmodule\" md-on-close=\"vm.searchTerm = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Product..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.T4Product = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Productdatas | filter:vm.searchTerm\" value=\"{{row.ProductName}}\">\n{{row.ProductName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T4NoOfPieces\" placeholder=\"No. Of Pieces\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.T4Pricing\" placeholder=\"Pricing\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title4Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm4.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></form><form name=\"basicForm5\" flex class=\"md-inline-form\" novalidate ng-show=\"Title5\"><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.T5Description\" placeholder=\"Description\" required></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.T5Quantity\" placeholder=\"Quantity\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" ng-model=\"vm.T5Rate\" \nplaceholder=\"Rate\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.T5Amount\" \nplaceholder=\"Amount\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Title5Submit()\" aria-label=\"Submit\" ng-disabled=\"basicForm5.$invalid\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></form><form name=\"basicForm6\" flex \nclass=\"md-inline-form\" novalidate ng-show=\"Title6\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.T6Description\" placeholder=\"Description\" required>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.T6Price\" placeholder=\"Price\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title6Submit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm6.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\">Cancel</md-button></div></form><form name=\"basicForm7\" flex class=\"md-inline-form\" novalidate \nng-show=\"Title7\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.T7SerialNo\" placeholder=\"Serial No\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.T7ForModelNo\" placeholder=\"For Model No\" required></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.T7LeasePerAnnum\" placeholder=\"Lease Per Annum\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex \nstyle=\"margin-top: 18px\"><label>Effective Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.T7EffectiveDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label>Expiry Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.T7ExpiryDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title7Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm7.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></form><form name=\"basicForm8\" flex class=\"md-inline-form\" novalidate ng-show=\"Title8\"><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.T8ForModelNo\" placeholder=\"For Model No\" required></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.T8NoOfBoardsNeeded\" placeholder=\"No Of Boards Needed\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.T8SellingPricing\" placeholder=\"Selling Pricing\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.T8Lifespan\" placeholder=\"Lifespan\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title8Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm8.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></form></md-dialog-actions></md-dialog><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 85px;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(26vw - 32px);\r\nmax-width: calc(35vw - 54px);\r\nmargin-left: -11px;\r\n}\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/AddPestTypepopup.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== false\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== true\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nname=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required ng-disabled=\"true\"><md-select-header><input \nng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Pesttype\" required \nng-disabled=\"true\"></md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"Treatmentpopupdata.length > 0\"><u>\nTreatment Methods:</u></span></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex \nng-if=\"Treatmentpopupdata.length > 0\" ng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/AddSor.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">SOR Details</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"gridContainer\" \ndx-data-grid=\"dataGridOptions\"></div></md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-disabled=\"Disablesubmit\" \nng-click=\"SubmitSOR()\" aria-label=\"Ok\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog><style>\n.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/AddTreatmentFrequency.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Work Order Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeWOTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"WOTreatmentpopupdata.length > 0\">\n<u>Treatment Methods:</u></span></div><div layout=\"column\" layout-gt-sm=\"row\" flex \nng-if=\"WOTreatmentpopupdata.length > 0\" ng-repeat=\"Tpd in WOTreatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitWOPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || WOTreatmentpopupdata == null || WOTreatmentpopupdata == \'\'\">\nSubmit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/PreviewTemplate.html","<md-dialog style=\"width: 80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Template</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding:1% 2% 1% 2%\"><div><span>Commencement of Contract</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header\" class=\"pb-32\"></text-angular><span>Service Hours</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header1\" class=\"pb-32\"></text-angular><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Header2\" class=\"pb-32\"></text-angular></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\">Save</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/Reject.html","<md-dialog style=\"width: 28%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMCONTRACTS.REJECT_THIS_CONTRACT\">Reject this Contract</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ReasonforReject\" placeholder=\"{{ \'CRMCONTRACTS.REASON_FOR_REJECT\' | translate }}\" required>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"RejectContract(vm.contractId)\" class=\"md-raised md-accent\" ng-disabled=\"eventForm.$invalid\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/crm/contractRenewal/Revice.html","<md-dialog style=\"width: 28%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMCONTRACTS.REVISE_THIS_CONTRACT\">Revise this Contract</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><md-input-container flex style=\"margin: 0px\"><label \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to Revise this contract?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-top: 20px;padding-left:53px\"><md-button ng-click=\"Revise(vm.ContractId)\" class=\"md-raised md-accent\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></md-input-container></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/crm/contractRenewal/Service.html","<md-dialog ng-style=\"{width:vm.sty + \'%\'}\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0 2% 0 2%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0;flex: 0.5\"><input type=\"text\" \nng-model=\"vm.usName\" placeholder=\"Name\"></md-input-container><md-input-container flex style=\"margin-bottom:0\"><label>\nAddress</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged1()\" \nng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usContactPerson\" \nplaceholder=\"Site Contact Person\"></md-input-container><md-chips \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" ng-init=\"vm.usMobile=[]\" \nname=\"sContactNum\" md-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" \nname=\"sContactNum\" placeholder=\"Contact Number\"></md-chips></div><p \nstyle=\"margin-left: 35%;margin-top: -23px !important\" class=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.ZoneCC\" placeholder=\"Email\" ng-init=\"vm.ZoneCC=[]\" \nreadonly=\"vm.readonly\" style=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" \nflex><md-chips ng-model=\"vm.ZoneEmail\" placeholder=\"CC\" ng-init=\"vm.ZoneEmail=[]\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType CC and Press Enter</span><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"Serviceadd(vm.Index);ClearGrid();\" ng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit\n</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n  .ms-scroll{\r\n    position: relative;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/addpesttype.html","<md-dialog style=\"width:100%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CREATE_CUSTOMER\">Create Customer</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"pesttype\" \nng-model=\"vm.pesttypename\" placeholder=\"{{ \'CRMCONTRACTS.PEST_TYPE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMCONTRACTS.NAME_IS_REQUIRED\">Name is required.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" \ntype=\"text\" name=\"remarks\" ng-model=\"vm.pestcode\" placeholder=\"{{ \'CRMCONTRACTS.PEST_CODE\' | translate }}\" required>\n<div ng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMCONTRACTS.PEST_CODE_IS_REQUIRED\">Pest Code is required.</span></div></div>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"pestsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"CRMCONTRACTS.SUBMIT\">Submit</md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTS.CANCEL\">Cancel</md-button></div></form></div></div></div></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/attachmentdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to delete this Attachment?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Adelete(AttachdeleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br><br></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/contractRenewal/cancelalert.html","<md-dialog style=\"width: 28%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CANCEL_THIS_CONTRACT\">\nCancel this Contract</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div ng-show=\"cancelaccess\" flex><label \ntranslate=\"CRMCONTRACTS.ARE YOU SURE YOU WANT TO CANCEL THIS CONTRACT\" \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to Cancel this Contract ?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-left:53px\"><md-button ng-click=\"CancelContract(vm.contractId)\" class=\"md-raised md-accent\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/contractRenewal/closealert.html","<md-dialog style=\"width: 23%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CLOSE_THIS_CONTRACT\">\nClose this Contract</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><md-input-container flex style=\"margin: 0px\"><label \ntranslate=\"CRMCONTRACTS.ARE YOU SURE YOU WANT TO CANCEL THIS CONTRACT\" \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to close this Contract ?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-top: 20px;padding-left:53px\"><md-button ng-click=\"CloseContract(vm.contractId)\" \nclass=\"md-raised md-accent\" translate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\" translate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></md-input-container>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/contractRenewal/contractrenewal.html","<div id=\"contract\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><span \nng-show=\"Contractsgrid || Contractsform || ShowContractform\">Contract Renewal</span></div><div \nng-show=\"Contractsgrid || Contractsform || ShowContractform\" class=\"product-count secondary-text\"><span \ntranslate=\"CRMCONTRACTS.TOTAL_CONTRACTS\">Total Contracts:</span> <span>{{workOrd.length}}</span></div></div><br><div>\n<md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"CRMCONTRACTS.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"ExportContract()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CRMCONTRACTS.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\" ng-show=\"Contractsgrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\">\n<md-tab ng-click=\"workOrd=contractdatas ; Refresh()\"><md-tab-label><span>Contract</span></md-tab-label><md-tab-body>\n<div id=\"PendingContainer\" dx-data-grid=\"vm.dataGridContract\"></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"content\" style=\"padding-top:30px\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"ShowContractform\" flex><span ng-if=\"Update\" style=\"font-size: 18px; font-weight: 500\">{{vm.ContractReference}}\n</span><form name=\"basicForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.ppCompanyName\" readonly=\"readonly\" \nplaceholder=\"Customer Name\"></md-input-container><md-input-container flex><label translate=\"CRMCONTRACTS.SALES_PERSON\">\nSales Person</label><md-select ng-model=\"vm.SalesPerson\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMCONTRACTS.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS=\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.CMarketSegment\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search For a Segment\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CMarketSegment = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" \nng-value=\"row\">{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.CSalutation\" readonly=\"readonly\" \nplaceholder=\"Salutation\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.CName\" \nreadonly=\"readonly\" placeholder=\"Name\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -15px\"><md-input-container flex><label>Billing Address</label><md-select ng-model=\"vm.BAddress\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search For Billing Address\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.BAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CustomerBillingAddress | filter:vm.searchTermC\" value=\"{{row._id}}\" \nng-click=\"vm.CEmail=row.bEmail.split(\',\') ; vm.CName=row.bContactPerson ; vm.Ccontact=row.bMobile.split(\',\')\">\n{{row.bStreetName}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Biiling Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-chips flex \nstyle=\"height: 13% !important\" ng-model=\"vm.Ccontact\" name=\"Ccontact\" ng-init=\"vm.Ccontact=[]\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"Ccontact\"><input type=\"number\" name=\"Ccontact\" \nplaceholder=\"Contact No (max 3)\"></md-chips></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 47px\">\n<md-chips flex style=\"height: 13% !important\" ng-model=\"vm.CEmail\" name=\"Email\" ng-init=\"vm.CEmail=[]\" \ninput-aria-label=\"Email\"><input type=\"text\" name=\"Email\" placeholder=\"Email\"></md-chips></div><span class=\"h5\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter </span><span style=\"color:#7f9593\"><h3>Site Details</h3>\n</span><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex ng-if=\"Update==false\"><label>Service Address\n</label><md-select ng-model=\"vm.CAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nvalue=\"{{row._id}}\">{{row.sName}} {{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container>\n<md-button style=\"margin: 12px -8px\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\" ng-if=\"Update==false && !(!vm.Customer_id)\"><md-icon \nmd-font-icon=\"icon-tooltip-outline-plus\"></md-icon></md-button></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 27px\"><md-input-container flex><label>Service Hours</label><md-select ng-model=\"vm.ServiceHours\" \nid=\"searchmodule\" md-on-close=\"vm.searchTerm2 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm2\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Service Hours\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ServiceHours = null;vm.searchTerm2=\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nvalue=\"During Office Hours\">Office Hours 9am - 5pm</md-option><md-option value=\"After Office Hours\">\nAfter Office Hours 5:00pm - 12:00mn</md-option><md-option value=\"Wee Hours\">Wee Hours 12:00mn - 9am</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:10px\"><label>\nService Start Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceStartDate\" \nmd-date-format=\"dd/MM/y\" required \nng-change=\"getServiceEndDate(vm.ServiceStartDate);getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\" \nstyle=\"margin-left: -10px\"></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Service End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required style=\"margin-left: -10px\" \nng-change=\"getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\"></md-datepicker></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Credit Term</label><md-select \nng-model=\"vm.CreditTerm\" id=\"searchmodule\" md-on-close=\"vm.searchTermcc = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" placeholder=\"Credit Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CreditTermdatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><input type=\"number\" \nng-model=\"vm.TotalOrderValue\" placeholder=\"Total Contract Sum\" \nng-change=\"getMonthAmount(vm.TotalMonth,vm.TotalOrderValue)\" required></md-input-container><md-input-container flex>\n<label>Select Template</label><md-select ng-model=\"vm.TemplateName\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" \nng-disabled=\"!vm.BillingFrequency || !vm.ServiceHours || !vm.ServiceStartDate || !vm.ServiceEndDate || !vm.TotalOrderValue || !vm.CreditTerm\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Contract Template\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.TemplateName = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Contracttemplates | filter:vm.searchTermC\" ng-click=\" ClickTemplate($event)\" value=\"{{row.id}}\">\n{{row.TemplateName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin: 0;padding-left:1%\"><md-checkbox ng-model=\"vm.IncludeSOR\" \nng-change=\"SORDerails(vm.IncludeSOR,$event,true)\" type=\"checkbox\"><span>Include SOR? </span>&emsp;</md-checkbox><span \nid=\"viewsor\" ng-show=\"vm.IncludeSOR\" ng-click=\"SORDerails(true,$event,false)\">View/Edit SOR Details </span>&emsp;\n</md-input-container><md-input-container flex style=\"margin: 0;padding-left:1%\" ng-show=\"Update == false\">\n</md-input-container></div><div style=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\"><b>\nPEST CONTROL SERVICES :</b></span><md-button id=\"viewedit\" class=\"md-raised md-button md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddPestType($event)\" style=\"float:right\">Add Frequency</md-button></div>\n<table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Method</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>\n{{ row.Frequency }}</td><td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EditPestControl($event,row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"Frequencydatas.length == 1\" ng-click=\"DeletePestControl(row)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table><div style=\"padding-bottom:2%\" ng-if=\"Update == true\"><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>ATTACH SIGNED CONTRACT :</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-if=\"Update == true\" style=\"border:1px solid rgb(224, 224, 224)\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"UploadContractfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span>\n</md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ContarctAttachmentdatas\"><td>\n</td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || Frequencydatas.length == 0\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div><div class=\"content\" \nng-show=\"Contractsform\"><form name=\"wizardStep1\" class=\"md-inline-form\" novalidate style=\"padding-bottom:0px\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%;border:1px solid rgb(224, 224, 224);float:left\"><div layout=\"row\">\n<div layout=\"column\" style=\"width:45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">Contract Details :\n</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract Reference #</b></span></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:13px;padding-left:2%\"><b>{{vm.ContractReferenceNo}}</b></span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Cutsomer Name</b></label></div><label\n style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uCompanyName1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Sales Person</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SalesPerson1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Credit Term</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.CreditTerm}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Template</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.TempTemplate}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service Start Date</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service End Date</b></label></div>\n<label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceEndDate| date:\'dd/MM/y\'}}</span></div></div></div><div \nlayout=\"column\" style=\"width:45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">\nContact Information :</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contact Person</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:\n</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{vm.uContactPerson}}\n</b></span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Phone</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b>\n</label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.Ccontact}}</span></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Email</b>\n</label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uEmail}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Billing Address</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>Service Address</b></label></div><label \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.uSAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:70%\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"CreateWorkOrder($event)\" aria-label=\"Submit\">Create Work Order</md-button></div><label \nstyle=\"font-size:15px;color:#7f9593\"></label><div class=\"p-4\" style=\"width:60%\"></div></div></div><div layout=\"column\" \nstyle=\"width:15%;margin-top:10px;float: right\"><a ng-click=\"Contractclose($event, vm.ContractId)\" \nstyle=\"cursor:pointer;font-size: 14px;color:orangered\" ng-hide=\"vm.ContractStatus == \'Closed\'\">Cancel Contract</a>\n</div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" \nstyle=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span \nclass=\"h3\" style=\"color:#7f9593\"><b>ATTACH SIGNED CONTRACT :</b></span></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input2\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input2\" flow-btn id=\"file-input2\"><md-button class=\"md-raised md-accent\" \nng-click=\"UploadContractfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span>\n</md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nclass=\"dataTable row-border hover\" style=\"border: 1px solid #d0d3d3\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ContarctAttachmentdatas\">\n<td></td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" \nstyle=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span \nclass=\"h3\" style=\"color:#7f9593\"><b>PEST CONTROL SERVICES :</b></span></div><table class=\"dataTable row-border hover\" \nstyle=\"border: 1px solid #d0d3d3\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nTreatment Method</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas | orderBy:\'-Freq\'\"><td \nstyle=\"font-size:14px\">{{$index+1}}</td><td style=\"font-size:14px\">{{ row.Frequency }}</td><td style=\"font-size:14px\">\n{{ row.PestType }}</td><td style=\"font-size:14px\">{{ row.Treatment }}</td></tr></tbody></table></div></div></form>\n</div></div><style>\n@media only screen and (max-width: 2200px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(27vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(4.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1600px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(24.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(3.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1150px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(18vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(2.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(30vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .label {\r\n        margin-top: -5px !important;\r\n        margin-bottom: -5px !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n        min-height: 250px;\r\n    }\r\n\r\n    .chipsdemoContactChips md-content.autocomplete input {\r\n        min-width: 400px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-item-text.compact {\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text {\r\n        padding: 14px 0;\r\n        max-width: 190px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n        margin: 0 !important;\r\n        padding: 0;\r\n        line-height: 1.2em !important;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n    .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n        .chipsdemoContactChips .contact-item {\r\n            float: left;\r\n            width: 33%;\r\n        }\r\n    }\r\n\r\n    .chipsdemoContactChips md-contact-chips {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-chips {\r\n        padding: 5px 0 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .fixedRows {\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-input1 {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-input2 {\r\n        display: none !important;\r\n    }\r\n\r\n    #attachmenthref label:hover {\r\n        border-bottom: 1px solid #23527c;\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    /* #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n    } */\r\n\r\n    #workflow .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    .dx-switch-handle:before {\r\n        background-color: #039be5de !important;\r\n    }\r\n\r\n    #viewsor:hover {\r\n        color: rgb(3, 155, 229) !important;\r\n        font-style: italic;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n\r\n    }\r\n\r\n    #viewsor {\r\n        color: rgb(181, 219, 238) !important;\r\n        font-style: italic;\r\n        font-size: 14px\r\n    }\r\n        .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contractRenewal/renewal.html","<md-dialog style=\"width:100%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{\'CRMCONTRACTS.CONTRACT\'|translate}} ({{vm.Crn}}) {{\'CRMCONTRACTS.RENEWAL\'|translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:1% 2% 1% 2%\"><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container style=\"width: 50%\"><span translate=\"CRMCONTRACTS.CUSTOMER_NAME\" \nstyle=\"color:#7f9593;font-size:16px\">Customer Name : &emsp;{{vm.Cname}}</span></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.CONTRACT_START_DATE\">Contract Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ContractStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"CRMCONTRACTS.CONTRACT_END_DATE\">Contract End Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ContractEndDate\" required \nmd-min-date=\"vm.ContractStartDate\" ng-change=\"DaysCalc(this)\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.ContractDuration\" \nplaceholder=\"{{\'CRMCONTRACTS.CONTRACT_DURATION(IN_DAYS)\'|translate}}\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.SERVICE_START_DATE\">Service Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceStartDate\" md-min-date=\"vm.ContractStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.SERVICE_END_DATE\">Service End Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceEndDate\" md-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex><label translate=\"CRMCONTRACTS.FREQUENCY\">Frequency</label><md-select \nng-model=\"vm.Frequency\" id=\"searchmodule\" required><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\">{{\'CRMCONTRACTS.FREQUENCY\'|translate}}..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"Daily\" translate=\"CRMCONTRACTS.DAILY\">Daily</md-option>\n<md-option value=\"Weekly\" translate=\"CRMCONTRACTS.WEEKLY\">Weekly</md-option><md-option value=\"Fortnightly\" \ntranslate=\"CRMCONTRACTS.FORTNIGHTLY\">Fortnightly</md-option><md-option value=\"Monthly\" \ntranslate=\"CRMCONTRACTS.MONTHLY\">Monthly</md-option><md-option value=\"Quarterly\" translate=\"CRMCONTRACTS.QUARTERLY\">\nQuarterly</md-option><md-option value=\"Half-Yearly\" translate=\"CRMCONTRACTS.HALF_YEARLY\">Half-Yearly</md-option>\n<md-option value=\"Yearly\" translate=\"CRMCONTRACTS.YEARLY\">Yearly</md-option></md-select></md-input-container></div><div\n layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"RenewalSubmit(vm.RenewalId)\" ng-disabled=\"eventForm.$invalid\" translate=\"CRMCONTRACTS.SUBMIT\">Submit\n</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCONTRACTS.CANCEL\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 14px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/costing/costing.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" style=\"margin:0 16px 0 16px\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"CRMCOSTING.ESTIMATION\">Estimation</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"CRMCOSTING.TOTALESTIMATION\">Total Estimations:</span> <span>\n{{Costingdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'CRMCOSTING.SEARCH\'| translate}}\" flex></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CRMCOSTING.ADD\">Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"CRMCOSTING.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"CRMCOSTING.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"CostingSheetgrid\"><div id=\"qmaintable\" class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Costingdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCOSTING.REFERENCE\">Reference #</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMCOSTING.CUSTOMER_NAME\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.CONTRACT_START_DATE\">Contract Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.CONTRACT_END_DATE\">\nContract End Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\"><span \ntranslate=\"CRMCOSTING.TOTAL_MANPOWER_COST\">Total Manpower Cost</span> ({{CurrencyCode}})</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\"><span translate=\"CRMCOSTING.TOTAL_EQUIPMENT_COST\">\nTotal Equipment Cost </span>({{CurrencyCode}})</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCOSTING.PREPARED_BY\">Prepared By</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMCOSTING.PREPARED_DATE\">Prepared Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.PREVIEW\">Preview</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.EDIT\">Edit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Costingdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Costinginfo(row.id)\" style=\"cursor:pointer\">{{ row.CostingID }}</a></td><td>{{ row.CustomerInfo }}</td><td>\n{{ row.StartDate | date : \'dd/MM/y\' }}</td><td>{{ row.EndDate | date : \'dd/MM/y\' }}</td><td>\n{{ row.TotalManpowerCost | number:2 }}</td><td>{{ row.EuipmentCost| number:2 }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date : \'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"preview(row.id, \'invoice\')\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Costinginfo(row.id)\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\" \nng-show=\"CostingSheetform\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nstyle=\"padding:16px 5px 16px 5px\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><label translate=\"CRMCOSTING.CUSTOMER_NAME\">Customer Name</label>\n<md-select ng-model=\"vm.Customer_Id\" id=\"searchmodule\" required><md-select-header><input style=\"flex: auto\" \nng-model=\"vm.searchTermC\" type=\"text\" placeholder=\"{{\'CRMCOSTING.SEARCH_FOR_A_CUSTOMER\' | translate}}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.CustomerID = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:vm.searchTermC\" \nng-click=\"CustomerServicedatadetails(row)\" value=\"{{row.id}}\">{{row.CompanyName}}</md-option></md-select>\n</md-input-container></div><label style=\"font-size:17px;padding-left:2%;margin-bottom: -1%\"><span \ntranslate=\"CRMCOSTING.INFORMATION\">Information</span> :</label><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border: 1px solid rgb(197, 197, 197)\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:15%\">\n<label style=\"font-size:15px;font-weight:bold;color:#7f9593\" translate=\"CRMCOSTING.COMPANY_NAME\">Company Name</label>\n</div><label style=\"font-size:15px;font-weight:bold;color:#7f9593\">:</label><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:14px;padding-left:3%\">{{vm.uCompanyName}}</span></div><div class=\"p-4\" style=\"width:15%\"><label \nstyle=\"font-size:15px;font-weight:bold;color:#7f9593\" translate=\"CRMCOSTING.CONTACT_PERSON\">Contact Person</label>\n</div><label style=\"font-size:15px;font-weight:bold;color:#7f9593;color:#7f9593\">:</label><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:14px;padding-left:3%\">{{vm.uContactPerson}}</span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:15%\"><label \nstyle=\"font-size:15px;font-weight:bold;color:#7f9593\" translate=\"CRMCOSTING.MOBILE\">Mobile</label></div><label \nstyle=\"font-size:15px;font-weight:bold;color:#7f9593;color:#7f9593\">:</label><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:14px;padding-left:3%\">{{vm.Mobile}}</span></div><div class=\"p-4\" style=\"width:15%\"><label \nstyle=\"font-size:15px;font-weight:bold;color:#7f9593\" translate=\"CRMCOSTING.EMAIL\">Email</label></div><label \nstyle=\"font-size:15px;font-weight:bold;color:#7f9593;color:#7f9593\">:</label><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:14px;padding-left:3%\">{{vm.uEmail}}</span></div></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px;padding:16px 10px 0px 10px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.RegularBaseHr\" placeholder=\"{{\'CRMCOSTING.REGULAR_BASE_HRS_RATE\' | translate }}\" required>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.BaseOtRate\" \nplaceholder=\"{{\'CRMCOSTING.BASE_OT_RATE\' | translate }}\" required></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label translate=\"CRMCOSTING.CONTRACT_START_DATE\">Contract Start Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.StartDate\" required></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label translate=\"CRMCOSTING.CONTRACT_END_DATE\">\nContract End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EndDate\" required \nng-change=\"DaysCalc(this)\" md-min-date=\"vm.StartDate\"></md-datepicker></md-input-container></div><br><span class=\"h3\" \nstyle=\"color:#7f9593\"><b><span translate=\"CRMCOSTING.ESTIMATION_SHEET\">Estimation Sheet</span> :</b></span><div \nlayout-gt-sm=\"row\" layout-align=\"end right\"><md-button class=\"md-raised\" ng-click=\"AddManpower($event)\" \nstyle=\"margin-top: 18px\"><span translate=\"CRMCOSTING.ADD\">Add</span></md-button></div><div class=\"content-card\"><table \nclass=\"dataTable row-border\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.SERVICE\">Service</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.SERVICE_YEAR\">Service/Year\n</span></div></th><th class=\"secondary-text\"><div style=\"text-align:center\"><span class=\"column-title;\" \ntranslate=\"CRMCOSTING.PEST_TYPE_PRICE\">Pest Type & Prcie</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCOSTING.CONTRACT_DURATION\">Contract Duration</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.TOTAL_TECHNICIANS\">Total Technicians\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.TOTAL_NORMAL_HOURS\">\nTotal Normal Hours</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCOSTING.TOTAL_OT_HOURS\">Total OT Hours</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCOSTING.ACTION\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in CostingAdddatas\" ng-if=\"row.Frequency != null && row.Frequency != undefined\"><td>{{ row.Frequency }}\n</td><td>{{ row.SvcPerYear }}</td><td><table class=\"dataTable cell-border\" \nstyle=\"font-size: smaller;border-top: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\"><tr \nng-repeat=\"pt in row.PestType\"><td>{{pt.PestName}}</td><td>{{pt.Price}}</td></tr></table></td><td \nstyle=\"text-align:center\">{{ row.Duration }}</td><td style=\"text-align:center\">{{ row.NoTech }}</td><td \nstyle=\"text-align:center\">{{ row.NoReg }}</td><td style=\"text-align:center\">{{ row.NoOT }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Delete(row.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr><tr><td></td><td></td>\n<td></td><td style=\"text-align:center\"></td><td><b><span translate=\"CRMCOSTING.TOTAL_PER_YEAR\">Total Per Year </span>:\n</b></td><td style=\"text-align:center\">{{vm.TotalPerYearNoReg}}</td><td style=\"text-align:center\">\n{{vm.TotalPerYearNoOT}}</td><td></td></tr></tbody></table></div><br><div style=\"padding-left:60%\"><div \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\" translate=\"CRMCOSTING.NORMAL_HOUR_RATE_PER_HOUR\">\nNormal Hour Rate (Per Hour)</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div \nclass=\"p-4\" style=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.RegularBaseHr | number : 2}}</span>\n</div></div><div layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\" translate=\"CRMCOSTING.OT_HOUR_RATE_PER_HOUR\">\nOT Hour Rate (Per Hour)</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div \nclass=\"p-4\" style=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.BaseOtRate | number : 2}}</span></div>\n</div><br><div layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.TOTAL_REGULAR_HRS_COST\">\nTotal Regular Hrs Cost</span> ({{CurrencyCode}})</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.TotalHrCost | number : 2}}</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.TOTAL_OT_COST\">Total OT Cost</span>\n ({{CurrencyCode}})</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" \nstyle=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.TotalOTCost | number : 2}}</span></div></div><br>\n<div layout-gt-sm=\"row\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593\"></div><br><div \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.TOTAL_MANPOWER_COST\">\nTotal ManPower Cost</span> ({{CurrencyCode}})</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">\n=</label><div class=\"p-4\" style=\"width:25%;text-align:right\"><span style=\"font-size:14px\">\n{{vm.TotalManpowerCost | number : 2}}</span></div></div></div><br><span class=\"h3\" style=\"color:#7f9593\"><b><span \ntranslate=\"CRMCOSTING.EQUIPMENTS\">Equipments</span> :</b></span><div layout-gt-sm=\"row\" layout-align=\"end right\">\n<md-button class=\"md-raised\" ng-click=\"AddProduct($event)\"><span translate=\"CRMCOSTING.ADD\">Add</span></md-button>\n</div><div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"table dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \nid=\"tb2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.EQUIPMENTS\">Equipments</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.COST_PIECE\">Cost/Piece</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.QUANTITY_YEAR\">Quantity/Year\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.COST_YEAR\">Cost/Year\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCOSTING.DELETE\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in CostingAdddatas\" \nng-if=\"row.Product != null && row.Product != undefined\"><td>&nbsp;</td><td>{{ row.Product }}</td><td>\n{{ row.CostPerPiece }}</td><td>{{ row.QtyPerYear }}</td><td>{{ row.CostPerYear }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"QDelete(row.id)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr><tr><td></td><td></td><td></td><td><b><span \ntranslate=\"CRMCOSTING.TOTAL_COST\">Total Cost</span> ({{CurrencyCode}}):</b></td><td>{{vm.EuipmentCost}}</td><td></td>\n</tr></tbody></table></div></div><br><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.COAPercentage\" placeholder=\"{{\'CRMCOSTING.OVERHEAD\' | translate }} (%)\" \nng-change=\"CalCOA()\" required></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.MarkupPercentage\" placeholder=\"{{\'CRMCOSTING.MARKUP\' | translate }} (%)\" ng-change=\"CalCOA()\" required>\n</md-input-container></div><br><div style=\"padding-left:60%\"><div layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"p-4\" style=\"width:55%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\"><span \ntranslate=\"CRMCOSTING.LABOUR_COST\">Labour Cost</span> ({{CurrencyCode}})</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.TotalManpowerCost | number : 2}}</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.EQUIPMENT_COST\">Equipment Cost\n</span> ({{CurrencyCode}})</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div \nclass=\"p-4\" style=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.EuipmentCost | number : 2}}</span>\n</div></div><br><div layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.TOTAL_EQUIPMENT_LABOUR_COST\">\nTotal Equipment/Labour Cost</span> ({{CurrencyCode}})</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.TotalEPerLCost | number : 2}}</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.C_OA_COST\">C & OA Cost</span>\n ({{CurrencyCode}})</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" \nstyle=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.COACost | number : 2}}</span></div></div><div \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\" translate=\"CRMCOSTING.MARKUP\">Markup</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.Markup | number : 2}}</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"start start\" style=\"border-top: 1px solid #7f9593\"></div><br><div layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.TOTAL_COST\">Total Cost</span>\n ({{CurrencyCode}})</span></div><label style=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" \nstyle=\"width:25%;text-align:right\"><span style=\"font-size:14px\">{{vm.TotalCost | number : 2}}</span></div></div><div \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.CONTRACT_PRICE_ANNUAL\">\nContract Price (Annual)</span> ({{CurrencyCode}})</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.ContractPriceAnnual | number : 2}}</span></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:55%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\"><span translate=\"CRMCOSTING.CONTRACT_PRICE_MONTH\">\nContract Price (Month)</span> ({{CurrencyCode}})</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:2%\">=</label><div class=\"p-4\" style=\"width:25%;text-align:right\">\n<span style=\"font-size:14px\">{{vm.ContractPriceMonth | number : 2}}</span></div></div></div><br><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-button type=\"submit\" ng-click=\"sSubmit()\" \nclass=\"md-raised md-accent\" ng-disabled=\"basicForm.$invalid\"><span translate=\"CRMCOSTING.SUBMIT\">Submit</span>\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\"><span translate=\"CRMCOSTING.CANCEL\">Cancel\n</span></md-button></div></form></div></div><br></div><div class=\"content\" ng-show=\"Previewdiv\" id=\"invoice\"><div \nstyle=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b \nstyle=\"padding-left:70px\" translate=\"CRMCOSTING.ESTIMATION\">ESTIMATION</b></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px;font-size:17px\"><span translate=\"CRMCOSTING.CUSTOMER_NAME\">Customer Name\n</span>>:</th><th style=\"border-collapse: collapse;width:1500px;font-weight:normal;font-size:17px;text-align:left\">\n{{vm.uCompanyName}}</th></tr></thead></table><br><span class=\"h3\" style=\"font-size:17px;font-weight:600\" \ntranslate=\"CRMCOSTING.INFORMATION\">Information :</span><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead style=\"border: 1px solid black\"><tr><th \nstyle=\"border-collapse: collapse;width:350px\"><span translate=\"CRMCOSTING.COMPANY_NAME\">Company Name</span>:</th><th \nstyle=\"border-collapse: collapse;width:650px;font-weight:normal\">{{vm.uCompanyName}}</th><th \nstyle=\"border-collapse: collapse;width:450px\"><span translate=\"CRMCOSTING.CONTACT_PERSON\">Contact Person</span>:</th>\n<th style=\"border-collapse: collapse;width:750px;font-weight:normal\">{{vm.uContactPerson}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:350px\"><span translate=\"CRMCOSTING.MOBILE\">Mobile</span>:</th><th \nstyle=\"border-collapse: collapse;width:650px;font-weight:normal\">{{vm.Mobile}}</th><th \nstyle=\"border-collapse: collapse;width:450px\"><span translate=\"CRMCOSTING.EMAIL\">Email</span>:</th><th \nstyle=\"border-collapse: collapse;width:750px;font-weight:normal\">{{vm.uEmail}}</th></tr></thead><tbody></tbody></table>\n<br><table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:600px\"><span translate=\"CRMCOSTING.REGULAR_BASE_HRS_RATE\">Regular Base Hrs Rate\n</span>:</th><th style=\"border-collapse: collapse;width:300px;font-weight:normal\">{{vm.RegularBaseHr}}</th><th \nstyle=\"border-collapse: collapse;width:600px\"><span translate=\"CRMCOSTING.BASE_OT_RATE\">Base OT Rate</span>:</th><th \nstyle=\"border-collapse: collapse;width:300px;font-weight:normal\">{{vm.BaseOtRate}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:600px\"><span translate=\"CRMCOSTING.CONTRACT_START_DATE\">Contract Start Date\n</span>:</th><th style=\"border-collapse: collapse;width:300px;font-weight:normal\">{{vm.StartDate | date:\'dd/MM/y\'}}\n</th><th style=\"border-collapse: collapse;width:600px\"><span translate=\"CRMCOSTING.CONTRACT_END_DATE\">Contract End Date\n</span>:</th><th style=\"border-collapse: collapse;width:300px;font-weight:normal\">{{vm.EndDate | date:\'dd/MM/y\'}}</th>\n</tr></thead><tbody></tbody></table><br><span class=\"h3\" style=\"font-size:17px;font-weight:600\"><b><span \ntranslate=\"CRMCOSTING.ESTIMATION_SHEET\">Estimation Sheet</span> :</b></span><div \nstyle=\"font-size:17px;text-align:left\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><span \ntranslate=\"CRMCOSTING.SERVICE\">Service</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMCOSTING.SERVICE_YEAR\">Service/Year</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:center\" \ntranslate=\"CRMCOSTING.PEST_TYPE_PRICE\">Pest Type & Price</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMCOSTING.CONTRACT_DURATION\">Contract Duration</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMCOSTING.TOTAL_TECHNICIANS\">Total Technicians</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMCOSTING.TOTAL_MAN_HOURS\">Total Normal Hours</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMCOSTING.TOTAL_OT_HOURS\">Total OT Hours</th></tr></thead><tbody><tr ng-repeat=\"row in CostingAdddatas\" \nng-if=\"row.Frequency != null && row.Frequency != undefined\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Frequency }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.SvcPerYear }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\"><table class=\"dataTable cell-border\" \nstyle=\"font-size: smaller;border-top: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\"><tr \nng-repeat=\"pt in row.PestType\"><td>{{pt.PestName}}</td><td>{{pt.Price}}</td></tr></table></td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.Duration|number:2 }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.NoTech|number:2 }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.NoReg|number:2 }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.NoOT |number:2}}</td></tr><tr><th \ncolspan=\"3\" style=\"text-align:center;border:none\"></th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_PER_YEAR\">Total Per Year</span> :</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalPerYearNoReg|number:2}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalPerYearNoOT|number:2}}</th></tr><tr><th rowspan=\"5\" colspan=\"3\" style=\"text-align:center;border:none\"></th>\n<th colspan=\"3\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\" \ntranslate=\"CRMCOSTING.NORMAL_HOUR_RATE_PER_HOUR\">Normal Hour Rate (Per Hour)</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.RegularBaseHr | number : 2}}</th></tr><tr><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.OT_HOUR_RATE_PER_HOUR\">OT Hour Rate (Per Hour)</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.BaseOtRate | number : 2}}</th></tr><tr><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_REGULAR_HRS_COST\">Total Regular Hrs Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalHrCost | number : 2}}</th></tr><tr><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_OT_COST\">Total OT Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalOTCost | number : 2}}</th></tr><tr><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_MANPOWER_COST\">Total ManPower Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalManpowerCost | number : 2}}</th></tr></tbody><tfoot></tfoot></table></div><br><span class=\"h3\" \nstyle=\"font-size:17px;font-weight:600\"><b><span translate=\"CRMCOSTING.EQUIPMENTS\">Equipments</span> :</b></span><div \nstyle=\"font-size:17px;text-align:left\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><span \ntranslate=\"CRMCOSTING.EQUIPMENTS\">Equipments</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><span \ntranslate=\"CRMCOSTING.COST_PIECE\">Cost/Piece</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><span \ntranslate=\"CRMCOSTING.QUANTITY_YEAR\">Quantity/Year</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><span \ntranslate=\"CRMCOSTING.COST_YEAR\">Cost/Year</span></th></tr></thead><tbody><tr ng-repeat=\"row in CostingAdddatas\" \nng-if=\"row.Product != null && row.Product != undefined\"><td style=\"border: 1px solid black;border-collapse: collapse\">\n{{ row.Product }}</td><td style=\"border: 1px solid black;border-collapse: collapse;text-align:right\">\n{{ row.CostPerPiece|number:2 }}</td><td style=\"border: 1px solid black;border-collapse: collapse;text-align:right\">\n{{ row.QtyPerYear |number:2 }}</td><td style=\"border: 1px solid black;border-collapse: collapse;text-align:right\">\n{{ row.CostPerYear |number:2 }}</td></tr><tr><th colspan=\"2\" style=\"text-align:center;border:none\"></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_COST\">Total Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.EuipmentCost |number:2}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.OVERHEAD\">Overhead</span> (%)</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:left\">\n{{vm.COAPercentage}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n<span translate=\"CRMCOSTING.MARKUP\">Markup </span>(%)</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:left\">\n{{vm.MarkupPercentage}}</th></tr><tr><th rowspan=\"8\" style=\"text-align:center;border:none\"></th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.LABOUR_COST\">Labour Cost </span>({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalManpowerCost | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.EQUIPMENT_COST\">Equipment Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.EuipmentCost | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_EQUIPMENT_LABOUR_COST\">Total Equipment/Labour Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalEPerLCost | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.C_OA_COST\">C & OA Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.COACost | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.MARKUP\">Markup</span></th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.Markup | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.TOTAL_COST\">Total Cost</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.TotalCost | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.CONTRACT_PRICE_ANNUAL\">Contract Price (Annual) </span>({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.ContractPriceAnnual | number : 2}}</th></tr><tr><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><span \ntranslate=\"CRMCOSTING.CONTRACT_PRICE_MOMTH\">Contract Price (Month)</span> ({{CurrencyCode}})</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;font-weight:normal;text-align:right\">\n{{vm.ContractPriceMonth | number : 2}}</th></tr></tbody><tfoot></tfoot></table></div><br></div></div></div><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 77px;\r\n    }\r\n\r\n    .md-default-theme .md-datepicker-input-mask-opaque, .md-datepicker-input-mask-opaque {\r\n        left: 0px !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -4px;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/crm/costing/costingpopup.html","<md-dialog style=\"width:60%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCOSTING.ADD_EQUIPMENTS\">Add Equipments</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><form name=\"basicForm3\" flex class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><label translate=\"CRMCOSTING.EQUIPMENTS\">Equipments\n</label><md-select ng-model=\"vm.Product\" id=\"searchmodule\" md-on-close=\"vm.searchTerm = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'CRMCOSTING.SEARCH_FOR_EQUIPMENTS\' | translate}}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.T4Product = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Productdatas | filter:vm.searchTerm\" value=\"{{row.ProductName}}\">{{row.ProductName}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.CostPerPiece\" \nng-change=\"GetCostPerYear()\" placeholder=\"{{\'CRMCOSTING.COST_PIECE\' | translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.QtyPerYear\" ng-change=\"GetCostPerYear()\" placeholder=\"{{\'CRMCOSTING.QUANTITY_YEAR\' | translate}}\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.CostPerYear\" \nplaceholder=\"{{\'CRMCOSTING.COST_YEAR\' | translate}}\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ProductSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm3.$invalid\"><span translate=\"CRMCOSTING.SUBMIT\">Submit</span></md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\"><span translate=\"CRMCOSTING.CANCEL\">Cancel</span></md-button></div>\n</form></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/costing/manpower.html","<md-dialog style=\"width:100%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCOSTING.COST_SHEET\">Cost Sheet</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><form name=\"basicForm3\" flex class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><label translate=\"CRMCOSTING.FREQUENCY\">Frequency\n</label><md-select ng-model=\"vm.Frequency\" id=\"searchmodule\" required><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\" translate=\"CRMCOSTING.FREQUENCY..\">Frequency..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.T1Frequency = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Weekly\" \ntranslate=\"CRMCOSTING.WEEKLY\">Weekly</md-option><md-option value=\"Twice a Month\" translate=\"CRMCOSTING.TWICE_A_MONTH\">\nTwice a Month</md-option><md-option value=\"Monthly\" translate=\"CRMCOSTING.MONTHLY\">Monthly</md-option><md-option \nvalue=\"Bi-Monthly\" translate=\"CRMCOSTING.BI_MONTHLY\">Bi-Monthly</md-option><md-option value=\"Quarterly\" \ntranslate=\"CRMCOSTING.QUARTERLY\">Quarterly</md-option><md-option value=\"One Time Service\" \ntranslate=\"CRMCOSTING.ONE_TIME_SERVICE\">One Time Service</md-option><md-option value=\"Annual Inspection\" \ntranslate=\"CRMCOSTING.ANNUAL_INSPECTION\">Annual Inspection</md-option><md-option value=\"Stationed Specialist\" \ntranslate=\"CRMCOSTING.STATIONED_SPECIALIST\">Stationed Specialist</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"CRMCOSTING.PEST_TYPE\">Pest Type</label><md-select ng-model=\"vm.PestType\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" multiple=\"\" \nrequired><md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'CRMCOSTING.PEST_TYPE..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.PestType = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas  | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.NoTech\" placeholder=\"{{\'CRMCOSTING.TOTAL_TECHNICIANS\' | translate }}\" required>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.NoReg\" \nplaceholder=\"{{\'CRMCOSTING.TOTAL_NORMAL_HOURS\' | translate }}\" required></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.NoOT\" placeholder=\"{{\'CRMCOSTING.TOTAL_OT_HOURS\' | translate }}\" required>\n</md-input-container></div><span class=\"h3\" ng-if=\"vm.PestType\" style=\"color:#7f9593\"><b><span \ntranslate=\"CRMCOSTING.PRICE\">Price</span> :</b></span><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\">\n<md-input-container ng-repeat=\"row in vm.PestType\" flex><input type=\"number\" ng-model=\"row.Price\" \nvalue=\"{{row.PestName}}\" placeholder=\"{{\'CRMCOSTING.PRICE\' | translate}}\" required></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"CostSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm3.$invalid\"><span translate=\"CRMCOSTING.SUBMIT\">Submit</span></md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\"><span translate=\"CRMCOSTING.CANCEL\">Cancel</span></md-button></div>\n</form></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/dashboard/sales.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"><span \ntranslate=\"CRMDASHBOARD.WELCOME_BACK\">Welcome back</span>, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div id=\"popupContainer\"></div>\n<div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Prospect Followup</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span>Details</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\" ng-click=\"getCustomerdata()\">{{ProspectFollowup}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total</div></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div\n class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\nThis shows the Clients we have sent quotation and are due within the next 3 months. This data will be taken from expected response date when creating leads.\n</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Leads</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span>Details\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-green-fg font-size-72 line-height-72\" ng-click=\"goToLead()\">\n{{TotalLeads}}</div><div class=\"h3 secondary-text font-weight-500\">Total</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"b16\"></md-icon></md-button></div><div>\nThis shows the total number of Leads</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Pipeline Value</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span>\nDetails</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\" ng-click=\"GetPipelineValue()\">\n{{PipelineValue}}</div><div class=\"h3 secondary-text font-weight-500\"><span>Total</span></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>\nThis shows the Pipeline value will be upcoming clients that are due within the next 3 months. This data of 3months will be taken from expected response date.\n</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Accumulated Sales For the month</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span>\nDetails</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"green-fg font-size-72 line-height-72\" ng-click=\"GetAccumulatedValue()\">\n{{AccumulatedSales}}</div><div class=\"h3 secondary-text font-weight-500\">Total</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>This shows the total Contract value for the current month</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget10.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" ng-click=\"RedirectPage(\'lead\')\" options=\"vm.widget10.mainChart.options\" \ndata=\"vm.widget10.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget11.title}}</div><md-divider>\n</md-divider><div class=\"p-16\" ng-click=\"RedirectPage(\'saleorder\')\"><nvd3 class=\"h-400\" \noptions=\"vm.widget11.mainChart.options\" data=\"vm.widget11.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">Sales Trending Report</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"100\"><div id=\"chart\" dx-chart=\"chartOptions\"></div></div></div></ms-widget-front>\n</ms-widget></div></div></div></div><style>\n.color-red {\r\n        color: red;\r\n    }\r\n    .md-green-500-bg {\r\n    background-color: #4abead !important;\r\n    color: white;\r\n}\r\n#chart{\r\n    width:85%\r\n}\n</style>");
$templateCache.put("app/main/apps/crm/contracts/AddPestTypepopup.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== false\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== true\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nname=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required ng-disabled=\"true\"><md-select-header><input \nng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Pesttype\" required \nng-disabled=\"true\"></md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"Treatmentpopupdata.length > 0\"><u>\nTreatment Methods:</u></span></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex \nng-if=\"Treatmentpopupdata.length > 0\" ng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/AddSor.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">SOR Details</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"gridContainer\" \ndx-data-grid=\"dataGridOptions\"></div></md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-disabled=\"Disablesubmit\" \nng-click=\"SubmitSOR()\" aria-label=\"Ok\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog><style>\n.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/crm/contracts/AddTreatmentFrequency.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Work Order Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeWOTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"WOTreatmentpopupdata.length > 0\">\n<u>Treatment Methods:</u></span></div><div layout=\"column\" layout-gt-sm=\"row\" flex \nng-if=\"WOTreatmentpopupdata.length > 0\" ng-repeat=\"Tpd in WOTreatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitWOPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || WOTreatmentpopupdata == null || WOTreatmentpopupdata == \'\'\">\nSubmit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/PreviewTemplate.html","<md-dialog style=\"width: 80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Template</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding:1% 2% 1% 2%\"><div><span>Commencement of Contract</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header\" class=\"pb-32\"></text-angular><span>Service Hours</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header1\" class=\"pb-32\"></text-angular><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Header2\" class=\"pb-32\"></text-angular></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\">Save</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/Reject.html","<md-dialog style=\"width: 28%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMCONTRACTS.REJECT_THIS_CONTRACT\">Reject this Contract</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ReasonforReject\" placeholder=\"{{ \'CRMCONTRACTS.REASON_FOR_REJECT\' | translate }}\" required>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"RejectContract(vm.contractId)\" class=\"md-raised md-accent\" ng-disabled=\"eventForm.$invalid\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/crm/contracts/Revice.html","<md-dialog style=\"width: 28%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMCONTRACTS.REVISE_THIS_CONTRACT\">Revise this Contract</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><md-input-container flex style=\"margin: 0px\"><label \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to Revise this contract?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-top: 20px;padding-left:53px\"><md-button ng-click=\"Revise(vm.ContractId)\" class=\"md-raised md-accent\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></md-input-container></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/crm/contracts/Service.html","<md-dialog ng-style=\"{width:vm.sty + \'%\'}\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0 2% 0 2%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0;flex: 0.5\"><input type=\"text\" \nng-model=\"vm.usName\" placeholder=\"Name\"></md-input-container><md-input-container flex style=\"margin-bottom:0\"><label>\nAddress</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged1()\" \nng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usContactPerson\" \nplaceholder=\"Site Contact Person\"></md-input-container><md-chips \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" ng-init=\"vm.usMobile=[]\" \nname=\"sContactNum\" md-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" \nname=\"sContactNum\" placeholder=\"Contact Number\"></md-chips></div><p \nstyle=\"margin-left: 35%;margin-top: -23px !important\" class=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.ZoneCC\" placeholder=\"Email\" ng-init=\"vm.ZoneCC=[]\" \nreadonly=\"vm.readonly\" style=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" \nflex><md-chips ng-model=\"vm.ZoneEmail\" placeholder=\"CC\" ng-init=\"vm.ZoneEmail=[]\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType CC and Press Enter</span><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"Serviceadd(vm.Index);ClearGrid();\" ng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit\n</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n  .ms-scroll{\r\n    position: relative;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/addpesttype.html","<md-dialog style=\"width:100%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CREATE_CUSTOMER\">Create Customer</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"pesttype\" \nng-model=\"vm.pesttypename\" placeholder=\"{{ \'CRMCONTRACTS.PEST_TYPE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMCONTRACTS.NAME_IS_REQUIRED\">Name is required.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" \ntype=\"text\" name=\"remarks\" ng-model=\"vm.pestcode\" placeholder=\"{{ \'CRMCONTRACTS.PEST_CODE\' | translate }}\" required>\n<div ng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMCONTRACTS.PEST_CODE_IS_REQUIRED\">Pest Code is required.</span></div></div>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"pestsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"CRMCONTRACTS.SUBMIT\">Submit</md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTS.CANCEL\">Cancel</md-button></div></form></div></div></div></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/attachmentdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to delete this Attachment?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Adelete(AttachdeleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br><br></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/contracts/cancelalert.html","<md-dialog style=\"width: 28%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CANCEL_THIS_CONTRACT\">\nCancel this Contract</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div ng-show=\"cancelaccess\" flex><label \ntranslate=\"CRMCONTRACTS.ARE YOU SURE YOU WANT TO CANCEL THIS CONTRACT\" \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to Cancel this Contract ?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-left:53px\"><md-button ng-click=\"CancelContract(vm.contractId)\" class=\"md-raised md-accent\" \ntranslate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/contracts/closealert.html","<md-dialog style=\"width: 23%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCONTRACTS.CLOSE_THIS_CONTRACT\">\nClose this Contract</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><md-input-container flex style=\"margin: 0px\"><label \ntranslate=\"CRMCONTRACTS.ARE YOU SURE YOU WANT TO CANCEL THIS CONTRACT\" \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to close this Contract ?</label>\n<md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"padding-top: 20px;padding-left:53px\"><md-button ng-click=\"CloseContract(vm.contractId)\" \nclass=\"md-raised md-accent\" translate=\"CRMCONTRACTS.YES\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\" translate=\"CRMCONTRACTS.NO\">No</md-button></div></md-input-container></md-input-container>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/contracts/contracts.html","<div id=\"contract\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document-box\"></md-icon><span \nng-show=\"Contractsgrid || Contractsform || ShowContractform\" translate=\"CRMCONTRACTS.HEADER\">Contracts</span> <span \nng-show=\"!Contractsgrid && !Contractsform && !ShowContractform\">Work Order</span></div><div \nng-show=\"Contractsgrid || Contractsform || ShowContractform\" class=\"product-count secondary-text\"><span \ntranslate=\"CRMCONTRACTS.TOTAL_CONTRACTS\">Total Contracts:</span> <span>{{workOrd.length}}</span></div></div><br><div \nclass=\"search\" layout=\"row\" style=\"margin-top: 15px\" ng-show=\"Add\" layout-align=\"start center\" flex><md-input-container\n flex=\"40\" id=\"Datefilter\"><label style=\"color: white; font-size: 14px\" translate=\"CRMSALESORDER.FROM\">From</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-change=\"uTo = uFrom\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label style=\"color: white; font-size: 14px\" \ntranslate=\"CRMSALESORDER.TO\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\">\n</md-datepicker></md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\" style=\"margin-top: -20px\"></md-icon></md-button><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ClearFilter()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-text icon search-icon\" style=\"margin-top: -20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"Addcontract()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CRMCONTRACTS.ADD\">Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"CRMCONTRACTS.BACK\">Back</span></md-button></div></div><div class=\"content\" \nng-show=\"Contractsgrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab \nng-click=\"workOrd=Pendingcontractdatas;\"><md-tab-label><span>Pending</span></md-tab-label><md-tab-body><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridPending\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=contractdatas;\"><md-tab-label><span>On-Going</span></md-tab-label><md-tab-body><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridContract\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=contractRenewaldatas;\"><md-tab-label><span>Renewal</span></md-tab-label><md-tab-body><div \nid=\"RenewalContainer\" dx-data-grid=\"vm.dataGridRenewal\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=PastContractdatas;\"><md-tab-label><span>Past Contract</span></md-tab-label><md-tab-body><div \nid=\"PastContractContainer\" dx-data-grid=\"vm.dataGridPastContract\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=Terminateddatas; getTerminated()\"><md-tab-label><span>Terminated</span></md-tab-label><md-tab-body>\n<div id=\"TerminateContainer\" dx-data-grid=\"vm.dataGridTerminated\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=OnHolddatas; getOnHolddatas()\"><md-tab-label><span>On-Hold</span></md-tab-label><md-tab-body><div \nid=\"TerminateContainer\" dx-data-grid=\"vm.dataGridOnHold\"></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"content\" style=\"padding-top: 30px\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"ShowContractform\" flex><span ng-if=\"Update\" style=\"font-size: 18px; font-weight: 500\">{{vm.ContractReference}}\n</span><form name=\"basicForm\" class=\"md-inline-form\" novalidate><br><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex ng-hide=\"Update\"><label>Customer Name</label><md-select ng-model=\"vm.Customer_id\" \nname=\"CustomerName\" md-on-close=\"vm.searchTermC = \'\'\" id=\"searchmodule\" ng-required=\"Update==false\" \nng-disabled=\"Update\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_CUSTOMER\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Customer_id = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float: right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatasfordropdown | filter:vm.searchTermC\" ng-click=\"ChangeCustomer(row)\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex ng-show=\"Update\"><input \ntype=\"text\" ng-model=\"vm.ppCompanyName\" readonly=\"readonly\" placeholder=\"Customer Name\"></md-input-container>\n<md-input-container flex><label translate=\"CRMCONTRACTS.SALES_PERSON\">Sales Person</label><md-select \nng-model=\"vm.SalesPerson\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required ng-disabled=\"Update \">\n<md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMCONTRACTS.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS=\'\'\" aria-label=\"Close dialog\" \nstyle=\"float: right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.CMarketSegment\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search For a Segment\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CMarketSegment = null\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" \nng-value=\"row\">{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.CSalutation\" readonly=\"readonly\" \nplaceholder=\"Salutation\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.CName\" \nreadonly=\"readonly\" placeholder=\"Name\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -15px\"><md-input-container flex><label>Billing Address</label><md-select ng-model=\"vm.BAddress\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search For Billing Address\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.BAddress = null\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CustomerBillingAddress | filter:vm.searchTermC\" value=\"{{row._id}}\" \nng-click=\"vm.CEmail=row.bEmail.split(\',\') ; vm.CName=row.bContactPerson ; vm.Ccontact=row.bMobile.split(\',\')\">\n{{row.bStreetName}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Biiling Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><br><div layout=\"column\"><div layout=\"column\" style=\"width: 100%\"><md-chips \nflex style=\"height: auto\" ng-model=\"vm.Ccontact\" name=\"Ccontact\" ng-init=\"vm.Ccontact=[]\" md-separator-keys=\"vm.keys\" \nmd-max-chips=\"4\" input-aria-label=\"Ccontact\"><input type=\"text\" name=\"Ccontact\" placeholder=\"Contact Number\" \nmd-on-add=\"vm.onContactChipAdd($chip)\"></md-chips><div class=\"error-message\" ng-show=\"vm.contactChipWarning\" \nstyle=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the contact number.</div><p class=\"md-caption\" \nstyle=\"margin-top: 4px\"><b>Note</b>\n: Separate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><div \nng-show=\"vm.contactErrorMessage\" style=\"color: red\">Invalid format. Use +60-123-4567-89</div></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 47px\"><md-chips md-transform-chip=\"transformChip($chip)\" flex \nstyle=\"height: 13% !important\" ng-model=\"vm.CEmail\" name=\"Email\" ng-init=\"vm.CEmail=[]\" input-aria-label=\"Email\"><input\n type=\"text\" name=\"Email\" placeholder=\"Email\" md-on-add=\"vm.onEmailChipAdd($chip)\"></md-chips></div><div \nng-show=\"vm.emailValidationError\" style=\"color: red; font-size: 13px\">Please enter valid email.</div><div \nng-show=\"vm.emailChipWarning\" style=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the email.</div>\n<span class=\"h5\" style=\"color: #7f9593; margin-top: 1%\">Type Email and Press Enter </span><span style=\"color: #7f9593\">\n<h3>Site Details</h3></span><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"RenewalUpdate==false\"><md-input-container \nflex><label>Service Address</label><md-select ng-model=\"vm.CAddress\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.CAddress = null\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nng-value=\"row\">{{row.sName}} {{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container></div><div\n layout=\"column\" layout-gt-sm=\"row\" ng-if=\"RenewalUpdate==true\"><md-input-container flex ng-if=\"Update==false\"><label>\nService Address</label><md-select ng-model=\"vm.CAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CAddress = null\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nvalue=\"{{row._id}}\">{{row.sName}} {{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 27px\"><md-input-container flex><label>Service Hours\n</label><md-select ng-model=\"vm.ServiceHours\" id=\"searchmodule\" md-on-close=\"vm.searchTerm2 = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Service Hours\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ServiceHours = null;vm.searchTerm2=\'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"During Office Hours\">\nOffice Hours 9am - 5pm</md-option><md-option value=\"After Office Hours\">After Office Hours 5:00pm - 12:00mn</md-option>\n<md-option value=\"Wee Hours\">Wee Hours 12:00mn - 9am</md-option></md-select></md-input-container><md-input-container \nflex style=\"margin-top: 18px; margin-left: 10px\"><label>Service Start Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required \nng-change=\"getServiceEndDate(vm.ServiceStartDate);getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\" \nstyle=\"margin-left: -10px\"></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Service End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required style=\"margin-left: -10px\" \nng-change=\"getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\"></md-datepicker></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Payment Term</label><md-select \nng-model=\"vm.CreditTerm\" id=\"searchmodule\" md-on-close=\"vm.searchTermcc = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" placeholder=\"Payment Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentTermdatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><input type=\"number\" \nng-model=\"vm.TotalOrderValue\" placeholder=\"Total Contract Sum\" \nng-change=\"getMonthAmount(vm.TotalMonth,vm.TotalOrderValue)\" required></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><input type=\"text\" ng-model=\"vm.PurchaseOrder\" placeholder=\"Purchase Order\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"RenewalUpdate==true\"><input type=\"text\" \nng-model=\"vm.RenewalRemarks\" placeholder=\"Renewal Remarks\"></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin: 0; padding-left: 1%\"><md-checkbox ng-model=\"vm.IncludeSOR\" \nng-change=\"SORDerails(vm.IncludeSOR,$event,true)\" type=\"checkbox\"><span>Include SOR? </span>&emsp;</md-checkbox><span \nid=\"viewsor\" ng-show=\"vm.IncludeSOR\" ng-click=\"SORDerails(true,$event,false)\">View/Edit SOR Details </span>&emsp;\n</md-input-container><md-input-container flex style=\"margin: 0; padding-left: 1%\" ng-show=\"Update == false\">\n</md-input-container></div><div style=\"padding-bottom: 2%\"><span class=\"h3\" style=\"color: #7f9593\"><b>\nPEST CONTROL SERVICES :</b></span><md-button id=\"viewedit\" class=\"md-raised md-button md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddPestType($event)\" style=\"float: right\">Add Frequency</md-button></div>\n<table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\" \nstyle=\"border: 1px solid rgb(224, 224, 224); font-size: 13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Method</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>\n{{ row.Frequency }}</td><td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EditPestControl($event,row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"Frequencydatas.length == 1\" ng-click=\"DeletePestControl(row)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table><div style=\"padding-bottom: 2%\" ng-if=\"Update == true\"><span \nclass=\"h3\" style=\"color: #7f9593\"><b>ATTACH SIGNED CONTRACT :</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-if=\"Update == true\" style=\"border: 1px solid rgb(224, 224, 224)\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3, 155, 229);\r\n                      margin-bottom: 0px;\r\n                      height: 18px\" \ntranslate=\"CRMLEAD.BROWSE\">Browse</label></div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"UploadContractfiles(uploader.flow.files);uploader.flow.files = []\" \nstyle=\"float: right\"><span>Upload</span></md-button><table style=\"float: left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ContarctAttachmentdatas\">\n<td></td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download style=\"cursor: pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ClickTemplate($event) \" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || Frequencydatas.length == 0\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div><div \nclass=\"content\" ng-show=\"Contractsform\"><form name=\"wizardStep1\" class=\"md-inline-form\" novalidate \nstyle=\"padding-bottom: 0px\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width: 100%; border: 1px solid rgb(224, 224, 224); float: left\"><div layout=\"row\"><div layout=\"column\" \nstyle=\"width: 45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width: 100%\"><label style=\"font-size: 17px\">\nContract Details :</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width: 30%\"><span \nstyle=\"font-size: 15px; color: #7f9593\"><b>Contract Reference #</b></span></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 13px; padding-left: 2%\"><b>{{vm.ContractReferenceNo}}</b></span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Cutsomer Name</b></label></div>\n<label style=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.uCompanyName1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Sales Person</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.SalesPerson1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Payment Term</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.CreditTerm}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Billing Frequency</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.Frequency}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Service Start Date</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.ServiceStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Service End Date</b></label>\n</div><label style=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.ServiceEndDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Total Contract Sum</b></label>\n</div><label style=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.TotalSum}}</span></div></div></div><div layout=\"column\" \nstyle=\"width: 45%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width: 100%\"><label style=\"font-size: 17px\"></label></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width: 30%\"><span style=\"font-size: 15px; color: #7f9593\"><b>\nContact Person</b></span></div><label style=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width: 60%\"><span style=\"font-size: 13px; padding-left: 2%\"><b>{{vm.uContactPerson}}</b></span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Phone\n</b></label></div><label style=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\">\n<span style=\"font-size: 14px; padding-left: 2%\">{{vm.Ccontact}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Email</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.uEmail}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Purchase Order</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.PurchaseOrder}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Billing Address</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.uAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Service Address</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.uSAddress}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 30%\"><label style=\"font-size: 15px; color: #7f9593\"><b>Service Hours</b></label></div><label \nstyle=\"font-size: 15px; color: #7f9593\"><b>:</b></label><div class=\"p-4\" style=\"width: 60%\"><span \nstyle=\"font-size: 14px; padding-left: 2%\">{{vm.ServiceHours}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width: 70%\"></div><label style=\"font-size: 15px; color: #7f9593\"></label><div class=\"p-4\" style=\"width: 60%\">\n</div></div></div><div layout=\"column\" style=\"width: 15%; margin-top: 10px; float: right\"><a \nng-click=\"Contractclose($event, vm.ContractId)\" style=\"cursor: pointer; font-size: 14px; color: orangered\" \nng-hide=\"vm.ContractStatus == \'Closed\'\">Cancel Contract</a></div></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span class=\"h3\" style=\"color: #7f9593\"><b>ATTACH SIGNED CONTRACT :</b>\n</span></div><md-content layout-padding><div flow-init flow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label \nfor=\"file-input2\" \nstyle=\"color: rgb(3, 155, 229);\r\n                    margin-bottom: 0px;\r\n                    height: 18px\" \ntranslate=\"CRMLEAD.BROWSE\">Browse</label></div><input class=\"file-input2\" flow-btn id=\"file-input2\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"UploadContractfiles(uploader.flow.files);uploader.flow.files = []\" \nstyle=\"float: right\"><span>Upload</span></md-button><table style=\"float: left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content><table class=\"dataTable row-border hover\" style=\"border: 1px solid #d0d3d3\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ContarctAttachmentdatas\">\n<td></td><td><a href=\"{{UploadsURL}}CRM/Contracts/{{row.TableID}}\" download style=\"cursor: pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" \nstyle=\"margin: 20px 20px 20px 20px\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 20px\"><span \nclass=\"h3\" style=\"color: #7f9593\"><b>PEST CONTROL SERVICES :</b></span></div><table class=\"dataTable row-border hover\" \nstyle=\"border: 1px solid #d0d3d3\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nTreatment Method</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas | orderBy:\'-Freq\'\"><td \nstyle=\"font-size: 14px\">{{$index+1}}</td><td style=\"font-size: 14px\">{{ row.Frequency }}</td><td \nstyle=\"font-size: 14px\">{{ row.PestType }}</td><td style=\"font-size: 14px\">{{ row.Treatment }}</td></tr></tbody>\n</table></div></div></form></div><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Salesform\" flex><form \nname=\"SbasicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-radio-container flex \nstyle=\"height: 70px\"><md-radio-group ng-model=\"vm.OrderType\" layout=\"row\" style=\"margin: 0\" required><span \nstyle=\"color: #7f9593;\r\n                padding-top: 5px;\r\n                float: left;\r\n                padding-right: 10px\">\nType :</span><md-radio-button value=\"Contract\">Contract</md-radio-button><md-radio-button value=\"Renewal\">Renewal\n</md-radio-button></md-radio-group></md-radio-container><md-radio-container flex style=\"height: 70px\"><md-radio-group \nng-model=\"vm.IsUrgent\" layout=\"row\" style=\"padding-left: 20px; margin: 0 !important\" required><span \nstyle=\"color: #7f9593;\r\n                padding-top: 5px;\r\n                float: left;\r\n                padding-right: 10px\">\nVIP ? :</span><md-radio-button value=\"true\">Yes</md-radio-button><md-radio-button value=\"false\">No</md-radio-button>\n</md-radio-group><md-radio-group ng-model=\"vm.TrendingReport\" layout=\"row\" \nstyle=\"margin: 20px 0 0 0px; margin-left: -35px\"><span \nstyle=\"color: #7f9593;\r\n                padding-top: 5px;\r\n                float: left;\r\n                padding-right: 10px\">\nTrending Reports? :</span><md-radio-button value=\"true\">Yes</md-radio-button><md-radio-button value=\"false\">No\n</md-radio-button></md-radio-group></md-radio-container></div><br><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Salesperson</label><md-select ng-model=\"vm.SalesPerson\" name=\"SalesPerson\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermS\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SalesPerson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.uCompanyName\" \nreadonly=\"readonly\" placeholder=\"Customer Name\"></md-input-container><md-input-container flex><label>Contract #</label>\n<input type=\"text\" ng-model=\"vm.ContractReferenceNo\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Contact Person</label><input type=\"text\" \nng-model=\"vm.BContactPerson\" readonly=\"readonly\"></md-input-container><md-input-container flex><label>Billing Address\n</label><input type=\"text\" ng-model=\"vm.BAddress\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -17px\"><md-chips flex style=\"height: 13% !important\" ng-model=\"vm.BContactNo\" \nname=\"BContactNo\" md-separator-keys=\"vm.keys1\" md-max-chips=\"4\" input-aria-label=\"Ccontact\"><input type=\"number\" \nname=\"BContactNo\" placeholder=\"Contact No (max 3)\"></md-chips></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 47px\"><md-chips ng-model=\"vm.BEmail\" placeholder=\"Email\" \nstyle=\"width: 100%; margin-top: -2%; margin-bottom: 30px\"></md-chips></div><div class=\"h4\" \nstyle=\"color: #7f9593; margin-top: -15px\">Type Email and Press Enter</div><span style=\"color: #7f9593\"><h3>Site Details\n</h3></span><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 27px\"><md-input-container flex><label>\nService Address</label><md-select ng-model=\"vm.SLocation\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required \nng-disabled=\"DisableServiceLocation\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Location\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SLocation = null\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nvalue=\"{{row._id}}\" ng-init=\"vm.ServiceEmail=row.sEmail; vm.ServiceEmailCC=row.sCC\">{{row.sStreetName}}</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px; flex: 0.5\"><label>Billing Frequency\n</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" md-on-close=\"vm.searchTerm1 = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Billing Frequency\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 27px\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Payment Mode</label><md-select ng-model=\"vm.PaymentMode\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermPm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'CRMSALESORDER.PAYMENT_MODE\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PaymentMode = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" placeholder=\"Total Price\" ng-model=\"vm.TotalPrice\" \nrequired></md-input-container><md-input-container flex><input type=\"text\" placeholder=\"Special Chemical/Equipments\" \nng-model=\"vm.SpecialChemical\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nid=\"date4\" flex style=\"margin-top: 18px\"><label>Service Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceStartDate\" ng-change=\"getServiceEndDate(vm.ServiceStartDate)\" required md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label>\nService End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" required \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container \nflex style=\"margin-top: 18px\"><input type=\"number\" placeholder=\"Estimated Man Hours Needed\" \nng-model=\"vm.EstimatedHoursRequired\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Coverage Area</label><input type=\"text\" \nng-model=\"vm.CoverageArea\"></md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"Purchase Order No\" ng-model=\"vm.PurchaseOrderNo\"></md-input-container><md-input-container><input \ntype=\"text\" placeholder=\"Remarks for Finance\" ng-model=\"vm.RemarksFinance\"></md-input-container></div><label \nstyle=\"width: 21%; font-weight: bold; color: #7f9593\">Message to Operation</label><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Message\"></text-angular><br><div><span class=\"h3\" style=\"color: #7f9593\"><b>TREATMENT FREQUENCY :</b>\n</span><md-button id=\"viewedit\" class=\"md-raised md-button md-ink-ripple md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddWOPestType($event)\" style=\"float: right\">Add Frequency</md-button></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin-top: 10px\"><table\n class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border: 1px solid rgb(224, 224, 224); font-size: 13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Methods</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">No of Job/Frequency</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Total Services Required</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in WOFrequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}\n</td><td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td>\n{{ row.JobsPerFrequency }}</td><td>{{ row.ServicesRequired }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Editpest($event, row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"WOFrequencydatas.length == 1\" ng-click=\"Deletepest(row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"white-bg md-whiteframe-4dp\" \nstyle=\"width: 49%;\r\n            border: 1px solid rgb(224, 224, 224);\r\n            float: left;\r\n            height: 30%\">\n<div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width: 100%; border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size: 17px\">Comments\n</label></div></div><md-input-container flex style=\"width: 95.9%; margin-left: 15px; margin-right: 15px\"><input \ntype=\"text\" placeholder=\"Comments\" ng-model=\"vm.SpecialRemarks\"><md-button class=\"btn btn-info md-raised\" \nstyle=\"position: absolute; margin-left: -7%; margin-top: -1%\" ng-click=\"AddComment(vm.SpecialRemarks);\"><span>Add\n</span></md-button></md-input-container><div \nstyle=\"background-color: whitesmoke;\r\n              overflow-y: scroll;\r\n              height: 200px\"><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }}</h3><md-button style=\"position: absolute; left: 60%; margin: 0\" id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeleteComment(item)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><h4>{{ item.CreatedDate | date:\'d/MM/y HH:mm:ss\'}}</h4><p>{{ item.cmt }}</p></div></md-list-item>\n</md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width: 49%;\r\n            border: 1px solid rgb(224, 224, 224);\r\n            float: right;\r\n            margin-left: 20px\">\n<div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width: 100%; border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size: 17px\" \ntranslate=\"CRMLEAD.ATTACHMENTS\">Attachments :</label></div></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input1\" \nstyle=\"color: rgb(3, 155, 229);\r\n                    margin-bottom: 0px;\r\n                    height: 18px\" \ntranslate=\"CRMLEAD.BROWSE\">Browse</label></div><input class=\"file-input1\" flow-btn id=\"file-input1\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"Uploadfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float: right\">\n<span>Upload Attachments</span></md-button><table style=\"float: left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>&nbsp;</td>\n<td><a href=\"{{UploadsURL}}CRM/SalesOrder/{{row.TableID}}\" download style=\"cursor: pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"WOSubmit()\" aria-label=\"Submit\" \nng-disabled=\"SbasicForm.$invalid || WOFrequencydatas.length == 0\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\" translate=\"CRMSALESORDER.CANCEL\">Cancel</md-button></div></form></div></div>\n<div class=\"content\" id=\"invoice\" ng-show=\"Previewdiv\"><div style=\"height: 100px\"><div style=\"width: auto\"></div><div \nstyle=\"font-size: 25px; font-weight: 500; float: right\"><img src=\"assets/images/logos/pest_logo.png\" \nstyle=\"width: 200px; height: 100px\"></div></div><h3 style=\"font-weight: 600; text-align: center\"><b>\nPEST MANAGEMENT SERVICE CONTRACT</b></h3><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.Message\" ng-disabled class=\"pb-32\"></text-angular></div><br><h3 style=\"font-weight: 500\"><b>SCOPE OF WORK\n</b></h3><ul style=\"width: 100%\" ng-repeat=\"items in Frequencygroups\"><h4 style=\"font-weight: 500\"><b>\n{{items[0].Frequency}}</b></h4><li style=\"list-style-type: none; padding-left: 3%\" ng-repeat=\"row in items\"><h5 \nstyle=\"font-weight: 500\"><u>{{row.PestType}}</u></h5><ul ng-repeat=\"rows in SOWdatas\" \nng-if=\"rows.PestType == row.PestType\" style=\"padding-left: 3%\"><li>{{rows.Scopeofwork}}</li></ul></li></ul></div>\n<style>\n@media only screen and (max-width: 2200px) {\r\n    md-datepicker .md-datepicker-input {\r\n      width: calc(27vw - 20px) !important;\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: -11px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n      width: calc(4.3vw - 20px) !important;\r\n      max-width: calc(25vw - 54px);\r\n    }\r\n  }\r\n\r\n  @media only screen and (max-width: 1600px) {\r\n    md-datepicker .md-datepicker-input {\r\n      width: calc(24.3vw - 20px) !important;\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: -11px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n      width: calc(3.3vw - 20px) !important;\r\n      max-width: calc(35vw - 54px);\r\n    }\r\n  }\r\n\r\n  @media only screen and (max-width: 1150px) {\r\n    md-datepicker .md-datepicker-input {\r\n      width: calc(18vw - 20px) !important;\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: -11px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n      width: calc(2.3vw - 20px) !important;\r\n      max-width: calc(25vw - 54px);\r\n    }\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(30vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .label {\r\n    margin-top: -5px !important;\r\n    margin-bottom: -5px !important;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n  .chipsdemoContactChips md-content.autocomplete input {\r\n    min-width: 400px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected h3 {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text {\r\n    padding: 14px 0;\r\n    max-width: 190px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n    line-height: 1.2em !important;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n  .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  .file-input1 {\r\n    display: none !important;\r\n  }\r\n\r\n  .file-input2 {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    border-bottom: 1px solid #23527c;\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  /* #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n    } */\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\n</style><style>\n.md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  .md-tab.md-active {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  .dx-switch-handle:before {\r\n    background-color: #039be5de !important;\r\n  }\r\n\r\n  #viewsor:hover {\r\n    color: rgb(3, 155, 229) !important;\r\n    font-style: italic;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  #viewsor {\r\n    color: rgb(181, 219, 238) !important;\r\n    font-style: italic;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .ta-scroll-window>.ta-bind {\r\n    height: auto;\r\n    min-height: 80px;\r\n    padding: 6px 12px;\r\n  }\r\n\r\n  .ta-editor.ta-html,\r\n  .ta-scroll-window.form-control {\r\n    min-height: 100px;\r\n    height: auto;\r\n    overflow: auto;\r\n    font-family: inherit;\r\n    font-size: 100%;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/contracts/renewal.html","<md-dialog style=\"width:100%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{\'CRMCONTRACTS.CONTRACT\'|translate}} ({{vm.Crn}}) {{\'CRMCONTRACTS.RENEWAL\'|translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:1% 2% 1% 2%\"><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container style=\"width: 50%\"><span translate=\"CRMCONTRACTS.CUSTOMER_NAME\" \nstyle=\"color:#7f9593;font-size:16px\">Customer Name : &emsp;{{vm.Cname}}</span></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.CONTRACT_START_DATE\">Contract Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ContractStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"CRMCONTRACTS.CONTRACT_END_DATE\">Contract End Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ContractEndDate\" required \nmd-min-date=\"vm.ContractStartDate\" ng-change=\"DaysCalc(this)\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.ContractDuration\" \nplaceholder=\"{{\'CRMCONTRACTS.CONTRACT_DURATION(IN_DAYS)\'|translate}}\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.SERVICE_START_DATE\">Service Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceStartDate\" md-min-date=\"vm.ContractStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTS.SERVICE_END_DATE\">Service End Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceEndDate\" md-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex><label translate=\"CRMCONTRACTS.FREQUENCY\">Frequency</label><md-select \nng-model=\"vm.Frequency\" id=\"searchmodule\" required><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\">{{\'CRMCONTRACTS.FREQUENCY\'|translate}}..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"Daily\" translate=\"CRMCONTRACTS.DAILY\">Daily</md-option>\n<md-option value=\"Weekly\" translate=\"CRMCONTRACTS.WEEKLY\">Weekly</md-option><md-option value=\"Fortnightly\" \ntranslate=\"CRMCONTRACTS.FORTNIGHTLY\">Fortnightly</md-option><md-option value=\"Monthly\" \ntranslate=\"CRMCONTRACTS.MONTHLY\">Monthly</md-option><md-option value=\"Quarterly\" translate=\"CRMCONTRACTS.QUARTERLY\">\nQuarterly</md-option><md-option value=\"Half-Yearly\" translate=\"CRMCONTRACTS.HALF_YEARLY\">Half-Yearly</md-option>\n<md-option value=\"Yearly\" translate=\"CRMCONTRACTS.YEARLY\">Yearly</md-option></md-select></md-input-container></div><div\n layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"RenewalSubmit(vm.RenewalId)\" ng-disabled=\"eventForm.$invalid\" translate=\"CRMCONTRACTS.SUBMIT\">Submit\n</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCONTRACTS.CANCEL\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 14px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/customer/BeforeAssignedUser.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">ASSIGN USERS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Users</label><md-select \nng-model=\"vm.UpdateAssignedUser\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" \nng-model-options=\"{trackBy: \'$value.UserID\'}\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a user..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.UpdateAssignedUser = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ResignedUsers | filter:vm.searchTermC\" ng-value=\"row\">{{row.UserID}}</md-option></md-select>\n</md-input-container></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"UpdateAssignedUser()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/crm/customer/BeforeAssignedUserforCustomer.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">ASSIGN USERS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-if=\"IsAdmin\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Users</label><md-select \nng-model=\"vm.UpdateAssignedUserforCustomer\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" \nng-model-options=\"{trackBy: \'$value.UserID\'}\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a user..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.UpdateAssignedUserforCustomer = null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ResignedUsers | filter:vm.searchTermC\" ng-value=\"row\">{{row.UserID}}</md-option></md-select>\n</md-input-container></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"UpdateAssignedUserforCustomer()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">\nSave</md-button><md-button type=\"submit\" class=\"md-raised\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button>\n</div></div><div ng-if=\"!IsAdmin\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.Comments\" placeholder=\"{{ \'CRMLEAD.COMMENT_HERE..\' | translate }}\"></md-input-container></div>\n<br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AssignbyComment()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" class=\"md-raised\" \nng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/customer/BeforeUpdateEmail.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nUpdate Email for Selected Service Address</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><span class=\"h4\" style=\"color:#7f9593\"><b>Email :</b></span><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.UpdateEmail\" placeholder=\"Email\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"GetDetailsforUpdateEmail()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/customer/Details.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-span=\"Close dialog\" translate \ntranslate-attr-aria-span=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:1% 1% 1% 1%\"><div class=\"content\" \nng-if=\"vm.Title == \'WorkOrder\'\"><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg\" \nstyle=\"width:50%;border:1px solid rgb(224, 224, 224);float:left;border-right:none;height:95%\"><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><span style=\"font-size:17px\">Work Order Details :</span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Work Order #</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:\n</b></span><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.SalesOrderNo}}</span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract #</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:</b>\n</span><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.ContractReferenceNo}}\n</span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Billing Address</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:\n</b></span><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.BillingAddress}}</span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contact No</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:</b>\n</span><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.SMobile}}</span></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>\nService Location</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.ServiceLocation}}</span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Enqiury No\n</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.EnquiryRefNo}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Service Start Date</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Total Price</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.TotalPrice}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Coverage Area</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.CoverageArea}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Pest Type</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.PestType}}</span></div></div><br></div><div class=\"white-bg\" \nstyle=\"width:50%;border:1px solid rgb(224, 224, 224);float:right;border-left:none;height:95%\"><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%\"><span style=\"font-size:17px\"></span></div></div><br><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>SalesPerson</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SalesPerson}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Type</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.OrderType}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Contact Person</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SContactPerson}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Email</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SEmail}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Payment Mode</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.PaymentMode}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Payment Terms</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.PaymentMode}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Service End Date</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceEndDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Billing Frequency</b></span></div>\n<span style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.BillingFrequency}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Estimated Man hours Needed</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.EstimatedHoursRequired}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Prefered Date and Time of Treatment\n</b></span></div><span style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.DateTimeofTreatment}}</span></div></div><br></div></div></div></div></div>\n<div class=\"content\" ng-if=\"vm.Title == \'Contract\'\"><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%;border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><span style=\"font-size:17px\">Contract Details :</span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract Reference #</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:13px;padding-left:2%\"><b>{{vm.ContractReferenceNo}}</b></span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Work Order #</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.SalesOrderID1}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Contract Start Date</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ContractStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Current Contract End Date</b></span>\n</div><span style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ContractEndDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Pest Type</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.PestType}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Status</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.CurrentStatus}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Frequency</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.Frequency}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Service Start Date</b></span></div><span \nstyle=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceStartDate| date:\'dd/MM/y\'}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>Service End Date</b></span></div><span\n style=\"font-size:15px;color:#7f9593\"><b>:</b></span><div class=\"p-4\" style=\"width:60%\"><span \nstyle=\"font-size:14px;padding-left:2%\">{{vm.ServiceEndDate| date:\'dd/MM/y\'}}</span></div></div></div></div></div></div>\n</div><div class=\"content\" ng-if=\"vm.Title == \'Schedule\'\"><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\">\n<div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Service Details :</label>\n</div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract #</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ContractReferenceNo}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Start Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">End Time\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.ServiceEndAt | date:\"hh:mm a\"}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PestType1}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Types}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service On</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceOn}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Time</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"hh:mm a\"}}</span>\n &emsp;<a href=\"\" style=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" ng-click=\"Showlocation(vm.StartLocation)\">\nShow Location</a></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual End Time</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.AServiceEndAt | date:\"hh:mm a\"}}</span> &emsp;<a href=\"\" \nstyle=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" ng-click=\"Showlocation(vm.EndLocation)\">Show Location</a>\n</div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed To</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentTo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentDate | date:\"dd/MM/y hh:mm a\"}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Performed By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgressedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedDate | date:\"dd/MM/y hh:mm a\"}}</span></div></div></div>\n</div></div></div></div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n    font-size: smaller;\r\n    padding: 0;\r\n}\r\n        .color-red {\r\n  color: red;\r\n}\r\n  md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 95%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/customer/Service.html","<md-dialog style=\"overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0 2% 0 2%; width: 800px\"><div ng-show=\"Service\"><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><md-checkbox ng-model=\"Servicecopy.value\" \nng-change=\"copymain(this)\" type=\"checkbox\"><span>Copy from main address?</span></md-checkbox><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0;flex: 0.5\"><input type=\"text\" \nng-model=\"vm.usName\" placeholder=\"Site Name\"></md-input-container><md-input-container flex style=\"margin-bottom:0\">\n<label>Address</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged1()\" \nng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usContactPerson\" \nplaceholder=\"Site Contact Person\"></md-input-container><md-chips id=\"Contact2service\" \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" md-separator-keys=\"vm.keys\" \nmd-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" name=\"sContactNum\" placeholder=\"Contact Number\" \nmd-on-add=\"vm.onContactChipAdd1($chip)\"></md-chips></div><div class=\"error-message\" ng-show=\"vm.contactChipWarning1\" \nstyle=\"color: red; font-size: 13px;margin-left: 35%; margin-top: -20px\">\nPlease press \"Enter\" after typing the contact number.</div><p style=\"margin-left: 35%!important\" class=\"md-caption\"><b>\nNote</b>:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-init=\"vm.initEmailChipHandler()\" id=\"Email2service\" \nng-model=\"vm.ZoneCC\" readonly=\"vm.readonly\" md-transform-chip=\"transformChip1($chip)\" \nstyle=\"width: 100%;padding:0!important\"><input type=\"text\" name=\"sEmail\" placeholder=\"Email\" \nmd-on-add=\"vm.onEmailChipAdd1($chip)\"></md-chips></div><div class=\"error-message\" ng-show=\"vm.emailChipWarning1\" \nstyle=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the Email.</div><div \nng-show=\"vm.emailValidationError1\" style=\"color: red; font-size: 13px\">Please enter valid email.</div><span class=\"h4\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" \nflex><md-chips md-transform-chip=\"transformChip2($chip)\" ng-model=\"vm.ZoneEmail\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"><input type=\"text\" name=\"sEmail\" placeholder=\"CC\" \nmd-on-add=\"vm.onCCChipAdd($chip)\"></md-chips></div><div ng-show=\"vm.emailValidationError2\" \nstyle=\"color: red; font-size: 13px\">Please enter valid email.</div><div class=\"error-message\" \nng-show=\"vm.emailccWarning\" style=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the Email.</div><span\n class=\"h4\" style=\"color:#7f9593;margin-top:1%\">Type CC and Press Enter</span><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Serviceadd(vm.Index);ClearGrid();\" \nng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div>\n</form></div><div ng-show=\"Billing\"><form name=\"BillingForm\" class=\"md-inline-form\" novalidate><md-checkbox-container \nflex><md-checkbox ng-model=\"checkboxModel.value\" ng-change=\"copybilling(this)\" type=\"checkbox\"><span \ntranslate=\"CRMCUSTOMER.COPY_FROM_MAIN_ADDRESS\">Copy from main address?</span></md-checkbox></md-checkbox-container><div\n layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubContactPerson\" \nplaceholder=\"{{ \'CRMCUSTOMER.CONTACT_PERSON\' | translate }}\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.ubMobile\" placeholder=\"{{ \'CRMCUSTOMER.MOBILE\' | translate }}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"email\" name=\"ubEmail\" \nng-model=\"vm.ubEmail\" placeholder=\"{{ \'CRMCUSTOMER.EMAIL\' | translate }}\"> <span \nng-show=\"BillingForm.ubEmail.$error.email && BillingForm.ubEmail.$touched\" style=\"color: red; font-size: 13px\">\nPlease enter valid email.</span></md-input-container><md-input-container flex><label>Address</label><input \nplaces-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged2()\" ng-model=\"vm.ubStreetName\" placeholder=\"\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" \nng-model=\"vm.ubBuildingName\" placeholder=\"{{ \'CRMCUSTOMER.BUILDING_NAME\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.ubPostal\" \nplaceholder=\"{{ \'CRMCUSTOMER.POSTAL_CODE\' | translate }}\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Billingadd(vm.Index)\" \nng-disabled=\"BillingForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div></form></div>\n</md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n\r\n  .ms-scroll {\r\n    position: relative;\r\n  }\r\n\r\n  .md-dialog-content {\r\n    max-height: 800px;\r\n    max-width: 900px;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/customer/addcoments.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Service Job Preview ({{vm.ServiceID}})</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract #</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ContractReferenceNo}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Start Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">End Time\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.ServiceEndAt | date:\"hh:mm a\"}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PestType1}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Types}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service On</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceOn}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Time</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"hh:mm a\"}}</span>\n &emsp;<a href=\"\" style=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" ng-click=\"Showlocation(vm.StartLocation)\">\nShow Location</a></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual End Time</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.AServiceEndAt | date:\"hh:mm a\"}}</span> &emsp;<a href=\"\" \nstyle=\"font-size: 14px\" ng-if=\"vm.Status == \'Completed\'\" ng-click=\"Showlocation(vm.EndLocation)\">Show Location</a>\n</div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed To</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentTo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentDate | date:\"dd/MM/y hh:mm a\"}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Performed By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgressedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedDate | date:\"dd/MM/y hh:mm a\"}}</span></div></div></div>\n</div><div layout=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\" layout=\"row\" \nlayout-gt-xs=\"row\" ng-if=\"latlng != null && latlng != \'\'\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:99%;margin-right:1%; border:1px solid rgb(224, 224, 224);float:left\"><ng-map id=\"mapa\" \ncenter=\"{{center}}\" zoom=\"5\" maximum-zoom=\"17\" street-view-control=\"true\" zoom-control=\"true\" \nzoom-to-include-markers=\"true\" ng-click=\"getpos($event)\"><marker position=\"{{latlng}}\" ng-dragend=\"getpos($event)\" \nanimation=\"Animation\" animation=\"DROP\" draggable=\"true\"></marker></ng-map></div></div></div></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Mobile Logs</span></md-tab-label><md-tab-body><div layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex style=\"padding:1%\"><label \nstyle=\"width:16%;font-weight:bold;color:#7f9593\">Services:</label><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptionspopup\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Services\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Tabletlighttracklistdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.Services }}</td></tr></tbody></table></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><label style=\"width:16%;font-weight:bold;color:#7f9593\">Materials:</label>\n<table id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptionspopup\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Materials\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in TabletMaterialslistdatas\"><td>&nbsp;</td><td>{{ row.PestType }}</td><td>{{ row.MaterialName }}</td>\n<td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td></tr></tbody></table></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Details</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Lead Name :</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.TeamLead}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\">\n<span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Members :</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">\n{{vm.TeamMembers}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:12%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Remarks :</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.TeamRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Technician Signature :</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:150px; width:40%; border:1px solid rgba(0, 0, 0, 0.12)\"><img \ndata-ng-src=\"data:image/png;base64,{{vm.TeamSignature}}\" style=\"height: 150px\" ng-if=\"vm.TeamSignature\" alt=\"\"></div>\n</div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos Before :</span></div></div><div layout-gt-sm=\"column\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in PhotosBdatas\" ng-switch \non=\"$index % 6\"><img ng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"Zoom Image\"> <img\n ng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+1].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+1].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+2].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+2].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+3].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+3].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+4].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+4].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+5].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+5].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n<div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos After :</span></div></div><div layout-gt-sm=\"column\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in PhotosAdatas\" ng-switch \non=\"$index % 6\"><img ng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+1].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+1].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+2].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+2].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+3].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+3].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+4].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+4].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+5].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+5].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n<br><div ng-show=\"PestDetailsDiv\"><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:12%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Details</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Culls</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfCulls || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Misting Carried Out?</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.MistingCariedOut}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Burrows</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfBurrows || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Density</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Density}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Dead</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfDead || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Instar</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.Instar}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Breeding Found?</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.BreedingFound}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Habitat</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Habitat}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Species</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px;color:blue\">&nbsp;{{vm.Species}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Action</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;{{vm.Action}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Findings?</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.Findings}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Recommendation</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Recommendation}}</span></div></div><br></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Details</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Email ID</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.MobilEmailId}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Mode</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.Paymentmethod}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Total Payment</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.Totalpayment}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Notes</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentNotes}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Remarks</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Total Area Planned</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.Totalarea}} (Sq.Mt)</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Total Area Completed</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.Totalcompleted}} (Sq.Mt)</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Rating</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.starRating1r >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.starRating1r >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.starRating1r >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.starRating1r >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.starRating1r == null || vm.starRating1r == undefined || vm.starRating1r == 0 || vm.starRating1r == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.starRating1r\" read-only=\"true\" max-rating=\"5\"></div></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Remarks</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CustomerRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:15%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Signature :</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:200px; width:40%; border:1px solid rgba(0, 0, 0, 0.12)\"><img \ndata-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" style=\"height:200px\" ng-if=\"CustomerSignature\" alt=\"\"></div>\n</div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Comments</span></md-tab-label>\n<md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div style=\"background-color: whitesmoke\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.CommentedBy }}</h3><h4>\n{{ item.CreatedDate | date:\'dd/MM/y HH:MM a\'}}</h4><p>{{ item.cmt }}</p></div></md-list-item></md-list></div></div><div\n class=\"white-bg md-whiteframe-4dp\" style=\"width:59.5%;border:1px solid rgb(224, 224, 224);float:right\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :\n</label></div></div><table id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" style=\"font-size:smaller\" \ndt-options=\"vm.dtOptionspopup\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">File Size</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>&nbsp;</td><td><a \nhref=\"{{UploadsURL}}Operations/Scheduler/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td>\n<td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td></tr>\n</tbody></table></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Logs</span></md-tab-label>\n<md-tab-body><table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Scheduled Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Scheduled<br>\nStart Time | End Time</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Rescheduled Date\n</span></div></th><th ng-hide=\"row.ScheduledStartsat == \'\'\" class=\"secondary-text\"><div><span class=\"column-title\">\n&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div></th><th ng-hide=\"row.ScheduledStartsat != \'\'\" \nclass=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDate & Time</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in SchedulerLogdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ShowType(row.CancelRemarks,row.ResheduleRemarks) }}</td><td>\n{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'hh:mm a\'}} | {{row.Endsat | date:\'hh:mm a\'}}</td><td>\n{{row.ScheduledStartsat | date:\'dd/MM/y\'}}</td><td ng-hide=\"row.ScheduledStartsat == \'\'\">\n{{row.ScheduledStartsat | date:\'hh:mm a\'}} | {{row.ScheduledEndsat | date:\'hh:mm a\'}}</td><td \nng-hide=\"row.ScheduledStartsat != \'\'\"></td><td>{{row.CancelRemarks || row.ResheduleRemarks}}</td><td>{{row.CreatedBy }}\n</td><td>{{row.CreateDate | date:\'dd/MM/y hh:mm a\'}}</td></tr></tbody></table></md-tab-body></md-tab><md-tab \nng-if=\"vm.Status == \'Completed\'\"><md-tab-label><span>Service Report</span></md-tab-label><md-tab-body><div \nlayout=\"column\"><div style=\"text-align:right;padding-right: 100px\"><label \nstyle=\"font-size:15px;margin-left: 85%;font-weight:bold;color: rgb(3,155,229)\">Print Report - <a \nng-click=\"printServiceWeb(\'Service\')\" style=\"cursor:pointer;font-size:15px;font-weight:bold\">Web </a>| <a \nng-click=\"printService(\'Service\')\" style=\"cursor:pointer;font-size:15px;font-weight:bold\">PDF</a></label></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"content\" id=\"Service\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img ng-src=\"{{logo}}\"></div></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>SERVICE REPORT</b></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Date</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px;color:blue\">&emsp;{{vm.ServiceStartAt | date:\'dd/MM/y\'}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Time In</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ServiceStartAt | date:\'hh:mm a\'}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Team</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Time In\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeIn | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Company Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Time Out\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeOut | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ContactPerson}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&emsp;{{vm.Types}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nstyle=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div><div \nstyle=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex style=\"padding:1%\"><label \nstyle=\"width:16%;font-weight:bold;color:#7f9593\">Services & Materials:</label><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Services</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Materials\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Tabletlighttracklistdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.PestType }}</td><td>{{ row.Services }}</td><td>\n{{ row.MaterialName }}</td></tr></tbody></table></div><div style=\"padding:1% 1% 0 1%\"><div \nstyle=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div><div \nstyle=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos Before :</span></div></div><div layout-gt-sm=\"column\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in PhotosBdatas\" ng-switch \non=\"$index % 6\"><img ng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+1].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+1].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+2].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+2].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+3].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+3].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+4].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+4].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosBdatas[$index+5].schimgbefore}}\" \nng-click=\"ShowPhotoinfo($event, PhotosBdatas[$index+5].schimgbefore)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n<div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos After :</span></div></div><div layout-gt-sm=\"column\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in PhotosAdatas\" ng-switch \non=\"$index % 6\"><img ng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+1].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+1].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+2].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+2].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+3].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+3].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+4].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+4].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <img \nng-switch-when=\"0\" data-ng-src=\"data:image/png;base64,{{PhotosAdatas[$index+5].schimgafter}}\" \nng-click=\"ShowPhotoinfo($event, PhotosAdatas[$index+5].schimgafter)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n<br><div ng-show=\"PestDetailsDiv\"><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:12%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Details</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Culls</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfCulls || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Misting Carried Out?</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.MistingCariedOut}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Burrows</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfBurrows || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Density</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Density}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Dead</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.NoOfDead || 0}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Instar</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.Instar}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Breeding Found?</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.BreedingFound}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Habitat</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Habitat}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Species</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px;color:blue\">&nbsp;{{vm.Species}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Action</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;{{vm.Action}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Findings?</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.Findings}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Recommendation</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Recommendation}}</span></div></div><br></div><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\"><div\n style=\"width:58%;float:left\"><label style=\"width:21%;font-weight:bold;color:#7f9593\">Prepared By</label></div><div \nstyle=\"width:32.5%;float:right\"><label style=\"width:35%;font-weight:bold;color:#7f9593\">Customer</label></div></div>\n<div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&emsp;{{vm.TeamLead}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:8%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Signature</label></div>:<div class=\"p-4\" style=\"width:25%\"><img\n style=\"height: 70px;width:100%\" data-ng-src=\"data:image/png;base64,{{vm.TeamSignature}}\" ng-if=\"vm.TeamSignature\" \nalt=\"\"></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Signature</label></div>:<div class=\"p-4\" style=\"width:25%\"><img\n style=\"height: 70px;width: 100%\" data-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" ng-if=\"CustomerSignature\" \nalt=\"\"></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:19%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Name of Co-technicians</label></div>:<div class=\"p-4\" \nstyle=\"width:80%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamMember}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div></div></div></div></div></div></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></form>\n</md-dialog><style>img {\n        cursor: -webkit-zoom-in;\n        cursor: -moz-zoom-in;\n    }</style><style>\n#viewedit.md-button {\n        margin: -16px 8px;\n    }\n\n    md-datepicker .md-datepicker-input {\n        width: calc(25vw - 35px);\n        max-width: calc(35vw - 54px);\n    }\n\n    .md-datepicker-button {\n        display: none;\n    }\n\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\n        right: 74px;\n    }\n\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\n        background: none !important;\n    }\n\n    md-dialog md-dialog-content {\n        padding: 0;\n    }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\n       min-height: 250px;\n    }\n\n        .chipsdemoContactChips md-content.autocomplete input {\n            min-width: 400px;\n        }\n\n    .chipsdemoContactChips .md-item-text.compact {\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n    .chipsdemoContactChips .contact-item {\n        box-sizing: border-box;\n    }\n\n        .chipsdemoContactChips .contact-item.selected {\n           opacity: 0.5;\n        }\n\n    .chipsdemoContactChips .contact-item.selected h3 {\n        opacity: 0.5;\n    }\n\n      .chipsdemoContactChips .contact-item .md-list-item-text {\n            padding: 14px 0;\n            max-width: 190px;\n        }\n\n            .chipsdemoContactChips .contact-item .md-list-item-text h3 {\n                margin: 0 !important;\n                padding: 0;\n                line-height: 1.2em !important;\n            }\n\n            .chipsdemoContactChips .contact-item .md-list-item-text h3, .chipsdemoContactChips .contact-item .md-list-item-text p {\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                overflow: hidden;\n            }\n\n    @media (min-width: 960px) {\n       .chipsdemoContactChips .contact-item {\n            float: left;\n            width: 33%;\n        }\n    }\n\n    .chipsdemoContactChips md-contact-chips {\n        margin-bottom: 10px;\n    }\n\n    .chipsdemoContactChips .md-chips {\n        padding: 5px 0 8px;\n    }\n\n    .chipsdemoContactChips .fixedRows {\n        height: 250px;\n        overflow: hidden;\n    }\n\n    .file-input {\n        display: none !important;\n    }\n\n   #attachmenthref label:hover {\n        cursor: pointer !important;\n        color: #23527c !important;\n    }\n\n    #Datefilter md-datepicker .md-datepicker-input {\n        width: 0;\n    }\n\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\n        border-top-color: white !important;\n    }\n\n    #Datefilter md-datepicker .md-datepicker-input {\n        color: white !important;\n        border-bottom-color: white !important;\n    }\n\n    #workflow .dataTables_wrapper .bottom {\n        display: none;\n    }\n\n    #tb2 {\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\n    }\n\n        #tb2 td:first-child:before {\n            counter-increment: serial-number; /* Increment the serial number counter */\n            content: counter(serial-number); /* Display the counter */\n        }\n    .dataTables_wrapper .bottom {\n        display: none;\n    }\n    .CBCustomer{\n        margin:0 !important;\n    }\n   md-checkbox  #chkboxhide .md-icon {\n       box-sizing: border-box;\n    -webkit-transition: 240ms;\n    transition: 240ms;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    border-width: 0px;\n    border-radius: 2px;\n}\n   md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon, md-checkbox[disabled]:not(.md-checked) .md-icon {\n    border-color: rgba(0, 0, 0, 0);\n}\n    md-dialog {\n        opacity: 0;\n        min-width: 240px;\n        max-width: 95%;\n        max-height: 95%;\n    }\n    \n    @import \"compass/css3\";\n\n    .star-rating {\n        margin: 0;\n        padding: 0;\n        display: inline-block;\n\n        .star {\n            padding: 1px;\n            color: #ddd;\n            font-size: 20px;\n            text-shadow: .05em .05em #aaa;\n            list-style-type: none;\n            display: inline-block;\n            cursor: pointer;\n\n            &.filled {\n                color: #fd0;\n            }\n        }\n\n        &.readonly .star.filled {\n            color: #666;\n        }\n    }\n</style>");
$templateCache.put("app/main/apps/crm/customer/addlead.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMLEAD.CREATE_LEAD\">Create Lead</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0.5% 1% 0.5% 1%\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label style=\"margin-right: 10px\">\nEnquiry Date</label><md-datepicker ng-model=\"vm.EnquiryDate\" required></md-datepicker></md-input-container>\n<md-input-container flex><label>Sales Person</label><md-select ng-model=\"vm.SalesPerson\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'CRMLEAD.SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS =\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Source of Enquiry</label><md-select \nng-model=\"vm.EnquiryMode\" id=\"searchmodule\" md-on-close=\"vm.searcem = \'\'\"><md-select-header><input style=\"flex: auto\" \nng-model=\"vm.searcem\" type=\"text\" placeholder=\"Enquiry source..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.EnquiryMode = null;vm.searcem = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EnquiryModedatas | filter:vm.searcem\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select><div \nng-messages=\"eventForm.EnquiryMode.$error\" ng-show=\"eventForm.EnquiryMode.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Source of Enquiry field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.ppCompanyName\" placeholder=\"Customer Name\" \nreadonly=\"readonly\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container \nflex style=\"margin-top: -1%;height:65px\"><span style=\"color:#7f9593\">Enquiry Type *</span><md-radio-group \nng-model=\"vm.EnquiryType\" layout=\"row\" required><md-radio-button value=\"Ad-hoc\">Ad-hoc</md-radio-button>\n<md-radio-button value=\"Contract\">Contract</md-radio-button></md-radio-group></md-radio-container><md-input-container \nid=\"date4\" flex><label style=\"margin-right:10px\">Expected Response Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ExpectedResponseDate\" required></md-datepicker></md-input-container><md-input-container flex><label>\nService Time</label><md-select ng-model=\"vm.ServiceTime\" id=\"searchmodule\" md-on-close=\"vm.searchcmc = \'\'\"><md-option \nvalue=\"Day\">Day</md-option><md-option value=\"Night\">Night</md-option><md-option value=\"WeeHours\">Wee Hours</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Pipelinevalue\" \nplaceholder=\"Pipeline Value\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<choose-file layout=\"row\" flex><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container flex \nclass=\"md-block\"><input type=\"text\" ng-model=\"fileName\" readonly=\"readonly\" placeholder=\"File Name\">\n</md-input-container><div><md-button id=\"uploadButton\" class=\"md-raised\"><span>Upload</span></md-button></div>\n</choose-file><md-input-container flex></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"leadSubmit()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"cancel($event)\" class=\"md-raised\" translate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></div>\n</md-dialog-content></form></md-dialog><style>\n.ms-scroll{\r\n    position: relative;\r\n}\r\n#date4 md-datepicker .md-datepicker-input {\r\n    width: calc(20vw - 30px) !important;\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n}\r\n.file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/customer/cspopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delete this Address?\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Servicedelete(vm.deleteID,vm.Index)\" class=\"md-raised md-accent\">{{\'CRMCUSTOMER.YES\'|translate}}</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel();ClearGrid();\">{{\'CRMCUSTOMER.NO\'|translate}}</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/customer/customer.html","<div id=\"customer\" class=\"page-layout carded fullwidth single-scroll\" ng-cloak><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple-outline\"></md-icon><span translate=\"CRMCUSTOMER.HEADER\">Customers</span>\n</div><div class=\"product-count secondary-text\"><span translate=\"CRMCUSTOMER.HEADER\">Total Customers:</span> <span>\n{{Customerdatas.length}}</span></div></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CRMCUSTOMER.ADD\">Add</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-hide=\"!IsAdmin\" ng-click=\"AddSegment($event)\">\n<span translate=\"CRMCUSTOMER.ADD_SEGMENT\">Add Segment</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"CRMCUSTOMER.BACK\">Back</span></md-button></div></div><div class=\"content-card\" ng-show=\"Customergrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 40px;padding-top: 1%\"><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"AD()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">A - D</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"EH()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">E - H</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"IL()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">I - L</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"MP()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">M - P</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"QT()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Q - T</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"UX()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">U -X</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"YZ()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Y -Z</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"AllInfo()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">{{\'CRMCUSTOMER.ALL\'|translate}}</a>\n</div></div><div style=\"padding:10px 0% 0 1%;float: initial;width: 60%\" ng-show=\"Cdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Customer Selected: {{v.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforAssignedUser($event)\">\n<span>Assign Users</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"UnAssignedUser()\"><span>Make UnAssign</span></md-button></div><div style=\"padding: 10px 10px 10px 10px\" \nid=\"gridContainer\" dx-data-grid=\"vm.dataGridOptions\"><div class=\"SchedulerLabels\" ng-if=\"!IsAdmin\" \ndata-options=\"dxTemplate:{ name:\'totalGroupCount\' }\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"width: fit-content !important\"><md-checkbox-container flex><md-checkbox ng-model=\"ViewAllCustomer\" \nng-change=\"AllCustomersview(ViewAllCustomer)\" type=\"checkbox\"><b>View All Customers?</b></md-checkbox>\n</md-checkbox-container></div></div></div></div></div><div class=\"content\"><div layout=\"row\"><ms-form-wizard flex \nng-show=\"Customerform\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-text\">Customer Details</span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form style=\"padding-bottom:0px\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"CompanyName\" ng-model=\"vm.uCompanyName\" \nplaceholder=\"Company Name\" required><div ng-messages=\"wizardStep1.CompanyName.$error\" \nng-show=\"wizardStep1.CompanyName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div></md-input-container><md-input-container flex><label>Salesperson</label><md-select \nng-model=\"vm.SalesPerson\" name=\"SalesPerson\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" placeholder=\"\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SalesPerson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.MarketSection\" id=\"searchmodule\" required md-on-close=\"vm.searchTermC = \'\'\" \nng-model-options=\"{trackBy: \'$value.SegmentName\'}\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.MarketSection = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">{{row.SegmentName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>\nSalutation</label><md-select ng-model=\"vm.uSalutation\"><md-option value=\"\">None</md-option><md-option value=\"Mr\">Mr\n</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Mdm\">Mdm</md-option><md-option value=\"Ms\">Ms\n</md-option><md-option value=\"Dr\">Dr</md-option></md-select></md-input-container><md-input-container flex><label>Name\n</label><input type=\"text\" name=\"FirstName\" ng-model=\"vm.uFirstName\" required><div \nng-messages=\"wizardStep1.FirstName.$error\" ng-show=\"wizardStep1.FirstName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required.</span></div></div></md-input-container><md-input-container id=\"date4\" \nflex><label style=\"margin-left: -10px\">Follow-up Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ProspectFollowDate\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"flex: 2\" ng-model=\"vm.StreetName\" required \nplaceholder=\"Address\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \non-place-changed=\"placeChanged()\" type=\"text\" ng-model=\"vm.StreetName\" placeholder=\"\" required></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"BuildingName\" ng-model=\"vm.BuildingName\" placeholder=\"Building Name\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" ng-model=\"vm.uPostal\" \nplaceholder=\"Postal Code\" required><div ng-messages=\"wizardStep1.PostalCode.$error\" \nng-show=\"wizardStep1.PostalCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Postal Code is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips id=\"Email1\" \nng-model=\"vm.uEmail\" name=\"Email\" md-on-add=\"vm.onEmailChipAdd($chip)\" md-transform-chip=\"transformChip($chip)\" \nstyle=\"width: 100%;padding:0!important\"><input type=\"text\" placeholder=\"Email\"></md-chips></div><div \nng-show=\"vm.emailChipWarning\" style=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the email.</div>\n<div ng-show=\"vm.emailValidationError\" style=\"color: red; font-size: 13px\">Please enter valid email.</div><span \nclass=\"h5\" style=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-chips id=\"Contact1\" style=\"width: 100% !important\" ng-model=\"vm.uMobile\" name=\"ContactNum\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"5\" input-aria-label=\"ContactNum\"><input type=\"text\" name=\"ContactNum\" \nplaceholder=\"Contact Number\" md-on-add=\"vm.onContactChipAdd($chip)\"></md-chips></div><div class=\"error-message\" \nng-show=\"vm.contactChipWarning\" style=\"color: red; font-size: 13px\">\nPlease press \"Enter\" after typing the contact number.</div><p class=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 5 Contact Numbers are allowed.</p><div \nng-show=\"vm.contactErrorMessage\" style=\"color: red\">Invalid format. Use +60-123-4567-89</div><br><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><label>Payment Mode</label><md-select ng-model=\"vm.PaymentTerm\">\n<md-option value=\"Advance\">Advance</md-option><md-option value=\"COD\">COD</md-option><md-option value=\"Credit\">Credit\n</md-option></md-select></md-input-container><md-input-container flex ng-if=\"vm.PaymentTerm==\'Credit\'\"><label>\nCredit Term</label><md-select ng-model=\"vm.CreditTerm\" id=\"searchmodule\" md-on-close=\"vm.searchTermcc = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" placeholder=\"Credit Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CreditTermdatas | filter:vm.searchTermCC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Source of Enquiry</label><md-select ng-model=\"vm.EnquiryMode\" \nid=\"searchmodule\" md-on-close=\"vm.searcem = \'\'\"><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searcem\" \ntype=\"text\" placeholder=\"Enquiry source..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.EnquiryMode = null;vm.searcem = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EnquiryModedatas | filter:vm.searcem\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select><div \nng-messages=\"eventForm.EnquiryMode.$error\" ng-show=\"eventForm.EnquiryMode.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Source of Enquiry field is required.</span></div></div></md-input-container></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Additional Information</label><md-select \nng-model=\"vm.additionalInformation\" required><md-option value=\"Contract\">Contract</md-option><md-option value=\"Ad-Hoc\">\nAd-Hoc</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.additionalInformation==\'Contract\'\" \nid=\"date4\" flex><label style=\"margin-left: -10px\">Current Contract End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ConEndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex style=\"margin-top:1%;width:100%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);margin-right:1%\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments:</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Comments\" placeholder=\"{{ \'CRMLEAD.COMMENT_HERE..\' | translate }}\">\n</md-input-container><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\"><span translate=\"CRMLEAD.SAVE\">\nSave</span></md-button></div><div style=\"padding-left:300px\"></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item \nng-repeat=\"item in CustomerCommentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y h:mm a\'}}</h3><md-button \nstyle=\"position: absolute;left: 60%;margin: 0\" id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"DeleteComment(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\">\n<md-tab-label><span ng-if=\"wizardStep2.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Billing & Service Address\n</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div><span class=\"h3\" style=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><div \nstyle=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div><div \nlayout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID, \'Billing\')\"><span>Add</span></md-button>\n</div></div><div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div\n style=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div layout=\"row\" \nstyle=\"padding-bottom:0.5%\"><div flex><div ng-show=\"SAdiv\" flex style=\"padding-left: 40%\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">\nTotal Service Address Selected: {{SelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforUpdateEmail($event)\"><span>\nUPDATE EMAILID</span></md-button></div></div><div><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><span>Add</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div id=\"customerservicegrid\" \ndx-data-grid=\"vm.dataGridCustomerService\"></div></div><br></form></md-tab-body></md-tab><md-tab ng-if=\"Update\">\n<md-tab-label><span class=\"ms-form-wizard-step-text\">UPLOADED DOCUMENTS</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" \nclass=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference No #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Uploaded Document</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nUploaded Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in UploadedDocuments\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nstyle=\"cursor:pointer\">{{ row.FileID }}</a></td><td>{{ row.TableName==\'Lead\'?\"Quotation\":\"Contract\" }}</td><td><a \nhref=\"{{UploadsURL}}CRM/{{row.TableName}}/{{row.TableID}}\" download=\"{{row.FileName}}\" target=\"_blank\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}\n</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab ng-if=\"Update\"><md-tab-label><span \nclass=\"ms-form-wizard-step-text\" translate=\"CRMCUSTOMER.WORK_ORDERS\">WORK ORDERS</span></md-tab-label><md-tab-body>\n<form name=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" \nclass=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.WORK_ORDER\">Work Order #\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.ENQUIRY_TYPE\">\nEnquiry Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.ENQUIRY\">Enquiry #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.PEST_TYPES\">Pest Types</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_MODE\">Payment Mode</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_TERMS\">Payment Terms</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.SERVICE_START_DATE\">Service Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMSALESORDER.SERVICE_END_DATE\">Service End Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in SalesOrderdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Detailsinfo($event, row._id, \'WorkOrder\')\" style=\"cursor:pointer\">{{ row.SalesOrderNo }}</a></td><td>\n{{ row.OrderType }}</td><td>{{ row.EnquiryReferenceNo }}</td><td>{{ row.PestType }}</td><td>{{row.PaymentTerms}}</td>\n<td>{{row.PaymentMode }}</td><td>{{ row.ServiceStartDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.ServiceEndDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab \nng-if=\"Update\" ng-click=\"GetSchedulerDetails(SID,vm.uFrom)\"><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.UPCOMING_SCHEDULES\">UPCOMING SCHEDULES</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\"><div dx-date-box=\"dateBox\"></div></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Service Location</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Schedule Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Technician\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Attachment</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Schedulerdetails | orderBy: \'+Startsat\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><a ng-click=\"SchedulerDetailsinfo($event, row._id,  \'Schedule\')\" style=\"cursor:pointer\">{{row.ServiceID }}</a>\n</td><td>{{row.Location}}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Status}}</td><td>\n{{row.teamdetails[0].TeamMembers}}</td><td ng-if=\"row.Status==\'Completed\'\"><a ng-click=\"getServiceReports(row._id)\" \nstyle=\"cursor:pointer\">Service Report</a></td><td ng-if=\"row.Status!=\'Completed\'\"></td></tr></tbody></table></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"end right\" \nstyle=\"padding:0px\"><md-button class=\"md-raised\" ng-click=\"msWizard.previousStep()\">Previous</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" style=\"padding: 0\"><md-button class=\"md-raised md-accent\" ng-click=\"sSubmit()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"Showgrid()\">Cancel</md-button></div></ms-form-wizard></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\n    width: calc(12vw - 35px);\n    max-width: calc(35vw - 54px);\n  }\n\n  .dataTables_wrapper .dataTables_filter {\n    float: right !important;\n  }\n\n  div.dataTables_filter input {\n    width: 30em !important;\n  }\n\n  #viewedit.md-button {\n    margin: -16px 8px;\n  }\n\n  .md-datepicker-button {\n    display: none;\n  }\n\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\n    left: 10px;\n  }\n\n  .md-default-theme.md-hue-1 .md-datepicker-input,\n  .md-hue-1 .md-datepicker-input {\n    background: none !important;\n  }\n\n  .md-tab.md-active {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\n    border-bottom: none !important;\n  }\n\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\n    border-bottom: none !important;\n  }\n\n  .file-input {\n    display: none !important;\n  }\n\n  .dx-checkbox-icon {\n    border: 1px solid #606b73 !important;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\n    background-color: #83878a !important;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\n    border-bottom-color: #606a71;\n  }\n\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\n    border-left-color: #606a71 !important;\n    border-right-color: #606a71 !important;\n  }\n\n  .dx-button {\n    border-width: 0 !important;\n  }\n\n  .dx-button-has-icon .dx-button-content {\n    padding: 0 !important;\n  }\n\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\n    color: #535858 !important;\n    font-weight: bold !important;\n  }\n\n  md-datepicker .md-datepicker-input {\n    width: calc(1.3vw - 20px) !important;\n    max-width: calc(35vw - 54px);\n    margin-left: -11px;\n  }\n\n  #Datefilter md-datepicker .md-datepicker-input {\n    color: white !important;\n    border-bottom-color: white !important;\n    width: calc(2.3vw - 20px) !important;\n    max-width: calc(25vw - 54px);\n  }\n\n  #date4 md-datepicker .md-datepicker-input {\n    width: calc(26vw - 30px) !important;\n    max-width: calc(35vw - 54px);\n    margin-left: -11px;\n  }\n\n  /* .dx-datagrid-content .dx-datagrid-table .dx-row > td, .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td{\n    vertical-align: baseline;\n  } */\n\n  .md-violet-500-bg {\n    background-color: #7030a0 !important;\n    color: white;\n  }\n\n  .md-yellow-500-bg {\n    background-color: #ffc000 !important;\n    color: white;\n  }\n\n  .md-blue-500-bg {\n    background-color: #0070c0 !important;\n    color: white;\n  }\n\n  .md-gray-500-bg {\n    background-color: #647988 !important;\n    color: white;\n\n  }\n\n  .md-light-green-500-bg {\n    background-color: #87b389 !important;\n    /* color: rgba(255, 255, 255, 0) !important; */\n  }\n\n  .status-label {\n    padding: 4px 10px;\n    border-radius: 4px;\n    color: white;\n    display: inline-block;\n    text-align: center;\n    font-weight: 500;\n  }\n</style>");
$templateCache.put("app/main/apps/crm/customer/segment.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMCUSTOMER.ADD_MARKET_SEGMENT\">Add Market Segment</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0.5% 1% 0.5% 1%\"><div layout-gt-xs=\"row\" layout=\"column\" layout-align=\"start center\"><md-input-container\n flex><input type=\"text\" name=\"SegmentName\" ng-model=\"vm.SegmentName\" \nplaceholder=\"{{ \'CRMCUSTOMER.SEGMENT_NAME\' | translate }}\" required><div ng-messages=\"eventForm.SegmentName.$error\" \nng-show=\"eventForm.SegmentName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CRMCUSTOMER.SEGMENT_NAME_IS_REQUIRED\">Segment Name is required.</span></div></div><p ng-show=\"errorms\" \nstyle=\"color:red\" translate=\"CRMCUSTOMER.SEGMENT_NAME_IS_REQUIRED\">Company Name Is already Exist.</p>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Description\" \nplaceholder=\"{{ \'CRMCUSTOMER.DESCRIPTION\' | translate }}\"></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" style=\"margin-top: -1.6%\" \nng-click=\"SegmentSubmit()\" ng-disabled=\"!vm.SegmentName\"><span translate=\"CRMCUSTOMER.SAVE\">Save</span></md-button>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"font-size:smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMCUSTOMER.SEGMENT_NAME\">Segment Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCUSTOMER.DESCRIPTION\">Description</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCUSTOMER.DELETE\">Delete</span></div></th>\n</tr></thead><tbody style=\"border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\"><tr \nng-repeat=\"row in Marketsegmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.SegmentName }}</td>\n<td>{{ row.Description}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Segmentdelete(row.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></md-dialog-content></form></md-dialog><style>\n.ms-scroll{\r\n    position: relative;\r\n}</style>");
$templateCache.put("app/main/apps/crm/flexischeduler/flexischeduler.html","<div id=\"shedular\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span>Daily Scheduler</span></div><div\n class=\"product-count secondary-text\"><span>Total Schedules:</span> <span>{{calenderdata.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex ng-show=\"WeekViewGrid\"><md-input-container flex \nid=\"Datefilter\" style=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" \nid=\"searchmodule\" style=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex ng-show=\"!WeekViewGrid\"><md-input-container flex id=\"Datefilter\" \nstyle=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" id=\"searchmodule\" \nstyle=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div><md-button class=\"md-raised md-background\" \nng-click=\"Refresh()\"><span>Refresh</span></md-button></div></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"border:1px solid rgb(224, 224, 224);padding:1.5% 1% 1.5% 1%\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><span class=\"dot\" style=\"background: #1e93c2\"></span> <span \nstyle=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Fixed)</b></span> <span class=\"dot\" style=\"background: #29824d\"></span> \n<span style=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Flexible)</b> </span><span class=\"dot\" style=\"background: red\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Ad-Hoc</b> </span><span class=\"dot\" style=\"background: #1527a9\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Service</b></span><div \nstyle=\"width:28%;margin: auto;display:inline-block\"></div><span style=\"font-size:14.5px\"><b>Date :</b> </span><span \nstyle=\"font-size:14.5px\">{{vm.Date | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><span class=\"calendarspan\">{{vm.Holiday}}<span><div id=\"scheduler\" \ndx-scheduler=\"schedulerOptions\"></div><div id=\"appointmentContextMenu\"></div><br><md-input-container \nng-show=\"WeekViewGrid\" flex=\"31\" style=\"margin-top: 39px\"><label style=\"color:black;font-size: 14px\">From</label><br>\n<md-datepicker onkeydown=\"return false\" ng-model=\"StDate\" ng-change=\"getForSelectedDays(1)\"></md-datepicker>\n</md-input-container><md-button class=\"md-raised md-button md-ink-ripple md-default-theme\" \nng-click=\"getForSelectedDays(3)\" ng-show=\"WeekViewGrid\"><span>3 Days</span></md-button><md-button \nclass=\"md-raised md-button md-ink-ripple md-default-theme\" ng-click=\"getForSelectedDays(5)\" ng-show=\"WeekViewGrid\">\n<span>5 Days</span></md-button><div id=\"NewDataGrid\" ng-show=\"WeekViewGrid\" style=\"margin-top: -39px\" \ndx-data-grid=\"vm.dataGridSalesOrderNew\"></div></span></span></div></div></div></div><div id=\"popup\" \nstyle=\"height: 99%; overflow-y: scroll\"></div><style>\n.blackcolor {\r\n        color: black;\r\n    }\r\n\r\n    .whiteColor {\r\n        color: white;\r\n    }\r\n\r\n    .dot {\r\n        height: 20px;\r\n        width: 20px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    .dot1 {\r\n        height: 10px;\r\n        width: 10px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        padding-top: 1.5%;\r\n        border-bottom: 1px solid #c2c8cc;\r\n    } */\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-value,\r\n    #Datefilter md-select .md-select-value {\r\n        border-bottom-color: rgb(255, 255, 255) !important;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-icon,\r\n    md-select .md-select-icon {\r\n        color: rgb(255, 255, 255);\r\n    }\r\n\r\n    /* md-select.md-default-theme:not([disabled]):focus .md-select-value, md-select:not([disabled]):focus .md-select-value{\r\n    color:white !important;\r\n} */\r\n    /* .dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n} */\r\n    /* .day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    /* .dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n} */\r\n\r\n    /* .dx-scheduler-group-header {\r\n    position: relative;\r\n} */\r\n\r\n    /* .dx-scheduler-timeline .dx-scheduler-appointment, .dx-scheduler-work-space-month .dx-scheduler-appointment, .dx-scheduler-all-day-appointment\r\n{\r\n  \r\n  \r\n    height: 73.5019px!important;\r\n   \r\n}\r\n.dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n}\r\n.dx-scheduler-dropdown-appointments{\r\n    position: absolute;\r\n    display: block;\r\n    height: 20px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    margin: 3px 0 0 3px;\r\n}\r\n.dx-scheduler-group-header {\r\n    position: relative;\r\n}\r\n\r\n.dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n\r\n.avatar {\r\n    width: 155px;\r\n    float: left;\r\n    overflow: hidden;\r\n    position: relative;\r\n    height: 125px;\r\n}\r\n\r\n.name {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.name h2 {\r\n    color: #fff;\r\n    text-align: left;\r\n    padding: 0 0 5px 175px;\r\n    margin: 0;    \r\n}\r\n\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n\r\n.info {\r\n    width: auto;\r\n    text-align: left;\r\n    height: 100%;\r\n    font-size: 11pt;\r\n    font-weight: normal;\r\n    padding: 25px 20px;\r\n    color: #707070;\r\n}\r\n\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n}\r\n\r\n.userInfo div {\r\n    margin: 20px;\r\n}\r\n\r\n.day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    .training-background-0 {\r\n        background-image: url(\"https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/gym/icon-abs.png\");\r\n    }\r\n\r\n    .appointment-content {\r\n        width: 360px;\r\n        margin-top: 3px;\r\n    }\r\n\r\n    .dx-popup-content .appointment-content {\r\n        margin-top: 7px;\r\n        height: 50px;\r\n    }\r\n\r\n    .dx-scheduler-header-panel-cell .dx-scheduler-cell-sizes-horizontal {\r\n        width: 100px\r\n    }\r\n\r\n    .appointment-badge {\r\n        text-align: center;\r\n        float: left;\r\n        margin-right: 12px;\r\n        color: white;\r\n        width: 28px;\r\n        height: 28px;\r\n        font-size: 20px;\r\n        line-height: 20px;\r\n        border-radius: 28px;\r\n        margin-top: 5px;\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    /* .appointment-dates {\r\n        color: #959595;\r\n        font-size: 12px;\r\n        text-align: left;\r\n        float: left;\r\n    }  */\r\n\r\n    .appointment-text {\r\n        overflow: hidden;\r\n        /* text-overflow: ellipsis; */\r\n        /* white-space: nowrap; */\r\n        width: 270px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        float: left;\r\n\r\n    }\r\n\r\n    .delete-appointment {\r\n        position: relative;\r\n        border: none;\r\n        box-shadow: none;\r\n        top: -8px;\r\n        height: 50px;\r\n    }\r\n\r\n    .showtime-preview>div:first-child {\r\n        font-size: 12px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .showtime-preview>div:not(:first-child) {\r\n        font-size: 11px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-button-content {\r\n        width: 50px;\r\n        height: 50px;\r\n        padding-left: 4px;\r\n    }\r\n\r\n    .delete-appointment.dx-state-hover,\r\n    .dx-list-item.dx-state-hover .dx-button {\r\n        box-shadow: none;\r\n        background-color: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-icon-trash {\r\n        color: #337ab7 !important;\r\n        font-size: 23px !important;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-group-table, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable:before{\r\n        content: \'TEAMS\'\r\n    } */\r\n    .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        border-bottom: 1px solid #c2c8cc;\r\n        content: \'TEAMS\';\r\n        font-size: larger;\r\n        font-weight: 700;\r\n        padding-left: 20px;\r\n        padding-top: 20px;\r\n\r\n    }\r\n\r\n    .dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        background-color: rgb(240, 102, 51);\r\n    }\r\n\r\n    .dx-scrollable-scroll-content {\r\n        background-color: rgb(240, 102, 51) !important;\r\n    }\r\n\r\n    .dx-icon-warning:before {\r\n        color: #d01e1e;\r\n        border: none\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable {\r\n        height: 15px !important;\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        height: 15px !important;\r\n    }\r\n\r\n    #dataGridFreq>div.dx-datagrid {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-rowsview .dx-row {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-top: none !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-headers {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-bottom: none !important;\r\n    }\r\n\r\n\r\n    #scheduler .dx-scheduler-cell-sizes-horizontal {\r\n        width: 80px;\r\n    }\r\n\r\n    .calendarspan {\r\n        padding-left: 50%;\r\n        font-weight: 800;\r\n        font-size: x-large;\r\n        color: maroon;\r\n    }\r\n\r\n    .custom-heading {\r\n        margin-top: 10px;\r\n        /* pushes it slightly down inside */\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        color: #333;\r\n        position: relative;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/AddPestTypepopup.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== false\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nname=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required><md-select-header><input \nng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest)\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required><md-select-header>\n<input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"EditFrequency== true\">\n<md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nname=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required ng-disabled=\"true\"><md-select-header><input \nng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Pesttype\" required \nng-disabled=\"true\"></md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"Treatmentpopupdata.length > 0\"><u>\nTreatment Methods:</u></span></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex \nng-if=\"Treatmentpopupdata.length > 0\" ng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/AddSor.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">SOR Details</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"gridContainer\" \ndx-data-grid=\"dataGridOptions\"></div></md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-disabled=\"Disablesubmit\" \nng-click=\"SubmitSOR()\" aria-label=\"Ok\">Submit</md-button></div></md-dialog><style>\n.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/crm/lead/CustomerInfo.html","<md-dialog style=\"width:70%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMLEAD.CUSTOMER_INFORMATION\">Customer Information :</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 1% 1% 1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:100%;height:auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"padding-left:5%\"><label \ntranslate=\"CRMLEAD.CUSTOMER_NAME\">Customer Name</label><md-select ng-model=\"vm.CustomerID\" id=\"searchmodule\" required>\n<md-select-header><input style=\"flex: auto\" ng-model=\"vm.searchTermC\" type=\"text\" \nplaceholder=\"{{ \'CRMLEAD.SEARCH_FOR_A_CUSTOMER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CustomerID = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatasfordropdown | filter:vm.searchTermC\" ng-mouseenter=\"vm.handleMouseEnter(row.id)\" \nng-click=\"vm.Customer = row.CompanyName\" value=\"{{row.id}}\">{{row.CompanyName}}</md-option></md-select>\n</md-input-container><md-button type=\"submit\" ng-disabled=\"!vm.CustomerID\" ng-click=\"cancel()\" class=\"md-raised\" \nstyle=\"height:5%\">{{\'CRMLEAD.OK\'|translate}}</md-button></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:99%;padding:0 1%; border:1px solid rgb(224, 224, 224)\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"padding-bottom:0\"><div class=\"p-4\" \nstyle=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.CUSTOMER_CODE\">Customer Code :</label></div><div \nclass=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppCustomerReference}}</span></div><div class=\"p-4\" \nstyle=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.CUSTOMER_TYPE\">Customer Type :</label></div><div \nclass=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppCustomerType}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"padding-bottom:0\">\n<div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.COMPANY_NAME\">Company Name :\n</label></div><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppCompanyName}}</span></div><div \nclass=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.CONTACT_PERSON\">Contact Person :</label>\n</div><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppContactPerson}}</span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"padding-bottom:0\"><div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.ADDRESS\">\nAddress :</label></div><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppAddress}}</span></div>\n<div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.POSTAL_CODE\">Postal Code :</label>\n</div><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppPostal}}</span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"padding-bottom:0\"><div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.COUNTRY\">\nCountry :</label></div><div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppCountry}}</span></div>\n<div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.WEBSITE\">Website :</label></div>\n<div class=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppWebsite}}</span></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"padding-bottom:0\">\n<div class=\"p-4\" style=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.MOBILE\">Mobile :</label></div><div \nclass=\"p-4\" style=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppMobile}}</span></div><div class=\"p-4\" \nstyle=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.PHONE\">Phone :</label></div><div class=\"p-4\" \nstyle=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppPhone}}</span></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"padding-bottom:0\"><div class=\"p-4\" \nstyle=\"width:40%\"><label style=\"font-size:15px\" translate=\"CRMLEAD.EMAIL\">Email :</label></div><div class=\"p-4\" \nstyle=\"width:100%\"><span style=\"font-size:14px\">{{vm.ppEmail}}</span></div></div></div></div></md-dialog-content>\n</form></md-dialog><style>md-dialog{\r\n        max-height:90%;\r\n    }</style>");
$templateCache.put("app/main/apps/crm/lead/PreviewTemplate.html","<md-dialog style=\"width: 80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Template</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding:1% 2% 1% 2%\"><div><span>Commencement of Contract</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header\" class=\"pb-32\"></text-angular><span>Service Hours</span>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Header1\" class=\"pb-32\"></text-angular><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Header2\" class=\"pb-32\"></text-angular></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\">Save</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/Service.html","<md-dialog ng-style=\"{width:vm.sty + \'%\'}\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0 2% 0 2%\"><div ng-show=\"Service\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-checkbox \nng-show=\"AddCon\" ng-model=\"Servicecopy.value\" ng-change=\"copymain(this)\" type=\"checkbox\"><span>Copy from main address?\n</span></md-checkbox><br ng-if=\"AddCon==false\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.5\"><input type=\"text\" ng-model=\"vm.usName\" placeholder=\"Name\"></md-input-container>\n<md-input-container flex style=\"margin-bottom:0\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \non-place-changed=\"placeChanged1()\" ng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nng-model=\"vm.usContactPerson\" placeholder=\"Site Contact Person\"></md-input-container><md-chips \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" name=\"sContactNum\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" name=\"sContactNum\" \nplaceholder=\"Contact Number\"></md-chips></div><p style=\"margin-left: 35%;margin-top: -23px !important\" \nclass=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.ZoneCC\" placeholder=\"Email\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips \nng-model=\"vm.ZoneEmail\" placeholder=\"CC\" readonly=\"vm.readonly\" style=\"width: 100%;padding:0!important\"></md-chips>\n</div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">Type CC and Press Enter</span><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Serviceadd(vm.Index);ClearGrid();\" \nng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div>\n</form></div><div ng-show=\"Billing\"><form name=\"BillingForm\" class=\"md-inline-form\" novalidate><md-checkbox-container \nflex><md-checkbox ng-model=\"checkboxModel.value\" ng-change=\"copybilling(this)\" type=\"checkbox\"><span \ntranslate=\"CRMCUSTOMER.COPY_FROM_MAIN_ADDRESS\">Copy from main address?</span></md-checkbox></md-checkbox-container><div\n layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubContactPerson\" \nplaceholder=\"{{ \'CRMCUSTOMER.CONTACT_PERSON\' | translate }}\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.ubMobile\" placeholder=\"{{ \'CRMCUSTOMER.MOBILE\' | translate }}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubEmail\" \nplaceholder=\"{{ \'CRMCUSTOMER.EMAIL\' | translate }}\"></md-input-container><md-input-container flex><label>Address\n</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged2()\" ng-model=\"vm.ubStreetName\" \nplaceholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ubBuildingName\" placeholder=\"{{ \'CRMCUSTOMER.BUILDING_NAME\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.ubPostal\" \nplaceholder=\"{{ \'CRMCUSTOMER.POSTAL_CODE\' | translate }}\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Billingadd(vm.Index)\" \nng-disabled=\"BillingForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div></form></div>\n</md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n      display: none;\r\n    }\r\n  \r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n      right: 84px;\r\n    }\r\n  \r\n    #datepopup md-datepicker .md-datepicker-input {\r\n      width: calc(17vw - 15px);\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: -11px;\r\n    }\r\n    .ms-scroll{\r\n      position: relative;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/addcustomer.html","<md-dialog style=\"width:100%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CREATE_CUSTOMER\">\nCreate Customer</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><div layout=\"row\"><ms-form-wizard flex>\n<md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"false\"><md-tab><md-tab-label><span \nng-if=\"wizardStep1.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Customer Details</span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"CompanyName\" \nng-model=\"vm.uCompanyName\" placeholder=\"Company Name\" required><div ng-messages=\"wizardStep1.CompanyName.$error\" \nng-show=\"wizardStep1.CompanyName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div><p ng-show=\"error1\" style=\"color:red\">Company Name Is already Exist.</p></md-input-container>\n<md-input-container flex><label>Market Segment</label><md-select ng-model=\"vm.MarketSection\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermC = \'\'\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" multiple=\"\"><md-select-header>\n<input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.MarketSection = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">\n{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><label>Salutation</label><md-select ng-model=\"vm.uSalutation\" required><md-option value=\"Mr\">\nMr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Mdm\">Mdm</md-option><md-option value=\"Ms\">Ms\n</md-option><md-option value=\"Mr\">Dr</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"FirstName\" ng-model=\"vm.uFirstName\" placeholder=\"Name\" required><div \nng-messages=\"wizardStep1.FirstName.$error\" ng-show=\"wizardStep1.FirstName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Full Name is required.</span></div></div></md-input-container><md-input-container \nid=\"date4\" flex><label style=\"margin-left: -10px\">Follow-up Date</label><md-datepicker \nng-model=\"vm.ProspectFollowupDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Address</label><input places-auto-complete \ntypes=\"[\'geocode\']\" on-place-changed=\"placeChanged()\" ng-model=\"vm.StreetName\" placeholder=\"\" required>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"BuildingName\" ng-model=\"vm.BuildingName\" \nplaceholder=\"Building Name\"></md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" \nng-model=\"vm.uPostal\" placeholder=\"Postal Code\" required><div ng-messages=\"wizardStep1.PostalCode.$error\" \nng-show=\"wizardStep1.PostalCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Postal Code is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.uEmail\" \nplaceholder=\"Email\" style=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h5\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-chips style=\"width: 68% !important ; height: 13% !important\" ng-model=\"vm.uMobile\" name=\"ContactNum\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"5\" input-aria-label=\"ContactNum\"><input type=\"number\" name=\"ContactNum\" \nplaceholder=\"Contact Number\"></md-chips><md-input-container id=\"date4\" flex><label style=\"margin-left: -10px\">\nContract End Date</label><md-datepicker ng-model=\"vm.ConEndDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><p style=\"float: left; margin-top:-33px !important\" class=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 5 Contact Numbers are allowed.</p></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\">\n</span> <span class=\"ms-form-wizard-step-text\">Billing & Service Address</span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div \nstyle=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div><div \nlayout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID, \'Billing\')\"><span>Add</span></md-button>\n</div></div><div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div\n style=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div layout=\"row\" \nstyle=\"padding-bottom:0.5%\"><div flex><div ng-show=\"SAdiv\" flex style=\"padding-left:40%\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Service Address Selected: {{SelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforUpdateEmail($event)\"><span>\nUPDATE EMAILID</span></md-button></div></div><div><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><span>Add</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" \ndx-data-grid=\"vm.dataGridCustomerService\"></div></div><br></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"padding: 0\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"customerSubmit()\" ng-disabled=\"msWizard.currentStepInvalid()\" \ntranslate=\"CRMLEAD.SUBMIT\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></ms-form-wizard></div></md-dialog-content></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n    width: calc(20vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .dataTables_wrapper .dataTables_filter {\r\n    float: right !important;\r\n  }\r\n\r\n  div.dataTables_filter input {\r\n    width: 30em !important;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  .md-tab.md-active {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n    background-color: #83878a !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\r\n    border-bottom-color: #606a71;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n    border-left-color: #606a71 !important;\r\n    border-right-color: #606a71 !important;\r\n  }\r\n\r\n  .dx-button {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  .dx-button-has-icon .dx-button-content {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n    color: #535858 !important;\r\n    font-weight: bold !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/lead/addlead.html","<md-dialog style=\"width:80%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMLEAD.CREATE_LEAD\">Create Lead</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container id=\"date4\" \nflex style=\"margin-top: 18px\"><label style=\"margin-right: 10px\">Quote Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EnquiryDate\" required></md-datepicker></md-input-container><md-input-container \nflex><label>Sales Person</label><md-select ng-model=\"vm.SalesPerson\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'CRMLEAD.SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS =\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex ng-hide=\"Update\"><label>Customer Name</label>\n<md-select ng-model=\"vm.ppCompanyName\" id=\"searchmodule\" md-on-close=\"vm.searchTerm2 = \'\'\" ng-required=\"Update==false\">\n<md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ppCompanyName = null;vm.searchTerm2 =\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatasfordropdown | filter:vm.searchTerm2\" ng-click=\"vm.ExpectedResponseDate=row.ConEndDate\" \nvalue=\"{{row.CompanyName}}\">{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex \nng-show=\"Update\"><input type=\"text\" ng-model=\"vm.pCompanyName\" placeholder=\"Customer Name\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex \nstyle=\"margin-top: -1%;height:65px\"><span style=\"color:#7f9593\">Enquiry Type *</span><md-radio-group \nng-model=\"vm.EnquiryType\" layout=\"row\" required><md-radio-button value=\"Ad-hoc\">Ad-hoc</md-radio-button>\n<md-radio-button value=\"Contract\">Contract</md-radio-button></md-radio-group></md-radio-container><md-input-container \nid=\"date4\" flex><label style=\"margin-right:10px\">Expected Response Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ExpectedResponseDate\" required></md-datepicker></md-input-container><md-input-container flex><label>\nService Time</label><md-select ng-model=\"vm.ServiceTime\" id=\"searchmodule\" md-on-close=\"vm.searchcmc = \'\'\"><md-option \nvalue=\"Day\">Day</md-option><md-option value=\"Night\">Night</md-option><md-option value=\"WeeHours\">Wee Hours</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Pipelinevalue\" \nplaceholder=\"Pipeline Value\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<choose-file layout=\"row\" flex ng-if=\"!Update\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container \nflex class=\"md-block\"><input type=\"text\" ng-model=\"fileName\" readonly=\"readonly\" placeholder=\"File Name\">\n</md-input-container><div><md-button id=\"uploadButton\" class=\"md-raised\" ng-show=\"UploadButton\"><span>\n{{UploadButtonName}}</span></md-button><md-button id=\"clearButton\" ng-click=\"fileName=null\" ng-show=\"ClearButton\" \nclass=\"md-raised\"><span>Clear</span></md-button></div></choose-file><md-input-container flex></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit($event)\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel($event)\" \nclass=\"md-raised\" translate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></div></md-dialog-content></form></md-dialog>\n<style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #date4 md-datepicker .md-datepicker-input {\r\n    width: calc(20vw - 23px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n    color: black !important;\r\n  }\r\n\r\n  #date4 .md-default-theme .md-datepicker-input-mask-opaque,\r\n  .md-datepicker-input-mask-opaque {\r\n    left: 0px !important;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/lead/addpesttype.html","<md-dialog style=\"width:50%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CREATE_PEST_TYPE\">Create Pest Type</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"pesttype\" \nng-model=\"vm.pesttypename\" placeholder=\"{{ \'CRMLEAD.PEST_TYPE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMLEAD.NAME_IS_REQUIRED\">Name is required.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" \ntype=\"text\" name=\"remarks\" ng-model=\"vm.pestcode\" placeholder=\"{{ \'CRMLEAD.PEST_CODE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMLEAD.PEST_CODE_IS_REQUIRED\">Pest Code is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin:0\">\n<md-checkbox ng-model=\"IncludeSOR\" type=\"checkbox\">Include SOR?</md-checkbox></md-input-container><md-input-container \nflex ng-show=\"IncludeSOR == true\"><input type=\"number\" name=\"RateOfficeHour\" ng-model=\"RateOfficeHour\" \nplaceholder=\"Rate During Office Hour\"></md-input-container><md-input-container flex ng-show=\"IncludeSOR == true\"><input\n type=\"number\" name=\"RateAfterOfficeHour\" ng-model=\"RateAfterOfficeHour\" placeholder=\"Rate After Office Hour\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"pestsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"CRMLEAD.SUBMIT\">Submit</md-button><md-button ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></form></div></div></div></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/addschedule.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Create Schedule</span><md-button class=\"md-icon-button\" ng-click=\"cancel();vm.AddSchedule = false;\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div flex><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.Customer}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" style=\"width:45%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PestTypestr}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Frequency</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.Frequency}}</span></div><div class=\"p-4\" style=\"width:15%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">No of Jobs/Frequency</label></div>:<div class=\"p-4\" \nstyle=\"width:10%\"><span style=\"font-size:14px\">&nbsp;{{vm.JobsPerFrequency}}</span></div><div class=\"p-4\" \nstyle=\"width:19%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Total No of Services/Contract</label>\n</div>:<div class=\"p-4\" style=\"width:10%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServicesRequired}}</span></div></div>\n<br><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-bottom:0;flex: 0.4\"><label>Days\n</label><md-select ng-model=\"vm.ServiceOn\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.Name\'}\" required \nmd-on-close=\"vm.searchTermP = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.son\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Days..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ServiceOn = null;vm.son = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Days | filter:vm.son\" \nng-value=\"row\">{{row.Name}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.4\"><label>Team</label><md-select ng-model=\"vm.AssignedTo\" id=\"searchmodule\" \nmd-on-close=\"vm.searchAssigned = \'\'\" required><md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" \nplaceholder=\"Search For a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" \nng-click=\"vm.TM = row.TeamMembers;vm.ppTeamName = row.TeamName;getTeamTable(row.id);\" value=\"{{row.id}}\">\n{{row.TeamName}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0\"><input \ntype=\"text\" ng-model=\"vm.TM\" placeholder=\"Team Members\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:70px\"><md-input-container id=\"date4\" flex \nstyle=\"margin-top: 18px;flex: 0.85\"><label>Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ServiceStartDate\" md-min-date=\"vm.ServiceStartDate\" required></md-datepicker></md-input-container>\n<md-input-container id=\"date4\" flex style=\"margin-top: 18px;flex: 0.85\"><label>End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" md-min-date=\"vm.ServiceStartDate\" \nmd-max-date=\"vm.ServiceEndDate\" required></md-datepicker></md-input-container><md-input-container flex><input \nmdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Start Time\" show-todays-date=\"\" \nmin-date=\"date\" ng-model=\"vm.ServiceStartTime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required>\n</md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" \nid=\"datetime\" placeholder=\"End Time\" show-todays-date=\"\" min-date=\"date\" ng-model=\"vm.ServiceEndTime\" format=\"hh:mm A\" \nclass=\"md-input\" readonly=\"readonly\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin-bottom:0;flex: 0.223\" \nng-if=\"(vm.Frequency | uppercase).includes(\'FORTNIGHTLY\') ||(vm.Frequency | uppercase).includes(\'BIWEEKLY\')  ||(vm.Frequency | uppercase).includes(\'BI-WEEKLY\')\">\n<label>Select Week</label><md-select ng-model=\"vm.ForBiWeekly\" ng-change=\"GetSummary(\'FORTNIGHTLY\')\" id=\"searchmodule\">\n<md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ForBiWeekly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option>\n<md-option value=\"2nd\">Second Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">\nFourth Week</md-option><md-option value=\"5th\">Last Week</md-option></md-select></md-input-container><md-input-container\n flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"(vm.Frequency | uppercase) == \'MONTHLY\'\"><label>Select Week</label>\n<md-select ng-model=\"vm.ForMonthly\" ng-change=\"GetSummary(\'MONTHLY\')\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.ForMonthly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option><md-option value=\"2nd\">\nSecond Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">Fourth Week</md-option>\n<md-option value=\"5th\">Last Week</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.223\" \nng-if=\"(vm.Frequency | uppercase).includes(\'BI-MONTHLY\') || (vm.Frequency | uppercase).includes(\'BIMONTHLY\')\"><label>\nSelect Week</label><md-select ng-model=\"vm.ForBiMonthly\" ng-change=\"GetSummary(\'BIMONTHLY\')\" id=\"searchmodule\">\n<md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ForMonthly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option>\n<md-option value=\"2nd\">Second Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">\nFourth Week</md-option><md-option value=\"5th\">Last Week</md-option></md-select></md-input-container><md-input-container\n flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"(vm.Frequency | uppercase).includes(\'QUARTERLY\')\"><label>Select Month\n</label><md-select ng-model=\"vm.ForQuaterly\" ng-change=\"GetSummary(\'QUARTERLY\')\" id=\"searchmodule\"><md-select-header>\n<span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Month..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.ForQuaterly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"1st\">First</md-option><md-option value=\"2nd\">Second\n</md-option><md-option value=\"3rd\">Third</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.223\" \nng-if=\"(vm.Frequency | uppercase).includes(\'HALF-YEARLY\') || (vm.Frequency | uppercase).includes(\'HALFYEARLY\')\"><label>\nSelect Month</label><md-select ng-model=\"vm.ForHalfYearly\" ng-change=\"GetSummary(\'HALFYEARLY\')\" id=\"searchmodule\">\n<md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Month..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ForHalfYearly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First</md-option><md-option \nvalue=\"2nd\">Second</md-option><md-option value=\"3rd\">Third</md-option><md-option value=\"4th\">Fourth</md-option>\n<md-option value=\"5th\">Fifth</md-option><md-option value=\"6th\">Sixth</md-option></md-select></md-input-container>\n<md-input-container flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"(vm.Frequency | uppercase) == \'YEARLY\'\"><label>\nSelect Month</label><md-select ng-model=\"vm.ForYearly\" ng-change=\"GetSummary(\'YEARLY\')\" id=\"searchmodule\">\n<md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Month..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ForYearly = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First</md-option><md-option \nvalue=\"2nd\">Second</md-option><md-option value=\"3rd\">Third</md-option><md-option value=\"4th\">Fourth</md-option>\n<md-option value=\"5th\">Fifth</md-option><md-option value=\"6th\">Sixth</md-option><md-option value=\"7st\">Seventh\n</md-option><md-option value=\"8nd\">Eighth</md-option><md-option value=\"9rd\">Ninth</md-option><md-option value=\"10th\">\nTenth</md-option><md-option value=\"11th\">Eleventh</md-option><md-option value=\"12th\">Twelfth</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"vm.ForQuaterly\"><label>\nSelect Week</label><md-select ng-model=\"vm.ForQuaterlyWeek\" ng-change=\"GetSummary(\'QUARTERLY\')\" id=\"searchmodule\">\n<md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ForQuaterlyWeek = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option>\n<md-option value=\"2nd\">Second Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">\nFourth Week</md-option><md-option value=\"5th\">Last Week</md-option></md-select></md-input-container><md-input-container\n flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"vm.ForHalfYearly\"><label>Select Week</label><md-select \nng-model=\"vm.ForHalfYearlyWeek\" ng-change=\"GetSummary(\'HALFYEARLY\')\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.ForHalfYearlyWeek = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option>\n<md-option value=\"2nd\">Second Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">\nFourth Week</md-option><md-option value=\"5th\">Last Week</md-option></md-select></md-input-container><md-input-container\n flex style=\"margin-bottom:0;flex: 0.223\" ng-if=\"vm.ForYearly\"><label>Select Week</label><md-select \nng-model=\"vm.ForYearlyWeek\" ng-change=\"GetSummary(\'YEARLY\')\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Select Week..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.ForYearlyWeek = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"1st\">First Week</md-option><md-option value=\"2nd\">\nSecond Week</md-option><md-option value=\"3rd\">Third Week</md-option><md-option value=\"4th\">Fourth Week</md-option>\n<md-option value=\"5th\">Last Week</md-option></md-select></md-input-container></div><br><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Service Address :</b></span><div class=\"white-bg md-whiteframe-4dp\"><div \nid=\"LSSgridContainer\" dx-data-grid=\"vm.dataGridCustomerService\"></div></div><br><div flex style=\"width:99%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Number of Selected Service Addresses :</b></span> <span style=\"font-size:14px\">\n{{ServiceAddressarray.length}}</span></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nstyle=\"padding:1% 43% 0 0;float:right\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"GetLatlong();vm.AddSchedule = true;vm.Scheduled = \'Yes\';\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || selected.length == 0 || ServiceAddressarray == \'\'\">SAVE</md-button><md-button \ntype=\"submit\" ng-click=\"cancel();vm.AddSchedule = false;vm.Scheduled = \'No\';\" class=\"md-raised\">Cancel</md-button>\n</div></md-dialog-content></form></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #date4 md-datepicker .md-datepicker-input {\r\n        width: calc(18.7vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 97%;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n              .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important; \r\n}\r\n       .dx-datagrid-rowsview .dx-selection.dx-row > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover > td, .dx-datagrid-rowsview .dx-selection.dx-row > tr > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover > tr > td {\r\n    background-color: #83878a !important; \r\n  \r\n}\r\n      .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines > tr > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines > tr > td {\r\n    border-bottom-color: #606a71;\r\n}\r\n      .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines > tr > td, .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines > tr > td {\r\n    border-left-color: #606a71 !important; \r\n    border-right-color: #606a71 !important; \r\n}\n</style>");
$templateCache.put("app/main/apps/crm/lead/attachmentdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to delete this Attachment?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Adelete(AttachdeleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br><br></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/lead/cancelalert.html","<md-dialog style=\"width: 28%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CANCEL_THIS_ENQUIRY\">Cancel this Enquiry\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div flex><label style=\"font-size:17px;color:#7f9593;padding-bottom:5px\">\nAre you sure you want to Cancel this enquiry?</label><md-input-container><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\" style=\"padding-left:53px\"><md-button ng-click=\"CancelEnquiry(vm.LeadId)\" \nclass=\"md-raised md-accent\" translate=\"CRMLEAD.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.NO\">No</md-button></div></md-input-container></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/lead/closealert.html","<md-dialog style=\"width: 28%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CLOSE_THIS_ENQUIRY\">Close this Enquiry\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><md-input-container flex style=\"margin: 0px\"><label \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">\n{{\'CRMLEAD.ARE YOU SURE YOU WANT TO CLOSE THIS ENQUIRY\'|translate}}</label><md-input-container><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"padding-top: 20px;padding-left:53px\"><md-button \nng-click=\"CloseEnquiry(vm.LeadId)\" class=\"md-raised md-accent\" translate=\"CRMLEAD.YES\">Yes</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\" translate=\"CRMLEAD.NO\">No</md-button></div></md-input-container>\n</md-input-container></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/lead/contracts.html","<md-dialog style=\"width:100%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Create Contract</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:9px 2% 0px 1%\"><form name=\"Contract\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ppCompanyName\" \nplaceholder=\"Customer Name\" required readonly=\"readonly\"></md-input-container><md-input-container flex><label \ntranslate=\"CRMCONTRACTS.SALES_PERSON\">Sales Person</label><md-select ng-model=\"vm.SalesPerson\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'CRMCONTRACTS.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SalesPerson = null;vm.searchTermS=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Market Segment</label><md-select \nng-model=\"vm.CMarketSegment\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search For a Segment\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CMarketSegment = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" \nng-value=\"row\">{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ppSalutation\" readonly=\"readonly\" \nplaceholder=\"Salutation\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.ppContactPerson\" readonly=\"readonly\" placeholder=\"Name\"></md-input-container><md-chips flex \nstyle=\"height: 13% !important\" ng-model=\"vm.ppMobile\" name=\"ppMobile\" md-separator-keys=\"vm.keys\" md-max-chips=\"3\" \ninput-aria-label=\"ppMobile\"><input type=\"number\" name=\"ppMobile\" placeholder=\"Contact No (max 2)\"></md-chips></div><div\n layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Billing Address</label><md-select \nng-model=\"vm.BAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For Billing Address\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.CAddress = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CustomerBillingAddress | filter:vm.searchTermC\" \nng-click=\"vm.ppEmail=row.bEmail.split(\',\') ; vm.ppContactPerson=row.bContactPerson ; vm.ppMobile=row.bMobile.split(\',\')\">\n</md-option>value=\"{{row._id}}\"> {{row.bStreetName}}</md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label>Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Biiling Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-chips flex \nstyle=\"height: 13% !important\" ng-model=\"vm.ppEmail\" name=\"Email\" md-separator-keys=\"vm.keys\" md-max-chips=\"4\" \ninput-aria-label=\"Email\"><input type=\"text\" name=\"Email\" placeholder=\"Email\"></md-chips></div><span flex class=\"h5\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter (Max. 3)</span> <span style=\"color:#7f9593\"><h3>\nSite Details</h3></span><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Service Address</label>\n<md-select ng-model=\"vm.CAddress\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Service Address\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CAddress = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerServiceAddress | filter:vm.searchTermC\" \nng-click=\"vm.SiteContactPerson=row.sContactPerson ;vm.SiteName = row.sName ;\r\n                                            row.sMobile!=null && row.sMobile!=\'\' && row.sMobile!=undefined?vm.SiteContact=row.sMobile.split(\',\'):vm.SiteContact=[] ;\r\n                                            row.sEmail!=null && row.sEmail!=\'\' && row.sEmail!=undefined?vm.SEmail=row.sEmail.split(\',\'):vm.SEmail=[] ;\" \nng-value=\"row\">{{row.sStreetName}}</md-option></md-select></md-input-container><md-button style=\"margin: 12px -8px\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><md-icon md-font-icon=\"icon-tooltip-outline-plus\">\n</md-icon></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" flex style=\"margin-top: 27px\"><md-input-container \nflex><label>Service Hours</label><md-select ng-model=\"vm.ServiceHours\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm2 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Service Hours\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ServiceHours = null;vm.searchTerm2=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"During Office Hours\">\nOffice Hours 9am - 5pm</md-option><md-option value=\"After Office Hours\">After Office Hours 5:00pm - 12:00mn</md-option>\n<md-option value=\"Wee Hours\">Wee Hours 12:00mn - 9am</md-option></md-select></md-input-container><md-input-container \nflex style=\"margin-top: 18px;margin-left:10px\"><label>Service Start Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required \nng-change=\"getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency);getServiceEndDate(vm.ServiceStartDate)\" \nstyle=\"margin-left: -10px\"></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\">\n<label>Service End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" required style=\"margin-left: -10px\" \nng-change=\"getMonth(vm.ServiceStartDate,vm.ServiceEndDate,vm.BillingFrequency)\"></md-datepicker></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Credit Term</label><md-select \nng-model=\"vm.CreditTerm\" id=\"searchmodule\" md-on-close=\"vm.searchTermcc = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTermcc\" style=\"flex: auto\" type=\"text\" placeholder=\"Credit Term\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CreditTerm = null;vm.searchTermcc=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CreditTermdatas | filter:vm.searchTermC\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><input type=\"number\" \nng-model=\"vm.TotalOrderValue\" placeholder=\"Total Contract Sum\" \nng-change=\"getMonthAmount(vm.TotalMonth,vm.TotalOrderValue)\" required></md-input-container><md-input-container flex>\n<label>Select Template</label><md-select ng-model=\"vm.TemplateName\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm1 = \'\'\" \nng-disabled=\"!vm.BillingFrequency || !vm.ServiceHours || !vm.ServiceStartDate || !vm.ServiceEndDate || !vm.TotalOrderValue\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Contract Template\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.TemplateName = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Contracttemplates | filter:vm.searchTermC\" ng-click=\" ClickTemplate($event)\" value=\"{{row.id}}\">\n{{row.TemplateName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex style=\"margin: 0;padding-left:1%\"><md-checkbox ng-model=\"vm.IncludeSOR\" \nng-change=\"SORDerails(vm.IncludeSOR,$event,true)\" type=\"checkbox\"><span>Include SOR? </span>&emsp;</md-checkbox><span \nid=\"viewsor\" ng-show=\"vm.IncludeSOR\" ng-click=\"SORDerails(true,$event,false)\">View/Edit SOR Details </span>&emsp;\n</md-input-container><md-input-container flex style=\"margin: 0;padding-left:1%\" ng-if=\"Update == false\">\n</md-input-container></div><br><div style=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\"><b>\nPEST CONTROL SERVICES :</b></span><md-button id=\"viewedit\" class=\"md-raised md-button md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddPestType($event)\" style=\"float:right\">Add Frequency</md-button></div>\n<table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Method</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Others</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Edit\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}</td><td>{{ row.PestType }}\n</td><td>{{ row.Treatment }}</td><td>{{ row.Others }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"EditPestControl($event,row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"Frequencydatas.length == 1\" ng-click=\"DeletePestControl(row)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"sContracctSubmit()\" ng-disabled=\"Contract.$invalid || Frequencydatas.length==0\">\nSubmit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCUSTOMER.CANCEL\">Cancel\n</md-button></div></form></md-dialog-content></md-dialog><style>\n.ms-scroll {\r\n        position: relative;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n\r\n    .dx-switch-handle:before {\r\n        background-color: #039be5de !important;\r\n    }\r\n\r\n    #viewsor:hover {\r\n        color: rgb(3, 155, 229) !important;\r\n        font-style: italic;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n\r\n    }\r\n\r\n    #viewsor {\r\n        color: rgb(181, 219, 238) !important;\r\n        font-style: italic;\r\n        font-size: 14px\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/cspopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMLEAD.DELETE_THIS_ADDRESS?\">Delete this Address?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Servicedelete(vm.deleteID)\" \nclass=\"md-raised md-accent\" translate=\"CRMLEAD.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.NO\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/lead/lead.html","<div id=\"lead\" class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Quote Management</span></div><div class=\"product-count secondary-text\"><span translate=\"CRMLEAD.TOTAL_LEADS\">\nTotal Quotes:</span> <span>{{Leaddatas.length}}</span></div></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Add\" ng-click=\"Addlead($event)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"CRMLEAD.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" \nng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"CRMLEAD.BACK\">Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"LExport()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"CRMLEAD.EXPORT\">Export</span></md-button></div></div>\n<div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"content-card\" ng-show=\"Leadgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Leaddatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"LeadgridContainer\" \ndx-data-grid=\"vm.dataGridLead\"></div></div></div><div class=\"content\"><div layout=\"row\"><ms-form-wizard flex \nng-show=\"Leadform\"><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate \nstyle=\"padding-bottom:0px;min-height:700px\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%;border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-30\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%; border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Enquiry Details :</label>\n<div style=\"float: right; display: flex; align-items: center; gap: 12px\"><md-input-container \nstyle=\"margin: 0; min-width: 150px\"><label>Status</label><md-select ng-model=\"vm.status\" \nng-change=\"QuotationSubmit(vm.status)\" \nng-class=\"{\r\n               \'status-win\': vm.status === \'Win\',\r\n               \'status-lost\': vm.status === \'Quotation Lost\',\r\n               \'status-cancel\': vm.status === \'Cancel\'\r\n             }\">\n<md-option ng-value=\"\'Win\'\" class=\"status-win\">Win</md-option><md-option ng-value=\"\'Quotation Lost\'\" \nclass=\"status-lost\">Quotation Lost</md-option><md-option ng-value=\"\'Cancel\'\" class=\"status-cancel\">Cancel</md-option>\n</md-select></md-input-container><a ng-click=\"leadeditinfo($event, SID)\" style=\"cursor:pointer; font-size:15px\" \nng-hide=\"vm.EnquiryStatus == \'Closed\'\">Edit</a></div></div></div><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:20%\"><lable \nstyle=\"font-size:15px;color:#7f9593\"><b>Reference #</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\"><b>{{vm.LeadReferenceNo}}</b></lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Cutsomer Name</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.uCompanyName}}</lable></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Date</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.EnquiryDate| date:\'dd/MM/y\'}}</lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Expected Response date</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.ExpectedResponseDate | date:\'dd/MM/y\'}}</lable></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Type</b>\n</lable></div><lable style=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div \nclass=\"p-4\" style=\"width:30%\"><lable style=\"font-size:14px\">{{vm.EnquiryType}}</lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Sales Person</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.uSalesPerson}}</lable></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Service Time</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.ServiceTime}}</lable></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Contact Information :\n</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:32%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Company Name</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uCompanyName}}</span></div><div class=\"p-4\" style=\"width:32%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Contact</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uMobile}}</span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:32%\">\n<label style=\"font-size:15px;color:#7f9593\"><b>Address</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uStreetName}}</span></div><div class=\"p-4\" style=\"width:32%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Postal Code</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uPostal}}</span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:32%\">\n<label style=\"font-size:15px;color:#7f9593\"><b>Contact Person</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uContactPerson}}</span></div><div class=\"p-4\" style=\"width:32%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Email</b></label></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\">:</lable><div class=\"p-4\" style=\"width:60%\">\n<span style=\"font-size:14px\">{{vm.uEmail}}</span></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nstyle=\"float:left;margin-top:1%;width:100%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:60%; border:1px solid rgb(224, 224, 224);margin-right:1%\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Addcomments\" placeholder=\"{{ \'CRMLEAD.COMMENT_HERE..\' | translate }}\">\n</md-input-container><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\"><span translate=\"CRMLEAD.SAVE\">\nSave</span></md-button></div><div style=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list>\n<md-list-item ng-repeat=\"item in Commentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y h:mm a\'}}</h3><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:40%;border:1px solid rgb(224, 224, 224)\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding><div flow-init flow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label \nfor=\"file-input\" style=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\" style=\"float:right\"><span>Upload Own Quotation</span></md-button><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>\n&nbsp;</td><td><a href=\"{{UploadsURL}}CRM/Lead/{{row.TableID}}\" target=\"_blank\" download style=\"cursor:pointer\">\n{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteAttachement($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></form></ms-form-wizard></div></div></div></div><div class=\"content\" id=\"invoice\" \nng-show=\"Previewdiv\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">\n&emsp;&emsp;<b style=\"padding-left:8%\">QUOTATION</b> <img ng-if=\"vm.QRCode\" \nstyle=\"height:20%; width:20%;float:right;margin-top:-1%\" src=\"{{vm.QRCode}}\"></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:25%\">Enquiry Reference # :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.LeadReferenceNo}}</th><th \nstyle=\"border-collapse: collapse;width:25%\"></th><th style=\"border-collapse: collapse;width:25%\">Date :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.EnquiryDate| date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:25%\">Customer Name:</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.Customer}}</th><th \nstyle=\"border-collapse: collapse;width:25%\"></th><th style=\"border-collapse: collapse;width:25%\">Received By :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.EnquiryReceivedBy}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:25%\">Mode :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.EnquiryMode}}</th><th \nstyle=\"border-collapse: collapse;width:25%\"></th><th style=\"border-collapse: collapse;width:25%\">Type :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.EnquiryType}}</th></tr></thead><tbody></tbody>\n<tfoot></tfoot></table><br><h3 style=\"font-weight: 600;margin:0px\">{{vm.Subject}}</h3><div class=\"printtextarea\">\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Header\" ng-disabled class=\"pb-32\"></text-angular></div><div \nstyle=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle1 != null && vm.TableTitle1 != \'\' && vm.TableTitle1 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle1}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" \ntranslate=\"CRMLEAD.TYPE_OF_PEST\">Type Of Pest</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Timing</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Frequency</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">Pricing</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Quotationdatas\" ng-if=\"row.TableEnquiryID1 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T1PestType }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T1Timing }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T1Frequency}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T1Pricing }}</td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle2 != null && vm.TableTitle2 != \'\' && vm.TableTitle2 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle2}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" \ntranslate=\"CRMLEAD.TYPE_OF_PEST\">Type Of Pest</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Quantity</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Timinig</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Frequency</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">Pricing</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Quotationdatas\" ng-if=\"row.TableEnquiryID2 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T2PestType }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T2Timing }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T2Quantity }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T2Frequency}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T2Pricing }}</td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle3 != null && vm.TableTitle3 != \'\' && vm.TableTitle3 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle3}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Area</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Type Of Pest</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">Quantity</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Timinig</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Frequency</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">Pricing</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Quotationdatas\" ng-if=\"row.TableEnquiryID3 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Area }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3PestType }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Quantity }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Timing }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Frequency}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Pricing }}</td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle4 != null && vm.TableTitle4 != \'\' && vm.TableTitle4 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle4}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" translate=\"CRMLEAD.PRODUCT\">\nProduct</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.NO_OF_PIECES\">No. Of Pieces</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\" translate=\"CRMLEAD.PRICING\">\nPricing</th></tr></thead><tbody><tr ng-repeat=\"row in Quotationdatas\" \nng-if=\"row.TableEnquiryID4 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T4Product }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T4NoOfPieces}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T4Pricing }}</td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle5 != null && vm.TableTitle5 != \'\' && vm.TableTitle5 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle5}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" translate=\"CRMLEAD.PRODUCTS\">\nProducts</th><th style=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" \ntranslate=\"CRMLEAD.QUANTITY\">Quantity</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.LEASING_UNIT_PRICE\">Leasing Unit Price</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.SELLING_UNIT_PRICE\">Selling Unit Price</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\" translate=\"CRMLEAD.PHOTO\">Photo\n</th></tr></thead><tbody><tr ng-repeat=\"row in Quotationdatas\" \nng-if=\"row.TableEnquiryID5 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T5Product }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T5Quantity }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T5LeasingUnitPrice }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T5SellingUnitPrice}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\"><img \nstyle=\"height:50px; width:50px;border:1px solid rgba(173, 173, 173, 0.57)\" src=\"{{row.T5Photo}}\"></td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle6 != null && vm.TableTitle6 != \'\' && vm.TableTitle6 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle6}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.DESCRIPTION\">Description</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\" translate=\"CRMLEAD.PRICE\">Price\n</th></tr></thead><tbody><tr ng-repeat=\"row in Quotationdatas\" \nng-if=\"row.TableEnquiryID6 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T6Description}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T6Price }}</td></tr></tbody><tfoot>\n</tfoot></table></div><h3 style=\"font-weight: 600\" translate=\"CRMLEAD.TERMS_&_CONDITIONS\">Terms & Conditions:</h3><div \nclass=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.TermsCondition\" ng-disabled class=\"pb-32\">\n</text-angular></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle7 != null && vm.TableTitle7 != \'\' && vm.TableTitle7 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle7}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" \ntranslate=\"CRMLEAD.FOR_MODEL_NO\">For Model No</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\" \ntranslate=\"CRMLEAD.NO_OF_LIGHT_TUBES_NEEDED\">No. of light tubes needed</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.NO_OF_LIGHT_TUBES_NEEDED\">No. of light tubes needed</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\" \ntranslate=\"CRMLEAD.SELLING_PRICE\">Selling Price</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\" translate=\"CRMLEAD.LIFESPAN\">\nLifespan</th></tr></thead><tbody><tr ng-repeat=\"row in Quotationdatas\" \nng-if=\"row.TableEnquiryID7 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T7PartNo }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T7ForModelNo }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T7NoOfLightTubesNeed }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T7SellingPricing}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T7Lifespan }}</td></tr></tbody>\n<tfoot></tfoot></table></div><div style=\"font-size:17px;text-align:left\" \nng-if=\"vm.TableTitle8 != null && vm.TableTitle8 != \'\' && vm.TableTitle8 != undefined\"><h4 \nstyle=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle8}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E;height:50px\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">For Model No</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">No. of board/s</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">Selling Price</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:300px;text-align:center\">Lifespan</th></tr></thead>\n<tbody><tr ng-repeat=\"row in Quotationdatas\" ng-if=\"row.TableEnquiryID8 == vm.EnquiryID && vm.EnquiryID != null\" \nstyle=\"border: 1px solid black;height:50px;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T8ForModelNo }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T8NoOfBoardsNeeded }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T8SellingPricing}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T8Lifespan }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.Footer\" ng-disabled class=\"pb-32\"></text-angular></div><canvas width=\"500\" id=\"canvas\"></canvas></div>\n<style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n        min-height: 250px;\r\n    }\r\n\r\n    .chipsdemoContactChips md-content.autocomplete input {\r\n        min-width: 400px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-item-text.compact {\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text {\r\n        padding: 14px 0;\r\n        max-width: 190px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n        margin: 0 !important;\r\n        padding: 0;\r\n        line-height: 1.2em !important;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n    .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n        .chipsdemoContactChips .contact-item {\r\n            float: left;\r\n            width: 33%;\r\n        }\r\n    }\r\n\r\n    .chipsdemoContactChips md-contact-chips {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-chips {\r\n        padding: 5px 0 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .fixedRows {\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    #attachmenthref label:hover {\r\n        border-bottom: 1px solid #23527c;\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    #workflow .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    .yellow {\r\n        background-color: yellow !important;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n        border-left-color: #606a71 !important;\r\n        border-right-color: #606a71 !important;\r\n    }\r\n\r\n    .dx-button {\r\n        border-width: 0 !important;\r\n    }\r\n\r\n    .dx-button-has-icon .dx-button-content {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n        color: #535858 !important;\r\n        font-weight: bold !important;\r\n    }\r\n\r\n    /* General select styling */\r\n    /* md-select {\r\n        color: #fff !important;\r\n        border-radius: 4px;\r\n        padding: 4px 8px;\r\n    } */\r\n\r\n    /* Selected label styles */\r\n    .status-win .md-select-value {\r\n        background-color: #66bb6a !important;\r\n        /* green */\r\n        color: white !important;\r\n    }\r\n\r\n    .status-lost .md-select-value {\r\n        background-color: #ef5350 !important;\r\n        /* red */\r\n        color: white !important;\r\n    }\r\n\r\n    .status-cancel .md-select-value {\r\n        background-color: #bdbdbd !important;\r\n        /* gray */\r\n        color: white !important;\r\n    }\r\n\r\n    .status-win {\r\n        background-color: #4CAF50 !important;\r\n        /* Green */\r\n        color: white !important;\r\n    }\r\n\r\n    .status-lost {\r\n        background-color: #f44336 !important;\r\n        /* Red */\r\n        color: white !important;\r\n    }\r\n\r\n    .status-cancel {\r\n        background-color: #9e9e9e !important;\r\n        /* Gray */\r\n        color: white !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/lead/quotationLost.html","<md-dialog aria-label=\"New Message\" style=\"width: 40%\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Quotation Lost</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:3% 2% 0 2%\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" \nng-model=\"vm.QuotationLost\" placeholder=\"Comment\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"QuotationSubmit()\" \nng-disabled=\"!vm.QuotationLost\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\">Cancel\n</md-button></div></form></md-dialog-content></md-dialog><style>.ms-scroll {\r\n        position: relative;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/preparequotation/OptionsPopup.html","<md-dialog style=\"width:70%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><form name=\"basicForm2\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex>\n<label>Pest Coverage</label><md-select ng-model=\"vm.tPestType\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.PestName\' }\" md-on-close=\"vm.searchf = \'\'\" multiple=\"\" required><md-select-header>\n<input style=\"flex: auto\" ng-model=\"vm.searchf\" type=\"text\" placeholder=\"Pest Coverage\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.tPestType = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in PestType | filter:vm.searchf\" ng-value=\"row\">{{row.PestName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\">\n<md-input-container flex><label>Frequency</label><md-select ng-model=\"vm.tFrequency\" id=\"searchmodule\" \nmd-on-close=\"vm.searchfe = \'\'\" required><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searchfe\" type=\"text\" \nplaceholder=\"Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.tFrequency = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" \nvalue=\"{{row.Name}}\">{{row.Name}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.tPrice\" placeholder=\"Price\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"OptionsSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm2.$invalid\">{{\'PREPAREQUOTATION.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\">{{\'PREPAREQUOTATION.CANCEL\'|translate}}</md-button></div></form>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/preparequotation/SaveasTemplatepopup.html","<md-dialog style=\"width:50%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"PREPAREQUOTATION.TEMPLATE\" class=\"title\">Template</span><md-button\n class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions flex><form name=\"basicForm\" class=\"md-inline-form\" flex novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.TemplateName\" \nplaceholder=\"{{\'PREPAREQUOTATION.TEMPLATE_NAME\'|translate}}\" required><p ng-show=\"error1\" style=\"color:red\">\n{{\'PREPAREQUOTATION.TEMPLATE_NAME_IS_ALREADY_EXIST\'|translate}}.</p></md-input-container><md-input-container flex>\n<label translate=\"PREPAREQUOTATION.DIVISION\">Division</label><md-select ng-model=\"vm.Division\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchDivision\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'PREPAREQUOTATION.SEARCH_FOR_A_DIVISION\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.Division = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Divisiondatas | filter:vm.searchDivisionsearchCC\" value=\"{{row.id}}\">{{row.DivisionName}}</md-option>\n</md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SaveasTemplatesubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{\'PREPAREQUOTATION.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\n{{\'PREPAREQUOTATION.CANCEL\'|translate}}</md-button></div></form></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/preparequotation/preparequotation.html","<div class=\"content\" id=\"invoice\" ng-show=\"Previewdiv\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b style=\"padding-left:6%\">\n{{\'PREPAREQUOTATION.QUOTATION\'|translate}}</b></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th width=\"220px\" \nstyle=\"border-collapse: collapse; width:25%\">{{\'PREPAREQUOTATION.REFERENCE\'|translate}} # :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{LeadReferenceNo}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">{{\'PREPAREQUOTATION.DATE\'|translate}} :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{EnquiryDate| date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:25%\">{{\'PREPAREQUOTATION.CUSTOMER_NAME\'|translate}}:</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{Customer}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">{{\'PREPAREQUOTATION.RECEIVED_BY\'|translate}} :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{EnquiryReceivedBy}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:25%\">{{\'PREPAREQUOTATION.MODE\'|translate}} :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{EnquiryMode}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">{{\'PREPAREQUOTATION.TYPE\'|translate}} :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{EnquiryType}}</th></tr></thead><tbody></tbody></table>\n<br><h3 style=\"font-weight: 600;margin:0px\">{{Subject}}</h3><div class=\"printtextarea\"><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" ng-disabled class=\"pb-32\"></text-angular></div><div \nstyle=\"font-size:17px;text-align:left\"><h4 style=\"font-weight: 600;margin-bottom:0px\">{{vm.TableTitle3}}</h4><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:center\">DESCRIPTION OF WORK</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">QUANTITY</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">UNIT PRICE</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">AMOUNT</th></tr></thead><tbody>\n<tr ng-repeat=\"row in Quotationdatas\" ng-if=\"row.TableEnquiryID3 == EnquiryID && EnquiryID != null\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:left\">{{ row.T3Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.T3Quantity }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.T3UnitRate| number : 2 }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:right\">{{ row.T3Amount| number : 2}}</td></tr><tr \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td></td><td></td><td><b>GST 7 %</b></td><td \nstyle=\"text-align:right\">{{vm.GSTTotal | number : 2}}</td></tr><tr \nstyle=\"border: 1px solid black;border-collapse: collapse;border-top:none\"><td></td><td></td><td style=\"width:1000px\">\n<b>Total Inclusive of GST</b></td><td style=\"text-align:right\">{{vm.TotalPrice | number : 2}}</td></tr></tbody></table>\n</div><br><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Footer\" ng-disabled \nclass=\"pb-32\"></text-angular></div></div><div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"PREPAREQUOTATION.PREPARE QUOTATION\">Prepare Quotation</span>\n</div></div><md-button type=\"submit\" ng-click=\"Back()\" class=\"md-raised\" translate=\"PREPAREQUOTATION.BACK\">Back\n</md-button></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div class=\"p-8\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"padding-bottom:0\"><div class=\"p-4\" style=\"width:15%\"><label\n style=\"font-size:17px;color:#7f9593\"><b>Enquiry #</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">{{LeadReferenceNo}}</span></div><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Date</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span \nstyle=\"font-size:14px\">{{EnquiryDate| date:\'dd/MM/y\'}}</span></div><md-input-container style=\"width:17%;margin:0\">\n</md-input-container></div><div class=\"p-8\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:15%\"><label style=\"font-size:17px;color:#7f9593\"><b>\nCustomer Name</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">{{Customer}}\n</span></div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:17px;color:#7f9593\"><b>Received By</b></label>\n</div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span style=\"font-size:14px\">{{EnquiryReceivedBy}}</span></div>\n<md-input-container style=\"width:17%;margin:0\"></md-input-container></div><div class=\"p-8\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" \nstyle=\"width:15%\"><label style=\"font-size:17px;color:#7f9593\"><b>Enquiry Mode</b></label></div>:&emsp;<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">{{EnquiryMode}}</span></div><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:17px;color:#7f9593\"><b>Type</b></label></div>:&emsp;<div class=\"p-4\" style=\"width:20%\"><span \nstyle=\"font-size:14px\">{{EnquiryType}}</span></div><md-input-container style=\"margin:0\" flex><label>\n{{\'PREPAREQUOTATION.SELECT TEMPLATE\'|translate}}</label><md-select ng-model=\"uEmployeeID\" id=\"searchmodule\" \nmd-on-close=\"vm.searchct = \'\'\"><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searchct\" type=\"text\" \nplaceholder=\"Select Template..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"uEmployeeID = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-click=\"SelectTemplate(row.id)\" \nng-repeat=\"row in Quotationtemplates  | filter:vm.searchct\" value=\"{{row.id}}\">{{row.TemplateName}}</md-option>\n</md-select></md-input-container></div><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><span flex=\"7\" class=\"h3\" style=\"color:#7f9593\"><b>{{\'PREPAREQUOTATION.SUBJECT\'|translate}}:</b>\n</span>&emsp;<md-input-container style=\"margin-top: 9px\" flex><input type=\"text\" \nstyle=\"font-weight:bold;border-bottom:1px solid #ddd\" ng-model=\"Subject\" flex></md-input-container>\n</material-input-group><span class=\"h3\" style=\"color:#7f9593\"><b>{{\'PREPAREQUOTATION.HEAD\'|translate}} :</b></span>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" class=\"pb-32\"></text-angular><span class=\"h3\" \nstyle=\"color:#7f9593\" \nng-hide=\"(vm.TemplateName | uppercase ) == \'SOIL TREATMENT\' || (vm.TemplateName | uppercase) == \'MOLD DECONTAMINATION\'\">\n<b>{{\'PREPAREQUOTATION.QUOTATION\'|translate}} :</b></span><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-bottom:20px\" \nng-hide=\"(vm.TemplateName | uppercase) == \'SOIL TREATMENT\' || (vm.TemplateName | uppercase) == \'MOLD DECONTAMINATION\'\">\n<md-input-container flex style=\"flex:0.5;margin-bottom: 0\"></md-input-container><md-input-container flex>\n</md-input-container><md-button class=\"md-raised\" ng-click=\"OptionsTable($event)\" style=\"height:4%\">Add</md-button>\n</div><div class=\"content-card\" \nng-hide=\"(vm.TemplateName | uppercase) == \'SOIL TREATMENT\' || (vm.TemplateName | uppercase) == \'MOLD DECONTAMINATION\'\">\n<div class=\"white-bg md-whiteframe-4dp\"><table class=\"table dataTable row-border hover\" id=\"tb2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Coverage</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nFrequency</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Price</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in LeadOptionsTabledata\"><td>&nbsp;</td><td>{{ row.PestCoverage }}</td><td>\n{{ row.Frequency}}</td><td>${{ row.Price}}</td></tr></tbody></table></div></div><br><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:20px;margin-bottom:18px\" ng-repeat=\"row in Options\" \nng-hide=\"(vm.TemplateName | uppercase) == \'SOIL TREATMENT\' || (vm.TemplateName | uppercase) == \'MOLD DECONTAMINATION\'\">\n<div style=\"width:100%\"><md-checkbox ng-model=\"row.selected\" ng-change=\"GetSelectedOptions(row.selected,row)\" \ntype=\"checkbox\"><span flex=\"2\" class=\"h3\" style=\"color:#7f9593\"><b>Option{{$index + 1}}</b></span>&emsp;</md-checkbox>\n<div class=\"white-bg md-whiteframe-4dp\"><table class=\"table dataTable row-border hover\" id=\"tb2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Coverage</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nFrequency</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Price</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"rows in row\"><td>&nbsp;</td><td>{{ rows.PestItems }}</td><td>{{ rows.Frequency}}</td><td>\n${{ rows.Price}}</td></tr></tbody></table></div></div></div><span class=\"h3\" style=\"color:#7f9593\"><b>\n{{\'PREPAREQUOTATION.FOOTER\'|translate}} :</b></span><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Footer\" \nclass=\"pb-32\"></text-angular><material-input-group layout=\"horizontal\" \nng-hide=\"(vm.TemplateName | uppercase) == \'SOIL TREATMENT\' || (vm.TemplateName | uppercase) == \'MOLD DECONTAMINATION\'\">\n<md-checkbox ng-model=\"IncludeSOR\" type=\"checkbox\"><span flex=\"2\" class=\"h3\" style=\"color:#7f9593\"><b>Include SOR?</b>\n</span>&emsp;</md-checkbox></material-input-group><div class=\"bottom\" layout=\"row\" layout-align=\"space-between\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"sSave()\" class=\"md-raised\">\n{{\'PREPAREQUOTATION.SAVE\'|translate}}</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\">\n{{\'PREPAREQUOTATION.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" ng-click=\"Back()\" class=\"md-raised\">\n{{\'PREPAREQUOTATION.CANCEL\'|translate}}</md-button></div><div><md-button type=\"submit\" ng-click=\"Preview(\'invoice\')\" \nclass=\"md-raised\">{{\'PREPAREQUOTATION.PREVIEW\'|translate}}</md-button><md-button type=\"submit\" ng-click=\"Back()\" \nclass=\"md-raised\">{{\'PREPAREQUOTATION.BACK\'|translate}}</md-button><md-button type=\"submit\" \nng-click=\"SaveasTemplatepopup($event)\" class=\"md-raised\">{{\'PREPAREQUOTATION.SAVE AS TEMPLATE\'|translate}}</md-button>\n</div></div></form></div></div><br></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label > md-datepicker .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px -6px;\r\n    }\r\n\r\n    table {\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    #example table.dataTable tbody td {\r\n        padding: 2px 8px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    table.dataTable {\r\n        border-bottom: 0;\r\n        border-top: 0;\r\n    }\r\n\r\n    textarea {\r\n        width: 85%;\r\n        height: 100px;\r\n        padding: 30px 20px;\r\n        resize: none;\r\n        font-size: 17px;\r\n    }\r\n\r\n    [disabled] md-input-container.md-default-theme .md-input, [disabled] md-input-container .md-input, md-input-container.md-default-theme .md-input[disabled], md-input-container .md-input[disabled] {\r\n        border-bottom-color: transparent;\r\n        border-bottom: 1px solid #e0e0e0;\r\n        color: rgba(0,0,0,0.38);\r\n        background-image: linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0);\r\n        background-image: -ms-linear-gradient(left,transparent 0,rgba(0,0,0,0.38) 100%);\r\n    }\r\n\r\n    .md-button.md-default-theme.md-primary.md-fab, .md-button.md-primary.md-fab, .md-button.md-default-theme.md-primary.md-raised, .md-button.md-primary.md-raised {\r\n        color: rgb(255, 255, 255);\r\n        background-color: rgba(8, 73, 68, 0.75);\r\n    }\r\n\r\n    .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #qmaintable .dataTables_wrapper .bottom {\r\n        display: flex;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    div.printtextarea > text-angular {\r\n        border: 1px solid black !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/preparequotation/preparequotationpopup.html","<md-dialog style=\"width:70%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{TableTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><form name=\"basicForm2\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.T3Description\" placeholder=\"Description of Work\" required></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3Quantity\" placeholder=\"Quantity\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3UnitRate\" placeholder=\"Unit Rate\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title3Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm2.$invalid\">{{\'PREPAREQUOTATION.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\">{{\'PREPAREQUOTATION.CANCEL\'|translate}}</md-button></div></form>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/settings/emailsettingsPopup.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">EMAIL SETTINGS</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"email\" \nstyle=\"border-radius:3px;padding-left:5px\" name=\"email\" ng-model=\"vm.EmailFrom\" placeholder=\"Email From\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email field is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"EmailPassword\" ng-model=\"vm.EmailPassword\" \nplaceholder=\"Email Password\" required></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><input type=\"text\" name=\"EmailSMTP\" ng-model=\"vm.EmailSMTP\" placeholder=\"Email SMTP\" required>\n</md-input-container><md-input-container flex><label>Enable SSL</label><md-select ng-model=\"vm.EnableSsl\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Enable SSL..\" ng-keydown=\"$event.stopPropagation()\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.EnableSsl=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EnableSSL | filter:vm.searchTerm1\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"number\" \nname=\"EmailPort\" ng-model=\"vm.EmailPort\" placeholder=\"Email Port\" required></md-input-container><md-input-container \nflex><input type=\"text\" name=\"EmailLicense\" ng-model=\"vm.EmailLicense\" placeholder=\"Email License\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"EmailSettingadd()\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"closeDialog()\" aria-label=\"CANCEL\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/settings/settings.html","<div id=\"qualification\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span translate=\"SETTING.HEADER\">Settings</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" \nng-model=\"model.Search\" placeholder=\"{{\'SETTING.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"CreditTermExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"PaymentTermsExport && AllowExport==\'true\'\" ng-click=\"ptExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"BillingFrequencyExport && AllowExport==\'true\'\" ng-click=\"bfExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"ScheduleFrequencyExport && AllowExport==\'true\'\" ng-click=\"sfExport()\"><md-icon\n md-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"JobTypesExport && AllowExport==\'true\'\" ng-click=\"jtExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"PaymentModeExport && AllowExport==\'true\'\" ng-click=\"pmExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"ContactMediumExport && AllowExport==\'true\'\" ng-click=\"cmExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"EnquiryModeExport && AllowExport==\'true\'\" ng-click=\"emExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"BuildingTypeExport && AllowExport==\'true\'\" ng-click=\"btExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"RemarksExport && AllowExport==\'true\'\" ng-click=\"rExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"AreaExport && AllowExport==\'true\'\" ng-click=\"aExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SETTING.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"CreT()\"><md-tab-label \ntranslate=\"SETTING.CREDIT_TERM\"><span>Credit Terms</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform1\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"EducationLevel\" \nng-model=\"vm.CreditTerm\" placeholder=\"{{\'SETTING.CREDIT_TERM\'|translate}}\" required></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"CreditTermSubmit()\" \nng-disabled=\"!vm.CreditTerm\"><span translate=\"SETTING.SAVE\">Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"vm.CreditTerm = null;\"><span translate=\"SETTING.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"CreditTermdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" style=\"border:1px solid rgb(224, 224, 224)\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.CREDIT_TERM\" class=\"column-title\">Credit Terms</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in CreditTermdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>\n{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td><td>\n{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"CreditTerminfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"PayT()\"><md-tab-label><span>Payment Term</span></md-tab-label></div>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"qualificationform2\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.PaymentTerm\" placeholder=\"{{\'SETTING.PAYMENT_TERMS\'|translate}}\" required>\n</md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"PaymentTermSubmit()\" ng-disabled=\"!vm.PaymentTerm\"><span translate=\"SETTING.SAVE\">Save</span></md-button>\n<md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"vm.PaymentTerm = null;\"><span \ntranslate=\"SETTING.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"PaymentTermdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224)\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.PAYMENT_TERMS\" \nclass=\"column-title\">Payment Terms</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PaymentTermdatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td><td>\n{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"PaymentTerminfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"BillF()\"><md-tab-label translate=\"SETTING.BILLING_FREQUENCY\"><span>\nBilling Frequency</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform3\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Licenses\" \nng-model=\"vm.BillingFrequency\" placeholder=\"{{\'SETTING.BILLING_FREQUENCY\'|translate}}\" required></md-input-container>\n<md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"BillingFrequencySubmit()\" \nng-disabled=\"!vm.BillingFrequency\"><span translate=\"SETTING.SAVE\">Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"vm.BillingFrequency = null;\"><span translate=\"SETTING.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"BillingFrequencydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.BILLING_FREQUENCY\" class=\"column-title\">Billing Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">\nUpdated Date</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in BillingFrequencydatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Name }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>\n{{ row.UpdatedBy }}</td><td>{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"BillingFrequencyinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteSettings(row.id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"SchedF()\"><md-tab-label><span>Schedule Frequency\n</span></md-tab-label></div><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<form name=\"qualificationform4\" novalidate><div class=\"content-card\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"ScheduleFrequencydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.SCHEDULE FREQUENCY\" class=\"column-title\">Schedule Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">\nUpdated Date</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in ScheduleFrequencydatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Name }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>\n{{ row.UpdatedBy }}</td><td>{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"ScheduleFrequencyinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteSettings(row.id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table>\n</div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"PayM()\"><md-tab-label \ntranslate=\"SETTING.PAYMENT_MODE..\"><span>Payment Mode</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform5\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Licenses\" \nng-model=\"vm.PaymentMode\" placeholder=\"{{\'SETTING.PAYMENT_MODE\'|translate}}\" required></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"PaymentModeSubmit()\" \nng-disabled=\"!vm.PaymentMode\"><span translate=\"SETTING.SAVE\">Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"vm.PaymentMode = null;\"><span translate=\"SETTING.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"PaymentModedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.PAYMENT_MODE..\" class=\"column-title\">Payment Mode</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in PaymentModedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}\n</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td>\n<td>{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"PaymentModeinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"JobT()\"><md-tab-label translate=\"SETTING.JOB TYPES\"><span>Job Types\n</span></md-tab-label></div><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<form name=\"qualificationform6\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nflex><input type=\"text\" name=\"Licenses\" ng-model=\"vm.JobTypes\" placeholder=\"{{\'SETTING.JOB TYPES\'|translate}}\" \nrequired></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"JobTypesSubmit()\" ng-disabled=\"!vm.JobTypes\"><span translate=\"SETTING.SAVE\">Save</span></md-button><md-button\n id=\"cancel\" class=\"md-raised md-background\" ng-click=\"vm.JobTypes = null;\"><span translate=\"SETTING.CANCEL\">Cancel\n</span></md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"JobTypesdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.JOB TYPES\" class=\"column-title\">Job Types</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in JobTypesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>\n{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td><td>\n{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"JobTypesinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"ContM()\"><md-tab-label translate=\"SETTING.CONTACT_MEDIUM\"><span>\nContact Medium</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform7\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Licenses\" \nng-model=\"vm.ContactMedium\" placeholder=\"{{\'SETTING.CONTACT_MEDIUM\'|translate}}\" required></md-input-container>\n<md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ContactMediumSubmit()\" \nng-disabled=\"!vm.ContactMedium\"><span translate=\"SETTING.SAVE\">Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"vm.ContactMedium = null;\"><span translate=\"SETTING.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"ContactMediumdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"SETTING.CONTACT_MEDIUM\" class=\"column-title\">Contact Medium</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in ContactMediumdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}\n</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td>\n<td>{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ContactMediuminfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"EnqM()\"><md-tab-label translate=\"SETTING.ENQUIRY_MODE\"><span>Enquiry Mode\n</span></md-tab-label></div><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<form name=\"qualificationform8\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nflex><input type=\"text\" name=\"Licenses\" ng-model=\"vm.EnquiryMode\" placeholder=\"{{\'SETTING.ENQUIRY_MODE\'|translate}}\" \nrequired></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"EnquiryModeSubmit()\" ng-disabled=\"!vm.EnquiryMode\"><span translate=\"SETTING.SAVE\">Save</span></md-button>\n<md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"vm.EnquiryMode = null;\"><span \ntranslate=\"SETTING.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"EnquiryModedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224)\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span translate=\"SETTING.ENQUIRY_MODE\" \nclass=\"column-title\">Enquiry Mode</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SETTING.CREATED_BY\" class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SETTING.CREATED_DATE\" class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"SETTING.UPDATED_BY\" class=\"column-title\">Updated By</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"SETTING.UPDATE_DATE\" class=\"column-title\">Updated Date</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"SETTING.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EnquiryModedatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate| date :\"dd/MM/y hh:mm a\" }}</td><td>{{ row.UpdatedBy }}</td><td>\n{{ row.UpdatedDate | date :\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"EnquiryModeinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteSettings(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    /*.layout-gt-sm-row.layout-align-start-center {\r\n        padding: 15px !important;\r\n    }*/\n</style>");
$templateCache.put("app/main/apps/crm/salesorder/AddPaymentFrequency.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Payment Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PaymentFrequencyForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.PaymentDate\" \nmd-date-format=\"dd/MM/y\" style=\"width: 22em\" required></md-datepicker></md-input-container><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Percentage %</label><input type=\"number\" name=\"Percentage\" \nng-model=\"vm.PaymentPercentage\" value=\"100\" required> <span \nng-show=\"(PaymentFrequencyForm.Percentage.$error.min || PaymentFrequencyForm.Percentage.$error.max) && PaymentFrequencyForm.Percentage.$touched\" \nstyle=\"color: red; font-size: 13px\">Please enter percentage value from 1 to 100.</span></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label>Payment Mode</label><md-select \nng-model=\"vm.PaymentFrequencyMode\" id=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" type=\"text\" placeholder=\"Payment Mode...\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PaymentFrequencyMode = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container style=\"margin-top: 18px\" \nflex><label>Remarks</label><input type=\"text\" name=\"Remarks\" ng-model=\"vm.PaymentRemarks\"></md-input-container></div>\n<div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPaymentFrequency()\" \naria-label=\"Ok\" ng-disabled=\"PaymentFrequencyForm.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog><style>\n.md-datepicker-button {\n        display: none;\n    }\n\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\n        right: 85px;\n    }\n\n    md-datepicker .md-datepicker-input {\n        width: calc(20vw - 28px);\n        max-width: calc(20vw - 28px);\n        margin-left: -11px;\n    }\n\n    li:first-letter {\n        text-transform: capitalize;\n    }\n</style>");
$templateCache.put("app/main/apps/crm/salesorder/AddTreatmentFrequency.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Frequency</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Frequency</label><md-select ng-model=\"vm.Frequency\" \nng-change=\"ForAlternateWeek(vm.Frequency)\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required \nng-disabled=\"PestUpdate\"><md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Frequency..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" \nng-click=\"calculateServices(row.Name,vm.JobsPerFrequency)\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"PestUpdate==false\"><label>Pest Types</label><md-select \nng-model=\"vm.SelectPest\" name=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest);CheckTreatment()\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required \nng-disabled=\"PestUpdate\"><md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatasdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"PestUpdate==true\"><input type=\"text\" name=\"Pesttype\" \nng-model=\"vm.EPesttype\" placeholder=\"Pest Types\" ng-disabled=\"PestUpdate==true\"></md-input-container></div><div \nstyle=\"width: 100%\"><span style=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" \nng-if=\"Treatmentpopupdata.length > 0\"><u>Treatment Methods:</u></span></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex ng-if=\"Treatmentpopupdata.length > 0\" ng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%\"><li \nng-repeat=\"item in Tpd.Treatment\" style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{item.selected}}\" ng-model=\"item.selected\" type=\"checkbox\"><span flex=\"2\" \nstyle=\"color:#272626;font-size:15px\">{{item.TreatmentName}} </span>&emsp;</md-checkbox></li></ul><ul \nstyle=\"width: 100%;margin-top:-8px\"><li style=\"list-style-type: none;float: left\"><md-checkbox \nng-checked=\"{{Tpd.selectothers}}\" ng-model=\"Tpd.selectothers\">Others:</md-checkbox><input type=\"text\" \nng-model=\"Tpd.Others\" style=\"border-bottom:1px solid #464545;border-radius:0%;width:400px!important\"><md-checkbox \nng-checked=\"{{Tpd.SelectServiceTrap}}\" ng-if=\"Tpd.PestName==\'Flies\'\" ng-model=\"Tpd.SelectServiceTrap\">\nService Light Traps:</md-checkbox><input type=\"text\" ng-model=\"Tpd.ServiceTrap\" ng-if=\"Tpd.PestName==\'Flies\'\" \nstyle=\"border-bottom:1px solid #464545;border-radius:0%;width:100px!important\"></li></ul></td></tr></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest()\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n    li:first-letter {\r\n    text-transform:capitalize;\r\n}\n</style>");
$templateCache.put("app/main/apps/crm/salesorder/Service.html","<md-dialog ng-style=\"{width:vm.sty + \'%\'}\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMCUSTOMER.ADDRESS\">{{PopupType}} Address</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0 2% 0 2%\"><div ng-show=\"Service\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-checkbox \nng-model=\"Servicecopy.value\" ng-change=\"copymain(this)\" type=\"checkbox\"><span>Copy from main address?</span>\n</md-checkbox><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0;flex: 0.5\">\n<input type=\"text\" ng-model=\"vm.usName\" placeholder=\"Name\"></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \non-place-changed=\"placeChanged1()\" ng-model=\"vm.usStreetName\" placeholder=\"\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nng-model=\"vm.usContactPerson\" placeholder=\"Site Contact Person\"></md-input-container><md-chips \nstyle=\"width: 66% !important ; height: 13% !important\" ng-model=\"vm.usMobile\" name=\"sContactNum\" \nmd-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"sContactNum\"><input type=\"text\" name=\"sContactNum\" \nplaceholder=\"Contact Number\"></md-chips></div><p style=\"margin-left: 35%;margin-top: -23px !important\" \nclass=\"md-caption\"><b>Note</b>\n:Seperate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nname=\"BuildingName\" ng-model=\"vm.usBuildingName\" placeholder=\"{{\'CRMCUSTOMER.BULDING_NAME\' | translate}}\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.usPostal\" \nplaceholder=\"{{\'CRMCUSTOMER.POSTAL_CODE\' | translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"CRMCUSTOMER.RECEIVE_SERVICE_REPORT_BY_EMAIL\"><b>Receive Service Report By Email :</b></span><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.ZoneCC\" placeholder=\"Email\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips \nng-model=\"vm.ZoneEmail\" placeholder=\"CC\" readonly=\"vm.readonly\" style=\"width: 100%;padding:0!important\"></md-chips>\n</div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">Type CC and Press Enter</span><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Serviceadd(vm.Index);ClearGrid();\" \nng-disabled=\"eventForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel();ClearGrid();\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div>\n</form></div><div ng-show=\"Billing\"><form name=\"BillingForm\" class=\"md-inline-form\" novalidate><md-checkbox-container \nflex><md-checkbox ng-model=\"checkboxModel.value\" ng-change=\"copybilling(this)\" type=\"checkbox\"><span \ntranslate=\"CRMCUSTOMER.COPY_FROM_MAIN_ADDRESS\">Copy from main address?</span></md-checkbox></md-checkbox-container><div\n layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubContactPerson\" \nplaceholder=\"{{ \'CRMCUSTOMER.CONTACT_PERSON\' | translate }}\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.ubMobile\" placeholder=\"{{ \'CRMCUSTOMER.MOBILE\' | translate }}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubEmail\" \nplaceholder=\"{{ \'CRMCUSTOMER.EMAIL\' | translate }}\"></md-input-container><md-input-container flex><label>Address\n</label><input places-auto-complete types=\"[\'geocode\']\" on-place-changed=\"placeChanged2()\" ng-model=\"vm.ubStreetName\" \nplaceholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.ubBuildingName\" placeholder=\"{{ \'CRMCUSTOMER.BUILDING_NAME\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.ubPostal\" \nplaceholder=\"{{ \'CRMCUSTOMER.POSTAL_CODE\' | translate }}\" required></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Billingadd(vm.Index)\" \nng-disabled=\"BillingForm.$invalid\" translate=\"CRMCUSTOMER.SUBMIT\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"CRMCUSTOMER.CANCEL\">Cancel</md-button></div></form></div>\n</md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n  .ms-scroll{\r\n    position: relative;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/salesorder/addcustomer.html","<md-dialog style=\"width:100%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"CRMLEAD.CREATE_CUSTOMER\">\nCreate Customer</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><div layout=\"row\"><ms-form-wizard flex>\n<md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"false\"><md-tab><md-tab-label><span \nng-if=\"wizardStep1.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Customer Details</span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" name=\"CompanyName\" \nng-model=\"vm.uCompanyName\" placeholder=\"Company Name\" required><div ng-messages=\"wizardStep1.CompanyName.$error\" \nng-show=\"wizardStep1.CompanyName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Company Name is required.\n</span></div></div><p ng-show=\"error1\" style=\"color:red\">Company Name Is already Exist.</p></md-input-container>\n<md-input-container flex><label>Market Segment</label><md-select ng-model=\"vm.MarketSection\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermC = \'\'\" ng-model-options=\"{trackBy: \'$value.SegmentName\'}\" multiple=\"\"><md-select-header>\n<input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For a Segment\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.MarketSection = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Marketsegmentdatas | filter:vm.searchTermC\" ng-value=\"row\">\n{{row.SegmentName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><label>Salutation</label><md-select ng-model=\"vm.uSalutation\" required><md-option value=\"Mr\">\nMr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Mdm\">Mdm</md-option><md-option value=\"Ms\">Ms\n</md-option><md-option value=\"Mr\">Dr</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"FirstName\" ng-model=\"vm.uFirstName\" placeholder=\"Name\" required><div \nng-messages=\"wizardStep1.FirstName.$error\" ng-show=\"wizardStep1.FirstName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Full Name is required.</span></div></div></md-input-container><md-input-container \nid=\"date4\" flex><label style=\"margin-left: -10px\">Follow-up Date</label><md-datepicker \nng-model=\"vm.ProspectFollowupDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Address</label><input places-auto-complete \ntypes=\"[\'geocode\']\" on-place-changed=\"placeChanged()\" ng-model=\"vm.StreetName\" placeholder=\"\" required>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"BuildingName\" ng-model=\"vm.BuildingName\" \nplaceholder=\"Building Name\"></md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" \nng-model=\"vm.uPostal\" placeholder=\"Postal Code\" required><div ng-messages=\"wizardStep1.PostalCode.$error\" \nng-show=\"wizardStep1.PostalCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Postal Code is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips ng-model=\"vm.uEmail\" \nplaceholder=\"Email\" ng-init=\"vm.uEmail=[]\" style=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h5\" \nstyle=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-chips style=\"width: 68% !important ; height: 13% !important\" ng-model=\"vm.uMobile\" ng-init=\"vm.uMobile=[]\" \nname=\"ContactNum\" md-separator-keys=\"vm.keys\" md-max-chips=\"5\" input-aria-label=\"ContactNum\"><input type=\"number\" \nname=\"ContactNum\" placeholder=\"Contact Number\"></md-chips><md-input-container id=\"date4\" flex><label \nstyle=\"margin-left: -10px\">Contract End Date</label><md-datepicker ng-model=\"vm.ConEndDate\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container></div><p style=\"float: left; margin-top:-33px !important\" class=\"md-caption\"><b>\nNote</b>:Seperate Contact Numbers with comma (,) or press Enter. Maximum 5 Contact Numbers are allowed.</p></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\">\n</span> <span class=\"ms-form-wizard-step-text\">Billing & Service Address</span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div \nstyle=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div><div \nlayout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID, \'Billing\')\"><span>Add</span></md-button>\n</div></div><div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div\n style=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div layout=\"row\" \nstyle=\"padding-bottom:0.5%\"><div flex><div ng-show=\"SAdiv\" flex style=\"padding-left:40%\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Service Address Selected: {{SelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AcceptanceforUpdateEmail($event)\"><span>\nUPDATE EMAILID</span></md-button></div></div><div><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Servicepopup($event, vm.uCustomerID,  \'Service\')\"><span>Add</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" \ndx-data-grid=\"vm.dataGridCustomerService\"></div></div><br></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"padding: 0\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"customerSubmit()\" ng-disabled=\"msWizard.currentStepInvalid()\" \ntranslate=\"CRMLEAD.SUBMIT\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.CANCEL\">Cancel</md-button></div></ms-form-wizard></div></md-dialog-content></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n    width: calc(20vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .dataTables_wrapper .dataTables_filter {\r\n    float: right !important;\r\n  }\r\n\r\n  div.dataTables_filter input {\r\n    width: 30em !important;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  .md-tab.md-active {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n    border-bottom: none !important;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n    background-color: #83878a !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\r\n    border-bottom-color: #606a71;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n    border-left-color: #606a71 !important;\r\n    border-right-color: #606a71 !important;\r\n  }\r\n\r\n  .dx-button {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  .dx-button-has-icon .dx-button-content {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n    color: #535858 !important;\r\n    font-weight: bold !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/crm/salesorder/cspopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CRMLEAD.DELETE_THIS_ADDRESS?\">Delete this Address?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Servicedelete(vm.deleteID)\" \nclass=\"md-raised md-accent\" translate=\"CRMLEAD.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"CRMLEAD.NO\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/salesorder/saleorder.html","<div id=\"salesOrder\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>\nTreatment Instructions</span></div><div class=\"product-count secondary-text\"><span>Total Treatment Instructions:</span>\n <span>{{workOrd.length}}</span></div></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CRMSALESORDER.ADD\">Add</span>\n</md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"CRMSALESORDER.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CRMSALESORDER.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\" ng-show=\"Salesgrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\">\n<md-tab ng-click=\"workOrd=salesOrderdatas\"><md-tab-label><span>Contract</span></md-tab-label><md-tab-body><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridSales\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=AdhocsalesOrderdatas\"><md-tab-label><span>Ad-hoc</span></md-tab-label><md-tab-body><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridAdhoc\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=DeletedSalesOrderdatas; getDeletedWO()\"><md-tab-label><span>Deleted Work Orders</span></md-tab-label>\n<md-tab-body><div id=\"DeletedWO\" dx-data-grid=\"vm.dataGridWorkOrder\"></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Salesform\" flex><span \nng-if=\"Update\" style=\"font-size: 18px; font-weight: 500\">{{vm.SalesOrderNo}}</span><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><br><div layout=\"column\" layout-gt-sm=\"row\"><md-radio-container flex \nstyle=\"height:70px\"><md-radio-group ng-model=\"vm.OrderType\" layout=\"row\" style=\"margin: 0\" required \nng-disabled=\"EUpdate == true\"><span style=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 10px\">Type :\n</span><md-radio-button value=\"Ad-hoc\">Ad-hoc</md-radio-button><md-radio-button \nvalue=\"{{\'CRMSALESORDER.CONTRACT\'|translate}}\">{{\'CRMSALESORDER.CONTRACT\'|translate}}</md-radio-button>\n</md-radio-group></md-radio-container><md-radio-container flex style=\"height: 120px;margin-top: -20px\"><md-radio-group \nng-model=\"vm.IsUrgent\" layout=\"row\" style=\"margin: 20px 0 0 0px\" required><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 65px\">VIP ? :</span><md-radio-button value=\"true\">Yes\n</md-radio-button><md-radio-button value=\"false\">No</md-radio-button></md-radio-group><md-radio-group \nng-model=\"vm.TrendingReport\" layout=\"row\" style=\"margin: 20px 0 0 0px\" required><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 10px\">Trending Reports? :</span><md-radio-button \nvalue=\"true\">Yes</md-radio-button><md-radio-button value=\"false\">No</md-radio-button></md-radio-group>\n</md-radio-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Salesperson</label>\n<md-select ng-model=\"vm.SalesPerson\" name=\"SalesPerson\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_SALES_PERSON\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.SalesPerson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-right:3px\"><label>Customer Name\n</label><md-select ng-model=\"vm.CustomerName\" name=\"CustomerName\" md-on-close=\"vm.searchTermC = \'\'\" id=\"searchmodule\" \nrequired ng-disabled=\"Update\"><md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_CUSTOMER\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CustomerName = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatasfordropdown | filter:vm.searchTermC\" \nng-click=\"GetLead(row.id, row.CustomerID);vm.CustomerArray=row;\r\n                                    vm.emailCname = row.CompanyName;vm.CustomerID = row.CustomerID;vm.uContactPerson = row.CompanyName;\r\n                                    row.Email!=null && row.Email!=undefined && row.Email!=\'\'?vm.BEmail=row.Email.split(\',\'): vm.BEmail=[];\r\n                                    row.Mobile!=null && row.Mobile!=undefined && row.Mobile!=\'\'?vm.BContactNo=row.Mobile.split(\',\').splice(0,2) : vm.BContactNo=[];vm.BContactPerson=row.ContactPerson\" \nvalue=\"{{row.id}}\">{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.OrderType==\'Contract\'\"><label>Contract #</label><md-select ng-model=\"vm.ContractNo\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermeq = \'\'\" required ng-disabled=\"Update\"><md-select-header><input ng-model=\"vm.searchTermS\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Contract #\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ContractNo = null;vm.searchTermeq = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in contractdatas | filter:vm.searchTermeq\" ng-click=\"getFrequencyTable(row)\" value=\"{{row._id}}\">\n{{row.ContractReferenceNo}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 27px\"><md-input-container flex><label>Contact Person</label><input type=\"text\" \nng-model=\"vm.BContactPerson\" readonly=\"readonly\"></md-input-container><md-input-container flex \nng-if=\"vm.OrderType==\'Contract\'|| Update\"><label>Billing Address</label><input type=\"text\" ng-model=\"vm.BAddress\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex ng-if=\"vm.OrderType!=\'Contract\'&& !Update\"><label>\nBilling Address</label><md-select ng-model=\"vm.BAddressId\" id=\"searchmodule\" md-on-close=\"vm.searchTermB = \'\'\" \nrequired><md-select-header><input ng-model=\"vm.searchTermB\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search For Billing Location\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BAddressId = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CustomerBBilingAddres | filter:vm.searchTermB\" \nng-click=\"vm.BEmail=row.bEmail.split(\',\') ; vm.BContactPerson=row.bContactPerson ;  vm.BContactNo= row.bMobile ? row.bMobile.split(\',\') : [];; BillingArray=row\" \nvalue=\"{{row._id}}\">{{row.bStreetName}} {{row.bPostal}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\"><div layout=\"column\" style=\"width: 100%\"><md-chips flex style=\"height: 13% !important\" \nng-model=\"vm.BContactNo\" name=\"BContactNo\" md-separator-keys=\"vm.keys\" md-max-chips=\"4\" input-aria-label=\"BContactNo\" \nmd-on-add=\"vm.onContactChipAdd($chip)\"><input type=\"text\" name=\"BContactNo\" placeholder=\"Contact Number\"></md-chips>\n<div class=\"error-message\" ng-show=\"vm.contactChipWarning\" style=\"color: red; font-size: 13px\">\nPlease press \"Enter\" after typing the contact number.</div><p class=\"md-caption\" style=\"margin-top: 4px\"><b>Note</b>\n: Separate Contact Numbers with comma (,) or press Enter. Maximum 3 Contact Numbers are allowed.</p><div \nng-show=\"vm.contactErrorMessage\" style=\"color: red\">Invalid format. Use +60-123-4567-89</div></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 47px\"><md-chips md-transform-chip=\"transformChip($chip)\" flex \nstyle=\"width: 100%; margin-top: -2%;margin-bottom: 30px\" ng-model=\"vm.BEmail\" name=\"Email\" ng-init=\"vm.BEmail=[]\" \ninput-aria-label=\"Email\"><input type=\"text\" name=\"Email\" placeholder=\"Email\" md-on-add=\"vm.onEmailChipAdd($chip)\">\n</md-chips></div><div ng-show=\"vm.emailValidationError\" style=\"color: red; font-size: 13px\">Please enter valid email.\n</div><div ng-show=\"vm.emailChipWarning\" style=\"color: red; font-size: 13px;margin-top: -15px\">\nPlease press \"Enter\" after typing the email.</div><div class=\"h4\" style=\"color:#7f9593\">Type Email and Press Enter\n</div><span style=\"color:#7f9593\"><h3>Site Details</h3></span><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 27px\"><md-input-container flex ng-if=\"Update==false\"><label>Service Address</label><md-select \nng-model=\"vm.SLocation\" id=\"searchmodule\" md-on-close=\"vm.searchTermW = \'\'\" multiple=\"\" required><md-select-header>\n<input ng-model=\"vm.searchTermW\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For Service Location\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.SLocation = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CustomerSServiceAddress | filter:vm.searchTermC\" ng-value=\"row\">\n{{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"Update==true\"><label>Service Address</label><md-select ng-model=\"vm.SLocation\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermW = \'\'\" required ng-disabled=\"DisableServiceLocation\"><md-select-header><input \nng-model=\"vm.searchTermW\" style=\"flex: auto\" type=\"text\" placeholder=\"Search For Service Location\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.SLocation = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CustomerSServiceAddress | filter:vm.searchTermC\" value=\"{{row._id}}\">\n{{row.sStreetName}} {{row.sPostal}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px; flex: 0.5\"><label>Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" \nid=\"searchmodule\" md-on-close=\"vm.searchTerm1 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Billing Frequency\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTerm1\" ng-click=\"getPerMonth(row.Name)\" value=\"{{row.Name}}\">\n{{row.Name}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;flex: 0.5\">\n<label>Payment Term</label><md-select ng-model=\"vm.PaymentMode\" id=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" \nrequired><md-select-header><input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Payment Term...\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PaymentMode = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentTermdatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 27px\"><md-input-container flex>\n<input type=\"number\" placeholder=\"Total Price\" ng-model=\"vm.TotalPrice\" required></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label>Credit Term</label><md-select ng-model=\"vm.CreditTerm\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermPm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Credit Term...\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CreditTerm = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CreditTermdatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" placeholder=\"Special Chemical/Equipments\" \nng-model=\"vm.SpecialChemical\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nid=\"date4\" flex style=\"margin-top: 18px\" ng-if=\"vm.OrderType==\'Contract\'\"><label>Service Start Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.ServiceStartDate\" ng-required=\"vm.OrderType==\'Contract\'\" \nmd-date-format=\"dd/MM/y\" ng-disabled=\"EUpdate\"></md-datepicker></md-input-container><md-input-container id=\"date4\" \nflex style=\"margin-top: 18px\" ng-if=\"vm.OrderType==\'Contract\'\"><label>Service End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ServiceEndDate\" ng-required=\"vm.OrderType==\'Contract\'\" \nmd-min-date=\"vm.ServiceStartDate\" md-date-format=\"dd/MM/y\" ng-disabled=\"EUpdate\"></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><input type=\"number\" placeholder=\"Estimated Man Hours Needed\" \nng-model=\"vm.EstimatedHoursRequired\" required></md-input-container><md-input-container flex \nng-if=\"vm.OrderType==\'Ad-hoc\'\"><label>Occurence</label><md-select ng-model=\"vm.Occurence\" required><md-option \nvalue=\"One-Off\">One-Off</md-option><md-option value=\"2 Trips\">2 Trips</md-option><md-option value=\"Unlimited Trips\">\nUnlimited Trips</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Coverage Area</label><input type=\"text\" \nng-model=\"vm.CoverageArea\"></md-input-container><md-input-container flex><input type=\"text\" \nplaceholder=\"Purchase Order No\" ng-model=\"vm.PurchaseOrderNo\"></md-input-container></div><label \nstyle=\"width:21%;font-weight:bold;color:#7f9593\">Message to Operation</label><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Message\"></text-angular><div><span class=\"h3\" style=\"color:#7f9593\"><b>TREATMENT FREQUENCY :</b></span>\n<md-button id=\"viewedit\" class=\"md-raised md-button md-ink-ripple md-default-theme\" aria-label=\"Custom Icon Button\" \nng-click=\"AddPestType($event)\" style=\"float:right\">Add Frequency</md-button></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin-top:10px\"><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Frequency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Methods</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">No of Job/Frequency</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Total Services Required</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Frequencydatas\"><td>{{$index+1}}</td><td>{{ row.Frequency }}</td>\n<td>{{ row.PestType }}</td><td>\n{{ row.Treatment.replace(\"Service Light Traps\",\"Service Light Traps :- \" + row.ServiceTrap) }}</td><td>\n{{ row.JobsPerFrequency }}</td><td>{{ row.ServicesRequired }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Editpest($event, row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-disabled=\"Frequencydatas.length == 1\" ng-click=\"Deletepest(row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div><div><span class=\"h3\" style=\"color:#7f9593\"><b>PAYMENT FREQUENCY :</b>\n</span><md-button id=\"viewedit\" class=\"md-raised md-button md-ink-ripple md-default-theme\" \naria-label=\"Custom Icon Button\" ng-click=\"AddPayment($event)\" style=\"float:right\">Add Payment Frequency</md-button>\n</div><div class=\"content fullpage-datatable\" layout=\"column\" flex layout-align-gt-xs=\"start\" style=\"margin-top:10px\">\n<table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Date</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Percentage</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Payment Method</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Edit</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PaymentFrequencyData\"><td>{{$index+1}}</td><td>{{ row.Date | date:\'dd/MM/yyyy\' }}</td><td>\n{{ row.Percentage }} %</td><td>{{ row.PaymentMode }}</td><td>{{ row.Remarks }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EditPaymentFrequency($event, row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeletePaymentFrequency($index,row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49%;border:1px solid rgb(224, 224, 224);float:left;height:30%\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments</label></div>\n</div><md-input-container flex style=\"width: 95.9%;margin-left:15px;margin-right:15px\"><input type=\"text\" \nplaceholder=\"Comments\" ng-model=\"vm.SpecialRemarks\" ng-enter=\"AddComment(vm.SpecialRemarks)\"></md-input-container><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y HH:mm:ss\'}}</h3><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49%;border:1px solid rgb(224, 224, 224);float:right;margin-left:20px\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\" \ntranslate=\"CRMLEAD.ATTACHMENTS\">Attachments :</label></div></div><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload Attachments\n</span></md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>\n{{$index+1}}&nbsp;</td><td><a ng-href=\"{{UploadsURL}}{{ row.ModuleID | removeUploadsPath }}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete($event, row._id, row)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || Frequencydatas.length == 0 && EUpdate == false\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"CRMSALESORDER.CANCEL\">Cancel</md-button></div></form>\n</div></div></div></div><style>\n@media only screen and (max-width: 2200px) {\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(4.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1600px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(19.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(3.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n    }\r\n\r\n    @media only screen and (max-width: 1150px) {\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(1.3vw - 20px) !important;\r\n            max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n        }\r\n\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n            color: white !important;\r\n            border-bottom-color: white !important;\r\n            width: calc(2.3vw - 20px) !important;\r\n            max-width: calc(25vw - 54px);\r\n        }\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(21.3vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #date5 md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 30px) !important;\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    /* #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    } */\r\n\r\n    .dtp div.dtp-picker {\r\n        padding: 12px 12px 12px 12px !important;\r\n        overflow: unset !important;\r\n    }\r\n\r\n    .md-inline-form md-radio-group {\r\n        margin: 31px 0 0 9px;\r\n    }\r\n\r\n    .dx-switch-handle:before {\r\n        background-color: #039be5de !important;\r\n    }\r\n\r\n    .ta-scroll-window>.ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\r\n\r\n    /* .dx-switch-on, .dx-switch-off {\r\n    float: left;\r\n    flex-shrink: 0;\r\n    width: 50%;\r\n    padding-right: 16px;\r\n    line-height: 22px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    overflow: hidden;\r\n    -o-text-overflow: ellipsis;\r\n    -ms-text-overflow: ellipsis;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n}\r\n.dx-switch-container {\r\n    overflow: hidden;\r\n    margin: 0 -6px 0 0;\r\n    padding: 0 2px;\r\n    height: 29px;\r\n    border: 1px solid #dee1e3;\r\n    background: #fff;\r\n    -webkit-border-radius: 0px;\r\n    -moz-border-radius: 0px;\r\n    -ms-border-radius: 0px;\r\n    -o-border-radius: 0px;\r\n    border-radius: 7px;\r\n    width: 60px;\r\n}\r\n.dx-switch-handle {\r\n    position: relative;\r\n    float: left;\r\n    flex-basis: 14px;\r\n    flex-shrink: 0;\r\n    width: 14px;\r\n    height: 21px;\r\n    margin-top: 2px;\r\n    -webkit-box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n} */\n</style>");
$templateCache.put("app/main/apps/dashboards/accounts/operations.html","<div id=\"styleacc\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'OPERATIONS.WELCOME BACK\'|translate}}, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" \nng-change=\"Range()\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">\n{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{totaljobs}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL JOBS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL COMPLETED\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{completedjobs}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.DUE\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{totalpayables}}</div>\n<div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL PAYABLES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL PAID\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{totalpaid}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button\n class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.UNDUE\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{totalreceivables}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL RECEIVABLES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL RECEIVED\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{totalreceived}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.FEATURES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{totalassets}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL ASSETS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL DISPOSED\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{totaldiposed}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">\n{{\'OPERATIONS.PAYABLES DETAILS\'|translate}}</div><table class=\"dataTable simple\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.PURCHASE_ORDER\" class=\"column-title\">Purchase Order</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"OPERATIONS.INVOICE_NUMBER\" class=\"column-title\">Invoice No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.INVOICE_DATE\" class=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.AMOUNT\" class=\"column-title\">Amount</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Purchaseinvoicedatas\"><td nowrap=\"nowrap\">{{ row.Purchaseorderdetails[0].POID }}</td><td \nnowrap=\"nowrap\">{{ row.InvoiceNumber }}</td><td>{{ row.Description }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>\n$ {{ row.Amount || 0 |number:2}}</td></tr></tbody></table></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">\n{{\'OPERATIONS.RECEIVABLES DETAILS\'|translate}}</div><table class=\"dataTable simple\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.INVOICE_NUMBER\" class=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.WORKORDER\" class=\"column-title\">WorkOrder</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"OPERATIONS.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"OPERATIONS.INVOICE_DATE\" \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"OPERATIONS.AMOUNT\" class=\"column-title\">Amount</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Salesinvoicedatas\"><td>{{ row.InvoiceNumber }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CompanyName }}</td><td\n nowrap=\"nowrap\">{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td>$ {{ row.Amount || 0 |number:2}}</td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>\n{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">\n{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\">\n<ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon>\n<span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/procurement/dashboard-procurement.html","<div id=\"dashboard-procurement\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'PROCUREMENTDASHBOARD.WELCOME BACK\'|translate}}, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'PROCUREMENTDASHBOARD.PURCHASE_ORDER\'|translate}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'PROCUREMENTDASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{TotalPurchaseorders.length}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'PROCUREMENTDASHBOARD.TOTAL PURCHASE ORDERS\'|translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"PROCUREMENTDASHBOARD.TOTAL SENT TO SUPPLIER\" \nclass=\"h4 secondary-text text-truncate\">Total Sent to Supplier:</span> <span class=\"h4 ml-8\">\n{{TotalPurchaseOrderSenttoSupplier}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h4\">\n{{\'PROCUREMENTDASHBOARD.PURCHASE_ORDER\'|translate}}</div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL NEW REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderNew}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REVIEWED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderReviewed}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL APPROVED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderApproved}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL CLOSED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderClosed}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REJECTED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderRejected}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL CANCELLED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPurchaseOrderCancelled}}</span></div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.UNIFORM_REQUEST\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'PROCUREMENTDASHBOARD.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"light-blue-fg font-size-72 line-height-72\">{{TotalUniformforms.length}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'PROCUREMENTDASHBOARD.TOTAL UNIFORM REQUESTS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'PROCUREMENTDASHBOARD.TOTAL APPROVED REQUESTS\'|translate}}:</span> <span \nclass=\"h4 ml-8\">{{TotalUniformRequestApproved}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.UNIFORM_REQUEST\'|translate}}</div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL NEW REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"light-blue-fg font-size-18 line-height-18\">{{TotalUniformRequestNew}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REVIEWED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"light-blue-fg font-size-18 line-height-18\">{{TotalUniformRequestReviewed}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REJECTED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"light-blue-fg font-size-18 line-height-18\">{{TotalUniformRequestRejected}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL CANCELLED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"light-blue-fg font-size-18 line-height-18\">{{TotalUniformRequestCancelled}}</span></div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.MATERIAL_REQUEST\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'PROCUREMENTDASHBOARD.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"red-fg font-size-72 line-height-72\">{{TotalMaterialforms.length}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'PROCUREMENTDASHBOARD.TOTAL MATERIAL REQUESTS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'PROCUREMENTDASHBOARD.TOTAL APPROVED REQUESTS\'|translate}}:</span> <span \nclass=\"h4 ml-8\">{{TotalMaterialRequestApproved}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.MATERIAL_REQUEST\'|translate}}</div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL NEW REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"red-fg font-size-18 line-height-18\">{{TotalMaterialRequestNew}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REVIEWED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"red-fg font-size-18 line-height-18\">{{TotalMaterialRequestReviewed}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REJECTED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"red-fg font-size-18 line-height-18\">{{TotalMaterialRequestRejected}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL CANCELLED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"red-fg font-size-18 line-height-18\">{{TotalMaterialRequestCancelled}}</span></div></ms-widget-back></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.PURCHASE_REQUEST\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'PROCUREMENTDASHBOARD.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"orange-fg font-size-72 line-height-72\">{{TotalPurchaseforms.length}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'PROCUREMENTDASHBOARD.TOTAL PURCHASE REQUESTS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'PROCUREMENTDASHBOARD.TOTAL APPROVED REQUESTS\'|translate}}:</span> <span \nclass=\"h4 ml-8\">{{TotalPurchaseRequestApproved}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.PURCHASE_REQUEST\'|translate}}</div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL NEW REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPurchaseRequestNew}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REVIEWED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPurchaseRequestReviewed}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL REJECTED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPurchaseRequestRejected}}</span></div><div class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.TOTAL CANCELLED REQUESTS\'|translate}} &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPurchaseRequestCancelled}}</span></div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\n{{\'PROCUREMENTDASHBOARD.STOCK LIST\'|translate}}</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">\n{{Minimumdetaildataslength}} {{\'PROCUREMENTDASHBOARD.MINIMUM LEVEL STOCKS\'|translate}}</span></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"PROCUREMENTDASHBOARD.PRODUCT_CODE\" class=\"column-title\">Product Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"PROCUREMENTDASHBOARD.STORE_NAME\" \nclass=\"column-title\">Store Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PROCUREMENTDASHBOARD.PRODUCT_NAME\" class=\"column-title\">Product Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PROCUREMENTDASHBOARD.PRODUCT_CATEGORY\" \nclass=\"column-title\">Product Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PROCUREMENTDASHBOARD.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"PROCUREMENTDASHBOARD.STOCK QUANTITY\" \nclass=\"column-title\">Stock Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"PROCUREMENTDASHBOARD.MINIMUM QUANTITY\" class=\"column-title\">Minimum Quantity</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Minimumdetaildatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCode }}</td><td>{{ row.StoreName }}</td><td>{{ row.ProductName }}</td><td>{{ row.ProductCategory}}</td>\n<td>{{ row.Description }}</td><td>{{ row.BalanceQuantity }}</td><td>{{ row.ReorderQuantity }}</td></tr></tbody></table>\n</ms-widget-front></ms-widget></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'PROCUREMENTDASHBOARD.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>\n{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">\n{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\">\n<ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>\n{{\'PROCUREMENTDASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'PROCUREMENTDASHBOARD.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon>\n<span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'OPERATIONS.WELCOME BACK\'|translate}}, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'OPERATIONS.FEATURES\'|translate}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\">{{totalassets}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'OPERATIONS.TOTAL ASSETS\'|translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL DISPOSED\'|translate}} :\n</span> <span class=\"h4 ml-8\">{{totaldiposed}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div\n class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.EMPLOYEES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{totalemployees}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL EMPLOYEES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL RESIGNED EMPLOYEES\'|translate}}:</span> <span \nclass=\"h4 ml-8\">{{resignedemployees}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{}}</div></ms-widget-back></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.ENQUIRIES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{totalenquiries}}</div>\n<div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL ENQUIRIES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'OPERATIONS.TOTAL CLOSED\'|translate}}:</span> <span class=\"h4 ml-8\">\n{{totalclosed}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'OPERATIONS.ORDERS\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{totalorders}}</div>\n<div class=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL ORDERS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Total Ad-hoc:</span> <span class=\"h4 ml-8\">{{totalAdhoc}}</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{\'OPERATIONS.SALES\'|translate}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" \nng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div>\n<div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\">\n<nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></div></ms-widget-front><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{\'OPERATIONS.EXPENSES\'|translate}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget6.ranges\" \nng-click=\"vm.widget6.changeRange(key)\" ng-disabled=\"vm.widget6.currentRange == key\">{{range}}</md-button></div></div>\n<div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"100\">\n<nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div></div></ms-widget-front></ms-widget></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div \nclass=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>\n{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">\n{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\">\n<ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>\n{{\'OPERATIONS.SETTINGS\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon>\n<span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/operations/operations.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'OPERATIONS.WELCOME BACK\'|translate}}, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'OPERATIONS.SCHEDULE JOBS\'|translate}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{NotCompletedlength}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL JOBS\'|translate}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'OPERATIONS.COMPLETED JOBS\'|translate}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{Completedlength}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL COMPLETED JOBS\'|translate}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{\'OPERATIONS.TEAMS\'|translate}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{Teamdatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL TEAMS\'|translate}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{\'OPERATIONS.TECHNICIANS\'|translate}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\n{{\'OPERATIONS.DETAILS\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">{{\'OPERATIONS.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{TeamMemberlength}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'OPERATIONS.TOTAL TECHNICIANS\'|translate}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\"><div class=\"white-bg md-whiteframe-4dp\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex style=\"height: 62px\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"OPERATIONS.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"vm.uscFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nid=\"Datefilter\"><label translate=\"OPERATIONS.TO\" style=\"color:green;font-size: 14px\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"vm.uscTo\"></md-datepicker></md-input-container><md-button \nid=\"viewedit\" class=\"md-raised md-background\" style=\"height: 60%;margin-top: 1.5%; margin-left: 2%\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><span translate=\"OPERATIONS.SEARCH\">Search</span></md-button>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"OPERATIONS.SERVICE_ID\" class=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"OPERATIONS.WORK_ORDER_#\" class=\"column-title\">Work Order #</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"OPERATIONS.CONTRACT_#\" class=\"column-title\">Contract #</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"OPERATIONS.TEAMS\" class=\"column-title\">Team</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"OPERATIONS.SCHEDULE_DATE\" class=\"column-title\">Schedule Date</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"OPERATIONS.START_TIME\" class=\"column-title\">Start Time</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"OPERATIONS.END_TIME\" class=\"column-title\">End Time</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"OPERATIONS.ACTUAL START TIME\" class=\"column-title\">\nActual Start Time</span></div></th><th class=\"secondary-text\"><div><span translate=\"OPERATIONS.ACTUAL END TIME\" \nclass=\"column-title\">Actual End Time</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"OPERATIONS.STARTED LATE\" class=\"column-title\">Started Late (hh:mm)</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"OPERATIONS.COMPLETED EARLIER\" class=\"column-title\">\nCompleted Earlier (hh:mm)</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Tabletschedule\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a style=\"cursor:pointer\">{{row.ServiceId }}</a></td><td>\n{{row.WorkorderNo}}</td><td>{{row.ContractOrderNo}}</td><td>{{row.Team }}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}\n</td><td>{{row.Startsat | date:\'hh:mm a\'}}</td><td>{{row.Endsat | date:\'hh:mm a\'}}</td><td>\n{{row.ActualStartsat | date:\'hh:mm a\'}}</td><td>{{row.ActualEndsat | date:\'hh:mm a\'}}</td><td>\n{{Late(row.Startsat, row.ActualStartsat)}}</td><td>{{Earlier(row.Endsat, row.ActualEndsat)}}</td></tr></tbody></table>\n</div></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div>\n<md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" \ndata=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget9.title}}</div><md-divider>\n</md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget9.mainChart.options\" \ndata=\"vm.widget9.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><nvd3 \noptions=\"options\" data=\"data\"></nvd3></ms-widget-front></ms-widget></div></div></div></div><style>\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    .dataTables_filter{\r\n        display:none!important;\r\n    }\r\n        #Datefilter md-datepicker .md-datepicker-input {\r\n        width:1%;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: forestgreen !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: forestgreen !important;\r\n        border-bottom-color: forestgreen !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'DASHBOARD.WELCOME BACK\'|translate}}, {{UserName}}!</span></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"General\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.EMPLOYEES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"green-fg font-size-72 line-height-72\">{{Employeedatas}}</div>\n<div class=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL EMPLOYEES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.TOTAL RESIGNED EMPLOYEES\'|translate}}:</span> <span \nclass=\"red-fg h4 ml-8\">{{EmployeeResineddatas}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.LEAVES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{Leavedatas.length}}</div><div class=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL LEAVES\'|translate}}</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.APPROVED\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{LeaveApprovedLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.RECRUITMENT\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{Recruitmentjobapplicationdatas.length}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'DASHBOARD.TOTAL RECRUITMENT\'|translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.APPROVED\'|translate}} :</span> \n<span class=\"h4 ml-8\">{{RecApprovedLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.CALENDAR\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{HolidayLength}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL HOLIDAYS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.TOTAL EVENTS\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{EventLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"h3 p-16\">{{vm.widget9.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget9.mainChart.options\" data=\"vm.widget9.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">{{\'DASHBOARD.ATTENDANCE\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3>\n</div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div \nclass=\"h4 secondary-text\">{{widget.data.label}}</div><div class=\"md-display-1\">\n{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" config=\"vm.widget5.supporting.chart.config\" \noptions=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label=\"Expiry Alerts\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nNRIC/FIN {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget10.mainChart.config\" \noptions=\"vm.widget10.mainChart.options\" data=\"vm.widget10.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget10.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget10.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget10.supporting.chart.config\" options=\"vm.widget10.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPassport {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget11.mainChart.config\" \noptions=\"vm.widget11.mainChart.options\" data=\"vm.widget11.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget11.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget11.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget11.supporting.chart.config\" options=\"vm.widget11.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPass {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div\n class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget12.mainChart.config\" \noptions=\"vm.widget12.mainChart.options\" data=\"vm.widget12.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget12.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget12.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget12.supporting.chart.config\" options=\"vm.widget12.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/apps/operations/areas-master/areas.html","<div id=\"areas\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon icon-bug\"></md-icon><span translate=\"OPERATIONSAREAMASTER.HEADER\">Affected Area</span>\n</div><div class=\"product-count secondary-text\"><span translate=\"OPERATIONSAREAMASTER.TOTAL_AREAS:\">Total Areas: \n</span><span>{{areasdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSAREAMASTER.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span translate=\"OPERATIONSAREAMASTER.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"OPERATIONSAREAMASTER.EXPORT\">Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"OPERATIONSAREAMASTER.BACK\">Back</span></md-button></div></div><div class=\"content-card\" ng-show=\"areasGrid\">\n<div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"areasdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"OPERATIONSAREAMASTER.AFFECTED_AREA\">Affected Area</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"OPERATIONSAREAMASTER.AREA_CODE\">Area Code</span></div></th>\n<th class=\"secondary-text\"><div><span translate=\"OPERATIONSAREAMASTER.CREATED BY\" class=\"column-title\">Created By\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"OPERATIONSAREAMASTER.CREATED DATE\" \nclass=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"OPERATIONSAREAMASTER.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in areasdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.AreasName }}</td><td>\n{{ row.Areascode }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreateDate | date:\"dd/MM/y hh:mm a\" }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"areainfo(row.id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"areasform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" ng-model=\"Areasname\" \nplaceholder=\"{{ \'OPERATIONSAREAMASTER.AFFECTED_AREAS\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"OPERATIONSAREAMASTER.AREAS_IS_REQUIRED\">Areas is required.</span></div></div><p \nng-show=\"error1\" style=\"color:red\" translate=\"OPERATIONSAREAMASTER.AFFECTED_AREAS_IS_ALREADY_EXIST.\">\nAffected Areas Is already Exist.</p></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"remarks\" ng-model=\"Areascode\" \nplaceholder=\"{{ \'OPERATIONSAREAMASTER.AREAS_CODE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"OPERATIONSAREAMASTER.AFFECTED_AREAS_CODE_IS_REQUIRED\">Code is required.</span>\n</div></div></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" \nng-click=\"fsubmit();\" ng-disabled=\"basicForm.$invalid\" translate=\"OPERATIONSAREAMASTER.SUBMIT\">Submit</md-button>\n<md-button ng-click=\"cancelbtnclk()\" class=\"md-raised\" translate=\"OPERATIONSAREAMASTER.CANCEL\">Cancel</md-button></div>\n</form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/checklist/checklist.html","<div id=\"checklist\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-image-filter-none\"></md-icon><span>Service-Checklist</span>\n</div><div class=\"product-count secondary-text\"><span translate=\"OPERATIONSCHECKLIST.TOTAL_CHECKLIST:\">\nTotal Checklist: </span><span>{{ServiceChecklist.length}}</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSCHECKLIST.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"OPERATIONSCHECKLIST.EXPORT\">Export</span></md-button></div></div>\n<div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate style=\"padding-top:2%\"><div layout=\"row\" layout-gt-xs=\"row\" flex style=\"padding-left:1%\"><md-input-container\n flex><label translate=\"OPERATIONSCHECKLIST.DIVISION_NAME\">Division Name</label><md-select ng-model=\"Division\" \nid=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchDivision\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSCHECKLIST.SEARCH_FOR_A_DIVISION\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Divisiondatas | filter:vm.searchDivisionsearchCC\" value=\"{{row.id}}\">\n{{row.DivisionName}}</md-option></md-select></md-input-container><md-input-container flex style=\"flex: 45%\"><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" \nplaceholder=\"{{ \'OPERATIONSCHECKLIST.DESCRIPTION\' | translate }}\"></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" \nstyle=\"height:1%;margin-top:1%\" ng-click=\"fsubmit();\" ng-disabled=\"basicForm.$invalid\" \ntranslate=\"OPERATIONSCHECKLIST.SAVE\">Save</md-button></div></form><md-progress-linear ng-hide=\"ServiceChecklist\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSCHECKLIST.DIVISION_NAME\">Division Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"OPERATIONSCHECKLIST.DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"OPERATIONSCHECKLIST.CREATED_BY\">Created By</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"OPERATIONSCHECKLIST.CREATED_DATE\">Created Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSCHECKLIST.VIEW/EDIT\">View/Edit</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSCHECKLIST.DELETE\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in ServiceChecklist\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.DivisionName }}</td><td>{{ row.Description }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreateDate | date:\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"Checklistinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"Delete(row.id)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/dashboard/Popup.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Technicians with 1 Star Rating</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container flex=\"3\" style=\"margin: 0\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.StDate\"></md-datepicker></md-input-container><md-input-container flex=\"3\" \nstyle=\"margin: 0\"><label>To</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EnDate\"></md-datepicker>\n</md-input-container><md-button id=\"viewedit\" style=\"margin-top: -2%\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"getCustomer1StarRating()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button><div layout=\"row\"><div id=\"sales\" dx-data-grid=\"dataGridOptions\"></div></div></md-dialog-content></form>\n</md-dialog><style>\n.md-input-container {\r\n        margin: 0;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        left: 12px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/dashboard/operations.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"><span \ntranslate=\"CRMDASHBOARD.WELCOME_BACK\">Welcome back</span>, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-click=\"goSchedulerPage(1)\" title=\"View Scheduler\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Yet To Start Jobs</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{YetToStartJobs}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Job(s)</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-click=\"goSchedulerPage(4)\" \ntitle=\"View Scheduler\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Outstanding Jobs</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-green-fg font-size-72 line-height-72\">\n{{OutstandingJobs}}</div><div class=\"h3 secondary-text font-weight-500\">Total Job(s)</div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-click=\"goSchedulerPage(6)\" title=\"View Scheduler\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Pending Approval</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72\">{{totalServiceReportPendingApproval}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Total Pending(s)</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-click=\"goSchedulerPage(0)\" \ntitle=\"View Scheduler\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Pending Schedule</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{totalUncompletedJobs}}</div><div class=\"h3 secondary-text font-weight-500\"><span>Total Job(s)</span></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h2\">EFFECIENCY OF TECHNICIANS</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-select class=\"simplified\" \nng-model=\"SelectedMember\" \nng-change=\"getEfficiencyofEmployees(SelectedMember,thisEmonth) ; CalculatteWorkingHours(SelectedMember,thisNEmonth)\" \naria-label=\"Change range\"><md-option ng-repeat=\"row in TechnicMebers\" value=\"{{row}}\">{{row}}</md-option></md-select>\n</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\"></div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\" \nstyle=\"margin-top: -60px\"><md-select class=\"simplified\" ng-model=\"thisEmonth\" \nng-change=\"getEfficiencyofEmployees(SelectedMember,thisEmonth)\" aria-label=\"Change range\"><md-option \nng-repeat=\"row in MonthEfficiancy\" value=\"{{row.value}}\">{{row.name}}</md-option></md-select></div><md-divider>\n</md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget1.mainChart.options\" \ndata=\"vm.widget1.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\"></div><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\" style=\"margin-top: -60px\"><md-select \nclass=\"simplified\" ng-model=\"thisNEmonth\" ng-change=\"CalculatteWorkingHours(SelectedMember,thisNEmonth)\" \naria-label=\"Change range\"><md-option ng-repeat=\"row in NMonthEfficiancy\" value=\"{{row.value}}\">{{row.name}}</md-option>\n</md-select></div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget2.mainChart.options\" data=\"vm.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div></div></ms-widget-front></ms-widget></div><div style=\"width:100% !important\" class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget style=\"width:90% !important\" layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h2\">TECHNICIANS WORKING ANALYSIS</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" \nlayout-align-sm=\"end\" flex-sm=\"100\"><md-select class=\"simplified\" ng-model=\"thismonth\" \nng-change=\"CalculateWorkingHours(thismonth)\" aria-label=\"Change range\"><md-option ng-repeat=\"row in WorkingMonth\" \nvalue=\"{{row.value}}\">{{row.name}}</md-option></md-select></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div style=\"width:90% !important\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><div \nstyle=\"width:90% !important;height: 70%!important\" id=\"chart\" dx-chart=\"chartOptions\"></div></div></div>\n</ms-widget-front></ms-widget></div></div></div></div><style>\n.color-red {\r\n    color: red;\r\n  }\r\n\r\n  .md-green-500-bg {\r\n    background-color: #4abead !important;\r\n    color: white;\r\n  }\r\n\r\n  #viewsor:hover {\r\n    color: rgb(3, 155, 229) !important;\r\n    font-style: italic;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  #viewsor {\r\n    color: rgb(181, 219, 238) !important;\r\n    font-style: italic;\r\n    font-size: 14px\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/divisions/divisions.html","<div id=\"division\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-image-filter-none\"></md-icon><span \ntranslate=\"OPERATIONSDIVISIONS.HEADER\">Divisions</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"OPERATIONSDIVISIONS.TOTAL_DIVISIONS:\">Total Divisions: </span><span>{{Divisiondatas.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'OPERATIONSDIVISIONS.SEARCH\' | translate }}\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"OPERATIONSDIVISIONS.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"OPERATIONSDIVISIONS.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"OPERATIONSDIVISIONS.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"DivisionGrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Divisiondatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSDIVISIONS.DIVISION_NAME\">Name</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSDIVISIONS.DESCRIPTION\">Description\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"OPERATIONSDIVISIONS.CREATED_BY\" \nclass=\"column-title\">Created By</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"OPERATIONSDIVISIONS.CREATED_DATE\" class=\"column-title\">Created Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSDIVISIONS.VIEW/EDIT\">View/Edit</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"row in Divisiondatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.DivisionName }}</td><td>{{ row.Description }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreateDate | date:\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"Divisioninfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Divisionform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"DivisionName\" ng-model=\"DivisionName\" \nplaceholder=\"{{ \'OPERATIONSDIVISIONS.DIVISION\' | translate }}\" required><div \nng-messages=\"basicForm.DivisionName.$error\" ng-show=\"basicForm.DivisionName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"OPERATIONSDIVISIONS.DIVISIONNAME_IS_REQUIRED\">Name is required.</span></div>\n</div><p ng-show=\"error1\" style=\"color:red\" translate=\"OPERATIONSDIVISIONS.DIVISIONNAME_IS_ALREADY_EXIST.\">\nName Is already Exist.</p></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"remarks\" ng-model=\"Description\" \nplaceholder=\"{{ \'OPERATIONSDIVISIONS.DESCRIPTION\' | translate }}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"OPERATIONSDIVISIONS.SUBMIT\">Submit</md-button><md-button \nng-click=\"cancelbtnclk()\" class=\"md-raised\" translate=\"OPERATIONSDIVISIONS.CANCEL\">Cancel</md-button></div></form>\n</div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/emailalert/emailalert.html","<div id=\"emailalert\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-message-alert\"></md-icon><span>Email Alerts</span></div><div \nclass=\"product-count secondary-text\"><span>Total Alerts: </span><span>{{EmailAlertdatas.length}}</span></div></div><div\n class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search here...\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"View\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"EmailAlertgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"EmailAlertdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table id=\"forms-dtDetails\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Alert Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Trigger After (Minutes)</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Notes</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Recipients</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EmailAlertdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a ng-click=\"EmailAlertinfo(row.id, $index)\" style=\"cursor:pointer\">\n{{ row.AlertType }}</a></td><td>{{ row.Scenario || 0 }}</td><td>{{row.Notes}}</td><td>{{row.Recipients}}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EmailAlertinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"EmailAlertform\" flex><form name=\"basicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Alert Type</label><md-select ng-model=\"AlertType\" ng-change=\"AlertTypeChanged()\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Alert Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button\n class=\"md-icon-button\" ng-click=\"AlertType=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option \nng-repeat=\"row in AlertTypeList | filter:vm.searchTerm1\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-optgroup>\n</md-select><p ng-show=\"error1\" style=\"color:red\">Alert Type Is already Exist.</p></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Scenario\" ng-model=\"Scenario\" \nplaceholder=\"Trigger After (Minutes)\" required><div ng-messages=\"basicForm.Scenario.$error\" \nng-show=\"basicForm.Scenario.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Scenario is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"Notes\" ng-model=\"Notes\" \nplaceholder=\"Notes\"><div ng-messages=\"basicForm.Notes.$error\" ng-show=\"basicForm.Notes.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Notes is required.</span></div></div></md-input-container></div><div \nng-show=\"ShowRecipients == true\"><span class=\"h4\" style=\"color:#7f9593\"><b>Recipients :</b></span><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-chips ng-model=\"Recipients\" placeholder=\"Email\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"></md-chips></div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-show=\"ShowRecipients == false\"><md-input-container flex><input type=\"text\" name=\"Recipients\" \nng-model=\"RecipientsLabel\" placeholder=\"Recipients\" readonly=\"readonly\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"eSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div><div ng-show=\"Update === true\"><br><div><span class=\"h3\" style=\"color:#7f9593\"><b>\nEmail Log History</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: -35px\"><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"LastMonth()\"><span>Last Month</span></md-button><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"LastWeek()\"><span>Last Week</span></md-button><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span>Today</span></md-button><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">From</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container>\n<md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"DatefilterOverallLogHistory()\"><span>Search</span></md-button></div></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.Spinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Emai Sent</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent To</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in EmailLogHistory\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.RefrenceNumber }}</td><td>{{ row.EmaiSent }}</td><td>{{ row.EmailSentTo }}</td><td>\n{{ row.EmailSentDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div></form></div></div></div></div>\n</div><style>\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n  \r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 1%;\r\n  }\r\n\r\n  .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n    border-top-color: forestgreen !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: forestgreen !important;\r\n    border-bottom-color: forestgreen !important;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  button#button {\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(27.2vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0,0,0,0.87);\r\n    background: none;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/feedback/feedback.html","<div id=\"feedback\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span translate=\"FEEDBACK.FEEDBACK\">\nFeedback</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: -10px\" flex>\n<input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'FEEDBACK.SEARCH\'|translate}}..\" flex></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: 18px\" flex><md-input-container flex=\"50\" \nid=\"Storefilter\" style=\"margin-top:3px\"><label translate=\"FEEDBACK.CUSTOMER_NAME\" style=\"color:white;font-size: 14px\">\nCustomer Name</label><md-select class=\"Storefilter\" ng-model=\"CustomerName\" md-on-close=\"vm.searchTermC = \'\'\">\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'FEEDBACK.SEARCH_FOR_A_CUSTOMER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"CustomerName = null;vm.searchTerm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.CompanyName}}</md-option></md-select>\n</md-input-container></div><div class=\"search\" layout=\"row\" style=\"margin-top:30px\" layout-align=\"start center\" flex>\n<md-input-container flex=\"40\" id=\"Datefilter\"><label translate=\"FEEDBACK.FROM\" style=\"color:white;font-size: 14px\">From\n</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label translate=\"FEEDBACK.TO\" \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"FEEDBACK.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Feedbackdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"FEEDBACK.STATUS\" class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"FEEDBACK.REFERENCE_NO\" class=\"column-title\">Reference No.</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"FEEDBACK.CUSTOMER_NAME\" class=\"column-title\">Customer Name</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"FEEDBACK.DATE OF SERVICE\" class=\"column-title\">\nDate of Service</span></div></th><th class=\"secondary-text\"><div><span translate=\"FEEDBACK.WORK_ORDER_#\" \nclass=\"column-title\">Work Order No.</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"FEEDBACK.CONTRACT_#\" class=\"column-title\">Contract No.</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"FEEDBACK.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No.</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"FEEDBACK.PEST_TYPE\" class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"FEEDBACK.FEEDBACK\" class=\"column-title\">Feedback</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"FEEDBACK.COMMENT\" class=\"column-title\">Comment</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Feedbackdatas| filter:CustomerName\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.Status }}</td><td><a href=\"\" ng-click=\"UpdateStatus($event,row._id)\" title=\"Close Feedback Status\" \nstyle=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.Customerdetails[0].CompanyName }}</td><td>\n{{ row.DateofService | date:\'dd/MM/y\' }}</td><td>{{ row.WorkOrder }}</td><td>{{ row.Contract }}</td><td>\n{{ row.ServiceNo }}</td><td>{{ row.PestType }}</td><td>{{ row.Feedback }}</td><td>{{ row.Comment }}</td></tr></tbody>\n</table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n     #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(27.2vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/feedback/updatefeedbackstatus.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"FEEDBACK.CLOSE THIS FEEDBACK\" class=\"title\">Close this {{ReferenceNo}} Feedback</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-bottom:-20px\" flex><md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comment\" \nplaceholder=\"{{\'FEEDBACK.COMMENT\'|translate}}\" required></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveCloseStatus()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'FEEDBACK.CLOSE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'FEEDBACK.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/dashboards/sales/sales.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"><span \ntranslate=\"CRMDASHBOARD.WELCOME_BACK\">Welcome back</span>, {{UserName}}!</span></div><div class=\"toolbar\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"General\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"CRMDASHBOARD.ENQUIRIES\">Enquiries</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span translate=\"CRMDASHBOARD.DETAILS\">\nDetails</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\"><span translate=\"CRMDASHBOARD.REFRESH\">Refresh</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{Leaddatas}}</div><div class=\"h3 secondary-text font-weight-500\" \ntranslate=\"CRMDASHBOARD.TOTAL_ENQUIRIES\">Total Enquiries</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\">sfsdfsdfsdfsdff sdfsdf<md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\" translate=\"CRMDASHBOARD.WORK_ORDERS\">\n{{\'CRMDASHBOARD.WORK_ORDERS\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span translate=\"CRMDASHBOARD.DETAILS\">\nDetails</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\"><span translate=\"CRMDASHBOARD.REFRESH\">Refresh</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{salesOrderdatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'CRMDASHBOARD.TOTAL_WORK_ORDERS\'|translate}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"CRMDASHBOARD.CONTRACTS\">Contracts</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span translate=\"CRMDASHBOARD.DETAILS\">Details</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\"><span \ntranslate=\"CRMDASHBOARD.REFRESH\">Refresh</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{Contractdatas}}</div><div class=\"h3 secondary-text font-weight-500\"><span translate=\"CRMDASHBOARD.TOTAL_CONTRACTS\">\nTotal Contracts</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Ad-hoc</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><span translate=\"CRMDASHBOARD.DETAILS\">Details</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\"><span \ntranslate=\"CRMDASHBOARD.REFRESH\">Refresh</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg font-size-72 line-height-72\">\n{{Adhoclength}}</div><div class=\"h3 secondary-text font-weight-500\" translate=\"CRMDASHBOARD.TOTAL_AD_HOC_JOBS\">\nTotal Ad-hoc Jobs</div></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget></div><ms-widget \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"white-bg md-whiteframe-4dp\" flex>\n<md-progress-linear ng-hide=\"Contractsitem\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMDASHBOARD.CONTRACT\">Contract #</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMDASHBOARD.WORK\">Work #</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMDASHBOARD.START_DATE\">Start Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMDASHBOARD.END_DATE\">End Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMDASHBOARD.DURATION\">Duration</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMDASHBOARD.EXPIRES_IN_DAYS\">Expires In (Days)</span></div></th></tr></thead>\n<tbody><tr ng-class=\"{ \'color-red\': Totla(row.ContractEndDate) < 30  || Totla(row.ContractEndDate) == \'Expiried\'}\" \nng-repeat=\"row in Contractsitem\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ContractReferenceNo }}\n</td><td>{{ row.workorderdetails[0].SalesOrderNo }}</td><td>{{ row.ContractStartDate | date:\'dd/MM/y\'}}</td><td>\n{{ row.ContractEndDate | date:\'dd/MM/y\'}}</td><td>{{ row.ContractDuration }}</td><td>{{ Totla(row.ContractEndDate)}}\n</td></tr></tbody></table></div></ms-widget><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}\n</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" \ndata=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget9.title}}</div><md-divider>\n</md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget9.mainChart.options\" \ndata=\"vm.widget9.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget10.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 \nclass=\"h-400\" options=\"vm.widget10.mainChart.options\" data=\"vm.widget10.mainChart.data\"></nvd3></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\">{{vm.widget11.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget11.mainChart.options\" data=\"vm.widget11.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\" translate=\"CRMDASHBOARD.ENQUIRIES\">Enquiries</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3>\n</div></div></ms-widget-front></ms-widget></div></md-tab><div ng-repeat=\"rows in Contractgroups\"><md-tab \nlabel=\"{{rows[0].Status}}\"><div class=\"white-bg md-whiteframe-4dp\"><table class=\"table dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMDASHBOARD.CONTRACT_ORDER\">\nContract Order #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMDASHBOARD.WORK\">Work #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMDASHBOARD.CUSTOMER_NAME\">Customer Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMDASHBOARD.SALES_PERSON\">Sales Person</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMDASHBOARD.PEST_TYPES\">Pest Types</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMDASHBOARD.CONTRACT_START_DATE\">Contract Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMDASHBOARD.CONTRACT_END_DATE\">Contract End Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMDASHBOARD.CONTRACT_DURATION\">Contract Duration</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMDASHBOARD.CONTRACT_STATUS\">Contract Status</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in rows\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"contractinfo(row._id)\" style=\"cursor:pointer\">{{ row.ContractReferenceNo }}</a></td><td>\n{{ row.workorderdetails[0].SalesOrderNo }}</td><td>{{ row.customerdetails[0].CompanyName }}</td><td>\n{{ row.employeedetails[0].EmployeeName }}</td><td>{{ row.PestType }}</td><td>{{ row.ServiceStartDate | date:\'dd/MM/y\'}}\n</td><td>{{ row.ServiceEndDate | date:\'dd/MM/y\'}}</td><td>{{ row.Frequency }}</td><td>{{ row.ContractStatus }}</td>\n</tr></tbody></table></div></md-tab></div></md-tabs></div></div></div><style>.color-red {\r\n        color: red;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/Editemobilelog.html","<md-dialog style=\"width:90%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Mobile Logs</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 2% 0% 2%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>DETAILS\n</span></md-tab-label><md-tab-body><br><span class=\"h4\" style=\"color:#7f9593\"><b>Team Members :</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.TeamName\" \nplaceholder=\"Team Name\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.TeamMembers\" placeholder=\"Team Members\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.TeamRemarks\" \nplaceholder=\"Remarks\"></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\"><b>Customer Review :</b></span>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.CompanyName\" \nplaceholder=\"Name\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"email\" \nng-model=\"vm.MobilEmailId\" placeholder=\"Email ID\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.CustomerRemarks\" \nplaceholder=\"Remarks\" readonly=\"readonly\"></md-input-container></div><div><div class=\"alert alert-success\"><div \nstyle=\"height: 40px\" star-rating rating=\"vm.starRating1\" read-only=\"true\" max-rating=\"5\" click=\"click1(param)\"></div>\n<div><span class=\"label label-primary\">Rating: {{vm.starRating1}}</span></div></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Services</span></md-tab-label><md-tab-body><br><md-input-container style=\"width:100%\" flex>\n<md-radio-group ng-model=\"vm.SMPestType\"><div ng-repeat=\"row in Pestdatas\"><md-radio-button ng-model=\"vm.ImgBPestType\" \nng-value=\"row.PestName\" ng-click=\"vm.ImgBPestType = row.PestName;\" flex style=\"float:left\">{{row.PestName}}&emsp;\n</md-radio-button></div></md-radio-group></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Services</label><md-select ng-model=\"vm.MServicetype\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.Servicetype\'}\" md-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header>\n<input ng-model=\"vm.searchTermC\" type=\"text\" placeholder=\"Search For a Services..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.MServicetype = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Servicesdatas | filter:vm.searchTermC\" ng-value=\"row\">{{row.Servicetype}}</md-option></md-select>\n</md-input-container></div><br><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.SMPestType || !vm.MServicetype\" ng-click=\"AddServiceMaterials()\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"vm.SMPestType=null;vm.MServicetype=null;vm.SMUpdate = false;\">Cancel</md-button>\n</div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"tb2\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Services</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Tabletlighttracklistdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.Services }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ServiceMaterialinfo(row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Materials</span></md-tab-label><md-tab-body><br><md-input-container style=\"width:100%\" \nflex><md-radio-group ng-model=\"vm.MLSMPestType\"><div ng-repeat=\"row in Pestdatas\"><md-radio-button \nng-model=\"vm.ImgBPestType\" ng-value=\"row.PestName\" ng-click=\"vm.ImgBPestType = row.PestName;\" flex style=\"float:left\">\n{{row.PestName}}&emsp;</md-radio-button></div></md-radio-group></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Materials</label><md-select ng-model=\"vm.MMaterialsName\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchM\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Materials..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.MMaterialsName=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Materialsdatas | filter:vm.searchM\" value=\"{{row.MaterialsName}}\">{{row.MaterialsName}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.MQuantity\" \nplaceholder=\"Quantity\"></md-input-container><md-input-container flex><label>Units</label><md-select \nng-model=\"vm.MUnit\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchU\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Units..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.MUnit=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Unitdatas | filter:vm.searchU\" value=\"{{row.UnitName}}\">{{row.UnitName}}</md-option></md-select>\n</md-input-container></div><br><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.MLSMPestType || !vm.MMaterialsName\" ng-click=\"AddMobileLogMaterials()\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" \nng-click=\"vm.MLSType=null;vm.MMaterialsName=null;vm.MQuantity=null;vm.MUnit=null;vm.SMLMUpdate = false;\">Cancel\n</md-button></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table\n id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Materials</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Quantity\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in TabletMaterialslistdatas\"><td>&nbsp;</td><td>{{ row.PestType }}</td><td>{{ row.MaterialName }}</td>\n<td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"MobileLogMaterialinfo(row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Payment</span></md-tab-label><md-tab-body><span class=\"h4\" style=\"color:#7f9593\"><b>\nPayment Details :</b></span><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:18%\"><md-input-container flex><label>\nPayment Mode</label><md-select ng-model=\"vm.Paymentmethod\" name=\"PaymentTerms\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP = \'\'\"><md-select-header><input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Payment Mode..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Paymentmethod = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Totalpayment\" \nplaceholder=\"Total Payment\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.PaymentNotes\" placeholder=\"Payment Notes/Cheque No\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:18%\"><md-input-container flex><input type=\"text\" ng-model=\"vm.PaymentRemarks\" \nplaceholder=\"Payment Remarks\"></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\"><b>Area Details :</b>\n</span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.Totalarea\" \nplaceholder=\"Total Area Planned (Sq.Mt)\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.Totalcompleted\" placeholder=\"Total Area Completed (Sq.Mt)\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"0.5\" style=\"padding-top: 0.4%\"><span>\nBreeding Found? :</span></md-input-container><md-input-container flex style=\"padding-left:1%;padding-right:2%\">\n<md-radio-group ng-model=\"vm.BreedingFound\" layout=\"row\" style=\"margin:0\"><md-radio-button value=\"Yes\">Yes\n</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex=\"0.5\" style=\"padding-top: 0.4%\" ng-if=\"vm.BreedingFound == \'Yes\'\"><span>Species? :</span>\n</md-input-container><md-input-container flex style=\"padding-left:1%;padding-right:2%\" \nng-if=\"vm.BreedingFound == \'Yes\'\"><md-radio-group ng-model=\"vm.Species\" layout=\"row\" style=\"margin:0\"><md-radio-button \nvalue=\"AEDES\">AEDES</md-radio-button><md-radio-button value=\"CULEX\">CULEX</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex=\"0.5\" style=\"padding-top: 0.4%\" ng-if=\"vm.BreedingFound == \'Yes\'\"><span>\nFindings? :</span></md-input-container><md-input-container flex style=\"padding-left:1%;padding-right:2%\" \nng-if=\"vm.BreedingFound == \'Yes\'\"><md-radio-group ng-model=\"vm.Findings\" layout=\"row\" style=\"margin:0\"><md-radio-button\n value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex ng-if=\"vm.BreedingFound == \'Yes\'\">\n<md-input-container style=\"padding-top: 0.4%\"><span>Misting Carried Out? :</span></md-input-container>\n<md-input-container style=\"padding-left:1%;padding-right:2%;flex :0.63\"><md-radio-group ng-model=\"vm.MistingCariedOut\" \nlayout=\"row\" style=\"margin:0\"><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No\n</md-radio-button></md-radio-group></md-input-container><md-input-container flex ng-if=\"vm.BreedingFound == \'Yes\'\">\n<input type=\"number\" ng-model=\"vm.Density\" placeholder=\"Density...\"><p ng-if=\"vm.Density > 999\" \nstyle=\"color:red;font-size:13px\">Density should be less than 999.</p></md-input-container><md-input-container flex \nng-if=\"vm.BreedingFound == \'Yes\'\"><label>Instar</label><md-select ng-model=\"vm.Instar\" id=\"searchmodule\">\n<md-select-header><span ng-model=\"vm.searchV\" style=\"flex: auto\" type=\"text\" placeholder=\"Instar..\" \nng-keydown=\"$event.stopPropagation()\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.Vehicle = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"Pupa\">Pupa\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nng-if=\"vm.BreedingFound == \'No\'\"><input type=\"text\" ng-model=\"vm.Reason\" placeholder=\"Reason...\"></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"EditmobileSubmit()\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\">Cancel</md-button></div><br></md-tab-body></md-tab><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" style=\"padding:1% 43% 1% 0;float:right\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"EditmobileSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n.md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 45px;\r\n  }\r\n\r\n  .md-datepicker .md-datepicker-input {\r\n    width: calc(35vw - 23px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n    color: black !important;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    width: calc(100% - 56px);\r\n  }\r\n\r\n  .md-default-theme .md-datepicker-input-mask-opaque,\r\n  .md-datepicker-input-mask-opaque {\r\n    left: 0px !important;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  .md-datepicker-input-container {\r\n    width: 133%;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-left: -8px;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n  }\r\n\r\n    #tb2 td:first-child:before {\r\n      counter-increment: serial-number; /* Increment the serial number counter */\r\n      content: counter(serial-number); /* Display the counter */\r\n    }\r\n\r\n  .md-button.md-fab {\r\n    z-index: 20;\r\n    line-height: 56px;\r\n    min-width: 0;\r\n    width: 56px;\r\n    height: 56px;\r\n    vertical-align: middle;\r\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\r\n    border-radius: 0%;\r\n    background-clip: padding-box;\r\n    overflow: hidden;\r\n    -webkit-transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n    -webkit-transition-property: background-color, box-shadow, -webkit-transform;\r\n    transition-property: background-color, box-shadow, -webkit-transform;\r\n    transition-property: background-color, box-shadow, transform;\r\n    transition-property: background-color, box-shadow, transform, -webkit-transform;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n    \r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/EmailConfirmation.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Email Confirmation</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 1% 1% 1%\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"padding:1%\"><span><strong>\nDo you wish to Send Email to these Email Adresses ?</strong></span></div><div id=\"EmailGrid\" \ndx-data-grid=\"vm.EmailDataGrid\"></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SendEmail()\" \naria-label=\"Submit\">Yes</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">No</md-button></div>\n</md-dialog-content></form></md-dialog><style>\nmd-dialog {\r\n        max-width: 90%;\r\n    max-height: 90%;\r\n    width: 90%;\r\n    height: 90%;\r\n    border-radius: 0;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/NewAdd.html","<md-dialog style=\"width:85%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.DServiceID}} - {{vm.DCustomerName}} - {{vm.DServiceAddres}}</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span>Details</span></md-tab-label><md-tab-body><br><label \nng-if=\"vm.Duplicate\" \nstyle=\"font-size:15px;font-weight: bold;margin-left: 90%;position: absolute; margin-top: -20px;color: #d01313\">\nDuplicate</label><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;height:auto;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:99.5%; border:1px solid rgb(224, 224, 224);float:left\"><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Work Order :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Client Contact :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DClientContactName}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Site Contact Name :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSiteContactName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width: 16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Site Contact Number :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DSiteContactNumber}}</span></div><div class=\"p-4\" style=\"width:4%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Email :</label></div><div class=\"p-4\" style=\"width:28%\"><span \nstyle=\"font-size:14px\">{{vm.DClientEmail}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Sales Person :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.SalesPerson}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Coverage Area :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DCoverageArea}}</span></div><div class=\"p-4\" style=\"width:16%\" \nng-if=\"vm.OrderType==\'Contract\'\"><label style=\"font-size:15px;font-weight: bold\">Contract Duration :</label></div><div \nclass=\"p-4\" style=\"width:16%\" ng-if=\"vm.OrderType==\'Contract\'\"><span style=\"font-size:14px\">\n{{vm.ContractStart| date:\"dd/MM/y\"}}-{{vm.ContractEnd| date:\"dd/MM/y\"}}</span></div><div class=\"p-4\" style=\"width:16%\" \nng-if=\"vm.OrderType!=\'Contract\'\"><label style=\"font-size:15px;font-weight: bold\">Ad-hoc Occurence :</label></div><div \nclass=\"p-4\" style=\"width:16%\" ng-if=\"vm.OrderType!=\'Contract\'\"><span style=\"font-size:14px\">{{vm.Occurence}}</span>\n</div><div class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Market Segment :</label></div>\n<div class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.MarketSegment}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label\n style=\"font-size:15px;font-weight: bold\">Team :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DTeamName}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Team Members :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.TeamMembers}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Job Type :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DTypes}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Prefered Days :\n</label></div><div class=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PreferedTime}}</span></div><div \nclass=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Preference Time :</label></div><div \nclass=\"p-4\" style=\"width:16%\"><span style=\"font-size:14px\">{{vm.PreferenceTime}}</span></div><div class=\"p-4\" \nstyle=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">Avoid Time :</label></div><div class=\"p-4\" \nstyle=\"width:16%\"><span style=\"font-size:14px\">{{vm.AvoidTime}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Man Hour :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.ManHour}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold\">Last Completed Date :</label></div><div class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.LastCompletedDate | date:\'dd/MM/y hh:mm a\'}} - {{vm.LastCompletedBy}}</span></div><div \nng-if=\"!vm.DuplicateRemarks\" class=\"p-4\" style=\"width:16%\"><label style=\"font-size:15px;font-weight: bold\">\nDuplicate Remarks :</label></div><div ng-if=\"!vm.DuplicateRemarks\" class=\"p-4\" style=\"width:16%\"><span \nstyle=\"font-size:14px\">{{vm.DuplicateRemarks}}</span></div></div></div></div></div><div class=\"navigation\"><br><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><div class=\"dx-field\"><div \nstyle=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">Date :</div><div class=\"dx-field-value\"><div \nstyle=\"width: 30%\" dx-date-box=\"dateBox.ResheduleFrom\" displayformat=\"dd-MM-yyyy\"></div></div></div><div \nstyle=\"margin-left: 10px\" class=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">\nStart Time :</div><div class=\"dx-field-value\"><div dx-date-box=\"dateBox.ResheduleStartTime\"></div></div></div><div \nstyle=\"margin-left: 10px\" class=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">\nEnd Time :</div><div class=\"dx-field-value\"><div dx-date-box=\"dateBox.ResheduleEndTime\"></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" \nname=\"SpecialRemark\" ng-model=\"vm.SpecialRemark\" placeholder=\"Remarks to this service\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"notes\" ng-model=\"vm.Notes\" placeholder=\"Neighbouring Job\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><label \nstyle=\"width:21%;font-weight:bold;color:#7f9593\">Message to Operation</label><text-angular ta-toolbar=\"none\" \nng-model=\"vm.Remarks\"></text-angular></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button ng-click=\"UpdateNewSchedule()\" style=\"float:right\" class=\"md-raised md-accent\">Update\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button></div><div id=\"dataGridFreq\" \ndx-data-grid=\"vm.dataGridFreqGrid\"></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Map</span>\n</md-tab-label><md-tab-body><div layout=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\" \nlayout=\"row\" layout-gt-xs=\"row\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%;margin-right:1%; border:1px solid rgb(224, 224, 224);float:left\"><input places-auto-complete \ntypes=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\"><ng-map id=\"mapa\" center=\"{{center}}\" zoom=\"5\" maximum-zoom=\"17\" \nstreet-view-control=\"true\" zoom-control=\"true\" zoom-to-include-markers=\"true\" ng-click=\"getpos($event)\"><marker \nposition=\"{{latlng}}\" ng-dragend=\"getpos($event)\" animation=\"Animation\" animation=\"DROP\" draggable=\"true\"></marker>\n</ng-map></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Comments</span></md-tab-label>\n<md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Addcomments\" placeholder=\"Comment Here..\"></md-input-container></div><div \nstyle=\"float: right;padding: 2%;\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"!vm.Addcomments\"><span>Save</span></md-button></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.CommentedBy }} @ {{ item.CreatedDate | date:\'dd/MM/y hh:mm a\'}}</h3><md-button \nstyle=\"position: absolute;left: 60%;margin: 0\" id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"DeleteComment(item._id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding><div flow-init=\"{singleFile: true}\" flow-name=\"uploader.flow\"><div \nid=\"attachmenthref\"><label for=\"file-input\" style=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\" style=\"float:right\"><span>Upload</span></md-button><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"font-size:smaller\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>\n&nbsp;</td><td><a \nhref=\"{{UploadsURL}}{{row.TableName==\'Operations\'?\'Operations/Scheduler\':\'CRM/SalesOrder\'}}/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeleteAttachment(row._id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\n.dx-field-item-required-mark {\r\n    color: #f74d61 !important;\r\n    margin: 0;\r\n    margin-left: 90%;\r\n    margin-top: -25px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-left: -8px;\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 97%;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n\r\n  .ms-scroll {\r\n    position: relative;\r\n  }\r\n\r\n  #viewsor:hover {\r\n    color: rgb(3, 155, 229) !important;\r\n    font-style: italic;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n\r\n  }\r\n\r\n  #viewsor {\r\n    color: rgb(148, 194, 218) !important;\r\n    font-style: italic;\r\n    font-size: 14px\r\n  }\r\n\r\n  #date1 .md-datepicker-input {\r\n    max-width: 100% !important;\r\n    min-width: 50% !important;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  #date1 md-datepicker .md-datepicker-input {\r\n    width: calc(13vw - 20px);\r\n    max-width: calc(15vw - 20px);\r\n  }\r\n\r\n  label {\r\n    padding-left: 10px !important;\r\n    font-size: 15px !important;\r\n  }\r\n\r\n  .ta-scroll-window>.ta-bind {\r\n    height: auto;\r\n    min-height: 80px;\r\n    padding: 6px 12px;\r\n    min-width: 1200px;\r\n  }\r\n\r\n  .ta-editor.ta-html,\r\n  .ta-scroll-window.form-control {\r\n    min-height: 100px;\r\n    height: auto;\r\n    overflow: auto;\r\n    font-family: inherit;\r\n    font-size: 100%;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/Popup.html","<md-dialog style=\"overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Add Service</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();vm.CompanyName = \'\';vm.WorkOrderNo = \'\';vm.ContractNo = \'\';vm.PestType = \'\';\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><br><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"height:40px;margin:0px\"><input type=\"text\" ng-model=\"vm.ServiceName\" \nplaceholder=\"Service Name\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:80px\"><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div\n class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"vm.dateBox1.ResheduleSSTime\"></div></div></div>\n<div class=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" \nclass=\"dx-field-label\">End Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" \ndx-date-box=\"vm.dateBox1.ResheduleSETime\"></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"height:40px;margin:0px\"><input type=\"text\" places-auto-complete types=\"[\'geocode\']\" \nng-model=\"vm.Description\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button ng-click=\"SubmitService()\" class=\"md-raised md-accent\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button>\n</div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        height: 55px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 54px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    .dataTables_filter {\r\n        display: block !important;\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\r\n\r\n    .color-orange {\r\n        color: orange;\r\n    }\r\n\r\n    .dx-checkbox-icon {\r\n        border: 1px solid #606b73 !important;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n        background-color: #83878a !important;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\r\n        border-bottom-color: #606a71;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n        border-left-color: #606a71 !important;\r\n        border-right-color: #606a71 !important;\r\n    }\r\n\r\n\r\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n        color: #535858e6 !important;\r\n        font-weight: bold !important;\r\n    }\r\n\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 94%;\r\n        max-height: 94%;\r\n    }\r\n\r\n    .dx-texteditor {\r\n        border-top-color: rgb(250, 250, 250) !important;\r\n        border-left-color: rgb(250, 250, 250) !important;\r\n        border-right-color: rgb(250, 250, 250) !important;\r\n    }\r\n\r\n    .dx-texteditor.dx-state-hover {\r\n        border-top-color: rgb(250, 250, 250) !important;\r\n        border-left-color: rgb(250, 250, 250) !important;\r\n        border-right-color: rgb(250, 250, 250) !important;\r\n        border-bottom-color: rgb(222, 225, 227) !important;\r\n    }\r\n\r\n    .dx-texteditor.dx-state-focused,\r\n    .dx-texteditor.dx-state-active {\r\n        border-top-color: rgb(250, 250, 250) !important;\r\n        border-left-color: rgb(250, 250, 250) !important;\r\n        border-right-color: rgb(250, 250, 250) !important;\r\n        border-bottom-color: rgb(51, 51, 51) !important;\r\n    }\r\n\r\n    .dx-searchbox {\r\n        border-color: rgb(222, 225, 227) !important;\r\n    }\r\n\r\n    .dx-searchbox.dx-state-hover {\r\n        border-color: rgb(177, 60, 39) !important;\r\n    }\r\n\r\n    .dx-searchbox.dx-state-focused,\r\n    .dx-searchbox.dx-state-active {\r\n        border-color: rgb(240, 91, 65) !important;\r\n    }\r\n\r\n    .dx-icon-warning:before {\r\n        content: \"\\f06b\";\r\n        color: #d01e1e;\r\n    }\r\n\r\n    .md-select-icon,\r\n    md-select .md-select-icon {\r\n        color: #757575\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/Scheduler-popup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this service?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5% 2% 2% 2%\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex style=\"height:40px;margin:0\"><input type=\"text\" \nng-model=\"vm.CancelRemarks\" placeholder=\"Reason\" required></md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox ng-model=\"Cancel.value\" \ntype=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">Send email notification to the Technicians and Creator?\n</md-checkbox></md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button\n ng-click=\"Schinfodelete(deleteID)\" class=\"md-raised md-accent\" ng-disabled=\"eventForm.$invalid\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/flexischeduler/Selectedschedule.html","<md-dialog style=\"overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Duplicate Job</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 20px 5px 20px\"><br><div flex><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:50px\">\n<md-input-container flex style=\"margin: 0\"><label style=\"margin-right: 10px\">Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.ResheduleSFrom\" required></md-datepicker></md-input-container><div \nclass=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">\nStart Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"vm.dateBox.ResheduleSSTime\">\n</div></div></div><div class=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" \nclass=\"dx-field-label\">End Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" \ndx-date-box=\"vm.dateBox.ResheduleSETime\"></div></div></div></div><div layout=\"column\" layout-gt-xs=\"column\">\n<md-input-container flex><label>Frequency & Pest Type</label><md-select ng-model=\"vm.CPestType\" \nng-change=\"CheckForFrequency(vm.PestType)\" id=\"searchmodule\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" placeholder=\"Frequency & Pest Type..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchPest\" ng-value=\"row\">{{row.Frequency}} - {{row.PestType}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Team</label><md-select ng-model=\"vm.CAssignedTo\" \nid=\"searchmodule\" ng-change=\"getTeamTable(vm.AssignedTo)\" md-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.TM=null;vm.ppTeamName=null;vm.TeamEstimationHr=vm.EstimationHr\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0;flex: 0.4\"><input \ntype=\"text\" ng-model=\"vm.ResheduleSRemarks\" placeholder=\"Remarks\" required></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"SubmitClone()\" \nng-disabled=\"!vm.ResheduleSRemarks\" class=\"md-raised md-accent\">Submit</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  .md-datepicker-input-container {\r\n    width: 90%;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    width: calc(100% - 45px);\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 45px;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/addcoments.html","<md-dialog style=\"width:70%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Service Job</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Duration</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.StartDate | date:\'hh:mm a\'}}-{{vm.EndDate | date:\'hh:mm a\'}}\n</span></div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Address\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Description}}</span></div>\n</div></div></div><br><div layout=\"column\"><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div \nclass=\"p-4\" style=\"width:10%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div>\n<div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"column\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" \nng-repeat=\"row in Photosdatas\" ng-switch on=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" \nng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></div></div>\n</div></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n    .chipsdemoContactChips md-content.autocomplete input {\r\n      min-width: 400px;\r\n    }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n    .chipsdemoContactChips .contact-item.selected {\r\n      opacity: 0.5;\r\n    }\r\n\r\n      .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n    .chipsdemoContactChips .contact-item .md-list-item-text {\r\n      padding: 14px 0;\r\n      max-width: 190px;\r\n    }\r\n\r\n      .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n        margin: 0 !important;\r\n        padding: 0;\r\n        line-height: 1.2em !important;\r\n      }\r\n\r\n      .chipsdemoContactChips .contact-item .md-list-item-text h3, .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n      }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n  }\r\n\r\n    #tb2 td:first-child:before {\r\n      counter-increment: serial-number; /* Increment the serial number counter */\r\n      content: counter(serial-number); /* Display the counter */\r\n    }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon, md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n   }\r\n    .star\r\n\r\n  {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n  .filled\r\n\r\n  {\r\n    color: #fd0;\r\n  }\r\n\r\n  \r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/flexischeduler/flexischeduler.html","<div id=\"shedular\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span>Daily Scheduler</span></div><div\n class=\"product-count secondary-text\"><span>Total Schedules:</span> <span>{{calenderdata.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex ng-show=\"WeekViewGrid\"><md-input-container flex \nid=\"Datefilter\" style=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" \nid=\"searchmodule\" style=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex ng-show=\"!WeekViewGrid\"><md-input-container flex id=\"Datefilter\" \nstyle=\"margin-top: 0\"><span style=\"color:white !important\">Team</span><md-select ng-model=\"Team\" id=\"searchmodule\" \nstyle=\"color:white !important\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Team = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchPest\" ng-value=\"row.id\">{{row.TeamName}}</md-option></md-select>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon></md-button></div><div><md-button class=\"md-raised md-background\" \nng-click=\"sendEmailPop($event)\" ng-show=\"WeekViewGrid\"><span>Send Email</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"Refresh()\"><span>Refresh</span></md-button></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"border:1px solid rgb(224, 224, 224);padding:1.5% 1% 1.5% 1%\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><span class=\"dot\" style=\"background: #1e93c2\"></span> <span \nstyle=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Fixed)</b></span> <span class=\"dot\" style=\"background: #29824d\"></span> \n<span style=\"padding: 0.2% 3% 0 0.7%\"><b>Contract (Flexible)</b> </span><span class=\"dot\" style=\"background: red\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Ad-Hoc</b> </span><span class=\"dot\" style=\"background: #1527a9\">\n</span> <span style=\"padding: 0.2% 3% 0 0.7%\"><b>Service</b></span><div \nstyle=\"width:28%;margin: auto;display:inline-block\"></div><span style=\"font-size:14.5px\"><b>Date :</b> </span><span \nstyle=\"font-size:14.5px\">{{vm.Date | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><span class=\"calendarspan\">{{vm.Holiday}}<span><div id=\"scheduler\" \ndx-scheduler=\"schedulerOptions\"></div><div id=\"appointmentContextMenu\"></div><br><md-input-container \nng-show=\"WeekViewGrid\" flex=\"31\" style=\"margin-top: 39px\"><label style=\"color:black;font-size: 14px\">From</label><br>\n<md-datepicker onkeydown=\"return false\" ng-model=\"StDate\" ng-change=\"getForSelectedDays(1)\"></md-datepicker>\n</md-input-container><md-button class=\"md-raised md-button md-ink-ripple md-default-theme\" \nng-click=\"getForSelectedDays(3)\" ng-show=\"WeekViewGrid\"><span>3 Days</span></md-button><md-button \nclass=\"md-raised md-button md-ink-ripple md-default-theme\" ng-click=\"getForSelectedDays(5)\" ng-show=\"WeekViewGrid\">\n<span>5 Days</span></md-button><div id=\"NewDataGrid\" ng-show=\"WeekViewGrid\" style=\"margin-top: -39px\" \ndx-data-grid=\"vm.dataGridSalesOrderNew\" dx-drop=\"dropped($event)\"></div></span></span></div></div></div></div><div \nid=\"popup\" style=\"height: 99%; overflow-y: scroll\"></div><style>\n.blackcolor {\r\n        color: black;\r\n    }\r\n\r\n    .whiteColor {\r\n        color: white;\r\n    }\r\n\r\n    .dot {\r\n        height: 20px;\r\n        width: 20px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    .dot1 {\r\n        height: 10px;\r\n        width: 10px;\r\n        border-radius: 50%;\r\n        display: inline-block;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        padding-top: 1.5%;\r\n        border-bottom: 1px solid #c2c8cc;\r\n    } */\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-value,\r\n    #Datefilter md-select .md-select-value {\r\n        border-bottom-color: rgb(255, 255, 255) !important;\r\n    }\r\n\r\n    #Datefilter md-select.md-default-theme .md-select-icon,\r\n    md-select .md-select-icon {\r\n        color: rgb(255, 255, 255);\r\n    }\r\n\r\n    /* md-select.md-default-theme:not([disabled]):focus .md-select-value, md-select:not([disabled]):focus .md-select-value{\r\n    color:white !important;\r\n} */\r\n    /* .dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n} */\r\n    /* .day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    /* .dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n} */\r\n\r\n    /* .dx-scheduler-group-header {\r\n    position: relative;\r\n} */\r\n\r\n    /* .dx-scheduler-timeline .dx-scheduler-appointment, .dx-scheduler-work-space-month .dx-scheduler-appointment, .dx-scheduler-all-day-appointment\r\n{\r\n  \r\n  \r\n    height: 73.5019px!important;\r\n   \r\n}\r\n.dx-scheduler-date-table-other-month.dx-scheduler-date-table-cell {\r\n    opacity: 1;\r\n    color: rgba(0, 0, 0, 0.3);\r\n}\r\n.dx-scheduler-dropdown-appointments{\r\n    position: absolute;\r\n    display: block;\r\n    height: 20px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    margin: 3px 0 0 3px;\r\n}\r\n.dx-scheduler-group-header {\r\n    position: relative;\r\n}\r\n\r\n.dx-template-wrapper {\r\n    height: 100%;\r\n}\r\n\r\n.avatar {\r\n    width: 155px;\r\n    float: left;\r\n    overflow: hidden;\r\n    position: relative;\r\n    height: 125px;\r\n}\r\n\r\n.name {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n.name h2 {\r\n    color: #fff;\r\n    text-align: left;\r\n    padding: 0 0 5px 175px;\r\n    margin: 0;    \r\n}\r\n\r\n.dx-theme-material .name h2 {\r\n    font-size: 28px;\r\n}\r\n\r\n.info {\r\n    width: auto;\r\n    text-align: left;\r\n    height: 100%;\r\n    font-size: 11pt;\r\n    font-weight: normal;\r\n    padding: 25px 20px;\r\n    color: #707070;\r\n}\r\n\r\n.dx-color-scheme-contrast .info {\r\n    color: #FFF;\r\n}\r\n\r\n.userInfo div {\r\n    margin: 20px;\r\n}\r\n\r\n.day-cell {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n} */\r\n    .training-background-0 {\r\n        background-image: url(\"https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/gym/icon-abs.png\");\r\n    }\r\n\r\n    .appointment-content {\r\n        width: 360px;\r\n        margin-top: 3px;\r\n    }\r\n\r\n    .dx-popup-content .appointment-content {\r\n        margin-top: 7px;\r\n        height: 50px;\r\n    }\r\n\r\n    .dx-scheduler-header-panel-cell .dx-scheduler-cell-sizes-horizontal {\r\n        width: 100px\r\n    }\r\n\r\n    .appointment-badge {\r\n        text-align: center;\r\n        float: left;\r\n        margin-right: 12px;\r\n        color: white;\r\n        width: 28px;\r\n        height: 28px;\r\n        font-size: 20px;\r\n        line-height: 20px;\r\n        border-radius: 28px;\r\n        margin-top: 5px;\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    /* .appointment-dates {\r\n        color: #959595;\r\n        font-size: 12px;\r\n        text-align: left;\r\n        float: left;\r\n    }  */\r\n\r\n    .appointment-text {\r\n        overflow: hidden;\r\n        /* text-overflow: ellipsis; */\r\n        /* white-space: nowrap; */\r\n        width: 270px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        float: left;\r\n\r\n    }\r\n\r\n    .delete-appointment {\r\n        position: relative;\r\n        border: none;\r\n        box-shadow: none;\r\n        top: -8px;\r\n        height: 50px;\r\n    }\r\n\r\n    .showtime-preview>div:first-child {\r\n        font-size: 12px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .showtime-preview>div:not(:first-child) {\r\n        font-size: 11px;\r\n        white-space: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-button-content {\r\n        width: 50px;\r\n        height: 50px;\r\n        padding-left: 4px;\r\n    }\r\n\r\n    .delete-appointment.dx-state-hover,\r\n    .dx-list-item.dx-state-hover .dx-button {\r\n        box-shadow: none;\r\n        background-color: inherit;\r\n    }\r\n\r\n    .delete-appointment .dx-icon-trash {\r\n        color: #337ab7 !important;\r\n        font-size: 23px !important;\r\n    }\r\n\r\n    /* .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-group-table, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable, .dx-scheduler-timeline.dx-scheduler-work-space-grouped[dx-group-column-count=\'1\'] .dx-scheduler-sidebar-scrollable:before{\r\n        content: \'TEAMS\'\r\n    } */\r\n    .dx-scheduler-timeline.dx-scheduler-work-space-both-scrollbar.dx-scheduler-work-space-grouped .dx-scheduler-sidebar-scrollable:before {\r\n        border-bottom: 1px solid #c2c8cc;\r\n        content: \'TEAMS\';\r\n        font-size: larger;\r\n        font-weight: 700;\r\n        padding-left: 20px;\r\n        padding-top: 20px;\r\n\r\n    }\r\n\r\n    .dx-scrollbar-vertical.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        background-color: rgb(240, 102, 51);\r\n    }\r\n\r\n    .dx-scrollable-scroll-content {\r\n        background-color: rgb(240, 102, 51) !important;\r\n    }\r\n\r\n    .dx-icon-warning:before {\r\n        color: #d01e1e;\r\n        border: none\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable {\r\n        height: 15px !important;\r\n    }\r\n\r\n    .dx-scrollbar-horizontal.dx-scrollbar-hoverable .dx-scrollable-scroll.dx-state-invisible {\r\n        height: 15px !important;\r\n    }\r\n\r\n    #dataGridFreq>div.dx-datagrid {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-rowsview .dx-row {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-top: none !important;\r\n    }\r\n\r\n    #dataGridFreq .dx-datagrid-headers {\r\n        border: 1px solid #dee1e3 !important;\r\n        border-bottom: none !important;\r\n    }\r\n\r\n\r\n    #scheduler .dx-scheduler-cell-sizes-horizontal {\r\n        width: 80px;\r\n    }\r\n\r\n    .calendarspan {\r\n        padding-left: 50%;\r\n        font-weight: 800;\r\n        font-size: x-large;\r\n        color: maroon;\r\n    }\r\n\r\n    .custom-heading {\r\n        margin-top: 10px;\r\n        /* pushes it slightly down inside */\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        color: #333;\r\n        position: relative;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/materials/materials.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-material-ui\"></md-icon><span translate=\"OPERATIONSMATERIALS.HEADER\">Materials</span></div>\n<div class=\"product-count secondary-text\"><span translate=\"OPERATIONSMATERIALS.TOTAL_MATERIALS:\">Total Materials:\n</span> <span>{{Materialsdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{ \'OPERATIONSMATERIALS.SEARCH\' | translate }}\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"OPERATIONSMATERIALS.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"OPERATIONSMATERIALS.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"OPERATIONSMATERIALS.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Materialsgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Materialsdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Types</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"OPERATIONSMATERIALS.MATERIAL_NAME\">Material Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSMATERIALS.MATERIAL_CODE\">Material Code\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"OPERATIONSMATERIALS.DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"OPERATIONSMATERIALS.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Materialsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.PestType }}</td><td>\n{{ row.MaterialsName }}</td><td>{{ row.Materialscode }}</td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Materialsinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Materialsform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Pest Types\n</label><md-select ng-model=\"vm.PestType\" name=\"PestType\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.PestName\'}\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchTermP = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"MaterialsName\" ng-model=\"uMaterialsName\" \nplaceholder=\"{{ \'OPERATIONSMATERIALS.MATERIAL_NAME\' | translate }}\" required><div \nng-messages=\"basicForm.MaterialsName.$error\" ng-show=\"basicForm.MaterialsName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"OPERATIONSMATERIALS.MATERIAL_NAME_REQUIRED\">Material Name required.</span></div>\n</div><p ng-show=\"error1\" style=\"color:red\" translate=\"OPERATIONSMATERIALS.MATERIAL_NAME_IS_ALREADY_EXIST.\">\nMaterials Name Is already Exist.</p></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" name=\"MaterialsCode\" ng-model=\"uMaterialscode\" \nplaceholder=\"{{ \'OPERATIONSMATERIALS.MATERIAL_CODE\' | translate }}\" required><div \nng-messages=\"basicForm.MaterialsCode.$error\" ng-show=\"basicForm.MaterialsCode.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"OPERATIONSMATERIALS.MATERIAL_CODE_FIELD_IS_REQUIRED.\">\nMaterial Code field is required.</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"OPERATIONSMATERIALS.DESCRIPTION\">Description</label><input type=\"text\" ng-model=\"udescription\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\" translate=\"OPERATIONSMATERIALS.SUBMIT\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"OPERATIONSMATERIALS.CANCEL\">Cancel\n</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n    width: calc(41vw - 60px);\r\n    max-width: calc(48vw - 64px);\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\n</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/pest-types/pest_types.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-bug\"></md-icon><span translate=\"CRMPESTTYPES.HEADER\">\nPest Types</span></div><div class=\"product-count secondary-text\"><span>Total Pest Types : </span><span>\n{{pestdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'CRMPESTTYPES.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"addbtn && IsAdmin==true\" ng-click=\"addnameclk()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"CRMPESTTYPES.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CRMPESTTYPES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"CRMPESTTYPES.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"pesttypeGrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"pestdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMPESTTYPES.PEST_TYPE\">Pest Type</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMPESTTYPES.PEST_CODE\">Pest Code</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"CRMPESTTYPES.CREATED BY\" class=\"column-title\">Created By</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"CRMPESTTYPES.CREATED DATE\" class=\"column-title\">\nCreated Date</span></div></th><th class=\"secondary-text\" ng-if=\"IsAdmin==true\"><div><span class=\"column-title\" \ntranslate=\"CRMPESTTYPES.VIEW/EDIT\">View/Edit</span></div></th><th class=\"secondary-text\" ng-if=\"IsAdmin==true\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in pestdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.PestName }}</td><td>{{ row.Pestcode }}</td><td>\n{{ row.CreatedBy }}</td><td>{{ row.CreateDate | date:\"dd/MM/y hh:mm a\" }}</td><td ng-if=\"IsAdmin==true\"><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"pestinfo(row.id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td ng-if=\"IsAdmin==true\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup($event, row.id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"pesttypeform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"pesttype\" ng-model=\"pesttypename\" \nplaceholder=\"{{ \'CRMPESTTYPES.PEST_TYPE\' | translate }}\" required><div ng-messages=\"basicForm.pesttype.$error\" \nng-show=\"basicForm.pesttype.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CRMPESTTYPES.PEST_TYPE_IS_REQUIRED\">Pest Type is required.</span></div></div><p ng-show=\"error1\" \nstyle=\"color:red\" translate=\"CRMPESTTYPES.PEST_TYPE_IS_ALREADY_EXIST\">Pest Type Is already Exist.</p>\n</md-input-container><md-input-container flex><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" \nname=\"remarks\" ng-model=\"pestcode\" placeholder=\"{{ \'CRMPESTTYPES.PEST_CODE\' | translate }}\" required><div \nng-messages=\"basicForm.pesttypename.$error\" ng-show=\"basicForm.pesttypename.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CRMPESTTYPES.PEST_CODE_IS_REQUIRED\">Pest Code is required.</span></div></div><p \nng-show=\"error2\" style=\"color:red\">Pest Code already Exists.</p></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-checkbox-container flex style=\"flex:0.5\"><md-checkbox ng-model=\"AddTreatment.value\" \ntype=\"checkbox\">Add Treatment?</md-checkbox></md-checkbox-container><md-input-container flex></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex ng-if=\"AddTreatment.value==true\"><md-input-container flex><input \ntype=\"text\" name=\"TreatmentName\" ng-model=\"vm.TreatmentName\" placeholder=\"Treatment Name\" required>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"ContactPerson\" ng-model=\"vm.Description\" \nplaceholder=\"Description\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:15px\" \nng-if=\"AddTreatment.value==true\"><md-input-container flex><input type=\"text\" name=\"Chemical\" ng-model=\"vm.Chemical\" \nplaceholder=\"Chemical\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Dilution\" \nng-model=\"vm.Dilution\" placeholder=\"Dilution\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:15px\" ng-if=\"AddTreatment.value==true\"><md-input-container flex style=\"margin-top:-28px\"><span>SOP\n</span><div dx-text-area=\"textAreaWithMaxLength\"></div></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"CRMPESTTYPES.SUBMIT\">Submit</md-button><md-button \nng-click=\"cancelbtnclk()\" class=\"md-raised\" translate=\"CRMPESTTYPES.CANCEL\">Cancel</md-button></div></form></div></div>\n</div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scopeofwork/scopeofwork.html","<div id=\"scopeofwork\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-shopping\"></md-icon><span>Scope of Work</span></div><div \nclass=\"product-count secondary-text\"><span>Total Scope of Works: </span><span>{{SOWdatas.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'OPERATIONSDIVISIONS.SEARCH\' | translate }}\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"OPERATIONSDIVISIONS.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"OPERATIONSDIVISIONS.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"OPERATIONSDIVISIONS.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"SOWGrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"SOWdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Scope of Work</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"OPERATIONSDIVISIONS.CREATED_BY\" class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"OPERATIONSDIVISIONS.CREATED_DATE\" class=\"column-title\">Created Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"OPERATIONSDIVISIONS.VIEW/EDIT\">View/Edit</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"row in SOWdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.PestType }}</td><td>{{ row.Scopeofwork }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date:\"dd/MM/y hh:mm a\" }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"SOWinfo(row._id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"SOWform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate>\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container style=\"margin-top: 18px\" flex><label>Pest Type</label>\n<md-select ng-model=\"PestType\" name=\"PestType\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a PestType..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.PestType = null;vm.searchfe = \'\'\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Pestdatas | filter:vm.searchfe\" value=\"{{row.PestName}}\">\n{{row.PestName}}</md-option></md-select></md-input-container><md-input-container flex><input \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"Scopeofwork\" ng-model=\"Scopeofwork\" \nplaceholder=\"Scope of Work\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"remarks\" \nng-model=\"Description\" placeholder=\"Description\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"basicForm.$invalid\" translate=\"OPERATIONSDIVISIONS.SUBMIT\">Submit</md-button><md-button \nng-click=\"cancelbtnclk()\" class=\"md-raised\" translate=\"OPERATIONSDIVISIONS.CANCEL\">Cancel</md-button></div></form>\n</div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ConfirmDownloadforCompletedJob.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">DOWNLOAD CONFIRMATION\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 20px 5px 20px\"><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span><b>\nAre you sure you want to Download {{CompletedSelectedIds.length}} Completed Services?</b></span></div><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"DownloadforSelectedCompletedJob(vm.CurrentDateTimeFolder, $event)\" class=\"md-raised md-accent\">Yes\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel();ClearGrid();\">No</md-button></div><br></md-dialog-content>\n</form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ConfirmEmailforCompletedJob.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nng-show=\"vm.Confirmation == true\" class=\"title\">SEND EMAIL CONFIRMATION</span> <span ng-show=\"vm.EmailDetails == true\" \nclass=\"title\">EMAIL STATUS</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 20px 5px 20px\"><div ng-show=\"vm.Confirmation == true\"><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span><b>\nAre you sure you want to send Email to {{CompletedSelectedIds.length}} Completed Services?</b></span></div><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"SendEmailforSelectedCompletedJob()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel();ClearGrid();\">No</md-button></div><br></div><div ng-show=\"vm.EmailDetails == true\"><div \nlayout=\"column\" layout-sm=\"column\" layout-align=\"center\" ng-if=\"vm.OverallEmailStatus == true\"><h4 \nstyle=\"text-align:center\"><b>{{vm.ECount}} of {{vm.EMax}} Completed.</b></h4></div><div class=\"progress\" \nlayout=\"column\" layout-sm=\"column\" layout-align=\"center\" ng-if=\"vm.OverallEmailStatus == true\"><div \nclass=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"{{vm.EValue}}\" aria-valuemin=\"0\" \naria-valuemax=\"{{vm.EMax}}\" style=\"width:{{vm.EValue}}%\"><b>{{vm.EValue}}% Completed</b></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent To</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remarks</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in ShowCompletedSelectedIds\" \nng-class=\"{ \'color-red\': getRowColourforSentBulkEmail(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.ServiceID }}</td><td>{{ row.EmailStatus }}</td><td>{{ row.EmailSentDate | date:\'dd/MM/y hh:mm a\'}}</td>\n<td>{{ removeLastComma(row.EmailSentTo) }}</td><td>{{ row.Remarks }}</td></tr></tbody></table></div></div>\n</md-dialog-content></form></md-dialog><style>\n.color-red {\r\n    color: red;\r\n  }\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ConfirmServiceReportApprove.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">APPROVE SERVICE REPORTS\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 20px 5px 20px\"><div layout=\"column\" layout-sm=\"column\" layout-align=\"center center\" \nng-show=\"vm.ServiceReportApproveSpinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span><b>Approving...</b></span></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" ng-show=\"vm.ServiceReportApproveSpinner == false\"><span><b>\nAre you sure you want to Approve {{CompletedSelectedIds.length}} Service Reports?</b></span></div><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" ng-show=\"vm.ServiceReportApproveSpinner == false\">\n<md-button ng-click=\"ApproveServiceReportforSelectedCompletedJob($event)\" class=\"md-raised md-accent\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel();ClearGrid();\">No</md-button></div><br></md-dialog-content></form>\n</md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ConfirmVerifyforCompletedJob.html","<md-dialog style=\"width:500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">VERIFY CONFIRMATION</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 20px 5px 20px\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><span><b>Are you sure you want to confirm verification?</b></span></div><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"VerifyforSelectedCompletedJob()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel();ClearGrid();\">No</md-button></div><br></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/scheduler/CustomAdd.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Create Ad-hoc Schedule</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-autocomplete flex md-selected-item=\"vm.selectedCustomer\" \nmd-search-text=\"vm.searchCompanyText\" required md-items=\"item in filterCustomerfn(vm.searchCompanyText)\" \nmd-item-text=\"item.CompanyName\" md-min-length=\"0\" placeholder=\"Company Name\" md-no-cache=\"true\" \nmd-floating-label=\"Company Name\" md-selected-item-change=\"onCustomerSelected(item)\"><md-item-template><span>\n{{ item.CompanyName }}</span></md-item-template><md-not-found>\nNo matches found. You can continue typing to add a new customer.</md-not-found></md-autocomplete><md-input-container \nflex><input type=\"text\" name=\"contactname\" ng-model=\"vm.AContactName\" placeholder=\"Contact Name\" required>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"totalprice\" ng-model=\"vm.ATotalPrice\" \nplaceholder=\"Total Price\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Payment Mode</label><md-select ng-model=\"vm.APaymentMode\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Payment Mode..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PaymentMode = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Billing Frequency</label><md-select \nng-model=\"vm.ABillingFrequency\" id=\"searchmodule\" md-on-close=\"vm.searchTerm1 = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Billing Frequency\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.BillingFrequency = null;vm.searchTerm1=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in BillingFrequencydatas | filter:vm.searchTerm1\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Team</label><md-select ng-model=\"vm.AAssignedTo\" \nid=\"searchmodule\" ng-change=\"getTeamTable(vm.AAssignedTo)\" md-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.AssignedTo = null;\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label>Salesperson</label><md-select ng-model=\"vm.ASalesperson\" name=\"SalesPerson\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Sales Person...\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ASalesperson = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" name=\"manhour\" \nng-model=\"vm.AManHour\" placeholder=\"Estimation Time\" min=\"0.5\" ng-change=\"calculate_end_time($event)\" required><div \nng-messages=\"eventForm.manhour.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nThis field is required.</div><div ng-message=\"min\">Estimation time must be at least 0.5 hours.</div><div \nng-message=\"number\">Enter a valid number.</div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"remarks\" ng-model=\"vm.ARemarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"dx-field\" \nstyle=\"flex: 1\"><div class=\"dx-field-label\" style=\"flex: 0.2\">Pest Type</div><div class=\"dx-field-value\" \nstyle=\"flex: 0.8\"><div is=\"pestTreeBoxOptions\" dx-drop-down-box=\"treeBoxOptions\"><div \ndata-options=\"dxTemplate: { name: \'content\' }\"><div dx-tree-view=\"treeBoxOptions.treeView\"></div></div></div></div>\n</div><br><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"dx-field\"><div class=\"dx-field-label\">Start Date and time\n</div><div class=\"dx-field-value\"><div dx-date-box=\"dateBox.AStartTime\"></div></div></div><div class=\"dx-field\"></div>\n<div class=\"dx-field\"><div class=\"dx-field-label\">End Date and time</div><div class=\"dx-field-value\"><div \ndx-date-box=\"dateBox.AEndTime\"></div></div></div></div><br><md-tabs md-dynamic-height md-center-tabs=\"false\" \nmd-selected=\"selectedIndex\"><md-tab><md-tab-label><span>Billing Address</span></md-tab-label><md-tab-body><div \nlayout=\"column\" layout-gt-sm=\"row\" flex style=\"padding:15px 0 0 5px\"><md-input-container flex style=\"margin-bottom:0\" \nng-if=\"vm.billingAddresses.length > 0\"><label>Address</label><md-select ng-model=\"vm.selectedBillingAddress\" required \nng-change=\"vm.fillBillingAddress(vm.selectedBillingAddress)\"><md-option ng-repeat=\"addr in vm.billingAddresses\" \nng-value=\"addr\">{{addr.bStreetName}} ({{addr.bPostal}})</md-option></md-select></md-input-container><md-input-container\n flex style=\"margin-bottom:0\" ng-if=\"vm.billingAddresses.length === 0\"><label>Address</label><input \nplaces-auto-complete types=\"[\'geocode\']\" required on-place-changed=\"placeChanged1()\" ng-model=\"vm.ABillingAddress\" \nplaceholder=\"\"></md-input-container><md-input-container flex style=\"margin-bottom:0;flex: 0.2\"><input type=\"text\" \nng-disabled=\"vm.billingAddresses.length > 0\" ng-model=\"vm.ABPostal\" placeholder=\"Postal Code\" required>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-chips \nmd-transform-chip=\"transformChip($chip)\" id=\"BillingEmail\" ng-model=\"vm.ABEMail\" readonly=\"vm.readonly\" \nstyle=\"width: 100%;padding:0!important\"><input type=\"text\" name=\"ContactNum\" placeholder=\"Email\" \nng-disabled=\"vm.billingAddresses.length > 0\" md-on-add=\"vm.onEmail1ChipAdd($chip)\"></md-chips></div><div \nng-show=\"vm.emailValidationError\" style=\"color: red; font-size: 13px\">Please enter valid email.</div><div \nclass=\"error-message\" ng-show=\"vm.Email1ChipWarning\" style=\"color: red; font-size: 13px\">\nPlease press \"Enter\" after typing the Email.</div><span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">\nType Email and Press Enter</span><br><br></md-tab-body></md-tab><md-tab><md-tab-label><span>Service Address</span>\n</md-tab-label><md-tab-body><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"padding:15px 0 0 5px\">\n<md-input-container flex style=\"margin-bottom:0\" ng-if=\"vm.serviceAddresses.length > 0\"><label>Address</label>\n<md-select ng-model=\"vm.selectedServiceAddress\" required ng-change=\"vm.fillServiceAddress(vm.selectedServiceAddress)\">\n<md-option ng-repeat=\"addr in vm.serviceAddresses\" ng-value=\"addr\">{{addr.sStreetName}} ({{addr.sPostal}})</md-option>\n</md-select></md-input-container><md-input-container flex style=\"margin-bottom:0\" \nng-if=\"vm.serviceAddresses.length === 0\"><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \nrequired on-place-changed=\"placeChanged2()\" ng-model=\"vm.AServicesAddress\" placeholder=\"\"></md-input-container>\n<md-input-container flex style=\"margin-bottom:0;flex: 0.2\"><input type=\"text\" ng-model=\"vm.ASPostal\" \nplaceholder=\"Postal Code\" required ng-disabled=\"vm.serviceAddresses.length > 0\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-chips md-transform-chip=\"transformChip1($chip)\" id=\"ServiceEmail\" \nng-model=\"vm.ASEmail\" readonly=\"vm.sreadonly\" style=\"width: 100%;padding:0!important\"><input type=\"text\" \nname=\"ContactNum\" placeholder=\"Email\" ng-disabled=\"vm.serviceAddresses.length > 0\" \nmd-on-add=\"vm.onEmail2ChipAdd($chip)\"></md-chips></div><div ng-show=\"vm.emailValidationError1\" \nstyle=\"color: red; font-size: 13px\">Please enter valid email.</div><div class=\"error-message\" \nng-show=\"vm.Email2ChipWarning\" style=\"color: red; font-size: 13px\">Please press \"Enter\" after typing the Email.</div>\n<span class=\"h4\" style=\"color:#7f9593;margin-top:1%\">Type Email and Press Enter</span><br></md-tab-body></md-tab>\n</md-tabs><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" style=\"padding:1% 43% 0 0;float:right\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sCustomScheduler($event)\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid\">Preview</md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></md-dialog-content></form></md-dialog>\n<style>\n#form-container {\r\n        margin: 10px;\r\n    }\r\n\r\n    .long-title h3 {\r\n        font-family: \'Segoe UI Light\', \'Helvetica Neue Light\', \'Segoe UI\', \'Helvetica Neue\', \'Trebuchet MS\', Verdana;\r\n        font-weight: 200;\r\n        font-size: 28px;\r\n        text-align: center;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .add-phone-button {\r\n        margin-top: 10px;\r\n    }\r\n\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\r\n\r\n    .md-datepicker .md-datepicker-input {\r\n        width: calc(35vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n        color: black !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 56px);\r\n    }\r\n\r\n    .md-default-theme .md-datepicker-input-mask-opaque,\r\n    .md-datepicker-input-mask-opaque {\r\n        left: 0px !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(17vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 133%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-left: -8px;\r\n    }\r\n\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 97%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/CustomPreview.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Preview</span></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Team Name&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppTeamName}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Service Address&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{previewdatas[0].Location}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\">\n<span style=\"font-size:15px;color:#7f9593\"><b>Job Type&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{previewdatas[0].JobType ==\'Contract\' ? \'Flexible\' : previewdatas[0].JobType}}</span></md-input-container>\n</div><br><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" dx-data-grid=\"vm.dataGridOptions\"></div>\n</div><br><span style=\"font-size:13.5px\">There are [{{vm.DuplicateCount}}] number of service jobs found duplicate\n</span><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Orange :</b></span> <span style=\"font-size:13.5px\">\nSame team assigned to other Fixed jobs during this time</span></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>Green :</b></span> <span \nstyle=\"font-size:13.5px\">Same Team assigned for other jobs</span></md-input-container></div><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"customPreviewsubmit()\" \naria-label=\"Submit\" ng-disabled=\"previewGridDatas.length==0\">Confirm</md-button><md-button type=\"submit\" \nng-click=\"ReDo()\" class=\"md-raised\">Re-Do</md-button></div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        height: 55px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 54px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    .dx-toolbar-label>div {\r\n        display: none !important;\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\r\n\r\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n        color: #535858e6 !important;\r\n        font-weight: bold !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/CustomerInfo.html","<md-dialog style=\"width:70%;overflow:unset\"><form name=\"CinfotForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Customer & Location :</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\" style=\"width:100%;padding: 1%;height:auto\"><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Customer Name</label><md-select \nng-model=\"vm.Customersearch\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" required><md-select-header><input \nstyle=\"flex: auto\" ng-model=\"vm.searchTermC\" type=\"text\" placeholder=\"Search For a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Customersearch = null;vm.searchTermC=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas | filter:vm.searchTermC\" ng-click=\"GetCinfo(row.id)\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" ng-disabled=\"!vm.Location\" style=\"height:5%\">Ok</md-button></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"font-size:13.5px\"><table class=\"table dataTable row-border hover\" id=\"tb2\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Contact Person</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Blk</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Building Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nStreet Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Postal</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Select</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in CustomerServicedatas track by $index\" ng-if=\"row.sContactPerson != null\"><td>&nbsp;</td><td>\n{{ row.sContactPerson}}</td><td>{{ row.sBLK }}</td><td>{{ row.sUnit}}</td><td>{{ row.sBuildingName}}</td><td>\n{{ row.sStreetName }}</td><td>{{ row.sPostal}}</td><td><md-radio-group ng-model=\"vm.Location\"><md-radio-button \nvalue=\"{{row.sBLK }} {{row.sUnit}} {{row.sBuildingName}} {{row.sStreetName }} {{row.sPostal}}\" \nng-click=\"vm.ContactPerson = row.sContactPerson;vm.ContactNumber = row.sMobile;\" style=\"height:18px\"></md-radio-button>\n</md-radio-group></td></tr></tbody></table></div></div></md-dialog-content></form></md-dialog><style>\n#tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/EditServiceLine.html","<md-dialog style=\"width:60%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Service Line</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 2% 1% 2%\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Preferred Days\n</label><md-select ng-model=\"vm.PPreferredDays\" ng-model-options=\"{trackBy: \'$value.names\'}\" id=\"searchmodule\" \nmd-on-close=\"vm.searchPreferre = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchPreferre\" type=\"text\" \nplaceholder=\"Search For Days..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PPreferredDays = null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Prefitems | filter:vm.searchPreferre\" \nng-value=\"row\">{{row.names}}</md-option></md-select></md-input-container><br><md-input-container flex><label>Team\n</label><md-select ng-model=\"vm.TeamList\" id=\"searchmodule\" ng-change=\"getTeamTable(vm.TeamList)\" \nmd-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchAssigned\" \ntype=\"text\" placeholder=\"Search For a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Team_id = null;vm.TM=null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">Pref Start Time :<p \nclass=\"dx-field-item-required-mark\">*</p></div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"PdateBox.PreferredStartTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">Pref End Time :<p \nclass=\"dx-field-item-required-mark\">*</p></div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"PdateBox.PreferredEndTime\"></div></div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><div \nclass=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">\nAvoid Start Time :</div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"PdateBox.AvoidStartTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Avoid End Time :</div>\n<div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div dx-date-box=\"PdateBox.AvoidEndTime\"></div></div>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" \nplaceholder=\"Estimated Man Hours Needed\" ng-model=\"vm.ManHour\"></md-input-container><br><md-input-container flex>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"SubmitSchedulerLine()\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 14px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/Editemobilelog.html","<md-dialog style=\"width:90%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Mobile Logs</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 2% 0% 2%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Photos</span>\n</md-tab-label><md-tab-body><br><span class=\"h4\" style=\"color:#7f9593\"><b>Team Members :</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.TeamName\" \nplaceholder=\"Team Name\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.TeamMembers\" placeholder=\"Team Members\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.TeamRemarks\" \nplaceholder=\"Remarks\"></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\"><b>Customer Review :</b></span>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.CompanyName\" \nplaceholder=\"Name\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"email\" \nng-model=\"vm.MobilEmailId\" placeholder=\"Email ID\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.CustomerRemarks\" \nplaceholder=\"Remarks\" readonly=\"readonly\"></md-input-container></div><div><div class=\"alert alert-success\"><div \nstyle=\"height: 40px\" star-rating rating=\"vm.starRating1\" read-only=\"true\" max-rating=\"5\" click=\"click1(param)\"></div>\n<div><span class=\"label label-primary\">Rating: {{vm.starRating1}}</span></div></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Infestation Level</span></md-tab-label><md-tab-body><br><md-input-container \nstyle=\"width:100%\" flex><md-radio-group ng-model=\"vm.MLSMPestType\"><div ng-repeat=\"row in Pestdatas\"><md-radio-button \nng-model=\"vm.ImgBPestType\" ng-value=\"row.PestName\" ng-click=\"vm.ImgBPestType = row.PestName;\" flex style=\"float:left\">\n{{row.PestName}}&emsp;</md-radio-button></div></md-radio-group></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Infestation Level</label><md-select ng-model=\"vm.MMaterialsName\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchM\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Materials..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.MMaterialsName=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Materialsdatas | filter:vm.searchM\" value=\"{{row.MaterialsName}}\">{{row.MaterialsName}}</md-option>\n</md-select></md-input-container></div><br><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.MLSMPestType || !vm.MMaterialsName\" ng-click=\"AddMobileLogMaterials()\">\nSubmit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"vm.MLSMPestType=null;vm.MMaterialsName=null;vm.MQuantity=null;vm.MUnit=null;vm.SMLMUpdate = false;\">Cancel\n</md-button></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table\n id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224)\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Infestation Level</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in TabletMaterialslistdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.MaterialName }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"MobileLogMaterialinfo(row)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Payment</span></md-tab-label><md-tab-body><span class=\"h4\" style=\"color:#7f9593\"><b>\nPayment Details :</b></span><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:18%\"><md-input-container flex><label>\nPayment Mode</label><md-select ng-model=\"vm.Paymentmethod\" name=\"PaymentTerms\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP = \'\'\"><md-select-header><input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Payment Mode..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Paymentmethod = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Totalpayment\" \nplaceholder=\"Total Payment\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.PaymentNotes\" placeholder=\"Payment Notes/Cheque No\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:18%\"><md-input-container flex><input type=\"text\" ng-model=\"vm.PaymentRemarks\" \nplaceholder=\"Payment Remarks\"></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\"><b>Area Details :</b>\n</span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.Totalarea\" \nplaceholder=\"Total Area Planned (Sq.Mt)\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.Totalcompleted\" placeholder=\"Total Area Completed (Sq.Mt)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"EditmobileSubmit()\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"cancel()\">Cancel\n</md-button></div><br></md-tab-body></md-tab><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nstyle=\"padding:1% 43% 1% 0;float:right\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"EditmobileSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n.md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 45px;\r\n  }\r\n\r\n  .md-datepicker .md-datepicker-input {\r\n    width: calc(35vw - 23px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n    color: black !important;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    width: calc(100% - 56px);\r\n  }\r\n\r\n  .md-default-theme .md-datepicker-input-mask-opaque,\r\n  .md-datepicker-input-mask-opaque {\r\n    left: 0px !important;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\r\n\r\n  #datepopup md-datepicker .md-datepicker-input {\r\n    width: calc(17vw - 15px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  .md-datepicker-input-container {\r\n    width: 133%;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-left: -8px;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n  }\r\n\r\n    #tb2 td:first-child:before {\r\n      counter-increment: serial-number; /* Increment the serial number counter */\r\n      content: counter(serial-number); /* Display the counter */\r\n    }\r\n\r\n  .md-button.md-fab {\r\n    z-index: 20;\r\n    line-height: 56px;\r\n    min-width: 0;\r\n    width: 56px;\r\n    height: 56px;\r\n    vertical-align: middle;\r\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\r\n    border-radius: 0%;\r\n    background-clip: padding-box;\r\n    overflow: hidden;\r\n    -webkit-transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n    -webkit-transition-property: background-color, box-shadow, -webkit-transform;\r\n    transition-property: background-color, box-shadow, -webkit-transform;\r\n    transition-property: background-color, box-shadow, transform;\r\n    transition-property: background-color, box-shadow, transform, -webkit-transform;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/GetCWC.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Details</span><md-input-container flex style=\"margin:0;margin-top:3%;flex:0.6\"><label \nstyle=\"color:white\">Search...</label><input id=\"forms-Detailsdt\" type=\"text\" \nstyle=\"border-bottom-color: white;color: white !important\"></md-input-container><md-button class=\"md-icon-button\" \nng-click=\"cancel();vm.ppCompanyName = \'\';vm.ppWorkOrder = \'\';vm.ppContractNo = \'\';vm.PestType = \'\';\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><md-dialog-content \nms-scroll style=\"padding:5px 10px 5px 10px\"><table id=\"Detailsdt\" class=\"table dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtdetails\" style=\"font-size:13px; border:1px solid rgb(224, 224, 224)\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Action</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Customer Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Work Order #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Types</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Preferred Date & Time</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Time Needed</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">End Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Urgent?</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in CWCDatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><md-radio-group ng-model=\"vm.SO\">\n<md-radio-button value=\"{{row.SalesOrderNo}}\" required \nng-click=\"SelectJobOrder(row._id);SelectContract(row.TotalOrderValue);GetCinfo(row.customerdetails[0]._id);vm.ppCompanyName = row.customerdetails[0].CompanyName;vm.Customersearch= row.customerdetails[0]._id;vm.jobdata = row._id;vm.ContractOrder = row.TotalOrderValue;vm.JobsPerFrequency = row.JobsPerFrequency;vm.ServicesRequired = row.ServicesRequired;vm.ppWorkOrder = row.SalesOrderNo;vm.ppContractNo = row.IsActive;vm.PreviewSpinner = true;vm.SpecialRemark = row.SpecialRemarks\" \nstyle=\"height:18px\"></md-radio-button></md-radio-group></td><td>{{row.customerdetails[0].CompanyName }}<br><div \nclass=\"label ng-binding ng-scope md-green-500-bg\">{{row.Status}}</div></td><td>{{ row.SalesOrderNo }}</td><td><ul \nng-repeat=\"rows in row.MultiFrequency\"><span>{{ rows.Frequency }} - {{ rows.PestType }}</span></ul></td><td>\n{{ row.DateTimeofTreatment }}</td><td>{{ row.EstimatedHoursRequired }}</td><td>\n{{ row.ServiceStartDate | date:\'dd/MM/y\' }}</td><td>{{ row.ServiceEndDate | date:\'dd/MM/y\' }}</td><td><md-icon \nmd-font-icon=\"icon-alert-circle\" ng-if=\"row.IsUrgent\" style=\"color: orangered\"></md-icon></td></tr></tbody></table><br>\n<span class=\"h3\" style=\"color:#7f9593\"><b>Service Address :</b></span><div class=\"white-bg md-whiteframe-4dp\"><div \nid=\"ServicegridContainer\" dx-data-grid=\"vm.dataGridCustomerService\"></div></div><br><div flex \nstyle=\"width:99%;padding-left:0.5%\"><span style=\"font-size:15px;color:#7f9593\"><b>\nNumber of Selected Service Addresses :</b></span> <span style=\"font-size:14px\">{{ServiceAddressarray.length}}</span>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"GetLatlong() ;vm.AssignedTo=null; vm.TM=null \" aria-label=\"Submit\" ng-disabled=\"ServiceAddressarray == \'\'\">Ok\n</md-button><md-button type=\"submit\" \nng-click=\"cancel();vm.ppCompanyName = \'\';vm.ppWorkOrder = \'\';vm.ppContractNo = \'\';vm.PestType = \'\';\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        height: 55px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 54px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    .dataTables_filter {\r\n        display: block !important;\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\r\n\r\n    .color-orange {\r\n        color: orange;\r\n    }\r\n\r\n    .dx-checkbox-icon {\r\n        border: 1px solid #606b73 !important;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n        background-color: #83878a !important;\r\n\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-row-lines>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-row-lines>tr>td {\r\n        border-bottom-color: #606a71;\r\n    }\r\n\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n    .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n        border-left-color: #606a71 !important;\r\n        border-right-color: #606a71 !important;\r\n    }\r\n\r\n\r\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n        color: #535858e6 !important;\r\n        font-weight: bold !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/MapView.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Map Location</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0.5% 1% 0.5% 1%\"><ng-map default-style=\"false\" center=\"{{CenterMapView}}\" zoom=\"12\" \nstyle=\"height:450px !important;display: block\"><info-window id=\"foo\" on-mouseover=\"vm.mouseover()\"><div \nng-non-bindable=\"\"><ul><li ng-repeat=\"item in vm.store.items\">Service Id:{{item.ServiceId}}<br>\nCustomer:{{item.Customer}}<br>Team : {{item.Team}}<br>Time : {{item.Time}}<br></li></ul></div></info-window><marker \nng-repeat=\"(id, store) in vm.stores\" id=\"{{id}}\" position=\"{{store.position}}\" on-click=\"vm.showStore(event, id)\">\n</marker></ng-map></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/scheduler/NewAdd.html","<md-dialog style=\"width:85%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Create Schedule for {{vm.ppCompanyName}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><md-tabs md-dynamic-height md-center-tabs=\"false\">\n<md-tab><md-tab-label><span>Add Schedule</span></md-tab-label><md-tab-body><br><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div flex><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:65px\"><md-input-container flex style=\"flex:0.3\"><input type=\"text\" \nng-model=\"vm.ppWorkOrder\" readonly=\"readonly\" style=\"font-size: 15px !important\" placeholder=\"Work Order\">\n</md-input-container><md-input-container flex style=\"flex:0.3\"><input type=\"text\" ng-model=\"vm.ppContractNo\" \nreadonly=\"readonly\" style=\"font-size: 15px !important\" placeholder=\"Contract #\"></md-input-container>\n<md-input-container flex style=\"flex:0.5\"><input type=\"text\" ng-model=\"vm.ppZone\" readonly=\"readonly\" \nstyle=\"font-size: 15px !important\" placeholder=\"Zone\"></md-input-container><md-input-container flex><label>\nFrequency & Pest Type</label><md-select ng-model=\"vm.PestType\" ng-change=\"CheckForFrequency(vm.PestType)\" \nid=\"searchmodule\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchPest\" type=\"text\" placeholder=\"Frequency & Pest Type..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.PestType = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchPest\" ng-value=\"row\">{{row.Frequency}} - {{row.PestName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex style=\"height:62px\">\n<md-input-container flex style=\"margin-bottom:0;flex: 0.4\"><label>Team</label><md-select ng-model=\"vm.AssignedTo\" \nid=\"searchmodule\" ng-change=\"getTeamTable(vm.AssignedTo)\" md-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.TM=null;vm.ppTeamName=null;vm.TeamEstimationHr=vm.EstimationHr\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" \nng-model=\"vm.TM\" placeholder=\"Team Members\" readonly=\"readonly\"></md-input-container><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.37\"><label>Job Type</label><md-select ng-model=\"vm.Types\" id=\"searchmodule\" \nmd-on-close=\"vm.searcTypes = \'\'\" required><md-select-header><input ng-model=\"vm.searcTypes\" type=\"text\" \nplaceholder=\"Search For a Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in JobTypesdatas | filter:vm.searcTypes\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex style=\"height:62px\"><md-input-container flex \nstyle=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.firstSpecialRemark\" placeholder=\"Remarks for first Service\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.Notes\" \nplaceholder=\"Neigbouring Jobs\"></md-input-container><md-input-container flex ng-if=\"vm.Twiceday!=null\"><label>\nDay for Twice a Week</label><md-select ng-model=\"vm.Twiceday\" id=\"searchmodule\" md-on-close=\"vm.searcTypes = \'\'\" \nrequired><md-select-header><input ng-model=\"vm.searcTypes\" type=\"text\" \nplaceholder=\"Select Other Day for \'Twice a Month\'..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Twiceday = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in dayitem2 | filter:vm.searcTypes\" ng-value=\"row\">{{row.names}}</md-option></md-select>\n</md-input-container></div><label style=\"width:21%;font-weight:bold;color:#7f9593\">Message to Operation</label>\n<text-angular ta-toolbar=\"none\" ng-model=\"vm.Message\"></text-angular><div class=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:23%;height:410px;border:1px solid rgb(224, 224, 224);float:left;padding-left: 10px\"><br>\n<md-input-container flex style=\"width: 100%\"><label>Preferred Days</label><md-select ng-model=\"vm.PreferredDays\" \nid=\"searchmodule\" md-on-close=\"vm.searchPreferre = \'\'\" required multiple=\"\"><md-select-header><input \nng-model=\"vm.searchPreferre\" type=\"text\" placeholder=\"Search For Days..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.PreferredDays = null;\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Prefitems | filter:vm.searchPreferre\" ng-value=\"row\">{{row.names}}</md-option></md-select>\n</md-input-container><br><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">Pref Start Time :<p \nclass=\"dx-field-item-required-mark\">*</p></div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"dateBox.PreferredStartTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">Pref End Time :<p \nclass=\"dx-field-item-required-mark\">*</p></div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"dateBox.PreferredEndTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold ; width: 50%\" class=\"dx-field-label\">Avoid Start Time :</div><div\n class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div dx-date-box=\"dateBox.AvoidStartTime\"></div></div>\n</div><div class=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" \nclass=\"dx-field-label\">Avoid End Time :</div><div class=\"dx-field-value\" style=\"width: 50%;padding-right: 5%\"><div \ndx-date-box=\"dateBox.AvoidEndTime\"></div></div></div></div><div class=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:41%;height:410px; border:1px solid rgb(224, 224, 224);float:left;padding: 10px 5px 0 20px\"><span \nstyle=\"color:#7f9593;padding-top:12px;padding-right: 22px\">Settings</span><br><div flex style=\"width:97%\"><span \nstyle=\"font-size:14px;font-style:italic;margin-top: -25px\">Action when service falls on public holiday?</span>\n<md-radio-container flex=\"15\" style=\"margin-top:-1px;margin-top: -25px\"><md-radio-group ng-model=\"vm.SFOPH\" \nlayout=\"row\" style=\"margin:0;margin-top:7px\"><md-radio-button value=\"Skip\">Skip</md-radio-button><md-radio-button \nvalue=\"Previous Day\">Previous Day</md-radio-button><md-radio-button value=\"Next Day\">Next Day</md-radio-button>\n</md-radio-group></md-radio-container></div><div flex style=\"width:97%;padding-top: 2%\"><md-radio-container flex=\"15\" \nstyle=\"margin-top:-1px;margin-top: -25px\"><md-radio-group ng-model=\"vm.JobType\" layout=\"row\" \nstyle=\"margin:0;margin-top:7px\"><md-radio-button value=\"Fixed\">Contract (Fixed)</md-radio-button><md-radio-button \nvalue=\"Contract\">Contract (Flexible)</md-radio-button><md-radio-button value=\"Ad-hoc\">Ad-hoc</md-radio-button>\n</md-radio-group></md-radio-container></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Site Address : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.SiteAddress}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Client Contact : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.uContactPerson}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Email :</span> <span \nstyle=\"font-size:15px;color:black\">{{vm.ClientEmail}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Site Contact Name : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.SiteContactName}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span\n style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Site Contact Number : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.SiteContactNumber}}</span></div><div style=\"color:#7f9593;padding-top:10px\">\n<span style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Coverage Area : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.CoverageArea}}</span></div><br></div><div class=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:13%;height:410px;border:1px solid rgb(224, 224, 224);float:left;padding-left: 10px\"><div \nstyle=\"color:#7f9593;padding-top:10px\"><span>Days</span></div><div flex ng-repeat=\"item in items\"><md-checkbox \nng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected, $event)\" \nng-disabled=\"selected.length == 1 && selected.indexOf(item) == -1\" \nstyle=\"padding: 0px 20px 0px 5px;margin:5px 0 5px 0\">{{ item.names }}</md-checkbox></div></div><div \nclass=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:22%;height:410px; border:1px solid rgb(224, 224, 224);float:left;padding: 10px 5px 0 10px\"><span \nstyle=\"color:#7f9593;padding-top:10px\">Dates</span><div layout=\"row\" layout-gt-xs=\"row\" style=\"width:100%;height:17%\">\n<label style=\"font-size:15px;color:#7f9593;font-weight: bold;padding-left: 0 !important;margin-top: 3%\">Start Date :\n</label><md-input-container flex style=\"margin-top: 0\"><md-datepicker ng-model=\"vm.ServiceStartAt\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\" \nstyle=\"width:100%;height:17%\"><label \nstyle=\"font-size:15px;color:#7f9593;padding-left: 0 !important;font-weight: bold;margin-top: 3%\">\nEnd Date&nbsp;&nbsp;&nbsp;:</label><md-input-container flex style=\"margin-top: 0\"><md-datepicker \nng-model=\"vm.ServiceEndAt\" md-date-format=\"dd/MM/y\" ng-change=\"getTeamTable(vm.AssignedTo)\"></md-datepicker>\n</md-input-container></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div\n class=\"dx-field-value\"><div dx-date-box=\"dateBox.ServiceStartTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">End Time :</div><div \nclass=\"dx-field-value\"><div dx-date-box=\"dateBox.ServiceEndTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold ; width:60%\" class=\"dx-field-label\">Man Hours:\n</div><div class=\"dx-field-label\" style=\"font-size:15px;color:#1d1f1e\">{{vm.EstimationHr}}</div></div><div \nclass=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold ; width:60%\" \nclass=\"dx-field-label\">Man hour per Tech:</div><div class=\"dx-field-label\" style=\"font-size:15px;color:#1d1f1e\">\n{{vm.TeamEstimationHr}}</div></div></div></div><br><div flex style=\"width:97%\" ng-if=\"Summary\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Description&nbsp;:</b></span> <span style=\"font-size:14px;font-style:italic\">\n{{Summary}}</span></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" style=\"padding:1% 43% 0 0;float:right\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sNewSubmit($event)\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || selected.length == 0 ||  !vm.ppCompanyName || !vm.PreferredStartTime || !vm.PreferredEndTime\">\nPreview</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Comments</span></md-tab-label><md-tab-body><div layout=\"column\"><div\n layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.NAddcomments\" placeholder=\"Comment Here..\">\n</md-input-container></div><div style=\"float: right;padding: 2%;\"><md-button class=\"md-raised md-accent\" \nng-click=\"NcommentSubmit()\" ng-disabled=\"!vm.NAddcomments\"><span>Save</span></md-button></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in NCommentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.CommentedBy }} @ {{ item.CreatedDate | date:\'dd/MM/y hh:mm a\'}}</h3><md-button \nstyle=\"position: absolute;left: 60%;margin: 0\" id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"DeleteComment(item._id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding><div flow-init=\"{singleFile: true}\" flow-name=\"uploader.flow\"><div \nid=\"attachmenthref\"><label for=\"file-input\" style=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\" style=\"float:right\"><span>Upload</span></md-button><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"font-size:smaller\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in NAttachmentdatas\"><td>\n&nbsp;</td><td><a \nhref=\"{{UploadsURL}}{{row.TableName==\'Operations\'?\'Operations/Scheduler\':\'CRM/SalesOrder\'}}/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeleteAttachment(row._id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\n.dx-field-item-required-mark {\r\n        color: #f74d61 !important;\r\n        margin: 0;\r\n        margin-left: 90%;\r\n        margin-top: -25px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-left: -8px;\r\n    }\r\n\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 97%;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    #attachmenthref label:hover {\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    .ms-scroll {\r\n        position: relative;\r\n    }\r\n\r\n    #viewsor:hover {\r\n        color: rgb(3, 155, 229) !important;\r\n        font-style: italic;\r\n        font-size: 14px;\r\n        cursor: pointer;\r\n\r\n    }\r\n\r\n    #viewsor {\r\n        color: rgb(148, 194, 218) !important;\r\n        font-style: italic;\r\n        font-size: 14px\r\n    }\r\n\r\n    #date1 .md-datepicker-input {\r\n        max-width: 100% !important;\r\n        min-width: 50% !important;\r\n        margin-left: -10px;\r\n    }\r\n\r\n    #date1 md-datepicker .md-datepicker-input {\r\n        width: calc(13vw - 20px);\r\n        max-width: calc(15vw - 20px);\r\n    }\r\n\r\n    label {\r\n        padding-left: 10px !important;\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    .ta-scroll-window>.ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/OnHoldPopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to On-Hold this service?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5% 2% 2% 2%\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex style=\"height:40px;margin:0\"><input type=\"text\" \nng-model=\"vm.OnHoldRemarks\" placeholder=\"Reason\" required></md-input-container></div><div class=\"navigation\" flex \nlayout=\"row\"><md-input-container><label>Reminder Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.OnHoldDate\"></md-datepicker></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"SubmitOnHold()\" class=\"md-raised md-accent\" \nng-disabled=\"eventForm.$invalid\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div>\n</md-dialog-content></form></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/OutStandingSelectedschedule.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.Title}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll ng-show=\"vm.Title == \'Reschedule\'\" \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-sm=\"column\" layout-align=\"center center\" \nng-show=\"vm.RescheduleSpinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span><b>Rescheduling...</b></span></div><div ng-show=\"vm.RescheduleSpinner == false\" flex><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span>\nAre you sure you want to reschedule {{OutstandingSelectedIds.length}} Services?</span></div><br><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label style=\"margin-right: 10px\">Reschedule Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ResheduleSFrom\" required></md-datepicker>\n</md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" \nid=\"datetime\" placeholder=\"Start Time\" show-todays-date=\"\" min-date=\"date\" ng-model=\"vm.ResheduleSSTime\" \nformat=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \nmdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"End Time\" show-todays-date=\"\" \nmin-date=\"date\" ng-model=\"vm.ResheduleSETime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"height:40px;margin:0px\"><input type=\"text\" ng-model=\"vm.ResheduleSRemarks\" placeholder=\"Remarks\" required>\n</md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox \nng-model=\"Reschedule.value\" type=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">\nSend email notification to the Technicians and Creator?</md-checkbox></md-input-container><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"OutstandingSubmitRescheduleSelected()\" \nng-disabled=\"!vm.ResheduleSRemarks\" class=\"md-raised md-accent\">Submit</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content><md-dialog-content ms-scroll \nng-show=\"vm.Title == \'Cancel\'\" style=\"padding:5px 20px 5px 20px\"><div layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.CancelSpinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span><b>Cancelling...</b></span></div><div \nng-show=\"vm.CancelSpinner == false\" flex><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span>\nAre you sure you want to cancel {{OutstandingSelectedIds.length}} Services?</span></div><br><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-input-container flex style=\"height:40px;margin:0px\"><input \ntype=\"text\" ng-model=\"vm.CancelSRemarks\" placeholder=\"Remarks\" required></md-input-container></div><md-input-container \nflex style=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox \nng-model=\"Cancel.value\" type=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">\nSend email notification to the Technicians and Creator?</md-checkbox></md-input-container><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"OutstandingSubmitCancelSelected()\" \nng-disabled=\"!vm.CancelSRemarks\" class=\"md-raised md-accent\">Submit</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  .md-datepicker-input-container {\r\n    width: 90%;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    width: calc(100% - 45px);\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 45px;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/PreviewAlert.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.RemovePTitle}}\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nng-show=\"vm.RemovePData == \'ReschedulePData\'\" style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label style=\"margin-right: 10px\">Reshedule Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.RPDservicat\" required></md-datepicker>\n</md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" \nid=\"datetime\" placeholder=\"Start Time\" show-todays-date=\"\" min-date=\"date\" ng-model=\"vm.RPDservicStime\" \nformat=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \nmdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"End Time\" show-todays-date=\"\" \nmin-date=\"date\" ng-model=\"vm.RPDservicEtime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"ReSchedulePData(vm.RemovePindex)\" ng-disabled=\"!vm.RPDservicat\" class=\"md-raised md-accent\">Submit\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div><br></md-dialog-content>\n<md-dialog-content ms-scroll ng-show=\"vm.RemovePData == \'RemovePData\'\" style=\"padding:5px 20px 5px 20px\"><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span>Are you sure you want to remove this service?\n</span></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nng-click=\"RemovePData(vm.RemovePindex)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/PreviewforReschedule.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Preview</span></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Work Order&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppWorkOrder}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppContractNo}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Team Name&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppTeamName}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Number of Service Addresses &nbsp;</b></span> <span style=\"font-size:14px\"><b>:\n</b>&nbsp;&nbsp;{{ServiceAddressarray.length}}</span></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>\nService Address&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>&nbsp;&nbsp;{{previewdatas[0].Location}}</span>\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>\nJob Type&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{previewdatas[0].JobType ==\'Contract\' ? \'Flexible\' : previewdatas[0].JobType}}</span></md-input-container>\n</div><br><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainerforReschedule\" \ndx-data-grid=\"vm.dataGridOptionsforReschdule\"></div></div><br><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"PreviewRescheduleConfirm()\" aria-label=\"Submit\">Confirm</md-button><md-button type=\"submit\" \nng-click=\"ReDo()\" class=\"md-raised\">Re-Do</md-button></div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\n        height: 55px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        min-height: 54px;\n        border: 1px solid rgba(0, 0, 0, 0.12);\n        border-top: none;\n        font-size: 13px;\n        padding: 0;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        /* justify-content: space-between; */\n    }\n\n    .dx-toolbar-label>div {\n        display: none !important;\n    }\n\n    .color-red {\n        color: red;\n    }\n\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\n        color: #535858e6 !important;\n        font-weight: bold !important;\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/Previewschedule.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Preview</span></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Work Order&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppWorkOrder}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Contract&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppContractNo}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Team Name&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppTeamName}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Number of Service Addresses &nbsp;</b></span> <span style=\"font-size:14px\"><b>:\n</b>&nbsp;&nbsp;{{ServiceAddressarray.length}}</span></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>\nService Address&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>&nbsp;&nbsp;{{previewdatas[0].Location}}</span>\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>\nJob Type&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{previewdatas[0].JobType ==\'Contract\' ? \'Flexible\' : previewdatas[0].JobType}}</span></md-input-container>\n</div><br><div class=\"white-bg md-whiteframe-4dp\"><div id=\"gridContainer\" dx-data-grid=\"vm.dataGridOptions\"></div>\n</div><br><span style=\"font-size:13.5px\">There are [{{vm.DuplicateCount}}] number of service jobs found duplicate\n</span><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><md-checkbox \nstyle=\"margin:0\" ng-model=\"vm.ShowDuplicate\" ng-change=\"ShowDuplicate(vm.ShowDuplicate)\" type=\"checkbox\">\nShow Duplicate(s) Only</md-checkbox></md-input-container><md-input-container flex style=\"margin-bottom:0\"><md-checkbox \nstyle=\"margin:0\" ng-model=\"vm.RemoveDuplicate\" type=\"checkbox\">Discard Duplicate(s)</md-checkbox></md-input-container>\n<md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>Orange :</b></span> \n<span style=\"font-size:13.5px\">Same team assigned to other Fixed jobs during this time</span></md-input-container>\n<md-input-container flex style=\"margin-bottom:0\"><span style=\"font-size:15px;color:#7f9593\"><b>Green :</b></span> <span\n style=\"font-size:13.5px\">Same Team assigned for other jobs</span></md-input-container></div><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"PreviewConfirm()\" aria-label=\"Submit\">\nConfirm</md-button><md-button type=\"submit\" ng-click=\"ReDo()\" class=\"md-raised\">Re-Do</md-button></div>\n</md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        height: 55px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 54px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    .dx-toolbar-label>div {\r\n        display: none !important;\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\r\n\r\n    .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n        color: #535858e6 !important;\r\n        font-weight: bold !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/PublicHolidays.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"font-size:13px; border:1px solid rgb(224, 224, 224)\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Event Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Title</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">End Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PHDetailsdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{row.EventType }}</td><td>{{row.EventTitle}}</td><td>\n{{row.Description}}</td><td>{{row.StartDate | date:\'dd/MM/y\'}}</td><td>{{row.EndDate | date:\'dd/MM/y\'}}</td></tr>\n</tbody></table></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 64px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ReportEdit.html","<md-dialog \nng-class=\"{ \'widther\': vm.ReportEditType == \'Edit Report\' ,\'widthpa\': vm.ReportEditType == \'Photo After\' ,\r\n  \'widthpb\': vm.ReportEditType == \'Photo Before\' ,\'widthservice\': vm.ReportEditType == \'Services\' , \r\n  \'widthmaterial\' :  vm.ReportEditType == \'Materials\',\'widthSiteCard\' :  vm.ReportEditType == \'Edit Site Card\' , \'widthmaterial\': vm.ReportEditType == \'Edit Infestation\'}\" \nstyle=\"overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate \nng-if=\"vm.ReportEditType == \'Services\'\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.ReportEditTtlte}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel();\r\n                               \" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Pest Types\n</label><md-select ng-model=\"vm.SMPestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.Servicetype\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" type=\"text\" \nplaceholder=\"Search For a Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SMPestType = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermC\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Services</label>\n<md-select ng-model=\"vm.MServicetype\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.Servicetype\'}\" \nmd-on-close=\"vm.searchTermC = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTermC\" type=\"text\" \nplaceholder=\"Search For a Services..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.MServicetype = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Servicesdatas | filter:vm.searchTermC\" ng-value=\"row\">{{row.Servicetype}}</md-option></md-select>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitServicesReport()\" \nng-disabled=\"!vm.SMPestType || !vm.MServicetype\" aria-label=\"Submit\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel();\" class=\"md-raised\">Cancel</md-button></div></md-dialog-content></form><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-if=\"vm.ReportEditType == \'Materials\'\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.ReportEditTtlte}}\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\" ng-repeat=\"row in Pestdatas\">\n<md-input-container style=\"width: 18%;margin-top: 2.7%\"><label style=\"font-size:15px;color:#7f9593;font-weight: bold\">\n{{row.PestType}} :</label></md-input-container><md-input-container flex><label>Infestation Level</label><md-select \nng-model=\"vm.MUnit\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-option value=\"Nil\">Nil</md-option><md-option \nvalue=\"Low\">Low</md-option><md-option value=\"Medium\">Medium</md-option><md-option value=\"High\">High</md-option>\n</md-select></md-input-container><md-input-container style=\"width: 18%;margin-top: 2.7%\"><label \nstyle=\"font-size:15px;color:#7f9593;font-weight: bold\">Adult Mosquito :</label></md-input-container><md-input-container\n flex><label>Infestation Level</label><md-select ng-model=\"vm.MUnit\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\">\n<md-option value=\"Nil\">Nil</md-option><md-option value=\"Low\">Low</md-option><md-option value=\"Medium\">Medium\n</md-option><md-option value=\"High\">High</md-option></md-select></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitMaterialsReport()\" \naria-label=\"Submit\" ng-disabled=\"!vm.MLSMPestType || !vm.MMaterialsName\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel();\" class=\"md-raised\">Cancel</md-button></div></md-dialog-content></form><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-if=\"vm.ReportEditType == \'Photo Before\'\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.ReportEditTtlte}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\"><div style=\"padding-left:0px\"><div \nflow-file-added=\"!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\" flow-name=\"vm.flow\" flow-init=\"{singleFile:true}\">\n<fieldset ng-disabled=\"!vm.ImgBPestType\"><md-button ng-show=\"!$flow.files.length\" class=\"md-raised md-primary\" \nstyle=\"margin-left: 2px\"><label style=\"font-size: 13px !important;padding-left: 0px !important;margin-bottom:0\" \nfor=\"selectb\">Select</label><input class=\"file-input\" flow-btn id=\"selectb\" type=\"file\" ng-show=\"!$flow.files.length\">\n</md-button><md-button ng-show=\"$flow.files.length\" class=\"md-raised md-accent\"><label \nstyle=\"font-size: 13px !important;padding-left: 0px !important;margin-bottom:0\" for=\"changeb\">Change</label><input \nclass=\"file-input\" flow-btn id=\"changeb\" ng-hide=\"$flow.files.length\"></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"UploadPhotoBefore($flow);\"><span>Upload</span></md-button></fieldset><div \nng-show=\"$flow.files.length\" style=\"padding-top: 2%\" flex><img flow-img=\"$flow.files[0]\" \nstyle=\"height:180px; width:280px\" id=\"CPB1\" ng-model=\"uCPB\"><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"vm.ImgBRemarks\" placeholder=\"Remarks\"></md-input-container></div><div ng-show=\"!$flow.files.length\"><img \nng-if=\"uCPB\" style=\"height:180px; width:280px\" data-ng-src=\"{{uCPB}}\"> <img ng-hide=\"uCPB\" \nstyle=\"height:180px; width:280px\" data-ng-src=\"../../../../../../assets/images/logos/Noimage.png\" alt=\"\">\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"vm.ImgBRemarks\" placeholder=\"Remarks\">\n</md-input-container></div></div></div></div><br><table id=\"tb2\" class=\"dataTable row-border hover\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Photo</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Edit</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Photosdatas\"><td>\n&nbsp;</td><td style=\"width:10%\"><img data-ng-src=\"{{row.Path}}\" title=\"Zoom Image\" \nstyle=\"width:100%;height:50px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"UpdatePhotosBeforeReport(row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"DeletePhotosBeforeReport(row.id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></md-dialog-content></form><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-if=\"vm.ReportEditType == \'Photo After\'\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.ReportEditTtlte}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><md-input-container style=\"width:100%\" flex><md-radio-group \nng-model=\"vm.ImgAPestType\"><div ng-repeat=\"row in Pestdatas\"><md-radio-button ng-model=\"vm.ImgAPestType\" \nng-value=\"row.PestName\" ng-click=\"vm.ImgAPestType = row.PestName;\" flex style=\"float:left\">{{row.PestName}}&emsp;\n</md-radio-button></div></md-radio-group></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><div \nstyle=\"padding-left:0px\"><div flow-file-added=\"!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\" \nflow-init=\"{singleFile:true}\"><div><md-button ng-show=\"!$flow.files.length\" class=\"md-raised md-primary\" \nstyle=\"margin-left: 2px\"><label style=\"font-size: 13px !important;padding-left: 0px !important;margin-bottom:0\" \nfor=\"selects\">Select</label><input class=\"file-input\" flow-btn id=\"selects\" type=\"file\" ng-show=\"!$flow.files.length\">\n</md-button><md-button ng-show=\"$flow.files.length\" class=\"md-raised md-accent\"><label \nstyle=\"font-size: 13px !important;padding-left: 0px !important;margin-bottom:0\" for=\"changes\">Select</label><input \nclass=\"file-input\" flow-btn id=\"changes\" ng-hide=\"$flow.files.length\"></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"UploadPhoto();$flow.cancel();\"><span>Upload</span></md-button></div><div \nng-show=\"$flow.files.length\"><img flow-img=\"$flow.files[0]\" style=\"height:220px; width:380px\" id=\"CP1\" ng-model=\"uCP\">\n<md-input-container flex><label>Remarks</label><md-select ng-model=\"vm.ImgARemarks\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.Name\'}\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchremark\" type=\"text\" placeholder=\"Search Remarks..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchremark = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Remarksdatas | filter:vm.searchremark\" ng-value=\"row\">{{row.Name}}</md-option></md-select>\n</md-input-container></div><div ng-show=\"!$flow.files.length\"><img ng-if=\"uCP\" style=\"height:220px; width:380px\" \ndata-ng-src=\"{{uCP}}\"> <img ng-hide=\"uCP\" style=\"height:220px; width:380px\" \ndata-ng-src=\"../../../../../../assets/images/logos/Noimage.png\" alt=\"\"><md-input-container flex ng-if=\"uCP\"><label>\nRemarks</label><md-select ng-model=\"vm.ImgARemarks\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.Name\'}\" \nmd-on-close=\"vm.searchPest = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchremark\" type=\"text\" \nplaceholder=\"Search Remarks..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.searchremark = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Remarksdatas | filter:vm.searchremark\" \nng-value=\"row\">{{row.Name}}</md-option></md-select></md-input-container></div></div></div></div><br><table id=\"tb2\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Photo</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Edit</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PhotosAdatas\"><td>\n&nbsp;</td><td>{{ row.PestType }}</td><td style=\"width:10%\"><img data-ng-src=\"{{row.Path}}\" title=\"Zoom Image\" \nstyle=\"width:100%;height:50px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"></td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"UpdatePhotosAfterReport(row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"DeletePhotosBeforeReport(row._id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></md-dialog-content></form><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-if=\"vm.ReportEditType == \'Edit Report\'\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.ReportEditTtlte}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Serive Type\n</label><md-select ng-model=\"vm.Types\" id=\"searchmodule\" md-on-close=\"vm.searchjb = \'\'\" required><md-select-header>\n<input style=\"flex: auto\" ng-model=\"vm.searchjb\" type=\"text\" placeholder=\"Type..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.Types = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in JobTypesdatas | filter:vm.searchjb\" value=\"{{row.Name}}\">{{row.Name}}\n</md-option></md-select></md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" \ntime=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Actual Time In \" show-todays-date=\"\" min-date=\"date\" \nng-model=\"vm.ATimeIn\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Time Out \" \nshow-todays-date=\"\" min-date=\"date\" ng-model=\"vm.ATimeOut\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:18%\"><md-input-container flex><label>\nPayment Mode</label><md-select ng-model=\"vm.Paymentmethod\" name=\"PaymentTerms\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP = \'\'\"><md-select-header><input ng-model=\"vm.searchTermPm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Payment Mode..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Paymentmethod = null;vm.searchTermPm = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PaymentModedatas | filter:vm.searchTermPm\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Totalpayment\" \nplaceholder=\"Total Payment\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.PaymentNotes\" placeholder=\"Payment Notes/Cheque No\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Totalarea\" placeholder=\"Total Area Planned (Sq.Mt)\"></md-input-container><md-input-container\n flex><input type=\"number\" ng-model=\"vm.Totalcompleted\" placeholder=\"Total Area Completed (Sq.Mt)\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"0.5\" \nstyle=\"padding-top: 0.5%\"><span>Breeding Found? :</span></md-input-container><md-input-container flex \nstyle=\"padding-left:1%;padding-right:2%\"><md-radio-group ng-model=\"vm.BreedingFound\" layout=\"row\" style=\"margin:0\">\n<md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex=\"0.5\" style=\"padding-top: 0.5%\" ng-if=\"vm.BreedingFound == \'Yes\'\"><span>\nSpecies? :</span></md-input-container><md-input-container flex style=\"padding-left:1%;padding-right:2%\" \nng-if=\"vm.BreedingFound == \'Yes\'\"><md-radio-group ng-model=\"vm.Species\" layout=\"row\" style=\"margin:0\"><md-radio-button \nvalue=\"AEDES\">AEDES</md-radio-button><md-radio-button value=\"CULEX\">CULEX</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex=\"0.5\" style=\"padding-top:0.5\" ng-if=\"vm.BreedingFound == \'Yes\'\"><span>\nFindings? :</span></md-input-container><md-input-container flex style=\"padding-left:1%;padding-right:2%\" \nng-if=\"vm.BreedingFound == \'Yes\'\"><md-radio-group ng-model=\"vm.Findings\" layout=\"row\" style=\"margin:0\"><md-radio-button\n value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex ng-if=\"vm.BreedingFound == \'Yes\'\">\n<md-input-container style=\"padding-top: 0.5%\"><span>Misting Carried Out? :</span></md-input-container>\n<md-input-container style=\"padding-left:1%;padding-right:2%;flex :0.63\"><md-radio-group ng-model=\"vm.MistingCariedOut\" \nlayout=\"row\" style=\"margin:0\"><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No\n</md-radio-button></md-radio-group></md-input-container><md-input-container flex ng-if=\"vm.BreedingFound == \'Yes\'\">\n<input type=\"number\" ng-model=\"vm.Density\" placeholder=\"Density...\"><p ng-if=\"vm.Density > 999\" \nstyle=\"color:red;font-size:13px\">Density should be less than 999.</p></md-input-container><md-input-container flex \nng-if=\"vm.BreedingFound == \'Yes\'\"><label>Instar</label><md-select ng-model=\"vm.Instar\" id=\"searchmodule\">\n<md-select-header><span ng-model=\"vm.searchV\" style=\"flex: auto\" type=\"text\" placeholder=\"Instar..\" \nng-keydown=\"$event.stopPropagation()\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.Vehicle = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"Pupa\">Pupa\n</md-option></md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SubmitEditReport()\" aria-label=\"Submit\" ng-disabled=\"!vm.TeamName || !vm.PerformedBy  || !vm.CoTechnicians\">\nSubmit</md-button><md-button type=\"submit\" ng-click=\"cancel();\" class=\"md-raised\">Cancel</md-button></div>\n</md-dialog-content></form><form name=\"eventForm\" class=\"md-inline-form\" novalidate \nng-if=\"vm.ReportEditType == \'Edit Site Card\'\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.ReportEditTtlte}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><md-tabs \nmd-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Job Plan ({{vm.SalesOrderNo}})</span>\n</md-tab-label><md-tab-body><br><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Pest Types\n</label><md-select ng-model=\"vm.JPestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nmd-on-close=\"vm.searchPest = \'\'\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Pest Type\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pesttypedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"flex: 0.62\"><label>AG No</label><md-select ng-model=\"vm.JAGNO\" \nid=\"searchmodule\" md-on-close=\"vm.searchAg = \'\'\"><md-select-header><input ng-model=\"vm.searchAg\" type=\"text\" \nplaceholder=\"Search Agreement No\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.JAGNO = null;vm.searchAg = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Agreementdatas | filter:vm.searchAg\" ng-click=\"vm.AgreNum=row.AGNO\" value=\"{{row._id}}\">{{row.AGNO}}\n</md-option></md-select></md-input-container><md-input-container flex><label>Sales Person</label><md-select \nng-model=\"vm.TechPersons\" id=\"searchmodule\" md-on-close=\"vm.searchEmployee = \'\'\"><md-select-header><input \nng-model=\"vm.searchEmployee\" type=\"text\" placeholder=\"Sales Person\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.TechPersons = null;vm.searchEmployee = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchEmployee\" value=\"{{row.id}}\">\n{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPO No</label><md-select ng-model=\"vm.JPONO\" id=\"searchmodule\" md-on-close=\"vm.searchAg = \'\'\"><md-select-header><input \nng-model=\"vm.searchAg\" type=\"text\" placeholder=\"Search PO No\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.JPONO = null;vm.searchAg = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PoCarddatas | filter:vm.searchTermC\" value=\"{{row.PONo}}\">{{row.PONo}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Job Type\n</label><md-select ng-model=\"vm.JobType\" id=\"searchmodule\" md-on-close=\"vm.searchTermJ = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchTermJ\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Job Type...\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.JobType = null ;searchTermJ=\'\'\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in JobTypesdatas | filter:vm.searchTermJ\" value=\"{{row.Name}}\">\n{{row.Name}}</md-option></md-select></md-input-container><md-input-container flex style=\"flex:0.5\"><input \ntype=\"number\" ng-model=\"vm.Amount\" ng-change=\"calculateAmountGST(vm.Amount,vm.GST)\" placeholder=\"Amount\">\n</md-input-container><md-input-container flex style=\"flex:0.4\"><label>GST %</label><input type=\"number\" \nng-model=\"vm.GST\" ng-change=\"calculateAmountGST(vm.Amount,vm.GST)\"></md-input-container><md-input-container flex \nstyle=\"flex:0.5\"><label>Amount included GST</label><input type=\"number\" ng-model=\"vm.AmountGST\"></md-input-container>\n<md-radio-container flex><md-radio-group ng-model=\"vm.CollectPayment\" layout=\"row\"><span \nstyle=\"color:#7f9593;margin-top: 1.9%\" style=\"color:#7f9593\">Collect Payment? &nbsp; :</span><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group></md-radio-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.JobDescription\" placeholder=\"Job Description\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.JobDetails\" \nplaceholder=\"Job Details\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex \nstyle=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.JobNotes\" placeholder=\"Job Notes\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-input-container \nflex><input type=\"text\" ng-model=\"vm.Notes\" placeholder=\"Notes\"></md-input-container></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>Site Card ({{vm.SiteCardNo}})</span></md-tab-label><md-tab-body><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.SiteName\" placeholder=\"Site Name\">\n</md-input-container><md-input-container flex style=\"flex:0.5\"><input type=\"tel\" ng-model=\"vm.PostalCode\" \nplaceholder=\"Postal Code\"></md-input-container><md-input-container flex style=\"margin-bottom:0\"><label>Address</label>\n<input places-auto-complete types=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\" ng-model=\"vm.Address\" placeholder=\"\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-input-container \nflex><input type=\"text\" ng-model=\"vm.ContactPerson\" placeholder=\"ContactPerson\"></md-input-container>\n<md-input-container flex><input type=\"tel\" ng-model=\"vm.Phone1\" placeholder=\"Phone #1\"></md-input-container>\n<md-input-container flex><input type=\"tel\" ng-model=\"vm.Phone2\" placeholder=\"Phone #2\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-input-container flex style=\"flex:0.5\"><input \ntype=\"tel\" ng-model=\"vm.Mobile\" placeholder=\"Mobile\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.Email\" placeholder=\"Email\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex \nstyle=\"margin-top: -27px\"><md-input-container flex style=\"flex:0.5\"><input type=\"text\" ng-model=\"vm.ServiceArea\" \nplaceholder=\"Service Area\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.AreaSize\" \nplaceholder=\"Area Size (Sq Mtrs)\"></md-input-container></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nAdditional Details</span></md-tab-label><md-tab-body><br><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><label>Work Type</label><md-select ng-model=\"vm.WorkType\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermCu = \'\'\"><md-select-header><input ng-model=\"vm.searchTermCu\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search Work Type...\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.WorkType = null ;searchTermCu=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in WorkTypedatas | filter:vm.searchTermCu\" value=\"{{row.Codes}}\">{{row.Codes}}-{{row.Names}}</md-option>\n</md-select></md-input-container><md-button style=\"margin: 12px -8px; margin-right: 4px\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"AddWorkType($event)\"><md-icon\n md-font-icon=\"icon-tooltip-outline-plus\"></md-icon></md-button><md-radio-container flex><md-radio-group \nstyle=\"margin-left: 5%\" ng-model=\"vm.PostPre\" layout=\"row\"><span style=\"color:#7f9593;margin-top: 1%\" \nstyle=\"color:#7f9593\">Types &nbsp;</span><md-radio-button value=\"Post\">Post</md-radio-button><md-radio-button \nvalue=\"Pre\">Pre</md-radio-button></md-radio-group></md-radio-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NavJobNo\" placeholder=\"New @ Nav Job No\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NavJobTaskNo\" placeholder=\"New @ Nav Job Task No\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-radio-container flex><md-radio-group style=\"margin-left: 5%\" \nng-model=\"vm.PosttoNAV\" layout=\"row\"><span style=\"color:#7f9593;margin-top: 2%;margin-left: -4%\" style=\"color:#7f9593\">\nPost to NAV?&nbsp;&nbsp;&nbsp; &nbsp;</span><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button \nvalue=\"No\">No</md-radio-button></md-radio-group></md-radio-container><md-input-container flex><label>Posting Date\n</label><md-select ng-model=\"vm.PostingDate\" id=\"searchmodule\" md-on-close=\"vm.searchTermCu = \'\'\"><md-select-header>\n<input ng-model=\"vm.searchTermCu\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Posting Date...\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PostingDate = null ;searchTermCu=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in PostingDatedatas | filter:vm.searchTermCu\" value=\"{{row.PDate}}\">{{row.PDate}}-{{row.Description}}\n</md-option></md-select></md-input-container><md-button style=\"margin: 12px -8px; margin-right: 4px\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"AddPostingDate($event)\">\n<md-icon md-font-icon=\"icon-tooltip-outline-plus\"></md-icon></md-button><md-input-container flex><input type=\"text\" \nng-model=\"vm.ExportFrequency\" placeholder=\"Posting Description\" maxlength=\"44\"></md-input-container><md-input-container\n flex><label>Resource Code</label><md-select ng-model=\"vm.ExportCutOffDate\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermCu = \'\'\"><md-select-header><input ng-model=\"vm.searchTermCu\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search Resource Code...\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ExportCutOffDate = null ;searchTermCu=\'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Resourcedatas | filter:vm.searchTermCu\" value=\"{{row.Code}}\">{{row.Code}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: -27px\"><md-radio-container \nflex><md-radio-group style=\"margin-left: 5%\" ng-model=\"vm.SubmitNEA\" layout=\"row\"><span \nstyle=\"color:#7f9593;margin-top: 1%;margin-left: -4%;width: 111.86px\" style=\"color:#7f9593\">\nSubmit NEA/SCDF?&nbsp;&nbsp; &nbsp;</span><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button \nvalue=\"No\">No</md-radio-button></md-radio-group></md-radio-container><md-radio-container flex><md-radio-group \nng-model=\"vm.BatchEmail\" layout=\"row\"><span style=\"color:#7f9593;margin-top: 1%\" style=\"color:#7f9593\">\nBatch Email? &nbsp;</span><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No\n</md-radio-button></md-radio-group></md-radio-container><md-input-container flex><label>Batch Code</label><md-select \nng-model=\"vm.BatchCode\" id=\"searchmodule\" md-on-close=\"vm.searchTermC = \'\'\" ng-disabled=\"vm.BatchEmail==\'No\'\">\n<md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Batch Email...\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.BatchCode = null ;searchTermC=\'\'\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in BatchMaildatas\" value=\"{{row.BatchCode}}\">{{row.BatchCode}}</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.OldNavCONNo\" \nplaceholder=\"OldNav CON No\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"SubmitJobPlan()\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\">Cancel</md-button></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></form><form name=\"eventForm\" class=\"md-inline-form\" novalidate \nng-if=\"vm.ReportEditType == \'Edit Infestation\'\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.ReportEditTtlte}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div layout=\"row\" \nlayout-sm=\"column\"><table style=\"float:left;width: 100%\"><tr ng-repeat=\"item in InfestationPest\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{item.PestType}}</td><td><md-input-container flex \nstyle=\"margin-bottom:0\"><md-select ng-model=\"item.InvestationLevel\" id=\"searchmodule\" md-on-close=\"vm.searcTypes = \'\'\">\n<md-option ng-repeat=\"row in InfestationLevel\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container></td></tr></table><br></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SubmitInfestation()\" aria-label=\"Submit\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel();\" \nclass=\"md-raised\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  .widthservice {\r\n    width: 60% !important;\r\n  }\r\n\r\n  .widthmaterial {\r\n    width: 60% !important;\r\n  }\r\n\r\n  .widthpa {\r\n    width: 80% !important;\r\n  }\r\n\r\n  .widthpb {\r\n    width: 80% !important;\r\n  }\r\n\r\n  .widther {\r\n    width: 80% !important;\r\n  }\r\n\r\n  .widthSiteCard {\r\n    width: 80% !important;\r\n\r\n  }\r\n\r\n  .md-inline-form md-radio-group md-radio-button {\r\n    display: inline-block;\r\n    height: 30px;\r\n    padding: 5px 0 0 0;\r\n    box-sizing: border-box;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/RescheduleNewAdd.html","<md-dialog style=\"width:65%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Re-Schedule for {{vm.ppCompanyName}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><md-tabs md-dynamic-height md-center-tabs=\"false\">\n<md-tab><md-tab-label><span>Re-Schedule</span></md-tab-label><md-tab-body><br><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div flex><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:65px\"><md-input-container flex style=\"flex:0.3\"><input type=\"text\" \nng-model=\"vm.ppWorkOrder\" readonly=\"readonly\" style=\"font-size: 15px !important\" placeholder=\"Work Order\">\n</md-input-container><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.TM\" \nplaceholder=\"Team Members\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nstyle=\"height:62px\"><md-input-container flex ng-if=\"vm.Twiceday!=null\"><label>Day for Twice a Week</label><md-select \nng-model=\"vm.Twiceday\" id=\"searchmodule\" md-on-close=\"vm.searcTypes = \'\'\" required><md-select-header><input \nng-model=\"vm.searcTypes\" type=\"text\" placeholder=\"Select Other Day for \'Twice a Month\'..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Twiceday = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in dayitem2 | filter:vm.searcTypes\" ng-value=\"row\">{{row.names}}</md-option></md-select>\n</md-input-container></div><div class=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:40%;height:410px; border:1px solid rgb(224, 224, 224);float:left;padding: 10px 5px 0 20px\"><span \nstyle=\"color:#7f9593;padding-top:12px;padding-right: 22px\">Settings</span><br><div flex style=\"width:97%\"><span \nstyle=\"font-size:14px;font-style:italic;margin-top: -25px\">Action when service falls on public holiday?</span>\n<md-radio-container flex=\"15\" style=\"margin-top:-1px;margin-top: -25px\"><md-radio-group ng-model=\"vm.SFOPH\" \nlayout=\"row\" style=\"margin:0;margin-top:7px\"><md-radio-button value=\"Skip\">Skip</md-radio-button><md-radio-button \nvalue=\"Previous Day\">Previous Day</md-radio-button><md-radio-button value=\"Next Day\">Next Day</md-radio-button>\n</md-radio-group></md-radio-container></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Site Address : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.SiteAddress}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Client Contact : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.uContactPerson}}</span></div><div style=\"color:#7f9593;padding-top:10px\"><span \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\">Site Contact Number : </span><span \nstyle=\"font-size:15px;color:black\">{{vm.SiteContactNumber}}</span></div><br></div><div \nclass=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:20%;height:410px;border:1px solid rgb(224, 224, 224);float:left;padding-left: 10px\"><div \nstyle=\"color:#7f9593;padding-top:10px\"><span>Days</span></div><div flex ng-repeat=\"item in items\"><md-checkbox \nng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected, $event)\" \nng-disabled=\"selected.length == 1 && selected.indexOf(item) == -1\" \nstyle=\"padding: 0px 20px 0px 5px;margin:5px 0 5px 0\">{{ item.names }}</md-checkbox></div></div><div \nclass=\"white-bg md-whiteframe-1dp\" \nstyle=\"width:40%;height:410px; border:1px solid rgb(224, 224, 224);float:left;padding: 10px 5px 0 10px\"><span \nstyle=\"color:#7f9593;padding-top:10px\">Dates</span><div layout=\"row\" layout-gt-xs=\"row\" style=\"width:100%;height:17%\">\n<label style=\"font-size:15px;color:#7f9593;font-weight: bold;padding-left: 0 !important;margin-top: 3%\">Start Date :\n</label><md-input-container flex style=\"margin-top: 0\"><md-datepicker ng-model=\"vm.ServiceStartAt\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout=\"row\" layout-gt-xs=\"row\" \nstyle=\"width:100%;height:17%\"><label \nstyle=\"font-size:15px;color:#7f9593;padding-left: 0 !important;font-weight: bold;margin-top: 3%\">\nEnd Date&nbsp;&nbsp;&nbsp;:</label><md-input-container flex style=\"margin-top: 0\"><md-datepicker \nng-model=\"vm.ServiceEndAt\" md-date-format=\"dd/MM/y\" ng-change=\"getTeamTable(vm.AssignedTo)\"></md-datepicker>\n</md-input-container></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div\n class=\"dx-field-value\"><div dx-date-box=\"dateBox.ServiceStartTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">End Time :</div><div \nclass=\"dx-field-value\"><div dx-date-box=\"dateBox.ServiceEndTime\"></div></div></div></div></div><br><div flex \nstyle=\"width:97%\" ng-if=\"Summary\"><span style=\"font-size:15px;color:#7f9593\"><b>Description&nbsp;:</b></span> <span \nstyle=\"font-size:14px;font-style:italic\">{{Summary}}</span></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nstyle=\"padding:1% 43% 0 0;float:right\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sNewSubmitforReschedule($event)\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || selected.length == 0 ||  !vm.ppCompanyName\">Preview</md-button>\n<md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content></form></md-dialog><style>\n.dx-field-item-required-mark {\n        color: #f74d61 !important;\n        margin: 0;\n        margin-left: 90%;\n        margin-top: -25px;\n    }\n\n    .md-datepicker-button {\n        display: none;\n    }\n\n    md-optgroup label {\n        display: block;\n        font-size: 14px;\n        text-transform: uppercase;\n        padding: 0;\n        font-weight: 500;\n    }\n\n    md-dialog md-dialog-content {\n        padding: 0;\n    }\n\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\n    md-input-container .md-placeholder {\n        margin-left: -8px;\n    }\n\n    md-dialog {\n        opacity: 0;\n        min-width: 240px;\n        max-width: 95%;\n        max-height: 97%;\n    }\n\n    .file-input {\n        display: none !important;\n    }\n\n    #attachmenthref label:hover {\n        cursor: pointer !important;\n        color: #23527c !important;\n    }\n\n    #tb2 {\n        counter-reset: serial-number;\n        /* Set the serial number counter to 0 */\n    }\n\n    #tb2 td:first-child:before {\n        counter-increment: serial-number;\n        /* Increment the serial number counter */\n        content: counter(serial-number);\n        /* Display the counter */\n    }\n\n    .ms-scroll {\n        position: relative;\n    }\n\n    #viewsor:hover {\n        color: rgb(3, 155, 229) !important;\n        font-style: italic;\n        font-size: 14px;\n        cursor: pointer;\n\n    }\n\n    #viewsor {\n        color: rgb(148, 194, 218) !important;\n        font-style: italic;\n        font-size: 14px\n    }\n\n    #date1 .md-datepicker-input {\n        max-width: 100% !important;\n        min-width: 50% !important;\n        margin-left: -10px;\n    }\n\n    #date1 md-datepicker .md-datepicker-input {\n        width: calc(13vw - 20px);\n        max-width: calc(15vw - 20px);\n    }\n\n    label {\n        padding-left: 10px !important;\n        font-size: 15px !important;\n    }\n\n    .ta-scroll-window>.ta-bind {\n        height: auto;\n        min-height: 80px;\n        padding: 6px 12px;\n    }\n\n    .ta-editor.ta-html,\n    .ta-scroll-window.form-control {\n        min-height: 100px;\n        height: auto;\n        overflow: auto;\n        font-family: inherit;\n        font-size: 100%;\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/RevertPopup.html","<md-dialog ng-class=\"{ \'widthteam\': vm.EditTeamdiv == true , \'widthrevert\' :  vm.EditTeamdiv != true}\" \nstyle=\"overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate ng-if=\"vm.EditTeamdiv == false\">\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Revert ({{vm.RevertServiceID}})</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" flex layout-align=\"center\" style=\"padding:1%;text-align:center\"><span>\nAre you sure you want to revert this service?</span></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"RevertSubmit()\" aria-label=\"Submit\">Yes</md-button><md-button type=\"submit\" ng-click=\"cancel();ClearGrid();\" \nclass=\"md-raised\">No</md-button></div></md-dialog-content></form><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate ng-if=\"vm.EditTeamdiv == true\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Edit Team</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:99.5%; border:1px solid rgb(224, 224, 224);float:left\"><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:45%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CustomerName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team</label></div>:<div class=\"p-4\" style=\"width:45%\"><span \nstyle=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Lead</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamLead}}</span></div><div class=\"p-4\" style=\"width:16%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Members</label></div>:<div class=\"p-4\" style=\"width:45%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamMembers}}</span></div></div></div></div></div><div class=\"navigation\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex style=\"height:62px\"><md-input-container flex style=\"margin-bottom:0;flex: 0.4\">\n<label>Team</label><md-select ng-model=\"vm.Team_id\" id=\"searchmodule\" ng-change=\"getTeamTable(vm.Team_id)\" \nmd-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchAssigned\" \ntype=\"text\" placeholder=\"Search For a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Team_id = null;vm.TM=null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-disabled=\"vm.Team_id.length>2\" ng-value=\"row\">\n{{row.TeamName}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0\"><input \ntype=\"text\" ng-model=\"vm.TM\" placeholder=\"Team Members\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 70px\"><md-input-container flex><md-button \nng-click=\"TeamEditSubmit()\" style=\"float:right\" ng-disabled=\"!vm.Team_id\" class=\"md-raised md-accent\">Update\n</md-button></md-input-container><md-input-container flex><md-button class=\"md-raised\" \nng-click=\"cancel();ClearGrid();\">Cancel</md-button></md-input-container></div></div></md-dialog-content></form>\n</md-dialog><style>\n.widthteam {\r\n            width:60% !important;\r\n        }\r\n         .widthrevert {\r\n           width: 40% !important;\r\n        }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/Scheduler-popup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this service?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5% 2% 2% 2%\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex style=\"height:40px;margin:0\"><input type=\"text\" \nng-model=\"vm.CancelRemarks\" placeholder=\"Reason\" required></md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox ng-model=\"Cancel.value\" \ntype=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">Send email notification to the Technicians and Creator?\n</md-checkbox></md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button\n ng-click=\"Schinfodelete(deleteID)\" class=\"md-raised md-accent\" ng-disabled=\"eventForm.$invalid\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/scheduler/Scheduler_list_popup.html","<md-dialog style=\"width:60%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Reschedule</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;height:auto;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:99.5%; border:1px solid rgb(224, 224, 224);float:left\"><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:25%\"><label style=\"font-size:15px\">\nService ID :</label></div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">{{vm.ServiceID}}</span></div>\n<div class=\"p-4\" style=\"width:25%\"><label style=\"font-size:15px\">Work Order :</label></div><div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">{{vm.SalesOrderNo}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:25%\"><label \nstyle=\"font-size:15px\">Contract # :</label></div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n{{vm.ContractReferenceNo}}</span></div><div class=\"p-4\" style=\"width:25%\"><label style=\"font-size:15px\">Team :</label>\n</div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">{{vm.TeamName}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" style=\"height:50px\"><div class=\"p-4\" style=\"width:25%\"><label\n style=\"font-size:15px\">Scheduled From :</label></div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n{{vm.ServiceStartAt | date:\"dd/MM/yyyy \'at\' h:mma\"}}</span></div><div class=\"p-4\" style=\"width:25%\"><label \nstyle=\"font-size:15px\">Scheduled To :</label></div><div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n{{vm.ServiceEndAt | date:\"h:mma\"}}</span></div></div></div></div></div><div class=\"navigation\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex style=\"margin-bottom:0;flex: 0.5\"><label>Team</label>\n<md-select ng-model=\"vm.UTeam\" id=\"searchmodule\" ng-change=\"getTeamTable(vm.UTeam)\" \nmd-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchAssigned\" \ntype=\"text\" placeholder=\"Search For a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.UTeam = null;vm.searchAssigned=null;vm.ppTeamName=null;vm.TeamEstimationHr=vm.EstimationHr\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0;flex: 0.5\"><label>\nTechnican Signature for Report</label><md-select ng-model=\"vm.UTeam1\" id=\"searchmodule\" \nmd-on-close=\"vm.searchAssigned1 = \'\'\"><md-select-header><input ng-model=\"vm.searchAssigned1\" type=\"text\" \nplaceholder=\"Search For a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.UTeam1 = null;vm.searchAssigned1=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned1\" value=\"{{row.TeamName}}\">{{row.TeamName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><div \nclass=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">Date :</div><div \nclass=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleFrom\" displayformat=\"dd-MM-yyyy\">\n</div></div></div><div class=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">\nStart Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleStartTime\">\n</div></div></div><div class=\"dx-field\"><div style=\"color:#7f9593;font-weight: bold\" class=\"dx-field-label\">End Time :\n</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleEndTime\"></div></div>\n</div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"height:40px;margin:0px\"><input \ntype=\"text\" ng-model=\"vm.ResheduleRemarks\" placeholder=\"Reason\"></md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox \nng-model=\"Reschedule.value\" type=\"checkbox\" style=\"padding-left:5px\">\nSend email notification to the Technicians and Creator?</md-checkbox></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height: 70px\"><md-input-container flex><md-button ng-click=\"sSubmit()\" style=\"float:right\" \nng-disabled=\"eventForm.$invalid\" class=\"md-raised md-accent\">Update</md-button></md-input-container><md-input-container\n flex><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button></md-input-container><md-input-container flex \nstyle=\"margin-left: -300px\"><md-button ng-if=\"vm.TabTitle == \'Outstanding\'\" ng-click=\"makeComplete($event)\" \nclass=\"md-warn md-raised md-hue-2\">Make Complete</md-button></md-input-container></div></div></md-dialog-content>\n</form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  #datefil {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(25vw - 54px);\r\n  } \r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/Selectedschedule.html","<md-dialog style=\"overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.Title}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nng-show=\"vm.Title == \'Reschedule\'\" style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.RescheduleSpinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span><b>Rescheduling...</b></span></div><div \nng-show=\"vm.RescheduleSpinner == false\" flex><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<span>Are you sure you want to reschedule {{SelectedIds.length}} Services?</span></div><br><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex style=\"margin: 0\"><label style=\"margin-right: 10px\">\nDate</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.ResheduleSFrom\" required></md-datepicker>\n</md-input-container><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div\n class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleSSTime\"></div></div></div><div \nclass=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">\nEnd Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleSETime\">\n</div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"height:40px;margin:0px\"><input type=\"text\" ng-model=\"vm.ResheduleSRemarks\" placeholder=\"Remarks\" required>\n</md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox \nng-model=\"Reschedule.value\" type=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">\nSend email notification to the Technicians and Creator?</md-checkbox></md-input-container><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"SubmitRescheduleSelected()\" \nng-disabled=\"!vm.ResheduleSRemarks || !vm.ResheduleSSTime || !vm.ResheduleSETime\" class=\"md-raised md-accent\">Submit\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content>\n<md-dialog-content ms-scroll ng-show=\"vm.Title == \'Reschedule by Time\'\" style=\"padding:5px 10px 5px 10px\"><div \nlayout=\"column\" layout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.RescheduleSpinner == true\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span><b>Rescheduling...</b>\n</span></div><div ng-show=\"vm.RescheduleSpinner == false\" flex><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><span>Are you sure you want to reschedule {{SelectedIds.length}} Services?</span></div>\n<br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">Start Time :</div><div\n class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleSSTime\"></div></div></div><div \nclass=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">\nEnd Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleSETime\">\n</div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"height:40px;margin:0px\"><input type=\"text\" ng-model=\"vm.ResheduleSRemarks\" placeholder=\"Remarks\" required>\n</md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox \nng-model=\"Reschedule.value\" type=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">\nSend email notification to the Technicians and Creator?</md-checkbox></md-input-container><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"submitrescheduled()\" \nng-disabled=\"!vm.ResheduleSRemarks || !vm.ResheduleSSTime || !vm.ResheduleSETime\" class=\"md-raised md-accent\">Submit\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content>\n<md-dialog-content ms-scroll ng-show=\"vm.Title == \'Cancel\'\" style=\"padding:5px 20px 5px 20px\"><div layout=\"column\" \nlayout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.CancelSpinner == true\" flex><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span><b>Cancelling...</b></span></div><div \nng-show=\"vm.CancelSpinner == false\" flex><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><span>\nAre you sure you want to cancel {{SelectedIds.length}} Services?</span></div><br><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex style=\"height:40px;margin:0px\"><input type=\"text\" \nng-model=\"vm.CancelSRemarks\" placeholder=\"Remarks\" required></md-input-container></div><md-input-container flex \nstyle=\"height: 60px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox ng-model=\"Cancel.value\" \ntype=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">Send email notification to the Technicians and Creator?\n</md-checkbox></md-input-container><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button\n ng-click=\"SubmitCancelSelected()\" ng-disabled=\"!vm.CancelSRemarks\" class=\"md-raised md-accent\">Submit</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content>\n<md-dialog-content ms-scroll ng-show=\"vm.Title == \'Clone the Job\'\" style=\"padding:5px 20px 5px 20px\"><div \nlayout=\"column\" layout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.RescheduleSpinner == true\" flex>\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span><b>Cloning...</b></span>\n</div><br><div ng-show=\"vm.RescheduleSpinner == false\" flex><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:50px\"><md-input-container flex style=\"margin: 0\"><label style=\"margin-right: 10px\">Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.ResheduleSFrom\" required></md-datepicker></md-input-container><div\n class=\"dx-field\"><div style=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" \nclass=\"dx-field-label\">Start Time :</div><div class=\"dx-field-value\"><div style=\"margin-left: -10px\" \ndx-date-box=\"dateBox.ResheduleSSTime\"></div></div></div><div class=\"dx-field\"><div \nstyle=\"font-size:15px;color:#7f9593;padding-right:3.4%;font-weight: bold\" class=\"dx-field-label\">End Time :</div><div \nclass=\"dx-field-value\"><div style=\"margin-left: -10px\" dx-date-box=\"dateBox.ResheduleSETime\"></div></div></div></div>\n<div layout=\"column\" layout-gt-xs=\"column\"><md-input-container flex><label>Frequency & Pest Type</label><md-select \nng-model=\"vm.CPestType\" ng-change=\"CheckForFrequency(vm.PestType)\" id=\"searchmodule\" md-on-close=\"vm.searchPest = \'\'\" \nmultiple=\"\" required><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Frequency & Pest Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchPest = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchPest\" ng-value=\"row\">{{row.Frequency}} - {{row.PestType}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Team</label><md-select ng-model=\"vm.CAssignedTo\" \nid=\"searchmodule\" ng-change=\"getTeamTable(vm.AssignedTo)\" md-on-close=\"vm.searchAssigned = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.TM=null;vm.ppTeamName=null;vm.TeamEstimationHr=vm.EstimationHr\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" ng-value=\"row\">{{row.TeamName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-bottom:0;flex: 0.4\"><input \ntype=\"text\" ng-model=\"vm.ResheduleSRemarks\" placeholder=\"Remarks\" required></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button ng-click=\"SubmitClone()\" \nng-disabled=\"!vm.ResheduleSRemarks\" class=\"md-raised md-accent\">Submit</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div><br></div><br></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  .md-datepicker-input-container {\r\n    width: 90%;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    width: calc(100% - 45px);\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 45px;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ShowDownloadedHistoryDetails.html","<md-dialog style=\"width:90%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">DOWNLOADED REPORT(S) HISTORY</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nstyle=\"padding-right: 10px\" flex><md-button class=\"md-accent md-raised\" ng-click=\"RefreshReportPathHistory()\" \nstyle=\"float:right\"><span>Refresh</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"start center\" style=\"padding-left:2%;margin-top: 5px\" flex><div style=\"float:left\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Note&nbsp;:</b> </span><span style=\"font-size:14px;font-style:italic\">\nShown last 10 requests.</span></div></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.DownSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" style=\"margin-top:-25px\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\" style=\"font-size:13.5px\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Requested By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nRequested Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Total Reports</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Completed Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Download Link</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Schedulerreportpathdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.RequestedBy }}</td><td>{{ row.RequestedDate| date:\'dd/MM/y hh:mm a\' }}</td><td>\n{{ row.CompletedRecords || 0}} out of {{ row.TotalRecords || 0}}<br><div \nng-if=\"row.TotalRecords == row.CompletedRecords\" class=\"label ng-binding ng-scope md-green-500-bg\">Completed</div><div \nng-if=\"row.TotalRecords > row.CompletedRecords\" class=\"label ng-binding ng-scope md-red-500-bg\">In-Progress</div></td>\n<td>{{ row.DownloadedDate| date:\'dd/MM/y hh:mm a\' }}</td><td><a href=\"{{DownloadURL}}{{row.DownloadedLink}}\" download \nstyle=\"cursor:pointer\">{{DownloadURL}}{{row.DownloadedLink}}</a></td></tr></tbody></table></div></md-dialog-content>\n</form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ShowEmailedHistoryDetails.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">EMAIL HISTORY</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"start center\" \nstyle=\"padding-left:2%;margin-top: 5px;margin-bottom: -20px\" flex><div style=\"float:left\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Total Records&nbsp;:</b> </span><span style=\"font-size:14px;font-style:italic\">\n{{Completeddatas.length}}</span></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\">\n<div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Service ID</span></div></th><th ng-hide=\"row.EmailSent == true\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th ng-hide=\"row.EmailSent != true\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email Sent To</span></div></th><th \nng-hide=\"row.EmailSent == true\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remarks\n</span></div></th><th ng-hide=\"row.EmailSent != true\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Completeddatas\" \nng-class=\"{ \'color-red\': getRowColourforSentEmail(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.ServiceID }}</td><td ng-hide=\"row.EmailSent == true\">Failed</td><td ng-hide=\"row.EmailSent != true\">Sent\n</td><td>{{ row.EmailSentDate | date:\'dd/MM/y hh:mm a\'}}</td><td>{{ removeLastComma(row.EmailSentTo) }}</td><td \nng-hide=\"row.EmailSent == true\">{{ row.EmailSentError }}</td><td ng-hide=\"row.EmailSent != true\">\nEmail Sent Successfully</td></tr></tbody></table></div></md-dialog-content></form></md-dialog><style>\n.color-red {\r\n    color: red;\r\n  }\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ShowImages.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Photo</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><br><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><img ng-if=\"uShowImage\" data-ng-src=\"{{uShowImage}}\">\n <img ng-hide=\"uShowImage\" style=\"height:180px; width:280px\" \ndata-ng-src=\"../../../../../../assets/images/logos/Noimage.png\" alt=\"\"></div><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Close</md-button></div><br>\n</md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/ShowPreferenceTime.html","<md-dialog style=\"width:20%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.Tittle}}</span><md-button ng-hide=\"vm.Tittle==\'Select Other Day for Twice a Week\'\" \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><br><div \nng-if=\"vm.Tittle == \'Select Month to Export\'\" dx-date-box=\"dateBox1\"></div><div \nng-if=\"vm.Tittle != \'Select Month to Export\'\" layout=\"column\" layout-gt-xs=\"row\" flex style=\"height:62px\">\n<md-input-container flex><label>Days</label><md-select ng-model=\"vm.Twiceday\" id=\"searchmodule\" \nmd-on-close=\"vm.searcTypes = \'\'\" required><md-select-header><input ng-model=\"vm.searcTypes\" type=\"text\" \nplaceholder=\"Select Other Day for \'Twice a Month\'..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Twiceday = null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in dayitem1 | filter:vm.searcTypes\" ng-click=\"pcancel()\" ng-value=\"row\">{{row.names}}</md-option>\n</md-select></md-input-container></div><br></md-dialog-content></form></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\r\n\r\n    .md-datepicker .md-datepicker-input {\r\n        width: calc(35vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n        color: black !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 56px);\r\n    }\r\n\r\n    .md-default-theme .md-datepicker-input-mask-opaque, .md-datepicker-input-mask-opaque {\r\n        left: 0px !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(17vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 133%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-left: -8px;\r\n    }\r\n   #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/VerifyDetails.html","<md-dialog style=\"width:1350px\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">VERIFY SERVICE(S)</span><md-button class=\"md-icon-button\" \nng-click=\"CloseVerification();ClearGrid();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.ShowVerifySpinner == true\" flex><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span><b>Verifing...</b></span></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"vm.ShowVerifySpinner == false\" flex><div id=\"gridContainer\" \ndx-data-grid=\"VerifydataGridOptions\"></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" style=\"padding-bottom: 35px\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"getConfirmationtoVerifyforSelectedCompletedJob()\" aria-label=\"Submit\">Verify</md-button><md-button \ntype=\"submit\" style=\"padding-bottom: 35px\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"CloseVerification();ClearGrid();\" aria-label=\"Submit\">Cancel</md-button></div></div></md-dialog-content>\n</md-dialog><style>\n#viewedit.md-button {\r\n    margin: -16px -5px;\r\n  }\r\n  .dx-datagrid-save-button {\r\n    width: 0px !important;\r\n    height: 0px !important;\r\n    padding: 0px !important;\r\n    visibility: hidden !important;\r\n  }\r\n\r\n  .dx-datagrid-cancel-button {\r\n    width: 0px !important;\r\n    height: 0px !important;\r\n    padding: 0px !important;\r\n    visibility: hidden !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/addcoments.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Service Job Preview ({{vm.ServiceID}})</span><md-button class=\"md-icon-button\" \nng-click=\"cancel();ClearGrid();\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div \nlayout=\"column\" layout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract #</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ContractReferenceNo}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Contact Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteCcontactName}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Contact Number</label></div>:<div\n class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteContactNo}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Site Email</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SiteEmail}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Start Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">End Time\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.ServiceEndAt | date:\"hh:mm a\"}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PestType1}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.JobType}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service On</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceOn}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Special Remarks</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SpecialRemark}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Type</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Types}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Present</label></div><div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.CustomerPresent}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Preferred Days</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PreferredTime}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Preference Time</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.PreferredStartTime | date : \"hh:mm a\"}} - {{vm.PreferredEndTime | date : \"hh:mm a\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Avoid Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.AvoidStartTime | date : \"hh:mm a\"}} - {{vm.AvoidEndTime | date : \"hh:mm a\"}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Start Time</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgresseAt | date:\"hh:mm:ss a\"}}\n</span> &emsp;</div><div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">\nActual End Time</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">\n&nbsp;{{vm.AServiceEndAt | date:\"hh:mm:ss a\"}}</span> &emsp;</div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed To</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;width:25%\">&nbsp;{{vm.EmailSentTo}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentDate | date:\"dd/MM/y hh:mm a\"}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Remarks</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PaymentRemarks}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Performed By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgressedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedBy}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedDate | date:\"dd/MM/y hh:mm a\"}}</span></div></div></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:59.5%; border:1px solid rgb(224, 224, 224);float:left\"><ng-map \nid=\"mapa\" center=\"{{center}}\" zoom=\"5\" maximum-zoom=\"17\" street-view-control=\"true\" zoom-control=\"true\" \nzoom-to-include-markers=\"true\" ng-click=\"getpos($event)\"><marker position=\"{{latlng}}\" ng-dragend=\"getpos($event)\" \nanimation=\"DROP\" draggable=\"true\"></marker></ng-map></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">\nRemarks for {{vm.ServiceID}}:</label></div></div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" \nstyle=\"height:70px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks..\">\n</md-input-container></div><div style=\"float: right;padding: 2%;\"><md-button class=\"md-raised md-accent\" \nng-click=\"RemarkSubmit()\" ng-disabled=\"!vm.Remarks\"><span>Save</span></md-button></div><div \nstyle=\"background-color:whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\"><div \nclass=\"md-list-item-text\" layout=\"column\"><p>{{ vm.ssRemark }}</p></div></md-list-item></md-list></div></div></div>\n</div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Mobile Logs</span></md-tab-label><md-tab-body><div\n layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;height:auto;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><label style=\"width:16%;font-weight:bold;color:#7f9593\">Services:</label><table\n id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Frequency</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Chemical</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Dilution</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in MultiFrequencydatas\"><td>\n&nbsp;</td><td>{{ row.Frequency }}</td><td>{{ row.PestType }}</td><td>{{ row.TreatmentMethod }}</td><td>\n{{ row.Chemical }}</td><td>{{ row.Dilution }}</td></tr></tbody></table></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><label style=\"width:16%;font-weight:bold;color:#7f9593\">Infestation Level:\n</label><table id=\"tb2\" class=\"dataTable row-border hover\" datatable=\"ng\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nInfestation Level</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialsdatas\"><td>&nbsp;</td><td>\n{{ row.PestType }}</td><td>{{ row.Infestation }}</td></tr></tbody></table></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"column\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in Photosdatas\" ng-switch \non=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" ng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <span>\n{{row.Remarks}}</span></div></div><br><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:12%\"><span style=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Details</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\" \nstyle=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Mode</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentMode}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Amount Received</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.AmountReceived}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Name of Bank</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.BankName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Cheque No.</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.ChequeNo}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Remarks</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.PaymentRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Details</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Email ID</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.MobilEmailId}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Ratings</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\" style=\"border-top: 1px solid #7f9593;width: 70%;margin-left:0.9%\"></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Attitude</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Attitude >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 2\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 3\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 4\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img ng-if=\"vm.Attitude >= 5\" \nsrc=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Attitude == null || vm.Attitude == undefined || vm.Attitude == 0 || vm.Attitude == \'\'\" style=\"height: 30px\" \nstar-rating rating=\"vm.Attitude\" read-only=\"true\" max-rating=\"5\"></div></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Appearance of Technician</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Appearance >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Appearance >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Appearance == null || vm.Appearance == undefined || vm.Appearance == 0 || vm.Appearance == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.Appearance\" read-only=\"true\" max-rating=\"5\"></div></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service Quality</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.ServiceQuality >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.ServiceQuality >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.ServiceQuality == null || vm.ServiceQuality == undefined || vm.ServiceQuality == 0 || vm.ServiceQuality == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.ServiceQuality\" read-only=\"true\" max-rating=\"5\"></div></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Punctuality</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><img \nng-if=\"vm.Punctuality >= 1\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 2\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 3\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 4\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"> <img \nng-if=\"vm.Punctuality >= 5\" src=\"../../../../../../assets/images/logos/star.png\" alt=\"\"><div \nng-if=\"vm.Punctuality == null || vm.Punctuality == undefined || vm.Punctuality == 0 || vm.Punctuality == \'\'\" \nstyle=\"height: 30px\" star-rating rating=\"vm.Punctuality\" read-only=\"true\" max-rating=\"5\"></div></div></div><br><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Feedback</span></div><label \nstyle=\"font-size:15px;color:#7f9593;padding-right:1%\">:</label><div class=\"p-4\" style=\"width:100%\"><span \nstyle=\"font-size:14px\">{{vm.CustomerRemarks}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:15%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Csutomer Signature :</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:200px; width:40%; border:1px solid rgba(0, 0, 0, 0.12)\"><img \ndata-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" style=\"height:200px\" ng-if=\"CustomerSignature\" alt=\"\"></div>\n</div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Comments</span></md-tab-label>\n<md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Comments :</label></div>\n</div><div layout-gt-sm=\"row\" class=\"p-16\" layout-align=\"start start\" style=\"height:70px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Addcomments\" placeholder=\"Comment Here..\"></md-input-container></div><div \nstyle=\"float: right;padding: 2%;\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"!vm.Addcomments\"><span>Save</span></md-button></div><div \nstyle=\"background-color: whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"item in Commentdatas\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ item.CommentedBy }} @ {{ item.CreatedDate | date:\'dd/MM/y hh:mm a\'}}</h3><p>{{ item.cmt }}</p></div></md-list-item>\n</md-list></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;border:1px solid rgb(224, 224, 224);float:right\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Attachments :</label>\n</div></div><md-content layout-padding><div flow-init=\"{singleFile: true}\" flow-name=\"uploader.flow\"><div \nid=\"attachmenthref\"><label for=\"file-input\" style=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\" style=\"float:right\"><span>Upload</span></md-button><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"font-size:smaller\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">File Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>&nbsp;</td><td><a href=\"{{UploadsURL}}Operations/Scheduler/{{row.TableID}}\" \ndownload style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y hh:mm a\' }}</td></tr></tbody></table></div></div></div></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span>Logs</span></md-tab-label><md-tab-body><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Scheduled Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Scheduled<br>\nStart Time | End Time</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Rescheduled Date\n</span></div></th><th ng-hide=\"row.ScheduledStartsat == \'\'\" class=\"secondary-text\"><div><span class=\"column-title\">\n&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div></th><th ng-hide=\"row.ScheduledStartsat != \'\'\" \nclass=\"secondary-text\"><div><span class=\"column-title\">&emsp; &emsp; Rescheduled<br>Start Time | End Time</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDate & Time</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in SchedulerLogdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ShowType(row.CancelRemarks,row.ResheduleRemarks) }}</td><td>\n{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'hh:mm a\'}} | {{row.Endsat | date:\'hh:mm a\'}}</td><td>\n{{row.ScheduledStartsat | date:\'dd/MM/y\'}}</td><td ng-hide=\"row.ScheduledStartsat == \'\'\">\n{{row.ScheduledStartsat | date:\'hh:mm a\'}} | {{row.ScheduledEndsat | date:\'hh:mm a\'}}</td><td \nng-hide=\"row.ScheduledStartsat != \'\'\"></td><td>{{row.CancelRemarks || row.ResheduleRemarks}}</td><td>{{row.CreatedBy }}\n</td><td>{{row.CreateDate | date:\'dd/MM/y hh:mm a\'}}</td></tr></tbody></table></md-tab-body></md-tab><md-tab \nng-if=\"vm.Status == \'Completed\'\"><md-tab-label><span>Service Report</span></md-tab-label><md-tab-body><div \nlayout=\"column\"><div layout=\"row\" flex style=\"margin-top: 15px;margin-bottom: -10px\"><div layout=\"column\" \nstyle=\"text-align:left\" flex ng-if=\"vm.IsUrgent\"><label \nstyle=\"font-size:15px;margin-left: 5%;font-weight:bold;color: rgb(3,155,229)\">\nService Report Status - {{vm.ServiceReportStatus}}<md-button class=\"md-raised md-accent md-button md-ink-ripple\" \nng-if=\"vm.ServiceReportStatus == \'Pending\'\" ng-click=\"updateServiceReportStatus()\"><span>Approve & Send Email</span>\n</md-button></label></div><div layout=\"column\" style=\"text-align:right\" flex><label \nstyle=\"font-size:15px;margin-right: 5%;font-weight:bold;color: rgb(3,155,229)\">Print Report - <a \nng-click=\"printServiceWeb(\'Service\')\" style=\"cursor:pointer;font-size:15px;font-weight:bold\">PDF</a></label></div>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"content\" id=\"Service\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img ng-src=\"{{logo}}\"></div></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>SERVICE REPORT</b></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Date</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px;color:blue\">&emsp;{{vm.ServiceStartAt | date:\'dd/MM/y\'}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Time In</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ServiceStartAt | date:\'hh:mm a\'}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Team</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Actual Time In\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeIn | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Company Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Time Out\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ATimeOut | date:\'hh:mm a\'}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.ContactPerson}}</span></div><div class=\"p-4\" \nstyle=\"width:25%\"></div><div class=\"p-4\" style=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&emsp;{{vm.JobType}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:12%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div><div \nstyle=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div><div \nstyle=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex style=\"padding:1%\"><label \nstyle=\"width:16%;font-weight:bold;color:#7f9593\">Services:</label><table id=\"tb2\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Chemical</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Dilution</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in MultiFrequencydatas\"><td>&nbsp;</td><td>{{ row.PestType }}</td><td>{{ row.TreatmentMethod }}</td><td>\n{{ row.Chemical }}</td><td>{{ row.Dilution }}</td></tr></tbody></table></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:1%\"><div style=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\" \nstyle=\"color:#7f9593\"><b>Infestation Level :</b></span></div><div layout=\"column\" layout-align=\"start end\"><div \nstyle=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" aria-label=\"Custom Icon Button\" style=\"margin:6px 8px\" \nng-click=\"EditInfestationReport($event)\"><span>Edit</span></md-button></div></div><table id=\"tb2\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pest Type</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Infestation Level</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialsdatas\"><td>\n&nbsp;</td><td>{{ row.PestType }}</td><td>{{ row.InvestationLevel }}</td></tr></tbody></table></div><div \nstyle=\"padding:1% 1% 0 1%\"><div style=\"margin: 0 8px 0 8px;padding-bottom:0.3%;border-top:0.2px solid #7f9593\"></div>\n<div style=\"margin:  0 8px 0 8px; border-width: 3px;border:0.2px solid #7f9593\"></div><br><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:10%\"><span \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Photos :</span></div></div><div layout=\"column\" \nlayout-align=\"start end\"><div style=\"margin-top:-10px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" style=\"margin:6px 8px\" ng-click=\"EditPhotoBeforeReport($event)\"><span>Add</span>\n</md-button></div></div><div layout-gt-sm=\"column\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" \nstyle=\"width:100%;height:auto; border:1px solid rgba(0, 0, 0, 0.12)\" ng-repeat=\"row in Photosdatas\" ng-switch \non=\"$index % 6\"><img data-ng-src=\"{{row.Path}}\" ng-click=\"ShowPhotoinfo($event, row.Path)\" title=\"Zoom Image\" \nstyle=\"width:16.2%;height:150px;border:1px solid rgba(0, 0, 0, 0.12);padding:5px;cursor:pointer\" alt=\"\"> <span>\n{{row.Remarks}}</span></div></div><br><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\"><div style=\"width:58%;float:left\"><label \nstyle=\"width:21%;font-weight:bold;color:#7f9593\">Prepared By</label></div><div style=\"width:32.5%;float:right\"><label \nstyle=\"width:35%;font-weight:bold;color:#7f9593\">Customer</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&emsp;{{vm.TeamLead}}</span></div><div class=\"p-4\" style=\"width:25%\"></div><div class=\"p-4\" \nstyle=\"width:8%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Name</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.CompanyName}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:8%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Co-technicians</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&emsp;{{vm.TeamMember}}</span></div><div class=\"p-4\" style=\"width:25%\">\n</div><div class=\"p-4\" style=\"width:8%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Signature\n</label></div>:<div class=\"p-4\" style=\"width:25%\"><img style=\"height: 70px;width: 100%\" \ndata-ng-src=\"data:image/png;base64,{{CustomerSignature}}\" ng-if=\"CustomerSignature\" alt=\"\"></div></div></div></div>\n</div></div></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n  .chipsdemoContactChips md-content.autocomplete input {\r\n    min-width: 400px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected h3 {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text {\r\n    padding: 14px 0;\r\n    max-width: 190px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n    line-height: 1.2em !important;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n  .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon,\r\n  md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n  }\r\n\r\n  .star {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .filled {\r\n    color: #fd0;\r\n  }\r\n\r\n\r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/adhocaddcoments.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Update Service Job ({{vm.ServiceID}})</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\" style=\"margin-top:35px\"><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-top: -6px\" flex><label>Customer Name</label><md-select ng-model=\"vm.CustomerID\" \nng-change=\"getWorkOrderDetails()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.CustomerID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:vm.searchTerm2\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container style=\"margin-top: -6px\" flex>\n<label>Work Order</label><md-select ng-model=\"vm.WorkOrderID\" ng-change=\"getContractDetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Work Order..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.WorkOrderID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in getSalesOrderdatas | filter:vm.searchTerm3\" \nvalue=\"{{row._id}}\">{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label>Contract #</label><md-select ng-model=\"vm.ContractID\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm4\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Contract #..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ContractID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in getContractdatas | filter:vm.searchTerm4\" \nvalue=\"{{row._id}}\">{{row.ContractReferenceNo}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label>Job Type</label><md-select ng-model=\"vm.Types\" id=\"searchmodule\" \nmd-on-close=\"vm.searchjb = \'\'\"><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searchjb\" type=\"text\" \nplaceholder=\"Search for a Job Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Types = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in JobTypesdatas | filter:vm.searchjb\" value=\"{{row.Name}}\">\n{{row.Name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-gt-xs=\"column\"><div \nclass=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :</label>\n</div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service ID</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px;color:blue\">&nbsp;{{vm.ServiceID}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Work Order</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.SalesOrderNo}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contract #</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ContractReferenceNo}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Customer Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Location</label></div>:<div class=\"p-4\" style=\"width:25%\"><span\n style=\"font-size:14px\">&nbsp;{{vm.Location}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Team Name</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.TeamName}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Scheduled Date</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"dd/MM/yyyy\"}}</span></div><div \nclass=\"p-4\" style=\"width:9%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Start Time</label></div>:\n<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceStartAt | date:\"hh:mm a\"}}</span>\n</div><div class=\"p-4\" style=\"width:9%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">End Time</label>\n</div>:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ServiceEndAt | date:\"hh:mm a\"}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Pest Type</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.PestType1}}</span></div><div class=\"p-4\" style=\"width:9%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Type</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Types}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Service On</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ServiceOn}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Job Performed By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{InProgressedBy}}</span></div><div class=\"p-4\" style=\"width:9%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created By</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{CreatedBy}}</span></div><div class=\"p-4\" style=\"width:9%\"><label\n style=\"font-size:15px;font-weight: bold;color: #7f9593\">Created Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{CreatedDate | date:\"dd/MM/y hh:mm a\"}}</span></div></div><div layout-gt-sm=\"row\" \nclass=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:12%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed To</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentTo}}</span></div><div class=\"p-4\" style=\"width:9%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Emailed Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.EmailSentDate | date:\"dd/MM/y hh:mm a\"}}</span></div><div class=\"p-4\" \nstyle=\"width:9%\"></div><div class=\"p-4\" style=\"width:25%\"></div></div></div></div></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AdhocUpdate()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Save</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel\n</md-button></div></div></md-dialog-content></form></md-dialog><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n       min-height: 250px;\r\n    }\r\n\r\n        .chipsdemoContactChips md-content.autocomplete input {\r\n            min-width: 400px;\r\n        }\r\n\r\n    .chipsdemoContactChips .md-item-text.compact {\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .contact-item {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n        .chipsdemoContactChips .contact-item.selected {\r\n           opacity: 0.5;\r\n        }\r\n\r\n    .chipsdemoContactChips .contact-item.selected h3 {\r\n        opacity: 0.5;\r\n    }\r\n\r\n      .chipsdemoContactChips .contact-item .md-list-item-text {\r\n            padding: 14px 0;\r\n            max-width: 190px;\r\n        }\r\n\r\n            .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n                margin: 0 !important;\r\n                padding: 0;\r\n                line-height: 1.2em !important;\r\n            }\r\n\r\n            .chipsdemoContactChips .contact-item .md-list-item-text h3, .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n                text-overflow: ellipsis;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n            }\r\n\r\n    @media (min-width: 960px) {\r\n       .chipsdemoContactChips .contact-item {\r\n            float: left;\r\n            width: 33%;\r\n        }\r\n    }\r\n\r\n    .chipsdemoContactChips md-contact-chips {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .chipsdemoContactChips .md-chips {\r\n        padding: 5px 0 8px;\r\n    }\r\n\r\n    .chipsdemoContactChips .fixedRows {\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n   #attachmenthref label:hover {\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    #workflow .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n    .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n    .CBCustomer{\r\n        margin:0 !important;\r\n    }\r\n   md-checkbox  #chkboxhide .md-icon {\r\n       box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n}\r\n   md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon, md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n}\r\n    md-dialog {\r\n        opacity: 0;\r\n        min-width: 240px;\r\n        max-width: 95%;\r\n        max-height: 95%;\r\n    }\r\n    \r\n    @import \"compass/css3\";\r\n\r\n    .star-rating {\r\n        margin: 0;\r\n        padding: 0;\r\n        display: inline-block;\r\n\r\n        .star {\r\n            padding: 1px;\r\n            color: #ddd;\r\n            font-size: 20px;\r\n            text-shadow: .05em .05em #aaa;\r\n            list-style-type: none;\r\n            display: inline-block;\r\n            cursor: pointer;\r\n\r\n            &.filled {\r\n                color: #fd0;\r\n            }\r\n        }\r\n\r\n        &.readonly .star.filled {\r\n            color: #666;\r\n        }\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/scheduler.html","<div id=\"shedular\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span>Scheduler</span></div><div \nclass=\"product-count secondary-text\" ng-init=\"vm.TabTitle = \'PendingSchedule\';getPendingSchedule() \"><span>\nTotal Records :</span> <span ng-if=\"vm.TabTitle == \'To be Started\'\">{{YettoStartdatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'On-Hold\'\">{{OnHolddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'In-Progress\'\">\n{{MobileInProgressdatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Outstanding\'\">{{InProgressdatas.length}}</span> \n<span ng-if=\"vm.TabTitle == \'Completed\'\">{{Completeddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Cancelled\'\">\n{{Cancelleddatas.length}}</span> <span ng-if=\"vm.TabTitle == \'Ad-hoc\'\">{{AdhocJobsdatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'PendingSchedule\'\">{{PendingScheduledatas.length}}</span> <span \nng-if=\"vm.TabTitle == \'ScheduledWorkOrder\'\">{{ScheduledWorkOrderdatas.length}}</span></div></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addadhoc($event)\"><span>Create Ad-hoc Schedule</span>\n</md-button><md-button class=\"md-raised md-background\" ng-click=\"FoggingList($event)\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Fogging List</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button></div></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"row\"><div class=\"col-md-12 text-center\"></div></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\" ng-hide=\"vm.SelectedTab == \'PendingSchedule\'\"><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"lastmonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Month</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"lastweek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nLast Week</a></div><div style=\"padding:0 1% 0 1%\"><a ng-click=\"Today()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"NextWeek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Next Week</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"NextMonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nNext Month</a></div></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\" ng-hide=\"vm.SelectedTab == \'PendingSchedule\'\"><md-input-container \nstyle=\"flex:  0.25\" flex><label>Search Customer</label><md-select ng-model=\"SelectedCustomerID\" \nmd-on-close=\"vm.searchTermC = \'\'\"><md-select-header><input style=\"flex: auto\" ng-model=\"vm.searchTermC\" type=\"text\" \nplaceholder=\"Search For a Customer..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"SelectedCustomerID = undefined\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CustomerSearchdatas | filter:vm.searchTermC\" ng-click=\"uFrom=\'\' ; uTo=\'\'\" ng-value=\"row.id\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex=\"1\"><label>From</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\"><label>To</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container>\n<md-icon md-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\">\n</md-icon><md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\">\n</md-icon><md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" \nclass=\"md-raised md-background\" ng-click=\"NewGetByStatus(vm.filterteam)\"><span>Search</span></md-button></div><md-tabs \nmd-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab \nng-click=\"vm.SelectedTab = \'PendingSchedule\';getPendingSchedule();vm.TabTitle = \'PendingSchedule\';vm.JobCount = PendingScheduledatas.length;\">\n<md-tab-label><span>Pending Schedule</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PendingSchedulespinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PendingContainer\" dx-data-grid=\"vm.PendingSchedulerdataGrid\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Yet to Start\';DeleteMarkers();NewGetByStatus(\'Yet to Start\');vm.TabTitle = \'To be Started\';\">\n<md-tab-label><span>TO BE STARTED</span></md-tab-label><md-tab-body><div style=\"padding:1% 0% 0 1%;width: 100%\" \nng-show=\"TRCdiv\"><a style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:15%\">\nTotal Services Selected: {{SelectedIds.length}}</a> <a ng-click=\"RescheduleSelected($event)\" \nstyle=\"cursor:pointer;color: orangered;font-size:13.5px;padding-right:5%\">Reschedule Selected Services</a> <a \nng-click=\"RescheduleSelectedbyTime($event)\" style=\"cursor:pointer;color: orangered;font-size:13.5px;padding-right:5%\">\nReschedule Selected Services by Time</a> <a ng-click=\"CancelSelected($event)\" \nstyle=\"cursor:pointer;color: orangered;font-size:13.5px\">Cancel Selected Services</a></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridYTS\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'On-Hold\';vm.TabTitle = \'On-Hold\'; getOnHoldWorkOrder();vm.JobCount = OnHolddatas.length;\">\n<md-tab-label><span>On-Hold</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.OnholdPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"OnHoldContainer\" dx-data-grid=\"vm.dataGridOnHold\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'In-Progress\';getAllInProgress();vm.TabTitle = \'In-Progress\';vm.JobCount = MobileInProgressdatas.length;\">\n<md-tab-label><span>In-Progress</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.InProgressPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"INPContainer\" dx-data-grid=\"vm.dataGridINP\"></div><div flex \nstyle=\"width:99%;padding-left:2%; padding-bottom: 15px\"><span style=\"font-size:15px;color:#7f9593\"><b>Note&nbsp;:</b> \n</span><span style=\"font-size:14px;font-style:italic\">This list is NOT filtered by any search parameters.</span></div>\n</md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Outstanding\';getOutsatnding();vm.TabTitle = \'Outstanding\';vm.JobCount = InProgressdatas.length;\">\n<md-tab-label><span>Outstanding</span></md-tab-label><md-tab-body><div style=\"padding:1% 0% 0 1%;width: 60%\" \nng-show=\"OutstandingTRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:15%\">\nTotal Services Selected: {{OutstandingSelectedIds.length}}</a> <a ng-click=\"OutstandingRescheduleSelected($event)\" \nstyle=\"cursor:pointer;color: orangered;font-size:13.5px;padding-right:5%\">Reschedule Selected Services</a> <a \nng-click=\"OutstandingCancelSelected($event)\" style=\"cursor:pointer;color: orangered;font-size:13.5px\">\nCancel Selected Services</a></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.OutstandingPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"OTSContainer\" dx-data-grid=\"vm.dataGridOTS\"></div><div flex style=\"width:99%;padding-left:2%;padding-bottom: 15px\">\n</div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Completed\';DeleteMarkers();NewGetByStatus(\'Completed\',vm.filtercustomer, vm.filterteam);vm.TabTitle = \'Completed\';vm.JobCount = Completeddatas.length;\">\n<md-tab-label><span>Completed</span></md-tab-label><md-tab-body><div \nstyle=\"padding:10px 0% 0px 24px;float:left;width: 100%;margin-bottom:5px\"><a ng-if=\"TRCCdiv\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:5%\">\nTotal Services Selected: {{CompletedSelectedIds.length}}</a><md-button style=\"background-color:green\" ng-if=\"TRCCdiv\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ConfirmEmailforCompletedJob()\"><span>\nReSend Emails</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple\" ng-if=\"TRCCdiv\" \nng-click=\"ConfirmDownloadforCompletedJob($event)\"><span>Download Reports</span></md-button><md-button id=\"button\" \nstyle=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \ntitle=\"Download History\" ng-click=\"ShowDownloadedHistory($event)\"><span>Download History</span></md-button></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"CMPContainer\" dx-data-grid=\"vm.dataGridCMP\"></div></md-tab-body></md-tab><md-tab \nng-click=\"DeleteMarkers();vm.SelectedTab = \'Pending Approval\';NewGetByStatus(\'Pending Approval\',vm.filtercustomer, vm.filterteam);vm.TabTitle = \'Pending Approval\';vm.JobCount = PendingApprovaldatas.length;\">\n<md-tab-label><span>Pending Approval</span></md-tab-label><md-tab-body><div \nstyle=\"padding:10px 0% 0px 24px;float:right;width: 100%;margin-bottom:5px\" ng-show=\"TRCCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:5%\">\nTotal Services Selected: {{CompletedSelectedIds.length}}</a><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple\" ng-click=\"ConfirmServiceReportApprove($event)\"><span>\nService Report Approve</span></md-button></div><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PASRContainer\" dx-data-grid=\"vm.dataGridPASR\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'ScheduledWorkOrder\';getScheduledWorkOrder();vm.TabTitle = \'ScheduledWorkOrder\';vm.JobCount = ScheduledWorkOrderdatas.length;\">\n<md-tab-label><span>Scheduled WorkOrders</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.ScheduledWorkOrderspinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"ScheduledWorkOrderContainer\" dx-data-grid=\"vm.ScheduledWorkOrderdataGrid\"></div></md-tab-body></md-tab><md-tab \nng-click=\"vm.SelectedTab = \'Cancelled\';getCancelled(cancelled);vm.TabTitle = \'Cancelled\';vm.JobCount = Cancelleddatas.length;\">\n<md-tab-label><span>CANCELLED</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.CancelledPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"CNLContainer\" dx-data-grid=\"vm.dataGridCNL\"></div></md-tab-body></md-tab></md-tabs></div></div></div><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n\r\n  md-input-container.md-default-theme .md-placeholder,\r\n  md-input-container .md-placeholder,\r\n  md-input-container.md-default-theme label,\r\n  md-input-container label {\r\n    color: none;\r\n  }\r\n\r\n  #content .header md-input-container {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-input-container {\r\n    display: inline-block;\r\n    position: relative;\r\n    /*padding: 10px !important;*/\r\n    margin: 18px 0;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  md-tabs-canvas.md-center-tabs {\r\n    display: none;\r\n  }\r\n\r\n  .md-button {\r\n    margin: 6px 0 0 15px;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n    height: 0px;\r\n  }\r\n\r\n  .txtbox ::-webkit-input-placeholder {\r\n    /* WebKit, Blink, Edge */\r\n    color: #909;\r\n  }\r\n\r\n  md-input-container.md-block.md-default-theme {\r\n    display: inherit !important;\r\n  }\r\n\r\n  md-toast.md-default-theme .md-toast-content,\r\n  md-toast .md-toast-content {\r\n    background: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n\r\n  .simple.fullwidth>.header {\r\n    height: auto;\r\n  }\r\n\r\n  md-content.md-default-theme,\r\n  md-content {\r\n    background-color: none !important;\r\n  }\r\n\r\n  .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n    height: 0;\r\n  }\r\n\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  .dataTables_filter {\r\n    display: none !important;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-legend {\r\n    color: #3F51B5;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-fieldset {\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    height: 100%;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 1;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  .checkboxdemoSelectAll .demo-select-all-checkboxes {\r\n    padding-left: 30px;\r\n  }\r\n\r\n  mwl-calendar .badge-important {\r\n    background-color: #27B1A6 !important;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n\r\n  .cal-day-tick {\r\n    display: none !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row.dx-column-lines>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover.dx-column-lines>tr>td {\r\n    border-left-color: #606a71 !important;\r\n    border-right-color: #606a71 !important;\r\n  }\r\n\r\n  .dx-button {\r\n    border-width: 0 !important;\r\n  }\r\n\r\n  .dx-button-has-icon .dx-button-content {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .dx-datagrid-nowrap .dx-header-row>td>.dx-datagrid-text-content {\r\n    color: #535858 !important;\r\n    font-weight: bold !important;\r\n  }\r\n\r\n  .dx-checkbox-icon {\r\n    border: 1px solid #606b73 !important;\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row>tr>td,\r\n  .dx-datagrid-rowsview .dx-selection.dx-row:hover>tr>td {\r\n    background-color: #83878a !important;\r\n  }\r\n\r\n  .dx-datagrid .dx-header-filter {\r\n    color: red !important;\r\n  }\r\n\r\n  .dx-datagrid .dx-header-filter-empty {\r\n    color: rgba(149, 149, 149, 0.5) !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/scheduleview.html","<md-dialog style=\"width:70%;height:70%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Assigned Schedules</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div class=\"white-bg md-whiteframe-1dp\"><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Customer Name&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppCompanyName}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Work Order&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppWorkOrder}}</span></md-input-container><md-input-container flex style=\"margin-bottom:0\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Team Name&nbsp;</b></span> <span style=\"font-size:14px\"><b>:</b>\n&nbsp;&nbsp;{{vm.ppTeamName}}</span></md-input-container></div><table id=\"tb2\" \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"font-size:smaller\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Service ID</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\" nowrap=\"nowrap\"><div><span class=\"column-title\">Day</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Schedule Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Start Time</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nEnd Time</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Status</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Teamtabledata\"><td>&nbsp;</td><td><a ng-click=\"AddComments($event, row._id)\" \nstyle=\"cursor:pointer\">{{row.ServiceID }}</a></td><td>{{row.PestType }}</td><td>{{row.ServiceOn}}</td><td>\n{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Startsat | date:\'HH:mm a\'}}</td><td>{{row.Endsat | date:\'HH:mm a\'}}\n</td><td>{{row.Status}}</td></tr></tbody></table></div></md-dialog-content></form></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\r\n\r\n    .md-datepicker .md-datepicker-input {\r\n        width: calc(35vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n        color: black !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 56px);\r\n    }\r\n\r\n    .md-default-theme .md-datepicker-input-mask-opaque,\r\n    .md-datepicker-input-mask-opaque {\r\n        left: 0px !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(17vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input,\r\n    .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 133%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-left: -8px;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/scheduler/workordercheck.html","<md-dialog style=\"width:40%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Scheduled ({{vm.CheckWorkOrerCount}})</span><md-button class=\"md-icon-button\" ng-click=\"pcancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><div layout=\"column\" layout-gt-xs=\"row\" flex \nlayout-align=\"center\" style=\"padding:1%;text-align:center\"><span>\nSystem already scheduled the required [{{vm.CheckWorkOrerCount}}] services for this work order.<br>\nAre you sure you want to create more?</span></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SchedulerCalculation($event);pcancel();\" aria-label=\"Submit\">Yes</md-button><md-button type=\"submit\" \nng-click=\"pcancel()\" class=\"md-raised\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/services-master/service-master.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon icon-factory\"></md-icon><span translate=\"OPERATIONSSERVICESMASTER.HEADER\">Services</span>\n</div><div class=\"product-count secondary-text\"><span translate=\"OPERATIONSSERVICESMASTER.TOTAL_SERVICES:\">\nTotal Services:</span> <span>{{Servicesdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSSERVICESMASTER.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"OPERATIONSSERVICESMASTER.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"OPERATIONSSERVICESMASTER.EXPORT\">Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"OPERATIONSSERVICESMASTER.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Servicesgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Servicesdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Types</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Treatment Method</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Chemical</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Dilution</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Description\n</span></div></th><th class=\"secondary-text\"><div><span>View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Servicesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Servicetype }}</td><td>\n{{ row.Servicecode }}</td><td>{{ row.PestType }}</td><td>{{ row.Treatment }}</td><td>{{ row.Chemical }}</td><td>\n{{ row.Dilution }}</td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Servicesinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Servicesform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"ServicesName\" ng-model=\"uServicesName\" placeholder=\"Service Name\" required><div \nng-messages=\"basicForm.ServicesName.$error\" ng-show=\"basicForm.ServicesName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Service Name field is required.</span></div></div><p ng-show=\"error1\" style=\"color:red\">\nService Name Is already Exist.</p></md-input-container><md-input-container flex><input type=\"text\" name=\"ServicesCode\" \nng-model=\"uservicescode\" placeholder=\"Code\" required><div ng-messages=\"basicForm.ServicesCode.$error\" \nng-show=\"basicForm.ServicesCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nServices Code field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.PestType\" name=\"PestType\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.PestName\'}\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchTermP = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" ng-click=\"GetTreatmentMethod(row.PestName)\" ng-value=\"row\">\n{{row.PestName}}</md-option></md-select></md-input-container><md-input-container flex><label>Treatment Method</label>\n<md-select ng-model=\"vm.Treatment\" name=\"Treatment\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.TreatmentName\'}\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required>\n<md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Treatment Method..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Treatment = null;vm.searchTermP = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Treatmentdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.TreatmentName}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nname=\"Chemical\" ng-model=\"Chemical\" placeholder=\"Chemical\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Dilution\" ng-model=\"Dilution\" placeholder=\"Dilution\"></md-input-container><md-input-container flex>\n<label>Description</label><input type=\"text\" name=\"ContactPerson\" ng-model=\"udescription\"></md-input-container></div>\n<div style=\"margin-top:-22px\" class=\"dx-fieldset-header\">SOP</div><div style=\"margin-top:-20px\" class=\"left-content\">\n<div dx-text-area=\"textAreaWithMaxLength\"></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .dx-texteditor.dx-state-hover,\r\n    .dx-texteditor.dx-state-focused {\r\n        border-color: black !important\r\n    }\r\n    .dx-fieldset-header{\r\n        font-weight: 400!important;\r\n        color: #929191 !important\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/team/TeamChange.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Team Change</span></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding: 5px 20px 5px 20px\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><span><b>Select the team to be replaced in upcoming Scheduled jobs</b></span></div><br>\n<div flex layout=\"row\" layout-align=\"center\"><md-input-container flex><label>Team</label><md-select \nng-model=\"vm.AssignedTo\" id=\"searchmodule\" md-on-close=\"vm.searchAssigned = \'\'\" required><md-select-header><input \nng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-click=\"TeamName=row.TeamName ; Id=row.id\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \naria-label=\"Close dialog\" style=\"float: right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Teamdatas | filter:vm.searchAssigned\" value=\"{{row}}\">{{row.TeamName}}\n</md-option></md-select></md-input-container></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button ng-click=\"SubmitTeamChange(vm.AssignedTo)\" class=\"md-raised md-accent\">Submit\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel();\">Cancel</md-button></div><br></md-dialog-content></form>\n</md-dialog><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\r\n\r\n  md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n  md-input-container .md-placeholder {\r\n    margin-right: 0 !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/team/team.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Teams</span></div><div class=\"product-count secondary-text\">\n<span translate=\"OPERATIONSTEAM.TOTAL_TEAMS:\">Total Teams: </span><span>{{Teamdatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSTEAM.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"OPERATIONSTEAM.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"OPERATIONSTEAM.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"OPERATIONSTEAM.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" ng-show=\"teamgrid\">\n<div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Teamdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"gridContainer\" dx-data-grid=\"dataGridOptions\"></div>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"teamform\" flex>\n<form name=\"basicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nname=\"teamName\" ng-model=\"uTeamName\" ng-disabled=\"Update==true\" \nplaceholder=\"{{ \'OPERATIONSTEAM.TEAM_NAME\' | translate }}\" required><p ng-show=\"error1\" style=\"color: red\" \ntranslate=\"OPERATIONSTEAM.TEAM_NAME_IS_ALREADY_EXIST\">Team Name Is already Exist.</p></md-input-container>\n<md-input-container flex><label translate=\"OPERATIONSTEAM.TEAM_LEAD\">Team Lead</label><md-select ng-model=\"TeamLead\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"searchTeam\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSTEAM.SEARCH_FOR_TEAM_LEAD\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:searchTeam\" value=\"{{row.EmployeeName}}\" \nng-click=\"vm.EmployeeID = row.EmployeeID\">{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"OPERATIONSTEAM.TEAM_MEMBERS\">Team Members</label>\n<md-select ng-model=\"TeamMembers\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{ \'OPERATIONSTEAM.SEARCH_FOR_TEAM_MEMBERS\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:searchTerm\" ng-value=\"row\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"Zone\" \nplaceholder=\"{{ \'OPERATIONSTEAM.ZONE\' | translate }}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"></md-input-container><md-input-container flex style=\"margin-top: 18px\"></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\" translate=\"OPERATIONSTEAM.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\" translate=\"OPERATIONSTEAM.CANCEL\">Cancel</md-button></div></form></div></div>\n</div></div></div><style>\n#example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(27.2vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/treatment/treatment.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-flattr\"></md-icon><span translate=\"TREATMENTMASTER.HEADER\">Treatment Methods</span></div>\n<div class=\"product-count secondary-text\"><span>Total Treatment Methods :</span> <span>{{Treatmentdatas.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'TREATMENTMASTER.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"TREATMENTMASTER.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"TREATMENTMASTER.EXPORT\">Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"TREATMENTMASTER.BACK\">Back</span></md-button></div></div><div class=\"content-card\" ng-show=\"Treatmentgrid\">\n<div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Treatmentdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"TREATMENTMASTER.NAME\" class=\"column-title\">Pest Type</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Treatment Name</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Chemical</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDilution</span></div></th><th class=\"secondary-text\"><div><span>View/Edit</span></div></th><th class=\"secondary-text\" \nng-if=\"IsAdmin==true\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Treatmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.PestType }}</td><td>\n{{ row.TreatmentName }}</td><td>{{ row.Chemical }}</td><td>{{ row.Dilution }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Treatmentinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td ng-if=\"IsAdmin==true\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup($event, row.id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Treatmentform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex \nstyle=\"margin-bottom:0;flex: 0.37\"><label>Pest Type</label><md-select ng-model=\"PestType\" id=\"searchmodule\" \nmd-on-close=\"vm.searcTypes = \'\'\" required><md-select-header><input ng-model=\"vm.searcTypes\" type=\"text\" \nplaceholder=\"Search For a Pest Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"PestType= null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Pestdatas | filter:vm.searcTypes\" value=\"{{row.PestName}}\">\n{{row.PestName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"TreatmentName\" ng-model=\"TreatmentName\" placeholder=\"Treatment Name\" required><p ng-show=\"error1\" \nstyle=\"color:red\">Treatment Name already exists</p></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:-12px\"><md-input-container flex><label>Description</label><input type=\"text\" name=\"ContactPerson\" \nng-model=\"Description\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Chemical\" \nng-model=\"Chemical\" placeholder=\"Chemical\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Dilution\" ng-model=\"Dilution\" placeholder=\"Dilution\"></md-input-container></div><div style=\"margin-top:-22px\" \nclass=\"dx-fieldset-header\">SOP</div><div style=\"margin-top:-20px\" class=\"left-content\"><div \ndx-text-area=\"textAreaWithMaxLength\"></div></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/dashboard/dashboard-server.html","<div id=\"dashboard-server\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">\n{{\'DASHBOARD.WELCOME BACK\'|translate}}, {{UserName}}!</span></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"{{General}}\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.EMPLOYEES\'|translate}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"green-fg font-size-72 line-height-72\">{{Employeedatas}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL EMPLOYEES\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.TOTAL RESIGNED EMPLOYEES\'|translate}}:</span> <span \nclass=\"red-fg h4 ml-8\">{{EmployeeResineddatas}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.LEAVES\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{Leavedatas.length}}</div><div class=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL LEAVES\'|translate}}</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.APPROVED\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{LeaveApprovedLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.RECRUITMENT\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{Recruitmentjobapplicationdatas.length}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'DASHBOARD.TOTAL RECRUITMENT\'|translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.APPROVED\'|translate}} :</span> \n<span class=\"h4 ml-8\">{{RecApprovedLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{\'DASHBOARD.CALENDAR\'|translate}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">{{\'DASHBOARD.DETAILS\'|translate}}</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\n{{\'DASHBOARD.REFRESH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{HolidayLength}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{\'DASHBOARD.TOTAL HOLIDAYS\'|translate}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{\'DASHBOARD.TOTAL EVENTS\'|translate}} :</span> <span class=\"h4 ml-8\">\n{{EventLength}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"h3 p-16\">{{vm.widget9.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget9.mainChart.options\" data=\"vm.widget9.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8 h3\">{{\'DASHBOARD.ATTENDANCE\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3>\n</div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div \nclass=\"h4 secondary-text\">{{widget.data.label}}</div><div class=\"md-display-1\">\n{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" config=\"vm.widget5.supporting.chart.config\" \noptions=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label=\"Expiry Alerts\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nNRIC/FIN {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget10.mainChart.config\" \noptions=\"vm.widget10.mainChart.options\" data=\"vm.widget10.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget10.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget10.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget10.supporting.chart.config\" options=\"vm.widget10.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPassport {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<div class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget11.mainChart.config\" \noptions=\"vm.widget11.mainChart.options\" data=\"vm.widget11.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget11.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget11.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget11.supporting.chart.config\" options=\"vm.widget11.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nPass {{\'DASHBOARD.EXPIRY DETAILS\'|translate}}</div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div\n class=\"p-16\" layout=\"row\" flex=\"100\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget12.mainChart.config\" \noptions=\"vm.widget12.mainChart.options\" data=\"vm.widget12.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" layout-wrap><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget12.supporting.widgets\"><div class=\"h4 secondary-text\">\n{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget12.currentRange]}}</div><nvd3 \nclass=\"h-50\" config=\"vm.widget12.supporting.chart.config\" options=\"vm.widget12.supporting.chart.options\" \ndata=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>\n</div>");
$templateCache.put("app/main/apps/human-resource/hrmusers/CustomerUser.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"HRMUSERS.ADD CUSTOMER LOGIN\" class=\"title\">Add Customer Login</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 1% 1% 1%\"><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"HRMUSERS.CLIENT/LICENSOR\">\nClient/Licensor</label><input type=\"text\" style=\"color:black\" ng-model=\"uClientName\" autocomplete=\"off\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><label translate=\"HRMUSERS.CUSTOMER_NAME\">\nCustomer Name</label><md-select ng-model=\"vm.CustomerName\" name=\"Empid\" id=\"searchmodule\" \nmd-on-close=\"vm.searchc = \'\'\" required><md-select-header><input ng-model=\"vm.searchc\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Customer Name\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CustomerName = null;vm.searchc = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas | filter:vm.searchc\" \nng-click=\"vm.cEmail = row.Email;vm.cUserName = row.CompanyName;vm.Customer_Id = row.id;\" value=\"{{row.CompanyName}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex><input class=\"txtbox\" \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"loginid\" ng-model=\"vm.cLoginID\" \nplaceholder=\"{{\'HRMUSERS.LOGIN_ID\'|translate}}\" required><div ng-messages=\"basicForm.loginid.$error\" \nng-show=\"basicForm.loginid.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HRMUSERS.LOGIN_ID_IS_REQUIRED\">Login ID is required.</span></div></div><p ng-show=\"error1\" \nstyle=\"color:red\">Login ID Is already Exist.</p></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -16px\"><md-input-container flex><input type=\"email\" style=\"border-radius:3px;padding-left:5px\" \nname=\"email\" ng-model=\"vm.cEmail\" placeholder=\"{{ \'HRMUSERS.EMAIL\' | translate }}\" ng-pattern=\"/^.+@.+\\..+$/\" required>\n<div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"HRMUSERS.EMAIL_FIELD_IS_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"HRMUSERS.EMAIL_MUST_BE_A_VALID_E-MAIL_ADDRESS\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"HRMUSERS.ROLES\"></label><input class=\"txtbox\" style=\"border-radius:3px;padding-left:5px\" type=\"text\" \nname=\"loginid\" ng-model=\"vm.rol = \'Customer\'\" placeholder=\"Role\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"HRMUSERS.EXPIRY_DATE\">Expiry Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.cExpiryDate\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -10px\"><md-input-container flex>\n<input class=\"txtbox\" style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"displayname\" \nng-model=\"vm.cUserName\" placeholder=\"{{ \'HRMUSERS.DISPLAY_NAME\' | translate }}\" required><div \nng-messages=\"basicForm.displayname.$error\" ng-show=\"basicForm.displayname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"HRMUSERS.DISPLAY_NAME_IS_REQUIRED\">Display Name is required.</span></div></div>\n</md-input-container><md-input-container flex><input class=\"txtbox\" type=\"number\" name=\"mobile\" \nng-model=\"vm.cMobileNumber\" placeholder=\"{{ \'HRMUSERS.MOBILE_NUMBER\' | translate }}\" autocomplete=\"off\">\n</md-input-container><md-input-container flex><div layout=\"row\" flex style=\"margin-top:-20px;margin-bottom:-30px\">\n<md-input-container flex><input type=\"password\" style=\"color:black\" name=\"text\" ng-model=\"vm.cPassword\" \nplaceholder=\"{{ \'HRMUSERS.PASSWORD\' | translate }}\" autocomplete=\"off\" required></md-input-container><div><md-button \nng-click=\"getForCustomer();\" class=\"md-raised\" translate=\"HRMUSERS.GENERATE\">generate</md-button></div></div>\n</md-input-container></div><div layout=\"row\" layout-sm=\"column\" style=\"margin-top:-25px\"><md-checkbox-container flex>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-model=\"checkboxModel.value\" type=\"checkbox\" ng-checked=\"true\">{{\'HRMUSERS.SEND_EMAIL_NOTIFICATION?\'| translate }}\n</md-checkbox></md-checkbox-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sCustomerSubmit()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid\">{{\'HRMUSERS.SUBMIT\'|translate}}\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">{{\'HRMUSERS.CANCEL\'|translate}}</md-button>\n</div></div></div></div></md-dialog-content></form></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(27vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left:-11px\r\n    }\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/hrmusers/Pagecancel.html","<md-dialog><form ng-cloak><md-dialog-content><p translate=\"HRMUSERS.DO_YOU_WANT_CANCEL?\">Do you want cancel?</p>\n</md-dialog-content><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Yespagecancel(UserId)\" class=\"md-raised md-accent\" translate=\"HRMUSERS.YES\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"closeDialog()\" translate=\"HRMUSERS.NO\">No</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/hrmusers/addroles.html","<md-dialog style=\"width:100%; overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"HRMUSERS.MANAGE ROLES\">Manage Role\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 15px 5px 15px\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \nclass=\"txtbox\" type=\"text\" name=\"RoleName\" ng-model=\"vm.uNewrole\" placeholder=\"{{ \'HRMUSERS.ROLE_NAME\' | translate }}\" \nng-readonly=\"rolereadonly\" required><div ng-messages=\"basicForm.RoleName.$error\" ng-show=\"basicForm.RoleName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"HRMUSERS.ROLENAME_IS_REQUIRED\">RoleName is required.</span>\n</div></div></md-input-container><md-input-container flex><input class=\"txtbox\" type=\"text\" name=\"Description\" \nng-model=\"vm.uDescription\" placeholder=\"{{ \'HRMUSERS.DESCRIPTION\' | translate }}\" ng-readonly=\"rolereadonly\"><div \nng-messages=\"basicForm.Description.$error\" ng-show=\"basicForm.Description.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"HRMUSERS.DESCRIPTION_IS_REQUIRED\">Description is required.</span></div></div>\n</md-input-container></div><span class=\"h4\" style=\"color:#7f9593\" translate=\"HRMUSERS.MODULES\"><b>Modules</b></span>\n<div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><md-checkbox ng-model=\"Human.value\" \nng-change=\"getdisabled(Human.value)\" ng-checked=\"ret2.Human==1\" type=\"checkbox\">{{\'HRMUSERS.HUMAN_RESOURCE\'|translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"Procurement.value\" \nng-change=\"getdisabled(Procurement.value)\" ng-checked=\"ret3.Procurement==1\" type=\"checkbox\">\n{{\'HRMUSERS.PROCUREMENT\'|translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"Operations.value\" ng-change=\"getdisabled(Operations.value)\" ng-checked=\"ret4.Operations==1\" type=\"checkbox\">\n{{\'HRMUSERS.OPERATIONS\'|translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"CRManagement.value\" ng-change=\"getdisabled(CRManagement.value)\" ng-checked=\"ret5.CRManagement==1\" \ntype=\"checkbox\">{{\'HRMUSERS.CUSTOMER_RELATIONSHIP\'|translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><md-checkbox ng-model=\"Accounts.value\" \nng-change=\"getdisabled(Accounts.value)\" ng-checked=\"ret6.Accounts==1\" type=\"checkbox\">{{\'HRMUSERS.ACCOUNTS\'|translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"Management.value\" \nng-change=\"getdisabled(Management.value)\" ng-checked=\"ret7.Management==1\" type=\"checkbox\">\n{{\'HRMUSERS.MANAGEMENT\'|translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"Tablet.value\" ng-change=\"getdisabled(Tablet.value)\" ng-checked=\"ret8.Tablet==1\" type=\"checkbox\">\n{{\'HRMUSERS.TABLET\'|translate}}</md-checkbox></md-input-container><md-input-container flex></md-input-container></div>\n</form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"clear:both\"><md-button \ntype=\"submit\" translate=\"HRMUSERS.SUBMIT\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"RolesSubmit()\" aria-label=\"Submit\" ng-disabled=\"!vm.uNewrole || !vm.chkbox\">Submit</md-button><md-button \ntype=\"submit\" translate=\"HRMUSERS.CANCEL\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div><br><table \nclass=\"table dataTable row-border hover\" style=\"width:100%; border:1px solid rgb(224, 224, 224)\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.ROLES\">Roles</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.MODULES\">Modules</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody \nstyle=\"font-size:small;font-weight:normal;color:black\"><tr \nng-repeat=\"(UserID, rows) in userModulesdatas | groupBy:\'UserID\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ UserID }}</td><td><p style=\"float: left;width:initial;padding-right:5px\" ng-repeat=\"row in rows\">\n{{ row.ModelID }}{{$last ? \'\' : \', \'}}</p></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Moduleedit(UserID)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></md-dialog-content></md-dialog><style>\n.thumbnail {\r\nfloat: left;\r\nwidth: 60px;\r\ndisplay: block;\r\n}\r\n/*.thumbnail > span:hover {\r\nbackground: #eee;\r\nbackground-size:5px;\r\n}*/\r\ntable {\r\nborder-collapse: collapse;\r\n}\r\n\r\n.tdthumbnail > td:hover {\r\nbackground: #eee;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/hrmusers/alertuser.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"HRMUSERS.DEACTIVATE_THIS_USER\">Deactivate this User\n</span><md-button class=\"md-icon-button\" ng-click=\"alertcancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \ntranslate=\"HRMUSERS.YES\" ng-click=\"Actsubmit(UserId)\" class=\"md-raised md-accent\">Yes</md-button><md-button \nclass=\"md-raised\" translate=\"HRMUSERS.NO\" ng-click=\"alertcancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/human-resource/hrmusers/hrmusers.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-circle\"></md-icon><span translate=\"HRMUSERS.HEADER\">Users</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"HRMUSERS.TOTAL_USERS\">Total Users:</span> <span>\n{{UserSummary.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'HRMUSERS.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"HRMUSERS.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAddCustomer($event)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span \ntranslate=\"HRMUSERS.ADD CUSTOMER\">Add Customer</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"HRMUSERS.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"HRMUSERS.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Rolesadd($event)\"><span translate=\"HRMUSERS.MANAGE ROLES\">Manage Roles</span></md-button></div></div><div \nclass=\"content-card\" ng-show=\"Usergrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"UserSummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.CLIENT\">Client</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.EMPLOYEE_ID\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"HRMUSERS.LOGIN_ID\">Login ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"HRMUSERS.EMAIL\">Email</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.ROLES\">Roles</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.LAST_LOGIN_DATE\">Last Login Date</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"HRMUSERS.ACTIVE\">Active?</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"HRMUSERS.LOCKED\">Locked?</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.VIEW/EDIT\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"HRMUSERS.DELETE\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"userdata in UserSummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ userdata.ClientName }}\n</td><td>{{ userdata.EmployeeID }}</td><td>{{ userdata.UserID }}</td><td>{{ userdata.Email }}</td><td>\n{{ userdata.Roles }}</td><td>{{ userdata.LastLoginDate | date:\'dd/MM/y hh:MM a\' }}</td><td><md-checkbox \nng-change=\"chkIsActive(userdata.ID,userdata.IsActive)\" ng-model=\"userdata.IsActive\" type=\"checkbox\"></md-checkbox></td>\n<td><md-checkbox ng-change=\"chkIsLocked(userdata.ID,userdata.IsLocked)\" ng-model=\"userdata.IsLocked\" type=\"checkbox\">\n</md-checkbox></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"userinfo(userdata.ID, $event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"userpopup($event, userdata.ID)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Userform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"HRMUSERS.CLIENT/LICENSOR\">Client/Licensor</label><input type=\"text\" style=\"color:black\" \nng-model=\"uClientName\" autocomplete=\"off\" readonly=\"readonly\"></md-input-container><md-input-container flex><label \ntranslate=\"HRMUSERS.EMPLOYEE_ID\">Employee ID</label><md-select ng-model=\"uEmployeeID\" name=\"Empid\" id=\"searchmodule\" \nmd-on-close=\"vm.searchE = \'\'\"><md-select-header><input ng-model=\"vm.searchE\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'HRMUSERS.EMPLOYEE_ID\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"uEmployeeID = null;vm.searchE = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchE\" ng-click=\"getEmailID(row.EmployeeID)\" value=\"{{row.EmployeeID}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select><div ng-messages=\"basicForm.Empid.$error\" \nng-show=\"basicForm.Empid.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HRMUSERS.EMPLOYEE_ID_IS_REQUIRED\">Employee ID is required.</span></div></div></md-input-container>\n<md-input-container flex><input class=\"txtbox\" style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"loginid\" \nng-model=\"formData.uLoginID\" placeholder=\"{{\'HRMUSERS.LOGIN_ID\'|translate}}\" required><div \nng-messages=\"basicForm.loginid.$error\" ng-show=\"basicForm.loginid.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"HRMUSERS.LOGIN_ID_IS_REQUIRED\">Login ID is required.</span></div></div><p ng-show=\"error1\" \nstyle=\"color:red\">Login ID Is already Exist.</p></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -16px\"><md-input-container flex><input type=\"email\" style=\"border-radius:3px;padding-left:5px\" \nname=\"email\" ng-model=\"formData.uEmail\" placeholder=\"{{ \'HRMUSERS.EMAIL\' | translate }}\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired><div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"HRMUSERS.EMAIL_FIELD_IS_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"HRMUSERS.EMAIL_MUST_BE_A_VALID_E-MAIL_ADDRESS\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"HRMUSERS.ROLES\">Roles</label><md-select ng-model=\"formData.selectedRole\" \nng-change=\"rolebased(formData.selectedRole)\" ng-model-options=\"{trackBy: \'$value.RoleName\'}\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" multiple=\"\" required><md-optgroup \nlabel=\"Roles\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchrole\" type=\"text\" \nplaceholder=\"{{ \'HRMUSERS.SELECT_ROLES\' | translate }}\"></md-select-header><md-option ng-value=\"Rolelist\" \nng-model=\"Rolelist.RoleName\" ng-repeat=\"Rolelist in Roledatas\">{{Rolelist.RoleName}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"HRMUSERS.EXPIRY_DATE\">Expiry Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -10px\"><md-input-container flex><input class=\"txtbox\" \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"displayname\" ng-model=\"formData.uUserName\" \nplaceholder=\"{{ \'HRMUSERS.DISPLAY_NAME\' | translate }}\" required><div ng-messages=\"basicForm.displayname.$error\" \nng-show=\"basicForm.displayname.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HRMUSERS.DISPLAY_NAME_IS_REQUIRED\">Display Name is required.</span></div></div></md-input-container>\n<md-input-container flex><input class=\"txtbox\" type=\"number\" name=\"mobile\" ng-model=\"formData.uMobileNumber\" \nplaceholder=\"{{ \'HRMUSERS.MOBILE_NUMBER\' | translate }}\" autocomplete=\"off\"></md-input-container><md-input-container \nflex><div layout=\"row\" flex style=\"margin-top:-20px;margin-bottom:-30px\"><md-input-container flex><input \ntype=\"password\" style=\"color:black\" name=\"text\" ng-model=\"formData.uPassword\" \nplaceholder=\"{{ \'HRMUSERS.PASSWORD\' | translate }}\" autocomplete=\"off\" required><div \nng-messages=\"basicForm.text.$error\" ng-show=\"basicForm.text.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HRMUSERS.PASSWORD_FIELD_IS_REQUIRED\">Password field is required.</span></div></div></md-input-container>\n<div><md-button ng-click=\"getNumber();\" class=\"md-raised\" translate=\"HRMUSERS.GENERATE\">generate</md-button></div>\n</div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" style=\"margin-top:-25px\"><md-checkbox-container \nflex></md-checkbox-container><md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-model=\"checkboxModel.value\" type=\"checkbox\" ng-checked=\"true\">\n{{\'HRMUSERS.SEND_EMAIL_NOTIFICATION?\'| translate }}</md-checkbox></md-checkbox-container></div></form><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox-container flex style=\"flex: 0.77\"><span class=\"h2\" \nstyle=\"color:#a2a2a2\" translate=\"HRMUSERS.PAGES\"><b>Pages</b></span></md-checkbox-container><md-checkbox-container \nstyle=\"font-size:16px;clear:both\"><md-checkbox ng-model=\"AllSelect.value\" ng-change=\"SelectAllchkbox()\" \ntype=\"checkbox\">{{\'HRMUSERS.SELECT_ALL\'| translate }}</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container></div><br><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox-container flex \nstyle=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>{{ \'HRMUSERS.REQUEST_FORMS\' | translate }}\n</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec46.LeaveR==1\" \nng-model=\"LeaveR.value\" type=\"checkbox\">{{ \'HRMUSERS.LEAVE_REQUEST\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec47.MaterialR==1\" \nng-model=\"MaterialR.value\" type=\"checkbox\">{{ \'HRMUSERS.MATERIAL_REQUEST\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec48.PurchaseR==1\" \nng-model=\"PurchaseR.value\" type=\"checkbox\">{{ \'HRMUSERS.PURCHASE_REQUEST\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec49.UniformR==1\" \nng-model=\"UniformR.value\" type=\"checkbox\">{{ \'HRMUSERS.UNIFORM_REQUEST\' | translate }}</md-checkbox>\n</md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox-container flex \nstyle=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec50.Incident==1\" ng-model=\"Incident.value\" type=\"checkbox\">{{ \'HRMUSERS.INCIDENT_REPORT\' | translate }}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec51.Medical==1\" \nng-model=\"Medical.value\" type=\"checkbox\">{{ \'HRMUSERS.MEDICAL_CLAIM\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec52.Expense==1\" \nng-model=\"Expense.value\" type=\"checkbox\">{{ \'HRMUSERS.EXPENSE_CLAIM\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec53.Payment==1\" \nng-model=\"Payment.value\" type=\"checkbox\">{{ \'HRMUSERS.PAYMENT_VOUCHER\' | translate }}</md-checkbox>\n</md-checkbox-container></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Humandiv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>Human Resource\n</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec36.DHuman==1\" \nng-model=\"DHuman.value\" type=\"checkbox\">{{\'HRMUSERS.DASHBOARD\'| translate}}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec44.Hrmusers==1\" ng-model=\"Hrmusers.value\" type=\"checkbox\">\n{{\'HRMUSERS.USERS & WORKFLOW\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec3.HRMAdmin==1\" ng-model=\"HRMAdmin.value\" type=\"checkbox\">\n{{ \'HRMUSERS.HRM_ADMIN\' | translate }}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec4.HRMCore==1\" ng-model=\"HRMCore.value\" type=\"checkbox\">{{ \'HRMUSERS.HRM_CORE\' | translate }}\n</md-checkbox></md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Humandiv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec41.Health==1\" ng-model=\"Health.value\" type=\"checkbox\">Health & Safety</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec12.Training==1\" \nng-model=\"Training.value\" type=\"checkbox\">{{ \'HRMUSERS.TRAINING\' | translate }}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec42.Insurance==1\" ng-model=\"Insurance.value\" type=\"checkbox\">\n{{\'HRMUSERS.INSURANCE\' | translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec11.Recruitment==1\" ng-model=\"Recruitment.value\" type=\"checkbox\">{{\'HRMUSERS.RECRUITMENT\'| translate}}\n</md-checkbox></md-checkbox-container></div><br><div layout=\"column\" layout-gt-sm=\"row\" ng-show=\"Salediv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>Human Resource\n</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec38.DCRM==1\" \nng-model=\"DCRM.value\" type=\"checkbox\">{{\'HRMUSERS.DASHBOARD\'| translate}}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec7.PestType==1\" ng-model=\"PestType.value\" type=\"checkbox\">\n{{\'HRMUSERS.PEST TYPES\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec13.CrmSettings==1\" ng-model=\"CrmSettings.value\" type=\"checkbox\">{{\'HRMUSERS.SETTINGS\'| translate}}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec9.Customers==1\" \nng-model=\"Customers.value\" type=\"checkbox\">{{\'HRMUSERS.CUSTOMERS\'| translate}}</md-checkbox></md-checkbox-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Salediv\"><md-checkbox-container flex \nstyle=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec14.Lead==1\" ng-model=\"Lead.value\" type=\"checkbox\">{{ \'HRMUSERS.LEAD_MANAGEMENT\' | translate }}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec55.Estimation==1\" \nng-model=\"Estimation.value\" type=\"checkbox\">{{\'HRMUSERS.ESTIMATION\' | translate}}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec16.Sales==1\" ng-model=\"Sales.value\" type=\"checkbox\">\n{{ \'HRMUSERS.WORK_ORDER\' | translate }}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec18.Contracts==1\" ng-model=\"Contracts.value\" type=\"checkbox\">{{\'HRMUSERS.CONTRACTS\'| translate}}\n</md-checkbox></md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Salediv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec15.Quotation==1\" ng-model=\"Quotation.value\" type=\"checkbox\">\n{{\'HRMUSERS.QUOTATION_TEMPLATE\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Procurementdiv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>\n{{ \'HRMUSERS.PROCUREMENT\' | translate }}</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec37.DProcurement==1\" ng-model=\"DProcurement.value\" type=\"checkbox\">{{\'HRMUSERS.DASHBOARD\'| translate}}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec5.Products==1\" \nng-model=\"Products.value\" type=\"checkbox\">{{\'HRMUSERS.PRODUCTS\'| translate}}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec6.Supliers==1\" ng-model=\"Supliers.value\" type=\"checkbox\">\n{{ \'HRMUSERS.SUPPLIERS\' | translate }}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec17.Stores==1\" ng-model=\"Stores.value\" type=\"checkbox\">{{ \'HRMUSERS.STORES\' | translate }}</md-checkbox>\n</md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Procurementdiv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec22.Requests==1\" ng-model=\"Requests.value\" type=\"checkbox\">\n{{\'HRMUSERS.REQUESTS\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec20.PurchaseOrder==1\" ng-model=\"PurchaseOrder.value\" type=\"checkbox\">\n{{\'HRMUSERS.PURCHASE_ORDER\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec21.StockManagement==1\" ng-model=\"StockManagement.value\" type=\"checkbox\">\n{{\'HRMUSERS.STOCK_MANAGEMENT\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec34.Vehicle==1\" ng-model=\"Vehicle.value\" type=\"checkbox\">\n{{\'HRMUSERS.VEHICLE_MANAGEMENT\'| translate}}</md-checkbox></md-checkbox-container></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex ng-show=\"Operationsdiv\"><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span \nclass=\"h4\" style=\"color:#7f9593\"><b>Operation</b></span></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec39.DOperations==1\" ng-model=\"DOperations.value\" type=\"checkbox\">\n{{\'HRMUSERS.DASHBOARD\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec45.Division==1\" ng-model=\"Division.value\" type=\"checkbox\">{{\'HRMUSERS.DIVISION\'| translate}}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec8.Services==1\" \nng-model=\"Services.value\" type=\"checkbox\">{{ \'HRMUSERS.SERVICES\' | translate }}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec56.Materials==1\" ng-model=\"Materials.value\" type=\"checkbox\">\n{{\'HRMUSERS.MATERIALS\'| translate}}</md-checkbox></md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex ng-show=\"Operationsdiv\"><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec32.Teams==1\" ng-model=\"Teams.value\" type=\"checkbox\">\n{{\'HRMUSERS.TEAMS\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec33.Scheduler==1\" ng-model=\"Scheduler.value\" type=\"checkbox\">Scheduler</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec31.Feedback==1\" \nng-model=\"Feedback.value\" type=\"checkbox\">Feedback</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec57.OperationsReport==1\" ng-model=\"OperationsReport.value\" type=\"checkbox\">Reports\n</md-checkbox></md-checkbox-container></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Accountsdiv\">\n<md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>\n{{ \'HRMUSERS.ACCOUNTS\' | translate }}</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec40.DAccounts==1\" ng-model=\"DAccounts.value\" type=\"checkbox\">{{\'HRMUSERS.DASHBOARD\'| translate}}\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec23.Setting==1\" \nng-model=\"Setting.value\" type=\"checkbox\">{{\'HRMUSERS.GENERAL SETTINGS\'| translate}}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec26.PurchasesPayables==1\" \nng-model=\"PurchasesPayables.value\" type=\"checkbox\">{{ \'HRMUSERS.PAYABLES\' | translate }}</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec27.SalesReceivables==1\" \nng-model=\"SalesReceivables.value\" type=\"checkbox\">{{ \'HRMUSERS.SALES\' | translate }}</md-checkbox>\n</md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-show=\"Accountsdiv\"><md-checkbox-container\n flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec25.BankCash==1\" ng-model=\"BankCash.value\" type=\"checkbox\">Bank & Cash</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec28.Asset==1\" ng-model=\"Asset.value\" \ntype=\"checkbox\">{{\'HRMUSERS.FIXED ASSET MANAGEMENT\'| translate}}</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec24.Ledger==1\" ng-model=\"Ledger.value\" type=\"checkbox\">\n{{\'HRMUSERS.REPORTS\'| translate}}</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container></div><br></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" translate=\"HRMUSERS.SUBMIT\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" translate=\"HRMUSERS.CANCEL\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><br></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\nmd-checkbox {\r\n        margin-bottom: 2px !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .price-tables .price-table.style-1 .price {\r\n        padding: 0px 0px 0px 0px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/hrmusers/userpopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span translate=\"HRMUSERS.DELETE_THIS_USER?\" \nclass=\"title\">Delete this User?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Userdelete(deleteID)\" class=\"md-raised md-accent\">{{\'HRMUSERS.YES\'|translate}}</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'HRMUSERS.NO\'|translate}}</md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/hrmworkflow/hrmworkflow.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"RECRUITMENT.WORKFLOW\">Workflow</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"RECRUITMENT.TOTAL_USERS\">Total Workflows:</span> <span>\n{{Workflowdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH\'|translate}}\" flex></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span translate=\"RECRUITMENT.ADD\">Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"RECRUITMENT.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"RECRUITMENT.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Workflowgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Workflowdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.CLIENT\" class=\"column-title\">Client Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.TYPE_NAME\" \nclass=\"column-title\">Type Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.LEVEL\" class=\"column-title\">Level</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"RECRUITMENT.ACTION\" class=\"column-title\">Action</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"RECRUITMENT.ACTIONED\" class=\"column-title\">Actioned</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"RECRUITMENT.NEXT_LEVEL\" class=\"column-title\">Next Level</span></div></th><th class=\"secondary-text\"><div>\n<span translate=\"RECRUITMENT.APPROVERS\" class=\"column-title\">Approvers</span></div></th><th class=\"secondary-text\">\n<div><span translate=\"RECRUITMENT.NOTIFY_TO\" class=\"column-title\">Notify To</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Workflowdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">\n{{ row.Client_Id }}</td><td nowrap=\"nowrap\">{{ row.TypeName }}</td><td nowrap=\"nowrap\">{{ row.LevelName }}</td><td>\n{{ row.Action }}</td><td>{{ row.Actioned }}</td><td>{{ row.NextLevel}}</td><td>{{ row.Approvers}}</td><td>\n{{ row.NotifyTo}}</td><td ng-click=\"Workflowinfo(row._id)\" class=\"editMe\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Workflowinfo(row._id)\">\n<md-icon md-font-icon=\"icon-pencil\" ng-click=\"Workflowinfo(row._id)\"></md-icon></md-button></td></tr></tbody></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Workflowform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"RECRUITMENT.CLIENT/LICENSOR\">Client/Licensor</label><input type=\"text\" \nstyle=\"color:black\" ng-model=\"uClientName\" autocomplete=\"off\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><label translate=\"RECRUITMENT.TYPE_NAME\">Type Name</label><md-select ng-model=\"TypeName\" \nid=\"searchmodule\" required><md-option value=\"\" translate=\"RECRUITMENT.SELECT_TYPE_NAME\">Select Type Name</md-option>\n<md-option value=\"HRM Employee Appraisal\">{{\'RECRUITMENT.HRM_EMPLOYEE_APPRAISAL\'|translate}}</md-option><md-option \nvalue=\"HRM Leave Request\" translate=\"RECRUITMENT.HRM_LEAVE_REQUEST\">HRM Leave Request</md-option><md-option \nvalue=\"HRM Incident Report\" translate=\"RECRUITMENT.HRM_INCIDENT_REPORT\">HRM Incident Report</md-option><md-option \nvalue=\"HRM Medical Claim Request\" translate=\"RECRUITMENT.HRM MEDICAL CLAIM REQUEST\">HRM Medical Claim Request\n</md-option><md-option value=\"Inventory Purchase Request\" translate=\"RECRUITMENT.INVENTORY PURCHASE REQUEST\">\nInventory Purchase Request</md-option><md-option value=\"Inventory Material Request\" \ntranslate=\"RECRUITMENT.INVENTORY MATERIAL REQUEST\">Inventory Material Request</md-option><md-option \nvalue=\"Inventory Uniform Request\" translate=\"RECRUITMENT.INVENTORY UNIFORM REQUEST\">Inventory Uniform Request\n</md-option><md-option value=\"Inventory Purchase Order\" translate=\"RECRUITMENT.INVENTORY PURCHASE ORDER\">\nInventory Purchase Order</md-option><md-option value=\"Inventory Stock Issuance\" \ntranslate=\"RECRUITMENT.INVENTORY STOCK ISSUANCE\">Inventory Stock Issuance</md-option><md-option value=\"CRM Leads\" \ntranslate=\"RECRUITMENT.CRM LEADS\">CRM Leads</md-option><md-option value=\"CRM Contract\" \ntranslate=\"RECRUITMENT.CRM CONTRACT\">CRM Contract</md-option><md-option value=\"Accounts Expense Claim\" \ntranslate=\"RECRUITMENT.ACCOUNTS EXPENSE CLAIM\">Accounts Expense Claim</md-option><md-option \nvalue=\"Accounts Payment Voucher\" translate=\"RECRUITMENT.ACCOUNTS PAYMENT VOUCHER\">Accounts Payment Voucher</md-option>\n<md-option value=\"Accounts Purchase Invoice\" translate=\"RECRUITMENT.ACCOUNTS PURCHASE INVOICE\">\nAccounts Purchase Invoice</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" \nname=\"LevelName\" ng-model=\"LevelName\" placeholder=\"{{\'RECRUITMENT.LEVEL\'|translate}}\" required><div \nng-messages=\"basicForm.LevelName.$error\" ng-show=\"basicForm.LevelName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.LEVEL IS REQUIRED\">Level is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Action\" ng-model=\"Action\" \nplaceholder=\"{{\'RECRUITMENT.ACTION\'|translate}}\" required><div ng-messages=\"basicForm.Action.$error\" \nng-show=\"basicForm.Action.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.ACTION IS REQUIRED\">Action is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Actioned\" ng-model=\"Actioned\" \nplaceholder=\"{{\'RECRUITMENT.ACTIONED TEXT\'|translate}}\" required><div ng-messages=\"basicForm.Actioned.$error\" \nng-show=\"basicForm.Actioned.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.ACTIONED TEXT IS REQUIRED\">Actioned Text is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Next Level\" ng-model=\"NextLevel\" \nplaceholder=\"{{\'RECRUITMENT.NEXT_LEVEL\'|translate}}\"></md-input-container><md-input-container flex><label \ntranslate=\"RECRUITMENT.APPROVERS\">Approvers</label><md-select ng-model=\"Approvers\" \nng-model-options=\"{trackBy: \'$value.UserID\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input \nng-model=\"searchTerm\" type=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH USER\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Userdatas  | filter:searchTerm\">{{row.UserID}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label translate=\"RECRUITMENT.NOTIFY_TO\">Notify To</label><md-select \nng-model=\"NotifyTo\" ng-model-options=\"{trackBy: \'$value.UserID\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\">\n<md-select-header><input ng-model=\"searchTerm1\" type=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH USER\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Userdatas | filter:searchTerm1\">{{row.UserID}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"test\" \nname=\"AlwaysNotifyTo\" ng-model=\"AlwaysNotifyTo\" placeholder=\"{{\'RECRUITMENT.ALWAYS NOTIFY TO\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"test\" name=\"EmailExceptions\" ng-model=\"EmailExceptions\" \nplaceholder=\"{{\'RECRUITMENT.EMAIL EXCEPTIONS\'|translate}}\"></md-input-container><md-input-container flex><md-checkbox \nng-model=\"ShowCancelButton.value\" type=\"checkbox\">{{\'RECRUITMENT.SHOW CANCEL BUTTON?\'|translate}}</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"ShowRejectButton.value\" type=\"checkbox\">\n{{\'RECRUITMENT.SHOW REJECT BUTTON?\'|translate}}</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><md-checkbox ng-model=\"ShowReviseButton.value\" type=\"checkbox\">\n{{\'RECRUITMENT.SHOW REVISE BUTTON?\'|translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox\n ng-model=\"Mandatory.value\" type=\"checkbox\">{{\'RECRUITMENT.MANDATORY\'|translate}}</md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-model=\"EmailNotification.value\" type=\"checkbox\">\n{{\'RECRUITMENT.EMAIL NOTIFICATION?\'|translate}}</md-checkbox></md-input-container><md-input-container flex><md-checkbox\n ng-model=\"NotifytoCurrentApprover.value\" type=\"checkbox\">{{\'RECRUITMENT.NOTIFY TO CURRENT APPROVER?\'|translate}}\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox \nng-model=\"NotifytoNextLevelApprover.value\" type=\"checkbox\">{{\'RECRUITMENT.NOTIFY TO NEXT APPROVER?\'|translate}}\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"NotifytoCreatorInitator.value\" \ntype=\"checkbox\">{{\'RECRUITMENT.NOTIFY TO CREATOR/INITIATOR?\'|translate}}</md-checkbox></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{\'RECRUITMENT.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></form></div></div></div>\n</div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/incidentform/incidentform.html","<div id=\"incidentform\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Incident Report</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"iSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"iAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"iView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"iExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Incidentgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Incidentdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Edit Request</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reported By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reported To</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reported Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Incident Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Incident Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Incidentdatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewIncidentinfo(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Incidentinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.InjuredEmployeedetails[0].EmployeeID }}-{{ row.InjuredEmployeedetails[0].EmployeeName }}</td><td>\n{{ row.ReportedByEmployeedetails[0].EmployeeID }}-{{ row.ReportedByEmployeedetails[0].EmployeeName }}</td><td>\n{{ row.ReportedToEmployeedetails[0].EmployeeID }}-{{ row.ReportedToEmployeedetails[0].EmployeeName }}</td><td>\n{{ row.ReportDate | date:\'dd/MM/y\' }}</td><td>{{ row.IncidentDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.IncidentLocation }}</td><td>{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Incidentform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div>\n<div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Employee Name</label><md-select \nng-model=\"InjuredName\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Employee..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"InjuredName=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm1\" value=\"{{row.id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select><div ng-messages=\"basicForm.InjuredName.$error\" \nng-show=\"basicForm.InjuredName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Employee Name Required.</span>\n</div></div></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label>\nReporting Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"ReportDate\" md-date-format=\"dd/MM/y\" required>\n</md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label>\nIncident Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"IncidentDate\" md-date-format=\"dd/MM/y\" required>\n</md-datepicker></md-input-container><md-input-container flex><input type=\"time\" name=\"IncidentTime\" \nng-model=\"IncidentTime\" placeholder=\"Incident Time\" required><div ng-messages=\"basicForm.IncidentTime.$error\" \nng-show=\"basicForm.IncidentTime.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Incident Time is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\">\n<md-input-container flex><label>Incident Location</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"IncidentLocation\" placeholder=\"\" required><div \nng-messages=\"basicForm.LOI.$error\" ng-show=\"basicForm.LOI.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nIncident Location is required.</span></div></div></md-input-container><md-input-container flex><label>\nIncident Reported By</label><md-select ng-model=\"ReportedBy\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Reported By..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"ReportedBy=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm2\" value=\"{{row.id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>\nIncident Reported To</label><md-select ng-model=\"ReportedTo\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Reported To..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"ReportedTo=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm3\" value=\"{{row.id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"><div ng-messages=\"basicForm.Remarks.$error\" \nng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Remarks Required.</span></div></div>\n</md-input-container></div><h2 style=\"text-align:left\">\n&nbsp;Nature of injury, injury type and part of the body affected(describe the injury, e.g. strain, sprain,cut, etc.)\n<hr></h2><div class=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"NatureofInjury\"></text-angular></div><h2 style=\"text-align:left\">\n&nbsp;Describe the Incident/accident and how it occurred: (Fill by Investigation Team/ Departmental Head In-charge)<hr>\n</h2><div class=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"IncidentOccured\"></text-angular></div><h2 style=\"text-align:left\">\n&nbsp;Caused of the Incident/accident: (Fill by Respective Departmental Head/Representative)<hr></h2><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"IncidentCause\"></text-angular></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex>\n<md-radio-group ng-model=\"PPERequired\" layout=\"row\"><span style=\"width:350px\"><b>\nPersonal protective equipment required?</b></span><md-radio-button value=\"No\">No</md-radio-button><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"PPEProvided\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Personal protective equipment provided?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-radio-group ng-model=\"PPEUsed\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Personal protective equipment being used?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button>&emsp;</md-radio-group><md-input-container flex>\n<input type=\"text\" ng-model=\"PPEUsedRemarks\" placeholder=\"If No, Explain\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\"><md-radio-group ng-model=\"PPETrained\" layout=\"row\"><span \nstyle=\"width:415px\"><b>Personal protective equipment being used as trained?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button>&emsp;</md-radio-group><md-input-container flex>\n<input type=\"text\" ng-model=\"PPETrainedRemarks\" placeholder=\"If No, Explain\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\"><md-radio-group ng-model=\"SafetyTaining\" layout=\"row\">\n<span style=\"width:350px\"><b>Safety training provided to the injured?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button>&emsp;</md-radio-group><md-input-container flex>\n<input type=\"text\" ng-model=\"SafetyTainingRemarks\" placeholder=\"If No, Explain\"></md-input-container></div><h2 \nstyle=\"text-align:left\">&nbsp;Witness(es)- List of Name, Address, Contact Number<hr></h2><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Witnesspopup($event, UniqueID)\"><span>Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" style=\"margin-top: -35px\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Contact Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Incidentwitnessdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Name }}</td><td>{{ row.Address }}</td><td>{{ row.ContactNo}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Witnessupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button\n id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Witnessdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><h2 style=\"text-align:left;margin-top: -25px\">\n&nbsp;Refer to CORRECTIVE ACTION for corrective action taken to prevent recurrence.<hr></h2><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nCorrective Action Report Reference Number:</b></span> <input type=\"text\" ng-model=\"CorrectiveActionRefNo\" \nplaceholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\">\n<md-radio-container flex><md-radio-group ng-model=\"RiskAssessmentReviewed\" layout=\"row\"><span style=\"width:350px\"><b>\nRisk Assessment Reviewed:</b></span><md-radio-button value=\"No\">No</md-radio-button><md-radio-button value=\"Yes\">Yes\n</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"RiskAssessmentRevised\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Risk Assessment Revised:</b></span><md-radio-button value=\"No\">No</md-radio-button>\n<md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"PreventiveAction\" \nlayout=\"row\"><span style=\"width:350px\"><b>Preventive Action to be Initiated:</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div></div>\n</div></form><br><form name=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\">\n<md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" \nrequired></md-input-container></div><div style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" \nng-click=\"commentSubmit()\" ng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button>\n</div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMHealth&Safety/IncidentReport/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"iSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><div \nclass=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewIncidentform\" flex><form \nname=\"basicForm11\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"text\" name=\"ReferenceNo\" ng-model=\"ReferenceNo\" placeholder=\"Reference #\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"InjuredEmployeeName\" \nng-model=\"InjuredEmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\"></md-input-container><md-input-container\n flex style=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"ReportDate\" \nng-model=\"ReportDate | date:\'dd/MM/y\'\" placeholder=\"Reporting Date\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"IncidentDate\" \nng-model=\"IncidentDate | date:\'dd/MM/y\'\" placeholder=\"Incident Date\" readonly=\"readonly\"></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-25px\"><md-input-container flex><input type=\"text\" \nname=\"IncidentTime\" ng-model=\"IncidentTime | date: \'h:mm a\'\" placeholder=\"Incident Time\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"IncidentLocation\" ng-model=\"IncidentLocation\" \nplaceholder=\"Incident Location\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"ReportedByEmployeeName\" ng-model=\"ReportedByEmployeeName\" placeholder=\"Incident Reported By\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"ReportedToEmployeeName\" \nng-model=\"ReportedToEmployeeName\" placeholder=\"Incident Reported To\" readonly=\"readonly\"></md-input-container></div>\n<div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"margin-top:-25px\"><md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\" readonly=\"readonly\"></md-input-container></div><h2 \nstyle=\"text-align:left\">\n&nbsp;Nature of injury, injury type and part of the body affected(describe the injury, e.g. strain, sprain,cut, etc.)\n<hr></h2><div class=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"NatureofInjury\"></text-angular></div><h2 style=\"text-align:left\">\n&nbsp;Describe the Incident/accident and how it occurred: (Fill by Investigation Team/ Departmental Head In-charge)<hr>\n</h2><div class=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"IncidentOccured\"></text-angular></div><h2 style=\"text-align:left\">\n&nbsp;Caused of the Incident/accident: (Fill by Respective Departmental Head/Representative)<hr></h2><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"IncidentCause\"></text-angular></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex>\n<md-radio-group ng-model=\"PPERequired\" layout=\"row\"><span style=\"width:350px\"><b>\nPersonal protective equipment required?</b></span><md-radio-button value=\"No\">No</md-radio-button><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"PPEProvided\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Personal protective equipment provided?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-radio-group ng-model=\"PPEUsed\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Personal protective equipment being used?</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button>&emsp;</md-radio-group><md-input-container flex>\n<input type=\"text\" ng-model=\"PPEUsedRemarks\" placeholder=\"If No, Explain\" readonly=\"readonly\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\"><md-radio-group ng-model=\"PPETrained\" \nlayout=\"row\"><span style=\"width:415px\"><b>Personal protective equipment being used as trained?</b></span>\n<md-radio-button value=\"No\">No</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button>&emsp;\n</md-radio-group><md-input-container flex><input type=\"text\" ng-model=\"PPETrainedRemarks\" placeholder=\"If No, Explain\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\">\n<md-radio-group ng-model=\"SafetyTaining\" layout=\"row\"><span style=\"width:350px\"><b>\nSafety training provided to the injured?</b></span><md-radio-button value=\"No\">No</md-radio-button><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button>&emsp;</md-radio-group><md-input-container flex><input type=\"text\" \nng-model=\"SafetyTainingRemarks\" placeholder=\"If No, Explain\" readonly=\"readonly\"></md-input-container></div><h2 \nstyle=\"text-align:left\">&nbsp;Witness(es)- List of Name, Address, Contact Number<hr></h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" style=\"margin-top: -70px\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Contact Number</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Incidentwitnessdatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>{{ row.Address }}</td><td>\n{{ row.ContactNo}}</td></tr></tbody></table></div><br><h2 style=\"text-align:left;margin-top: -25px\">\n&nbsp;Refer to CORRECTIVE ACTION for corrective action taken to prevent recurrence.<hr></h2><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nCorrective Action Report Reference Number:</b></span> <input type=\"text\" ng-model=\"CorrectiveActionRefNo\" \nplaceholder=\"\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"RiskAssessmentReviewed\" layout=\"row\"><span \nstyle=\"width:350px\"><b>Risk Assessment Reviewed:</b></span><md-radio-button value=\"No\">No</md-radio-button>\n<md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-radio-container flex><md-radio-group ng-model=\"RiskAssessmentRevised\" \nlayout=\"row\"><span style=\"width:350px\"><b>Risk Assessment Revised:</b></span><md-radio-button value=\"No\">No\n</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group></md-radio-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-radio-container flex><md-radio-group \nng-model=\"PreventiveAction\" layout=\"row\"><span style=\"width:350px\"><b>Preventive Action to be Initiated:</b></span>\n<md-radio-button value=\"No\">No</md-radio-button><md-radio-button value=\"Yes\">Yes</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr>\n<div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" \nname=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm11.$invalid || basicForm11.$pristine\"><span>Save</span></md-button></div><md-progress-linear \nng-hide=\"Commentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-inputs\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-inputs\" flow-btn id=\"file-inputs\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMHealth&Safety/IncidentReport/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -80px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/incidentform/witness.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">WITNESS(ES) LIST</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.wName\" placeholder=\"Name\" \nrequired><div ng-messages=\"eventForm.vm.wName.$error\" ng-show=\"eventForm.vm.wName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Name is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:-27px\"><md-input-container flex><label>Address</label><input places-auto-complete \ntypes=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\" ng-model=\"vm.wAddress\" placeholder=\"\" required><div \nng-messages=\"eventForm.vm.wAddress.$error\" ng-show=\"eventForm.vm.wAddress.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Address is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" ng-model=\"vm.wContactNo\" \nplaceholder=\"Contact Number\" required><div ng-messages=\"eventForm.vm.wContactNo.$error\" \nng-show=\"eventForm.vm.wContactNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Contact Number is required.\n</span></div></div></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Witnessadd()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n        max-width: 1000px;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/incidentform/witnessdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this incident witness?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Wdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/leaveform/leaveCancel.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this leave request?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Cancelrequest(CancellID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/leaveform/leaveform.html","<div id=\"leaveform\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Leave Request</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"lSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"lAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"lView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"lExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Leavegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Leavedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Cancel Request</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Leave Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Leave From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Leave To</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Paid Leaves</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unpaid Leaves</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Leavedatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewLeaveinfo(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n<md-button ng-hide=\"row.Status ==\'Cancelled\' ||row.Status ==\'Rejected\'\" id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"LeaveCancellPopup($event,row._id, $index)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.LeaveType }}</td><td>\n{{ row.FromDate | date:\'dd/MM/y\' }}</td><td>{{ row.ToDate | date:\'dd/MM/y\' }}</td><td>{{ row.TotalDaysApplied }}</td>\n<td>{{ row.TotalPaidLeaves }}</td><td>{{ row.TotalUnPaidLeaves }}</td><td>{{ row.Status }}</td></tr></tbody></table>\n</div></div><div class=\"content\" ng-show=\"Leaveform\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nflex><md-progress-circular ng-hide=\"Leavedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-circular><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\">\n<md-button class=\"md-accent md-raised\" ng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span>Cancel Request</span>\n</md-button></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"EmployeeName\" ng-model=\"RequestedByEmployee\" placeholder=\"Employee Name\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><label>Leave Type</label><md-select ng-model=\"LeaveType\" \nng-change=\"OnLeaveChange()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Leave Type..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"LeaveType=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in LeaveList | filter:vm.searchTerm1\" value=\"{{row.Name}}\">{{row.Name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\">\n<md-input-container style=\"margin-top: 18px;margin-left:-10px\"><label>From Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"FromDate\" ng-change=\"OnDateChange()\" md-date-format=\"dd/MM/y\" required>\n</md-datepicker></md-input-container><md-radio-group ng-model=\"FromDayType\" ng-change=\"OnDateChange()\" layout=\"row\">\n&emsp; &emsp;<md-radio-button value=\"Full Day\">Full Day</md-radio-button><md-radio-button value=\"Morning\">Morning\n</md-radio-button><md-radio-button value=\"Noon\">Noon</md-radio-button></md-radio-group></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -25px\"><md-input-container style=\"margin-top: 18px;margin-left:-10px\"><label>\nTo Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"ToDate\" ng-change=\"OnDateChange()\" \nmd-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container><md-radio-group ng-model=\"ToDayType\" \nng-change=\"OnDateChange()\" ng-hide=\"isDisabled\" layout=\"row\">&emsp; &emsp;<md-radio-button value=\"Full Day\">Full Day\n</md-radio-button><md-radio-button value=\"Morning\">Morning</md-radio-button><md-radio-button value=\"Noon\">Noon\n</md-radio-button></md-radio-group></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-20px;margin-bottom:-20px\"><md-input-container flex><input type=\"text\" name=\"Reason\" \nng-model=\"Reason\" placeholder=\"Reason for Taking Leave\"><div ng-messages=\"basicForm.Reason.$error\" \nng-show=\"basicForm.Reason.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Reason is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"number\" name=\"EmergencyContactNo\" \nng-model=\"EmergencyContactNo\" placeholder=\"Emergency Contact Number\"><div \nng-messages=\"basicForm.EmergencyContactNo.$error\" ng-show=\"basicForm.EmergencyContactNo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Emergency Contact Number is required.</span></div></div></md-input-container></div><h2>\n<strong>Leave </strong>Details<hr></h2><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\"><label \nstyle=\"width:180px\">Total Days</label>: &emsp; <span style=\"font-weight:bold\"><b>{{TotalDaysApplied}}</b></span></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:10px\"><label style=\"width:180px\">Total Paid Leaves</label>\n: &emsp; <span style=\"font-weight:bold\"><b>{{TotalPaidLeaves}}</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:10px\"><label style=\"width:180px\">Total Unpaid Leaves</label>: &emsp; <span style=\"font-weight:bold\">\n<b>{{TotalUnPaidLeaves}}</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:10px\"><label \nstyle=\"width:180px\">Leave Taken</label>: &emsp; <span style=\"font-weight:bold\"><b>\n{{LeaveTaken}} (Excluding this request)</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:10px\"><label style=\"width:180px\">Leave Balance</label>: &emsp; <span style=\"font-weight:bold\"><b>\n{{LeaveBalance}} (Excluding this request)</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:10px\"><label style=\"width:180px\">Leave Entitlement</label>: &emsp; <span style=\"font-weight:bold\"><b>\n{{LeaveEntitlement}}</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:10px\"><label \nstyle=\"width:180px\">Total Worked Months</label>: &emsp; <span style=\"font-weight:bold\"><b>{{TotalWorkedMonths}} months.\n</b></span></div></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"lSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></form><br><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr>\n<div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" \nname=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br></div></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewLeaveform\" flex><form name=\"basicForm11\" class=\"md-inline-form\" \nnovalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"ReferenceNo\" \nng-model=\"ReferenceNo\" placeholder=\"Reference #\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"EmployeeName\" ng-model=\"EmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"LeaveType\" ng-model=\"LeaveType\" \nplaceholder=\"Leave Type\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -25px\"><md-input-container flex style=\"margin-top: 18px\"><input type=\"text\" name=\"FromDate\" \nng-model=\"FromDate | date:\'dd/MM/y\'\" placeholder=\"From Date\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"FromDayType\" ng-model=\"FromDayType\" placeholder=\"From Day Type\" \nreadonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top: 18px\" flex><input type=\"text\" \nname=\"ToDate\" ng-model=\"ToDate | date:\'dd/MM/y\'\" placeholder=\"To Date\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"ToDayType\" ng-model=\"ToDayType\" placeholder=\"To Day Type\" \nreadonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"margin-top: -25px\"><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Reason\" \nplaceholder=\"Reason for Taking Leave\" readonly=\"readonly\"></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"ECNumber\" ng-model=\"EmergencyContactNo\" placeholder=\"Emergency Contact Number\" readonly=\"readonly\">\n</md-input-container></div><h2><strong>Leave </strong>Details<hr></h2><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -25px\"><label style=\"width:180px\">Total Days</label>: &emsp; <span style=\"font-weight:bold\"><b>\n{{TotalDaysApplied}}</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:10px\"><label \nstyle=\"width:180px\">Total Paid Leaves</label>: &emsp; <span style=\"font-weight:bold\"><b>{{TotalPaidLeaves}}</b></span>\n</div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:10px\"><label style=\"width:180px\">Total Unpaid Leaves\n</label>: &emsp; <span style=\"font-weight:bold\"><b>{{TotalUnPaidLeaves}}</b></span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:10px\"><label style=\"width:180px\">Leave Taken</label>: &emsp; <span \nstyle=\"font-weight:bold\"><b>{{LeaveTaken}} (Excluding this request)</b></span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:10px\"><label style=\"width:180px\">Leave Balance</label>: &emsp; <span \nstyle=\"font-weight:bold\"><b>{{LeaveBalance}} (Excluding this request)</b></span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:10px\"><label style=\"width:180px\">Leave Entitlement</label>: &emsp; <span \nstyle=\"font-weight:bold\"><b>{{LeaveEntitlement}}</b></span></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:10px\"><label style=\"width:180px\">Total Worked Months</label>: &emsp; <span style=\"font-weight:bold\">\n<b>{{TotalWorkedMonths}} months.</b></span></div></div></div><br><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\">\n<md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" \nrequired></md-input-container></div><div style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" \nng-click=\"commentSubmit()\" ng-disabled=\"basicForm11.$invalid || basicForm11.$pristine\"><span>Save</span></md-button>\n</div><md-progress-linear ng-hide=\"Commentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-inputs\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-inputs\" flow-btn id=\"file-inputs\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/medicalform/medicalform.html","<div id=\"medicalform\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Medical Claim</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"mSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"mAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"mView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"mExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Medicalgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Medicaldatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Edit Request</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Requester Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Claim Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Visit Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Medical Institution</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Medicaldatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewMedicalinfo(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Medicalinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.ClaimDate | date:\'dd/MM/y\' }}</td><td>{{ row.VisitDate | date:\'dd/MM/y\' }}</td><td>{{ row.MedicalInstitution }}\n</td><td>{{ row.Amount }}</td><td>{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Medicalform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div>\n<div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Requester Name</label><md-select \nng-model=\"Employee\" ng-change=\"GetLeave()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a requester..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Employee=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm1\" value=\"{{row.id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><input type=\"text\" name=\"ClaimDate\" ng-model=\"ClaimDate | date:\'dd/MM/y\'\" \nplaceholder=\"Date of Claim\" readonly=\"readonly\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label>Date of Visit</label><md-datepicker onkeydown=\"return false\" \nng-model=\"VisitDate\" ng-change=\"GetLeave()\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"MedicalInstitution\" ng-model=\"MedicalInstitution\" \nplaceholder=\"Medical Institution\" required><div ng-messages=\"basicForm.MedicalInstitution.$error\" \nng-show=\"basicForm.MedicalInstitution.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nMedical Institution field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"number\" name=\"Amount\" ng-model=\"Amount\" placeholder=\"Amount\" \nrequired><div ng-messages=\"basicForm.Amount.$error\" ng-show=\"basicForm.Amount.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Amount is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Consultation\" ng-model=\"Consultation\" placeholder=\"Consultation\"><div \nng-messages=\"basicForm.Consultation.$error\" ng-show=\"basicForm.Consultation.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Consultation is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Reimbursable\" ng-model=\"Reimbursable\" placeholder=\"Reimbursable\"><div \nng-messages=\"basicForm.Reimbursable.$error\" ng-show=\"basicForm.Reimbursable.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Reimbursable is required.</span></div></div></md-input-container><md-input-container flex>\n<label>Medical Leave</label><md-select ng-model=\"MedicalLeave\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\">\n<md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Leave..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"MedicalLeave=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Leaverefdatas | filter:vm.searchTerm2\" value=\"{{row.ReferenceNo}}\">\n{{row.ReferenceNo}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Purpose\" ng-model=\"Purpose\" \nplaceholder=\"Purpose\"><div ng-messages=\"basicForm.Purpose.$error\" ng-show=\"basicForm.Purpose.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Purpose Required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"><div ng-messages=\"basicForm.Remarks.$error\" \nng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Remarks Required.</span></div></div>\n</md-input-container></div></div></div></form><br><form name=\"basicForm1\" class=\"md-inline-form\" novalidate><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMHealth&Safety/MedicalClaim/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"mSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><div \nclass=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewMedicalform\" flex><form \nname=\"basicForm11\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"text\" name=\"ReferenceNo\" ng-model=\"ReferenceNo\" placeholder=\"Reference #\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"EmployeeName\" ng-model=\"EmployeeName\" \nplaceholder=\"Requester Name\" readonly=\"readonly\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"ClaimDate\" ng-model=\"ClaimDate | date:\'dd/MM/y\'\" \nplaceholder=\"Date of Claim\" readonly=\"readonly\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"VisitDate\" ng-model=\"VisitDate | date:\'dd/MM/y\'\" \nplaceholder=\"Date of Visit\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"MedicalInstitution\" ng-model=\"MedicalInstitution\" \nplaceholder=\"Medical Institution\" readonly=\"readonly\"></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Amount\" ng-model=\"Amount\" placeholder=\"Amount\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Consultation\" ng-model=\"Consultation\" placeholder=\"Consultation\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"number\" name=\"Reimbursable\" \nng-model=\"Reimbursable\" placeholder=\"Reimbursable\" readonly=\"readonly\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"MedicalLeave\" \nng-model=\"MedicalLeave\" placeholder=\"Medical Leave\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Purpose\" ng-model=\"Purpose\" placeholder=\"Purpose\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\" \nreadonly=\"readonly\"></md-input-container></div></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\">\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2>\n<hr><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input \ntype=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div\n style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm11.$invalid || basicForm11.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-inputs\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-inputs\" flow-btn id=\"file-inputs\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMHealth&Safety/MedicalClaim/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n        #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n        #tb3 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb3 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/award.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.SCHOLARSHIPS / AWARDS / BONDS\" class=\"title\">SCHOLARSHIPS / AWARDS / BONDS</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex><input type=\"number\" ng-model=\"vm.aYearofAward\" placeholder=\"{{\'RECRUITMENT.YEAR OF AWARD\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.aDescription\" \nplaceholder=\"{{\'RECRUITMENT.DESCRIPTION\'|translate}}\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.aValueofAward\" placeholder=\"{{\'RECRUITMENT.VALUE OF AWARD\'|translate}} \"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"date2\">\n<label translate=\"RECRUITMENT.START DATE OF BOND\">Start Date of Bond</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.aSDOB\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label translate=\"RECRUITMENT.END DATE OF BOND\">End Date of Bond\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.aEDOB\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Awardadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog><style>\n#date2 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n        max-width: 1000px;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/awarddelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS AWARD DETAIL\" class=\"title\">\nAre you sure you want to cancel this award detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Adelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/character.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.CHARACTER REFERENCES\" class=\"title\">CHARACTER REFERENCES</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex><input type=\"text\" ng-model=\"vm.cName\" placeholder=\"{{\'RECRUITMENT.NAME\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.cOccupationName\" \nplaceholder=\"{{\'RECRUITMENT.OCCUPATION & NAME OF THE ORGANISATION\'|translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.cPeriodKnown\" \nplaceholder=\"{{\'RECRUITMENT.PERIOD KNOWN\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.cContactNo\" placeholder=\"{{\'RECRUITMENT.CONTACT NO\'|translate}}.\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"Address\"><md-input-container flex><input type=\"text\" ng-model=\"vm.cAddress\" \nplaceholder=\"{{\'RECRUITMENT.ADDRESS\'|translate}}\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Characteradd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/characterdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS CHARACTER DETAIL\" class=\"title\">\nAre you sure you want to cancel this character detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Cdelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/convertemployee.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CONVERT THIS CANDIDATE AS A EMPLOYEE\" class=\"title\">\nAre you sure you want to convert this candidate as a employee?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"ConvertEmployeeadd(ApplicationId)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/education.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.EDUCATIONAL AND OTHER PROFESSIONAL QUALIFICATIONS\" class=\"title\">\nEDUCATIONAL AND OTHER PROFESSIONAL QUALIFICATIONS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.eNameofInstitution\" placeholder=\"{{\'RECRUITMENT.NAME OF INSTITUTION / COUNTRY\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.eHighestQualificationsAttained\" \nplaceholder=\"{{\'RECRUITMENT.HIGHEST QUALIFICATIONS ATTAINED\'|translate}} \"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"date2\">\n<label translate=\"RECRUITMENT.FROM\">From</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.eFrom\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label translate=\"RECRUITMENT.TO\">To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.eTo\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Educationadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog><style>\n#date2 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/educationdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS EDUCATION DETAIL\" class=\"title\">\nAre you sure you want to cancel this education detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Edudelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/emphistory.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.EMPLOYMENT HISTORY\" class=\"title\">EMPLOYMENT HISTORY</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.hNameofEmployer\" placeholder=\"{{\'RECRUITMENT.NAME OF EMPLOYER\'|translate}} \">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.hAddressofEmployer\" \nplaceholder=\"{{\'RECRUITMENT.ADDRESS OF EMPLOYER\'|translate}} \"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label \ntranslate=\"RECRUITMENT.FROM\">From</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.hFrom\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label translate=\"RECRUITMENT.TO\">To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.hTo\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.hLastDrawnMonthlySalary\" \nplaceholder=\"{{\'RECRUITMENT.CURRENT /LAST DRAWN MONTHLY SALARY\'|translate}}\"></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.hAllowanceBonus\" \nplaceholder=\"{{\'RECRUITMENT.ALLOWANCE & BONUS (IF ANY)\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.hJobTitle\" \nplaceholder=\"{{\'RECRUITMENT.JOB TITLE & BRIEF DESCRIPTION OF DUTIES\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.hReasonforLeaving\" \nplaceholder=\"{{\'RECRUITMENT.REASON(S) FOR LEAVING\'|translate}}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Emphistoryadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog><style>\n#date2 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/emphistorydelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS EMPLOYMENT HISTORY DETAIL\" class=\"title\">\nAre you sure you want to cancel this Employment history detail?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Empdelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/family.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.FAMILY PARTICULARS\" class=\"title\">FAMILY PARTICULARS</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.fName\" placeholder=\"{{\'RECRUITMENT.NAME\'|translate}}\" required><div \nng-messages=\"basicForm.vm.fName.$error\" ng-show=\"basicForm.vm.fName.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"RECRUITMENT.NAME IS REQUIRED\">Name is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.fRelationship\" \nplaceholder=\"{{\'RECRUITMENT.RELATIONSHIP\'|translate}}\" required><div ng-messages=\"basicForm.vm.fRelationship.$error\" \nng-show=\"basicForm.vm.fRelationship.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.RELATIONSHIP IS REQUIRED\">Relationship is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"RECRUITMENT.COUNTRY\">Country\n</label><md-select ng-model=\"vm.fCountry\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH_FOR_A_COUNTRY\'|translate}}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.fCountry=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CountyList | filter:vm.searchTerm\" value=\"{{row.name}}\">{{row.name}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" \nid=\"date1\"><label translate=\"RECRUITMENT.DATE_OF_BIRTH\">Date of Birth</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.fDOB\" required></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.fOccupation\" \nplaceholder=\"{{\'RECRUITMENT.OCCUPATION\'|translate}}\" required></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.fCompany\" placeholder=\"{{\'RECRUITMENT.COMPANY\'|translate}}\" required></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Familyadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n        max-width: 1000px;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/familydelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS FAMILY DETAIL\" class=\"title\">\nAre you sure you want to cancel this family detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Fdelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/language.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.LANGUAGE PROFICIENCY\" class=\"title\">LANGUAGE PROFICIENCY</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex><input type=\"text\" ng-model=\"vm.lLanguage\" placeholder=\"{{\'RECRUITMENT.LANGUAGE / DIALECTS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -25px\"><md-input-container flex>\n<label translate=\"RECRUITMENT.WRITTEN\">Written</label><md-select ng-model=\"vm.lWritten\" id=\"searchmodule\"><md-option \nvalue=\"{{\'RECRUITMENT.GOOD\'|translate}}\">{{\'RECRUITMENT.GOOD\'|translate}}</md-option><md-option \nvalue=\"{{\'RECRUITMENT.MODERATE\'|translate}}\">{{\'RECRUITMENT.MODERATE\'|translate}}</md-option><md-option \nvalue=\"{{\'RECRUITMENT.BEGINNER\'|translate}}\">{{\'RECRUITMENT.BEGINNER\'|translate}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"RECRUITMENT.SPOKEN\">Spoken</label><md-select ng-model=\"vm.lSpoken\" id=\"searchmodule\"><md-option \nvalue=\"{{\'RECRUITMENT.GOOD\'|translate}}\">{{\'RECRUITMENT.GOOD\'|translate}}</md-option><md-option \nvalue=\"{{\'RECRUITMENT.MODERATE\'|translate}}\">{{\'RECRUITMENT.MODERATE\'|translate}}</md-option><md-option \nvalue=\"{{\'RECRUITMENT.BEGINNER\'|translate}}\">{{\'RECRUITMENT.BEGINNER\'|translate}}</md-option></md-select>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Languageadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog><style>\n#date2 .md-datepicker-input {\r\n        min-width: 270px !important;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/languagedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS LANGUAGE DETAIL\" class=\"title\">\nAre you sure you want to cancel this language detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Ldelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/membership.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.PROFESSIONAL MEMBERSHIPS\" class=\"title\">PROFESSIONAL MEMBERSHIPS</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex><input type=\"text\" ng-model=\"vm.mCompany\" \nplaceholder=\"{{\'RECRUITMENT.ASSOCIATION / SOCIETY / COMPANY\'|translate}}\"></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"vm.mPositionHeld\" placeholder=\"{{\'RECRUITMENT.POSITION HELD\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label translate=\"RECRUITMENT.FROM\">From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.mFrom\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"date2\"><label translate=\"RECRUITMENT.TO\">To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.mTo\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Membershipadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">{{\'RECRUITMENT.SAVE\'|translate}}\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog><style>\n#date2 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n    }\r\n\r\n\r\n\r\n\r\n    /*.thumbnail {\r\n     float:left;\r\n    width: 60px;\r\n     display:block;\r\n    }*/\r\n /*.thumbnail > span:hover {\r\n  background: #eee;\r\n  background-size:5px;\r\n}*/\r\n/*table {\r\n    border-collapse: collapse; \r\n}\r\n .tdthumbnail > td:hover {\r\n  background: #eee;\r\n}*/\n</style>");
$templateCache.put("app/main/apps/human-resource/recruitment/membershipdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"RECRUITMENT.ARE YOU SURE YOU WANT TO CANCEL THIS MEMBERSHIP DETAIL\" class=\"title\">\nAre you sure you want to cancel this membership detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Mdelete(deleteID)\" class=\"md-raised md-accent\">{{\'RECRUITMENT.YES\'|translate}}</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">{{\'RECRUITMENT.NO\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/recruitment/recruitment.html","<div id=\"recruitment\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span \ntranslate=\"RECRUITMENT.HEADER\">Recruitment</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"rSearch\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH\'|translate}}\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"rAdd\" ng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span translate=\"RECRUITMENT.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"rView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"RECRUITMENT.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"rExport  && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"RECRUITMENT.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" ng-show=\"Grid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Recruitmentjobapplicationdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.CANDIDATE NAME\" class=\"column-title\">\nCandidate Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.APPLICATION DATE\" class=\"column-title\">Application Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.STATUS\" class=\"column-title\">Status\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.APPLICATION\" class=\"column-title\">\nApplication</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.EVALUATION\" \nclass=\"column-title\">Evaluation</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"RECRUITMENT.CONTRACT\" class=\"column-title\">Contract</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"RECRUITMENT.CONVERT EMPLOYEE\" class=\"column-title\">Convert Employee</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">&emsp; OJT1</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">&emsp;OJT2</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Recruitmentjobapplicationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.NameinPassport }}</td><td>{{ row.DateofApplication | date:\'dd/MM/y\' }}</td><td>{{ row.Status }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"JobApplicationinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Recruitmentevaluationinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon></md-button>\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Recruitmentcontractinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon></md-button></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"ConvertEmployee($event,row.id, $index)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon></md-button></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"JobInduction1info(row.id, $index)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"OJT2(row.id)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"JobApplication\" flex>\n<form name=\"basicForm1\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-show=\"Application\" ng-click=\"printJobApplication(row._id)\"><span \ntranslate=\"RECRUITMENT.PRINT\">Print</span></md-button></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>{{\'RECRUITMENT.JOB APPLICATION FORM\'|translate}}</b></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;{{\'RECRUITMENT.INSTRUCTIONS\'|translate}}</h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div style=\"text-align:justify;font-size:17px\"><p><ol><li>\n{{\'RECRUITMENT.THIS FORM HAS BEEN DESIGNED TO PROVIDE US WITH BASIC INFORMATION FOR EASY PROCESSING OF YOUR APPLICATION FOR EMPLOYMENT WITH US\'|translate}}.\n</li><li>{{\'RECRUITMENT.ALL RELEVANT PARTS OF THIS APPLICATION FORM MUST BE COMPLETED\'|translate}}.</li><li>\n{{\'RECRUITMENT.ASTERISK (*) ITEMS ARE FOR ADMINISTRATIVE PURPOSES ONLY\'|translate}}.</li></ol></p></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"PositionApplied\" \nng-model=\"PositionApplied\" placeholder=\"{{\'RECRUITMENT.POSITION APPLIED FOR\'|translate}}\" required><div \nng-messages=\"basicForm1.PositionApplied.$error\" ng-show=\"basicForm1.PositionApplied.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.POSITION APPLIED IS REQUIRED\">Position Applied is required.</span>\n</div></div></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label \ntranslate=\"RECRUITMENT.DATE OF APPLICATION\">Date of Application</label><md-datepicker onkeydown=\"return false\" \nng-model=\"DateofApplication\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div></div></div><br><br>\n<div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;1. {{\'RECRUITMENT.PERSONAL PARTICULARS\'|translate}}</h1>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"NameinPassport\" \nplaceholder=\"{{\'RECRUITMENT.NAME, AS IN PASSPORT/NRIC\'|translate}}\" required><div \nng-messages=\"basicForm1.NameinPassport.$error\" ng-show=\"basicForm1.NameinPassport.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"NameinNative\" \nplaceholder=\"{{\'RECRUITMENT.NAME IN NATIVE SCRIPT, IF APPLICABLE\'|translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label \ntranslate=\"RECRUITMENT.DATE_OF_BIRTH\">Date of Birth</label><md-datepicker onkeydown=\"return false\" ng-model=\"DOB\" \nmd-date-format=\"dd/MM/y\" required></md-datepicker><div ng-messages=\"basicForm1.DOB.$error\" \nng-show=\"basicForm1.DOB.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.DATE OF BIRTH IS REQUIRED\">Date of Birth is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"PlaceofBirth\" \nplaceholder=\"{{\'RECRUITMENT.PLACE OF BIRTH\'|translate}}\" required><div ng-messages=\"basicForm1.PlaceofBirth.$error\" \nng-show=\"basicForm1.PlaceofBirth.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.PLACE OF BIRTH IS REQUIRED\">Place of Birth is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"Citizenship\" \nplaceholder=\"{{\'RECRUITMENT.CITIZENSHIP\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"RECRUITMENT.RACE\">Race</label><md-select ng-model=\"Race\" \nrequired><md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">\n{{\'RECRUITMENT.RACE\'|translate}}..</span><md-button class=\"md-icon-button\" ng-click=\"Race = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"Arctic\">{{\'RECRUITMENT.ARCTIC (SIBERIAN, ESKIMO)\'|translate}}</md-option>\n<md-option value=\"European\">{{\'RECRUITMENT.CAUCASIAN (EUROPEAN)\'|translate}}</md-option><md-option value=\"Indian\">\n{{\'RECRUITMENT.CAUCASIAN (INDIAN)\'|translate}}</md-option><md-option value=\"Middle\">\n{{\'RECRUITMENT.CAUCASIAN (MIDDLE EAST)\'|translate}}</md-option><md-option value=\"Other\">\n{{\'RECRUITMENT.CAUCASIAN (NORTH AFRICAN, OTHER)\'|translate}}</md-option><md-option value=\"Indigenous\">\n{{\'RECRUITMENT.INDIGENOUS AUSTRALIAN\'|translate}}</md-option><md-option value=\"American\">\n{{\'RECRUITMENT.NATIVE AMERICAN\'|translate}}</md-option><md-option value=\"Asian\">\n{{\'RECRUITMENT.NORTH EAST ASIAN (MONGOL, TIBETAN, KOREAN JAPANESE, ETC)\'|translate}}</md-option><md-option \nvalue=\"Pacific\">{{\'RECRUITMENT.PACIFIC (POLYNESIAN, MICRONESIAN, ETC)\'|translate}}</md-option><md-option value=\"South\">\n{{\'RECRUITMENT.SOUTH EAST ASIAN (CHINESE, THAI, MALAY, FILIPINO, ETC)\'|translate}}</md-option><md-option value=\"West\">\n{{\'RECRUITMENT.WEST AFRICAN, BUSHMEN, ETHIOPIAN\'|translate}}</md-option></md-select><div \nng-messages=\"basicForm1.Race.$error\" ng-show=\"basicForm1.Race.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.RACE IS REQUIRED\">Race is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"FINNumber\" placeholder=\"{{\'RECRUITMENT.NRIC/FIN NUMBER\'|translate}}\" required><div \nng-messages=\"basicForm1.FINNumber.$error\" ng-show=\"basicForm1.FINNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.FIN NUMBER IS REQUIRED\">FIN Number is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"PassportNumber\" \nplaceholder=\"{{\'RECRUITMENT.PASSPORT_NUMBER\'|translate}}\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"Sex\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.SEX\'|translate}} *:</b></span><md-radio-button value=\"{{\'RECRUITMENT.MALE\'|translate}}\">\n{{\'RECRUITMENT.MALE\'|translate}}</md-radio-button><md-radio-button value=\"{{\'RECRUITMENT.FEMALE\'|translate}}\">\n{{\'RECRUITMENT.FEMALE\'|translate}}</md-radio-button></md-radio-group></md-radio-container></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"MaritalStatus\" layout=\"row\"><span\n style=\"width:135px\"><b>{{\'RECRUITMENT.MARITAL_STATUS\'|translate}} *:</b></span><md-radio-button \nvalue=\"{{\'RECRUITMENT.SINGLE\'|translate}}\">{{\'RECRUITMENT.SINGLE\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.MARRIED\'|translate}}\">{{\'RECRUITMENT.MARRIED\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.DIVORCED\'|translate}}\">{{\'RECRUITMENT.DIVORCED\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.WIDOWED\'|translate}}\">{{\'RECRUITMENT.WIDOWED\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div><br><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"SingaporePR\" layout=\"row\"><span style=\"width:135px\"><b>Singapore PR:</b></span><md-radio-button value=\"No\">\n{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-show=\"SingaporePR == \'Yes\'\" flex><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label \ntranslate=\"RECRUITMENT.DATE ATTAINED SPR STATUS\">Date Attained SPR Status</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"DateAttainedSPRStatus\"></md-datepicker></md-input-container></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"DrivingLicense\" layout=\"row\">\n<span style=\"width:135px\"><b>{{\'RECRUITMENT.DRIVING LICENSE\'|translate}}:</b></span><md-radio-button value=\"No\">\n{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"2\">Class 2</md-radio-button><md-radio-button \nvalue=\"2A\">2A</md-radio-button><md-radio-button value=\"2B\">2B</md-radio-button><md-radio-button value=\"3\">3\n</md-radio-button><md-radio-button value=\"3A\">3A</md-radio-button><md-radio-button value=\"4\">4</md-radio-button>\n<md-radio-button value=\"5\">5</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-show=\"DrivingLicense != \'No\'\" flex><md-input-container \nstyle=\"margin-top: 18px;margin-left:-10px\" flex><label translate=\"RECRUITMENT.DRIVING LICENSE PASSING DATE\">\nDriving License Passing Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"DLPassingDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><br><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"RTelephoneNumber\" \nplaceholder=\"{{\'RECRUITMENT.RESIDENTIAL TELEPHONE NUMBER\'|translate}}\"><div \nng-messages=\"basicForm1.RTelephoneNumber.$error\" ng-show=\"basicForm1.RTelephoneNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"MobileNumber\" \nplaceholder=\"{{\'RECRUITMENT.MOBILE_NUMBER\'|translate}}\"><div ng-messages=\"basicForm1.MobileNumber.$error\" \nng-show=\"basicForm1.MobileNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"email\" ng-model=\"Email\" \nplaceholder=\"{{\'RECRUITMENT.EMAIL\'|translate}}\"><div ng-messages=\"basicForm1.Email.$error\" \nng-show=\"basicForm1.Email.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"RAddress\" placeholder=\"{{\'RECRUITMENT.RESIDENTIAL ADDRESS\'|translate}}\" required><div \nng-messages=\"basicForm1.RAddress.$error\" ng-show=\"basicForm1.RAddress.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"PRAddress\" \nplaceholder=\"{{\'RECRUITMENT.PERMANENT RESIDENTIAL ADDRESS\'|translate}}\" required><div \nng-messages=\"basicForm1.PRAddress.$error\" ng-show=\"basicForm1.PRAddress.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span>\n</div></div></md-input-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;2. {{\'RECRUITMENT.FAMILY PARTICULARS\'|translate}}</h1><div layout-gt-sm=\"row\" id=\"head\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Familypopup($event, JobApplicationID)\" style=\"float:right\"><span translate=\"RECRUITMENT.ADD\">Add</span>\n</md-button></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.NAME\" class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.RELATIONSHIP\" class=\"column-title\">Relationship</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.NATIONALITY\" class=\"column-title\">\nNationality</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.DATE_OF_BIRTH\" class=\"column-title\">Date of Birth</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"RECRUITMENT.OCCUPATION\" class=\"column-title\">Occupation</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.COMPANY\" class=\"column-title\">Company\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" class=\"column-title\">\nDelete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobfamilydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>{{ row.Relationship }}</td><td>\n{{ row.Country }}</td><td>{{ row.DOB | date:\'dd/MM/y\' }}</td><td>{{ row.Occupation }}</td><td>{{ row.Company }}</td>\n<td><md-button class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Familyupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Familydelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;3. {{\'RECRUITMENT.CONTACT PERSON / NEXT OF KIN - IN CASE OF EMERGENCY\'|translate}}</h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"EmergencyContactName\" placeholder=\"{{\'RECRUITMENT.NAME\'|translate}}\"><div \nng-messages=\"basicForm1.EmergencyContactName.$error\" ng-show=\"basicForm1.EmergencyContactName.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"EmergencyContactRelationship\" placeholder=\"{{\'RECRUITMENT.RELATIONSHIP\'|translate}}\"><div \nng-messages=\"basicForm1.EmergencyContactRelationship.$error\" \nng-show=\"basicForm1.EmergencyContactRelationship.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.NAME IN PASSPORT IS REQUIRED\">Name in Passport is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"EmergencyContactRTelephoneNumber\" \nplaceholder=\"{{\'RECRUITMENT.RESIDENTIAL TELEPHONE NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"EmergencyContactOTelephoneNumber\" \nplaceholder=\"{{\'RECRUITMENT.OFFICE TELEPHONE NUMBER\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"EmergencyContactMobileNumber\" placeholder=\"{{\'RECRUITMENT.MOBILE_NUMBER\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"email\" ng-model=\"EmergencyContactEmail\" \nplaceholder=\"{{\'RECRUITMENT.EMAIL\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"EmergencyContactRAddress\" \nplaceholder=\"{{\'RECRUITMENT.RESIDENTIAL ADDRESS\'|translate}}\"></md-input-container></div></div></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;4. {{\'RECRUITMENT.NATIONAL SERVICE (IF APPLICABLE)\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"NSStatus\" layout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.NS STATUS\'|translate}}:</b></span>\n<md-radio-button value=\"{{\'RECRUITMENT.ACTIVE\'|translate|translate}}\">{{\'RECRUITMENT.ACTIVE\'|translate|translate}}\n</md-radio-button><md-radio-button value=\"{{\'RECRUITMENT.INACTIVE ORD\'|translate}}\">\n{{\'RECRUITMENT.INACTIVE ORD\'|translate}}</md-radio-button></md-radio-group></md-radio-container></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"ServiceStatus\" layout=\"row\"><span\n style=\"width:135px\"><b>{{\'RECRUITMENT.SERVICE STATUS\'|translate}}:</b></span><md-radio-button \nvalue=\"{{\'RECRUITMENT.PART-TIME\'|translate}}\">{{\'RECRUITMENT.PART-TIME\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.FULL-TIME\'|translate}}\">{{\'RECRUITMENT.FULL-TIME\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.DEFERRED\'|translate}}\">{{\'RECRUITMENT.DEFERRED\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.EXEMPTED\'|translate}}\">{{\'RECRUITMENT.EXEMPTED\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div><br><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"ExemptedReason\" placeholder=\"{{\'RECRUITMENT.IF EXEMPTED, STATE REASON\'|translate}}\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"ORD\" \nplaceholder=\"ORD\"></md-input-container><md-input-container style=\"margin-top: 18px;margin-left:-10px\" flex><label \ntranslate=\"RECRUITMENT.ENLISTMENT DATE\">Enlistment Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"EnlistmentDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"RankAtORD\" placeholder=\"Rank At ORD\"></md-input-container>\n<md-input-container style=\"margin-top: 18px;margin-left:-10px\" flex><label translate=\"RECRUITMENT.NEXT RESERVIST DATE\">\nNext Reservist Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"ReservistDate\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;5. {{\'RECRUITMENT.PROFESSIONAL MEMBERSHIPS\'|translate}}</h1><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Membershippopup($event, JobApplicationID)\"><span translate=\"RECRUITMENT.ADD\">Add</span></md-button></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.ASSOCIATION / SOCIETY / COMPANY\" \nclass=\"column-title\">Association / Society / Company</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.POSITION HELD\" class=\"column-title\">Position Held</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.FROM\" class=\"column-title\">From\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.TO\" \nclass=\"column-title\">To</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" \nclass=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobmembershipdatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Company }}</td><td>{{ row.PositionHeld }}</td><td>\n{{ row.From | date:\'dd/MM/y\'}}</td><td>{{ row.To | date:\'dd/MM/y\'}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Membershipupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Membershipdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;6. {{\'RECRUITMENT.COMPUTER LITERACY\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"ComputerLiteracy\"></text-angular></div></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;7. {{\'RECRUITMENT.LANGUAGE PROFICIENCY\'|translate}}</h1>\n<div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Languagepopup($event, JobApplicationID)\"><span translate=\"RECRUITMENT.ADD\">Add</span></md-button></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.LANGUAGE / DIALECTS\" \nclass=\"column-title\">Language / Dialects</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.WRITTEN\" class=\"column-title\">Written</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.SPOKEN\" class=\"column-title\">Spoken</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th\n class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Recruitmentjoblanguagedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.Language }}</td><td>{{ row.Written }}</td><td>{{ row.Spoken }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Languageupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Languagedelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;8. {{\'RECRUITMENT.HOBBIES / INTERESTS / GAMES\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Hobbies\"></text-angular></div></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;9. {{\'RECRUITMENT.EDUCATIONAL AND OTHER PROFESSIONAL QUALIFICATIONS\'|translate}}</h1><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Educationpopup($event, JobApplicationID)\"><span translate=\"RECRUITMENT.ADD\">Add</span></md-button></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.NAME OF INSTITUTION / COUNTRY\" \nclass=\"column-title\">Name of Institution / Country</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.HIGHEST QUALIFICATIONS ATTAINED\" class=\"column-title\">\nHighest Qualifications Attained</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.FROM\" class=\"column-title\">From</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.TO\" class=\"column-title\">To</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th><th\n class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Recruitmentjobeducationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.NameofInstitution }}</td><td>{{ row.HighestQualificationsAttained }}</td><td>{{ row.From | date:\'dd/MM/y\'}}\n</td><td>{{ row.To | date:\'dd/MM/y\'}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Educationupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Educationdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;10. {{\'RECRUITMENT.EMPLOYMENT HISTORY\'|translate}}</h1><div layout-gt-sm=\"row\" id=\"head\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Emphistorypopup($event, JobApplicationID)\"><span translate=\"RECRUITMENT.ADD\">Add</span></md-button></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.FROM\" class=\"column-title\">From</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.TO\" class=\"column-title\">\nTo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.LAST DRAWN MONTHLY SALARY\" class=\"column-title\">Last Drawn Monthly Salary</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.ALLOWANCE & BONUS\" class=\"column-title\">\nAllowance & Bonus</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.JOB TITLE\" class=\"column-title\">Job Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"RECRUITMENT.REASON FOR LEAVING\" class=\"column-title\">Reason for Leaving</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" class=\"column-title\">View/Edit\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobemphistorydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.From | date:\'dd/MM/y\'}}</td><td>{{ row.To | date:\'dd/MM/y\'}}\n</td><td>{{ row.LastDrawnMonthlySalary }}</td><td>{{ row.AllowanceBonus }}</td><td>{{ row.JobTitle }}</td><td>\n{{ row.ReasonforLeaving }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Emphistoryupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Emphistorydelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;11. {{\'RECRUITMENT.SUPPLEMENTAL INFORMATION\'|translate}}</h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><h3 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.PREVIOUS JOB YOU\'|translate}} <u>{{\'RECRUITMENT.ENJOYED THE MOST\'|translate}}</u>\n {{\'RECRUITMENT.AND WHY\'|translate}}?</b></h3><div><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"MostEnjoyed\">\n</text-angular></div><h3 style=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.PREVIOUS JOB YOU\'|translate}} <u>\n{{\'RECRUITMENT.ENJOYED THE LEAST\'|translate}}</u> {{\'RECRUITMENT.AND WHY\'|translate}}?</b></h3><div><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"LeastEnjoyed\"></text-angular></div><h3 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.WHY DO YOU THINK WE SHOULD CONSIDER YOUR APPLICATION\'|translate}}?</b></h3><div><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"ApplicationConsider\"></text-angular></div></div></div><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" \nstyle=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div \nclass=\"content-card\"><h1 style=\"text-align:left\">&nbsp;12.{{\'RECRUITMENT.REFERENCES\'|translate}}</h1><div \nlayout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Characterpopup($event, JobApplicationID)\"><span translate=\"RECRUITMENT.ADD\">Add</span></md-button></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.NAME\" class=\"column-title\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.OCCUPATION & NAME OF THE ORGANISATION\" class=\"column-title\">\nOccupation & Name of the Organisation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"RECRUITMENT.PERIOD KNOWN\" class=\"column-title\">Period Known</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span translate=\"RECRUITMENT.CONTACT NO\" class=\"column-title\">Contact No.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"RECRUITMENT.ADDRESS\" class=\"column-title\">Address\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.VIEW/EDIT\" class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span translate=\"RECRUITMENT.DELETE\" class=\"column-title\">\nDelete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobcharacterdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>{{ row.OccupationName }}</td><td>\n{{ row.PeriodKnown }}</td><td>{{ row.ContactNo }}</td><td>{{ row.Address }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Characterupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Characterdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;13. {{\'RECRUITMENT.ADDITIONAL INFORMATION\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" \nng-model=\"ExpectedMonthlySalary\" placeholder=\"{{\'RECRUITMENT.WHAT IS YOUR EXPECTED MONTHLY SALARY\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"JoinUs\" \nplaceholder=\"{{\'RECRUITMENT.HOW SOON CAN YOU JOIN US\'|translate}}?\"></md-input-container></div><div \nstyle=\"height: 70px;margin-top: -22px\"><md-radio-container flex><span><b>\n{{\'RECRUITMENT.HOW DID YOU LEARN ABOUT THIS POSITION\'|translate}}?</b></span><md-radio-group \nng-model=\"LearnAboutThisPosition\" layout=\"row\" style=\"padding-left:20px\"><md-radio-button value=\"StraitsTimes\">\nStraits Times</md-radio-button><md-radio-button value=\"TheNewPaper\">The New Paper</md-radio-button><md-radio-button \nvalue=\"BeritaHarian\">Berita Harian</md-radio-button><md-radio-button value=\"ZaoBao\">Zao Bao</md-radio-button>\n</md-radio-group></md-radio-container></div><div style=\"height: 70px;margin-top: -22px\"><md-radio-container flex>\n<md-radio-group ng-model=\"LearnAboutThisPosition\" layout=\"row\" style=\"padding-left:20px\"><md-radio-button \nvalue=\"JobDB\">JobDB.com</md-radio-button><md-radio-button value=\"JobStreet\">JobStreet.com</md-radio-button>\n<md-radio-button value=\"{{\'RECRUITMENT.WEBSITE\'|translate}}\">{{\'RECRUITMENT.WEBSITE\'|translate}}</md-radio-button>\n<md-radio-button value=\"{{\'RECRUITMENT.TODAY\'|translate}}\">{{\'RECRUITMENT.TODAY\'|translate}}</md-radio-button>\n<md-radio-button value=\"{{\'RECRUITMENT.RECOMMEND A FRIEND INCENTIVE\'|translate}}\">\n{{\'RECRUITMENT.RECOMMEND A FRIEND INCENTIVE\'|translate}}</md-radio-button></md-radio-group></md-radio-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -40px\"><md-radio-group ng-model=\"LearnAboutThisPosition\" \nstyle=\"padding-left:20px\"><md-radio-button value=\"{{\'RECRUITMENT.OTHER\'|translate}}\">\n{{\'RECRUITMENT.OTHER\'|translate}}&nbsp;</md-radio-button></md-radio-group><md-input-container flex \nstyle=\"margin-top: -7px\"><input type=\"text\" name=\"Remarks\" ng-model=\"LearnAboutThisPositionOtherRemark\" placeholder=\"\">\n</md-input-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;14. {{\'RECRUITMENT.DECLARATION\'|translate}}</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">1.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.1 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\"><md-radio-group \nng-model=\"Offence \" layout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>\n&nbsp;<md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr>\n<tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">2.</th><th \ncolspan=\"5\" style=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.2 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Bankruptcy \" \nlayout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button \nvalue=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">3.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.3 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Judgement \" \nlayout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button \nvalue=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">4.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.4 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Acknowledgement \" \nlayout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button \nvalue=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">5.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.5 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Capacity \" \nlayout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button \nvalue=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">6.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.6 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Position\" layout=\"row\">\n&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button value=\"Yes\">\n{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px;text-align:center\">7.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;height:80px;padding-left: 1.5pc\">\n{{\'RECRUITMENT.7 ROW\'|translate}}</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\"><md-radio-group ng-model=\"Competitors\" \nlayout=\"row\">&nbsp;<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button>&nbsp;<md-radio-button \nvalue=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button>&nbsp;</md-radio-group></th></tr><tr><th valign=\"top\" \ncolspan=\"8\" style=\"border: 1px solid black;border-collapse: collapse\">{{\'RECRUITMENT.8 ROW\'|translate}}<text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"Declaration\"></text-angular></th></tr><tr><th colspan=\"8\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><ul><li>{{\'RECRUITMENT.1 DECLARATION\'|translate}}</li><br>\n<li>{{\'RECRUITMENT.2 DECLARATION\'|translate}}</li><br><li>{{\'RECRUITMENT.3 DECLARATION\'|translate}}</li><br><li>\n{{\'RECRUITMENT.4 DECLARATION\'|translate}}</li><br><li>{{\'RECRUITMENT.5 DECLARATION\'|translate}}</li><br><li>\n{{\'RECRUITMENT.6 DECLARATION\'|translate}}</li><br><li>{{\'RECRUITMENT.7 DECLARATION\'|translate}}</li><br></ul><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-bottom: 10px\"><md-radio-container><md-radio-group ng-model=\"Accept\" \nlayout=\"row\"><span style=\"width:75px;padding-left:10px\"><b>{{\'RECRUITMENT.ACCEPT\'|translate}}:</b></span>\n<md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">\n{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group></md-radio-container><md-input-container \nng-show=\"Accept == \'Yes\'\" style=\"margin-top:-6px\" flex><input type=\"text\" name=\"AcceptRemarks\" \nng-model=\"AcceptRemarks\" placeholder=\"\"></md-input-container></div></th></tr></thead><tbody></tbody></table></div>\n</div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:center;font-size:20px;font-weight:500\"><b>\n{{\'RECRUITMENT.PRIVACY POLICY STATEMENT\'|translate}} </b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"PrivacyPolicy\" class=\"pb-32\"></text-angular>\n</div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"jSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'RECRUITMENT.SUBMIT\'|translate}}\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">{{\'RECRUITMENT.CANCEL\'|translate}}\n</md-button></div></div></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Evaluation\" flex><form name=\"basicForm2\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"printEvaluation(row._id)\"><span \ntranslate=\"RECRUITMENT.PRINT\">Print</span></md-button></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>{{\'RECRUITMENT.EVALUATION FORM\'|translate}}</b></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"NameofCandidate\" ng-model=\"NameofCandidate\" \nplaceholder=\"{{\'RECRUITMENT.NAME OF CANDIDATE\'|translate}}\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"PositionTitle\" ng-model=\"PositionTitle\" \nplaceholder=\"{{\'RECRUITMENT.POSITION TITLE\'|translate}}\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><label translate=\"RECRUITMENT.DEPARTMENT\">Department</label><md-select ng-model=\"Department\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH FOR A DEPARTMENT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"Department=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CostCentredatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.CostCentreName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><label translate=\"RECRUITMENT.INTERVIEWER(S)\">Interviewer(s)</label><md-select \nng-model=\"Interviewer\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'RECRUITMENT.SEARCH FOR A INTERVIEWER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Interviewer=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"DateofInterview\" \nng-model=\"DateofInterview | date:\'dd/MM/y\'\" placeholder=\"{{\'RECRUITMENT.DATE OF INTERVIEW\'|translate}}\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input class=\"txtbox\" \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"CompletedBy\" ng-model=\"CompletedBy\" \nplaceholder=\"{{\'RECRUITMENT.COMPLETED BY\'|translate}}\"><div ng-messages=\"basicForm.CompletedBy.$error\" \nng-show=\"basicForm.CompletedBy.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.COMPLETED BY IS REQUIRED\">Completed By is required.</span></div></div></md-input-container>\n</div></div><div class=\"content fullpage-datatable\" layout=\"column\" style=\"margin-top: -50px\" flex><div \nstyle=\"text-align:justify\"><hr><h4><b>{{\'RECRUITMENT.RECRUITMENT PURPOSE\'|translate}}</b></h4></div><h4 \nstyle=\"text-align:justify;font-size:17px\"><b>{{\'RECRUITMENT.RATING KEY - NS\'|translate}}:</b>\n {{\'RECRUITMENT.NOT SATISFACTORY\'|translate}}; <b>S:</b> {{\'RECRUITMENT.SATISFACTORY\'|translate}}; <b>VS:</b>\n {{\'RECRUITMENT.VERY SATISFACTORY\'|translate}}; <b>NA:</b> {{\'RECRUITMENT.NOT APPLICABLE\'|translate}}<br></h4></div>\n</div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.EDUCATIONAL BACKGROUND\'|translate}} </b></h1><div style=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.DOES THE CANDIDATE HAVE THE APPROPRIATE EDUCATIONAL QUALIFICATIONS OR TRAINING FOR THIS POSITION\'|translate}}\n</h2></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"EducationalComment\" \nplaceholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-group ng-model=\"Educational\" layout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button \nvalue=\"S\">S</md-radio-button><md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA\n</md-radio-button></md-radio-group></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.PRIOR WORK EXPERIENCE\'|translate}}</b></h1><div \nstyle=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.HAS THE CANDIDATE ACQUIRED NECESSARY SKILLS OR QUALIFICATIONS THROUGH PAST WORK EXPERIENCES\'|translate}}\n</h2></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"ExperienceComment\" \nplaceholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-group ng-model=\"Experience\" layout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button \nvalue=\"S\">S</md-radio-button><md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA\n</md-radio-button></md-radio-group></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;<b>{{\'RECRUITMENT.TECHNICAL QUALIFICATIONS/EXPERIENCE\'|translate}} </b></h1><div style=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.DOES THE CANDIDATE HAVE THE TECHNICAL SKILLS NECESSARY FOR THIS POSITION\'|translate}}</h2></div>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"QualificationsComment\" \nplaceholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-group ng-model=\"Qualifications\" layout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button\n value=\"S\">S</md-radio-button><md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA\n</md-radio-button></md-radio-group></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.COMMUNICATION SKILLS\'|translate}} </b></h1><div \nstyle=\"margin-top: -20px\"><h2>&nbsp;{{\'RECRUITMENT.(WRITTEN AND VERBAL)\'|translate}}</h2></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"CommunicationComment\" placeholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-group ng-model=\"Communication\" \nlayout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button value=\"S\">S</md-radio-button>\n<md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA</md-radio-button></md-radio-group></div>\n</div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.PRESENTATION\'|translate}} </b></h1><div style=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.(PROMPTNESS, NEATNESS OF RESUME/APPLICATION, APPEARANCE)\'|translate}}</h2></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"PresentationComment\" placeholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-group ng-model=\"Presentation\" \nlayout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button value=\"S\">S</md-radio-button>\n<md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA</md-radio-button></md-radio-group></div>\n</div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.CANDIDATE ENTHUSIASM\'|translate}} </b>\n</h1><div style=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.HOW MUCH INTEREST DID THE CANDIDATE SHOW IN THE POSITION?\'|translate}}</h2></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"EnthusiasmComment\" placeholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-group ng-model=\"Enthusiasm\" layout=\"row\">\n<md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button value=\"S\">S</md-radio-button><md-radio-button \nvalue=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA</md-radio-button></md-radio-group></div></div></div><br>\n<br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.JOB STABILITY\'|translate}}</b></h1>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"StabilityComment\" \nplaceholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-group ng-model=\"Stability\" layout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button \nvalue=\"S\">S</md-radio-button><md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA\n</md-radio-button></md-radio-group></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\">\n<md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.OVERALL IMPRESSION AND RECOMMENDATION\'|translate}} </b></h1><div \nstyle=\"margin-top: -20px\"><h2>\n&nbsp;{{\'RECRUITMENT.FINAL COMMENTS AND RECOMMENDATIONS FOR PROCEEDING WITH THIS CANDIDATE\'|translate}}</h2></div><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"ImpressionComment\" \nplaceholder=\"{{\'RECRUITMENT.COMMENTS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-group ng-model=\"Impression\" layout=\"row\"><md-radio-button value=\"NS\">NS</md-radio-button><md-radio-button \nvalue=\"S\">S</md-radio-button><md-radio-button value=\"VS\">VS</md-radio-button><md-radio-button value=\"NA\">NA\n</md-radio-button></md-radio-group></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">\n&nbsp;<b>{{\'RECRUITMENT.CANDIDATES STRENGTHS\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"CandidateStrength\"></text-angular></div>\n</div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div>\n<div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.CANDIDATES WEAKNESSES\'|translate}}</b>\n</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"CandidateWeakness\"></text-angular></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.PLEASE PROVIDE ANY ADDITIONAL COMMENTS YOU HAVE ABOUT THIS CANDIDATE\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"AdditionalComment\"></text-angular></div></div></div><br><br><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"Result\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.RESULT\'|translate}}:</b></span><md-radio-button value=\"{{\'RECRUITMENT.SELECTED\'|translate}}\">\n{{\'RECRUITMENT.SELECTED\'|translate}}</md-radio-button><md-radio-button \nvalue=\"{{\'RECRUITMENT.NOT-SELECTED\'|translate}}\">{{\'RECRUITMENT.NOT-SELECTED\'|translate}}</md-radio-button>\n<md-radio-button value=\"KVI\">KVI</md-radio-button></md-radio-group></md-radio-container></div></form><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"evaluationSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm2.$invalid || basicForm2.$pristine\">{{\'RECRUITMENT.SUBMIT\'|translate}}</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></div></div>\n</div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Contract\" flex><form \nname=\"basicForm3\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"PrintContract()\"><span translate=\"RECRUITMENT.PRINT\">Print</span></md-button>\n</div><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>\n{{\'RECRUITMENT.EMPLOYMENT CONTRACT FORM\'|translate}}</b></div><div class=\"content-card\" style=\"padding:30px\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"Name\" \nplaceholder=\"{{\'RECRUITMENT.NAME\'|translate}}\" readonly=\"readonly\"></md-input-container><md-input-container flex><input\n type=\"text\" name=\"Address\" ng-model=\"Address\" placeholder=\"{{\'RECRUITMENT.ADDRESS\'|translate}}\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Date\" ng-model=\"Date1 | date:\'dd/MM/y\'\" \nplaceholder=\"{{\'RECRUITMENT.DATE\'|translate}}\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"RECRUITMENT.CONTRACT TEMPLATE\">Contract Template</label>\n<md-select ng-model=\"ContractTemplate\" ng-change=\"ContractTemplateDetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{\'RECRUITMENT.SEARCH FOR A TEMPLATE\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"ContractSearchTermcancel()\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeecontracttemplateformdatas | filter:vm.searchTerm\" value=\"{{row._id}}\">{{row.TemplateName}}\n</md-option></md-select></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container></div><br><br><div style=\"text-align:left;font-size:20px;font-weight:500\"><b>\n{{\'RECRUITMENT.CONTRACT OF SERVICE\'|translate}}</b></div><div style=\"text-align:justify;font-size:17px\"><p>\n{{\'RECRUITMENT.WE REFER TO YOUR SUCCESSFUL APPLICATION FOR EMPLOYMENT DATED\'|translate}} &nbsp;<md-input-container \nflex style=\"margin-top:35px\"><md-datepicker onkeydown=\"return false\" ng-model=\"Date2\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container>&nbsp;&nbsp;&nbsp; {{\'RECRUITMENT.FOR THE POST OF\'|translate}} &nbsp;\n<md-input-container style=\"width: 350px;margin-bottom: -5px\" flex><input type=\"text\" name=\"Post\" ng-model=\"Post\" \nplaceholder=\"\"><div ng-messages=\"basicForm.Post.$error\" ng-show=\"basicForm.Post.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.POST FIELD IS REQUIRED\">Post field is required.</span></div></div>\n</md-input-container>&nbsp; {{\'RECRUITMENT.YOU WILL BE EMPLOYED EFFECTIVE\'|translate}} &nbsp;<md-input-container flex \nstyle=\"margin: -12px\"><md-datepicker onkeydown=\"return false\" ng-model=\"Date3\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container>&nbsp;&nbsp;&nbsp; {{\'RECRUITMENT.ON THE FOLLOWING TERMS\'|translate}}: -</p></div>\n<br></div><br><div class=\"content-card\" style=\"padding:30px\"><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"EmpContract\" class=\"pb-32\"></text-angular></div></form><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"contractSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm3.$invalid || basicForm3.$pristine\">{{\'RECRUITMENT.SUBMIT\'|translate}}</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">{{\'RECRUITMENT.CANCEL\'|translate}}</md-button></div></div></div>\n</div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"JobInduction1\" flex>\n<form name=\"basicForm4\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"printOJT(row._id)\"><span translate=\"RECRUITMENT.PRINT\">Print</span></md-button>\n</div><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>{{\'RECRUITMENT.JOB INDUCTION FORM\'|translate}}\n</b></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" \nlayout-gt-xs=\"column\" layout-align=\"center end\"><md-input-container flex style=\"margin-top: 18px\" id=\"datehr\"><label \ntranslate=\"RECRUITMENT.PLEASE RETURN TO HUMAN RESOURCE BY\">PLEASE RETURN TO HUMAN RESOURCE BY</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"ReturntoHRDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"Employee\" \nplaceholder=\"{{\'RECRUITMENT.EMPLOYEE\'|translate}}\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"SeniorName\" ng-model=\"SeniorName\" \nplaceholder=\"{{\'RECRUITMENT.SENIORS NAME & SIGNATURE\'|translate}}\"><div ng-messages=\"basicForm.SeniorName.$error\" \nng-show=\"basicForm.SeniorName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RECRUITMENT.SENIORNAME FIELD IS REQUIRED\">SeniorName field is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"RECRUITMENT.DATE OF INDUCTION\">Date of Induction</label><md-datepicker onkeydown=\"return false\" \nng-model=\"DateofInduction\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" name=\"Attachement\" \nng-model=\"Attachement\" placeholder=\"{{\'RECRUITMENT.ATTACHMENT\'|translate}}\"><div \nng-messages=\"basicForm.Attachement.$error\" ng-show=\"basicForm.Attachement.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"RECRUITMENT.ATTACHMENT IS REQUIRED\">Attachment is required.</span></div></div>\n</md-input-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.GENERAL - TO CONDUCT BEFORE TRAINEE LEAVE OFFICE\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"GeneralConductAcknowledgment\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"GeneralConductTraineeLearn\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"GeneralConductRemarks\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"GeneralConductSeniorCheck\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n1. {{\'RECRUITMENT.INTRODUCE YOURSELF\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment1\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn1\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks1\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckIntroduce\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n2. {{\'RECRUITMENT.INTRODUCE FELLOW COLLEAGUES/SENIORS\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"Acknowledgment2\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn2\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks2\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckSeniors\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>\n3. {{\'RECRUITMENT.ASK HOW TO CALL OFFICE/SENIOR, TOLL FREE LINES & EMERGENCY LINE\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment3\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn3\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks3\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckEmergency\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>4. {{\'RECRUITMENT.UNIFORM AND ID PASS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment4\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn4\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks4\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckUniform\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>5. {{\'RECRUITMENT.DRESSING/PERSONAL GROOMING\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment5\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn5\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks5\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckDressing\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>6. {{\'RECRUITMENT.WORKING HOURS; REPORTING IN FOR WORK\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment6\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn6\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks6\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckWorking\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>7. {{\'RECRUITMENT.PUNCTUALITY & PERFECT ATTENDANCE INCENTIVE\'|translate}}</b></h1><hr>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment7\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn7\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks7\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckPunctuality\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n8. {{\'RECRUITMENT.ABSENTEESIM & REPORTING ABSENCE; TIME OFF / URGENT LEAVE & OTHER FORM OF LEAVE\'|translate}}</b></h1>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment8\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn8\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks8\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckAbsenteesim\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n9. {{\'RECRUITMENT.REPORTING OF MEDICAL CERTIFICATE\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"Acknowledgment9\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn9\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks9\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckMedical\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>10. {{\'RECRUITMENT.LUNCH AND BREAK PERIODS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment10\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn10\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks10\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckLunch\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>11. {{\'RECRUITMENT.SAFETY RULES AND EQUIPMENTS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment11\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn11\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks11\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckSafety\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>12. {{\'RECRUITMENT.SUBMISSION OF CHEMICAL MATERIAL RESQUISITION\'|translate}} </b></h1>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment12\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn12\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks12\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckSubmission\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n13. {{\'RECRUITMENT.OVERTIME, SUBMISSION OF OT CARD & OT PAYMENT\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment13\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn13\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks13\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckOvertime\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>14. {{\'RECRUITMENT.COMPANYS PRODUCTS AND SERVICES\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment14\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn14\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks14\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckProducts\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>15. {{\'RECRUITMENT.EMPLOYEES JOB DESCRIPTION\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment15\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn15\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks15\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckEmployee\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>16. {{\'RECRUITMENT.MONTHLY STAFF GENERAL MEETING\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment16\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn16\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks16\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckMeeting\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>17. {{\'RECRUITMENT.TRAINING NOTICE BOARDS\'|translate}} </b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment17\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn17\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks17\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckBoards\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>18. {{\'RECRUITMENT.MINUTES OF MEETINGS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment18\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn18\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks18\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckMinutes\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>19. {{\'RECRUITMENT.WHERE TO GET INFORMATION AND HELP\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment19\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn19\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks19\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckHelp\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>20. {{\'RECRUITMENT.WHO WILL HANDLE EMPLOYEES PROBLEMS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment20\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn20\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks20\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckHandle\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>21. {{\'RECRUITMENT.STORE / VEHICLE MAINTENACE\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment21\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn21\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks21\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckVehicle\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>22. {{\'RECRUITMENT.NO SMOKING\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment22\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn22\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks22\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckSmoking\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>{{\'RECRUITMENT.STATIONED\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"StationedAcknowledgment\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"StationedTraineeLearn\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"StationedRemarks\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"StationedSeniorCheck\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n23. {{\'RECRUITMENT.MONTHLY SUBMISSION OF DAILY ATTENDANCE\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment23\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn23\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks23\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckAttendance\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>24. {{\'RECRUITMENT.MONTHLY SUBMISSION OF PEST ACTIVITY LOG & ROOM CHART\'|translate}} \n</b></h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment24\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn24\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks24\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckActivity\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n25. {{\'RECRUITMENT.SUBMISSION OF REPORTS FOR OVERTIME JOB OR ATTACHED ACCOUNTS REPORTS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment25\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn25\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks25\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"SeniorCheckOvertimeAccounts\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.STATIONED\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"MobileAcknowledgment\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"MobileTraineeLearn\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"MobileRemarks\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"MobileSeniorCheck\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n26.{{\'RECRUITMENT.WEEKLY SUBMISSION OF VEHICLE LOG SHEET\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment26\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn26\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks26\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckSheet\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>27. {{\'RECRUITMENT.DAILY SUBMISSION OF REPORTS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment27\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn27\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks27\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckDaily\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>28. {{\'RECRUITMENT.SUBMISSION OF NON-CONTRACTURAL JOB & PAYMENT\'|translate}}</b></h1>\n<hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment28\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn28\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks28\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckPayment\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n29. {{\'RECRUITMENT.REPORTING OF VEHICLE ACCIDENT\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"Acknowledgment29\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn29\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks29\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckVehicleAccident\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>30. {{\'RECRUITMENT.MONTHLY VEHICLE COMPETITION\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment30\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn30\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks30\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"SeniorCheckVehicleCompetition\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n31.{{\'RECRUITMENT.TOUR OF WORK AREA\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"Acknowledgment31\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"TraineeLearn31\" placeholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Remarks31\" \nplaceholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-radio-container flex><md-radio-group ng-model=\"SeniorCheckTour\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.TO CONDUCT WITHIN 1 WEEK FROM DATE OF EMPLOYMENT\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"DateofEmploymentAcknowledgment\" \nplaceholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"DateofEmploymentTraineeLearn\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"DateofEmploymentRemarks\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group \nng-model=\"DateofEmploymentSeniorCheck\" layout=\"row\"><span style=\"width:135px\"><b>\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button value=\"No\">{{\'RECRUITMENT.NO\'|translate}}\n</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}</md-radio-button></md-radio-group>\n</md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span translate=\"RECRUITMENT.SAVE DRAFT\">\nSave Draft</span></md-button></div><div class=\"content-card\"><h1 style=\"text-align:left\">&nbsp;<b>\n32. {{\'RECRUITMENT.INTRODUCE KEY CUSTOMERS STAFF\'|translate}}</b></h1><hr><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"Acknowledgment32\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn32\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks32\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckStaff\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>33. {{\'RECRUITMENT.IMPORTANCE OF JOB TO PRODUCTIVITY\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment33\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn33\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks33\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckProductivity\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>34. {{\'RECRUITMENT.IMPORTANCE OF JOB TO QUALITY\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment34\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn34\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks34\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckQuality\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><br><br><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>35. {{\'RECRUITMENT.IMPORTANCE OF JOB TO COLLEAGUES\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment35\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn35\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks35\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckColleagues\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"SaveDraft()\" style=\"float:right\"><span \ntranslate=\"RECRUITMENT.SAVE DRAFT\">Save Draft</span></md-button></div><div class=\"content-card\"><h1 \nstyle=\"text-align:left\">&nbsp;<b>36. {{\'RECRUITMENT.IMPORTANCE OF JOB TO TOTAL PROCESS\'|translate}}</b></h1><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" ng-model=\"Acknowledgment36\" placeholder=\"{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"TraineeLearn36\" \nplaceholder=\"{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?\"></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"Remarks36\" placeholder=\"{{\'RECRUITMENT.REMARKS\'|translate}}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-radio-container flex><md-radio-group ng-model=\"SeniorCheckProcess\" \nlayout=\"row\"><span style=\"width:135px\"><b>{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}:</b></span><md-radio-button \nvalue=\"No\">{{\'RECRUITMENT.NO\'|translate}}</md-radio-button><md-radio-button value=\"Yes\">{{\'RECRUITMENT.YES\'|translate}}\n</md-radio-button></md-radio-group></md-radio-container></div></div></div></form><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"jobinductionSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm4.$invalid || basicForm4.$pristine\">{{\'RECRUITMENT.SUBMIT\'|translate}}\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">{{\'RECRUITMENT.CANCEL\'|translate}}\n</md-button></div></div></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"JobInduction2\" flex><form name=\"basicForm5\" novalidate><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"PrintJobInduction2(\'JI2\', row.id)\"><span \ntranslate=\"RECRUITMENT.PRINT\">Print</span></md-button></div><h1><b>{{\'RECRUITMENT.EXPLANATION OF TERMS\'|translate}} \n</b></h1><div class=\"content-card\"><h2 style=\"text-align:left\">&nbsp;<b>\n{{\'RECRUITMENT.ON-THE-JOB INDUCTION CHECKLIST\'|translate}}</b></h2><hr><div \nstyle=\"text-align:justify;font-size:17px;padding:25px\"><table \nstyle=\"width:100%; border: 1px solid black;border-collapse: collapse\"><thead><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">1</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE YOURSELF TO YOUR FELLOW COLLEAGUES\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">2</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE FELLOW COLLEAGUES TO HIM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">3</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.OFFICE: 6288 2828 / EMERGENCY LINE: 91809990\'|translate}}</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">4</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.UNIFORM MUST BE NEAT AND CLEAN AT ALL TIMES. TEMP ID PASS DURING PROBATION AND PERM ID PASS FOR CONFIRMED ASSOCIATE\'|translate}}\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">5\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HAIR MUST BE KEPT SHORT AND NEAT. NO COLOURED HAIR OR FUNKY HAIRSTYLE\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">6</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.MON-FRI: 0830-1730HRS, SAT: 0830-1230HRS. REPORTING IN BEFORE 0830HRS. EVERY SATURDAYS, REPORT TO 6320 1737\'|translate}}\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">7\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.PERFECT ATTENDANCE INCENTIVE IS GIVEN WITH NO LATENESS, MC, RESERVIST, URGENT LEAVE FOR THE MONTH\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">8\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SEEK FOR HODS APPROVAL FOR ALL LEAVE APPLICATION\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">9</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.REPORT SICK BEFORE 0830HRS TO SENIORS OR OFFICE ASSOCIATE, REPORT SICK LEAVE STATUS BEFORE 1100HRS. NO SMS/VOICEMAIL ALLOWED\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n10</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.1 HOUR LUNCH BREAK\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">11</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.DESCRIBE GENERAL SAFETY REGULATIONS LIKE NOT TO SMOKE OR EAT ON THE JOB.MORE SPECIFIC SAFETY PROCEDURES CAN BE DEMONSTRATED WHEN TEACHING THE TASKS CONCERNED\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n12</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY EVERY THURSDAY, CHEMICAL WILL BE COLLECTED THE FOLLOWING MONDAY\'|translate}}.</th></tr><tr><th\n colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">13</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.OT CARD SUBMISSION ON EVERY 3RD WORKING DAY OF THE FOLLOWING MONTH.PAYMENT WILL BE GIVEN IN THE MID MONTH OF THE FOLLOWING MONTH\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n14</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHAT SERVICES PESTBUSTERS PROVIDES TO ITS CUSTOMERS AND WHAT THE CUSTOMER EXPECTS FROM US\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n15</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN THE TRAINEES ROLE IN PESTBUSTERS, AND WHAT THE COMPANY EXPECTS FROM HIM/HER\'|translate}}.</th>\n</tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">16\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHEN AND WHERE ARE THE MAMS AND AGMS HELD, AND WHAT ARE THEY ALL ABOUT\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">17 & 18</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHERE ARE THEY AND WHY THE ASSOCIATE NEEDS TO READ THEM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">19</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW TO CONTACT SENIOR, SUPERVISOR OR THE OFFICE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">20</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHO TO ASK, DEPENDING ON THE NATURE OF THE PROBLEM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">21</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW TO MAINTAIN THE STORE OR VEHICLE AND WHY THAT IS IMPORTANT\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">22</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHY SMOKING IS NOT PERMITTED ON THE JOB, IN THE STORE AND IN THE VEHICLE.POINT OUR THE DESIGNATED AREAS WHERE THE CLIENTS REGULATIONS ALLOW SMOKING\'|translate}}\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n23,24 & 25</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY THE 3RD OF THE FOLLOWING MONTH. FAX IS ACCEPTABLE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">26</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY EVERY MONDAY\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">27</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY NEXT WORKING DAY, PREFERABLY IN THE MORNING\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">28</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT WITHIN THE SAME WORKING DAY, IF NOT LATEST BY NEXT WORKING DAY MORNING\'|translate}}.</th></tr>\n<tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">29</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.IMMEDIATELY INFORM OFFICE ASSOCIATE IF ANY ACCIDENT OF THE VEHICLE OCCURRED\'|translate}}.</th></tr><tr>\n<th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">30</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EVERY 2ND TUESDAY OF THE MONTH AT 0730HRS\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">31</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.APPLIES TO STATIONED TECHNICIANS. SHOW THE TRAINEE ALL RELEVANT AREAS LIKE STORE, HOUSEKEEPING DEPT, KITCHENS, CANTEENS, ETC.TELL HIM WHERE TO CHANGE HIS PASS AND WHO TO REPORT TO\'|translate}}\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n32</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE IMPORTANT CLIENTS AND KEY CUSTOMER ASSOCIATE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">33</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHAT SERVICES PESTBUSTERS PROVIDES TO ITS CUSTOMERS AND WHAT THE CUSTOMER EXPECTS FROM US\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n34</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.DESCRIBE HOW THE TRAINEE IS EXPECTED TO CONTRIBUTE TO THE COMPANYS QUALITY SERVICE\'|translate}}.</th>\n</tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">35\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPAIN HOW HIS FELLOW ASSOCIATES RELY ON HIS COOPERATION\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">36</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW DOES HIS JOB FIT INTO THE OPERATIONS OF THE WHOLE COMPANY\'|translate}}.</th></tr></thead><tbody>\n</tbody><tfoot></tfoot></table></div></div></form></div></div></div><div class=\"content\" id=\"JobApp\" ng-show=\"JA\"><div \nclass=\"content\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">\n&emsp;&emsp;&emsp;<b>{{\'RECRUITMENT.JOB APPLICATION FORM\'|translate}}</b></div><br><br><div \nstyle=\"text-align:left;font-size:20px;font-weight:500\"><b>{{\'INSTRUCTIONS\'}}</b></div><div \nstyle=\"text-align:justify;font-size:17px\"><p><ol><li>\n{{\'RECRUITMENT.THIS FORM HAS BEEN DESIGNED TO PROVIDE US WITH BASIC INFORMATION FOR EASY PROCESSING OF YOUR APPLICATION FOR EMPLOYMENT WITH US\'|translate}}.\n</li><li>{{\'RECRUITMENT.ALL RELEVANT PARTS OF THIS APPLICATION FORM MUST BE COMPLETED\'|translate}}.</li><li>\n{{\'RECRUITMENT.ASTERISK (*) ITEMS ARE FOR ADMINISTRATIVE PURPOSES ONLY\'|translate}}.</li></ol></p></div><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead></thead><tbody><tr><th valign=\"top\" colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;height:60px; text-align:left\">\n{{\'RECRUITMENT.POSITION APPLIED FOR\'|translate}}:<br><br>{{PositionApplied}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.DATE OF APPLICATION\'|translate}}:<br><br>{{DateofApplication | date:\'dd/MM/y\'}}</th></tr></tbody><tfoot>\n</tfoot></table></div><h3 style=\"font-weight: 600\">1. {{\'RECRUITMENT.PERSONAL PARTICULARS\'|translate}}</h3><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead></thead><tbody><tr><th valign=\"top\" colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.NAME, AS IN PASSPORT/NRIC\'|translate}} (Underline surname):<br><br>{{NameinPassport}}</th><th \nvalign=\"top\" colspan=\"3\" rowspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{\'RECRUITMENT.NAME IN NATIVE SCRIPT, IF APPLICABLE\'|translate}}:<br><br>{{NameinNative}}</th></tr><tr><th \nvalign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.NRIC/FIN NUMBER\'|translate}}:<br><br>{{FINNumber}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.PASSPORT_NUMBER\'|translate}}:<br><br>{{PassportNumber}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><label style=\"width:50px\">\n{{\'RECRUITMENT.SEX\'|translate}}*:</label><br><br>{{Sex}}</th></tr><tr><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;  border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.PLACE OF BIRTH\'|translate}}:<br><br>{{PlaceofBirth}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black; border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.DATE_OF_BIRTH\'|translate}}*:<br><br>{{DOB | date:\'dd/MM/y\'}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.RACE\'|translate}}*:<br><br>{{Race}}</th></tr><tr><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><label style=\"width:150px\">\n{{\'RECRUITMENT.MARITAL_STATUS\'|translate}}*:</label><br><br>{{MaritalStatus}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><label style=\"width:150px\">\n{{\'RECRUITMENT.DRIVING LICENSE\'|translate}}:</label><br><br>{{DrivingLicense}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.DRIVING LICENSE PASSING DATE\'|translate}}:<br><br>{{DLPassingDate | date:\'dd/MM/y\'}}</th></tr><tr><th \nvalign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.CITIZENSHIP\'|translate}}:<br><br>{{Citizenship}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><label style=\"width:100px\">\nSingapore PR:</label><br><br>{{SingaporePR}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.DATE ATTAINED SPR STATUS\'|translate}}:<br><br>{{DateAttainedSPRStatus | date:\'dd/MM/y\'}}</th><th \ncolspan=\"3\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\"></th>\n</tr><tr style=\"background-color:#9E9E9E\"><th colspan=\"12\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:2000px\">\n{{\'RECRUITMENT.CONTACT INFORMATION\'|translate|translate}} (in Singapore)</th></tr><tr><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:80px;text-align:left\">\n{{\'RECRUITMENT.RESIDENTIAL ADDRESS\'|translate}}:<br><br>{{RAddress}}</th><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:80px;text-align:left\">\n{{\'RECRUITMENT.RESIDENTIAL TELEPHONE NUMBER\'|translate}}:<br><br>{{RTelephoneNumber}}</th></tr><tr><th valign=\"top\" \ncolspan=\"6\" style=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:60px;text-align:left\">EMAIL:\n<br><br>{{Email}}</th><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:60px;text-align:left\">\n{{\'RECRUITMENT.MOBILE_NUMBER\'|translate}}:<br><br>{{MobileNumber}}</th></tr><tr style=\"background-color:#9E9E9E\"><th \ncolspan=\"12\" style=\"border: 1px solid black;border-collapse: collapse;width:2000px\">\n{{\'RECRUITMENT.CONTACT INFORMATION\'|translate}} (Overseas, for non-Singapore citizen or permanent resident)</th></tr>\n<tr><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:80px;text-align:left\">\n{{\'RECRUITMENT.PERMANENT RESIDENTIAL ADDRESS\'|translate}}:<br><br>{{PRAddress}}</th><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:80px;text-align:left\">\n{{\'RECRUITMENT.RECRUITMENT.CONTACT NUMBER\'|translate}}(s):<br><br>{{MobileNumber}}</th></tr></tbody><tfoot></tfoot>\n</table></div><br><h3 style=\"font-weight: 600\">2. {{\'RECRUITMENT.FAMILY PARTICULARS\'|translate}}</h3><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.NAME\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.RELATIONSHIP\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.NATIONALITY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.DATE_OF_BIRTH\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.OCCUPATION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.COMPANY\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobfamilydatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Name }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Relationship }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Country }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.DOB | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Occupation }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Company }}</td></tr></tbody><tfoot>\n</tfoot></table></div><br><h3 style=\"font-weight: 600\">\n3. {{\'RECRUITMENT.CONTACT PERSON / NEXT OF KIN - IN CASE OF EMERGENCY\'|translate}}</h3><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead></thead><tbody><tr><th valign=\"top\" colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.NAME\'|translate}}:<br><br>{{EmergencyContactName}}</th><th valign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.RELATIONSHIP\'|translate}}:<br><br>{{EmergencyContactRelationship}}</th></tr><tr><th valign=\"top\" \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px;height:80px;text-align:left\">\n{{\'RECRUITMENT.RECRUITMENT.RESIDENTIAL ADDRESS\'|translate}}:<br><br>{{EmergencyContactRAddress}}</th><th valign=\"top\" \ncolspan=\"3\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;height:80px;text-align:left\">\n{{\'RECRUITMENT.RESIDENTIAL TELEPHONE NUMBER\'|translate}}:<br><br>{{EmergencyContactRTelephoneNumber}}</th></tr><tr><th \nvalign=\"top\" colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.OFFICE TELEPHONE NUMBER\'|translate}}:<br><br>{{EmergencyContactOTelephoneNumber}}</th><th valign=\"top\" \ncolspan=\"3\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;height:60px;text-align:left\">\n{{\'RECRUITMENT.MOBILE_NUMBER\'|translate}}:<br><br>{{EmergencyContactMobileNumber}}</th><th valign=\"top\" colspan=\"6\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;height:60px;text-align:left\">EMAIL:<br><br>\n{{EmergencyContactEmail}}</th></tr></tbody><tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">\n4. {{\'RECRUITMENT.NATIONAL SERVICE (IF APPLICABLE)\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\">\n<table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead></thead><tbody><tr><th valign=\"top\" \ncolspan=\"8\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:left\"><label \nstyle=\"width:135px\">{{\'RECRUITMENT.SERVICE STATUS\'|translate}}:</label><br><br>{{ServiceStatus}}</th></tr><tr><th \nvalign=\"top\" colspan=\"8\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;height: 60px;text-align:left\">\n{{\'RECRUITMENT.IF EXEMPTED, STATE REASON\'|translate}}:<br><br>{{ExemptedReason}}</th></tr><tr><th valign=\"top\" \ncolspan=\"4\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 40px;text-align:left\">\n{{\'RECRUITMENT.ENLISTMENT DATE\'|translate}}:<br><br>{{EnlistmentDate | date:\'dd/MM/y\' }}</th><th valign=\"top\" \ncolspan=\"4\" style=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 40px;text-align:left\">ORD:<br>\n<br>{{ORD}}</th></tr><tr><th valign=\"top\" colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 40px;text-align:left\">\n{{\'RECRUITMENT.RANK AT ORD\'|translate}}:<br><br>{{RankAtORD}}</th><th valign=\"top\" colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\"><label style=\"width:100px\">\n{{\'RECRUITMENT.NS STATUS\'|translate}}:</label><br><br>{{NSStatus}}</th></tr><tr><th valign=\"top\" colspan=\"8\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;height: 40px;text-align:left\">\n{{\'RECRUITMENT.NEXT RESERVIST DATE\'|translate}}:<br><br>{{ReservistDate| date:\'dd/MM/y\'}}</th></tr></tbody><tfoot>\n</tfoot></table></div><br><h3 style=\"font-weight: 600\">5. {{\'RECRUITMENT.SCHOLARSHIPS / AWARDS / BONDS\'|translate}}\n</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.YEAR OF AWARD\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.DESCRIPTION|translate\'}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.VALUE OF AWARD\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.START DATE OF BOND\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.END DATE OF BOND\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobawarddatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.YearofAward }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Description }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.ValueofAward }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.SDOB | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.EDOB | date:\'dd/MM/y\' }}</td></tr>\n</tbody><tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">\n6. {{\'RECRUITMENT.PROFESSIONAL MEMBERSHIPS\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.ASSOCIATION / SOCIETY / COMPANY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.POSITION HELD\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.FROM\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">{{\'RECRUITMENT.TO\'|translate}}\n</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobmembershipdatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Company }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.PositionHeld}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.From | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.To | date:\'dd/MM/y\' }}</td></tr>\n</tbody><tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">7. {{\'RECRUITMENT.COMPUTER LITERACY\'|translate}}\n</h3><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;height:100px;text-align:left\">{{ComputerLiteracy}}<br><br>\n</th></tr></thead><tbody></tbody><tfoot></tfoot></table><h3 style=\"font-weight: 600\">\n8. {{\'RECRUITMENT.LANGUAGE PROFICIENCY\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:center\">\n{{\'RECRUITMENT.LANGUAGE / DIALECTS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.WRITTEN|translate\'}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.SPOKEN\'|translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjoblanguagedatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Language }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Written }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Spoken }}</td></tr></tbody><tfoot>\n</tfoot></table></div><br><h3 style=\"font-weight: 600\">9. {{\'RECRUITMENT.HOBBIES / INTERESTS / GAMES\'|translate}}</h3>\n<table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;height:100px;text-align:left\">{{Hobbies}}<br><br></th></tr>\n</thead><tbody></tbody><tfoot></tfoot></table><h3 style=\"font-weight: 600\">\n10. {{\'RECRUITMENT.EDUCATIONAL AND OTHER PROFESSIONAL QUALIFICATIONS\'|translate}}</h3><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.NAME OF INSTITUTION/COUNTRY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.HIGHEST QUALIFICATIONS ATTAINED\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;text-align:center\">\n{{\'RECRUITMENT.FROM\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;text-align:center\">{{\'RECRUITMENT.TO\'|translate}}\n</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobeducationdatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.NameofInstitution }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.HighestQualificationsAttained}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.From | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.To | date:\'dd/MM/y\' }}</td></tr>\n</tbody><tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">\n11. {{\'RECRUITMENT.EMPLOYMENT HISTORY\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.NAME OF EMPLOYER\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.ADDRESS OF EMPLOYER\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;text-align:center\">\n{{\'RECRUITMENT.FROM\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;text-align:center\">{{\'RECRUITMENT.TO\'|translate}}\n</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.CURRENT /LAST DRAWN MONTHLY SALARY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.ALLOWANCE & BONUS\'|translate}} (if any)</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.JOB TITLE & BRIEF DESCRIPTION OF DUTIES\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.REASON FOR LEAVING\'|translate}}</th></tr></thead><tbody><tr \nng-repeat=\"row in Recruitmentjobemphistorydatas\" ng-if=\"row.JobApplicationID == JobApplicationID\" \nstyle=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.NameofEmployer }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.AddressofEmployer}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.From | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.To | date:\'dd/MM/y\' }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.LastDrawnMonthlySalary }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.AllowanceBonus}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.JobTitle }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ReasonforLeaving}}</td></tr></tbody><tfoot></tfoot>\n</table></div><br><h3 style=\"font-weight: 600\">12. {{\'RECRUITMENT.SUPPLEMENTAL INFORMATION\'|translate}}</h3><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">S.NO</th><th \ncolspan=\"3\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">\n{{\'RECRUITMENT.SUPPLEMENTAL INFORMATION\'|translate}}</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 80px\">\n{{\'RECRUITMENT.YOUR INFORMATION\'|translate}}</th></tr></thead><tbody><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px\">1.</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.PREVIOUS JOB YOU\'|translate}} <u>\n{{\'RECRUITMENT.ENJOYED THE MOST\'|translate}}</u> {{\'RECRUITMENT.AND WHY\'|translate}}?</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 80px\">{{MostEnjoyed}}</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">2.</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.PREVIOUS JOB YOU\'|translate}} <u>\n{{\'ENJOYED THE LEAST\'|translate}}</u> {{\'AND WHY\'|translate}}?</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 80px\">{{LeastEnjoyed}}</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">3.</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">\n{{\'RECRUITMENT.WHY DO YOU THINK WE SHOULD CONSIDER YOUR APPLICATION\'|translate}}?</th><th colspan=\"3\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 80px\">{{ApplicationConsider}}</th></tr>\n</tbody><tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">\n13. {{\'RECRUITMENT.CHARACTER REFERENCES\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.NAME\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.OCCUPATION & NAME OF THE ORGANISATION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.PERIOD KNOWN\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.ADDRESS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.CONTACT NO\'|translate}}.</th></tr></thead><tbody><tr ng-repeat=\"row in Recruitmentjobcharacterdatas\" \nng-if=\"row.JobApplicationID == JobApplicationID\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Name }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.OccupationName}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.PeriodKnown }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.Address }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{ row.ContactNo }}</td></tr></tbody>\n<tfoot></tfoot></table></div><br><h3 style=\"font-weight: 600\">14. {{\'RECRUITMENT.ADDITIONAL INFORMATION\'|translate}}\n</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{\'RECRUITMENT.ADDITIONAL INFORMATION\'|translate}}</th><th \ncolspan=\"4\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">\n{{\'RECRUITMENT.YOUR INFORMATION\'|translate}}</th></tr></thead><tbody><tr><th colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.WHAT IS YOUR EXPECTED MONTHLY SALARY\'|translate|translate}}?</th><th colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 40px\">{{ExpectedMonthlySalary}}</th></tr>\n<tr><th colspan=\"4\" style=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HOW SOON CAN YOU JOIN US\'|translate}}?</th><th colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;height: 40px\">{{JoinUs}}</th></tr><tr><th \ncolspan=\"4\" style=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HOW DID YOU LEARN ABOUT THIS POSITION\'|translate}}?</th><th colspan=\"4\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{LearnAboutThisPosition}}<br>\n{{LearnAboutThisPositionOtherRemark}}</th></tr></tbody><tfoot></tfoot></table></div><h3 style=\"font-weight: 600\">\n15. {{\'RECRUITMENT.DECLARATION\'|translate}}</h3><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px\">S.NO</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse;text-align:center\">{{\'RECRUITMENT.DECLARATION\'|translate}}\n</th><th colspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\"></th></tr></thead><tbody>\n<tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">1.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HAVE YOU EVER BEEN CHARGED WITH ANY OFFENCE OR CONVICTED BY ANY COURT OR DETAINED BY THE AUTHORITIES (POLICE/CUSTOM/IMMIGRATION) UNDER THE PROVISIONS OF ANY LAW IN SINGAPORE OR ANY COUNTRY? (PLEASE NOTE THAT YOU MUST GIVE FULL DETAILS OF ANY CHARGES MADE AGAINST YOU EVEN IF YOU WERE EVENTUALLY ACQUITTED BY THE COURT.)\'}}|translate\n</th><th colspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Offence}}</th></tr><tr><th\n colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">2.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HAS ANY BANKRUPTCY ACTION EVER BEEN TAKEN AGAINST YOU\'|translate}}?</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Bankruptcy}}</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px\">3.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HAS ANY COURT JUDGEMENT OR ORDER EVER BEEN MADE AGAINST YOU ORDERING YOU TO PAY A DEBT TO SOMEONE\'|translate}}?\n</th><th colspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Judgement}}</th></tr><tr>\n<th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">4.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HAVE YOU SIGNED A PROMISSORY NOTE OR AN ACKNOWLEDGEMENT OF INDEBTEDNESS FOR WHICH THE AMOUNT PLEDGED HAS NOT ALREADY BEEN FULLY REPAID\'|translate}}?\n</th><th colspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Acknowledgement}}</th>\n</tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">5.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'HAVE YOU APPLIED ON ANY PREVIOUS OCCASIONS FOR EMPLOYMENT IN ANY CAPACITY WITH PESTBUSTERS PTE LTD\'|translate}}?\n</th><th colspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Capacity}}</th></tr><tr>\n<th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:40px\">6.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.HAVE YOU BEEN DISMISSED OR SUSPENDED FROM ANY POSITION\'|translate}}?</th><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Position}}</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:40px\">7.</th><th colspan=\"5\" \nstyle=\"border: 1px solid black;border-collapse: collapse\">\n{{\'RECRUITMENT.DO YOU HAVE ANY RELATIVES OR FRIENDS WORKING WITH ANY OF OUR COMPETITORS\'|translate}}?</th><th \ncolspan=\"2\" style=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{Competitors}}</th></tr><tr><th \nvalign=\"top\" colspan=\"8\" style=\"border: 1px solid black;border-collapse: collapse;height:170px;text-align:left\">\n{{\'RECRUITMENT.IF YOUR ANSWER TO ANY OF THE ABOVE IS YES, PLEASE GIVE DETAILS IN THE SPACE PROVIDED OR ON A SEPARATE SHEET\'|translate}}.\n<br><br>{{Declaration}}</th></tr><tr><th colspan=\"8\" style=\"border-collapse: collapse;text-align:left\"><ul><li>\n{{\'RECRUITMENT.1 DECLARATION\'|translate}}.</li><br><li>{{\'RECRUITMENT.2 DECLARATION\'|translate}}.</li><br><li>\n{{\'RECRUITMENT.3 DECLARATION\'|translate}}.</li><br><li>{{\'RECRUITMENT.4 DECLARATION\'|translate}}.</li><br><li>\n{{\'RECRUITMENT.5 DECLARATION\'|translate}}.</li><br><li>{{\'RECRUITMENT.6 DECLARATION\'|translate}}.</li><br><li>\n{{\'RECRUITMENT.7 DECLARATION\'|translate}}.</li><br></ul></th></tr><tr><th colspan=\"8\" \nstyle=\"border-collapse: collapse;text-align:left\">&emsp;{{\'RECRUITMENT.SIGNATURE OF APPLICANT\'|translate}}:<br>\n&emsp;{{SignatureofApplicant}}<br><br><br></th></tr></tbody><tfoot></tfoot></table></div><br><div \nstyle=\"text-align:center;font-size:20px;font-weight:500\"><b>{{\'RECRUITMENT.PRIVACY POLICY STATEMENT\'|translate}}</b>\n</div><br><div style=\"text-align:justify;font-size:17px\"><h3 style=\"font-weight: 600\">\n1.&emsp; {{\'RECRUITMENT.GENERAL\'|translate}}</h3><p style=\"padding-left: 2pc\">{{\'RECRUITMENT.1 PRIVACY\'|translate}}.\n</p><h3 style=\"font-weight: 600\">2.&emsp; Personal Data</h3><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.2 PRIVACY\'|translate}}.</p><p style=\"padding-left: 2pc\">{{\'RECRUITMENT.3 PRIVACY\'|translate}}.</p><p \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.4 PRIVACY\'|translate}}.</p><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.5 PRIVACY\'|translate}}.</p><h3 style=\"font-weight: 600\">\n3.&emsp; {{\'RECRUITMENT.HOW WE USED YOUR PERSONAL DATA\'|translate}}</h3><p style=\"padding-left: 2pc\"><ul \nstyle=\"padding-left: 4pc\"><li>{{\'RECRUITMENT.ADMINISTRATION OF PAY AND BENEFITS\'|translate}}.</li><li>\n{{\'RECRUITMENT.AUDIT OF COMPANY RECORDS, INCLUDING EMPLOYEE RECORDS\'|translate}}.</li><li>\n{{\'RECRUITMENT.APPLICATION FOR EMPLOYMENT PASS/WORK PERMIT/VISA\'|translate}}.</li><li>\n{{\'RECRUITMENT.PAYMENT OF CPF\'|translate}}.</li><li>\n{{\'RECRUITMENT.HOLDING AS PART OF THE COMPANYS RECORDS AS TO THE BUSINESS CARRIED ON BY THE COMPANY\'|translate}}.</li>\n<li>{{\'RECRUITMENT.FILING OF INCOME TAX DETAILS\'|translate}}.</li><li>\n{{\'RECRUITMENT.ORGANISATION OF VOLUNTEER ACTIVITIES AND CHARITABLE GIVING\'|translate}}.</li><li>\n{{\'RECRUITMENT.FACILITATION OF COMMUNICATION WITHIN THE COMPANY AND THE COMPANYS RELATED COMPANIES THROUGH THE USE OF GLOBAL AND LOCAL DIRECTORIES\'|translate}}.\n</li><li>\n{{\'RECRUITMENT.MONITORING OF EACH ASSOCIATES COMPLIANCE WITH COMPANY POLICIES, CONDUCT OF PERFORMANCE REVIEWS AND DETERMINATION OF PERFORMANCE REQUIREMENTS\'|translate}}.\n</li><li>{{\'RECRUITMENT.ESTABLISHMENT OF TRAINING AND DEVELOPMENT REQUIREMENTS\'|translate}}.</li><li>\n{{\'RECRUITMENT.MANAGEMENT OF MEDICAL LEAVE, EVALUATION OF EMPLOYEE WELLNESS PROGRAMMES, HEALTH BENEFITS AND HEALTH INSURANCE, AND\'|translate}}\n</li><li>\n{{\'RECRUITMENT.INVESTIGATION INTO COMPLAINTS AND DISCIPLINARY ISSUES AND CONDUCT OF DISCIPLINARY AND GRIEVANCE PROCEDURES, INCLUDING KEEPING RECORDS THEREOF\'|translate}}.\n</li><li>\n{{\'RECRUITMENT.IF YOU HAVE CONTACTED US WITH ANY FEEDBACK, COMPLAINTS OR COMMENTS, WE MAY USE AND DISCLOSE YOUR PERSONAL DATA TO RESPOND BACK TO YOU\'|translate}} .\n</li></ul></p><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.WE MAY CONTACT YOU VIA REGULAR MAIL, EMAIL, TELECOMMUNICATION MEANS OR ANY OTHER MEANS FOR THE ABOVE PURPOSES BY USING YOUR PERSONAL DATA\'|translate}}\n</p><h3 style=\"font-weight: 600\">4.&emsp;{{\'RECRUITMENT.DISCLOSURE OF PERSONAL DATA\'|translate}}</h3><p \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.1 DISCLOSURE\'|translate}}.</p><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.2 DISCLOSURE\'|translate}}.</p><p style=\"padding-left: 2pc\">{{\'RECRUITMENT.3 DISCLOSURE\'|translate}}.</p>\n<h3 style=\"font-weight: 600\">5.&emsp; Our Safe guard for your personal data</h3><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.4 DISCLOSURE\'|translate}}.</p><h3 style=\"font-weight: 600\">6.&emsp; Amendment of privacy policy</h3><p \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.5 DISCLOSURE\'|translate}}</p><h3 style=\"font-weight: 600\">7.&emsp; Your Rights\n</h3><p style=\"padding-left: 2pc\">{{\'RECRUITMENT.6 DISCLOSURE\'|translate}}:</p><div \nstyle=\"text-align:justify;font-size:17px;padding-left: 2.5pc\"><table \nstyle=\"width:100%;text-align:left;border-collapse: collapse\"><thead><tr style=\"padding-left: 2.5pc\"><th \nstyle=\"border-collapse: collapse;width:70px\">Attention</th><th style=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">Angeline Hia@Ang, Director, Human Capital</th></tr><tr\n style=\"padding-left: 2.5pc\"><th style=\"border-collapse: collapse;width:70px\">Email</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">angeline@pestbusters.com.sg</th></tr><tr \nstyle=\"padding-left: 2.5pc\"><th style=\"border-collapse: collapse;width:70px\">Telephone</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">6288 2828</th></tr><tr style=\"padding-left: 2.5pc\"><th\n style=\"border-collapse: collapse;width:70px\">Address</th><th style=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">\n22 New Industrial Road, #02-03 to 08 Primax, Singapore 536208</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div><h3 style=\"font-weight: 600\">8.&emsp; {{\'RECRUITMENT.GOVERNING LAW\'|translate}}</h3><p style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.7 DISCLOSURE\'|translate}}.</p></div></div></div><div class=\"content\" id=\"InterviewEval\" \nng-show=\"InterEvaluation\"><div class=\"content\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp;<b>{{\'RECRUITMENT.INTERVIEW EVALUATION FORM\'|translate}}</b></div><br>\n<table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:130px\">{{\'RECRUITMENT.NAME OF CANDIDATE\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{NameofCandidate}}</th><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.DEPARTMENT\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{DepartmentName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:130px\">{{\'RECRUITMENT.POSITION TITLE\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{PositionTitle}}</th><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.COMPLETED BY\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{CompletedBy}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:130px\">{{\'RECRUITMENT.DATE OF INTERVIEW\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{DateofInterview | date:\'dd/MM/y\'}}</th><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.INTERVIEWER(S)\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:200px;font-weight:normal\">{{InterviewerName}}</th></tr></thead><tbody></tbody>\n<tfoot></tfoot></table><br><hr><div style=\"text-align:justify\"><h4><p><b>\n{{\'RECRUITMENT.RECRUITMENT PURPOSE\'|translate}}.</b></p></h4></div><h4 style=\"text-align:justify;font-size:17px\"><p><b>\n{{\'RECRUITMENT.RATING KEY - NS\'|translate}}:</b> {{\'RECRUITMENT.NOT SATISFACTORY\'|translate}}; <b>S:</b>\n {{\'RECRUITMENT.SATISFACTORY\'|translate}}; <b>VS:</b> {{\'RECRUITMENT.VERY SATISFACTORY\'|translate}}; <b>NA:</b>\n {{\'RECRUITMENT.RECRUITMENT.NOT APPLICABLE\'|translate}}<br></p></h4><div style=\"text-align:justify;font-size:17px\">\n<table style=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr \nstyle=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:800px;text-align:center\">\n{{\'RECRUITMENT.CRITERIA\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.COMMENTS\'|translate}}:<br>(Be very specific; support your rating)</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n{{\'RECRUITMENT.RATING\'|translate}}</th></tr></thead><tbody><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.EDUCATIONAL BACKGROUND\'|translate}}</b><br>\n{{\'RECRUITMENT.DOES THE CANDIDATE HAVE THE APPROPRIATE EDUCATIONAL QUALIFICATIONS OR TRAINING FOR THIS POSITION\'|translate}}\n</td><td style=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{EducationalComment}}\n</td><td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Educational}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.PRIOR WORK EXPERIENCE\'|translate}}</b><br>\n{{\'RECRUITMENT. HAS THE CANDIDATE ACQUIRED NECESSARY SKILLS OR QUALIFICATIONS THROUGH PAST WORK EXPERIENCES\'|translate}}?\n</td><td style=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{ExperienceComment}}\n</td><td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Experience}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.TECHNICAL QUALIFICATIONS/EXPERIENCE\'|translate}}</b><br>\n{{\'RECRUITMENT.DOES THE CANDIDATE HAVE THE TECHNICAL SKILLS NECESSARY FOR THIS POSITION\'|translate}}?</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{QualificationsComment}}</td>\n<td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Qualifications}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.COMMUNICATION SKILLS\'|translate}}</b><br>{{\'RECRUITMENT.(WRITTEN AND VERBAL)\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{CommunicationComment}}</td><td\n style=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Communication}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.PRESENTATION\'|translate}}</b><br>\n{{\'RECRUITMENT.(PROMPTNESS, NEATNESS OF RESUME/APPLICATION, APPEARANCE)\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{PresentationComment}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Presentation}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.CANDIDATE ENTHUSIASM\'|translate}}</b><br>\n{{\'RECRUITMENT.HOW MUCH INTEREST DID THE CANDIDATE SHOW IN THE POSITION\'|translate}}?</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{EnthusiasmComment}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Enthusiasm}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.JOB STABILITY\'|translate}}</b><br></td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{StabilityComment}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Stability}}</td></tr><tr><td \nstyle=\"border: 1px solid black; border-collapse: collapse;width:800px;text-align:left\"><b>\n{{\'RECRUITMENT.OVERALL IMPRESSION AND RECOMMENDATION\'|translate}}</b><br>\n{{\'RECRUITMENT.FINAL COMMENTS AND RECOMMENDATIONS FOR PROCEEDING WITH THIS CANDIDATE\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">{{ImpressionComment}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">{{Impression}}</td></tr></tbody><tfoot></tfoot>\n</table></div><br><h3 style=\"font-weight: 600\">{{\'RECRUITMENT.CANDIDATES STRENGTHS\'|translate}}:</h3><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;height:100px;text-align:left\">{{CandidateStrength}}<br><br>\n</th></tr></thead><tbody></tbody><tfoot></tfoot></table><h3 style=\"font-weight: 600\">\n{{\'RECRUITMENT.CANDIDATES WEAKNESSES\'|translate}}:</h3><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;height:100px;text-align:left\">{{CandidateWeakness}}<br><br>\n</th></tr></thead><tbody></tbody><tfoot></tfoot></table><h3 style=\"font-weight: 600\">\n{{\'RECRUITMENT.PLEASE PROVIDE ANY ADDITIONAL COMMENTS YOU HAVE ABOUT THIS CANDIDATE\'|translate}}:</h3><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;height:100px;text-align:left\">{{AdditionalComment}}<br><br>\n</th></tr></thead><tbody></tbody><tfoot></tfoot></table><br></div></div><div class=\"content\" id=\"Con\" ng-show=\"EmpCon\">\n<div class=\"content\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">\n&emsp;&emsp; <b>{{\'RECRUITMENT.EMPLOYMENT CONTRACT FORM\'|translate}}</b></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:50px\">{{\'RECRUITMENT.NAME\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Name}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:50px\">{{\'RECRUITMENT.ADDRESS\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Address}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:50px\">{{\'RECRUITMENT.DATE\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Date1 | date:\'dd/MM/y\'}}</th></tr></thead><tbody>\n</tbody><tfoot></tfoot></table><br><div style=\"text-align:left;font-size:20px;font-weight:500\"><b>\n{{\'RECRUITMENT.CONTRACT OF SERVICE\'|translate}}</b></div><div style=\"text-align:justify;font-size:17px\"><p>\n{{\'RECRUITMENT.WE REFER TO YOUR SUCCESSFUL APPLICATION FOR EMPLOYMENT DATED\'|translate}} &nbsp;{{Date2 | date:\'dd/MM/y\'}}&nbsp;&nbsp; {{\'RECRUITMENT.FOR THE POST OF\'|translate}} \n<b><u>{{Post}}.</u></b>\n {{\'YOU WILL BE EMPLOYED EFFECTIVE\'|translate}} &nbsp; {{Date3 | date:\'dd/MM/y\'}}&nbsp;&nbsp; {{\'RECRUITMENT.ON THE FOLLOWING TERMS\'|translate}}: -\n</p></div><div style=\"text-align:justify;font-size:17px\"><h3 style=\"font-weight: 600\">\n&nbsp;1.&emsp; {{\'RECRUITMENT.INFORMATION SUPPLIED BY YOU\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 EMPLOYEMENT\'|translate}} <u>{{\'RECRUITMENT.WITHOUT NOTICE\'|translate}}.</u></p><h3 \nstyle=\"font-weight: 600\">&nbsp;2.&emsp; {{\'RECRUITMENT.PROBATION\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 PROBATION\'|translate}}.</p><h3 style=\"font-weight: 600\">\n&nbsp;3.&emsp; {{\'RECRUITMENT.CONFIRMATION\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 CONFIRMATION\'|translate}}.</p><h3 style=\"font-weight: 600\">\n&nbsp;4.&emsp; {{\'RECRUITMENT.SALARY\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.YOU WILL BE PAID A MONTHLY BASIC SALARY OF\'|translate}} &nbsp;$____________________</p><p \nstyle=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.YOU WILL ALSO BE ELIGIBLE FOR THE PERFECT ATTENDANCE INCENTIVE\'|translate}}, &nbsp; $____________________ &nbsp;&nbsp;{{\'RECRUITMENT.EACH MONTH IF YOU MEET THE FOLLOWING CRITERIA\'|translate}}:\n<br><ul style=\"padding-left: 5pc\"><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.NO MEDICAL LEAVE\'|translate}}.</li><li \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.NO RESERVIST\'|translate}}.</li><li style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.RECRUITMENT.PUNCTUAL. REPORTING TO WORK BY / BEFORE 0830 HOURS\'|translate}}.</li><li \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.NO URGENT LEAVE\'|translate}} .</li><li style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.NO TIME-OFF APPLICATION\'|translate}}.</li></ul></p><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.A TOTAL SUM OF\'}} &nbsp; $____________________&nbsp;&nbsp; {{\'RECRUITMENT.WILL BE RETAINED FROM YOUR 1ST SALARY. THIS WILL BE REFUNDED WHEN ALL THE ITEMS ISSUED TO YOU HAVE BEEN RETURNED ON THE LAST DAY OF YOUR EMPLOYMENT\'|translate}}.\n</p><h3 style=\"font-weight: 600\">&nbsp;5.&emsp; {{\'RECRUITMENT.SALARY PAYMENT\'}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.DURING THE PROBATIONARY PERIOD, YOUR SALARY WILL BE PAID ON THE\'|translate}} <b><u>\n{{\'RECRUITMENT.3RD\'|translate}}</u></b>\n {{\'RECRUITMENT.WORKING DAY OF THE FOLLOWING MONTH.UPON CONFIRMATION, YOUR SALARY WILL BE PAID THROUGH GIRO AT THE\'|translate}}\n<b>{{\'RECRUITMENT.OCBC (STATE BRANCH)\'|translate}}</b> {{\'RECRUITMENT.OR\'|translate}}<b>POSB.</b>\n{{\'RECRUITMENT.YOU WILL BE REQUIRED TO HAVE AN ACCOUNT WITH\'|translate}} <b>\n{{\'RECRUITMENT.OCBC (STATE BRANCH)\'|translate}}</b>{{\'RECRUITMENT.OR\'|translate}} <b>POSB</b>\n {{\'RECRUITMENT.FOR THIS PURPOSE.THE PERIOD OF SALARY SHALL BE IN ACCORDANCE WITH THE LAW\'|translate}}.</p><p \nstyle=\"padding-left: 2.5pc\"><b>\n{{\'RECRUITMENT.PLEASE TAKE NOTE THAT YOU WILL RECEIVE YOUR SALARY ON THE 28TH OF EACH MONTH IF YOU HAVE AN OCBC BANK SAVINGS ACCOUNT AND THE 29TH IF YOU HAVE A POSB BANK SAVINGS ACCOUNT\'|translate}}.\n</b></p><h3 style=\"font-weight: 600\">&nbsp;6.&emsp; {{\'RECRUITMENT.ANNUAL INCREMENT\'|translate}}</h3><p \nstyle=\"padding-left: 2.5pc\">{{\'RECRUITMENT.THE ANNUAL INCREMENT WILL BE ON\'|translate}} <b>\n{{\'RECRUITMENT.1ST JANUARY\'|translate}}</b> {{\'RECRUITMENT.OF EACH YEAR\'|translate}}.</p><h3 style=\"font-weight: 600\">\n&nbsp;7.&emsp; {{\'RECRUITMENT.ANNUAL LEAVE\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.AN EMPLOYEES ANNUAL LEAVE ENTITLEMENT WILL BE AS FOLLOWS\'|translate}}: -<br><ol \nstyle=\"padding-left: 5pc\"><li style=\"padding-left: 2pc\">\n7 {{\'RECRUITMENT.WORKING DAYS FOR THE 1ST YEAR OF EMPLOYMENT\'|translate}}.</li><br><li style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.THEREAFTER YOU WILL BE ENTITLED TO AN EXTRA DAY OF ANNUAL LEAVE FOR EVERY SUBSEQUENT 12 MONTHS OF CONTINUOUS SERVICE UP TO A MAXIMUM OF 14 DAYS PER YEAR\'|translate}}.\n</li></ol></p><p style=\"padding-left: 2.5pc\"><b>\n{{\'RECRUITMENT.THERE IS NO ENTITLEMENT TO ANNUAL LEAVE DURING PROBATIONARY PERIOD\'|translate}}.</b></p><h3 \nstyle=\"font-weight: 600\">&nbsp;8.&emsp; {{\'RECRUITMENT.PUBLIC HOLIDAY\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.YOU WILL BE ENTITLED TO PAID HOLIDAYS AT THE ORDINARY RATE OF BASIC SALARY ON SUCH PUBLIC DAYS AS SPECIFIED IN ACCORDANCE WITH THE LAW\'|translate}}.\n</p><h3 style=\"font-weight: 600\">&nbsp;9.&emsp; {{\'RECRUITMENT.SICK LEAVE AND HOSPITALIZATION\'|translate}}</h3><p \nstyle=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.UPON CONFIRMATION OF EMPLOYMENT, THE NUMBER OF DAYS OF PAID SICK LEAVE A NEW EMPLOYEE IS ENTITLED TO DEPEND ON HIS SERVICE PERIOD\'|translate}}:\n</p><br><div style=\"text-align:justify;font-size:17px;padding-left: 2.5pc\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n{{\'RECRUITMENT.NO OF MONTHS OF SERVICE COMPLETED OF A NEW EMPLOYEE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n{{\'RECRUITMENT.PAID OUTPATIENT NONHOSPITALISATION LEAVE (DAYS)\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n{{\'RECRUITMENT.PAID HOSPITALISATION LEAVE (DAYS)\'|translate}}*</th></tr></thead><tbody><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n3 {{\'RECRUITMENT.MONTHS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">5</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">15</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n4 {{\'RECRUITMENT.MONTHS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">5 + 3 = 8</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">15 + 15 = 30</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n5 {{\'RECRUITMENT.MONTHS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">8 + 3 = 11</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">30 + 15 = 45</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n6 {{\'RECRUITMENT.MONTHS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">11 + 3 = 14</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">45 + 15 = 60</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">\n{{\'RECRUITMENT.THEREAFTER\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">14</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:700px;text-align:center\">60</td></tr></tbody><tfoot>\n</tfoot></table></div><p style=\"padding-left: 2.5pc\"><b>\n{{\'RECRUITMENT.THERE IS NO ENTITLEMENT TO MEDICAL LEAVE DURING PROBATIONARY PERIOD\'|translate}}.</b></p><h3 \nstyle=\"font-weight: 600\">10.&emsp; {{\'RECRUITMENT.MEDICAL\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.YOU WILL BE ENTITLED TO FREE OUTPATIENT MEDICAL CONSULTATION AND MEDICINE PRESCRIBED BY THE GOVERNMENT MEDICAL PRACTITIONER (POLYCLINIC) ONLY UPON\'|translate}}\n<b><u>{{\'RECRUITMENT.CONFIRMATION\'|translate}}</u></b>\n {{\'RECRUITMENT.OF YOUR EMPLOYMENT. IN THE EVENT,YOU SHOULD SEEK MEDICAL CONSULTATION AND MEDICINE FROM PRIVATE MEDICAL PRACTITIONER/SPECIALIST CLINIC THEN THE COMPANY WILL ONLY REIMBURSE YOU UP TO S$10.00\'| translate}}.\n</p><h3 style=\"font-weight: 600\">11.&emsp; {{\'RECRUITMENT.WORKING HOURS\'|translate}}</h3><p \nstyle=\"padding-left: 2.5pc\">{{\'RECRUITMENT.YOUR WORKING HOURS WILL BE AS FOLLOWS\'|translate}}: -</p><div \nstyle=\"text-align:justify;font-size:17px;padding-left: 2.5pc\"><table \nstyle=\"width:100%;text-align:left;border-collapse: collapse\"><thead><tr style=\"padding-left: 2.5pc\"><th \nstyle=\"border-collapse: collapse;width:150px\">{{\'RECRUITMENT.MONDAYS TO FRIDAYS\'|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">8.30 A.M. TO 5.30 P.M.<br><br></th></tr><tr \nstyle=\"padding-left: 2.5pc\"><th style=\"border-collapse: collapse;width:150px\">{{\'RECRUITMENT.SATURDAYS\'|translate}}<br>\n<br></th><th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">8.30 a.m. to 12.30 p.m.<br><br></th></tr></thead>\n<tbody></tbody><tfoot></tfoot></table></div><p style=\"padding-left: 2.5pc\">\n{{\'BUT WORK ARRANGEMENT MAY BE SUBJECTED TO CHANGES DEPENDING ON JOB REQUIREMENTS\'|translate}}.</p><h3 \nstyle=\"font-weight: 600\">12.&emsp;{{\'RECRUITMENT.OVERTIME\'}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.THE COMPANY SHALL HAVE THE RIGHT TO REQUIRE YOU TO WORK IN EXCESS OF THE NORMAL WORKING HOURS\'|translate}}.\n<br><br>{{\'RECRUITMENT.ANY WORK PERFORMED IN EXCESS OF THE NORMAL HOURS WILL BE REGARDED AS OVERTIME WORK\'|translate}}.\n</p><div style=\"text-align:justify;font-size:17px;padding-left: 2.5pc\"><table \nstyle=\"width:100%;text-align:left;border-collapse: collapse\"><thead><tr style=\"padding-left: 2.5pc\"><th \nstyle=\"border-collapse: collapse;width:150px\">{{\'RECRUITMENT.MONDAYS TO FRIDAYS\'|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">\n{{\'RECRUITMENT.NUMBER OF HOURS X 1.5 TIMES\'|translate}}<br><br></th></tr><tr style=\"padding-left: 2.5pc\"><th \nstyle=\"border-collapse: collapse;width:150px\">{{\'RECRUITMENT.SATURDAYS\'|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">\n{{\'RECRUITMENT.NUMBER OF HOURS X 1.5 TIMES (AFTER 1 P.M.)\'|translate}}<br><br></th></tr><tr \nstyle=\"padding-left: 2.5pc\"><th style=\"border-collapse: collapse;width:150px\">{{\'RECRUITMENT.SUNDAYS\'|translate}}<br>\n<br></th><th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">\n{{\'RECRUITMENT.NUMBER OF HOURS X 1.5 TIMES PLUS ADDITIONAL S$20.00\'|translate}}<br><br></th></tr><tr \nstyle=\"padding-left: 2.5pc\"><th style=\"border-collapse: collapse;width:150px\">\n{{\'RECRUITMENT.PUBLIC HOLIDAYS\'|translate}}<br><br></th><th style=\"border-collapse: collapse;width:10px\">:<br><br></th>\n<th style=\"border-collapse: collapse;width:500px;font-weight:normal\">\n{{\'RECRUITMENT.NUMBER OF HOURS X 1.5 TIMES\'|translate}}<br><br></th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.DRIVERS ALLOWANCE FOR NIGHT TREATMENT (FOR JOBS CARRIED OUT AFTER 12 MIDNIGHT) WILL BE S$5.00 PER NIGHT\'|translate}}.\n</p><h3 style=\"font-weight: 600\">13.&emsp;{{\'RECRUITMENT.CENTRAL PROVIDENT FUND\'}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.THE COMPANY WILL PAY YOUR CPF CONTRIBUTION IN ACCORDANCE WITH THE PROVISION OF THE CENTRAL PROVISION FUND ACT\'|translate}}.\n</p><h3 style=\"font-weight: 600\">14.&emsp;SIM CARD / HANDPHONE / SMART PHONE</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.WHENEVER ANY OF THE ABOVE IS ISSUED TO YOU, YOU ARE TO ENSURE THAT IT IS NOT DAMAGED OR LOST.THE COMPANY HAS THE RIGHT TO RECOVER THE COST OF THE ITEM IF IT IS DAMAGED OR LOST WHILST IN YOUR POSSESSION\'|translate}}.\n</p><h3 style=\"font-weight: 600\">15.&emsp;{{\'RECRUITMENT.TRANSPORT\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.TRANSPORT TO AND FROM THE WORK PLACE WILL BE AT YOUR OWN EXPENSE\'|translate}}.</p><h3 \nstyle=\"font-weight: 600\">16.&emsp;{{\'RECRUITMENT.VEHICLE\'|translate}}</h3><p style=\"padding-left: 2.5pc\"><ol type=\"I\" \nstyle=\"padding-left: 5pc\"><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.1 VEHICLE\'|translate}}</li><br><li \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.2 VEHICLE\'|translate}}.</li><br><li style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.3 VEHICLE\'|translate}}.</li><br><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.4 VEHICLE\'|translate}}.\n</li></ol></p><h3 style=\"font-weight: 600\">17.&emsp;{{\'RECRUITMENT.FLEET CARD FOR PETROL\'|translate}}</h3><p \nstyle=\"padding-left: 2.5pc\">{{\'RECRUITMENT.1 FLEET\'|translate}}</p><h3 style=\"font-weight: 600\">\n18.&emsp;{{\'RECRUITMENT.DAMAGE TO PROPERTIES AND PROPERTIES OF CLIENTS\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n<ol type=\"I\" style=\"padding-left: 5pc\"><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.1 DAMAGE\'|translate}}.</li><br><li \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.2 DAMAGE\'|translate}}.</li><br></ol></p><h3 style=\"font-weight: 600\">\n19.&emsp;{{\'RECRUITMENT.NOTICE OF TERMINATION\'|translate}}</h3><p style=\"padding-left: 2.5pc\"><ol type=\"I\" \nstyle=\"padding-left: 5pc\"><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.1 NOTICE\'|translate}}: -</li></ol><ol type=\"A\" \nstyle=\"padding-left: 8pc\"><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.2 NOTICE\'|translate}}.</li><br><li \nstyle=\"padding-left: 2pc\">{{\'RECRUITMENT.3 NOTICE\'|translate}}.</li><br><li style=\"padding-left: 2pc\">\n{{\'RECRUITMENT.4 NOTICE\'|translate}}.</li><br><li style=\"padding-left: 2pc\">{{\'RECRUITMENT.5 NOTICE\'|translate}}.</li>\n</ol></p><h3 style=\"font-weight: 600\">20.&emsp;{{\'RECRUITMENT.UNIFORM AND EQUIPMENT\'|translate}}</h3><p \nstyle=\"padding-left: 2.5pc\">{{\'RECRUITMENT.1 UNIFORM\'|translate}}<b>{{\'RECRUITMENT.SCHEDULE I\'|translate}}.</b></p><p \nstyle=\"padding-left: 2.5pc\"><b>NB: {{\'RECRUITMENT.2 UNIFORM\'|translate}}.</b></p><h3 style=\"font-weight: 600\">\n21.&emsp;{{\'RECRUITMENT.CONFIDENTIALITY\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 CONFIDENTIALITY\'|translate}}.</p><h3 style=\"font-weight: 600\">\n22.&emsp;{{\'RECRUITMENT.WORK ETHICS\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 ETHICS\'|translate}}.</p><h3 style=\"font-weight: 600\">\n23.&emsp;{{\'RECRUITMENT.EMPLOYEES OBLIGATION\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 OBLIGATION\'|translate}}.</p><p style=\"padding-left: 2.5pc\"><b>\n{{\'RECRUITMENT.2 OBLIGATION\'|translate}}.</b></p><h3 style=\"font-weight: 600\">\n24.&emsp;{{\'RECRUITMENT.COMPANY RULES\'|translate}}</h3><p style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.1 COMPANY\'|translate}}.<br><br>{{\'RECRUITMENT.2 COMPANY\'|translate}}.<br><br>\n{{\'RECRUITMENT.3 COMPANY\'|translate}}.<br><br></p><br><br><br><br><p>{{\'RECRUITMENT.YOURS SINCERELY\'|translate}},<br>\n{{\'RECRUITMENT.FOR AND ON BEHALF OF\'|translate}}<br><b>PESTBUSTERS PTE LTD</b></p><br><br><br><br><br><p><b>TAN LI YI \n</b><br>Manager, Human Capital</p><hr><hr><p>\n{{\'RECRUITMENT.THIS IS TO CONFIRM THAT THE CONTENTS OF THE ABOVE HAVE BEEN EXPLAINED TO ME AND I FULLY UNDERSTOOD AND ACCEPT THE EMPLOYMENT ON THE TERMS AND CONDITIONS SPELT OUT IN THIS AGREEMENT\'|translate}}.\n<br><br>\n{{\'RECRUITMENT.I CONFIRM THAT ALL THE INFORMATION SUPPLIED BY ME TO THE COMPANY IS TRUE AND ACCURATE\'|translate}}.<br>\n<br>{{\'RECRUITMENT.I ALSO CONFIRM THAT I HAVE\'|translate}} <b><u>{{\'RECRUITMENT.NO POLICE RECORDS\'|translate}}</u></b>\n {{\'RECRUITMENT.OF ANY KIND AND HAVE NEVER TAKEN AND AM NOT TAKING\'|translate}} <b><u>\n{{\'RECRUITMENT.ANY PROHIBITED DRUGS\'|translate}}.</u></b></p><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.NAME\'|translate|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Name}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.SIGNATURE\'|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:100px\">NRIC / FIN No<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{FINNumber}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:100px\">{{\'RECRUITMENT.DATE\'|translate}}<br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Date1 | date:\'dd/MM/y\'}}<br><br></th></tr></thead>\n<tbody></tbody><tfoot></tfoot></table></div><br><div style=\"text-align:left;font-size:20px;font-weight:500\"><b>\n{{\'RECRUITMENT.SCHEDULE I\'|translate}}:</b></div><div style=\"text-align:justify;font-size:17px\"><h3 \nstyle=\"font-weight: 600\">\n{{\'RECRUITMENT.CHARGES FOR LOSS / NON-RETURN PERSONAL COMPANY ITEMS UPON TERMINATION OF EMPLOYMENT\'|translate}}.</h3>\n<br><p><ol type=\"I\"><li style=\"padding-left: 2.5pc\">\n{{\'RECRUITMENT.T-SHIRTS, JACKETS, CAPS, POUCH, HAVERSACK, TORCH, HELMET, OVERALL AND ID PASS ARE TO BE|translate\'}} <b>\n<u>{{\'RECRUITMENT.RETURNED\'|translate}}.</u></b><br><br><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead></thead><tbody><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">a</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.T-SHIRT\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$7.00 PER T-SHIRT FOR LAUNDRY PURPOSE AND S$14.00 FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">b</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.JACKET\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$20.00 PER JACKET FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">c</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.CAP\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$8.00 PER CAP FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">d</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.POUCH\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$6.00 PER POUCH FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">e</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.HAVERSACK\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$15.00 PER HAVERSACK FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">f</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.RESPIRATOR\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$41.00 PER RESPIRATOR FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">g</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.SAFETY HELMET\'|translate}}</td><td\n style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$6.00 PER SAFETY HELMET FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">h</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.OVERALL\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S40.00 PER OVERALL FOR NON-RETURNED\'|translate}}.</td></tr><tr><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px\">i</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.ID PASS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$10.00 FOR PERMANENT PASS AND S$2.00 FOR TEMPORARY PASS FOR NON-RETURNED\'|translate}}.</td></tr><tr><td\n style=\"border: 1px solid black;border-collapse: collapse;width:100px\">j</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.TRAINING HANDOUTS\'|translate}}\n</td><td style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S$100.00 PER NON-RETURNED HANDOUT\'|translate}}.</td></tr></tbody><tfoot></tfoot></table></div></li><br>\n<br><li style=\"padding-left: 2.5pc\">{{\'RECRUITMENT.PANTS, SAFETY BOOTS AND SHOES ARE TO BE\'|translate}} <b><u>\n{{\'RECRUITMENT.RETAINED\'|translate}}</u></b> {{\'RECRUITMENT.BY YOU\'|translate}}.<br><br><div \nstyle=\"text-align:justify;font-size:17px\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead></thead><tbody><tr><td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">a</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.PANTS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.S20.00 PER PANTS FOR LESS THAN SIX (06) MONTHS OF SERVICE FROM THE DATE OF ISSUE. IF YOU HAVE MORE THAN SIX (06) MONTHS OF SERVICE, YOU ARE NOT REQUIRED TO PAY\'|translate}}.\n</td></tr><tr><td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">b</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.SHOES\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.COMPANY WILL ONLY SUBSIDIES S$20.00 PER PAIR OF SHOES FOR ONE YEAR OF SERVICE. S$20.00 SUBSIDY WILL BE DEDUCTED IF YOU RESIGN OR BE TERMINATED WITHIN SIX (06) MONTHS FROM RECEIPT OF THE SUBSIDY\' | translate}}.\n</td></tr><tr><td style=\"border: 1px solid black;border-collapse: collapse;width:100px\">c</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px\">{{\'RECRUITMENT.SAFETY-BOOTS\'|translate}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.AMOUNT DEDUCTIBLE WILL BE BASED ON THE COST OF THE PAIR OF BOOTS. THE COST OF THE PAIR OF BOOTS WILL BE BORNE BY YOU IF YOU RESIGN OR BE TERMINATED WITHIN SIX (06) MONTHS FROM THE DATE OF ISSUE. NO DEDUCTION WILL BE MADE AFTER SIX (06) MONTHS FROM THE DATE OF ISSUE\'|translate}}.\n</td></tr></tbody><tfoot></tfoot></table></div></li></ol></p></div><br><br><br></div></div><div class=\"content\" \nid=\"JI1\" ng-show=\"JobInd1\"><div class=\"content\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp; <b>{{\'RECRUITMENT.ON-THE-JOB INDUCTION CHECKLIST\'|translate}}</b></div>\n<br><table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:700px;text-align:right\">\n{{\'RECRUITMENT.PLEASE RETURN TO HUMAN RESOURCE BY\'|translate}}</th></tr><tr><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:700px;font-weight:normal;text-align:right\">\n{{ReturntoHRDate | date:\'dd/MM/y\'}}&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:200px\">{{\'RECRUITMENT.EMPLOYEE\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Employee}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:200px\">{{\'RECRUITMENT.SENIORS NAME & SIGNATURE\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{SeniorName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:200px\">{{\'RECRUITMENT.DATE OF INDUCTION\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{DateofInduction | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:200px\">{{\'RECRUITMENT.ATTACHEMENT\'|translate}}</th><th \nstyle=\"border-collapse: collapse;width:10px\">:</th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">{{Attachement}}</th></tr></thead><tbody></tbody>\n<tfoot></tfoot></table><br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.DESCRIPTION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;text-align:center\">\n{{\'RECRUITMENT.TICK BY SENIOR\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.TRAINEES ACKNOWLEDGMENT\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.WHAT HAVE THE TRAINEE LEARN\'|translate}}?</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">\n{{\'RECRUITMENT.REMARKS\'|translate}}</th></tr></thead><tbody><tr style=\"background-color: coral\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px\">\n{{\'RECRUITMENT.GENERAL - TO CONDUCT BEFORE TRAINEE LEAVE OFFICE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;background-color: coral\">\n{{GeneralConductSeniorCheck}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{GeneralConductAcknowledgment}}\n</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{GeneralConductTraineeLearn}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{GeneralConductRemarks}}</th>\n</tr><tr><th style=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n1. {{\'RECRUITMENT.INTRODUCE YOURSELF\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckIntroduce}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment1}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn1}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks1}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n2. {{\'RECRUITMENT.INTRODUCE FELLOW COLLEAGUES/SENIORS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckSeniors}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment2}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn2}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks2}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n3. {{\'RECRUITMENT.ASK HOW TO CALL OFFICE/SENIOR, TOLL FREE LINES & EMERGENCY LINE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckEmergency}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment3}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn3}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks3}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n4. {{\'RECRUITMENT.UNIFORM AND ID PASS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckUniform}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment4}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn4}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks4}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n5. {{\'RECRUITMENT.DRESSING/PERSONAL GROOMING\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckDressing}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment5}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn5}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks5}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n6. {{\'RECRUITMENT.WORKING HOURS; REPORTING IN FOR WORK\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckWorking}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment6}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn6}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks6}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n7. {{\'RECRUITMENT.PUNCTUALITY & PERFECT ATTENDANCE INCENTIVE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckPunctuality}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment7}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn7}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks7}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n8. {{\'RECRUITMENT.ABSENTEESIM & REPORTING ABSENCE; TIME OFF / URGENT LEAVE & OTHER FORM OF LEAVE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckAbsenteesim}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment8}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn8}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks8}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n9. {{\'RECRUITMENT.REPORTING OF MEDICAL CERTIFICATE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckMedical}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment9}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn9}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks9}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n10. {{\'RECRUITMENT.LUNCH AND BREAK PERIODS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckLunch}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment10}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn10}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks10}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n11. {{\'RECRUITMENT.SAFETY RULES AND EQUIPMENTS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckSafety}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment11}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn11}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks11}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n12. {{\'RECRUITMENT.SUBMISSION OF CHEMICAL MATERIAL RESQUISITION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckSubmission}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment12}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn12}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks12}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n13. {{\'RECRUITMENT.OVERTIME, SUBMISSION OF OT CARD & OT PAYMENT\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckOvertime}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment13}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn13}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks13}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n14. {{\'RECRUITMENT.COMPANYS PRODUCTS AND SERVICES\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckProducts}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment14}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn14}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks14}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n15. {{\'RECRUITMENT.EMPLOYEES JOB DESCRIPTION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckEmployee}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment15}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn15}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks15}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n16. {{\'RECRUITMENT.MONTHLY STAFF GENERAL MEETING\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckMeeting}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment16}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn16}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks16}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n17. {{\'RECRUITMENT.TRAINING NOTICE BOARDS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckBoards}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment17}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn17}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks17}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n18. {{\'RECRUITMENT.MINUTES OF MEETINGS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckMinutes}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment18}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn18}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks18}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n19. {{\'RECRUITMENT.WHERE TO GET INFORMATION AND HELP\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckHelp}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment19}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn19}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks19}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n20. {{\'RECRUITMENT.WHO WILL HANDLE EMPLOYEES PROBLEMS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckHandle}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment20}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn20}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks20}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n21. {{\'RECRUITMENT.STORE / VEHICLE MAINTENACE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckVehicle}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment21}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn21}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks21}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n22. {{\'RECRUITMENT.NO SMOKING\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckSmoking}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment22}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn22}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks22}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.STATIONED\'|translate}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:200px\">\n{{StationedSeniorCheck}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{StationedAcknowledgment}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{StationedTraineeLearn}}</th><th\n style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{StationedRemarks}}</th></tr>\n<tr><th style=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n23. {{\'RECRUITMENT.MONTHLY SUBMISSION OF DAILY ATTENDANCE\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckAttendance}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment23}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn23}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks23}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n24. {{\'RECRUITMENT.MONTHLY SUBMISSION OF PEST ACTIVITY LOG & ROOM CHART\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckActivity}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment24}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn24}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks24}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n25. {{\'RECRUITMENT.SUBMISSION OF REPORTS FOR OVERTIME JOB OR ATTACHED ACCOUNTS REPORTS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckOvertimeAccounts}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment25}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn25}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks25}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.MOBILE\'|translate}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:200px\">\n{{MobileSeniorCheck}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{MobileAcknowledgment}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{MobileTraineeLearn}}</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{MobileRemarks}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n26. {{\'RECRUITMENT.WEEKLY SUBMISSION OF VEHICLE LOG SHEET\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckSheet}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment26}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn26}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks26}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n27. {{\'RECRUITMENT.DAILY SUBMISSION OF REPORTS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckDaily}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment27}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn27}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks27}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n28. {{\'RECRUITMENT.SUBMISSION OF NON-CONTRACTURAL JOB & PAYMENT\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckPayment}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment28}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn28}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks28}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n29. {{\'RECRUITMENT.REPORTING OF VEHICLE ACCIDENT\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckVehicleAccident}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment29}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn29}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks29}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n30. {{\'RECRUITMENT.MONTHLY VEHICLE COMPETITION\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckVehicleCompetition}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment30}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn30}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks30}}</th></tr><tr \nstyle=\"background-color:yellow\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:center\">\n{{\'RECRUITMENT.TO CONDUCT WITHIN 1 WEEK FROM DATE OF EMPLOYMENT\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px;background-color:yellow\">\n{{DateofEmploymentSeniorCheck}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{DateofEmploymentAcknowledgment}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{DateofEmploymentTraineeLearn}}\n</th><th style=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">\n{{DateofEmploymentRemarks}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n31.{{\'RECRUITMENT.TOUR OF WORK AREA\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckTour}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment31}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn31}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks31}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n32. {{\'RECRUITMENT.INTRODUCE KEY CUSTOMERS STAFF\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckStaff}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment32}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn32}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks32}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n33. {{\'RECRUITMENT.IMPORTANCE OF JOB TO PRODUCTIVITY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckProductivity}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment33}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn33}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks33}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n34. {{\'RECRUITMENT.IMPORTANCE OF JOB TO QUALITY\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckQuality}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment34}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn34}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks34}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n35. {{\'RECRUITMENT.IMPORTANCE OF JOB TO COLLEAGUES\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckColleagues}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment35}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn35}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks35}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1000px;text-align:left\">\n36. {{\'RECRUITMENT.IMPORTANCE OF JOB TO TOTAL PROCESS\'|translate}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:200px\">{{SeniorCheckProcess}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Acknowledgment36}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{TraineeLearn36}}</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:left\">{{Remarks36}}</th></tr></tbody>\n<tfoot></tfoot></table></div></div></div><div class=\"content\" id=\"JI2\" ng-show=\"JobInd2\"><div class=\"content\"><div \nstyle=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">&emsp;<b>\n{{\'RECRUITMENT.EXPLANATION OF TERMS\'|translate}}</b></div><div style=\"text-align:justify;font-size:17px\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:center\">\n{{\'RECRUITMENT.TERMS\'|translate}}</th></tr></thead><tbody><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">1</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE YOURSELF TO YOUR FELLOW COLLEAGUES\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">2</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE FELLOW COLLEAGUES TO HIM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">3</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.OFFICE: 6288 2828 / EMERGENCY LINE: 91809990\'|translate}}</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">4</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.UNIFORM MUST BE NEAT AND CLEAN AT ALL TIMES. TEMP ID PASS DURING PROBATION AND PERM ID PASS FOR CONFIRMED ASSOCIATE\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">5\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HAIR MUST BE KEPT SHORT AND NEAT. NO COLOURED HAIR OR FUNKY HAIRSTYLE\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">6</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.MON-FRI: 0830-1730HRS, SAT: 0830-1230HRS. REPORTING IN BEFORE 0830HRS. EVERY SATURDAYS, REPORT TO 6320 1737\'|translate}}\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">7\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.PERFECT ATTENDANCE INCENTIVE IS GIVEN WITH NO LATENESS, MC, RESERVIST, URGENT LEAVE FOR THE MONTH\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">8\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SEEK FOR HODS APPROVAL FOR ALL LEAVE APPLICATION\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">9</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.REPORT SICK BEFORE 0830HRS TO SENIORS OR OFFICE ASSOCIATE, REPORT SICK LEAVE STATUS BEFORE 1100HRS. NO SMS/VOICEMAIL ALLOWED\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n10</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.1 HOUR LUNCH BREAK\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">11</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.DESCRIBE GENERAL SAFETY REGULATIONS LIKE NOT TO SMOKE OR EAT ON THE JOB.MORE SPECIFIC SAFETY PROCEDURES CAN BE DEMONSTRATED WHEN TEACHING THE TASKS CONCERNED\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n12</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY EVERY THURSDAY, CHEMICAL WILL BE COLLECTED THE FOLLOWING MONDAY\'|translate}}.</th></tr><tr><th\n colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">13</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.OT CARD SUBMISSION ON EVERY 3RD WORKING DAY OF THE FOLLOWING MONTH.PAYMENT WILL BE GIVEN IN THE MID MONTH OF THE FOLLOWING MONTH\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n14</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHAT SERVICES PESTBUSTERS PROVIDES TO ITS CUSTOMERS AND WHAT THE CUSTOMER EXPECTS FROM US\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n15</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN THE TRAINEES ROLE IN PESTBUSTERS, AND WHAT THE COMPANY EXPECTS FROM HIM/HER\'|translate}}.</th>\n</tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">16\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHEN AND WHERE ARE THE MAMS AND AGMS HELD, AND WHAT ARE THEY ALL ABOUT\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">17 & 18</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHERE ARE THEY AND WHY THE ASSOCIATE NEEDS TO READ THEM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">19</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW TO CONTACT SENIOR, SUPERVISOR OR THE OFFICE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">20</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.WHO TO ASK, DEPENDING ON THE NATURE OF THE PROBLEM\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">21</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW TO MAINTAIN THE STORE OR VEHICLE AND WHY THAT IS IMPORTANT\'|translate}}.</th></tr><tr><th \ncolspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">22</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHY SMOKING IS NOT PERMITTED ON THE JOB, IN THE STORE AND IN THE VEHICLE.POINT OUR THE DESIGNATED AREAS WHERE THE CLIENTS REGULATIONS ALLOW SMOKING\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n23,24 & 25</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY THE 3RD OF THE FOLLOWING MONTH. FAX IS ACCEPTABLE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">26</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY EVERY MONDAY\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">27</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT BY NEXT WORKING DAY, PREFERABLY IN THE MORNING\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">28</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.SUBMIT WITHIN THE SAME WORKING DAY, IF NOT LATEST BY NEXT WORKING DAY MORNING\'|translate}}.</th></tr>\n<tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">29</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.IMMEDIATELY INFORM OFFICE ASSOCIATE IF ANY ACCIDENT OF THE VEHICLE OCCURRED\'|translate}}.</th></tr><tr>\n<th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">30</th><th \ncolspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EVERY 2ND TUESDAY OF THE MONTH AT 0730HRS\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">31</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.APPLIES TO STATIONED TECHNICIANS. SHOW THE TRAINEE ALL RELEVANT AREAS LIKE STORE, HOUSEKEEPING DEPT, KITCHENS, CANTEENS, ETC.TELL HIM WHERE TO CHANGE HIS PASS AND WHO TO REPORT TO\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n32</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.INTRODUCE IMPORTANT CLIENTS AND KEY CUSTOMER ASSOCIATE\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">33</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPLAIN WHAT SERVICES PESTBUSTERS PROVIDES TO ITS CUSTOMERS AND WHAT THE CUSTOMER EXPECTS FROM US\'|translate}}.\n</th></tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">\n34</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.DESCRIBE HOW THE TRAINEE IS EXPECTED TO CONTRIBUTE TO THE COMPANYS QUALITY SERVICE\'|translate}}.</th>\n</tr><tr><th colspan=\"1\" style=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">35\n</th><th colspan=\"9\" style=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.EXPAIN HOW HIS FELLOW ASSOCIATES RELY ON HIS COOPERATION\'|translate}}.</th></tr><tr><th colspan=\"1\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">36</th><th colspan=\"9\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px\">\n{{\'RECRUITMENT.HOW DOES HIS JOB FIT INTO THE OPERATIONS OF THE WHOLE COMPANY\'|translate}}.</th></tr></tbody><tfoot>\n</tfoot></table></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    .md-datepicker-input {\r\n        min-width: 290px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n    #datehr .md-datepicker-input {\r\n        min-width: 381px !important;\r\n        max-width: 1000px;\r\n    }\r\n    \r\n    /*md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }*/\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n    /*div#draft {\r\n        margin-top: -30px;\r\n    }*/\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/security/email/email.html","<div id=\"email\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><span>Email Notifications</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"qExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Notification Selection</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"qualificationform6\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex>\n<input type=\"text\" name=\"NotificationType\" ng-model=\"model.NotificationType\" placeholder=\"Notification Type\" required>\n<div ng-messages=\"qualificationform6.NotificationType.$error\" ng-show=\"qualificationform6.NotificationType.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Notification Type is required.</span></div></div></md-input-container>\n<md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveNotification()\" \nng-disabled=\"qualificationform6.$invalid || qualificationform6.$pristine\"><span>ADD</span></md-button><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancelNotification()\"><span>Cancel\n</span></md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Notification Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nAction</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Notificationdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.NotificationType }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Notificationinfo(row.id)\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>ESS Subscriber</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform7\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"SubscriberName\" \nng-model=\"model.SubscriberName\" placeholder=\"ESS Subscriber Name\" required><div \nng-messages=\"qualificationform7.SubscriberName.$error\" ng-show=\"qualificationform7.SubscriberName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>ESS Subscriber Name is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"email\" name=\"SubscriberEmail\" ng-model=\"model.SubscriberEmail\" \nplaceholder=\"ESS Subscriber Email\" required><div ng-messages=\"qualificationform7.SubscriberEmail.$error\" \nng-show=\"qualificationform7.SubscriberEmail.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nESS Subscriber Email is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveSubscriber()\" \nng-disabled=\"qualificationform7.$invalid || qualificationform7.$pristine\"><span>ADD</span></md-button><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancelSubscriber()\"><span>Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">ESS Subscriber Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">ESS Subscriber Email</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nAction</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Subscriberdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.SubscriberName }}</td><td>{{ row.SubscriberEmail }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Subscriberinfo(row.id)\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    /*.layout-gt-sm-row.layout-align-start-center {\r\n        padding: 15px !important;\r\n    }*/\n</style>");
$templateCache.put("app/main/apps/security/clients/Delivery.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delivery Address</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"BillingForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.ubContactPerson\" \nplaceholder=\"Contact Person\" required></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.ubBLK\" placeholder=\"Blk\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.ubUnit\" placeholder=\"Unit\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex><label>Address</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"vm.ubStreetName\" placeholder=\"\"></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"vm.ubBuildingName\" placeholder=\"Building Name\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.ubPostal\" placeholder=\"Postal Code\" required>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Country</label>\n<md-select ng-model=\"vm.ubCountry\" id=\"searchmodule\" required md-on-close=\"vm.searchWork1 = \'\'\"><md-select-header>\n<input ng-model=\"vm.searchWork1\" style=\"flex:auto\" type=\"text\" placeholder=\"Search for a Country..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.ubCountry = null;vm.searchWork1 = null;\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CountyList | filter:vm.searchWork1\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.ubMobile\" placeholder=\"Mobile\">\n</md-input-container><md-input-container flex><input type=\"email\" ng-model=\"vm.ubEmail\" placeholder=\"Email\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"Deliveryadd()\" ng-disabled=\"BillingForm.$invalid\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"cancel()\">Cancel</md-button></div></form></md-dialog-content></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n         #datepopup md-datepicker .md-datepicker-input {\r\n            width: calc(17vw - 15px);\r\n            max-width: calc(35vw - 54px);\r\n               margin-left: -11px;\r\n        }\n</style>");
$templateCache.put("app/main/apps/security/clients/clients.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple-outline\"></md-icon><span>Client/Licensor</span></div><div \nclass=\"product-count secondary-text\"><span>Total Clients:</span> <span>{{Clientdatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n</div></div><div class=\"content-card\" ng-show=\"Clientgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Clientdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Client Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Client Code</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nContact Person</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Default Currency</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Transaction Currencies</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">GST Registration Number</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div><span>\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Clientdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ClientName }}</td><td>{{ row.ClientCode }}</td><td>\n{{ row.ContactPerson }}</td><td>{{ row.CurrencyCode }}</td><td>{{ row.TransactionCurrencies }}</td><td>\n{{row.GSTNumber}}</td><td>{{ row.Phone}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Clientinfo(row._id)\"><md-icon\n md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><ms-form-wizard flex ng-show=\"Clientform\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span ng-if=\"wizardStep1.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Client Information</span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"ClientName\" ng-model=\"vm.uClientName\" placeholder=\"Client Name\" required><div \nng-messages=\"basicForm.ClientName.$error\" ng-show=\"basicForm.ClientName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Client Name field is required.</span></div></div><p ng-show=\"error1\" style=\"color:red\">\nClient Name Is already Exist.</p></md-input-container><md-input-container flex><input type=\"text\" name=\"ClientCode\" \nng-model=\"vm.uClientCode\" placeholder=\"Client Code\" required><div ng-messages=\"basicForm.ClientCode.$error\" \nng-show=\"basicForm.ClientCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Client Code field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Contact Person</label><input type=\"text\" \nname=\"ContactPerson\" ng-model=\"vm.uContactPerson\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Default Currency Code</label><md-select ng-model=\"vm.uCurrencyCode\" \nid=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTermP1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Currency Code..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"uCurrencyCode = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CurrencyCodeList | filter:vm.searchTermP1\" \nvalue=\"{{row.CCode}}\">{{row.CCode}}</md-option></md-select></md-input-container><md-input-container flex><label>\nTransaction Currencies</label><md-select ng-model=\"vm.TransactionCurrencies\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.CCode\'}\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Transaction Currencies..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" aria-label=\"Close dialog\" style=\"float:right\">\n</md-button></md-select-header><md-option ng-repeat=\"row in CurrencyCodeList | filter:vm.searchTermP\" ng-value=\"row\">\n{{row.CCode}}</md-option></md-select></md-input-container><md-input-container flex><label>GST Registration Number\n</label><input type=\"text\" name=\"GSTRegistration\" ng-model=\"vm.GSTNumber\" required><div \nng-messages=\"basicForm.GSTRegistration.$error\" ng-show=\"basicForm.GSTRegistration.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>GST Registration Number is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Email</label><input type=\"email\" name=\"Email\" \nng-model=\"vm.Email\" required><div ng-messages=\"basicForm.Email.$error\" ng-show=\"basicForm.Email.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Email is required.</span></div></div></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label>Subscription Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.uStartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label>Subscription End Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.uEndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><label>Blk</label><input type=\"text\" ng-model=\"vm.Blk\">\n</md-input-container><md-input-container flex><label>Unit</label><input type=\"text\" ng-model=\"vm.Unit\">\n</md-input-container><md-input-container flex><label>Address</label><input type=\"text\" ng-model=\"vm.StreetName\" \nrequired></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>\nBuilding Name</label><input type=\"text\" ng-model=\"vm.BuildingName\"></md-input-container><md-input-container flex>\n<label>Postal Code</label><input type=\"number\" ng-model=\"vm.PostalCode\" required></md-input-container><md-autocomplete \nflex required md-input-name=\"autocompleteField\" md-input-minlength=\"0\" md-input-maxlength=\"18\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" md-require-match \nmd-floating-label=\"Country\"><md-item-template><span md-highlight-text=\"ctrl.searchText\">{{item.display}}</span>\n</md-item-template><div ng-messages=\"searchForm.autocompleteField.$error\" \nng-if=\"searchForm.autocompleteField.$touched\"><div ng-message=\"required\">You <b>must</b> have a Country.</div><div \nng-message=\"md-require-match\">Please select Country.</div></div></md-autocomplete></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><label>Phone</label><input type=\"number\" ng-model=\"vm.Phone\" required>\n</md-input-container><md-input-container flex><label>Mobile</label><input type=\"text\" ng-model=\"vm.Mobile\" required>\n</md-input-container><md-input-container flex><label>Fax</label><input type=\"text\" ng-model=\"vm.Fax\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Website</label>\n<input type=\"text\" ng-model=\"vm.Website\" required></md-input-container><md-input-container flex><label>Remarks</label>\n<input type=\"text\" ng-model=\"vm.uRemarks\"></md-input-container></div><md-input-container flex><md-checkbox \nng-model=\"checkboxModel.value\" ng-hide=\"filtered_client\" type=\"checkbox\">Primary ?</md-checkbox></md-input-container>\n<div layout=\"column\" layout-gt-sm=\"row\"><choose-file layout=\"row\" flex><input id=\"fileInput\" type=\"file\" \nclass=\"ng-hide\" accept=\"image/*\"><div ng-if=\"!previewSrc && !FilePath\" \nstyle=\"height: 100px;\r\n                          width: 250px;\r\n                          background-color: whitesmoke;\r\n                          border: 1px solid #efd6d6\">\n</div><img ng-if=\"previewSrc\" \nstyle=\"height: 100px;\r\n                          width: 250px;\r\n                          border: 1px solid #efd6d6\" \nng-src=\"{{ previewSrc }}\" alt=\"Preview\"> <img ng-if=\"!previewSrc && FilePath\" \nstyle=\"height: 100px;\r\n                          width: 250px;\r\n                          border: 1px solid #efd6d6\" \nng-src=\"{{ FilePath }}\" alt=\"Existing Logo\"><div><md-button class=\"md-raised\" ng-click=\"triggerFileInput()\"><span>\nUpload Logo</span></md-button><p style=\"color: red\" ng-if=\"fileError\">Please upload a logo before submitting.</p></div>\n</choose-file></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"sSubmit()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"Showgrid()\">Cancel</md-button></div></ms-form-wizard></div></div></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item {\r\n        opacity: 1 !important;\r\n        padding: 24px;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9e9e9e91;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26.3vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n        color: black !important;\r\n    }\r\n\r\n    .md-default-theme .md-datepicker-input-mask-opaque,\r\n    .md-datepicker-input-mask-opaque {\r\n        left: 0px !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style>");
$templateCache.put("app/main/apps/security/clients/cspopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delete this Address?\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Deliverydelete(vm.deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/security/user/Pagecancel.html","<md-dialog><form ng-cloak><md-dialog-content><p>Do you want cancel?</p></md-dialog-content><md-dialog-actions><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Yespagecancel(UserId)\" \nclass=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"closeDialog()\">No</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/security/user/addroles.html","<md-dialog style=\"width:100%; overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Manage Role</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 15px 5px 15px\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \nclass=\"txtbox\" type=\"text\" name=\"RoleName\" ng-model=\"vm.uNewrole\" placeholder=\"Role Name\" ng-readonly=\"rolereadonly\" \nrequired><div ng-messages=\"basicForm.RoleName.$error\" ng-show=\"basicForm.RoleName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>RoleName is required.</span></div></div></md-input-container><md-input-container flex>\n<input class=\"txtbox\" type=\"text\" name=\"Description\" ng-model=\"vm.uDescription\" placeholder=\"Description\" \nng-readonly=\"rolereadonly\"><div ng-messages=\"basicForm.Description.$error\" ng-show=\"basicForm.Description.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Description is required.</span></div></div></md-input-container></div>\n<span class=\"h4\" style=\"color:#7f9593\"><b>Modules</b></span><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><md-checkbox ng-model=\"Security.value\" ng-change=\"getdisabled(Security.value)\" \nng-checked=\"ret1.Security==1\" type=\"checkbox\">Security</md-checkbox></md-input-container><md-input-container flex>\n<md-checkbox ng-model=\"Human.value\" ng-change=\"getdisabled(Human.value)\" ng-checked=\"ret2.Human==1\" type=\"checkbox\">\nHuman Resource</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"Operations.value\" \nng-change=\"getdisabled(Operations.value)\" ng-checked=\"ret4.Operations==1\" type=\"checkbox\">Operations</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"CRManagement.value\" \nng-change=\"getdisabled(CRManagement.value)\" ng-checked=\"ret5.CRManagement==1\" type=\"checkbox\">Customer Relationship\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex>\n<md-checkbox ng-model=\"Procurement.value\" ng-change=\"getdisabled(Procurement.value)\" ng-checked=\"ret3.Procurement==1\" \ntype=\"checkbox\">Procurement</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"Accounts.value\" ng-change=\"getdisabled(Accounts.value)\" ng-checked=\"ret6.Accounts==1\" type=\"checkbox\">\nAccounts</md-checkbox></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container></div></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"clear:both\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"RolesSubmit()\" aria-label=\"Submit\" ng-disabled=\"!vm.uNewrole || !vm.chkbox\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div><br><table \nclass=\"table dataTable row-border hover\" style=\"width:100%; border:1px solid rgb(224, 224, 224)\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Roles</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Modules</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody \nstyle=\"font-size:small;font-weight:normal;color:black\"><tr \nng-repeat=\"(UserID, rows) in userModulesdatas | groupBy:\'UserID\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ UserID }}</td><td><p style=\"float: left;width:initial;padding-right:5px\" ng-repeat=\"row in rows\">\n{{ row.ModelID }}{{$last ? \'\' : \', \'}}</p></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Moduleedit(UserID)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></md-dialog-content></md-dialog><style>\n.thumbnail {\r\n        float: left;\r\n        width: 60px;\r\n        display: block;\r\n    }\r\n\r\n    /*.thumbnail > span:hover {\r\nbackground: #eee;\r\nbackground-size:5px;\r\n}*/\r\n    table {\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    .tdthumbnail>td:hover {\r\n        background: #eee;\r\n    }\n</style>");
$templateCache.put("app/main/apps/security/user/alertuser.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Deactivate this User</span><md-button class=\"md-icon-button\" \nng-click=\"alertcancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Actsubmit(UserId)\" class=\"md-raised md-accent\">Yes\n</md-button><md-button class=\"md-raised\" ng-click=\"alertcancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/security/user/user.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-circle\"></md-icon><span>Users</span></div><div \nclass=\"product-count secondary-text\"><span>Total Users:</span> <span>{{UserSummary.length}}</span></div></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: absolute; margin-left: auto; margin-right: auto; left: 0; right: 0;bottom:20%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && UAllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Usergrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"UserSummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"table dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Client</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Employee ID\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Login ID</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Last Login Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"userdata in Userdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ userdata.ClientName }}</td><td>{{ userdata.EmployeeID }}</td><td>{{ userdata.UserID }}</td><td>{{ userdata.Email }}\n</td><td>{{getLoginDate(userdata.UserID) | date:\'dd/MM/y hh:MM a\'}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"userinfo(userdata.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"userpopup($event, userdata.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Userform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Client/Licensor</label><md-select ng-model=\"uClientID\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Client/Licensor..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"uClientID = null;vm.searchC = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Clientdatas | filter:vm.searchC\" ng-click=\"getEmployees(row._id)\" value=\"{{row._id}}\">\n{{row.ClientName}}</md-option></md-select></md-input-container><md-input-container flex><label>Employee ID</label>\n<md-select ng-model=\"uEmployeeID\" name=\"Empid\" id=\"searchmodule\" md-on-close=\"vm.searchE = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchE\" style=\"flex: auto\" type=\"text\" placeholder=\"Employee ID..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"uEmployeeID = null;vm.searchE = \'\'\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchE\" \nng-click=\"getEmailID(row.EmployeeID)\" value=\"{{row.EmployeeID}}\">{{row.EmployeeID}}-{{row.EmployeeName}}</md-option>\n</md-select><div ng-messages=\"basicForm.Empid.$error\" ng-show=\"basicForm.Empid.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Employee ID is required.</span></div></div></md-input-container><md-input-container flex>\n<input class=\"txtbox\" style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"loginid\" \nng-model=\"formData.uLoginID\" placeholder=\"Login ID\" required><div ng-messages=\"basicForm.loginid.$error\" \nng-show=\"basicForm.loginid.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Login ID is required.</span></div>\n</div><p ng-show=\"error1\" style=\"color:red\">Login ID Is already Exist.</p></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px\"><md-input-container flex><input type=\"email\" \nstyle=\"border-radius:3px;padding-left:5px\" name=\"email\" ng-model=\"formData.uEmail\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"basicForm.email.$error\" ng-show=\"basicForm.email.$touched\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email field is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container flex><input class=\"txtbox\" type=\"number\" name=\"mobile\" ng-model=\"formData.uMobileNumber\" \nplaceholder=\"Mobile No\" autocomplete=\"off\"></md-input-container><md-input-container flex><input class=\"txtbox\" \nstyle=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"displayname\" ng-model=\"formData.uUserName\" \nplaceholder=\"Display Name\" required><div ng-messages=\"basicForm.displayname.$error\" \nng-show=\"basicForm.displayname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Display Name is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -10px\">\n<md-input-container flex><div layout=\"row\" flex style=\"margin-top:-20px;margin-bottom:-30px\"><md-input-container flex>\n<input type=\"password\" style=\"color:black\" name=\"text\" ng-model=\"formData.uPassword\" placeholder=\"Password\" \nautocomplete=\"off\" required><div ng-messages=\"basicForm.text.$error\" ng-show=\"basicForm.text.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required.</span></div></div></md-input-container><div><md-button \nng-click=\"getNumber();\" class=\"md-raised\">generate</md-button></div></div></md-input-container><choose-file \nlayout=\"row\" flex style=\"margin-left: 50px !important\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><div \nng-if=\"!fileName\" ng-hide=\"FilePath != null\" \nstyle=\"height:70px;width:200px;background-color: whitesmoke;border: 1px solid #efd6d6\"></div><img \nng-if=\"fileName && FilePath == null\" \nstyle=\"height:70px; width:200px;background-color: whitesmoke;border: 1px solid #efd6d6\" id=\"imagePreview\" src=\"#\" \nalt=\"No image\"> <img style=\"height:70px; width:200px;border: 1px solid #efd6d6\" \nng-if=\"FilePath != null && fileName == null\" src=\"{{FilePath}}\"><div><md-button id=\"uploadButton\" class=\"md-raised\">\n<span>Upload Signature</span></md-button></div></choose-file><md-checkbox-container flex style=\"flex:0.5\">\n</md-checkbox-container><md-checkbox-container flex style=\"flex:0.5\"></md-checkbox-container></div><div layout=\"row\" \nlayout-sm=\"column\" style=\"margin-top:-25px\"><md-checkbox-container flex style=\"flex:0.5;margin-left: 10px\"><md-checkbox\n ng-model=\"IsAdmin.value\" type=\"checkbox\" ng-checked=\"true\">Is Admin?</md-checkbox></md-checkbox-container></div>\n</form><br><br><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox-container flex style=\"flex: 0.77\"><span class=\"h2\" \nstyle=\"color:#a2a2a2\"><b>Pages</b></span></md-checkbox-container><md-checkbox-container flex></md-checkbox-container>\n<md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex></md-checkbox-container>\n<md-checkbox-container flex></md-checkbox-container></div><br><form name=\"basicForm1\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\">\n<span class=\"h4\" style=\"color:#7f9593\"><b>Security</b></span></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-required=\"true\" ng-checked=\"rec2.Client==1\" ng-model=\"Client.value\" type=\"checkbox\">Client/Licensor\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-required=\"true\" \nng-checked=\"rec1.Users==1\" ng-model=\"Users.value\" type=\"checkbox\">Users</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex></md-checkbox-container></div><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span \nclass=\"h4\" style=\"color:#7f9593\"><b>Human Resource</b></span></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec36.DHuman==1\" ng-model=\"DHuman.value\" type=\"checkbox\">Dashboard</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec43.ELeaves==1\" \nng-model=\"ELeaves.value\" type=\"checkbox\">Leave Approval</md-checkbox></md-checkbox-container><md-checkbox-container \nflex><md-checkbox ng-checked=\"rec3.HRMAdmin==1\" ng-model=\"HRMAdmin.value\" type=\"checkbox\">HRM Admin</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec12.Training==1\" \nng-model=\"Training.value\" type=\"checkbox\">Training</md-checkbox></md-checkbox-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec42.Insurance==1\" ng-model=\"Insurance.value\" type=\"checkbox\">\nInsurance</md-checkbox></md-checkbox-container><md-checkbox-container flex></md-checkbox-container>\n<md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex></md-checkbox-container></div><br><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" \nstyle=\"color:#7f9593\"><b>Customer Relationship</b></span></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec38.DCRM==1\" ng-model=\"DCRM.value\" type=\"checkbox\">Dashboard</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec9.Customers==1\" \nng-model=\"Customers.value\" type=\"checkbox\">Customers</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec14.Lead==1\" ng-model=\"Lead.value\" type=\"checkbox\">Lead Management</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec18.Contracts==1\" \nng-model=\"Contracts.value\" type=\"checkbox\">Contracts</md-checkbox></md-checkbox-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec16.WorkOrder==1\" ng-model=\"WorkOrder.value\" type=\"checkbox\">\nWork Orders</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec13.CrmSettings==1\" ng-model=\"CrmSettings.value\" type=\"checkbox\">Settings</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec15.Quotation==1\" \nng-model=\"Quotation.value\" type=\"checkbox\">Templates</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec8.Services==1\" ng-model=\"Services.value\" type=\"checkbox\">Daily Scheduler</md-checkbox>\n</md-checkbox-container></div><br><div layout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex \nstyle=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" style=\"color:#7f9593\"><b>Operations</b></span>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec39.DOperations==1\" \nng-model=\"DOperations.value\" type=\"checkbox\">Dashboard</md-checkbox></md-checkbox-container><md-checkbox-container \nflex><md-checkbox ng-checked=\"rec33.Scheduler==1\" ng-model=\"Scheduler.value\" type=\"checkbox\">Scheduler</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec32.Teams==1\" ng-model=\"Teams.value\" \ntype=\"checkbox\">Teams</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec7.PestType==1\" ng-model=\"PestType.value\" type=\"checkbox\">Pest Types</md-checkbox>\n</md-checkbox-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex \nstyle=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec57.Treatment==1\" ng-model=\"Treatment.value\" type=\"checkbox\">Treatment Methods</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container><md-checkbox-container flex></md-checkbox-container></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span class=\"h4\" \nstyle=\"color:#7f9593\"><b>Procurement</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec37.DProcurement==1\" ng-model=\"DProcurement.value\" type=\"checkbox\">Dashboard</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec6.Supliers==1\" \nng-model=\"Supliers.value\" type=\"checkbox\">Suppliers</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec19.EquipmentRequest==1\" ng-model=\"EquipmentRequest.value\" type=\"checkbox\">Equipment Request\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec55.ChemicalRequest==1\" \nng-model=\"ChemicalRequest.value\" type=\"checkbox\">Chemical Request</md-checkbox></md-checkbox-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\">\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec21.StockManagement==1\" \nng-model=\"StockManagement.value\" type=\"checkbox\">Stock Management</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec56.ProcurementSettings==1\" \nng-model=\"ProcurementSettings.value\" type=\"checkbox\">Settings</md-checkbox></md-checkbox-container>\n<md-checkbox-container flex></md-checkbox-container><md-checkbox-container flex></md-checkbox-container></div><br><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"><span \nclass=\"h4\" style=\"color:#7f9593\"><b>Accounts</b></span></md-checkbox-container><md-checkbox-container flex><md-checkbox\n ng-checked=\"rec40.AcCustomer==1\" ng-model=\"AcCustomer.value\" type=\"checkbox\">Customer</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec41.AcContract==1\" \nng-model=\"AcContract.value\" type=\"checkbox\">Contract</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n<md-checkbox ng-checked=\"rec26.AccountsWorkOrder==1\" ng-model=\"AccountsWorkOrder.value\" type=\"checkbox\">Work Order\n</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec45.AcScheduler==1\" \nng-model=\"AcScheduler.value\" type=\"checkbox\">Scheduler</md-checkbox></md-checkbox-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-checkbox-container flex style=\"padding-top:1.8%;flex: 0.7\"></md-checkbox-container>\n<md-checkbox-container flex><md-checkbox ng-checked=\"rec46.AcDScheduler==1\" ng-model=\"AcDScheduler.value\" \ntype=\"checkbox\">Daily Scheduler</md-checkbox></md-checkbox-container><md-checkbox-container flex><md-checkbox \nng-checked=\"rec47.AcPestOff==1\" ng-model=\"AcPestOff.value\" type=\"checkbox\">Cash/Cheque</md-checkbox>\n</md-checkbox-container><md-checkbox-container flex><md-checkbox ng-checked=\"rec48.AcLumiair==1\" \nng-model=\"AcLumiair.value\" type=\"checkbox\">Invoice</md-checkbox></md-checkbox-container><md-checkbox-container flex>\n</md-checkbox-container></div><br></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" \nclass=\"md-raised\">Cancel</md-button></div></div></div></div><br></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\nmd-checkbox {\r\n        margin-bottom: 2px !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .price-tables .price-table.style-1 .price {\r\n        padding: 0px 0px 0px 0px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/security/user/userpopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Delete this User?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Userdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/security/workflow/workflow.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Workflow</span></div><div \nclass=\"product-count secondary-text\"><span>Total Workflows:</span> <span>{{Workflowdatas.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 18px\" flex><md-input-container flex=\"50\" id=\"Storefilter\" \nstyle=\"margin-top:3px\"><label style=\"color:white;font-size: 14px\">Client</label><md-select class=\"Storefilter\" \nng-model=\"ClID\" ng-change=\"OnClientChange()\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a client..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"ClID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Clientdatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.ClientName}}</md-option></md-select>\n</md-input-container></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Workflowgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Workflowdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Client Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Level</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Action</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Actioned</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Next Level\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Approvers</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Notify To</span></div></th><th class=\"secondary-text\"><div>\n<span>View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Workflowdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">{{ row.Clientdetails[0].ClientName }}</td><td \nnowrap=\"nowrap\">{{ row.TypeName }}</td><td nowrap=\"nowrap\">{{ row.LevelName }}</td><td>{{ row.Action }}</td><td>\n{{ row.Actioned }}</td><td>{{ row.NextLevel}}</td><td>{{ row.Approvers}}</td><td>{{ row.NotifyTo}}</td><td \nng-click=\"Workflowinfo(row._id)\" class=\"editMe\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Workflowinfo(row._id)\">\n<md-icon md-font-icon=\"icon-pencil\" ng-click=\"Workflowinfo(row._id)\"></md-icon></md-button></td></tr></tbody></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Workflowform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Client</label><md-select ng-model=\"ClientID\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" ng-change=\"LoadUserByClient()\" required><md-select-header><input \nng-model=\"vm.searchTerms\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a client..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"ClientID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Clientdatas | filter:vm.searchTerms\" value=\"{{row.id}}\">\n{{row.ClientName}}</md-option></md-select></md-input-container><md-input-container flex><label>Type Name</label>\n<md-select ng-model=\"TypeName\" id=\"searchmodule\" required><md-option value=\"\">Select Type Name</md-option><md-option \nvalue=\"HRM Employee Appraisal\">HRM Employee Appraisal</md-option><md-option value=\"HRM Leave Request\">HRM Leave Request\n</md-option><md-option value=\"HRM Incident Reporting\">HRM Incident Reporting</md-option><md-option \nvalue=\"HRM Medical Claim Request\">HRM Medical Claim Request</md-option><md-option value=\"CRM Leads\">CRM Leads\n</md-option><md-option value=\"CRM Contract\">CRM Contract</md-option><md-option value=\"Accounts Expense Claim\">\nAccounts Expense Claim</md-option><md-option value=\"Accounts Payment Voucher\">Accounts Payment Voucher</md-option>\n<md-option value=\"Accounts Purchase Invoice\">Accounts Purchase Invoice</md-option></md-select></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"LevelName\" ng-model=\"LevelName\" placeholder=\"Level\" required><div \nng-messages=\"basicForm.LevelName.$error\" ng-show=\"basicForm.LevelName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Level is required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Action\" ng-model=\"Action\" placeholder=\"Action\" required><div ng-messages=\"basicForm.Action.$error\" \nng-show=\"basicForm.Action.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Action is required.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"Actioned\" ng-model=\"Actioned\" placeholder=\"Actioned Text\" required><div ng-messages=\"basicForm.Actioned.$error\" \nng-show=\"basicForm.Actioned.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Actioned Text is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" name=\"Next Level\" ng-model=\"NextLevel\" \nplaceholder=\"Next Level\"></md-input-container><md-input-container flex><label>Approvers</label><md-select \nng-model=\"Approvers\" ng-model-options=\"{trackBy: \'$value.UserID\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"text\" placeholder=\"Search for a user..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Userdatas  | filter:searchTerm\">{{row.UserID}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><label>Notify To</label><md-select ng-model=\"NotifyTo\" \nng-model-options=\"{trackBy: \'$value.UserID\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input \nng-model=\"searchTerm1\" type=\"text\" placeholder=\"Search for a user..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-optgroup><md-option ng-value=\"row\" ng-repeat=\"row in Userdatas | filter:searchTerm1\">\n{{row.UserID}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"test\" name=\"AlwaysNotifyTo\" ng-model=\"AlwaysNotifyTo\" \nplaceholder=\"Always Notify To\"></md-input-container><md-input-container flex><input type=\"test\" name=\"EmailExceptions\" \nng-model=\"EmailExceptions\" placeholder=\"Email Exceptions\"></md-input-container><md-input-container flex><md-checkbox \nng-model=\"ShowCancelButton.value\" type=\"checkbox\">Show Cancel Button?</md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-model=\"ShowRejectButton.value\" type=\"checkbox\">Show Reject Button?\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox \nng-model=\"ShowReviseButton.value\" type=\"checkbox\">Show Revise Button?</md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-model=\"Mandatory.value\" type=\"checkbox\">Mandatory</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"EmailNotification.value\" type=\"checkbox\">\nEmail Notification?</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"NotifytoCurrentApprover.value\" type=\"checkbox\">Notify to Current Approver?</md-checkbox></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-checkbox \nng-model=\"NotifytoNextLevelApprover.value\" type=\"checkbox\">Notify to Next Level Approver?</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"NotifytoCreatorInitator.value\" type=\"checkbox\">\nNotify to Creator/Initator?</md-checkbox></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Submit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/EquipmentRequest/EquipmentRequest.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-houzz-box\"></md-icon><span>Equipment Request</span></div><div \nclass=\"product-count secondary-text\"><span>Total Equipment Requests : </span><span>{{EquipmentRequestdatas.length}}\n</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search...\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"exportbtn && AllowExport==\'true\'\" \nng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"content-card\" ng-show=\"EquipmentGrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"EquipmentRequestdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Reference Number</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nVehicle Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Requested Date</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Team Name</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EquipmentRequestdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewReqinfo($event,row.id)\" \ntitle=\"Requested Chemicals\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.RequestedBy }}</td><td>\n{{ row.VehicleNumber }}</td><td>{{ row.RequestedDate | date :\"dd/MM/y\" }}</td><td>{{ row.Teamdetails[0].TeamName }}\n</td><td ng-if=\"row.Status==\'Accepted\'\"><div class=\"label ng-binding ng-scope md-blue-500-bg\">{{ row.Status }}</div>\n</td><td ng-if=\"row.Status==\'Received\'\"><div class=\"label ng-binding ng-scope md-green-500-bg\">{{ row.Status }}</div>\n</td><td ng-if=\"row.Status==\'Rejected\'\"><div class=\"label ng-binding ng-scope md-red-500-bg\">{{ row.Status }}</div>\n</td><td ng-if=\"row.Status==\'New\'\"><div class=\"label ng-binding ng-scope md-orange-500-bg\">{{ row.Status }}</div></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"EquipmentInfo(row.id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Equipmentform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" name=\"RequestedBy\" ng-model=\"vm.RequestedBy\" placeholder=\"Name\" readonly=\"readOnly\"><div \nng-messages=\"basicForm.RequestedBy.$error\" ng-show=\"basicForm.RequestedBy.$touched\" role=\"alert\"></div>\n</md-input-container><md-input-container flex><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" \nname=\"ContactNumber\" readonly=\"readOnly\" ng-model=\"vm.ContactNumber\" placeholder=\"Contact Number\"></md-input-container>\n<md-input-container><label style=\"font-size: 14px\">Requested Date</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"vm.RequestedDate\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" name=\"JobPosition\" ng-model=\"vm.JobPosition\" \nplaceholder=\"Job Position\" readonly=\"readOnly\"><div ng-messages=\"basicForm.JobPosition.$error\" \nng-show=\"basicForm.JobPosition.$touched\" role=\"alert\"></div></md-input-container><md-input-container flex><label>\nVehicle Number</label><md-select ng-model=\"vm.VehicleNumber\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\">\n<md-select-header><input ng-model=\"vm.searchTerm5\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Vehicle Number\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"VehicleNumber = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Vehicledatas | filter:vm.searchTerm5\" value=\"{{row.VehicleNumber}}\">\n{{row.VehicleNumber}}</md-option></md-select></md-input-container><md-input-container flex><label>Team</label>\n<md-select ng-model=\"vm.AssignedTo\" id=\"searchmodule\" md-on-close=\"vm.searchAssigned = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" value=\"{{row.id}}\">{{row.TeamName}}</md-option></md-select>\n</md-input-container></div><br><div><h3><b>Equipments</b></h3></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:2px 2px 2px 2px\"><md-button style=\"margin-left:90%;width:5%;margin-top:-45px\" \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AddRecord($event)\">Add\n</md-button><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Equipment Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Manufacturer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EquipmentItemdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Code }}</td><td>{{ row.EquipmentName }}</td><td>\n{{ row.Manufacturer }}</td><td>{{ row.SerialNumber }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\" Equipmentdelete($index)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"EquipmentItemdatas.length==0 && !vm.AssignedTo\">Submit</md-button><md-button ng-click=\"cancelbtnclk()\" \nclass=\"md-raised\">Cancel</md-button></div></form></div></div></div><div class=\"content\" ng-show=\"EquipmentReqInfo\"><div\n layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%;border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">\nEquipment Request Details :</label><a ng-click=\"RequestRejected()\" \nstyle=\"color:red;cursor:pointer;font-size:15px;float:right;margin-right: 25px\" ng-if=\"vm.Status==\'New\'\">Reject </a><a \nng-click=\"RequestAccepted()\" style=\"color:green; cursor:pointer;font-size:15px;float:right;margin-right: 25px\" \nng-if=\"vm.Status==\'New\'\">Accept</a></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:20%\"><lable \nstyle=\"font-size:15px;color:#7f9593\"><b>Reference #</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\"><b>{{vm.ReferenceNo}}</b></lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Requested By</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.RequestedBy}}</lable></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Requested Date</b></lable></div>\n<lable style=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.RequestedDate| date:\'dd/MM/y\'}}</lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Team Name</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.TeamName}}</lable></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"border:1px solid rgb(224, 224, 224)\"><br><div \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px;padding-left: 4px\">\nRequested Equipments:</label></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Equipment Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Manufacturer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EquipmentItemdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Code }}</td><td>{{ row.EquipmentName }}</td><td>\n{{ row.Manufacturer }}</td><td>{{ row.SerialNumber }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\" Equipmentdelete($index)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div></div>\n<style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/EquipmentRequest/ViewEquipments.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Requested Equipments</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div ng-show=\"ViewTable\" id=\"gridContainer\" dx-data-grid=\"dataGridOptions\"></div><div \nng-hide=\"ViewTable\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Equipment</label><md-select \nng-model=\"vm.Equipment\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for Equipment..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in EquipmentListName | filter:vm.searchTerm2\" \nng-click=\"getEquipmentSerialumber(row.EquipmentName)\" value=\"{{row.EquipmentName}}\">{{row.EquipmentName }}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Equipment Serial Number</label><md-select \nng-model=\"vm.dDescription\" ng-change=\"vm.Quantity = vm.dDescription.length\" id=\"Supplier1\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"multiple\" required><md-select-header><input ng-model=\"vm.searchTerm3\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Serial Number..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EquipmentSeraildatas | filter:vm.searchTerm3\" ng-value=\"row\">{{row.Brand }} - {{row.SerialNumber }}\n</md-option></md-select></md-input-container></div><div ng-hide=\"ViewTable\" layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Stock\" ng-model=\"vm.Stock\" placeholder=\"Current Stock\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"number\" name=\"Quantity\" \nng-model=\"vm.Quantity\" placeholder=\"Selected Quantity\" readonly=\"readonly\"></md-input-container></div>\n</md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"margin-bottom:15px\"><md-button ng-hide=\"ViewTable\" type=\"submit\" ng-click=\"saveEquipment()\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog>\n<style>.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/procurement/chemicalrequest/EditStock.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Edit Chemical Stock\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nflex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.Stock\" min=\"0\" placeholder=\"Quantity\" required>\n</md-input-container><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"UpdateStock()\" class=\"md-raised md-accent\">Update</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">Cancel</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/chemicalrequest/ViewChemicals.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Requested Chemicals</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div ng-show=\"ViewTable\" id=\"gridContainer\" dx-data-grid=\"dataGridOptions\"></div><div \nng-hide=\"ViewTable\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Chemcial</label><md-select \nng-model=\"vm.dDescription\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Supplier..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Chemicaldatas | filter:vm.searchTerm2\" \nng-click=\"vm.Stock=row.CurrentStock ; vm.ItemId=row._id ; vm.ProductCode=row.Code\" value=\"{{row.ChemicalName}}\">\n{{row.ChemicalName }}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Stock\" ng-model=\"vm.Stock\" placeholder=\"Current Stock\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.Quantity\" placeholder=\"Quantity\" required>\n</md-input-container></div></md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button ng-hide=\"ViewTable\" type=\"submit\" ng-click=\"saveItems()\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog>\n<style>.dx-icon-trash:before{\r\n    color : #8899a8 !important\r\n}</style>");
$templateCache.put("app/main/apps/procurement/chemicalrequest/chemicalrequest.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-basket-unfill\"></md-icon><span>Chemical Request</span></div>\n<div class=\"product-count secondary-text\"><span>Total Chemical Request : </span><span>{{chemicalrequestdatas.length}}\n</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'CRMPESTTYPES.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span translate=\"CRMPESTTYPES.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"FExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"CRMPESTTYPES.EXPORT\">Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"CRMPESTTYPES.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"chemicalrequestGrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"chemicalrequestdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nReference Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Vehicle Number</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Requested Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nTeam</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in chemicalrequestdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nng-click=\"ViewRequestinfo($event,row.id)\" title=\"Requested Chemicals\" style=\"border:none\">{{ row.ReferenceNo }}</a>\n</td><td>{{ row.RequestedBy }}</td><td>{{ row.VehicleNumber }}</td><td>{{ row.RequestedDate | date :\"dd/MM/y h:mm a\" }}\n</td><td>{{ row.Teamdetails[0].TeamName}}</td><td ng-if=\"row.Status==\'Accepted\'\"><div \nclass=\"label ng-binding ng-scope md-blue-500-bg\">{{ row.Status }}</div></td><td ng-if=\"row.Status==\'Received\'\"><div \nclass=\"label ng-binding ng-scope md-green-500-bg\">{{ row.Status }}</div></td><td ng-if=\"row.Status==\'Rejected\'\"><div \nclass=\"label ng-binding ng-scope md-red-500-bg\">{{ row.Status }}</div></td><td ng-if=\"row.Status==\'New\'\"><div \nclass=\"label ng-binding ng-scope md-orange-500-bg\">{{ row.Status }}</div></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"chemicalrequestinfo(row.id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"chemicalrequestform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" name=\"RequestedBy\" ng-model=\"vm.RequestedBy\" placeholder=\"Name\" readonly=\"readOnly\"><div \nng-messages=\"basicForm.RequestedBy.$error\" ng-show=\"basicForm.RequestedBy.$touched\" role=\"alert\"></div>\n</md-input-container><md-input-container flex><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" \nname=\"ContactNumber\" ng-model=\"vm.ContactNumber\" placeholder=\"Contact Number\" readonly=\"readOnly\"></md-input-container>\n<md-input-container><label style=\"font-size: 14px\">Requested Date</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"vm.RequestedDate\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" name=\"JobPosition\" ng-model=\"vm.JobPosition\" \nplaceholder=\"Job Position\" readonly=\"readOnly\"><div ng-messages=\"basicForm.JobPosition.$error\" \nng-show=\"basicForm.JobPosition.$touched\" role=\"alert\"></div></md-input-container><md-input-container flex><label>\nVehicle Number</label><md-select ng-model=\"vm.VehicleNumber\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\">\n<md-select-header><input ng-model=\"vm.searchTerm5\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Vehicle Number\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"VehicleNumber = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Vehicledatas | filter:vm.searchTerm5\" value=\"{{row.VehicleNumber}}\">\n{{row.VehicleNumber}}</md-option></md-select></md-input-container><md-input-container flex><label>Team</label>\n<md-select ng-model=\"vm.AssignedTo\" id=\"searchmodule\" md-on-close=\"vm.searchAssigned = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" value=\"{{row.id}}\">{{row.TeamName}}</md-option></md-select>\n</md-input-container></div><span style=\"font-weight: bold ;font-size: 16px;left:20%\">Chemicals</span><br><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><br><div class=\"content fullpage-datatable\" \nlayout=\"column\" style=\"padding:2px 2px 2px 2px\" flex><md-button style=\"margin-left:90%;width:5%;margin-top:-20px\" \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AddRecord($event)\">Add\n</md-button><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Chemical Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Action</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in ChemicalItemdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.Chemical }}</td><td>{{ row.Quantity }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ItemInfo($index)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteItem($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"fsubmit()\" aria-label=\"Submit\" \nng-disabled=\"ChemicalItemdatas.length==0 && !vm.AssignedTo\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div><div class=\"content\" \nng-show=\"ChemicalReqInfo\"><div layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%;border:1px solid rgb(224, 224, 224);float:left\"><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Chemical Request Details :\n</label><a ng-click=\"RequestRejected()\" style=\"color:red;cursor:pointer;font-size:15px;float:right;margin-right: 25px\" \nng-if=\"vm.Status==\'New\'\">Reject </a><a ng-click=\"RequestAccepted()\" \nstyle=\"color:green; cursor:pointer;font-size:15px;float:right;margin-right: 25px\" ng-if=\"vm.Status==\'New\'\">Accept</a>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>\nReference #</b></lable></div><lable style=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b>\n</lable><div class=\"p-4\" style=\"width:30%\"><lable style=\"font-size:14px\"><b>{{vm.ReferenceNo}}</b></lable></div><div \nclass=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Requested By</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.RequestedBy}}</lable></div></div><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" style=\"margin-top: -15px\">\n<div class=\"p-4\" style=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Requested Date</b></lable></div>\n<lable style=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.RequestedDate| date:\'dd/MM/y\'}}</lable></div><div class=\"p-4\" \nstyle=\"width:20%\"><lable style=\"font-size:15px;color:#7f9593\"><b>Team Name</b></lable></div><lable \nstyle=\"font-size:15px;color:#7f9593;padding-left: 1%;padding-right: 1.5%\"><b>:</b></lable><div class=\"p-4\" \nstyle=\"width:30%\"><lable style=\"font-size:14px\">{{vm.TeamName}}</lable></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"border:1px solid rgb(224, 224, 224)\"><br><div \nstyle=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px;padding-left: 4px\">\nRequested Chemical:</label></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Chemical Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.Status==\'New\'\"><div><span class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ChemicalItemdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Chemical }}</td><td>{{ row.Quantity }}</td><td \nng-if=\"vm.Status==\'New\'\"><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"EditItem($index,row.Quantity,$event)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"DeleteItem($index)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n    .dx-row dx-column-lines dx-header-row {\r\n        color: black !important\r\n    }\r\n\r\n    .dx-icon-edit:before {\r\n        color: #8899a8 !important\r\n    }\r\n\r\n    .dx-icon-trash:before {\r\n        color: #8899a8 !important\r\n    }\r\n\r\n    .dx-datagrid .dx-link {\r\n        color: #8899a8 !important\r\n    }\r\n\r\n    .dx-datagrid .dx-row-lines>td {\r\n        border-bottom: 1px solid #8899a8 !important\r\n    }\r\n\r\n    .dx-datagrid .dx-column-lines>tr {\r\n        border-left: 1px solid #8899a8 !important;\r\n        border-right: 1px solid #8899a8 !important;\r\n        border-top: 1px solid #8899a8 !important;\r\n        border-bottom: 1px solid #8899a8 !important\r\n    }\r\n\r\n    .dx-datagrid-text-content {\r\n        color: rgb(27, 26, 26) !important;\r\n        font-weight: 500\r\n    }\r\n    .AcceptButton{\r\n        background-color: #4cb34c !important;\r\n    }\r\n    .RejectButton{\r\n        background-color: #db3139 !important;\r\n    }\r\n    .status {\r\n                                font-size: 12px;\r\n                                white-space: nowrap;\r\n                                padding: 2px 5px;\r\n                                border-radius: 2px;\r\n                            }\n</style>");
$templateCache.put("app/main/apps/procurement/dashboard/dashboard-procurement.html","<div id=\"dashboard-procurement\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex \nms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, {{UserName}}!</span></div>\n<div class=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" \nhide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div>\n</div></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">EQUIPMENT REQUEST</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"blue-grey-fg font-size-72 line-height-72\" ng-click=\"goToRequestPage(\'app.equipmentrequest\')\">\n{{totalEquipmentRequests}}</div><div class=\"h3 secondary-text font-weight-500\">NEW EQUIPMENT REQUESTS</div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div class=\"h4\">PURCHASE ORDER</div><div class=\"h3\">Total PO Created &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPOCreated}}</span></div><div class=\"h3\">\nTotal Sent to Supplier &nbsp; : &nbsp; <span class=\"blue-grey-fg font-size-18 line-height-18\">{{TotalSenttoSupplier}}\n</span></div><div class=\"h3\">Total Goods Received &nbsp; : &nbsp; <span \nclass=\"blue-grey-fg font-size-18 line-height-18\">{{TotalGoodsReceived}}</span></div><div class=\"h3\">\nTotal PO Completed &nbsp; : &nbsp; <span class=\"blue-grey-fg font-size-18 line-height-18\">{{TotalPOCompleted}}</span>\n</div><div class=\"h3\">Total PO Rejected &nbsp; : &nbsp; <span class=\"blue-grey-fg font-size-18 line-height-18\">\n{{TotalRejected}}</span></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">CHEMICAL REQUEST</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\" \nng-click=\"goToRequestPage(\'app.Chemicalrequest\')\">{{totalChemicalRequests}}</div><div \nclass=\"h3 secondary-text font-weight-500\">NEW CHEMICAL REQUESTS</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\nSTOCK REQUEST</div><div class=\"h3\">Total New Requests &nbsp; : &nbsp; <span class=\"red-fg font-size-18 line-height-18\">\n{{TotalSRNew}}</span></div><div class=\"h3\">Total Approved Requests &nbsp; : &nbsp; <span \nclass=\"red-fg font-size-18 line-height-18\">{{TotalSRApproved}}</span></div><div class=\"h3\">\nTotal Rejected Requests &nbsp; : &nbsp; <span class=\"red-fg font-size-18 line-height-18\">{{TotalSRRejected}}</span>\n</div><div class=\"h3\">Total Cancelled Requests &nbsp; : &nbsp; <span class=\"red-fg font-size-18 line-height-18\">\n{{TotalSRCancelled}}</span></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">EQUIPMENT REQUIRE SERVICE</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{totalEquipmentLists}}\n</div><div class=\"h3 secondary-text font-weight-500\">TOTAL EQUIPMENTS</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\nPURCHASE REQUEST</div><div class=\"h3\">Total New Requests &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPRNew}}</span></div><div class=\"h3\">\nTotal Approved Requests &nbsp; : &nbsp; <span class=\"orange-fg font-size-18 line-height-18\">{{TotalPRApproved}}</span>\n</div><div class=\"h3\">Total Rejected Requests &nbsp; : &nbsp; <span class=\"orange-fg font-size-18 line-height-18\">\n{{TotalPRRejected}}</span></div><div class=\"h3\">Total Cancelled Requests &nbsp; : &nbsp; <span \nclass=\"orange-fg font-size-18 line-height-18\">{{TotalPRCancelled}}</span></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">CHEMICAL LIST</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"green-fg font-size-72 line-height-72\">{{totalChemicalLists}}</div><div \nclass=\"h3 secondary-text font-weight-500\">TOTAL CHEMICAL LISTS</div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"h3\">\nSTOCK LIST</div><div class=\"h3\">Total Minimum Order Stocks &nbsp; : &nbsp; <span \nclass=\"green-fg font-size-18 line-height-18\">{{totalLowonStock}}</span></div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">STOCK LIST</span> \n<span class=\"ml-16 text-boxed pink-bg white-fg\">{{Minimumdetaildatas.length}} Minimum Order Stocks</span></div></div>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Image</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Chemical Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Chemical Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Current Stock</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Threshold Level</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Minimum Order</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Chemicaldatas\" ng-style=\"{\'color\':(row.Threshold>row.CurrentStock?\'#bf0707\':\'black\')}\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><img class=\"product-image\" \nng-src=\"{{UploadsURL + \'Procurement/SupplierItems/\'+row.ItemId+\'.png\'}}\"></td><td><a href=\"\" \nng-click=\"Storeinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">{{ row.Code }}</a></td><td>\n{{ row.ChemicalName }}</td><td>{{ row.Supplier }}</td><td>{{ row.CurrentStock }}</td><td>{{ row.Threshold }}</td><td>\n{{ row.MinimumOrder }}</td></tr></tbody></table></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\nChemicals Taken by Technicians</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" \nng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div>\n<div id=\"chart\" dx-chart=\"chartOptions\"></div></ms-widget-front></ms-widget></div></div></div></div><style>\n.product-image {\r\n                            width: 52px;\r\n                            height: 52px;\r\n                            border: 1px solid rgba(0, 0, 0, 0.12);\r\n                        }\r\n                        #chart{\r\n                            width:85%\r\n                        }\n</style>");
$templateCache.put("app/main/apps/procurement/product/product.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Products</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"Datasearch\" class=\"search-input\" type=\"text\" \nng-model=\"SearchDetails\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"ChemicalExport && AllowExport==\'true\'\" ng-click=\"cExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n<span>Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"EquipmentExport && AllowExport==\'true\'\" ng-click=\"uExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n<span>Export</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\">\n<md-tab><div ng-click=\"Categories()\"><md-tab-label><span>Chemicals</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"Categoryform\" novalidate \nautocomplete=\"on\"><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" \nname=\"Category\" ng-model=\"model.CategoryName\" placeholder=\"Category\" autocomplete=\"on\" required><div \nng-messages=\"Categoryform.CategoryName.$error\" ng-show=\"Categoryform.CategoryName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Category is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Chemical\" ng-model=\"model.ChemicalName\" placeholder=\"Chemical Name\" required><div \nng-messages=\"Categoryform.ChemicalName.$error\" ng-show=\"Categoryform.ChemicalName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Chemical Name is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveCategory()\" \nng-disabled=\"Categoryform.$invalid || Categoryform.$pristine\"><span>Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"cancelCategory()\"><span>Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Categorydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Chemical Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Categorydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CProductCode }}</td><td>{{ row.Category }}</td><td>\n{{ row.ChemicalName }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Categoryinfo(row.id,row.Category, row.ChemicalName,$index)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div></md-tab-body>\n</md-tab><md-tab><div ng-click=\"Units()\"><md-tab-label><span>Equipments</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"Unitform\" novalidate \nautocomplete=\"on\"><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container flex><input type=\"text\" name=\"ECategory\" \nng-model=\"model.ECategory\" placeholder=\"Inventory Category\" autocomplete=\"on\" required><div \nng-messages=\"Unitform.Category.$error\" ng-show=\"Unitform.Category.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Category is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Equipment\" ng-model=\"model.EquipmentName\" placeholder=\"Equipment Name\" required><div \nng-messages=\"Categoryform.EquipmentName.$error\" ng-show=\"Categoryform.EquipmentName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Equipment Name is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"EManufacturer\" ng-model=\"model.EManufacturer\" placeholder=\"Manufacturer\" \nautocomplete=\"on\"><div ng-messages=\"Unitform.EManufacturer.$error\" ng-show=\"Unitform.EManufacturer.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Manufacturer is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"ESerialNumber\" ng-model=\"model.ESerialNumber\" \nplaceholder=\"Serial Number\" autocomplete=\"on\" required><div ng-messages=\"Unitform.ESerialNumber.$error\" \nng-show=\"Unitform.ESerialNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span>SerialNumber is required.\n</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container flex><input \ntype=\"text\" name=\"ELocation\" ng-model=\"model.ELocation\" placeholder=\"Location\" autocomplete=\"on\"><div \nng-messages=\"Unitform.ELocation.$error\" ng-show=\"Unitform.ELocation.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Location is required.</span></div></div></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>TakeOver Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"ETakeOverDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"ERemarks\" ng-model=\"model.ERemarks\" placeholder=\"Remarks\" autocomplete=\"on\"><div \nng-messages=\"Unitform.ERemarks.$error\" ng-show=\"Unitform.ERemarks.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Remarks is required.</span></div></div></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" \nstyle=\"margin-left:40%\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveUnit()\" ng-disabled=\"Unitform.$invalid || Unitform.$pristine\"><span>Submit</span></md-button><md-button \nid=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelUnit()\"><span>Cancel</span></md-button></div></form></div>\n<div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Equipmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Inventory Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Equipment Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Manufacturer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">TakeOver Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Equipmentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.EProductCode }}</td><td>{{ row.Category }}</td><td>\n{{ row.EquipmentName }}</td><td>{{ row.EManufacturer }}</td><td>{{ row.ESerialNumber }}</td><td>{{ row.ELocation }}\n</td><td>{{ row.ETakeOverDate | date:\'dd/MM/y\' }}</td><td>{{ row.ERemarks }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Unitinfo(row.id,row.Category,row.EquipmentName,row.EManufacturer,row.ESerialNumber,row.ELocation,row.ETakeOverDate,row.ERemarks,$index)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></div></md-tab-body>\n</md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n        button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n            margin-bottom: 40px !important;\r\n        }\r\n        button#cancel {\r\n            margin-bottom: 40px;\r\n        }\r\n        .secondary-text {\r\n            font-size: 15px !important;\r\n        }\r\n    \r\n        td.dataTables_empty {\r\n            height: 30px !important;\r\n            text-align: center !important;\r\n        }\r\n    \r\n        .dataTables_wrapper {\r\n            font-size: 14px;\r\n        }\r\n    \r\n        .md-tab.md-active {\r\n            background-color: #9E9E9E;\r\n        }\r\n    \r\n        .file-input {\r\n            display: none !important;\r\n        }\r\n        .md-datepicker-input {\r\n    font-size: 14px;\r\n    box-sizing: border-box;\r\n    border: none;\r\n    box-shadow: none;\r\n    outline: none;\r\n    background: transparent;\r\n    min-width: 262px;\r\n    max-width: 328px;\r\n    padding: 0 0 5px;\r\n    margin-left: -10px;\r\n}\r\n._md-datepicker-floating-label > md-datepicker .md-datepicker-button {\r\n    float: left;\r\n    /* margin-top: -12px; */\r\n    top: 1.5px;\r\n}\n</style>");
$templateCache.put("app/main/apps/procurement/materialrequisition/material.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">STOCK REQUISITION</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container style=\"margin-top: 18px\" flex><label>Store</label>\n<md-select ng-model=\"vm.mStore\" id=\"Store\" ng-change=\"ProductCodedetails()\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm4\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a store..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.mStore=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm4\" value=\"{{row.StoreName}}\">\n{{row.StoreName}}</md-option></md-select></md-input-container><md-input-container flex><label>Product Category</label>\n<md-select ng-model=\"vm.mProductCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm5\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a category..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"clearSearchTerm()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ProductCategorydatas | filter:vm.searchTerm5\" value=\"{{row.CategoryName}}\">{{row.CategoryName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label>Product Name</label><md-select ng-model=\"vm.mMaterial\" ng-change=\"ProductCodedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm6\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for product name..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"clearSearchTerm()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Categorydatas | filter:vm.searchTerm6\" value=\"{{row.ProductName}}\">{{row.ProductName}}</md-option>\n</md-select><div ng-messages=\"eventForm.pName .$error\" ng-show=\"eventForm.pName .$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Product Name is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Name\" ng-model=\"vm.mProductCode\" placeholder=\"Product Code\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container flex>\n<input type=\"text\" name=\"Description\" ng-model=\"vm.mDescription\" placeholder=\"Description\" required><div \nng-messages=\"eventForm.Description.$error\" ng-show=\"eventForm.Description.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Description field is required.</span></div></div></md-input-container><md-input-container \nflex><label>Serial Number</label><md-select ng-model=\"vm.mSerialNumber\" ng-change=\"getQuantitydetails()\" \nng-model-options=\"{trackBy: \'$value\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input \nng-model=\"vm.searchTerm7\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Serial #..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"clearSearchTerm()\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-select-header><input type=\"checkbox\" style=\"width: 20px;height: 20px\" ng-model=\"vm.select\" \nng-click=\"selectAll()\"> &nbsp; Select All/Unselect All</md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in SerialNoArray |filter:vm.searchTerm7 \">{{row}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container flex>\n<input type=\"text\" name=\"StockQuantity\" ng-model=\"vm.mStockQuantity\" placeholder=\"Available Stock Quantity\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"number\" name=\"QuantityRequired\" \nng-model=\"vm.mQuantityRequired\" placeholder=\"Quantity Required\" required><div \nng-messages=\"eventForm.QuantityRequired.$error\" ng-show=\"eventForm.QuantityRequired.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Quantity Required.</span></div></div></md-input-container><md-input-container flex><label>\nUnits</label><md-select ng-model=\"vm.mUnits\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm8\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Units..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.mUnits=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Unitdatas | filter:vm.searchTerm8\" value=\"{{row.UnitName}}\">\n{{row.UnitName}}</md-option></md-select><div ng-messages=\"eventForm.Units.$error\" ng-show=\"eventForm.Units.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Units Required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container style=\"margin-top: -25px\" flex><md-radio-group \nng-model=\"vm.mType\" layout=\"row\"><md-radio-button value=\"No\">Non-Returnable</md-radio-button><md-radio-button \nvalue=\"Yes\">Returnable</md-radio-button></md-radio-group></md-input-container><md-input-container id=\"date1\" \nng-show=\"vm.mType == \'Yes\'\" style=\"margin-top: -6px;margin-left:-10px\" flex><label>Expected Return Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.mExpectedReturnDate\" ng-required=\"vm.mType == \'Yes\'\">\n</md-datepicker></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Materialadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/materialrequisition/materialdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this material request?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Mdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/materialrequisition/materialrequisition.html","<div id=\"materialrequisition\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stock Requisition</span>\n</div><div><span>Total Stock Requests:</span> <span>{{Materialformdatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"mrSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input id=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" ng-show=\"mrSearch\" \nstyle=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"mrAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"mrView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"mrExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Materialgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Materialformdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Edit Request</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Requester Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Requested Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Items</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialformdatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewMaterialinfo(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Materialinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y hh:mm a\' }}</td><td><a href=\"\" ng-click=\"ViewMaterialItmes($event,row._id)\" \ntitle=\"Detail Material Grid\" style=\"border:none\">{{ row.TotalItems || 0 }}</a></td><td>{{ row.Status }}</td></tr>\n</tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Materialform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-show=\"Cancel\" \nng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div><div class=\"form-wrapper md-whiteframe-1dp\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" name=\"EmployeeName\" ng-model=\"RequestedByEmployee\" \nplaceholder=\"Requested By\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top: -6px\" flex>\n<label>Work Order</label><md-select ng-model=\"WorkOrder\" ng-model-options=\"{trackBy: \'$value.SalesOrderNo\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a work order..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"WorkOrder=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.SalesOrderNo\" ng-repeat=\"row in SalesOrderdatas  | filter:vm.searchTerm1\">{{row.SalesOrderNo}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label>Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"Date\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -27px\"><md-input-container style=\"margin-top: -6px\" flex><label>Customer\n</label><md-select ng-model=\"Customer\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Customer=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:vm.searchTerm2\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Location\" ng-model=\"Location\" placeholder=\"Location\"></md-input-container><md-input-container \nstyle=\"margin-top: -6px\" flex><label>Purpose</label><md-select ng-model=\"Purpose\" \nng-model-options=\"{trackBy: \'$value.Description\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input\n ng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a purpose..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Purpose=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-optgroup><md-option ng-value=\"row\" ng-model=\"row.Description\" \nng-repeat=\"row in Definedatas  | filter:vm.searchTerm3\">{{row.Description}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"margin-top: -27px\">\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"><div \nng-messages=\"basicForm.Remarks.$error\" ng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Remarks Required.</span></div></div></md-input-container></div></div></div><br><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">&nbsp;STOCK REQUISITION</h1><div \nlayout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Materialpopup($event, UniqueID)\" style=\"float:right\"><span>Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Materialdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Materialdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.SerialNumber }}</td><td>{{ row.QuantityRequired }}</td><td>{{ row.Unit }}</td><td>{{ row.ProductType }}\n</td><td>{{ row.ExpectedReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div><br><br></form><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"mSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div></div></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewMaterialform\" flex><form name=\"basicForm2\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"ReferenceNo\" \nng-model=\"ReferenceNo\" placeholder=\"Reference #\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"RequestedBy\" ng-model=\"EmployeeName\" placeholder=\"Requested By\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"WorkOrder\" ng-model=\"WorkOrder\" \nplaceholder=\"Work Order\" readonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -27px\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><input type=\"text\" name=\"Date\" ng-model=\"Date | date:\'dd/MM/y\'\" \nplaceholder=\"Date\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"CustomerName\" ng-model=\"CustomerName\" placeholder=\"Customer\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Location\" ng-model=\"Location\" placeholder=\"Location\" \nreadonly=\"readonly\"></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" name=\"Purpose\" ng-model=\"Purpose\" \nplaceholder=\"Purpose\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\" readonly=\"readonly\"></md-input-container><md-input-container \nflex></md-input-container></div></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 \nstyle=\"text-align:left\">&nbsp;STOCK REQUISITION</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Store Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Materialdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreName }}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.SerialNumber }}</td><td>{{ row.QuantityRequired }}</td><td>{{ row.Unit }}</td><td>{{ row.ProductType }}\n</td><td>{{ row.ExpectedReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div><br><br></form><br></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n     md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n   #date1 md-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/materialrequisition/viewItems.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TOTAL ITEMS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Materialdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}\n</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>\n{{ row.SerialNumber }}</td><td>{{ row.QuantityRequired }}</td><td>{{ row.Unit }}</td></tr></tbody></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Close\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/purchaserequisition/purchase.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">PURCHASE REQUISITION</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Product Category\n</label><md-select ng-model=\"vm.pProductCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm6\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a category..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.pProductCategory=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ProductCategorydatas | filter:vm.searchTerm6\" value=\"{{row.CategoryName}}\">{{row.CategoryName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label>Product Name</label><md-select ng-model=\"vm.pName\" ng-change=\"ProductCodedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm7\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for product name..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"ProductNameClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Categorydatas | filter:vm.searchTerm7\" value=\"{{row.ProductName}}\">{{row.ProductName}}</md-option>\n</md-select><div ng-messages=\"eventForm.pName .$error\" ng-show=\"eventForm.pName .$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Product Name is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.pProductCode\" \nplaceholder=\"Product Code\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-20px\"><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"vm.pDescription\" \nplaceholder=\"Description\" required><div ng-messages=\"eventForm.Description.$error\" \nng-show=\"eventForm.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Description field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\">\n<md-input-container flex><input type=\"number\" name=\"Quantity\" ng-change=\"CalculateTotal()\" ng-model=\"vm.pQuantity\" \nplaceholder=\"Quantity\" required><div ng-messages=\"eventForm.Quantity.$error\" ng-show=\"eventForm.Quantity.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Quantity field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Units</label><md-select ng-model=\"vm.pUnits\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm8\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Units..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.pUnits=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Unitdatas | filter:vm.searchTerm8\" \nvalue=\"{{row.UnitName}}\">{{row.UnitName}}</md-option></md-select><div ng-messages=\"eventForm.Units.$error\" \nng-show=\"eventForm.Units.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Units Required.</span></div></div>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Purchaseadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/purchaserequisition/purchasedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this purchase request?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Pdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaserequisition/purchaserequisition.html","<div id=\"pruchaserequisition\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Purchase Requisition\n</span></div><div><span>Total Purchase Requests:</span> <span>{{Purchaseformdatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"prSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input \nid=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" \nng-show=\"prSearch\" style=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\">\n<label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"prAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"prView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"prExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Purchasegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Purchaseformdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Edit Request</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Requester Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Department</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Work Order</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Deadline</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Items</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Purchaseformdatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewPurchaseinfo(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Purchaseinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Employeedetails[0].EDesignation }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.WorkOrder }}</td><td>\n{{ row.Deadline | date:\'dd/MM/y\'}}</td><td><a href=\"\" ng-click=\"ViewPurchaseItmes($event,row._id)\" \ntitle=\"Detail Purchase Grid\" style=\"border:none\">{{ row.TotalItems || 0 }}</a></td><td>{{ row.Status }}</td></tr>\n</tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Purchaseform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-show=\"Cancel\" \nng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div><div class=\"form-wrapper md-whiteframe-1dp\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" name=\"EmployeeName\" ng-model=\"RequestedByEmployee\" \nplaceholder=\"Requested By\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top: -6px\" flex>\n<label>Work Order</label><md-select ng-model=\"WorkOrder\" ng-model-options=\"{trackBy: \'$value.SalesOrderNo\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a work order..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"WorkOrder=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.SalesOrderNo\" ng-repeat=\"row in SalesOrderdatas  | filter:vm.searchTerm1\">{{row.SalesOrderNo}}\n</md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label>Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"Date\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -27px\"><md-input-container style=\"margin-top: -6px\" flex><label>Supplier\n</label><md-select ng-model=\"Supplier\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Supplier..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Supplier=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:vm.searchTerm2\" value=\"{{row.id}}\">{{row.Name}}\n</md-option></md-select></md-input-container><md-input-container style=\"margin-top: -6px\" flex><label>Store</label>\n<md-select ng-model=\"Store\" ng-change=\"Storedetails()\" id=\"Store\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a store..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Store=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm3\" value=\"{{row._id}}\">\n{{row.StoreName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label>Deadline</label><md-datepicker onkeydown=\"return false\" \nng-model=\"Deadline\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -27px\"><md-input-container style=\"margin-top: -6px\" flex><label>Purpose\n</label><md-select ng-model=\"Purpose\" ng-model-options=\"{trackBy: \'$value.Description\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTerm4\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a purpose..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Purpose=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.Description\" ng-repeat=\"row in Definedatas  | filter:vm.searchTerm4\">{{row.Description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"Remarks\" placeholder=\"Remarks\"></md-input-container><md-input-container flex></md-input-container></div>\n</div></div><br></form><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-bottom: -30px\"><md-input-container style=\"margin-top: -10px\" flex><h1 style=\"text-align:left\">\n&nbsp;PURCHASE REQUISITION</h1></md-input-container><md-input-container style=\"font-size:16px\" flex><label>Currency\n</label><md-select ng-model=\"Currency\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm5\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Currency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Currency = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CurrencyCodeList | filter:vm.searchTerm5\" \nvalue=\"{{row.TransactionCurrencies}}\">{{row.TransactionCurrencies}}</md-option></md-select></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container></div><div \nlayout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Purchasepopup($event, UniqueID)\" style=\"float:right\"><span>Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" style=\"font-size:16px\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\">\n<div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unit Price</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Cost</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Edit/Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Purchasedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>\n{{ row.ProductName }}</td><td><span editable-text=\"row.Description\" e-name=\"Description\" e-form=\"rowform\">\n{{ row.Description}}</span></td><td><span editable-text=\"row.Quantity\" e-name=\"Quantity\" e-form=\"rowform\">\n{{ row.Quantity}}</span></td><td>{{ row.Unit }}</td><td><span editable-text=\"row.UnitPrice\" e-name=\"UnitPrice\" \ne-form=\"rowform\">{{ row.UnitPrice}}</span></td><td>{{ row.TotalCost|number:2}}</td><td style=\"white-space: nowrap\">\n<form editable-form name=\"rowform\" \nonbeforesave=\"PurchaseUpdate($data, row.UniqueID, row._id, row.ProductCategory, row.ProductCodeID, row.ProductName, row.Unit, row.Model)\" \nng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == row\"><button type=\"submit\" \nng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\">save</button> <button type=\"button\" \nng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default\">cancel</button></form><div \nclass=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary\" ng-click=\"rowform.$show()\">edit</button> \n<button class=\"btn btn-danger\" ng-click=\"Purchasedelete($event, row._id)\">delete</button></div></td></tr></tbody>\n</table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Sub Total:</b> &emsp; \n<span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><input type=\"number\" \nname=\"Discount\" ng-model=\"DiscountBefore\" ng-change=\"ChangeTotal()\" placeholder=\"Discount % (Before GST)\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\"><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"GST\" ng-model=\"GST\" ng-change=\"ChangeTotal()\" placeholder=\"GST %\">\n<div ng-messages=\"basicForm.GST.$error\" ng-show=\"basicForm.GST.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nGST field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-35px\"><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex><input type=\"number\" name=\"Discount\" \nng-model=\"DiscountAfter\" ng-change=\"ChangeTotal()\" placeholder=\"Discount % (After GST)\"><div \nng-messages=\"basicForm.DiscountAfter.$error\" ng-show=\"basicForm.DiscountAfter.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Discount After field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Total:</b> &emsp; <span ng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div>\n</div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"pSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div></div></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewPurchaseform\" flex><form name=\"basicForm2\" class=\"md-inline-form\" \nnovalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" \nname=\"ReferenceNo\" ng-model=\"ReferenceNo\" placeholder=\"Reference #\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"RequestedBy\" ng-model=\"EmployeeName\" placeholder=\"Requested By\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><input \ntype=\"text\" name=\"Date\" ng-model=\"Date | date:\'dd/MM/y\'\" placeholder=\"Date\" readonly=\"readonly\"></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"margin-top:-27px\"><md-input-container flex><input \ntype=\"text\" name=\"SupplierName\" ng-model=\"SupplierName\" placeholder=\"Supplier Name\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"StoreName\" ng-model=\"StoreName\" \nplaceholder=\"Store Name\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"WorkOrder\" ng-model=\"WorkOrder\" placeholder=\"Work Order\" readonly=\"readonly\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"margin-top:-27px\"><md-input-container flex \nstyle=\"margin-top: 18px\"><input type=\"text\" name=\"Deadline\" ng-model=\"Deadline | date:\'dd/MM/y\'\" \nplaceholder=\"Deadline\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Purpose\" ng-model=\"Purpose\" placeholder=\"Purpose\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\" readonly=\"readonly\">\n</md-input-container></div></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-bottom: -60px\"><md-input-container style=\"margin-top: -10px\" flex><h1 \nstyle=\"text-align:left\">&nbsp;PURCHASE REQUISITION</h1></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Currency\" ng-model=\"Currency\" placeholder=\"Currency\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Purchasedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost|number:2 }}\n</td></tr></tbody></table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Sub Total:</b> &emsp; <span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DiscountBefore\" ng-model=\"DiscountBefore\" placeholder=\"Discount % (Before GST)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST %\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"DiscountAfter\" ng-model=\"DiscountAfter\" \nplaceholder=\"Discount % (After GST)\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Total:</b> &emsp; <span \nng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div></div></form><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" \nclass=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    div#head {\r\n        margin-top: -75px;\r\n    }\r\n    \r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    [ng\\:cloak], [ng-cloak], .ng-cloak {\r\n        display: none !important;\r\n    }\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/purchaserequisition/viewItems.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TOTAL ITEMS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Purchasedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}\n</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>{{ row.Quantity }}\n</td><td>{{ row.Unit }}</td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">Close</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/settings/settings.html","<div id=\"settings\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-store\"></md-icon><span>Settings</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"Datasearch\" class=\"search-input\" type=\"text\" \nng-model=\"SearchDetails\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"categoryExport && AllowExport==\'true\'\" ng-click=\"cExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n<span>Export</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"unitExport && AllowExport==\'true\'\" \nng-click=\"uExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"paymenttermExport && AllowExport==\'true\'\" ng-click=\"pExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"tagExport && AllowExport==\'true\'\" ng-click=\"tExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"defineExport && AllowExport==\'true\'\" \nng-click=\"dExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"Categories()\"><md-tab-label>\n<span>Category</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"Categoryform\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Category\" \nng-model=\"model.CategoryName\" placeholder=\"Category\" required><div ng-messages=\"Categoryform.CategoryName.$error\" \nng-show=\"Categoryform.CategoryName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Category is required.</span>\n</div></div></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveCategory()\" ng-disabled=\"Categoryform.$invalid || Categoryform.$pristine\"><span>Save</span></md-button>\n<md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelCategory()\"><span>Cancel</span></md-button>\n</div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Categorydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Categorydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CategoryName }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Categoryinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Units()\"><md-tab-label><span>Unit</span>\n</md-tab-label></div><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"Unitform\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" name=\"Unit\" ng-model=\"model.UnitName\" placeholder=\"Unit\" required><div \nng-messages=\"Unitform.UnitName.$error\" ng-show=\"Unitform.UnitName.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Unit is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveUnit()\" \nng-disabled=\"Unitform.$invalid || Unitform.$pristine\"><span>Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"cancelUnit()\"><span>Cancel</span></md-button></div><div class=\"content-card\">\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"Unitdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Unitdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.UnitName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Unitinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"PaymentTerms()\"><md-tab-label><span>\nPayment Terms</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"PaymentTermform\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"PaymentTermName\" \nng-model=\"model.PaymentTermName\" placeholder=\"Payment Term\" required><div \nng-messages=\"PaymentTermform.UnitName.$error\" ng-show=\"PaymentTermform.UnitName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Payment Term is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"savePaymentTerm()\" \nng-disabled=\"PaymentTermform.$invalid || PaymentTermform.$pristine\"><span>Save</span></md-button><md-button \nid=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelPaymentTerm()\"><span>Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Unitdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment Term</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PaymentTermdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.PaymentTermName }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"PaymentTerminfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/purchaseorder/RejectReason.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">REASON FOR REJECTION</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container flex>\n<input type=\"text\" name=\"Reason\" ng-model=\"vm.Comments\" placeholder=\"Reason\" required><div \nng-messages=\"eventForm.Comments.$error\" ng-show=\"eventForm.Comments.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Reason is required.</span></div></div></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"reject()\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"CANCEL\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaseorder/goods.html","<md-dialog style=\"width:1350px\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">GOODS RECEIVING</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm2\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"RefNo\" ng-model=\"RefNo\" placeholder=\"PO #\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DONumber\" ng-model=\"vm.gDONumber\" placeholder=\"DO #\" required></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"GRN\" ng-model=\"vm.gGRN\" placeholder=\"Goods Receiving #\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" name=\"ReceivedDate\" \nng-model=\"vm.gReceivedDate| date:\'dd/MM/y\'\" placeholder=\"Received Date\" readonly=\"readonly\"></md-input-container></div>\n</form><div layout=\"column\" layout-gt-sm=\"row\" style=\"width:100%;margin-top: -35px;margin-bottom: -35px\" \nng-show=\"ShowAlert\"><div layout=\"column\"><label style=\"color:red\"><b>\n{{ExistingSerialNoList}} Serial Number(s) are already Exist.</b></label><br><br></div></div><table \nclass=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight:bold\"><td style=\"width:10%\">\nProduct Category</td><td style=\"width:10%\">Product Code</td><td style=\"width:10%\">Product Name</td><td \nstyle=\"width:10%\">Description</td><td style=\"width:10%\">Ordered Quantity</td><td style=\"width:5%\">Unit</td><td \nstyle=\"width:5%\">Receive Quantity</td><td style=\"width:5%\">Return Quantity</td><td style=\"width:10%\">Serial Number</td>\n<td style=\"width:10%\">Received Quantity</td><td style=\"width:5%\">Edit</td></tr><tr \nng-repeat=\"user in Purchaseorderproductdatas\"><td>{{ user.ProductCategory}}</td><td>{{ user.ProductCodeID}}</td><td>\n{{ user.ProductName}}</td><td>{{ user.Description}}</td><td>{{ user.Quantity}}</td><td>{{ user.Unit}}</td><td><span \neditable-number=\"user.ReceiveQuantity || 0\" e-name=\"ReceiveQuantity\" e-form=\"rowform\" e-style=\"width:40px\">\n{{ user.ReceiveQuantity || \'0\' }}</span></td><td><span editable-number=\"user.ReturnQuantity || \'\'\" \ne-name=\"ReturnQuantity\" e-form=\"rowform\" e-style=\"width:40px\">{{ user.ReturnQuantity || \'\' }}</span></td><td><span \neditable-textarea=\"user.SerialNumber || \'\'\" e-name=\"SerialNumber\" e-form=\"rowform\" e-style=\"width:200px;height:60px;\">\n{{ user.SerialNumber || \'\' }}</span></td><td>{{ user.ReceivedQuantity || \'0\'}}</td><td style=\"white-space: nowrap\">\n<form editable-form name=\"rowform\" \nonbeforesave=\"saveGoods($data, user._id, user.ProductCategory, user.ProductCodeID, user.ProductName, user.Description, user.Quantity, user.Unit,  user.Model)\" \nng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == user\"><button type=\"submit\" \nng-disabled=\"rowform.$waiting && basicForm2.$invalid || basicForm2.$pristine\" class=\"btn btn-primary\">save</button> \n<button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default\">cancel\n</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary\" \nng-click=\"rowform.$show()\">edit</button></div></td></tr></table></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Close\n</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaseorder/goodsclose.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nGoods not received yet. Are you sure you want to complete this PO?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"CompletePOworkflow()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaseorder/goodsdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this goods received?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Gdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaseorder/purchaseorder.html","<div id=\"purchaseorder\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Purchase Order</span>\n</div><div><span>Total Purchase Orders:</span> <span>{{Purchaseorderdatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"poSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input \nid=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" \nng-show=\"poSearch\" style=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\">\n<label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-show=\"poView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"poExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Purchaseordergrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Purchaseorderdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">PO Reference #</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nPR Reference #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Requested By</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Supplier</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Order Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nRequired Delivery Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Status</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"row in Purchaseorderdatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"Purchaseorderinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo}}</a>\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>{{ row.PRID }}</td>\n<td>{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Supplierdetails[0].Name }}</td><td>{{ row.OrderDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.DeliveryDate | date:\'dd/MM/y\'}}</td><td>{{ row.Status}}</td></tr></tbody></table></div></div><div \nclass=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Purchaseorderform\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;PURCHASE ORDER DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">PO Reference #\n</label>&nbsp; : &nbsp; {{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">\nPR Reference #</label>&nbsp; :&nbsp; {{RequisitionNo}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:180px\">Requested By</label>&nbsp; :&nbsp; {{RequestedByName}}<br><br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:180px\">Order Date</label>&nbsp; :&nbsp; {{OrderDate | date:\'dd/MM/y\'}}\n<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">Required Delivery Date</label>\n&nbsp; :&nbsp; {{DeliveryDate | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">\nRemarks</label>&nbsp; : &nbsp; {{Remarks}}<br><br></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"rejectReason()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:49.5%;float:left;height:340px\"><h2 style=\"text-align:left\">\n&nbsp;SUPPLIER</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-left:20px\" flex=\"50\"><input type=\"text\" name=\"Supplier\" ng-model=\"SupplierName\" placeholder=\"Supplier\" \nreadonly=\"readonly\"></md-input-container></div><div style=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label>\n<br>&emsp; <span ng-model=\"SupplierAddress1\">{{SupplierAddress1}} </span>&nbsp; <span ng-model=\"SupplierAddress2\">\n{{SupplierAddress2}}</span><br>&emsp; <span ng-model=\"SupplierCity\">{{SupplierCity}} </span>&nbsp; <span \nng-model=\"SupplierState\">{{SupplierState}} </span><br>&emsp; <span ng-model=\"SupplierCountry\">{{SupplierCountry}} \n</span>&nbsp; <span ng-model=\"sPostalCode\">{{SupplierPostalCode}} </span><br></div><div>&emsp;<label><b>Phone:</b>\n</label>&nbsp; <span ng-model=\"SupplierPhone\">{{SupplierPhone}} </span>&nbsp;<label><b>Mobile:</b></label>&nbsp; <span \nng-model=\"SupplierMobile\">{{SupplierMobile}}</span><br></div><div>&emsp;<label><b>Fax:</b></label>&nbsp; <span \nng-model=\"SupplierFax\">{{SupplierFax}} </span>&nbsp;<label><b>Email:</b></label>&nbsp; <span ng-model=\"SupplierEmail\">\n{{SupplierEmail}} </span><br></div><div>&emsp;<label><b>Website:</b></label>&nbsp; <span ng-model=\"SupplierWebsite\">\n{{SupplierWebsite}}</span></div></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;float:right;height:340px\"><h2 style=\"text-align:left\">&nbsp;DELIVER TO</h2><hr><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-left:20px\" flex=\"50\"><input \ntype=\"text\" name=\"Store\" ng-model=\"StoreName\" placeholder=\"Store\" readonly=\"readonly\"></md-input-container></div><div \nstyle=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label><br>&emsp;<label \nstyle=\"font-weight:500;font-size:17px\" ng-model=\"ClientStore\">{{ClientStore}}</label><br>&emsp; <span \nng-model=\"StoreAddress1\">{{StoreAddress1}} </span>&nbsp; <span ng-model=\"StoreAddress2\">{{StoreAddress2}}</span><br>\n&emsp; <span ng-model=\"StoreCity\">{{StoreCity}} </span>&nbsp; <span ng-model=\"StoreState\">{{StoreState}} </span><br>\n&emsp; <span ng-model=\"StoreCountry\">{{StoreCountry}} </span>&nbsp; <span ng-model=\"StorePostalCode\">\n{{StorePostalCode}} </span><br></div><div>&emsp;<label style=\"width:50px\"><b>Phone:</b></label>&nbsp; <span \nng-model=\"StorePhone\">{{StorePhone}} </span>&emsp;<label style=\"width:50px\"><b>Email:</b></label>&nbsp; <span \nng-model=\"StoreEmail\">{{StoreEmail}} </span><br></div><div></div></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: -60px\">\n<md-input-container style=\"margin-top: -10px\" flex><h1 style=\"text-align:left\">&nbsp;PURCHASE ORDER</h1>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Currency\" ng-model=\"Currency\" \nplaceholder=\"Currency\" readonly=\"readonly\"></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseorderproductdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost|number:2 }}\n</td></tr></tbody></table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Sub Total:</b> &emsp; <span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DiscountBefore\" ng-model=\"DiscountBefore\" placeholder=\"Discount % (Before GST)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST %\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"DiscountAfter\" ng-model=\"DiscountAfter\" \nplaceholder=\"Discount % (After GST)\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Total:</b> &emsp; <span \nng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\"><h2 style=\"text-align:left\">&nbsp;GOODS RECEIVING</h2><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" ng-show=\"Goods\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Goodspopup($event)\" style=\"float:right\"><span>Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serial No.</span></div></th><th \nng-show=\"row.OrderedQuantity != 0\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nOrdered Quantity</span></div></th><th ng-show=\"row.OrderedQuantity == 0\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ordered Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returned Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DO #</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">GRN #</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received By</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Goodsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}</td><td>\n{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>{{ row.SerialNumber }}</td>\n<td ng-show=\"row.OrderedQuantity != 0\">{{ row.OrderedQuantity }}</td><td ng-show=\"row.OrderedQuantity == 0\"></td><td>\n{{ row.ReceivedQuantity }}</td><td>{{ row.ReturnedQuantity || 0 }}</td><td>{{ row.Unit }}</td><td>{{ row.DONumber }}\n</td><td>{{ row.GRN }}</td><td>{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td><td>{{ row.CreatedBy }}</td></tr></tbody>\n</table></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr>\n<div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" \nname=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button \nclass=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input class=\"file-input\" \nflow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Purchase Order/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"ViewPurchaseorderform\" flex><form name=\"basicForm2\" class=\"md-inline-form\" novalidate><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;PURCHASE ORDER DETAILS</h2><hr>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:180px\">PO Reference #</label>&nbsp; : &nbsp; {{ReferenceNo}}<br><br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:180px\">PR Reference #</label>&nbsp; :&nbsp; {{RequisitionNo}}<br><br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">Requested By</label>&nbsp; :&nbsp; {{RequestedByName}}\n<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">Order Date</label>\n&nbsp; :&nbsp; {{OrderDate | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">\nRequired Delivery Date</label>&nbsp; :&nbsp; {{DeliveryDate | date:\'dd/MM/y\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:180px\">Remarks</label>&nbsp; : &nbsp; {{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr>\n<div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"rejectReason()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:49.5%;float:left;height:300px\"><h2 style=\"text-align:left\">\n&nbsp;SUPPLIER</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-left:20px\" flex=\"50\"><input type=\"text\" name=\"Supplier\" ng-model=\"SupplierName\" placeholder=\"Supplier\" \nreadonly=\"readonly\"></md-input-container></div><div style=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label>\n<br>&emsp; <span ng-model=\"SupplierAddress1\">{{SupplierAddress1}} </span>&nbsp; <span ng-model=\"SupplierAddress2\">\n{{SupplierAddress2}}</span><br>&emsp; <span ng-model=\"SupplierCity\">{{SupplierCity}} </span>&nbsp; <span \nng-model=\"SupplierState\">{{SupplierState}} </span><br>&emsp; <span ng-model=\"SupplierCountry\">{{SupplierCountry}} \n</span>&nbsp; <span ng-model=\"sPostalCode\">{{SupplierPostalCode}} </span><br></div><div>&emsp;<label><b>Phone:</b>\n</label>&nbsp; <span ng-model=\"SupplierPhone\">{{SupplierPhone}} </span>&nbsp;<label><b>Mobile:</b></label>&nbsp; <span \nng-model=\"SupplierMobile\">{{SupplierMobile}}</span><br></div><div>&emsp;<label><b>Fax:</b></label>&nbsp; <span \nng-model=\"SupplierFax\">{{SupplierFax}} </span>&nbsp;<label><b>Email:</b></label>&nbsp; <span ng-model=\"SupplierEmail\">\n{{SupplierEmail}} </span>&nbsp;<label><b>Website:</b></label>&nbsp; <span ng-model=\"SupplierWebsite\">\n{{SupplierWebsite}} </span><br></div></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;float:right;height:300px\"><h2 style=\"text-align:left\">&nbsp;DELIVER TO</h2><hr><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-left:20px\" flex=\"50\"><input \ntype=\"text\" name=\"Store\" ng-model=\"StoreName\" placeholder=\"Store\" readonly=\"readonly\"></md-input-container></div><div \nstyle=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label><br>&emsp;<label \nstyle=\"font-weight:500;font-size:17px\" ng-model=\"ClientStore\">{{ClientStore}}</label><br>&emsp; <span \nng-model=\"StoreAddress1\">{{StoreAddress1}} </span>&nbsp; <span ng-model=\"StoreAddress2\">{{StoreAddress2}}</span><br>\n&emsp; <span ng-model=\"StoreCity\">{{StoreCity}} </span>&nbsp; <span ng-model=\"StoreState\">{{StoreState}} </span><br>\n&emsp; <span ng-model=\"StoreCountry\">{{StoreCountry}} </span>&nbsp; <span ng-model=\"StorePostalCode\">\n{{StorePostalCode}} </span><br></div><div>&emsp;<label style=\"width:50px\"><b>Phone:</b></label>&nbsp; <span \nng-model=\"StorePhone\">{{StorePhone}} </span>&emsp;<label style=\"width:50px\"><b>Email:</b></label>&nbsp; <span \nng-model=\"StoreEmail\">{{StoreEmail}} </span><br></div><div></div></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: -60px\">\n<md-input-container style=\"margin-top: -10px\" flex><h1 style=\"text-align:left\">&nbsp;PURCHASE ORDER</h1>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Currency\" ng-model=\"Currency\" \nplaceholder=\"Currency\" readonly=\"readonly\"></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseorderproductdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost }}</td></tr>\n</tbody></table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Sub Total:</b> &emsp; <span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DiscountBefore\" ng-model=\"DiscountBefore\" placeholder=\"Discount % (Before GST)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST %\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"DiscountAfter\" ng-model=\"DiscountAfter\" \nplaceholder=\"Discount % (After GST)\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Total:</b> &emsp; <span \nng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\"><h2 style=\"text-align:left\">&nbsp;GOODS RECEIVING</h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ordered Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returned Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DO#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received By</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Goodsdatas\"><td>&nbsp;</td><td>{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>\n{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>{{ row.OrderedQuantity }}</td><td>\n{{ row.ReceivedQuantity }}</td><td>{{ row.ReturnedQuantity || 0 }}</td><td>{{ row.Unit }}</td><td>{{ row.DONumber }}\n</td><td>{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td><td>{{ row.CreatedBy }}</td></tr></tbody></table></div></div><br>\n<div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Commented By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Commented Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}</td><td>{{ row.CommentedBy }}</td><td>\n{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS</h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Purchase Order/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n     #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n    /*.md-datepicker-input {\r\n        min-width: 760px;\r\n        max-width: 1500px;\r\n    }*/\r\n   /*#date1 .md-datepicker .md-datepicker-input {\r\n        min-width: 344px;\r\n        max-width: 500px;\r\n    }*/\r\n\r\n    /*md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 3px);\r\n        max-width: calc(35vw - 54px);\r\n    }*/\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/purchaseorder/purchaseorderadd.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">PURCHASE ORDER</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Product Category</label><md-select \nng-model=\"vm.pCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a category..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.pCategory=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CategoryList | filter:vm.searchTerm\" value=\"{{row.name}}\">{{row.name}}\n</md-option></md-select><div ng-messages=\"eventForm.ProductCategory .$error\" \nng-show=\"eventForm.ProductCategory .$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nProduct Category is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Product Name</label><md-select ng-model=\"vm.pName\" ng-change=\"ProductCodedetails()\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for product name..\" ng-keydown=\"$event.stopPropagation()\"><md-button\n class=\"md-icon-button\" ng-click=\"ProductNameclear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Categorydatas | filter:vm.searchTerm\" value=\"{{row.ProductName}}\">{{row.ProductName}}</md-option>\n</md-select><div ng-messages=\"eventForm.pName .$error\" ng-show=\"eventForm.pName .$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Product Name is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.pCode\" \nplaceholder=\"Product Code\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-20px\"><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"vm.pDescription\" \nplaceholder=\"Product Description\"><div ng-messages=\"eventForm.Description.$error\" \nng-show=\"eventForm.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nProduct Description field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container flex><input type=\"number\" name=\"Quantity\" \nng-model=\"vm.pQuantity\" ng-change=\"CalculateTotal()\" placeholder=\"Quantity\" required><div \nng-messages=\"eventForm.Quantity.$error\" ng-show=\"eventForm.Quantity.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Quantity field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Name\" ng-model=\"vm.pUnit\" placeholder=\"Units\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"UnitPrice\" ng-model=\"vm.pUnitPrice\" ng-change=\"CalculateTotal()\" placeholder=\"Unit Price\">\n<div ng-messages=\"eventForm.UnitPrice.$error\" ng-show=\"eventForm.UnitPrice.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Unit Price field is required.</span></div></div></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Purchaseorderadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/purchaseorder/purchaseorderdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this purchase request?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Pdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/purchaseorder/viewprdata.html","<div class=\"content\"><div layout=\"row\" style=\"width:800px\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<span style=\"color:#617d7b\"><b>Purchase Order</b></span></md-input-container></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nProduct Category</label><md-select ng-model=\"vm.pCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search for a category..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in vm.states | filter:vm.searchTerm\" value=\"{{row.abbrev}}\">{{row.abbrev}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Product Name</label>\n<md-select ng-model=\"vm.pName\" ng-change=\"ProductCodedetails()\" id=\"searchmodule\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search for product name..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ProductList | filter:vm.searchTerm\" value=\"{{row.Name}}\">{{row.Name}}\n</md-option></md-select><div ng-messages=\"basicForm.pName .$error\" ng-show=\"basicForm.pName .$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Product Name is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.pCode\" \nplaceholder=\"Product Code\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-20px\"><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"vm.pDescription\" \nplaceholder=\"Product Description\"><div ng-messages=\"basicForm.Description.$error\" \nng-show=\"basicForm.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nProduct Description field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container flex><input type=\"number\" name=\"Quantity\" \nng-model=\"vm.pQuantity\" ng-change=\"CalculateTotal()\" placeholder=\"Quantity\" required><div \nng-messages=\"basicForm.Quantity.$error\" ng-show=\"basicForm.Quantity.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Quantity field is required.</span></div></div></md-input-container><md-input-container flex><label>Units</label>\n<md-select ng-model=\"vm.pUnit\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search for a Units..\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in UnitList | filter:vm.searchTerm\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"UnitPrice\" ng-model=\"vm.pUnitPrice\" \nng-change=\"CalculateTotal()\" placeholder=\"Unit Price\"><div ng-messages=\"basicForm.UnitPrice.$error\" \nng-show=\"basicForm.UnitPrice.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Unit Price field is required.\n</span></div></div></md-input-container></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Purchaseorderadd()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></div></div></div><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/purchaseorder/viewpurchaseorder.html","<div id=\"purchaseorder\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Purchase Order</span>\n</div></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm2\" class=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;PURCHASE ORDER DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">PO Reference #\n</label>&nbsp; : &nbsp; {{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">\nPR Reference #</label>&nbsp; :&nbsp; {{RequisitionNo}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:180px\">Requested By</label>&nbsp; :&nbsp; {{RequestedByName}}<br><br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:180px\">Order Date</label>&nbsp; :&nbsp; {{OrderDate | date:\'dd/MM/y\'}}\n<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">Required Delivery Date</label>\n&nbsp; :&nbsp; {{DeliveryDate | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:180px\">\nRemarks</label>&nbsp; : &nbsp; {{Remarks}}<br><br></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"rejectReason()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:49.5%;float:left;height:300px\"><h2 style=\"text-align:left\">\n&nbsp;SUPPLIER</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-left:20px\" flex=\"50\"><input type=\"text\" name=\"Supplier\" ng-model=\"SupplierName\" placeholder=\"Supplier\" \nreadonly=\"readonly\"></md-input-container></div><div style=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label>\n<br>&emsp; <span ng-model=\"SupplierAddress1\">{{SupplierAddress1}} </span>&nbsp; <span ng-model=\"SupplierAddress2\">\n{{SupplierAddress2}}</span><br>&emsp; <span ng-model=\"SupplierCity\">{{SupplierCity}} </span>&nbsp; <span \nng-model=\"SupplierState\">{{SupplierState}} </span><br>&emsp; <span ng-model=\"SupplierCountry\">{{SupplierCountry}} \n</span>&nbsp; <span ng-model=\"sPostalCode\">{{SupplierPostalCode}} </span><br></div><div>&emsp;<label><b>Phone:</b>\n</label>&nbsp; <span ng-model=\"SupplierPhone\">{{SupplierPhone}} </span>&nbsp;<label><b>Mobile:</b></label>&nbsp; <span \nng-model=\"SupplierMobile\">{{SupplierMobile}}</span><br></div><div>&emsp;<label><b>Fax:</b></label>&nbsp; <span \nng-model=\"SupplierFax\">{{SupplierFax}} </span>&nbsp;<label><b>Email:</b></label>&nbsp; <span ng-model=\"SupplierEmail\">\n{{SupplierEmail}} </span>&nbsp;<label><b>Website:</b></label>&nbsp; <span ng-model=\"SupplierWebsite\">\n{{SupplierWebsite}} </span><br></div></div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:49.5%;float:right;height:300px\"><h2 style=\"text-align:left\">&nbsp;DELIVER TO</h2><hr><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-left:20px\" flex=\"50\"><input \ntype=\"text\" name=\"Store\" ng-model=\"StoreName\" placeholder=\"Store\" readonly=\"readonly\"></md-input-container></div><div \nstyle=\"margin-top:-28px\"><div>&emsp;<label><b>Address:</b></label><br>&emsp;<label \nstyle=\"font-weight:500;font-size:17px\" ng-model=\"ClientStore\">{{ClientStore}}</label><br>&emsp; <span \nng-model=\"StoreAddress1\">{{StoreAddress1}} </span>&nbsp; <span ng-model=\"StoreAddress2\">{{StoreAddress2}}</span><br>\n&emsp; <span ng-model=\"StoreCity\">{{StoreCity}} </span>&nbsp; <span ng-model=\"StoreState\">{{StoreState}} </span><br>\n&emsp; <span ng-model=\"StoreCountry\">{{StoreCountry}} </span>&nbsp; <span ng-model=\"StorePostalCode\">\n{{StorePostalCode}} </span><br></div><div>&emsp;<label style=\"width:50px\"><b>Phone:</b></label>&nbsp; <span \nng-model=\"StorePhone\">{{StorePhone}} </span>&emsp;<label style=\"width:50px\"><b>Email:</b></label>&nbsp; <span \nng-model=\"StoreEmail\">{{StoreEmail}} </span><br></div><div></div></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: -60px\">\n<md-input-container style=\"margin-top: -10px\" flex><h1 style=\"text-align:left\">&nbsp;PURCHASE ORDER</h1>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Currency\" ng-model=\"Currency\" \nplaceholder=\"Currency\" readonly=\"readonly\"></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseorderproductdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost }}</td></tr>\n</tbody></table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Sub Total:</b> &emsp; <span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DiscountBefore\" ng-model=\"DiscountBefore\" placeholder=\"Discount % (Before GST)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST %\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"DiscountAfter\" ng-model=\"DiscountAfter\" \nplaceholder=\"Discount % (After GST)\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Total:</b> &emsp; <span \nng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\"><h2 style=\"text-align:left\">&nbsp;GOODS RECEIVING</h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" id=\"tb1\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Ordered Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returned Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DO#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received By</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Goodsdatas\"><td>&nbsp;</td><td>{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>\n{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>{{ row.OrderedQuantity }}</td><td>\n{{ row.ReceivedQuantity }}</td><td>{{ row.ReturnedQuantity || 0 }}</td><td>{{ row.Unit }}</td><td>{{ row.DONumber }}\n</td><td>{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td><td>{{ row.CreatedBy }}</td></tr></tbody></table></div></div><br>\n<div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:39.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Comment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Commented By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Commented Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}</td><td>{{ row.CommentedBy }}</td><td>\n{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:59.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS</h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Purchase Order/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div></form></div></div></div></div></div><style>\n#viewedit.md-button {\r\n         margin: -16px 8px;\r\n     }\r\n     div#head {\r\n         margin-top: -50px;\r\n     }\r\n\r\n     #tb1 {\r\n         counter-reset: serial-number;  /* Set the serial number counter to 0 */\r\n     }\r\n     #tb1 td:first-child:before {\r\n         counter-increment: serial-number;  /* Increment the serial number counter */\r\n         content: counter(serial-number);  /* Display the counter */\r\n     }\r\n\r\n     #tb2 {\r\n         counter-reset: serial-number;  /* Set the serial number counter to 0 */\r\n     }\r\n     #tb2 td:first-child:before {\r\n         counter-increment: serial-number;  /* Increment the serial number counter */\r\n         content: counter(serial-number);  /* Display the counter */\r\n     }\r\n\r\n     #tb3 {\r\n         counter-reset: serial-number;  /* Set the serial number counter to 0 */\r\n     }\r\n     #tb3 td:first-child:before {\r\n         counter-increment: serial-number;  /* Increment the serial number counter */\r\n         content: counter(serial-number);  /* Display the counter */\r\n     }\r\n\r\n     md-datepicker .md-datepicker-input {\r\n         width: calc(22vw - 33px);\r\n         max-width: calc(35vw - 54px);\r\n         margin-left: 1px;\r\n     }\r\n\r\n      .file-input {\r\n         display: none !important;\r\n     }\r\n\r\n     /*.md-datepicker-input {\r\n         min-width: 760px;\r\n         max-width: 1500px;\r\n     }*/\r\n    /*#date1 .md-datepicker .md-datepicker-input {\r\n         min-width: 344px;\r\n         max-width: 500px;\r\n     }*/\r\n\r\n     /*md-datepicker .md-datepicker-input {\r\n         width: calc(26vw - 3px);\r\n         max-width: calc(35vw - 54px);\r\n     }*/\r\n\r\n     .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n         color: rgba(0,0,0,0.87);\r\n         background: none;\r\n     }\r\n\r\n     ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n         right: 74px;\r\n     }\r\n\r\n     .md-datepicker-button {\r\n         display: none;\r\n     }\r\n\r\n     .ta-root .ta-scroll-window.form-control {\r\n         border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n     }\r\n\r\n     .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n         min-height: 100px !important;\r\n         padding: 1px 12px !important;\r\n     }\n</style>");
$templateCache.put("app/main/apps/procurement/purchaseorder/viewrequisitionpopupdatas.html","<md-dialog style=\"width:1200px\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">PURCHASE REQUEST DATAS</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex><table \nclass=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight:bold\"><td style=\"width:10%\">CATEGORY\n</td><td style=\"width:15%\">NAME</td><td style=\"width:15%\">CODE</td><td style=\"width:20%\">DESCRIPTION</td><td \nstyle=\"width:5%\">QUANTITY</td><td style=\"width:10%\">UNITS</td></tr><tr ng-repeat=\"user in RequisitionPopupDatas\"><td>\n{{user.ProductCategory}}</td><td>{{ user.ProductName}}</td><td>{{ user.ProductCodeID}}</td><td>{{ user.Description}}\n</td><td>{{ user.Quantity}}</td><td>{{ user.Unit}}</td></tr></table></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button class=\"md-raised md-accent\" ng-click=\"PurchaseRequestSave()\">Ok\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/procurement/store/store.html","<div id=\"store\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stores</span></div><div>\n<span>Total Stores:</span> <span>{{Storedatas.length}}</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"sSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"sAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"sView\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"sExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Storegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Storedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Incharge</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Postal Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Country</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Storedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nng-click=\"Storeinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n{{ row.StoreName}}</td><td>{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.PostalCode }}</td><td>\n{{ row.Country }}</td><td>{{ row.Phone }}</td><td>{{ row.Email }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Storeinfo(row._id, $index)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Storeform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"StoreName\" ng-model=\"StoreName\" placeholder=\"Store Name\" required><div ng-messages=\"basicForm.StoreName.$error\" \nng-show=\"basicForm.StoreName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Store Name field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Incharge</label><md-select ng-model=\"Incharge\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a employee..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Incharge=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm1\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><label>Address1</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"Address1\" placeholder=\"\"><div ng-messages=\"basicForm.Address1.$error\" \nng-show=\"basicForm.Address1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Address1 field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Address2</label><input places-auto-complete \ntypes=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\" ng-model=\"Address2\" placeholder=\"\"><div \nng-messages=\"basicForm.Address2.$error\" ng-show=\"basicForm.Address2.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Address2 field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -27px\"><md-input-container flex><label>City</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"City\" placeholder=\"\"><div ng-messages=\"basicForm.City.$error\" \nng-show=\"basicForm.City.$touched\" role=\"alert\"><div ng-message=\"required\"><span>City field is required.</span></div>\n</div></md-input-container><md-input-container flex><label>State</label><input places-auto-complete \ntypes=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\" ng-model=\"State\" placeholder=\"\"><div \nng-messages=\"basicForm.State.$error\" ng-show=\"basicForm.State.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nState field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -27px\"><md-input-container flex><input type=\"number\" name=\"PostalCode\" ng-model=\"PostalCode\" \nplaceholder=\"Postal Code\"><div ng-messages=\"basicForm.PostalCode.$error\" ng-show=\"basicForm.PostalCode.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>PostalCode field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Country</label><md-select ng-model=\"Country\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a country..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Country=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in CountyList | filter:vm.searchTerm2\" value=\"{{row.name}}\">\n{{row.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -27px\"><md-input-container flex><input type=\"number\" name=\"Phone\" ng-model=\"Phone\" \nplaceholder=\"Phone\"><div ng-messages=\"basicForm.Phone.$error\" ng-show=\"basicForm.Phone.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Phone field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"email\" name=\"Email\" ng-model=\"Email\" placeholder=\"Email\"><div ng-messages=\"basicForm.Email.$error\" \nng-show=\"basicForm.Email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Email field is required.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container \nflex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"><div \nng-messages=\"basicForm.Remarks.$error\" ng-show=\"basicForm.Remarks.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Remarks field is required.</span></div></div></md-input-container></div></form><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/suppliers/BillingAddress.html","<md-dialog style=\"width:900px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Supplied Items</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Category</label><md-select ng-model=\"vm.Category\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm2\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Select Category..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Category=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Chemical\">Chemical</md-option>\n<md-option value=\"Equipment\">Equipment</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Items\" ng-model=\"vm.Item\" placeholder=\"Items\" required><div ng-messages=\"eventForm.vm.Items.$error\" \nng-show=\"eventForm.vm.Items.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Items field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"number\" name=\"Price\" ng-model=\"vm.Price\" placeholder=\"Price\"></md-input-container><md-input-container flex><input\n type=\"number\" name=\"MinimumOrder\" ng-model=\"vm.MinimumOrder\" placeholder=\"Minimum Order\"></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"ThresholdLevel\" ng-model=\"vm.ThresholdLevel\" \nplaceholder=\"Threshold Level\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex ng-if=\"vm.Category==\'Chemical\'\"><label>Unit</label><md-select ng-model=\"vm.Unit\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm5\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search Unit\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Unit = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Unitdatas | filter:vm.searchTerm5 \" \nvalue=\"{{row.UnitName}}\">{{row.UnitName}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><choose-file layout=\"row\" flex><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><div \nng-if=\"!fileName\" ng-hide=\"FilePath != null\" \nstyle=\"height:150px;width:200px;background-color: whitesmoke;border: 1px solid #efd6d6\"></div><img \nng-if=\"fileName && FilePath == null\" \nstyle=\"height:150px; width:200px;background-color: whitesmoke;border: 1px solid #efd6d6\" id=\"imagePreview\" src=\"#\" \nalt=\"No image\"> <img id=\"ItemPhoto\" ng-if=\"FilePath != null && fileName == null\" src=\"{{FilePath}}\"><div><md-button \nid=\"uploadButton\" class=\"md-raised\"><span>Upload Photo</span></md-button></div></choose-file></div><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Billingadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid \">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }\r\n\r\n    .ms-scroll {\r\n        position: relative;\r\n    }\r\n    #ItemPhoto{\r\n        height:150px !important; \r\n        width:200px !important; \r\n        border: 1px solid #efd6d6;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/suppliers/BillingAddressdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this item ?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Bdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/suppliers/SiteAddress.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">SITE ADDRESS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"ContactName\" \nng-model=\"vm.sContactName\" placeholder=\"Contact Name\" required><div ng-messages=\"eventForm.vm.sContactName.$error\" \nng-show=\"eventForm.vm.sContactName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>ContactName is required.\n</span></div></div></md-input-container></div><span class=\"h4\"><b>ADDRESS</b></span><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Street1</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"vm.sStreet1\" placeholder=\"\"><div ng-messages=\"eventForm.vm.sStreet1.$error\" \nng-show=\"eventForm.vm.sStreet1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><label>Street2</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"vm.sStreet2\" placeholder=\"\"><div ng-messages=\"eventForm.vm.sStreet2.$error\" \nng-show=\"eventForm.vm.sStreet2.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><label>City</label><input places-auto-complete types=\"[\'geocode\']\" \nng-place-changed=\"placeMarker()\" ng-model=\"vm.sCity\" placeholder=\"\"><div ng-messages=\"eventForm.vm.sCity.$error\" \nng-show=\"eventForm.vm.sCity.$touched\" role=\"alert\"><div ng-message=\"required\"><span>City field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>State</label><input places-auto-complete \ntypes=\"[\'geocode\']\" ng-place-changed=\"placeMarker()\" ng-model=\"vm.sState\" placeholder=\"\"><div \nng-messages=\"eventForm.vm.sState.$error\" ng-show=\"eventForm.vm.sState.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>State field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex><input type=\"number\" name=\"PostalCode\" \nng-model=\"vm.sPostalCode\" placeholder=\"Postal Code\"><div ng-messages=\"eventForm.vm.sPostalCode.$error\" \nng-show=\"eventForm.vm.sPostalCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>PostalCode field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Country</label><md-select \nng-model=\"vm.sCountry\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Country..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.sCountry=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in CountyList | filter:vm.searchTerm3\" value=\"{{row.name}}\">{{row.name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><input type=\"number\" name=\"Phone\" ng-model=\"vm.sPhone\" placeholder=\"Phone\"><div \nng-messages=\"eventForm.vm.sPhone.$error\" ng-show=\"eventForm.vm.sPhone.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Phone field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Mobile\" ng-model=\"vm.sMobile\" placeholder=\"Mobile\"><div \nng-messages=\"eventForm.vm.sMobile.$error\" ng-show=\"eventForm.vm.sMobile.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Mobile field is required.</span></div></div></md-input-container><md-input-container flex>\n<input type=\"email\" name=\"Email\" ng-model=\"vm.sEmail\" placeholder=\"Email\"><div \nng-messages=\"eventForm.vm.sEmail.$error\" ng-show=\"eventForm.vm.sEmail.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Email field is required.</span></div></div></md-input-container></div><span class=\"h4\"><b>\nNotes</b></span><div class=\"content fullpage-datatable\" layout=\"column\" flex><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.sNotes\"></text-angular></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Siteadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }\r\n    .ms-scroll {\r\n        position: relative;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/suppliers/SiteAddressdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this site address?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Sdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/suppliers/suppliers.html","<div id=\"supplier\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span>Suppliers</span>\n</div><div><span>Total Suppliers:</span> <span>{{Supplierdatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"sSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"sAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"sView\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"sExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Suppliergrid\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height: 40px;padding-top: 1%\"><div style=\"padding:0 1% 0 1%\"><a ng-click=\"AD()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">A - D</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"EH()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">E - H</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"IL()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">I - L</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"MP()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">M - P</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"QT()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Q - T</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"UX()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">U -X</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"YZ()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">Y -Z</a></div><md-divider vertical \nstyle=\"margin-bottom: 1%\"></md-divider><div style=\"padding:0 1% 0 1%\"><a ng-click=\"All()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold\">All</a></div></div><md-progress-linear \nng-hide=\"Supplierdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Supplier Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Contact Person</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tel</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Mobile</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Supplierdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Supplierinfo(row.id, $index)\" title=\"Detail Grid\" style=\"border:none;cursor: pointer\">{{ row.ReferenceNo }}\n</a></td><td>{{ row.Name}}</td><td>{{ row.ContactPerson }}</td><td>{{ row.Phone }}</td><td>{{ row.Mobile }}</td><td>\n{{ row.Email }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Supplierinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td><md-button ng-disabled=\"row.Equipmentdetails>0 || row.chemicaldetails>0\" id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"SupplierDelete(row.id)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Supplierform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-radio-group ng-model=\"sServiceStatus\" \nlayout=\"row\"><md-radio-button value=\"Company\">Company</md-radio-button><md-radio-button value=\"Individual\">Individual\n</md-radio-button></md-radio-group></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"Name\" ng-model=\"sName\" placeholder=\"Name\" required><div ng-messages=\"basicForm.sName.$error\" \nng-show=\"basicForm.sName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required.</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Address\n</label><input type=\"text\" ng-model=\"sStreet1\" placeholder=\"\" required><div ng-messages=\"basicForm.sStreet1.$error\" \nng-show=\"basicForm.sStreet1.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Address field is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"PostalCode\" ng-model=\"sPostalCode\" \nplaceholder=\"Postal Code\"><div ng-messages=\"basicForm.sPostalCode.$error\" ng-show=\"basicForm.sPostalCode.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>PostalCode field is required.</span></div></div></md-input-container>\n<md-input-container flex><label>Country</label><md-select ng-model=\"sCountry\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a country..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"sCountry=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in CountyList | filter:vm.searchTerm1\" value=\"{{row.name}}\">\n{{row.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex \nstyle=\"margin-top: -17px\"><md-chips style=\"width: 100% !important ; height: 13% !important\" ng-model=\"sPhone\" \nname=\"ContactNum\" md-separator-keys=\"vm.keys\" input-aria-label=\"ContactNum\"><input type=\"number\" name=\"ContactNum\" \nplaceholder=\"Tel\"></md-chips></div><div layout=\"column\" layout-gt-sm=\"row\" flex style=\"margin-top: 27px\"><md-chips \nstyle=\"width: 100% !important ; height: 13% !important\" ng-model=\"sEmail\" name=\"ContactNum\" \nmd-separator-keys=\"vm.keys\" input-aria-label=\"ContactNum\"><input type=\"text\" name=\"ContactNum\" placeholder=\"Email\">\n</md-chips></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 27px\"><md-input-container flex><input \ntype=\"text\" name=\"ContactPerson\" ng-model=\"sContactPerson\" placeholder=\"Contact Person\"><div \nng-messages=\"basicForm.ContactPerson.$error\" ng-show=\"basicForm.ContactPerson.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Contact Person is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"JobPosition\" ng-model=\"sJobPosition\" placeholder=\"Job Position\"><div \nng-messages=\"basicForm.sJobPosition.$error\" ng-show=\"basicForm.sJobPosition.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Job Position field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"number\" name=\"Mobile\" ng-model=\"sMobile\" placeholder=\"Mobile\"><div \nng-messages=\"basicForm.sMobile.$error\" ng-show=\"basicForm.sMobile.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Mobile field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" name=\"Fax\" ng-model=\"sFax\" placeholder=\"Fax\"><div\n ng-messages=\"basicForm.sFax.$error\" ng-show=\"basicForm.sFax.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nFax field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Website\" ng-model=\"sWebsite\" placeholder=\"Website\"><div ng-messages=\"basicForm.sWebsite.$error\" \nng-show=\"basicForm.sWebsite.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Website field is required.</span>\n</div></div></md-input-container><md-input-container flex><label>Payment Terms</label><md-select \nng-model=\"sPaymentTerms\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a payment terms..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"sPaymentTerms=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in PaymentTermdatas | filter:vm.searchTerm2\" \nvalue=\"{{row.PaymentTermName}}\">{{row.PaymentTermName}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex><label>Category</label><md-select\n ng-model=\"sSupplyList\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for Category..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"sSupplyList=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Categorydatas | filter:vm.searchTerm2\" value=\"{{row.CategoryName}}\">\n{{row.CategoryName}}</md-option></md-select></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span>Items they Supply</span></md-tab-label><md-tab-body><div \nlayout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"Billingpopup($event, UniqueID)\"><span>Add</span></md-button></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Items</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Remarks</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in SupplierItemdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><img class=\"product-image\" \nng-src=\"{{UploadsURL + \'Procurement/SupplierItems/\'+row._id+\'.png\'}}\"></td><td>{{ row.Category}}</td><td>{{ row.Item}}\n</td><td>{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Billingupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Billingdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></md-tab-body></md-tab><md-tab ng-if=\"Update==true\"><md-tab-label>\n<span>Purchase History</span></md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions1\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delivery Order No.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Received Item</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Deliverynotedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo}}\n</td><td>{{ row.DODate | date:\'dd/m/y h:mm a\'}}</td><td>{{ row.Description }}</td><td>{{ row.Quantity }}</td><td>\n{{ row.TotalPrice }}</td></tr></tbody></table></md-tab-body></md-tab></md-tabs></div></form><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n    .product-image {\r\n                            width: 52px;\r\n                            height: 52px;\r\n                            border: 1px solid rgba(0, 0, 0, 0.12);\r\n                        }\n</style>");
$templateCache.put("app/main/apps/procurement/vehicle/addvehiclelogs.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Vehicle Log</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"AddVehicleLogForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.SelectDate\" md-date-format=\"dd/MM/y\" required>\n</md-datepicker></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Millage\" \nplaceholder=\"Millage\" required></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.CallCost\" \nplaceholder=\"Call Cost\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nflex><input type=\"text\" ng-model=\"vm.LRemarks\" placeholder=\"Remarks\"></md-input-container><choose-file layout=\"row\" \nflex><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container flex class=\"md-block\"><input type=\"text\" \nng-model=\"fileName\" readonly=\"readonly\" placeholder=\"File Name\"></md-input-container><div><md-button id=\"uploadButton\" \nclass=\"md-raised\"><span>Upload Document</span></md-button><md-button id=\"clearButton\" ng-click=\"fileName=null\" \nclass=\"md-raised\"><span>Clear</span></md-button></div></choose-file></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" \nng-disabled=\"AddVehicleLogForm.$invalid\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SubmitVehicleLog()\" aria-label=\"Ok\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\">Cancel</md-button></div></form></md-dialog-content></md-dialog><style>\n/* .md-datepicker-button {\r\n            display: none;\r\n        }\r\n    \r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 85px;\r\n        } */\r\n    \r\n        /* md-datepicker .md-datepicker-input {\r\n            width: calc(15vw - 20px);\r\n            max-width: calc(15vw - 20px);\r\n            margin-left: -11px;\r\n        } */\r\n        .md-datepicker-input {\r\n        min-width: 25px !important;\r\n        max-width: 200px;\r\n    }\r\n\r\n        .file-input {\r\n        display: none !important;\r\n    }\r\n    md-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n  }\n</style>");
$templateCache.put("app/main/apps/procurement/vehicle/detailgrid.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">VEHICLE DETAILS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Type</label><md-select ng-model=\"Type\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm1\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Type..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Type=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in TypeList | filter:vm.searchTerm1\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Description\" \nplaceholder=\"Service Description\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" ng-model=\"TotalCost\" placeholder=\"Total Cost\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\" id=\"date2\"><label>Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"CompletedDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:-27px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"Details\" placeholder=\"Remarks\"></md-input-container><md-input-container flex><label>Status\n</label><md-select ng-model=\"Status\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Status..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"Status=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in StatusList | filter:vm.searchTerm2\" value=\"{{row.name}}\">{{row.name}}\n</md-option></md-select></md-input-container></div><choose-file layout=\"row\" flex ng-if=\"AttachOff == false\"><input \nid=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container flex class=\"md-block\"><input type=\"text\" \nng-model=\"fileName\" readonly=\"readonly\" placeholder=\"File Name\"></md-input-container><div><md-button id=\"uploadButton\" \nclass=\"md-raised\"><span>Upload Document</span></md-button><md-button id=\"clearButton\" ng-click=\"fileName=null\" \nclass=\"md-raised\"><span>Clear</span></md-button></div></choose-file><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitVehicleLog()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div><div ng-if=\"AttachOff == true\"><div style=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\">\n<b>ATTACHMENT :</b></span></div><div class=\"white-bg md-whiteframe-4dp\" style=\"border:1px solid rgb(224, 224, 224)\">\n<table id=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>1.</td><td><a href=\"{{UploadsURL}}Procurement/Vehicle/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y\' }}</td></tr></tbody></table></div></div></md-dialog-content></form></md-dialog>\n<style>\n#date2 .md-datepicker-input {\r\n        min-width: 460px !important;\r\n    }\r\n    .ms-scroll{\r\n     position: relative;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/vehicle/vehicle.html","<div id=\"vehicle\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bus\"></md-icon><span>Vehicle Management</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"vSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"vAdd\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"vView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"vExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Vehiclegrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Vehicledatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Vehicle Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Assigned Driver</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Manufacturer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Chasis Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Model</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Purchase Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Servicing Needed</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Vehicledatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Vehicleinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.VehicleNumber }}</a></td><td>{{ row.AssignedDriver}}</td><td>\n{{ row.ChasisNumber }}</td><td>{{ row.Manufacturer }}</td><td>{{ row.Model }}</td><td>\n{{ row.PurchaseDate | date:\'dd/MM/y\' }}</td><td>{{ row.ServiceNeed }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"VehicleDelete(row._id)\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Vehicleform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"VehicleNumber\" ng-model=\"VehicleNumber\" placeholder=\"Vehicle Number\" required><div \nng-messages=\"basicForm.VehicleNumber.$error\" ng-show=\"basicForm.VehicleNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Vehicle Number field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"AssignedDriver\" ng-model=\"AssignedDriver\" \nplaceholder=\"Assigned Driver\"><div ng-messages=\"basicForm.AssignedDriver.$error\" \nng-show=\"basicForm.AssignedDriver.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nAssigned Driver field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Manufacturer\" ng-model=\"Manufacturer\" placeholder=\"Manufacturer\"><div \nng-messages=\"basicForm.Manufacturer.$error\" ng-show=\"basicForm.Manufacturer.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Manufacturer field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" name=\"Model\" \nng-model=\"Model\" placeholder=\"Model\"><div ng-messages=\"basicForm.Model.$error\" ng-show=\"basicForm.Model.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Model field is required.</span></div></div></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>Purchase Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"PurchaseDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"ChasisNumber\" ng-model=\"ChasisNumber\" placeholder=\"Chasis Number\">\n<div ng-messages=\"basicForm.ChasisNumber.$error\" ng-show=\"basicForm.ChasisNumber.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Chasis Number field is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" name=\"Color\" \nng-model=\"Color\" placeholder=\"Auto/Manual\"><div ng-messages=\"basicForm.Color.$error\" \nng-show=\"basicForm.Color.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Auto/Manual field is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"Remarks\"><div ng-messages=\"basicForm.Remarks.$error\" ng-show=\"basicForm.Remarks.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Remarks field is required.</span></div></div></md-input-container></div><div \nstyle=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\"><b>Vehicle Logs:</b></span><md-button id=\"viewedit\" \nclass=\"md-raised md-button md-default-theme\" aria-label=\"Custom Icon Button\" ng-click=\"popupClick($event,SID)\" \nstyle=\"float:right\">Add</md-button></div><md-progress-linear ng-hide=\"vm.Vehicledetaildatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Completed Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Details</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in vm.Vehicledetaildatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Type }}</td><td>\n{{ row.Description}}</td><td>{{ row.TotalCost}}</td><td>{{ row.CompletedDate | date:\'dd/MM/y\'}}</td><td>\n{{ row.Details }}</td><td>{{ row.Status }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Vehicledetailinfo(row._id,$event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"vSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  /*md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }*/\r\n  .md-datepicker-input {\r\n    min-width: 300px !important;\r\n    max-width: 1000px;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\n</style>");
$templateCache.put("app/main/pages/administration/certification/certification.html","<div id=\"certification\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"certification-container\" \nstyle=\"padding-top:10px\"><md-button class=\"print md-accent-bg\" id=\"printpagebutton\" ng-click=\"Back()\" \nstyle=\"float: left\"><span translate=\"INVOICE.BACK\">Back</span></md-button><md-button class=\"print md-accent-bg\" \nid=\"printpagebutton1\" ng-click=\"printToCart(\'certification\')\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span translate=\"INVOICE.PRINT\">Print</span></md-button><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton2\" ng-click=\"Save()\" style=\"float: right\"><span translate=\"INVOICE.SAVE\">\nSave</span></md-button><div class=\"card md-whiteframe-4dp\" id=\"printe\"><div class=\"content\" id=\"rcorners2\"><div \nstyle=\"text-align:center;font-size:60px;font-weight:600;color:red\"><b>{{\'INVOICE.CERTIFICATE\'|translate}}</b><br><b>\n{{\'INVOICE.OF\'|translate}}</b><br><b>{{\'INVOICE.ACHIEVEMENT\'|translate}}</b><br></div><br><material-input-group \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><span class=\"contentcolor\" \nstyle=\"text-align:center;font-size:17px;color:black;padding-left:400px\">{{Name}}</span></material-input-group><br><div \nclass=\"onprint1\" style=\"text-align:justify;font-size:20px;font-weight:600;padding-left:150px\">\n&emsp;&emsp; &emsp;{{\'INVOICE.SUCCESSFULLY COMPLETED THE TRAINING PROGRAM OF\'|translate}}<br>\n{{\'INVOICE.THE INTRODUCTORY TRAINING SERIES FOR NEW SERVICE TECHNICIANS\'|translate}}</div><br><br><div class=\"onprint\">\n<div class=\"material-input-group-theme-light\" style=\"height: 60px;padding-left:235px\" layout=\"horizontal\"><span \nstyle=\"text-align:center;font-size:17px;color:black; font-style:italic;padding: 0 20px\">{{\'INVOICE.FROM\'|translate}} :\n</span> <span style=\"text-align:center;font-size:17px;color:black\">{{From | date:\'dd/MM/y\'}}</span> <span \nstyle=\"text-align:center;font-size:17px;color:black; font-style:italic;padding: 0 20px\">{{\'INVOICE.TO\'|translate}} :\n</span> <span style=\"text-align:center;font-size:17px;color:black\">{{To| date:\'dd/MM/y\'}}</span></div></div><div \nstyle=\"text-align:center;height:110px\"><img src=\"assets/images/logos/pest_logo.png\" style=\"height:76px\"></div><div \nclass=\"verticalspace\"></div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"padding: 25px;float:left\"><span style=\"font-size:20px;padding-left:30px\"><b>{{CEO}} </b></span><br><span \nstyle=\"font-size:16px;padding-left:70px\">{{\'INVOICE.CHAIRMAN & CEO\'|translate}}</span></div><div \nstyle=\"padding: 25px;float:right\"><span style=\"font-size:20px;padding-right:70px\"><b>{{Trainer}} </b></span><br><span \nstyle=\"font-size:16px;padding-right:70px\">{{\'INVOICE.TRAINER\'|translate}}</span></div></div></div></div><div \nstyle=\"padding-left:40%\"><md-button class=\"md-accent-bg\" id=\"printpagebutton3\" ng-click=\"Back()\"><span \ntranslate=\"INVOICE.BACK\">Back</span></md-button><md-button class=\"md-accent-bg\" id=\"printpagebutton4\" \nng-click=\"Save()\"><span translate=\"INVOICE.SAVE\">Save</span></md-button></div></div></div><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n    #rcorners2 {\r\n    border-radius: 25px;\r\n    border: 3px solid #b0b0b0;\r\n} \r\n    .verticalspace{\r\n        height:150px;\r\n    }\r\n\r\n    md-select:not([disabled]):focus .md-select-value{\r\n      border-bottom:none;  \r\n}\r\n    md-select.md-default-theme .md-select-value, md-select .md-select-value {\r\n          margin-bottom: 0px;\r\n      font-size:20px;\r\n        font-weight: bold;\r\n       border-bottom:none;\r\n    }\r\n    .md-select-value .md-select-icon:after {\r\n        display: none;\r\n    }\r\n    md-input-container > md-select {\r\n    margin-bottom: -19px;\r\n      font-size:20px;\r\n    font-weight: bold;\r\n       border-bottom:none;\r\n}\n</style>");
$templateCache.put("app/main/pages/administration/evaluation/evaluation.html","<div id=\"evaluation\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"evaluation-container\" \nstyle=\"padding-top:10px\"><md-button class=\"print md-accent-bg\" id=\"printpagebutton\" ng-click=\"Back()\" \nstyle=\"float: left\"><span translate=\"INVOICE.BACK\">Back</span></md-button><md-button class=\"print md-accent-bg\" \nid=\"printpagebutton1\" ng-disabled=\"!SID\" ng-click=\"printToCart(\'INVOICE\')\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span translate=\"INVOICE.PRINT\">Print</span></md-button><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton2\" ng-click=\"Save()\" style=\"float: right\"><span translate=\"INVOICE.SAVE\">\nSave</span></md-button><div class=\"card md-whiteframe-8dp\" id=\"printe\"><div class=\"header\"><div \nstyle=\"text-align:left\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\">\n</div></div><div class=\"content\"><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>\n{{\'INVOICE.HEADER\'|translate}}</b></div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"column\"><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">{{\'INVOICE.NAME\'|translate}}</p><span \nstyle=\"text-align:center;font-size:17px;color:black\">{{Name}}</span></material-input-group><br><material-input-group \nclass=\"material-input-group-theme-light\" style=\"height: 60px\" layout=\"horizontal\"><p flex=\"20\">\n{{\'INVOICE.TRAINING DATE\'|translate}}</p><span translate=\"INVOICE.FROM\" \nstyle=\"text-align:center;font-size:17px;color:black; font-style:italic;padding: 0 20px 0 0px\">From :</span> <span \nstyle=\"text-align:center;font-size:17px;color:black\">: {{From | date:\'dd/MM/y\'}}</span> <span translate=\"INVOICE.TO\" \nstyle=\"text-align:center;font-size:17px;color:black; font-style:italic;padding: 0 20px\">To :</span> <span \nstyle=\"text-align:center;font-size:17px;color:black\">: {{To| date:\'dd/MM/y\'}}</span></material-input-group>\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\n{{\'INVOICE.TYPE OF TRAINING\'|translate}} :</p><span style=\"text-align:center;font-size:17px;color:black\">\n{{TypeofTraining}}</span></material-input-group></div></form><div \nstyle=\"text-align:justify;font-size:15px;font-style: italic\">\n{{\'INVOICE.PLEASE COMPLETE THIS EVALUATION FORM. YOUR FRANK FEEDBACK WILL HELP US IMPROVE. PLEASE CIRCLE THE APPROPRIATE GRADING. THANK YOU\'|translate}}.\n<br></div><br><br><div class=\"ecursor\"><div style=\"text-align:justify;font-size:17px\">\n1. {{\'INVOICE.HOW USEFUL WAS THIS TRAINING TO YOU\'|translate}}?<br><md-radio-group layout=\"row\" class=\"radiocustom\" \nng-model=\"TE1\"><md-radio-button value=\"usefulv\" class=\"radiobuttoncustom\">\n{{\'INVOICE.VERY USEFUL\'|translate}}&nbsp;&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"useful4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"useful3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"useful2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"useful1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"usefull\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.LEAST USEFUL\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">2. {{\'INVOICE.KNOWLEDGE GAINED DURING TRAINING WAS\'|translate}}<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\" ng-model=\"TE2\"><md-radio-button value=\"gainedv\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.MUCH GAINED\'|translate}}&nbsp;&nbsp;&nbsp;</md-radio-button><md-radio-button \nvalue=\"gained4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"gained3\" \nclass=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"gained2\" class=\"radiobuttoncustom\">2\n</md-radio-button><md-radio-button value=\"gained1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button \nvalue=\"gainedl\" class=\"radiobuttoncustom\">{{\'INVOICE.LEAST GAINED\'|translate}}</md-radio-button></md-radio-group></div>\n<div style=\"text-align:justify;font-size:17px\">\n3. {{\'INVOICE.HOW WELL WILL THE CONCEPTS PRESENTED IN THIS TRAINING HELP YOU IN YOUR WORK\'|translate}}?<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\" ng-model=\"TE3\"><md-radio-button value=\"conceptsv\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.VERY USEFUL\'|translate}}&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button \nvalue=\"concepts4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"concepts3\" \nclass=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"concepts2\" class=\"radiobuttoncustom\">2\n</md-radio-button><md-radio-button value=\"concepts1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button \nvalue=\"conceptsl\" class=\"radiobuttoncustom\">{{\'INVOICE.LEAST USEFUL\'|translate}}</md-radio-button></md-radio-group>\n</div><div style=\"text-align:justify;font-size:17px\">\n4. {{\'INVOICE.HOW WELL DID THE HANDOUTS AND/OR OTHER MATERIALS AID YOUR UNDERSTANDING\'|translate}}?<br><md-radio-group \nlayout=\"row\" class=\"radiocustom\" ng-model=\"TE4\"><md-radio-button value=\"handoutsv\" class=\"radiobuttoncustom\">\n{{\'INVOICE.VERY WELL\'|translate}}&emsp;&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"handouts4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"handouts3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"handouts2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"handouts1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"handoutsl\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.NOT AT ALL\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n5. {{\'INVOICE.THERE WERE SUFFICIENT TEST QUESTIONS TO TEST MY UNDERSTANDING\'|translate}}<br><md-radio-group \nlayout=\"row\" class=\"radiocustom\" ng-model=\"TE5\"><md-radio-button value=\"sufficientv\" class=\"radiobuttoncustom\">\n{{\'INVOICE.STRONGLY AGREE\'|translate}}</md-radio-button><md-radio-button value=\"sufficient4\" class=\"radiobuttoncustom\">\n4</md-radio-button><md-radio-button value=\"sufficient3\" class=\"radiobuttoncustom\">3</md-radio-button><md-radio-button \nvalue=\"sufficient2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button value=\"sufficient1\" \nclass=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"sufficientl\" class=\"radiobuttoncustom\">\n{{\'INVOICE.STRONGLY DISAGREE\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n6. {{\'INVOICE.THE TESTS QUESTIONS WERE WELL STRUCTURED AND RELEVANT\'|translate}}<br><md-radio-group layout=\"row\" \nclass=\"radiocustom\" ng-model=\"TE6\"><md-radio-button value=\"testsv\" class=\"radiobuttoncustom\">\n{{\'INVOICE.STRONGLY AGREE\'|translate}}</md-radio-button><md-radio-button value=\"tests4\" class=\"radiobuttoncustom\">4\n</md-radio-button><md-radio-button value=\"tests3\" class=\"radiobuttoncustom\">3</md-radio-button><md-radio-button \nvalue=\"tests2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button value=\"tests1\" class=\"radiobuttoncustom\">1\n</md-radio-button><md-radio-button value=\"testsl\" class=\"radiobuttoncustom\">{{\'INVOICE.STRONGLY DISAGREE\'|translate}}\n</md-radio-button></md-radio-group></div><div style=\"text-align:justify;font-size:17px\">\n7. {{\'INVOICE.THE DURATION OF THE COURSE\'|translate}}<br><md-radio-group layout=\"row\" class=\"radiocustom\" \nng-model=\"TE7\"><md-radio-button value=\"durationv\" class=\"radiobuttoncustom\">\n{{\'INVOICE.TOO LONG\'|translate}}&emsp;&emsp;&nbsp;</md-radio-button><md-radio-button value=\"duration4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"duration3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"duration2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"duration1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"durationl\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.TOO SHORT\'|translate}}</md-radio-button></md-radio-group></div><div \nclass=\"onprint\" style=\"text-align:justify;font-size:17px\">8. {{\'INVOICE.OVERALL RATING OF THE LECTURER\'|translate}}<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\" ng-model=\"TE8\"><md-radio-button value=\"Overallv\" \nclass=\"radiobuttoncustom\">{{\'INVOICE.EXCELLENT\'|translate}}&emsp;&emsp;&nbsp;</md-radio-button><md-radio-button \nvalue=\"Overall4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"Overall3\" \nclass=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"Overall2\" class=\"radiobuttoncustom\">2\n</md-radio-button><md-radio-button value=\"Overall1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button \nvalue=\"Overalll\" class=\"radiobuttoncustom\">{{\'INVOICE.POOR\'|translate}}</md-radio-button></md-radio-group></div></div>\n<div style=\"text-align:justify;font-size:17px\"><h3>\n9.{{\'INVOICE.WHAT PORTION OF THE TRAINING DID YOU REALLY ENJOY/DISLIKE AND FOR WHAT REASON/S\'|translate}}?</h3>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"TE9\"></text-angular><h3>\n10. {{\'INVOICE.WHAT SUGGESTIONS WOULD YOU MAKE TO IMPROVE THIS TRAINING IN THE FUTURE\'|translate}}?</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"TE10\"></text-angular></div><br><div \nstyle=\"text-align:justify;font-size:16px;font-weight:600\">\n{{\'INVOICE.THANK YOU FOR YOUR CO-OPERATION IN COMPLETING THIS TRAINING EVALUATION FEEDBACK\'|translate}}.</div></div>\n<div class=\"footer\"></div></div><div style=\"padding-left:40%\"><md-button class=\"md-accent-bg\" id=\"printpagebutton3\" \nng-click=\"Back()\"><span translate=\"INVOICE.BACK\">Back</span></md-button><md-button class=\"md-accent-bg\" \nid=\"printpagebutton4\" ng-click=\"Save()\"><span translate=\"INVOICE.SAVE\">Save</span></md-button></div></div></div><style>\n.radiocustom{\r\n        padding-left:45px;\r\n          padding-top:10px;\r\n            padding-bottom:20px;\r\n    }\r\n.radiobuttoncustom{\r\n          padding-right:20px;\r\n    }\r\n.ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87)!important;\r\n    }\r\n\r\n.ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 120px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n .md-datepicker-button {\r\n  display: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n}\r\n.numberCircle {\r\n    width: 40px;\r\n    height: 25px;\r\n    padding: 4px;\r\n    float:right;\r\n    background: #fff;\r\n    border: 1px solid #666;\r\n    text-align: center;\r\n    margin-top: 15px;\r\n    font: 12px Arial, sans-serif;\r\n    cursor: pointer;\r\n}\r\n\r\n  div .numberCircle:hover {\r\n  background: #AAB7B8;\r\n}\r\n  .ecursor  p:hover {\r\n    color:forestgreen;\r\n    font-weight:400;\r\n}\n</style>");
$templateCache.put("app/main/pages/administration/monitoring/monitoring.html","<div id=\"monitoring\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" style=\"padding-left: 40px\" layout-align=\"start center\"><span>Training Monitoring</span></div></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Form</span>\n</md-tab-label><md-tab-body><div class=\"monitoring-container\" style=\"padding-top:0px;margin-top: -15px\"><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton\" ng-click=\"printToCart(\'monitoring\')\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span>Print</span></md-button><div class=\"card md-whiteframe-8dp\" \nid=\"monitoring1\"><div class=\"header\"><div style=\"text-align:left\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img\n src=\"assets/images/logos/pest_logo.png\"></div></div><div class=\"content\"><div \nstyle=\"text-align:center;font-size:20px;font-weight:600\"><b>\nIntroductory Training Series for New Service Technician – Training Monitoring Form</b></div><br><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"column\"><material-input-group \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Name of Staff</p><md-input-container \nstyle=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uName\" flex=\"40\"></md-input-container></material-input-group>\n<material-input-group style=\"height: 60px\" class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\nDate of Training</p><md-input-container style=\"margin-top: 8px;margin-left: -12px\" flex=\"20\"><md-datepicker \nng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></material-input-group>\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Dept. & Job Title</p>\n<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"40\">\n</md-input-container></material-input-group></div></form><br><br><div style=\"text-align:justify;font-size:17px\">\n1. Please complete Section I of this form BEFORE attending the training.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">\n2. Bring this form along on the 1st day of training for the trainer’s attention.</div><br><div \nstyle=\"font-weight:600;font-size:17px\">Section I: Pre – Course Training Brief (Superior)</div><br><div \nstyle=\"font-size:17px\">\nSelect any 02 of the following learning objectives that you wish your staff to acquire during and after the course of their training.\n</div><br><table style=\"border: 1px solid #a5a5a5\" width=\"100%;\"><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">01</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td1\" ng-click=\"td1()\">\nWhen is an animal or an insect defined as a pest?</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">02</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td2\" ng-click=\"td2()\">\nWhat is a pest?</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">03</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td3\" ng-click=\"td3()\">\nWhat are non-chemical control methods</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">04</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td4\" ng-click=\"td4()\">\nThe benefits of using a combination of all available</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">05</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td5\" ng-click=\"td5()\">\nWhy are we required to correctly identify pests</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">06</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td6\" ng-click=\"td6()\">\nThe 10 most unwanted pests</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">07</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td7\" ng-click=\"td7()\">\nWhat are pesticides and their role in pest managemen</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">08</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td8\" ng-click=\"td8()\">\nThe type of pesticides</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">09</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td9\" ng-click=\"td9()\">\nThe importance of on the job safety and the different hazards</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">10</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" id=\"td10\" ng-click=\"td10()\">\nThe need for good customer relations</td></tr></table><br><br><div class=\"onprint\" \nstyle=\"font-weight:600;font-size:17px\">Section II: Transfer of Learning (Trainee)</div><br><div style=\"font-size:17px\">\n1. Were you able to learn the options your superior chose above before the commencement of training?</div><br><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group layout=\"row\" \nclass=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button><md-radio-button \nvalue=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-size:17px\">2. Will you be able to apply what you have learnt during the course of your training at work?\n</div><br><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button>\n<md-radio-button value=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-weight:600;font-size:17px\">Section III: Training Achievement (Superior)</div><br><div \nstyle=\"font-size:17px\">This training has / has not been successful for the staff.</div><br><div style=\"font-size:17px\">\n&emsp; If no, please state reasons<br><textarea style=\"border:1px solid black\" ng-model=\"Questionnaire2\"></textarea>\n</div></div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Advance Training Monitoring Form</span></md-tab-label><md-tab-body><div \nclass=\"monitoring-container\" style=\"padding-top:0px;margin-top: -15px\"><md-button class=\"print md-accent-bg\" \nid=\"printpagebutton\" ng-click=\"printToCart(\'monitoring\')\" style=\"float: right\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span>Print</span></md-button><div class=\"card md-whiteframe-8dp\" id=\"monitoring\"><div class=\"header\"><div \nstyle=\"text-align:left\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\">\n</div></div><div class=\"content\"><div style=\"text-align:center;font-size:20px;font-weight:600\"><b>\nAdvance Training Monitoring Form</b></div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"column\"><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">Name of Staff</p><md-input-container style=\"margin-top: 8.5px\" flex><input \ntype=\"text\" ng-model=\"uName\" flex=\"40\"></md-input-container></material-input-group><material-input-group \nstyle=\"height: 60px\" class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Date of Training</p>\n<md-input-container style=\"margin-top: 8.5px;margin-left: -12px\" flex=\"20\"><md-datepicker \nng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></material-input-group>\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Dept. & Job Title</p>\n<md-input-container style=\"margin-top: 8.5px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"40\">\n</md-input-container></material-input-group></div></form><br><br><div style=\"text-align:justify;font-size:17px\">\n1. Please complete Section I of this form BEFORE attending the training.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">\n2. Bring this form along on the 1st day of training for the trainer’s attention.</div><br><div \nstyle=\"font-weight:600;font-size:17px\">Section I: Pre – Course Training Brief (Superior)</div><br><div \nstyle=\"font-size:17px\">\nSelect any 02 of the following learning objectives that you wish your staff to acquire during and after the course of their training.\n</div><br><table style=\"border: 1px solid #a5a5a5\" width=\"100%;\"><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">01</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nDifferences between the German and American Cockroaches</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">02</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe Life Cycle of Cockroaches</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">03</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nComparison between the Roof Rat and Sewer Rat</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">04</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe Life Cycle of Rodents</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">05</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nTypes of Termites</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">06\n</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nInspection for Termites</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">07</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nCommon Flies in F&B Areas</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">08</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">Fly management\n</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">09</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nManagement of Ants</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">\n10</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nInspection for Ants</td></tr></table><br><br><div style=\"font-weight:600;font-size:17px\">\nSection II: Transfer of Learning (Trainee)</div><br><div style=\"font-size:17px\">\n1. Were you able to learn the options your superior chose above before the commencement of training?</div><br><div \nclass=\"onprint\" layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button>\n<md-radio-button value=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-size:17px\">2. Will you be able to apply what you have learnt during the course of your training at work?\n</div><br><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button>\n<md-radio-button value=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-weight:600;font-size:17px\">Section III: Training Achievement (Superior)</div><br><div \nstyle=\"font-size:17px\">This training has / has not been successful for the staff.</div><br><div style=\"font-size:17px\">\n&emsp; If no, please state reasons<br><textarea style=\"border:1px solid black\" ng-model=\"Questionnaire2\"></textarea>\n</div></div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Commitment Form</span></md-tab-label><md-tab-body><div class=\"monitoring-container\" \nstyle=\"padding-top:0px;margin-top: -15px\"><md-button class=\"print md-accent-bg\" id=\"printpagebutton\" \nng-click=\"printToCart(\'monitoring\')\" style=\"float: right\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span>Print\n</span></md-button><div class=\"card md-whiteframe-8dp\" id=\"monitoring\"><div class=\"header\"><div \nstyle=\"text-align:left\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\">\n</div></div><div class=\"content\"><div style=\"text-align:center;font-size:20px;font-weight:600\"><b>\nPESTBUSTERS TRAINING COMMITMENT FORM</b></div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"column\"><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">Name</p><md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" \nng-model=\"uName\" flex=\"40\"></md-input-container></material-input-group><material-input-group style=\"height: 60px\" \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Date</p><md-input-container \nstyle=\"margin-top: 8px;margin-left: -12px\" flex=\"20\"><md-datepicker ng-model=\"formData.uExpiryDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></material-input-group><material-input-group \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Re / Type of Training</p><md-input-container \nstyle=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"40\"></md-input-container>\n</material-input-group></div></form><br><br><div style=\"text-align:justify;font-size:17px\">I,&emsp;<md-input-container \nstyle=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>\n(Name as in NRIC/Passport), holder of<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" \nng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>\n(NRIC/FIN No.) sincerely pledge my commitment for the above sponsored training.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">Therefore I pledge:<br><br>\n&emsp;&emsp;&emsp;&nbsp; 1) To attain and abide by all Company’s and government’s regulatory requirements and procedures.\n<br><br>&emsp;&emsp;&emsp;&nbsp;2) To pass the examinations, otherwise I’ll bear the cost for a second attempt, if any.\n<br><br>\n&emsp;&emsp;&emsp;&nbsp;3) Not to resign within three (03) months from the date of receiving the examination results.\n<br><br>\nIn the event I fail to comply with any of the above, I am aware that I’ll be required to bear the full amount of the cost for this training.\n<br>The cost of this training amounts to $<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" \nng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>.<br>\nFurthermore, I shall not absent myself from the above training without prior approval of the Company’s management and the HR Department. Any such absences should be supported by documentary proof that must be accepted by the training institution and or SDF.\n<br><br>Where assignments, projects, etc. are concerned, I’ll submit a copy to the Company.</div><br><br><div>\n<md-input-container style=\"width: 300px;height: 25px\"><input type=\"text\" ng-model=\"uName\"></md-input-container><br>\n<span style=\"font-size:16px;padding-left:0px;font-style:italic\"><b>Signature (Trainee) & Date </b></span><br></div><br>\n<br><div><md-input-container style=\"width: 300px;height: 25px\"><input type=\"text\" ng-model=\"uName\">\n</md-input-container><br><span style=\"font-size:16px;padding-left:0px;font-style:italic\"><b>\nSignature (Head, HC Department) & Date </b></span><br></div></div></div><div class=\"footer\"></div></div><div \nclass=\"page-break\"></div></md-tab-body></md-tab></md-tabs></div></div><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(23vw - 35px);\r\nmax-width: calc(35vw - 54px);\r\n}\r\ntable {\r\nborder-collapse: collapse; \r\n}\r\npage-layout.simple.tabbed > .content > md-tabs > md-tabs-content-wrapper > md-tab-content {\r\npadding: 0px;\r\nmargin-left: -5px\r\n}\r\n.tdthumbnail > td:hover {\r\nbackground: #eee;\r\n}\r\n.md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74px;\r\n}\r\ntextarea {\r\nwidth: 100%;\r\nheight: 100px;\r\npadding: 12px 20px;\r\nresize: none;\r\n}\r\n.numberCircle {\r\nwidth: 40px;\r\nheight: 25px;\r\npadding: 4px;\r\nfloat: right;\r\nbackground: #fff;\r\nborder: 1px solid #666;\r\ntext-align: center;\r\nmargin-top: 15px;\r\nfont: 12px Arial, sans-serif;\r\n}\r\n.verticalspace {\r\nheight: 200px;\r\n}\r\nmd-radio-button .md-label {\r\nbox-sizing: border-box;\r\nposition: relative;\r\ndisplay: inline-block;\r\nmargin-left: 35px;\r\nmargin-top: 25px;\r\nfont-size: 16px;\r\nmargin-right: 0;\r\nvertical-align: middle;\r\nwhite-space: normal;\r\npointer-events: none;\r\nwidth: auto;\r\n}\n</style>");
$templateCache.put("app/main/apps/procurement/uniformrequisition/uniformrequisition.html","<div id=\"uniformrequisition\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><span>Email Logs</span></div><div \nclass=\"product-count secondary-text\"><span>Total data:</span> <span>{{workOrd.length}}</span></div></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab \nng-click=\"workOrd=SEmaillogdatas ; SucessLog()\"><md-tab-label><span>Email Sent</span></md-tab-label><md-tab-body><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PendingSchedulespinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridPending\"></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=FEmaillogdatas;FailedLog()\"><md-tab-label><span>Email Failed</span></md-tab-label><md-tab-body><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridCollected\"></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><img src=\"{{logo}}\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">\nRecover your password</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"LoginID\" ng-model=\"uLoginID\" placeholder=\"LoginID\" required><div \nng-messages=\"forgotPasswordForm.LoginID.$error\" ng-show=\"forgotPasswordForm.LoginID.$touched\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>LoginID is required</span></div></div></md-input-container><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><div ng-show=\"Error6\"><p \nstyle=\"font-size: 14px;font-weight: 500;color:red\">Login ID not exist.</p></div><div ng-show=\"Error7\"><p>\nYour Login ID is correct. We\'ll reset your Password immediately and send to your email address.</p></div></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" ng-click=\"ResetPassword()\">RESET PASSWORD\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div><style>\n#forgot-password #forgot-password-form-wrapper #forgot-password-form .login {\r\n    \r\n    }</style>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><img \nsrc=\"assets/images/logos/logo-icon.png\" width=\"70px\"></div><div class=\"title\">Log In</div><form name=\"loginForm\" \nnovalidate><md-input-container class=\"md-block\"><input type=\"text\" name=\"LoginID\" ng-model=\"uLoginID\" \nplaceholder=\"Login Id\" ng-change=\"Error1 = false;Error2 = false;Error3 = false;Error4 = false;Error5 = false\" required>\n<div ng-messages=\"loginForm.LoginID.$error\" ng-show=\"loginForm.LoginID.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.LOGIN ID FIELD IS REQUIRED\">Login ID field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" ng-model=\"uPassword\" \nplaceholder=\"Password\" ng-change=\"Error1 = false;Error2 = false;Error3 = false;Error4 = false;Error5 = false\" required>\n<div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><div \nng-show=\"Error1\"><span class=\"text\" style=\"font-size: 14px; font-weight: 500; color: red\">Login ID not exist.</span>\n</div><div ng-show=\"Error2\"><p style=\"font-size: 14px; font-weight: 500; color: red\">Incorrect password.</p></div><div \nng-show=\"Error3\"><p style=\"font-size: 14px; font-weight: 500; color: red\">Account locked.</p></div><div \nng-show=\"Error4\"><p style=\"font-size: 14px; font-weight: 500; color: red\">Account not activated.</p></div><div \nng-show=\"Error5\"><p style=\"font-size: 14px; font-weight: 500; color: red\">Account expired.</p></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-click=\"login()\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div></div></div><style>\n.center {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }</style>");
$templateCache.put("app/main/pages/profile/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT\">ABOUT</div></div><div class=\"title\">{{ClientName}}</div></div></header><div class=\"content\">\n<div style=\"text-align:justify;font-size:17px\"><table style=\"width:100%;text-align:left;border-collapse: collapse\">\n<thead><tr><th style=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.LOGIN_ID\">Login ID</span><br><br>\n</th><th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{UserID}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.DISPLAY_NAME\">Display Name</span><br><br></th>\n<th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{UserName}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.EMAIL\">Email</span><br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{Email}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.LAST_UPDATED\">Last Updated</span><br><br></th>\n<th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{UpdatedDate | date : \'hh:mm a\'}}<br><br></th>\n</tr><tr><th style=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.ROLE\">Role</span><br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{Role}}<br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.EXPIRY_DATE\">Expiry Date</span><br><br></th><th \nstyle=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{ExpiryDate}}<br><br></th></tr></thead><tbody>\n</tbody><tfoot></tfoot></table></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account\">&nbsp;</md-icon></div><div class=\"title\" \ntranslate=\"PROFILE.PROFILE\">PROFILE</div></div></header><div class=\"content\"><div class=\"user-info\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center\"><img class=\"profile-image avatar huge\" \nng-if=\"Data\" src=\"{{Data}}\"> <img class=\"profile-image avatar huge\" ng-hide=\"Data\" \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"\"></div><div class=\"title\" style=\"font-size: 17px !important\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center\">{{UserName}}</div><br><br>\n<table style=\"width:100%;text-align:left;border-collapse: collapse\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.CREATED_DATE\">Created Date</span><br><br></th>\n<th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{CreatedDate | date : \'M/d/yy h:mm a\'}}<br>\n<br></th></tr><tr><th style=\"border-collapse: collapse;width:150px\"><span translate=\"PROFILE.LAST_LOGIN\">Last Login\n</span><br><br></th><th style=\"border-collapse: collapse;width:10px\">:<br><br></th><th \nstyle=\"border-collapse: collapse;width:500px;font-weight:normal\">&emsp; {{SessionEndDate | date : \'M/d/yy h:mm a\'}}<br>\n<br></th></tr></thead><tbody></tbody><tfoot></tfoot></table></div></div></div></div><style>\n.avatar.huge {\r\n    width: 146px !important;\r\n    min-width: 146px !important;\r\n    height: 155px !important;\r\n    line-height: 146px !important;\r\n}\n</style>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/accounts/Lumair/casheInvoice/CustomerInfo.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Customer Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel();ClearGrid();\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab>\n<md-tab-label><span>Details</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" \nlayout-gt-xs=\"column\"><div class=\"content-card\" style=\"width:100%;height:auto;padding:1% 1% 0 1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%; border:1px solid rgb(224, 224, 224);float:left\"><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\"><label style=\"font-size:17px\">Information :\n</label></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Reference No</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px;color:blue\">&nbsp;{{vm.CustomerReference}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Company Name</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.CompanyName}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Sales Person</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.SalesPerson}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Market Segment</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.MarketSection}}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Person Name</label></div>:<div\n class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Salutation }} {{vm.ContactPerson }}</span></div>\n<div class=\"p-4\" style=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Address</label></div>\n:<div class=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Address}}</span></div></div><div \nlayout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Email</label></div>:<div class=\"p-4\" style=\"width:25%\"><span \nstyle=\"font-size:14px\">&nbsp;{{vm.Email}}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Contact Number</label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.Mobile}}</span></div><div class=\"p-4\" style=\"width:10%\">\n<label style=\"font-size:15px;font-weight: bold;color: #7f9593\">Current Contract End Date</label></div>:<div \nclass=\"p-4\" style=\"width:25%\"><span style=\"font-size:14px\">&nbsp;{{vm.ConEndDate | date:\"dd/MM/yyyy\"}}</span></div>\n</div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width:13%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Payment Term</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.PaymentTerm }}</span></div><div class=\"p-4\" style=\"width:10%\"><label \nstyle=\"font-size:15px;font-weight: bold;color: #7f9593\">Followup Date</label></div>:<div class=\"p-4\" style=\"width:25%\">\n<span style=\"font-size:14px\">&nbsp;{{vm.ProspectFollowDate | date:\"dd/MM/yyyy\" }}</span></div><div class=\"p-4\" \nstyle=\"width:10%\"><label style=\"font-size:15px;font-weight: bold;color: #7f9593\"></label></div>:<div class=\"p-4\" \nstyle=\"width:25%\"><span style=\"font-size:14px\">&nbsp;</span></div></div></div></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"border:1px solid rgb(224, 224, 224)\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%;border-bottom: 1px solid rgb(197, 197, 197)\">\n<label style=\"font-size:17px\">Comments:</label></div></div><div \nstyle=\"background-color:whitesmoke;overflow-y: scroll; height:200px\"><md-list><md-list-item \nng-repeat=\"item in CustomerCommentdatas | orderBy: \'-\' \"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$index+1}}.{{ item.CommentedBy }} {{ item.CreatedDate | date:\'d/MM/y h:mm a\'}}</h3><p>{{ item.cmt }}</p></div>\n</md-list-item></md-list></div></div></div></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nBilling & Service Address</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate \nstyle=\"padding-bottom:0px\"><div><span class=\"h3\" style=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}\n</span></div><div style=\"margin-top: 22px;margin-bottom: -25px\"><span class=\"h4\"><b>Billing Address :</b></span></div>\n<div class=\"white-bg md-whiteframe-4dp\"><div dx-data-grid=\"vm.dataGridCustomerBilling\"></div></div><br><div \nstyle=\"margin-bottom: -40px\"><span class=\"h4\"><b>Service Address :</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div id=\"customerservicegrid\" dx-data-grid=\"vm.dataGridCustomerService\"></div></div>\n<br></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\">UPLOADED DOCUMENTS\n</span></md-tab-label><md-tab-body><form name=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\">\n<div><span class=\"h3\" style=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><table \nid=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference No #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Uploaded Document</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nUploaded Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Uploaded By</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in UploadedDocuments\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nstyle=\"cursor:pointer\">{{ row.FileID }}</a></td><td>{{ row.TableName==\'Lead\'?\"Quotation\":\"Contract\" }}</td><td><a \nhref=\"{{UploadsURL}}CRM/{{row.TableName}}/{{row.TableID}}\" download=\"{{row.FileName}}\" target=\"_blank\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.CreatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}\n</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.WORK_ORDERS\">WORK ORDERS</span></md-tab-label><md-tab-body><form name=\"wizardStep4\" \nms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" style=\"color:#7f9593\"><b>\nCustomer Name : </b>{{vm.uCompanyName}}</span></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.WORK_ORDER\">Work Order #\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.ENQUIRY_TYPE\">\nEnquiry Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.ENQUIRY\">Enquiry #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCUSTOMER.PEST_TYPES\">Pest Types</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_MODE\">Payment Mode</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMCUSTOMER.PAYMENT_TERMS\">Payment Terms</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMSALESORDER.SERVICE_START_DATE\">Service Start Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMSALESORDER.SERVICE_END_DATE\">Service End Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in SalesOrderdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nng-click=\"Detailsinfo($event, row._id, \'WorkOrder\')\" style=\"cursor:pointer\">{{ row.SalesOrderNo }}</a></td><td>\n{{ row.OrderType }}</td><td>{{ row.EnquiryReferenceNo }}</td><td>{{ row.PestType }}</td><td>{{row.PaymentTerms}}</td>\n<td>{{row.PaymentMode }}</td><td>{{ row.ServiceStartDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.ServiceEndDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></form></md-tab-body></md-tab><md-tab \nng-click=\"GetSchedulerDetails(SID,vm.uFrom)\"><md-tab-label><span class=\"ms-form-wizard-step-text\" \ntranslate=\"CRMCUSTOMER.UPCOMING_SCHEDULES\">UPCOMING SCHEDULES</span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom:0px\"><div><span class=\"h3\" \nstyle=\"color:#7f9593\"><b>Customer Name : </b>{{vm.uCompanyName}}</span></div><br><div layout=\"column\" \nlayout-gt-sm=\"row\"><div dx-date-box=\"dateBox\"></div></div><br><table id=\"example\" class=\"dataTable row-border hover\" \nstyle=\"font-size: smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Service ID</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Service Location</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Schedule Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Technician\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Attachment</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Schedulerdetails | orderBy: \'+Startsat\'\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td><a ng-click=\"SchedulerDetailsinfo($event, row._id,  \'Schedule\')\" style=\"cursor:pointer\">{{row.ServiceID }}</a>\n</td><td>{{row.Location}}</td><td>{{row.Startsat | date:\'dd/MM/y\'}}</td><td>{{row.Status}}</td><td>\n{{row.teamdetails[0].TeamMembers}}</td><td ng-if=\"row.Status==\'Completed\'\"><a ng-click=\"getServiceReports(row._id)\" \nstyle=\"cursor:pointer\">Service Report</a></td><td ng-if=\"row.Status!=\'Completed\'\"></td></tr></tbody></table></form>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></form></md-dialog><style>\nimg {\r\n    cursor: -webkit-zoom-in;\r\n    cursor: -moz-zoom-in;\r\n  }</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(25vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-default-theme.md-hue-1 .md-datepicker-input,\r\n  .md-hue-1 .md-datepicker-input {\r\n    background: none !important;\r\n  }\r\n\r\n  md-dialog md-dialog-content {\r\n    padding: 0;\r\n  }\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\r\n    min-height: 250px;\r\n  }\r\n\r\n  .chipsdemoContactChips md-content.autocomplete input {\r\n    min-width: 400px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-item-text.compact {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item.selected h3 {\r\n    opacity: 0.5;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text {\r\n    padding: 14px 0;\r\n    max-width: 190px;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3 {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n    line-height: 1.2em !important;\r\n  }\r\n\r\n  .chipsdemoContactChips .contact-item .md-list-item-text h3,\r\n  .chipsdemoContactChips .contact-item .md-list-item-text p {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    .chipsdemoContactChips .contact-item {\r\n      float: left;\r\n      width: 33%;\r\n    }\r\n  }\r\n\r\n  .chipsdemoContactChips md-contact-chips {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chipsdemoContactChips .md-chips {\r\n    padding: 5px 0 8px;\r\n  }\r\n\r\n  .chipsdemoContactChips .fixedRows {\r\n    height: 250px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #attachmenthref label:hover {\r\n    cursor: pointer !important;\r\n    color: #23527c !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #workflow .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  #tb2 {\r\n    counter-reset: serial-number;\r\n    /* Set the serial number counter to 0 */\r\n  }\r\n\r\n  #tb2 td:first-child:before {\r\n    counter-increment: serial-number;\r\n    /* Increment the serial number counter */\r\n    content: counter(serial-number);\r\n    /* Display the counter */\r\n  }\r\n\r\n  .dataTables_wrapper .bottom {\r\n    display: none;\r\n  }\r\n\r\n  .CBCustomer {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  md-checkbox #chkboxhide .md-icon {\r\n    box-sizing: border-box;\r\n    -webkit-transition: 240ms;\r\n    transition: 240ms;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-width: 0px;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon,\r\n  md-checkbox[disabled]:not(.md-checked) .md-icon {\r\n    border-color: rgba(0, 0, 0, 0);\r\n  }\r\n\r\n  md-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n  }\r\n\r\n  @import \"compass/css3\";\r\n\r\n  .star-rating {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: inline-block;\r\n  }\r\n\r\n  .star {\r\n    padding: 1px;\r\n    color: #ddd;\r\n    font-size: 20px;\r\n    text-shadow: .05em .05em #aaa;\r\n    list-style-type: none;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .filled {\r\n    color: #fd0;\r\n  }\r\n\r\n\r\n\r\n  .readonly .star.filled {\r\n    color: #666;\r\n  }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/casheInvoice/addvehiclelogs.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Payment</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"AddVehicleLogForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label>Date</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"vm.Date\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.Amount\" placeholder=\"Amount\" required></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" ng-disabled=\"AddVehicleLogForm.$invalid\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPayment()\" aria-label=\"Ok\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog><style>\n/* .md-datepicker-button {\r\n            display: none;\r\n        }\r\n    \r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 85px;\r\n        } */\r\n\r\n    /* md-datepicker .md-datepicker-input {\r\n            width: calc(15vw - 20px);\r\n            max-width: calc(15vw - 20px);\r\n            margin-left: -11px;\r\n        } */\r\n    .md-datepicker-input {\r\n        min-width: 25px !important;\r\n        max-width: 200px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/casheInvoice/cashInvoice.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>\nCash/Cheque</span></div><div class=\"product-count secondary-text\"><span>Total Invoice:</span> <span>{{workOrd.length}}\n</span></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"InvoiceExport()\" \nng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\" ng-show=\"InvoiceGrid\"><br>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 5%\"><div style=\"padding:0 1% 0 1%\"><a ng-click=\"lastmonth()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Month</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"lastweek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Week</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"Today()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today\n</a></div></div><br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container flex=\"1\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"InvoiceFilterByDate()\"><span>Search</span></md-button></div><md-tabs md-dynamic-height \nmd-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab ng-click=\"workOrd=PendingSalesinvoicedatas\"><md-tab-label>\n<span>Pending</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PendingSchedulespinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridPending\"><div class=\"SchedulerLabels\" ng-if=\"TRCdiv\" \ndata-options=\"dxTemplate:{ name:\'totalGroupCount\' }\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"width: fit-content !important\"><md-button class=\"md-raised md-background\" ng-click=\"PushCollected()\"><span>\nCollected</span></md-button></div></div></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=CollectedSalesinvoicedatas\"><md-tab-label><span>Collected</span></md-tab-label><md-tab-body><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridCollected\"><div class=\"SchedulerLabels\" ng-if=\"UTRCdiv\" \ndata-options=\"dxTemplate:{ name:\'totalGroupCount1\' }\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"width: fit-content !important\"><md-button class=\"md-raised md-background\" ng-click=\"PushUnCollected()\"><span>\nUncollected</span></md-button></div></div></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" readonly=\"readonly\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input \ntype=\"text\" ng-model=\"CustomerName\" placeholder=\"Customer Name\" readonly=\"readonly\" required></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input type=\"text\" ng-model=\"WorkOrderNo\" \nplaceholder=\"Work Order No\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Invoice Amount\" ng-model=\"Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"pdate\" ng-model=\"DueDate\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ssubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button></div><div\n class=\"white-bg md-whiteframe-4dp\"><b><h3 style=\"margin: 2px;font-weight: bold\">SERVICE DESCRIPTION</h3></b><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup( row.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></div><br><br><br><div class=\"white-bg md-whiteframe-4dp\"><h3 \nstyle=\"margin: 2px;font-weight: bold\">PAYMENT HISTORY</h3><div \nstyle=\"float:left;margin-top:-75px;margin-bottom: -35px\"><span style=\"font-weight: 900;color: cadetblue\">\nOutstanding Amount : {{TOutStandingAmount}}</span></div><div style=\"float:right;margin-top:-75px;margin-bottom: -35px\">\n<md-button class=\"md-raised md-accent\" ng-click=\"AddPayment($event)\"><span>Add</span></md-button></div><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount Paid</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paymentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Amount }}</td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"EditPop($event, row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"PDeletePopup( row._id , row.Amount)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" \nlayout-align=\"center\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span \ntranslate=\"SALESRECEIVABLES.CANCEL\">Cancel</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/collectpayment.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Collect Payment</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span>Last Month\n</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span>Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span>Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span>Next Week</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\" NextMonth()\"><span>Next Month</span></md-button><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>Customer</b></label><md-select \nclass=\"Supplierfilter\" ng-model=\"vm.CustomerID\" id=\"searchmodule\" required ng-change=\"InvoicefilterByCustomer()\">\n<md-select-header><input ng-model=\"searchTermc\" type=\"text\" placeholder=\"Search for a customer..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc\" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoicefilterByCustomer()\"><span>Search</span></md-button></div></div><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SALESRECEIVABLES.INVOICE_NUMBER\">Invoice Number</label><md-select ng-model=\"vm.InvoiceID\" \nng-model-options=\"{trackBy: \'$value._id\'}\" ng-change=\"OnInvoiceChange()\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-select-header><b>\n{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}} - {{\'SALESRECEIVABLES.INVOICE_DATE\'|translate}}</b></md-select-header>\n<md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Salesinvoicedatasdd | filter:{CustomerID :vm.CustomerID}  | filter:vm.searchTerm1\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" class=\"pdate\" \nng-model=\"vm.VoucherDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SALESRECEIVABLES.ACCOUNTING_CODE\">Accounting Code</label><md-select \nng-model=\"vm.AccountID\" id=\"searchmodule\" required><md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm \" value=\"{{row.id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Amount Paid\" ng-model=\"vm.Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SALESRECEIVABLES.BANK_NAME\">Bank Name</label><md-select \nng-model=\"vm.BankID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTermb\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH FOR A BANK\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Bankdatas | filter:vm.searchTermb\" value=\"{{row.id}}\">{{row.BankName}}\n</md-option></md-select></md-input-container><md-input-container flex><input \ntranslate=\"SALESRECEIVABLES.CHEQUE_NUMBER\" type=\"text\" ng-model=\"vm.ChequeNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.CHEQUE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.COLLECTION_DATE\">Collection Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveCollectPayment()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n        width: 160px\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/creditnote.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.CREDIT_NOT\" class=\"title\">Credit Note</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Invoice No\" ng-model=\"InvoiceNo\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"basicForm.InvoiceNo.$error\" \nng-show=\"basicForm.InvoiceNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO_FIELD_IS_REQUIRED\">Invoice No field is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"DisposalDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Invoice Amount\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_AMOUNT\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_AMOUNT_FIELD_IS_REQUIRED\">Invoice Amount field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Credit Note Amount\" ng-model=\"Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Credit Note No\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\">\n</md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/invoice.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE\" class=\"title\">Invoice</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Contract No\" \nng-model=\"ContractNo\" placeholder=\"{{\'SALESRECEIVABLE.CONTRACT NO\'|translate}}\" required><div \nng-messages=\"basicForm.ContractNo.$error\" ng-show=\"basicForm.ContractNo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Contract No field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Service Report No\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.SERVICE_REPORT_NO\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO_FIELD_IS_REQUIRED\">Service Report No field is required.</span></div>\n</div></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.DATE\">\nDate</label><md-datepicker onkeydown=\"return false\" ng-model=\"DisposalDate\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Description\" \nng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Amount\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button>\n<md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/newsalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" ng-mode=\"SearchValue\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ExporttoXero()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export to Xero</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Contractsgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"contractdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"ContractgridContainer\" \ndx-data-grid=\"vm.dataGridContract\"><div class=\"SchedulerLabels\" data-options=\"dxTemplate:{ name:\'totalGroupCount\' }\">\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"width: fit-content !important\"><md-checkbox-container flex><md-checkbox \nng-model=\"uShowClosed\" ng-change=\"ShowClosed(uShowClosed)\" type=\"checkbox\"><b>Show Exported Invoices</b></md-checkbox>\n</md-checkbox-container></div></div></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label><b>\n{{\'SALESRECEIVABLES.CONTRACT\'|translate}}</b></label><md-select ng-model=\"ConID\" id=\"searchmodule\" \nng-change=\"OnConChange()\"><md-select-header><input force-select-focus ng-model=\"searchTerm32\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_CONTRACT\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ConID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in contractdatas |filter:{Customer_id:CustomerID}| filter:searchTerm32\" value=\"{{row._id}}\">\n{{row.ContractReferenceNo}} - {{row.customerdetails[0].CompanyName}}</md-option></md-select></md-input-container></div>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select ng-model=\"WorkOrderID\" id=\"searchmodule\" required>\n<md-select-header><input force-select-focus ng-model=\"searchTermw\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/osalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.ACCOUNTS RECEIVABLES\">Accounts Receivables</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"search\" class=\"search-input\" type=\"text\" ng-mode=\"SearchValue\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CollectPaymentExport()\" \nng-show=\"CollectPaymentSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteExport()\" ng-show=\"CreditnoteGrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"DebitnoteExport()\" ng-show=\"DebitnoteSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CustomerStatementExport()\" \nng-show=\"CustomerStatementSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteShowgrid()\" ng-show=\"CreditnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridDebit()\" ng-show=\"DebitnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridCollectPayment()\" \nng-show=\"CollectPaymentFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab ng-click=\"InvoiceTab()\"><md-tab-label><span translate=\"SALESRECEIVABLES.INVOICE\">Invoice\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" \nng-show=\"InvoiceGrid\"><form name=\"organizationform1\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"SALESRECEIVABLES.LAST_MONTH\">\nLast Month</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"SALESRECEIVABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"SALESRECEIVABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"SALESRECEIVABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"SALESRECEIVABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"SALESRECEIVABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"SALESRECEIVABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"SALESRECEIVABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" id=\"MainWrap\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Salesinvoicedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SALESRECEIVABLES.PRINT\" class=\"column-title\">Print</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_NO\" class=\"column-title\">Voucher No</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_DATE\" class=\"column-title\">\nVoucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO\" class=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_DATE\" class=\"column-title\">Invoice Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SITE_ADDRESS\" class=\"column-title\">Site Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.AGENT_NAME\" class=\"column-title\">\nAgent Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.WORKORDER\" class=\"column-title\">WorkOrder</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.SALES_AMOUNT\" \nclass=\"column-title\">Sales Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.GST_AMOUNT\" class=\"column-title\">GST Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">OutStanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.GST_CODE\" class=\"column-title\">GST Code</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_TERM\" \nclass=\"column-title\">Credit Term</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DUE_DATE\" class=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_NOTE_NUMBER\" class=\"column-title\">Credit Note Number\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DEBIT_NOTE_NUMBER\" class=\"column-title\">Debit Note Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.REMARKS\" class=\"column-title\">\nRemarks</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Salesinvoicedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><md-button \nclass=\"md-flat md-icon-button reference-button\" id=\"target\" aria-label=\"Custom Icon Button\" \nng-click=\"Printsalesinvoice(\'salesinvoice\', row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td>\n<td nowrap=\"nowrap\"><a href=\"\" ng-click=\"SalesInvoiceInfo(row._id,$index)\" title=\"View/Edit\" style=\"border:none\">\n{{ row.VoucherNumber }}</a></td><td>{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">\n{{ row.InvoiceNumber }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Status }}</td><td \nnowrap=\"nowrap\">{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CompanyName }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].BLK }} {{ row.Customerdetails[0].StreetName }} {{ row.Customerdetails[0].Unit }} {{ row.Customerdetails[0].BuildingName }} {{ row.Customerdetails[0].Country }} {{ row.Customerdetails[0].Postal }}\n</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].ContactPerson }}</td><td nowrap=\"nowrap\">\n{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td nowrap=\"nowrap\">\n$ {{ row.Amount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.GSTAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">\n{{ row.Invoicecomment[0].Description }} {{ row.Invoicecomment[1].Description }} {{ row.Invoicecomment[2].Description }} {{ row.Invoicecomment[3].Description }} {{ row.Invoicecomment[4].Description }}\n</td><td nowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }}</td><td nowrap=\"nowrap\">{{ row.CreditTerm }}</td><td>\n{{ row.DueDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber }}</td><td nowrap=\"nowrap\">\n{{ row.DebitNoteNumber }}</td><td nowrap=\"nowrap\">{{ row.Remarks }}</td></tr></tbody></table></div></div></form></div>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form \nname=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select \nng-model=\"WorkOrderID\" id=\"searchmodule\" required><md-select-header><input force-select-focus ng-model=\"searchTermw\" \ntype=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Lumair/salesreceivables/salesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div><div class=\"product-count secondary-text\"><span>Total Invoice:</span> <span>{{Salesinvoicedatas.length}}\n</span></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"InvoiceExport()\" \nng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\" ng-show=\"InvoiceGrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 5%\"><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"lastmonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nLast Month</a></div><div style=\"padding:0 1% 0 1%\"><a ng-click=\"lastweek()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Week</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"Today()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today</a></div></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container flex=\"1\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"InvoiceFilterByDate()\"><span>Search</span></md-button></div><br><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"ContractgridContainer\" dx-data-grid=\"vm.dataGridContract\"></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" readonly=\"readonly\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input \ntype=\"text\" ng-model=\"CustomerName\" placeholder=\"Customer Name\" readonly=\"readonly\" required></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input type=\"text\" ng-model=\"WorkOrderNo\" \nplaceholder=\"Work Order No\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Invoice Amount\" ng-model=\"Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"pdate\" ng-model=\"DueDate\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ssubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button></div><div\n class=\"white-bg md-whiteframe-4dp\"><b><h3 style=\"margin: 2px;font-weight: bold\">SERVICE DESCRIPTION</h3></b><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup( row.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" layout-align=\"center\">\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">\nCancel</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/casheInvoice/addvehiclelogs.html","<md-dialog style=\"width:60%;overflow:auto\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Add Payment</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"AddVehicleLogForm\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label>Date</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"vm.Date\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.Amount\" placeholder=\"Amount\" required></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" ng-disabled=\"AddVehicleLogForm.$invalid\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPayment()\" aria-label=\"Ok\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog><style>\n/* .md-datepicker-button {\r\n            display: none;\r\n        }\r\n    \r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 85px;\r\n        } */\r\n\r\n    /* md-datepicker .md-datepicker-input {\r\n            width: calc(15vw - 20px);\r\n            max-width: calc(15vw - 20px);\r\n            margin-left: -11px;\r\n        } */\r\n    .md-datepicker-input {\r\n        min-width: 25px !important;\r\n        max-width: 200px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/casheInvoice/cashInvoice.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>\nCash/Cheque</span></div><div class=\"product-count secondary-text\"><span>Total Invoice:</span> <span>{{workOrd.length}}\n</span></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"InvoiceExport()\" \nng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\" ng-show=\"InvoiceGrid\"><br>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 5%\"><div style=\"padding:0 1% 0 1%\"><a ng-click=\"lastmonth()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Month</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"lastweek()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Week</a></div><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"Today()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today\n</a></div></div><br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container flex=\"1\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"InvoiceFilterByDate()\"><span>Search</span></md-button></div><md-tabs md-dynamic-height \nmd-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab ng-click=\"workOrd=PendingSalesinvoicedatas\"><md-tab-label>\n<span>Pending</span></md-tab-label><md-tab-body><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PendingSchedulespinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"PendingContainer\" dx-data-grid=\"vm.dataGridPending\"><div class=\"SchedulerLabels\" ng-if=\"TRCdiv\" \ndata-options=\"dxTemplate:{ name:\'totalGroupCount\' }\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"width: fit-content !important\"><md-button class=\"md-raised md-background\" ng-click=\"PushCollected()\"><span>\nCollected</span></md-button></div></div></div></md-tab-body></md-tab><md-tab \nng-click=\"workOrd=CollectedSalesinvoicedatas\"><md-tab-label><span>Collected</span></md-tab-label><md-tab-body><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"YTSContainer\" dx-data-grid=\"vm.dataGridCollected\"><div class=\"SchedulerLabels\" ng-if=\"UTRCdiv\" \ndata-options=\"dxTemplate:{ name:\'totalGroupCount1\' }\"><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"width: fit-content !important\"><md-button class=\"md-raised md-background\" ng-click=\"PushUnCollected()\"><span>\nUncollected</span></md-button></div></div></div></md-tab-body></md-tab></md-tabs></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" readonly=\"readonly\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input \ntype=\"text\" ng-model=\"CustomerName\" placeholder=\"Customer Name\" readonly=\"readonly\" required></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input type=\"text\" ng-model=\"WorkOrderNo\" \nplaceholder=\"Work Order No\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Invoice Amount\" ng-model=\"Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"pdate\" ng-model=\"DueDate\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ssubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button></div><div\n class=\"white-bg md-whiteframe-4dp\"><b><h3 style=\"margin: 2px;font-weight: bold\">SERVICE DESCRIPTION</h3></b><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup( row.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></div><br><br><br><div class=\"white-bg md-whiteframe-4dp\"><h3 \nstyle=\"margin: 2px;font-weight: bold\">PAYMENT HISTORY</h3><div \nstyle=\"float:left;margin-top:-75px;margin-bottom: -35px\"><span style=\"font-weight: 900;color: cadetblue\">\nOutstanding Amount : {{TOutStandingAmount}}</span></div><div style=\"float:right;margin-top:-75px;margin-bottom: -35px\">\n<md-button class=\"md-raised md-accent\" ng-click=\"AddPayment($event)\"><span>Add</span></md-button></div><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount Paid</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Edit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Paymentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.Amount }}</td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \nng-click=\"EditPop($event, row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"PDeletePopup( row._id , row.Amount)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" \nlayout-align=\"center\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span \ntranslate=\"SALESRECEIVABLES.CANCEL\">Cancel</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/collectpayment.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Collect Payment</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span>Last Month\n</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span>Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span>Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span>Next Week</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\" NextMonth()\"><span>Next Month</span></md-button><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.uTo\"></md-datepicker></md-input-container><md-input-container flex=\"1\" \nstyle=\"margin-top: 17px;width:200px\"><label style=\"color:green;font-size: 14px\"><b>Customer</b></label><md-select \nclass=\"Supplierfilter\" ng-model=\"vm.CustomerID\" id=\"searchmodule\" required ng-change=\"InvoicefilterByCustomer()\">\n<md-select-header><input ng-model=\"searchTermc\" type=\"text\" placeholder=\"Search for a customer..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc\" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoicefilterByCustomer()\"><span>Search</span></md-button></div></div><form \nname=\"eventForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SALESRECEIVABLES.INVOICE_NUMBER\">Invoice Number</label><md-select ng-model=\"vm.InvoiceID\" \nng-model-options=\"{trackBy: \'$value._id\'}\" ng-change=\"OnInvoiceChange()\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchTerm1\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_INVOICE_NUMBER\'|translate}}..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-select-header><b>\n{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}} - {{\'SALESRECEIVABLES.INVOICE_DATE\'|translate}}</b></md-select-header>\n<md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in Salesinvoicedatasdd | filter:{CustomerID :vm.CustomerID}  | filter:vm.searchTerm1\">\n{{row.InvoiceNumber}} - {{row.Date | date:\'dd/MM/y\'}}</md-option></md-optgroup></md-select></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" class=\"pdate\" \nng-model=\"vm.VoucherDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SALESRECEIVABLES.ACCOUNTING_CODE\">Accounting Code</label><md-select \nng-model=\"vm.AccountID\" id=\"searchmodule\" required><md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_ACCOUNT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm \" value=\"{{row.id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"Amount Paid\" ng-model=\"vm.Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SALESRECEIVABLES.BANK_NAME\">Bank Name</label><md-select \nng-model=\"vm.BankID\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTermb\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH FOR A BANK\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Bankdatas | filter:vm.searchTermb\" value=\"{{row.id}}\">{{row.BankName}}\n</md-option></md-select></md-input-container><md-input-container flex><input \ntranslate=\"SALESRECEIVABLES.CHEQUE_NUMBER\" type=\"text\" ng-model=\"vm.ChequeNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.CHEQUE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.COLLECTION_DATE\">Collection Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.Date\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></form></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"SaveCollectPayment()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"SAVE\" translate-attr-aria-label=\"SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n        width: 160px\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-dialog {\r\n\r\n        max-width: 60%;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/creditnote.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.CREDIT_NOT\" class=\"title\">Credit Note</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Invoice No\" ng-model=\"InvoiceNo\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"basicForm.InvoiceNo.$error\" \nng-show=\"basicForm.InvoiceNo.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO_FIELD_IS_REQUIRED\">Invoice No field is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"DisposalDate\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Invoice Amount\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_AMOUNT\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_AMOUNT_FIELD_IS_REQUIRED\">Invoice Amount field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Credit Note Amount\" ng-model=\"Description\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Credit Note No\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.CREDIT_NOTE_NUMBER\'|translate}}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\">\n</md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button><md-button \nng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/invoice.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE\" class=\"title\">Invoice</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><div\n class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Contract No\" \nng-model=\"ContractNo\" placeholder=\"{{\'SALESRECEIVABLE.CONTRACT NO\'|translate}}\" required><div \nng-messages=\"basicForm.ContractNo.$error\" ng-show=\"basicForm.ContractNo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Contract No field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Service Report No\" ng-model=\"Item\" \nplaceholder=\"{{\'SALESRECEIVABLES.SERVICE_REPORT_NO\'|translate}}\" required><div ng-messages=\"basicForm.Item.$error\" \nng-show=\"basicForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO_FIELD_IS_REQUIRED\">Service Report No field is required.</span></div>\n</div></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"SALESRECEIVABLES.DATE\">\nDate</label><md-datepicker onkeydown=\"return false\" ng-model=\"DisposalDate\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Description\" \nng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Amount\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div></form></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">{{\'SALESRECEIVABLES.SAVE\'|translate}}</md-button>\n<md-button ng-click=\"closeDialog()\" class=\"cancel-button md-accent md-raised\" aria-label=\"CANCEL\">\n{{\'SALESRECEIVABLES.CANCEL\'|translate}}</md-button></md-dialog-actions></div></div><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0, 0, 0, 0.87);\r\n            background: none;\r\n            width:160px\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-dialog {\r\n\r\n            max-width: 60%;\r\n        }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/newsalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" ng-mode=\"SearchValue\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ExporttoXero()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export to Xero</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Contractsgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"contractdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"ContractgridContainer\" \ndx-data-grid=\"vm.dataGridContract\"><div class=\"SchedulerLabels\" data-options=\"dxTemplate:{ name:\'totalGroupCount\' }\">\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"width: fit-content !important\"><md-checkbox-container flex><md-checkbox \nng-model=\"uShowClosed\" ng-change=\"ShowClosed(uShowClosed)\" type=\"checkbox\"><b>Show Exported Invoices</b></md-checkbox>\n</md-checkbox-container></div></div></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label><b>\n{{\'SALESRECEIVABLES.CONTRACT\'|translate}}</b></label><md-select ng-model=\"ConID\" id=\"searchmodule\" \nng-change=\"OnConChange()\"><md-select-header><input force-select-focus ng-model=\"searchTerm32\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_CONTRACT\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ConID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in contractdatas |filter:{Customer_id:CustomerID}| filter:searchTerm32\" value=\"{{row._id}}\">\n{{row.ContractReferenceNo}} - {{row.customerdetails[0].CompanyName}}</md-option></md-select></md-input-container></div>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select ng-model=\"WorkOrderID\" id=\"searchmodule\" required>\n<md-select-header><input force-select-focus ng-model=\"searchTermw\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/osalesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.ACCOUNTS RECEIVABLES\">Accounts Receivables</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"search\" class=\"search-input\" type=\"text\" ng-mode=\"SearchValue\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH\'|translate}}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"InvoiceExport()\" ng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CollectPaymentExport()\" \nng-show=\"CollectPaymentSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteExport()\" ng-show=\"CreditnoteGrid && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"DebitnoteExport()\" ng-show=\"DebitnoteSelect && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"CustomerStatementExport()\" \nng-show=\"CustomerStatementSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"CreditnoteShowgrid()\" ng-show=\"CreditnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridDebit()\" ng-show=\"DebitnoteForm && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"Showgrid()\" ng-show=\"InvoiceFormback && AllowExport==\'true\'\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"SALESRECEIVABLES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"ShowgridCollectPayment()\" \nng-show=\"CollectPaymentFormback && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab ng-click=\"InvoiceTab()\"><md-tab-label><span translate=\"SALESRECEIVABLES.INVOICE\">Invoice\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" \nng-show=\"InvoiceGrid\"><form name=\"organizationform1\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"SALESRECEIVABLES.LAST_MONTH\">\nLast Month</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"SALESRECEIVABLES.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"SALESRECEIVABLES.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"SALESRECEIVABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"SALESRECEIVABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"SALESRECEIVABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"SALESRECEIVABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"SALESRECEIVABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" id=\"MainWrap\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Salesinvoicedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"SALESRECEIVABLES.PRINT\" class=\"column-title\">Print</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_NO\" class=\"column-title\">Voucher No</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.VOUCHER_DATE\" class=\"column-title\">\nVoucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NO\" class=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_DATE\" class=\"column-title\">Invoice Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.STATUS\" \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\" class=\"column-title\">Customer Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CUSTOMER_NAME\" class=\"column-title\">\nCustomer Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SITE_ADDRESS\" class=\"column-title\">Site Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.AGENT_NAME\" class=\"column-title\">\nAgent Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.WORKORDER\" class=\"column-title\">WorkOrder</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.SALES_AMOUNT\" \nclass=\"column-title\">Sales Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.GST_AMOUNT\" class=\"column-title\">GST Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">OutStanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">Description</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"SALESRECEIVABLES.GST_CODE\" class=\"column-title\">GST Code</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_TERM\" \nclass=\"column-title\">Credit Term</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DUE_DATE\" class=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.CREDIT_NOTE_NUMBER\" class=\"column-title\">Credit Note Number\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.DEBIT_NOTE_NUMBER\" class=\"column-title\">Debit Note Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.REMARKS\" class=\"column-title\">\nRemarks</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Salesinvoicedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><md-button \nclass=\"md-flat md-icon-button reference-button\" id=\"target\" aria-label=\"Custom Icon Button\" \nng-click=\"Printsalesinvoice(\'salesinvoice\', row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td>\n<td nowrap=\"nowrap\"><a href=\"\" ng-click=\"SalesInvoiceInfo(row._id,$index)\" title=\"View/Edit\" style=\"border:none\">\n{{ row.VoucherNumber }}</a></td><td>{{ row.VoucherDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">\n{{ row.InvoiceNumber }}</td><td>{{ row.Date | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.Status }}</td><td \nnowrap=\"nowrap\">{{ row.Customerdetails[0].CustomerReference }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].CompanyName }}</td><td nowrap=\"nowrap\">\n{{ row.Customerdetails[0].BLK }} {{ row.Customerdetails[0].StreetName }} {{ row.Customerdetails[0].Unit }} {{ row.Customerdetails[0].BuildingName }} {{ row.Customerdetails[0].Country }} {{ row.Customerdetails[0].Postal }}\n</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].ContactPerson }}</td><td nowrap=\"nowrap\">\n{{ row.WorkOrderdetails[0].SalesOrderNo }}</td><td nowrap=\"nowrap\">{{ row.ServiceID}}</td><td nowrap=\"nowrap\">\n$ {{ row.Amount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.GSTAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">\n{{ row.Invoicecomment[0].Description }} {{ row.Invoicecomment[1].Description }} {{ row.Invoicecomment[2].Description }} {{ row.Invoicecomment[3].Description }} {{ row.Invoicecomment[4].Description }}\n</td><td nowrap=\"nowrap\">{{ row.GSTdetails[0].GSTTaxCode }}</td><td nowrap=\"nowrap\">{{ row.CreditTerm }}</td><td>\n{{ row.DueDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">{{ row.CreditNoteNumber }}</td><td nowrap=\"nowrap\">\n{{ row.DebitNoteNumber }}</td><td nowrap=\"nowrap\">{{ row.Remarks }}</td></tr></tbody></table></div></div></form></div>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form \nname=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"VoucherNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.VOUCHER_NUMBER\'|translate}}\" required ng-disabled=\"Update\"><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.VOUCHER_NUMBER_IS_REQUIRED\">Voucher Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"VoucherDate\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.CUSTOMER_CODE\">Customer Code</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" \nng-change=\"OnCustomerChange()\" required><md-select-header><input force-select-focus ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_A_CUSTOMER..\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"ClearSearch()\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" required><div ng-messages=\"eventForm.Item.$error\" \nng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.INVOICE_DATE\">Invoice Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnInvoiceDateChange()\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"margin-top: -6px\" flex><label translate=\"SALESRECEIVABLES.WORKORDER\">Work Order</label><md-select \nng-model=\"WorkOrderID\" id=\"searchmodule\" required><md-select-header><input force-select-focus ng-model=\"searchTermw\" \ntype=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_WORK_ORDER\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus><md-button class=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: -6px\">\n<label translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\">Service Report No</label><md-select ng-model=\"ServiceID\" \nng-model-options=\"{trackBy: \'$value.ServiceID\'}\" multiple=\"\" required ng-change=\"OnWorkOrderChange()\">\n<md-select-header><input force-select-focus ng-model=\"searchTerm11\" type=\"text\" \nplaceholder=\"{{\'SALESRECEIVABLES.SEARCH_SERVICE_REPORT_NO\'|translate}}\" ng-keydown=\"$event.stopPropagation()\" \nforce-select-focus></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-repeat=\"row in schedulerdatas | filter:{JobsOrders :WorkOrderID}   | filter:searchTerm11\">\n{{row.ServiceID}} - Billed Amount ({{row.BillingAmount || 0 |number:2}})</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Amount Paid\" ng-model=\"Amount\" \nplaceholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label \ntranslate=\"SALESRECEIVABLES.GST_CODE\">GST Code</label><md-select ng-model=\"GSTID\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"searchTermGST\" type=\"text\" placeholder=\"{{\'SALESRECEIVABLES.SEARCH_FOR_GST..\'|translate}}.\" \nng-keydown=\"$event.stopPropagation()\" force-select-focus><md-button class=\"md-icon-button\" ng-click=\"GSTID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in GSTdatas  | filter:searchTermGST\" value=\"{{row._id}}\">\n{{row.GSTTaxCode}} - {{row.TaxRate}} %</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"CreditTerm\" placeholder=\"{{\'SALESRECEIVABLES.CREDIT_TERM\'|translate}}\" \nnd-change=\"OnCreditTermChange()\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label translate=\"SALESRECEIVABLES.DUE_DATE\">Due Date\n</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"pdate\" ng-model=\"DueDate\"></md-datepicker>\n</md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input \ntype=\"text\" ng-model=\"Remarks\" placeholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div>\n<div class=\"white-bg md-whiteframe-4dp\"><br><h3 style=\"text-align:left\">\n&nbsp;{{\'SALESRECEIVABLES.NOTE\'|translate}} :{{\'SALESRECEIVABLES.CLICK SERVICE REPORT NO TO UPDATE DESCRIPTION\'|translate}}\n</h3><hr><label ng-hide=\"Desc\">&nbsp;{{\'SALESRECEIVABLES.DESCRIPTION FOR\'|translate}} {{ServiceReportNo}}</label><div \nlayout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><textarea \nitem-width=\"100%\" item-height=\"60px\" ng-model=\"Description\" placeholder=\"{{\'SALESRECEIVABLES.DESCRIPTION\'|translate}}\" \ntitle=\"Click Service Report No to update description\" ng-focus=\"textbar\" ng-readonly=\"Desc\"></textarea>\n</md-input-container></div><div style=\"float:right;margin-top:-45px;margin-bottom: -35px\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"DescriptionSubmit()\" \nng-disabled=\"PurchaseInvoice.$invalid || PurchaseInvoice.$pristine\"><span translate=\"SALESRECEIVABLES.SAVE\">Save</span>\n</md-button></div><table class=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" \nclass=\"column-title\">Description</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td></tr></tbody></table></div><br><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SaveInvoice()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button><md-button\n id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">Cancel\n</span></md-button></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/Pestoff/salesreceivables/salesreceivables.html","<div id=\"salesreceivables\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span>Invoice\n</span></div><div class=\"product-count secondary-text\"><span>Total Invoice:</span> <span>{{Salesinvoicedatas.length}}\n</span></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"InvoiceExport()\" \nng-show=\"InvoiceSelect && AllowExport==\'true\'\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"Showgrid()\" ng-show=\"InvoiceFormback\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"SALESRECEIVABLES.BACK\">Back</span></md-button></div></div><div class=\"content\" ng-show=\"InvoiceGrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><br><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 5%\"><div \nstyle=\"padding:0 1% 0 1%\"><a ng-click=\"lastmonth()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">\nLast Month</a></div><div style=\"padding:0 1% 0 1%\"><a ng-click=\"lastweek()\" \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Last Week</a></div><div style=\"padding:0 1% 0 1%\"><a \nng-click=\"Today()\" style=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px\">Today</a></div></div><br><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex \nng-init=\"vm.SelectedTab = \'PendingSchedule\'\"><md-input-container flex=\"1\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\"><label>To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-icon \nmd-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\"></md-icon>\n<md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\"></md-icon>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-click=\"InvoiceFilterByDate()\"><span>Search</span></md-button></div><br><div id=\"ContractgridContainer\" \ndx-data-grid=\"vm.dataGridContract\"></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"InvoiceForm\"><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"text\" ng-model=\"InvoiceNumber\" \nplaceholder=\"{{\'SALESRECEIVABLES.INVOICE_NUMBER\'|translate}}\" readonly=\"readonly\" required><div \nng-messages=\"eventForm.Item.$error\" ng-show=\"eventForm.Item.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SALESRECEIVABLES.INVOICE_NUMBER_IS_REQUIRED\">Invoice Number is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.VOUCHER_DATE\">Voucher Date</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"pdate\" ng-model=\"Date\" ng-change=\"OnVoucherDateChange()\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input \ntype=\"text\" ng-model=\"CustomerName\" placeholder=\"Customer Name\" readonly=\"readonly\" required></md-input-container>\n</div><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><input type=\"text\" ng-model=\"WorkOrderNo\" \nplaceholder=\"Work Order No\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Invoice Amount\" ng-model=\"Amount\" placeholder=\"{{\'SALESRECEIVABLES.AMOUNT\'|translate}}\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\" id=\"DateFilterWidth\"><label \ntranslate=\"SALESRECEIVABLES.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"pdate\" ng-model=\"DueDate\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'SALESRECEIVABLES.REMARKS\'|translate}}\"></md-input-container></div></div><div class=\"bottom\" \nlayout=\"row\" layout-align=\"center\"><md-button type=\"submit\" style=\"height:36px !important\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ssubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\">{{\'SALESRECEIVABLES.SUBMIT\'|translate}}</md-button></div><div\n class=\"white-bg md-whiteframe-4dp\"><b><h3 style=\"margin: 2px;font-weight: bold\">SERVICE DESCRIPTION</h3></b><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"SALESRECEIVABLES.SERVICE_REPORT_NO\" class=\"column-title\">Service Report No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"SALESRECEIVABLES.DESCRIPTION\" class=\"column-title\">\nDescription</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Descriptiondatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EnableDescription(row._id,row.ServiceReportNo )\" title=\"Details\" style=\"border:none\">\n{{ row.ServiceReportNo }}</a></td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup( row.id)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" layout-align=\"center\">\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Showgrid()\"><span translate=\"SALESRECEIVABLES.CANCEL\">\nCancel</span></md-button></div></div></form></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\n</style><style>\n.hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #DateFilterWidth md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(24vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #DateFilterPayment md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n        width: calc(21vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_processing {\r\n        position: absolute;\r\n        top: 30%;\r\n        left: 50%;\r\n        width: 30%;\r\n        height: 40px;\r\n        margin-left: -20%;\r\n        margin-top: -25px;\r\n        padding-top: 20px;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        background: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/balancesheet/balancesheet.html","<div id=\"balancesheet\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"BALANCE_SHEET.HEADER\">Balance Sheet</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'BALANCE_SHEET.SEARCH\'|translate}}\" flex>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"BALANCE_SHEET.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"BALANCE_SHEET.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"BALANCE_SHEET.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"BALANCE_SHEET.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"BALANCE_SHEET.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"BALANCE_SHEET.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"BALANCE_SHEET.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\" id=\"Datefilter\"><label translate=\"BALANCE_SHEET.TO\" style=\"color:green;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker>\n</md-input-container><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span \ntranslate=\"BALANCE_SHEET.SEARCH\">Search</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Uniqueledgersummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BALANCE_SHEET.ACCOUNT_CODE\" class=\"column-title\">Account Group</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BALANCE_SHEET.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BALANCE_SHEET.ACCOUNT_DESCRIPTION\" \nclass=\"column-title\">Account Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BALANCE_SHEET.DEBIT\" class=\"column-title\">Debit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BALANCE_SHEET.CREDIT\" class=\"column-title\">Credit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Uniqueledgersummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nnowrap=\"nowrap\">{{ row.AccountGroup }}</td><td><a href=\"\" style=\"border:none\">{{ row.AccountCode }}</a></td><td \nnowrap=\"nowrap\">{{ row.AccountDescription }}</td><td nowrap=\"nowrap\">$ {{ row.DebitAmountTotal || 0 |number:2 }}</td>\n<td nowrap=\"nowrap\">$ {{ row.CreditAmountTotal || 0 |number:2 }}</td></tr></tbody></table></div></div></div></div>\n<style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/billingreport/billingreport.html","<div id=\"billingreport\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"BILLING_REPORT.HEADER\">Billing Report</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'BILLING_REPORT.SEARCH\'|translate}}\" flex>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"BILLING_REPORT.EXPORT\">Export</span></md-button></div>\n</div><div class=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\" ng-show=\"grid\"><span \nclass=\"h4\" style=\"padding-left:0px;color:#7f9593\"><b>{{\'BILLING_REPORT.CUSTOMER_DETAILS\'|translate}} :</b></span><br>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"BILLING_REPORT.SEARCH_CUSTOMER\">\nSearch Customer</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" ng-change=\"OnCustomerChange()\">\n<md-select-header><input ng-model=\"searchTermc\" type=\"text\" \nplaceholder=\"{{\'BILLING_REPORT.SEARCH_CUSTOMER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"CustomerID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Customerdatas  | filter:searchTermc \" value=\"{{row.id}}\">\n{{row.CustomerReference}} - {{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex>\n<label translate=\"BILLING_REPORT.SEARCH_CONTRACT\">Search Contract</label><md-select class=\"Supplierfilter\" \nng-model=\"ContractID\" id=\"searchmodule\"><md-select-header><input ng-model=\"searchTerm3\" type=\"text\" \nplaceholder=\"{{\'BILLING_REPORT.SEARCH_CONTRACT\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"ContractID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in contractdatas  |filter:{Customer_id:CustomerID} | filter:searchTerm3\" value=\"{{row._id}}\">\n{{row.ContractReferenceNo}} - {{row.customerdetails[0].CompanyName}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"BILLING_REPORT.SEARCH_WORK_ORDER\">Search Work Order</label><md-select \nng-model=\"WorkOrderID\" id=\"searchmodule\"><md-select-header><input ng-model=\"searchTermw\" type=\"text\" \nplaceholder=\"{{\'BILLING_REPORT.SEARCH_WORK_ORDER\'|translate}}..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"WorkOrderID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in salesOrderdatas |filter:{Customer_id:CustomerID} | filter:searchTermw\" value=\"{{row._id}}\">\n{{row.SalesOrderNo}}</md-option></md-select></md-input-container></div><span class=\"h4\" \nstyle=\"padding-left:0px;color:#7f9593\"><b>{{\'BILLING_REPORT.BILLING_DETAILS\'|translate}} :</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"BILLING_REPORT.SEARCH_PAYMENT_TERMS\">\nSearch Payment Terms</label><md-select ng-model=\"vm.PaymentTerms\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">{{\'BILLING_REPORT.PAYMENT_TERMS\'|translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.PaymentTerms = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nvalue=\"{{\'BILLING_REPORT.DAILY\'|translate}}\">{{\'BILLING_REPORT.DAILY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.WEEKLY\'|translate}}\">{{\'BILLING_REPORT.WEEKLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.FORTNIGHTLY\'|translate}}\">{{\'BILLING_REPORT.FORTNIGHTLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.MONTHLY\'|translate}}\">{{\'BILLING_REPORT.MONTHLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.QUARTERLY\'|translate}}\">{{\'BILLING_REPORT.QUARTERLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.HALF_YEARLY\'|translate}}\">{{\'BILLING_REPORT.HALF_YEARLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.YEARLY\'|translate}}\">{{\'BILLING_REPORT.YEARLY\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.OTHERS\'|translate}}\">{{\'BILLING_REPORT.OTHERS\'|translate}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"BILLING_REPORT.SEARCH_BILLING_FREQUENCY\">\nSearch Billing Frequency</label><md-select ng-model=\"vm.BillingFrequency\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">{{\'BILLING_REPORT.BILLING_FREQUENCY\'|translate}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.BillingFrequency = null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nvalue=\"{{\'BILLING_REPORT.CASH\'|translate}}\">{{\'BILLING_REPORT.CASH\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.CHEQUE\'|translate}}\">{{\'BILLING_REPORT.CHEQUE\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.CREDIT/DEBIT_CARD\'|translate}}\">{{\'BILLING_REPORT.CREDIT/DEBIT_CARD\'|translate}}</md-option>\n<md-option value=\"{{\'BILLING_REPORT.PAYPAL\'|translate}}\">{{\'BILLING_REPORT.PAYPAL\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.NETS\'|translate}}\">{{\'BILLING_REPORT.NETS\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.ONLINE_TRANSFER\'|translate}}\">{{\'BILLING_REPORT.ONLINE_TRANSFER\'|translate}}</md-option>\n<md-option value=\"{{\'BILLING_REPORT.OTHERS\'|translate}}\">{{\'BILLING_REPORT.OTHERS\'|translate}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"BILLING_REPORT.SEARCH_PAYMENT_TERMS\">\nSearch Payment Mode</label><md-select ng-model=\"vm.PaymentMode\" id=\"searchmodule\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">{{\'BILLING_REPORT.PAYMENT_TERMS\'|translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.PaymentMode = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nvalue=\"{{\'BILLING_REPORT.CASH_ON_DELIVERY\'|translate}}\">{{\'BILLING_REPORT.CASH_ON_DELIVERY\'|translate}}</md-option>\n<md-option value=\"{{\'BILLING_REPORT.NET_30\'|translate}}\">{{\'BILLING_REPORT.NET_30\'|translate}}</md-option><md-option \nvalue=\"{{\'BILLING_REPORT.CASH_IN_ADVANCE\'|translate}}\">{{\'BILLING_REPORT.CASH_IN_ADVANCE\'|translate}}</md-option>\n<md-option value=\"{{\'BILLING_REPORT.OTHERS\'|translate}}\">{{\'BILLING_REPORT.OTHERS\'|translate}}</md-option></md-select>\n</md-input-container></div><br><div layout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastmonth()\"><span translate=\"BILLING_REPORT.LAST_MONTH\">Last Month</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastweek()\"><span \ntranslate=\"BILLING_REPORT.LAST_WEEK\">Last Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Today()\"><span translate=\"BILLING_REPORT.TODAY\">Today</span></md-button>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"NextWeek()\"><span \ntranslate=\"BILLING_REPORT.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"BILLING_REPORT.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"BILLING_REPORT.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BILLING_REPORT.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"BILLING_REPORT.SEARCH\">Search</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"isLoading\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BILLING_REPORT.LAST_WEEK\" class=\"column-title\">\nService Report No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BILLING_REPORT.SERVICE_DATE\" class=\"column-title\">Service Date</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BILLING_REPORT.INVOICE_NO\" class=\"column-title\">Invoice No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BILLING_REPORT.INVOICE_DATE\" \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BILLING_REPORT.SALES_AMOUNT\" class=\"column-title\">Sales Amount</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BILLING_REPORT.INVOICE_AMOUNT\" class=\"column-title\">Invoice Amount</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BILLING_REPORT.OUTSTANDING_AMOUNT\" \nclass=\"column-title\">Outstanding Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BILLING_REPORT.STATUS\" class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Salesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">{{row.ServiceID}}\n</td><td nowrap=\"nowrap\">{{ row.ServiceDate}}</td><td nowrap=\"nowrap\">{{ row.InvoiceNumber }}</td><td>\n{{ row.InvoiceDate | date:\'dd/MM/y\' }}</td><td nowrap=\"nowrap\">$ {{ row.Amount || 0 |number:2 }}</td><td \nnowrap=\"nowrap\">$ {{ row.InvoiceAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.OutStandingAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">{{ row.Status }}</td></tr></tbody></table></div>\n</div></div></div><style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/generalledger/generalledger.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"JOURNALENTRY.HEADER\">Journal Entry</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{\'JOURNALENTRY.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"JOURNALENTRY.ADD\">Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"JOURNALENTRY.EXPORT\">Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"JOURNALENTRY.BACK\">Back</span></md-button></div></div><div \nclass=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\" ng-show=\"grid\"><br><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"PURCHASESPAYABLES.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"PURCHASESPAYABLES.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"PURCHASESPAYABLES.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"PURCHASESPAYABLES.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"PURCHASESPAYABLES.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"PURCHASESPAYABLES.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"PURCHASESPAYABLES.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"PURCHASESPAYABLES.SEARCH\">Search</span>\n</md-button></div></div><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Ledgerdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"JOURNALENTRY.TXN_DATE\" class=\"column-title\">Txn Date\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"JOURNALENTRY.TRANSACTION_DETAILS\" class=\"column-title\">Transaction Details</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"JOURNALENTRY.ACCOUNT_CODE\" class=\"column-title\">\nAccount Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"JOURNALENTRY.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"JOURNALENTRY.VOUCHER_NUMBER\" class=\"column-title\">\nVoucher Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"JOURNALENTRY.DEBIT\" class=\"column-title\">Debit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"JOURNALENTRY.CREDIT\" class=\"column-title\">Credit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"JOURNALENTRY.BALANCE\" class=\"column-title\">Balance\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"JOURNALENTRY.VIEW/EDIT\" \nclass=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Ledgerdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\">{{ row.TransactionDate | date:\"dd/MM/y\" }}</td><td \nnowrap=\"nowrap\">{{ row.Description}}</td><td nowrap=\"nowrap\">{{ row.Accountdetails[0].AccountCode }}</td><td \nnowrap=\"nowrap\">{{ row.Accountdetails[0].AccountDescription }}</td><td>{{ row.JournalVoucherNumber}}</td><td \nnowrap=\"nowrap\">$ {{ row.DebitAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.CreditAmount || 0 |number:2 }}\n</td><td nowrap=\"nowrap\">$ {{ row.BalanceAmount || 0 |number:2 }}</td><td class=\"editMe\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Ledgerinfo(row._id)\"><md-icon\n md-font-icon=\"icon-pencil\" ng-click=\"Ledgerinfo(row._id)\"></md-icon></md-button></td></tr></tbody></table></div></div>\n<div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"form\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px\" id=\"Add\"><label translate=\"JOURNALENTRY.TXN_DATE\">Transaction Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"TransactionDate\" id=\"Add\" class=\"Add\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"Description\" \nplaceholder=\"{{\'JOURNALENTRY.TRANSACTION_DETAILS\'|translate}}\"></md-input-container><md-input-container flex><label \ntranslate=\"JOURNALENTRY.ACCOUNTING_CODE\">Accounting Code</label><md-select ng-model=\"AccountingCode\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"text\" \nplaceholder=\"{{\'JOURNALENTRY.SEARCH_FOR_A_ACCOUNT..\'|translate}}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in ChartofAccountatas  | filter:searchTerm\" value=\"{{row._id}}\">\n{{row.AccountCode}} - {{row.AccountDescription}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" name=\"JournalVoucherNumber\" \nng-model=\"JournalVoucherNumber\" placeholder=\"{{\'JOURNALENTRY.JOURNAL VOUCHER NUMBER\'|translate}}\"></md-input-container>\n<md-input-container flex style=\"margin-top: -3px\"><label translate=\"JOURNALENTRY.TYPE\">TYPE</label><md-radio-group \nng-model=\"TransactionType\" layout=\"row\"><md-radio-button value=\"{{\'JOURNALENTRY.CREDIT\'|translate}}\">\n{{\'JOURNALENTRY.CREDIT\'|translate}}</md-radio-button><md-radio-button value=\"{{\'JOURNALENTRY.DEBIT\'|translate}}\">\n{{\'JOURNALENTRY.DEBIT\'|translate}}</md-radio-button></md-radio-group></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"Amount\" placeholder=\"{{\'JOURNALENTRY.AMOUNT\'|translate}}\" required></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{\'JOURNALENTRY.REMARKS\'|translate}}\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{\'JOURNALENTRY.SUBMIT\'|translate}}</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">{{\'JOURNALENTRY.CANCEL\'|translate}}</md-button></div></form></div></div></div>\n</div></div><style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(28vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/profitloss/profitloss.html","<div id=\"profitloss\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"BALANCE_SHEET.HEADER\">\nBalance Sheet</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{\'BALANCE_SHEET.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng0show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"BALANCE_SHEET.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"BALANCE_SHEET.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"BALANCE_SHEET.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"BALANCE_SHEET.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"BALANCE_SHEET.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"BALANCE_SHEET.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"BALANCE_SHEET.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\" id=\"Datefilter\"><label translate=\"BALANCE_SHEET.TO\" style=\"color:green;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker>\n</md-input-container><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span \ntranslate=\"BALANCE_SHEET.SEARCH\">Search</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Uniqueledgersummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BALANCE_SHEET.ACCOUNT_CODE\" class=\"column-title\">Account Group</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"BALANCE_SHEET.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"BALANCE_SHEET.ACCOUNT_DESCRIPTION\" \nclass=\"column-title\">Account Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BALANCE_SHEET.DEBIT\" class=\"column-title\">Debit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BALANCE_SHEET.CREDIT\" class=\"column-title\">Credit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Uniqueledgersummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nnowrap=\"nowrap\">{{ row.AccountGroup }}</td><td><a href=\"\" style=\"border:none\">{{ row.AccountCode }}</a></td><td \nnowrap=\"nowrap\">{{ row.AccountDescription }}</td><td nowrap=\"nowrap\">$ {{ row.DebitAmountTotal || 0 |number:2 }}</td>\n<td nowrap=\"nowrap\">$ {{ row.CreditAmountTotal || 0 |number:2 }}</td></tr></tbody></table></div></div></div></div>\n<style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/trailbalance/trailbalance.html","<div id=\"trailbalance\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"TRAILBALANCE.HEADER\">Trail Balance</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"TRAILBALANCE.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"TRAILBALANCE.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"TRAILBALANCE.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"TRAILBALANCE.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"TRAILBALANCE.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"TRAILBALANCE.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"TRAILBALANCE.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\" id=\"Datefilter\"><label translate=\"TRAILBALANCE.TO\" style=\"color:green;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker>\n</md-input-container><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span \ntranslate=\"TRAILBALANCE.SEARCH\">Search</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Uniqueledgersummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"TRAILBALANCE.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"TRAILBALANCE.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"TRAILBALANCE.DEBIT\" \nclass=\"column-title\">Debit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"TRAILBALANCE.CREDIT\" class=\"column-title\">Credit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Uniqueledgersummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nstyle=\"border:none\">{{ row.AccountCode }}</a></td><td nowrap=\"nowrap\">{{ row.AccountDescription }}</td><td \nnowrap=\"nowrap\">$ {{ row.DebitAmountTotal || 0 |number:2 }}</td><td nowrap=\"nowrap\">\n$ {{ row.CreditAmountTotal || 0 |number:2 }}</td></tr></tbody></table></div></div></div></div><style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/reconciliation/reconciliation.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"BANK_RECONCILIATION.HEADER\">Bank Reconciliation\n</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{\'BANK_RECONCILIATION.SEARCH\'|translate}}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"ReconciliationExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"BANK_RECONCILIATION.EXPORT\">Export</span></md-button></div></div>\n<div class=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\" ng-show=\"grid\"><br><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"BANK_RECONCILIATION.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"BANK_RECONCILIATION.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"BANK_RECONCILIATION.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"BANK_RECONCILIATION.NEXT_WEEK\">Next Week</span></md-button><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"BANK_RECONCILIATION.NEXT_MONTH\">\nNext Month</span></md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\">\n<label translate=\"BANK_RECONCILIATION.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label translate=\"BANK_RECONCILIATION.TO\" \nstyle=\"color:green;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span translate=\"BANK_RECONCILIATION.SEARCH\">Search</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANK_RECONCILIATION.LEDGER\" class=\"column-title\">Ledger</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"BANK_RECONCILIATION.DATE\" class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"BANK_RECONCILIATION.PARTICULARS\" \nclass=\"column-title\">Particulars</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"BANK_RECONCILIATION.VCH_TYPE\" class=\"column-title\">Vch Type</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span translate=\"BANK_RECONCILIATION.TRANSACTION_TYPE\" class=\"column-title\">Transaction Type\n</span></div></th><th class=\"secondary-text\"><div><span translate=\"BANK_RECONCILIATION.INSTRUMENT_NO\" \nclass=\"column-title\">Instrument No</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"BANK_RECONCILIATION.INSTRUMENT_DATE\" class=\"column-title\">Instrument Date</span></div></th><th \nclass=\"secondary-text\"><div><span translate=\"BANK_RECONCILIATION.BANK_DATE\" class=\"column-title\">Bank Date</span></div>\n</th><th class=\"secondary-text\"><div><span translate=\"BANK_RECONCILIATION.DEBIT\" class=\"column-title\">Debit</span>\n</div></th><th class=\"secondary-text\"><div><span translate=\"BANK_RECONCILIATION.CREDIT\" class=\"column-title\">Credit\n</span></div></th></tr></thead><tbody><tr><td>1</td><td>DBS Bank</td><td>29/05/2015</td><td>Sales Invoice</td><td>\nOpening BRS</td><td>Cheque/DD</td><td>000122</td><td>29/05/2015</td><td></td><td>10,0000.00</td><td></td></tr><tr><td>2\n</td><td>DBS Bank</td><td>30/06/2015</td><td>Advertisement charges</td><td>Opening BRS</td><td>Cheque/DD</td><td></td>\n<td>30/06/2015</td><td></td><td>22,898.00</td><td></td></tr><tr><td>3</td><td>DBS Bank</td><td>09/07/2015</td><td>\nFurniture & Fittings</td><td>Opening BRS</td><td>Cash</td><td>086453</td><td>09/07/2015</td><td></td><td></td><td>\n67,000.00</td></tr></tbody></table></div></div></div></div></div><style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/accounts/reports/viewgeneralledger/ledgerSaleshistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALLEDGER.LEDGER TRANSACTION HISTORY\" class=\"title\">LEDGER TRANSACTION HISTORY</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.VOUCHER_NUMBER\" class=\"column-title\">Voucher Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.VOUCHER_DATE\" class=\"column-title\">\nVoucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.INVOICE_NUMBER..\" class=\"column-title\">Invoice Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.CUSTOMER_CODE\" class=\"column-title\">\nCustomer Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.CUSTOMER_NAME\" class=\"column-title\">Customer Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"GENERALLEDGER.DEBIT\" class=\"column-title\">Debit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.CREDIT\" class=\"column-title\">Credit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in deatilgrid\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.JournalVoucherNumber }}</td><td>{{ row.TransactionDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.SalesInvoicedetails[0].InvoiceNumber }}</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CustomerReference }}\n</td><td nowrap=\"nowrap\">{{ row.Customerdetails[0].CompanyName }}</td><td nowrap=\"nowrap\">\n$ {{ row.DebitAmount || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.CreditAmount || 0 |number:2 }}</td></tr>\n</tbody></table></div><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\" class=\"md-raised md-accent\">Close</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/accounts/reports/viewgeneralledger/ledgerpayableshistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"GENERALLEDGER.LEDGER TRANSACTION HISTORY\" class=\"title\">LEDGER TRANSACTION HISTORY</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.VOUCHER_NUMBER\" class=\"column-title\">Voucher Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.VOUCHER_DATE\" class=\"column-title\">\nVoucher Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.INVOICE_NUMBER..\" class=\"column-title\">Invoice Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.SUPPLIER_CODE\" class=\"column-title\">\nSupplier Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.SUPPLIER_NAME\" class=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"GENERALLEDGER.DEBIT\" class=\"column-title\">Debit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.CREDIT\" class=\"column-title\">Credit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in deatilgrid\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.JournalVoucherNumber }}</td><td>{{ row.TransactionDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.PurchaseInvoicedetails[0].InvoiceNumber }}</td><td nowrap=\"nowrap\">{{ row.Supplierdetails[0].ReferenceNo }}</td>\n<td nowrap=\"nowrap\">{{ row.Supplierdetails[0].Name }}</td><td nowrap=\"nowrap\">$ {{ row.DebitAmount || 0 |number:2 }}\n</td><td nowrap=\"nowrap\">$ {{ row.CreditAmount || 0 |number:2 }}</td></tr></tbody></table></div><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-accent\">{{\'GENERALLEDGER.CLOSE\'|translate}}</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/accounts/reports/viewgeneralledger/viewgeneralledger.html","<div id=\"viewgeneralledger\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"GENERALLEDGER.HEADER\">General Ledger</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'GENERALLEDGER.SEARCH\'|translate}}\" flex>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"GENERALLEDGER.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card product-detail-form-container md-background-bg md-whiteframe-14dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"GENERALLEDGER.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"GENERALLEDGER.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"GENERALLEDGER.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"GENERALLEDGER.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"NextMonth()\"><span translate=\"GENERALLEDGER.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \ntranslate=\"GENERALLEDGER.FROM\" style=\"color:green;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\" id=\"Datefilter\"><label translate=\"GENERALLEDGER.TO\" style=\"color:green;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker>\n</md-input-container><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"InvoiceFilter()\"><span \ntranslate=\"GENERALLEDGER.SEARCH\">Search</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Uniqueledgersummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.ACCOUNT_CODE\" class=\"column-title\">Account Code</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span translate=\"GENERALLEDGER.ACCOUNT_DESCRIPTION\" class=\"column-title\">Account Description\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span translate=\"GENERALLEDGER.DEBIT\" \nclass=\"column-title\">Debit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"GENERALLEDGER.CREDIT\" class=\"column-title\">Credit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span translate=\"GENERALLEDGER.BALANCE\" class=\"column-title\">Balance</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Uniqueledgersummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewLedgerHistory($event, row._id,row.LedgerType)\" title=\"Detail Grid\" style=\"border:none\">\n{{ row.AccountCode }}</a></td><td nowrap=\"nowrap\">{{ row.AccountDescription }}</td><td nowrap=\"nowrap\">\n$ {{ row.DebitAmountTotal || 0 |number:2 }}</td><td nowrap=\"nowrap\">$ {{ row.CreditAmountTotal || 0 |number:2 }}</td>\n<td nowrap=\"nowrap\">$ {{ row.Balance || 0 |number:2 }}</td></tr></tbody></table></div></div></div></div><style>\n#Add md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } \r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    } \r\n    .md-inline-form md-checkbox {\r\n        margin: 0px 0 6px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    tr.group,\r\n    tr.group:hover {\r\n        background-color: grey !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    } \r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    } \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    } \r\n    button#button {\r\n        margin-bottom: 50px;\r\n    } \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.eEventTitle}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"Eventupdate(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.eStartDate.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.eEndDate.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n</div></md-dialog-content></md-dialog><style>\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired md-autofocus><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float>\n<input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float>\n<input ng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container class=\"md-block\" flex>\n<label translate=\"CALENDAR.REPEAT\">Repeat</label><input ng-model=\"vm.calendarEvent.repeat\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.LOCATION\">Location</label><input \nng-model=\"vm.calendarEvent.location\"></md-input-container><div class=\"notifications\" layout=\"column\"><div \nclass=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div><md-select ng-model=\"notification\" \nplaceholder=\"Notification\" ng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option \nng-repeat=\"opt in vm.notifications\" value=\"{{opt}}\">{{opt}}</md-option></md-select><md-button \naria-label=\"+ Add Another Notification\" translate=\"CALENDAR.ADD_NOTIFICATION\" \ntranslate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification</md-button></div><md-input-container \nflex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea \nng-model=\"vm.task.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" \ntranslate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog><style>\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/crm/templates/contractstemplates/PestServiceDetail.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">PEST CONTROL SERVICES</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container style=\"margin-top: 18px\" \nflex><label>Pest Types</label><md-select ng-model=\"vm.PestType\" name=\"PestType\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.PestType = null;vm.searchTermP = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" value=\"{{row.PestName}}\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select \nng-model=\"vm.Frequency\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Materialadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/crm/templates/contractstemplates/contractpopup.html","<md-dialog style=\"width:50%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">PEST CONTROL SERVICES</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><form name=\"basicForm1\" flex \nclass=\"md-inline-form\" novalidate ng-show=\"Title1\"><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container \nstyle=\"margin-top: 18px\" flex><label>Pest Types</label><md-select ng-model=\"vm.T1PestType\" name=\"PestType\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermP\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.PestType = null;vm.searchTermP = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" value=\"{{row.PestName}}\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container style=\"margin-top: 18px\" flex><label>Frequency</label><md-select \nng-model=\"vm.T1Frequency\" name=\"Frequency\" id=\"searchmodule\" md-on-close=\"vm.searchfe = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchfe\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Frequency..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Frequency = null;vm.searchfe = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ScheduleFrequencydatas | filter:vm.searchfe\" value=\"{{row.Name}}\">{{row.Name}}</md-option>\n</md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"Title1Submit()\" aria-label=\"Submit\" ng-disabled=\"basicForm1.$invalid\" \ntranslate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form name=\"basicForm3\" flex \nclass=\"md-inline-form\" novalidate ng-show=\"Title3\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\">\n<md-input-container flex><label translate=\"CRMCONTRACTSTEMPLATES.AREA\">Area</label><md-select ng-model=\"vm.T3Area\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermP5 = \'\'\" required><md-select-header><input ng-model=\"vm.searchTermP5\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.AREA\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.T3Area = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in areasdatas | filter: vm.searchTermP5\" value=\"{{row.AreasName}}\">\n{{row.AreasName}}</md-option></md-select></md-input-container><md-input-container flex><label>Pest Type</label>\n<md-select ng-model=\"vm.T3PestType\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTermP4\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.PEST_TYPES\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.T3PestType = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Pestdatas | filter: vm.searchTermP4\" value=\"{{row.PestName}}\">\n{{row.PestName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3Quantity\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.QUANTITY\' | translate }}\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.T3Timing\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.TIMING\' | translate }}\"></md-input-container>\n<md-input-container flex><label translate=\"CRMCONTRACTSTEMPLATES.FREQUENCY\">Frequency</label><md-select \nng-model=\"vm.T3Frequency\" id=\"searchmodule\"><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\" translate=\"CRMCONTRACTSTEMPLATES.FREQUENCY\">Frequency..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.T3Frequency = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Daily\" \ntranslate=\"CRMCONTRACTSTEMPLATES.DAILY\">Daily</md-option><md-option value=\"Weekly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.WEEKLY\">Weekly</md-option><md-option value=\"Fortnightly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.FORTNIGHTLY\">Fortnightly</md-option><md-option value=\"Monthly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.MONTHLY\">Monthly</md-option><md-option value=\"Quarterly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.QUARTERLY\">Quarterly</md-option><md-option value=\"Half-Yearly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.HALF_YEARLY\">Half-Yearly</md-option><md-option value=\"Yearly\" \ntranslate=\"CRMCONTRACTSTEMPLATES.YEARLY\">Yearly</md-option></md-select></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.T3Pricing\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.PRICING\' | translate }}\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title3Submit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm3.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel\n</md-button></div></form><form name=\"basicForm4\" flex class=\"md-inline-form\" novalidate ng-show=\"Title4\"><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><label \ntranslate=\"CRMCONTRACTSTEMPLATES.PRODUCT\">Product</label><md-select ng-model=\"vm.T4Product\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTerm = \'\'\" required><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.SEARCH_FOR_A_PRODUCT\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.T4Product = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Productdatas | filter:vm.searchTerm\" value=\"{{row.ProductName}}\">\n{{row.ProductName}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T4NoOfPieces\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.NO_OF_PIECES\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.T4Pricing\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.PRICING\' | translate }}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title4Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm4.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form \nname=\"basicForm5\" flex class=\"md-inline-form\" novalidate ng-show=\"Title5\"><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.T5Description\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.DESCRIPTION\' | translate }}\" required></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.T5Quantity\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.QUANTITY\' | translate }}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.T5Rate\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.RATE\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.T5Amount\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.AMOUNT\' | translate }}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title5Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm5.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form \nname=\"basicForm6\" flex class=\"md-inline-form\" novalidate ng-show=\"Title6\"><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.T6Description\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.DESCRIPTION\' | translate }}\" required></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.T6Price\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.PRICE\' | translate }}\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title6Submit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm6.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel\n</md-button></div></form><form name=\"basicForm7\" flex class=\"md-inline-form\" novalidate ng-show=\"Title7\"><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.T7SerialNo\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.SERIAL_NO\' | translate }}\" required>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.T7ForModelNo\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.FOR_MODEL_NO\' | translate }}\" required></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.T7LeasePerAnnum\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.LEASE_PER_ANNUM\' | translate }}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"CRMCONTRACTSTEMPLATES.EFFECTIVE_DATE\">Effective Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.T7EffectiveDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"CRMCONTRACTSTEMPLATES.EXPIRY_DATE\">Expiry Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.T7ExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title7Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm7.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form \nname=\"basicForm8\" flex class=\"md-inline-form\" novalidate ng-show=\"Title8\"><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.T8ForModelNo\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.FOR_MODEL_NO\' | translate }}\" required></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.T8NoOfBoardsNeeded\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.NO_OF_BOARDS_NEEDED\' | translate }}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.T8SellingPricing\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.SELLING_PRICE\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.T8Lifespan\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.LIFESPAN\' | translate }}\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title8Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm8.$invalid\" translate=\"CRMCONTRACTSTEMPLATES.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form>\n</md-dialog-actions></md-dialog><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 85px;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(26vw - 32px);\r\nmax-width: calc(35vw - 54px);\r\nmargin-left: -11px;\r\n}\n</style>");
$templateCache.put("app/main/apps/crm/templates/contractstemplates/contractstemplates.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Contract Templates</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CRMCONTRACTSTEMPLATES.TOTAL_CONTRACTS\">Total Templates:</span> <span>{{Contracttemplates.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'CRMCONTRACTSTEMPLATES.SEARCH\' | translate }}\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span translate=\"CRMCONTRACTSTEMPLATES.ADD\">Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span translate=\"CRMCONTRACTSTEMPLATES.BACK\">Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"CRMCONTRACTSTEMPLATES.EXPORT\">Export</span></md-button></div>\n</div><div class=\"content-card\" ng-show=\"ContractsTemplatesgrid\"><div id=\"qmaintable\" \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Contracttemplates\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"table dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.TEMPLATE_NAME\">Template Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CREATED_BY\">Created By</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.CREATED_DATE\">Created Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.VIEW\">View</span></div></th><th\n class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.CLONE\">Clone</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.EDIT\">Edit</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMCONTRACTSTEMPLATES.DELETE\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Contracttemplates\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}\n</td><td>{{ row.TemplateName }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y hh:mm a\' }}</td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Preview(row.id, \'invoice\')\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Clone(row.id)\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"templateinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Delete(row.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div class=\"content\" ng-show=\"ContractsTemplatesform\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.TemplateName\" \nplaceholder=\"{{ \'CRMCONTRACTSTEMPLATES.TEMPLATE_NAME\' | translate }}\" required></md-input-container><p \nng-show=\"error1\" style=\"color:red\" translate=\"CRMCONTRACTSTEMPLATES.TEMPLATE_NAME_IS_ALREADY_EXIST\">\nTemplate Name Is already Exist.</p></div><span class=\"h3\" style=\"color:#7f9593\"><b>BODY :</b></span><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Header\" class=\"pb-32\"></text-angular><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-button type=\"submit\" ng-click=\"sSubmit()\" class=\"md-raised md-accent\" \nng-disabled=\"!vm.TemplateName\" translate=\"CRMCONTRACTSTEMPLATES.SAVE\">Save</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form></div>\n</div></div></div></div><div class=\"content\" id=\"invoice\" ng-show=\"Previewdiv\"><div style=\"height:100px\"><div \nstyle=\"width:auto\"></div><div style=\"font-size:25px;font-weight:500;float:right\"><img ng-src=\"{{logo}}\" \nstyle=\"width:200px;height:100px\"></div></div><h3 style=\"font-weight: 600;text-align:center\"><b>\nPEST MANAGEMENT SERVICE CONTRACT</b></h3><div style=\"font-size:17px;text-align:left\"></div><div class=\"printtextarea\">\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Header\" ng-disabled class=\"pb-32\"></text-angular></div></div>\n<style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label > md-datepicker .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px -6px;\r\n    }\r\n\r\n    table {\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    #example table.dataTable tbody td {\r\n        padding: 2px 8px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    table.dataTable {\r\n        border-bottom: 0;\r\n        border-top: 0;\r\n    }\r\n\r\n    textarea {\r\n        width: 85%;\r\n        height: 100px;\r\n        padding: 30px 20px;\r\n        resize: none;\r\n        font-size: 17px;\r\n    }\r\n\r\n    [disabled] md-input-container.md-default-theme .md-input, [disabled] md-input-container .md-input, md-input-container.md-default-theme .md-input[disabled], md-input-container .md-input[disabled] {\r\n        border-bottom-color: transparent;\r\n        border-bottom: 1px solid #e0e0e0;\r\n        color: rgba(0,0,0,0.38);\r\n        background-image: linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0);\r\n        background-image: -ms-linear-gradient(left,transparent 0,rgba(0,0,0,0.38) 100%);\r\n    }\r\n\r\n    .md-button.md-default-theme.md-primary.md-fab, .md-button.md-primary.md-fab, .md-button.md-default-theme.md-primary.md-raised, .md-button.md-primary.md-raised {\r\n        color: rgb(255, 255, 255);\r\n        background-color: rgba(8, 73, 68, 0.75);\r\n    }\r\n\r\n    .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #qmaintable .dataTables_wrapper .bottom {\r\n        display: flex;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/crm/templates/quotation/TermsAndCondition.html","<md-dialog style=\"width:95%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMQUOTATION.ADD_TERMS_CONDITIONS\">Add Terms & Conditions</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><div layout-gt-xs=\"row\" layout=\"column\" \nlayout-align=\"start center\"><md-input-container flex style=\"margin-bottom:0\"><input type=\"text\" ng-model=\"vm.Name\" \nplaceholder=\"{{\'CRMQUOTATION.NAME\' | translate}}\" required></md-input-container></div><span class=\"h3\" \nstyle=\"color:#7f9593\" translate=\"CRMQUOTATION.TERMS_CONDITIONS\">Terms & Conditions :</span><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"vm.AddTermsCondition\" class=\"pb-32\"></text-angular><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"TermsAndConditionSubmit()\" \nng-disabled=\"!vm.Name\"><span translate=\"CRMQUOTATION.SUBMIT\">Submit</span></md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\"><span translate=\"CRMQUOTATION.CANCEL\">Cancel</span></md-button></div><br><div \nlayout-gt-xs=\"row\" layout=\"column\" layout-align=\"start center\" style=\"height: 45px\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.Searchtc\" placeholder=\"{{\'CRMQUOTATION.SEARCHHERE\' | translate}}\"></md-input-container>\n<md-input-container flex></md-input-container></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" \nstyle=\"font-size:smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12);border-top: 1px solid rgba(0, 0, 0, 0.12)\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CRMQUOTATION.NAME\">Name</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CRMQUOTATION.TERMS_CONDITIONS\">Terms & Conditions</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATION.ACTION\">Action</span></div></th></tr>\n</thead><tbody style=\"border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\"><tr \nng-repeat=\"row in TermsAndConditiondatas | filter:vm.Searchtc\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Name}}</td><td>{{ row.TermsCondition | htmlToPlaintext}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"TermsAndConditioninfo(row.id,row.Name,row.TermsCondition)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></md-dialog-content></form></md-dialog><style>\nmd-dialog {\r\n    opacity: 0;\r\n    min-width: 240px;\r\n    max-width: 95%;\r\n    max-height: 95%;\r\n    }</style>");
$templateCache.put("app/main/apps/crm/templates/quotation/description.html","<md-dialog style=\"width:100%;overflow:unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CRMQUOTATION.ADD_DESCRIPTION\">Add Description</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0.5% 1% 0.5% 1%\"><div layout-gt-xs=\"row\" layout=\"column\" layout-align=\"start center\"><md-input-container\n flex><input type=\"text\" ng-model=\"vm.AddDescription\" placeholder=\"{{\'CRMQUOTATYION.DESCRIPTION\' | translate}}\" \nrequired></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nstyle=\"margin-top: -1.6%\" ng-click=\"AddDescriptionSubmit()\" ng-disabled=\"!vm.AddDescription\"><span \ntranslate=\"CRMQUOTATION.SAVE\">Save</span></md-button></div><div layout-gt-xs=\"row\" layout=\"column\" \nlayout-align=\"start center\" style=\"height: 45px\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.SearchDescription\" placeholder=\"{{\'CRMQUOTATYION.SEARCH_HERE\' | translate}}\"></md-input-container>\n<md-input-container flex></md-input-container></div><table class=\"dataTable row-border hover\" \nstyle=\"font-size:smaller;border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12);border-top: 1px solid rgba(0, 0, 0, 0.12)\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATYION.DESCRIPTION\">Description\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATYION.DELETE\">Delete\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATYION.SELECT\">Select\n</span></div></th></tr></thead><tbody \nstyle=\"border-left: 1px solid rgba(0, 0, 0, 0.12);border-right: 1px solid rgba(0, 0, 0, 0.12)\"><tr \nng-repeat=\"row in Descriptiondatas | filter:vm.SearchDescription\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.Descriptions}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"AddDescriptionDelete(row.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td><td><md-button class=\"md-raised md-background\" style=\"margin:0\" ng-click=\"LoadDesc(row.Descriptions)\">\n<span translate=\"CRMQUOTATYION.CHOOSE\">Choose</span></md-button></td></tr></tbody></table></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/crm/templates/quotation/quotation.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span translate=\"CRMQUOTATION.HEADER\">Quotation Template</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CRMQUOTATION.TOTAL_QUOTATION\">Total Templates:</span> <span>{{Quotationtemplates.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'CRMQUOTATION.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"CRMQUOTATION.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"CRMQUOTATION.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"CRMQUOTATION.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" ng-show=\"Quotationgrid\">\n<div id=\"qmaintable\" class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Quotationtemplates\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"table dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATION.TEMPLATE_NAME\">Template Name</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMQUOTATION.CREATED_DATE\">\nCreated Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMQUOTATION.CREATED_BY\">Created By</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMQUOTATION.PREVIEW\">Preview</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMQUOTATION.CLONE\">Clone</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMQUOTATION.EDIT\">Edit</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMQUOTATION.DELETE\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Quotationtemplates\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.TemplateName }}\n</td><td>{{ row.CreatedDate | date : \'dd/MM/y hh:mm a\' }}</td><td>{{ row.CreatedBy }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Preview(row.id, \'invoice\')\">\n<md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Clone(row.id)\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"templateinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Delete(row.id)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\" \nng-show=\"Quotationform\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.TemplateName\" placeholder=\"{{ \'CRMCONTRACTS.TEMPLATE_NAME\' | translate }}\" required><p ng-show=\"error1\" \nstyle=\"color:red\" translate=\"CRMQUOTATION.TEMPLATE_NAME_IS_ALREADY_EXIST\">Template Name Is already Exist.</p>\n</md-input-container><md-input-container flex><label translate=\"CRMQUOTATION.DIVISION\">Division</label><md-select \nng-model=\"vm.Division\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchDivision\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'CRMQUOTATION.SEARCH_FOR_A_DIVISION\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.Division = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Divisiondatas | filter:vm.searchDivisionsearchCC\" value=\"{{row.id}}\">{{row.DivisionName}}</md-option>\n</md-select></md-input-container></div><material-input-group style=\"margin-top: -25px;margin-bottom: -15px\" \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><span flex=\"7\" class=\"h3\" style=\"color:#7f9593\" \ntranslate=\"CRMQUOTATION.SUBJECT\"><b>Subject:</b></span>&emsp;<md-input-container style=\"margin-top: 9px\" flex><input \ntype=\"text\" style=\"font-weight:bold;border-bottom:1px solid #ddd\" ng-model=\"vm.Subject\" flex></md-input-container>\n</material-input-group><span class=\"h3\" style=\"color:#7f9593\" translate=\"CRMQUOTATION.HEAD\"><b>HEADER :</b></span>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Header\" class=\"pb-32\"></text-angular><br><span class=\"h3\" \nstyle=\"color:#7f9593\" translate=\"CRMQUOTATION.FOOTER\"><b>FOOTER :</b></span><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.Footer\" class=\"pb-32\"></text-angular><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\">\n<md-button type=\"submit\" ng-click=\"sSubmit()\" class=\"md-raised md-accent\" ng-disabled=\"!vm.TemplateName\" \ntranslate=\"CRMQUOTATION.SAVE\">Save</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" \ntranslate=\"CRMQUOTATION.CANCEL\">Cancel</md-button></div></form></div></div><br></div></div></div><div class=\"content\" \nid=\"invoice\" ng-show=\"Previewdiv\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b style=\"padding-left:300px\"> <span \ntranslate=\"CRMQUOTATION.QUOTATION_CAPS\">QUOTATION</span></b></div><h3 style=\"font-weight: 600;margin:0px\">{{Subject}}\n</h3><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Header\" ng-disabled class=\"pb-32\">\n</text-angular></div><br><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.Footer\" \nng-disabled class=\"pb-32\"></text-angular></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label > md-datepicker .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input, .md-hue-1 .md-datepicker-input {\r\n        background: none !important;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px -6px;\r\n    }\r\n\r\n    table {\r\n        border-collapse: collapse;\r\n    }\r\n\r\n    #example table.dataTable tbody td {\r\n        padding: 2px 8px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    table.dataTable {\r\n        border-bottom: 0;\r\n        border-top: 0;\r\n    }\r\n\r\n    textarea {\r\n        width: 85%;\r\n        height: 100px;\r\n        padding: 30px 20px;\r\n        resize: none;\r\n        font-size: 17px;\r\n    }\r\n\r\n    [disabled] md-input-container.md-default-theme .md-input, [disabled] md-input-container .md-input, md-input-container.md-default-theme .md-input[disabled], md-input-container .md-input[disabled] {\r\n        border-bottom-color: transparent;\r\n        border-bottom: 1px solid #e0e0e0;\r\n        color: rgba(0,0,0,0.38);\r\n        background-image: linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0);\r\n        background-image: -ms-linear-gradient(left,transparent 0,rgba(0,0,0,0.38) 100%);\r\n    }\r\n\r\n    .md-button.md-default-theme.md-primary.md-fab, .md-button.md-primary.md-fab, .md-button.md-default-theme.md-primary.md-raised, .md-button.md-primary.md-raised {\r\n        color: rgb(255, 255, 255);\r\n        background-color: rgba(8, 73, 68, 0.75);\r\n    }\r\n\r\n    .ta-scroll-window > .ta-bind {\r\n        height: auto;\r\n        min-height: 80px;\r\n        padding: 6px 12px;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control {\r\n        min-height: 100px;\r\n        height: auto;\r\n        overflow: auto;\r\n        font-family: inherit;\r\n        font-size: 100%;\r\n    }\r\n\r\n    .file-input {\r\n        display: none;\r\n    }\r\n\r\n    .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    #qmaintable .dataTables_wrapper .bottom {\r\n        display: flex;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        width: 100% !important; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/crm/templates/quotation/quotationpopup.html","<md-dialog style=\"width:50%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{TableTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions><form name=\"basicForm2\" flex \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"height:80px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.T3Description\" placeholder=\"Description of Work\" required></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3Quantity\" placeholder=\"Quantity\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.T3UnitRate\" placeholder=\"Unit Rate\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Title3Submit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm2.$invalid\" translate=\"CRMQUOTATION.SUBMIT\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMQUOTATION.CANCEL\">Cancel</md-button></div></form>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/crm/templates/sormaster/alert.html","<md-dialog style=\"width:30%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Delete</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate>\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:0.5% 1% 0.5% 1%\"><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><span \nstyle=\"font-size:17px;color:#7f9593;padding-bottom:5px\">Are you sure you want to delete this data?</span></div><br><div\n class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"Delete()\">Yes\n</md-button><md-button ng-click=\"cancel()\" class=\"md-raised\">No</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/crm/templates/sormaster/sormaster.html","<div id=\"sormaster\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span>Standard Schedule of Rates</span></div><div class=\"product-count secondary-text\">\n<span>Total SOR : </span><span>{{Sordatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"addbtn\" ng-click=\"addnameclk()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span>Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"exportbtn && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"SorGrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Sordatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nRate During Office Hour</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nRate After Office Hour</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Sordatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{row.Description}}</td><td>\n{{ row.Unit }}</td><td>{{ row.RateDuringOfficeHour }}</td><td>{{ row.RateAfterOfficeHour }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" ng-click=\"pestinfo(row._id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" ng-click=\"DeletePopup($event, row._id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"pesttypeform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"Description\" placeholder=\"Description\" required></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Unit\" ng-model=\"Unit\" placeholder=\"Unit\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex><input type=\"number\" name=\"RateOfficeHour\" ng-model=\"RateOfficeHour\" placeholder=\"Rate During Office Hour\" \nrequired></md-input-container><md-input-container flex><input type=\"number\" name=\"RateAfterOfficeHour\" \nng-model=\"RateAfterOfficeHour\" placeholder=\"Rate After Office Hour\" required></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button ng-click=\"cancelbtnclk()\" class=\"md-raised\">Cancel\n</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/apps/operations/services-master/services-jobs/service-jobs.html","<div id=\"forms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Services</span></div><div class=\"product-count secondary-text\"><span>Total Servicess:</span> <span>\n{{Servicesdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span>Add</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"Export\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span>View</span></md-button></div>\n</div><div class=\"content-card\" ng-show=\"Servicesgrid\"><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Services Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div><span>Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Servicesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ServicesName }}</td><td>{{ row.ServicesCode }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Servicesinfo(row.id)\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nclass=\"content\"><div layout=\"row\"></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(41vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/report/BirdsCount/BirdsCount.html","<div id=\"BirdsCount\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Birds and Rodents Count</span>\n</div><div class=\"product-count secondary-text\"><span>Total Records: </span><span>{{BirdsandRodentsReportdatas.length}}\n</span></div></div><div class=\"search\" layout=\"row\" style=\"margin-top:30px\" layout-align=\"end right\" flex>\n<md-input-container id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nstyle=\"max-height:35px !important; min-height:35px !important;margin-top: 3%\" class=\"md-raised md-background\" \nng-click=\"Datefilter()\"><span>Search</span></md-button></div></div><div class=\"content-card\"><div \nclass=\"white-bg md-whiteframe-4dp\"><br><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"dataContainer\" dx-data-grid=\"vm.dataGrid\"></div></div></div></div></div><style>\nbutton#button {\r\n      margin-bottom: 50px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n      width: calc(22vw - 33px);\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: 1px;\r\n    }\r\n\r\n    .file-input {\r\n      display: none !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n      width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n      border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n      color: white !important;\r\n      border-bottom-color: white !important;\r\n    }\r\n\r\n    #example tr td {\r\n      height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n      margin: -16px 8px;\r\n    }\r\n\r\n    /*table.dataTable tbody tr.odd {\r\n          display: none;\r\n      }*/\r\n\r\n    #viewedit.md-button {\r\n      margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n      width: calc(27.2vw - 35px);\r\n      max-width: calc(35vw - 54px);\r\n      margin-left: -11px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n      color: rgba(0, 0, 0, 0.87);\r\n      background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n      right: 84px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n      display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/report/ConsumptionReport/ConsumptionReport.html","<div id=\"ConsumptionReport\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Consumption Report\n</span></div><div class=\"product-count secondary-text\"><span>Total Records: </span><span>\n{{ConsumptionReportdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" style=\"margin-top:30px\" \nlayout-align=\"end right\" flex><md-input-container id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From\n</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important;margin-top: 3%\" \nclass=\"md-raised md-background\" ng-click=\"Datefilter()\"><span>Search</span></md-button></div></div><div \nclass=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"dataContainer\" dx-data-grid=\"vm.dataGrid\"></div></div></div></div></div><style>\nbutton#button {\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(22vw - 33px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: 1px;\r\n  }\r\n\r\n  .file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #example tr td {\r\n    height: 30px;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  md-datepicker .md-datepicker-input {\r\n    width: calc(27.2vw - 35px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\n</style><style>\n#viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n\r\n  tr.group,\r\n  tr.group:hover {\r\n    background-color: grey !important;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/report/detailanalytical/detailanalytical.html","<div id=\"detailanalytical\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>\nDetail Analytical Report</span></div><div class=\"product-count secondary-text\"><span>Total Records: </span><span>\n{{Feedbackdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" style=\"margin-top:30px\" \nlayout-align=\"end right\" flex><md-input-container id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From\n</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">To</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container>\n<md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important;margin-top: 3%\" \nclass=\"md-raised md-background\" ng-click=\"Datefilter()\"><span>Search</span></md-button></div></div><div \nclass=\"content-card\"><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nid=\"dataContainer\" dx-data-grid=\"vm.dataGrid\"></div></div></div></div><style>\n.file-input {\r\n    display: none !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  #example tr td {\r\n    height: 30px;\r\n  }\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n\r\n  #viewedit.md-button {\r\n    margin: -16px 8px;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/report/rodentsSummary/rodentsSummary.html","<div id=\"monthlyproductivityreport\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Rodents Summary\n</span></div><div class=\"product-count secondary-text\"><span>Total Records: </span><span>{{RodentSummarydatas.length}}\n</span></div></div></div><div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><br><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height: 62px;margin:0 1% 0% 1%\" flex><md-input-container style=\"flex: 0.3\" flex><label>\nSearch Customer</label><md-select ng-model=\"CustomerName\" md-on-close=\"vm.searchTermC = \'\'\"><md-select-header><input \nstyle=\"flex: auto\" ng-model=\"vm.searchTermC\" type=\"text\" placeholder=\"Search For a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"CustomerName = undefined\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:vm.searchTermC\" ng-value=\"row.CompanyName\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container flex=\"1\"><label>From</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container \nflex=\"1\"><label>To</label><md-datepicker onkeydown=\"return false\" ng-model=\"uTo\"></md-datepicker></md-input-container>\n<md-icon md-font-icon=\"icon-code-less-than\" style=\"margin:19px 2px;margin-left:1%\" ng-click=\"ChangeDate(\'less\')\">\n</md-icon><md-icon md-font-icon=\"icon-code-greater-than\" style=\"margin:19px 2px\" ng-click=\"ChangeDate(\'greater\')\">\n</md-icon><md-button id=\"button\" style=\"max-height:35px !important; min-height:35px !important\" \nclass=\"md-raised md-background\" ng-click=\"SearchData();\"><span>Search</span></md-button><md-button id=\"button\" \nstyle=\"max-height:35px !important; min-height:35px !important\" class=\"md-raised md-background\" \nng-disabled=\"DownloadButton\" ng-click=\"DownloadImage();\"><span>Download Photos</span></md-button></div><div \nclass=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.YTSPreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div flex \nstyle=\"width:99%;padding-left:1%\"><span style=\"font-size:15px;color:#7f9593\"><b>Note&nbsp;:</b> </span><span \nstyle=\"font-size:14px;font-style:italic\">\nDOWNLOAD PHOTOS button will be enabled in 15 seconds after SEARCH button is pressed</span></div><div \nid=\"dataContainer\" dx-data-grid=\"vm.dataGrid\" dx-item-alias=\"employee\"></div></div></div></div></div><style>\nlabel {\r\n      padding-left: 10px !important;\r\n      font-size: 15px !important;\r\n      /*color: #000 !important;*/\r\n    }\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 0;\r\n  }\r\n\r\n  .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n    border-top-color: white !important;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    color: white !important;\r\n    border-bottom-color: white !important;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    background: none;\r\n  }\r\n\r\n  ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n  }\r\n\r\n  .md-datepicker-button {\r\n    display: none;\r\n  }\r\n\r\n  #Datefilter md-datepicker .md-datepicker-input {\r\n    width: 1;\r\n  }\n</style>");
$templateCache.put("app/main/apps/operations/trendingReports/pastTrendingReports/pastTrendingReports.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span>Past Trending Reports</span></div></div><div><md-button \nclass=\"md-raised reference-button\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back\n</span></md-button></div></div><div class=\"content\"><div layout=\"row\"><div class=\"md-scroll-mask\" \nstyle=\"z-index: 50;position: absolute;background-color: transparent;top: 0;right: 0;bottom: 0;left: 0\" \nng-if=\"vm.PreviewSpinner == true\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nstyle=\"z-index: 1000; position: fixed; margin-left: auto; margin-right: auto; left: 0; right: 0; top:40%\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Customer Name</label><md-select \nng-model=\"vm.Customer_Id\" name=\"CustomerName\" required md-on-close=\"vm.searchTermC = \'\'\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchTermC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'CRMSALESORDER.SEARCH_FOR_A_CUSTOMER\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.Customer_Id = null;vm.searchTermC = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in SalesOrderdatas | filter:vm.searchTermC\" ng-click=\"CustomerInfo(row)\" value=\"{{row.Customer_id}}\">\n{{row.customerdetails[0].CompanyName}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"SiteContactPerson\" ng-model=\"vm.SiteContactPerson\" placeholder=\"Site Contact Person\" \nreadonly=\"readOnly\"></md-input-container><md-input-container flex><input type=\"text\" name=\"SiteContactNumber\" \nreadonly=\"readOnly\" ng-model=\"vm.SiteContactNumber\" placeholder=\"Site Contact Number\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex ng-init=\"LoadDate()\"><md-input-container flex><input type=\"text\" \nname=\"ServiceLocation\" readonly=\"readOnly\" ng-model=\"vm.ServiceLocation\" placeholder=\"Service Location\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"SiteEmail\" ng-model=\"vm.SiteEmail\" \nplaceholder=\"Email\" readonly=\"readOnly\"></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;flex:0.62\"><label>From</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.StartDate\" \nmd-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;flex:0.62\"><label>To</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EndDate\" \nmd-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"end right\"><md-button class=\"md-raised md-accent md-background\" style=\"height:4%\" \nng-click=\"GenerateReport()\" ng-disabled=\"basicForm.$invalid\">Generate Report</md-button><md-button \nclass=\"md-raised md-background\" style=\"height:4%\" ng-click=\"Clear()\">Clear</md-button></div><br></form></div></div>\n</div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(17vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/trendingReports/pendingReports/Popup.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.Title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"basicForm\" flex \nclass=\"md-inline-form\" ng-if=\"vm.Title!=\'Edit Rodent Bait Station\' && vm.Title!=\'Send Report\'\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex><label>Pest Type</label><md-select \nng-model=\"vm.PestType\" name=\"PestType\" md-on-close=\"vm.searchTermP = \'\'\" required><md-select-header><input \nng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" placeholder=\"Pest Types..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.PestType = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" ng-value=\"row.PestName\">{{row.PestName}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" placeholder=\"Threshold\" ng-model=\"vm.Threshold\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"margin-bottom:15px\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Submit(vm.Title)\" aria-label=\"Ok\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" \ntranslate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form name=\"basicForm1\" flex \nclass=\"md-inline-form\" ng-if=\"vm.Title==\'Edit Rodent Bait Station\'\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" \nflex><md-input-container flex><input type=\"text\" placeholder=\"Location\" ng-model=\"vm.Location\"></md-input-container>\n<md-radio-container flex><md-radio-group ng-model=\"vm.BaitConsumed\" layout=\"row\" \nstyle=\"margin: 20px 0 0 0px;margin-left: 15px\" required><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 10px\">Bait Consumed? :</span><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group></md-radio-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Submit(vm.Title)\" \naria-label=\"Ok\" ng-disabled=\"basicForm1.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form><form name=\"basicForm2\" flex \nclass=\"md-inline-form\" ng-if=\"vm.Title==\'Send Report\'\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><input type=\"email\" placeholder=\"Email\" ng-model=\"vm.Email\" required></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SendEmail()\" \naria-label=\"Ok\" ng-disabled=\"basicForm2.$invalid\">Send</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form></md-dialog-content>\n</md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    li:first-letter {\r\n        text-transform: capitalize;\r\n    }\n</style>");
$templateCache.put("app/main/apps/operations/trendingReports/pendingReports/pendingReports.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span>Pending Reports</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"Search...\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Search && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span>\n</md-button></div></div><div class=\"content-card\" ng-show=\"PendingGrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"TabletTrendingDatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\"><thead><tr><th class=\"secondary-text\">\n<div><span>#</span></div></th><th class=\"secondary-text\"><div><span>Service Report #</span></div></th><th \nclass=\"secondary-text\"><div><span>Completed Date</span></div></th><th class=\"secondary-text\"><div><span>Customer Name\n</span></div></th><th class=\"secondary-text\"><div><span>Sales Person</span></div></th><th class=\"secondary-text\"><div>\n<span>Status</span></div></th><th class=\"secondary-text\"><div style=\"text-align: center\"><span>Edit</span></div></th>\n<th class=\"secondary-text\"><div style=\"text-align: center\"><span>Download</span></div></th><th class=\"secondary-text\">\n<div style=\"text-align: center\"><span>Send</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in TabletTrendingDatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nng-click=\"ViewInfo(row)\" style=\"border:none\">{{ row.ServiceID }}</a></td><td>\n{{ row.CompletedDate | date : \'dd/MM/y hh:mm a\' }}</td><td>{{ row.CompanyName }}</td><td>{{ row.SalesPerson }}</td><td>\n{{ row.ServiceStatus}}</td><td style=\"text-align: center\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"ViewInfo(row)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td style=\"text-align: center\"><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"GenerateReport(row.Service_Id)\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></td><td \nstyle=\"text-align: center\"><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" \nng-click=\"SendReport($event);vm.Service_Id = row.Service_Id;vm.CustomerName = row.CompanyName;vm.ServiceID = row.ServiceID;vm.Email = row.Email\">\n<md-icon md-font-icon=\"icon-send\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div\n layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Pendingform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input \ntype=\"text\" name=\"Service\" readonly=\"readOnly\" ng-model=\"vm.ServiceID\" placeholder=\"Service ID\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Customer\" readonly=\"readOnly\" ng-model=\"vm.CustomerName\" \nplaceholder=\"Customer Name\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container\n flex><input type=\"text\" name=\"SiteContactPerson\" ng-model=\"vm.SiteContactPerson\" placeholder=\"Site Contact Person\" \nreadonly=\"readOnly\"></md-input-container><md-input-container flex><input type=\"text\" name=\"ServiceLocation\" \nreadonly=\"readOnly\" ng-model=\"vm.ServiceLocation\" placeholder=\"Service Location\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" name=\"SiteContactNumber\" \nreadonly=\"readOnly\" ng-model=\"vm.SiteContactNumber\" placeholder=\"Site Contact Number\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"SiteEmail\" ng-model=\"vm.SiteEmail\" placeholder=\"Email\" \nreadonly=\"readOnly\"></md-input-container></div><br><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nLight Trap - LT</span></md-tab-label><md-tab-body><br><div style=\"width: 99% !important\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr><th \nclass=\"secondary-text\"><div><span>#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>\nLocation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Pest Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Threshold</span></div></th><th class=\"secondary-text\"><div>\n<span>Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Lighttrapdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }} - {{ row.Location }}</td><td>\n{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" EditPest($event, $index,\'LT\')\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Rodent Bait Station - RBS</span></md-tab-label>\n<md-tab-body><br><div style=\"width: 99% !important\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions1\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th \nclass=\"secondary-text\"><div><span>#</span></div></th><th class=\"secondary-text\"><div><span>Station No</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span>Bait Consumed?</span></div></th><th class=\"secondary-text\">\n<div><span>Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in RodentBaitdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }} - {{ row.Location }}</td><td>\n{{ row.BaitConsumed }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\" EditPest($event, $index,\'RBS\')\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></md-tab-body></md-tab><md-tab><md-tab-label><span>\nMonitoring Station - MS</span></md-tab-label><md-tab-body><br><div style=\"width: 99% !important\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);width: 99% !important;font-size:13.5px\"><thead><tr><th \nclass=\"secondary-text\"><div><span>#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>\nLocation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Pest Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span>Threshold</span></div></th><th class=\"secondary-text\"><div>\n<span>Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in MonitoringStationdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }} - {{ row.Location }}</td><td>\n{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" EditPest($event, $index,\'MS\')\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Rodent Trapper - RT</span></md-tab-label><md-tab-body>\n<br><div style=\"width: 99% !important\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"border:1px solid rgb(224, 224, 224);width: 99% !important;font-size:13.5px\"><thead>\n<tr><th class=\"secondary-text\"><div><span>#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span>Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span>Pest Type</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span>Threshold</span></div></th><th class=\"secondary-text\"><div>\n<span>Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in RodentTrapperdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }} - {{ row.Location }}</td><td>\n{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" EditPest($event, $index,\'RT\')\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></md-tab-body></md-tab></md-tabs><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"end right\"><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \naria-label=\"Submit\" ng-click=\"GenerateReport(vm.Service_Id);\">Generate Report</md-button></div></form></div></div>\n</div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .dataTables_wrapper .bottom {\r\n        font-size: 13.5px !important;\r\n        padding: 0 !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/autoattendance/autoAttendancepopup.html","<md-dialog style=\"width:50%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Auto Attendance</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\" ng-hide=\"Update\"><md-input-container flex><label>Employee</label><md-select \nng-model=\"vm.uEmployee\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Search Employee..\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\" \nng-show=\"Update\"><md-input-container flex><input type=\"text\" ng-model=\"vm.EmpName\" placeholder=\"Employee\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nShift</label><md-select ng-model=\"vm.uShift\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchShift\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Shift..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.uShift=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Shiftdatas | filter:vm.searchShift\" value=\"{{row.id}}\">\n{{row.ShiftName}}</md-option></md-select></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    /*.md-datepicker-input-container {\r\n        width: 50%;\r\n    }*/\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/autoattendance/autoattendance.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Auto Attendance</span></div><div \nclass=\"product-count secondary-text\"><span>Total Attendances:</span> <span>{{Attendancedatas.length}}</span></div>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd($event)\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Attendancegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Attendancedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Shift\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">CreatedBy</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attendancedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Employeedetails[0].EmployeeID }}</td><td>\n{{ row.Employeedetails[0].EmployeeName }}</td><td>{{row.Shiftdetails[0].ShiftName}}</td><td>{{row.CreatedBy}}</td><td>\n{{row.CreatedDate | date:\'dd/MM/y\'}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Alertpopup($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(19.5vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/autoattendance/autoattendancealert.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre You Sure Want to Delete?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:20px\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"AutoAttendancedelete(AttendanceID)\" class=\"md-raised md-accent\" \nstyle=\"margin-top:5px\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/operations/trendingReports/setup/Popup.html","<md-dialog style=\"width:60%;overflow:unset\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.Title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"padding:0.5% 1% 0.5% 1%\"><form name=\"PestbasicForm\" flex \nclass=\"md-inline-form\" ng-if=\"vm.Title!=\'Add Rodent Bait Station\'\" novalidate><br><div layout=\"column\" \nlayout-gt-sm=\"row\" flex><md-input-container flex><input type=\"text\" placeholder=\"Location\" ng-model=\"vm.Location\">\n</md-input-container><md-input-container flex><label>Pest Types</label><md-select ng-model=\"vm.SelectPest\" \nname=\"PestType\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.PestName\'}\" \nng-change=\"ChangeTreatment(vm.SelectPest)\" md-on-close=\"vm.searchTermP = \'\'\" multiple=\"\" required \nng-disabled=\"PestUpdate\"><md-select-header><input ng-model=\"vm.searchTermP\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Pest Types..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.SelectPest = null;vm.searchTermP = \'\';\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Pestdatas | filter:vm.searchTermP\" ng-value=\"row\">{{row.PestName}}</md-option></md-select>\n</md-input-container></div><div style=\"width: 100%\"><span \nstyle=\"color:#7f9593;list-style-type: none;padding-right:2%;margin-top:2.2%\" ng-if=\"Treatmentpopupdata.length > 0\"><u>\nThreshold Level:</u></span></div><div layout=\"column\" layout-gt-sm=\"row\" flex ng-if=\"Treatmentpopupdata.length > 0\" \nng-repeat=\"Tpd in Treatmentpopupdata\"><table style=\"width: 100%\"><tr><td \nstyle=\"width:20%;color: #7f9593;border:1.5px solid #e0e2e2;padding-left:10px\"><b>{{Tpd.PestName}}</b></td><td \nstyle=\"width:80%;padding-left:20px;border:1.5px solid #e0e2e2\"><ul style=\"width: 100%;margin-top:-8px\"><li \nstyle=\"list-style-type: none;float: left;margin-top: 15px\"><label>Threshold:<label><input type=\"number\" \nng-model=\"Tpd.Threshold\" \nstyle=\"border-top: transparent;border-right: transparent; border-left: transparent;margin-left: 15px;border-color: #888888\">\n</label></label></li></ul></td></tr></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\" style=\"margin-bottom:15px\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitPest(vm.Title)\" aria-label=\"Ok\" \nng-disabled=\"PestbasicForm.$invalid || Treatmentpopupdata == null || Treatmentpopupdata == \'\'\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel\n</md-button></div></form><form name=\"PestbasicForm\" flex class=\"md-inline-form\" \nng-if=\"vm.Title==\'Add Rodent Bait Station\'\" novalidate><br><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex><input type=\"text\" placeholder=\"Location\" ng-model=\"vm.Location\"></md-input-container>\n<md-radio-container flex><md-radio-group ng-model=\"vm.BaitConsumed\" layout=\"row\" \nstyle=\"margin: 20px 0 0 0px;margin-left: 15px\" required><span \nstyle=\"color:#7f9593;padding-top: 5px;float: left;padding-right: 10px\">Bait Consumed? :</span><md-radio-button \nvalue=\"Yes\">Yes</md-radio-button><md-radio-button value=\"No\">No</md-radio-button></md-radio-group></md-radio-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" style=\"margin-bottom:15px\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitBait(vm.Title)\" \naria-label=\"Ok\" ng-disabled=\"PestbasicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></form></md-dialog-content>\n</md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 85px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 32px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n    li:first-letter {\r\n    text-transform:capitalize;\r\n}\n</style>");
$templateCache.put("app/main/apps/operations/trendingReports/setup/setup.html","<div id=\"pesttype\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span>Setup</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"forms-search\" class=\"search-input\" type=\"text\" placeholder=\"Search...\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Search\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span>Add</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"Search && AllowExport==\'true\'\" \nng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"viewbtn\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button></div></div><div class=\"content-card\" ng-show=\"SetupGrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Setupdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference #</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Work Order #</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Site Contact Person</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Service Location</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nSite Contact Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Site Email</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"row in Setupdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"ViewReqinfo(row)\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.CompanyName }}</td>\n<td>{{ row.SalesOrderNo }}</td><td>{{ row.SiteContactPerson}}</td><td>{{ row.ServiceLocation }}</td><td>\n{{ row.SiteContactNo }}</td><td>{{ row.Email }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Setupform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Customer\n</label><md-select ng-model=\"vm.SalesOrder\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm5\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Customer\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"VehicleNumber = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in salesOrderdatas | filter:vm.searchTerm5\" ng-click=\"CustomerInfo(row)\" \nvalue=\"{{row._id}}\">{{row.SalesOrderNo}} - {{row.customerdetails[0].CompanyName}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"SiteContactPerson\" \nng-model=\"vm.SiteContactPerson\" placeholder=\"Site Contact Person\" readonly=\"readOnly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><input type=\"text\" name=\"ServiceLocation\" \nreadonly=\"readOnly\" ng-model=\"vm.ServiceLocation\" placeholder=\"Service Location\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"SiteContactNumber\" readonly=\"readOnly\" \nng-model=\"vm.SiteContactNumber\" placeholder=\"Site Contact Number\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"SiteEmail\" readonly=\"readOnly\" ng-model=\"vm.SiteEmail\" placeholder=\"Email\"></md-input-container>\n</div><div class=\"form-wrapper md-whiteframe-1dp\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nLight Trap - LT</span></md-tab-label><md-tab-body><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"TrapPopup($event, \'LT\')\"><span>Add</span>\n</md-button></div><div style=\"width: 99% !important\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" style=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr>\n<th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Threshold</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Lighttrapdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ReferenceNo }} - {{ row.Location }}</td><td>{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" Delete($index,\'LT\')\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table>\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span>Rodent Bait Station - RBS</span></md-tab-label><md-tab-body>\n<div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"TrapPopup($event, \'RBS\')\"><span>Add</span></md-button></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions1\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Station No</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nBait Consumed?</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in RodentBaitdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ReferenceNo }} - {{ row.Location }}</td><td>{{ row.BaitConsumed }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\" Delete($index,\'RBS\')\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Monitoring Station - MS</span></md-tab-label><md-tab-body><div layout-gt-sm=\"row\" id=\"head\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"TrapPopup($event, \'MS\')\">\n<span>Add</span></md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Threshold</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in MonitoringStationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ReferenceNo }} - {{ row.Location }}</td><td>{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" Delete($index,\'MS\')\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Rodent Trapper - RT</span></md-tab-label><md-tab-body><div \nlayout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-click=\"TrapPopup($event, \'RT\')\"><span>Add</span></md-button></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pest Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Threshold</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in RodentTrapperdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ReferenceNo }} - {{ row.Location }}</td><td>{{ row.PestType }}</td><td>{{ row.Threshold }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\" Delete($index,\'RT\')\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table>\n</md-tab-body></md-tab></md-tabs><div style=\"padding-bottom:2%\"><span class=\"h3\" style=\"color:#7f9593\"><b>ATTACHMENT:\n</b></span></div><div class=\"white-bg md-whiteframe-4dp\" style=\"border:1px solid rgb(224, 224, 224)\"><md-content \nlayout-padding><div flow-init flow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span>\n</md-button><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td \nstyle=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table \nid=\"tb2\" class=\"dataTable row-border hover\" \nstyle=\"border:1px solid rgb(224, 224, 224);font-size:13.5px;width:98% !important\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Operation/TrendingSetup/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"!vm.SalesOrder\">Submit</md-button><md-button ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button>\n</div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 60px);\r\n        max-width: calc(48vw - 64px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/calendar/calendar.html","<div id=\"admincalendar\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon icon-calendar\"></md-icon><span \ntranslate=\"CALENDAR.HEADER\">Calendar</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'CALENDAR.SEARCH\' | translate }}\" flex></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top:30px !important\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\" translate=\"CALENDAR.FROM\">From</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"FromDate\" format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container flex=\"40\" id=\"Datefilter\"><label style=\"color:white;font-size: 14px\" translate=\"CALENDAR.TO\">To\n</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"ToDate\" format=\"mm/dd/y\"></md-datepicker>\n</md-input-container><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"Calendarpopup($event)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"CALENDAR.ADD_EVENT\">Add Event</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"CALENDAR.EXPORT\">Export</span></md-button></div></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"Eventform\" flex><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"Gridclick()\">\n<md-tab-label translate=\"CALENDAR.GRID_VIEW\"><span>Grid View</span></md-tab-label></div><md-tab-body><br><div \nlayout=\"column\" layout-gt-xs=\"row\" flex></div><md-progress-linear ng-hide=\"Calendardatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CALENDAR.EVENT_TYPE\">Event Type\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CALENDAR.TITLE\">Title</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CALENDAR.DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\" nowrap=\"nowrap\"><div>\n<span class=\"column-title\" translate=\"CALENDAR.VIEW/EDIT\">View/Edit</span></div></th><th class=\"secondary-text\" \nnowrap=\"nowrap\"><div><span class=\"column-title\" translate=\"CALENDAR.REMOVE_EVENT\">Remove Event</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Calendardatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{row.EventType }}</td><td>{{row.EventTitle}}</td><td>{{row.Description}}</td><td>{{row.StartDate | date:\'dd/MM/y\'}}\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"CalendarEventupdate($event, row.id, $index)\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon>\n</md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"CalendarEventdelete($event, row.id)\"><md-icon \nmd-font-icon=\"icon-calendar-remove\"></md-icon></md-button></td></tr></tbody></table></md-tab-body></md-tab></md-tabs>\n</div></div></div><style>\nlabel {\r\n        padding-left: 10px !important;\r\n        font-size: 14px !important;\r\n        /*color: #000 !important;*/\r\n    }\r\n\r\n    #content .header md-input-container {\r\n        margin: 0 !important;\r\n    }\r\n\r\n    md-input-container {\r\n        display: inline-block;\r\n        position: relative;\r\n        /*padding: 10px !important;*/\r\n        margin: 18px 0;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    md-tabs-canvas.md-center-tabs {\r\n        display: none;\r\n    }\r\n\r\n    .md-button {\r\n        margin: 6px 0 0 15px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n        height: 0px;\r\n    }\r\n\r\n    .txtbox ::-webkit-input-placeholder { /* WebKit, Blink, Edge */\r\n        color: #909;\r\n    }\r\n\r\n    md-input-container.md-block.md-default-theme {\r\n        display: inherit !important;\r\n    }\r\n\r\n    md-toast.md-default-theme .md-toast-content, md-toast .md-toast-content {\r\n        background: rgba(0,0,0,0.87) !important;\r\n    }\r\n\r\n    .simple.fullwidth > .header {\r\n        height: auto;\r\n    }\r\n\r\n    md-content.md-default-theme, md-content {\r\n        background-color: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas {\r\n        height: 0;\r\n    }\r\n     md-datepicker .md-datepicker-input {\r\n        /*width: calc(39vw - 35px);*/\r\n        /*max-width: calc(40vw - 54px);*/\r\n    }\r\n\r\n    \r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    .dataTables_filter{\r\n        display:none!important;\r\n    }\r\n    .checkboxdemoSelectAll .demo-legend {\r\n  color: #3F51B5; }\r\n\r\n.checkboxdemoSelectAll .demo-fieldset {\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  height: 100%; }\r\n\r\n.checkboxdemoSelectAll .demo-select-all-checkboxes {\r\n  padding-left: 30px; }\r\n\r\n    mwl-calendar .badge-important {\r\n    background-color: #27B1A6!important;\r\n}\r\n    .datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n    .cal-day-tick{\r\n        display:none!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/calendar/calendardelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CALENDAR.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_EVENT?\">Are you sure you want to cancel this event?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"Eventdelete(deleteID)\" class=\"md-raised md-accent\" \ntranslate=\"CALENDAR.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" translate=\"CALENDAR.NO\">No\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/calendar/calendarpopup.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CALENDAR.EVENT\">{{DialogTitle }} Event</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div style=\"height: 70px;margin-top: -22px;margin-left: -20px\">\n<md-radio-container flex><md-radio-group ng-model=\"vm.eEventType\" layout=\"row\" style=\"padding-left:20px\">\n<md-radio-button value=\"Event\">{{ \'CALENDAR.EVENT\' | translate }}</md-radio-button><md-radio-button value=\"Holiday\">\n{{ \'CALENDAR.HOLIDAY\' | translate }}</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.TITLE\">Title</label><input \nname=\"title\" ng-model=\"vm.eEventTitle\" required md-autofocus></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\" id=\"date1\"><label translate=\"CALENDAR.START_DATE\">Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.eStartDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.DESCRIPTION\">Description</label><input \nng-model=\"vm.eDescription\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<md-button ng-click=\"CalendarEventadd()\" style=\"float:right\" class=\"md-raised md-accent\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\">SAVE</md-button></md-input-container>\n<md-input-container flex><md-button class=\"md-raised\" ng-click=\"cancel()\" translate=\"CALENDAR.CANCEL\">Cancel\n</md-button></md-input-container></div></md-dialog-content></form></md-dialog><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #date1 .md-datepicker-input {\r\n        max-width: 1000px !important;\r\n        min-width: 370px !important;\r\n        margin-left:-10px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/hrpolicy/hrpolicy.html","<div id=\"hrpolicy\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"HRPOLICY.HEADER\">HR Policy</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" \nclass=\"search-input\" type=\"text\" ng-model=\"model.Search\" placeholder=\"{{ \'ORGANIZATION.SEARCH\' | translate }}\" flex>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"orgExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"HRPOLICY.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"costExport && AllowExport==\'true\'\" ng-click=\"ccExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"HRPOLICY.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"divisionExport && AllowExport==\'true\'\" ng-click=\"dExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"HRPOLICY.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"chartExport && AllowExport==\'true\'\" ng-click=\"chExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"HRPOLICY.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab ng-click=\"HandbookTab()\"><md-tab-label><span \ntranslate=\"HRPOLICY.EMPLOYEE_HAND_BOOK\">EMPLOYEE HAND BOOK</span></md-tab-label><md-tab-body><form name=\"Handbook\" \nclass=\"md-inline-form\" novalidate><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content-card\" \nstyle=\"width:100%;padding:-1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:40.5%;float:left\"><h2 \nstyle=\"text-align:left\" translate=\"HRPOLICY.EMPLOYEE_HAND_BOOK\">&nbsp;EMPLOYEE HAND BOOK</h2><hr><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init=\"{singleFile:true}\" \nflow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button \nclass=\"md-accent md-raised\"><label translate=\"HRPOLICY.BROWSE\" for=\"file-input\" style=\"margin-bottom:0px\">Browse\n</label><input class=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"UploadEmployeeHandbookfiles(uploader.flow.files)\"><span translate=\"HRPOLICY.UPLOAD\">Upload</span></md-button>\n</div><table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">\n{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"EmployeeHandbookdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"HRPOLICY.FILE_NAME\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"HRPOLICY.FILE_SIZE(KB)\">\nFile Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"HRPOLICY.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"HRPOLICY.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in EmployeeHandbookdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMAdmin/HR Policy/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>\n{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:58.5%;float:right; padding:5px\"><span \nclass=\"h3\" style=\"color:#7f9593\" translate=\"HRPOLICY.EMPLOYEE_HAND_BOOK\"><b>EMPLOYEE HAND BOOK:</b></span><text-angular\n ta-toolbar=\"vm.taToolbar\" ng-model=\"model.HandbookDetail\" class=\"pb-32\"></text-angular><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" translate=\"HRPOLICY.SAVE\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"HandbookSubmit()\" aria-label=\"Submit\" \nng-disabled=\"Handbook.$invalid || Handbook.$pristine\">Save</md-button><md-button id=\"cancel\" type=\"submit\" \nng-click=\"model.HandbookDetail = \'\'\" class=\"md-raised\" translate=\"HRPOLICY.CANCEL\">Cancel</md-button></div></div></div>\n</div></div></div></form></md-tab-body></md-tab><md-tab ng-click=\"PolicyTab()\"><md-tab-label><span \ntranslate=\"HRPOLICY.HR_POLICY\">HR POLICY</span></md-tab-label><md-tab-body><form name=\"HrPolicy\" \nclass=\"md-inline-form\" novalidate><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content-card\" \nstyle=\"width:100%;padding:-1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:40.5%;float:left\"><h2 \nstyle=\"text-align:left\" translate=\"HRPOLICY.HR_POLICY\">&nbsp;HR POLICY</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-content layout-padding><div flow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\">\n<div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button class=\"md-accent md-raised\"><label \nfor=\"file-inputs\" style=\"margin-bottom:0px\" translate=\"HRPOLICY.BROWSE\">Browse</label><input class=\"file-inputs\" \nflow-btn id=\"file-inputs\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"UploadHrpolicyfiles(uploader.flow.files)\"><span translate=\"HRPOLICY.UPLOAD\">Upload</span></md-button></div>\n<table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">\n{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Hrpolicydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"HRPOLICY.FILE_NAME\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"HRPOLICY.FILE_SIZE(KB)\">\nFile Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"HRPOLICY.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"HRPOLICY.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Hrpolicydatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMAdmin/HR Policy/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>\n{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:58.5%;float:right; padding:5px\"><span \nclass=\"h3\" style=\"color:#7f9593\" translate=\"HRPOLICY.HR_POLICY\"><b>HR POLICY:</b></span><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"model.PolicyDetail\" class=\"pb-32\"></text-angular><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" translate=\"HRPOLICY.SAVE\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"PolicySubmit()\" aria-label=\"Submit\" \nng-disabled=\"HrPolicy.$invalid || HrPolicy.$pristine\">Save</md-button><md-button id=\"cancel\" type=\"submit\" \nng-click=\"model.PolicyDetail = \'\'\" class=\"md-raised\" translate=\"HRPOLICY.CANCEL\">Cancel</md-button></div></div></div>\n</div></div></div></form></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/job/job.html","<div id=\"job\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"JOB.HEADER\">Job Categories</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" \nclass=\"search-input\" type=\"text\" ng-model=\"model.Search\" placeholder=\"{{ \'JOB.SEARCH\' | translate }}\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-show=\"titleExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"JOB.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"categoryExport && AllowExport==\'true\'\" ng-click=\"cExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"JOB.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"statusExport && AllowExport==\'true\'\" ng-click=\"sExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"JOB.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"visatypeExport && AllowExport==\'true\'\" ng-click=\"vExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"JOB.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"Title()\"><md-tab-label \ntranslate=\"JOB.JOB_TITLE\"><span>Job Title</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"jobform1\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"JobTitle\" \nng-model=\"model.JobTitle\" placeholder=\"{{ \'JOB.JOB_TITLE\' | translate }}\" required><div \nng-messages=\"jobform1.JobTitle.$error\" ng-show=\"jobform1.JobTitle.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"JOB.JOB_TITLE_IS_REQUIRED\">Job Title is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveJobTitle()\" \nng-disabled=\"jobform1.$invalid || jobform1.$pristine\"><span translate=\"JOB.SAVE\">Save</span></md-button><md-button \nid=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelJobTitle()\"><span translate=\"JOB.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"JobTitledatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"JOB.JOB_TITLE\">Job Title</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"JOB.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in JobTitledatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.JobTitle }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"JobTitleinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Category()\"><md-tab-label \ntranslate=\"JOB.JOB_CATEGORIES\"><span>Job Categories</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"jobform2\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Name\" \nng-model=\"model.Name\" placeholder=\"{{ \'JOB.NAME\' | translate }}\" required><div ng-messages=\"jobform2.Name.$error\" \nng-show=\"jobform2.Name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"JOB.NAME_IS_REQUIRED\">\nName is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"Code\" \nng-model=\"model.Code\" placeholder=\"{{ \'JOB.CODE\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Description\" ng-model=\"model.Description\" placeholder=\"{{ \'JOB.DESCRIPTION\' | translate }}\">\n</md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveJobCategories()\" ng-disabled=\"jobform2.$invalid || jobform2.$pristine\"><span translate=\"JOB.SAVE\">Save\n</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelJobCategories()\"><span \ntranslate=\"JOB.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"JobCategoriesdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"JOB.NAME\">Name</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"JOB.CODE\">Code</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"JOB.DESCRIPTION\">\nDescription</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"JOB.VIEW/EDIT\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in JobCategoriesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Name }}</td><td>{{ row.Code }}</td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"JobCategoriesinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"delete\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"JobCategoriesDelete(row.id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Status()\"><md-tab-label \ntranslate=\"JOB.EMPLOYMENT_STATUS\"><span>Employment Status</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"jobform3\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"EmploymentStatus\" \nng-model=\"model.EmploymentStatusName\" placeholder=\"{{ \'JOB.EMPLOYMENT_STATUS\' | translate }}\" required><div \nng-messages=\"jobform3.EmploymentStatusName.$error\" ng-show=\"jobform3.EmploymentStatusName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"JOB.EMPLOYMENT_STATUS_IS_REQUIRED\">Employment Status is required.</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveEmploymentStatus()\" ng-disabled=\"jobform3.$invalid || jobform3.$pristine\"><span translate=\"JOB.SAVE\">Save\n</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelEmploymentStatus()\"><span \ntranslate=\"JOB.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"EmploymentStatusdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"JOB.EMPLOYMENT_STATUS\">\nEmployment Status</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"JOB.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EmploymentStatusdatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.EmploymentStatusName }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EmploymentStatusinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"VisaType()\"><md-tab-label \ntranslate=\"JOB.VISA_TYPES\"><span>VISA Types</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"jobform4\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"VisaType\" \nng-model=\"model.visatype\" placeholder=\"{{\'JOB.VISA_TYPE\'|translate}}\" required><div \nng-messages=\"jobform4.visatype.$error\" ng-show=\"jobform4.visatype.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"JOB.VISA TYPE IS REQUIRED\">VISA Type is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveVisaType()\" \nng-disabled=\"jobform4.$invalid || jobform4.$pristine\"><span translate=\"JOB.SAVE\">Save</span></md-button><md-button \nid=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelVisaType()\"><span translate=\"JOB.CANCEL\">Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"EmploymentStatusdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \ntranslate=\"JOB.VISA_TYPES\" class=\"column-title\">VISA Type</span></div></th><th class=\"secondary-text\"><div><span \ntranslate=\"JOB.VIEW/EDIT\" class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in VisaTypedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.VisaTypeName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"VisaTypeinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n                margin: -16px 8px;\r\n            }\r\n        \r\n            button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n                margin-bottom: 40px !important;\r\n            }\r\n            button#cancel {\r\n                margin-bottom: 40px;\r\n            }\r\n            .secondary-text {\r\n                font-size: 15px !important;\r\n            }\r\n        \r\n            td.dataTables_empty {\r\n                height: 30px !important;\r\n                text-align: center !important;\r\n            }\r\n        \r\n            .dataTables_wrapper {\r\n                font-size: 14px;\r\n            }\r\n        \r\n            .md-tab.md-active {\r\n                background-color: #9E9E9E;\r\n            }\r\n        \r\n            /*.layout-gt-sm-row.layout-align-start-center {\r\n                padding: 15px !important;\r\n            }*/\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/data/data.html","");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/qualification/qualification.html","<div id=\"qualification\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-school\"></md-icon><span>\n&nbsp;Qualification & Skills</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" \nclass=\"search-input\" type=\"text\" ng-model=\"model.Search\" placeholder=\"{{ \'QUALIFICATION.SEARCH\' | translate }}\" flex>\n</div><div><md-button class=\"md-raised md-background\" ng-show=\"eduExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"QUALIFICATION.EXPORT\">Export</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"skillExport && AllowExport==\'true\'\" ng-click=\"skExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"QUALIFICATION.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"licenseExport && AllowExport==\'true\'\" ng-click=\"liExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"QUALIFICATION.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"languageExport && AllowExport==\'true\'\" ng-click=\"laExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"QUALIFICATION.EXPORT\">Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"membershipExport && AllowExport==\'true\'\" ng-click=\"mExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"QUALIFICATION.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"Education()\"><md-tab-label \ntranslate=\"QUALIFICATION.EDUCATION\"><span>Education</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform1\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"EducationLevel\" \nng-model=\"model.EducationLevel\" placeholder=\"{{ \'QUALIFICATION.EDUCATION_LEVEL\' | translate }}\" required><div \nng-messages=\"qualificationform1.EducationLevel.$error\" ng-show=\"qualificationform1.EducationLevel.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"QUALIFICATION.EDUCATION_LEVEL_IS_REQUIRED\">\nEducation Level is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"EducationName\" ng-model=\"model.EducationName\" placeholder=\"{{ \'QUALIFICATION.EDUCATION_NAME\' | translate }}\"><div\n ng-messages=\"qualificationform1.EducationName.$error\" ng-show=\"qualificationform1.EducationName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"QUALIFICATION.EDUCATION_NAME_IS_REQUIRED\">\nEducation Name is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveEducation()\" \nng-disabled=\"qualificationform1.$invalid || qualificationform1.$pristine\"><span translate=\"QUALIFICATION.SAVE\">Save\n</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelEducation()\"><span \ntranslate=\"QUALIFICATION.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"Educationdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUALIFICATION.EDUCATION_LEVEL\">\nEducation Level</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUALIFICATION.EDUCATION_NAME\">Education Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"QUALIFICATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Educationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.EducationLevel }}</td>\n<td>{{ row.EducationName }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Educationinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Skills()\">\n<md-tab-label translate=\"QUALIFICATION.SKILLS\"><span>Skills</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform2\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Name\" \nng-model=\"model.Name\" placeholder=\"{{ \'QUALIFICATION.NAME\' | translate }}\" required><div \nng-messages=\"qualificationform2.Name.$error\" ng-show=\"qualificationform2.Name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"QUALIFICATION.NAME_IS_REQUIRED\">Name is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"model.Description\" \nplaceholder=\"{{ \'QUALIFICATION.DESCRIPTION\' | translate }}\"><div ng-messages=\"qualificationform2.Description.$error\" \nng-show=\"qualificationform2.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"QUALIFICATION.DESCRIPTION_IS_REQUIRED\">Description is required.</span></div></div></md-input-container>\n<md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveSkills()\" \nng-disabled=\"qualificationform2.$invalid || qualificationform2.$pristine\"><span translate=\"QUALIFICATION.SAVE\">Save\n</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelSkills()\"><span \ntranslate=\"QUALIFICATION.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"Skillsdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUALIFICATION.NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUALIFICATION.DESCRIPTION\">Description</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"QUALIFICATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Skillsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Name }}</td><td>\n{{ row.Description }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Skillsinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div \nng-click=\"License()\"><md-tab-label translate=\"QUALIFICATION.LICENSE\"><span>License</span></md-tab-label></div>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"qualificationform3\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex>\n<input type=\"text\" name=\"Licenses\" ng-model=\"model.Licenses\" placeholder=\"{{ \'QUALIFICATION.LICENSES\' | translate }}\" \nrequired><div ng-messages=\"qualificationform3.Licenses.$error\" ng-show=\"qualificationform3.Licenses.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"QUALIFICATION.LICENSES_IS_REQUIRED\">Licenses is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"AgencyName\" \nng-model=\"model.AgencyName\" placeholder=\"{{ \'QUALIFICATION.INSTITUTION/AGENCY_NAME\' | translate }}\"><div \nng-messages=\"qualificationform3.AgencyName.$error\" ng-show=\"qualificationform3.AgencyName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"QUALIFICATION.INSTITUTION/AGENCY_NAME_IS_REQUIRED\">\nInstitution / Agency Name is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveLicense()\" \nng-disabled=\"qualificationform3.$invalid || qualificationform3.$pristine\"><span translate=\"QUALIFICATION.SAVE\">Save\n</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelLicense()\"><span \ntranslate=\"QUALIFICATION.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"Licensedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUALIFICATION.LICENSES\">Licenses\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"QUALIFICATION.INSTITUTION/AGENCY_NAME\">Institution / Agency Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"QUALIFICATION.VIEW/EDIT\">View/Edit</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in Licensedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Licenses }}</td><td>{{ row.AgencyName }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Licenseinfo(row.id, $index)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"Language()\"><md-tab-label translate=\"QUALIFICATION.LANGUAGE\"><span>\nLanguage</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform4\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"Language\" \nng-model=\"model.LanguageName\" placeholder=\"{{ \'QUALIFICATION.LANGUAGE\' | translate }}\" required><div \nng-messages=\"qualificationform4.LanguageName.$error\" ng-show=\"qualificationform4.LanguageName.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"QUALIFICATION.LANGUAGE_IS_REQUIRED\">Language is required.</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveLanguage()\" ng-disabled=\"qualificationform4.$invalid || qualificationform4.$pristine\"><span \ntranslate=\"QUALIFICATION.SAVE\">Save</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" \nng-click=\"cancelLanguage()\"><span translate=\"QUALIFICATION.CANCEL\">Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Languagedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"QUALIFICATION.LANGUAGE\">Language</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\" translate=\"QUALIFICATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Languagedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.LanguageName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Languageinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Membership()\"><md-tab-label \ntranslate=\"QUALIFICATION.MEMBERSHIP\"><span>Membership</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"qualificationform5\" novalidate>\n<div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"MembershipName\" \nng-model=\"model.MembershipName\" placeholder=\"{{ \'QUALIFICATION.MEMBERSHIP_NAME\' | translate }}\" required><div \nng-messages=\"qualificationform5.MembershipName.$error\" ng-show=\"qualificationform5.MembershipName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"QUALIFICATION.MEMBERSHIP_NAME_IS_REQUIRED\">\nMembership Name is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Association\" ng-model=\"model.Association\" placeholder=\"{{ \'QUALIFICATION.ASSOCIATION\' | translate }}\"><div \nng-messages=\"qualificationform5.Association.$error\" ng-show=\"qualificationform5.Association.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"QUALIFICATION.ASSOCIATION_IS_REQUIRED\">Association is required.</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveMembership()\" ng-disabled=\"qualificationform5.$invalid || qualificationform5.$pristine\"><span \ntranslate=\"QUALIFICATION.SAVE\">Save</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" \nng-click=\"cancelMembership()\"><span translate=\"QUALIFICATION.CANCEL\">Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Membershipdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"QUALIFICATION.MEMBERSHIP_NAME\">Membership Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"QUALIFICATION.ASSOCIATION\">\nAssociation</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"QUALIFICATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Membershipdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.MembershipName }}</td>\n<td>{{ row.Association }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Membershipinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div>\n<style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    /*.layout-gt-sm-row.layout-align-start-center {\r\n        padding: 15px !important;\r\n    }*/\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/organization/organization.html","<div id=\"organization\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home-variant\"></md-icon><span \ntranslate=\"ORGANIZATION.HEADER\">Organization Setup</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" class=\"search-input\" type=\"text\" ng-model=\"model.Search\" \nplaceholder=\"{{ \'ORGANIZATION.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"orgExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"ORGANIZATION.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"costExport && AllowExport==\'true\'\" ng-click=\"ccExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"ORGANIZATION.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"divisionExport && AllowExport==\'true\'\" ng-click=\"dExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n<span translate=\"ORGANIZATION.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"chartExport && AllowExport==\'true\'\" ng-click=\"chExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"ORGANIZATION.EXPORT\">Export</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"bankExport && AllowExport==\'true\'\" ng-click=\"bExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"countryExport && AllowExport==\'true\'\" \nng-click=\"cExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"nationExport && AllowExport==\'true\'\" ng-click=\"nExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"Structure()\"><md-tab-label \ntranslate=\"ORGANIZATION.ORGANIZATION_STRUCTURE\"><label>Organization Structure</label></md-tab-label></div><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform1\" \nnovalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" \nname=\"BusinessUnitName\" ng-model=\"model.BusinessUnitName\" \nplaceholder=\"{{ \'ORGANIZATION.BUSINESS_UNIT_NAME\' | translate }}\" required><div \nng-messages=\"organizationform1.BusinessUnitName.$error\" ng-show=\"organizationform1.BusinessUnitName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"ORGANIZATION.BUSINESS_UNIT_NAME_IS_REQUIRED\">\nBusiness Unit Name is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"BusinessUnitCode\" ng-model=\"model.BusinessUnitCode\" \nplaceholder=\"{{ \'ORGANIZATION.BUSINESS_UNIT_CODE\' | translate }}\" required><div \nng-messages=\"organizationform1.BusinessUnitCode.$error\" ng-show=\"organizationform1.BusinessUnitCode.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"ORGANIZATION.BUSINESS_UNIT_CODE_IS_REQUIRED\">\nBusiness Unit Code is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"BusinessUnitLocation\" ng-model=\"model.BusinessUnitLocation\" \nplaceholder=\"{{ \'ORGANIZATION.BUSINESS_UNIT_LOCATION\' | translate }}\" required><div \nng-messages=\"organizationform1.BusinessUnitLocation.$error\" ng-show=\"organizationform1.BusinessUnitLocation.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"ORGANIZATION.BUSINESS_UNIT_LOCATION_IS_REQUIRED\">\nBusiness Unit Location is required.</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveOrganization()\" \nng-disabled=\"organizationform1.$invalid || organizationform1.$pristine\"><span translate=\"ORGANIZATION.SAVE\">Save</span>\n</md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelOrganization()\"><span \ntranslate=\"ORGANIZATION.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"Organizationdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION.BUSINESS_UNIT_NAME\">Business Unit Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION.BUSINESS_UNIT_CODE\">Business Unit Code</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION.BUSINESS_UNIT_LOCATION\">Business Unit Location</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"ORGANIZATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Organizationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.BusinessUnitName }}\n</td><td>{{ row.BusinessUnitCode }}</td><td>{{ row.BusinessUnitLocation }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Organizationinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"CostCentre()\"><md-tab-label \ntranslate=\"ORGANIZATION.COST_CENTRE\"><span>Cost Centre</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform2\" novalidate><div\n layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"CostCentreName\" \nng-model=\"model.CostCentreName\" placeholder=\"{{ \'ORGANIZATION.COST_CENTRE_NAME\' | translate }}\" required><div \nng-messages=\"organizationform2.CostCentreName.$error\" ng-show=\"organizationform2.CostCentreName.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"ORGANIZATION.COST_CENTRE_NAME_IS_REQUIRED\">Cost Centre Name is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"CostCentreCode\" \nng-model=\"model.CostCentreCode\" placeholder=\"{{ \'ORGANIZATION.COST_CENTRE_CODE\' | translate }}\" required><div \nng-messages=\"organizationform2.CostCentreCode.$error\" ng-show=\"organizationform2.CostCentreCode.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"ORGANIZATION.COST_CENTRE_CODE_IS_REQUIRED\">Cost Centre Code is required.\n</span></div></div></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveCostCentre()\" \nng-disabled=\"organizationform2.$invalid || organizationform2.$pristine\"><span translate=\"ORGANIZATION.SAVE\">Save</span>\n</md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelCostCentre()\"><span \ntranslate=\"ORGANIZATION.CANCEL\">Cancel</span></md-button></div><div class=\"content-card\"><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear ng-hide=\"CostCentredatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION.COST_CENTRE_NAME\">\nCost Centre Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION.COST_CENTRE_CODE\">Cost Centre Code</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"ORGANIZATION.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in CostCentredatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CostCentreName }}</td>\n<td>{{ row.CostCentreCode }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"CostCentreinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div \nng-click=\"Division()\"><md-tab-label translate=\"ORGANIZATION.DIVISION\"><span>Division</span></md-tab-label></div>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"organizationform3\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input\n type=\"text\" name=\"DivisionName\" ng-model=\"model.DivisionName\" \nplaceholder=\"{{ \'ORGANIZATION.DIVISION_NAME\' | translate }}\" required><div \nng-messages=\"organizationform3.DivisionName.$error\" ng-show=\"organizationform3.DivisionName.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"ORGANIZATION.DIVISION_NAME_IS_REQUIRED\">Division Name is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"DivisionCode\" \nng-model=\"model.DivisionCode\" placeholder=\"{{ \'ORGANIZATION.DIVISION_CODE\' | translate }}\" required><div \nng-messages=\"organizationform3.DivisionCode.$error\" ng-show=\"organizationform3.DivisionCode.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"ORGANIZATION.DIVISION_CODE_IS_REQUIRED\">Division Code is required.</span></div>\n</div></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveDivision()\" ng-disabled=\"organizationform3.$invalid || organizationform3.$pristine\"><span \ntranslate=\"ORGANIZATION.SAVE\">Save</span></md-button><md-button id=\"cancel\" class=\"md-raised md-background\" \nng-click=\"cancelDivision()\"><span translate=\"ORGANIZATION.CANCEL\">Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Divisiondatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ORGANIZATION.DIVISION_NAME\">Division Name</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION.DIVISION_CODE\">Division Code</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ORGANIZATION.VIEW/EDIT\">View/Edit</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Divisiondatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.DivisionName }}</td><td>{{ row.DivisionCode }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Divisioninfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Chart()\"><md-tab-label \ntranslate=\"ORGANIZATION.ORGANIZATION_CHART\"><span>Organization Chart</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform4\" novalidate><h2 \nstyle=\"text-align:left\" translate=\"ORGANIZATION.ORGANIZATION_CHART\">&nbsp;Organization Chart</h2><hr><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init flow-name=\"uploader.flow\"><div\n layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button class=\"md-accent md-raised\"><label for=\"file-input\" \nstyle=\"margin-bottom:0px\" translate=\"ORGANIZATION.BROWSE\">Browse</label><input class=\"file-input\" flow-btn \nid=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" ng-click=\"Uploadfiles(uploader.flow.files)\"><span \ntranslate=\"ORGANIZATION.UPLOAD\">Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Organizationchartdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION.FILE_NAME\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION.FILE_SIZE(KB)\">\nFile Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION.UPLOADED_BY\">Uploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"ORGANIZATION.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Organizationchartdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMAdmin/Organization Chart/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div ng-click=\"Bank()\"><md-tab-label>\n<span>Bank</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform4\" novalidate><div\n layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"BankCode\" \nng-model=\"model.BankCode\" placeholder=\"Bank Code\" required><div ng-messages=\"organizationform4.BankCode.$error\" \nng-show=\"organizationform4.BankCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Bank Code is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"BankName\" \nng-model=\"model.BankName\" placeholder=\"Bank Name\" required><div ng-messages=\"organizationform4.BankName.$error\" \nng-show=\"organizationform4.BankName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Bank Name is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"BIC\" ng-model=\"model.BIC\" \nplaceholder=\"BIC\"></md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveBank()\" ng-disabled=\"organizationform4.$invalid || organizationform4.$pristine\"><span>Save</span>\n</md-button><md-button id=\"cancel\" class=\"md-raised md-background\" ng-click=\"cancelBank()\"><span>Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Bankdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Bank Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Bank Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">BIC</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Bankdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.BankCode }}</td><td>{{ row.BankName }}</td><td>{{ row.BIC }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Bankinfo(row.id, $index)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></form></div>\n</md-tab-body></md-tab><md-tab><div ng-click=\"Nationality()\"><md-tab-label><span>Nationality</span></md-tab-label>\n</div><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"organizationform7\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input\n type=\"text\" ng-model=\"model.NationalityCode\" placeholder=\"Nationality Code\" required></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"model.NationalityName\" placeholder=\"Nationality\" required>\n</md-input-container><md-button class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveNationality()\" ng-disabled=\"!model.NationalityCode && !model.NationalityName\"><span>Save</span>\n</md-button><md-button id=\"cancel\" class=\"md-raised md-background\" \nng-click=\"model.NationalityCode = \'\';model.NationalityName = \'\';\"><span>Cancel</span></md-button></div><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Nationalitydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nationality Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nationality Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Nationalitydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.NationalityCode }}</td><td>{{ row.NationalityName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Nationalityinfo(row.id, row.NationalityCode ,  row.NationalityName )\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon></md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab><md-tab><div \nng-click=\"Country()\"><md-tab-label><span>Country</span></md-tab-label></div><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"organizationform8\" novalidate><div\n layout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex><input type=\"text\" \nng-model=\"model.CountryCode\" placeholder=\"Country Code\" required></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"model.CountryName\" placeholder=\"Country Name\" required></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"saveCountry()\" \nng-disabled=\"!model.CountryCode || !model.CountryName\"><span>Save</span></md-button><md-button id=\"cancel\" \nclass=\"md-raised md-background\" ng-click=\"model.CountryCode = \'\';model.CountryName = \'\'\"><span>Cancel</span>\n</md-button></div><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Countrydatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Country Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Country Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Countrydatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CountryCode }}</td><td>{{ row.CountryName }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Countryinfo(row.id, row.CountryCode, row.CountryName)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmAdmin/workweek/workweek.html","<div id=\"workweek\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span translate=\"WORKWEEK.HEADER\">\nWork Week Settings</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"lSearch\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'WORKWEEK.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"lAdd\" ng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"WORKWEEK.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" ng-show=\"lView\" \nng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"WORKWEEK.BACK\">Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"lExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"WORKWEEK.EXPORT\">Export</span></md-button></div></div>\n<div class=\"content-card\" ng-show=\"Workweekgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Workweekdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORKWEEK.WORK_WEEK_CODE\">Work Week Code</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"WORKWEEK.WORK_WEEK_DESCRIPTION\">Work Week Description</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"WORKWEEK.TOTAL_HOURS\">Total Hours</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORKWEEK.MONDAY\">Monday\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORKWEEK.TUESDAY\">Tuesday</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORKWEEK.WEDNESDAY\">Wednesday</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORKWEEK.THURSDAY\">Thursday</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"WORKWEEK.FRIDAY\">Friday</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORKWEEK.SATURDAY\">Saturday</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"WORKWEEK.SUNDAY\">Sunday</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"WORKWEEK.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Workweekdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.WorkWeekCode }}</td><td>\n{{ row.WorkWeekDescription }}</td><td>{{ row.TotalWorkingHours }}</td><td>{{ row.Monday }}</td><td>{{ row.Tuesday }}\n</td><td>{{ row.Wednesday }}</td><td>{{ row.Thursday }}</td><td>{{ row.Friday }}</td><td>{{ row.Saturday }}</td><td>\n{{ row.Sunday }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Workweekinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Workweekform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"WorkWeekCode \" placeholder=\"{{ \'WORKWEEK.WORK_WEEK_CODE\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"WorkWeekDescription \" \nplaceholder=\"{{ \'WORKWEEK.WORK_WEEK_DESCRIPTION\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"TotalWorkingHours\" \nplaceholder=\"{{ \'WORKWEEK.TOTAL_NO_OF_WORKING_HOURS_PER_WEEK\' | translate }}\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-gt-xs=\"row\" style=\"margin-top:-25px\"><md-input-container flex><input type=\"number\" \nng-model=\"Monday\" placeholder=\"{{ \'WORKWEEK.MONDAY\' | translate }}\"></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"Tuesday\" placeholder=\"{{ \'WORKWEEK.TUESDAY\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"Wednesday\" \nplaceholder=\"{{ \'WORKWEEK.WEDNESDAY\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"Thursday\" placeholder=\"{{ \'WORKWEEK.THURSDAY\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"Friday\" placeholder=\"{{ \'WORKWEEK.FRIDAY\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"Saturday\" \nplaceholder=\"{{ \'WORKWEEK.SATURDAY\' | translate }}\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"Sunday\" placeholder=\"{{ \'WORKWEEK.SUNDAY\' | translate }}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><label style=\"width:100px\" translate=\"WORKWEEK.SATURDAY_OFF\"><b>Saturday Off:</b></label>&emsp;\n<md-radio-container flex><md-radio-group ng-model=\"SaturdayOff\" layout=\"row\"><md-radio-button value=\"NA\">\n{{ \'WORKWEEK.NA\' | translate }}</md-radio-button><md-radio-button value=\"Odd\">{{ \'WORKWEEK.ODD\' | translate }}\n</md-radio-button><md-radio-button value=\"Even\">{{ \'WORKWEEK.EVEN\' | translate }}</md-radio-button></md-radio-group>\n</md-radio-container></div></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" translate=\"WORKWEEK.SUBMIT\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"saveWorkweek()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"WORKWEEK.CANCEL\">Cancel\n</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-inline-form md-radio-group {\r\n        margin-top: -4px;\r\n    }\n</style><style>\n/*md-checkbox {\r\n            margin-bottom: 2px !important;\r\n        }\r\n\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        .price-tables .price-table.style-1 .price {\r\n            padding: 0px 0px 0px 0px;\r\n        }\r\n\r\n        .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n            border-bottom-color: rgba(0, 0, 0, 0.15);\r\n        }\r\n\r\n        .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n            border-bottom-color: rgba(0, 0, 0, 0.14);\r\n        }*/\r\n    /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveapproval/leaveapproval.html","<div id=\"leaveapproval\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Leave Approval</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"lSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" \nflex><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" \nlayout=\"row\" ng-show=\"lSearch\" style=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\">\n<label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-show=\"lView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"lExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Leavegrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Leavedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reference #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Report\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Employee Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Leave Type</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Leave From</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Leave To</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Days</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Paid Leaves</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unpaid Leaves</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Leavedatas\" ng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Leaveinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.LeaveType }}</td><td>\n{{ row.FromDate | date:\'dd/MM/y\' }}</td><td>{{ row.ToDate | date:\'dd/MM/y\' }}</td><td>{{ row.TotalDaysApplied }}</td>\n<td>{{ row.TotalPaidLeaves }}</td><td>{{ row.TotalUnPaidLeaves }}</td><td>{{ row.Status }}</td></tr></tbody></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Leaveform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\">\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;LEAVE REQUEST DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px\">Reference No.</label>\n&nbsp; : &nbsp; {{ReferenceNo}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">\nEmployee Name</label>&nbsp; :&nbsp; {{EmployeeName}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Leave Type</label>&nbsp; :&nbsp; {{LeaveType}}<br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">From Date</label>\n&nbsp; :&nbsp; {{FromDate | date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">To Date</label>\n&nbsp; :&nbsp; {{ToDate | date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Reason for Taking Leave</label>\n&nbsp; :&nbsp; {{Reason}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">\nEmergency Contact Number</label>&nbsp; :&nbsp; {{EmergencyContactNo}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Total Days</label>&nbsp; :&nbsp; {{TotalDaysApplied}}\n<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Total Paid Leaves</label>\n&nbsp; :&nbsp; {{TotalPaidLeaves}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">\nTotal Unpaid Leaves</label>&nbsp; :&nbsp; {{TotalUnPaidLeaves}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Leave Taken</label>\n&nbsp; :&nbsp; {{LeaveTaken}} (Excluding this request)<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Leave Balance</label>\n&nbsp; :&nbsp; {{LeaveBalance}} (Excluding this request)<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">Leave Entitlement</label>\n&nbsp; :&nbsp; {{LeaveEntitlement1}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\">\n</label>&nbsp; :&nbsp; {{LeaveEntitlement2}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\">\nNo. of Male associates applying leave on the same date/s</label>&nbsp; :&nbsp; {{MaleAssociate}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\">\nNo. of Female associates applying leave on the same date/s</label>&nbsp; :&nbsp; {{FemaleAssociate}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\">No. of Trainee attend training on the same date/s\n</label>&nbsp; :&nbsp; {{TraineeAssociate}}<br></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr><div layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><md-progress-linear \nng-hide=\"Logdetailsdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div></form><br><form name=\"basicForm1\" class=\"md-inline-form\" novalidate><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button></div><md-progress-linear \nng-hide=\"Commentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n    \r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/PreviewLeaveentitlement.html","<md-dialog style=\"width:80%;overflow:unset\"><form name=\"eventForm1\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">PREVIEW LEAVE ENTITLEMENT</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding:5px 10px 5px 10px\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" style=\"font-size:13px; border:1px solid rgb(224, 224, 224)\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">EmployeeName</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nAL Entitlement</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Earned</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Adoption Leave</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">ChildCare Leave</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nCompassionate Leave</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Maternity Leave</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Paternity Leave</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">SharedParental Leave</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Sick Leave</span></div></th><th class=\"secondary-text\" \nnowrap=\"nowrap\"><div><span class=\"column-title\">Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PreviewLeaveEntitlement\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{row.EmployeeName }}\n</td><td>{{row.AnnualLeaveEntitlement }}</td><td>{{row.Earned }}</td><td>{{row.AdoptionLeave }}</td><td>\n{{row.ChildCareLeave }}</td><td>{{row.CompassionateLeave }}</td><td>{{row.MaternityLeave }}</td><td>\n{{row.PaternityLeave }}</td><td>{{row.SharedParentalLeave }}</td><td>{{row.SickLeave }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"PreviewLeaveentitlementinfo($event, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td>\n</tr></tbody></table><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SetforNextYearConfirm()\" \naria-label=\"Submit\">Confirm</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n.dataTables_wrapper .bottom {\r\n        height: 55px;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        min-height: 54px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n        border-top: none;\r\n        font-size: 13px;\r\n        padding: 0;\r\n        -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n        /* justify-content: space-between; */\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/PreviewLeaveentitlementUpdate.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">LEAVE ENTITLEMENT</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"EmployeeName\" \nng-model=\"EmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"LeaveEntitlementYear\" ng-model=\"vm.LeaveEntitlementYear\" \nplaceholder=\"Leave Entitlement Year\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"Earned\" \nng-model=\"vm.Earned\" placeholder=\"Earned\"></md-input-container><md-input-container flex><input type=\"number\" \nname=\"AnnualLeaveEntitlement\" ng-model=\"vm.AnnualLeaveEntitlement\" placeholder=\"Annual Leave Entitlement\">\n</md-input-container><md-input-container flex><input type=\"number\" name=\"AdoptionLeave\" ng-model=\"vm.AdoptionLeave\" \nplaceholder=\"Adoption Leave\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"ChildCareLeave\" \nng-model=\"vm.ChildCareLeave\" placeholder=\"Child Care Leave\"></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"CompassionateLeave\" ng-model=\"vm.CompassionateLeave\" placeholder=\"Compassionate Leave\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-27px\"><md-input-container flex>\n<input type=\"number\" name=\"MaternityLeave\" ng-model=\"vm.MaternityLeave\" placeholder=\"Maternity Leave\">\n</md-input-container><md-input-container flex><input type=\"number\" name=\"PaternityLeave\" ng-model=\"vm.PaternityLeave\" \nplaceholder=\"Paternity Leave\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"SharedParentalLeave\" \nng-model=\"vm.SharedParentalLeave\" placeholder=\"Shared Parental Leave\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"SickLeave\" ng-model=\"vm.SickLeave\" placeholder=\"Sick Leave\"></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"PreviewLeaveEntitlementUpdate(vm.IndxID)\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/PreviewleaveentitlementRemove.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to Remove this Leave Entitlement?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"RemovePreviewLeaveEntitlement(vm.IndxID)\" class=\"md-raised md-accent\">Yes</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/ShowDuplicatePreviewLeaveentitlement.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">ALREADY UPDATED EMPLOYEE(S) FOR NEXT YEAR</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee Name</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in DuplicateLeaveEntitlement\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.EmployeeName }}</td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/leaveentitlement.html","<div id=\"leaveentitlement\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Leave Approval</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"lSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"lAdd\" \nng-click=\"AddLeaveEntitlement()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button>\n<md-button class=\"md-raised reference-button\" ng-show=\"lView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"UView\" ng-click=\"ShowLeave()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span>\n</md-button><md-button class=\"md-raised md-background\" ng-show=\"lExport && AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content\" \nng-show=\"Leavegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"GroupEmployee\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Employee ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Annual Leave</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unpaid Leave</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Medical Leave</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Hospitalization</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Maternity</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Paternity</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Child Care</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reservist</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in GroupEmployee\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"getEmployeeLeave(row.EmployeeID,row)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.EmpID }}</a></td><td>{{ row.EmployeeName }}</td><td>{{ row.Annual }}\n</td><td>{{ row.UnpaidLeavr }}</td><td>{{ row.SickHospitalisation }}</td><td>{{ row.Adoption }}</td><td>\n{{ row.Maternity }}</td><td>{{ row.Paternity }}</td><td>{{ row.ChildCare }}</td><td>{{ row.Reservist }}</td></tr>\n</tbody></table></div></div><div class=\"content-card\" ng-show=\"LeaveUpdate\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"EmpLeavedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Leave ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Type Of Leave</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">End Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Deducted Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in EmpLeavedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td><a href=\"\" ng-click=\"getLeave(row)\" title=\"Detail Grid\" style=\"border:none\">{{ row.LeaveID }}</a></td><td>\n{{ row.Employeedetails[0].EmployeeID }}</td><td>{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.Type }}</td>\n<td>{{ row.StartDate | date:\'dd/MM/y\'}}-{{row.FromLeaveDay}}</td><td>\n{{ row.EndDate | date:\'dd/MM/y\' }}-{{row.ToLeaveDay}}</td><td>{{ row.Days }}</td><td>{{ row.Remarks }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteLeav(row)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div class=\"content\" ng-show=\"Leaveform\"><div class=\"white-bg md-whiteframe-4dp\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 10px\"><md-input-container flex><label>Employee</label><md-select \nng-model=\"vm.Employee\" name=\"Employee\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" required><md-select-header>\n<input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" placeholder=\"Search Employee\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Employee = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTermS\" value=\"{{row.id}}\" ng-click=\"getEmployeeBalance(row)\">\n{{row.EmpID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>\nType of Leave</label><md-select ng-model=\"vm.Type\" name=\"Type\" id=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" \nng-change=\"CalculateDays()\" required><md-select-header><input ng-model=\"vm.searchTermS\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search Type of Leave\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Type = null;vm.searchTermS = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Leavedatas | filter:vm.searchTermS\" value=\"{{row.Name}}\">{{row.Name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 10px\"><md-input-container flex \nid=\"Date\"><label style=\"margin-left: -10px\">From Date</label><md-datepicker ng-model=\"vm.StartDate\" \nng-change=\"CalculateDays()\" md-date-format=\"dd/MM/y\" required></md-datepicker></md-input-container><md-input-container \nflex style=\"flex: 0.3\"><md-select ng-model=\"vm.FromLeave\" name=\"FromLeave\" id=\"searchmodule\" \nmd-on-close=\"vm.searchTermS = \'\'\" ng-change=\"CalculateDays()\"><md-option value=\"FullDay\">Full Day</md-option><md-option\n value=\"HalfDayMorning\">Half day (Mor)</md-option><md-option value=\"HalfDayAftn\">Half day (Aftn)</md-option>\n</md-select></md-input-container><md-input-container flex id=\"Date\"><label style=\"margin-left: -10px\">To Date</label>\n<md-datepicker ng-model=\"vm.EndDate\" ng-change=\"CalculateDays()\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex style=\"flex: 0.3\"><md-select ng-model=\"vm.ToLeave\" name=\"ToLeave\" \nid=\"searchmodule\" md-on-close=\"vm.searchTermS = \'\'\" ng-change=\"CalculateDays()\" ng-disabled=\"SameDate\"><md-option \nvalue=\"FullDay\">Full Day</md-option><md-option value=\"HalfDayMorning\">Half day (Mor)</md-option><md-option \nvalue=\"HalfDayAftn\">Half day (Aftn)</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"flex: 0.3\"><input type=\"text\" name=\"Days\" ng-model=\"Days\" placeholder=\"Deducted Days\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 10px\"><md-input-container flex>\n<input type=\"text\" name=\"Remarks\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div \nid=\"LeaveContainer\"><span style=\"font-weight: bold; font-size: 20px; display: flex\">Leave Balance</span><div \nid=\"Leavediv\"><div id=\"leaveBox\"><span>Annual Leave : {{vm.AnnualLeave}}</span></div><div id=\"leaveBox\"><span>\nMedical Leave : {{vm.SickHospitalisation}}</span></div><div id=\"leaveBox\"><span>Hospitalization Leave : {{vm.Adoption}}\n</span></div><div id=\"leaveBox\"><span>Unpaid Leave : {{vm.UnpaidLeave}}</span></div></div><div id=\"Leavediv\"><div \nid=\"leaveBox\"><span>Maternity Leave : {{vm.Maternity }}</span></div><div id=\"leaveBox\"><span>\nPaternity Leave : {{vm.Paternity }}</span></div><div id=\"leaveBox\"><span>Child Care Leave : {{vm.ChildCare }}</span>\n</div><div id=\"leaveBox\"><span>Reservist Leave : {{vm.Reservist }}</span></div></div></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"sSubmit()\" \nclass=\"md-raised md-accent\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div><div class=\"content\" \nng-show=\"Leaveform2\"><div class=\"white-bg md-whiteframe-4dp\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 10px\">\n<md-input-container flex><input type=\"text\" name=\"EmployeeName\" ng-model=\"EmployeeName\" placeholder=\"Employee Name\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" name=\"LeaveType\" \nng-model=\"LeaveType\" placeholder=\"Leave Type\" readonly=\"readonly\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"LeaveDates\" ng-model=\"LeaveDates\" placeholder=\"Leave Dates\" readonly=\"readonly\"></md-input-container>\n</div><div id=\"LeaveContainer\"><span style=\"font-weight: bold; font-size: 20px; display: flex\">Leave Balance</span><div\n id=\"Leavediv\"><div id=\"leaveBox\"><span>Annual Leave : {{UAnnual}}</span></div><div id=\"leaveBox\"><span>\nMedical Leave : {{USickHospitalisation}}</span></div><div id=\"leaveBox\"><span>Hospitalization Leave : {{UAdoption}}\n</span></div><div id=\"leaveBox\"><span>Unpaid Leave : {{UUnpaidLeavr}}</span></div></div><div id=\"Leavediv\"><div \nid=\"leaveBox\"><span>Maternity Leave : {{UMaternity }}</span></div><div id=\"leaveBox\"><span>\nPaternity Leave : {{UPaternity }}</span></div><div id=\"leaveBox\"><span>Child Care Leave : {{UChildCare }}</span></div>\n<div id=\"leaveBox\"><span>Reservist Leave : {{UReservist }}</span></div></div></div><div style=\"padding-bottom:2%\"><span\n class=\"h3\" style=\"color:#7f9593\"><b>Attach Medical Certificate :</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"border:1px solid rgb(224, 224, 224)\"><md-content layout-padding><div \nflow-init flow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px\" translate=\"CRMLEAD.BROWSE\">Browse</label></div><input \nclass=\"file-input\" flow-btn id=\"file-input\"><md-button class=\"md-raised md-accent\" \nng-click=\"uploadfile(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span></md-button>\n<table style=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">\n{{$index+1}}.</td><td>{{file.name}}</td></tr></table></div></md-content><table id=\"tb2\" \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Attachmentdatas\"><td></td><td><a href=\"{{UploadsURL}}HRM/Leave/{{row.TableID}}\" download \nstyle=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Adelete( row._id)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"ShowLeave()\" class=\"md-raised\">Cancel\n</md-button></div></form></div></div></div></div></div><style>\n#Date {\r\n        flex: 0.55\r\n    }\r\n\r\n    #LeaveContainer {\r\n        box-sizing: border-box;\r\n        display: inline-block;\r\n        align-content: center;\r\n        text-align: center;\r\n\r\n        /* height: 100vh; */\r\n        background: whitesmoke;\r\n    }\r\n\r\n    #Leavediv {\r\n        display: flex;\r\n        text-align: center;\r\n        /* width: 400vh; */\r\n        /* align-items: center;\r\n    justify-content: center; */\r\n        margin: 0;\r\n    }\r\n\r\n    #leaveBox {\r\n        /* display: flex; */\r\n\r\n        font-weight: 500;\r\n        color: brown;\r\n        padding: 20px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style><style>\nbutton#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(23vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmLeave/leaveentitlement/leaveentitlementUpdate.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">LEAVE ENTITLEMENT</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"EmployeeName\" \nng-model=\"uEmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"LeaveEntitlementYear\" ng-model=\"vm.uLeaveEntitlementYear\" \nplaceholder=\"Leave Entitlement Year\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"Earned\" \nng-model=\"vm.uEarned\" placeholder=\"Earned\"></md-input-container><md-input-container flex><input type=\"number\" \nname=\"AnnualLeaveEntitlement\" ng-model=\"vm.uAnnualLeaveEntitlement\" placeholder=\"Annual Leave Entitlement\">\n</md-input-container><md-input-container flex><input type=\"number\" name=\"AdoptionLeave\" ng-model=\"vm.uAdoptionLeave\" \nplaceholder=\"Adoption Leave\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"ChildCareLeave\" \nng-model=\"vm.uChildCareLeave\" placeholder=\"Child Care Leave\"></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"CompassionateLeave\" ng-model=\"vm.uCompassionateLeave\" placeholder=\"Compassionate Leave\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-27px\"><md-input-container flex>\n<input type=\"number\" name=\"MaternityLeave\" ng-model=\"vm.uMaternityLeave\" placeholder=\"Maternity Leave\">\n</md-input-container><md-input-container flex><input type=\"number\" name=\"PaternityLeave\" ng-model=\"vm.uPaternityLeave\" \nplaceholder=\"Paternity Leave\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" name=\"SharedParentalLeave\" \nng-model=\"vm.uSharedParentalLeave\" placeholder=\"Shared Parental Leave\"></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"SickLeave\" ng-model=\"vm.uSickLeave\" placeholder=\"Sick Leave\"></md-input-container></div><div\n class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"LeaveEntitlementUpdate()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/contracttemplate/contracttemplate.html","<div id=\"contracttemplate\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-document\"></md-icon><span>Template</span></div>\n</div></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"border:1px solid rgb(224, 224, 224);float:right;margin-left:20px\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><p>Please Add files here...</p></div>\n<md-content layout-padding><div flow-init flow-name=\"uploader.flow\"><div id=\"attachmenthref\"><label for=\"file-input\" \nstyle=\"color: rgb(3,155,229);margin-bottom: 0px;height:18px;cursor: pointer\" translate=\"CRMLEAD.BROWSE\">Browse</label>\n</div><input class=\"file-input\" flow-btn id=\"file-input\"><table style=\"float:left;width: 50%\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n<td><md-input-container flex style=\"margin-left: 20%\"><input type=\"text\" name=\"FileName\" ng-model=\"file.TfileName\" \nplaceholder=\"Document Type\"></md-input-container></td><td><md-icon md-font-icon=\"icon-close\" \nng-click=\"RemoveFiles($index, uploader.flow.files)\"></md-icon></td></tr></table><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files);uploader.flow.files = []\" style=\"float:right\"><span>Upload</span>\n</md-button></div></md-content><table id=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">File Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDocument Type</span></div></th><th class=\"secondary-text\"><div><span>File Size</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">Uploaded By</span></div></th><th\n class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Templatedatas\"><td>{{$index+1}}.</td><td><a href=\"{{UploadsURL}}HRM/Template/{{row.TableID}}\" \ndownload=\"{{row.FileName}}\" style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileID }}</td><td>\n{{ (row.FileSize/1024).toFixed(2) }} KB</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y\' }}\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Adelete(row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div>\n</div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -60px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n    .file-input{\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/contracttemplate/contracttemplatedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CONTRACTTEMPLATE.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_TEMPLATE?\">\nAre you sure you want to cancel this template?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"TFdelete(deleteID)\" class=\"md-raised md-accent\" translate=\"CONTRACTTEMPLATE.YES\">Yes</md-button><md-button \nclass=\"md-raised\" ng-click=\"cancel()\" translate=\"CONTRACTTEMPLATE.NO\">No</md-button></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/expirydetails/expirydetails.html","<div id=\"expiry\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"EXPIRYDETAILS.HEADER\">Expiry Details</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" \nlayout-align=\"start center\" style=\"margin-top: -32px\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'EXPIRYDETAILS.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"EXPIRYDETAILS.EXPORT\">Export</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-selected=\"vm.selectedIndex\" md-center-tabs=\"false\"><md-tab><md-tab-label><span ng-click=\"NRIC()\" \ntranslate=\"EXPIRYDETAILS.NRIC/FIN\">NRIC/FIN</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-14dp\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Expired()\"><span translate=\"EXPIRYDETAILS.EXPIRED\">\nExpired</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"EXPIRYDETAILS.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"EXPIRYDETAILS.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"EXPIRYDETAILS.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"EXPIRYDETAILS.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" NextMonth()\"><span translate=\"EXPIRYDETAILS.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.FROM\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\">\n<label style=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.TO\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"Search()\"><span translate=\"EXPIRYDETAILS.SEARCH\">Search</span></md-button>\n</div></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_ID\">Employee ID</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_NAME\">Employee Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPIRYDETAILS.NRIC/FIN_NUMBER\">NRIC/FIN Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EXPIRY_DATE\">Expiry Date</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in EmployeInfo\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.EmployeeID }}</td><td>{{ row.EmployeeName }}</td><td>{{ row.NRICNumber }}</td><td>\n{{row.NRICExpiryDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-click=\"Passport()\" translate=\"EXPIRYDETAILS.PASSPORT\">Passport</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Expired()\"><span \ntranslate=\"EXPIRYDETAILS.EXPIRED\">Expired</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"lastmonth()\"><span translate=\"EXPIRYDETAILS.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"EXPIRYDETAILS.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"EXPIRYDETAILS.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"EXPIRYDETAILS.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" NextMonth()\"><span translate=\"EXPIRYDETAILS.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.FROM\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\">\n<label style=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.TO\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" Search()\"><span translate=\"EXPIRYDETAILS.SEARCH\">Search</span></md-button>\n</div></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_ID\">Employee ID</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_NAME\">Employee Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPIRYDETAILS.PASSPORT_NUMBER\">Passport Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EXPIRY_DATE\">Expiry Date</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in EmployeInfo\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.EmployeeID }}</td><td>{{ row.EmployeeName }}</td><td>{{row.PassportNo}}</td><td>\n{{row.WorkPassExpiryDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span ng-click=\"Course()\" translate=\"EXPIRYDETAILS.COURSE\">Course</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Expired()\"><span translate=\"EXPIRYDETAILS.EXPIRED\">\nExpired</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"lastmonth()\"><span \ntranslate=\"EXPIRYDETAILS.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"EXPIRYDETAILS.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"EXPIRYDETAILS.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"EXPIRYDETAILS.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" NextMonth()\"><span translate=\"EXPIRYDETAILS.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.FROM\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\">\n<label style=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.TO\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" Search()\"><span translate=\"EXPIRYDETAILS.SEARCH\">Search</span></md-button>\n</div></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_ID\">Employee ID</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_NAME\">Employee Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPIRYDETAILS.EXPIRY_DATE\">Expiry Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Organizationdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.BusinessUnitName }}\n</td><td>{{ row.BusinessUnitCode }}</td><td>{{ row.BusinessUnitLocation }}</td></tr></tbody></table></div></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span ng-click=\"Pass()\" translate=\"EXPIRYDETAILS.PASS\">Pass</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Expired()\"><span \ntranslate=\"EXPIRYDETAILS.EXPIRED\">Expired</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"lastmonth()\"><span translate=\"EXPIRYDETAILS.LAST_MONTH\">Last Month</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"lastweek()\"><span translate=\"EXPIRYDETAILS.LAST_WEEK\">Last Week</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"Today()\"><span \ntranslate=\"EXPIRYDETAILS.TODAY\">Today</span></md-button><md-button id=\"button\" class=\"md-raised md-background\" \nng-click=\"NextWeek()\"><span translate=\"EXPIRYDETAILS.NEXT_WEEK\">Next Week</span></md-button><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" NextMonth()\"><span translate=\"EXPIRYDETAILS.NEXT_MONTH\">Next Month</span>\n</md-button><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"1\" id=\"Datefilter\"><label \nstyle=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.FROM\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"1\" id=\"Datefilter\">\n<label style=\"color:green;font-size: 14px\" translate=\"EXPIRYDETAILS.TO\">To</label><md-datepicker \nonkeydown=\"return false\" class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\" Search()\"><span translate=\"EXPIRYDETAILS.SEARCH\">Search</span></md-button>\n</div></div><br><br><div class=\"content-card\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_ID\">Employee ID</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EMPLOYEE_NAME\">Employee Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"EXPIRYDETAILS.PASS_NUMBER\">Pass Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EXPIRYDETAILS.EXPIRY_DATE\">Expiry Date</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"row in EmployeInfo\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.EmployeeID }}</td><td>{{ row.EmployeeName }}</td><td>{{ row.PassNumber }}</td><td>\n{{row.ExpiryDate | date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div></div></md-tab-body></md-tab></md-tabs></div>\n</div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n    button#cancel {\r\n        margin-bottom: 40px;\r\n    }\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    button#button {\r\n    margin-bottom: 50px;\r\n}\r\n\r\n\r\n#Datefilter md-datepicker .md-datepicker-input {\r\nwidth:1;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: green !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: green !important;\r\n    border-bottom-color: red !important;\r\n}\r\n\r\n\r\n#viewedit.md-button {\r\n\r\n color: black !important;\r\nmargin-top: 20px;\r\n}\r\n\r\n.md-datepicker-button {\r\ndisplay: none;\r\n} \r\n\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/Family.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"EMPLOYEE.FAMILY_PARTICULARS\">Family Particulars</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.FuName\" \nplaceholder=\"{{ \'EMPLOYEE.NAME\' | translate }}\" required></md-input-container><md-input-container id=\"datepopup\" flex \nstyle=\"margin-top: 18px\"><label translate=\"EMPLOYEE.DATE_OF_BIRTH\">Date of Birth</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.FuDOB\"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate=\"EMPLOYEE.RELATIONSHIP\">Relationship</label><md-select ng-model=\"vm.FuRelationship\"><md-option \nvalue=\"Father\">{{\'EMPLOYEE.FATHER\'| translate}}</md-option><md-option value=\"Mother\">{{\'EMPLOYEE.MOTHER\'| translate}}\n</md-option><md-option value=\"Husband \">{{\'EMPLOYEE.HUSBAND\'| translate}}</md-option><md-option value=\"Wife \">\n{{\'EMPLOYEE.WIFE\'| translate}}</md-option><md-option value=\"Son \">{{\'EMPLOYEE.SON\'| translate}}</md-option><md-option \nvalue=\"Daughter\">{{\'EMPLOYEE.DAUGHTER\'| translate}}</md-option><md-option value=\"Brother \">\n{{\'EMPLOYEE.BROTHER\'| translate}}</md-option><md-option value=\"Sister\">{{\'EMPLOYEE.SISTER\'| translate}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.FuOccupation\" placeholder=\"{{ \'EMPLOYEE.OCCUPATION\' | translate }}\"></md-input-container>\n<md-input-container flex><label translate=\"EMPLOYEE.NATIONALITY\">Nationality</label><md-select \nng-model=\"vm.FuNationality\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.sFuNationality\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_NATIONALITY\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.FuNationality = null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in NationalityList | filter:vm.sFuNationality\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.FuHomeTel\" \nplaceholder=\"{{ \'EMPLOYEE.HOME_TEL\' | translate }}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.FuMobile\" placeholder=\"{{ \'EMPLOYEE.MOBILE\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.FuEmail\" \nplaceholder=\"{{ \'EMPLOYEE.EMAIL\' | translate }}\"></md-input-container><md-input-container flex></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Familyadd()\" \nng-disabled=\"eventForm.$invalid\" translate=\"EMPLOYEE.SUBMIT\">{{\'EMPLOYEE.SUBMIT\'|translate}}</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"cancel()\" translate=\"EMPLOYEE.CANCEL\">{{\'EMPLOYEE.CANCEL\'|translate}}</md-button>\n</div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n         #datepopup md-datepicker .md-datepicker-input {\r\n            width: calc(17vw - 15px);\r\n            max-width: calc(35vw - 54px);\r\n               margin-left: -11px;\r\n        }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/Membership.html","<md-dialog class=\"event-form-dialog\" style=\"width:70%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"EMPLOYEE.MEMBERSHIP\">Membership</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"EMPLOYEE.MEMBERSHIP_NAME\">Membership Name</label>\n<md-select ng-model=\"vm.uMembershipName\" required><md-select-header><input ng-model=\"vm.suMembershipName\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_MEMBERSHIP\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.uMembershipName = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Membershipdatas | filter : vm.suMembershipName\" \nvalue=\"{{row.MembershipName}}\">{{row.MembershipName}}</md-option></md-select></md-input-container><md-input-container \nid=\"datepopup\" flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.VALID_FROM\">Valid From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.uMembershipValidFrom\"></md-datepicker></md-input-container><md-input-container \nid=\"datepopup\" flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.VALID_TO\">Valid To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.uMembershipValidTo\"></md-datepicker></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Membershipadd()\" \ntranslate=\"EMPLOYEE.SUBMIT\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"cancel()\" translate=\"EMPLOYEE.CANCEL\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n         #datepopup md-datepicker .md-datepicker-input {\r\n           width: calc(17vw - 15px);\r\n            max-width: calc(35vw - 54px);\r\n               margin-left: -11px;\r\n        }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/Qualification.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EMPLOYEE.QUALIFICATIONS\">Qualifications</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.QuQualificationsName\" \nplaceholder=\"{{ \'EMPLOYEE.QUALIFICATIONS_NAME\' | translate }}\" required></md-input-container><md-input-container flex \nid=\"datepopup\" style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.FROM\">From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.QuFrom\"></md-datepicker></md-input-container><md-input-container flex \nid=\"datepopup\" style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.TO\">To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.QuTo\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.QuNameofSchoolInstitution\" \nplaceholder=\"{{ \'EMPLOYEE.NAME/SCHOOL_OF_INSTITUTION\' | translate }}\"></md-input-container><md-input-container flex>\n<label translate=\"EMPLOYEE.COUNTRY\">Country</label><md-select ng-model=\"vm.QuCountry\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchQContry\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_COUNTRY..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.QuCountry = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in CountyList | filter:vm.searchQContry\" value=\"{{row.name}}\">{{row.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"EMPLOYEE.HIGHEST_QUALIFICATIONS_ATTAINED\">\nHighest Qualifications Attained</label><md-select ng-model=\"vm.QuHighestQualificationsAttained\"><md-option \nvalue=\"No qualification\" translate=\"EMPLOYEE.NO_QUALIFICATION\">No qualification</md-option><md-option value=\"Primary \" \ntranslate=\"EMPLOYEE.PRIMARY\">Primary</md-option><md-option value=\"Lower secondary\" \ntranslate=\"EMPLOYEE.LOWER_SECONDARY\">Lower secondary</md-option><md-option value=\"Secondary \" \ntranslate=\"EMPLOYEE.SECONDARY\">Secondary</md-option><md-option value=\"Junior College\" \ntranslate=\"EMPLOYEE.JUNIOR_COLLEGE\">Junior College</md-option><md-option value=\"Polytechnic and Arts Institution \" \ntranslate=\"EMPLOYEE.POLYTECHNIC_AND_ARTS_INSTITUTION\">Polytechnic and Arts Institution</md-option><md-option \nvalue=\"Other Diploma \" translate=\"EMPLOYEE.OTHER_DIPLOMA\">Other Diploma</md-option><md-option value=\"University  \" \ntranslate=\"EMPLOYEE.UNIVERSITY\">University</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Qualificationadd()\" \nng-disabled=\"eventForm.$invalid\" translate=\"EMPLOYEE.SUBMIT\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"cancel()\" translate=\"EMPLOYEE.CANCEL\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    #CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n     #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(17vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n            margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/employee.html","<div id=\"employee\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span \ntranslate=\"EMPLOYEE.HEADER\">Employee Profile</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"EMPLOYEE.TOTAL_EMPLOYEES\">Total Employees:</span> <span>{{TotalEmployeedatas.length}}</span></div></div><div\n class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH\' | translate }}\" flex></div><md-checkbox ng-show=\"Search\" ng-model=\"uShowResigned\" \nng-change=\"ShowResigned(uShowResigned)\" type=\"checkbox\">{{ \'EMPLOYEE.SHOW_RESIGNED?\' | translate }}</md-checkbox><div>\n<md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span translate=\"EMPLOYEE.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"EMPLOYEE.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"ExportData()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"EMPLOYEE.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" ng-show=\"Employeegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"TotalEmployeedatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\" nowrap=\"nowrap\"><div><span class=\"column-title\" translate=\"EMPLOYEE.EMPLOYEE_ID\">Employee ID\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.EMPLOYEE_NAME\">\nEmployee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Display Name</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.GENDER\">Gender</span></div></th><th\n class=\"secondary-text\"><div><span translate=\"EMPLOYEE.UNIQUE\" class=\"column-title\">NRIC/FIN/Unique #</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.COUNTRY\">Country</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.CITIZENSHIP\">Citizenship</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">DOB</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"EMPLOYEE.DESIGNATION\">Designation</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"EMPLOYEE.DIVISION\">Division</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"EMPLOYEE.TEAM\">Team</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in TotalEmployeedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nng-class=\"{ \'color-red\': row.IsActive == false,  \'color-blue\': row.IsActive == true}\" style=\"cursor:pointer\" \nng-click=\"Employeeinfo(row.id)\">{{ row.EmployeeID }}</td><td>{{ row.EmployeeFullName }}</td><td>{{ row.EmployeeName }}\n</td><td>{{row.Gender}}</td><td>{{row.NRICNumber}}</td><td>{{row.Country}}</td><td>{{row.Citizenship}}</td><td>\n{{row.DateofBirth | date:\'dd/MM/y\'}}</td><td>{{row.EDesignation}}</td><td>{{row.EDivision}}</td><td>{{row.ETeam}}</td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Employeeinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteEmployeepopup(row, $event)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><ms-form-wizard flex ng-show=\"Employeeform\"><md-tabs \nmd-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"false\"><md-tab><md-tab-label><span \nng-if=\"wizardStep1.$valid\"></span> <span class=\"ms-form-wizard-step-text\" translate=\"EMPLOYEE.PERSONAL_INFORMATION\">\nPersonal Information</span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex style=\"flex: 0.5\">\n<input type=\"text\" name=\"EmployeeID\" ng-model=\"vm.uEmployeeID\" placeholder=\"{{ \'EMPLOYEE.EMPLOYEE_ID\' | translate }}\" \nrequired readonly=\"readonly\"><div ng-messages=\"wizardStep1.EmployeeID.$error\" \nng-show=\"wizardStep1.EmployeeID.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"EMPLOYEE.EMPLOYEE_ID_FIELD_IS_REQUIRED\">Employee ID field is required.</span></div></div>\n</md-input-container><md-input-container flex style=\"flex: 0.5\"><label translate=\"EMPLOYEE.SALUTATION\">Salutation\n</label><md-select ng-model=\"vm.uSalutation\" ng-change=\"getMartial(vm.uSalutation)\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\" translate=\"EMPLOYEE.SALUTATION\">Salutation..</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.uSalutation = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Mr\">Mr</md-option><md-option \nvalue=\"Mrs\">Mrs</md-option><md-option value=\"Miss\">Miss</md-option><md-option value=\"Ms\">Ms</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"uEmployeeFullName\" \nng-model=\"vm.uEmployeeFullName\" placeholder=\"Employee Name\" required></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"EmployeeName\" ng-model=\"vm.uEmployeeName\" placeholder=\"Display Name\" required><div \nng-messages=\"wizardStep1.EmployeeName.$error\" ng-show=\"wizardStep1.EmployeeName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Display Name is required.</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"EMPLOYEE.GENDER\">Gender</label><md-select ng-model=\"vm.uGender\"><md-select-header><span \nstyle=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">{{\'EMPLOYEE.GENDER\'|translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.uGender = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Male\" translate=\"EMPLOYEE.MALE\">\nMale</md-option><md-option value=\"Female\" translate=\"EMPLOYEE.FEMALE\">Female</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EMPLOYEE.MARITAL_STATUS\">Marital Status</label><md-select ng-model=\"vm.uMaritalStatus\"><md-select-header>\n<span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">{{\'EMPLOYEE.MARITAL_STATUS\'|translate}}</span><md-button\n class=\"md-icon-button\" ng-click=\"vm.uMaritalStatus = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Married\" \ntranslate=\"EMPLOYEE.MARRIED\">Married</md-option><md-option value=\"Single\" translate=\"EMPLOYEE.SINGLE\">Single\n</md-option><md-option value=\"Divorced\" translate=\"EMPLOYEE.DIVORCED\">Divorced</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Citizenship\" ng-model=\"vm.uCitizenship\" \nplaceholder=\"Citizenship\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Race\" \nng-model=\"vm.uRace\" placeholder=\"Race\"></md-input-container><md-input-container flex><label>Pass Type</label><md-select\n ng-model=\"vm.uVisaType\"><md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Pass Type...\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.uVisaType = null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in VisaTypedatas\" value=\"{{row.VisaTypeName}}\">{{row.VisaTypeName}}</md-option></md-select>\n</md-input-container></div><br><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.uPlaceofBirth\" placeholder=\"{{ \'EMPLOYEE.PLACE_OF_BIRTH\' | translate }}\"></md-input-container>\n<md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.DATE_OF_BIRTH\">Date of Birth\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.uDateofBirth\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.uDLClass\" placeholder=\"Driving License Class\">\n</md-input-container><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label \ntranslate=\"EMPLOYEE.LICENSE_EXPIRY_DATE\">License Expiry Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.uDrivingLicenseExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label>License Issue Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.uDLicenseIssueDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" name=\"NRICNumber\" ng-model=\"vm.uNRICNumber\" \nplaceholder=\"{{\'EMPLOYEE.UNIQUE_NUMBER\'|translate}}\" required><div ng-messages=\"wizardStep1.NRICNumber.$error\" \nng-show=\"wizardStep1.EmployeeID.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nNRIC/FIN/Unique Number field is required.</span></div></div><p ng-show=\"error1\" style=\"color:red\">\nNRIC/FIN/Unique Number Is already Exist.</p></md-input-container><md-input-container id=\"date4\" flex \nstyle=\"margin-top: 18px\"><label>NRIC Issued Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.uNRICIssuedDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"Passport Number\" ng-model=\"vm.uWorkPermitNumber\" placeholder=\"Work Permit Number\">\n</md-input-container><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label>Permit Issue Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.permitIssueDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label>Permit Expiry Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.permitExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span\n ng-if=\"wizardStep2.$valid\"></span> <span class=\"ms-form-wizard-step-text\" translate=\"EMPLOYEE.EMPLOYEE_DETAILS\">\nEmployment Details</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EMPLOYEE.DESIGNATION\">Designation</label><md-select ng-model=\"vm.EuDesignation\" \nmd-on-close=\"vm.searchDesignation = \'\'\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchDesignation\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"{{\'EMPLOYEE.SEARCH_FOR_A_DESIGNATION..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.EuDesignation = null;vm.searchDesignation = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in JobTitledatas | filter:vm.searchDesignation track by $index\" ng-value=\"row.JobTitle\">{{row.JobTitle}}\n</md-option></md-select></md-input-container><md-input-container flex><label translate=\"EMPLOYEE.COST_CENTER\">\nCost Center</label><md-select ng-model=\"vm.EuCostCenter\" id=\"searchmodule\" md-on-close=\"vm.searchCC = \'\'\">\n<md-select-header><input ng-model=\"vm.searchCC\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_COST_CENTRE\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.EuCostCenter = null;vm.searchCC = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Costcentredatas | filter:vm.searchCC track by $index\" ng-value=\"row.CostCentreName\">\n{{row.CostCentreName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"EMPLOYEE.DIVISION\">Division</label><md-select ng-model=\"vm.EuDivision\" id=\"searchmodule\" \nmd-on-close=\"vm.searchDivision = \'\'\"><md-select-header><input ng-model=\"vm.searchDivision\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search For A Division\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.EuDivision = null;vm.searchDivision = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Divisiondatas | filter:vm.searchDivisionsearchCC track by $index\" ng-value=\"row.DivisionName\">\n{{row.DivisionName}}</md-option></md-select></md-input-container></div><br><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"EMPLOYEE.JOB_CATEGORY\">Job Category</label><md-select \nng-model=\"vm.EuJobCategory\" id=\"searchmodule\" md-on-close=\"vm.searchJob = \'\'\"><md-select-header><input \nng-model=\"vm.searchJob\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_JOB_CATEGORY\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.EuJobCategory = null;vm.searchJob = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in JobCategoriesdatas | filter:vm.searchJob track by $index\" ng-value=\"row.Name\">{{row.Name}}\n</md-option></md-select></md-input-container><md-input-container flex><label translate=\"EMPLOYEE.EMPLOYMENT_STATUS\">\nEmployment Status</label><md-select ng-model=\"vm.EuEmploymentStatus\" id=\"searchmodule\" md-on-close=\"vm.searchES = \'\'\">\n<md-select-header><input ng-model=\"vm.searchES\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_STATUS..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.EuEmploymentStatus = null;vm.searchES = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EmploymentStatusdatas | filter:vm.searchES track by $index\" ng-value=\"row.EmploymentStatusName\">\n{{row.EmploymentStatusName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"EMPLOYEE.SUPERVISOR\">Supervisor</label><md-select ng-model=\"vm.EuSupervisor\" id=\"searchmodule\" \nmd-on-close=\"vm.searchSV = \'\'\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchSV\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_SUPERVISOR..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.EuSupervisor = null;vm.EuSupervisor = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedataselect | filter:vm.searchSV track by $index\" ng-value=\"row\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container></div><br><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.PROBATION_STARTS_DATE\">\nProbation Starts Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EuProbationStartDate\" \nng-change=\"getDoJ(vm.EuProbationStartDate)\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"EMPLOYEE.PROBATION_COMPLETION_DATE\">Probation Completion Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.EuProbationCompletionDate\"></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.DATE_OF_JOIN\">Date Of Join</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.EuDateOfJoin\" ng-change=\"getPCD(vm.EuDateOfJoin)\"></md-datepicker>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span\n ng-if=\"wizardStep3.$valid\"></span> <span class=\"ms-form-wizard-step-text\" translate=\"EMPLOYEE.CONTACT_INFORMATION\">\nContact Information</span></md-tab-label><md-tab-body><form name=\"wizardStep3\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><span translate=\"EMPLOYEE.LOCAL_ADDRESS\" class=\"h4\" style=\"color:#7f9593\"><b>\n{{\'EMPLOYEE.LOCAL_ADDRESS\'|translate}}</b></span><md-input-container class=\"md-block\"><label \ntranslate=\"EMPLOYEE.RESIDENTIAL_ADDRESS\">Residential Address</label><input type=\"text\" \nng-model=\"vm.CuResidentialAddress\" placeholder=\"\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.CuUnitBuilding\" \nplaceholder=\"{{ \'EMPLOYEE.UNIT/BUILDING\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.CuPostal\" placeholder=\"{{ \'EMPLOYEE.POSTAL\' | translate }}\"></md-input-container>\n<md-input-container flex><label translate=\"EMPLOYEE.COUNTRY\">Country</label><md-select ng-model=\"vm.CuCountry\" \nid=\"searchmodule\" md-on-close=\"vm.searchcuContry = \'\'\"><md-select-header><input ng-model=\"vm.searchcuContry\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Country..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CuCountry = null;vm.searchcuContry = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Countrydatas | filter:vm.searchcuContry\" \nng-click=\"vm.CountryName = row.CountryName; vm.CountryCode=row.CountryCode;\" value=\"{{row.CountryName}}\">\n{{row.CountryName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.CuHomeTel\" \nplaceholder=\"{{ \'EMPLOYEE.HOME_TEL\' | translate }}\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.CuMobile\" placeholder=\"{{ \'EMPLOYEE.MOBILE\' | translate }}\"></md-input-container><md-input-container flex>\n<input type=\"email\" ng-model=\"vm.CuEmail\" placeholder=\"{{ \'EMPLOYEE.EMAIL\' | translate }}\"></md-input-container></div>\n<span class=\"h4\" style=\"color:#7f9593\" translate=\"EMPLOYEE.OVERSEAS_ADDRESS\"><b>\n{{\'EMPLOYEE.OVERSEAS_ADDRESS\'|translate}}</b></span><md-input-container class=\"md-block\"><label \ntranslate=\"EMPLOYEE.PERMANENT_RESIDENTIAL_ADDRESS\">Permanent Residential Address</label><input type=\"text\" \nng-model=\"vm.uPermanentResidentialAddress\" placeholder=\"\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.CuOUnitBuilding\" \nplaceholder=\"{{ \'EMPLOYEE.UNIT/BUILDING\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.CuOPostalZip\" placeholder=\"{{ \'EMPLOYEE.POSTAL\' | translate }}\"></md-input-container>\n<md-input-container flex><label translate=\"EMPLOYEE.COUNTRY\">Country</label><md-select ng-model=\"vm.CuOCountry\" \nid=\"searchmodule\" md-on-close=\"vm.searchCuOCountry = \'\'\"><md-select-header><input ng-model=\"vm.searchCuOCountry\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Country..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.CuOCountry = null;vm.searchCuOCountry = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Countrydatas | filter:vm.searchCuOCountry\" value=\"{{row.CountryName}}\">{{row.CountryName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.CuOContactNo\" \nplaceholder=\"{{ \'EMPLOYEE.CONTACT_NUMBER\' | translate }}\"></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep4.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\" translate=\"EMPLOYEE.QUALIFICATIONS\">Qualifications</span></md-tab-label><md-tab-body>\n<form name=\"wizardStep4\" class=\"md-inline-form\" ms-form-wizard-form novalidate><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"EMPLOYEE.QUALIFICATIONS\"><b>{{\'EMPLOYEE.QUALIFICATIONS\'|translate}}</b></span><div layout=\"column\" \nlayout-align=\"start end\"><div style=\"margin-top:-40px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Qualificationpopup()\"><span translate=\"EMPLOYEE.ADD\">Add</span></md-button>\n</div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex ng-show=\"Qualificationdiv\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"EMPLOYEE.QUALIFICATIONS_NAME\">Qualifications Name</label>\n<md-select ng-model=\"vm.QuQualificationsName\" md-on-close=\"vm.searchQn = \'\'\" id=\"searchmodule\" \nng-required=\"Qualificationdiv\"><md-select-header><input ng-model=\"vm.searchQn\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{\'EMPLOYEE.QUALIFICATIONS_NAME\'|translate}}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.QuQualificationsName = null;vm.searchQn = \'\'\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Educationdatas | filter:vm.searchQn\" ng-value=\"row.EducationName\">{{row.EducationName}}</md-option>\n</md-select></md-input-container><md-input-container flex id=\"datepopup\" style=\"margin-top: 18px\"><label \ntranslate=\"EMPLOYEE.FROM\">From</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.QuFrom\"></md-datepicker>\n</md-input-container><md-input-container flex id=\"datepopup\" style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.TO\">To\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.QuTo\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.QuNameofSchoolInstitution\" \nplaceholder=\"{{ \'EMPLOYEE.NAME_OF_SCHOOL/INSTITUTION\' | translate }}\"></md-input-container><md-input-container flex>\n<label translate=\"EMPLOYEE.COUNTRY\">Country</label><md-select ng-model=\"vm.QuCountry\" id=\"searchmodule\" \nmd-on-close=\"vm.searchQContry = \'\'\"><md-select-header><input ng-model=\"vm.searchQContry\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_COUNTRY..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.QuCountry = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Countrydatas | filter:vm.searchQContry\" value=\"{{row.CountryName}}\">{{row.CountryName}}</md-option>\n</md-select></md-input-container><md-input-container flex><label translate=\"EMPLOYEE.HIGHEST_QUALIFICATIONS_ATTAINED\">\nHighest Qualifications Attained</label><md-select ng-model=\"vm.QuHighestQualificationsAttained\" \nmd-on-close=\"vm.searchhqa = \'\'\" id=\"searchmodule\" ng-required=\"Qualificationdiv\"><md-select-header><input \nng-model=\"vm.searchQn\" style=\"flex: auto\" type=\"text\" placeholder=\"Highest Qualifications Attained\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.QuHighestQualificationsAttained = null;vm.searchhqa = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Educationdatas | filter:vm.searchhqa\" ng-value=\"row.EducationLevel\">{{row.EducationLevel}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"Qualificationadd()\" ng-disabled=\"!vm.QuQualificationsName\" \ntranslate=\"EMPLOYEE.SAVE_QUALIFICATION\">Save Qualification</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"closeaddform()\" translate=\"EMPLOYEE.CANCEL\">Cancel</md-button></div></div><br><div \nclass=\"white-bg md-whiteframe-1dp\" ng-if=\"!Qualificationdiv\" style=\"font-size:13.5px\"><table \nclass=\"table dataTable row-border hover\" id=\"tb2\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EMPLOYEE.QUALIFICATIONS_NAME\">Qualifications Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EMPLOYEE.FROM\">From</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EMPLOYEE.TO\">To</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.NAME_OF_SCHOOL/INSTITUTION\">\nName of School/Institution</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"EMPLOYEE.COUNTRY\">Country</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"EMPLOYEE.HIGHEST_QUALIFICATIONS_ATTAINED\">Highest Qualifications Attained</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.VIEW/EDIT\">View/Edit</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"EMPLOYEE.DELETE\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in EmployeeQualificationdatas\" ng-if=\"row.EmployeeID == vm.uEmployeeID\"><td>&nbsp;\n</td><td>{{ row.QQualificationsName }}</td><td>{{ row.QFrom | date:\'dd/MM/y\' }}</td><td>{{ row.QTo | date:\'dd/MM/y\'}}\n</td><td>{{ row.QNameofSchoolInstitution}}</td><td>{{ row.QCountry}}</td><td>{{ row.QHighestQualificationsAttained}}\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Qualificationsupdate($event, row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"employeepopup($event, row.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div><br><span translate=\"EMPLOYEE.SKILLS\" class=\"h4\" style=\"color:#7f9593\"><b>{{\'EMPLOYEE.SKILLS\'|translate}}\n</b></span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"EMPLOYEE.SKILLS\">Skills\n</label><md-select ng-model=\"vm.uSkill\" ng-model-options=\"{trackBy: \'$value.Name\'}\" md-on-close=\"vm.searchuSkill = \'\'\" \nmultiple=\"\"><md-select-header><input ng-model=\"vm.searchuSkill\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"{{ \'EMPLOYEE.SEARCH_FOR_A_SKILLS\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.uSkill = null;vm.searchuSkill = \'\'\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-optgroup><md-option ng-value=\"row\" \nng-model=\"row.Name\" ng-repeat=\"row in skilldatas | filter : vm.searchuSkill\">{{row.Name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\" translate=\"EMPLOYEE.LICENCE\"><b>\n{{\'EMPLOYEE.LICENCE\'|translate}}</b></span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EMPLOYEE.LICENCE_NAME\">Qualifications Name</label><md-select ng-model=\"vm.QLicenceName\" \nmd-on-close=\"vm.searchln = \'\'\" id=\"searchmodule\" ng-required=\"Qualificationdiv\"><md-select-header><input \nng-model=\"vm.searchQn\" style=\"flex: auto\" type=\"text\" placeholder=\"{{ \'EMPLOYEE.LICENCE_NAME\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.QLicenceName = null;vm.searchln = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Licensedatas | filter:vm.searchln\" ng-value=\"row.Licenses\">{{row.Licenses}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.LICENCE_START_DATE\">\nLicence Start Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.QLicenceStartDate\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.LICENCE_END_DATE\">\nLicence End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.QLicenceEndDate\"></md-datepicker>\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span\n ng-if=\"wizardStep6.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Emergency Contact</span></md-tab-label>\n<md-tab-body><form name=\"wizardStep6\" class=\"md-inline-form\" ms-form-wizard-form novalidate><span class=\"h4\" \nstyle=\"color:#7f9593\" translate=\"EMPLOYEE.FAMILY_PARTICULARS\"><b>{{\'EMPLOYEE.FAMILY_PARTICULARS\'|translate}}</b></span>\n<div layout=\"column\" layout-align=\"start end\"><div style=\"margin-top:-40px\"><md-button class=\"md-raised md-raised\" \naria-label=\"Custom Icon Button\" ng-click=\"Familypopup($event)\"><span translate=\"EMPLOYEE.ADD\">Add</span></md-button>\n</div></div><div class=\"form-wrapper md-whiteframe-1dp\" flex ng-show=\"Familydiv\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.FuName\" \nplaceholder=\"{{ \'EMPLOYEE.NAME\' | translate }}\" ng-required=\"Familydiv\"></md-input-container><md-input-container \nid=\"datepopup\" flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.DATE_OF_BIRTH\">Date of Birth</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.FuDOB\"></md-datepicker></md-input-container><md-input-container \nflex><label translate=\"EMPLOYEE.RELATIONSHIP\">Relationship</label><md-select ng-model=\"vm.FuRelationship\"><md-option \nvalue=\"Father\" translate=\"EMPLOYEE.FATHER\">Father</md-option><md-option value=\"Mother\" translate=\"EMPLOYEE.MOTHER\">\nMother</md-option><md-option value=\"Husband\" translate=\"EMPLOYEE.HUSBAND\">Husband</md-option><md-option value=\"Wife\" \ntranslate=\"EMPLOYEE.WIFE\">Wife</md-option><md-option value=\"Son \" translate=\"EMPLOYEE.SON\">Son</md-option><md-option \nvalue=\"Daughter\" translate=\"EMPLOYEE.DAUGHTER\">Daughter</md-option><md-option value=\"Brother \" \ntranslate=\"EMPLOYEE.BROTHER\">Brother</md-option><md-option value=\"Sister\" translate=\"EMPLOYEE.SISTER\">Sister\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.FuOccupation\" placeholder=\"{{ \'EMPLOYEE.OCCUPATION\' | translate }}\">\n</md-input-container><md-input-container flex><label translate=\"EMPLOYEE.NATIONALITY\">Nationality</label><md-select \nng-model=\"vm.FuNationality\" id=\"searchmodule\" md-on-close=\"vm.sFuNationality = \'\'\"><md-select-header><input \nng-model=\"vm.sFuNationality\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Nationality..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.FuNationality = null;vm.sFuNationality = \'\'\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Nationalitydatas | filter:vm.sFuNationality\" value=\"{{row.NationalityName}}\">{{row.NationalityName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.FuHomeTel\" \nplaceholder=\"{{ \'EMPLOYEE.HOME_TEL\' | translate }}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.FuMobile\" placeholder=\"{{ \'EMPLOYEE.MOBILE\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.FuEmail\" \nplaceholder=\"{{ \'EMPLOYEE.EMAIL\' | translate }}\"></md-input-container><md-input-container flex></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"Familyadd()\" \nng-disabled=\"!vm.FuName\" translate=\"EMPLOYEE.SAVE_FAMILY_PARTICULARS\">Save Family Particulars</md-button><md-button \nclass=\"md-raised md-raised\" ng-click=\"closeaddform()\" translate=\"EMPLOYEE.CANCEL\">Cancel</md-button></div></div><br>\n<div class=\"white-bg md-whiteframe-1dp\" ng-if=\"!Familydiv\" style=\"font-size:13.5px\"><table \nclass=\"table dataTable row-border hover\" id=\"tb2\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"EMPLOYEE.NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"EMPLOYEE.DATE_OF_BIRTH\">Date of Birth</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"EMPLOYEE.RELATIONSHIP\">\nRelationship</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"EMPLOYEE.NATIONALTY\">Nationality</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"EMPLOYEE.MOBILE\">Mobile</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"EMPLOYEE.VIEW/EDIT\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"EMPLOYEE.DELETE\">Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in EmployeeFamilyatas\" ng-if=\"row.EmployeeID == vm.uEmployeeID\"><td>&nbsp;</td><td>{{ row.FName }}</td>\n<td>{{ row.FDOB | date:\'dd/MM/y\' }}</td><td>{{ row.FRelationship }}</td><td>{{ row.FNationality }}</td><td>\n{{ row.FMobile}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Familyupdate($event, row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"employeeFpopup($event, row.id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div><br><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"EMPLOYEE.NEXT_OF_KIN_CONTACT\"><b>{{\'EMPLOYEE.NEXT_OF_KIN_CONTACT\'| translate }}</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.uName\" \nplaceholder=\"{{ \'EMPLOYEE.NAME\' | translate }}\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NRelationship\" placeholder=\"{{ \'EMPLOYEE.RELATIONSHIP\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.NHomeTel\" \nplaceholder=\"{{ \'EMPLOYEE.HOME_TEL\' | translate }}\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.NOfficeTel\" \nplaceholder=\"{{ \'EMPLOYEE.OFFICE_TEL\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.NMobile\" placeholder=\"{{ \'EMPLOYEE.MOBILE\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"email\" ng-model=\"vm.NEmail\" placeholder=\"{{ \'EMPLOYEE.EMAIL\' | translate }}\">\n</md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span\n ng-if=\"wizardStep7.$valid\"></span> <span class=\"ms-form-wizard-step-text\" translate=\"EMPLOYEE.WORK_WEEK&LEAVES\">\nWork Week & Leaves</span></md-tab-label><md-tab-body><form name=\"wizardStep7\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><span translate=\"EMPLOYEE.WORK WEEK\" class=\"h4\" style=\"color:#7f9593\"><b>\n{{\'EMPLOYEE.WORK WEEK\'|translate}}</b></span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"EMPLOYEE.WORK_WEEK_CODE\">Work Week Code</label><md-select ng-model=\"vm.uWorkWeekCode\" \nng-change=\"workweek(vm.uWorkWeekCode)\" md-on-close=\"vm.searchwwc = \'\'\" required><md-select-header><input \nng-model=\"vm.searchwwc\" style=\"flex: auto\" type=\"text\" placeholder=\"{{ \'EMPLOYEE.WORK_WEEK_CODE\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.uWorkWeekCode = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"{{row.WorkWeekCode}}\" ng-repeat=\"row in Workweekdatas | filter: vm.searchwwc\">\n{{row.WorkWeekCode}}</md-option></md-select></md-input-container></div><span class=\"h4\" style=\"color:#7f9593\" \ntranslate=\"EMPLOYEE.LEAVES\"><b>Leaves</b></span><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input\n type=\"number\" name=\"Annual\" ng-model=\"vm.Annual\" placeholder=\"{{ \'EMPLOYEE.ANNUAL_LEAVE\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.SickHospitalisation\" \nplaceholder=\"Medical Leave\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Adoption\" \nplaceholder=\"Hospitalization Leave\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" name=\"Maternity\" ng-model=\"vm.Maternity\" \nplaceholder=\"{{ \'EMPLOYEE.MATERNITY\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Paternity\" placeholder=\"{{ \'EMPLOYEE.PATERNITY\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.ChildCare\" placeholder=\"Child Care\"></md-input-container>\n</div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nng-if=\"wizardStep8.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Documents</span></md-tab-label><md-tab-body>\n<form name=\"wizardStep8\" class=\"md-inline-form\" ms-form-wizard-form novalidate><span></span><md-content><md-list><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.Spinner==true\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-list-item class=\"md-3-line\" ng-repeat=\"item in messages\"><div \nclass=\"md-list-item-text\"><h3>{{item.Name}}</h3><br><input id=\"{{item.value}}\" class=\"file-input\" type=\"file\"> <span \nid=\"test{{item.value}}\"><a></a></span></div><md-button id=\"Upload{{item.value}}\" ng-disabled=\"\" \nng-click=\"UploadFile(item.value)\" style=\"color: white\" class=\"md-warn md-raised md-hue-2\">Upload</md-button><md-button \nid=\"Delete{{item.value}}\" ng-click=\"Removefile(item.value)\" class=\"md-raised md-raised\">Delete</md-button><md-divider>\n</md-divider></md-list-item></md-list></md-content><br><span><b>For Foreigners Only</b></span><md-content><md-list>\n<md-list-item class=\"md-3-line\" ng-repeat=\"item in fmessages\"><div class=\"md-list-item-text\"><h3>{{item.Name}}</h3><br>\n<input id=\"{{item.value}}\" class=\"file-input\" type=\"file\"> <span id=\"test{{item.value}}\"><a></a></span></div><md-button\n id=\"Upload{{item.value}}\" ng-click=\"UploadFile(item.value)\" style=\"color: white\" class=\"md-warn md-raised md-hue-2\">\nUpload</md-button><md-button id=\"Delete{{item.value}}\" ng-click=\"Removefile(item.value)\" class=\"md-raised md-raised\">\nDelete</md-button><md-divider></md-divider></md-list-item></md-list></md-content><br></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\" \nng-if=\"(vm.EuEmploymentStatus | uppercase).includes(\'RESIGN\') || (vm.EuEmploymentStatus | uppercase).includes(\'TERMINAT\')\">\n<md-tab-label><span ng-if=\"wizardStep9.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Resignation</span>\n</md-tab-label><md-tab-body><form name=\"wizardStep9\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"EMPLOYEE.STATUS\">Status</label><md-select\n ng-model=\"vm.ResignationStatus\" md-on-close=\"vm.searchres = \'\'\" required><md-select-header><input \nng-model=\"vm.searchres\" style=\"flex: auto\" type=\"text\" placeholder=\"{{ \'EMPLOYEE.STATUS..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.ResignationStatus = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"{{row.EmploymentStatusName}}\" \nng-repeat=\"row in EmploymentStatusdatas | filter: vm.searchres\">{{row.EmploymentStatusName}}</md-option></md-select>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"EMPLOYEE.RESIGNATION_DATE\">\nResignation Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.RuResignationofDate\" required>\n</md-datepicker></md-input-container><md-input-container flex><label translate=\"EMPLOYEE.REASON_FOR_RESIGNATION\">\nReason for Resignation</label><md-select ng-model=\"vm.RuReason\" required><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\" translate=\"EMPLOYEE.REASON_FOR_RESIGNATION..\">Reason for Resignation..</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.RuReason = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option value=\"Better Job Offer\" \ntranslate=\"EMPLOYEE.BETTER_JOB_OFFER\">Better Job Offer</md-option><md-option value=\"Health Reasons\" \ntranslate=\"EMPLOYEE.HEALTH_REASONS\">Health Reasons</md-option><md-option value=\"Type of Work\" \ntranslate=\"EMPLOYEETYPE_OF_WORK.\">Type of Work</md-option><md-option value=\"Work Conditions\" \ntranslate=\"EMPLOYEE.WORK_CONDITIONS\">Work Conditions</md-option><md-option value=\"Lack of Recognition\" \ntranslate=\"EMPLOYEE.LACK_OF_RECOGNITION\">Lack of Recognition</md-option><md-option value=\"Contract Not Renewed\" \ntranslate=\"EMPLOYEE.CONTRACT_NOT_RENEWED\">Contract Not Renewed</md-option><md-option value=\"Dismissed\" \ntranslate=\"EMPLOYEE.DISMISSED\">Dismissed</md-option><md-option value=\"Laid-off\" translate=\"EMPLOYEE.LAID-OFF\">Laid-off\n</md-option><md-option value=\"Physically Disabled/Compensated\" translate=\"EMPLOYEE.PHYSICALLY_DISABLED/COMPENSATED\">\nPhysically Disabled/Compensated</md-option><md-option value=\"Resigned - CompanyRequested\" \ntranslate=\"EMPLOYEE.RESIGNED-COMPANY_REQUESTED\">Resigned - Company Requested</md-option><md-option \nvalue=\"Resigned - Self Proposed\" translate=\"EMPLOYEE.RESIGNED-SELF_PROPOSED\">Resigned - Self Proposed</md-option>\n<md-option value=\"Others\" translate=\"EMPLOYEE.OTHERS\">Others</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex ng-show=\"vm.RuReason ==\'Others\'\"><input \nng-model=\"vm.RuOtherReason\" placeholder=\"{{ \'EMPLOYEE.REASON_FOR_RESIGNATION\' | translate }}\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.RuRemarks\" placeholder=\"{{ \'EMPLOYEE.REMARKS\' | translate }}\">\n</md-input-container></div><md-button class=\"md-raised md-raised\" ng-click=\"ExitInterview(SID)\" \nng-disabled=\"msWizard.currentStepInvalid()\">Exit Interview</md-button></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"end right\" style=\"margin-top:-60px\"><md-button class=\"md-raised\" \nng-click=\"msWizard.previousStep()\" translate=\"EMPLOYEE.PREVIOUS\">Previous</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" translate=\"EMPLOYEE.NEXT\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\" \nng-hide=\"msWizard.isLastStep() && (vm.EuEmploymentStatus | uppercase).includes(\'RESIGN\') || (vm.EuEmploymentStatus | uppercase).includes(\'TERMINAT\')\">\n<md-button class=\"md-raised md-accent\" ng-click=\"sSubmit()\" ng-disabled=\"msWizard.currentStepInvalid()\" \ntranslate=\"EMPLOYEE.SUBMIT\">Submit</md-button><md-button class=\"md-raised md-raised\" ng-click=\"Showgrid()\" \ntranslate=\"EMPLOYEE.CANCEL\">Cancel</md-button></div></ms-form-wizard></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 2px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #date4 md-datepicker .md-datepicker-input {\r\n        width: calc(15vw - 23px);\r\n        max-width: calc(25vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #seprate md-datepicker .md-datepicker-input {\r\n        width: calc(40vw - 54px);\r\n        max-width: calc(45vw - 64px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item {\r\n        opacity: 1 !important;\r\n        padding: 24px;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        content: counter(serial-number);\r\n    }\r\n\r\n    .md-button.md-fab {\r\n        z-index: 20;\r\n        line-height: 56px;\r\n        min-width: 0;\r\n        width: 56px;\r\n        height: 56px;\r\n        vertical-align: middle;\r\n        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\r\n        border-radius: 0%;\r\n        background-clip: padding-box;\r\n        overflow: hidden;\r\n        -webkit-transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n        transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\r\n        -webkit-transition-property: background-color, box-shadow, -webkit-transform;\r\n        transition-property: background-color, box-shadow, -webkit-transform;\r\n        transition-property: background-color, box-shadow, transform;\r\n        transition-property: background-color, box-shadow, transform, -webkit-transform;\r\n    }\r\n\r\n\r\n\r\n    #uploadButton md-button :hover {\r\n        background-color: none;\r\n    }\r\n\r\n    #attachmenthref label:hover {\r\n        border-bottom: 1px solid #23527c;\r\n        cursor: pointer !important;\r\n        color: #23527c !important;\r\n    }\r\n\r\n    #tb2 .dataTables_wrapper .bottom {\r\n        display: none;\r\n    }\r\n\r\n    .color-red {\r\n        color: red;\r\n    }\r\n\r\n    .color-blue {\r\n        color: rgb(3, 155, 229);\r\n    }\r\n\r\n    #datepopup md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 15px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    input[type=\'file\'] {\r\n        /*Default styles for field*/\r\n        font-weight: 500;\r\n        border: 1px solid rgba(0, 0, 0, .08);\r\n\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/employeeFpopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EMPLOYEE.DELETE_THIS_FAMILY_PARTICULARS?\">Delete this Family Particullars?</span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"Familydelete(deleteID)\" class=\"md-raised md-accent\" translate=\"EMPLOYEE.YES\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\" translate=\"EMPLOYEE.NO\">No</md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/employeeMpopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EMPLOYEE.DELETE_THIS_MEMBERSHIP?\">Delete this Membership?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Membershipelete(deleteID)\" \nclass=\"md-raised md-accent\" translate=\"EMPLOYEE.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"EMPLOYEE.NO\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/employee/employeepopup.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate ng-if=\"!vm.DeleteEmployee\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Delete this Qualification?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Qualificationelete(deleteID)\" \nclass=\"md-raised md-accent\" translate=\"EMPLOYEE.YES\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\" \ntranslate=\"EMPLOYEE.NO\">No</md-button></div></md-dialog-content></form><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate ng-if=\"vm.DeleteEmployee\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Delete this Employee?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><span>\nAre you sure you want to delete this employee?</span><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"DeleteEmployee()\" class=\"md-raised md-accent\">Yes</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\" translate=\"EMPLOYEE.NO\">No</md-button></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/pass/pass.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-hospital\"></md-icon><span translate=\"PASS.HEADER\">Pass Management</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"PASS.TOTAL_PASSES\">Total Passes:</span> <span>\n{{Passdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'PASS.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"PASS.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" \nng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"PASS.BACK\">Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"PASS.EXPORT\">Export</span></md-button></div></div><div \nclass=\"content-card\" ng-show=\"Passgrid\"><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PASS.EMPLOYEE_ID\">Employee Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PASS.EMPLOYEE_NAME\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PASS.PASS_NUMBER\">Pass Number\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PASS.PASS_DETAILS\">Pass Details</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"PASS.APPLIED_DATE\">Applied Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"PASS.ISSUED_DATE\">Isued Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"PASS.EXPIRY_DATE\">Expiry Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"PASS.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Passsummary\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.EmployeeID}}</td><td>{{ row.EmployeeName}}</td><td>\n{{ row.PassNumber}}</td><td>{{row.PassDetails}}</td><td>{{row.AppliedDate | date:\'dd/MM/y\' }}</td><td>\n{{row.IssuedDate | date:\'dd/MM/y\' }}</td><td>{{row.ExpiryDate | date:\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"passinfo(row.ID)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Passform\" flex><form name=\"basicForm\" novalidate><div\n layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><md-select ng-model=\"EmployeeID\" \nplaceholder=\"{{ \'PASS.EMPLOYEE_NAME\' | translate }}\"><md-option ng-repeat=\"row in Employeedatas\" \nvalue=\"{{row.EmployeeID}}\">{{row.EmployeeName}}</md-option></md-select><div ng-messages=\"basicForm.EmployeeID.$error\" \nng-show=\"basicForm.EmployeeID.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PASS.EMPLOYEE_NAME_FIELD_IS_REQUIRED\">Employee Name field is required.</span></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"PassNumber\" ng-model=\"PassNumber\" \nplaceholder=\"{{ \'PASS.PASS_NUMBER\' | translate }}\" required><div ng-messages=\"basicForm.PassNumber.$error\" \nng-show=\"basicForm.PassNumber.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PASS.PASS_NUMBER_FIELD_IS_REQUIRED\">Pass Number field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"PassDetails\" placeholder=\"{{ \'PASS.PASS_DETAILS\' | translate }}\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -11px\"><label translate=\"PASS.APPLIED_DATE\">Applied Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"AppliedDate\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -11px\"><label translate=\"PASS.ISSUED_DATE\">Issued Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"IssuedDate\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -11px\"><label translate=\"PASS.EXPIRY_DATE\">Expiry Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"ExpiryDate\"></md-datepicker></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" translate=\"PASS.SUBMIT\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"PASS.CANCEL\">Cancel</md-button></div></form></div>\n</div></div></div></div><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74.5px;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(27vw - 35px);\r\nmax-width: calc(35vw - 54px);\r\n}\r\n.ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item {\r\nopacity: 1 !important;\r\npadding: 24px;\r\n}\r\n\r\n.ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\nborder-bottom: none !important;\r\n}\r\n\r\n.ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\nborder-bottom: none !important;\r\n}\r\n\r\n.md-tab.md-active {\r\nbackground-color: #9E9E9E;\r\n}\r\n\r\n#example tr td {\r\n    height: 30px;\r\n}\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/leave/leave.html","<div id=\"leave\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-hospital\"></md-icon><span translate=\"LEAVE.HEADER\">Leave Request</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"lSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'LEAVE.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised reference-button\" \nng-show=\"lView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span translate=\"LEAVE.BACK\">\nBack</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"lExport && AllowExport==\'true\'\" \nng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"LEAVE.EXPORT\">Export</span>\n</md-button></div></div><div class=\"content-card\" ng-show=\"Leavegrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Leavedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEAVE.REFERENCE\">Reference #</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.EMPLOYEE_NAME\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.LEAVE_TYPE\">Leave Type\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEAVE.LEAVE_FROM\">Leave From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEAVE.LEAVE_TO\">Leave To</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.TOTAL_DAYS\">Total Days</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.PAID_LEAVES\">Paid Leaves\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEAVE.UNPAID_LEAVES\">Unpaid Leaves</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"LEAVE.STATUS\">Status</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"LEAVE.REPORT\">Report</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Leavedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nng-click=\"Leaveinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.LeaveType }}</td><td>\n{{ row.FromDate | date:\'dd/MM/y\' }}</td><td>{{ row.ToDate | date:\'dd/MM/y\' }}</td><td>{{ row.TotalDaysApplied }}</td>\n<td>{{ row.TotalPaidLeaves }}</td><td>{{ row.TotalUnPaidLeaves }}</td><td>{{ row.Status }}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"delete(row._id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div>\n<div class=\"content\" id=\"printleave\" ng-show=\"Pop\"><div style=\"font-size:25px;font-weight:600\"><img \nsrc=\"assets/images/logos/pest_logo.png\">&emsp;&emsp;<b>LEAVE REQUEST</b> <img ng-if=\"QRCode\" \nstyle=\"height:20%; width:20%;float:right;margin-top:-1%\" src=\"{{QRCode}}\"></div><br><div \nstyle=\"font-size:17px;text-align:left\"><table style=\"width:100%;border: 1px solid black;border-collapse: collapse\">\n<thead><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.REFERENCE_NO\">Reference No.</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{ReferenceNo}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.EMPLOYEE_NAME\">Employee Name</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{EmployeeName}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.LEAVE_TYPE\">Leave Type</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{LeaveType}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.FROM_DATE\">From Date</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{FromDate | date:\'dd/MM/y\'}} &nbsp; {{FromDayType}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.TO_DATE\">To Date</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{ToDate | date:\'dd/MM/y\'}} &nbsp; {{ToDayType}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.REASON_FOR_TAKING_LEAVE\">Reason for Taking Leave</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{Reason}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.EMERGENCY_CONTACT_NUMBER\">Emergency Contact Number</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{EmergencyContactNo}}</th></tr><tr style=\"background-color:#9E9E9E\"><th colspan=\"2\" \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1500px;text-align:center;font-size:17px\" \ntranslate=\"LEAVE.LEAVE_DETAILS\">LEAVE DETAILS</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.TOTAL_DAYS\">Total Days</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{TotalDaysApplied}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.TOTAL_PAID_LEAVES\">Total Paid Leaves</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{TotalPaidLeaves}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.TOTAL_UNPAID_LEAVES\">Total Unpaid Leaves</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{TotalUnPaidLeaves}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.LEAVE_TAKEN\">Leave Taken</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{LeaveTaken}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.LEAVE_BALANCE\">Leave Balance</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{LeaveBalance}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\" \ntranslate=\"LEAVE.LEAVE_ENTITLEMENT\">Leave Entitlement</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{LeaveEntitlement}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\">\nNo. of Male associates applying leave on the same date/s as above</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{MaleAssociate}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\">\nNo. of Female associates applying leave on the same date/s as above</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{FemaleAssociate}}</th></tr><tr><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:350px;text-align:left;font-size:17px;padding:3px\">\nNo. of Trainee attend training on the same date/s as above</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:1100px;text-align:left;font-weight:normal;font-size:17px;padding:3px\">\n&nbsp;&nbsp; {{TraineeAssociate}}</th></tr></thead><tbody></tbody></table></div><br><br><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:1500px\" translate=\"LEAVE.PREPARED_BY\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\" translate=\"LEAVE.RECEIVED_BY\">Received By<br><br><br><br></th></tr><tr>\n<th style=\"border-collapse: collapse;width:1500px\" translate=\"LEAVE.DATE_PREPARED\">Date Prepared<br><br><br><br></th>\n<th style=\"border-collapse: collapse;width:700px\" translate=\"LEAVE.DATE_RECEIVED\">Date Received<br><br><br><br></th>\n</tr><tr><th style=\"border-collapse: collapse;width:1500px\" translate=\"LEAVE.VERIFIED/ISSUED_BY\">Verified/ Issued By\n</th><th style=\"border-collapse: collapse;width:700px\" translate=\"LEAVE.DELIVERED_BY\">Delivered By</th></tr></thead>\n<tbody></tbody><tfoot></tfoot></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Leaveform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:48.5%;float:left\"><h2 style=\"text-align:left\" translate=\"LEAVE.LEAVE_REQUEST_DETAILS\">\n&nbsp;LEAVE REQUEST DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px\" \ntranslate=\"LEAVE.REFERENCE_NO\">Reference No.</label>&nbsp; : &nbsp; {{ReferenceNo}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.EMPLOYEE_NAME\">Employee Name</label>\n&nbsp; :&nbsp; {{EmployeeName}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" \ntranslate=\"LEAVE.LEAVE_TYPE\">Leave Type</label>&nbsp; :&nbsp; {{LeaveType}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.FROM_DATE\">From Date</label>\n&nbsp; :&nbsp; {{FromDate | date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.TO_DATE\">To Date</label>\n&nbsp; :&nbsp; {{ToDate | date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.REASON_FOR_TAKING_LEAVE\">\nReason for Taking Leave</label>&nbsp; :&nbsp; {{Reason}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.EMERGENCY_CONTACT_NUMBER\">\nEmergency Contact Number</label>&nbsp; :&nbsp; {{EmergencyContactNo}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.TOTAL_DAYS\">Total Days</label>\n&nbsp; :&nbsp; {{TotalDaysApplied}}<br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" \ntranslate=\"LEAVE.TOTAL_PAID_LEAVES\">Total Paid Leaves</label>&nbsp; :&nbsp; {{TotalPaidLeaves}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.TOTAL_UNPAID_LEAVES\">\nTotal Unpaid Leaves</label>&nbsp; :&nbsp; {{TotalUnPaidLeaves}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.LEAVE_TAKEN\">Leave Taken</label>\n&nbsp; :&nbsp; {{LeaveTaken}} (Excluding this request)<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.LEAVE_BALANCE\">Leave Balance</label>\n&nbsp; :&nbsp; {{LeaveBalance}} (Excluding this request)<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\" translate=\"LEAVE.LEAVE_ENTITLEMENT\">Leave Entitlement\n</label>&nbsp; :&nbsp; {{LeaveEntitlement1}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:155px;margin-top: 5px\"></label>&nbsp; :&nbsp; {{LeaveEntitlement2}}<br>&nbsp;\n<label style=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\" \ntranslate=\"LEAVE.NO_OF_MALE_ASSOCIATES_APPLYING_LEAVE_ON_THE_SAME_DATE/S\">\nNo. of Male associates applying leave on the same date/s</label>&nbsp; :&nbsp; {{MaleAssociate}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\" \ntranslate=\"LEAVE.NO_OF_FEMALE_ASSOCIATES_APPLYING_LEAVE_ON_THE_SAME_DATE/S\">\nNo. of Female associates applying leave on the same date/s</label>&nbsp; :&nbsp; {{FemaleAssociate}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:270px;margin-top: 5px\" \ntranslate=\"LEAVE.NO_OF_TRAINEE_ATTEND_TRAINING_ON_THE_SAME_DATE/S\">No. of Trainee attend training on the same date/s\n</label>&nbsp; :&nbsp; {{TraineeAssociate}}<br></div><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:50.5%;float:right\"><h2 style=\"text-align:left\" translate=\"LEAVE.WORKFLOW\">&nbsp;WORKFLOW</h2><hr><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\" translate=\"LEAVE.CURRENT_STATUS\">\nCurrent Status</label>: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><label \nstyle=\"width:100px;font-weight:500\" translate=\"LEAVE.NEXT_STATUS\">Next Status</label>: &emsp; {{NextLevelAction}}</div>\n</div><br><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-a ccent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span translate=\"LEAVE.REJECT\">Reject</span></md-button></div><div layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" \nid=\"cancel\" value=\"Cancel\" ng-click=\"cancel()\"><span translate=\"LEAVE.CANCEL\">Cancel</span></md-button></div><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button \nclass=\"md-accent md-raised\" id=\"revise\" value=\"Revise\" ng-click=\"revise()\"><span translate=\"LEAVE.REVISE\">Revise</span>\n</md-button></div></div><br><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEAVE.ACTION\">Action</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.ACTIONED_BY\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.ACTIONED_DATE\">\nActioned Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>\n{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div></form><br><form \nname=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\" \ntranslate=\"LEAVE.COMMENTS\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" \nplaceholder=\"{{ \'LEAVE.COMMENT_HERE..\' | translate }}\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span translate=\"LEAVE.SAVE\">Save</span></md-button></div>\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEAVE.COMMENT\">Comment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEAVE.COMMENTED_BY\">Commented By</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.COMMENTED_DATE\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\" \ntranslate=\"LEAVE.ATTACHMENTS\">&nbsp;ATTACHMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content\n layout-padding><div flow-init flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span translate=\"LEAVE.UPLOAD\">Upload</span></md-button></div><table \nstyle=\"float:left\"><tr ng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.\n</td><td>{{file.name}}</td></tr></table></div></md-content></div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEAVE.FILE_NAME\">File Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.FILE_SIZE(KB)\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEAVE.UPLOADED_BY\">Uploaded By\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEAVE.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"LEAVE.CANCEL\">Cancel\n</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    \r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/health/eshattendance/eshattendance.html","<div id=\"eshattendance\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>ESH Attendance</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Attendancegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Attendancedatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Attach Timesheet</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attendancedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Date | date:\'dd/MM/y\'}}</td><td>{{ row.Description}}</td><td>{{ row.Attachment}}</td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Attendanceinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Attendanceform\" flex><form name=\"basicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label>Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"Date\" required></md-datepicker></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"Description\" placeholder=\"Description\" required><div ng-messages=\"basicForm.Description.$error\" \nng-show=\"basicForm.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.</span>\n</div></div></md-input-container><choose-file layout=\"row\" flex><input id=\"fileInput\" type=\"file\" class=\"ng-hide\">\n<md-input-container flex class=\"md-block\"><input type=\"text\" ng-model=\"Attachment\" placeholder=\"Attach Timesheet\" \ndisabled=\"disabled\"></md-input-container><div><md-button id=\"uploadButton\" class=\"md-fab md-mini\"><md-icon \nmd-font-icon=\"icon-attachment\"></md-icon></md-button></div></choose-file></div><div layout=\"row\" class=\"bottom\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"aSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n             .md-datepicker-button {\r\n  display: none;\r\n}\r\n             ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n }\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    [disabled] md-input-container.md-default-theme .md-input, [disabled] md-input-container .md-input, md-input-container.md-default-theme .md-input[disabled], md-input-container .md-input[disabled] {\r\n    border-bottom-color: transparent;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    color: rgba(0,0,0,0.38);\r\n    background-image: linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0);\r\n    background-image: -ms-linear-gradient(left,transparent 0,rgba(0,0,0,0.38) 100%);\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/health/checkup/checkup.html","<div id=\"checkup\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Medical Checkup</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"cSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"cAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"cview\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"cExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Checkupgrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Medicalcheckupdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Delete\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Test Date</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Medical Institution</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Medical Test</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Test Type</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Medicalcheckupdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"Checkupinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Checkupinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Checkupdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td><td>\n{{ row.TestDate | date:\'dd/MM/y\'}}</td><td>{{ row.MedicalInstitution }}</td><td>{{ row.MedicalTest }}</td><td>\n{{ row.TestType }}</td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Checkupform\" flex><form name=\"basicForm\" novalidate><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container style=\"margin-top: -6px\" flex><label>Employee Name\n</label><md-select ng-model=\"Employee\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header>\n<input ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search for a Employee..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"MedicalInstitution\" \nng-model=\"MedicalInstitution\" placeholder=\"Medical Institution\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"MedicalTest\" ng-model=\"MedicalTest\" placeholder=\"Medical Test\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"start center\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\">\n<label>Test Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"TestDate\" md-date-format=\"dd/MM/y\" required>\n</md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label>\nNext Test Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"NextTestDate\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container><md-input-container flex><input type=\"text\" name=\"TestType\" ng-model=\"TestType\" \nplaceholder=\"Test Type\"></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container flex><input type=\"number\" name=\"RBCCount\" ng-model=\"RBCCount\" placeholder=\"RBC Count\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"Remarks\"></md-input-container><md-input-container flex></md-input-container></div><div layout=\"row\" \nclass=\"bottom\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/health/checkup/checkupdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this Checkup Detail?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Cdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/health/eshbreifing/eshbreifing.html","<div id=\"eshbreifing\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>ESH Breifing</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Breifinggrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Breifingdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Breifingdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y\'}}</td><td>{{ row.Description }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Breifinginfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Breifingform\" flex><form name=\"basicForm\" novalidate><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container style=\"margin-top: -6px\" flex><label>Employee</label><md-select ng-model=\"Employee\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a requester..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Employee=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label>Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"Date\" md-date-format=\"dd/MM/y\" required></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"Description\" \nplaceholder=\"Description\"></md-input-container></div><div layout=\"row\" class=\"bottom\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"bSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div>\n</div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    \r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/health/incident/incident.html","<div id=\"incident\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Incident Reports</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"iSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"iAdd\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"iView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"iExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Incidentgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Incidentdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Incident Title</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reported Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Report Done By</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Created On</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"INSURANCEITEMS.REMARKS\">Remarks</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"INSURANCEITEMS.VIEW/EDIT\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Incidentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.InsuranceName }}</td>\n<td>{{row.StartDate | date: \"dd/MM/y\"}}</td><td>{{ row.ProviderName }}</td><td>{{row.CreatedDate | date: \"dd/MM/y\"}}\n</td><td>{{row.Remarks}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"shiftinfo(row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Incidentform\" flex><form name=\"basicForm\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"InsuranceName\" \nplaceholder=\"Incident Title\" required></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label>\nIncident Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"StartDate\" required></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"ProviderName\" placeholder=\"Reported By\" \nrequired></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container \nflex><input type=\"text\" ng-model=\"Remarks\" placeholder=\"{{ \'INSURANCEITEMS.REMARKS\' | translate }}\">\n</md-input-container></div><md-content><md-list><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular ng-if=\"vm.Spinner==true\" md-mode=\"indeterminate\"></md-progress-circular></div><md-list-item \nclass=\"md-3-line\" ng-repeat=\"item in messages\"><div class=\"md-list-item-text\"><h3>Upload Document</h3><br><input \nid=\"{{item.value}}\" class=\"file-input\" type=\"file\"> <span id=\"test{{item.value}}\"><a></a></span></div><md-button \nid=\"Upload{{item.value}}\" ng-disabled=\"\" ng-click=\"UploadFile(item.value)\" style=\"color: white\" \nclass=\"md-warn md-raised md-hue-2\">Upload</md-button><md-button id=\"Delete{{item.value}}\" \nng-click=\"Removefile(item.value)\" class=\"md-raised md-raised\">Delete</md-button><md-divider></md-divider>\n</md-list-item></md-list></md-content><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\" translate=\"INSURANCEITEMS.SUBMIT\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"INSURANCEITEMS.CANCEL\">Cancel</md-button></div></form>\n</div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -80px;\r\n    }\r\n\r\n    .file-input {\r\n        display: block ;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/health/incident/incidentdelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this incident report?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"Wdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/health/medical/medical.html","<div id=\"medical\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Medical Certificate</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"mSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"mAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"mView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"mExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Medicalgrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Medicaldatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reference #</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Report\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Requester Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Claim Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Visit Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Medical Institution</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Medicaldatas\" ng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Medicalinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.ClaimDate | date:\'dd/MM/y\' }}</td><td>{{ row.VisitDate | date:\'dd/MM/y\' }}</td><td>{{ row.MedicalInstitution }}\n</td><td>{{ row.Amount }}</td><td>{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Medicalform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;MEDICAL CLAIM REQUEST DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Reference No.\n</label>&nbsp;:&nbsp;{{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Requested By\n</label>&nbsp;:&nbsp;{{EmployeeName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Claim Date\n</label>&nbsp;:&nbsp;{{ClaimDate | date:\'dd/MM/y\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">Visit Date</label>&nbsp;:&nbsp;{{VisitDate | date:\'dd/MM/y\'}}<br><br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Medical Institution</label>\n&nbsp;:&nbsp;{{MedicalInstitution}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Amount</label>\n&nbsp;:&nbsp;{{Amount|number:2}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Consultation\n</label>&nbsp;:&nbsp;{{Consultation|number:2}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\nReimbursable</label>&nbsp;:&nbsp;{{Reimbursable|number:2}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">Medical Leave</label>&nbsp;:&nbsp;{{MedicalLeave}}<br><br>&nbsp;<label\n style=\"font-size:17px;color:#7f9593;width:150px\">Purpose</label>&nbsp;:&nbsp;{{Purpose}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">Remarks</label>&nbsp;:&nbsp;{{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr>\n<div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancelreq()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h2 style=\"text-align:left\">\n&nbsp;REIMBURSABLE DETAILS</h2><hr><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"number\" name=\"Amount\" ng-model=\"Amount\" placeholder=\"Amount\"><div ng-messages=\"basicForm.Amount.$error\" \nng-show=\"basicForm.Amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Amount is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"number\" name=\"Consultation\" ng-model=\"Consultation\" \nplaceholder=\"Consultation\"><div ng-messages=\"basicForm.Consultation.$error\" ng-show=\"basicForm.Consultation.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Consultation is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Reimbursable\" ng-model=\"Reimbursable\" placeholder=\"Reimbursable\">\n<div ng-messages=\"basicForm.Reimbursable.$error\" ng-show=\"basicForm.Reimbursable.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Reimbursable is required.</span></div></div></md-input-container><md-button \nng-show=\"Claimsave\" type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"mUpdate()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Save</md-button></div>\n</div></form><br><form name=\"basicForm1\" class=\"md-inline-form\" novalidate><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\">\n<md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" \nrequired></md-input-container></div><div style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" \nng-click=\"commentSubmit()\" ng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button>\n</div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}HRMHealth&Safety/MedicalClaim/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised, .md-button.md-accent.md-raised {\r\n        margin-bottom: 50px !important;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n        #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n        #tb3 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb3 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/insurance/items/items.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Vehicle Insurance</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"INSURANCEITEMS.TOTAL_INSURANCE_ITEMS:\">Total Insurance Items:</span> <span>{{Insuranceitemsdatas.length}}\n</span></div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'INSURANCEITEMS.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"INSURANCEITEMS.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"INSURANCEITEMS.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"sExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"INSURANCEITEMS.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Insuranceitemsgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Insuranceitemsdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Insurance Provider</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Due Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"INSURANCEITEMS.REMARKS\">Remarks</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"INSURANCEITEMS.VIEW/EDIT\">View/Edit</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Insuranceitemsdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.InsuranceName }}</td><td>{{ row.ProviderName }}</td><td>\n{{row.StartDate | date: \"dd/MM/y\"}}</td><td>{{row.EndDate | date: \"dd/MM/y\"}}</td><td>{{row.Remarks}}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"shiftinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"DeleteInfo(row.id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div>\n</div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Insuranceitemsform\" \nflex><form name=\"basicForm\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"InsuranceName\" placeholder=\"Vehicle Number\" required></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"ProviderName\" placeholder=\"Insurance Provider\" required></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"INSURANCEITEMS.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"StartDate\" \nrequired></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label>Due Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"EndDate\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{ \'INSURANCEITEMS.REMARKS\' | translate }}\"></md-input-container></div><md-content><md-list><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.Spinner==true\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-list-item class=\"md-3-line\" ng-repeat=\"item in messages\"><div \nclass=\"md-list-item-text\"><h3>Upload Document</h3><br><input id=\"{{item.value}}\" class=\"file-input\" type=\"file\"> <span \nid=\"test{{item.value}}\"><a></a></span></div><md-button id=\"Upload{{item.value}}\" ng-disabled=\"\" \nng-click=\"UploadFile(item.value)\" style=\"color: white\" class=\"md-warn md-raised md-hue-2\">Upload</md-button><md-button \nid=\"Delete{{item.value}}\" ng-click=\"Removefile(item.value)\" class=\"md-raised md-raised\">Delete</md-button><md-divider>\n</md-divider></md-list-item></md-list></md-content><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\" translate=\"INSURANCEITEMS.SUBMIT\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"INSURANCEITEMS.CANCEL\">Cancel\n</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n         width: calc(41.5vw - 60px);\r\n         max-width: calc(48vw - 64px);\r\n        margin-left: -11px;\r\n    }\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/insurance/master/master.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>General Insurance</span></div><div \nclass=\"product-count secondary-text\"><span>Total Insurance items:</span> <span>{{Insurancemasterdatas.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'INSURANCEMASTER.SEARCH\' | translate }}\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span translate=\"INSURANCEMASTER.ADD\">Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span \ntranslate=\"INSURANCEMASTER.BACK\">Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"INSURANCEMASTER.EXPORT\">Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Insurancemastergrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Insurancemasterdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Insurance Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Insurance Provider</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Due Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"INSURANCEITEMS.REMARKS\">Remarks\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"INSURANCEITEMS.VIEW/EDIT\">\nView/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Insurancemasterdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.InsuranceName }}</td><td>{{ row.ProviderName }}</td><td>{{row.StartDate | date: \"dd/MM/y\"}}</td><td>\n{{row.EndDate | date: \"dd/MM/y\"}}</td><td>{{row.Remarks}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"shiftinfo(row.id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"DeleteInfo(row.id)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Insurancemasterform\" flex><form name=\"basicForm\" \nnovalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"InsuranceName\" placeholder=\"Insurance Number\" required></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"ProviderName\" placeholder=\"Insurance Provider\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex style=\"margin-top: 18px\"><label \ntranslate=\"INSURANCEITEMS.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"StartDate\" \nrequired></md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px\"><label>Due Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"EndDate\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><input type=\"text\" ng-model=\"Remarks\" \nplaceholder=\"{{ \'INSURANCEITEMS.REMARKS\' | translate }}\"></md-input-container></div><md-content><md-list><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.Spinner==true\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><md-list-item class=\"md-3-line\" ng-repeat=\"item in messages\"><div \nclass=\"md-list-item-text\"><h3>Upload Document</h3><br><input id=\"{{item.value}}\" class=\"file-input\" type=\"file\"> <span \nid=\"test{{item.value}}\"><a></a></span></div><md-button id=\"Upload{{item.value}}\" ng-disabled=\"\" \nng-click=\"UploadFile(item.value)\" style=\"color: white\" class=\"md-warn md-raised md-hue-2\">Upload</md-button><md-button \nid=\"Delete{{item.value}}\" ng-click=\"Removefile(item.value)\" class=\"md-raised md-raised\">Delete</md-button><md-divider>\n</md-divider></md-list-item></md-list></md-content><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\" translate=\"INSURANCEITEMS.SUBMIT\">Submit\n</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\" translate=\"INSURANCEITEMS.CANCEL\">Cancel\n</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(19.5vw - 25px);\r\nmax-width: calc(35vw - 54px);\r\n}\r\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n}\r\n#example tr td {\r\nheight: 30px;\r\n}\r\n#viewedit.md-button {\r\nmargin: -16px 8px;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\nmd-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0;\r\n    font-weight: 500;\r\n}\r\nmd-dialog md-dialog-content {\r\n   padding: 0;\r\n}\r\nmd-dialog md-dialog-actions .md-button {\r\n    margin: 0px 3px;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/performance/review/review.html","");
$templateCache.put("app/main/apps/human-resource/performance/template/template.html","");
$templateCache.put("app/main/apps/human-resource/performance/tracker/tracker.html","");
$templateCache.put("app/main/apps/human-resource/payroll/allowances/allowances.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Settings</span></div><div \nclass=\"product-count secondary-text\"><span>Total Settings:</span> <span>{{Allowancesdatas.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" style=\"margin-top: -32px\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button>\n<md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Allowancesgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Allowancesdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Type Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Type Code\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Period</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Allowancesdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Type}}</td><td>\n{{ row.TypeName}}</td><td>{{ row.TypeCode }}</td><td>{{row.Period}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Allowancesinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\">\n<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Allowancesform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container style=\"width: 15%\">\n<span style=\"color:#7f9593;font-size:16px\">Type :</span></md-input-container><md-radio-container flex=\"15\" \nstyle=\"margin-top:-2px\"><md-radio-group ng-model=\"vm.Type\" layout=\"row\"><md-radio-button value=\"Allowance\">Allowance\n</md-radio-button><md-radio-button value=\"Deduction\">Deduction</md-radio-button></md-radio-group></md-radio-container>\n<md-input-container style=\"width: 22%\"><span style=\"color:#7f9593;font-size:16px\">Period :</span></md-input-container>\n<md-radio-container flex=\"15\" style=\"margin-top:-2px\"><md-radio-group ng-model=\"vm.Period\" layout=\"row\">\n<md-radio-button value=\"Monthly\">Monthly</md-radio-button><md-radio-button value=\"Daily\">Daily</md-radio-button>\n</md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\">\n<md-input-container flex><input type=\"text\" name=\"TypeName\" ng-model=\"vm.TypeName\" placeholder=\"Type Name\" required>\n<div ng-messages=\"basicForm.TypeName.$error\" ng-show=\"basicForm.TypeName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Type Name field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"TypeCode\" ng-model=\"vm.TypeCode\" placeholder=\"Type Code\"><div \nng-messages=\"basicForm.TypeCode.$error\" ng-show=\"basicForm.TypeCode.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Amount field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div\n class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(39.5vw - 35px);\r\n        max-width: calc(45vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/allowances/allowancespopup.html","<md-dialog style=\"width:100%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Attendance</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\" ng-hide=\"Update\"><md-input-container flex><label>Employee</label><md-select \nng-model=\"vm.uEmployee\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Search Employee..\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\" \nng-show=\"Update\"><md-input-container flex><input type=\"text\" ng-model=\"vm.EmpName\" placeholder=\"Employee\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>Start Date</label><md-datepicker ng-model=\"vm.uStartDate\" required \nmd-max-date=\"vm.uStartDate\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>End Date</label><md-datepicker ng-model=\"vm.uEndDate\" required \nmd-max-date=\"vm.uStartDate\"></md-datepicker></md-input-container><md-input-container flex><input \nmdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"time2\" placeholder=\"Time In\" min-date=\"minDate\" \nformat=\"HH:mm:A\" ng-model=\"vm.uTimeIn\" class=\"md-input\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Time Out\" \nmin-date=\"minDate\" format=\"hh:mm A\" ng-model=\"vm.uTimeOut\" class=\"md-input\" readonly=\"readonly\"></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/cpf/alertpopup.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Are you sure want to confirm for selected employee(s) ?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"ConfirmPayroll()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/human-resource/payroll/cpf/bulkeditpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Payroll/CPF Submission</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:15px 15px 5px 15px\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Deductions\" placeholder=\"Deductions\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.EmployeeCPF\" placeholder=\"Employee Levy/CPF\"></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.EmployerCPF\" placeholder=\"Employeer Contribution\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.AgencyAmount\" \nplaceholder=\"Agency Amount\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.SDF\" \nplaceholder=\"SDF Amount\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.PaymentMode\" \nplaceholder=\"Payment Mode\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"UpdateSelected()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/cpf/cpf.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Payroll/CPF Submission</span></div><div \nclass=\"product-count secondary-text\"><span>Total Records:</span> <span>{{EndMonthData.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><label style=\"color:white;font-size: 14px\">\nPayroll/CPF Submission For:</label><md-input-container flex=\"20\"><input \nstyle=\"color:white;font-size: 14px;padding-top:15px\" class=\"search-input\" moment-picker=\"dateFields.selectedDate\" \nformat=\"MMM-YYYY\" max-view=\"month\" ng-model=\"dateFields.selectedDate\" start-date=\"dateFields.selectedDate\" \nstartview=\"year\" min-date=\"\'\'\" max-date=\"\'\'\" ng-change=\"OnMonthChange()\"></md-input-container></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start\" style=\"margin-top: -32px\" flex><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div></div><div class=\"content-card\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div style=\"padding:10px 0% 0 1%;float:right;width: 100%\" ng-show=\"TRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Employee(s) Selected: {{SelectedIds.length}}</a><md-button style=\"background-color:green\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ConfirmSelected($event)\"><span>\nConfirm Selected Employee(s)</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple\" \nng-click=\"EditSelected($event)\"><span>Edit Selected Employee(s)</span></md-button></div><md-progress-linear \nng-hide=\"Employeedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" \nnowrap=\"nowrap\"><div><md-checkbox ng-change=\"CheckAll(All)\" ng-model=\"All\" style=\"margin-bottom:0\" type=\"checkbox\">\n</md-checkbox></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nWorked Months</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Calendar Days</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Total Days</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Day Rate</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nBasic Pay</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">OT</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Incentives</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Gross Pay</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nEmployee<br>Levy/CPF</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Employer<br>\nContribution</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Agency Type</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Agency Amount</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">SDF</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDeductions</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Net Pay</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Payment Mode</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nBank Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Account Number</span></div></th>\n</tr></thead><tbody><tr ng-class=\"RecordStatus(row)\" ng-repeat=\"row in EndMonthData\"><td><md-checkbox \nstyle=\"margin: 0\" ng-change=\"Check(All ,row._id)\" ng-checked=\"Selec.value\" ng-model=\"All\" type=\"checkbox\">\n</md-checkbox></td><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EditIndividual(row._id,$event)\" title=\"View/Edit\" style=\"border:none\">{{ row.EmployeeID }}</a></td><td>\n{{ row.EmployeeName}}</td><td>{{WorkedMonth(row.EDateOfJoin ) || 0 }}</td><td>{{row.CalendarDays || 0 }}</td><td>\n{{ row.TotalDays || 0 }}</td><td>{{ row.DayRate || 0 |number:2}}</td><td>{{ row.BasicPay || 0 |number:2 }}</td><td>\n{{ row.OT || 0 |number:2}}</td><td>{{ row.Incentives || 0 |number:2}}</td><td>{{ row.GrossPay || 0 |number:2}}</td><td>\n{{ row.EmployeeCPF || 0 |number:2}}</td><td>{{ row.EmployerCPF || 0 |number:2}}</td><td>{{ row.AgencyType }}</td><td>\n{{ row.AgencyAmount || 0 |number:2}}</td><td>{{ row.SDF || 0 |number:2}}</td><td>{{ row.Deductions || 0 |number:2}}\n</td><td>{{ row.NetPay || 0 |number:2}}</td><td>{{ row.PaymentMode }}</td><td>{{row.Remarks}}</td><td>\n{{ row.BankName }}</td><td>{{ row.Acc }}</td></tr></tbody></table><div style=\"text-align: right;width: 100%\"><md-button\n style=\"background-color:lightseagreen\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"DownloadPayrollSubmission()\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon><span>\nDownload DBS Payroll Summary</span></md-button><md-button style=\"background-color:lightseagreen\" \nclass=\"md-raised md-accent md-button md-ink-ripple\" ng-click=\"DownloadCPFSubmission()\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon><span>Download CPF Submission Summary</span></md-button>\n<br><br></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(39.5vw - 35px);\r\n        max-width: calc(45vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n\r\n    .RedColor {\r\n        color: red;\r\n    }\r\n\r\n    .GreenColor {\r\n        color: green;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/cpf/editpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Payroll/CPF Submission</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:15px 15px 5px 15px\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Deductions\" placeholder=\"Deductions\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.EmployeeCPF\" placeholder=\"Employee Levy/CPF\"></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.EmployerCPF\" placeholder=\"Employeer Contribution\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.AgencyAmount\" \nplaceholder=\"Agency Amount\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.SDF\" \nplaceholder=\"SDF Amount\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.PaymentMode\" \nplaceholder=\"Payment Mode\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitIndividual()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/endmonth/alertpopup.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Are you sure want to confirm for selected employee(s) ?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"ConfirmPayroll()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/human-resource/payroll/endmonth/bulkeditpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">End Month Payroll</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:15px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"UpdateSelected()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/endmonth/editpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">End Month Payroll</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:15px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.TotalDays\" placeholder=\"Total Days\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.DayRate\" \nplaceholder=\"Day Rate\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NetPay\" placeholder=\"Net Pay\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitIndividual()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" \nclass=\"md-raised\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/endmonth/endmonth.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>End Month Payroll</span></div><div \nclass=\"product-count secondary-text\"><span>Total Records:</span> <span>{{EndMonthData.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><label style=\"color:white;font-size: 14px\">\nEnd-Month Payroll For:</label><md-input-container flex=\"20\"><input \nstyle=\"color:white;font-size: 14px;padding-top:15px\" class=\"search-input\" moment-picker=\"dateFields.selectedDate\" \nformat=\"MMM-YYYY\" max-view=\"month\" ng-model=\"dateFields.selectedDate\" start-date=\"dateFields.selectedDate\" \nstartview=\"year\" min-date=\"\'\'\" max-date=\"\'\'\" ng-change=\"OnMonthChange()\"></md-input-container></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: -32px\" flex><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\">\n</md-icon><span>Download Payroll</span></md-button></div></div><div class=\"content-card\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div style=\"padding:10px 0% 0 1%;float:right;width: 100%\" ng-show=\"TRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Employee(s) Selected: {{SelectedIds.length}}</a><md-button style=\"background-color:green\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ConfirmSelected($event)\"><span>\nConfirm Selected Employee(s)</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple\" \nng-click=\"EditSelected($event)\"><span>Edit Selected Employee(s)</span></md-button></div><md-progress-linear \nng-hide=\"Employeedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" \nnowrap=\"nowrap\"><div><md-checkbox ng-change=\"CheckAll(All)\" ng-model=\"All\" style=\"margin-bottom:0\" type=\"checkbox\">\n</md-checkbox></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nWorked Months</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Calendar Days</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Total Days</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Day Rate</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nBasic Pay</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Net Pay</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Bank Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nAccount Number</span></div></th></tr></thead><tbody><tr ng-class=\"RecordStatus(row)\" ng-repeat=\"row in EndMonthData\">\n<td><md-checkbox style=\"margin: 0\" ng-change=\"Check(All ,row._id)\" ng-checked=\"Selec.value\" ng-model=\"All\" \ntype=\"checkbox\"></md-checkbox></td><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EditIndividual(row._id,$event)\" title=\"View/Edit\" style=\"border:none\">{{ row.EmployeeID }}</a></td><td>\n{{ row.EmployeeName}}</td><td>{{WorkedMonth(row.EDateOfJoin ) || 0 }}</td><td>{{row.CalendarDays || 0 }}</td><td>\n{{ row.TotalWorkedDays || 0 }}</td><td>$ {{DayRate(row.Amount,row.CalendarDays ) || 0 |number:2}}</td><td>\n$ {{ row.Amount || 0 |number:2 }}</td><td>\n$ {{NetPay(DayRate(row.Amount,row.CalendarDays),row.TotalWorkedDays) || 0 |number:2}}</td><td>{{row.Remarks}}</td><td>\n{{ row.BankName }}</td><td>{{ row.Acc }}</td></tr></tbody></table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(39.5vw - 35px);\r\n        max-width: calc(45vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n\r\n    .RedColor {\r\n        color: red;\r\n    }\r\n\r\n    .GreenColor {\r\n        color: green;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/iras/alertpopup.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Are you sure want to confirm for selected employee(s) ?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"ConfirmPayroll()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/human-resource/payroll/iras/iras.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>IRAS Submission</span></div><div \nclass=\"product-count secondary-text\"><span>Total Records:</span> <span>{{EndMonthData.length}}</span></div></div><div \nng-show=\"Export\" class=\"search\" layout=\"row\" layout-align=\"start center\" flex><label \nstyle=\"color:white;font-size: 14px\">IRAS Submission For:</label><md-input-container flex=\"15\"><input \nstyle=\"color:white;font-size: 14px;padding-top:15px\" class=\"search-input\" moment-picker=\"dateFields.selectedDate\" \nformat=\"YYYY\" max-view=\"year\" ng-model=\"dateFields.selectedDate\" start-date=\"dateFields.selectedDate\" startview=\"year\" \nmin-date=\"\'\'\" max-date=\"\'\'\" ng-change=\"OnMonthChange()\"></md-input-container></div><div ng-show=\"Export\" \nclass=\"search\" layout=\"row\" layout-align=\"start\" style=\"margin-top: -32px\" flex><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><md-button style=\"background-color:lightseagreen\" \nng-show=\"Export\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"DownloadIRASSubmission()\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon><span>\nDownload IRAS Summary</span></md-button></div><div class=\"content-card\" ng-show=\"Employeegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div style=\"padding:10px 0% 0 1%;float:right;width: 100%\" ng-show=\"TRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Employee(s) Selected: {{SelectedIds.length}}</a><md-button style=\"background-color:green\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ConfirmSelected($event)\"><span>\nConfirm Selected Employee(s)</span></md-button></div><md-progress-linear ng-hide=\"Employeedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" nowrap=\"nowrap\"><div><md-checkbox \nng-change=\"CheckAll(All)\" ng-model=\"All\" style=\"margin-bottom:0\" type=\"checkbox\"></md-checkbox></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nEmployee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Designation</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Basic Pay</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">OT</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Incentives\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Gross Pay</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Bonus</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Director\'s fees</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nEmployee<br>Levy/CPF</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Agency Amount</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\">SDF</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Net Pay</span></div></th></tr></thead><tbody><tr ng-class=\"RecordStatus(row)\" \nng-repeat=\"row in EndMonthData\"><td><md-checkbox style=\"margin: 0\" ng-change=\"Check(All ,row._id)\" \nng-checked=\"Selec.value\" ng-model=\"All\" type=\"checkbox\"></md-checkbox></td><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EditIndividual(row.EmployeeID,$event)\" title=\"View/Edit\" style=\"border:none\">{{ row.EmpID }}</a></td><td>\n{{ row.EmployeeName}}</td><td>{{ row.Designation}}</td><td>{{ row.BasicPay || 0 |number:2 }}</td><td>\n{{ row.OT || 0 |number:2}}</td><td>{{ row.Incentives || 0 |number:2}}</td><td>{{ row.GrossPay || 0 |number:2}}</td><td>\n{{ row.Bonus || 0 |number:2}}</td><td>{{ row.Directorsfees || 0 |number:2}}</td><td>{{ row.EmployeeCPF || 0 |number:2}}\n</td><td>{{ row.AgencyAmount || 0 |number:2}}</td><td>{{ row.SDF || 0 |number:2}}</td><td>\n{{ row.NetPay || 0 |number:2}}</td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\">\n<ms-form-wizard flex ng-show=\"Employeeform\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span ng-if=\"wizardStep1.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"text\" name=\"EmployeeName\" ng-model=\"vm.EmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><label>Gender</label><md-select ng-model=\"vm.Gender\"><md-select-header>\n<span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">Gender..</span><md-button class=\"md-icon-button\" \nng-click=\"vm.Gender = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option value=\"Male\">Male</md-option><md-option value=\"Female\">Female</md-option>\n</md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"Designation\" \nng-model=\"vm.Designation\" placeholder=\"Designation\"></md-input-container><md-input-container flex id=\"date4\" \nstyle=\"margin-top: 18px\"><label>Date of Birth</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.DOB\">\n</md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"NRICNumber\" ng-model=\"vm.NRICNumber\" placeholder=\"NRIC/FIN Number\"></md-input-container>\n<md-input-container flex><label>Bank</label><md-select ng-model=\"vm.BankCode\" id=\"searchmodule\"><md-select-header>\n<input ng-model=\"vm.searchBankCode\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a bank..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.BankCode = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in BankCodeList | filter:vm.searchBankCode\" value=\"{{row.code}}\">\n{{row.name}}</md-option></md-select></md-input-container><md-input-container flex><label>Nationality</label><md-select \nng-model=\"vm.NationalityCode\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchCitizenship\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a nationality..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.NationalityCode = null\" aria-label=\"Close dialog\" style=\"float:right\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Nationalitydatas | filter:vm.searchCitizenship\" value=\"{{row.NationalityCode}}\">\n{{row.NationalityName}}</md-option></md-select></md-input-container><md-input-container flex><label>Address Type\n</label><md-select ng-model=\"vm.AddressType\" ng-change=\"OnAddressTypeChange()\"><md-option value=\"L\">\nLocal residential address</md-option><md-option value=\"F\">Foreign address</md-option><md-option value=\"C\">\nLocal C/O address</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-show=\"Local\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Block\" placeholder=\"Block/House No.\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.StreetName\" placeholder=\"Street Name\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"Local\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.LevelNo\" placeholder=\"Level No.\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.UnitNo\" placeholder=\"Unit No\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.PostalCode\" placeholder=\"Postal Code\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-hide=\"Local\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Address1\" \nplaceholder=\"Address 1\"></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Address2\" \nplaceholder=\"Address 2\"></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Address3\" \nplaceholder=\"Address 3\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-hide=\"Local\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.PostalCode\" placeholder=\"Postal Code\"></md-input-container>\n<md-input-container flex><label>Country</label><md-select ng-model=\"vm.CountryCode\" id=\"searchmodule\">\n<md-select-header><input ng-model=\"vm.searchCountryCode\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a country..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.CountryCode = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Countrydatas | filter:vm.searchCountryCode\" \nvalue=\"{{row.CountryCode}}\">{{row.CountryName}}</md-option></md-select></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Payment Information</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.MBF\" placeholder=\"Mosque Building Fund\"></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.Donations\" placeholder=\"Donations\"></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.EmployeeCPF\" placeholder=\"CPF/Pension/PF\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Insurance\" placeholder=\"Insurance\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.Salary\" placeholder=\"Salary\" readonly=\"readonly\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Bonus\" placeholder=\"Bonus\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Directorsfees\" placeholder=\"Director\'s fees\"></md-input-container><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.Others\" placeholder=\"Others\"></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\"></span> <span \nclass=\"ms-form-wizard-step-text\">Optional Information</span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<input type=\"number\" ng-model=\"vm.ExemptIncome\" placeholder=\"Exempt Income\"></md-input-container><md-input-container \nflex><input type=\"number\" ng-model=\"vm.AmountOfEmployementIncome\" \nplaceholder=\"Amount of employement income for which tax is borne\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.FixedAmountOfIncomeTax\" placeholder=\"Fixed Amount of income tax\"></md-input-container>\n<md-input-container flex><label>Appendix 8A indicator</label><md-select ng-model=\"vm.Appendix8A\"><md-option value=\"Y\">\nYes</md-option><md-option value=\"N\">No</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Section 45 indicator</label><md-select ng-model=\"vm.Section45\">\n<md-option value=\"Y\" ng-selected>Yes</md-option><md-option value=\"N\">No</md-option></md-select></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.EmployeesIncomeTax\" \nplaceholder=\"Employee\'s income tax is borne by employer indicator\"></md-input-container><md-input-container flex>\n<label>Gratuity/ Notice PAy/ Ex-gratia payment</label><md-select ng-model=\"vm.Gratuity\"><md-option value=\"Y\">Yes\n</md-option><md-option value=\"N\">No</md-option></md-select></md-input-container><md-input-container flex><label>\nCompensation for loss of office</label><md-select ng-model=\"vm.Compensationforlossofoffice\"><md-option value=\"Y\">Yes\n</md-option><md-option value=\"N\">No</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Approval attained from IRAS</label><md-select \nng-model=\"vm.ApprovalattainedfromIRAS\"><md-option value=\"Y\">Yes</md-option><md-option value=\"N\">No</md-option>\n</md-select></md-input-container><md-input-container flex id=\"date4\"><label>\nDate of Approval(Approval attained from IRAS)</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.DateofApprovalIRAS\"></md-datepicker></md-input-container><md-input-container flex><label>\nCessation Provisions</label><md-select ng-model=\"vm.CessationProvisions\"><md-option value=\"Y\">Yes</md-option><md-option\n value=\"N\">No</md-option></md-select></md-input-container><md-input-container flex><label>Form IR8S Indicator</label>\n<md-select ng-model=\"vm.FormIR8S\"><md-option value=\"Y\">Yes</md-option><md-option value=\"N\">No</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nRemission / Overseas Posting / Exempt Indicator</label><md-select ng-model=\"vm.Remission\"><md-option value=\"1\">\nTax Remission on Overseas Cost of Living Allowance (OCLA)</md-option><md-option value=\"3\">Seaman</md-option><md-option \nvalue=\"4\">Exemption</md-option><md-option value=\"5\">Overseas Pension Fund with Tax Concession</md-option><md-option \nvalue=\"6\">Income from Overseas Employement</md-option><md-option value=\"7\">\nIncome from Overseas Employement and Overseas Pension Fund with Tax Concession</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.GrossCommission\" \nplaceholder=\"Employee\'s income tax is borne by employer indicator\"></md-input-container><md-input-container flex \nid=\"date4\"><label>Gross Commission From Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.GrossCommissionFromDate\"></md-datepicker></md-input-container><md-input-container flex id=\"date4\"><label>\nGross Commission To Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.GrossCommissionToDate\">\n</md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nGross Commission Indicator</label><md-select ng-model=\"vm.GrossCommissionIndicator\"><md-option value=\"M\">Monthly\n</md-option><md-option value=\"O\">Other adhoc</md-option><md-option value=\"B\">Both</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Pension\" placeholder=\"Pension\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.TransportAllowance\" \nplaceholder=\"Transport Allowance\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.EntertainmentAllowance\" placeholder=\"Entertainment Allowance\"></md-input-container></div></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span ng-if=\"wizardStep2.$valid\">\n</span> <span class=\"ms-form-wizard-step-text\">Optional Information 2</span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.OtherAllowance\" placeholder=\"Other allowance\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.GratuityAmount\" \nplaceholder=\"Gratuity/ Notice Pay/ Ex-gratia payment (Amount)\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.CompensationforlossofofficeAmount\" placeholder=\"Compensation for loss of office (Amount)\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Retirementbenefitsaccrued311292\" \nplaceholder=\"Retirement benefits accrued up to 31/12/92 \"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.Retirementbenefitsaccruedfrom1993\" \nplaceholder=\"Retirement benefits accrued from 1993 \"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Contributionmadebyemployertoanypension\" \nplaceholder=\"Contribution made by employer to any pension\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.Excessvoluntrycontribution\" placeholder=\"Excess / voluntry contribution to CPF by employer\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Gainsandprofits\" \nplaceholder=\"Gains and profits from share options for S10\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.Valueofbenefits\" \nplaceholder=\"Value of benefits in kinds\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.Employeesvoluntrycontribution\" \nplaceholder=\"Employees voluntry contribution to CPF obligatory by contract of employment\"></md-input-container>\n<md-input-container flex id=\"date4\"><label>Date of Commencement</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.DateofCommencement\"></md-datepicker></md-input-container><md-input-container flex id=\"date4\"><label>\nDate of Cessation</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.DateofCessation\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex id=\"date4\"><label>\nDate of Declaration of bonus</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.DateofBonus\"></md-datepicker>\n</md-input-container><md-input-container flex id=\"date4\"><label>Date of Directors fees approval</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.DateofDirectorsfeesapproval\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.NameoffundforRetirementbenefits\" \nplaceholder=\"Name of fund for Retirement benefits\"></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NameofDesignatedPension\" placeholder=\"Name of Designated Pension\"></md-input-container></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"end right\" \nstyle=\"margin-top:-60px\"><md-button class=\"md-raised\" ng-click=\"msWizard.previousStep()\">Previous</md-button><md-button\n class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"SubmitIndividual()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Submit</md-button><md-button class=\"md-raised md-raised\" \nng-click=\"Showgrid()\">Cancel</md-button></div></ms-form-wizard></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(39.5vw - 35px);\r\n        max-width: calc(45vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n\r\n    .RedColor {\r\n        color: red;\r\n    }\r\n\r\n    .GreenColor {\r\n        color: green;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(25vw - 2px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #date4 md-datepicker .md-datepicker-input {\r\n        width: calc(20vw - 23px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: -11px;\r\n    }\r\n\r\n    #seprate md-datepicker .md-datepicker-input {\r\n        width: calc(40vw - 54px);\r\n        max-width: calc(45vw - 64px);\r\n        margin-left: -11px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/midmonth/alertpopup.html","<md-dialog><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Are you sure want to confirm for selected employee(s) ?</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-actions><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"ConfirmPayroll()\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/human-resource/payroll/midmonth/bulkeditpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Mid Month Payroll</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:15px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.GPIncentives\" placeholder=\"GP Incentive\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.OTBSIncentives\" \nplaceholder=\"OTBS Incentive\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.WeekdayAllowance\" placeholder=\"Weekday Allowance\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.WeekendAllowance\" \nplaceholder=\"Weekend Allowance\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.SiteAllowance\" placeholder=\"Site Allowance\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.OT15\" placeholder=\"OT 1.5 (Hours)\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.OT20\" placeholder=\"OT 2.0 (Hours)\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"UpdateSelected()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/midmonth/editpopup.html","<md-dialog style=\"width:40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Mid Month Payroll</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:15px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.GPIncentives\" placeholder=\"GP Incentive\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.OTBSIncentives\" \nplaceholder=\"OTBS Incentive\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.WeekdayAllowance\" placeholder=\"Weekday Allowance\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.WeekendAllowance\" \nplaceholder=\"Weekend Allowance\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.SiteAllowance\" placeholder=\"Site Allowance\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.OT15\" placeholder=\"OT 1.5 (Hours)\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.OT20\" placeholder=\"OT 2.0 (Hours)\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"SubmitIndividual()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore),\r\n    md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/midmonth/midmonth.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Mid Month Payroll</span></div><div \nclass=\"product-count secondary-text\"><span>Total Records:</span> <span>{{EndMonthData.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><label style=\"color:white;font-size: 14px\">\nMid-Month Payroll For:</label><md-input-container flex=\"20\"><input \nstyle=\"color:white;font-size: 14px;padding-top:15px\" class=\"search-input\" moment-picker=\"dateFields.selectedDate\" \nformat=\"MMM-YYYY\" max-view=\"month\" ng-model=\"dateFields.selectedDate\" start-date=\"dateFields.selectedDate\" \nstartview=\"year\" min-date=\"\'\'\" max-date=\"\'\'\" ng-change=\"OnMonthChange()\"></md-input-container></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: -32px\" flex><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon><span>Download Payroll\n</span></md-button></div></div><div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><div \nstyle=\"padding:10px 0% 0 1%;float:right;width: 100%\" ng-show=\"TRCdiv\"><a \nstyle=\"cursor:pointer;color: rgb(6, 104, 97);font-size:13.5px;font-weight:bold;padding-right:2%\">\nTotal Employee(s) Selected: {{SelectedIds.length}}</a><md-button style=\"background-color:green\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ConfirmSelected($event)\"><span>\nConfirm Selected Employee(s)</span></md-button><md-button class=\"md-raised md-accent md-button md-ink-ripple\" \nng-click=\"EditSelected($event)\"><span>Edit Selected Employee(s)</span></md-button><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple\" ng-click=\"PrintReport()\"><span>Print Payslip</span></md-button>\n</div><md-progress-linear ng-hide=\"Employeedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\" \nnowrap=\"nowrap\"><div><md-checkbox ng-change=\"CheckAll(All)\" ng-model=\"All\" style=\"margin-bottom:0\" type=\"checkbox\">\n</md-checkbox></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nGP Incentives</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">OTBS Incentives</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Standby Duties<br>Allowance Weekday</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Standby Duties<br>Allowance Weekend</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Site Allowance</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">OT 1.5 Times<br>(Hours)</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">OT 2.0 Times<br>(Hours)</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Total Pay</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Remarks\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Bank Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Account Number</span></div></th></tr></thead><tbody><tr \nng-class=\"RecordStatus(row)\" ng-repeat=\"row in EndMonthData\"><td><md-checkbox style=\"margin: 0\" \nng-change=\"Check(All ,row._id)\" ng-checked=\"Selec.value\" ng-model=\"All\" type=\"checkbox\"></md-checkbox></td><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td nowrap=\"nowrap\"><a href=\"\" \nng-click=\"EditIndividual(row._id,$event)\" title=\"View/Edit\" style=\"border:none\">{{ row.EmployeeID }}</a></td><td>\n{{ row.EmployeeName}}</td><td>{{ row.GPIncentives || 0 |number:2 }}</td><td>{{row.OTBSIncentives || 0 |number:2 }}</td>\n<td>{{row.WeekdayAllowance || 0 |number:2}}</td><td>{{ row.WeekendAllowance || 0 |number:2 }}</td><td>\n{{ row.SiteAllowance || 0 |number:2}}</td><td>{{ row.OT15 || 0 |number:2}}</td><td>{{ row.OT20 || 0 |number:2}}</td>\n<td>{{ row.TotalPay || 0 |number:2}}</td><td>{{row.Remarks}}</td><td>{{ row.BankName }}</td><td>{{ row.Acc }}</td></tr>\n</tbody></table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(39.5vw - 35px);\r\n        max-width: calc(45vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n    \r\n    .RedColor {\r\n        color: red;\r\n    }\r\n    .GreenColor {\r\n        color: green;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/payrollsetting/Alert.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre You Sure Want to Delete?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll ng-show=\"AWCEmployeediv\"><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"AllowanceEmployeedelete(vm.AllowanceEmployeeId)\" \nclass=\"md-raised md-accent\" style=\"margin-top:0px\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No\n</md-button></div></md-dialog-content><md-dialog-content ms-scroll ng-show=\"IncrementE\"><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"DeleteIncrement(vm.AllowanceEmployeeId)\" \nclass=\"md-raised md-accent\" style=\"margin-top:0px\">Yes</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/payroll/payrollsetting/Allowancepop.html","<md-dialog style=\"width:50%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Add Employee Allowance</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:1% 1.5% 1% 1.5%\"><form name=\"eventForm\" class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" \nflex><md-input-container style=\"width: 25%\"><span style=\"color:#7f9593;font-size:16px\">Allowance Type :</span>\n</md-input-container><md-radio-container flex=\"15\" style=\"margin-top:-2px\"><md-radio-group ng-model=\"vm.AllowanceType\" \nlayout=\"row\"><md-radio-button value=\"Allowance\">Allowance</md-radio-button><md-radio-button value=\"Deduction\">Deduction\n</md-radio-button></md-radio-group></md-radio-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex style=\"margin-top: 18px\"><label class=\"md-inline-form\">Type Name</label><md-select \nng-model=\"vm.TypeName\" id=\"searchmodule\" required md-on-close=\"vm.searchTerm1 = \'\'\"><md-select-header><input \nng-model=\"searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Type Name\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.TypeName = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Allowancesdatas | filter:Type = vm.AllowanceType | filter:searchTerm1\" \nvalue=\"{{row.TypeName}}\">{{row.TypeName}}</md-option></md-select></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Amount\" ng-model=\"vm.ADAmount\" placeholder=\"Amount\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container id=\"date4\" flex style=\"margin-top: 18px\"><label \nstyle=\"margin-right: 10px\">Date</label><md-datepicker ng-model=\"vm.Date\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 0.5%;padding-left:1%\"><md-checkbox \nng-model=\"AD.value\" type=\"checkbox\">Monthly Recurring?</md-checkbox></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AllowanceSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></form></md-dialog-content></md-dialog><style>\n.md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    #date4 md-datepicker .md-datepicker-input {\r\n        width: calc(25.2vw - 23px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: -11px;\r\n    color:black !important;\r\n}\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n    #date4 .md-default-theme .md-datepicker-input-mask-opaque, .md-datepicker-input-mask-opaque {\r\n    left: 0px !important;\r\n}\r\n    .md-dialog {\r\n        max-width: 60%;\r\n    }\r\n\r\n    input[type=\"number\"]::-webkit-outer-spin-button,\r\n    input[type=\"number\"]::-webkit-inner-spin-button {\r\n        -webkit-appearance: none;\r\n        margin: 0;\r\n    }\r\n\r\n    input[type=\"number\"] {\r\n        -moz-appearance: textfield;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/payrollsetting/payrollsetting.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Pay Settings</span></div><div class=\"product-count secondary-text\" style=\"width:130%\"><span>Total Employees :\n</span> <span style=\"padding-right:8%\">{{Employeelength.length}}</span> <span>Filled :</span> <span \nstyle=\"padding-right:8%\">{{Filled.length}}</span> <span>Blank :</span> <span>{{Blank}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" style=\"margin-top: -32px\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button>\n<md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-if=\"Export  && AllowExport==\'true\'\" ng-click=\"Exportdata()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Payrollgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Paysettingsdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nBasic Pay</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Salary</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Pay Cycle</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">OT Eligibility</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Paysettingsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" \nng-click=\"Payrollinfo(row.id)\">{{ row.EmployeeID }}</a></td><td>{{ row.EmployeeName }}</td><td>{{ row.BasicPay}}</td>\n<td>{{row.Amount}}</td><td>{{ row.PayCycle}}</td><td>{{ row.OTEligible}}</td><td>{{row.EffectiveDate | date:\'dd/MM/y\'}}\n</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Payrollinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Payrollform\" \nflex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:80px\" ng-hide=\"Update\"><md-input-container flex><label>Employee</label><md-select ng-model=\"vm.Employee\" \nid=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" md-on-close=\"vm.searchPest = \'\'\" multiple=\"\" \nng-required=\"Update == false\"><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Search Employee..\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\">\n<label>Effective Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EffectiveDate\" \nng-required=\"Update == false\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-left: 35px;margin-top:4px\"><md-checkbox ng-model=\"OT.value\" type=\"checkbox\">OT Eligible?</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\" flex ng-show=\"Update\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.EmployeeName\" placeholder=\"Employee Name\" readonly=\"readonly\">\n</md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>Effective Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.EffectiveDate\"></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-left: 35px;margin-top:4px\"><md-checkbox ng-model=\"OT.value\" type=\"checkbox\">\nOT Eligible?</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 80px\"><span\n class=\"h4\" style=\"color:#7f9593;margin-top:26px\"><b>Basic Pay :</b></span><md-radio-container flex \nstyle=\"height:80px;flex: 0.83\"><md-radio-group ng-model=\"vm.BasicPay\" layout=\"row\" style=\"padding-left:20px\" required>\n<md-radio-button value=\"Daily\">Daily</md-radio-button><md-radio-button value=\"Monthly\">Monthly</md-radio-button>\n</md-radio-group></md-radio-container><md-input-container flex style=\"flex:0.8;margin-left:-30px\"><input type=\"number\" \nng-model=\"vm.Amount\" placeholder=\"Salary\" required></md-input-container><md-input-container flex></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height: 75px\"><span class=\"h4\" \nstyle=\"color:#7f9593;margin-top:26px\"><b>Pay Cycle :</b></span><md-radio-container flex style=\"flex:0.4\">\n<md-radio-group ng-model=\"vm.PayCycle\" ng-click=\"Calculate()\" layout=\"row\" style=\"padding-left:20px\" required>\n<md-radio-button value=\"1st to EOD\">1st to EOD</md-radio-button><md-radio-button value=\"Others\">Others\n</md-radio-button></md-radio-group></md-radio-container><div ng-show=\"vm.PayCycle == \'Others\'\" style=\"height:65px\" \nflex><md-input-container flex style=\"margin-top: 18px;margin-left: 10px\"><label>From</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.FromDate\"></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: 10px\"><label>To</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.ToDate\"></md-datepicker></md-input-container></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nstyle=\"height: 65px\"><md-input-container flex><label>Bank Name</label><md-select ng-model=\"vm.BankName\" \nng-change=\"getBIC(vm.BankName)\"><md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\">\nSearch Bank ..</span><md-button class=\"md-icon-button\" ng-click=\"vm.BankName = null\" aria-label=\"Close dialog\" \nstyle=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in HRMBankdatas | filter:vm.Bnkname\" ng-value=\"row.BankName\">{{row.BankName}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Acc\" placeholder=\"Account Number\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.payment\" placeholder=\"Payment Mode\">\n</md-input-container></div><br><br><span class=\"h4\" style=\"color:#7f9593\"><b>Agency Donation :</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>CPF Type</label><md-select \nng-model=\"vm.CPFType\" ng-change=\"CalculateAgency(vm.CPFType)\" required><md-select-header><span style=\"flex: auto\" \nng-keydown=\"$event.stopPropagation()\">CPF Type..</span><md-button class=\"md-icon-button\" ng-click=\"vm.CPFType = null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option value=\"ECF\">ECF</md-option><md-option value=\"SINDA\">SINDA</md-option><md-option \nvalue=\"CDAC\">CDAC</md-option><md-option value=\"MBMF\">MBMF</md-option></md-select></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.AgencyAmount\" placeholder=\"Amount\"></md-input-container>\n<md-input-container flex><input type=\"number\" ng-model=\"vm.SDF\" placeholder=\"SDF Amount\"></md-input-container></div>\n<br><span class=\"h4\" style=\"color:#7f9593\"><b>Increment :</b></span><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:65px\" flex><md-input-container flex><input type=\"number\" ng-model=\"vm.IncrementAmount\" \nplaceholder=\"Amount\"></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>\nEffective Date</label><md-datepicker ng-model=\"vm.IncrementEffectiveDate\"></md-datepicker></md-input-container>\n<md-button style=\"height:50%;margin-top:1.5%\" class=\"md-raised md-button md-ink-ripple\" ng-click=\"IncrementSubmit()\" \nng-disabled=\"!vm.IncrementAmount || !vm.Employee\"><span>Save Increment</span></md-button></div><div \nclass=\"white-bg md-whiteframe-1dp\" style=\"font-size:13.5px\"><table class=\"table dataTable row-border hover\" id=\"tb2\">\n<thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Effective Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Incrementdatadatas\"><td>&nbsp;\n</td><td>{{ row.IncrementAmount }}</td><td>{{ row.IncrementDate | date:\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Alertpopup($event, row.id, \'IncrementE\')\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td>\n</tr></tbody></table></div><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" \nclass=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26.3vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/human-resource/payroll/payslip/payslip.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<span>Payroll Summary Report</span></div><div class=\"product-count secondary-text\" style=\"width:130%\"><span>\nEmployees In Payroll :</span> <span style=\"padding-right:8%\">{{Filled.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker class=\"datefilter\" ng-model=\"uFrom\"></md-datepicker>\n</md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label style=\"color:white;font-size: 14px\">To\n</label><md-datepicker class=\"datefilter\" ng-model=\"uTo\"></md-datepicker></md-input-container></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"PreviousMonth()\"><md-icon md-font-icon=\"icon-calendar-select\"></md-icon>\n<span>Previous Month</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"CurrentMonth()\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><span>Current Month</span></md-button></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"PrintPaySlip()\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span>\nPrint Report</span></md-button></div></div><div class=\"content-card\" ng-show=\"Payrollgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Paysettingsdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nVisa Type</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Country</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Basic Pay</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Pay Cycle\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Effective Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Paysettingsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.EmployeeID }}</td><td>{{ row.EmployeeName }}</td><td>{{row.VisaType}}</td><td>{{row.Country}}</td><td>\n{{ row.BasicPay}}</td><td>{{row.Amount}}</td><td>{{ row.PayCycle}}</td><td>{{row.EffectiveDate | date:\'dd/MM/y\'}}</td>\n</tr></tbody></table></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(26.3vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\r\n\r\n    #tb2 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb2 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/timelog/attendance/Attendancepopup.html","<md-dialog style=\"width:100%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Attendance</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:5px 15px 5px 15px\"><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\" ng-hide=\"Update\"><md-input-container flex><label>Employee</label><md-select \nng-model=\"vm.uEmployee\" id=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" \nplaceholder=\"Search Employee..\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\" \nng-show=\"Update\"><md-input-container flex><input type=\"text\" ng-model=\"vm.EmpName\" placeholder=\"Employee\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nShift</label><md-select ng-model=\"vm.uShift\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchShift\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Shift..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.uShift=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Shiftdatas | filter:vm.searchShift\" value=\"{{row.id}}\">\n{{row.ShiftName}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"vm.uDate\" required md-max-date=\"vm.uStartDate\"></md-datepicker></md-input-container><md-input-container flex>\n<input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"time2\" placeholder=\"Time In\" min-date=\"minDate\" \nformat=\"HH:mm:A\" ng-model=\"vm.uTimeIn\" class=\"md-input\" readonly=\"readonly\"></md-input-container><md-input-container \nflex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Time Out\" \nmin-date=\"minDate\" format=\"hh:mm A\" ng-model=\"vm.uTimeOut\" class=\"md-input\" readonly=\"readonly\"></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    /*.md-datepicker-input-container {\r\n        width: 50%;\r\n    }*/\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/timelog/attendance/attendance.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Attendance</span></div><div \nclass=\"product-count secondary-text\"><span>Total Attendances:</span> <span>{{Attendancedatas.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" style=\"margin-top: -32px\" flex>\n<md-input-container flex=\"80\" id=\"Storefilter\" style=\"margin-top:18px\"><label style=\"color:white;font-size: 20px\">\nEmployee</label><md-select style=\"color:white\" class=\"Storefilter\" ng-model=\"EmployeeID\"><md-select-header \nstyle=\"color:white\"><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a employee..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"EmployeeID=undefined\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in EmployeeItems | filter:vm.searchTerm\" \nvalue=\"{{row.id}}\">{{row.EmployeeID}} - {{row.EmployeeName}}</md-option></md-select></md-input-container></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\">\n<label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container></div><div><md-button class=\"md-raised md-background\" \nng-show=\"Add\" ng-click=\"Datefilter()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>Search</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" \nng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"Export && AllowExport==\'true\'\" ng-click=\"ExportAdatas()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div layout=\"row\" \nstyle=\"height: 40px !important;max-height: 60px !important\" layout-align=\"center\" flex><md-button \nclass=\"md-raised md-background\" style=\"height: 40px !important\" ng-click=\"PreviousMonth()\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><span>Previous Month</span></md-button><md-button \nclass=\"md-raised md-background\" style=\"height: 40px !important\" ng-click=\"CurrentMonth()\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><span>Current Month</span></md-button><md-button \nclass=\"md-raised md-background\" style=\"height: 40px !important\" ng-click=\"PrintTimeSheet()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span>Print TimeSheet</span></md-button></div><div class=\"content-card\" \nng-show=\"Attendancegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Attendancedatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Employee ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Employee</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Shift\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Time In</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Time Out</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Entry Type\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Location</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attendancedatas |filter:{Employee:EmployeeID}\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td>\n<td>{{ row.Employeedetails.EmployeeID }}</td><td>{{ row.Employeedetails.EmployeeName }}</td><td>\n{{row.Shiftdetails[0].ShiftName}}</td><td>{{row.TimeIn | date:\'dd/MM/y\'}}</td><td>{{row.TimeIn | date: \"hh:mm a\"}}</td>\n<td>{{row.TimeOut | date: \"hh:mm a\"}}</td><td>{{row.EntryType}}</td><td><a href=\"\" \nng-click=\"Showlocation(row.Latitude, row.Longitude)\">Show Location</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Attendanceinfo($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Attendanceform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label>Employee</label><md-select ng-model=\"uEmployee\" \nid=\"searchmodule\" ng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\" \nrequired><md-select-header><input ng-model=\"vm.searchPest\" type=\"text\" placeholder=\"Search Employee..\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchPest\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>Start Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"uStartDate\" required></md-datepicker></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left: -10px\"><label>End Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"uEndDate\" required></md-datepicker></md-input-container><md-input-container flex><input \nmdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"time2\" placeholder=\"Time In\" min-date=\"minDate\" \nformat=\"HH:mm:A\" ng-model=\"uTimeIn\" class=\"md-input\" readonly=\"readonly\"></md-input-container><md-input-container flex>\n<input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"Time Out\" \nmin-date=\"minDate\" format=\"hh:mm A\" ng-model=\"uTimeOut\" class=\"md-input\" readonly=\"readonly\"></md-input-container>.\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div></form></div></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(19.5vw - 25px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #example tr td {\r\n        height: 30px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter>div>button>div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n    md-optgroup label {\r\n        display: block;\r\n        font-size: 14px;\r\n        text-transform: uppercase;\r\n        padding: 0;\r\n        font-weight: 500;\r\n    }\r\n\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    md-dialog md-dialog-actions .md-button {\r\n        margin: 0px 3px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/timelog/monthlyplan/calendarpopup.html","<md-dialog style=\"width:50%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Monthly Shift Plan</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"padding:15px 15px 5px 15px\"><div ng-show=\"vm.addform\" \nstyle=\"float:left\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\"><md-input-container \nstyle=\"width: 95%;margin:10px 0 5px 0\"><label>Team Name</label><md-select ng-model=\"vm.Team_id\" id=\"searchmodule\" \nrequired><md-select-header><input ng-model=\"vm.searchAssigned\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Team_id = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Teamdatas | filter:vm.searchAssigned\" \nvalue=\"{{row.id}}\">{{row.TeamName}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"width: 95%;margin:10px 0 5px 0\"><label>Shift Name</label><md-select ng-model=\"vm.Shift_id\" id=\"searchmodule\" \nrequired><md-select-header><input ng-model=\"vm.searchAssigned1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Shift..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Shift_id = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Shiftdatas | filter:vm.searchAssigned1\" \nvalue=\"{{row.id}}\">{{row.ShiftName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>Start Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.StartDate\" required></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EndDate\" required></md-datepicker></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">\nCancel</md-button></div></div><div ng-show=\"vm.deleteform\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:80px\">\n<md-input-container style=\"width: 95%;margin:10px 0 5px 0\"><label>Team Name</label><md-select ng-model=\"vm.Team_id\" \nid=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchAssigned\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Team..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Team_id = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Teamdatas | filter:vm.searchAssigned\" \nvalue=\"{{row.id}}\">{{row.TeamName}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"width: 95%;margin:10px 0 5px 0\"><label>Shift Name</label><md-select ng-model=\"vm.Shift_id\" id=\"searchmodule\" \nrequired><md-select-header><input ng-model=\"vm.searchAssigned1\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Shift..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.Shift_id = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in Shiftdatas | filter:vm.searchAssigned1\" \nvalue=\"{{row.id}}\">{{row.ShiftName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>Start Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.StartDate\" required></md-datepicker></md-input-container>\n<md-input-container flex style=\"margin-top: 18px;margin-left: -10px\"><label>End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.EndDate\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-button class=\"md-icon-button\" ng-click=\"deleteplan(MonthlyplanID)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></md-dialog-content></form></md-dialog><style>\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74px;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\n        width: calc(24.3vw - 23px);\r\n    max-width: calc(35vw - 54px);\r\n    margin-left: 0px;\r\n  \r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/timelog/monthlyplan/monthlyplan.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-timetable\"></md-icon><span>Monthly Plan</span></div><div \nclass=\"product-count secondary-text\"><span>Total Plans:</span> <span>{{Attendancedatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" style=\"margin-top: -32px\" flex><input \nid=\"employee-search\" class=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" \nlayout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-click=\"sAdd($event)\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span>Add</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" \nng-click=\"mpExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div \nclass=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><h2 style=\"text-align:center;font-weight:800\">\n{{ vm.calendarTitle }}</h2><div class=\"col-md-6 text-center\"><div class=\"btn-group\"><button class=\"btn btn-primary\" \nmwl-date-modifier date=\"vm.viewDate\" decrement=\"vm.calendarView\" ng-click=\"vm.cellIsOpen = false\">Previous</button> \n<button class=\"btn btn-default\" mwl-date-modifier date=\"vm.viewDate\" set-to-today ng-click=\"vm.cellIsOpen = false\">\nToday</button> <button class=\"btn btn-primary\" mwl-date-modifier date=\"vm.viewDate\" increment=\"vm.calendarView\" \nng-click=\"vm.cellIsOpen = false\">Next</button></div></div><div class=\"col-md-6 text-right\"><div class=\"btn-group\">\n<label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'year\'\" ng-click=\"vm.cellIsOpen = false\">Year\n</label><label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'month\'\" \nng-click=\"vm.cellIsOpen = false\">Month</label><label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" \nuib-btn-radio=\"\'week\'\" ng-click=\"vm.cellIsOpen = false\">Week</label><label class=\"btn btn-primary\" \nng-model=\"vm.calendarView\" uib-btn-radio=\"\'day\'\" ng-click=\"vm.cellIsOpen = false\">Day</label></div></div><br><br><br \nclass=\"visible-xs visible-sm\"><mwl-calendar events=\"calendereventdata\" view=\"vm.calendarView\" \nview-title=\"vm.calendarTitle\" view-date=\"vm.viewDate\" on-event-click=\"EventList(calendarEvent, calendarEvent.id)\" \non-event-times-changed=\"vm.eventTimesChanged(calendarEvent); calendarEvent = calendarEvent.id;  calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd\" \ncell-is-open=\"vm.cellIsOpen\" day-view-start=\"00:00\" day-view-end=\"23:59\" day-view-split=\"30\" \ncell-modifier=\"vm.modifyCell(calendarCell)\" cell-auto-open-disabled=\"true\" \non-timespan-click=\"vm.timespanClicked(calendarDate, calendarCell)\"></mwl-calendar></div></div></div></div><style>\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(19.5vw - 25px);\r\nmax-width: calc(35vw - 54px);\r\n}\r\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 74px;\r\n}\r\n#example tr td {\r\nheight: 30px;\r\n}\r\n#viewedit.md-button {\r\nmargin: -16px 8px;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\nmd-optgroup label {\r\n    display: block;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    padding: 0; \r\n    font-weight: 500;\r\n}\r\nmd-dialog md-dialog-content {\r\n   padding: 0;\r\n}\r\nmd-dialog md-dialog-actions .md-button {\r\n    margin: 0px 3px;\r\n}\r\n    .cal-day-tick{\r\n        display:none!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/report/report.html","");
$templateCache.put("app/main/apps/human-resource/training/calender/calender.html","<div id=\"Course\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"CALENDAR1.HEADER\">Course Administration</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"search\" \nplaceholder=\"{{ \'CALENDAR1.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"AllowExport==\'true\'\" ng-click=\"lExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"CALENDAR1.EXPORT\">Export</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span translate=\"CALENDAR1.COURSE_MASTER\">Course Master</span>\n</md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"coursemaster\" novalidate><div layout-gt-xs=\"row\" layout=\"column\" layout-align=\"start center\"><md-input-container \nflex><input type=\"text\" name=\"CourseName\" ng-model=\"CourseName\" \nplaceholder=\"{{ \'CALENDAR1.COURSE_NAME\' | translate }}\" required><div ng-messages=\"coursemaster.CourseName.$error\" \nng-show=\"coursemaster.CourseName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR1.COURSE_NAME_IS_REQUIRED\">Course Name is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"CourseProvider\" ng-model=\"CourseProvider\" \nplaceholder=\"{{ \'CALENDAR1.COURSE_PROVIDER\' | translate }}\" required><div \nng-messages=\"coursemaster.CourseProvider.$error\" ng-show=\"coursemaster.CourseProvider.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR1.COURSE_PROVIDER_IS_REQUIRED\">Course Provider is required.</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" ng-model=\"Description\" \nplaceholder=\"{{ \'CALENDAR1.REMARKS\' | translate }}\"></md-input-container><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" id=\"addbutton\" ng-click=\"CourseMasterSubmit()\" \nng-disabled=\"coursemaster.$invalid\"><span translate=\"CALENDAR1.SAVE\">Save</span></md-button></div></form><div \nclass=\"content-card\"><div class=\"content fullpage-datatable\" style=\"margin-left: -24px; margin-right: -24px\" \nlayout=\"column\" flex><md-progress-linear ng-hide=\"Coursemasterdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" \naria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div \nclass=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CALENDAR1.COURSE_NAME\">Course Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CALENDAR1.COURSE_PROVIDER\">\nCourse Provider</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CALENDAR1.REMARKS\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CALENDAR1.ACTION\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Coursemasterdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CourseName }}</td><td>{{ row.CourseProvider}}</td><td>\n{{ row.Description}}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"CourseMasterinfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"CALENDAR1.COURSE_SCHEDULING\">Course Scheduling</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"Schedulingform\" novalidate \nng-show=\"CourseSchedulingform\"><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container flex><label \ntranslate=\"CALENDAR1.COURSE_NAME\">Course Name</label><md-select ng-model=\"vm.CourseName\" name=\"CourseName\" \nid=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'CALENDAR1.COURSE_NAME\' | translate }}\" ng-keydown=\"$event.stopPropagation()\"></md-select-header>\n<md-option ng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">{{row.CourseName}}\n</md-option></md-select><div ng-messages=\"Schedulingform.CourseName.$error\" \nng-show=\"Schedulingform.CourseName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR1.COURSE_NAME_IS_REQUIRED\">Course Name is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"BatchName\" ng-model=\"vm.BatchName\" \nplaceholder=\"{{ \'CALENDAR1.BATCH_NAME\' | translate }}\" required><div ng-messages=\"Schedulingform.BatchName.$error\" \nng-show=\"Schedulingform.BatchName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR1.BATCH_NAME_IS_REQUIRED\">Batch Name is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"CALENDAR1.TRAINER_NAME\">Trainer Name</label><md-select \nng-model=\"vm.TrainerName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.EmployeeName}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label translate=\"CALENDAR1.START_DATE\">Start Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex style=\"margin-top: 18px\"><label translate=\"CALENDAR1.END_DATE\">End Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.EndDate\" ng-change=\"DaysCalc(this)\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex><input type=\"text\" \nng-model=\"vm.NoofDays \" placeholder=\"{{ \'CALENDAR1.NO_OF_DAYS\' | translate }}\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.SubsidiaryProvider \" \nplaceholder=\"{{ \'CALENDAR1.SUBSIDIARY_PROVIDER\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.SDFReferenceNumber \" placeholder=\"{{ \'CALENDAR1.SDF_REFERENCE_NO\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.TotalHours \" \nplaceholder=\"{{ \'CALENDAR1.TOTAL_HOURS\' | translate }}\"></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.VenueDetails \" \nplaceholder=\"{{ \'CALENDAR1.VENUE_DETAILS\' | translate }}\"></md-input-container><md-input-container flex><input \ntype=\"number\" ng-model=\"vm.TotalSeatings \" placeholder=\"{{ \'CALENDAR1.TOTAL_SEATINGS\' | translate }}\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.Remarks \" \nplaceholder=\"{{ \'CALENDAR1.REMARKS\' | translate }}\"></md-input-container></div><md-input-container flex \nstyle=\"height: 50px;margin:0 10px 0 0px;padding-left: 6px;padding-bottom: 10px\"><md-checkbox ng-model=\"Inhouse.value\" \ntype=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">{{\'CALENDAR1.INHOUSE_TRAINING\'|translate}}?</md-checkbox>\n</md-input-container><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"height: 60px\">\n<md-button ng-click=\"CourseSchedulingSubmit()\" ng-disabled=\"Schedulingform.$invalid\" class=\"md-raised md-accent\" \ntranslate=\"CALENDAR1.SUBMIT\">Submit</md-button><md-button class=\"md-raised\" ng-click=\"Showgrid()\" \ntranslate=\"CALENDAR1.CANCEL\">Cancel</md-button></div></form><div class=\"content-card\" ng-show=\"CourseSchedulinggrid\">\n<div class=\"search\" layout=\"row\" layout-align=\"end left\" flex><md-button class=\"md-raised md-accent md-default-theme\" \nng-click=\"sAdd()\"><span translate=\"CALENDAR1.ADD\">ADD</span></md-button></div><div class=\"content fullpage-datatable\" \nstyle=\"margin-left: -24px; margin-right: -24px\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Courseschedulingdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CALENDAR1.BATCH_ID\">Batch ID</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"CALENDAR1.COURSE_NAME\">Course Name</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CALENDAR1.BATCH_NAME\">Batch Name</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CALENDAR1.TRAINER_NAME\">Trainer Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.START_DATE\">Start Date</span></div></th><th\n class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.END_DATE\">End Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.NO_OF_DAYS\">No of Days</span></div></th><th\n class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.INHOUSE_TRAINING\">Inhouse Training?</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.VENUE_DETAILS\">Venue Details\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.ACTION\">Action</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Courseschedulingdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a ng-click=\"CourseSchedulinginfo(row.id)\" style=\"cursor:pointer\">\n{{ row.BatchID }}</a></td><td>{{ row.CourseName }}</td><td>{{ row.BatchName }}</td><td>{{ row.TrainerName }}</td><td>\n{{ row.StartDate | date:\'dd/MM/y\' }}</td><td>{{ row.EndDate | date:\'dd/MM/y\' }}</td><td>{{ row.NoofDays }}</td><td>\n{{ row.InhouseTraining }}</td><td>{{ row.VenueDetails }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"CourseSchedulinginfo(row.id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Enrollments</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"EnrollmentsForm\" novalidate ng-show=\"EnrollmentForm\"><div layout=\"column\" layout-gt-xs=\"row\" \nng-hide=\"EnrollmentUpdate\"><md-input-container flex><label translate=\"CALENDAR1.COURSE_NAME\">Course Name</label>\n<md-select ng-model=\"vm.ECourseName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" \ntype=\"text\" placeholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_COURSE..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">\n{{row.CourseName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"CALENDAR1.BATCH_NAME\">Batch Name</label><md-select ng-model=\"vm.EBatchName\" id=\"searchmodule\" required>\n<md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_BATCH..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nng-if=\"row.CourseName == vm.ECourseName\" value=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"CALENDAR1.EMPLOYEE_NAME\">Employee Name</label>\n<md-select ng-model=\"vm.EEmployeeName\" id=\"searchmodule\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_EMPLOYEE\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"EnrollmentUpdate\">\n<md-input-container flex><label translate=\"CALENDAR1.COURSE_NAME\">Course Name</label><md-select \nng-model=\"vm.ECourseName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_COURSE..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">\n{{row.CourseName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"CALENDAR1.BATCH_NAME\">Batch Name</label><md-select ng-model=\"vm.EBatchName\" id=\"searchmodule\" required>\n<md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'CALENDAR1.SEARCH_FOR_A_BATCH..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nng-if=\"row.CourseName == vm.ECourseName\" value=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"vm.EmpName\" \nplaceholder=\"{{ \'CALENDAR1.EMPLOYEE_NAME\' | translate }}\" readonly=\"readonly\"></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" ng-model=\"vm.EFees \" \nplaceholder=\"{{ \'CALENDAR1.FEES\' | translate }}\"></md-input-container><md-input-container flex><input type=\"number\" \nng-model=\"vm.GST \" placeholder=\"GST\"></md-input-container><md-input-container flex><label \ntranslate=\"CALENDAR1.PAYMENT_RECEIVED\">Payment Received</label><md-select ng-model=\"vm.PaymentReceived\" \nid=\"searchmodule\"><md-select-header><span style=\"flex: auto\" ng-keydown=\"$event.stopPropagation()\" \ntranslate=\"CALENDAR1.PAYMENT_RECEIVED..\">Payment Received..</span><md-button class=\"md-icon-button\" \nng-click=\"PaymentReceived = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option value=\"Yes\" translate=\"CALENDAR1.YES\">Yes</md-option><md-option \nvalue=\"No\" translate=\"CALENDAR1.NO\">No</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.ERemarks \" \nplaceholder=\"{{ \'CALENDAR1.REMARKS\' | translate }}\"></md-input-container><md-input-container flex \nstyle=\"padding-left:5px\"><md-checkbox ng-model=\"Company.value\" type=\"checkbox\" style=\"padding-left:5px;margin-top:0px\">\n{{\'CALENDAR1.COMPANY_SPONSORED?\'|translate}}</md-checkbox></md-input-container></div><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" style=\"height: 60px\"><md-button ng-click=\"EnrollmentSubmit()\" \nclass=\"md-raised md-accent\" translate=\"CALENDAR1.SUBMIT\">Submit</md-button><md-button class=\"md-raised\" \nng-click=\"Showgrid()\" translate=\"CALENDAR1.CANCEL\">Cancel</md-button></div></form><div class=\"content-card\" \nng-show=\"Enrollmentgrid\"><div class=\"search\" layout=\"row\" layout-align=\"end left\" flex><md-button \nclass=\"md-raised md-accent md-default-theme\" ng-click=\"EAdd()\"><span translate=\"CALENDAR1.ADD\">ADD</span></md-button>\n</div><div class=\"content fullpage-datatable\" style=\"margin-left: -24px; margin-right: -24px\" layout=\"column\" flex>\n<md-progress-linear ng-hide=\"Enrollmentsdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CALENDAR1.ENROLMENT_ID\">Enrolment ID</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"CALENDAR1.COURSE_NAME\">Course Name</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\" translate=\"CALENDAR1.BATCH_NAME\">Batch Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.EMPLOYEE_NAME\">Employee Name</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CALENDAR1.COMPANY_SPONSORED?\">\nCompany Sponsored?</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CALENDAR1.FEES\">Fees</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CALENDAR1.REMARKS\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CALENDAR1.ACTION\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Enrollmentsdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a ng-click=\"Enrolmentinfo(row.id)\" style=\"cursor:pointer\">\n{{ row.EnrolmentID }}</a></td><td>{{ row.CourseName }}</td><td>{{ row.BatchName }}</td><td>{{ row.EmployeeName }}</td>\n<td>{{ row.CompanySponsored }}</td><td>{{ row.Fees }}</td><td>{{ row.Remarks }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Enrolmentinfo(row.id)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div></div></md-tab-body>\n</md-tab><md-tab ng-click=\"tabclick()\"><md-tab-label><span translate=\"CALENDAR1.TRAINING_CALENDAR\">Training CALENDAR\n</span></md-tab-label><md-tab-body><div style=\"background:#fff!important\"><h2 \nstyle=\"text-align:center;font-weight:800\">{{ vm.calendarTitle }}</h2><div class=\"col-md-6 text-center\"><div \nclass=\"btn-group\"><button class=\"btn btn-primary\" mwl-date-modifier date=\"vm.viewDate\" decrement=\"vm.calendarView\" \nng-click=\"vm.cellIsOpen = false\">{{\'CALENDAR1.PREVIOUS\'|translate}}</button> <button class=\"btn btn-default\" \nmwl-date-modifier date=\"vm.viewDate\" set-to-today ng-click=\"vm.cellIsOpen = false\">{{\'CALENDAR1.TODAY\'|translate}}\n</button> <button class=\"btn btn-primary\" mwl-date-modifier date=\"vm.viewDate\" increment=\"vm.calendarView\" \nng-click=\"vm.cellIsOpen = false\">{{\'CALENDAR1.NEXT\'|translate}}</button></div></div><div class=\"col-md-6 text-right\">\n<div class=\"btn-group\"><label translate=\"CALENDAR1.YEAR\" class=\"btn btn-primary\" ng-model=\"vm.calendarView\" \nuib-btn-radio=\"\'year\'\" ng-click=\"vm.cellIsOpen = false\">Year</label><label translate=\"CALENDAR1.MONTH\" \nclass=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'month\'\" ng-click=\"vm.cellIsOpen = false\">Month\n</label><label translate=\"CALENDAR1.WEEK\" class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'week\'\" \nng-click=\"vm.cellIsOpen = false\">Week</label><label translate=\"CALENDAR1.DAY\" class=\"btn btn-primary\" \nng-model=\"vm.calendarView\" uib-btn-radio=\"\'day\'\" ng-click=\"vm.cellIsOpen = false\">Day</label></div></div><br><br><br \nclass=\"visible-xs visible-sm\"><mwl-calendar events=\"calendereventdata\" view=\"vm.calendarView\" \nview-title=\"vm.calendarTitle\" view-date=\"vm.viewDate\" on-event-click=\"EventList(calendarEvent)\" \non-event-times-changed=\"vm.eventTimesChanged(calendarEvent); calendarEvent = calendarEvent.id;  calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd\" \ncell-is-open=\"vm.cellIsOpen\" day-view-start=\"00:00\" day-view-end=\"23:59\" day-view-split=\"30\" \ncell-modifier=\"vm.modifyCell(calendarCell)\" cell-auto-open-disabled=\"true\" \non-timespan-click=\"vm.timespanClicked(calendarDate, calendarCell)\"></mwl-calendar></div></md-tab-body></md-tab>\n</md-tabs></div></div><style>\n#datelarge md-datepicker .md-datepicker-input {\r\n        width: calc(40vw - 54px);\r\n        max-width: calc(50vw - 64px);\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(28.5vw - 54px);\r\n        max-width: calc(50vw - 64px);\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 84px;\r\n    }\r\n\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #addbutton.md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input, .md-hue-2 .md-datepicker-input {\r\n        margin-left: -10px;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .md-datepicker-input {\r\n        min-width: 240px !important;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n    #Course .header {\r\n        height: 70px;\r\n    }\r\n\r\n    #calendar .header:before {\r\n        background: none;\r\n    }\r\n\r\n    #calendar .header .header-content .header-bottom {\r\n        margin-top: -40px;\r\n    }\r\n\r\n    #CAmodule md-datepicker .md-datepicker-input {\r\n        width: calc(27vw - 54px);\r\n        max-width: calc(50vw - 64px);\r\n    }\r\n\r\n    .cal-day-tick {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/administration.html","<div id=\"Course\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span translate=\"ADMINISTRATION.HEADER\">Course Progress</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"forms-search\" class=\"search-input\" type=\"search\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH\' | translate }}\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"AllowExport==\'true\'\" ng-click=\"lExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span \ntranslate=\"ADMINISTRATION.EXPORT\">Export</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span translate=\"ADMINISTRATION.COURSE_ATTENDANCE\">Course Attendance\n</span></md-tab-label><md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nclass=\"content-card\" ng-show=\"CourseAGrid\"><div layout=\"column\" layout-gt-xs=\"row\" style=\"height:50px\">\n<md-input-container flex style=\"margin-top: 5px\"><label translate=\"ADMINISTRATION.COURSE_NAME\">Course Name</label>\n<md-select ng-model=\"CourseNameFilter[queryBy]\" id=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" \ntype=\"text\" placeholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_COURSE..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">{{row.CourseName}}</md-option>\n</md-select></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-button class=\"md-raised md-accent md-default-theme\" ng-click=\"sAdd($event)\"><span \ntranslate=\"ADMINISTRATION.ADD\">ADD</span></md-button></div><div class=\"content fullpage-datatable\" \nstyle=\"margin-left: -24px; margin-right: -24px\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Courseattendancedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"ADMINISTRATION.COURSE_NAME\">Course Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\" translate=\"ADMINISTRATION.EMPLOYEE_NAME\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.ATTENDANCE_DATE\">Attendance Date\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.TIME_IN\">Time In\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.TIME_OUT\">\nTime Out</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.ACTION\">\nAction</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Courseattendancedatas | filter:CourseNameFilter | filter:AttendanceFilter\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.CourseName }}</td><td>{{ row.BatchName }}</td><td>\n{{ row.employeedetails[0].EmployeeName }}</td><td>{{ row.AttendanceDate | date:\'dd/MM/yy\' }}</td><td>\n{{ row.StartTime | date:\'hh:mm:a\'}}</td><td>{{ row.EndTime | date:\'hh:mm:a\'}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"CourseAInfo($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><form name=\"CourseAttendanceForm\" novalidate ng-show=\"CourseAForm\"><div layout-gt-xs=\"row\" \nlayout=\"column\"><md-input-container flex><label translate=\"ADMINISTRATION.COURSE_NAME\">Course Name</label><md-select \nng-model=\"vm.CourseName\" name=\"CourseName\" id=\"searchmodule\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">{{row.CourseName}}</md-option>\n</md-select><div ng-messages=\"CourseAttendanceForm.CourseName.$error\" \nng-show=\"CourseAttendanceForm.CourseName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ADMINISTRATION.COURSE_NAME_IS_REQUIRED\">Course Name is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</label><md-select \nng-model=\"vm.BatchName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nvalue=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select></md-input-container><md-input-container flex><label\n translate=\"ADMINISTRATION.EMPLOYEE_NAME\">Employee Name</label><md-select ng-model=\"vm.EmployeeName\" id=\"searchmodule\" \nmultiple=\"\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" ng-value=\"row\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex style=\"margin-top: 18px\"><label translate=\"ADMINISTRATION.ATTENDANCE_DATE\">\nAttendance Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.AttendanceDate\" required \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" \ndate=\"false\" time=\"true\" type=\"text\" id=\"datetime\" placeholder=\"{{ \'ADMINISTRATION.START_TIME\' | translate }}\" \nshow-todays-date=\"\" min-date=\"date\" ng-model=\"vm.StartTime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" \nrequired></md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" \ntype=\"text\" id=\"datetime\" placeholder=\"{{ \'ADMINISTRATION.END_TIME\' | translate }}\" show-todays-date=\"\" \nmin-date=\"date\" ng-model=\"vm.EndTime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\"></md-input-container></div>\n<div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" style=\"height: 60px\"><md-button \nng-click=\"CourseASubmit()\" ng-disabled=\"Schedulingform.$invalid\" class=\"md-raised md-accent\" \ntranslate=\"ADMINISTRATION.SUBMIT\">Submit</md-button><md-button class=\"md-raised\" ng-click=\"Showgrid()\" \ntranslate=\"ADMINISTRATION.CANCEL\">Cancel</md-button></div></form></div></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"ADMINISTRATION.PROGRESS\">Progress</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"content-card\"><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"height:50px\"><md-input-container flex><label \ntranslate=\"ADMINISTRATION.COURSE_NAME\">Course Name</label><md-select ng-model=\"CourseNameFilter[queryBy]\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">\n{{row.CourseName}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</label><md-select ng-model=\"BatchNameFilter[queryBy]\" \nid=\"searchmodule\"><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nvalue=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container></div><br><div class=\"content fullpage-datatable\" \nstyle=\"margin-left: -24px; margin-right: -24px\" layout=\"column\" flex><md-progress-linear ng-hide=\"Enrollmentsdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.ENROLMENT_ID\">Enrolment ID</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.COURSE_NAME\">\nCourse Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\" translate=\"ADMINISTRATION.EMPLOYEE_NAME\">Employee Name</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.START_DATE\">Start Date</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.END_DATE\">End Date</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.FEES\">Fees</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.EVALUATION\">Evaluation</span>\n</div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"ADMINISTRATION.EVALUATION_STATUS\">\nEvaluation Staus</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"ADMINISTRATION.CERTIFICATE\">Certificate</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Enrollmentsdatas | filter:CourseNameFilter | filter:BatchNameFilter\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a ng-click=\"Enrolmentinfo(row.id)\" style=\"cursor:pointer\">\n{{ row.EnrolmentID }}</a></td><td>{{ row.CourseName }}</td><td>{{ row.BatchName }}</td><td>{{ row.EmployeeName }}</td>\n<td>{{ row.CompanySponsored | date:\'dd/MM/y\' }}</td><td>{{ row.Remarks | date:\'dd/MM/y\' }}</td><td>{{ row.Fees }}</td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Evaluation(row.id)\"><md-icon md-font-icon=\"icon-file-document\"></md-icon></md-button></td><td \nng-class=\"{ \'color-blue\': row.Status == \'Not Done\',\'color-green\':  row.Status == \'Completed\'}\">{{ row.Status }}</td>\n<td><md-button id=\"viewedit\" ng-disabled=\"row.Status == \'Not Done\'\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Certificate(row.id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></md-tab-body></md-tab></md-tabs></div></div><style>\nmd-dialog md-dialog-content {\r\n    padding: 0;\r\n}\r\n#datelarge md-datepicker .md-datepicker-input {\r\n \r\nmax-width: calc(19vw - 64px);\r\n}\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(28.5vw - 54px);\r\n        max-width: calc(50vw - 64px);\r\n    }\r\n                .md-datepicker-button {\r\n    display: none;\r\n    }\r\n                    .md-default-theme.md-hue-2 .md-datepicker-input, .md-hue-2 .md-datepicker-input {\r\n            margin-left: -10px;\r\n        }\r\n                ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n    right: 84px;\r\n    }\r\n    #viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    #addbutton.md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    .md-datepicker-input {\r\n        min-width: 240px !important;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid, .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused, .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    /*table.dataTable tbody tr.odd {\r\n        display: none;\r\n    }*/\r\n        #Course .header {\r\n        height: 70px;\r\n    }\r\n        #calendar .header:before {\r\n    background: none;\r\n    }\r\n    #calendar .header .header-content .header-bottom {\r\n        margin-top: -40px;\r\n    }\r\n        #CAmodule md-datepicker .md-datepicker-input {\r\n        width: calc(27vw - 54px);\r\n        max-width: calc(50vw - 64px);\r\n    }\r\n        .color-green {\r\n  color: green;\r\n}\r\n\r\n.color-blue {\r\n  color: orange;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/administrationpopup.html","<md-dialog style=\"width:100%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"ADMINISTRATION.COURSE_ATTENDANCE\">Course Attendance</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding:5px 15px 5px 15px\"><div layout-gt-xs=\"row\" layout=\"column\" ng-hide=\"CourseAUpdate\"><md-input-container \nflex><label translate=\"ADMINISTRATION.COURSE_NAME\">Course Name</label><md-select ng-model=\"vm.CourseName\" \nname=\"CourseName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">\n{{row.CourseName}}</md-option></md-select><div ng-messages=\"CourseAttendanceForm.CourseName.$error\" \nng-show=\"CourseAttendanceForm.CourseName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ADMINISTRATION.COURSE_NAME_IS_REQUIRED\">Course Name is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</label><md-select \nng-model=\"vm.BatchName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nng-if=\"row.CourseName == vm.CourseName\" value=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select>\n</md-input-container><md-input-container flex><label translate=\"ADMINISTRATION.EMPLOYEE_NAME\">Employee Name</label>\n<md-select ng-model=\"vm.EmployeeName\" id=\"searchmodule\" multiple=\"\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout-gt-xs=\"row\" layout=\"column\" ng-show=\"CourseAUpdate\">\n<md-input-container flex><label translate=\"ADMINISTRATION.COURSE_NAME\">Course Name</label><md-select \nng-model=\"vm.CourseName\" name=\"CourseName\" id=\"searchmodule\" required><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Coursemasterdatas | filter:vm.searchTerm\" value=\"{{row.CourseName}}\">{{row.CourseName}}</md-option>\n</md-select><div ng-messages=\"CourseAttendanceForm.CourseName.$error\" \nng-show=\"CourseAttendanceForm.CourseName.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ADMINISTRATION.COURSE_NAME_IS_REQUIRED\">Course Name is required.</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"ADMINISTRATION.BATCH_NAME\">Batch Name</label><md-select \nng-model=\"vm.BatchName\" id=\"searchmodule\" required><md-select-header><input ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"{{ \'ADMINISTRATION.SEARCH_FOR_A_TRAINER..\' | translate }}\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"row in Courseschedulingdatas | filter:vm.searchTerm\" \nvalue=\"{{row.BatchName}}\">{{row.BatchName}}</md-option></md-select></md-input-container><md-input-container flex><input\n type=\"text\" ng-model=\"vm.EmployeeName\" placeholder=\"{{ \'ADMINISTRATION.EMPLOYEE_NAME\' | translate }}\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nstyle=\"margin-top: 18px\"><label translate=\"ADMINISTRATION.ATTENDANCE_DATE\">Attendance Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.AttendanceDate\" required md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" \nid=\"datetime\" placeholder=\"{{ \'ADMINISTRATION.START_TIME\' | translate }}\" show-todays-date=\"\" min-date=\"date\" \nng-model=\"vm.StartTime\" format=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\" required></md-input-container>\n<md-input-container flex><input mdc-datetime-picker=\"\" date=\"false\" time=\"true\" type=\"text\" id=\"datetime\" \nplaceholder=\"{{ \'ADMINISTRATION.END_TIME\' | translate }}\" show-todays-date=\"\" min-date=\"date\" ng-model=\"vm.EndTime\" \nformat=\"hh:mm A\" class=\"md-input\" readonly=\"readonly\"></md-input-container></div><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\" style=\"height: 60px\"><md-button ng-click=\"CourseASubmit()\" \nng-disabled=\"Schedulingform.$invalid\" class=\"md-raised md-accent\" translate=\"ADMINISTRATION.SUBMIT\">Submit</md-button>\n<md-button class=\"md-raised\" ng-click=\"cancel()\" translate=\"ADMINISTRATION.CANCEL\">Cancel</md-button></div>\n</md-dialog-content></form></md-dialog><style>\nmd-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .md-datepicker-input-container {\r\n        width: 90%;\r\n    }\r\n\r\n    md-input-container label:not(.md-no-float):not(.md-container-ignore), md-input-container .md-placeholder {\r\n        margin-right: 0 !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        width: calc(100% - 45px);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 45px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/training/training.html","<div id=\"incidentform\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span>Personnel Training</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"iSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"iAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"iView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"iExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Incidentgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Trainingdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description Of Training</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Duration</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">End Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Trainer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Trainee Signature</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Trainingdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewTraining(row)\" title=\"Detail Grid\" \nstyle=\"border:none\">{{ row.TrainingName }}</a></td><td>{{ row.Duration }}</td><td>{{ row.StartDate | date : \'dd/MM/y\'}}\n</td><td>{{ row.EndDate | date : \'dd/MM/y\'}}</td><td>{{ row.TrainerNamedata[0].EmployeeName }}</td><td>\n{{ row.TraineeSigndata[0].EmployeeName }}</td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\">\n<div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Incidentform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"TrainingName\" \nng-model=\"TrainingName\" placeholder=\"Description of Training\"><div ng-messages=\"basicForm.TrainingName.$error\" \nng-show=\"basicForm.TrainingName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription of Training is Required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Duration\" ng-model=\"Duration\" placeholder=\"Duration\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex><label>Trainer</label><md-select \nng-model=\"TrainerName\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Reported By..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"ReportedBy=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Signaturedatas | filter:vm.searchTerm2\" value=\"{{row._id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>\nTrainee Sign</label><md-select data-ng-model=\"TraineeSign\"><md-select-label></md-select-label><md-option \ndata-ng-value=\"opt._id\" data-ng-repeat=\"opt in Signaturedatas\"><img \nsrc=\"{{UploadsURL}}Security/Users/{{ opt.TableID }}\" width=\"50\" height=\"50\"> - {{opt.EmployeeName}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label>Start Date\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"StartDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container><md-input-container><label>End Date</label><md-datepicker onkeydown=\"return false\" \nng-model=\"EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"></md-input-container></div></div></div></form><br>\n<div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"iSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -80px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb1 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/traininglist/traininglist.html","<div id=\"incidentform\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><span>Training List</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"iSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"iAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"iView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"iExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Incidentgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Trainingdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description Of Training</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Duration</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">End Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Trainer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Trainee Name</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Trainingdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewTraining(row)\" title=\"Detail Grid\" \nstyle=\"border:none\">{{ row.TrainingName }}</a></td><td>{{ row.Duration }}</td><td>{{ row.StartDate | date : \'dd/MM/y\'}}\n</td><td>{{ row.EndDate | date : \'dd/MM/y\'}}</td><td>{{ row.TrainerNamedata[0].EmployeeName }}</td><td>\n{{ row.TraineeName }}</td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Incidentform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div class=\"form-wrapper md-whiteframe-1dp\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"TrainingName\" \nng-model=\"TrainingName\" placeholder=\"Description of Training\"><div ng-messages=\"basicForm.TrainingName.$error\" \nng-show=\"basicForm.TrainingName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nDescription of Training is Required.</span></div></div></md-input-container><md-input-container flex><input \ntype=\"number\" name=\"Duration\" ng-model=\"Duration\" placeholder=\"Duration\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex><label>Trainer</label><md-select \nng-model=\"TrainerName\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Trainer Name..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"TrainerName=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Signaturedatas | filter:vm.searchTerm2\" value=\"{{row._id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>\nTrainee Name</label><md-select ng-model=\"TraineeName\" id=\"searchmodule\" \nng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\" required>\n<md-select-header><input ng-model=\"searchTerm\" type=\"text\" placeholder=\"Search for a Trainee Name\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in Signaturedatas | filter:searchTerm\" ng-value=\"row\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container><label>\nStart Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"StartDate\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container><md-input-container><label>End Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"EndDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\">\n</md-input-container></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"iSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div>\n<style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -80px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number;\r\n        /* Set the serial number counter to 0 */\r\n    }\r\n\r\n    #tb1 td:first-child:before {\r\n        counter-increment: serial-number;\r\n        /* Increment the serial number counter */\r\n        content: counter(serial-number);\r\n        /* Display the counter */\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/timelog/shift/shift.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-clock\"></md-icon><span>Shift Management</span></div></div><div class=\"search\" layout=\"row\" \nng-show=\"Search\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"employee-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" ng-click=\"sAdd()\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"view\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"Export && AllowExport==\'true\'\" ng-click=\"sExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Shiftgrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Shiftsummary\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Shift Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Shift Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Client/Licensor</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nDays of Week</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Shift Start</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">Shift End</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Shiftsummary\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ShiftName }}</td><td>{{ row.ShiftCode }}</td><td>\n{{row.ClientName}}</td><td>{{row.DaysofWeek}}</td><td>{{row.ShiftStartTime | date: \"HH:mm a\"}}</td><td>\n{{row.ShiftEndTime | date: \"HH:mm a\"}}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"shiftinfo(row.ID)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Shiftform\" flex><form name=\"basicForm\" novalidate>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Client/Licensor</label><md-select \nng-model=\"uClientID\" id=\"searchmodule\"><md-option ng-repeat=\"row in clientdatas\" value=\"{{row.id}}\">{{row.ClientName}}\n</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" name=\"ShiftName\" \nng-model=\"uShiftName\" placeholder=\"Shift Name\" required><div ng-messages=\"basicForm.ShiftName.$error\" \nng-show=\"basicForm.ShiftName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Shift Name field is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"ShiftCode\" \nng-model=\"uShiftCode\" placeholder=\"Shift Code\" required><div ng-messages=\"wizardStep1.ShiftCode.$error\" \nng-show=\"wizardStep1.ShiftCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Shift Code field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><span>\nDays of Week</span></md-input-container><md-input-container flex><md-checkbox ng-model=\"DOW.Mon\" \nng-checked=\"rec2.Mon==1\" type=\"checkbox\">Mon</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"DOW.Tues\" ng-checked=\"rec3.Tues==1\" type=\"checkbox\">Tues</md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-model=\"DOW.Wed\" ng-checked=\"rec4.Wed==1\" type=\"checkbox\">Wed</md-checkbox>\n</md-input-container><md-input-container flex><md-checkbox ng-model=\"DOW.Thur\" ng-checked=\"rec5.Thur==1\" \ntype=\"checkbox\">Thur</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-model=\"DOW.Fri\" \nng-checked=\"rec6.Fri==1\" type=\"checkbox\">Fri</md-checkbox></md-input-container><md-input-container flex><md-checkbox \nng-model=\"DOW.Sat\" ng-checked=\"rec7.Sat==1\" type=\"checkbox\">Sat</md-checkbox></md-input-container><md-input-container \nflex><md-checkbox ng-model=\"DOW.Sun\" ng-checked=\"rec1.Sun==1\" type=\"checkbox\">Sun</md-checkbox></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"time\" name=\"time\" \nng-model=\"uShiftStartTime\" placeholder=\"Shift Start\"></md-input-container><md-input-container flex><input type=\"time\" \nng-model=\"uShiftEndTime\" placeholder=\"Shift End\"></md-input-container><md-input-container flex><input type=\"time\" \nng-model=\"uLunchBreakfrom\" placeholder=\"Lunch Start\"></md-input-container><md-input-container flex><input type=\"time\" \nng-model=\"uLunchBreakTo\" placeholder=\"Lunch End\"></md-input-container><md-input-container flex><input type=\"time\" \nng-model=\"uAdditionalBreakfrom\" placeholder=\"Break Start\"></md-input-container><md-input-container flex><input \ntype=\"time\" ng-model=\"uAdditionalBreakTo\" placeholder=\"Break End\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-time-picker ng-model=\"time\" message=\"message\" no-meridiem no-auto-switch></md-time-picker>\n<md-input-container flex><md-checkbox ng-model=\"night.shift\" type=\"checkbox\">Night Shift</md-checkbox>\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"sSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div></div></div><style>\n.ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item {\r\n                opacity: 1 !important;\r\n                padding: 24px;\r\n            }\r\n\r\n                .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before {\r\n                    border-bottom: none !important;\r\n                }\r\n\r\n                .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n                    border-bottom: none !important;\r\n                }\r\n\r\n            .md-tab.md-active {\r\n                background-color: #9E9E9E;\r\n            }\r\n\r\n#example tr td {\r\n    height: 30px;\r\n}\r\n        #viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n    md-dialog md-dialog-content {\r\n        padding: 0;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/request/material/material.html","<div id=\"material\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stock Requisition</span>\n</div><div><span>Total Stock Requests:</span> <span>{{Materialformdatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"mrSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input id=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" ng-show=\"mrSearch\" \nstyle=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-show=\"mrView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"mrExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Materialgrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Materialformdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Requester Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Requested Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Items</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Purpose</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Remarks</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Materialformdatas\" ng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Materialinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y hh:mm a\' }}</td><td><a href=\"\" ng-click=\"ViewMaterialItmes($event,row._id)\" \ntitle=\"Detail Stock Grid\" style=\"border:none\">{{ row.TotalItems || 0 }}</a></td><td>{{ row.Status }}</td><td>\n{{ row.Purpose }}</td><td>{{ row.Remarks }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Materialform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;STOCK REQUEST DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Reference #</label>\n&nbsp;:&nbsp;{{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Requested By</label>\n&nbsp;:&nbsp;{{EmployeeName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Customer</label>\n&nbsp;:&nbsp;{{CustomerName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Location</label>\n&nbsp;:&nbsp;{{Location}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Work Order</label>\n&nbsp;:&nbsp;{{WorkOrder}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Date</label>\n&nbsp;:&nbsp;{{Date | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Purpose\n</label>&nbsp;:&nbsp;{{Purpose}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Remarks</label>\n&nbsp;:&nbsp;{{Remarks}}<br><br></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 \nstyle=\"text-align:left\">&nbsp;WORKFLOW</h2><hr><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" flex><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label \nstyle=\"width:110px;font-weight:500\">Current Status</label>: &emsp; {{Actioned}}</div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label style=\"width:100px;font-weight:500\">Next Status\n</label>: &emsp; {{NextLevelAction}}</div></div><br><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" flex><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"ShowWorkflowButton\"><md-button class=\"md-accent md-raised\" id=\"review\" value=\"Review\" \nng-click=\"workflow($event)\"><span>{{NextLevelAction}}</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" \nvalue=\"Reject\" ng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;STOCK REQUISITION</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Store Name</span></div></th><th class=\"secondary-text\" ng-show=\"Status == \'New\'\"><div><span \nclass=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Materialdatas\">\n<td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreName }}</td><td ng-show=\"Status == \'New\'\"><md-button\n id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"updateMaterial($event,row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.SerialNumber }}</td><td>{{ row.QuantityRequired }}</td><td>{{ row.Unit }}</td><td>{{ row.ProductType }}\n</td><td>{{ row.ExpectedReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div><br><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n     md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/request/material/materialupdate.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">STOCK REQUISITION</span><md-button class=\"md-icon-button\" ng-click=\"close()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"StockQuantity\" \nng-model=\"vm.mStockQuantity\" placeholder=\"Available Stock Quantity\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"QuantityRequired\" ng-model=\"vm.mQuantityRequired\" \nplaceholder=\"Quantity Required\" required><div ng-messages=\"eventForm.QuantityRequired.$error\" \nng-show=\"eventForm.QuantityRequired.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Quantity Required.</span>\n</div></div></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Materialadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"close()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/request/material/unavailablestocks.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">NOT AVAILABLE STOCKS</span><md-button class=\"md-icon-button\" ng-click=\"close()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Product Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Available Stock</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Required Stock</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in notavaildata\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductName }}</td><td>\n{{ DisplayAvailable(row.AvailableQuantity) }}</td><td>{{ row.RequiredQuantity }}</td></tr></tbody></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"close()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/request/material/viewItems.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TOTAL ITEMS</span><md-button class=\"md-icon-button\" ng-click=\"close()\" aria-label=\"Close dialog\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Materialdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}\n</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>\n{{ row.SerialNumber }}</td><td>{{ row.QuantityRequired }}</td><td>{{ row.Unit }}</td></tr></tbody></table></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"close()\" aria-label=\"Submit\">Close\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/request/purchase/purchase.html","<div id=\"purchase\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Purchase Requisition\n</span></div><div><span>Total Purchase Requests:</span> <span>{{Purchaseformdatas.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" ng-show=\"prSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input \nid=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" \nng-show=\"prSearch\" style=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" \nid=\"Datefilter\"><label style=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\">\n<label style=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-show=\"prView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"prExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Purchasegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Purchaseformdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference Number</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Requester Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Work Order</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Deadline</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Items</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Purchaseformdatas | filter:Department\" ng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Purchaseinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>\n{{ row.Date | date:\'dd/MM/y\' }}</td><td>{{ row.WorkOrder }}</td><td>{{ row.Deadline | date:\'dd/MM/y\'}}</td><td><a \nhref=\"\" ng-click=\"ViewPurchaseItmes($event,row._id)\" title=\"Detail Purchase Grid\" style=\"border:none\">\n{{ row.TotalItems || 0 }}</a></td><td>{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Purchaseform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;PURCHASE REQUEST DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Reference #\n</label>&nbsp;:&nbsp;{{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Requested By\n</label>&nbsp;:&nbsp;{{EmployeeName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Supplier\n</label>&nbsp;:&nbsp;{{SupplierName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Store\n</label>&nbsp;:&nbsp;{{StoreName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Work Order\n</label>&nbsp;:&nbsp;{{WorkOrder}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Date</label>\n&nbsp;:&nbsp;{{Date | date:\'dd/MM/y\'}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Deadline\n</label>&nbsp;:&nbsp;{{Deadline | date:\'dd/MM/y\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:110px\">Purpose</label>&nbsp;:&nbsp;{{Purpose}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:110px\">Remarks</label>&nbsp;:&nbsp;{{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr>\n<div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-bottom: -60px\"><md-input-container style=\"margin-top: -10px\" flex><h1 \nstyle=\"text-align:left\">&nbsp;PURCHASE REQUISITION</h1></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Currency\" ng-model=\"Currency\" placeholder=\"Currency\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Cost</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Purchasedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}\n</td><td>{{ row.Quantity }}</td><td>{{ row.Unit }}</td><td>{{ row.UnitPrice }}</td><td>{{ row.TotalCost|number:2 }}\n</td></tr></tbody></table><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<b>Sub Total:</b> &emsp; <span ng-model=\"SubTotal\">{{Currency}} {{SubTotal|number:2}}</span></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-15px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"text\" name=\"DiscountBefore\" ng-model=\"DiscountBefore\" placeholder=\"Discount % (Before GST)\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"GST\" ng-model=\"GST\" placeholder=\"GST %\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\">\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"DiscountAfter\" ng-model=\"DiscountAfter\" \nplaceholder=\"Discount % (After GST)\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:-52px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><b>Total:</b> &emsp; <span \nng-model=\"Total\">{{Currency}} {{Total|number:2}}</span></md-input-container></div></div></div><br><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\"><span>Save</span></md-button></div><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Purchase Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -50px;\r\n    }\r\n\r\n     .ta-root .ta-scroll-window.form-control {\r\n            border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n        }\r\n\r\n        .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n            min-height: 100px !important;\r\n            padding: 1px 12px !important;\r\n        }\r\n        \r\n\r\n        md-select.md-default-theme .md-select-value, md-select .md-select-value {\r\n            border-bottom-color: white !important;\r\n            color:#FFF!important;\r\n        }\r\n      md-select.md-default-theme .md-select-icon, md-select .md-select-icon {\r\n            color: white !important;\r\n            border-top-color: white !important;\r\n        }\r\n    \r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/request/purchase/viewItems.html","<md-dialog style=\"width:1000px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TOTAL ITEMS</span><md-button class=\"md-icon-button\" ng-click=\"close()\" aria-label=\"Close dialog\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Purchasedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ProductCategory }}\n</td><td>{{ row.ProductCodeID }}</td><td>{{ row.ProductName }}</td><td>{{ row.Description }}</td><td>{{ row.Quantity }}\n</td><td>{{ row.Unit }}</td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"close()\" aria-label=\"Submit\">Close</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/Equipment/Equipment.html","<div id=\"store\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-trello\"></md-icon><span>Equipment Inventory</span>\n</div><div><span>Total Equipments:</span> <span>{{Equipmentdatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"sSearch\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nflex></div><div><md-button class=\"md-raised md-background\" ng-show=\"sAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-click=\"Showgrid()\" ng-show=\"sView\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised reference-button\" ng-click=\"ShowEquipmentGrid()\" ng-show=\"EqView\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"sExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Storegrid\"><div class=\"white-bg md-whiteframe-4dp\">\n<md-progress-linear ng-hide=\"Equipmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" \nrole=\"progressbar\" class=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\">\n</div><div class=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Image</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Inventory Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Product Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Supplier</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Current Stock</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Minimum Order</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nView/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Equipmentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><img class=\"product-image\" \nng-src=\"{{UploadsURL + \'Procurement/SupplierItems/\'+row._id+\'.png\'}}\"></td><td><a href=\"\" \nng-click=\"EquipmentInfoR(row._id,row)\" title=\"Detail Grid\" style=\"border:none\">{{ row.EquipmentCode }}</a></td><td>\n{{ row.EquipmentName }}</td><td>{{ row.SupplierName }}</td><td>{{ row.TotalStock }}</td><td>{{ row.MinimumOrder}}</td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"EquipmentInfoR(row._id,row)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr></tbody>\n</table></div></div><div class=\"content\" ng-show=\"Storeform\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"basicForm1\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"InventoryCode\" ng-model=\"Code\" \nplaceholder=\"Inventory Code\" readonly=\"readonly\" required></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"ProductName\" ng-model=\"EquipmentName\" placeholder=\"Product Name\" readonly=\"readonly\" required>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Manufacturer\" ng-model=\"Manufacturer\" \nplaceholder=\"Maufacturer\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\">\n<md-input-container flex><input type=\"text\" name=\"SerialNumber\" ng-model=\"SerialNumber\" placeholder=\"Serial Number\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Brand\" ng-model=\"Brand\" placeholder=\"Brand\">\n</md-input-container><md-input-container><label>Purchased Date</label><md-datepicker onkeydown=\"return false\" \nclass=\"datefilter\" ng-model=\"PurchasedDate\"></md-datepicker></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -27px;margin-left: -8px\"><md-input-container flex style=\"flex: 0.5\"><input \ntype=\"text\" name=\"Location\" ng-model=\"Location\" placeholder=\"Location\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\">\n</md-input-container></div></form><br><div class=\"content fullpage-datatable\" layout=\"column\" style=\"font-size:16px\" \nflex><span style=\"font-weight: bold\">Record Log</span><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions2\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Equipment Given On</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Technician Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Technician Contact</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Recorddetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Date | date:\'dd/MM/y\'}}</td><td>{{ row.TechnicianName }}</td><td>{{ row.TechnicianContact }}</td></tr></tbody>\n</table></div><br><br><div class=\"content fullpage-datatable\" layout=\"column\" style=\"font-size:16px\" flex><span \nstyle=\"font-weight: bold\">Equipment Maintenance Log</span><md-button ng-hide=\"ReturnEquip\" \nstyle=\"margin-left:90%;width:5%;margin-top:-20px\" type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AddRecord($event , \'Service\')\">Add\n</md-button><md-button ng-show=\"ReturnEquip\" style=\"margin-left:90%;width:5%;margin-top:-20px\" type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ReturnEquipment()\">Return</md-button>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serviced Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serviced For</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Uploaded Documents</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ServiceLogdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ServiceDate | date:\'dd/MM/y\' }}</td><td>{{ row.ServiceFor }}</td><td>{{ row.Remarks }}</td><td><a \ntarget=\"_blank\" href=\"{{UploadsURL}}Procurement/Equipment/{{row.GUID}}\" download style=\"cursor:pointer\">\n{{ row.UploadDocument }}</a></td></tr></tbody></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm1.$invalid\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><div class=\"content\" \nng-show=\"EquipmentInfo\"><div layout=\"row\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:100%;border:1px solid rgb(224, 224, 224)\" flex><div layout=\"row\"><div layout=\"column\" style=\"width:30%\">\n<div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div \nclass=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">Equipment Information :</label></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>\nEquipment Code #</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{vm.EquipmentCode}}</b></span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>\nCurrent Stock</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.TotalStock}}</span></div></div></div><div \nlayout=\"column\" style=\"width:30%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\"></label></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>\nEquipment Name</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{vm.EquipmentName}}</b></span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>\nMinuimum Order</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.MinimumOrder}}</span></div></div></div><div \nlayout=\"column\" style=\"width:30%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\"></label></div>\n</div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span style=\"font-size:15px;color:#7f9593\"><b>\nSupplier Name</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{vm.SupplierName}}</b></span></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nstyle=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label style=\"font-size:15px;color:#7f9593\"><b>\nThreshold Level</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:</b></label><div class=\"p-4\" \nstyle=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{vm.ThresholdLevel}}</span></div></div></div></div><div\n layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"false\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-text\">Equipment Details</span>\n</md-tab-label><md-tab-body><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Equipment Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Brand Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Purchased Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EquipmentListdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Code }}</td><td>{{ row.Brand }}</td><td>\n{{ row.SerialNumber }}</td><td>{{ row.PurchasedDate | date:\'dd/MM/y h:m a\' }}</td><td>{{ row.Remarks }}</td><td \nng-if=\"row.Quantity==1\"><div class=\"label ng-binding ng-scope md-green-500-bg\">{{row.EquipmentGivenTo}}</div></td><td \nng-if=\"row.Quantity==0\"><div class=\"label ng-binding ng-scope md-orange-500-bg\">{{row.EquipmentGivenTo}}</div></td><td \nng-if=\"row.Quantity==-1\"><div class=\"label ng-binding ng-scope md-red-500-bg\">Service</div></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Storeinfo(row.id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"delete\" ng-disabled=\"row.EquipmentGivenTo!=\'Store\'\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"DeleteEquipment(row.id, $index)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></td></tr></tbody></table></md-tab-body></md-tab><md-tab><md-tab-label><span \nng-if=\"wizardStep2.$valid\"></span> <span class=\"ms-form-wizard-step-text\">Purchase History</span></md-tab-label>\n<md-tab-body><md-tab-body><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">DO #</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Delivered Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Created By</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PurchaseHistory\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }}</td>\n<td>{{ row.CreatedDate | date:\'dd/MM/y h:m a\'}}</td><td>{{ row.Supplierdetails[0].Name }}</td><td>{{ row.CreatedBy }}\n</td></tr></tbody></table></md-tab-body></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div></div></div><div \nclass=\"content\" ng-show=\"AddEquipmentform\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form \nname=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label>Supplier</label><md-select ng-model=\"Supplier\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a Supplier..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:vm.searchTerm2\" \nng-click=\"getSupplierItems(row.UniqueID,row.Name)\" value=\"{{row.id}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Items</label><md-select ng-model=\"vm.dDescription\" id=\"Supplier\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Supplier..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in SupplierItemdatas | filter:vm.searchTerm2\" ng-click=\"getItemDetails(row)\" value=\"{{row.Item}}\">\n{{row.Item}}</md-option></md-select></md-input-container><md-input-container><label>Purchased Date</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"PurchasedDate\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex>\n<input type=\"text\" name=\"SerialNumber\" ng-model=\"SerialNumber\" placeholder=\"Serial Number\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Brand\" ng-model=\"Brand\" placeholder=\"Brand\"></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Location\" ng-model=\"Location\" placeholder=\"Location\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px;margin-left: -8px\">\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\">\n</md-input-container></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"NewSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(28vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before,\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        content: \'\';\r\n        display: none;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 0;\r\n        right: 50%;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n        z-index: 8;\r\n    }\r\n\r\n    .product-image {\r\n        width: 52px;\r\n        height: 52px;\r\n        border: 1px solid rgba(0, 0, 0, 0.12);\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/Equipment/ServicePop.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.Title}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-show=\"Service\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\"><md-input-container><label>\nServiced Date</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"vm.SDate\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Contact\" ng-model=\"vm.ServicedFor\" \nplaceholder=\"Serviced For\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-20px\">\n<md-input-container flex><div layout=\"row\" flex style=\"margin-top:-20px;margin-bottom:-30px\"><input id=\"fileInput1\" \ntype=\"file\" class=\"ng-hide\" onchange=\"angular.element(this).scope().BindAttach(\'fileInput1\')\"><md-input-container flex \nclass=\"md-block\"><input type=\"text\" ng-model=\"vm.FileName1\" readonly=\"readonly\" placeholder=\"File Name\">\n</md-input-container><div><md-button ng-click=\"AGUpload(\'fileInput1\')\" class=\"md-raised\">Upload</md-button></div></div>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"vm.Remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"ServiceSubmit()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">Cancel</md-button></div></div></md-dialog-content></form></md-dialog><style>\nmd-datepicker .md-datepicker-input {\r\n        width: calc(15vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/Chemical/Chemical.html","<div id=\"store\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon><span>Chemical Inventory\n</span></div><div><span>Total Chemicals:</span> <span>{{selecteddata.length}}</span></div></div><div><md-button \nclass=\"md-raised md-background\" ng-show=\"sAdd\" ng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n<span>Add</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"sView\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"sExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Storegrid\"><md-tabs md-dynamic-height md-center-tabs=\"false\" md-selected=\"selectedIndex\"><md-tab \nng-click=\"selectedtab = \'instock\';selecteddata=Chemicaldatas ; Refresh()\"><md-tab-label><span>In Stock</span>\n</md-tab-label><md-tab-body><div id=\"YTSContainer\" dx-data-grid=\"vm.dataGridContract\"></div></md-tab-body></md-tab>\n<md-tab ng-click=\"selectedtab = \'onhold\';selecteddata=OnHoldChemicaldatas;getOnHoldChemicals()\"><md-tab-label><span>\nOn-Hold</span></md-tab-label><md-tab-body><div id=\"PendingContainer\" dx-data-grid=\"vm.dataGridPending\"></div>\n</md-tab-body></md-tab></md-tabs></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Storeform\" flex><div layout=\"column\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:100%;border:1px solid rgb(224, 224, 224)\" flex><div layout=\"row\"><div \nlayout=\"column\" style=\"width:30%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">\nChemical Information :</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Chemical Code #</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>\n:</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{Code}}</b></span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Current Stock</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>:\n</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{CurrentStock}}</span>\n</div></div></div><div layout=\"column\" style=\"width:30%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">\n</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Chemical Name</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:\n</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{ChemicalName}}</b>\n</span></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Minuimum Order</b></label></div><label style=\"font-size:15px;color:#7f9593\"><b>\n:</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{MinimumOrder}}</span>\n</div></div></div><div layout=\"column\" style=\"width:30%\"><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><div class=\"p-4\" style=\"width:100%\"><label style=\"font-size:17px\">\n</label></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><span \nstyle=\"font-size:15px;color:#7f9593\"><b>Supplier Name</b></span></div><label style=\"font-size:15px;color:#7f9593\"><b>:\n</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:13px;padding-left:2%\"><b>{{Supplier}}</b></span>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\" style=\"margin-top: -15px\"><div class=\"p-4\" style=\"width:30%\"><label \nstyle=\"font-size:15px;color:#7f9593\"><b>Threshold Level</b></label></div><label style=\"font-size:15px;color:#7f9593\">\n<b>:</b></label><div class=\"p-4\" style=\"width:60%\"><span style=\"font-size:14px;padding-left:2%\">{{Threshold}}</span>\n</div></div></div></div></div><br><div layout=\"column\" style=\"padding: 2px 2px 2px 2px\"><div><span \nclass=\"ms-form-wizard-step-text\"><h3><b>Purchase History</b></h3></span></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">DO #</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Delivered Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Created By</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PurchaseHistory\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }}</td><td>\n{{ row.CreatedDate | date:\'dd/MM/y h:m a\'}}</td><td>{{ row.Supplierdetails[0].Name }}</td><td>{{ row.CreatedBy }}</td>\n</tr></tbody></table></div></div></div></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ChemicalAdd\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Supplier</label><md-select \nng-model=\"Supplier\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Supplier..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Supplierdatas | filter:vm.searchTerm2\" \nng-click=\"getSupplierItems(row.UniqueID,row.Name)\" value=\"{{row.id}}\">{{row.Name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Items</label><md-select ng-model=\"vm.dDescription\" id=\"Supplier\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Supplier..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in SupplierItemdatas | filter:vm.searchTerm2\" ng-click=\"getItemDetails(row)\" value=\"{{row.Item}}\">\n{{row.Item}}</md-option></md-select></md-input-container><md-input-container><label>Last Purchase Date</label>\n<md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"PurchasedDate\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex>\n<input type=\"text\" name=\"Threshold\" ng-model=\"Threshold\" placeholder=\"Threshold Level\" readonly=\"readonly\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"MinimumOrder\" ng-model=\"MinimumOrder\" \nplaceholder=\"Minimum Order\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"number\" \nname=\"Quantity\" ng-model=\"Quantity\" placeholder=\"Quantity\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex style=\"flex: 0.5\"><input type=\"text\" name=\"Unit\" \nng-model=\"Unit\" placeholder=\"Unit\" readonly=\"readonly\"></md-input-container><md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"Remarks\" placeholder=\"Remarks\"></md-input-container></div></form><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"NewSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n    .product-image {\r\n                            width: 52px;\r\n                            height: 52px;\r\n                            border: 1px solid rgba(0, 0, 0, 0.12);\r\n                        }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/Chemical/EditStock.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Edit Chemical Stock\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nflex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.Stock\" min=\"0\" placeholder=\"Quantity\" required>\n</md-input-container><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"UpdateStock()\" class=\"md-raised md-accent\">Update</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">Cancel</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/deliverynote/DeliverynoteAdd.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">ITEM LIST</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Items</label><md-select ng-model=\"vm.dDescription\" id=\"Supplier\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Item..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in SupplierItemdatas | filter:vm.searchTerm2\" \nng-click=\"getItemDetails(row)\" value=\"{{row.Item}}\">{{row.Category}} - {{row.Item}}</md-option></md-select>\n</md-input-container><md-input-container flex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.Quantity\" \nplaceholder=\"Quantity\" required></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"text\" name=\"Description\" ng-model=\"vm.Remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"EquipmentDetails($event);\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"cancel()\" aria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/deliverynote/deliverynote.html","<div id=\"deliverynote\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hops\"></md-icon><span>Delivery Order</span></div>\n<div><span>Total Delivery Orders:</span> <span>{{Deliverynotedatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"dnSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input id=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" \nng-show=\"dnAdd\" ng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button>\n<md-button class=\"md-raised reference-button\" ng-show=\"dnView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"dnExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"Deliverynotegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Deliverynotedatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">DO No</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Supplier Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">View/Edit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Deliverynotedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"Deliverynoteinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.Supplierdetails[0].Name }}</td><td>\n{{ row.DODate| date:\'dd/MM/y\' }}</td><td>{{ row.Remarks| date:\'dd/MM/y\' }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate| date:\'dd/MM/y HH:mm:ss\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Deliverynoteinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Deliverynoteform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Supplier</label><md-select ng-model=\"Supplier\" id=\"Supplier\" \nmd-on-close=\"clearSearchTerm()\" ng-required=\"To == \'Supplier\'\"><md-select-header><input ng-model=\"vm.searchTerm2\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Supplier..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Supplierdatas | filter:vm.searchTerm2\" ng-click=\"getSupplierItems(row.UniqueID,row.Name)\" \nvalue=\"{{row.id}}\">{{row.Name}}</md-option></md-select></md-input-container><md-input-container flex \nstyle=\"margin-top: 18px;margin-left:-10px\"><label>Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"Date\">\n</md-datepicker></md-input-container><md-input-container flex><div layout=\"row\" flex \nstyle=\"margin-top:-20px;margin-bottom:-30px\"><input id=\"fileInput\" type=\"file\" class=\"ng-hide\" \nonchange=\"angular.element(this).scope().BindAttach(\'fileInput\')\"><md-input-container flex class=\"md-block\"><input \ntype=\"text\" style=\"color:black\" ng-model=\"FileName\" readonly=\"readonly\" placeholder=\"File Name\"></md-input-container>\n<div><md-button ng-click=\"AGUpload(\'fileInput\')\" class=\"md-raised\">Upload</md-button></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"Remarks\" placeholder=\"Remarks\"></md-input-container><md-input-container flex></md-input-container></div><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><h2 style=\"text-align:left\">&nbsp;ITEM LIST</h2><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-hide=\"Update\" \nng-click=\"Deliverynotedetailpopup(UniqueID, $event )\" ng-disabled=\"!Supplier\" style=\"float:right\"><span>Add</span>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" style=\"margin-top: 10px\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Received Item</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"row in Deliverynotedetaildatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Description }}</td><td>{{ row.Quantity }}</td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"DeliveryNoteDetailsdelete(row._id,$index)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div><br><div \nstyle=\"padding-bottom:2%\" ng-if=\"Update == true\"><span class=\"h3\" style=\"color:#7f9593\"><b>ATTACHMENT :</b></span>\n</div><div class=\"white-bg md-whiteframe-4dp\" ng-if=\"Update == true\" style=\"border:1px solid rgb(224, 224, 224)\"><table\n id=\"tb2\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_NAME\">File Name\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.FILE_SIZE\">File Size\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" translate=\"CRMLEAD.UPLOADED_BY\">\nUploaded By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\" \ntranslate=\"CRMLEAD.UPLOADED_DATE\">Uploaded Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Attachmentdatas\"><td>1.</td><td><a href=\"{{UploadsURL}}Procurement/DeliveryOrder/{{row.TableID}}\" \ndownload style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y\' }}</td></tr></tbody></table></div></form><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"dnSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">\nCancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -65px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n     #Datefilter md-datepicker .md-datepicker-input {\r\n        width:0;\r\n    }\r\n \r\n    .datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n        border-top-color: white !important;\r\n    }\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\r\n\r\n\r\n    /*md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }*/\r\n\r\n     md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/deliverynote/deliverynotedetaildelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.Title}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div ng-show=\"DeleteDelivery\" class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"Ddelete(deleteID)\" class=\"md-raised md-accent\">Yes\n</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">No</md-button></div><div ng-hide=\"DeleteDelivery\" \nclass=\"navigation\" flex layout=\"column\" layout-align=\"center center\"><div id=\"gridContainer\" \ndx-data-grid=\"vm.dataGridOptions\"></div><div><md-button ng-click=\"Deliverynotedetailadd()\" class=\"md-raised md-accent\">\nSubmit</md-button><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button></div></div></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/auditing/IssuanceAdd.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">STOCK ISSUANCE</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-radio-group ng-model=\"vm.iType\" layout=\"row\"><md-radio-button value=\"No\">\nNon-Returnable</md-radio-button><md-radio-button value=\"Yes\">Returnable</md-radio-button></md-radio-group></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"margin-top: 18px\" flex><label>Store</label><md-select \nng-model=\"vm.iStore\" ng-change=\"ProductCodedetails()\" id=\"Store\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a store..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.iStore=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm\" value=\"{{row.StoreName}}\">\n{{row.StoreName}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.iType == \'Yes\'\" \nstyle=\"margin-top: 18px;margin-left:-10px\" flex><label>Expected Return Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.iExpectedReturnDate\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Product Category</label><md-select \nng-model=\"vm.iProductCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" \nrequired><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a category..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.iProductCategory=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></md-select-header><md-option ng-repeat=\"row in CategoryList | filter:vm.searchTerm\" \nvalue=\"{{row.name}}\">{{row.name}}</md-option></md-select><div ng-messages=\"eventForm.ProductCategory .$error\" \nng-show=\"eventForm.ProductCategory .$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nProduct Category is required.</span></div></div></md-input-container><md-input-container flex><label>Product Name\n</label><md-select ng-model=\"vm.iProductName\" ng-change=\"ProductCodedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for product name..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"ProductNameclear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Categorydatas | filter:vm.searchTerm\" value=\"{{row.ProductName}}\">{{row.ProductName}}</md-option>\n</md-select><div ng-messages=\"eventForm.pName .$error\" ng-show=\"eventForm.pName .$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Product Name is required.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"Name\" ng-model=\"vm.iProductCode\" \nplaceholder=\"Product Code\" readonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"text\" \nname=\"Description\" ng-model=\"vm.iDescription\" placeholder=\"Description\" readonly=\"readonly\"></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -27px\"><md-input-container flex><input type=\"text\" \nname=\"Name\" ng-model=\"vm.iStockQuantity\" placeholder=\"Stock Quantity\" readonly=\"readonly\"></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"Quantity\" ng-model=\"vm.iQuantity\" placeholder=\"Issue Quantity\" \nrequired><div ng-messages=\"eventForm.Quantity.$error\" ng-show=\"eventForm.Quantity.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Quantity field is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" name=\"Name\" ng-model=\"vm.iUnits\" placeholder=\"Unit\" readonly=\"readonly\"></md-input-container>\n</div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"StockIssuanceadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/auditing/auditing.html","<div id=\"auditing\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Auditing Activity</span>\n</div></div><div class=\"search\" layout=\"row\" ng-show=\"siSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"siAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"siView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"siExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"StockIssuancegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Stockissuanceformdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference #</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Issue To</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Receiver Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Requested Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Issued Date</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Report</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Stockissuanceformdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewStockinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.To }}</td><td>\n{{ row.Employeedetails[0].EmployeeName || row.Storedetails[0].StoreName || row.Customerdetails[0].CompanyName || row.ThirdParty }}\n</td><td>{{ row.RequestedDate| date:\'dd/MM/y HH:mm:ss\' }}</td><td>{{ row.Status }}</td><td>\n{{ row.IssuedDate| date:\'dd/MM/y HH:mm:ss\' }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Stockinfo(row._id, $index)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"printToCart(row._id)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td></tr></tbody></table></div><div class=\"content\" \nid=\"invoice\" ng-show=\"Pop\"><div style=\"font-size:25px;font-weight:600\"><img src=\"assets/images/logos/pest_logo.png\">\n&emsp;&emsp;<b>STOCK ISSUANCE FORM</b> <img ng-if=\"QRCode\" style=\"height:20%; width:20%;float:right;margin-top:-1%\" \nsrc=\"{{QRCode}}\"></div><br><table style=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Reference #:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{ReferenceNo}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Date:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{RequestedDate | date:\'dd/MM/y\'}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Issue To:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{To}}</th><th \nstyle=\"border-collapse: collapse;width:300px\">Name:</th><th \nstyle=\"border-collapse: collapse;width:1000px;font-weight:normal\">{{RequestedByName}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Purpose:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Purpose}}</th></tr><tr><th \nstyle=\"border-collapse: collapse;width:300px\">Remarks:</th><th colspan=\"3\" \nstyle=\"border-collapse: collapse;width:2300px;font-weight:normal\">{{Remarks}}</th></tr></thead><tbody></tbody><tfoot>\n</tfoot></table><br><div style=\"font-size:17px;text-align:left\"><table \nstyle=\"width:100%;border: 1px solid black;border-collapse: collapse\"><thead><tr style=\"background-color:#9E9E9E\"><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:100px;text-align:center\">S.NO</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">STORE</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">CATEGORY</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">CODE</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">NAME</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">ISSUED QUANTITY</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">RETURNABLE</th><th \nstyle=\"border: 1px solid black;border-collapse: collapse;width:500px;text-align:center\">EXPECTED RETURN DATE</th></tr>\n</thead><tbody><tr ng-repeat=\"row in Stockissuancedatas\" style=\"border: 1px solid black;border-collapse: collapse\"><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.StoreID }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ProductCategory }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ProductCode }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ProductName }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.Quantity }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ProductType }}</td><td \nstyle=\"border: 1px solid black;border-collapse: collapse\">{{ row.ReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody><tfoot>\n</tfoot></table></div><br><br><br><br><br><br><table style=\"width:100%;border-collapse: collapse;text-align:left\">\n<thead><tr><th style=\"border-collapse: collapse;width:1500px\">Prepared By<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Received By<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Date Prepared<br><br><br><br></th><th \nstyle=\"border-collapse: collapse;width:700px\">Date Received<br><br><br><br></th></tr><tr><th \nstyle=\"border-collapse: collapse;width:1500px\">Verified/ Issued By</th><th \nstyle=\"border-collapse: collapse;width:700px\">Delivered By</th></tr></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"StockIssuanceform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><h2 style=\"text-align:left\">\n&nbsp;ISSUANCE FORM</h2><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\" ng-show=\"Cancel\">\n<md-button class=\"md-accent md-raised\" ng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div><hr><div\n layout=\"column\" layout-gt-xs=\"row\"><label style=\"width:50px;margin-top: 20px\"><b>To:</b></label>&emsp;<md-radio-group \nng-model=\"To\" ng-change=\"Tofield()\" layout=\"row\"><md-radio-button value=\"Employee\">Employee</md-radio-button>\n<md-radio-button value=\"Store\">Store</md-radio-button><md-radio-button value=\"Customer\">Customer</md-radio-button>\n<md-radio-button value=\"ThirdParty\">Third Party</md-radio-button></md-radio-group></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container ng-show=\"To == \'Employee\'\" flex><label>Employee Name</label><md-select \nng-model=\"EmployeeID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\"><md-select-header><input \nng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Employee..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"EmployeeID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Employeedatas | filter:vm.searchTerm\" value=\"{{row.id}}\">\n{{row.EmployeeID}}-{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container \nng-show=\"To == \'Store\'\" flex><label>Store Name</label><md-select ng-model=\"StoreID\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a store..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"StoreID=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm\" value=\"{{row._id}}\">\n{{row.StoreName}}</md-option></md-select></md-input-container><md-input-container ng-show=\"To == \'Customer\'\" flex>\n<label>Customer Name</label><md-select ng-model=\"CustomerID\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\">\n<md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a Customer..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"CustomerID=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Customerdatas | filter:vm.searchTerm\" value=\"{{row.id}}\">\n{{row.CompanyName}}</md-option></md-select></md-input-container><md-input-container ng-show=\"To == \'ThirdParty\'\" flex>\n<input type=\"text\" name=\"ThirdPartyName\" ng-model=\"ThirdPartyName\" placeholder=\"Third Party Name\"><div \nng-messages=\"basicForm.ThirdPartyName.$error\" ng-show=\"basicForm.ThirdPartyName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Third Party Name field is required.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Purpose\" ng-model=\"Purpose\" placeholder=\"Purpose\">\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"Remarks\" \nplaceholder=\"Remarks\"></md-input-container></div><div class=\"form-wrapper md-whiteframe-1dp\" flex><h2 \nstyle=\"text-align:left\">&nbsp;MATERIAL LIST</h2><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"StockIssuancepopup(UniqueID, $event )\" \nstyle=\"float:right\"><span>Add</span></md-button></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Store</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Stockissuancedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreID }}</td><td>{{ row.ProductCategory }}</td><td>\n{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Quantity }}</td><td>{{ row.ProductType }}</td><td>\n{{ row.ReturnDate| date:\'dd/MM/y\' }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"StockIssuancedelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></td></tr></tbody></table></div></div></form><br><div class=\"bottom\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"siSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewStockIssuanceform\" flex><form name=\"basicForm2\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:48.5%;float:left\"><h2 style=\"text-align:left\">\n&nbsp;STOCK ISSUANCE DETAILS</h2><hr>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Reference No.\n</label>&nbsp; :&nbsp; {{ReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Issue To\n</label>&nbsp; :&nbsp; {{To}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">Receiver Name\n</label>&nbsp; :&nbsp; {{RequestedByName}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\nRequested Date</label>&nbsp; :&nbsp; {{RequestedDate| date:\'dd/MM/y HH:mm:ss\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">Purpose</label>&nbsp; :&nbsp; {{Purpose}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px\">Remarks</label>&nbsp; :&nbsp; {{Remarks}}<br><br></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:50.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;WORKFLOW</h2><hr>\n<div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status</label>\n: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><label \nstyle=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowIssueButton\">\n<md-button class=\"md-accent md-raised\" id=\"revise\" value=\"Revise\" ng-click=\"issue()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div></div><br><md-progress-linear \nng-hide=\"Logdetailsdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h2 style=\"text-align:left\">\n&nbsp;MATERIAL LIST</h2><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Stockissuancedatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Store</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Issued Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Stockissuancedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreID }}</td><td>\n{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>{{ row.Quantity }}</td>\n<td>{{ row.ProductType }}</td><td>{{ row.ReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div><br><div \nclass=\"content-card\" style=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"Comment\" \nng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm2.$invalid || basicForm2.$pristine\"><span>Save</span></md-button></div><md-progress-linear \nng-hide=\"Commentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div flow-init \nflow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\"><md-button \nclass=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input class=\"file-input\" \nflow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">File Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">File Size(KB)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Uploaded By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Uploaded Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"{{UploadsURL}}Procurement/Stock Issuance/{{row.TableID}}\" \ndownload style=\"cursor:pointer\">{{ row.FileName }}</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div></div></div></form><br><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" \nclass=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -65px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    /*md-datepicker .md-datepicker-input {\r\n        width: calc(26vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }*/\r\n\r\n    .md-datepicker-input {\r\n        min-width: 350px;\r\n        max-width: 1500px;\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    #tbm {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tbm td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n         #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n         #tb3 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb3 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n         #tb4 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb4 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/auditing/issuancedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this stock issuance?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"SIdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/issuance/issuance.html","<div id=\"issuance\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stock Issuance</span>\n</div><div><span>Total Records:</span> <span>{{Stockissuanceformdatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" ng-show=\"siSearch\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input id=\"search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" ng-show=\"siSearch\" \nstyle=\"margin-top:30px\" layout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised reference-button\" ng-show=\"siView\" ng-click=\"Showgrid()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"siExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nExport</span></md-button></div></div><div class=\"content-card\" ng-show=\"StockIssuancegrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Stockissuanceformdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Issuance Reference #</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Stock Request Reference #</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Request By</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Requested Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Purpose</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Stockissuanceformdatas\" \nng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"\" ng-click=\"Stockinfo(row._id, $index)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td>\n<td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.StockReferenceNo }}</td><td>{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}\n</td><td>{{ row.RequestedDate| date:\'dd/MM/y HH:mm:ss\' }}</td><td>{{ row.IssuedDate| date:\'dd/MM/y HH:mm:ss\' }}</td>\n<td>{{ row.Purpose }}</td><td>{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"StockIssuanceform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><h2 style=\"text-align:left\">\n&nbsp;STOCK ISSUANCE DETAILS</h2><hr><div style=\"width:49.5%;float:left\">&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:250px\">Issuance Reference No.</label>&nbsp;:&nbsp;{{ReferenceNo}}<br><br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:250px\">Stock Request Reference. No.</label>\n&nbsp;:&nbsp;{{StockReferenceNo}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:250px\">Receiver Name\n</label>&nbsp;:&nbsp;{{RequestedByEmployee}}<br><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:250px\">\nRequested Date</label>&nbsp;:&nbsp;{{RequestedDate| date:\'dd/MM/y HH:mm:ss\'}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:250px\">Issued Date</label>\n&nbsp;:&nbsp;{{IssuedDate| date:\'dd/MM/y HH:mm:ss\'}}<br><br></div><div style=\"width:49.5%;float:right\">&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:80px\">Purpose</label>&nbsp;:&nbsp;{{Purpose}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:80px\">Remarks</label>&nbsp;:&nbsp;{{Remarks}}<br><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:80px\">Status</label>&nbsp;:&nbsp;{{Status}}<br><br></div></div><br><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><h2 style=\"text-align:left\">&nbsp;STOCK LIST</h2><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Returnable</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Stockissuancedatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.StoreID }}</td><td>{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td>\n<td>{{ row.Description }}</td><td>{{ row.Quantity }}</td><td>{{ row.ProductType }}</td><td>\n{{ row.ReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table></div></div><br><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 \nstyle=\"text-align:left\">&nbsp;COMMENTS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\">\n<md-input-container flex><input type=\"text\" name=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" \nrequired></md-input-container></div><div style=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" \nng-click=\"commentSubmit()\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\"><span>Save</span></md-button></div>\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Stock Issuance/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}</a>\n</td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}</td>\n</tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -65px;\r\n    }\r\n\r\n     .file-input {\r\n        display: none !important;\r\n    }\r\n    \r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n     #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    #tbm {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tbm td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n         #tb2 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb2 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n         #tb3 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb3 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n         #tb4 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb4 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/lighttraplist/lighttraphistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TRANSACTION HISTORY</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\" style=\"margin-top:-40px\"><h2 \nstyle=\"text-align:left\">&nbsp;RATSENSE</h2><hr>&emsp;<label style=\"font-size:17px;color:#7f9593;width:135px\">\nProduct Category</label>&nbsp; :&nbsp;<label style=\"font-size:17px\">{{ProductCategory}}</label>&emsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:110px\">Product Code</label>&nbsp; :&nbsp;<label style=\"font-size:17px\">\n{{ProductCode}}</label>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Product Name</label>&nbsp; :&nbsp;\n<label style=\"font-size:17px\">{{ProductName}}</label><br><br>&emsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:135px\">Model Number</label>&nbsp; :&nbsp;<label style=\"font-size:17px\">\n{{Model}}</label>&emsp;<label style=\"font-size:17px;color:#7f9593;width:110px\">Serial Number</label>&nbsp; :&nbsp;\n<label style=\"font-size:17px\">{{SerialNumber}}</label><br><br></div><md-tabs md-dynamic-height md-center-tabs=\"false\">\n<md-tab><div ng-click=\"IssuanceDetaildatas()\"><md-tab-label><span>ISSUANCE DETAILS</span></md-tab-label></div>\n<md-tab-body><div class=\"form-wrapper md-whiteframe-1dp\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Location</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Issued Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Issued By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Returned Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Returned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Lighttrapdetaildatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Customerdetails[0].CompanyName }}</td><td>{{ row.Location}}</td><td>{{ row.StartDate | date:\'dd/MM/y\'}}</td><td>\n{{ row.EndDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.CreatedBy }}</td><td>\n{{ row.UpdatedDate | date:\'dd/MM/y\'}}</td><td>{{ row.UpdatedBy }}</td><td>{{row.Status}}</td></tr></tbody></table>\n</div></md-tab-body></md-tab><md-tab><div ng-click=\"PurchaseHistoryDetails()\"><md-tab-label><span>PURCHASE HISTORY\n</span></md-tab-label></div><md-tab-body><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nng-hide=\"row.ReferenceNo == \'Manual\'\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nPO Number</span></div></th><th ng-hide=\"row.ReferenceNo != \'Manual\'\" class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">PO Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Store Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">DO Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Received By</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Received Date</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in PurchaseHistorydatas\" \nng-if=\"$index == myIndex\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td ng-hide=\"row.ReferenceNo == \'Manual\'\">\n<a href=\"\" ng-click=\"GoPO(row._id)\" title=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td \nng-hide=\"row.ReferenceNo != \'Manual\'\">{{ row.ReferenceNo }}</td><td>{{ row.StoreName}}</td><td>{{ row.DONumber }}</td>\n<td>1</td><td>{{ row.Unit }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td></tr>\n</tbody></table></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"cancel()\" class=\"md-raised md-accent\">Close</md-button></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/lighttraplist/lighttraplist.html","<div id=\"lighttraplist\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>RATSENSE</span></div>\n<div><span>Total Records:</span> <span>{{Lighttrapdatas.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -15px\" flex><input id=\"search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search..\" flex></div><div><md-button class=\"md-raised md-background\" ng-shoe=\"AllowExport==\'true\'\" \nng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div \nclass=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Lighttrapdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Location</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Model</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Lighttrapdatas | filter:Status\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Customerdetails[0].CompanyName }}</td><td>{{ row.Location }}</td><td><a href=\"\" \nng-click=\"ViewIssuanceHistory($event,row._id)\" title=\"Purchase History\" style=\"border:none\">{{ row.ProductCode }}</a>\n</td><td>{{ row.ProductCategory}}</td><td>{{ row.ProductName }}</td><td>{{ row.Model }}</td><td>{{ row.SerialNumber }}\n</td><td>{{ row.Status }}</td></tr></tbody></table></div></div></div></div><style>\n#viewedit.md-button {\r\n            margin: -16px 8px;\r\n        }\r\n\r\n        md-datepicker .md-datepicker-input {\r\n            width: calc(26vw - 35px);\r\n            max-width: calc(35vw - 54px);\r\n        }\r\n\r\n        .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n            color: rgba(0,0,0,0.87);\r\n            background: none;\r\n        }\r\n\r\n        ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n            right: 74px;\r\n        }\r\n\r\n        .md-datepicker-button {\r\n            display: none;\r\n        }\r\n\r\n        .ta-root .ta-scroll-window.form-control {\r\n            border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n        }\r\n\r\n        .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n            min-height: 100px !important;\r\n            padding: 1px 12px !important;\r\n        }\r\n        \r\n        \r\n        /*md-select.md-default-theme .md-select-value, md-select .md-select-value {\r\n            border-bottom-color: white !important;\r\n            color:#FFF!important;\r\n        }\r\n      md-select.md-default-theme .md-select-icon, md-select .md-select-icon {\r\n            color: white !important;\r\n            border-top-color: white !important;\r\n        }*/\n</style>");
$templateCache.put("app/main/apps/procurement/stock/return/return.html","<div id=\"return\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stock Return</span>\n</div><div><span>Total Records:</span> <span>{{Stockreturndatas.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-top: -10px\" flex><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" style=\"margin-top:30px\" \nlayout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<md-checkbox ng-model=\"uShowReturned\" ng-change=\"ShowReturned(uShowReturned)\" type=\"checkbox\" \nstyle=\"margin-top: 35px;color:white\">Show Returned?</md-checkbox><div><md-button class=\"md-raised md-background\" \nng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span>\n</md-button></div></div><div class=\"content-card\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Stockreturndatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Reference #</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Store</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Location</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Issued Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Returned Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unit</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Stockreturndatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewStockReturnHistory($event,row._id)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td>{{ row.StoreID }}</td><td>{{ row.Location }}\n</td><td>{{ row.ProductCategory }}</td><td>{{ row.ProductCode }}</td><td>{{ row.ProductName }}</td><td>\n{{ row.ReceivedQuantity }}</td><td><a href=\"\" ng-click=\"ReturnQuantityPopup($event,row._id, $index)\" \ntitle=\"Return Quantity\" style=\"border:none\">{{ row.ReturnedQuantity || 0 }}</a></td><td>{{ row.Unit }}</td></tr>\n</tbody></table></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n     #Datefilter md-datepicker .md-datepicker-input {\r\nwidth:0;\r\n}\r\n \r\n.datefilter> div > button >  div.md-datepicker-expand-triangle{\r\n   border-top-color: white !important;\r\n}\r\n#Datefilter md-datepicker .md-datepicker-input {\r\n  color: white !important;\r\n    border-bottom-color: white !important;\r\n}\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/return/returnquantity.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">RETURN QUANTITY</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Serial Number</label><md-select \nng-model=\"vm.SerialNumber\" ng-change=\"getQuantitydetails()\" ng-model-options=\"{trackBy: \'$value\'}\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"\"><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Serial #..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.SerialNumber=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-select-header><input type=\"checkbox\" \nstyle=\"width: 20px;height: 20px\" ng-model=\"vm.select\" ng-click=\"selectAll()\"> &nbsp; Select All/Unselect All\n</md-select-header><md-optgroup><md-option ng-value=\"row\" ng-repeat=\"row in SerialNoArray  | filter:vm.searchTerm1\">\n{{row}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.ReturnQuantity\" placeholder=\"Return Quantity\" required>\n</md-input-container><md-input-container style=\"margin-top: 18px;margin-left:-10px\" flex><label>Date of Return</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.ReturnQuantityDate\"></md-datepicker></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" style=\"width:100%;margin-top: -5px;margin-bottom: -35px\" ng-show=\"Alert\"><div \nstyle=\"width:50%;float:left\"></div><div layout=\"column\" style=\"width:50%;float:left\"><label style=\"color:red\"><b>\n{{AlreadyReturnedSNoProduct}} Product(s) already Returned.</b></label><br><br></div></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ReturnQuantityadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 175px !important;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/return/returnquantityhistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">STOCK RETURN HISTORY</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Reference No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Store Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returned Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returned Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in StockReturnHistorysummary\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ReferenceNo }}</td><td>{{ row.StoreID}}</td><td>{{ row.ReceivedQuantity }}</td><td>{{ row.ReturnedQuantity }}\n</td><td>{{ row.Unit }}</td><td>{{ row.ReturnQuantityDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button ng-click=\"cancel()\" \nclass=\"md-raised md-accent\">Close</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/EquipmentReturn/EquipmentAdd.html","<md-dialog style=\"width: 40%\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Requested Equipments</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div ng-show=\"ViewTable\" id=\"gridContainer\" dx-data-grid=\"dataGridOptions\"></div><div \nng-hide=\"ViewTable\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Equipment</label><md-select \nng-model=\"vm.Equipment\" id=\"Supplier\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm2\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for Equipment..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" \naria-label=\"Close dialog\" style=\"float: right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in EquipmentListName | filter:vm.searchTerm2\" \nng-click=\"getEquipmentSerialumber(row.EquipmentName)\" value=\"{{row.EquipmentName}}\">{{row.EquipmentName }}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Equipment Serial Number</label><md-select \nng-model=\"vm.dDescription\" ng-change=\"vm.Quantity = vm.dDescription.length\" id=\"Supplier1\" \nmd-on-close=\"clearSearchTerm()\" multiple=\"multiple\" required><md-select-header><input ng-model=\"vm.searchTerm3\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a Serial Number..\" ng-keydown=\"$event.stopPropagation()\">\n<md-button class=\"md-icon-button\" ng-click=\"SupplierClear()\" aria-label=\"Close dialog\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in EquipmentSeraildatas | filter:vm.searchTerm3\" ng-value=\"row\">{{row.Brand }} - {{row.SerialNumber }}\n</md-option></md-select></md-input-container></div><div ng-hide=\"ViewTable\" layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"Stock\" ng-model=\"vm.Stock\" placeholder=\"Current Stock\" \nreadonly=\"readonly\"></md-input-container><md-input-container flex><input type=\"number\" name=\"Quantity\" \nng-model=\"vm.Quantity\" placeholder=\"Selected Quantity\" readonly=\"readonly\"></md-input-container></div>\n</md-dialog-content></form><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\" \nstyle=\"margin-bottom: 15px\"><md-button ng-hide=\"ViewTable\" type=\"submit\" ng-click=\"saveEquipment()\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\">Submit</md-button><md-button type=\"submit\" \nng-click=\"cancel()\" class=\"md-raised\" translate=\"CRMCONTRACTSTEMPLATES.CANCEL\">Cancel</md-button></div></md-dialog>\n<style>.dx-icon-trash:before {\n        color: #8899a8 !important;\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/EquipmentReturn/EquipmentInfo.html","<md-dialog style=\"width: 100%; overflow: unset\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Equipment Details</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"padding: 0.5% 1% 0.5% 1%\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Details\n</span></md-tab-label><md-tab-body><div layout=\"column\"><div layout=\"column\" layout-gt-xs=\"column\"><div \nclass=\"content-card\" style=\"width: 100%; height: auto; padding: 1% 1% 0 1%\"><div class=\"white-bg md-whiteframe-4dp\" \nstyle=\"width: 100%;\n                      border: 1px solid rgb(224, 224, 224);\n                      float: left\"><div\n layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width: 13%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nInventory Code</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.Code}}</span>\n</div><div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nProduct Name</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px; color: #7f9593\">\n&nbsp;{{vm.EquipmentName}}</span></div><div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nManufacturer</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.Manufacturer}}\n</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" layout-align=\"start start\"><div class=\"p-4\" style=\"width: 13%\">\n<label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nSerial Number</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.SerialNumber}}\n</span></div><div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nBrand</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.Brand}}</span></div>\n<div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nPurchased Date</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">\n&nbsp;{{vm.PurchasedDate | date :\"dd/MM/yyyy\"}}</span></div></div><div layout-gt-sm=\"row\" class=\"p-8\" \nlayout-align=\"start start\"><div class=\"p-4\" style=\"width: 13%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nLocation</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.Location}}</span>\n</div><div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\nRemarks</label></div>:<div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;{{vm.Remarks}}</span>\n</div><div class=\"p-4\" style=\"width: 10%\"><label \nstyle=\"font-size: 15px;\n                            font-weight: bold;\n                            color: #7f9593\">\n</label></div><div class=\"p-4\" style=\"width: 25%\"><span style=\"font-size: 14px\">&nbsp;</span></div></div></div></div>\n<form name=\"wizardStep2\" ms-form-wizard-form novalidate style=\"padding-bottom: 0px\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><span style=\"color: #617d7b\"><b>Record Log</b></span></md-input-container>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Equipment Given On</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Technician Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Technician Contact</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Recorddetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Date | date:\'dd/MM/y\'}}\n</td><td>{{ row.TechnicianName }}</td><td>{{ row.TechnicianContact }}</td></tr></tbody></table></form><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate style=\"padding-bottom: 0px\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><span style=\"color: #617d7b\"><b>Equipment Maintenance Log</b></span></md-input-container>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions2\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serviced Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serviced For</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Uploaded Documents</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ServiceLogdetails\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.ServiceDate | date:\'dd/MM/y\' }}</td><td>{{ row.ServiceFor }}</td><td>{{ row.Remarks }}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Equipment/Service/{{row.GUID}}\" download style=\"cursor: pointer\">\n{{ row.UploadDocument }}</a></td></tr></tbody></table></form></div></div></md-tab-body></md-tab></md-tabs>\n</md-dialog-content></form></md-dialog><style>\nimg {\n        cursor: -webkit-zoom-in;\n        cursor: -moz-zoom-in;\n    }</style><style>\n#viewedit.md-button {\n        margin: -16px 8px;\n    }\n\n    md-datepicker .md-datepicker-input {\n        width: calc(25vw - 35px);\n        max-width: calc(35vw - 54px);\n    }\n\n    /* .md-datepicker-button {\n    display: none;\n  } */\n\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\n        right: 74px;\n    }\n\n    .md-default-theme.md-hue-1 .md-datepicker-input,\n    .md-hue-1 .md-datepicker-input {\n        background: none !important;\n    }\n\n    /* md-dialog md-dialog-content {\n    padding: 0;\n  } */\n</style><style>\n.chipsdemoContactChips md-content.autocomplete {\n        min-height: 250px;\n    }\n\n    .chipsdemoContactChips md-content.autocomplete input {\n        min-width: 400px;\n    }\n\n    .chipsdemoContactChips .md-item-text.compact {\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n    .chipsdemoContactChips .contact-item {\n        box-sizing: border-box;\n    }\n\n    .chipsdemoContactChips .contact-item.selected {\n        opacity: 0.5;\n    }\n\n    .chipsdemoContactChips .contact-item.selected h3 {\n        opacity: 0.5;\n    }\n\n    .chipsdemoContactChips .contact-item .md-list-item-text {\n        padding: 14px 0;\n        max-width: 190px;\n    }\n\n    .chipsdemoContactChips .contact-item .md-list-item-text h3 {\n        margin: 0 !important;\n        padding: 0;\n        line-height: 1.2em !important;\n    }\n\n    .chipsdemoContactChips .contact-item .md-list-item-text h3,\n    .chipsdemoContactChips .contact-item .md-list-item-text p {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    @media (min-width: 960px) {\n        .chipsdemoContactChips .contact-item {\n            float: left;\n            width: 33%;\n        }\n    }\n\n    .chipsdemoContactChips md-contact-chips {\n        margin-bottom: 10px;\n    }\n\n    .chipsdemoContactChips .md-chips {\n        padding: 5px 0 8px;\n    }\n\n    .chipsdemoContactChips .fixedRows {\n        height: 250px;\n        overflow: hidden;\n    }\n\n    .file-input {\n        display: none !important;\n    }\n\n    #attachmenthref label:hover {\n        cursor: pointer !important;\n        color: #23527c !important;\n    }\n\n    #Datefilter md-datepicker .md-datepicker-input {\n        width: 0;\n    }\n\n    /* .datefilter>div>button>div.md-datepicker-expand-triangle {\n    border-top-color: white !important;\n  } */\n\n    /* #Datefilter md-datepicker .md-datepicker-input {\n    color: white !important;\n    border-bottom-color: white !important;\n  } */\n\n    #workflow .dataTables_wrapper .bottom {\n        display: none;\n    }\n\n    #tb2 {\n        counter-reset: serial-number;\n        /* Set the serial number counter to 0 */\n    }\n\n    #tb2 td:first-child:before {\n        counter-increment: serial-number;\n        /* Increment the serial number counter */\n        content: counter(serial-number);\n        /* Display the counter */\n    }\n\n    .dataTables_wrapper .bottom {\n        display: none;\n    }\n\n    .CBCustomer {\n        margin: 0 !important;\n    }\n\n    md-checkbox #chkboxhide .md-icon {\n        box-sizing: border-box;\n        -webkit-transition: 240ms;\n        transition: 240ms;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 20px;\n        height: 20px;\n        border-width: 0px;\n        border-radius: 2px;\n    }\n\n    md-checkbox.md-default-theme[disabled]:not(.md-checked) .md-icon,\n    md-checkbox[disabled]:not(.md-checked) .md-icon {\n        border-color: rgba(0, 0, 0, 0);\n    }\n\n    /* md-dialog {\n    opacity: 0;\n    min-width: 240px;\n    max-width: 95%;\n    max-height: 95%;\n  } */\n\n    @import \"compass/css3\";\n\n    .star-rating {\n        margin: 0;\n        padding: 0;\n        display: inline-block;\n    }\n\n    .star {\n        padding: 1px;\n        color: #ddd;\n        font-size: 20px;\n        text-shadow: 0.05em 0.05em #aaa;\n        list-style-type: none;\n        display: inline-block;\n        cursor: pointer;\n    }\n\n    .filled {\n        color: #fd0;\n    }\n\n    .readonly .star.filled {\n        color: #666;\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/EquipmentReturn/EquipmentReturn.html","<div id=\"time\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box\"></md-icon><span>Technician Inventory</span></div><div \nclass=\"product-count secondary-text\"><span>Total Equipments:</span> <span>{{Equipmentdatas.length}}</span></div></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"sAdd\" ng-click=\"AddEquipment()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"sExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button><md-button class=\"md-raised reference-button\" ng-click=\"Showgrid()\" ng-show=\"sView\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Storegrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Equipmentdatas\" \nmd-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><div id=\"gridContainer\" dx-data-grid=\"vm.dataGridOptions\">\n</div></div></div><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Equipmentform\" flex><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex><label>Team\n</label><md-select ng-model=\"vm.AssignedTo\" id=\"searchmodule\" md-on-close=\"vm.searchAssigned = \'\'\" required>\n<md-select-header><input ng-model=\"vm.searchAssigned\" type=\"text\" placeholder=\"Search For a Team..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.AssignedTo = null;vm.searchAssigned = null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in teamdatas | filter:vm.searchAssigned\" value=\"{{row.id}}\" \nng-click=\"getEmployeedetails(row.EmployeeID)\">{{row.TeamName}}</md-option></md-select></md-input-container>\n<md-input-container flex><input style=\"border-radius:3px;padding-left:5px\" type=\"text\" name=\"ContactNumber\" \nreadonly=\"readOnly\" ng-model=\"vm.ContactNumber\" placeholder=\"Contact Number\"></md-input-container><md-input-container>\n<label style=\"font-size: 14px\">Requested Date</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"vm.RequestedDate\"></md-datepicker></md-input-container></div><br><div><h3><b>Equipments</b></h3></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex style=\"padding:2px 2px 2px 2px\"><md-button style=\"margin-left:90%;width:5%;margin-top:-45px\" \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"AddRecord($event)\">Add\n</md-button><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Product Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Equipment Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Manufacturer</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in EquipmentItemdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Code }}</td><td>{{ row.EquipmentName }}</td><td>\n{{ row.Manufacturer }}</td><td>{{ row.SerialNumber }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\" Equipmentdelete($index)\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" aria-label=\"Submit\" ng-click=\"fsubmit();\" \nng-disabled=\"EquipmentItemdatas.length==0 && !vm.AssignedTo\">Submit</md-button><md-button ng-click=\"Showgrid()\" \nclass=\"md-raised\">Cancel</md-button></div></form></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(28vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon>label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html,\r\n    .ta-scroll-window.form-control,\r\n    .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:before,\r\n    .ms-form-wizard md-tabs md-tabs-wrapper md-tabs-canvas md-pagination-wrapper md-tab-item:after {\r\n        content: \'\';\r\n        display: none;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 0;\r\n        right: 50%;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n        z-index: 8;\r\n    }\n</style>");
$templateCache.put("app/main/apps/procurement/stock/EquipmentReturn/ServicePop.html","<md-dialog style=\"width: 800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.Title}}</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-show=\"Service\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -20px\"><md-input-container><label>\nServiced Date</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" ng-model=\"vm.SDate\"></md-datepicker>\n</md-input-container><md-input-container flex><input type=\"text\" name=\"Contact\" ng-model=\"vm.ServicedFor\" \nplaceholder=\"Serviced For\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -20px\"><md-input-container flex><div layout=\"row\" flex \nstyle=\"margin-top: -20px; margin-bottom: -30px\"><input id=\"fileInput1\" type=\"file\" class=\"ng-hide\" \nonchange=\"angular.element(this).scope().BindAttach(\'fileInput1\')\"><md-input-container flex class=\"md-block\"><input \ntype=\"text\" ng-model=\"vm.FileName1\" readonly=\"readonly\" placeholder=\"File Name\"></md-input-container><div><md-button \nng-click=\"AGUpload(\'fileInput1\')\" class=\"md-raised\">Upload</md-button></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\">\n</md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ServiceSubmit()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></div></md-dialog-content></form></md-dialog><style>\nmd-datepicker .md-datepicker-input {\n        width: calc(15vw - 35px);\n        max-width: calc(35vw - 54px);\n    }\n</style>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title Description</label><input \nname=\"title\" ng-model=\"vm.task.Title\" required md-autofocus><div ng-messages=\"taskForm.title.$error\" \nng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">\nTitle field is required</span></div></div></md-input-container><div class=\"assignedto\" ng-show=\"vm.show\">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"PassNumber\" ng-model=\"vm.task.AssignedTo\" \nplaceholder=\"Assigned To\" readonly=\"readonly\"></md-input-container></div><div class=\"assignedto\" ng-show=\"vm.show1\">\n<md-input-container class=\"md-block\"><md-select ng-model=\"vm.task.AssignedTo\" placeholder=\"Assigned To\" \nng-model-options=\"{trackBy: \'$value.EmployeeName\'}\" md-on-close=\"clearSearchTerm()\" multiple=\"\" required><md-optgroup>\n<md-option ng-value=\"row\" ng-repeat=\"row in Employeedatas\">{{row.EmployeeName}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><div flex class=\"date-container\"><label \ntranslate=\"TODO.START_DATE\">Start Date</label><md-datepicker onkeydown=\"return false\" flex \nng-model=\"vm.task.StartDate\" md-placeholder=\"Start Date\"></md-datepicker></div><div flex class=\"date-container\"><label \ntranslate=\"TODO.DUE_DATE\">Due Date</label><md-datepicker onkeydown=\"return false\" flex ng-model=\"vm.task.DueDate\" \nmd-placeholder=\"Due Date\"></md-datepicker></div></div><div class=\"notes\"><label translate=\"TODO.NOTES\">Notes</label>\n<text-angular ng-model=\"vm.task.Notes\"></text-angular></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"TODO.SAVE\" translate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div></div><md-content class=\"content\" flex \nms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.openTaskDialog($event)\" \naria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" translate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div>\n<div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.ALL_TASKS\">All Tasks</span></div></md-button><div class=\"item subheader\" \ntranslate=\"TODO.FILTERS\">Filters</div><md-button class=\"item\" aria-label=\"Starred\" translate \ntranslate-attr-aria-label=\"TODO.STARRED\" ng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" \nng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button><md-button class=\"item\" aria-label=\"Priority\" \ntranslate translate-attr-aria-label=\"TODO.PRIORITY\" ng-click=\"vm.toggleFilterWithEmpty(\'important\')\" \nng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.PRIORITY\">Priority</span></md-button><md-button class=\"item\" aria-label=\"Done\" translate \ntranslate-attr-aria-label=\"TODO.DONE\" ng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" \nng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.DONE\">Done</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/procurement/stock/stocklist/manualadd.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">MANUAL STOCK ADD FORM</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"margin-top: 18px\" flex>\n<label>Store</label><md-select ng-model=\"vm.mStore\" id=\"Store\" md-on-close=\"clearSearchTerm()\" required>\n<md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for a store..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"vm.mStore=null\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm1\" value=\"{{row.StoreName}}\">\n{{row.StoreName}}</md-option></md-select></md-input-container><md-input-container flex><label>Product Category</label>\n<md-select ng-model=\"vm.mProductCategory\" ng-change=\"ProductNamedetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a category..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.mProductCategory=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in ProductCategorydatas | filter:vm.searchTerm2\" value=\"{{row.CategoryName}}\">{{row.CategoryName}}\n</md-option></md-select><div ng-messages=\"eventForm.ProductCategory .$error\" \nng-show=\"eventForm.ProductCategory .$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nProduct Category is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Product Name</label><md-select ng-model=\"vm.mProductName\" \nng-change=\"ProductCodedetails()\" id=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input \nng-model=\"vm.searchTerm3\" style=\"flex: auto\" type=\"text\" placeholder=\"Search for product name..\" \nng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" ng-click=\"ProductNameClear()\" \naria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</md-select-header><md-option ng-repeat=\"row in Categorydatas | filter:vm.searchTerm3\" value=\"{{row.ProductName}}\">\n{{row.ProductName}}</md-option></md-select><div ng-messages=\"eventForm.mProductName .$error\" \nng-show=\"eventForm.mProductName .$touched\" role=\"alert\"><div ng-message=\"required\"><span>Product Name is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"ProductCode\" \nng-model=\"vm.mProductCode\" placeholder=\"Product Code\" required><div ng-messages=\"eventForm.ProductCode.$error\" \nng-show=\"eventForm.ProductCode.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Product Code is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -20px\">\n<md-input-container flex><input type=\"text\" name=\"SerialNumber\" ng-model=\"vm.mSerialNumber\" ng-change=\"getQuantity()\" \nplaceholder=\"Serial Number\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width:100%;margin-top: -35px;margin-bottom: -35px\" ng-show=\"ShowAlert\"><div layout=\"column\"><label \nstyle=\"color:red\"><b>{{ExistingSerialNoList}} Serial Number(s) are already Exist.</b></label><br><br></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -20px\"><md-input-container flex><input type=\"number\" \nname=\"Quantity\" ng-model=\"vm.mQuantity\" placeholder=\"Quantity\" required><div ng-messages=\"eventForm.Quantity.$error\" \nng-show=\"eventForm.Quantity.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Quantity is required.</span></div>\n</div></md-input-container><md-input-container flex><label>Unit</label><md-select ng-model=\"vm.mUnit\" \nid=\"searchmodule\" md-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm4\" \nstyle=\"flex: auto\" type=\"text\" placeholder=\"Search for a category..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.mUnit=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Unitdatas | filter:vm.searchTerm4\" value=\"{{row.UnitName}}\">{{row.UnitName}}</md-option></md-select>\n<div ng-messages=\"eventForm.Unit.$error\" ng-show=\"eventForm.Unit.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Unit is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: -20px\"><md-input-container flex><input type=\"text\" name=\"Model\" ng-model=\"vm.mModel\" \nplaceholder=\"Model\"></md-input-container><md-input-container flex><input type=\"text\" name=\"Description\" \nng-model=\"vm.mDescription\" placeholder=\"Description\"><div ng-messages=\"eventForm.Description.$error\" \nng-show=\"eventForm.Description.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Description is required.</span>\n</div></div></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\">\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"ManualSubmit()\" aria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">Cancel</md-button></div></md-dialog-content></form></md-dialog><style>\n.ms-scroll {\r\n        position: relative;\r\n    }</style>");
$templateCache.put("app/main/apps/procurement/stock/stocklist/reorder.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">REORDER QUANTITY LEVEL</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"number\" \nng-model=\"vm.ReorderQuantity\" placeholder=\"Reorder Quantity\" required></md-input-container><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Unit\" placeholder=\"Unit\" readonly=\"readonly\"></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"ReorderSubmit()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/stocklist/stockhistory.html","<md-dialog style=\"width:1500px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TRANSACTION HISTORY</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"white-bg md-whiteframe-4dp\" style=\"margin-top:-40px\"><h2 \nstyle=\"text-align:left\">&nbsp;STOCK DETAILS</h2><hr>&emsp;<label style=\"font-size:17px;color:#7f9593\">Product Category\n</label>&nbsp;:&nbsp;<label style=\"font-size:17px\">{{ProductCategory}}</label>&emsp;<label \nstyle=\"font-size:17px;color:#7f9593\">Product Code</label>&nbsp;:&nbsp;<label style=\"font-size:17px\">{{ProductCode}}\n</label>&emsp;<label style=\"font-size:17px;color:#7f9593\">Product Name</label>&nbsp;:&nbsp;<label \nstyle=\"font-size:17px\">{{ProductName}}</label>&emsp;<label style=\"font-size:17px;color:#7f9593\">Model Number</label>\n&nbsp;:&nbsp;<label style=\"font-size:17px\">{{Model}}</label><br><br>&emsp;<label \nstyle=\"font-size:17px;color:#7f9593;color:green\">Current Stock</label>&nbsp;:&nbsp;<label style=\"font-size:17px\"><label\n style=\"color:green\">{{TotalQuantity}}</label></label>&emsp;<label style=\"font-size:17px;color:#7f9593\">\n[Total Purchased</label>&nbsp;:&nbsp;<label style=\"font-size:17px\">{{TotalPurchased}}</label>&emsp;<label \nstyle=\"font-size:17px;color:#7f9593\">Total Issued</label>&nbsp;:&nbsp;<label style=\"font-size:17px\">{{TotalIssued}}\n</label>&emsp;<label style=\"font-size:17px;color:#7f9593\">Total Returned</label>&nbsp;:&nbsp;<label \nstyle=\"font-size:17px\">{{TotalReturned}}</label>\n&emsp; Between &nbsp; {{model.uFromDate| date:\'dd/MM/y\' }}&nbsp; and &nbsp;{{model.uToDate| date:\'dd/MM/y\'}}]<br><br>\n</div><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><div ng-click=\"DateFilterPurchaseHistoryDetails()\">\n<md-tab-label><span>PURCHASE HISTORY</span></md-tab-label></div><md-tab-body><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: 10px\"><md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">From\n</label><md-datepicker class=\"datefilter\" ng-model=\"model.uFromDate\"></md-datepicker></md-input-container>\n<md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">To</label><md-datepicker \nclass=\"datefilter\" ng-model=\"model.uToDate\"></md-datepicker></md-input-container><md-button id=\"button\" \nclass=\"md-raised md-background\" ng-click=\"DateFilterPurchaseHistoryDetails()\"><span>Search</span></md-button><md-button\n id=\"button\" class=\"md-raised md-background\" style=\"margin-left:50px\" ng-click=\"PurchaseHistoryExport()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div><p><b>\nNote: Traceable items with serial number always counted as 1 quantity. Therefore ordered/received quantity will not be shown. Example: Sensors and other Assets.\n</b></p><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th ng-hide=\"row.ReferenceNo == \'Manual\'\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PO Number</span></div></th><th \nng-hide=\"row.ReferenceNo != \'Manual\'\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nPO Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">DO Number</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serial Number</span></div>\n</th><th ng-show=\"row.OrderedQuantity != 0\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ordered Quantity</span></div></th><th ng-show=\"row.OrderedQuantity == 0\" class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Ordered Quantity</span></div></th><th \nng-show=\"row.SerialNumber == \'\'\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nReceived Quantity</span></div></th><th ng-show=\"row.SerialNumber != \'\'\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Unit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received By</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in PurchaseHistorydatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td \nng-hide=\"row.ReferenceNo == \'Manual\'\"><a href=\"\" ng-click=\"GoPO(row._id)\" title=\"Detail Grid\" style=\"border:none\">\n{{ row.ReferenceNo }}</a></td><td ng-hide=\"row.ReferenceNo != \'Manual\'\">{{ row.ReferenceNo }}</td><td>\n{{ row.StoreName}}</td><td>{{ row.DONumber }}</td><td>{{ row.SerialNumber }}</td><td \nng-show=\"row.OrderedQuantity != 0\">{{ row.OrderedQuantity }}</td><td ng-show=\"row.OrderedQuantity == 0\"></td><td \nng-show=\"row.SerialNumber == \'\'\">{{ row.ReceivedQuantity }}</td><td ng-show=\"row.SerialNumber != \'\'\"></td><td>\n{{ row.Unit }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.ReceivedDate | date:\'dd/MM/y\' }}</td></tr></tbody></table>\n</md-tab-body></md-tab><md-tab><div ng-click=\"DateFilterIssuanceHistoryDetails()\"><md-tab-label><span>ISSUANCE HISTORY\n</span></md-tab-label></div><md-tab-body><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: 10px\">\n<md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">From</label><md-datepicker \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"model.uFromDate\"></md-datepicker></md-input-container>\n<md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">To</label><md-datepicker \nmd-min-date=\"minDate\" class=\"datefilter\" ng-model=\"model.uToDate\"></md-datepicker></md-input-container><md-button \nid=\"button\" class=\"md-raised md-background\" ng-click=\"DateFilterIssuanceHistoryDetails()\"><span>Search</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" style=\"margin-left:50px\" \nng-click=\"IssuaneHistoryExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Reference No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Store</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued To</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Issued Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Returnable</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in IssuanceHistorydatas\" ng-class=\"{ \'text-success\': getIssuanceHistoryRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }}</td><td>{{ row.StoreID }}</td><td>\n{{ row.IssueTo }}</td><td>{{ row.SerialNumber }}</td><td>{{ row.Quantity }}</td><td>\n{{ row.IssuedDate| date:\'dd/MM/y\' }}</td><td>{{ row.ProductType }}</td><td>{{ row.ReturnDate| date:\'dd/MM/y\' }}</td>\n</tr></tbody></table></md-tab-body></md-tab><md-tab><div ng-click=\"DateFilterReturnHistoryDetails()\"><md-tab-label>\n<span>RETURN HISTORY</span></md-tab-label></div><md-tab-body><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: 10px\"><md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">From\n</label><md-datepicker md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"model.uFromDate\"></md-datepicker>\n</md-input-container><md-input-container flex=\"1\" id=\"Datefilter\"><label style=\"color:green;font-size: 14px\">To</label>\n<md-datepicker md-min-date=\"minDate\" class=\"datefilter\" ng-model=\"model.uToDate\"></md-datepicker></md-input-container>\n<md-button id=\"button\" class=\"md-raised md-background\" ng-click=\"DateFilterReturnHistoryDetails()\"><span>Search</span>\n</md-button><md-button id=\"button\" class=\"md-raised md-background\" style=\"margin-left:50px\" \nng-click=\"ReturnHistoryExport()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions1\"><thead><tr><th \nclass=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Reference No.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Store</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Quantity</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Received Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expected Return Date</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ReturnHistorydatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.ReferenceNo }}</td>\n<td>{{ row.StoreID }}</td><td>{{ row.SerialNumber }}</td><td>{{ row.ReturnedQuantity }}</td><td>\n{{ row.ReturnQuantityDate| date:\'dd/MM/y\' }}</td><td>{{ row.ReturnDate| date:\'dd/MM/y\' }}</td></tr></tbody></table>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"cancel()\" class=\"md-raised md-accent\">Close</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/procurement/stock/stocklist/stocklist.html","<div id=\"stocklist\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ng-cloak><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Stock List</span></div>\n<div><span>Total Stocks:</span> <span>{{Goodsuniquedatas.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: -15px\" flex><input id=\"Stocksearch\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search..\" flex></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-top: 18px\" flex><md-input-container flex=\"50\" id=\"Storefilter\" style=\"margin-top:3px\"><label \nstyle=\"color:white;font-size: 14px\">Store</label><md-select class=\"Storefilter\" ng-model=\"Store\" \nng-change=\"StoreFilter()\"><md-select-header><input ng-model=\"vm.searchTerm\" style=\"flex: auto\" type=\"text\" \nplaceholder=\"Search for a store..\" ng-keydown=\"$event.stopPropagation()\"><md-button class=\"md-icon-button\" \nng-click=\"Store=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></md-select-header><md-option ng-repeat=\"row in Storedatas | filter:vm.searchTerm\" \nvalue=\"{{row.StoreName}}\">{{row.StoreName}}</md-option></md-select></md-input-container></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"ManualaddPopup($event)\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>\nAdd</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"AllowExport==\'true\'\" ng-click=\"Export()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\"><div\n class=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Goodsuniquedatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Store Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Code</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Product Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Minimum Order</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total on Hold</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Stock</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Unit</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"row in Goodsuniquedatas\" ng-class=\"{ \'text-danger\': getRowColour(row) === true }\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.StoreName }}</td><td><a href=\"\" \nng-click=\"ViewStockHistory($event,row._id)\" title=\"Purchase History\" style=\"border:none\">{{ row.ProductCode }}</a></td>\n<td>{{ row.Productdetails[0].Category}}</td><td>{{ row.Productdetails[0].ProductName }}</td><td><a href=\"\" \nng-click=\"ReOrderedQuantityPopup($event,row._id, $index)\" title=\"Reorder Quantity\" style=\"border:none\">\n{{ row.ReorderQuantity ||0 }}</a></td><td>{{ DisplayOnHold(row.OnHold) ||0 }}</td><td>\n{{ShowTotalStock(row.TotalQuantity)||0 }}</td><td>{{ row.Unit }}</td></tr></tbody></table></div></div></div></div>\n<style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    .file-inputs {\r\n        display: none !important;\r\n    }\r\n\r\n    button.md-default-theme.md-accent.md-raised,\r\n    .md-button.md-accent.md-raised {\r\n        margin-bottom: 40px !important;\r\n    }\r\n\r\n    .secondary-text {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    td.dataTables_empty {\r\n        height: 30px !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .md-tab.md-active {\r\n        background-color: #9E9E9E;\r\n    }\r\n\r\n    button#button {\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style><style>\n/* md-datepicker .md-datepicker-input {\r\n        width: calc(23vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    } */\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0, 0, 0, 0.87);\r\n        background: none;\r\n    }\r\n\r\n    .hidden {\r\n        display: none !important;\r\n        visibility: hidden !important;\r\n    }\r\n\r\n\r\n    .group-title {\r\n        background-color: #687074 !important;\r\n        color: #FFF !important;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-1 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-1 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-1 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-hue-2 .md-datepicker-input-container.md-datepicker-invalid,\r\n    .md-warn .md-default-theme.md-hue-2 .md-datepicker-input-container.md-datepicker-focused,\r\n    .md-warn .md-hue-2 .md-datepicker-input-container.md-datepicker-focused {\r\n        border-bottom-color: rgba(0, 0, 0, 0.14);\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 1;\r\n    }\r\n\r\n    #pdate md-datepicker .md-datepicker-input {\r\n        width: calc(23vw - 35px);\r\n        max-width: calc(35vw - 54px);\r\n    }\r\n\r\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n        border-top-color: green !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\r\n\r\n    #Supplierfilter md-select .md-select-value {\r\n        color: green !important;\r\n        border-bottom-color: red !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" \nng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" \nng-repeat=\"task in vm.tasks |  filter:global.search | filter:vm.taskFilters.search | filter:{\'completed\': vm.taskFilters.completed} \r\n\r\n         | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index\" \nng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div>\n<md-checkbox class=\"no-label\" ng-checked=\"task.completed\" ng-click=\"vm.toggleCompleted(task, $event)\" \naria-label=\"{{task.completed ? \'Not completed\' : \'completed\'}}\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\">{{task.Title}}</div><div ta-bind \nng-model=\"task.Notes\"></div><div class=\"assignedto\">{{task.Assignedto}}</div></div><div class=\"buttons\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" \nng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"is-starred amber-600-fg\" \nng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"MarkasDone(task, $event)\" \naria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon \nng-class=\"task.completed === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\">\n</md-icon><span ng-show=\"!task.completed\" translate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span \nng-show=\"task.completed\" translate=\"TODO.MARK_AS_UNDONE\">Mark as undone</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"MarkasImportant(task, $event)\" aria-label=\"Toggle important\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon \nng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon>\n<span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span \nng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"MarkasStar(task, $event)\" aria-label=\"Toggle star\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_STAR\"><md-icon ng-class=\"task.starred === false ? \'grey-fg\' : \'amber-600-fg\'\" \nmd-font-icon=\"icon-star\" class=\"s18\"></md-icon><span ng-show=\"!task.starred\" translate=\"TODO.ADD_STAR\">Add star</span> \n<span ng-show=\"task.starred\" translate=\"TODO.REMOVE_STAR\">Remove star</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/pages/form/views/exit/exit.html","<div id=\"exit\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"invoice-container\"><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton\" ng-click=\"EIBack()\" style=\"float: left\"><span>Back</span></md-button>\n<md-button class=\"print md-accent-bg\" id=\"printpagebutton1\" ng-disabled=\"!_id\" ng-click=\"printToCart(\'certification\')\" \nstyle=\"float: right\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span>Print</span></md-button><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton2\" ng-click=\"EISave()\" style=\"float: right\"><span>Submit</span>\n</md-button><div class=\"card md-whiteframe-8dp\"><div class=\"content\"><md-input-container style=\"width:20%\"><label>\nSelect Template</label><md-select ng-model=\"uEmployeeID\" id=\"searchmodule\"><md-option \nng-click=\"SelectTemplate(row.id)\" ng-repeat=\"row in templatedatas\" value=\"{{row.id}}\">{{row.TemplateName}}</md-option>\n</md-select></md-input-container><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>EXIT INTERVIEW</b>\n</div><br><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" class=\"pb-32\"></text-angular><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height:50px\">\n<label style=\"width:150px\">Employee Name :</label>&emsp;<md-input-container flex=\"25\"><span \nstyle=\"text-align:center;font-size:18px;color:black;font-weight:bold;color:#7f9593\">{{EmployeeName}}</span>\n</md-input-container>&emsp;&emsp;<label style=\"width:150px\">Termination Date :</label>&emsp;<md-input-container \nflex=\"25\" style=\"margin-top: 18px\"><span \nstyle=\"text-align:center;font-size:16px;color:black;font-weight:bold;color:#7f9593\">\n{{RuResignationofDate | date:\'dd/MM/y\'}}</span></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\"><label style=\"width:150px\">\nJob Title :</label>&emsp;<md-input-container flex=\"25\"><span \nstyle=\"text-align:center;font-size:16px;color:black;font-weight:bold;color:#7f9593\">{{vm.EuJobCategory}}</span>\n</md-input-container>&emsp;&emsp;<label style=\"width:150px\">Eligible for Rehire :</label>&emsp;&nbsp;&nbsp;\n<md-radio-group ng-model=\"Rehire\" layout=\"row\"><md-radio-button value=\"Yes\">Yes</md-radio-button><md-radio-button \nvalue=\"No\">No</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\"><label style=\"width:200px\">Reason for Resignation :</label>\n<md-input-container flex=\"25\"><span \nstyle=\"text-align:center;font-size:16px;color:black;font-weight:bold;color:#7f9593\">{{RuReason}}</span>\n</md-input-container></div><br><h3 style=\"font-weight: 600\">Employee Comments:</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EmployeeComment\"></text-angular><h3 style=\"font-weight: 600\">Interviewer Comments:\n</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"InterviewerComment\"></text-angular><br><div \nstyle=\"font-size:17px;height: 80px;padding-top:5%\"><div style=\"font-size:17px;float:left\"><label \nstyle=\"font-weight: 600\">Interviewer\'s Signature</label></div><div style=\"font-size:17px;float:right\"><label \nstyle=\"font-weight: 600\">Employee\'s Signature</label></div></div><br><br><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>Exit Interview</b></div><br><div \nstyle=\"text-align:center;font-size:20px;font-weight:500\"><b>Questionnaire</b></div><div \nstyle=\"text-align:justify;font-size:17px\"><h3 style=\"font-weight: 600\">1. What are your primary reasons for leaving?\n</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"EI1\"></text-angular><h3 style=\"font-weight: 600\">\n2. What did you find most satisfying about your job?</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"EI2\">\n</text-angular><h3 style=\"font-weight: 600\">3. What did you find most frustrating about your job?</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EI3\"></text-angular><h3 style=\"font-weight: 600\">\n4. Would you consider returning to this company in the future?</h3><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"EI4\"></text-angular><h3 style=\"font-weight: 600\">\n5. Is there anything the company could have done to prevent you from leaving?</h3><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EI5\" class=\"pb-32\"></text-angular></div></div></div><div style=\"padding-left:40%\">\n<md-button class=\"md-accent-bg\" id=\"printpagebutton3\" ng-click=\"EIBack()\"><span>Back</span></md-button><md-button \nclass=\"md-accent-bg\" id=\"printpagebutton4\" ng-click=\"EISave()\"><span>Submit</span></md-button><md-button \nclass=\"md-raised\" id=\"printpagebutton5\" ng-click=\"SaveasTemplate($event)\" style=\"float:right\"><span>Save as Template\n</span></md-button></div></div></div><div class=\"content\" id=\"certification\" ng-show=\"Previewdiv\"><div \nclass=\"invoice-container\"><div class=\"card md-whiteframe-8dp\"><div class=\"content\"><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>EXIT INTERVIEW</b></div><br><table \nstyle=\"width:100%;border-collapse: collapse;text-align:left\"><thead><tr style=\"height: 35px\"><th \nstyle=\"border-collapse: collapse;width:25%\">Employee Name :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{EmployeeName}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">Termination Date :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{RuResignationofDate | date:\'dd/MM/y\'}}</th></tr><tr \nstyle=\"height: 35px\"><th style=\"border-collapse: collapse;width:25%\">Job Title :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{vm.EuJobCategory}}</th><th \nstyle=\"border-collapse: collapse;width:25%\">Eligible for Rehire :</th><th \nstyle=\"border-collapse: collapse;width:25%;font-weight:normal\">{{Rehire}}</th></tr><tr style=\"height: 35px\"><th \nstyle=\"border-collapse: collapse;width:30%\">Reason for Resignation :</th><th \nstyle=\"border-collapse: collapse;width:30%;font-weight:normal\">{{RuReason}}</th></tr></thead><tbody></tbody><tfoot>\n</tfoot></table><br><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Header\" class=\"pb-32\">\n</text-angular></div><h3 style=\"font-weight: 600\">Employee Comments:</h3><div class=\"printtextarea\"><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EmployeeComment\"></text-angular></div><h3 style=\"font-weight: 600\">\nInterviewer Comments:</h3><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" \nng-model=\"InterviewerComment\"></text-angular></div><br><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 60px\"><label \nstyle=\"width:190px;padding-bottom: 20px;font-weight: 600\">Interviewer\'s Signature</label>&emsp;</div><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">\n<label style=\"width:190px;font-weight: 600\">Employee\'s Signature</label></div><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>Exit Interview</b></div><br><div \nstyle=\"text-align:center;font-size:20px;font-weight:500\"><b>Questionnaire</b></div><div \nstyle=\"text-align:justify;font-size:17px\"><h3 style=\"font-weight: 600\">1. What are your primary reasons for leaving?\n</h3><div class=\"printtextarea\"><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"EI1\"></text-angular></div><h3 \nstyle=\"font-weight: 600\">2. What did you find most satisfying about your job?</h3><div class=\"printtextarea\">\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"EI2\"></text-angular></div><h3 style=\"font-weight: 600\">\n3. What did you find most frustrating about your job?</h3><div class=\"printtextarea\"><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EI3\"></text-angular></div><h3 style=\"font-weight: 600\">\n4. Would you consider returning to this company in the future?</h3><div class=\"printtextarea\"><text-angular \nta-toolbar=\"vm.taToolbar\" ng-model=\"EI4\"></text-angular></div><h3 style=\"font-weight: 600\">\n5. Is there anything the company could have done to prevent you from leaving?</h3><div class=\"printtextarea\">\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"EI5\" class=\"pb-32\"></text-angular></div></div></div></div></div>\n</div><style>\n#invoice .invoice-container {\r\n        padding-top: 15px;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 120px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n     .md-datepicker-input {\r\n        min-width: 250px !important;\r\n    }\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n     }\r\n\r\n     .md-datepicker-button {\r\n        display: none;\r\n    }\r\n     textarea{\r\n    width: 85%;\r\n    height: 100px;\r\n    padding: 30px 20px;\r\n    resize: none;\r\n    font-size:17px;\r\n}\r\n     /*#invoice .invoice-container .card {\r\n        padding-top: 40px !important;\r\n    }*/\n</style>");
$templateCache.put("app/main/pages/form/views/exit/temppopup.html","<md-dialog style=\"width:40%\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Template</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-actions flex><form name=\"basicForm\" \nclass=\"md-inline-form\" flex novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input \ntype=\"text\" ng-model=\"vm.TemplateName\" placeholder=\"Template Name\" required><p ng-show=\"error1\" style=\"color:red\">\nTemplate Name Is already Exist.</p></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"SaveasTemplatesubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Submit</md-button><md-button \ntype=\"submit\" ng-click=\"cancel()\" class=\"md-raised\">Cancel</md-button></div></form></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/form/views/resign/resign.html","<div id=\"invoice\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"invoice-container\"><md-button \nclass=\"print md-accent-bg\" id=\"printpagebutton\" ng-click=\"printToCart(\'invoice\')\" style=\"float: right\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span>Print</span></md-button><md-button class=\"print md-accent-bg\" \nid=\"printback\" ng-click=\"Back()\" style=\"float: right\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><span>Back\n</span></md-button><div class=\"card md-whiteframe-8dp\"><div class=\"header\"></div><div class=\"content\"><div \nstyle=\"text-align:center;font-size:25px;font-weight:600\"><b>STAFF RESIGNATION CLEARANCE FORM</b></div><br><br><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">\n<label style=\"width:100px\">Name</label>&emsp;<md-input-container flex=\"25\"><md-select ng-model=\"Employee\" \nid=\"Employee\" style=\"margin-bottom: 20px\"><md-option ng-repeat=\"row in Employeedatas\" value=\"{{row.id}}\">\n{{row.EmployeeName}}</md-option></md-select></md-input-container>&emsp;&emsp;<label style=\"width:150px\">Date Joined\n</label>&emsp;<md-input-container flex=\"25\"><md-datepicker ng-model=\"DateJoined\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 55px\"><label style=\"width:100px\">Designation</label>&emsp;\n<md-input-container flex=\"25\"><input type=\"text\" name=\"Designation\" ng-model=\"Designation\" placeholder=\"\">\n</md-input-container>&emsp;&emsp;<label style=\"width:150px\">Last date of Service</label>&emsp;<md-input-container \nflex=\"25\"><md-datepicker ng-model=\"DateofService\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div>\n<div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 55px\"><label style=\"width:100px\">Department</label>&emsp;\n<md-input-container flex=\"25\"><md-select ng-model=\"Department\" id=\"Department\" style=\"margin-bottom: 20px\"><md-option \nng-repeat=\"row in Departmentdatas\" value=\"{{row.id}}\">{{row.DepartmentName}}</md-option></md-select>\n</md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 60px\"><label style=\"width:100px\">Job Title</label>&emsp;\n<md-input-container flex=\"25\"><input type=\"text\" name=\"JobTitle\" ng-model=\"JobTitle\" placeholder=\"\">\n</md-input-container>&emsp;&emsp;<label style=\"width:150px\">Notice given</label>&emsp;&nbsp;&nbsp;<md-radio-group \nng-model=\"Noticegiven\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button><md-radio-button value=\"false\">\nNo</md-radio-button></md-radio-group></div><div style=\"text-align:justify;font-size:17px\"><p>\nKindly ensure that you had completed all your clearance procedure with the relevant department before proceeding to the Human Resource Department for the final clearance.\n<br><br></p></div><div style=\"text-align:justify;font-size:17px\">Thank you for your co-operations.<br><br></div><br>\n<br><br><div style=\"text-align:center;font-size:20px;font-weight:500\"><b>OPERATIONS DEPARTMENT</b></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 5px\">1. Maglite with accessories:</h3><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">\n&emsp;&emsp;&emsp;&emsp;<md-radio-group ng-model=\"Maglite\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"other\">\nOther&nbsp;</md-radio-button></md-radio-group><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"magliteRemarks\" placeholder=\"\"></md-input-container></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 5px\">2. Respirators / Ear Mufflers:</h3><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">\n&emsp;&emsp;&emsp;&emsp;<md-radio-group ng-model=\"Respirators\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"other\">\nOther&nbsp;</md-radio-button></md-radio-group><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"respiratorsRemarks\" placeholder=\"\"></md-input-container></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 5px\">3. Overtime:</h3><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;\n<md-radio-group ng-model=\"Overtime\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;\n<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"other\">Other&nbsp;</md-radio-button>\n</md-radio-group><md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"overtimeRemarks\" placeholder=\"\">\n</md-input-container></div><h3 style=\"text-align:justify;font-weight: 600;height: 5px\">4. Non-Contractual Incentives:\n</h3><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<md-radio-group ng-model=\"Contractual\" \nlayout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No\n</md-radio-button>&emsp;<md-radio-button value=\"other\">Other&nbsp;</md-radio-button></md-radio-group>\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"contractualRemarks\" placeholder=\"\">\n</md-input-container></div><h3 style=\"text-align:justify;font-weight: 600;height: 5px\">\n5. Station / MQ-ST Allowances ( if applicable ) :</h3><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<md-radio-group ng-model=\"Station\" \nstyle=\"height:30px\"><md-radio-button value=\"Applicable \">Applicable</md-radio-button><md-radio-button \nvalue=\"NotApplicable \">Not Applicable</md-radio-button></md-radio-group><md-input-container flex><input type=\"text\" \nname=\"Others\" ng-model=\"stationRemarks\" placeholder=\"\"></md-input-container>\n&nbsp;(Kindly compute accordingly)&nbsp;&nbsp;<br></div><br><br><div \nstyle=\"text-align:justify;font-size:17px;height: 75px;-ms-flex: 0 1 auto\"><h3 style=\"font-weight: 600\">\n6. Please ensure the following are cleared and returned accordingly.</h3><div \nstyle=\"text-align:left;font-size:17px;font-weight:500\">&emsp;&emsp;<b>FOR DRIVERS / STAFF ISSUED WITH HP</b></div>\n</div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>Personal HP Usage</label>&nbsp;\n<md-input-container flex><input type=\"text\" name=\"Others\" ng-model=\"hpRemarks\" placeholder=\"\"></md-input-container>\n</div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<label style=\"width:155px\">\nReimbursement</label>&emsp;<md-radio-group ng-model=\"Reimbursement\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>&emsp;&emsp;<label \nstyle=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"reimbursementRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;\n<label style=\"width:155px\">Sim Card</label>&emsp;<md-radio-group ng-model=\"SimCard\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>\n&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"simcardRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;\n<label style=\"width:155px\">Deposit</label>&emsp;<md-radio-group ng-model=\"Deposit\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>\n&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"depositRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;\n<label style=\"width:155px\">PDA</label>&emsp;<md-radio-group ng-model=\"PDA\" layout=\"row\"><md-radio-button value=\"true\">\nYes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>&emsp;&emsp;<label\n style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"pdaRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:187px\">Personal petrol usage</label>&emsp;<md-radio-group ng-model=\"Petrol\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>\n&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"petrolRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:187px\">Vehicle Key Returned</label>&emsp;<md-radio-group ng-model=\"Vehicle\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>\n&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"vehicleRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:187px\">Fleet Card</label>&emsp;<md-radio-group ng-model=\"FleetCard\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>\n&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"fleetcardRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:187px\">Vehicle Handover</label>&emsp;<md-radio-group ng-model=\"VehicleHandover\" layout=\"row\">\n<md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;\n</md-radio-group>&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input \ntype=\"text\" name=\"Remarks\" ng-model=\"vehiclehandoverRemarks\" placeholder=\"\"></md-input-container></div><div \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">\n&emsp;&emsp;&emsp;&emsp;<label style=\"width:187px\">Summonses</label>&emsp;<md-radio-group ng-model=\"Summonses1\" \nlayout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No\n</md-radio-button>&emsp;</md-radio-group>&emsp;&emsp;<label style=\"width:100px\">Remarks</label>&nbsp;\n<md-input-container flex><input type=\"text\" name=\"Remarks\" ng-model=\"summonsesRemarks\" placeholder=\"\">\n</md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<md-radio-group \nng-model=\"Summonses2\" layout=\"row\"><md-radio-button value=\"hdb\">HDB</md-radio-button>&emsp;<md-radio-button \nvalue=\"lta\">LTA</md-radio-button>&emsp;<md-radio-button value=\"ura\">URA</md-radio-button>&emsp;<md-radio-button \nvalue=\"tp\">TP</md-radio-button></md-radio-group></div><br><div style=\"text-align:left;font-size:17px;font-weight:500\">\n&emsp;&emsp;<b>FOR STATIONED TECHNICANS</b></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:187px\">\nStore Keys Returned</label>&emsp;<md-radio-group ng-model=\"StoreKeys\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;</md-radio-group>&emsp;&emsp;<label \nstyle=\"width:100px\">Remarks</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"storekeysRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>\nOthers</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Others\" ng-model=\"otherRemarks1\" placeholder=\"\">\n</md-input-container></div><br><br><div style=\"text-align:left;font-size:17px;height: 50px\"><b>Verified By:</b></div>\n<br><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 50px\"><label style=\"width:150px;font-weight: 600\">Name / Signature\n</label>&emsp;<md-input-container flex><input type=\"text\" name=\"ClearanceFormName\" ng-model=\"ClearanceFormName\" \nplaceholder=\"\"></md-input-container>&emsp;&emsp;<label style=\"width:50px;font-weight: 600\">Date</label>&emsp;\n<md-date-container flex style=\"margin-bottom: 15px\"><md-datepicker ng-model=\"ClearanceFormDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-date-container></div><br><br><br><br><br><br><div \nstyle=\"text-align:center;font-size:20px;font-weight:500\"><b>HUMAN RESOURCE DEPARTMENT</b></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 5px\">1. Training Handouts Returned:</h3><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\">\n&emsp;&emsp;&emsp;&emsp;<md-radio-group ng-model=\"TrainingHandouts\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"other\">\nOther&nbsp;</md-radio-button></md-radio-group><md-input-container flex><input type=\"text\" name=\"Remarks\" \nng-model=\"TrainingHandoutsRemarks\" placeholder=\"\"></md-input-container></div><div style=\"margin-top: -30px\"><h4><b>\n&emsp;&emsp;&emsp;&emsp;* Misplaced handouts will be charged at S$5.00 per module / lesson.</b></h4></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 5px\">2. Items Returned:</h3><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:210px\">T-shirt Shirt</label>&emsp;&emsp;<md-radio-group ng-model=\"Tshirt\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button \nvalue=\"na\">NA</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:210px\">Cap</label>\n&emsp;&emsp;<md-radio-group ng-model=\"Cap\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;\n<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"na\">NA</md-radio-button>\n</md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:210px\">\nST / MQ Jacket</label>&emsp;&emsp;<md-radio-group ng-model=\"Jacket\" layout=\"row\"><md-radio-button value=\"true\">Yes\n</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"na\">NA\n</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:210px\">Pouch</label>\n&emsp;&emsp;<md-radio-group ng-model=\"Pouch\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;\n<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"na\">NA</md-radio-button>\n</md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:210px\">Staff ID\n</label>&emsp;&emsp;<md-radio-group ng-model=\"StaffID\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>\n&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"na\">NA</md-radio-button>\n</md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label style=\"width:210px\">\nNEA Vector Control License</label>&emsp;&emsp;<md-radio-group ng-model=\"VectorControlLicense\" layout=\"row\">\n<md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;\n<md-radio-button value=\"na\">NA</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:210px\">Safety Helmet</label>&emsp;&emsp;<md-radio-group ng-model=\"SafetyHelmet\" layout=\"row\">\n<md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;\n<md-radio-button value=\"na\">NA</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<label \nstyle=\"width:210px\">Haversack</label>&emsp;&emsp;<md-radio-group ng-model=\"Haversack\" layout=\"row\"><md-radio-button \nvalue=\"true\">Yes</md-radio-button>&emsp;<md-radio-button value=\"false\">No</md-radio-button>&emsp;<md-radio-button \nvalue=\"na\">NA</md-radio-button></md-radio-group></div><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>Others</label>&nbsp;\n<md-input-container flex><input type=\"text\" name=\"Others\" ng-model=\"OtherRemarks2\" placeholder=\"\"></md-input-container>\n</div><h3 style=\"text-align:justify;font-weight: 600;height: 5px\">3. Education Incentive:</h3><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 45px\">\n&emsp;&emsp;&emsp;&emsp;<label>Diploma</label>&emsp;&emsp;<md-radio-group ng-model=\"Diploma\" layout=\"row\">\n<md-radio-button value=\"a\">GCE \'A\' level</md-radio-button>&emsp;<md-radio-button value=\"o\">GCE \'O\' Level\n</md-radio-button>&emsp;<md-radio-button value=\"n\">GCE \'N\' Level</md-radio-button>&emsp;<md-radio-button value=\"na\">NA\n</md-radio-button></md-radio-group></div><h3 style=\"text-align:justify;font-weight: 600;height: 5px\">\n4. Class 3 Driving Incentive:</h3><div layout-gt-xs=\"row\" layout=\"row\" layout-align=\"start center\" \nstyle=\"text-align:justify;font-size:17px;height: 45px\">&emsp;&emsp;&emsp;&emsp;<md-radio-group \nng-model=\"DrivingIncentive\" layout=\"row\"><md-radio-button value=\"true\">Yes</md-radio-button>&emsp;<md-radio-button \nvalue=\"false\">No</md-radio-button>&emsp;<md-radio-button value=\"na\">NA</md-radio-button></md-radio-group></div><h3 \nstyle=\"text-align:justify;font-weight: 600;height: 20px\">5. Annual Leave Balance:</h3><div layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">\n&emsp;&emsp;&emsp;&emsp;<label>Yes</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Others\" \nng-model=\"AnnualLeaveBalanceRemarks\" placeholder=\"\"></md-input-container>\n&emsp; (Kindly compute accordingly) /Not Applicable</div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>\nPerfect Attendance Entitlement</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Others\" \nng-model=\"AttendanceEntitlementRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>\nMalaysian Deposit (if any)</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Others\" \nng-model=\"MalaysianDepositRemarks\" placeholder=\"\"></md-input-container></div><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 55px\">&emsp;&emsp;&emsp;&emsp;<label>\nJoin-In Bonus (if any)</label>&nbsp;<md-input-container flex><input type=\"text\" name=\"Others\" \nng-model=\"JoinInBonusRemarks\" placeholder=\"\"></md-input-container></div><br><br><div \nstyle=\"text-align:left;font-size:17px;height: 50px\"><b>Verified By:</b></div><br><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\"><label \nstyle=\"width:150px;font-weight: 600\">Name / Signature</label>&emsp;<md-input-container flex><input type=\"text\" \nname=\"HRDepartmentName\" ng-model=\"HRDepartmentName\" placeholder=\"\"></md-input-container>&emsp;&emsp;<label \nstyle=\"width:50px;font-weight: 600\">Date</label>&emsp;<md-date-container flex style=\"margin-bottom: 15px\">\n<md-datepicker ng-model=\"HRDepartmentDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-date-container></div><br><br>\n<br><br><br><div style=\"text-align:center;font-size:20px;font-weight:500\"><b>ACCOUNTS DEPARTMENT</b></div><br><div \nstyle=\"text-align:justify;font-size:17px\"><p>\nPlease ensure that all the above are correct and accounted for before releasing the final salary payment. A sum of $50.00 will be retained for miscellaneous deductions e.g. personal usage of vehicle, hand phone, etc. This sum will be released ONLY upon Operations clearance procedure.\n<br><br></p></div><div style=\"text-align:justify;font-size:17px\">Thank you.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">HR Dept.<br><br></div><br><br><div \nstyle=\"text-align:left;font-size:17px;height: 50px\"><b>Received By:</b></div><br><div layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"start center\" style=\"text-align:justify;font-size:17px;height: 50px\"><label \nstyle=\"width:150px;font-weight: 600\">Name / Signature</label>&emsp;<md-input-container flex><input type=\"text\" \nname=\"AccountsDepartmentName\" ng-model=\"AccountsDepartmentName\" placeholder=\"\"></md-input-container>&emsp;&emsp;<label \nstyle=\"width:50px;font-weight: 600\">Date</label>&emsp;<md-date-container flex style=\"margin-bottom: 15px\">\n<md-datepicker ng-model=\"AccountsDepartmentDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-date-container></div>\n</div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></div><style>\n#invoice .invoice-container {\r\n        padding-top: 15px;\r\n    }\r\n\r\n    .md-datepicker-input {\r\n        min-width: 250px !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\n</style>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/eappraisal/eappraisal.html","<div id=\"eappraisal\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Employee Appraisals</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"aSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div class=\"search\" layout=\"row\" ng-show=\"aSearch\" style=\"margin-top:30px\" \nlayout-align=\"start center\" flex><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">From</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uFrom\"></md-datepicker></md-input-container><md-input-container flex=\"40\" id=\"Datefilter\"><label \nstyle=\"color:white;font-size: 14px\">To</label><md-datepicker onkeydown=\"return false\" class=\"datefilter\" \nng-model=\"uTo\"></md-datepicker></md-input-container><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"Datefilter()\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\" style=\"margin-top:-20px\"></md-icon></md-button></div>\n<div><md-button class=\"md-raised md-background\" ng-show=\"aAdd\" ng-click=\"Add()\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button class=\"md-raised reference-button\" \nng-show=\"aView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><span>Back</span></md-button>\n<md-button class=\"md-raised md-background\" ng-show=\"aExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Appraisalgrid\"><div class=\"white-bg md-whiteframe-4dp\"><md-progress-linear \nng-hide=\"Employeeappraisalformdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Reference #\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Report</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Employee Name</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nAppraisal Year</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Appraisal No.</span></div>\n</th><th class=\"secondary-text\"><div><span class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\">\n<div><span class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div><span \nclass=\"column-title\">Status</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Employeeappraisalformdatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a href=\"\" ng-click=\"ViewAppraisalinfo(row._id, $index)\" \ntitle=\"Detail Grid\" style=\"border:none\">{{ row.ReferenceNo }}</a></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Appraisalinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button\n id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"printToCart(row._id)\"><md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></td><td>\n{{ row.Employeedetails[0].EmployeeID }}-{{ row.Employeedetails[0].EmployeeName }}</td><td>{{ row.AppraisalYear }}</td>\n<td>{{ row.AppraisalNo }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y\' }}</td><td>\n{{ row.Status }}</td></tr></tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Appraisalform\" flex><form name=\"basicForm\" class=\"md-inline-form\" \nnovalidate><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" \nng-show=\"Cancel\" ng-click=\"cancelrequest()\"><span>Cancel Request</span></md-button></div><div class=\"content-card\" \nstyle=\"width:100%;padding:1%\"><div class=\"white-bg md-whiteframe-4dp\" style=\"width:63.5%;float:left;height:400px\"><h2 \nstyle=\"text-align:left\">&nbsp;APPRAISAL DETAILS</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"padding:2px\"><md-input-container flex><input type=\"text\" name=\"AppraisalYear\" ng-model=\"AppraisalYear\" \nplaceholder=\"Year of Appraisal\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top: -6px\" \nflex><label>Employee Name</label><md-select ng-model=\"Employee\" ng-change=\"EmployeeDetails()\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm1\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a requester..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"Employeeclear()\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Employeedatas | filter:vm.searchTerm1\" value=\"{{row.id}}\">{{row.EmployeeID}}-{{row.EmployeeName}}\n</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\" \nstyle=\"padding:2px\"><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label>Appraisal Period Start\n</label><md-datepicker onkeydown=\"return false\" ng-model=\"AppraisalPeriodStart\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container><md-input-container flex style=\"margin-top: 18px;margin-left:-10px\"><label>\nAppraisal Period End</label><md-datepicker onkeydown=\"return false\" ng-model=\"AppraisalPeriodEnd\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"start center\" style=\"padding:2px\"><md-input-container style=\"margin-top: -6px\" flex><label>\nAppraisal Template</label><md-select ng-model=\"AppraisalType\" ng-change=\"TemplateDetails(e)\" id=\"searchmodule\" \nmd-on-close=\"clearSearchTerm()\" required><md-select-header><input ng-model=\"vm.searchTerm2\" style=\"flex: auto\" \ntype=\"text\" placeholder=\"Search for a Appraisal Template..\" ng-keydown=\"$event.stopPropagation()\"><md-button \nclass=\"md-icon-button\" ng-click=\"AppraisalType=null\" aria-label=\"Close dialog\" style=\"float:right\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-select-header><md-option \nng-repeat=\"row in Appraisaltemplateformdatas | filter:vm.searchTerm2\" value=\"{{row._id}}\">{{row.TemplateName}}\n</md-option></md-select></md-input-container><md-input-container flex></md-input-container></div></div><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:35.5%;float:right;height:400px\"><h2 style=\"text-align:left\">\n&nbsp;EMPLOYEE DETAILS</h2><hr><div layout=\"row\" layout-align=\"center center\"><img ng-if=\"Photo\" \nstyle=\"height:150px; width:150px\" src=\"{{Photo}}\"> <img ng-hide=\"Photo\" style=\"height:150px; width:150px\" \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"\"></div><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px\">\nDepartment</label>&nbsp; :&nbsp; {{Department}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px;margin-top: 5px\">Designation</label>&nbsp; :&nbsp; {{Designation}}<br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:150px;margin-top: 5px\">Date Joined</label>\n&nbsp; :&nbsp; {{DateJoined| date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:150px;margin-top: 5px\">Appraisal No.</label>&nbsp; :&nbsp; {{AppraisalNo}}\n<br></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;APPRAISAL DETAILS</h1><div layout-gt-sm=\"row\" id=\"head\" layout=\"column\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"Templatedetailnewpopup($event, UniqueID)\" style=\"float:right\"><span>Add</span>\n</md-button></div><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Criteria</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Weightage</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Grade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">View/Edit\n</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">Delete</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"row in Employeeappraisaldatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Category }}</td><td>{{ row.Criteria }}</td><td>{{ row.Weightage }}</td><td>{{ row.Grade }}</td><td>\n{{ row.Remarks }}</td><td><md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" \naria-label=\"Custom Icon Button\" ng-click=\"Templatedetailnewupdate($event, row._id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Templatedetailnewdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td>\n</tr></tbody></table><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:10px\"><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"TotalPFScore\" ng-model=\"TotalPFScore\" placeholder=\"Total PF Score\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\"><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"MaxPFScore\" ng-model=\"MaxPFScore\" placeholder=\"Max PF Score\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\"><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"TotalPF\" ng-model=\"TotalPF\" placeholder=\"Total PF(%)\">\n</md-input-container></div><br><h2 style=\"text-align:left;margin-top: -25px\">&nbsp;<b>Appraisal Summary</b><hr></h2>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span \nstyle=\"width:450px\"><b>Total Score</b></span>: &emsp; <input type=\"number\" ng-model=\"TotalScore\" placeholder=\"\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container \nlayout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Bonus Score</b></span>: &emsp; <input type=\"number\" \nng-model=\"BonusScore\" placeholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Bonus Score Remarks\n</b></span>: &emsp; <input type=\"text\" ng-model=\"BonusScoreRemarks\" placeholder=\"\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span \nstyle=\"width:450px\"><b>Overall Performance Rating</b></span>: &emsp; <input type=\"number\" ng-model=\"OverallRating\" \nplaceholder=\"\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\">\n<md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Employee Comments</b></span>: &emsp; <input \ntype=\"text\" ng-model=\"EmployeeComment\" placeholder=\"\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nCSO/HOD Comments</b></span>: &emsp; <input type=\"text\" ng-model=\"CsoComment\" placeholder=\"\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span \nstyle=\"width:450px\"><b>HR Comments</b></span>: &emsp; <input type=\"text\" ng-model=\"HRComment\" placeholder=\"\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container \nlayout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Recommendation</b></span>: &emsp; <input type=\"text\" \nng-model=\"Recommendation\" placeholder=\"\"></md-input-container></div></div></div><br></form><br><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"aSubmit()\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div><div class=\"content\"><div \nlayout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"ViewAppraisalform\" flex><form name=\"basicForm1\" \nclass=\"md-inline-form\" novalidate><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:58.5%;float:left;height:440px\"><h2 style=\"text-align:left\">\n&nbsp;EMPLOYEE DETAILS</h2><hr><div layout=\"row\" layout-align=\"center center\"><img ng-if=\"Photo\" \nstyle=\"height:150px; width:150px\" src=\"{{Photo}}\"> <img ng-hide=\"Photo\" style=\"height:150px; width:150px\" \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"\"></div><br>&nbsp;<label style=\"font-size:17px;color:#7f9593;width:170px\">\nReference #</label>&nbsp; :&nbsp;<label style=\"font-size:17px;width:250px\">{{ReferenceNo}}</label>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:115px\">Department</label>&nbsp; :&nbsp; {{Department}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:170px;margin-top: 5px\">Employee Name</label>&nbsp; :&nbsp;<label \nstyle=\"font-size:17px;width:250px\">{{EmployeeName}}</label>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:115px;margin-top: 5px\">Designation</label>&nbsp; :&nbsp; {{Designation}}<br>\n&nbsp;<label style=\"font-size:17px;color:#7f9593;width:170px;margin-top: 5px\">Appraisal Period Start</label>\n&nbsp; :&nbsp;<label style=\"font-size:17px;width:250px\">{{AppraisalPeriodStart| date:\'dd/MM/y\'}}</label>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:115px;margin-top: 5px\">Date Joined</label>\n&nbsp; :&nbsp; {{DateJoined| date:\'dd/MM/y\'}}<br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:170px;margin-top: 5px\">Appraisal Period End</label>&nbsp; :&nbsp;<label \nstyle=\"font-size:17px;width:250px\">{{AppraisalPeriodEnd| date:\'dd/MM/y\'}}</label>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:115px;margin-top: 5px\">Appraisal Year</label>&nbsp; :&nbsp;<label \nstyle=\"font-size:17px;width:250px\">{{AppraisalYear}}</label><br>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:170px;margin-top: 5px\">Appraisal Template</label>&nbsp; :&nbsp;<label \nstyle=\"font-size:17px;width:250px\">{{TemplateName}}</label>&nbsp;<label \nstyle=\"font-size:17px;color:#7f9593;width:115px;margin-top: 5px\">Appraisal No.</label>&nbsp; :&nbsp; {{AppraisalNo}}\n<br></div><div class=\"white-bg md-whiteframe-4dp\" style=\"width:40.5%;float:right\"><h2 style=\"text-align:left\">\n&nbsp;WORKFLOW</h2><hr><div layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nflex><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">&nbsp;<label style=\"width:110px;font-weight:500\">Current Status\n</label>: &emsp; {{Actioned}}</div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\" ng-hide=\"NextLevelAction == \'\'\">\n<label style=\"width:100px;font-weight:500\">Next Status</label>: &emsp; {{NextLevelAction}}</div></div><br><div \nlayout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" flex><div \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" ng-show=\"ShowWorkflowButton\"><md-button \nclass=\"md-accent md-raised\" id=\"review\" value=\"Review\" ng-click=\"workflow()\"><span>{{NextLevelAction}}</span>\n</md-button></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"end center\" \nng-show=\"NextLevelShowRejectButton\"><md-button class=\"md-accent md-raised\" id=\"reject\" value=\"Reject\" \nng-click=\"reject()\"><span>Reject</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowCancelButton\"><md-button class=\"md-accent md-raised\" id=\"cancel\" \nvalue=\"Cancel\" ng-click=\"cancel()\"><span>Cancel</span></md-button></div><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"end center\" ng-show=\"NextLevelShowReviseButton\"><md-button class=\"md-accent md-raised\" id=\"revise\" \nvalue=\"Revise\" ng-click=\"revise()\"><span>Revise</span></md-button></div></div><br><md-progress-linear \nng-hide=\"Logdetailsdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actioned Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Logdetailsdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.Action }}</td><td>{{ row.ActionedBy }}</td><td>{{ row.ActionedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr>\n</tbody></table></div></div><br><div class=\"form-wrapper md-whiteframe-1dp\" flex><h1 style=\"text-align:left\">\n&nbsp;APPRAISAL DETAILS</h1><hr><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Employeeappraisaldatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Criteria</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Weightage</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Grade</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Remarks</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Employeeappraisaldatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Category }}</td><td>{{ row.Criteria }}</td><td>\n{{ row.Weightage }}</td><td>{{ row.Grade }}</td><td>{{ row.Remarks }}</td></tr></tbody></table><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top:10px\"><md-input-container flex></md-input-container><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex><input type=\"number\" \nname=\"TotalPFScore\" ng-model=\"TotalPFScore\" placeholder=\"Total PF Score\" readonly=\"readonly\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\"><md-input-container flex></md-input-container>\n<md-input-container flex></md-input-container><md-input-container flex></md-input-container><md-input-container flex>\n<input type=\"number\" name=\"MaxPFScore\" ng-model=\"MaxPFScore\" placeholder=\"Max PF Score\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-35px\"><md-input-container flex>\n</md-input-container><md-input-container flex></md-input-container><md-input-container flex></md-input-container>\n<md-input-container flex><input type=\"number\" name=\"TotalPF\" ng-model=\"TotalPF\" placeholder=\"Total PF(%)\" \nreadonly=\"readonly\"></md-input-container></div><br><h2 style=\"text-align:left;margin-top: -25px\">&nbsp;<b>\nAppraisal Summary</b><hr></h2><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container \nlayout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Total Score</b></span>: &emsp; <input type=\"number\" \nng-model=\"TotalScore\" placeholder=\"\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nBonus Score</b></span>: &emsp; <input type=\"number\" ng-model=\"BonusScore\" placeholder=\"\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container \nlayout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Bonus Score Remarks</b></span>: &emsp; <input type=\"text\" \nng-model=\"BonusScoreRemarks\" placeholder=\"\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nOverall Performance Rating</b></span>: &emsp; <input type=\"number\" ng-model=\"OverallRating\" placeholder=\"\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\">\n<md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>Employee Comments</b></span>: &emsp; <input \ntype=\"text\" ng-model=\"EmployeeComment\" placeholder=\"\" readonly=\"readonly\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span \nstyle=\"width:450px\"><b>CSO/HOD Comments</b></span>: &emsp; <input type=\"text\" ng-model=\"CsoComment\" placeholder=\"\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top: -7px\">\n<md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>HR Comments</b></span>: &emsp; <input \ntype=\"text\" ng-model=\"HRComment\" placeholder=\"\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top: -7px\"><md-input-container layout=\"row\" flex=\"40\"><span style=\"width:450px\"><b>\nRecommendation</b></span>: &emsp; <input type=\"text\" ng-model=\"Recommendation\" placeholder=\"\" readonly=\"readonly\">\n</md-input-container></div></div></div><br><div class=\"content-card\" style=\"width:100%;padding:1%\"><div \nclass=\"white-bg md-whiteframe-4dp\" style=\"width:44.5%;float:left\"><h2 style=\"text-align:left\">&nbsp;COMMENTS</h2><hr>\n<div layout-gt-sm=\"row\" layout-align=\"start center\" style=\"padding:2px\"><md-input-container flex><input type=\"text\" \nname=\"Comment\" ng-model=\"vm.Comments\" placeholder=\"Comment here..\" required></md-input-container></div><div \nstyle=\"float:right;margin-top:-45px\"><md-button class=\"md-raised md-accent\" ng-click=\"commentSubmit()\" \nng-disabled=\"basicForm1.$invalid || basicForm1.$pristine\"><span>Save</span></md-button></div><md-progress-linear \nng-hide=\"Commentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Commented Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Commentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.cmt }}\n</td><td>{{ row.CommentedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y HH:mm:ss\' }}</td></tr></tbody></table></div>\n<div class=\"white-bg md-whiteframe-4dp\" style=\"width:54.5%;float:right\"><h2 style=\"text-align:left\">&nbsp;ATTACHMENTS\n</h2><hr><div layout-gt-sm=\"row\" layout-align=\"start center\"><md-content layout-padding><div \nflow-init=\"{singleFile:true}\" flow-name=\"uploader.flow\"><div layout-gt-sm=\"row\" layout=\"column\" id=\"attachmenthref\">\n<md-button class=\"md-accent md-raised\"><label for=\"file-input\" style=\"margin-bottom:0px\">Browse</label><input \nclass=\"file-input\" flow-btn id=\"file-input\"></md-button><md-button class=\"md-raised md-accent\" \nng-click=\"Uploadfiles(uploader.flow.files)\"><span>Upload</span></md-button></div><table style=\"float:left\"><tr \nng-repeat=\"file in uploader.flow.files\"><td style=\"padding: 5px 10px 5px 10px\">{{$index+1}}.</td><td>{{file.name}}</td>\n</tr></table></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear \nng-hide=\"Attachmentdatas\" md-mode=\"indeterminate\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" \nclass=\"md-default-theme\"><div class=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div \nclass=\"md-bar md-bar1\"></div><div class=\"md-bar md-bar2\"></div></div></md-progress-linear><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File Size(KB)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded By</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uploaded Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"row in Attachmentdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td><a \nhref=\"{{UploadsURL}}Procurement/Material Request/{{row.TableID}}\" download style=\"cursor:pointer\">{{ row.FileName }}\n</a></td><td>{{ row.FileSize }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date :\'dd/MM/y HH:mm:ss\' }}\n</td></tr></tbody></table></div></div></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div>\n</div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -65px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: calc(22vw - 33px);\r\n        max-width: calc(35vw - 54px);\r\n        margin-left: 1px;\r\n    }\r\n\r\n    /*md-datepicker .md-datepicker-input {\r\n        width: 300px !important;\r\n        max-width: 1000px !important;\r\n    }*/\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\r\n\r\n    \r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        width: 0;\r\n    }\r\n\r\n    .datefilter > div > button > div.md-datepicker-expand-triangle {\r\n        border-top-color: white !important;\r\n    }\r\n\r\n    #Datefilter md-datepicker .md-datepicker-input {\r\n        color: white !important;\r\n        border-bottom-color: white !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/eappraisal/newtemplate.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TEMPLATE DETAILS</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Category\" \nplaceholder=\"Category\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"margin-top:-27px\"><md-input-container flex><input type=\"text\" ng-model=\"vm.Criteria\" placeholder=\"Criteria\" \nrequired></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:-27px\">\n<md-input-container flex><input type=\"number\" ng-model=\"vm.Weightage\" placeholder=\"Weightage\" required>\n</md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.Grade\" placeholder=\"Grade\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:-27px\"><md-input-container flex>\n<input type=\"text\" ng-model=\"vm.Remarks\" placeholder=\"Remarks\"></md-input-container></div><div class=\"bottom\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Templatedetailnewadd()\" \naria-label=\"Submit\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/eappraisal/newtemplatedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this appraisal template data?</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button ng-click=\"TDNdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/eappraisal/viewtemplate.html","<md-dialog style=\"width:1200px\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{TempName}}</span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"form-wrapper md-whiteframe-1dp\" flex><table \nclass=\"table table-bordered table-hover table-condensed\"><tr style=\"font-weight:bold\"><td style=\"width:20%\">Category\n</td><td style=\"width:20%\">Criteria</td><td style=\"width:5%\">Weightage</td><td style=\"width:5%\">Grade</td><td \nstyle=\"width:10%\">Remarks</td><td style=\"width:5%\">Edit</td></tr><tr ng-repeat=\"user in Tempdetaildatas\"><td>\n{{ user.Category}}</td><td>{{ user.Criteria}}</td><td><span editable-text=\"user.Weightage\" e-name=\"Weightage\" \ne-form=\"rowform\">{{ user.Weightage}}</span></td><td><span editable-text=\"user.Grade\" e-name=\"Grade\" e-form=\"rowform\">\n{{ user.Grade}}</span></td><td><span editable-textarea=\"user.Remarks\" e-name=\"Remarks\" e-form=\"rowform\" \ne-style=\"width:200px;height:60px\">{{ user.Remarks}}</span></td><td style=\"white-space: nowrap\"><form editable-form \nname=\"rowform\" onbeforesave=\"TemplateDetailSave($data, user._id, user.Category, user.Criteria)\" \nng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == user\"><button type=\"submit\" \nng-disabled=\"rowform.$waiting\" class=\"btn btn-primary\">save</button> <button type=\"button\" \nng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default\">cancel</button></form><div \nclass=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary\" ng-click=\"rowform.$show()\">edit</button>\n</div></td></tr></table></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" \naria-label=\"Submit\">Close</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/template/template.html","<div id=\"template\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hospital\"></md-icon><span>Appraisal Templates</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"tSearch\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"tAdd\" \nng-click=\"Add()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised reference-button\" ng-show=\"tView\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><span>Back</span></md-button><md-button class=\"md-raised md-background\" \nng-show=\"tExport && AllowExport==\'true\'\" ng-click=\"Export()\"><md-icon md-font-icon=\"icon-export\"></md-icon><span>Export\n</span></md-button></div></div><div class=\"content-card\" ng-show=\"Templategrid\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-progress-linear ng-hide=\"Appraisaltemplateformdatas\" md-mode=\"indeterminate\" \naria-valuemin=\"0\" aria-valuemax=\"100\" role=\"progressbar\" class=\"md-default-theme\"><div \nclass=\"md-container md-mode-indeterminate\"><div class=\"md-dashed\"></div><div class=\"md-bar md-bar1\"></div><div \nclass=\"md-bar md-bar2\"></div></div></md-progress-linear><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">Template Name</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Created By</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">\nCreated Date</span></div></th><th class=\"secondary-text\"><div><span class=\"column-title\">&nbsp; Clone</span></div></th>\n<th class=\"secondary-text\"><div><span class=\"column-title\">&nbsp;&nbsp;&nbsp; Edit</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">&nbsp; Delete</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in Appraisaltemplateformdatas\"><td>{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>\n{{ row.TemplateName }}</td><td>{{ row.CreatedBy }}</td><td>{{ row.CreatedDate | date:\'dd/MM/y hh:mm a\' }}</td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Clone(row._id)\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Templateinfo(row._id, $index)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td><md-button \nid=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Templateformdelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr>\n</tbody></table></div></div><div class=\"content\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" \nng-show=\"Templateform\" flex><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container flex><input type=\"text\" name=\"TemplateName\" ng-model=\"TemplateName\" \nplaceholder=\"Template Name\" required><div ng-messages=\"basicForm.TemplateName.$error\" \nng-show=\"basicForm.TemplateName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Template Name Required.</span>\n</div></div></md-input-container></div><h1 style=\"text-align:left\">&nbsp;TEMPLATES</h1><div layout-gt-sm=\"row\" \nid=\"head\" layout=\"column\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"!TemplateName\" \nng-click=\"Templatepopup($event, UniqueID)\" style=\"float:right\"><span>Add</span></md-button></div><hr><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Category</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Criteria</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Weightage</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order</span></div></th><th \nclass=\"secondary-text\"><div><span class=\"column-title\">View/Edit</span></div></th><th class=\"secondary-text\"><div><span\n class=\"column-title\">Delete</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Appraisaltemplatedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.Category }}</td><td>{{ row.Criteria }}</td><td>\n{{ row.Weightage }}</td><td>{{ row.Order }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Templateupdate($event, row._id)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></td><td>\n<md-button id=\"viewedit\" class=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" \nng-click=\"Templatedelete($event, row._id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody>\n</table></div></form><br><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button \ntype=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"tSubmit()\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button><md-button type=\"submit\" \nng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></div></div></div></div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    div#head {\r\n        margin-top: -60px;\r\n    }\r\n\r\n    .file-input {\r\n        display: none !important;\r\n    }\r\n\r\n    /*#qmaintable .dataTables_wrapper .bottom {\r\n        display: flex;\r\n    }*/\r\n\r\n    #tb1 {\r\n        counter-reset: serial-number; /* Set the serial number counter to 0 */\r\n    }\r\n\r\n        #tb1 td:first-child:before {\r\n            counter-increment: serial-number; /* Increment the serial number counter */\r\n            content: counter(serial-number); /* Display the counter */\r\n        }\r\n\r\n    md-datepicker .md-datepicker-input {\r\n        width: 230px !important;\r\n        max-width: 1000px !important;\r\n    }\r\n\r\n\r\n    .md-teal-theme.md-hue-1 .md-datepicker-input {\r\n        color: rgba(0,0,0,0.87);\r\n        background: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n\r\n    .md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    .ta-root .ta-scroll-window.form-control {\r\n        border: 1px solid rgba(0, 0, 0, 0.87) !important;\r\n    }\r\n\r\n    .ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n        min-height: 100px !important;\r\n        padding: 1px 12px !important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/template/templatedelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this template?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"TFdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/template/templatedetail.html","<md-dialog style=\"width:800px\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">TEMPLATE LIST</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><input type=\"text\" ng-model=\"vm.tCategory\" \nplaceholder=\"Category\" required><div ng-messages=\"eventForm.vm.tCategory.$error\" \nng-show=\"eventForm.vm.tCategory.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Category is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" style=\"margin-top:-27px\">\n<md-input-container flex><input type=\"text\" ng-model=\"vm.tCriteria\" placeholder=\"Criteria\" required><div \nng-messages=\"eventForm.vm.tCriteria.$error\" ng-show=\"eventForm.vm.tCriteria.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Criteria is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"margin-top:-27px\"><md-input-container flex><input type=\"number\" ng-model=\"vm.tWeightage\" \nplaceholder=\"Weightage\" required><div ng-messages=\"eventForm.vm.tWeightage.$error\" \nng-show=\"eventForm.vm.tWeightage.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Weightage is required.</span>\n</div></div></md-input-container><md-input-container flex><input type=\"number\" ng-model=\"vm.tOrder\" \nplaceholder=\"Order\" required><div ng-messages=\"eventForm.vm.tOrder.$error\" ng-show=\"eventForm.vm.tOrder.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Order is required.</span></div></div></md-input-container></div><div \nclass=\"bottom\" layout=\"row\" layout-sm=\"column\" layout-align=\"center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"Templateadd()\" aria-label=\"Submit\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\">Save</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" ng-click=\"cancel()\" aria-label=\"Submit\">Cancel\n</md-button></div></md-dialog-content></form></md-dialog><style>\n#date1 .md-datepicker-input {\r\n        min-width: 370px !important;\r\n        max-width: 1000px;\r\n    }</style>");
$templateCache.put("app/main/apps/human-resource/HcmCore/appraisal/template/templatedetaildelete.html","<md-dialog><form name=\"eventForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAre you sure you want to cancel this template data?</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-click=\"TDdelete(deleteID)\" class=\"md-raised md-accent\">Yes</md-button><md-button class=\"md-raised\" \nng-click=\"cancel()\">No</md-button></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/human-resource/HcmCore/expirydetails/allowance/allowance.html","<div id=\"department\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Allowance</span></div><div \nclass=\"product-count secondary-text\"><span>Total Allowance:</span> <span>{{Departmentsummary.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" ng-show=\"Search\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"product\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" flex></div><div><md-button class=\"md-raised md-background\" ng-show=\"Add\" \nng-click=\"sAdd()\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><span>Add</span></md-button><md-button \nclass=\"md-raised md-background\" ng-show=\"view\" ng-click=\"Showgrid()\"><md-icon md-font-icon=\"icon-eye\"></md-icon><span>\nView</span></md-button><md-button class=\"md-raised md-background\" ng-show=\"Export\" ng-click=\"Export()\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span>Export</span></md-button></div></div><div class=\"content-card\" \nng-show=\"Allowancegrid\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div>\n<span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Work Injury Compensation</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Foriegn Medical Insurance</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Travel Insurance Plan</span></div></th><th class=\"secondary-text\"><div>\n<span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in Allowancedatas\"><td>\n{{itemsPerPage *(currentPage-1)+$index+1}}</td><td>{{ row.WorkInjuryCompensation }}</td><td>\n{{ row.ForiegnMedicalInsurance }}</td><td>{{ row.TravelInsurancePlan }}</td><td><md-button id=\"viewedit\" \nclass=\"md-flat md-icon-button reference-button\" aria-label=\"Custom Icon Button\" ng-click=\"allowanceinfo(row.id)\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nclass=\"content\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" ng-show=\"Allowanceform\" \nflex><form name=\"basicForm\" novalidate><span class=\"h4\" style=\"color:#a8bfbd\"><b>Benefits Type</b></span><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><span>Join in Bonus</span></md-input-container>\n<md-input-container flex><md-radio-group ng-model=\"uJoininBonus\"><md-radio-button value=\"Daily\">Daily</md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><md-radio-group ng-model=\"uJoininBonus\"><md-radio-button\n value=\"Monthly\">Monthly</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"uRecommendafriend\" ng-model=\"uRecommendafriend\" \nplaceholder=\"Recommend a friend\" required><div ng-messages=\"basicForm.uRecommendafriend.$error\" \nng-show=\"basicForm.uRecommendafriend.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nRecommend a friend is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"PerfectAttendance\" ng-model=\"uPerfectAttendance\" placeholder=\"Perfect Attendance\" required><div \nng-messages=\"basicForm.PerfectAttendance.$error\" ng-show=\"basicForm.PerfectAttendance.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Perfect Attendance is required.</span></div></div></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"uMosquitojobAllowance\" placeholder=\"Mosquito job Allowance\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"uSoilTreatmentjobAllowance\" placeholder=\"Soil Treatment job Allowance\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"uProductivityAllowance\" placeholder=\"Productivity Allowance\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"uOMOAllowance\" placeholder=\"OMO Allowance\">\n</md-input-container></div><span class=\"h4\" style=\"color:#a8bfbd\"><b>Insurance Type</b></span><div layout=\"column\" \nstyle=\"margin-top: 12px\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nng-model=\"uWorkInjuryCompensation\" placeholder=\"Work Injury Compensation \"></md-input-container><md-input-container \nflex><input type=\"text\" ng-model=\"uForiegnedicalInsurance\" placeholder=\"Foriegn Medical Insurance\">\n</md-input-container><md-input-container flex><input type=\"text\" ng-model=\"uTravelInsurancePlan\" \nplaceholder=\"Travel Insurance Plan\"></md-input-container></div><div class=\"bottom\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center\"><md-button type=\"submit\" class=\"md-raised md-accent md-button md-ink-ripple md-default-theme\" \nng-click=\"sSubmit()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button>\n<md-button type=\"submit\" ng-click=\"Showgrid()\" class=\"md-raised\">Cancel</md-button></div></form></div></div></div>\n</div></div><style>\n#viewedit.md-button {\r\n        margin: -16px 8px;\r\n    }\r\n\r\n    .form-wrapper.md-whiteframe-1dp.flex {\r\n        padding-top: 30px;\r\n     }\r\n\r\n    md-input-container {\r\n        position: relative !important;\r\n        padding: 10px !important;\r\n        vertical-align: middle !important;\r\n        margin: 0px !important;\r\n    }\r\n\r\n    .page-layout {\r\n        position: relative !important;\r\n        overflow: auto !important; \r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/certification/certification.html","<div id=\"invoice\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"invoice-container\"><md-button \nng-click=\"printToCart(\'invoice\')\" class=\"print md-accent-bg\" id=\"printpagebutton\">Print</md-button><div \nclass=\"card md-whiteframe-8dp\" id=\"invoice\"><div class=\"content\" id=\"rcorners2\"><div \nstyle=\"text-align:center;font-size:60px;font-weight:600;color:red\"><b>Certificate</b><br><b>of</b><br><b>Achievement\n</b><br></div><br><material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\">\n<md-input-container style=\"margin-top: 8.5px;padding-left:300px\" flex><input type=\"text\" ng-model=\"uName\" flex=\"40\">\n</md-input-container></material-input-group><div \nstyle=\"text-align:justify;font-size:20px;font-weight:600;padding-left:120px\">\n&emsp;&emsp; &emsp;Successfully completed the training program of<br>\n‘The Introductory Training Series for New Service Technicians’</div><br><br><div \nstyle=\"text-align:center;font-size:19px;color:black; font-style:italic\">from {{fromDate}} - {{toDate}}<br></div><div \nstyle=\"text-align:center;height:110px\"><img src=\"assets/images/logos/pest_logo.png\"></div><div class=\"verticalspace\">\n</div><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div style=\"padding: 25px\">\n<md-input-container style=\"width: 300px;height: 32px\"><input type=\"text\" ng-model=\"uName\"></md-input-container><br>\n<span style=\"font-size:20px;padding-left:30px\"><b>THOMAS FERNANDEZ </b></span><br><span \nstyle=\"font-size:16px;padding-left:60px\">Chairman & CEO</span></div><div style=\"padding: 25px\"><md-input-container \nstyle=\"width: 300px;height: 32px\"><input type=\"text\" ng-model=\"uName\"></md-input-container><br><span \nstyle=\"font-size:20px;padding-left:90px\"><b>M J DANIEL </b></span><br><span style=\"font-size:16px;padding-left:110px\">\nTrainer</span></div></div></div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></div><style>\n.md-datepicker-button {\r\n        display: none;\r\n    }\r\n\r\n    ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\n        right: 74px;\r\n    }\r\n    #rcorners2 {\r\n     \r\n    border-radius: 25px;\r\n    border: 3px solid #b0b0b0;\r\n}\r\n    .numberCircle {\r\n        width: 40px;\r\n        height: 25px;\r\n        padding: 4px;\r\n        float: right;\r\n        background: #fff;\r\n        border: 1px solid #666;\r\n        text-align: center;\r\n        margin-top: 15px;\r\n        font: 12px Arial, sans-serif;\r\n    }\r\n    .verticalspace{\r\n        height:200px\r\n    }\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/courseschedule/courseschedule.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"top-bg md-accent-bg\" \nstyle=\"height:120px\"></div><div class=\"header\"><div class=\"header-content\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon><span>Course Schedule</span></div></div><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div><style>\n.page-layout.simple.fullwidth > .header, .page-layout.simple.inner-sidenav > .header {\r\n    height: 120px;\r\n    min-height: 100px;\r\n    max-height: 200px;\r\n    padding: 24px;\r\n    background-image: url(/assets/images/backgrounds/header-bg.png);\r\n    background-size: cover;\r\n}\r\n #calendar .header:before {\r\n    background: none;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/evaluation/evaluation.html","<div id=\"evaluation\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"evaluation-container\"><md-button \nng-click=\"printToCart(\'evaluation\')\" class=\"print md-accent-bg\" id=\"printpagebutton\">Print</md-button><div \nclass=\"card md-whiteframe-8dp\" id=\"evaluation\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\"></div></div><div \nclass=\"content\"><div style=\"text-align:center;font-size:25px;font-weight:600\"><b>{{\'EVALUATION.HEADER\'|translate}}</b>\n</div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"column\">\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\n{{\'EVALUATION.NAME\'|translate}}</p><md-input-container style=\"margin-top: 8.5px\" flex><input type=\"text\" \nng-model=\"uName\" flex=\"40\"></md-input-container></material-input-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"height: 60px\" layout=\"horizontal\"><p flex=\"20\">\n{{\'EVALUATION.TRAINING DATE\'|translate}}</p><md-input-container style=\"margin-top: 8.5px;margin-left: -12px\" flex=\"20\">\n<label translate=\"EVALUATION.FROM\">From</label><md-datepicker onkeydown=\"return false\" ng-model=\"formData.uExpiryDate\" \nmd-date-format=\"dd/MM/y\"></md-datepicker></md-input-container><md-input-container \nstyle=\"margin-top: 8.5px;margin-left:-20px\" flex><label translate=\"EVALUATION.TO\">To</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n</material-input-group><material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\n{{\'EVALUATION.TYPE OF TRG\'|translate}}</p><md-input-container style=\"margin-top:8.5px\" flex><input type=\"text\" \nng-model=\"uTypeofreg\" flex=\"40\"></md-input-container></material-input-group></div></form><div \nstyle=\"text-align:justify;font-size:15px;font-style: italic\">\n{{\'EVALUATION.PLEASE COMPLETE THIS EVALUATION FORM. YOUR FRANK FEEDBACK WILL HELP US IMPROVE. PLEASE CIRCLE THE APPROPRIATE GRADING. THANK YOU\'|translate}}.\n<br></div><br><br><div class=\"ecursor\"><div style=\"text-align:justify;font-size:17px\">\n1. {{\'EVALUATION.HOW USEFUL WAS THIS TRAINING TO YOU\'|translate}}?<br><md-radio-group layout=\"row\" class=\"radiocustom\">\n<md-radio-button value=\"usefulv\" class=\"radiobuttoncustom\">\n{{\'EVALUATION.VERY USEFUL\'|translate}}&nbsp;&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"useful4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"useful3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"useful2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"useful1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"usefull\" \nclass=\"radiobuttoncustom\">{{\'EVALUATION.LEAST USEFUL\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">2. {{\'EVALUATION.KNOWLEDGE GAINED DURING TRAINING WAS\'|translate}}<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\"><md-radio-button value=\"gainedv\" class=\"radiobuttoncustom\">\n{{\'EVALUATION.MUCH GAINED\'|translate}}&nbsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"gained4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"gained3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"gained2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"gained1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"gainedl\" \nclass=\"radiobuttoncustom\">{{\'EVALUATION.LEAST GAINED\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n3. {{\'EVALUATION.HOW WELL WILL THE CONCEPTS PRESENTED IN THIS TRAINING HELP YOU IN YOUR WORK\'|translate}}?<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\"><md-radio-button value=\"conceptsv\" class=\"radiobuttoncustom\">\n{{\'EVALUATION.VERY USEFUL\'|translate}}&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"concepts4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"concepts3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"concepts2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"concepts1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"concepts1\" \nclass=\"radiobuttoncustom\">{{\'EVALUATION.LEAST USEFUL\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n4. {{\'EVALUATION.HOW WELL DID THE HANDOUTS AND/OR OTHER MATERIALS AID YOUR UNDERSTANDING\'|translate}}?<br>\n<md-radio-group layout=\"row\" class=\"radiocustom\"><md-radio-button value=\"handoutsv\" class=\"radiobuttoncustom\">\n{{\'EVALUATION.VERY WELL\'|translate}}&emsp;&emsp;&nbsp;&nbsp;</md-radio-button><md-radio-button value=\"handouts4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"handouts3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"handouts2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"handouts1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"handoutsl\" \nclass=\"radiobuttoncustom\">{{\'EVALUATION.NOT AT ALL\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n5. {{\'EVALUATION.THERE WERE SUFFICIENT TEST QUESTIONS TO TEST MY UNDERSTANDING\'|translate}}<br><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"sufficientv\" class=\"radiobuttoncustom\">\n{{\'EVALUATION.STRONGLY AGREE\'|translate}}</md-radio-button><md-radio-button value=\"sufficient4\" \nclass=\"radiobuttoncustom\">4</md-radio-button><md-radio-button value=\"sufficient3\" class=\"radiobuttoncustom\">3\n</md-radio-button><md-radio-button value=\"sufficient2\" class=\"radiobuttoncustom\">2</md-radio-button><md-radio-button \nvalue=\"sufficient1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button value=\"sufficientl\" \nclass=\"radiobuttoncustom\">{{\'EVALUATION.STRONGLY DISAGREE\'|translate}}</md-radio-button></md-radio-group></div><div \nstyle=\"text-align:justify;font-size:17px\">\n6. {{\'EVALUATION.THE TESTS QUESTIONS WERE WELL STRUCTURED AND RELEVANT\'|translate}}<br><md-radio-group layout=\"row\" \nclass=\"radiocustom\"><md-radio-button value=\"testsv\" class=\"radiobuttoncustom\">{{\'EVALUATION.STRONGLY AGREE\'|translate}}\n</md-radio-button><md-radio-button value=\"tests4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button \nvalue=\"tests3\" class=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"tests2\" class=\"radiobuttoncustom\">2\n</md-radio-button><md-radio-button value=\"tests1\" class=\"radiobuttoncustom\">1</md-radio-button><md-radio-button \nvalue=\"testsl\" class=\"radiobuttoncustom\">{{\'EVALUATION.STRONGLY DISAGREE\'|translate}}</md-radio-button>\n</md-radio-group></div><div style=\"text-align:justify;font-size:17px\">\n7. {{\'EVALUATION.THE DURATION OF THE COURSE\'|translate}}<br><md-radio-group layout=\"row\" class=\"radiocustom\">\n<md-radio-button value=\"durationv\" class=\"radiobuttoncustom\">{{\'EVALUATION.TOO LONG\'|translate}}&emsp;&emsp;&nbsp;\n</md-radio-button><md-radio-button value=\"duration4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button \nvalue=\"duration3\" class=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"duration2\" \nclass=\"radiobuttoncustom\">2</md-radio-button><md-radio-button value=\"duration1\" class=\"radiobuttoncustom\">1\n</md-radio-button><md-radio-button value=\"durationl\" class=\"radiobuttoncustom\">{{\'EVALUATION.TOO SHORT\'|translate}}\n</md-radio-button></md-radio-group></div><div style=\"text-align:justify;font-size:17px\">\n8. {{\'EVALUATION.OVERALL RATING OF THE LECTURER\'|translate}}<br><md-radio-group layout=\"row\" class=\"radiocustom\">\n<md-radio-button value=\"Overallv\" class=\"radiobuttoncustom\">{{\'EVALUATION.EXCELLENT\'|translate}}&emsp;&emsp;&nbsp;\n</md-radio-button><md-radio-button value=\"Overall4\" class=\"radiobuttoncustom\">4</md-radio-button><md-radio-button \nvalue=\"Overall3\" class=\"radiobuttoncustom\">3</md-radio-button><md-radio-button value=\"Overall2\" \nclass=\"radiobuttoncustom\">2</md-radio-button><md-radio-button value=\"Overall1\" class=\"radiobuttoncustom\">1\n</md-radio-button><md-radio-button value=\"Overalll\" class=\"radiobuttoncustom\">{{\'EVALUATION.POOR\'|translate}}\n</md-radio-button></md-radio-group></div></div><div style=\"text-align:justify;font-size:17px\"><h3>\n9. {{\'EVALUATION.WHAT PORTION OF THE TRAINING DID YOU REALLY ENJOY/DISLIKE AND FOR WHAT REASON/S\'|translate}}?</h3>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Questionnaire1\"></text-angular><h3>\n10. {{\'EVALUATION.WHAT SUGGESTIONS WOULD YOU MAKE TO IMPROVE THIS TRAINING IN THE FUTURE\'|translate}}?</h3>\n<text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"Questionnaire2\"></text-angular></div><br><div \nstyle=\"text-align:justify;font-size:16px;font-weight:600\">\n{{\'EVALUATION.THANK YOU FOR YOUR CO-OPERATION IN COMPLETING THIS TRAINING EVALUATION FEEDBACK\'|translate}}.</div><br>\n<br><br><br><br><div style=\"text-align:justify;font-size:17px\">{{\'EVALUATION.TRAINING DEPT\'|translate}}</div></div><div\n class=\"footer\"></div></div><div class=\"page-break\"></div></div></div><style>\n.radiocustom{\r\n    padding-left:45px;\r\n        padding-top:10px;\r\n        padding-bottom:20px;\r\n}\r\n.radiobuttoncustom{\r\n        padding-right:20px;\r\n}\r\n.ta-root .ta-scroll-window.form-control {\r\n    border: 1px solid rgba(0, 0, 0, 0.87)!important;\r\n}\r\n\r\n.ta-editor.ta-html, .ta-scroll-window.form-control, .ta-bind {\r\n    min-height: 120px !important;\r\n    padding: 1px 12px !important;\r\n}\r\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n\r\n.numberCircle {\r\nwidth: 40px;\r\nheight: 25px;\r\npadding: 4px;\r\nfloat:right;\r\nbackground: #fff;\r\nborder: 1px solid #666;\r\ntext-align: center;\r\nmargin-top: 15px;\r\nfont: 12px Arial, sans-serif;\r\ncursor: pointer;\r\n}\r\ndiv .numberCircle:hover {\r\nbackground: #AAB7B8;\r\n}\r\n.ecursor  p:hover {\r\ncolor:forestgreen;\r\nfont-weight:400;\r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/training/administration/monitoring/monitoring.html","<div id=\"invoice\" class=\"page-layout simple tabbed\" ms-scroll><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" style=\"padding-left: 40px\" layout-align=\"start center\"><span>Training Monitoring</span></div></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height md-center-tabs=\"false\"><md-tab><md-tab-label><span>Form</span>\n</md-tab-label><md-tab-body><div class=\"invoice-container\"><md-button ng-click=\"printToCart(\'invoice\')\" \nclass=\"print md-accent-bg\" id=\"printpagebutton\">Print</md-button><div class=\"card md-whiteframe-8dp\" id=\"invoice\"><div \nclass=\"header\"><div style=\"text-align:left\">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img \nsrc=\"assets/images/logos/pest_logo.png\"></div></div><div class=\"content\"><div \nstyle=\"text-align:center;font-size:20px;font-weight:600\"><b>\nIntroductory Training Series for New Service Technician – Training Monitoring Form</b></div><br><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"column\"><material-input-group \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Name of Staff</p><md-input-container \nstyle=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uName\" flex=\"40\"></md-input-container></material-input-group>\n<material-input-group style=\"height: 60px\" class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\nDate of Training</p><md-input-container style=\"margin-top: 8px;margin-left: -12px\" flex=\"20\"><md-datepicker \nonkeydown=\"return false\" ng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker></md-input-container>\n</material-input-group><material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">\nDept. & Job Title</p><md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" \nflex=\"40\"></md-input-container></material-input-group></div></form><br><br><div \nstyle=\"text-align:justify;font-size:17px\">1. Please complete Section I of this form BEFORE attending the training.<br>\n<br></div><div style=\"text-align:justify;font-size:17px\">\n2. Bring this form along on the 1st day of training for the trainer’s attention.</div><br><div \nstyle=\"font-weight:600;font-size:17px\">Section I: Pre – Course Training Brief (Superior)</div><br><div \nstyle=\"font-size:17px\">\nSelect any 02 of the following learning objectives that you wish your staff to acquire during and after the course of their training.\n</div><br><table style=\"border: 1px solid #a5a5a5\" width=\"100%;\"><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">01</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nWhen is an animal or an insect defined as a pest?</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">02</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">What is a pest?\n</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">03</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nWhat are non-chemical control methods</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">04</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe benefits of using a combination of all available</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">05</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nWhy are we required to correctly identify pests</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">06</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe 10 most unwanted pests</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">07</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nWhat are pesticides and their role in pest managemen</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">08</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe type of pesticides</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">09</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe importance of on the job safety and the different hazards</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">10</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe need for good customer relations</td></tr></table><br><br><div style=\"font-weight:600;font-size:17px\">\nSection II: Transfer of Learning (Trainee)</div><br><div style=\"font-size:17px\">\n1. Were you able to learn the options your superior chose above before the commencement of training?</div><br><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group layout=\"row\" \nclass=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button><md-radio-button \nvalue=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-size:17px\">2. Will you be able to apply what you have learnt during the course of your training at work?\n</div><br><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button>\n<md-radio-button value=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-weight:600;font-size:17px\">Section III: Training Achievement (Superior)</div><br><div \nstyle=\"font-size:17px\">This training has / has not been successful for the staff.</div><br><div style=\"font-size:17px\">\n&emsp; If no, please state reasons<br><textarea style=\"border:1px solid black\" ng-model=\"Questionnaire2\"></textarea>\n</div></div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Advance Training Monitoring Form</span></md-tab-label><md-tab-body><div class=\"invoice-container\">\n<md-button ng-click=\"printToCart(\'invoice\')\" class=\"print md-accent-bg\" id=\"printpagebutton\">Print</md-button><div \nclass=\"card md-whiteframe-8dp\" id=\"invoice\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\"></div></div><div \nclass=\"content\"><div style=\"text-align:center;font-size:20px;font-weight:600\"><b>Advance Training Monitoring Form</b>\n</div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"column\">\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Name of Staff</p>\n<md-input-container style=\"margin-top: 8.5px\" flex><input type=\"text\" ng-model=\"uName\" flex=\"40\"></md-input-container>\n</material-input-group><material-input-group style=\"height: 60px\" class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">Date of Training</p><md-input-container style=\"margin-top: 8.5px;margin-left: -12px\" \nflex=\"20\"><md-datepicker onkeydown=\"return false\" ng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\">\n</md-datepicker></md-input-container></material-input-group><material-input-group \nclass=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Dept. & Job Title</p><md-input-container \nstyle=\"margin-top: 8.5px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"40\"></md-input-container>\n</material-input-group></div></form><br><br><div style=\"text-align:justify;font-size:17px\">\n1. Please complete Section I of this form BEFORE attending the training.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">\n2. Bring this form along on the 1st day of training for the trainer’s attention.</div><br><div \nstyle=\"font-weight:600;font-size:17px\">Section I: Pre – Course Training Brief (Superior)</div><br><div \nstyle=\"font-size:17px\">\nSelect any 02 of the following learning objectives that you wish your staff to acquire during and after the course of their training.\n</div><br><table style=\"border: 1px solid #a5a5a5\" width=\"100%;\"><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">01</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nDifferences between the German and American Cockroaches</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">02</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe Life Cycle of Cockroaches</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">03</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nComparison between the Roof Rat and Sewer Rat</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">04</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nThe Life Cycle of Rodents</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">05</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nTypes of Termites</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">06\n</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nInspection for Termites</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">07</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nCommon Flies in F&B Areas</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">08</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">Fly management\n</td></tr><tr class=\"tdthumbnail\"><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">09</td><td \nstyle=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nManagement of Ants</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;width: 8%;padding:10px;text-align:center\">\n10</td><td style=\"border: 1px solid #a5a5a5;font-size: 17px;padding:10px;cursor: pointer\" ng-click=\"Moduleedit()\">\nInspection for Ants</td></tr></table><br><br><div style=\"font-weight:600;font-size:17px\">\nSection II: Transfer of Learning (Trainee)</div><br><div style=\"font-size:17px\">\n1. Were you able to learn the options your superior chose above before the commencement of training?</div><br><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group layout=\"row\" \nclass=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button><md-radio-button \nvalue=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-size:17px\">2. Will you be able to apply what you have learnt during the course of your training at work?\n</div><br><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: -16px;  padding-left: 20px\"><md-radio-group \nlayout=\"row\" class=\"radiocustom\"><md-radio-button value=\"0\" class=\"radiobuttoncustom\">Yes</md-radio-button>\n<md-radio-button value=\"1\" class=\"radiobuttoncustom\">No</md-radio-button></md-radio-group><material-input-group \nclass=\"material-input-group-theme-light\" style=\"width:80%\" layout=\"horizontal\"><p flex=\"20\" \nstyle=\"margin-top: 25px;font-size: 18px;padding-left:30px;margin-right: -50px\">If no:</p><md-input-container flex>\n<input type=\"text\" ng-model=\"uName\" flex=\"80\"></md-input-container></material-input-group></div><div \nstyle=\"font-weight:600;font-size:17px\">Section III: Training Achievement (Superior)</div><br><div \nstyle=\"font-size:17px\">This training has / has not been successful for the staff.</div><br><div style=\"font-size:17px\">\n&emsp; If no, please state reasons<br><textarea style=\"border:1px solid black\" ng-model=\"Questionnaire2\"></textarea>\n</div></div><div class=\"footer\"></div></div><div class=\"page-break\"></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Commitment Form</span></md-tab-label><md-tab-body><div class=\"invoice-container\"><md-button \nng-click=\"printToCart(\'invoice\')\" class=\"print md-accent-bg\" id=\"printpagebutton\">Print</md-button><div \nclass=\"card md-whiteframe-8dp\" id=\"invoice\"><div class=\"header\"><div style=\"text-align:left\">\n&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; <img src=\"assets/images/logos/pest_logo.png\"></div></div><div \nclass=\"content\"><div style=\"text-align:center;font-size:20px;font-weight:600\"><b>PESTBUSTERS TRAINING COMMITMENT FORM\n</b></div><br><form name=\"basicForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"column\">\n<material-input-group class=\"material-input-group-theme-light\" layout=\"horizontal\"><p flex=\"20\">Name</p>\n<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uName\" flex=\"40\"></md-input-container>\n</material-input-group><material-input-group style=\"height: 60px\" class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">Date</p><md-input-container style=\"margin-top: 8px;margin-left: -12px\" flex=\"20\">\n<md-datepicker onkeydown=\"return false\" ng-model=\"formData.uExpiryDate\" md-date-format=\"dd/MM/y\"></md-datepicker>\n</md-input-container></material-input-group><material-input-group class=\"material-input-group-theme-light\" \nlayout=\"horizontal\"><p flex=\"20\">Re / Type of Training</p><md-input-container style=\"margin-top: 8px\" flex><input \ntype=\"text\" ng-model=\"uTypeofreg\" flex=\"40\"></md-input-container></material-input-group></div></form><br><br><div \nstyle=\"text-align:justify;font-size:17px\">I,&emsp;<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" \nng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>(Name as in NRIC/Passport), holder of<md-input-container \nstyle=\"margin-top: 8px\" flex><input type=\"text\" ng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>\n(NRIC/FIN No.) sincerely pledge my commitment for the above sponsored training.<br><br></div><div \nstyle=\"text-align:justify;font-size:17px\">Therefore I pledge:<br><br>\n&emsp;&emsp;&emsp;&nbsp; 1) To attain and abide by all Company’s and government’s regulatory requirements and procedures.\n<br><br>&emsp;&emsp;&emsp;&nbsp;2) To pass the examinations, otherwise I’ll bear the cost for a second attempt, if any.\n<br><br>\n&emsp;&emsp;&emsp;&nbsp;3) Not to resign within three (03) months from the date of receiving the examination results.\n<br><br>\nIn the event I fail to comply with any of the above, I am aware that I’ll be required to bear the full amount of the cost for this training.\n<br>The cost of this training amounts to $<md-input-container style=\"margin-top: 8px\" flex><input type=\"text\" \nng-model=\"uTypeofreg\" flex=\"90\"></md-input-container>.<br>\nFurthermore, I shall not absent myself from the above training without prior approval of the Company’s management and the HR Department. Any such absences should be supported by documentary proof that must be accepted by the training institution and or SDF.\n<br><br>Where assignments, projects, etc. are concerned, I’ll submit a copy to the Company.</div><br><br><div>\n<md-input-container style=\"width: 300px;height: 25px\"><input type=\"text\" ng-model=\"uName\"></md-input-container><br>\n<span style=\"font-size:16px;padding-left:0px;font-style:italic\"><b>Signature (Trainee) & Date </b></span><br></div><br>\n<br><div><md-input-container style=\"width: 300px;height: 25px\"><input type=\"text\" ng-model=\"uName\">\n</md-input-container><br><span style=\"font-size:16px;padding-left:0px;font-style:italic\"><b>\nSignature (Head, HC Department) & Date </b></span><br></div></div></div><div class=\"footer\"></div></div><div \nclass=\"page-break\"></div></md-tab-body></md-tab></md-tabs></div></div><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\nmd-datepicker .md-datepicker-input {\r\nwidth: calc(22vw - 35px);\r\nmax-width: calc(35vw - 54px);\r\n}\r\ntable {\r\nborder-collapse: collapse; \r\n}\r\npage-layout.simple.tabbed > .content > md-tabs > md-tabs-content-wrapper > md-tab-content {\r\npadding: 0px;\r\nmargin-left: -5px\r\n}\r\n.tdthumbnail > td:hover {\r\nbackground: #eee;\r\n}\r\n.md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74px;\r\n}\r\ntextarea {\r\nwidth: 100%;\r\nheight: 100px;\r\npadding: 12px 20px;\r\nresize: none;\r\n}\r\n.numberCircle {\r\nwidth: 40px;\r\nheight: 25px;\r\npadding: 4px;\r\nfloat: right;\r\nbackground: #fff;\r\nborder: 1px solid #666;\r\ntext-align: center;\r\nmargin-top: 15px;\r\nfont: 12px Arial, sans-serif;\r\n}\r\n.verticalspace {\r\nheight: 200px;\r\n}\r\nmd-radio-button .md-label {\r\nbox-sizing: border-box;\r\nposition: relative;\r\ndisplay: inline-block;\r\nmargin-left: 35px;\r\nmargin-top: 25px;\r\nfont-size: 16px;\r\nmargin-right: 0;\r\nvertical-align: middle;\r\nwhite-space: normal;\r\npointer-events: none;\r\nwidth: auto;\r\n}\n</style>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)\">{{contact.name.charAt(0)}}</div>\n<div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3>{{contact.name}}\n</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/human-resource/training/calender/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Attendance</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label>Course</label><md-select ng-model=\"uClientID\" \nid=\"searchmodule\"><md-option ng-repeat=\"row in CourseSummary\" value=\"{{row.CourseName}}\">{{row.CourseName}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Employee</label><md-select ng-model=\"Employee\" \nid=\"searchmodule\" multiple=\"multiple\"><md-option ng-repeat=\"row in EmployeeSummary\" value=\"{{row.EmployeeID}}\">\n{{row.EmployeeName}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nstyle=\"height:80px\"><md-input-container flex=\"30\" id=\"CAmodule\" style=\"margin-top: 18px\"><label>Start Date</label>\n<md-datepicker onkeydown=\"return false\" ng-model=\"vm.calendarEvent.start\" ng-model-options=\"{ timezone: \'UTC\' }\">\n</md-datepicker></md-input-container><md-input-container flex=\"30\" id=\"CAmodule\" style=\"margin-top: 18px\"><label>\nEnd Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.calendarEvent.end\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker></md-input-container></div><md-input-container flex \nclass=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea ng-model=\"vm.task.notes\" \nmd-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid\" translate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">\nSAVE</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog><style>\n#CAmodule .md-datepicker-button {\r\ndisplay: none;}\r\n#CAmodule ._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74px;  \r\n}\n</style>");
$templateCache.put("app/main/apps/human-resource/training/calender/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">Schedule</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/human-resource/training/administration/courseschedule/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">Schedule</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/human-resource/training/administration/courseschedule/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Add Schedule</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\" style=\"height:80px\"><md-input-container flex><label>Employee</label><md-select ng-model=\"uClientID\" \nid=\"searchmodule\" multiple=\"multiple\"><md-option ng-repeat=\"row in EmployeeSummary\" value=\"{{row.EmployeeID}}\">\n{{row.EmployeeName}}</md-option></md-select></md-input-container><md-input-container flex><label>Course</label>\n<md-select ng-model=\"uClientID\" id=\"searchmodule\"><md-option ng-repeat=\"row in Clientdatas\" value=\"{{row.id}}\">\n{{row.ClientName}}</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-input-container flex=\"30\" style=\"margin-top: 18px\"><label>Start Date</label><md-datepicker \nonkeydown=\"return false\" ng-model=\"vm.calendarEvent.start\" ng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker>\n</md-input-container><md-input-container class=\"no-errors-spacer\" flex=\"20\" md-no-float><input type=\"time\" \nng-model=\"uTimein\" placeholder=\"Time In\" translate translate-attr-placeholder=\"CALENDAR.START_TIME\">\n</md-input-container></div><div layout=\"row\" class=\"date-row\"><md-input-container flex=\"30\" style=\"margin-top: 18px\">\n<label>End Date</label><md-datepicker onkeydown=\"return false\" ng-model=\"vm.calendarEvent.end\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker></md-input-container><md-input-container \nclass=\"no-errors-spacer\" flex=\"20\" md-no-float><input type=\"time\" ng-model=\"uTimeout\" placeholder=\"Time Out\" translate \ntranslate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container flex \nclass=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label><textarea ng-model=\"vm.task.notes\" \nmd-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" \naria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog><style>\n.md-datepicker-button {\r\ndisplay: none;\r\n}\r\n._md-datepicker-floating-label._md-datepicker-has-calendar-icon > label:not(.md-no-float):not(.md-container-ignore) {\r\nright: 74px;\r\n}\n</style>");}]);